(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 5778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

'use client';
__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = exports.aF = __webpack_unused_export__ = __webpack_unused_export__ = exports.dr = void 0;
var tslib_1 = __webpack_require__(22970);
var use_user_1 = tslib_1.__importStar(__webpack_require__(10917));
Object.defineProperty(exports, "dr", ({ enumerable: true, get: function () { return use_user_1.default; } }));
__webpack_unused_export__ = ({ enumerable: true, get: function () { return use_user_1.UserContext; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return use_user_1.RequestError; } });
Object.defineProperty(exports, "aF", ({ enumerable: true, get: function () { return use_user_1.useUser; } }));
var with_page_auth_required_1 = tslib_1.__importDefault(__webpack_require__(31469));
__webpack_unused_export__ = ({ enumerable: true, get: function () { return with_page_auth_required_1.default; } });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 59108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34406);

'use client';
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useConfig = void 0;
var tslib_1 = __webpack_require__(22970);
var react_1 = tslib_1.__importStar(__webpack_require__(2784));
var Config = (0, react_1.createContext)({});
var useConfig = function () { return (0, react_1.useContext)(Config); };
exports.useConfig = useConfig;
exports["default"] = (function (_a) {
    var children = _a.children, _b = _a.loginUrl, loginUrl = _b === void 0 ? process.env.NEXT_PUBLIC_AUTH0_LOGIN || '/api/auth/login' : _b;
    return react_1.default.createElement(Config.Provider, { value: { loginUrl: loginUrl } }, children);
});
//# sourceMappingURL=use-config.js.map

/***/ }),

/***/ 10917:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34406);

'use client';
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useUser = exports.UserContext = exports.RequestError = void 0;
var tslib_1 = __webpack_require__(22970);
var react_1 = tslib_1.__importStar(__webpack_require__(2784));
var use_config_1 = tslib_1.__importDefault(__webpack_require__(59108));
/**
 * The error thrown by the default {@link UserFetcher}.
 *
 * The `status` property contains the status code of the response. It is `0` when the request
 * fails, for example due to being offline.
 *
 * This error is not thrown when the status code of the response is `204`, because that means the
 * user is not authenticated.
 *
 * @category Client
 */
var RequestError = /** @class */ (function (_super) {
    tslib_1.__extends(RequestError, _super);
    function RequestError(status) {
        var _this = 
        /* c8 ignore next */
        _super.call(this) || this;
        _this.status = status;
        Object.setPrototypeOf(_this, RequestError.prototype);
        return _this;
    }
    return RequestError;
}(Error));
exports.RequestError = RequestError;
/**
 * @ignore
 */
var missingUserProvider = 'You forgot to wrap your app in <UserProvider>';
/**
 * @ignore
 */
exports.UserContext = (0, react_1.createContext)({
    get user() {
        throw new Error(missingUserProvider);
    },
    get error() {
        throw new Error(missingUserProvider);
    },
    get isLoading() {
        throw new Error(missingUserProvider);
    },
    checkSession: function () {
        throw new Error(missingUserProvider);
    }
});
/**
 * The `useUser` hook, which will get you the {@link UserProfile} object from the server-side session by fetching it
 * from the {@link HandleProfile} API route.
 *
 * ```js
 * // pages/profile.js
 * import Link from 'next/link';
 * import { useUser } from '@auth0/nextjs-auth0/client';
 *
 * export default function Profile() {
 *   const { user, error, isLoading } = useUser();
 *
 *   if (isLoading) return <div>Loading...</div>;
 *   if (error) return <div>{error.message}</div>;
 *   if (!user) return <Link href="/api/auth/login"><a>Login</a></Link>;
 *   return <div>Hello {user.name}, <Link href="/api/auth/logout"><a>Logout</a></Link></div>;
 * }
 * ```
 *
 * @category Client
 */
var useUser = function () { return (0, react_1.useContext)(exports.UserContext); };
exports.useUser = useUser;
/**
 * @ignore
 */
var userFetcher = function (url) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var response, _a;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch(url)];
            case 1:
                response = _b.sent();
                return [3 /*break*/, 3];
            case 2:
                _a = _b.sent();
                throw new RequestError(0); // Network error
            case 3:
                if (response.status == 204)
                    return [2 /*return*/, undefined];
                if (response.ok)
                    return [2 /*return*/, response.json()];
                throw new RequestError(response.status);
        }
    });
}); };
exports["default"] = (function (_a) {
    var children = _a.children, initialUser = _a.user, _b = _a.profileUrl, profileUrl = _b === void 0 ? process.env.NEXT_PUBLIC_AUTH0_PROFILE || '/api/auth/me' : _b, loginUrl = _a.loginUrl, _c = _a.fetcher, fetcher = _c === void 0 ? userFetcher : _c;
    var _d = tslib_1.__read((0, react_1.useState)({ user: initialUser, isLoading: !initialUser }), 2), state = _d[0], setState = _d[1];
    var checkSession = (0, react_1.useCallback)(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var user_1, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetcher(profileUrl)];
                case 1:
                    user_1 = _a.sent();
                    setState(function (previous) { return (tslib_1.__assign(tslib_1.__assign({}, previous), { user: user_1, error: undefined })); });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    setState(function (previous) { return (tslib_1.__assign(tslib_1.__assign({}, previous), { error: error_1 })); });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [profileUrl]);
    (0, react_1.useEffect)(function () {
        if (state.user)
            return;
        (function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, checkSession()];
                    case 1:
                        _a.sent();
                        setState(function (previous) { return (tslib_1.__assign(tslib_1.__assign({}, previous), { isLoading: false })); });
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [state.user]);
    var user = state.user, error = state.error, isLoading = state.isLoading;
    var value = (0, react_1.useMemo)(function () { return ({ user: user, error: error, isLoading: isLoading, checkSession: checkSession }); }, [user, error, isLoading, checkSession]);
    return (react_1.default.createElement(use_config_1.default, { loginUrl: loginUrl },
        react_1.default.createElement(exports.UserContext.Provider, { value: value }, children)));
});
//# sourceMappingURL=use-user.js.map

/***/ }),

/***/ 31469:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

'use client';
Object.defineProperty(exports, "__esModule", ({ value: true }));
var tslib_1 = __webpack_require__(22970);
var react_1 = tslib_1.__importStar(__webpack_require__(2784));
var use_config_1 = __webpack_require__(59108);
var use_user_1 = __webpack_require__(10917);
/**
 * @ignore
 */
var defaultOnRedirecting = function () { return react_1.default.createElement(react_1.default.Fragment, null); };
/**
 * @ignore
 */
var defaultOnError = function () { return react_1.default.createElement(react_1.default.Fragment, null); };
/**
 * @ignore
 */
var withPageAuthRequired = function (Component, options) {
    if (options === void 0) { options = {}; }
    return function WithPageAuthRequired(props) {
        var returnTo = options.returnTo, _a = options.onRedirecting, onRedirecting = _a === void 0 ? defaultOnRedirecting : _a, _b = options.onError, onError = _b === void 0 ? defaultOnError : _b;
        var loginUrl = (0, use_config_1.useConfig)().loginUrl;
        var _c = (0, use_user_1.useUser)(), user = _c.user, error = _c.error, isLoading = _c.isLoading;
        (0, react_1.useEffect)(function () {
            if ((user && !error) || isLoading)
                return;
            var returnToPath;
            if (!returnTo) {
                var currentLocation = window.location.toString();
                returnToPath = currentLocation.replace(new URL(currentLocation).origin, '') || '/';
            }
            else {
                returnToPath = returnTo;
            }
            window.location.assign("".concat(loginUrl, "?returnTo=").concat(encodeURIComponent(returnToPath)));
        }, [user, error, isLoading]);
        if (error)
            return onError(error);
        if (user)
            return react_1.default.createElement(Component, tslib_1.__assign({ user: user }, props));
        return onRedirecting();
    };
};
exports["default"] = withPageAuthRequired;
//# sourceMappingURL=with-page-auth-required.js.map

/***/ }),

/***/ 33343:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (memoize);


/***/ }),

/***/ 31938:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["Z"] = (unitlessKeys);


/***/ }),

/***/ 49929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ FontAwesomeIcon; }
/* harmony export */ });
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81674);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var beat = props.beat,
      fade = props.fade,
      beatFade = props.beatFade,
      bounce = props.bounce,
      shake = props.shake,
      flash = props.flash,
      spin = props.spin,
      spinPulse = props.spinPulse,
      spinReverse = props.spinReverse,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-beat': beat,
    'fa-fade': fade,
    'fa-beat-fade': beatFade,
    'fa-bounce': bounce,
    'fa-shake': shake,
    'fa-flash': flash,
    'fa-spin': spin,
    'fa-spin-reverse': spinReverse,
    'fa-spin-pulse': spinPulse,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip': flip === true,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

var _excluded = ["style"];

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, _excluded);

  mixins.attrs['style'] = _objectSpread2(_objectSpread2({}, mixins.attrs['style']), existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2(_objectSpread2({}, mixins.attrs), remaining)].concat(_toConsumableArray(children)));
}

var PRODUCTION = false;

try {
  PRODUCTION = "production" === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .parse.icon */ .Qc.icon) {
    return _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .parse.icon */ .Qc.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}

var FontAwesomeIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (props, ref) {
  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title,
      titleId = props.titleId,
      maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .parse.transform */ .Qc.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = (0,_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .icon */ .qv)(iconLookup, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform), mask), {}, {
    symbol: symbol,
    title: title,
    titleId: titleId,
    maskId: maskId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: ref
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  beat: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  border: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  beatFade: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  bounce: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  fade: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  flash: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  mask: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  maskId: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  fixedWidth: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  inverse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  flip: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([true, false, 'horizontal', 'vertical', 'both']),
  icon: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  listItem: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  pull: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(['right', 'left']),
  pulse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  rotation: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([0, 90, 180, 270]),
  shake: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  size: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  spinPulse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  spinReverse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  symbol: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  title: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  titleId: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  transform: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)]),
  swapOpacity: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: '',
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, react__WEBPACK_IMPORTED_MODULE_1__.createElement);




/***/ }),

/***/ 57307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/*
 * Module dependencies.
 */

var keys = __webpack_require__(29236);

var objToString = Object.prototype.toString;

/**
 * Tests if a value is a number.
 *
 * @name isNumber
 * @api private
 * @param {*} val The value to test.
 * @return {boolean} Returns `true` if `val` is a number, otherwise `false`.
 */
// TODO: Move to library
var isNumber = function isNumber(val) {
  var type = typeof val;
  return type === 'number' || (type === 'object' && objToString.call(val) === '[object Number]');
};

/**
 * Tests if a value is an array.
 *
 * @name isArray
 * @api private
 * @param {*} val The value to test.
 * @return {boolean} Returns `true` if the value is an array, otherwise `false`.
 */
// TODO: Move to library
var isArray = typeof Array.isArray === 'function' ? Array.isArray : function isArray(val) {
  return objToString.call(val) === '[object Array]';
};

/**
 * Tests if a value is array-like. Array-like means the value is not a function and has a numeric
 * `.length` property.
 *
 * @name isArrayLike
 * @api private
 * @param {*} val
 * @return {boolean}
 */
// TODO: Move to library
var isArrayLike = function isArrayLike(val) {
  return val != null && (isArray(val) || (val !== 'function' && isNumber(val.length)));
};

/**
 * Internal implementation of `each`. Works on arrays and array-like data structures.
 *
 * @name arrayEach
 * @api private
 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
 * @param {Array} array The array(-like) structure to iterate over.
 * @return {undefined}
 */
var arrayEach = function arrayEach(iterator, array) {
  for (var i = 0; i < array.length; i += 1) {
    // Break iteration early if `iterator` returns `false`
    if (iterator(array[i], i, array) === false) {
      break;
    }
  }
};

/**
 * Internal implementation of `each`. Works on objects.
 *
 * @name baseEach
 * @api private
 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
 * @param {Object} object The object to iterate over.
 * @return {undefined}
 */
var baseEach = function baseEach(iterator, object) {
  var ks = keys(object);

  for (var i = 0; i < ks.length; i += 1) {
    // Break iteration early if `iterator` returns `false`
    if (iterator(object[ks[i]], ks[i], object) === false) {
      break;
    }
  }
};

/**
 * Iterate over an input collection, invoking an `iterator` function for each element in the
 * collection and passing to it three arguments: `(value, index, collection)`. The `iterator`
 * function can end iteration early by returning `false`.
 *
 * @name each
 * @api public
 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
 * @param {Array|Object|string} collection The collection to iterate over.
 * @return {undefined} Because `each` is run only for side effects, always returns `undefined`.
 * @example
 * var log = console.log.bind(console);
 *
 * each(log, ['a', 'b', 'c']);
 * //-> 'a', 0, ['a', 'b', 'c']
 * //-> 'b', 1, ['a', 'b', 'c']
 * //-> 'c', 2, ['a', 'b', 'c']
 * //=> undefined
 *
 * each(log, 'tim');
 * //-> 't', 2, 'tim'
 * //-> 'i', 1, 'tim'
 * //-> 'm', 0, 'tim'
 * //=> undefined
 *
 * // Note: Iteration order not guaranteed across environments
 * each(log, { name: 'tim', occupation: 'enchanter' });
 * //-> 'tim', 'name', { name: 'tim', occupation: 'enchanter' }
 * //-> 'enchanter', 'occupation', { name: 'tim', occupation: 'enchanter' }
 * //=> undefined
 */
var each = function each(iterator, collection) {
  return (isArrayLike(collection) ? arrayEach : baseEach).call(this, iterator, collection);
};

/*
 * Exports.
 */

module.exports = each;


/***/ }),

/***/ 29236:
/***/ (function(module) {

"use strict";


var hop = Object.prototype.hasOwnProperty;
var strCharAt = String.prototype.charAt;
var toStr = Object.prototype.toString;

/**
 * Returns the character at a given index.
 *
 * @param {string} str
 * @param {number} index
 * @return {string|undefined}
 */
// TODO: Move to a library
var charAt = function(str, index) {
  return strCharAt.call(str, index);
};

/**
 * hasOwnProperty, wrapped as a function.
 *
 * @name has
 * @api private
 * @param {*} context
 * @param {string|number} prop
 * @return {boolean}
 */

// TODO: Move to a library
var has = function has(context, prop) {
  return hop.call(context, prop);
};

/**
 * Returns true if a value is a string, otherwise false.
 *
 * @name isString
 * @api private
 * @param {*} val
 * @return {boolean}
 */

// TODO: Move to a library
var isString = function isString(val) {
  return toStr.call(val) === '[object String]';
};

/**
 * Returns true if a value is array-like, otherwise false. Array-like means a
 * value is not null, undefined, or a function, and has a numeric `length`
 * property.
 *
 * @name isArrayLike
 * @api private
 * @param {*} val
 * @return {boolean}
 */
// TODO: Move to a library
var isArrayLike = function isArrayLike(val) {
  return val != null && (typeof val !== 'function' && typeof val.length === 'number');
};


/**
 * indexKeys
 *
 * @name indexKeys
 * @api private
 * @param {} target
 * @param {Function} pred
 * @return {Array}
 */
var indexKeys = function indexKeys(target, pred) {
  pred = pred || has;

  var results = [];

  for (var i = 0, len = target.length; i < len; i += 1) {
    if (pred(target, i)) {
      results.push(String(i));
    }
  }

  return results;
};

/**
 * Returns an array of an object's owned keys.
 *
 * @name objectKeys
 * @api private
 * @param {*} target
 * @param {Function} pred Predicate function used to include/exclude values from
 * the resulting array.
 * @return {Array}
 */
var objectKeys = function objectKeys(target, pred) {
  pred = pred || has;

  var results = [];

  for (var key in target) {
    if (pred(target, key)) {
      results.push(String(key));
    }
  }

  return results;
};

/**
 * Creates an array composed of all keys on the input object. Ignores any non-enumerable properties.
 * More permissive than the native `Object.keys` function (non-objects will not throw errors).
 *
 * @name keys
 * @api public
 * @category Object
 * @param {Object} source The value to retrieve keys from.
 * @return {Array} An array containing all the input `source`'s keys.
 * @example
 * keys({ likes: 'avocado', hates: 'pineapple' });
 * //=> ['likes', 'pineapple'];
 *
 * // Ignores non-enumerable properties
 * var hasHiddenKey = { name: 'Tim' };
 * Object.defineProperty(hasHiddenKey, 'hidden', {
 *   value: 'i am not enumerable!',
 *   enumerable: false
 * })
 * keys(hasHiddenKey);
 * //=> ['name'];
 *
 * // Works on arrays
 * keys(['a', 'b', 'c']);
 * //=> ['0', '1', '2']
 *
 * // Skips unpopulated indices in sparse arrays
 * var arr = [1];
 * arr[4] = 4;
 * keys(arr);
 * //=> ['0', '4']
 */
var keys = function keys(source) {
  if (source == null) {
    return [];
  }

  // IE6-8 compatibility (string)
  if (isString(source)) {
    return indexKeys(source, charAt);
  }

  // IE6-8 compatibility (arguments)
  if (isArrayLike(source)) {
    return indexKeys(source, has);
  }

  return objectKeys(source);
};

/*
 * Exports.
 */

module.exports = keys;


/***/ }),

/***/ 20321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/*
 * Module dependencies.
 */

var each = __webpack_require__(57307);

/**
 * Produce a new array by passing each value in the input `collection` through a transformative
 * `iterator` function. The `iterator` function is passed three arguments:
 * `(value, index, collection)`.
 *
 * @name map
 * @api public
 * @param {Function} iterator The transformer function to invoke per iteration.
 * @param {Array} collection The collection to iterate over.
 * @return {Array} A new array containing the results of each `iterator` invocation.
 * @example
 * var square = function(x) { return x * x; };
 *
 * map(square, [1, 2, 3]);
 * //=> [1, 4, 9]
 */
var map = function map(iterator, collection) {
  if (typeof iterator !== 'function') {
    throw new TypeError('Expected a function but received a ' + typeof iterator);
  }

  var result = [];

  each(function(val, i, collection) {
    result.push(iterator(val, i, collection));
  }, collection);

  return result;
};

/*
 * Exports.
 */

module.exports = map;


/***/ }),

/***/ 39160:
/***/ (function(module) {

module.exports=function(settings) {
var __t, __p = '';
__p += '(function(){\n\n  // Create a queue, but don\'t obliterate an existing one!\n  var analytics = window.analytics = window.analytics || [];\n\n  // If the real analytics.js is already on the page return.\n  if (analytics.initialize) return;\n\n  // If the snippet was invoked already show an error.\n  if (analytics.invoked) {\n    if (window.console && console.error) {\n      console.error(\'Segment snippet included twice.\');\n    }\n    return;\n  }\n\n  // Invoked flag, to make sure the snippet\n  // is never invoked twice.\n  analytics.invoked = true;\n\n  // A list of the methods in Analytics.js to stub.\n  analytics.methods = [\n    \'trackSubmit\',\n    \'trackClick\',\n    \'trackLink\',\n    \'trackForm\',\n    \'pageview\',\n    \'identify\',\n    \'reset\',\n    \'group\',\n    \'track\',\n    \'ready\',\n    \'alias\',\n    \'debug\',\n    \'page\',\n    \'once\',\n    \'off\',\n    \'on\',\n    \'addSourceMiddleware\',\n    \'addIntegrationMiddleware\',\n    \'setAnonymousId\',\n    \'addDestinationMiddleware\'\n  ];\n\n  // Define a factory to create stubs. These are placeholders\n  // for methods in Analytics.js so that you never have to wait\n  // for it to load to actually record data. The `method` is\n  // stored as the first argument, so we can replay the data.\n  analytics.factory = function(e){\n    return function(){\n      if (window.analytics.initialized) {\n        // Sometimes users assigned analytics to a variable before analytics is done loading, resulting in a stale reference.\n        // If so, proxy any calls to the \'real\' analytics instance.\n        return window.analytics[e].apply(window.analytics, arguments);\n      }\n      var args = Array.prototype.slice.call(arguments);\n      args.unshift(e);\n      analytics.push(args);\n      return analytics;\n    };\n  };\n\n\n  // For each of our methods, generate a queueing stub.\n  for (var i = 0; i < analytics.methods.length; i++) {\n    var key = analytics.methods[i];\n    analytics[key] = analytics.factory(key);\n  }\n\n  // Define a method to load Analytics.js from our CDN,\n  // and that will be sure to only ever load it once.\n  analytics.load = function(key, options){\n    // Create an async script element based on your key.\n    var t = document.createElement(\'script\');\n    t.type = \'text/javascript\';\n    t.async = true;\n    t.src = "https://' +
((__t = ( settings.host )) == null ? '' : __t) +
'' +
((__t = ( settings.ajsPath )) == null ? '' : __t) +
'";\n\n    // Insert our script next to the first script element.\n    var first = document.getElementsByTagName(\'script\')[0];\n    first.parentNode.insertBefore(t, first);\n    analytics._loadOptions = options;\n  };\n  analytics._writeKey = \'' +
((__t = ( settings.apiKey )) == null ? '' : __t) +
'\';\n\n  ' +
((__t = ( settings.optionalCDN )) == null ? '' : __t) +
'\n\n  // Add a version to keep track of what\'s in the wild.\n  analytics.SNIPPET_VERSION = \'4.16.1\';\n\n  // Load Analytics.js with your key, which will automatically\n  // load the tools you\'ve enabled for your account. Boosh!\n  ' +
((__t = ( settings.load )) == null ? '' : __t) +
'\n\n  // Make the first page call to load the integrations. If\n  // you\'d like to manually name or tag the page, edit or\n  // move this call however you\'d like.\n  ' +
((__t = ( settings.page )) == null ? '' : __t) +
'\n})();\n';
return __p
}

/***/ }),

/***/ 82700:
/***/ (function(module) {

module.exports=function(settings) {
var __t, __p = '';
__p += '!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){if(window.analytics.initialized)return window.analytics[e].apply(window.analytics,arguments);var i=Array.prototype.slice.call(arguments);i.unshift(e);analytics.push(i);return analytics}};for(var i=0;i<analytics.methods.length;i++){var key=analytics.methods[i];analytics[key]=analytics.factory(key)}analytics.load=function(key,i){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://' +
((__t = ( settings.host )) == null ? '' : __t) +
'' +
((__t = ( settings.ajsPath )) == null ? '' : __t) +
'";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=i};analytics._writeKey="' +
((__t = ( settings.apiKey )) == null ? '' : __t) +
'";' +
((__t = ( settings.optionalCDN )) == null ? '' : __t) +
';analytics.SNIPPET_VERSION="4.16.1";\n' +
((__t = ( settings.load )) == null ? '' : __t) +
'\n' +
((__t = ( settings.page )) == null ? '' : __t) +
'\n}}();';
return __p
}

/***/ }),

/***/ 70490:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


/**
 * Module Dependencies.
 */

var map = __webpack_require__(20321);
var maxTemplate = __webpack_require__(39160);
var minTemplate = __webpack_require__(82700);

/**
 * Has convenience alias
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Return the maxified templating function.
 *
 * @param {Object} options (optional)
 * @return {String} rendered
 */

__webpack_unused_export__ = function(options) {
  var settings = defaults(options);
  settings.load = renderLoad(settings);
  settings.page = renderPage(settings.page);
  settings.optionalCDN = renderOptionalCDNHost(settings);

  return maxTemplate(settings);
};

/**
 * Return the minified templating function.
 *
 * @param {Object} options
 * @return {String} min
 */

exports.V = function(options) {
  var settings = defaults(options);
  settings.load = renderLoad(settings);
  settings.page = renderPage(settings.page);
  settings.optionalCDN = renderOptionalCDNHost(settings);

  return minTemplate(settings);
};

/**
 * Back an options object with the snippet defaults.
 *
 * @param {Object} options (optional)
 * @return {Object}
 */

function defaults(options) {
  options || (options = {});
  options.apiKey || (options.apiKey = 'YOUR_API_KEY');
  options.host || (options.host = 'cdn.segment.com');
  options.ajsPath || (options.ajsPath = '/analytics.js/v1/\" + key + \"/analytics.min.js');
  options.useHostForBundles || (options.useHostForBundles = false);

  if (!has.call(options, 'page')) options.page = true;
  if (!has.call(options, 'load')) options.load = true;
  return options;
}

/**
 * Handlebars helper which will render the window.analytics.page call.
 *
 * By default just render the empty call, adding whatever arguments are
 * passed in explicitly.
 *
 * @param {Object|Boolean} page options (name, category, properties)
 * @return {String}
 */

function renderPage(page) {
  if (!page) return '';

  var args = [];

  if (page.category) args.push(page.category);
  if (page.name) args.push(page.name);
  if (page.properties) args.push(page.properties);

  // eslint-disable-next-line no-restricted-globals
  var res = 'analytics.page(' + map(JSON.stringify, args).join(', ') + ');';

  return res;
}

function renderLoad(settings) {
  if (!settings.load) return '';

  if (typeof settings.load !== 'boolean') {
    // eslint-disable-next-line no-restricted-globals
    var loadOptions = JSON.stringify(settings.load);
    return 'analytics.load("' + settings.apiKey + '", ' + loadOptions + ');';
  }

  return 'analytics.load("' + settings.apiKey + '");';
}

function renderOptionalCDNHost(settings) {
  if (!settings) return '';

  if (typeof settings.useHostForBundles === 'boolean' && settings.useHostForBundles) {
    return 'analytics._cdn = "https://' + settings.host + '"';
  }

  return '';
}


/***/ }),

/***/ 95766:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(95766)
const ieee754 = __webpack_require__(62333)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

const K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 3613:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(t,e){ true?e(exports):0}(this,(function(t){"use strict";var e={};Object.defineProperty(e,"__esModule",{value:!0});var n=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],i=!0,r=!1,a=void 0;try{for(var o,s=t[Symbol.iterator]();!(i=(o=s.next()).done)&&(n.push(o.value),!e||n.length!==e);i=!0);}catch(t){r=!0,a=t}finally{try{!i&&s.return&&s.return()}finally{if(r)throw a}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},i={getItem:function(t,e){return i.multiGet([t]).then((function(t){return t[0][1]})).then((function(t){return e&&e(null,t),t})).catch((function(t){return e&&e(t,null),t}))},setItem:function(t,e,n){return i.multiSet([[t,e]]).then((function(t){return n&&n(null,t),t})).catch((function(t){return n&&n(t,null),t}))},getAllKeys:function(t){return Promise.resolve(Object.keys(localStorage)).then((function(e){return t&&t(null,e),e})).catch((function(e){return t&&t(e,null),e}))},removeItem:function(t,e){return i.multiRemove([t]).then((function(){e&&e(null)})).catch((function(t){e&&e(t,null)}))},clear:function(){return new Promise((function(t){window.localStorage.clear(),t()}))},multiGet:function(t){return new Promise((function(e){e(t.reduce((function(t,e){return t.concat([[e,localStorage.getItem(e)]])}),[]))}))},multiSet:function(t){return new Promise((function(e,i){var r=[];return t.forEach((function(t){var e=n(t,2),i=e[0],a=e[1];try{localStorage.setItem(i,a)}catch(t){r.push(t)}})),r.length>0?i(r):e()}))},multiRemove:function(t){return new Promise((function(e){t.forEach((function(t){return window.localStorage.removeItem(t)})),e()}))},flushGetRequests:function(){console.warn("AsyncStorage.flushGetRequests: Not supported on `web`")}},r=e.default=i,a=function(){return a=Object.assign||function(t){for(var e,n=1,i=arguments.length;n<i;n++)for(var r in e=arguments[n])Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r]);return t},a.apply(this,arguments)};function o(t,e,n){if(n||2===arguments.length)for(var i,r=0,a=e.length;r<a;r++)!i&&r in e||(i||(i=Array.prototype.slice.call(e,0,r)),i[r]=e[r]);return t.concat(i||Array.prototype.slice.call(e))}var s,l,u=function t(e,n){if(e===n)return!0;if(e&&n&&"object"==typeof e&&"object"==typeof n){if(e.constructor!==n.constructor)return!1;var i,r,a;if(Array.isArray(e)){if((i=e.length)!=n.length)return!1;for(r=i;0!=r--;)if(!t(e[r],n[r]))return!1;return!0}if(e.constructor===RegExp)return e.source===n.source&&e.flags===n.flags;if(e.valueOf!==Object.prototype.valueOf)return e.valueOf()===n.valueOf();if(e.toString!==Object.prototype.toString)return e.toString()===n.toString();if((i=(a=Object.keys(e)).length)!==Object.keys(n).length)return!1;for(r=i;0!=r--;)if(!Object.prototype.hasOwnProperty.call(n,a[r]))return!1;for(r=i;0!=r--;){var o=a[r];if(!t(e[o],n[o]))return!1}return!0}return e!=e&&n!=n},c=null,h="BULLET_TRAIN_DB",g="BULLET_TRAIN_EVENT",f="https://edge.api.flagsmith.com/api/v1/",v=function(t){return"Attempted to "+t+" a user before calling flagsmith.init. Call flagsmith.init first, if you wish to prevent it sending a request for flags, call init with preventFetch:true."},d="flagsmith_value_",p="flagsmith_enabled_",m="flagsmith_trait_",y=function(){function t(t){var e=this;this.timestamp=null,this.isLoading=!1,this.eventSource=null,this.getJSON=function(t,n,i){var r=e,a=r.environmentID,o=r.headers,l={method:n||"GET",body:i,headers:{"x-environment-key":"".concat(a)}};return n&&"GET"!==n&&(l.headers["Content-Type"]="application/json; charset=utf-8"),o&&Object.assign(l.headers,o),s||console.error("Flagsmith: fetch is undefined, please specify a fetch implementation into flagsmith.init to support SSR."),s(t,l).then((function(i){var r,a=null===(r=i.headers)||void 0===r?void 0:r.get("x-flagsmith-document-updated-at");if(a)try{var o=parseFloat(a);if(isNaN(o))throw"Failed to parse x-flagsmith-document-updated-at";e.timestamp=o}catch(t){e.log(t,"Failed to parse x-flagsmith-document-updated-at",a)}return e.log("Fetch response: "+i.status+" "+(n||"GET")+0+t),i.text().then((function(t){var e=t;try{e=JSON.parse(t)}catch(t){}return i.status&&i.status>=200&&i.status<300?e:Promise.reject(e)}))})).catch((function(t){throw console.error("Flagsmith: Fetch error: "+t),new Error("Flagsmith: Fetch error:"+t)}))},this.getFlags=function(t,n){var i=e,r=i.onChange,o=i.onError,s=i.identity,l=i.api,c=!1;e.log("Get Flags"),e.isLoading=!0;var h=function(t){var n=t.flags,i=t.traits;e.isLoading=!1,s&&(e.withTraits=null);var o={},l={};i=i||[],(n=n||[]).forEach((function(t){o[t.feature.name.toLowerCase().replace(/ /g,"_")]={id:t.feature.id,enabled:t.enabled,value:t.feature_state_value}})),i.forEach((function(t){l[t.trait_key.toLowerCase().replace(/ /g,"_")]=t.trait_value})),e.oldFlags=a({},e.flags);var c=u(e.flags,o),h=u(e.traits,l);if(e.flags=o,e.traits=l,e.updateStorage(),e.datadogRum)try{if(e.datadogRum.trackTraits){var g={};Object.keys(e.traits).map((function(t){g[m+t]=e.getTrait(t)}));var f=a(a(a({},e.datadogRum.client.getUser()),{id:e.datadogRum.client.getUser().id||e.identity}),g);e.log("Setting Datadog user",f),e.datadogRum.client.setUser(f)}}catch(t){console.error(t)}if(e.dtrum)try{var v={javaDouble:{},date:{},shortString:{},javaLongOrObject:{}};Object.keys(e.flags).map((function(t){E(v,d+t,e.getValue(t,{},!0)),E(v,p+t,e.hasFeature(t,!0))})),Object.keys(e.traits).map((function(t){E(v,m+t,e.getTrait(t))})),e.log("Sending javaLongOrObject traits to dynatrace",v.javaLongOrObject),e.log("Sending date traits to dynatrace",v.date),e.log("Sending shortString traits to dynatrace",v.shortString),e.log("Sending javaDouble to dynatrace",v.javaDouble),e.dtrum.sendSessionProperties(v.javaLongOrObject,v.date,v.shortString,v.javaDouble)}catch(t){console.error(t)}r&&r(e.oldFlags,{isFromServer:!0,flagsChanged:!c,traitsChanged:!h})};return s?Promise.all([e.withTraits?e.getJSON(l+"identities/","POST",JSON.stringify({identifier:s,traits:Object.keys(e.withTraits).map((function(t){return{trait_key:t,trait_value:e.withTraits[t]}})).filter((function(t){return void 0!==t.trait_value||(e.log("Warning - attempted to set an undefined trait value for key",t.trait_key),!1)}))})):e.getJSON(l+"identities/?identifier="+encodeURIComponent(s))]).then((function(n){e.withTraits=null,h(n[0]),t&&!c&&(c=!0,t())})).catch((function(t){var n=t.message;e.isLoading=!1,o&&o(new Error(n))})):Promise.all([e.getJSON(l+"flags/")]).then((function(e){h({flags:e[0],traits:void 0}),t&&!c&&(c=!0,t())})).catch((function(t){e.isLoading=!1,n&&!c&&(c=!0,n(t)),o&&o(t)}))},this.analyticsFlags=function(){var t=e.api;if(e.evaluationEvent&&e.evaluationEvent[e.environmentID])return e.evaluationEvent&&0!==Object.getOwnPropertyNames(e.evaluationEvent).length&&0!==Object.getOwnPropertyNames(e.evaluationEvent[e.environmentID]).length?e.getJSON(t+"analytics/flags/","POST",JSON.stringify(e.evaluationEvent[e.environmentID])).then((function(t){var n=e.getState();e.evaluationEvent||(e.evaluationEvent={}),e.evaluationEvent[e.environmentID]={},e.setState(a(a({},n),{evaluationEvent:e.evaluationEvent})),e.updateEventStorage()})).catch((function(t){e.log("Exception fetching evaluationEvent",t)})):void 0},this.datadogRum=null,this.canUseStorage=!1,this.analyticsInterval=null,this.api=null,this.cacheFlags=!1,this.ts=null,this.enableAnalytics=!1,this.enableLogs=!1,this.environmentID="",this.evaluationEvent=null,this.flags=null,this.getFlagInterval=null,this.headers=null,this.initialised=!1,this.oldFlags=null,this.onChange=null,this.onError=null,this.trigger=null,this.identity=null,this.ticks=null,this.timer=null,this.traits=null,this.dtrum=null,this.withTraits=null,this.cacheOptions={ttl:0,skipAPI:!1},this.evaluateFlag=function(t,n){if(e.datadogRum&&(e.datadogRum.client.addFeatureFlagEvaluation?(e.log("Sending feature flag evaluation to Datadog",t,n),"VALUE"===n?e.datadogRum.client.addFeatureFlagEvaluation(d+t,e.getValue(t,{},!0)):e.datadogRum.client.addFeatureFlagEvaluation(p+t,e.hasFeature(t,!0))):console.error("Flagsmith: Your datadog RUM client does not support the function addFeatureFlagEvaluation, please update it.")),e.enableAnalytics){if(!e.evaluationEvent)return;e.evaluationEvent[e.environmentID]||(e.evaluationEvent[e.environmentID]={}),void 0===e.evaluationEvent[e.environmentID][t]&&(e.evaluationEvent[e.environmentID][t]=0),e.evaluationEvent[e.environmentID][t]+=1}e.updateEventStorage()},this.getValue=function(t,n,i){var r=e.flags&&e.flags[t.toLowerCase().replace(/ /g,"_")],a=null;if(r&&(a=r.value),i||e.evaluateFlag(t,"VALUE"),null==n?void 0:n.json)try{return null===a?(e.log("Tried to parse null flag as JSON: "+t),n.fallback):JSON.parse(a)}catch(t){return n.fallback}return a},this.getTrait=function(t){return e.traits&&e.traits[t.toLowerCase().replace(/ /g,"_")]},this.getAllTraits=function(){return e.traits},this.setTrait=function(t,n){if(e.api){var i={};return i[t]=n,e.setTraits(i)}console.error(v("setTrait"))},this.setTraits=function(t){if(e.api){if(t&&"object"==typeof t||console.error("Expected object for flagsmith.setTraits"),e.withTraits=a(a({},e.withTraits||{}),t),e.identity)return e.initialised?e.getFlags():void 0;e.log("Set traits prior to identifying",e.withTraits)}else console.error(v("setTraits"))},this.hasFeature=function(t,n){var i=e.flags&&e.flags[t.toLowerCase().replace(/ /g,"_")],r=!1;return i&&i.enabled&&(r=!0),n||e.evaluateFlag(t,"ENABLED"),r},s=t.fetch?t.fetch:"undefined"!=typeof fetch?fetch:null===__webpack_require__.g||void 0===__webpack_require__.g?void 0:__webpack_require__.g.fetch,this.canUseStorage="undefined"!=typeof window||!!t.browserlessStorage,this.log("Constructing flagsmith instance "+t),t.eventSource&&(l=t.eventSource),t.AsyncStorage&&(c=t.AsyncStorage)}return t.prototype.init=function(t){var e=this,n=t.environmentID,i=t.api,r=void 0===i?f:i,o=t.headers,u=t.onChange,v=t.cacheFlags,d=t.datadogRum,p=t.onError,m=t.defaultFlags,y=t.fetch,S=t.preventFetch,_=t.enableLogs,E=t.enableDynatrace,b=t.enableAnalytics,w=t.realtime,I=t.eventSourceUrl,O=void 0===I?"https://realtime.flagsmith.com/":I,F=t.AsyncStorage,C=t.identity,T=t.traits,j=t._trigger,A=t.state,P=t.cacheOptions,L=t.angularHttpClient;return new Promise((function(t,i){if(e.environmentID=n,e.api=r,e.headers=o,e.getFlagInterval=null,e.analyticsInterval=null,e.onChange=function(t,n){u&&u(t,n),e.trigger&&(e.log("trigger called"),e.trigger())},e.trigger=j||e.trigger,e.onError=p?function(t){t instanceof Error?p(t):p(new Error(t))}:null,e.identity=C,e.withTraits=T,e.enableLogs=_||!1,e.cacheOptions=P?{skipAPI:!!P.skipAPI,ttl:P.ttl||0}:e.cacheOptions,!e.cacheOptions.ttl&&e.cacheOptions.skipAPI&&console.warn("Flagsmith: you have set a cache ttl of 0 and are skipping API calls, this means the API will not be hit unless you clear local storage."),y&&(s=y),e.enableAnalytics=b||!1,e.flags=Object.assign({},m)||{},e.initialised=!0,e.ticks=1e4,w&&"undefined"!=typeof window){var f=O+"sse/environments/"+n+"/stream";l?e.eventSource||(e.log("Creating event source with url "+f),e.eventSource=new l(f),e.eventSource.addEventListener("environment_updated",(function(t){var n;try{n=JSON.parse(t.data).updated_at}catch(t){e.log("Could not parse sse event",t)}n?!e.timestamp||n>e.timestamp?e.isLoading?e.log("updated_at is new, but flags are loading",t.data,e.timestamp):(e.log("updated_at is new, fetching flags",t.data,e.timestamp),e.getFlags()):e.log("updated_at is outdated, skipping get flags",t.data,e.timestamp):e.log("No updated_at received, fetching flags",t)}))):e.log("Error, EventSource is undefined")}if(e.log("Initialising with properties",{environmentID:n,api:r,headers:o,onChange:u,cacheFlags:v,onError:p,defaultFlags:m,preventFetch:S,enableLogs:_,enableAnalytics:b,AsyncStorage:c,identity:C,traits:T,_trigger:j,state:A,angularHttpClient:L},e),e.timer=e.enableLogs?(new Date).valueOf():null,F&&(c=F),e.cacheFlags=void 0!==c&&!!v,e.setState(A),!n)throw i("Please specify a environment id"),"Please specify a environment id";d&&(e.datadogRum=d),E&&("undefined"==typeof dtrum?console.error("You have attempted to enable dynatrace but dtrum is undefined, please check you have the Dynatrace RUM JavaScript API installed."):e.dtrum=dtrum),L&&(s=function(t,e){var n=e.headers,i=e.method,r=e.body;return new Promise((function(e){switch(i){case"GET":return L.get(t,{headers:n}).subscribe((function(t){e({ok:!0,text:function(){return Promise.resolve(t)}})}));case"POST":case"PUT":return L.post(t,r,{headers:n}).subscribe((function(t){e({ok:!0,text:function(){return Promise.resolve(t)}})}))}}))}),c&&e.canUseStorage&&c.getItem(g).then((function(t){if(t)try{e.evaluationEvent=JSON.parse(t)}catch(t){e.evaluationEvent={}}else e.evaluationEvent={};return e.analyticsInterval=setInterval(e.analyticsFlags,e.ticks),!0})),e.enableAnalytics&&(e.analyticsInterval&&clearInterval(e.analyticsInterval),c&&e.canUseStorage&&c.getItem(g,(function(t,n){if(n){var i=JSON.parse(n);i[e.environmentID]&&(A=e.getState(),e.log("Retrieved events from cache",n),e.setState(a(a({},A),{evaluationEvent:i[e.environmentID]})))}return!0}))),v?c&&e.canUseStorage&&c.getItem(h,(function(n,r){if(r)try{var a=JSON.parse(r),o=!1;if(a&&a.api===e.api&&a.environmentID===e.environmentID){var s=!0;e.identity&&a.identity!==e.identity&&(e.log("Ignoring cache,  identity has changed from "+a.identity+" to "+e.identity),s=!1),e.cacheOptions.ttl&&(!a.ts||(new Date).valueOf()-a.ts>e.cacheOptions.ttl)&&a.ts&&(e.log("Ignoring cache, timestamp is too old ts:"+a.ts+" ttl: "+e.cacheOptions.ttl+" time elapsed since cache: "+((new Date).valueOf()-a.ts)+"ms"),s=!1),s&&(o=!0,e.setState(a),e.log("Retrieved flags from cache",a))}e.flags?(e.onChange&&(e.log("onChange called"),e.onChange(null,{isFromServer:!1,flagsChanged:!0,traitsChanged:!!e.traits})),e.oldFlags=e.flags,t(!0),e.cacheOptions.skipAPI&&o&&e.log("Skipping API, using cache"),S||e.cacheOptions.skipAPI&&o||e.getFlags()):S?t(!0):e.getFlags(t,i)}catch(t){e.log("Exception fetching cached logs",t)}else S?(m&&e.onChange&&(e.log("onChange called"),e.onChange(null,{isFromServer:!1,flagsChanged:!0,traitsChanged:!!e.traits})),t(!0)):e.getFlags(t,i);return!0})):S?(m&&e.onChange&&(e.log("onChange called"),e.onChange(null,{isFromServer:!1,flagsChanged:!0,traitsChanged:!!e.traits})),t(!0)):e.getFlags(t,i)})).catch((function(t){e.log("Error during initialisation ",t),p&&p(t)}))},t.prototype.getAllFlags=function(){return this.flags},t.prototype.identify=function(t,e){return this.identity=t,this.log("Identify: "+this.identity),e&&(this.withTraits=a(a({},this.withTraits||{}),e)),this.initialised?this.getFlags():Promise.resolve()},t.prototype.getState=function(){return{api:this.api,environmentID:this.environmentID,flags:this.flags,identity:this.identity,ts:this.ts,traits:this.traits,evaluationEvent:this.evaluationEvent}},t.prototype.setState=function(t){t&&(this.initialised=!0,this.api=t.api||this.api||f,this.environmentID=t.environmentID||this.environmentID,this.flags=t.flags||this.flags,this.identity=t.identity||this.identity,this.traits=t.traits||this.traits,this.evaluationEvent=t.evaluationEvent||this.evaluationEvent,this.log("setState called",this))},t.prototype.log=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];this.enableLogs&&console.log.apply(this,o(["FLAGSMITH:",(new Date).valueOf()-(this.timer||0),"ms"],t,!0))},t.prototype.updateStorage=function(){if(this.cacheFlags){this.ts=(new Date).valueOf();var t=JSON.stringify(this.getState());this.log("Setting storage",t),c.setItem(h,t)}},t.prototype.updateEventStorage=function(){if(this.enableAnalytics){var t=JSON.stringify(this.getState().evaluationEvent);this.log("Setting event storage",t),c.setItem(g,t)}},t.prototype.logout=function(){return this.identity=null,this.traits=null,this.initialised?this.getFlags():Promise.resolve()},t.prototype.startListening=function(t){void 0===t&&(t=1e3),this.getFlagInterval&&clearInterval(this.getFlagInterval),this.getFlagInterval=setInterval(this.getFlags,t)},t.prototype.stopListening=function(){this.getFlagInterval&&(clearInterval(this.getFlagInterval),this.getFlagInterval=null)},t.prototype.getSegments=function(){},t}();function S(t){var e=t.fetch,n=t.AsyncStorage,i=t.eventSource;return new y({fetch:e,AsyncStorage:n,eventSource:i})}var _,E=function(t,e,n){var i="shortString",r=!0;"number"==typeof n&&(i="javaDouble",r=!1),t[i]=t[i]||{},t[i][e]=r?n+"":n},b=(_=function(t,e){return _=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n])},_(t,e)},function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Class extends value "+String(e)+" is not a constructor or null");function n(){this.constructor=t}_(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}),w=function(t){var e="function"==typeof Symbol&&Symbol.iterator,n=e&&t[e],i=0;if(n)return n.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&i>=t.length&&(t=void 0),{value:t&&t[i++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")},I=function(t,e){var n="function"==typeof Symbol&&t[Symbol.iterator];if(!n)return t;var i,r,a=n.call(t),o=[];try{for(;(void 0===e||e-- >0)&&!(i=a.next()).done;)o.push(i.value)}catch(t){r={error:t}}finally{try{i&&!i.done&&(n=a.return)&&n.call(a)}finally{if(r)throw r.error}}return o},O=function(t,e,n){if(n||2===arguments.length)for(var i,r=0,a=e.length;r<a;r++)!i&&r in e||(i||(i=Array.prototype.slice.call(e,0,r)),i[r]=e[r]);return t.concat(i||Array.prototype.slice.call(e))},F=function(t){function e(){return t.call(this,"EventSource not available.\nConsider loading an EventSource polyfill and making it available globally as EventSource, or passing one in as eventSourceClass to the ReconnectingEventSource constructor.")||this}return b(e,t),e}(Error),C=function(){function t(t,e){var n=this;if(this.CONNECTING=0,this.OPEN=1,this.CLOSED=2,this._configuration=null!=e?Object.assign({},e):void 0,this.withCredentials=!1,this._eventSource=null,this._lastEventId=null,this._timer=null,this._listeners={open:[],error:[],message:[]},this.url=t.toString(),this.readyState=this.CONNECTING,this.max_retry_time=3e3,this.eventSourceClass=globalThis.FlagsmithEventSource,null!=this._configuration&&(this._configuration.lastEventId&&(this._lastEventId=this._configuration.lastEventId,delete this._configuration.lastEventId),this._configuration.max_retry_time&&(this.max_retry_time=this._configuration.max_retry_time,delete this._configuration.max_retry_time),this._configuration.eventSourceClass&&(this.eventSourceClass=this._configuration.eventSourceClass,delete this._configuration.eventSourceClass)),null==this.eventSourceClass||"function"!=typeof this.eventSourceClass)throw new F;this._onevent_wrapped=function(t){n._onevent(t)},this._start()}return t.prototype.dispatchEvent=function(t){throw new Error("Method not implemented.")},t.prototype._start=function(){var t,e,n=this,i=this.url;this._lastEventId&&(-1===i.indexOf("?")?i+="?":i+="&",i+="lastEventId="+encodeURIComponent(this._lastEventId)),this._eventSource=new this.eventSourceClass(i,this._configuration),this._eventSource.onopen=function(t){n._onopen(t)},this._eventSource.onerror=function(t){n._onerror(t)},this._eventSource.onmessage=function(t){n.onmessage(t)};try{for(var r=w(Object.keys(this._listeners)),a=r.next();!a.done;a=r.next()){var o=a.value;this._eventSource.addEventListener(o,this._onevent_wrapped)}}catch(e){t={error:e}}finally{try{a&&!a.done&&(e=r.return)&&e.call(r)}finally{if(t)throw t.error}}},t.prototype._onopen=function(t){0===this.readyState&&(this.readyState=1,this.onopen(t))},t.prototype._onerror=function(t){var e=this;if(1===this.readyState&&(this.readyState=0,this.onerror(t)),this._eventSource){this._eventSource.close(),this._eventSource=null;var n=Math.round(this.max_retry_time*Math.random());this._timer=setTimeout((function(){return e._start()}),n)}},t.prototype._onevent=function(t){var e,n;t&&t.lastEventId&&(this._lastEventId=t.lastEventId);var i=this._listeners[t.type];if(null!=i)try{for(var r=w(O([],I(i),!1)),a=r.next();!a.done;a=r.next()){a.value.call(this,t)}}catch(t){e={error:t}}finally{try{a&&!a.done&&(n=r.return)&&n.call(r)}finally{if(e)throw e.error}}"message"===t.type&&this.onmessage(t)},t.prototype.onopen=function(t){},t.prototype.onerror=function(t){},t.prototype.onmessage=function(t){},t.prototype.close=function(){this._timer&&(clearTimeout(this._timer),this._timer=null),this._eventSource&&(this._eventSource.close(),this._eventSource=null),this.readyState=2},t.prototype.addEventListener=function(t,e,n){null==this._listeners[t]&&(this._listeners[t]=[],null!=this._eventSource&&this._eventSource.addEventListener(t,this._onevent_wrapped));var i=this._listeners[t];i.includes(e)||(this._listeners[t]=O(O([],I(i),!1),[e],!1))},t.prototype.removeEventListener=function(t,e,n){var i=this._listeners[t];this._listeners[t]=i.filter((function(t){return t!==e}))},t}();globalThis.FlagsmithEventSource="undefined"!=typeof EventSource?EventSource:null;var T=function(t,e){return e=e||{},new Promise((function(n,i){var r=new XMLHttpRequest,a=[],o=[],s={},l=function(){return{ok:2==(r.status/100|0),statusText:r.statusText,status:r.status,url:r.responseURL,text:function(){return Promise.resolve(r.responseText)},json:function(){return Promise.resolve(r.responseText).then(JSON.parse)},blob:function(){return Promise.resolve(new Blob([r.response]))},clone:l,headers:{keys:function(){return a},entries:function(){return o},get:function(t){return s[t.toLowerCase()]},has:function(t){return t.toLowerCase()in s}}}};for(var u in r.open(e.method||"get",t,!0),r.onload=function(){r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,(function(t,e,n){a.push(e=e.toLowerCase()),o.push([e,n]),s[e]=s[e]?s[e]+","+n:n})),n(l())},r.onerror=i,r.withCredentials="include"==e.credentials,e.headers)r.setRequestHeader(u,e.headers[u]);r.send(e.body||null)}))},j=S({AsyncStorage:r,fetch:T,eventSource:C});"undefined"!=typeof window&&(window.flagsmith=j);t.createFlagsmithInstance=function(){return S({AsyncStorage:r,fetch:T,eventSource:C})},t.default=j,Object.defineProperty(t,"__esModule",{value:!0})}));
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 98861:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(2784)):0}(this,(function(e,t){"use strict";function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=n(t),i=function(){return i=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},i.apply(this,arguments)},o={exports:{}};function a(){}a.prototype={on:function(e,t,n){var r=this.e||(this.e={});return(r[e]||(r[e]=[])).push({fn:t,ctx:n}),this},once:function(e,t,n){var r=this;function i(){r.off(e,i),t.apply(n,arguments)}return i._=t,this.on(e,i,n)},emit:function(e){for(var t=[].slice.call(arguments,1),n=((this.e||(this.e={}))[e]||[]).slice(),r=0,i=n.length;r<i;r++)n[r].fn.apply(n[r].ctx,t);return this},off:function(e,t){var n=this.e||(this.e={}),r=n[e],i=[];if(r&&t)for(var o=0,a=r.length;o<a;o++)r[o].fn!==t&&r[o].fn._!==t&&i.push(r[o]);return i.length?n[e]=i:delete n[e],this}},o.exports=a,o.exports.TinyEmitter=a;var u=new o.exports.TinyEmitter,s=t.createContext(null),f=function(e){var n=t.useRef(e);return n.current||(n.current=e),n.current},c=function(e){if("string"==typeof e)return[e];if("object"==typeof e&&e.hasOwnProperty("length"))return e;throw new Error("Flagsmith: please supply an array of strings or a single string of flag keys to useFlags")},l=function(e,t,n){return void 0===n&&(n=[]),t.map((function(t){return"".concat(e.getValue(t)).concat(e.hasFeature(t))})).concat(n.map((function(t){return"".concat(e.getTrait(t))}))).join(",")};e.FlagsmithContext=s,e.FlagsmithProvider=function(e){var n=e.flagsmith,o=e.options,a=e.serverState,f=e.children,c=t.useRef(!0);return n&&!(null==n?void 0:n.trigger)&&(n.trigger=function(){n.log("React - trigger event received"),u.emit("event")}),a&&!n.initialised&&n.setState(a),c.current&&(c.current=!1,o&&n.init(i(i({},o),{state:o.state||a,onChange:function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];o.onChange&&o.onChange.apply(o,e)}}))),r.default.createElement(s.Provider,{value:n},f)},e.useFlags=function(e,n){void 0===n&&(n=[]);var r=t.useRef(!0),i=f(c(e)),o=f(c(n)),a=t.useContext(s),g=t.useState(l(a,i,o)),h=g[0],p=g[1],v=t.useCallback((function(){var e=l(a,i,o);e!==h&&(null==a||a.log("React - useFlags flags and traits have changed"),p(e))}),[h]);return r.current&&(r.current=!1,null==a||a.log("React - Initialising event listeners")),t.useEffect((function(){return u.on("event",v),function(){u.off("event",v)}}),[v]),t.useMemo((function(){var e={};return i.map((function(t){e[t]={enabled:a.hasFeature(t),value:a.getValue(t)}})).concat(null==o?void 0:o.map((function(t){e[t]=a.getTrait(t)}))),e}),[h])},e.useFlagsmith=function(){var e=t.useContext(s);if(!e)throw new Error("useFlagsmith must be used with in a FlagsmithProvider");return e},Object.defineProperty(e,"__esModule",{value:!0})}));
//# sourceMappingURL=react.js.map


/***/ }),

/***/ 73463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(73887);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 43459:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 73887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(43459);
} else {}


/***/ }),

/***/ 62333:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 98357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;


/***/ }),

/***/ 89612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(52118),
    hashDelete = __webpack_require__(96909),
    hashGet = __webpack_require__(98138),
    hashHas = __webpack_require__(4174),
    hashSet = __webpack_require__(7942);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 80235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3945),
    listCacheDelete = __webpack_require__(21846),
    listCacheGet = __webpack_require__(88028),
    listCacheHas = __webpack_require__(72344),
    listCacheSet = __webpack_require__(94769);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 10326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 96738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(92411),
    mapCacheDelete = __webpack_require__(36417),
    mapCacheGet = __webpack_require__(86928),
    mapCacheHas = __webpack_require__(79493),
    mapCacheSet = __webpack_require__(24150);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 86571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235),
    stackClear = __webpack_require__(15243),
    stackDelete = __webpack_require__(72858),
    stackGet = __webpack_require__(4417),
    stackHas = __webpack_require__(8605),
    stackSet = __webpack_require__(71418);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 50857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 79162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 49432:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 1634:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(36473),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152),
    isBuffer = __webpack_require__(73226),
    isIndex = __webpack_require__(39045),
    isTypedArray = __webpack_require__(77598);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 28582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(13940),
    eq = __webpack_require__(41225);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 60091:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(13940),
    eq = __webpack_require__(41225);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 22218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(41225);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 13940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(83043);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 39413:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 15308:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(55463);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 53366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    getRawTag = __webpack_require__(62107),
    objectToString = __webpack_require__(37157);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 15183:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 6840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(61049),
    isMasked = __webpack_require__(47394),
    isObject = __webpack_require__(29259),
    toSource = __webpack_require__(87035);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 35522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isLength = __webpack_require__(61158),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 18390:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259),
    isPrototype = __webpack_require__(16001),
    nativeKeysIn = __webpack_require__(62966);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 84565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(86571),
    assignMergeValue = __webpack_require__(28582),
    baseFor = __webpack_require__(15308),
    baseMergeDeep = __webpack_require__(25561),
    isObject = __webpack_require__(29259),
    keysIn = __webpack_require__(18582),
    safeGet = __webpack_require__(52434);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 25561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(28582),
    cloneBuffer = __webpack_require__(92175),
    cloneTypedArray = __webpack_require__(6190),
    copyArray = __webpack_require__(51522),
    initCloneObject = __webpack_require__(78725),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152),
    isArrayLikeObject = __webpack_require__(93746),
    isBuffer = __webpack_require__(73226),
    isFunction = __webpack_require__(61049),
    isObject = __webpack_require__(29259),
    isPlainObject = __webpack_require__(97030),
    isTypedArray = __webpack_require__(77598),
    safeGet = __webpack_require__(52434),
    toPlainObject = __webpack_require__(63329);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 36060:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(23059),
    overRest = __webpack_require__(43114),
    setToString = __webpack_require__(75251);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 86532:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(86874),
    defineProperty = __webpack_require__(83043),
    identity = __webpack_require__(23059);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 36473:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 47826:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 79882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(79162);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 92175:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(37772);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 6190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(79882);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 51522:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(60091),
    baseAssignValue = __webpack_require__(13940);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 24019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 97263:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(36060),
    isIterateeCall = __webpack_require__(82406);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 55463:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 83043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 51242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 27937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(98304);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 38761:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(6840),
    getValue = __webpack_require__(98109);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 47353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(60241);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 62107:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 98109:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 52118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 96909:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 98138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 4174:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 7942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 78725:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(39413),
    getPrototype = __webpack_require__(47353),
    isPrototype = __webpack_require__(16001);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 39045:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 82406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(41225),
    isArrayLike = __webpack_require__(67878),
    isIndex = __webpack_require__(39045),
    isObject = __webpack_require__(29259);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 98304:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 47394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(24019);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 16001:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 3945:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 21846:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 88028:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 72344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 94769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 92411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(89612),
    ListCache = __webpack_require__(80235),
    Map = __webpack_require__(10326);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 36417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 86928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 79493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 24150:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 99191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 62966:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 4146:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(51242);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 37157:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 60241:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 43114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(49432);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 37772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(51242);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 52434:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 75251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(86532),
    shortOut = __webpack_require__(97787);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 97787:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 15243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 72858:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 4417:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 8605:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 71418:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235),
    Map = __webpack_require__(10326),
    MapCache = __webpack_require__(96738);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 87035:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 86874:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 41225:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 23059:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 79631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(15183),
    isObjectLike = __webpack_require__(15125);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 86152:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 67878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(61049),
    isLength = __webpack_require__(61158);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 93746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(67878),
    isObjectLike = __webpack_require__(15125);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 73226:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(37772),
    stubFalse = __webpack_require__(79207);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 61049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObject = __webpack_require__(29259);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 61158:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 29259:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 15125:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 97030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    getPrototype = __webpack_require__(47353),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 77598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(35522),
    baseUnary = __webpack_require__(47826),
    nodeUtil = __webpack_require__(4146);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 18582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1634),
    baseKeysIn = __webpack_require__(18390),
    isArrayLike = __webpack_require__(67878);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 76635:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 98537:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(84565),
    createAssigner = __webpack_require__(97263);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 79207:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 63329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(752),
    keysIn = __webpack_require__(18582);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 36631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["Z"] = (memoizeOne);


/***/ }),

/***/ 97438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cC": function() { return /* reexport */ es.Trans; },
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "ag": function() { return /* reexport */ globalI18n; },
  "$G": function() { return /* reexport */ es.useTranslation; }
});

// UNUSED EXPORTS: I18nContext, Translation, withTranslation

// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(98614);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(51171);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(59147);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || _nonIterableRest();
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
;// CONCATENATED MODULE: ../../node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },
  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },
  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: []
};
;// CONCATENATED MODULE: ../../node_modules/next-i18next/dist/esm/utils.js


var getFallbackForLng = function getFallbackForLng(lng, fallbackLng) {
  if (typeof fallbackLng === 'string') {
    return [fallbackLng];
  }
  if (Array.isArray(fallbackLng)) {
    return fallbackLng;
  }
  if (_typeof(fallbackLng) === 'object') {
    var fallbackList = fallbackLng[lng];
    var fallbackDefault = fallbackLng["default"];
    return [].concat(_toConsumableArray(fallbackList !== null && fallbackList !== void 0 ? fallbackList : []), _toConsumableArray(fallbackDefault !== null && fallbackDefault !== void 0 ? fallbackDefault : []));
  }
  if (typeof fallbackLng === 'function') {
    return getFallbackForLng(lng, fallbackLng(lng));
  }
  return [];
};
var unique = function unique(list) {
  return Array.from(new Set(list));
};
;// CONCATENATED MODULE: ../../node_modules/next-i18next/dist/esm/config/createConfig.js





var _excluded = ["i18n"],
  _excluded2 = ["i18n"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$interpola, _userConfig$interpola2, _userConfig$use;
  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  }

  //
  // Initial merge of default and user-provided config
  //
  var userI18n = userConfig.i18n,
    userConfigStripped = (0,objectWithoutProperties/* default */.Z)(userConfig, _excluded);
  var defaultI18n = defaultConfig.i18n,
    defaultConfigStripped = (0,objectWithoutProperties/* default */.Z)(defaultConfig, _excluded2);
  var combinedConfig = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);
  var defaultNS = combinedConfig.defaultNS,
    lng = combinedConfig.lng,
    localeExtension = combinedConfig.localeExtension,
    localePath = combinedConfig.localePath,
    nonExplicitSupportedLngs = combinedConfig.nonExplicitSupportedLngs;
  var locales = combinedConfig.locales.filter(function (l) {
    return l !== 'default';
  });

  /**
   * Skips translation file resolution while in cimode
   * https://github.com/i18next/next-i18next/pull/851#discussion_r503113620
   */
  if (lng === 'cimode') {
    return combinedConfig;
  }
  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;
    if (combinedConfig.fallbackLng === 'default') {
      var _locales = _slicedToArray(locales, 1);
      combinedConfig.fallbackLng = _locales[0];
    }
  }
  var userPrefix = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$interpola = userConfig.interpolation) === null || _userConfig$interpola === void 0 ? void 0 : _userConfig$interpola.prefix;
  var userSuffix = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$interpola2 = userConfig.interpolation) === null || _userConfig$interpola2 === void 0 ? void 0 : _userConfig$interpola2.suffix;
  var prefix = userPrefix !== null && userPrefix !== void 0 ? userPrefix : '{{';
  var suffix = userSuffix !== null && userSuffix !== void 0 ? userSuffix : '}}';
  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.localeStructure) !== 'string' && (userPrefix || userSuffix)) {
    combinedConfig.localeStructure = "".concat(prefix, "lng").concat(suffix, "/").concat(prefix, "ns").concat(suffix);
  }
  var fallbackLng = combinedConfig.fallbackLng,
    localeStructure = combinedConfig.localeStructure;
  if (nonExplicitSupportedLngs) {
    var createFallbackObject = function createFallbackObject(acc, l) {
      var _l$split = l.split('-'),
        _l$split2 = _slicedToArray(_l$split, 1),
        locale = _l$split2[0];
      acc[l] = [locale];
      return acc;
    };
    if (typeof fallbackLng === 'string') {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": [fallbackLng]
      });
    } else if (Array.isArray(fallbackLng)) {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": fallbackLng
      });
    } else if ((0,esm_typeof/* default */.Z)(fallbackLng) === 'object') {
      combinedConfig.fallbackLng = Object.entries(combinedConfig.fallbackLng).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          l = _ref2[0],
          f = _ref2[1];
        acc[l] = l.includes('-') ? unique([l.split('-')[0]].concat((0,toConsumableArray/* default */.Z)(f))) : f;
        return acc;
      }, fallbackLng);
    } else if (typeof fallbackLng === 'function') {
      throw new Error('If nonExplicitSupportedLngs is true, no functions are allowed for fallbackLng');
    }
  }
  var hasCustomBackend = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });
  if (false) { var getNamespaces, _defaultFallbackNSExists, _fallback, _defaultNSExists, _defaultNSPath, defaultFallbackNSExists, fallback, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }
    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  }

  //
  // Deep merge with overwrite - goes last
  //
  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = _objectSpread(_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
;// CONCATENATED MODULE: ../../node_modules/i18next/dist/esm/i18next.js
const consoleLogger = {
  type: 'logger',
  log(args) {
    this.output('log', args);
  },
  warn(args) {
    this.output('warn', args);
  },
  error(args) {
    this.output('error', args);
  },
  output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
class Logger {
  constructor(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.init(concreteLogger, options);
  }
  init(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  }
  log() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return this.forward(args, 'log', '', true);
  }
  warn() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return this.forward(args, 'warn', '', true);
  }
  error() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return this.forward(args, 'error', '');
  }
  deprecate() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  }
  forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = `${prefix}${this.prefix} ${args[0]}`;
    return this.logger[lvl](args);
  }
  create(moduleName) {
    return new Logger(this.logger, {
      ...{
        prefix: `${this.prefix}:${moduleName}:`
      },
      ...this.options
    });
  }
  clone(options) {
    options = options || this.options;
    options.prefix = options.prefix || this.prefix;
    return new Logger(this.logger, options);
  }
}
var baseLogger = new Logger();

class EventEmitter {
  constructor() {
    this.observers = {};
  }
  on(events, listener) {
    events.split(' ').forEach(event => {
      this.observers[event] = this.observers[event] || [];
      this.observers[event].push(listener);
    });
    return this;
  }
  off(event, listener) {
    if (!this.observers[event]) return;
    if (!listener) {
      delete this.observers[event];
      return;
    }
    this.observers[event] = this.observers[event].filter(l => l !== listener);
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (this.observers[event]) {
      const cloned = [].concat(this.observers[event]);
      cloned.forEach(observer => {
        observer(...args);
      });
    }
    if (this.observers['*']) {
      const cloned = [].concat(this.observers['*']);
      cloned.forEach(observer => {
        observer.apply(observer, [event, ...args]);
      });
    }
  }
}

function defer() {
  let res;
  let rej;
  const promise = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(m => {
    if (s[m]) t[m] = s[m];
  });
}
function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }
  const stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    const key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}
function setPath(object, path, newValue) {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  const {
    obj,
    k
  } = getLastOfPath(object, path);
  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  const value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (const prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, s => _entityMap[s]);
  }
  return data;
}
const chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  const possibleChars = chars.filter(c => nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
  if (possibleChars.length === 0) return true;
  const r = new RegExp(`(${possibleChars.map(c => c === '?' ? '\\?' : c).join('|')})`);
  let matched = !r.test(key);
  if (!matched) {
    const ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
}
function deepFind(obj, path) {
  let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  const paths = path.split(keySeparator);
  let current = obj;
  for (let i = 0; i < paths.length; ++i) {
    if (!current) return undefined;
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }
    if (current[paths[i]] === undefined) {
      let j = 2;
      let p = paths.slice(i, i + j).join(keySeparator);
      let mix = current[p];
      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }
      if (mix === undefined) return undefined;
      if (mix === null) return null;
      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }
      const joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }
    current = current[paths[i]];
  }
  return current;
}
function getCleanedCode(code) {
  if (code && code.indexOf('_') > 0) return code.replace('_', '-');
  return code;
}

class ResourceStore extends EventEmitter {
  constructor(data) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    super();
    this.data = data || {};
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    if (this.options.ignoreJSONStructure === undefined) {
      this.options.ignoreJSONStructure = true;
    }
  }
  addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  }
  removeNamespaces(ns) {
    const index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  }
  getResource(lng, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }
    const result = getPath(this.data, path);
    if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
    return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
  }
  addResource(lng, ns, key, value) {
    let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      silent: false
    };
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    setPath(this.data, path, value);
    if (!options.silent) this.emit('added', lng, ns, key, value);
  }
  addResources(lng, ns, resources) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
      silent: false
    };
    for (const m in resources) {
      if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
        silent: true
      });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  addResourceBundle(lng, ns, resources, deep, overwrite) {
    let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
      silent: false
    };
    let path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    let pack = getPath(this.data, path) || {};
    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = {
        ...pack,
        ...resources
      };
    }
    setPath(this.data, path, pack);
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);
    this.emit('removed', lng, ns);
  }
  hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  }
  getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;
    if (this.options.compatibilityAPI === 'v1') return {
      ...{},
      ...this.getResource(lng, ns)
    };
    return this.getResource(lng, ns);
  }
  getDataByLanguage(lng) {
    return this.data[lng];
  }
  hasLanguageSomeTranslations(lng) {
    const data = this.getDataByLanguage(lng);
    const n = data && Object.keys(data) || [];
    return !!n.find(v => data[v] && Object.keys(data[v]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}

var postProcessor = {
  processors: {},
  addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle(processors, value, key, options, translator) {
    processors.forEach(processor => {
      if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

const checkedLoadedFor = {};
class Translator extends EventEmitter {
  constructor(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, this);
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    this.logger = baseLogger.create('translator');
  }
  changeLanguage(lng) {
    if (lng) this.language = lng;
  }
  exists(key) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      interpolation: {}
    };
    if (key === undefined || key === null) {
      return false;
    }
    const resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  }
  extractFromKey(key, options) {
    let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let namespaces = options.ns || this.options.defaultNS || [];
    const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
    const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
    if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
      const m = key.match(this.interpolator.nestingRegexp);
      if (m && m.length > 0) {
        return {
          key,
          namespaces
        };
      }
      const parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];
    return {
      key,
      namespaces
    };
  }
  translate(keys, options, lastKey) {
    if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) {
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (typeof options === 'object') options = {
      ...options
    };
    if (!options) options = {};
    if (keys === undefined || keys === null) return '';
    if (!Array.isArray(keys)) keys = [String(keys)];
    const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const {
      key,
      namespaces
    } = this.extractFromKey(keys[keys.length - 1], options);
    const namespace = namespaces[namespaces.length - 1];
    const lng = options.lng || this.language;
    const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        const nsSeparator = options.nsSeparator || this.options.nsSeparator;
        if (returnDetails) {
          return {
            res: `${namespace}${nsSeparator}${key}`,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace
          };
        }
        return `${namespace}${nsSeparator}${key}`;
      }
      if (returnDetails) {
        return {
          res: key,
          usedKey: key,
          exactUsedKey: key,
          usedLng: lng,
          usedNS: namespace
        };
      }
      return key;
    }
    const resolved = this.resolve(keys, options);
    let res = resolved && resolved.res;
    const resUsedKey = resolved && resolved.usedKey || key;
    const resExactUsedKey = resolved && resolved.exactUsedKey || key;
    const resType = Object.prototype.toString.apply(res);
    const noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
    const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
    const handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        if (!this.options.returnedObjectHandler) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        }
        const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
          ...options,
          ns: namespaces
        }) : `key '${key} (${this.language})' returned an object instead of string.`;
        if (returnDetails) {
          resolved.res = r;
          return resolved;
        }
        return r;
      }
      if (keySeparator) {
        const resTypeIsArray = resType === '[object Array]';
        const copy = resTypeIsArray ? [] : {};
        const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
        for (const m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            const deepKey = `${newKeyToUse}${keySeparator}${m}`;
            copy[m] = this.translate(deepKey, {
              ...options,
              ...{
                joinArrays: false,
                ns: namespaces
              }
            });
            if (copy[m] === deepKey) copy[m] = res[m];
          }
        }
        res = copy;
      }
    } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options, lastKey);
    } else {
      let usedDefault = false;
      let usedKey = false;
      const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      const hasDefaultValue = Translator.hasDefaultValue(options);
      const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
      const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
        ordinal: false
      }) : '';
      const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
      if (!this.isValidLookup(res) && hasDefaultValue) {
        usedDefault = true;
        res = defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }
      const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
      const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
      const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
        if (keySeparator) {
          const fk = this.resolve(key, {
            ...options,
            keySeparator: false
          });
          if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
        }
        let lngs = [];
        const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (let i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }
        const send = (l, k, specificDefaultValue) => {
          const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
          } else if (this.backendConnector && this.backendConnector.saveMissing) {
            this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
          }
          this.emit('missingKey', l, namespace, k, res);
        };
        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach(language => {
              this.pluralResolver.getSuffixes(language, options).forEach(suffix => {
                send([language], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
              });
            });
          } else {
            send(lngs, key, defaultValue);
          }
        }
      }
      res = this.extendTranslation(res, keys, options, resolved, lastKey);
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
      if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
        if (this.options.compatibilityAPI !== 'v1') {
          res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
        } else {
          res = this.options.parseMissingKeyHandler(res);
        }
      }
    }
    if (returnDetails) {
      resolved.res = res;
      return resolved;
    }
    return res;
  }
  extendTranslation(res, key, options, resolved, lastKey) {
    var _this = this;
    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, {
        ...this.options.interpolation.defaultVariables,
        ...options
      }, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
        resolved
      });
    } else if (!options.skipInterpolation) {
      if (options.interpolation) this.interpolator.init({
        ...options,
        ...{
          interpolation: {
            ...this.options.interpolation,
            ...options.interpolation
          }
        }
      });
      const skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let nestBef;
      if (skipOnVariables) {
        const nb = res.match(this.interpolator.nestingRegexp);
        nestBef = nb && nb.length;
      }
      let data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
      res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
      if (skipOnVariables) {
        const na = res.match(this.interpolator.nestingRegexp);
        const nestAft = na && na.length;
        if (nestBef < nestAft) options.nest = false;
      }
      if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
      if (options.nest !== false) res = this.interpolator.nest(res, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (lastKey && lastKey[0] === args[0] && !options.context) {
          _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
          return null;
        }
        return _this.translate(...args, key);
      }, options);
      if (options.interpolation) this.interpolator.reset();
    }
    const postProcess = options.postProcess || this.options.postProcess;
    const postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
        i18nResolved: resolved,
        ...options
      } : options, this);
    }
    return res;
  }
  resolve(keys) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let found;
    let usedKey;
    let exactUsedKey;
    let usedLng;
    let usedNS;
    if (typeof keys === 'string') keys = [keys];
    keys.forEach(k => {
      if (this.isValidLookup(found)) return;
      const extracted = this.extractFromKey(k, options);
      const key = extracted.key;
      usedKey = key;
      let namespaces = extracted.namespaces;
      if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
      const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
      const needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
      const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
      namespaces.forEach(ns => {
        if (this.isValidLookup(found)) return;
        usedNS = ns;
        if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
          checkedLoadedFor[`${codes[0]}-${ns}`] = true;
          this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        }
        codes.forEach(code => {
          if (this.isValidLookup(found)) return;
          usedLng = code;
          const finalKeys = [key];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys) {
            this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            let pluralSuffix;
            if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
            const zeroSuffix = `${this.options.pluralSeparator}zero`;
            const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (needsPluralHandling) {
              finalKeys.push(key + pluralSuffix);
              if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
              }
              if (needsZeroSuffixLookup) {
                finalKeys.push(key + zeroSuffix);
              }
            }
            if (needsContextHandling) {
              const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
              finalKeys.push(contextKey);
              if (needsPluralHandling) {
                finalKeys.push(contextKey + pluralSuffix);
                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                  finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                }
                if (needsZeroSuffixLookup) {
                  finalKeys.push(contextKey + zeroSuffix);
                }
              }
            }
          }
          let possibleKey;
          while (possibleKey = finalKeys.pop()) {
            if (!this.isValidLookup(found)) {
              exactUsedKey = possibleKey;
              found = this.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });
    return {
      res: found,
      usedKey,
      exactUsedKey,
      usedLng,
      usedNS
    };
  }
  isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  }
  getResource(code, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  }
  static hasDefaultValue(options) {
    const prefix = 'defaultValue';
    for (const option in options) {
      if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
        return true;
      }
    }
    return false;
  }
}

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
class LanguageUtil {
  constructor(options) {
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  getScriptPartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return null;
    const p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    if (p[p.length - 1].toLowerCase() === 'x') return null;
    return this.formatLanguageCode(p.join('-'));
  }
  getLanguagePartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return code;
    const p = code.split('-');
    return this.formatLanguageCode(p[0]);
  }
  formatLanguageCode(code) {
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      const specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      let p = code.split('-');
      if (this.options.lowerCaseLng) {
        p = p.map(part => part.toLowerCase());
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }
      return p.join('-');
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  }
  isSupportedCode(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
  }
  getBestMatchFromCodes(codes) {
    if (!codes) return null;
    let found;
    codes.forEach(code => {
      if (found) return;
      const cleanedLng = this.formatLanguageCode(code);
      if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
    });
    if (!found && this.options.supportedLngs) {
      codes.forEach(code => {
        if (found) return;
        const lngOnly = this.getLanguagePartFromCode(code);
        if (this.isSupportedCode(lngOnly)) return found = lngOnly;
        found = this.options.supportedLngs.find(supportedLng => {
          if (supportedLng === lngOnly) return supportedLng;
          if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
          if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
        });
      });
    }
    if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
    return found;
  }
  getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
    if (!code) return fallbacks.default || [];
    let found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
    if (!found) found = fallbacks.default;
    return found || [];
  }
  toResolveHierarchy(code, fallbackCode) {
    const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
    const codes = [];
    const addCode = c => {
      if (!c) return;
      if (this.isSupportedCode(c)) {
        codes.push(c);
      } else {
        this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
      }
    };
    if (typeof code === 'string' && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }
    fallbackCodes.forEach(fc => {
      if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
    });
    return codes;
  }
}

let sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
let _rulesPluralsTypes = {
  1: function (n) {
    return Number(n > 1);
  },
  2: function (n) {
    return Number(n != 1);
  },
  3: function (n) {
    return 0;
  },
  4: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function (n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function (n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function (n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function (n) {
    return Number(n >= 2);
  },
  10: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function (n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function (n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function (n) {
    return Number(n !== 0);
  },
  14: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function (n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function (n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function (n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function (n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function (n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
const nonIntlVersions = ['v1', 'v2', 'v3'];
const intlVersions = ['v4'];
const suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  const rules = {};
  sets.forEach(set => {
    set.lngs.forEach(l => {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}
class PluralResolver {
  constructor(languageUtils) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    if ((!this.options.compatibilityJSON || intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }
    this.rules = createRules();
  }
  addRule(lng, obj) {
    this.rules[lng] = obj;
  }
  getRule(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      try {
        return new Intl.PluralRules(getCleanedCode(code), {
          type: options.ordinal ? 'ordinal' : 'cardinal'
        });
      } catch {
        return;
      }
    }
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  }
  needsPlural(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const rule = this.getRule(code, options);
    if (this.shouldUseIntlApi()) {
      return rule && rule.resolvedOptions().pluralCategories.length > 1;
    }
    return rule && rule.numbers.length > 1;
  }
  getPluralFormsOfKey(code, key) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return this.getSuffixes(code, options).map(suffix => `${key}${suffix}`);
  }
  getSuffixes(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const rule = this.getRule(code, options);
    if (!rule) {
      return [];
    }
    if (this.shouldUseIntlApi()) {
      return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2) => suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map(pluralCategory => `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    return rule.numbers.map(number => this.getSuffix(code, number, options));
  }
  getSuffix(code, count) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const rule = this.getRule(code, options);
    if (rule) {
      if (this.shouldUseIntlApi()) {
        return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
      }
      return this.getSuffixRetroCompatible(rule, count);
    }
    this.logger.warn(`no plural rule found for: ${code}`);
    return '';
  }
  getSuffixRetroCompatible(rule, count) {
    const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
    let suffix = rule.numbers[idx];
    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      if (suffix === 2) {
        suffix = 'plural';
      } else if (suffix === 1) {
        suffix = '';
      }
    }
    const returnSuffix = () => this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
    if (this.options.compatibilityJSON === 'v1') {
      if (suffix === 1) return '';
      if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
      return returnSuffix();
    } else if (this.options.compatibilityJSON === 'v2') {
      return returnSuffix();
    } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      return returnSuffix();
    }
    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
  }
  shouldUseIntlApi() {
    return !nonIntlVersions.includes(this.options.compatibilityJSON);
  }
}

function deepFindWithDefaults(data, defaultData, key) {
  let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  let path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && typeof key === 'string') {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
}
class Interpolator {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || (value => value);
    this.init(options);
  }
  init() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!options.interpolation) options.interpolation = {
      escapeValue: true
    };
    const iOpts = options.interpolation;
    this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
    this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
    this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
    this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
    this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
    this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
    this.resetRegExp();
  }
  reset() {
    if (this.options) this.init(this.options);
  }
  resetRegExp() {
    const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
    this.regexp = new RegExp(regexpStr, 'g');
    const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
    const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  }
  interpolate(str, data, lng, options) {
    let match;
    let value;
    let replaces;
    const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }
    const handleFormat = key => {
      if (key.indexOf(this.formatSeparator) < 0) {
        const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(path, undefined, lng, {
          ...options,
          ...data,
          interpolationkey: key
        }) : path;
      }
      const p = key.split(this.formatSeparator);
      const k = p.shift().trim();
      const f = p.join(this.formatSeparator).trim();
      return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
        ...options,
        ...data,
        interpolationkey: k
      });
    };
    this.resetRegExp();
    const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
    const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    const todos = [{
      regex: this.regexpUnescape,
      safeValue: val => regexSafe(val)
    }, {
      regex: this.regexp,
      safeValue: val => this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
    }];
    todos.forEach(todo => {
      replaces = 0;
      while (match = todo.regex.exec(str)) {
        const matchedVar = match[1].trim();
        value = handleFormat(matchedVar);
        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            const temp = missingInterpolationHandler(str, match, options);
            value = typeof temp === 'string' ? temp : '';
          } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
            value = '';
          } else if (skipOnVariables) {
            value = match[0];
            continue;
          } else {
            this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = makeString(value);
        }
        const safeValue = todo.safeValue(value);
        str = str.replace(match[0], safeValue);
        if (skipOnVariables) {
          todo.regex.lastIndex += value.length;
          todo.regex.lastIndex -= match[0].length;
        } else {
          todo.regex.lastIndex = 0;
        }
        replaces++;
        if (replaces >= this.maxReplaces) {
          break;
        }
      }
    });
    return str;
  }
  nest(str, fc) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let match;
    let value;
    let clonedOptions;
    function handleHasOptions(key, inheritedOptions) {
      const sep = this.nestingOptionsSeparator;
      if (key.indexOf(sep) < 0) return key;
      const c = key.split(new RegExp(`${sep}[ ]*{`));
      let optionsString = `{${c[1]}`;
      key = c[0];
      optionsString = this.interpolate(optionsString, clonedOptions);
      const matchedSingleQuotes = optionsString.match(/'/g);
      const matchedDoubleQuotes = optionsString.match(/"/g);
      if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
        optionsString = optionsString.replace(/'/g, '"');
      }
      try {
        clonedOptions = JSON.parse(optionsString);
        if (inheritedOptions) clonedOptions = {
          ...inheritedOptions,
          ...clonedOptions
        };
      } catch (e) {
        this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
        return `${key}${sep}${optionsString}`;
      }
      delete clonedOptions.defaultValue;
      return key;
    }
    while (match = this.nestingRegexp.exec(str)) {
      let formatters = [];
      clonedOptions = {
        ...options
      };
      clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      let doReduce = false;
      if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
        const r = match[1].split(this.formatSeparator).map(elem => elem.trim());
        match[1] = r.shift();
        formatters = r;
        doReduce = true;
      }
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
      if (value && match[0] === str && typeof value !== 'string') return value;
      if (typeof value !== 'string') value = makeString(value);
      if (!value) {
        this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
        value = '';
      }
      if (doReduce) {
        value = formatters.reduce((v, f) => this.format(v, f, options.lng, {
          ...options,
          interpolationkey: match[1].trim()
        }), value.trim());
      }
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  }
}

function parseFormatStr(formatStr) {
  let formatName = formatStr.toLowerCase().trim();
  const formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    const p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    const optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      const opts = optStr.split(';');
      opts.forEach(opt => {
        if (!opt) return;
        const [key, ...rest] = opt.split(':');
        const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName,
    formatOptions
  };
}
function createCachedFormatter(fn) {
  const cache = {};
  return function invokeFormatter(val, lng, options) {
    const key = lng + JSON.stringify(options);
    let formatter = cache[key];
    if (!formatter) {
      formatter = fn(getCleanedCode(lng), options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
}
class Formatter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      currency: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt,
          style: 'currency'
        });
        return val => formatter.format(val);
      }),
      datetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.DateTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      relativetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.RelativeTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val, opt.range || 'day');
      }),
      list: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.ListFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      })
    };
    this.init(options);
  }
  init(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      interpolation: {}
    };
    const iOpts = options.interpolation;
    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
  }
  add(name, fc) {
    this.formats[name.toLowerCase().trim()] = fc;
  }
  addCached(name, fc) {
    this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
  }
  format(value, format, lng) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const formats = format.split(this.formatSeparator);
    const result = formats.reduce((mem, f) => {
      const {
        formatName,
        formatOptions
      } = parseFormatStr(f);
      if (this.formats[formatName]) {
        let formatted = mem;
        try {
          const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
          const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
          formatted = this.formats[formatName](mem, l, {
            ...formatOptions,
            ...options,
            ...valOptions
          });
        } catch (error) {
          this.logger.warn(error);
        }
        return formatted;
      } else {
        this.logger.warn(`there was no format function for ${formatName}`);
      }
      return mem;
    }, value);
    return result;
  }
}

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}
class Connector extends EventEmitter {
  constructor(backend, store, services) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    super();
    this.backend = backend;
    this.store = store;
    this.services = services;
    this.languageUtils = services.languageUtils;
    this.options = options;
    this.logger = baseLogger.create('backendConnector');
    this.waitingReads = [];
    this.maxParallelReads = options.maxParallelReads || 10;
    this.readingCalls = 0;
    this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    this.state = {};
    this.queue = [];
    if (this.backend && this.backend.init) {
      this.backend.init(services, options.backend, options);
    }
  }
  queueLoad(languages, namespaces, options, callback) {
    const toLoad = {};
    const pending = {};
    const toLoadLanguages = {};
    const toLoadNamespaces = {};
    languages.forEach(lng => {
      let hasAllNamespaces = true;
      namespaces.forEach(ns => {
        const name = `${lng}|${ns}`;
        if (!options.reload && this.store.hasResourceBundle(lng, ns)) {
          this.state[name] = 2;
        } else if (this.state[name] < 0) ; else if (this.state[name] === 1) {
          if (pending[name] === undefined) pending[name] = true;
        } else {
          this.state[name] = 1;
          hasAllNamespaces = false;
          if (pending[name] === undefined) pending[name] = true;
          if (toLoad[name] === undefined) toLoad[name] = true;
          if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
        }
      });
      if (!hasAllNamespaces) toLoadLanguages[lng] = true;
    });
    if (Object.keys(toLoad).length || Object.keys(pending).length) {
      this.queue.push({
        pending,
        pendingCount: Object.keys(pending).length,
        loaded: {},
        errors: [],
        callback
      });
    }
    return {
      toLoad: Object.keys(toLoad),
      pending: Object.keys(pending),
      toLoadLanguages: Object.keys(toLoadLanguages),
      toLoadNamespaces: Object.keys(toLoadNamespaces)
    };
  }
  loaded(name, err, data) {
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    if (err) this.emit('failedLoading', lng, ns, err);
    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }
    this.state[name] = err ? -1 : 2;
    const loaded = {};
    this.queue.forEach(q => {
      pushPath(q.loaded, [lng], ns);
      removePending(q, name);
      if (err) q.errors.push(err);
      if (q.pendingCount === 0 && !q.done) {
        Object.keys(q.loaded).forEach(l => {
          if (!loaded[l]) loaded[l] = {};
          const loadedKeys = q.loaded[l];
          if (loadedKeys.length) {
            loadedKeys.forEach(n => {
              if (loaded[l][n] === undefined) loaded[l][n] = true;
            });
          }
        });
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });
    this.emit('loaded', loaded);
    this.queue = this.queue.filter(q => !q.done);
  }
  read(lng, ns, fcName) {
    let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
    let callback = arguments.length > 5 ? arguments[5] : undefined;
    if (!lng.length) return callback(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng,
        ns,
        fcName,
        tried,
        wait,
        callback
      });
      return;
    }
    this.readingCalls++;
    const resolver = (err, data) => {
      this.readingCalls--;
      if (this.waitingReads.length > 0) {
        const next = this.waitingReads.shift();
        this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
      }
      if (err && data && tried < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    };
    const fc = this.backend[fcName].bind(this.backend);
    if (fc.length === 2) {
      try {
        const r = fc(lng, ns);
        if (r && typeof r.then === 'function') {
          r.then(data => resolver(null, data)).catch(resolver);
        } else {
          resolver(null, r);
        }
      } catch (err) {
        resolver(err);
      }
      return;
    }
    return fc(lng, ns, resolver);
  }
  prepareLoading(languages, namespaces) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let callback = arguments.length > 3 ? arguments[3] : undefined;
    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];
    const toLoad = this.queueLoad(languages, namespaces, options, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback();
      return null;
    }
    toLoad.toLoad.forEach(name => {
      this.loadOne(name);
    });
  }
  load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  }
  reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {
      reload: true
    }, callback);
  }
  loadOne(name) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    this.read(lng, ns, 'read', undefined, undefined, (err, data) => {
      if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
      if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
      this.loaded(name, err, data);
    });
  }
  saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : () => {};
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
      this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
      return;
    }
    if (key === undefined || key === null || key === '') return;
    if (this.backend && this.backend.create) {
      const opts = {
        ...options,
        isUpdate
      };
      const fc = this.backend.create.bind(this.backend);
      if (fc.length < 6) {
        try {
          let r;
          if (fc.length === 5) {
            r = fc(languages, namespace, key, fallbackValue, opts);
          } else {
            r = fc(languages, namespace, key, fallbackValue);
          }
          if (r && typeof r.then === 'function') {
            r.then(data => clb(null, data)).catch(clb);
          } else {
            clb(null, r);
          }
        } catch (err) {
          clb(err);
        }
      } else {
        fc(languages, namespace, key, fallbackValue, clb, opts);
      }
    }
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  }
}

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: false,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      let ret = {};
      if (typeof args[1] === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];
      if (typeof args[2] === 'object' || typeof args[3] === 'object') {
        const options = args[3] || args[2];
        Object.keys(options).forEach(key => {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: (value, format, lng, options) => value,
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  return options;
}

function noop() {}
function bindMemberFunctions(inst) {
  const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(mem => {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
class I18n extends EventEmitter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    super();
    this.options = transformOptions(options);
    this.services = {};
    this.logger = baseLogger;
    this.modules = {
      external: []
    };
    bindMemberFunctions(this);
    if (callback && !this.isInitialized && !options.isClone) {
      if (!this.options.initImmediate) {
        this.init(options, callback);
        return this;
      }
      setTimeout(() => {
        this.init(options, callback);
      }, 0);
    }
  }
  init() {
    var _this = this;
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options.defaultNS && options.defaultNS !== false && options.ns) {
      if (typeof options.ns === 'string') {
        options.defaultNS = options.ns;
      } else if (options.ns.indexOf('translation') < 0) {
        options.defaultNS = options.ns[0];
      }
    }
    const defOpts = get();
    this.options = {
      ...defOpts,
      ...this.options,
      ...transformOptions(options)
    };
    if (this.options.compatibilityAPI !== 'v1') {
      this.options.interpolation = {
        ...defOpts.interpolation,
        ...this.options.interpolation
      };
    }
    if (options.keySeparator !== undefined) {
      this.options.userDefinedKeySeparator = options.keySeparator;
    }
    if (options.nsSeparator !== undefined) {
      this.options.userDefinedNsSeparator = options.nsSeparator;
    }
    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }
    if (!this.options.isClone) {
      if (this.modules.logger) {
        baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        baseLogger.init(null, this.options);
      }
      let formatter;
      if (this.modules.formatter) {
        formatter = this.modules.formatter;
      } else if (typeof Intl !== 'undefined') {
        formatter = Formatter;
      }
      const lu = new LanguageUtil(this.options);
      this.store = new ResourceStore(this.options.resources, this.options);
      const s = this.services;
      s.logger = baseLogger;
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new PluralResolver(lu, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      });
      if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
        s.formatter = createClassOnDemand(formatter);
        s.formatter.init(s, this.options);
        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
      }
      s.interpolator = new Interpolator(this.options);
      s.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      };
      s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        _this.emit(event, ...args);
      });
      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
      }
      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }
      this.translator = new Translator(this.services, this.options);
      this.translator.on('*', function (event) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        _this.emit(event, ...args);
      });
      this.modules.external.forEach(m => {
        if (m.init) m.init(this);
      });
    }
    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;
    if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
    }
    if (!this.services.languageDetector && !this.options.lng) {
      this.logger.warn('init: no languageDetector is used and no lng is defined');
    }
    const storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
    storeApi.forEach(fcName => {
      this[fcName] = function () {
        return _this.store[fcName](...arguments);
      };
    });
    const storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
    storeApiChained.forEach(fcName => {
      this[fcName] = function () {
        _this.store[fcName](...arguments);
        return _this;
      };
    });
    const deferred = defer();
    const load = () => {
      const finish = (err, t) => {
        if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
        this.isInitialized = true;
        if (!this.options.isClone) this.logger.log('initialized', this.options);
        this.emit('initialized', this.options);
        deferred.resolve(t);
        callback(err, t);
      };
      if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, finish);
    };
    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }
    return deferred;
  }
  loadResources(language) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    let usedCallback = callback;
    const usedLng = typeof language === 'string' ? language : this.language;
    if (typeof language === 'function') usedCallback = language;
    if (!this.options.resources || this.options.partialBundledLanguages) {
      if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
      const toLoad = [];
      const append = lng => {
        if (!lng) return;
        const lngs = this.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(l => {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      if (!usedLng) {
        const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(l => append(l));
      } else {
        append(usedLng);
      }
      if (this.options.preload) {
        this.options.preload.forEach(l => append(l));
      }
      this.services.backendConnector.load(toLoad, this.options.ns, e => {
        if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
        usedCallback(e);
      });
    } else {
      usedCallback(null);
    }
  }
  reloadResources(lngs, ns, callback) {
    const deferred = defer();
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = noop;
    this.services.backendConnector.reload(lngs, ns, err => {
      deferred.resolve();
      callback(err);
    });
    return deferred;
  }
  use(module) {
    if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
    if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
    if (module.type === 'backend') {
      this.modules.backend = module;
    }
    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }
    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }
    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }
    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    }
    if (module.type === 'formatter') {
      this.modules.formatter = module;
    }
    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }
    return this;
  }
  setResolvedLanguage(l) {
    if (!l || !this.languages) return;
    if (['cimode', 'dev'].indexOf(l) > -1) return;
    for (let li = 0; li < this.languages.length; li++) {
      const lngInLngs = this.languages[li];
      if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
      if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
        this.resolvedLanguage = lngInLngs;
        break;
      }
    }
  }
  changeLanguage(lng, callback) {
    var _this2 = this;
    this.isLanguageChangingTo = lng;
    const deferred = defer();
    this.emit('languageChanging', lng);
    const setLngProps = l => {
      this.language = l;
      this.languages = this.services.languageUtils.toResolveHierarchy(l);
      this.resolvedLanguage = undefined;
      this.setResolvedLanguage(l);
    };
    const done = (err, l) => {
      if (l) {
        setLngProps(l);
        this.translator.changeLanguage(l);
        this.isLanguageChangingTo = undefined;
        this.emit('languageChanged', l);
        this.logger.log('languageChanged', l);
      } else {
        this.isLanguageChangingTo = undefined;
      }
      deferred.resolve(function () {
        return _this2.t(...arguments);
      });
      if (callback) callback(err, function () {
        return _this2.t(...arguments);
      });
    };
    const setLng = lngs => {
      if (!lng && !lngs && this.services.languageDetector) lngs = [];
      const l = typeof lngs === 'string' ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
      if (l) {
        if (!this.language) {
          setLngProps(l);
        }
        if (!this.translator.language) this.translator.changeLanguage(l);
        if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
      }
      this.loadResources(l, err => {
        done(err, l);
      });
    };
    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      if (this.services.languageDetector.detect.length === 0) {
        this.services.languageDetector.detect().then(setLng);
      } else {
        this.services.languageDetector.detect(setLng);
      }
    } else {
      setLng(lng);
    }
    return deferred;
  }
  getFixedT(lng, ns, keyPrefix) {
    var _this3 = this;
    const fixedT = function (key, opts) {
      let options;
      if (typeof opts !== 'object') {
        for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          rest[_key3 - 2] = arguments[_key3];
        }
        options = _this3.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      } else {
        options = {
          ...opts
        };
      }
      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
      const keySeparator = _this3.options.keySeparator || '.';
      let resultKey;
      if (options.keyPrefix && Array.isArray(key)) {
        resultKey = key.map(k => `${options.keyPrefix}${keySeparator}${k}`);
      } else {
        resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
      }
      return _this3.t(resultKey, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    fixedT.keyPrefix = keyPrefix;
    return fixedT;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  }
  hasLoadedNamespace(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.isInitialized) {
      this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
      return false;
    }
    if (!this.languages || !this.languages.length) {
      this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
      return false;
    }
    const lng = options.lng || this.resolvedLanguage || this.languages[0];
    const fallbackLng = this.options ? this.options.fallbackLng : false;
    const lastLng = this.languages[this.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n) => {
      const loadState = this.services.backendConnector.state[`${l}|${n}`];
      return loadState === -1 || loadState === 2;
    };
    if (options.precheck) {
      const preResult = options.precheck(this, loadNotPending);
      if (preResult !== undefined) return preResult;
    }
    if (this.hasResourceBundle(lng, ns)) return true;
    if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
  }
  loadNamespaces(ns, callback) {
    const deferred = defer();
    if (!this.options.ns) {
      if (callback) callback();
      return Promise.resolve();
    }
    if (typeof ns === 'string') ns = [ns];
    ns.forEach(n => {
      if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
    });
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  loadLanguages(lngs, callback) {
    const deferred = defer();
    if (typeof lngs === 'string') lngs = [lngs];
    const preloaded = this.options.preload || [];
    const newLngs = lngs.filter(lng => preloaded.indexOf(lng) < 0);
    if (!newLngs.length) {
      if (callback) callback();
      return Promise.resolve();
    }
    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  dir(lng) {
    if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
    if (!lng) return 'rtl';
    const rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
    const languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
    return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
  }
  static createInstance() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
  }
  cloneInstance() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    const forkResourceStore = options.forkResourceStore;
    if (forkResourceStore) delete options.forkResourceStore;
    const mergedOptions = {
      ...this.options,
      ...options,
      ...{
        isClone: true
      }
    };
    const clone = new I18n(mergedOptions);
    if (options.debug !== undefined || options.prefix !== undefined) {
      clone.logger = clone.logger.clone(options);
    }
    const membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(m => {
      clone[m] = this[m];
    });
    clone.services = {
      ...this.services
    };
    clone.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    if (forkResourceStore) {
      clone.store = new ResourceStore(this.store.data, mergedOptions);
      clone.services.resourceStore = clone.store;
    }
    clone.translator = new Translator(clone.services, mergedOptions);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      clone.emit(event, ...args);
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = mergedOptions;
    clone.translator.backendConnector.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    return clone;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const i18next_instance = I18n.createInstance();
i18next_instance.createInstance = I18n.createInstance;

const createInstance = i18next_instance.createInstance;
const dir = i18next_instance.dir;
const init = i18next_instance.init;
const loadResources = i18next_instance.loadResources;
const reloadResources = i18next_instance.reloadResources;
const use = i18next_instance.use;
const changeLanguage = i18next_instance.changeLanguage;
const getFixedT = i18next_instance.getFixedT;
const t = i18next_instance.t;
const exists = i18next_instance.exists;
const setDefaultNamespace = i18next_instance.setDefaultNamespace;
const hasLoadedNamespace = i18next_instance.hasLoadedNamespace;
const loadNamespaces = i18next_instance.loadNamespaces;
const loadLanguages = i18next_instance.loadLanguages;



;// CONCATENATED MODULE: ../../node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  if (config.ns === undefined) config.ns = [];
  var instance = i18next_instance.createInstance(config);
  var initPromise;
  if (!instance.isInitialized) {
    var _config$use;
    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });
    if (typeof config.onPreInitI18next === 'function') {
      config.onPreInitI18next(instance);
    }
    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next_instance.t);
  }
  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ../../node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;
function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? appWithTranslation_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;
    var _ref = props.pageProps || {},
      _nextI18Next = _ref._nextI18Next; // pageProps may be undefined on strange setups, i.e. https://github.com/i18next/next-i18next/issues/2109
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 ? void 0 : (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale;
    var ns = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.ns;

    // Memoize the instance and only re-initialize when either:
    // 1. The route changes (non-shallowly)
    // 2. Router locale changes
    // 3. UserConfig override changes
    var i18n = (0,react.useMemo)(function () {
      var _userConfig$i18n;
      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;
      if (!userConfig) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }
      if (!(userConfig !== null && userConfig !== void 0 && userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }
      if (!(userConfig !== null && userConfig !== void 0 && (_userConfig$i18n = userConfig.i18n) !== null && _userConfig$i18n !== void 0 && _userConfig$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }
      var _ref2 = _nextI18Next || {},
        initialI18nStore = _ref2.initialI18nStore;
      var resources = configOverride !== null && configOverride !== void 0 && configOverride.resources ? configOverride.resources : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: locale
      }))), {}, {
        lng: locale,
        ns: ns,
        resources: resources
      })).i18n;
      globalI18n = instance;
      return instance;
    }, [_nextI18Next, locale, configOverride, ns]);
    return i18n !== null ? __jsx(es.I18nextProvider, {
      i18n: i18n
    }, __jsx(WrappedComponent, props)) : __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props));
  };
  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ../../node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 70314:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(96112)


/***/ }),

/***/ 86570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(68100);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ ErrorBoundary; },
  "C": function() { return /* reexport */ ErrorServer; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./utils/log.ts
var log = __webpack_require__(58647);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./utils/app-pages.ts
var app_pages = __webpack_require__(90729);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./components/shared/ErrorBoundary/ErrorFallback.tsx





// Component.
// -----------------------------------------------------------------------------
var ErrorFallback = function(param) {
    var onRetry = param.onRetry;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("errorPage").t;
    var router = (0,next_router.useRouter)();
    // Handlers.
    // ---------------------------------------------------------------------------
    var handleOnClick = (0,react.useCallback)(function() {
        onRetry();
        router.push((0,app_pages/* getPagePath */.mn)(app_pages/* APP_PAGES.home */.EJ.home, router.locale));
    }, [
        onRetry,
        router
    ]);
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: t("errorFallback.heading")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "There was an error"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: handleOnClick,
                children: "Retry"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/shared/ErrorBoundary/ErrorBoundary.tsx







// IMPORTANT:
// Error boundaries work like a JavaScript catch {} block, but for components.
// Only class components can be error boundaries.
// Class.
// -----------------------------------------------------------------------------
var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ErrorBoundary, Component);
    var _super = _createSuper(ErrorBoundary);
    function ErrorBoundary() {
        _classCallCheck(this, ErrorBoundary);
        var _this;
        _this = _super.apply(this, arguments);
        // State.
        // ---------------------------------------------------------------------------
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        (0,log/* logError */.H)({
            context: "ErrorBoundary",
            message: "Error captured by ErrorBoundary. Error: ".concat(error, ". Error info: ").concat(errorInfo),
            error: error
        });
    };
    // Handler.
    // ---------------------------------------------------------------------------
    _proto.handleOnRetry = function handleOnRetry() {
        this.setState({
            hasError: false
        });
    };
    // Render.
    // ---------------------------------------------------------------------------
    _proto.render = function render() {
        if (this.state.hasError) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorFallback, {
                onRetry: this.handleOnRetry
            });
        }
        return this.props.children;
    };
    // Life-cycle
    // ---------------------------------------------------------------------------
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    return ErrorBoundary;
}(react.Component);

// EXTERNAL MODULE: ../ui-library/dist/index.js + 234 modules
var dist = __webpack_require__(68107);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(2374);
;// CONCATENATED MODULE: ./components/layout/ErrorPage/ErrorPage.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  padding: 2rem 0 2rem 0;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-right: 2px solid #dedce4;\n  padding-right: 1rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  text-align: left;\n\n  max-width: 800px;\n  margin: 2rem auto;\n  padding: 0 1.5rem;\n  flex: 1 1 auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5deb47e1-0"
})(_templateObject());
var Logo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-5deb47e1-1"
})(_templateObject1());
var LogoTE = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-5deb47e1-2"
})(_templateObject2());
var Content = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-5deb47e1-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./components/layout/ErrorPage/ErrorPage.tsx




var ErrorPage = function(param) {
    var children = param.children;
    var t = (0,useI18n/* useI18n */.Q)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                gap: "xl",
                direction: "row",
                alignment: "center",
                contentAlign: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                        src: "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg",
                        width: "150px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoTE, {
                        src: "https://talent-engine-media.s3.eu-west-1.amazonaws.com/assets/logo_talent_engine_color.svg",
                        alt: t("common.page-title"),
                        width: "175px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/layout/ErrorPage/index.ts


// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var client_router = __webpack_require__(93642);
// EXTERNAL MODULE: ./components/shared/HtmlTrans/index.ts + 1 modules
var HtmlTrans = __webpack_require__(75822);
;// CONCATENATED MODULE: ./components/shared/ErrorBoundary/ErrorServer.tsx








// Component.
// -----------------------------------------------------------------------------
var ErrorServer = function(param) {
    var message = param.message;
    // Hooks.
    // ---------------------------------------------------------------------------
    var router = (0,client_router.useRouter)();
    var t = (0,useI18n/* useI18n */.Q)("common").t;
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
            alignment: "center",
            direction: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Card */.Zb, {
                    hideImage: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                            as: "h2",
                            size: "3xl",
                            children: t("common.page_500.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* HtmlTrans */.q, {
                            i18nKey: "common.page_500.desc",
                            ns: "common",
                            components: {
                                supportLink: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:soporte@getmanfred.com",
                                    target: "_blank"
                                }),
                                talentEngineLink: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.getmanfred.com/talent-engine",
                                    target: "_blank"
                                }),
                                salesTeamLink: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.getmanfred.com/talent-engine#talentEngineForm",
                                    target: "_blank"
                                })
                            },
                            values: {
                                error: message
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                    href: (0,app_pages/* getPagePath */.mn)(app_pages/* APP_PAGES.logout */.EJ.logout, router.locale),
                    label: "Accede de nuevo a la plataforma",
                    startIcon: pro_solid_svg_icons/* faUserAstronaut */.KCX,
                    schema: "neutral",
                    variant: "hard"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/shared/ErrorBoundary/index.ts




/***/ }),

/***/ 75822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* reexport */ HtmlTrans; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(37328);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(97438);
;// CONCATENATED MODULE: ./components/shared/HtmlTrans/HtmlTrans.tsx





var HtmlTrans = function(_param) {
    var components = _param.components, other = (0,_object_without_properties/* default */.Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        components: (0,_object_spread/* default */.Z)({
            ul: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {}),
            ol: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {}),
            li: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {}),
            p: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}),
            a: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {}),
            strong: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}),
            em: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {}),
            u: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {}),
            code: /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {}),
            span: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            blockquote: /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {})
        }, components)
    }));
};

;// CONCATENATED MODULE: ./components/shared/HtmlTrans/index.ts



/***/ }),

/***/ 39105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ useI18n; }
});

// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(97438);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./hooks/useI18n/useI18n.ts


var useI18n = function(ns) {
    var t = (0,esm/* useTranslation */.$G)(ns).t;
    var tFunction = (0,react.useRef)(function(key) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return "".concat(t(key, options)) || "";
    });
    return {
        t: tFunction.current
    };
};

;// CONCATENATED MODULE: ./hooks/useI18n/index.ts



/***/ }),

/***/ 65743:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(15153);
module.exports = {
    localePath: path.resolve("./public/locales"),
    reloadOnPrerender: "production" === "development",
    react: {
        useSuspense: false
    },
    i18n: {
        locales: [
            "es"
        ],
        defaultLocale: "es",
        localeDetection: false
    }
};


/***/ }),

/***/ 39595:
/***/ (function(module) {

"use strict";

module.exports = {
    asgardApiUrl: {
        name: "ASGARD_API_URL"
    },
    apiUrl: {
        name: "API_URL",
        defaultValue: "https://api.getmanfred.com"
    },
    appUrl: {
        name: "AUTH0_BASE_URL"
    },
    auth0Audience: {
        name: "AUTH0_AUDIENCE"
    },
    auth0Secret: {
        name: "AUTH0_SECRET",
        hide: true
    },
    auth0ClientSecret: {
        name: "AUTH0_CLIENT_SECRET",
        hide: true
    },
    auth0ClientId: {
        name: "AUTH0_CLIENT_ID"
    },
    auth0IssuerBaseUrl: {
        name: "AUTH0_ISSUER_BASE_URL"
    },
    segmentApiKey: {
        name: "NEXT_PUBLIC_SEGMENT_API_KEY"
    },
    segmentCustomProxyUrl: {
        name: "NEXT_PUBLIC_SEGMENT_CUSTOM_PROXY_URL"
    },
    segmentCustomCDN: {
        name: "NEXT_PUBLIC_SEGMENT_CUSTOM_CDN"
    },
    manfrediteProfileBaseUrl: {
        name: "NEXT_PUBLIC_MANFREDITE_PROFILE_URL"
    },
    flagsmithEnvironmentKey: {
        name: "FLAGSMITH_ENVIRONMENT_KEY"
    },
    offerExampleOffer: {
        name: "DEFAULT_OFFER_URL"
    }
};


/***/ }),

/***/ 58701:
/***/ (function(module) {

"use strict";

module.exports = {
    home: {
        page: "/index",
        langs: {
            es: "/"
        },
        params: ""
    },
    error_401: {
        page: "/401",
        langs: {
            es: "/401"
        },
        params: ""
    },
    error_404: {
        page: "/404",
        langs: {
            es: "/404"
        },
        params: ""
    },
    catalog: {
        page: "/catalog",
        langs: {
            es: "/catalogo"
        },
        params: ""
    },
    company: {
        page: "/company",
        langs: {
            es: "/empresa"
        },
        params: ""
    },
    createOffer: {
        page: "/offer",
        langs: {
            es: "/oferta"
        },
        params: ""
    },
    offer: {
        page: "/offer/:offerId",
        langs: {
            es: "/oferta/:offerId"
        },
        params: ""
    },
    candidates: {
        page: "/offer/:offerId/candidates",
        langs: {
            es: "/oferta/:offerId/candidatos"
        },
        params: ""
    },
    candidate: {
        page: "/offer/:offerId/candidates/:candidateId",
        langs: {
            es: "/oferta/:offerId/candidatos/:candidateId"
        },
        params: ""
    },
    notFound: {
        page: "/404",
        langs: {
            es: "/404"
        },
        params: ""
    },
    login: {
        page: "/api/auth/login",
        langs: {
            es: "/entra"
        },
        params: ""
    },
    logout: {
        page: "/api/auth/logout",
        langs: {
            es: "/logout"
        },
        params: ""
    }
};


/***/ }),

/***/ 68100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(37328);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 234 modules
var dist = __webpack_require__(68107);
// EXTERNAL MODULE: ../../node_modules/@auth0/nextjs-auth0/dist/client/index.js
var client = __webpack_require__(5778);
// EXTERNAL MODULE: ./components/shared/ErrorBoundary/index.ts + 15 modules
var ErrorBoundary = __webpack_require__(10026);
// EXTERNAL MODULE: ./utils/env-vars.ts + 1 modules
var env_vars = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/@segment/snippet/lib/index.js
var lib = __webpack_require__(70490);
;// CONCATENATED MODULE: ./utils/segment.ts


function renderSegmentSnippet() {
    var opts = {
        apiKey: env_vars/* ENV.segmentApiKey */.V.segmentApiKey || "",
        page: false,
        useHostForBundles: true,
        host: env_vars/* ENV.segmentCustomCDN */.V.segmentCustomCDN,
        load: !env_vars/* ENV.segmentCustomProxyUrl */.V.segmentCustomProxyUrl
    };
    if (false) {}
    return lib/* min */.V(opts);
}

// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/shared/SegmentScript/SegmentScript.tsx




var SegmentScript = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            env_vars/* ENV.segmentApiKey */.V.segmentApiKey && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "segment-script",
                dangerouslySetInnerHTML: {
                    __html: renderSegmentSnippet()
                }
            }),
            env_vars/* ENV.segmentApiKey */.V.segmentApiKey && env_vars/* ENV.segmentCustomProxyUrl */.V.segmentCustomProxyUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "segment-config-script",
                dangerouslySetInnerHTML: {
                    __html: 'analytics.load("'.concat(env_vars/* ENV.segmentApiKey */.V.segmentApiKey, '", { integrations: { "Segment.io": { apiHost: "').concat(env_vars/* ENV.segmentCustomProxyUrl */.V.segmentCustomProxyUrl, '/v1" }}})')
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/shared/SegmentScript/index.ts


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(2374);
;// CONCATENATED MODULE: ./components/styles/GlobalStyles/GlobalStyles.utils.ts
function getFont(fontName) {
    return "local(''),\n  url('".concat("/fonts/" + fontName + ".woff2", "') format('woff2'),\n  url('").concat("/fonts/" + fontName + ".woff", "') format('woff')");
}

;// CONCATENATED MODULE: ./components/styles/GlobalStyles/GlobalStyles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  \n@font-face {\n  font-family: 'Avenir';\n  font-style: normal;\n  font-weight: 400;\n  font-display: fallback;\n  src: ",
        "\n}\n\n@font-face {\n  font-family: 'Avenir';\n  font-style: normal;\n  font-weight: 500;\n  font-display: fallback;\n  src: ",
        "\n}\n\n@font-face {\n  font-family: 'Avenir';\n  font-style: normal;\n  font-weight: 800;\n  font-display: fallback;\n  src: ",
        "\n}\n\n@font-face {\n  font-family: 'Avenir';\n  font-style: normal;\n  font-weight: 900;\n  font-display: fallback;\n  src: ",
        "\n}\n\n  * {\n    box-sizing: border-box;\n  }\n\n  html {\n    scroll-behavior: smooth;\n  }\n\n  html,\n  body {\n    background: #faf9ff;\n    margin: 0;\n    padding: 0;\n    font-family: 'Avenir', sans-serif;\n    font-size: 16px;\n    -webkit-font-smoothing: antialiased;\n    -webkit-text-rendering: optimizeLegibility;\n    text-rendering: optimizeLegibility;\n  }\n\n  div[class^='_editorRoot_'] {\n    z-index: 11;\n  }\n\n  #ui-toast-portals {\n    z-index: 10;\n    position: relative;\n  }\n\n  .ui-library-portal-classname {\n    position: relative;\n    z-index: 9;\n  }\n\n  .slick-dots li button:before {\n    font-size: 12px !important;\n  }\n\n  hr {\n    height: 1px;\n    width: 100%;\n    border: 0;\n    background: #DEDCE4;\n  }\n\n  a {\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n\n    &:focus {\n      color: ",
        ";\n    }\n\n    &:active {\n      color: ",
        ';\n    };\n  }\n\n\n\n  #ui-toast-portals {\n    z-index: 10;\n    position: relative;\n  }\n\n  #ui-toast-content {\n    position: relative;\n    bottom: 2rem;\n    right: 2rem;\n    max-width: 30rem;\n  }\n\n  .markdown-editor form > div {\n    display: none !important;\n}\n\n  .markdown-editor form > div:first-child,\n  .markdown-editor form > div:nth-child(2),\n  .markdown-editor form > div:last-child,\n  .markdown-editor form[class*="_linkDialogEditForm"] > div {\n      display: flex !important;\n  }\n\n  .markdown-editor [contenteditable="true"] img {\n    max-width: 100%;\n  }\n\n  .markdown-editor [role="toolbar"] > span:first-child,\n  .markdown-editor [role="toolbar"] > select {\n    display: none;\n  }\n\n  .markdown-editor [class*="_diffSourceToggle_"] button {\n    display: none;\n  }\n\n  .markdown-editor [class*="_diffSourceToggle_"] button:nth-child(1),\n  .markdown-editor [class*="_diffSourceToggle_"] button:nth-child(3) {\n    display: block;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject(), function() {
    return getFont("Avenir-Roman");
}, function() {
    return getFont("Avenir-Medium");
}, function() {
    return getFont("Avenir-Heavy");
}, function() {
    return getFont("Avenir-Black");
}, function(param) {
    var theme = param.theme;
    return theme.palette.schema.brand2.light.ghost.default.foreground;
}, function(param) {
    var theme = param.theme;
    return theme.palette.schema.brand2.light.ghost.hover.foreground;
}, function(param) {
    var theme = param.theme;
    return theme.palette.schema.brand2.light.ghost.focus.foreground;
}, function(param) {
    var theme = param.theme;
    return theme.palette.schema.brand2.light.ghost.pressed.foreground;
});

;// CONCATENATED MODULE: ./components/styles/GlobalStyles/index.ts


// EXTERNAL MODULE: ../../node_modules/@fortawesome/fontawesome-svg-core/index.mjs
var fontawesome_svg_core = __webpack_require__(81674);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/fontawesome-svg-core/styles.css
var styles = __webpack_require__(69993);
;// CONCATENATED MODULE: ./theme/index.ts


var theme = (0,_object_spread/* default */.Z)({}, dist/* defaultTheme */.uH);
/* harmony default export */ var theme_0 = (theme);

// EXTERNAL MODULE: ./utils/icons/index.ts + 1 modules
var icons = __webpack_require__(33084);
// EXTERNAL MODULE: ../../node_modules/flagsmith/index.js
var flagsmith = __webpack_require__(3613);
var flagsmith_default = /*#__PURE__*/__webpack_require__.n(flagsmith);
// EXTERNAL MODULE: ../../node_modules/flagsmith/react.js
var react = __webpack_require__(98861);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(97438);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/reflect-metadata/Reflect.js
var Reflect = __webpack_require__(1738);
// EXTERNAL MODULE: ../../node_modules/swr/core/dist/index.esm.js
var index_esm = __webpack_require__(2514);
;// CONCATENATED MODULE: ./pages/_app.tsx
// eslint-disable-next-line prettier/prettier























// See: https://fontawesome.com/docs/web/use-with/react/use-with
fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;
fontawesome_svg_core/* library.add */.vI.add(icons/* faManfred */.x);
function App(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Toast */.FN, {
                position: "bottom-right"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Talent Engine - Manfred"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:locale",
                        content: router.locale
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Manfred"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentScript, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* ErrorBoundary */.S, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
                    theme: theme_0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* UIProvider */.JP, {
                        theme: theme_0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SWRConfig */.J$, {
                            value: {
                                fallback: pageProps.fallback
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.FlagsmithProvider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                flagsmith: (flagsmith_default())
                            },  true && {
                                options: {
                                    environmentID: env_vars/* ENV.flagsmithEnvironmentKey */.V.flagsmithEnvironmentKey
                                }
                            }), {
                                serverState: "flagsmithState" in pageProps ? pageProps.flagsmithState : undefined,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(client/* UserProvider */.dr, {
                                    children: [
                                        env_vars/* ENV.segmentApiKey */.V.segmentApiKey && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                                            id: "segment-script",
                                            dangerouslySetInnerHTML: {
                                                __html: renderSegmentSnippet()
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                                    ]
                                })
                            }))
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(App));


/***/ }),

/***/ 90729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EJ": function() { return /* binding */ APP_PAGES; },
/* harmony export */   "mn": function() { return /* binding */ getPagePath; },
/* harmony export */   "wo": function() { return /* binding */ getOfferPagePath; }
/* harmony export */ });
/* unused harmony exports getLoginPagePath, getHomePagePath, getCatalogPagePath, getCreateOfferPagePath */
/* harmony import */ var _next_pages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58701);
/* harmony import */ var _next_pages__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_next_pages__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77751);


/**
 * Object containing the app pages config
 */ var APP_PAGES = (_next_pages__WEBPACK_IMPORTED_MODULE_0___default());
/**
 * Get the path URL for a given page and locale
 *
 * @param page The page
 * @param locale The locale to use
 *
 * @returns The path for the given page and locale
 */ var getPagePath = function(page) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _locale__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_LOCALE */ .Z;
    return page.langs[locale.toLowerCase()];
};
/**
 * Get the path URL for the login page
 *
 * @param locale The locale to use
 *
 * @returns The path for the login page
 */ var getLoginPagePath = function() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_LOCALE;
    return "".concat(getPagePath(APP_PAGES.login, locale));
};
/**
 * Get the path URL for the home page
 *
 * @param locale The locale to use
 *
 * @returns The path for the home page
 */ var getHomePagePath = function() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_LOCALE;
    return "".concat(getPagePath(APP_PAGES.home, locale));
};
/**
 * Get the path URL for the catalog page
 *
 * @param locale The locale to use
 *
 * @returns The path for the catalog page
 */ var getCatalogPagePath = function() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_LOCALE;
    return "".concat(getPagePath(APP_PAGES.catalog, locale));
};
/**
 * Get the path URL for the create offer page
 *
 * @param locale The locale to use
 *
 * @returns The path for the create offer page
 */ var getCreateOfferPagePath = function() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_LOCALE;
    return "".concat(getPagePath(APP_PAGES.createOffer, locale));
};
/**
 * Get the path URL for a given Offer page
 *
 * @param offerId The Offer Id
 * @param locale The locale to use
 *
 * @returns The path for the given Offer Id and locale
 */ var getOfferPagePath = function(offerId) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _locale__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_LOCALE */ .Z, tab = arguments.length > 2 ? arguments[2] : void 0;
    return "".concat(getPagePath(APP_PAGES.offer, locale)).concat(tab ? "?tab=".concat(tab) : "").replace(":offerId", offerId.toString());
};


/***/ }),

/***/ 59413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ ENV; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./next.env-vars.js
var next_env_vars = __webpack_require__(39595);
// EXTERNAL MODULE: ../../node_modules/next/config.js
var config = __webpack_require__(70314);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./utils/env-vars.utils.ts



var publicRuntimeConfig = config_default()().publicRuntimeConfig;
var getRuntimeVariable = function(runtimeVariable, defaultValue) {
    var unvalidatedRuntimeVariable = publicRuntimeConfig[runtimeVariable];
    if (!unvalidatedRuntimeVariable) {
        if (defaultValue != null) {
            return defaultValue;
        }
        // ? We could throw an error here instead setting an empty value
        // * This would stop the execution, ensuring that the variable is available
        return "";
    } else {
        return unvalidatedRuntimeVariable;
    }
};
/**
 * Returns all the env vars for the app (from the `next.env-vars.js` file)
 *
 * @returns object containing all the env vars
 */ var getAppEnvVars = function() {
    var config = {};
    Object.entries(next_env_vars).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        config[key] = getRuntimeVariable(value.name, value.defaultValue);
    });
    return config;
};

;// CONCATENATED MODULE: ./utils/env-vars.ts

/**
 * Returns a typed object containing all the env vars for the app (from the `next.env-vars.js` file)
 */ var ENV = getAppEnvVars();


/***/ }),

/***/ 33084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ faManfred; }
});

;// CONCATENATED MODULE: ./utils/icons/manfred.ts
var faManfred = {
    // Use a prefix like 'fac' that doesn't conflict with a prefix in the standard Font Awesome styles
    // (So avoid fab, fal, fas, far, fa)
    prefix: "fas",
    iconName: "manfred",
    icon: [
        16,
        11,
        [],
        "",
        "M12.3175 0.399414C13.3966 0.399414 14.2751 0.766601 14.9528 1.50015C15.6304 2.23391 15.9694 3.32784 15.9694 4.78215V10.4715C15.9694 10.6037 15.9234 10.7195 15.8312 10.8187C15.7392 10.9177 15.6207 10.9672 15.4759 10.9672H13.048C12.9031 10.9672 12.7814 10.921 12.6828 10.8286C12.5838 10.736 12.5347 10.6171 12.5347 10.4717V4.92077C12.5347 4.31264 12.4064 3.86666 12.1498 3.58219C11.8932 3.29813 11.5476 3.156 11.1134 3.156C10.7054 3.156 10.3733 3.29813 10.1166 3.58219C9.86002 3.86645 9.73171 4.31264 9.73171 4.92077V6.25379C9.73171 6.47039 9.55637 6.64594 9.3406 6.64594H6.68777C6.63634 6.64594 6.58545 6.63562 6.53796 6.61603C6.49048 6.59622 6.44736 6.56734 6.41104 6.53104C6.37471 6.49452 6.34593 6.45141 6.32629 6.40376C6.30668 6.35631 6.29659 6.30536 6.29665 6.254V4.92077C6.29665 4.31264 6.16504 3.86666 5.90203 3.58219C5.63881 3.29813 5.29658 3.156 4.87555 3.156C4.46752 3.156 4.13189 3.29813 3.86888 3.58219C3.60566 3.86645 3.47405 4.30604 3.47405 4.90097V6.25379C3.47405 6.47039 3.29871 6.64594 3.08293 6.64594H0.391117C0.3397 6.64594 0.288799 6.63562 0.241317 6.61603C0.193835 6.59622 0.150703 6.56734 0.114385 6.53104C0.0780662 6.49452 0.0492719 6.45141 0.0296457 6.40376C0.0100195 6.35631 -5.39904e-05 6.30536 2.1762e-07 6.254V1.09336C2.1762e-07 0.947926 0.0495087 0.829107 0.148113 0.736485C0.240428 0.646544 0.364531 0.596623 0.493434 0.597654H2.7832C2.92801 0.597654 3.04642 0.643863 3.13863 0.736485C3.23063 0.829107 3.27684 0.947926 3.27684 1.09336V1.7677C3.59246 1.38422 4.00049 1.06035 4.50073 0.796098C5.00077 0.53164 5.56661 0.399414 6.19825 0.399414C7.64576 0.399414 8.63943 0.967936 9.17908 2.10477C9.49469 1.60247 9.93552 1.19258 10.5014 0.875312C11.0674 0.558046 11.6727 0.399414 12.3175 0.399414ZM9.34328 7.82444C9.55926 7.82444 9.7344 7.99999 9.7344 8.21659V10.5753C9.7344 10.7919 9.55926 10.9672 9.34328 10.9672H6.68426C6.63283 10.9672 6.5819 10.9571 6.53439 10.9373C6.48689 10.9175 6.44373 10.8886 6.40741 10.8523C6.37106 10.816 6.34224 10.7727 6.3226 10.7252C6.30296 10.6776 6.29288 10.6266 6.29294 10.5753V8.21639C6.29294 7.99979 6.46828 7.82444 6.68405 7.82444H9.34328ZM3.08438 7.82444C3.30036 7.82444 3.47529 7.99999 3.47529 8.21659V10.5753C3.47529 10.7919 3.30036 10.9672 3.08438 10.9672H0.391736C0.287931 10.967 0.188441 10.9257 0.115137 10.8521C0.0418328 10.7787 0.000715847 10.679 0.000825358 10.5753V8.21639C0.000825358 7.99979 0.175755 7.82444 0.391736 7.82444H3.08438Z" // svg path data
    ]
};

;// CONCATENATED MODULE: ./utils/icons/index.ts



/***/ }),

/***/ 77751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DEFAULT_LOCALE; }
/* harmony export */ });
/* unused harmony export getLocaleForRequest */
/* harmony import */ var _next_i18next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65743);
/* harmony import */ var _next_i18next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_next_i18next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_dist_server_accept_header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18149);


/**
 * This is just an alias over the `defaultLocale` value from `next-i18next.config.js`
 */ var DEFAULT_LOCALE = _next_i18next_config__WEBPACK_IMPORTED_MODULE_0__.i18n.defaultLocale;
/**
 * Get the locale for a given request:
 *
 * - If i18n is not configured, use the default locale
 * - If the user has chosen a locale (via NEXT_LOCALE cookie), use it
 * - Otherwise, use the first valid locale from the `accept-language` header
 * - If no locale is found, use the default locale
 *
 * @param req NextJS API Request
 *
 * @returns the request locale
 */ function getLocaleForRequest(req) {
    if (!i18n) return DEFAULT_LOCALE;
    var chosenLocale = i18n.locales.find(function(locale) {
        return locale === req.cookies.NEXT_LOCALE;
    });
    var detectedLocale = chosenLocale !== null && chosenLocale !== void 0 ? chosenLocale : acceptLanguage(req.headers["accept-language"], i18n.locales);
    return detectedLocale || DEFAULT_LOCALE;
}


/***/ }),

/***/ 58647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; },
/* harmony export */   "Y": function() { return /* binding */ Logger; }
/* harmony export */ });
/* harmony import */ var _asgard_ui_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66879);

var Logger = _asgard_ui_common__WEBPACK_IMPORTED_MODULE_0__/* .Logger */ .Yd;
/**
 * @deprecated Use `Logger.error()` from `ui-common` instead
 */ var logError = Logger.error;


/***/ }),

/***/ 69993:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 15153:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={114:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t="";n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(114);module.exports=t})();

/***/ }),

/***/ 18149:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = acceptLanguage;
function parse(raw, preferences, options) {
    const lowers = new Map();
    const header = raw.replace(/[ \t]/g, "");
    if (preferences) {
        let pos = 0;
        for (const preference of preferences){
            const lower = preference.toLowerCase();
            lowers.set(lower, {
                orig: preference,
                pos: pos++
            });
            if (options.prefixMatch) {
                const parts = lower.split("-");
                while(parts.pop(), parts.length > 0){
                    const joined = parts.join("-");
                    if (!lowers.has(joined)) {
                        lowers.set(joined, {
                            orig: preference,
                            pos: pos++
                        });
                    }
                }
            }
        }
    }
    const parts = header.split(",");
    const selections = [];
    const map = new Set();
    for(let i = 0; i < parts.length; ++i){
        const part = parts[i];
        if (!part) {
            continue;
        }
        const params = part.split(";");
        if (params.length > 2) {
            throw new Error(`Invalid ${options.type} header`);
        }
        let token = params[0].toLowerCase();
        if (!token) {
            throw new Error(`Invalid ${options.type} header`);
        }
        const selection = {
            token,
            pos: i,
            q: 1
        };
        if (preferences && lowers.has(token)) {
            selection.pref = lowers.get(token).pos;
        }
        map.add(selection.token);
        if (params.length === 2) {
            const q = params[1];
            const [key, value] = q.split("=");
            if (!value || key !== "q" && key !== "Q") {
                throw new Error(`Invalid ${options.type} header`);
            }
            const score = parseFloat(value);
            if (score === 0) {
                continue;
            }
            if (Number.isFinite(score) && score <= 1 && score >= 0.001) {
                selection.q = score;
            }
        }
        selections.push(selection);
    }
    selections.sort((a, b)=>{
        if (b.q !== a.q) {
            return b.q - a.q;
        }
        if (b.pref !== a.pref) {
            if (a.pref === undefined) {
                return 1;
            }
            if (b.pref === undefined) {
                return -1;
            }
            return a.pref - b.pref;
        }
        return a.pos - b.pos;
    });
    const values = selections.map((selection)=>selection.token);
    if (!preferences || !preferences.length) {
        return values;
    }
    const preferred = [];
    for (const selection1 of values){
        if (selection1 === "*") {
            for (const [preference, value] of lowers){
                if (!map.has(preference)) {
                    preferred.push(value.orig);
                }
            }
        } else {
            const lower = selection1.toLowerCase();
            if (lowers.has(lower)) {
                preferred.push(lowers.get(lower).orig);
            }
        }
    }
    return preferred;
}
function acceptLanguage(header = "", preferences) {
    return parse(header, preferences, {
        type: "accept-language",
        prefixMatch: true
    })[0] || "";
}

//# sourceMappingURL=accept-header.js.map

/***/ }),

/***/ 97729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(75913)


/***/ }),

/***/ 5632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(93642)


/***/ }),

/***/ 45847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20747)


/***/ }),

/***/ 34406:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 68262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(23586);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 13980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(68262)();
}


/***/ }),

/***/ 23586:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 18726:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	_createClass(AutosizeInput, null, [{
		key: 'getDerivedStateFromProps',
		value: function getDerivedStateFromProps(props, state) {
			var id = props.id;

			return id !== state.prevId ? { inputId: id || generateId(), prevId: id } : null;
		}
	}]);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId(),
			prevId: props.id
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.Z = AutosizeInput;

/***/ }),

/***/ 66866:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),

/***/ 48570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(66866);
} else {}


/***/ }),

/***/ 55497:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(90679);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(ButtonElement);

/***/ }),

/***/ 92276:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(29942);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports["default"] = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),

/***/ 98824:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(90679);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(LinkElement);

/***/ }),

/***/ 70423:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.W_ = __webpack_unused_export__ = __webpack_unused_export__ = undefined;

var _Link = __webpack_require__(98824);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(55497);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(92276);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(73123);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(90496);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(70752);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(27793);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(90679);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(29942);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(9465);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_unused_export__ = _Link2.default;
__webpack_unused_export__ = _Button2.default;
exports.W_ = _Element2.default;
__webpack_unused_export__ = _scroller2.default;
__webpack_unused_export__ = _scrollEvents2.default;
__webpack_unused_export__ = _scrollSpy2.default;
__webpack_unused_export__ = _animateScroll2.default;
__webpack_unused_export__ = _scrollLink2.default;
__webpack_unused_export__ = _scrollElement2.default;
__webpack_unused_export__ = _Helpers2.default;
__webpack_unused_export__ = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),

/***/ 9465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(2784);
var ReactDOM = __webpack_require__(28316);

var utils = __webpack_require__(40659);
var scrollSpy = __webpack_require__(70752);
var defaultScroller = __webpack_require__(73123);
var PropTypes = __webpack_require__(13980);
var scrollHash = __webpack_require__(67654);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),

/***/ 27793:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(40659);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(32684);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(7050);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(90496);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports["default"] = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),

/***/ 7050:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(32165);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports["default"] = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),

/***/ 32165:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),

/***/ 29942:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28316);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(73123);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports["default"] = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),

/***/ 90496:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports["default"] = Events;

/***/ }),

/***/ 67654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(32165);

var _utils = __webpack_require__(40659);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports["default"] = scrollHash;

/***/ }),

/***/ 90679:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(70752);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(73123);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(67654);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  activeStyle: _propTypes2.default.object,
  spy: _propTypes2.default.bool,
  horizontal: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool,
  saveHashHistory: _propTypes2.default.bool,
  spyThrottle: _propTypes2.default.number
};

exports["default"] = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var style = {};

        if (this.state && this.state.active) {
          style = _extends({}, this.props.style, this.props.activeStyle);
        } else {
          style = _extends({}, this.props.style);
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.style = style;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();
          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;
        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),

/***/ 70752:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _lodash = __webpack_require__(98357);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(32165);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageYOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length && scrollSpy.spySetState.indexOf(stateHandler) > -1) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports["default"] = scrollSpy;

/***/ }),

/***/ 73123:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(40659);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(27793);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(90496);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports["default"] = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),

/***/ 32684:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

exports["default"] = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),

/***/ 99570:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.isBrowser = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _reactDom = _interopRequireDefault(__webpack_require__(28316));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var useCreatePortal = typeof _reactDom["default"].createPortal === 'function';
var isBrowser = typeof window !== 'undefined';
exports.isBrowser = isBrowser;

var Portal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal(props) {
    var _this;

    _classCallCheck(this, Portal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Portal).call(this, props));

    if (isBrowser) {
      _this.container = document.createElement('div');
      document.body.appendChild(_this.container);

      _this.renderLayer();
    }

    return _this;
  }

  _createClass(Portal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!useCreatePortal) {
        _reactDom["default"].unmountComponentAtNode(this.container);
      }

      document.body.removeChild(this.container);
    }
  }, {
    key: "renderLayer",
    value: function renderLayer() {
      if (!useCreatePortal) {
        _reactDom["default"].unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (useCreatePortal) {
        return _reactDom["default"].createPortal(this.props.children, this.container);
      }

      return null;
    }
  }]);

  return Portal;
}(_react["default"].Component);

Portal.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = Portal;
exports["default"] = _default;

/***/ }),

/***/ 39189:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getScrollTop = getScrollTop;
exports.getScrollLeft = getScrollLeft;
exports.getArrowSpacing = getArrowSpacing;
exports.getScrollParent = getScrollParent;
exports.noArrowDistance = exports.bodyPadding = exports.minArrowPadding = void 0;

/**
 * a handful of shared functions and constants
 */
var minArrowPadding = 5;
exports.minArrowPadding = minArrowPadding;
var bodyPadding = 10;
exports.bodyPadding = bodyPadding;
var noArrowDistance = 3;
/**
 * cross browser scroll positions
 */

exports.noArrowDistance = noArrowDistance;

function getScrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

function getScrollLeft() {
  return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
}

function getArrowSpacing(props) {
  var defaultArrowSpacing = props.arrow ? props.arrowSize : noArrowDistance;
  return typeof props.distance === 'number' ? props.distance : defaultArrowSpacing;
}
/**
 * get first ancestor that might scroll
 */


function getScrollParent(element) {
  var style = getComputedStyle(element);
  var scrollParent = window;

  if (style.position !== 'fixed') {
    var parent = element.parentElement;

    while (parent) {
      var parentStyle = getComputedStyle(parent);

      if (/(auto|scroll)/.test(parentStyle.overflow + parentStyle.overflowY + parentStyle.overflowX)) {
        scrollParent = parent;
        parent = undefined;
      } else {
        parent = parent.parentElement;
      }
    }
  }

  return scrollParent;
}

/***/ }),

/***/ 91608:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getDirection;

var _functions = __webpack_require__(39189);

/**
 * Checks the intended tip direction and falls back if not enough space
 */
function checkLeftRightWidthSufficient(tip, target, distance, bodyPadding) {
  var targetRect = target.getBoundingClientRect();
  var deadSpace = Math.min(targetRect.left, document.documentElement.clientWidth - targetRect.right);
  return tip.offsetWidth + target.offsetWidth + distance + bodyPadding + deadSpace < document.documentElement.clientWidth;
}

function checkTargetSufficientlyVisible(target, tip, props) {
  var targetRect = target.getBoundingClientRect();
  var bottomOverhang = targetRect.bottom > window.innerHeight;
  var topOverhang = targetRect.top < 0; // if the target is taller than the viewport (and we know there's sufficient left/right width before this is called),
  // then go with the left/right direction as top/bottom will both be off screen

  if (topOverhang && bottomOverhang) {
    return true;
  } // if the target is bigger than the tip, we need to check if enough of the target is visible


  if (target.offsetHeight > tip.offsetHeight) {
    var halfTargetHeight = target.offsetHeight / 2;
    var arrowClearance = props.arrowSize + _functions.minArrowPadding;
    var bottomOverhangAmount = targetRect.bottom - window.innerHeight;
    var topOverhangAmount = -targetRect.top;
    var targetCenterToBottomOfWindow = halfTargetHeight - bottomOverhangAmount;
    var targetCenterToTopOfWindow = halfTargetHeight - topOverhangAmount;
    return targetCenterToBottomOfWindow >= arrowClearance && targetCenterToTopOfWindow >= arrowClearance;
  } // otherwise just check that the whole target is visible


  return !bottomOverhang && !topOverhang;
}

function checkForArrowOverhang(props, arrowStyles, bodyPadding) {
  var scrollLeft = (0, _functions.getScrollLeft)();
  var hasLeftClearance = arrowStyles.positionStyles.left - scrollLeft > bodyPadding;
  var hasRightClearance = arrowStyles.positionStyles.left + props.arrowSize * 2 < scrollLeft + document.documentElement.clientWidth - bodyPadding;
  return !hasLeftClearance || !hasRightClearance;
}

function getDirection(currentDirection, tip, target, props, bodyPadding, arrowStyles, recursive) {
  // can't switch until target is rendered
  if (!target) {
    return currentDirection;
  }

  var targetRect = target.getBoundingClientRect();
  var arrowSpacing = (0, _functions.getArrowSpacing)(props); // this is how much space is needed to display the tip above or below the target

  var heightOfTipWithArrow = tip.offsetHeight + arrowSpacing + bodyPadding;
  var spaceBelowTarget = window.innerHeight - targetRect.bottom;
  var spaceAboveTarget = targetRect.top;
  var hasSpaceBelow = spaceBelowTarget >= heightOfTipWithArrow;
  var hasSpaceAbove = spaceAboveTarget >= heightOfTipWithArrow;

  switch (currentDirection) {
    case 'right':
      // if the window is not wide enough try top (which falls back to down)
      if (!checkLeftRightWidthSufficient(tip, target, arrowSpacing, bodyPadding) || !checkTargetSufficientlyVisible(target, tip, props)) {
        return getDirection('up', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
      }

      if (document.documentElement.clientWidth - targetRect.right < tip.offsetWidth + arrowSpacing + bodyPadding) {
        return 'left';
      }

      return 'right';

    case 'left':
      // if the window is not wide enough try top (which falls back to down)
      if (!checkLeftRightWidthSufficient(tip, target, arrowSpacing, bodyPadding) || !checkTargetSufficientlyVisible(target, tip, props)) {
        return getDirection('up', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
      }

      if (targetRect.left < tip.offsetWidth + arrowSpacing + bodyPadding) {
        return 'right';
      }

      return 'left';

    case 'up':
      if (!recursive && arrowStyles && checkForArrowOverhang(props, arrowStyles, bodyPadding)) {
        return getDirection('left', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
      }

      if (!hasSpaceAbove) {
        if (hasSpaceBelow) {
          return 'down';
        }

        if (!recursive && checkLeftRightWidthSufficient(tip, target, arrowSpacing, bodyPadding)) {
          return getDirection('right', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
        }
      }

      return 'up';

    case 'down':
    default:
      if (!recursive && arrowStyles && checkForArrowOverhang(props, arrowStyles, bodyPadding)) {
        return getDirection('right', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
      }

      if (!hasSpaceBelow) {
        // if there's no space below, but space above, switch to that direction
        if (hasSpaceAbove) {
          return 'up'; // if there's not space above or below, check if there would be space left or right
        }

        if (!recursive && checkLeftRightWidthSufficient(tip, target, arrowSpacing, bodyPadding)) {
          return getDirection('right', tip, target, arrowSpacing, bodyPadding, arrowStyles, true);
        } // if there's no space in any direction, default to the original direction

      }

      return 'down';
  }
}

/***/ }),

/***/ 64457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _Portal = _interopRequireWildcard(__webpack_require__(99570));

var _position = _interopRequireDefault(__webpack_require__(92494));

var _functions = __webpack_require__(39189);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// default colors
var defaultColor = '#fff';
var defaultBg = '#333';
var resizeThrottle = 100;
var resizeThreshold = 5;

var stopProp = function stopProp(e) {
  return e.stopPropagation();
};

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  _createClass(Tooltip, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      return _Portal.isBrowser && nextProps.isOpen ? {
        hasBeenShown: true
      } : null;
    }
  }]);

  function Tooltip() {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this));

    _defineProperty(_assertThisInitialized(_this), "debounceTimeout", false);

    _defineProperty(_assertThisInitialized(_this), "hoverTimeout", false);

    _this.state = {
      showTip: false,
      hasHover: false,
      ignoreShow: false,
      hasBeenShown: false
    };
    _this.showTip = _this.showTip.bind(_assertThisInitialized(_this));
    _this.hideTip = _this.hideTip.bind(_assertThisInitialized(_this));
    _this.checkHover = _this.checkHover.bind(_assertThisInitialized(_this));
    _this.toggleTip = _this.toggleTip.bind(_assertThisInitialized(_this));
    _this.startHover = _this.startHover.bind(_assertThisInitialized(_this));
    _this.endHover = _this.endHover.bind(_assertThisInitialized(_this));
    _this.listenResizeScroll = _this.listenResizeScroll.bind(_assertThisInitialized(_this));
    _this.handleResizeScroll = _this.handleResizeScroll.bind(_assertThisInitialized(_this));
    _this.bodyTouchStart = _this.bodyTouchStart.bind(_assertThisInitialized(_this));
    _this.bodyTouchEnd = _this.bodyTouchEnd.bind(_assertThisInitialized(_this));
    _this.targetTouchStart = _this.targetTouchStart.bind(_assertThisInitialized(_this));
    _this.targetTouchEnd = _this.targetTouchEnd.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // if the isOpen prop is passed on first render we need to immediately trigger a second render,
      // because the tip ref is needed to calculate the position
      if (this.props.isOpen) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
          isOpen: true
        });
      }

      this.scrollParent = (0, _functions.getScrollParent)(this.target);
      window.addEventListener('resize', this.listenResizeScroll);
      this.scrollParent.addEventListener('scroll', this.listenResizeScroll);
      window.addEventListener('touchstart', this.bodyTouchStart);
      window.addEventListener('touchEnd', this.bodyTouchEnd);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      // older versions of react won't leverage getDerivedStateFromProps, TODO: remove when < 16.3 support is dropped
      if (!this.state.hasBeenShown && this.props.isOpen) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          hasBeenShown: true
        });
        return setTimeout(this.showTip, 0);
      } // we need to render once to get refs in place, then we can make the calculations on a followup render
      // this only has to happen the first time the tip is shown, and allows us to not render every tip on the page with initial render.


      if (!prevState.hasBeenShown && this.state.hasBeenShown) {
        this.showTip();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.listenResizeScroll);
      this.scrollParent.removeEventListener('scroll', this.listenResizeScroll);
      window.removeEventListener('touchstart', this.bodyTouchStart);
      window.removeEventListener('touchEnd', this.bodyTouchEnd);
      clearTimeout(this.debounceTimeout);
      clearTimeout(this.hoverTimeout);
    }
  }, {
    key: "listenResizeScroll",
    value: function listenResizeScroll() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(this.handleResizeScroll, resizeThrottle);

      if (this.state.targetTouch) {
        this.setState({
          targetTouch: undefined
        });
      }
    }
  }, {
    key: "handleResizeScroll",
    value: function handleResizeScroll() {
      if (this.state.showTip) {
        // if we're showing the tip and the resize was actually a signifigant change, then setState to re-render and calculate position
        var clientWidth = Math.round(document.documentElement.clientWidth / resizeThreshold) * resizeThreshold;
        this.setState({
          clientWidth: clientWidth
        });
      }
    }
  }, {
    key: "targetTouchStart",
    value: function targetTouchStart() {
      this.setState({
        targetTouch: true
      });
    }
  }, {
    key: "targetTouchEnd",
    value: function targetTouchEnd() {
      if (this.state.targetTouch) {
        this.toggleTip();
      }
    }
  }, {
    key: "bodyTouchEnd",
    value: function bodyTouchEnd() {
      if (this.state.targetTouch) {
        this.setState({
          targetTouch: undefined
        });
      }
    }
  }, {
    key: "bodyTouchStart",
    value: function bodyTouchStart(e) {
      // if it's a controlled tip we don't want to auto-dismiss, otherwise we just ignore taps inside the tip
      if (!(this.target && this.target.contains(e.target)) && !(this.tip && this.tip.contains(e.target)) && !this.props.isOpen) {
        this.hideTip();
      }
    }
  }, {
    key: "toggleTip",
    value: function toggleTip() {
      this.state.showTip ? this.hideTip() : this.showTip();
    }
  }, {
    key: "showTip",
    value: function showTip() {
      var _this2 = this;

      if (!this.state.hasBeenShown) {
        // this will render once, then fire componentDidUpdate, which will show the tip
        return this.setState({
          hasBeenShown: true
        });
      }

      if (!this.state.showTip) {
        this.setState({
          showTip: true
        }, function () {
          if (typeof _this2.props.onToggle === 'function') {
            _this2.props.onToggle(_this2.state.showTip);
          }
        });
      }
    }
  }, {
    key: "hideTip",
    value: function hideTip() {
      var _this3 = this;

      this.setState({
        hasHover: false
      });

      if (this.state.showTip) {
        this.setState({
          showTip: false
        }, function () {
          if (typeof _this3.props.onToggle === 'function') {
            _this3.props.onToggle(_this3.state.showTip);
          }
        });
      }
    }
  }, {
    key: "startHover",
    value: function startHover() {
      if (!this.state.ignoreShow) {
        this.setState({
          hasHover: true
        });
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = setTimeout(this.checkHover, this.props.hoverDelay);
      }
    }
  }, {
    key: "endHover",
    value: function endHover() {
      this.setState({
        hasHover: false
      });
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(this.checkHover, this.props.mouseOutDelay || this.props.hoverDelay);
    }
  }, {
    key: "checkHover",
    value: function checkHover() {
      this.state.hasHover ? this.showTip() : this.hideTip();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          arrow = _this$props.arrow,
          arrowSize = _this$props.arrowSize,
          background = _this$props.background,
          className = _this$props.className,
          children = _this$props.children,
          color = _this$props.color,
          content = _this$props.content,
          direction = _this$props.direction,
          distance = _this$props.distance,
          eventOff = _this$props.eventOff,
          eventOn = _this$props.eventOn,
          eventToggle = _this$props.eventToggle,
          forceDirection = _this$props.forceDirection,
          isOpen = _this$props.isOpen,
          mouseOutDelay = _this$props.mouseOutDelay,
          padding = _this$props.padding,
          styles = _this$props.styles,
          TagName = _this$props.tagName,
          tipContentHover = _this$props.tipContentHover,
          tipContentClassName = _this$props.tipContentClassName,
          useDefaultStyles = _this$props.useDefaultStyles,
          useHover = _this$props.useHover,
          arrowContent = _this$props.arrowContent;
      var isControlledByProps = typeof isOpen !== 'undefined' && isOpen !== null;
      var showTip = isControlledByProps ? isOpen : this.state.showTip;

      var wrapperStyles = _objectSpread({
        position: 'relative'
      }, styles);

      var props = {
        style: wrapperStyles,
        ref: function ref(target) {
          _this4.target = target;
        },
        className: className
      };
      var portalProps = {
        // keep clicks on the tip from closing click controlled tips
        onClick: stopProp
      }; // event handling

      if (eventOff) {
        props[eventOff] = this.hideTip;
      }

      if (eventOn) {
        props[eventOn] = this.showTip;
      }

      if (eventToggle) {
        props[eventToggle] = this.toggleTip; // only use hover if they don't have a toggle event
      } else if (useHover && !isControlledByProps) {
        props.onMouseEnter = this.startHover;
        props.onMouseLeave = tipContentHover || mouseOutDelay ? this.endHover : this.hideTip;
        props.onTouchStart = this.targetTouchStart;
        props.onTouchEnd = this.targetTouchEnd;

        if (tipContentHover) {
          portalProps.onMouseEnter = this.startHover;
          portalProps.onMouseLeave = this.endHover;
          portalProps.onTouchStart = stopProp;
        }
      } // conditional rendering of tip


      var tipPortal;

      if (this.state.hasBeenShown) {
        var currentPositions = (0, _position["default"])(direction, forceDirection, this.tip, this.target, _objectSpread({}, this.state, {
          showTip: showTip
        }), {
          background: useDefaultStyles ? defaultBg : background,
          arrow: arrow,
          arrowSize: arrowSize,
          distance: distance
        });

        var tipStyles = _objectSpread({}, currentPositions.tip, {
          background: useDefaultStyles ? defaultBg : background,
          color: useDefaultStyles ? defaultColor : color,
          padding: padding,
          boxSizing: 'border-box',
          zIndex: this.props.zIndex,
          position: 'absolute',
          display: 'inline-block'
        });

        var arrowStyles = _objectSpread({}, currentPositions.arrow.positionStyles, arrowContent ? {} : currentPositions.arrow.borderStyles, {
          position: 'absolute',
          width: '0px',
          height: '0px',
          zIndex: this.props.zIndex + 1
        });

        tipPortal = _react["default"].createElement(_Portal["default"], null, _react["default"].createElement("div", _extends({}, portalProps, {
          className: typeof tipContentClassName !== 'undefined' ? tipContentClassName : className
        }), _react["default"].createElement("span", {
          className: "react-tooltip-lite",
          style: tipStyles,
          ref: function ref(tip) {
            _this4.tip = tip;
          }
        }, content), _react["default"].createElement("span", {
          className: "react-tooltip-lite-arrow react-tooltip-lite-".concat(currentPositions.realDirection, "-arrow"),
          style: arrowStyles
        }, arrowContent)));
      }

      return _react["default"].createElement(TagName, props, children, tipPortal);
    }
  }]);

  return Tooltip;
}(_react["default"].Component);

_defineProperty(Tooltip, "propTypes", {
  arrow: _propTypes["default"].bool,
  arrowSize: _propTypes["default"].number,
  background: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  content: _propTypes["default"].node.isRequired,
  direction: _propTypes["default"].string,
  distance: _propTypes["default"].number,
  eventOff: _propTypes["default"].string,
  eventOn: _propTypes["default"].string,
  eventToggle: _propTypes["default"].string,
  forceDirection: _propTypes["default"].bool,
  hoverDelay: _propTypes["default"].number,
  isOpen: _propTypes["default"].bool,
  mouseOutDelay: _propTypes["default"].number,
  padding: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  styles: _propTypes["default"].object,
  tagName: _propTypes["default"].string,
  tipContentHover: _propTypes["default"].bool,
  tipContentClassName: _propTypes["default"].string,
  useDefaultStyles: _propTypes["default"].bool,
  useHover: _propTypes["default"].bool,
  zIndex: _propTypes["default"].number,
  onToggle: _propTypes["default"].func,
  arrowContent: _propTypes["default"].node
});

_defineProperty(Tooltip, "defaultProps", {
  arrow: true,
  arrowSize: 10,
  background: '',
  className: '',
  color: '',
  direction: 'up',
  distance: undefined,
  eventOff: undefined,
  eventOn: undefined,
  eventToggle: undefined,
  forceDirection: false,
  hoverDelay: 200,
  isOpen: undefined,
  mouseOutDelay: undefined,
  padding: '10px',
  styles: {},
  tagName: 'div',
  tipContentHover: false,
  tipContentClassName: undefined,
  useDefaultStyles: false,
  useHover: true,
  zIndex: 1000,
  onToggle: undefined,
  arrowContent: null
});

var _default = Tooltip;
exports.Z = _default;

/***/ }),

/***/ 92494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = positions;

var _getDirection = _interopRequireDefault(__webpack_require__(91608));

var _functions = __webpack_require__(39189);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Sets tip max width safely for mobile
 */
function getTipMaxWidth() {
  return typeof document !== 'undefined' ? document.documentElement.clientWidth - _functions.bodyPadding * 2 : 1000;
}
/**
 * Parses align mode from direction if specified with hyphen, defaulting to middle if not -
 * e.g. 'left-start' is mode 'start' and 'left' would be the default of 'middle'
 */


function parseAlignMode(direction) {
  var directionArray = direction.split('-');

  if (directionArray.length > 1) {
    return directionArray[1];
  }

  return 'middle';
}
/**
 * Gets wrapper's left position for top/bottom tooltips as well as needed width restriction
 */


function getUpDownPosition(tip, target, state, direction, alignMode, props) {
  var left = -10000000;
  var top;
  var transform = state.showTip ? undefined : 'translateX(-10000000px)';
  var arrowSpacing = (0, _functions.getArrowSpacing)(props);

  if (tip) {
    // get wrapper left position
    var scrollLeft = (0, _functions.getScrollLeft)();
    var targetRect = target.getBoundingClientRect();
    var targetLeft = targetRect.left + scrollLeft;
    var halfTargetWidth = Math.round(target.offsetWidth / 2);
    var tipWidth = Math.min(getTipMaxWidth(), tip.offsetWidth);
    var arrowCenter = targetLeft + halfTargetWidth;
    var arrowLeft = arrowCenter - props.arrowSize;
    var arrowRight = arrowCenter + props.arrowSize;

    if (alignMode === 'start') {
      left = props.arrow ? Math.min(arrowLeft, targetLeft) : targetLeft;
    } else if (alignMode === 'end') {
      var rightWithArrow = Math.max(arrowRight, targetLeft + target.offsetWidth);
      var rightEdge = props.arrow ? rightWithArrow : targetLeft + target.offsetWidth;
      left = Math.max(rightEdge - tipWidth, _functions.bodyPadding + scrollLeft);
    } else {
      var centeredLeft = targetLeft + halfTargetWidth - Math.round(tipWidth / 2);
      var availableSpaceOnLeft = _functions.bodyPadding + scrollLeft;
      left = Math.max(centeredLeft, availableSpaceOnLeft);
    } // check for right overhang


    var rightOfTip = left + tipWidth;
    var rightOfScreen = scrollLeft + document.documentElement.clientWidth - _functions.bodyPadding;
    var rightOverhang = rightOfTip - rightOfScreen;

    if (rightOverhang > 0) {
      left -= rightOverhang;
    }

    if (direction === 'up') {
      top = targetRect.top + (0, _functions.getScrollTop)() - (tip.offsetHeight + arrowSpacing);
    } else {
      top = targetRect.bottom + (0, _functions.getScrollTop)() + arrowSpacing;
    }
  }

  return {
    left: left,
    top: top,
    transform: transform
  };
}
/**
 * gets top position for left/right arrows
 */


function getLeftRightPosition(tip, target, state, direction, alignMode, props) {
  var left = -10000000;
  var top = 0;
  var transform = state.showTip ? undefined : 'translateX(-10000000px)';
  var arrowSpacing = (0, _functions.getArrowSpacing)(props);
  var arrowPadding = props.arrow ? _functions.minArrowPadding : 0;

  if (tip) {
    var scrollTop = (0, _functions.getScrollTop)();
    var scrollLeft = (0, _functions.getScrollLeft)();
    var targetRect = target.getBoundingClientRect();
    var targetTop = targetRect.top + scrollTop;
    var halfTargetHeight = Math.round(target.offsetHeight / 2);
    var arrowTop = targetTop + halfTargetHeight - props.arrowSize;
    var arrowBottom = targetRect.top + scrollTop + halfTargetHeight + props.arrowSize; // TODO: handle close to edges better

    if (alignMode === 'start') {
      top = props.arrow ? Math.min(targetTop, arrowTop) : targetTop;
    } else if (alignMode === 'end') {
      var topForBottomAlign = targetRect.bottom + scrollTop - tip.offsetHeight;
      top = props.arrow ? Math.max(topForBottomAlign, arrowBottom - tip.offsetHeight) : topForBottomAlign;
    } else {
      // default to middle, but don't go below body
      var centeredTop = Math.max(targetTop + halfTargetHeight - Math.round(tip.offsetHeight / 2), _functions.bodyPadding + scrollTop); // make sure it doesn't go below the arrow

      top = Math.min(centeredTop, arrowTop - arrowPadding);
    } // check for bottom overhang


    var bottomOverhang = top - scrollTop + tip.offsetHeight + _functions.bodyPadding - window.innerHeight;

    if (bottomOverhang > 0) {
      // try to add the body padding below the tip, but don't offset too far from the arrow
      top = Math.max(top - bottomOverhang, arrowBottom + arrowPadding - tip.offsetHeight);
    }

    if (direction === 'right') {
      left = targetRect.right + arrowSpacing + scrollLeft;
    } else {
      left = targetRect.left - arrowSpacing - tip.offsetWidth + scrollLeft;
    }
  }

  return {
    left: left,
    top: top,
    transform: transform
  };
}
/**
 * sets the Arrow styles based on direction
 */


function getArrowStyles(target, tip, direction, state, props) {
  if (!target || !props.arrow) {
    return {
      positionStyles: {
        top: '0',
        left: '-10000000px'
      }
    };
  }

  var targetRect = target.getBoundingClientRect();
  var halfTargetHeight = Math.round(target.offsetHeight / 2);
  var halfTargetWidth = Math.round(target.offsetWidth / 2);
  var scrollTop = (0, _functions.getScrollTop)();
  var scrollLeft = (0, _functions.getScrollLeft)();
  var arrowSpacing = (0, _functions.getArrowSpacing)(props);
  var borderStyles = {};
  var positionStyles = {};

  switch (direction) {
    case 'right':
      borderStyles.borderTop = "".concat(props.arrowSize, "px solid transparent");
      borderStyles.borderBottom = "".concat(props.arrowSize, "px solid transparent");

      if (props.background) {
        borderStyles.borderRight = "".concat(props.arrowSize, "px solid ").concat(props.background);
      } else {
        borderStyles.borderRightWidth = "".concat(props.arrowSize, "px");
        borderStyles.borderRightStyle = 'solid';
      }

      positionStyles.top = state.showTip && tip ? targetRect.top + scrollTop + halfTargetHeight - props.arrowSize : '-10000000px';
      positionStyles.left = targetRect.right + scrollLeft + arrowSpacing - props.arrowSize;
      break;

    case 'left':
      borderStyles.borderTop = "".concat(props.arrowSize, "px solid transparent");
      borderStyles.borderBottom = "".concat(props.arrowSize, "px solid transparent");

      if (props.background) {
        borderStyles.borderLeft = "".concat(props.arrowSize, "px solid ").concat(props.background);
      } else {
        borderStyles.borderLeftWidth = "".concat(props.arrowSize, "px");
        borderStyles.borderLeftStyle = 'solid';
      }

      positionStyles.top = state.showTip && tip ? targetRect.top + scrollTop + halfTargetHeight - props.arrowSize : '-10000000px';
      positionStyles.left = targetRect.left + scrollLeft - arrowSpacing - 1;
      break;

    case 'up':
      borderStyles.borderLeft = "".concat(props.arrowSize, "px solid transparent");
      borderStyles.borderRight = "".concat(props.arrowSize, "px solid transparent"); // if color is styled with css, we need everything except border-color, if styled with props, we add entire border rule

      if (props.background) {
        borderStyles.borderTop = "".concat(props.arrowSize, "px solid ").concat(props.background);
      } else {
        borderStyles.borderTopWidth = "".concat(props.arrowSize, "px");
        borderStyles.borderTopStyle = 'solid';
      }

      positionStyles.left = state.showTip && tip ? targetRect.left + scrollLeft + halfTargetWidth - props.arrowSize : '-10000000px';
      positionStyles.top = targetRect.top + scrollTop - arrowSpacing;
      break;

    case 'down':
    default:
      borderStyles.borderLeft = "".concat(props.arrowSize, "px solid transparent");
      borderStyles.borderRight = "".concat(props.arrowSize, "px solid transparent");

      if (props.background) {
        borderStyles.borderBottom = "10px solid ".concat(props.background);
      } else {
        borderStyles.borderBottomWidth = "".concat(props.arrowSize, "px");
        borderStyles.borderBottomStyle = 'solid';
      }

      positionStyles.left = state.showTip && tip ? targetRect.left + scrollLeft + halfTargetWidth - props.arrowSize : '-10000000px';
      positionStyles.top = targetRect.bottom + scrollTop + arrowSpacing - props.arrowSize;
      break;
  }

  return {
    borderStyles: borderStyles,
    positionStyles: positionStyles
  };
}
/**
 * Returns the positions style rules
 */


function positions(direction, forceDirection, tip, target, state, props) {
  var alignMode = parseAlignMode(direction);
  var trimmedDirection = direction.split('-')[0];
  var realDirection = trimmedDirection;

  if (!forceDirection && tip) {
    var testArrowStyles = props.arrow && getArrowStyles(target, tip, trimmedDirection, state, props);
    realDirection = (0, _getDirection["default"])(trimmedDirection, tip, target, props, _functions.bodyPadding, testArrowStyles);
  }

  var maxWidth = getTipMaxWidth(); // force the tip to display the width we measured everything at when visible

  var width;

  if (tip) {
    // adding the exact width on the first render forces a bogus line break, so add 1px the first time
    var spacer = tip.style.width ? 0 : 1;
    width = Math.min(tip.offsetWidth, maxWidth) + spacer;
  }

  var tipPosition = realDirection === 'up' || realDirection === 'down' ? getUpDownPosition(tip, target, state, realDirection, alignMode, props) : getLeftRightPosition(tip, target, state, realDirection, alignMode, props);
  return {
    tip: _objectSpread({}, tipPosition, {
      maxWidth: maxWidth,
      width: width
    }),
    arrow: getArrowStyles(target, tip, realDirection, state, props),
    realDirection: realDirection
  };
}

/***/ }),

/***/ 1738:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34406);
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect;
(function (Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function (factory) {
        var root = typeof __webpack_require__.g === "object" ? __webpack_require__.g :
            typeof self === "object" ? self :
                typeof this === "object" ? this :
                    Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") {
            root.Reflect = Reflect;
        }
        else {
            exporter = makeExporter(root.Reflect, exporter);
        }
        factory(exporter);
        function makeExporter(target, previous) {
            return function (key, value) {
                if (typeof target[key] !== "function") {
                    Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
                }
                if (previous)
                    previous(key, value);
            };
        }
    })(function (exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate
                ? function () { return MakeDictionary(Object.create(null)); }
                : supportsProto
                    ? function () { return MakeDictionary({ __proto__: null }); }
                    : function () { return MakeDictionary({}); },
            has: downLevel
                ? function (map, key) { return hasOwn.call(map, key); }
                : function (map, key) { return key in map; },
            get: downLevel
                ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
                : function (map, key) { return map[key]; },
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof process === "object" && process.env && process.env["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */
        function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                    throw new TypeError();
                if (IsNull(attributes))
                    attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            }
            else {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsConstructor(target))
                    throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */
        function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                    throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */
        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */
        function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */
        function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            if (!metadataMap.delete(metadataKey))
                return false;
            if (metadataMap.size > 0)
                return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0)
                return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated))
                        throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated))
                        throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create)
                    return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create)
                    return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null)
                return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0)
                return ownKeys;
            if (ownKeys.length <= 0)
                return parentKeys;
            var set = new _Set();
            var keys = [];
            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while (true) {
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                }
                catch (e) {
                    try {
                        IteratorClose(iterator);
                    }
                    finally {
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null)
                return 1 /* Null */;
            switch (typeof x) {
                case "undefined": return 0 /* Undefined */;
                case "boolean": return 2 /* Boolean */;
                case "string": return 3 /* String */;
                case "symbol": return 4 /* Symbol */;
                case "number": return 5 /* Number */;
                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
                default: return 6 /* Object */;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch (Type(input)) {
                case 0 /* Undefined */: return input;
                case 1 /* Null */: return input;
                case 2 /* Boolean */: return input;
                case 3 /* String */: return input;
                case 4 /* Symbol */: return input;
                case 5 /* Number */: return input;
            }
            var hint = PreferredType === 3 /* String */ ? "string" : PreferredType === 5 /* Number */ ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result))
                    throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */);
            if (IsSymbol(key))
                return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray
                ? Array.isArray(argument)
                : argument instanceof Object
                    ? argument instanceof Array
                    : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch (Type(argument)) {
                case 3 /* String */: return true;
                case 4 /* Symbol */: return true;
                default: return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null)
                return undefined;
            if (!IsCallable(func))
                throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method))
                throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator))
                throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f)
                f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype)
                return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype)
                return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype)
                return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function")
                return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O)
                return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ (function () {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function () { return this; };
                MapIterator.prototype[iteratorSymbol] = function () { return this; };
                MapIterator.prototype.next = function () {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        }
                        else {
                            this._index++;
                        }
                        return { value: result, done: false };
                    }
                    return { value: undefined, done: true };
                };
                MapIterator.prototype.throw = function (error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function (value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return { value: value, done: true };
                };
                return MapIterator;
            }());
            return /** @class */ (function () {
                function Map() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map.prototype, "size", {
                    get: function () { return this._keys.length; },
                    enumerable: true,
                    configurable: true
                });
                Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
                Map.prototype.get = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map.prototype.set = function (key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map.prototype.delete = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for (var i = index + 1; i < size; i++) {
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map.prototype.clear = function () {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
                Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
                Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
                Map.prototype["@@iterator"] = function () { return this.entries(); };
                Map.prototype[iteratorSymbol] = function () { return this.entries(); };
                Map.prototype._find = function (key, insert) {
                    if (this._cacheKey !== key) {
                        this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map;
            }());
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [key, value];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return /** @class */ (function () {
                function Set() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set.prototype, "size", {
                    get: function () { return this._map.size; },
                    enumerable: true,
                    configurable: true
                });
                Set.prototype.has = function (value) { return this._map.has(value); };
                Set.prototype.add = function (value) { return this._map.set(value, value), this; };
                Set.prototype.delete = function (value) { return this._map.delete(value); };
                Set.prototype.clear = function () { this._map.clear(); };
                Set.prototype.keys = function () { return this._map.keys(); };
                Set.prototype.values = function () { return this._map.values(); };
                Set.prototype.entries = function () { return this._map.entries(); };
                Set.prototype["@@iterator"] = function () { return this.keys(); };
                Set.prototype[iteratorSymbol] = function () { return this.keys(); };
                return Set;
            }());
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ (function () {
                function WeakMap() {
                    this._key = CreateUniqueKey();
                }
                WeakMap.prototype.has = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap.prototype.get = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap.prototype.set = function (target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap.prototype.delete = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap.prototype.clear = function () {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap;
            }());
            function CreateUniqueKey() {
                var key;
                do
                    key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create)
                        return undefined;
                    Object.defineProperty(target, rootKey, { value: HashMap.create() });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for (var i = 0; i < size; ++i)
                    buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined")
                        return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined")
                        return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for (var offset = 0; offset < UUID_SIZE; ++offset) {
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8)
                        result += "-";
                    if (byte < 16)
                        result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})(Reflect || (Reflect = {}));


/***/ }),

/***/ 45433:
/***/ (function(module) {

var characterMap = {
	"À": "A",
	"Á": "A",
	"Â": "A",
	"Ã": "A",
	"Ä": "A",
	"Å": "A",
	"Ấ": "A",
	"Ắ": "A",
	"Ẳ": "A",
	"Ẵ": "A",
	"Ặ": "A",
	"Æ": "AE",
	"Ầ": "A",
	"Ằ": "A",
	"Ȃ": "A",
	"Ç": "C",
	"Ḉ": "C",
	"È": "E",
	"É": "E",
	"Ê": "E",
	"Ë": "E",
	"Ế": "E",
	"Ḗ": "E",
	"Ề": "E",
	"Ḕ": "E",
	"Ḝ": "E",
	"Ȇ": "E",
	"Ì": "I",
	"Í": "I",
	"Î": "I",
	"Ï": "I",
	"Ḯ": "I",
	"Ȋ": "I",
	"Ð": "D",
	"Ñ": "N",
	"Ò": "O",
	"Ó": "O",
	"Ô": "O",
	"Õ": "O",
	"Ö": "O",
	"Ø": "O",
	"Ố": "O",
	"Ṍ": "O",
	"Ṓ": "O",
	"Ȏ": "O",
	"Ù": "U",
	"Ú": "U",
	"Û": "U",
	"Ü": "U",
	"Ý": "Y",
	"à": "a",
	"á": "a",
	"â": "a",
	"ã": "a",
	"ä": "a",
	"å": "a",
	"ấ": "a",
	"ắ": "a",
	"ẳ": "a",
	"ẵ": "a",
	"ặ": "a",
	"æ": "ae",
	"ầ": "a",
	"ằ": "a",
	"ȃ": "a",
	"ç": "c",
	"ḉ": "c",
	"è": "e",
	"é": "e",
	"ê": "e",
	"ë": "e",
	"ế": "e",
	"ḗ": "e",
	"ề": "e",
	"ḕ": "e",
	"ḝ": "e",
	"ȇ": "e",
	"ì": "i",
	"í": "i",
	"î": "i",
	"ï": "i",
	"ḯ": "i",
	"ȋ": "i",
	"ð": "d",
	"ñ": "n",
	"ò": "o",
	"ó": "o",
	"ô": "o",
	"õ": "o",
	"ö": "o",
	"ø": "o",
	"ố": "o",
	"ṍ": "o",
	"ṓ": "o",
	"ȏ": "o",
	"ù": "u",
	"ú": "u",
	"û": "u",
	"ü": "u",
	"ý": "y",
	"ÿ": "y",
	"Ā": "A",
	"ā": "a",
	"Ă": "A",
	"ă": "a",
	"Ą": "A",
	"ą": "a",
	"Ć": "C",
	"ć": "c",
	"Ĉ": "C",
	"ĉ": "c",
	"Ċ": "C",
	"ċ": "c",
	"Č": "C",
	"č": "c",
	"C̆": "C",
	"c̆": "c",
	"Ď": "D",
	"ď": "d",
	"Đ": "D",
	"đ": "d",
	"Ē": "E",
	"ē": "e",
	"Ĕ": "E",
	"ĕ": "e",
	"Ė": "E",
	"ė": "e",
	"Ę": "E",
	"ę": "e",
	"Ě": "E",
	"ě": "e",
	"Ĝ": "G",
	"Ǵ": "G",
	"ĝ": "g",
	"ǵ": "g",
	"Ğ": "G",
	"ğ": "g",
	"Ġ": "G",
	"ġ": "g",
	"Ģ": "G",
	"ģ": "g",
	"Ĥ": "H",
	"ĥ": "h",
	"Ħ": "H",
	"ħ": "h",
	"Ḫ": "H",
	"ḫ": "h",
	"Ĩ": "I",
	"ĩ": "i",
	"Ī": "I",
	"ī": "i",
	"Ĭ": "I",
	"ĭ": "i",
	"Į": "I",
	"į": "i",
	"İ": "I",
	"ı": "i",
	"Ĳ": "IJ",
	"ĳ": "ij",
	"Ĵ": "J",
	"ĵ": "j",
	"Ķ": "K",
	"ķ": "k",
	"Ḱ": "K",
	"ḱ": "k",
	"K̆": "K",
	"k̆": "k",
	"Ĺ": "L",
	"ĺ": "l",
	"Ļ": "L",
	"ļ": "l",
	"Ľ": "L",
	"ľ": "l",
	"Ŀ": "L",
	"ŀ": "l",
	"Ł": "l",
	"ł": "l",
	"Ḿ": "M",
	"ḿ": "m",
	"M̆": "M",
	"m̆": "m",
	"Ń": "N",
	"ń": "n",
	"Ņ": "N",
	"ņ": "n",
	"Ň": "N",
	"ň": "n",
	"ŉ": "n",
	"N̆": "N",
	"n̆": "n",
	"Ō": "O",
	"ō": "o",
	"Ŏ": "O",
	"ŏ": "o",
	"Ő": "O",
	"ő": "o",
	"Œ": "OE",
	"œ": "oe",
	"P̆": "P",
	"p̆": "p",
	"Ŕ": "R",
	"ŕ": "r",
	"Ŗ": "R",
	"ŗ": "r",
	"Ř": "R",
	"ř": "r",
	"R̆": "R",
	"r̆": "r",
	"Ȓ": "R",
	"ȓ": "r",
	"Ś": "S",
	"ś": "s",
	"Ŝ": "S",
	"ŝ": "s",
	"Ş": "S",
	"Ș": "S",
	"ș": "s",
	"ş": "s",
	"Š": "S",
	"š": "s",
	"Ţ": "T",
	"ţ": "t",
	"ț": "t",
	"Ț": "T",
	"Ť": "T",
	"ť": "t",
	"Ŧ": "T",
	"ŧ": "t",
	"T̆": "T",
	"t̆": "t",
	"Ũ": "U",
	"ũ": "u",
	"Ū": "U",
	"ū": "u",
	"Ŭ": "U",
	"ŭ": "u",
	"Ů": "U",
	"ů": "u",
	"Ű": "U",
	"ű": "u",
	"Ų": "U",
	"ų": "u",
	"Ȗ": "U",
	"ȗ": "u",
	"V̆": "V",
	"v̆": "v",
	"Ŵ": "W",
	"ŵ": "w",
	"Ẃ": "W",
	"ẃ": "w",
	"X̆": "X",
	"x̆": "x",
	"Ŷ": "Y",
	"ŷ": "y",
	"Ÿ": "Y",
	"Y̆": "Y",
	"y̆": "y",
	"Ź": "Z",
	"ź": "z",
	"Ż": "Z",
	"ż": "z",
	"Ž": "Z",
	"ž": "z",
	"ſ": "s",
	"ƒ": "f",
	"Ơ": "O",
	"ơ": "o",
	"Ư": "U",
	"ư": "u",
	"Ǎ": "A",
	"ǎ": "a",
	"Ǐ": "I",
	"ǐ": "i",
	"Ǒ": "O",
	"ǒ": "o",
	"Ǔ": "U",
	"ǔ": "u",
	"Ǖ": "U",
	"ǖ": "u",
	"Ǘ": "U",
	"ǘ": "u",
	"Ǚ": "U",
	"ǚ": "u",
	"Ǜ": "U",
	"ǜ": "u",
	"Ứ": "U",
	"ứ": "u",
	"Ṹ": "U",
	"ṹ": "u",
	"Ǻ": "A",
	"ǻ": "a",
	"Ǽ": "AE",
	"ǽ": "ae",
	"Ǿ": "O",
	"ǿ": "o",
	"Þ": "TH",
	"þ": "th",
	"Ṕ": "P",
	"ṕ": "p",
	"Ṥ": "S",
	"ṥ": "s",
	"X́": "X",
	"x́": "x",
	"Ѓ": "Г",
	"ѓ": "г",
	"Ќ": "К",
	"ќ": "к",
	"A̋": "A",
	"a̋": "a",
	"E̋": "E",
	"e̋": "e",
	"I̋": "I",
	"i̋": "i",
	"Ǹ": "N",
	"ǹ": "n",
	"Ồ": "O",
	"ồ": "o",
	"Ṑ": "O",
	"ṑ": "o",
	"Ừ": "U",
	"ừ": "u",
	"Ẁ": "W",
	"ẁ": "w",
	"Ỳ": "Y",
	"ỳ": "y",
	"Ȁ": "A",
	"ȁ": "a",
	"Ȅ": "E",
	"ȅ": "e",
	"Ȉ": "I",
	"ȉ": "i",
	"Ȍ": "O",
	"ȍ": "o",
	"Ȑ": "R",
	"ȑ": "r",
	"Ȕ": "U",
	"ȕ": "u",
	"B̌": "B",
	"b̌": "b",
	"Č̣": "C",
	"č̣": "c",
	"Ê̌": "E",
	"ê̌": "e",
	"F̌": "F",
	"f̌": "f",
	"Ǧ": "G",
	"ǧ": "g",
	"Ȟ": "H",
	"ȟ": "h",
	"J̌": "J",
	"ǰ": "j",
	"Ǩ": "K",
	"ǩ": "k",
	"M̌": "M",
	"m̌": "m",
	"P̌": "P",
	"p̌": "p",
	"Q̌": "Q",
	"q̌": "q",
	"Ř̩": "R",
	"ř̩": "r",
	"Ṧ": "S",
	"ṧ": "s",
	"V̌": "V",
	"v̌": "v",
	"W̌": "W",
	"w̌": "w",
	"X̌": "X",
	"x̌": "x",
	"Y̌": "Y",
	"y̌": "y",
	"A̧": "A",
	"a̧": "a",
	"B̧": "B",
	"b̧": "b",
	"Ḑ": "D",
	"ḑ": "d",
	"Ȩ": "E",
	"ȩ": "e",
	"Ɛ̧": "E",
	"ɛ̧": "e",
	"Ḩ": "H",
	"ḩ": "h",
	"I̧": "I",
	"i̧": "i",
	"Ɨ̧": "I",
	"ɨ̧": "i",
	"M̧": "M",
	"m̧": "m",
	"O̧": "O",
	"o̧": "o",
	"Q̧": "Q",
	"q̧": "q",
	"U̧": "U",
	"u̧": "u",
	"X̧": "X",
	"x̧": "x",
	"Z̧": "Z",
	"z̧": "z",
};

var chars = Object.keys(characterMap).join('|');
var allAccents = new RegExp(chars, 'g');
var firstAccent = new RegExp(chars, '');

var removeAccents = function(string) {	
	return string.replace(allAccents, function(match) {
		return characterMap[match];
	});
};

var hasAccents = function(string) {
	return !!string.match(firstAccent);
};

module.exports = removeAccents;
module.exports.has = hasAccents;
module.exports.remove = removeAccents;


/***/ }),

/***/ 88665:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 2374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ Fe; },
  "vJ": function() { return /* binding */ We; },
  "iv": function() { return /* binding */ Ce; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; },
  "F4": function() { return /* binding */ Ue; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, __PRIVATE__, isStyledComponent, useTheme, version, withTheme

// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(48570);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(88665);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

// EXTERNAL MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitless_browser_esm = __webpack_require__(31938);
// EXTERNAL MODULE: ../../node_modules/@emotion/memoize/dist/emotion-memoize.browser.esm.js
var emotion_memoize_browser_esm = __webpack_require__(33343);
;// CONCATENATED MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_browser_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_browser_esm = (isPropValid);

// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(34406);
function v(){return(v=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var g=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},S=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},w=Object.freeze([]),E=Object.freeze({});function b(e){return"function"==typeof e}function _(e){return false||e.displayName||e.name||"Component"}function N(e){return e&&"string"==typeof e.styledComponentId}var A="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="5.3.10",I="undefined"!=typeof window&&"HTMLElement"in window,P=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),O={},R= false?0:{};function D(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function j(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var T=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&j(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),x=new Map,k=new Map,V=1,B=function(e){if(x.has(e))return x.get(e);for(;k.has(V);)V++;var t=V++;return false&&0,x.set(e,t),k.set(t,e),t},z=function(e){return k.get(e)},M=function(e,t){t>=V&&(V=t+1),x.set(e,t),k.set(t,e)},G="style["+A+'][data-styled-version="5.3.10"]',L=new RegExp("^"+A+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),F=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},Y=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(L);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(M(u,c),F(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},q=function(){return true?__webpack_require__.nc:0},H=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(A))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(A,"active"),r.setAttribute("data-styled-version","5.3.10");var i=q();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},$=function(){function e(e){var t=this.element=H(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}j(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),W=function(){function e(e){var t=this.element=H(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),U=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),J=I,X={isServer:!I,useCSSOMInjection:!P},Z=function(){function e(e,t,n){void 0===e&&(e=E),void 0===t&&(t={}),this.options=v({},X,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&I&&J&&(J=!1,function(e){for(var t=document.querySelectorAll(G),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(A)&&(Y(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return B(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(v({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new U(o):r?new $(o):new W(o),new T(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(B(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(B(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(B(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=A+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),K=/(a)(d)/gi,Q=function(e){return String.fromCharCode(e+(e>25?39:97))};function ee(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Q(t%52)+n;return(Q(t%52)+n).replace(K,"$1-$2")}var te=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},ne=function(e){return te(5381,e)};function re(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(b(n)&&!N(n))return!1}return!0}var oe=ne("5.3.10"),se=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&re(e),this.componentId=t,this.baseHash=te(oe,t),this.baseStyle=n,Z.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=Ne(this.rules,e,t,n).join(""),i=ee(te(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=te(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=Ne(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=te(u,f+d),l+=f}}if(l){var m=ee(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),ie=/^\s*\/\/.*$/gm,ae=[":","[",".","#"];function ce(e){var t,n,r,o,s=void 0===e?E:e,i=s.options,a=void 0===i?E:i,c=s.plugins,u=void 0===c?w:c,l=new stylis_browser_esm(a),d=[],h=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ae.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(ie,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},h,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||j(15),te(e,t.name)}),5381).toString():"",m}var ue=react.createContext(),le=ue.Consumer,de=react.createContext(),he=(de.Consumer,new Z),pe=ce();function fe(){return (0,react.useContext)(ue)||he}function me(){return (0,react.useContext)(de)||pe}function ye(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=fe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ce({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ue.Provider,{value:u},react.createElement(de.Provider,{value:l}, false?0:e.children))}var ve=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=pe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return j(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=pe),this.name+e.hash},e}(),ge=/([A-Z])/,Se=/([A-Z])/g,we=/^ms-/,Ee=function(e){return"-"+e.toLowerCase()};function be(e){return ge.test(e)?e.replace(Se,Ee).replace(we,"-ms-"):e}var _e=function(e){return null==e||!1===e||""===e};function Ne(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=Ne(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(_e(e))return"";if(N(e))return"."+e.styledComponentId;if(b(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,Ne(u,n,r,o)}var l;return e instanceof ve?r?(e.inject(r,o),e.getName(o)):e:S(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!_e(t[i])&&(Array.isArray(t[i])&&t[i].isCss||b(t[i])?s.push(be(i)+":",t[i],";"):S(t[i])?s.push.apply(s,e(t[i],i)):s.push(be(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm/* default */.Z||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ae=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ce(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return b(e)||S(e)?Ae(Ne(g(w,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ae(Ne(g(e,n)))}var Ie=/invalid hook call/i,Pe=new Set,Oe=function(e,t){if(false){ var o, n, r; }},Re=function(e,t,n){return void 0===n&&(n=E),e.theme!==n.theme&&e.theme||t||n.theme},De=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,je=/(^-|-$)/g;function Te(e){return e.replace(De,"-").replace(je,"")}var xe=function(e){return ee(ne(e)>>>0)};function ke(e){return"string"==typeof e&&( true||0)}var Ve=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Be=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];Ve(t)&&Ve(r)?Me(r,t):e[n]=t}function Me(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(Ve(i))for(var a in i)Be(a)&&ze(e,i[a],a)}return e}var Ge=react.createContext(),Le=Ge.Consumer;function Fe(e){var t=(0,react.useContext)(Ge),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return j(14);if(b(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?j(8):t?v({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Ge.Provider,{value:n},e.children):null}var Ye={};function qe(e,t,n){var o=N(e),i=!ke(e),a=t.attrs,c=void 0===a?w:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":Te(e);Ye[n]=(Ye[n]||0)+1;var r=n+"-"+xe("5.3.10"+n+Ye[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,f=void 0===p?function(e){return ke(e)?"styled."+e:"Styled("+_(e)+")"}(e):p,g=t.displayName&&t.componentId?Te(t.displayName)+"-"+t.componentId:t.componentId||h,S=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new se(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target; false&&0;var f=function(e,t,n){void 0===e&&(e=E);var r=v({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in b(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Re(t,(0,react.useContext)(Ge),a)||E,t,o),y=f[0],g=f[1],S=function(e,t,n,r){var o=fe(),s=me(),i=t?e.generateAndInjectStyles(E,o,s):e.generateAndInjectStyles(n,o,s);return false&&0, false&&0,i}(i,r,y, false?0:void 0),w=n,_=g.$as||t.$as||g.as||t.as||p,N=ke(_),A=g!==t?v({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,emotion_is_prop_valid_browser_esm,_):!N||emotion_is_prop_valid_browser_esm(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=v({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=w,(0,react.createElement)(_,C)}(C,e,t,P)};return O.displayName=f,(C=react.forwardRef(O)).attrs=S,C.componentStyle=I,C.displayName=f,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):w,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(ke(e)?e:Te(_(e)));return qe(e,v({},o,{attrs:S,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Me({},e.defaultProps,t):t}}), false&&(0),Object.defineProperty(C,"toString",{value:function(){return"."+C.styledComponentId}}),i&&hoist_non_react_statics_cjs_default()(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var He=function(e){return function e(t,r,o){if(void 0===o&&(o=E),!(0,react_is.isValidElementType)(r))return j(1,String(r));var s=function(){return t(r,o,Ce.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,v({},o,{},n))},s.attrs=function(n){return e(t,r,v({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(qe,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){He[e]=He(e)}));var $e=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=re(e),Z.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(Ne(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&Z.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function We(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ce.apply(void 0,[e].concat(n)),a="sc-global-"+xe(JSON.stringify(i)),u=new $e(i,a);function l(e){var t=fe(),n=me(),o=(0,react.useContext)(Ge),l=(0,react.useRef)(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(l,e,t,o,n),(0,react.useLayoutEffect)((function(){if(!t.server)return h(l,e,t,o,n),function(){return u.removeStyles(l,t)}}),[l,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,O,n,o);else{var s=v({},t,{theme:Re(t,r,l.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,react.memo(l)}function Ue(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ce.apply(void 0,[e].concat(n)).join(""),s=xe(o);return new ve(s,o)}var Je=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=q();return"<style "+[n&&'nonce="'+n+'"',A+'="true"','data-styled-version="5.3.10"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?j(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return j(2);var n=((t={})[A]="",t["data-styled-version"]="5.3.10",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=q();return o&&(n.nonce=o),[react.createElement("style",v({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new Z({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?j(2):react.createElement(ye,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return j(3)},e}(),Xe=function(e){var t=r.forwardRef((function(t,n){var o=s(Ge),i=e.defaultProps,a=Re(t,o,i);return false&&0,r.createElement(e,v({},t,{theme:a,ref:n}))}));return y(t,e),t.displayName="WithTheme("+_(e)+")",t},Ze=function(){return s(Ge)},Ke={StyleSheet:Z,masterSheet:he}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (He);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 24694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ OBJECT; },
/* harmony export */   "BN": function() { return /* binding */ internalMutate; },
/* harmony export */   "DY": function() { return /* binding */ SWRGlobalState; },
/* harmony export */   "Iy": function() { return /* binding */ useStateWithDeps; },
/* harmony export */   "J$": function() { return /* binding */ SWRConfig; },
/* harmony export */   "JG": function() { return /* binding */ mutate; },
/* harmony export */   "JN": function() { return /* binding */ createCacheHelper; },
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "PM": function() { return /* binding */ mergeObjects; },
/* harmony export */   "W6": function() { return /* binding */ IS_SERVER; },
/* harmony export */   "i_": function() { return /* binding */ UNDEFINED; },
/* harmony export */   "kY": function() { return /* binding */ useSWRConfig; },
/* harmony export */   "ko": function() { return /* binding */ subscribeCallback; },
/* harmony export */   "kw": function() { return /* binding */ rAF; },
/* harmony export */   "mf": function() { return /* binding */ isFunction; },
/* harmony export */   "o8": function() { return /* binding */ isUndefined; },
/* harmony export */   "qC": function() { return /* binding */ serialize; },
/* harmony export */   "s6": function() { return /* binding */ withArgs; },
/* harmony export */   "sj": function() { return /* binding */ constants; },
/* harmony export */   "u3": function() { return /* binding */ getTimestamp; },
/* harmony export */   "u_": function() { return /* binding */ defaultConfig; },
/* harmony export */   "w6": function() { return /* binding */ IS_REACT_LEGACY; },
/* harmony export */   "xD": function() { return /* binding */ withMiddleware; }
/* harmony export */ });
/* unused harmony exports cache, compare, defaultConfigOptions, hasRequestAnimationFrame, initCache, isDocumentDefined, isWindowDefined, mergeConfigs, noop, normalize, preload, preset, slowConnection, stableHash */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


// Global state used to deduplicate requests and store listeners
const SWRGlobalState = new WeakMap();

const EMPTY_CACHE = {};
const INITIAL_CACHE = {};
const noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const UNDEFINED = /*#__NOINLINE__*/ noop();
const OBJECT = Object;
const isUndefined = (v)=>v === UNDEFINED;
const isFunction = (v)=>typeof v == 'function';
const mergeObjects = (a, b)=>({
        ...a,
        ...b
    });
const STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const isWindowDefined = typeof window != STR_UNDEFINED;
const isDocumentDefined = typeof document != STR_UNDEFINED;
const hasRequestAnimationFrame = ()=>isWindowDefined && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
const createCacheHelper = (cache, key)=>{
    const state = SWRGlobalState.get(cache);
    return [
        // Getter
        ()=>cache.get(key) || EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!isUndefined(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in INITIAL_CACHE)) {
                    INITIAL_CACHE[key] = prev;
                }
                state[5](key, mergeObjects(prev, info), prev || EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!isUndefined(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in INITIAL_CACHE) return INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return cache.get(key) || EMPTY_CACHE;
        }
    ];
};

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const table = new WeakMap();
// counter of the key
let counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const stableHash = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++){
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            const keys = OBJECT.keys(arg).sort();
            while(!isUndefined(index = keys.pop())){
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    } else {
        result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    }
    return result;
};

/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let online = true;
const isOnline = ()=>online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [onWindowEvent, offWindowEvent] = isWindowDefined && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    noop,
    noop
];
const isVisible = ()=>{
    const visibilityState = isDocumentDefined && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
const initFocus = (callback)=>{
    // focus revalidate
    if (isDocumentDefined) {
        document.addEventListener('visibilitychange', callback);
    }
    onWindowEvent('focus', callback);
    return ()=>{
        if (isDocumentDefined) {
            document.removeEventListener('visibilitychange', callback);
        }
        offWindowEvent('focus', callback);
    };
};
const initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return ()=>{
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
const preset = {
    isOnline,
    isVisible
};
const defaultConfigOptions = {
    initFocus,
    initReconnect
};

const IS_REACT_LEGACY = !react__WEBPACK_IMPORTED_MODULE_0__.useId;
const IS_SERVER = !isWindowDefined || 'Deno' in window;
// Polyfill requestAnimationFrame
const rAF = (f)=>hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const useIsomorphicLayoutEffect = IS_SERVER ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
const navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const slowConnection = !IS_SERVER && navigatorConnection && ([
    'slow-2g',
    '2g'
].includes(navigatorConnection.effectiveType) || navigatorConnection.saveData);

const serialize = (key)=>{
    if (isFunction(key)) {
        try {
            key = key();
        } catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? stableHash(key) : '';
    return [
        key,
        args
    ];
};

// Global timestamp.
let __timestamp = 0;
const getTimestamp = ()=>++__timestamp;

const FOCUS_EVENT = 0;
const RECONNECT_EVENT = 1;
const MUTATE_EVENT = 2;

var constants = {
  __proto__: null,
  FOCUS_EVENT: FOCUS_EVENT,
  RECONNECT_EVENT: RECONNECT_EVENT,
  MUTATE_EVENT: MUTATE_EVENT
};

async function internalMutate(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = mergeObjects({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const revalidate = options.revalidate !== false;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if (isFunction(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for(let keyIt = it.next(); !keyIt.done; keyIt = it.next()){
            const key = keyIt.value;
            if (// Skip the special useSWRInfinite keys.
            !key.startsWith('$inf$') && keyFilter(cache.get(key)._k)) {
                matchedKeys.push(key);
            }
        }
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = serialize(_k);
        if (!key) return;
        const [get, set] = createCacheHelper(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH] = SWRGlobalState.get(cache);
        const revalidators = EVENT_REVALIDATORS[key];
        const startRevalidate = ()=>{
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                if (revalidators && revalidators[0]) {
                    return revalidators[0](MUTATE_EVENT).then(()=>get().data);
                }
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) {
            // Revalidate and broadcast state.
            return startRevalidate();
        }
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = getTimestamp();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !isUndefined(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = isUndefined(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = isFunction(optimisticData) ? optimisticData(committedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if (isFunction(data)) {
            // `data` is a function, call it passing current cache value.
            try {
                data = data(committedData);
            } catch (err) {
                // If it throws an error synchronously, we shouldn't update the cache.
                error = err;
            }
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && isFunction(data.then)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                data = committedData;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data,
                    _c: UNDEFINED
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if (isFunction(populateCache)) {
                    data = populateCache(data, committedData);
                }
                // Only update cached data if there's no error. Data can be `undefined` here.
                set({
                    data,
                    _c: UNDEFINED
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = getTimestamp();
        // Update existing SWR Hooks' internal states:
        const res = await startRevalidate();
        // The mutation and revalidation are ended, we can clear it since the data is
        // not an optimistic value anymore.
        set({
            _c: UNDEFINED
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return populateCache ? res : data;
    }
}

const revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators){
        if (revalidators[key][0]) revalidators[key][0](type);
    }
};
const initCache = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        const opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = internalMutate.bind(UNDEFINED, provider);
        let unmount = noop;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) {
                for(let i = subs.length; i--;){
                    subs[i](value, prev);
                }
            }
        };
        const initProvider = ()=>{
            if (!SWRGlobalState.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                SWRGlobalState.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!IS_SERVER) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        SWRGlobalState.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        SWRGlobalState.get(provider)[4]
    ];
};

// error retry
const onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
const compare = (currentData, newData)=>stableHash(currentData) == stableHash(newData);
// Default cache provider
const [cache, mutate] = initCache(new Map());
// Default config
const defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare,
    isPaused: ()=>false,
    cache,
    mutate,
    fallback: {}
}, // use web preset by default
preset);

const mergeConfigs = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1 , fallback: f1  } = a;
        const { use: u2 , fallback: f2  } = b;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

const SWRConfigContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
const SWRConfig = (props)=>{
    const { value  } = props;
    const parentConfig = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext);
    const isFunctionalConfig = isFunction(value);
    const config = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>isFunctionalConfig ? config : mergeConfigs(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // Use a lazy initialized state to create the cache on first access.
    const [cacheContext] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>provider ? initCache(provider(extendedConfig.cache || cache), config) : UNDEFINED);
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

// @ts-expect-error
const enableDevtools = isWindowDefined && window.__SWR_DEVTOOLS_USE__;
const use = enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const setupDevTools = ()=>{
    if (enableDevtools) {
        // @ts-expect-error
        window.__SWR_DEVTOOLS_REACT__ = react__WEBPACK_IMPORTED_MODULE_0__;
    }
};

const normalize = (args)=>{
    return isFunction(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};

const useSWRConfig = ()=>{
    return mergeObjects(defaultConfig, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext));
};

const preload = (key_, fetcher)=>{
    const key = serialize(key_)[0];
    const [, , , PRELOAD] = SWRGlobalState.get(cache);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(key_);
    PRELOAD[key] = req;
    return req;
};
const middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const key = serialize(key_)[0];
            const [, , , PRELOAD] = SWRGlobalState.get(cache);
            const req = PRELOAD[key];
            if (req) {
                delete PRELOAD[key];
                return req;
            }
            return fetcher_(...args);
        });
        return useSWRNext(key_, fetcher, config);
    };

const BUILT_IN_MIDDLEWARE = use.concat(middleware);

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const withArgs = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = useSWRConfig();
        // Normalize arguments.
        const [key, fn, _config] = normalize(args);
        // Merge configurations.
        const config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use  } = config;
        const middleware = (use || []).concat(BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;){
            next = middleware[i](next);
        }
        return next(key, fn || config.fetcher || null, config);
    };
};

/**
 * An implementation of state with dependency-tracking.
 */ const useStateWithDeps = (state)=>{
    const rerender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({})[1];
    const unmountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(state);
    // If a state property (data, error, or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    const stateDependenciesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
   * @param payload To change stateRef, pass the values explicitly to setState:
   * @example
   * ```js
   * setState({
   *   isValidating: false
   *   data: newData // set data to newData
   *   error: undefined // set error to undefined
   * })
   *
   * setState({
   *   isValidating: false
   *   data: undefined // set data to undefined
   *   error: err // set error to err
   * })
   * ```
   */ const setState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((payload)=>{
        let shouldRerender = false;
        const currentState = stateRef.current;
        for(const _ in payload){
            const k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            if (IS_REACT_LEGACY) {
                rerender({});
            } else {
                react__WEBPACK_IMPORTED_MODULE_0__.startTransition(()=>rerender({}));
            }
        }
    }, // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    useIsomorphicLayoutEffect(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
        };
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const subscribeCallback = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

// Create a custom hook with a middleware
const withMiddleware = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = normalize(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};

setupDevTools();




/***/ }),

/***/ 2514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J$": function() { return /* binding */ SWRConfig; },
/* harmony export */   "JG": function() { return /* reexport safe */ swr_internal__WEBPACK_IMPORTED_MODULE_2__.JG; },
/* harmony export */   "ZP": function() { return /* binding */ useSWR; },
/* harmony export */   "kY": function() { return /* reexport safe */ swr_internal__WEBPACK_IMPORTED_MODULE_2__.kY; }
/* harmony export */ });
/* unused harmony export unstable_serialize */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43100);
/* harmony import */ var swr_internal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24694);





const WITH_DEDUPE = {
    dedupe: true
};
const useSWRHandler = (_key, fetcher, config)=>{
    const { cache , compare , suspense , fallbackData , revalidateOnMount , revalidateIfStale , refreshInterval , refreshWhenHidden , refreshWhenOffline , keepPreviousData  } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH] = swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .SWRGlobalState.get */ .DY.get(cache);
    // `key` is the identifier of the SWR `data` state, `keyInfo` holds extra
    // states such as `error` and `isValidating` inside,
    // all of them are derived from `_key`.
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    const [key, fnArg] = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .serialize */ .qC)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(key);
    const fetcherRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fetcher);
    const configRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .createCacheHelper */ .JN)(cache, key);
    const stateDependencies = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}).current;
    const fallback = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        let equal = true;
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(current[t], prev[t])) {
                    if ((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(prev[t])) {
                        if (!compare(current[t], returnedData)) {
                            equal = false;
                        }
                    } else {
                        equal = false;
                    }
                }
            } else {
                if (current[t] !== prev[t]) {
                    equal = false;
                }
            }
        }
        return equal;
    };
    const getSnapshot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .mergeObjects */ .PM)(state);
            delete snapshot._k;
            if (!shouldStartRequest) {
                return snapshot;
            }
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = getSelectedCache(getCache());
        const memorizedInitialSnapshot = getSelectedCache(getInitialCache());
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                return isEqual(newSnapshot, memorizedSnapshot) ? memorizedSnapshot : memorizedSnapshot = newSnapshot;
            },
            ()=>memorizedInitialSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0,use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_1__.useSyncExternalStore)((0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(data);
    const returnedData = keepPreviousData ? (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) {
            return false;
        }
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_REACT_LEGACY */ .w6) {
                return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            }
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) {
                delete FETCH[key];
            }
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(getCache().data)) {
            initialState.isLoading = true;
        }
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(getCache().data)) {
                    setTimeout(()=>{
                        if (loading && callbackSafeguard()) {
                            getConfig().onLoadingSlow(key, config);
                        }
                    }, config.loadingTimeout);
                }
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .getTimestamp */ .u3)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) {
                // If the request isn't interrupted, clean it up after the
                // deduplication interval.
                setTimeout(cleanupState, config.dedupingInterval);
            }
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) {
                        getConfig().onDiscarded(key);
                    }
                }
                return false;
            }
            // Clear error.
            finalState.error = swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .UNDEFINED */ .i_;
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) {
                        getConfig().onDiscarded(key);
                    }
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) {
                    getConfig().onSuccess(newData, key, config);
                }
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError  } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .mf)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (isActive()) {
                            // If it's inactive, stop. It will auto-revalidate when
                            // refocusing or reconnecting.
                            // When retrying, deduplication is always enabled.
                            currentConfig.onErrorRetry(err, key, currentConfig, revalidate, {
                                retryCount: (opts.retryCount || 0) + 1,
                                dedupe: true
                            });
                        }
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const boundMutate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(// Use callback to make sure `keyRef.current` returns latest result every time
    (...args)=>{
        return (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .internalMutate */ .BN)(cache, keyRef.current, ...args);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // The logic for updating refs.
    (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cachedData)) {
            laggyDataRef.current = cachedData;
        }
    });
    // After mounted or key changed.
    (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind(swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .UNDEFINED */ .i_, WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type)=>{
            if (type == swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .revalidateEvents.FOCUS_EVENT */ .sj.FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .revalidateEvents.RECONNECT_EVENT */ .sj.RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            } else if (type == swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .revalidateEvents.MUTATE_EVENT */ .sj.MUTATE_EVENT) {
                return revalidate();
            }
            return;
        };
        const unsubEvents = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .subscribeCallback */ .ko)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation.
        if (shouldDoInitialRevalidation) {
            if ((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) || swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6) {
                // Revalidate immediately.
                softRevalidate();
            } else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .rAF */ .kw)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .mf)(refreshInterval) ? refreshInterval(data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            } else {
                // Schedule the next interval to check again.
                next();
            }
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_REACT_LEGACY */ .w6 && swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6) {
            throw new Error('Fallback data is required when using suspense in SSR.');
        }
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const SWRConfig = swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .OBJECT.defineProperty */ .$l.defineProperty(swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .SWRConfig */ .J$, 'defaultValue', {
    value: swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .defaultConfig */ .u_
});
const unstable_serialize = (key)=>serialize(key)[0];
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (!data) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ var useSWR = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .withArgs */ .s6)(useSWRHandler);

// useSWR




/***/ }),

/***/ 20452:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(2784);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 43100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(20452);
} else {}


/***/ }),

/***/ 64896:
/***/ (function(module) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),

/***/ 66879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yd": function() { return /* reexport */ Logger; },
  "e$": function() { return /* reexport */ getErrorMessage; },
  "Sv": function() { return /* reexport */ getHttpClient; },
  "m9": function() { return /* reexport */ useCopyToClipboard; },
  "xF": function() { return /* reexport */ useFormOnKeyDownAvoidEnter; },
  "_": function() { return /* reexport */ useLocalStorage; },
  "Db": function() { return /* reexport */ useMutation; },
  "aM": function() { return /* reexport */ useQuery; }
});

// UNUSED EXPORTS: HttpError, getErrorName, logError, useEnterKeyFormSubmit, useOnEscKey, useSessionStorage

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useCopyToClipboard/useCopyToClipboard.js

function useCopyToClipboard() {
    const [copiedText, setCopiedText] = (0,react.useState)(null);
    const copy = async (text) => {
        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
            return false;
        }
        // Try to save to clipboard then save it in the state if worked
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        }
        catch (error) {
            console.warn('Copy failed', error);
            setCopiedText(null);
            return false;
        }
    };
    return [copiedText, copy];
}
/* harmony default export */ var useCopyToClipboard_useCopyToClipboard = ((/* unused pure expression or super */ null && (useCopyToClipboard)));
//# sourceMappingURL=useCopyToClipboard.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useCopyToClipboard/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useEnterKeyFormSubmit/useEnterKeyFormSubmit.js

const useEnterKeyFormSubmit = () => {
    const submitButtonRef = useRef(null);
    return {
        submitButtonRef,
        onKeyDownHandler: (event) => {
            if (event.key === 'Enter' && !event.shiftKey && submitButtonRef.current) {
                event.preventDefault();
                submitButtonRef.current.click();
            }
        }
    };
};
//# sourceMappingURL=useEnterKeyFormSubmit.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useEnterKeyFormSubmit/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useFormOnKeyDownAvoidEnter/useFormOnKeyDownAvoidEnter.js
const useFormOnKeyDownAvoidEnter = () => {
    return [
        (e) => {
            // @ts-expect-error `type` indeed exists in `target`
            if (e.key === 'Enter' && e.target.type !== 'textarea') {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    ];
};
//# sourceMappingURL=useFormOnKeyDownAvoidEnter.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useFormOnKeyDownAvoidEnter/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useLocalStorage/useLocalStorage.js

// Custom hook.
// -----------------------------------------------------------------------------
const useLocalStorage = (key, initialValue) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [data, setData] = (0,react.useState)(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            return initialValue;
        }
    });
    (0,react.useEffect)(() => {
        try {
            const item = window.localStorage.getItem(key);
            setData(item ? JSON.parse(item) : initialValue);
        }
        catch (error) {
            setData(initialValue);
        }
    }, [initialValue, key]);
    // Helpers
    // ---------------------------------------------------------------------------
    const setValue = (0,react.useCallback)((value) => {
        try {
            const dataToStore = value instanceof Function ? value(data) : value;
            setData(dataToStore);
            if (typeof window !== 'undefined') {
                window.localStorage.setItem(key, JSON.stringify(dataToStore));
            }
        }
        catch (error) {
            console.log(error);
        }
    }, [data, key]);
    return [data, setValue];
};
//# sourceMappingURL=useLocalStorage.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useLocalStorage/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../node_modules/swr/core/dist/index.esm.js
var index_esm = __webpack_require__(2514);
// EXTERNAL MODULE: ../../node_modules/swr/_internal/dist/index.esm.js
var dist_index_esm = __webpack_require__(24694);
;// CONCATENATED MODULE: ../../node_modules/swr/mutation/dist/index.esm.js




const mutation = ()=>{
    return (key, fetcher, config = {})=>{
        const { mutate  } = (0,index_esm/* useSWRConfig */.kY)();
        const keyRef = (0,react.useRef)(key);
        const fetcherRef = (0,react.useRef)(fetcher);
        // Ditch all mutation results that happened earlier than this timestamp.
        const ditchMutationsUntilRef = (0,react.useRef)(0);
        const [stateRef, stateDependencies, setState] = (0,dist_index_esm/* useStateWithDeps */.Iy)({
            data: dist_index_esm/* UNDEFINED */.i_,
            error: dist_index_esm/* UNDEFINED */.i_,
            isMutating: false
        });
        const currentState = stateRef.current;
        const trigger = (0,react.useCallback)(async (arg, opts)=>{
            const [serializedKey, resolvedKey] = (0,dist_index_esm/* serialize */.qC)(keyRef.current);
            if (!fetcherRef.current) {
                throw new Error('Can’t trigger the mutation: missing fetcher.');
            }
            if (!serializedKey) {
                throw new Error('Can’t trigger the mutation: missing key.');
            }
            // Disable cache population by default.
            const options = (0,dist_index_esm/* mergeObjects */.PM)((0,dist_index_esm/* mergeObjects */.PM)({
                populateCache: false,
                throwOnError: true
            }, config), opts);
            // Trigger a mutation, and also track the timestamp. Any mutation that happened
            // earlier this timestamp should be ignored.
            const mutationStartedAt = (0,dist_index_esm/* getTimestamp */.u3)();
            ditchMutationsUntilRef.current = mutationStartedAt;
            setState({
                isMutating: true
            });
            try {
                const data = await mutate(serializedKey, fetcherRef.current(resolvedKey, {
                    arg
                }), // We must throw the error here so we can catch and update the states.
                (0,dist_index_esm/* mergeObjects */.PM)(options, {
                    throwOnError: true
                }));
                // If it's reset after the mutation, we don't broadcast any state change.
                if (ditchMutationsUntilRef.current <= mutationStartedAt) {
                    setState({
                        data,
                        isMutating: false,
                        error: undefined
                    });
                    options.onSuccess == null ? void 0 : options.onSuccess(data, serializedKey, options);
                }
                return data;
            } catch (error) {
                // If it's reset after the mutation, we don't broadcast any state change
                // or throw because it's discarded.
                if (ditchMutationsUntilRef.current <= mutationStartedAt) {
                    setState({
                        error: error,
                        isMutating: false
                    });
                    options.onError == null ? void 0 : options.onError(error, serializedKey, options);
                    if (options.throwOnError) {
                        throw error;
                    }
                }
            }
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        const reset = (0,react.useCallback)(()=>{
            ditchMutationsUntilRef.current = (0,dist_index_esm/* getTimestamp */.u3)();
            setState({
                data: dist_index_esm/* UNDEFINED */.i_,
                error: dist_index_esm/* UNDEFINED */.i_,
                isMutating: false
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        (0,dist_index_esm/* useIsomorphicLayoutEffect */.LI)(()=>{
            keyRef.current = key;
            fetcherRef.current = fetcher;
        });
        // We don't return `mutate` here as it can be pretty confusing (e.g. people
        // calling `mutate` but they actually mean `trigger`).
        // And also, `mutate` relies on the useSWR hook to exist too.
        return {
            trigger,
            reset,
            get data () {
                stateDependencies.data = true;
                return currentState.data;
            },
            get error () {
                stateDependencies.error = true;
                return currentState.error;
            },
            get isMutating () {
                stateDependencies.isMutating = true;
                return currentState.isMutating;
            }
        };
    };
};
/**
 * A hook to define and manually trigger remote mutations like POST, PUT, DELETE and PATCH use cases.
 *
 * @link https://swr.vercel.app/docs/mutation
 * @example
 * ```jsx
 * import useSWRMutation from 'swr/mutation'
 *
 * const {
 *   data,
 *   error,
 *   trigger,
 *   reset,
 *   isMutating
 * } = useSWRMutation(key, fetcher, options?)
 * ```
 */ var index = (0,dist_index_esm/* withMiddleware */.xD)(index_esm/* default */.ZP, mutation);



;// CONCATENATED MODULE: ../ui-common/dist/hooks/useMutation/useMutation.js


const useMutation = (key, promise) => {
    const { mutate } = (0,index_esm/* useSWRConfig */.kY)();
    const { trigger: SWRTrigger, isMutating } = index(key, async (_, { arg }) => {
        return promise(arg);
    });
    return {
        isMutating,
        trigger: (arg, opts) => {
            // TODO: watch SWR updates to see if types are fixed
            const data = SWRTrigger(arg, {
                populateCache: (opts === null || opts === void 0 ? void 0 : opts.populateCache)
                    ? (result, currentData) => { var _a; return (_a = opts.populateCache) === null || _a === void 0 ? void 0 : _a.call(opts, result, currentData); }
                    : undefined,
                revalidate: !(opts === null || opts === void 0 ? void 0 : opts.populateCache),
                throwOnError: !(opts === null || opts === void 0 ? void 0 : opts.onError),
                onSuccess: (data) => {
                    var _a, _b;
                    (_a = opts === null || opts === void 0 ? void 0 : opts.onSuccess) === null || _a === void 0 ? void 0 : _a.call(opts, data);
                    (_b = opts === null || opts === void 0 ? void 0 : opts.finally) === null || _b === void 0 ? void 0 : _b.call(opts);
                },
                onError: (error) => {
                    var _a, _b;
                    (_a = opts === null || opts === void 0 ? void 0 : opts.onError) === null || _a === void 0 ? void 0 : _a.call(opts, error);
                    (_b = opts === null || opts === void 0 ? void 0 : opts.finally) === null || _b === void 0 ? void 0 : _b.call(opts);
                }
            });
            // Revalidate specified keys
            if ((opts === null || opts === void 0 ? void 0 : opts.revalidateKeys) && opts.revalidateKeys.length > 0) {
                mutate((key) => { var _a; return typeof key === 'string' && ((_a = opts.revalidateKeys) === null || _a === void 0 ? void 0 : _a.includes(key)); }, undefined, { revalidate: true });
            }
            return data;
        }
    };
};
//# sourceMappingURL=useMutation.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useMutation/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useOnEscKey/useOnEscKey.js
// Custom hook.

// -----------------------------------------------------------------------------
const useOnEscKey = (callback) => {
    // Effect
    // ---------------------------------------------------------------------------
    useEffect(() => {
        const handleOnEsc = (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                callback();
            }
        };
        document.addEventListener('keydown', handleOnEsc);
        return () => {
            document.removeEventListener('keydown', handleOnEsc);
        };
    }, [callback]);
};
//# sourceMappingURL=useOnEscKey.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useOnEscKey/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useQuery/useQuery.js

const useQuery = (key, promise, opts = {}) => {
    const { fallback } = (0,index_esm/* useSWRConfig */.kY)();
    const { data, error, isLoading } = (0,index_esm/* default */.ZP)(opts.avoidFetch ? null : key, promise, {
        fallback: {
            [`${key}`]: key && fallback && fallback[key] ? fallback[key] : null
        },
        focusThrottleInterval: 30 * 1000,
        onSuccess: (data) => {
            if (opts === null || opts === void 0 ? void 0 : opts.onSuccess) {
                opts === null || opts === void 0 ? void 0 : opts.onSuccess(data);
            }
        },
        onError: (error) => {
            if (opts === null || opts === void 0 ? void 0 : opts.onError) {
                opts === null || opts === void 0 ? void 0 : opts.onError(error);
            }
        }
    });
    return {
        data,
        error,
        isLoading
    };
};
//# sourceMappingURL=useQuery.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useQuery/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useSessionStorage/useSessionStorage.js

// Custom hook.
// -----------------------------------------------------------------------------
const useSessionStorage = (key, initialValue) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [data, setData] = useState(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            return initialValue;
        }
    });
    useEffect(() => {
        try {
            const item = window.sessionStorage.getItem(key);
            setData(item ? JSON.parse(item) : initialValue);
        }
        catch (error) {
            setData(initialValue);
        }
    }, [initialValue, key]);
    // Helpers
    // ---------------------------------------------------------------------------
    const setValue = useCallback((value) => {
        try {
            const dataToStore = value instanceof Function ? value(data) : value;
            setData(dataToStore);
            if (typeof window !== 'undefined') {
                window.sessionStorage.setItem(key, JSON.stringify(dataToStore));
            }
        }
        catch (error) {
            console.log(error);
        }
    }, [data, key]);
    return [data, setValue];
};
//# sourceMappingURL=useSessionStorage.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/useSessionStorage/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-common/dist/hooks/index.js








//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-common/dist/models/http-error/model.http-error.js
class HttpError extends Error {
    constructor(message, status) {
        super(message); // 'Error' breaks prototype chain here
        this.name = 'HttpError';
        this.status = status;
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    }
}
//# sourceMappingURL=model.http-error.js.map
;// CONCATENATED MODULE: ../ui-common/dist/models/http-error/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-common/dist/models/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-common/dist/utils/errors/errors.js

const getErrorMessage = (error) => {
    return error instanceof HttpError
        ? error.message
        : typeof error.message === 'object'
            ? JSON.stringify(error.message)
            : error.message || error.toString();
};
const getErrorName = (error) => error.name;
//# sourceMappingURL=errors.js.map
;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(48834)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/index.js




/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
 const isStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();


/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new browser.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (browser.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/defaults/index.js










const DEFAULT_CONTENT_TYPE = {
  'Content-Type': undefined
};

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: browser.classes.FormData,
    Blob: browser.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

utils.freezeMethods(AxiosHeaders.prototype);
utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/cookies.js





/* harmony default export */ var cookies = (browser.isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })());

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var isURLSameOrigin = (browser.isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      if (browser.isStandardBrowserEnv || browser.isStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else {
        requestHeaders.setContentType('multipart/form-data;', false); // mobile/desktop app frameworks
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (browser.isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath))
        && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && browser.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

utils.forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = utils.isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new core_AxiosError(
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        utils.hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!utils.isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/env/data.js
const VERSION = "1.4.0";
;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    let contextHeaders;

    // Flatten headers
    contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    contextHeaders && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/axios.js



















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);

;// CONCATENATED MODULE: ../ui-common/dist/utils/logger/logger.js

/**
 * @deprecated Use `Logger.error` instead
 */
const logError = (args) => error(args);
const http = ({ method, path, data }) => {
    if (data) {
        console.log({
            http: { method: method, url: path },
            message: `▶️ ${method || '<NONE>'} ${path || '<NONE>'}`,
            data
        });
    }
    else {
        console.log({
            http: { method: method, url: path },
            message: `▶️ ${method || '<NONE>'} ${path || '<NONE>'}`
        });
    }
};
const log = ({ context, message, object }) => {
    if (object) {
        console.log(`[${context}] ${message}`, object);
    }
    else {
        console.log(`[${context}] ${message}`);
    }
};
const debug = ({ context, message, object }) => {
    if (object) {
        console.debug(`🔎 [${context}] ${message}`, object);
    }
    else {
        console.debug(`🔎 [${context}] ${message}`);
    }
};
const info = ({ context, message, object }) => {
    if (object) {
        console.info(`ℹ️ [${context}] ${message}`, object);
    }
    else {
        console.info(`ℹ️ [${context}] ${message}`);
    }
};
const warn = ({ context, message, object }) => {
    if (object) {
        console.warn(`🚧 [${context}] ${message}`, object);
    }
    else {
        console.warn(`🚧 [${context}] ${message}`);
    }
};
const error = ({ context, message, error, object }) => {
    if (object) {
        console.error(`🚨 [${context}] ${message}. Error: ${getErrorMessage(error)}`, error, object);
    }
    else {
        console.error(`🚨 [${context}] ${message}. Error: ${getErrorMessage(error)}`, error);
    }
};
const Logger = {
    http,
    log,
    debug,
    info,
    warn,
    error
};
//# sourceMappingURL=logger.js.map
;// CONCATENATED MODULE: ../ui-common/dist/utils/http/http.utils.js



function buildHttpHeaders(options) {
    const opts = options || {};
    const headers = Object.assign({}, opts.headers);
    if (opts.bearer) {
        headers.Authorization = `Bearer ${opts.bearer}`;
    }
    return headers;
}
// * Using "any" as return type here consciously
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function httpResponseHandler(response) {
    if (response.status < 400) {
        const data = response === null || response === void 0 ? void 0 : response.data;
        if (!data) {
            Logger.warn({
                context: '/utils/http',
                message: 'Response is empty',
                object: response
            });
            return;
        }
        return data;
    }
    throw new HttpError('[/utils/http] Invalid status code');
}
function getHttpErrorHandler(unauthorizedCallback) {
    return function httpErrorHandler(error) {
        var _a, _b;
        if (lib_axios.isAxiosError(error)) {
            const status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
            const isClientSide = typeof window !== 'undefined';
            // If unauthorized and client-side, redirect to login page
            if (status === 401 && isClientSide) {
                Logger.warn({
                    context: '/utils/http',
                    message: 'Unauthorized'
                });
                unauthorizedCallback();
                return Promise.reject();
            }
            Logger.error({
                context: 'utils/http',
                message: error.message,
                error
            });
            return Promise.reject(new HttpError(((_b = error.response) === null || _b === void 0 ? void 0 : _b.data.message) || error.message, status));
        }
        Logger.error({
            context: 'utils/http',
            message: error.message,
            error
        });
        return Promise.reject(new HttpError(error.message));
    };
}
//# sourceMappingURL=http.utils.js.map
;// CONCATENATED MODULE: ../ui-common/dist/utils/http/http.js


function getHttpClient(args) {
    var _a, _b;
    const axiosClient = lib_axios.create({
        timeout: args.timeout || 10000,
        headers: {
            'x-anonymous-id': ((_b = (_a = __webpack_require__.g.analytics) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.call(_a).anonymousId()) || ''
        }
    });
    axiosClient.interceptors.response.use(httpResponseHandler, getHttpErrorHandler(args.unauthorizedCallback));
    return {
        get: async (url, options) => {
            return await axiosClient.get(url, {
                headers: buildHttpHeaders(options)
            });
        },
        post: async (url, data, options) => {
            return await axiosClient.post(url, data, {
                headers: buildHttpHeaders(options)
            });
        },
        put: async (url, data, options) => {
            return await axiosClient.put(url, data, {
                headers: buildHttpHeaders(options)
            });
        },
        patch: async (url, data, options) => {
            return await axiosClient.patch(url, data, {
                headers: buildHttpHeaders(options)
            });
        },
        delete: async (url, options) => {
            return await axiosClient.delete(url, {
                headers: buildHttpHeaders(options)
            });
        },
        deleteWithBody: async (url, data, options) => {
            return await axiosClient.request({
                url,
                data,
                method: 'DELETE',
                headers: buildHttpHeaders(options)
            });
        }
    };
}
//# sourceMappingURL=http.js.map
;// CONCATENATED MODULE: ../ui-common/dist/utils/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-common/dist/index.js



//# sourceMappingURL=index.js.map

/***/ }),

/***/ 86111:
/***/ (function(module) {

"use strict";

module.exports = {
    "breakpoints": {
        "s": 320,
        "m": 672,
        "l": 1056,
        "xl": 1312,
        "2xl": 1584
    },
    "colorbrewer": {
        "qualitative": {
            "accent": {
                "1": {
                    "value": "#7FC97F",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#7FC97F"
                    },
                    "name": "ColorbrewerQualitativeAccent1",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "1"
                    ]
                },
                "2": {
                    "value": "#BEAED4",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#BEAED4"
                    },
                    "name": "ColorbrewerQualitativeAccent2",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "2"
                    ]
                },
                "3": {
                    "value": "#FDC086",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FDC086"
                    },
                    "name": "ColorbrewerQualitativeAccent3",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "3"
                    ]
                },
                "4": {
                    "value": "#FFFF99",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFFF99"
                    },
                    "name": "ColorbrewerQualitativeAccent4",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "4"
                    ]
                },
                "5": {
                    "value": "#376BAE",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#376BAE"
                    },
                    "name": "ColorbrewerQualitativeAccent5",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "5"
                    ]
                },
                "6": {
                    "value": "#ED0280",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#ED0280"
                    },
                    "name": "ColorbrewerQualitativeAccent6",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "6"
                    ]
                },
                "7": {
                    "value": "#BF5B17",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#BF5B17"
                    },
                    "name": "ColorbrewerQualitativeAccent7",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "7"
                    ]
                },
                "8": {
                    "value": "#666666",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#666666"
                    },
                    "name": "ColorbrewerQualitativeAccent8",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "8"
                    ]
                }
            },
            "dark2": {
                "1": {
                    "value": "#1B9D76",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#1B9D76"
                    },
                    "name": "ColorbrewerQualitativeDark21",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "1"
                    ]
                },
                "2": {
                    "value": "#D95F02",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#D95F02"
                    },
                    "name": "ColorbrewerQualitativeDark22",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "2"
                    ]
                },
                "3": {
                    "value": "#746FB3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#746FB3"
                    },
                    "name": "ColorbrewerQualitativeDark23",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "3"
                    ]
                },
                "4": {
                    "value": "#E7278A",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E7278A"
                    },
                    "name": "ColorbrewerQualitativeDark24",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "4"
                    ]
                },
                "5": {
                    "value": "#65A41E",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#65A41E"
                    },
                    "name": "ColorbrewerQualitativeDark25",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "5"
                    ]
                },
                "6": {
                    "value": "#E3A702",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E3A702"
                    },
                    "name": "ColorbrewerQualitativeDark26",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "6"
                    ]
                },
                "7": {
                    "value": "#A6761D",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#A6761D"
                    },
                    "name": "ColorbrewerQualitativeDark27",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "7"
                    ]
                },
                "8": {
                    "value": "#666666",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#666666"
                    },
                    "name": "ColorbrewerQualitativeDark28",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "8"
                    ]
                }
            },
            "paired": {
                "1": {
                    "value": "#A6CEE3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#A6CEE3"
                    },
                    "name": "ColorbrewerQualitativePaired1",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "1"
                    ]
                },
                "2": {
                    "value": "#1E77B3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#1E77B3"
                    },
                    "name": "ColorbrewerQualitativePaired2",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "2"
                    ]
                },
                "3": {
                    "value": "#B2DF8A",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#B2DF8A"
                    },
                    "name": "ColorbrewerQualitativePaired3",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "3"
                    ]
                },
                "4": {
                    "value": "#34A02C",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#34A02C"
                    },
                    "name": "ColorbrewerQualitativePaired4",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "4"
                    ]
                },
                "5": {
                    "value": "#FB9A99",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FB9A99"
                    },
                    "name": "ColorbrewerQualitativePaired5",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "5"
                    ]
                },
                "6": {
                    "value": "#E41B1E",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E41B1E"
                    },
                    "name": "ColorbrewerQualitativePaired6",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "6"
                    ]
                },
                "7": {
                    "value": "#FDBF6F",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FDBF6F"
                    },
                    "name": "ColorbrewerQualitativePaired7",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "7"
                    ]
                },
                "8": {
                    "value": "#FF8000",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FF8000"
                    },
                    "name": "ColorbrewerQualitativePaired8",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "8"
                    ]
                },
                "9": {
                    "value": "#CAB2D6",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#CAB2D6"
                    },
                    "name": "ColorbrewerQualitativePaired9",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "9"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "9"
                    ]
                },
                "10": {
                    "value": "#6A3D99",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#6A3D99"
                    },
                    "name": "ColorbrewerQualitativePaired10",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "10"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "10"
                    ]
                },
                "11": {
                    "value": "#FFFF99",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFFF99"
                    },
                    "name": "ColorbrewerQualitativePaired11",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "11"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "11"
                    ]
                },
                "12": {
                    "value": "#B35929",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#B35929"
                    },
                    "name": "ColorbrewerQualitativePaired12",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "12"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "12"
                    ]
                }
            },
            "pastel1": {
                "1": {
                    "value": "#FBB4AE",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FBB4AE"
                    },
                    "name": "ColorbrewerQualitativePastel11",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "1"
                    ]
                },
                "2": {
                    "value": "#B3CDE3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#B3CDE3"
                    },
                    "name": "ColorbrewerQualitativePastel12",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "2"
                    ]
                },
                "3": {
                    "value": "#CCEBC5",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#CCEBC5"
                    },
                    "name": "ColorbrewerQualitativePastel13",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "3"
                    ]
                },
                "4": {
                    "value": "#DECBE4",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#DECBE4"
                    },
                    "name": "ColorbrewerQualitativePastel14",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "4"
                    ]
                },
                "5": {
                    "value": "#FED9A6",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FED9A6"
                    },
                    "name": "ColorbrewerQualitativePastel15",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "5"
                    ]
                },
                "6": {
                    "value": "#FFFFCC",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFFFCC"
                    },
                    "name": "ColorbrewerQualitativePastel16",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "6"
                    ]
                },
                "7": {
                    "value": "#E5D8BD",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E5D8BD"
                    },
                    "name": "ColorbrewerQualitativePastel17",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "7"
                    ]
                },
                "8": {
                    "value": "#FDDAEC",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FDDAEC"
                    },
                    "name": "ColorbrewerQualitativePastel18",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "8"
                    ]
                },
                "9": {
                    "value": "#F2F2F2",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#F2F2F2"
                    },
                    "name": "ColorbrewerQualitativePastel19",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "9"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "9"
                    ]
                }
            },
            "pastel2": {
                "1": {
                    "value": "#B3E2CD",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#B3E2CD"
                    },
                    "name": "ColorbrewerQualitativePastel21",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "1"
                    ]
                },
                "2": {
                    "value": "#FDCDAC",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FDCDAC"
                    },
                    "name": "ColorbrewerQualitativePastel22",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "2"
                    ]
                },
                "3": {
                    "value": "#CBD5E8",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#CBD5E8"
                    },
                    "name": "ColorbrewerQualitativePastel23",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "3"
                    ]
                },
                "4": {
                    "value": "#F4CAE4",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#F4CAE4"
                    },
                    "name": "ColorbrewerQualitativePastel24",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "4"
                    ]
                },
                "5": {
                    "value": "#E6F5C9",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E6F5C9"
                    },
                    "name": "ColorbrewerQualitativePastel25",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "5"
                    ]
                },
                "6": {
                    "value": "#FFF2AE",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFF2AE"
                    },
                    "name": "ColorbrewerQualitativePastel26",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "6"
                    ]
                },
                "7": {
                    "value": "#F1E2CC",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#F1E2CC"
                    },
                    "name": "ColorbrewerQualitativePastel27",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "7"
                    ]
                },
                "8": {
                    "value": "#CCCCCC",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#CCCCCC"
                    },
                    "name": "ColorbrewerQualitativePastel28",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "8"
                    ]
                }
            },
            "set1": {
                "1": {
                    "value": "#E61A1D",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E61A1D"
                    },
                    "name": "ColorbrewerQualitativeSet11",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "1"
                    ]
                },
                "2": {
                    "value": "#377EB9",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#377EB9"
                    },
                    "name": "ColorbrewerQualitativeSet12",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "2"
                    ]
                },
                "3": {
                    "value": "#4DB04A",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#4DB04A"
                    },
                    "name": "ColorbrewerQualitativeSet13",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "3"
                    ]
                },
                "4": {
                    "value": "#974EA2",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#974EA2"
                    },
                    "name": "ColorbrewerQualitativeSet14",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "4"
                    ]
                },
                "5": {
                    "value": "#FF8000",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FF8000"
                    },
                    "name": "ColorbrewerQualitativeSet15",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "5"
                    ]
                },
                "6": {
                    "value": "#FFFF33",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFFF33"
                    },
                    "name": "ColorbrewerQualitativeSet16",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "6"
                    ]
                },
                "7": {
                    "value": "#A45528",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#A45528"
                    },
                    "name": "ColorbrewerQualitativeSet17",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "7"
                    ]
                },
                "8": {
                    "value": "#F782C1",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#F782C1"
                    },
                    "name": "ColorbrewerQualitativeSet18",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "8"
                    ]
                },
                "9": {
                    "value": "#999999",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#999999"
                    },
                    "name": "ColorbrewerQualitativeSet19",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "9"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "9"
                    ]
                }
            },
            "set2": {
                "1": {
                    "value": "#66C2A5",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#66C2A5"
                    },
                    "name": "ColorbrewerQualitativeSet21",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "1"
                    ]
                },
                "2": {
                    "value": "#FC8F64",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FC8F64"
                    },
                    "name": "ColorbrewerQualitativeSet22",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "2"
                    ]
                },
                "3": {
                    "value": "#8C9ECA",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#8C9ECA"
                    },
                    "name": "ColorbrewerQualitativeSet23",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "3"
                    ]
                },
                "4": {
                    "value": "#E788C3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E788C3"
                    },
                    "name": "ColorbrewerQualitativeSet24",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "4"
                    ]
                },
                "5": {
                    "value": "#A6D855",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#A6D855"
                    },
                    "name": "ColorbrewerQualitativeSet25",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "5"
                    ]
                },
                "6": {
                    "value": "#FFD92E",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFD92E"
                    },
                    "name": "ColorbrewerQualitativeSet26",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "6"
                    ]
                },
                "7": {
                    "value": "#FEE8C8",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FEE8C8"
                    },
                    "name": "ColorbrewerQualitativeSet27",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "7"
                    ]
                },
                "8": {
                    "value": "#999999",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#999999"
                    },
                    "name": "ColorbrewerQualitativeSet28",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "8"
                    ]
                }
            },
            "set3": {
                "1": {
                    "value": "#8DD3C7",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#8DD3C7"
                    },
                    "name": "ColorbrewerQualitativeSet31",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "1"
                    ]
                },
                "2": {
                    "value": "#FFFFB3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFFFB3"
                    },
                    "name": "ColorbrewerQualitativeSet32",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "2"
                    ]
                },
                "3": {
                    "value": "#BDB9DA",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#BDB9DA"
                    },
                    "name": "ColorbrewerQualitativeSet33",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "3"
                    ]
                },
                "4": {
                    "value": "#FB8274",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FB8274"
                    },
                    "name": "ColorbrewerQualitativeSet34",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "4"
                    ]
                },
                "5": {
                    "value": "#7EAFD3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#7EAFD3"
                    },
                    "name": "ColorbrewerQualitativeSet35",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "5"
                    ]
                },
                "6": {
                    "value": "#FDB563",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FDB563"
                    },
                    "name": "ColorbrewerQualitativeSet36",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "6"
                    ]
                },
                "7": {
                    "value": "#B3DE68",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#B3DE68"
                    },
                    "name": "ColorbrewerQualitativeSet37",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "7"
                    ]
                },
                "8": {
                    "value": "#FCCFE6",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FCCFE6"
                    },
                    "name": "ColorbrewerQualitativeSet38",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "8"
                    ]
                },
                "9": {
                    "value": "#D9D9D9",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#D9D9D9"
                    },
                    "name": "ColorbrewerQualitativeSet39",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "9"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "9"
                    ]
                },
                "10": {
                    "value": "#BC7FBD",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#BC7FBD"
                    },
                    "name": "ColorbrewerQualitativeSet310",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "10"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "10"
                    ]
                },
                "11": {
                    "value": "#CDEBC6",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#CDEBC6"
                    },
                    "name": "ColorbrewerQualitativeSet311",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "11"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "11"
                    ]
                },
                "12": {
                    "value": "#FFEE70",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFEE70"
                    },
                    "name": "ColorbrewerQualitativeSet312",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "12"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "12"
                    ]
                }
            }
        }
    },
    "colors": {
        "active": {
            "100": {
                "value": "#01ffc6",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#01ffc6"
                },
                "name": "ColorsActive100",
                "attributes": {
                    "category": "colors",
                    "type": "active",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "active",
                    "100"
                ]
            }
        },
        "black": {
            "100": {
                "value": "#000000",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#000000"
                },
                "name": "ColorsBlack100",
                "attributes": {
                    "category": "colors",
                    "type": "black",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "black",
                    "100"
                ]
            }
        },
        "blue": {
            "100": {
                "value": "#d9f9ff",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#d9f9ff"
                },
                "name": "ColorsBlue100",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "blue",
                    "100"
                ]
            },
            "150": {
                "value": "#c2f2fd",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#c2f2fd"
                },
                "name": "ColorsBlue150",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "blue",
                    "150"
                ]
            },
            "200": {
                "value": "#adecfa",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#adecfa"
                },
                "name": "ColorsBlue200",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "blue",
                    "200"
                ]
            },
            "300": {
                "value": "#7fdbf3",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#7fdbf3"
                },
                "name": "ColorsBlue300",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "blue",
                    "300"
                ]
            },
            "400": {
                "value": "#54c5e7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#54c5e7"
                },
                "name": "ColorsBlue400",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "blue",
                    "400"
                ]
            },
            "500": {
                "value": "#30abd5",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#30abd5"
                },
                "name": "ColorsBlue500",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "blue",
                    "500"
                ]
            },
            "600": {
                "value": "#168fbb",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#168fbb"
                },
                "name": "ColorsBlue600",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "blue",
                    "600"
                ]
            },
            "700": {
                "value": "#07719c",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#07719c"
                },
                "name": "ColorsBlue700",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "blue",
                    "700"
                ]
            },
            "800": {
                "value": "#01547a",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#01547a"
                },
                "name": "ColorsBlue800",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "blue",
                    "800"
                ]
            },
            "850": {
                "value": "#014869",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#014869"
                },
                "name": "ColorsBlue850",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "blue",
                    "850"
                ]
            },
            "900": {
                "value": "#003b59",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#003b59"
                },
                "name": "ColorsBlue900",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "blue",
                    "900"
                ]
            }
        },
        "cyan": {
            "100": {
                "value": "#dffffd",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#dffffd"
                },
                "name": "ColorsCyan100",
                "attributes": {
                    "category": "colors",
                    "type": "cyan",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "cyan",
                    "100"
                ]
            },
            "300": {
                "value": "#a5eeef",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#a5eeef"
                },
                "name": "ColorsCyan300",
                "attributes": {
                    "category": "colors",
                    "type": "cyan",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "cyan",
                    "300"
                ]
            },
            "500": {
                "value": "#6dcdd8",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#6dcdd8"
                },
                "name": "ColorsCyan500",
                "attributes": {
                    "category": "colors",
                    "type": "cyan",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "cyan",
                    "500"
                ]
            },
            "700": {
                "value": "#3ba0b7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#3ba0b7"
                },
                "name": "ColorsCyan700",
                "attributes": {
                    "category": "colors",
                    "type": "cyan",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "cyan",
                    "700"
                ]
            },
            "900": {
                "value": "#147092",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#147092"
                },
                "name": "ColorsCyan900",
                "attributes": {
                    "category": "colors",
                    "type": "cyan",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "cyan",
                    "900"
                ]
            }
        },
        "emerald": {
            "100": {
                "value": "#e6fff7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#e6fff7"
                },
                "name": "ColorsEmerald100",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "emerald",
                    "100"
                ]
            },
            "150": {
                "value": "#c9f8eb",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#c9f8eb"
                },
                "name": "ColorsEmerald150",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "emerald",
                    "150"
                ]
            },
            "200": {
                "value": "#aef1e1",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#aef1e1"
                },
                "name": "ColorsEmerald200",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "emerald",
                    "200"
                ]
            },
            "300": {
                "value": "#86ddcf",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#86ddcf"
                },
                "name": "ColorsEmerald300",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "emerald",
                    "300"
                ]
            },
            "400": {
                "value": "#5ecabf",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#5ecabf"
                },
                "name": "ColorsEmerald400",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "emerald",
                    "400"
                ]
            },
            "500": {
                "value": "#35b7b2",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#35b7b2"
                },
                "name": "ColorsEmerald500",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "emerald",
                    "500"
                ]
            },
            "600": {
                "value": "#0da1a4",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#0da1a4"
                },
                "name": "ColorsEmerald600",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "emerald",
                    "600"
                ]
            },
            "700": {
                "value": "#038185",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#038185"
                },
                "name": "ColorsEmerald700",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "emerald",
                    "700"
                ]
            },
            "800": {
                "value": "#006266",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#006266"
                },
                "name": "ColorsEmerald800",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "emerald",
                    "800"
                ]
            },
            "850": {
                "value": "#005153",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#005153"
                },
                "name": "ColorsEmerald850",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "emerald",
                    "850"
                ]
            },
            "900": {
                "value": "#003f40",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#003f40"
                },
                "name": "ColorsEmerald900",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "emerald",
                    "900"
                ]
            }
        },
        "green": {
            "100": {
                "value": "#eaffbf",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#eaffbf"
                },
                "name": "ColorsGreen100",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "green",
                    "100"
                ]
            },
            "150": {
                "value": "#e0fdb0",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#e0fdb0"
                },
                "name": "ColorsGreen150",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "green",
                    "150"
                ]
            },
            "200": {
                "value": "#d6faa2",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#d6faa2"
                },
                "name": "ColorsGreen200",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "green",
                    "200"
                ]
            },
            "300": {
                "value": "#bbf383",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#bbf383"
                },
                "name": "ColorsGreen300",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "green",
                    "300"
                ]
            },
            "400": {
                "value": "#9be764",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#9be764"
                },
                "name": "ColorsGreen400",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "green",
                    "400"
                ]
            },
            "500": {
                "value": "#78d549",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#78d549"
                },
                "name": "ColorsGreen500",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "green",
                    "500"
                ]
            },
            "600": {
                "value": "#56bb34",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#56bb34"
                },
                "name": "ColorsGreen600",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "green",
                    "600"
                ]
            },
            "700": {
                "value": "#389c24",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#389c24"
                },
                "name": "ColorsGreen700",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "green",
                    "700"
                ]
            },
            "800": {
                "value": "#217a19",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#217a19"
                },
                "name": "ColorsGreen800",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "green",
                    "800"
                ]
            },
            "850": {
                "value": "#196915",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#196915"
                },
                "name": "ColorsGreen850",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "green",
                    "850"
                ]
            },
            "900": {
                "value": "#125912",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#125912"
                },
                "name": "ColorsGreen900",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "green",
                    "900"
                ]
            }
        },
        "indigo": {
            "100": {
                "value": "#e6dfff",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#e6dfff"
                },
                "name": "ColorsIndigo100",
                "attributes": {
                    "category": "colors",
                    "type": "indigo",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "indigo",
                    "100"
                ]
            },
            "300": {
                "value": "#b3a2f1",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b3a2f1"
                },
                "name": "ColorsIndigo300",
                "attributes": {
                    "category": "colors",
                    "type": "indigo",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "indigo",
                    "300"
                ]
            },
            "500": {
                "value": "#7d64d6",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#7d64d6"
                },
                "name": "ColorsIndigo500",
                "attributes": {
                    "category": "colors",
                    "type": "indigo",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "indigo",
                    "500"
                ]
            },
            "700": {
                "value": "#472ca6",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#472ca6"
                },
                "name": "ColorsIndigo700",
                "attributes": {
                    "category": "colors",
                    "type": "indigo",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "indigo",
                    "700"
                ]
            },
            "900": {
                "value": "#1e076e",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#1e076e"
                },
                "name": "ColorsIndigo900",
                "attributes": {
                    "category": "colors",
                    "type": "indigo",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "indigo",
                    "900"
                ]
            }
        },
        "midnight": {
            "100": {
                "value": "#faf9ff",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#faf9ff"
                },
                "name": "ColorsMidnight100",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "midnight",
                    "100"
                ]
            },
            "150": {
                "value": "#eceaf1",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#eceaf1"
                },
                "name": "ColorsMidnight150",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "midnight",
                    "150"
                ]
            },
            "200": {
                "value": "#dedce4",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#dedce4"
                },
                "name": "ColorsMidnight200",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "midnight",
                    "200"
                ]
            },
            "300": {
                "value": "#c0bec9",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#c0bec9"
                },
                "name": "ColorsMidnight300",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "midnight",
                    "300"
                ]
            },
            "400": {
                "value": "#a29eae",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#a29eae"
                },
                "name": "ColorsMidnight400",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "midnight",
                    "400"
                ]
            },
            "500": {
                "value": "#837e93",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#837e93"
                },
                "name": "ColorsMidnight500",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "midnight",
                    "500"
                ]
            },
            "600": {
                "value": "#676178",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#676178"
                },
                "name": "ColorsMidnight600",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "midnight",
                    "600"
                ]
            },
            "700": {
                "value": "#4d485c",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#4d485c"
                },
                "name": "ColorsMidnight700",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "midnight",
                    "700"
                ]
            },
            "800": {
                "value": "#353241",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#353241"
                },
                "name": "ColorsMidnight800",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "midnight",
                    "800"
                ]
            },
            "850": {
                "value": "#2a2734",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#2a2734"
                },
                "name": "ColorsMidnight850",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "midnight",
                    "850"
                ]
            },
            "900": {
                "value": "#1f1d26",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#1f1d26"
                },
                "name": "ColorsMidnight900",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "midnight",
                    "900"
                ]
            }
        },
        "mint": {
            "100": {
                "value": "#dffff1",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#dffff1"
                },
                "name": "ColorsMint100",
                "attributes": {
                    "category": "colors",
                    "type": "mint",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "mint",
                    "100"
                ]
            },
            "300": {
                "value": "#b3fee3",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b3fee3"
                },
                "name": "ColorsMint300",
                "attributes": {
                    "category": "colors",
                    "type": "mint",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "mint",
                    "300"
                ]
            },
            "500": {
                "value": "#84f6d6",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#84f6d6"
                },
                "name": "ColorsMint500",
                "attributes": {
                    "category": "colors",
                    "type": "mint",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "mint",
                    "500"
                ]
            },
            "700": {
                "value": "#53e4c8",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#53e4c8"
                },
                "name": "ColorsMint700",
                "attributes": {
                    "category": "colors",
                    "type": "mint",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "mint",
                    "700"
                ]
            },
            "900": {
                "value": "#28cebc",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#28cebc"
                },
                "name": "ColorsMint900",
                "attributes": {
                    "category": "colors",
                    "type": "mint",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "mint",
                    "900"
                ]
            }
        },
        "navy": {
            "100": {
                "value": "#e6fcff",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#e6fcff"
                },
                "name": "ColorsNavy100",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "navy",
                    "100"
                ]
            },
            "150": {
                "value": "#cef0f6",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#cef0f6"
                },
                "name": "ColorsNavy150",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "navy",
                    "150"
                ]
            },
            "200": {
                "value": "#b7e2ec",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b7e2ec"
                },
                "name": "ColorsNavy200",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "navy",
                    "200"
                ]
            },
            "300": {
                "value": "#8dc3d7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#8dc3d7"
                },
                "name": "ColorsNavy300",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "navy",
                    "300"
                ]
            },
            "400": {
                "value": "#69a2c2",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#69a2c2"
                },
                "name": "ColorsNavy400",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "navy",
                    "400"
                ]
            },
            "500": {
                "value": "#4981ad",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#4981ad"
                },
                "name": "ColorsNavy500",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "navy",
                    "500"
                ]
            },
            "600": {
                "value": "#2e6197",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#2e6197"
                },
                "name": "ColorsNavy600",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "navy",
                    "600"
                ]
            },
            "700": {
                "value": "#184382",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#184382"
                },
                "name": "ColorsNavy700",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "navy",
                    "700"
                ]
            },
            "800": {
                "value": "#092c64",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#092c64"
                },
                "name": "ColorsNavy800",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "navy",
                    "800"
                ]
            },
            "850": {
                "value": "#042252",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#042252"
                },
                "name": "ColorsNavy850",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "navy",
                    "850"
                ]
            },
            "900": {
                "value": "#001940",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#001940"
                },
                "name": "ColorsNavy900",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "navy",
                    "900"
                ]
            }
        },
        "purple": {
            "100": {
                "value": "#ffdfec",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ffdfec"
                },
                "name": "ColorsPurple100",
                "attributes": {
                    "category": "colors",
                    "type": "purple",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "purple",
                    "100"
                ]
            },
            "300": {
                "value": "#f9b7d7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#f9b7d7"
                },
                "name": "ColorsPurple300",
                "attributes": {
                    "category": "colors",
                    "type": "purple",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "purple",
                    "300"
                ]
            },
            "500": {
                "value": "#ec8cc2",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ec8cc2"
                },
                "name": "ColorsPurple500",
                "attributes": {
                    "category": "colors",
                    "type": "purple",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "purple",
                    "500"
                ]
            },
            "700": {
                "value": "#d460ac",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#d460ac"
                },
                "name": "ColorsPurple700",
                "attributes": {
                    "category": "colors",
                    "type": "purple",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "purple",
                    "700"
                ]
            },
            "900": {
                "value": "#b93a98",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b93a98"
                },
                "name": "ColorsPurple900",
                "attributes": {
                    "category": "colors",
                    "type": "purple",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "purple",
                    "900"
                ]
            }
        },
        "red": {
            "100": {
                "value": "#ffe2d3",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ffe2d3"
                },
                "name": "ColorsRed100",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "red",
                    "100"
                ]
            },
            "150": {
                "value": "#fdd1bd",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fdd1bd"
                },
                "name": "ColorsRed150",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "red",
                    "150"
                ]
            },
            "200": {
                "value": "#fcc0a7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fcc0a7"
                },
                "name": "ColorsRed200",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "red",
                    "200"
                ]
            },
            "300": {
                "value": "#f6997a",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#f6997a"
                },
                "name": "ColorsRed300",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "red",
                    "300"
                ]
            },
            "400": {
                "value": "#ec704f",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ec704f"
                },
                "name": "ColorsRed400",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "red",
                    "400"
                ]
            },
            "500": {
                "value": "#de492b",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#de492b"
                },
                "name": "ColorsRed500",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "red",
                    "500"
                ]
            },
            "600": {
                "value": "#cb2811",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#cb2811"
                },
                "name": "ColorsRed600",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "red",
                    "600"
                ]
            },
            "700": {
                "value": "#b31102",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b31102"
                },
                "name": "ColorsRed700",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "red",
                    "700"
                ]
            },
            "800": {
                "value": "#980600",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#980600"
                },
                "name": "ColorsRed800",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "red",
                    "800"
                ]
            },
            "850": {
                "value": "#8c0300",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#8c0300"
                },
                "name": "ColorsRed850",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "red",
                    "850"
                ]
            },
            "900": {
                "value": "#800000",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#800000"
                },
                "name": "ColorsRed900",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "red",
                    "900"
                ]
            }
        },
        "sand": {
            "100": {
                "value": "#f8f7f3",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#f8f7f3"
                },
                "name": "ColorsSand100",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "sand",
                    "100"
                ]
            },
            "150": {
                "value": "#ebe8df",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ebe8df"
                },
                "name": "ColorsSand150",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "sand",
                    "150"
                ]
            },
            "200": {
                "value": "#ded9cc",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ded9cc"
                },
                "name": "ColorsSand200",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "sand",
                    "200"
                ]
            },
            "300": {
                "value": "#c4b9a7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#c4b9a7"
                },
                "name": "ColorsSand300",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "sand",
                    "300"
                ]
            },
            "400": {
                "value": "#aa9987",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#aa9987"
                },
                "name": "ColorsSand400",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "sand",
                    "400"
                ]
            },
            "500": {
                "value": "#8f7a6a",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#8f7a6a"
                },
                "name": "ColorsSand500",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "sand",
                    "500"
                ]
            },
            "600": {
                "value": "#755d52",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#755d52"
                },
                "name": "ColorsSand600",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "sand",
                    "600"
                ]
            },
            "700": {
                "value": "#5a443d",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#5a443d"
                },
                "name": "ColorsSand700",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "sand",
                    "700"
                ]
            },
            "800": {
                "value": "#402d2a",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#402d2a"
                },
                "name": "ColorsSand800",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "sand",
                    "800"
                ]
            },
            "850": {
                "value": "#332321",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#332321"
                },
                "name": "ColorsSand850",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "sand",
                    "850"
                ]
            },
            "900": {
                "value": "#261a19",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#261a19"
                },
                "name": "ColorsSand900",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "sand",
                    "900"
                ]
            }
        },
        "sun": {
            "100": {
                "value": "#fff8df",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fff8df"
                },
                "name": "ColorsSun100",
                "attributes": {
                    "category": "colors",
                    "type": "sun",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "sun",
                    "100"
                ]
            },
            "300": {
                "value": "#fff3bc",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fff3bc"
                },
                "name": "ColorsSun300",
                "attributes": {
                    "category": "colors",
                    "type": "sun",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "sun",
                    "300"
                ]
            },
            "500": {
                "value": "#f8eb95",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#f8eb95"
                },
                "name": "ColorsSun500",
                "attributes": {
                    "category": "colors",
                    "type": "sun",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "sun",
                    "500"
                ]
            },
            "700": {
                "value": "#e6dc6b",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#e6dc6b"
                },
                "name": "ColorsSun700",
                "attributes": {
                    "category": "colors",
                    "type": "sun",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "sun",
                    "700"
                ]
            },
            "900": {
                "value": "#d1cb44",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#d1cb44"
                },
                "name": "ColorsSun900",
                "attributes": {
                    "category": "colors",
                    "type": "sun",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "sun",
                    "900"
                ]
            }
        },
        "white": {
            "100": {
                "value": "#ffffff",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ffffff"
                },
                "name": "ColorsWhite100",
                "attributes": {
                    "category": "colors",
                    "type": "white",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "white",
                    "100"
                ]
            }
        },
        "yellow": {
            "100": {
                "value": "#ffefcf",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ffefcf"
                },
                "name": "ColorsYellow100",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "yellow",
                    "100"
                ]
            },
            "150": {
                "value": "#fde6b7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fde6b7"
                },
                "name": "ColorsYellow150",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "yellow",
                    "150"
                ]
            },
            "200": {
                "value": "#fcdda0",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fcdda0"
                },
                "name": "ColorsYellow200",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "yellow",
                    "200"
                ]
            },
            "300": {
                "value": "#f6c96f",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#f6c96f"
                },
                "name": "ColorsYellow300",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "yellow",
                    "300"
                ]
            },
            "400": {
                "value": "#ecb341",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ecb341"
                },
                "name": "ColorsYellow400",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "yellow",
                    "400"
                ]
            },
            "500": {
                "value": "#de9d1b",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#de9d1b"
                },
                "name": "ColorsYellow500",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "yellow",
                    "500"
                ]
            },
            "600": {
                "value": "#cb8801",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#cb8801"
                },
                "name": "ColorsYellow600",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "yellow",
                    "600"
                ]
            },
            "700": {
                "value": "#b37700",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b37700"
                },
                "name": "ColorsYellow700",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "yellow",
                    "700"
                ]
            },
            "800": {
                "value": "#986600",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#986600"
                },
                "name": "ColorsYellow800",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "yellow",
                    "800"
                ]
            },
            "850": {
                "value": "#8c5d00",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#8c5d00"
                },
                "name": "ColorsYellow850",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "yellow",
                    "850"
                ]
            },
            "900": {
                "value": "#805500",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#805500"
                },
                "name": "ColorsYellow900",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "yellow",
                    "900"
                ]
            }
        }
    },
    "radius": {
        "s": "4px",
        "m": "8px",
        "lg": "16px"
    },
    "shadows": {
        "light": {
            "inner": {
                "value": "1.51px 1.51px 1.51px 261a191a",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "1.51px 1.51px 1.51px 261a191a"
                },
                "name": "ShadowsLightInner",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "inner"
                },
                "path": [
                    "shadows",
                    "light",
                    "inner"
                ]
            },
            "s": {
                "value": "0px 0.76px 2.27px #261a191a, 0px 0.76px 1.51px #261a190f",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 0.76px 2.27px #261a191a, 0px 0.76px 1.51px #261a190f"
                },
                "name": "ShadowsLightS",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "s"
                },
                "path": [
                    "shadows",
                    "light",
                    "s"
                ]
            },
            "m": {
                "value": "0px 3.03px 4.54px #261a190d, 0px 1.51px 5.3px #261a190a",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 3.03px 4.54px #261a190d, 0px 1.51px 5.3px #261a190a"
                },
                "name": "ShadowsLightM",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "m"
                },
                "path": [
                    "shadows",
                    "light",
                    "m"
                ]
            },
            "l": {
                "value": "0px 3.03px 4.54px #261a190d, 0px 7.57px 11.35px #261a191a",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 3.03px 4.54px #261a190d, 0px 7.57px 11.35px #261a191a"
                },
                "name": "ShadowsLightL",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "l"
                },
                "path": [
                    "shadows",
                    "light",
                    "l"
                ]
            },
            "xl": {
                "value": "0px 7.57px 7.57px #261a190a, 0px 15.14px 18.92px #261a191a",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 7.57px 7.57px #261a190a, 0px 15.14px 18.92px #261a191a"
                },
                "name": "ShadowsLightXl",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "xl"
                },
                "path": [
                    "shadows",
                    "light",
                    "xl"
                ]
            },
            "2xl": {
                "value": "0px 18.92px 37.84px #261a1940",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 18.92px 37.84px #261a1940"
                },
                "name": "ShadowsLight2xl",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "2xl"
                },
                "path": [
                    "shadows",
                    "light",
                    "2xl"
                ]
            }
        },
        "dark": {
            "inner": {
                "value": "1.51px 1.51px 1.51px #00000080",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "1.51px 1.51px 1.51px #00000080"
                },
                "name": "ShadowsDarkInner",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "inner"
                },
                "path": [
                    "shadows",
                    "dark",
                    "inner"
                ]
            },
            "s": {
                "value": "0px 0.76px 2.27px #261a19, 0px 0.76px 1.51px #261a19bf",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 0.76px 2.27px #261a19, 0px 0.76px 1.51px #261a19bf"
                },
                "name": "ShadowsDarkS",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "s"
                },
                "path": [
                    "shadows",
                    "dark",
                    "s"
                ]
            },
            "m": {
                "value": "0px 3.03px 4.54px #261a19, 0px 1.51px 5.3px #261a19bf",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 3.03px 4.54px #261a19, 0px 1.51px 5.3px #261a19bf"
                },
                "name": "ShadowsDarkM",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "m"
                },
                "path": [
                    "shadows",
                    "dark",
                    "m"
                ]
            },
            "l": {
                "value": "0px 3.03px 4.54px #261a19, 0px 7.57px 11.25px #261a1980",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 3.03px 4.54px #261a19, 0px 7.57px 11.25px #261a1980"
                },
                "name": "ShadowsDarkL",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "l"
                },
                "path": [
                    "shadows",
                    "dark",
                    "l"
                ]
            },
            "xl": {
                "value": "0px 7.57px 7.57px #261a190a, 0px 15.14px 18.92px #261a1980",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 7.57px 7.57px #261a190a, 0px 15.14px 18.92px #261a1980"
                },
                "name": "ShadowsDarkXl",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "xl"
                },
                "path": [
                    "shadows",
                    "dark",
                    "xl"
                ]
            },
            "2xl": {
                "value": "0px 18.92px 37.84px #00000080",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 18.92px 37.84px #00000080"
                },
                "name": "ShadowsDark2xl",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "2xl"
                },
                "path": [
                    "shadows",
                    "dark",
                    "2xl"
                ]
            }
        }
    },
    "spacing": {
        "2xs": {
            "value": "2px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "2px"
            },
            "name": "Spacing2xs",
            "attributes": {
                "category": "spacing",
                "type": "2xs"
            },
            "path": [
                "spacing",
                "2xs"
            ]
        },
        "xs": {
            "value": "4px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "4px"
            },
            "name": "SpacingXs",
            "attributes": {
                "category": "spacing",
                "type": "xs"
            },
            "path": [
                "spacing",
                "xs"
            ]
        },
        "s": {
            "value": "8px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "8px"
            },
            "name": "SpacingS",
            "attributes": {
                "category": "spacing",
                "type": "s"
            },
            "path": [
                "spacing",
                "s"
            ]
        },
        "m": {
            "value": "12px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "12px"
            },
            "name": "SpacingM",
            "attributes": {
                "category": "spacing",
                "type": "m"
            },
            "path": [
                "spacing",
                "m"
            ]
        },
        "l": {
            "value": "16px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "16px"
            },
            "name": "SpacingL",
            "attributes": {
                "category": "spacing",
                "type": "l"
            },
            "path": [
                "spacing",
                "l"
            ]
        },
        "xl": {
            "value": "20px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "20px"
            },
            "name": "SpacingXl",
            "attributes": {
                "category": "spacing",
                "type": "xl"
            },
            "path": [
                "spacing",
                "xl"
            ]
        },
        "2xl": {
            "value": "24px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "24px"
            },
            "name": "Spacing2xl",
            "attributes": {
                "category": "spacing",
                "type": "2xl"
            },
            "path": [
                "spacing",
                "2xl"
            ]
        },
        "3xl": {
            "value": "32px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "32px"
            },
            "name": "Spacing3xl",
            "attributes": {
                "category": "spacing",
                "type": "3xl"
            },
            "path": [
                "spacing",
                "3xl"
            ]
        },
        "4xl": {
            "value": "40px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "40px"
            },
            "name": "Spacing4xl",
            "attributes": {
                "category": "spacing",
                "type": "4xl"
            },
            "path": [
                "spacing",
                "4xl"
            ]
        },
        "5xl": {
            "value": "48px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "48px"
            },
            "name": "Spacing5xl",
            "attributes": {
                "category": "spacing",
                "type": "5xl"
            },
            "path": [
                "spacing",
                "5xl"
            ]
        },
        "6xl": {
            "value": "64px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "64px"
            },
            "name": "Spacing6xl",
            "attributes": {
                "category": "spacing",
                "type": "6xl"
            },
            "path": [
                "spacing",
                "6xl"
            ]
        },
        "7xl": {
            "value": "96px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "96px"
            },
            "name": "Spacing7xl",
            "attributes": {
                "category": "spacing",
                "type": "7xl"
            },
            "path": [
                "spacing",
                "7xl"
            ]
        },
        "8xl": {
            "value": "160px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "160px"
            },
            "name": "Spacing8xl",
            "attributes": {
                "category": "spacing",
                "type": "8xl"
            },
            "path": [
                "spacing",
                "8xl"
            ]
        },
        "9xl": {
            "value": "192px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "192px"
            },
            "name": "Spacing9xl",
            "attributes": {
                "category": "spacing",
                "type": "9xl"
            },
            "path": [
                "spacing",
                "9xl"
            ]
        },
        "10xl": {
            "value": "240px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "240px"
            },
            "name": "Spacing10xl",
            "attributes": {
                "category": "spacing",
                "type": "10xl"
            },
            "path": [
                "spacing",
                "10xl"
            ]
        }
    },
    "font": {
        "family": {
            "display": {
                "value": "'Source Serif Pro', 'Times New Roman', serif",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "'Source Serif Pro', 'Times New Roman', serif"
                },
                "name": "FontFamilyDisplay",
                "attributes": {
                    "category": "font",
                    "type": "family",
                    "item": "display"
                },
                "path": [
                    "font",
                    "family",
                    "display"
                ]
            },
            "mono": {
                "value": "Menlo, Courier, monospace",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "Menlo, Courier, monospace"
                },
                "name": "FontFamilyMono",
                "attributes": {
                    "category": "font",
                    "type": "family",
                    "item": "mono"
                },
                "path": [
                    "font",
                    "family",
                    "mono"
                ]
            },
            "sans": {
                "value": "Avenir, sans-serif",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "Avenir, sans-serif"
                },
                "name": "FontFamilySans",
                "attributes": {
                    "category": "font",
                    "type": "family",
                    "item": "sans"
                },
                "path": [
                    "font",
                    "family",
                    "sans"
                ]
            },
            "serif": {
                "value": "'Source Serif Pro', 'Times New Roman', serif",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "'Source Serif Pro', 'Times New Roman', serif"
                },
                "name": "FontFamilySerif",
                "attributes": {
                    "category": "font",
                    "type": "family",
                    "item": "serif"
                },
                "path": [
                    "font",
                    "family",
                    "serif"
                ]
            }
        },
        "letterSpacing": {
            "s": {
                "value": "0.25em",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "0.25em"
                },
                "name": "FontLetterSpacingS",
                "attributes": {
                    "category": "font",
                    "type": "letterSpacing",
                    "item": "s"
                },
                "path": [
                    "font",
                    "letterSpacing",
                    "s"
                ]
            },
            "m": {
                "value": "0.35em",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "0.35em"
                },
                "name": "FontLetterSpacingM",
                "attributes": {
                    "category": "font",
                    "type": "letterSpacing",
                    "item": "m"
                },
                "path": [
                    "font",
                    "letterSpacing",
                    "m"
                ]
            }
        },
        "lineHeight": {
            "body": {
                "value": 1.5,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 1.5
                },
                "name": "FontLineHeightBody",
                "attributes": {
                    "category": "font",
                    "type": "lineHeight",
                    "item": "body"
                },
                "path": [
                    "font",
                    "lineHeight",
                    "body"
                ]
            },
            "header": {
                "value": 1.125,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 1.125
                },
                "name": "FontLineHeightHeader",
                "attributes": {
                    "category": "font",
                    "type": "lineHeight",
                    "item": "header"
                },
                "path": [
                    "font",
                    "lineHeight",
                    "header"
                ]
            },
            "text": {
                "value": 1.2,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 1.2
                },
                "name": "FontLineHeightText",
                "attributes": {
                    "category": "font",
                    "type": "lineHeight",
                    "item": "text"
                },
                "path": [
                    "font",
                    "lineHeight",
                    "text"
                ]
            }
        },
        "size": {
            "2xs": {
                "value": "10px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "10px"
                },
                "name": "FontSize2xs",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "2xs"
                },
                "path": [
                    "font",
                    "size",
                    "2xs"
                ]
            },
            "xs": {
                "value": "12px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "12px"
                },
                "name": "FontSizeXs",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "xs"
                },
                "path": [
                    "font",
                    "size",
                    "xs"
                ]
            },
            "s": {
                "value": "14px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "14px"
                },
                "name": "FontSizeS",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "s"
                },
                "path": [
                    "font",
                    "size",
                    "s"
                ]
            },
            "m": {
                "value": "16px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "16px"
                },
                "name": "FontSizeM",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "m"
                },
                "path": [
                    "font",
                    "size",
                    "m"
                ]
            },
            "l": {
                "value": "20px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "20px"
                },
                "name": "FontSizeL",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "l"
                },
                "path": [
                    "font",
                    "size",
                    "l"
                ]
            },
            "xl": {
                "value": "24px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "24px"
                },
                "name": "FontSizeXl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "xl"
                },
                "path": [
                    "font",
                    "size",
                    "xl"
                ]
            },
            "2xl": {
                "value": "28px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "28px"
                },
                "name": "FontSize2xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "2xl"
                },
                "path": [
                    "font",
                    "size",
                    "2xl"
                ]
            },
            "3xl": {
                "value": "32px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "32px"
                },
                "name": "FontSize3xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "3xl"
                },
                "path": [
                    "font",
                    "size",
                    "3xl"
                ]
            },
            "4xl": {
                "value": "40px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "40px"
                },
                "name": "FontSize4xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "4xl"
                },
                "path": [
                    "font",
                    "size",
                    "4xl"
                ]
            },
            "5xl": {
                "value": "48px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "48px"
                },
                "name": "FontSize5xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "5xl"
                },
                "path": [
                    "font",
                    "size",
                    "5xl"
                ]
            },
            "6xl": {
                "value": "56px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "56px"
                },
                "name": "FontSize6xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "6xl"
                },
                "path": [
                    "font",
                    "size",
                    "6xl"
                ]
            },
            "7xl": {
                "value": "68px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "68px"
                },
                "name": "FontSize7xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "7xl"
                },
                "path": [
                    "font",
                    "size",
                    "7xl"
                ]
            },
            "8xl": {
                "value": "84px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "84px"
                },
                "name": "FontSize8xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "8xl"
                },
                "path": [
                    "font",
                    "size",
                    "8xl"
                ]
            },
            "9xl": {
                "value": "100px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "100px"
                },
                "name": "FontSize9xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "9xl"
                },
                "path": [
                    "font",
                    "size",
                    "9xl"
                ]
            },
            "10xl": {
                "value": "120px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "120px"
                },
                "name": "FontSize10xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "10xl"
                },
                "path": [
                    "font",
                    "size",
                    "10xl"
                ]
            }
        },
        "weight": {
            "thin": {
                "value": 100,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 100
                },
                "name": "FontWeightThin",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "thin"
                },
                "path": [
                    "font",
                    "weight",
                    "thin"
                ]
            },
            "light": {
                "value": 300,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 300
                },
                "name": "FontWeightLight",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "light"
                },
                "path": [
                    "font",
                    "weight",
                    "light"
                ]
            },
            "regular": {
                "value": 400,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 400
                },
                "name": "FontWeightRegular",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "regular"
                },
                "path": [
                    "font",
                    "weight",
                    "regular"
                ]
            },
            "medium": {
                "value": 500,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 500
                },
                "name": "FontWeightMedium",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "medium"
                },
                "path": [
                    "font",
                    "weight",
                    "medium"
                ]
            },
            "semiBold": {
                "value": 600,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 600
                },
                "name": "FontWeightSemiBold",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "semiBold"
                },
                "path": [
                    "font",
                    "weight",
                    "semiBold"
                ]
            },
            "bold": {
                "value": 700,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 700
                },
                "name": "FontWeightBold",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "bold"
                },
                "path": [
                    "font",
                    "weight",
                    "bold"
                ]
            },
            "extraBold": {
                "value": 800,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 800
                },
                "name": "FontWeightExtraBold",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "extraBold"
                },
                "path": [
                    "font",
                    "weight",
                    "extraBold"
                ]
            },
            "black": {
                "value": 900,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 900
                },
                "name": "FontWeightBlack",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "black"
                },
                "path": [
                    "font",
                    "weight",
                    "black"
                ]
            }
        }
    }
};
//# sourceMappingURL=tokens.js.map

/***/ }),

/***/ 68107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qE": function() { return /* reexport */ Avatar_Avatar; },
  "Ct": function() { return /* reexport */ Molecules_Badge_Badge; },
  "zx": function() { return /* reexport */ Button_Button; },
  "hE": function() { return /* reexport */ ButtonGroup_ButtonGroup; },
  "ZP": function() { return /* reexport */ ButtonLink_ButtonLink; },
  "Zb": function() { return /* reexport */ Card_Card; },
  "XZ": function() { return /* reexport */ Checkbox_Checkbox; },
  "cO": function() { return /* reexport */ CheckboxGroup_CheckboxGroup; },
  "e1": function() { return /* reexport */ ControlledTable_ControlledTable; },
  "dy": function() { return /* reexport */ Drawer; },
  "Lt": function() { return /* reexport */ Dropdown_Dropdown; },
  "pg": function() { return /* reexport */ Fieldset_Fieldset; },
  "WN": function() { return /* reexport */ Flag_Flag; },
  "h4": function() { return /* reexport */ Header_Header; },
  "JO": function() { return /* reexport */ Icon_Icon; },
  "hU": function() { return /* reexport */ IconButton_IconButton; },
  "Rn": function() { return /* reexport */ InputNumber_InputNumber; },
  "u_": function() { return /* reexport */ Modal_Modal; },
  "P_": function() { return /* reexport */ Notification_Notification; },
  "Y8": function() { return /* reexport */ Radio_Radio; },
  "Ee": function() { return /* reexport */ RadioGroup_RadioGroup; },
  "Ph": function() { return /* reexport */ Molecules_Select_Select; },
  "_1": function() { return /* reexport */ SelectMulti_SelectMulti; },
  "Od": function() { return /* reexport */ Skeleton_Skeleton; },
  "Kq": function() { return /* reexport */ Stack_Stack; },
  "vO": function() { return /* reexport */ StackItem; },
  "iA": function() { return /* reexport */ Table_Table; },
  "RM": function() { return /* reexport */ TableBody_TableBody; },
  "C5": function() { return /* reexport */ TableData_TableData; },
  "ss": function() { return /* reexport */ TableHead_TableHead; },
  "xD": function() { return /* reexport */ TableHeader_TableHeader; },
  "SC": function() { return /* reexport */ TableRow_TableRow; },
  "mQ": function() { return /* reexport */ Tabs_Tabs; },
  "xv": function() { return /* reexport */ Text_Text; },
  "Kx": function() { return /* reexport */ TextArea_TextArea; },
  "qo": function() { return /* reexport */ TextField_TextField; },
  "FN": function() { return /* reexport */ Toast_Toast; },
  "u": function() { return /* reexport */ Tooltip_Tooltip; },
  "JP": function() { return /* reexport */ UIProvider_UIProvider; },
  "uH": function() { return /* reexport */ defaultTheme; },
  "pm": function() { return /* reexport */ useToast; },
  "PI": function() { return /* reexport */ withFormGroup; }
});

// UNUSED EXPORTS: BadgeList, IconLink, Kanban, Paragraph, SpinnerBadge, Switch

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ../ui-library/dist/foundation/tokens/js/tokens.js
var tokens = __webpack_require__(86111);
var tokens_default = /*#__PURE__*/__webpack_require__.n(tokens);
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/space.utils.js

// Functions.
// -----------------------------------------------------------------------------
// Returns the value of the space token received as a parameter.
const getSpace = (size) => !size ? '0px' : (tokens_default()).spacing[size].value;
// Returns the value of the radius token received as a parameter.
const getRadius = (size) => !size ? '0px' : (tokens_default()).radius[size];
//# sourceMappingURL=space.utils.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Header/Header.constants.js


// Map for responsive rules.
// -----------------------------------------------------------------------------
const DEFAULT_HEADER_EDITORIAL_BAR = 'none';
const DEFAULT_HEADER_EDITORIAL = false;
const EDITORIAL_RULES = {
    h1: {
        color: (tokens_default()).colors.mint[900].value,
        height: 12,
        width: 96
    },
    h2: {
        color: (tokens_default()).colors.cyan[700].value,
        height: 12,
        width: 64
    },
    h3: {
        color: (tokens_default()).colors.indigo[500].value,
        height: 8,
        width: 48
    },
    h4: {
        color: (tokens_default()).colors.mint[900].value,
        height: 4,
        width: 48
    }
};
const SIZES_RULES = {
    '10xl': {
        fontSize: (tokens_default()).font.size["10xl"].value,
        fontWeight: (tokens_default()).font.weight.black.value,
        marginBottom: getSpace('6xl')
    },
    '9xl': {
        fontSize: (tokens_default()).font.size["9xl"].value,
        fontWeight: (tokens_default()).font.weight.black.value,
        marginBottom: getSpace('5xl')
    },
    '8xl': {
        fontSize: (tokens_default()).font.size["8xl"].value,
        fontWeight: (tokens_default()).font.weight.black.value,
        marginBottom: getSpace('4xl')
    },
    '7xl': {
        fontSize: (tokens_default()).font.size["7xl"].value,
        fontWeight: (tokens_default()).font.weight.black.value,
        marginBottom: getSpace('3xl')
    },
    '6xl': {
        fontSize: (tokens_default()).font.size["6xl"].value,
        fontWeight: (tokens_default()).font.weight.black.value,
        marginBottom: getSpace('2xl')
    },
    '5xl': {
        fontSize: (tokens_default()).font.size["5xl"].value,
        fontWeight: (tokens_default()).font.weight.bold.value,
        marginBottom: getSpace('2xl')
    },
    '4xl': {
        fontSize: (tokens_default()).font.size["4xl"].value,
        fontWeight: (tokens_default()).font.weight.bold.value,
        marginBottom: getSpace('2xl')
    },
    '3xl': {
        fontSize: (tokens_default()).font.size["3xl"].value,
        fontWeight: (tokens_default()).font.weight.bold.value,
        marginBottom: getSpace('l')
    },
    '2xl': {
        fontSize: (tokens_default()).font.size["2xl"].value,
        fontWeight: (tokens_default()).font.weight.bold.value,
        marginBottom: getSpace('l')
    },
    xl: {
        fontSize: (tokens_default()).font.size.xl.value,
        fontWeight: (tokens_default()).font.weight.bold.value,
        marginBottom: getSpace('m')
    },
    l: {
        fontSize: (tokens_default()).font.size.l.value,
        fontWeight: (tokens_default()).font.weight.bold.value,
        marginBottom: getSpace('m')
    },
    m: {
        fontSize: (tokens_default()).font.size.m.value,
        fontWeight: (tokens_default()).font.weight.bold.value,
        marginBottom: getSpace('s')
    },
    s: {
        fontSize: (tokens_default()).font.size.s.value,
        fontWeight: (tokens_default()).font.weight.extraBold.value,
        marginBottom: getSpace('s')
    },
    xs: {
        fontSize: (tokens_default()).font.size.xs.value,
        fontWeight: (tokens_default()).font.weight.extraBold.value,
        marginBottom: getSpace('s')
    },
    '2xs': {
        fontSize: (tokens_default()).font.size["2xs"].value,
        fontWeight: (tokens_default()).font.weight.extraBold.value,
        marginBottom: getSpace('xs')
    }
};
const AS_RULES = {
    h1: '5xl',
    h2: '4xl',
    h3: '3xl',
    h4: '2xl',
    h5: 'xl',
    h6: 'l'
};
//# sourceMappingURL=Header.constants.js.map
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(2374);
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/breakpoints.types.js
// Types.
// -----------------------------------------------------------------------------
// Common.
// -----------------------------------------------------------------------------
// Defined breakpoints.
const UI_BREAKPOINTS = ['s', 'm', 'l', 'xl', '2xl'];
//# sourceMappingURL=breakpoints.types.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/breakpoints.utils.js


// Functions.
// -----------------------------------------------------------------------------
const breakPointDistance = (from, to) => {
    const indexFrom = UI_BREAKPOINTS.indexOf(from);
    const indexTo = UI_BREAKPOINTS.indexOf(to);
    return indexTo - indexFrom;
};
const breakpointMax = ({ breakpoint, rules, theme }) => styled_components_browser_esm/* css */.iv `
  @media (max-width: ${theme.breakpoints[breakpoint]}px) {
    ${rules}
  }
`;
const breakpointMin = ({ breakpoint, rules, theme }) => styled_components_browser_esm/* css */.iv `
  @media (min-width: ${theme.breakpoints[breakpoint]}px) {
    ${rules}
  }
`;
//# sourceMappingURL=breakpoints.utils.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/theme.types.js
// Types.
// -----------------------------------------------------------------------------
const UI_SIZES = [
    '2xs',
    'xs',
    's',
    'm',
    'l',
    'xl',
    '2xl',
    '3xl',
    '4xl',
    '5xl',
    '6xl',
    '7xl',
    '8xl',
    '9xl',
    '10xl'
];
//# sourceMappingURL=theme.types.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Header/Header.styled.js





// styled-components.
// -----------------------------------------------------------------------------
const HeaderRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ align, as, editorial, editorialBar, size, theme }) => {
    const baseSize = size ? size : AS_RULES[as];
    const { fontWeight, fontSize, marginBottom } = SIZES_RULES[baseSize];
    const breakpoints = [];
    Object.entries(theme.breakpoints).forEach(([key, value]) => {
        if (typeof value !== 'function') {
            const breakpointDist = breakPointDistance('2xl', key);
            const baseSizeIndex = UI_SIZES.indexOf(baseSize);
            const adjustIndex = baseSizeIndex + breakpointDist - 1;
            const adjustSize = UI_SIZES[adjustIndex];
            // We add a default value just in case the adjustSize is out of bounds
            const breakPointCSS = SIZES_RULES[adjustSize] || SIZES_RULES.xs;
            const cssRules = styled_components_browser_esm/* css */.iv `
          font-size: ${breakPointCSS.fontSize};
          font-weight: ${breakPointCSS.fontWeight};
          margin-bottom: ${breakPointCSS.marginBottom};
        `;
            const breakpoint = theme.breakpoints.max({
                breakpoint: key,
                rules: cssRules,
                theme
            });
            breakpoints.push(breakpoint);
        }
    });
    const editorialCSS = !editorial || editorialBar === 'none' || as === 'h5' || as === 'h6'
        ? ''
        : styled_components_browser_esm/* css */.iv `
            position: relative;

            &::before {
              background-color: ${EDITORIAL_RULES[as]
            .color};
              content: '';
              height: ${EDITORIAL_RULES[as].height}px;
              position: absolute;
              top: calc(${getSpace('m')} * -1);
              width: ${EDITORIAL_RULES[as].width}px;

              ${editorialBar === 'center' && `left: 50%;`}
              ${editorialBar === 'center' && `transform: translateX(-50%);`}

              ${editorialBar === 'right' && `right: 0`}
            }
          `;
    return styled_components_browser_esm/* css */.iv `
      /* Common rules. */
      font-family: ${editorial
        ? theme.typography.fontEditorial
        : theme.typography.fontFamily};
      text-align: ${align};

      /* Theme */
      font-size: ${fontSize};
      font-weight: ${fontWeight};
      margin-bottom: ${marginBottom};
      margin-top: 0;

      /* Editorial */
      ${editorialCSS}

      /* Media Queries */
      ${breakpoints.reverse()}

      .wrapper {
        ${align === 'center' &&
        `
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: baseline;
          gap: 1rem;
        `}

        position: relative;

        > span {
          position: relative;
        }
      }

      .anchor {
        display: none;
        text-decoration: none;
        font-size: 1.25rem;
        top: 50%;
        margin-top: -0.75rem;

        ${(align === 'left' || align === 'inherit' || align === 'center') &&
        `
          position: absolute;
          left: -1.75rem;
          padding-right: 0.5rem;
        `}

        ${align === 'right' &&
        `
          position: absolute;
          right: -1.75rem;
          padding-left: 0.5rem;
        `}
      }

      &:hover .anchor {
        display: inline-block;
        visibility: visible;
      }
    `;
}}
`;
//# sourceMappingURL=Header.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Header/Header.js





// Component.
// -----------------------------------------------------------------------------
const Header = (0,react.forwardRef)(({ align = 'inherit', children, as, editorial = DEFAULT_HEADER_EDITORIAL, editorialBar = DEFAULT_HEADER_EDITORIAL_BAR, size, anchor, ...rest }, ref) => ((0,jsx_runtime.jsx)(HeaderRoot, { align: align, as: as, editorial: editorial, editorialBar: editorialBar, ref: ref, size: size, ...rest, children: (0,jsx_runtime.jsx)("span", { className: "wrapper", children: (0,jsx_runtime.jsxs)("span", { children: [anchor && ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)(modules/* Element */.W_, { name: anchor, id: anchor, as: "span", style: {
                                position: 'relative',
                                top: `-100px`,
                                display: 'block',
                                visibility: 'hidden',
                                height: 0,
                                width: 0
                            } }), (0,jsx_runtime.jsx)("a", { href: `#${anchor}`, className: "anchor", children: "\uD83D\uDD17" })] })), children] }) }) })));
// Component configuration.
// -----------------------------------------------------------------------------
Header.displayName = 'Header';
/* harmony default export */ var Header_Header = (Header);
//# sourceMappingURL=Header.js.map
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Icon/Icon.constants.js
// Constants.
// -----------------------------------------------------------------------------
// Default values.
const ICON_DEFAULT_SIZE = 'l';
const ICON_DEFAULT_SPIN = false;
//# sourceMappingURL=Icon.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Icon/Icon.styled.js


// styled-components.
// -----------------------------------------------------------------------------
// Animations.
const spinner = styled_components_browser_esm/* keyframes */.F4 `
  to { transform: rotate(360deg); }
`;
// styled-components
const IconRoot = styled_components_browser_esm/* default.span */.ZP.span `
  display: inline-flex;
  align-items: center;
  justify-content: center;

  /* this is the CSS class that fontawesome sets when we set the prop 'spin' to 'true'. */
  .fa-spinner-third {
    animation: ${spinner} 1s linear infinite;
  }

  ${({ size = 'l' }) => {
    return styled_components_browser_esm/* css */.iv `
      svg {
        /* Fixed */
        transition: 0.3s;
        height: auto;
        width: ${getSpace(size)};

        /* Misc */
        transition: 0.3s;
      }
    `;
}}
`;
//# sourceMappingURL=Icon.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Icon/Icon.js





// Component.
// -----------------------------------------------------------------------------
const Icon = (0,react.forwardRef)(({ icon, size = ICON_DEFAULT_SIZE, spin = ICON_DEFAULT_SPIN, ...rest }, ref) => ((0,jsx_runtime.jsx)(IconRoot, { ref: ref, size: size, spin: spin, title: rest.title || icon.iconName, ...rest, children: (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, { icon: icon }) })));
// Component configuration.
// -----------------------------------------------------------------------------
Icon.displayName = 'Icon';
/* harmony default export */ var Icon_Icon = (Icon);
//# sourceMappingURL=Icon.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Paragraph/Paragraph.constants.js
// Constants.
// -----------------------------------------------------------------------------
// Default values.
const DEFAULT_PARAGRAPH_ALIGN = 'inherit';
const DEFAULT_PARAGRAPH_VARIANTS = 'm';
//# sourceMappingURL=Paragraph.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Paragraph/Paragraph.styled.js

// styled-components.
// -----------------------------------------------------------------------------
const ParagraphRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ align, theme, variant: appVariant }) => {
    const variant = theme.typography.paragraph[appVariant];
    return styled_components_browser_esm/* css */.iv `
      color: ${theme.palette.text.primary};
      font-family: ${theme.typography.fontFamily};
      font-size: ${variant.fontSize};
      font-weight: ${theme.typography.fontWeight};
      line-height: calc(${variant.fontSize} * ${variant.lineHeight});
      text-align: ${align};
    `;
}}
`;
//# sourceMappingURL=Paragraph.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Paragraph/Paragraph.js




// Component.
// -----------------------------------------------------------------------------
const Paragraph = (0,react.forwardRef)(({ align = DEFAULT_PARAGRAPH_ALIGN, children, variant = DEFAULT_PARAGRAPH_VARIANTS, ...rest }, ref) => ((0,jsx_runtime.jsx)(ParagraphRoot, { align: align, ref: ref, variant: variant, ...rest, children: children })));
// Component configuration.
// -----------------------------------------------------------------------------
Paragraph.displayName = 'Paragraph';
/* harmony default export */ var Paragraph_Paragraph = ((/* unused pure expression or super */ null && (Paragraph)));
//# sourceMappingURL=Paragraph.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Skeleton/Skeleton.constants.js
// Constants.
// -----------------------------------------------------------------------------
const SKELETON_DEFAULT_ANIMATION = 'wave';
const SKELETON_DEFAULT_BORDER_RADIUS = '8px';
const SKELETON_DEFAULT_RADIUS = 48;
const SKELETON_DEFAULT_HEIGHT = '1.5rem';
const SKELETON_DEFAULT_VARIANT = 'rectangular';
const SKELETON_DEFAULT_WIDTH = '100%';
//# sourceMappingURL=Skeleton.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Skeleton/Skeleton.styled.js


// styled-components.
// -----------------------------------------------------------------------------
const pulseAnimation = styled_components_browser_esm/* keyframes */.F4 `
  0% { background-color: ${(tokens_default()).colors.midnight[100].value}; }
  100% { background-color: ${(tokens_default()).colors.midnight[300].value}; }
`;
const waveAnimation = styled_components_browser_esm/* keyframes */.F4 `
  to { background-position-x: -20%; }
`;
const PULSE_CSS = styled_components_browser_esm/* css */.iv `
  opacity: 0.7;
  animation: ${pulseAnimation} 1s linear infinite alternate;

  /*
  width: 100%;
  height: 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: 0.125rem;
  */
`;
const WAVE_CSS = styled_components_browser_esm/* css */.iv `
  background-color: ${(tokens_default()).colors.midnight[200].value};
  background: linear-gradient(
      100deg,
      rgba(255, 255, 255, 0) 40%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 60%
    )
    ${(tokens_default()).colors.midnight[200].value};

  background-size: 200% 100%;
  background-position-x: 180%;
  animation: ${waveAnimation} 1s ease-in-out infinite;
`;
const SkeletonCircularRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ animation, radius }) => {
    return styled_components_browser_esm/* css */.iv `
      border-radius: ${radius}px;
      height: ${radius * 2}px;
      width: ${radius * 2}px;

      ${animation === 'pulse' && PULSE_CSS}
      ${animation === 'wave' && WAVE_CSS}
    `;
}}
`;
const SkeletonRectangularRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ animation, height, width }) => {
    return styled_components_browser_esm/* css */.iv `
      height: ${height};
      width: ${width};

      ${animation === 'pulse' && PULSE_CSS}
      ${animation === 'wave' && WAVE_CSS}
    `;
}}
`;
const SkeletonRoundedRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ animation, borderRadius, height, width }) => {
    return styled_components_browser_esm/* css */.iv `
      border-radius: ${borderRadius};
      height: ${height};
      width: ${width};

      ${animation === 'pulse' && PULSE_CSS}
      ${animation === 'wave' && WAVE_CSS}
    `;
}}
`;
//# sourceMappingURL=Skeleton.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Skeleton/Skeleton.js




// Component.
// -----------------------------------------------------------------------------
const Skeleton = (0,react.forwardRef)((props, ref) => ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [props.variant === 'circular' && ((0,jsx_runtime.jsx)(SkeletonCircularRoot, { ...props, animation: props.animation ?? SKELETON_DEFAULT_ANIMATION, radius: props.radius ?? SKELETON_DEFAULT_RADIUS, ref: ref })), props.variant === 'rectangular' && ((0,jsx_runtime.jsx)(SkeletonRectangularRoot, { ...props, animation: props.animation ?? SKELETON_DEFAULT_ANIMATION, height: props.height ?? SKELETON_DEFAULT_HEIGHT, ref: ref, width: props.width ?? SKELETON_DEFAULT_WIDTH })), props.variant === 'rounded' && ((0,jsx_runtime.jsx)(SkeletonRoundedRoot, { ...props, animation: props.animation ?? SKELETON_DEFAULT_ANIMATION, borderRadius: props.borderRadius ?? SKELETON_DEFAULT_BORDER_RADIUS, height: props.height ?? SKELETON_DEFAULT_HEIGHT, ref: ref, width: props.width ?? SKELETON_DEFAULT_WIDTH }))] })));
// Component configuration.
// -----------------------------------------------------------------------------
Skeleton.displayName = 'Skeleton';
/* harmony default export */ var Skeleton_Skeleton = (Skeleton);
//# sourceMappingURL=Skeleton.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Stack/Stack.styled.js



// styled-components.
// -----------------------------------------------------------------------------
const StackRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ theme, gap, direction }) => {
    return styled_components_browser_esm/* css */.iv `
      display: flex;
      flex-direction: ${direction};
      gap: ${getSpace(gap)};

      ${breakpointMax({
        breakpoint: 'm',
        rules: styled_components_browser_esm/* css */.iv `
          flex-direction: column;
        `,
        theme
    })}
    `;
}}

  ${({ alignment }) => {
    return (alignment &&
        styled_components_browser_esm/* css */.iv `
        align-items: ${alignment};
      `);
}}

  ${({ contentAlign }) => {
    return (contentAlign &&
        styled_components_browser_esm/* css */.iv `
        justify-content: ${contentAlign};
      `);
}}

  ${({ _wrap }) => {
    return (_wrap &&
        styled_components_browser_esm/* css */.iv `
        flex-wrap: wrap;
      `);
}}
`;
const StackItemRoot = styled_components_browser_esm/* default.div */.ZP.div ``;
//# sourceMappingURL=Stack.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Stack/Stack.js



const Stack_Stack = (0,react.forwardRef)(({ direction = 'row', gap = '2xl', wrap = false, alignment, contentAlign, children, ...rest }, ref) => ((0,jsx_runtime.jsx)(StackRoot, { ref: ref, direction: direction, gap: gap, alignment: alignment, contentAlign: contentAlign, _wrap: wrap ? 'true' : undefined, ...rest, children: children })));
const StackItem = (0,react.forwardRef)(({ children, ...rest }, ref) => ((0,jsx_runtime.jsx)(StackItemRoot, { ref: ref, ...rest, children: children })));
Stack_Stack.displayName = 'Stack';
StackItem.displayName = 'StackItem';
//# sourceMappingURL=Stack.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Stack/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Text/Text.constants.js
// Constants.
// -----------------------------------------------------------------------------
// Default values.
const DEFAULT_TEXT_ALIGN = 'inherit';
const DEFAULT_TEXT_BOLD = false;
const DEFAULT_TEXT_IS_CHILDREN = false;
const DEFAULT_TEXT_SIZE = 'm';
const DEFAULT_TEXT_UPPERCASE = false;
//# sourceMappingURL=Text.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Text/Text.styled.js

// styled-components.
// -----------------------------------------------------------------------------
const TextRoot = styled_components_browser_esm/* default.span */.ZP.span `
  ${({ align, bold, theme, isTitle, uppercase, size: appSize }) => {
    const variant = theme.typography.text[appSize];
    return styled_components_browser_esm/* css */.iv `
      font-family: ${theme.typography.fontFamily};
      font-size: ${variant.fontSize};
      font-weight: ${bold || isTitle
        ? variant.fontWeight
        : theme.typography.fontWeight};
      letter-spacing: ${isTitle ? variant.letterSpacing : 1};
      text-align: ${align};
      text-transform: ${uppercase ? 'uppercase' : 'none'};
    `;
}}
`;
//# sourceMappingURL=Text.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Atoms/Text/Text.js




// Component.
// -----------------------------------------------------------------------------
const Text = (0,react.forwardRef)(({ align = DEFAULT_TEXT_ALIGN, bold = DEFAULT_TEXT_BOLD, children, isTitle = DEFAULT_TEXT_IS_CHILDREN, size = DEFAULT_TEXT_SIZE, uppercase = DEFAULT_TEXT_UPPERCASE, ...rest }, ref) => ((0,jsx_runtime.jsx)(TextRoot, { align: align, bold: bold, ref: ref, isTitle: isTitle, size: size, uppercase: uppercase, ...rest, children: children })));
// Component configuration.
// -----------------------------------------------------------------------------
Text.displayName = 'Text';
/* harmony default export */ var Text_Text = (Text);
//# sourceMappingURL=Text.js.map
// EXTERNAL MODULE: ../../node_modules/lodash/merge.js
var merge = __webpack_require__(98537);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/breakpoints.js


// Default breakpoints.
// -----------------------------------------------------------------------------
const breakpoints = {
    // Values.
    s: (tokens_default()).breakpoints.s,
    m: (tokens_default()).breakpoints.m,
    l: (tokens_default()).breakpoints.l,
    xl: (tokens_default()).breakpoints.xl,
    '2xl': (tokens_default()).breakpoints["2xl"],
    // Methods.
    max: breakpointMax,
    min: breakpointMin
};
//# sourceMappingURL=breakpoints.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/palette.schema.active.js

// Definition of the "active" color schema
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
const ACTIVE_LIGHT_HARD_DEFAULT = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.active[100].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Light + Hard + Hover
const ACTIVE_LIGHT_HARD_HOVER = {
    background: (tokens_default()).colors.navy[900].value,
    border: (tokens_default()).colors.navy[900].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Light + Hard + Pressed
const ACTIVE_LIGHT_HARD_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Light + Hard + Focus
const ACTIVE_LIGHT_HARD_FOCUS = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Light + Hard + Disabled
const ACTIVE_LIGHT_HARD_DISABLED = {
    background: 'transparent',
    border: (tokens_default()).colors.navy[700].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.navy[700].value
};
// Ligth + Soft + Default
const ACTIVE_LIGHT_WHITE_DEFAULT = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Light + Soft + Hover
const ACTIVE_LIGHT_WHITE_HOVER = {
    background: (tokens_default()).colors.navy[900].value,
    border: (tokens_default()).colors.navy[900].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Light + Soft + Pressed
const ACTIVE_LIGHT_WHITE_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Light + Soft + Focus
const ACTIVE_LIGHT_WHITE_FOCUS = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Light + Soft + Disabled
const ACTIVE_LIGHT_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Ligth + White + Default
const ACTIVE_LIGHT_SOFT_DEFAULT = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Light + White + Hover
const ACTIVE_LIGHT_SOFT_HOVER = {
    background: (tokens_default()).colors.navy[900].value,
    border: (tokens_default()).colors.navy[900].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Light + White + Pressed
const ACTIVE_LIGHT_SOFT_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Light + White + Focus
const ACTIVE_LIGHT_SOFT_FOCUS = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Light + White + Disabled
const ACTIVE_LIGHT_SOFT_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Ghost + Default
const ACTIVE_LIGHT_GHOST_DEFAULT = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Light + Ghost + Hover
const ACTIVE_LIGHT_GHOST_HOVER = {
    background: (tokens_default()).colors.navy[900].value,
    border: (tokens_default()).colors.navy[900].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Light + Ghost + Pressed
const ACTIVE_LIGHT_GHOST_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Light + Ghost + Focus
const ACTIVE_LIGHT_GHOST_FOCUS = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Light + Ghost + Disabled
const ACTIVE_LIGHT_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Bare + Default
const ACTIVE_LIGHT_BARE_DEFAULT = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Light + Bare + Hover
const ACTIVE_LIGHT_BARE_HOVER = {
    background: (tokens_default()).colors.navy[900].value,
    border: (tokens_default()).colors.navy[900].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Light + Bare + Pressed
const ACTIVE_LIGHT_BARE_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Light + Bare + Focus
const ACTIVE_LIGHT_BARE_FOCUS = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Light + Bare + Disabled
const ACTIVE_LIGHT_BARE_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
const ACTIVE_DARK_HARD_DEFAULT = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.active[100].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Dark + Hard + Hover
const ACTIVE_DARK_HARD_HOVER = {
    background: (tokens_default()).colors.navy[900].value,
    border: (tokens_default()).colors.navy[900].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Dark + Hard + Pressed
const ACTIVE_DARK_HARD_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Dark + Hard + Focus
const ACTIVE_DARK_HARD_FOCUS = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Dark + Hard + Disabled
const ACTIVE_DARK_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Soft + Default
const ACTIVE_DARK_SOFT_DEFAULT = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Dark + Soft + Hover
const ACTIVE_DARK_SOFT_HOVER = {
    background: (tokens_default()).colors.navy[900].value,
    border: (tokens_default()).colors.navy[900].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Dark + Soft + Pressed
const ACTIVE_DARK_SOFT_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Dark + Soft + Focus
const ACTIVE_DARK_SOFT_FOCUS = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Dark + Soft + Disabled
const ACTIVE_DARK_SOFT_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + White + Default
const ACTIVE_DARK_WHITE_DEFAULT = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Dark + White + Hover
const ACTIVE_DARK_WHITE_HOVER = {
    background: (tokens_default()).colors.navy[900].value,
    border: (tokens_default()).colors.navy[900].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Dark + White + Pressed
const ACTIVE_DARK_WHITE_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Dark + White + Focus
const ACTIVE_DARK_WHITE_FOCUS = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Dark + White + Disabled
const ACTIVE_DARK_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Ghost + Default
const ACTIVE_DARK_GHOST_DEFAULT = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Dark + Ghost + Hover
const ACTIVE_DARK_GHOST_HOVER = {
    background: (tokens_default()).colors.navy[900].value,
    border: (tokens_default()).colors.navy[900].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Dark + Ghost + Pressed
const ACTIVE_DARK_GHOST_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Dark + Ghost + Focus
const ACTIVE_DARK_GHOST_FOCUS = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Dark + Ghost + Disabled
const ACTIVE_DARK_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Bare + Default
const ACTIVE_DARK_BARE_DEFAULT = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Dark + Bare + Hover
const ACTIVE_DARK_BARE_HOVER = {
    background: (tokens_default()).colors.navy[900].value,
    border: (tokens_default()).colors.navy[900].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Dark + Bare + Pressed
const ACTIVE_DARK_BARE_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.active[100].value,
    foreground: (tokens_default()).colors.active[100].value
};
// Dark + Bare + Focus
const ACTIVE_DARK_BARE_FOCUS = {
    background: (tokens_default()).colors.active[100].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Dark + Bare + Disabled
const ACTIVE_DARK_BARE_DISABLED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
const ACTIVE_LIGHT_HARD = {
    default: ACTIVE_LIGHT_HARD_DEFAULT,
    disabled: ACTIVE_LIGHT_HARD_DISABLED,
    focus: ACTIVE_LIGHT_HARD_FOCUS,
    hover: ACTIVE_LIGHT_HARD_HOVER,
    pressed: ACTIVE_LIGHT_HARD_PRESSED
};
// Light + Soft
const ACTIVE_LIGHT_SOFT = {
    default: ACTIVE_LIGHT_SOFT_DEFAULT,
    disabled: ACTIVE_LIGHT_SOFT_DISABLED,
    focus: ACTIVE_LIGHT_SOFT_FOCUS,
    hover: ACTIVE_LIGHT_SOFT_HOVER,
    pressed: ACTIVE_LIGHT_SOFT_PRESSED
};
// Light + White
const ACTIVE_LIGHT_WHITE = {
    default: ACTIVE_LIGHT_WHITE_DEFAULT,
    disabled: ACTIVE_LIGHT_WHITE_DISABLED,
    focus: ACTIVE_LIGHT_WHITE_FOCUS,
    hover: ACTIVE_LIGHT_WHITE_HOVER,
    pressed: ACTIVE_LIGHT_WHITE_PRESSED
};
// Light + Ghost
const ACTIVE_LIGHT_GHOST = {
    default: ACTIVE_LIGHT_GHOST_DEFAULT,
    disabled: ACTIVE_LIGHT_GHOST_DISABLED,
    focus: ACTIVE_LIGHT_GHOST_FOCUS,
    hover: ACTIVE_LIGHT_GHOST_HOVER,
    pressed: ACTIVE_LIGHT_GHOST_PRESSED
};
// Light + Bare
const ACTIVE_LIGHT_BARE = {
    default: ACTIVE_LIGHT_BARE_DEFAULT,
    disabled: ACTIVE_LIGHT_BARE_DISABLED,
    focus: ACTIVE_LIGHT_BARE_FOCUS,
    hover: ACTIVE_LIGHT_BARE_HOVER,
    pressed: ACTIVE_LIGHT_BARE_PRESSED
};
// Dark + Hard
const ACTIVE_DARK_HARD = {
    default: ACTIVE_DARK_HARD_DEFAULT,
    disabled: ACTIVE_DARK_HARD_DISABLED,
    focus: ACTIVE_DARK_HARD_FOCUS,
    hover: ACTIVE_DARK_HARD_HOVER,
    pressed: ACTIVE_DARK_HARD_PRESSED
};
// Dark + Soft
const ACTIVE_DARK_SOFT = {
    default: ACTIVE_DARK_SOFT_DEFAULT,
    disabled: ACTIVE_DARK_SOFT_DISABLED,
    focus: ACTIVE_DARK_SOFT_FOCUS,
    hover: ACTIVE_DARK_SOFT_HOVER,
    pressed: ACTIVE_DARK_SOFT_PRESSED
};
// Dark + White
const ACTIVE_DARK_WHITE = {
    default: ACTIVE_DARK_WHITE_DEFAULT,
    disabled: ACTIVE_DARK_WHITE_DISABLED,
    focus: ACTIVE_DARK_WHITE_FOCUS,
    hover: ACTIVE_DARK_WHITE_HOVER,
    pressed: ACTIVE_DARK_WHITE_PRESSED
};
// Dark + Ghost
const ACTIVE_DARK_GHOST = {
    default: ACTIVE_DARK_GHOST_DEFAULT,
    disabled: ACTIVE_DARK_GHOST_DISABLED,
    focus: ACTIVE_DARK_GHOST_FOCUS,
    hover: ACTIVE_DARK_GHOST_HOVER,
    pressed: ACTIVE_DARK_GHOST_PRESSED
};
// Dark + Bare
const ACTIVE_DARK_BARE = {
    default: ACTIVE_DARK_BARE_DEFAULT,
    disabled: ACTIVE_DARK_BARE_DISABLED,
    focus: ACTIVE_DARK_BARE_FOCUS,
    hover: ACTIVE_DARK_BARE_HOVER,
    pressed: ACTIVE_DARK_BARE_PRESSED
};
// Light
const ACTIVE_LIGHT = {
    bare: ACTIVE_LIGHT_BARE,
    ghost: ACTIVE_LIGHT_GHOST,
    hard: ACTIVE_LIGHT_HARD,
    soft: ACTIVE_LIGHT_SOFT,
    white: ACTIVE_LIGHT_WHITE
};
// Dark
const ACTIVE_DARK = {
    bare: ACTIVE_DARK_BARE,
    ghost: ACTIVE_DARK_GHOST,
    hard: ACTIVE_DARK_HARD,
    soft: ACTIVE_DARK_SOFT,
    white: ACTIVE_DARK_WHITE
};
// Color schema
const ACTIVE = {
    dark: ACTIVE_DARK,
    light: ACTIVE_LIGHT
};
/* harmony default export */ var palette_schema_active = (ACTIVE);
//# sourceMappingURL=palette.schema.active.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/palette.schema.brand1.js

// Definition of the "brand1" color scheme
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
const BRAND1_LIGHT_HARD_DEFAULT = {
    background: (tokens_default()).colors.navy[700].value,
    border: (tokens_default()).colors.navy[700].value,
    foregroundAlt: (tokens_default()).colors.navy[400].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Light + Hard + Hover
const BRAND1_LIGHT_HARD_HOVER = {
    background: (tokens_default()).colors.navy[500].value,
    border: (tokens_default()).colors.navy[500].value,
    foregroundAlt: (tokens_default()).colors.navy[300].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Light + Hard + Pressed
const BRAND1_LIGHT_HARD_PRESSED = {
    background: (tokens_default()).colors.navy[200].value,
    border: (tokens_default()).colors.navy[200].value,
    foregroundAlt: (tokens_default()).colors.navy[400].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Light + Hard + Focus
const BRAND1_LIGHT_HARD_FOCUS = {
    background: (tokens_default()).colors.navy[700].value,
    border: (tokens_default()).colors.navy[700].value,
    foregroundAlt: (tokens_default()).colors.navy[400].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Light + Hard + Disabled
const BRAND1_LIGHT_HARD_DISABLED = {
    background: 'transparent',
    border: (tokens_default()).colors.navy[700].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.navy[700].value
};
// Light + White + Default
const BRAND1_LIGHT_WHITE_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.navy[300].value,
    foregroundAlt: (tokens_default()).colors.navy[300].value,
    foreground: (tokens_default()).colors.navy[700].value
};
// Light + White + Hover
const BRAND1_LIGHT_WHITE_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.navy[500].value,
    foregroundAlt: (tokens_default()).colors.navy[500].value,
    foreground: (tokens_default()).colors.navy[700].value
};
// Light + White + Pressed
const BRAND1_LIGHT_WHITE_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.navy[300].value,
    foregroundAlt: (tokens_default()).colors.navy[300].value,
    foreground: (tokens_default()).colors.navy[300].value
};
// Light + White + Focus
const BRAND1_LIGHT_WHITE_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.navy[700].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.navy[700].value
};
// Light + White + Disabled
const BRAND1_LIGHT_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Ghost + Default
const BRAND1_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[800].value,
    foreground: (tokens_default()).colors.navy[800].value
};
// Light + Ghost + Hover
const BRAND1_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.navy[500].value,
    foregroundAlt: (tokens_default()).colors.navy[500].value,
    foreground: (tokens_default()).colors.navy[500].value
};
// Light + Ghost + Pressed
const BRAND1_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.navy[300].value,
    foregroundAlt: (tokens_default()).colors.navy[300].value,
    foreground: (tokens_default()).colors.navy[300].value
};
// Light + Ghost + Focus
const BRAND1_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.navy[700].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.navy[700].value
};
// Light + Ghost + Disabled
const BRAND1_LIGHT_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Bare + Default
const BRAND1_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.navy[500].value,
    foreground: (tokens_default()).colors.navy[700].value
};
// Light + Bare + Hover
const BRAND1_LIGHT_BARE_HOVER = {
    background: (tokens_default()).colors.navy[150].value,
    border: (tokens_default()).colors.navy[150].value,
    foregroundAlt: (tokens_default()).colors.navy[400].value,
    foreground: (tokens_default()).colors.navy[700].value
};
// Light + Bare + Pressed
const BRAND1_LIGHT_BARE_PRESSED = {
    background: (tokens_default()).colors.navy[200].value,
    border: (tokens_default()).colors.navy[200].value,
    foregroundAlt: (tokens_default()).colors.navy[400].value,
    foreground: (tokens_default()).colors.navy[400].value
};
// Light + Bare + Focus
const BRAND1_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.navy[700].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.navy[700].value
};
// Light + Bare + Disabled
const BRAND1_LIGHT_BARE_DISABLED = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
const BRAND1_DARK_HARD_DEFAULT = {
    background: (tokens_default()).colors.navy[500].value,
    border: (tokens_default()).colors.navy[500].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.black[100].value
};
// Dark + Hard + Hover
const BRAND1_DARK_HARD_HOVER = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[600].value,
    foreground: (tokens_default()).colors.navy[600].value
};
// Dark + Hard + Pressed
const BRAND1_DARK_HARD_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.black[100].value
};
// Dark + Hard + Focus
const BRAND1_DARK_HARD_FOCUS = {
    background: (tokens_default()).colors.navy[500].value,
    border: (tokens_default()).colors.navy[500].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.black[100].value
};
// Dark + Hard + Disabled
const BRAND1_DARK_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + White + Default
const BRAND1_DARK_WHITE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.navy[700].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.navy[300].value
};
// Dark + White + Hover
const BRAND1_DARK_WHITE_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.navy[600].value,
    foregroundAlt: (tokens_default()).colors.navy[500].value,
    foreground: (tokens_default()).colors.navy[300].value
};
// Dark + White + Pressed
const BRAND1_DARK_WHITE_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.navy[700].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.navy[700].value
};
// Dark + White + Focus
const BRAND1_DARK_WHITE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.navy[300].value,
    foregroundAlt: (tokens_default()).colors.navy[300].value,
    foreground: (tokens_default()).colors.navy[300].value
};
// Dark + White + Disabled
const BRAND1_DARK_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Ghost + Default
const BRAND1_DARK_GHOST_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.navy[300].value,
    foregroundAlt: (tokens_default()).colors.navy[300].value,
    foreground: (tokens_default()).colors.navy[300].value
};
// Dark + Ghost + Hover
const BRAND1_DARK_GHOST_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.navy[500].value,
    foregroundAlt: (tokens_default()).colors.navy[500].value,
    foreground: (tokens_default()).colors.navy[500].value
};
// Dark + Ghost + Pressed
const BRAND1_DARK_GHOST_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.navy[700].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.navy[700].value
};
// Dark + Ghost + Focus
const BRAND1_DARK_GHOST_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.navy[300].value,
    foregroundAlt: (tokens_default()).colors.navy[300].value,
    foreground: (tokens_default()).colors.navy[300].value
};
// Dark + Ghost + Disabled
const BRAND1_DARK_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Bare + Default
const BRAND1_DARK_BARE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.navy[300].value
};
// Dark + Bare + Hover
const BRAND1_DARK_BARE_HOVER = {
    background: (tokens_default()).colors.navy[850].value,
    border: (tokens_default()).colors.navy[850].value,
    foregroundAlt: (tokens_default()).colors.navy[700].value,
    foreground: (tokens_default()).colors.navy[300].value
};
// Dark + Bare + Pressed
const BRAND1_DARK_BARE_PRESSED = {
    background: (tokens_default()).colors.navy[800].value,
    border: (tokens_default()).colors.navy[800].value,
    foregroundAlt: (tokens_default()).colors.navy[600].value,
    foreground: (tokens_default()).colors.navy[600].value
};
// Dark + Bare + Focus
const BRAND1_DARK_BARE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.navy[300].value,
    foregroundAlt: (tokens_default()).colors.navy[300].value,
    foreground: (tokens_default()).colors.navy[300].value
};
// Dark + Bare + Disabled
const BRAND1_DARK_BARE_DISABLED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
const BRAND1_LIGHT_HARD = {
    default: BRAND1_LIGHT_HARD_DEFAULT,
    disabled: BRAND1_LIGHT_HARD_DISABLED,
    focus: BRAND1_LIGHT_HARD_FOCUS,
    hover: BRAND1_LIGHT_HARD_HOVER,
    pressed: BRAND1_LIGHT_HARD_PRESSED
};
// Light + White
const BRAND1_LIGHT_WHITE = {
    default: BRAND1_LIGHT_WHITE_DEFAULT,
    disabled: BRAND1_LIGHT_WHITE_DISABLED,
    focus: BRAND1_LIGHT_WHITE_FOCUS,
    hover: BRAND1_LIGHT_WHITE_HOVER,
    pressed: BRAND1_LIGHT_WHITE_PRESSED
};
// Light + Ghost
const BRAND1_LIGHT_GHOST = {
    default: BRAND1_LIGHT_GHOST_DEFAULT,
    disabled: BRAND1_LIGHT_GHOST_DISABLED,
    focus: BRAND1_LIGHT_GHOST_FOCUS,
    hover: BRAND1_LIGHT_GHOST_HOVER,
    pressed: BRAND1_LIGHT_GHOST_PRESSED
};
// Light + Bare
const BRAND1_LIGHT_BARE = {
    default: BRAND1_LIGHT_BARE_DEFAULT,
    disabled: BRAND1_LIGHT_BARE_DISABLED,
    focus: BRAND1_LIGHT_BARE_FOCUS,
    hover: BRAND1_LIGHT_BARE_HOVER,
    pressed: BRAND1_LIGHT_BARE_PRESSED
};
// Dark + Hard
const BRAND1_DARK_HARD = {
    default: BRAND1_DARK_HARD_DEFAULT,
    disabled: BRAND1_DARK_HARD_DISABLED,
    focus: BRAND1_DARK_HARD_FOCUS,
    hover: BRAND1_DARK_HARD_HOVER,
    pressed: BRAND1_DARK_HARD_PRESSED
};
// Dark + White
const BRAND1_DARK_WHITE = {
    default: BRAND1_DARK_WHITE_DEFAULT,
    disabled: BRAND1_DARK_WHITE_DISABLED,
    focus: BRAND1_DARK_WHITE_FOCUS,
    hover: BRAND1_DARK_WHITE_HOVER,
    pressed: BRAND1_DARK_WHITE_PRESSED
};
// Dark + Ghost
const BRAND1_DARK_GHOST = {
    default: BRAND1_DARK_GHOST_DEFAULT,
    disabled: BRAND1_DARK_GHOST_DISABLED,
    focus: BRAND1_DARK_GHOST_FOCUS,
    hover: BRAND1_DARK_GHOST_HOVER,
    pressed: BRAND1_DARK_GHOST_PRESSED
};
// Dark + Bare
const BRAND1_DARK_BARE = {
    default: BRAND1_DARK_BARE_DEFAULT,
    disabled: BRAND1_DARK_BARE_DISABLED,
    focus: BRAND1_DARK_BARE_FOCUS,
    hover: BRAND1_DARK_BARE_HOVER,
    pressed: BRAND1_DARK_BARE_PRESSED
};
// Light
const BRAND1_LIGHT = {
    bare: BRAND1_LIGHT_BARE,
    ghost: BRAND1_LIGHT_GHOST,
    hard: BRAND1_LIGHT_HARD,
    // This color scheme does not have "Soft" but for convenience we match it to "Hard".
    soft: BRAND1_LIGHT_HARD,
    white: BRAND1_LIGHT_WHITE
};
// Dark
const BRAND1_DARK = {
    bare: BRAND1_DARK_BARE,
    ghost: BRAND1_DARK_GHOST,
    hard: BRAND1_DARK_HARD,
    // This color scheme does not have "Soft" but for convenience we match it to "Hard".
    soft: BRAND1_DARK_WHITE,
    white: BRAND1_DARK_WHITE
};
// Color schema
const BRAND1 = {
    dark: BRAND1_DARK,
    light: BRAND1_LIGHT
};
/* harmony default export */ var palette_schema_brand1 = (BRAND1);
//# sourceMappingURL=palette.schema.brand1.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/palette.schema.brand2.js

// Definition of the "brand2" color scheme
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
const BRAND2_LIGHT_HARD_DEFAULT = {
    background: (tokens_default()).colors.emerald[700].value,
    border: (tokens_default()).colors.emerald[700].value,
    foregroundAlt: (tokens_default()).colors.emerald[400].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Light + Hard + Hover
const BRAND2_LIGHT_HARD_HOVER = {
    background: (tokens_default()).colors.emerald[600].value,
    border: (tokens_default()).colors.emerald[600].value,
    foregroundAlt: (tokens_default()).colors.emerald[300].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Light + Hard + Pressed
const BRAND2_LIGHT_HARD_PRESSED = {
    background: (tokens_default()).colors.emerald[200].value,
    border: (tokens_default()).colors.emerald[200].value,
    foregroundAlt: (tokens_default()).colors.emerald[500].value,
    foreground: (tokens_default()).colors.emerald[500].value
};
// Light + Hard + Focus
const BRAND2_LIGHT_HARD_FOCUS = {
    background: (tokens_default()).colors.emerald[700].value,
    border: (tokens_default()).colors.emerald[700].value,
    foregroundAlt: (tokens_default()).colors.emerald[400].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Light + Hard + Disabled
const BRAND2_LIGHT_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[300].value,
    border: (tokens_default()).colors.midnight[300].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + White + Default
const BRAND2_LIGHT_WHITE_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.emerald[300].value,
    foregroundAlt: (tokens_default()).colors.emerald[300].value,
    foreground: (tokens_default()).colors.emerald[700].value
};
// Light + White + Hover
const BRAND2_LIGHT_WHITE_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.emerald[500].value,
    foregroundAlt: (tokens_default()).colors.emerald[500].value,
    foreground: (tokens_default()).colors.emerald[700].value
};
// Light + White + Pressed
const BRAND2_LIGHT_WHITE_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.emerald[300].value,
    foregroundAlt: (tokens_default()).colors.emerald[300].value,
    foreground: (tokens_default()).colors.emerald[300].value
};
// Light + White + Focus
const BRAND2_LIGHT_WHITE_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.emerald[700].value,
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.emerald[700].value
};
// Light + White + Disabled
const BRAND2_LIGHT_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Secondary + Default
const BRAND2_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.emerald[700].value,
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.emerald[700].value
};
// Light + Secondary + Hover
const BRAND2_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.emerald[500].value,
    foregroundAlt: (tokens_default()).colors.emerald[500].value,
    foreground: (tokens_default()).colors.emerald[500].value
};
// Light + Secondary + Pressed
const BRAND2_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.emerald[300].value,
    foregroundAlt: (tokens_default()).colors.emerald[300].value,
    foreground: (tokens_default()).colors.emerald[300].value
};
// Light + Secondary + Focus
const BRAND2_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.emerald[700].value,
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.emerald[700].value
};
// Light + Secondary + Disabled
const BRAND2_LIGHT_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Bare + Default
const BRAND2_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.emerald[700].value
};
// Light + Bare + Hover
const BRAND2_LIGHT_BARE_HOVER = {
    background: (tokens_default()).colors.emerald[150].value,
    border: (tokens_default()).colors.emerald[150].value,
    foregroundAlt: (tokens_default()).colors.emerald[400].value,
    foreground: (tokens_default()).colors.emerald[700].value
};
// Light + Bare + Pressed
const BRAND2_LIGHT_BARE_PRESSED = {
    background: (tokens_default()).colors.emerald[200].value,
    border: (tokens_default()).colors.emerald[200].value,
    foregroundAlt: (tokens_default()).colors.emerald[400].value,
    foreground: (tokens_default()).colors.emerald[400].value
};
// Light + Bare + Focus
const BRAND2_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.emerald[700].value,
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.emerald[700].value
};
// Light + Bare + Disabled
const BRAND2_LIGHT_BARE_DISABLED = {
    background: 'transparent',
    border: (tokens_default()).colors.emerald[100].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
const BRAND2_DARK_HARD_DEFAULT = {
    background: (tokens_default()).colors.emerald[500].value,
    border: (tokens_default()).colors.emerald[500].value,
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.black[100].value
};
// Dark + Hard + Hover
const BRAND2_DARK_HARD_HOVER = {
    background: (tokens_default()).colors.emerald[300].value,
    border: (tokens_default()).colors.emerald[300].value,
    foregroundAlt: (tokens_default()).colors.emerald[600].value,
    foreground: (tokens_default()).colors.black[100].value
};
// Dark + Hard + Pressed
const BRAND2_DARK_HARD_PRESSED = {
    background: (tokens_default()).colors.emerald[800].value,
    border: (tokens_default()).colors.emerald[800].value,
    foregroundAlt: (tokens_default()).colors.emerald[600].value,
    foreground: (tokens_default()).colors.emerald[600].value
};
// Dark + Hard + Focus
const BRAND2_DARK_HARD_FOCUS = {
    background: (tokens_default()).colors.emerald[500].value,
    border: (tokens_default()).colors.emerald[500].value,
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.black[100].value
};
// Dark + Hard + Disabled
const BRAND2_DARK_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + White + Default
const BRAND2_DARK_WHITE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.emerald[700].value,
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.emerald[300].value
};
// Dark + White + Hover
const BRAND2_DARK_WHITE_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.emerald[600].value,
    foregroundAlt: (tokens_default()).colors.emerald[500].value,
    foreground: (tokens_default()).colors.emerald[300].value
};
// Dark + White + Pressed
const BRAND2_DARK_WHITE_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.emerald[700].value,
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.emerald[700].value
};
// Dark + White + Focus
const BRAND2_DARK_WHITE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.emerald[300].value,
    foregroundAlt: (tokens_default()).colors.emerald[300].value,
    foreground: (tokens_default()).colors.emerald[300].value
};
// Dark + White + Disabled
const BRAND2_DARK_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Secondary + Default
const BRAND2_DARK_GHOST_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.emerald[300].value,
    foregroundAlt: (tokens_default()).colors.emerald[300].value,
    foreground: (tokens_default()).colors.emerald[300].value
};
// Dark + Secondary + Hover
const BRAND2_DARK_GHOST_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.emerald[500].value,
    foregroundAlt: (tokens_default()).colors.emerald[500].value,
    foreground: (tokens_default()).colors.emerald[500].value
};
// Dark + Secondary + Pressed
const BRAND2_DARK_GHOST_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.emerald[700].value,
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.emerald[700].value
};
// Dark + Secondary + Focus
const BRAND2_DARK_GHOST_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.emerald[300].value,
    foregroundAlt: (tokens_default()).colors.emerald[300].value,
    foreground: (tokens_default()).colors.emerald[300].value
};
// Dark + Secondary + Disabled
const BRAND2_DARK_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Bare + Default
const BRAND2_DARK_BARE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.emerald[300].value
};
// Dark + Bare + Hover
const BRAND2_DARK_BARE_HOVER = {
    background: (tokens_default()).colors.emerald[850].value,
    border: (tokens_default()).colors.emerald[850].value,
    foregroundAlt: (tokens_default()).colors.emerald[600].value,
    foreground: (tokens_default()).colors.emerald[600].value
};
// Dark + Bare + Pressed
const BRAND2_DARK_BARE_PRESSED = {
    background: (tokens_default()).colors.emerald[800].value,
    border: (tokens_default()).colors.emerald[800].value,
    foregroundAlt: (tokens_default()).colors.emerald[700].value,
    foreground: (tokens_default()).colors.emerald[300].value
};
// Dark + Bare + Focus
const BRAND2_DARK_BARE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.emerald[300].value,
    foregroundAlt: (tokens_default()).colors.emerald[300].value,
    foreground: (tokens_default()).colors.emerald[300].value
};
// Dark + Bare + Disabled
const BRAND2_DARK_BARE_DISABLED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
const BRAND2_LIGHT_HARD = {
    default: BRAND2_LIGHT_HARD_DEFAULT,
    disabled: BRAND2_LIGHT_HARD_DISABLED,
    focus: BRAND2_LIGHT_HARD_FOCUS,
    hover: BRAND2_LIGHT_HARD_HOVER,
    pressed: BRAND2_LIGHT_HARD_PRESSED
};
// Light + White
const BRAND2_LIGHT_WHITE = {
    default: BRAND2_LIGHT_WHITE_DEFAULT,
    disabled: BRAND2_LIGHT_WHITE_DISABLED,
    focus: BRAND2_LIGHT_WHITE_FOCUS,
    hover: BRAND2_LIGHT_WHITE_HOVER,
    pressed: BRAND2_LIGHT_WHITE_PRESSED
};
// Light + Ghost
const BRAND2_LIGHT_GHOST = {
    default: BRAND2_LIGHT_GHOST_DEFAULT,
    disabled: BRAND2_LIGHT_GHOST_DISABLED,
    focus: BRAND2_LIGHT_GHOST_FOCUS,
    hover: BRAND2_LIGHT_GHOST_HOVER,
    pressed: BRAND2_LIGHT_GHOST_PRESSED
};
// Light + Bare
const BRAND2_LIGHT_BARE = {
    default: BRAND2_LIGHT_BARE_DEFAULT,
    disabled: BRAND2_LIGHT_BARE_DISABLED,
    focus: BRAND2_LIGHT_BARE_FOCUS,
    hover: BRAND2_LIGHT_BARE_HOVER,
    pressed: BRAND2_LIGHT_BARE_PRESSED
};
// Dark + Hard
const BRAND2_DARK_HARD = {
    default: BRAND2_DARK_HARD_DEFAULT,
    disabled: BRAND2_DARK_HARD_DISABLED,
    focus: BRAND2_DARK_HARD_FOCUS,
    hover: BRAND2_DARK_HARD_HOVER,
    pressed: BRAND2_DARK_HARD_PRESSED
};
// Dark + White
const BRAND2_DARK_WHITE = {
    default: BRAND2_DARK_WHITE_DEFAULT,
    disabled: BRAND2_DARK_WHITE_DISABLED,
    focus: BRAND2_DARK_WHITE_FOCUS,
    hover: BRAND2_DARK_WHITE_HOVER,
    pressed: BRAND2_DARK_WHITE_PRESSED
};
// Dark + Ghost
const BRAND2_DARK_GHOST = {
    default: BRAND2_DARK_GHOST_DEFAULT,
    disabled: BRAND2_DARK_GHOST_DISABLED,
    focus: BRAND2_DARK_GHOST_FOCUS,
    hover: BRAND2_DARK_GHOST_HOVER,
    pressed: BRAND2_DARK_GHOST_PRESSED
};
// Dark + Bare
const BRAND2_DARK_BARE = {
    default: BRAND2_DARK_BARE_DEFAULT,
    disabled: BRAND2_DARK_BARE_DISABLED,
    focus: BRAND2_DARK_BARE_FOCUS,
    hover: BRAND2_DARK_BARE_HOVER,
    pressed: BRAND2_DARK_BARE_PRESSED
};
// Light
const BRAND2_LIGHT = {
    bare: BRAND2_LIGHT_BARE,
    ghost: BRAND2_LIGHT_GHOST,
    hard: BRAND2_LIGHT_HARD,
    // This color scheme does not have "Soft" but for convenience we match it to "Hard".
    soft: BRAND2_LIGHT_HARD,
    white: BRAND2_LIGHT_WHITE
};
// Dark
const BRAND2_DARK = {
    bare: BRAND2_DARK_BARE,
    ghost: BRAND2_DARK_GHOST,
    hard: BRAND2_DARK_HARD,
    // This color scheme does not have "Soft" but for convenience we match it to "Hard".
    soft: BRAND2_DARK_HARD,
    white: BRAND2_DARK_WHITE
};
// Color schema
const BRAND2 = {
    dark: BRAND2_DARK,
    light: BRAND2_LIGHT
};
/* harmony default export */ var palette_schema_brand2 = (BRAND2);
//# sourceMappingURL=palette.schema.brand2.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/palette.schema.info.js

// Definition of the "info" color schema
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
const INFO_LIGHT_HARD_DEFAULT = {
    background: (tokens_default()).colors.blue[400].value,
    border: (tokens_default()).colors.blue[400].value,
    foregroundAlt: (tokens_default()).colors.blue[700].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Light + Hard + Hover
const INFO_LIGHT_HARD_HOVER = {
    background: (tokens_default()).colors.blue[500].value,
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[800].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Light + Hard + Pressed
const INFO_LIGHT_HARD_PRESSED = {
    background: (tokens_default()).colors.blue[600].value,
    border: (tokens_default()).colors.blue[600].value,
    foregroundAlt: (tokens_default()).colors.blue[900].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Light + Hard + Focus
const INFO_LIGHT_HARD_FOCUS = {
    background: (tokens_default()).colors.blue[400].value,
    border: (tokens_default()).colors.blue[400].value,
    foregroundAlt: (tokens_default()).colors.blue[700].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Light + Hard + Disabled
const INFO_LIGHT_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[150].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Soft + Default
const INFO_LIGHT_SOFT_DEFAULT = {
    background: (tokens_default()).colors.blue[200].value,
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Light + Soft + Hover
const INFO_LIGHT_SOFT_HOVER = {
    background: (tokens_default()).colors.blue[300].value,
    border: (tokens_default()).colors.blue[600].value,
    foregroundAlt: (tokens_default()).colors.blue[600].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Light + Soft + Pressed
const INFO_LIGHT_SOFT_PRESSED = {
    background: (tokens_default()).colors.blue[400].value,
    border: (tokens_default()).colors.blue[700].value,
    foregroundAlt: (tokens_default()).colors.blue[700].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Light + Soft + Focus
const INFO_LIGHT_SOFT_FOCUS = {
    background: (tokens_default()).colors.blue[200].value,
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Light + Soft + Disabled
const INFO_LIGHT_SOFT_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + White + Default
const INFO_LIGHT_WHITE_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[700].value
};
// Light + White + Hover
const INFO_LIGHT_WHITE_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.blue[700].value,
    foregroundAlt: (tokens_default()).colors.blue[700].value,
    foreground: (tokens_default()).colors.blue[700].value
};
// Light + White + Pressed
const INFO_LIGHT_WHITE_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[500].value
};
// Light + White + Focus
const INFO_LIGHT_WHITE_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[700].value
};
// Light + White + Disabled
const INFO_LIGHT_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Ghost + Default
const INFO_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[700].value
};
// Light + Ghost + Hover
const INFO_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.blue[700].value,
    foregroundAlt: (tokens_default()).colors.blue[700].value,
    foreground: (tokens_default()).colors.blue[700].value
};
// Light + Ghost + Pressed
const INFO_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[500].value
};
// Light + Ghost + Focus
const INFO_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[700].value
};
// Light + Ghost + Disabled
const INFO_LIGHT_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Bare + Default
const INFO_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[700].value
};
// Light + Bare + Hover
const INFO_LIGHT_BARE_HOVER = {
    background: (tokens_default()).colors.blue[150].value,
    border: (tokens_default()).colors.blue[150].value,
    foregroundAlt: (tokens_default()).colors.blue[600].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Light + Bare + Pressed
const INFO_LIGHT_BARE_PRESSED = {
    background: (tokens_default()).colors.blue[200].value,
    border: (tokens_default()).colors.blue[200].value,
    foregroundAlt: (tokens_default()).colors.blue[700].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Light + Bare + Focus
const INFO_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[700].value
};
// Light + Bare + Disabled
const INFO_LIGHT_BARE_DISABLED = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
const INFO_DARK_HARD_DEFAULT = {
    background: (tokens_default()).colors.blue[400].value,
    border: (tokens_default()).colors.blue[400].value,
    foregroundAlt: (tokens_default()).colors.blue[700].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Dark + Hard + Hover
const INFO_DARK_HARD_HOVER = {
    background: (tokens_default()).colors.blue[500].value,
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[800].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Dark + Hard + Pressed
const INFO_DARK_HARD_PRESSED = {
    background: (tokens_default()).colors.blue[600].value,
    border: (tokens_default()).colors.blue[600].value,
    foregroundAlt: (tokens_default()).colors.blue[900].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Dark + Hard + Focus
const INFO_DARK_HARD_FOCUS = {
    background: (tokens_default()).colors.blue[400].value,
    border: (tokens_default()).colors.blue[400].value,
    foregroundAlt: (tokens_default()).colors.blue[700].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Dark + Hard + Disabled
const INFO_DARK_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Soft + Default
const INFO_DARK_SOFT_DEFAULT = {
    background: (tokens_default()).colors.blue[200].value,
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Dark + Soft + Hover
const INFO_DARK_SOFT_HOVER = {
    background: (tokens_default()).colors.blue[300].value,
    border: (tokens_default()).colors.blue[600].value,
    foregroundAlt: (tokens_default()).colors.blue[600].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Dark + Soft + Pressed
const INFO_DARK_SOFT_PRESSED = {
    background: (tokens_default()).colors.blue[400].value,
    border: (tokens_default()).colors.blue[700].value,
    foregroundAlt: (tokens_default()).colors.blue[700].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Dark + Soft + Focus
const INFO_DARK_SOFT_FOCUS = {
    background: (tokens_default()).colors.blue[200].value,
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[900].value
};
// Dark + Soft + Disabled
const INFO_DARK_SOFT_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + White + Default
const INFO_DARK_WHITE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[500].value
};
// Dark + White + Hover
const INFO_DARK_WHITE_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.blue[300].value,
    foregroundAlt: (tokens_default()).colors.blue[300].value,
    foreground: (tokens_default()).colors.blue[300].value
};
// Dark + White + Pressed
const INFO_DARK_WHITE_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.blue[700].value,
    foregroundAlt: (tokens_default()).colors.blue[700].value,
    foreground: (tokens_default()).colors.blue[700].value
};
// Dark + White + Focus
const INFO_DARK_WHITE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[500].value
};
// Dark + White + Disabled
const INFO_DARK_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Ghost + Default
const INFO_DARK_GHOST_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[500].value
};
// Dark + Ghost + Hover
const INFO_DARK_GHOST_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.blue[300].value,
    foregroundAlt: (tokens_default()).colors.blue[300].value,
    foreground: (tokens_default()).colors.blue[300].value
};
// Dark + Ghost + Pressed
const INFO_DARK_GHOST_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.blue[700].value,
    foregroundAlt: (tokens_default()).colors.blue[700].value,
    foreground: (tokens_default()).colors.blue[700].value
};
// Dark + Ghost + Focus
const INFO_DARK_GHOST_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[500].value
};
// Dark + Ghost + Disabled
const INFO_DARK_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Bare + Default
const INFO_DARK_BARE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[500].value
};
// Dark + Bare + Hover
const INFO_DARK_BARE_HOVER = {
    background: (tokens_default()).colors.blue[850].value,
    border: (tokens_default()).colors.blue[850].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[500].value
};
// Dark + Bare + Pressed
const INFO_DARK_BARE_PRESSED = {
    background: (tokens_default()).colors.blue[800].value,
    border: (tokens_default()).colors.blue[800].value,
    foregroundAlt: (tokens_default()).colors.blue[300].value,
    foreground: (tokens_default()).colors.blue[300].value
};
// Dark + Bare + Focus
const INFO_DARK_BARE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.blue[500].value,
    foregroundAlt: (tokens_default()).colors.blue[500].value,
    foreground: (tokens_default()).colors.blue[500].value
};
// Dark + Bare + Disabled
const INFO_DARK_BARE_DISABLED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
const INFO_LIGHT_HARD = {
    default: INFO_LIGHT_HARD_DEFAULT,
    disabled: INFO_LIGHT_HARD_DISABLED,
    focus: INFO_LIGHT_HARD_FOCUS,
    hover: INFO_LIGHT_HARD_HOVER,
    pressed: INFO_LIGHT_HARD_PRESSED
};
// Light + Soft
const INFO_LIGHT_SOFT = {
    default: INFO_LIGHT_SOFT_DEFAULT,
    disabled: INFO_LIGHT_SOFT_DISABLED,
    focus: INFO_LIGHT_SOFT_FOCUS,
    hover: INFO_LIGHT_SOFT_HOVER,
    pressed: INFO_LIGHT_SOFT_PRESSED
};
// Light + White
const INFO_LIGHT_WHITE = {
    default: INFO_LIGHT_WHITE_DEFAULT,
    disabled: INFO_LIGHT_WHITE_DISABLED,
    focus: INFO_LIGHT_WHITE_FOCUS,
    hover: INFO_LIGHT_WHITE_HOVER,
    pressed: INFO_LIGHT_WHITE_PRESSED
};
// Light + Ghost
const INFO_LIGHT_GHOST = {
    default: INFO_LIGHT_GHOST_DEFAULT,
    disabled: INFO_LIGHT_GHOST_DISABLED,
    focus: INFO_LIGHT_GHOST_FOCUS,
    hover: INFO_LIGHT_GHOST_HOVER,
    pressed: INFO_LIGHT_GHOST_PRESSED
};
// Light + Bare
const INFO_LIGHT_BARE = {
    default: INFO_LIGHT_BARE_DEFAULT,
    disabled: INFO_LIGHT_BARE_DISABLED,
    focus: INFO_LIGHT_BARE_FOCUS,
    hover: INFO_LIGHT_BARE_HOVER,
    pressed: INFO_LIGHT_BARE_PRESSED
};
// Dark + Hard
const INFO_DARK_HARD = {
    default: INFO_DARK_HARD_DEFAULT,
    disabled: INFO_DARK_HARD_DISABLED,
    focus: INFO_DARK_HARD_FOCUS,
    hover: INFO_DARK_HARD_HOVER,
    pressed: INFO_DARK_HARD_PRESSED
};
// Dark + Soft
const INFO_DARK_SOFT = {
    default: INFO_DARK_SOFT_DEFAULT,
    disabled: INFO_DARK_SOFT_DISABLED,
    focus: INFO_DARK_SOFT_FOCUS,
    hover: INFO_DARK_SOFT_HOVER,
    pressed: INFO_DARK_SOFT_PRESSED
};
// Dark + White
const INFO_DARK_WHITE = {
    default: INFO_DARK_WHITE_DEFAULT,
    disabled: INFO_DARK_WHITE_DISABLED,
    focus: INFO_DARK_WHITE_FOCUS,
    hover: INFO_DARK_WHITE_HOVER,
    pressed: INFO_DARK_WHITE_PRESSED
};
// Dark + Ghost
const INFO_DARK_GHOST = {
    default: INFO_DARK_GHOST_DEFAULT,
    disabled: INFO_DARK_GHOST_DISABLED,
    focus: INFO_DARK_GHOST_FOCUS,
    hover: INFO_DARK_GHOST_HOVER,
    pressed: INFO_DARK_GHOST_PRESSED
};
// Dark + Bare
const INFO_DARK_BARE = {
    default: INFO_DARK_BARE_DEFAULT,
    disabled: INFO_DARK_BARE_DISABLED,
    focus: INFO_DARK_BARE_FOCUS,
    hover: INFO_DARK_BARE_HOVER,
    pressed: INFO_DARK_BARE_PRESSED
};
// Light
const INFO_LIGHT = {
    bare: INFO_LIGHT_BARE,
    ghost: INFO_LIGHT_GHOST,
    hard: INFO_LIGHT_HARD,
    soft: INFO_LIGHT_SOFT,
    white: INFO_LIGHT_WHITE
};
// Dark
const INFO_DARK = {
    bare: INFO_DARK_BARE,
    ghost: INFO_DARK_GHOST,
    hard: INFO_DARK_HARD,
    soft: INFO_DARK_SOFT,
    white: INFO_DARK_WHITE
};
// Color schema
const INFO = {
    dark: INFO_DARK,
    light: INFO_LIGHT
};
/* harmony default export */ var palette_schema_info = (INFO);
//# sourceMappingURL=palette.schema.info.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/palette.schema.negative.js

// Definition of the "negative" color schema
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Hard
const NEGATIVE_LIGHT_HARD_DEFAULT = {
    background: (tokens_default()).colors.red[600].value,
    border: (tokens_default()).colors.red[600].value,
    foregroundAlt: (tokens_default()).colors.red[200].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Light + Hard + Hover
const NEGATIVE_LIGHT_HARD_HOVER = {
    background: (tokens_default()).colors.red[700].value,
    border: (tokens_default()).colors.red[700].value,
    foregroundAlt: (tokens_default()).colors.red[300].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Light + Hard + Pressed
const NEGATIVE_LIGHT_HARD_PRESSED = {
    background: (tokens_default()).colors.red[800].value,
    border: (tokens_default()).colors.red[800].value,
    foregroundAlt: (tokens_default()).colors.red[400].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Light + Hard + Focus
const NEGATIVE_LIGHT_HARD_FOCUS = {
    background: (tokens_default()).colors.red[600].value,
    border: (tokens_default()).colors.red[600].value,
    foregroundAlt: (tokens_default()).colors.red[200].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Light + Hard + Disabled
const NEGATIVE_LIGHT_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[150].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Soft + Default
const NEGATIVE_LIGHT_SOFT_DEFAULT = {
    background: (tokens_default()).colors.red[100].value,
    border: (tokens_default()).colors.red[300].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Light + Soft + Hover
const NEGATIVE_LIGHT_SOFT_HOVER = {
    background: (tokens_default()).colors.red[200].value,
    border: (tokens_default()).colors.red[400].value,
    foregroundAlt: (tokens_default()).colors.red[600].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Light + Soft + Pressed
const NEGATIVE_LIGHT_SOFT_PRESSED = {
    background: (tokens_default()).colors.red[300].value,
    border: (tokens_default()).colors.red[500].value,
    foregroundAlt: (tokens_default()).colors.red[700].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Light + Soft + Focus
const NEGATIVE_LIGHT_SOFT_FOCUS = {
    background: (tokens_default()).colors.red[100].value,
    border: (tokens_default()).colors.red[300].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Light + Soft + Disabled
const NEGATIVE_LIGHT_SOFT_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + White + Default
const NEGATIVE_LIGHT_WHITE_DEFAULT = {
    background: (tokens_default()).colors.red[100].value,
    border: (tokens_default()).colors.red[300].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Light + White + Hover
const NEGATIVE_LIGHT_WHITE_HOVER = {
    background: (tokens_default()).colors.red[200].value,
    border: (tokens_default()).colors.red[400].value,
    foregroundAlt: (tokens_default()).colors.red[600].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Light + White + Pressed
const NEGATIVE_LIGHT_WHITE_PRESSED = {
    background: (tokens_default()).colors.red[300].value,
    border: (tokens_default()).colors.red[500].value,
    foregroundAlt: (tokens_default()).colors.red[700].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Light + White + Focus
const NEGATIVE_LIGHT_WHITE_FOCUS = {
    background: (tokens_default()).colors.red[100].value,
    border: (tokens_default()).colors.red[300].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Light + White + Dissabled
const NEGATIVE_LIGHT_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Ghost + Hard
const NEGATIVE_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.red[500].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[700].value
};
// Light + Ghost + Hover
const NEGATIVE_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.red[700].value,
    foregroundAlt: (tokens_default()).colors.red[700].value,
    foreground: (tokens_default()).colors.red[700].value
};
// Light + Ghost + Pressed
const NEGATIVE_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.red[500].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[500].value
};
// Light + Ghost + Focus
const NEGATIVE_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.red[500].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[700].value
};
// Light + Ghost + Disabled
const NEGATIVE_LIGHT_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Bare + Hard
const NEGATIVE_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[700].value
};
// Light + Bare + Hover
const NEGATIVE_LIGHT_BARE_HOVER = {
    background: (tokens_default()).colors.red[150].value,
    border: (tokens_default()).colors.red[150].value,
    foregroundAlt: (tokens_default()).colors.red[600].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Light + Bare + Pressed
const NEGATIVE_LIGHT_BARE_PRESSED = {
    background: (tokens_default()).colors.red[200].value,
    border: (tokens_default()).colors.red[200].value,
    foregroundAlt: (tokens_default()).colors.red[600].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Light + Bare + Focus
const NEGATIVE_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Bare + Disabled
const NEGATIVE_LIGHT_BARE_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Hard
const NEGATIVE_DARK_HARD_DEFAULT = {
    background: (tokens_default()).colors.red[600].value,
    border: (tokens_default()).colors.red[600].value,
    foregroundAlt: (tokens_default()).colors.red[200].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Dark + Hard + Hover
const NEGATIVE_DARK_HARD_HOVER = {
    background: (tokens_default()).colors.red[700].value,
    border: (tokens_default()).colors.red[700].value,
    foregroundAlt: (tokens_default()).colors.red[300].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Dark + Hard + Pressed
const NEGATIVE_DARK_HARD_PRESSED = {
    background: (tokens_default()).colors.red[800].value,
    border: (tokens_default()).colors.red[800].value,
    foregroundAlt: (tokens_default()).colors.red[400].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Dark + Hard + Focus
const NEGATIVE_DARK_HARD_FOCUS = {
    background: (tokens_default()).colors.red[600].value,
    border: (tokens_default()).colors.red[600].value,
    foregroundAlt: (tokens_default()).colors.red[200].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Dark + Hard + Disabled
const NEGATIVE_DARK_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Soft + Default
const NEGATIVE_DARK_SOFT_DEFAULT = {
    background: (tokens_default()).colors.red[600].value,
    border: (tokens_default()).colors.red[600].value,
    foregroundAlt: (tokens_default()).colors.red[200].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Dark + Soft + Hover
const NEGATIVE_DARK_SOFT_HOVER = {
    background: (tokens_default()).colors.red[700].value,
    border: (tokens_default()).colors.red[700].value,
    foregroundAlt: (tokens_default()).colors.red[300].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Dark + Soft + Pressed
const NEGATIVE_DARK_SOFT_PRESSED = {
    background: (tokens_default()).colors.red[800].value,
    border: (tokens_default()).colors.red[800].value,
    foregroundAlt: (tokens_default()).colors.red[400].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Dark + Soft + Focus
const NEGATIVE_DARK_SOFT_FOCUS = {
    background: (tokens_default()).colors.red[600].value,
    border: (tokens_default()).colors.red[600].value,
    foregroundAlt: (tokens_default()).colors.red[200].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Dark + Soft + Disabled
const NEGATIVE_DARK_SOFT_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + White + Default
const NEGATIVE_DARK_WHITE_DEFAULT = {
    background: (tokens_default()).colors.red[100].value,
    border: (tokens_default()).colors.red[300].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Dark + White + Hover
const NEGATIVE_DARK_WHITE_HOVER = {
    background: (tokens_default()).colors.red[200].value,
    border: (tokens_default()).colors.red[400].value,
    foregroundAlt: (tokens_default()).colors.red[600].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Dark + White + Pressed
const NEGATIVE_DARK_WHITE_PRESSED = {
    background: (tokens_default()).colors.red[300].value,
    border: (tokens_default()).colors.red[500].value,
    foregroundAlt: (tokens_default()).colors.red[700].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Dark + White + Focus
const NEGATIVE_DARK_WHITE_FOCUS = {
    background: (tokens_default()).colors.red[100].value,
    border: (tokens_default()).colors.red[300].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[900].value
};
// Dark + White + Dissabled
const NEGATIVE_DARK_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Ghost + Hard
const NEGATIVE_DARK_GHOST_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.red[500].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[500].value
};
// Dark + Ghost + Hover
const NEGATIVE_DARK_GHOST_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.red[300].value,
    foregroundAlt: (tokens_default()).colors.red[300].value,
    foreground: (tokens_default()).colors.red[300].value
};
// Dark + Ghost + Pressed
const NEGATIVE_DARK_GHOST_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.red[700].value,
    foregroundAlt: (tokens_default()).colors.red[700].value,
    foreground: (tokens_default()).colors.red[700].value
};
// Dark + Ghost + Focus
const NEGATIVE_DARK_GHOST_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.red[500].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[500].value
};
// Dark + Ghost + Disabled
const NEGATIVE_DARK_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Bare + Hard
const NEGATIVE_DARK_BARE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[500].value
};
// Dark + Bare + Hover
const NEGATIVE_DARK_BARE_HOVER = {
    background: (tokens_default()).colors.red[850].value,
    border: (tokens_default()).colors.red[850].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Dark + Bare + Pressed
const NEGATIVE_DARK_BARE_PRESSED = {
    background: (tokens_default()).colors.red[900].value,
    border: (tokens_default()).colors.red[900].value,
    foregroundAlt: (tokens_default()).colors.red[300].value,
    foreground: (tokens_default()).colors.white[100].value
};
// Dark + Bare + Focus
const NEGATIVE_DARK_BARE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.red[500].value,
    foregroundAlt: (tokens_default()).colors.red[500].value,
    foreground: (tokens_default()).colors.red[500].value
};
// Dark + Bare + Disabled
const NEGATIVE_DARK_BARE_DISABLED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
const NEGATIVE_LIGHT_HARD = {
    default: NEGATIVE_LIGHT_HARD_DEFAULT,
    disabled: NEGATIVE_LIGHT_HARD_DISABLED,
    focus: NEGATIVE_LIGHT_HARD_FOCUS,
    hover: NEGATIVE_LIGHT_HARD_HOVER,
    pressed: NEGATIVE_LIGHT_HARD_PRESSED
};
// Light + Soft
const NEGATIVE_LIGHT_SOFT = {
    default: NEGATIVE_LIGHT_SOFT_DEFAULT,
    disabled: NEGATIVE_LIGHT_SOFT_DISABLED,
    focus: NEGATIVE_LIGHT_SOFT_FOCUS,
    hover: NEGATIVE_LIGHT_SOFT_HOVER,
    pressed: NEGATIVE_LIGHT_SOFT_PRESSED
};
// Light + White
const NEGATIVE_LIGHT_WHITE = {
    default: NEGATIVE_LIGHT_WHITE_DEFAULT,
    disabled: NEGATIVE_LIGHT_WHITE_DISABLED,
    focus: NEGATIVE_LIGHT_WHITE_FOCUS,
    hover: NEGATIVE_LIGHT_WHITE_HOVER,
    pressed: NEGATIVE_LIGHT_WHITE_PRESSED
};
// Light + Ghost
const NEGATIVE_LIGHT_GHOST = {
    default: NEGATIVE_LIGHT_GHOST_DEFAULT,
    disabled: NEGATIVE_LIGHT_GHOST_DISABLED,
    focus: NEGATIVE_LIGHT_GHOST_FOCUS,
    hover: NEGATIVE_LIGHT_GHOST_HOVER,
    pressed: NEGATIVE_LIGHT_GHOST_PRESSED
};
// Light + Bare
const NEGATIVE_LIGHT_BARE = {
    default: NEGATIVE_LIGHT_BARE_DEFAULT,
    disabled: NEGATIVE_LIGHT_BARE_DISABLED,
    focus: NEGATIVE_LIGHT_BARE_FOCUS,
    hover: NEGATIVE_LIGHT_BARE_HOVER,
    pressed: NEGATIVE_LIGHT_BARE_PRESSED
};
// Dark + Hard
const NEGATIVE_DARK_HARD = {
    default: NEGATIVE_DARK_HARD_DEFAULT,
    disabled: NEGATIVE_DARK_HARD_DISABLED,
    focus: NEGATIVE_DARK_HARD_FOCUS,
    hover: NEGATIVE_DARK_HARD_HOVER,
    pressed: NEGATIVE_DARK_HARD_PRESSED
};
// Dark + Soft
const NEGATIVE_DARK_SOFT = {
    default: NEGATIVE_DARK_SOFT_DEFAULT,
    disabled: NEGATIVE_DARK_SOFT_DISABLED,
    focus: NEGATIVE_DARK_SOFT_FOCUS,
    hover: NEGATIVE_DARK_SOFT_HOVER,
    pressed: NEGATIVE_DARK_SOFT_PRESSED
};
// Dark + White
const NEGATIVE_DARK_WHITE = {
    default: NEGATIVE_DARK_WHITE_DEFAULT,
    disabled: NEGATIVE_DARK_WHITE_DISABLED,
    focus: NEGATIVE_DARK_WHITE_FOCUS,
    hover: NEGATIVE_DARK_WHITE_HOVER,
    pressed: NEGATIVE_DARK_WHITE_PRESSED
};
// Dark + Ghost
const NEGATIVE_DARK_GHOST = {
    default: NEGATIVE_DARK_GHOST_DEFAULT,
    disabled: NEGATIVE_DARK_GHOST_DISABLED,
    focus: NEGATIVE_DARK_GHOST_FOCUS,
    hover: NEGATIVE_DARK_GHOST_HOVER,
    pressed: NEGATIVE_DARK_GHOST_PRESSED
};
// Dark + Bare
const NEGATIVE_DARK_BARE = {
    default: NEGATIVE_DARK_BARE_DEFAULT,
    disabled: NEGATIVE_DARK_BARE_DISABLED,
    focus: NEGATIVE_DARK_BARE_FOCUS,
    hover: NEGATIVE_DARK_BARE_HOVER,
    pressed: NEGATIVE_DARK_BARE_PRESSED
};
// Light
const NEGATIVE_LIGHT = {
    bare: NEGATIVE_LIGHT_BARE,
    ghost: NEGATIVE_LIGHT_GHOST,
    hard: NEGATIVE_LIGHT_HARD,
    soft: NEGATIVE_LIGHT_SOFT,
    white: NEGATIVE_LIGHT_WHITE
};
// Dark
const NEGATIVE_DARK = {
    bare: NEGATIVE_DARK_BARE,
    ghost: NEGATIVE_DARK_GHOST,
    hard: NEGATIVE_DARK_HARD,
    soft: NEGATIVE_DARK_SOFT,
    white: NEGATIVE_DARK_WHITE
};
// Color schema
const NEGATIVE = {
    dark: NEGATIVE_DARK,
    light: NEGATIVE_LIGHT
};
/* harmony default export */ var palette_schema_negative = (NEGATIVE);
//# sourceMappingURL=palette.schema.negative.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/palette.schema.neutral.js

// Definition of the "neutral" color scheme
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
const NEUTRAL_LIGHT_HARD_DEFAULT = {
    background: (tokens_default()).colors.midnight[800].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[600].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Light + Hard + Hover
const NEUTRAL_LIGHT_HARD_HOVER = {
    background: (tokens_default()).colors.midnight[600].value,
    border: (tokens_default()).colors.midnight[600].value,
    foregroundAlt: (tokens_default()).colors.midnight[400].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Light + Hard + Pressed
const NEUTRAL_LIGHT_HARD_PRESSED = {
    background: (tokens_default()).colors.midnight[200].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[400].value,
    foreground: (tokens_default()).colors.midnight[400].value,
    active: (tokens_default()).colors.active[100].value
};
// Light + Hard + Focus
const NEUTRAL_LIGHT_HARD_FOCUS = {
    background: (tokens_default()).colors.midnight[800].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[600].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Light + Hard + Disabled
const NEUTRAL_LIGHT_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[300].value,
    border: (tokens_default()).colors.midnight[300].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Light + White + Default
const NEUTRAL_LIGHT_WHITE_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[300].value,
    foreground: (tokens_default()).colors.midnight[800].value,
    active: (tokens_default()).colors.active[100].value
};
// Light + White + Hover
const NEUTRAL_LIGHT_WHITE_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.midnight[400].value,
    foregroundAlt: (tokens_default()).colors.midnight[400].value,
    foreground: (tokens_default()).colors.midnight[800].value,
    active: (tokens_default()).colors.active[100].value
};
// Light + White + Pressed
const NEUTRAL_LIGHT_WHITE_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Light + White + Focus
const NEUTRAL_LIGHT_WHITE_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Light + White + Disabled
const NEUTRAL_LIGHT_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Ghost + Default
const NEUTRAL_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Light + Ghost + Hover
const NEUTRAL_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.midnight[400].value,
    foregroundAlt: (tokens_default()).colors.midnight[400].value,
    foreground: (tokens_default()).colors.midnight[400].value
};
// Light + Ghost + Pressd
const NEUTRAL_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Ghost + Focus
const NEUTRAL_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Light + Ghost + Disabled
const NEUTRAL_LIGHT_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Bare + Default
const NEUTRAL_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.midnight[300].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Light + Bare + Hover
const NEUTRAL_LIGHT_BARE_HOVER = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[150].value,
    foregroundAlt: (tokens_default()).colors.midnight[400].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Light + Bare + Pressed
const NEUTRAL_LIGHT_BARE_PRESSED = {
    background: (tokens_default()).colors.midnight[200].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[400].value,
    foreground: (tokens_default()).colors.midnight[400].value
};
// Light + Bare + Focus
const NEUTRAL_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Light + Bare + Disabled
const NEUTRAL_LIGHT_BARE_DISABLED = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
const NEUTRAL_DARK_HARD_DEFAULT = {
    background: (tokens_default()).colors.midnight[200].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[400].value,
    foreground: (tokens_default()).colors.midnight[800].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Hard + Hover
const NEUTRAL_DARK_HARD_HOVER = {
    background: (tokens_default()).colors.midnight[400].value,
    border: (tokens_default()).colors.midnight[400].value,
    foregroundAlt: (tokens_default()).colors.midnight[600].value,
    foreground: (tokens_default()).colors.midnight[800].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Hard + Pressed
const NEUTRAL_DARK_HARD_PRESSED = {
    background: (tokens_default()).colors.midnight[800].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[600].value,
    foreground: (tokens_default()).colors.midnight[600].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Hard + Focus
const NEUTRAL_DARK_HARD_FOCUS = {
    background: (tokens_default()).colors.midnight[200].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[400].value,
    foreground: (tokens_default()).colors.midnight[800].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Hard + Disabled
const NEUTRAL_DARK_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[700].value,
    border: (tokens_default()).colors.midnight[700].value,
    foregroundAlt: (tokens_default()).colors.midnight[850].value,
    foreground: (tokens_default()).colors.midnight[850].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + White + Default
const NEUTRAL_DARK_WHITE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.midnight[700].value,
    foregroundAlt: (tokens_default()).colors.midnight[700].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + White + Hover
const NEUTRAL_DARK_WHITE_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.midnight[500].value,
    foregroundAlt: (tokens_default()).colors.midnight[500].value,
    foreground: (tokens_default()).colors.midnight[800].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + White + Pressed
const NEUTRAL_DARK_WHITE_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.midnight[700].value,
    foregroundAlt: (tokens_default()).colors.midnight[700].value,
    foreground: (tokens_default()).colors.midnight[700].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + White + Focus
const NEUTRAL_DARK_WHITE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + White + Disabled
const NEUTRAL_DARK_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[700].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[850].value,
    foreground: (tokens_default()).colors.midnight[850].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Ghost + Default
const NEUTRAL_DARK_GHOST_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Ghost + Hover
const NEUTRAL_DARK_GHOST_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.midnight[500].value,
    foregroundAlt: (tokens_default()).colors.midnight[500].value,
    foreground: (tokens_default()).colors.midnight[500].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Ghost + Pressd
const NEUTRAL_DARK_GHOST_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.midnight[700].value,
    foregroundAlt: (tokens_default()).colors.midnight[700].value,
    foreground: (tokens_default()).colors.midnight[700].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Ghost + Focus
const NEUTRAL_DARK_GHOST_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Ghost + Disabled
const NEUTRAL_DARK_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[700].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[850].value,
    foreground: (tokens_default()).colors.midnight[850].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Bare + Default
const NEUTRAL_DARK_BARE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.midnight[700].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Bare + Hover
const NEUTRAL_DARK_BARE_HOVER = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[600].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Bare + Pressed
const NEUTRAL_DARK_BARE_PRESSED = {
    background: (tokens_default()).colors.midnight[800].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[600].value,
    foreground: (tokens_default()).colors.midnight[600].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Bare + Focus
const NEUTRAL_DARK_BARE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value,
    active: (tokens_default()).colors.active[100].value
};
// Dark + Bare + Disabled
const NEUTRAL_DARK_BARE_DISABLED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value,
    active: (tokens_default()).colors.active[100].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
const NEUTRAL_LIGHT_HARD = {
    default: NEUTRAL_LIGHT_HARD_DEFAULT,
    disabled: NEUTRAL_LIGHT_HARD_DISABLED,
    focus: NEUTRAL_LIGHT_HARD_FOCUS,
    hover: NEUTRAL_LIGHT_HARD_HOVER,
    pressed: NEUTRAL_LIGHT_HARD_PRESSED
};
// Light + White
const NEUTRAL_LIGHT_WHITE = {
    default: NEUTRAL_LIGHT_WHITE_DEFAULT,
    disabled: NEUTRAL_LIGHT_WHITE_DISABLED,
    focus: NEUTRAL_LIGHT_WHITE_FOCUS,
    hover: NEUTRAL_LIGHT_WHITE_HOVER,
    pressed: NEUTRAL_LIGHT_WHITE_PRESSED
};
// Light + Ghost
const NEUTRAL_LIGHT_GHOST = {
    default: NEUTRAL_LIGHT_GHOST_DEFAULT,
    disabled: NEUTRAL_LIGHT_GHOST_DISABLED,
    focus: NEUTRAL_LIGHT_GHOST_FOCUS,
    hover: NEUTRAL_LIGHT_GHOST_HOVER,
    pressed: NEUTRAL_LIGHT_GHOST_PRESSED
};
// Light + Bare
const NEUTRAL_LIGHT_BARE = {
    default: NEUTRAL_LIGHT_BARE_DEFAULT,
    disabled: NEUTRAL_LIGHT_BARE_DISABLED,
    focus: NEUTRAL_LIGHT_BARE_FOCUS,
    hover: NEUTRAL_LIGHT_BARE_HOVER,
    pressed: NEUTRAL_LIGHT_BARE_PRESSED
};
// Dark + Hard
const NEUTRAL_DARK_HARD = {
    default: NEUTRAL_DARK_HARD_DEFAULT,
    disabled: NEUTRAL_DARK_HARD_DISABLED,
    focus: NEUTRAL_DARK_HARD_FOCUS,
    hover: NEUTRAL_DARK_HARD_HOVER,
    pressed: NEUTRAL_DARK_HARD_PRESSED
};
// Dark + White
const NEUTRAL_DARK_WHITE = {
    default: NEUTRAL_DARK_WHITE_DEFAULT,
    disabled: NEUTRAL_DARK_WHITE_DISABLED,
    focus: NEUTRAL_DARK_WHITE_FOCUS,
    hover: NEUTRAL_DARK_WHITE_HOVER,
    pressed: NEUTRAL_DARK_WHITE_PRESSED
};
// Dark + Ghost
const NEUTRAL_DARK_GHOST = {
    default: NEUTRAL_DARK_GHOST_DEFAULT,
    disabled: NEUTRAL_DARK_GHOST_DISABLED,
    focus: NEUTRAL_DARK_GHOST_FOCUS,
    hover: NEUTRAL_DARK_GHOST_HOVER,
    pressed: NEUTRAL_DARK_GHOST_PRESSED
};
// Dark + Bare
const NEUTRAL_DARK_BARE = {
    default: NEUTRAL_DARK_BARE_DEFAULT,
    disabled: NEUTRAL_DARK_BARE_DISABLED,
    focus: NEUTRAL_DARK_BARE_FOCUS,
    hover: NEUTRAL_DARK_BARE_HOVER,
    pressed: NEUTRAL_DARK_BARE_PRESSED
};
// Light
const NEUTRAL_LIGHT = {
    bare: NEUTRAL_LIGHT_BARE,
    ghost: NEUTRAL_LIGHT_GHOST,
    hard: NEUTRAL_LIGHT_HARD,
    // This color scheme does not have "Soft" but for convenience we match it to "Hard".
    soft: NEUTRAL_LIGHT_HARD,
    white: NEUTRAL_LIGHT_WHITE
};
// Dark
const NEUTRAL_DARK = {
    bare: NEUTRAL_DARK_BARE,
    ghost: NEUTRAL_DARK_GHOST,
    hard: NEUTRAL_DARK_HARD,
    // This color scheme does not have "Soft" but for convenience we match it to "Hard".
    soft: NEUTRAL_DARK_HARD,
    white: NEUTRAL_DARK_WHITE
};
// Color schema
const NEUTRAL = {
    dark: NEUTRAL_DARK,
    light: NEUTRAL_LIGHT
};
/* harmony default export */ var palette_schema_neutral = (NEUTRAL);
//# sourceMappingURL=palette.schema.neutral.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/palette.schema.notice.js

// Definition of the "notice" color scheme
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
const NOTICE_LIGHT_HARD_DEFAULT = {
    background: (tokens_default()).colors.yellow[400].value,
    border: (tokens_default()).colors.yellow[400].value,
    foregroundAlt: (tokens_default()).colors.yellow[700].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Light + Hard + Hover
const NOTICE_LIGHT_HARD_HOVER = {
    background: (tokens_default()).colors.yellow[500].value,
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[800].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Light + Hard + Pressed
const NOTICE_LIGHT_HARD_PRESSED = {
    background: (tokens_default()).colors.yellow[600].value,
    border: (tokens_default()).colors.yellow[600].value,
    foregroundAlt: (tokens_default()).colors.yellow[900].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Light + Hard + Focus
const NOTICE_LIGHT_HARD_FOCUS = {
    background: (tokens_default()).colors.yellow[400].value,
    border: (tokens_default()).colors.yellow[700].value,
    foregroundAlt: (tokens_default()).colors.yellow[900].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Light + Hard + Disabled
const NOTICE_LIGHT_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[150].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Soft + Default
const NOTICE_LIGHT_SOFT_DEFAULT = {
    background: (tokens_default()).colors.yellow[200].value,
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Light + Soft + Hover
const NOTICE_LIGHT_SOFT_HOVER = {
    background: (tokens_default()).colors.yellow[300].value,
    border: (tokens_default()).colors.yellow[600].value,
    foregroundAlt: (tokens_default()).colors.yellow[600].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Light + Soft + Pressed
const NOTICE_LIGHT_SOFT_PRESSED = {
    background: (tokens_default()).colors.yellow[400].value,
    border: (tokens_default()).colors.yellow[700].value,
    foregroundAlt: (tokens_default()).colors.yellow[700].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Light + Soft + Focus
const NOTICE_LIGHT_SOFT_FOCUS = {
    background: (tokens_default()).colors.yellow[200].value,
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Light + Soft + Disabled
const NOTICE_LIGHT_SOFT_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + White + Default
const NOTICE_LIGHT_WHITE_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[700].value
};
// Light + White + Hover
const NOTICE_LIGHT_WHITE_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.yellow[700].value,
    foregroundAlt: (tokens_default()).colors.yellow[700].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Light + White + Pressed
const NOTICE_LIGHT_WHITE_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[500].value
};
// Light + White + Focus
const NOTICE_LIGHT_WHITE_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[700].value
};
// Light + White + Disabled
const NOTICE_LIGHT_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Ghost + Default
const NOTICE_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[700].value
};
// Light + Ghost + Hover
const NOTICE_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.yellow[700].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[700].value
};
// Light + Ghost + Pressed
const NOTICE_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[500].value
};
// Light + Ghost + Focus
const NOTICE_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[700].value
};
// Light + Ghost + Disabled
const NOTICE_LIGHT_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Bare + Default
const NOTICE_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[700].value
};
// Light + Bare + Hover
const NOTICE_LIGHT_BARE_HOVER = {
    background: (tokens_default()).colors.yellow[150].value,
    border: (tokens_default()).colors.yellow[150].value,
    foregroundAlt: (tokens_default()).colors.yellow[600].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Light + Bare + Pressed
const NOTICE_LIGHT_BARE_PRESSED = {
    background: (tokens_default()).colors.yellow[200].value,
    border: (tokens_default()).colors.yellow[200].value,
    foregroundAlt: (tokens_default()).colors.yellow[700].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Light + Bare + Focus
const NOTICE_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[700].value
};
// Light + Bare + Disabled
const NOTICE_LIGHT_BARE_DISABLED = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
const NOTICE_DARK_HARD_DEFAULT = {
    background: (tokens_default()).colors.yellow[400].value,
    border: (tokens_default()).colors.yellow[400].value,
    foregroundAlt: (tokens_default()).colors.yellow[700].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Dark + Hard + Hover
const NOTICE_DARK_HARD_HOVER = {
    background: (tokens_default()).colors.yellow[500].value,
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[800].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Dark + Hard + Pressed
const NOTICE_DARK_HARD_PRESSED = {
    background: (tokens_default()).colors.yellow[600].value,
    border: (tokens_default()).colors.yellow[600].value,
    foregroundAlt: (tokens_default()).colors.yellow[900].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Dark + Hard + Focus
const NOTICE_DARK_HARD_FOCUS = {
    background: (tokens_default()).colors.yellow[400].value,
    border: (tokens_default()).colors.yellow[400].value,
    foregroundAlt: (tokens_default()).colors.yellow[700].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Dark + Hard + Disabled
const NOTICE_DARK_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Soft + Default
const NOTICE_DARK_SOFT_DEFAULT = {
    background: (tokens_default()).colors.yellow[200].value,
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Dark + Soft + Hover
const NOTICE_DARK_SOFT_HOVER = {
    background: (tokens_default()).colors.yellow[300].value,
    border: (tokens_default()).colors.yellow[600].value,
    foregroundAlt: (tokens_default()).colors.yellow[600].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Dark + Soft + Pressed
const NOTICE_DARK_SOFT_PRESSED = {
    background: (tokens_default()).colors.yellow[400].value,
    border: (tokens_default()).colors.yellow[700].value,
    foregroundAlt: (tokens_default()).colors.yellow[700].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Dark + Soft + Focus
const NOTICE_DARK_SOFT_FOCUS = {
    background: (tokens_default()).colors.yellow[200].value,
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[900].value
};
// Dark + Soft + Disabled
const NOTICE_DARK_SOFT_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + White + Default
const NOTICE_DARK_WHITE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[500].value
};
// Dark + White + Hover
const NOTICE_DARK_WHITE_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.yellow[300].value,
    foregroundAlt: (tokens_default()).colors.yellow[300].value,
    foreground: (tokens_default()).colors.yellow[300].value
};
// Dark + White + Pressed
const NOTICE_DARK_WHITE_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.yellow[700].value,
    foregroundAlt: (tokens_default()).colors.yellow[700].value,
    foreground: (tokens_default()).colors.yellow[700].value
};
// Dark + White + Focus
const NOTICE_DARK_WHITE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[500].value
};
// Dark + White + Disabled
const NOTICE_DARK_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Ghost + Default
const NOTICE_DARK_GHOST_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[500].value
};
// Dark + Ghost + Hover
const NOTICE_DARK_GHOST_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.yellow[300].value,
    foregroundAlt: (tokens_default()).colors.yellow[300].value,
    foreground: (tokens_default()).colors.yellow[300].value
};
// Dark + Ghost + Pressed
const NOTICE_DARK_GHOST_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.yellow[700].value,
    foregroundAlt: (tokens_default()).colors.yellow[700].value,
    foreground: (tokens_default()).colors.yellow[700].value
};
// Dark + Ghost + Focus
const NOTICE_DARK_GHOST_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[500].value
};
// Dark + Ghost + Disabled
const NOTICE_DARK_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Bare + Default
const NOTICE_DARK_BARE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[500].value
};
// Dark + Bare + Hover
const NOTICE_DARK_BARE_HOVER = {
    background: (tokens_default()).colors.yellow[850].value,
    border: (tokens_default()).colors.yellow[850].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[500].value
};
// Dark + Bare + Pressed
const NOTICE_DARK_BARE_PRESSED = {
    background: (tokens_default()).colors.yellow[900].value,
    border: (tokens_default()).colors.yellow[900].value,
    foregroundAlt: (tokens_default()).colors.yellow[300].value,
    foreground: (tokens_default()).colors.yellow[300].value
};
// Dark + Bare + Focus
const NOTICE_DARK_BARE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.yellow[500].value,
    foregroundAlt: (tokens_default()).colors.yellow[500].value,
    foreground: (tokens_default()).colors.yellow[500].value
};
// Dark + Bare + Disabled
const NOTICE_DARK_BARE_DISABLED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
const NOTICE_LIGHT_HARD = {
    default: NOTICE_LIGHT_HARD_DEFAULT,
    disabled: NOTICE_LIGHT_HARD_DISABLED,
    focus: NOTICE_LIGHT_HARD_FOCUS,
    hover: NOTICE_LIGHT_HARD_HOVER,
    pressed: NOTICE_LIGHT_HARD_PRESSED
};
// Light + Soft
const NOTICE_LIGHT_SOFT = {
    default: NOTICE_LIGHT_SOFT_DEFAULT,
    disabled: NOTICE_LIGHT_SOFT_DISABLED,
    focus: NOTICE_LIGHT_SOFT_FOCUS,
    hover: NOTICE_LIGHT_SOFT_HOVER,
    pressed: NOTICE_LIGHT_SOFT_PRESSED
};
// Light + White
const NOTICE_LIGHT_WHITE = {
    default: NOTICE_LIGHT_WHITE_DEFAULT,
    disabled: NOTICE_LIGHT_WHITE_DISABLED,
    focus: NOTICE_LIGHT_WHITE_FOCUS,
    hover: NOTICE_LIGHT_WHITE_HOVER,
    pressed: NOTICE_LIGHT_WHITE_PRESSED
};
// Light + Ghost
const NOTICE_LIGHT_GHOST = {
    default: NOTICE_LIGHT_GHOST_DEFAULT,
    disabled: NOTICE_LIGHT_GHOST_DISABLED,
    focus: NOTICE_LIGHT_GHOST_FOCUS,
    hover: NOTICE_LIGHT_GHOST_HOVER,
    pressed: NOTICE_LIGHT_GHOST_PRESSED
};
// Light + Bare
const NOTICE_LIGHT_BARE = {
    default: NOTICE_LIGHT_BARE_DEFAULT,
    disabled: NOTICE_LIGHT_BARE_DISABLED,
    focus: NOTICE_LIGHT_BARE_FOCUS,
    hover: NOTICE_LIGHT_BARE_HOVER,
    pressed: NOTICE_LIGHT_BARE_PRESSED
};
// Dark+ Hard
const NOTICE_DARK_HARD = {
    default: NOTICE_DARK_HARD_DEFAULT,
    disabled: NOTICE_DARK_HARD_DISABLED,
    focus: NOTICE_DARK_HARD_FOCUS,
    hover: NOTICE_DARK_HARD_HOVER,
    pressed: NOTICE_DARK_HARD_PRESSED
};
// Dark+ Soft
const NOTICE_DARK_SOFT = {
    default: NOTICE_DARK_SOFT_DEFAULT,
    disabled: NOTICE_DARK_SOFT_DISABLED,
    focus: NOTICE_DARK_SOFT_FOCUS,
    hover: NOTICE_DARK_SOFT_HOVER,
    pressed: NOTICE_DARK_SOFT_PRESSED
};
// Dark+ White
const NOTICE_DARK_WHITE = {
    default: NOTICE_DARK_WHITE_DEFAULT,
    disabled: NOTICE_DARK_WHITE_DISABLED,
    focus: NOTICE_DARK_WHITE_FOCUS,
    hover: NOTICE_DARK_WHITE_HOVER,
    pressed: NOTICE_DARK_WHITE_PRESSED
};
// Dark + Ghost
const NOTICE_DARK_GHOST = {
    default: NOTICE_DARK_GHOST_DEFAULT,
    disabled: NOTICE_DARK_GHOST_DISABLED,
    focus: NOTICE_DARK_GHOST_FOCUS,
    hover: NOTICE_DARK_GHOST_HOVER,
    pressed: NOTICE_DARK_GHOST_PRESSED
};
// Dark + BARE
const NOTICE_DARK_BARE = {
    default: NOTICE_DARK_BARE_DEFAULT,
    disabled: NOTICE_DARK_BARE_DISABLED,
    focus: NOTICE_DARK_BARE_FOCUS,
    hover: NOTICE_DARK_BARE_HOVER,
    pressed: NOTICE_DARK_BARE_PRESSED
};
// Light
const NOTICE_LIGHT = {
    bare: NOTICE_LIGHT_BARE,
    ghost: NOTICE_LIGHT_GHOST,
    hard: NOTICE_LIGHT_HARD,
    soft: NOTICE_LIGHT_SOFT,
    white: NOTICE_LIGHT_WHITE
};
// Dark
const NOTICE_DARK = {
    bare: NOTICE_LIGHT_BARE,
    ghost: NOTICE_LIGHT_GHOST,
    hard: NOTICE_LIGHT_HARD,
    soft: NOTICE_LIGHT_SOFT,
    white: NOTICE_LIGHT_WHITE
};
// Color schema
const NOTICE = {
    dark: NOTICE_DARK,
    light: NOTICE_LIGHT
};
/* harmony default export */ var palette_schema_notice = (NOTICE);
//# sourceMappingURL=palette.schema.notice.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/palette.schema.positive.js

// Definition of the "positive" color scheme
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
const POSITIVE_LIGHT_HARD_DEFAULT = {
    background: (tokens_default()).colors.green[400].value,
    border: (tokens_default()).colors.green[400].value,
    foregroundAlt: (tokens_default()).colors.green[700].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + Hard + Hover
const POSITIVE_LIGHT_HARD_HOVER = {
    background: (tokens_default()).colors.green[500].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[800].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + Hard + Pressed
const POSITIVE_LIGHT_HARD_PRESSED = {
    background: (tokens_default()).colors.green[600].value,
    border: (tokens_default()).colors.green[600].value,
    foregroundAlt: (tokens_default()).colors.green[900].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + Hard + Focus
const POSITIVE_LIGHT_HARD_FOCUS = {
    background: (tokens_default()).colors.green[400].value,
    border: (tokens_default()).colors.green[400].value,
    foregroundAlt: (tokens_default()).colors.green[700].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + Hard + Disabled
const POSITIVE_LIGHT_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[150].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Soft + Default
const POSITIVE_LIGHT_SOFT_DEFAULT = {
    background: (tokens_default()).colors.green[200].value,
    border: (tokens_default()).colors.green[400].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + Soft + Hover
const POSITIVE_LIGHT_SOFT_HOVER = {
    background: (tokens_default()).colors.green[300].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[600].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + Soft + Pressed
const POSITIVE_LIGHT_SOFT_PRESSED = {
    background: (tokens_default()).colors.green[400].value,
    border: (tokens_default()).colors.green[700].value,
    foregroundAlt: (tokens_default()).colors.green[700].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + Soft + Focus
const POSITIVE_LIGHT_SOFT_FOCUS = {
    background: (tokens_default()).colors.green[200].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + Soft + Disabled
const POSITIVE_LIGHT_SOFT_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + White + Default
const POSITIVE_LIGHT_WHITE_DEFAULT = {
    background: (tokens_default()).colors.green[200].value,
    border: (tokens_default()).colors.green[400].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + White + Hover
const POSITIVE_LIGHT_WHITE_HOVER = {
    background: (tokens_default()).colors.green[300].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[600].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + White + Pressed
const POSITIVE_LIGHT_WHITE_PRESSED = {
    background: (tokens_default()).colors.green[400].value,
    border: (tokens_default()).colors.green[700].value,
    foregroundAlt: (tokens_default()).colors.green[700].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + White + Focus
const POSITIVE_LIGHT_WHITE_FOCUS = {
    background: (tokens_default()).colors.green[200].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + White + Disabled
const POSITIVE_LIGHT_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Ghost + Default
const POSITIVE_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[700].value
};
// Light + Ghost + Hover
const POSITIVE_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: (tokens_default()).colors.green[700].value,
    foregroundAlt: (tokens_default()).colors.green[700].value,
    foreground: (tokens_default()).colors.green[700].value
};
// Light + Ghost + Pressed
const POSITIVE_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[500].value
};
// Light + Ghost + Focus
const POSITIVE_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[700].value
};
// Light + Ghost + Disabled
const POSITIVE_LIGHT_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[150].value,
    border: (tokens_default()).colors.midnight[200].value,
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Light + Bare + Default
const POSITIVE_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[700].value
};
// Light + Bare + Hover
const POSITIVE_LIGHT_BARE_HOVER = {
    background: (tokens_default()).colors.green[150].value,
    border: (tokens_default()).colors.green[150].value,
    foregroundAlt: (tokens_default()).colors.green[600].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + Bare + Pressed
const POSITIVE_LIGHT_BARE_PRESSED = {
    background: (tokens_default()).colors.green[200].value,
    border: (tokens_default()).colors.green[200].value,
    foregroundAlt: (tokens_default()).colors.green[700].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Light + Bare + Focus
const POSITIVE_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[700].value
};
// Light + Bare + Disabled
const POSITIVE_LIGHT_BARE_DISABLED = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: (tokens_default()).colors.midnight[200].value,
    foreground: (tokens_default()).colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
const POSITIVE_DARK_HARD_DEFAULT = {
    background: (tokens_default()).colors.green[400].value,
    border: (tokens_default()).colors.green[400].value,
    foregroundAlt: (tokens_default()).colors.green[700].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Dark + Hard + Hover
const POSITIVE_DARK_HARD_HOVER = {
    background: (tokens_default()).colors.green[500].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[800].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Dark + Hard + Pressed
const POSITIVE_DARK_HARD_PRESSED = {
    background: (tokens_default()).colors.green[600].value,
    border: (tokens_default()).colors.green[600].value,
    foregroundAlt: (tokens_default()).colors.green[900].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Dark + Hard + Focus
const POSITIVE_DARK_HARD_FOCUS = {
    background: (tokens_default()).colors.green[400].value,
    border: (tokens_default()).colors.green[400].value,
    foregroundAlt: (tokens_default()).colors.green[700].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Dark + Hard + Disabled
const POSITIVE_DARK_HARD_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[850].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Soft + Default
const POSITIVE_DARK_SOFT_DEFAULT = {
    background: (tokens_default()).colors.green[300].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[600].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Dark + Soft + Hover
const POSITIVE_DARK_SOFT_HOVER = {
    background: (tokens_default()).colors.green[300].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[600].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Dark + Soft + Pressed
const POSITIVE_DARK_SOFT_PRESSED = {
    background: (tokens_default()).colors.green[400].value,
    border: (tokens_default()).colors.green[700].value,
    foregroundAlt: (tokens_default()).colors.green[700].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Dark + Soft + Focus
const POSITIVE_DARK_SOFT_FOCUS = {
    background: (tokens_default()).colors.green[200].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[900].value
};
// Dark + Soft + Disabled
const POSITIVE_DARK_SOFT_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + White + Default
const POSITIVE_DARK_WHITE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[500].value
};
// Dark + White + Hover
const POSITIVE_DARK_WHITE_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.green[300].value,
    foregroundAlt: (tokens_default()).colors.green[300].value,
    foreground: (tokens_default()).colors.green[300].value
};
// Dark + White + Pressed
const POSITIVE_DARK_WHITE_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.green[700].value,
    foregroundAlt: (tokens_default()).colors.green[700].value,
    foreground: (tokens_default()).colors.green[700].value
};
// Dark + White + Focus
const POSITIVE_DARK_WHITE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[500].value
};
// Dark + White + Disabled
const POSITIVE_DARK_WHITE_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Ghost + Default
const POSITIVE_DARK_GHOST_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[500].value
};
// Dark + Ghost + Hover
const POSITIVE_DARK_GHOST_HOVER = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.green[300].value,
    foregroundAlt: (tokens_default()).colors.green[300].value,
    foreground: (tokens_default()).colors.green[300].value
};
// Dark + Ghost + Pressed
const POSITIVE_DARK_GHOST_PRESSED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.green[700].value,
    foregroundAlt: (tokens_default()).colors.green[700].value,
    foreground: (tokens_default()).colors.green[700].value
};
// Dark + Ghost + Focus
const POSITIVE_DARK_GHOST_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[500].value
};
// Dark + Ghost + Disabled
const POSITIVE_DARK_GHOST_DISABLED = {
    background: (tokens_default()).colors.midnight[850].value,
    border: (tokens_default()).colors.midnight[800].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Dark + Bare + Default
const POSITIVE_DARK_BARE_DEFAULT = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[500].value
};
// Dark + Bare + Hover
const POSITIVE_DARK_BARE_HOVER = {
    background: (tokens_default()).colors.green[850].value,
    border: (tokens_default()).colors.green[850].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[500].value
};
// Dark + Bare + Pressed
const POSITIVE_DARK_BARE_PRESSED = {
    background: (tokens_default()).colors.green[800].value,
    border: (tokens_default()).colors.green[800].value,
    foregroundAlt: (tokens_default()).colors.green[300].value,
    foreground: (tokens_default()).colors.green[300].value
};
// Dark + Bare + Focus
const POSITIVE_DARK_BARE_FOCUS = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.green[500].value,
    foregroundAlt: (tokens_default()).colors.green[500].value,
    foreground: (tokens_default()).colors.green[500].value
};
// Dark + Bare + Disabled
const POSITIVE_DARK_BARE_DISABLED = {
    background: (tokens_default()).colors.black[100].value,
    border: (tokens_default()).colors.black[100].value,
    foregroundAlt: (tokens_default()).colors.midnight[800].value,
    foreground: (tokens_default()).colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
const POSITIVE_LIGHT_HARD = {
    default: POSITIVE_LIGHT_HARD_DEFAULT,
    disabled: POSITIVE_LIGHT_HARD_DISABLED,
    focus: POSITIVE_LIGHT_HARD_FOCUS,
    hover: POSITIVE_LIGHT_HARD_HOVER,
    pressed: POSITIVE_LIGHT_HARD_PRESSED
};
// Light + Soft
const POSITIVE_LIGHT_SOFT = {
    default: POSITIVE_LIGHT_SOFT_DEFAULT,
    disabled: POSITIVE_LIGHT_SOFT_DISABLED,
    focus: POSITIVE_LIGHT_SOFT_FOCUS,
    hover: POSITIVE_LIGHT_SOFT_HOVER,
    pressed: POSITIVE_LIGHT_SOFT_PRESSED
};
// Light + White
const POSITIVE_LIGHT_WHITE = {
    default: POSITIVE_LIGHT_WHITE_DEFAULT,
    disabled: POSITIVE_LIGHT_WHITE_DISABLED,
    focus: POSITIVE_LIGHT_WHITE_FOCUS,
    hover: POSITIVE_LIGHT_WHITE_HOVER,
    pressed: POSITIVE_LIGHT_WHITE_PRESSED
};
// Light + Ghost
const POSITIVE_LIGHT_GHOST = {
    default: POSITIVE_LIGHT_GHOST_DEFAULT,
    disabled: POSITIVE_LIGHT_GHOST_DISABLED,
    focus: POSITIVE_LIGHT_GHOST_FOCUS,
    hover: POSITIVE_LIGHT_GHOST_HOVER,
    pressed: POSITIVE_LIGHT_GHOST_PRESSED
};
// Light + Tertiary
const POSITIVE_LIGHT_BARE = {
    default: POSITIVE_LIGHT_BARE_DEFAULT,
    disabled: POSITIVE_LIGHT_BARE_DISABLED,
    focus: POSITIVE_LIGHT_BARE_FOCUS,
    hover: POSITIVE_LIGHT_BARE_HOVER,
    pressed: POSITIVE_LIGHT_BARE_PRESSED
};
// Dark + Hard
const POSITIVE_DARK_HARD = {
    default: POSITIVE_DARK_HARD_DEFAULT,
    disabled: POSITIVE_DARK_HARD_DISABLED,
    focus: POSITIVE_DARK_HARD_FOCUS,
    hover: POSITIVE_DARK_HARD_HOVER,
    pressed: POSITIVE_DARK_HARD_PRESSED
};
// Dark + Soft
const POSITIVE_DARK_SOFT = {
    default: POSITIVE_DARK_SOFT_DEFAULT,
    disabled: POSITIVE_DARK_SOFT_DISABLED,
    focus: POSITIVE_DARK_SOFT_FOCUS,
    hover: POSITIVE_DARK_SOFT_HOVER,
    pressed: POSITIVE_DARK_SOFT_PRESSED
};
// Dark + White
const POSITIVE_DARK_WHITE = {
    default: POSITIVE_DARK_WHITE_DEFAULT,
    disabled: POSITIVE_DARK_WHITE_DISABLED,
    focus: POSITIVE_DARK_WHITE_FOCUS,
    hover: POSITIVE_DARK_WHITE_HOVER,
    pressed: POSITIVE_DARK_WHITE_PRESSED
};
// Dark + Ghost
const POSITIVE_DARK_GHOST = {
    default: POSITIVE_DARK_GHOST_DEFAULT,
    disabled: POSITIVE_DARK_GHOST_DISABLED,
    focus: POSITIVE_DARK_GHOST_FOCUS,
    hover: POSITIVE_DARK_GHOST_HOVER,
    pressed: POSITIVE_DARK_GHOST_PRESSED
};
// Dark + Tertiary
const POSITIVE_DARK_BARE = {
    default: POSITIVE_DARK_BARE_DEFAULT,
    disabled: POSITIVE_DARK_BARE_DISABLED,
    focus: POSITIVE_DARK_BARE_FOCUS,
    hover: POSITIVE_DARK_BARE_HOVER,
    pressed: POSITIVE_DARK_BARE_PRESSED
};
// Light
const POSITIVE_LIGHT = {
    bare: POSITIVE_LIGHT_BARE,
    ghost: POSITIVE_LIGHT_GHOST,
    hard: POSITIVE_LIGHT_HARD,
    soft: POSITIVE_LIGHT_SOFT,
    white: POSITIVE_LIGHT_WHITE
};
// Dark
const POSITIVE_DARK = {
    bare: POSITIVE_DARK_BARE,
    ghost: POSITIVE_DARK_GHOST,
    hard: POSITIVE_DARK_HARD,
    soft: POSITIVE_DARK_SOFT,
    white: POSITIVE_DARK_WHITE
};
// Color schema
const POSITIVE = {
    dark: POSITIVE_DARK,
    light: POSITIVE_LIGHT
};
/* harmony default export */ var palette_schema_positive = (POSITIVE);
//# sourceMappingURL=palette.schema.positive.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/palette.js









// Default palette.
// -----------------------------------------------------------------------------
const palette = {
    // Colors
    schema: {
        active: palette_schema_active,
        brand1: palette_schema_brand1,
        brand2: palette_schema_brand2,
        info: palette_schema_info,
        negative: palette_schema_negative,
        neutral: palette_schema_neutral,
        notice: palette_schema_notice,
        positive: palette_schema_positive
    },
    // Text
    text: {
        primary: (tokens_default()).colors.midnight[800].value,
        secondary: (tokens_default()).colors.midnight[800].value,
        disabled: (tokens_default()).colors.midnight[800].value,
        subtle: (tokens_default()).colors.midnight[500].value
    }
};
//# sourceMappingURL=palette.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/shape.js

// Default space.
// -----------------------------------------------------------------------------
const shape = {
    // shadows
    shadow: {
        dark: {
            '2xl': (tokens_default()).shadows.dark["2xl"].value,
            inner: (tokens_default()).shadows.dark.inner.value,
            l: (tokens_default()).shadows.dark.l.value,
            m: (tokens_default()).shadows.dark.m.value,
            s: (tokens_default()).shadows.dark.s.value,
            xl: (tokens_default()).shadows.dark.xl.value
        },
        light: {
            '2xl': (tokens_default()).shadows.light["2xl"].value,
            inner: (tokens_default()).shadows.light.inner.value,
            l: (tokens_default()).shadows.light.l.value,
            m: (tokens_default()).shadows.light.m.value,
            s: (tokens_default()).shadows.light.s.value,
            xl: (tokens_default()).shadows.light.xl.value
        }
    },
    // border-radius
    radius: {
        l: (tokens_default()).radius.lg,
        m: (tokens_default()).radius.m,
        s: (tokens_default()).radius.s
    }
};
//# sourceMappingURL=shape.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/space.js

// Default space.
// -----------------------------------------------------------------------------
const space = {
    space: getSpace
};
//# sourceMappingURL=space.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/typography.utils.js

// Functions.
// -----------------------------------------------------------------------------
const getFontSize = (size) => (tokens_default()).font.size[size].value;
const getFontWeight = (weight) => (tokens_default()).font.weight[weight].value;
//# sourceMappingURL=typography.utils.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/typography.js


// Default typography.
// -----------------------------------------------------------------------------
const typography = {
    // Default props.
    fontFamily: (tokens_default()).font.family.sans.value,
    fontEditorial: (tokens_default()).font.family.display.value,
    fontWeight: (tokens_default()).font.weight.medium.value,
    // Header
    header: {
        h1: {
            fontSize: (tokens_default()).font.size["6xl"].value,
            fontWeight: (tokens_default()).font.weight.extraBold.value,
            marginBottom: (tokens_default()).spacing["2xl"].value,
            lineHeight: (tokens_default()).font.lineHeight.header.value
        },
        h2: {
            fontSize: (tokens_default()).font.size["5xl"].value,
            fontWeight: (tokens_default()).font.weight.extraBold.value,
            marginBottom: (tokens_default()).spacing["2xl"].value,
            lineHeight: (tokens_default()).font.lineHeight.header.value
        },
        h3: {
            fontSize: (tokens_default()).font.size["4xl"].value,
            fontWeight: (tokens_default()).font.weight.extraBold.value,
            marginBottom: (tokens_default()).spacing["2xl"].value,
            lineHeight: (tokens_default()).font.lineHeight.header.value
        },
        h4: {
            fontSize: (tokens_default()).font.size["3xl"].value,
            fontWeight: (tokens_default()).font.weight.extraBold.value,
            marginBottom: (tokens_default()).spacing.l.value,
            lineHeight: (tokens_default()).font.lineHeight.header.value
        },
        h5: {
            fontSize: (tokens_default()).font.size["2xl"].value,
            fontWeight: (tokens_default()).font.weight.extraBold.value,
            marginBottom: (tokens_default()).spacing.l.value,
            lineHeight: (tokens_default()).font.lineHeight.header.value
        },
        h6: {
            fontSize: (tokens_default()).font.size.xl.value,
            fontWeight: (tokens_default()).font.weight.extraBold.value,
            marginBottom: (tokens_default()).spacing.m.value,
            lineHeight: (tokens_default()).font.lineHeight.header.value
        }
    },
    // Paragraph
    paragraph: {
        '2xs': {
            fontSize: (tokens_default()).font.size["2xs"].value,
            lineHeight: (tokens_default()).font.lineHeight.body.value
        },
        '1xs': {
            fontSize: (tokens_default()).font.size.xs.value,
            lineHeight: (tokens_default()).font.lineHeight.body.value
        },
        s: {
            fontSize: (tokens_default()).font.size.s.value,
            lineHeight: (tokens_default()).font.lineHeight.body.value
        },
        m: {
            fontSize: (tokens_default()).font.size.m.value,
            lineHeight: (tokens_default()).font.lineHeight.body.value
        },
        l: {
            fontSize: (tokens_default()).font.size.l.value,
            lineHeight: (tokens_default()).font.lineHeight.body.value
        },
        '1xl': {
            fontSize: (tokens_default()).font.size.xl.value,
            lineHeight: (tokens_default()).font.lineHeight.body.value
        },
        '2xl': {
            fontSize: (tokens_default()).font.size["2xl"].value,
            lineHeight: (tokens_default()).font.lineHeight.body.value
        }
    },
    // Text.
    text: {
        '2xs': {
            fontSize: (tokens_default()).font.size["2xs"].value,
            fontWeight: getFontWeight('black'),
            letterSpacing: (tokens_default()).font.letterSpacing.s.value,
            lineHeight: (tokens_default()).font.lineHeight.text.value
        },
        xs: {
            fontSize: (tokens_default()).font.size.xs.value,
            fontWeight: getFontWeight('black'),
            letterSpacing: (tokens_default()).font.letterSpacing.s.value,
            lineHeight: (tokens_default()).font.lineHeight.text.value
        },
        s: {
            fontSize: (tokens_default()).font.size.s.value,
            fontWeight: getFontWeight('black'),
            letterSpacing: (tokens_default()).font.letterSpacing.s.value,
            lineHeight: (tokens_default()).font.lineHeight.text.value
        },
        m: {
            fontSize: (tokens_default()).font.size.m.value,
            fontWeight: getFontWeight('black'),
            letterSpacing: (tokens_default()).font.letterSpacing.m.value,
            lineHeight: (tokens_default()).font.lineHeight.text.value
        },
        l: {
            fontSize: (tokens_default()).font.size.l.value,
            fontWeight: getFontWeight('black'),
            letterSpacing: (tokens_default()).font.letterSpacing.m.value,
            lineHeight: (tokens_default()).font.lineHeight.text.value
        },
        xl: {
            fontSize: (tokens_default()).font.size.xl.value,
            fontWeight: getFontWeight('black'),
            letterSpacing: (tokens_default()).font.letterSpacing.m.value,
            lineHeight: (tokens_default()).font.lineHeight.text.value
        },
        '2xl': {
            fontSize: (tokens_default()).font.size["2xl"].value,
            fontWeight: getFontWeight('black'),
            letterSpacing: (tokens_default()).font.letterSpacing.m.value,
            lineHeight: (tokens_default()).font.lineHeight.text.value
        }
    }
};
//# sourceMappingURL=typography.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/theme.js





// Default theme.
// -----------------------------------------------------------------------------
const defaultTheme = {
    breakpoints: breakpoints,
    palette: palette,
    shape: shape,
    space: space,
    typography: typography
};
//# sourceMappingURL=theme.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/UIProvider/UIProvider.js




// Component.
// -----------------------------------------------------------------------------
const UIProvider = ({ theme = {}, children }) => ((0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, { theme: merge_default()(defaultTheme, theme), children: children }));
/* harmony default export */ var UIProvider_UIProvider = (UIProvider);
//# sourceMappingURL=UIProvider.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Avatar/Avatar.constants.js
// Constants.
// -----------------------------------------------------------------------------
const AVATAR_DEFAULT_SIZE = 'm';
const AVATAR_DEFAULT_DOT = false;
const AVATAR_DEFAULT_MODE = 'light';
const AVATAR_DEFAULT_SCHEMA = 'neutral';
const AVATAR_DEFAULT_VARIANT = 'hard';
// Mappings.
const AVATAR_SIZE_MAP = {
    l: 48,
    m: 40,
    s: 32,
    '2xl': 64
};
const AVATAR_SIZE_TO_ICON_SIZE = {
    '2xl': '3xl',
    l: 'xl',
    m: 'l',
    s: 'm'
};
//# sourceMappingURL=Avatar.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/palette.utils.js

// Functions.
// -----------------------------------------------------------------------------
const getSchemaVariant = ({ mode, schema, theme, variant }) => theme.palette.schema[schema][mode][variant];
const getSchemaState = ({ state, ...args }) => getSchemaVariant(args)[state];
const getWhiteColor = () => (tokens_default()).colors.white[100].value;
//# sourceMappingURL=palette.utils.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Avatar/Avatar.styled.js




// styled-components.
// -----------------------------------------------------------------------------
const AvatarRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ mode, schema, size, showDot, theme, variant, color }) => {
    const { default: normal } = getSchemaVariant({
        mode,
        schema,
        theme,
        variant
    });
    const pixels = AVATAR_SIZE_MAP[size];
    return styled_components_browser_esm/* css */.iv `
      display: inline-block;
      position: relative;

      img {
        border-radius: 50%;
        max-height: ${pixels}px;
        max-width: ${pixels}px;
        height: ${pixels}px;
        vertical-align: top;
        width: ${pixels}px;
      }

      .avatar-icon,
      .avatar-text {
        align-items: center;
        background-color: ${color || normal.background};
        border-radius: 50%;
        color: ${color ? '#fff' : normal.foreground};
        display: inline-flex;
        height: ${pixels}px;
        justify-content: center;
        max-height: ${pixels}px;
        max-width: ${pixels}px;
        width: ${pixels}px;
      }

      ${showDot &&
        `
        &::after {
          background-color: ${(tokens_default()).colors.green[500].value};
          border-radius: 50%;
          top: 14.8%;
          content: '';
          display: block;
          height: 10px;
          position: absolute;
          right: 14.8%;
          transform: translate(5px, -5px);
          width: 10px;
        }
      `}
    `;
}}
`;
const AvatarText = styled_components_browser_esm/* default.div */.ZP.div `
  background-color: red;
`;
//# sourceMappingURL=Avatar.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Avatar/Avatar.js





// Component.
// -----------------------------------------------------------------------------
const Avatar = (0,react.forwardRef)(({ icon: iconProps, img: imgProps, showDot = AVATAR_DEFAULT_DOT, size = AVATAR_DEFAULT_SIZE, text: textProps, color, ...rest }, ref) => {
    const mode = textProps?.mode || AVATAR_DEFAULT_MODE;
    const schema = textProps?.schema || AVATAR_DEFAULT_SCHEMA;
    const variant = textProps?.variant || AVATAR_DEFAULT_VARIANT;
    return ((0,jsx_runtime.jsx)(AvatarRoot, { mode: mode, ref: ref, schema: schema, showDot: showDot, size: size, variant: variant, color: color, ...rest, children: imgProps ? ((0,jsx_runtime.jsx)("img", { alt: imgProps.alt, src: imgProps.src })) : textProps ? ((0,jsx_runtime.jsx)("div", { className: "avatar-text", children: (0,jsx_runtime.jsx)(Text_Text, { size: size, uppercase: true, children: textProps.text }) })) : iconProps ? ((0,jsx_runtime.jsx)("div", { className: "avatar-icon", children: (0,jsx_runtime.jsx)(Icon_Icon, { icon: iconProps.icon, size: AVATAR_SIZE_TO_ICON_SIZE[size] }) })) : null }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Avatar.displayName = 'Avatar';
/* harmony default export */ var Avatar_Avatar = (Avatar);
//# sourceMappingURL=Avatar.js.map
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-duotone-svg-icons/index.mjs
var pro_duotone_svg_icons = __webpack_require__(82655);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Button/Button.constants.js
// Constants.
// -----------------------------------------------------------------------------
// Default values.
const BUTTON_DEFAULT_DISABLED = false;
const BUTTON_DEFAULT_ICON_LOADING_TITLE = 'start-icon-loading';
const BUTTON_DEFAULT_LOADING = false;
const BUTTON_DEFAULT_MODE = 'light';
const BUTTON_DEFAULT_SCHEME = 'neutral';
const BUTTON_DEFAULT_SIZE = 's';
const BUTTON_DEFAULT_VARIANT = 'hard';
// Mapping
const BUTTON_ICON_SIZES = {
    s: '2xl',
    xs: 'l',
    '2xs': 'l'
};
const BUTTON_TEXT_PROPS = {
    s: {
        size: 's',
        bold: true,
        uppercase: true
    },
    xs: {
        size: 'xs',
        bold: true,
        uppercase: true
    },
    '2xs': {
        size: 'xs',
        bold: true,
        uppercase: true
    }
};
const BUTTON_PADDING_SIZES = {
    s: {
        horizontal: 'l',
        vertical: 'l'
    },
    xs: {
        horizontal: 'm',
        vertical: 'm'
    },
    '2xs': {
        horizontal: 's',
        vertical: 's'
    }
};
//# sourceMappingURL=Button.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Badge/Badge.constants.js
// Constants.
// -----------------------------------------------------------------------------
// Default values.
const BADGE_DEFAULT_ARIAL_LABEL_CLOSE = 'close-button';
const BADGE_DEFAULT_ICON_TITLE = 'start-icon-badge';
const BADGE_DEFAULT_ICON_LOADING_TITLE = 'start-icon-loading';
const BADGE_DEFAULT_LOADING = false;
const BADGE_DEFAULT_MODE = 'light';
const BADGE_DEFAULT_SIZE = 'm';
const BADGE_DEAULT_VARIANT = 'hard';
// Mappings.
const BADGE_ICON_SIZES = {
    l: 'xl',
    m: 'l',
    s: 'l',
    xs: 'l'
};
const BADGE_PADDING_SIZES = {
    xs: {
        horizontal: 'm',
        vertical: '2xs',
        gap: 'xs'
    },
    s: {
        horizontal: 's',
        vertical: 'xs',
        gap: 's'
    },
    m: {
        horizontal: 'l',
        vertical: 's',
        gap: 's'
    },
    l: {
        horizontal: '2xl',
        vertical: 'l',
        gap: 's'
    }
};
//# sourceMappingURL=Badge.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Badge/Badge.styled.js




// styled-components.
// -----------------------------------------------------------------------------
const BadgeRoot = styled_components_browser_esm/* default.span */.ZP.span `
  ${({ isClickable, isRounded, isLoading, size, ...args }) => {
    const { background, border, foreground, active, foregroundAlt } = getSchemaState({
        ...args,
        state: 'default'
    });
    const verticalPadding = getSpace(BADGE_PADDING_SIZES[size].vertical);
    const horizontalPadding = isRounded
        ? verticalPadding
        : getSpace(BADGE_PADDING_SIZES[size].horizontal);
    return styled_components_browser_esm/* css */.iv `
      /* Fixed rules */
      align-items: center;
      border-radius: 100px;
      display: inline-flex;
      align-items: center;
      gap: ${getSpace(BADGE_PADDING_SIZES[size].gap)};
      justify-content: center;
      text-align: center;

      /* Clickable */
      ${isClickable && `cursor: pointer;`}

      ${isClickable && !isLoading && `&:hover { background-color: ${active}; }`}

      /* Colors */
      background-color: ${background};
      border: 2px solid ${border};
      color: ${foreground};

      /* Paddings */
      padding-bottom: ${verticalPadding};
      padding-left: ${horizontalPadding};
      padding-top: ${verticalPadding};
      padding-right: ${horizontalPadding};

      /* Icon */
      svg {
        color: ${foregroundAlt};
      }

      /* isLoading */
      ${isLoading &&
        styled_components_browser_esm/* css */.iv `
        pointer-events: none;

        .button__icon--loading svg {
          color: ${active || foregroundAlt};
        }
      `}

      /* Close button. */
      .close-button,
      .close-button:hover {
        background: none;
        border: none;
        padding: 0;
      }
    `;
}}
`;
const BadgeText = styled_components_browser_esm/* default.span */.ZP.span `
  white-space: nowrap;
  margin-top: ${({ size }) => (size === 'xs' ? '-2px' : '0')};
`;
//# sourceMappingURL=Badge.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Badge/Badge.js








// Component.
// -----------------------------------------------------------------------------
const Badge_Badge = (0,react.forwardRef)(({ icon = null, label, mode = BADGE_DEFAULT_MODE, isLoading = BUTTON_DEFAULT_LOADING, onClick, onClose, schema, size = BADGE_DEFAULT_SIZE, variant = BADGE_DEAULT_VARIANT, bold = false, color, tooltip, ...rest }, ref) => ((0,jsx_runtime.jsx)(Tooltip_Tooltip, { content: tooltip, children: (0,jsx_runtime.jsxs)(BadgeRoot, { mode: mode, isClickable: !!onClick, isRounded: label === undefined, isLoading: isLoading, ref: ref, onClick: onClick, schema: schema, size: size, ...(onClick && { role: 'button' }), variant: variant, ...rest, style: {
            ...rest.style,
            ...(color
                ? {
                    backgroundColor: color,
                    borderColor: 'rgba(0,0,0,.075)'
                }
                : undefined)
        }, children: [isLoading ? ((0,jsx_runtime.jsx)(Icon_Icon, { className: "button__icon--loading", icon: pro_duotone_svg_icons/* faSpinnerThird */.AX7, size: BADGE_ICON_SIZES[size], spin: true, title: BADGE_DEFAULT_ICON_LOADING_TITLE })) : (icon && ((0,jsx_runtime.jsx)(Icon_Icon, { icon: icon, size: BADGE_ICON_SIZES[size], title: BADGE_DEFAULT_ICON_TITLE }))), label && ((0,jsx_runtime.jsx)(BadgeText, { size: size, children: (0,jsx_runtime.jsx)(Text_Text, { size: size, bold: bold, children: label }) })), onClose && ((0,jsx_runtime.jsx)(IconButton_IconButton, { "aria-label": BADGE_DEFAULT_ARIAL_LABEL_CLOSE, className: "close-button", icon: pro_light_svg_icons/* faTimes */.NBC, onClick: onClose, size: "xs" }))] }) })));
// Component configuration.
// -----------------------------------------------------------------------------
Badge_Badge.displayName = 'Badge';
/* harmony default export */ var Molecules_Badge_Badge = (Badge_Badge);
//# sourceMappingURL=Badge.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/theme/shape.utils.js
// Functions.
// -----------------------------------------------------------------------------
// Returns the shadow box associated with a mode and a variant within a theme.
const getShadow = ({ mode, theme, variant }) => theme.shape.shadow[mode][variant];
// Returns the value of the radius inside the theme.
const shape_utils_getRadius = (theme, radius) => theme.shape.radius[radius];
//# sourceMappingURL=shape.utils.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Button/Button.styled.js





// styled-components.
// -----------------------------------------------------------------------------
const ButtonRoot = styled_components_browser_esm/* default.button */.ZP.button `
  ${({ mode, schema, size, theme, isLoading, variant }) => {
    const { default: defaultColor, disabled: disabledColor, focus: focusColor, hover: focusHover, pressed: pressedHover } = getSchemaVariant({ mode, schema, theme, variant });
    return styled_components_browser_esm/* css */.iv `
      cursor: pointer;

      /* Box model */
      align-items: center;
      display: inline-flex;
      gap: ${getSpace('s')};
      justify-content: center;

      /* Colors */
      background-color: ${defaultColor.background};
      border: 2px solid ${defaultColor.border};
      color: ${defaultColor.foreground};

      svg {
        color: ${defaultColor.foregroundAlt};
      }

      /* Radius */
      border-radius: ${shape_utils_getRadius(theme, 'm')};

      /* Misc */
      transition: 0.3s;
      cursor: pointer;

      /* Spacing */
      padding-bottom: ${getSpace(BUTTON_PADDING_SIZES[size].vertical)};
      padding-left: ${getSpace(BUTTON_PADDING_SIZES[size].horizontal)};
      padding-right: ${getSpace(BUTTON_PADDING_SIZES[size].horizontal)};
      padding-top: ${getSpace(BUTTON_PADDING_SIZES[size].vertical)};

      /* isLoading */
      ${isLoading &&
        styled_components_browser_esm/* css */.iv `
        pointer-events: none;

        .button__icon--loading svg {
          color: ${defaultColor.active || defaultColor.foregroundAlt};
        }
      `}

      /* Status: Disabled. */
      &:disabled {
        background-color: ${disabledColor.background};
        border: 2px solid ${disabledColor.border};
        color: ${disabledColor.foreground};
        cursor: not-allowed;

        svg {
          color: ${disabledColor.foregroundAlt};
        }

        &:hover {
          background-color: ${disabledColor.background};
          border: 2px solid ${disabledColor.border};
          color: ${disabledColor.foreground};

          svg {
            color: ${disabledColor.foregroundAlt};
          }
        }
      }

      /* Status: Focus. */
      &:focus {
        background-color: ${focusColor.background};
        border: 2px solid ${focusColor.border};
        color: ${focusColor.foreground};

        svg {
          color: ${focusColor.foregroundAlt};
        }
      }

      /* Status: Hover. */
      &:hover {
        background-color: ${focusHover.background};
        border: 2px solid ${focusHover.border};
        color: ${focusHover.foreground};

        svg {
          color: ${focusHover.foregroundAlt};
        }
      }

      /* Status: Pressed. */
      &:active {
        background-color: ${pressedHover.background};
        border: 2px solid ${pressedHover.border};
        color: ${pressedHover.foreground};

        svg {
          color: ${pressedHover.foregroundAlt};
        }
      }
    `;
}}
`;
const ButtonText = styled_components_browser_esm/* default.span */.ZP.span `
  white-space: nowrap;
`;
//# sourceMappingURL=Button.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Button/Button.js







// Component.
// -----------------------------------------------------------------------------
const Button = (0,react.forwardRef)(({ disabled = BUTTON_DEFAULT_DISABLED, endIcon = null, isLoading = BUTTON_DEFAULT_LOADING, label, loadingText, mode = BUTTON_DEFAULT_MODE, onClick, schema = BUTTON_DEFAULT_SCHEME, size = BUTTON_DEFAULT_SIZE, startIcon = null, variant = BUTTON_DEFAULT_VARIANT, ...rest }, ref) => ((0,jsx_runtime.jsxs)(ButtonRoot, { disabled: disabled, mode: mode, onClick: onClick, ref: ref, schema: schema, size: size, variant: variant, isLoading: isLoading, ...rest, children: [isLoading ? ((0,jsx_runtime.jsx)(Icon_Icon, { className: "button__icon--loading", icon: pro_duotone_svg_icons/* faSpinnerThird */.AX7, size: BUTTON_ICON_SIZES[size], spin: true, title: BUTTON_DEFAULT_ICON_LOADING_TITLE })) : (startIcon && ((0,jsx_runtime.jsx)(Icon_Icon, { icon: startIcon, size: BUTTON_ICON_SIZES[size], title: `start-icon-${label}` }))), label && ((0,jsx_runtime.jsx)(ButtonText, { children: (0,jsx_runtime.jsx)(Text, { ...BUTTON_TEXT_PROPS[size], children: isLoading ? loadingText || label : label }) })), endIcon && ((0,jsx_runtime.jsx)(Icon_Icon, { icon: endIcon, size: BUTTON_ICON_SIZES[size], title: `end-icon-${label}` }))] })));
// Component configuration.
// -----------------------------------------------------------------------------
Button.displayName = 'Button';
/* harmony default export */ var Button_Button = (Button);
//# sourceMappingURL=Button.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ButtonGroup/ButtonGroup.constants.js
// Constants.
// -----------------------------------------------------------------------------
const BUTTON_GROUP_DEFAULT_ORIENTATION = 'horizontal';
//# sourceMappingURL=ButtonGroup.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ButtonGroup/ButtonGroup.styled.js


// styled-components.
// -----------------------------------------------------------------------------
const ButtonGroupRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ orientation, theme }) => {
    return styled_components_browser_esm/* css */.iv `
      // Display & Box Model.
      display: flex;
      flex-direction: ${orientation === 'vertical' ? 'column' : 'row'};
      overflow: hidden;
      width: fit-content;

      > button,
      > * button {
        border-radius: 0;

        ${orientation === 'horizontal' &&
        `
          border-right-width: 0;

          &:focus,
          &:hover {
            border-right-width: 0;
          }
        `}

        ${orientation === 'vertical' &&
        `
          border-bottom-width: 0;

          &:focus,
          &:hover {
            border-bottom-width: 0;
          }
        `}
      }

      > button:first-child,
      > *:first-child button {
        border-top-left-radius: ${shape_utils_getRadius(theme, 'm')};

        ${orientation === 'horizontal' &&
        `
          border-bottom-left-radius: ${shape_utils_getRadius(theme, 'm')};
        `};

        ${orientation === 'vertical' &&
        `border-top-right-radius: ${shape_utils_getRadius(theme, 'm')};`};
      }

      > button:last-child,
      > *:last-child button {
        ${orientation === 'horizontal' &&
        `
          border-right-width: 2px;
          border-top-right-radius: ${shape_utils_getRadius(theme, 'm')};
          border-bottom-right-radius: ${shape_utils_getRadius(theme, 'm')};
        `};

        ${orientation === 'vertical' &&
        `
          border-bottom-width: 2px;
          border-bottom-right-radius: ${shape_utils_getRadius(theme, 'm')};
          border-bottom-left-radius: ${shape_utils_getRadius(theme, 'm')};
        `};
      }
    `;
}}
`;
//# sourceMappingURL=ButtonGroup.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ButtonGroup/ButtonGroup.js




// Component.
// -----------------------------------------------------------------------------
const ButtonGroup = (0,react.forwardRef)(({ children, orientation = BUTTON_GROUP_DEFAULT_ORIENTATION }, ref) => ((0,jsx_runtime.jsx)(ButtonGroupRoot, { orientation: orientation, ref: ref, children: children })));
// Component configuration.
// -----------------------------------------------------------------------------
ButtonGroup.displayName = 'ButtonGroup';
/* harmony default export */ var ButtonGroup_ButtonGroup = (ButtonGroup);
//# sourceMappingURL=ButtonGroup.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ButtonLink/ButtonLink.constants.js

// Constants.
// -----------------------------------------------------------------------------
const BUTTON_LINK_DEFAULT_DISABLED = false;
const BUTTON_LINK_DEFAULT_IS_LOADING = false;
const BUTTON_LINK_DEFAULT_MODE = 'light';
const BUTTON_LINK_DEFAULT_SCHEMA = 'brand2';
const BUTTON_LINK_DEFAULT_SIZE = 's';
const BUTTON_LINK_DEFAULT_VARIANT = 'bare';
const BUTTON_LINK_TEXT_PROPS = BUTTON_TEXT_PROPS;
const BUTTON_LINK_PADDING_SIZES = BUTTON_PADDING_SIZES;
const BUTTON_LINK_ICON_SIZES = BUTTON_ICON_SIZES;
//# sourceMappingURL=ButtonLink.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ButtonLink/ButtonLink.styled.js





// styled-components.
// -----------------------------------------------------------------------------
const ButtonLinkRoot = styled_components_browser_esm/* default.a */.ZP.a `
  ${({ mode, schema, size, theme, variant }) => {
    const { default: defaultColor, disabled: disabledColor, focus: focusColor, hover: focusHover, pressed: pressedHover } = getSchemaVariant({
        mode,
        schema,
        theme,
        variant
    });
    return styled_components_browser_esm/* css */.iv `
      cursor: pointer;

      /* Box model */
      align-items: center;
      display: inline-flex;
      gap: ${getSpace('s')};
      justify-content: center;
      line-height: 1;

      /* Colors */
      background-color: ${defaultColor.background};
      border: 2px solid ${defaultColor.border};
      color: ${defaultColor.foreground};

      svg {
        color: ${defaultColor.foregroundAlt};
      }

      /* Radius */
      border-radius: ${shape_utils_getRadius(theme, 'm')};

      /* Misc */
      transition: 0.3s;
      cursor: pointer;
      text-decoration: none;

      /* Spacing */
      padding-bottom: ${getSpace(BUTTON_LINK_PADDING_SIZES[size].vertical)};
      padding-left: ${getSpace(BUTTON_LINK_PADDING_SIZES[size].horizontal)};
      padding-right: ${getSpace(BUTTON_LINK_PADDING_SIZES[size].horizontal)};
      padding-top: ${getSpace(BUTTON_LINK_PADDING_SIZES[size].vertical)};

      /* Status: Disabled. */
      &:disabled {
        background-color: ${disabledColor.background};
        border: 2px solid ${disabledColor.border};
        color: ${disabledColor.foreground};
        cursor: not-allowed;

        svg {
          color: ${disabledColor.foregroundAlt};
        }
      }

      /* Status: Focus. */
      &:focus {
        background-color: ${focusColor.background};
        border: 2px solid ${focusColor.border};
        color: ${focusColor.foreground};

        svg {
          color: ${focusColor.foregroundAlt};
        }
      }

      /* Status: Hover. */
      &:hover {
        background-color: ${focusHover.background};
        border: 2px solid ${focusHover.border};
        color: ${focusHover.foreground};

        svg {
          color: ${focusHover.foregroundAlt};
        }
      }

      /* Status: Pressed. */
      &:active {
        background-color: ${pressedHover.background};
        border: 2px solid ${pressedHover.border};
        color: ${pressedHover.foreground};

        svg {
          color: ${pressedHover.foregroundAlt};
        }
      }
    `;
}}
`;
const ButtonLinkText = styled_components_browser_esm/* default.span */.ZP.span `
  white-space: nowrap;
`;
//# sourceMappingURL=ButtonLink.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ButtonLink/ButtonLink.js





// Component.
// -----------------------------------------------------------------------------
const ButtonLink = (0,react.forwardRef)(({ href, label, endIcon, mode = BUTTON_LINK_DEFAULT_MODE, schema = BUTTON_LINK_DEFAULT_SCHEMA, size = BUTTON_LINK_DEFAULT_SIZE, startIcon, variant = BUTTON_LINK_DEFAULT_VARIANT, ...rest }, ref) => ((0,jsx_runtime.jsxs)(ButtonLinkRoot, { href: href, mode: mode, ref: ref, schema: schema, size: size, variant: variant, ...rest, children: [startIcon && ((0,jsx_runtime.jsx)(Icon_Icon, { icon: startIcon, size: BUTTON_LINK_ICON_SIZES[size], title: `start-icon-${label}` })), (0,jsx_runtime.jsx)(ButtonLinkText, { children: (0,jsx_runtime.jsx)(Text_Text, { ...BUTTON_LINK_TEXT_PROPS[size], children: label }) }), endIcon && ((0,jsx_runtime.jsx)(Icon_Icon, { icon: endIcon, size: BUTTON_LINK_ICON_SIZES[size], title: `end-icon-${label}` }))] })));
// Component configuration.
// -----------------------------------------------------------------------------
ButtonLink.displayName = 'ButtonLink';
/* harmony default export */ var ButtonLink_ButtonLink = (ButtonLink);
//# sourceMappingURL=ButtonLink.js.map
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
;// CONCATENATED MODULE: ../ui-library/dist/foundation/utils/html.utils.js
// Functions.
// -----------------------------------------------------------------------------
/**
 * Gets the dimensions of the image that is hosted in the url received as a
 * parameter.
 */
const getImageDimensions = async (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => {
            resolve({ width: img.width, height: img.height });
        });
        img.addEventListener('error', (err) => {
            reject(err);
        });
        img.src = url;
    });
};
//# sourceMappingURL=html.utils.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Card/Card.constants.js
// Constants.
// -----------------------------------------------------------------------------
// Default props.
const CARD_IMAGE_DEFAULT_PROP_HIDE_IMAGE = false;
// Default values.
const CARD_IMAGE_MAX_HEIGHT = 180;
const CARD_IMAGE_MAX_HEIGHT_MOBILE = 104;
const CARD_IMAGE_MAX_WIDTH = 180;
const CARD_IMAGE_MAX_WIDTH_MOBILE = 248;
//# sourceMappingURL=Card.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Card/Card.styled.js







// styled-components.
// -----------------------------------------------------------------------------
const CardContentActions = styled_components_browser_esm/* default.div */.ZP.div `
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  gap: ${getSpace('s')};
  justify-content: flex-start;
`;
const CardContent = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ selected, hasImage }) => styled_components_browser_esm/* css */.iv `
    background-color: ${selected
    ? (tokens_default()).colors.emerald[100].value
    : getWhiteColor()};
    display: flex;
    flex-direction: column;
    border-left: ${hasImage
    ? `1px solid ${(tokens_default()).colors.midnight[200].value}`
    : `0`};
    flex: 1 1 auto;
    justify-content: space-between;
    padding: ${getSpace('2xl')};
  `}
`;
const CardFlag = styled_components_browser_esm/* default.div */.ZP.div `
  left: -4px;
  position: absolute;
  right: 0;
  transform: translateY(-50%);
  z-index: 1;
`;
const CardNoImage = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ theme }) => styled_components_browser_esm/* css */.iv `
    align-items: center;
    background-color: ${(tokens_default()).colors.midnight[100].value};
    color: ${(tokens_default()).colors.midnight[200].value};
    display: inline-flex;
    flex-shrink: 0;
    justify-content: center;
    width: ${CARD_IMAGE_MAX_WIDTH}px;

    ${breakpointMax({
    breakpoint: 'm',
    rules: styled_components_browser_esm/* css */.iv `
        display: none;
      `,
    theme
})}
  `}
`;
const CardRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ theme, selected }) => styled_components_browser_esm/* css */.iv `
    border: 1px solid ${(tokens_default()).colors.midnight[selected ? 500 : 200].value};
    box-shadow: ${getShadow({ mode: 'light', theme, variant: 'm' })};
    border-radius: ${shape_utils_getRadius(theme, 'm')};
    display: flex;
    min-height: ${CARD_IMAGE_MAX_HEIGHT}px;
    margin-bottom: ${getSpace('4xl')};
    overflow: hidden;

    ${breakpointMax({
    breakpoint: 'm',
    rules: styled_components_browser_esm/* css */.iv `
        flex-direction: column;
        height: auto;
      `,
    theme
})}
  `}
`;
const CardWithImage = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ isCover, theme, url }) => styled_components_browser_esm/* css */.iv `
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${url});
    flex-shrink: 0;
    height: ${CARD_IMAGE_MAX_HEIGHT}px;
    width: ${CARD_IMAGE_MAX_WIDTH}px;

    ${isCover && `background-size: cover;`}

    ${breakpointMax({
    breakpoint: 'm',
    rules: styled_components_browser_esm/* css */.iv `
        border-right: none;
        margin-left: auto;
        margin-right: auto;
        margin-top: ${getSpace('3xl')};
        height: ${CARD_IMAGE_MAX_HEIGHT_MOBILE}px;
        width: ${CARD_IMAGE_MAX_WIDTH_MOBILE}px;
      `,
    theme
})}
  `}
`;
const CardWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  position: relative;
`;
//# sourceMappingURL=Card.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Card/Card.js








// Component.
// -----------------------------------------------------------------------------
const Card = (0,react.forwardRef)(({ children, deleteAction, editAction, flag, hideImage = CARD_IMAGE_DEFAULT_PROP_HIDE_IMAGE, image, selected, className }, ref) => {
    // Hooks.
    // -------------------------------------------------------------------------
    const [dimensions, setDimensions] = (0,react.useState)();
    // Helpers.
    // -------------------------------------------------------------------------
    const obtainImageDimensions = (0,react.useCallback)(async (url) => {
        try {
            const data = await getImageDimensions(url);
            setDimensions(data);
        }
        catch (ex) {
            console.group('Could not get image dimensions');
            console.log('URL: ', url);
            console.log('Exception: ', ex);
            console.groupEnd();
        }
    }, []);
    const renderImage = (0,react.useCallback)(() => {
        if (!image || !dimensions) {
            return ((0,jsx_runtime.jsx)(CardNoImage, { children: (0,jsx_runtime.jsx)(Icon_Icon, { icon: pro_light_svg_icons/* faImage */.VmB, size: "5xl" }) }));
        }
        const isCover = dimensions.width >= CARD_IMAGE_MAX_WIDTH ||
            dimensions.height >= CARD_IMAGE_MAX_HEIGHT;
        return (0,jsx_runtime.jsx)(CardWithImage, { isCover: isCover, url: image.url });
    }, [dimensions, image]);
    // Effects.
    // -------------------------------------------------------------------------
    (0,react.useEffect)(() => {
        if (!hideImage && !!image) {
            obtainImageDimensions(image.url);
        }
    }, [hideImage, image, obtainImageDimensions]);
    // Render
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsxs)(CardWrapper, { className: `ui-card-wrapper ${className || ''}`.trim(), children: [flag && ((0,jsx_runtime.jsx)(CardFlag, { children: (0,jsx_runtime.jsx)(Flag_Flag, { ...flag }) })), (0,jsx_runtime.jsxs)(CardRoot, { ref: ref, selected: selected, children: [!hideImage && renderImage(), (0,jsx_runtime.jsxs)(CardContent, { selected: selected, hasImage: !hideImage && !!image, children: [(0,jsx_runtime.jsx)("div", { children: children }), (!!editAction || !!deleteAction) && ((0,jsx_runtime.jsxs)(CardContentActions, { children: [!!editAction && ((0,jsx_runtime.jsx)(Button_Button, { label: editAction.label, onClick: editAction.onClick, size: "xs", startIcon: pro_solid_svg_icons/* faPencil */.TzT, variant: "bare" })), !!deleteAction && ((0,jsx_runtime.jsx)(Button_Button, { label: deleteAction.label, schema: "negative", onClick: deleteAction.onClick, size: "xs", startIcon: pro_solid_svg_icons/* faTrashCan */.Vui, variant: "bare" }))] }))] })] })] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Card.displayName = 'Card';
/* harmony default export */ var Card_Card = (Card);
//# sourceMappingURL=Card.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Checkbox/Checkbox.constants.js


// Constants.
// -----------------------------------------------------------------------------
/** Default checked */
const CHECKBOX_DEFAULT_CHECKED = false;
/** Default disabled */
const CHECKBOX_DEFAULT_DISABLED = false;
/** Default mode. */
const CHECKBOX_DEFAULT_MODE = 'light';
/** Default role. */
const CHECKBOX_DEFAULT_ROLE = 'none';
/** Default size. */
const CHECKBOX_DEFAULT_SIZE = 's';
/** Mapping: mode. */
const MAPPINGS_MODE = {
    // Dark mode.
    dark: {
        background: (tokens_default()).colors.black[100].value,
        border: (tokens_default()).colors.midnight[700].value,
        text: (tokens_default()).colors.midnight[300].value,
        checked: {
            background: (tokens_default()).colors.midnight[100].value,
            border: (tokens_default()).colors.midnight[700].value
        },
        disabled: {
            background: (tokens_default()).colors.midnight[850].value,
            border: (tokens_default()).colors.midnight[800].value,
            text: (tokens_default()).colors.midnight[800].value
        },
        focus: {
            border: (tokens_default()).colors.midnight[850].value,
            shadow: `0 0 0 4px ${(tokens_default()).colors.midnight[150].value}`
        },
        hover: {
            border: (tokens_default()).colors.midnight[400].value
        }
    },
    // Light mode.
    light: {
        background: (tokens_default()).colors.white[100].value,
        border: (tokens_default()).colors.midnight[200].value,
        text: (tokens_default()).colors.midnight[800].value,
        checked: {
            background: (tokens_default()).colors.midnight[800].value,
            border: (tokens_default()).colors.midnight[800].value
        },
        disabled: {
            background: (tokens_default()).colors.midnight[150].value,
            border: (tokens_default()).colors.midnight[200].value,
            text: (tokens_default()).colors.midnight[200].value
        },
        focus: {
            border: (tokens_default()).colors.midnight[850].value,
            shadow: `0 0 0 4px ${(tokens_default()).colors.midnight[150].value}`
        },
        hover: {
            border: (tokens_default()).colors.midnight[400].value
        }
    }
};
/** Scale mappings. */
const MAPPINGS_SCALE = {
    s: {
        fontSize: getFontSize('s'),
        fontWeight: getFontWeight('medium')
    },
    xs: {
        fontSize: getFontSize('xs'),
        fontWeight: getFontWeight('medium')
    }
};
//# sourceMappingURL=Checkbox.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Checkbox/Checkbox.styled.js




// styled-components.
// -----------------------------------------------------------------------------
const CheckboxHidden = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({ type: 'checkbox' }) `
  border: 0;
  clip: rect(0, 0, 0, 0);
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  height: 1px;
  width: 1px;
`;
const CheckboxLabel = styled_components_browser_esm/* default.label */.ZP.label `
  ${({ scale, theme }) => {
    const { fontSize, fontWeight } = MAPPINGS_SCALE[scale];
    return styled_components_browser_esm/* css */.iv `
      align-items: center;
      cursor: pointer;
      display: inline-flex;
      font-family: ${theme.typography.fontFamily};
      font-size: ${fontSize};
      font-weight: ${fontWeight};
      gap: ${getSpace('s')};
      line-height: ${(tokens_default()).font.lineHeight.text.value};
    `;
}}
`;
const CheckboxVisible = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ checked: isChecked, disabled: isDisabled, mode }) => {
    const { background, border, checked, disabled, hover } = MAPPINGS_MODE[mode];
    return styled_components_browser_esm/* css */.iv `
      border-radius: ${getRadius('s')};
      cursor: pointer;
      flex-shrink: 0;
      height: ${getSpace('2xl')};
      position: relative;
      transition: 0.3s;
      width: ${getSpace('2xl')};

      /* Mode */
      background-color: ${background};
      border: 2px solid ${border};

      &:hover {
        border-color: ${hover.border};
      }

      &.error {
        border-color: ${(tokens_default()).colors.red[700].value};
      }

      ${isDisabled &&
        `
          background-color: ${disabled.background} !important;
          border-color: ${disabled.border} !important;
          color: ${disabled.text} !important;
          pointer-events: none;
        `}

      ${isChecked &&
        `
        background-color: ${checked.background};
        border-color: ${checked.border};
      `}

      &::after {
        background-color: transparent;
        border: 3px solid ${border};
        border-top: none;
        border-right: none;
        border-radius: 2px;
        content: '';
        height: 0.4rem;
        left: 50%;
        outline: 1px solid transparent;
        opacity: ${isChecked ? 1 : 0};
        position: absolute;
        top: 40%;
        transform: translate(-50%, -50%) rotate(-45deg);
        width: 0.8rem;
      }
    `;
}}
`;
const CheckboxWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ mode }) => {
    const { focus } = MAPPINGS_MODE[mode];
    return styled_components_browser_esm/* css */.iv `
      align-items: center;
      display: inline-flex;

      input[type='checkbox'] {
        &:focus + label ${CheckboxVisible} {
          border-color: ${focus.border};
          box-shadow: ${focus.shadow};
          outline: 0;
        }
      }
    `;
}}
`;
//# sourceMappingURL=Checkbox.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Checkbox/Checkbox.js




// Component
// -----------------------------------------------------------------------------
const Checkbox = (0,react.forwardRef)(({ checked = CHECKBOX_DEFAULT_CHECKED, disabled = CHECKBOX_DEFAULT_DISABLED, label, mode = CHECKBOX_DEFAULT_MODE, name, onChange, role = CHECKBOX_DEFAULT_ROLE, size = CHECKBOX_DEFAULT_SIZE, value, ...rest }, ref) => {
    return ((0,jsx_runtime.jsxs)(CheckboxWrapper, { mode: mode, children: [(0,jsx_runtime.jsx)(CheckboxHidden, { checked: checked, disabled: disabled, id: name, name: name, ref: ref, onChange: onChange, value: value, ...rest }), (0,jsx_runtime.jsxs)(CheckboxLabel, { htmlFor: name, scale: size, children: [(0,jsx_runtime.jsx)(CheckboxVisible, { ...(role && { className: role }), checked: checked, disabled: disabled, mode: mode }), label] })] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Checkbox.displayName = 'Checkbox';
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);
//# sourceMappingURL=Checkbox.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/CheckboxGroup/CheckboxGroup.constants.js

// Constants.
// -----------------------------------------------------------------------------
/** Default 'disabled' value. */
const CHECKBOXGROUP_DEFAULT_DISABLED = false;
/** Default 'direction' value. */
const CHECKBOXGROUP_DEFAULT_DIRECTION = 'column';
/** Default 'mode' value. */
const CHECKBOXGROUP_DEFAULT_MODE = CHECKBOX_DEFAULT_MODE;
//# sourceMappingURL=CheckboxGroup.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/CheckboxGroup/CheckboxGroup.styled.js


// Styled-Components.
// -----------------------------------------------------------------------------
const CheckboxGroupWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ direction }) => {
    return styled_components_browser_esm/* css */.iv `
      display: inline-flex;
      flex-direction: ${direction};
      flex-wrap: wrap;
      gap: ${getSpace('m')};
    `;
}}
`;
//# sourceMappingURL=CheckboxGroup.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/CheckboxGroup/CheckboxGroup.js







// Component.
// -----------------------------------------------------------------------------
const CheckboxGroup = (0,react.forwardRef)(({ disabled = CHECKBOXGROUP_DEFAULT_DISABLED, direction = CHECKBOXGROUP_DEFAULT_DIRECTION, mode = CHECKBOXGROUP_DEFAULT_MODE, onChange, options, size = CHECKBOX_DEFAULT_SIZE, ...rest }, ref) => options.length === 0 ? null : ((0,jsx_runtime.jsx)(CheckboxGroupWrapper, { direction: direction, ref: ref, children: options.map((option, index) => ((0,react.createElement)(Checkbox_Checkbox, { ...((disabled || option.disabled) && { disabled: true }), checked: option.checked, key: `${option.name}-${index}`, label: option.label, mode: mode, onChange: (e) => {
            const newOptions = options.map((option) => ({
                ...option,
                checked: e.currentTarget.name === option.name
                    ? !option.checked
                    : option.checked
            }));
            onChange(e, newOptions);
        }, size: size, ...rest, name: option.name }))) })));
// Component configuration.
// -----------------------------------------------------------------------------
CheckboxGroup.displayName = 'CheckboxGroup';
/* harmony default export */ var CheckboxGroup_CheckboxGroup = (CheckboxGroup);
//# sourceMappingURL=CheckboxGroup.js.map
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTable.constants.js

// Mappings.
// -----------------------------------------------------------------------------
const DEFAULT_BASE_TABLE_ALIGN = 'left';
const DEFAULT_BASE_TABLE_BORDER_TYPE = 'row';
const DEFAULT_BASE_TABLE_FULL_WIDTH = false;
const DEFAULT_BASE_TABLE_MODE = 'light';
const DEFAULT_BASE_TABLE_ZEBRA = false;
const MAP_CELL_MODES = {
    dark: {
        actionsColor: (tokens_default()).colors.emerald[500].value,
        bgColor: (tokens_default()).colors.black[100].value,
        bgColorHover: (tokens_default()).colors.midnight[850].value,
        borderColor: (tokens_default()).colors.midnight[700].value,
        iconColor: (tokens_default()).colors.midnight[100].value,
        textColor: (tokens_default()).colors.midnight[200].value,
        thColorHover: (tokens_default()).colors.midnight[850].value
    },
    light: {
        actionsColor: (tokens_default()).colors.midnight[800].value,
        bgColor: (tokens_default()).colors.white[100].value,
        bgColorHover: (tokens_default()).colors.midnight[100].value,
        borderColor: (tokens_default()).colors.midnight[200].value,
        iconColor: (tokens_default()).colors.midnight[800].value,
        textColor: (tokens_default()).colors.midnight[800].value,
        thColorHover: (tokens_default()).colors.midnight[150].value
    }
};
const MAP_CELL_STYLES = {
    // Size 's'.
    s: {
        actions: {
            paddingX: 'l',
            paddingY: 'l',
            fontSize: 'l' // 20px
        },
        badge: {
            paddingX: 'm',
            paddingY: 'm',
            fontSize: 'xs' // 12px
        },
        button: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'xs' // 12px
        },
        free: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 's' // 14px
        },
        icon: {
            paddingX: 'l',
            paddingY: 'l',
            fontSize: 'l' // 20px
        },
        number: {
            paddingY: 'xl',
            paddingX: 'l',
            fontSize: 's' // 14px
        },
        text: {
            paddingY: 'xl',
            paddingX: 'l',
            fontSize: 's' // 14px
        }
    },
    // Size 'xs'.
    xs: {
        actions: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'm' // 16px
        },
        badge: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'xs' // 12px
        },
        button: {
            paddingX: 'xs',
            paddingY: 'xs',
            fontSize: '2xs' // 12px
        },
        free: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 's' // 14px
        },
        icon: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'm' // 16px
        },
        number: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'xs' // 12px
        },
        text: {
            paddingX: 's',
            paddingY: 's',
            fontSize: 'xs' // 12px
        }
    }
};
const MAP_HEADERS_STYLES = {
    // Size 's'.
    s: {
        paddingY: 'xl',
        paddingX: 'l',
        fontSize: 's' // 14px
    },
    // Size 'xs'.
    xs: {
        paddingX: 's',
        paddingY: 's',
        fontSize: 'xs' // 12px
    }
};
//# sourceMappingURL=BaseTable.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTable.styled.js


// styled-components.
// -----------------------------------------------------------------------------
const BaseTableRoot = styled_components_browser_esm/* default.table */.ZP.table `
  ${({ borderType, fullWidth, mode, zebra }) => {
    const { actionsColor, bgColor, bgColorHover, borderColor, textColor } = MAP_CELL_MODES[mode];
    return styled_components_browser_esm/* css */.iv `
      // Box model.
      border-collapse: collapse;
      width: ${fullWidth ? '100%' : 'auto'};

      // Colors.
      border: 1px solid ${borderColor};

      // Headers.
      thead > tr {
        border-bottom: 1px solid ${borderColor};
      }

      th,
      td {
        background-color: ${bgColor};
        color: ${textColor};
      }

      td.actions-ctas .actions-ctas-menu {
        color: ${actionsColor};
      }

      // Elements.
      ${borderType === 'column' &&
        `
        th, td {
          border-left: 1px solid ${borderColor};
          border-right: 1px solid ${borderColor};
        }
      `}

      ${borderType === 'full' &&
        `
        th, td {
          border: 1px solid ${borderColor};
        }
      `}

      ${borderType === 'none' && ``}

      ${borderType === 'row' &&
        `
        tr {
          border: 1px solid ${borderColor};
        }
      `}

      ${zebra &&
        `
        tbody tr:nth-child(odd) td {
          background-color: ${bgColorHover};
        }
      `}
    `;
}}
`;
//# sourceMappingURL=BaseTable.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTable.js




// Component.
// -----------------------------------------------------------------------------
const BaseTable = (0,react.forwardRef)(({ borderType = DEFAULT_BASE_TABLE_BORDER_TYPE, children, fullWidth = DEFAULT_BASE_TABLE_FULL_WIDTH, mode = DEFAULT_BASE_TABLE_MODE, zebra = DEFAULT_BASE_TABLE_ZEBRA, ...rest }, ref) => ((0,jsx_runtime.jsx)(BaseTableRoot, { borderType: borderType, fullWidth: fullWidth, mode: mode, ref: ref, zebra: zebra, ...rest, children: children })));
// Component configuration.
// -----------------------------------------------------------------------------
BaseTable.displayName = 'BaseTable';
/* harmony default export */ var BaseTable_BaseTable = (BaseTable);
//# sourceMappingURL=BaseTable.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTableBody.js

// Component.
// -----------------------------------------------------------------------------
// Its only function is to render the 'tbody' node.
const BaseTableBody = ({ children }) => {
    return (0,jsx_runtime.jsx)("tbody", { children: children });
};
//# sourceMappingURL=BaseTableBody.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTableHead.js

// Component.
// -----------------------------------------------------------------------------
// Its only function is to render the 'thead' node.
const BaseTableHead = ({ children }) => {
    return ((0,jsx_runtime.jsx)("thead", { children: (0,jsx_runtime.jsx)("tr", { children: children }) }));
};
//# sourceMappingURL=BaseTableHead.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTableNoData.styled.js



// styled-components.
// -----------------------------------------------------------------------------
const BaseTableEmptyIcon = styled_components_browser_esm/* default.div */.ZP.div `
  color: ${(tokens_default()).colors.midnight[300].value};

  svg {
    height: 48px;
    width: 48px;
  }
`;
const BaseTableNoDataRoot = styled_components_browser_esm/* default.tr */.ZP.tr ``;
const BaseTableNoDataTitle = styled_components_browser_esm/* default.div */.ZP.div `
  color: ${(tokens_default()).colors.midnight[500].value};
  text-transform: uppercase;
`;
const BaseTableNoDataWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  // Box.
  align-items: center;
  display: flex;
  flex-direction: column;

  // Spacing.
  gap: ${getSpace('xl')};
  margin: ${getSpace('5xl')};
`;
//# sourceMappingURL=BaseTableNoData.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTableNoData.js




// Component.
// -----------------------------------------------------------------------------
const BaseTableNoData = ({ label, span }) => ((0,jsx_runtime.jsx)(BaseTableNoDataRoot, { children: (0,jsx_runtime.jsx)("td", { colSpan: span, children: (0,jsx_runtime.jsxs)(BaseTableNoDataWrapper, { children: [(0,jsx_runtime.jsx)(BaseTableEmptyIcon, { children: (0,jsx_runtime.jsx)(Icon_Icon, { icon: pro_solid_svg_icons/* faEmptySet */.ImE }) }), (0,jsx_runtime.jsx)(BaseTableNoDataTitle, { children: label })] }) }) }));
//# sourceMappingURL=BaseTableNoData.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTableTH.styled.js



// styled-components.
// -----------------------------------------------------------------------------
const BaseTableNoSortable = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ align }) => {
    return styled_components_browser_esm/* css */.iv `
      ${align === 'center' && `justify-content: center;`}
      ${align === 'left' && `justify-content: flex-start;`}
      ${align === 'right' && `justify-content: flex-end;`}

      // Box model
      align-items: center;
      display: flex;
    `;
}}
`;
const BaseTableSortable = styled_components_browser_esm/* default.button */.ZP.button `
  ${({ align }) => {
    return styled_components_browser_esm/* css */.iv `
      // Box model
      align-items: center;
      border: none;
      display: flex;
      gap: ${getSpace('xs')};
      padding: 0;
      width: 100%;

      ${align === 'center' && `justify-content: center;`}
      ${align === 'left' && `justify-content: flex-start;`}
      ${align === 'right' && `justify-content: flex-end;`}

      // Colors.
      background-color: transparent;

      // Space.
      gap: ${getSpace('m')};

      // Miscellanea.
      cursor: pointer;
    `;
}}
`;
const BaseTableTHRoot = styled_components_browser_esm/* default.th */.ZP.th `
  ${({ align, isSortable, mode, size }) => {
    const { paddingX, paddingY } = MAP_HEADERS_STYLES[size];
    const { thColorHover } = MAP_CELL_MODES[mode];
    return styled_components_browser_esm/* css */.iv `
      // Display & Box model.
      padding-bottom: ${getSpace(paddingY)};
      padding-left: ${getSpace(paddingX)};
      padding-right: ${getSpace(paddingX)};
      padding-top: ${getSpace(paddingY)};

      ${align && `text-align: ${align};`}

      ${isSortable &&
        `
        :hover {
          background-color: ${thColorHover};
        }
      `}
    }
  `;
}}
`;
//# sourceMappingURL=BaseTableTH.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTableTH.js








// Component.
// -----------------------------------------------------------------------------
const BaseTableTH = ({ align = DEFAULT_BASE_TABLE_ALIGN, label, mode = DEFAULT_BASE_TABLE_MODE, size, sortable, type, className, labelSlot, ...rest }) => {
    return ((0,jsx_runtime.jsx)(BaseTableTHRoot, { isSortable: Boolean(sortable), mode: mode, size: size, type: type, className: className, children: sortable ? ((0,jsx_runtime.jsxs)(BaseTableSortable, { align: align, ...(rest.sortOrder && {
                className: 'sorted'
            }), onClick: () => rest.onClick(label), children: [(0,jsx_runtime.jsxs)(Stack_Stack, { gap: "2xs", alignment: "center", children: [labelSlot, (0,jsx_runtime.jsx)(Text_Text, { bold: true, size: MAP_HEADERS_STYLES[size].fontSize, uppercase: true, children: label })] }), rest.sortOrder ? ((0,jsx_runtime.jsx)(Icon_Icon, { className: "sorted", icon: rest.sortOrder === 'asc'
                        ? pro_duotone_svg_icons/* faSortUp */.foy
                        : pro_duotone_svg_icons/* faSortDown */.u9C, size: "m" })) : ((0,jsx_runtime.jsx)(Icon_Icon, { icon: pro_solid_svg_icons/* faSort */.CmM, size: "m" }))] })) : ((0,jsx_runtime.jsx)(BaseTableNoSortable, { align: align, children: (0,jsx_runtime.jsxs)(Stack_Stack, { gap: "2xs", alignment: "center", children: [labelSlot, (0,jsx_runtime.jsx)(Text_Text, { bold: true, size: MAP_HEADERS_STYLES[size].fontSize, uppercase: true, children: label })] }) })) }));
};
//# sourceMappingURL=BaseTableTH.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTableTD.constants.js
// Constants
// -----------------------------------------------------------------------------
const BASE_TABLE_TD_ALIGN = 'left';
//# sourceMappingURL=BaseTableTD.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTableTD.styled.js



// styled-components.
// -----------------------------------------------------------------------------
const BaseTableTDRoot = styled_components_browser_esm/* default.td */.ZP.td `
  ${({ align, size, type }) => {
    const { paddingX, paddingY } = MAP_CELL_STYLES[size][type];
    return styled_components_browser_esm/* css */.iv `
      // Box.
      text-align: ${align};

      // Scacing
      padding-bottom: ${getSpace(paddingY)};
      padding-left: ${getSpace(paddingX)};
      padding-right: ${getSpace(paddingX)};
      padding-top: ${getSpace(paddingY)};
    `;
}}
`;
//# sourceMappingURL=BaseTableTD.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTableTD.js



// Component.
// -----------------------------------------------------------------------------
const BaseTableTD = ({ align = BASE_TABLE_TD_ALIGN, children, size, type, className }) => ((0,jsx_runtime.jsx)(BaseTableTDRoot, { align: align, size: size, type: type, className: className, children: children }));
//# sourceMappingURL=BaseTableTD.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/index.js
// Imports.






// Export.

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTableLoading.styled.js



// styled-components.
// -----------------------------------------------------------------------------
const BaseTableLoadingRoot = styled_components_browser_esm/* default.tr */.ZP.tr ``;
const BaseTableLoadingTitle = styled_components_browser_esm/* default.div */.ZP.div `
  color: ${(tokens_default()).colors.midnight[500].value};
  text-transform: uppercase;
`;
const BaseTableLoadingWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  // Box.
  align-items: center;
  display: flex;
  flex-direction: column;

  // Spacing.
  gap: ${getSpace('xl')};
  margin: ${getSpace('5xl')};
`;
//# sourceMappingURL=BaseTableLoading.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseTable/BaseTableLoading.js


// Component.
// -----------------------------------------------------------------------------
const BaseTableLoading = ({ label, span }) => ((0,jsx_runtime.jsx)(BaseTableLoadingRoot, { children: (0,jsx_runtime.jsx)("td", { colSpan: span, children: (0,jsx_runtime.jsx)(BaseTableLoadingWrapper, { children: (0,jsx_runtime.jsx)(BaseTableLoadingTitle, { children: label }) }) }) }));
//# sourceMappingURL=BaseTableLoading.js.map
;// CONCATENATED MODULE: ../ui-library/dist/foundation/utils/object.utils.js
// Functions.
// -----------------------------------------------------------------------------
const pick = (object, prop) => {
    const keys = prop.split('.');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let value = object;
    keys.forEach((key) => {
        if (typeof value === 'undefined' || value === null) {
            return undefined;
        }
        value = value[key];
    });
    return value;
};
//# sourceMappingURL=object.utils.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ControlledTable/ControlledActions.styled.js






// styled-components.
// -----------------------------------------------------------------------------
const ControlledActionSpin = styled_components_browser_esm/* default.div */.ZP.div `
  // Display & Box.
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1px 0;
  width: 100%;
`;
const ControlledActionLinkSpin = styled_components_browser_esm/* default.div */.ZP.div `
  // Display & Box.
  align-items: center;
  display: flex;
  gap: ${getSpace('m')};
  padding: ${getSpace('xl')};

  // Other.
  cursor: pointer;

  &:hover {
    background-color: ${(tokens_default()).colors.active[100].value};
    color: ${(tokens_default()).colors.navy[800].value};
  }
`;
const ControlledActionButton = styled_components_browser_esm/* default.button */.ZP.button `
  ${({ isOpen }) => {
    return styled_components_browser_esm/* css */.iv `
      // Box model.
      border: none;

      // Colors.
      background-color: ${isOpen
        ? (tokens_default()).colors.active[100].value
        : 'transparent'};

      ${isOpen &&
        `
        color: ${(tokens_default()).colors.navy[800].value};
      `}

      // Space.
      padding: ${getSpace('l')};

      // Miscellanea.
      cursor: pointer;

      svg {
        height: 20px;
        width: 20px;
      }

      ${!isOpen &&
        `
        &:hover {
        svg {
          opacity: 0.3;
        }
      }
      `}
    `;
}}
`;
const ControlledActionGroup = styled_components_browser_esm/* default.div */.ZP.div `
  // Display & Box model.
  padding-bottom: ${getSpace('s')};
  padding-left: ${getSpace('xl')};
  padding-right: ${getSpace('xl')};
  padding-top: ${getSpace('s')};

  // Color.
  color: ${(tokens_default()).colors.midnight[500].value};

  // Text.
  font-size: ${getFontSize('xs')};
  font-weight: ${getFontWeight('black')};
  text-transform: uppercase;
`;
const ControlledActionSeparator = styled_components_browser_esm/* default.div */.ZP.div `
  // Display & Box model.
  background: ${(tokens_default()).colors.midnight[200].value};
  height: 2px;
  margin-bottom: ${getSpace('xs')};
  margin-top: ${getSpace('xs')};
  width: 100%;
`;
const ControlledActionsOptionsWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ theme }) => {
    return styled_components_browser_esm/* css */.iv `
      // Box model.
      border-radius: ${shape_utils_getRadius(theme, 'm')};
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 0;
      top: 60px;
      white-space: nowrap;
      width: fit-content;

      z-index: 10;

      // Space.
      padding: ${getSpace('s')};

      // Color.
      background-color: ${(tokens_default()).colors.white[100].value};
      border: 2px solid ${(tokens_default()).colors.midnight[200].value};
    `;
}}
`;
const ControlledActionWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  // Box model.
  display: flex;
  flex-direction: column;
  gap: ${getSpace('2xs')};
  min-width: 56px;
  position: relative;
`;
const ControlledActionOptionAsButton = styled_components_browser_esm/* default.button */.ZP.button `
  ${({ schema, theme }) => {
    const { default: color } = getSchemaVariant({
        mode: 'light',
        schema,
        theme,
        variant: 'bare'
    });
    return styled_components_browser_esm/* css */.iv `
      // Box model.
      align-items: center;
      border: none;
      display: flex;

      // Colors.
      background-color: ${color.background};
      color: ${color.foreground};

      svg {
        color: ${color.foregroundAlt};
      }

      // Space.
      cursor: pointer;
      gap: ${getSpace('m')};
      padding: ${getSpace('xl')};

      &:hover {
        background-color: ${(tokens_default()).colors.active[100].value};
      }

      > span {
        display: inline-block;
      }
    `;
}}
`;
const ControlledActionOptionAsLink = styled_components_browser_esm/* default.a */.ZP.a `
  // Display & Box model.
  align-items: center;
  border: none;
  display: flex;
  gap: ${getSpace('m')};
  padding: ${getSpace('xl')};

  // Colors.
  background-color: transparent;
  color: inherit;

  // Other.
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background-color: ${(tokens_default()).colors.active[100].value};
    color: ${(tokens_default()).colors.navy[800].value};
  }

  &:visited,
  &:active,
  &:focus {
    color: inherit;
  }

  > span {
    display: inline-block;
  }
`;
const ControlledActionsRoot = styled_components_browser_esm/* default.td */.ZP.td `
  ${({ borderType }) => {
    return styled_components_browser_esm/* css */.iv `
      ${borderType === 'full' &&
        `
        box-shadow: -2px 2px 5px 0px rgba(38, 26, 25, 0.04), -3px 0px 5px 0px rgba(38, 26, 25, 0.05);
      `}

      ${borderType === 'row' &&
        `
        box-shadow: -2px 2px 5px 0px rgba(38, 26, 25, 0.04), -3px 0px 5px 0px rgba(38, 26, 25, 0.05);
      `}

      ${borderType === 'column' &&
        `
      box-shadow: -3px 0px 0px 0px rgba(38, 26, 25, 0.05);
      `}
    `;
}}
`;
//# sourceMappingURL=ControlledActions.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ControlledTable/ControlledActions.hooks.js

// Custom Hook.
// -----------------------------------------------------------------------------
const useControlledActions = ({ actions, refOptions, row }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [clickedAction, setClickedAction] = (0,react.useState)();
    // Variables.
    // ---------------------------------------------------------------------------
    const actionItems = (0,react.useMemo)(() => {
        const items = actions.filter((action) => {
            if (!action.show) {
                return action;
            }
            return action.show(row.original);
        });
        return items;
    }, [actions, row]);
    const hasIcons = (0,react.useMemo)(() => actions.every((action) => action.icon), [actions]);
    // Functions.
    // ---------------------------------------------------------------------------
    const handleOnClickCTA = (0,react.useCallback)(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);
    const handleOnClickAction = (0,react.useCallback)(async (action, event) => {
        if (!clickedAction) {
            if (action.isAsync) {
                setClickedAction(action);
            }
            await action.callback(row, event);
            setIsOpen(false);
            setClickedAction(undefined);
        }
    }, [clickedAction, row]);
    const handleOnClickButtonItem = (0,react.useCallback)(async (action, event) => {
        await handleOnClickAction(action, event);
    }, [handleOnClickAction]);
    const handleOnClickLinkItem = (0,react.useCallback)(async (action, event) => {
        event.preventDefault();
        await handleOnClickAction(action, event);
    }, [handleOnClickAction]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react.useEffect)(() => {
        // On Esc.
        const handleOnEsc = (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                setIsOpen(false);
            }
        };
        // Outside click.
        const handleOutsideClick = (event) => {
            if (refOptions.current &&
                !refOptions.current.contains(event.target)) {
                event.preventDefault();
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('click', handleOutsideClick);
            document.addEventListener('keydown', handleOnEsc);
        }
        else {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('keydown', handleOnEsc);
        }
        return () => {
            document.removeEventListener('keydown', handleOnEsc);
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isOpen, refOptions]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        actionItems,
        clickedAction,
        hasIcons,
        isAsyncFnClicked: Boolean(clickedAction),
        isOpen,
        onClickCTA: handleOnClickCTA,
        onClickLinkOption: handleOnClickLinkItem,
        onClickButtonOption: handleOnClickButtonItem
    };
};
//# sourceMappingURL=ControlledActions.hooks.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ControlledTable/ControlledActions.contants.js
// Constants.
// -----------------------------------------------------------------------------
const DEFAULT_ACTION_SCHEMA = 'neutral';
//# sourceMappingURL=ControlledActions.contants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ControlledTable/ControlledActions.js









// Component.
// -----------------------------------------------------------------------------
const ControlledActions = ({ actions, borderType, row, size }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const refOptions = (0,react.useRef)(null);
    const { actionItems, clickedAction, hasIcons, isAsyncFnClicked, isOpen, onClickCTA, onClickLinkOption, onClickButtonOption } = useControlledActions({
        actions,
        refOptions,
        row
    });
    // Render.
    // ---------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(ControlledActionsRoot, { borderType: borderType, className: "actions-ctas", children: (0,jsx_runtime.jsx)(ControlledActionWrapper, { children: !(0,lodash.isEmpty)(actionItems) && ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)(ControlledActionButton, { className: "actions-ctas-menu", isOpen: isOpen, onClick: onClickCTA, children: (0,jsx_runtime.jsx)(Icon_Icon, { icon: pro_solid_svg_icons/* faEllipsisVertical */.Uwo }) }), isOpen && ((0,jsx_runtime.jsx)(ControlledActionsOptionsWrapper, { ref: refOptions, children: actionItems.map((action, index) => {
                            const isClicked = clickedAction
                                ? (0,lodash.isEqual)(action, clickedAction)
                                : false;
                            return ((0,jsx_runtime.jsxs)(react.Fragment, { children: [action.separator && (0,jsx_runtime.jsx)(ControlledActionSeparator, {}), action.groupName && ((0,jsx_runtime.jsx)(ControlledActionGroup, { children: action.groupName })), action.asLink ? ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: isAsyncFnClicked ? ((0,jsx_runtime.jsxs)(ControlledActionLinkSpin, { children: [hasIcons && ((0,jsx_runtime.jsx)(Icon_Icon, { icon: action.icon })), (0,jsx_runtime.jsx)(Text_Text, { size: size, children: action.label })] })) : ((0,jsx_runtime.jsxs)(ControlledActionOptionAsLink, { href: action.href, ...(action.callback && {
                                                onClick: async (event) => {
                                                    await onClickLinkOption(action, event);
                                                }
                                            }), ...(action.target && { target: action.target }), children: [hasIcons && ((0,jsx_runtime.jsx)(Icon_Icon, { icon: action.icon })), (0,jsx_runtime.jsx)(Text_Text, { size: size, children: action.label })] })) })) : ((0,jsx_runtime.jsx)(ControlledActionOptionAsButton, { schema: action.schema ?? DEFAULT_ACTION_SCHEMA, onClick: async (event) => {
                                            await onClickButtonOption(action, event);
                                        }, children: isClicked ? (hasIcons ? ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)(Icon_Icon, { spin: true, icon: pro_solid_svg_icons/* faSpinnerThird */.AX7 }), (0,jsx_runtime.jsx)(Text_Text, { size: size, children: action.label })] })) : ((0,jsx_runtime.jsx)(ControlledActionSpin, { children: (0,jsx_runtime.jsx)(Icon_Icon, { spin: true, icon: pro_solid_svg_icons/* faSpinnerThird */.AX7 }) }))) : ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [hasIcons && ((0,jsx_runtime.jsx)(Icon_Icon, { icon: action.icon })), (0,jsx_runtime.jsx)(Text_Text, { size: size, children: action.label })] })) }))] }, index));
                        }) }))] })) }) }));
};
//# sourceMappingURL=ControlledActions.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ControlledTable/ControlledRows.contants.js
// Constants.
// -----------------------------------------------------------------------------
const MAP_TD_ALIGN = {
    actions: 'left',
    badge: 'left',
    button: 'left',
    free: 'left',
    icon: 'left',
    number: 'right',
    text: 'left'
};
//# sourceMappingURL=ControlledRows.contants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ControlledTable/ControlledRows.styled.js


// styled-components.
// -----------------------------------------------------------------------------
const ControlledTableRowRoot = styled_components_browser_esm/* default.tr */.ZP.tr `
  ${({ isSelected }) => {
    return styled_components_browser_esm/* css */.iv `
      ${isSelected &&
        `
        > td {
          background-color: ${(tokens_default()).colors.active[100].value} !important;
          color: ${(tokens_default()).colors.midnight[800].value} !important;
        }
      `}
    `;
}}
`;
//# sourceMappingURL=ControlledRows.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ControlledTable/ControlledRows.js







// Component.
// -----------------------------------------------------------------------------
const ControlledRows = ({ actions, borderType, columns, dataRowId, enableRowSelection, onChangeOne, rows, size }) => ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: rows.map((row, index) => {
        const rowId = typeof dataRowId === 'function'
            ? dataRowId(row.original)
            : pick(row, dataRowId);
        return ((0,jsx_runtime.jsxs)(ControlledTableRowRoot, { isSelected: row.isSelected, children: [enableRowSelection && ((0,jsx_runtime.jsx)(BaseTableTD, { size: size, type: "icon", children: (0,jsx_runtime.jsx)(Checkbox_Checkbox, { checked: row.isSelected, name: `tr-check-${rowId}`, label: "", onChange: () => onChangeOne(row) }) })), row.columns.map((cell, j) => {
                    const { align, type, className, render } = columns[j];
                    return ((0,jsx_runtime.jsx)(BaseTableTD, { align: align ?? MAP_TD_ALIGN[type], size: size, type: type, className: className, children: typeof render === 'function'
                            ? render(row.original)
                            : pick(row.original, render) }, `td-${rowId}-${j}`));
                }), actions && ((0,jsx_runtime.jsx)(ControlledActions, { actions: actions, borderType: borderType, row: row, size: size }))] }, `tbody-tr-${rowId || index}`));
    }) }));
//# sourceMappingURL=ControlledRows.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ControlledTable/ControlledTable.constants.js
// Constantes.
// ----------------------------------------------------------------------
const DEFAULT_BORDER_TYPE = 'row';
const DEFAULT_ENABLE_ROW_SELECTION = false;
const DEFAULT_FULL_WIDTH = true;
const DEFAULT_LOADING_MESSAGE = 'Loading...';
const DEFAULT_MODE = 'light';
const DEFAULT_NO_DATA_MESSAGE = 'No Data';
const DEFAULT_SELECTED_DATA = [];
const DEFAULT_SIZE = 's';
const DEFAULT_ZEBRA = false;
const DEFAULT_STICKY_HEADER = false;
const DEFAULT_MAX_HEIGHT = 500;
//# sourceMappingURL=ControlledTable.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ControlledTable/ControlledTable.hook.js


// Custom hook.
// -----------------------------------------------------------------------------
const useControlledTable = ({ actions, columns, data, onSelectedDataChange, selectedData }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    const [rows, setRows] = (0,react.useState)([]);
    const [sortColumn, setSortColumn] = (0,react.useState)();
    const [sortOrder, setSortOrder] = (0,react.useState)();
    // Variables.
    // ---------------------------------------------------------------------------
    const hasActions = (0,react.useMemo)(() => {
        if (!actions) {
            return false;
        }
        return actions.some((action) => {
            return rows.some((row) => {
                if (action.show === undefined) {
                    return true;
                }
                return action.show(row.original);
            });
        });
    }, [actions, rows]);
    // Funciones.
    // ---------------------------------------------------------------------------
    const handleOnChangeAll = (0,react.useCallback)(() => {
        if (onSelectedDataChange) {
            const everySelected = rows.every((row) => row.isSelected);
            const selectedRows = everySelected
                ? []
                : rows.map((row) => row.original);
            onSelectedDataChange(selectedRows);
        }
    }, [onSelectedDataChange, rows]);
    const handleOnChangeOne = (0,react.useCallback)((row) => {
        if (onSelectedDataChange) {
            const newState = !row.isSelected;
            const currentSelected = rows
                .filter((row) => row.isSelected)
                .map((row) => row.original);
            const selectedRows = newState
                ? [...currentSelected, row.original]
                : currentSelected.filter((current) => !(0,lodash.isEqual)(current, row.original));
            onSelectedDataChange(selectedRows);
        }
    }, [onSelectedDataChange, rows]);
    const handleOnSort = (0,react.useCallback)((label) => {
        // Sort master.
        const newSortColumn = columns.find((column) => column.label === label);
        // New order.
        const newSortOrder = sortColumn === undefined ||
            sortOrder === undefined ||
            sortColumn.label !== label
            ? 'asc'
            : sortOrder === 'asc'
                ? 'desc'
                : 'asc';
        // Sorted rows.
        const index = columns.findIndex((column) => column.label === label);
        const { sortValue, type } = columns[index];
        const full = rows.map((row) => {
            let sort;
            // Sort function.
            if (sortValue) {
                sort = sortValue(row.original);
            }
            else if (type === 'text') {
                sort = row.columns[index].toLowerCase();
            }
            else {
                sort = row.columns[index];
            }
            return {
                ...row,
                sort
            };
        });
        const partialNewRows = (0,lodash.sortBy)(full, 'sort');
        const newRows = newSortOrder === 'asc' ? partialNewRows : partialNewRows.reverse();
        // Update state.
        setSortColumn(newSortColumn);
        setSortOrder(newSortOrder);
        setRows(newRows);
    }, [columns, rows, sortColumn, sortOrder]);
    const handleSetRows = (0,react.useCallback)(() => {
        if (!data || data.length === 0) {
            setRows([]);
        }
        else {
            const items = data.map((original) => {
                const isSelected = selectedData.some((selected) => (0,lodash.isEqual)(selected, original));
                return {
                    columns,
                    isSelected,
                    original
                };
            });
            setRows(items);
        }
    }, [columns, data, selectedData]);
    const isSortColumn = (0,react.useCallback)((label) => {
        if (!sortColumn) {
            return false;
        }
        return sortColumn.label === label;
    }, [sortColumn]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react.useEffect)(() => {
        if (isLoading) {
            setIsLoading(false);
            handleSetRows();
        }
    }, [handleSetRows, isLoading]);
    (0,react.useEffect)(() => {
        handleSetRows();
    }, [data, handleSetRows]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        hasActions,
        isLoading,
        isSortColumn,
        onChangeAll: handleOnChangeAll,
        onChangeOne: handleOnChangeOne,
        onSort: handleOnSort,
        rows,
        sortOrder
    };
};
//# sourceMappingURL=ControlledTable.hook.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ControlledTable/ControlledTable.styled.js


// styled-components.
// -----------------------------------------------------------------------------
const Root = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ stickyHeader, mode, maxHeight }) => {
    const { borderColor } = MAP_CELL_MODES[mode];
    return styled_components_browser_esm/* css */.iv `
      ${stickyHeader &&
        `
        border-bottom: 1px solid ${borderColor};
        border-top: 1px solid ${borderColor};
        overflow-y: auto;
        max-height: ${maxHeight}px;

        table {
          border-top: 0;
          border-bottom: 0;
        }

        thead {
          position: sticky;
          top: 0;
          z-index: 1;
        }

        table tr {
          border: 0;
        }

        table tbody tr {
          border-bottom: 1px solid ${borderColor};
          border-left: 1px solid ${borderColor};
        }

        table thead tr th {
          border-bottom: 1px solid ${borderColor};
        }
      `}
    `;
}}
`;
const ControlledTableRoot = styled_components_browser_esm/* default.table */.ZP.table `
  border-collapse: collapse;
`;
const ControlledTableHeadActions = styled_components_browser_esm/* default.th */.ZP.th `
  ${({ borderType }) => {
    return styled_components_browser_esm/* css */.iv `
      ${borderType === 'full' &&
        `
        box-shadow: -2px 2px 5px 0px rgba(38, 26, 25, 0.04), -3px 0px 5px 0px rgba(38, 26, 25, 0.05);
      `}

      ${borderType === 'row' &&
        `
        box-shadow: -2px 2px 5px 0px rgba(38, 26, 25, 0.04), -3px 0px 5px 0px rgba(38, 26, 25, 0.05);
      `}

      ${borderType === 'column' &&
        `
      box-shadow: -3px 0px 0px 0px rgba(38, 26, 25, 0.05);
      `}
    `;
}}
`;
//# sourceMappingURL=ControlledTable.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/ControlledTable/ControlledTable.js









// Component.
// -----------------------------------------------------------------------------
const ControlledTable = ({ actions, borderType = DEFAULT_BORDER_TYPE, columns, dataRowId, enableRowSelection = DEFAULT_ENABLE_ROW_SELECTION, fullWidth = DEFAULT_FULL_WIDTH, data, noDataMessage = DEFAULT_NO_DATA_MESSAGE, loadingMessage = DEFAULT_LOADING_MESSAGE, mode = DEFAULT_MODE, onSelectedDataChange, selectedData = DEFAULT_SELECTED_DATA, size = DEFAULT_SIZE, zebra = DEFAULT_ZEBRA, stickyHeader = DEFAULT_STICKY_HEADER, maxHeight = DEFAULT_MAX_HEIGHT, ...rest }) => {
    // Hooks.
    // -------------------------------------------------------------------------
    const { hasActions, isLoading, isSortColumn, onChangeAll, onChangeOne, onSort, rows, sortOrder } = useControlledTable({
        actions,
        columns,
        data,
        selectedData,
        onSelectedDataChange
    });
    // Guard condition.
    // -------------------------------------------------------------------------
    if ((0,lodash.isEmpty)(columns)) {
        return null;
    }
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(Root, { stickyHeader: stickyHeader, mode: mode, maxHeight: maxHeight, children: (0,jsx_runtime.jsxs)(BaseTable_BaseTable, { borderType: borderType, fullWidth: fullWidth, mode: mode, zebra: zebra, ...rest, children: [(0,jsx_runtime.jsxs)(BaseTableHead, { children: [enableRowSelection && ((0,jsx_runtime.jsx)(BaseTableTH, { label: (0,jsx_runtime.jsx)(Checkbox_Checkbox, { name: "tr-check-th", label: "", onChange: onChangeAll }), mode: mode, size: size, sortable: false, type: "icon" })), columns.map(({ align, className, label, sortable, type, labelSlot }, index) => ((0,jsx_runtime.jsx)(BaseTableTH, { align: align, className: className, label: label, labelSlot: labelSlot, mode: mode, onClick: onSort, size: size, sortable: sortable !== undefined ? sortable : true, sortOrder: isSortColumn(label) ? sortOrder : undefined, type: type }, `thead-th-${index}`))), hasActions && (0,jsx_runtime.jsx)(ControlledTableHeadActions, { borderType: borderType })] }), (0,jsx_runtime.jsx)(BaseTableBody, { children: isLoading ? ((0,jsx_runtime.jsx)(BaseTableLoading, { label: loadingMessage, span: columns.length +
                            (enableRowSelection ? 1 : 0) +
                            (hasActions ? 1 : 0) })) : rows?.length === 0 ? ((0,jsx_runtime.jsx)(BaseTableNoData, { label: noDataMessage, span: columns.length +
                            (enableRowSelection ? 1 : 0) +
                            (hasActions ? 1 : 0) })) : ((0,jsx_runtime.jsx)(ControlledRows, { ...(hasActions && { actions }), borderType: borderType, columns: columns, dataRowId: dataRowId, enableRowSelection: enableRowSelection, onChangeOne: onChangeOne, rows: rows, size: size })) })] }) }));
};
// Component configuration.
// -----------------------------------------------------------------------------
ControlledTable.displayName = 'ControlledTable';
/* harmony default export */ var ControlledTable_ControlledTable = (ControlledTable);
//# sourceMappingURL=ControlledTable.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Dropdown/Dropdown.constants.js

// Constants.
// -----------------------------------------------------------------------------
const Dropdown_constants_DEFAULT_MODE = 'light';
const DEFAULT_POSITION = 'left';
const DEFAULT_SCHEMA = 'neutral';
const Dropdown_constants_DEFAULT_SIZE = 's';
const DEFAULT_VARIANT = 'hard';
const DROPDOWN_ICON_SIZES = BUTTON_ICON_SIZES;
const DROPDOWN_PADDING_SIZES = BUTTON_PADDING_SIZES;
const DROPDOWN_OPTION_SCHEMA = 'neutral';
//# sourceMappingURL=Dropdown.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Dropdown/Dropdown.hooks.js

// Hooks.
// -----------------------------------------------------------------------------
const useDropdown = ({ options, refOptions }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [clickedOption, setClickedOption] = (0,react.useState)();
    // Variables.
    // ---------------------------------------------------------------------------
    const hasIcons = (0,react.useMemo)(() => options.every((option) => Boolean(option.icon)), [options]);
    // Handlers.
    // ---------------------------------------------------------------------------
    const handleOnClickCTA = (0,react.useCallback)(() => {
        setIsOpen((prev) => !prev);
    }, []);
    const handleOnClickOption = (0,react.useCallback)(async (option) => {
        if (!clickedOption) {
            if (option.isAsync) {
                setClickedOption(option);
            }
            await option.callback();
            setIsOpen(false);
            setClickedOption(undefined);
        }
    }, [clickedOption]);
    const handleOnClickOptionButton = (0,react.useCallback)(async (option) => {
        await handleOnClickOption(option);
    }, [handleOnClickOption]);
    const handleOnClickOptionLink = (0,react.useCallback)(async (option, event) => {
        event.preventDefault();
        await handleOnClickOption(option);
    }, [handleOnClickOption]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react.useEffect)(() => {
        // On Esc.
        const handleOnEsc = (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                setIsOpen(false);
            }
        };
        // Outside click.
        const handleOutsideClick = (event) => {
            if (refOptions.current &&
                !refOptions.current.contains(event.target)) {
                event.preventDefault();
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('click', handleOutsideClick);
            document.addEventListener('keydown', handleOnEsc);
        }
        else {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('keydown', handleOnEsc);
        }
        return () => {
            document.removeEventListener('keydown', handleOnEsc);
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isOpen, refOptions]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        clickedOption,
        hasIcons,
        isOpen,
        isWaiting: Boolean(clickedOption),
        onClickCTA: handleOnClickCTA,
        onClickOptionButton: handleOnClickOptionButton,
        onClickOptionLink: handleOnClickOptionLink
    };
};
//# sourceMappingURL=Dropdown.hooks.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Dropdown/Dropdown.styles.js






// styled-components.
// -----------------------------------------------------------------------------
const DropdownButton = styled_components_browser_esm/* default.button */.ZP.button `
  ${({ mode, schema, size, theme, variant }) => {
    const { default: color, disabled, focus, hover } = getSchemaVariant({
        mode,
        schema,
        theme,
        variant
    });
    return styled_components_browser_esm/* css */.iv `
      // Display & Box model.
      align-items: center;
      border-radius: ${shape_utils_getRadius(theme, 'm')};
      display: inline-flex;
      gap: ${getSpace('s')};
      justify-content: center;
      padding-bottom: ${getSpace(DROPDOWN_PADDING_SIZES[size].vertical)};
      padding-left: ${getSpace(DROPDOWN_PADDING_SIZES[size].horizontal)};
      padding-right: ${getSpace(DROPDOWN_PADDING_SIZES[size].horizontal)};
      padding-top: ${getSpace(DROPDOWN_PADDING_SIZES[size].vertical)};

      // Colors.
      background-color: ${color.background};
      border: 2px solid ${color.border};
      color: ${color.foreground};

      svg {
        color: ${color.foregroundAlt};
        max-height: 16px;
      }

      .closed,
      .opened {
        transition: 0.175s;
      }

      .opened {
        transform: rotate(180deg);
      }

      // Other.
      cursor: pointer;
      transition: 0.3s;

      /* Status: Disabled. */
      &:disabled {
        background-color: ${disabled.background};
        border: 2px solid ${disabled.border};
        color: ${disabled.foreground};
        cursor: not-allowed;

        svg {
          color: ${disabled.foregroundAlt};
        }
      }

      /* Status: Focus. */
      &:focus {
        background-color: ${focus.background};
        border: 2px solid ${focus.border};
        color: ${focus.foreground};

        svg {
          color: ${focus.foregroundAlt};
        }
      }

      /* Status: Hover. */
      &:hover {
        background-color: ${hover.background};
        border: 2px solid ${hover.border};
        color: ${hover.foreground};

        svg {
          color: ${hover.foregroundAlt};
        }
      }
    `;
}}
`;
const DropdownButtonLabel = styled_components_browser_esm/* default.div */.ZP.div `
  // Display & Box model.
  align-items: center;
  display: flex;
  gap: ${getSpace('s')};
  margin-right: ${({ iconOnly }) => (iconOnly ? 0 : getSpace('m'))};
`;
const DropdownOptionAsButton = styled_components_browser_esm/* default.button */.ZP.button `
  ${({ schema, theme }) => {
    const { default: color } = getSchemaVariant({
        mode: 'light',
        schema,
        theme,
        variant: 'bare'
    });
    return styled_components_browser_esm/* css */.iv `
      // Box model.
      align-items: center;
      border: none;
      display: flex;

      // Colors.
      background-color: ${color.background};
      color: ${color.foreground};

      svg {
        color: ${color.foreground};
      }

      // Space.
      cursor: pointer;
      gap: ${getSpace('m')};
      padding: ${getSpace('xl')};

      &:hover {
        background-color: ${(tokens_default()).colors.active[100].value};
      }

      > span {
        display: inline-block;
      }
    `;
}}
`;
const DropdownOptionAsLink = styled_components_browser_esm/* default.a */.ZP.a `
  ${({ schema, theme }) => {
    const { default: color } = getSchemaVariant({
        mode: 'light',
        schema,
        theme,
        variant: 'bare'
    });
    return styled_components_browser_esm/* css */.iv `
      // Display & Box model.
      align-items: center;
      border: none;
      display: flex;
      gap: ${getSpace('m')};
      padding: ${getSpace('xl')};

      // Colors.
      background-color: transparent;
      color: ${color.foreground};

      // Other.
      cursor: pointer;
      text-decoration: none;

      svg {
        color: ${color.foreground};
      }

      &:hover {
        background-color: ${(tokens_default()).colors.active[100].value};
        color: ${(tokens_default()).colors.navy[800].value};
      }

      &:visited,
      &:active,
      &:focus {
        color: inherit;
      }

      > span {
        display: inline-block;
      }
    `;
}}
`;
const DropdownOptionSpin = styled_components_browser_esm/* default.div */.ZP.div `
  // Display & Box.
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1px 0;
  width: 100%;
`;
const DropdownOptionLinkSpin = styled_components_browser_esm/* default.div */.ZP.div `
  // Display & Box.
  align-items: center;
  display: flex;
  gap: ${getSpace('m')};
  padding: ${getSpace('xl')};

  // Other.
  cursor: pointer;

  &:hover {
    background-color: ${(tokens_default()).colors.active[100].value};
    color: ${(tokens_default()).colors.navy[800].value};
  }
`;
const DropdownOptionsWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ position, size, theme }) => {
    return styled_components_browser_esm/* css */.iv `
      // Positioning.
      position: absolute;
      // top: 64px;
      top: ${size === 's' ? '64px' : '54px'};
      z-index: 10;

      ${position === 'left' && 'left: 0;'}
      ${position === 'right' && 'right: 0;'}

      // Display & Box model.
      border-radius: ${shape_utils_getRadius(theme, 'm')};
      display: flex;
      flex-direction: column;
      max-height: 300px;
      overflow: auto;
      padding: ${getSpace('s')};
      white-space: nowrap;
      width: fit-content;

      // Color.
      background-color: ${(tokens_default()).colors.white[100].value};
      border: 2px solid ${(tokens_default()).colors.midnight[200].value};
    `;
}}
`;
const DropdownRoot = styled_components_browser_esm/* default.div */.ZP.div `
  // Positioning.
  position: relative;
  width: fit-content;

  // Display & Box model.
  display: flex;
  flex-direction: column;
  gap: ${getSpace('2xs')};
`;
//# sourceMappingURL=Dropdown.styles.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Dropdown/Dropdown.js









// Component.
// -----------------------------------------------------------------------------
const Dropdown = (0,react.forwardRef)(({ icon, label, mode = Dropdown_constants_DEFAULT_MODE, options, position = DEFAULT_POSITION, schema = DEFAULT_SCHEMA, size = Dropdown_constants_DEFAULT_SIZE, variant = DEFAULT_VARIANT }, ref) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const refOptions = (0,react.useRef)(null);
    const { clickedOption, hasIcons, isOpen, isWaiting, onClickCTA, onClickOptionButton, onClickOptionLink } = useDropdown({
        options,
        refOptions
    });
    // Guard condition.
    // ---------------------------------------------------------------------------
    if ((0,lodash.isEmpty)(options)) {
        return null;
    }
    // Render.
    // ---------------------------------------------------------------------------
    return ((0,jsx_runtime.jsxs)(DropdownRoot, { ref: ref, children: [(0,jsx_runtime.jsxs)(DropdownButton, { mode: mode, onClick: (e) => {
                    e.stopPropagation();
                    onClickCTA();
                }, schema: schema, size: size, variant: variant, children: [(0,jsx_runtime.jsxs)(DropdownButtonLabel, { iconOnly: !!icon && !label, children: [icon && (0,jsx_runtime.jsx)(Icon_Icon, { icon: icon, size: DROPDOWN_ICON_SIZES[size] }), label && ((0,jsx_runtime.jsx)(Text_Text, { bold: true, size: size, uppercase: true, children: label }))] }), label && ((0,jsx_runtime.jsx)(Icon_Icon, { className: isOpen ? 'opened' : 'close', icon: pro_solid_svg_icons/* faCaretDown */.eW2, size: "m" }))] }), isOpen && ((0,jsx_runtime.jsx)(DropdownOptionsWrapper, { position: position, ref: refOptions, size: size, children: options.map((option, index) => {
                    return ((0,jsx_runtime.jsx)(react.Fragment, { children: option.asLink ? ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: isWaiting && (0,lodash.isEqual)(option, clickedOption) ? ((0,jsx_runtime.jsxs)(DropdownOptionLinkSpin, { children: [hasIcons && ((0,jsx_runtime.jsx)(Icon_Icon, { icon: option.icon })), (0,jsx_runtime.jsx)(Text_Text, { size: size, children: option.label })] })) : ((0,jsx_runtime.jsxs)(DropdownOptionAsLink, { href: option.href, ...(option.callback && {
                                    onClick: async (event) => {
                                        await onClickOptionLink(option, event);
                                    }
                                }), schema: option.schema ?? DROPDOWN_OPTION_SCHEMA, ...(option.target && { target: option.target }), children: [hasIcons && ((0,jsx_runtime.jsx)(Icon_Icon, { icon: option.icon })), (0,jsx_runtime.jsx)(Text_Text, { size: size, children: option.label })] })) })) : ((0,jsx_runtime.jsx)(DropdownOptionAsButton, { onClick: async () => {
                                await onClickOptionButton(option);
                            }, schema: option.schema ?? DROPDOWN_OPTION_SCHEMA, children: isWaiting && (0,lodash.isEqual)(option, clickedOption) ? (hasIcons ? ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)(Icon_Icon, { spin: true, icon: pro_solid_svg_icons/* faSpinnerThird */.AX7 }), (0,jsx_runtime.jsx)(Text_Text, { size: size, children: option.label })] })) : ((0,jsx_runtime.jsx)(DropdownOptionSpin, { children: (0,jsx_runtime.jsx)(Icon_Icon, { spin: true, icon: pro_solid_svg_icons/* faSpinnerThird */.AX7 }) }))) : ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [hasIcons && ((0,jsx_runtime.jsx)(Icon_Icon, { icon: option.icon })), (0,jsx_runtime.jsx)(Text_Text, { size: size, children: option.label })] })) })) }, index));
                }) }))] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Dropdown.displayName = 'Dropdown';
/* harmony default export */ var Dropdown_Dropdown = (Dropdown);
//# sourceMappingURL=Dropdown.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Fieldset/Fieldset.constants.js
const FIELDSET_BODY_PADDING_SIZES = {
    box: {
        horizontal: '2xl',
        vertical: '2xl'
    },
    underline: {
        vertical: 'xl'
    }
};
//# sourceMappingURL=Fieldset.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Fieldset/Fieldset.styled.js





// styled-components.
// -----------------------------------------------------------------------------
const FieldsetRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ variant }) => {
    return styled_components_browser_esm/* css */.iv `
      /* Fixed
      ----------- */
      margin: 0 0 ${getSpace('xl')} 0;

      fieldset {
        border: 0;
        margin: 0;
        padding: 0;
      }

      /* Variants
      ----------- */
      ${variant === 'box' &&
        styled_components_browser_esm/* css */.iv `
        background-color: ${getWhiteColor()};
        border: 1px solid ${(tokens_default()).colors.midnight[200].value};
        border-radius: ${(tokens_default()).radius.m};
      `}

      ${variant === 'underline' &&
        styled_components_browser_esm/* css */.iv `
        border: 0;
      `}
    `;
}}
`;
const FieldsetLegend = styled_components_browser_esm/* default.legend */.ZP.legend `
  ${({ theme, variant }) => {
    return styled_components_browser_esm/* css */.iv `
      /* Fixed
      ----------- */
      border-top-left-radius: ${(tokens_default()).radius.m};
      border-top-right-radius: ${(tokens_default()).radius.m};
      box-sizing: border-box;
      color: ${theme.palette.text.subtle};
      display: flex;
      align-items: center;
      margin: 0;
      width: 100%;
      gap: 1rem;

      /* Variants
      ----------- */
      ${variant === 'box' &&
        styled_components_browser_esm/* css */.iv `
        background-color: ${(tokens_default()).colors.midnight[100].value};
        border-bottom: 1px solid ${(tokens_default()).colors.midnight[200].value};

        padding-bottom: ${getSpace('l')};
        padding-left: ${getSpace('2xl')};
        padding-top: ${getSpace('l')};
        padding-right: ${getSpace('2xl')};
      `}

      ${variant === 'underline' &&
        styled_components_browser_esm/* css */.iv `
        border-bottom: 1px solid ${(tokens_default()).colors.midnight[200].value};
        padding: 0 0 ${getSpace('m')} 0;
      `}
    `;
}}
`;
const FieldsetLegendText = styled_components_browser_esm/* default.span */.ZP.span `
  flex: 1 1 auto;
`;
const FieldsetLegendActionsSlot = styled_components_browser_esm/* default.span */.ZP.span `
  flex: 0 1 auto;
`;
const FieldsetBody = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ variant }) => {
    const verticalPadding = getSpace(FIELDSET_BODY_PADDING_SIZES[variant].vertical);
    const horizontalPadding = getSpace(FIELDSET_BODY_PADDING_SIZES[variant].horizontal);
    return styled_components_browser_esm/* css */.iv `
      padding-bottom: ${verticalPadding};
      padding-right: ${horizontalPadding};
      padding-top: ${verticalPadding};
      padding-left: ${horizontalPadding};
      position: relative;
    `;
}}
`;
const LockedOverlay = styled_components_browser_esm/* default.div */.ZP.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.05);
  background: linear-gradient(
    0,
    rgba(2, 0, 36, 0.1) 0%,
    rgba(2, 0, 36, 0.05) 50%,
    rgba(2, 0, 36, 0.025) 100%
  );
  border-radius: 0 0 ${(tokens_default()).radius.m} ${(tokens_default()).radius.m};
  cursor: not-allowed;
`;
//# sourceMappingURL=Fieldset.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Fieldset/Fieldset.js





// Component.
// -----------------------------------------------------------------------------
const Fieldset = (0,react.forwardRef)(({ children, legend, legendActionsSlot, preLegendSlot, variant = 'box', className = '', isLocked = false, ...rest }, ref) => ((0,jsx_runtime.jsx)(FieldsetRoot, { variant: variant, className: `fieldset-wrapper ${className}`, children: (0,jsx_runtime.jsxs)("fieldset", { ref: ref, ...rest, children: [legend && ((0,jsx_runtime.jsxs)(FieldsetLegend, { variant: variant, children: [preLegendSlot && ((0,jsx_runtime.jsx)(FieldsetLegendActionsSlot, { children: preLegendSlot })), (0,jsx_runtime.jsx)(FieldsetLegendText, { children: (0,jsx_runtime.jsx)(Text_Text, { size: "m", bold: true, uppercase: true, isTitle: true, children: (0,jsx_runtime.jsxs)(Stack_Stack, { alignment: "center", gap: "s", children: [isLocked && (0,jsx_runtime.jsx)(Icon_Icon, { icon: pro_duotone_svg_icons/* faLock */.byT }), legend] }) }) }), legendActionsSlot && ((0,jsx_runtime.jsx)(FieldsetLegendActionsSlot, { children: legendActionsSlot }))] })), (0,jsx_runtime.jsxs)(FieldsetBody, { variant: variant, children: [isLocked && (0,jsx_runtime.jsx)(LockedOverlay, {}), children] })] }) })));
// Component configuration.
// -----------------------------------------------------------------------------
Fieldset.displayName = 'Fieldset';
/* harmony default export */ var Fieldset_Fieldset = (Fieldset);
//# sourceMappingURL=Fieldset.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Flag/Flag.constants.js


// Constants.
// -----------------------------------------------------------------------------
// Default values.
const FLAG_DEFAULT_SIZE = 'm';
// Each of the different flags that can be rendered.
const FLAG_TYPES = (/* unused pure expression or super */ null && ([
    'award',
    'certification',
    'course',
    'degree',
    'job-position',
    'launch',
    'milestone',
    'open-source',
    'other',
    'podcast',
    'publication',
    'reading',
    'self-training',
    'side-project',
    'talk',
    'video-bookmark',
    'video-highlight',
    'website'
]));
// Mappings
const FLAG_PADDING_SIZES = {
    m: {
        horizontal: 'm',
        vertical: 's'
    },
    s: {
        horizontal: 's',
        vertical: 'xs'
    }
};
const FLAG_VARIANT_BACKGROUND_COLOR = {
    award: (tokens_default()).colorbrewer.qualitative.set1[7].value,
    certification: (tokens_default()).colorbrewer.qualitative.set3[1].value,
    course: (tokens_default()).colorbrewer.qualitative.set3[10].value,
    degree: (tokens_default()).colorbrewer.qualitative.set3[6].value,
    'job-position': (tokens_default()).colorbrewer.qualitative.set1[9].value,
    launch: (tokens_default()).colorbrewer.qualitative.dark2[3].value,
    milestone: (tokens_default()).colorbrewer.qualitative.set1[2].value,
    'open-source': (tokens_default()).colorbrewer.qualitative.set2[4].value,
    other: (tokens_default()).colorbrewer.qualitative.pastel1[5].value,
    podcast: (tokens_default()).colorbrewer.qualitative.pastel1[3].value,
    publication: (tokens_default()).colorbrewer.qualitative.set1[3].value,
    reading: (tokens_default()).colorbrewer.qualitative.pastel1[2].value,
    'self-training': (tokens_default()).colorbrewer.qualitative.set3[5].value,
    'side-project': (tokens_default()).colorbrewer.qualitative.set1[5].value,
    talk: (tokens_default()).colorbrewer.qualitative.set1[5].value,
    'video-bookmark': (tokens_default()).colorbrewer.qualitative.pastel1[4].value,
    'video-highlight': (tokens_default()).colorbrewer.qualitative.set1[4].value,
    website: (tokens_default()).colorbrewer.qualitative.pastel1[6].value
};
const FLAG_VARIANT_COLOR = {
    award: (tokens_default()).colors.white[100].value,
    certification: (tokens_default()).colors.white[100].value,
    course: (tokens_default()).colors.white[100].value,
    degree: (tokens_default()).colors.white[100].value,
    'job-position': (tokens_default()).colors.white[100].value,
    launch: (tokens_default()).colors.white[100].value,
    milestone: (tokens_default()).colors.white[100].value,
    'open-source': (tokens_default()).colors.white[100].value,
    other: (tokens_default()).colors.midnight[800].value,
    podcast: (tokens_default()).colors.midnight[800].value,
    publication: (tokens_default()).colors.white[100].value,
    reading: (tokens_default()).colors.midnight[800].value,
    'self-training': (tokens_default()).colors.white[100].value,
    'side-project': (tokens_default()).colors.white[100].value,
    talk: (tokens_default()).colors.white[100].value,
    'video-bookmark': (tokens_default()).colors.midnight[800].value,
    'video-highlight': (tokens_default()).colors.white[100].value,
    website: (tokens_default()).colors.midnight[800].value
};
const FLAG_VARIANT_ICON = {
    award: pro_solid_svg_icons/* faMedal */._su,
    certification: pro_solid_svg_icons/* faFileCertificate */.CGe,
    course: pro_solid_svg_icons/* faDiploma */.ZJ7,
    degree: pro_solid_svg_icons/* faGraduationCap */.Xf_,
    'job-position': pro_solid_svg_icons/* faSuitcase */.qbi,
    launch: pro_solid_svg_icons/* faRocket */.tMT,
    milestone: pro_solid_svg_icons/* faBadgeCheck */.fix,
    'open-source': pro_solid_svg_icons/* faFileCode */.w49,
    other: pro_solid_svg_icons/* faBoxHeart */.mMr,
    podcast: pro_solid_svg_icons/* faPodcast */.tb9,
    publication: pro_solid_svg_icons/* faNewspaper */.Xgz,
    reading: pro_solid_svg_icons/* faBook */.FL8,
    'self-training': pro_solid_svg_icons/* faHeadSideHeadphones */.cAo,
    'side-project': pro_solid_svg_icons/* faBookSparkles */.pw6,
    talk: pro_solid_svg_icons/* faKeynote */.XH,
    'video-bookmark': pro_solid_svg_icons/* faFilmSimple */.uzA,
    'video-highlight': pro_solid_svg_icons/* faFilmSimple */.uzA,
    website: pro_solid_svg_icons/* faBrowser */.m6E
};
const FLAG_VARIANT_LABEL = {
    award: 'award',
    certification: 'certification',
    course: 'course',
    degree: 'degree',
    'job-position': 'job position',
    launch: 'launch',
    milestone: 'milestone',
    'open-source': 'open source',
    other: 'other',
    podcast: 'podcast',
    publication: 'publication',
    reading: 'reading',
    'self-training': 'self training',
    'side-project': 'side project',
    talk: 'talk',
    'video-bookmark': 'video',
    'video-highlight': 'video',
    website: 'website'
};
//# sourceMappingURL=Flag.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Flag/Flag.styled.js




// styled-components.
// -----------------------------------------------------------------------------
const FlagRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ size, variant }) => {
    const verticalPadding = getSpace(FLAG_PADDING_SIZES[size].vertical);
    const horizontalPadding = getSpace(FLAG_PADDING_SIZES[size].horizontal);
    return styled_components_browser_esm/* css */.iv `
      /* Fixed rules */
      align-items: center;
      clip-path: polygon(
        0px 0px,
        100% 0px,
        calc(100% - 0.5rem) 50%,
        100% 100%,
        0px 100%
      );
      display: inline-flex;
      gap: ${getSpace('s')};

      /* Color */
      background-color: ${FLAG_VARIANT_BACKGROUND_COLOR[variant]};
      border-left: 4px solid ${(tokens_default()).colors.midnight[800].value};
      color: ${FLAG_VARIANT_COLOR[variant]};

      /* Paddings */
      padding-bottom: ${verticalPadding};
      padding-left: ${horizontalPadding};
      padding-top: ${verticalPadding};
      padding-right: ${horizontalPadding};

      .flag__text {
        text-transform: uppercase;
        padding-right: ${horizontalPadding};
      }
    `;
}}
`;
//# sourceMappingURL=Flag.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Flag/Flag.js





// Component
// -----------------------------------------------------------------------------
const Flag = (0,react.forwardRef)(({ label, size = FLAG_DEFAULT_SIZE, variant, icon }, ref) => {
    return ((0,jsx_runtime.jsxs)(FlagRoot, { ref: ref, size: size, variant: variant, children: [size === 'm' && !icon && (0,jsx_runtime.jsx)(Icon_Icon, { icon: FLAG_VARIANT_ICON[variant] }), size === 'm' && !!icon && (0,jsx_runtime.jsx)(Icon_Icon, { icon: icon }), (0,jsx_runtime.jsx)(Text_Text, { className: "flag__text", size: "xs", bold: true, children: label || FLAG_VARIANT_LABEL[variant] })] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Flag.displayName = 'Flag';
/* harmony default export */ var Flag_Flag = (Flag);
//# sourceMappingURL=Flag.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/IconButton/IconButton.constants.js
// Sizes.
// -----------------------------------------------------------------------------
// Valores por defecto.
const ICONBUTTON_DEFAULT_DISABLED = false;
const ICONBUTTON_DEFAULT_MODE = 'light';
const ICONBUTTON_DEFAULT_SCHEME = 'neutral';
const ICONBUTTON_DEFAULT_SIZE = 's';
const ICONBUTTON_DEFAULT_VARIANT = 'hard';
// Mapping
const ICONBUTTON_ICON_SIZES = {
    s: 'xl',
    xs: 'l',
    '2xs': 'l'
};
const ICONBUTTON_PADDING_SIZES = {
    s: {
        horizontal: 'l',
        vertical: 'l'
    },
    xs: {
        horizontal: 'm',
        vertical: 'm'
    },
    '2xs': {
        horizontal: 's',
        vertical: 'xs'
    }
};
//# sourceMappingURL=IconButton.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/IconButton/IconButton.styled.js





// styled-components.
// -----------------------------------------------------------------------------
const IconButtonRoot = styled_components_browser_esm/* default.button */.ZP.button `
  ${({ mode, schema, size, theme, variant, isRound }) => {
    const { default: defaultColor, disabled: disabledColor, focus: focusColor, hover: focusHover, pressed: pressedHover } = getSchemaVariant({ mode, schema, theme, variant });
    return styled_components_browser_esm/* css */.iv `
      /* Box model */
      align-items: center;
      display: inline-flex;
      gap: ${getSpace('s')};
      justify-content: center;

      /* Colors */
      background-color: ${defaultColor.background};
      border: 2px solid ${defaultColor.border};
      color: ${defaultColor.foreground};

      svg {
        height: 18px;
        color: ${defaultColor.foregroundAlt};
      }

      /* Radius */
      border-radius: ${isRound ? `100%` : shape_utils_getRadius(theme, 'm')};

      /* Spacing */
      padding-bottom: ${getSpace(ICONBUTTON_PADDING_SIZES[size].vertical)};
      padding-left: ${getSpace(ICONBUTTON_PADDING_SIZES[size].horizontal)};
      padding-right: ${getSpace(ICONBUTTON_PADDING_SIZES[size].horizontal)};
      padding-top: ${getSpace(ICONBUTTON_PADDING_SIZES[size].vertical)};

      /* Misc */
      cursor: pointer;

      /* Status: Disabled. */
      &:disabled {
        background-color: ${disabledColor.background};
        border: 2px solid ${disabledColor.border};
        color: ${disabledColor.foreground};

        svg {
          color: ${disabledColor.foregroundAlt};
        }
      }

      /* Status: Focus. */
      &:focus {
        background-color: ${focusColor.background};
        border: 2px solid ${focusColor.border};
        color: ${focusColor.foreground};

        svg {
          color: ${focusColor.foregroundAlt};
        }
      }

      /* Status: Hover. */
      &:hover {
        background-color: ${focusHover.background};
        border: 2px solid ${focusHover.border};
        color: ${focusHover.foreground};

        svg {
          color: ${focusHover.foregroundAlt};
        }
      }

      /* Status: Pressed. */
      &:active {
        background-color: ${pressedHover.background};
        border: 2px solid ${pressedHover.border};
        color: ${pressedHover.foreground};

        svg {
          color: ${pressedHover.foregroundAlt};
        }
      }
    `;
}}
`;
//# sourceMappingURL=IconButton.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/IconButton/IconButton.js






// Component.
// -----------------------------------------------------------------------------
const IconButton = (0,react.forwardRef)(({ disabled = ICONBUTTON_DEFAULT_DISABLED, icon, mode = ICONBUTTON_DEFAULT_MODE, schema = ICONBUTTON_DEFAULT_SCHEME, size = ICONBUTTON_DEFAULT_SIZE, variant = ICONBUTTON_DEFAULT_VARIANT, isLoading, isRound = false, ...rest }, ref) => ((0,jsx_runtime.jsx)(IconButtonRoot, { disabled: disabled, mode: mode, ref: ref, schema: schema, size: size, variant: variant, isRound: isRound, ...rest, children: (0,jsx_runtime.jsx)(Icon_Icon, { icon: isLoading ? pro_duotone_svg_icons/* faSpinnerThird */.AX7 : icon, spin: isLoading, size: ICONBUTTON_ICON_SIZES[size], title: rest.title || rest['aria-label'] }) })));
// Component configuration.
// -----------------------------------------------------------------------------
IconButton.displayName = 'IconButton';
/* harmony default export */ var IconButton_IconButton = (IconButton);
//# sourceMappingURL=IconButton.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/IconLink/IconLink.constants.js

// Constants.
// -----------------------------------------------------------------------------
const ICON_LINK_DEFAULT_MODE = 'light';
const ICON_LINK_DEFAULT_SCHEMA = 'brand2';
const ICON_LINK_DEFAULT_SIZE = 's';
const ICON_LINK_DEFAULT_VARIANT = 'bare';
const ICON_LINK_ICON_SIZES = ICONBUTTON_ICON_SIZES;
const ICON_LINK_PADDING_SIZES = ICONBUTTON_PADDING_SIZES;
//# sourceMappingURL=IconLink.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/IconLink/IconLink.styled.js





// styled-components.
// -----------------------------------------------------------------------------
const IconLinkRoot = styled_components_browser_esm/* default.a */.ZP.a `
  ${({ mode, schema, size, theme, variant }) => {
    const { default: defaultColor, disabled: disabledColor, focus: focusColor, hover: focusHover, pressed: pressedHover } = getSchemaVariant({
        mode,
        schema,
        theme,
        variant
    });
    return styled_components_browser_esm/* css */.iv `
      cursor: pointer;

      /* Box model */
      align-items: center;
      display: inline-flex;
      gap: ${getSpace('s')};
      justify-content: center;
      line-height: 1;

      /* Colors */
      background-color: ${defaultColor.background};
      border: 2px solid ${defaultColor.border};
      color: ${defaultColor.foreground};

      svg {
        color: ${defaultColor.foregroundAlt};
      }

      /* Radius */
      border-radius: ${shape_utils_getRadius(theme, 'm')};

      /* Misc */
      transition: 0.3s;
      cursor: pointer;
      text-decoration: none;

      /* Spacing */
      padding-bottom: ${getSpace(ICON_LINK_PADDING_SIZES[size].vertical)};
      padding-left: ${getSpace(ICON_LINK_PADDING_SIZES[size].horizontal)};
      padding-right: ${getSpace(ICON_LINK_PADDING_SIZES[size].horizontal)};
      padding-top: ${getSpace(ICON_LINK_PADDING_SIZES[size].vertical)};

      /* Status: Disabled. */
      &:disabled {
        background-color: ${disabledColor.background};
        border: 2px solid ${disabledColor.border};
        color: ${disabledColor.foreground};
        cursor: not-allowed;

        svg {
          color: ${disabledColor.foregroundAlt};
        }
      }

      /* Status: Focus. */
      &:focus {
        background-color: ${focusColor.background};
        border: 2px solid ${focusColor.border};
        color: ${focusColor.foreground};

        svg {
          color: ${focusColor.foregroundAlt};
        }
      }

      /* Status: Hover. */
      &:hover {
        background-color: ${focusHover.background};
        border: 2px solid ${focusHover.border};
        color: ${focusHover.foreground};

        svg {
          color: ${focusHover.foregroundAlt};
        }
      }

      /* Status: Pressed. */
      &:active {
        background-color: ${pressedHover.background};
        border: 2px solid ${pressedHover.border};
        color: ${pressedHover.foreground};

        svg {
          color: ${pressedHover.foregroundAlt};
        }
      }
    `;
}}
`;
//# sourceMappingURL=IconLink.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/IconLink/IconLink.js





// Component.
// -----------------------------------------------------------------------------
const IconLink = (0,react.forwardRef)(({ href, icon, mode = ICON_LINK_DEFAULT_MODE, schema = ICON_LINK_DEFAULT_SCHEMA, size = ICON_LINK_DEFAULT_SIZE, variant = ICON_LINK_DEFAULT_VARIANT, ...rest }, ref) => {
    return ((0,jsx_runtime.jsx)(IconLinkRoot, { href: href, mode: mode, ref: ref, schema: schema, size: size, variant: variant, title: rest.title || rest['aria-label'], ...rest, children: (0,jsx_runtime.jsx)(Icon_Icon, { icon: icon, size: ICON_LINK_ICON_SIZES[size], title: rest.title || rest['aria-label'] }) }));
});
// Component configuration.
// -----------------------------------------------------------------------------
IconLink.displayName = 'IconLink';
/* harmony default export */ var IconLink_IconLink = ((/* unused pure expression or super */ null && (IconLink)));
//# sourceMappingURL=IconLink.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/FormGroup/FormGroup.constants.js

// Constantes.
// -----------------------------------------------------------------------------
const FORM_GROUP_DEFAULT_MODE = 'light';
const DEFAULT_LABEL_POSITION = 'stacked';
const DEFAULT_LABEL_SIZE = 's';
const FormGroup_constants_MAPPINGS_MODE = {
    dark: {
        background: (tokens_default()).colors.black[100].value,
        color: (tokens_default()).colors.midnight[200].value,
        details: (tokens_default()).colors.midnight[500].value
    },
    light: {
        background: (tokens_default()).colors.white[100].value,
        color: (tokens_default()).colors.midnight[800].value,
        details: (tokens_default()).colors.midnight[500].value
    }
};
//# sourceMappingURL=FormGroup.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/FormGroup/FormGroup.styled.js



// styled-components.
// -----------------------------------------------------------------------------
const FormGroupRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ mode, position, hasLabel }) => {
    const { color } = FormGroup_constants_MAPPINGS_MODE[mode];
    return styled_components_browser_esm/* css */.iv `
      /* Common. */
      background-color: transparent;
      color: ${color};
      display: grid;

      /* Box model. */
      grid-template-columns: ${position === 'stacked'
        ? 'auto'
        : 'minmax(auto, max-content) auto'};
      grid-template-rows: ${position === 'stacked' ? 'auto' : 'auto auto'};
      grid-gap: ${hasLabel ? `0 ${getSpace('s')}` : 0};

      .ui-fg-label {
        align-self: center;
        grid-row: 1/2;
        grid-column: 1/2;
      }

      .ui-fg-field {
        align-self: center;
        ${position === 'stacked'
        ? `
          grid-row: 2/3;
          grid-column: 1/2;
        `
        : `
          grid-row: 1/2;
          grid-column: 2/3;
        `}
      }

      .ui-fg-explain {
        ${position === 'stacked'
        ? `
          grid-row: 3/4;
          grid-column: 1/2;
        `
        : `
          grid-row: 2/3;
          grid-column: 2/3;
        `}
      }
    `;
}}
`;
//# sourceMappingURL=FormGroup.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/FormGroup/FormGroupExplain.hooks.js


// Custom Hook.
// -----------------------------------------------------------------------------
const useFormGroupExplian = (role) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { icon, cssClass } = (0,react.useMemo)(() => {
        if (!role) {
            return { icon: undefined, cssClass: undefined };
        }
        switch (role) {
            case 'error':
                return { icon: pro_solid_svg_icons/* faTimesCircle */.nYk, cssClass: 'fg-explain-error' };
            case 'info':
                return { icon: pro_solid_svg_icons/* faCircleQuestion */.FDd, cssClass: 'fg-explain-info' };
            case 'success':
                return { icon: pro_solid_svg_icons/* faCheckCircle */.f8k, cssClass: 'fg-explain-success' };
            case 'none':
                return {};
            default:
                // eslint-disable-next-line no-case-declarations
                const exhaustiveCheck = role;
                throw new Error(exhaustiveCheck);
        }
    }, [role]);
    // Return.
    // ---------------------------------------------------------------------------
    return { cssClass, icon };
};
//# sourceMappingURL=FormGroupExplain.hooks.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/FormGroup/FormGroupExplain.styled.js




// styled-components.
// -----------------------------------------------------------------------------
const FormGroupExplainRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ theme }) => {
    return styled_components_browser_esm/* css */.iv `
      /* Box */
      display: flex;
      gap: ${getSpace('xs')};
      align-items: flex-start;

      /** Font */
      font-family: ${theme.typography.fontFamily};
      font-size: ${getFontSize('s')};
      font-weight: ${getFontWeight('medium')};
      line-height: 1.25;

      .fg-explain-error {
        svg {
          color: ${(tokens_default()).colors.red[500].value};
        }
      }

      .fg-explain-info {
        svg {
          color: ${(tokens_default()).colors.blue[500].value};
        }
      }

      .fg-explain-success {
        svg {
          color: ${(tokens_default()).colors.green[500].value};
        }
      }
    `;
}}
`;
//# sourceMappingURL=FormGroupExplain.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/FormGroup/FormGroupExplain.js





// Component.
// -----------------------------------------------------------------------------
const FormGroupExplain = ({ children, role }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { cssClass, icon } = useFormGroupExplian(role);
    // Render.
    // ---------------------------------------------------------------------------
    return ((0,jsx_runtime.jsxs)(FormGroupExplainRoot, { role: "alert", children: [!(0,lodash.isEmpty)(icon) && (0,jsx_runtime.jsx)(Icon_Icon, { className: cssClass, icon: icon }), (0,jsx_runtime.jsx)("div", { children: children })] }));
};
//# sourceMappingURL=FormGroupExplain.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/FormGroup/FormGroupLabel.constants.js

// Constants.
// -----------------------------------------------------------------------------
const LABEL_SIZES_MAPPING = {
    inline: {
        s: {
            fontSize: getFontSize('s'),
            fontWeight: getFontWeight('extraBold')
        },
        xs: {
            fontSize: getFontSize('xs'),
            fontWeight: getFontWeight('extraBold')
        }
    },
    stacked: {
        s: {
            fontSize: getFontSize('s'),
            fontWeight: getFontWeight('extraBold')
        },
        xs: {
            fontSize: getFontSize('s'),
            fontWeight: getFontWeight('extraBold')
        }
    }
};
//# sourceMappingURL=FormGroupLabel.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/FormGroup/FormGroupLabel.styled.js






// styled-components.
// -----------------------------------------------------------------------------
const FormGroupLabelRoot = styled_components_browser_esm/* default.label */.ZP.label `
  ${({ position, size, theme }) => {
    const { fontSize, fontWeight } = LABEL_SIZES_MAPPING[position][size];
    return styled_components_browser_esm/* css */.iv `
      /* Fixed. */
      font-family: ${theme.typography.fontFamily};
      line-height: ${(tokens_default()).font.lineHeight.text.value};

      /* Variable. */
      font-size: ${fontSize};
      font-weight: ${fontWeight};
    `;
}}
`;
const FormGroupDetails = styled_components_browser_esm/* default.span */.ZP.span `
  ${({ mode }) => {
    const { details } = FormGroup_constants_MAPPINGS_MODE[mode];
    return styled_components_browser_esm/* css */.iv `
      color: ${details};
      display: inline-block;
      font-weight: ${getFontWeight('medium')};
      margin-left: ${getSpace('s')};
    `;
}}
`;
//# sourceMappingURL=FormGroupLabel.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/FormGroup/FormGroupLabel.js


// Component.
// -----------------------------------------------------------------------------
const FormGroupLabel = ({ children, details, mode, name, position, size }) => ((0,jsx_runtime.jsxs)(FormGroupLabelRoot, { htmlFor: name, position: position, size: size, children: [children, details && (0,jsx_runtime.jsx)(FormGroupDetails, { mode: mode, children: details })] }));
//# sourceMappingURL=FormGroupLabel.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/FormGroup/FormGroup.js





// High Order Component.
// -----------------------------------------------------------------------------
function withFormGroup(WrappedComponent) {
    return function withFormGroup(props) {
        const position = props.formGroup?.label?.position || DEFAULT_LABEL_POSITION;
        const explainRole = props.formGroup?.explain?.role
            ? props.formGroup?.explain.role
            : props.role
                ? props.role
                : 'none';
        return ((0,jsx_runtime.jsxs)(FormGroupRoot, { mode: props.mode ?? FORM_GROUP_DEFAULT_MODE, position: position, hasLabel: !!props.formGroup?.label?.content, children: [props.formGroup?.label && ((0,jsx_runtime.jsx)("div", { className: "ui-fg-label", children: (0,jsx_runtime.jsx)(FormGroupLabel, { details: props.formGroup.label.details, mode: props.mode ?? FORM_GROUP_DEFAULT_MODE, name: props.name, position: position, size: props.size ?? DEFAULT_LABEL_SIZE, children: props.formGroup.label.content }) })), (0,jsx_runtime.jsx)("div", { className: "ui-fg-field", children: (0,jsx_runtime.jsx)(WrappedComponent, { ...props }) }), props.formGroup?.explain && ((0,jsx_runtime.jsx)("div", { className: "ui-fg-explain", children: (0,jsx_runtime.jsx)(FormGroupExplain, { role: explainRole, children: props.formGroup.explain.content }) }))] }));
    };
}
//# sourceMappingURL=FormGroup.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseInput/BaseInput.constants.js



// Constants.
// -----------------------------------------------------------------------------
const BASE_INPUT_DEFAULT_DISABLE = false;
const BASE_INPUT_DEFAULT_MODE = 'light';
const BASE_INPUT_DEFAULT_SIZE = 's';
const BASE_INPUT_DEFAULT_ROLE = 'none';
const BASE_INPUT_DEFAULT_WIDTH = '100%';
/** Mode mappings */
const BaseInput_constants_MAPPINGS_MODE = {
    // Dark mode.
    dark: {
        background: (tokens_default()).colors.black[100].value,
        border: (tokens_default()).colors.midnight[700].value,
        placeholder: (tokens_default()).colors.midnight[700].value,
        text: (tokens_default()).colors.midnight[300].value,
        disabled: {
            background: (tokens_default()).colors.midnight[850].value,
            border: (tokens_default()).colors.midnight[800].value,
            text: (tokens_default()).colors.midnight[800].value
        },
        focus: {
            border: (tokens_default()).colors.midnight[850].value,
            shadow: `0 0 0 4px ${(tokens_default()).colors.midnight[150].value}`
        },
        hover: {
            border: (tokens_default()).colors.midnight[400].value
        },
        selection: {
            background: (tokens_default()).colors.navy[200].value,
            color: (tokens_default()).colors.navy[800].value
        }
    },
    // Light mode.
    light: {
        background: (tokens_default()).colors.white[100].value,
        border: (tokens_default()).colors.midnight[200].value,
        placeholder: (tokens_default()).colors.midnight[300].value,
        text: (tokens_default()).colors.midnight[800].value,
        disabled: {
            background: (tokens_default()).colors.midnight[150].value,
            border: (tokens_default()).colors.midnight[200].value,
            text: (tokens_default()).colors.midnight[800].value
        },
        focus: {
            border: (tokens_default()).colors.midnight[850].value,
            shadow: `0 0 0 4px ${(tokens_default()).colors.midnight[150].value}`
        },
        hover: {
            border: (tokens_default()).colors.midnight[400].value
        },
        selection: {
            background: (tokens_default()).colors.navy[200].value,
            color: (tokens_default()).colors.navy[800].value
        }
    }
};
/** Scale mappings. */
const BaseInput_constants_MAPPINGS_SCALE = {
    s: {
        fontSize: getFontSize('s'),
        fontWeight: getFontWeight('medium'),
        padding: getSpace('xl')
    },
    xs: {
        fontSize: getFontSize('s'),
        fontWeight: getFontWeight('medium'),
        padding: `${getSpace('s')} ${getSpace('m')}`
    }
};
//# sourceMappingURL=BaseInput.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/TextField/TextField.constants.js

// Constants.
// -----------------------------------------------------------------------------
/** Default disabled. */
const TEXT_FIELD_DEFAULT_DISABLED = BASE_INPUT_DEFAULT_DISABLE;
/** Default mode. */
const TEXT_FIELD_DEFAULT_MODE = BASE_INPUT_DEFAULT_MODE;
/** Default size. */
const TEXT_FIELD_DEFAULT_SIZE = BASE_INPUT_DEFAULT_SIZE;
/** Default type. */
const TEXT_FIELD_DEFAULT_TYPE = 'text';
/** Default role. */
const TEXT_FIELD_DEFAULT_ROLE = BASE_INPUT_DEFAULT_ROLE;
//# sourceMappingURL=TextField.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/InputNumber/InputNumber.constants.js
// Constants.
// -----------------------------------------------------------------------------
const DEFAULT_DISABLED = false;
const InputNumber_constants_DEFAULT_MODE = 'light';
const DEFAULT_INPUT_WIDTH = '100%';
const InputNumber_constants_DEFAULT_SIZE = 's';
//# sourceMappingURL=InputNumber.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/InputNumber/InputNumber.hooks.js

// Hooks.
// -----------------------------------------------------------------------------
const useInputNumber = ({ name }) => {
    // Handlers.
    // ---------------------------------------------------------------------------
    const handleDecrement = (0,react.useCallback)(() => {
        const node = document.getElementById(`input-number-${name}`);
        if (node) {
            node.stepDown();
            node.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }, [name]);
    const handlerIncrement = (0,react.useCallback)(() => {
        const node = document.getElementById(`input-number-${name}`);
        if (node) {
            node.stepUp();
            node.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }, [name]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        onDecrement: handleDecrement,
        onIncrement: handlerIncrement
    };
};
//# sourceMappingURL=InputNumber.hooks.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseInput/BaseInput.styled.js




// Styled-components.
// -----------------------------------------------------------------------------
const BaseInputRoot = ({ inputWidth = BASE_INPUT_DEFAULT_WIDTH, mode, scale, theme }) => {
    const { background, border, disabled, focus, hover, placeholder, selection, text } = BaseInput_constants_MAPPINGS_MODE[mode];
    const { fontSize, fontWeight, padding } = BaseInput_constants_MAPPINGS_SCALE[scale];
    return styled_components_browser_esm/* css */.iv `
    /* Common. */
    appearance: none;
    border-radius: ${getRadius('m')};
    box-sizing: border-box;
    font-family: ${theme.typography.fontFamily};
    line-height: 1;
    transition: 0.3s;
    width: ${inputWidth};

    /* Mode props */
    background-color: ${background};
    border: 2px solid ${border};
    color: ${text};

    /* Scale. */
    font-size: ${fontSize};
    font-weight: ${fontWeight};
    padding: ${padding};

    &::placeholder {
      color: ${placeholder};
    }

    &::selection {
      background-color: ${selection.background};
      color: ${selection.color};
    }

    &:disabled {
      background-color: ${disabled.background};
      border-color: ${disabled.border};
      color: ${disabled.text};
    }

    &:focus {
      outline: 0;
      border-color: ${focus.border};
      box-shadow: ${focus.shadow};
    }

    &:hover {
      border-color: ${hover.border};
    }

    &.error {
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0C3.58065 0 0 3.58065 0 8C0 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8C16 3.58065 12.4194 0 8 0ZM11.9226 10.1C12.0742 10.2516 12.0742 10.4968 11.9226 10.6484L10.6452 11.9226C10.4935 12.0742 10.2484 12.0742 10.0968 11.9226L8 9.80645L5.9 11.9226C5.74839 12.0742 5.50323 12.0742 5.35161 11.9226L4.07742 10.6452C3.92581 10.4935 3.92581 10.2484 4.07742 10.0968L6.19355 8L4.07742 5.9C3.92581 5.74839 3.92581 5.50323 4.07742 5.35161L5.35484 4.07419C5.50645 3.92258 5.75161 3.92258 5.90323 4.07419L8 6.19355L10.1 4.07742C10.2516 3.92581 10.4968 3.92581 10.6484 4.07742L11.9258 5.35484C12.0774 5.50645 12.0774 5.75161 11.9258 5.90323L9.80645 8L11.9226 10.1Z' fill='%23DE492B'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: right ${getSpace('l')} top 50%;
      border-color: ${(tokens_default()).colors.red[700].value};
    }

    &.success {
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 8C16 12.4183 12.4183 16 8 16C3.58171 16 0 12.4183 0 8C0 3.58171 3.58171 0 8 0C12.4183 0 16 3.58171 16 8ZM7.07464 12.2359L13.0101 6.30045C13.2117 6.0989 13.2117 5.7721 13.0101 5.57055L12.2802 4.84064C12.0787 4.63906 11.7519 4.63906 11.5503 4.84064L6.70968 9.68123L4.44971 7.42126C4.24816 7.21971 3.92135 7.21971 3.71977 7.42126L2.98987 8.15116C2.78832 8.35271 2.78832 8.67952 2.98987 8.88106L6.34471 12.2359C6.54629 12.4375 6.87306 12.4375 7.07464 12.2359Z' fill='%2378D549'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: right ${getSpace('l')} top 50%;
      padding-right: 3rem;
    }
  `;
};
//# sourceMappingURL=BaseInput.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/InputNumber/InputNumber.styles.js





// styled-components.
// -----------------------------------------------------------------------------
const InputNumberAdormentRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ position, type }) => styled_components_browser_esm/* css */.iv `
    /* Display & Box */
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    top: 0;
    width: 46px;
    color: ${(tokens_default()).colors.green[700].value};

    ${position === 'end' && `right: 30px;`}

    ${type === 'euro' && ` color: ${(tokens_default()).colors.green[700].value};`}
  `}
`;
const InputNumberButtons = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ mode, size }) => styled_components_browser_esm/* css */.iv `
    /* Display & Box Model */
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-evenly;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;

    > button {
      /* Display & Box Model */
      border: 2px solid ${BaseInput_constants_MAPPINGS_MODE[mode].border};
      border-bottom: 0;
      border-right: 0;
      border-radius: 0;
      border-top: 0;
      margin: 0;
      padding: ${size === 'xs' ? 0 : getSpace('xs')} ${getSpace('s')};
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50%;

      /* Color */
      appearance: none;
      background-color: transparent;

      /* Text */
      font: inherit;
      text-align: inherit;

      /* Miscellanea */
      cursor: pointer;
      transition: 0.3s;
    }

    > button:first-of-type {
      border-bottom: 1px solid ${BaseInput_constants_MAPPINGS_MODE[mode].border};

      &:hover,
      &:focus {
        border-radius: 0 10px 0 0;
      }

      svg {
        margin-bottom: -3px;
      }
    }

    > button:last-of-type {
      border-top: 1px solid ${BaseInput_constants_MAPPINGS_MODE[mode].border};

      &:hover,
      &:focus {
        border-radius: 0 0 10px 0;
      }
    }

    > button:hover,
    > button:focus {
      background-color: ${(tokens_default()).colors.midnight[850].value};
      color: ${(tokens_default()).colors.white[100].value};
    }

    &.error {
      > button {
        border-color: ${(tokens_default()).colors.red[700].value};
      }

      > button:first-of-type,
      > button:last-of-type {
        border-color: ${(tokens_default()).colors.red[700].value};
      }
    }
  `}
`;
const InputNumberRoot = styled_components_browser_esm/* default.input */.ZP.input `
  ${({ hasEndAdorment, hasStartAdorment }) => styled_components_browser_esm/* css */.iv `
    ${BaseInputRoot}

    /* Miscellanea */
    appearance: textfield;

    ::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }

    ${hasStartAdorment && `padding-left: 46px;`}
    ${hasEndAdorment && `padding-right: 46px;`}
  `}

  &.error {
    background: none;
  }
`;
const InputButtonWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ inputWidth, mode }) => styled_components_browser_esm/* css */.iv `
    /* Display & Box Model */
    position: relative;
    width: ${inputWidth};

    :hover {
      button {
        border-color: ${BaseInput_constants_MAPPINGS_MODE[mode].hover.border};
      }

      ${InputNumberRoot} {
        border-color: ${BaseInput_constants_MAPPINGS_MODE[mode].hover.border};

        &.error {
          border-color: ${(tokens_default()).colors.red[700].value};
        }
      }
    }

    :focus-within {
      button {
        border-color: ${BaseInput_constants_MAPPINGS_MODE[mode].focus.border};
      }

      ${InputNumberRoot} {
        border-color: ${BaseInput_constants_MAPPINGS_MODE[mode].focus.border};

        &.error {
          border-color: ${(tokens_default()).colors.red[700].value};
        }
      }
    }
  `}
`;
//# sourceMappingURL=InputNumber.styles.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/InputNumber/InputNumber.js









// Component.
// -----------------------------------------------------------------------------
const InputNumber = withFormGroup(({ disabled = DEFAULT_DISABLED, endAdorment, inputWidth = DEFAULT_INPUT_WIDTH, name, role = TEXT_FIELD_DEFAULT_ROLE, mode = InputNumber_constants_DEFAULT_MODE, size = InputNumber_constants_DEFAULT_SIZE, startAdorment, inputRef, ...rest }) => {
    // Hooks.
    // -------------------------------------------------------------------------
    const { onDecrement, onIncrement } = useInputNumber({ name });
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsxs)(InputButtonWrapper, { inputWidth: inputWidth, mode: mode, children: [(0,jsx_runtime.jsx)(InputNumberRoot, { ...(role && { className: role }), hasEndAdorment: !!endAdorment, hasStartAdorment: !!startAdorment, id: `input-number-${name}`, mode: mode, 
                // we are using 'scale' because input has its own 'size'.
                scale: size, type: "number", ref: inputRef, ...rest }), (0,jsx_runtime.jsxs)(InputNumberButtons, { mode: mode, size: size, ...(role && { className: role }), children: [(0,jsx_runtime.jsx)("button", { disabled: disabled, onClick: onIncrement, type: "button", children: (0,jsx_runtime.jsx)(Icon_Icon, { icon: pro_solid_svg_icons/* faCaretUp */.l1h, size: "s" }) }), (0,jsx_runtime.jsx)("button", { disabled: disabled, onClick: onDecrement, type: "button", children: (0,jsx_runtime.jsx)(Icon_Icon, { icon: pro_solid_svg_icons/* faCaretDown */.eW2, size: "s" }) })] }), startAdorment && ((0,jsx_runtime.jsxs)(InputNumberAdormentRoot, { position: "start", type: startAdorment, children: [startAdorment === 'euro' && (0,jsx_runtime.jsx)(Icon_Icon, { icon: pro_solid_svg_icons/* faEuroSign */.QU_, size: "m" }), endAdorment === 'percentage' && (0,jsx_runtime.jsx)(Icon_Icon, { icon: pro_solid_svg_icons/* faPercent */.jGC, size: "m" })] })), endAdorment && ((0,jsx_runtime.jsxs)(InputNumberAdormentRoot, { position: "end", type: endAdorment, children: [endAdorment === 'euro' && (0,jsx_runtime.jsx)(Icon_Icon, { icon: pro_solid_svg_icons/* faEuroSign */.QU_, size: "m" }), endAdorment === 'percentage' && (0,jsx_runtime.jsx)(Icon_Icon, { icon: pro_solid_svg_icons/* faPercent */.jGC, size: "m" })] }))] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
InputNumber.displayName = 'TextField';
const InputNumberWithFormGroup = react.forwardRef((props, ref) => {
    return (0,jsx_runtime.jsx)(InputNumber, { ...props, inputRef: ref });
});
InputNumberWithFormGroup.displayName = 'InputNumberWithFormGroup';
/* harmony default export */ var InputNumber_InputNumber = (InputNumberWithFormGroup);
//# sourceMappingURL=InputNumber.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Kanban/Kanban.constants.js
// Constantes.
// ----------------------------------------------------------------------
const Kanban_constants_DEFAULT_MODE = 'light';
const DEFAULT_COLUMN_SIZE = '275px';
//# sourceMappingURL=Kanban.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Kanban/Kanban.styled.js




// styled-components.
// -----------------------------------------------------------------------------
const KanbanRoot = styled_components_browser_esm/* default.div */.ZP.div `
  // Display and Box
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  grid-auto-rows: 1fr;
  grid-gap: ${getSpace('s')};

  // Spacing
  padding: ${getSpace('s')};

  // Other
  border-radius: ${getRadius('m')};
  min-height: 800px;
  overflow: auto;
`;
const KanbanCluster = styled_components_browser_esm/* default.div */.ZP.div `
  display: flex;
  flex-direction: column;
`;
const KanbanClusterTitle = styled_components_browser_esm/* default.div */.ZP.div `
  // Display and box
  align-items: center;
  display: flex;
  gap: ${getSpace('s')};

  // Spacing
  padding: 0 ${getSpace('s')};

  // Color
  ${({ theme, variant, mode }) => {
    const { background } = getSchemaState({
        variant: 'hard',
        schema: variant,
        state: 'default',
        theme,
        mode
    });
    return styled_components_browser_esm/* css */.iv `
      svg {
        color: ${background};
      }
    `;
}}
`;
const KanbanClusterContent = styled_components_browser_esm/* default.div */.ZP.div `
  // Display and box
  display: grid;
  flex: 1 1 auto;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  grid-auto-rows: 1fr;
  grid-gap: ${getSpace('s')};

  // Spacing
  padding: ${getSpace('s')};

  // Other
  border-radius: ${getRadius('m')};

  // Color
  ${({ theme, variant, mode }) => {
    const { background } = getSchemaState({
        variant: 'soft',
        schema: variant,
        state: 'default',
        theme,
        mode
    });
    return styled_components_browser_esm/* css */.iv `
      background-color: ${background};
    `;
}}
`;
const KanbanColumn = styled_components_browser_esm/* default.div */.ZP.div `
  display: flex;
  flex-direction: column;
`;
const KanbanColumnContent = styled_components_browser_esm/* default.div */.ZP.div `
  display: grid;
  grid-gap: ${getSpace('s')};
  flex: 1 1 auto;

  ${({ columnSize }) => {
    return styled_components_browser_esm/* css */.iv `
      grid-auto-columns: ${columnSize};
    `;
}}
`;
const KanbanTile = styled_components_browser_esm/* default.div */.ZP.div `
  background: #f4f5f7bd;
  border-radius: ${getRadius('m')};
`;
const KanbanTileTitle = styled_components_browser_esm/* default.div */.ZP.div `
  // Display and box
  align-items: center;
  display: flex;
  gap: ${getSpace('s')};

  // Spacing
  padding: ${getSpace('s')} ${getSpace('m')} 0 ${getSpace('m')};

  // Color
  color: #565656;

  svg {
    color: #999;
  }
`;
const KanbanTileContent = styled_components_browser_esm/* default.div */.ZP.div `
  // Display and box
  display: flex;
  gap: ${getSpace('s')};
  flex-direction: column;

  // Spacing
  padding: ${getSpace('s')};
`;
const KanbanCard = styled_components_browser_esm/* default.div */.ZP.div `
  // Spacing
  padding: ${getSpace('m')};

  // Color
  background: ${getWhiteColor()};

  // Other
  border: 1px solid #ddd;
  border-radius: ${getRadius('m')};

  ${({ theme, mode }) => {
    return styled_components_browser_esm/* css */.iv `
      box-shadow: ${getShadow({
        theme,
        mode,
        variant: 's'
    })};
    `;
}}
`;
//# sourceMappingURL=Kanban.styled.js.map
// EXTERNAL MODULE: ../../node_modules/react-tooltip-lite/dist/index.js
var dist = __webpack_require__(64457);
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tooltip/Tooltip.constants.js
const TOOLTIP_DEFAULT_TEXT_ALIGN = 'center';
const TOOLTIP_DEFAULT_DISTANCE = 12;
const TOOLTIP_DEFAULT_VISIBLE = false;
const TOOLTIP_TEXT_ALIGN_DICT = {
    left: 'tooltip__left',
    right: 'tooltip__right',
    center: 'tooltip__center'
};
//# sourceMappingURL=Tooltip.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tooltip/Tooltip.styled.js


// styled-components.
// -----------------------------------------------------------------------------
const TooltipGlobalStyles = styled_components_browser_esm/* createGlobalStyle */.vJ `
.react-tooltip-lite {
  box-sizing: border-box;
  background: ${(tokens_default()).colors.midnight[800].value};
  color: ${(tokens_default()).colors.white[100].value};
  border-radius: ${(tokens_default()).radius.m};
  font-size: ${(tokens_default()).font.size.s.value};
  line-height: 1.33;
  font-weight: ${(tokens_default()).font.weight.medium.value};
  max-width: 14rem !important;
  word-break: break-word;

  strong {
    font-weight: ${(tokens_default()).font.weight.black.value};
  }

  p {
    margin: 0;

    &:not(:first-child) {
      margin-top: 1em;
    }
  }

  a {
    color: ${(tokens_default()).colors.emerald[400].value};

    &:hover,
    &:active {
      color: ${(tokens_default()).colors.indigo[500].value};
    }
  }

  ul, ol {
    margin-left: 0;
    padding-left: 1rem;
  }
}

.react-tooltip-lite-arrow {
  border-color: ${(tokens_default()).colors.midnight[800].value};
  transform: scale(1.2);
}

.tooltip__left .react-tooltip-lite {
  text-align: left;
}

.tooltip__right .react-tooltip-lite {
  text-align: right;
}

.tooltip__center .react-tooltip-lite {
  text-align: center;
}
`;
//# sourceMappingURL=Tooltip.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tooltip/Tooltip.js




// Component.
// -----------------------------------------------------------------------------
const Tooltip = ({ content, direction, distance = TOOLTIP_DEFAULT_DISTANCE, textAlign = TOOLTIP_DEFAULT_TEXT_ALIGN, children, visible = TOOLTIP_DEFAULT_VISIBLE }) => {
    if (!content)
        return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: children });
    return ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)(TooltipGlobalStyles, {}), (0,jsx_runtime.jsx)(dist/* default */.Z, { content: content, className: textAlign
                    ? TOOLTIP_TEXT_ALIGN_DICT[textAlign]
                    : `tooltip_${TOOLTIP_DEFAULT_TEXT_ALIGN}`, eventOn: "onFocus", eventOff: "onBlur", padding: 12, arrowSize: 6, tipContentHover: true, direction: direction, distance: distance, tagName: "span", isOpen: visible || undefined, children: children ? children : (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) })] }));
};
/* harmony default export */ var Tooltip_Tooltip = (Tooltip);
//# sourceMappingURL=Tooltip.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Kanban/Kanban.js









// Component.
// -----------------------------------------------------------------------------
const Kanban = ({ content, mode = Kanban_constants_DEFAULT_MODE, columnSize = DEFAULT_COLUMN_SIZE, ...rest }) => {
    const renderTitle = (0,react.useCallback)((content, tooltip, label, icon) => {
        if ((label || icon) && tooltip) {
            return (0,jsx_runtime.jsx)(Tooltip_Tooltip, { content: tooltip, children: content });
        }
        return content;
    }, []);
    // Guard condition.
    // -------------------------------------------------------------------------
    if ((0,lodash.isEmpty)(content)) {
        return null;
    }
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(KanbanRoot, { ...rest, children: content.map((cluster, index) => ((0,jsx_runtime.jsxs)(KanbanCluster, { children: [(0,jsx_runtime.jsx)(KanbanClusterTitle, { variant: cluster.variant || 'neutral', mode: mode, children: renderTitle((0,jsx_runtime.jsxs)(Stack_Stack, { gap: "xs", alignment: "center", children: [cluster.icon && (0,jsx_runtime.jsx)(Icon_Icon, { icon: cluster.icon }), cluster.label && ((0,jsx_runtime.jsx)(Text_Text, { bold: true, size: "l", children: cluster.label }))] }), cluster.tooltip, cluster.label, cluster.icon) }), (0,jsx_runtime.jsx)(KanbanClusterContent, { variant: cluster.variant || 'neutral', mode: mode, children: cluster.columns.map((column, index) => ((0,jsx_runtime.jsx)(KanbanColumn, { children: (0,jsx_runtime.jsx)(KanbanColumnContent, { columnSize: columnSize, children: column.tiles.map((column, index) => ((0,jsx_runtime.jsxs)(KanbanTile, { children: [(0,jsx_runtime.jsx)(KanbanTileTitle, { children: renderTitle((0,jsx_runtime.jsxs)(Stack_Stack, { gap: "xs", alignment: "flex-start", children: [column.icon && (0,jsx_runtime.jsx)(Icon_Icon, { icon: column.icon }), column.label && (0,jsx_runtime.jsx)(Text_Text, { bold: true, children: column.label })] }), column.tooltip, column.label, column.icon) }), (0,jsx_runtime.jsx)(KanbanTileContent, { children: column.renderCards((content) => ((0,jsx_runtime.jsx)(KanbanCard, { mode: mode, children: content }))) })] }, index))) }) }, index))) })] }, index))) }));
};
// Component configuration.
// -----------------------------------------------------------------------------
Kanban.displayName = 'Kanban';
/* harmony default export */ var Kanban_Kanban = ((/* unused pure expression or super */ null && (Kanban)));
//# sourceMappingURL=Kanban.js.map
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Modal/Modal.constants.js

// Constants.
// -----------------------------------------------------------------------------
// Default values.
const MODAL_DEFAULT_BUTTON_CANCEL = {
    label: 'Cancelar',
    size: 's',
    startIcon: pro_solid_svg_icons/* faTimesCircle */.nYk,
    variant: 'ghost'
};
const MODAL_DEFAULT_BUTTON_SUCCESS = {
    label: 'Guardar',
    size: 's',
    startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k
};
const MODAL_DEFAULT_CLOSEABLE = true;
const MODAL_DEFAULT_BUTTONS_FULL_WIDTH = false;
const MODAL_DEFAULT_DISABLE_ESC_KEY = false;
const MODAL_DEFAULT_DISABLE_OUTSIDE_CLICK = false;
const MODAL_DEFAULT_IS_OPEN = false;
const MODAL_DEFAULT_SIZE = 'm';
const MODAL_PORTAL_DIV_ID = 'ui-library-portal-id';
const MODAL_PORTAL_DIV_CLASSNAME = 'ui-library-portal-classname';
// Labels
const MODAL_ACTION_BUTTON_CANCEL_ARIA_LABEL = 'action-cancel';
const MODAL_ACTION_BUTTON_SUCCESS_ARIA_LABEL = 'action-success';
const MODAL_TOP_BUTTON_ARIA_LABEL = 'cross-close';
// Styled-components.
const MODAL_SIZES_MAP = {
    '2xl': 1200,
    xl: 960,
    l: 736,
    m: 680,
    s: 480
};
//# sourceMappingURL=Modal.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Modal/Modal.hooks.js

// Custom hooks.
// -----------------------------------------------------------------------------
const useModal = ({ disableEscKey, disableOutsideClick, isOpen, onClose, ref, refModal }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    (0,react.useImperativeHandle)(ref, () => refModal.current);
    // Effect.
    // ---------------------------------------------------------------------------
    (0,react.useEffect)(() => {
        // Esc Key
        const handleOnEsc = (event) => {
            if (!disableEscKey && event.key === 'Escape') {
                event.preventDefault();
                handleOnClickCross();
            }
        };
        // Outside Click.
        const handleOutsideClick = (event) => {
            if (!disableOutsideClick) {
                const divModal = refModal.current;
                if (divModal && !divModal.contains(event.target)) {
                    event.preventDefault();
                    handleOnClickCross();
                }
            }
        };
        if (isOpen) {
            document.addEventListener('click', handleOutsideClick);
            document.addEventListener('keydown', handleOnEsc);
        }
        else {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('keydown', handleOnEsc);
        }
        return () => {
            document.removeEventListener('keydown', handleOnEsc);
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isOpen]);
    // Handlers.
    // ---------------------------------------------------------------------------
    const handleOnClickCross = (0,react.useCallback)(() => {
        onClose?.();
    }, [onClose]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        onClickCross: handleOnClickCross
    };
};
//# sourceMappingURL=Modal.hooks.js.map
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(88960);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && (0,setPrototypeOf/* default */.Z)(p, r.prototype), p;
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), (0,setPrototypeOf/* default */.Z)(Wrapper, t);
  }, _wrapNativeSuper(t);
}

;// CONCATENATED MODULE: ../../node_modules/polished/dist/polished.esm.js






function last() {
  var _ref;

  return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}

function negation(a) {
  return -a;
}

function addition(a, b) {
  return a + b;
}

function subtraction(a, b) {
  return a - b;
}

function multiplication(a, b) {
  return a * b;
}

function division(a, b) {
  return a / b;
}

function max() {
  return Math.max.apply(Math, arguments);
}

function min() {
  return Math.min.apply(Math, arguments);
}

function comma() {
  return Array.of.apply(Array, arguments);
}

var defaultSymbols = {
  symbols: {
    '*': {
      infix: {
        symbol: '*',
        f: multiplication,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '*',
      regSymbol: '\\*'
    },
    '/': {
      infix: {
        symbol: '/',
        f: division,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '/',
      regSymbol: '/'
    },
    '+': {
      infix: {
        symbol: '+',
        f: addition,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '+',
        f: last,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '+',
      regSymbol: '\\+'
    },
    '-': {
      infix: {
        symbol: '-',
        f: subtraction,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '-',
        f: negation,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '-',
      regSymbol: '-'
    },
    ',': {
      infix: {
        symbol: ',',
        f: comma,
        notation: 'infix',
        precedence: 1,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: ',',
      regSymbol: ','
    },
    '(': {
      prefix: {
        symbol: '(',
        f: last,
        notation: 'prefix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '(',
      regSymbol: '\\('
    },
    ')': {
      postfix: {
        symbol: ')',
        f: undefined,
        notation: 'postfix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: ')',
      regSymbol: '\\)'
    },
    min: {
      func: {
        symbol: 'min',
        f: min,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'min',
      regSymbol: 'min\\b'
    },
    max: {
      func: {
        symbol: 'max',
        f: max,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'max',
      regSymbol: 'max\\b'
    }
  }
};
var defaultSymbolMap = (/* unused pure expression or super */ null && (defaultSymbols));

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  (0,inheritsLoose/* default */.Z)(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (true) {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else { var _len2, args, _key2; }

    return _assertThisInitialized(_this);
  }

  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g; // Merges additional math functionality into the defaults.

function mergeSymbolMaps(additionalSymbols) {
  var symbolMap = {};
  symbolMap.symbols = additionalSymbols ? _extends({}, defaultSymbolMap.symbols, additionalSymbols.symbols) : _extends({}, defaultSymbolMap.symbols);
  return symbolMap;
}

function exec(operators, values) {
  var _ref;

  var op = operators.pop();
  values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
  return op.precedence;
}

function calculate(expression, additionalSymbols) {
  var symbolMap = mergeSymbolMaps(additionalSymbols);
  var match;
  var operators = [symbolMap.symbols['('].prefix];
  var values = [];
  var pattern = new RegExp( // Pattern for numbers
  "\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
  Object.keys(symbolMap.symbols).map(function (key) {
    return symbolMap.symbols[key];
  }) // longer symbols should be listed first
  // $FlowFixMe
  .sort(function (a, b) {
    return b.symbol.length - a.symbol.length;
  }) // $FlowFixMe
  .map(function (val) {
    return val.regSymbol;
  }).join('|') + "|(\\S)", 'g');
  pattern.lastIndex = 0; // Reset regular expression object

  var afterValue = false;

  do {
    match = pattern.exec(expression);

    var _ref2 = match || [')', undefined],
        token = _ref2[0],
        bad = _ref2[1];

    var notNumber = symbolMap.symbols[token];
    var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
    var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix; // Check for syntax errors:

    if (bad || (afterValue ? notAfterValue : notNewValue)) {
      throw new PolishedError(37, match ? match.index : expression.length, expression);
    }

    if (afterValue) {
      // We either have an infix or postfix operator (they should be mutually exclusive)
      var curr = notNumber.postfix || notNumber.infix;

      do {
        var prev = operators[operators.length - 1];
        if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break; // Apply previous operator, since it has precedence over current one
      } while (exec(operators, values)); // Exit loop after executing an opening parenthesis or function


      afterValue = curr.notation === 'postfix';

      if (curr.symbol !== ')') {
        operators.push(curr); // Postfix always has precedence over any operator that follows after it

        if (afterValue) exec(operators, values);
      }
    } else if (notNumber) {
      // prefix operator or function
      operators.push(notNumber.prefix || notNumber.func);

      if (notNumber.func) {
        // Require an opening parenthesis
        match = pattern.exec(expression);

        if (!match || match[0] !== '(') {
          throw new PolishedError(38, match ? match.index : expression.length, expression);
        }
      }
    } else {
      // number
      values.push(+token);
      afterValue = true;
    }
  } while (match && operators.length);

  if (operators.length) {
    throw new PolishedError(39, match ? match.index : expression.length, expression);
  } else if (match) {
    throw new PolishedError(40, match ? match.index : expression.length, expression);
  } else {
    return values.pop();
  }
}

function reverseString(str) {
  return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */


function math(formula, additionalSymbols) {
  var reversedFormula = reverseString(formula);
  var formulaMatch = reversedFormula.match(unitRegExp); // Check that all units are the same

  if (formulaMatch && !formulaMatch.every(function (unit) {
    return unit === formulaMatch[0];
  })) {
    throw new PolishedError(41);
  }

  var cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
  return "" + calculate(cleanFormula, additionalSymbols) + (formulaMatch ? reverseString(formulaMatch[0]) : '');
}

var cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */

function cssVar(cssVariable, defaultValue) {
  if (!cssVariable || !cssVariable.match(cssVariableRegex)) {
    throw new PolishedError(73);
  }

  var variableValue;
  /* eslint-disable */

  /* istanbul ignore next */

  if (typeof document !== 'undefined' && document.documentElement !== null) {
    variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
  }
  /* eslint-enable */


  if (variableValue) {
    return variableValue.trim();
  } else if (defaultValue) {
    return defaultValue;
  }

  throw new PolishedError(74);
}

// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var positionMap$1 = (/* unused pure expression or super */ null && (['Top', 'Right', 'Bottom', 'Left']));

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');

  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return "" + acc + capitalizeString(val);
    });
  }

  var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
  return property === joinedProperty ? "" + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};

  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap$1[i])] = valuesWithDefaults[i];
    }
  }

  return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */


function directionalProperty(property) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === void 0 ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === void 0 ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === void 0 ? secondValue : _values$3;
  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

/**
 * Check if a string ends with something
 * @private
 */
function endsWith(string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

var cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */

function stripUnit(value) {
  if (typeof value !== 'string') return value;
  var matchedValue = value.match(cssRegex$1);
  return matchedValue ? parseFloat(value) : value;
}

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */

var pxtoFactory = function pxtoFactory(to) {
  return function (pxval, base) {
    if (base === void 0) {
      base = '16px';
    }

    var newPxval = pxval;
    var newBase = base;

    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new PolishedError(69, to, pxval);
      }

      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new PolishedError(70, to, base);
      }

      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new PolishedError(71, pxval, to);
    }

    if (typeof newBase === 'string') {
      throw new PolishedError(72, base, to);
    }

    return "" + newPxval / newBase + to;
  };
};

var pixelsto = (/* unused pure expression or super */ null && (pxtoFactory));

/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em = /*#__PURE__*/(/* unused pure expression or super */ null && (pixelsto('em')));
var em$1 = (/* unused pure expression or super */ null && (em));

var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */

function getValueAndUnit(value) {
  if (typeof value !== 'string') return [value, ''];
  var matchedValue = value.match(cssRegex);
  if (matchedValue) return [parseFloat(value), matchedValue[2]];
  return [value, undefined];
}

/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */

function important(styleBlock, rules) {
  if (typeof styleBlock !== 'object' || styleBlock === null) {
    throw new PolishedError(75, typeof styleBlock);
  }

  var newStyleBlock = {};
  Object.keys(styleBlock).forEach(function (key) {
    if (typeof styleBlock[key] === 'object' && styleBlock[key] !== null) {
      newStyleBlock[key] = important(styleBlock[key], rules);
    } else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) {
      newStyleBlock[key] = styleBlock[key] + " !important";
    } else {
      newStyleBlock[key] = styleBlock[key];
    }
  });
  return newStyleBlock;
}

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4
};

function getRatio(ratioName) {
  return ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */


function modularScale(steps, base, ratio) {
  if (base === void 0) {
    base = '1em';
  }

  if (ratio === void 0) {
    ratio = 1.333;
  }

  if (typeof steps !== 'number') {
    throw new PolishedError(42);
  }

  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new PolishedError(43);
  }

  var _ref = typeof base === 'string' ? getValueAndUnit(base) : [base, ''],
      realBase = _ref[0],
      unit = _ref[1];

  var realRatio = typeof ratio === 'string' ? getRatio(ratio) : ratio;

  if (typeof realBase === 'string') {
    throw new PolishedError(44, base);
  }

  return "" + realBase * Math.pow(realRatio, steps) + (unit || '');
}

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */

var rem = /*#__PURE__*/(/* unused pure expression or super */ null && (pixelsto('rem')));
var rem$1 = (/* unused pure expression or super */ null && (rem));

var defaultFontSize = 16;

function convertBase(base) {
  var deconstructedValue = getValueAndUnit(base);

  if (deconstructedValue[1] === 'px') {
    return parseFloat(base);
  }

  if (deconstructedValue[1] === '%') {
    return parseFloat(base) / 100 * defaultFontSize;
  }

  throw new PolishedError(78, deconstructedValue[1]);
}

function getBaseFromDoc() {
  /* eslint-disable */

  /* istanbul ignore next */
  if (typeof document !== 'undefined' && document.documentElement !== null) {
    var rootFontSize = getComputedStyle(document.documentElement).fontSize;
    return rootFontSize ? convertBase(rootFontSize) : defaultFontSize;
  }
  /* eslint-enable */

  /* istanbul ignore next */


  return defaultFontSize;
}
/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */


function remToPx(value, base) {
  var deconstructedValue = getValueAndUnit(value);

  if (deconstructedValue[1] !== 'rem' && deconstructedValue[1] !== '') {
    throw new PolishedError(77, deconstructedValue[1]);
  }

  var newBase = base ? convertBase(base) : getBaseFromDoc();
  return deconstructedValue[0] * newBase + "px";
}

var functionsMap$3 = {
  back: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  circ: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  cubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  expo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  quad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  quart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  quint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  sine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */

function easeIn(functionName) {
  return functionsMap$3[functionName.toLowerCase().trim()];
}

var functionsMap$2 = {
  back: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  circ: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  cubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  expo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  quad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  quart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  quint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  sine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */

function easeInOut(functionName) {
  return functionsMap$2[functionName.toLowerCase().trim()];
}

var functionsMap$1 = {
  back: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  cubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  circ: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  expo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  quad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  quart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  quint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  sine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */

function easeOut(functionName) {
  return functionsMap$1[functionName.toLowerCase().trim()];
}

/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */

function between(fromSize, toSize, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  var _getValueAndUnit = getValueAndUnit(fromSize),
      unitlessFromSize = _getValueAndUnit[0],
      fromSizeUnit = _getValueAndUnit[1];

  var _getValueAndUnit2 = getValueAndUnit(toSize),
      unitlessToSize = _getValueAndUnit2[0],
      toSizeUnit = _getValueAndUnit2[1];

  var _getValueAndUnit3 = getValueAndUnit(minScreen),
      unitlessMinScreen = _getValueAndUnit3[0],
      minScreenUnit = _getValueAndUnit3[1];

  var _getValueAndUnit4 = getValueAndUnit(maxScreen),
      unitlessMaxScreen = _getValueAndUnit4[0],
      maxScreenUnit = _getValueAndUnit4[1];

  if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) {
    throw new PolishedError(47);
  }

  if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) {
    throw new PolishedError(48);
  }

  if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) {
    throw new PolishedError(76);
  }

  var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
  var base = unitlessToSize - slope * unitlessMaxScreen;
  return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
}

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */
function clearFix(parent) {
  var _ref;

  if (parent === void 0) {
    parent = '&';
  }

  var pseudoSelector = parent + "::after";
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */
function cover(offset) {
  if (offset === void 0) {
    offset = 0;
  }

  return {
    position: 'absolute',
    top: offset,
    right: offset,
    bottom: offset,
    left: offset
  };
}

/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */
function ellipsis(width, lines) {
  if (lines === void 0) {
    lines = 1;
  }

  var styles = {
    display: 'inline-block',
    maxWidth: width || '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
  return lines > 1 ? _extends({}, styles, {
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: lines,
    display: '-webkit-box',
    whiteSpace: 'normal'
  }) : styles;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */
function fluidRange(cssProp, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) {
    throw new PolishedError(49);
  }

  if (Array.isArray(cssProp)) {
    var mediaQueries = {};
    var fallbacks = {};

    for (var _iterator = _createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;) {
      var _extends2, _extends3;

      var obj = _step.value;

      if (!obj.prop || !obj.fromSize || !obj.toSize) {
        throw new PolishedError(50);
      }

      fallbacks[obj.prop] = obj.fromSize;
      mediaQueries["@media (min-width: " + minScreen + ")"] = _extends({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = between(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
      mediaQueries["@media (min-width: " + maxScreen + ")"] = _extends({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
    }

    return _extends({}, fallbacks, mediaQueries);
  } else {
    var _ref, _ref2, _ref3;

    if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) {
      throw new PolishedError(51);
    }

    return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = between(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
  }
}

var dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var formatHintMap = {
  woff: 'woff',
  woff2: 'woff2',
  ttf: 'truetype',
  otf: 'opentype',
  eot: 'embedded-opentype',
  svg: 'svg',
  svgz: 'svg'
};

function generateFormatHint(format, formatHint) {
  if (!formatHint) return '';
  return " format(\"" + formatHintMap[format] + "\")";
}

function isDataURI(fontFilePath) {
  return !!fontFilePath.replace(/\s+/g, ' ').match(dataURIRegex);
}

function generateFileReferences(fontFilePath, fileFormats, formatHint) {
  if (isDataURI(fontFilePath)) {
    return "url(\"" + fontFilePath + "\")" + generateFormatHint(fileFormats[0], formatHint);
  }

  var fileFontReferences = fileFormats.map(function (format) {
    return "url(\"" + fontFilePath + "." + format + "\")" + generateFormatHint(format, formatHint);
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return "local(\"" + font + "\")";
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));

  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats, formatHint));
  }

  return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */


function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === void 0 ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      _ref$formatHint = _ref.formatHint,
      formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint,
      _ref$localFonts = _ref.localFonts,
      localFonts = _ref$localFonts === void 0 ? [fontFamily] : _ref$localFonts,
      unicodeRange = _ref.unicodeRange,
      fontDisplay = _ref.fontDisplay,
      fontVariationSettings = _ref.fontVariationSettings,
      fontFeatureSettings = _ref.fontFeatureSettings;
  // Error Handling
  if (!fontFamily) throw new PolishedError(55);

  if (!fontFilePath && !localFonts) {
    throw new PolishedError(52);
  }

  if (localFonts && !Array.isArray(localFonts)) {
    throw new PolishedError(53);
  }

  if (!Array.isArray(fileFormats)) {
    throw new PolishedError(54);
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats, formatHint),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight,
      fontDisplay: fontDisplay,
      fontVariationSettings: fontVariationSettings,
      fontFeatureSettings: fontFeatureSettings
    }
  }; // Removes undefined fields for cleaner css object.

  return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */
function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */
function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */
function hiDPI(ratio) {
  if (ratio === void 0) {
    ratio = 1.3;
  }

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

function constructGradientValue(literals) {
  var template = '';

  for (var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    substitutions[_key - 1] = arguments[_key];
  }

  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i];

    if (i === substitutions.length - 1 && substitutions[i]) {
      var definedValues = substitutions.filter(function (substitute) {
        return !!substitute;
      }); // Adds leading coma if properties preceed color-stops

      if (definedValues.length > 1) {
        template = template.slice(0, -1);
        template += ", " + substitutions[i]; // No trailing space if color-stops is the only param provided
      } else if (definedValues.length === 1) {
        template += "" + substitutions[i];
      }
    } else if (substitutions[i]) {
      template += substitutions[i] + " ";
    }
  }

  return template.trim();
}

var _templateObject$1;

/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */
function linearGradient(_ref) {
  var colorStops = _ref.colorStops,
      fallback = _ref.fallback,
      _ref$toDirection = _ref.toDirection,
      toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;

  if (!colorStops || colorStops.length < 2) {
    throw new PolishedError(56);
  }

  return {
    backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ',').split(' ')[0].replace(/,(?=\S)/g, ', '),
    backgroundImage: constructGradientValue(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["linear-gradient(", "", ")"])), toDirection, colorStops.join(', ').replace(/,(?=\S)/g, ', '))
  };
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize() {
  var _ref;

  return [(_ref = {
    html: {
      lineHeight: '1.15',
      textSizeAdjust: '100%'
    },
    body: {
      margin: '0'
    },
    main: {
      display: 'block'
    },
    h1: {
      fontSize: '2em',
      margin: '0.67em 0'
    },
    hr: {
      boxSizing: 'content-box',
      height: '0',
      overflow: 'visible'
    },
    pre: {
      fontFamily: 'monospace, monospace',
      fontSize: '1em'
    },
    a: {
      backgroundColor: 'transparent'
    },
    'abbr[title]': {
      borderBottom: 'none',
      textDecoration: 'underline'
    }
  }, _ref["b,\n    strong"] = {
    fontWeight: 'bolder'
  }, _ref["code,\n    kbd,\n    samp"] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  }, _ref.small = {
    fontSize: '80%'
  }, _ref["sub,\n    sup"] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
  }, _ref.sub = {
    bottom: '-0.25em'
  }, _ref.sup = {
    top: '-0.5em'
  }, _ref.img = {
    borderStyle: 'none'
  }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: '0'
  }, _ref["button,\n    input"] = {
    overflow: 'visible'
  }, _ref["button,\n    select"] = {
    textTransform: 'none'
  }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
    WebkitAppearance: 'button'
  }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
    borderStyle: 'none',
    padding: '0'
  }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
    outline: '1px dotted ButtonText'
  }, _ref.fieldset = {
    padding: '0.35em 0.625em 0.75em'
  }, _ref.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
  }, _ref.progress = {
    verticalAlign: 'baseline'
  }, _ref.textarea = {
    overflow: 'auto'
  }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
    boxSizing: 'border-box',
    padding: '0'
  }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
    height: 'auto'
  }, _ref['[type="search"]'] = {
    WebkitAppearance: 'textfield',
    outlineOffset: '-2px'
  }, _ref['[type="search"]::-webkit-search-decoration'] = {
    WebkitAppearance: 'none'
  }, _ref['::-webkit-file-upload-button'] = {
    WebkitAppearance: 'button',
    font: 'inherit'
  }, _ref.details = {
    display: 'block'
  }, _ref.summary = {
    display: 'list-item'
  }, _ref.template = {
    display: 'none'
  }, _ref['[hidden]'] = {
    display: 'none'
  }, _ref), {
    'abbr[title]': {
      textDecoration: 'underline dotted'
    }
  }];
}

var _templateObject;

/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */
function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      _ref$extent = _ref.extent,
      extent = _ref$extent === void 0 ? '' : _ref$extent,
      fallback = _ref.fallback,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? '' : _ref$position,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? '' : _ref$shape;

  if (!colorStops || colorStops.length < 2) {
    throw new PolishedError(57);
  }

  return {
    backgroundColor: fallback || colorStops[0].split(' ')[0],
    backgroundImage: constructGradientValue(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["radial-gradient(", "", "", "", ")"])), position, shape, extent, colorStops.join(', '))
  };
}

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
  var _ref;

  if (extension === void 0) {
    extension = 'png';
  }

  if (retinaSuffix === void 0) {
    retinaSuffix = '_2x';
  }

  if (!filename) {
    throw new PolishedError(58);
  } // Replace the dot at the beginning of the passed extension if one exists


  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
  return _ref = {
    backgroundImage: "url(" + filename + "." + ext + ")"
  }, _ref[hiDPI()] = _extends({
    backgroundImage: "url(" + rFilename + ")"
  }, backgroundSize ? {
    backgroundSize: backgroundSize
  } : {}), _ref;
}

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */

function getTimingFunction(functionName) {
  return functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */


function timingFunctions(timingFunction) {
  return getTimingFunction(timingFunction);
}

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  var fullWidth = "" + width[0] + (width[1] || '');
  var halfWidth = "" + width[0] / 2 + (width[1] || '');
  var fullHeight = "" + height[0] + (height[1] || '');
  var halfHeight = "" + height[0] / 2 + (height[1] || '');

  switch (pointingDirection) {
    case 'top':
      return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;

    case 'topLeft':
      return fullWidth + " " + fullHeight + " 0 0";

    case 'left':
      return halfHeight + " " + fullWidth + " " + halfHeight + " 0";

    case 'bottomLeft':
      return fullWidth + " 0 0 " + fullHeight;

    case 'bottom':
      return fullHeight + " " + halfWidth + " 0 " + halfWidth;

    case 'bottomRight':
      return "0 0 " + fullWidth + " " + fullHeight;

    case 'right':
      return halfHeight + " 0 " + halfHeight + " " + fullWidth;

    case 'topRight':
    default:
      return "0 " + fullWidth + " " + fullHeight + " 0";
  }
};

var getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
  switch (pointingDirection) {
    case 'top':
    case 'bottomRight':
      return {
        borderBottomColor: foregroundColor
      };

    case 'right':
    case 'bottomLeft':
      return {
        borderLeftColor: foregroundColor
      };

    case 'bottom':
    case 'topLeft':
      return {
        borderTopColor: foregroundColor
      };

    case 'left':
    case 'topRight':
      return {
        borderRightColor: foregroundColor
      };

    default:
      throw new PolishedError(59);
  }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */


function triangle(_ref) {
  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
  var widthAndUnit = getValueAndUnit(width);
  var heightAndUnit = getValueAndUnit(height);

  if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) {
    throw new PolishedError(60);
  }

  return _extends({
    width: '0',
    height: '0',
    borderColor: backgroundColor
  }, getBorderColor(pointingDirection, foregroundColor), {
    borderStyle: 'solid',
    borderWidth: getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
  });
}

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */
function wordWrap(wrap) {
  if (wrap === void 0) {
    wrap = 'break-word';
  }

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }

  throw new PolishedError(5);
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }

  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;

    case green:
      hue = (blue - red) / delta + 2;
      break;

    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;

  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }

  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

var reduceHexValue$1 = reduceHexValue;

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new PolishedError(1);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }

  throw new PolishedError(2);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new PolishedError(7);
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */


function toColorString(color) {
  if (typeof color !== 'object') throw new PolishedError(8);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new PolishedError(8);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare


function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */

function adjustHue(degree, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: hslColor.hue + parseFloat(degree)
  }));
} // prettier-ignore


var curriedAdjustHue = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(adjustHue)));
var curriedAdjustHue$1 = (/* unused pure expression or super */ null && (curriedAdjustHue));

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function complement(color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */

function darken(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDarken = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(darken)));
var curriedDarken$1 = (/* unused pure expression or super */ null && (curriedDarken));

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */

function desaturate(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDesaturate = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(desaturate)));
var curriedDesaturate$1 = (/* unused pure expression or super */ null && (curriedDesaturate));

/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */

function getLuminance(color) {
  if (color === 'transparent') return 0;
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}

/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */

function getContrast(color1, color2) {
  var luminance1 = getLuminance(color1);
  var luminance2 = getLuminance(color2);
  return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function grayscale(color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: 0
  }));
}

/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */
function hslToColorString(color) {
  if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
    if (color.alpha && typeof color.alpha === 'number') {
      return hsla({
        hue: color.hue,
        saturation: color.saturation,
        lightness: color.lightness,
        alpha: color.alpha
      });
    }

    return hsl({
      hue: color.hue,
      saturation: color.saturation,
      lightness: color.lightness
    });
  }

  throw new PolishedError(45);
}

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */

function invert(color) {
  if (color === 'transparent') return color; // parse color string to rgb

  var value = parseToRgb(color);
  return toColorString(_extends({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */

function lighten(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
} // prettier-ignore


var curriedLighten = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(lighten)));
var curriedLighten$1 = (/* unused pure expression or super */ null && (curriedLighten));

/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */
function meetsContrastGuidelines(color1, color2) {
  var contrastRatio = getContrast(color1, color2);
  return {
    AA: contrastRatio >= 4.5,
    AALarge: contrastRatio >= 3,
    AAA: contrastRatio >= 7,
    AAALarge: contrastRatio >= 4.5
  };
}

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */

function mix(weight, color, otherColor) {
  if (color === 'transparent') return otherColor;
  if (otherColor === 'transparent') return color;
  if (weight === 0) return otherColor;
  var parsedColor1 = parseToRgb(color);

  var color1 = _extends({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);

  var color2 = _extends({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
  }); // The formula is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method


  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
  };
  return rgba(mixedColor);
} // prettier-ignore


var curriedMix = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string, string> */
(mix)));
var mix$1 = (/* unused pure expression or super */ null && (curriedMix));

/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */

function opacify(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
  });

  return rgba(colorWithAlpha);
} // prettier-ignore


var curriedOpacify = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(opacify)));
var curriedOpacify$1 = (/* unused pure expression or super */ null && (curriedOpacify));

var defaultReturnIfLightColor = '#000';
var defaultReturnIfDarkColor = '#fff';
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */

function readableColor(color, returnIfLightColor, returnIfDarkColor, strict) {
  if (returnIfLightColor === void 0) {
    returnIfLightColor = defaultReturnIfLightColor;
  }

  if (returnIfDarkColor === void 0) {
    returnIfDarkColor = defaultReturnIfDarkColor;
  }

  if (strict === void 0) {
    strict = true;
  }

  var isColorLight = getLuminance(color) > 0.179;
  var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;

  if (!strict || getContrast(color, preferredReturnColor) >= 4.5) {
    return preferredReturnColor;
  }

  return isColorLight ? defaultReturnIfLightColor : defaultReturnIfDarkColor;
}

/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */
function rgbToColorString(color) {
  if (typeof color === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
    if (typeof color.alpha === 'number') {
      return rgba({
        red: color.red,
        green: color.green,
        blue: color.blue,
        alpha: color.alpha
      });
    }

    return rgb({
      red: color.red,
      green: color.green,
      blue: color.blue
    });
  }

  throw new PolishedError(46);
}

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */

function saturate(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
  }));
} // prettier-ignore


var curriedSaturate = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(saturate)));
var curriedSaturate$1 = (/* unused pure expression or super */ null && (curriedSaturate));

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */

function setHue(hue, color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    hue: parseFloat(hue)
  }));
} // prettier-ignore


var curriedSetHue = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(setHue)));
var curriedSetHue$1 = (/* unused pure expression or super */ null && (curriedSetHue));

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */

function setLightness(lightness, color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    lightness: parseFloat(lightness)
  }));
} // prettier-ignore


var curriedSetLightness = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(setLightness)));
var curriedSetLightness$1 = (/* unused pure expression or super */ null && (curriedSetLightness));

/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */

function setSaturation(saturation, color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: parseFloat(saturation)
  }));
} // prettier-ignore


var curriedSetSaturation = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(setSaturation)));
var curriedSetSaturation$1 = (/* unused pure expression or super */ null && (curriedSetSaturation));

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  if (color === 'transparent') return color;
  return mix$1(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore


var curriedShade = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(shade)));
var curriedShade$1 = (/* unused pure expression or super */ null && (curriedShade));

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  if (color === 'transparent') return color;
  return mix$1(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore


var curriedTint = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(tint)));
var curriedTint$1 = (/* unused pure expression or super */ null && (curriedTint));

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */

function transparentize(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
  });

  return rgba(colorWithAlpha);
} // prettier-ignore


var curriedTransparentize = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(transparentize)));
var curriedTransparentize$1 = (/* unused pure expression or super */ null && (curriedTransparentize));

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);

  if (!multiMode && args.length > 8) {
    throw new PolishedError(64);
  }

  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new PolishedError(65);
    }

    if (Array.isArray(arg) && arg.length > 8) {
      throw new PolishedError(66);
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');
  return {
    animation: code
  };
}

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */
function backgroundImages() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

var sideMap = (/* unused pure expression or super */ null && (['top', 'right', 'bottom', 'left']));
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */

function border(sideKeyword) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (typeof sideKeyword === 'string' && sideMap.indexOf(sideKeyword) >= 0) {
    var _ref;

    return _ref = {}, _ref["border" + capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
  } else {
    values.unshift(sideKeyword);
    return {
      borderWidth: values[0],
      borderStyle: values[1],
      borderColor: values[2]
    };
  }
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */
function borderColor() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderColor'].concat(values));
}

/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */
function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);

  if (!radius && radius !== 0) {
    throw new PolishedError(62);
  }

  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
  }

  throw new PolishedError(63);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */
function borderStyle() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderStyle'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderWidth'].concat(values));
}

function generateSelectors(template, state) {
  var stateSuffix = state ? ":" + state : '';
  return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */


function statefulSelectors(states, template, stateMap) {
  if (!template) throw new PolishedError(67);
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];

  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new PolishedError(68);
    }

    selectors.push(generateSelectors(template, states[i]));
  }

  selectors = selectors.join(',');
  return selectors;
}

var stateMap$1 = (/* unused pure expression or super */ null && ([undefined, null, 'active', 'focus', 'hover']));

function template$1(state) {
  return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */


function buttons() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */
function margin() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['margin'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */
function padding() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['padding'].concat(values));
}

var positionMap = (/* unused pure expression or super */ null && (['absolute', 'fixed', 'relative', 'static', 'sticky']));
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */

function position(firstValue) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap.indexOf(firstValue) >= 0 && firstValue) {
    return _extends({}, directionalProperty.apply(void 0, [''].concat(values)), {
      position: firstValue
    });
  } else {
    return directionalProperty.apply(void 0, ['', firstValue].concat(values));
  }
}

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */
function size(height, width) {
  if (width === void 0) {
    width = height;
  }

  return {
    height: height,
    width: width
  };
}

var stateMap = (/* unused pure expression or super */ null && ([undefined, null, 'active', 'focus', 'hover']));

function template(state) {
  return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */


function textInputs() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */

function transitions() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  if (Array.isArray(properties[0]) && properties.length === 2) {
    var value = properties[1];

    if (typeof value !== 'string') {
      throw new PolishedError(61);
    }

    var transitionsString = properties[0].map(function (property) {
      return property + " " + value;
    }).join(', ');
    return {
      transition: transitionsString
    };
  } else {
    return {
      transition: properties.join(', ')
    };
  }
}



;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Modal/Modal.styled.js





// styled-components.
// -----------------------------------------------------------------------------
const ModalButtons = styled_components_browser_esm/* default.div */.ZP.div `
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;

  ${({ buttonsFullWidth }) => buttonsFullWidth &&
    styled_components_browser_esm/* css */.iv `
      justify-content: center;

      button {
        width: 100%;
      }
    `}
`;
const ModalContent = styled_components_browser_esm/* default.div */.ZP.div `
  margin-top: ${getSpace('xl')};
`;
const fadeInOverlay = styled_components_browser_esm/* keyframes */.F4 `
  from { opacity: 0; }
  to   { opacity: 1; }
`;
const ModalOverlay = styled_components_browser_esm/* default.div */.ZP.div `
  align-items: center;
  animation-name: ${fadeInOverlay};
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
  background: ${rgba('#353241', 0.8)};
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  opacity: 1;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 20;
`;
const fadeInModal = styled_components_browser_esm/* keyframes */.F4 `
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const ModalRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ size, theme }) => styled_components_browser_esm/* css */.iv `
    animation-name: ${fadeInModal};
    animation-duration: 0.3s;

    box-shadow: ${getShadow({ mode: 'light', theme, variant: 'xl' })};
    background: #fff;
    border-radius: ${getRadius('m')};
    max-height: 90vh;
    overflow: auto;
    padding: ${getSpace('2xl')};
    position: relative;

    width: ${MODAL_SIZES_MAP[size]}px;
    z-index: 99999;

    .btn__close {
      background-color: transparent;
      border: 0;
      cursor: pointer;
      padding: 0;
      position: absolute;
      top: ${getSpace('2xl')};
      right: ${getSpace('2xl')};
    }
  `}
`;
const ModalTitle = styled_components_browser_esm/* default.div */.ZP.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
`;
//# sourceMappingURL=Modal.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Modal/Modal.js








// Component.
// -----------------------------------------------------------------------------
const Modal = (0,react.forwardRef)(({ buttonCancel, buttonSuccess, buttonsFullWidth = MODAL_DEFAULT_BUTTONS_FULL_WIDTH, buttonsSlot, children, closeable = MODAL_DEFAULT_CLOSEABLE, disableEscKey = MODAL_DEFAULT_DISABLE_ESC_KEY, disableOutsideClick = MODAL_DEFAULT_DISABLE_OUTSIDE_CLICK, isOpen = MODAL_DEFAULT_IS_OPEN, onClose, size = MODAL_DEFAULT_SIZE, title, ...rest }, ref) => {
    // Hooks.
    // -------------------------------------------------------------------------
    const [portalId, setPortalId] = (0,react.useState)('');
    const refModal = (0,react.useRef)(null);
    const { onClickCross } = useModal({
        disableEscKey,
        disableOutsideClick,
        isOpen,
        onClose,
        ref,
        refModal
    });
    // Effect.
    // -------------------------------------------------------------------------
    (0,react.useEffect)(() => {
        if (isOpen) {
            const portals = document.querySelectorAll(`.${MODAL_PORTAL_DIV_CLASSNAME}`);
            const portalSeq = portals.length === 0 ? 0 : portals.length - 1;
            const currentPortalId = `${MODAL_PORTAL_DIV_ID}-${portalSeq}`;
            const currentPortal = document.getElementById(currentPortalId);
            const fnCreateNode = (theId) => {
                const div = document.createElement('div');
                div.classList.add(MODAL_PORTAL_DIV_CLASSNAME);
                div.setAttribute('id', theId);
                document.body.append(div);
            };
            if (!currentPortal) {
                fnCreateNode(currentPortalId);
                setPortalId(currentPortalId);
            }
            else if (currentPortal.childElementCount === 0) {
                const portalDivId = `${MODAL_PORTAL_DIV_ID}-${portalSeq + 1}`;
                fnCreateNode(portalDivId);
                setPortalId(portalDivId);
            }
            else {
                setPortalId(currentPortalId);
            }
        }
    }, [isOpen]);
    // Guard condition.
    // -------------------------------------------------------------------------
    if (!isOpen ||
        typeof window === 'undefined' ||
        (typeof window !== 'undefined' && !document.getElementById(portalId))) {
        return null;
    }
    // Render.
    // -------------------------------------------------------------------------
    return (0,react_dom.createPortal)((0,jsx_runtime.jsx)(ModalOverlay, { children: (0,jsx_runtime.jsxs)(ModalRoot, { "aria-modal": true, "aria-labelledby": "modal-title", ref: refModal, role: "alertdialog", size: size, ...rest, children: [title && ((0,jsx_runtime.jsx)(ModalTitle, { id: "modal-title", children: (0,jsx_runtime.jsx)(Text_Text, { bold: true, size: "xl", children: title }) })), closeable && ((0,jsx_runtime.jsx)(IconButton_IconButton, { "aria-label": MODAL_TOP_BUTTON_ARIA_LABEL, className: "btn__close", icon: pro_solid_svg_icons/* faClose */.YIN, onClick: onClickCross })), (0,jsx_runtime.jsx)(ModalContent, { children: children }), (buttonSuccess || buttonCancel || buttonsSlot) && ((0,jsx_runtime.jsxs)(ModalButtons, { buttonsFullWidth: buttonsFullWidth, children: [buttonSuccess && ((0,jsx_runtime.jsx)(Button_Button, { ...MODAL_DEFAULT_BUTTON_SUCCESS, ...buttonSuccess, "aria-label": MODAL_ACTION_BUTTON_SUCCESS_ARIA_LABEL })), buttonCancel && ((0,jsx_runtime.jsx)(Button_Button, { ...MODAL_DEFAULT_BUTTON_CANCEL, ...buttonCancel, "aria-label": MODAL_ACTION_BUTTON_CANCEL_ARIA_LABEL })), buttonsSlot] }))] }) }), document.getElementById(portalId));
});
// Component configuration.
// -----------------------------------------------------------------------------
Modal.displayName = 'Modal';
/* harmony default export */ var Modal_Modal = (Modal);
//# sourceMappingURL=Modal.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Notification/Notification.constants.js

const NOTIFICATION_TYPE_ICON = {
    info: pro_solid_svg_icons/* faInfoCircle */.sqG,
    success: pro_solid_svg_icons/* faCheckCircle */.f8k,
    warning: pro_solid_svg_icons/* faExclamationTriangle */.eHv,
    error: pro_solid_svg_icons/* faTimesCircle */.nYk
};
const NOTIFICATION_TYPE_SCHEMA = {
    info: {
        variant: 'soft',
        schema: 'info',
        state: 'default'
    },
    success: {
        variant: 'soft',
        schema: 'positive',
        state: 'default'
    },
    warning: {
        variant: 'soft',
        schema: 'notice',
        state: 'default'
    },
    error: {
        variant: 'soft',
        schema: 'negative',
        state: 'default'
    }
};
//# sourceMappingURL=Notification.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Notification/Notification.styled.js





// styled-components.
// -----------------------------------------------------------------------------
const NotificationRoot = styled_components_browser_esm/* default.figure */.ZP.figure `
  ${({ theme, type, mode }) => {
    const { background, foreground } = getSchemaState({
        ...NOTIFICATION_TYPE_SCHEMA[type],
        theme,
        mode
    });
    return styled_components_browser_esm/* css */.iv `
      /* Fixed */
      align-items: baseline;
      border-radius: ${getRadius('m')};
      display: flex;
      margin: 0 0 ${getSpace('4xl')} 0;
      padding: ${getSpace('l')};

      /* Colors */
      background-color: ${background};
      color: ${foreground};

      /* Nested links */
      a {
        color: ${foreground};
        text-decoration: underline;
        font-weight: ${getFontWeight('black')};
      }
    `;
}}
`;
const NotificationIcon = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ theme, type, mode }) => {
    const { foregroundAlt } = getSchemaState({
        ...NOTIFICATION_TYPE_SCHEMA[type],
        theme,
        mode
    });
    return styled_components_browser_esm/* css */.iv `
      /* Fixed */
      margin-right: ${getSpace('s')};

      /* Colors */
      color: ${foregroundAlt};
    `;
}};
`;
const NotificationContent = styled_components_browser_esm/* default.div */.ZP.div `
  flex: 1 1 auto;
`;
const NotificationTitle = styled_components_browser_esm/* default.figcaption */.ZP.figcaption `
  margin-bottom: ${getSpace('xs')};
`;
const NotificationMessage = styled_components_browser_esm/* default.div */.ZP.div ``;
const NotificationActions = styled_components_browser_esm/* default.div */.ZP.div `
  button {
    appearance: none;
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }
`;
//# sourceMappingURL=Notification.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Notification/Notification.js






// Component.
// -----------------------------------------------------------------------------
const Notification = (0,react.forwardRef)(({ type = 'info', mode = 'light', message, title, icon, onClose, closeIcon = pro_light_svg_icons/* faTimes */.NBC, ...rest }, ref) => ((0,jsx_runtime.jsxs)(NotificationRoot, { ref: ref, type: type, mode: mode, ...rest, children: [(0,jsx_runtime.jsx)(NotificationIcon, { type: type, mode: mode, children: (0,jsx_runtime.jsx)(Icon_Icon, { icon: icon || NOTIFICATION_TYPE_ICON[type] }) }), (0,jsx_runtime.jsxs)(NotificationContent, { children: [title && ((0,jsx_runtime.jsx)(NotificationTitle, { children: (0,jsx_runtime.jsx)(Text_Text, { size: "m", bold: true, children: title }) })), (0,jsx_runtime.jsx)(NotificationMessage, { children: (0,jsx_runtime.jsx)(Text_Text, { size: "s", children: message }) })] }), onClose && ((0,jsx_runtime.jsx)(NotificationActions, { children: (0,jsx_runtime.jsx)("button", { onClick: onClose, children: (0,jsx_runtime.jsx)(Icon_Icon, { icon: closeIcon, size: "m" }) }) }))] })));
// Component configuration.
// -----------------------------------------------------------------------------
Notification.displayName = 'Notification';
/* harmony default export */ var Notification_Notification = (Notification);
//# sourceMappingURL=Notification.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Radio/Radio.constants.js


// Constants.
// -----------------------------------------------------------------------------
/** Default checked value. */
const RADIO_DEFAULT_CHECKED = false;
/** Default disabled */
const RADIO_DEFAULT_DISABLED = false;
/** Default mode. */
const RADIO_DEFAULT_MODE = 'light';
/** Default role. */
const RADIO_DEFAULT_ROLE = 'none';
/** Default size. */
const RADIO_DEFAULT_SIZE = 's';
/** Mapping: mode. */
const Radio_constants_MAPPINGS_MODE = {
    // Dark mode.
    dark: {
        background: (tokens_default()).colors.black[100].value,
        border: (tokens_default()).colors.midnight[700].value,
        text: (tokens_default()).colors.midnight[300].value,
        checked: {
            background: (tokens_default()).colors.midnight[100].value,
            border: (tokens_default()).colors.midnight[700].value
        },
        disabled: {
            background: (tokens_default()).colors.midnight[850].value,
            border: (tokens_default()).colors.midnight[800].value,
            text: (tokens_default()).colors.midnight[800].value
        },
        focus: {
            border: (tokens_default()).colors.midnight[850].value,
            shadow: `0 0 0 4px ${(tokens_default()).colors.midnight[150].value}`
        },
        hover: {
            border: (tokens_default()).colors.midnight[400].value
        }
    },
    // Light mode.
    light: {
        background: (tokens_default()).colors.white[100].value,
        border: (tokens_default()).colors.midnight[200].value,
        text: (tokens_default()).colors.midnight[800].value,
        checked: {
            background: (tokens_default()).colors.midnight[800].value,
            border: (tokens_default()).colors.midnight[800].value
        },
        disabled: {
            background: (tokens_default()).colors.midnight[150].value,
            border: (tokens_default()).colors.midnight[200].value,
            text: (tokens_default()).colors.midnight[200].value
        },
        focus: {
            border: (tokens_default()).colors.midnight[850].value,
            shadow: `0 0 0 4px ${(tokens_default()).colors.midnight[150].value}`
        },
        hover: {
            border: (tokens_default()).colors.midnight[400].value
        }
    }
};
/** Scale mappings. */
const Radio_constants_MAPPINGS_SCALE = {
    s: {
        fontSize: getFontSize('s'),
        fontWeight: getFontWeight('medium')
    },
    xs: {
        fontSize: getFontSize('xs'),
        fontWeight: getFontWeight('medium')
    }
};
//# sourceMappingURL=Radio.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Radio/Radio.styled.js




// styled-components.
// -----------------------------------------------------------------------------
const RadioHidden = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({ type: 'radio' }) `
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
const RadioLabel = styled_components_browser_esm/* default.label */.ZP.label `
  ${({ scale, theme }) => {
    const { fontSize, fontWeight } = Radio_constants_MAPPINGS_SCALE[scale];
    return styled_components_browser_esm/* css */.iv `
      align-items: center;
      cursor: pointer;
      display: inline-flex;
      font-family: ${theme.typography.fontFamily};
      font-size: ${fontSize};
      font-weight: ${fontWeight};
      gap: ${getSpace('s')};
      line-height: ${(tokens_default()).font.lineHeight.text.value};
    `;
}}
`;
const RadioVisible = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ checked: isChecked, disabled: isDisabled, mode }) => {
    const { background, border, checked, disabled, hover } = Radio_constants_MAPPINGS_MODE[mode];
    return styled_components_browser_esm/* css */.iv `
      border-radius: 50%;
      cursor: pointer;
      flex-shrink: 0;
      height: ${getSpace('2xl')};
      position: relative;
      transition: 0.3s;
      width: ${getSpace('2xl')};

      /* Mode */
      background-color: ${background};
      border: 2px solid ${border};

      &:hover {
        border-color: ${hover.border};
      }

      &.error {
        border-color: ${(tokens_default()).colors.red[700].value};
      }

      ${isDisabled &&
        `
          background-color: ${disabled.background} !important;
          border-color: ${disabled.border} !important;
          color: ${disabled.text} !important;
          pointer-events: none;
        `}

      ${isChecked &&
        `
        background-color: ${checked.background};
        border-color: ${checked.border};
      `}

      &::after {
        background-color: ${border};
        border-radius: 50%;
        content: '';
        height: 50%;
        margin-top: 50%;
        margin-left: 50%;
        opacity: ${isChecked ? 1 : 0};
        position: absolute;
        transform: translate(-50%, -50%);
        transition: 0.3s;
        width: 50%;
      }
    `;
}}
`;
const RadioWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  align-items: center;
  display: inline-flex;
`;
//# sourceMappingURL=Radio.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Radio/Radio.js




// Component.
// -----------------------------------------------------------------------------
const Radio = (0,react.forwardRef)(({ checked = RADIO_DEFAULT_CHECKED, disabled = RADIO_DEFAULT_DISABLED, id, label, name, mode = RADIO_DEFAULT_MODE, onChange, role = RADIO_DEFAULT_ROLE, size = RADIO_DEFAULT_SIZE, value, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsxs)(RadioWrapper, { children: [(0,jsx_runtime.jsx)(RadioHidden, { checked: checked, disabled: disabled, id: id || name, name: name, ref: ref, onChange: onChange, value: value, ...rest }), (0,jsx_runtime.jsxs)(RadioLabel, { htmlFor: id || name, scale: size, children: [(0,jsx_runtime.jsx)(RadioVisible, { ...(role && { className: role }), checked: checked, disabled: disabled, mode: mode }), label] })] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Radio.displayName = 'Radio';
/* harmony default export */ var Radio_Radio = (Radio);
//# sourceMappingURL=Radio.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/RadioGroup/RadioGroup.constants.js

// Constants.
// -----------------------------------------------------------------------------
/** Default 'disabled' values. */
const RADIO_GROUP_DEFAULT_DIRECTION = 'column';
const RADIO_GROUP_DEFAULT_DISABLED = false;
const RADIO_GROUP_DEFAULT_MODE = RADIO_DEFAULT_MODE;
const RADIO_GROUP_DEFAULT_SIZE = RADIO_DEFAULT_SIZE;
//# sourceMappingURL=RadioGroup.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/RadioGroup/RadioGroup.styled.js


// Styled-Components.
// -----------------------------------------------------------------------------
const RadioGroupWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ direction }) => {
    return styled_components_browser_esm/* css */.iv `
      display: inline-flex;
      flex-direction: ${direction};
      flex-wrap: wrap;
      gap: ${getSpace('m')};
    `;
}}
`;
//# sourceMappingURL=RadioGroup.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/RadioGroup/RadioGroup.js






// Component
// -----------------------------------------------------------------------------
const RadioGroup = (0,react.forwardRef)(({ direction = RADIO_GROUP_DEFAULT_DIRECTION, disabled = RADIO_GROUP_DEFAULT_DISABLED, mode = RADIO_GROUP_DEFAULT_MODE, name, onChange, options, size = RADIO_GROUP_DEFAULT_SIZE, value, ...rest }, ref) => options.length === 0 ? null : ((0,jsx_runtime.jsx)(RadioGroupWrapper, { direction: direction, ref: ref, children: options.map((option) => ((0,react.createElement)(Radio_Radio, { ...((disabled || option.disabled) && { disabled: true }), checked: value === option.value, id: `${name}_${option.value}`, key: option.value, label: option.label, mode: mode, name: name, onChange: (e) => onChange(e, option.value), size: size, value: option.value, ...rest }))) })));
// Component configuration.
// -----------------------------------------------------------------------------
RadioGroup.displayName = 'RadioGroup';
/* harmony default export */ var RadioGroup_RadioGroup = (RadioGroup);
//# sourceMappingURL=RadioGroup.js.map
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/remove-accents/index.js
var remove_accents = __webpack_require__(45433);
var remove_accents_default = /*#__PURE__*/__webpack_require__.n(remove_accents);
;// CONCATENATED MODULE: ../../node_modules/match-sorter/dist/match-sorter.esm.js



var rankings = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
matchSorter.rankings = rankings;

var defaultBaseSortFn = function defaultBaseSortFn(a, b) {
  return String(a.rankedValue).localeCompare(String(b.rankedValue));
};
/**
 * Takes an array of items and a value and returns a new array with the items that match the given value
 * @param {Array} items - the items to sort
 * @param {String} value - the value to use for ranking
 * @param {Object} options - Some options to configure the sorter
 * @return {Array} - the new sorted array
 */


function matchSorter(items, value, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      keys = _options.keys,
      _options$threshold = _options.threshold,
      threshold = _options$threshold === void 0 ? rankings.MATCHES : _options$threshold,
      _options$baseSort = _options.baseSort,
      baseSort = _options$baseSort === void 0 ? defaultBaseSortFn : _options$baseSort,
      _options$sorter = _options.sorter,
      sorter = _options$sorter === void 0 ? function (matchedItems) {
    return matchedItems.sort(function (a, b) {
      return sortRankedValues(a, b, baseSort);
    });
  } : _options$sorter;
  var matchedItems = items.reduce(reduceItemsToRanked, []);
  return sorter(matchedItems).map(function (_ref) {
    var item = _ref.item;
    return item;
  });

  function reduceItemsToRanked(matches, item, index) {
    var rankingInfo = getHighestRanking(item, keys, value, options);
    var rank = rankingInfo.rank,
        _rankingInfo$keyThres = rankingInfo.keyThreshold,
        keyThreshold = _rankingInfo$keyThres === void 0 ? threshold : _rankingInfo$keyThres;

    if (rank >= keyThreshold) {
      matches.push((0,esm_extends/* default */.Z)({}, rankingInfo, {
        item: item,
        index: index
      }));
    }

    return matches;
  }
}
/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, keyIndex: Number, keyThreshold: Number}} - the highest ranking
 */


function getHighestRanking(item, keys, value, options) {
  if (!keys) {
    // if keys is not specified, then we assume the item given is ready to be matched
    var stringItem = item;
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: stringItem,
      rank: getMatchRanking(stringItem, value, options),
      keyIndex: -1,
      keyThreshold: options.threshold
    };
  }

  var valuesToRank = getAllValuesToRank(item, keys);
  return valuesToRank.reduce(function (_ref2, _ref3, i) {
    var rank = _ref2.rank,
        rankedValue = _ref2.rankedValue,
        keyIndex = _ref2.keyIndex,
        keyThreshold = _ref2.keyThreshold;
    var itemValue = _ref3.itemValue,
        attributes = _ref3.attributes;
    var newRank = getMatchRanking(itemValue, value, options);
    var newRankedValue = rankedValue;
    var minRanking = attributes.minRanking,
        maxRanking = attributes.maxRanking,
        threshold = attributes.threshold;

    if (newRank < minRanking && newRank >= rankings.MATCHES) {
      newRank = minRanking;
    } else if (newRank > maxRanking) {
      newRank = maxRanking;
    }

    if (newRank > rank) {
      rank = newRank;
      keyIndex = i;
      keyThreshold = threshold;
      newRankedValue = itemValue;
    }

    return {
      rankedValue: newRankedValue,
      rank: rank,
      keyIndex: keyIndex,
      keyThreshold: keyThreshold
    };
  }, {
    rankedValue: item,
    rank: rankings.NO_MATCH,
    keyIndex: -1,
    keyThreshold: options.threshold
  });
}
/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */


function getMatchRanking(testString, stringToRank, options) {
  testString = prepareValueForComparison(testString, options);
  stringToRank = prepareValueForComparison(stringToRank, options); // too long

  if (stringToRank.length > testString.length) {
    return rankings.NO_MATCH;
  } // case sensitive equals


  if (testString === stringToRank) {
    return rankings.CASE_SENSITIVE_EQUAL;
  } // Lower casing before further comparison


  testString = testString.toLowerCase();
  stringToRank = stringToRank.toLowerCase(); // case insensitive equals

  if (testString === stringToRank) {
    return rankings.EQUAL;
  } // starts with


  if (testString.startsWith(stringToRank)) {
    return rankings.STARTS_WITH;
  } // word starts with


  if (testString.includes(" " + stringToRank)) {
    return rankings.WORD_STARTS_WITH;
  } // contains


  if (testString.includes(stringToRank)) {
    return rankings.CONTAINS;
  } else if (stringToRank.length === 1) {
    // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return rankings.NO_MATCH;
  } // acronym


  if (getAcronym(testString).includes(stringToRank)) {
    return rankings.ACRONYM;
  } // will return a number between rankings.MATCHES and
  // rankings.MATCHES + 1 depending  on how close of a match it is.


  return getClosenessRanking(testString, stringToRank);
}
/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */


function getAcronym(string) {
  var acronym = '';
  var wordsInString = string.split(' ');
  wordsInString.forEach(function (wordInString) {
    var splitByHyphenWords = wordInString.split('-');
    splitByHyphenWords.forEach(function (splitByHyphenWord) {
      acronym += splitByHyphenWord.substr(0, 1);
    });
  });
  return acronym;
}
/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a tighter match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */


function getClosenessRanking(testString, stringToRank) {
  var matchingInOrderCharCount = 0;
  var charNumber = 0;

  function findMatchingCharacter(matchChar, string, index) {
    for (var j = index, J = string.length; j < J; j++) {
      var stringChar = string[j];

      if (stringChar === matchChar) {
        matchingInOrderCharCount += 1;
        return j + 1;
      }
    }

    return -1;
  }

  function getRanking(spread) {
    var spreadPercentage = 1 / spread;
    var inOrderPercentage = matchingInOrderCharCount / stringToRank.length;
    var ranking = rankings.MATCHES + inOrderPercentage * spreadPercentage;
    return ranking;
  }

  var firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);

  if (firstIndex < 0) {
    return rankings.NO_MATCH;
  }

  charNumber = firstIndex;

  for (var i = 1, I = stringToRank.length; i < I; i++) {
    var matchChar = stringToRank[i];
    charNumber = findMatchingCharacter(matchChar, testString, charNumber);
    var found = charNumber > -1;

    if (!found) {
      return rankings.NO_MATCH;
    }
  }

  var spread = charNumber - firstIndex;
  return getRanking(spread);
}
/**
 * Sorts items that have a rank, index, and keyIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first, 0 if equal
 */


function sortRankedValues(a, b, baseSort) {
  var aFirst = -1;
  var bFirst = 1;
  var aRank = a.rank,
      aKeyIndex = a.keyIndex;
  var bRank = b.rank,
      bKeyIndex = b.keyIndex;
  var same = aRank === bRank;

  if (same) {
    if (aKeyIndex === bKeyIndex) {
      // use the base sort function as a tie-breaker
      return baseSort(a, b);
    } else {
      return aKeyIndex < bKeyIndex ? aFirst : bFirst;
    }
  } else {
    return aRank > bRank ? aFirst : bFirst;
  }
}
/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */


function prepareValueForComparison(value, _ref4) {
  var keepDiacritics = _ref4.keepDiacritics;
  // value might not actually be a string at this point (we don't get to choose)
  // so part of preparing the value for comparison is ensure that it is a string
  value = "" + value; // toString

  if (!keepDiacritics) {
    value = remove_accents_default()(value);
  }

  return value;
}
/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */


function getItemValues(item, key) {
  if (typeof key === 'object') {
    key = key.key;
  }

  var value;

  if (typeof key === 'function') {
    value = key(item);
  } else if (item == null) {
    value = null;
  } else if (Object.hasOwnProperty.call(item, key)) {
    value = item[key];
  } else if (key.includes('.')) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return getNestedValues(key, item);
  } else {
    value = null;
  } // because `value` can also be undefined


  if (value == null) {
    return [];
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [String(value)];
}
/**
 * Given path: "foo.bar.baz"
 * And item: {foo: {bar: {baz: 'buzz'}}}
 *   -> 'buzz'
 * @param path a dot-separated set of keys
 * @param item the item to get the value from
 */


function getNestedValues(path, item) {
  var keys = path.split('.');
  var values = [item];

  for (var i = 0, I = keys.length; i < I; i++) {
    var nestedKey = keys[i];
    var nestedValues = [];

    for (var j = 0, J = values.length; j < J; j++) {
      var nestedItem = values[j];
      if (nestedItem == null) continue;

      if (Object.hasOwnProperty.call(nestedItem, nestedKey)) {
        var nestedValue = nestedItem[nestedKey];

        if (nestedValue != null) {
          nestedValues.push(nestedValue);
        }
      } else if (nestedKey === '*') {
        // ensure that values is an array
        nestedValues = nestedValues.concat(nestedItem);
      }
    }

    values = nestedValues;
  }

  if (Array.isArray(values[0])) {
    // keep allowing the implicit wildcard for an array of strings at the end of
    // the path; don't use `.flat()` because that's not available in node.js v10
    var result = [];
    return result.concat.apply(result, values);
  } // Based on our logic it should be an array of strings by now...
  // assuming the user's path terminated in strings


  return values;
}
/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param item - the item from which the values will be retrieved
 * @param keys - the keys to use to retrieve the values
 * @return objects with {itemValue, attributes}
 */


function getAllValuesToRank(item, keys) {
  var allValues = [];

  for (var j = 0, J = keys.length; j < J; j++) {
    var key = keys[j];
    var attributes = getKeyAttributes(key);
    var itemValues = getItemValues(item, key);

    for (var i = 0, I = itemValues.length; i < I; i++) {
      allValues.push({
        itemValue: itemValues[i],
        attributes: attributes
      });
    }
  }

  return allValues;
}

var defaultKeyAttributes = {
  maxRanking: Infinity,
  minRanking: -Infinity
};
/**
 * Gets all the attributes for the given key
 * @param key - the key from which the attributes will be retrieved
 * @return object containing the key's attributes
 */

function getKeyAttributes(key) {
  if (typeof key === 'string') {
    return defaultKeyAttributes;
  }

  return (0,esm_extends/* default */.Z)({}, defaultKeyAttributes, key);
}
/*
eslint
  no-continue: "off",
*/



;// CONCATENATED MODULE: ../../node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var emotion_sheet_browser_esm_StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        before = _this.prepend ? _this.container.firstChild : _this.before;
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ../../node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} value
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var Tokenizer_position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string} type
 * @param {string[]} props
 * @param {object[]} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {string} value
 * @param {object} root
 * @param {string} type
 */
function copy (value, root, type) {
	return node(value, root.root, root.parent, type, root.props, root.children, 0)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = Tokenizer_position > 0 ? Utility_charat(characters, --Tokenizer_position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = Tokenizer_position < Tokenizer_length ? Utility_charat(characters, Tokenizer_position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, Tokenizer_position)
}

/**
 * @return {number}
 */
function caret () {
	return Tokenizer_position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), Tokenizer_position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(Tokenizer_position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(Tokenizer_position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return Tokenizer_position
			// " '
			case 34: case 39:
				return delimiter(type === 34 || type === 39 ? type : character)
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return Tokenizer_position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, Tokenizer_position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, Tokenizer_position)
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Enum.js
var MS = '-ms-'
var MOZ = '-moz-'
var WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Prefixer.js



/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix (value, length) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (Utility_strlen(value) - 1 - length > 6)
				switch (Utility_charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (Utility_charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (Utility_charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return replace(value, ':', ':' + WEBKIT) + value
				// (inline-)?fl(e)x
				case 101:
					return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (Utility_charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (!element.return)
		switch (element.type) {
			case DECLARATION: element.return = prefix(element.value, element.length)
				break
			case KEYFRAMES:
				return serialize([copy(replace(element.value, '@', '@' + WEBKIT), element, '')], callback)
			case Enum_RULESET:
				if (element.length)
					return Utility_combine(element.props, function (value) {
						switch (match(value, /(::plac\w+|:read-\w+)/)) {
							// :read-(only|write)
							case ':read-only': case ':read-write':
								return serialize([copy(replace(value, /:(read-\w+)/, ':' + MOZ + '$1'), element, '')], callback)
							// :placeholder
							case '::placeholder':
								return serialize([
									copy(replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1'), element, ''),
									copy(replace(value, /:(plac\w+)/, ':' + MOZ + '$1'), element, ''),
									copy(replace(value, /:(plac\w+)/, MS + 'input-$1'), element, '')
								], callback)
						}

						return ''
					})
		}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// " ' [ (
			case 34: case 39: case 91: case 40:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, length, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ../../node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var emotion_cache_browser_esm_last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifier(Tokenizer_position - 1);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // .length indicates if this rule contains pseudo or not
  !element.length) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(emotion_cache_browser_esm_last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new emotion_sheet_browser_esm_StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);

;// CONCATENATED MODULE: ../../node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var emotion_utils_browser_esm_insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/hash/dist/hash.browser.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var hash_browser_esm = (murmur2);

// EXTERNAL MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitless_browser_esm = __webpack_require__(31938);
// EXTERNAL MODULE: ../../node_modules/@emotion/memoize/dist/emotion-memoize.browser.esm.js
var emotion_memoize_browser_esm = __webpack_require__(33343);
;// CONCATENATED MODULE: ../../node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_browser_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_browser_esm/* default */.Z[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var emotion_serialize_browser_esm_serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hash_browser_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/react/dist/emotion-element-99289b21.browser.esm.js








var emotion_element_99289b21_browser_esm_hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */emotion_cache_browser_esm({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var emotion_element_99289b21_browser_esm_withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var emotion_element_99289b21_browser_esm_ThemeContext = /* #__PURE__ */(0,react.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return useContext(emotion_element_99289b21_browser_esm_ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = useContext(emotion_element_99289b21_browser_esm_ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/createElement(emotion_element_99289b21_browser_esm_ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = useContext(emotion_element_99289b21_browser_esm_ThemeContext);
    return /*#__PURE__*/createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_99289b21_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type;

  if (false) { var match, error; }

  return newProps;
};
var Emotion = /* #__PURE__ */emotion_element_99289b21_browser_esm_withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = emotion_serialize_browser_esm_serializeStyles(registeredStyles, undefined, (0,react.useContext)(emotion_element_99289b21_browser_esm_ThemeContext));

  if (false) { var labelFromStack; }

  var rules = emotion_utils_browser_esm_insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_99289b21_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/(0,react.createElement)(type, newProps);

  return ele;
});

if (false) {}



// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
;// CONCATENATED MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js












var pkg = {
	name: "@emotion/react",
	version: "11.4.1",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"isolated-hoist-non-react-statics-do-not-use-this-in-your-code",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.13.10",
		"@emotion/cache": "^11.4.0",
		"@emotion/serialize": "^1.0.2",
		"@emotion/sheet": "^1.0.2",
		"@emotion/utils": "^1.0.0",
		"@emotion/weak-memoize": "^0.2.5",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.13.10",
		"@emotion/css": "11.1.3",
		"@emotion/css-prettifier": "1.0.0",
		"@emotion/server": "11.4.0",
		"@emotion/styled": "11.3.0",
		"@types/react": "^16.9.11",
		dtslint: "^0.3.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./isolated-hoist-non-react-statics-do-not-use-this-in-your-code.js"
		],
		umdName: "emotionReact"
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_99289b21_browser_esm_hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = useRef();
  useLayoutEffect(function () {
    var key = cache.key + "-global";
    var sheet = new StyleSheet({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useLayoutEffect(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
})));

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return emotion_serialize_browser_esm_serializeStyles(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function emotion_react_browser_esm_merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = /* #__PURE__ */emotion_element_99289b21_browser_esm_withEmotionCache(function (props, cache) {
  var hasRendered = false;

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = emotion_serialize_browser_esm_serializeStyles(args, cache.registered);

    {
      emotion_utils_browser_esm_insertStyles(cache, serialized, false);
    }

    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return emotion_react_browser_esm_merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: (0,react.useContext)(emotion_element_99289b21_browser_esm_ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;

  return ele;
});

if (false) {}

if (false) { var globalKey, globalContext, isJest, emotion_react_browser_esm_isBrowser; }



;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/react-input-autosize/lib/AutosizeInput.js
var AutosizeInput = __webpack_require__(18726);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js + 1 modules
var toPropertyKey = __webpack_require__(32802);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,toPropertyKey/* default */.Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && (0,setPrototypeOf/* default */.Z)(t, e);
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
;// CONCATENATED MODULE: ../../node_modules/react-select/dist/index-4bd03571.esm.js













function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function index_4bd03571_esm_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function index_4bd03571_esm_getPrototypeOf(o) {
  index_4bd03571_esm_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return index_4bd03571_esm_getPrototypeOf(o);
}

function index_4bd03571_esm_isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function index_4bd03571_esm_assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return index_4bd03571_esm_assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = index_4bd03571_esm_isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = index_4bd03571_esm_getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = index_4bd03571_esm_getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if ((0,esm_typeof/* default */.Z)(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
      props.clearValue;
      props.cx;
      props.getStyles;
      props.getValue;
      props.hasValue;
      props.isMulti;
      props.isRtl;
      props.options;
      props.selectOption;
      props.selectProps;
      props.setValue;
      props.theme;
      var innerProps = (0,objectWithoutProperties/* default */.Z)(props, ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"]);

  return index_4bd03571_esm_objectSpread2({}, innerProps);
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36

var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }

}; // check for SSR

var w = typeof window !== 'undefined' ? window : {};

if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop, options);
  w.removeEventListener('p', noop, false);
}

var supportsPassiveEvents = passiveOptionAccessed;

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, (0,defineProperty/* default */.Z)(_ref3, alignToControl(placement), '100%'), (0,defineProperty/* default */.Z)(_ref3, "backgroundColor", colors.neutral0), (0,defineProperty/* default */.Z)(_ref3, "borderRadius", borderRadius), (0,defineProperty/* default */.Z)(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), (0,defineProperty/* default */.Z)(_ref3, "marginBottom", spacing.menuGutter), (0,defineProperty/* default */.Z)(_ref3, "marginTop", spacing.menuGutter), (0,defineProperty/* default */.Z)(_ref3, "position", 'absolute'), (0,defineProperty/* default */.Z)(_ref3, "width", '100%'), (0,defineProperty/* default */.Z)(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /*#__PURE__*/(0,react.createContext)({
  getPortalPlacement: null
}); // NOTE: internal only

var MenuPlacer = /*#__PURE__*/function (_Component) {
  _inherits(MenuPlacer, _Component);

  var _super = _createSuper(MenuPlacer);

  function MenuPlacer() {
    var _this;

    _classCallCheck(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };

    _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    };

    _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return index_4bd03571_esm_objectSpread2(index_4bd03571_esm_objectSpread2({}, _this.props), {}, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    };

    return _this;
  }

  _createClass(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(react.Component);
MenuPlacer.contextType = PortalPlacementContext;

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      isMulti = props.isMulti;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /*#__PURE__*/function (_Component2) {
  _inherits(MenuPortal, _Component2);

  var _super2 = _createSuper(MenuPortal);

  function MenuPortal() {
    var _this2;

    _classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };

    _this2.getPortalPlacement = function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    };

    return _this2;
  }

  _createClass(MenuPortal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          className = _this$props2.className,
          controlElement = _this$props2.controlElement,
          cx = _this$props2.cx,
          innerProps = _this$props2.innerProps,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = jsx("div", (0,esm_extends/* default */.Z)({
        css: getStyles('menuPortal', state),
        className: cx({
          'menu-portal': true
        }, className)
      }, innerProps), children);
      return jsx(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /*#__PURE__*/(0,react_dom.createPortal)(menuWrapper, appendTo) : menuWrapper);
    }
  }]);

  return MenuPortal;
}(react.Component);

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      isMulti = props.isMulti,
      getStyles = props.getStyles,
      hasValue = props.hasValue;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      getStyles = props.getStyles;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children);
};

var index_4bd03571_esm_templateObject;

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref2 =  true ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : 0;

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, ["size"]);

  return jsx("svg", (0,esm_extends/* default */.Z)({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }, innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }, innerProps), children || jsx(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("span", (0,esm_extends/* default */.Z)({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes(index_4bd03571_esm_templateObject || (index_4bd03571_esm_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : 0,  true ? "" : 0)
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }, innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var index_4bd03571_esm_css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return jsx("div", (0,esm_extends/* default */.Z)({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      innerProps = props.innerProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, innerProps), jsx(Heading, (0,esm_extends/* default */.Z)({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), jsx("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var getStyles = props.getStyles,
      cx = props.cx,
      className = props.className;

  var _cleanCommonProps = cleanCommonProps(props);
      _cleanCommonProps.data;
      var innerProps = (0,objectWithoutProperties/* default */.Z)(_cleanCommonProps, ["data"]);

  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('groupHeading', props),
    className: cx({
      'group-heading': true
    }, className)
  }, innerProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    label: 'input',
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;

  var _cleanCommonProps = cleanCommonProps(props),
      innerRef = _cleanCommonProps.innerRef,
      isDisabled = _cleanCommonProps.isDisabled,
      isHidden = _cleanCommonProps.isHidden,
      innerProps = (0,objectWithoutProperties/* default */.Z)(_cleanCommonProps, ["innerRef", "isDisabled", "isHidden"]);

  return jsx("div", {
    css: getStyles('input', props)
  }, jsx(AutosizeInput/* default */.Z, (0,esm_extends/* default */.Z)({
    className: cx({
      input: true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
      innerProps = _ref5.innerProps;
  return jsx("div", innerProps, children || jsx(CrossIcon, {
    size: 14
  }));
}

var MultiValue = function MultiValue(props) {
  var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      data = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;
  return jsx(ClassNames, null, function (_ref6) {
    var css = _ref6.css,
        emotionCx = _ref6.cx;
    return jsx(Container, {
      data: data,
      innerProps: index_4bd03571_esm_objectSpread2({
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }, innerProps),
      selectProps: selectProps
    }, jsx(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), jsx(Remove, {
      data: data,
      innerProps: index_4bd03571_esm_objectSpread2({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className))
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

MultiValue.defaultProps = {
  cropWithEllipsis: true
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return index_4bd03571_esm_objectSpread2(index_4bd03571_esm_objectSpread2({}, components), props.components);
};



// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(51171);
// EXTERNAL MODULE: ../../node_modules/memoize-one/dist/memoize-one.esm.js
var memoize_one_esm = __webpack_require__(36631);
;// CONCATENATED MODULE: ../../node_modules/react-select/dist/Select-dbb12e54.esm.js











function Select_dbb12e54_esm_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref =  true ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : 0;

var A11yText = function A11yText(props) {
  return jsx("span", (0,esm_extends/* default */.Z)({
    css: _ref
  }, props));
};

var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
        isMulti = props.isMulti,
        isDisabled = props.isDisabled,
        tabSelectsValue = props.tabSelectsValue,
        context = props.context;

    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");

      case 'input':
        return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';

      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
        _props$label = props.label,
        label = _props$label === void 0 ? '' : _props$label,
        isDisabled = props.isDisabled;

    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");

      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");

      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
        _props$focused = props.focused,
        focused = _props$focused === void 0 ? {} : _props$focused,
        options = props.options,
        _props$label2 = props.label,
        label = _props$label2 === void 0 ? '' : _props$label2,
        selectValue = props.selectValue,
        isDisabled = props.isDisabled,
        isSelected = props.isSelected;

    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };

    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }

    if (context === 'menu') {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }

    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
        resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};

var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
      focusedOption = props.focusedOption,
      focusedValue = props.focusedValue,
      focusableOptions = props.focusableOptions,
      isFocused = props.isFocused,
      selectValue = props.selectValue,
      selectProps = props.selectProps;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
      getOptionLabel = selectProps.getOptionLabel,
      inputValue = selectProps.inputValue,
      isMulti = selectProps.isMulti,
      isOptionDisabled = selectProps.isOptionDisabled,
      isSearchable = selectProps.isSearchable,
      menuIsOpen = selectProps.menuIsOpen,
      options = selectProps.options,
      screenReaderStatus = selectProps.screenReaderStatus,
      tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live']; // Update aria live message configuration when prop changes

  var messages = (0,react.useMemo)(function () {
    return index_4bd03571_esm_objectSpread2(index_4bd03571_esm_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]); // Update aria live selected option when prop changes

  var ariaSelected = (0,react.useMemo)(function () {
    var message = '';

    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
          removedValue = ariaSelection.removedValue,
          value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value

      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      };

      var selected = removedValue || option || asOption(value);

      var onChangeProps = index_4bd03571_esm_objectSpread2({
        isDisabled: selected && isOptionDisabled(selected),
        label: selected ? getOptionLabel(selected) : ''
      }, ariaSelection);

      message = messages.onChange(onChangeProps);
    }

    return message;
  }, [ariaSelection, isOptionDisabled, getOptionLabel, messages]);
  var ariaFocused = (0,react.useMemo)(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));

    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused),
        isSelected: isSelected,
        options: options,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }

    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, options, selectValue]);
  var ariaResults = (0,react.useMemo)(function () {
    var resultsMsg = '';

    if (menuIsOpen && options.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }

    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus]);
  var ariaGuidance = (0,react.useMemo)(function () {
    var guidanceMsg = '';

    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue
      });
    }

    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  return jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && jsx(react.Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext)));
};

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};

for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];

  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}

var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

var memoizedStripDiacriticsForInput = (0,memoize_one_esm/* default */.Z)(stripDiacritics);

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = index_4bd03571_esm_objectSpread2({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

function DummyInput(_ref) {
  _ref.in;
      _ref.out;
      _ref.onExited;
      _ref.appear;
      _ref.enter;
      _ref.exit;
      var innerRef = _ref.innerRef;
      _ref.emotion;
      var props = (0,objectWithoutProperties/* default */.Z)(_ref, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

  return jsx("input", (0,esm_extends/* default */.Z)({
    ref: innerRef
  }, props, {
    css: /*#__PURE__*/css({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      fontSize: 'inherit',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(0)'
    },  true ? "" : 0,  true ? "" : 0)
  }));
}

var cancelScroll = function cancelScroll(event) {
  event.preventDefault();
  event.stopPropagation();
};

function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
      onBottomArrive = _ref.onBottomArrive,
      onBottomLeave = _ref.onBottomLeave,
      onTopArrive = _ref.onTopArrive,
      onTopLeave = _ref.onTopLeave;
  var isBottom = (0,react.useRef)(false);
  var isTop = (0,react.useRef)(false);
  var touchStart = (0,react.useRef)(0);
  var scrollTarget = (0,react.useRef)(null);
  var handleEventDelta = (0,react.useCallback)(function (event, delta) {
    // Reference should never be `null` at this point, but flow complains otherwise
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
        scrollTop = _scrollTarget$current.scrollTop,
        scrollHeight = _scrollTarget$current.scrollHeight,
        clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false; // reset bottom/top flags

    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }

    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    } // bottom limit


    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }

      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true; // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }

      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    } // cancel scroll


    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, []);
  var onWheel = (0,react.useCallback)(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = (0,react.useCallback)(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = (0,react.useCallback)(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = (0,react.useCallback)(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false; // all the if statements are to appease Flow 😢

    if (typeof el.addEventListener === 'function') {
      el.addEventListener('wheel', onWheel, notPassive);
    }

    if (typeof el.addEventListener === 'function') {
      el.addEventListener('touchstart', onTouchStart, notPassive);
    }

    if (typeof el.addEventListener === 'function') {
      el.addEventListener('touchmove', onTouchMove, notPassive);
    }
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = (0,react.useCallback)(function (el) {
    // bail early if no element is available to detach from
    if (!el) return; // all the if statements are to appease Flow 😢

    if (typeof el.removeEventListener === 'function') {
      el.removeEventListener('wheel', onWheel, false);
    }

    if (typeof el.removeEventListener === 'function') {
      el.removeEventListener('touchstart', onTouchStart, false);
    }

    if (typeof el.removeEventListener === 'function') {
      el.removeEventListener('touchmove', onTouchMove, false);
    }
  }, [onTouchMove, onTouchStart, onWheel]);
  (0,react.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface


function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
      _ref$accountForScroll = _ref.accountForScrollbars,
      accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = (0,react.useRef)({});
  var scrollTarget = (0,react.useRef)(null);
  var addScrollLock = (0,react.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    } // apply the lock styles and padding if this is the first scroll lock


    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });

      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    } // account for touch devices


    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions); // Allow scroll on provided target

      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    } // increment active scroll locks


    activeScrollLocks += 1;
  }, []);
  var removeScrollLock = (0,react.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style; // safely decrement active scroll locks

    activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    } // remove touch listeners


    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);

      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, []);
  (0,react.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var blurSelectInput = function blurSelectInput() {
  return document.activeElement && document.activeElement.blur();
};

var Select_dbb12e54_esm_ref2 =  true ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : 0;

function ScrollManager(_ref) {
  var children = _ref.children,
      lockEnabled = _ref.lockEnabled,
      _ref$captureEnabled = _ref.captureEnabled,
      captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
      onBottomArrive = _ref.onBottomArrive,
      onBottomLeave = _ref.onBottomLeave,
      onTopArrive = _ref.onTopArrive,
      onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });

  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };

  return jsx(react.Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: Select_dbb12e54_esm_ref2
  }), children(targetRef));
}

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: index_4bd03571_esm_css,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$1,
  valueContainer: valueContainerCSS
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _objectSpread2({}, source); // massage in target styles


  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var Select_dbb12e54_esm_borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var Select_dbb12e54_esm_defaultTheme = {
  borderRadius: Select_dbb12e54_esm_borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};

function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);

  var isSelected = _isOptionSelected(props, option, selectValue);

  var label = getOptionLabel$1(props, option);
  var value = getOptionValue$1(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}

function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if (groupOrOption.options) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }

    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }) // Flow limitation (see https://github.com/facebook/flow/issues/1414)
  .filter(function (categorizedOption) {
    return !!categorizedOption;
  });
}

function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, (0,toConsumableArray/* default */.Z)(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }

    return optionsAccumulator;
  }, []);
}

function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}

function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
      inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
      isSelected = categorizedOption.isSelected,
      label = categorizedOption.label,
      value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}

function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
      lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }

  return null;
}

function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}

var getOptionLabel$1 = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};

var getOptionValue$1 = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};

function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}

function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;

  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }

  var candidate = getOptionValue$1(props, option);
  return selectValue.some(function (i) {
    return getOptionValue$1(props, i) === candidate;
  });
}

function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}

var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
      isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};

var instanceId = 1;

var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);

  var _super = _createSuper(Select);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;

    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };

    _this.focusedOptionRef = null;

    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };

    _this.menuListRef = null;

    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };

    _this.inputRef = null;

    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };

    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;

    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      actionMeta.name = name;

      _this.ariaOnChange(newValue, actionMeta);

      onChange(newValue, actionMeta);
    };

    _this.setValue = function (newValue) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.setState({
        clearFocusValueOnUpdate: true
      });

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };

    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti,
          name = _this$props3.name;
      var selectValue = _this.state.selectValue;

      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);

      var isDisabled = _this.isOptionDisabled(newValue, selectValue);

      if (deselected) {
        var candidate = _this.getOptionValue(newValue);

        _this.setValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        }), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue([].concat((0,toConsumableArray/* default */.Z)(selectValue), [newValue]), 'select-option', newValue);
        } else {
          _this.setValue(newValue, 'select-option');
        }
      } else {
        _this.ariaOnChange(newValue, {
          action: 'select-option',
          name: name
        });

        return;
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };

    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = isMulti ? newValueArray : newValueArray[0] || null;

      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.focusInput();
    };

    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;

      _this.onChange(_this.props.isMulti ? [] : null, {
        action: 'clear',
        removedValues: selectValue
      });
    };

    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = isMulti ? newValueArray : newValueArray[0] || null;

      _this.onChange(newValue, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };

    _this.getValue = function () {
      return _this.state.selectValue;
    };

    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };

    _this.getOptionLabel = function (data) {
      return getOptionLabel$1(_this.props, data);
    };

    _this.getOptionValue = function (data) {
      return getOptionValue$1(_this.props, data);
    };

    _this.getStyles = function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };

    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };

    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };

    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };

    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };

    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };

    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };

    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: index_4bd03571_esm_objectSpread2({
          value: value
        }, actionMeta)
      });
    };

    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    };

    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };

    _this.onControlMouseDown = function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if ( // $FlowFixMe
        event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }

      if ( // $FlowFixMe
      event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };

    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    };

    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };

    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };

    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };

    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };

    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };

    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };

    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };

    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    };

    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    };

    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    };

    _this.handleInputChange = function (event) {
      var inputValue = event.currentTarget.value;

      _this.setState({
        inputIsHiddenAfterUpdate: false
      });

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };

    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    };

    _this.onInputBlur = function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };

    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    };

    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };

    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
          isMulti = _this$props5.isMulti,
          backspaceRemovesValue = _this$props5.backspaceRemovesValue,
          escapeClearsValue = _this$props5.escapeClearsValue,
          inputValue = _this$props5.inputValue,
          isClearable = _this$props5.isClearable,
          isDisabled = _this$props5.isDisabled,
          menuIsOpen = _this$props5.menuIsOpen,
          onKeyDown = _this$props5.onKeyDown,
          tabSelectsValue = _this$props5.tabSelectsValue,
          openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
          focusedOption = _this$state.focusedOption,
          focusedValue = _this$state.focusedValue,
          selectValue = _this$state.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    };

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
          isDisabled = _this$props6.isDisabled,
          menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programatically disabled while focused
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    } // ==============================
    // Consumer Handlers
    // ==============================

  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;

      var _this$state2 = this.state,
          selectValue = _this$state2.selectValue,
          isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;

      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
          selectValue = _this$state3.selectValue,
          focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing

      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value: // ==============================
    // Getters
    // ==============================
    function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return Select_dbb12e54_esm_defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(Select_dbb12e54_esm_defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return index_4bd03571_esm_objectSpread2(index_4bd03571_esm_objectSpread2({}, Select_dbb12e54_esm_defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          cx = this.cx,
          getStyles = this.getStyles,
          getValue = this.getValue,
          selectOption = this.selectOption,
          setValue = this.setValue,
          props = this.props;
      var isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
          isClearable = _this$props7.isClearable,
          isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    value: // ==============================
    // Composition Handlers
    // ==============================
    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: // ==============================
    // Touch Handlers
    // ==============================
    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
          isDisabled = _this$props8.isDisabled,
          isSearchable = _this$props8.isSearchable,
          inputId = _this$props8.inputId,
          inputValue = _this$props8.inputValue,
          tabIndex = _this$props8.tabIndex,
          form = _this$props8.form;

      var _this$getComponents = this.getComponents(),
          Input = _this$getComponents.Input;

      var inputIsHidden = this.state.inputIsHidden;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/react.createElement(DummyInput, (0,esm_extends/* default */.Z)({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          form: form,
          value: ""
        }, ariaAttributes));
      }

      return /*#__PURE__*/react.createElement(Input, (0,esm_extends/* default */.Z)({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;

      var _this$getComponents2 = this.getComponents(),
          MultiValue = _this$getComponents2.MultiValue,
          MultiValueContainer = _this$getComponents2.MultiValueContainer,
          MultiValueLabel = _this$getComponents2.MultiValueLabel,
          MultiValueRemove = _this$getComponents2.MultiValueRemove,
          SingleValue = _this$getComponents2.SingleValue,
          Placeholder = _this$getComponents2.Placeholder;

      var commonProps = this.commonProps;
      var _this$props9 = this.props,
          controlShouldRenderValue = _this$props9.controlShouldRenderValue,
          isDisabled = _this$props9.isDisabled,
          isMulti = _this$props9.isMulti,
          inputValue = _this$props9.inputValue,
          placeholder = _this$props9.placeholder;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue,
          isFocused = _this$state4.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/react.createElement(Placeholder, (0,esm_extends/* default */.Z)({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          return /*#__PURE__*/react.createElement(MultiValue, (0,esm_extends/* default */.Z)({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: "".concat(_this3.getOptionValue(opt)).concat(index),
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return /*#__PURE__*/react.createElement(SingleValue, (0,esm_extends/* default */.Z)({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
          ClearIndicator = _this$getComponents3.ClearIndicator;

      var commonProps = this.commonProps;
      var _this$props10 = this.props,
          isDisabled = _this$props10.isDisabled,
          isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(ClearIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
          LoadingIndicator = _this$getComponents4.LoadingIndicator;

      var commonProps = this.commonProps;
      var _this$props11 = this.props,
          isDisabled = _this$props11.isDisabled,
          isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(LoadingIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
          DropdownIndicator = _this$getComponents5.DropdownIndicator,
          IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator


      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/react.createElement(IndicatorSeparator, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
          DropdownIndicator = _this$getComponents6.DropdownIndicator;

      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(DropdownIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;

      var _this$getComponents7 = this.getComponents(),
          Group = _this$getComponents7.Group,
          GroupHeading = _this$getComponents7.GroupHeading,
          Menu = _this$getComponents7.Menu,
          MenuList = _this$getComponents7.MenuList,
          MenuPortal = _this$getComponents7.MenuPortal,
          LoadingMessage = _this$getComponents7.LoadingMessage,
          NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
          Option = _this$getComponents7.Option;

      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
          captureMenuScroll = _this$props12.captureMenuScroll,
          inputValue = _this$props12.inputValue,
          isLoading = _this$props12.isLoading,
          loadingMessage = _this$props12.loadingMessage,
          minMenuHeight = _this$props12.minMenuHeight,
          maxMenuHeight = _this$props12.maxMenuHeight,
          menuIsOpen = _this$props12.menuIsOpen,
          menuPlacement = _this$props12.menuPlacement,
          menuPosition = _this$props12.menuPosition,
          menuPortalTarget = _this$props12.menuPortalTarget,
          menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
          noOptionsMessage = _this$props12.noOptionsMessage,
          onMenuScrollToTop = _this$props12.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props, id) {
        var type = props.type,
            data = props.data,
            isDisabled = props.isDisabled,
            isSelected = props.isSelected,
            label = props.label,
            value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /*#__PURE__*/react.createElement(Option, (0,esm_extends/* default */.Z)({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var data = item.data,
                options = item.options,
                groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/react.createElement(Group, (0,esm_extends/* default */.Z)({}, commonProps, {
              key: groupId,
              data: data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/react.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = /*#__PURE__*/react.createElement(NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/react.createElement(MenuPlacer, (0,esm_extends/* default */.Z)({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
            _ref4$placerProps = _ref4.placerProps,
            placement = _ref4$placerProps.placement,
            maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/react.createElement(Menu, (0,esm_extends/* default */.Z)({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/react.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/react.createElement(MenuList, (0,esm_extends/* default */.Z)({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);

              scrollTargetRef(instance);
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/react.createElement(MenuPortal, (0,esm_extends/* default */.Z)({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;

      var _this$props13 = this.props,
          delimiter = _this$props13.delimiter,
          isDisabled = _this$props13.isDisabled,
          isMulti = _this$props13.isMulti,
          name = _this$props13.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/react.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/react.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/react.createElement("input", {
            name: name,
            type: "hidden"
          });
          return /*#__PURE__*/react.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return /*#__PURE__*/react.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state5 = this.state,
          ariaSelection = _this$state5.ariaSelection,
          focusedOption = _this$state5.focusedOption,
          focusedValue = _this$state5.focusedValue,
          isFocused = _this$state5.isFocused,
          selectValue = _this$state5.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/react.createElement(LiveRegion, (0,esm_extends/* default */.Z)({}, commonProps, {
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
          Control = _this$getComponents8.Control,
          IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
          SelectContainer = _this$getComponents8.SelectContainer,
          ValueContainer = _this$getComponents8.ValueContainer;

      var _this$props14 = this.props,
          className = _this$props14.className,
          id = _this$props14.id,
          isDisabled = _this$props14.isDisabled,
          menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/react.createElement(SelectContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/react.createElement(Control, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/react.createElement(ValueContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/react.createElement(IndicatorsContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
          clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
          inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate;
      var options = props.options,
          value = props.value,
          menuIsOpen = props.menuIsOpen,
          inputValue = props.inputValue;
      var newMenuOptionsState = {};

      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var selectValue = cleanValue(value);
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      } // some updates should toggle the state of the input visibility


      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      return index_4bd03571_esm_objectSpread2(index_4bd03571_esm_objectSpread2(index_4bd03571_esm_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props
      });
    }
  }]);

  return Select;
}(react.Component);

Select.defaultProps = defaultProps;



;// CONCATENATED MODULE: ../../node_modules/react-select/dist/stateManager-845a3300.esm.js








var stateManager_845a3300_esm_defaultProps = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(StateManager, _Component);

    var _super = _createSuper(StateManager);

    function StateManager() {
      var _this;

      _classCallCheck(this, StateManager);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.select = void 0;
      _this.state = {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      };

      _this.onChange = function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      };

      _this.onInputChange = function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      };

      _this.onMenuOpen = function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      };

      _this.onMenuClose = function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      };

      return _this;
    }

    _createClass(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any

    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any

    }, {
      key: "callProp",
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props;
            _this$props2.defaultInputValue;
            _this$props2.defaultMenuIsOpen;
            _this$props2.defaultValue;
            var props = (0,objectWithoutProperties/* default */.Z)(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return /*#__PURE__*/react.createElement(SelectComponent, (0,esm_extends/* default */.Z)({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(react.Component), _class.defaultProps = stateManager_845a3300_esm_defaultProps, _temp;
};



;// CONCATENATED MODULE: ../../node_modules/react-select/dist/react-select.esm.js





















var NonceProvider = /*#__PURE__*/function (_Component) {
  _inherits(NonceProvider, _Component);

  var _super = _createSuper(NonceProvider);

  function NonceProvider(props) {
    var _this;

    _classCallCheck(this, NonceProvider);

    _this = _super.call(this, props);

    _this.createEmotionCache = function (nonce, key) {
      return emotion_cache_browser_esm({
        nonce: nonce,
        key: key
      });
    };

    _this.createEmotionCache = (0,memoize_one_esm/* default */.Z)(_this.createEmotionCache);
    return _this;
  }

  _createClass(NonceProvider, [{
    key: "render",
    value: function render() {
      var emotionCache = this.createEmotionCache(this.props.nonce, this.props.cacheKey);
      return /*#__PURE__*/react.createElement(CacheProvider, {
        value: emotionCache
      }, this.props.children);
    }
  }]);

  return NonceProvider;
}(react.Component);

var index = manageState(Select);

/* harmony default export */ var react_select_esm = (index);


;// CONCATENATED MODULE: ../../node_modules/react-select/creatable/dist/react-select.esm.js


















var compareOption = function compareOption() {
  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var option = arguments.length > 1 ? arguments[1] : undefined;
  var accessors = arguments.length > 2 ? arguments[2] : undefined;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return "Create \"".concat(inputValue, "\"");
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  },
  getOptionValue: getOptionValue,
  getOptionLabel: getOptionLabel
};
var react_select_esm_defaultProps = index_4bd03571_esm_objectSpread2({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);
var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(Creatable, _Component);

    var _super = _createSuper(Creatable);

    function Creatable(props) {
      var _this;

      _classCallCheck(this, Creatable);

      _this = _super.call(this, props);
      _this.select = void 0;

      _this.onChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value,
            name = _this$props.name;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }

        var newOption = _this.state.newOption;
        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = {
              action: 'create-option',
              name: name,
              option: newOptionData
            };

            if (isMulti) {
              onChange([].concat((0,toConsumableArray/* default */.Z)(cleanValue(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }

        onChange(newValue, actionMeta);
      };

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    _createClass(Creatable, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var options = this.state.options;
        return /*#__PURE__*/react.createElement(SelectComponent, (0,esm_extends/* default */.Z)({}, this.props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          options: options,
          onChange: this.onChange
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props, state) {
        var allowCreateWhileLoading = props.allowCreateWhileLoading,
            createOptionPosition = props.createOptionPosition,
            formatCreateLabel = props.formatCreateLabel,
            getNewOptionData = props.getNewOptionData,
            inputValue = props.inputValue,
            isLoading = props.isLoading,
            isValidNewOption = props.isValidNewOption,
            value = props.value,
            getOptionValue = props.getOptionValue,
            getOptionLabel = props.getOptionLabel;
        var options = props.options || [];
        var newOption = state.newOption;

        if (isValidNewOption(inputValue, cleanValue(value), options, {
          getOptionValue: getOptionValue,
          getOptionLabel: getOptionLabel
        })) {
          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
        } else {
          newOption = undefined;
        }

        return {
          newOption: newOption,
          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat((0,toConsumableArray/* default */.Z)(options)) : [].concat((0,toConsumableArray/* default */.Z)(options), [newOption]) : options
        };
      }
    }]);

    return Creatable;
  }(react.Component), _class.defaultProps = react_select_esm_defaultProps, _temp;
}; // TODO: do this in package entrypoint

var SelectCreatable = makeCreatableSelect(Select);
var Creatable = manageState(SelectCreatable);

/* harmony default export */ var dist_react_select_esm = (Creatable);


;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseSelect/BaseSelect.constants.js



// Constants.
// -----------------------------------------------------------------------------
const BASE_SELECT_DEFAULT_MATCH_ORDER = false;
// styles.
const BASE_SELECT_DEFAULT_MODE = 'light';
const BASE_SELECT_DEFAULT_SIZE = 's';
const BaseSelect_constants_BASE_SELECT_DEFAULT_ROLE = 'none';
const MAPPING_MODE = {
    // Dark.
    dark: {
        clearIndicator: {
            borderRight: (tokens_default()).colors.midnight[700].value,
            color: (tokens_default()).colors.midnight[300].value
        },
        control: {
            background: (tokens_default()).colors.black[100].value,
            border: (tokens_default()).colors.midnight[700].value,
            color: (tokens_default()).colors.midnight[200].value,
            focus: {
                border: (tokens_default()).colors.midnight[200].value,
                shadow: (tokens_default()).colors.midnight[150].value
            },
            hover: {
                border: (tokens_default()).colors.midnight[500].value
            }
        },
        menu: {
            border: (tokens_default()).colors.midnight[700].value
        },
        multi: {
            remove: {
                color: (tokens_default()).colors.midnight[300].value,
                hoverColor: (tokens_default()).colors.midnight[300].value
            },
            value: {
                background: (tokens_default()).colors.midnight[300].value,
                border: (tokens_default()).colors.midnight[300].value
            }
        },
        option: {
            focus: {
                background: (tokens_default()).colors.midnight[300].value
            },
            selected: {
                background: '#00ccaa',
                color: (tokens_default()).colors.navy[800].value
            }
        },
        placeholder: (tokens_default()).colors.midnight[300].value
    },
    // Light.
    light: {
        clearIndicator: {
            borderRight: (tokens_default()).colors.midnight[200].value,
            color: (tokens_default()).colors.midnight[800].value
        },
        control: {
            background: (tokens_default()).colors.white[100].value,
            border: (tokens_default()).colors.midnight[200].value,
            color: (tokens_default()).colors.midnight[800].value,
            focus: {
                border: (tokens_default()).colors.midnight[850].value,
                shadow: (tokens_default()).colors.midnight[150].value
            },
            hover: {
                border: (tokens_default()).colors.midnight[400].value
            }
        },
        menu: {
            border: (tokens_default()).colors.midnight[200].value
        },
        multi: {
            remove: {
                color: (tokens_default()).colors.black[100].value,
                hoverColor: (tokens_default()).colors.midnight[800].value
            },
            value: {
                background: (tokens_default()).colors.white[100].value,
                border: (tokens_default()).colors.midnight[200].value
            }
        },
        option: {
            focus: {
                background: (tokens_default()).colors.midnight[150].value
            },
            selected: {
                background: '#00ccaa',
                color: (tokens_default()).colors.navy[800].value
            }
        },
        placeholder: (tokens_default()).colors.midnight[300].value
    }
};
const MAPPING_SCALE = {
    // 's'.
    s: {
        control: {
            fontSize: getFontSize('s'),
            minHeight: '3.5rem'
        },
        dropdownIndicator: {
            paddingBottom: getSpace('2xl'),
            paddingLeft: getSpace('s'),
            paddingRight: getSpace('2xl'),
            paddingTop: getSpace('m')
        },
        multiLabel: {
            paddingBottom: getSpace('s'),
            paddingLeft: getSpace('l'),
            paddingRight: getSpace('s'),
            paddingTop: getSpace('s')
        },
        value: {
            paddingLeft: '1.25rem'
        }
    },
    // 'xs'.
    xs: {
        control: {
            fontSize: getFontSize('s'),
            minHeight: '2.5rem'
        },
        dropdownIndicator: {
            paddingBottom: getSpace('m'),
            paddingLeft: getSpace('s'),
            paddingRight: getSpace('2xl'),
            paddingTop: getSpace('m')
        },
        multiLabel: {
            paddingBottom: getSpace('xs'),
            paddingLeft: getSpace('s'),
            paddingRight: getSpace('s'),
            paddingTop: getSpace('xs')
        },
        value: {
            paddingLeft: getSpace('m')
        }
    }
};
//# sourceMappingURL=BaseSelect.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseSelect/BaseSelect.styled.js





// Styled-components.
// -----------------------------------------------------------------------------
const BaseSelectWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ mode: modeProps, scale: scaleProps, theme }) => {
    const mode = MAPPING_MODE[modeProps];
    const scale = MAPPING_SCALE[scaleProps];
    return styled_components_browser_esm/* css */.iv `
      .mf-select {
        /* Typing... */
        &__control {
          background-color: ${mode.control.background};
          border-radius: ${getRadius('m')};
          min-height: ${scale.control.minHeight};
          transition: 0.3s;

          /* Color */
          border: 2px solid ${mode.control.border};
          color: ${mode.control.border};

          /** Font */
          font-family: ${theme.typography.fontFamily};
          font-size: ${scale.control.fontSize};
          font-weight: ${getFontWeight('medium')};

          &:hover {
            border-color: ${mode.control.hover.border};
          }

          &--is-focused {
            outline: 0;
            border-color: ${mode.control.focus.border};
            box-shadow: 0 0 0 4px ${mode.control.focus.shadow};
          }
        }

        &__placeholder {
          color: ${mode.placeholder};
        }

        &__value-container {
          padding-left: ${scale.value.paddingLeft};
          padding-right: 0;
        }

        /* Arrow options */
        &__indicator-separator {
          display: none;
        }

        &__dropdown-indicator {
          background-image: url("data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.538289 0.730988H7.46171C7.94067 0.730988 8.18015 1.30951 7.84111 1.64855L4.38075 5.11161C4.17087 5.32149 3.82913 5.32149 3.61925 5.11161L0.158886 1.64855C-0.180154 1.30951 0.0593268 0.730988 0.538289 0.730988Z' fill='%23353241'/%3E%3C/svg%3E%0A");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 0.65em auto;

          padding-bottom: ${scale.dropdownIndicator.paddingBottom};
          padding-left: ${scale.dropdownIndicator.paddingLeft};
          padding-right: ${scale.dropdownIndicator.paddingRight};
          padding-top: ${scale.dropdownIndicator.paddingTop};

          svg {
            display: none;
          }
        }

        &__control--menu-is-open .mf-select__dropdown-indicator {
          transform: rotate(180deg);
        }

        &__clear-indicator {
          border-right: 1px solid ${mode.clearIndicator.borderRight};
          color: ${mode.clearIndicator.color};
          margin-right: 0;
          padding: ${getSpace('xs')} ${getSpace('s')};

          svg {
            width: ${getSpace('l')};
            height: ${getSpace('l')};
          }
        }

        &__menu {
          border: 2px solid ${mode.menu.border};
          border-radius: ${getRadius('m')};
          box-shadow: ${(tokens_default()).shadows.light.xl.value};
          margin-top: ${getSpace('xs')};
          overflow: hidden;
          z-index: 2;

          .cs-limit-reached {
            padding: ${getSpace('l')};
          }
        }

        &__menu-list {
          padding-bottom: 0;
          padding-top: 0;
        }

        &__option {
          font-size: ${getFontSize('s')};
          font-weight: ${getFontWeight('medium')};
          padding: 20px;

          &--is-focused {
            background-color: ${mode.option.focus.background};
          }

          &--is-selected {
            background-color: ${mode.option.selected.background};
            color: ${mode.option.selected.color};
            font-weight: ${getFontWeight('black')};
          }
        }

        &__single-value,
        &__multi-value {
          margin-left: 0;
          margin-right: ${getSpace('xs')};
        }

        .multi-value-separator {
          display: inline-block;
          margin: 0 ${getSpace('xs')};
        }

        &__multi-value {
          background-color: ${mode.multi.value.background};
          border: 2px solid ${mode.multi.value.border};
          border-radius: 100px;

          &__label {
            padding-bottom: ${scale.multiLabel.paddingBottom};
            padding-left: ${scale.multiLabel.paddingLeft};
            padding-right: ${scale.multiLabel.paddingRight};
            padding-top: ${scale.multiLabel.paddingTop};

            font-size: ${getFontSize('s')};
            font-weight: ${getFontWeight('medium')};
            line-height: 1;
          }

          &__remove {
            padding-right: ${getSpace('s')};
            color: ${mode.multi.remove.color};

            &:hover {
              background: transparent;
              color: ${mode.multi.remove.hoverColor};
            }
          }
        }
      }

      .error {
        .mf-select__control {
          background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0C3.58065 0 0 3.58065 0 8C0 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8C16 3.58065 12.4194 0 8 0ZM11.9226 10.1C12.0742 10.2516 12.0742 10.4968 11.9226 10.6484L10.6452 11.9226C10.4935 12.0742 10.2484 12.0742 10.0968 11.9226L8 9.80645L5.9 11.9226C5.74839 12.0742 5.50323 12.0742 5.35161 11.9226L4.07742 10.6452C3.92581 10.4935 3.92581 10.2484 4.07742 10.0968L6.19355 8L4.07742 5.9C3.92581 5.74839 3.92581 5.50323 4.07742 5.35161L5.35484 4.07419C5.50645 3.92258 5.75161 3.92258 5.90323 4.07419L8 6.19355L10.1 4.07742C10.2516 3.92581 10.4968 3.92581 10.6484 4.07742L11.9258 5.35484C12.0774 5.50645 12.0774 5.75161 11.9258 5.90323L9.80645 8L11.9226 10.1Z' fill='%23DE492B'/%3E%3C/svg%3E%0A");
          background-repeat: no-repeat;
          background-position: right ${getSpace('l')} top 50%;
          border-color: ${(tokens_default()).colors.red[700].value};
          padding-right: 3rem;
        }
      }

      .success {
        .mf-select__control {
          background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 8C16 12.4183 12.4183 16 8 16C3.58171 16 0 12.4183 0 8C0 3.58171 3.58171 0 8 0C12.4183 0 16 3.58171 16 8ZM7.07464 12.2359L13.0101 6.30045C13.2117 6.0989 13.2117 5.7721 13.0101 5.57055L12.2802 4.84064C12.0787 4.63906 11.7519 4.63906 11.5503 4.84064L6.70968 9.68123L4.44971 7.42126C4.24816 7.21971 3.92135 7.21971 3.71977 7.42126L2.98987 8.15116C2.78832 8.35271 2.78832 8.67952 2.98987 8.88106L6.34471 12.2359C6.54629 12.4375 6.87306 12.4375 7.07464 12.2359Z' fill='%2378D549'/%3E%3C/svg%3E%0A");
          background-repeat: no-repeat;
          background-position: right ${getSpace('l')} top 50%;
          padding-right: 3rem;
        }
      }
    `;
}}
`;
//# sourceMappingURL=BaseSelect.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/common/BaseSelect/BaseSelect.js







// Component.
// -----------------------------------------------------------------------------
const BaseSelect = (0,react.forwardRef)(({ disabled, mode, multi, name, useMatchSorter = BASE_SELECT_DEFAULT_MATCH_ORDER, noOptionsMessage, onChange, options, placeholder, size, isClearable = true, isCreatable = false, hideDropdownUntilSearch = false, formatCreateLabel, ...rest }) => {
    const [currentOptions, setCurrentOptions] = (0,react.useState)(options);
    const [menuIsOpen, setMenuIsOpen] = (0,react.useState)(false);
    const handleOnInputChange = (newValue) => {
        if (hideDropdownUntilSearch) {
            setMenuIsOpen(newValue.length > 0);
        }
    };
    (0,react.useEffect)(() => {
        if (options && useMatchSorter) {
            setCurrentOptions(options);
        }
    }, [options, useMatchSorter]);
    return ((0,jsx_runtime.jsx)(BaseSelectWrapper, { mode: mode, scale: size, children: isCreatable ? ((0,jsx_runtime.jsx)(dist_react_select_esm, { "aria-label": name, classNamePrefix: "mf-select", menuPosition: "absolute", id: name, isDisabled: disabled, isMulti: multi, isClearable: isClearable, mode: mode, name: name, formatCreateLabel: formatCreateLabel, menuIsOpen: hideDropdownUntilSearch ? menuIsOpen : undefined, onInputChange: (inputValue) => {
                handleOnInputChange(inputValue);
                if (useMatchSorter) {
                    setCurrentOptions(matchSorter(options, inputValue, { keys: ['label'] }));
                }
            }, noOptionsMessage: () => noOptionsMessage, onChange: (options) => {
                onChange(options);
            }, options: useMatchSorter ? currentOptions : options, placeholder: placeholder, scale: size, ...rest })) : ((0,jsx_runtime.jsx)(react_select_esm, { "aria-label": name, classNamePrefix: "mf-select", menuPosition: "absolute", id: name, isDisabled: disabled, isMulti: multi, isClearable: isClearable, mode: mode, name: name, menuIsOpen: hideDropdownUntilSearch ? menuIsOpen : undefined, onInputChange: (inputValue) => {
                handleOnInputChange(inputValue);
                if (useMatchSorter) {
                    setCurrentOptions(matchSorter(options, inputValue, { keys: ['label'] }));
                }
            }, noOptionsMessage: () => noOptionsMessage, onChange: (options) => {
                onChange(options);
            }, options: useMatchSorter ? currentOptions : options, placeholder: placeholder, scale: size, ...rest })) }));
});
// Component configuration.
// -----------------------------------------------------------------------------
BaseSelect.displayName = 'BaseSelect';
/* harmony default export */ var BaseSelect_BaseSelect = (BaseSelect);
//# sourceMappingURL=BaseSelect.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Select/Select.constants.js

// Constants.
// -----------------------------------------------------------------------------
/** Default disabled value. */
const SELECT_DEFAULT_DISABLED = false;
/** Default mode. */
const SELECT_DEFAULT_MODE = BASE_SELECT_DEFAULT_MODE;
/** Default placeholder. */
const SELECT_DEFAULT_PLACEHOLDER = '';
/** Default size. */
const SELECT_DEFAULT_SIZE = BASE_SELECT_DEFAULT_SIZE;
/** Default role. */
const Select_constants_TEXT_FIELD_DEFAULT_ROLE = (/* unused pure expression or super */ null && (BASE_SELECT_DEFAULT_ROLE));
//# sourceMappingURL=Select.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Select/Select.js






// Component.
// -----------------------------------------------------------------------------
const Select_Select = withFormGroup(({ disabled = SELECT_DEFAULT_DISABLED, mode = SELECT_DEFAULT_MODE, name, onChange, options, role = BaseSelect_constants_BASE_SELECT_DEFAULT_ROLE, placeholder = SELECT_DEFAULT_PLACEHOLDER, size = SELECT_DEFAULT_SIZE, isClearable = true, isCreatable = false, formatCreateLabel, inputRef, ...rest }) => ((0,jsx_runtime.jsx)(BaseSelect_BaseSelect, { ...(role && { className: role }), disabled: disabled, mode: mode, multi: false, name: name, onChange: (options) => {
        // Even though in typescript we are typing it as an array at runtime
        // react-select as it is a single element that can be selected what it
        // is doing is returning the element so we have to do this trick to
        // make TypeScript happy.
        if (Array.isArray(options)) {
            onChange(options[0]);
        }
        else {
            onChange(options);
        }
    }, options: options, placeholder: placeholder, size: size, ref: inputRef, isClearable: isClearable, isCreatable: isCreatable, formatCreateLabel: formatCreateLabel, ...rest })));
// Component configuration.
// -----------------------------------------------------------------------------
Select_Select.displayName = 'Select';
const SelectWithFormGroup = react.forwardRef((props, ref) => {
    return (0,jsx_runtime.jsx)(Select_Select, { ...props, inputRef: ref });
});
SelectWithFormGroup.displayName = 'SelectWithFormGroup';
/* harmony default export */ var Molecules_Select_Select = (SelectWithFormGroup);
//# sourceMappingURL=Select.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/SelectMulti/SelectMulti.constants.js

// Constants.
// -----------------------------------------------------------------------------
/** Default disabled value. */
const SELECT_MULTI_DEFAULT_DISABLED = false;
/** Default match order. */
const SELECT_MULTI_DEFAULT_MATCH_ORDER = false;
/** Default mode. */
const SELECT_MULTI_DEFAULT_MODE = BASE_SELECT_DEFAULT_MODE;
/** Default placeholder. */
const SELECT_MULTI_DEFAULT_PLACEHOLDER = '';
/** Default size. */
const SELECT_MULTI_DEFAULT_SIZE = BASE_SELECT_DEFAULT_SIZE;
//# sourceMappingURL=SelectMulti.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/SelectMulti/SelectMulti.js






// Component.
// -----------------------------------------------------------------------------
const SelectMulti = withFormGroup(({ disabled = SELECT_MULTI_DEFAULT_DISABLED, useMatchSorter = SELECT_MULTI_DEFAULT_MATCH_ORDER, mode = SELECT_MULTI_DEFAULT_MODE, name, onChange, options, role = BaseSelect_constants_BASE_SELECT_DEFAULT_ROLE, placeholder = SELECT_MULTI_DEFAULT_PLACEHOLDER, size = SELECT_MULTI_DEFAULT_SIZE, isCreatable = false, formatCreateLabel, isClearable = true, inputRef, hideDropdownUntilSearch = false, ...rest }) => {
    return ((0,jsx_runtime.jsx)(BaseSelect_BaseSelect, { ...(role && { className: role }), disabled: disabled, useMatchSorter: useMatchSorter, mode: mode, multi: true, name: name, onChange: onChange, options: options, placeholder: placeholder, size: size, ref: inputRef, isClearable: isClearable, isCreatable: isCreatable, formatCreateLabel: formatCreateLabel, hideDropdownUntilSearch: hideDropdownUntilSearch, ...rest }));
});
// Component configuration.
// -----------------------------------------------------------------------------
SelectMulti.displayName = 'SelectMulti';
const SelectMultiWithFormGroup = react.forwardRef((props, ref) => {
    return (0,jsx_runtime.jsx)(SelectMulti, { ...props, inputRef: ref });
});
SelectMultiWithFormGroup.displayName = 'SelectMultiWithFormGroup';
/* harmony default export */ var SelectMulti_SelectMulti = (SelectMultiWithFormGroup);
//# sourceMappingURL=SelectMulti.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/SpinnerBadge/SpinnerBadge.constants.js
const SPINNER_BADGE_DEFAULT_ICON_LOADING_TITLE = 'start-icon-loading';
//# sourceMappingURL=SpinnerBadge.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/SpinnerBadge/SpinnerBadge.styled.js



// styled-components.
// -----------------------------------------------------------------------------
const SpinnerBadgeRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ ...args }) => {
    const { background, border, foreground, active, foregroundAlt } = getSchemaState({
        ...args,
        schema: 'neutral',
        variant: 'white',
        state: 'default'
    });
    return styled_components_browser_esm/* css */.iv `
      /* Fixed rules */
      align-items: center;
      border-radius: ${getRadius('m')};
      display: inline-flex;
      gap: ${getSpace('s')};
      justify-content: center;
      text-align: center;

      /* Colors */
      background-color: ${background};
      border: 2px solid ${border};
      color: ${foreground};

      /* Paddings */
      padding: ${getSpace('s')} ${getSpace('l')};

      /* Icon */
      .spinner-badge__icon--loading svg {
        color: ${active || foregroundAlt};
      }
    `;
}}
`;
//# sourceMappingURL=SpinnerBadge.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/SpinnerBadge/SpinnerBadge.js






// Component.
// -----------------------------------------------------------------------------
const SpinnerBadge = (0,react.forwardRef)(({ label, mode = 'light', ...rest }, ref) => ((0,jsx_runtime.jsxs)(SpinnerBadgeRoot, { ref: ref, mode: mode, ...rest, children: [(0,jsx_runtime.jsx)(Icon_Icon, { className: "spinner-badge__icon--loading", icon: pro_duotone_svg_icons/* faSpinnerThird */.AX7, size: "l", spin: true, title: SPINNER_BADGE_DEFAULT_ICON_LOADING_TITLE }), label && ((0,jsx_runtime.jsx)(Text_Text, { size: "xs", bold: true, children: label }))] })));
// Component configuration.
// -----------------------------------------------------------------------------
SpinnerBadge.displayName = 'SpinnerBadge';
/* harmony default export */ var SpinnerBadge_SpinnerBadge = ((/* unused pure expression or super */ null && (SpinnerBadge)));
//# sourceMappingURL=SpinnerBadge.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Switch/Switch.constants.js


// Constants.
// -----------------------------------------------------------------------------
/** Default disabled */
const SWITCH_DEFAULT_DISABLED = false;
/** Default mode. */
const SWITCH_DEFAULT_MODE = 'light';
/** Default on value. */
const SWITCH_DEFAULT_ON = false;
/** Default role. */
const SWITCH_DEFAULT_ROLE = 'none';
/** Default size. */
const SWITCH_DEFAULT_SIZE = 's';
/** Scale mappings. */
const Switch_constants_MAPPINGS_SCALE = {
    s: {
        fontSize: getFontSize('s'),
        fontWeight: getFontWeight('medium')
    },
    xs: {
        fontSize: getFontSize('xs'),
        fontWeight: getFontWeight('medium')
    }
};
/** Mapping: mode. */
const Switch_constants_MAPPINGS_MODE = {
    // Dark.
    dark: {
        background: (tokens_default()).colors.black[100].value,
        border: (tokens_default()).colors.midnight[800].value,
        dot: (tokens_default()).colors.midnight[800].value,
        disabled: {
            background: (tokens_default()).colors.midnight[900].value,
            border: (tokens_default()).colors.midnight[850].value,
            dot: (tokens_default()).colors.midnight[850].value,
            checked: (tokens_default()).colors.midnight[900].value
        },
        focus: {
            background: (tokens_default()).colors.midnight[850].value,
            shadow: (tokens_default()).colors.midnight[150].value,
            checkedBackground: (tokens_default()).colors.midnight[200].value,
            checkerBorder: (tokens_default()).colors.midnight[800].value
        },
        hover: {
            border: (tokens_default()).colors.midnight[400].value,
            dot: (tokens_default()).colors.midnight[400].value
        },
        checked: {
            background: (tokens_default()).colors.midnight[200].value,
            border: (tokens_default()).colors.midnight[800].value,
            dot: (tokens_default()).colors.midnight[800].value,
            hoverBackground: (tokens_default()).colors.midnight[600].value,
            hoverBorder: (tokens_default()).colors.midnight[600].value,
            hoverDot: (tokens_default()).colors.midnight[200].value
        }
    },
    // Light.
    light: {
        background: (tokens_default()).colors.midnight[150].value,
        border: (tokens_default()).colors.midnight[200].value,
        dot: (tokens_default()).colors.midnight[200].value,
        disabled: {
            background: (tokens_default()).colors.midnight[100].value,
            border: (tokens_default()).colors.midnight[150].value,
            dot: (tokens_default()).colors.midnight[150].value,
            checked: (tokens_default()).colors.midnight[100].value
        },
        focus: {
            background: (tokens_default()).colors.midnight[150].value,
            shadow: (tokens_default()).colors.midnight[150].value,
            checkedBackground: (tokens_default()).colors.midnight[800].value,
            checkerBorder: (tokens_default()).colors.midnight[800].value
        },
        hover: {
            border: (tokens_default()).colors.midnight[400].value,
            dot: (tokens_default()).colors.midnight[400].value
        },
        checked: {
            background: (tokens_default()).colors.midnight[800].value,
            border: (tokens_default()).colors.midnight[800].value,
            dot: (tokens_default()).colors.midnight[200].value,
            hoverBackground: (tokens_default()).colors.midnight[600].value,
            hoverBorder: (tokens_default()).colors.midnight[600].value,
            hoverDot: (tokens_default()).colors.midnight[200].value
        }
    }
};
//# sourceMappingURL=Switch.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Switch/Switch.styled.js




// styled-components.
// -----------------------------------------------------------------------------
const SwitchLabel = styled_components_browser_esm/* default.label */.ZP.label `
  ${({ scale, theme }) => {
    const { fontSize, fontWeight } = Switch_constants_MAPPINGS_SCALE[scale];
    return styled_components_browser_esm/* css */.iv `
      align-items: center;
      cursor: pointer;
      display: inline-flex;
      font-family: ${theme.typography.fontFamily};
      font-size: ${fontSize};
      font-weight: ${fontWeight};
      gap: ${getSpace('s')};
      line-height: ${(tokens_default()).font.lineHeight.text.value};
    `;
}}
`;
const SwitchRoot = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({ type: 'checkbox' }) `
  ${({ mode }) => {
    const { background, border, checked, disabled, dot, focus, hover } = Switch_constants_MAPPINGS_MODE[mode];
    return styled_components_browser_esm/* css */.iv `
      appearance: none;
      border-radius: 9999px;
      cursor: pointer;
      display: inline-block;
      flex: 1 0 auto;
      height: 2rem;
      max-width: 3.5rem;
      outline: none;
      position: relative;
      transition: 0.3s;
      vertical-align: top;
      width: 3.5rem;

      /* Color */
      background: ${background};
      border: 2px solid ${border};

      &::after {
        border-radius: 50%;
        content: '';
        display: block;
        height: 1.25rem;
        left: 3px;
        position: absolute;
        top: 4px;
        transform: translateX(0);
        transition: 0.3s;
        width: 1.25rem;

        /* Color */
        background-color: ${dot};
      }

      /* Error */
      &.error {
        border-color: ${(tokens_default()).colors.red[700].value};

        &::after {
          background-color: ${(tokens_default()).colors.red[700].value};
        }
      }

      /* Disabled */
      &[disabled] {
        background-color: ${disabled.background};
        border-color: ${disabled.border};
        pointer-events: none;

        &::after {
          background-color: ${disabled.dot};
        }

        &:checked {
          background-color: ${disabled.checked};
        }
      }

      /* Focus */
      &:focus {
        background-color: ${focus.background};
        box-shadow: 0 0 0 4px ${focus.shadow};
        outline: 0;

        &:checked {
          background-color: ${focus.checkedBackground};
          border-color: ${focus.checkerBorder};
        }
      }

      /* Hover */
      &:hover {
        border-color: ${hover.border};

        &::after {
          background-color: ${hover.dot};
        }
      }

      /* Checked. */
      &:checked {
        background: ${checked.background};
        border-color: ${checked.border};

        &::after {
          background-color: ${checked.dot};
          transform: translateX(24px);
        }

        &:hover {
          background-color: ${checked.hoverBackground};
          border-color: ${checked.hoverBorder};

          &::after {
            background-color: ${checked.hoverDot};
          }
        }
      }
    `;
}}
`;
const SwitchWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  align-items: center;
  display: inline-flex;
  gap: 0.5rem;
`;
//# sourceMappingURL=Switch.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Switch/Switch.js




// Component.
// -----------------------------------------------------------------------------
const Switch = (0,react.forwardRef)(({ disabled = SWITCH_DEFAULT_DISABLED, label, mode = SWITCH_DEFAULT_MODE, name, checked: on = SWITCH_DEFAULT_ON, onChange, role = SWITCH_DEFAULT_ROLE, size = SWITCH_DEFAULT_SIZE, ...rest }, ref) => {
    return ((0,jsx_runtime.jsxs)(SwitchWrapper, { children: [(0,jsx_runtime.jsx)(SwitchRoot, { checked: on, ...(role && { className: role }), disabled: disabled, id: name, mode: mode, name: name, onChange: onChange, ref: ref, ...rest }), label && ((0,jsx_runtime.jsx)(SwitchLabel, { htmlFor: name, scale: size, children: label }))] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Switch.displayName = 'Switch';
/* harmony default export */ var Switch_Switch = ((/* unused pure expression or super */ null && (Switch)));
//# sourceMappingURL=Switch.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/Table.constants.js


const TABLE_DEFAULT_BORDER_TYPE = 'full';
const TABLE_DEFAULT_WIDTH = 'full';
const TABLE_DEFAULT_SIZE = 's';
const TABLE_DEFAULT_ZEBRA = false;
/** Size mappings. */
const MAPPINGS_SIZE = {
    s: {
        fontSize: getFontSize('s'),
        padding: `${getSpace('xl')} ${getSpace('l')}`
    },
    xs: {
        fontSize: getFontSize('xs'),
        padding: `${getSpace('l')} ${getSpace('m')}`
    }
};
//# sourceMappingURL=Table.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/Table.styled.js



// styled-components.
// -----------------------------------------------------------------------------
const TableRoot = styled_components_browser_esm/* default.table */.ZP.table `
  border-collapse: collapse;
  width: auto;

  /* Sizing
  --------------------------------------------------------*/
  &,
  td,
  th {
    ${({ size }) => styled_components_browser_esm/* css */.iv `
      padding: ${MAPPINGS_SIZE[size].padding};
      font-size: ${MAPPINGS_SIZE[size].fontSize};
    `}
  }

  th {
    font-weight: ${(tokens_default()).font.weight.bold.value};
    text-transform: uppercase;
  }

  /* WIDTH
  --------------------------------------------------------*/
  ${({ width }) => width === 'full' &&
    styled_components_browser_esm/* css */.iv `
      width: 100%;
    `}

  /* ZEBRA
  --------------------------------------------------------*/
  ${({ zebra }) => !!zebra &&
    styled_components_browser_esm/* css */.iv `
      tbody tr:nth-child(odd) {
        background-color: ${(tokens_default()).colors.midnight[100].value};
      }
    `}

  /* BORDER
  --------------------------------------------------------*/
  &,
  td,
  th {
    border: 1px solid ${(tokens_default()).colors.midnight[200].value};
  }

  ${({ borderType }) => borderType === 'separator' &&
    styled_components_browser_esm/* css */.iv `
      & {
        border: 1px solid ${(tokens_default()).colors.midnight[200].value};

        td,
        th {
          border: 0;
        }
      }

      tr {
        border-bottom: 1px solid ${(tokens_default()).colors.midnight[200].value};
      }
    `}

  ${({ borderType }) => borderType === 'none' &&
    styled_components_browser_esm/* css */.iv `
      &,
      td,
      th {
        border: 0;
      }
    `}
`;
const TableWrapper = styled_components_browser_esm/* default.div */.ZP.div ``;
//# sourceMappingURL=Table.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/Table.js




// Component.
// -----------------------------------------------------------------------------
const Table = (0,react.forwardRef)(({ children, borderType = TABLE_DEFAULT_BORDER_TYPE, width = TABLE_DEFAULT_WIDTH, size = TABLE_DEFAULT_SIZE, zebra = TABLE_DEFAULT_ZEBRA, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(TableWrapper, { children: (0,jsx_runtime.jsx)(TableRoot, { ref: ref, borderType: borderType, width: width, size: size, zebra: zebra, ...rest, children: children }) }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Table.displayName = 'Table';
/* harmony default export */ var Table_Table = (Table);
//# sourceMappingURL=Table.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/TableBody/TableBody.styled.js

// styled-components.
// -----------------------------------------------------------------------------
const TableBodyRoot = styled_components_browser_esm/* default.tbody */.ZP.tbody ``;
//# sourceMappingURL=TableBody.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/TableBody/TableBody.js



// Component.
// -----------------------------------------------------------------------------
const TableBody = (0,react.forwardRef)(({ children, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(TableBodyRoot, { ref: ref, ...rest, children: children }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableBody.displayName = 'TableBody';
/* harmony default export */ var TableBody_TableBody = (TableBody);
//# sourceMappingURL=TableBody.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/TableCell/TableCell.styled.js

// styled-components.
// -----------------------------------------------------------------------------
const BaseStyles = ({ align }) => {
    if (align === 'left')
        return styled_components_browser_esm/* css */.iv `
      text-align: left;
    `;
    if (align === 'center')
        return styled_components_browser_esm/* css */.iv `
      text-align: center;
    `;
    if (align === 'right')
        return styled_components_browser_esm/* css */.iv `
      text-align: right;
    `;
};
const TableCellRoot = styled_components_browser_esm/* default.td */.ZP.td `
  ${({ align }) => BaseStyles({ align })}
`;
const TableHeadCellRoot = styled_components_browser_esm/* default.th */.ZP.th `
  ${({ align }) => BaseStyles({ align })}
`;
//# sourceMappingURL=TableCell.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/TableCell/TableCell.js



// Component.
// -----------------------------------------------------------------------------
const TableCell = (0,react.forwardRef)(({ children, header, text, align = 'left', ...rest }, ref) => {
    const Component = header ? TableHeadCellRoot : TableCellRoot;
    const Content = text || children;
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(Component, { ref: ref, align: align, ...rest, children: Content }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableCell.displayName = 'TableCell';
/* harmony default export */ var TableCell_TableCell = (TableCell);
//# sourceMappingURL=TableCell.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/TableData/TableData.js



// Component.
// -----------------------------------------------------------------------------
const TableData = (0,react.forwardRef)(({ children, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(TableCell_TableCell, { header: false, ref: ref, ...rest, children: children }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableData.displayName = 'TableData';
/* harmony default export */ var TableData_TableData = (TableData);
//# sourceMappingURL=TableData.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/TableHead/TableHead.styled.js

// styled-components.
// -----------------------------------------------------------------------------
const TableHeadRoot = styled_components_browser_esm/* default.thead */.ZP.thead ``;
//# sourceMappingURL=TableHead.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/TableHead/TableHead.js



// Component.
// -----------------------------------------------------------------------------
const TableHead = (0,react.forwardRef)(({ children, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(TableHeadRoot, { ref: ref, ...rest, children: children }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableHead.displayName = 'TableHead';
/* harmony default export */ var TableHead_TableHead = (TableHead);
//# sourceMappingURL=TableHead.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/TableHeader/TableHeader.js



// Component.
// -----------------------------------------------------------------------------
const TableHeader = (0,react.forwardRef)(({ children, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(TableCell_TableCell, { header: true, ref: ref, ...rest, children: children }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableHeader.displayName = 'TableHeader';
/* harmony default export */ var TableHeader_TableHeader = (TableHeader);
//# sourceMappingURL=TableHeader.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/TableRow/TableRow.styled.js


// styled-components.
// -----------------------------------------------------------------------------
const TableRowRoot = styled_components_browser_esm/* default.tr */.ZP.tr `
  ${({ selected }) => selected &&
    styled_components_browser_esm/* css */.iv `
      &:nth-child(odd),
      &:nth-child(even) {
        &.selected {
          background-color: ${(tokens_default()).colors.active[100].value};
          font-weight: ${(tokens_default()).font.weight.bold.value};
        }
      }
    `}
`;
//# sourceMappingURL=TableRow.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/TableRow/TableRow.js



// Component.
// -----------------------------------------------------------------------------
const TableRow = (0,react.forwardRef)(({ children, selected = false, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(TableRowRoot, { ref: ref, selected: selected, className: `${selected && 'selected'}`, ...rest, children: children }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableRow.displayName = 'TableRow';
/* harmony default export */ var TableRow_TableRow = (TableRow);
//# sourceMappingURL=TableRow.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Table/index.js







//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/Tabs.styles.js

// styled-components.
// -----------------------------------------------------------------------------
const TabsRoot = styled_components_browser_esm/* default.div */.ZP.div `
  background-color: transparent;
`;
//# sourceMappingURL=Tabs.styles.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/Tabs.constants.js
// Constants.
// -----------------------------------------------------------------------------
const Tabs_constants_DEFAULT_MODE = 'light';
const DEFAULT_SELECTED_COLOR = '#00ccaa';
const INITAL_CONTEXT_VALUE = {
    selectedTabId: 0,
    setSelectedTabId: () => { }
};
//# sourceMappingURL=Tabs.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/Tabs.context.js



// Component.
// -----------------------------------------------------------------------------
// Context definition.
const TabsContext = (0,react.createContext)(INITAL_CONTEXT_VALUE);
// Context provider.
const TabsContextProvider = ({ children, activeTabId, onTabChange }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [currentIndex, setCurrentIndex] = (0,react.useState)(activeTabId || INITAL_CONTEXT_VALUE.selectedTabId);
    (0,react.useEffect)(() => {
        if (activeTabId) {
            setCurrentIndex(activeTabId);
        }
    }, [activeTabId]);
    // Render.
    // ---------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(TabsContext.Provider, { value: {
            selectedTabId: currentIndex,
            setSelectedTabId: (tabId) => {
                onTabChange?.(tabId);
                setCurrentIndex(tabId);
            }
        }, children: children }));
};
//# sourceMappingURL=Tabs.context.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/Tabs.hooks.js


// Custom hook.
// -----------------------------------------------------------------------------
const useTabsContext = () => {
    // Hooks.
    // -----------------------------------------------------------------------------
    const ctx = (0,react.useContext)(TabsContext);
    if (!ctx) {
        throw new Error('useTabs must be used within a TabsProvider');
    }
    return ctx;
};
//# sourceMappingURL=Tabs.hooks.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/TabLabelNumber.hooks.js



// Custom hook.
// -----------------------------------------------------------------------------
const useTabLabelNumber = ({ definition, number }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { setSelectedTabId } = useTabsContext();
    // Handlers.
    // ---------------------------------------------------------------------------
    const handleOnClick = (0,react.useCallback)(() => {
        setSelectedTabId(definition.id);
    }, [definition.id, setSelectedTabId]);
    // Variables.
    // ---------------------------------------------------------------------------
    const isDisabled = (0,react.useMemo)(() => definition.disabled || false, [definition.disabled]);
    const label = (0,react.useMemo)(() => (0,lodash.padStart)(number.toString(), 2, '0'), [number]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        isDisabled,
        label,
        onClick: handleOnClick
    };
};
//# sourceMappingURL=TabLabelNumber.hooks.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/TabLabelNumber.styles.js




// styled-components.
// -----------------------------------------------------------------------------
const TabLabelNumberLabel = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ disabled, mode }) => styled_components_browser_esm/* css */.iv `
    /* Color */
    color: ${disabled
    ? (tokens_default()).colors.midnight[200].value
    : (tokens_default()).colors.midnight[mode === 'light' ? 800 : 200].value};

    /* Text */
    font-family: ${(tokens_default()).font.family.sans.value};
    font-size: ${getFontSize('m')};
    font-weight: ${getFontWeight('medium')};
    line-height: ${getFontSize('l')};
    text-transform: uppercase;
  `}
`;
const TabLabelNumberPosition = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ disabled, mode, selected, selectedColor }) => styled_components_browser_esm/* css */.iv `
    /* Color */
    color: ${disabled
    ? (tokens_default()).colors.midnight[200].value
    : selected
        ? selectedColor
        : (tokens_default()).colors.midnight[mode === 'light' ? 300 : 800].value};

    /* Text */
    font-family: ${(tokens_default()).font.family.serif.value};
    font-size: ${getFontSize('2xl')};
    font-weight: ${getFontWeight('bold')};
    line-height: ${getFontSize('3xl')};
  `}
`;
const TabLabelNumberRoot = styled_components_browser_esm/* default.button */.ZP.button `
  ${({ selected, selectedColor }) => styled_components_browser_esm/* css */.iv `
    /* Display & Box Model */
    align-items: center;
    border: none;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    border-radius: 0;
    display: flex;
    gap: ${getSpace('xs')};
    margin: 0;
    padding: ${getSpace('s')} ${getSpace('l')};

    /* Color */
    background-color: transparent;
    border-bottom-color: ${selected ? selectedColor : 'transparent'};

    /* Text */
    font: inherit;
    text-align: inherit;

    /* Miscellanea */
    cursor: pointer;

    :not([disabled]):hover {
      border-bottom-color: ${selected
    ? selectedColor
    : (tokens_default()).colors.midnight[400].value};
    }
  `}
`;
const TabLabelNumberSeparator = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ disabled, mode }) => styled_components_browser_esm/* css */.iv `
    /* Color */
    color: ${disabled
    ? (tokens_default()).colors.midnight[200].value
    : (tokens_default()).colors.midnight[mode === 'light' ? 300 : 800].value};

    /* Text */
    font-family: ${(tokens_default()).font.family.serif.value};
    font-size: ${getFontSize('2xl')};
    font-weight: ${getFontWeight('bold')};
    line-height: ${getFontSize('3xl')};
  `}
`;
//# sourceMappingURL=TabLabelNumber.styles.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/TabsLabels.styled.js



// styled-components.
// -----------------------------------------------------------------------------
const TabLabelBoxed = styled_components_browser_esm/* default.button */.ZP.button `
  ${({ mode, selected }) => styled_components_browser_esm/* css */.iv `
    /* Display & Box Model */
    border: 1px solid transparent;
    border-bottom: 0;
    border-radius: 0;
    border-top-style: solid;
    border-top-width: 4px;
    margin: 0;
    padding: ${getSpace('m')} ${getSpace('2xl')};

    /* Color */
    background-color: transparent;
    border-color: ${selected
    ? (tokens_default()).colors.midnight[mode === 'light' ? 800 : 200].value
    : (tokens_default()).colors.midnight[mode === 'light' ? 200 : 700].value};
    color: ${mode === 'light'
    ? (tokens_default()).colors.black[100].value
    : (tokens_default()).colors.midnight[200].value};

    /* Text */
    font: inherit;
    text-align: inherit;

    /* Miscellanea */
    cursor: pointer;

    :not([disabled]):hover {
      border-color: ${selected
    ? (tokens_default()).colors.midnight[mode === 'light' ? 800 : 200].value
    : (tokens_default()).colors.midnight[400].value};
    }
  `};
`;
const TabsLabelUnderline = styled_components_browser_esm/* default.button */.ZP.button `
  ${({ mode, selected, selectedColor }) => styled_components_browser_esm/* css */.iv `
    /* Display & Box Model */
    border: none;
    border-bottom-style: solid;
    border-bottom-width: 4px;
    border-radius: 0;
    margin: 0;
    padding: ${getSpace('m')} ${getSpace('2xl')};

    /* Color */
    background-color: transparent;
    border-bottom-color: ${selected ? selectedColor : 'transparent'};
    color: ${mode === 'light'
    ? (tokens_default()).colors.black[100].value
    : (tokens_default()).colors.midnight[200].value};

    /* Text */
    font: inherit;
    text-align: inherit;

    /* Miscellanea */
    cursor: pointer;

    :not([disabled]):hover {
      border-bottom-color: ${selected
    ? selectedColor
    : (tokens_default()).colors.midnight[400].value};
    }

    :disabled {
      color: ${(tokens_default()).colors.midnight[200].value};
    }
  `}
`;
const TabsLabelsRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ type }) => styled_components_browser_esm/* css */.iv `
    /* Display & Box Model */
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;

    ${type !== 'boxed' && `gap: ${getSpace('xs')};`}

    /* Color */
    background-color: transparent;
  `}
`;
const TabBadge = styled_components_browser_esm/* default.span */.ZP.span `
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.schema.active.light.hard.default.background};
  color: ${({ theme }) => theme.palette.schema.active.light.hard.default.foreground};
`;
//# sourceMappingURL=TabsLabels.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/TabLabelNumber.js





// Component.
// -----------------------------------------------------------------------------
const TabLabelNumber = ({ definition, mode, number, selected, selectedColor }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { isDisabled, label, onClick } = useTabLabelNumber({
        definition,
        number
    });
    // Render.
    // ---------------------------------------------------------------------------
    return ((0,jsx_runtime.jsxs)(TabLabelNumberRoot, { disabled: isDisabled, selected: selected, selectedColor: selectedColor, onClick: onClick, children: [(0,jsx_runtime.jsx)(TabLabelNumberPosition, { disabled: isDisabled, mode: mode, selected: selected, selectedColor: selectedColor, children: label }), (0,jsx_runtime.jsx)(TabLabelNumberSeparator, { disabled: isDisabled, mode: mode, children: "/" }), (0,jsx_runtime.jsx)(TabLabelNumberLabel, { disabled: isDisabled, mode: mode, children: (0,jsx_runtime.jsxs)(Stack_Stack, { alignment: "center", gap: "xs", children: [(0,jsx_runtime.jsx)(StackItem, { children: definition.label }), definition.badge && (0,jsx_runtime.jsx)(TabBadge, { children: definition.badge })] }) })] }));
};
//# sourceMappingURL=TabLabelNumber.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/TabsLabels.js





// Component.
// -----------------------------------------------------------------------------
const TabsLabels = ({ definitions, selectedColor, mode, type }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { selectedTabId, setSelectedTabId } = useTabsContext();
    // Render.
    // ---------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(TabsLabelsRoot, { type: type, children: definitions.map((definition, index) => type === 'number' ? ((0,jsx_runtime.jsx)(TabLabelNumber, { definition: definition, mode: mode, number: index + 1, selected: selectedTabId === definition.id, selectedColor: selectedColor }, `tab-label-${definition.id}`)) : type === 'underline' ? ((0,jsx_runtime.jsx)(TabsLabelUnderline, { disabled: definition.disabled || false, mode: mode, onClick: () => setSelectedTabId(definition.id), selected: selectedTabId === definition.id, selectedColor: selectedColor, children: (0,jsx_runtime.jsxs)(Stack_Stack, { alignment: "center", gap: "xs", children: [(0,jsx_runtime.jsx)(StackItem, { children: definition.label }), definition.badge && (0,jsx_runtime.jsx)(TabBadge, { children: definition.badge })] }) }, `tab-label-${definition.id}`)) : ((0,jsx_runtime.jsx)(TabLabelBoxed, { disabled: definition.disabled || false, mode: mode, onClick: () => setSelectedTabId(definition.id), selected: selectedTabId === definition.id, children: (0,jsx_runtime.jsxs)(Stack_Stack, { alignment: "center", gap: "xs", children: [(0,jsx_runtime.jsx)(StackItem, { children: definition.label }), definition.badge && (0,jsx_runtime.jsx)(TabBadge, { children: definition.badge })] }) }, `tab-label-${definition.id}`))) }));
};
//# sourceMappingURL=TabsLabels.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/TabsContents.styled.js



// styled-components.
// -----------------------------------------------------------------------------
const TabsContentsRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ mode, type }) => styled_components_browser_esm/* css */.iv `
    /* Color */
    background-color: transparent;

    ${type === 'boxed' &&
    `
      border: 1px solid ${(tokens_default()).colors.midnight[mode === 'light' ? 800 : 200].value};
      color: ${(tokens_default()).colors.midnight[mode === 'light' ? 800 : 200].value};
      padding: ${getSpace('l')};
    `}

    ${type !== 'boxed' &&
    `
      margin-top: ${getSpace('xl')};
    `}
  `}
`;
//# sourceMappingURL=TabsContents.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/TabsContents.hooks.js


// Custom hook.
// -----------------------------------------------------------------------------
const useTabContents = (definitions) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { selectedTabId } = useTabsContext();
    // Variables.
    // ---------------------------------------------------------------------------
    const tab = (0,react.useMemo)(() => definitions.find(({ id }) => id === selectedTabId), [definitions, selectedTabId]);
    // Return.
    // ---------------------------------------------------------------------------
    return { tab };
};
//# sourceMappingURL=TabsContents.hooks.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/TabsContents.js



// Component.
// -----------------------------------------------------------------------------
const TabsContents = ({ definitions, mode, type }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { tab } = useTabContents(definitions);
    // Render.
    // ---------------------------------------------------------------------------
    return tab ? ((0,jsx_runtime.jsx)(TabsContentsRoot, { mode: mode, type: type, children: tab.content })) : null;
};
//# sourceMappingURL=TabsContents.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Tabs/Tabs.js

// Components.
// -----------------------------------------------------------------------------







const Tabs = (0,react.forwardRef)(({ definitions, mode = Tabs_constants_DEFAULT_MODE, selectedColor = DEFAULT_SELECTED_COLOR, activeTabId, type, onTabChange, render = (renderTabs, renderContent) => ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [renderTabs(), renderContent()] })), ...rest }, ref) => {
    function renderTabs() {
        return ((0,jsx_runtime.jsx)(TabsLabels, { definitions: definitions, mode: mode, selectedColor: selectedColor, type: type }));
    }
    function renderContent() {
        return (0,jsx_runtime.jsx)(TabsContents, { definitions: definitions, mode: mode, type: type });
    }
    // Guard condition.
    if ((0,lodash.isEmpty)(definitions)) {
        return null;
    }
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(TabsContextProvider, { activeTabId: activeTabId, onTabChange: onTabChange, children: (0,jsx_runtime.jsx)(TabsRoot, { ref: ref, ...rest, children: render(renderTabs, renderContent) }) }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Tabs.displayName = 'Tabs';
/* harmony default export */ var Tabs_Tabs = (Tabs);
//# sourceMappingURL=Tabs.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/TextArea/TextArea.constants.js

// Constants.
// -----------------------------------------------------------------------------
/** Default disabled */
const TEXTAREA_DEFAULT_DISABLED = BASE_INPUT_DEFAULT_DISABLE;
/** Default mode. */
const TEXTAREA_DEFAULT_MODE = BASE_INPUT_DEFAULT_MODE;
/** Default number of Text Area rows. */
const TEXTAREA_DEFAULT_ROWS = 5;
/** Default size. */
const TEXT_AREA_DEFAULT_SIZE = BASE_INPUT_DEFAULT_SIZE;
/** Default role. */
const TEXT_AREA_DEFAULT_ROLE = BASE_INPUT_DEFAULT_ROLE;
//# sourceMappingURL=TextArea.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/TextArea/TextArea.styled.js



// styled-components.
// -----------------------------------------------------------------------------
const TextAreaRoot = styled_components_browser_esm/* default.textarea */.ZP.textarea `
  ${BaseInputRoot}

  &.error,
  &.success {
    background-position: right ${getSpace('l')} top 12%;
  }
`;
const TextAreaWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  position: relative;

  ${({ autoGrow }) => autoGrow &&
    `
    & {
      display: grid;
    }
    &::after {
      content: attr(data-replicated-value) " ";
      white-space: pre-wrap;
      visibility: hidden;
    }
    
    & > textarea {
      resize: none;
      overflow: hidden;
    }
    
    & > textarea,
    &::after {
      /* Identical styling required!! */
      ${BaseInputRoot}
    
      grid-area: 1 / 1 / 2 / 2;
    }
  `}
`;
//# sourceMappingURL=TextArea.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/TextArea/TextArea.js





// Component.
// -----------------------------------------------------------------------------
const TextArea = withFormGroup(({ disabled = TEXTAREA_DEFAULT_DISABLED, mode = TEXTAREA_DEFAULT_MODE, name, role = TEXT_AREA_DEFAULT_ROLE, rows = TEXTAREA_DEFAULT_ROWS, size = TEXT_AREA_DEFAULT_SIZE, autoGrow = false, inputRef, ...rest }) => {
    const wrapperRef = (0,react.useRef)(null);
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(TextAreaWrapper, { autoGrow: autoGrow, ref: wrapperRef, children: (0,jsx_runtime.jsx)(TextAreaRoot, { "aria-label": name, ...(role && { className: role }), disabled: disabled, mode: mode, name: name, ref: inputRef, rows: rows, scale: size, onInput: autoGrow
                ? (e) => {
                    if (wrapperRef.current) {
                        wrapperRef.current.dataset.replicatedValue =
                            e.currentTarget.value;
                    }
                }
                : undefined, ...rest }) }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TextArea.displayName = 'TextArea';
const TextareaWithFormGroup = react.forwardRef((props, ref) => {
    return (0,jsx_runtime.jsx)(TextArea, { ...props, inputRef: ref });
});
TextareaWithFormGroup.displayName = 'TextareaWithFormGroup';
/* harmony default export */ var TextArea_TextArea = (TextareaWithFormGroup);
//# sourceMappingURL=TextArea.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/TextField/TextField.hooks.js

// Custom hooks.
// -----------------------------------------------------------------------------
const useTextField = (type) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [showPassword, setShotPassword] = (0,react.useState)(false);
    const inputType = (0,react.useMemo)(() => (type !== 'password' ? type : showPassword ? 'text' : 'password'), [showPassword, type]);
    // Helpers.
    // ---------------------------------------------------------------------------
    const handleClickShowPassword = (0,react.useCallback)(() => {
        setShotPassword((prev) => !prev);
    }, []);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        inputType,
        onClickShowPassword: handleClickShowPassword
    };
};
//# sourceMappingURL=TextField.hooks.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/TextField/TextField.styled.js


// styled-components.
// -----------------------------------------------------------------------------
const TextFieldRoot = styled_components_browser_esm/* default.input */.ZP.input `
  ${BaseInputRoot}
`;
const TextFieldWrapper = styled_components_browser_esm/* default.div */.ZP.div `
  position: relative;

  .btn-eye {
    background: transparent;
    border: none;
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translate(0, -50%);
  }
`;
//# sourceMappingURL=TextField.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/TextField/TextField.js








// Component.
// -----------------------------------------------------------------------------
const TextField = withFormGroup(({ disabled = TEXT_FIELD_DEFAULT_DISABLED, mode = TEXT_FIELD_DEFAULT_MODE, name, role = TEXT_FIELD_DEFAULT_ROLE, size = TEXT_FIELD_DEFAULT_SIZE, type = TEXT_FIELD_DEFAULT_TYPE, inputRef, ...rest }) => {
    // Hooks.
    // -------------------------------------------------------------------------
    const { inputType, onClickShowPassword } = useTextField(type);
    // Render.
    // -------------------------------------------------------------------------
    return ((0,jsx_runtime.jsxs)(TextFieldWrapper, { children: [(0,jsx_runtime.jsx)(TextFieldRoot, { ...(role && { className: role }), disabled: disabled, id: name, mode: mode, name: name, role: "textbox", 
                // we are using 'scale' because input has its own 'size'.
                scale: size, type: inputType, ref: inputRef, ...rest }), type === 'password' && role !== 'error' && ((0,jsx_runtime.jsx)(IconButton_IconButton, { "aria-label": "show password", className: "btn-eye", icon: inputType === 'password' ? pro_solid_svg_icons/* faEye */.Mdf : pro_solid_svg_icons/* faEyeSlash */.Aq, mode: mode, onClick: onClickShowPassword, schema: "neutral", variant: "bare" }))] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TextField.displayName = 'TextField';
const TextFieldWithFormGroup = react.forwardRef((props, ref) => {
    return (0,jsx_runtime.jsx)(TextField, { ...props, inputRef: ref });
});
TextFieldWithFormGroup.displayName = 'TextFieldWithFormGroup';
/* harmony default export */ var TextField_TextField = (TextFieldWithFormGroup);
//# sourceMappingURL=TextField.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Toast/Toast.constants.js
// Constants.
// -----------------------------------------------------------------------------
const TOAST_CONTAINER_DIV_PORTAL = 'ui-toast-portals';
const TOAST_CONTAINER_DIV_CONTENT = 'ui-toast-content';
const TOAST_DEFAULT_POSITION = 'bottom-right';
const TOAST_DEFAULT_DURATION_IN_MILLISECONDS = 5000;
//# sourceMappingURL=Toast.constants.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Toast/Toast.styled.js


// styled-components.
// -----------------------------------------------------------------------------
const ToastContainer = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ position }) => {
    return styled_components_browser_esm/* css */.iv `
      // Box.
      display: flex;
      flex-direction: column;
      gap: ${getSpace('l')};

      ${position === 'bottom-center' && `align-items: center;`}
      ${position === 'bottom-right' && `align-items: flex-end;`}
      ${position === 'top-center' && `align-items: center;`}
      ${position === 'top-right' && `align-items: flex-end;`}
    `;
}}
`;
const ToastRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ position }) => {
    return styled_components_browser_esm/* css */.iv `
      // Box.
      position: fixed;

      // Space
      margin: ${getSpace('s')};

      // Conditional rules.
      ${position === 'bottom-center' &&
        `bottom: 0; left: 50%; transform: translateX(-50%);`}
      ${position === 'bottom-left' && `bottom: 0; left: 0;`}
      ${position === 'bottom-right' && `bottom: 0; right: 0;`}

      ${position === 'top-center' &&
        `top: 0; left: 50%; transform: translateX(-50%);`}
      ${position === 'top-right' && `top: 0; right: 0;`}
      ${position === 'top-left' && `top: 0; left: 0;`}
    `;
}}
`;
//# sourceMappingURL=Toast.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Toast/ToastItem.styled.js

// animations.
// -----------------------------------------------------------------------------
const fadeIn = styled_components_browser_esm/* keyframes */.F4 `
  from { bottom: 0; opacity: 0; }
  to   { bottom: 30px; opacity: 1; }
`;
// styled-components.
// -----------------------------------------------------------------------------
const ToastItemRoot = styled_components_browser_esm/* default.div */.ZP.div `
  ${({ maxWidth }) => styled_components_browser_esm/* css */.iv `
    // Animations.
    animation-name: ${fadeIn};
    animation-duration: 0.5s;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;

    // Block.
    width: fit-content;
    ${maxWidth && `max-width: ${maxWidth};`}
  `}
`;
//# sourceMappingURL=ToastItem.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Toast/ToastItem.hook.js

// Custom Hook.
// -----------------------------------------------------------------------------
const useToastItem = ({ duration, id, onRemove }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [isVisible, setIsVisible] = (0,react.useState)(true);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react.useEffect)(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
            onRemove(id);
        }, duration);
        return () => {
            clearTimeout(timer);
        };
    }, [duration, id, onRemove]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        isVisible
    };
};
//# sourceMappingURL=ToastItem.hook.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Toast/ToastItem.js




// Component.
// -----------------------------------------------------------------------------
const ToastItem = ({ duration, maxWidth, message, id, onRemove, title, type }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { isVisible } = useToastItem({ duration, id, onRemove });
    // Guard condition.
    // ---------------------------------------------------------------------------
    if (!isVisible) {
        return null;
    }
    // Render.
    // ---------------------------------------------------------------------------
    return ((0,jsx_runtime.jsx)(ToastItemRoot, { id: `toast-item-${id}`, maxWidth: maxWidth, children: (0,jsx_runtime.jsx)(Notification_Notification, { message: message, style: {
                marginBottom: 0
            }, title: title, type: type }) }));
};
//# sourceMappingURL=ToastItem.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Toast/Toast.hooks.js






// Hooks.
// -----------------------------------------------------------------------------
const useToast = ({ duration = TOAST_DEFAULT_DURATION_IN_MILLISECONDS, maxWidth, position = TOAST_DEFAULT_POSITION } = {
    duration: TOAST_DEFAULT_DURATION_IN_MILLISECONDS,
    position: TOAST_DEFAULT_POSITION
}) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [node, setNode] = (0,react.useState)(null);
    const [toasts, setToasts] = (0,react.useState)([]);
    // Functions.
    // ---------------------------------------------------------------------------
    const removeToast = (0,react.useCallback)((key) => {
        setToasts((prev) => prev.filter((toast) => toast.key !== key));
    }, []);
    const showToast = (0,react.useCallback)(({ message, title, type }) => {
        setToasts((prev) => [
            ...prev,
            {
                key: prev.length === 0 ? 0 : prev[prev.length - 1].key + 1,
                message,
                title,
                type
            }
        ]);
    }, []);
    const showSuccess = (0,react.useCallback)((message, title) => {
        showToast({ message, title, type: 'success' });
    }, [showToast]);
    const showError = (0,react.useCallback)((message, title) => {
        showToast({ message, title, type: 'error' });
    }, [showToast]);
    const showWarning = (0,react.useCallback)((message, title) => {
        showToast({ message, title, type: 'warning' });
    }, [showToast]);
    const showInfo = (0,react.useCallback)((message, title) => {
        showToast({ message, title, type: 'info' });
    }, [showToast]);
    // Effect.
    // ---------------------------------------------------------------------------
    (0,react.useEffect)(() => {
        if (!node) {
            const div = document.createElement('div');
            div.id = TOAST_CONTAINER_DIV_PORTAL;
            document.body.appendChild(div);
            setNode(div);
        }
        return () => {
            if (node && node.parentNode === document.body) {
                document.body.removeChild(node);
            }
        };
    }, [node]);
    (0,react.useEffect)(() => {
        const container = document.getElementById(TOAST_CONTAINER_DIV_CONTENT);
        if (container) {
            (0,react_dom.render)((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: toasts.map(({ key, message, title, type }) => ((0,jsx_runtime.jsx)(UIProvider_UIProvider, { children: (0,jsx_runtime.jsx)(ToastItem, { id: key, duration: duration, maxWidth: maxWidth, message: message, position: position, onRemove: removeToast, title: title, type: type }) }, `toast-item-${key}`))) }), container);
        }
    }, [duration, maxWidth, position, removeToast, toasts]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        node,
        showError,
        showInfo,
        showSuccess,
        showWarning
    };
};
//# sourceMappingURL=Toast.hooks.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Toast/Toast.js






// Component.
// -----------------------------------------------------------------------------
/**
 * In order to use it, it is necessary to render the `Toast` component in the
 * application. Subsequently, messages can be sent with the functions provided
 * by the hook useToast.
 */
const Toast = (0,react.forwardRef)(({ position = TOAST_DEFAULT_POSITION }, ref) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { node } = useToast({ position });
    // Guard Condition.
    // ---------------------------------------------------------------------------
    if (!node) {
        return null;
    }
    // Render.
    // ---------------------------------------------------------------------------
    return (0,react_dom.createPortal)((0,jsx_runtime.jsx)(ToastRoot, { position: position, ref: ref, children: (0,jsx_runtime.jsx)(ToastContainer, { id: TOAST_CONTAINER_DIV_CONTENT, position: position }) }), node);
});
// Component configuration.
// -----------------------------------------------------------------------------
Toast.displayName = 'Toast';
/* harmony default export */ var Toast_Toast = (Toast);
//# sourceMappingURL=Toast.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/BadgeList/BadgeList.js






const BadgeList = ({ items, stackWrapperProps, maxItems = 0 }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    if (items.length === 0)
        return null;
    return (_jsxs(Stack, { wrap: true, gap: "s", alignment: "center", ...stackWrapperProps, children: [items
                .slice(0, !maxItems || isExpanded ? items.length : maxItems)
                .map((item) => (_createElement(Badge, { ...item, key: item.key }))), !!maxItems && items.length > maxItems && (_jsx(_Fragment, { children: _jsx(Badge, { label: isExpanded ? '' : `${items.length - maxItems}+`, icon: isExpanded ? faMinus : undefined, variant: "ghost", schema: "neutral", size: "xs", bold: true, onClick: () => setIsExpanded((prev) => !prev) }) }))] }));
};
//# sourceMappingURL=BadgeList.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/BadgeList/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/react-modern-drawer/dist/index.modern.js


function index_modern_extends() {
  index_modern_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return index_modern_extends.apply(this, arguments);
}

var getDirectionStyle = function getDirectionStyle(dir, size) {
  switch (dir) {
    case 'left':
      return {
        top: 0,
        left: 0,
        transform: 'translate3d(-100%, 0, 0)',
        width: size,
        height: '100vh'
      };

    case 'right':
      return {
        top: 0,
        right: 0,
        transform: 'translate3d(100%, 0, 0)',
        width: size,
        height: '100vh'
      };

    case 'bottom':
      return {
        left: 0,
        right: 0,
        bottom: 0,
        transform: 'translate3d(0, 100%, 0)',
        width: '100%',
        height: size
      };

    case 'top':
      return {
        left: 0,
        right: 0,
        top: 0,
        transform: 'translate3d(0, -100%, 0)',
        width: '100%',
        height: size
      };

    default:
      return {};
  }
};

var EZDrawer = function EZDrawer(props) {
  var open = props.open,
      _props$onClose = props.onClose,
      onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
      children = props.children,
      style = props.style,
      _props$enableOverlay = props.enableOverlay,
      enableOverlay = _props$enableOverlay === void 0 ? true : _props$enableOverlay,
      _props$overlayColor = props.overlayColor,
      overlayColor = _props$overlayColor === void 0 ? '#000' : _props$overlayColor,
      _props$overlayOpacity = props.overlayOpacity,
      overlayOpacity = _props$overlayOpacity === void 0 ? 0.4 : _props$overlayOpacity,
      _props$zIndex = props.zIndex,
      zIndex = _props$zIndex === void 0 ? 100 : _props$zIndex,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? 500 : _props$duration,
      direction = props.direction,
      _props$size = props.size,
      size = _props$size === void 0 ? 250 : _props$size,
      className = props.className,
      customIdSuffix = props.customIdSuffix,
      _props$lockBackground = props.lockBackgroundScroll,
      lockBackgroundScroll = _props$lockBackground === void 0 ? false : _props$lockBackground,
      _props$overlayClassNa = props.overlayClassName,
      overlayClassName = _props$overlayClassNa === void 0 ? '' : _props$overlayClassNa;
  var bodyRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    var updatePageScroll = function updatePageScroll() {
      bodyRef.current = window.document.querySelector('body');

      if (bodyRef.current && lockBackgroundScroll) {
        if (open) {
          bodyRef.current.style.overflow = 'hidden';
        } else {
          bodyRef.current.style.overflow = '';
        }
      }
    };

    updatePageScroll();
  }, [open]);
  var idSuffix = (0,react.useMemo)(function () {
    return customIdSuffix || (Math.random() + 1).toString(36).substring(7);
  }, [customIdSuffix]);
  var overlayStyles = {
    backgroundColor: "" + overlayColor,
    opacity: "" + overlayOpacity,
    zIndex: zIndex
  };

  var drawerStyles = index_modern_extends({
    zIndex: zIndex + 1,
    transitionDuration: duration + "ms"
  }, getDirectionStyle(direction, size), style);

  return react.createElement("div", {
    id: 'EZDrawer' + idSuffix,
    className: 'EZDrawer'
  }, react.createElement("input", {
    type: 'checkbox',
    id: 'EZDrawer__checkbox' + idSuffix,
    className: 'EZDrawer__checkbox',
    onChange: onClose,
    checked: open
  }), react.createElement("nav", {
    role: 'navigation',
    id: 'EZDrawer__container' + idSuffix,
    style: drawerStyles,
    className: 'EZDrawer__container ' + className
  }, children), enableOverlay && react.createElement("label", {
    htmlFor: 'EZDrawer__checkbox' + idSuffix,
    id: 'EZDrawer__overlay' + idSuffix,
    className: 'EZDrawer__overlay ' + overlayClassName,
    style: overlayStyles
  }));
};

/* harmony default export */ var index_modern = (EZDrawer);
//# sourceMappingURL=index.modern.js.map

;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Drawer/Drawer.styled.js

const DrawerStyles = styled_components_browser_esm/* createGlobalStyle */.vJ `
  .EZDrawer .EZDrawer__checkbox {
    display: none;
  }
    
  .EZDrawer .EZDrawer__checkbox:checked ~ .EZDrawer__overlay {
    display: block;
    opacity: 1;
  }
  
  .EZDrawer .EZDrawer__checkbox:checked ~ .EZDrawer__container {
    visibility: visible;
    transform: translate3d(0, 0, 0) !important;
  }
  
  .EZDrawer .EZDrawer__container {
    position: fixed;
    visibility: hidden;
    background: white;
    transition: all;
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
  }  
`;
const DrawerOverlayStyles = styled_components_browser_esm/* createGlobalStyle */.vJ `
  .EZDrawer .EZDrawer__overlay {
    display: none;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
  }
`;
const DrawerContainer = styled_components_browser_esm/* default.div */.ZP.div `
  height: 100%;
`;
//# sourceMappingURL=Drawer.styled.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Drawer/Drawer.js



const Drawer = ({ isOpened, onClose, size, className = '', children, lockBackgroundScroll = true, showOverlay = true }) => {
    return ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)(DrawerStyles, {}), showOverlay && (0,jsx_runtime.jsx)(DrawerOverlayStyles, {}), (0,jsx_runtime.jsx)(index_modern, { open: isOpened, onClose: onClose, direction: "right", size: size, className: className, lockBackgroundScroll: lockBackgroundScroll, 
                // ? We should centralize these numbers somewhere
                zIndex: 8, children: (0,jsx_runtime.jsx)(DrawerContainer, { children: children }) })] }));
};
//# sourceMappingURL=Drawer.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/Molecules/Drawer/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-library/dist/components/index.js
// Imports.
// -----------------------------------------------------------------------------






































// Exports.
// -----------------------------------------------------------------------------




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../ui-library/dist/index.js


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 926:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 56666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32802);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 7896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 81665:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88960);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, o);
}


/***/ }),

/***/ 59740:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31461);

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 31461:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 88960:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ 51171:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(926);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(59147);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}


/***/ }),

/***/ 32802:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ toPropertyKey; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 86522:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 59147:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(926);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ }),

/***/ 81674:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse$1; },
/* harmony export */   "qv": function() { return /* binding */ icon; },
/* harmony export */   "vI": function() { return /* binding */ library$1; },
/* harmony export */   "vc": function() { return /* binding */ config$1; }
/* harmony export */ });
/* unused harmony exports noAuto, dom, findIconDefinition, toHtml, layer, text, counter, api */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var _familyProxy, _familyProxy2, _familyProxy3, _familyProxy4, _familyProxy5;

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_CSS_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var MUTATION_APPROACH_ASYNC = 'async';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION = function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
}();
var FAMILY_CLASSIC = 'classic';
var FAMILY_SHARP = 'sharp';
var FAMILIES = [FAMILY_CLASSIC, FAMILY_SHARP];

function familyProxy(obj) {
  // Defaults to the classic family if family is not available
  return new Proxy(obj, {
    get: function get(target, prop) {
      return prop in target ? target[prop] : target[FAMILY_CLASSIC];
    }
  });
}
var PREFIX_TO_STYLE = familyProxy((_familyProxy = {}, _defineProperty(_familyProxy, FAMILY_CLASSIC, {
  'fa': 'solid',
  'fas': 'solid',
  'fa-solid': 'solid',
  'far': 'regular',
  'fa-regular': 'regular',
  'fal': 'light',
  'fa-light': 'light',
  'fat': 'thin',
  'fa-thin': 'thin',
  'fad': 'duotone',
  'fa-duotone': 'duotone',
  'fab': 'brands',
  'fa-brands': 'brands',
  'fak': 'kit',
  'fa-kit': 'kit'
}), _defineProperty(_familyProxy, FAMILY_SHARP, {
  'fa': 'solid',
  'fass': 'solid',
  'fa-solid': 'solid',
  'fasr': 'regular',
  'fa-regular': 'regular',
  'fasl': 'light',
  'fa-light': 'light'
}), _familyProxy));
var STYLE_TO_PREFIX = familyProxy((_familyProxy2 = {}, _defineProperty(_familyProxy2, FAMILY_CLASSIC, {
  'solid': 'fas',
  'regular': 'far',
  'light': 'fal',
  'thin': 'fat',
  'duotone': 'fad',
  'brands': 'fab',
  'kit': 'fak'
}), _defineProperty(_familyProxy2, FAMILY_SHARP, {
  'solid': 'fass',
  'regular': 'fasr',
  'light': 'fasl'
}), _familyProxy2));
var PREFIX_TO_LONG_STYLE = familyProxy((_familyProxy3 = {}, _defineProperty(_familyProxy3, FAMILY_CLASSIC, {
  'fab': 'fa-brands',
  'fad': 'fa-duotone',
  'fak': 'fa-kit',
  'fal': 'fa-light',
  'far': 'fa-regular',
  'fas': 'fa-solid',
  'fat': 'fa-thin'
}), _defineProperty(_familyProxy3, FAMILY_SHARP, {
  'fass': 'fa-solid',
  'fasr': 'fa-regular',
  'fasl': 'fa-light'
}), _familyProxy3));
var LONG_STYLE_TO_PREFIX = familyProxy((_familyProxy4 = {}, _defineProperty(_familyProxy4, FAMILY_CLASSIC, {
  'fa-brands': 'fab',
  'fa-duotone': 'fad',
  'fa-kit': 'fak',
  'fa-light': 'fal',
  'fa-regular': 'far',
  'fa-solid': 'fas',
  'fa-thin': 'fat'
}), _defineProperty(_familyProxy4, FAMILY_SHARP, {
  'fa-solid': 'fass',
  'fa-regular': 'fasr',
  'fa-light': 'fasl'
}), _familyProxy4));
var ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl)?[\-\ ]/; // eslint-disable-line no-useless-escape

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var FONT_WEIGHT_TO_PREFIX = familyProxy((_familyProxy5 = {}, _defineProperty(_familyProxy5, FAMILY_CLASSIC, {
  '900': 'fas',
  '400': 'far',
  'normal': 'far',
  '300': 'fal',
  '100': 'fat'
}), _defineProperty(_familyProxy5, FAMILY_SHARP, {
  '900': 'fass',
  '400': 'fasr',
  '300': 'fasl'
}), _familyProxy5));
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
var DUOTONE_CLASSES = {
  GROUP: 'duotone-group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var prefixes = new Set();
Object.keys(STYLE_TO_PREFIX[FAMILY_CLASSIC]).map(prefixes.add.bind(prefixes));
Object.keys(STYLE_TO_PREFIX[FAMILY_SHARP]).map(prefixes.add.bind(prefixes));
var RESERVED_CLASSES = [].concat(FAMILIES, _toConsumableArray(prefixes), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
  return "".concat(n, "x");
})).concat(oneToTwenty.map(function (n) {
  return "w-".concat(n);
}));

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-css-prefix', 'cssPrefix'], ['data-family-default', 'familyDefault'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  styleDefault: 'solid',
  familyDefault: 'classic',
  cssPrefix: DEFAULT_CSS_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present

if (initial.familyPrefix) {
  initial.cssPrefix = initial.familyPrefix;
}

var _config = _objectSpread2(_objectSpread2({}, _default), initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_default).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;

      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0

Object.defineProperty(config, 'familyPrefix', {
  enumerable: true,
  set: function set(val) {
    _config.cssPrefix = val;

    _onChangeCb.forEach(function (cb) {
      return cb(config);
    });
  },
  get: function get() {
    return _config.cssPrefix;
  }
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);

  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = '';

  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }

  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";

function css() {
  var dcp = DEFAULT_CSS_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.cssPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dcp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var _cssInserted = false;

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css: css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = string.charCodeAt(counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      var extra = string.charCodeAt(counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }

  return output;
}

function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  var size = string.length;
  var first = string.charCodeAt(index);
  var second;

  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);

    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }

  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});
}

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var duotonePathRe = [/*#__PURE__*/_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
  d1: 1,
  d2: 2
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2,
  cls2: 3,
  d2: 4
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2
})];

var _LONG_STYLE, _PREFIXES, _PREFIXES_FOR_FAMILY;
var styles = namespace.styles,
    shims = namespace.shims;
var LONG_STYLE = (_LONG_STYLE = {}, _defineProperty(_LONG_STYLE, FAMILY_CLASSIC, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_LONG_STYLE, FAMILY_SHARP, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = (_PREFIXES = {}, _defineProperty(_PREFIXES, FAMILY_CLASSIC, Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES, FAMILY_SHARP, Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP])), _PREFIXES);

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function getIconName(cssPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === cssPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'number';
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    acc[iconName] = iconName;

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'string';
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }

    return acc;
  });
  _byAlias = lookup(function (acc, icon, iconName) {
    var aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  }); // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.

  var hasRegular = 'far' in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
    family: config.familyDefault
  });
};
onChange(function (c) {
  _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault, {
    family: config.familyDefault
  });
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$family = params.family,
      family = _params$family === void 0 ? FAMILY_CLASSIC : _params$family;
  var style = PREFIX_TO_STYLE[family][styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[family][styleOrPrefix] || STYLE_TO_PREFIX[family][style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
var PREFIXES_FOR_FAMILY = (_PREFIXES_FOR_FAMILY = {}, _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_CLASSIC, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_SHARP, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _PREFIXES_FOR_FAMILY);
function getCanonicalIcon(values) {
  var _famProps;

  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
      skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var famProps = (_famProps = {}, _defineProperty(_famProps, FAMILY_CLASSIC, "".concat(config.cssPrefix, "-").concat(FAMILY_CLASSIC)), _defineProperty(_famProps, FAMILY_SHARP, "".concat(config.cssPrefix, "-").concat(FAMILY_SHARP)), _famProps);
  var givenPrefix = null;
  var family = FAMILY_CLASSIC;

  if (values.includes(famProps[FAMILY_CLASSIC]) || values.some(function (v) {
    return PREFIXES_FOR_FAMILY[FAMILY_CLASSIC].includes(v);
  })) {
    family = FAMILY_CLASSIC;
  }

  if (values.includes(famProps[FAMILY_SHARP]) || values.some(function (v) {
    return PREFIXES_FOR_FAMILY[FAMILY_SHARP].includes(v);
  })) {
    family = FAMILY_SHARP;
  }

  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.cssPrefix, cls);

    if (styles[cls]) {
      cls = LONG_STYLE[family].includes(cls) ? LONG_STYLE_TO_PREFIX[family][cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES[family].indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls, {
        family: family
      });
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass && cls !== famProps[FAMILY_CLASSIC] && cls !== famProps[FAMILY_SHARP]) {
      acc.rest.push(cls);
    }

    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);

      if (shim.prefix) {
        givenPrefix = null;
      }

      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;

      if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
        // Allow a fallback from the regular style to solid if regular is not available
        // but only if we aren't auto-fetching SVGs
        acc.prefix = 'fas';
      }
    }

    return acc;
  }, emptyCanonicalIcon());

  if (values.includes('fa-brands') || values.includes('fab')) {
    canonical.prefix = 'fab';
  }

  if (values.includes('fa-duotone') || values.includes('fad')) {
    canonical.prefix = 'fad';
  }

  if (!canonical.prefix && family === FAMILY_SHARP && (styles['fass'] || config.autoFetchSvg)) {
    canonical.prefix = 'fass';
    canonical.iconName = byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
  }

  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }

  return canonical;
}

var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change

        var longPrefix = PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC][key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        var aliases = icon[2];
        if (!additions[prefix]) additions[prefix] = {};

        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === 'string') {
              additions[prefix][alias] = icon;
            }
          });
        }

        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  var obj = _ref.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k) {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });

  _plugins.forEach(function (plugin) {
    var mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(function (tk) {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }

      if (_typeof(mixout[tk]) === 'object') {
        Object.keys(mixout[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }

          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });

    if (plugin.hooks) {
      var hooks = plugin.hooks();
      Object.keys(hooks).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }

        _hooks[hook].push(hooks[hook]);
      });
    }

    if (plugin.provides) {
      plugin.provides(providers);
    }
  });

  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args)); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }

  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject('Operation requires a DOM of some kind.');
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;

    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
var parse = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }

    if (_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }

    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix: prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }

    if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.cssPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }

    if (typeof _icon === 'string') {
      var _prefix = getDefaultUsablePrefix();

      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  parse: parse,
  library: library,
  findIconDefinition: findIconDefinition,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.cssPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var attrClass = [config.replacementClass, iconName ? "".concat(config.cssPrefix, "-").concat(iconName) : ''].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }

  var args = _objectSpread2(_objectSpread2({}, content), {}, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
  });

  var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  },
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _objectSpread2({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform: transform,
      startCentered: true,
      width: width,
      height: height
    });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}

var styles$1 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};

function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}

function findIcon(iconName, prefix) {
  var givenPrefix = prefix;

  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }

  return new Promise(function (resolve, reject) {
    var val = {
      found: false,
      width: 512,
      height: 512,
      icon: callProvided('missingIconAbstract') || {}
    };

    if (givenPrefix === 'fa') {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }

    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }

    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = "FA \"6.4.0\"";

var begin = function begin(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};

var perf = {
  begin: begin,
  end: end
};

var noop$2 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}

function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}

function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}

function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}

function createElement(tag) {
  return DOCUMENT.createElement(tag);
}

function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
      ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;

  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }

  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn: ceFn
    }));
  });
  return tag;
}

function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */

  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */

  return comment;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];

    if (node.parentNode) {
      mutation[1].forEach(function (_abstract) {
        node.parentNode.insertBefore(convertSVG(_abstract), node);
      });

      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var _abstract2 = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement

    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp("".concat(config.cssPrefix, "-.*"));
    delete _abstract2[0].attributes.id;

    if (_abstract2[0].attributes.class) {
      var splitClasses = _abstract2[0].attributes.class.split(' ').reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }

        return acc;
      }, {
        toNode: [],
        toSvg: []
      });

      _abstract2[0].attributes.class = splitClasses.toSvg.join(' ');

      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }

    var newInnerHTML = _abstract2.map(function (a) {
      return toHtml(a);
    }).join('\n');

    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function performOperationSync(op) {
  op();
}

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$2;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;

    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var _options$treeCallback = options.treeCallback,
      treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
      _options$nodeCallback = options.nodeCallback,
      nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
      _options$pseudoElemen = options.pseudoElementsCallback,
      pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  var style = node.getAttribute('style');
  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
}

function classParser (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  var val = getCanonicalIcon(classArray(node));

  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.iconName && val.prefix) {
    return val;
  }

  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }

  if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) {
    val.iconName = node.firstChild.data;
  }

  return val;
}

function attributesParser (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }

    return acc;
  }, {});
  var title = node.getAttribute('title');
  var titleId = node.getAttribute('data-fa-title-id');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }

  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };

  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2({
    iconName: iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix: prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

var styles$2 = namespace.styles;

function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}

var knownPrefixes = new Set();
FAMILIES.map(function (family) {
  knownPrefixes.add("fa-".concat(family));
});
Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC]).map(knownPrefixes.add.bind(knownPrefixes));
Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP]).map(knownPrefixes.add.bind(knownPrefixes));
knownPrefixes = _toConsumableArray(knownPrefixes);

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;

  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var prefixes = config.autoFetchSvg ? knownPrefixes : FAMILIES.map(function (f) {
    return "fa-".concat(f);
  }).concat(Object.keys(styles$2));

  if (!prefixes.includes('fa')) {
    prefixes.push('fa');
  }

  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
    return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }

  var candidates = [];

  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e) {// noop
  }

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }

  var mark = perf.begin('onTree');
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e.name === 'MissingIcon') {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);
  return new Promise(function (resolve, reject) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(function (e) {
      mark();
      reject(e);
    });
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
      mask: mask
    }));
  };
}

var render = function render(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return domVariants(_objectSpread2({
    type: 'icon'
  }, iconDefinition), function () {
    callHooks('beforeDOMElementCreation', {
      iconDefinition: iconDefinition,
      params: params
    });

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node, callback);
    };

    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      var iconName = nodeMeta.iconName,
          title = nodeMeta.title,
          titleId = nodeMeta.titleId,
          prefix = nodeMeta.prefix,
          transform = nodeMeta.transform,
          symbol = nodeMeta.symbol,
          mask = nodeMeta.mask,
          maskId = nodeMeta.maskId,
          extra = nodeMeta.extra;
      return new Promise(function (resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              main = _ref2[0],
              mask = _ref2[1];

          resolve([node, makeInlineSvgAbstract({
            icons: {
              main: main,
              mask: mask
            },
            prefix: prefix,
            iconName: iconName,
            transform: transform,
            symbol: symbol,
            maskId: maskId,
            title: title,
            titleId: titleId,
            extra: extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };

    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
          attributes = _ref3.attributes,
          main = _ref3.main,
          transform = _ref3.transform,
          styles = _ref3.styles;
      var styleString = joinStyles(styles);

      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }

      var nextChild;

      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main: main,
          transform: transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }

      children.push(nextChild || main.icon);
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var Layers = {
  mixout: function mixout() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: 'layer'
        }, function () {
          callHooks('beforeDOMElementCreation', {
            assembler: assembler,
            params: params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a) {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.cssPrefix, "-layers")].concat(_toConsumableArray(classes)).join(' ')
            },
            children: children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout: function mixout() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'counter',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.cssPrefix, "-layers-counter")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout: function mixout() {
    return {
      text: function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform,
            transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
            _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'text',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersTextAbstract({
            content: content,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.cssPrefix, "-layers-text")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      var title = nodeMeta.title,
          transform = nodeMeta.transform,
          extra = nodeMeta.extra;
      var width = null;
      var height = null;

      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }

      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }

      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width: width,
        height: height,
        transform: transform,
        title: title,
        extra: extra,
        watchable: true
      })]);
    };
  }
};

var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}

function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise(function (resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }

    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
    var fontWeight = styles.getPropertyValue('font-weight');
    var content = styles.getPropertyValue('content');

    if (alreadyProcessedPseudoElement && !fontFamily) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== 'none' && content !== '') {
      var _content = styles.getPropertyValue('content');

      var family = ~['Sharp'].indexOf(fontFamily[2]) ? FAMILY_SHARP : FAMILY_CLASSIC;
      var prefix = ~['Solid', 'Regular', 'Light', 'Thin', 'Duotone', 'Brands', 'Kit'].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[family][fontWeight];

      var _hexValueFromContent = hexValueFromContent(_content),
          hexValue = _hexValueFromContent.value,
          isSecondary = _hexValueFromContent.isSecondary;

      var isV4 = fontFamily[0].startsWith('FontAwesome');
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;

      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);

        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName


      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);

        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }

        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var _abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
            icons: {
              main: main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix,
            iconName: iconIdentifier,
            extra: extra,
            watchable: true
          }));

          var element = DOCUMENT.createElement('svg');

          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }

          element.outerHTML = _abstract.map(function (a) {
            return toHtml(a);
          }).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

function replace(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}

function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject) {
    var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    var end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(function () {
      end();
      enableObservation();
      resolve();
    }).catch(function () {
      end();
      enableObservation();
      reject();
    });
  });
}

var PseudoElements = {
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node;

      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto: function noAuto() {
        disconnect();
      },
      watch: function watch(params) {
        var observeMutationsRoot = params.observeMutationsRoot;

        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot: observeMutationsRoot
          }));
        }
      }
    };
  }
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
    var parts = n.toLowerCase().split('-');
    var first = parts[0];
    var rest = parts.slice(1).join('-');

    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }

    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }

    rest = parseFloat(rest);

    if (isNaN(rest)) {
      return acc;
    }

    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;

      case 'shrink':
        acc.size = acc.size - rest;
        break;

      case 'left':
        acc.x = acc.x - rest;
        break;

      case 'right':
        acc.x = acc.x + rest;
        break;

      case 'up':
        acc.y = acc.y - rest;
        break;

      case 'down':
        acc.y = acc.y + rest;
        break;

      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }

    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute('data-fa-transform');

        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }

        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      var main = _ref.main,
          transform = _ref.transform,
          containerWidth = _ref.containerWidth,
          iconWidth = _ref.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer: outer,
        inner: inner,
        path: path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(_abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (_abstract.attributes && (_abstract.attributes.fill || force)) {
    _abstract.attributes.fill = 'black';
  }

  return _abstract;
}

function deGroup(_abstract2) {
  if (_abstract2.tag === 'g') {
    return _abstract2.children;
  } else {
    return [_abstract2];
  }
}

var Masks = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute('data-fa-mask');
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function (i) {
          return i.trim();
        }));

        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }

        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      var children = _ref.children,
          attributes = _ref.attributes,
          main = _ref.main,
          mask = _ref.mask,
          explicitMaskId = _ref.maskId,
          transform = _ref.transform;
      var mainWidth = main.width,
          mainPath = main.icon;
      var maskWidth = mask.width,
          maskPath = mask.icon;
      var trans = transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: 'rect',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.inner),
        children: [fillBlack(_objectSpread2({
          tag: mainPath.tag,
          attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: 'mask',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides: function provides(providers) {
    var reduceMotion = false;

    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    providers.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: 'currentColor'
      };
      var ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      }; // Ring

      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });

      var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });

      var dot = {
        tag: 'circle',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };

      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }

      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });

      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }

      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute('data-fa-symbol');
        var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon = api.icon;
var layer = api.layer;
var text = api.text;
var counter = api.counter;




/***/ }),

/***/ 82655:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AX7": function() { return /* binding */ faSpinnerThird; },
/* harmony export */   "L4e": function() { return /* binding */ faStickyNote; },
/* harmony export */   "acZ": function() { return /* binding */ faArrowLeft; },
/* harmony export */   "byT": function() { return /* binding */ faLock; },
/* harmony export */   "foy": function() { return /* binding */ faSortUp; },
/* harmony export */   "sqG": function() { return /* binding */ faInfoCircle; },
/* harmony export */   "u9C": function() { return /* binding */ faSortDown; }
/* harmony export */ });
/* unused harmony exports fad, prefix, fa0, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, faFillDrip, faArrowsToCircle, faCircleChevronRight, faChevronCircleRight, faWagonCovered, faLineHeight, faBagel, faTransporter7, faAt, faRectanglesMixed, faPhoneArrowUpRight, faPhoneArrowUp, faPhoneOutgoing, faTrashCan, faTrashAlt, faCircleL, faHeadSideGoggles, faHeadVr, faTextHeight, faUserXmark, faUserTimes, faFaceHandYawn, faGaugeSimpleMin, faTachometerSlowest, faStethoscope, faCoffin, faMessage, faCommentAlt, faSalad, faBowlSalad, faInfo, faRobotAstromech, faRingDiamond, faFonduePot, faTheta, faFaceHandPeeking, faSquareUser, faDownLeftAndUpRightToCenter, faCompressAlt, faExplosion, faFileLines, faFileAlt, faFileText, faWaveSquare, faRing, faBuildingUn, faDiceThree, faTirePressureWarning, faWifiFair, faWifi2, faCalendarDays, faCalendarAlt, faMp3Player, faAnchorCircleCheck, faTally4, faRectangleHistory, faBuildingCircleArrowRight, faVolleyball, faVolleyballBall, faSunHaze, faTextSize, faUfo, faFork, faUtensilFork, faArrowsUpToLine, faMobileSignal, faBarcodeScan, faSortDesc, faFolderArrowDown, faFolderDownload, faCircleMinus, faMinusCircle, faFaceIcicles, faShovel, faDoorOpen, faFilms, faRightFromBracket, faSignOutAlt, faFaceGlasses, faNfc, faAtom, faSoap, faIcons, faHeartMusicCameraBolt, faMicrophoneLinesSlash, faMicrophoneAltSlash, faClosedCaptioningSlash, faCalculatorSimple, faCalculatorAlt, faBridgeCircleCheck, faSlidersUp, faSlidersV, faLocationMinus, faMapMarkerMinus, faPumpMedical, faFingerprint, faSkiBoot, faStandardDefinition, faRectangleSd, faH1, faHandPointRight, faMagnifyingGlassLocation, faSearchLocation, faMessageBot, faForwardStep, faStepForward, faFaceSmileBeam, faSmileBeam, faLightCeiling, faMessageExclamation, faCommentAltExclamation, faBowlScoop, faBowlShavedIce, faSquareX, faUtilityPoleDouble, faFlagCheckered, faChevronsUp, faChevronDoubleUp, faFootball, faFootballBall, faUserVneck, faSchoolCircleExclamation, faCrop, faAnglesDown, faAngleDoubleDown, faUsersRectangle, faPeopleRoof, faSquareArrowRight, faArrowSquareRight, faLocationPlus, faMapMarkerPlus, faLightbulbExclamationOn, faPeopleLine, faBeerMugEmpty, faBeer, faCrateEmpty, faDiagramPredecessor, faTransporter, faCalendarCircleUser, faArrowUpLong, faLongArrowUp, faPersonCarryBox, faPersonCarry, faFireFlameSimple, faBurn, faPerson, faMale, faLaptop, faFileCsv, faMenorah, faUnion, faChevronsLeft, faChevronDoubleLeft, faCircleHeart, faHeartCircle, faTruckPlane, faRecordVinyl, faBringForward, faSquareP, faFaceGrinStars, faGrinStars, faSigma, faCameraMovie, faBong, faClarinet, faTruckFlatbed, faSpaghettiMonsterFlying, faPastafarianism, faArrowDownUpAcrossLine, faLeafHeart, faHouseBuilding, faCheeseSwiss, faSpoon, faUtensilSpoon, faJarWheat, faEnvelopesBulk, faMailBulk, faFileCircleExclamation, faBowArrow, faCartXmark, faHexagonXmark, faTimesHexagon, faXmarkHexagon, faCircleH, faHospitalSymbol, faMerge, faPager, faCartMinus, faAddressBook, faContactBook, faPanFrying, faGrid, faGrid3, faFootballHelmet, faHandLove, faTrees, faStrikethrough, faPage, faK, faDiagramPrevious, faGaugeMin, faTachometerAltSlowest, faFolderGrid, faEggplant, faRam, faLandmarkFlag, faLips, faPencil, faPencilAlt, faBackward, faCaretRight, faComments, faPaste, faFileClipboard, faDesktopArrowDown, faCodePullRequest, faPumpkin, faClipboardList, faPenField, faBlueberries, faTruckRampBox, faTruckLoading, faNote, faArrowDownToSquare, faUserCheck, faCloudXmark, faVialVirus, faBookBlank, faBookAlt, faGolfFlagHole, faMessageArrowDown, faCommentAltArrowDown, faFaceUnamused, faSheetPlastic, faCircle9, faBlog, faUserNinja, faPencilSlash, faBowlingPins, faPersonArrowUpFromLine, faDownRight, faScrollTorah, faTorah, faWebhook, faBlindsOpen, faFence, faUp, faArrowAltUp, faBroomBall, faQuidditch, faQuidditchBroomBall, faDrumstick, faSquareV, faFaceAwesome, faGaveDandy, faDialOff, faToggleOff, faFaceSmileHorns, faBoxArchive, faArchive, faGrapes, faPersonDrowning, faDialMax, faCircleM, faCalendarImage, faCircleCaretDown, faCaretCircleDown, faArrowDown91, faSortNumericDesc, faSortNumericDownAlt, faFaceGrinTongueSquint, faGrinTongueSquint, faShishKebab, faSprayCan, faAlarmSnooze, faScarecrow, faTruckMonster, faGiftCard, faW, faCodePullRequestDraft, faSquareB, faElephant, faEarthAfrica, faGlobeAfrica, faRainbow, faCircleNotch, faTabletScreenButton, faTabletAlt, faPaw, faMessageQuestion, faCloud, faTrowelBricks, faSquare3, faFaceFlushed, faFlushed, faHospitalUser, faMicrowave, faChfSign, faTentArrowLeftRight, faCartCircleArrowUp, faTrashClock, faGavel, faLegal, faSprinklerCeiling, faBrowsers, faTrillium, faMusicSlash, faTruckRamp, faBinoculars, faMicrophoneSlash, faBoxTissue, faCircleC, faStarChristmas, faChartBullet, faMotorcycle, faTreeChristmas, faTireFlat, faSunglasses, faBadge, faMessagePen, faCommentAltEdit, faMessageEdit, faBellConcierge, faConciergeBell, faPenRuler, faPencilRuler, faArrowProgress, faChessRookPiece, faChessRookAlt, faSquareRoot, faAlbumCollectionCirclePlus, faPeopleArrows, faPeopleArrowsLeftRight, faFaceAngryHorns, faMarsAndVenusBurst, faTombstone, faSquareCaretRight, faCaretSquareRight, faScissors, faCut, faListMusic, faSunPlantWilt, faToiletsPortable, faHockeyPuck, faMustache, faHyphen, faTable, faUserChef, faMessageImage, faCommentAltImage, faUsersMedical, faSensorTriangleExclamation, faSensorAlert, faMagnifyingGlassArrowRight, faTachographDigital, faDigitalTachograph, faFaceMask, faPickleball, faStarSharpHalf, faUsersSlash, faClover, faMeat, faReply, faMailReply, faStarAndCrescent, faEmptySet, faHouseFire, faSquareMinus, faMinusSquare, faHelicopter, faBird, faCompass, faSquareCaretDown, faCaretSquareDown, faHeartHalfStroke, faHeartHalfAlt, faFileCircleQuestion, faLaptopCode, faJoystick, faGrillFire, faRectangleVerticalHistory, faSwatchbook, faPrescriptionBottle, faBars, faNavicon, faKeyboardLeft, faPeopleGroup, faHourglassEnd, faHourglass3, faHeartCrack, faHeartBroken, faFaceBeamHandOverMouth, faDropletPercent, faHumidity, faSquareUpRight, faExternalLinkSquareAlt, faFaceKissBeam, faKissBeam, faCorn, faRollerCoaster, faPhotoFilmMusic, faRadar, faSickle, faFilm, faCoconut, faRulerHorizontal, faShieldCross, faCassetteTape, faSquareTerminal, faPeopleRobbery, faLightbulb, faCaretLeft, faCommentMiddle, faTrashCanList, faBlock, faCircleExclamation, faExclamationCircle, faSchoolCircleXmark, faArrowRightFromBracket, faSignOut, faFaceFrownSlight, faCircleChevronDown, faChevronCircleDown, faSidebarFlip, faUnlockKeyhole, faUnlockAlt, faTemperatureList, faCloudShowersHeavy, faHeadphonesSimple, faHeadphonesAlt, faSitemap, faPipeSection, faSpaceStationMoonConstruction, faSpaceStationMoonAlt, faCircleDollarToSlot, faDonate, faMemory, faFaceSleeping, faRoadSpikes, faFireBurner, faSquirrel, faArrowUpToLine, faArrowToTop, faFlag, faFaceCowboyHat, faHanukiah, faChartScatter3d, faDisplayChartUp, faSquareCode, faFeather, faVolumeLow, faVolumeDown, faXmarkToSlot, faTimesToSlot, faVoteNay, faBoxTaped, faBoxAlt, faCommentSlash, faSwords, faCloudSunRain, faAlbum, faCircleN, faCompress, faWheatAwn, faWheatAlt, faAnkh, faHandsHoldingChild, faAsterisk, faKeySkeletonLeftRight, faCommentLines, faLuchadorMask, faLuchador, faMaskLuchador, faSquareCheck, faCheckSquare, faShredder, faBookOpenCover, faBookOpenAlt, faSandwich, faPesetaSign, faSquareParkingSlash, faParkingSlash, faTrainTunnel, faHeading, faHeader, faGhost, faFaceAnguished, faHockeySticks, faAbacus, faFilmSimple, faFilmAlt, faList, faListSquares, faTreePalm, faSquarePhoneFlip, faPhoneSquareAlt, faCartPlus, faGamepad, faBorderCenterV, faCircleDot, faDotCircle, faClipboardMedical, faFaceDizzy, faDizzy, faEgg, faUpToLine, faArrowAltToTop, faHouseMedicalCircleXmark, faWatchFitness, faClockNineThirty, faCampground, faFolderPlus, faJug, faFutbol, faFutbolBall, faSoccerBall, faSnowBlowing, faPaintbrush, faPaintBrush, faArrowDownFromLine, faArrowFromTop, faGasPump, faSignalBarsSlash, faSignalAltSlash, faMonkey, faRectanglePro, faPro, faHouseNight, faHotTubPerson, faHotTub, faBlanket, faMapLocation, faMapMarked, faHouseFloodWater, faCommentsQuestionCheck, faTree, faArrowsCross, faBackpack, faSquareSmall, faFolderArrowUp, faFolderUpload, faBridgeLock, faCrosshairsSimple, faSackDollar, faPenToSquare, faEdit, faSquareSliders, faSlidersHSquare, faCarSide, faMessageMiddleTop, faCommentMiddleTopAlt, faLightbulbOn, faKnife, faUtensilKnife, faShareNodes, faShareAlt, faDisplayChartUpCircleDollar, faWaveSine, faHeartCircleMinus, faCircleW, faCircleCalendar, faCalendarCircle, faHourglassHalf, faHourglass2, faMicroscope, faSunset, faSink, faCalendarExclamation, faTruckContainerEmpty, faHandHeart, faBagShopping, faShoppingBag, faArrowDownZA, faSortAlphaDesc, faSortAlphaDownAlt, faMitten, faReplyClock, faReplyTime, faPersonRays, faRight, faArrowAltRight, faCircleF, faUsers, faFacePleading, faEyeSlash, faFlaskVial, faPoliceBox, faCucumber, faHeadSideBrain, faHand, faHandPaper, faPersonBikingMountain, faBikingMountain, faUtensilsSlash, faPrintMagnifyingGlass, faPrintSearch, faFolderBookmark, faOm, faPi, faFlaskRoundPotion, faFlaskPotion, faFaceShush, faWorm, faHouseCircleXmark, faPlug, faCalendarCircleExclamation, faSquareI, faChevronUp, faFaceSaluting, faGaugeSimpleLow, faTachometerSlow, faFacePersevering, faCircleCamera, faCameraCircle, faHandSpock, faSpiderWeb, faCircleMicrophone, faMicrophoneCircle, faBookArrowUp, faPopsicle, faCommand, faBlinds, faStopwatch, faSaxophone, faSquare2, faFieldHockeyStickBall, faFieldHockey, faArrowUpSquareTriangle, faSortShapesUpAlt, faFaceScream, faSquareM, faCameraWeb, faWebcam, faCommentArrowDown, faLightbulbCfl, faWindowFrameOpen, faFaceKiss, faKiss, faBridgeCircleXmark, faPeriod, faFaceGrinTongue, faGrinTongue, faUpToDottedLine, faThoughtBubble, faSkeletonRibs, faRaygun, faFlute, faAcorn, faVideoArrowUpRight, faGrateDroplet, faSealExclamation, faChessBishop, faMessageSms, faCoffeeBeans, faHatWitch, faFaceGrinWink, faGrinWink, faClockThreeThirty, faEarDeaf, faDeaf, faDeafness, faHardOfHearing, faAlarmClock, faEclipse, faFaceRelieved, faRoadCircleCheck, faDiceFive, faOctagonMinus, faMinusOctagon, faSquareRss, faRssSquare, faFaceZany, faTricycle, faLandMineOn, faSquareArrowUpLeft, faICursor, faChartMixedUpCircleDollar, faSaltShaker, faStamp, faFilePlus, faDrawSquare, faToiletPaperUnderSlash, faToiletPaperReverseSlash, faStairs, faDroneFront, faDroneAlt, faGlassEmpty, faDialHigh, faUserHelmetSafety, faUserConstruction, faUserHardHat, faI, faHryvniaSign, faHryvnia, faArrowDownLeftAndArrowUpRightToCenter, faPills, faFaceGrinWide, faGrinAlt, faTooth, faBasketballHoop, faObjectsAlignBottom, faV, faSparkles, faSquid, faLeafyGreen, faCircleArrowUpRight, faCalendars, faBangladeshiTakaSign, faBicycle, faHammerWar, faCircleD, faSpiderBlackWidow, faStaffSnake, faRodAsclepius, faRodSnake, faStaffAesculapius, faPear, faHeadSideCoughSlash, faTriangle, faApartment, faTruckMedical, faAmbulance, faPepper, faPiano, faGunSquirt, faWheatAwnCircleExclamation, faSnowman, faUserAlien, faShieldCheck, faMortarPestle, faRoadBarrier, faChartCandlestick, faBriefcaseBlank, faSchool, faIgloo, faBracketRound, faParenthesis, faJoint, faHorseSaddle, faMugMarshmallows, faFilters, faBellOn, faAngleRight, faDialMed, faHorse, faQ, faMonitorWaveform, faMonitorHeartRate, faLinkSimple, faWhistle, faG, faWineGlassCrack, faFragile, faSlotMachine, faNotesMedical, faCarWash, faEscalator, faCommentImage, faTemperatureHalf, faTemperature2, faThermometer2, faThermometerHalf, faDongSign, faDonut, faDoughnut, faCapsules, faPooStorm, faPooBolt, faTally1, faFaceFrownOpen, faFrownOpen, faSquareDashed, faSquareJ, faHandPointUp, faMoneyBill, faArrowUpBigSmall, faSortSizeUp, faBarcodeRead, faBaguette, faBowlSoftServe, faFaceHoldingBackTears, faSquareUp, faArrowAltSquareUp, faTrainSubwayTunnel, faSubwayTunnel, faSquareExclamation, faExclamationSquare, faSemicolon, faBookmark, faFanTable, faAlignJustify, faBatteryLow, faBattery1, faCreditCardFront, faBrainArrowCurvedRight, faMindShare, faUmbrellaBeach, faHelmetUn, faLocationSmile, faMapMarkerSmile, faArrowLeftToLine, faArrowToLeft, faBullseye, faSushi, faNigiri, faMessageCaptions, faCommentAltCaptions, faTrashList, faBacon, faOption, faHandPointDown, faArrowUpFromBracket, faTrashPlus, faObjectsAlignTop, faFolder, faFolderBlank, faFaceAnxiousSweat, faCreditCardBlank, faFileWaveform, faFileMedicalAlt, faMicrochipAi, faMug, faPlaneUpSlash, faRadiation, faPenCircle, faBagSeedling, faChartSimple, faCrutches, faCircleParking, faParkingCircle, faMarsStroke, faLeafOak, faSquareBolt, faVial, faGauge, faDashboard, faGaugeMed, faTachometerAltAverage, faWandMagicSparkles, faMagicWandSparkles, faLambda, faE, faPizza, faBowlChopsticksNoodles, faH3, faPenClip, faPenAlt, faBridgeCircleExclamation, faBadgePercent, faUser, faSensor, faComma, faSchoolCircleCheck, faToiletPaperUnder, faToiletPaperReverse, faLightEmergency, faArrowDownToArc, faDumpster, faVanShuttle, faShuttleVan, faBuildingUser, faLightSwitch, faSquareCaretLeft, faCaretSquareLeft, faHighlighter, faWavePulse, faHeartRate, faKey, faHatSanta, faTamale, faBoxCheck, faBullhorn, faSteak, faLocationCrosshairsSlash, faLocationSlash, faPersonDolly, faGlobe, faSynagogue, faFileChartColumn, faFileChartLine, faPersonHalfDress, faFolderImage, faCalendarPen, faCalendarEdit, faRoadBridge, faFaceSmileTear, faMessagePlus, faCommentAltPlus, faLocationArrow, faC, faTabletButton, faRectangleHistoryCircleUser, faBuildingLock, faChartLineUp, faMailbox, faTruckBolt, faPizzaSlice, faMoneyBillWave, faChartArea, faAreaChart, faHouseFlag, faCircleThreeQuartersStroke, faPersonCircleMinus, faScalpel, faBan, faCancel, faBellExclamation, faCircleBookmark, faBookmarkCircle, faEggFried, faFaceWeary, faUniformMartialArts, faCameraRotate, faSunDust, faCommentText, faSprayCanSparkles, faAirFreshener, faSignalBars, faSignalAlt, faSignalAlt4, faSignalBarsStrong, faDiamondExclamation, faStar, faDialMin, faRepeat, faCross, faPageCaretDown, faFileCaretDown, faBox, faVenusMars, faClockSevenThirty, faArrowPointer, faMousePointer, faClockFourThirty, faSignalBarsGood, faSignalAlt3, faCactus, faLightbulbGear, faMaximize, faExpandArrowsAlt, faChargingStation, faShapes, faTriangleCircleSquare, faPlaneTail, faGaugeSimpleMax, faTachometerFastest, faCircleU, faShieldSlash, faSquarePhoneHangup, faPhoneSquareDown, faArrowUpLeft, faTransporter1, faPeanuts, faShuffle, faRandom, faPersonRunning, faRunning, faMobileRetro, faGripLinesVertical, faBinBottlesRecycle, faArrowUpFromSquare, faFileDashedLine, faPageBreak, faBracketCurlyRight, faSpider, faClockThree, faHandsBound, faScalpelLineDashed, faScalpelPath, faFileInvoiceDollar, faPipeSmoking, faFaceAstonished, faWindow, faPlaneCircleExclamation, faEar, faFileLock, faDiagramVenn, faXRay, faGoalNet, faCoffinCross, faSpellCheck, faLocationXmark, faMapMarkerTimes, faMapMarkerXmark, faCircleQuarterStroke, faLasso, faSlash, faPersonToPortal, faPortalEnter, faCalendarStar, faComputerMouse, faMouse, faArrowRightToBracket, faSignIn, faPegasus, faFilesMedical, faNfcLock, faPersonSkiLift, faSkiLift, faSquare6, faShopSlash, faStoreAltSlash, faWindTurbine, faSlidersSimple, faGridRound, faBadgeSheriff, faServer, faVirusCovidSlash, faIntersection, faShopLock, faFamily, faHourglassStart, faHourglass1, faUserHairBuns, faBlenderPhone, faHourglassClock, faPersonSeatReclined, faPaperPlaneTop, faPaperPlaneAlt, faSend, faMessageArrowUp, faCommentAltArrowUp, faLightbulbExclamation, faLayerMinus, faLayerGroupMinus, faChartPieSimpleCircleCurrency, faCircleE, faBuildingWheat, faGaugeMax, faTachometerAltFastest, faPersonBreastfeeding, faApostrophe, faFireHydrant, faRightToBracket, faSignInAlt, faVideoPlus, faSquareRight, faArrowAltSquareRight, faCommentSmile, faVenus, faPassport, faInboxIn, faInboxArrowDown, faHeartPulse, faHeartbeat, faCircle8, faCloudsMoon, faClockTenThirty, faPeopleCarryBox, faPeopleCarry, faFolderUser, faTrashCanXmark, faTemperatureHigh, faMicrochip, faLeftLongToLine, faCrown, faWeightHanging, faXmarksLines, faFilePrescription, faCalendarRange, faFlowerDaffodil, faHandBackPointUp, faWeightScale, faWeight, faStarExclamation, faBooks, faUserGroup, faUserFriends, faArrowUpAZ, faSortAlphaUp, faLayerPlus, faLayerGroupPlus, faPlayPause, faBlockQuestion, faSnooze, faZzz, faScannerImage, faTvRetro, faSquareT, faFarm, faBarnSilo, faChessKnight, faBarsSort, faPalletBoxes, faPaletteBoxes, faPalletAlt, faFaceLaughSquint, faLaughSquint, faCodeSimple, faBoltSlash, faPanelFire, faBinaryCircleCheck, faCommentMinus, faBurrito, faViolin, faObjectsColumn, faSquareChevronDown, faChevronSquareDown, faCommentPlus, faTriangleInstrument, faTriangleMusic, faWheelchair, faUserPilotTie, faPianoKeyboard, faBedEmpty, faCircleArrowUp, faArrowCircleUp, faToggleOn, faRectangleVertical, faRectanglePortrait, faPersonWalking, faWalking, faL, faSignalStream, faDownToBracket, faCircleZ, faStars, faFire, faBedPulse, faProcedures, faHouseDay, faShuttleSpace, faSpaceShuttle, faShirtLongSleeve, faChartPieSimple, faChartPieAlt, faFaceLaugh, faLaugh, faFolderOpen, faAlbumCollectionCircleUser, faCandy, faBowlHot, faSoup, faFlatbread, faHeartCirclePlus, faCodeFork, faCity, faSignalBarsWeak, faSignalAlt1, faMicrophoneLines, faMicrophoneAlt, faClockTwelve, faPepperHot, faCitrusSlice, faSheep, faUnlock, faColonSign, faHeadset, faBadgerHoney, faH4, faStoreSlash, faRoadCircleXmark, faSignalSlash, faUserMinus, faMarsStrokeUp, faMarsStrokeV, faChampagneGlasses, faGlassCheers, faTaco, faHexagonPlus, faPlusHexagon, faClipboard, faHouseCircleExclamation, faFileArrowUp, faFileUpload, faWifi, faWifi3, faWifiStrong, faMessages, faCommentsAlt, faBath, faBathtub, faUmbrellaSimple, faUmbrellaAlt, faRectangleHistoryCirclePlus, faUnderline, faPrescriptionBottlePill, faUserPen, faUserEdit, faBinarySlash, faSquareO, faSignature, faStroopwafel, faBold, faAnchorLock, faBuildingNgo, faTransporter3, faEngineWarning, faEngineExclamation, faCircleDownRight, faSquareK, faManatSign, faMoneyCheckPen, faMoneyCheckEdit, faNotEqual, faBorderTopLeft, faBorderStyle, faMapLocationDot, faMapMarkedAlt, faTilde, faJedi, faSquarePollVertical, faPoll, faArrowDownSquareTriangle, faSortShapesDownAlt, faMugHot, faDogLeashed, faCarBattery, faBatteryCar, faFaceDowncastSweat, faMailboxFlagUp, faMemoCircleInfo, faGift, faDiceTwo, faVolume, faVolumeMedium, faTransporter5, faGaugeCircleBolt, faCoinFront, faFileSlash, faMessageArrowUpRight, faTreasureChest, faChessQueen, faPaintbrushFine, faPaintBrushAlt, faPaintBrushFine, faPaintbrushAlt, faGlasses, faHoodCloak, faSquareQuote, faUpLeft, faBringFront, faChessBoard, faBurgerCheese, faCheeseburger, faBuildingCircleCheck, faRepeat1, faArrowDownToLine, faArrowToBottom, faGrid5, faRightLongToLine, faPersonChalkboard, faMarsStrokeRight, faMarsStrokeH, faHandBackFist, faHandRock, faGridRound5, faTally, faTally5, faSquareCaretUp, faCaretSquareUp, faCloudShowersWater, faChartBar, faBarChart, faHandsBubbles, faHandsWash, faLessThanEqual, faTrain, faUpFromDottedLine, faEyeLowVision, faLowVision, faTrafficLightGo, faFaceExhaling, faSensorFire, faUserUnlock, faHexagonDivide, fa00, faCrow, faCassetteBetamax, faBetamax, faSailboat, faWindowRestore, faNfcMagnifyingGlass, faFileBinary, faCircleV, faSquarePlus, faPlusSquare, faBowlScoops, faMistletoe, faCustard, faLacrosseStick, faHockeyMask, faSunrise, faPanelEws, faToriiGate, faCloudExclamation, faMessageLines, faCommentAltLines, faFrog, faBucket, faFloppyDiskPen, faImage, faWindowFrame, faMicrophone, faCow, faFileZip, faSquareRing, faDownFromLine, faArrowAltFromTop, faCaretUp, faShieldXmark, faShieldTimes, faScrewdriver, faCircleSortDown, faSortCircleDown, faFolderClosed, faHouseTsunami, faSquareNfi, faForklift, faArrowUpFromGroundWater, faBracketSquareRight, faMartiniGlass, faGlassMartiniAlt, faRotateLeft, faRotateBack, faRotateBackward, faUndoAlt, faTableColumns, faColumns, faSquareA, faTick, faLemon, faHeadSideMask, faHandshake, faGem, faDolly, faDollyBox, faSmoking, faMinimize, faCompressArrowsAlt, faRefrigerator, faMonument, faOctagonXmark, faTimesOctagon, faXmarkOctagon, faAlignSlash, faSnowplow, faAnglesRight, faAngleDoubleRight, faTruckRampCouch, faTruckCouch, faCannabis, faCirclePlay, faPlayCircle, faArrowUpRightAndArrowDownLeftFromCenter, faTablets, fa360Degrees, faEthernet, faEuroSign, faEur, faEuro, faChair, faCircleCheck, faCheckCircle, faSquareDashedCirclePlus, faMoneySimpleFromBracket, faBat, faCircleStop, faStopCircle, faHeadSideHeadphones, faPhoneRotary, faCompassDrafting, faDraftingCompass, faPlateWheat, faCalendarCircleMinus, faChopsticks, faCarWrench, faCarMechanic, faIcicles, faPersonShelter, faNeuter, faIdBadge, faKazoo, faMarker, faBinBottles, faFaceLaughBeam, faLaughBeam, faSquareArrowDownLeft, faBatteryBolt, faTreeLarge, faHelicopterSymbol, faAperture, faUniversalAccess, faGearComplex, faFileMagnifyingGlass, faFileSearch, faUpRight, faCircleChevronUp, faChevronCircleUp, faUserPolice, faLariSign, faVolcano, faTeddyBear, faStocking, faPersonWalkingDashedLineArrowRight, faImageSlash, faMaskSnorkel, faSmoke, faSterlingSign, faGbp, faPoundSign, faBatteryExclamation, faViruses, faSquarePersonConfined, faUserTie, faArrowDownLong, faLongArrowDown, faTentArrowDownToLine, faCertificate, faCrystalBall, faReplyAll, faMailReplyAll, faSuitcase, faPersonSkating, faSkating, faStarShooting, faBinaryLock, faFilterCircleDollar, faFunnelDollar, faCameraRetro, faCircleArrowDown, faArrowCircleDown, faCommentPen, faCommentEdit, faFileImport, faArrowRightToFile, faBanjo, faSquareArrowUpRight, faExternalLinkSquare, faLightEmergencyOn, faKerning, faBoxOpen, faSquareF, faScroll, faSpa, faArrowLeftFromLine, faArrowFromRight, faStrawberry, faLocationPinLock, faPause, faClockEightThirty, faPlaneEngines, faPlaneAlt, faHillAvalanche, faTemperatureEmpty, faTemperature0, faThermometer0, faThermometerEmpty, faBomb, faGaugeLow, faTachometerAltSlow, faRegistered, faTrashCanPlus, faAddressCard, faContactCard, faVcard, faScaleUnbalancedFlip, faBalanceScaleRight, faGlobeSnow, faSubscript, faDiamondTurnRight, faDirections, faIntegral, faBurst, faHouseLaptop, faLaptopHouse, faFaceTired, faTired, faMoneyBills, faBlindsRaised, faSmog, faUfoBeam, faCircleCaretUp, faCaretCircleUp, faUserVneckHairLong, faSquareALock, faCrutch, faGasPumpSlash, faFontAwesome, faFontAwesomeFlag, faFontAwesomeLogoFull, faCloudArrowUp, faCloudUpload, faCloudUploadAlt, faPalette, faTransporter4, faChartMixedUpCircleCurrency, faObjectsAlignRight, faArrowsTurnRight, faVest, faPig, faInboxFull, faCircleEnvelope, faEnvelopeCircle, faTrianglePersonDigging, faConstruction, faFerry, faBullseyeArrow, faArrowsDownToPeople, faSeedling, faSprout, faClockSeven, faLeftRight, faArrowsAltH, faBoxesPacking, faCircleArrowLeft, faArrowCircleLeft, faFlashlight, faGroupArrowsRotate, faBowlFood, faSquare9, faCandyCane, faArrowDownWideShort, faSortAmountAsc, faSortAmountDown, faSquareDollar, faDollarSquare, faUsdSquare, faPhoneArrowRight, faHandHoldingSeedling, faMessageCheck, faCommentAltCheck, faCloudBolt, faThunderstorm, faChartLineUpDown, faTextSlash, faRemoveFormat, faWatch, faCircleDownLeft, faText, faProjector, faFaceSmileWink, faSmileWink, faTombstoneBlank, faTombstoneAlt, faChessKingPiece, faChessKingAlt, faCircle6, faLeft, faArrowAltLeft, faFileWord, faFilePowerpoint, faSquareDown, faArrowAltSquareDown, faObjectsAlignCenterVertical, faArrowsLeftRight, faArrowsH, faHouseLock, faCloudArrowDown, faCloudDownload, faCloudDownloadAlt, faWreath, faChildren, faMeterDroplet, faChalkboard, faBlackboard, faUserLargeSlash, faUserAltSlash, faSignalStrong, faSignal4, faLollipop, faLollypop, faListTree, faEnvelopeOpen, faDrawCircle, faCatSpace, faHandshakeSimpleSlash, faHandshakeAltSlash, faRabbitRunning, faRabbitFast, faMemoPad, faMattressPillow, faAlarmPlus, faAlicorn, faCommentQuestion, faGingerbreadMan, faGuaraniSign, faBurgerFries, faMugTea, faBorderTop, faArrowsRotate, faRefresh, faSync, faCircleBookOpen, faBookCircle, faArrowsToDottedLine, faFireExtinguisher, faGarageOpen, faShelvesEmpty, faCruzeiroSign, faWatchApple, faWatchCalculator, faListDropdown, faCabinetFiling, faBurgerSoda, faSquareArrowUp, faArrowSquareUp, faGreaterThanEqual, faPalletBox, faFaceConfounded, faShieldHalved, faShieldAlt, faTruckPlow, faBookAtlas, faAtlas, faVirus, faGridRound2, faCommentMiddleTop, faEnvelopeCircleCheck, faLayerGroup, faRestroomSimple, faArrowsToDot, faBorderOuter, faHashtagLock, faClockTwoThirty, faArchway, faHeartCircleCheck, faHouseChimneyCrack, faHouseDamage, faFileZipper, faFileArchive, faHeartHalf, faCommentCheck, faSquare, faMemo, faMartiniGlassEmpty, faGlassMartini, faCouch, faCediSign, faItalic, faGlassCitrus, faCalendarLinesPen, faChurch, faPersonSnowmobiling, faSnowmobile, faFaceHushed, faCommentsDollar, faPickaxe, faLinkSimpleSlash, faDemocrat, faFaceConfused, faPinball, faZ, faPersonSkiing, faSkiing, faDeer, faInputPipe, faRoadLock, faA, faBookmarkSlash, faTemperatureArrowDown, faTemperatureDown, faMace, faFeatherPointed, faFeatherAlt, faSausage, faTrashCanClock, faP, faBroomWide, faSnowflake, faStomach, faNewspaper, faRectangleAd, faAd, faGuitarElectric, faArrowTurnDownRight, faMoonCloud, faBreadSliceButter, faCircleArrowRight, faArrowCircleRight, faUserGroupCrown, faUsersCrown, faCircleI, faToiletPaperCheck, faFilterCircleXmark, faLocust, faSort, faUnsorted, faListOl, faList12, faListNumeric, faChartWaterfall, faSparkle, faFaceParty, faKidneys, faWifiExclamation, faChartNetwork, faPersonDressBurst, faDiceD4, faMoneyCheckDollar, faMoneyCheckAlt, faVectorSquare, faBreadSlice, faLanguage, faWheatAwnSlash, faFaceKissWinkHeart, faKissWinkHeart, faDagger, faPodium, faMemoCircleCheck, faRouteHighway, faDownToLine, faArrowAltToBottom, faFilter, faSquareG, faCirclePhone, faPhoneCircle, faClipboardPrescription, faUserNurseHair, faQuestion, faFileSignature, faToggleLargeOn, faUpDownLeftRight, faArrowsAlt, faDryerHeat, faDryerAlt, faHouseChimneyUser, faHandHoldingHeart, faArrowUpSmallBig, faSortSizeUpAlt, faTrainTrack, faPuzzlePiece, faMoneyCheck, faStarHalfStroke, faStarHalfAlt, faFileExclamation, faCode, faWhiskeyGlass, faGlassWhiskey, faMoonStars, faBuildingCircleExclamation, faClothesHanger, faMobileNotch, faMobileIphone, faMagnifyingGlassChart, faArrowUpRightFromSquare, faExternalLink, faCubesStacked, faImagesUser, faWonSign, faKrw, faWon, faImagePolaroidUser, faVirusCovid, faSquareEllipsis, faPie, faChessKnightPiece, faChessKnightAlt, faAustralSign, faCloudPlus, faF, faLeaf, faBedBunk, faRoad, faTaxi, faCab, faPersonCirclePlus, faChartPie, faPieChart, faBoltLightning, faClockEight, faSackXmark, faFileExcel, faFileContract, faFishFins, faCircleQ, faBuildingFlag, faFaceGrinBeam, faGrinBeam, faObjectUngroup, faFaceDisguise, faCircleArrowDownRight, faAlien8bit, faAlienMonster, faHandPointRibbon, faPoop, faObjectExclude, faTelescope, faLocationPin, faMapMarker, faSquareList, faKaaba, faToiletPaper, faHelmetSafety, faHardHat, faHatHard, faCommentCode, faSimCards, faStarship, faEject, faCircleRight, faArrowAltCircleRight, faPlaneCircleCheck, faSeal, faUserCowboy, faHexagonVerticalNft, faFaceRollingEyes, faMehRollingEyes, faBreadLoaf, faRingsWedding, faObjectGroup, faFrenchFries, faChartLine, faLineChart, faCalendarArrowDown, faCalendarDownload, faSendBack, faMaskVentilator, faSignatureLock, faArrowRight, faSignsPost, faMapSigns, faOctagonPlus, faPlusOctagon, faCashRegister, faPersonCircleQuestion, faMelonSlice, faSpaceStationMoon, faMessageSmile, faCommentAltSmile, faCupStraw, faLeftFromLine, faArrowAltFromRight, faH, faBasketShoppingSimple, faShoppingBasketAlt, faHandsHoldingHeart, faHandsHeart, faClockNine, faTarp, faFaceSleepy, faHandHorns, faScrewdriverWrench, faTools, faArrowsToEye, faCircleThreeQuarters, faTrophyStar, faTrophyAlt, faPlugCircleBolt, faFaceThermometer, faGridRound4, faShirtRunning, faBookCircleArrowUp, faFaceNauseated, faHeart, faFileChartPie, faMarsAndVenus, faHouseUser, faHomeUser, faCircleArrowDownLeft, faDumpsterFire, faHexagonMinus, faMinusHexagon, faLeftToLine, faArrowAltToLeft, faHouseCrack, faPawSimple, faPawAlt, faArrowLeftLongToLine, faBracketsRound, faParentheses, faMartiniGlassCitrus, faCocktail, faUserShakespeare, faArrowRightToArc, faFaceSurprise, faSurprise, faBottleWater, faCirclePause, faPauseCircle, faGaugeCirclePlus, faFolders, faAngel, faValueAbsolute, faRabbit, faToiletPaperSlash, faCircleEuro, faAppleWhole, faAppleAlt, faKitchenSet, faDiamondHalf, faLockKeyhole, faLockAlt, faR, faTemperatureQuarter, faTemperature1, faThermometer1, faThermometerQuarter, faSquareInfo, faInfoSquare, faWifiSlash, faToiletPaperXmark, faHandsHoldingDollar, faHandsUsd, faCube, faArrowDownTriangleSquare, faSortShapesDown, faBitcoinSign, faShutters, faShieldDog, faSolarPanel, faLockOpen, faTableTree, faHouseChimneyHeart, faTally3, faElevator, faMoneyBillTransfer, faMoneyBillTrendUp, faHouseFloodWaterCircleArrowRight, faSquarePollHorizontal, faPollH, faCircle, faCartCircleExclamation, faSword, faBackwardFast, faFastBackward, faRecycle, faUserAstronaut, faInterrobang, faPlaneSlash, faCircleDashed, faTrademark, faBasketball, faBasketballBall, faForkKnife, faUtensilsAlt, faSatelliteDish, faBadgeCheck, faCircleUp, faArrowAltCircleUp, faSlider, faMobileScreenButton, faMobileAlt, faClockOneThirty, faInboxOut, faInboxArrowUp, faCloudSlash, faVolumeHigh, faVolumeUp, faUsersRays, faWallet, faOctagonCheck, faFlatbreadStuffed, faClipboardCheck, faCartCirclePlus, faTruckClock, faShippingTimed, faPool8Ball, faFileAudio, faTurnDownLeft, faLockHashtag, faChartRadar, faStaff, faBurger, faHamburger, faUtilityPole, faTransporter6, faWrench, faBugs, faVectorPolygon, faDiagramNested, faRupeeSign, faRupee, faFileImage, faCircleQuestion, faQuestionCircle, faImageUser, faBuoy, faPlaneDeparture, faHandshakeSlash, faBookBookmark, faBorderCenterH, faCanFood, faTypewriter, faArrowRightFromArc, faCircleK, faFaceHandOverMouth, faPopcorn, faHouseWater, faHouseFlood, faObjectSubtract, faCodeBranch, faWarehouseFull, faWarehouseAlt, faHatCowboy, faBridge, faPhoneFlip, faPhoneAlt, faArrowDownFromDottedLine, faFileDoc, faSquareQuarters, faTruckFront, faCat, faTrashXmark, faCircleCaretLeft, faCaretCircleLeft, faFiles, faAnchorCircleExclamation, faFaceClouds, faUserCrown, faTruckField, faRoute, faCartCircleCheck, faClipboardQuestion, faPanorama, faCommentMedical, faTeethOpen, faUserTieHairLong, faFileCircleMinus, faHeadSideMedical, faTags, faWineGlass, faForwardFast, faFastForward, faFaceMehBlank, faMehBlank, faUserRobot, faSquareParking, faParking, faCardDiamond, faFaceZipper, faFaceRaisedEyebrow, faHouseSignal, faSquareChevronUp, faChevronSquareUp, faNfcSymbol, faBarsProgress, faTasksAlt, faFaucetDrip, faArrowsToLine, faDolphin, faArrowUpRight, faCircleR, faCartFlatbed, faDollyFlatbed, faBanSmoking, faSmokingBan, faCircleSortUp, faSortCircleUp, faTerminal, faMobileButton, faHouseMedicalFlag, faBasketShopping, faShoppingBasket, faTape, faChestnut, faBusSimple, faBusAlt, faEye, faFaceSadCry, faSadCry, faHeat, faTicketAirline, faBootHeeled, faArrowsMinimize, faCompressArrows, faAudioDescription, faPersonMilitaryToPerson, faFileShield, faHexagon, faManhole, faUserSlash, faPen, faTowerObservation, faFloppyDisks, faToiletPaperBlankUnder, faToiletPaperReverseAlt, faFileCode, faSignal, faSignal5, faSignalPerfect, faPump, faBus, faHeartCircleXmark, faArrowUpLeftFromCircle, faHouseChimney, faHomeLg, faWindowMaximize, faDryer, faFaceFrown, faFrown, faChessBishopPiece, faChessBishopAlt, faShirtTankTop, faDiploma, faScrollRibbon, faScreencast, faWalker, faPrescription, faShop, faStoreAlt, faFloppyDisk, faSave, faVihara, faFaceKissClosedEyes, faScaleUnbalanced, faBalanceScaleLeft, faFileUser, faUserPoliceTie, faFaceTongueMoney, faTennisBall, faSquareL, faSortAsc, faCalendarArrowUp, faCalendarUpload, faCommentDots, faCommenting, faPlantWilt, faScarf, faAlbumCirclePlus, faUserNurseHairLong, faDiamond, faSquareLeft, faArrowAltSquareLeft, faFaceGrinSquint, faGrinSquint, faCircleEllipsisVertical, faHandHoldingDollar, faHandHoldingUsd, faGridDividers, faBacterium, faHandPointer, faDrumSteelpan, faHandScissors, faHandsPraying, faPrayingHands, faFacePensive, faUserMusic, faArrowRotateRight, faArrowRightRotate, faArrowRotateForward, faRedo, faMessagesDollar, faCommentsAltDollar, faSensorOn, faBalloon, faBiohazard, faChessQueenPiece, faChessQueenAlt, faLocationCrosshairs, faLocation, faMarsDouble, faHousePersonLeave, faHouseLeave, faHousePersonDepart, faRulerTriangle, faCardClub, faChildDress, faUsersBetweenLines, faLungsVirus, faFaceGrinTears, faGrinTears, faPhone, faComputerMouseScrollwheel, faMouseAlt, faCalendarXmark, faCalendarTimes, faChildReaching, faTableLayout, faNarwhal, faRampLoading, faCalendarCirclePlus, faToothbrush, faBorderInner, faPawClaws, faKiwiFruit, faTrafficLightSlow, faRectangleCode, faHeadSideVirus, faKeyboardBrightness, faBooksMedical, faLightbulbSlash, faHouseBlank, faHomeBlank, faSquare5, faSquareHeart, faHeartSquare, faPuzzle, faUserGear, faUserCog, faPipeCircleCheck, faArrowUp19, faSortNumericUp, faOctagonExclamation, faDialLow, faDoorClosed, faLaptopMobile, faPhoneLaptop, faConveyorBeltBoxes, faConveyorBeltAlt, faShieldVirus, faStarfighterTwinIonEngineAdvanced, faStarfighterAltAdvanced, faDiceSix, faStarfighterTwinIonEngine, faStarfighterAlt, faRocketLaunch, faMosquitoNet, faVentDamper, faBridgeWater, faBanBug, faDebug, faPersonBooth, faTextWidth, faGarageCar, faSquareKanban, faHatWizard, faPenFancy, faCoffeePot, faMouseField, faPersonDigging, faDigging, faShowerDown, faShowerAlt, faBoxCircleCheck, faBrightness, faCarSideBolt, faOrnament, faPhoneArrowDownLeft, faPhoneArrowDown, faPhoneIncoming, faCloudWord, faHandFingersCrossed, faTrash, faGaugeSimple, faGaugeSimpleMed, faTachometerAverage, faArrowDownSmallBig, faSortSizeDownAlt, faBookMedical, faFaceMelting, faPoo, faPenClipSlash, faPenAltSlash, faQuoteRight, faQuoteRightAlt, faScrollOld, faGuitars, faPhoneXmark, faHose, faClockSix, faShirt, faTShirt, faTshirt, faBillboard, faSquareR, faCubes, faEnvelopeOpenDollar, faDivide, faSunCloud, faLampFloor, faSquare7, faTengeSign, faTenge, faHeadphones, faHandsHolding, faCampfire, faCircleAmpersand, faSnowflakes, faHandsClapping, faRepublican, faLeafMaple, faPersonCircleXmark, faRuler, faCupStrawSwoosh, faTemperatureSun, faTemperatureHot, faAlignLeft, faDiceD6, faRestroom, faHighDefinition, faRectangleHd, faJ, faGalaxy, faUsersViewfinder, faFileVideo, faCherries, faUpRightFromSquare, faExternalLinkAlt, faCircleSort, faSortCircle, faTableCells, faTh, faFilePdf, faSiren, faArrowUpToDottedLine, faImageLandscape, faLandscape, faTankWater, faCurlingStone, faCurling, faGamepadModern, faGamepadAlt, faMessagesQuestion, faBookBible, faBible, faO, faSuitcaseMedical, faMedkit, faBriefcaseArrowRight, faExpandWide, faClockElevenThirty, faRv, faUserSecret, faOtter, faDreidel, faPersonDress, faFemale, faCommentDollar, faBusinessTime, faBriefcaseClock, faFlowerTulip, faPeoplePantsSimple, faCloudDrizzle, faTableCellsLarge, faThLarge, faBookTanakh, faTanakh, faSolarSystem, faSealQuestion, faPhoneVolume, faVolumeControlPhone, faDiscDrive, faHatCowboySide, faTableRows, faRows, faLocationExclamation, faMapMarkerExclamation, faFaceFearful, faClipboardUser, faBusSchool, faFilmSlash, faSquareArrowDownRight, faBookSparkles, faBookSpells, faWashingMachine, faWasher, faChild, faLiraSign, faUserVisor, faFilePlusMinus, faChessClockFlip, faChessClockAlt, faSatellite, faPlaneLock, faSteeringWheel, faTag, faStretcher, faBookSection, faBookLaw, faInboxes, faCoffeeBean, faCircleYen, faBracketsCurly, faEllipsisStrokeVertical, faEllipsisVAlt, faComment, faSquare1, faCakeCandles, faBirthdayCake, faCake, faHeadSide, faEnvelope, faDollyEmpty, faFaceTissue, faAnglesUp, faAngleDoubleUp, faBinRecycle, faPaperclip, faChartLineDown, faArrowRightToCity, faLockA, faRibbon, faLungs, faPersonPinball, faArrowUp91, faSortNumericUpAlt, faAppleCore, faCircleY, faH6, faLitecoinSign, faCircleSmall, faBorderNone, faArrowTurnDownLeft, faCircleNodes, faParachuteBox, faMessageMedical, faCommentAltMedical, faRugbyBall, faCommentMusic, faIndent, faTreeDeciduous, faTreeAlt, faPuzzlePieceSimple, faPuzzlePieceAlt, faTruckFieldUn, faNfcTrash, faHourglass, faHourglassEmpty, faMountain, faFileXmark, faFileTimes, faHouseHeart, faHomeHeart, faHouseChimneyBlank, faMeterBolt, faUserDoctor, faUserMd, faSlashBack, faCircleInfo, faFishingRod, faHammerCrash, faMessageHeart, faCloudMeatball, faCameraPolaroid, faCamera, faCameraAlt, faSquareVirus, faCartArrowUp, faMeteor, faCarOn, faSleigh, faArrowDown19, faSortNumericAsc, faSortNumericDown, faBuoyMooring, faSquare4, faHandHoldingDroplet, faHandHoldingWater, faTricycleAdult, faWaveform, faWater, faStarSharpHalfStroke, faStarSharpHalfAlt, faNfcSignal, faPlaneProp, faCalendarCheck, faClockDesk, faCalendarClock, faCalendarTime, faBraille, faPrescriptionBottleMedical, faPrescriptionBottleAlt, faPlateUtensils, faFamilyPants, faHoseReel, faHouseWindow, faLandmark, faTruck, faCrosshairs, faCloudRainbow, faPersonCane, faAlien, faTent, faLaptopBinary, faVestPatches, faPeopleDressSimple, faCheckDouble, faArrowDownAZ, faSortAlphaAsc, faSortAlphaDown, faBowlingBallPin, faBellSchoolSlash, faPlusLarge, faMoneyBillWheat, faCameraViewfinder, faScreenshot, faMessageMusic, faCommentAltMusic, faCarBuilding, faBorderBottomRight, faBorderStyleAlt, faOctagon, faCommentArrowUpRight, faOctagonDivide, faCookie, faArrowRotateLeft, faArrowLeftRotate, faArrowRotateBack, faArrowRotateBackward, faUndo, faTvMusic, faHardDrive, faHdd, faReel, faFaceGrinSquintTears, faGrinSquintTears, faDumbbell, faRectangleList, faListAlt, faTarpDroplet, faAlarmExclamation, faHouseMedicalCircleCheck, faTrafficCone, faGrate, faArrowDownRight, faPersonSkiingNordic, faSkiingNordic, faCalendarPlus, faPersonFromPortal, faPortalExit, faPlaneArrival, faCowbellCirclePlus, faCowbellMore, faCircleLeft, faArrowAltCircleLeft, faDistributeSpacingVertical, faSignalBarsFair, faSignalAlt2, faSportsball, faGameConsoleHandheldCrank, faTrainSubway, faSubway, faChartGantt, faFaceSmileUpsideDown, faBallPile, faBadgeDollar, faMoneyBillsSimple, faMoneyBillsAlt, faListTimeline, faIndianRupeeSign, faIndianRupee, faInr, faCropSimple, faCropAlt, faMoneyBill1, faMoneyBillAlt, faLeftLong, faLongArrowAltLeft, faKeyboardDown, faCircleUpRight, faCloudBoltMoon, faThunderstormMoon, faDna, faVirusSlash, faBracketRoundRight, faCircleSterling, faCircle5, faMinus, faSubtract, faFireFlame, faFlame, faRightToLine, faArrowAltToRight, faGif, faChess, faTrashSlash, faArrowLeftLong, faLongArrowLeft, faPlugCircleCheck, faFontCase, faStreetView, faArrowDownLeft, faFrancSign, faFlaskRoundPoison, faFlaskPoison, faVolumeOff, faBookCircleArrowRight, faChartUser, faUserChart, faHandsAslInterpreting, faAmericanSignLanguageInterpreting, faAslInterpreting, faHandsAmericanSignLanguageInterpreting, faPresentationScreen, faPresentation, faCircleBolt, faFaceSmileHalo, faCartCircleArrowDown, faHousePersonReturn, faHousePersonArrive, faHouseReturn, faMessageXmark, faCommentAltTimes, faMessageTimes, faFileCertificate, faFileAward, faUserDoctorHairLong, faCameraSecurity, faCameraHome, faGear, faCog, faDropletSlash, faTintSlash, faBookHeart, faMosque, faDuck, faMosquito, faStarOfDavid, faFlagSwallowtail, faFlagAlt, faPersonMilitaryRifle, faCarGarage, faCartShopping, faShoppingCart, faBookFont, faShieldPlus, faVials, faEyeDropperFull, faDistributeSpacingHorizontal, faTabletRugged, faTemperatureSnow, faTemperatureFrigid, faMoped, faFaceSmilePlus, faSmilePlus, faRadioTuner, faRadioAlt, faFaceSwear, faWaterArrowDown, faWaterLower, faScannerTouchscreen, faCircle7, faPlugCirclePlus, faPersonSkiJumping, faSkiJump, faPlaceOfWorship, faWaterArrowUp, faWaterRise, faWaveformLines, faWaveformPath, faSplit, faFilmCanister, faFilmCannister, faFolderXmark, faFolderTimes, faToiletPaperBlank, faToiletPaperAlt, faTabletScreen, faTabletAndroidAlt, faHexagonVerticalNftSlanted, faFolderMusic, faDisplayMedical, faDesktopMedical, faShareAll, faPeapod, faChessClock, faAxe, faSquareD, faGripVertical, faMobileSignalOut, faArrowTurnUp, faLevelUp, faU, faArrowUpFromDottedLine, faSquareRootVariable, faSquareRootAlt, faLightSwitchOn, faArrowDownArrowUp, faSortAlt, faRaindrops, faDash, faMinusLarge, faClock, faClockFour, faInputNumeric, faTruckTow, faBackwardStep, faStepBackward, faPallet, faCarBolt, faArrowsMaximize, faExpandArrows, faFaucet, faCloudSleet, faLampStreet, faListRadio, faPenNibSlash, faBaseballBatBall, faSquareUpLeft, faOverline, faS, faTimeline, faKeyboard, faArrowsFromDottedLine, faUsbDrive, faBallot, faCaretDown, faLocationDotSlash, faMapMarkerAltSlash, faCards, faHouseChimneyMedical, faClinicMedical, faBoxingGlove, faGloveBoxing, faTemperatureThreeQuarters, faTemperature3, faThermometer3, faThermometerThreeQuarters, faBellSchool, faMobileScreen, faMobileAndroidAlt, faPlaneUp, faFolderHeart, faCircleLocationArrow, faLocationCircle, faFaceHeadBandage, faSushiRoll, faMakiRoll, faMakizushi, faCarBump, faPiggyBank, faRacquet, faCarMirrors, faIndustryWindows, faIndustryAlt, faBoltAuto, faBatteryHalf, faBattery3, faFluxCapacitor, faMountainCity, faCoins, faHoneyPot, faOlive, faKhanda, faFilterList, faOutlet, faSliders, faSlidersH, faCauldron, faPeople, faFolderTree, faNetworkWired, faCroissant, faMapPin, faHamsa, faCentSign, faSwordsLaser, faFlask, faPersonPregnant, faSquareU, faWandSparkles, faRouter, faEllipsisVertical, faEllipsisV, faSwordLaserAlt, faTicket, faPowerOff, faCoin, faLaptopSlash, faRightLong, faLongArrowAltRight, faCircleB, faPersonDressSimple, faPipeCollar, faLightsHoliday, faCitrus, faFlagUsa, faLaptopFile, faTty, faTeletype, faChartTreeMap, faDiagramNext, faPersonRifle, faClockFiveThirty, faPipeValve, faArrowUpFromArc, faFaceSpiralEyes, faCompressWide, faCirclePhoneHangup, faPhoneCircleDown, faGearComplexCode, faHouseMedicalCircleExclamation, faBadminton, faClosedCaptioning, faPersonHiking, faHiking, faRightFromLine, faArrowAltFromLeft, faVenusDouble, faImages, faCalculator, faShuttlecock, faUserHair, faEyeEvil, faPeoplePulling, faN, faGarage, faCableCar, faTram, faShovelSnow, faCloudRain, faFaceLying, faSprinkler, faBuildingCircleXmark, faPersonSledding, faSledding, faGameConsoleHandheld, faShip, faClockSixThirty, faBatterySlash, faTugrikSign, faArrowsDownToLine, faDownload, faShelves, faInventory, faCloudSnow, faFaceGrin, faGrin, faDeleteLeft, faBackspace, faOven, faCloudBinary, faEyeDropper, faEyeDropperEmpty, faEyedropper, faCommentCaptions, faCommentsQuestion, faScribble, faRotateExclamation, faFileCircleCheck, faGlass, faLoader, faForward, faUserPilot, faMobile, faMobileAndroid, faMobilePhone, faCodePullRequestClosed, faFaceMeh, faMeh, faAlignCenter, faBookSkull, faBookDead, faIdCard, faDriversLicense, faFaceDotted, faFaceWorried, faOutdent, faDedent, faHeartCircleExclamation, faHouse, faHome, faHomeAlt, faHomeLgAlt, faVectorCircle, faCarCircleBolt, faCalendarWeek, faFlyingDisc, faLaptopMedical, faSquareDownRight, faB, faSeatAirline, faMoonOverSun, faEclipseAlt, faPipe, faFileMedical, faPotato, faDiceOne, faCircleA, faHelmetBattle, faButter, faBlanketFire, faKiwiBird, faCastle, faGolfClub, faArrowRightArrowLeft, faExchange, faRotateRight, faRedoAlt, faRotateForward, faUtensils, faCutlery, faArrowUpWideShort, faSortAmountUp, faChartPieSimpleCircleDollar, faBalloons, faMillSign, faBowlRice, faTimelineArrow, faSkull, faGameBoardSimple, faGameBoardAlt, faCircleVideo, faVideoCircle, faChartScatterBubble, faHouseTurret, faBanana, faHandHoldingSkull, faPeopleDress, faLoveseat, faCouchSmall, faTowerBroadcast, faBroadcastTower, faTruckPickup, faBlockQuote, faUpLong, faLongArrowAltUp, faStop, faCodeMerge, faMoneyCheckDollarPen, faMoneyCheckEditAlt, faUpFromLine, faArrowAltFromBottom, faUpload, faHurricane, faGridRound2Plus, faPeoplePants, faMound, faWindsock, faCircleHalf, faBrakeWarning, faToiletPortable, faCompactDisc, faFileArrowDown, faFileDownload, faSaxophoneFire, faSaxHot, faCameraWebSlash, faWebcamSlash, faFolderMedical, faFolderGear, faFolderCog, faHandWave, faArrowUpArrowDown, faSortUpDown, faCaravan, faShieldCat, faMessageSlash, faCommentAltSlash, faBolt, faZap, faTrashCanCheck, faGlassWater, faOilWell, faPersonSimple, faVault, faMars, faToilet, faPlaneCircleXmark, faYenSign, faCny, faJpy, faRmb, faYen, faGearCode, faNotes, faRubleSign, faRouble, faRub, faRuble, faTrashUndo, faTrashArrowTurnLeft, faChampagneGlass, faGlassChampagne, faObjectsAlignCenterHorizontal, faSun, faTrashCanSlash, faTrashAltSlash, faScreenUsers, faUsersClass, faGuitar, faSquareArrowLeft, faArrowSquareLeft, faSquare8, faFaceSmileHearts, faBracketsSquare, faBrackets, faLaptopArrowDown, faHockeyStickPuck, faHouseTree, faSignalFair, faSignal2, faFaceLaughWink, faLaughWink, faCircleDollar, faDollarCircle, faUsdCircle, faHorseHead, faArrowsRepeat, faRepeatAlt, faBoreHole, faIndustry, faImagePolaroid, faWaveTriangle, faPersonRunningFast, faCircleDown, faArrowAltCircleDown, faGrill, faArrowsTurnToDots, faChartMixed, faAnalytics, faFlorinSign, faArrowDownShortWide, faSortAmountDesc, faSortAmountDownAlt, faLessThan, faDisplayCode, faDesktopCode, faFaceDrooling, faOilTemperature, faOilTemp, faSquareQuestion, faQuestionSquare, faAirConditioner, faAngleDown, faMountains, faOmega, faCarTunnel, faPersonDollyEmpty, faPanFood, faHeadSideCough, faGripLines, faThumbsDown, faUserLock, faArrowRightLong, faLongArrowRight, faTicketsAirline, faAnchorCircleXmark, faEllipsis, faEllipsisH, faNfcSlash, faChessPawn, faKitMedical, faFirstAid, faGrid2Plus, faBells, faPersonThroughWindow, faToolbox, faEnvelopeDot, faEnvelopeBadge, faHandsHoldingCircle, faBug, faBowlChopsticks, faCreditCard, faCreditCardAlt, faCircleS, faBoxBallot, faCar, faAutomobile, faHandHoldingHand, faUserTieHair, faPodiumStar, faUserHairMullet, faBusinessFront, faPartyBack, faTrianBalbot, faMicrophoneStand, faBookOpenReader, faBookReader, faFamilyDress, faCircleX, faCabin, faMountainSun, faChartSimpleHorizontal, faBluetooth, faArrowsLeftRightToLine, faHandBackPointLeft, faMessageDots, faCommentAltDots, faMessaging, faFileHeart, faBeerMug, faBeerFoam, faDiceD20, faDrone, faTruckDroplet, faFileCircleXmark, faTemperatureArrowUp, faTemperatureUp, faMedal, faBed, faBookCopy, faSquareH, faHSquare, faSquareC, faClockTwo, faSquareEllipsisVertical, faCalendarUsers, faPodcast, faBee, faTemperatureFull, faTemperature4, faThermometer4, faThermometerFull, faBell, faCandyBar, faChocolateBar, faXmarkLarge, faPinata, faArrowsFromLine, faSuperscript, faBowlSpoon, faHexagonCheck, faPlugCircleXmark, faStarOfLife, faPhoneSlash, faTrafficLightStop, faPaintRoller, faAccentGrave, faHandshakeAngle, faHandsHelping, faCircle0, faDialMedLow, faLocationDot, faMapMarkerAlt, faCrab, faBoxOpenFull, faBoxFull, faFile, faGreaterThan, faQuotes, faPretzel, faPersonSwimming, faSwimmer, faArrowDown, faUserRobotXmarks, faMessageQuote, faCommentAltQuote, faCandyCorn, faFolderMagnifyingGlass, faFolderSearch, faNotebook, faDroplet, faTint, faBullseyePointer, faEraser, faHexagonImage, faEarthAmericas, faEarth, faEarthAmerica, faGlobeAmericas, faCrateApple, faAppleCrate, faPersonBurst, faGameBoard, faHatChef, faHandBackPointRight, faDove, faSnowflakeDroplets, faBatteryEmpty, faBattery0, faGrid4, faSocks, faFaceSunglasses, faInbox, faSquare0, faSection, faSquareThisWayUp, faBoxUp, faGaugeHigh, faTachometerAlt, faTachometerAltFast, faSquareAmpersand, faEnvelopeOpenText, faLampDesk, faHospital, faHospitalAlt, faHospitalWide, faPollPeople, faWhiskeyGlassIce, faGlassWhiskeyRocks, faWineBottle, faChessRook, faUserBountyHunter, faBarsStaggered, faReorder, faStream, faDiagramSankey, faCloudHailMixed, faCircleUpLeft, faDharmachakra, faObjectsAlignLeft, faOilCanDrip, faFaceSmilingHands, faBroccoli, faRouteInterstate, faEarMuffs, faHotdog, faTransporterEmpty, faPersonWalkingWithCane, faBlind, faAngle90, faRectangleTerminal, faKite, faDrum, faScrubber, faIceCream, faHeartCircleBolt, faFishBones, faDeerRudolph, faFax, faParagraph, faHeadSideHeart, faSquareE, faMeterFire, faCloudHail, faCheckToSlot, faVoteYea, faMoneyFromBracket, faStarHalf, faCarBus, faSpeaker, faTimer, faBoxesStacked, faBoxes, faBoxesAlt, faGrillHot, faBallotCheck, faLink, faChain, faEarListen, faAssistiveListeningSystems, faFileMinus, faTreeCity, faPlay, faFont, faCupTogo, faCoffeeTogo, faSquareDownLeft, faBurgerLettuce, faRupiahSign, faMagnifyingGlass, faSearch, faTableTennisPaddleBall, faPingPongPaddleBall, faTableTennis, faPersonDotsFromLine, faDiagnoses, faChevronsDown, faChevronDoubleDown, faTrashCanArrowUp, faTrashRestoreAlt, faSignalGood, faSignal3, faLocationQuestion, faMapMarkerQuestion, faFloppyDiskCircleXmark, faFloppyDiskTimes, faSaveCircleXmark, faSaveTimes, faNairaSign, faPeach, faTaxiBus, faBracketCurly, faBracketCurlyLeft, faLobster, faCartFlatbedEmpty, faDollyFlatbedEmpty, faColon, faCartArrowDown, faWand, faWalkieTalkie, faFilePen, faFileEdit, faReceipt, faTablePicnic, faSquarePen, faPenSquare, faPencilSquare, faCircleMicrophoneLines, faMicrophoneCircleAlt, faDisplaySlash, faDesktopSlash, faSuitcaseRolling, faPersonCircleExclamation, faTransporter2, faHandsHoldingDiamond, faHandReceiving, faMoneyBillSimpleWave, faChevronDown, faBatteryFull, faBattery, faBattery5, faBellPlus, faBookArrowRight, faHospitals, faClub, faSkullCrossbones, faDropletDegree, faDewpoint, faCodeCompare, faListUl, faListDots, faHandHoldingMagic, faWatermelonSlice, faCircleEllipsis, faSchoolLock, faTowerCell, faSdCards, faJugBottle, faDownLong, faLongArrowAltDown, faEnvelopes, faPhoneOffice, faRankingStar, faChessKing, faNfcPen, faPersonHarassing, faHatWinter, faBrazilianRealSign, faLandmarkDome, faLandmarkAlt, faBoneBreak, faArrowUp, faDownFromDottedLine, faTv, faTelevision, faTvAlt, faBorderLeft, faCircleDivide, faShrimp, faListCheck, faTasks, faDiagramSubtask, faJugDetergent, faCircleUser, faUserCircle, faSquareY, faUserDoctorHair, faPlanetRinged, faMushroom, faUserShield, faMegaphone, faWreathLaurel, faCircleExclamationCheck, faWind, faBoxDollar, faBoxUsd, faCarBurst, faCarCrash, faY, faUserHeadset, faArrowsRetweet, faRetweetAlt, faPersonSnowboarding, faSnowboarding, faSquareChevronRight, faChevronSquareRight, faLacrosseStickBall, faTruckFast, faShippingFast, faUserMagnifyingGlass, faStarSharp, faCommentHeart, faCircle1, faCircleStar, faStarCircle, faFish, faCloudFog, faFog, faWaffle, faMusicNote, faMusicAlt, faHexagonExclamation, faCartShoppingFast, faObjectUnion, faUserGraduate, faStarfighter, faCircleHalfStroke, faAdjust, faArrowRightLongToLine, faSquareArrowDown, faArrowSquareDown, faDiamondHalfStroke, faClapperboard, faSquareChevronLeft, faChevronSquareLeft, faPhoneIntercom, faLinkHorizontal, faChainHorizontal, faMango, faMusicNoteSlash, faMusicAltSlash, faCircleRadiation, faRadiationAlt, faFaceTongueSweat, faGlobeStand, faBaseball, faBaseballBall, faCircleP, faAwardSimple, faJetFighterUp, faDiagramProject, faProjectDiagram, faPedestal, faChartPyramid, faSidebar, faSnowmanHead, faFrostyHead, faCopy, faBurgerGlass, faVolumeXmark, faVolumeMute, faVolumeTimes, faHandSparkles, faBarsFilter, faPaintbrushPencil, faPartyBell, faUserVneckHair, faJackOLantern, faGrip, faGripHorizontal, faShareFromSquare, faShareSquare, faKeynote, faChildCombatant, faChildRifle, faGun, faSquarePhone, faPhoneSquare, faHatBeach, faPlus, faAdd, faExpand, faComputer, faFort, faCloudCheck, faXmark, faClose, faMultiply, faRemove, faTimes, faFaceSmirking, faArrowsUpDownLeftRight, faArrows, faChalkboardUser, faChalkboardTeacher, faRhombus, faClawMarks, faPesoSign, faFaceSmileTongue, faCartCircleXmark, faBuildingShield, faCirclePhoneFlip, faPhoneCircleAlt, faBaby, faUsersLine, faQuoteLeft, faQuoteLeftAlt, faTractor, faKeySkeleton, faTrashArrowUp, faTrashRestore, faArrowDownUpLock, faArrowDownToBracket, faLinesLeaning, faSquareQ, faRulerCombined, faSymbols, faIconsAlt, faCopyright, faFlaskGear, faHighlighterLine, faBracketSquare, faBracket, faBracketLeft, faIslandTropical, faIslandTreePalm, faArrowRightFromLine, faArrowFromLeft, faH2, faEquals, faCakeSlice, faShortcake, faPeanut, faWrenchSimple, faBlender, faTeeth, faTally2, faShekelSign, faIls, faShekel, faSheqel, faSheqelSign, faCars, faAxeBattle, faUserHairLong, faMap, faFileCircleInfo, faFaceDisappointed, faLassoSparkles, faClockEleven, faRocket, faSirenOn, faClockTen, faCandleHolder, faVideoArrowDownLeft, faPhotoFilm, faPhotoVideo, faFloppyDiskCircleArrowRight, faSaveCircleArrowRight, faFolderMinus, faPlanetMoon, faFaceEyesXmarks, faChartScatter, faDisplayArrowDown, faStore, faArrowTrendUp, faPlugCircleMinus, faOliveBranch, faAngle, faVacuumRobot, faSignHanging, faSign, faSquareDivide, faSignalStreamSlash, faBezierCurve, faEyeDropperHalf, faStoreLock, faBellSlash, faCloudBoltSun, faThunderstormSun, faCameraSlash, faCommentQuote, faTablet, faTabletAndroid, faSchoolFlag, faMessageCode, faGlassHalf, faGlassHalfEmpty, faGlassHalfFull, faFill, faMessageMinus, faCommentAltMinus, faAngleUp, faDinosaur, faDrumstickBite, faLinkHorizontalSlash, faChainHorizontalSlash, faHollyBerry, faNose, faChevronLeft, faBacteria, faClouds, faMoneyBillSimple, faHandLizard, faTablePivot, faFilterSlash, faTrashCanUndo, faTrashCanArrowTurnLeft, faTrashUndoAlt, faNotdef, faDisease, faPersonToDoor, faTurntable, faBriefcaseMedical, faGenderless, faChevronRight, faSignalWeak, faSignal1, faClockFive, faRetweet, faCarRear, faCarAlt, faPumpSoap, faComputerClassic, faFrame, faVideoSlash, faBatteryQuarter, faBattery2, faEllipsisStroke, faEllipsisHAlt, faRadio, faBabyCarriage, faCarriageBaby, faFaceExpressionless, faDownToDottedLine, faCloudMusic, faTrafficLight, faCloudMinus, faThermometer, faShieldMinus, faVrCardboard, faCarTilt, faGaugeCircleMinus, faBrightnessLow, faHandMiddleFinger, faPercent, faPercentage, faTruckMoving, faGlassWaterDroplet, faConveyorBelt, faLocationCheck, faMapMarkerCheck, faCoinVertical, faDisplay, faPersonSign, faFaceSmile, faSmile, faPhoneHangup, faSignatureSlash, faThumbtack, faThumbTack, faWheatSlash, faTrophy, faCloudsSun, faPersonPraying, faPray, faHammer, faFaceVomit, faSpeakers, faTtyAnswer, faTeletypeAnswer, faMugTeaSaucer, faDiagramLeanCanvas, faAlt, faDial, faDialMedHigh, faHandPeace, faCircleTrash, faTrashCircle, faRotate, faSyncAlt, faCircleQuarters, faSpinner, faTowerControl, faArrowUpTriangleSquare, faSortShapesUp, faWhale, faRobot, faPeace, faPartyHorn, faGears, faCogs, faSunBright, faSunAlt, faWarehouse, faConveyorBeltArm, faLockKeyholeOpen, faLockOpenAlt, faSquareFragile, faBoxFragile, faSquareWineGlassCrack, faArrowUpRightDots, faSquareN, faSplotch, faFaceGrinHearts, faGrinHearts, faMeter, faMandolin, faDiceFour, faSimCard, faTransgender, faTransgenderAlt, faMercury, faUpFromBracket, faKnifeKitchen, faBorderRight, faArrowTurnDown, faLevelDown, faSpade, faCardSpade, faLineColumns, faArrowRightToLine, faArrowToRight, faPersonFallingBurst, faFlagPennant, faPennant, faConveyorBeltEmpty, faUserGroupSimple, faAward, faTicketSimple, faTicketAlt, faBuilding, faAnglesLeft, faAngleDoubleLeft, faCamcorder, faVideoHandheld, faPancakes, faAlbumCircleUser, faQrcode, faDiceD10, faFireplace, faBrowser, faPenPaintbrush, faPencilPaintbrush, faFishCooked, faChairOffice, faNestingDolls, faClockRotateLeft, faHistory, faTrumpet, faFaceGrinBeamSweat, faGrinBeamSweat, faFireSmoke, faPhoneMissed, faFileExport, faArrowRightFromFile, faShield, faShieldBlank, faArrowUpShortWide, faSortAmountUpAlt, faArrowsRepeat1, faRepeat1Alt, faGunSlash, faAvocado, faBinary, faGlassesRound, faGlassesAlt, faPhonePlus, faDitto, faPersonSeat, faHouseMedical, faGolfBallTee, faGolfBall, faCircleChevronLeft, faChevronCircleLeft, faHouseChimneyWindow, faScythe, faPenNib, faBanParking, faParkingCircleSlash, faTentArrowTurnLeft, faFaceDiagonalMouth, faDiagramCells, faCricketBatBall, faCricket, faTents, faWandMagic, faMagic, faDog, faPenLine, faAtomSimple, faAtomAlt, faAmpersand, faCarrot, faArrowUpFromLine, faArrowFromBottom, faMoon, faPenSlash, faWineGlassEmpty, faWineGlassAlt, faSquareStar, faCheese, faSendBackward, faYinYang, faMusic, faCompassSlash, faClockOne, faFileMusic, faCodeCommit, faTemperatureLow, faPersonBiking, faBiking, faDisplayChartUpCircleCurrency, faSkeleton, faCircleG, faCircleArrowUpLeft, faCoinBlank, faBroom, faVacuum, faShieldHeart, faCardHeart, faLightbulbCflOn, faMelon, faGopuram, faEarthOceania, faGlobeOceania, faContainerStorage, faFacePouting, faSquareXmark, faTimesSquare, faXmarkSquare, faFaceExplode, faExplodingHead, faHashtag, faUpRightAndDownLeftFromCenter, faExpandAlt, faOilCan, faT, faTransformerBolt, faHippo, faChartColumn, faCassetteVhs, faVhs, faInfinity, faVialCircleCheck, faChimney, faObjectIntersect, faPersonArrowDownToLine, faVoicemail, faBlockBrick, faWallBrick, faFan, faBagsShopping, faParagraphLeft, faParagraphRtl, faPersonWalkingLuggage, faCaravanSimple, faCaravanAlt, faTurtle, faPencilMechanical, faUpDown, faArrowsAltV, faCloudMoonRain, faBoothCurtain, faCalendar, faBoxHeart, faTrailer, faUserDoctorMessage, faUserMdChat, faBahai, faHaykal, faAmpGuitar, faSdCard, faVolumeSlash, faBorderBottom, faWifiWeak, faWifi1, faDragon, faShoePrints, faCirclePlus, faPlusCircle, faFaceGrinTongueWink, faGrinTongueWink, faHandHolding, faPlugCircleExclamation, faLinkSlash, faChainBroken, faChainSlash, faUnlink, faClone, faPersonWalkingArrowLoopLeft, faArrowUpZA, faSortAlphaUpAlt, faFireFlameCurved, faFireAlt, faTornado, faFileCirclePlus, faDeleteRight, faBookQuran, faQuran, faCircleQuarter, faAnchor, faBorderAll, faFunction, faFaceAngry, faAngry, faPeopleSimple, faCookieBite, faArrowTrendDown, faRss, faFeed, faFaceMonocle, faDrawPolygon, faScaleBalanced, faBalanceScale, faCalendarLines, faCalendarNote, faArrowDownBigSmall, faSortSizeDown, faGaugeSimpleHigh, faTachometer, faTachometerFast, faDoNotEnter, faShower, faDiceD8, faDesktop, faDesktopAlt, faM, faGripDotsVertical, faFaceViewfinder, faSoftServe, faCreemee, faH5, faHandBackPointDown, faTableList, faThList, faCommentSms, faSms, faRectangle, faRectangleLandscape, faClipboardListCheck, faTurkey, faBook, faUserPlus, faIceSkate, faCheck, faBatteryThreeQuarters, faBattery4, faTomato, faSwordLaser, faHouseCircleCheck, faBuildings, faAngleLeft, faCartFlatbedBoxes, faDollyFlatbedAlt, faDiagramSuccessor, faTruckArrowRight, faSquareW, faArrowsSplitUpAndLeft, faLamp, faAirplay, faHandFist, faFistRaised, faShieldQuartered, faSlashForward, faLocationPen, faMapMarkerEdit, faCloudMoon, faPotFood, faBriefcase, faPersonFalling, faImagePortrait, faPortrait, faUserTag, faRug, faPrintSlash, faEarthEurope, faGlobeEurope, faCartFlatbedSuitcase, faLuggageCart, faHandBackPointRibbon, faRectangleXmark, faRectangleTimes, faTimesRectangle, faWindowClose, faTireRugged, faLightbulbDollar, faCowbell, faBahtSign, faCorner, faChevronsRight, faChevronDoubleRight, faBookOpen, faBookJournalWhills, faJournalWhills, faInhaler, faHandcuffs, faSnake, faTriangleExclamation, faExclamationTriangle, faWarning, faNoteMedical, faDatabase, faDownLeft, faShare, faArrowTurnRight, faMailForward, faFaceThinking, faTurnDownRight, faBottleDroplet, faMaskFace, faHillRockslide, faScannerKeyboard, faCircleO, faGridHorizontal, faMessageDollar, faCommentAltDollar, faRightLeft, faExchangeAlt, faColumns3, faPaperPlane, faRoadCircleExclamation, faDungeon, faHandHoldingBox, faInputText, faWindowFlip, faWindowAlt, faAlignRight, faScannerGun, faScanner, faTire, faEngine, faMoneyBill1Wave, faMoneyBillWaveAlt, faLifeRing, faHands, faSignLanguage, faSigning, faCircleCaretRight, faCaretCircleRight, faWheat, faFileSpreadsheet, faAudioDescriptionSlash, faCalendarDay, faWaterLadder, faLadderWater, faSwimmingPool, faArrowsUpDown, faArrowsV, faChessPawnPiece, faChessPawnAlt, faFaceGrimace, faGrimace, faWheelchairMove, faWheelchairAlt, faTurnDown, faLevelDownAlt, faSquareS, faRectangleBarcode, faBarcodeAlt, faPersonWalkingArrowRight, faSquareEnvelope, faEnvelopeSquare, faDice, faUnicorn, faBowlingBall, faPompebled, faBrain, faWatchSmart, faBookUser, faSensorCloud, faSensorSmoke, faClapperboardPlay, faBandage, faBandAid, faCalendarMinus, faCircleXmark, faTimesCircle, faXmarkCircle, faCircle4, faGifts, faAlbumCollection, faHotel, faEarthAsia, faGlobeAsia, faIdCardClip, faIdCardAlt, faMagnifyingGlassPlus, faSearchPlus, faThumbsUp, faCloudShowers, faUserClock, faOnion, faClockTwelveThirty, faArrowDownToDottedLine, faHandDots, faAllergies, faFileInvoice, faWindowMinimize, faRectangleWide, faCommentArrowUp, faGarlic, faMugSaucer, faCoffee, faBrush, faTreeDecorated, faMask, faCalendarHeart, faMagnifyingGlassMinus, faSearchMinus, faFlower, faRightLeftLarge, faRulerVertical, faCirclesOverlap, faUserLarge, faUserAlt, faStarshipFreighter, faTrainTram, faBridgeSuspension, faTrashCheck, faUserNurse, faBoombox, faSyringe, faCloudSun, faShieldExclamation, faStopwatch20, faSquareFull, faGripDots, faCommentExclamation, faPenSwirl, faFalafel, faCircle2, faMagnet, faJar, faGramophone, faDiceD12, faNoteSticky, faDown, faArrowAltDown, faHundredPoints, fa100, faPaperclipVertical, faWindWarning, faWindCircleExclamation, faLocationPinSlash, faMapMarkerSlash, faFaceSadSweat, faBugSlash, faCupcake, faLightSwitchOff, faToggleLargeOff, faPenFancySlash, faTruckContainer, faBoot, faArrowUpFromWaterPump, faFileCheck, faBone, faCardsBlank, faCircle3, faBenchTree, faKeyboardBrightnessLow, faSkiBootSki, faBrainCircuit, faUserInjured, faBlockBrickFire, faFirewall, faFaceSadTear, faSadTear, faPlane, faTentArrowsDown, faExclamation, faArrowsSpin, faFaceSmileRelaxed, faCommentXmark, faCommentTimes, faPrint, faTurkishLiraSign, faTry, faTurkishLira, faFaceNoseSteam, faCircleWaveformLines, faWaveformCircle, faDollarSign, faDollar, faUsd, faFerrisWheel, faComputerSpeaker, faSkullCow, faX, faMagnifyingGlassDollar, faSearchDollar, faUsersGear, faUsersCog, faPersonMilitaryPointing, faBuildingColumns, faBank, faInstitution, faMuseum, faUniversity, faCircleT, faSack, faGrid2, faCameraCctv, faCctv, faUmbrella, faTrowel, faHorizontalRule, faBedFront, faBedAlt, faD, faStapler, faMasksTheater, faTheaterMasks, faKipSign, faFaceWoozy, faCloudQuestion, faPineapple, faHandPointLeft, faGalleryThumbnails, faCircleJ, faEyes, faHandshakeSimple, faHandshakeAlt, faPageCaretUp, faFileCaretUp, faJetFighter, faFighterJet, faComet, faSquareShareNodes, faShareAltSquare, faShieldKeyhole, faBarcode, faPlusMinus, faSquareSlidersVertical, faSlidersVSquare, faVideo, faVideoCamera, faMessageMiddle, faCommentMiddleAlt, faGraduationCap, faMortarBoard, faHandHoldingMedical, faPersonCircleCheck, faSquareZ, faMessageText, faCommentAltText, faTurnUp, faLevelUpAlt */
var prefix = "fad";
var fa0 = {
  prefix: 'fad',
  iconName: '0',
  icon: [320, 512, [], "30", ["M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 96c-53 0-96 43-96 96V320c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z", ""]]
};
var fa1 = {
  prefix: 'fad',
  iconName: '1',
  icon: [256, 512, [], "31", ["M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z", ""]]
};
var fa2 = {
  prefix: 'fad',
  iconName: '2',
  icon: [320, 512, [], "32", ["M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z", ""]]
};
var fa3 = {
  prefix: 'fad',
  iconName: '3',
  icon: [320, 512, [], "33", ["M0 64C0 46.3 14.3 32 32 32H272c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H105.4C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H80c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96H32C14.3 96 0 81.7 0 64z", ""]]
};
var fa4 = {
  prefix: 'fad',
  iconName: '4',
  icon: [384, 512, [], "34", ["M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368H256v80c0 17.7 14.3 32 32 32s32-14.3 32-32V368h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V304H82.4L189 77.6z", ""]]
};
var fa5 = {
  prefix: 'fad',
  iconName: '5',
  icon: [320, 512, [], "35", ["M32.5 58.3C35.3 43.1 48.5 32 64 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H100.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z", ""]]
};
var fa6 = {
  prefix: 'fad',
  iconName: '6',
  icon: [320, 512, [], "36", ["M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3c0 .2 0 .3 0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z", ""]]
};
var fa7 = {
  prefix: 'fad',
  iconName: '7',
  icon: [320, 512, [], "37", ["M0 64C0 46.3 14.3 32 32 32H288c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z", ""]]
};
var fa8 = {
  prefix: 'fad',
  iconName: '8',
  icon: [320, 512, [], "38", ["M304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h15.9c0 0 .1 0 .1 0h32c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0H144c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z", ""]]
};
var fa9 = {
  prefix: 'fad',
  iconName: '9',
  icon: [320, 512, [], "39", ["M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z", ""]]
};
var faFillDrip = {
  prefix: 'fad',
  iconName: 'fill-drip',
  icon: [576, 512, [], "f576", ["M67.5 288H386.7L238.6 436.1c-12.5 12.5-32.8 12.5-45.3 0L75.9 318.6c-8.3-8.3-11.1-20-8.4-30.6zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z", "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L238.6 436.1c-12.5 12.5-32.8 12.5-45.3 0L75.9 318.6c-12.5-12.5-12.5-32.8 0-45.3L168 181.3z"]]
};
var faArrowsToCircle = {
  prefix: 'fad',
  iconName: 'arrows-to-circle',
  icon: [640, 512, [], "e4bd", ["M256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z", "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"]]
};
var faCircleChevronRight = {
  prefix: 'fad',
  iconName: 'circle-chevron-right',
  icon: [512, 512, ["chevron-circle-right"], "f138", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z", "M345 239c9.4 9.4 9.4 24.6 0 33.9L241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239z"]]
};
var faChevronCircleRight = faCircleChevronRight;
var faWagonCovered = {
  prefix: 'fad',
  iconName: 'wagon-covered',
  icon: [640, 512, [], "f8ee", ["M4.5 57.4C-5.2 30.3 16.1 2.1 44.8 4.1L194.1 14C210.9 15.1 224 29.1 224 45.9V224H64L4.5 57.4zM288 16h64c17.7 0 32 14.3 32 32V224H256V48c0-17.7 14.3-32 32-32zM64 400a112 112 0 1 1 224 0A112 112 0 1 1 64 400zm96 62V416H114c5.8 22.5 23.5 40.2 46 46zm-46-78h46V338c-22.5 5.8-40.2 23.5-46 46zm124 32H192v46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46v46h46zm114 16a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm96 62V416H402c5.8 22.5 23.5 40.2 46 46zm-46-78h46V338c-22.5 5.8-40.2 23.5-46 46zm124 32H480v46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46v46h46zM595.2 4.1c28.7-1.9 50 26.2 40.3 53.4L576 224H416V45.9c0-16.8 13.1-30.8 29.9-31.9l149.3-10z", "M96 256c-17.7 0-32 14.3-32 32s14.3 32 32 32h1.6c20.2-19.8 47.9-32 78.4-32c61.9 0 112 50.1 112 112c0 5.4-.4 10.8-1.1 16h66.3c-.7-5.2-1.1-10.6-1.1-16c0-61.9 50.1-112 112-112c30.5 0 58.2 12.2 78.4 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"]]
};
var faLineHeight = {
  prefix: 'fad',
  iconName: 'line-height',
  icon: [576, 512, [], "f871", ["M256 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c-17.7 0-32-14.3-32-32zm32 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M73.4 41.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-9.4-9.4V370.7l9.4-9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l9.4 9.4V141.3l-9.4 9.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64z"]]
};
var faBagel = {
  prefix: 'fad',
  iconName: 'bagel',
  icon: [640, 512, [129391], "e3d7", ["M413.9 44.4c10.9-7.5 25.3-7.5 36.2 0L471 58.7c5.1 3.5 11.1 5.4 17.2 5.6l25.3 .7c13.2 .4 24.8 8.8 29.3 21.3l8.5 23.9c2.1 5.8 5.8 10.9 10.6 14.6L582 140.2c10.5 8.1 14.9 21.7 11.2 34.4L586 199c-1.7 5.9-1.7 12.2 0 18.1l7.2 24.3c3.7 12.7-.7 26.3-11.2 34.4l-20.1 15.5c-4.9 3.8-8.6 8.8-10.6 14.6l-8.5 23.9c-4.4 12.5-16.1 20.9-29.3 21.3l-25.3 .7c-6.2 .2-12.1 2.1-17.2 5.6l-20.9 14.3c-4.1 2.8-8.7 4.5-13.3 5.2c7.3-23 11.3-47.5 11.3-72.9c0-11.4-.8-22.5-2.3-33.5c28.8-6.3 50.3-31.9 50.3-62.5c0-35.3-28.7-64-64-64c-13.3 0-25.6 4-35.9 11c-20.8-26.2-46.9-48-76.8-63.6l1.8-5.1c4.4-12.5 16.1-20.9 29.3-21.3l25.3-.7c6.2-.2 12.1-2.1 17.2-5.6l20.9-14.3z", "M432 416c-3.9 0-7.7-.1-11.5-.3c6.5-12.3 12-25.3 16.3-38.8c4.7-.7 9.3-2.5 13.3-5.3L471 357.3c5.1-3.5 11-5.4 17.2-5.6l25.3-.7c13.2-.4 24.8-8.8 29.3-21.3l8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6L582 275.8c10.5-8.1 14.9-21.7 11.2-34.4L586 217c-1.7-5.9-1.7-12.2 0-18.1l7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4l-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6l-8.5-23.9c-4.4-12.5-16.1-20.9-29.3-21.3l-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6L450.1 44.4c-10.9-7.5-25.3-7.5-36.2 0L393 58.7c-5.1 3.5-11 5.4-17.2 5.6L350.5 65c-13.2 .4-24.8 8.8-29.3 21.3l-1.8 5.1c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208s-93.1 208-208 208zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm256 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM144 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
};
var faTransporter7 = {
  prefix: 'fad',
  iconName: 'transporter-7',
  icon: [512, 512, [], "e2a8", ["M472.7 38.6L480 64l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 96l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 96l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 64l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zm-416 224L64 288l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 320l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 320 6.6 312.7C2.7 311.6 0 308.1 0 304s2.7-7.6 6.6-8.7L32 288l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6z", "M96 480c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z"]]
};
var faAt = {
  prefix: 'fad',
  iconName: 'at',
  icon: [512, 512, [61946], "40", ["M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z", ""]]
};
var faRectanglesMixed = {
  prefix: 'fad',
  iconName: 'rectangles-mixed',
  icon: [576, 512, [], "e323", ["M432 32c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H432zM112 304c-26.5 0-48 21.5-48 48v80c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V352c0-26.5-21.5-48-48-48H112z", "M0 80C0 53.5 21.5 32 48 32H272c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80z"]]
};
var faPhoneArrowUpRight = {
  prefix: 'fad',
  iconName: 'phone-arrow-up-right',
  icon: [512, 512, ["phone-arrow-up", "phone-outgoing"], "e224", ["M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z", "M295 217c-9.4-9.4-9.4-24.6 0-33.9l135-135H384c-13.3 0-24-10.7-24-24s10.7-24 24-24H488c13.3 0 24 10.7 24 24V128c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9L329 217c-9.4 9.4-24.6 9.4-33.9 0z"]]
};
var faPhoneArrowUp = faPhoneArrowUpRight;
var faPhoneOutgoing = faPhoneArrowUpRight;
var faTrashCan = {
  prefix: 'fad',
  iconName: 'trash-can',
  icon: [448, 512, [61460, "trash-alt"], "f2ed", ["M416 96H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V96zM144 176V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8z"]]
};
var faTrashAlt = faTrashCan;
var faCircleL = {
  prefix: 'fad',
  iconName: 'circle-l',
  icon: [512, 512, [], "e114", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 152V336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M184 128c13.3 0 24 10.7 24 24V336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"]]
};
var faHeadSideGoggles = {
  prefix: 'fad',
  iconName: 'head-side-goggles',
  icon: [512, 512, ["head-vr"], "f6ea", ["M45.9 128H225.6C233 91.5 265.3 64 304 64h95.1C364 24.7 312.9 0 256 0H233.7C148.3 0 75.3 53.1 45.9 128zM32.2 192c-.2 3.2-.2 6.5-.2 9.7c0 44.8 18.3 91.5 46.5 127.7C88.9 342.8 96 358.8 96 375.8V480c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V448h64c35.3 0 64-28.7 64-64V320h20.2c24.2 0 43.8-19.6 43.8-43.8c0-10-3.4-19.6-9.6-27.4L482.6 224H304c-26.2 0-49.4-12.6-64-32H32.2z", "M304 64H416V224H304c-26.2 0-49.4-12.6-64-32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H225.6C233 91.5 265.3 64 304 64zM480 224H448V64h32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32z"]]
};
var faHeadVr = faHeadSideGoggles;
var faTextHeight = {
  prefix: 'fad',
  iconName: 'text-height',
  icon: [576, 512, [], "f034", ["M64 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V80C0 53.5 21.5 32 48 32H160 272c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H192l0 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h32l0-320H64z", "M457.4 41.4c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H512l0 192h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32l0-192H416c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l64-64z"]]
};
var faUserXmark = {
  prefix: 'fad',
  iconName: 'user-xmark',
  icon: [640, 512, ["user-times"], "f235", ["M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z", "M505 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faUserTimes = faUserXmark;
var faFaceHandYawn = {
  prefix: 'fad',
  iconName: 'face-hand-yawn',
  icon: [512, 512, [], "e379", ["M336.9 498.9C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5V384 330.4c0-28.7 23.3-52 52-52c1.8 0 3.6 .1 5.3 .3C184.8 246.3 217.8 224 256 224c28.7 0 54.5 12.6 72.1 32.6c14.8-2.4 30.4 2 41.8 13.4c12.2 12.2 16.5 29.4 12.8 45c1.1 .9 2.2 1.9 3.2 3c18.1 18.1 18.7 47.1 1.8 65.9c16.9 18.8 16.3 47.8-1.8 65.9l-49 49zM202 124.5l-80 64c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l80-64c6.9-5.5 17-4.4 22.5 2.5s4.4 17-2.5 22.5zM307.5 102c5.5-6.9 15.6-8 22.5-2.5l80 64c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5l-80-64c-6.9-5.5-8-15.6-2.5-22.5z", "M204.5 102c-5.5-6.9-15.6-8-22.5-2.5l-80 64c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l80-64c6.9-5.5 8-15.6 2.5-22.5zm94.8 197.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7V330.4c0-11-9-20-20-20s-20 9-20 20V384v32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3zM310 124.5l80 64c6.9 5.5 17 4.4 22.5-2.5s4.4-17-2.5-22.5l-80-64c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5z"]]
};
var faGaugeSimpleMin = {
  prefix: 'fad',
  iconName: 'gauge-simple-min',
  icon: [512, 512, ["tachometer-slowest"], "f62d", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-35.3-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64s64-28.7 64-64z", "M100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6z"]]
};
var faTachometerSlowest = faGaugeSimpleMin;
var faStethoscope = {
  prefix: 'fad',
  iconName: 'stethoscope',
  icon: [576, 512, [129658], "f0f1", ["M448 265.3V336c0 61.9-50.1 112-112 112c-57.6 0-105-43.4-111.3-99.3c-10.6 2.2-21.5 3.3-32.7 3.3c-10.8 0-21.3-1.1-31.5-3.1C167.1 440.1 243.1 512 336 512c97.2 0 176-78.8 176-176V265.3c-9.8 4.3-20.6 6.7-32 6.7s-22.2-2.4-32-6.7z", "M122.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S118.6-3.9 101.9 1.6L75.8 10.3C49.6 19.1 32 43.5 32 71.1V192c0 88.4 71.6 160 160 160s160-71.6 160-160V71.1c0-27.5-17.6-52-43.8-60.7L282.1 1.6c-16.8-5.6-34.9 3.5-40.5 20.2s3.5 34.9 20.2 40.5L288 71.1V192c0 53-43 96-96 96s-96-43-96-96V71.1l26.1-8.7zM512 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]]
};
var faCoffin = {
  prefix: 'fad',
  iconName: 'coffin',
  icon: [384, 512, [9904], "f6c6", ["M11.5 114.9l91-104C108.5 4 117.3 0 126.5 0h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6z", ""]]
};
var faMessage = {
  prefix: 'fad',
  iconName: 'message',
  icon: [512, 512, ["comment-alt"], "f27a", ["M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z", ""]]
};
var faCommentAlt = faMessage;
var faSalad = {
  prefix: 'fad',
  iconName: 'salad',
  icon: [512, 512, [129367, "bowl-salad"], "f81e", ["M423.8 96.2c-2.6-.2-5.2-.2-7.8-.2c-70.7 0-128 57.3-128 128c0 11 1.4 21.8 4 32H240V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V249.4L107.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256H96c-53 0-96-43-96-96s43-96 96-96c8.7 0 17.2 1.2 25.3 3.4C138.5 27.7 178 0 224 0s85.5 27.7 102.7 67.4c8-2.2 16.5-3.4 25.3-3.4c28.5 0 54.2 12.5 71.8 32.2zM512 224c0 11.2-1.9 22-5.5 32H325.5c-3.5-10-5.5-20.8-5.5-32c0-53 43-96 96-96s96 43 96 96z", "M27.4 288C12.3 288 0 300.3 0 315.4c0 70.5 44.4 130.7 106.7 154.1l1.8 14.4c2 16 15.6 28 31.8 28H371.8c16.1 0 29.8-12 31.8-28l1.8-14.4C467.6 446.1 512 385.9 512 315.4c0-15.1-12.3-27.4-27.4-27.4H27.4z"]]
};
var faBowlSalad = faSalad;
var faInfo = {
  prefix: 'fad',
  iconName: 'info',
  icon: [192, 512, [], "f129", ["M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80z", "M32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V224c0-17.7-14.3-32-32-32H32z"]]
};
var faRobotAstromech = {
  prefix: 'fad',
  iconName: 'robot-astromech',
  icon: [512, 512, [], "e2d2", ["M96 192c-26.5 0-48 21.5-48 48V398.3c0 8.7-2.4 17.2-6.8 24.7L2.3 487.8c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1h96c8.8 0 16-7.2 16-16V384l45.3 45.3c12 12 28.3 18.7 45.3 18.7h75c17 0 33.3-6.7 45.3-18.7L384 384V496c0 8.8 7.2 16 16 16h96c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1L470.8 423c-4.5-7.5-6.8-16-6.8-24.7V240c0-26.5-21.5-48-48-48H96zm112 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M128 128C128 57.3 185.3 0 256 0s128 57.3 128 128v64H128V128zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 256h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faRingDiamond = {
  prefix: 'fad',
  iconName: 'ring-diamond',
  icon: [384, 512, [], "e5ab", ["M122.5 13.3C126.6 5.1 134.9 0 144 0h96c9.1 0 17.4 5.1 21.5 13.3l24 48c3.5 7.1 3.4 15.5-.5 22.4l-30.4 54.8C234.9 131.7 213.9 128 192 128s-42.9 3.7-62.6 10.4L99 83.7c-3.8-6.9-4-15.3-.5-22.4l24-48z", "M192 192a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM384 320A192 192 0 1 1 0 320a192 192 0 1 1 384 0z"]]
};
var faFonduePot = {
  prefix: 'fad',
  iconName: 'fondue-pot',
  icon: [512, 512, [129749], "e40d", ["M319 39.8l-24 96c-2.9 11.5-11.6 20-22.2 23L256.5 224H224c0-1.3 .2-2.6 .5-3.9L241.8 151c-7.9-7.7-11.7-19.3-8.8-30.8l24-96C261.2 7.1 278.6-3.3 295.8 1s27.6 21.7 23.3 38.8zm62.9 120.2L339.2 224H304c0-3.1 .9-6.1 2.7-8.9l48.6-72.9c-4.9-9.9-4.5-22.1 2.1-31.9l64-96C431.2-.5 451-4.4 465.8 5.4s18.7 29.7 8.9 44.4l-64 96c-6.6 9.9-17.7 14.9-28.7 14.2zM64 240V224h48 48v16 32c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240z", "M64 224H32c-17.7 0-32 14.3-32 32v64c0 52.3 25.1 98.8 64 128v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-3.2c10.3 2.1 21 3.2 32 3.2H288c11 0 21.7-1.1 32-3.2V480c0 17.7 14.3 32 32 32s32-14.3 32-32V448c38.9-29.2 64-75.7 64-128V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448 384 160v16 32c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240 224z"]]
};
var faTheta = {
  prefix: 'fad',
  iconName: 'theta',
  icon: [384, 512, [], "f69e", ["M96 256c0-17.7 14.3-32 32-32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z", "M104.2 128.4C79.9 160 64 205 64 256s15.9 96 40.2 127.6C128.5 415.1 159.8 432 192 432s63.5-16.9 87.8-48.4C304.1 352 320 307 320 256s-15.9-96-40.2-127.6C255.5 96.9 224.2 80 192 80s-63.5 16.9-87.8 48.4zm-50.7-39C87.1 45.7 135.8 16 192 16s104.9 29.7 138.5 73.4C364.1 133.1 384 192.1 384 256s-19.9 122.9-53.5 166.6C296.9 466.3 248.2 496 192 496s-104.9-29.7-138.5-73.4C19.9 378.9 0 319.9 0 256S19.9 133.1 53.5 89.4z"]]
};
var faFaceHandPeeking = {
  prefix: 'fad',
  iconName: 'face-hand-peeking',
  icon: [640, 512, [129763], "e481", ["M545.5 134.7c-15.9-6.5-34.8-3.3-47.7 9.6c-7.3 7.3-11.5 16.6-12.6 26.2l-37.9-27.1c-10.9-7.8-24.3-9.3-36.1-5.4c-6.2-1.4-12.6-2.1-19.2-2.1c-48.6 0-88 39.4-88 88c0 40.3 27.1 74.3 64.1 84.7c-.1 1.1-.1 2.2-.1 3.3c0 22.1 17.9 40 40 40h8c0 .3 0 .6 0 .9c0 22.1 17.9 40 40 40h64.8c5.5 0 10.9-.4 16.3-1.1C491.8 464 411.5 512 320 512c-109.6 0-203-68.8-239.6-165.6c12.4 4.3 25.5 6.5 38.8 6.5l64.8 0c22.1 0 40-17.9 40-40c0-.3 0-.6 0-.9h8c22.1 0 40-17.9 40-40c0-2.6-.2-5.1-.7-7.5c10.1-7.3 16.7-19.1 16.7-32.5s-6.6-25.3-16.7-32.5c.5-2.4 .7-4.9 .7-7.5c0-22.1-17.9-40-40-40H156.8l1.5-1.5c17.2-17.2 17.2-45 0-62.2c-6-6-13.2-9.9-20.9-11.7C183.8 29.3 248.5 0 320 0c97.5 0 182.2 54.5 225.5 134.7zM384 400c0-26.5-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48zm32.4-176c0 6.1-2.3 11.8-6.1 16H374.5c-3.8-4.2-6.1-9.9-6.1-16c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M232 208c8.8 0 16-7.2 16-16s-7.2-16-16-16H118.2c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L51.9 166.4l-.8 .8C14.7 204.4 15 264.1 51.9 301c17.9 17.9 42.1 27.9 67.3 27.9l64.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-14 0c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5h62c8.8 0 16-7.2 16-16s-7.2-16-16-16H169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4l78.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4l62.4 0zm182.7-19c-7.2-5.1-8.9-15.1-3.7-22.3s15.1-8.9 22.3-3.7l81.8 58.4c2.3 1.6 5.1 2.3 7.8 2c9.3-1.1 13.2-12.4 6.6-19l-14.8-14.8c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l45.1 45.1 .8 .8c36.4 37.2 36.1 96.9-.8 133.8c-17.9 17.9-42.1 27.9-67.3 27.9H456c-8.8 0-16-7.2-16-16s7.2-16 16-16h19.5c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5L408 328c-8.8 0-16-7.2-16-16s7.2-16 16-16h68c2.2 0 4-1.8 4-4s-1.8-4-4-4H392c-8.8 0-16-7.2-16-16s7.2-16 16-16l74.6 0c7.4 0 13.4-6 13.4-13.4c0-4.3-2.1-8.4-5.6-10.9L414.7 189z"]]
};
var faSquareUser = {
  prefix: 'fad',
  iconName: 'square-user',
  icon: [448, 512, [], "e283", ["M81.1 416H366.9c-7.8-54.3-54.4-96-110.9-96H192c-56.4 0-103.1 41.7-110.9 96zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144z", "M152 200a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM81.1 416c7.8-54.3 54.4-96 110.9-96h64c56.4 0 103.1 41.7 110.9 96H81.1z"]]
};
var faDownLeftAndUpRightToCenter = {
  prefix: 'fad',
  iconName: 'down-left-and-up-right-to-center',
  icon: [512, 512, ["compress-alt"], "f422", ["M216 272H72c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39L7 439c-9.4 9.4-9.4 24.6 0 33.9l32 32c9.4 9.4 24.6 9.4 33.9 0l87-87 39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V296c0-13.3-10.7-24-24-24z", "M473 7c-9.4-9.4-24.6-9.4-33.9 0l-87 87L313 55c-6.9-6.9-17.2-8.9-26.2-5.2S272 62.3 272 72V216c0 13.3 10.7 24 24 24H440c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-39-39 87-87c9.4-9.4 9.4-24.6 0-33.9L473 7z"]]
};
var faCompressAlt = faDownLeftAndUpRightToCenter;
var faExplosion = {
  prefix: 'fad',
  iconName: 'explosion',
  icon: [576, 512, [], "e4e9", ["M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-91.4 91.4c1.6 9 2.4 18.2 2.4 27.7H384c0-53-43-96-96-96s-96 43-96 96H128c0-8.1 .6-16 1.8-23.8L42.3 363.7c-9.7-6.8-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.6 9.4-11.3L107.4 236.4c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM288 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z", "M0 480c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
};
var faFileLines = {
  prefix: 'fad',
  iconName: 'file-lines',
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]]
};
var faFileAlt = faFileLines;
var faFileText = faFileLines;
var faWaveSquare = {
  prefix: 'fad',
  iconName: 'wave-square',
  icon: [640, 512, [], "f83e", ["M128 64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V416h96V256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96H192V256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z", ""]]
};
var faRing = {
  prefix: 'fad',
  iconName: 'ring',
  icon: [512, 512, [], "f70b", ["M411.1 255.2C434.3 242 448 225.6 448 208c0-44.2-86-80-192-80s-192 35.8-192 80c0 17.6 13.7 34 36.9 47.2C141.2 235.9 195.8 224 256 224s114.8 11.9 155.1 31.2z", "M111.9 157.4C147.1 139.8 198 128 256 128s108.9 11.8 144.1 29.4C437.2 176 448 195.7 448 208s-10.8 32-47.9 50.6C364.9 276.2 314 288 256 288s-108.9-11.8-144.1-29.4C74.8 240 64 220.3 64 208s10.8-32 47.9-50.6zM83.3 100.2C39.4 122.2 0 158.4 0 208v96c0 49.6 39.4 85.8 83.3 107.8C129.1 434.7 190.3 448 256 448s126.9-13.3 172.7-36.2c43.9-22 83.3-58.2 83.3-107.8V208c0-49.6-39.4-85.8-83.3-107.8C382.9 77.3 321.7 64 256 64s-126.9 13.3-172.7 36.2z"]]
};
var faBuildingUn = {
  prefix: 'fad',
  iconName: 'building-un',
  icon: [384, 512, [], "e4d9", ["M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M237.3 71.1c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3v96c0 8.8 7.2 16 16 16s16-7.2 16-16V132.8l34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v43.2l-34.7-52zM112 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 26.5 21.5 48 48 48s48-21.5 48-48V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V80z"]]
};
var faDiceThree = {
  prefix: 'fad',
  iconName: 'dice-three',
  icon: [448, 512, [9858], "f527", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faTirePressureWarning = {
  prefix: 'fad',
  iconName: 'tire-pressure-warning',
  icon: [512, 512, [], "f633", ["M384 32c0-17.7 14.3-32 32-32s32 14.3 32 32V54.5c0 24.1 3.9 48 11.5 70.8l2.5 7.4c4.8 14.4 11.5 28.6 19.3 44.4c17.5 35.6 33.4 82.6 27.5 136.2c-5.3 48.6-28.1 99-76.8 148.7v34c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16v-8H336v8c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16v-8H240v8c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16v-8H144v8c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V462C31.3 412.3 8.6 361.9 3.2 313.3c-5.9-53.6 9.9-100.6 27.5-136.2c7.8-15.8 14.5-30 19.3-44.4l2.5-7.4C60.1 102.5 64 78.5 64 54.5V32C64 14.3 78.3 0 96 0s32 14.3 32 32V54.5c0 31-5 61.7-14.8 91.1l-2.5 7.4c-6.3 19-14.8 36.6-22.6 52.5c-14.7 29.7-25.3 64-21.3 100.9c3.7 34 20.4 74.1 65.7 117.7H379.4c45.3-43.6 62-83.7 65.7-117.7c4.1-36.9-6.6-71.1-21.3-100.9c-7.8-15.8-16.3-33.5-22.6-52.5l-2.5-7.4C389 116.2 384 85.4 384 54.5V32z", "M280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24V232c0 13.3 10.7 24 24 24s24-10.7 24-24V120zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faWifiFair = {
  prefix: 'fad',
  iconName: 'wifi-fair',
  icon: [640, 512, ["wifi-2"], "f6ab", ["M320 96C216.8 96 123.2 136.7 54.2 202.9c-12.8 12.2-33 11.8-45.2-.9s-11.8-33 .9-45.2C90.3 79.5 199.6 32 320 32s229.7 47.5 310.2 124.7c12.8 12.2 13.2 32.5 .9 45.2s-32.5 13.2-45.2 .9C516.8 136.7 423.2 96 320 96z", "M171.8 312c39.5-34.9 91.3-56 148.2-56s108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8zM320 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faWifi2 = faWifiFair;
var faCalendarDays = {
  prefix: 'fad',
  iconName: 'calendar-days',
  icon: [448, 512, ["calendar-alt"], "f073", ["M0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zM80 384c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336z", "M160 32c0-17.7-14.3-32-32-32S96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32z"]]
};
var faCalendarAlt = faCalendarDays;
var faMp3Player = {
  prefix: 'fad',
  iconName: 'mp3-player',
  icon: [384, 512, [], "f8ce", ["M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM288 352A96 96 0 1 0 96 352a96 96 0 1 0 192 0zM96 64C78.3 64 64 78.3 64 96v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96z", "M96 64H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM224 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 352a96 96 0 1 1 192 0A96 96 0 1 1 96 352z"]]
};
var faAnchorCircleCheck = {
  prefix: 'fad',
  iconName: 'anchor-circle-check',
  icon: [640, 512, [], "e4aa", ["M288 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 32c0 33.4-17 62.8-42.9 80H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H320V368v80h19.2c12.6 24.7 30.9 46 53 62.2c-7.9 1.2-16 1.8-24.2 1.8H288 208c-88.4 0-160-71.6-160-160v-6.1l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56-56c9.4-9.4 24.6-9.4 33.9 0l56 56c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7V352c0 53 43 96 96 96h48V240H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h10.9C209 158.8 192 129.4 192 96c0-53 43-96 96-96s96 43 96 96z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faTally4 = {
  prefix: 'fad',
  iconName: 'tally-4',
  icon: [640, 512, [], "e297", ["M128 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm128 0c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM416 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32z", "M512 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"]]
};
var faRectangleHistory = {
  prefix: 'fad',
  iconName: 'rectangle-history',
  icon: [512, 512, [], "e4a2", ["M464 104c0-13.3-10.7-24-24-24L72 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0c13.3 0 24-10.7 24-24zM416 24c0-13.3-10.7-24-24-24L120 0C106.7 0 96 10.7 96 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24z", "M448 160c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0z"]]
};
var faBuildingCircleArrowRight = {
  prefix: 'fad',
  iconName: 'building-circle-arrow-right',
  icon: [640, 512, [], "e4d1", ["M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm19.3-211.3l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]]
};
var faVolleyball = {
  prefix: 'fad',
  iconName: 'volleyball',
  icon: [512, 512, [127952, "volleyball-ball"], "f45f", ["M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z", "M138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9c5.2 21.2 13 41.5 23.1 60.3c6.7-108.7 71.9-209.9 177.1-257.9c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451c8.9 7.5 18.2 14.5 28.1 20.8c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c15.6-14.9 29.3-31.8 40.7-50.2c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.8 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6c2.1-11.3 3.4-22.9 3.9-34.7c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.6-204.2-103.2-272.4C307.3 4.2 286 .8 263.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.2-2.4-86.4-14.1-126.8-35.9c-2.5-90.9-41.1-172.7-101.9-231.7c-11 3.9-21.7 8.6-32 14z"]]
};
var faVolleyballBall = faVolleyball;
var faSunHaze = {
  prefix: 'fad',
  iconName: 'sun-haze',
  icon: [640, 512, [], "f765", ["M435.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L320 65.1 229.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L185 121 77.1 140.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L129.1 256l62.9 0c0-70.7 57.3-128 128-128s128 57.3 128 128l62.9 0 62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L455 121 435.1 13.1zM416 256c0-53-43-96-96-96s-96 43-96 96H416z", "M640 312c0-13.3-10.7-24-24-24H504c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24zm-208 0c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24s10.7 24 24 24H408c13.3 0 24-10.7 24-24zm144 88c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24zM88 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zm208 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H296z"]]
};
var faTextSize = {
  prefix: 'fad',
  iconName: 'text-size',
  icon: [640, 512, [], "f894", ["M64 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V80C0 53.5 21.5 32 48 32H192 336c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H224l0 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32l0-320H64z", "M384 288v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V272c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H512l0 128h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432c-17.7 0-32-14.3-32-32s14.3-32 32-32h16l0-128H384z"]]
};
var faUfo = {
  prefix: 'fad',
  iconName: 'ufo',
  icon: [640, 512, [128760], "e047", ["M496 237.1s-51.8 50.9-176 50.9s-176-50.9-176-50.9C144 141.5 222.8 64 320 64s176 77.5 176 173.1z", "M320 288c124.2 0 176-50.9 176-50.9c0-8.3-.6-16.5-1.7-24.5C582 235.5 640 275 640 320c0 70.7-143.3 128-320 128S0 390.7 0 320c0-45 58-84.5 145.7-107.4c-1.2 8-1.7 16.2-1.7 24.5c0 0 51.8 50.9 176 50.9zm24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm408-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]]
};
var faFork = {
  prefix: 'fad',
  iconName: 'fork',
  icon: [512, 512, ["utensil-fork"], "f2e3", ["M411.3 27.3c5.8-5.8 6.3-15.1 1.1-21.5S398-1.9 391.1 2.7l-106.5 71C256.8 92.3 240 123.6 240 157.1c0 26.6 10.6 52.1 29.4 70.9L284 242.6c18.8 18.8 44.3 29.4 70.9 29.4c33.5 0 64.8-16.8 83.4-44.6l71-106.5c4.6-6.8 3.2-16-3.2-21.2s-15.6-4.8-21.5 1.1L393.4 192c-5.2 5.2-13.6 5.2-18.8 0c-4.9-4.9-5.2-12.8-.6-18.1l86.1-99.4c5.5-6.3 5.2-15.9-.8-21.8s-15.4-6.3-21.8-.8L338.1 138c-5.3 4.6-13.2 4.3-18.1-.6c-5.2-5.2-5.2-13.6 0-18.8l91.3-91.3z", "M9.4 457.4L255.7 211c3.9 6.1 8.4 11.8 13.6 17L284 242.6c5.2 5.2 10.9 9.8 17 13.6L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3z"]]
};
var faUtensilFork = faFork;
var faArrowsUpToLine = {
  prefix: 'fad',
  iconName: 'arrows-up-to-line',
  icon: [576, 512, [], "e4c2", ["M0 64C0 81.7 14.3 96 32 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64z", "M54.6 278.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L160 237.3 160 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-210.7L54.6 278.6zm320 0c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 237.3 480 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-210.7-41.4 41.4z"]]
};
var faMobileSignal = {
  prefix: 'fad',
  iconName: 'mobile-signal',
  icon: [512, 512, [], "e1ef", ["M288 64H64V448H227c-2 13-3 26.4-3 40v24H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64V261.7c-24.1 14.5-45.7 32.8-64 54V64zM128 400c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16z", "M512 280c0-13.3-10.7-24-24-24c-128.1 0-232 103.9-232 232c0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184c13.3 0 24-10.7 24-24zM448 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40-128c-75.1 0-136 60.9-136 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]]
};
var faBarcodeScan = {
  prefix: 'fad',
  iconName: 'barcode-scan',
  icon: [640, 512, [], "f465", ["M0 256c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z", "M64 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V192H64V56zm0 264h64V456c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V320zm96 0h32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V320zm64 0h64V456c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V320zm64-128H224V56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V192zm32 128h64V456c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V320zm64-128H320V56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V192zm64 128h32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V320zm32-128H448V48c0-8.8 7.2-16 16-16s16 7.2 16 16V192zm32 128h64V456c0 13.3-10.7 24-24 24H536c-13.3 0-24-10.7-24-24V320zm64-128H512V56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V192zm-384 0H160V48c0-8.8 7.2-16 16-16s16 7.2 16 16V192z"]]
};
var faSortDown = {
  prefix: 'fad',
  iconName: 'sort-down',
  icon: [320, 512, ["sort-desc"], "f0dd", ["M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zM109.3 160H210.7L160 109.3 109.3 160z", "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]]
};
var faSortDesc = faSortDown;
var faFolderArrowDown = {
  prefix: 'fad',
  iconName: 'folder-arrow-down',
  icon: [512, 512, ["folder-download"], "e053", ["M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24V302.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V200z", "M256 176c13.3 0 24 10.7 24 24V302.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V200c0-13.3 10.7-24 24-24z"]]
};
var faFolderDownload = faFolderArrowDown;
var faCircleMinus = {
  prefix: 'fad',
  iconName: 'circle-minus',
  icon: [512, 512, ["minus-circle"], "f056", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M160 256c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24z"]]
};
var faMinusCircle = faCircleMinus;
var faFaceIcicles = {
  prefix: 'fad',
  iconName: 'face-icicles',
  icon: [512, 512, [], "e37c", ["M512 256c0 8.3-.4 16.6-1.2 24.7c0 .5-.1 1.1-.1 1.6l-14.8 200C494.7 499.1 480.8 512 464 512s-30.7-12.9-31.9-29.6l-2.8-37.9c-5 4.6-10.2 9-15.6 13.2l-11.5 32.9C397.7 503.4 385.6 512 372 512c-11.5 0-21.9-6.1-27.5-15.7C316.9 506.5 287.1 512 256 512c-69.4 0-132.3-27.6-178.4-72.4C71.9 444.9 64.3 448 56 448c-15.6 0-29-11.3-31.6-26.7L6.5 313.4C2.2 294.9 0 275.7 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM56 415.8l0 .2 0-.2 20-120.2C78.1 283.3 68.6 272 56 272s-22.1 11.3-20.1 23.7L56 415.8zM344 400l28 80 28-80V360l-56 0v40zm55.3-56c-3.8-22.7-23.6-40-47.3-40h-8v40l55.3 0zM328 344V304H264v40h64zm0 56V360H264v40l32 48 32-48zm-80-96H184v40l64 0V304zm0 56l-64 0v40h64V360zm-80-16V304h-8c-23.8 0-43.5 17.3-47.3 40H168zm0 56V360H112.7c3.8 22.7 23.6 40 47.3 40h8zm40.4-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 480l21.8-232.1C487 235.1 476.9 224 464 224s-23 11.1-21.8 23.9L464 480z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faShovel = {
  prefix: 'fad',
  iconName: 'shovel',
  icon: [512, 512, [], "f713", ["M406.6 9.4c-12.5-12.5-32.8-12.5-45.3 0L317.3 53.5C298.5 72.2 288 97.6 288 124.1c0 15.9 3.7 30.9 10.3 44.3l-97 97 45.3 45.3 97-97c13.4 6.6 28.4 10.3 44.3 10.3c26.5 0 51.9-10.5 70.6-29.3l44.1-44.1c12.5-12.5 12.5-32.8 0-45.3l-96-96zM362.5 98.7L384 77.3 434.7 128l-21.5 21.5c-6.7 6.7-15.9 10.5-25.4 10.5c-19.8 0-35.9-16.1-35.9-35.9c0-9.5 3.8-18.6 10.5-25.4z", "M0 386.3V480c0 17.7 14.3 32 32 32h93.7c42.4 0 83.1-16.9 113.1-46.9l58.5-58.5c12.5-12.5 12.5-32.8 0-45.3L150.6 214.6c-12.5-12.5-32.8-12.5-45.3 0L46.9 273.1C16.9 303.1 0 343.8 0 386.3z"]]
};
var faDoorOpen = {
  prefix: 'fad',
  iconName: 'door-open',
  icon: [576, 512, [], "f52b", ["M307.7 6.8C315.5 12.8 320 22.1 320 32V480v32l-32 0L96 512l-32 0V480 92.5c0-22 15-41.2 36.4-46.6L280.2 1c9.6-2.4 19.7-.2 27.5 5.8zM232 288c13.3 0 24-14.3 24-32s-10.7-32-24-32s-24 14.3-24 32s10.7 32 24 32z", "M320 128H448V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H320v64zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448H32zM232 288c13.3 0 24-14.3 24-32s-10.7-32-24-32s-24 14.3-24 32s10.7 32 24 32z"]]
};
var faFilms = {
  prefix: 'fad',
  iconName: 'films',
  icon: [576, 512, [], "e17a", ["M256 112v48c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32zm0 144v48c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z", "M96 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96zm56 0v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16zM488 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H488zM152 200v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V200c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16zm336-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V200c0-8.8-7.2-16-16-16H488zM152 304v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16zm336-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H488zM256 112v48c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32zm32 112c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H288z"]]
};
var faRightFromBracket = {
  prefix: 'fad',
  iconName: 'right-from-bracket',
  icon: [512, 512, ["sign-out-alt"], "f2f5", ["M199.7 60.8c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96l0-256c0-53 43-96 96-96l64 0c17.7 0 32 14.3 32 32z", "M508.4 225.5L385.7 102.7c-6.4-6.4-15-9.9-24-9.9c-18.7 0-33.9 15.2-33.9 33.9l0 62.1-128 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0 0 62.1c0 18.7 15.2 33.9 33.9 33.9c9 0 17.6-3.6 24-9.9L508.4 280.1c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3z"]]
};
var faSignOutAlt = faRightFromBracket;
var faFaceGlasses = {
  prefix: 'fad',
  iconName: 'face-glasses',
  icon: [512, 512, [], "e377", ["M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256c0-22.8 3-44.8 8.5-65.8c2.2 1.2 4.8 1.8 7.5 1.8H48v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V192h32v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V192h32c2.7 0 5.2-.7 7.5-1.8c5.6 21 8.5 43.1 8.5 65.8zM53.4 160H18.6C56.6 66.2 148.6 0 256 0S455.4 66.2 493.4 160H458.6c-9-18.9-28.3-32-50.6-32H328c-22.3 0-41.6 13.1-50.6 32H234.6c-9-18.9-28.3-32-50.6-32H104c-22.3 0-41.6 13.1-50.6 32zm88.1 179.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6z", "M16 192H48v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V192h32v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V192h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H458.6c-9-18.9-28.3-32-50.6-32H328c-22.3 0-41.6 13.1-50.6 32H234.6c-9-18.9-28.3-32-50.6-32H104c-22.3 0-41.6 13.1-50.6 32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16zm64 56V192v-8c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24zm352-56v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v8zM184.4 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faNfc = {
  prefix: 'fad',
  iconName: 'nfc',
  icon: [448, 512, [], "e1f7", ["M210.7 128H144 112c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16v66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-5.6 1-11 2.7-16z", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h66.7c6.6-18.6 24.4-32 45.3-32h80c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"]]
};
var faAtom = {
  prefix: 'fad',
  iconName: 'atom',
  icon: [512, 512, [9883], "f5d2", ["M290.9 412.3c-16.7 33.8-31 35.7-34.9 35.7s-18.1-1.9-34.9-35.7c11.4-3.9 23.1-8.4 34.9-13.5c11.8 5.1 23.4 9.7 34.9 13.5zM469.6 384c20.7-37.1 9.4-82.8-23.6-128c33-45.2 44.3-90.9 23.6-128c-20.2-36.3-62.5-49.3-115.2-43.2C332.4 32.7 298.8 0 256 0s-76.4 32.7-98.4 84.8c-52.7-6.1-95 6.8-115.2 43.2C21.7 165.1 33 210.8 66 256c-33 45.2-44.3 90.9-23.6 128c20.2 36.3 62.5 49.3 115.2 43.2c22 52.1 55.7 84.8 98.4 84.8s76.4-32.7 98.4-84.8c52.7 6.1 95-6.8 115.2-43.2zm-67.8-79.2c18.9 30.2 14.2 44 11.9 48.1c-1.6 2.9-8.4 13-40.2 11.7c2.8-13.1 5-26.9 6.7-41.2c7.6-6.1 14.8-12.3 21.6-18.6zm11.9-145.7c2.3 4.2 7 17.9-11.9 48.1c-6.8-6.3-14-12.5-21.6-18.6c-1.7-14.3-3.9-28-6.7-41.2c31.8-1.4 38.6 8.7 40.2 11.7zM256 64c3.9 0 18.1 1.9 34.9 35.7c-11.4 3.9-23.1 8.4-34.9 13.5c-11.8-5.1-23.4-9.7-34.9-13.5C237.9 65.9 252.1 64 256 64zM138.5 147.5c-2.8 13.1-5 26.9-6.7 41.2c-7.6 6.1-14.8 12.3-21.6 18.6C91.4 177 96 163.3 98.3 159.1c1.6-2.9 8.4-13 40.2-11.7zM98.3 352.9c-2.3-4.2-7-17.9 11.9-48.1c6.8 6.3 14 12.5 21.6 18.6c1.7 14.2 3.9 28 6.7 41.2c-31.8 1.4-38.6-8.7-40.2-11.7zM256 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faSoap = {
  prefix: 'fad',
  iconName: 'soap',
  icon: [512, 512, [129532], "e06e", ["M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm96 144a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM384 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M385.6 262.1C404.3 244.5 416 219.6 416 192c53 0 96 43 96 96V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V288c0-53 43-96 96-96H224c0 24.6 9.2 47 24.4 64H160c-53 0-96 43-96 96s43 96 96 96H352c53 0 96-43 96-96c0-41.2-25.9-76.3-62.4-89.9zM320 288h32c35.3 0 64 28.7 64 64s-28.7 64-64 64H160c-35.3 0-64-28.7-64-64s28.7-64 64-64H320z"]]
};
var faIcons = {
  prefix: 'fad',
  iconName: 'icons',
  icon: [512, 512, ["heart-music-camera-bolt"], "f86d", ["M139.7 219.1l96.4-99.9c28-29 26.5-76.9-4.5-103.9c-28-23.5-68.9-19-93.9 6.5l-9.5 10.5-10-10.5c-25-25.5-66.4-30-93.4-6.5c-31.5 27-33 74.9-5 103.9l96.9 99.9c6 6.5 16.5 6.5 23 0zm333.7 39.9c-6-4.4-14.3-4-19.9 .9l-128 112c-5 4.4-6.8 11.4-4.4 17.7s8.3 10.4 15 10.4h55.7l-38.4 89.7c-2.9 6.9-.7 14.9 5.3 19.2s14.3 4 19.9-.9l128-112c5-4.4 6.8-11.4 4.4-17.7s-8.3-10.4-15-10.4H440.3l38.4-89.7c2.9-6.9 .7-14.9-5.3-19.2z", "M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L213.3 304H256c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V336c0-17.7 14.3-32 32-32H74.7zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]]
};
var faHeartMusicCameraBolt = faIcons;
var faMicrophoneLinesSlash = {
  prefix: 'fad',
  iconName: 'microphone-lines-slash',
  icon: [640, 512, ["microphone-alt-slash"], "f539", ["M401.3 412.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2zm70.8-67.5c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24 16c0 21.2-5.1 41.1-14.2 58.7l38.3 30zM408 294.5c5.2-11.8 8-24.8 8-38.5H358.9L408 294.5zM324.4 229c2.9-3.1 7-5 11.6-5h80V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L324.4 229z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faMicrophoneAltSlash = faMicrophoneLinesSlash;
var faClosedCaptioningSlash = {
  prefix: 'fad',
  iconName: 'closed-captioning-slash',
  icon: [640, 512, [], "e135", ["M32 121.2V416c0 35.3 28.7 64 64 64H487.4L295 328.4c-16.8 14.7-38.9 23.6-63 23.6c-53 0-96-43-96-96c0-16 3.9-31.1 10.8-44.3L32 121.2zM255.9 297.6l-70-55.1c-1.3 4.3-1.9 8.8-1.9 13.5c0 26.5 21.5 48 48 48c8.7 0 16.9-2.3 23.9-6.4zM303.5 192c6.1 6.8 7.6 16.2 4.7 24.3l22.4 17.5c10-42.3 48-73.8 93.4-73.8c28.4 0 54 12.4 71.5 32c8.8 9.9 8 25-1.9 33.9s-25 8-33.9-1.9c-8.8-9.9-21.6-16-35.8-16c-26.5 0-48 21.5-48 48c0 5.4 .9 10.5 2.5 15.4l41.4 32.5c1.3 .1 2.7 .2 4.1 .2c14.2 0 27-6.1 35.8-16c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9c-7.8 8.7-17.2 16-27.7 21.4L600.8 445.6c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9L236.6 160.1c26.6 1.2 50.4 13.3 67 31.9z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faCalculatorSimple = {
  prefix: 'fad',
  iconName: 'calculator-simple',
  icon: [512, 512, ["calculator-alt"], "f64c", ["M48 0C21.5 0 0 21.5 0 48V176c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM336 0c-26.5 0-48 21.5-48 48V176c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H336zM0 336V464c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48zM416 64V96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16s16 7.2 16 16zM64 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM83.3 348.7L112 377.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L134.6 400l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L112 422.6 83.3 451.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 400 60.7 371.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z", "M416 64V96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16s16 7.2 16 16zM64 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM83.3 348.7L112 377.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L134.6 400l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L112 422.6 83.3 451.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 400 60.7 371.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM288 336c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V336zm48 32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16z"]]
};
var faCalculatorAlt = faCalculatorSimple;
var faBridgeCircleCheck = {
  prefix: 'fad',
  iconName: 'bridge-circle-check',
  icon: [640, 512, [], "e4c9", ["M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h72v72.2C577.6 207.1 538.5 192 496 192c-69.1 0-128.9 39.8-157.7 97.7c-5.9-1.1-12-1.7-18.3-1.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faSlidersUp = {
  prefix: 'fad',
  iconName: 'sliders-up',
  icon: [512, 512, ["sliders-v"], "f3f1", ["M96 0C78.3 0 64 14.3 64 32V86.7C73.8 82.4 84.6 80 96 80s22.2 2.4 32 6.7V32c0-17.7-14.3-32-32-32zM64 233.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V233.3c-9.8 4.3-20.6 6.7-32 6.7s-22.2-2.4-32-6.7zM256 0c-17.7 0-32 14.3-32 32V278.7c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7V32c0-17.7-14.3-32-32-32zM224 425.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V425.3c-9.8 4.3-20.6 6.7-32 6.7s-22.2-2.4-32-6.7zM448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v86.7c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7V32zM384 265.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V265.3c-9.8 4.3-20.6 6.7-32 6.7s-22.2-2.4-32-6.7z", "M96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112A80 80 0 1 0 96 80a80 80 0 1 0 0 160zm160 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM384 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]]
};
var faSlidersV = faSlidersUp;
var faLocationMinus = {
  prefix: 'fad',
  iconName: 'location-minus',
  icon: [384, 512, ["map-marker-minus"], "f609", ["M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM120 168H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M96 192c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24z"]]
};
var faMapMarkerMinus = faLocationMinus;
var faPumpMedical = {
  prefix: 'fad',
  iconName: 'pump-medical',
  icon: [448, 512, [], "e06a", ["M117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M128 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h60.1c21.2 0 41.6 8.4 56.6 23.4l33.9 33.9c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-33.9-33.9c-3-3-7.1-4.7-11.3-4.7H256v64H128V32zm64 224c13.3 0 24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24z"]]
};
var faFingerprint = {
  prefix: 'fad',
  iconName: 'fingerprint',
  icon: [512, 512, [], "f577", ["M256 80c97.2 0 176 78.8 176 176v24.9c0 27.7-1.7 55.3-5 82.7c-1.4 11.7-11.5 20.3-23.3 20.3c-14.7 0-25.9-13.2-24.2-27.8c3-24.9 4.4-50.1 4.4-75.3V256c0-70.7-57.3-128-128-128c-11.6 0-22.8 1.5-33.4 4.4c-10.6 2.9-22.3 .4-29.4-7.9c-10.4-12.1-6.9-30.9 8.3-35.9C218.6 83 237 80 256 80zM150.7 148.7c8.2 9.6 7.5 23.8 .2 34.2C136.5 203.6 128 228.8 128 256v24.9c0 28.9-3.3 57.7-9.7 85.8C115.9 377 106.6 384 96.1 384c-15.9 0-27.3-15.6-23.9-31.1c5.2-23.6 7.8-47.7 7.8-71.9V256c0-40.6 13.7-78 36.8-107.7c8.5-11 24.8-10.2 33.9 .4zM280 256v24.9c0 65.8-12.1 131-35.7 192.4l-5.9 15.3c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l5.9-15.3C221 400.2 232 340.8 232 280.9V256c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM352 256c0-53-43-96-96-96s-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1V256z"]]
};
var faSkiBoot = {
  prefix: 'fad',
  iconName: 'ski-boot',
  icon: [512, 512, [], "e3cc", ["M480 448L5.6 448l-5 26c-1.8 9.4 .7 19.1 6.8 26.4c6.1 7.3 15.1 11.6 24.6 11.6H480.1c17.6 0 31.9-14.3 31.9-32c0-17.7-14.3-32-32-32zM35.4 292.8c45.7-10.8 158.9-58 194-260.8H112C96.7 32 83.5 42.9 80.6 58L35.4 292.8z", "M358 .6c17.4 3.3 28.7 20.1 25.4 37.5l-6.2 32L360 160H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h65.8l-12.3 64H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h68l122 59.2c11 5.4 18 16.5 18 28.8v72L5.6 448 35.4 292.8c45.7-10.8 158.9-58 194-260.8h90l1.2-6C323.9 8.6 340.7-2.8 358 .6z"]]
};
var faStandardDefinition = {
  prefix: 'fad',
  iconName: 'standard-definition',
  icon: [576, 512, ["rectangle-sd"], "e28a", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352zm-193.2 8.1c-.3 3 .2 3.9 .3 4.1l0 0c.2 .3 .9 1.5 3.9 3.3c7 4.2 18 7 34.1 10.7l1.7 .4 0 0c13.6 3.2 31.5 7.3 45.1 15.5c7.7 4.6 15.4 11.1 20.5 20.7c5.3 9.8 6.7 20.8 5 32.3c-1.6 10.9-6 20.7-13.4 28.5c-7.2 7.6-16 12.3-24.9 15.2c-17.2 5.4-37.5 4.9-56.4 2.3l-.1 0 0 0c-11-1.5-28.6-6.7-39.4-9.9l0 0 0 0 0 0c-2-.6-3.8-1.1-5.3-1.5c-11.9-3.4-18.8-15.8-15.4-27.7s15.8-18.8 27.7-15.4c2.3 .6 4.7 1.4 7.2 2.1c11.1 3.2 24 7 31.4 8c16.8 2.2 29.2 1.8 36.9-.6c3.5-1.1 5.1-2.4 5.8-3.1c.5-.6 1.3-1.6 1.7-4.3c.5-3.4-.1-4.5-.2-4.7l0 0c-.2-.3-.9-1.5-3.9-3.3c-7-4.2-18-7-34.1-10.7l-1.7-.4 0 0c-13.6-3.2-31.5-7.3-45.1-15.5c-7.7-4.6-15.4-11.1-20.5-20.7c-5.3-9.8-6.7-20.8-5-32.3c.1-.4 .1-.8 .2-1.2c4.6-22.6 19.7-36.2 38.5-42.3c17.1-5.5 37.1-5 56-2.5c5.8 .8 23.2 3.7 29.7 5.1c12.1 2.8 19.6 14.8 16.9 26.8s-14.8 19.6-26.8 16.9c-4.7-1.1-20.6-3.7-25.7-4.4c-16.8-2.2-28.8-1.7-36.2 .7c-5.5 1.8-7.3 3.9-8.3 8z", "M328 160c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96H328zm24 144V208h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H352zM167.1 208.1c7.4-2.4 19.5-2.9 36.2-.7c5.1 .7 21.1 3.4 25.7 4.4c12.1 2.8 24.1-4.8 26.8-16.9s-4.8-24.1-16.9-26.8c-6.5-1.5-23.9-4.4-29.7-5.1c-18.9-2.5-38.9-3.1-56 2.5c-18.8 6.1-33.9 19.7-38.5 42.3c-.1 .4-.1 .8-.2 1.2c-1.7 11.4-.2 22.4 5 32.3c5.1 9.6 12.9 16.1 20.5 20.7c13.7 8.2 31.5 12.3 45.1 15.5l1.7 .4c16 3.7 27.1 6.5 34.1 10.7c3 1.8 3.8 3 3.9 3.3l0 0c.1 .1 .7 1.2 .2 4.7c-.4 2.7-1.2 3.8-1.7 4.3c-.7 .7-2.3 2-5.8 3.1c-7.7 2.4-20.1 2.9-36.9 .6c-7.4-1-20.3-4.8-31.4-8c-2.5-.7-5-1.4-7.2-2.1c-11.9-3.4-24.3 3.5-27.7 15.4s3.5 24.3 15.4 27.7c1.5 .4 3.3 1 5.3 1.6l0 0 0 0c10.8 3.2 28.4 8.3 39.4 9.9l0 0 .1 0c18.9 2.5 39.2 3.1 56.4-2.3c8.9-2.8 17.8-7.5 24.9-15.2c7.3-7.8 11.8-17.6 13.4-28.5c1.7-11.4 .2-22.4-5-32.3c-5.1-9.6-12.9-16.1-20.5-20.7c-13.7-8.2-31.5-12.3-45.1-15.5l0 0-1.7-.4c-16-3.7-27.1-6.5-34.1-10.7c-3-1.8-3.8-3-3.9-3.3l0 0c-.1-.1-.6-1.1-.3-4.1c.9-4 2.8-6.2 8.3-8z"]]
};
var faRectangleSd = faStandardDefinition;
var faH1 = {
  prefix: 'fad',
  iconName: 'h1',
  icon: [576, 512, [], "f313", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M496.8 68.8C506.3 74.6 512 84.9 512 96V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480 416c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V147.8l-17.7 8.8c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l64-32c9.9-5 21.7-4.4 31.1 1.4z"]]
};
var faHandPointRight = {
  prefix: 'fad',
  iconName: 'hand-point-right',
  icon: [512, 512, [], "f0a4", ["M512 128c0 17.7-14.3 32-32 32l-208 0 0-64 208 0c17.7 0 32 14.3 32 32zM200 288l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z", "M352 192c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32h48zm-32 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm0 128c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32z"]]
};
var faMagnifyingGlassLocation = {
  prefix: 'fad',
  iconName: 'magnifying-glass-location',
  icon: [512, 512, ["search-location"], "f689", ["M208 416A208 208 0 1 0 208 0a208 208 0 1 0 0 416zm11.4-101.4c-6 7.3-16.8 7.3-22.7 0C174.5 287.6 128 224.8 128 176c0-44.2 35.8-80 80-80s80 35.8 80 80c0 48.8-46.5 111.6-68.6 138.6z", "M288 176c0 48.8-46.5 111.6-68.6 138.6c-6 7.3-16.8 7.3-22.7 0C174.5 287.6 128 224.8 128 176c0-44.2 35.8-80 80-80s80 35.8 80 80zm-48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm90.7 200C348 363.3 363.3 348 376 330.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376z"]]
};
var faSearchLocation = faMagnifyingGlassLocation;
var faMessageBot = {
  prefix: 'fad',
  iconName: 'message-bot',
  icon: [640, 512, [], "e3b8", ["M96 64c0-35.3 28.7-64 64-64H480c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H373.3L249.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H160c-35.3 0-64-28.7-64-64V64zm96 32c-17.7 0-32 14.3-32 32V256c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192z", "M59.7 208c-5.5 9.6-15.9 16-27.7 16c-17.7 0-32-14.3-32-32s14.3-32 32-32c11.8 0 22.2 6.4 27.7 16H96v32H59.7zM192 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 32c0 17.7-14.3 32-32 32c-11.8 0-22.2-6.4-27.7-16H544V176h36.3c5.5-9.6 15.9-16 27.7-16c17.7 0 32 14.3 32 32z"]]
};
var faForwardStep = {
  prefix: 'fad',
  iconName: 'forward-step',
  icon: [320, 512, ["step-forward"], "f051", ["M288 448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32z", "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4l192-160L256 271V241l-11.5-9.6-192-160c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z"]]
};
var faStepForward = faForwardStep;
var faFaceSmileBeam = {
  prefix: 'fad',
  iconName: 'face-smile-beam',
  icon: [512, 512, [128522, "smile-beam"], "f5b8", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z", "M217.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]]
};
var faSmileBeam = faFaceSmileBeam;
var faLightCeiling = {
  prefix: 'fad',
  iconName: 'light-ceiling',
  icon: [512, 512, [], "e016", ["M256 0c17.7 0 32 14.3 32 32V192H256 224V32c0-17.7 14.3-32 32-32zm64 448c0 35.3-28.7 64-64 64s-64-28.7-64-64H320z", "M256 192C125.4 192 17.7 289.8 2 416.1C-.2 433.6 14.3 448 32 448H480c17.7 0 32.2-14.4 30-31.9C494.3 289.8 386.6 192 256 192z"]]
};
var faMessageExclamation = {
  prefix: 'fad',
  iconName: 'message-exclamation',
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM256 80c-13.3 0-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M280 104c0-13.3-10.7-24-24-24s-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104zM256 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faCommentAltExclamation = faMessageExclamation;
var faBowlScoop = {
  prefix: 'fad',
  iconName: 'bowl-scoop',
  icon: [448, 512, [127847, "bowl-shaved-ice"], "e3de", ["M413.3 256c1.7-10.4 2.7-21.1 2.7-32c0-106-86-192-192-192S32 118 32 224c0 10.9 .9 21.6 2.7 32H413.3z", "M4 261.4c3-3.4 7.4-5.4 12-5.4H432c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9C436.9 361.9 375.6 416 303 416H262.6l68.7 68.7c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H128c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L185.4 416H145C72.4 416 11.1 361.9 2.1 289.9L.1 274c-.6-4.6 .8-9.1 3.9-12.6z"]]
};
var faBowlShavedIce = faBowlScoop;
var faSquareX = {
  prefix: 'fad',
  iconName: 'square-x',
  icon: [448, 512, [], "e286", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.3 104.5L224 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L192.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z", "M120.5 133.7c10.1-8.6 25.3-7.3 33.8 2.8L224 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L192.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8z"]]
};
var faUtilityPoleDouble = {
  prefix: 'fad',
  iconName: 'utility-pole-double',
  icon: [512, 512, [], "e2c4", ["M128 64H80V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8zM48 64H0V56C0 42.7 10.7 32 24 32s24 10.7 24 24v8zm35.2 64h57.7L224 183.4v38.5L83.2 128zM288 183.4L371.2 128h57.7L288 221.9V183.4zM384 64V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8H384zm80 0V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8H464zM288 375.4L371.2 320h57.7L288 413.9V375.4zM140.8 320L224 375.4v38.5L83.2 320h57.7zM128 256H80v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8zm-80 0H0v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8zm464 0H464v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8zm-80 0H384v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8z", "M256 0c17.7 0 32 14.3 32 32V64H512V96c0 17.7-14.3 32-32 32H288V256H512v32c0 17.7-14.3 32-32 32H288V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320H32c-17.7 0-32-14.3-32-32V256H224V128H32C14.3 128 0 113.7 0 96V64H224V32c0-17.7 14.3-32 32-32z"]]
};
var faFlagCheckered = {
  prefix: 'fad',
  iconName: 'flag-checkered',
  icon: [448, 512, [127937], "f11e", ["M64 246.2l69-17.2c19.4-4.9 39.4-6.1 59-3.8V331.8c20.3 2.4 40.2 8.3 58.7 17.5c21.8 10.9 45.4 17.1 69.3 18.5V258.7c25.2 0 50.4-5.8 73.6-17.4L448 214.2v-96l-54.4 27.2c-23.2 11.6-48.4 17.4-73.6 17.4V60.6c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3V129.1c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4v96c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3v-96c-19.6-2.3-39.6-1.1-59 3.8L64 150.2v96z", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c21-5.2 42.6-6.6 63.7-4.1V225.1c-19.6-2.3-39.6-1.1-59 3.8L64 246.2v-96l69-17.2c19.4-4.9 39.4-6.1 59-3.8v96c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4V367.8c24.4 1.4 49.1-2.2 72.5-11l34.7-13c12.5-4.7 20.8-16.6 20.8-30V214.2l-54.4 27.2c-23.2 11.6-48.4 17.4-73.6 17.4v-96c25.2 0 50.4-5.8 73.6-17.4L448 118.2v-52c0-23-24.2-38-44.8-27.7l-9.6 4.8C370.4 54.8 345.2 60.6 320 60.6V162.7c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3V27c-19.6-2.3-39.6-1.1-59 3.8L64 48V32z"]]
};
var faChevronsUp = {
  prefix: 'fad',
  iconName: 'chevrons-up',
  icon: [512, 512, ["chevron-double-up"], "f325", ["M233.4 233.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 301.3 86.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z", "M233.4 41.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 109.3 86.6 278.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]]
};
var faChevronDoubleUp = faChevronsUp;
var faFootball = {
  prefix: 'fad',
  iconName: 'football',
  icon: [512, 512, [127944, "football-ball"], "f44e", ["M16.8 306.7c2.1-19.2 5.4-38.6 10.1-57.8L264.5 486.6c-18.3 4.4-37.7 7.6-58.4 9.5L16.8 306.7zM485.1 263L247.5 25.4c18.3-4.4 37.7-7.6 58.4-9.5L495.2 205.3c-2.1 19.2-5.4 38.6-10.1 57.8z", "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"]]
};
var faFootballBall = faFootball;
var faUserVneck = {
  prefix: 'fad',
  iconName: 'user-vneck',
  icon: [448, 512, [], "e461", ["M352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z", "M130 308.3c6.1-1.4 12.4 1.4 15.9 6.6L210.7 412c6.3 9.5 20.3 9.5 26.6 0l64.8-97.1c3.5-5.2 9.8-8 15.9-6.6c74.5 17.2 130 84 130 163.7v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-79.7 55.5-146.5 130-163.7z"]]
};
var faSchoolCircleExclamation = {
  prefix: 'fad',
  iconName: 'school-circle-exclamation',
  icon: [640, 512, [], "e56c", ["M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V266.8C608.1 221.6 555.5 192 496 192c-38.5 0-74.2 12.4-103.1 33.4c9.6-14.1 15.1-31.1 15.1-49.4c0-48.6-39.4-88-88-88s-88 39.4-88 88s39.4 88 88 88c15.6 0 30.2-4 42.9-11.1c-23.4 27.1-38.8 61.4-42.2 99.1h-.5l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM336 144v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faCrop = {
  prefix: 'fad',
  iconName: 'crop',
  icon: [512, 512, [], "f125", ["M457.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-56.8 56.8c-5.9-22-23.2-39.4-45.3-45.3L457.4 9.4zM384 128v45.3L173.3 384H384v64H128c-35.3 0-64-28.7-64-64V32C64 14.3 78.3 0 96 0s32 14.3 32 32V338.7L338.7 128H384zm64 320V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448z", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H64V64H32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352c0-35.3-28.7-64-64-64H128v64l256 0 0 352z"]]
};
var faAnglesDown = {
  prefix: 'fad',
  iconName: 'angles-down',
  icon: [448, 512, ["angle-double-down"], "f103", ["M201.4 278.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 210.7 86.6 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z", "M201.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 86.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]]
};
var faAngleDoubleDown = faAnglesDown;
var faUsersRectangle = {
  prefix: 'fad',
  iconName: 'users-rectangle',
  icon: [640, 512, [], "e594", ["M175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z", "M0 96C0 43 43 0 96 0H544c53 0 96 43 96 96V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V96zM96 64C78.3 64 64 78.3 64 96V416c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96z"]]
};
var faPeopleRoof = {
  prefix: 'fad',
  iconName: 'people-roof',
  icon: [640, 512, [], "e537", ["M360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5z", "M304.5 4c9.7-5.4 21.4-5.4 31.1 0l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4z"]]
};
var faSquareArrowRight = {
  prefix: 'fad',
  iconName: 'square-arrow-right',
  icon: [448, 512, ["arrow-square-right"], "f33b", ["M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM361 273L249 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L361 239c9.4 9.4 9.4 24.6 0 33.9z", "M361 239c9.4 9.4 9.4 24.6 0 33.9L249 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L361 239z"]]
};
var faArrowSquareRight = faSquareArrowRight;
var faLocationPlus = {
  prefix: 'fad',
  iconName: 'location-plus',
  icon: [384, 512, ["map-marker-plus"], "f60a", ["M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM168 280V216H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V104c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M168 216v64c0 13.3 10.7 24 24 24s24-10.7 24-24V216h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V104c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H104c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faMapMarkerPlus = faLocationPlus;
var faLightbulbExclamationOn = {
  prefix: 'fad',
  iconName: 'lightbulb-exclamation-on',
  icon: [640, 512, [], "e1ca", ["M449.2 297.8c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4zM320 64c-13.3 0-24 10.7-24 24V200c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80V384H400v48z"]]
};
var faPeopleLine = {
  prefix: 'fad',
  iconName: 'people-line',
  icon: [640, 512, [], "e534", ["M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 168a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V217.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5z", "M0 448c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
};
var faBeerMugEmpty = {
  prefix: 'fad',
  iconName: 'beer-mug-empty',
  icon: [512, 512, ["beer"], "f0fc", ["M32 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h51.2c42.4 0 76.8 34.4 76.8 76.8V274.9c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V172.8c0-7.1-5.7-12.8-12.8-12.8H384V311.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z", "M144 128c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z"]]
};
var faBeer = faBeerMugEmpty;
var faCrateEmpty = {
  prefix: 'fad',
  iconName: 'crate-empty',
  icon: [512, 512, [], "e151", ["M48 224c-26.5 0-48 21.5-48 48v80H512V272c0-26.5-21.5-48-48-48H48zM512 384H0v80c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V384zM64 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM48 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z", "M64 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM464 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faDiagramPredecessor = {
  prefix: 'fad',
  iconName: 'diagram-predecessor',
  icon: [512, 512, [], "e477", ["M448 480c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0z", "M224 224c35.3 0 64-28.7 64-64V96l80 0c8.8 0 16 7.2 16 16v16H345.9c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41H448V112c0-44.2-35.8-80-80-80H224 208 64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64l160 0z"]]
};
var faTransporter = {
  prefix: 'fad',
  iconName: 'transporter',
  icon: [512, 512, [], "e042", ["M472.7 6.6L480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4C456.4 2.7 459.9 0 464 0s7.6 2.7 8.7 6.6zm-416 64L64 96l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 128l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 128 6.6 120.7C2.7 119.6 0 116.1 0 112s2.7-7.6 6.6-8.7L32 96l7.3-25.4C40.4 66.7 43.9 64 48 64s7.6 2.7 8.7 6.6z", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 272v96H184V237.3L153 276c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36L409 236c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-31-38.7V416H264V320H248zM216 512H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H296 216z"]]
};
var faCalendarCircleUser = {
  prefix: 'fad',
  iconName: 'calendar-circle-user',
  icon: [576, 512, [], "e471", ["M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32zM416 192.7c-89.7 8.1-160 83.5-160 175.3c0 59.5 29.6 112.1 74.8 144H48c-26.5 0-48-21.5-48-48V192H416v.7z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-30.2 0-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7C489.5 468.1 462.2 480 432 480zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faArrowUpLong = {
  prefix: 'fad',
  iconName: 'arrow-up-long',
  icon: [384, 512, ["long-arrow-up"], "f176", ["M160 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l-32-32-32 32z", "M169.4 9.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 77.3 86.6 182.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z"]]
};
var faLongArrowUp = faArrowUpLong;
var faPersonCarryBox = {
  prefix: 'fad',
  iconName: 'person-carry-box',
  icon: [384, 512, ["person-carry"], "f4cf", ["M224 96c-17.7 0-32 14.3-32 32v96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H224z", "M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM96 241.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3L98.1 399.4 18.7 320C6.7 308 0 291.7 0 274.7V186.6C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64H224c17.7 0 32 14.3 32 32s-14.3 32-32 32H152.6c-16 0-31-8-39.9-21.4L96 241.7zM0 480L0 346.5l64 64V480v0c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]]
};
var faPersonCarry = faPersonCarryBox;
var faFireFlameSimple = {
  prefix: 'fad',
  iconName: 'fire-flame-simple',
  icon: [384, 512, ["burn"], "f46a", ["M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z", "M279.8 301.6l1.9 4.3c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1z"]]
};
var faBurn = faFireFlameSimple;
var faPerson = {
  prefix: 'fad',
  iconName: 'person',
  icon: [320, 512, [129485, "male"], "f183", ["M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z", "M88 256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9z"]]
};
var faMale = faPerson;
var faLaptop = {
  prefix: 'fad',
  iconName: 'laptop',
  icon: [640, 512, [128187], "f109", ["M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z", "M128 96H512V352H128V96z"]]
};
var faFileCsv = {
  prefix: 'fad',
  iconName: 'file-csv',
  icon: [512, 512, [], "f6dd", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM200 352c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-22.1-17.9-40-40-40H200zm133.1 0c-24.9 0-45.1 20.2-45.1 45.1c0 17.8 10.5 34 26.8 41.2l37.4 16.6c4.7 2.1 7.8 6.8 7.8 12c0 7.2-5.9 13.1-13.1 13.1H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h42.9c24.9 0 45.1-20.2 45.1-45.1c0-17.8-10.5-34-26.8-41.2l-37.4-16.6c-4.7-2.1-7.8-6.8-7.8-12c0-7.2 5.9-13.1 13.1-13.1H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H333.1zm98.9 0c-8.8 0-16 7.2-16 16v31.6c0 34.7 10.3 68.7 29.6 97.6l5.1 7.7c3 4.5 8 7.1 13.3 7.1s10.3-2.7 13.3-7.1l5.1-7.7c19.3-28.9 29.6-62.9 29.6-97.6V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v31.6c0 23-5.5 45.6-16 66c-10.5-20.3-16-42.9-16-66V368c0-8.8-7.2-16-16-16z"]]
};
var faMenorah = {
  prefix: 'fad',
  iconName: 'menorah',
  icon: [640, 512, [], "f676", ["M2.7 49.7L20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1zm96 0L116.8 7.4C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L212.8 7.4zm77.8 42.4L308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L404.8 7.4zm77.8 42.4L500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L596.8 7.4z", "M64 160c0-17.7-14.3-32-32-32s-32 14.3-32 32V288c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V288c0 17.7-14.3 32-32 32H352V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V160zm96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v96 32h64V256 160zm96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v96 32h64V256 160zm192 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v96 32h64V256 160zm96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v96 32h64V256 160z"]]
};
var faUnion = {
  prefix: 'fad',
  iconName: 'union',
  icon: [384, 512, [8899], "f6a2", ["M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z", ""]]
};
var faChevronsLeft = {
  prefix: 'fad',
  iconName: 'chevrons-left',
  icon: [512, 512, ["chevron-double-left"], "f323", ["M233.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l192-192c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L301.3 256 470.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-192-192z", "M41.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l192-192c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 278.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-192-192z"]]
};
var faChevronDoubleLeft = faChevronsLeft;
var faCircleHeart = {
  prefix: 'fad',
  iconName: 'circle-heart',
  icon: [512, 512, ["heart-circle"], "f4c7", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM131.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L278.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L131.9 280.9z", "M131.9 172.9c-29.4 29.8-29.4 78.2 0 108L233.5 384.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L380.1 280.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0l-17.7 18-17.7-18c-29.4-29.8-77-29.8-106.4 0z"]]
};
var faHeartCircle = faCircleHeart;
var faTruckPlane = {
  prefix: 'fad',
  iconName: 'truck-plane',
  icon: [640, 512, [], "e58f", ["M144 86.1C144 54.7 169.4 0 200 0c31.5 0 56 54.7 56 86.1v96.9l0 0c0 .4 0 .7 0 1.1V325.5 408v3.5l.1 .1c1.2 22.2 13.7 41.3 31.9 51.8V496c0 5.2 .8 10.3 2.4 15L200 480.9l-90.9 30.3c-4.9 1.6-10.2 .8-14.4-2.2s-6.6-7.8-6.6-13V464c0-4.9 2.2-9.5 6-12.5l50-40V330.3l-123.4 37c-4.8 1.5-10.1 .5-14.1-2.5S0 357.1 0 352V288c0-5.6 2.9-10.8 7.8-13.7L144 192.5V86.1z", "M336 128c-26.5 0-48 21.5-48 48V400c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V448H544v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V445.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336zm16 176l15.8-49.3c3.3-8.7 11.2-14.7 20.5-14.7H539.7c9.2 0 17.2 6 20.5 14.7L576 304H352zm192 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM360 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faRecordVinyl = {
  prefix: 'fad',
  iconName: 'record-vinyl',
  icon: [512, 512, [], "f8d9", ["M256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]]
};
var faBringForward = {
  prefix: 'fad',
  iconName: 'bring-forward',
  icon: [512, 512, [], "f856", ["M448 448H224V352H160v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H352v64h96V448z", "M0 288c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288z"]]
};
var faSquareP = {
  prefix: 'fad',
  iconName: 'square-p',
  icon: [448, 512, [], "e279", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h92c50.8 0 92 41.2 92 92s-41.2 92-92 92H176v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V288 152c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44H176v88h68z", "M128 152c0-13.3 10.7-24 24-24h92c50.8 0 92 41.2 92 92s-41.2 92-92 92H176v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V288 152zm48 112h68c24.3 0 44-19.7 44-44s-19.7-44-44-44H176v88z"]]
};
var faFaceGrinStars = {
  prefix: 'fad',
  iconName: 'face-grin-stars',
  icon: [512, 512, [129321, "grin-stars"], "f587", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm407.4 75.5c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z", "M167.2 124.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm192 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7z"]]
};
var faGrinStars = faFaceGrinStars;
var faSigma = {
  prefix: 'fad',
  iconName: 'sigma',
  icon: [384, 512, [8721], "f68b", ["M2.4 51.8C7.4 39.8 19.1 32 32 32H320c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H109.3L246.6 233.4c12.5 12.5 12.5 32.8 0 45.3L109.3 416H320V384c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 35.3-28.7 64-64 64H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L178.7 256 9.4 86.6C.2 77.5-2.5 63.7 2.4 51.8z", ""]]
};
var faCameraMovie = {
  prefix: 'fad',
  iconName: 'camera-movie',
  icon: [576, 512, [127909, 127910], "f8a9", ["M32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H128 64 32z", "M128 64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM352 256H128C57.3 256 0 198.7 0 128S57.3 0 128 0c48.2 0 90.2 26.6 112 66C261.8 26.6 303.8 0 352 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zm0-192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM558.3 259.4c10.8 5.4 17.7 16.5 17.7 28.6V480c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48L448 448V432 336 320l12.8-9.6 64-48c9.7-7.3 22.7-8.4 33.5-3z"]]
};
var faBong = {
  prefix: 'fad',
  iconName: 'bong',
  icon: [448, 512, [], "f55c", ["M160 208.5c0 29.1-15.6 53.9-37.2 67.8C87.3 299.2 64 338.9 64 384c0 23.4 6.2 45.2 17.1 64H302.9c10.9-18.8 17.1-40.6 17.1-64c0-45.1-23.3-84.8-58.8-107.7c-21.6-13.9-37.2-38.7-37.2-67.8V64H160V208.5zM288 64V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V64C78.3 64 64 49.7 64 32S78.3 0 96 0h16H272h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z", "M302.9 320H81.1C70.2 338.8 64 360.7 64 384c0 23.4 6.2 45.2 17.1 64H302.9c10.9-18.8 17.1-40.6 17.1-64c0-23.3-6.2-45.2-17.1-64z"]]
};
var faClarinet = {
  prefix: 'fad',
  iconName: 'clarinet',
  icon: [640, 512, [], "f8ad", ["M631.5 161.9c5.2 2.8 8.5 8.2 8.5 14.1V368c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8l-31.9-21.3c-7.9-5.3-17.1-8.1-26.6-8.1H108.3c-10.2 0-20.3-1.9-29.7-5.7L10.1 318.9C4 316.4 0 310.5 0 304V240c0-6.5 4-12.4 10.1-14.9l68.6-27.4c9.4-3.8 19.5-5.7 29.7-5.7H556.6c9.5 0 18.7-2.8 26.6-8.1l31.9-21.3c4.9-3.3 11.2-3.6 16.4-.8zM272 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M240 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32h32V160h64v32h32V160h64v32h32V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H464 368 272 240zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faTruckFlatbed = {
  prefix: 'fad',
  iconName: 'truck-flatbed',
  icon: [640, 512, [], "e2b6", ["M176 512a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm288 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M640 384c0 17.7-14.3 32-32 32H574.9c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H352 286.9c-3.6-24.9-15.3-47.2-32.5-64H352V128c0-17.7 14.3-32 32-32h16 16 50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32zM97.6 352c-17.1 16.8-28.9 39.1-32.5 64H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H97.6zM544 256V237.3L466.7 160H416v96H544z"]]
};
var faSpaghettiMonsterFlying = {
  prefix: 'fad',
  iconName: 'spaghetti-monster-flying',
  icon: [640, 512, ["pastafarianism"], "f67b", ["M197.1 127.8L212.2 158c-21.1 13.6-37.7 30.2-51.4 46.4c-7.1 8.3-13.5 16.6-19.3 24l-1.4 1.8c-6.3 8.1-11.6 14.8-16.7 20.4C112.7 262.3 107.3 264 104 264c-2.5 0-4.3-.6-7.1-3.3c-3.7-3.5-7.1-8.8-12.5-17.4l-.6-.9c-4.6-7.4-11-17.6-19.4-25.7C54.7 207.4 41.5 200 24 200c-13.3 0-24 10.7-24 24s10.7 24 24 24c2.5 0 4.3 .6 7.1 3.3c3.7 3.5 7.1 8.8 12.5 17.4l.6 .9 0 0c4.6 7.4 11 17.6 19.4 25.7C73.3 304.6 86.5 312 104 312c18.5 0 32.9-8.5 44.3-18.6c3.1 4 6.6 8.3 10.5 12.7c-1.4 4.3-2.8 8.5-4 12.5c-.9 3-1.8 5.8-2.6 8.6c-3 9.8-5.5 18.2-8.6 25.9c-3.9 9.8-7.4 15.4-10.8 18.5c-2.6 2.4-5.9 4.3-12.8 4.3c-8.7 0-16.9-4.2-33.7-13.2c-15-8-35.7-18.8-62.3-18.8c-13.3 0-24 10.7-24 24s10.7 24 24 24c13.4 0 24.7 5.2 39.7 13.2c1 .6 2.1 1.1 3.2 1.7l0 0C80.1 414 98.6 424 120 424c18.4 0 33.6-6.1 45.5-17.2c11.1-10.3 17.9-23.7 22.7-36c3.6-9 6.7-19.1 9.5-28.5c16.4 12.3 36.1 23.6 58.9 31.3c-3.6 10.8-8.4 23.5-14.4 36.2c-7.5 15.9-16.2 30.4-25.8 40.5C207 460.5 198.8 464 192 464c-13.3 0-24 10.7-24 24s10.7 24 24 24c25.2 0 45-13.5 59.5-28.8c14.5-15.4 25.7-34.9 34.2-53c8-17 14.1-33.8 18.3-46.9c5.2 .4 10.6 .6 16 .6s10.8-.2 16-.6c4.2 13 10.3 29.9 18.3 46.9c8.5 18.1 19.8 37.6 34.2 53C403 498.5 422.8 512 448 512c13.3 0 24-10.7 24-24s-10.7-24-24-24c-6.8 0-15-3.5-24.5-13.7c-9.5-10.1-18.3-24.6-25.8-40.5c-5.9-12.6-10.7-25.4-14.4-36.2c22.8-7.7 42.5-19 58.9-31.3c2.9 9.4 6 19.5 9.5 28.5c4.8 12.2 11.6 25.6 22.7 36C486.4 417.9 501.6 424 520 424c21.4 0 39.9-10 53.1-17.1c1.1-.6 2.2-1.2 3.2-1.7c15-8 26.3-13.2 39.7-13.2c13.3 0 24-10.7 24-24s-10.7-24-24-24c-26.6 0-47.3 10.8-62.3 18.8c-16.8 9-25 13.2-33.7 13.2c-6.8 0-10.2-1.9-12.8-4.3c-3.4-3.2-7-8.8-10.8-18.5c-3-7.7-5.6-16.1-8.6-25.9c-.8-2.7-1.7-5.6-2.6-8.6c-1.2-4-2.6-8.2-4-12.5c3.9-4.5 7.4-8.8 10.5-12.7C503.1 303.5 517.5 312 536 312c17.5 0 30.7-7.4 40.4-16.7c8.4-8.1 14.8-18.3 19.4-25.7l.6-.9c5.4-8.6 8.8-13.9 12.5-17.4c2.8-2.7 4.6-3.3 7.1-3.3c13.3 0 24-10.7 24-24s-10.7-24-24-24c-17.5 0-30.7 7.4-40.4 16.7c-8.4 8.1-14.8 18.3-19.4 25.7l-.6 .9c-5.4 8.6-8.8 13.9-12.5 17.4c-2.8 2.7-4.6 3.3-7.1 3.3c-3.3 0-8.7-1.7-19.4-13.4c-5.1-5.6-10.4-12.3-16.7-20.4l-1.4-1.8c-5.8-7.4-12.2-15.7-19.3-24c-13.8-16.2-30.4-32.8-51.4-46.4l15.1-30.2c-17.1-1.3-32.2-9.4-42.9-21.5l-15.6 31.2c-18.7-6-39.9-9.5-64.4-9.5s-45.8 3.5-64.4 9.5L240 106.3c-10.7 12.1-25.9 20.1-42.9 21.5z", "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 128 64zm336 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 384 64z"]]
};
var faPastafarianism = faSpaghettiMonsterFlying;
var faArrowDownUpAcrossLine = {
  prefix: 'fad',
  iconName: 'arrow-down-up-across-line',
  icon: [576, 512, [], "e4af", ["M0 256c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288H128V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 224h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V224zM393.4 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3V224h64V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0zM448 448V288H384V448c0 17.7 14.3 32 32 32s32-14.3 32-32z"]]
};
var faLeafHeart = {
  prefix: 'fad',
  iconName: 'leaf-heart',
  icon: [512, 512, [], "f4cb", ["M272 96l0 0H376c42.7 0 79.9-23.9 98.8-59.1c3.5-6.5 13.6-6.8 16.2 .1c13.5 36.5 21.1 77 21.1 119.6C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.4 48 440v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440c0-75.1 38.3-141.2 96.4-179.9C102.5 168.5 178.8 96 272 96l0 0zM189.7 242.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5c-29.5 0-53.5 23.9-53.5 53.5z", "M243.2 189.3c-29.5 0-53.5 23.9-53.5 53.5c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.3 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5z"]]
};
var faHouseBuilding = {
  prefix: 'fad',
  iconName: 'house-building',
  icon: [640, 512, [], "e1b1", ["M320 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H400c10-13.4 16-30 16-48V352h16c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H416V277.1c0-7.2-1-14.3-2.8-21.1H432c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16v4.6l-64-58.7V48zM528 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H528zM512 304v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM384 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16zM528 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H528z", "M0 464V277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zM168 272c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V296c0-13.3-10.7-24-24-24H168z"]]
};
var faCheeseSwiss = {
  prefix: 'fad',
  iconName: 'cheese-swiss',
  icon: [512, 512, [129472], "f7f0", ["M512 256V240.2C512 125.2 418.8 32 303.8 32c-10.3 0-20.3 3-28.9 8.7l-47 31.3c-7.8 5.2-9.2 16.1-6.3 25.1c1.5 4.7 2.3 9.7 2.3 14.9c0 26.5-21.5 48-48 48c-12 0-22.9-4.4-31.3-11.6c-7.1-6.1-17.7-9.1-25.5-3.8L28.5 205C11.3 216.5 .8 235.5 0 256H332.2c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48s48-21.5 48-48c0-12.3-4.6-23.5-12.2-32H512zM224 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z", "M368 336c26.5 0 48-21.5 48-48c0-12.3-4.6-23.5-12.2-32H512V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256H332.2c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48zM224 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]]
};
var faSpoon = {
  prefix: 'fad',
  iconName: 'spoon',
  icon: [512, 512, [129348, 61873, "utensil-spoon"], "f2e5", ["M224 160.2c0 24.5 9.4 49 28.1 67.7l32 32c18.7 18.7 43.2 28.1 67.7 28.1C432 288 512 192 512 96c0-53-43-96-96-96C320 0 224 80 224 160.2z", "M245.8 220.9c2 2.4 4.1 4.7 6.3 6.9l32 32c2.2 2.2 4.6 4.3 6.9 6.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"]]
};
var faUtensilSpoon = faSpoon;
var faJarWheat = {
  prefix: 'fad',
  iconName: 'jar-wheat',
  icon: [320, 512, [], "e517", ["M64 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM176 224H122.2C90 224 64 198 64 165.8c0-3.2 2.6-5.8 5.8-5.8H112c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7h42.2c3.2 0 5.8 2.6 5.8 5.8c0 32.1-26 58.2-58.2 58.2L176 224zm74.2 32c3.2 0 5.8 2.6 5.8 5.8c0 32.1-26 58.2-58.2 58.2H176 144 122.2C90 320 64 294 64 261.8c0-3.2 2.6-5.8 5.8-5.8l42.2 0c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7h42.2zm0 96c3.2 0 5.8 2.6 5.8 5.8c0 32.1-26 58.2-58.2 58.2L176 416v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V416l-21.8 0C90 416 64 390 64 357.8c0-3.2 2.6-5.8 5.8-5.8H112c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7h42.2z", "M64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32S46.3 0 64 0zM256 165.8c0 32.1-26 58.2-58.2 58.2L176 224l-32 0-21.8 0C90 224 64 198 64 165.8c0-3.2 2.6-5.8 5.8-5.8H112c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7h42.2c3.2 0 5.8 2.6 5.8 5.8zM250.2 256c3.2 0 5.8 2.6 5.8 5.8c0 32.1-26 58.2-58.2 58.2L176 320l-32 0-21.8 0C90 320 64 294 64 261.8c0-3.2 2.6-5.8 5.8-5.8H112c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7h42.2zm0 96c3.2 0 5.8 2.6 5.8 5.8c0 32.1-26 58.2-58.2 58.2L176 416v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V416l-21.8 0C90 416 64 390 64 357.8c0-3.2 2.6-5.8 5.8-5.8H112c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7h42.2z"]]
};
var faEnvelopesBulk = {
  prefix: 'fad',
  iconName: 'envelopes-bulk',
  icon: [640, 512, ["mail-bulk"], "f674", ["M96 32V224h96V192c0-35.3 28.7-64 64-64H480V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32zM256 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64V416H576c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM32 301v39.8L168 441.6c6.9 5.1 15.3 7.9 24 7.9s17-2.8 24-7.9L352 340.8V301L196.9 415.9c-1.4 1-3.1 1.6-4.9 1.6s-3.5-.6-4.9-1.6L32 301z", "M496 224h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM32 288c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v13L196.9 415.9c-1.4 1-3.1 1.6-4.9 1.6s-3.5-.6-4.9-1.6L32 301V288zM216 441.6L352 340.8V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V340.8L168 441.6c6.9 5.1 15.3 7.9 24 7.9s17-2.8 24-7.9z"]]
};
var faMailBulk = faEnvelopesBulk;
var faFileCircleExclamation = {
  prefix: 'fad',
  iconName: 'file-circle-exclamation',
  icon: [576, 512, [], "e4eb", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]]
};
var faBowArrow = {
  prefix: 'fad',
  iconName: 'bow-arrow',
  icon: [512, 512, [127993], "f6b9", ["M309.7 168.3c-60.7-47.3-143.3-53-209.3-17.1L360.8 411.6c35.8-66 30.1-148.6-17.1-209.3l45.5-45.5c71.7 86.4 77.8 209 18.3 301.5c11.6 12.6 11.3 32.1-.9 44.3c-12.5 12.5-32.8 12.5-45.3 0l-352-352c-12.5-12.5-12.5-32.8 0-45.3c12.2-12.2 31.8-12.5 44.3-.9C146.3 45 268.8 51.1 355.3 122.8l-45.5 45.5z", "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1 .3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16l35 35L213.7 264.4l33.9 33.9L425.7 120.3l35 35c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zM202.3 343.6l-33.9-33.9-23.8 23.8L93.8 320.7c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-12.7-50.8 23.8-23.8z"]]
};
var faCartXmark = {
  prefix: 'fad',
  iconName: 'cart-xmark',
  icon: [576, 512, [], "e0dd", ["M459.2 288H170.7L124.5 45.5c-.9-4.8-2.4-9.3-4.4-13.5h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3zM395.4 128.9c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L336 131.7l-31.1-31.1c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3L307.7 160l-31.1 31.1c-7.8 7.8-7.8 20.5 0 28.3s20.5 7.8 28.3 0L336 188.3l31.1 31.1c7.8 7.8 20.5 7.8 28.3 0s7.8-20.5 0-28.3L364.3 160l31.1-31.1z", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-51.6-271C119.5 19.1 96.4 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM395.4 128.9c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L336 131.7l-31.1-31.1c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3L307.7 160l-31.1 31.1c-7.8 7.8-7.8 20.5 0 28.3s20.5 7.8 28.3 0L336 188.3l31.1 31.1c7.8 7.8 20.5 7.8 28.3 0s7.8-20.5 0-28.3L364.3 160l31.1-31.1z"]]
};
var faHexagonXmark = {
  prefix: 'fad',
  iconName: 'hexagon-xmark',
  icon: [512, 512, ["times-hexagon", "xmark-hexagon"], "f2ee", ["M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z", "M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faTimesHexagon = faHexagonXmark;
var faXmarkHexagon = faHexagonXmark;
var faCircleH = {
  prefix: 'fad',
  iconName: 'circle-h',
  icon: [512, 512, [9405, "hospital-symbol"], "f47e", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H320V152c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M344 128c13.3 0 24 10.7 24 24l0 104V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24z"]]
};
var faHospitalSymbol = faCircleH;
var faMerge = {
  prefix: 'fad',
  iconName: 'merge',
  icon: [512, 512, [], "e526", ["M243.8 252l3.2 4L154.2 372c-6.1 7.6-15.3 12-25 12H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h97.2c29.2 0 56.7-13.3 75-36l99.2-124h15.4c-29.2 0-56.7-13.3-75-36z", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h97.2c9.7 0 18.9 4.4 25 12l89.6 112c18.2 22.8 45.8 36 75 36H384v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H318.8c-9.7 0-18.9-4.4-25-12L204.2 100c-18.2-22.8-45.8-36-75-36H32z"]]
};
var faPager = {
  prefix: 'fad',
  iconName: 'pager',
  icon: [512, 512, [128223], "f815", ["M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z", "M64 160c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"]]
};
var faCartMinus = {
  prefix: 'fad',
  iconName: 'cart-minus',
  icon: [576, 512, [], "e0db", ["M459.2 288H170.7L124.5 45.5c-.9-4.8-2.4-9.3-4.4-13.5h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3zM272 140c-11 0-20 9-20 20s9 20 20 20H400c11 0 20-9 20-20s-9-20-20-20H272z", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-51.6-271C119.5 19.1 96.4 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 140c-11 0-20 9-20 20s9 20 20 20H400c11 0 20-9 20-20s-9-20-20-20H272z"]]
};
var faAddressBook = {
  prefix: 'fad',
  iconName: 'address-book',
  icon: [512, 512, [62138, "contact-book"], "f2b9", ["M32 64C32 28.7 60.7 0 96 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zm96 304c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H208c-44.2 0-80 35.8-80 80zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z", "M496 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm0 128c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm16 144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zM128 368c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zM240 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]]
};
var faContactBook = faAddressBook;
var faPanFrying = {
  prefix: 'fad',
  iconName: 'pan-frying',
  icon: [576, 512, [127859], "e42c", ["M176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z", "M427.6 317.6C440.7 289.1 448 257.4 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224S100.3 448 224 448c53.3 0 102.3-18.6 140.8-49.7L472.7 498.5c11 8.8 24.1 13.5 39.3 13.5c35.3 0 64-28.7 64-64c0-20.9-9.3-38.8-24.7-50.5L427.6 317.6zM254.1 115.6c15.2 15.8 44.5 32.9 65.8 38.4c13.7 3.5 26.4 11.6 35.5 23.9c21 28.4 15.1 68.5-13.3 89.5c-8.9 6.6-18.9 10.5-29.2 12c-18.6 2.6-42.2 16.3-51.6 32.6c-22.1 38.3-71 51.4-109.3 29.3s-51.4-71-29.3-109.3c12.4-21.4 19.4-53 21.5-77.6c1.3-14.9 7.8-29.4 19.4-40.5c25.5-24.5 66-23.7 90.5 1.8zM512 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faGrid = {
  prefix: 'fad',
  iconName: 'grid',
  icon: [448, 512, ["grid-3"], "e195", ["M200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zM160 392v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zM360 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360z", "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z"]]
};
var faGrid3 = faGrid;
var faFootballHelmet = {
  prefix: 'fad',
  iconName: 'football-helmet',
  icon: [512, 512, [], "f44f", ["M288 352h39.7l9.6 51c10.1 54 57.2 93 112.1 93h17c25.2 0 45.6-20.4 45.6-45.6V400 368c0-26.5-21.5-48-48-48H354.3l-14-74.5-31.8 4L321.7 320H272l16 32zm78.3 32l-6-32H464c8.8 0 16 7.2 16 16v16H366.3zm8.4 32H480v34.4c0 7.5-6.1 13.6-13.6 13.6h-17c-32.7 0-61.6-19.3-74.7-48z", "M462.5 230.2c17.5-2.2 30.2-18.3 25.7-35.3C461.1 91.9 367.4 16 256 16C123.5 16 16 123.5 16 256c0 56.3 19.4 108.1 51.9 149.1c5.7 7.1 14.4 10.9 23.5 10.9h14c4.3 0 8.6 .9 12.6 2.6l93.4 40c8.3 3.5 17.2 5.4 26.1 5.4h1.7c35.7 0 64.7-29 64.7-64.7c0-10-2.3-20-6.8-28.9L259 294c-2-4-3-8.4-3-12.8c0-14.4 10.7-26.6 25.1-28.4l181.4-22.7zM176 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faHandLove = {
  prefix: 'fad',
  iconName: 'hand-love',
  icon: [512, 512, [], "e1a5", ["M160 0c17.7 0 32 14.3 32 32V191.9l0 .1v96c0 35.3 28.7 64 64 64c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7c35.3 0 64-28.7 64-64V224.1c0 0 0 0 0-.1V96c0-17.7 14.3-32 32-32s32 14.3 32 32V336c0 97.2-78.8 176-176 176H284.8c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V32c0-17.7 14.3-32 32-32z", "M256 160c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32zm96 32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32z"]]
};
var faTrees = {
  prefix: 'fad',
  iconName: 'trees',
  icon: [640, 512, [], "f724", ["M178.5 5.8L70.2 121.4c-4 4.3-6.2 9.9-6.2 15.7C64 149.7 74.3 160 86.9 160H112L37.4 249.5c-3.5 4.2-5.4 9.5-5.4 15c0 13 10.5 23.5 23.5 23.5H80L5.4 377.5C1.9 381.7 0 387 0 392.5c0 13 10.5 23.5 23.5 23.5H160V216c0-17.7 14.3-32 32-32s32 14.3 32 32V416H360.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L304 288h24.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L272 160h25.1c12.7 0 22.9-10.3 22.9-22.9c0-5.8-2.2-11.4-6.2-15.7L205.5 5.8C202 2.1 197.1 0 192 0s-10 2.1-13.5 5.8zm163.1 99.1c6.7 9.3 10.4 20.5 10.4 32.1c0 17.7-8.3 33.4-21.3 43.4L371.1 229c8.3 10 12.9 22.5 12.9 35.5c0 17.8-8.4 33.6-21.4 43.8L403.1 357c8.2 9.8 12.7 22.2 12.9 35h0V216c0-17.7 14.3-32 32-32s32 14.3 32 32V416H616.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L560 288h24.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L528 160h25.1c12.7 0 22.9-10.3 22.9-22.9c0-5.8-2.2-11.4-6.2-15.7L461.5 5.8C458 2.1 453.1 0 448 0s-10 2.1-13.5 5.8l-92.9 99.1z", "M224 216c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V216zm256 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V216z"]]
};
var faStrikethrough = {
  prefix: 'fad',
  iconName: 'strikethrough',
  icon: [512, 512, [], "f0cc", ["M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z", "M0 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
};
var faPage = {
  prefix: 'fad',
  iconName: 'page',
  icon: [384, 512, [], "e428", ["M64 512H320c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64z", ""]]
};
var faK = {
  prefix: 'fad',
  iconName: 'k',
  icon: [320, 512, [107], "4b", ["M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64V328 448c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z", ""]]
};
var faDiagramPrevious = {
  prefix: 'fad',
  iconName: 'diagram-previous',
  icon: [512, 512, [], "e478", ["M385 168.4c16 16 19.6 37.2 14.1 55.6h49c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64l49 0c-5.5-18.4-2-39.6 14.1-55.6L216.4 79c21.9-21.9 57.3-21.9 79.2 0L385 168.4z", "M448 288c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64H232V224l-46.1 0c-21.4 0-32.1-25.9-17-41L239 113c9.4-9.4 24.6-9.4 33.9 0L343 183c15.1 15.1 4.4 41-17 41L280 224v64H448z"]]
};
var faGaugeMin = {
  prefix: 'fad',
  iconName: 'gauge-min',
  icon: [512, 512, ["tachometer-alt-slowest"], "f628", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6z"]]
};
var faTachometerAltSlowest = faGaugeMin;
var faFolderGrid = {
  prefix: 'fad',
  iconName: 'folder-grid',
  icon: [512, 512, [], "e188", ["M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM104 240c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H104zm128 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H232zm104 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H360c-13.3 0-24 10.7-24 24z", "M80 264c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V264zm128 0c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H232c-13.3 0-24-10.7-24-24V264zm152-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V264c0-13.3 10.7-24 24-24z"]]
};
var faEggplant = {
  prefix: 'fad',
  iconName: 'eggplant',
  icon: [512, 512, [], "e16c", ["M307.2 49.2C314.1 67.2 331.5 80 352 80c5.8 0 10.7 4 12.6 9.4c4.8 13.3 13 25.4 22.8 35.1s21.9 18 35.1 22.8c5.4 2 9.4 6.9 9.4 12.6c0 22.3 15.1 41 35.7 46.4C426.6 337.3 322.1 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3c51.1-24.8 102.6-49.8 137.3-90.1z", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-9 9H320c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48c5.8 0 10.7 4 12.6 9.4c4.8 13.3 13 25.4 22.8 35.1s21.9 18 35.1 22.8c5.4 2 9.4 6.9 9.4 12.6c0 26.5 21.5 48 48 48c8.8 0 16-7.2 16-16V49.9l9-9z"]]
};
var faRam = {
  prefix: 'fad',
  iconName: 'ram',
  icon: [640, 512, [128015], "f70a", ["M475.3 352H464c-61.9 0-112-50.1-112-112V207.4c-18.7-2.7-35.5-14.8-43.5-33.4c-8.9-20.8-4.3-44 10-59.7C312.3 85.6 286.7 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c3.3 0 6.6-.3 9.8-.7c6.8 28 32.1 48.7 62.2 48.7c15 0 28.9-5.2 39.8-13.9c11.7 13.4 29 21.9 48.2 21.9s36.5-8.5 48.2-21.9C315.1 434.8 329 440 344 440c30.1 0 55.3-20.8 62.2-48.7c3.2 .5 6.5 .7 9.8 .7c26.9 0 49.9-16.5 59.3-40z", "M400 0c-35.3 0-64 28.7-64 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-8.8 7.2-16 16-16s16 7.2 16 16V88.4c-6.8 6.1-12.8 13.2-17.6 21l-47.8 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2V240c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V167.8l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5c-4.9-7.8-10.8-14.9-17.6-21V64c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-35.3-28.7-64-64-64s-64 28.7-64 64v1.3c-5.2-.9-10.5-1.3-16-1.3s-10.8 .5-16 1.3V64c0-35.3-28.7-64-64-64zm64 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM115.1 485.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32V426.3l-.2-.2C196.9 434.8 183 440 168 440c-30.1 0-55.3-20.8-62.2-48.7c-2.7 .4-5.5 .7-8.3 .7l17.6 93.9zM304 480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1L414.5 392c-2.8-.1-5.6-.3-8.3-.7c-6.8 28-32.1 48.7-62.2 48.7c-15 0-28.9-5.2-39.8-13.9l-.2 .2V480z"]]
};
var faLandmarkFlag = {
  prefix: 'fad',
  iconName: 'landmark-flag',
  icon: [512, 512, [], "e51c", ["M128 192H64V420.3c-.6 .3-1.2 .7-1.7 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V192H384V416H344V192H280V416H232V192H168V416H128V192z", "M272 0h80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H272v32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H240V16c0-8.8 7.2-16 16-16h16z"]]
};
var faLips = {
  prefix: 'fad',
  iconName: 'lips',
  icon: [576, 512, [128068, 128482], "f600", ["M0 224c0 9.2 2.6 19.1 5.3 27.5c3 9.1 7.4 19.4 12.8 30.3c10.8 21.7 26.8 46.9 47.7 71.1C107.2 400.9 171.3 448 256 448h64c84.7 0 148.8-47.1 190.2-95.1c20.9-24.2 36.8-49.4 47.7-71.1c5.4-10.8 9.7-21.1 12.8-30.3c2.8-8.4 5.3-18.3 5.3-27.5H512c0 7.9-80 96-224 96s-224-88.1-224-96H0z", "M297.7 94c-3.4 2.5-6.7 4.9-9.7 7.3c-3-2.4-6.2-4.8-9.7-7.3C260.6 81.2 231.5 64 200 64c-20.3 0-42.8 9.3-61.4 19.2c-20 10.6-41.1 24.7-60.2 39.5c-19.1 14.8-37.1 31.2-50.8 46.5c-6.8 7.6-13.1 15.7-17.9 23.7C5.5 200.2 0 211.2 0 224H64c0-7.7 46.3-31.1 138.8-32c3.4 0 6.9 .5 10.1 1.5c13.1 4 49.4 14.4 75.1 14.4s62-10.4 75.1-14.4c3.3-1 6.7-1.6 10.1-1.5c92.5 .9 138.8 24.2 138.8 32h64c0-12.8-5.5-23.8-9.7-31c-4.8-8.1-11.1-16.1-17.9-23.7c-13.6-15.3-31.7-31.7-50.8-46.5c-19.1-14.9-40.2-29-60.2-39.5C418.8 73.3 396.3 64 376 64c-31.5 0-60.6 17.2-78.3 30z"]]
};
var faPencil = {
  prefix: 'fad',
  iconName: 'pencil',
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", ["M492.7 58.2c25 25 25 65.5 0 90.5l-60 60L302.7 78.7l60-60c25-25 65.5-25 90.5 0l39.4 39.4zM315.3 186.7l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z", "M432.7 208.7L302.7 78.7 58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L432.7 208.7zM89.3 360.5l22.7-9.1v32c0 8.8 7.2 16 16 16h32l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3zm226-196.4c6.2 6.2 6.2 16.4 0 22.6l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0z"]]
};
var faPencilAlt = faPencil;
var faBackward = {
  prefix: 'fad',
  iconName: 'backward',
  icon: [512, 512, [9194], "f04a", ["M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L256 271V241L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96V416c0 12.4-7.2 23.7-18.4 29z", "M203.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160z"]]
};
var faCaretRight = {
  prefix: 'fad',
  iconName: 'caret-right',
  icon: [256, 512, [], "f0da", ["M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z", ""]]
};
var faComments = {
  prefix: 'fad',
  iconName: 'comments',
  icon: [640, 512, [128490, 61670], "f086", ["M231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129z", "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.3 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176z"]]
};
var faPaste = {
  prefix: 'fad',
  iconName: 'paste',
  icon: [512, 512, ["file-clipboard"], "f0ea", ["M224 176c0-26.5 21.5-48 48-48H396.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V176z", "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zm0 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faFileClipboard = faPaste;
var faDesktopArrowDown = {
  prefix: 'fad',
  iconName: 'desktop-arrow-down',
  icon: [576, 512, [], "e155", ["M264 0H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H312V64H512V288H64V64H264V0z", "M264 64H64V288H512V64H312V174.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V64zm82.7 384L336 416H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7z"]]
};
var faCodePullRequest = {
  prefix: 'fad',
  iconName: 'code-pull-request',
  icon: [512, 512, [], "e13c", ["M112 153.3c-9.8 4.3-20.6 6.7-32 6.7s-22.2-2.4-32-6.7V358.7c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7V153.3zM400 358.7c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7V192c0-70.7-57.3-128-128-128H320V24c0-9.5-5.6-18.1-14.2-21.9S287-.2 279.9 6.2l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c7 6.3 17.2 7.9 25.8 4.1s14.2-12.4 14.2-21.9V128h16c35.3 0 64 28.7 64 64V358.7z", "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 80 0a80 80 0 1 0 0 160zm0 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm328-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]]
};
var faPumpkin = {
  prefix: 'fad',
  iconName: 'pumpkin',
  icon: [576, 512, [], "f707", ["M157.5 171.7c-7.5 4.5-16-3.4-10.4-10.1c9.6-11.4 20.6-21.7 32.7-30.5c-.6-.1-1.2-.2-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320S68.1 512 152 512c19.3 0 37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8c83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8c-.6 .1-1.2 .2-1.8 .3c12.1 8.8 23.1 19.1 32.7 30.5c5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7z", "M234.6 103.9l40.9-93.5c2.8-6.3 9-10.4 15.8-10.4h1.2c2.3 0 4.7 .5 6.8 1.4l42.3 18.1c6.4 2.7 10.5 9 10.5 15.9v72C332.1 100 310.5 96 288 96c-18.6 0-36.5 2.8-53.5 7.9z"]]
};
var faClipboardList = {
  prefix: 'fad',
  iconName: 'clipboard-list',
  icon: [384, 512, [], "f46d", ["M113.2 66.3c.1-.8 .3-1.6 .4-2.3H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H270.4c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z", "M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm0 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
};
var faPenField = {
  prefix: 'fad',
  iconName: 'pen-field',
  icon: [640, 512, [], "e211", ["M0 208c0-44.2 35.8-80 80-80H272c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V304c0-17.7 14.3-32 32-32s32 14.3 32 32V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V208z", "M534.1 16L494.4 55.7l89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4 .4-68.2L601.9 16c-18.8-18.8-49.2-18.7-67.9 0zM471.7 78.4L328.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15L560.8 167.5 471.7 78.4zM160 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faBlueberries = {
  prefix: 'fad',
  iconName: 'blueberries',
  icon: [512, 512, [], "e2e8", ["M351.3 351.3C441.4 343.6 512 268 512 176C512 78.8 433.2 0 336 0C244 0 168.4 70.6 160.7 160.7c5.1-.4 10.2-.7 15.3-.7c97.2 0 176 78.8 176 176c0 5.2-.2 10.3-.7 15.3zM368 48c8.8 0 16 7.2 16 16V96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16zM192 224c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V288h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V224z", "M384 64V96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16s16 7.2 16 16zM0 336a176 176 0 1 1 352 0A176 176 0 1 1 0 336zM176 208c-8.8 0-16 7.2-16 16v32H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V288h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V224c0-8.8-7.2-16-16-16z"]]
};
var faTruckRampBox = {
  prefix: 'fad',
  iconName: 'truck-ramp-box',
  icon: [640, 512, ["truck-loading"], "f4de", ["M23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l154.5-41.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7zm69-51.6l20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3L92.1 156.1zM544 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M544 288c-66.1 0-120.6 50.2-127.3 114.5L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640V331.3c-23.5-26.6-57.8-43.3-96-43.3zM153.9 139.5l20.7 77.3c2.3 8.5-2.8 17.3-11.3 19.6l-30.9 8.3c-8.5 2.3-17.3-2.8-19.6-11.3L92.1 156.1l61.8-16.6z"]]
};
var faTruckLoading = faTruckRampBox;
var faNote = {
  prefix: 'fad',
  iconName: 'note',
  icon: [448, 512, [], "e1ff", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320H320c-17.7 0-32 14.3-32 32V480H64c-35.3 0-64-28.7-64-64V96zM112 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM88 104a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z", "M288 352V480h5.5c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3V320H320c-17.7 0-32 14.3-32 32z"]]
};
var faArrowDownToSquare = {
  prefix: 'fad',
  iconName: 'arrow-down-to-square',
  icon: [512, 512, [], "e096", ["M0 112C0 67.8 35.8 32 80 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H400c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112z", "M233.4 342.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 242.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V242.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96z"]]
};
var faUserCheck = {
  prefix: 'fad',
  iconName: 'user-check',
  icon: [640, 512, [], "f4fc", ["M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z", "M625 143c9.4 9.4 9.4 24.6 0 33.9L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faCloudXmark = {
  prefix: 'fad',
  iconName: 'cloud-xmark',
  icon: [640, 512, [], "e35f", ["M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm95-273c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z", "M273 207c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faVialVirus = {
  prefix: 'fad',
  iconName: 'vial-virus',
  icon: [512, 512, [], "e597", ["M0 64C0 46.3 14.3 32 32 32H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V207.1c-3.1 2.1-6.1 4.4-8.8 7.2c-21.9 21.9-21.9 57.3 0 79.2c.2 .2 .2 .3 .3 .3l0 0c0 .1 0 .3-.1 .6s-.2 .4-.3 .5l-.1 0c-.1 0-.2 0-.4 0c-30.9 0-56 25.1-56 56s25.1 56 56 56c.2 0 .4 0 .4 0l.1 0c.1 .1 .2 .2 .3 .5s.1 .5 .1 .6l0 0c0 .1-.1 .2-.3 .3c-11.2 11.2-16.6 25.9-16.4 40.5C181.3 468 156 480 128 480c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zM96 96v96h64V96H96z", "M376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.9 43.3-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24c28.8 0 43.3 34.9 22.9 55.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-6 55.2 22.8c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.4-20.4-5.9-55.3 22.9-55.3c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.9 259.3 376 244.8 376 216zM288.8 321.4a31.7 31.7 0 1 1 63.5 0 31.7 31.7 0 1 1 -63.5 0zm95.2 39.6a23.8 23.8 0 1 1 0 47.6 23.8 23.8 0 1 1 0-47.6z"]]
};
var faBookBlank = {
  prefix: 'fad',
  iconName: 'book-blank',
  icon: [448, 512, [128213, 128215, 128216, 128217, "book-alt"], "f5d9", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H352 256 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H256h96 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96z"]]
};
var faBookAlt = faBookBlank;
var faGolfFlagHole = {
  prefix: 'fad',
  iconName: 'golf-flag-hole',
  icon: [512, 512, [], "e3ac", ["M128 332.8C51.5 349.4 0 380.5 0 416c0 53 114.6 96 256 96s256-43 256-96s-114.6-96-256-96c-27.9 0-54.8 1.7-80 4.8v70.1c11.7-6.6 28.9-10.8 48-10.8c35.3 0 64 14.3 64 32s-28.7 32-64 32c-23.2 0-43.5-6.2-54.7-15.4c-4.4 4.5-10.5 7.4-17.3 7.4c-13.3 0-24-10.7-24-24V332.8z", "M139.4 3.6c7.1-4.4 15.9-4.8 23.4-1.1l208 104c8.1 4.1 13.3 12.4 13.3 21.5s-5.1 17.4-13.3 21.5L176 246.8V416c0 13.3-10.7 24-24 24s-24-10.7-24-24V240c0-1.4 .1-2.7 .3-4c-.2-1.3-.3-2.6-.3-4V24c0-8.3 4.3-16 11.4-20.4z"]]
};
var faMessageArrowDown = {
  prefix: 'fad',
  iconName: 'message-arrow-down',
  icon: [512, 512, ["comment-alt-arrow-down"], "e1db", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V238.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V120z", "M256 96c13.3 0 24 10.7 24 24V238.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V120c0-13.3 10.7-24 24-24z"]]
};
var faCommentAltArrowDown = faMessageArrowDown;
var faFaceUnamused = {
  prefix: 'fad',
  iconName: 'face-unamused',
  icon: [512, 512, [], "e39f", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-117.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z", "M96 208c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16zm192 0c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z"]]
};
var faSheetPlastic = {
  prefix: 'fad',
  iconName: 'sheet-plastic',
  icon: [384, 512, [], "e571", ["M64 512c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V352H256c-17.7 0-32 14.3-32 32V512H64zM171.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96zm96 32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160z", "M224 512L384 352H256c-17.7 0-32 14.3-32 32V512z"]]
};
var faCircle9 = {
  prefix: 'fad',
  iconName: 'circle-9',
  icon: [512, 512, [], "e0f6", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C337.8 287.2 352 256.4 352 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z", "M304 224a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-74 92.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C337.8 287.2 352 256.4 352 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z"]]
};
var faBlog = {
  prefix: 'fad',
  iconName: 'blog',
  icon: [512, 512, [], "f781", ["M224 0c-17.7 0-32 14.3-32 32s14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192z", "M48 96c26.5 0 48 21.5 48 48V368c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48H128V224h16c79.5 0 144 64.5 144 144s-64.5 144-144 144S0 447.5 0 368V144c0-26.5 21.5-48 48-48z"]]
};
var faUserNinja = {
  prefix: 'fad',
  iconName: 'user-ninja',
  icon: [448, 512, [129399], "f504", ["M144 112c0-8.8 7.2-16 16-16H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16z", "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]]
};
var faPencilSlash = {
  prefix: 'fad',
  iconName: 'pencil-slash',
  icon: [640, 512, [], "e215", ["M237.6 283.2L195.5 250l-72.9 72.9c-10.4 10.4-18 23.3-22.2 37.4L65 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2l88.3-88.3-77.9-61.4-27.6 27.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.9-24.9zm141.7-96.5l-47.8 47.8 78.1 61.2 42.1-42.1L474.3 231l11.3-11.3-33.9-33.9-62.1-62.1L355.7 89.8l-11.3 11.3-22.6 22.6-57.8 57.8 42.2 33.1 50.5-50.5c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM224 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9l-78.1 23 23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM426.7 18.7L412.3 33.2 389.7 55.8 378.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L517.3 18.7c-25-25-65.5-25-90.5 0z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faBowlingPins = {
  prefix: 'fad',
  iconName: 'bowling-pins',
  icon: [512, 512, [], "f437", ["M128 0c35.3 0 64 28.7 64 64v1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1H86.5c-.5-2.7-1.1-5.4-1.8-8.1L66.9 87.1c-2-7.2-2.9-14.6-2.9-22V64C64 28.7 92.7 0 128 0zM82.1 210.4c2.2-6 3.8-12.1 4.8-18.4h82.3c1 6.3 2.6 12.4 4.8 18.4l38.6 104.7c7.6 20.6 11.5 42.5 11.5 64.4c0 28.9-6.7 57.5-19.7 83.4l-15.7 31.4C183.2 505.2 172.1 512 160 512H96c-12.1 0-23.2-6.8-28.6-17.7L51.7 462.9C38.7 437 32 408.5 32 379.5c0-22 3.9-43.8 11.5-64.4L82.1 210.4zM384 0c35.3 0 64 28.7 64 64v1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1H342.5c-.5-2.7-1.1-5.4-1.8-8.1L322.9 87.1c-2-7.2-2.9-14.6-2.9-22V64c0-35.3 28.7-64 64-64zM338.1 210.4c2.2-6 3.8-12.1 4.8-18.4h82.3c1 6.3 2.6 12.4 4.8 18.4L470 319.3c6.6 17.9 10 36.8 10 55.8c0 20.5-3.9 40.9-11.5 59.9l-22.7 56.9C440.9 504 429.1 512 416 512H352c-13.1 0-24.9-8-29.7-20.1L299.5 435C291.9 416 288 395.6 288 375.1c0-19 3.4-37.9 10-55.8l40.1-108.9z", "M86.8 192c.8-4.9 1.2-9.9 1.2-14.8c0-5.8-.5-11.5-1.5-17.2h83.1c-1 5.7-1.5 11.4-1.5 17.2c0 5 .4 9.9 1.2 14.8H86.8zm256 0c.8-4.9 1.2-9.9 1.2-14.8c0-5.8-.5-11.5-1.5-17.2h83.1c-1 5.7-1.5 11.4-1.5 17.2c0 5 .4 9.9 1.2 14.8H342.8z"]]
};
var faPersonArrowUpFromLine = {
  prefix: 'fad',
  iconName: 'person-arrow-up-from-line',
  icon: [640, 512, [], "e539", ["M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96h64V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448h64z", "M598.6 166.6c12.5-12.5 12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faDownRight = {
  prefix: 'fad',
  iconName: 'down-right',
  icon: [384, 512, [], "e16b", ["M145.4 305.4L11.3 171.3C4.1 164.1 0 154.2 0 144s4.1-20.1 11.3-27.3L52.7 75.3C59.9 68.1 69.8 64 80 64s20.1 4.1 27.3 11.3L241.4 209.4l-96 96z", "M336 432H96c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l240-240c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6V400c0 17.7-14.3 32-32 32z"]]
};
var faScrollTorah = {
  prefix: 'fad',
  iconName: 'scroll-torah',
  icon: [640, 512, ["torah"], "f6a0", ["M544 32H96V480H544V32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z", "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32zm544 0V32c0-17.7-21.5-32-48-32s-48 14.3-48 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32z"]]
};
var faTorah = faScrollTorah;
var faWebhook = {
  prefix: 'fad',
  iconName: 'webhook',
  icon: [576, 512, [], "e5d5", ["M210.1 110C220 67 262.9 40.1 306 50.1c41.1 9.5 67.5 49.2 61.1 90.2c-2.1 13.1 6.9 25.4 20 27.4s25.4-6.9 27.4-20C424.8 82 382.6 18.5 316.8 3.3c-68.9-15.9-137.6 27-153.5 95.9c-10.7 46.3 5.2 92.6 37.7 122.7L129.7 336c17.7 .6 32.9 10.7 40.7 25.4l82.8-132.5c3.4-5.4 4.5-11.9 3-18.1s-5.3-11.6-10.7-15c-28.2-17.6-43.4-51.7-35.5-85.9zm120.3 40.5c-7.8 14.7-23.1 24.8-40.7 25.4l82.8 132.5c3.4 5.4 8.8 9.2 15 10.7s12.7 .3 18.1-3c30.9-19.3 72.1-15.5 99 11.3c31.2 31.2 31.2 81.9 0 113.1c-26.8 26.8-68.1 30.6-99 11.3c-11.2-7-26-3.6-33.1 7.6s-3.6 26 7.6 33.1c49.4 31 115.4 25 158.4-18c50-50 50-131 0-181c-37-37-91-46.6-136.8-28.9L330.4 150.5zM110.1 278.8c-5.1-12.2-19.1-18-31.4-12.9C22.1 289.4-11 351 3.3 412.8c15.9 68.9 84.6 111.8 153.5 95.9c51-11.8 87.7-52.5 97-100.7H406.4c-4.1-7.1-6.4-15.3-6.4-24s2.3-16.9 6.4-24H232c-6.4 0-12.5 2.5-17 7s-7 10.6-7 17c0 36.4-25 69.4-62 77.9c-43.1 9.9-86-16.9-95.9-60c-8.9-38.6 11.7-77.1 47.1-91.8c12.2-5.1 18-19.1 12.9-31.4z", "M288 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM176 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm320 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]]
};
var faBlindsOpen = {
  prefix: 'fad',
  iconName: 'blinds-open',
  icon: [512, 512, [], "f8fc", ["M160 192H494.2c9.8 0 17.8-8 17.8-17.8c0-4-1.4-7.9-3.9-11.1L489.6 140c-6.1-7.6-15.3-12-25-12H160v64zm-32-64H47.4c-9.7 0-18.9 4.4-25 12L3.9 163.1C1.4 166.3 0 170.2 0 174.2C0 184 8 192 17.8 192H128V128zM98.7 288H47.4c-9.7 0-18.9 4.4-25 12L3.9 323.1C1.4 326.3 0 330.2 0 334.2C0 344 8 352 17.8 352H144 494.2c9.8 0 17.8-8 17.8-17.8c0-4-1.4-7.9-3.9-11.1L489.6 300c-6.1-7.6-15.3-12-25-12H189.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16zM494.2 512c9.8 0 17.8-8 17.8-17.8c0-4-1.4-7.9-3.9-11.1L489.6 460c-6.1-7.6-15.3-12-25-12H47.4c-9.7 0-18.9 4.4-25 12L3.9 483.1C1.4 486.3 0 490.2 0 494.2C0 504 8 512 17.8 512H494.2z", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64h96V258.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V64H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faFence = {
  prefix: 'fad',
  iconName: 'fence',
  icon: [512, 512, [], "e303", ["M192 160H128v64h64V160zm192 0H320v64h64V160zM128 352v64h64V352H128zm256 0H320v64h64V352z", "M76.8 38.4C73.8 34.4 69 32 64 32s-9.8 2.4-12.8 6.4L6.4 98.1C2.2 103.7 0 110.4 0 117.3V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V117.3c0-6.9-2.2-13.7-6.4-19.2L76.8 38.4zm192 0c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4L198.4 98.1c-4.2 5.5-6.4 12.3-6.4 19.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V117.3c0-6.9-2.2-13.7-6.4-19.2L268.8 38.4zM448 32c-5 0-9.8 2.4-12.8 6.4L390.4 98.1c-4.2 5.5-6.4 12.3-6.4 19.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V117.3c0-6.9-2.2-13.7-6.4-19.2L460.8 38.4c-3-4-7.8-6.4-12.8-6.4z"]]
};
var faUp = {
  prefix: 'fad',
  iconName: 'up',
  icon: [384, 512, ["arrow-alt-up"], "f357", ["M128 256V440c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V256H128z", "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h96v0H256v0h96c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-160-160z"]]
};
var faArrowAltUp = faUp;
var faBroomBall = {
  prefix: 'fad',
  iconName: 'broom-ball',
  icon: [576, 512, ["quidditch", "quidditch-broom-ball"], "f458", ["M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192 45.3 45.3 192-192zM464 512a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M409.4 281.4L294.6 166.6c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16zm-68.3 72L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"]]
};
var faQuidditch = faBroomBall;
var faQuidditchBroomBall = faBroomBall;
var faDrumstick = {
  prefix: 'fad',
  iconName: 'drumstick',
  icon: [512, 512, [127831], "f6d6", ["M160.2 278.2c3 39.2 34.3 70.5 73.5 73.5l-36.4 36.4c-12.3 12.3-11.4 32.5-7.2 49.4c1.1 4.6 1.8 9.5 1.8 14.5c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c5 0 9.8 .6 14.5 1.8c16.9 4.2 37.1 5.2 49.4-7.2l36.4-36.4z", "M160 176v96c0 44.2 35.8 80 80 80h96c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176z"]]
};
var faSquareV = {
  prefix: 'fad',
  iconName: 'square-v',
  icon: [448, 512, [], "e284", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm77.5 125.3L224 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z", "M109.3 146.5c11.9-5.9 26.3-1.1 32.2 10.7L224 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2z"]]
};
var faFaceAwesome = {
  prefix: 'fad',
  iconName: 'face-awesome',
  icon: [512, 512, ["gave-dandy"], "e409", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 120c35.3 0 64 28.7 64 64v10.3c0 16.4-13.3 29.7-29.7 29.7H109.7C93.3 224 80 210.7 80 194.3V184c0-35.3 28.7-64 64-64zm128 72c0-39.8 32.2-72 72-72s72 32.2 72 72v7.5c0 13.5-11 24.5-24.5 24.5H296.5C283 224 272 213 272 199.5V192zM116.3 288H395.7c10.4 0 18.1 9.6 15.9 19.8C395.5 380.4 330.3 432 256 432s-139.5-51.6-155.6-124.2c-2.3-10.2 5.5-19.8 15.9-19.8z", "M154 120.8c22.6 3.5 41.3 18.9 49.5 39.6c-5.6 9.4-15.8 15.6-27.5 15.6c-17.7 0-32-14.3-32-32c0-9.1 3.8-17.4 10-23.2zM360.8 122c22 5.3 40.1 20.6 49.1 40.9c-5.8 8-15.2 13.1-25.9 13.1c-17.7 0-32-14.3-32-32c0-8.5 3.3-16.3 8.8-22zM100.4 307.8c-2.3-10.2 5.5-19.8 15.9-19.8H395.7c10.4 0 18.1 9.6 15.9 19.8c-5 22.3-14.6 42.7-27.7 60.2c-13.4-10-30-16-47.9-16c-44.2 0-80 35.8-80 80c-74.3 0-139.5-51.6-155.6-124.2z"]]
};
var faGaveDandy = faFaceAwesome;
var faDialOff = {
  prefix: 'fad',
  iconName: 'dial-off',
  icon: [576, 512, [], "e162", ["M256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M312 446.2c77-11.6 136-78 136-158.2c0-88.4-71.6-160-160-160s-160 71.6-160 160c0 80.2 59 146.6 136 158.2V288c0-13.3 10.7-24 24-24s24 10.7 24 24V446.2z"]]
};
var faToggleOff = {
  prefix: 'fad',
  iconName: 'toggle-off',
  icon: [576, 512, [], "f204", ["M192 128c-70.7 0-128 57.3-128 128s57.3 128 128 128H384c70.7 0 128-57.3 128-128s-57.3-128-128-128H192zM384 64c106 0 192 86 192 192s-86 192-192 192H192C86 448 0 362 0 256S86 64 192 64H384z", "M96 256a96 96 0 1 0 192 0A96 96 0 1 0 96 256z"]]
};
var faFaceSmileHorns = {
  prefix: 'fad',
  iconName: 'face-smile-horns',
  icon: [640, 512, [], "e391", ["M64 256a256 256 0 1 1 512 0A256 256 0 1 1 64 256zm141.5 91.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 370.2 363.4 392 320 392s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM240.4 304c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M566.1 185.1C550.5 131 517.6 84.3 473.8 51.3c17-3.3 39.7-8.6 63-15.5c29.8-8.9 59.1-20.2 78.4-33.1c5.4-3.6 12.4-3.6 17.8 0s8.1 10.1 6.8 16.4c-6.2 31-29.3 106.6-73.6 166zM103.3 35.8c23.3 7 46 12.2 63 15.5c-43.8 33-76.7 79.7-92.3 133.8C29.6 125.8 6.5 50.1 .3 19.1C-1 12.8 1.7 6.3 7.1 2.7s12.4-3.6 17.8 0c19.3 12.9 48.5 24.2 78.4 33.1zM240.4 304c-17.7 0-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8z"]]
};
var faBoxArchive = {
  prefix: 'fad',
  iconName: 'box-archive',
  icon: [512, 512, ["archive"], "f187", ["M480 128H32V416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V128zM192 192H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64z"]]
};
var faArchive = faBoxArchive;
var faGrapes = {
  prefix: 'fad',
  iconName: 'grapes',
  icon: [512, 512, [], "e306", ["M320 72c0-29.7 17.6-55 26.7-66c3.3-4 8.2-6 13.3-6s10 2 13.2 6C382.3 17.4 400 44.3 400 80c0 32-8 40-8 40s8-8 40-8c35.7 0 62.6 17.7 74 26.8c4 3.2 6 8.1 6 13.2s-2 10-6 13.3C495 174.4 469.7 192 440 192c-40 0-55.3-15.3-80-40s-40-40-40-80z", "M248 208a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-80-32A56 56 0 1 0 56 176a56 56 0 1 0 112 0zM88 368a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM56 512a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm144-32a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm192-80a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM224 344a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm192-80a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]]
};
var faPersonDrowning = {
  prefix: 'fad',
  iconName: 'person-drowning',
  icon: [576, 512, [], "e545", ["M269.5 389.9c11.1-7.9 25.9-7.9 37 0C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1z", "M160 32c17.7 0 32 14.3 32 32V96.2c0 52.7 34.1 99.3 84.3 115.3c40 12.7 82.7 14.5 123.7 5.2l105-23.9c17.2-3.9 34.4 6.9 38.3 24.1s-6.9 34.4-24.1 38.3l-105 23.9c-10.6 2.4-21.2 4.2-31.9 5.5l-17.7 97.6c-13.6-3.2-27.3-9.4-39.7-18c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-7.3 0-15-1.2-22.8-3.3l21-146.7C151.5 200.1 128 150.2 128 96.2V64c0-17.7 14.3-32 32-32zm96 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]]
};
var faDialMax = {
  prefix: 'fad',
  iconName: 'dial-max',
  icon: [576, 512, [], "e15e", ["M256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M417.1 382.8c46.2-62.6 41-151.3-15.7-208c-62.5-62.5-163.8-62.5-226.3 0s-62.5 163.8 0 226.3c56.7 56.7 145.4 62 208 15.7L271.3 304.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L417.1 382.8z"]]
};
var faCircleM = {
  prefix: 'fad',
  iconName: 'circle-m',
  icon: [512, 512, [], "e115", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.5 137.9L256 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2l-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L176 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7 .3 26.8 8.8z", "M144.6 129.2c9.9-3.2 20.7 .3 26.8 8.8L256 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2l-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L176 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8z"]]
};
var faCalendarImage = {
  prefix: 'fad',
  iconName: 'calendar-image',
  icon: [448, 512, [], "e0d4", ["M0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM147.2 360.7L99.8 422.2c-8.1 10.5-.6 25.8 12.7 25.8H338.9c12.6 0 20.3-13.9 13.5-24.6L268.9 292.3c-6.1-9.7-20.1-9.9-26.7-.5L184 376l-11.4-15.1c-6.4-8.5-19-8.5-25.5-.2zM128 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM99.8 422.2c-8.1 10.5-.6 25.8 12.7 25.8H338.9c12.6 0 20.3-13.9 13.5-24.6L268.9 292.3c-6.1-9.7-20.1-9.9-26.7-.5L184 376l-11.4-15.1c-6.4-8.5-19-8.5-25.5-.2L99.8 422.2z"]]
};
var faCircleCaretDown = {
  prefix: 'fad',
  iconName: 'circle-caret-down',
  icon: [512, 512, ["caret-circle-down"], "f32d", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm0-144c6.7 0 13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H152c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7z", "M273.6 360.3c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4H360c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112z"]]
};
var faCaretCircleDown = faCircleCaretDown;
var faArrowDown91 = {
  prefix: 'fad',
  iconName: 'arrow-down-9-1',
  icon: [576, 512, ["sort-numeric-desc", "sort-numeric-down-alt"], "f886", ["M445.7 148.9A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2zM464 320v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4s13.3 15.7 13.3 26z", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z"]]
};
var faSortNumericDesc = faArrowDown91;
var faSortNumericDownAlt = faArrowDown91;
var faFaceGrinTongueSquint = {
  prefix: 'fad',
  iconName: 'face-grin-tongue-squint',
  icon: [512, 512, [128541, "grin-tongue-squint"], "f58a", ["M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm-41-368.1c-7.9-4.2-17.5 1.5-17.5 10.5c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9zM396 141.1c0-9-9.6-14.7-17.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6z", "M133.5 130.7c-7.9-4.2-17.5 1.5-17.5 10.5c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9zm245 0l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6c0-9-9.6-14.7-17.5-10.5zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"]]
};
var faGrinTongueSquint = faFaceGrinTongueSquint;
var faShishKebab = {
  prefix: 'fad',
  iconName: 'shish-kebab',
  icon: [512, 512, [], "f821", ["M393.4 73.4c12.5-12.5 32.8-12.5 45.3 0c10.4 10.4 12.2 26.4 5.1 38.6c-8.8 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c21.2-36.7 16.2-84.5-15.3-115.9c-37.5-37.5-98.3-37.5-135.8 0c-25.7 25.7-33.8 62.4-24.3 94.9c1.8 6.1 2.4 11.4 2.1 15.2c-.1 2-.5 2.9-.6 3.2l-31 31 45.3 45.3 31.1-31.1c13.1-13.1 18-29.4 19.1-43.4c1.1-13.8-1.3-27.2-4.5-38c-3.2-11-.5-23.1 8.1-31.7zM241.7 315.6l-45.3-45.3-30.1 30.1 45.3 45.3 30.1-30.1zm-128 128L68.4 398.3l-59 59c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l59-59zM325.3 141.5a.1 .1 0 1 0 -.1-.2 .1 .1 0 1 0 .1 .2z", "M203.7 138.3l-41.4 41.4c-15.6 15.6-15.6 40.9 0 56.6L275.7 349.7c15.6 15.6 40.9 15.6 56.6 0l41.4-41.4c15.6-15.6 15.6-40.9 0-56.6L260.3 138.3c-15.6-15.6-40.9-15.6-56.6 0zm-71.4 128c-15.6-15.6-40.9-15.6-56.6 0L34.3 307.7c-15.6 15.6-15.6 40.9 0 56.6L147.7 477.7c15.6 15.6 40.9 15.6 56.6 0l41.4-41.4c15.6-15.6 15.6-40.9 0-56.6L132.3 266.3z"]]
};
var faSprayCan = {
  prefix: 'fad',
  iconName: 'spray-can',
  icon: [512, 512, [], "f5bd", ["M256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 336a80 80 0 1 1 160 0A80 80 0 1 1 80 336zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0z"]]
};
var faAlarmSnooze = {
  prefix: 'fad',
  iconName: 'alarm-snooze',
  icon: [512, 512, [], "f845", ["M256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zM200 192H312c9.2 0 17.5 5.2 21.6 13.5s3 18-2.6 25.3L249.1 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-9.2 0-17.5-5.2-21.6-13.5s-3-18 2.6-25.3L262.9 240H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M14.9 146.4L160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1zm482.3 0C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM200 192c-13.3 0-24 10.7-24 24s10.7 24 24 24h62.9L181.1 345.3c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5H312c13.3 0 24-10.7 24-24s-10.7-24-24-24H249.1l81.9-105.3c5.6-7.2 6.6-17 2.6-25.3s-12.4-13.5-21.6-13.5H200z"]]
};
var faScarecrow = {
  prefix: 'fad',
  iconName: 'scarecrow',
  icon: [448, 512, [], "f70d", ["M224 192A96 96 0 1 0 224 0a96 96 0 1 0 0 192zM192 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM192 400.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V400.1l-24.1 13.8c-4.9 2.8-11 2.8-15.9 0L192 400.1z", "M133.5 128H32c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l7.6 11.4L6.4 179.2C2.4 182.2 0 187 0 192s2.4 9.8 6.4 12.8l19.9 14.9-7.6 11.4c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5h73c10.1 0 17.7 9.2 15.7 19.1L96.3 396.9c-1.2 6.2 1.2 12.5 6.3 16.1s11.8 4 17.3 .9L160.1 391c4.9-2.8 11-2.8 15.9 0l40.1 22.9c4.9 2.8 11 2.8 15.9 0L272.1 391c4.9-2.8 11-2.8 15.9 0l40.1 22.9c5.4 3.1 12.2 2.8 17.3-.9s7.6-10 6.3-16.1L327.3 275.1c-2-9.9 5.6-19.1 15.7-19.1h73c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-7.6-11.4 19.9-14.9c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-19.9-14.9 7.6-11.4c3.3-4.9 3.6-11.2 .8-16.4s-8.2-8.5-14.1-8.5H314.5c-13.2 37.3-48.7 64-90.5 64s-77.4-26.7-90.5-64z"]]
};
var faTruckMonster = {
  prefix: 'fad',
  iconName: 'truck-monster',
  icon: [640, 512, [], "f63b", ["M130.3 276c4.8-11.7 16.2-20 29.7-20s24.9 8.3 29.7 20c9.1 2.5 17.7 6.1 25.7 10.7c11.6-4.9 25.6-2.6 35.1 6.8s11.8 23.5 6.8 35.1c4.6 8 8.2 16.6 10.7 25.7c11.7 4.8 20 16.2 20 29.7s-8.3 24.9-20 29.7c-2.5 9.1-6.1 17.7-10.7 25.7c4.9 11.6 2.6 25.6-6.8 35.1s-23.5 11.8-35.1 6.8c-8 4.6-16.6 8.2-25.7 10.7c-4.8 11.7-16.2 20-29.7 20s-24.9-8.3-29.7-20c-9.1-2.5-17.7-6.1-25.7-10.7C93 486.3 79 484 69.5 474.5S57.7 451 62.6 439.4c-4.6-8-8.2-16.6-10.7-25.7c-11.7-4.8-20-16.2-20-29.7s8.3-24.9 20-29.7c2.5-9.1 6.1-17.7 10.7-25.7C57.7 317 60 303 69.5 293.5s23.5-11.8 35.1-6.8c8-4.6 16.6-8.2 25.7-10.7zM208 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM450.3 276c4.8-11.7 16.2-20 29.7-20s24.9 8.3 29.7 20c9.1 2.5 17.7 6.1 25.7 10.7c11.6-4.9 25.6-2.6 35.1 6.8s11.8 23.5 6.9 35.1c4.6 8 8.2 16.6 10.7 25.7c11.7 4.8 20 16.2 20 29.7s-8.3 24.9-20 29.7c-2.5 9.1-6.1 17.7-10.7 25.7c4.9 11.6 2.6 25.6-6.9 35.1s-23.5 11.8-35.1 6.8c-8 4.6-16.6 8.2-25.7 10.7c-4.8 11.7-16.2 20-29.7 20s-24.9-8.3-29.7-20c-9.1-2.5-17.7-6.1-25.7-10.7c-11.6 4.9-25.6 2.6-35.1-6.9s-11.8-23.5-6.8-35.1c-4.6-8-8.2-16.6-10.7-25.7c-11.7-4.8-20-16.2-20-29.7s8.3-24.9 20-29.7c2.5-9.1 6.1-17.7 10.7-25.7c-4.9-11.6-2.6-25.6 6.8-35.1s23.5-11.8 35.1-6.8c8-4.6 16.6-8.2 25.7-10.7zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z", "M288 64v64H416L368 64H288zM419.2 25.6L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64H288c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H224V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6z"]]
};
var faGiftCard = {
  prefix: 'fad',
  iconName: 'gift-card',
  icon: [576, 512, [], "f663", ["M470.4 128H512c35.3 0 64 28.7 64 64V320H0V192c0-35.3 28.7-64 64-64h41.6c14.6 28.5 44.2 48 78.4 48h59.4l-53.9 64.6c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1L288 197.5l61.6 73.9c8.5 10.2 23.6 11.6 33.8 3.1s11.6-23.6 3.1-33.8L332.6 176H392c34.2 0 63.8-19.5 78.4-48zM0 416H576v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416z", "M186.2 48H184c-22.1 0-40 17.9-40 40s17.9 40 40 40h73.3L222.5 68.8C214.9 55.9 201.1 48 186.2 48zm57.3 128H184c-48.6 0-88-39.4-88-88s39.4-88 88-88h2.2c31.9 0 61.5 16.9 77.7 44.4l24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0H392c48.6 0 88 39.4 88 88s-39.4 88-88 88H332.6l53.9 64.6c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1L288 197.5l-61.6 73.9c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L243.4 176zM392 128c22.1 0 40-17.9 40-40s-17.9-40-40-40h-2.2c-14.9 0-28.8 7.9-36.3 20.8L318.7 128H320h72zM576 416H0V320H576v96z"]]
};
var faW = {
  prefix: 'fad',
  iconName: 'w',
  icon: [576, 512, [119], "57", ["M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z", ""]]
};
var faCodePullRequestDraft = {
  prefix: 'fad',
  iconName: 'code-pull-request-draft',
  icon: [448, 512, [], "e3fa", ["M416 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 153.3c-9.8 4.3-20.6 6.7-32 6.7s-22.2-2.4-32-6.7V358.7c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7V153.3zM368 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 80 0a80 80 0 1 0 0 160zm0 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm264-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]]
};
var faSquareB = {
  prefix: 'fad',
  iconName: 'square-b',
  icon: [448, 512, [], "e264", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 120c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76H152c-13.3 0-24-10.7-24-24V256 152zm144 52c0-15.5-12.5-28-28-28H176v56h68c15.5 0 28-12.5 28-28zM176 336h84c15.5 0 28-12.5 28-28s-12.5-28-28-28H244 176v56z", "M152 128c-13.3 0-24 10.7-24 24V256 360c0 13.3 10.7 24 24 24H260c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3c8.7-12.4 13.8-27.4 13.8-43.7c0-42-34-76-76-76H152zm92 104H176V176h68c15.5 0 28 12.5 28 28s-12.5 28-28 28zm-68 48h68 16c15.5 0 28 12.5 28 28s-12.5 28-28 28H176V280z"]]
};
var faElephant = {
  prefix: 'fad',
  iconName: 'elephant',
  icon: [640, 512, [128024], "f6da", ["M192 112C192 50.1 242.1 0 304 0c30.5 0 58.2 12.2 78.4 32H384c88.4 0 160 71.6 160 160V346.5c-10 3.5-20.8 5.5-32 5.5c-34.9 0-65.5-18.6-82.3-46.5c-4.6-7.6-14.4-10-22-5.4s-10 14.4-5.4 22c4 6.6 8.6 12.9 13.7 18.7V480c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V410c-15.3 3.9-31.4 6-48 6s-32.7-2.1-48-6v70c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V344.7c-2.6 4.7-5.5 9.2-8.7 13.5L43.2 374.4c-8 10.6-23 12.8-33.6 4.8s-12.8-23-4.8-33.6l12.1-16.2c5.7-7.6 9.6-16.3 11.4-25.6C30.8 291.7 32 279.4 32 267V248c0-72.2 35.4-136.1 89.9-175.4c16.7-13.1 35.6-23.4 56.1-30.4c-11.5 20.7-18 44.5-18 69.8c0 79.5 64.5 144 144 144c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112-50.1-112-112zM480 380c10.2 2.6 21 4 32 4s21.8-1.4 32-4v18.6c0 9.6 7.8 17.4 17.4 17.4c6.6 0 12.6-3.7 15.6-9.6l2.3-4.7c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.3 4.7c-13.8 27.6-42 45-72.8 45c-45 0-81.4-36.5-81.4-81.4V380zm0-172a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z", "M464 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-34.3 81.5c-4.6-7.6-14.4-10-22-5.4s-10 14.4-5.4 22c22.4 37.1 63.1 62 109.7 62c35.8 0 68.2-14.7 91.4-38.4c6.2-6.3 6.1-16.4-.2-22.6s-16.4-6.1-22.6 .2C563.1 341 538.9 352 512 352c-34.9 0-65.5-18.6-82.3-46.5z"]]
};
var faEarthAfrica = {
  prefix: 'fad',
  iconName: 'earth-africa',
  icon: [512, 512, [127757, "globe-africa"], "f57c", ["M146 24.8l39.9 54.8c4 5.5 6.1 12.1 6.1 18.8v39.5c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l12.5 4.2c13.2 4.4 27.6-1.6 33.9-14c3.2-6.3 9.6-10.3 16.7-10.3h76.4c5.3 20.5 8.1 41.9 8.1 64c0 141.4-114.6 256-256 256S0 397.4 0 256C0 154 59.7 65.9 146 24.8z", "M146 24.8l39.9 54.8c4 5.5 6.1 12.1 6.1 18.8v39.5c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l12.5 4.2c13.2 4.4 27.6-1.6 33.9-14c3.2-6.3 9.6-10.3 16.7-10.3h76.4C475.5 81.6 375.3 0 256 0c-39.4 0-76.7 8.9-110 24.8z"]]
};
var faGlobeAfrica = faEarthAfrica;
var faRainbow = {
  prefix: 'fad',
  iconName: 'rainbow',
  icon: [640, 512, [127752], "f75b", ["M320 192c-88.4 0-160 71.6-160 160v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-88.4-71.6-160-160-160z", "M64 352C64 210.6 178.6 96 320 96s256 114.6 256 256v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352C640 175.3 496.7 32 320 32S0 175.3 0 352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352zm192 0c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-70.7-57.3-128-128-128s-128 57.3-128 128v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352z"]]
};
var faCircleNotch = {
  prefix: 'fad',
  iconName: 'circle-notch',
  icon: [512, 512, [], "f1ce", ["M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z", ""]]
};
var faTabletScreenButton = {
  prefix: 'fad',
  iconName: 'tablet-screen-button',
  icon: [448, 512, ["tablet-alt"], "f3fa", ["M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64H64V384H384V64z", "M64 64H384V384H64V64z"]]
};
var faTabletAlt = faTabletScreenButton;
var faPaw = {
  prefix: 'fad',
  iconName: 'paw',
  icon: [512, 512, [], "f1b0", ["M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM90.2 282.7c-24.5 14-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3s14.3 70.1-10.2 84.1zm331.7 0c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z", "M69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5z"]]
};
var faMessageQuestion = {
  prefix: 'fad',
  iconName: 'message-question',
  icon: [512, 512, [], "e1e3", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm169.8 53.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M222.6 80c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6zM256 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faCloud = {
  prefix: 'fad',
  iconName: 'cloud',
  icon: [640, 512, [9729], "f0c2", ["M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z", ""]]
};
var faTrowelBricks = {
  prefix: 'fad',
  iconName: 'trowel-bricks',
  icon: [512, 512, [], "e58a", ["M320 224H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zM0 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416zm192 0c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416z", "M256 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-192 96C6.8 104.8 0 115.9 0 128s6.8 23.2 17.7 28.6l192 96c9.9 5 21.7 4.4 31.1-1.4s15.2-16.1 15.2-27.2V152h89c3.6 13.8 16.1 24 31 24h88c26.5 0 48-21.5 48-48s-21.5-48-48-48H376c-14.9 0-27.4 10.2-31 24H256V32z"]]
};
var faSquare3 = {
  prefix: 'fad',
  iconName: 'square-3',
  icon: [448, 512, [], "e258", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H280c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2H208c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L218.3 176H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M128 152c0-13.3 10.7-24 24-24H280c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.1 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2H208c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L218.3 176H152c-13.3 0-24-10.7-24-24z"]]
};
var faFaceFlushed = {
  prefix: 'fad',
  iconName: 'face-flushed',
  icon: [512, 512, [128563, "flushed"], "f579", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zM88 224a72 72 0 1 1 144 0A72 72 0 1 1 88 224zm264-72a72 72 0 1 1 0 144 72 72 0 1 1 0-144z", "M160 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faFlushed = faFaceFlushed;
var faHospitalUser = {
  prefix: 'fad',
  iconName: 'hospital-user',
  icon: [576, 512, [], "f80d", ["M0 48C0 21.5 21.5 0 48 0H272c26.5 0 48 21.5 48 48V271.8v95.9c-38.2 21.4-64 62.3-64 109.2c0 12.9 3.6 24.9 9.9 35.1H48c-26.5 0-48-21.5-48-48V384H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V288H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V48zM136 80v24H112c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152h24c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H184V80c0-8.8-7.2-16-16-16H152c-8.8 0-16 7.2-16 16z", "M432 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-50.9 32c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1z"]]
};
var faMicrowave = {
  prefix: 'fad',
  iconName: 'microwave',
  icon: [576, 512, [], "e01b", ["M120 128c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120z", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32H128c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64V96zm96 56V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm400-40c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16z"]]
};
var faChfSign = {
  prefix: 'fad',
  iconName: 'chf-sign',
  icon: [640, 512, [], "e602", ["M224 32c17.7 0 32 14.3 32 32V224h96V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H256V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32z", "M0 113.4C0 68.5 36.5 32 81.4 32c30.8 0 59 17.4 72.8 45l2.3 4.7c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L97 105.6c-3-5.9-9-9.6-15.6-9.6C71.8 96 64 103.8 64 113.4V398.6c0 9.6 7.8 17.4 17.4 17.4c6.6 0 12.6-3.7 15.6-9.6l2.3-4.7c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.3 4.7c-13.8 27.6-42 45-72.8 45C36.5 480 0 443.5 0 398.6V113.4zM448 64c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V224h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64z"]]
};
var faTentArrowLeftRight = {
  prefix: 'fad',
  iconName: 'tent-arrow-left-right',
  icon: [576, 512, [], "e57f", ["M268.6 166.5c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160c1.4 9.2-1.3 18.6-7.4 25.6s-14.9 11.1-24.2 11.1H384L288 352V512H96c-9.3 0-18.2-4.1-24.2-11.1s-8.8-16.4-7.4-25.6l24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128z", "M454.2 7.9c8.9-9.9 24-10.7 33.9-1.8l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-9.9 8.9-25 8.1-33.9-1.8s-8.1-25 1.8-33.9L489.5 120 86.5 120l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72C2.9 109.3 0 102.8 0 96s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8s8.1 25-1.8 33.9L86.5 72l402.9 0L455.9 41.8c-9.9-8.9-10.7-24-1.8-33.9z"]]
};
var faCartCircleArrowUp = {
  prefix: 'fad',
  iconName: 'cart-circle-arrow-up',
  icon: [640, 512, [], "e3f0", ["M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5h121c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H339.2c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM428.7 348.7l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6l0 89.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"]]
};
var faTrashClock = {
  prefix: 'fad',
  iconName: 'trash-clock',
  icon: [576, 512, [], "e2b0", ["M416 96H32L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2H330.8C285.6 480.1 256 427.5 256 368c0-89.9 67.4-164 154.4-174.7L416 96z", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]]
};
var faGavel = {
  prefix: 'fad',
  iconName: 'gavel',
  icon: [512, 512, ["legal"], "f0e3", ["M249.4 217.4L168 298.7l-1.4-1.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4 81.4-81.4-45.3-45.3z", "M273.4 9.4c12.5-12.5 32.8-12.5 45.3 0l16 16c12.5 12.5 12.5 32.8 0 45.3l-4 4L437.4 181.4l4-4c12.5-12.5 32.8-12.5 45.3 0l16 16c12.5 12.5 12.5 32.8 0 45.3l-120 120c-12.5 12.5-32.8 12.5-45.3 0l-16-16c-12.5-12.5-12.5-32.8 0-45.3l4-4L218.6 186.6l-4 4c-12.5 12.5-32.8 12.5-45.3 0l-16-16c-12.5-12.5-12.5-32.8 0-45.3l120-120z"]]
};
var faLegal = faGavel;
var faSprinklerCeiling = {
  prefix: 'fad',
  iconName: 'sprinkler-ceiling',
  icon: [384, 512, [], "e44c", ["M112 344a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 408a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM24 448a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 344a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-32 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-80 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-72 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm136-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M0 96c0 15.3 10.8 28.4 25.7 31.4L128 147.8V82.6L64 69.8V0H0V96zm256 51.8l102.3-20.5c15-3 25.7-16.1 25.7-31.4V0H320V69.8L256 82.6v65.3zM224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V64z"]]
};
var faBrowsers = {
  prefix: 'fad',
  iconName: 'browsers',
  icon: [576, 512, [], "e0cb", ["M192 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM512 416c35.3 0 64-28.7 64-64l0-160L96 192V352c0 35.3 28.7 64 64 64l352 0z", "M160 0C124.7 0 96 28.7 96 64V192H576V64c0-35.3-28.7-64-64-64H160zm32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32c0-13.3 10.7-24 24-24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]]
};
var faTrillium = {
  prefix: 'fad',
  iconName: 'trillium',
  icon: [448, 512, [], "e588", ["M130.8 135.6c-1.8 8.1-2.8 16.3-2.8 24.4c0 15.7 3.8 30.4 10.4 43.5c-16.3 0-32.7 4.2-47.8 12.9c-6.3 3.6-12.2 7.9-17.7 12.8C26.4 196.4 7 161 0 144.3c-5.8-13.8 3-29.1 17.9-31c18.3-2.3 59.8-3.2 112.9 22.2zM375 229.2c-5.5-4.9-11.4-9.2-17.7-12.8c-15-8.7-31.5-12.8-47.7-12.9c6.6-13.1 10.4-27.8 10.4-43.5c0-8.2-1-16.3-2.8-24.4c53.1-25.4 94.6-24.5 112.9-22.2c14.9 1.9 23.7 17.1 17.9 31c-7 16.7-26.4 52.1-73 84.9zM169 390.8c6.1-2.2 12-4.9 17.5-8.1c16.6-9.6 29.2-23.3 37.4-39.2c8.1 15.8 20.8 29.6 37.4 39.2c5.6 3.2 11.5 5.9 17.7 8.2c-4.8 53.1-25.4 90.2-36 106.3c-9.1 13.7-28.8 13.7-37.9 0c-10.6-16-31.2-53.2-36-106.3z", "M214.1 8.9C189.6 31.8 128 95.9 128 160c0 15.7 3.8 30.4 10.4 43.5c-16.3 0-32.7 4.2-47.8 12.9c-55.5 32-80.2 117.5-87.8 150.2c-1.8 7.5 2.5 14.9 9.9 17.1c32.1 9.7 118.4 31.1 173.9-1c16.6-9.6 29.2-23.3 37.4-39.2c8.1 15.8 20.8 29.6 37.4 39.2c55.5 32 141.8 10.7 173.9 1c7.4-2.2 11.6-9.6 9.9-17.1c-7.6-32.7-32.3-118.1-87.8-150.2c-15-8.7-31.5-12.8-47.7-12.9c6.6-13.1 10.4-27.8 10.4-43.5c0-64.1-61.6-128.2-86.1-151.1c-5.6-5.3-14.1-5.3-19.8 0zM224 200a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]]
};
var faMusicSlash = {
  prefix: 'fad',
  iconName: 'music-slash',
  icon: [640, 512, [], "f8d1", ["M563.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 16.7-6.2 32.2-16.7 45.1L421.2 304.8C437.4 294.3 457.8 288 480 288c11.2 0 22 1.6 32 4.6V147L300.7 210.4 192.1 125.3c1.1-13 10-24.1 22.7-27.9l320-96c9.7-2.9 20.2-1.1 28.3 5zM192 247.3l64 50.4V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V247.3z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faTruckRamp = {
  prefix: 'fad',
  iconName: 'truck-ramp',
  icon: [640, 512, [], "f4e0", ["M448 416a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z", "M416.7 402.5C423.4 338.2 477.9 288 544 288c38.2 0 72.5 16.8 96 43.3V0H416c-35.3 0-64 28.7-64 64V353.8L31.6 441.1c-17.1 4.6-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5L416.7 402.5z"]]
};
var faBinoculars = {
  prefix: 'fad',
  iconName: 'binoculars',
  icon: [512, 512, [], "f1e5", ["M96 64V96h96V64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm224 0V96h96V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zM288 96H224V256h64V96z", "M192 448V256h32V96H192 93c-16.4 0-30.2 12.5-31.8 28.8l-9 89.7c-2.7 27.3-11.5 53.7-25.6 77.3C9.2 320.7 0 353.8 0 387.6V448c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32zm128 0c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V387.6c0-33.8-9.2-66.9-26.5-95.8c-14.1-23.6-22.9-49.9-25.6-77.3l-9-89.7C449.2 108.5 435.5 96 419 96H320 288V256h32V448z"]]
};
var faMicrophoneSlash = {
  prefix: 'fad',
  iconName: 'microphone-slash',
  icon: [640, 512, [], "f131", ["M401.3 412.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2zm70.8-67.5c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7l38.3 30zM408 294.5c5.2-11.8 8-24.8 8-38.5V96c0-53-43-96-96-96s-96 43-96 96v54.3L408 294.5z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faBoxTissue = {
  prefix: 'fad',
  iconName: 'box-tissue',
  icon: [512, 512, [], "e05b", ["M113.8 224H48c-26.5 0-48 21.5-48 48V384H512V272c0-26.5-21.5-48-48-48H405.3L384 288h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h48l-14.2-64z", "M103.9 0H208c40 0 52 24 64 48s24 48 64 48h67.6c21.8 0 37.3 21.4 30.4 42.1L373.3 320H135.1L72.7 38.9C68.2 19 83.4 0 103.9 0zM512 384v80c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V384H512z"]]
};
var faCircleC = {
  prefix: 'fad',
  iconName: 'circle-c',
  icon: [512, 512, [], "e101", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z", "M312.6 199.4c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"]]
};
var faStarChristmas = {
  prefix: 'fad',
  iconName: 'star-christmas',
  icon: [512, 512, [], "f7d4", ["M71 105c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 105zM441 105l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm0 336c-9.4 9.4-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9zM71 407l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9z", "M192 320L15.5 275.9C6.4 273.6 0 265.4 0 256s6.4-17.6 15.5-19.9L192 192 236.1 15.5C238.4 6.4 246.6 0 256 0s17.6 6.4 19.9 15.5L320 192l176.5 44.1c9.1 2.3 15.5 10.5 15.5 19.9s-6.4 17.6-15.5 19.9L320 320 275.9 496.5c-2.3 9.1-10.5 15.5-19.9 15.5s-17.6-6.4-19.9-15.5L192 320z"]]
};
var faChartBullet = {
  prefix: 'fad',
  iconName: 'chart-bullet',
  icon: [512, 512, [], "e0e1", ["M160 64v64h80V64H160zm288 96H288v64H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H288v64H448v32zm-288 0v64h80V160H160zM384 384v64h80c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H384v64h64v32H384zm-48-32V288H256v64h80zm0 32H256v64h80V384z", "M264 32c-13.3 0-24 10.7-24 24V232c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H160V64H48zm0 224c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H256V288H48zm336-8c0-13.3-10.7-24-24-24s-24 10.7-24 24V456c0 13.3 10.7 24 24 24s24-10.7 24-24V280z"]]
};
var faMotorcycle = {
  prefix: 'fad',
  iconName: 'motorcycle',
  icon: [640, 512, [127949], "f21c", ["M128 416c26.9 0 49.9-16.5 59.3-40h66.4C242.5 435.2 190.5 480 128 480C57.3 480 0 422.7 0 352s57.3-128 128-128c62.5 0 114.5 44.8 125.8 104H187.3c-9.5-23.5-32.5-40-59.3-40c-35.3 0-64 28.7-64 64s28.7 64 64 64zm256-64c0-40 18.4-75.7 47.1-99.2l31.6 58.4C453.5 322.3 448 336.5 448 352c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-2.4 0-4.8 .1-7.1 .4L473.3 230c12.2-3.9 25.2-6 38.7-6c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128z", "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l75.2 139.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faTreeChristmas = {
  prefix: 'fad',
  iconName: 'tree-christmas',
  icon: [448, 512, [127876], "f7db", ["M195.3 105.9l2.1 .8L215 153.8c1.4 3.8 5 6.2 9 6.2s7.6-2.5 9-6.2l17.7-47.1 2.1-.8L418.8 313.5c3.4 4.2 5.2 9.4 5.2 14.8c0 13.1-10.6 23.7-23.7 23.7H368l76.2 122c2.5 4 3.8 8.5 3.8 13.2c0 13.7-11.1 24.9-24.9 24.9H24.9C11.1 512 0 500.9 0 487.1c0-4.7 1.3-9.2 3.8-13.2L80 352H47.7C34.6 352 24 341.4 24 328.3c0-5.4 1.8-10.6 5.2-14.8L195.3 105.9zM160 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z", "M150.2 71l47.1-17.7L215 6.2c1.4-3.8 5-6.2 9-6.2s7.6 2.5 9 6.2l17.7 47.1L297.8 71c3.8 1.4 6.2 5 6.2 9s-2.5 7.6-6.2 9l-47.1 17.7L233 153.8c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2l-17.7-47.1L150.2 89c-3.8-1.4-6.2-5-6.2-9s2.5-7.6 6.2-9zM288 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faTireFlat = {
  prefix: 'fad',
  iconName: 'tire-flat',
  icon: [512, 512, [], "f632", ["M239.9 350l0 65c-44.2-5.5-81.5-33.6-99.8-72.4l61.9-20.1c8.6 13.4 22.1 23.4 37.9 27.5zm32 0c15.9-4.1 29.4-14.1 38-27.6l61.9 20.1c-18.3 38.8-55.6 66.9-99.8 72.4l0-65zm47.9-58c.1-1.3 .1-2.7 .1-4c0-15.4-5.5-29.6-14.5-40.6l38.2-52.6C368.5 218.1 384 251.2 384 288c0 8.3-.8 16.3-2.3 24.2L319.9 292zm-40.2-63.5c-7.3-2.9-15.3-4.5-23.6-4.5s-16.3 1.6-23.6 4.5l-10-13.8-28.1-38.8C212.5 165.8 233.6 160 256 160s43.5 5.8 61.8 15.9l-38.2 52.6zm-73.1 18.9c-9.1 11-14.5 25.2-14.5 40.6c0 1.4 0 2.7 .1 4l-61.8 20.1c-1.5-7.8-2.3-15.9-2.3-24.2c0-36.8 15.5-69.9 40.3-93.3l28.1 38.7 10.1 13.9zM256 448a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM224 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M0 288C0 146.6 114.6 32 256 32s256 114.6 256 256c0 47.3-12.8 91.7-35.2 129.7c20.3 5.6 35.2 24.2 35.2 46.3c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48c0-22.1 14.9-40.7 35.2-46.3C12.8 379.7 0 335.3 0 288zm416 0c0-88.4-71.6-160-160-160s-160 71.6-160 160c0 52.3 25.1 98.8 64 128c26.7 20.1 60 32 96 32c33.1 0 63.9-10.1 89.5-27.3c2.2-1.5 4.4-3.1 6.6-4.7c38.9-29.2 64-75.7 64-128zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faSunglasses = {
  prefix: 'fad',
  iconName: 'sunglasses',
  icon: [576, 512, [128374], "f892", ["M192.9 303.6c10.5 2.8 20.8 6.3 30.5 10.4l-3.2 57.5c-1.9 33.9-29.9 60.4-63.9 60.4H112c-32.7 0-59.7-24.5-63.5-56.2l144.4-72.2zM356 374l141-70.5c10.7 2.8 21.1 6.4 31 10.7V368c0 35.3-28.7 64-64 64H419.7c-33.1 0-60.6-25.3-63.7-58z", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8c40.1 0 82.2 9.6 118.5 27.3c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.4 7.7-9.8 13.5-12.7c36.2-17.8 78.4-27.3 118.5-27.3c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2c.3 1.8 .5 3.7 .5 5.6v5.2c0 .5 0 1 0 1.5V352c0 .2 0 .4 0 .6V368c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM48 352v16c0 35.3 28.7 64 64 64h44.3c34 0 62-26.5 63.9-60.5l3.2-57.5c-27.3-11.7-58.3-18-87.7-18c-29.5 0-60.5 6.4-87.7 18.2V352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c1.9 33.9 29.9 60.5 63.9 60.5H464c35.3 0 64-28.7 64-64V314.2c-27.2-11.8-58.2-18.2-87.7-18.2z"]]
};
var faBadge = {
  prefix: 'fad',
  iconName: 'badge',
  icon: [512, 512, [], "f335", ["M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9z", ""]]
};
var faMessagePen = {
  prefix: 'fad',
  iconName: 'message-pen',
  icon: [512, 512, ["comment-alt-edit", "message-edit"], "f4a4", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm340.8 59c-14.7-14.7-38.6-14.7-53.3 0L272.6 138l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 232.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 284c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 160.6l-71.9 71.9z", "M287.5 123L272.6 138l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3s-38.6-14.7-53.3 0zM250 160.6l-71.9 71.9c-4.1 4.1-7 9.2-8.4 14.9L160.5 284c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 160.6z"]]
};
var faCommentAltEdit = faMessagePen;
var faMessageEdit = faMessagePen;
var faBellConcierge = {
  prefix: 'fad',
  iconName: 'bell-concierge',
  icon: [512, 512, [128718, "concierge-bell"], "f562", ["M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3c7.9-.8 15.9-1.3 24-1.3s16.1 .4 24 1.3V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM480 400H32 24c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8z", "M480 368c0-123.7-100.3-224-224-224S32 244.3 32 368v32H480V368z"]]
};
var faConciergeBell = faBellConcierge;
var faPenRuler = {
  prefix: 'fad',
  iconName: 'pen-ruler',
  icon: [512, 512, ["pencil-ruler"], "f5ae", ["M249.4 103.4L204.2 58.3c-.3 .3-.6 .7-.9 1l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c.3-.3 .7-.6 1-.9L161.9 16C143.2-2.7 112.8-2.7 94.1 16L16 94.1c-18.7 18.7-18.7 49.1 0 67.9l87.4 87.4L249.4 103.4zM408.6 262.6L262.6 408.6 350.1 496c18.7 18.7 49.1 18.7 67.9 0L496 417.9c18.7-18.7 18.7-49.1 0-67.9l-19.8-19.8c-.3 .3-.6 .7-.9 1l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c.3-.3 .7-.6 1-.9l-45.1-45.1z", "M378.7 19.3L322.3 75.7 436.3 189.7l56.4-56.4c25-25 25-65.5 0-90.5L469.3 19.3c-25-25-65.5-25-90.5 0zm-79 79L44.9 353.2c-6.7 6.7-11.6 15.1-14.2 24.2L.9 481.4C-1.5 489.8 .9 498.8 7 505s15.2 8.5 23.6 6.1l104-29.7c9.2-2.6 17.5-7.5 24.2-14.2L413.7 212.3 299.7 98.3z"]]
};
var faPencilRuler = faPenRuler;
var faArrowProgress = {
  prefix: 'fad',
  iconName: 'arrow-progress',
  icon: [512, 512, [], "e5df", ["M448 0a64 64 0 1 1 0 128A64 64 0 1 1 448 0zM64 384c23.7 0 44.4 12.9 55.4 32H160V401.9c0-9.9 8-17.9 17.9-17.9c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8c-9.9 0-17.9-8-17.9-17.9V480H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64s28.7-64 64-64z", "M256 110.1V96H128c-35.3 0-64 28.7-64 64s28.7 64 64 64H384c70.7 0 128 57.3 128 128c0 62.2-44.4 114.1-103.2 125.6C398.1 498 376.7 512 352 512c-35.3 0-64-28.7-64-64s28.7-64 64-64c22.2 0 41.7 11.3 53.2 28.4c24.9-8.7 42.8-32.5 42.8-60.4c0-35.3-28.7-64-64-64H128C57.3 288 0 230.7 0 160S57.3 32 128 32H256V17.9C256 8 264 0 273.9 0c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8c-9.9 0-17.9-8-17.9-17.9z"]]
};
var faChessRookPiece = {
  prefix: 'fad',
  iconName: 'chess-rook-piece',
  icon: [320, 512, ["chess-rook-alt"], "f448", ["M272 416H48L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L272 416z", "M48 416L72 264 47 232.8c-4.5-5.7-7-12.7-7-20V112c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V112c0-8.8 7.2-16 16-16h24c8.8 0 16 7.2 16 16V212.8c0 7.3-2.5 14.3-7 20L248 264l24 152H48zm88-135.1c0 3.9 3.2 7.1 7.1 7.1h33.8c3.9 0 7.1-3.2 7.1-7.1V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v32.9z"]]
};
var faChessRookAlt = faChessRookPiece;
var faSquareRoot = {
  prefix: 'fad',
  iconName: 'square-root',
  icon: [576, 512, [8730], "f697", ["M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1z", ""]]
};
var faAlbumCollectionCirclePlus = {
  prefix: 'fad',
  iconName: 'album-collection-circle-plus',
  icon: [640, 512, [], "e48e", ["M56 0H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 48 32 37.3 32 24S42.7 0 56 0zM12 176.2C21.1 165.9 34.2 160 48 160H464c13.8 0 26.9 5.9 36 16.2c4.2 4.8 7.4 10.3 9.4 16.3c-4.4-.3-8.9-.5-13.4-.5c-46.9 0-89.5 18.3-121 48.2C342.9 220.1 301.4 208 256 208C154.4 208 72 268.9 72 344s82.4 136 184 136c33.2 0 64.4-6.5 91.3-17.9c12.4 19.6 28.6 36.6 47.5 49.9H80c-24.2 0-44.6-18-47.6-42L.4 214c-1.7-13.7 2.5-27.4 11.6-37.7zM288 352c0 13.3-14.3 24-32 24s-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24zM16 104c0-13.3 10.7-24 24-24H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"]]
};
var faPeopleArrows = {
  prefix: 'fad',
  iconName: 'people-arrows',
  icon: [640, 512, ["people-arrows-left-right"], "e068", ["M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM25.9 233.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c.6-.2 1.1-.4 1.7-.6L167 321c-9.4-9.4-9.4-24.6 0-33.9l62-62c-7.1-37.4-39.8-65.1-78.6-65.1H105.6c-41.6 0-76.3 31.9-79.7 73.4zM446.3 347.6c.6 .2 1.1 .4 1.7 .6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C610.7 191.9 576 160 534.4 160H489.6c-38.8 0-71.5 27.7-78.6 65.1l62 62c9.4 9.4 9.4 24.6 0 33.9l-26.7 26.7zM576 64A64 64 0 1 0 448 64a64 64 0 1 0 128 0z", "M257.2 217.8c9 3.7 14.8 12.5 14.8 22.2v32h96V240c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V336H272v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2z"]]
};
var faPeopleArrowsLeftRight = faPeopleArrows;
var faFaceAngryHorns = {
  prefix: 'fad',
  iconName: 'face-angry-horns',
  icon: [640, 512, [], "e368", ["M64 256a256 256 0 1 1 512 0A256 256 0 1 1 64 256zM402.7 411.9c6.6-5.9 7.1-16 1.2-22.6C387.8 371.4 359.7 352 320 352s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM240.4 304c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M566.1 185.1C550.5 131 517.6 84.3 473.8 51.3c17-3.3 39.7-8.6 63-15.5c29.8-8.9 59.1-20.2 78.4-33.1c5.4-3.6 12.4-3.6 17.8 0s8.1 10.1 6.8 16.4c-6.2 31-29.3 106.6-73.6 166zM103.3 35.8c23.3 7 46 12.2 63 15.5c-43.8 33-76.7 79.7-92.3 133.8C29.6 125.8 6.5 50.1 .3 19.1C-1 12.8 1.7 6.3 7.1 2.7s12.4-3.6 17.8 0c19.3 12.9 48.5 24.2 78.4 33.1zM240.4 304c-17.7 0-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8z"]]
};
var faMarsAndVenusBurst = {
  prefix: 'fad',
  iconName: 'mars-and-venus-burst',
  icon: [640, 512, [], "e523", ["M176 8c6.6 0 12.4 4 14.9 10.1l29.4 74 76.2-23.1c6.3-1.9 13.1 .2 17.2 5.3c3 3.7 4.1 8.5 3.2 13C270.7 115.4 240 166.1 240 224c0 27.8 7.1 53.9 19.5 76.7l1.9 26.4c.5 6.5-3.1 12.7-9 15.5s-12.9 1.8-17.8-2.6L176 286.1l-58.6 53.9c-4.8 4.4-11.9 5.5-17.8 2.6s-9.5-9-9-15.5l5.6-79.4L17.6 235.4c-6.5-1-11.7-5.9-13.1-12.2s1.1-13 6.5-16.7l65.6-45.1L37 92.2c-3.3-5.7-2.7-12.8 1.4-17.9s10.9-7.2 17.2-5.3l76.2 23.1 29.4-74C163.6 12 169.4 8 176 8z", "M481.8 14.8C485.5 5.8 494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C551 163.3 560 192.6 560 224c0 80.2-59.1 146.7-136.1 158.2c0 .6 .1 1.2 .1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H424v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-24 0-24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456H352c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2 .1-1.8C299.1 370.7 240 304.2 240 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L526.1 80 487 41c-6.9-6.9-8.9-17.2-5.2-26.2zM592 48l0 0h0v0zM400 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24h24zm96-264a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]]
};
var faTombstone = {
  prefix: 'fad',
  iconName: 'tombstone',
  icon: [448, 512, [], "f720", ["M224 0C118 0 32 86 32 192V448H416V192C416 86 330 0 224 0zm24 152v40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V240H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M248 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h48V360c0 13.3 10.7 24 24 24s24-10.7 24-24V240h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V152zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faSquareCaretRight = {
  prefix: 'fad',
  iconName: 'square-caret-right',
  icon: [448, 512, ["caret-square-right"], "f152", ["M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z", "M312.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 208c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"]]
};
var faCaretSquareRight = faSquareCaretRight;
var faScissors = {
  prefix: 'fad',
  iconName: 'scissors',
  icon: [512, 512, [9984, 9986, 9988, "cut"], "f0c4", ["M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l64-64zm64 64l-64 64L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L320 256zM112 160a48 48 0 1 1 0-96 48 48 0 1 1 0 96z", "M216.5 359.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L152.5 295.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5zM64 400a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]]
};
var faCut = faScissors;
var faListMusic = {
  prefix: 'fad',
  iconName: 'list-music',
  icon: [512, 512, [], "f8c9", ["M0 96C0 78.3 14.3 64 32 64H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 224c0-17.7 14.3-32 32-32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM0 352c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M512 32c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-96 32C360.8 38 352 50.2 352 64v64V359.7c-14.5-4.9-30.8-7.7-48-7.7c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V151.1l74.1-24.7C503.2 122 512 109.8 512 96V32z"]]
};
var faSunPlantWilt = {
  prefix: 'fad',
  iconName: 'sun-plant-wilt',
  icon: [640, 512, [], "e57a", ["M174.6 9.5C172 3.7 166.3 0 160 0s-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5zM96 160a64 64 0 1 1 128 0A64 64 0 1 1 96 160zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M536 144c-17.7 0-32 14.3-32 32v96 8V448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H456V280v-8c0-17.7-14.3-32-32-32s-32 14.3-32 32v21.4c14.8 7.7 24 23.1 24 44.6c0 16.6-16 43.9-37.4 67.2c-5.7 6.2-15.5 6.2-21.2 0C336 382 320 354.9 320 338c0-21.5 9.2-37 24-44.6V272c0-44.2 35.8-80 80-80c11.4 0 22.2 2.4 32 6.7V176c0-44.2 35.8-80 80-80s80 35.8 80 80v53.4c14.8 7.7 24 23.1 24 44.6c0 16.6-16 43.9-37.4 67.2c-5.7 6.2-15.5 6.2-21.2 0C560 318 544 290.9 544 274c0-21.5 9.2-37 24-44.6V176c0-17.7-14.3-32-32-32z"]]
};
var faToiletsPortable = {
  prefix: 'fad',
  iconName: 'toilets-portable',
  icon: [576, 512, [], "e584", ["M24 64H0V88 488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H208v8c0 13.3 10.7 24 24 24s24-10.7 24-24V88 64H232 24zM192 224c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM344 64H320V88 488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H528v8c0 13.3 10.7 24 24 24s24-10.7 24-24V88 64H552h-8H352h-8zM512 224c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16z", "M32 0C14.3 0 0 14.3 0 32V64H256V32c0-17.7-14.3-32-32-32H32zM352 0c-17.7 0-32 14.3-32 32V64H576V32c0-17.7-14.3-32-32-32H352zM192 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zm336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]]
};
var faHockeyPuck = {
  prefix: 'fad',
  iconName: 'hockey-puck',
  icon: [512, 512, [], "f453", ["M512 160c0 53-114.6 96-256 96S0 213 0 160s114.6-96 256-96s256 43 256 96z", "M256 256c141.4 0 256-43 256-96V352c0 53-114.6 96-256 96S0 405 0 352V160c0 53 114.6 96 256 96z"]]
};
var faMustache = {
  prefix: 'fad',
  iconName: 'mustache',
  icon: [640, 512, [], "e5bc", ["M193.4 194.9c16.4-12.3 36.3-18.9 56.8-18.9c26.6 0 51.9 11.2 69.8 30.7c17.9-19.5 43.2-30.7 69.8-30.7c20.5 0 40.4 6.6 56.8 18.9l13.1 9.8c16.7 12.5 37 19.3 57.8 19.3c15 0 29.7-3.5 43.1-10.2l8.3-4.1c1.9-1 4-1.5 6-1.7c1.8-.1 3.6 0 5.4 .5c.3 .1 .5 .2 .8 .2c2.2 .7 4.1 1.9 5.7 3.3c1.2 1.1 2.2 2.3 3 3.7c.4 .6 .7 1.3 1 1.9c.6 1.5 1 2.9 1.1 4.4c.2 2.2 0 4.5-.7 6.8c-9.4 28.3-32.9 54.7-58.8 73.8c-25.8 19-57.3 33.1-85 33.1c-16.4 0-34.4-4.7-50.1-11.2c-15.6-6.5-30.6-15.5-40.6-25.5c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c6 6 17 13 30.3 18.5c13.2 5.5 26.9 8.8 37.8 8.8c18.2 0 43-9.9 66-26.9c9.5-7 18.1-14.8 25.4-22.9c-7 1.2-14.2 1.8-21.4 1.8c-27.8 0-54.8-9-77-25.7l-13.1-9.8c-10.8-8.1-24-12.5-37.6-12.5c-19 0-37 8.6-48.9 23.5l-8.2 10.2c-.4 .6-.9 1.1-1.4 1.6c-1.3 1.3-2.8 2.4-4.5 3.1c-4.4 2.1-9.4 2-13.7 0c-1.6-.8-3.1-1.8-4.5-3.1c-.5-.5-1-1-1.4-1.6l-8.2-10.2c-11.9-14.9-29.9-23.5-48.9-23.5c-13.6 0-26.7 4.4-37.6 12.5l-13.1 9.8c-22.2 16.7-49.3 25.7-77 25.7c-7.2 0-14.3-.6-21.4-1.8c7.3 8.1 16 15.9 25.4 22.9c23 17 47.9 26.9 66 26.9c10.9 0 24.6-3.3 37.8-8.8c13.3-5.5 24.3-12.5 30.3-18.5c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-10 10-25 19-40.6 25.5C227 331.3 209 336 192.6 336c-27.7 0-59.2-14.1-85-33.1c-25.9-19.1-49.3-45.5-58.8-73.7c-.1-.4-.2-.8-.3-1.2c-.4-1.5-.6-3.1-.5-4.6c.1-2.2 .6-4.4 1.7-6.5c1-2.1 2.4-3.8 4.1-5.2c1.3-1.1 2.9-2 4.6-2.7c.3-.1 .7-.2 1-.3c3.8-1.1 7.7-.8 11.1 .7c.2 .1 .5 .2 .7 .3l8.2 4.1c13.4 6.7 28.1 10.2 43.1 10.2c20.9 0 41.2-6.8 57.8-19.3l13.1-9.8z", "M231 112c-31.6 0-61.7 13.2-83.1 36.4l-2 2.1c-27.6 29.9-74.6 30.9-103.4 2.1L41 151c-2.5-2.5-5.5-4.4-8.6-5.5c-2.6-1-5.4-1.5-8.4-1.5c-3.6 0-7.1 .8-10.2 2.3c-1.7 .8-3.3 1.8-4.8 3c-1.5 1.2-2.9 2.7-4.1 4.2c-.7 1-1.4 2-2 3C1.1 159.9 0 163.8 0 168v39.4C0 313.8 86.2 400 192.6 400c46.7 0 91.7-16.9 126.9-47.7l.5-.4 .5 .4c35.1 30.7 80.2 47.7 126.9 47.7C553.8 400 640 313.8 640 207.4V168c0-4-1-7.8-2.7-11.2c-.2-.5-.5-.9-.8-1.4c-.2-.4-.5-.8-.7-1.1c-.3-.5-.7-1-1.1-1.4c-1.1-1.3-2.3-2.5-3.6-3.6c-4.1-3.3-9.3-5.2-15-5.2c-2.9 0-5.8 .5-8.4 1.5c-3.1 1.2-6.1 3-8.6 5.5l-1.6 1.6c-28.8 28.8-75.8 27.9-103.4-2.1l-2-2.1C470.7 125.2 440.6 112 409 112c-33 0-64.4 14.4-85.9 39.5l-3.1 3.6-3.1-3.6C295.4 126.4 264 112 231 112zm19.2 64c26.6 0 51.9 11.2 69.8 30.7c17.9-19.5 43.2-30.7 69.8-30.7c20.5 0 40.4 6.6 56.8 18.9l13.1 9.8c16.7 12.5 37 19.3 57.8 19.3c15 0 29.7-3.5 43.1-10.2l8.3-4.1c1.9-1 4-1.5 6-1.7c1.8-.1 3.6 0 5.4 .5c.3 .1 .5 .2 .8 .2c2.2 .7 4.1 1.9 5.7 3.3c1.2 1.1 2.2 2.3 3 3.7c.4 .6 .7 1.3 1 1.9c.6 1.5 1 2.9 1.1 4.4c.2 2.2 0 4.5-.7 6.8c-9.4 28.3-32.9 54.7-58.8 73.8c-25.8 19-57.3 33.1-85 33.1c-16.4 0-34.4-4.7-50.1-11.2c-15.6-6.5-30.6-15.5-40.6-25.5c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c6 6 17 13 30.3 18.5c13.2 5.5 26.9 8.8 37.8 8.8c18.2 0 43-9.9 66-26.9c9.5-7 18.1-14.8 25.4-22.9c-7 1.2-14.2 1.8-21.4 1.8c-27.8 0-54.8-9-77-25.7l-13.1-9.8c-10.8-8.1-24-12.5-37.6-12.5c-19 0-37 8.6-48.9 23.5l-8.2 10.2c-.4 .6-.9 1.1-1.4 1.6c-1.3 1.3-2.8 2.4-4.5 3.1c-4.4 2.1-9.4 2-13.7 0c-1.6-.8-3.1-1.8-4.5-3.1c-.5-.5-1-1-1.4-1.6l-8.2-10.2c-11.9-14.9-29.9-23.5-48.9-23.5c-13.6 0-26.7 4.4-37.6 12.5l-13.1 9.8c-22.2 16.7-49.3 25.7-77 25.7c-7.2 0-14.3-.6-21.4-1.8c7.3 8.1 16 15.9 25.4 22.9c23 17 47.9 26.9 66 26.9c10.9 0 24.6-3.3 37.8-8.8c13.3-5.5 24.3-12.5 30.3-18.5c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-10 10-25 19-40.6 25.5C227 331.3 209 336 192.6 336c-27.7 0-59.2-14.1-85-33.1c-25.9-19.1-49.3-45.5-58.8-73.7c-.1-.4-.2-.8-.3-1.2c-.4-1.5-.6-3.1-.5-4.6c.1-2.2 .6-4.4 1.7-6.5c1-2.1 2.4-3.8 4.1-5.2c1.3-1.1 2.9-2 4.6-2.7c.3-.1 .7-.2 1-.3c3.8-1.1 7.7-.8 11.1 .7c.2 .1 .5 .2 .7 .3l8.2 4.1c13.4 6.7 28.1 10.2 43.1 10.2c20.9 0 41.2-6.8 57.8-19.3l13.1-9.8c16.4-12.3 36.3-18.9 56.8-18.9z"]]
};
var faHyphen = {
  prefix: 'fad',
  iconName: 'hyphen',
  icon: [320, 512, [], "2d", ["M0 256c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", ""]]
};
var faTable = {
  prefix: 'fad',
  iconName: 'table',
  icon: [512, 512, [], "f0ce", ["M224 320v96h64V320l160 0V256l-160 0V160H224v96L64 256v64l160 0z", "M64 160V416H448V160H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]]
};
var faUserChef = {
  prefix: 'fad',
  iconName: 'user-chef',
  icon: [448, 512, [], "e3d2", ["M96 160H352c0 70.7-57.3 128-128 128s-128-57.3-128-128z", "M384 48c0 20.9-13.4 38.7-32 45.3V112v48H320 304 144 128 96V112 93.3C77.4 86.7 64 68.9 64 48C64 21.5 85.5 0 112 0c14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zM178.4 340.6c7.5 1.9 8.2 12.3 1 15.2l-43.2 17.3C111.9 382.8 96 406.3 96 432.5V480v24 8H88 64 25.6C11.5 512 0 500.5 0 486.4c0-58.8 37.7-108.8 90.3-127c3.3-1.2 5.7-4.3 5.7-7.8V330.2c0-5.2 4.9-9 9.9-7.8l72.5 18.1zM352 512H160 136h-8v-8V480 432.5c0-13.1 8-24.9 20.1-29.7L341 325.6c5.3-2.1 11 1.8 11 7.4v18.6c0 3.5 2.3 6.6 5.7 7.8c52.6 18.2 90.3 68.2 90.3 127c0 14.1-11.5 25.6-25.6 25.6H352zM224 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faMessageImage = {
  prefix: 'fad',
  iconName: 'message-image',
  icon: [512, 512, ["comment-alt-image"], "e1e0", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm176 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm120 0c-8 0-15.5 4-20 10.7l-56 84L202.7 201c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H392c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C311.5 132 304 128 296 128z", "M144 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm172-21.3C311.5 132 304 128 296 128s-15.5 4-20 10.7l-56 84L202.7 201c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H392c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144z"]]
};
var faCommentAltImage = faMessageImage;
var faUsersMedical = {
  prefix: 'fad',
  iconName: 'users-medical',
  icon: [640, 512, [], "f830", ["M64 80a80 80 0 1 1 160 0A80 80 0 1 1 64 80zm368 0a80 80 0 1 1 160 0A80 80 0 1 1 432 80zM106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7C0 239.8 47.8 192 106.7 192zm298 128c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H605.3c-6.6-18.6-24.4-32-45.3-32H528c-20.9 0-38.7 13.4-45.3 32H405.3c-.2 0-.4 0-.7 0zm28.2 43.5C422.5 372.3 416 385.4 416 400v32c0 26.5 21.5 48 48 48h16v16c0 5.6 1 11 2.7 16H154.7c-14.7 0-26.7-11.9-26.7-26.7C128 411.7 187.7 352 261.3 352H378.7c19.3 0 37.6 4.1 54.2 11.5zM320 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M528 320c-8.8 0-16 7.2-16 16v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448h48c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16l-48 0V336c0-8.8-7.2-16-16-16H528z"]]
};
var faSensorTriangleExclamation = {
  prefix: 'fad',
  iconName: 'sensor-triangle-exclamation',
  icon: [640, 512, ["sensor-alert"], "e029", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v32c-26.4 0-50.7 14.2-63.7 37.1L233.9 430c-6.5 11.5-9.9 24.5-9.9 37.7c0 4.2 .3 8.3 1 12.3H64c-35.3 0-64-28.7-64-64V96zm88 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24z", "M412.2 180.9l-150.4 265c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3H595.7c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9zM448 256c8.8 0 16 7.2 16 16v88c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8 7.2-16 16-16zM424 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
};
var faSensorAlert = faSensorTriangleExclamation;
var faMagnifyingGlassArrowRight = {
  prefix: 'fad',
  iconName: 'magnifying-glass-arrow-right',
  icon: [512, 512, [], "e521", ["M208 416A208 208 0 1 0 208 0a208 208 0 1 0 0 416zm33-297l72 72c9.4 9.4 9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31H120c-13.3 0-24-10.7-24-24s10.7-24 24-24H238.1l-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z", "M241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H238.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72zM457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376L457.4 502.6z"]]
};
var faTachographDigital = {
  prefix: 'fad',
  iconName: 'tachograph-digital',
  icon: [640, 512, ["digital-tachograph"], "f566", ["M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z", "M96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zM80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm320 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H400z"]]
};
var faDigitalTachograph = faTachographDigital;
var faFaceMask = {
  prefix: 'fad',
  iconName: 'face-mask',
  icon: [576, 512, [], "e37f", ["M542 224.1c-1.5 .2-3.1 .6-4.5 1.3L423.1 276.2C414.4 264 400.2 256 384 256H192c-16.2 0-30.4 8-39.1 20.2L38.5 225.4c-1.5-.7-3-1.1-4.5-1.3C49.7 97.8 157.4 0 288 0S526.3 97.8 542 224.1zm2 33.4c-.3 47.9-13.7 92.7-36.9 131c-2.9-2.8-6.8-4.5-11.1-4.5H432V307.3l112-49.8zM487.9 416c-46.9 58.5-119 96-199.9 96s-152.9-37.5-199.9-96h58.6c6.6 18.6 24.4 32 45.3 32H384c20.9 0 38.7-13.4 45.3-32h58.6zm-419-27.5c-23.2-38.2-36.6-83-36.9-131l112 49.8V384H80c-4.3 0-8.2 1.7-11.1 4.5zM240 176c8.8 0 16-7.2 16-16s-7.2-16-16-16c-55.4 0-93.6 23-107.3 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C162.9 195.7 193 176 240 176zm180.7 27.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C429.6 167 391.4 144 336 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c47 0 77.1 19.7 84.7 27.3z", "M38.5 225.4c-8.1-3.6-17.5 0-21.1 8.1s0 17.5 8.1 21.1L144 307.3V384H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h66.7c6.6 18.6 24.4 32 45.3 32H384c20.9 0 38.7-13.4 45.3-32H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H432V307.3l118.5-52.7c8.1-3.6 11.7-13 8.1-21.1s-13-11.7-21.1-8.1L423.1 276.2C414.4 264 400.2 256 384 256H192c-16.2 0-30.4 8-39.1 20.2L38.5 225.4zM208 304H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faPickleball = {
  prefix: 'fad',
  iconName: 'pickleball',
  icon: [576, 512, [], "e435", ["M432 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM352 384a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm96 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-80-80a16 16 0 1 1 0-32 16 16 0 1 1 0 32z", "M386.3 28c-37.5-37.4-98.4-37.4-136 0L84.9 193c-18.4 18.3-23.8 45.8-13.9 69.7l24.2 57.9c10 23.9 4.5 51.5-13.9 69.8L27.8 443.8c-15.6 15.6-15.7 40.9 0 56.5s41 15.6 56.7 0l53.8-53.6c18.3-18.2 45.7-23.7 69.6-13.9l56.7 23.2c8.7 3.6 17.9 5.1 26.9 4.7C279.1 437.9 272 411.8 272 384c0-3.3 .1-6.5 .3-9.8L133.1 235.5c-6.3-6.2-6.3-16.4 0-22.6s16.4-6.3 22.6 0L279.3 336.1C299.7 271.1 360.3 224 432 224c32.1 0 62 9.4 87 25.7c16.7-35.5 10.3-79.1-19.1-108.4L386.3 28z"]]
};
var faStarSharpHalf = {
  prefix: 'fad',
  iconName: 'star-sharp-half',
  icon: [576, 512, [], "e28c", ["M321.6 50.4l40 125.6H485.7 488h13.3H520c10.3 0 19.4 6.5 22.7 16.2s.1 20.4-8 26.7L520 230.4l-10.5 8.2-1.8 1.4L403.9 320.7l40.1 126 1.1 3.5 4.7 14.8 5 15.7c3.2 10-.5 21-9.1 27s-20.2 5.7-28.5-.7l-13-10.1L392 487.3l-2.9-2.3L288 406.4V325.3 155.9 0c10.5 0 19.7 6.8 22.9 16.7L316 32.9l0 0 4.6 14.3 1 3.2z", "M254.4 50.4L214.5 176H90.3 88 74.7 56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L56 230.4l10.5 8.2 1.8 1.4 103.7 80.7L132 446.7l-1.1 3.5L126.1 465l-5 15.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7l13-10.1 12.3-9.5 2.9-2.3L288 406.4V325.3 155.9 0c-10.5 0-19.7 6.8-22.9 16.7L260 32.9l0 0-4.6 14.3-1 3.2z"]]
};
var faUsersSlash = {
  prefix: 'fad',
  iconName: 'users-slash',
  icon: [640, 512, [], "e073", ["M440.6 320L420 303.9c17.5-21.9 28-49.7 28-79.9c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H440.6zm-45.7-35.8L243.7 165.7C261.3 142.8 288.9 128 320 128c53 0 96 43 96 96c0 22.8-7.9 43.7-21.2 60.2zM203.1 133.9L77.5 35.5C91.9 14.1 116.3 0 144 0c44.2 0 80 35.8 80 80c0 20.8-7.9 39.7-20.9 53.9zM106.7 192h15.2l72.6 57.2c5.6 27.9 20.3 52.6 40.8 70.8c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7C0 239.8 47.8 192 106.7 192zM261.3 352h63.6L509.2 497.2c-4.4 8.8-13.4 14.8-23.9 14.8H154.7c-14.7 0-26.7-11.9-26.7-26.7C128 411.7 187.7 352 261.3 352zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faClover = {
  prefix: 'fad',
  iconName: 'clover',
  icon: [448, 512, [], "e139", ["M173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l31.9 53.2-53.2-31.9c-10.3-6.2-22-9.4-34-9.4H61.3C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l7.4 7.4-7.4 7.4C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l53.2-31.9-31.9 53.2c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l7.4-7.4 7.4 7.4c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-31.9-53.2 53.2 31.9c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-7.4-7.4 7.4-7.4c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3h-4.9c-12 0-23.7 3.3-34 9.4l-53.2 31.9 31.9-53.2c6.2-10.3 9.4-22 9.4-34V93.3C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9L224 57.4l-7.4-7.4C205.1 38.5 189.5 32 173.3 32z", ""]]
};
var faMeat = {
  prefix: 'fad',
  iconName: 'meat',
  icon: [512, 512, [127830], "f814", ["M343.9 168.1c-15.3-15.3-20.4-34.9-11.5-43.8s28.5-3.7 43.8 11.5s20.4 34.9 11.5 43.8s-28.5 3.7-43.8-11.5zm-220 146.5l6.3-6.3c7.9 36.7 36.8 65.6 73.5 73.5l-6.3 6.3c-12.3 12.3-11.4 32.5-7.2 49.4c1.1 4.6 1.8 9.5 1.8 14.5c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c5 0 9.8 .6 14.5 1.8c16.9 4.2 37.1 5.2 49.4-7.2z", "M243.6 19.6C283.7-20.4 371.9 2.8 440.5 71.5s91.9 156.8 51.8 196.9l-40.5 40.5C403.9 357 338.7 384 270.8 384H224c-53 0-96-43-96-96V241.3c0-67.9 27-133 75-181l40.7-40.7zm64 184.8c49.6 49.6 113.3 66.4 142.2 37.4s12.2-92.6-37.4-142.2S299.1 33.2 270.2 62.2s-12.2 92.6 37.4 142.2z"]]
};
var faReply = {
  prefix: 'fad',
  iconName: 'reply',
  icon: [512, 512, [61714, "mail-reply"], "f3e5", ["M224 288V128H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224z", "M224 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 190.3 0 198.9 0 208s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V64z"]]
};
var faMailReply = faReply;
var faStarAndCrescent = {
  prefix: 'fad',
  iconName: 'star-and-crescent',
  icon: [512, 512, [9770], "f699", ["M375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z", "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33 0 64.6-6.3 93.6-17.7c7.4-2.9 11.5-10.7 9.8-18.4s-8.8-13-16.7-12.4c-4.8 .3-9.7 .5-14.6 .5c-114.9 0-208-93.1-208-208s93.1-208 208-208c4.9 0 9.8 .2 14.6 .5c7.9 .5 15-4.7 16.7-12.4s-2.4-15.5-9.8-18.4C320.6 6.3 289 0 256 0z"]]
};
var faEmptySet = {
  prefix: 'fad',
  iconName: 'empty-set',
  icon: [512, 512, [8709, 216], "f656", ["M390.2 76.6C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2l45.9-45.9C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5l45.9-45.9zM167.8 389.5l-45.9 45.9c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1l-45.9 45.9C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5z", "M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-448 448c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l448-448c12.5-12.5 32.8-12.5 45.3 0z"]]
};
var faHouseFire = {
  prefix: 'fad',
  iconName: 'house-fire',
  icon: [640, 512, [], "e50c", ["M288 352c0-.6 0-1.3 0-1.9c0-35.2 16.3-73.6 37.2-107.4c21.7-35.2 51.9-71.2 87.3-102.8c9.8-8.8 22.5-12.7 34.8-11.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h32z", "M443.7 160c3.5 0 7 1.3 9.8 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7zM481 448c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z"]]
};
var faSquareMinus = {
  prefix: 'fad',
  iconName: 'square-minus',
  icon: [448, 512, [61767, "minus-square"], "f146", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M128 256c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z"]]
};
var faMinusSquare = faSquareMinus;
var faHelicopter = {
  prefix: 'fad',
  iconName: 'helicopter',
  icon: [640, 512, [128641], "f533", ["M128 32c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64H320V64H160c-17.7 0-32-14.3-32-32zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H536.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z", "M384 384H320c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128H384h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H384zm0-64H512V288c0-53-43-96-96-96H384V320z"]]
};
var faBird = {
  prefix: 'fad',
  iconName: 'bird',
  icon: [512, 512, [], "e469", ["M162.1 407.4l48.6 91.9c6.2 11.7 20.7 16.2 32.4 10s16.2-20.7 10-32.4L221 416c-20.4-.3-40.1-3.3-58.9-8.6zm99 5.6l45.7 86.3c6.2 11.7 20.7 16.2 32.4 10s16.2-20.7 10-32.4l-40.9-77.2c-15 6.1-30.8 10.6-47.2 13.4zM448 175.5l56.2-33.7c4.8-2.9 7.8-8.1 7.8-13.7s-2.9-10.8-7.8-13.7L446.6 79.7C447.5 85 448 90.4 448 96v79.5z", "M0 188.4V192C0 315.7 100.3 416 224 416s224-100.3 224-224V96c0-53-43-96-96-96s-96 43-96 96v32c0 17.7-14.3 32-32 32H28.4C12.7 160 0 172.7 0 188.4zM352 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faCompass = {
  prefix: 'fad',
  iconName: 'compass',
  icon: [512, 512, [129517], "f14e", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4L162.4 380.6z", "M162.4 380.6l144.3-55.5c8.5-3.3 15.1-9.9 18.4-18.4l55.5-144.3c7.5-19.4-11.6-38.5-31-31L205.3 186.9c-8.5 3.3-15.1 9.9-18.4 18.4L131.4 349.6c-7.5 19.4 11.6 38.5 31 31zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faSquareCaretDown = {
  prefix: 'fad',
  iconName: 'square-caret-down',
  icon: [448, 512, ["caret-square-down"], "f150", ["M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zM224 352c6.7 0 13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H120c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7z", "M241.6 344.3c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4H328c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112z"]]
};
var faCaretSquareDown = faSquareCaretDown;
var faHeartHalfStroke = {
  prefix: 'fad',
  iconName: 'heart-half-stroke',
  icon: [512, 512, ["heart-half-alt"], "e1ac", ["M256 480c10.3 0 20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96v90.5l45.3-45.3 12-12c18-18 43.6-26.2 68.8-22c38.1 6.3 66 39.3 66 77.9v5.8c0 23.8-9.9 46.5-27.3 62.7L256 407.4V480z", "M256 96L244 84l0 0c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9l0-50.7 0-265.4V96z"]]
};
var faHeartHalfAlt = faHeartHalfStroke;
var faFileCircleQuestion = {
  prefix: 'fad',
  iconName: 'file-circle-question',
  icon: [576, 512, [], "e4ef", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-94.4c0-23 18.6-41.6 41.6-41.6h40.5c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6L448 378.9V384c0 8.8-7.2 16-16 16s-16-7.2-16-16V369.2c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9H409.6c-5.3 0-9.6 4.3-9.6 9.6l0 6.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-6.4z"]]
};
var faLaptopCode = {
  prefix: 'fad',
  iconName: 'laptop-code',
  icon: [640, 512, [], "f5fc", ["M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z", "M512 96H128V352H512V96zM281 193l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 159l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]]
};
var faJoystick = {
  prefix: 'fad',
  iconName: 'joystick',
  icon: [448, 512, [128377], "f8c5", ["M192 352V219.4c10.1 3 20.9 4.6 32 4.6s21.9-1.6 32-4.6V352H192zM64 352c0-17.7 14.3-32 32-32s32 14.3 32 32H64z", "M336 112a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM176 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H64z"]]
};
var faGrillFire = {
  prefix: 'fad',
  iconName: 'grill-fire',
  icon: [576, 512, [], "e5a4", ["M40 32C17.9 32 0 49.9 0 72V96c0 89.8 52.9 167.3 129.2 203l-23.1 53.8c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64h75.5c-5.5-15.3-9.1-31.4-10.7-48h-73l22.9-53.4c15.9 3.6 32.3 5.4 49.3 5.4c1.2 0 2.4 0 3.6 0c5.9-26.2 18.6-52.9 33.6-77.3c21.7-35.2 51.9-71.2 87.3-102.8C366.2 124 393.3 124 411 140c9 8.1 17.7 16.4 26.2 25.1c7-21.8 10.9-45 10.9-69.1V72c0-22.1-17.9-40-40-40H40zM72 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M379.7 160c3.5 0 7 1.3 9.8 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C576 440 504.7 512 416 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7zM417 448c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z"]]
};
var faRectangleVerticalHistory = {
  prefix: 'fad',
  iconName: 'rectangle-vertical-history',
  icon: [576, 512, [], "e237", ["M120 48c-13.3 0-24 10.7-24 24V440c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-13.3-10.7-24-24-24zM24 96C10.7 96 0 106.7 0 120V392c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24z", "M192 64c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64z"]]
};
var faSwatchbook = {
  prefix: 'fad',
  iconName: 'swatchbook',
  icon: [512, 512, [], "f5c3", ["M64 64v64h64V64H64zM173.1 473.1c5.9-3.7 11.4-8.1 16.5-13.2L435.2 214.4c12.5-12.5 12.5-32.8 0-45.3L344.7 78.6c-12.5-12.5-32.8-12.5-45.3 0L192 186V416c0 19.9-6 38.4-16.4 53.7c-.8 1.2-1.6 2.3-2.5 3.5zM480 512c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H374.8l-192 192L480 512zM128 192H64v64h64V192z", "M32 0C14.3 0 0 14.3 0 32V416c0 53 43 96 96 96s96-43 96-96V32c0-17.7-14.3-32-32-32H32zm96 64v64H64V64h64zM64 192h64v64H64V192zM96 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faPrescriptionBottle = {
  prefix: 'fad',
  iconName: 'prescription-bottle',
  icon: [384, 512, [], "f485", ["M352 96H32v96H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v32c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V96z", "M32 0C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96H352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM144 192H32v32H144c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 96H32v32H144c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 96H32v32H144c8.8 0 16-7.2 16-16s-7.2-16-16-16z"]]
};
var faBars = {
  prefix: 'fad',
  iconName: 'bars',
  icon: [448, 512, ["navicon"], "f0c9", ["M0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M448 96c0-17.7-14.3-32-32-32H32C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32zm0 320c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"]]
};
var faNavicon = faBars;
var faKeyboardLeft = {
  prefix: 'fad',
  iconName: 'keyboard-left',
  icon: [640, 512, [], "e1c3", ["M224 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H224zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM224 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM320 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336zM432 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM416 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V240zM528 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM512 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z", "M240 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm0 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM224 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336zM336 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM320 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V240zM432 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM416 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V240zM528 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM512 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM113.2 153.8c9 3.7 14.8 12.5 14.8 22.2V336c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L7 273c-9.4-9.4-9.4-24.6 0-33.9l80-80c6.9-6.9 17.2-8.9 26.2-5.2z"]]
};
var faPeopleGroup = {
  prefix: 'fad',
  iconName: 'people-group',
  icon: [640, 512, [], "e533", ["M128 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM48 304c0-16.2 6-31.1 16-42.3v84.7C54 335 48 320.2 48 304zm112 0c0-37.8 14.6-72.2 38.4-97.9c-16.1-9-34.7-14.1-54.4-14.1H112C50.1 192 0 242.1 0 304c0 44.7 26.2 83.2 64 101.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V405.2 394.5c-20-24.7-32-56.2-32-90.5zM448 405.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V405.2c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H496c-19.7 0-38.3 5.1-54.4 14.1C465.4 231.8 480 266.2 480 304c0 34.3-12 65.8-32 90.5v10.7zM512 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm80 144c0 16.2-6 31-16 42.3V261.7c10 11.3 16 26.1 16 42.3z", "M384 96A64 64 0 1 0 256 96a64 64 0 1 0 128 0zM256 261.7v84.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3zm128 84.7V261.7c10 11.3 16 26.1 16 42.3s-6 31-16 42.3zm0 58.9c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H304c-61.9 0-112 50.1-112 112c0 44.7 26.2 83.2 64 101.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V405.2z"]]
};
var faHourglassEnd = {
  prefix: 'fad',
  iconName: 'hourglass-end',
  icon: [384, 512, [8987, "hourglass-3"], "f253", ["M32 75V64H96V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64h64V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11H32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1l22.6-22.6L78.9 188.1C48.9 158.1 32 117.4 32 75z", "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 64 0 49.7 0 32zM0 480c0-17.7 14.3-32 32-32l64 0V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9v11l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
};
var faHourglass3 = faHourglassEnd;
var faHeartCrack = {
  prefix: 'fad',
  iconName: 'heart-crack',
  icon: [512, 512, [128148, "heart-broken"], "f7a9", ["M119.4 44.1c23.3-3.9 46.8-1.9 68.5 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.7c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z", "M296.8 61.7C286.4 67.8 276.7 75.3 268 84L256 96 244 84c-16-16-35.2-27.7-56-34.6l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.7z"]]
};
var faHeartBroken = faHeartCrack;
var faFaceBeamHandOverMouth = {
  prefix: 'fad',
  iconName: 'face-beam-hand-over-mouth',
  icon: [512, 512, [129325], "e47c", ["M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L207 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V384v32.8c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM217.6 212.8l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 172.4 120 190.1 120 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 172.4 280 190.1 280 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z", "M217.6 212.8l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 172.4 120 190.1 120 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm81.7 86.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7V330.4c0-11-9-20-20-20s-20 9-20 20V384v32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3zm78.3-86.5l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 172.4 280 190.1 280 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]]
};
var faDropletPercent = {
  prefix: 'fad',
  iconName: 'droplet-percent',
  icon: [384, 512, ["humidity"], "f750", ["M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zm75.3-267.3c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6zM136 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M267.3 267.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM160 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]]
};
var faHumidity = faDropletPercent;
var faSquareUpRight = {
  prefix: 'fad',
  iconName: 'square-up-right',
  icon: [448, 512, [8599, "external-link-square-alt"], "f360", ["M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM320 313.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z", "M320 176V313.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6L248 296l-66.3 66.3C178 366 173.1 368 168 368s-10-2-13.7-5.7l-36.7-36.7C114 322 112 317.1 112 312s2-10 5.7-13.7L184 232l-33.4-33.4c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H304c8.8 0 16 7.2 16 16z"]]
};
var faExternalLinkSquareAlt = faSquareUpRight;
var faFaceKissBeam = {
  prefix: 'fad',
  iconName: 'face-kiss-beam',
  icon: [512, 512, [128537, "kiss-beam"], "f597", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z", "M217.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]]
};
var faKissBeam = faFaceKissBeam;
var faCorn = {
  prefix: 'fad',
  iconName: 'corn',
  icon: [512, 512, [127805], "f6c7", ["M491.5 74.9C503.7 68.1 512 55 512 40c0-22.1-17.9-40-40-40c-15 0-28.1 8.3-34.9 20.5C429.8 12.8 419.4 8 408 8c-18 0-33.2 11.8-38.2 28.2C364.4 33.5 358.4 32 352 32c-18 0-33.2 11.8-38.2 28.2C308.4 57.5 302.4 56 296 56c-22.1 0-40 17.9-40 40c0 1.1 0 2.3 .1 3.4C251.2 97.2 245.7 96 240 96c-13.6 0-25.7 6.8-32.9 17.3c29.7 47.7 41.1 103.6 34.2 157.5c53.9-6.9 109.8 4.5 157.5 34.2c10.4-7.2 17.3-19.3 17.3-32.9c0-5.7-1.2-11.2-3.4-16.1c1.1 .1 2.2 .1 3.4 .1c22.1 0 40-17.9 40-40c0-6.4-1.5-12.4-4.2-17.8c16.3-5 28.2-20.2 28.2-38.2c0-6.4-1.5-12.4-4.2-17.8c16.3-5 28.2-20.2 28.2-38.2c0-11.4-4.8-21.8-12.5-29.1z", "M150.9 94.1c-4.3-4.8-12.1-2.4-13.2 3.9l-10.2 54.9c-4.7 25.4-17 48.8-35.3 67.1l-64 64c-36.4 36.4-37.5 94.7-3.2 132.4l77.4-77.4c30.4-30.4 66.9-50.9 105.5-61.6c12.6-69.3-11.5-132.9-56.9-183.4zM47.4 439.2l44.7 44.7c37.5 37.5 98.3 37.5 135.8 0l64-64c18.3-18.3 41.7-30.6 67.1-35.3L414 374.3c6.3-1.2 8.7-8.9 3.9-13.2c-53-47.6-120.7-71.6-192.8-55c-36.7 8.5-71.5 27-100.1 55.6L47.4 439.2z"]]
};
var faRollerCoaster = {
  prefix: 'fad',
  iconName: 'roller-coaster',
  icon: [640, 512, [], "e324", ["M200 105.9c14 7 26.2 17.4 35.3 30.5L248 154.7V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V105.9zm96 117.9l48 69.1V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.8zm96 128.2c14.2 11.5 30.5 20.2 48 25.6V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V351.9zM488 384h8c13.9 0 27.3-2 40-5.6V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V384zM104 113.1c13.7-9.7 30.2-15.8 48-16.9V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.1z", "M158.1 96c-52 0-94.1 42.1-94.1 94.1V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V190.1C0 102.8 70.8 32 158.1 32c51.8 0 100.3 25.4 129.8 67.9l129 185.7c15 21.5 39.5 34.4 65.7 34.4H496c44.2 0 80-35.8 80-80c0-32.8-19.7-61-48-73.3V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V160.6c-14.2 1.5-28 5.8-40.7 12.5l-7.3 3.9v74.2L357.6 144.2l51.6-27.5C434.7 103.1 463.1 96 492 96h4c79.5 0 144 64.5 144 144c0 2.7-.1 5.4-.2 8h.2V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V359.8c-22.9 15.3-50.4 24.2-80 24.2H482.6c-47.2 0-91.4-23.1-118.3-61.9l-129-185.7C217.7 111.1 188.9 96 158.1 96z"]]
};
var faPhotoFilmMusic = {
  prefix: 'fad',
  iconName: 'photo-film-music',
  icon: [640, 512, [], "e228", ["M160 96H64C28.7 96 0 124.7 0 160V384c0 35.3 28.7 64 64 64H289.9c4.4-18.2 15.9-33.1 29.6-43.4c6.8-5.1 14.5-9.4 22.6-12.6H192c-17.7 0-32-14.3-32-32V96zM56 168c0-8.8 7.2-16 16-16H88c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H72c-8.8 0-16-7.2-16-16V168zm16 80H88c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H72c-8.8 0-16-7.2-16-16V264c0-8.8 7.2-16 16-16zM56 360c0-8.8 7.2-16 16-16H88c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H72c-8.8 0-16-7.2-16-16V360zM640 184c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-192 64c-9.8 3.3-16.4 12.4-16.4 22.8v48V417.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48V313.3l144-48v88.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.5-.1-3-.3-4.4c.2-1.2 .3-2.4 .3-3.6V232 184zM461.6 103.5c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5L388 177.9l-15.3-19.7c-3-3.9-7.7-6.2-12.6-6.2s-9.6 2.3-12.6 6.2l-56 72c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9h64l0-7.9c0-24.1 15.4-45.5 38.3-53.1l93.1-31-37.8-60.5z", "M192 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64v69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-98.9 33-37.8-60.5c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5L388 177.9l-15.3-19.7c-3-3.9-7.7-6.2-12.6-6.2s-9.6 2.3-12.6 6.2l-56 72c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9h64v64H256c-35.3 0-64-28.7-64-64V64zM320 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
};
var faRadar = {
  prefix: 'fad',
  iconName: 'radar',
  icon: [512, 512, [], "e024", ["M350.9 127.2l-46.1 46.1c-14.3-8.4-31-13.3-48.8-13.3c-53 0-96 43-96 96s43 96 96 96s96-43 96-96h64c0 73.5-49.6 135.5-117.2 154.2C290.8 394.7 274.7 384 256 384s-34.8 10.7-42.8 26.2c-51.7-14.3-92.8-53.9-109.4-104.6c14.4-8.3 24.1-23.8 24.1-41.7c0-19.4-11.5-36.1-28-43.7C116.2 149.1 179.9 96 256 96c35.5 0 68.3 11.6 94.9 31.2zm22.8-22.8C341.2 79 300.4 64 256 64C163.1 64 85.7 129.9 67.9 217.6C47.2 222.9 32 241.7 32 264c0 23.8 17.3 43.6 40.1 47.4c19.3 64.3 71.5 114.4 137 130.9C213.8 463.8 233 480 256 480s42.2-16.2 46.9-37.8C386.3 421.3 448 345.9 448 256h64c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8l-45.5 45.5z", "M497 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-182 182c-7.7-3.3-16.1-5.1-25-5.1c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-8.9-1.8-17.3-5.1-25L497 49z"]]
};
var faSickle = {
  prefix: 'fad',
  iconName: 'sickle',
  icon: [512, 512, [], "f822", ["M128 181c0 38 11.9 74.7 33.7 105.2L137 311l16 16 32 32 16 16 23-23 24.5-24.5c4.5-4.5 5.9-11.3 3.7-17.3c-7-18.9-12.2-37.9-12.2-58.6v-9.8C240 165.7 301.7 104 377.8 104c41.7 0 81 18.9 107.1 51.1c2.4 3 6.1 4.9 9.9 4.9c7.6 0 13.3-6.8 11.5-14.2C485.8 62.1 410.1 0 320 0H309C209 0 128 81 128 181z", "M129 303c-9.4-9.4-24.6-9.4-33.9 0L79 319c-9.4 9.4-9.4 24.6 0 33.9l7 7L7 439c-9.4 9.4-9.4 24.6 0 33.9l32 32c9.4 9.4 24.6 9.4 33.9 0l79-79 7 7c9.4 9.4 24.6 9.4 33.9 0l16-16c9.4-9.4 9.4-24.6 0-33.9l-24-24-32-32-24-24z"]]
};
var faFilm = {
  prefix: 'fad',
  iconName: 'film',
  icon: [512, 512, [127902], "f008", ["M192 96c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192zm0 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"]]
};
var faCoconut = {
  prefix: 'fad',
  iconName: 'coconut',
  icon: [512, 512, [], "e2f6", ["M256 256c62.5-62.5 92.9-133.4 67.9-158.4s-95.9 5.4-158.4 67.9S72.6 298.9 97.6 323.9s95.9-5.4 158.4-67.9z", "M274.5 55.3c42.7-13.2 71.9-7.4 86.7 7.5s20.6 44 7.5 86.7c-12.8 41.5-42.1 89.6-85.8 133.3s-91.8 73-133.3 85.8c-42.7 13.2-71.9 7.4-86.7-7.5s-20.6-44-7.5-86.7c12.8-41.5 42.1-89.6 85.8-133.3s91.8-73 133.3-85.8zM395.2 28.8C361.5-4.8 309.6-5.7 260.4 9.5C210 25 155.3 59.1 107.2 107.2S25 209.9 9.5 260.3C-5.7 309.6-4.8 361.5 28.9 395.2l41 41C118.4 484.7 184.3 512 253 512c143.1 0 259-116 259-259c0-68.7-27.3-134.6-75.9-183.2L395.2 28.8zm24.1 175.8l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-56 136l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-136 56l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]]
};
var faRulerHorizontal = {
  prefix: 'fad',
  iconName: 'ruler-horizontal',
  icon: [640, 512, [], "f547", ["M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z", "M144 208l0-80H112v80c0 8.8 7.2 16 16 16s16-7.2 16-16zm96-80H208v80c0 8.8 7.2 16 16 16s16-7.2 16-16V128zm96 80V128H304v80c0 8.8 7.2 16 16 16s16-7.2 16-16zm96-80H400v80c0 8.8 7.2 16 16 16s16-7.2 16-16V128zm96 0H496v80c0 8.8 7.2 16 16 16s16-7.2 16-16V128z"]]
};
var faShieldCross = {
  prefix: 'fad',
  iconName: 'shield-cross',
  icon: [512, 512, [9960], "f712", ["M224 10.8L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c0 6.4 .2 13 .6 20H192c17.7 0 32-14.3 32-32V10.8zM24.7 224C43.7 319.9 97.4 437.2 224 500.4V256c0-17.7-14.3-32-32-32H24.7zM288 500.4C414.6 437.2 468.3 319.9 487.3 224H320c-17.7 0-32 14.3-32 32V500.4zM495.4 160c.4-7 .6-13.7 .6-20c.1-26.2-16.3-47.9-38.3-57.2L288 10.8V128c0 17.7 14.3 32 32 32H495.4z", "M288 10.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L224 10.8V128c0 17.7-14.3 32-32 32H16.6c1.1 19.4 3.6 41.1 8.1 64H192c17.7 0 32 14.3 32 32V500.4c1.9 .9 3.7 1.8 5.6 2.7c16.7 8 36.1 8 52.8 0c1.9-.9 3.8-1.8 5.6-2.7V256c0-17.7 14.3-32 32-32H487.3c4.5-22.9 7.1-44.6 8.1-64H320c-17.7 0-32-14.3-32-32V10.8z"]]
};
var faCassetteTape = {
  prefix: 'fad',
  iconName: 'cassette-tape',
  icon: [576, 512, [128429], "f8ab", ["M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H483.1l-36.3-96.9c-7-18.7-24.9-31.1-44.9-31.1H174.2c-20 0-37.9 12.4-44.9 31.1L92.9 480H64c-35.3 0-64-28.7-64-64V96zM416.8 394.4L448.9 480H127.1l32.1-85.6c2.3-6.2 8.3-10.4 15-10.4H401.8c6.7 0 12.6 4.1 15 10.4zM160 128c-44.2 0-80 35.8-80 80s35.8 80 80 80H416c44.2 0 80-35.8 80-80s-35.8-80-80-80H160z", "M240 208c0 11.4-2.4 22.2-6.7 32H342.7c-4.3-9.8-6.7-20.6-6.7-32s2.4-22.2 6.7-32H233.3c4.3 9.8 6.7 20.6 6.7 32zm176 80H160c-44.2 0-80-35.8-80-80s35.8-80 80-80H416c44.2 0 80 35.8 80 80s-35.8 80-80 80zM160 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm272-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
};
var faSquareTerminal = {
  prefix: 'fad',
  iconName: 'square-terminal',
  icon: [448, 512, [], "e32a", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm70.3 55.8c-9 9.8-8.3 25 1.5 33.9L148.5 256 71.8 326.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z", "M71.8 185.7c-9.8-9-10.4-24.1-1.5-33.9s24.1-10.4 33.9-1.5l96 88c5 4.5 7.8 11 7.8 17.7s-2.8 13.1-7.8 17.7l-96 88c-9.8 9-25 8.3-33.9-1.5s-8.3-25 1.5-33.9L148.5 256 71.8 185.7zM216 336H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faPeopleRobbery = {
  prefix: 'fad',
  iconName: 'people-robbery',
  icon: [576, 512, [], "e536", ["M400 128c41.7 0 78.1-28.4 88.2-68.9L497 24.2C501.2 7.1 518.6-3.3 535.8 1s27.6 21.7 23.3 38.8l-8.7 34.9c-11 44-40.2 79.6-78.3 99.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H392V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V174.3c-38.1-20-67.3-55.7-78.3-99.6L241 39.8C236.7 22.6 247.1 5.2 264.2 1s34.5 6.1 38.8 23.3l8.7 34.9C321.9 99.6 358.3 128 400 128zM352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z", "M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM8 192c0-35.3 28.7-64 64-64h32.7c27.4 0 52.9 14 67.5 37.1L209.6 224H240c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-11 0-21.1-5.6-27-14.9l-13-20.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H72V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V288.6l0-.6V192z"]]
};
var faLightbulb = {
  prefix: 'fad',
  iconName: 'lightbulb',
  icon: [384, 512, [128161], "f0eb", ["M321.2 297.8c-19.8 27.1-39.7 54.4-49.2 86.2H112c-9.6-31.9-29.5-59.1-49.2-86.2c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4zM112 176c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C130.1 64 80 114.1 80 176c0 8.8 7.2 16 16 16s16-7.2 16-16z", "M192 512c44.2 0 80-35.8 80-80V384H112v48c0 44.2 35.8 80 80 80z"]]
};
var faCaretLeft = {
  prefix: 'fad',
  iconName: 'caret-left',
  icon: [256, 512, [], "f0d9", ["M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z", ""]]
};
var faCommentMiddle = {
  prefix: 'fad',
  iconName: 'comment-middle',
  icon: [512, 512, [], "e149", ["M188.3 408.7l44.5 89c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3l44.5-89C432.2 384.5 512 303.8 512 208C512 93.1 397.4 0 256 0S0 93.1 0 208c0 95.8 79.8 176.5 188.3 200.7z", ""]]
};
var faTrashCanList = {
  prefix: 'fad',
  iconName: 'trash-can-list',
  icon: [640, 512, [], "e2ab", ["M384 96H32V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96zM160 192V416c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm128 0V416c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M119.2 17.7C124.6 6.8 135.7 0 147.8 0H268.2c12.1 0 23.2 6.8 28.6 17.7L304 32h80c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h80l7.2-14.3zM480 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-17.7 0-32-14.3-32-32s14.3-32 32-32zM448 416c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-17.7 0-32-14.3-32-32z"]]
};
var faBlock = {
  prefix: 'fad',
  iconName: 'block',
  icon: [448, 512, [], "e46a", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM96 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M72 128a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm304 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM96 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faCircleExclamation = {
  prefix: 'fad',
  iconName: 'circle-exclamation',
  icon: [512, 512, ["exclamation-circle"], "f06a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faExclamationCircle = faCircleExclamation;
var faSchoolCircleXmark = {
  prefix: 'fad',
  iconName: 'school-circle-xmark',
  icon: [640, 512, [], "e56d", ["M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V266.8C608.1 221.6 555.5 192 496 192c-38.5 0-74.2 12.4-103.1 33.4c9.6-14.1 15.1-31.1 15.1-49.4c0-48.6-39.4-88-88-88s-88 39.4-88 88s39.4 88 88 88c15.6 0 30.2-4 42.9-11.1c-23.4 27.1-38.8 61.4-42.2 99.1h-.5l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM336 144v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faArrowRightFromBracket = {
  prefix: 'fad',
  iconName: 'arrow-right-from-bracket',
  icon: [512, 512, ["sign-out"], "f08b", ["M192 64c0 17.7-14.3 32-32 32L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32z", "M502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 288 192 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l210.7 0-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z"]]
};
var faSignOut = faArrowRightFromBracket;
var faFaceFrownSlight = {
  prefix: 'fad',
  iconName: 'face-frown-slight',
  icon: [512, 512, [], "e376", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm91.9-117.5C330 373.8 299.4 352 256 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faCircleChevronDown = {
  prefix: 'fad',
  iconName: 'circle-chevron-down',
  icon: [512, 512, ["chevron-circle-down"], "f13a", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM377 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87-87-87c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 345c9.4 9.4 24.6 9.4 33.9 0L377 241z", "M239 345c9.4 9.4 24.6 9.4 33.9 0L377 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87-87-87c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 345z"]]
};
var faChevronCircleDown = faCircleChevronDown;
var faSidebarFlip = {
  prefix: 'fad',
  iconName: 'sidebar-flip',
  icon: [512, 512, [], "e24f", ["M0 96C0 60.7 28.7 32 64 32H288V480H64c-35.3 0-64-28.7-64-64V96z", "M448 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H288V32H448zM424 96H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24zm-24 72H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]]
};
var faUnlockKeyhole = {
  prefix: 'fad',
  iconName: 'unlock-keyhole',
  icon: [448, 512, ["unlock-alt"], "f13e", ["M224 64c-44.2 0-80 35.8-80 80v48H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64z", "M64 192c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H64zM256 384H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32z"]]
};
var faUnlockAlt = faUnlockKeyhole;
var faTemperatureList = {
  prefix: 'fad',
  iconName: 'temperature-list',
  icon: [512, 512, [], "e299", ["M144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M320 64c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-17.7 0-32-14.3-32-32zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V176c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3zM352 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32z"]]
};
var faCloudShowersHeavy = {
  prefix: 'fad',
  iconName: 'cloud-showers-heavy',
  icon: [512, 512, [], "f740", ["M94.1 385.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112zm120 0c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112zm219.4-31.5c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zM326.1 385.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112z", "M0 224c0 53 43 96 96 96H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z"]]
};
var faHeadphonesSimple = {
  prefix: 'fad',
  iconName: 'headphones-simple',
  icon: [512, 512, ["headphones-alt"], "f58f", ["M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208z", "M144 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h16c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H144zm224 0H352c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32h16c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64z"]]
};
var faHeadphonesAlt = faHeadphonesSimple;
var faSitemap = {
  prefix: 'fad',
  iconName: 'sitemap',
  icon: [576, 512, [], "f0e8", ["M264 280v40h48V280H464c4.4 0 8 3.6 8 8v32h48V288c0-30.9-25.1-56-56-56H312V192H264v40H112c-30.9 0-56 25.1-56 56v32h48V288c0-4.4 3.6-8 8-8H264z", "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V80zM48 320h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm208 0h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm208 0h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48z"]]
};
var faPipeSection = {
  prefix: 'fad',
  iconName: 'pipe-section',
  icon: [640, 512, [], "e438", ["M576 128H64V384H576V128z", "M64 128c0-17.7-14.3-32-32-32S0 110.3 0 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm576 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128z"]]
};
var faSpaceStationMoonConstruction = {
  prefix: 'fad',
  iconName: 'space-station-moon-construction',
  icon: [512, 512, ["space-station-moon-alt"], "e034", ["M511 279.1c.7-7.6 1-15.3 1-23.1c0-10.8-.7-21.5-2-32H448V160H368V96h48V56.1C372.2 21 316.5 0 256 0C114.6 0 0 114.6 0 256c0 7.8 .3 15.5 1 23.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9zM6.8 314.8C33.4 427.9 134.9 512 256 512c76.5 0 145.1-33.5 192-86.7V384H384V342.8c-40.7 6-83.7 9.2-128 9.2c-91.3 0-176.6-13.6-249.2-37.2zM112 160a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M224 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM6.8 314.8C4.1 303.2 2.1 291.3 1 279.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9c-1.1 12.2-3 24.1-5.8 35.8C432.6 338.4 347.3 352 256 352s-176.6-13.6-249.2-37.2z"]]
};
var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
var faCircleDollarToSlot = {
  prefix: 'fad',
  iconName: 'circle-dollar-to-slot',
  icon: [512, 512, ["donate"], "f4b9", ["M256 416A208 208 0 1 0 256 0a208 208 0 1 0 0 416zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V312c0 11-9 20-20 20s-20-9-20-20V297.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V104c0-11 9-20 20-20s20 9 20 20z", "M276 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104zM64 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H448c-19.4 25.9-44 47.7-72.2 64H448v32H256 64V416h72.2C108 399.7 83.4 377.9 64 352z"]]
};
var faDonate = faCircleDollarToSlot;
var faMemory = {
  prefix: 'fad',
  iconName: 'memory',
  icon: [576, 512, [], "f538", ["M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320H576V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zm128 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z", "M192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zM0 416V320H576v96c0 17.7-14.3 32-32 32H496V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H368V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H240V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H112V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H32c-17.7 0-32-14.3-32-32z"]]
};
var faFaceSleeping = {
  prefix: 'fad',
  iconName: 'face-sleeping',
  icon: [512, 512, [], "e38d", ["M477.8 128c21.8 37.7 34.2 81.4 34.2 128c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c48.7 0 94.2 13.6 132.9 37.2c1.9 4 4.4 7.6 7.3 10.8c-12.2 13.7-15.7 33.3-8.6 50.4c7.4 17.9 24.9 29.6 44.3 29.6h45.8zM256 80c0 8.8 7.2 16 16 16h25.4l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H310.6l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H272c-8.8 0-16 7.2-16 16zm0 344a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm60.8-185.6c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0zm-121.6 0c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2z", "M416 16c0 8.8 7.2 16 16 16h25.4L420.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H470.6l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0H432c-8.8 0-16 7.2-16 16zM256 80c0 8.8 7.2 16 16 16h25.4l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H310.6l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H272c-8.8 0-16 7.2-16 16zM387.2 238.4c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zm-262.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0z"]]
};
var faRoadSpikes = {
  prefix: 'fad',
  iconName: 'road-spikes',
  icon: [640, 512, [], "e568", ["M416 246.9V114.8c0-15.6 20.1-22 29.1-9.2L581.8 300.8C598.8 325.2 608 354.2 608 384H450.5 416 322.5 288 194.5 160 32V114.8c0-15.6 20.1-22 29.1-9.2L160 246.9V114.8c0-15.6 20.1-22 29.1-9.2L288 246.9V114.8c0-15.6 20.1-22 29.1-9.2L416 246.9z", "M0 416c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
};
var faFireBurner = {
  prefix: 'fad',
  iconName: 'fire-burner',
  icon: [640, 512, [], "e4f1", ["M321 288c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96c-15 10-31 15-49 15zM32 280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H80v80H560V304H536c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24V384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V280zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M283.7 0c3.5 0 7 1.3 9.8 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7zM321 288c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z"]]
};
var faSquirrel = {
  prefix: 'fad',
  iconName: 'squirrel',
  icon: [512, 512, [], "f71a", ["M158 301.7c-18.7 22.3-30 51-30 82.3c0 70.7 57.3 128 128 128h49.1C242.7 512 192 461.3 192 398.9v-3.8c0-27.6 11-54.1 30.5-73.6l7-7c24-24 43.7-51.6 58.5-81.6V144C288 64.5 223.5 0 144 0S0 64.5 0 144s64.5 144 144 144c2.3 0 4.6-.1 6.9-.2c4.9-.2 9.1 3.5 9.1 8.4c0 2-.7 3.9-2 5.4z", "M320 75.2C320 69 325 64 331.2 64c15.2 0 28.7 7.6 36.8 19.2C376.1 71.6 389.6 64 404.8 64C411 64 416 69 416 75.2V96c53 0 96 43 96 96l-8.2 12.4c-14.8 22.3-39.8 35.6-66.6 35.6H416v58.8c-14.5-6.9-30.8-10.8-48-10.8c-13.1 0-25.6 2.2-37.3 6.4c-8.3 2.9-12.7 12.1-9.8 20.4s12.1 12.7 20.4 9.8c8.3-2.9 17.3-4.5 26.7-4.5c18 0 34.6 6 48 16c19.4 14.6 32 37.8 32 64c0 18-6 34.6-16 48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H376 352 320 305.1 304v0c-62-.6-112-51-112-113.1v-3.8c0-27.6 11-54.1 30.5-73.6l7-7C287.4 256.6 320 178 320 96V75.2zM416 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faArrowUpToLine = {
  prefix: 'fad',
  iconName: 'arrow-up-to-line',
  icon: [384, 512, ["arrow-to-top"], "f341", ["M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64z", "M169.4 169.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 269.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V269.3L86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z"]]
};
var faArrowToTop = faArrowUpToLine;
var faFlag = {
  prefix: 'fad',
  iconName: 'flag',
  icon: [448, 512, [127988, 61725], "f024", ["M64 352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V352z", "M32 0C49.7 0 64 14.3 64 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32C0 14.3 14.3 0 32 0z"]]
};
var faFaceCowboyHat = {
  prefix: 'fad',
  iconName: 'face-cowboy-hat',
  icon: [512, 512, [], "e36e", ["M48 304c0-49.4 17.2-94.7 45.9-130.4C136.6 204.9 193.5 224 256 224s119.4-19.1 162.1-50.4c28.7 35.7 45.9 81 45.9 130.4c0 114.9-93.1 208-208 208S48 418.9 48 304zm299.8 60.7c-27.9 7.8-59 12.1-91.6 12.1s-63.7-4.3-91.6-12.1c-12.4-3.5-24.3 7.3-18.6 18.8C166.2 424.1 208 452 256.2 452s90-27.9 110.2-68.6c5.7-11.5-6.2-22.2-18.6-18.8zM216 296a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M133.6 109.8C148.6 64.9 179.2 0 216 0c9.1 0 17.9 4 26.1 10.7c7.9 6.5 19.8 6.5 27.7 0C278.1 4 286.9 0 296 0c36.8 0 67.4 64.9 82.4 109.8C412 99.3 442 84.6 466.9 66.8c2.5-1.8 5.4-2.8 8.4-2.8c8.9 0 15.6 8.3 12.9 16.7C461.2 163.2 367.5 224 256 224S50.8 163.2 23.8 80.7C21 72.3 27.7 64 36.7 64c3 0 6 1 8.4 2.8C70 84.6 100 99.3 133.6 109.8zM168 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faHanukiah = {
  prefix: 'fad',
  iconName: 'hanukiah',
  icon: [640, 512, [128334], "f6e6", ["M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104z", "M352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144zM128 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v96 16h32V272 176zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96 16h32V272 176zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96 16h32V272 176zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96 16h32V272 176zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96 16h32V272 176zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96 16h32V272 176z"]]
};
var faChartScatter3d = {
  prefix: 'fad',
  iconName: 'chart-scatter-3d',
  icon: [512, 512, [], "e0e8", ["M256 32c17.7 0 32 14.3 32 32V273L468.5 423.4c13.6 11.3 15.4 31.5 4.1 45.1s-31.5 15.4-45.1 4.1L256 329.7 84.5 472.6c-13.6 11.3-33.8 9.5-45.1-4.1s-9.5-33.8 4.1-45.1L224 273V64c0-17.7 14.3-32 32-32z", "M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faDisplayChartUp = {
  prefix: 'fad',
  iconName: 'display-chart-up',
  icon: [576, 512, [], "e5e3", ["M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z", "M64 64H512V352H64V64zM346.7 448H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416h96l10.7 32zM344 112c-13.3 0-24 10.7-24 24s10.7 24 24 24h38.1L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l71-71 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l95-95V232c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24H344z"]]
};
var faSquareCode = {
  prefix: 'fad',
  iconName: 'square-code',
  icon: [448, 512, [], "e267", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm262.2 71.9c-8.9 9.9-8.1 25 1.8 33.9L324.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L123.9 256l60.2-54.2z", "M184.1 201.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L123.9 256l60.2-54.2zm79.9 0L324.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9z"]]
};
var faFeather = {
  prefix: 'fad',
  iconName: 'feather',
  icon: [512, 512, [129718], "f52d", ["M97.9 448h84c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330v84L311 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L97.9 448z", "M24 512c-6.2 0-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9L311 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-4.7 4.7-10.8 7-17 7z"]]
};
var faVolumeLow = {
  prefix: 'fad',
  iconName: 'volume-low',
  icon: [448, 512, [128264, "volume-down"], "f027", ["M378.8 185c8.4-10.3 23.5-11.8 33.8-3.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8z", "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"]]
};
var faVolumeDown = faVolumeLow;
var faXmarkToSlot = {
  prefix: 'fad',
  iconName: 'xmark-to-slot',
  icon: [576, 512, ["times-to-slot", "vote-nay"], "f771", ["M144 32c-26.5 0-48 21.5-48 48V400H480V80c0-26.5-21.5-48-48-48H144zm63 103c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z", "M207 135c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9zM48 288H96v80H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V288h48c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48z"]]
};
var faTimesToSlot = faXmarkToSlot;
var faVoteNay = faXmarkToSlot;
var faBoxTaped = {
  prefix: 'fad',
  iconName: 'box-taped',
  icon: [448, 512, ["box-alt"], "f49a", ["M50.7 58.5C58.9 42.3 75.5 32 93.7 32H192L160 160H0L50.7 58.5zM288 160v96c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V160H288zm0 0L256 32h98.3c18.2 0 34.8 10.3 42.9 26.5L448 160H288z", "M160 160H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V160H288v96c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V160z"]]
};
var faBoxAlt = faBoxTaped;
var faCommentSlash = {
  prefix: 'fad',
  iconName: 'comment-slash',
  icon: [640, 512, [], "f4b3", ["M424.1 430.1L82.9 161.3C70.7 185.6 64 212.2 64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104.1-17.9zm88.9-53.4C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3l368 288.5z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faSwords = {
  prefix: 'fad',
  iconName: 'swords',
  icon: [512, 512, [9876], "f71d", ["M146.7 278.6L96 329.4 182.6 416l50.7-50.7-86.6-86.6zm218.5-45.3L484.5 114.2c6.7-6.7 11.3-15.2 13.1-24.5l14.1-70.5c1-5.2-.6-10.7-4.4-14.5s-9.2-5.4-14.5-4.4L422.4 14.4c-9.3 1.9-17.8 6.4-24.5 13.1L278.6 146.7l86.6 86.6zM19.1 .3C13.9-.7 8.5 .9 4.7 4.7S-.7 13.9 .3 19.1L14.4 89.6c1.9 9.3 6.4 17.8 13.1 24.5L329.4 416 416 329.4 114.2 27.5c-6.7-6.7-15.2-11.3-24.5-13.1L19.1 .3z", "M75.3 308.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-4.7 4.7-6 11.8-3.3 17.8l27.5 62L4.7 460.7c-6.2 6.2-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l56.2-56.2 62 27.5c6 2.7 13.1 1.4 17.8-3.3l16-16c6.2-6.2 6.2-16.4 0-22.6l-128-128zm361.4 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6l16 16c4.7 4.7 11.8 6 17.8 3.3l62-27.5 56.2 56.2c6.2 6.2 16.4 6.2 22.6 0l24-24c6.2-6.2 6.2-16.4 0-22.6l-56.2-56.2 27.5-62c2.7-6.1 1.4-13.1-3.3-17.8l-16-16c-6.2-6.2-16.4-6.2-22.6 0z"]]
};
var faCloudSunRain = {
  prefix: 'fad',
  iconName: 'cloud-sun-rain',
  icon: [640, 512, [127782], "f743", ["M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm76.1 309.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3zm96 0l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3zm96 0l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3zm96 0l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3z", "M559.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.3 114.6 402.8 96 368 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H559.9z"]]
};
var faAlbum = {
  prefix: 'fad',
  iconName: 'album',
  icon: [448, 512, [128189], "f89f", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z", "M224 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faCircleN = {
  prefix: 'fad',
  iconName: 'circle-n',
  icon: [512, 512, [], "e118", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM203.7 138.3L304 283.2V152c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 10.5-6.8 19.8-16.8 22.9s-20.9-.6-26.9-9.2L208 228.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.5 6.8-19.8 16.8-22.9s20.9 .6 26.9 9.2z", "M176.8 129.1c10-3.1 20.9 .6 26.9 9.2L304 283.2V152c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 10.5-6.8 19.8-16.8 22.9s-20.9-.6-26.9-9.2L208 228.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.5 6.8-19.8 16.8-22.9z"]]
};
var faCompress = {
  prefix: 'fad',
  iconName: 'compress',
  icon: [448, 512, [], "f066", ["M160 448c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32v96zM320 192c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z", "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"]]
};
var faWheatAwn = {
  prefix: 'fad',
  iconName: 'wheat-awn',
  icon: [512, 512, ["wheat-alt"], "e2cd", ["M505 7c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0zm-177.8 223L295.3 262c-16-1.6-32.2-.1-47.8 4.3c4.8-16.6 6.1-34 4-51l30.5-30.5L294.2 197l22.6 22.6 10.4 10.4zm131.6-46.9c-14.4-10.3-30.5-17.2-47.1-20.8L471 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-46.2 46.2zm-108-84c-3.9-16.4-11.1-32.2-21.6-46.3L375 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L350.7 99.2zM225.4 331.9l-31.9 31.9c-16-1.6-32.2-.1-47.8 4.3c4.8-16.6 6.1-34 4-51l30.5-30.5L215 321.5l0 0 10.4 10.4zM123.5 433.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l68.9-68.9 34.8 34.8 0 0 10.4 10.4z", "M282.8 27.3c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-22.6-22.6 0 0-45.3-45.3c-37.5-37.5-37.5-98.3 0-135.8l11.3-11.3zM203.6 129.1L215 140.5c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0L215 321.5l0 0-45.3-45.3c-37.5-37.5-37.5-98.3 0-135.8L181 129.1c6.2-6.2 16.4-6.2 22.6 0zM79.2 231c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5L282.8 412c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-22.6-22.6s0 0 0 0L67.9 378c-37.5-37.5-37.5-98.3 0-135.8L79.2 231z"]]
};
var faWheatAlt = faWheatAwn;
var faAnkh = {
  prefix: 'fad',
  iconName: 'ankh',
  icon: [320, 512, [9765], "f644", ["M192 320V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320h64z", "M160 64c-35.3 0-64 28.7-64 64c0 41.6 20.7 76.6 46.6 104.1c5.9 6.2 11.8 11.8 17.4 16.7c5.6-4.9 11.5-10.5 17.4-16.7C203.3 204.6 224 169.6 224 128c0-35.3-28.7-64-64-64zM32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 52.4-21.5 95.5-46.8 128H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H172.6 147.4 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H78.8C53.5 223.5 32 180.4 32 128z"]]
};
var faHandsHoldingChild = {
  prefix: 'fad',
  iconName: 'hands-holding-child',
  icon: [640, 512, [], "e4fa", ["M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z", "M280 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM384.5 181l-19.8-16.7L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8L266 109.2c10.1-8.5 22.9-13.2 36.2-13.2h35.6c13.2 0 26 4.7 36.2 13.2l41.5 35.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8z"]]
};
var faAsterisk = {
  prefix: 'fad',
  iconName: 'asterisk',
  icon: [384, 512, [10033, 61545], "2a", ["M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z", ""]]
};
var faKeySkeletonLeftRight = {
  prefix: 'fad',
  iconName: 'key-skeleton-left-right',
  icon: [640, 512, [], "e3b4", ["M128 448a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm0-192C57.3 256 0 313.3 0 384s57.3 128 128 128c59.6 0 109.8-40.8 124-96l196 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-32 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-68 0c-14.2-55.2-64.3-96-124-96z", "M512 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 192c70.7 0 128-57.3 128-128S582.7 0 512 0C452.4 0 402.2 40.8 388 96L192 96c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160h68c14.2 55.2 64.3 96 124 96z"]]
};
var faCommentLines = {
  prefix: 'fad',
  iconName: 'comment-lines',
  icon: [512, 512, [], "f4b0", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM152 176H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M128 200c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z"]]
};
var faLuchadorMask = {
  prefix: 'fad',
  iconName: 'luchador-mask',
  icon: [448, 512, ["luchador", "mask-luchador"], "f455", ["M144 288c-44.2 0-80-35.8-80-80c0-26.5 21.5-48 48-48h32c44.2 0 80 35.8 80 80c0-44.2 35.8-80 80-80h32c26.5 0 48 21.5 48 48c0 44.2-35.8 80-80 80H290.7c3.4 6.3 5.3 13.4 5.3 20.7c0 4-.6 7.9-1.6 11.6c32.3 3.2 57.6 30.5 57.6 63.7c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64c0-33.2 25.2-60.5 57.6-63.7c-1-3.7-1.6-7.6-1.6-11.6c0-7.3 1.8-14.4 5.3-20.7H144zM96 208c0 26.5 21.5 48 48 48h32c8.8 0 16-7.2 16-16c0-26.5-21.5-48-48-48H112c-8.8 0-16 7.2-16 16zm88 100.7c0 6.2 5.1 11.3 11.3 11.3h11.3 6 .6 21.5 .6 6 11.3c6.2 0 11.3-5.1 11.3-11.3c0-3-1.2-5.9-3.3-8l-8-8-4.2-4.2-.4-.4-10.3-10.3C234 274 229.1 272 224 272s-10 2-13.7 5.7L200 288l-.4 .4-4.2 4.2-8 8c-2.1 2.1-3.3 5-3.3 8zM195.3 352H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H252.7 195.3zM336 192H304c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16z", "M0 224C0 100.3 100.3 0 224 0S448 100.3 448 224v96c0 106-86 192-192 192H192C86 512 0 426 0 320V224zm153.6 96.3C121.2 323.5 96 350.8 96 384c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64c0-33.2-25.2-60.5-57.6-63.7c1-3.7 1.6-7.6 1.6-11.6c0-7.3-1.8-14.4-5.3-20.7H304c44.2 0 80-35.8 80-80c0-26.5-21.5-48-48-48H304c-44.2 0-80 35.8-80 80c0-44.2-35.8-80-80-80H112c-26.5 0-48 21.5-48 48c0 44.2 35.8 80 80 80h13.3c-3.4 6.3-5.3 13.4-5.3 20.7c0 4 .6 7.9 1.6 11.6z"]]
};
var faLuchador = faLuchadorMask;
var faMaskLuchador = faLuchadorMask;
var faSquareCheck = {
  prefix: 'fad',
  iconName: 'square-check',
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M337 175c9.4 9.4 9.4 24.6 0 33.9L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faCheckSquare = faSquareCheck;
var faShredder = {
  prefix: 'fad',
  iconName: 'shredder',
  icon: [512, 512, [], "f68a", ["M128 0C92.7 0 64 28.7 64 64V192h64V64H354.7L384 93.3V192h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM40 384V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384H40zm96 0V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384H136zm96 0V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384H232zm96 0V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384H328zm96 0V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384H424z", "M64 192c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faBookOpenCover = {
  prefix: 'fad',
  iconName: 'book-open-cover',
  icon: [640, 512, ["book-open-alt"], "e0c0", ["M64 373.8c0 15.3 10.8 28.4 25.7 31.4L304 448V32L100.6 2.2C81.3-.7 64 14.3 64 33.8V373.8zM576 33.8c0-19.5-17.3-34.5-36.6-31.7L336 32V448l214.3-42.9c15-3 25.7-16.1 25.7-31.4V33.8z", "M89.7 405.1L320 451.2l230.3-46.1c15-3 25.7-16.1 25.7-31.4V28.8l25.7-5.1C621.5 19.7 640 34.8 640 55V421.8c0 15.3-10.8 28.4-25.7 31.4L320 512 25.7 453.1C10.8 450.2 0 437 0 421.8V55C0 34.8 18.5 19.7 38.3 23.7L64 28.8v345c0 15.3 10.8 28.4 25.7 31.4z"]]
};
var faBookOpenAlt = faBookOpenCover;
var faSandwich = {
  prefix: 'fad',
  iconName: 'sandwich',
  icon: [512, 512, [129386], "f81f", ["M32 304c22.7 0 44.3-10.3 58.8-17.2l0 0c1.3-.6 2.6-1.2 3.8-1.8c17.4-8.2 29.4-13 41.4-13c16.2 0 27.5 5 45.4 13.1l.1 0c18 8.2 41.4 18.9 74.5 18.9s56.6-10.7 74.5-18.9l.1 0C348.5 277 359.8 272 376 272c12 0 23.9 4.7 41.4 13c1.2 .6 2.5 1.2 3.8 1.8l0 0c14.5 6.9 36.1 17.2 58.8 17.2c17.7 0 32-14.3 32-32s-14.3-32-32-32c-7.2 0-15.8-3.7-35.4-13c-16.6-7.8-40.6-19-68.6-19c-30.6 0-53 10.2-70.1 18l-1.9 .9C286.9 234.7 274.3 240 256 240s-30.9-5.3-48.1-13.1l-1.9-.9c-17-7.8-39.4-18-70.1-18c-28 0-52.1 11.3-68.6 19c-19.6 9.2-28.2 13-35.4 13c-17.7 0-32 14.3-32 32s14.3 32 32 32zm201.7 37.7l70.2 40.9c10 5.8 22.3 5.8 32.2 0l70.2-40.9c6.4-3.7 13.6-5.7 20.9-5.7H212.8c7.4 0 14.6 2 20.9 5.7z", "M32 64C14.3 64 0 78.3 0 96v48c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H32zM233.7 341.7c-6.4-3.7-13.6-5.7-20.9-5.7H208 32c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V368c0-17.7-14.3-32-32-32H432h-4.8c-7.4 0-14.6 2-20.9 5.7l-70.2 40.9c-10 5.8-22.3 5.8-32.2 0l-70.2-40.9z"]]
};
var faPesetaSign = {
  prefix: 'fad',
  iconName: 'peseta-sign',
  icon: [384, 512, [], "e221", ["M32 160l0 64c-17.7 0-32-14.3-32-32s14.3-32 32-32zm250.5 64H96V160H282.5c3.5 10 5.5 20.8 5.5 32s-1.9 22-5.5 32zm66.3 0c2.1-10.3 3.2-21 3.2-32s-1.1-21.7-3.2-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-3.2z", "M32 64c0-17.7 14.3-32 32-32H192c88.4 0 160 71.6 160 160s-71.6 160-160 160H96v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V320 64zM96 288h96c53 0 96-43 96-96s-43-96-96-96H96V288z"]]
};
var faSquareParkingSlash = {
  prefix: 'fad',
  iconName: 'square-parking-slash',
  icon: [640, 512, ["parking-slash"], "f617", ["M544 401.1V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1L227 152.7c6-14.5 20.3-24.7 37-24.7h72c53 0 96 43 96 96c0 26.3-10.6 50.2-27.8 67.5L544 401.1zM352.8 251.2c9.1-5.6 15.2-15.7 15.2-27.2c0-17.7-14.3-32-32-32H288v8.4l64.8 50.8zM486.9 479.6L288 322.9V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 272.5L96 171.6V416c0 35.3 28.7 64 64 64H480c2.3 0 4.6-.1 6.9-.4z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faParkingSlash = faSquareParkingSlash;
var faTrainTunnel = {
  prefix: 'fad',
  iconName: 'train-tunnel',
  icon: [512, 512, [], "e454", ["M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h41.4l64.3-64.3C137.3 444.5 112 417.2 112 384V192c0-35.3 28.7-64 64-64H336c35.3 0 64 28.7 64 64V384c0 33.2-25.3 60.5-57.7 63.7L406.6 512H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM361.4 512l-64-64H214.6l-64 64H361.4zM160 216v80c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24z", "M112 192c0-35.3 28.7-64 64-64H336c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H176c-35.3 0-64-28.7-64-64V192zm48 24v80c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm96 200a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faHeading = {
  prefix: 'fad',
  iconName: 'heading',
  icon: [448, 512, ["header"], "f1dc", ["M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z", ""]]
};
var faHeader = faHeading;
var faGhost = {
  prefix: 'fad',
  iconName: 'ghost',
  icon: [384, 512, [128123], "f6e2", ["M40.1 467.1l-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2V192C0 86 86 0 192 0S384 86 384 192V462.2c0 9.8-8 17.8-17.8 17.8c-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M128 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faFaceAnguished = {
  prefix: 'fad',
  iconName: 'face-anguished',
  icon: [512, 512, [], "e369", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z", "M192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-15.6 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 128.9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]]
};
var faHockeySticks = {
  prefix: 'fad',
  iconName: 'hockey-sticks',
  icon: [640, 512, [], "f454", ["M462.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9L261.5 476.6c-10.8 21.7-33 35.4-57.2 35.4H160 128 96V480 352H252.2L419.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3zM0 384c0-17.7 14.3-32 32-32H64V512H32c-17.7 0-32-14.3-32-32V384zm576-32V512H544V352h32z", "M220.6 17.7l81.5 163-35.8 71.6L163.4 46.3c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3zM337.9 395.3l35.8-71.6L387.8 352H544V480v32H512 480 435.8c-24.2 0-46.4-13.7-57.2-35.4l-40.6-81.3zM608 352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H576V352h32zM96 352V512H64V352H96z"]]
};
var faAbacus = {
  prefix: 'fad',
  iconName: 'abacus',
  icon: [576, 512, [129518], "f640", ["M512 96V208H448V176H416v32H288V176H256v32H160V176H128v32H64V96h64v32h32V96h96v32h32V96H416v32h32V96h64zM64 416l0-176h64v24h32V240h96v24h32V240H416v96h32V240h64V416H448V384H416v32H288V384H256v32H160V384H128v32H64zm64-80h32V312H128v24zm128 0h32V312H256v24zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z", "M96 152c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm160 0c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24zM96 288c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zM96 360c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm160 0c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24z"]]
};
var faFilmSimple = {
  prefix: 'fad',
  iconName: 'film-simple',
  icon: [512, 512, ["film-alt"], "f3a0", ["M160 32H352V480H160V32z", "M160 32H112V80c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V34C20.4 41.1 0 66.2 0 96V416c0 29.8 20.4 54.9 48 62V432c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16v48h48V32zM352 480h48V432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v46c27.6-7.1 48-32.2 48-62V96c0-29.8-20.4-54.9-48-62V80c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V32H352V480zM64 160H96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm336 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V176zM64 288H96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm336 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V304z"]]
};
var faFilmAlt = faFilmSimple;
var faList = {
  prefix: 'fad',
  iconName: 'list',
  icon: [512, 512, ["list-squares"], "f03a", ["M160 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm32 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M16 72c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V72zm0 160c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V232zM40 368H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24z"]]
};
var faListSquares = faList;
var faTreePalm = {
  prefix: 'fad',
  iconName: 'tree-palm',
  icon: [576, 512, [127796], "f82b", ["M248.4 206.9c4 10.8 7.8 26.2 9.7 47.2c4.2 46.5-1.6 116.8-32.7 216.4c-3 9.7-1.3 20.3 4.8 28.5s15.6 13 25.8 13h64c16.1 0 29.8-12 31.8-28c12.4-99-2.3-207.2-31.7-292H272c-2.5 0-5-.6-7.1-1.7l-16.5 16.5z", "M133.2 141.9L102.9 91.4c-3.1-5.2-10.6-5.2-13.7 0L69.5 124.1c-1.4 2.4-4 3.9-6.9 3.9H16c-8.8 0-16.1-7.2-14.4-15.9C10.7 64.2 59.6 0 160 0c88 0 136.5 49.4 153.2 93.8C338.4 76.2 372.3 64 416 64c100.4 0 149.3 64.2 158.4 112.1c1.7 8.7-5.6 15.9-14.4 15.9H513.3c-2.8 0-5.4-1.5-6.9-3.9l-19.6-32.7c-3.1-5.2-10.6-5.2-13.7 0l-19.6 32.7c-1.4 2.4-4.1 3.9-6.9 3.9H272c-2.5 0-5-.6-7.1-1.7L109.8 345.5c-6.2 6.2-16.5 6.3-21.4-1C61 304.1 50.2 224.1 121.1 153.1c4-4 8-7.7 12-11.2z"]]
};
var faSquarePhoneFlip = {
  prefix: 'fad',
  iconName: 'square-phone-flip',
  icon: [448, 512, ["phone-square-alt"], "f87b", ["M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z", "M269.5 140.3c3.9-9.3 14-14.2 23.7-11.6l44 12C346 143.1 352 151 352 160c0 123.7-100.3 224-224 224c-9 0-16.9-6-19.3-14.7l-12-44c-2.6-9.7 2.3-19.9 11.6-23.7l48-20c8.2-3.4 17.6-1 23.2 5.8L199.7 312c35.2-16.6 63.7-45.1 80.3-80.3l-24.7-20.2c-6.8-5.6-9.2-15-5.8-23.2l20-48z"]]
};
var faPhoneSquareAlt = faSquarePhoneFlip;
var faCartPlus = {
  prefix: 'fad',
  iconName: 'cart-plus',
  icon: [576, 512, [], "f217", ["M170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411c2 4.2 3.5 8.8 4.4 13.5L170.7 288zM252 160c0-11 9-20 20-20h44V96c0-11 9-20 20-20s20 9 20 20v44h44c11 0 20 9 20 20s-9 20-20 20H356v44c0 11-9 20-20 20s-20-9-20-20V180H272c-11 0-20-9-20-20z", "M0 24C0 10.7 10.7 0 24 0H69.5c26.9 0 50 19.1 55 45.5l51.6 271c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0-11 9-20 20-20h44V96c0-11 9-20 20-20s20 9 20 20v44h44c11 0 20 9 20 20s-9 20-20 20H356v44c0 11-9 20-20 20s-20-9-20-20V180H272c-11 0-20-9-20-20z"]]
};
var faGamepad = {
  prefix: 'fad',
  iconName: 'gamepad',
  icon: [640, 512, [], "f11b", ["M192 64C86 64 0 150 0 256S86 448 192 448H448c106 0 192-86 192-192s-86-192-192-192H192zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200z", "M192 176c-13.3 0-24 10.7-24 24v32H136c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v32c0 13.3 10.7 24 24 24s24-10.7 24-24V280h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V200c0-13.3-10.7-24-24-24z"]]
};
var faBorderCenterV = {
  prefix: 'fad',
  iconName: 'border-center-v',
  icon: [448, 512, [], "f89d", ["M448 448a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 352A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM384 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 160A32 32 0 1 1 0 160a32 32 0 1 1 64 0zm320 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zM384 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 64a32 32 0 1 1 64 0A32 32 0 1 1 0 64zM64 448A32 32 0 1 1 0 448a32 32 0 1 1 64 0zM288 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 64A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM96 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64-192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z", "M224 480c-17.7 0-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32s32 14.3 32 32l0 384c0 17.7-14.3 32-32 32z"]]
};
var faCircleDot = {
  prefix: 'fad',
  iconName: 'circle-dot',
  icon: [512, 512, [128280, "dot-circle"], "f192", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M256 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z"]]
};
var faDotCircle = faCircleDot;
var faClipboardMedical = {
  prefix: 'fad',
  iconName: 'clipboard-medical',
  icon: [384, 512, [], "e133", ["M113.2 66.3c.1-.8 .3-1.6 .4-2.3H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H270.4c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z", "M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"]]
};
var faFaceDizzy = {
  prefix: 'fad',
  iconName: 'face-dizzy',
  icon: [512, 512, ["dizzy"], "f567", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z", "M196.7 132.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 169.4l36.7-36.7zm96 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"]]
};
var faDizzy = faFaceDizzy;
var faEgg = {
  prefix: 'fad',
  iconName: 'egg',
  icon: [384, 512, [129370], "f7fb", ["M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z", "M155.8 111.4c6 6.5 5.5 16.7-1 22.6c-18.8 17.1-33.6 42.7-43.7 71.2C101 233.6 96 263.5 96 288c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-28.3 5.7-61.9 16.9-93.5c11.2-31.5 28.4-62.4 52.3-84.2c6.5-6 16.7-5.5 22.6 1z"]]
};
var faUpToLine = {
  prefix: 'fad',
  iconName: 'up-to-line',
  icon: [384, 512, ["arrow-alt-to-top"], "f34d", ["M0 64C0 81.7 14.3 96 32 96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64z", "M219.3 139.3L342.1 262.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9L256 320l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128-62.1 0C47.2 320 32 304.8 32 286.1c0-9 3.6-17.6 9.9-24L164.7 139.3c7.2-7.2 17.1-11.3 27.3-11.3s20.1 4.1 27.3 11.3z"]]
};
var faArrowAltToTop = faUpToLine;
var faHouseMedicalCircleXmark = {
  prefix: 'fad',
  iconName: 'house-medical-circle-xmark',
  icon: [640, 512, [], "e513", ["M394.8 512C349.5 480.1 320 427.5 320 368c0-5.4 .2-10.7 .7-16H320v16c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h40.2c32.3-39.1 81.1-64 135.8-64c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H394.8z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faWatchFitness = {
  prefix: 'fad',
  iconName: 'watch-fitness',
  icon: [384, 512, [], "f63e", ["M80 64C35.8 64 0 99.8 0 144V368c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80H80zm0 157.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3z", "M112.3 0H271.7C298.4 0 320 21.6 320 48.3V65.6c-5.2-1-10.5-1.6-16-1.6H80c-5.5 0-10.8 .6-16 1.6V48.3C64 21.6 85.6 0 112.3 0zM64 464V446.4c5.2 1 10.5 1.6 16 1.6H304c5.5 0 10.8-.6 16-1.6V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48zM80 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3z"]]
};
var faClockNineThirty = {
  prefix: 'fad',
  iconName: 'clock-nine-thirty',
  icon: [512, 512, [], "e34d", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V256c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h80V392c0 13.3 10.7 24 24 24s24-10.7 24-24z", "M256 416c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h80V392c0 13.3 10.7 24 24 24z"]]
};
var faCampground = {
  prefix: 'fad',
  iconName: 'campground',
  icon: [576, 512, [9978], "f6bb", ["M0 448v16c0 26.5 21.5 48 48 48H288 528c26.5 0 48-21.5 48-48V448H407.5l0 0H288 168.5l0 0H0z", "M372 7c13.8 11 16 31.2 5 45l-48 60L563.7 405.4c7.9 9.9 12.3 22.3 12.3 35V448H407.5L288 291.7 168.5 448H0v-7.6c0-12.7 4.3-25.1 12.3-35L247 112 199 52c-11-13.8-8.8-33.9 5-45s33.9-8.8 45 5l39 48.8L327 12c11-13.8 31.2-16 45-5zM47.7 512H528.3c-.1 0-.2 0-.3 0H288 48c-.1 0-.2 0-.3 0z"]]
};
var faFolderPlus = {
  prefix: 'fad',
  iconName: 'folder-plus',
  icon: [512, 512, [], "f65e", ["M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z", "M232 312v64c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faJug = {
  prefix: 'fad',
  iconName: 'jug',
  icon: [448, 512, [], "f8c6", ["M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zM416 288H32V416H416V288z", "M144 59.7V85c0 7.1-2.4 14-6.7 19.6L59 205.3c-17.5 22.5-27 50.1-27 78.6V288H416v-4.1c0-17.4-3.5-34.5-10.3-50.3C430.6 222.3 448 197.2 448 168c0-39.8-32.2-72-72-72c-21.2 0-40.3 9.2-53.5 23.8l-11.8-15.1C306.4 99 304 92.1 304 85V59.7c-4.7 2.7-10.2 4.3-16 4.3H160c-5.8 0-11.3-1.6-16-4.3zM32 448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V416H32v32zM378.6 191.9l-25.1-32.2c3.4-9.1 12.2-15.6 22.5-15.6c13.3 0 24 10.7 24 24c0 12.4-9.4 22.6-21.4 23.9z"]]
};
var faFutbol = {
  prefix: 'fad',
  iconName: 'futbol',
  icon: [512, 512, [9917, "futbol-ball", "soccer-ball"], "f1e3", ["M155.4 20.5C119.8 35.8 88.3 58.9 63.1 87.6l40.1 100.1c2.4 6 2.6 12.6 .6 18.8s-6.1 11.4-11.6 14.8L1 278.9c3.5 39.4 15.9 76.3 35.2 108.5l107.6-7.2c6.4-.4 12.8 1.4 18.1 5.2s9 9.3 10.5 15.6L199 505.6c18.3 4.2 37.4 6.4 57 6.4s38.7-2.2 57-6.4L339.5 401c1.6-6.3 5.3-11.8 10.5-15.6s11.6-5.6 18.1-5.2l107.6 7.2c19.3-32.2 31.7-69.1 35.2-108.5l-91.3-57.5c-5.5-3.4-9.6-8.7-11.6-14.8s-1.8-12.8 .6-18.8L448.9 87.6c-25.1-28.8-56.6-51.9-92.3-67.1L273.7 89.6c-5 4.1-11.2 6.4-17.7 6.4s-12.7-2.3-17.7-6.4L155.4 20.5zm86.5 145.7c8.4-6.1 19.8-6.1 28.2 0L337 214.8c8.4 6.1 11.9 16.9 8.7 26.8l-25.5 78.6c-3.2 9.9-12.4 16.6-22.8 16.6H214.7c-10.4 0-19.6-6.7-22.8-16.6l-25.6-78.6c-3.2-9.9 .3-20.7 8.7-26.8l66.9-48.6z", "M1 278.9c-.7-7.5-1-15.2-1-22.9C0 191.5 23.8 132.6 63.1 87.6l40.1 100.1c2.4 6 2.6 12.6 .6 18.8s-6.1 11.4-11.6 14.8L1 278.9zM199 505.6C130 489.9 71.6 446.4 36.2 387.4l107.6-7.2c6.4-.4 12.8 1.4 18.1 5.2s9 9.3 10.5 15.6L199 505.6zM475.8 387.4C440.4 446.4 382 489.9 313 505.6L339.5 401c1.6-6.3 5.3-11.8 10.5-15.6s11.6-5.6 18.1-5.2l107.6 7.2zM448.9 87.6C488.2 132.6 512 191.5 512 256c0 7.7-.3 15.3-1 22.9l-91.3-57.5c-5.5-3.4-9.6-8.7-11.6-14.8s-1.8-12.8 .6-18.8L448.9 87.6zM356.6 20.5L273.7 89.6c-5 4.1-11.2 6.4-17.7 6.4s-12.7-2.3-17.7-6.4L155.4 20.5C186.3 7.3 220.3 0 256 0s69.7 7.3 100.6 20.5zM241.9 166.3c8.4-6.1 19.8-6.1 28.2 0L337 214.8c8.4 6.1 11.9 16.9 8.7 26.8l-25.5 78.6c-3.2 9.9-12.4 16.6-22.8 16.6H214.7c-10.4 0-19.6-6.7-22.8-16.6l-25.6-78.6c-3.2-9.9 .3-20.7 8.7-26.8l66.9-48.6z"]]
};
var faFutbolBall = faFutbol;
var faSoccerBall = faFutbol;
var faSnowBlowing = {
  prefix: 'fad',
  iconName: 'snow-blowing',
  icon: [640, 512, [], "f761", ["M512 48c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c53 0 96-43 96-96s-43-96-96-96H512zm0 416h24c53 0 96-43 96-96s-43-96-96-96H416c-17.7 0-32 14.3-32 32s14.3 32 32 32H536c17.7 0 32 14.3 32 32s-14.3 32-32 32H512c-17.7 0-32 14.3-32 32s14.3 32 32 32z", "M176 64c13.3 0 24 10.7 24 24v25.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L200 158.6v55.8l48.3-27.9 12.9-48.2c2.3-8.5 11.1-13.6 19.6-11.3s13.6 11.1 11.3 19.6l-4.6 17.3 22-12.7c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8l-22 12.7 17.3 4.6c8.5 2.3 13.6 11.1 11.3 19.6s-11.1 13.6-19.6 11.3l-48.2-12.9L224 256l48.3 27.9L320.6 271c8.5-2.3 17.3 2.8 19.6 11.3s-2.8 17.3-11.3 19.6l-17.3 4.6 22 12.7c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8l-22-12.7 4.6 17.3c2.3 8.5-2.8 17.3-11.3 19.6s-17.3-2.8-19.6-11.3l-12.9-48.2L200 297.6v55.8l35.3 35.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L200 398.6V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V398.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L152 353.4V297.6l-48.3 27.9L90.7 373.7c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l4.6-17.3-22 12.7C31 367.4 16.4 363.5 9.7 352s-2.7-26.2 8.8-32.8l22-12.7-17.3-4.6c-8.5-2.3-13.6-11.1-11.3-19.6s11.1-13.6 19.6-11.3l48.2 12.9L128 256 79.7 228.1 31.4 241c-8.5 2.3-17.3-2.8-19.6-11.3s2.8-17.3 11.3-19.6l17.3-4.6-22-12.7C7 186.2 3.1 171.5 9.7 160s21.3-15.4 32.8-8.8l22 12.7-4.6-17.3c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3l12.9 48.2L152 214.4V158.6l-35.3-35.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L152 113.4V88c0-13.3 10.7-24 24-24z"]]
};
var faPaintbrush = {
  prefix: 'fad',
  iconName: 'paintbrush',
  icon: [576, 512, [128396, "paint-brush"], "f1fc", ["M208.1 272.1c-.6 0-1.2-.1-1.8-.1H184c-66.3 0-120 53.7-120 120c0 6.2 .5 12.4 1.4 18.4C68.1 428.2 56.1 448 38 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H175.9c.1 0 .1-.1 .1-.1s.1-.1 .1-.1c2.6 .2 5.2 .3 7.9 .3c66.3 0 120-53.7 120-120c0-2.8-.1-5.5-.2-8.3L208.1 272.1z", "M411 331.6c-19.9 32.6-55.3 52.4-93.4 52.4c-4.8 0-9.6-.3-14.3-.9L208 272c.2-35.9 17.8-69.4 47.1-90.1L500.2 8.8c18.6-13.1 43.9-11.4 60.5 4.2s20 40.6 8.2 60.1L411 331.6z"]]
};
var faPaintBrush = faPaintbrush;
var faLock = {
  prefix: 'fad',
  iconName: 'lock',
  icon: [448, 512, [128274], "f023", ["M224 64c-44.2 0-80 35.8-80 80v48H80V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48H304V144c0-44.2-35.8-80-80-80z", "M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z"]]
};
var faArrowDownFromLine = {
  prefix: 'fad',
  iconName: 'arrow-down-from-line',
  icon: [384, 512, [8615, "arrow-from-top"], "f345", ["M0 64C0 81.7 14.3 96 32 96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64z", "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.7V304 192c0-17.7-14.3-32-32-32s-32 14.3-32 32V304v66.7L86.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"]]
};
var faArrowFromTop = faArrowDownFromLine;
var faGasPump = {
  prefix: 'fad',
  iconName: 'gas-pump',
  icon: [512, 512, [9981], "f52f", ["M96 0C60.7 0 32 28.7 32 64V448H320V64c0-35.3-28.7-64-64-64H96zm16 64H240c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16z", "M384 64l32 32v64c0 29.8 20.4 54.9 48 62V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88h-8v48h8c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V224 192 168 154.5c0-17-6.7-33.3-18.7-45.3L416 32c-8.8-8.8-23.2-8.8-32 0s-8.8 23.2 0 32zM0 480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]]
};
var faSignalBarsSlash = {
  prefix: 'fad',
  iconName: 'signal-bars-slash',
  icon: [640, 512, ["signal-alt-slash"], "f694", ["M608 451.2V48c0-26.5-21.5-48-48-48s-48 21.5-48 48V376l96 75.2zM448 325.8V176c0-26.5-21.5-48-48-48s-48 21.5-48 48v74.6l96 75.2zM560 512l-.3 0h.7l-.3 0zM448 464V449l-96-75.6V464c0 26.5 21.5 48 48 48s48-21.5 48-48zM288 322.9l-74.7-58.8C200.5 272.7 192 287.4 192 304V464c0 26.5 21.5 48 48 48s48-21.5 48-48V322.9zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faSignalAltSlash = faSignalBarsSlash;
var faMonkey = {
  prefix: 'fad',
  iconName: 'monkey',
  icon: [576, 512, [128018], "f6fb", ["M384 64c-26.5 0-48 21.5-48 48c0 20.8 13.2 38.4 31.6 45.1c4.7 1.7 8.4 5.9 8.4 10.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9c18.5-6.7 31.6-24.4 31.6-45.1c0-26.5-21.5-48-48-48H384zm-16 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z", "M160 416c0-89.7 61.4-165 144.5-186.1C329.1 265 369.9 288 416 288c9.8 0 19.4-1 28.7-3L526.5 363c31.6 30.2 49.5 72 49.5 115.7V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-26.2-10.7-51.3-29.7-69.4L416 346.1V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H416 160C71.6 512 0 440.4 0 352V110.1C0 49.3 49.3 0 110.1 0h10.4c57.2 0 102.8 47.8 100.1 104.9c-2.3 48.2-38.6 88-86.4 94.6l-1.9 .3c-17.5 2.4-33.7-9.8-36.1-27.3s9.8-33.7 27.3-36.1l1.9-.3c17.3-2.4 30.4-16.7 31.2-34.2c1-20.6-15.5-37.9-36.2-37.9H110.1C84.7 64 64 84.7 64 110.1V352c0 53 43 96 96 96V416zM416 256c-29.3 0-55.9-12.2-74.8-31.7c-9-9.3-16.2-20.2-21.3-32.3c-35.3 0-64-28.7-64-64s28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64s-28.6 64-64 64c-15.7 37.6-52.8 64-96 64zM384 64c-26.5 0-48 21.5-48 48c0 20.8 13.2 38.4 31.6 45.1c4.7 1.7 8.4 5.9 8.4 10.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9c18.5-6.7 31.6-24.4 31.6-45.1c0-26.5-21.5-48-48-48H384z"]]
};
var faRectanglePro = {
  prefix: 'fad',
  iconName: 'rectangle-pro',
  icon: [640, 512, ["pro"], "e235", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm40 128h56c35.3 0 64 28.7 64 64s-28.7 64-64 64H128v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 184c0-13.3 10.7-24 24-24zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H128v32h32zm80-56c0-13.3 10.7-24 24-24h56c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.7 52.7l24.1 38.5c7 11.2 3.6 26-7.6 33.1s-26 3.6-33.1-7.6l-33-52.7H288v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 184zm48 56h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288v32zm200-80c48.6 0 88 39.4 88 88v16c0 48.6-39.4 88-88 88s-88-39.4-88-88V248c0-48.6 39.4-88 88-88zm-40 88v16c0 22.1 17.9 40 40 40s40-17.9 40-40V248c0-22.1-17.9-40-40-40s-40 17.9-40 40z", "M80 184v80 64c0 13.3 10.7 24 24 24s24-10.7 24-24V288h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H104c-13.3 0-24 10.7-24 24zm48 56V208h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H128zm112-56v80 64c0 13.3 10.7 24 24 24s24-10.7 24-24V288h18.7l33 52.7c7 11.2 21.8 14.7 33.1 7.6s14.7-21.8 7.6-33.1l-24.1-38.5C373 265.2 384 245.9 384 224c0-35.3-28.7-64-64-64H264c-13.3 0-24 10.7-24 24zm48 56V208h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H288zm200-80c-48.6 0-88 39.4-88 88v16c0 48.6 39.4 88 88 88s88-39.4 88-88V248c0-48.6-39.4-88-88-88zm-40 88c0-22.1 17.9-40 40-40s40 17.9 40 40v16c0 22.1-17.9 40-40 40s-40-17.9-40-40V248z"]]
};
var faPro = faRectanglePro;
var faHouseNight = {
  prefix: 'fad',
  iconName: 'house-night',
  icon: [640, 512, [], "e010", ["M125.2 16.1c6.2-4.4 5.4-14.8-2.2-15.6c-3.6-.4-7.3-.5-11-.5C50.1 0 0 50.1 0 112s50.1 112 112 112c32.1 0 61.1-13.5 81.5-35.2c5.2-5.6-1-14-8.6-13.2c-2.9 .3-5.9 .4-9 .4c-48.6 0-88-39.4-88-88c0-29.7 14.7-55.9 37.2-71.9zm123.3-3.8L236.6 44.6 204.3 56.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15L275.4 44.6 263.5 12.3c-2.6-7-12.4-7-15 0zm-160 320L76.6 364.6 44.3 376.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3c-2.6-7-12.4-7-15 0z", "M378.3 104.5c12.3-11.3 31.2-11.3 43.4 0l208 192c9.7 8.9 12.9 22.9 8.1 35.2S621.2 352 608 352H576V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V352H192c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM368 288c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H368z"]]
};
var faHotTubPerson = {
  prefix: 'fad',
  iconName: 'hot-tub-person',
  icon: [512, 512, ["hot-tub"], "f593", ["M248 0c13.3 0 24 10.7 24 24v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C238.4 95.7 224 63.3 224 29.2V24c0-13.3 10.7-24 24-24zM0 256c0-53 43-96 96-96c20.8 0 41 6.7 57.6 19.2L256 256H0zM384 24v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C350.4 95.7 336 63.3 336 29.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM0 64a64 64 0 1 1 128 0A64 64 0 1 1 0 64z", "M0 256H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm112 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16zm112 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336zm80-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16zm112 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"]]
};
var faHotTub = faHotTubPerson;
var faBlanket = {
  prefix: 'fad',
  iconName: 'blanket',
  icon: [448, 512, [], "f498", ["M0 352V128C0 75 43 32 96 32H352c53 0 96 43 96 96V304c0-44.2-35.8-80-80-80H128C57.3 224 0 281.3 0 352z", "M128 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H128C57.3 480 0 422.7 0 352s57.3-128 128-128H368c44.2 0 80 35.8 80 80s-35.8 80-80 80H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]]
};
var faMapLocation = {
  prefix: 'fad',
  iconName: 'map-location',
  icon: [576, 512, ["map-marked"], "f59f", ["M416 503V200.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503zM15.1 187.3l122.6-49c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3zM384 255V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0c13.9-17.4 35.7-45.7 56.2-77z", "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120z"]]
};
var faMapMarked = faMapLocation;
var faHouseFloodWater = {
  prefix: 'fad',
  iconName: 'house-flood-water',
  icon: [576, 512, [], "e50e", ["M306.5 309.9c-11.1-7.9-25.9-7.9-37 0C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z", "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128z"]]
};
var faCommentsQuestionCheck = {
  prefix: 'fad',
  iconName: 'comments-question-check',
  icon: [640, 512, [], "e14f", ["M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM136.2 108.4c6.6-18.6 24.2-31.1 44-31.1h48.5c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20V179.5c0-7.2 3.8-13.8 10-17.3L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6H180.2c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1zM181.3 264a26.7 26.7 0 1 1 53.3 0 26.7 26.7 0 1 1 -53.3 0z", "M136.2 108.4l-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4h48.5c7 0 12.6 5.7 12.6 12.6c0 4.5-2.4 8.7-6.3 10.9L198 162.1c-6.2 3.6-10 10.2-10 17.3v11.2c0 11 9 20 20 20c10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6c0-29.1-23.6-52.6-52.6-52.6H180.2c-19.8 0-37.4 12.4-44 31.1zM234.7 264a26.7 26.7 0 1 0 -53.3 0 26.7 26.7 0 1 0 53.3 0zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 3.9 16 7.9 25.3 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5zm-33 17.6c-9.9 84.3-90 151-190.2 157.8l0 0c100.1-6.8 180.3-73.5 190.2-157.8zM566.1 318.1l-80 80c-7.8 7.8-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0L472 355.7l65.9-65.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"]]
};
var faTree = {
  prefix: 'fad',
  iconName: 'tree',
  icon: [448, 512, [127794], "f1bb", ["M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320H80L5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5H192V224c0-17.7 14.3-32 32-32s32 14.3 32 32V448H424.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z", "M224 192c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]]
};
var faArrowsCross = {
  prefix: 'fad',
  iconName: 'arrows-cross',
  icon: [448, 512, [], "e0a2", ["M288 480H416c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v50.7L269.3 256 224 301.3 338.7 416H288c-17.7 0-32 14.3-32 32s14.3 32 32 32zM178.7 256L224 210.7 54.6 41.4c-12.5-12.5-32.8-12.5-45.3 0S-3.1 74.1 9.4 86.6L178.7 256z", "M256 64c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32V192c0 17.7-14.3 32-32 32s-32-14.3-32-32V141.3L54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 96H288c-17.7 0-32-14.3-32-32z"]]
};
var faBackpack = {
  prefix: 'fad',
  iconName: 'backpack',
  icon: [448, 512, [127890], "f5d4", ["M184 56c0-4.4 3.6-8 8-8h64c4.4 0 8 3.6 8 8V96h48V56c0-30.9-25.1-56-56-56H192c-30.9 0-56 25.1-56 56V96h48V56zM352 384H96V512H352V384z", "M0 224C0 153.3 57.3 96 128 96H320c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H352V400 336c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48v64V512H64c-35.3 0-64-28.7-64-64V224zm144-48c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]]
};
var faSquareSmall = {
  prefix: 'fad',
  iconName: 'square-small',
  icon: [320, 512, [], "e27e", ["M0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160z", ""]]
};
var faFolderArrowUp = {
  prefix: 'fad',
  iconName: 'folder-arrow-up',
  icon: [512, 512, ["folder-upload"], "e054", ["M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM280 360V257.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V360c0 13.3 10.7 24 24 24s24-10.7 24-24z", "M256 384c13.3 0 24-10.7 24-24V257.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V360c0 13.3 10.7 24 24 24z"]]
};
var faFolderUpload = faFolderArrowUp;
var faBridgeLock = {
  prefix: 'fad',
  iconName: 'bridge-lock',
  icon: [640, 512, [], "e4cc", ["M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c28.8 0 54.6 12.7 72.2 32.7c5.6-10 13.9-18.4 23.8-24.1V272c0-61.9 50.1-112 112-112h8V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faCrosshairsSimple = {
  prefix: 'fad',
  iconName: 'crosshairs-simple',
  icon: [512, 512, [], "e59f", ["M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z", "M288 66.7c-10.4-1.7-21.1-2.7-32-2.7s-21.6 .9-32 2.7V128c0 17.7 14.3 32 32 32s32-14.3 32-32V66.7zM66.7 288H128c17.7 0 32-14.3 32-32s-14.3-32-32-32H66.7c-1.7 10.4-2.7 21.1-2.7 32s.9 21.6 2.7 32zM224 445.3c10.4 1.7 21.1 2.7 32 2.7s21.6-.9 32-2.7V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v61.3zM445.3 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h61.3c1.7-10.4 2.7-21.1 2.7-32s-.9-21.6-2.7-32z"]]
};
var faSackDollar = {
  prefix: 'fad',
  iconName: 'sack-dollar',
  icon: [512, 512, [128176], "f81d", ["M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zm-64 68c11 0 20 9 20 20v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2 0 0c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V424c0 11-9 20-20 20s-20-9-20-20V409.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4l0 0c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V216c0-11 9-20 20-20z", "M192 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H192zm84 120c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5l0 0c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"]]
};
var faPenToSquare = {
  prefix: 'fad',
  iconName: 'pen-to-square',
  icon: [512, 512, ["edit"], "f044", ["M0 160c0-53 43-96 96-96h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 53-43 96-96 96H96c-53 0-96-43-96-96V160z", "M392.4 21.7L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0zM339.7 74.3L172.4 241.7c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3z"]]
};
var faEdit = faPenToSquare;
var faSquareSliders = {
  prefix: 'fad',
  iconName: 'square-sliders',
  icon: [448, 512, ["sliders-h-square"], "f3f0", ["M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zm0-144c0 17.7-14.3 32-32 32l-32 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16L96 368c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 32 0c17.7 0 32 14.3 32 32zM352 144c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 160 0z", "M192 224c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96zM320 384c0 17.7-14.3 32-32 32s-32-14.3-32-32V288c0-17.7 14.3-32 32-32s32 14.3 32 32v96z"]]
};
var faSlidersHSquare = faSquareSliders;
var faCarSide = {
  prefix: 'fad',
  iconName: 'car-side',
  icon: [640, 512, [128663], "f5e4", ["M171.3 128H224v96H111.3l30.4-75.9c4.9-12.1 16.6-20.1 29.7-20.1zM272 224V128h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zM64 432a80 80 0 1 1 160 0A80 80 0 1 1 64 432zm432-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M171.3 128H224v96H111.3l30.4-75.9c4.9-12.1 16.6-20.1 29.7-20.1zM272 224V128h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1l-100-125c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 228.4C16.8 237.8 0 260.9 0 288V400c0 17.7 14.3 32 32 32c0-61.9 50.1-112 112-112s112 50.1 112 112H384c0-61.9 50.1-112 112-112s112 50.1 112 112c17.7 0 32-14.3 32-32V352c0-65.2-48.8-119-111.8-127z"]]
};
var faMessageMiddleTop = {
  prefix: 'fad',
  iconName: 'message-middle-top',
  icon: [512, 512, ["comment-middle-top-alt"], "e1e2", ["M343.5 96H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H168.5L243.7 5.8c3-3.6 7.5-5.8 12.3-5.8s9.3 2.1 12.3 5.8L343.5 96z", ""]]
};
var faCommentMiddleTopAlt = faMessageMiddleTop;
var faLightbulbOn = {
  prefix: 'fad',
  iconName: 'lightbulb-on',
  icon: [640, 512, [], "f672", ["M449.2 297.8c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4zM240 176c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16z", "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80V384H400v48z"]]
};
var faKnife = {
  prefix: 'fad',
  iconName: 'knife',
  icon: [512, 512, ["utensil-knife"], "f2e4", ["M459.5 7.3L201.4 265.4l59.9 59.9c12 12 28.3 18.7 45.3 18.7h11c17 0 33.2-6.8 45.3-18.7C455.7 233.9 512 186.1 512 96c0-24.5-6.7-57.4-11.4-77.6C498.1 7.5 488.2 0 477.1 0c-6.6 0-12.9 2.6-17.6 7.3z", "M217.4 249.4l-16 16 45.3 45.3-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l208-208z"]]
};
var faUtensilKnife = faKnife;
var faShareNodes = {
  prefix: 'fad',
  iconName: 'share-nodes',
  icon: [448, 512, ["share-alt"], "f1e0", ["M285.4 197.1c-15.4-14.9-25.9-34.9-28.6-57.2l-94.1 47c15.4 14.9 25.9 34.9 28.6 57.2l94.1-47zm-94.1 70.8c-2.8 22.4-13.2 42.4-28.6 57.2l94.1 47c2.8-22.4 13.2-42.4 28.6-57.2l-94.1-47z", "M256 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM0 256a96 96 0 1 1 192 0A96 96 0 1 1 0 256zm352 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]]
};
var faShareAlt = faShareNodes;
var faDisplayChartUpCircleDollar = {
  prefix: 'fad',
  iconName: 'display-chart-up-circle-dollar',
  icon: [640, 512, [], "e5e6", ["M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H394.8C349.5 480.1 320 427.5 320 368c0-5.4 .2-10.7 .7-16H64V64H512V192.7c22.9 2.1 44.5 8.5 64 18.5V64c0-35.3-28.7-64-64-64H64zM480 192.7V120c0-13.3-10.7-24-24-24H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h22.1L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111V200c0 1.3 .1 2.6 .3 3.9c15-5.8 31-9.7 47.7-11.2z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM472.1 339l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z"]]
};
var faWaveSine = {
  prefix: 'fad',
  iconName: 'wave-sine',
  icon: [640, 512, [8767], "f899", ["M63.4 230.3l0-.1 .2-1c.2-.9 .5-2.4 1-4.3c1-3.8 2.5-9.4 4.6-16.2C73.6 195 80.3 177 90 159.4C110.2 122.8 137.8 96 176 96c29 0 49.1 14.4 67 44.4c19 31.8 31.9 75.4 46.3 124.5c.2 .8 .5 1.6 .7 2.4c13.5 46.2 28.4 97.5 52 137c25.1 42 63 75.6 122 75.6c73.8 0 118.2-53.2 142-96.6c12.3-22.4 20.6-44.5 25.7-60.8c2.6-8.2 4.5-15.1 5.7-20c.6-2.5 1.1-4.4 1.4-5.9c.2-.7 .3-1.3 .4-1.7l.1-.5 0-.2 0-.1 0 0c0 0 0 0-31.4-6.3l31.4 6.3c3.5-17.3-7.8-34.2-25.1-37.7s-34.2 7.8-37.7 25.1l0 0 0 .1-.2 1c-.2 .9-.5 2.4-1 4.3c-1 3.8-2.5 9.4-4.6 16.2c-4.3 13.7-11.1 31.6-20.8 49.2c-20.1 36.6-47.8 63.4-86 63.4c-29 0-49.1-14.4-67-44.4c-19-31.8-31.9-75.4-46.3-124.5c-.2-.8-.5-1.6-.7-2.4c-13.5-46.2-28.4-97.5-52-137C272.9 65.6 235 32 176 32C102.2 32 57.8 85.2 34 128.6C21.7 151 13.4 173 8.2 189.3c-2.6 8.2-4.5 15.1-5.7 20c-.6 2.5-1.1 4.4-1.4 5.9c-.2 .7-.3 1.3-.4 1.7l-.1 .5 0 .2 0 .1 0 0c0 0 0 0 31.4 6.3L.6 217.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1", ""]]
};
var faHeartCircleMinus = {
  prefix: 'fad',
  iconName: 'heart-circle-minus',
  icon: [576, 512, [], "e4ff", ["M228.3 469.1L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 6.6-.4 13.2-1.3 19.6C487 198.7 460.3 192 432 192c-97.2 0-176 78.8-176 176c0 36.6 11.2 70.6 30.3 98.7l-2.6 2.4c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]]
};
var faCircleW = {
  prefix: 'fad',
  iconName: 'circle-w',
  icon: [512, 512, [], "e12c", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM150.9 168.7L192 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L320 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L256 254.7 214.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z", "M120.7 153.1c12.6-4 26.1 2.9 30.2 15.5L192 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L320 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L256 254.7 214.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2z"]]
};
var faCircleCalendar = {
  prefix: 'fad',
  iconName: 'circle-calendar',
  icon: [512, 512, ["calendar-circle"], "e102", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 96c8.8 0 16 7.2 16 16v16h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32c17.7 0 32 14.3 32 32v64V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V224 160c0-17.7 14.3-32 32-32h32V112c0-8.8 7.2-16 16-16z", "M192 112c0-8.8 7.2-16 16-16s16 7.2 16 16v16h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32c17.7 0 32 14.3 32 32v64H128V160c0-17.7 14.3-32 32-32h32V112z"]]
};
var faCalendarCircle = faCircleCalendar;
var faHourglassHalf = {
  prefix: 'fad',
  iconName: 'hourglass-half',
  icon: [384, 512, ["hourglass-2"], "f252", ["M32 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9v11h64V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75V64H32V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9l22.6 22.6L78.9 323.9C48.9 353.9 32 394.6 32 437z", "M0 32C0 49.7 14.3 64 32 64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V437c0-19-5.6-37.4-16-53H112c-10.3 15.6-16 34-16 53v11H32c-17.7 0-32 14.3-32 32zM259.9 142.9c4.6-4.6 8.6-9.6 12.1-14.9H112c3.5 5.3 7.6 10.3 12.1 14.9L192 210.7l67.9-67.9z"]]
};
var faHourglass2 = faHourglassHalf;
var faMicroscope = {
  prefix: 'fad',
  iconName: 'microscope',
  icon: [512, 512, [128300], "f610", ["M192 0c-17.7 0-32 14.3-32 32h96c0-17.7-14.3-32-32-32H192zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z", "M128 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32V64zM512 320c0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H320c70.7 0 128-57.3 128-128s-57.3-128-128-128V128c106 0 192 86 192 192z"]]
};
var faSunset = {
  prefix: 'fad',
  iconName: 'sunset',
  icon: [576, 512, [127751], "f767", ["M403.1 237.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L288 289.1l-90.3-62.3c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L153 345 45.1 364.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L86.1 464H161c7.9-63.1 61.7-112 127-112s119.1 48.9 127 112h74.9l51.3-74.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L423 345 403.1 237.1zM382.7 464c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H382.7z", "M354.5 104.3L320 135.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V135.7l-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]]
};
var faSink = {
  prefix: 'fad',
  iconName: 'sink',
  icon: [512, 512, [], "e06d", ["M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm448 96H32v32c0 53 43 96 96 96H384c53 0 96-43 96-96V384z", "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96V288h64V96zM56 208c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24h48V264c0-30.9-25.1-56-56-56H56zm344 56c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24h48V264z"]]
};
var faCalendarExclamation = {
  prefix: 'fad',
  iconName: 'calendar-exclamation',
  icon: [448, 512, [], "f334", ["M0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM256 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-176c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V256z", "M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v80H0V112C0 85.5 21.5 64 48 64H96V32zm96 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-176v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-13.3 10.7-24 24-24s24 10.7 24 24z"]]
};
var faTruckContainerEmpty = {
  prefix: 'fad',
  iconName: 'truck-container-empty',
  icon: [640, 512, [], "e2b5", ["M96 352a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm160 0a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm288 0a64 64 0 1 0 0 128 64 64 0 1 0 0-128z", "M456 144c-13.3 0-24 10.7-24 24v88 32 16H32c-17.7 0-32 14.3-32 32v16c0 8.8 3.6 16.8 9.4 22.6C24.8 342.3 57.8 320 96 320c33.4 0 62.8 17 80 42.9C193.2 337 222.6 320 256 320c41.8 0 77.4 26.7 90.5 64H432h21.5c13.2-37.3 48.7-64 90.5-64c38.2 0 71.2 22.3 86.6 54.6c5.8-5.8 9.4-13.8 9.4-22.6V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H456zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256z"]]
};
var faHandHeart = {
  prefix: 'fad',
  iconName: 'hand-heart',
  icon: [512, 512, [], "f4bc", ["M256 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V336c0 97.2-78.8 176-176 176H284.8c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zM208 362.6c0 12.1 5.1 23.6 14.1 31.6l55.2 49.7c6.1 5.5 15.3 5.5 21.4 0l55.2-49.7c9-8.1 14.1-19.6 14.1-31.6c0-23.5-19.1-42.6-42.6-42.6h-1.1c-14.6 0-28.3 7.3-36.4 19.5c-8.1-12.2-21.7-19.5-36.4-19.5h-1.1c-23.5 0-42.6 19.1-42.6 42.6z", "M250.6 320c-23.5 0-42.6 19.1-42.6 42.6c0 12.1 5.1 23.6 14.1 31.6l55.2 49.7c6.1 5.5 15.3 5.5 21.4 0l55.2-49.7c9-8.1 14.1-19.6 14.1-31.6c0-23.5-19.1-42.6-42.6-42.6h-1.1c-14.6 0-28.3 7.3-36.4 19.5c-8.1-12.2-21.7-19.5-36.4-19.5h-1.1z"]]
};
var faBagShopping = {
  prefix: 'fad',
  iconName: 'bag-shopping',
  icon: [448, 512, ["shopping-bag"], "f290", ["M288 160H160v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V160H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V160z", "M224 48c-35.3 0-64 28.7-64 64V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V112C112 50.1 162.1 0 224 0s112 50.1 112 112V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V112c0-35.3-28.7-64-64-64z"]]
};
var faShoppingBag = faBagShopping;
var faArrowDownZA = {
  prefix: 'fad',
  iconName: 'arrow-down-z-a',
  icon: [576, 512, ["sort-alpha-desc", "sort-alpha-down-alt"], "f881", ["M352 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352zm64 160c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z"]]
};
var faSortAlphaDesc = faArrowDownZA;
var faSortAlphaDownAlt = faArrowDownZA;
var faMitten = {
  prefix: 'fad',
  iconName: 'mitten',
  icon: [448, 512, [], "f7b5", ["M64 384c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H64z", "M314.7 234.7L283.2 108.9C267.2 44.9 209.7 0 143.8 0h-3.4C62.8 0 0 62.8 0 140.3c0 13 1.8 26 5.4 38.6L64 384H352l79.2-85.8c10.8-11.7 16.8-27 16.8-42.9c0-34.9-28.3-63.3-63.3-63.3H382c-19 0-37.2 8.2-49.7 22.6l-17.6 20.1z"]]
};
var faReplyClock = {
  prefix: 'fad',
  iconName: 'reply-clock',
  icon: [640, 512, ["reply-time"], "e239", ["M511.2 319.4c-5 .4-10.1 .6-15.2 .6c-91.8 0-167.2-70.3-175.3-160H224V96c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 222.3 0 230.9 0 240s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V320h96c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C430.5 499.9 512 449.3 512 336c0-5.6-.3-11.2-.8-16.6z", "M496 288A144 144 0 1 0 496 0a144 144 0 1 0 0 288zM512 80v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faReplyTime = faReplyClock;
var faPersonRays = {
  prefix: 'fad',
  iconName: 'person-rays',
  icon: [512, 512, [], "e54d", ["M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H248z", "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM471 7L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm464 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80z"]]
};
var faRight = {
  prefix: 'fad',
  iconName: 'right',
  icon: [448, 512, [11157, "arrow-alt-right"], "f356", ["M224 192V320L40 320c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40H224z", "M224 320h0l0 96c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 96h0V320z"]]
};
var faArrowAltRight = faRight;
var faCircleF = {
  prefix: 'fad',
  iconName: 'circle-f',
  icon: [512, 512, [], "e10e", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24z", "M160 152c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152z"]]
};
var faUsers = {
  prefix: 'fad',
  iconName: 'users',
  icon: [640, 512, [], "f0c0", ["M224 80A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm368 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7zm298 128c.2 0 .4 0 .7 0H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96z", "M320 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3z"]]
};
var faFacePleading = {
  prefix: 'fad',
  iconName: 'face-pleading',
  icon: [512, 512, [], "e386", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM302.7 427.9c6.6-5.9 7.1-16 1.2-22.6C294.7 395.1 278.7 384 256 384s-38.7 11.1-47.9 21.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c4.7-5.3 12.7-10.7 24.1-10.7s19.4 5.4 24.1 10.7c5.9 6.6 16 7.1 22.6 1.2zM240 240c0-41.5-31.5-75.6-72-79.6c10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9c1 8.1 7.9 14 15.9 14c-10 13.4-16 30-16 48c0 44.2 35.8 80 80 80s80-35.8 80-80zm192 0c0-18-6-34.6-16-48c8 0 14.9-5.9 15.9-14c1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8c-40.4 4-72 38.1-72 79.6c0 44.2 35.8 80 80 80s80-35.8 80-80z", "M191.4 116.4l-1.5 5.2c-10.6 37-42.2 64.1-80.4 68.9L98 191.9c-8.8 1.1-16.8-5.1-17.9-13.9s5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8zm129.2 0c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9s-9.1 15-17.9 13.9l-11.5-1.4c-38.2-4.8-69.8-31.9-80.4-68.9l-1.5-5.2zM128 232c17.7 0 32-14.3 32-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4c17.7 0 32-14.3 32-32z"]]
};
var faEyeSlash = {
  prefix: 'fad',
  iconName: 'eye-slash',
  icon: [640, 512, [], "f070", ["M360.8 380.3C339.4 392.8 314.6 400 288 400c-79.5 0-144-64.5-144-144c0-14.5 2.1-28.5 6.1-41.7L63.5 146c-29.4 34.7-49.9 70.8-61.1 97.6c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480c56.1 0 104.4-17.8 144.5-43.2l-71.7-56.5zM198.5 252.4c-3.7 .8-6.7 3.7-6.5 7.7c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9c1.9-.5 3.9-1.1 5.7-1.7l-120-94.6zm89-52.4l94.8 74.3c2.7-13.9 2.4-28.6-1.5-43.2c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 2.7-.2 5.4-.5 8zM432 256c0 17.7-3.2 34.6-9 50.2l84.1 65.9c32.3-36.6 54.6-75.4 66.4-103.9c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32c-60 0-111.1 20.3-152.8 48.7L207 136.9c23.1-15.7 51-24.9 81-24.9c79.5 0 144 64.5 144 144z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faFlaskVial = {
  prefix: 'fad',
  iconName: 'flask-vial',
  icon: [640, 512, [], "e4f3", ["M175 389.4l49-79.6V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32C14.3 0 0 14.3 0 32S14.3 64 32 64V352c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5c0-18.7 5.2-37.1 15-53.1zM96 64h64v96H96V64z", "M480 0H352 320c-17.7 0-32 14.3-32 32s14.3 32 32 32V214.9L202.3 406.2c-6.7 10.9-10.3 23.5-10.3 36.4c0 38.3 31.1 69.4 69.4 69.4H570.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L512 214.9V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H480zM384 224V64h64V224c0 5.9 1.6 11.7 4.7 16.8L501.5 320h-171l48.8-79.2c3.1-5 4.7-10.8 4.7-16.8z"]]
};
var faPoliceBox = {
  prefix: 'fad',
  iconName: 'police-box',
  icon: [384, 512, [], "e021", ["M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32h32V16zM104 128c-4.4 0-8 3.6-8 8v24h32V128H104zm24 48H96v24c0 4.4 3.6 8 8 8h24V176zm16-48v32h32V136c0-4.4-3.6-8-8-8H144zm32 48H144v32h24c4.4 0 8-3.6 8-8V176zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM208 136v24h32V128H216c-4.4 0-8 3.6-8 8zm0 40v24c0 4.4 3.6 8 8 8h24V176H208zm72-48H256v32h32V136c0-4.4-3.6-8-8-8zm-24 48v32h24c4.4 0 8-3.6 8-8V176H256z", "M96 32C78.3 32 64 46.3 64 64C46.3 64 32 78.3 32 96V464H352V96c0-17.7-14.3-32-32-32c0-17.7-14.3-32-32-32H96zm0 104c0-4.4 3.6-8 8-8h24v32H96V136zm0 40h32v32H104c-4.4 0-8-3.6-8-8V176zm72-48c4.4 0 8 3.6 8 8v24H144V128h24zm-24 48h32v24c0 4.4-3.6 8-8 8H144V176zm72-48h24v32H208V136c0-4.4 3.6-8 8-8zm24 48v32H216c-4.4 0-8-3.6-8-8V176h32zm16-48h24c4.4 0 8 3.6 8 8v24H256V128zm32 48v24c0 4.4-3.6 8-8 8H256V176h32zM96 256c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V256z"]]
};
var faCucumber = {
  prefix: 'fad',
  iconName: 'cucumber',
  icon: [512, 512, [129362], "e401", ["M376 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM280 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-136 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M37.5 474.5c47.8 47.8 124 49.9 174.3 6.3c12.6 10.3 31.1 9.6 42.9-2.2c11.6-11.6 12.4-30 2.4-42.6L436 257c12.6 10.1 31 9.3 42.6-2.4c11.7-11.7 12.5-30.3 2.2-42.9c43.6-50.3 41.5-126.5-6.3-174.3c-50-50-131-50-181 0L172 159c-12.6-10.1-31-9.3-42.6 2.4s-12.4 30-2.4 42.6L37.5 293.5c-50 50-50 131 0 181zM400 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM304 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
};
var faHeadSideBrain = {
  prefix: 'fad',
  iconName: 'head-side-brain',
  icon: [512, 512, [], "f808", ["M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM285.3 208H336c26.5 0 48-21.5 48-48s-21.5-48-48-48c-.9 0-1.8 0-2.7 .1C326.7 93.4 308.9 80 288 80c-8.6 0-16.6 2.2-23.5 6.2C255.9 72.8 241 64 224 64s-31.9 8.8-40.5 22.2c-7-3.9-15-6.2-23.5-6.2c-26.5 0-48 21.5-48 48c-26.5 0-48 21.5-48 48c0 20.9 13.4 38.7 32.1 45.3c0 .9-.1 1.8-.1 2.7c0 26.5 21.5 48 48 48c5.6 0 11-1 16-2.7V288c0 17.7 14.3 32 32 32s32-14.3 32-32V269.3c5 1.8 10.4 2.7 16 2.7c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16zM160 176v2.7l-.1 0c0-.9 .1-1.8 .1-2.7z", "M336 208H285.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48c-5.6 0-11-1-16-2.7V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V269.3c-5 1.8-10.4 2.7-16 2.7c-26.5 0-48-21.5-48-48c0-.9 0-1.8 .1-2.7C77.4 214.7 64 196.9 64 176c0-26.5 21.5-48 48-48c0-26.5 21.5-48 48-48c8.6 0 16.6 2.2 23.5 6.2C192.1 72.8 207 64 224 64s31.9 8.8 40.5 22.2c7-3.9 15-6.2 23.5-6.2c20.9 0 38.7 13.4 45.3 32.1c.9 0 1.8-.1 2.7-.1c26.5 0 48 21.5 48 48s-21.5 48-48 48zM159.9 178.7l.1 0V176c0 .9 0 1.8-.1 2.7z"]]
};
var faHand = {
  prefix: 'fad',
  iconName: 'hand',
  icon: [512, 512, [129306, 9995, "hand-paper"], "f256", ["M256 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V336c0 97.2-78.8 176-176 176H284.8c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zM192 336c0 8.8 7.2 16 16 16h8c39.8 0 72 32.2 72 72v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-27.9-11-53.3-29-72h77c8.8 0 16-7.2 16-16s-7.2-16-16-16H216h-8c-8.8 0-16 7.2-16 16z", "M208 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h8c39.8 0 72 32.2 72 72v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-27.9-11-53.3-29-72h77c8.8 0 16-7.2 16-16s-7.2-16-16-16H216h-8z"]]
};
var faHandPaper = faHand;
var faPersonBikingMountain = {
  prefix: 'fad',
  iconName: 'person-biking-mountain',
  icon: [640, 512, [128693, "biking-mountain"], "f84b", ["M96.2 276.6C97.9 264.9 107.9 256 120 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C158.1 503.1 148.1 512 136 512H120c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L31.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C8.9 414.1 0 404.1 0 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM192 384A64 64 0 1 0 64 384a64 64 0 1 0 128 0zM480.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C542.1 503.1 532.1 512 520 512H504c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C392.9 414.1 384 404.1 384 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM576 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z", "M448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM427.2 160l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zm-238.8 6.7L290.8 89.9c7.2-5.4 8.5-15.7 2.9-22.8L278.8 48.4c-21.6-27-60.7-32-88.4-11.2L125.2 86.1c-7.2 5.4-8.5 15.7-2.9 22.8l44 55c5.4 6.7 15.2 8 22.1 2.8z"]]
};
var faBikingMountain = faPersonBikingMountain;
var faUtensilsSlash = {
  prefix: 'fad',
  iconName: 'utensils-slash',
  icon: [640, 512, [], "e464", ["M544 401.1V352 240 32c0-17.7-14.3-32-32-32C496 0 384 32 384 176v99.7L544 401.1zM306.4 214.9c8.6-13.6 13.6-29.7 13.6-47c0-6.4-.7-12.8-2.1-19.1L287.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S256 7.8 256 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L223.9 14.6C223.2 6.3 216.3 0 208 0s-15.2 6.3-15.9 14.6l-9.4 103.3 123.8 97zM160 100.1V16c0-8.2-6.1-15-14.3-15.9s-15.6 4.5-17.4 12.4L116.5 66 160 100.1zm80 185L96.1 171.7c1.9 44.2 36.3 80 79.9 83.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V285.1z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faPrintMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'print-magnifying-glass',
  icon: [640, 512, ["print-search"], "f81a", ["M128 64v96h64V64H418.7L448 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L464 18.7C452 6.7 435.7 0 418.7 0H192c-35.3 0-64 28.7-64 64zM352 192H128c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32h32v64c0 35.3 28.7 64 64 64H448c24.4 0 45.6-13.7 56.4-33.8l-6.3-6.3c-15.8 5.2-32.6 8-50.2 8c-36 0-69.3-11.9-96-32H192V384 368 352h99.2c-2.1-10.3-3.2-21-3.2-32c0-52.3 25.1-98.8 64-128z", "M528 320.1a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM519.9 426c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426z"]]
};
var faPrintSearch = faPrintMagnifyingGlass;
var faFolderBookmark = {
  prefix: 'fad',
  iconName: 'folder-bookmark',
  icon: [512, 512, [], "e186", ["M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8V336c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L368 308l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V96c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z", "M288 96V336c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L368 308l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V96H288z"]]
};
var faOm = {
  prefix: 'fad',
  iconName: 'om',
  icon: [512, 512, [128329], "f679", ["M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zm-98.4 62c-6-4-14-3.5-19.5 1.3s-7 12.7-3.7 19.2L272 80c-14.3 7.2-14.3 7.2-14.3 7.2l0 0 0 0 0 .1 .1 .2 .4 .7c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-22.6-22.6l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3c-12.4-12.4-32.6-12.5-45.1-.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2 0 0 0 0 0 0z", "M115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48H109.8c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H144h16s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5 0-.1c-2.6-7.8-10.7-12.3-18.7-10.5C4.4 354.2-.9 361.8 .1 370L16 368C.1 370 .1 370 .1 370l0 0 0 0 0 .1 .1 .4c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.3 0 0c0 0 0 0 0 0c-1.9-7.3-8.6-12.4-16.2-12.1c-7.6 .3-13.9 5.9-15.1 13.4L336 368c-15.8-2.6-15.8-2.6-15.8-2.6l0 0 0 0 0 .1-.1 .3-.1 .5-.1 .6c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96V288c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4H245.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4z"]]
};
var faPi = {
  prefix: 'fad',
  iconName: 'pi',
  icon: [448, 512, [], "f67e", ["M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H96V284c0 39.7-9.3 78.9-27 114.5l-1.6 3.2c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l1.6-3.2C148.4 382.7 160 333.7 160 284V128H288V366.6c0 45 36.5 81.4 81.4 81.4c30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6c-9.6 0-17.4-7.8-17.4-17.4V128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z", ""]]
};
var faFlaskRoundPotion = {
  prefix: 'fad',
  iconName: 'flask-round-potion',
  icon: [448, 512, ["flask-potion"], "f6e1", ["M192 157.7c0 30.4-16.9 56.1-40.3 69.7C108.7 252.5 80 298.9 80 352c0 36.9 13.8 70.5 36.7 96H331.3c22.9-25.5 36.7-59.1 36.7-96c0-53.1-28.7-99.5-71.7-124.6c-23.4-13.6-40.3-39.3-40.3-69.7V64H192v93.7zM320 64v93.7c0 6 3.3 11.4 8.5 14.4C390.4 208.2 432 275.2 432 352c0 56-22.1 106.9-58.2 144.3C363.5 507 348.7 512 333.8 512H114.2c-14.9 0-29.7-5-40.1-15.7C38.1 458.9 16 408 16 352c0-76.8 41.6-143.8 103.5-179.9c5.2-3 8.5-8.4 8.5-14.4V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h16H304h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z", "M368 351.8c-58.6-1.7-85.4-12.6-109.9-22.6c-22-9-42.2-17.2-82.1-17.2c-42.3 0-73.4 9.2-94.5 18.8c-1 6.9-1.5 14-1.5 21.2c0 36.9 13.8 70.5 36.7 96H331.3c22.9-25.5 36.7-59.1 36.7-96c0-.1 0-.1 0-.2z"]]
};
var faFlaskPotion = faFlaskRoundPotion;
var faFaceShush = {
  prefix: 'fad',
  iconName: 'face-shush',
  icon: [512, 512, [], "e38c", ["M0 256C0 359.8 61.8 449.1 150.5 489.3c-4.2-10.3-6.5-21.5-6.5-33.3V432 408c0-37.3 23.2-69.2 56-82V275.9c-14.8-6.9-26.6-15.9-35.3-24.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c3.7 3.7 8.1 7.4 13.3 10.9c4-27 27.3-47.6 55.4-47.6s51.3 20.7 55.4 47.6c5.2-3.5 9.6-7.3 13.3-10.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-8.7 8.7-20.5 17.7-35.3 24.6v58.3c17.9 11.7 31.3 29.7 37 50.9c16-3.2 33.3 .6 46.9 11.9c18.4 15.3 24.5 39.9 17.1 61.3c60.3-46.8 99-120 99-202.3C512 114.6 397.4 0 256 0S0 114.6 0 256zM176.4 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M272 416c0 13.3 10.7 24 24 24s24-10.7 24-24H272zm8-168c0-13.3-10.7-24-24-24s-24 10.7-24 24h48zm98.4 207.4c8.5-10.2 7.1-25.3-3.1-33.8s-25.3-7.1-33.8 3.1l36.9 30.7zm-44 15.4l18.4 15.4-18.4-15.4zM280 464H232v48h48V464zm-56-8V432H176v24h48zm0-24V408H176v24h48zm8-32h32V352H232v48zm40 8v8h48v-8H272zm21.8 60.3l-80-56-27.5 39.3 80 56 27.5-39.3zM232 248v72h48V248H232zm48 264h17.5V464H280v48zm72.8-25.9l25.6-30.7-36.9-30.7L316 455.4l36.9 30.7zM297.5 512c21.4 0 41.6-9.5 55.3-25.9L316 455.4c-4.6 5.5-11.3 8.6-18.4 8.6v48zM264 400c4.4 0 8 3.6 8 8h48c0-30.9-25.1-56-56-56v48zm-40 8c0-4.4 3.6-8 8-8V352c-30.9 0-56 25.1-56 56h48zm8 56c-4.4 0-8-3.6-8-8H176c0 30.9 25.1 56 56 56V464z"]]
};
var faWorm = {
  prefix: 'fad',
  iconName: 'worm',
  icon: [512, 512, [], "e599", ["M288 96c0-53 43-96 96-96h38.4C471.9 0 512 40.1 512 89.6V176v16V360c0 83.9-68.1 152-152 152s-152-68.1-152-152V312c0-30.9-25.1-56-56-56s-56 25.1-56 56V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V312c0-83.9 68.1-152 152-152s152 68.1 152 152v48c0 30.9 25.1 56 56 56s56-25.1 56-56V192H384c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z", "M384 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
};
var faHouseCircleXmark = {
  prefix: 'fad',
  iconName: 'house-circle-xmark',
  icon: [640, 512, [], "e50b", ["M496 192c-91.8 0-167.2 70.3-175.3 160l-.7 0H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faPlug = {
  prefix: 'fad',
  iconName: 'plug',
  icon: [384, 512, [128268], "f1e6", ["M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V160h64V32zm192 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V160h64V32z", "M0 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32v32c0 77.4-55 142-128 156.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V412.8C87 398 32 333.4 32 256V224c-17.7 0-32-14.3-32-32z"]]
};
var faCalendarCircleExclamation = {
  prefix: 'fad',
  iconName: 'calendar-circle-exclamation',
  icon: [576, 512, [], "e46e", ["M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32zM416 192.7c-89.7 8.1-160 83.5-160 175.3c0 59.5 29.6 112.1 74.8 144H48c-26.5 0-48-21.5-48-48V192H416v.7z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faSquareI = {
  prefix: 'fad',
  iconName: 'square-i',
  icon: [448, 512, [], "e272", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V336h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M128 152c0-13.3 10.7-24 24-24h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V336h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176H152c-13.3 0-24-10.7-24-24z"]]
};
var faChevronUp = {
  prefix: 'fad',
  iconName: 'chevron-up',
  icon: [512, 512, [], "f077", ["M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z", ""]]
};
var faFaceSaluting = {
  prefix: 'fad',
  iconName: 'face-saluting',
  icon: [640, 512, [129761], "e484", ["M352 0c-18.4 0-36.3 1.9-53.5 5.6c12.6 27.9 3.8 61.6-22.4 79.4l-54.6 37c8.6 4.4 16.3 10.9 22.3 19.2c8.6 11.9 12.6 25.7 12.2 39.3c4.8-2.8 10.4-4.5 16.3-4.5c17.7 0 32 14.3 32 32s-14.3 32-32 32c-13.9 0-25.8-8.9-30.2-21.4c-3.5 4.4-7.7 8.5-12.5 12l-82.3 59.9c-13.9 10.1-29.5 16.6-45.6 19.6C126.5 425.5 229.1 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0zM257.4 341c17.5 12.6 48.9 27 94.6 27s77.2-14.4 94.6-27c7.2-5.2 17.2-3.5 22.3 3.6s3.5 17.2-3.6 22.3c-22.7 16.4-60.7 33-113.4 33s-90.6-16.6-113.4-33c-7.2-5.2-8.8-15.2-3.6-22.3s15.2-8.8 22.3-3.6zm175-165a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M258.1 58.5c14.6-9.9 18.4-29.8 8.5-44.4S236.8-4.4 222.2 5.5L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c28.1 22.9 68.2 24 97.5 2.7l82.3-59.9c14.3-10.4 17.5-30.4 7.1-44.7s-30.4-17.5-44.7-7.1L128 185.8V146.8L258.1 58.5z"]]
};
var faGaugeSimpleLow = {
  prefix: 'fad',
  iconName: 'gauge-simple-low',
  icon: [512, 512, ["tachometer-slow"], "f62c", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.1 .3L173.3 140.9c-6.1-11.8-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4l76.6 147.4C197.8 321.6 192 336.1 192 352c0 35.3 28.7 64 64 64s64-28.7 64-64z", "M173.3 140.9c-6.1-11.8-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4l76.6 147.4C197.8 321.6 192 336.1 192 352c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-2.1 0-4.1 .1-6.1 .3L173.3 140.9z"]]
};
var faTachometerSlow = faGaugeSimpleLow;
var faFacePersevering = {
  prefix: 'fad',
  iconName: 'face-persevering',
  icon: [512, 512, [], "e385", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zm-104.8-310c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM133.5 210.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 221.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z", "M211.3 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zm89.4 0l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM133.5 210.7c-7.9-4.2-17.5 1.5-17.5 10.5c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9zM396 221.1c0-9-9.6-14.7-17.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6z"]]
};
var faCircleCamera = {
  prefix: 'fad',
  iconName: 'circle-camera',
  icon: [512, 512, ["camera-circle"], "e103", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM202.2 143.6c3.5-9.4 12.5-15.6 22.5-15.6h62.7c10 0 19 6.2 22.5 15.6L316 160h36c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h36l6.2-16.4z", "M202.2 143.6L196 160H160c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H316l-6.2-16.4c-3.5-9.4-12.5-15.6-22.5-15.6H224.6c-10 0-19 6.2-22.5 15.6zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faCameraCircle = faCircleCamera;
var faHandSpock = {
  prefix: 'fad',
  iconName: 'hand-spock',
  icon: [576, 512, [128406], "f259", ["M207.7 1.1c17.1-4.6 34.6 5.6 39.2 22.6l57 212.8C307 248 317.4 256 329.3 256c12.4 0 23.2-8.7 25.8-20.9L392.7 57.4c3.7-17.3 20.6-28.3 37.9-24.7s28.3 20.6 24.7 37.9l-36 170.3c-1.6 7.8 4.3 15.1 12.2 15.1c5.5 0 10.4-3.6 12-8.9l37.9-128.1c5-16.9 22.8-26.6 39.8-21.6s26.6 22.8 21.6 39.8L461.5 412c-16.7 56.6-67 96.2-125.3 99.7c-.1 0-.1 .1-.1 .1s-.1 .1-.1 .1h-8.2H316.8c-59.6 0-116.9-22.9-160-64L44.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4L155 335.8c6 5.7 15.6-.3 13.2-8.1L105.4 121.3c-5.1-16.9 4.4-34.8 21.3-39.9s34.8 4.4 39.9 21.3l43.5 143.1c1.9 6.1 7.5 10.3 13.9 10.3c9.5 0 16.4-9 14-18.2L185.1 40.3c-4.6-17.1 5.6-34.6 22.6-39.2zM224 336c0 8.8 7.2 16 16 16h8c39.8 0 72 32.2 72 72v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-27.9-11-53.3-29-72h77c8.8 0 16-7.2 16-16s-7.2-16-16-16H248h-8c-8.8 0-16 7.2-16 16z", "M240 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h8c39.8 0 72 32.2 72 72v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-27.9-11-53.3-29-72h77c8.8 0 16-7.2 16-16s-7.2-16-16-16H248h-8z"]]
};
var faSpiderWeb = {
  prefix: 'fad',
  iconName: 'spider-web',
  icon: [576, 512, [128376], "f719", ["M165.3 97.7L178 63.9l36.4 6.8L235.1 107l.8 .1c34.4 6.1 69.7 6.1 104.1 0l.8-.1 20.8-36.4L398 63.9l12.7 33.8-22.2 38.9 .7 2c11.5 32.5 28.5 62.8 50.4 89.4h44.6l23.3 28-23.3 28H439.6c-21.9 26.6-38.9 56.9-50.4 89.4l-.7 2 22.2 38.9L398 448.1l-36.4-6.8L340.9 405l-.8-.2c-34.4-6.1-69.7-6.1-104.1 0l-.8 .2-20.8 36.4L178 448.1l-12.7-33.8 22.2-38.9-.7-2c-11.5-32.5-28.5-62.8-50.4-89.4H91.8L68.4 256l23.3-28h44.6c21.9-26.6 38.9-56.9 50.4-89.4l.7-2L165.3 97.7zM239.8 228l-22.1-38.7c-6.4 13.4-13.7 26.3-21.8 38.7h43.9zM288 199.6L311.2 159c-15.4 1-30.9 1-46.3 0L288 199.6zM336.2 228h43.9c-8.1-12.4-15.4-25.3-21.8-38.7L336.2 228zm0 56l22.1 38.7c6.4-13.4 13.7-26.3 21.8-38.7H336.2zM288 312.4L264.8 353c15.4-1 30.9-1 46.3 0L288 312.4zM239.8 284H195.8c8.1 12.4 15.4 25.3 21.8 38.7L239.8 284z", "M133.8 22.2c4.8-12.7 18-20.2 31.4-17.7l69 12.9c35.6 6.7 72.1 6.7 107.6 0l69-12.9c13.4-2.5 26.6 5 31.4 17.7l28.9 77.2c11.5 30.7 28.1 59.2 49.1 84.4l45.3 54.3c8.7 10.4 8.7 25.5 0 35.9l-45.3 54.3c-21 25.2-37.6 53.7-49.1 84.4l-28.9 77.2c-4.8 12.7-18 20.2-31.4 17.7l-69-12.9c-35.6-6.7-72.1-6.7-107.6 0l-69 12.9c-13.4 2.5-26.6-5-31.4-17.7l-28.9-77.2C93.3 382 76.7 353.4 55.7 328.2L10.5 273.9c-8.7-10.4-8.7-25.5 0-35.9l45.3-54.3c21-25.2 37.6-53.7 49.1-84.4l28.9-77.2zM178 63.9L157.3 119c-13.7 36.6-33.5 70.6-58.5 100.6L68.4 256l30.3 36.4c25 30 44.8 64 58.5 100.6L178 448.1l45.9-8.6c42.4-7.9 85.9-7.9 128.3 0l45.9 8.6L418.7 393c13.7-36.6 33.5-70.6 58.5-100.6L507.6 256l-30.3-36.4c-25-30-44.8-64-58.5-100.6L398 63.9l-45.9 8.6c-42.4 7.9-85.9 7.9-128.3 0L178 63.9z"]]
};
var faCircleMicrophone = {
  prefix: 'fad',
  iconName: 'circle-microphone',
  icon: [512, 512, ["microphone-circle"], "e116", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256c0 26.5-21.5 48-48 48s-48-21.5-48-48V144zm-64 80c8.8 0 16 7.2 16 16v16c0 53 43 96 96 96s96-43 96-96V240c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 65.3-48.9 119.1-112 127v17c0 8.8-7.2 16-16 16s-16-7.2-16-16V383c-63.1-7.9-112-61.7-112-127V240c0-8.8 7.2-16 16-16z", "M256 96c-26.5 0-48 21.5-48 48V256c0 26.5 21.5 48 48 48s48-21.5 48-48V144c0-26.5-21.5-48-48-48zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 65.3 48.9 119.1 112 127v17c0 8.8 7.2 16 16 16s16-7.2 16-16V383c63.1-7.9 112-61.7 112-127V240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53-43 96-96 96s-96-43-96-96V240z"]]
};
var faMicrophoneCircle = faCircleMicrophone;
var faBookArrowUp = {
  prefix: 'fad',
  iconName: 'book-arrow-up',
  icon: [448, 512, [], "e0ba", ["M216 384H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H216V384zm48 64H416V384H264v64z", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H216V448H96c-17.7 0-32-14.3-32-32s14.3-32 32-32H216l0-174.1-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39V384h88 64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zM264 448v64H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 264z"]]
};
var faPopsicle = {
  prefix: 'fad',
  iconName: 'popsicle',
  icon: [320, 512, [], "e43e", ["M160 0C71.6 0 0 71.6 0 160V336c0 26.5 21.5 48 48 48h80V192c0-17.7 14.3-32 32-32s32 14.3 32 32V384h80c26.5 0 48-21.5 48-48V160C320 71.6 248.4 0 160 0z", "M128 192c0-17.7 14.3-32 32-32s32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V192z"]]
};
var faCommand = {
  prefix: 'fad',
  iconName: 'command',
  icon: [512, 512, [], "e142", ["M320 128V96c0-53 43-96 96-96s96 43 96 96s-43 96-96 96H384V320H320V192 128zM192 320v64 32c0 53-43 96-96 96s-96-43-96-96s43-96 96-96h32V192h64V320zm-64 64H96c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32V384zM384 128h32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32v32z", "M0 96C0 43 43 0 96 0s96 43 96 96v32H320v64H192 128 96h0C43 192 0 149 0 96zM320 320h64 32c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96V384H192V320H320zM128 128V96c0-17.7-14.3-32-32-32S64 78.3 64 96s14.3 32 32 32h32zM384 384v32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32H384z"]]
};
var faBlinds = {
  prefix: 'fad',
  iconName: 'blinds',
  icon: [512, 512, [], "f8fb", ["M15 59.1L1.1 100.8c-.7 2.1-1.1 4.3-1.1 6.5C0 118.8 9.2 128 20.6 128H128V64H32c-6.3 0-12.1-1.8-17-4.9zM160 64v64H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L497 59.1c-4.9 3.1-10.8 4.9-17 4.9H160zM24 160L1.1 228.8c-.7 2.1-1.1 4.3-1.1 6.5C0 246.8 9.2 256 20.6 256H98.7c4.8-13.6 15.6-24.4 29.3-29.3V160H24zM144 320c-20.9 0-38.7-13.4-45.3-32H24L1.1 356.8c-.7 2.1-1.1 4.3-1.1 6.5C0 374.8 9.2 384 20.6 384H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 288H189.3c-6.6 18.6-24.4 32-45.3 32zm16-93.3c13.6 4.8 24.4 15.6 29.3 29.3H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 160H160v66.7zM20.6 512H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 416H24L1.1 484.8c-.7 2.1-1.1 4.3-1.1 6.5C0 502.8 9.2 512 20.6 512z", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64h96V226.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V64H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faStopwatch = {
  prefix: 'fad',
  iconName: 'stopwatch',
  icon: [448, 512, [9201], "f2f2", ["M224 512a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm24-320V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M144 32c0-17.7 14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H256V98.4c-10.4-1.6-21.1-2.4-32-2.4s-21.6 .8-32 2.4V64H176c-17.7 0-32-14.3-32-32zM355.7 143l21.6-21.6c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-24.1 24.1c-11.7-18-26.2-34.1-42.8-47.7zM248 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"]]
};
var faSaxophone = {
  prefix: 'fad',
  iconName: 'saxophone',
  icon: [640, 512, [127927], "f8dc", ["M246.7 176L171.4 306.1c-2.2 3.8-3.4 8.2-3.4 12.6v2.6c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L319 225l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L367 177l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L415 129l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8 44.3-44.3c12-12 28.3-18.7 45.3-18.7h30.3c15 0 29.5 5.2 41 14.8l24.3 20.3c3.7 3.1 5.9 7.7 5.9 12.6c0 9-7.3 16.3-16.3 16.3H559.5c-9.8 0-19 4.5-25.1 12.1L288.6 418.6C257.9 457.4 211.2 480 161.8 480C72.4 480 0 407.6 0 318.2v-3.1c0-12.7 1.5-25.4 4.4-37.8L28.2 176H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H246.7zM120 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M319 225L353 191l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8zm48-48L401 143l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8zm48-48L449 95l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8zM152 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-32 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]]
};
var faSquare2 = {
  prefix: 'fad',
  iconName: 'square-2',
  icon: [448, 512, [], "e257", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM190.7 184.7l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L212.7 336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L244.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z", "M216 176.3c-9.1-.1-18 2.8-25.3 8.3l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L212.7 336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L244.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1z"]]
};
var faFieldHockeyStickBall = {
  prefix: 'fad',
  iconName: 'field-hockey-stick-ball',
  icon: [512, 512, [127953, "field-hockey"], "f44c", ["M491.2 8.5c21.8 15.1 27.3 45 12.2 66.8L442.1 164l-79.9-53.3 62.2-90c15.1-21.8 45-27.3 66.8-12.2zM432 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M442.1 164l-79.9-53.3L162 400.3c-6.7 9.7-17.7 15.4-29.4 15.5c-20 .1-36.1-16.2-36-36.1l0-2.2c.1-7.3 2.2-14.4 6.2-20.6l17.3-26.5c14.5-22.2 8.3-51.9-13.9-66.4s-51.9-8.3-66.4 13.9L22.5 304.3C8.4 325.8 .8 350.9 .6 376.7l0 2.2C.1 452.3 59.5 512 132.9 511.8c43.2-.1 83.5-21.4 108.1-56.9L442.1 164z"]]
};
var faFieldHockey = faFieldHockeyStickBall;
var faArrowUpSquareTriangle = {
  prefix: 'fad',
  iconName: 'arrow-up-square-triangle',
  icon: [576, 512, ["sort-shapes-up-alt"], "f88b", ["M368 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm48 256c11 0 21.3 5.7 27.1 15l80 128c6.2 9.9 6.5 22.3 .9 32.5s-16.4 16.5-28 16.5H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6 .9-32.5l80-128c5.8-9.4 16.1-15 27.1-15z", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z"]]
};
var faSortShapesUpAlt = faArrowUpSquareTriangle;
var faFaceScream = {
  prefix: 'fad',
  iconName: 'face-scream',
  icon: [640, 512, [], "e38b", ["M573.9 288.5c1.4-10.7 2.1-21.5 2.1-32.5C576 114.6 461.4 0 320 0S64 114.6 64 256c0 11 .7 21.9 2.1 32.6c20.6-2.5 41.7 3.5 57.8 16.9l0 0c57.5 48 87.8 118 98 187C252.1 505.1 285.2 512 320 512c34.8 0 68-6.9 98.2-19.5c10.2-69 40.4-139 98-187l0 0c16.1-13.4 37.2-19.4 57.8-17zM320 320c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm-46.6-77c-22.5 36.9-62.8 54.7-90.1 39.8s-31.1-56.9-8.7-93.7s62.8-54.7 90.1-39.8s31.1 56.9 8.7 93.7zm183.3 39.8c-27.3 14.9-67.6-2.9-90.1-39.8s-18.6-78.8 8.7-93.7s67.6 2.9 90.1 39.8s18.6 78.8-8.7 93.7z", "M183.3 282.7c27.3 14.9 67.6-2.9 90.1-39.8s18.6-78.8-8.7-93.7s-67.6 2.9-90.1 39.8s-18.6 78.8 8.7 93.7zm273.4 0c27.3-14.9 31.1-56.9 8.7-93.7s-62.8-54.7-90.1-39.8s-31.1 56.9-8.7 93.7s62.8 54.7 90.1 39.8zM103.4 330.1C89.1 318.2 68 316.4 51.6 327c-20 13-25.6 39.5-12.4 59.3c26.4 40 43.6 75.3 43.2 125.7L192 512c-7-68.4-34.8-137-88.7-181.9zM588.5 327c-16.4-10.6-37.6-8.8-51.8 3.1C482.8 375 455 443.6 448 512l109.8 0c-.4-50.5 16.7-85.7 43.2-125.7c13.1-19.8 7.6-46.3-12.4-59.3z"]]
};
var faSquareM = {
  prefix: 'fad',
  iconName: 'square-m',
  icon: [448, 512, [], "e276", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm75.5 105.9L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2l-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7 .3 26.8 8.8z", "M112.6 129.2c9.9-3.2 20.7 .3 26.8 8.8L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2l-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8z"]]
};
var faCameraWeb = {
  prefix: 'fad',
  iconName: 'camera-web',
  icon: [448, 512, ["webcam"], "f832", ["M224 352a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM176 224c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z", "M448 224c0 79.5-41.4 149.3-103.8 189.1l58.2 40.7c11.4 8 16.4 22.5 12.2 35.8S398 512 384 512H64c-14 0-26.3-9.1-30.5-22.4s.7-27.8 12.2-35.8l58.2-40.7C41.4 373.3 0 303.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM224 384a160 160 0 1 0 0-320 160 160 0 1 0 0 320z"]]
};
var faWebcam = faCameraWeb;
var faCommentArrowDown = {
  prefix: 'fad',
  iconName: 'comment-arrow-down',
  icon: [512, 512, [], "e143", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm24-296V270.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V152c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M256 128c13.3 0 24 10.7 24 24V270.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V152c0-13.3 10.7-24 24-24z"]]
};
var faLightbulbCfl = {
  prefix: 'fad',
  iconName: 'lightbulb-cfl',
  icon: [320, 512, [], "e5a6", ["M167.8 63L39.8 95C22.6 99.3 5.2 88.9 1 71.8S7.1 37.2 24.2 33l128-32c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zM319 88.2c4.3 17.1-6.1 34.5-23.3 38.8l-256 64C22.6 195.3 5.2 184.9 1 167.8s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3zm0 96c4.3 17.1-6.1 34.5-23.3 38.8L99.9 272 96 273 39.8 287C22.6 291.3 5.2 280.9 1 263.8s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3zM96 306l48-12v90H96V306zm223-25.7c4.3 17.1-6.1 34.5-23.3 38.8l-64 16L224 337v47H176V308.7c0-.5 0-.9 0-1.4V304l.2 0c1.6-12.7 10.8-23.7 24-27l16-4 64-16c17.1-4.3 34.5 6.1 38.8 23.3z", "M96 384c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c0 17.7 14.3 32 32 32s32-14.3 32-32h32c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H96z"]]
};
var faWindowFrameOpen = {
  prefix: 'fad',
  iconName: 'window-frame-open',
  icon: [512, 512, [], "e050", ["M232 64H96V224H232V64zm48 160H416V64H280V224z", "M480 224V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V224v64H96 416h64V224zm-64 0H280V64H416V224zm-184 0H96V64H232V224zM96 448V320H32V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320H416V448H96z"]]
};
var faFaceKiss = {
  prefix: 'fad',
  iconName: 'face-kiss',
  icon: [512, 512, [128535, "kiss"], "f596", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faKiss = faFaceKiss;
var faBridgeCircleXmark = {
  prefix: 'fad',
  iconName: 'bridge-circle-xmark',
  icon: [640, 512, [], "e4cb", ["M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h72v72.2C577.6 207.1 538.5 192 496 192c-69.1 0-128.9 39.8-157.7 97.7c-5.9-1.1-12-1.7-18.3-1.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faPeriod = {
  prefix: 'fad',
  iconName: 'period',
  icon: [128, 512, [], "2e", ["M0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416z", ""]]
};
var faFaceGrinTongue = {
  prefix: 'fad',
  iconName: 'face-grin-tongue',
  icon: [512, 512, [128539, "grin-tongue"], "f589", ["M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zM208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"]]
};
var faGrinTongue = faFaceGrinTongue;
var faUpToDottedLine = {
  prefix: 'fad',
  iconName: 'up-to-dotted-line',
  icon: [448, 512, [], "e457", ["M384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM224 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z", "M196.7 139.3L73.9 262.1c-6.4 6.4-9.9 15-9.9 24C64 304.8 79.2 320 97.9 320H160V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V320h62.1c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24L251.3 139.3c-7.2-7.2-17.1-11.3-27.3-11.3s-20.1 4.1-27.3 11.3z"]]
};
var faThoughtBubble = {
  prefix: 'fad',
  iconName: 'thought-bubble',
  icon: [512, 512, [], "e32e", ["M144 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M374.8 80.3C355.9 33.2 309.8 0 256 0s-99.9 33.2-118.8 80.3c-3-.2-6.1-.3-9.2-.3C57.3 80 0 137.3 0 208s57.3 128 128 128c14.4 0 28.3-2.4 41.3-6.8C184.7 361.6 217.7 384 256 384s71.3-22.4 86.7-54.8c12.9 4.4 26.8 6.8 41.3 6.8c70.7 0 128-57.3 128-128s-57.3-128-128-128c-3.1 0-6.1 .1-9.2 .3z"]]
};
var faSkeletonRibs = {
  prefix: 'fad',
  iconName: 'skeleton-ribs',
  icon: [640, 512, [], "e5cb", ["M352 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM479.9 376c-3 0-6-.5-9.1-1.4L352 339v40.9c-21.1-4.3-42.9-4.3-64 0v-42L160.3 372.7c1-22.4 5.1-45.9 11-69.3L288 271.6V231.9L186 254.6c9-26 19.4-50.6 29.3-72.1L288 166.3V128h64v38.3l72.7 16.2c9.9 21.4 20.2 46.1 29.3 72.1L352 231.9v40.3l117.8 35.3c5.6 23.2 9.3 46.4 10.1 68.5zM288 446.2c20.7-7.3 43.3-7.3 64 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V446.2zM64 80c35.3 0 64 28.7 64 64c0 20.1-9.5 39.1-25.6 51.2L76.8 214.4C68.7 220.4 64 229.9 64 240V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V240 144c0-35.3 28.7-64 64-64zm576 64v96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V240c0-10.1-4.7-19.6-12.8-25.6l-25.6-19.2C521.5 183.1 512 164.1 512 144c0-35.3 28.7-64 64-64s64 28.7 64 64z", "M178.2 112.9C194.5 81.6 226.7 64 260.2 64H379.8c33.5 0 65.8 17.6 82.1 48.9C489.5 165.8 544 282.2 544 384v17c0 43.6-35.4 79-79 79c-15.1 0-30.1-2.7-44.2-8l-67.1-25.2c-21.7-8.2-45.7-8.2-67.4 0L219.2 472c-14.1 5.3-29.1 8-44.2 8c-43.6 0-79-35.4-79-79V384c0-101.8 54.5-218.2 82.2-271.1zM260.2 128c-11.4 0-20.8 5.9-25.3 14.5C207.2 195.6 160 299.4 160 384v17c0 8.3 6.7 15 15 15c7.4 0 14.8-1.3 21.7-3.9l67.1-25.2c36.2-13.6 76.1-13.6 112.4 0l67.1 25.2c7 2.6 14.3 3.9 21.7 3.9c8.3 0 15-6.7 15-15V384c0-84.6-47.2-188.4-74.9-241.5c-4.5-8.6-13.9-14.5-25.3-14.5H260.2z"]]
};
var faRaygun = {
  prefix: 'fad',
  iconName: 'raygun',
  icon: [576, 512, [], "e025", ["M64 24.6V74.8C78.5 67.9 94.8 64 112 64h80L102.2 4.1C98.2 1.4 93.4 0 88.6 0C75 0 64 11 64 24.6zM336 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V56zm80 32c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V88z", "M288 64H112C50.1 64 0 114.1 0 176s50.1 112 112 112h8.2L51.4 425.7c-7.9 15.8-1.5 35 14.3 42.9l80 40c15.8 7.9 35 1.5 42.9-14.3L288 295.6V64zM416 208h60.9l77.1 30.9c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2V128c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L476.9 144H416v64zM112 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
};
var faFlute = {
  prefix: 'fad',
  iconName: 'flute',
  icon: [640, 512, [], "f8b9", ["M48 160H96V352H48c-26.5 0-48-21.5-48-48V208c0-26.5 21.5-48 48-48zM592 352H128V160H592c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48zM320 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M128 160H96V352h32V160zM320 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]]
};
var faAcorn = {
  prefix: 'fad',
  iconName: 'acorn',
  icon: [448, 512, [], "f6ae", ["M400 192H48v32c0 78.1 30.5 201.9 165.9 252.4c6.5 2.4 13.7 2.4 20.2 0C369.5 425.9 400 302.1 400 224V192z", "M267.2 38.4c8-10.6 5.8-25.6-4.8-33.6s-25.6-5.8-33.6 4.8L224 16c-10.7 14.3-18 30.7-21.6 48H96C43 64 0 107 0 160c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32c0-53-43-96-96-96H252.1c2.4-6.8 5.9-13.3 10.3-19.2l4.8-6.4z"]]
};
var faVideoArrowUpRight = {
  prefix: 'fad',
  iconName: 'video-arrow-up-right',
  icon: [576, 512, [], "e2c9", ["M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm88 96H264c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V241.9L137 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l103-103H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6L384 315.8V196.2l142.2-94.8c9.8-6.5 22.4-7.2 32.9-1.6zM152 160H264c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V241.9L137 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l103-103H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faGrateDroplet = {
  prefix: 'fad',
  iconName: 'grate-droplet',
  icon: [576, 512, [], "e194", ["M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64h64 96 96 24.2c-15.3-22.9-24.2-50.4-24.2-80c0-23.6 5.8-46.9 16.9-67.8l75.3-141.2c7.6-14.3 20.6-24.5 35.8-28.8V96c0-35.3-28.7-64-64-64H320 224 128 64zm0 64H96V224H64V96zm0 192H96V416H64V288zm96 128V288h32V416H160zm96 0V288h32V416H256zM384 224H352V96h32V224zM288 96V224H256V96h32zm-96 0V224H160V96h32z", "M365.2 347.3l75.3-141.2c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7z"]]
};
var faSealExclamation = {
  prefix: 'fad',
  iconName: 'seal-exclamation',
  icon: [512, 512, [], "e242", ["M222.1 18.4c18.7-18.7 49.1-18.7 67.9 0L335.5 64H400c26.5 0 48 21.5 48 48v64.5l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.5V400c0 26.5-21.5 48-48 48H335.5l-45.6 45.6c-18.7 18.7-49.1 18.7-67.9 0L176.5 448H112c-26.5 0-48-21.5-48-48V335.5L18.4 289.9c-18.7-18.7-18.7-49.1 0-67.9L64 176.5V112c0-26.5 21.5-48 48-48h64.5l45.6-45.6zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faChessBishop = {
  prefix: 'fad',
  iconName: 'chess-bishop',
  icon: [320, 512, [9821], "f43a", ["M258.7 432H61.3c-8.5 0-16.6 3.4-22.6 9.4l-32 32c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512H297.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-32-32c-6-6-14.1-9.4-22.6-9.4z", "M96 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32c0 16.1-11.9 29.4-27.4 31.7c22.4 21.4 51 52.8 74.2 90.9L164.7 260.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l99.4-99.4C301.8 215.6 312 250.7 312 288c0 47.4-30.8 72.3-56 84.7V432H64V372.7C38.8 360.3 8 335.4 8 288C8 190 78.4 106.8 123.4 63.7C107.9 61.4 96 48.1 96 32z"]]
};
var faMessageSms = {
  prefix: 'fad',
  iconName: 'message-sms',
  icon: [512, 512, [], "e1e5", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm202.9 80.8C196.4 147 192 153.1 192 160v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208v48c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6zm173.1 38c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.1 .1 12.9 1.4 20.1 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4c-9.3-.1-20.4 1.9-29.7 7.4c-9.9 5.9-18.6 16.4-18.5 31.6c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7-.2-13.5-2.4-22.6-5.5l0 0 0 0c-1.5-.5-3.2-1.1-4.9-1.6c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.2 .4 2.6 .9 4 1.4l0 0 0 0c8.8 3 20.4 7 32.6 7.4c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.2-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4zm-272 0c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.6 .1 16.7 1.6 23.3 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4c-9.3-.1-20.4 1.9-29.7 7.4C80.6 157.3 72 167.8 72 183c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7.2-.2-14.2-2.6-23.7-5.8l0 0 0 0c-1.3-.4-2.7-.9-4.1-1.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1 .4 2.4 .8 3.6 1.2l0 0 0 0c9 3.1 20.9 7.2 33.2 7.6c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4z", "M220.8 150.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 153.1 192 160v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208v48c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9zM376.5 181c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.1 .1 12.9 1.4 20.1 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4c-9.3-.1-20.4 1.9-29.7 7.4c-9.9 5.9-18.6 16.4-18.5 31.6c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7-.2-13.5-2.4-22.6-5.5l0 0c-1.5-.5-3.2-1.1-4.9-1.6c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.3 .4 2.6 .9 4 1.4l0 0c8.8 3 20.4 7 32.6 7.4c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.2-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4c0-1.1 .2-1.6 .4-1.9zm-272 0c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.6 .1 16.7 1.6 23.3 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4c-9.3-.1-20.4 1.9-29.7 7.4C80.6 157.3 72 167.8 72 183c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7.2-.2-14.2-2.6-23.7-5.8l0 0 0 0c-1.3-.4-2.7-.9-4.1-1.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1 .4 2.4 .8 3.6 1.2l0 0 0 0 0 0c9 3.1 20.9 7.2 33.2 7.6c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4c0-1.1 .2-1.6 .4-1.9z"]]
};
var faCoffeeBeans = {
  prefix: 'fad',
  iconName: 'coffee-beans',
  icon: [512, 512, [], "e13f", ["M278.4 235.4c-55.1-55.1-69.5-132.5-37.9-184.3c8.1 17.8 18.9 38.5 31.3 53.2c27.7 32.8 61.2 44.7 90.7 55.3l1 .4c30.1 10.8 56.2 20.3 78 46.2c10.9 12.8 21.4 33.6 29.5 52.3c1 2.3 2 4.6 2.9 6.8c-51.3 41.5-136.3 29.3-195.6-29.9zm181-181c55.1 55.1 69.5 132.5 37.9 184.3c-8.1-17.8-18.9-38.5-31.3-53.2c-27.7-32.8-61.2-44.7-90.7-55.3l-1-.4c-30.1-10.8-56.2-20.3-78-46.2c-10.9-12.8-21.4-33.6-29.5-52.3c-1-2.3-2-4.6-2.9-6.8C315.1-17 400.2-4.9 459.4 54.4zM0 352c0-77.9 44.5-142.8 103.5-157.1c-6.9 18.3-13.9 40.6-15.5 59.7c-3.6 42.8 11.6 74.9 25 103.2l.4 .9c13.7 28.9 25.3 54.1 22.5 87.8c-1.4 16.7-8.6 38.9-16.1 57.9c-.9 2.4-1.9 4.7-2.8 6.9C51.5 504.5 0 435.8 0 352zm256 0c0 77.9-44.5 142.8-103.5 157.1c6.9-18.3 13.9-40.6 15.5-59.8c3.6-42.8-11.6-74.9-25-103.2l-.4-.9c-13.7-28.9-25.3-54.1-22.5-87.8c1.4-16.7 8.6-38.9 16.1-57.9c.9-2.4 1.9-4.7 2.8-6.9C204.5 199.5 256 268.2 256 352z", "M471 258.5c1 2.3 2 4.6 2.9 6.8c2.8-2.3 5.5-4.7 8.1-7.3c5.9-5.9 11-12.4 15.2-19.4c-8.1-17.8-18.9-38.5-31.3-53.2c-27.7-32.8-61.2-44.7-90.7-55.3l-1-.4c-30.1-10.8-56.2-20.3-78-46.2c-10.9-12.8-21.4-33.6-29.5-52.3c-1-2.3-2-4.6-2.9-6.8c-2.8 2.3-5.5 4.7-8.1 7.3c-5.9 5.9-11 12.4-15.2 19.4c8.1 17.8 18.9 38.5 31.3 53.2c27.7 32.8 61.2 44.7 90.7 55.3l1 .4c30.1 10.8 56.2 20.3 78 46.2c10.9 12.8 21.4 33.6 29.5 52.3zM119.9 504.5c-.9 2.4-1.9 4.7-2.8 6.9c3.6 .4 7.2 .6 10.9 .6c8.4 0 16.6-1 24.5-2.9c6.9-18.3 13.9-40.6 15.5-59.8c3.6-42.8-11.6-74.9-25-103.2l-.4-.9c-13.7-28.9-25.3-54.1-22.5-87.8c1.4-16.7 8.6-38.9 16.1-57.9c.9-2.4 1.9-4.7 2.8-6.9c-3.6-.4-7.2-.6-10.9-.6c-8.4 0-16.6 1-24.5 2.9c-6.9 18.3-13.9 40.6-15.5 59.7c-3.6 42.8 11.6 74.9 25 103.2l.4 .9c13.7 28.9 25.3 54.1 22.5 87.8c-1.4 16.7-8.6 38.9-16.1 57.9z"]]
};
var faHatWitch = {
  prefix: 'fad',
  iconName: 'hat-witch',
  icon: [576, 512, [], "f6e7", ["M553.4 416H22.6C10.1 416 0 426.1 0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512H416c77.4 0 134.1-41.7 153.1-57.8c4.6-3.9 6.9-9.6 6.9-15.6c0-12.5-10.1-22.6-22.6-22.6z", "M96 416L200.6 180.7c15.3-34.4 40.3-63.5 72-83.7L416.1 5c5.2-3.3 11.1-5 17.3-5h2.2c8 0 15.7 3 21.6 8.4l76.4 70.1c6.6 6.1 10.4 14.6 10.4 23.6v6.8c0 2.1-.2 4.2-.6 6.3l-12.2 60.8c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1l-6.2-24.6C482.5 138 469.7 128 455 128H434.6c-11.5 0-22.1 6.2-27.8 16.1l-18.6 32.5c-2.8 4.8-4.2 10.3-4.2 15.9v.7c0 4.5 .9 8.9 2.8 13L480 416H352V368c0-26.5-21.5-48-48-48H272c-26.5 0-48 21.5-48 48v48H96zm160 0V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48H256z"]]
};
var faFaceGrinWink = {
  prefix: 'fad',
  iconName: 'face-grin-wink',
  icon: [512, 512, ["grin-wink"], "f58c", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm124.4-6.4c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z"]]
};
var faGrinWink = faFaceGrinWink;
var faClockThreeThirty = {
  prefix: 'fad',
  iconName: 'clock-three-thirty',
  icon: [512, 512, [], "e357", ["M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V256c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M256 416c-13.3 0-24-10.7-24-24V256c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V392c0 13.3-10.7 24-24 24z"]]
};
var faEarDeaf = {
  prefix: 'fad',
  iconName: 'ear-deaf',
  icon: [512, 512, ["deaf", "deafness", "hard-of-hearing"], "f2a4", ["M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0zm-320 320c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0z", "M128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"]]
};
var faDeaf = faEarDeaf;
var faDeafness = faEarDeaf;
var faHardOfHearing = faEarDeaf;
var faAlarmClock = {
  prefix: 'fad',
  iconName: 'alarm-clock',
  icon: [512, 512, [9200], "f34e", ["M256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zm24-328v94.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17V184c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M14.9 146.4L160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1zM256 160c-13.3 0-24 10.7-24 24V288c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41V184c0-13.3-10.7-24-24-24zM352 25.4L497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4z"]]
};
var faEclipse = {
  prefix: 'fad',
  iconName: 'eclipse',
  icon: [640, 512, [], "f749", ["M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9l9.6 52.2c-34.2 15-63.7 38.9-85.4 68.8c-12.4-4-25.6-6.2-39.4-6.2c-70.7 0-128 57.3-128 128s57.3 128 128 128c13.7 0 27-2.2 39.4-6.2c21.7 29.9 51.1 53.9 85.4 68.8l-9.6 52.2c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM278.1 162.6C264 190.7 256 222.4 256 256s8 65.3 22.1 93.4c-7.1 1.7-14.5 2.6-22.1 2.6c-53 0-96-43-96-96s43-96 96-96c7.6 0 15 .9 22.1 2.6z", "M464 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352z"]]
};
var faFaceRelieved = {
  prefix: 'fad',
  iconName: 'face-relieved',
  icon: [512, 512, [], "e389", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM187.3 356.7c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C329.4 397.2 298.9 416 256 416s-73.4-18.8-91.3-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM207.2 74.9c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zM314.9 95.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 141.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z", "M207.2 74.9c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zM124.8 238.4c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm192 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM314.9 95.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 141.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z"]]
};
var faRoadCircleCheck = {
  prefix: 'fad',
  iconName: 'road-circle-check',
  icon: [640, 512, [], "e564", ["M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32l.7 0c-.5-5.3-.7-10.6-.7-16c0-16.9 2.4-33.3 6.8-48.7c-2.2 .5-4.5 .7-6.8 .7c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32v42.8c31.9-45.2 84.5-74.8 144-74.8c11.6 0 22.9 1.1 33.8 3.2L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faDiceFive = {
  prefix: 'fad',
  iconName: 'dice-five',
  icon: [448, 512, [9860], "f523", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faOctagonMinus = {
  prefix: 'fad',
  iconName: 'octagon-minus',
  icon: [512, 512, ["minus-octagon"], "f308", ["M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z", "M160 256c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24z"]]
};
var faMinusOctagon = faOctagonMinus;
var faSquareRss = {
  prefix: 'fad',
  iconName: 'square-rss',
  icon: [448, 512, ["rss-square"], "f143", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z", "M120 112c-13.3 0-24 10.7-24 24s10.7 24 24 24c110.5 0 200 89.5 200 200c0 13.3 10.7 24 24 24s24-10.7 24-24c0-137-111-248-248-248zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24c57.4 0 104 46.6 104 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-83.9-68.1-152-152-152zm8 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faRssSquare = faSquareRss;
var faFaceZany = {
  prefix: 'fad',
  iconName: 'face-zany',
  icon: [512, 512, [], "e3a4", ["M477.8 128c70.7 122.4 28.7 279-93.7 349.7c-8.5 4.9-17.2 9.3-26.1 13.2c6.4-12.9 10.1-27.5 10.1-42.9V391.7c49.1-40.9 70.1-105.6 55-165c-3.5-13.8-19.5-18.9-31.8-11.8L152.9 352.5c-12.3 7.1-15.9 23.5-5.7 33.4c8.8 8.6 18.5 16 28.9 22.2V448c0 21.1 6.8 40.6 18.4 56.5C129.3 488.3 70.6 446.7 34.4 384C-36.3 261.6 5.6 105 128.1 34.3S407.1 5.6 477.8 128zM192 224A64 64 0 1 0 64 224a64 64 0 1 0 128 0zm120 0a72 72 0 1 0 0-144 72 72 0 1 0 0 144z", "M296 104a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM104 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM336.1 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6z"]]
};
var faTricycle = {
  prefix: 'fad',
  iconName: 'tricycle',
  icon: [512, 512, [], "e5c3", ["M256 352c0-51.5 30.4-95.9 74.2-116.2l14 56.1c-19.4 12.9-32.2 35-32.2 60c0 39.8 32.2 72 72 72s72-32.2 72-72c0-37.5-28.6-68.2-65.2-71.7l-14-56.1c2.4-.1 4.8-.2 7.2-.2c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128zm-88 16A56 56 0 1 0 56 368a56 56 0 1 0 112 0zM0 368a112 112 0 1 1 224 0A112 112 0 1 1 0 368z", "M256 56c0-13.3 10.7-24 24-24h73.6C388.1 32 416 59.9 416 94.4c0 18.2-8 35.5-21.8 47.3l-31.3 26.9 44.4 177.6c3.2 12.9-4.6 25.9-17.5 29.1s-25.9-4.6-29.1-17.5L319.3 192H307.2c-57.6 0-110.9 29.5-141.6 77.6c-14.3-7.8-30.5-12.6-47.8-13.5c1.2-2.3 2.5-4.5 3.9-6.7L77.6 176H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-2.4l19.6 32.6c40-40.7 95.3-64.6 154.1-64.6h10.9c.7-.8 1.5-1.5 2.3-2.2L363 105.3c3.2-2.7 5-6.7 5-10.9c0-7.9-6.4-14.4-14.4-14.4H280c-13.3 0-24-10.7-24-24z"]]
};
var faLandMineOn = {
  prefix: 'fad',
  iconName: 'land-mine-on',
  icon: [640, 512, [], "e51b", ["M224 288c-17.7 0-32 14.3-32 32v32H448V320c0-17.7-14.3-32-32-32H224zm-66.3 96c-18.2 0-34.8 10.3-42.9 26.5L87.2 465.7C76.5 487 92 512 115.8 512H524.2c23.8 0 39.3-25 28.6-46.3l-27.6-55.2c-8.1-16.3-24.8-26.5-42.9-26.5H157.7z", "M320 0c13.3 0 24 10.7 24 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"]]
};
var faSquareArrowUpLeft = {
  prefix: 'fad',
  iconName: 'square-arrow-up-left',
  icon: [448, 512, [], "e263", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM288 144c13.3 0 24 10.7 24 24s-10.7 24-24 24H193.9L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24H288z", "M136 144H288c13.3 0 24 10.7 24 24s-10.7 24-24 24H193.9L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24z"]]
};
var faICursor = {
  prefix: 'fad',
  iconName: 'i-cursor',
  icon: [256, 512, [], "f246", ["M96 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96V224zm64 64h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160v64z", "M29.3 63.9C11.7 62.4-1.4 47 .1 29.3S17-1.4 34.7 .1l8 .7C76.8 3.6 106.8 19.7 128 43.7c21.2-24 51.2-40 85.4-42.9l8-.7c17.6-1.5 33.1 11.6 34.5 29.2s-11.6 33.1-29.2 34.5l-8 .7C185.5 67.3 160 95 160 128.3V383.7c0 33.3 25.5 61 58.7 63.8l8 .7c17.6 1.5 30.7 16.9 29.2 34.5s-16.9 30.7-34.5 29.2l-8-.7c-34.1-2.8-64.2-18.9-85.4-42.9c-21.2 24-51.2 40.1-85.4 42.9l-8 .7C17 513.4 1.6 500.3 .1 482.7s11.6-33.1 29.2-34.5l8-.7C70.5 444.7 96 417 96 383.7V128.3c0-33.3-25.5-61-58.7-63.8l-8-.7z"]]
};
var faChartMixedUpCircleDollar = {
  prefix: 'fad',
  iconName: 'chart-mixed-up-circle-dollar',
  icon: [576, 512, [], "e5d9", ["M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.8L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L480 105v39c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H400zM160 256V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32s-32 14.3-32 32z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z"]]
};
var faSaltShaker = {
  prefix: 'fad',
  iconName: 'salt-shaker',
  icon: [384, 512, [129474], "e446", ["M36.6 192L.6 443.8c-.4 2.8-.6 5.6-.6 8.5c0 33 26.8 59.8 59.8 59.8H324.2c33 0 59.8-26.8 59.8-59.8c0-2.8-.2-5.7-.6-8.5L347.4 192H282.8l36.6 256H64.6l36.6-256H36.6z", "M101.2 192H282.8h64.7l-9.3-65.3C327.7 54 265.4 0 192 0S56.3 54 45.9 126.7L36.6 192h64.6zM176 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]]
};
var faStamp = {
  prefix: 'fad',
  iconName: 'stamp',
  icon: [512, 512, [], "f5bf", ["M32 416v48c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V416H416v32H96V416H32z", "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368v8c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40v-8c0-61.9-50.1-112-112-112H366.2c-29.9 0-54.2-24.3-54.2-54.2z"]]
};
var faFilePlus = {
  prefix: 'fad',
  iconName: 'file-plus',
  icon: [384, 512, [], "f319", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 240c-13.3 0-24 10.7-24 24v48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V360h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V264c0-13.3-10.7-24-24-24z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zM192 240c13.3 0 24 10.7 24 24v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V264c0-13.3 10.7-24 24-24z"]]
};
var faDrawSquare = {
  prefix: 'fad',
  iconName: 'draw-square',
  icon: [448, 512, [], "f5ef", ["M328.6 64H119.4c5.4 9.4 8.6 20.3 8.6 32s-3.1 22.6-8.6 32H328.6c-5.4-9.4-8.6-20.3-8.6-32s3.1-22.6 8.6-32zM352 151.4V360.6c9.4-5.4 20.3-8.6 32-8.6s22.6 3.1 32 8.6V151.4c-9.4 5.4-20.3 8.6-32 8.6s-22.6-3.1-32-8.6zM64 160c-11.7 0-22.6-3.1-32-8.6V360.6c9.4-5.4 20.3-8.6 32-8.6s22.6 3.1 32 8.6V151.4c-9.4 5.4-20.3 8.6-32 8.6zM328.6 448c-5.4-9.4-8.6-20.3-8.6-32s3.1-22.6 8.6-32H119.4c5.4 9.4 8.6 20.3 8.6 32s-3.1 22.6-8.6 32H328.6z", "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM64 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm320 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]]
};
var faToiletPaperUnderSlash = {
  prefix: 'fad',
  iconName: 'toilet-paper-under-slash',
  icon: [640, 512, ["toilet-paper-reverse-slash"], "e2a1", ["M576 426.2V343.1c-9.9 19.5-23.2 38.2-39.9 51.8L576 426.2zm-66-51.7c22.6-14.8 41.4-46 53.1-86.4c8.2-28.2 12.8-61 12.8-96C576 86 533 0 480 0c-11.2 0-22 3.8-32 10.9c-37.3 26.4-64 97.5-64 181.1c0 33.8 4.4 65.5 12 93.1l114 89.3zM356.7 254.3c-3.1-19.9-4.7-40.8-4.7-62.3c0-56.9 11.5-110 31.5-150.1c7.5-15 17.1-29.7 28.7-41.9H160c-24.8 0-47.4 18.8-64.4 49.6L356.7 254.3zM528 512L406.2 416H224v48c0 26.5 21.5 48 48 48H528l.3 0H528zM64 192c0 106 43 192 96 192H365.5L66.5 148.4C64.9 162.4 64 177 64 192zm416 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
var faStairs = {
  prefix: 'fad',
  iconName: 'stairs',
  icon: [576, 512, [], "e289", ["M384 96h64v64H384V96zM256 224h64v64H256V224zM192 352v64H128V352h64z", "M416 32c-17.7 0-32 14.3-32 32V96h64 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H416zM384 160H288c-17.7 0-32 14.3-32 32v32h64 96c17.7 0 32-14.3 32-32V160H384zM160 288c-17.7 0-32 14.3-32 32v32h64 96c17.7 0 32-14.3 32-32V288H256 160zm32 128H128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32-14.3 32-32V416z"]]
};
var faDroneFront = {
  prefix: 'fad',
  iconName: 'drone-front',
  icon: [640, 512, ["drone-alt"], "f860", ["M24 112c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm352 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z", "M160 160H96v32 64c0 12.6 7.4 24.1 19 29.2l56.5 25.1c-17.8 21.5-27.5 48.5-27.5 76.4V392c0 13.3 10.7 24 24 24s24-10.7 24-24v-5.2c0-16.8 5.9-33.2 16.7-46.1l8.4-10.1L259 349.2c4.1 1.8 8.5 2.8 13 2.8h96c4.5 0 8.9-.9 13-2.8l41.9-18.6 8.4 10.1c10.8 12.9 16.7 29.3 16.7 46.1V392c0 13.3 10.7 24 24 24s24-10.7 24-24v-5.2c0-27.9-9.7-54.9-27.5-76.4L525 285.2c11.6-5.1 19-16.6 19-29.2V192 160H480v32 43.2l-17.8 7.9-40.6-23.7C390.7 201.5 355.7 192 320 192s-70.7 9.5-101.6 27.5l-40.6 23.7L160 235.2V192 160zm324.3-48h55.4c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16zM128 96c-11.8 0-22.2 6.4-27.7 16h55.4c-5.5-9.6-15.9-16-27.7-16z"]]
};
var faDroneAlt = faDroneFront;
var faGlassEmpty = {
  prefix: 'fad',
  iconName: 'glass-empty',
  icon: [384, 512, [], "e191", ["M8.6 10.2C14.6 3.7 23.1 0 32 0H352c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1L355.1 437.7c-3 41.9-37.8 74.3-79.8 74.3H108.7c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64L92.7 433.1c.6 8.4 7.6 14.9 16 14.9H275.3c8.4 0 15.4-6.5 16-14.9L317.6 64H66.4z", ""]]
};
var faDialHigh = {
  prefix: 'fad',
  iconName: 'dial-high',
  icon: [576, 512, [], "e15c", ["M256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M446.6 263.6c-11.6-77-78-136-158.2-136c-88.4 0-160 71.6-160 160s71.6 160 160 160c80.2 0 146.6-59 158.2-136l-158.2 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l158.2 0z"]]
};
var faUserHelmetSafety = {
  prefix: 'fad',
  iconName: 'user-helmet-safety',
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", ["M97 176c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128s128-57.3 128-128c0-5.4-.3-10.8-1-16H97z", "M216 0c-13.3 0-24 10.7-24 24V80L163.6 23.1C125.6 43.5 99 82.6 96.2 128H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24h-.2C349 82.6 322.4 43.5 284.4 23.1L256 80V24c0-13.3-10.7-24-24-24H216zM134.4 352C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352H134.4z"]]
};
var faUserConstruction = faUserHelmetSafety;
var faUserHardHat = faUserHelmetSafety;
var faI = {
  prefix: 'fad',
  iconName: 'i',
  icon: [320, 512, [105], "49", ["M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96h96V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 32z", ""]]
};
var faHryvniaSign = {
  prefix: 'fad',
  iconName: 'hryvnia-sign',
  icon: [384, 512, [8372, "hryvnia"], "f6f2", ["M260.9 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H155.5l91.8-52.5c5.3-3 9.9-7 13.6-11.5zM99.8 272H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H52.3c7.5-26.1 24.2-49 47.5-64zm23.2 64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l-91.8 52.5c-5.3 3-9.9 7-13.6 11.5zm161.1-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H331.7c-7.5 26.1-24.2 49-47.5 64z", "M179.6 96c-21 0-41.3 7.1-57.7 20.2L116 121c-13.8 11-33.9 8.8-45-5s-8.8-33.9 5-45l5.9-4.7C109.7 44.1 144.1 32 179.6 32H223c62.4 0 113 50.6 113 113c0 40.5-21.7 78-56.9 98.1L136.7 324.5c-15.3 8.7-24.7 25-24.7 42.5c0 27.1 21.9 49 49 49h43.4c21 0 41.3-7.1 57.7-20.2L268 391c13.8-11 33.9-8.8 45 5s8.8 33.9-5 45l-5.9 4.7c-27.7 22.2-62.2 34.3-97.7 34.3H161C98.6 480 48 429.4 48 367c0-40.6 21.7-78 56.9-98.1l142.4-81.4c15.3-8.7 24.7-25 24.7-42.5c0-27.1-21.9-49-49-49H179.6z"]]
};
var faHryvnia = faHryvniaSign;
var faArrowDownLeftAndArrowUpRightToCenter = {
  prefix: 'fad',
  iconName: 'arrow-down-left-and-arrow-up-right-to-center',
  icon: [512, 512, [], "e092", ["M48 304c0-17.7 14.3-32 32-32H208c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32s-32-14.3-32-32V381.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L130.7 336H80c-17.7 0-32-14.3-32-32z", "M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3L381.3 176H432c17.7 0 32 14.3 32 32s-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32s32 14.3 32 32v50.7L457.4 9.4c12.5-12.5 32.8-12.5 45.3 0z"]]
};
var faPills = {
  prefix: 'fad',
  iconName: 'pills',
  icon: [576, 512, [], "f484", ["M224 256V224l0-80c0-61.9-50.1-112-112-112S0 82.1 0 144v80 32H32l160 0h32zM554.9 399.4C568.3 376 576 348.9 576 320c0-88.4-71.6-160-160-160c-28.9 0-56 7.7-79.4 21.1c-12.3 7.1-13.1 23.7-3.1 33.8L521.1 402.5c10 10 26.7 9.3 33.8-3.1zm-59.5 59.5c12.3-7.1 13.1-23.7 3.1-33.8L310.9 237.5c-10-10-26.7-9.3-33.8 3.1C263.7 264 256 291.1 256 320c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1z", "M32 256H0v32 80c0 61.9 50.1 112 112 112s112-50.1 112-112V288 256H192 32z"]]
};
var faFaceGrinWide = {
  prefix: 'fad',
  iconName: 'face-grin-wide',
  icon: [512, 512, [128515, "grin-alt"], "f581", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z", "M176 256c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zm160 0c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z"]]
};
var faGrinAlt = faFaceGrinWide;
var faTooth = {
  prefix: 'fad',
  iconName: 'tooth',
  icon: [448, 512, [129463], "f5c9", ["M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z", ""]]
};
var faBasketballHoop = {
  prefix: 'fad',
  iconName: 'basketball-hoop',
  icon: [640, 512, [], "f435", ["M6.8 187C24.7 153.1 116.7 0 320 0S615.3 153.1 633.2 187c4.9 9.4 6.8 19.1 6.8 28V331.2c0 25.3-14.9 48.2-38 58.5l-96.4 42.9L526.2 288H528c13.3 0 24-10.7 24-24s-10.7-24-24-24H480V224 160c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64 16H112c-13.3 0-24 10.7-24 24s10.7 24 24 24h1.8l20.7 144.6L38 389.7C14.9 379.4 0 356.5 0 331.2V214.9c0-8.9 1.8-18.6 6.8-28zM192 240V224 160H448v64 16H192z", "M112 240c-13.3 0-24 10.7-24 24s10.7 24 24 24h34.1l7.2 50.3 22.9 160c.9 6.1 5.2 11.2 11.1 13s12.3 .1 16.5-4.4L255.6 451l52.8 56c3 3.2 7.2 5 11.6 5s8.6-1.8 11.6-5l52.8-56 51.9 55.9c4.2 4.5 10.6 6.2 16.5 4.4s10.2-6.9 11.1-13l22.9-160 7.2-50.3H528c13.3 0 24-10.7 24-24s-10.7-24-24-24H112zm349.6 48l-5.2 36.6-44-36.6h49.2zm-99.3 0l.6 .5L320 334.6l-42.8-46.1 .6-.5h84.4zm-134.5 0l-44 36.6L178.4 288h49.2zm159.8 21l48.7 40.5-51.6 54.7-42.7-46L387.5 309zm49.4 151.6l-30.5-32.9 41.5-44-11 76.8zM320 381.7l42.6 45.9L320 472.7l-42.6-45.2L320 381.7zm-21.8-23.5l-42.7 46-51.6-54.7L252.5 309l45.7 49.2zm-64.6 69.5l-30.5 32.9-11-76.8 41.5 44z"]]
};
var faObjectsAlignBottom = {
  prefix: 'fad',
  iconName: 'objects-align-bottom',
  icon: [512, 512, [], "e3bb", ["M112 384c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0l64 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-64 0zm224 0c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-64 0z", "M0 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24z"]]
};
var faV = {
  prefix: 'fad',
  iconName: 'v',
  icon: [384, 512, [118], "56", ["M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z", ""]]
};
var faSparkles = {
  prefix: 'fad',
  iconName: 'sparkles',
  icon: [512, 512, [10024], "f890", ["M327.5 85.2L384 64 405.2 7.5C406.9 3 411.2 0 416 0s9.1 3 10.8 7.5L448 64l56.5 21.2c4.5 1.7 7.5 6 7.5 10.8s-3 9.1-7.5 10.8L448 128l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5s-9.1-3-10.8-7.5L384 128l-56.5-21.2c-4.5-1.7-7.5-6-7.5-10.8s3-9.1 7.5-10.8zm0 320L384 384l21.2-56.5c1.7-4.5 6-7.5 10.8-7.5s9.1 3 10.8 7.5L448 384l56.5 21.2c4.5 1.7 7.5 6 7.5 10.8s-3 9.1-7.5 10.8L448 448l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5s-9.1-3-10.8-7.5L384 448l-56.5-21.2c-4.5-1.7-7.5-6-7.5-10.8s3-9.1 7.5-10.8z", "M205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.4 187.4 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3z"]]
};
var faSquid = {
  prefix: 'fad',
  iconName: 'squid',
  icon: [512, 512, [129425], "e450", ["M392.7 23.6c-49.9 15.2-90.2 34-122.4 54.7L257.3 19.5c-1.2-5.3 .4-10.8 4.2-14.7S270.7-.8 276 .3L392.7 23.6zm41.8 218.9c20.7-32.2 39.4-72.5 54.7-122.4l23.3 116.7c1.1 5.3-.6 10.8-4.5 14.6s-9.4 5.4-14.7 4.2l-58.9-13.1z", "M512.7 18.6c.8-5.1-.8-10.3-4.5-13.9S499.4-.6 494.3 .2c-238 39.7-322.1 146.4-334.5 226.5l-14-14-2-2-22.6-22.6c-6.2-6.2-6.2-16.4 0-22.6l56.4-56.4c18.9-18.9 18.7-49.5-.3-68.2L140.1 4.6c-6.3-6.1-16.3-6.1-22.5 .1l-2.8 2.8c-34 34-33.3 87.7-1.9 121L98.5 142.9c-18.7 18.7-18.7 49.1 0 67.9l22.6 22.6 0 0 5.7 5.7 0 0c9.3 9.4 9.3 24.5 0 33.9c-9.3 9.3-24.4 9.4-33.8 .2L76.5 256.6c-19.1-19.1-50.2-18.7-68.7 .9L4.4 261c-6.1 6.4-5.8 16.5 .6 22.6s16.5 5.8 22.6-.6l3.3-3.5c6.2-6.5 16.6-6.7 22.9-.3l10.6 10.6 .2 .2 22.6 22.6c10.1 10.2 9 26.9-2.4 35.8l-20 15.6c-3.5 2.7-7.7 4.2-12.1 4.2c-10.9 0-19.7-8.8-19.7-19.7V336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 12.3C.9 376.8 24.1 400 52.6 400c11.5 0 22.7-3.8 31.8-10.9l28.2-21.9c9.4-7.3 22.8-6.5 31.2 1.9s9.3 21.8 1.9 31.2l-21.9 28.2c-7.1 9.1-10.9 20.3-10.9 31.8c0 28.6 23.2 51.7 51.7 51.7h12.3c8.8 0 16-7.2 16-16s-7.2-16-16-16H164.6c-10.9 0-19.7-8.8-19.7-19.7c0-4.4 1.5-8.7 4.2-12.1l15.6-20c8.8-11.4 25.6-12.4 35.8-2.3l.1 .1L223 448.3l.1 .1 9.9 9.9c6.5 6.5 6.2 17.2-.7 23.3l-2.8 2.5c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l2.8-2.5c20.7-18.3 21.6-50.3 2.1-69.8l-9.9-9.9-5.7-5.7-.1-.1c-9.2-9.3-9.2-24.4 0-33.8l.1-.1 .1-.1c9.3-9.2 24.4-9.2 33.7 0l28.4 28.4c18.7 18.7 49.1 18.7 67.9 0L384.4 400c33.3 31.4 87 32.1 121-1.9l2.8-2.8c6.2-6.2 6.3-16.3 .1-22.5L472 335.7c-18.7-19-49.3-19.2-68.2-.3l-56.4 56.4c-6.2 6.2-16.4 6.2-22.6 0l-22.5-22.5-.1-.1-16-16C366.3 340.8 473 256.6 512.7 18.6zM168.9 280a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faLeafyGreen = {
  prefix: 'fad',
  iconName: 'leafy-green',
  icon: [576, 512, [129388], "e41d", ["M109.3 421.5L94.2 436.6C84 426.2 78.3 412.3 78.3 397.8l0-12.9c0-14.7-5.8-28.8-16.3-39.2L35.7 319.3c-10.4-10.4-16.3-24.5-16.3-39.2V244.4c0-13.1-5.3-25.4-11-37.1c-15.2-31.1-9.9-69.6 15.9-95.4c2.1-2.1 4.3-4.1 6.5-5.9C50.6 89.9 70 69.6 83 47.7c4.1-6.9 9.1-13.4 15-19.3c37.9-37.9 99.4-37.9 137.3 0c5.9 5.9 10.9 12.4 15 19.3c1.2 2.1 2.5 4.1 3.9 6.2c-3.6 5.9-6.6 12.3-8.9 18.9c-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3v43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3v45.7c0 17-6.7 33.3-18.7 45.3zM475.3 123.3L390.6 208H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H358.6l-59.3 59.3-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L272 281.4V192c0-8.8 7.2-16 16-16s16 7.2 16 16v57.4l36.7-36.7 112-112c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z", "M572.5 140c-7.3 28.4-8.1 60.8-5 89.9c.3 3.3 .5 6.7 .5 10.1c0 42.1-27.1 77.9-64.9 90.8c-14.3 4.9-28.6 10.6-39.3 21.3l-29.1 29.1c-12 12-28.3 18.7-45.3 18.7h-43c-17 0-33.3 6.7-45.3 18.7l-10.5 10.5c-12 12-28.3 18.7-45.3 18.7H199.8c-17 0-33.3 6.7-45.3 18.7l-35.9 35.9c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.9-35.9c12-12 18.7-28.3 18.7-45.3V330.5c0-17 6.7-33.3 18.7-45.3l10.5-10.5c12-12 18.7-28.3 18.7-45.3v-43c0-17 6.7-33.3 18.7-45.3l29.1-29.1c10.7-10.7 16.4-25 21.3-39.3C258.1 35.1 293.9 8 336 8c3.4 0 6.8 .2 10.1 .5c29.1 3.1 61.5 2.3 89.9-5C445 1.2 454.3 0 464 0c61.9 0 112 50.1 112 112c0 9.7-1.2 19-3.5 28zm-97.2-16.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-112 112L304 249.4V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48L358.6 240H448c8.8 0 16-7.2 16-16s-7.2-16-16-16H390.6l84.7-84.7z"]]
};
var faCircleArrowUpRight = {
  prefix: 'fad',
  iconName: 'circle-arrow-up-right',
  icon: [512, 512, [], "e0fc", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm368 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-94.1L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135L184 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l160 0c13.3 0 24 10.7 24 24l0 152z", "M368 168l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-94.1L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135L184 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l160 0c13.3 0 24 10.7 24 24z"]]
};
var faCalendars = {
  prefix: 'fad',
  iconName: 'calendars',
  icon: [512, 512, [], "e0d7", ["M96 192H512V368c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V192z", "M224 0c-17.7 0-32 14.3-32 32V64H144c-26.5 0-48 21.5-48 48v80H512V112c0-26.5-21.5-48-48-48H416V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H256V32c0-17.7-14.3-32-32-32zM48 184c0-13.3-10.7-24-24-24s-24 10.7-24 24V392c0 66.3 53.7 120 120 120H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V184z"]]
};
var faBangladeshiTakaSign = {
  prefix: 'fad',
  iconName: 'bangladeshi-taka-sign',
  icon: [384, 512, [], "e2e6", ["M64 160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V160zm64 64h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H128v64z", "M.2 60C2.4 42.5 18.4 30.1 36 32.2l7.9 1c48 6 84.1 46.8 84.1 95.3V384c0 17.7 14.3 32 32 32h32c70.7 0 128-57.3 128-128V256c0-17.7-14.3-32-32-32H272c-17.7 0-32-14.3-32-32s14.3-32 32-32h16c53 0 96 43 96 96v32c0 106-86 192-192 192H160c-53 0-96-43-96-96V128.5c0-16.1-12-29.8-28-31.8l-7.9-1C10.5 93.6-1.9 77.6 .2 60z"]]
};
var faBicycle = {
  prefix: 'fad',
  iconName: 'bicycle',
  icon: [640, 512, [128690], "f206", ["M431.1 252.8C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6l27.5 50.9c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3l-27.5-50.9zM128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112H198.2c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l26.2-52.3c-10-2.5-20.5-3.8-31.2-3.8z", "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-77 153.9c-9 18.1 4.1 39.4 24.3 39.4H304c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 81.4 150.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM166.8 320l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"]]
};
var faHammerWar = {
  prefix: 'fad',
  iconName: 'hammer-war',
  icon: [384, 512, [], "f6e4", ["M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V50.8l27.3 4.1c3.1 .5 6.3 .5 9.5 0L224 50.8V32zm0 237.2l-27.3-4.1c-3.1-.5-6.3-.5-9.5 0L160 269.2V480c0 17.7 14.3 32 32 32s32-14.3 32-32V269.2z", "M36.7 32.4c-9.2-1.4-18.6 1.3-25.6 7.4S0 54.7 0 64V256c0 9.3 4.1 18.2 11.1 24.2s16.4 8.8 25.6 7.4l150.5-22.6c3.1-.5 6.3-.5 9.5 0l150.5 22.6c9.2 1.4 18.6-1.3 25.6-7.4s11.1-14.9 11.1-24.2V64c0-9.3-4.1-18.2-11.1-24.2s-16.4-8.8-25.6-7.4L196.7 54.9c-3.1 .5-6.3 .5-9.5 0L36.7 32.4z"]]
};
var faCircleD = {
  prefix: 'fad',
  iconName: 'circle-d',
  icon: [512, 512, [], "e104", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128h72c70.7 0 128 57.3 128 128s-57.3 128-128 128H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm72 208c44.2 0 80-35.8 80-80s-35.8-80-80-80H208V336h48z", "M160 152c0-13.3 10.7-24 24-24h72c70.7 0 128 57.3 128 128s-57.3 128-128 128H184c-13.3 0-24-10.7-24-24V152zm48 24V336h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H208z"]]
};
var faSpiderBlackWidow = {
  prefix: 'fad',
  iconName: 'spider-black-widow',
  icon: [512, 512, [], "f718", ["M158.4 32.6l-32.5 84.6c-1.1 3-.4 6.3 1.8 8.5L176 174.1v51.3l-24.9-8.3L93.7 159.7C78.1 144 73.1 120.6 81.1 100l32.5-84.6c4.8-12.4 18.6-18.5 31-13.8s18.5 18.6 13.8 31zM418.3 159.7l-57.4 57.4L336 225.4V174.1l48.3-48.3c2.2-2.2 2.9-5.6 1.8-8.5L353.6 32.6c-4.8-12.4 1.4-26.3 13.8-31s26.3 1.4 31 13.8L430.9 100c7.9 20.7 3 44.1-12.7 59.7zM218.4 307.2c-1.6-2.1-2.4-4.6-2.4-7.2c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12c0 2.6-.8 5.1-2.4 7.2L272 336l21.6 28.8c1.6 2.1 2.4 4.6 2.4 7.2c0 6.6-5.4 12-12 12H228c-6.6 0-12-5.4-12-12c0-2.6 .8-5.1 2.4-7.2L240 336l-21.6-28.8z", "M240 101.2c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160v65.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1L336 225.4V160c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16V101.2zm-21.6 206c-1.6-2.1-2.4-4.6-2.4-7.2c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12c0 2.6-.8 5.1-2.4 7.2L272 336l21.6 28.8c1.6 2.1 2.4 4.6 2.4 7.2c0 6.6-5.4 12-12 12H228c-6.6 0-12-5.4-12-12c0-2.6 .8-5.1 2.4-7.2L240 336l-21.6-28.8z"]]
};
var faStaffSnake = {
  prefix: 'fad',
  iconName: 'staff-snake',
  icon: [384, 512, ["rod-asclepius", "rod-snake", "staff-aesculapius"], "e579", ["M222.5 48h-61H72 64 56C25.1 48 0 73.1 0 104s25.1 56 56 56H72c22.3 0 41.6-13.1 50.6-32H164h56 68c8.8 0 16 7.2 16 16s-7.2 16-16 16H219l-2.5 80H288c53 0 96-43 96-96s-43-96-96-96H222.5zm-55 192L165 160H152c-53 0-96 43-96 96s43 96 96 96h19 42 43c8.8 0 16 7.2 16 16s-7.2 16-16 16H212l-2.1 67.5-.4 12.5H256c53 0 96-43 96-96s-43-96-96-96H215.5h-47H152c-8.8 0-16-7.2-16-16s7.2-16 16-16h15.5zm6.6 211.5L172 384H136c-22.1 0-40 17.9-40 40s17.9 40 40 40h38.5l-.4-12.5zM64 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z", "M222.6 43.2L223 32c0-.7 0-1.3 0-1.9c-.5-16.6-14.1-30-31-30s-30.5 13.4-31 30c0 .6 0 1.3 0 1.9l.4 11.2 .1 4.8h61l.1-4.8zM215.5 272L220 128H164l4.5 144h47zM213 352H171l3.1 99.5 1.4 43.5 0 1c.3 8.9 7.6 16 16.5 16s16.2-7.1 16.5-16l0-1 1.4-43.5L213 352z"]]
};
var faRodAsclepius = faStaffSnake;
var faRodSnake = faStaffSnake;
var faStaffAesculapius = faStaffSnake;
var faPear = {
  prefix: 'fad',
  iconName: 'pear',
  icon: [512, 512, [], "e20c", ["M423.9 54.1C403.4 40.2 378.7 32 352 32c-30.7 0-58.9 10.8-81 28.9c-36.5 29.9-81.8 61.4-127.4 73.3c-32 8.3-62.3 25-87.3 50.1c-75 75-75 196.5 0 271.5s196.5 75 271.5 0c25.1-25.1 41.8-55.3 50.1-87.3c11.8-45.7 43.4-90.9 73.3-127.4c18-22.1 28.9-50.3 28.9-81c0-26.7-8.2-51.4-22.1-71.9L425 121c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l32.9-32.9zM304 304c8.8 0 16 7.2 16 16c0 70.7-57.3 128-128 128c-8.8 0-16-7.2-16-16s7.2-16 16-16c53 0 96-43 96-96c0-8.8 7.2-16 16-16z", "M505 7c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faHeadSideCoughSlash = {
  prefix: 'fad',
  iconName: 'head-side-cough-slash',
  icon: [640, 512, [], "e062", ["M0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM89.6 44.9C127 16.7 173.5 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 5.8L89.6 44.9zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-88-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faTriangle = {
  prefix: 'fad',
  iconName: 'triangle',
  icon: [512, 512, [9650], "f2ec", ["M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480H472c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z", ""]]
};
var faApartment = {
  prefix: 'fad',
  iconName: 'apartment',
  icon: [576, 512, [], "e468", ["M176 0c-26.5 0-48 21.5-48 48V96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48h80 32 96V416c0-17.7 14.3-32 32-32s32 14.3 32 32v96h96 32 80c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H448V48c0-26.5-21.5-48-48-48H176zM368 320H336c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm144 80c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm16 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm112-80H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM384 80v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zM384 208c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM496 320H464c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 208c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm112 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16z", "M384 80c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80zM112 320c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zm272-16V272c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 96V368c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm-384 0V368c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm112-80c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zm0-256H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM384 208V176c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 320c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zM128 208V176c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm112 16c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32z"]]
};
var faTruckMedical = {
  prefix: 'fad',
  iconName: 'truck-medical',
  icon: [640, 512, [128657, "ambulance"], "f0f9", ["M176 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48l48 0c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240v48c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16V192H128c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16l48 0V80zM96 432a80 80 0 1 1 160 0A80 80 0 1 1 96 432zm288 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576h-1.1c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H286.9c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM176 80v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H240V80c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"]]
};
var faAmbulance = faTruckMedical;
var faPepper = {
  prefix: 'fad',
  iconName: 'pepper',
  icon: [512, 512, [129745], "e432", ["M216.7 97.4c-.3-.1-.6-.1-.9-.2c-8.8-1.5-17.9-1.7-27.1-.6c-4 .5-7.9 1.2-11.9 2.2c-51.4 12.9-74.7 65-61.9 116.4l37.1 148.3c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6L83.8 223c-11.8-47 .4-94.4 31.3-125.2c-13.6-2.8-28-2.6-42.4 1C21.3 111.7-10 163.8 2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.8c7-1.7 13.6-4.2 19.8-7.3c5.6-2.8 12.3-2.8 17.9 0c3 1.5 6 2.8 9.2 4c10.7 4 22.2 6.2 34 6.2c11.6 0 22.9-2.1 33.5-6.1c3.2-1.2 6.4-2.6 9.4-4.1c5.6-2.8 12.3-2.8 17.9 0c6.2 3.1 12.8 5.6 19.8 7.3c51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.8-116.4c-23.2-5.8-46.5-2.6-66.3 7.3c-5.6 2.8-12.3 2.8-17.9 0c-6.2-3.1-12.8-5.6-19.8-7.3c-24.5-6.1-49.1-2.2-69.6 9c-6 3.3-13.4 3.3-19.4 0c-9.2-5-19.2-8.6-29.6-10.5z", "M252.6 11.7C245.8 .3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c6.7 11.2 10.3 24 10.3 37v10.9c4.9 1.8 9.7 3.9 14.3 6.4c6 3.3 13.4 3.3 19.4 0c4.6-2.5 9.4-4.7 14.3-6.4V90.6c0-21.7-5.9-43.1-17.1-61.7L252.6 11.7z"]]
};
var faPiano = {
  prefix: 'fad',
  iconName: 'piano',
  icon: [512, 512, [], "f8d4", ["M0 448V352H64v96H448V352h64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z", "M0 192V352H96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h96V327.6c0-24.2-13.7-46.4-35.4-57.2l-58.4-29.2c-21-10.5-34.2-31.9-34.2-55.4C384 83.2 300.8 0 198.3 0H192C86 0 0 86 0 192z"]]
};
var faGunSquirt = {
  prefix: 'fad',
  iconName: 'gun-squirt',
  icon: [576, 512, [], "e19d", ["M96 192c-17.7 0-32-14.3-32-32H480c0 17.7-14.3 32-32 32H96zM272 376H219l12-48h41V312c0-13.3 10.7-24 24-24s24 10.7 24 24v40 40c0 13.3-10.7 24-24 24s-24-10.7-24-24V376z", "M104 32c13.3 0 24 10.7 24 24v8H448c41.8 0 77.4 26.7 90.5 64H552c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H538.5c-13.2 37.3-48.7 64-90.5 64H249L199 455.8C195.5 470 182.7 480 168 480H64c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L79.4 254.6C34.3 246.7 0 207.3 0 160c0-47.6 34.6-87.1 80-94.7V56c0-13.3 10.7-24 24-24zm-8 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"]]
};
var faWheatAwnCircleExclamation = {
  prefix: 'fad',
  iconName: 'wheat-awn-circle-exclamation',
  icon: [640, 512, [], "e598", ["M505 7c-9.4-9.4-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88c9.4-9.4 9.4-24.6 0-33.9zM295.3 262l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L294.2 16 271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-22.6-22.6-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L90.5 219.6 67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6-22.6-22.6c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faSnowman = {
  prefix: 'fad',
  iconName: 'snowman',
  icon: [512, 512, [9731, 9924], "f7d0", ["M342.3 152.6c-2.8-3.4-3.3-8.1-1.2-12C348 127.2 352 112.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 16.1 4 31.2 10.9 44.6c2 3.9 1.6 8.6-1.2 12C153.7 172 144 196.9 144 224c0 11.5 1.7 22.5 4.9 32.9c1.2 3.8 .1 8-2.8 10.8C115.3 296.9 96 338.2 96 384c0 44.7 18.3 85 47.8 114.1c9.9 9.7 23.7 13.9 37.5 13.9H330.7c13.9 0 27.7-4.2 37.5-13.9C397.7 469 416 428.7 416 384c0-45.8-19.3-87.1-50.1-116.3c-2.9-2.8-4-6.9-2.8-10.8c3.2-10.4 4.9-21.5 4.9-32.9c0-27.1-9.7-52-25.7-71.4zM208 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM272 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-32 43.2V120c0-8.8 7.2-16 16-16s16 7.2 16 16v3.2c0 3.2-.8 6.3-2.3 9l-9 16.9c-.9 1.7-2.7 2.8-4.7 2.8s-3.8-1.1-4.7-2.8l-9-16.9c-1.5-2.8-2.3-5.9-2.3-9z", "M224 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm32 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM272 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 96c13.3 0 24 10.7 24 24v40.2L152.6 181c-5.5 13.2-8.6 27.8-8.6 43c0 1.9 0 3.7 .1 5.6L70.5 198.1l-56-24C2.4 168.8-3.3 154.7 1.9 142.5s19.3-17.8 31.5-12.6L56 139.6V120c0-13.3 10.7-24 24-24zM368 224c0-15.2-3-29.8-8.6-43L408 160.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c.1-1.9 .1-3.7 .1-5.6z"]]
};
var faUserAlien = {
  prefix: 'fad',
  iconName: 'user-alien',
  icon: [448, 512, [], "e04a", ["M64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 101-106.6 185-139.2 208.3c-6.1 4.3-13.4 6.5-20.8 6.5s-14.7-2.1-20.8-6.5C170.6 352 64 268.1 64 167zm244.6 9c-37.9 0-68.6 30.7-68.6 68.6c0 6.3 5.1 11.4 11.4 11.4h16c37.9 0 68.6-30.7 68.6-68.6c0-6.3-5.1-11.4-11.4-11.4h-16zM208 244.6c0-37.9-30.7-68.6-68.6-68.6h-16c-6.3 0-11.4 5.1-11.4 11.4c0 37.9 30.7 68.6 68.6 68.6h16c6.3 0 11.4-5.1 11.4-11.4zM0 486.4C0 415 55.7 356.6 126.1 352.3c23.8 23.2 46.1 40.2 58.5 49.1c12 8.6 25.9 12.4 39.4 12.4s27.4-3.8 39.4-12.4c12.4-8.8 34.7-25.8 58.5-49.1C392.3 356.6 448 415 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4z", "M139.4 176c37.9 0 68.6 30.7 68.6 68.6c0 6.3-5.1 11.4-11.4 11.4h-16c-37.9 0-68.6-30.7-68.6-68.6c0-6.3 5.1-11.4 11.4-11.4h16zm169.1 0h16c6.3 0 11.4 5.1 11.4 11.4c0 37.9-30.7 68.6-68.6 68.6h-16c-6.3 0-11.4-5.1-11.4-11.4c0-37.9 30.7-68.6 68.6-68.6z"]]
};
var faShieldCheck = {
  prefix: 'fad',
  iconName: 'shield-check',
  icon: [512, 512, [], "f2f7", ["M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faMortarPestle = {
  prefix: 'fad',
  iconName: 'mortar-pestle',
  icon: [512, 512, [], "f5a7", ["M502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5S474.5-3.7 461 6.2L213.7 188.5c-1.5 1.1-3 2.3-4.4 3.5H365.3L502.6 54.6z", "M0 224c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32c0 82.5-43.4 147.7-123.9 176.2c11.1 13.9 19.4 30.3 23.9 48.1c4.4 17.1-10.4 31.7-28.1 31.7H160c-17.7 0-32.4-14.6-28.1-31.7c4.5-17.8 12.8-34.1 23.9-48.1C75.4 403.7 32 338.5 32 256c-17.7 0-32-14.3-32-32z"]]
};
var faRoadBarrier = {
  prefix: 'fad',
  iconName: 'road-barrier',
  icon: [640, 512, [], "e562", ["M405.2 96H330.8l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zM362.8 288h74.3l5.4-10.7L533.2 96H458.8l-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96H202.8zm288 192H576V117.7L490.8 288zM64 96V266.3L149.2 96H64z", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm576 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"]]
};
var faChartCandlestick = {
  prefix: 'fad',
  iconName: 'chart-candlestick',
  icon: [512, 512, [], "e0e2", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M304 32c8.8 0 16 7.2 16 16V96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32V48c0-8.8 7.2-16 16-16zM416 192V144c0-8.8 7.2-16 16-16s16 7.2 16 16v48c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM128 160c0-17.7 14.3-32 32-32V80c0-8.8 7.2-16 16-16s16 7.2 16 16v48c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c-17.7 0-32-14.3-32-32V160z"]]
};
var faBriefcaseBlank = {
  prefix: 'fad',
  iconName: 'briefcase-blank',
  icon: [512, 512, [], "e0c8", ["M184 48c-4.4 0-8 3.6-8 8V96H128V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96H336V56c0-4.4-3.6-8-8-8H184z", "M64 96C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64z"]]
};
var faSchool = {
  prefix: 'fad',
  iconName: 'school',
  icon: [640, 512, [127979], "f549", ["M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM256 416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H256V416zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM320 88a88 88 0 1 1 0 176 88 88 0 1 1 0-176z", "M336 144v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zM80 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208zm416 0c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336z"]]
};
var faIgloo = {
  prefix: 'fad',
  iconName: 'igloo',
  icon: [576, 512, [], "f7ae", ["M288 32c10.8 0 21.5 .6 32 1.8V160H48.5C100.2 82.8 188.1 32 288 32zM527.5 160H352V39.1C424.9 55.7 487.2 99.8 527.5 160zM0 320c0-46 10.8-89.4 29.9-128H96V320L0 320zm197.5 0L128 320V192H448V320l-69.5 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64zM384 352l192 0v80c0 26.5-21.5 48-48 48H384V352zM192 480H48c-26.5 0-48-21.5-48-48V352l192 0V480zM576 320l-96 0V192h66.1c19.2 38.6 29.9 82 29.9 128z", "M320 33.8c10.9 1.2 21.5 3 32 5.4V160H527.5c6.8 10.2 13 20.9 18.6 32H480V320h96v32l-192 0V480H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64V480H192V352L0 352V320H96V192H29.9c5.5-11.1 11.7-21.8 18.6-32H320V33.8zM197.5 320c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H448V192H128V320h69.5z"]]
};
var faBracketRound = {
  prefix: 'fad',
  iconName: 'bracket-round',
  icon: [192, 512, ["parenthesis"], "28", ["M154.6 46.2c9.8 14.7 5.8 34.6-8.9 44.4C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4c14.7 9.8 18.7 29.7 8.9 44.4s-29.7 18.7-44.4 8.9C71.9 449 0 371.8 0 256S71.9 62.9 110.2 37.4c14.7-9.8 34.6-5.8 44.4 8.9z", ""]]
};
var faParenthesis = faBracketRound;
var faJoint = {
  prefix: 'fad',
  iconName: 'joint',
  icon: [640, 512, [], "f595", ["M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11z", "M214.7 358c5.2-.8 10.5-.3 15.2 2c10.2 4.9 19.3 12 26.7 20.8L358.9 503.7c2.6 3.2 .5 8.3-3.6 8.3H288c-59.2 0-127.7-14.7-180.2-28.8C81.3 476 58.3 468.9 42 463.6c-8.2-2.7-14.7-4.9-19.2-6.5c-2.3-.8-4-1.4-5.2-1.8l-1.3-.5C6.8 451.5 0 442.6 0 432s6.8-19.5 16.3-22.7l1.3-.5c1.2-.4 3-1.1 5.2-1.8c4.5-1.6 11-3.8 19.2-6.5c16.3-5.4 39.2-12.5 65.7-19.6c31.7-8.5 69.2-17.3 106.9-22.8zM464 512H445c-23.7 0-46.3-10.5-61.5-28.8L281.1 360.3c-2.6-3.2-.6-8.2 3.5-8.3c1.1 0 2.3 0 3.4 0h48 19c23.7 0 46.3 10.5 61.5 28.8L518.9 503.7c2.6 3.2 .5 8.3-3.6 8.3H464zM444.7 352H600c22.1 0 40 17.9 40 40v80c0 21.4-16.8 38.9-37.9 39.9c-22.7-.8-44-11.2-58.6-28.7L441.1 360.3c-2.6-3.2-.5-8.3 3.6-8.3z"]]
};
var faHorseSaddle = {
  prefix: 'fad',
  iconName: 'horse-saddle',
  icon: [576, 512, [], "f8c3", ["M160 128H320v48c0 38.7-27.5 71-64 78.4V328c0 8.8-7.2 16-16 16s-16-7.2-16-16V254.4c-36.5-7.4-64-39.7-64-78.4V128zM64 212.8c0 3.6 .2 7.1 .7 10.7C54.6 230.8 48 242.6 48 256v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-44.6 33.2-81.5 76.3-87.2C68.5 181.6 64 196.7 64 212.8z", "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128v48c0 38.7-27.5 71-64 78.4v74.7l51.7 14.8c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM224 254.4c-36.5-7.4-64-39.7-64-78.4V128H148.8C102 128 64 166 64 212.8c0 16.8 5 33.1 14.2 47.1l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l.3 .1V254.4zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faMugMarshmallows = {
  prefix: 'fad',
  iconName: 'mug-marshmallows',
  icon: [512, 512, [], "f7b7", ["M197.7 125.7L200 128H344l2.3-2.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L285.7 37.7C282 34 277.1 32 272 32s-10 2-13.7 5.7L197.7 98.3C194 102 192 106.9 192 112s2 10 5.7 13.7zM32 64v64H162.6c-1.7-5.1-2.6-10.5-2.6-16c0-13.6 5.4-26.7 15-36.3l36.8-36.8C206.4 34.6 199.5 32 192 32H64C46.3 32 32 46.3 32 64zm128 96H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160z", "M96 160H32c-17.7 0-32 14.3-32 32V384c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM384 320V224h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384z"]]
};
var faFilters = {
  prefix: 'fad',
  iconName: 'filters',
  icon: [640, 512, [], "e17e", ["M40 96H164.1c3.2 9 8.2 17.4 14.9 24.7L320 274v16.7l-32 34.8V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V325.5L10.6 163.1C-.2 151.4-3 134.5 3.4 119.9S24.1 96 40 96z", "M195.4 55.9C201.7 41.4 216.1 32 232 32H600c15.9 0 30.2 9.4 36.6 23.9s3.6 31.5-7.2 43.2L480 261.5V416c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V261.5L202.6 99.1c-10.7-11.7-13.6-28.6-7.2-43.2z"]]
};
var faBellOn = {
  prefix: 'fad',
  iconName: 'bell-on',
  icon: [640, 512, [128365], "f8fa", ["M320 0c-17.7 0-32 14.3-32 32V51.2C215 66 160 130.6 160 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416H512c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C497.3 319.2 480 273.9 480 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32z", "M586.7 53.5c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-64 32c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l64-32zM0 200c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm512 0c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H536c-13.3 0-24 10.7-24 24zM42.5 21.3c-5.9 11.9-1.1 26.3 10.7 32.2l64 32c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-64-32C62.9 4.6 48.5 9.4 42.5 21.3zm322.7 472c12-12 18.7-28.3 18.7-45.3H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"]]
};
var faAngleRight = {
  prefix: 'fad',
  iconName: 'angle-right',
  icon: [320, 512, [8250], "f105", ["M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z", ""]]
};
var faDialMed = {
  prefix: 'fad',
  iconName: 'dial-med',
  icon: [576, 512, [], "e15f", ["M256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M264 129c-77 11.6-136 78-136 158.2c0 88.4 71.6 160 160 160s160-71.6 160-160C448 207 389 140.6 312 129l0 158.2c0 13.3-10.7 24-24 24s-24-10.7-24-24L264 129z"]]
};
var faHorse = {
  prefix: 'fad',
  iconName: 'horse',
  icon: [576, 512, [128014], "f6f0", ["M76.3 168.8C68.5 181.6 64 196.7 64 212.8c0 3.6 .2 7.1 .7 10.7C54.6 230.8 48 242.6 48 256v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-44.6 33.2-81.5 76.3-87.2z", "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128H224 203.2 148.8C102 128 64 166 64 212.8c0 16.8 5 33.1 14.2 47.1l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faQ = {
  prefix: 'fad',
  iconName: 'q',
  icon: [448, 512, [113], "51", ["M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z", ""]]
};
var faMonitorWaveform = {
  prefix: 'fad',
  iconName: 'monitor-waveform',
  icon: [576, 512, ["monitor-heart-rate"], "f611", ["M512 96H64V256H192c6.1 0 11.6 3.4 14.3 8.8L224 300.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L329.9 256H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-6.1 0-11.6-3.4-14.3-8.8L288 243.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L182.1 288H64V416H512V96z", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM512 96V416H64V96H512z"]]
};
var faMonitorHeartRate = faMonitorWaveform;
var faLinkSimple = {
  prefix: 'fad',
  iconName: 'link-simple',
  icon: [576, 512, [], "e1cd", ["M160 256c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32z", "M160 96C71.6 96 0 167.6 0 256s71.6 160 160 160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-53 0-96-43-96-96s43-96 96-96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm256 0H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96 43 96 96s-43 96-96 96H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c88.4 0 160-71.6 160-160s-71.6-160-160-160z"]]
};
var faWhistle = {
  prefix: 'fad',
  iconName: 'whistle',
  icon: [640, 512, [], "f460", ["M288 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm92.7 111c-34.8 49-92 81-156.7 81C118 448 32 362 32 256S118 64 224 64c51 0 97.4 19.9 131.8 52.4c1.1 .5 2.2 1.2 3.2 2l62.4 48.3c5.1 4 7.3 10.6 5.6 16.9l-5.7 21.1c-3.2 11.7 1.1 24.2 10.8 31.5c9.6 7.2 22.7 7.9 33 1.7l17.7-10.6c5.7-3.4 12.8-3 18 1.1l128.6 99.6C636.1 333 640 341 640 349.4c0 6.8-2.5 13.4-7.1 18.4l-63.4 69.7c-6.1 6.7-14.7 10.5-23.7 10.5h-2c-5.2 0-10.2-1.2-14.8-3.6L380.7 367z", "M0 128c0 28.4 18.5 52.5 44.1 60.8c6.1-16.3 14.4-31.6 24.4-45.5c-1.4 .4-2.9 .6-4.5 .6c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16c0 .3 0 .7 0 1c11.4-12.9 24.5-24.3 39-33.8C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128zM224 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faG = {
  prefix: 'fad',
  iconName: 'g',
  icon: [448, 512, [103], "47", ["M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H400c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z", ""]]
};
var faWineGlassCrack = {
  prefix: 'fad',
  iconName: 'wine-glass-crack',
  icon: [320, 512, ["fragile"], "f4bb", ["M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H208l25.8 51.7c3.5 7.1 1.4 15.7-5.1 20.3l-58.4 40.9c-6 4.2-8.4 12-5.8 18.9l31.1 81c2.1 5.5-1.9 11.4-7.8 11.4c-2.4 0-4.7-1.1-6.3-2.9L92.1 118c-6.4-7.4-4.7-18.7 3.5-24l58.6-37.3c7.6-4.8 9.7-14.9 4.7-22.4L136 0H64z", "M154.2 56.8L95.7 94c-8.2 5.2-9.9 16.6-3.5 24l89.3 103.1c1.6 1.8 3.9 2.9 6.3 2.9c5.9 0 9.9-5.9 7.8-11.4l-31.1-81c-2.6-6.9-.3-14.6 5.8-18.9l58.4-40.9c6.5-4.5 8.7-13.2 5.1-20.3L208 0H136l22.9 34.4c5 7.5 2.8 17.6-4.7 22.4z"]]
};
var faFragile = faWineGlassCrack;
var faSlotMachine = {
  prefix: 'fad',
  iconName: 'slot-machine',
  icon: [640, 512, [], "e3ce", ["M64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm16 80h59.9c23 0 38.5 23.5 29.4 44.6L126.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L115.6 224H80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 24c0-13.3 10.7-24 24-24h59.9c23 0 38.5 23.5 29.4 44.6L270.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L259.6 224H224c-13.3 0-24-10.7-24-24zm168-24h59.9c23 0 38.5 23.5 29.4 44.6L414.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L403.6 224H368c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M128 0H384c35.3 0 64 28.7 64 64H64C64 28.7 92.7 0 128 0zM640 176c0 14.2-6.2 27-16 35.8V416c0 53-43 96-96 96H448 416 128c-35.3 0-64-28.7-64-64V416H448v32h80c17.7 0 32-14.3 32-32V211.8c-9.8-8.8-16-21.6-16-35.8c0-26.5 21.5-48 48-48s48 21.5 48 48z"]]
};
var faNotesMedical = {
  prefix: 'fad',
  iconName: 'notes-medical',
  icon: [512, 512, [], "f481", ["M96 96V352c0 35.3 28.7 64 64 64H357.5c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm160 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V256H208c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16h48V144z", "M296 464c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296zM256 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48l48 0c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V256H208c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16l48 0V144z"]]
};
var faCarWash = {
  prefix: 'fad',
  iconName: 'car-wash',
  icon: [448, 512, [], "f5e6", ["M112 80c0 32-21.5 48-48 48s-48-21.5-48-48C16 48 64 0 64 0s48 48 48 80zm160 0c0 32-21.5 48-48 48s-48-21.5-48-48c0-32 48-80 48-80s48 48 48 80zm112 48c-26.5 0-48-21.5-48-48c0-32 48-80 48-80s48 48 48 80s-21.5 48-48 48z", "M138.8 234.6L119.7 288H328.3l-19.1-53.4c-2.3-6.4-8.3-10.6-15.1-10.6H153.8c-6.8 0-12.8 4.3-15.1 10.6zM50.2 292.4l28.3-79.3C89.9 181.3 120 160 153.8 160H294.2c33.8 0 64 21.3 75.3 53.1l28.3 79.3c20.1 8.5 34.2 28.4 34.2 51.6v40 64 32c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V448H96v32c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V448 384 344c0-23.2 14.1-43.1 34.2-51.6zM120 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faEscalator = {
  prefix: 'fad',
  iconName: 'escalator',
  icon: [640, 512, [], "e171", ["M405.9 175.8C417.5 165.6 432.5 160 448 160h96c35.3 0 64 28.7 64 64s-28.7 64-64 64H472L234.1 496.2C222.5 506.4 207.5 512 192 512H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h72L405.9 175.8z", "M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm64 192v16.4l-128 112V192c0-35.3 28.7-64 64-64s64 28.7 64 64z"]]
};
var faCommentImage = {
  prefix: 'fad',
  iconName: 'comment-image',
  icon: [512, 512, [], "e148", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm168-16c7.6 0 14.7 3.6 19.2 9.6l96 128c5.5 7.3 6.3 17 2.3 25.1s-12.4 13.3-21.5 13.3H200 120c-9.3 0-17.8-5.4-21.7-13.8s-2.7-18.4 3.3-25.5l40-48c4.6-5.5 11.3-8.6 18.4-8.6s13.9 3.2 18.4 8.6L199 257.3l77.8-103.7c4.5-6 11.6-9.6 19.2-9.6z", "M296 144c7.6 0 14.7 3.6 19.2 9.6l96 128c5.5 7.3 6.3 17 2.3 25.1s-12.4 13.3-21.5 13.3H200 120c-9.3 0-17.8-5.4-21.7-13.8s-2.7-18.4 3.3-25.5l40-48c4.6-5.5 11.3-8.6 18.4-8.6s13.9 3.2 18.4 8.6L199 257.3l77.8-103.7c4.5-6 11.6-9.6 19.2-9.6z"]]
};
var faTemperatureHalf = {
  prefix: 'fad',
  iconName: 'temperature-half',
  icon: [320, 512, [127777, "temperature-2", "thermometer-2", "thermometer-half"], "f2c9", ["M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M176 208c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V208z"]]
};
var faTemperature2 = faTemperatureHalf;
var faThermometer2 = faTemperatureHalf;
var faThermometerHalf = faTemperatureHalf;
var faDongSign = {
  prefix: 'fad',
  iconName: 'dong-sign',
  icon: [384, 512, [], "e169", ["M256 64v64H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm64 64V64c17.7 0 32 14.3 32 32s-14.3 32-32 32zM0 480c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M288 32c-17.7 0-32 14.3-32 32V177.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V288 64c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]]
};
var faDonut = {
  prefix: 'fad',
  iconName: 'donut',
  icon: [512, 512, [127849, "doughnut"], "e406", ["M171.3 123.3l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm224 9.4l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-64 150.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM197.7 372.4c18.4 7.8 38.3 11.7 58.3 11.6c20 .2 39.9-3.7 58.3-11.6c14.4-6 29.8-9 45.4-8.8c18.8 1.6 37.8-1.8 54.9-9.7s32-20.2 43-35.5c5.8-9 14.4-15.9 24.4-19.6c11.6-3.8 22-10.6 29.9-19.9V304c0 88.4-114.6 160-256 160S0 392.4 0 304V278.8c7.9 9.2 18.3 16.1 29.9 19.8c10 3.8 18.5 10.6 24.4 19.6c11 15.4 25.8 27.7 43 35.6s36.1 11.3 55 9.8c15.6-.2 31 2.9 45.4 8.8z", "M0 208C0 119.6 114.6 48 256 48s256 71.6 256 160v70.9c-7.9 9.2-18.3 16.1-29.9 19.9c-10 3.7-18.6 10.6-24.4 19.6c-11 15.4-25.8 27.6-43 35.5s-36.1 11.3-54.9 9.7c-15.6-.2-31 2.9-45.4 8.8C295.9 380.3 276 384.2 256 384c-20 .2-39.9-3.7-58.3-11.6c-14.4-6-29.8-9-45.4-8.8c-18.9 1.5-37.8-1.8-55-9.8s-32-20.2-43-35.6c-5.8-9-14.4-15.8-24.4-19.6C18.3 294.9 7.9 288 0 278.8V208zm320-16c0-17.7-28.7-32-64-32s-64 14.3-64 32s28.7 32 64 32s64-14.3 64-32zM283.3 84.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-112 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm224 9.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zM64 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm331.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-240 16c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm176 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"]]
};
var faDoughnut = faDonut;
var faCapsules = {
  prefix: 'fad',
  iconName: 'capsules',
  icon: [576, 512, [], "f46b", ["M224 256H192 160l-96 0H32 0V192 144C0 82.1 50.1 32 112 32s112 50.1 112 112l0 48v64zm85.1 83.7L256 262.2V98.3c4.6-4.7 9.7-9.1 15.3-13.1c50.7-36.2 120.5-23.6 156 28.1l66.6 97.1L309.1 339.7z", "M372.3 431.7l-63.1-92L361.6 303l0 0 79.9-55.9 0 0 52.4-36.7 61.9 90.2c35.5 51.7 23.2 123-27.5 159.2s-120.5 23.6-156-28.1zm116.4-22.4c.8-.5 1.6-1 2.4-1.6c.5-.4 1.1-.8 1.6-1.2l-4 2.8zM0 256H32 64h96 32 32v64 48c0 61.9-50.1 112-112 112S0 429.9 0 368V320 256z"]]
};
var faPooStorm = {
  prefix: 'fad',
  iconName: 'poo-storm',
  icon: [448, 512, ["poo-bolt"], "f75a", ["M286.3 247.2c3.4-6.7 1.6-14.9-4.3-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H233.9l52.4-104.8z", "M222.4 5.9c3.5-4.3 9-6.5 14.5-5.7C283.9 6.5 320 46.7 320 95.4c0 5.7-.5 11.2-1.4 16.6H320c35.3 0 64 28.7 64 64c0 12-3.3 23.1-9 32.7c41.2 5.4 73 40.6 73 83.3c0 46.4-37.6 84-84 84H351.3c1.3-7.8 .7-16-2-23.9C342.5 332.9 324.4 320 304 320H285.7l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2L82 330.5C68.9 341 62.4 357.5 64.3 373.7C27.4 364.8 0 331.6 0 292c0-42.7 31.8-77.9 73-83.3c-5.7-9.6-9-20.8-9-32.7c0-35.3 28.7-64 64-64h16.3c23.8 0 44-6.3 57.8-17C215.5 84.5 224 69.1 224 47.3c0-9.2-1.5-18-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.3z"]]
};
var faPooBolt = faPooStorm;
var faTally1 = {
  prefix: 'fad',
  iconName: 'tally-1',
  icon: [640, 512, [], "e294", ["", "M128 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"]]
};
var faFaceFrownOpen = {
  prefix: 'fad',
  iconName: 'face-frown-open',
  icon: [512, 512, [128550, "frown-open"], "f57a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM179.3 385.4c-12.3 5.2-26.1-4.2-20.8-16.4c16.7-38.2 55.8-65.1 101.5-65.1c45.7 0 84.9 26.9 101.5 65.1c5.3 12.2-8.6 21.5-20.8 16.4c-24.4-10.3-51.8-16.1-80.7-16.1c-28.9 0-56.2 5.8-80.6 16.1z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faFrownOpen = faFaceFrownOpen;
var faSquareDashed = {
  prefix: 'fad',
  iconName: 'square-dashed',
  icon: [448, 512, [], "e269", ["M96 32h32V96H96c-17.7 0-32 14.3-32 32v32H0V128C0 75 43 32 96 32zm0 384h32v64H96c-53 0-96-43-96-96V352H64v32c0 17.7 14.3 32 32 32zm256 64H320V416h32c17.7 0 32-14.3 32-32V352h64v32c0 53-43 96-96 96zm96-320H384V128c0-17.7-14.3-32-32-32H320V32h32c53 0 96 43 96 96v32z", "M0 192V320H64V192H0zm384 0V320h64V192H384zM160 480H288V416H160v64zm0-384H288V32H160V96z"]]
};
var faSquareJ = {
  prefix: 'fad',
  iconName: 'square-j',
  icon: [448, 512, [], "e273", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 152V288c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M280 128c13.3 0 24 10.7 24 24V288c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24z"]]
};
var faHandPointUp = {
  prefix: 'fad',
  iconName: 'hand-point-up',
  icon: [384, 512, [9757], "f0a6", ["M64 0C81.7 0 96 14.3 96 32V240H32V32C32 14.3 46.3 0 64 0zM224 312l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z", "M128 160c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm128 0c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]]
};
var faMoneyBill = {
  prefix: 'fad',
  iconName: 'money-bill',
  icon: [576, 512, [], "f0d6", ["M448 128H128c0 35.3-28.7 64-64 64V320c35.3 0 64 28.7 64 64H448c0-35.3 28.7-64 64-64V192c-35.3 0-64-28.7-64-64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm384 64c0 35.3 28.7 64 64 64V320c-35.3 0-64 28.7-64 64H128c0-35.3-28.7-64-64-64V192c35.3 0 64-28.7 64-64H448z"]]
};
var faArrowUpBigSmall = {
  prefix: 'fad',
  iconName: 'arrow-up-big-small',
  icon: [576, 512, ["sort-size-up"], "f88e", ["M368 32c-26.5 0-48 21.5-48 48V208c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368zm0 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H368z", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z"]]
};
var faSortSizeUp = faArrowUpBigSmall;
var faBarcodeRead = {
  prefix: 'fad',
  iconName: 'barcode-read',
  icon: [576, 512, [], "f464", ["M48 56c0-4.4 3.6-8 8-8h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C25.1 0 0 25.1 0 56v80c0 13.3 10.7 24 24 24s24-10.7 24-24V56zm480 0v80c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-30.9-25.1-56-56-56H440c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c4.4 0 8 3.6 8 8zM56 464c-4.4 0-8-3.6-8-8V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 30.9 25.1 56 56 56h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm472-8c0 4.4-3.6 8-8 8H440c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c30.9 0 56-25.1 56-56V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v80z", "M152 128c-13.3 0-24 10.7-24 24V360c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H152zm160 0c-13.3 0-24 10.7-24 24V360c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H312zm72 24V360c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24zM240 128c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16z"]]
};
var faBaguette = {
  prefix: 'fad',
  iconName: 'baguette',
  icon: [640, 512, [129366], "e3d8", ["M583 234.5c58.8-39.2 74.7-118.7 35.5-177.5S499.8-17.7 441 21.5L356.5 77.8l70.8 70.8c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L329.3 96l-88 58.7 74 74c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-78.6-78.6-88 58.7 77.2 77.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L98.9 249.6 57 277.5C-1.8 316.7-17.7 396.2 21.5 455s118.7 74.7 177.5 35.5l384-256z", "M356.5 77.8L329.3 95.9l75.4 75.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L356.5 77.8zM126.1 231.4L98.9 249.5l81.8 81.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-77.2-77.2zm115.2-76.8l-27.2 18.1 78.6 78.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-74-74z"]]
};
var faBowlSoftServe = {
  prefix: 'fad',
  iconName: 'bowl-soft-serve',
  icon: [512, 512, [], "e46b", ["M256 0h32c70.7 0 128 57.3 128 128c0 11.8-3.2 22.8-8.8 32.3C448 164 480 198.3 480 240c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80c0-41.7 32-76 72.8-79.7C99.2 150.8 96 139.8 96 128c0-35.3 28.7-64 64-64h81.3c17 0 30.7-13.7 30.7-30.7c0-6.1-1.8-12-5.2-17L256 0z", "M64 320c-8.8 0-16 7.2-16 16v8c0 57.4 46.6 104 104 104h30.1l-20.4 40.8c-1.1 2.3-1.7 4.7-1.7 7.2c0 2.9 .8 5.8 2.4 8.4c2.9 4.7 8.1 7.6 13.6 7.6H336c5.5 0 10.7-2.9 13.6-7.6c1.6-2.6 2.4-5.5 2.4-8.4c0-2.4-.6-4.9-1.7-7.2L329.9 448H360c57.4 0 104-46.6 104-104v-8c0-8.8-7.2-16-16-16H64z"]]
};
var faFaceHoldingBackTears = {
  prefix: 'fad',
  iconName: 'face-holding-back-tears',
  icon: [512, 512, [129401], "e482", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM344.5 367.9c-6.7-5.8-16.8-5.1-22.6 1.6C309 384.4 287.1 400 256 400s-53-15.6-65.9-30.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6C183.1 410.3 213.2 432 256 432s72.9-21.7 90.1-41.5c5.8-6.7 5.1-16.8-1.6-22.6zM240 272V240c0-41.5-31.5-75.6-72-79.6c10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9c1 8.1 7.9 14 15.9 14c-10 13.4-16 30-16 48s6 34.6 16 48v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.7c9.8 4.3 20.6 6.7 32 6.7c18 0 34.6-6 48-16c0 8.8 7.2 16 16 16s16-7.2 16-16V288 272zm144 41.3V320c0 8.8 7.2 16 16 16s16-7.2 16-16V288c10-13.4 16-30 16-48s-6-34.6-16-48c8 0 14.9-5.9 15.9-14c1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8c-40.4 4-72 38.1-72 79.6c0 44.2 35.8 80 80 80c11.4 0 22.2-2.4 32-6.7z", "M191.4 116.4l-1.5 5.2c-10.6 37-42.2 64.1-80.4 68.9L98 191.9c-8.8 1.1-16.8-5.1-17.9-13.9s5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8zm129.2 0c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9s-9.1 15-17.9 13.9l-11.5-1.4c-38.2-4.8-69.8-31.9-80.4-68.9l-1.5-5.2zM128 232c17.7 0 32-14.3 32-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4c17.7 0 32-14.3 32-32z"]]
};
var faSquareUp = {
  prefix: 'fad',
  iconName: 'square-up',
  icon: [448, 512, [11014, "arrow-alt-square-up"], "f353", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm39.1 185.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H272v96c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V256H118.3C106 256 96 246 96 233.7c0-6.2 2.6-12.1 7.1-16.3z", "M210.2 117.5L103.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3C96 246 106 256 118.3 256H176v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h57.7c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L237.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5z"]]
};
var faArrowAltSquareUp = faSquareUp;
var faTrainSubwayTunnel = {
  prefix: 'fad',
  iconName: 'train-subway-tunnel',
  icon: [512, 512, ["subway-tunnel"], "e2a3", ["M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h41.4l64.3-64.3C137.3 444.5 112 417.2 112 384V192c0-35.3 28.7-64 64-64H336c35.3 0 64 28.7 64 64V384c0 33.2-25.3 60.5-57.7 63.7L406.6 512H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM361.4 512l-64-64H214.6l-64 64H361.4zM184 192c-13.3 0-24 10.7-24 24v8 64 8c0 13.3 10.7 24 24 24h8 16 8c13.3 0 24-10.7 24-24v-8V224v-8c0-13.3-10.7-24-24-24h-8H192h-8zm88 24v8 64 8c0 13.3 10.7 24 24 24h8 16 8c13.3 0 24-10.7 24-24v-8V224v-8c0-13.3-10.7-24-24-24h-8H304h-8c-13.3 0-24 10.7-24 24z", "M112 192c0-35.3 28.7-64 64-64H336c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H176c-35.3 0-64-28.7-64-64V192zm48 24v8 64 8c0 13.3 10.7 24 24 24h8 16 8c13.3 0 24-10.7 24-24v-8V224v-8c0-13.3-10.7-24-24-24h-8H192h-8c-13.3 0-24 10.7-24 24zm136-24c-13.3 0-24 10.7-24 24v8 64 8c0 13.3 10.7 24 24 24h8 16 8c13.3 0 24-10.7 24-24v-8V224v-8c0-13.3-10.7-24-24-24h-8H304h-8zM208 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm120 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faSubwayTunnel = faTrainSubwayTunnel;
var faSquareExclamation = {
  prefix: 'fad',
  iconName: 'square-exclamation',
  icon: [448, 512, ["exclamation-square"], "f321", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M248 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faExclamationSquare = faSquareExclamation;
var faSemicolon = {
  prefix: 'fad',
  iconName: 'semicolon',
  icon: [192, 512, [], "3b", ["M83.7 492.8L150.8 383c6-9.8 9.2-21.2 9.2-32.7c0-34.2-27.7-62.3-61.9-62.3c-29.2 0-54.4 20.4-60.6 49L10.4 463.6C5 488.5 24 512 49.5 512c14 0 26.9-7.3 34.2-19.2z", "M32 128a64 64 0 1 1 128 0A64 64 0 1 1 32 128z"]]
};
var faBookmark = {
  prefix: 'fad',
  iconName: 'bookmark',
  icon: [384, 512, [128278, 61591], "f02e", ["M192 288l-71.1 47.4c-10.6 7.1-24.9-.5-24.9-13.3V0H288V322.1c0 12.8-14.2 20.4-24.9 13.3L192 288z", "M0 487.7V48C0 21.5 21.5 0 48 0H96V322.1c0 12.8 14.2 20.4 24.9 13.3L192 288l71.1 47.4c10.6 7.1 24.9-.5 24.9-13.3V0h48c26.5 0 48 21.5 48 48V487.7c0 13.4-10.9 24.3-24.3 24.3c-5 0-9.9-1.5-14-4.4L192 400 38.3 507.6c-4.1 2.9-9 4.4-14 4.4C10.9 512 0 501.1 0 487.7z"]]
};
var faFanTable = {
  prefix: 'fad',
  iconName: 'fan-table',
  icon: [448, 512, [], "e004", ["M432 208c0 104-76.3 190.2-176 205.6V448H192V413.6C92.3 398.2 16 312 16 208C16 93.1 109.1 0 224 0S432 93.1 432 208zM224.3 166L184.9 68.5c-3.3-8.2-12.6-12.2-20.8-8.8C119 77.9 97.2 129.1 115.4 174.2c12.6 31.1 40.9 51.1 72.1 54.5l-64.8 82.9c-5.4 7-4.2 17 2.8 22.5c38.3 29.9 93.6 23.1 123.5-15.2c20.7-26.4 23.8-61 11.2-89.7l104.2 14.6c8.8 1.2 16.8-4.9 18.1-13.6c6.8-48.1-26.8-92.6-74.9-99.4c-33.2-4.7-64.7 9.9-83.3 35.1z", "M184.9 68.5L224.3 166c18.5-25.3 50-39.8 83.3-35.1c48.1 6.8 81.7 51.3 74.9 99.4c-1.2 8.8-9.3 14.8-18.1 13.6L260.2 229.2c12.6 28.7 9.5 63.2-11.2 89.7c-29.9 38.3-85.2 45.1-123.5 15.2c-7-5.4-8.2-15.5-2.8-22.5l64.8-82.9c-31.2-3.4-59.5-23.4-72.1-54.5C97.2 129.1 119 77.9 164.1 59.7c8.2-3.3 17.5 .6 20.8 8.8zM240 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 448H224 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224 96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]]
};
var faAlignJustify = {
  prefix: 'fad',
  iconName: 'align-justify',
  icon: [448, 512, [], "f039", ["M32 352c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zM32 96C14.3 96 0 81.7 0 64S14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z", "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"]]
};
var faBatteryLow = {
  prefix: 'fad',
  iconName: 'battery-low',
  icon: [576, 512, ["battery-1"], "e0b1", ["M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z", "M96 192h64V320H96z"]]
};
var faBattery1 = faBatteryLow;
var faCreditCardFront = {
  prefix: 'fad',
  iconName: 'credit-card-front',
  icon: [576, 512, [], "f38a", ["M112 288c-8.8 0-16 7.2-16 16s7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM96 368c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM112 288c-8.8 0-16 7.2-16 16s7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM96 368c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zM408 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H408z"]]
};
var faBrainArrowCurvedRight = {
  prefix: 'fad',
  iconName: 'brain-arrow-curved-right',
  icon: [640, 512, ["mind-share"], "f677", ["M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7c5.7 2.7 11.1 6.1 16 10c-1.4 4.6-2.2 9.4-2.2 14.3v16H448c-79.5 0-144 64.5-144 144c0 43.3 17.3 75 33.5 95.2c-3.1 .5-6.3 .8-9.5 .8c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z", "M521.9 241.2c6-2.5 12.9-1.1 17.4 3.5l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8V400H464c-35.3 0-64 28.7-64 64v35.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.7-2.2c-10.5-8.2-45-39.5-45-93.8c0-61.9 50.1-112 112-112h64V256c0-6.5 3.9-12.3 9.9-14.8z"]]
};
var faMindShare = faBrainArrowCurvedRight;
var faUmbrellaBeach = {
  prefix: 'fad',
  iconName: 'umbrella-beach',
  icon: [576, 512, [127958], "f5ca", ["M297.1 219.8l60.1 21.9L282.1 448H214l83.1-228.2z", "M434 269.7L223.5 193l3.3-9.1c18.1-49.8 45.6-95.6 80.9-135.1l4-4.5C335 18.3 371.8 8.9 404.8 20.6c.9 .3 1.9 .7 2.8 1.1c31.9 12.6 53.3 43 54.4 77.4l.2 6c1.7 52.9-6.8 105.7-24.9 155.5l-3.3 9.1zM287.8 23.1l-4 4.5c-38 42.5-67.6 91.9-87.1 145.5l-3.3 9.1-71-25.8c-18.1-6.6-26.4-27.7-15.3-43.4C153.7 47.1 228.8 7.3 308.4 4.9C300.9 10 294 16.1 287.8 23.1zM494 98.1c-.3-8.5-1.4-16.8-3.4-24.8c56.9 53 87.3 130 80.8 208.5c-1.6 19.2-21.5 30-39.6 23.4l-67.7-24.6 3.3-9.1c19.5-53.6 28.6-110.4 26.8-167.4l-.2-6zM32 448H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]]
};
var faHelmetUn = {
  prefix: 'fad',
  iconName: 'helmet-un',
  icon: [512, 512, [], "e503", ["M215.7 384L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.6l-1.6-1.5V288H320V416.9L242.3 343l-14.6 25.1L218.4 384h-2.7z", "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384H200h18.4l9.3-15.9L274.4 288H448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM285.3 103.1l34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faLocationSmile = {
  prefix: 'fad',
  iconName: 'location-smile',
  icon: [384, 512, ["map-marker-smile"], "f60d", ["M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-95.4 84.9c6.2 9.4 29.1 31.1 63.4 31.1s57.1-21.7 63.4-31.1c6.1-9.2 18.5-11.7 27.7-5.5s11.7 18.5 5.5 27.7C277.1 284.4 243.1 316 192 316s-85.1-31.6-96.6-48.9c-6.1-9.2-3.6-21.6 5.5-27.7s21.6-3.6 27.7 5.5z", "M160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128.6 244.9c-6.1-9.2-18.5-11.7-27.7-5.5s-11.7 18.5-5.5 27.7C106.9 284.4 140.9 316 192 316s85.1-31.6 96.6-48.9c6.1-9.2 3.6-21.6-5.5-27.7s-21.6-3.6-27.7 5.5c-6.2 9.4-29.1 31.1-63.4 31.1s-57.1-21.7-63.4-31.1z"]]
};
var faMapMarkerSmile = faLocationSmile;
var faArrowLeftToLine = {
  prefix: 'fad',
  iconName: 'arrow-left-to-line',
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", ["M32 448c-17.7 0-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32z", "M137.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L237.3 224 416 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-178.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"]]
};
var faArrowToLeft = faArrowLeftToLine;
var faBullseye = {
  prefix: 'fad',
  iconName: 'bullseye',
  icon: [512, 512, [], "f140", ["M256 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224a144 144 0 1 0 0-288 144 144 0 1 0 0 288z", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faSushi = {
  prefix: 'fad',
  iconName: 'sushi',
  icon: [576, 512, [127843, "nigiri"], "e48a", ["M32 384V369c8.5 .7 17.5-.3 26.4-3.4l193-66.9c20-6.9 41.6-7.1 61.7-.4l205.5 68.2c8.6 2.9 17.2 3.8 25.5 3.1V384c0 35.3-28.7 64-64 64c-19.1 0-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7C132.3 439.6 115.1 448 96 448c-35.3 0-64-28.7-64-64z", "M405.9 295.5L506.3 125.6c24.8 26.7 42.1 60.7 48.5 98.8l12.5 75.2c4 23.8-18.8 43.2-41.7 35.6L405.9 295.5zm76.2-191.9L374.8 285.2 323.1 268c-14.6-4.9-30-7-45.2-6.4L393.5 66.1c32.9 4.8 63.2 18 88.7 37.5zM246.6 64H357.5L235.6 270.4 96.1 318.7 246.6 64zm-37.2 0L49.4 334.8C27 341.5 5 322.3 8.9 298.9l12.4-74.4C36.6 132.2 116.1 64.6 209.5 64z"]]
};
var faNigiri = faSushi;
var faMessageCaptions = {
  prefix: 'fad',
  iconName: 'message-captions',
  icon: [512, 512, ["comment-alt-captions"], "e1de", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zM120 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z", "M96 216c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm224 0c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zM96 296c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24z"]]
};
var faCommentAltCaptions = faMessageCaptions;
var faTrashList = {
  prefix: 'fad',
  iconName: 'trash-list',
  icon: [640, 512, [], "e2b1", ["M362.6 466.8L384 96H32L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2H314.7c25.4 0 46.5-19.8 47.9-45.2z", "M147.8 0c-12.1 0-23.2 6.8-28.6 17.7L112 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H304l-7.2-14.3C291.4 6.8 280.3 0 268.2 0H147.8zM448 160c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H480c-17.7 0-32 14.3-32 32zm0 128c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H480c-17.7 0-32 14.3-32 32zm32 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H480z"]]
};
var faBacon = {
  prefix: 'fad',
  iconName: 'bacon',
  icon: [576, 512, [129363], "f7e5", ["M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z", "M518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9L518 56.7z"]]
};
var faOption = {
  prefix: 'fad',
  iconName: 'option',
  icon: [640, 512, [], "e318", ["M416 96c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H448c-17.7 0-32 14.3-32 32z", "M423 436c6.1 7.6 15.3 12 25 12H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H463.4L217 76c-6.1-7.6-15.3-12-25-12H32C14.3 64 0 78.3 0 96s14.3 32 32 32H176.6L423 436z"]]
};
var faHandPointDown = {
  prefix: 'fad',
  iconName: 'hand-point-down',
  icon: [384, 512, [], "f0a7", ["M64 512c17.7 0 32-14.3 32-32V272H32V480c0 17.7 14.3 32 32 32zM224 200l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0H162.3C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z", "M352 320c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32zm-128 0V256c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm-96 32V304c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]]
};
var faArrowUpFromBracket = {
  prefix: 'fad',
  iconName: 'arrow-up-from-bracket',
  icon: [448, 512, [], "e09a", ["M32 320c17.7 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96V352c0-17.7 14.3-32 32-32z", "M201.4 9.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 109.3V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z"]]
};
var faTrashPlus = {
  prefix: 'fad',
  iconName: 'trash-plus',
  icon: [448, 512, [], "e2b2", ["M416 96H32L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2H346.7c25.4 0 46.5-19.8 47.9-45.2L416 96zM200 376V312H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V200c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM200 376V312H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V200c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]]
};
var faObjectsAlignTop = {
  prefix: 'fad',
  iconName: 'objects-align-top',
  icon: [512, 512, [], "e3c0", ["M112 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H112zm224 0c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H336z", "M0 24C0 10.7 10.7 0 24 0H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24z"]]
};
var faFolder = {
  prefix: 'fad',
  iconName: 'folder',
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", ["M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z", ""]]
};
var faFolderBlank = faFolder;
var faFaceAnxiousSweat = {
  prefix: 'fad',
  iconName: 'face-anxious-sweat',
  icon: [576, 512, [], "e36a", ["M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512zM208 400c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16zM367.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z", "M227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM239.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM348.7 148.7c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM48 416c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C67.6 308.6 96 349 96 369c0 26-21.5 47-48 47z"]]
};
var faCreditCardBlank = {
  prefix: 'fad',
  iconName: 'credit-card-blank',
  icon: [576, 512, [], "f389", ["M112 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 368c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]]
};
var faFileWaveform = {
  prefix: 'fad',
  iconName: 'file-waveform',
  icon: [448, 512, ["file-medical-alt"], "f478", ["M64 64C64 28.7 92.7 0 128 0H288V128c0 17.7 14.3 32 32 32H448V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V320h65.2l41.4 82.7c4.2 8.5 13 13.6 22.5 13.2s17.8-6.3 21.3-15.1l44.2-110.4 8.1 16.2c4.1 8.1 12.4 13.3 21.5 13.3h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H302.8l-25.4-50.7c-4.2-8.5-13-13.6-22.5-13.2s-17.8 6.3-21.3 15.1L189.6 333.5l-24.1-48.2c-4.1-8.1-12.4-13.3-21.5-13.3H64V64z", "M448 160L288 0V128c0 17.7 14.3 32 32 32H448zM277.5 221.3c-4.2-8.5-13-13.6-22.5-13.2s-17.8 6.3-21.3 15.1L189.6 333.5l-24.1-48.2c-4.1-8.1-12.4-13.3-21.5-13.3H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H129.2l41.4 82.7c4.2 8.5 13 13.6 22.5 13.2s17.8-6.3 21.3-15.1l44.2-110.4 8.1 16.2c4.1 8.1 12.4 13.3 21.5 13.3h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H302.8l-25.4-50.7z"]]
};
var faFileMedicalAlt = faFileWaveform;
var faMicrochipAi = {
  prefix: 'fad',
  iconName: 'microchip-ai',
  icon: [512, 512, [], "e1ec", ["M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64h48V24zM280 64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64h48zm104 0V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64h48zm64 112h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448v48zm0 104h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448v48zm0 104h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448v48zM336 448v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H336zm-104 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H232zm-104 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H128zM64 336H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64V336zm0-104H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64V232zm0-104H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64V128z", "M128 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H128zm94.7 121.6l42 96 14 32c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2L239.5 304H176.5l-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l14-32 42-96c2.5-5.8 8.3-9.6 14.7-9.6s12.1 3.8 14.7 9.6zM208 231.9L190.5 272h35.1L208 231.9zM352 192V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faMug = {
  prefix: 'fad',
  iconName: 'mug',
  icon: [576, 512, [], "f874", ["M416 320h32c70.7 0 128-57.3 128-128s-57.3-128-128-128H384c17.7 0 32 14.3 32 32v32h32c35.3 0 64 28.7 64 64s-28.7 64-64 64H416v64z", "M32 96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V352c0 53-43 96-96 96H128c-53 0-96-43-96-96V96z"]]
};
var faPlaneUpSlash = {
  prefix: 'fad',
  iconName: 'plane-up-slash',
  icon: [640, 512, [], "e22e", ["M161.3 223.1L445.9 447.3c1.4 2.4 2.1 5.1 2.1 8V498c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L320 480 209.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L256 400V320L85.1 377C74.7 380.4 64 372.7 64 361.8V305.1c0-10.7 5.3-20.7 14.2-26.6l83.1-55.4zM554.9 377l-72.5-24.2-237-185.8L256 160V93.7C256 59.5 285 0 320 0c36 0 64 59.5 64 93.7l0 66.3L561.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faRadiation = {
  prefix: 'fad',
  iconName: 'radiation',
  icon: [512, 512, [], "f7b9", ["M208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z", "M176 256c0-29.6 16.1-55.5 40-69.3L144 62c-8.8-15.3-28.6-20.7-42.7-10C47.8 92.7 10.7 154 2 224.1C-.2 241.6 14.3 256 32 256l144 0zm40 69.3L144 450.1c-8.8 15.3-3.7 35.1 12.6 41.9c30.6 12.9 64.2 20 99.4 20s68.9-7.1 99.4-20c16.3-6.9 21.4-26.6 12.6-41.9L296 325.3c-11.8 6.8-25.4 10.7-40 10.7s-28.2-3.9-40-10.7zM336 256l144 0c17.7 0 32.2-14.4 30-31.9C501.3 154 464.2 92.7 410.7 52c-14.1-10.7-33.8-5.3-42.7 10L296 186.7c23.9 13.8 40 39.7 40 69.3z"]]
};
var faPenCircle = {
  prefix: 'fad',
  iconName: 'pen-circle',
  icon: [512, 512, [], "e20e", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM357.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM151.9 289L257.1 183.8l71 71L222.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z", "M301.2 139.7l-21.4 21.4 71 71 21.4-21.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-44 44L151.9 289c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L328.1 254.7l-71-71z"]]
};
var faBagSeedling = {
  prefix: 'fad',
  iconName: 'bag-seedling',
  icon: [512, 512, [], "e5f2", ["M64 64H448l18.6 74.5c8.9 35.5 13.4 72 13.4 108.7v17.7c0 36.6-4.5 73.1-13.4 108.7L448 448H64L45.4 373.5C36.5 338 32 301.5 32 264.8V247.2c0-36.6 4.5-73.1 13.4-108.7L64 64zm80 96c-8.8 0-16 7.2-16 16c0 59.2 45.9 107.6 104 111.7V328c0 13.3 10.7 24 24 24s24-10.7 24-24V287.7c58.1-4.1 104-52.6 104-111.7c0-8.8-7.2-16-16-16h-2c-47.3 0-88.4 26-110 64.5C234.4 186 193.3 160 146 160h-2z", "M38.6 38.6L64 64H448l25.4-25.4c4.2-4.2 6.6-10 6.6-16C480 10.1 469.9 0 457.4 0H54.6C42.1 0 32 10.1 32 22.6c0 6 2.4 11.8 6.6 16zm0 434.7c-4.2 4.2-6.6 10-6.6 16C32 501.9 42.1 512 54.6 512H457.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L448 448H64L38.6 473.4zM144 160c-8.8 0-16 7.2-16 16c0 59.2 45.9 107.6 104 111.7V328c0 13.3 10.7 24 24 24s24-10.7 24-24V287.7c58.1-4.1 104-52.6 104-111.7c0-8.8-7.2-16-16-16h-2c-47.3 0-88.4 26-110 64.5C234.4 186 193.3 160 146 160h-2z"]]
};
var faChartSimple = {
  prefix: 'fad',
  iconName: 'chart-simple',
  icon: [448, 512, [], "e473", ["M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80z", "M368 96c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48z"]]
};
var faCrutches = {
  prefix: 'fad',
  iconName: 'crutches',
  icon: [640, 512, [], "f7f8", ["M470.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm-256 0c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l1.4-1.4L188.2 345.4c2.7 2.7 5.5 5.1 8.4 7.5l17-17 10.1-45.5L101.3 168 168 101.3l86.3 86.3c5-7.9 10.9-15.3 17.6-22l25.4-25.4L213.3 56l1.4-1.4c12.5-12.5 12.5-32.8 0-45.3zM457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64.1-64.1c-8.6 4-17.6 7.1-26.9 9.2l-44.5 9.9 90.2 90.2z", "M329.4 153.4L426.7 56 472 101.3 397.3 176 464 242.7 538.7 168 584 213.3l-97.3 97.3c0 0-.1 .1-.1 .1s-.1 .1-.1 .1l-34.7 34.7c-12.9 12.9-29.2 21.9-47.1 25.8L297.1 395.2c-5.9 1.3-11.4 4.3-15.7 8.6l-98.8 98.8c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l98.8-98.8c4.3-4.3 7.3-9.7 8.6-15.7l23.9-107.6c4-17.8 12.9-34.1 25.8-47.1l34.8-34.8zM352 221.3l-12.2 12.2c-4.3 4.3-7.3 9.7-8.6 15.7l-17 76.7 76.7-17c5.9-1.3 11.4-4.3 15.7-8.6L418.7 288 352 221.3z"]]
};
var faCircleParking = {
  prefix: 'fad',
  iconName: 'circle-parking',
  icon: [512, 512, ["parking-circle"], "f615", ["M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z", "M240 192h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H240V192zm0 128h48c53 0 96-43 96-96s-43-96-96-96H216c-22.1 0-40 17.9-40 40V288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"]]
};
var faParkingCircle = faCircleParking;
var faMarsStroke = {
  prefix: 'fad',
  iconName: 'mars-stroke',
  icon: [512, 512, [9894], "f229", ["M128 304a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H376zm88 48h0v0l0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"]]
};
var faLeafOak = {
  prefix: 'fad',
  iconName: 'leaf-oak',
  icon: [512, 512, [], "f6f7", ["M470.6 258.4l-40.8 10.2c-6 1.5-8.1 9-3.7 13.4l22 22c17.7 17.7 17.7 46.3 0 64c-10.1 10.1-24.3 14.8-38.4 12.8l-75.1-10.7c-5.6-.8-9.5 5.4-6.4 10.1c13.9 20.8 11.1 48.5-6.6 66.2l-3.6 3.6c-17.9 17.9-45.2 22.3-67.8 11L219 445.5c-17.8-8.9-37.4-13.5-57.2-13.5H113.9L313.9 232.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L80 398.1l0-47.8c0-19.9-4.6-39.5-13.5-57.2L50.9 261.9c-11.3-22.6-6.9-49.9 11-67.8l3.6-3.6c17.7-17.7 45.4-20.4 66.2-6.6c4.7 3.1 10.9-.8 10.1-6.4l-10.7-75.1c-2-14.1 2.7-28.3 12.8-38.4c17.7-17.7 46.3-17.7 64 0l22 22c4.4 4.4 11.9 2.3 13.4-3.7l10.2-40.8C259.7 17.1 281.6 0 306.7 0c18.3 0 35.4 9.1 45.5 24.4l9.5 14.3c3.8 5.6 10.6 8.3 17.2 6.6l20.1-5c20.4-5.1 42 .9 56.9 15.8s20.9 36.5 15.8 56.9l-5 20.1c-1.6 6.6 1 13.4 6.6 17.2l14.3 9.5C502.9 169.9 512 187 512 205.3c0 25.1-17.1 47-41.4 53.1z", "M7 505c-9.4-9.4-9.4-24.6 0-33.9L279.9 198.1c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0z"]]
};
var faSquareBolt = {
  prefix: 'fad',
  iconName: 'square-bolt',
  icon: [448, 512, [], "e265", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm234.1 83.6c5.8 4.7 7.6 12.9 4.3 19.6L249.9 240H320c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L198.1 272H128c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z", "M302.3 135.2c3.4-6.7 1.6-14.9-4.3-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L145.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H249.9l52.4-104.8z"]]
};
var faVial = {
  prefix: 'fad',
  iconName: 'vial',
  icon: [512, 512, [129514], "f492", ["M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l32 32 96 96 32 32c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-9.4-9.4L169.4 483.9c-18 18-42.4 28.1-67.9 28.1H96c-53 0-96-43-96-96v-5.5c0-25.5 10.1-49.9 28.1-67.9L306.7 64l-9.4-9.4c-12.5-12.5-12.5-32.8 0-45.3zM352 109.3L73.4 387.9c-6 6-9.4 14.1-9.4 22.6V416c0 17.7 14.3 32 32 32h5.5c8.5 0 16.6-3.4 22.6-9.4L402.7 160 352 109.3z", "M306.7 256H205.3L73.4 387.9c-6 6-9.4 14.1-9.4 22.6V416c0 17.7 14.3 32 32 32h5.5c8.5 0 16.6-3.4 22.6-9.4L306.7 256z"]]
};
var faGauge = {
  prefix: 'fad',
  iconName: 'gauge',
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M280 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V88z"]]
};
var faDashboard = faGauge;
var faGaugeMed = faGauge;
var faTachometerAltAverage = faGauge;
var faWandMagicSparkles = {
  prefix: 'fad',
  iconName: 'wand-magic-sparkles',
  icon: [576, 512, ["magic-wand-sparkles"], "e2ca", ["M234.7 42.7L248.8 5c1.1-3 4-5 7.2-5s6.1 2 7.2 5l14.1 37.7L315 56.8c3 1.1 5 4 5 7.2s-2 6.1-5 7.2L277.3 85.3 263.2 123c-1.1 3-4 5-7.2 5s-6.1-2-7.2-5L234.7 85.3 197 71.2c-3-1.1-5-4-5-7.2s2-6.1 5-7.2l37.7-14.1zm295.2 73.9L419.2 227.2l-39.6-39.6 105-105L461.4 59.3l-105 105-39.6-39.6L427.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9zM7.5 117.2L64 96 85.2 39.5C86.9 35 91.2 32 96 32s9.1 3 10.8 7.5L128 96l56.5 21.2c4.5 1.7 7.5 6 7.5 10.8s-3 9.1-7.5 10.8L128 160l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5s-9.1-3-10.8-7.5L64 160 7.5 138.8C3 137.1 0 132.8 0 128s3-9.1 7.5-10.8zm352 256L416 352l21.2-56.5c1.7-4.5 6-7.5 10.8-7.5s9.1 3 10.8 7.5L480 352l56.5 21.2c4.5 1.7 7.5 6 7.5 10.8s-3 9.1-7.5 10.8L480 416l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5s-9.1-3-10.8-7.5L416 416l-56.5-21.2c-4.5-1.7-7.5-6-7.5-10.8s3-9.1 7.5-10.8z", "M419.2 227.2L316.7 124.7 46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L419.2 227.2z"]]
};
var faMagicWandSparkles = faWandMagicSparkles;
var faLambda = {
  prefix: 'fad',
  iconName: 'lambda',
  icon: [448, 512, [], "f66e", ["M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H140.2l16.4 32.7L18.8 434.9c-7.3 16.1-.1 35.1 16 42.3s35.1 .1 42.3-16L193.5 202.6l121 242c10.8 21.7 33 35.4 57.2 35.4H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H371.8L197.5 67.4C186.6 45.7 164.5 32 140.2 32H32z", ""]]
};
var faE = {
  prefix: 'fad',
  iconName: 'e',
  icon: [320, 512, [101], "45", ["M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z", ""]]
};
var faPizza = {
  prefix: 'fad',
  iconName: 'pizza',
  icon: [576, 512, [127829], "f817", ["M108.9 403.1c81.2 81.2 212.9 81.2 294.2 0L278.6 278.6c-12.5-12.5-12.5-32.8 0-45.3L403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2zM128 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM479.6 120.4L366.6 233.4c-12.5 12.5-12.5 32.8 0 45.3l112 112c31.6-36.7 50.5-84.4 50.3-136.6c-.2-51-18.8-97.6-49.4-133.6zM416 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M403.1 403.1C365.4 440.7 313.4 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c57.4 0 109.4 23.3 147.1 60.9l11.3-11.3C426.9 85.1 427 64.7 413 53.8C369.7 20.1 315.2 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c59.2 0 113.7-20.1 157-53.8c13.9-10.9 13.8-31.3 1.3-43.8l-11.3-11.3zm75.5-12.5l9.9 9.9c13.1 13.1 34.7 12.5 44.9-3C560.3 357 576 308.3 576 256s-15.7-101-42.6-141.5c-10.2-15.4-31.8-16-44.9-3l-9.9 9.9C509.4 157.7 528 204.7 528 256s-18.6 98.3-49.4 134.6zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM128 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faBowlChopsticksNoodles = {
  prefix: 'fad',
  iconName: 'bowl-chopsticks-noodles',
  icon: [512, 512, [], "e2ea", ["M64 84v34l-45.5 7.1C8.8 126.6 0 119.1 0 109.3C0 101.6 5.5 95 13.1 93.6L64 84zm0 58v34H16.2C7.3 176 0 168.7 0 159.7c0-8.8 7-16 15.7-16.2L64 142zm160 34V137l263.6-8.2C501 128.3 512 139 512 152.4c0 13-10.6 23.6-23.6 23.6H224zm0-83V54L484.4 5.2C498.7 2.5 512 13.5 512 28.1c0 11.5-8.4 21.2-19.7 23L224 93z", "M192 40c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H112V56c0-13.3-10.7-24-24-24S64 42.7 64 56V224H33.6C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35H332.7c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5H192V40z"]]
};
var faH3 = {
  prefix: 'fad',
  iconName: 'h3',
  icon: [640, 512, [], "f315", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M368 96c0-17.7 14.3-32 32-32H592c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-89.5 89.5C589 210.8 640 263.4 640 328c0 66.3-53.7 120-120 120H455.4c-43 0-79.7-31.1-86.8-73.5l-.2-1.2c-2.9-17.4 8.9-33.9 26.3-36.8s33.9 8.9 36.8 26.3l.2 1.2c1.9 11.6 11.9 20.1 23.7 20.1H520c30.9 0 56-25.1 56-56s-25.1-56-56-56H448c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L514.7 128H400c-17.7 0-32-14.3-32-32z"]]
};
var faPenClip = {
  prefix: 'fad',
  iconName: 'pen-clip',
  icon: [512, 512, ["pen-alt"], "f305", ["M362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c25 25 25 65.5 0 90.5L417.9 224 288 94.1l74.7-74.7z", "M207 114.9c9.4-9.4 24.6-9.4 33.9 0L254.1 128 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L401 241l17-17-1-1-16-16-96-96-17-17L274.9 81c-28.1-28.1-73.7-28.1-101.8 0L71 183c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L207 114.9z"]]
};
var faPenAlt = faPenClip;
var faBridgeCircleExclamation = {
  prefix: 'fad',
  iconName: 'bridge-circle-exclamation',
  icon: [640, 512, [], "e4ca", ["M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h72v72.2C577.6 207.1 538.5 192 496 192c-69.1 0-128.9 39.8-157.7 97.7c-5.9-1.1-12-1.7-18.3-1.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faBadgePercent = {
  prefix: 'fad',
  iconName: 'badge-percent',
  icon: [512, 512, [], "f646", ["M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z", "M224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z"]]
};
var faUser = {
  prefix: 'fad',
  iconName: 'user',
  icon: [448, 512, [128100, 62144], "f007", ["M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128z", "M0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"]]
};
var faSensor = {
  prefix: 'fad',
  iconName: 'sensor',
  icon: [448, 512, [], "e028", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 88V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M88 96c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm96 0c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24z"]]
};
var faComma = {
  prefix: 'fad',
  iconName: 'comma',
  icon: [192, 512, [], "2c", ["M160 350.4V349c0-33.7-27.3-61-61-61c-29.5 0-54.8 21.1-60.1 50.1l-22.2 122c-.5 2.6-.7 5.2-.7 7.9v8.2C16 495.9 32.1 512 51.9 512c12.5 0 24.1-6.5 30.6-17.2L150.8 383c6-9.8 9.2-21.1 9.2-32.6z", ""]]
};
var faSchoolCircleCheck = {
  prefix: 'fad',
  iconName: 'school-circle-check',
  icon: [640, 512, [], "e56b", ["M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V266.8C608.1 221.6 555.5 192 496 192c-38.5 0-74.2 12.4-103.1 33.4c9.6-14.1 15.1-31.1 15.1-49.4c0-48.6-39.4-88-88-88s-88 39.4-88 88s39.4 88 88 88c15.6 0 30.2-4 42.9-11.1c-23.4 27.1-38.8 61.4-42.2 99.1h-.5l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM336 144v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faToiletPaperUnder = {
  prefix: 'fad',
  iconName: 'toilet-paper-under',
  icon: [512, 512, ["toilet-paper-reverse"], "e2a0", ["M96 384C43 384 0 298 0 192S43 0 96 0H416c-53 0-96 86-96 192s43 192 96 192H128 96zM80 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z", "M320 195.9c1 104.2 43.6 188.1 96 188.1H160v80c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V192C512 86 469 0 416 0s-96 86-96 192c0 1.3 0 2.6 0 3.9zM448 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zM80 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
};
var faToiletPaperReverse = faToiletPaperUnder;
var faLightEmergency = {
  prefix: 'fad',
  iconName: 'light-emergency',
  icon: [448, 512, [], "e41f", ["M224 32C135.6 32 64 103.6 64 192V352H384V192c0-88.4-71.6-160-160-160zM144 192c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z", "M32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"]]
};
var faArrowDownToArc = {
  prefix: 'fad',
  iconName: 'arrow-down-to-arc',
  icon: [512, 512, [], "e4ae", ["M448 256c0 106-86 192-192 192S64 362 64 256c0-17.7-14.3-32-32-32s-32 14.3-32 32C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.7-14.3-32-32-32s-32 14.3-32 32z", "M390.6 185.4c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-112-112c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 242.7 224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 57.4-57.4c12.5-12.5 32.8-12.5 45.3 0z"]]
};
var faDumpster = {
  prefix: 'fad',
  iconName: 'dumpster',
  icon: [576, 512, [], "f793", ["M140.5 32H49.7c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32zm7 128H272V32H173.1L147.5 160zM304 32V160H428.5L402.9 32H304zm131.5 0l25.6 128h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5z", "M64 448L44 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h4l-4-32H544l-4 32h4c17.7 0 32 14.3 32 32s-14.3 32-32 32H532L512 448c0 17.7-14.3 32-32 32s-32-14.3-32-32H128c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]]
};
var faVanShuttle = {
  prefix: 'fad',
  iconName: 'van-shuttle',
  icon: [640, 512, [128656, "shuttle-van"], "f5b6", ["M160 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm320 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M64 104c0-4.4 3.6-8 8-8h88v96H64V104zm482 88H384V96h81.1L546 192zm-226 0H224V96h96v96zM72 32C32.2 32 0 64.2 0 104V336c0 26.5 21.5 48 48 48h1.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96h98.3c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H592c26.5 0 48-21.5 48-48V227.7c0-15.1-5.3-29.7-15-41.2L514.1 54.8C501.9 40.3 484 32 465.1 32H352 192 72z"]]
};
var faShuttleVan = faVanShuttle;
var faBuildingUser = {
  prefix: 'fad',
  iconName: 'building-user',
  icon: [640, 512, [], "e4da", ["M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V271.8v95.9c-38.2 21.4-64 62.3-64 109.2c0 12.9 3.6 24.9 9.9 35.1H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M496 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-50.9 32c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1z"]]
};
var faLightSwitch = {
  prefix: 'fad',
  iconName: 'light-switch',
  icon: [384, 512, [], "e017", ["M288 272H96V240H288v32z", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm96 96V352c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM208 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
};
var faSquareCaretLeft = {
  prefix: 'fad',
  iconName: 'square-caret-left',
  icon: [448, 512, ["caret-square-left"], "f191", ["M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z", "M135.7 238.4c-4.9 4.5-7.7 10.9-7.7 17.6s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-208c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104z"]]
};
var faCaretSquareLeft = faSquareCaretLeft;
var faHighlighter = {
  prefix: 'fad',
  iconName: 'highlighter',
  icon: [576, 512, [], "f591", ["M360.7 360.7L183.3 183.3l-35.7 26.3c-12.3 9-19.5 23.4-19.5 38.6V320l0 0L70.6 377.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0L224 416h71.7c15.3 0 29.6-7.2 38.6-19.5l26.3-35.7z", "M360.7 360.7L183.3 183.3 420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L360.7 360.7zM7 466.3l56-56c1.5 4.5 4.1 8.7 7.6 12.2l50.7 50.7c3.6 3.6 7.8 6.1 12.2 7.6l-24 24c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"]]
};
var faWavePulse = {
  prefix: 'fad',
  iconName: 'wave-pulse',
  icon: [640, 512, ["heart-rate"], "f5f8", ["M319.1 0c14.8-.4 27.9 9.3 31.8 23.6l74 271.2 17.7-35.4c10.8-21.7 33-35.4 57.2-35.4H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H499.8L444.6 398.3c-5.9 11.9-18.6 18.8-31.8 17.5s-24.2-10.6-27.7-23.4L323.7 167.3 255.3 486.7c-3.1 14.4-15.5 24.8-30.2 25.3s-27.8-9.1-31.8-23.2L135.9 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H135.9c28.6 0 53.7 18.9 61.5 46.4L219.6 348 288.7 25.3C291.8 10.9 304.4 .4 319.1 0z", ""]]
};
var faHeartRate = faWavePulse;
var faKey = {
  prefix: 'fad',
  iconName: 'key',
  icon: [512, 512, [128273], "f084", ["M168.3 229.7L282.3 343.7l0 0s0 0 0 0L249 377c-4.5 4.5-10.6 7-17 7H192v40c0 13.3-10.7 24-24 24H128v40c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V408c0-6.4 2.5-12.5 7-17L168.3 229.7s0 0 0 0l0 0z", "M168.3 229.7L282.3 343.7l0 0c16.9 5.4 35 8.3 53.7 8.3c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7l0 0zM336 136a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]]
};
var faHatSanta = {
  prefix: 'fad',
  iconName: 'hat-santa',
  icon: [640, 512, [], "f7a7", ["M560 160c-12.7 0-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C489.8 217 480 227.3 480 240s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C537 310.2 547.3 320 560 320s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C630.2 263 640 252.7 640 240s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2C583 169.8 572.7 160 560 160zM64 352c-35.3 0-64 28.7-64 64s28.7 64 64 64H448c35.3 0 64-28.7 64-64s-28.7-64-64-64H64z", "M64 352l85.7-214.2C175.2 73.9 237.1 32 305.9 32c49.5 0 96.5 21.8 128.5 59.6l74.3 87.8c-1.9 1.1-3.7 2.4-5.3 4c-8.9 8.9-9.4 23.2-1.2 32.6c-3.9 .3-7.5 1.5-10.7 3.4L402 192.6c-1.3-.4-2.7-.6-4-.6h-.8c-7.3 0-13.2 5.9-13.2 13.2c0 1.8 .4 3.7 1.1 5.4L448 352H64z"]]
};
var faTamale = {
  prefix: 'fad',
  iconName: 'tamale',
  icon: [320, 512, [129748], "e451", ["M48.1 18.3C72.3 8.6 108.4 0 160 0s87.7 8.6 111.9 18.3c12.1 4.8 21 9.9 27.4 14.1c12.7 8.5 23.1 20.4 20.3 36.9L291.1 240H233.4L248 72.7c.4-4.4-2.9-8.3-7.3-8.7s-8.3 2.9-8.7 7.3L217.4 240H168l0-176c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 176H102.6L88 71.3c-.4-4.4-4.3-7.7-8.7-7.3s-7.7 4.3-7.3 8.7L86.6 240H28.9L.4 69.3C-2.3 52.8 8.1 40.8 20.8 32.4c6.3-4.2 15.3-9.3 27.4-14.1zM28.9 272H86.6L72 439.3c-.4 4.4 2.9 8.3 7.3 8.7s8.3-2.9 8.7-7.3l9.9-113.3c1.1 2.1 2.6 3.9 4.6 5.4c7.1 5.3 17.1 3.9 22.4-3.2L152 293.3 152 448c0 4.4 3.6 8 8 8s8-3.6 8-8l0-154.7 27.2 36.3c5.3 7.1 15.3 8.5 22.4 3.2c2-1.5 3.5-3.3 4.6-5.4L232 440.7c.4 4.4 4.3 7.7 8.7 7.3s7.7-4.3 7.3-8.7L233.4 272h57.7l28.4 170.7c1.7 10.2-1.6 20.6-8.9 27.9l0 0c-10.6 10.5-25.1 17.6-38.7 23C247.7 503.4 211.6 512 160 512s-87.7-8.6-111.9-18.3c-13.7-5.5-28.1-12.5-38.7-23l0 0c-7.3-7.3-10.6-17.7-8.9-27.9L28.9 272zm191.8 38.2L192 272h25.4l3.3 38.2zM102.6 272H128L99.3 310.2l3.3-38.2z", "M24 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H128L99.2 310.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2L160 282.7l35.2 46.9c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4L192 272H296c8.8 0 16-7.2 16-16s-7.2-16-16-16H160 24z"]]
};
var faBoxCheck = {
  prefix: 'fad',
  iconName: 'box-check',
  icon: [448, 512, [], "f467", ["M93.7 32C75.5 32 58.9 42.3 50.7 58.5L0 160H208V32H93.7zM240 32V160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240z", "M448 160H240V32H208V160H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V160zM337 265L209 393c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 231c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]]
};
var faBullhorn = {
  prefix: 'fad',
  iconName: 'bullhorn',
  icon: [512, 512, [128226, 128363], "f0a1", ["M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192v32 32 96 32 32h8.7c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32z", "M0 192c0-35.3 28.7-64 64-64H192V320v32V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32l0-128c-35.3 0-64-28.7-64-64V192zm512 48c0 27.9-13.4 51.6-32 60.4V179.6c18.6 8.8 32 32.5 32 60.4z"]]
};
var faSteak = {
  prefix: 'fad',
  iconName: 'steak',
  icon: [576, 512, [129385], "f824", ["M368 0c-38.3 0-72.3 12.4-99.2 37.4c-23.5 21.9-36.3 48.9-44.1 66.5c-4.4 10.1-8 18.9-11.2 26.6c-10.4 25.1-16.2 39.1-30 52.9c-23.1 23.1-50.4 36.9-77.7 50.7c-21.8 11-43.6 22.1-63.3 37.8C17.8 291.7 0 321.4 0 360c0 84.3 73.4 120.1 110 132.7c43.5 15 93.3 19.3 130 19.3c81.7 0 162.1-30.8 222.6-75.8C520.9 392.8 576 323.9 576 240c0-60.4-23.6-117.6-57.5-160C485.7 39 433 0 368 0zM236.3 448C167.4 448 64 430.5 64 369.5c0-29.8 19.8-38.3 51.7-51.9c31.1-13.3 73.6-31.5 120.6-79c28.1-28.5 41.9-62.8 54.2-93.4C308.4 100.7 323.1 64 374.2 64C443.1 64 512 151.3 512 238.5C512 343.3 370.9 448 236.3 448z", "M236.3 448C167.4 448 64 430.5 64 369.5c0-29.8 19.8-38.3 51.7-51.9c31.1-13.3 73.6-31.5 120.6-79c28.1-28.5 41.9-62.8 54.2-93.4C308.4 100.7 323.1 64 374.2 64C443.1 64 512 151.3 512 238.5C512 343.3 370.9 448 236.3 448zM384 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faLocationCrosshairsSlash = {
  prefix: 'fad',
  iconName: 'location-crosshairs-slash',
  icon: [640, 512, ["location-slash"], "f603", ["M509.3 288c-4 24-12.5 46.5-24.6 66.6l-51-40c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-51-40C212.4 92.3 248.1 73.3 288 66.7V32c0-17.7 14.3-32 32-32s32 14.3 32 32V66.7C432.4 80.1 495.9 143.6 509.3 224H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H509.3zM400 256c0 9.9-1.8 19.4-5.1 28.2L274.7 190c12.9-8.8 28.5-14 45.3-14c44.2 0 80 35.8 80 80zM358.2 378.2l56.8 44.7c-19.2 10.9-40.4 18.6-62.9 22.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C207.6 431.9 144.1 368.4 130.7 288H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h34.7c1.2-7.2 2.8-14.3 4.8-21.3l56.8 44.7c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faLocationSlash = faLocationCrosshairsSlash;
var faPersonDolly = {
  prefix: 'fad',
  iconName: 'person-dolly',
  icon: [512, 512, [], "f4d0", ["M247.3 186.2c-3.2-12.9-16.2-20.7-29.1-17.5s-20.7 16.2-17.5 29.1l49.6 198.4c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L339.7 410.3c-10-13.7-25.3-23.3-42.8-25.7L247.3 186.2zM272 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm85.4-71.8L449 353.4c17.1-4.3 27.6-21.7 23.3-38.8L449.4 223c-4.3-17.1-21.7-27.6-38.8-23.3L319 222.6c-17.1 4.3-27.6 21.7-23.3 38.8L318.6 353c4.3 17.1 21.7 27.6 38.8 23.3z", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM96 306.7V241.7l16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4h70.7l-16-64H161.1l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32v0V410.5l-64-64z"]]
};
var faGlobe = {
  prefix: 'fad',
  iconName: 'globe',
  icon: [512, 512, [127760], "f0ac", ["M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z", "M344.3 352H167.7c6.1 36.4 15.5 68.6 27 94.6c10.5 23.6 22.2 40.7 33.5 51.5C239.4 508.8 248.7 512 256 512s16.6-3.2 27.8-13.8c11.3-10.8 23-27.9 33.5-51.5c11.6-26 20.9-58.2 27-94.6zM321.4 503.6c-20.9 5.5-42.8 8.4-65.4 8.4s-44.6-2.9-65.4-8.4c-25.5-34.2-45.2-87.7-55.3-151.6H18.6c-4.2-10.3-7.7-21-10.5-32H131.2c-2.1-20.6-3.2-42-3.2-64s1.1-43.4 3.2-64H8.1c2.8-11 6.4-21.7 10.5-32H135.3c10-63.9 29.8-117.4 55.3-151.6C211.4 2.9 233.4 0 256 0c-7.3 0-16.6 3.2-27.8 13.8c-11.3 10.8-23 27.9-33.5 51.5c-11.6 26-20.9 58.2-27 94.7H344.3c-6.1-36.4-15.5-68.6-27-94.7c-10.5-23.6-22.2-40.7-33.5-51.5C272.6 3.2 263.3 0 256 0c22.6 0 44.6 2.9 65.4 8.4c25.5 34.2 45.2 87.7 55.3 151.6H493.4c4.2 10.3 7.7 21 10.5 32H380.8c2.1 20.6 3.2 42 3.2 64s-1.1 43.4-3.2 64H503.9c-2.8 11-6.4 21.7-10.5 32H376.7c-10 63.9-29.8 117.4-55.3 151.6zM352 256c0-22.2-1.2-43.6-3.3-64H163.3c-2.2 20.4-3.3 41.8-3.3 64s1.2 43.6 3.3 64H348.7c2.2-20.4 3.3-41.8 3.3-64z"]]
};
var faSynagogue = {
  prefix: 'fad',
  iconName: 'synagogue',
  icon: [640, 512, [128333], "f69b", ["M160 273.4L99.3 212.7c-6.2-6.2-16.4-6.2-22.6 0L14.1 275.3c-9 9-14.1 21.2-14.1 33.9V448c0 35.3 28.7 64 64 64h96V273.4zM480 512H592c26.5 0 48-21.5 48-48V309.3c0-12.7-5.1-24.9-14.1-33.9l-62.6-62.6c-6.2-6.2-16.4-6.2-22.6 0L480 273.4V512z", "M330.2 3.7c-5.9-4.9-14.6-4.9-20.5 0l-121 100.8C170.5 119.7 160 142.2 160 166V496v16h16 80V384c0-35.3 28.7-64 64-64s64 28.7 64 64V512h80 16V496 166c0-23.7-10.5-46.3-28.8-61.5L330.2 3.7zM313 124.3c3.1-5.4 10.9-5.4 13.9 0l15.9 28.1 32.3-.3c6.2-.1 10.1 6.7 7 12.1L365.7 192l16.4 27.8c3.2 5.4-.7 12.1-7 12.1l-32.3-.3L327 259.7c-3.1 5.4-10.9 5.4-13.9 0l-15.9-28.1-32.3 .3c-6.2 .1-10.1-6.7-7-12.1L274.3 192l-16.4-27.8c-3.2-5.4 .7-12.1 7-12.1l32.3 .3L313 124.3z"]]
};
var faFileChartColumn = {
  prefix: 'fad',
  iconName: 'file-chart-column',
  icon: [384, 512, ["file-chart-line"], "f659", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM216 248c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248zm88 64c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 13.3 10.7 24 24 24s24-10.7 24-24V312zM128 376c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V376z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM216 248c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248zm88 64c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 13.3 10.7 24 24 24s24-10.7 24-24V312zM128 376c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V376z"]]
};
var faFileChartLine = faFileChartColumn;
var faPersonHalfDress = {
  prefix: 'fad',
  iconName: 'person-half-dress',
  icon: [320, 512, [], "e548", ["M160 128V352h8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H160zm0-32c26.5 0 48-21.5 48-48s-21.5-48-48-48c0 0 0 0 0 0V96s0 0 0 0z", "M160 96V0s0 0 0 0c-26.5 0-48 21.5-48 48s21.5 48 48 48c0 0 0 0 0 0zm0 32h-5.8c-39.3 0-75.7 20.6-96 54.3L4.6 271.5c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L55 362.9C51.6 373.3 59.3 384 70.2 384H88v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h8V128z"]]
};
var faFolderImage = {
  prefix: 'fad',
  iconName: 'folder-image',
  icon: [512, 512, [], "e18a", ["M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM176 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm120 0c-8 0-15.5 4-20 10.7l-56 84L202.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H392c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C311.5 228 304 224 296 224z", "M296 224c8 0 15.5 4 20 10.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S400.9 416 392 416H248 200 120c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C280.5 228 288 224 296 224z"]]
};
var faCalendarPen = {
  prefix: 'fad',
  iconName: 'calendar-pen',
  icon: [512, 512, ["calendar-edit"], "f333", ["M480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM340.8 267c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L272.6 282 287.5 267c14.7-14.7 38.6-14.7 53.3 0zM178.1 376.5L250 304.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.6c1.4-5.6 4.3-10.8 8.4-14.9z", "M160 0c-17.7 0-32 14.3-32 32V64H80c-26.5 0-48 21.5-48 48v80H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32zM340.8 267c-14.7-14.7-38.6-14.7-53.3 0L272.6 282l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 376.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 428c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 304.6l-71.9 71.9z"]]
};
var faCalendarEdit = faCalendarPen;
var faRoadBridge = {
  prefix: 'fad',
  iconName: 'road-bridge',
  icon: [640, 512, [], "e563", ["M288 96H32C14.3 96 0 110.3 0 128s14.3 32 32 32H72v64H0v96c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V416c0-53 43-96 96-96V224H248V160h40V96zM120 160h80v64H120V160z", "M608 0H352c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32zM504 224v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V224c0-13.3 10.7-24 24-24s24 10.7 24 24zM480 360c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V384c0-13.3 10.7-24 24-24zM504 64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-13.3 10.7-24 24-24s24 10.7 24 24z"]]
};
var faFaceSmileTear = {
  prefix: 'fad',
  iconName: 'face-smile-tear',
  icon: [512, 512, [], "e393", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm141.5 67.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5c8.8 0 16-7.2 16-16s-7.2-16-16-16c-43.4 0-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM352 416c26.5 0 48-21 48-47c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C332.4 308.6 304 349 304 369c0 26 21.5 47 48 47zM208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM400 369c0 26-21.5 47-48 47s-48-21-48-47c0-20 28.4-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C371.4 308.6 400 349 400 369zM336.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faMessagePlus = {
  prefix: 'fad',
  iconName: 'message-plus',
  icon: [512, 512, ["comment-alt-plus"], "f4a8", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM232 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z", "M232 232v64c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faCommentAltPlus = faMessagePlus;
var faLocationArrow = {
  prefix: 'fad',
  iconName: 'location-arrow',
  icon: [448, 512, [], "f124", ["M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z", ""]]
};
var faC = {
  prefix: 'fad',
  iconName: 'c',
  icon: [384, 512, [99], "43", ["M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z", ""]]
};
var faTabletButton = {
  prefix: 'fad',
  iconName: 'tablet-button',
  icon: [448, 512, [], "f10a", ["M448 384H0v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM224 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V384H0V64z"]]
};
var faRectangleHistoryCircleUser = {
  prefix: 'fad',
  iconName: 'rectangle-history-circle-user',
  icon: [640, 512, [], "e4a4", ["M394.8 512C349.5 480.1 320 427.5 320 368c0-97.2 78.8-176 176-176c2.5 0 5 .1 7.5 .2c-11-19.2-31.8-32.2-55.5-32.2L64 160c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64l330.8 0zM464 104c0-13.3-10.7-24-24-24L72 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0c13.3 0 24-10.7 24-24zM416 24c0-13.3-10.7-24-24-24H120C106.7 0 96 10.7 96 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-30.2 0-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7C553.5 468.1 526.2 480 496 480zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faBuildingLock = {
  prefix: 'fad',
  iconName: 'building-lock',
  icon: [576, 512, [], "e4d6", ["M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V193.6c-19.8 20.2-32 47.9-32 78.4v24.6c-19.1 11.1-32 31.7-32 55.4V480c0 11.7 3.1 22.6 8.6 32H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M432 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faChartLineUp = {
  prefix: 'fad',
  iconName: 'chart-line-up',
  icon: [512, 512, [], "e0e5", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M406.6 246.6L439 279c15.1 15.1 41 4.4 41-17V152c0-13.3-10.7-24-24-24H345.9c-21.4 0-32.1 25.9-17 41l32.4 32.4L304 258.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 253.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0l80-80z"]]
};
var faMailbox = {
  prefix: 'fad',
  iconName: 'mailbox',
  icon: [576, 512, [128234], "f813", ["M512 448H224c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144H432c79.5 0 144 64.5 144 144V384c0 35.3-28.7 64-64 64zM400 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H464 400z", "M0 208C0 128.5 64.5 64 144 64s144 64.5 144 144V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208zm64 0c0 8.8 7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm336-16h64 32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V224H400c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faTruckBolt = {
  prefix: 'fad',
  iconName: 'truck-bolt',
  icon: [640, 512, [], "e3d0", ["M266.3 51.7c5.7 4.8 7.4 12.8 4.1 19.4L233.9 144H288c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4L182.1 176H128c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9 .5zM96 432a80 80 0 1 1 160 0A80 80 0 1 1 96 432zm288 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576h-1.1c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H286.9c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM266.3 51.7c-5.7-4.8-13.9-5-19.9-.5l-128 96c-5.5 4.1-7.8 11.3-5.6 17.9s8.3 10.9 15.2 10.9h54.1l-36.4 72.8c-3.3 6.6-1.6 14.7 4.1 19.4s13.9 5 19.9 .5l128-96c5.5-4.1 7.8-11.3 5.6-17.9S294.9 144 288 144H233.9l36.4-72.8c3.3-6.6 1.6-14.7-4.1-19.4z"]]
};
var faPizzaSlice = {
  prefix: 'fad',
  iconName: 'pizza-slice',
  icon: [512, 512, [], "f818", ["M432 400l0 1.6L20.1 511.5c-5.5 1.5-11.4-.1-15.4-4.1s-5.6-9.9-4.1-15.4L110.4 80l1.6 0c176.7 0 320 143.3 320 320zM208 240a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80l1.6 0c176.7 0 320 143.3 320 320l0 1.6 44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM208 240a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faMoneyBillWave = {
  prefix: 'fad',
  iconName: 'money-bill-wave',
  icon: [576, 512, [], "f53a", ["M512 160c-33.9 0-61.6-26.3-63.9-59.7c-40 .9-83.5 10.5-134.2 23.2c-4.6 1.2-9.4 2.3-14.2 3.6l0 0c-51.1 12.8-110.4 27.8-172.9 28.6C121.5 185.4 95.4 208 64 208V352c33.9 0 61.6 26.3 63.9 59.7c40-.9 83.5-10.5 134.2-23.2c4.7-1.2 9.4-2.3 14.2-3.6l0 0c51.1-12.8 110.4-27.8 172.9-28.6c5.5-29.8 31.6-52.4 63-52.4V160zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM512 160V304c-31.4 0-57.5 22.6-63 52.4c-62.5 .8-121.8 15.7-172.9 28.6l0 0c-4.8 1.2-9.5 2.4-14.2 3.6c-50.7 12.6-94.1 22.2-134.2 23.2C125.6 378.3 97.9 352 64 352V208c31.4 0 57.5-22.6 63-52.4c62.5-.8 121.8-15.7 172.9-28.6l0 0c4.8-1.2 9.5-2.4 14.2-3.6c50.7-12.6 94.1-22.2 134.2-23.2c2.2 33.3 30 59.7 63.9 59.7z"]]
};
var faChartArea = {
  prefix: 'fad',
  iconName: 'chart-area',
  icon: [512, 512, ["area-chart"], "f1fe", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M448 352H160c-17.7 0-32-14.3-32-32V236c0-7.8 2.8-15.2 7.9-21.1l79.4-90.8c13-14.8 36.1-14.5 48.7 .6l39.2 47c9 10.8 25.4 11.6 35.4 1.6l21-21c13.2-13.2 34.8-12.4 46.9 1.8L472.3 231c5 5.8 7.7 13.2 7.7 20.8V320c0 17.7-14.3 32-32 32z"]]
};
var faAreaChart = faChartArea;
var faHouseFlag = {
  prefix: 'fad',
  iconName: 'house-flag',
  icon: [640, 512, [], "e50d", ["M416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288H64V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.8c.1 0 .1 0 .2 0h-1V159z", "M512 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512z"]]
};
var faCircleThreeQuartersStroke = {
  prefix: 'fad',
  iconName: 'circle-three-quarters-stroke',
  icon: [512, 512, [], "e5d4", ["M256 0C397.4 0 512 114.6 512 256H448c0-106-86-192-192-192V0z", "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256H288c-17.7 0-32-14.3-32-32V0z"]]
};
var faPersonCircleMinus = {
  prefix: 'fad',
  iconName: 'person-circle-minus',
  icon: [576, 512, [], "e540", ["M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]]
};
var faScalpel = {
  prefix: 'fad',
  iconName: 'scalpel',
  icon: [512, 512, [], "f61d", ["M169.4 320l-4.7 4.7-160 160c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336V320H272 176h-6.6z", "M441.2 0c-20.6 0-40.2 9-53.7 24.6L155.9 293.6c-4.1 4.7-5 11.4-2.4 17.1s8.3 9.3 14.5 9.3H300.9c13.9 0 27.1-6 36.3-16.5L493.8 122.9C505.5 109.4 512 92.1 512 74.2V70.8C512 31.7 480.3 0 441.2 0z"]]
};
var faBan = {
  prefix: 'fad',
  iconName: 'ban',
  icon: [512, 512, [128683, "cancel"], "f05e", ["M99.5 144.8L367.2 412.5c17.5-12.5 32.8-27.8 45.3-45.3L144.8 99.5C127.3 112 112 127.3 99.5 144.8z", "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]]
};
var faCancel = faBan;
var faBellExclamation = {
  prefix: 'fad',
  iconName: 'bell-exclamation',
  icon: [448, 512, [], "f848", ["M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zM192 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-184v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M224 112c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24zm32 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm13.3 173.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"]]
};
var faCircleBookmark = {
  prefix: 'fad',
  iconName: 'circle-bookmark',
  icon: [512, 512, ["bookmark-circle"], "e100", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 176c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 6.2-3.5 11.8-9.1 14.4s-12.1 1.9-16.9-1.9l-70-56-70 56c-4.8 3.8-11.4 4.6-16.9 1.9s-9.1-8.3-9.1-14.4V176z", "M208 128c-26.5 0-48 21.5-48 48V368c0 6.2 3.5 11.8 9.1 14.4s12.1 1.9 16.9-1.9l70-56 70 56c4.8 3.8 11.4 4.6 16.9 1.9s9.1-8.3 9.1-14.4V176c0-26.5-21.5-48-48-48H208z"]]
};
var faBookmarkCircle = faCircleBookmark;
var faEggFried = {
  prefix: 'fad',
  iconName: 'egg-fried',
  icon: [512, 512, [], "f7fc", ["M415.8 116c-42.4-10.9-101.2-45.1-131.5-76.7c-49-51-130-52.6-181-3.6C80.1 58 67.1 87 64.5 116.8C60.2 166.1 46.2 229.1 21.4 272C-22.7 348.5 3.5 446.4 80 490.6s174.4 18 218.6-58.6c18.8-32.5 66.1-60 103.3-65.2c20.5-2.9 40.6-10.8 58.4-24c56.8-42.1 68.7-122.3 26.6-179.1c-18.2-24.6-43.5-40.7-71-47.8zM224 128a112 112 0 1 1 0 224 112 112 0 1 1 0-224z", "M224 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 232c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-39.8 32.2-72 72-72c8.8 0 16 7.2 16 16s-7.2 16-16 16c-22.1 0-40 17.9-40 40z"]]
};
var faFaceWeary = {
  prefix: 'fad',
  iconName: 'face-weary',
  icon: [512, 512, [], "e3a1", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm46.6-164c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z", "M211.3 187.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]]
};
var faUniformMartialArts = {
  prefix: 'fad',
  iconName: 'uniform-martial-arts',
  icon: [640, 512, [], "e3d1", ["M180 0h28 9.6c12.3 0 23.5 7 28.8 18.1l61.1 126.7L253 288H144V133.1L98 216.7c-1.3 2.4-2 5-2 7.7V384c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224.4c0-18.9 4.8-37.4 13.9-54L80.3 49.7C95.9 21.2 124.9 2.8 157 .3c1-.2 2-.3 3-.3h4.4H180zM389.1 20.6C393.8 8.2 405.7 0 419 0h13 28 15.6H480c1 0 2 .1 3 .3c32.1 2.5 61 20.9 76.7 49.5l66.4 120.7c9.1 16.5 13.9 35.1 13.9 54V384c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224.4c0-2.7-.7-5.3-2-7.7l-46-83.7V288H287.2l52.7-138.3L389.1 20.6zM496 448c0 35.3-28.7 64-64 64H208c-35.3 0-64-28.7-64-64V384h86.3l-14.2 21.4c-14.7 22.1-8.7 51.9 13.3 66.6s51.9 8.7 66.6-13.3L320 422.5l24.1 36.1c14.7 22.1 44.5 28 66.6 13.3s28-44.5 13.3-66.6L409.7 384H496v64z", "M496 288H144v64H290.1l-47.4 71.1c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l50.7-76 50.7 76c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L349.9 352H496V288z"]]
};
var faCameraRotate = {
  prefix: 'fad',
  iconName: 'camera-rotate',
  icon: [640, 512, [], "e0d8", ["M213.1 64.8L202.7 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM192 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z", "M448 179.3V256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3zM192 396.7V320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3z"]]
};
var faSunDust = {
  prefix: 'fad',
  iconName: 'sun-dust',
  icon: [512, 512, [], "f764", ["M156.7 512c0 0-.1 0-.1 0h.1zM512 355.3c0 .1 0 .1 0 .2v-.2zM391 121L371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l44.5-44.5C142.3 323.3 128 291.3 128 256c0-70.7 57.3-128 128-128c35.3 0 67.3 14.3 90.5 37.5L391 121zm-67.1 67.1C306.5 170.7 282.5 160 256 160c-53 0-96 43-96 96c0 26.5 10.7 50.5 28.1 67.9L323.9 188.1z", "M480 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM272 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM400 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
};
var faCommentText = {
  prefix: 'fad',
  iconName: 'comment-text',
  icon: [512, 512, [], "e14d", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM184 160h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V312c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M160 184c0-13.3 10.7-24 24-24h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V312c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H184c-13.3 0-24-10.7-24-24z"]]
};
var faSprayCanSparkles = {
  prefix: 'fad',
  iconName: 'spray-can-sparkles',
  icon: [512, 512, ["air-freshener"], "f5d0", ["M384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6zM160 416a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0z"]]
};
var faAirFreshener = faSprayCanSparkles;
var faSignalBars = {
  prefix: 'fad',
  iconName: 'signal-bars',
  icon: [640, 512, ["signal-alt", "signal-alt-4", "signal-bars-strong"], "f690", ["", "M560 0c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V48c0-26.5-21.5-48-48-48zM352 176V464c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zM240 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z"]]
};
var faSignalAlt = faSignalBars;
var faSignalAlt4 = faSignalBars;
var faSignalBarsStrong = faSignalBars;
var faDiamondExclamation = {
  prefix: 'fad',
  iconName: 'diamond-exclamation',
  icon: [512, 512, [], "e405", ["M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faStar = {
  prefix: 'fad',
  iconName: 'star',
  icon: [576, 512, [11088, 61446], "f005", ["M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z", ""]]
};
var faDialMin = {
  prefix: 'fad',
  iconName: 'dial-min',
  icon: [576, 512, [], "e161", ["M256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M192.8 416.7c62.6 46.2 151.3 41 208-15.7c62.5-62.5 62.5-163.8 0-226.3s-163.8-62.5-226.3 0c-56.7 56.7-62 145.4-15.7 208L270.8 270.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L192.8 416.7z"]]
};
var faRepeat = {
  prefix: 'fad',
  iconName: 'repeat',
  icon: [512, 512, [128257], "f363", ["M480 256c17.7 0 32 14.3 32 32c0 88.4-71.6 160-160 160H192l0 32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32H352c53 0 96-43 96-96c0-17.7 14.3-32 32-32z", "M32 256c-17.7 0-32-14.3-32-32C0 135.6 71.6 64 160 64H320l0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V128H160c-53 0-96 43-96 96c0 17.7-14.3 32-32 32z"]]
};
var faCross = {
  prefix: 'fad',
  iconName: 'cross',
  icon: [384, 512, [128327, 10013], "f654", ["M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H256V48c0-26.5-21.5-48-48-48H176z", "M128 256H256v32H128V256z"]]
};
var faPageCaretDown = {
  prefix: 'fad',
  iconName: 'page-caret-down',
  icon: [384, 512, ["file-caret-down"], "e429", ["M320 512c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320zM192 352c-4.5 0-8.8-1.9-11.8-5.2l-75.7-82.6c-14.1-15.4-3.2-40.2 17.7-40.2l139.6 0c20.9 0 31.8 24.8 17.7 40.2l-75.7 82.6c-3 3.3-7.3 5.2-11.8 5.2z", "M180.2 346.8c3 3.3 7.3 5.2 11.8 5.2s8.8-1.9 11.8-5.2l75.7-82.6c14.1-15.4 3.2-40.2-17.7-40.2H122.2c-20.9 0-31.8 24.8-17.7 40.2l75.7 82.6z"]]
};
var faFileCaretDown = faPageCaretDown;
var faBox = {
  prefix: 'fad',
  iconName: 'box',
  icon: [448, 512, [128230], "f466", ["M93.7 32C75.5 32 58.9 42.3 50.7 58.5L0 160H208V32H93.7zM240 32V160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240z", "M240 160H448V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160H208V32h32V160z"]]
};
var faVenusMars = {
  prefix: 'fad',
  iconName: 'venus-mars',
  icon: [640, 512, [9892], "f228", ["M271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4zM592 48l0 0h0v0zM176 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H208v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zm32 0c0-4.8-.2-9.6-.5-14.3c5.3-1.1 10.8-1.7 16.5-1.7c44.2 0 80 35.8 80 80s-35.8 80-80 80c-21.5 0-41-8.5-55.3-22.2C369.4 263.5 384 221.5 384 176z"]]
};
var faClockSevenThirty = {
  prefix: 'fad',
  iconName: 'clock-seven-thirty',
  icon: [512, 512, [], "e351", ["M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V335.3l-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M256 416c-13.3 0-24-10.7-24-24V335.3l-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23V392c0 13.3-10.7 24-24 24z"]]
};
var faArrowPointer = {
  prefix: 'fad',
  iconName: 'arrow-pointer',
  icon: [320, 512, ["mouse-pointer"], "f245", ["M121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H144l-22.8 26z", "M0 426V55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5c0 12.2-9.9 22.1-22.1 22.1H144L38.6 440.5C34.4 445.3 28.4 448 22 448c-12.2 0-22-9.9-22-22z"]]
};
var faMousePointer = faArrowPointer;
var faClockFourThirty = {
  prefix: 'fad',
  iconName: 'clock-four-thirty',
  icon: [512, 512, [], "e34b", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V300.8L338.7 340c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256V392c0 13.3 10.7 24 24 24s24-10.7 24-24z", "M256 416c13.3 0 24-10.7 24-24V300.8L338.7 340c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256V392c0 13.3 10.7 24 24 24z"]]
};
var faSignalBarsGood = {
  prefix: 'fad',
  iconName: 'signal-bars-good',
  icon: [640, 512, ["signal-alt-3"], "f693", ["M512 48c0-26.5 21.5-48 48-48s48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V48z", "M400 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 304V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48s-48 21.5-48 48zM32 432v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]]
};
var faSignalAlt3 = faSignalBarsGood;
var faCactus = {
  prefix: 'fad',
  iconName: 'cactus',
  icon: [512, 512, [127797], "f8a7", ["M96 144c0-26.5-21.5-48-48-48S0 117.5 0 144v64c0 61.9 50.1 112 112 112h48V224H112c-8.8 0-16-7.2-16-16V144zM416 272v64c0 8.8-7.2 16-16 16H352v96h48c61.9 0 112-50.1 112-112V272c0-26.5-21.5-48-48-48s-48 21.5-48 48z", "M160 96c0-53 43-96 96-96s96 43 96 96V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V96zm80 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faLightbulbGear = {
  prefix: 'fad',
  iconName: 'lightbulb-gear',
  icon: [576, 512, [], "e5fd", ["M240.6 384c2.3-13.3 10.5-24.9 21.4-31.8c-16.6-10.6-26.7-31.7-20-53.3c4-12.9 9.4-25.5 16.4-37.6s15.2-23.1 24.4-33c15.7-16.9 39.6-18.5 57.2-8.7v-.9c0-17.8 10.2-35.6 28-43.3C367.6 78.4 289 0 192 0C94.8 0 16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H240.6zm5 32H112v16c0 44.2 35.8 80 80 80c35.2 0 65.1-22.8 75.8-54.4c-3.3-4.7-6.4-9.5-9.4-14.6c-5.1-8.8-9.3-17.8-12.8-27zM192 96c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16z", "M383.3 203.4c-6.8 1.5-11.3 7.8-11.3 14.8v17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9l0 17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8l0-17.7c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7V218.2c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7zM416 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faMaximize = {
  prefix: 'fad',
  iconName: 'maximize',
  icon: [512, 512, ["expand-arrows-alt"], "f31e", ["M56 32H200c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 79 79-64 64-79-79L73 217c-6.9 6.9-17.2 8.9-26.2 5.2S32 209.7 32 200V56c0-13.3 10.7-24 24-24zM256 320l64-64 79 79 40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V456c0 13.3-10.7 24-24 24H312c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40-79-79z", "M480 56V200c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L177 399l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H56c-13.3 0-24-10.7-24-24V312c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L335 113 295 73c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H456c13.3 0 24 10.7 24 24z"]]
};
var faExpandArrowsAlt = faMaximize;
var faChargingStation = {
  prefix: 'fad',
  iconName: 'charging-station',
  icon: [576, 512, [], "f5e7", ["M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V448H32V64zm191.2 37.1c2.3-6.8-.3-14.3-6.3-18.3s-13.9-3.6-19.3 1.1l-112 96c-5.1 4.4-6.9 11.4-4.6 17.7s8.3 10.4 15 10.4h57.8l-25 74.9c-2.3 6.8 .3 14.3 6.3 18.3s13.9 3.6 19.3-1.1l112-96c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4H198.2l25-74.9z", "M480 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320v48h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80zM0 480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]]
};
var faShapes = {
  prefix: 'fad',
  iconName: 'shapes',
  icon: [512, 512, ["triangle-circle-square"], "f61f", ["M288 0c-11.2 0-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2H384c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160C309.7 5.9 299.2 0 288 0zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z", "M328 272c-22.1 0-40 17.9-40 40V456c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328z"]]
};
var faTriangleCircleSquare = faShapes;
var faPlaneTail = {
  prefix: 'fad',
  iconName: 'plane-tail',
  icon: [512, 512, [], "e22c", ["M61.5 308.8L.8 39C-3.7 19 11.5 0 32 0h76.9c17.3 0 33.9 7 46 19.5L384 256H264.7c-7.9 0-15.8 1.1-23.4 3.2L61.5 308.8z", "M512 464V304 280 256H488 264.7c-7.9 0-15.8 1.1-23.4 3.2L45.9 313.1C18.8 320.5 0 345.2 0 373.4c0 26 16.1 49.3 40.4 58.5l196.1 74.4c10 3.8 20.5 5.7 31.2 5.7H488h24V488 464zM216 352H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faGaugeSimpleMax = {
  prefix: 'fad',
  iconName: 'gauge-simple-max',
  icon: [512, 512, ["tachometer-fastest"], "f62b", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm192 96c0-35.3 28.7-64 64-64c14.1 0 27.2 4.6 37.8 12.4l117.5-72.8c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33L319.1 341.2c.6 3.5 .9 7.1 .9 10.8c0 35.3-28.7 64-64 64s-64-28.7-64-64z", "M411.4 227.6c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33L319.1 341.2c.6 3.5 .9 7.1 .9 10.8c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c14.1 0 27.2 4.6 37.8 12.4l117.6-72.8z"]]
};
var faTachometerFastest = faGaugeSimpleMax;
var faCircleU = {
  prefix: 'fad',
  iconName: 'circle-u',
  icon: [512, 512, [], "e127", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 168V288c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M168 144c13.3 0 24 10.7 24 24V288c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24z"]]
};
var faShieldSlash = {
  prefix: 'fad',
  iconName: 'shield-slash',
  icon: [640, 512, [], "e24b", ["M320 0c4.6 0 9.2 1 13.4 2.9L521.7 82.8c22 9.3 38.4 31 38.3 57.2c-.3 58.7-14.7 146.2-62.1 225L131 77.4 306.7 2.9C310.8 1 315.4 0 320 0zM80.6 159.5L437.5 440.7c-25.2 24-55.3 45.4-91.1 62.5c-16.7 8-36.1 8-52.8 0C132 425.8 86.1 261.5 80.6 159.5z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faSquarePhoneHangup = {
  prefix: 'fad',
  iconName: 'square-phone-hangup',
  icon: [448, 512, ["phone-square-down"], "e27a", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM359.4 310c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4 .2-26.7-8.5L66.8 274.8C62 267 63.4 257.3 70.3 251c84.9-78.6 222.6-78.6 307.5 0c6.8 6.3 8.2 16.1 3.4 23.8L359.4 310z", "M332.7 318.5c9.9 3.8 21.4 .2 26.7-8.5l21.7-35.2c4.8-7.8 3.4-17.5-3.4-23.8c-84.9-78.6-222.6-78.6-307.5 0c-6.8 6.3-8.2 16.1-3.4 23.8L88.6 310c5.3 8.6 16.8 12.3 26.7 8.5l46.2-17.6c8.7-3.3 14.1-11.6 13.1-20.3L171.7 254c33.8-10.8 70.8-10.8 104.6 0l-2.9 26.7c-.9 8.7 4.4 16.9 13.1 20.3l46.2 17.6z"]]
};
var faPhoneSquareDown = faSquarePhoneHangup;
var faArrowUpLeft = {
  prefix: 'fad',
  iconName: 'arrow-up-left',
  icon: [384, 512, [], "e09d", ["M96 205.3L297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 160H96v45.3z", "M32 128c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H96V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V128z"]]
};
var faTransporter1 = {
  prefix: 'fad',
  iconName: 'transporter-1',
  icon: [512, 512, [], "e043", ["M480 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 160l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 160zM64 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 352 6.6 359.3C2.7 360.4 0 363.9 0 368s2.7 7.6 6.6 8.7L32 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 352zm112-32c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM216 512h80 88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h88zM359 276c6.3 7.8 15.4 11.9 24.7 12h.3v0c7 0 14.1-2.3 20-7c13.8-11.1 16-31.2 5-45l-57.7-72c-18.2-22.7-45.8-36-74.9-36H235.6c-29.1 0-56.7 13.2-74.9 36L103 236c-11.1 13.8-8.8 33.9 5 45c5.9 4.7 13 7 20 7v0h.3c9.3-.1 18.5-4.2 24.7-12l31-38.7V288H328V237.3L359 276z"]]
};
var faPeanuts = {
  prefix: 'fad',
  iconName: 'peanuts',
  icon: [640, 512, [129372], "e431", ["M560 0H492c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C373 57.8 362.4 74 355.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364v68c0 44.2 35.8 80 80 80h68c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C623.6 225.4 640 188.6 640 148V80c0-44.2-35.8-80-80-80zM524.8 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm0 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 0a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM320 396.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm0-64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z", "M161.7 28.3L212.6 5.7c33.1-14.7 71.8 .1 86.6 33.2l22.7 50.9c12.4 27.8 13.5 57.8 5.2 84.8c-3.1 4.8-6.7 9.4-10.9 13.5c-17.6 17.6-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364v68c0 23.4 10 44.4 26 59l-34.3 15.3c-33.1 14.7-71.8-.2-86.6-33.2L10.5 422.2C3.8 407.2 .4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6C14 314 22.7 300.5 33.4 289.3c5.8-6.1 12.3-11.7 19.5-16.6c16.7-11.8 32.5-25.8 39.8-44.9s5-40.1 .4-60c-2.1-8.4-3.2-17-3.4-25.4c-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9c10.7-11.2 23.6-20.6 38.7-27.3zM524.8 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm0 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 0a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM320 396.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm0-64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z"]]
};
var faShuffle = {
  prefix: 'fad',
  iconName: 'shuffle',
  icon: [512, 512, [128256, "random"], "f074", ["M438.6 41.4c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6V96H352c-30.2 0-58.7 14.2-76.8 38.4L224 202.7 264 256l62.4-83.2c6-8.1 15.5-12.8 25.6-12.8h32v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64zM224 309.3L184 256l-62.4 83.2c-6 8.1-15.5 12.8-25.6 12.8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96c30.2 0 58.7-14.2 76.8-38.4L224 309.3z", "M352 416c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352z"]]
};
var faRandom = faShuffle;
var faPersonRunning = {
  prefix: 'fad',
  iconName: 'person-running',
  icon: [448, 512, [127939, "running"], "f70c", ["M146.1 228.4L91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5l24.6-55.4-5.7-3.6c-25.1-15.7-36.1-46.5-26.8-74.5l8.5-25.6zm60.4 21.3c-.1 .2-.1 .5-.2 .7l.2-.7z", "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C102.4 108.3 132.2 96 163.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H362.7c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L238 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L286.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3z"]]
};
var faRunning = faPersonRunning;
var faMobileRetro = {
  prefix: 'fad',
  iconName: 'mobile-retro',
  icon: [320, 512, [], "e527", ["M0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z", "M64 160c0-17.7 14.3-32 32-32H224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"]]
};
var faGripLinesVertical = {
  prefix: 'fad',
  iconName: 'grip-lines-vertical',
  icon: [192, 512, [], "f7a5", ["M128 64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64z", "M0 64C0 46.3 14.3 32 32 32s32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64z"]]
};
var faBinBottlesRecycle = {
  prefix: 'fad',
  iconName: 'bin-bottles-recycle',
  icon: [640, 512, [], "e5f6", ["M128 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16V24zm0 72H256c24.9 0 47.6 9.5 64.6 25c1.1 1 2.2 2 3.2 3.1C341.3 141.5 352 165.5 352 192H32c0-53 43-96 96-96zm447.1 96H384c0-40.7-19-76.9-48.6-100.4c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7V24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V66.1c5.6 1.3 11.1 3.2 16.4 5.7L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5z", "M0 256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32L583.8 457c-4.5 31.5-31.5 55-63.4 55h-401c-31.8 0-58.9-23.4-63.4-55L32 288c-17.7 0-32-14.3-32-32zm319.9 64c4.6 0 9 2.3 11.5 6.2l8.5 12.9c4.8 7.3 14.5 9.4 21.8 4.8c7.6-4.8 9.8-14.9 4.9-22.4l-8.5-12.9c-8.5-12.9-22.8-20.6-38.2-20.6c-15.3 0-29.6 7.7-38.1 20.4l-7.6 11.4c-5 7.5-2.8 17.7 4.8 22.4c7.3 4.6 17 2.5 21.8-4.7l7.6-11.4c2.6-3.8 6.9-6.1 11.5-6.1zm-59.4 48.4c-7.3-4.6-17-2.5-21.8 4.7l-7.9 11.9c-4.4 6.7-6.8 14.5-6.8 22.5c0 22.4 18.2 40.6 40.6 40.6h25.2c8.8 0 16-7.2 16-16s-7.2-16-16-16H264.6c-4.7 0-8.6-3.8-8.6-8.6c0-1.7 .5-3.3 1.4-4.7l7.9-11.9c5-7.5 2.8-17.7-4.8-22.4zM337.7 432c0 8.8 7.2 16 16 16h20.9c22.4 0 40.6-18.2 40.6-40.6c0-7.9-2.3-15.7-6.7-22.4l-6.6-10.1c-4.8-7.3-14.5-9.4-21.8-4.8c-7.6 4.8-9.8 14.9-4.9 22.4l6.6 10.1c.9 1.4 1.4 3.1 1.4 4.7c0 4.8-3.9 8.6-8.6 8.6H353.7c-8.8 0-16 7.2-16 16z"]]
};
var faArrowUpFromSquare = {
  prefix: 'fad',
  iconName: 'arrow-up-from-square',
  icon: [512, 512, [], "e09c", ["M80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h8c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z", "M233.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z"]]
};
var faFileDashedLine = {
  prefix: 'fad',
  iconName: 'file-dashed-line',
  icon: [640, 512, ["page-break"], "f877", ["M192 0c-35.3 0-64 28.7-64 64V256H512V160H384c-17.7 0-32-14.3-32-32V0H192zM512 368H128v80c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V368zM384 0V128H512L384 0z", "M32 312c0-13.3 10.7-24 24-24H168c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zm224 0c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24zm192 0c0-13.3 10.7-24 24-24H584c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24z"]]
};
var faPageBreak = faFileDashedLine;
var faBracketCurlyRight = {
  prefix: 'fad',
  iconName: 'bracket-curly-right',
  icon: [256, 512, [], "7d", ["M192 128c0-53-43-96-96-96H64C46.3 32 32 46.3 32 64s14.3 32 32 32H96c17.7 0 32 14.3 32 32v37.5c0 25.5 10.1 49.9 28.1 67.9L178.7 256l-22.6 22.6c-18 18-28.1 42.4-28.1 67.9V384c0 17.7-14.3 32-32 32H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96c53 0 96-43 96-96V346.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3l-45.3-45.3c-6-6-9.4-14.1-9.4-22.6V128z", ""]]
};
var faSpider = {
  prefix: 'fad',
  iconName: 'spider',
  icon: [512, 512, [128375], "f717", ["M144.6 1.6c-12.4-4.8-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4 24.9 8.3V174.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6c4.8-12.4-1.4-26.3-13.8-31zM360.9 217.1l57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1v51.3l24.9-8.3z", "M221.5 87.8c9.1-4.4 18.5 3.3 18.5 13.4V112c0 8.8 7.2 16 16 16s16-7.2 16-16V101.2c0-10.1 9.4-17.7 18.5-13.4C317.4 100.7 336 128.2 336 160v65.4l105.2-35.1c2.4-.8 4.3-2.7 5.1-5.1l18.9-56.8c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4l-18.9 56.8c-5.6 16.7-18.7 29.8-35.4 35.4L395.9 256l60.5 20.2c16.7 5.6 29.8 18.7 35.4 35.4l18.9 56.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-18.9-56.8c-.8-2.4-2.7-4.3-5.1-5.1l-80.4-26.8 57.4 57.4c15.6 15.6 20.6 39 12.7 59.7l-32.5 84.6c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l32.5-84.6c1.1-3 .4-6.3-1.8-8.5L352 353.9c-1 52.1-43.6 94.1-96 94.1s-95-41.9-96-94.1l-32.3 32.3c-2.2 2.2-2.9 5.6-1.8 8.5l32.5 84.6c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8L81.1 412c-7.9-20.7-3-44.1 12.7-59.7l57.4-57.4L70.8 321.7c-2.4 .8-4.3 2.7-5.1 5.1L46.8 383.6C42.6 396.2 29 403 16.4 398.8S-3 381 1.2 368.4l18.9-56.8c5.6-16.7 18.7-29.8 35.4-35.4L116.1 256 55.6 235.8c-16.7-5.6-29.8-18.7-35.4-35.4L1.2 143.6C-3 131 3.8 117.4 16.4 113.2s26.2 2.6 30.4 15.2l18.9 56.8c.8 2.4 2.7 4.3 5.1 5.1L176 225.4V160c0-31.8 18.6-59.3 45.5-72.2z"]]
};
var faClockThree = {
  prefix: 'fad',
  iconName: 'clock-three',
  icon: [512, 512, [], "e356", ["M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z", "M256 96c-13.3 0-24 10.7-24 24V256c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24z"]]
};
var faHandsBound = {
  prefix: 'fad',
  iconName: 'hands-bound',
  icon: [640, 512, [], "e4f9", ["M64 0C81.7 0 96 14.3 96 32V96v48.8l69.3 92.4c5.7 7.6 16.1 9.6 24.2 4.8c9.7-5.7 12.1-18.7 5.1-27.5L167 180c-10.8-13.5-8.9-33.3 4.4-44.5s33-9.8 44.5 3.2l46.7 52.5C279 209.7 288 233.4 288 258.1V320v32H131.6L46.3 252.5C37.1 241.8 32 228 32 213.9V192 155.8v-.7V96 32C32 14.3 46.3 0 64 0zm96 480H288v32H160V480zm192 0H480v32H352V480zM508.4 352H352V320 258.1c0-24.6 9-48.4 25.4-66.8l46.7-52.5c11.5-13 31.3-14.4 44.5-3.2s15.2 30.9 4.4 44.5l-27.6 34.5c-7 8.8-4.7 21.8 5.1 27.5c8.1 4.8 18.6 2.7 24.2-4.8L544 144.8V96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V96v59.1 .7V192v21.9c0 14.2-5.1 27.9-14.3 38.7L508.4 352z", "M128 352c-13.3 0-24 10.7-24 24s10.7 24 24 24H512c13.3 0 24-10.7 24-24s-10.7-24-24-24H128zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H512c13.3 0 24-10.7 24-24s-10.7-24-24-24H128z"]]
};
var faScalpelLineDashed = {
  prefix: 'fad',
  iconName: 'scalpel-line-dashed',
  icon: [576, 512, ["scalpel-path"], "f61e", ["M169.4 320l-4.7 4.7-160 160c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336V320H272 176h-6.6z", "M387.5 24.6C400.9 9 420.5 0 441.2 0C480.3 0 512 31.7 512 70.8v3.4c0 17.9-6.5 35.2-18.2 48.7L337.2 303.5C328 314 314.8 320 300.9 320H168c-6.3 0-11.9-3.6-14.5-9.3s-1.7-12.4 2.4-17.1L387.5 24.6zM240 480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faScalpelPath = faScalpelLineDashed;
var faFileInvoiceDollar = {
  prefix: 'fad',
  iconName: 'file-invoice-dollar',
  icon: [384, 512, [], "f571", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 72c-8.8 0-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V440c0 8.8 7.2 16 16 16s16-7.2 16-16V422.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V232c0-8.8-7.2-16-16-16z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM208 232c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16V422.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V232z"]]
};
var faPipeSmoking = {
  prefix: 'fad',
  iconName: 'pipe-smoking',
  icon: [640, 512, [], "e3c4", ["M495.3 106.7C513.1 80 543.1 64 575.2 64H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H575.2C521.7 0 471.7 26.7 442 71.2L361.5 192c5.6 .3 11.2 2 16.2 5.3l24 16c5.8 3.9 9.9 9.3 12.2 15.4l81.3-122z", "M377.8 197.4c-14.7-9.8-34.6-5.8-44.4 8.9L256 322.3V272c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48v82.9C0 441.7 70.3 512 157.1 512c52.5 0 101.6-26.2 130.7-69.9L410.6 257.8c9.8-14.7 5.8-34.6-8.9-44.4l-24-16z"]]
};
var faFaceAstonished = {
  prefix: 'fad',
  iconName: 'face-astonished',
  icon: [512, 512, [], "e36b", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V352c0-26.5 21.5-48 48-48zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z", "M192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-15.6 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 128.9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]]
};
var faWindow = {
  prefix: 'fad',
  iconName: 'window',
  icon: [512, 512, [], "f40e", ["M160 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM512 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V224l512 0V416zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M64 32C28.7 32 0 60.7 0 96V224H512V96c0-35.3-28.7-64-64-64H64zM96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faPlaneCircleExclamation = {
  prefix: 'fad',
  iconName: 'plane-circle-exclamation',
  icon: [640, 512, [], "e556", ["M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l77.1 44.1C350.6 254 320 307.4 320 368c0 54.2 24.5 102.7 63.1 135c-2 5.3-7.1 9-13.1 9c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faEar = {
  prefix: 'fad',
  iconName: 'ear',
  icon: [384, 512, [128066], "f5f0", ["M319.9 335.2c-18.2 16.3-30 39.1-35.1 62.9c-5.6 26.3-18.6 51.3-39 71.7c-56.2 56.2-147.4 56.2-203.6 0C14.1 441.7 0 404.9 0 368V192C0 86 86 0 192 0S384 86 384 192c0 56.9-24.8 108-64.1 143.2zM128 192c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-61.9-50.1-112-112-112S80 130.1 80 192v20.2c0 21.2 12 40.6 31 50.1l14 7c1.8 .9 3 2.8 3 4.9c0 1.6-.7 3.2-2 4.2L88.6 309.6c-10.2 8.5-11.6 23.6-3.1 33.8s23.6 11.6 33.8 3.1l37.4-31.2C169 305.1 176 290.1 176 274.2c0-20.2-11.4-38.8-29.5-47.8l-14-7c-2.7-1.4-4.4-4.1-4.4-7.2V192z", "M192 128c-35.3 0-64 28.7-64 64v20.2c0 3 1.7 5.8 4.4 7.2l14 7c18.1 9.1 29.5 27.6 29.5 47.8c0 15.9-7 30.9-19.2 41.1l-37.4 31.2c-10.2 8.5-25.3 7.1-33.8-3.1s-7.1-25.3 3.1-33.8L126 278.4c1.2-1 2-2.6 2-4.2c0-2.1-1.2-4-3-4.9l-14-7c-19-9.5-31-28.9-31-50.1V192c0-61.9 50.1-112 112-112s112 50.1 112 112v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-35.3-28.7-64-64-64z"]]
};
var faFileLock = {
  prefix: 'fad',
  iconName: 'file-lock',
  icon: [576, 512, [], "e3a6", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v33.6c-19.8 20.2-32 47.9-32 78.4v24.6c-19.1 11.1-32 31.7-32 55.4V480c0 11.4 3 22.2 8.3 31.5c-2.7 .3-5.5 .5-8.3 .5H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zm80 80c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]]
};
var faDiagramVenn = {
  prefix: 'fad',
  iconName: 'diagram-venn',
  icon: [640, 512, [], "e15a", ["M192 256c0-61 24.4-116.4 64-156.8c23.6 4.8 45.4 14.8 64 28.8c-38.9 29.2-64 75.7-64 128s25.1 98.8 64 128c-18.6 14-40.3 24-64 28.8C216.4 372.4 192 317 192 256zM384 412.8c39.6-40.4 64-95.7 64-156.8s-24.4-116.4-64-156.8c-8.6-8.8-17.9-16.9-27.9-24.1c-.5-.4-1-.7-1.5-1.1c-10.9-7.8-22.4-14.7-34.6-20.5C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-34.4 0-66.9-7.7-96-21.6c12.2-5.8 23.8-12.7 34.6-20.5c10.5-7.5 20.3-16 29.3-25.2z", "M352 352H288c-7.4-9.8-13.7-20.6-18.7-32H370.7c6.5-14.9 10.8-31.1 12.5-48H256.8c-.5-5.3-.8-10.6-.8-16s.3-10.7 .8-16H383.2c-1.7-16.9-6-33.1-12.5-48H269.3c5-11.4 11.3-22.2 18.7-32h64c-29.2-38.9-75.7-64-128-64C135.6 96 64 167.6 64 256s71.6 160 160 160c52.3 0 98.8-25.1 128-64zM0 256a224 224 0 1 1 448 0A224 224 0 1 1 0 256z"]]
};
var faXRay = {
  prefix: 'fad',
  iconName: 'x-ray',
  icon: [512, 512, [], "f497", ["M480 96H32V416H480V96zM256 128c8.8 0 16 7.2 16 16v16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v32H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v48c0 .4 0 .8 0 1.2l50.4-21.6c5.5-2.4 11.4-3.6 17.4-3.6h7.4c20.4 0 36.9 16.5 36.9 36.9c0 8.2-2.8 16.3-7.9 22.8l-19.4 24.8C347 376.8 332.1 384 316.4 384H195.6c-15.7 0-30.6-7.2-40.3-19.6l-19.4-24.8c-5.1-6.5-7.9-14.5-7.9-22.8c0-20.4 16.5-36.9 36.9-36.9h7.4c6 0 11.9 1.2 17.4 3.6L240 305.2c0-.4 0-.8 0-1.2V256H128c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V192H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V144c0-8.8 7.2-16 16-16zM208 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faGoalNet = {
  prefix: 'fad',
  iconName: 'goal-net',
  icon: [640, 512, [], "e3ab", ["M160 144c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H384v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H288v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H192v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V320H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V224H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V144zm32 240h64V320H192v64zm96 0h64V320H288v64zm96 0h64V320H384v64zm64-160H384v64h64V224zm-96 0H288v64h64V224zm-96 0H192v64h64V224z", "M96 96c-17.7 0-32 14.3-32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V128C0 75 43 32 96 32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7-14.3-32-32-32H96z"]]
};
var faCoffinCross = {
  prefix: 'fad',
  iconName: 'coffin-cross',
  icon: [384, 512, [], "e051", ["M102.4 10.9l-91 104C4.1 123.3 0 134.2 0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1H255.9c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0h-131c-9.2 0-18 4-24.1 10.9zM216 120v40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V120c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M216 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h48V328c0 13.3 10.7 24 24 24s24-10.7 24-24V208h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V120z"]]
};
var faSpellCheck = {
  prefix: 'fad',
  iconName: 'spell-check',
  icon: [576, 512, [], "f891", ["M141.5 19.7C136.6 7.8 124.9 0 112 0S87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160zM112 115.2L130.7 160H93.3L112 115.2zM288 0c-17.7 0-32 14.3-32 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H288zm80 80c0 8.8-7.2 16-16 16H320V64h32c8.8 0 16 7.2 16 16zM320 192V160h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320z", "M566.6 265.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L352 434.7 521.4 265.4c12.5-12.5 32.8-12.5 45.3 0z"]]
};
var faLocationXmark = {
  prefix: 'fad',
  iconName: 'location-xmark',
  icon: [384, 512, ["map-marker-times", "map-marker-xmark"], "f60e", ["M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM111 111c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z", "M145 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faMapMarkerTimes = faLocationXmark;
var faMapMarkerXmark = faLocationXmark;
var faCircleQuarterStroke = {
  prefix: 'fad',
  iconName: 'circle-quarter-stroke',
  icon: [512, 512, [], "e5d3", ["M64 256c0 106 86 192 192 192s192-86 192-192s-86-192-192-192V0C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256H64z", "M256 0C114.6 0 0 114.6 0 256l224 0c17.7 0 32-14.3 32-32L256 0z"]]
};
var faLasso = {
  prefix: 'fad',
  iconName: 'lasso',
  icon: [576, 512, [], "f8c8", ["M576 176c0 97.2-128.9 176-288 176c-13.2 0-26.3-.5-39-1.6c4.6 12.8 7 26.5 7 40.6c0 66.8-54.2 121-121 121H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h71c31.5 0 57-25.5 57-57c0-21.6-12.2-41.3-31.5-51l-46.8-23.4 .2-.4C44.7 284.1 0 233.2 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 288c123.7 0 224-50.1 224-112s-100.3-112-224-112S64 114.1 64 176s100.3 112 224 112z", ""]]
};
var faSlash = {
  prefix: 'fad',
  iconName: 'slash',
  icon: [640, 512, [], "f715", ["", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faPersonToPortal = {
  prefix: 'fad',
  iconName: 'person-to-portal',
  icon: [512, 512, ["portal-enter"], "e022", ["M352.6 287.5c3.3 .3 6.7 .5 10.1 .5H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-3.5 0-6.8-.6-10-1.6C357.8 96.9 391.4 0 432 0c44.2 0 80 114.6 80 256s-35.8 256-80 256c-40.9 0-74.6-98-79.4-224.5z", "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"]]
};
var faPortalEnter = faPersonToPortal;
var faCalendarStar = {
  prefix: 'fad',
  iconName: 'calendar-star',
  icon: [512, 512, [], "f736", ["M480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM265.3 250.9l23.6 47.8 52.7 7.7c8.5 1.2 11.9 11.7 5.8 17.7l-38.2 37.2 9 52.5c1.5 8.5-7.5 15-15.1 11L256 400l-47.2 24.8c-7.6 4-16.5-2.5-15.1-11l9-52.5-38.2-37.2c-6.2-6-2.8-16.5 5.8-17.7l52.7-7.7 23.6-47.8c3.8-7.7 14.8-7.7 18.7 0z", "M160 0c-17.7 0-32 14.3-32 32V64H80c-26.5 0-48 21.5-48 48v80H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32zM265.3 250.9c-3.8-7.7-14.8-7.7-18.7 0l-23.6 47.8-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L256 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8z"]]
};
var faComputerMouse = {
  prefix: 'fad',
  iconName: 'computer-mouse',
  icon: [384, 512, [128433, "mouse"], "f8cc", ["M0 192H176V0H160C71.6 0 0 71.6 0 160v32zm0 32V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192 0zm384-32V160C384 71.6 312.4 0 224 0H208V192H384z", "M176 192H0v32H192 384V192H208V0H176V192z"]]
};
var faMouse = faComputerMouse;
var faArrowRightToBracket = {
  prefix: 'fad',
  iconName: 'arrow-right-to-bracket',
  icon: [512, 512, ["sign-in"], "f090", ["M320 448c0-17.7 14.3-32 32-32l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32z", "M342.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]]
};
var faSignIn = faArrowRightToBracket;
var faPegasus = {
  prefix: 'fad',
  iconName: 'pegasus',
  icon: [576, 512, [], "f703", ["M76.3 168.8C68.5 181.6 64 196.7 64 212.8c0 3.6 .2 7.1 .7 10.7C54.6 230.8 48 242.6 48 256v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-44.6 33.2-81.5 76.3-87.2z", "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C378.4 0 321.7 55.6 320 124.8L184.9 34.7c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1c0 48.1 3.8 99.9 26 139.8c9.2 16.6 21.7 31.3 38.2 42.7c-7.2-2.5-14-5.4-20.3-8.8c-22.5-12.1-38.6-29.4-49.9-49.8c-7.3-13.2-12.7-27.8-16.5-43C96 134.3 64 169.8 64 212.8c0 16.8 5 33.1 14.2 47.1l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faFilesMedical = {
  prefix: 'fad',
  iconName: 'files-medical',
  icon: [448, 512, [], "f7fd", ["M352 0H160C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96H384c-17.7 0-32-14.3-32-32V0zM240 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304v48c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V288H192c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z", "M352 64V0l96 96H384c-17.7 0-32-14.3-32-32zM24 96c13.3 0 24 10.7 24 24V376c0 48.6 39.4 88 88 88H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24zm216 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304v48c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V288H192c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"]]
};
var faNfcLock = {
  prefix: 'fad',
  iconName: 'nfc-lock',
  icon: [576, 512, [], "e1f8", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H320V416H112c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H320V352c0-23.7 12.9-44.4 32-55.4V272 144c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16v66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-26.5 21.5-48 48-48h80c26.5 0 48 21.5 48 48v49.6c16.8-17.1 39.1-28.9 64-32.5V96c0-35.3-28.7-64-64-64H64z", "M432 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faPersonSkiLift = {
  prefix: 'fad',
  iconName: 'person-ski-lift',
  icon: [512, 512, ["ski-lift"], "f7c8", ["M240 0c8.8 0 16 7.2 16 16V198.3l-32 8.5V16c0-8.8 7.2-16 16-16zM13.6 178.3c12-5.7 26.3-.7 32 11.3l65 135.8c8.3 17.4 28 26.4 46.6 21.3l36.5-9.9c12.8-3.5 26 4.1 29.5 16.8s-4.1 26-16.8 29.5l-36.5 9.9c-41 11.2-84.2-8.6-102.5-46.9L2.3 210.4c-5.7-12-.7-26.3 11.3-32zM488 288c13.3 0 24 10.7 24 24v1c0 33.5-20.9 63.4-52.3 75L128.3 510.5c-12.4 4.6-26.2-1.8-30.8-14.2s1.8-26.2 14.2-30.8L443.1 343c12.6-4.6 20.9-16.6 20.9-30v-1c0-13.3 10.7-24 24-24z", "M64 80a48 48 0 1 1 96 0A48 48 0 1 1 64 80zm36.4 138c-14.2-30.8 8.3-66 42.2-66c18.2 0 34.8 10.7 42.3 27.3l28.8 63.4 55.9-14.9c25.4-6.8 50.3 12.4 50.3 38.6V388.5l-64 23.7V297.7l-66.7 17.8c-22.6 6-46.2-5.1-55.9-26.3L100.4 218z"]]
};
var faSkiLift = faPersonSkiLift;
var faSquare6 = {
  prefix: 'fad',
  iconName: 'square-6',
  icon: [448, 512, [], "e25b", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C142.2 224.8 128 255.6 128 288z", "M279.6 170.2c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C142.2 224.8 128 255.6 128 288c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4zM272 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]]
};
var faShopSlash = {
  prefix: 'fad',
  iconName: 'shop-slash',
  icon: [640, 512, ["store-alt-slash"], "e070", ["M121.8 192L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192h85zM384 398.5l-64-50.4V384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.5zM543.7 512c.1 0 .2 0 .3 0s.2 0 .3 0h-.6zM320 225.5l64 50.2V224H320v1.5zM512 376l64 50.2V224H512V376zM74.1 32.8L277.2 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L74.1 32.8z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faStoreAltSlash = faShopSlash;
var faWindTurbine = {
  prefix: 'fad',
  iconName: 'wind-turbine',
  icon: [512, 512, [], "f89b", ["M224 265.7V464H152c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H288V369.7l-64-104z", "M345.2 404.1c2.5 17.2-20.3 25.5-29.5 10.7L214 249.4c-1.8-2.9-4.5-5.2-7.7-6.5L25.7 171.4C9.5 165 13.7 141 31.1 140.6l194.1-5.4c3.5-.1 6.8-1.3 9.5-3.5L387 11c13.6-10.8 32.3 4.8 24 20.1L318.6 202c-1.6 3-2.3 6.5-1.8 9.9l28.4 192.1zM256 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faSlidersSimple = {
  prefix: 'fad',
  iconName: 'sliders-simple',
  icon: [512, 512, [], "e253", ["M325.5 192L32 192c-17.7 0-32-14.3-32-32s14.3-32 32-32H325.5c-3.5 10-5.5 20.8-5.5 32s1.9 22 5.5 32zM186.5 384c3.5-10 5.5-20.8 5.5-32s-1.9-22-5.5-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H186.5z", "M416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-128a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM96 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-128a96 96 0 1 0 0 192 96 96 0 1 0 0-192z"]]
};
var faGridRound = {
  prefix: 'fad',
  iconName: 'grid-round',
  icon: [448, 512, [], "e5da", ["M224 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM64 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm96 224a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM384 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128z", "M128 96A64 64 0 1 1 0 96a64 64 0 1 1 128 0zm0 320A64 64 0 1 1 0 416a64 64 0 1 1 128 0zm96-96a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM448 96A64 64 0 1 1 320 96a64 64 0 1 1 128 0zM384 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"]]
};
var faBadgeSheriff = {
  prefix: 'fad',
  iconName: 'badge-sheriff',
  icon: [448, 512, [], "f8a2", ["M224 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z", "M272 48c0 14.8-6.7 28-17.2 36.8l25 42.8c5.7 9.8 16.2 15.8 27.5 15.9l47.6 .2c6.7-18.5 24.4-31.7 45.2-31.7c26.5 0 48 21.5 48 48s-21.5 48-48 48c-5.9 0-11.6-1.1-16.9-3.1L363 240.1c-5.6 9.8-5.6 21.9 0 31.8l20.1 35.2c5.3-2 10.9-3.1 16.9-3.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.8 0-38.5-13.2-45.2-31.7l-47.6 .2c-11.3 0-21.8 6.1-27.5 15.9l-25 42.8c10.5 8.8 17.2 22 17.2 36.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-14.8 6.7-28 17.2-36.8l-25-42.8c-5.7-9.8-16.2-15.8-27.5-15.9l-47.6-.2C86.5 386.8 68.8 400 48 400c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.6 1.1 16.9 3.1L85 271.9c5.6-9.8 5.6-21.9 0-31.8L64.9 204.9c-5.3 2-10.9 3.1-16.9 3.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.8 0 38.5 13.2 45.2 31.7l47.6-.2c11.3 0 21.8-6.1 27.5-15.9l25-42.8C182.7 76 176 62.8 176 48c0-26.5 21.5-48 48-48s48 21.5 48 48zM224 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faServer = {
  prefix: 'fad',
  iconName: 'server',
  icon: [512, 512, [], "f233", ["M416 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm32 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faVirusCovidSlash = {
  prefix: 'fad',
  iconName: 'virus-covid-slash',
  icon: [640, 512, [], "e4a9", ["M472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 472.1 344.7zm-70.8 67.5L149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faIntersection = {
  prefix: 'fad',
  iconName: 'intersection',
  icon: [384, 512, [8898], "f668", ["M32 480c17.7 0 32-14.3 32-32V224c0-70.7 57.3-128 128-128s128 57.3 128 128V448c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-106-86-192-192-192S0 118 0 224V448c0 17.7 14.3 32 32 32z", ""]]
};
var faShopLock = {
  prefix: 'fad',
  iconName: 'shop-lock',
  icon: [640, 512, [], "e4a5", ["M449.6 192H36.8C16.5 192 0 175.5 0 155.2c0-7.3 2.2-14.4 6.2-20.4L81.8 21.4C90.7 8 105.6 0 121.7 0H518.3c16.1 0 31 8 39.9 21.4l75.6 113.3c4 6.1 6.2 13.2 6.2 20.4c0 19.3-14.8 35.1-33.7 36.7C586.1 172.2 558.5 160 528 160c-30.5 0-58.2 12.2-78.4 32zM384 352v32 80c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V384 224h64V384H320V224h64V352z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faFamily = {
  prefix: 'fad',
  iconName: 'family',
  icon: [512, 512, [], "e300", ["M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 160h44.8c9.2 0 18.1 1.6 26.4 4.5c-.5 3.8-.8 7.6-.8 11.5c0 24.3 10.9 46.1 28 60.8c-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1 .8 11.9 2.4 17.5c-8.7 9-20.9 14.5-34.4 14.5H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160zM368 512c-13.5 0-25.7-5.6-34.4-14.5c1.6-5.6 2.4-11.4 2.4-17.5V423.6c19.6-17.6 32-43.1 32-71.6V336c0-43.1-24.3-80.5-60-99.2c17.1-14.7 28-36.5 28-60.8c0-2.4-.1-4.7-.3-7.1c9.6-5.7 20.8-8.9 32.6-8.9h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48H368zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0z", "M208 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM176 336c0-44.2 35.8-80 80-80s80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V407.4c-19.1-11.1-32-31.7-32-55.4V336z"]]
};
var faHourglassStart = {
  prefix: 'fad',
  iconName: 'hourglass-start',
  icon: [384, 512, ["hourglass-1"], "f251", ["M32 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9v11h64V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75V64H32V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9l22.6 22.6L78.9 323.9C48.9 353.9 32 394.6 32 437z", "M0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM0 32C0 49.7 14.3 64 32 64l64 0V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 0 0 14.3 0 32z"]]
};
var faHourglass1 = faHourglassStart;
var faUserHairBuns = {
  prefix: 'fad',
  iconName: 'user-hair-buns',
  icon: [448, 512, [], "e3d3", ["M224 80c14.6 19.4 37.8 32 64 32h32v64c0 53-43 96-96 96s-96-43-96-96V112h32c26.2 0 49.4-12.6 64-32z", "M109.8 70.1C131 28.5 174.1 0 224 0s93 28.5 114.2 70.1c6.8-3.9 14.7-6.1 23.1-6.1c25.8 0 46.7 20.9 46.7 46.7V136c0 30.9-25.1 56-56 56H318.7c.9-5.2 1.3-10.5 1.3-16V112H288c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32H128v64c0 5.5 .5 10.8 1.3 16H96c-30.9 0-56-25.1-56-56V110.7C40 84.9 60.9 64 86.7 64c8.4 0 16.2 2.2 23.1 6.1zM0 481.3C0 392.2 72.2 320 161.3 320H286.7C375.8 320 448 392.2 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3z"]]
};
var faBlenderPhone = {
  prefix: 'fad',
  iconName: 'blender-phone',
  icon: [576, 512, [], "f6b6", ["M224 384L196.3 52C194 24 216.1 0 244.2 0H535c20.8 0 36.1 19.6 31 39.8L560 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H552l-16 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H528l-16 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H504l-24 96H224z", "M147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2zM560 64l-8 32H400c-8.8 0-16-7.2-16-16s7.2-16 16-16H560zm-24 96l-8 32H400c-8.8 0-16-7.2-16-16s7.2-16 16-16H536zm-24 96l-8 32H400c-8.8 0-16-7.2-16-16s7.2-16 16-16H512zM208 384H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faHourglassClock = {
  prefix: 'fad',
  iconName: 'hourglass-clock',
  icon: [576, 512, [], "e41b", ["M0 32C0 14.3 14.3 0 32 0H64 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l36 36c-11 23-17.2 48.8-17.2 76c0 59.5 29.6 112.1 74.8 144H320 64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zM96 64V75c0 19 5.6 37.4 16 53H272c10.3-15.6 16-34 16-53V64H96z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faPersonSeatReclined = {
  prefix: 'fad',
  iconName: 'person-seat-reclined',
  icon: [512, 512, [], "e21f", ["M58.1 128.5c17.4-3.3 34.1 8.2 37.3 25.6l33.3 177.7c5.7 30.3 32.1 52.2 62.9 52.2H272c17.7 0 32 14.3 32 32s-14.3 32-32 32H191.7c-61.6 0-114.5-43.9-125.8-104.4L32.5 165.9c-3.3-17.4 8.2-34.1 25.6-37.3z", "M128 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM257 256l8 32h53.8c33.3 0 63.2 20.7 74.9 51.9l25.5 68 18.7-6.2c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5l-48 16c-16.3 5.4-34-3-40.1-19.1l-36.3-96.9c-2.3-6.2-8.3-10.4-15-10.4H240.7c-.5 0-.9 0-1.4 0H233c-29.4 0-55-20-62.1-48.5L149.8 219c-7.5-30 15.2-59 46.1-59c20.4 0 38.4 13 44.9 32H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H257z"]]
};
var faPaperPlaneTop = {
  prefix: 'fad',
  iconName: 'paper-plane-top',
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", ["M-1.2 83.5c-18-33.4 16.3-70.8 51.1-55.7L491.8 219.3c32.1 13.9 32.1 59.5 0 73.4L49.9 484.2c-34.8 15.1-69.1-22.3-51.1-55.7L75.2 286.6 266 262.7c3.4-.4 6-3.3 6-6.7s-2.6-6.3-6-6.7L75.2 225.4-1.2 83.5z", "M75.2 286.6L266 262.7c3.4-.4 6-3.3 6-6.7s-2.6-6.3-6-6.7L75.2 225.4l8.3 15.4c5.1 9.5 5.1 20.9 0 30.3l-8.3 15.4z"]]
};
var faPaperPlaneAlt = faPaperPlaneTop;
var faSend = faPaperPlaneTop;
var faMessageArrowUp = {
  prefix: 'fad',
  iconName: 'message-arrow-up',
  icon: [512, 512, ["comment-alt-arrow-up"], "e1dc", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM280 296V177.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V296c0 13.3 10.7 24 24 24s24-10.7 24-24z", "M256 320c13.3 0 24-10.7 24-24V177.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V296c0 13.3 10.7 24 24 24z"]]
};
var faCommentAltArrowUp = faMessageArrowUp;
var faLightbulbExclamation = {
  prefix: 'fad',
  iconName: 'lightbulb-exclamation',
  icon: [384, 512, [], "f671", ["M321.2 297.8c-19.8 27.1-39.7 54.4-49.2 86.2H112c-9.6-31.9-29.5-59.1-49.2-86.2c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4zM192 64c-13.3 0-24 10.7-24 24V200c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M192 512c44.2 0 80-35.8 80-80V384H112v48c0 44.2 35.8 80 80 80z"]]
};
var faLayerMinus = {
  prefix: 'fad',
  iconName: 'layer-minus',
  icon: [576, 512, ["layer-group-minus"], "f5fe", ["M264.5 133.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l218.6-101zM476.9 337.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2z", "M384 80c0-13.3 10.7-24 24-24H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24z"]]
};
var faLayerGroupMinus = faLayerMinus;
var faChartPieSimpleCircleCurrency = {
  prefix: 'fad',
  iconName: 'chart-pie-simple-circle-currency',
  icon: [640, 512, [], "e604", ["M509.8 192.5c-4.6-.4-9.2-.5-13.8-.5c-46.8 0-89.3 18.2-120.8 48H272V16.6c0-9 7-16.6 16-16.6C401 0 494.5 83.7 509.8 192.5zM339.2 288c-12.3 24-19.2 51.2-19.2 80c0 42.5 15 81.4 40.1 111.8C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V288H339.2z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM460.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L460.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426c-21.6 13.2-49.1 13.2-70.7 0z"]]
};
var faCircleE = {
  prefix: 'fad',
  iconName: 'circle-e',
  icon: [512, 512, [], "e109", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v56H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V256 152c0-13.3 10.7-24 24-24z", "M160 152c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v56H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V256 152z"]]
};
var faBuildingWheat = {
  prefix: 'fad',
  iconName: 'building-wheat',
  icon: [640, 512, [], "e4db", ["M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M640 208l0-16-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80zm0 96l-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80l0-16zm0 112l-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80l0-16zM512 512l0-16c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0zm0-128c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0 0-16zm0-96l0-16c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0zM552 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104zm48 16c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32c0-13.3-10.7-24-24-24zM480 96c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32z"]]
};
var faGaugeMax = {
  prefix: 'fad',
  iconName: 'gauge-max',
  icon: [512, 512, ["tachometer-alt-fastest"], "f626", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 416c-35.3 0-64-28.7-64-64s28.7-64 64-64c14.1 0 27.2 4.6 37.8 12.4l117.5-72.8c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33L319.1 341.2c.6 3.5 .9 7.1 .9 10.8c0 35.3-28.7 64-64 64zM400 144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80-80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z", "M411.4 227.6c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33L319.1 341.2c.6 3.5 .9 7.1 .9 10.8c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c14.1 0 27.2 4.6 37.8 12.4l117.6-72.8z"]]
};
var faTachometerAltFastest = faGaugeMax;
var faPersonBreastfeeding = {
  prefix: 'fad',
  iconName: 'person-breastfeeding',
  icon: [448, 512, [], "e53a", ["M160 288c17.7 0 32 14.3 32 32v36.8c25.4 29.7 60.8 49.3 99.7 54.8l.8 .1c-9.1 19.6-4.1 43.6 13.5 57.7c6.4 5.1 13.7 8.3 21.2 9.7c-3.7 .9-7.7 1.1-11.7 .5L282.7 475c-9.1-1.3-18.1-3.2-27-5.6c2.2-19.5-7.7-39.1-26.2-48.4L128.1 370.4c-.1-.8-.1-1.6-.1-2.4V320c0-17.7 14.3-32 32-32zm72 44a44 44 0 1 1 88 0 44 44 0 1 1 -88 0z", "M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"]]
};
var faApostrophe = {
  prefix: 'fad',
  iconName: 'apostrophe',
  icon: [192, 512, [], "27", ["M72 352c66.3 0 120-53.7 120-120V160 128 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h64v8c0 30.9-25.1 56-56 56H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h8z", ""]]
};
var faFireHydrant = {
  prefix: 'fad',
  iconName: 'fire-hydrant',
  icon: [384, 512, [], "e17f", ["M192 0c17.7 0 32 14.3 32 32v4c45 11.6 80.4 47 92 92h12c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H68c11.6-45 47-80.4 92-92V32c0-17.7 14.3-32 32-32zM16 304c0-17.7 14.3-32 32-32H64V400H48c-17.7 0-32-14.3-32-32V304zm320-32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320V272h16z", "M64 176H320V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H64 56c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V176zM192 400a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faRightToBracket = {
  prefix: 'fad',
  iconName: 'right-to-bracket',
  icon: [512, 512, ["sign-in-alt"], "f2f6", ["M320 448c0-17.7 14.3-32 32-32l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32z", "M340.7 228.7L217.9 105.9c-6.4-6.4-15-9.9-24-9.9c-18.7 0-33.9 15.2-33.9 33.9l0 62.1L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0 0 62.1c0 18.7 15.2 33.9 33.9 33.9c9 0 17.6-3.6 24-9.9L340.7 283.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3z"]]
};
var faSignInAlt = faRightToBracket;
var faVideoPlus = {
  prefix: 'fad',
  iconName: 'video-plus',
  icon: [576, 512, [], "f4e1", ["M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM216 184v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V184c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6L384 315.8V196.2l142.2-94.8c9.8-6.5 22.4-7.2 32.9-1.6zM216 184v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]]
};
var faSquareRight = {
  prefix: 'fad',
  iconName: 'square-right',
  icon: [448, 512, [10145, "arrow-alt-square-right"], "f352", ["M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM262.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L262.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C234 384 224 374 224 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z", "M362.5 242.2L262.6 135.1c-4.2-4.5-10.1-7.1-16.3-7.1C234 128 224 138 224 150.3l0 57.7-96 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l96 0 0 57.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8z"]]
};
var faArrowAltSquareRight = faSquareRight;
var faCommentSmile = {
  prefix: 'fad',
  iconName: 'comment-smile',
  icon: [512, 512, [], "f4b4", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM192 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM150.5 270.1c9.9-8.8 25-8 33.9 1.9c17.6 19.7 43.1 32 71.6 32s53.9-12.3 71.6-32c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9C337 333.4 298.6 352 256 352s-81-18.6-107.3-48c-8.8-9.9-8-25 1.9-33.9z", "M224 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184.4 272c-8.8-9.9-24-10.7-33.9-1.9s-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32z"]]
};
var faVenus = {
  prefix: 'fad',
  iconName: 'venus',
  icon: [384, 512, [9792], "f221", ["M112 176a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"]]
};
var faPassport = {
  prefix: 'fad',
  iconName: 'passport',
  icon: [448, 512, [], "f5ab", ["M183 278.8c-6.8-17.1-12.9-40.4-14.6-70.8H129.3c5.3 31.4 25.8 57.6 53.7 70.8zm41.3 9.2c2.4-3.5 5.7-8.9 9.1-16.5c6-13.6 12.4-34.3 14.2-63.5H200.5c1.8 29.2 8.1 49.9 14.2 63.5c3.4 7.6 6.7 13 9.1 16.5c.1 0 .2 0 .3 0s.2 0 .3 0zm40.7-9.2c27.9-13.2 48.4-39.4 53.7-70.8H279.6c-1.6 30.4-7.7 53.8-14.6 70.8zM279.6 176h39.1c-5.3-31.4-25.8-57.6-53.7-70.8c6.8 17.1 12.9 40.4 14.6 70.8zM223.7 96c-2.4 3.5-5.7 8.9-9.1 16.5c-6 13.6-12.4 34.3-14.2 63.5h47.1c-1.8-29.2-8.1-49.9-14.2-63.5c-3.4-7.6-6.7-13-9.1-16.5c-.1 0-.2 0-.3 0s-.2 0-.3 0zM183 105.2c-27.9 13.2-48.4 39.4-53.7 70.8h39.1c1.6-30.4 7.7-53.8 14.6-70.8zM96 192a128 128 0 1 1 256 0A128 128 0 1 1 96 192z", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8H279.6zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8H129.3c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]]
};
var faInboxIn = {
  prefix: 'fad',
  iconName: 'inbox-in',
  icon: [512, 512, [128229, "inbox-arrow-down"], "f310", ["M124.2 320H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7z", "M256 0c17.7 0 32 14.3 32 32V210.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7V32c0-17.7 14.3-32 32-32z"]]
};
var faInboxArrowDown = faInboxIn;
var faHeartPulse = {
  prefix: 'fad',
  iconName: 'heart-pulse',
  icon: [512, 512, ["heartbeat"], "f21e", ["M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 16.9-2.8 33.5-8.3 49.1z", "M35.7 288h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c12.1-14.2 21.4-30.5 27.4-48h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1c6.1 17 15.2 32.9 27 46.9z"]]
};
var faHeartbeat = faHeartPulse;
var faCircle8 = {
  prefix: 'fad',
  iconName: 'circle-8',
  icon: [512, 512, [], "e0f5", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 128H248c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0H248s0 0 0 0zm16 48h8c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-17.7 0-32-14.3-32-32s14.3-32 32-32h8 16z", "M336 200c0-39.8-32.2-72-72-72H248c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42zm-72 72h8c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c0 0 0 0 0 0h16c0 0 0 0 0 0zm0-48H248c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]]
};
var faCloudsMoon = {
  prefix: 'fad',
  iconName: 'clouds-moon',
  icon: [640, 512, [], "f745", ["M352 160C352 71.7 423.4 0 511.5 0c4.6 0 9.1 .2 13.5 .6c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-35.4 20.1-59.3 58.2-59.3 101.9c0 64.6 52.2 116.9 116.5 116.9c6.8 0 13.5-.6 20-1.7c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7C594 302.8 554.8 320 511.5 320c-3.8 0-7.5-.1-11.2-.4c-11.3-9.9-24.2-17.8-38.5-23.2c-9.9-53.2-52.6-94.8-106.4-103c-2.3-10.8-3.5-22-3.5-33.4z", "M208.1 224c12.9 0 25.3 2.2 36.8 6.2c19.6-19.9 45.8-33.5 75-37.2l0-.9c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72c16.1 0 30.9-5.3 42.9-14.1c20.1-30.1 54.3-49.9 93.2-49.9zM64 431.9c0 44.2 35.8 80 80 80H415.9c53 0 96-43 96-96c0-47.6-34.6-87-80-94.6l0-1.3c0-53-43-96-96-96c-34.9 0-65.4 18.6-82.2 46.4C240.8 261.3 225 256 208 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 431.9z"]]
};
var faClockTenThirty = {
  prefix: 'fad',
  iconName: 'clock-ten-thirty',
  icon: [512, 512, [], "e355", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V256c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3L232 268.8V392c0 13.3 10.7 24 24 24s24-10.7 24-24z", "M256 416c13.3 0 24-10.7 24-24V256c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3L232 268.8V392c0 13.3 10.7 24 24 24z"]]
};
var faPeopleCarryBox = {
  prefix: 'fad',
  iconName: 'people-carry-box',
  icon: [640, 512, ["people-carry"], "f4ce", ["M248.6 319.2c-2.4-.6-4.7-1.4-7-2.5l-.6-.3c2.4 1.2 4.9 2.2 7.5 2.8zm134.7 .8H256.6c11.5-.2 22.5-6.7 28-17.7c7.9-15.8 1.5-35-14.3-42.9L224 236.2V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l-46.3 23.2c-15.8 7.9-22.2 27.1-14.3 42.9c5.5 11 16.5 17.4 28 17.7zm8.5-1c2.5-.6 4.8-1.5 7-2.7l-.5 .3c-2.1 1.1-4.3 1.9-6.5 2.4z", "M176 48A48 48 0 1 0 80 48a48 48 0 1 0 96 0zM144 306.7V241.7l19 28.5c4.6 7 11 12.6 18.5 16.3l60.2 30.1c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-56.4-28.2L166.5 160c-13.3-20-35.8-32-59.9-32C74.2 128 48 154.2 48 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM2.3 468.1c-6.6 16.4 1.4 35 17.8 41.6s35-1.4 41.6-17.8l37.6-94L50.1 348.6 2.3 468.1zM464 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm32 258.7l-51 51c-7.1 7.1-11.8 16.2-13.4 26.1l-15.2 90.9c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l14.3-85.9L573.3 320c12-12 18.7-28.3 18.7-45.3V186.6c0-32.4-26.2-58.6-58.6-58.6c-24.1 0-46.5 12-59.9 32l-47.4 71.1-56.4 28.2c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l60.2-30.1c7.5-3.7 13.8-9.4 18.5-16.3l19-28.5v65.1zM637.7 468.1L589.9 348.6l-49.2 49.2 37.6 94c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6z"]]
};
var faPeopleCarry = faPeopleCarryBox;
var faFolderUser = {
  prefix: 'fad',
  iconName: 'folder-user',
  icon: [512, 512, [], "e18e", ["M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM144 405.3c0 5.9 4.8 10.7 10.7 10.7H357.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H197.3c-29.5 0-53.3 23.9-53.3 53.3z", "M256 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-58.7 32c-29.5 0-53.3 23.9-53.3 53.3c0 5.9 4.8 10.7 10.7 10.7H357.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H197.3z"]]
};
var faTrashCanXmark = {
  prefix: 'fad',
  iconName: 'trash-can-xmark',
  icon: [448, 512, [], "e2ae", ["M416 96H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V96zM143 207c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM143 207c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]]
};
var faTemperatureHigh = {
  prefix: 'fad',
  iconName: 'temperature-high',
  icon: [512, 512, [], "f769", ["M144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM144 96c-8.8 0-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16z"]]
};
var faMicrochip = {
  prefix: 'fad',
  iconName: 'microchip',
  icon: [512, 512, [], "f2db", ["M152 0c-13.3 0-24 10.7-24 24V64h48V24c0-13.3-10.7-24-24-24zm80 24V64h48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24zm104 0V64h48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24zM488 128H448v48h40c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 104H448v48h40c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 104H448v48h40c13.3 0 24-10.7 24-24s-10.7-24-24-24zM384 488V448H336v40c0 13.3 10.7 24 24 24s24-10.7 24-24zM280 448H232v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448zm-104 0H128v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448zM24 384H64V336H24c-13.3 0-24 10.7-24 24s10.7 24 24 24zM64 280V232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64zM24 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H64V128H24zm328 32H160V352H352V160z", "M128 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H128zm32 64H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32z"]]
};
var faLeftLongToLine = {
  prefix: 'fad',
  iconName: 'left-long-to-line',
  icon: [640, 512, [], "e41e", ["M32 64C14.3 64 0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32z", "M305.5 414c-8.8 3.8-19 2-26-4.6l-144-136c-4.8-4.5-7.5-10.8-7.5-17.4s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z"]]
};
var faCrown = {
  prefix: 'fad',
  iconName: 'crown',
  icon: [576, 512, [128081], "f521", ["M248 72a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM0 136a40 40 0 1 1 80 0A40 40 0 1 1 0 136zM536 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z", "M504 160l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106c-6.1 3.8-13.3 6-21 6s-14.9-2.2-21-6L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c-7.2 9.5-18.5 15.8-31.3 16L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c-12.8-.2-24.1-6.5-31.3-16z"]]
};
var faWeightHanging = {
  prefix: 'fad',
  iconName: 'weight-hanging',
  icon: [512, 512, [], "f5cd", ["M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H256h90.5z", "M120 128c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H120z"]]
};
var faXmarksLines = {
  prefix: 'fad',
  iconName: 'xmarks-lines',
  icon: [640, 512, [], "e59a", ["M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z", "M177 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47L49 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47L15 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM273 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47zM463 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]]
};
var faFilePrescription = {
  prefix: 'fad',
  iconName: 'file-prescription',
  icon: [384, 512, [], "f572", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM104 196c-11 0-20 9-20 20v80 64c0 11 9 20 20 20s20-9 20-20V316h20c.7 .9 1.5 1.8 2.3 2.6l64.8 60.8-32.6 29.9c-8.1 7.5-8.7 20.1-1.2 28.3s20.1 8.7 28.3 1.2l34.9-32 33.9 31.8c8.1 7.6 20.7 7.1 28.3-.9s7.1-20.7-.9-28.3L270 379.7l31.6-28.9c8.1-7.5 8.7-20.1 1.2-28.3s-20.1-8.7-28.3-1.2l-33.8 31-43-40.3c22.4-8.7 38.3-30.5 38.3-55.9c0-33.1-26.9-60-60-60H104zm72 80H124V236h52c11 0 20 9 20 20s-9 20-20 20z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM104 196c-11 0-20 9-20 20v80 64c0 11 9 20 20 20s20-9 20-20V316h20c.7 .9 1.5 1.8 2.3 2.6l64.8 60.8-32.6 29.9c-8.1 7.5-8.7 20.1-1.2 28.3s20.1 8.7 28.3 1.2l34.9-32 33.9 31.8c8.1 7.6 20.7 7.1 28.3-.9s7.1-20.7-.9-28.3L270 379.7l31.6-28.9c8.1-7.5 8.7-20.1 1.2-28.3s-20.1-8.7-28.3-1.2l-33.8 31-43-40.3c22.4-8.7 38.3-30.5 38.3-55.9c0-33.1-26.9-60-60-60H104zm72 80H124V236h52c11 0 20 9 20 20s-9 20-20 20z"]]
};
var faCalendarRange = {
  prefix: 'fad',
  iconName: 'calendar-range',
  icon: [512, 512, [], "e0d6", ["M32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zm64 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm288 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 288c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm40 104H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24z", "M128 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v80H32V112c0-26.5 21.5-48 48-48h48V32zm32 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM384 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 288c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm40 104c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24H264z"]]
};
var faFlowerDaffodil = {
  prefix: 'fad',
  iconName: 'flower-daffodil',
  icon: [512, 512, [9880], "f800", ["M224 394.8V281.3c12.7-5.6 23.8-14.4 32-25.3c8.2 11 19.3 19.8 32 25.3V394.8c31.9-45.2 84.5-74.8 144-74.8h50.5c16.3 0 29.5 13.2 29.5 29.5C512 439.3 439.3 512 349.5 512H288 256 224 162.5C72.7 512 0 439.3 0 349.5C0 333.2 13.2 320 29.5 320H80c59.5 0 112.1 29.6 144 74.8z", "M320 288c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64c-19.4-14.6-32-37.8-32-64c0-44.2 35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c44.2 0 80 35.8 80 80c0 26.2-12.6 49.4-32 64c19.4 14.6 32 37.8 32 64c0 44.2-35.8 80-80 80zm-64-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
};
var faHandBackPointUp = {
  prefix: 'fad',
  iconName: 'hand-back-point-up',
  icon: [448, 512, [], "e1a2", ["M136 0C113.9 0 96 17.9 96 40V240v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L39 284.8C24.4 297 16 315 16 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H288c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C334 227.5 313.3 208 288 208c-12.4 0-23.6 4.7-32.1 12.3C254 195.5 233.3 176 208 176c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z", ""]]
};
var faWeightScale = {
  prefix: 'fad',
  iconName: 'weight-scale',
  icon: [512, 512, ["weight"], "f496", ["M80 176a176 176 0 1 1 352 0A176 176 0 1 1 80 176zm216 48c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z", "M256 352c97.2 0 176-78.8 176-176c0-42.5-15.1-81.6-40.2-112H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h56.2C95.1 94.4 80 133.5 80 176c0 97.2 78.8 176 176 176zm40-128c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-22 17.8-39.9 39.7-40l33.6-78.3c3.5-8.1 12.9-11.9 21-8.4s11.9 12.9 8.4 21l-33.6 78.3c6.7 7.2 10.9 16.8 10.9 27.4z"]]
};
var faWeight = faWeightScale;
var faStarExclamation = {
  prefix: 'fad',
  iconName: 'star-exclamation',
  icon: [576, 512, [], "f2f3", ["M288.1 0c12.2 0 23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18zM288 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M312 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM288 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faBooks = {
  prefix: 'fad',
  iconName: 'books',
  icon: [512, 512, [128218], "f5db", ["M0 32C0 14.3 14.3 0 32 0H96c17.7 0 32 14.3 32 32V96H0V32zm0 96H128V384H0V128zM0 416H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416zM160 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96H160V32zm0 96H288V384H160V128zm0 288H288v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416zM289.4 117.8L412.2 85l8.2 30.9L297.6 148.8l-8.2-30.9zm74.2 278.3l122.8-32.9 8.2 30.9L371.8 427l-8.2-30.9z", "M288 112.6l1.4 5.2L412.2 85 395.8 23.7c-4.5-17-22-27.1-38.9-22.6L295.5 17.6c-2.7 .7-5.2 1.8-7.5 3.1L288 96H160v32H288l0-15.4zm132.4 3.2L297.6 148.8l66 247.4 122.8-32.9-66-247.4zM388.2 488.3c4.5 17 22 27.1 38.9 22.6l61.4-16.5c16.9-4.6 27-22.1 22.5-39.1l-16.3-61.1L371.8 427l16.3 61.3zM0 96v32H128V96H0zM128 384H0v32H128V384zm160 0H160v32H288V384z"]]
};
var faUserGroup = {
  prefix: 'fad',
  iconName: 'user-group',
  icon: [640, 512, [128101, "user-friends"], "f500", ["M609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"]]
};
var faUserFriends = faUserGroup;
var faArrowUpAZ = {
  prefix: 'fad',
  iconName: 'arrow-up-a-z',
  icon: [576, 512, ["sort-alpha-up"], "f15e", ["M416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176zM352 352c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352z", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z"]]
};
var faSortAlphaUp = faArrowUpAZ;
var faLayerPlus = {
  prefix: 'fad',
  iconName: 'layer-plus',
  icon: [576, 512, ["layer-group-plus"], "f5ff", ["M264.5 133.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l218.6-101zM476.9 337.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2z", "M488 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h32l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24V104h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H488V24z"]]
};
var faLayerGroupPlus = faLayerPlus;
var faPlayPause = {
  prefix: 'fad',
  iconName: 'play-pause',
  icon: [640, 512, [], "e22f", ["M416 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm128 0c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32z", "M116.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160z"]]
};
var faBlockQuestion = {
  prefix: 'fad',
  iconName: 'block-question',
  icon: [448, 512, [], "e3dd", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm73.8 141.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 272.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V258.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H190.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 360a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM376 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM48 408a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M48 104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm304 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM72 384a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM137.8 173.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 272.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V258.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H190.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 360a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faSnooze = {
  prefix: 'fad',
  iconName: 'snooze',
  icon: [448, 512, [128164, "zzz"], "f880", ["M160 32c0-17.7 14.3-32 32-32h96c12.1 0 23.2 6.8 28.6 17.7s4.3 23.8-3 33.5L256 128h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-12.1 0-23.2-6.8-28.6-17.7s-4.3-23.8 3-33.5L224 64H192c-17.7 0-32-14.3-32-32zM288 256c0-17.7 14.3-32 32-32h96c12.1 0 23.2 6.8 28.6 17.7s4.3 23.8-3 33.5L384 352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-12.1 0-23.2-6.8-28.6-17.7s-4.3-23.8 3-33.5L352 288H320c-17.7 0-32-14.3-32-32z", "M0 288c0-17.7 14.3-32 32-32H192c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 448H192c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L123.7 320H32c-17.7 0-32-14.3-32-32z"]]
};
var faZzz = faSnooze;
var faScannerImage = {
  prefix: 'fad',
  iconName: 'scanner-image',
  icon: [576, 512, [], "f8f3", ["M64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm0 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M35.8 48.9c8.3-15.6 27.7-21.5 43.3-13.2L525.2 273.7c20.9 11.2 36.6 29.4 44.7 50.9C559.6 303 537.5 288 512 288H416L48.9 92.2C33.3 83.9 27.4 64.5 35.8 48.9zM96 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faTvRetro = {
  prefix: 'fad',
  iconName: 'tv-retro',
  icon: [512, 512, [128250], "f401", ["M169 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55H80C35.8 96 0 131.8 0 176V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H321.9l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87L169 7zM424 232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 224c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V224z", "M64 224c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V224z"]]
};
var faSquareT = {
  prefix: 'fad',
  iconName: 'square-t',
  icon: [448, 512, [], "e280", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 112H224 328c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M96 168c0-13.3 10.7-24 24-24H224 328c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H120c-13.3 0-24-10.7-24-24z"]]
};
var faFarm = {
  prefix: 'fad',
  iconName: 'farm',
  icon: [576, 512, ["barn-silo"], "f864", ["M160 270.3V480c0 17.7 14.3 32 32 32H304V448c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64H544c17.7 0 32-14.3 32-32V270.3c0-4.2-.8-8.3-2.4-12.2L524.7 139.4c-3-7.4-8.7-13.3-15.9-16.7L381.7 62.5c-8.7-4.1-18.7-4.1-27.4 0L227.2 122.7c-7.2 3.4-12.9 9.4-15.9 16.7L162.4 258.1c-1.6 3.9-2.4 8-2.4 12.2zM344 224h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24z", "M0 96H192c0-53-43-96-96-96S0 43 0 96zm181.4 32H0V464c0 26.5 21.5 48 48 48h88.6c-5.4-9.4-8.6-20.3-8.6-32V270.3c0-8.4 1.6-16.6 4.8-24.4l48.6-118zM344 224c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H344z"]]
};
var faBarnSilo = faFarm;
var faChessKnight = {
  prefix: 'fad',
  iconName: 'chess-knight',
  icon: [448, 512, [9822], "f441", ["M384 432H64L22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H409.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432z", "M82.7 61.3L96 48 74.9 37.5C68.2 34.1 64 27.3 64 19.8C64 8.9 72.9 0 83.8 0H224C330 0 416 86 416 192v17.3c0 9.8-.7 19.5-2.2 29.2L384 432H64V418.7c0-31.7 15.7-61.4 41.9-79.3l112.6-76.8c10.5-7.2 10.9-22.6 .7-30.3c-6.6-5-15.7-5-22.3 0l-49.4 37c-2.3 1.7-4.8 3.2-7.3 4.5l-3.2 1.6c-15.4 7.7-33.8 6.6-48.1-3l-10.6-7C69.3 259.6 64 249.6 64 238.9V106.5c0-17 6.7-33.3 18.7-45.3zM140 136a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]]
};
var faBarsSort = {
  prefix: 'fad',
  iconName: 'bars-sort',
  icon: [448, 512, [], "e0ae", ["M0 256c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M448 96c0-17.7-14.3-32-32-32H32C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM192 416c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32-14.3 32-32z"]]
};
var faPalletBoxes = {
  prefix: 'fad',
  iconName: 'pallet-boxes',
  icon: [640, 512, [57863, "palette-boxes", "pallet-alt"], "f483", ["M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z", "M96 0C78.3 0 64 14.3 64 32V224c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zM416 64c-17.7 0-32 14.3-32 32V224c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H416z"]]
};
var faPaletteBoxes = faPalletBoxes;
var faPalletAlt = faPalletBoxes;
var faFaceLaughSquint = {
  prefix: 'fad',
  iconName: 'face-laugh-squint',
  icon: [512, 512, ["laugh-squint"], "f59b", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z", "M116 125.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm280 0c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]]
};
var faLaughSquint = faFaceLaughSquint;
var faCodeSimple = {
  prefix: 'fad',
  iconName: 'code-simple',
  icon: [576, 512, [], "e13d", ["M361.4 73.4c-12.5 12.5-12.5 32.8 0 45.3L498.7 256 361.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0z", "M214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L77.3 256 214.6 393.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0z"]]
};
var faBoltSlash = {
  prefix: 'fad',
  iconName: 'bolt-slash',
  icon: [640, 512, [], "e0b8", ["M154.8 218l88.9 70H160c-13.3 0-25.3-8.3-30-20.7s-1.1-26.6 8.9-35.3L154.8 218zm109.6 86.4L374.4 391 245.1 504.1c-11.2 9.8-27.8 10.6-39.9 1.8s-16.5-24.8-10.6-38.5l69.9-163zm236.6-24.3l-52.7 46.1L228.4 153.7 394.9 7.9c11.2-9.8 27.8-10.6 39.9-1.8s16.5 24.8 10.6 38.5L368.5 224H480c13.3 0 25.3 8.3 30 20.7s1.2 26.6-8.9 35.3z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faPanelFire = {
  prefix: 'fad',
  iconName: 'panel-fire',
  icon: [640, 512, [], "e42f", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-2 .1-4 .2-6.1c-.1 0-.1 0-.2 0c-13.3 0-24-10.7-24-24s10.7-24 24-24c3.5 0 6.9 .8 9.9 2.1c6.7-19 16.4-37.8 27.2-55.4c3.8-6.2 7.9-12.5 12.3-18.7H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v39.4c9-9.4 18.5-18.6 28.5-27.5c10-8.9 23-12.8 35.5-11.7V96c0-35.3-28.7-64-64-64H64zM96 296a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M443.7 159.9c3.5 0 7 1.3 9.8 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79c0 87.8-71.3 159.8-160 159.8c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7zm37.3 288c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z"]]
};
var faBinaryCircleCheck = {
  prefix: 'fad',
  iconName: 'binary-circle-check',
  icon: [640, 512, [], "e33c", ["M336 32V160h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H304 256c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V76.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16C303.6-1.6 314.4 0 322.7 6s13.3 15.7 13.3 26zM112 320V448h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4s13.3 15.7 13.3 26zM0 64C0 28.7 28.7 0 64 0h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm128 0H64v96h64V64zM256 288h64c6.2 0 12.2 .9 17.9 2.5c-11.2 22.9-17.6 48.6-17.9 75.7V352H256v96h64v0h19.2c7.8 15.3 17.8 29.3 29.5 41.5C357 503.3 339.5 512 320 512H256c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zm64 96V369.8c0 4.8 .3 9.5 .7 14.2H320z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faCommentMinus = {
  prefix: 'fad',
  iconName: 'comment-minus',
  icon: [512, 512, [], "f4b1", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM184 216H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M160 240c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24z"]]
};
var faBurrito = {
  prefix: 'fad',
  iconName: 'burrito',
  icon: [512, 512, [127791], "f7ed", ["M33.9 270.1L251.4 52.6C274.4 82.3 288 119.6 288 160c0 18-2.7 35.4-7.7 51.7C258.2 283.7 191.2 336 112 336c-37.8 0-72.8-11.9-101.5-32.2c5.7-12.4 13.6-23.9 23.4-33.7zM352 224c40.4 0 77.7 13.6 107.4 36.6L241.9 478.1C220.2 499.8 190.7 512 160 512s-60.2-12.2-81.9-33.9L33.9 433.9C12.2 412.2 0 382.7 0 352c0-5.4 .4-10.7 1.1-16c32.1 20.3 70.1 32 110.9 32c90.5 0 167.5-57.8 196.1-138.5c14-3.6 28.7-5.5 43.9-5.5z", "M320 160c0-53.6-20.3-102.5-53.6-139.4C280.6 7.8 299.4 0 320 0c11.4 0 22.2 2.4 32 6.7C361.8 2.4 372.6 0 384 0c34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32c0 20.6-7.8 39.4-20.6 53.6C454.5 212.3 405.6 192 352 192c-11.9 0-23.6 1-34.9 2.9c1.9-11.4 2.9-23 2.9-34.9z"]]
};
var faViolin = {
  prefix: 'fad',
  iconName: 'violin',
  icon: [640, 512, [127931], "f8ed", ["M544 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM496 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM417 177.7C398 166.5 375.7 160 352 160c-20.8 0-40.4 5-57.8 13.8c-6.7 3.4-9.1 11.4-7.7 18.8c1 5 1.5 10.2 1.5 15.4c0 44.2-35.8 80-80 80c-11.6 0-22.7-2.5-32.7-7c-7.4-3.3-16.6-2.4-21.3 4.3C137.6 308.7 128 337.2 128 368c0 26.7 7.3 51.7 19.9 73.1l50.5-37.9c6.4-4.8 15.3-4.1 20.9 1.5l16 16c5.6 5.6 6.3 14.5 1.5 20.9l-37.9 50.5C220.3 504.7 245.3 512 272 512c30.8 0 59.3-9.6 82.6-26.1c6.7-4.7 7.6-13.8 4.3-21.3c-4.5-10-7-21-7-32.7c0-44.2 35.8-80 80-80c5.3 0 10.5 .5 15.4 1.5c7.4 1.4 15.4-1 18.8-7.7c8.8-17.4 13.8-37 13.8-57.8c0-23.7-6.5-46-17.7-65l-23.7 23.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L417 177.7zM568 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm48-48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M630.6 54.6l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM345 7c9.4 9.4 9.4 24.6 0 33.9L41 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L311 7c9.4-9.4 24.6-9.4 33.9 0zM219.3 404.7l16 16c5.6 5.6 6.3 14.5 1.5 20.9l-48 64c-2.8 3.7-7 6-11.7 6.4s-9.2-1.4-12.4-4.6l-32-32c-3.3-3.3-5-7.8-4.6-12.4s2.6-8.9 6.4-11.7l64-48c6.4-4.8 15.3-4.1 20.9 1.5z"]]
};
var faObjectsColumn = {
  prefix: 'fad',
  iconName: 'objects-column',
  icon: [448, 512, [], "e3c1", ["M304 32c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304zm0 192c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H304z", "M48 32C21.5 32 0 53.5 0 80V240c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 320c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H48z"]]
};
var faSquareChevronDown = {
  prefix: 'fad',
  iconName: 'square-chevron-down',
  icon: [448, 512, ["chevron-square-down"], "f329", ["M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zM241 345L345 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87-87-87c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L207 345c9.4 9.4 24.6 9.4 33.9 0z", "M207 345c9.4 9.4 24.6 9.4 33.9 0L345 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87-87-87c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L207 345z"]]
};
var faChevronSquareDown = faSquareChevronDown;
var faCommentPlus = {
  prefix: 'fad',
  iconName: 'comment-plus',
  icon: [512, 512, [], "f4b2", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM232 328V264H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V152c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M232 264v64c0 13.3 10.7 24 24 24s24-10.7 24-24V264h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faTriangleInstrument = {
  prefix: 'fad',
  iconName: 'triangle-instrument',
  icon: [576, 512, ["triangle-music"], "f8e2", ["M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V69.9c-18 6.8-33.6 19.4-44.1 36.1L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94H450c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L430.7 211.3l-46.4 46.4 91.1 144.2c3 4.8 4.6 10.4 4.6 16c0 16.6-13.5 30-30 30H126c-16.6 0-30-13.5-30-30c0-5.7 1.6-11.2 4.6-16L266 140.1c4.8-7.6 13.1-12.1 22-12.1s17.3 4.6 22 12.1l48 75.9 46.4-46.4L364.1 106C353.6 89.2 338 76.7 320 69.9V32z", "M537 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L306.8 267.2c-5.9-2.1-12.2-3.2-18.8-3.2c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8L537 105z"]]
};
var faTriangleMusic = faTriangleInstrument;
var faWheelchair = {
  prefix: 'fad',
  iconName: 'wheelchair',
  icon: [512, 512, [], "f193", ["M160 192c1.9 0 3.9 0 5.8 .1l9.8 49c-5.1-.7-10.3-1.1-15.6-1.1C98.1 240 48 290.1 48 352s50.1 112 112 112s112-50.1 112-112h48c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160z", "M240 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm19.8 128l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H282.2l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H259.8z"]]
};
var faUserPilotTie = {
  prefix: 'fad',
  iconName: 'user-pilot-tie',
  icon: [448, 512, [], "e2c1", ["M101.7 154.2C98 166.1 96 178.8 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-13.2-2-25.9-5.7-37.8C308.2 168.3 267 176 224 176s-84.2-7.7-122.3-21.8z", "M230.1 .8l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6l-23.8 20.4c.1 1 .1 2 .1 3.1v21.2c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 147.7 80 137.6 80 126.9V105.7c0-1 0-2.1 .1-3.1L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40c4-1.1 8.2-1.1 12.2 0zM161.7 72.8c-4 7.9-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1 183.2 65.7c-7.9-4-17.5-.7-21.5 7.2zM208 416l-20.4-40.8c-5.3-10.6 2.4-23.2 14.3-23.2h44.2c11.9 0 19.6 12.5 14.3 23.2L240 416l12.2 48.9L315 360.3c3-5 8.6-8.1 14.4-7.4C396.2 360.8 448 417.5 448 486.4c0 14.1-11.5 25.6-25.6 25.6H256v0H192v0H25.6C11.5 512 0 500.5 0 486.4c0-68.9 51.8-125.6 118.6-133.5c5.8-.7 11.4 2.4 14.4 7.4l62.8 104.6L208 416zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336z"]]
};
var faPianoKeyboard = {
  prefix: 'fad',
  iconName: 'piano-keyboard',
  icon: [576, 512, [127929], "f8d5", ["M0 224V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224H512V384H432V315.7c-4.7 2.7-10.2 4.3-16 4.3s-11.3-1.6-16-4.3V384H304V315.7c-4.7 2.7-10.2 4.3-16 4.3s-11.3-1.6-16-4.3V384H176V315.7c-4.7 2.7-10.2 4.3-16 4.3s-11.3-1.6-16-4.3V384H64V224H0z", "M64 64C28.7 64 0 92.7 0 128v96H128v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224H576V128c0-35.3-28.7-64-64-64H64z"]]
};
var faBedEmpty = {
  prefix: 'fad',
  iconName: 'bed-empty',
  icon: [640, 512, [128719], "f8f9", ["M64 224H96 544c24.3 0 46.6 9.1 63.5 24h.5v.4c19.6 17.6 32 43.1 32 71.6H64V256 224z", "M32 32c17.7 0 32 14.3 32 32V320H608h32v32 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32z"]]
};
var faCircleArrowUp = {
  prefix: 'fad',
  iconName: 'circle-arrow-up',
  icon: [512, 512, ["arrow-circle-up"], "f0aa", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119c9.4-9.4 24.6-9.4 33.9 0L385 231z", "M239 119c9.4-9.4 24.6-9.4 33.9 0L385 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119z"]]
};
var faArrowCircleUp = faCircleArrowUp;
var faToggleOn = {
  prefix: 'fad',
  iconName: 'toggle-on',
  icon: [576, 512, [], "f205", ["M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M288 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]]
};
var faRectangleVertical = {
  prefix: 'fad',
  iconName: 'rectangle-vertical',
  icon: [384, 512, ["rectangle-portrait"], "f2fb", ["M320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0z", ""]]
};
var faRectanglePortrait = faRectangleVertical;
var faPersonWalking = {
  prefix: 'fad',
  iconName: 'person-walking',
  icon: [320, 512, [128694, "walking"], "f554", ["M109.6 295.8c2.6 9.8 7.6 19 14.7 26.7l30.3 33.1-27.7 69.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398l40.9-102.2z", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5z"]]
};
var faWalking = faPersonWalking;
var faL = {
  prefix: 'fad',
  iconName: 'l',
  icon: [320, 512, [108], "4c", ["M64 32c17.7 0 32 14.3 32 32V416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z", ""]]
};
var faSignalStream = {
  prefix: 'fad',
  iconName: 'signal-stream',
  icon: [576, 512, [], "f8dd", ["M113.1 116c11.1-13.8 8.8-33.9-5-45s-33.9-8.8-45 5C23.7 125.3 0 187.9 0 256s23.7 130.7 63.2 180c11.1 13.8 31.2 16 45 5s16-31.2 5-45C82.4 357.6 64 309 64 256s18.4-101.6 49.1-140zM512.8 76c-11.1-13.8-31.2-16-45-5s-16 31.2-5 45c30.7 38.4 49.1 87 49.1 140s-18.4 101.6-49.1 140c-11.1 13.8-8.8 33.9 5 45s33.9 8.8 45-5C552.3 386.7 576 324.1 576 256s-23.7-130.7-63.2-180zM204.5 181.3c11.8-13.2 10.7-33.4-2.5-45.2s-33.4-10.7-45.2 2.5C129 169.8 112 210.9 112 256s17 86.2 44.8 117.3c11.8 13.2 32 14.3 45.2 2.5s14.3-32 2.5-45.2c-17.8-19.8-28.5-46-28.5-74.7s10.8-54.8 28.5-74.7zm214.7-42.7c-11.8-13.2-32-14.3-45.2-2.5s-14.3 32-2.5 45.2c17.8 19.8 28.5 46 28.5 74.7s-10.8 54.8-28.5 74.7c-11.8 13.2-10.7 33.4 2.5 45.2s33.4 10.7 45.2-2.5C447 342.2 464 301.1 464 256s-17-86.2-44.8-117.3z", "M232 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z"]]
};
var faDownToBracket = {
  prefix: 'fad',
  iconName: 'down-to-bracket',
  icon: [448, 512, [], "e4e7", ["M32 320c17.7 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96V352c0-17.7 14.3-32 32-32z", "M251.3 340.7L374.1 217.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9L288 160l0-128c0-17.7-14.3-32-32-32L192 0c-17.7 0-32 14.3-32 32l0 128-62.1 0C79.2 160 64 175.2 64 193.9c0 9 3.6 17.6 9.9 24L196.7 340.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3z"]]
};
var faCircleZ = {
  prefix: 'fad',
  iconName: 'circle-z',
  icon: [512, 512, [], "e130", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c8.9 0 17.1 5 21.3 12.9s3.6 17.5-1.5 24.8L229.8 336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.9 0-17.1-5-21.3-12.9s-3.6-17.5 1.5-24.8L282.2 176H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M160 152c0-13.3 10.7-24 24-24H328c8.9 0 17.1 5 21.3 12.9s3.6 17.5-1.5 24.8L229.8 336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.9 0-17.1-5-21.3-12.9s-3.6-17.5 1.5-24.8L282.2 176H184c-13.3 0-24-10.7-24-24z"]]
};
var faStars = {
  prefix: 'fad',
  iconName: 'stars',
  icon: [512, 512, [], "f762", ["M312 104l13.8 48.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104zM428.8 243.2l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z", "M213.4 157.4c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94z"]]
};
var faFire = {
  prefix: 'fad',
  iconName: 'fire',
  icon: [448, 512, [128293], "f06d", ["M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z", "M294.5 395c-21.1 14-43.5 21-68.8 21C162.6 416 112 375.4 112 306.8c0-30.1 16.9-56.9 50.8-99.4c6.3-8 18.4-7.9 24.7 .1c16.8 21.3 46.3 58.8 62.8 79.8c6.2 7.9 18.1 8.1 24.7 .5l25.2-29.3c6.5-7.6 18-6.9 22.5 2c25.3 46.2 14 105-28.1 134.4z"]]
};
var faBedPulse = {
  prefix: 'fad',
  iconName: 'bed-pulse',
  icon: [640, 512, ["procedures"], "f487", ["M332.7 160H320c-17.7 0-32 14.3-32 32V320v32h32H608h32V320 256c0-53-43-96-96-96H461.9l-11.2 23.8c-8.6 18.3-26.4 30.5-46.5 32s-39.5-8-50.7-24.8L332.7 160zM256 240A80 80 0 1 0 96 240a80 80 0 1 0 160 0z", "M483.2 9.6C478.1 2.9 469.9-.7 461.6 .1s-15.7 6-19.3 13.7l-45.9 97.5L372 74.7C367.5 68 360 64 352 64H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H339.2L380 173.3c4.8 7.2 13.1 11.3 21.7 10.6s16.3-5.9 19.9-13.7l47-99.9 24.1 32.1c4.5 6 11.6 9.6 19.2 9.6H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H524L483.2 9.6zM64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V448H576v32c0 17.7 14.3 32 32 32s32-14.3 32-32V384 352H608 64V96z"]]
};
var faProcedures = faBedPulse;
var faHouseDay = {
  prefix: 'fad',
  iconName: 'house-day',
  icon: [640, 512, [], "e00e", ["M160.1-.1c5.9 0 11.3 3.2 14.1 8.4l27.6 51.2 55.7-16.7c5.6-1.7 11.7-.1 15.9 4s5.7 10.3 4 15.9l-16.7 55.7 35.3 19-64.7 59.7c5.6-10.9 8.7-23.3 8.7-36.3c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c10.8 0 21.1-2.1 30.5-6l-41.7 38.5L133.1 288l-14.6-27.2L62.8 277.5c-5.6 1.7-11.7 .1-15.9-4s-5.7-10.3-4-15.9l16.7-55.7L8.3 174.3c-5.2-2.8-8.4-8.2-8.4-14.1s3.2-11.3 8.4-14.1l51.2-27.6L42.8 62.8c-1.7-5.6-.1-11.7 4-15.9s10.3-5.7 15.9-4l55.7 16.7L146 8.3c2.8-5.2 8.2-8.4 14.1-8.4zM160 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96z", "M378.3 104.5c12.3-11.3 31.2-11.3 43.4 0l208 192c9.7 8.9 12.9 22.9 8.1 35.2S621.2 352 608 352H576V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V352H192c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM368 288c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H368z"]]
};
var faShuttleSpace = {
  prefix: 'fad',
  iconName: 'shuttle-space',
  icon: [640, 512, ["space-shuttle"], "f197", ["M96 32v96H32V80c0-26.5 21.5-48 48-48H96zm0 352v96H80c-26.5 0-48-21.5-48-48V384H96zm32 96V380.3c16.1-5.1 30.1-15.1 40-28.3H405.3L245.2 448.1C210.4 469 170.6 480 130 480h-2zm0-348.3V32h2c40.6 0 80.4 11 115.2 31.9L405.3 160H168c-9.9-13.2-23.9-23.3-40-28.3z", "M0 168c0-22.1 17.9-40 40-40h64c26.2 0 49.4 12.6 64 32H456c69.3 0 135 22.7 179.2 81.6c6.4 8.5 6.4 20.3 0 28.8C591 329.3 525.3 352 456 352H168c-14.6 19.4-37.8 32-64 32H40c-22.1 0-40-17.9-40-40V328 184 168zM512 268.4V243.6c0-19.6-15.9-35.6-35.6-35.6c-2.5 0-4.4 2-4.4 4.4v87.1c0 2.5 2 4.4 4.4 4.4c19.6 0 35.6-15.9 35.6-35.6z"]]
};
var faSpaceShuttle = faShuttleSpace;
var faShirtLongSleeve = {
  prefix: 'fad',
  iconName: 'shirt-long-sleeve',
  icon: [640, 512, [], "e3c7", ["M320 112c61.9 0 112-50.1 112-112h28 15.6H480c1 0 2 .1 3 .3c32.1 2.5 61 20.9 76.7 49.5l66.4 120.7c9.1 16.5 13.9 35.1 13.9 54V384c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224.4c0-2.7-.7-5.3-2-7.7l-46-83.7V448c0 35.3-28.7 64-64 64H208c-35.3 0-64-28.7-64-64V133.1L98 216.7c-1.3 2.4-2 5-2 7.7V384c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224.4c0-18.9 4.8-37.4 13.9-54L80.3 49.7C95.9 21.2 124.9 2.8 157 .3c1-.2 2-.3 3-.3h4.4H180h28c0 61.9 50.1 112 112 112z", "M208 0c0 61.9 50.1 112 112 112s112-50.1 112-112H400c0 44.2-35.8 80-80 80s-80-35.8-80-80H208z"]]
};
var faChartPieSimple = {
  prefix: 'fad',
  iconName: 'chart-pie-simple',
  icon: [512, 512, ["chart-pie-alt"], "f64e", ["M224 49.6c0-9.2-7.8-16.6-17-15.4C90.1 50.3 0 150.7 0 272C0 404.6 107.5 512 240 512c121.4 0 221.7-90.1 237.7-207c1.3-9.2-6.1-17-15.4-17H224V49.6z", "M272 240H495.4c9 0 16.6-7 16.6-16C512 100.3 411.7 0 288 0c-9 0-16 7.6-16 16.6V240z"]]
};
var faChartPieAlt = faChartPieSimple;
var faFaceLaugh = {
  prefix: 'fad',
  iconName: 'face-laugh',
  icon: [512, 512, ["laugh"], "f599", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176.4 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faLaugh = faFaceLaugh;
var faFolderOpen = {
  prefix: 'fad',
  iconName: 'folder-open',
  icon: [576, 512, [128194, 128449, 61717], "f07c", ["M461.4 461.1l16.2-27.9c-3 10.7-8.7 20.2-16.2 27.9zM480 224H144c-11.4 0-21.9 6-27.6 15.9l-112 192c-5.8 9.9-5.8 22.1-.1 32.1c1 1.7 2 3.2 3.2 4.6C2.8 463 0 455.8 0 448V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v64zM11.1 472.2c5.7 4.9 13.1 7.8 20.9 7.8c-8 0-15.3-2.9-20.9-7.8z", "M144 224c-11.4 0-21.9 6-27.6 15.9l-112 192c-5.8 9.9-5.8 22.1-.1 32.1S20.5 480 32 480H432c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144z"]]
};
var faAlbumCollectionCircleUser = {
  prefix: 'fad',
  iconName: 'album-collection-circle-user',
  icon: [640, 512, [], "e48f", ["M56 0H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 48 32 37.3 32 24S42.7 0 56 0zM12 176.2C21.1 165.9 34.2 160 48 160H464c13.8 0 26.9 5.9 36 16.2c4.2 4.8 7.4 10.3 9.4 16.3c-4.4-.3-8.9-.5-13.4-.5c-46.9 0-89.5 18.3-121 48.2C342.9 220.1 301.4 208 256 208C154.4 208 72 268.9 72 344s82.4 136 184 136c33.2 0 64.4-6.5 91.3-17.9c12.4 19.6 28.6 36.6 47.5 49.9H80c-24.2 0-44.6-18-47.6-42L.4 214c-1.7-13.7 2.5-27.4 11.6-37.7zM288 352c0 13.3-14.3 24-32 24s-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24zM16 104c0-13.3 10.7-24 24-24H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-30.2 0-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7C553.5 468.1 526.2 480 496 480zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faCandy = {
  prefix: 'fad',
  iconName: 'candy',
  icon: [640, 512, [127852], "e3e7", ["M504 310.9c5.2-17.4 8-35.8 8-54.9s-2.8-37.5-8-54.9l93.2-46.6c10.5-5.3 23.3-2.1 30.2 7.4s5.8 22.7-2.5 31l-29.6 29.6 29.1 10.9C633.8 237 640 246 640 256s-6.2 19-15.6 22.5l-29.1 10.9L625 319c8.3 8.3 9.4 21.5 2.5 31s-19.7 12.7-30.2 7.4L504 310.9zM136 201.1c-5.2 17.4-8 35.8-8 54.9s2.8 37.5 8 54.9L42.7 357.5c-10.5 5.3-23.3 2.1-30.2-7.4s-5.8-22.7 2.5-31l29.6-29.6L15.6 278.5C6.2 275 0 266 0 256s6.2-19 15.6-22.5l29.1-10.9L15 193c-8.3-8.3-9.4-21.5-2.5-31s19.7-12.7 30.2-7.4L136 201.1z", "M318.1 64c-24.5 .2-47.9 5.1-69.4 13.7L419.9 420c20.3-12.4 38.2-28.5 52.6-47.3L318.1 64zM492.3 340.8C504.9 315.2 512 286.4 512 256c0-93.9-67.4-172.1-156.5-188.7L492.3 340.8zm-101 93.5L220.1 92c-20.3 12.4-38.2 28.5-52.6 47.3L321.9 448c24.5-.2 47.9-5.1 69.4-13.7zM284.5 444.7L147.7 171.2C135.1 196.8 128 225.6 128 256c0 93.9 67.4 172.1 156.5 188.7z"]]
};
var faBowlHot = {
  prefix: 'fad',
  iconName: 'bowl-hot',
  icon: [512, 512, ["soup"], "f823", ["M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 32.7 15.4 63.6 41.6 83.2C183.7 125.8 192 142.4 192 160v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-32.7-15.4-63.6-41.6-83.2C184.3 66.2 176 49.6 176 32V24zm128 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 32.7 15.4 63.6 41.6 83.2C311.7 125.8 320 142.4 320 160v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-32.7-15.4-63.6-41.6-83.2C312.3 66.2 304 49.6 304 32V24z", "M33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35H332.7c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5H33.6z"]]
};
var faSoup = faBowlHot;
var faFlatbread = {
  prefix: 'fad',
  iconName: 'flatbread',
  icon: [512, 512, [129747], "e40b", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 171.3l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-112-70.6c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zm160 182.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z", "M251.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zm112 48c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0zm48 134.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faHeartCirclePlus = {
  prefix: 'fad',
  iconName: 'heart-circle-plus',
  icon: [576, 512, [], "e500", ["M507 208.7C484.3 198 458.8 192 432 192c-97.2 0-176 78.8-176 176c0 35.7 10.6 68.9 28.9 96.6l-5.4 5.6c-13 13-34 13-45.9 0L39.7 270.5c-55.9-57.9-52.9-153.8 10-207.8c53.9-47 136.8-38 186.8 13l20 21 19-21c49.9-50.9 131.8-59.9 187.8-13c42.9 37.4 57.5 95 43.8 146.1z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]]
};
var faCodeFork = {
  prefix: 'fad',
  iconName: 'code-fork',
  icon: [448, 512, [], "e13b", ["M112 153.3c-9.8 4.3-20.6 6.7-32 6.7s-22.2-2.4-32-6.7V192c0 53 43 96 96 96h48v70.7c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7V288h48c53 0 96-43 96-96V153.3c-9.8 4.3-20.6 6.7-32 6.7s-22.2-2.4-32-6.7V192c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V153.3z", "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 80 0a80 80 0 1 0 0 160zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 368 0a80 80 0 1 0 0 160zM200 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]]
};
var faCity = {
  prefix: 'fad',
  iconName: 'city',
  icon: [640, 512, [127961], "f64f", ["M432 0c26.5 0 48 21.5 48 48V192H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336 304 48c-26.5 0-48-21.5-48-48V240 144c0-26.5 21.5-48 48-48H288V48c0-26.5 21.5-48 48-48h96zM560 352H528c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM256 400V368c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM112 416c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zM576 272c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272zM240 160H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16zM128 176c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176zM240 320c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zM128 304V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm272-48H368c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16zM416 80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80zm-16 80H368c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16z", "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96h48V24zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24V96h48V24zm16 136H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16zM576 272c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272zM112 416c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zm144-16V368c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm320-32c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368zM128 176c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176zM240 320c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zM128 304V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"]]
};
var faSignalBarsWeak = {
  prefix: 'fad',
  iconName: 'signal-bars-weak',
  icon: [640, 512, ["signal-alt-1"], "f691", ["M560 0c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V48c0-26.5-21.5-48-48-48zM352 176V464c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zM192 304V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48s-48 21.5-48 48z", "M32 432c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z"]]
};
var faSignalAlt1 = faSignalBarsWeak;
var faMicrophoneLines = {
  prefix: 'fad',
  iconName: 'microphone-lines',
  icon: [384, 512, [127897, "microphone-alt"], "f3c9", ["M208 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V96H208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V160H208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V224H208zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z", "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96z"]]
};
var faMicrophoneAlt = faMicrophoneLines;
var faClockTwelve = {
  prefix: 'fad',
  iconName: 'clock-twelve',
  icon: [512, 512, [], "e358", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V256c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M256 96c13.3 0 24 10.7 24 24V256c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24z"]]
};
var faPepperHot = {
  prefix: 'fad',
  iconName: 'pepper-hot',
  icon: [512, 512, [127798], "f816", ["M281.8 124.3c3.5 2.3 7.9 3.7 13 3.7l17.1 0c13.3 0 24 10.7 24 24v80c0 13.3 10.7 24 24 24h73.2c9.1 0 17.4 5.1 21.5 13.3l11.7 23.4c2 4.1 5 7.2 8.3 9.4C397.9 429.6 258.4 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7L281.8 124.3z", "M461 12.3C454.5 .8 439.9-3.4 428.3 3s-15.8 21-9.3 32.6l4.8 8.7c9.7 17.5 11.5 37.6 6 55.8C406.8 87.3 380.3 80 352 80c-24.3 0-47.3 5.4-67.9 15.1c-19.3 9-10.5 32.9 10.8 32.9l17.1 0c13.3 0 24 10.7 24 24v80c0 13.3 10.7 24 24 24h73.2c9.1 0 17.4 5.1 21.5 13.3l11.7 23.4c8.2 16.4 30.7 17.5 36.8 .1c5.8-16.5 8.9-34.3 8.9-52.8c0-42.1-16.2-80.4-42.8-108.9c16.4-34.3 15.9-75.4-3.4-110L461 12.3z"]]
};
var faCitrusSlice = {
  prefix: 'fad',
  iconName: 'citrus-slice',
  icon: [512, 512, [], "e2f5", ["M253.5 230.9c-3.7-3.7-4.4-9.4-2.4-14.3s6.5-8.5 11.8-8.5H448.2c8.6 0 15.8 6.8 15.5 15.5c-1.4 50.6-18.3 100.8-50.6 143c-5.6 7.3-16.3 7.7-22.9 1.1L253.5 230.9zM208 262.9c0-5.3 3.7-9.8 8.5-11.8s10.6-1.4 14.3 2.4L367.6 390.3c6.5 6.5 6.2 17.3-1.1 22.9c-42.2 32.3-92.5 49.2-143 50.6c-8.6 .2-15.5-6.9-15.5-15.5V262.9zM250.5 166c-2.6-5.9-2.1-13 2.5-17.6L366.3 35.1c4.6-4.6 20.1 1.2 24.7 5.8c33.4 33.4 55.3 73.9 65.7 116.6c2.3 9.6-5.2 18.5-15.1 18.5H264.5c-6.2 0-11.5-4.3-14-10zM148.4 253c4.6-4.6 11.7-5.2 17.6-2.5c5.7 2.5 10 7.8 10 14V441.7c0 9.9-8.9 17.4-18.5 15.1C114.8 446.3 74.4 424.4 41 391c-4.6-4.6-10.5-20.1-5.8-24.7L148.4 253z", "M7 391c9.4-9.4 24.6-9.4 33.9 0c96.9 96.9 253.6 97.1 350.4 .3s96.6-253.5-.3-350.4c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c115.6 115.6 116 302.6 .3 418.3S122.6 540.5 7 425c-9.4-9.4-9.4-24.6 0-33.9z"]]
};
var faSheep = {
  prefix: 'fad',
  iconName: 'sheep',
  icon: [640, 512, [128017], "f711", ["M308.5 142.1c8 18.6 24.8 30.7 43.5 33.4V208c0 61.9 50.1 112 112 112h15.5c.3 2.6 .5 5.3 .5 8c0 35.3-28.7 64-64 64c-3.3 0-6.6-.3-9.8-.7c-6.8 28-32.1 48.7-62.2 48.7c-15 0-28.9-5.2-39.8-13.9c-11.7 13.4-29 21.9-48.2 21.9s-36.5-8.5-48.2-21.9C196.9 434.8 183 440 168 440c-30.1 0-55.3-20.8-62.2-48.7c-3.2 .5-6.5 .7-9.8 .7c-35.3 0-64-28.7-64-64c0-5.3 .7-10.5 1.9-15.5C13.7 301.7 0 280.5 0 256s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 92.8 137.9 72 168 72c15 0 28.9 5.2 39.8 13.9C219.5 72.5 236.8 64 256 64c22.9 0 43 12 54.3 30.1c-7.5 14.4-8.7 31.9-1.8 47.9z", "M384 135.8l-14.5 6.2c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l47.8-20.5C415.3 50.2 445.5 32 480 32s64.7 18.2 81.6 45.4l47.8 20.5c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6L576 135.8V208c0 44.2-35.8 80-80 80H464c-44.2 0-80-35.8-80-80V135.8zM464 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM115.1 485.9L97.5 392c2.8-.1 5.6-.3 8.3-.7c6.8 28 32.1 48.7 62.2 48.7c15 0 28.9-5.2 39.8-13.9l.2 .2V480c0 17.7-14.3 32-32 32H146.6c-15.4 0-28.6-11-31.5-26.1zM304 480V426.3l.2-.2C315.1 434.8 329 440 344 440c30.1 0 55.3-20.8 62.2-48.7c2.7 .4 5.5 .7 8.3 .7l-17.6 93.9C394.1 501 380.8 512 365.4 512H336c-17.7 0-32-14.3-32-32z"]]
};
var faUnlock = {
  prefix: 'fad',
  iconName: 'unlock',
  icon: [448, 512, [128275], "f09c", ["M224 64c-44.2 0-80 35.8-80 80v48H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64z", "M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z"]]
};
var faColonSign = {
  prefix: 'fad',
  iconName: 'colon-sign',
  icon: [384, 512, [], "e140", ["M255 39.8l-6.5 25.8c-8.1-1-16.3-1.6-24.6-1.6c-14.5 0-28.6 1.6-42.1 4.6L193 24.2C197.2 7.1 214.6-3.3 231.8 1s27.6 21.7 23.3 38.8zm-22.1 88.5L171.8 372.9c-22.2-9.9-41.1-26-54.4-46.1l45.9-183.4C181.3 133.6 202 128 224 128c3 0 6 .1 8.9 .3zM199.6 381.7l62-248.1c14.3 4.4 27.5 11.2 39.2 20c6 4.5 13.2 6.6 20.2 6.4L266.8 376.7C253.4 381.4 239 384 224 384c-8.3 0-16.5-.8-24.4-2.3zm-43.5 54l-13 52.1c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l17.7-70.8c16.8 14.5 36.2 26.2 57.4 34.2zm28 8.2c12.9 2.7 26.2 4.2 39.9 4.2c8.6 0 17.1-.6 25.4-1.7L239 487.8c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l7.1-28.4zM336 100c-17.6-12.7-37.5-22.4-58.8-28.6L289 24.2C293.2 7.1 310.6-3.3 327.8 1s27.6 21.7 23.3 38.8L336 100z", "M224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8C307.1 433.7 267.2 448 224 448C118 448 32 362 32 256S118 64 224 64c43.2 0 83.1 14.3 115.2 38.4c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128z"]]
};
var faHeadset = {
  prefix: 'fad',
  iconName: 'headset',
  icon: [512, 512, [], "f590", ["M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208V400.1c0 22.1-17.9 40-40 40L313.6 440c-8.3-14.4-23.8-24-41.6-24H240c-26.5 0-48 21.5-48 48s21.5 48 48 48h32c17.8 0 33.3-9.7 41.6-24l110.4 .1c48.6 0 88.1-39.4 88.1-88V256C512 114.6 397.4 0 256 0S0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256z", "M144 208c-35.3 0-64 28.7-64 64v48c0 35.3 28.7 64 64 64h16c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H144zm224 0H352c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32h16c35.3 0 64-28.7 64-64V272c0-35.3-28.7-64-64-64z"]]
};
var faBadgerHoney = {
  prefix: 'fad',
  iconName: 'badger-honey',
  icon: [640, 512, [129441], "f6b4", ["M502 122.2L570 160H467.5c-23.2 0-46 6.3-65.9 18.2L294.8 242.3c-14.9 9-32 13.7-49.4 13.7H192c-46.4 0-86.2-28.2-103.2-68.5C102 161.7 129 144 160 144H332.2c31 0 61.5-7.2 89.2-21.1l4.7-2.4c11.3-5.6 23.7-8.6 36.3-8.6c13.8 0 27.4 3.5 39.5 10.2zm51.2 154.9l-16.1-25.8c15.5-4.9 31.7-8.4 48.3-10.2c1.4-.1 2.8-.3 4.2-.6l-22.8 36.5c-3.1 5-10.4 5-13.6 0z", "M180.6 352l-16 37.3c-3 6.9-3.4 14.6-1.2 21.8l8.3 27.7c6.2 20.5-9.2 41.2-30.7 41.2H111.8c-14.1 0-26.6-9.3-30.7-22.8L68 413.5c-2.6-8.8-2.7-18.2-.2-27l16.8-59C69.1 316.2 56.2 301.4 47 284.3c-4.5 2.4-9.6 3.7-15 3.7c-17.7 0-32-14.3-32-32V224C0 153.3 57.3 96 128 96h32H332.2c23.5 0 46.7-5.5 67.8-16l4.7-2.4c17.9-9 37.7-13.6 57.8-13.6c22 0 43.6 5.6 62.8 16.3l81.9 45.5C627.4 137 640 158.4 640 181.6v3.8c0 14.5-5.8 28.4-16 38.6s-24.2 15.7-38.6 17.2C500.8 250 427.7 306.1 393 342.1l16.8 100.6C413 462.2 398 480 378.2 480H347.1c-15.6 0-29-11.3-31.6-26.7L298.7 352H180.6zM570 160l-68-37.8c-12.1-6.7-25.6-10.2-39.5-10.2c-12.6 0-25.1 2.9-36.3 8.6l-4.7 2.4c-27.7 13.9-58.3 21.1-89.2 21.1H160c-31 0-58 17.7-71.2 43.5c17 40.2 56.8 68.5 103.2 68.5h53.4c17.4 0 34.5-4.7 49.4-13.7l106.8-64.1c19.9-11.9 42.7-18.2 65.9-18.2h5.9c-.9 2.5-1.4 5.2-1.4 8c0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.8-.5-5.5-1.4-8H570z"]]
};
var faH4 = {
  prefix: 'fad',
  iconName: 'h4',
  icon: [640, 512, [], "f86a", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M479 103.8c4.3-17.1-6.1-34.5-23.3-38.8s-34.5 6.1-38.8 23.3l-48 192c-2.4 9.6-.2 19.7 5.8 27.5s15.4 12.3 25.2 12.3H576v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H441L479 103.8z"]]
};
var faStoreSlash = {
  prefix: 'fad',
  iconName: 'store-slash',
  icon: [640, 512, [], "e071", ["M365.5 384H160V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3L365.5 384zM48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5zM480 350.9l64 50.2V384 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V350.9zM94.9 49.1L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faRoadCircleXmark = {
  prefix: 'fad',
  iconName: 'road-circle-xmark',
  icon: [640, 512, [], "e566", ["M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32l.7 0c-.5-5.3-.7-10.6-.7-16c0-16.9 2.4-33.3 6.8-48.7c-2.2 .5-4.5 .7-6.8 .7c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32v42.8c31.9-45.2 84.5-74.8 144-74.8c11.6 0 22.9 1.1 33.8 3.2L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faSignalSlash = {
  prefix: 'fad',
  iconName: 'signal-slash',
  icon: [640, 512, [], "f695", ["M608 451.2V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V401.1l64 50.2zM480 350.9V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V300.8l64 50.2zM352 250.6V224c0-17.7-14.3-32-32-32c-10.7 0-20.1 5.2-25.9 13.2L352 250.6zM576 512l-.3 0h.6l-.3 0zm-96-32v-5.8l-64-50.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM352 373.3l-64-50.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V373.3zM192 288c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faUserMinus = {
  prefix: 'fad',
  iconName: 'user-minus',
  icon: [640, 512, [], "f503", ["M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z", "M448 224c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24z"]]
};
var faMarsStrokeUp = {
  prefix: 'fad',
  iconName: 'mars-stroke-up',
  icon: [320, 512, [9896, "mars-stroke-v"], "f22a", ["M96 352a64 64 0 1 1 128 0A64 64 0 1 1 96 352z", "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H184v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8V168H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z"]]
};
var faMarsStrokeV = faMarsStrokeUp;
var faChampagneGlasses = {
  prefix: 'fad',
  iconName: 'champagne-glasses',
  icon: [640, 512, [129346, "glass-cheers"], "f79f", ["M195 1.9C179.9-3.6 163 3 155.6 17.3L76.9 170.2C48.1 226 66.5 292.5 115.3 326.8L84 413l-41-15c-16.6-6.1-35 2.5-41 19.1s2.5 35 19.1 41l71.1 25.9L163.3 510c16.6 6.1 35-2.5 41-19.1s-2.5-35-19.1-41l-41-15 31.3-86.2c59.4 5.2 116.2-33.9 130-95.2L320 188.8l14.6 64.7c13.8 61.3 70.6 100.4 130 95.2l31.3 86.2-41 15c-16.6 6.1-25.2 24.4-19.1 41s24.4 25.2 41 19.1l71.1-25.9L619 458.2c16.6-6.1 25.2-24.4 19.1-41s-24.4-25.2-41-19.1l-41 15-31.3-86.2c48.8-34.3 67.2-100.8 38.5-156.6L484.4 17.3C477.1 3 460.2-3.6 445.1 1.9L320 47.5 195 1.9zM133.7 199.6L199.6 71.7l75.1 27.4L243 239.4c-7.8 34.5-44 54.3-77.2 42.2s-48.2-50.6-32.1-82zm372.6 0c16.2 31.4 1.1 69.9-32.1 82s-69.4-7.7-77.2-42.2L365.4 99.1l75.1-27.4 65.9 127.8z", "M172.4 124.5l-38.7 75c-16.2 31.4-1.1 69.9 32.1 82s69.4-7.7 77.2-42.2L261.6 157l-89.2-32.5zm295.2 0L378.5 157 397 239.4c7.8 34.5 44 54.3 77.2 42.2s48.2-50.6 32.1-82l-38.7-75z"]]
};
var faGlassCheers = faChampagneGlasses;
var faTaco = {
  prefix: 'fad',
  iconName: 'taco',
  icon: [512, 512, [127790], "f826", ["M480 480c17.7 0 32-14.3 32-32c0-141.4-114.6-256-256-256S0 306.6 0 448c0 17.7 14.3 32 32 32H480zM96 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z", "M237.2 38.4c11-8.6 26.5-8.6 37.5 0l44.1 34.2c5.6 4.4 12.6 6.6 19.7 6.4l55.8-1.7c14-.4 26.5 8.6 30.4 22.1l15.6 53.6c2 6.8 6.3 12.8 12.2 16.8L498.6 201c11.6 7.9 16.3 22.5 11.6 35.7l-27.8 91.6C439.4 247.2 354.1 192 256 192s-183.4 55.2-226.3 136.3L1.8 236.7c-4.7-13.1 0-27.8 11.6-35.7l46.1-31.4c5.9-4 10.2-9.9 12.2-16.8L87.3 99.3c3.9-13.4 16.4-22.5 30.4-22.1L173.4 79c7.1 .2 14.1-2 19.7-6.4l44.1-34.2z"]]
};
var faHexagonPlus = {
  prefix: 'fad',
  iconName: 'hexagon-plus',
  icon: [512, 512, ["plus-hexagon"], "f300", ["M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z", "M232 280v64c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faPlusHexagon = faHexagonPlus;
var faClipboard = {
  prefix: 'fad',
  iconName: 'clipboard',
  icon: [384, 512, [128203], "f328", ["M113.6 64c-.2 .8-.3 1.6-.4 2.3C93.9 72.6 80 90.7 80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112c0-21.3-13.9-39.4-33.2-45.7c-.1-.8-.3-1.6-.4-2.3H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h49.6z", "M192 0c-39.5 0-72.4 28.7-78.8 66.3C93.9 72.6 80 90.7 80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112c0-21.3-13.9-39.4-33.2-45.7C264.4 28.7 231.5 0 192 0zm0 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faHouseCircleExclamation = {
  prefix: 'fad',
  iconName: 'house-circle-exclamation',
  icon: [640, 512, [], "e50a", ["M496 192c-91.8 0-167.2 70.3-175.3 160l-.7 0H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faFileArrowUp = {
  prefix: 'fad',
  iconName: 'file-arrow-up',
  icon: [384, 512, ["file-upload"], "f574", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM216 392V289.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V392c0 13.3 10.7 24 24 24s24-10.7 24-24z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zM216 392c0 13.3-10.7 24-24 24s-24-10.7-24-24V289.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V392z"]]
};
var faFileUpload = faFileArrowUp;
var faWifi = {
  prefix: 'fad',
  iconName: 'wifi',
  icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", ["", "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]]
};
var faWifi3 = faWifi;
var faWifiStrong = faWifi;
var faMessages = {
  prefix: 'fad',
  iconName: 'messages',
  icon: [640, 512, ["comments-alt"], "f4b6", ["M256 352v32c0 35.3 28.7 64 64 64H437.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V448h32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448V256c0 53-43 96-96 96H256z", "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V320H64c-35.3 0-64-28.7-64-64V64z"]]
};
var faCommentsAlt = faMessages;
var faBath = {
  prefix: 'fad',
  iconName: 'bath',
  icon: [512, 512, [128705, "bathtub"], "f2cd", ["M109.3 64C101.9 64 96 69.9 96 77.3V256H32V77.3C32 34.6 66.6 0 109.3 0c20.5 0 40.1 8.1 54.6 22.6l14.9 14.9C187.8 34 197.7 32 208 32c19.9 0 38 7.2 52 19.2c9.2-5.3 21.1-4 29 3.8c9.4 9.4 9.4 24.6 0 33.9L185 193c-9.4 9.4-24.6 9.4-33.9 0c-7.9-7.9-9.1-19.8-3.8-29c-12-14-19.2-32.1-19.2-52c0-10.3 2-20.2 5.5-29.2L118.6 67.9c-2.5-2.5-5.9-3.9-9.4-3.9z", "M32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm448 96H32v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352z"]]
};
var faBathtub = faBath;
var faUmbrellaSimple = {
  prefix: 'fad',
  iconName: 'umbrella-simple',
  icon: [512, 512, ["umbrella-alt"], "e2bc", ["M288 288V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V288h64z", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v2C108.2 48.4 16.4 140.2 2 256.1C-.2 273.6 14.3 288 32 288H480c17.7 0 32.2-14.4 30-31.9C495.6 140.2 403.8 48.4 288 34V32z"]]
};
var faUmbrellaAlt = faUmbrellaSimple;
var faRectangleHistoryCirclePlus = {
  prefix: 'fad',
  iconName: 'rectangle-history-circle-plus',
  icon: [640, 512, [], "e4a3", ["M394.8 512C349.5 480.1 320 427.5 320 368c0-97.2 78.8-176 176-176c2.5 0 5 .1 7.5 .2c-11-19.2-31.8-32.2-55.5-32.2L64 160c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64l330.8 0zM464 104c0-13.3-10.7-24-24-24L72 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0c13.3 0 24-10.7 24-24zM416 24c0-13.3-10.7-24-24-24H120C106.7 0 96 10.7 96 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"]]
};
var faUnderline = {
  prefix: 'fad',
  iconName: 'underline',
  icon: [448, 512, [], "f0cd", ["M48 32C30.3 32 16 46.3 16 64s14.3 32 32 32H64V224c0 88.4 71.6 160 160 160s160-71.6 160-160V96h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H304c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V224c0 53-43 96-96 96s-96-43-96-96V96h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z", "M0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
};
var faPrescriptionBottlePill = {
  prefix: 'fad',
  iconName: 'prescription-bottle-pill',
  icon: [576, 512, [], "e5c0", ["M32 0C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96H352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM352 128H32v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v32c0 35.3 28.7 64 64 64H288c11.6 0 22.4-3.1 31.8-8.4c-39-32.3-63.8-81-63.8-135.6c0-68.4 39-127.7 96-156.8V128z", "M338.5 297.1c-10.1-10.1-27-9.2-33.7 3.4C294.1 320.6 288 343.6 288 368c0 79.5 64.5 144 144 144c24.4 0 47.4-6.1 67.5-16.8c12.6-6.7 13.5-23.6 3.4-33.7L338.5 297.1zM525.5 438.9c10.1 10.1 27 9.2 33.7-3.4C569.9 415.4 576 392.4 576 368c0-79.5-64.5-144-144-144c-24.4 0-47.4 6.1-67.5 16.8c-12.6 6.7-13.5 23.6-3.4 33.7L525.5 438.9z"]]
};
var faUserPen = {
  prefix: 'fad',
  iconName: 'user-pen',
  icon: [640, 512, ["user-edit"], "f4ff", ["M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c48.1 0 91.8 19.1 123.9 50.1l-40.3 40.3c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H29.7C13.3 512 0 498.7 0 482.3z", "M557.2 235.7l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71z"]]
};
var faUserEdit = faUserPen;
var faBinarySlash = {
  prefix: 'fad',
  iconName: 'binary-slash',
  icon: [640, 512, [], "e33e", ["M384 398.5l-63.9-50.3c-.1 1.3-.1 2.5-.1 3.8v96c0 35.3 28.7 64 64 64h64c20.1 0 38.1-9.3 49.8-23.8l-51-40.2H384V398.5zM399.7 288L512 376V352c0-35.3-28.7-64-64-64H399.7zM236.4 160L298 208.3c13.5-11.7 22-29 22-48.3V64c0-35.3-28.7-64-64-64H192c-35.3 0-64 28.7-64 64V75l64 50.2V64h64v96H236.4zM464 32c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V32zM240 320c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H240V320z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faSquareO = {
  prefix: 'fad',
  iconName: 'square-o',
  icon: [448, 512, [], "e278", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z", "M224 176a80 80 0 1 0 0 160 80 80 0 1 0 0-160zm128 80A128 128 0 1 1 96 256a128 128 0 1 1 256 0z"]]
};
var faSignature = {
  prefix: 'fad',
  iconName: 'signature',
  icon: [640, 512, [], "f5b7", ["M64 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368zm219.5 48H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48z", "M224 96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-53 43-96 96-96s96 43 96 96v7.8c0 20.8-1.2 41.6-3.6 62.3l122.4-36.7c11.4-3.4 23.8-.2 32.2 8.4s11.2 21.1 7.4 32.4l-18 53.9H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l12.5-37.5-94.4 28.3c-11.9 52.8-31.6 103.5-58.4 150.5l-13.9 24.3c-12.9 22.6-36.9 36.5-62.9 36.5c-40 0-72.5-32.5-72.5-72.5V335.6c0-42.4 27.8-79.8 68.4-92l84.4-25.3c4.8-27.2 7.1-54.9 7.1-82.5V128c0-17.7-14.3-32-32-32zm7.8 194.3l-49 14.7C169.3 309 160 321.5 160 335.6v71.9c0 4.7 3.8 8.5 8.5 8.5c3 0 5.9-1.6 7.4-4.3l13.9-24.3c17.6-30.8 31.7-63.4 42.1-97.2z"]]
};
var faStroopwafel = {
  prefix: 'fad',
  iconName: 'stroopwafel',
  icon: [512, 512, [], "f551", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3L233.4 256l-45.3 45.3L142.9 256zm67.9 67.9L256 278.6l45.3 45.3L256 369.1l-45.3-45.3zM278.6 256l45.3-45.3L369.1 256l-45.3 45.3L278.6 256zm22.6-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z", "M425.7 312.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9zM256 369.1l-45.3-45.3L256 278.6l45.3 45.3L256 369.1zm-67.9-67.9L142.9 256l45.3-45.3L233.4 256l-45.3 45.3zM256 233.4l-45.3-45.3L256 142.9l45.3 45.3L256 233.4zm67.9 67.9L278.6 256l45.3-45.3L369.1 256l-45.3 45.3z"]]
};
var faBold = {
  prefix: 'fad',
  iconName: 'bold',
  icon: [384, 512, [], "f032", ["M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z", ""]]
};
var faAnchorLock = {
  prefix: 'fad',
  iconName: 'anchor-lock',
  icon: [640, 512, [], "e4ad", ["M288 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 32c0 33.4-17 62.8-42.9 80H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H320V448h48c5.5 0 10.8-.5 16-1.3V480c0 11 2.7 21.3 7.6 30.3c-7.7 1.1-15.6 1.7-23.6 1.7H288 208c-88.4 0-160-71.6-160-160v-6.1l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56-56c9.4-9.4 24.6-9.4 33.9 0l56 56c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7V352c0 53 43 96 96 96h48V240H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h10.9C209 158.8 192 129.4 192 96c0-53 43-96 96-96s96 43 96 96z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faBuildingNgo = {
  prefix: 'fad',
  iconName: 'building-ngo',
  icon: [384, 512, [], "e4d7", ["M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z", "M61.3 71.1c-3.9-5.9-11.2-8.5-17.9-6.4S32 72.9 32 80v96c0 8.8 7.2 16 16 16s16-7.2 16-16V132.8l34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v43.2l-34.7-52zM152 80v88c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H184V96h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H168c-8.8 0-16 7.2-16 16zM304 96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm-48 16v32c0 26.5 21.5 48 48 48s48-21.5 48-48V112c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]]
};
var faTransporter3 = {
  prefix: 'fad',
  iconName: 'transporter-3',
  icon: [512, 512, [], "e045", ["M480 32L472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32zM64 128l-7.3-25.4C55.6 98.7 52.1 96 48 96s-7.6 2.7-8.7 6.6L32 128 6.6 135.3C2.7 136.4 0 139.9 0 144s2.7 7.6 6.6 8.7L32 160l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 160l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 128zm112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm8 464H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H296 216zM96 256.5v-1c0 .3 0 .7 0 1z"]]
};
var faEngineWarning = {
  prefix: 'fad',
  iconName: 'engine-warning',
  icon: [640, 512, ["engine-exclamation"], "f5f2", ["M424 88c0-13.3-10.7-24-24-24H208c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0v32h48V112l72 0c13.3 0 24-10.7 24-24zM24 136c-13.3 0-24 10.7-24 24V352c0 13.3 10.7 24 24 24s24-10.7 24-24V280H96V232H48V160c0-13.3-10.7-24-24-24zm552 56c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H576z", "M128 144c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32h44.8l32 40c12.1 15.2 30.5 24 50 24H448c35.3 0 64-28.7 64-64V238.8c0-19.4-8.8-37.8-24-50L449.5 158c-11.3-9.1-25.4-14-40-14H208 160 128zm196 64v88c0 11-9 20-20 20s-20-9-20-20V208c0-11 9-20 20-20s20 9 20 20zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faEngineExclamation = faEngineWarning;
var faCircleDownRight = {
  prefix: 'fad',
  iconName: 'circle-down-right',
  icon: [512, 512, [], "e108", ["M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm96 198.6V336c0 8.8-7.2 16-16 16H198.6c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L216 280l-66.3-66.3C146 210 144 205.1 144 200s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L280 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6z", "M352 336V198.6c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6L280 216l-66.3-66.3C210 146 205.1 144 200 144s-10 2-13.7 5.7l-36.7 36.7C146 190 144 194.9 144 200s2 10 5.7 13.7L216 280l-33.4 33.4c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6H336c8.8 0 16-7.2 16-16z"]]
};
var faSquareK = {
  prefix: 'fad',
  iconName: 'square-k',
  icon: [448, 512, [], "e274", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM313.1 168.8l-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V298.5 152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8L278.9 135.2c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5 .3 33.9z", "M312.8 134.9c9.5 9.3 9.6 24.5 .3 33.9l-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V298.5 152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8L278.9 135.2c9.3-9.5 24.5-9.6 33.9-.3z"]]
};
var faManatSign = {
  prefix: 'fad',
  iconName: 'manat-sign',
  icon: [384, 512, [], "e1d5", ["M192 32c-17.7 0-32 14.3-32 32V98.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7V64c0-17.7-14.3-32-32-32zm32 132c-10.2-2.6-21-4-32-4s-21.8 1.4-32 4V448c0 17.7 14.3 32 32 32s32-14.3 32-32V164z", "M0 288C0 182 86 96 192 96s192 86 192 192V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288c0-70.7-57.3-128-128-128s-128 57.3-128 128V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288z"]]
};
var faMoneyCheckPen = {
  prefix: 'fad',
  iconName: 'money-check-pen',
  icon: [640, 512, ["money-check-edit"], "f872", ["M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64.6c-15.2 2-29.8 8.8-41.4 20.5L353.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-6 23.9H64c-35.3 0-64-28.7-64-64V128zM96 304c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16-112c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z", "M557.2 235.7l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71z"]]
};
var faMoneyCheckEdit = faMoneyCheckPen;
var faNotEqual = {
  prefix: 'fad',
  iconName: 'not-equal',
  icon: [448, 512, [], "f53e", ["M260.2 144l-42.7 64H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H260.2zM153.5 304l-42.7 64H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H153.5zm34.3 64l42.7-64H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8zM294.5 208l42.7-64H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5z", "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4l-256 384c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4l256-384c9.8-14.7 29.7-18.7 44.4-8.9z"]]
};
var faBorderTopLeft = {
  prefix: 'fad',
  iconName: 'border-top-left',
  icon: [448, 512, ["border-style"], "f853", ["M416 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM128 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M32 480c-17.7 0-32-14.3-32-32L0 112C0 67.8 35.8 32 80 32l336 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96c-8.8 0-16 7.2-16 16l0 336c0 17.7-14.3 32-32 32z"]]
};
var faBorderStyle = faBorderTopLeft;
var faMapLocationDot = {
  prefix: 'fad',
  iconName: 'map-location-dot',
  icon: [576, 512, ["map-marked-alt"], "f5a0", ["M416 503V200.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503zM15.1 187.3l122.6-49c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3zM384 255V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0c13.9-17.4 35.7-45.7 56.2-77z", "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM288 72a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]]
};
var faMapMarkedAlt = faMapLocationDot;
var faTilde = {
  prefix: 'fad',
  iconName: 'tilde',
  icon: [448, 512, [63135], "7e", ["M99.9 192C80.1 192 64 208.1 64 227.9V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V227.9C0 172.7 44.7 128 99.9 128c26.5 0 51.9 10.5 70.6 29.3L322.7 309.5c6.7 6.7 15.9 10.5 25.4 10.5c19.8 0 35.9-16.1 35.9-35.9V192c0-17.7 14.3-32 32-32s32 14.3 32 32v92.1c0 55.2-44.7 99.9-99.9 99.9c-26.5 0-51.9-10.5-70.6-29.3L125.3 202.5c-6.7-6.7-15.9-10.5-25.4-10.5z", ""]]
};
var faJedi = {
  prefix: 'fad',
  iconName: 'jedi',
  icon: [576, 512, [], "f669", ["M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5c-7.4 1.3-15.1 2-22.9 2s-15.4-.7-22.9-2l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z", "M376.2 201.9c-7.5 5.8-8 17.9-1 24.4C400.3 249.6 416 283 416 320c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-37 15.7-70.4 40.8-93.7c7-6.5 6.5-18.6-1-24.4C165.9 175.5 144 134.3 144 88c0-16.8 2.9-33 8.2-48c4.6-13-10.2-30-21.4-22C77.3 56 38.1 112.8 22.9 178.8c-.5 2.1 .2 4.3 1.7 5.9l28.4 28.4c4 4 1.2 10.9-4.5 10.9h-26c-3.4 0-6.2 2.6-6.3 6c-.1 3.3-.2 6.6-.2 10c0 17.5 1.7 34.7 4.8 51.3c.2 1.2 .8 2.4 1.7 3.3l46.5 46.5c4 4 1.2 10.9-4.5 10.9H50c-4.6 0-7.7 4.8-5.7 9C88.8 450.5 181.2 512 288 512s199.2-61.5 243.7-151c2.1-4.2-1-9-5.7-9H511.4c-5.7 0-8.6-6.9-4.5-10.9l46.5-46.5c.9-.9 1.5-2 1.7-3.3c3.2-16.6 4.8-33.8 4.8-51.3c0-3.3-.1-6.7-.2-10c-.1-3.4-2.9-6-6.3-6h-26c-5.7 0-8.6-6.9-4.5-10.9l28.4-28.4c1.5-1.5 2.2-3.8 1.7-5.9C537.9 112.8 498.7 56 445.2 18c-11.3-8-26 8.9-21.4 22c5.3 15 8.2 31.2 8.2 48c0 46.3-21.9 87.5-55.8 113.9z"]]
};
var faSquarePollVertical = {
  prefix: 'fad',
  iconName: 'square-poll-vertical',
  icon: [448, 512, ["poll"], "f681", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM320 288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z", "M192 160c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM96 256c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256zm224 32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z"]]
};
var faPoll = faSquarePollVertical;
var faArrowDownSquareTriangle = {
  prefix: 'fad',
  iconName: 'arrow-down-square-triangle',
  icon: [576, 512, ["sort-shapes-down-alt"], "f889", ["M368 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm48 256c11 0 21.3 5.7 27.1 15l80 128c6.2 9.9 6.5 22.3 .9 32.5s-16.4 16.5-28 16.5H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6 .9-32.5l80-128c5.8-9.4 16.1-15 27.1-15z", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z"]]
};
var faSortShapesDownAlt = faArrowDownSquareTriangle;
var faMugHot = {
  prefix: 'fad',
  iconName: 'mug-hot',
  icon: [512, 512, [9749], "f7b6", ["M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z", "M32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256z"]]
};
var faDogLeashed = {
  prefix: 'fad',
  iconName: 'dog-leashed',
  icon: [576, 512, [129454], "f6d4", ["M101 4.4c6.4-6.1 16.5-5.8 22.6 .6L281.3 170.5l148.9 62.7c8.1 3.4 12 12.8 8.5 21s-12.8 12-21 8.5L288 208.1V384c0 8.8-7.2 16-16 16s-16-7.2-16-16V190.4L100.4 27c-6.1-6.4-5.8-16.5 .6-22.6z", "M256 192H144 128 98c-14.7 0-27.5-10-31-24.2L63 152.2c-4.3-17.1-21.7-27.6-38.8-23.3S-3.3 150.6 1 167.8l3.9 15.5c7.8 31.2 30.4 55.6 59.2 66.5V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V364.8c24 12.3 51.2 19.2 80 19.2c5.4 0 10.7-.2 16-.7V192zm32 185.4c11.2-3.2 21.9-7.4 32-12.6V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32l0-218L288 208.1V377.4zM420.5 229.2l6.2-37.2H448h16 32c44.2 0 80-35.8 80-80V88c0-13.3-10.7-24-24-24H496L478.1 46.1c-9-9-21.2-14.1-33.9-14.1H392L375.1 9.5c-4.5-6-11.5-9.5-19-9.5c-11.6 0-21.5 8.4-23.4 19.8l-26.8 161 114.6 48.3zM432 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]]
};
var faCarBattery = {
  prefix: 'fad',
  iconName: 'car-battery',
  icon: [512, 512, ["battery-car"], "f5df", ["M0 160c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm368 16c-8.8 0-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192c0-8.8-7.2-16-16-16zM96 224c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z", "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32H80zm224 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32H304z"]]
};
var faBatteryCar = faCarBattery;
var faFaceDowncastSweat = {
  prefix: 'fad',
  iconName: 'face-downcast-sweat',
  icon: [512, 512, [], "e371", ["M256 0c-51.4 0-99.3 15.2-139.4 41.2c1.5 3.1 3 6.2 4.3 9.3c3.4 8 7.1 19 7.1 30.5c0 44.3-36.6 79-80 79c-9.6 0-18.8-1.7-27.4-4.8C7.3 186.1 0 220.2 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM195.9 410.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7z", "M48 128C21.5 128 0 107 0 81C0 61 28.6 20.6 41.6 3.3c3.2-4.4 9.6-4.4 12.8 0C67.6 20.6 96 61 96 81c0 26-21.5 47-48 47zM96 272c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm192 0c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16z"]]
};
var faMailboxFlagUp = {
  prefix: 'fad',
  iconName: 'mailbox-flag-up',
  icon: [576, 512, [], "e5bb", ["M400 224c-8.8 0-16-7.2-16-16V96 64H144c79.5 0 144 64.5 144 144V384c0 35.3-28.7 64-64 64H512c35.3 0 64-28.7 64-64V208c0-56.5-32.6-105.5-80-129V96c0 8.8-7.2 16-16 16H416v96c0 8.8-7.2 16-16 16z", "M400 224c-8.8 0-16-7.2-16-16V96 48c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H416v96c0 8.8-7.2 16-16 16zM0 208C0 128.5 64.5 64 144 64s144 64.5 144 144V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208zm64 0c0 8.8 7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z"]]
};
var faMemoCircleInfo = {
  prefix: 'fad',
  iconName: 'memo-circle-info',
  icon: [576, 512, [], "e49a", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c3.3 0 6.6-.3 9.7-.7C285.1 479.3 256 427.1 256 368c0-80.6 54.1-148.5 128-169.4V64c0-35.3-28.7-64-64-64H64zM80 128H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-40 56c-8.8 0-16 7.2-16 16s7.2 16 16 16h0v48h0c-8.8 0-16 7.2-16 16s7.2 16 16 16h16 16c8.8 0 16-7.2 16-16s-7.2-16-16-16V368c0-8.8-7.2-16-16-16H416z"]]
};
var faGift = {
  prefix: 'fad',
  iconName: 'gift',
  icon: [512, 512, [127873], "f06b", ["M73.6 128c14.6 28.5 44.2 48 78.4 48h64 8v80H32c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H73.6zM480 256H288V176h72c34.2 0 63.8-19.5 78.4-48H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32zM32 288H224V512H80c-26.5 0-48-21.5-48-48V288zM288 512V288H480V464c0 26.5-21.5 48-48 48H288z", "M190.5 68.8L225.3 128H224h-8H152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88s39.4 88 88 88h64 8v80h64V176h72c48.6 0 88-39.4 88-88s-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5zm65.5-16.7C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40s-17.9 40-40 40H286.7l34.8-59.2zM288 512V288H224V512h64z"]]
};
var faDiceTwo = {
  prefix: 'fad',
  iconName: 'dice-two',
  icon: [448, 512, [9857], "f528", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faVolume = {
  prefix: 'fad',
  iconName: 'volume',
  icon: [576, 512, [128265, "volume-medium"], "f6a8", ["M471.3 110.5c8.4-10.3 23.5-11.8 33.8-3.5c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8zM410.8 185c8.4-10.3 23.5-11.8 33.8-3.5C466.1 199.1 480 225.9 480 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8z", "M352 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L163.8 160H96c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L298.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S352 460.6 352 448V64z"]]
};
var faVolumeMedium = faVolume;
var faTransporter5 = {
  prefix: 'fad',
  iconName: 'transporter-5',
  icon: [512, 512, [], "e2a6", ["M480 32L472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32zM64 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 160 6.6 167.3C2.7 168.4 0 171.9 0 176s2.7 7.6 6.6 8.7L32 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 160zM224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z", "M96 480c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z"]]
};
var faGaugeCircleBolt = {
  prefix: 'fad',
  iconName: 'gauge-circle-bolt',
  icon: [640, 512, [], "e496", ["M504 192.2c-2.6-.1-5.3-.2-8-.2c-97.2 0-176 78.8-176 176c0 45.9 17.6 87.7 46.4 119C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2zM256 416c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM368 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm194.5-66.2c2.8-5 1.7-11.1-2.6-14.9s-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H516.4l30.1-54.2z"]]
};
var faCoinFront = {
  prefix: 'fad',
  iconName: 'coin-front',
  icon: [512, 512, [], "e3fc", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm24-264c0-13.3-10.7-24-24-24s-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V184z", "M256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384z"]]
};
var faFileSlash = {
  prefix: 'fad',
  iconName: 'file-slash',
  icon: [640, 512, [], "e3a7", ["M0 448V96L384 398.5V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM384 275.7L38.8 5.1C46.6 1.8 55.1 0 64 0H224V128c0 17.7 14.3 32 32 32H384V275.7zM256 0L384 128H256V0z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faMessageArrowUpRight = {
  prefix: 'fad',
  iconName: 'message-arrow-up-right',
  icon: [512, 512, [], "e1dd", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm200 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24H200z", "M176 152c0-13.3 10.7-24 24-24H312c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.9l-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87H200c-13.3 0-24-10.7-24-24z"]]
};
var faTreasureChest = {
  prefix: 'fad',
  iconName: 'treasure-chest',
  icon: [576, 512, [], "f723", ["M96 36V256H0V160C0 100.4 40.8 50.2 96 36zM224 256H160V32H416V256H352V224c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v32zm256 0V36c55.2 14.2 96 64.3 96 124v96H480zM0 288H96V480H48c-26.5 0-48-21.5-48-48V288zM416 480H160V288h64v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288h64V480zm64 0V288h96V432c0 26.5-21.5 48-48 48H480z", "M160 32V256H96V36c10.2-2.6 21-4 32-4h32zM416 256V32h32c11 0 21.8 1.4 32 4V256H416zM224 224c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V224zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM160 480H96V288h64V480zm256 0V288h64V480H416z"]]
};
var faChessQueen = {
  prefix: 'fad',
  iconName: 'chess-queen',
  icon: [512, 512, [9819], "f445", ["M400 432H112L70.6 473.4c-4.2 4.2-6.6 10-6.6 16C64 501.9 74.1 512 86.6 512H425.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L400 432z", "M312 56A56 56 0 1 0 200 56a56 56 0 1 0 112 0zM164.3 120c-15.3 0-27 10.8-30.2 23.8c-7 27.8-32.2 48.3-62.1 48.3c-10.8 0-20.9-2.7-29.8-7.3c-8.4-4.4-19-4.5-27.7 .9C2.1 193.3-2.4 209.2 4.3 222.2L112.4 432H128h38.4H345.6 384h15.6L507.7 222.2c6.7-13 2.2-28.9-10.2-36.5c-8.7-5.4-19.3-5.4-27.7-.9c-8.9 4.7-19 7.3-29.8 7.3c-29.9 0-55.1-20.5-62.1-48.3c-3.3-13-15-23.8-30.2-23.8c-12.3 0-22.6 7.2-27.7 17c-12 23.2-36.2 39-64 39s-52-15.8-64-39c-5.1-9.8-15.4-17-27.7-17zM256 224l0 0 0 0s0 0 0 0z"]]
};
var faPaintbrushFine = {
  prefix: 'fad',
  iconName: 'paintbrush-fine',
  icon: [576, 512, ["paint-brush-alt", "paint-brush-fine", "paintbrush-alt"], "f5a9", ["M205 291.8l0 0 0 0c-9.2-2.5-19-3.8-29-3.8c-61.9 0-112 50.1-112 112c0 3.9 .2 7.8 .6 11.6C66.4 429.1 54.4 448 36.8 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H176c61.9 0 112-50.1 112-112c0-10-1.3-19.7-3.8-29l0 0 0 0c0-.1 0-.1-.1-.2l-78.9-78.9c-.1 0-.1 0-.2-.1z", "M559.6 95.6c21.9-21.9 21.9-57.3 0-79.2s-57.3-21.9-79.2 0L205.1 291.7l79.2 79.2L559.6 95.6z"]]
};
var faPaintBrushAlt = faPaintbrushFine;
var faPaintBrushFine = faPaintbrushFine;
var faPaintbrushAlt = faPaintbrushFine;
var faGlasses = {
  prefix: 'fad',
  iconName: 'glasses',
  icon: [576, 512, [], "f530", ["M223.4 314l-3.2 57.5c-1.9 33.9-29.9 60.5-63.9 60.5H112c-35.3 0-64-28.7-64-64V314.2c27.2-11.8 58.2-18.2 87.7-18.2c29.4 0 60.4 6.3 87.7 18zm129.2 0c27.3-11.7 58.3-18 87.7-18c29.5 0 60.5 6.4 87.7 18.2V368c0 35.3-28.7 64-64 64H419.7c-34 0-62-26.5-63.9-60.5L352.6 314z", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8c40.1 0 82.2 9.6 118.5 27.3c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.4 7.7-9.8 13.5-12.7c36.2-17.8 78.4-27.3 118.5-27.3c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2c.3 1.8 .5 3.7 .5 5.6v5.2c0 .5 0 1 0 1.5V352c0 .2 0 .4 0 .6V368c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM48 352v16c0 35.3 28.7 64 64 64h44.3c34 0 62-26.5 63.9-60.5l3.2-57.5c-27.3-11.7-58.3-18-87.7-18c-29.5 0-60.5 6.4-87.7 18.2V352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c1.9 33.9 29.9 60.5 63.9 60.5H464c35.3 0 64-28.7 64-64V314.2c-27.2-11.8-58.2-18.2-87.7-18.2z"]]
};
var faHoodCloak = {
  prefix: 'fad',
  iconName: 'hood-cloak',
  icon: [576, 512, [], "f6ef", ["M160 320c0-70.7 57.3-128 128-128s128 57.3 128 128V512H160V320z", "M432 0H288h0c-9.8 0-66 0-120.2 37.7C111.4 76.9 64 151.8 64 288c0 58.5-14.6 101.6-28.6 129.7c-7 14.1-14 24.5-19 31.1c-2.5 3.3-4.5 5.7-5.7 7.1c-.6 .7-1.1 1.2-1.3 1.4l-.2 .2c-9 9.1-11.7 22.8-6.8 34.7c5 12 16.6 19.8 29.6 19.8H160V320c0-70.7 57.3-128 128-128s128 57.3 128 128V512H544c12.9 0 24.6-7.8 29.6-19.8c4.9-11.9 2.2-25.6-6.8-34.7l0 0 0 0 0 0-.1-.1c-.2-.2-.7-.7-1.3-1.4c-1.3-1.4-3.2-3.8-5.7-7.1c-5-6.6-11.9-17-19-31.1C526.6 389.6 512 346.5 512 288c0-103.1-46.5-172.8-95.8-217.2l32-29c7.3-6.7 9.8-17.2 6.2-26.4S441.9 0 432 0z"]]
};
var faSquareQuote = {
  prefix: 'fad',
  iconName: 'square-quote',
  icon: [448, 512, [], "e329", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 128h48c17.7 0 32 14.3 32 32v24 24 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272H128c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm224 80v39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272H272c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24z", "M96 192c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272H128c-17.7 0-32-14.3-32-32V192zm256 87.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272H272c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24 39.3z"]]
};
var faUpLeft = {
  prefix: 'fad',
  iconName: 'up-left',
  icon: [384, 512, [], "e2bd", ["M238.6 206.6L372.7 340.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3l-41.4 41.4c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L142.6 302.6l96-96z", "M48 80H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-240 240c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V112c0-17.7 14.3-32 32-32z"]]
};
var faBringFront = {
  prefix: 'fad',
  iconName: 'bring-front',
  icon: [640, 512, [], "f857", ["M192 64H64V192h96v64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H192c35.3 0 64 28.7 64 64V96H224c-11.7 0-22.6 3.1-32 8.6V64zM384 416h32c11.7 0 22.6-3.1 32-8.6V448H576V320H480V256h96c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H448c-35.3 0-64-28.7-64-64V416z", "M224 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H224z"]]
};
var faChessBoard = {
  prefix: 'fad',
  iconName: 'chess-board',
  icon: [448, 512, [], "f43c", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 96V416H64V96H384z", "M192 96H128v64H64v64h64v64H64v64h64v64h64V352h64v64h64V352h64V288H320V224h64V160H320V96H256v64H192V96zm0 128H128V160h64v64zm64 0v64h64v64H256V288H192v64H128V288h64V224h64zm0 0V160h64v64H256z"]]
};
var faBurgerCheese = {
  prefix: 'fad',
  iconName: 'burger-cheese',
  icon: [512, 512, [127828, "cheeseburger"], "f7f1", ["M32 194.9C32 211 45 224 61.1 224H450.9c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zM128 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm240 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 400v16c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V400c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM234 262.7l68.2 45.5c10.7 7.2 24.8 7.2 35.5 0L406 262.7c6.5-4.4 14.2-6.7 22.1-6.7H211.9c7.9 0 15.6 2.3 22.1 6.7z", "M302.2 308.2L234 262.7c-6.5-4.4-14.2-6.7-22.1-6.7H208c0 0-.1 0-.1 0H64c-26.5 0-48 21.5-48 48s21.5 48 48 48H448c26.5 0 48-21.5 48-48s-21.5-48-48-48H432.1c0 0-.1 0-.1 0h-3.9c-7.9 0-15.6 2.3-22.1 6.7l-68.2 45.5c-10.7 7.2-24.8 7.2-35.5 0z"]]
};
var faCheeseburger = faBurgerCheese;
var faBuildingCircleCheck = {
  prefix: 'fad',
  iconName: 'building-circle-check',
  icon: [640, 512, [], "e4d2", ["M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faRepeat1 = {
  prefix: 'fad',
  iconName: 'repeat-1',
  icon: [512, 512, [128258], "f365", ["", "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160zM278 196.5c6.3 4.5 10 11.8 10 19.5v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3z"]]
};
var faArrowDownToLine = {
  prefix: 'fad',
  iconName: 'arrow-down-to-line',
  icon: [384, 512, ["arrow-to-bottom"], "f33d", ["M0 448c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z", "M169.4 342.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 242.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V242.7L86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"]]
};
var faArrowToBottom = faArrowDownToLine;
var faGrid5 = {
  prefix: 'fad',
  iconName: 'grid-5',
  icon: [448, 512, [], "e199", ["M96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V48zM16 128H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm0 192H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm96-96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM96 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V432zM208 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM192 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V336zM304 32h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM288 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V240zm16 176h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zm80-272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V144zm16 176h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z", "M0 48c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H16C7.2 96 0 88.8 0 80V48zM0 240c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V240zM16 416H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM96 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144zm16 176h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM192 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V48zm16 176h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM192 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V432zM304 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM288 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V336zM400 32h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM384 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V240zm16 176h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16z"]]
};
var faRightLongToLine = {
  prefix: 'fad',
  iconName: 'right-long-to-line',
  icon: [640, 512, [], "e444", ["M608 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32z", "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z"]]
};
var faPersonChalkboard = {
  prefix: 'fad',
  iconName: 'person-chalkboard',
  icon: [640, 512, [], "e53d", ["M144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L91.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h65.9H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H264V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H184z", "M384 128V64H576V256H384V192H320v80c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80h64z"]]
};
var faMarsStrokeRight = {
  prefix: 'fad',
  iconName: 'mars-stroke-right',
  icon: [640, 512, [9897, "mars-stroke-h"], "f22b", ["M128 256a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152H416V176c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32V176c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V280H464v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H382.4z"]]
};
var faMarsStrokeH = faMarsStrokeRight;
var faHandBackFist = {
  prefix: 'fad',
  iconName: 'hand-back-fist',
  icon: [448, 512, ["hand-rock"], "f255", ["M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z", ""]]
};
var faHandRock = faHandBackFist;
var faGridRound5 = {
  prefix: 'fad',
  iconName: 'grid-round-5',
  icon: [448, 512, [], "e5de", ["M160 64A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM32 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM448 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z", "M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm0 192A32 32 0 1 1 0 256a32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]]
};
var faTally = {
  prefix: 'fad',
  iconName: 'tally',
  icon: [640, 512, ["tally-5"], "f69c", ["M128 32c-17.7 0-32 14.3-32 32V296.9l64-21.3V64c0-17.7-14.3-32-32-32zM96 364.4V448c0 17.7 14.3 32 32 32s32-14.3 32-32V343.1L96 364.4zm128-42.7V448c0 17.7 14.3 32 32 32s32-14.3 32-32V300.4l-64 21.3zm128-42.7V448c0 17.7 14.3 32 32 32s32-14.3 32-32V257.7l-64 21.3zm64-88.8V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V211.6l64-21.3zm64 46.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V215.1l-64 21.3zm64-88.8V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V168.9l64-21.3zM288 232.9V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V254.3l64-21.3z", "M638.4 149.9c5.6 16.8-3.5 34.9-20.2 40.5l-576 192c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l576-192c16.8-5.6 34.9 3.5 40.5 20.2z"]]
};
var faTally5 = faTally;
var faSquareCaretUp = {
  prefix: 'fad',
  iconName: 'square-caret-up',
  icon: [448, 512, ["caret-square-up"], "f151", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z", "M241.6 167.7c-4.5-4.9-10.9-7.7-17.6-7.7s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9s12.5 14.4 22 14.4H328c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"]]
};
var faCaretSquareUp = faSquareCaretUp;
var faCloudShowersWater = {
  prefix: 'fad',
  iconName: 'cloud-showers-water',
  icon: [576, 512, [], "e4e4", ["M132.3 259.4c-11.4-6.8-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9zm336 0c-11.4-6.8-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9zM252.6 292.3c6.8-11.4 3.1-26.1-8.2-32.9s-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80zm103.8-32.9c-11.4-6.8-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z", "M311.2 55.7C295.9 22.8 262.6 0 224 0c-53 0-96 43-96 96c-35.3 0-64 28.7-64 64s28.7 64 64 64H448c35.3 0 64-28.7 64-64s-28.7-64-64-64h-1.6C439 59.5 406.7 32 368 32c-22.2 0-42.3 9.1-56.8 23.7z"]]
};
var faChartBar = {
  prefix: 'fad',
  iconName: 'chart-bar',
  icon: [512, 512, ["bar-chart"], "f080", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 96zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160z"]]
};
var faBarChart = faChartBar;
var faHandsBubbles = {
  prefix: 'fad',
  iconName: 'hands-bubbles',
  icon: [576, 512, ["hands-wash"], "e05e", ["M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM64 128c-17.7 0-32 14.4-32 32l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7v-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8L218.3 141.7c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l51.5-89.1c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5L149.9 116l0 0 0 0L96 209.3 96 160c0-17.7-14.4-32-32-32zm278.3 30.1c.9 1.4 1.7 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8L307.5 131c13.9 4.5 26.4 13.7 34.7 27zm36.2-5.9l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4H352h13.3l0 0H397l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM544 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM112 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352v8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H352l0 0 0 0H258.8L305 219.1c15-9.4 19.5-29.1 10.2-44.1z"]]
};
var faHandsWash = faHandsBubbles;
var faLessThanEqual = {
  prefix: 'fad',
  iconName: 'less-than-equal',
  icon: [448, 512, [], "f537", ["M413.7 52.1c6.6 16.4-1.4 35-17.8 41.6L150.2 192l245.7 98.3c16.4 6.6 24.4 25.2 17.8 41.6s-25.2 24.4-41.6 17.8l-320-128C40 216.9 32 205.1 32 192s8-24.9 20.1-29.7l320-128c16.4-6.6 35 1.4 41.6 17.8z", "M0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
};
var faTrain = {
  prefix: 'fad',
  iconName: 'train',
  icon: [448, 512, [128646], "f238", ["M96 64C78.3 64 64 78.3 64 96v96c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96zM35.1 492.9C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H96c-5.1 0-10-.4-14.9-1.1l-46 46zm307.5 9.7c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c-4.8 .8-9.8 1.1-14.9 1.1H288l54.6 54.6z", "M0 96C0 43 43 0 96 0H352c53 0 96 43 96 96V352c0 53-43 96-96 96H96c-53 0-96-43-96-96V96zm64 0v96c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96C78.3 64 64 78.3 64 96zM224 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
};
var faUpFromDottedLine = {
  prefix: 'fad',
  iconName: 'up-from-dotted-line',
  icon: [448, 512, [], "e456", ["M0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm96 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M196.7 43.3L73.9 166.1c-6.4 6.4-9.9 15-9.9 24C64 208.8 79.2 224 97.9 224H160V352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224h62.1c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24L251.3 43.3C244.1 36.1 234.2 32 224 32s-20.1 4.1-27.3 11.3z"]]
};
var faEyeLowVision = {
  prefix: 'fad',
  iconName: 'eye-low-vision',
  icon: [640, 512, ["low-vision"], "f2a8", ["M605.5 268.3c-13.4 32.3-40.3 77.8-79.9 118.4l-79.1-62C457.7 304.3 464 280.9 464 256c0-79.5-64.5-144-144-144c-37.3 0-71.4 14.2-96.9 37.5L150.7 92.8C195 58.3 251.8 32 320 32c80.8 0 145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6zM416 256c0 13.7-2.9 26.7-8 38.5l-94.6-74.1c4.2-8.5 6.6-18.2 6.6-28.3c0-11.5-3-22.3-8.4-31.6c2.8-.2 5.5-.4 8.4-.4c53 0 96 43 96 96z", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L38.8 5.1zM33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8zM393.6 469.4c18.7-5.5 36.2-13 52.6-21.8L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7z"]]
};
var faLowVision = faEyeLowVision;
var faTrafficLightGo = {
  prefix: 'fad',
  iconName: 'traffic-light-go',
  icon: [320, 512, [], "f638", ["M160 320a48 48 0 1 1 0 96 48 48 0 1 1 0-96z", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]]
};
var faFaceExhaling = {
  prefix: 'fad',
  iconName: 'face-exhaling',
  icon: [576, 512, [], "e480", ["M256 512c55.8 0 107.4-17.9 149.5-48.2c-10.5-9.3-17.9-22.1-20.5-36.5l-42.2-12.7C329.3 410.6 320 398.1 320 384s9.3-26.6 22.8-30.6L385 340.7c5.3-30 31.5-52.7 63-52.7c.7 0 1.4 0 2.1 0c13.2-14.7 32.3-24 53.7-24c2.7 0 5.4 .2 8.1 .5c.1-2.8 .1-5.6 .1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM195.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm121.6 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM256 344a40 40 0 1 1 0 80 40 40 0 1 1 0-80z", "M543.5 336c0 .8 0 1.7-.1 2.5c19 6.4 32.6 24.4 32.6 45.5s-13.6 39.1-32.6 45.5c.1 .8 .1 1.7 .1 2.5c0 22.1-17.9 40-39.9 40c-14.2 0-26.6-7.4-33.7-18.5c-4.4 1.6-9.1 2.5-14 2.5c-22.1 0-39.9-17.9-39.9-40c0-2.7 .3-5.3 .8-7.8l-56.9-14.2c-4.6-1.1-7.8-5.2-7.8-9.9s3.2-8.8 7.8-9.9L415.9 360c0-22.1 17.9-40 39.9-40c3.6 0 7.2 .5 10.5 1.4c5.8-14.9 20.3-25.4 37.2-25.4c22.1 0 39.9 17.9 39.9 40z"]]
};
var faSensorFire = {
  prefix: 'fad',
  iconName: 'sensor-fire',
  icon: [640, 512, [], "e02a", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v32.2c-12.6-1.2-25.5 2.7-35.5 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1c0 49.3 18.6 95.2 49.6 129.9H64c-35.3 0-64-28.7-64-64V96zm88 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24z", "M433.8 163.6c5.6-5 14.2-5 19.8 0c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 56.7 24.2 76.9c0 87.8-71.3 161.9-160 161.9c-89.7 0-160-74.2-160-161.9c0-26.4 12.7-58.6 32.4-90.6c20-32.4 48.1-66.1 81.4-95.8zM481 447.9c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z"]]
};
var faUserUnlock = {
  prefix: 'fad',
  iconName: 'user-unlock',
  icon: [640, 512, [], "e058", ["M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3V480c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3z", "M528 240c-17.7 0-32 14.3-32 32v48h16 48 48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272c0-44.2 35.8-80 80-80s80 35.8 80 80H560c0-17.7-14.3-32-32-32z"]]
};
var faHexagonDivide = {
  prefix: 'fad',
  iconName: 'hexagon-divide',
  icon: [512, 512, [], "e1ad", ["M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H168zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M224 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 96c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24zm112 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var fa00 = {
  prefix: 'fad',
  iconName: '00',
  icon: [640, 512, [], "e467", ["M352 176c0-79.5 64.5-144 144-144s144 64.5 144 144V336c0 79.5-64.5 144-144 144s-144-64.5-144-144V176zM496 96c-44.2 0-80 35.8-80 80V336c0 44.2 35.8 80 80 80s80-35.8 80-80V176c0-44.2-35.8-80-80-80z", "M0 176C0 96.5 64.5 32 144 32s144 64.5 144 144V336c0 79.5-64.5 144-144 144S0 415.5 0 336V176zM144 96c-44.2 0-80 35.8-80 80V336c0 44.2 35.8 80 80 80s80-35.8 80-80V176c0-44.2-35.8-80-80-80z"]]
};
var faCrow = {
  prefix: 'fad',
  iconName: 'crow',
  icon: [640, 512, [], "f520", ["M544 120V88c0-21.3-7.5-40.8-20.1-56H574c29.4 0 55 20 62.1 48.5L640 96l-96 24zM355.2 384c16.9-.3 33.4-2.8 49-7.1l42 102c5 12.3-.8 26.3-13.1 31.3s-26.3-.8-31.3-13.1L355.2 384zm-96 0h51.9l39.1 94.9c5 12.3-.8 26.3-13.1 31.3s-26.3-.8-31.3-13.1L259.2 384z", "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384H352c106 0 192-86 192-192V128 88c0-48.6-39.4-88-88-88zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faCassetteBetamax = {
  prefix: 'fad',
  iconName: 'cassette-betamax',
  icon: [576, 512, ["betamax"], "f8a4", ["M0 160H576V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zM256 320A96 96 0 1 0 64 320a96 96 0 1 0 192 0zm96-96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H352z", "M64 32C28.7 32 0 60.7 0 96v64H576V96c0-35.3-28.7-64-64-64H64zM192 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-96a96 96 0 1 0 0 192 96 96 0 1 0 0-192z"]]
};
var faBetamax = faCassetteBetamax;
var faSailboat = {
  prefix: 'fad',
  iconName: 'sailboat',
  icon: [576, 512, [], "e445", ["M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6H272c-8.8 0-16-7.2-16-16V16zm-32 96V336c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5s11.9 8.2 11.9 15.5z", "M5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"]]
};
var faWindowRestore = {
  prefix: 'fad',
  iconName: 'window-restore',
  icon: [512, 512, [], "f2d2", ["M208 64H432c8.8 0 16 7.2 16 16V304c0 8.8-7.2 16-16 16H416v64h16c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H208c-44.2 0-80 35.8-80 80V96h64V80c0-8.8 7.2-16 16-16z", "M64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]]
};
var faNfcMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'nfc-magnifying-glass',
  icon: [640, 512, [], "e1f9", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c8.7 0 17-1.7 24.6-4.9c-35.9-9.1-67-30.3-88.6-59.1H112c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H301.3c-8.6-19.6-13.3-41.2-13.3-64c0-52.3 25.1-98.8 64-128V144c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16v66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-26.5 21.5-48 48-48h80c26.5 0 48 21.5 48 48v29.3c19.6-8.6 41.2-13.3 64-13.3V96c0-35.3-28.7-64-64-64H64z", "M528 320.1a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM519.9 426c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426z"]]
};
var faFileBinary = {
  prefix: 'fad',
  iconName: 'file-binary',
  icon: [384, 512, [], "e175", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H112zM96 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V304zm144-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v96H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h32 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V272c0-8.8-7.2-16-16-16H240z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM112 256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H112zM96 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V304zm144-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v96H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h32 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V272c0-8.8-7.2-16-16-16H240z"]]
};
var faCircleV = {
  prefix: 'fad',
  iconName: 'circle-v',
  icon: [512, 512, [], "e12a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM173.5 157.3L256 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z", "M141.3 146.5c11.9-5.9 26.3-1.1 32.2 10.7L256 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2z"]]
};
var faSquarePlus = {
  prefix: 'fad',
  iconName: 'square-plus',
  icon: [448, 512, [61846, "plus-square"], "f0fe", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M200 280v64c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faPlusSquare = faSquarePlus;
var faBowlScoops = {
  prefix: 'fad',
  iconName: 'bowl-scoops',
  icon: [448, 512, [127813], "e3df", ["M242.3 146.6C230.7 164.2 224 185.3 224 208c0 17.2 3.9 33.5 10.8 48H437.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112l-1.1 0c-38.7 .4-72.7 20.4-92.6 50.6zM10.8 256H200.2c-5.3-15-8.2-31.2-8.2-48c0-22 4.9-42.8 13.7-61.4c-19.8-30.2-53.8-50.2-92.6-50.6L112 96C50.1 96 0 146.1 0 208c0 17.2 3.9 33.5 10.8 48zM224 0c-44.8 0-83.5 26.3-101.4 64.4c40.9 3 77.1 23 101.4 53.1c24.3-30.1 60.5-50.1 101.4-53.1C307.5 26.3 268.8 0 224 0z", "M4 261.4c3-3.4 7.4-5.4 12-5.4H432c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9C436.9 361.9 375.6 416 303 416H262.6l68.7 68.7c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H128c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L185.4 416H145C72.4 416 11.1 361.9 2.1 289.9L.1 274c-.6-4.6 .8-9.1 3.9-12.6z"]]
};
var faMistletoe = {
  prefix: 'fad',
  iconName: 'mistletoe',
  icon: [576, 512, [], "f7b4", ["M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v94.1l-98 98L91.3 230.4C38.3 240.6 0 287 0 341c0 41.4 33.6 75 75 75c50.5 0 94.3-33.5 108.1-81.2c-4.5-6.5-7.1-14.3-7.1-22.8c0-14.2 7.4-26.6 18.5-33.7l5.4-28.2L264 185.9v72.4c14.7 13.2 24 32.3 24 53.7c0 39.8-32.2 72-72 72c-7.2 0-14.2-1.1-20.8-3c-2.1 8.4-3.2 17.1-3.2 25.9V416c0 53 43 96 96 96s96-43 96-96v-9.1c0-25.1-9-49.4-25.3-68.4L312 284V185.9L376.1 250l14.4 74.7C400.6 377.7 447 416 501 416c41.4 0 75-33.6 75-75c0-54-38.3-100.3-91.3-110.5L410 216.1l-98-98V24z", "M376 112a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM216 352a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]]
};
var faCustard = {
  prefix: 'fad',
  iconName: 'custard',
  icon: [576, 512, [127854], "e403", ["M476.7 193.3C453.9 184.9 424 176 400 176c-22.7 0-39.4 8-56 16s-33.3 16-56 16s-39.4-8-56-16s-33.3-16-56-16c-24 0-53.9 8.9-76.7 17.3l-35 157.5L512 352 476.7 193.3z", "M396.7 64H179.3c-30 0-56 20.8-62.5 50.1L99.3 193.3C122.1 184.9 152 176 176 176c22.7 0 39.4 8 56 16s33.3 16 56 16s39.4-8 56-16s33.3-16 56-16c24 0 53.9 8.9 76.7 17.3l-17.6-79.2C452.6 84.8 426.7 64 396.7 64zM32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faLacrosseStick = {
  prefix: 'fad',
  iconName: 'lacrosse-stick',
  icon: [512, 512, [], "e3b5", ["M145.4 321.4l-136 136c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l136-136c-18.7-11-34.3-26.6-45.3-45.3z", "M264.8 117.7l-3.3 11.5c-5.6 19.6-15.1 37.9-27.8 53.9L205.8 218c-8.9 11.1-13.8 25-13.8 39.2c0 34.7 28.1 62.8 62.8 62.8c14.3 0 28.1-4.9 39.2-13.8l34.9-27.9c15.9-12.8 34.3-22.2 53.9-27.8l11.5-3.3c31.8-9.1 53.7-38.1 53.7-71.2h0c0-.1 0-.2 0-.3c0-19.9-13.6-48.1-38.6-73.1s-53.2-38.6-73.1-38.6c-.1 0-.2 0-.3 0v0c-33.1 0-62.1 21.9-71.2 53.7zM512 176h0c0 61.6-40.9 115.8-100.1 132.7L400.3 312c-11.5 3.3-22.2 8.8-31.5 16.2l-34.9 27.9c-22.5 18-50.4 27.8-79.2 27.8c-70 0-126.8-56.8-126.8-126.8c0-28.8 9.8-56.7 27.8-79.2l27.9-34.9c7.4-9.3 13-20 16.2-31.5l3.3-11.5C220.2 40.9 274.4 0 336 0V0c.1 0 .2 0 .3 0c43.8 0 87.4 26.4 118.4 57.3s57.3 74.5 57.3 118.4c0 .1 0 .2 0 .3z"]]
};
var faHockeyMask = {
  prefix: 'fad',
  iconName: 'hockey-mask',
  icon: [448, 512, [], "f6ee", ["M0 240C0 111 64 0 224 0S448 111 448 240c0 192-48 272-224 272S0 432 0 240zM160 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 272c35.3 0 64-28.7 64-64c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64zm256-64c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64s64-28.7 64-64z", "M136 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM152 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm0 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faSunrise = {
  prefix: 'fad',
  iconName: 'sunrise',
  icon: [576, 512, [127749], "f766", ["M403.1 237.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L288 289.1l-90.3-62.3c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L153 345 45.1 364.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L86.1 464H161c7.9-63.1 61.7-112 127-112s119.1 48.9 127 112h74.9l51.3-74.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L423 345 403.1 237.1zM382.7 464c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H382.7z", "M354.5 135.7L320 104.3V208c0 17.7-14.3 32-32 32s-32-14.3-32-32V104.3l-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zM24 464H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faPanelEws = {
  prefix: 'fad',
  iconName: 'panel-ews',
  icon: [512, 512, [], "e42e", ["M64 0C28.7 0 0 28.7 0 64V288H16c44.2 0 80 35.8 80 80v16c0 17.7 14.3 32 32 32s32-14.3 32-32V352c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V368c0-26.5-21.5-48-48-48H0V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm48 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 128h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 128h64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32z", "M128 288c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V368c0-26.5-21.5-48-48-48H0V288H16c44.2 0 80 35.8 80 80v16c0 17.7 14.3 32 32 32s32-14.3 32-32V352c-17.7 0-32-14.3-32-32V288zm192-32h64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32z"]]
};
var faToriiGate = {
  prefix: 'fad',
  iconName: 'torii-gate',
  icon: [512, 512, [9961], "f6a1", ["M64 128h64v96H64V128zm160 0h64v96H224V128zm160 0h64v96H384V128zM64 480V256h64V480c0 17.7-14.3 32-32 32s-32-14.3-32-32zm320 0V256h64V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z", "M0 13.4V80c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V13.4C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32H126.8c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faCloudExclamation = {
  prefix: 'fad',
  iconName: 'cloud-exclamation',
  icon: [640, 512, [], "e491", ["M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM320 160c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faMessageLines = {
  prefix: 'fad',
  iconName: 'message-lines',
  icon: [512, 512, ["comment-alt-lines"], "f4a6", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm152 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z", "M128 168c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z"]]
};
var faCommentAltLines = faMessageLines;
var faFrog = {
  prefix: 'fad',
  iconName: 'frog',
  icon: [576, 512, [], "f52e", ["M447.7 104.5c.2 2.5 .3 5 .3 7.5c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5 .5-9.8 1.3-14.5C127 112.9 0 249.6 0 416c0 35.3 28.7 64 64 64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H261.8l37.1-37.1c3.4-3.4 6.4-7.1 9-10.9c18.7-28 15.7-66.2-9-90.9c-24.6-24.6-62.6-27.7-90.5-9.2c-4 2.6-7.8 5.7-11.3 9.2l-.1 .1-.1 .1L123 347.6c-6.4 6.1-16.5 5.8-22.6-.6s-5.8-16.5 .6-22.6l73.6-70.1c40.6-40.5 106.4-40.4 146.9 .1c28.6 28.6 37.1 69.7 25.4 105.7L457.4 470.6c6 6 14.1 9.4 22.6 9.4h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H493.3l-92.5-92.5 144.5-82.1c18.9-10.8 30.7-30.9 30.7-52.7c0-26.6-17.3-50.1-42.8-57.9l-85.6-26.3z", "M368 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-104a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faBucket = {
  prefix: 'fad',
  iconName: 'bucket',
  icon: [448, 512, [], "e4cf", ["M200 48C142.6 48 96 94.6 96 152v40H48V152C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v40H352V152c0-57.4-46.6-104-104-104H200z", "M32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32h5.1L59.5 469c2.6 24.4 23.2 43 47.7 43H340.8c24.6 0 45.2-18.5 47.7-43l22.4-213H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faFloppyDiskPen = {
  prefix: 'fad',
  iconName: 'floppy-disk-pen',
  icon: [576, 512, [], "e182", ["M0 96C0 60.7 28.7 32 64 32H306.7c17 0 33.3 6.7 45.3 18.7L429.3 128c12 12 18.7 28.3 18.7 45.3v62.4L289.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-14 55.9H64c-35.3 0-64-28.7-64-64V96zm96 0c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96zM288 352a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z", "M493.2 235.8l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L311.9 417.1c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 358.8l-71-71z"]]
};
var faImage = {
  prefix: 'fad',
  iconName: 'image',
  icon: [512, 512, [], "f03e", ["M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176z"]]
};
var faWindowFrame = {
  prefix: 'fad',
  iconName: 'window-frame',
  icon: [512, 512, [129695], "e04f", ["M232 288V448H96V288H232zM96 224V64H232V224H96zM280 64H416V224H280V64zM416 288V448H280V288H416z", "M32 256V64C32 28.7 60.7 0 96 0H416c35.3 0 64 28.7 64 64V256 448c17.7 0 32 14.3 32 32s-14.3 32-32 32H416 96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V256zm384 32H280V448H416V288zm-184 0H96V448H232V288zm48-64H416V64H280V224zM232 64H96V224H232V64z"]]
};
var faMicrophone = {
  prefix: 'fad',
  iconName: 'microphone',
  icon: [384, 512, [], "f130", ["M40 192c13.3 0 24 10.7 24 24v40c0 70.7 57.3 128 128 128s128-57.3 128-128V216c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 89.1-66.2 162.7-152 174.4V464h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H192 120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V430.4C82.2 418.7 16 345.1 16 256V216c0-13.3 10.7-24 24-24z", "M96 96c0-53 43-96 96-96s96 43 96 96V256c0 53-43 96-96 96s-96-43-96-96V96z"]]
};
var faCow = {
  prefix: 'fad',
  iconName: 'cow',
  icon: [640, 512, [128004], "f6c8", ["M64 224h8v38.4C72 294.2 46.2 320 14.4 320C6.4 320 0 313.6 0 305.6V288c0-35.3 28.7-64 64-64zM192 327.8c.1-30.8 25.2-55.8 56-55.8h48c30.8 0 55.9 24.9 56 55.8c-9.9 6.6-20.6 12-32 16.1V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V351.1c-5.3 .6-10.6 .9-16 .9s-10.7-.3-16-.9V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V343.8c-11.4-4-22.1-9.4-32-16.1z", "M72 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160v64 32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V328v-.2s0 0 0 0c.1-30.8 25.2-55.8 56-55.8h48c30.8 0 55.9 24.9 56 55.8c0 0 0 0 0 0v.2 88c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H272 256 192 144C77.7 64 24 117.7 24 184v54c11-8.8 24.9-14 40-14h8V184zM576 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM190.1 190.1l-23.4-23.4c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H361.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9z"]]
};
var faFileZip = {
  prefix: 'fad',
  iconName: 'file-zip',
  icon: [512, 512, [], "e5ee", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H240c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM240 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h38.1L225.7 488.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H265.9l52.4-104.8c2.5-5 2.2-10.9-.7-15.6s-8.1-7.6-13.6-7.6H240zm144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V368zm32 0v80 48c0 8.8 7.2 16 16 16s16-7.2 16-16V464h8c30.9 0 56-25.1 56-56s-25.1-56-56-56H432c-8.8 0-16 7.2-16 16zm32 64V384h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8z"]]
};
var faSquareRing = {
  prefix: 'fad',
  iconName: 'square-ring',
  icon: [448, 512, [], "e44f", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z", "M224 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm160 96A160 160 0 1 1 64 256a160 160 0 1 1 320 0z"]]
};
var faDownFromLine = {
  prefix: 'fad',
  iconName: 'down-from-line',
  icon: [384, 512, ["arrow-alt-from-top"], "f349", ["M0 64C0 81.7 14.3 96 32 96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64z", "M164.7 468.7L41.9 345.9c-6.4-6.4-9.9-15-9.9-24C32 303.2 47.2 288 65.9 288H128V160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V288h62.1c18.7 0 33.9 15.2 33.9 33.9c0 9-3.6 17.6-9.9 24L219.3 468.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3z"]]
};
var faArrowAltFromTop = faDownFromLine;
var faCaretUp = {
  prefix: 'fad',
  iconName: 'caret-up',
  icon: [320, 512, [], "f0d8", ["M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z", ""]]
};
var faShieldXmark = {
  prefix: 'fad',
  iconName: 'shield-xmark',
  icon: [512, 512, ["shield-times"], "e24c", ["M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z", "M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faShieldTimes = faShieldXmark;
var faScrewdriver = {
  prefix: 'fad',
  iconName: 'screwdriver',
  icon: [512, 512, [129691], "f54a", ["M433.4 5C442.9-2.4 456.4-1.5 465 7l40 40c8.5 8.5 9.4 22 2.1 31.6l-80 104c-4.5 5.9-11.6 9.4-19 9.4H353.9l-109 109c-3.6-7.1-8.4-13.7-14.3-19.7s-12.6-10.7-19.7-14.3l109-109V104c0-7.5 3.5-14.5 9.4-19l104-80z", "M230.6 281.4c-30.2-30.2-79.1-30.2-109.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3z"]]
};
var faCircleSortDown = {
  prefix: 'fad',
  iconName: 'circle-sort-down',
  icon: [512, 512, ["sort-circle-down"], "e031", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H352c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zM244.7 411.3c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96z", "M267.3 411.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9H352c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96z"]]
};
var faSortCircleDown = faCircleSortDown;
var faFolderClosed = {
  prefix: 'fad',
  iconName: 'folder-closed',
  icon: [512, 512, [], "e185", ["M0 192H512V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96v96z", "M0 192L0 416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192H0z"]]
};
var faHouseTsunami = {
  prefix: 'fad',
  iconName: 'house-tsunami',
  icon: [576, 512, [], "e515", ["M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1c0 0 .1 0 .1 0c31.9 0 60.5-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 325.4 219.5 336 192 336l0 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z", "M332.8 118.4c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72z"]]
};
var faSquareNfi = {
  prefix: 'fad',
  iconName: 'square-nfi',
  icon: [448, 512, [], "e576", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z", "M93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2S64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8zM240 160c-8.8 0-16 7.2-16 16v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240zm144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"]]
};
var faForklift = {
  prefix: 'fad',
  iconName: 'forklift',
  icon: [640, 512, [], "f47a", ["M544 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V32zM160 432A80 80 0 1 0 0 432a80 80 0 1 0 160 0zm256 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z", "M160 160l96 96h94L281.4 64H160v96zm-64 0V48c0-26.5 21.5-48 48-48H292.7c20.3 0 38.4 12.8 45.2 31.9l75.3 210.8c1.8 5.2 2.8 10.6 2.8 16.1v94.8c-20.3-20.7-48.7-33.6-80-33.6c-56.4 0-103.1 41.7-110.9 96H190.9c-7.8-54.3-54.4-96-110.9-96c-31.3 0-59.7 12.9-80 33.6V208c0-26.5 21.5-48 48-48H96z"]]
};
var faArrowUpFromGroundWater = {
  prefix: 'fad',
  iconName: 'arrow-up-from-ground-water',
  icon: [576, 512, [], "e4b5", ["M48 192H192V416.5c-19 0-41.2-7.9-59.1-20.3c-23.8-16.7-55.8-15.3-78.1 3.4c-10.6 8.8-24.2 15.6-37.3 18.6C11.2 419.6 5.3 421.9 0 425V240c0-26.5 21.5-48 48-48zM576 425c-5.3-3.1-11.2-5.4-17.5-6.9c-13.1-3.1-26.7-9.8-37.3-18.6c-22.2-18.7-54.3-20.1-78.1-3.4c-18 12.4-40.1 20.3-59.2 20.3c0 0 0 0 0 0V192H528c26.5 0 48 21.5 48 48V425z", "M320 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l80-80c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L320 109.3V320zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]]
};
var faBracketSquareRight = {
  prefix: 'fad',
  iconName: 'bracket-square-right',
  icon: [192, 512, [], "5d", ["M192 96c0-35.3-28.7-64-64-64H64C46.3 32 32 46.3 32 64s14.3 32 32 32h64V416H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c35.3 0 64-28.7 64-64V96z", ""]]
};
var faMartiniGlass = {
  prefix: 'fad',
  iconName: 'martini-glass',
  icon: [512, 512, [127864, "glass-martini-alt"], "f57b", ["M2.4 19.8C7.4 7.8 19.1 0 32 0H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L288 269.3V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H256 160c-17.7 0-32-14.3-32-32s14.3-32 32-32h64V269.3L9.4 54.6C.2 45.5-2.5 31.7 2.4 19.8zM256 210.7L402.7 64H109.3L256 210.7z", "M338.7 128L256 210.7 173.3 128H338.7z"]]
};
var faGlassMartiniAlt = faMartiniGlass;
var faRotateLeft = {
  prefix: 'fad',
  iconName: 'rotate-left',
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", ["M98.6 96.6l45.3 45.3c62.6-61.5 163.1-61.2 225.3 1c62.5 62.5 62.5 163.8 0 226.3s-163.8 62.5-226.3 0c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c87.5 87.5 229.3 87.5 316.8 0s87.5-229.3 0-316.8c-87.2-87.2-228.3-87.5-315.8-1z", "M168 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"]]
};
var faRotateBack = faRotateLeft;
var faRotateBackward = faRotateLeft;
var faUndoAlt = faRotateLeft;
var faTableColumns = {
  prefix: 'fad',
  iconName: 'table-columns',
  icon: [512, 512, ["columns"], "f0db", ["M224 160h64V416H224V160z", "M64 160l0 256H448V160L64 160zm0 320c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64L64 480z"]]
};
var faColumns = faTableColumns;
var faSquareA = {
  prefix: 'fad',
  iconName: 'square-a',
  icon: [448, 512, [], "e25f", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 336H158.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L182.8 288h82.3L224 205.7z", "M245.5 141.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-104 208c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L158.8 336H289.2l17.4 34.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-104-208zM265.2 288H182.8L224 205.7 265.2 288z"]]
};
var faTick = {
  prefix: 'fad',
  iconName: 'tick',
  icon: [128, 512, [], "e32f", ["M0 98.3V96C0 60.7 28.7 32 64 32s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L101.5 256.5C98.3 274.7 82.5 288 64 288s-34.3-13.3-37.5-31.5L1 109.6c-.7-3.8-1-7.5-1-11.4z", ""]]
};
var faLemon = {
  prefix: 'fad',
  iconName: 'lemon',
  icon: [448, 512, [127819], "f094", ["M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z", "M223.4 107.5c2.5 8.5-2.4 17.4-10.9 19.9c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9z"]]
};
var faHeadSideMask = {
  prefix: 'fad',
  iconName: 'head-side-mask',
  icon: [576, 512, [], "e063", ["M39.7 165.7c-5 18.7-7.7 38.3-7.7 58.5c0 49.9 16.6 98.2 46.9 137.3c10.2 13.2 17.1 29 17.1 45.8V480c0 17.7 14.3 32 32 32H272V338.2L39.7 165.7zm18.2-46.3L284.9 288H544v.2c0-.1 0-.1 0-.2c0-10-3.4-19.6-9.6-27.4l-44.8-65.7c-6.5-9.6-10-20.7-11.9-32.2C462.8 70.6 376.1 0 280 0H256C170.1 0 95.5 48.4 57.9 119.4zM352 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M20.7 121.7c7.9-10.6 22.9-12.9 33.6-5L284.9 288H544v21.6c0 6.9-1.1 13.7-3.3 20.2L528 368H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H517.3l-10.7 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496l-1.4 4.2c-8.7 26.1-33.2 43.8-60.7 43.8H272V338.2L25.7 155.3c-10.6-7.9-12.9-22.9-5-33.6z"]]
};
var faHandshake = {
  prefix: 'fad',
  iconName: 'handshake',
  icon: [640, 512, [], "f2b5", ["M512 352V128h-1.5l-71-47.3C423.2 69.8 404.1 64 384.5 64c-20.7 0-40.9 6.5-57.7 18.5l-98.6 70.4c-21.6 15.4-26.6 45.4-11.2 67s45.4 26.6 67 11.2l57.2-40.8L496.4 332.6c6 5.5 10.3 12.2 12.8 19.4H512zm32 0c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544V352zm48-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z", "M156.2 352H128V128l72-48c15.6-10.4 34-16 52.8-16c22.7 0 44.7 8.1 61.9 22.9l2.7 2.3-89.3 63.8c-21.6 15.4-26.6 45.4-11.2 67s45.4 26.6 67 11.2l57.2-40.8 13.1 12L496.4 332.6c5.5 5 9.6 11.1 12.1 17.5c6.6 16.6 3.7 36.2-9.2 50.3c-17.9 19.5-48.3 20.9-67.8 2.9l-7.8-7.1c-.9 10.1-5 20.1-12.4 28.2c-17.9 19.5-48.3 20.9-67.8 2.9l-17-15.6c-1.9 7.4-5.6 14.5-11.1 20.6c-17.9 19.6-48.2 21-67.8 3.1L156.2 352zM0 144c0-8.8 7.2-16 16-16H96V352c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V144zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
};
var faGem = {
  prefix: 'fad',
  iconName: 'gem',
  icon: [512, 512, [128142], "f3a5", ["M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z", "M165.9 74.6c-2.8-3-7.4-3.4-10.7-1s-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6z"]]
};
var faDolly = {
  prefix: 'fad',
  iconName: 'dolly',
  icon: [576, 512, ["dolly-box"], "f472", ["M244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5zM256 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M0 32C0 14.3 14.3 0 32 0h72.9c27.5 0 52 17.6 60.7 43.8L257.7 320c-.6 0-1.2 0-1.7 0c-22.2 0-42.7 7.6-59 20.2L104.9 64H32C14.3 64 0 49.7 0 32zM352 416c0-22.2-7.6-42.7-20.2-59l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c0-.6 0-1.2 0-1.7zM371.8 59.6l19.8 60.9-60.9 19.8L311 79.4l60.9-19.8z"]]
};
var faDollyBox = faDolly;
var faSmoking = {
  prefix: 'fad',
  iconName: 'smoking',
  icon: [640, 512, [128684], "f48d", ["M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11z", "M64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H416c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H64zm160 64H384v32H224V416zm320-32c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384zm96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384z"]]
};
var faMinimize = {
  prefix: 'fad',
  iconName: 'minimize',
  icon: [512, 512, ["compress-arrows-alt"], "f78c", ["M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zM56 288H200c13.3 0 24 10.7 24 24V456c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z", "M56 224H200c13.3 0 24-10.7 24-24V56c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L143 79 69.7 5.7C66 2 61.1 0 56 0S46 2 42.3 5.7L5.7 42.3C2 46 0 50.9 0 56s2 10 5.7 13.7L79 143 39 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8zm400 64H312c-13.3 0-24 10.7-24 24V456c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 73.4 73.4c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l36.7-36.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L433 369l40-40c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8z"]]
};
var faCompressArrowsAlt = faMinimize;
var faRefrigerator = {
  prefix: 'fad',
  iconName: 'refrigerator',
  icon: [384, 512, [], "e026", ["M288 160H0v32H288V160zm96 0H320v32h64V160z", "M96 0C43 0 0 43 0 96v64H288V112c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V96c0-53-43-96-96-96H96zM384 192H320V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H0V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V192z"]]
};
var faMonument = {
  prefix: 'fad',
  iconName: 'monument',
  icon: [384, 512, [], "f5a6", ["M0 480c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M203.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-2.5 2.5-4.1 5.8-4.6 9.3L51.9 448H332.1L287.9 94c-.4-3.5-2-6.8-4.6-9.3l-80-80zM128 296c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z"]]
};
var faOctagonXmark = {
  prefix: 'fad',
  iconName: 'octagon-xmark',
  icon: [512, 512, ["times-octagon", "xmark-octagon"], "f2f0", ["M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z", "M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faTimesOctagon = faOctagonXmark;
var faXmarkOctagon = faOctagonXmark;
var faAlignSlash = {
  prefix: 'fad',
  iconName: 'align-slash',
  icon: [640, 512, [], "f846", ["M406.2 416l81.2 64H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H406.2zM243.7 288l81.2 64H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H243.7zm-143-112.7L162.5 224H128c-17.7 0-32-14.3-32-32c0-6.1 1.7-11.8 4.7-16.7zM399.7 288H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H481.4l-81.7-64zM236.4 160H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H318.1l-81.7-64zM512 96H154.8L98.4 51.8C103.2 40.2 114.6 32 128 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faSnowplow = {
  prefix: 'fad',
  iconName: 'snowplow',
  icon: [640, 512, [], "f7d2", ["M368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H368zM112 288C50.1 288 0 338.1 0 400s50.1 112 112 112H368c61.9 0 112-50.1 112-112s-50.1-112-112-112H112z", "M298.9 64l68.6 160H256l-64-64V64H298.9zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48V160H96c-17.7 0-32 14.3-32 32V298.8c14.5-6.9 30.8-10.8 48-10.8H368c44.7 0 83.2 26.2 101.2 64H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V320 235.2L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288H448V256.7c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faAnglesRight = {
  prefix: 'fad',
  iconName: 'angles-right',
  icon: [512, 512, [187, "angle-double-right"], "f101", ["M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z", "M470.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 256 265.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"]]
};
var faAngleDoubleRight = faAnglesRight;
var faTruckRampCouch = {
  prefix: 'fad',
  iconName: 'truck-ramp-couch',
  icon: [640, 512, ["truck-couch"], "f4dd", ["M294.5 209.2c8.7-2.3 17.4-2.1 25.5 .2V334.8l-38.7 10.4L126.7 386.6 64.9 403.2c-17.1 4.6-34.6-5.6-39.2-22.6L13.3 334.2c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9c-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5c-11 2.9-20.8 8-29.2 14.7L8 252.8zM544 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M416.7 402.5C423.4 338.2 477.9 288 544 288c38.2 0 72.5 16.8 96 43.3V0H416c-35.3 0-64 28.7-64 64V353.8L31.6 441.1c-17.1 4.6-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5L416.7 402.5z"]]
};
var faTruckCouch = faTruckRampCouch;
var faCannabis = {
  prefix: 'fad',
  iconName: 'cannabis',
  icon: [512, 512, [], "f55f", ["M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v41.2l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z", "M280 376c0-13.3-10.7-24-24-24s-24 10.7-24 24V488c0 13.3 10.7 24 24 24s24-10.7 24-24V376z"]]
};
var faCirclePlay = {
  prefix: 'fad',
  iconName: 'circle-play',
  icon: [512, 512, [61469, "play-circle"], "f144", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z", "M212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z"]]
};
var faPlayCircle = faCirclePlay;
var faArrowUpRightAndArrowDownLeftFromCenter = {
  prefix: 'fad',
  iconName: 'arrow-up-right-and-arrow-down-left-from-center',
  icon: [512, 512, [], "e0a0", ["M169.4 297.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 448H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32s32 14.3 32 32v50.7L169.4 297.4z", "M320 32c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32V160c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L342.6 214.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 64H352c-17.7 0-32-14.3-32-32z"]]
};
var faTablets = {
  prefix: 'fad',
  iconName: 'tablets',
  icon: [640, 512, [], "f490", ["M591.4 248.8L391.2 48.6c-6.7-6.7-6.2-17.8 1.8-22.9C418.1 9.4 447.9 0 480 0c88.4 0 160 71.6 160 160c0 32.1-9.4 61.9-25.7 87c-5.2 7.9-16.2 8.5-22.9 1.8zm-22.6 22.6c6.7 6.7 6.2 17.8-1.8 22.9c-25 16.3-54.9 25.7-87 25.7c-88.4 0-160-71.6-160-160c0-32.1 9.4-61.9 25.7-87c5.2-7.9 16.2-8.5 22.9-1.8L568.8 271.4z", "M316.5 385.5c2-9.3-5.5-17.5-15-17.5H18.5c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5zm0-66.9C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5H301.5c9.5 0 16.9-8.2 15-17.5z"]]
};
var fa360Degrees = {
  prefix: 'fad',
  iconName: '360-degrees',
  icon: [640, 512, [], "e2dc", ["M576 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M0 96C0 78.3 14.3 64 32 64H160c12.1 0 23.2 6.8 28.6 17.7s4.3 23.8-3 33.5l-63.7 84.9C163 216.7 192 257 192 304v48c0 53-43 96-96 96H90.5c-25.5 0-49.9-10.1-67.9-28.1L9.4 406.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l13.3 13.3c6 6 14.1 9.4 22.6 9.4H96c17.7 0 32-14.3 32-32V304c0-26.5-21.5-48-48-48H64c-12.1 0-23.2-6.8-28.6-17.7s-4.3-23.8 3-33.5L96 128H32C14.3 128 0 113.7 0 96zm496 32c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm0 320c-44.2 0-80-35.8-80-80V144c0-44.2 35.8-80 80-80s80 35.8 80 80V368c0 44.2-35.8 80-80 80zM320 128c-17.7 0-32 14.3-32 32v33.6c5.2-1 10.5-1.6 16-1.6c44.2 0 80 35.8 80 80v96c0 44.2-35.8 80-80 80s-80-35.8-80-80V288.2c0-.1 0-.2 0-.2V160c0-53 43-96 96-96c17.7 0 32 14.3 32 32s-14.3 32-32 32zM288 272v96c0 8.8 7.2 16 16 16s16-7.2 16-16V272c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]]
};
var faEthernet = {
  prefix: 'fad',
  iconName: 'ethernet',
  icon: [512, 512, [], "f796", ["M0 224V416c0 17.7 14.3 32 32 32H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448V160c0-17.7-14.3-32-32-32H384V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z", "M112 320c8.8 0 16 7.2 16 16V448H96V336c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16V448H192V336c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16V448H288V336c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16V448H384V336c0-8.8 7.2-16 16-16z"]]
};
var faEuroSign = {
  prefix: 'fad',
  iconName: 'euro-sign',
  icon: [320, 512, [8364, "eur", "euro"], "f153", ["M48.1 272H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H60.3c-7.1-20.1-11.3-41.6-12.1-64zm82 64H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c1.2 23.1 7.5 44.8 17.9 64zm-17.9-96H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c-10.4 19.2-16.7 40.9-17.9 64zM60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48.1c.8-22.4 5-43.9 12.1-64z", "M48 248C48 128.7 144.7 32 264 32h24c17.7 0 32 14.3 32 32s-14.3 32-32 32H264c-83.9 0-152 68.1-152 152v16c0 83.9 68.1 152 152 152h24c17.7 0 32 14.3 32 32s-14.3 32-32 32H264C144.7 480 48 383.3 48 264V248z"]]
};
var faEur = faEuroSign;
var faEuro = faEuroSign;
var faChair = {
  prefix: 'fad',
  iconName: 'chair',
  icon: [448, 512, [129681], "f6c0", ["M248 48H200V288H152V58.7c-23.9 13.8-40 39.7-40 69.3V288H64V128C64 57.3 121.3 0 192 0h64c70.7 0 128 57.3 128 128V288H336V128c0-29.6-16.1-55.5-40-69.3V288H248V48zM32 480V384H96v96c0 17.7-14.3 32-32 32s-32-14.3-32-32zm384-96v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h64z", "M19.4 305.7C24.8 294.8 35.9 288 48 288H400c12.1 0 23.2 6.8 28.6 17.7l16 32c5 9.9 4.4 21.7-1.4 31.1s-16.1 15.2-27.2 15.2H32c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32z"]]
};
var faCircleCheck = {
  prefix: 'fad',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faCheckCircle = faCircleCheck;
var faSquareDashedCirclePlus = {
  prefix: 'fad',
  iconName: 'square-dashed-circle-plus',
  icon: [576, 512, [], "e5c2", ["M128 32V96H96c-17.7 0-32 14.3-32 32v32H0V128C0 75 43 32 96 32h32zM0 320V192H64V320H0zm0 32H64v32c0 17.7 14.3 32 32 32h32v64H96c-53 0-96-43-96-96V352zM448 192.7c-5.3-.5-10.6-.7-16-.7c-16.6 0-32.7 2.3-48 6.6V128c0-17.7-14.3-32-32-32H320V32h32c53 0 96 43 96 96v64.7zM262.6 416c5.5 19.3 14.1 37.2 25.4 53.2V480H160V416H262.6zM288 96H160V32H288V96z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]]
};
var faMoneySimpleFromBracket = {
  prefix: 'fad',
  iconName: 'money-simple-from-bracket',
  icon: [640, 512, [], "e313", ["M512 448l0-352L128 96l0 352c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64zM224 272c0-44.2 43-80 96-80s96 35.8 96 80s-43 80-96 80s-96-35.8-96-80z", "M96 64C78.3 64 64 78.3 64 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 43 43 0 96 0H544c53 0 96 43 96 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7-14.3-32-32-32H96z"]]
};
var faBat = {
  prefix: 'fad',
  iconName: 'bat',
  icon: [576, 512, [], "f6b5", ["M235.6 52.8l10.8 14.4c6 8.1 15.5 12.8 25.6 12.8h32c10.1 0 19.6-4.7 25.6-12.8l10.8-14.4c2.3-3 5.8-4.8 9.6-4.8c5.8 0 10.8 4.1 11.8 9.8l19 101.4-25.5 12.1c-6.4 3.1-13.5 4.7-20.6 4.7H241.2c-7.1 0-14.2-1.6-20.6-4.7l-25.5-12.1 19-101.4c1.1-5.7 6-9.8 11.8-9.8c3.8 0 7.4 1.8 9.6 4.8z", "M334.8 176H241.2c-7.1 0-14.2-1.6-20.6-4.7L123.4 125c-16.2-7.7-35.5-3.6-47.1 10C27.1 192.4 0 265.6 0 341.2v37.6c0 9.7 10.2 16 18.9 11.7l63.8-31.9c7.5-3.7 16.6-1.1 20.9 6.1l29.8 49.7c5.4 8.9 17.7 10.4 25 3.1l36.6-36.6c6.8-6.8 18.1-6.1 24 1.6l56.2 73.1c6.4 8.3 19 8.3 25.4 0l56.2-73.1c5.9-7.7 17.2-8.4 24-1.6l36.6 36.6c7.4 7.4 19.7 5.8 25-3.1l29.8-49.7c4.3-7.2 13.4-9.8 20.9-6.1l63.8 31.9c8.7 4.3 18.9-2 18.9-11.7V341.2c0-75.6-27.1-148.8-76.3-206.2c-11.6-13.6-30.9-17.7-47.1-10l-97.2 46.3c-6.4 3.1-13.5 4.7-20.6 4.7z"]]
};
var faCircleStop = {
  prefix: 'fad',
  iconName: 'circle-stop',
  icon: [512, 512, [62094, "stop-circle"], "f28d", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z", ""]]
};
var faStopCircle = faCircleStop;
var faHeadSideHeadphones = {
  prefix: 'fad',
  iconName: 'head-side-headphones',
  icon: [512, 512, [], "f8c2", ["M160 9.3V86.6c0 12.4-7.4 23.3-17.4 30.5C114.4 137.4 96 170.6 96 208c0 61.9 50.1 112 112 112s112-50.1 112-112c0-37.4-18.4-70.6-46.6-90.9c-10-7.2-17.4-18.2-17.4-30.5V.2c92 3.7 173.6 71.7 189.3 160c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2C0 122.8 67.4 36.9 160 9.3z", "M256 64V.2c-2.7-.1-5.3-.2-8-.2H224c-22.2 0-43.7 3.2-64 9.3V64 86.6c0 12.4-7.4 23.3-17.4 30.5C114.4 137.4 96 170.6 96 208c0 61.9 50.1 112 112 112s112-50.1 112-112c0-37.4-18.4-70.6-46.6-90.9c-10-7.2-17.4-18.2-17.4-30.5V64zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
};
var faPhoneRotary = {
  prefix: 'fad',
  iconName: 'phone-rotary',
  icon: [512, 512, [9742], "f8d3", ["M0 141.3V176c0 17.7 14.3 32 32 32H74.3c13.1 0 24.9-8 29.7-20.1l19.4-48.6c2.9-7.3 8.4-13.2 15.7-16c18.6-7 59.5-19.3 116.8-19.3s98.2 12.3 116.8 19.3c7.3 2.8 12.8 8.7 15.7 16L408 187.9c4.9 12.1 16.6 20.1 29.7 20.1H480c17.7 0 32-14.3 32-32V141.3c0-8.5-3.4-16.6-9.9-22.1C473.8 95.4 386.1 32 256 32S38.2 95.4 9.9 119.2C3.4 124.6 0 132.8 0 141.3zM256 384a72 72 0 1 0 0-144 72 72 0 1 0 0 144z", "M32 401v31c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V401c0-11.1-2.9-22.1-8.4-31.8l-101.1-177C359 172.3 337.8 160 314.9 160H197.1c-23 0-44.2 12.3-55.6 32.2L40.4 369.2C34.9 378.9 32 389.9 32 401zM256 240a72 72 0 1 1 0 144 72 72 0 1 1 0-144z"]]
};
var faCompassDrafting = {
  prefix: 'fad',
  iconName: 'compass-drafting',
  icon: [512, 512, ["drafting-compass"], "f568", ["M99.3 256.1L66.5 312.9C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1zm55.9 109.8l32.7-56.4c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1z", "M343.2 136.2c5.6-12.2 8.8-25.8 8.8-40.2c0-53-43-96-96-96s-96 43-96 96c0 14.3 3.1 27.9 8.8 40.2L6.5 416.5C2.2 423.9 0 432.2 0 440.6V496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l55.4-27.7c8.4-4.2 15.4-10.8 20.1-18.9L256 192h0c0 0 0 0 0 0l68 117.5c33.7-10.7 63.9-29.2 88.6-53.4L343.2 136.2zM224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM356.7 365.9l56.6 97.8c4.7 8.1 11.7 14.7 20.1 18.9l55.4 27.7c5 2.5 10.9 2.2 15.6-.7s7.6-8.1 7.6-13.6V440.6c0-8.4-2.2-16.7-6.5-24.1l-60-103.7c-25.9 22.7-55.9 40.8-88.8 53z"]]
};
var faDraftingCompass = faCompassDrafting;
var faPlateWheat = {
  prefix: 'fad',
  iconName: 'plate-wheat',
  icon: [512, 512, [], "e55a", ["M160 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zM32 88c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM0 160c0-13.3 10.7-24 24-24H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm56 48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM288 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm96 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zm80 128c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM240 176c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80z", "M27.8 320C13 320 1.6 332.9 3.5 347.6C9.7 397.8 47.8 437 96 446v2c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32v-2c48.2-9 86.3-48.2 92.6-98.4c1.8-14.7-9.6-27.6-24.4-27.6H27.8z"]]
};
var faCalendarCircleMinus = {
  prefix: 'fad',
  iconName: 'calendar-circle-minus',
  icon: [576, 512, [], "e46f", ["M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32zM416 192.7c-89.7 8.1-160 83.5-160 175.3c0 59.5 29.6 112.1 74.8 144H48c-26.5 0-48-21.5-48-48V192H416v.7z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]]
};
var faChopsticks = {
  prefix: 'fad',
  iconName: 'chopsticks',
  icon: [640, 512, [], "e3f7", ["M235.8 153.5L3.4 486.1c-5.5 6.9-4.3 17 2.7 22.5s17 4.3 22.5-2.7l267.8-304-60.5-48.4zM419 211L133.6 483.9c-6.7 5.8-7.5 15.8-1.7 22.6s15.9 7.5 22.6 1.7L472.3 264.3 419 211z", "M296.3 201.9l-60.5-48.4L330.3 18.3C339 7.2 352.7 0 368 0c26.5 0 48 21.5 48 48c0 11.2-3.8 21.5-10.3 29.7L296.3 201.9zm175.9 62.4L419 211 560.8 75.6C569.2 68.4 580.1 64 592 64c26.5 0 48 21.5 48 48c0 14.6-6.5 27.6-16.8 36.4l-151 115.8z"]]
};
var faCarWrench = {
  prefix: 'fad',
  iconName: 'car-wrench',
  icon: [512, 512, ["car-mechanic"], "f5e3", ["M163.8 112c-6.4 0-12 3.8-15.3 9.3C134.5 144.5 109.1 160 80 160c-28.1 0-52.8-14.5-67.1-36.4C7 114.6 14.7 104 25.5 104H56c13.3 0 24-10.7 24-24s-10.7-24-24-24H25.5C14.7 56 7 45.4 12.9 36.4C27.2 14.5 51.9 0 80 0c29.1 0 54.5 15.5 68.5 38.7c3.3 5.4 8.9 9.3 15.3 9.3H348.2c6.4 0 12-3.8 15.3-9.3C377.5 15.5 402.9 0 432 0c28.1 0 52.8 14.5 67.1 36.4c5.9 9-1.7 19.6-12.5 19.6H456c-13.3 0-24 10.7-24 24s10.7 24 24 24h30.5c10.8 0 18.4 10.6 12.5 19.6c-14.3 21.9-39 36.4-67.1 36.4c-29.1 0-54.5-15.5-68.5-38.7c-3.3-5.4-8.9-9.3-15.3-9.3H163.8z", "M170.8 234.6L151.7 288H360.3l-19.1-53.4c-2.3-6.4-8.3-10.6-15.1-10.6H185.8c-6.8 0-12.8 4.3-15.1 10.6zM82.2 292.4l28.3-79.3C121.9 181.3 152 160 185.8 160H326.2c33.8 0 64 21.3 75.3 53.1l28.3 79.3c20.1 8.5 34.2 28.4 34.2 51.6v40 64 32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V448 384 344c0-23.2 14.1-43.1 34.2-51.6zM152 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faCarMechanic = faCarWrench;
var faIcicles = {
  prefix: 'fad',
  iconName: 'icicles',
  icon: [512, 512, [], "f7ad", ["M336 160l61.2 336.4c1.6 9 9.5 15.6 18.7 15.6c9.3 0 17.2-6.7 18.8-15.9L511.6 34.4c.3-1.6 .4-3.2 .4-4.9C512 13.2 498.8 0 482.4 0H342.1c-1.6 0-3.2 .1-4.8 .4c13.8 2.3 24.3 14.3 24.3 28.7c0 1.9-.2 3.8-.6 5.7L336 160l0 0z", "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H332.5c16.1 0 29.1 13 29.1 29.1c0 1.9-.2 3.8-.6 5.7L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"]]
};
var faPersonShelter = {
  prefix: 'fad',
  iconName: 'person-shelter',
  icon: [512, 512, [], "e54f", ["M296 168a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM248 488V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z", "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l224 128c10 5.7 16.1 16.3 16.1 27.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V178.6L256 68.9 64 178.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-11.5 6.2-22.1 16.1-27.8l224-128z"]]
};
var faNeuter = {
  prefix: 'fad',
  iconName: 'neuter',
  icon: [384, 512, [9906], "f22c", ["M112 176a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"]]
};
var faIdBadge = {
  prefix: 'fad',
  iconName: 'id-badge',
  icon: [384, 512, [], "f2c1", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M192 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H160z"]]
};
var faKazoo = {
  prefix: 'fad',
  iconName: 'kazoo',
  icon: [640, 512, [], "f8c7", ["M592 256c0 55.7-31.7 104.1-78 128h94c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H514c46.3 23.9 78 72.3 78 128zM224 384H382c-46.3-23.9-78-72.3-78-128s31.7-104.1 78-128H224c-3 0-6 .4-9 1.3l-192 56C9.4 189.3 0 201.8 0 216v80c0 14.2 9.4 26.7 23 30.7l192 56c2.9 .8 5.9 1.3 9 1.3zM427.3 212.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256l-20.7 20.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L448 278.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L470.6 256l20.7-20.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L448 233.4l-20.7-20.7z", "M448 400a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-240a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]]
};
var faMarker = {
  prefix: 'fad',
  iconName: 'marker',
  icon: [512, 512, [], "f5a1", ["M305 337L175 207 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L305 337z", "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 175 207 305 337 481 161c35.9-35.9 35.9-94.1 0-129.9z"]]
};
var faBinBottles = {
  prefix: 'fad',
  iconName: 'bin-bottles',
  icon: [640, 512, [], "e5f5", ["M128 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16V24zm0 72H256c24.9 0 47.6 9.5 64.6 25c1.1 1 2.2 2 3.2 3.1C341.3 141.5 352 165.5 352 192H32c0-53 43-96 96-96zm447.1 96H384c0-40.7-19-76.9-48.6-100.4c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7V24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V66.1c5.6 1.3 11.1 3.2 16.4 5.7L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5z", "M32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32L56.2 457c4.5 31.5 31.5 55 63.4 55h401c31.8 0 58.9-23.4 63.4-55L608 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faFaceLaughBeam = {
  prefix: 'fad',
  iconName: 'face-laugh-beam',
  icon: [512, 512, [128513, "laugh-beam"], "f59a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM217.6 212.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z", "M217.6 212.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 172.4 120 190.1 120 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 172.4 280 190.1 280 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]]
};
var faLaughBeam = faFaceLaughBeam;
var faSquareArrowDownLeft = {
  prefix: 'fad',
  iconName: 'square-arrow-down-left',
  icon: [448, 512, [], "e261", ["M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zM288 368c13.3 0 24-10.7 24-24s-10.7-24-24-24H193.9L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V344c0 13.3 10.7 24 24 24H288z", "M136 368H288c13.3 0 24-10.7 24-24s-10.7-24-24-24H193.9L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V344c0 13.3 10.7 24 24 24z"]]
};
var faBatteryBolt = {
  prefix: 'fad',
  iconName: 'battery-bolt',
  icon: [576, 512, [], "f376", ["M299.2 96l-80 64H80c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16h90.3l-5.3 10.5c-8.9 17.8-5.8 39 7.2 53.5H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80H299.2zm25.7 256H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H373.7l5.3-10.5c8.9-17.8 5.8-39-7.2-53.5H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H244.8l80-64z", "M350.3 135.2c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L193.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H297.9l52.4-104.8z"]]
};
var faTreeLarge = {
  prefix: 'fad',
  iconName: 'tree-large',
  icon: [448, 512, [], "f7dd", ["M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L28.5 313.7c-2.9 4.1-4.5 9-4.5 14.1C24 341.1 34.8 352 48.2 352H80L3.8 474c-2.5 4-3.8 8.5-3.8 13.2C0 500.9 11.1 512 24.9 512H192V224c0-17.7 14.3-32 32-32s32 14.3 32 32V512H423.1c13.7 0 24.9-11.1 24.9-24.9c0-4.7-1.3-9.2-3.8-13.2L368 352h31.8c13.4 0 24.2-10.9 24.2-24.2c0-5-1.6-10-4.5-14.1L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z", "M224 192c17.7 0 32 14.3 32 32V512H192V224c0-17.7 14.3-32 32-32z"]]
};
var faHelicopterSymbol = {
  prefix: 'fad',
  iconName: 'helicopter-symbol',
  icon: [512, 512, [], "e502", ["M510 224C495.6 108.2 403.8 16.4 288 2V66.7C368.4 80.1 431.9 143.6 445.3 224H510zm-64.7 64C431.9 368.4 368.4 431.9 288 445.4V510c115.8-14.4 207.6-106.2 222-222H445.3zM66.7 288H2C16.4 403.8 108.2 495.6 224 510V445.4C143.6 431.9 80.1 368.4 66.7 288zm0-64C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224H66.7z", "M176 128c17.7 0 32 14.3 32 32v64h96V160c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H208v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32z"]]
};
var faAperture = {
  prefix: 'fad',
  iconName: 'aperture',
  icon: [512, 512, [], "e2df", ["M336.4 12.9C400.2 34 453 79.5 483.5 138.4c5.2 10.1-2.5 21.6-13.8 21.6H265.2c-12.3 0-20-13.3-13.9-24l67-116c3.6-6.3 11.1-9.4 18-7.1zM0 256c0-50.9 14.9-98.3 40.5-138.2c6.1-9.5 19.9-8.6 25.6 1.2L168.2 296c6.2 10.7-1.5 24-13.9 24H20.5c-7.3 0-13.7-4.9-15.2-12.1C1.8 291.2 0 273.8 0 256zM256 512c-4 0-7.9-.1-11.9-.3c-11.3-.5-17.5-12.9-11.8-22.8L334.5 312c6.2-10.7 21.6-10.7 27.7 0l66.9 115.9c3.6 6.3 2.6 14.3-2.9 19.2C381.1 487.5 321.4 512 256 512z", "M256 0c4 0 7.9 .1 11.9 .3c11.3 .5 17.4 12.9 11.8 22.8L177.5 200c-6.2 10.7-21.6 10.7-27.7 0L82.8 84.1c-3.6-6.3-2.6-14.3 2.9-19.2C130.9 24.5 190.6 0 256 0zM193.6 492c-3.6 6.3-11.1 9.4-18 7.1C111.8 478 59 432.5 28.5 373.6C23.3 363.5 31 352 42.3 352H246.8c12.3 0 20 13.3 13.9 24l-67 116zm277.9-97.8c-6.1 9.5-19.9 8.6-25.6-1.2L343.8 216c-6.2-10.7 1.5-24 13.9-24H491.5c7.3 0 13.7 4.9 15.2 12.1c3.5 16.8 5.3 34.1 5.3 51.9c0 50.9-14.9 98.3-40.5 138.2z"]]
};
var faUniversalAccess = {
  prefix: 'fad',
  iconName: 'universal-access',
  icon: [512, 512, [], "f29a", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6V235.5c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z", "M256 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM129.9 182.5c5.2-12.2 19.3-17.8 31.5-12.6l11.9 5.1c26.1 11.2 54.2 17 82.7 17s56.5-5.8 82.7-17l11.9-5.1c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-11.9 5.1c-17.3 7.4-35.2 12.9-53.6 16.3v50.1c0 4.3 .7 8.6 2.1 12.6l28.7 86.1c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-24.4-73.2c-1.3-3.8-4.8-6.4-8.8-6.4s-7.6 2.6-8.8 6.4l-24.4 73.2c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4l28.7-86.1c1.4-4.1 2.1-8.3 2.1-12.6V235.5c-18.4-3.5-36.3-8.9-53.6-16.3l-11.9-5.1c-12.2-5.2-17.8-19.3-12.6-31.5z"]]
};
var faGearComplex = {
  prefix: 'fad',
  iconName: 'gear-complex',
  icon: [512, 512, [], "e5e9", ["M192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z", "M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1 .6 266.1 0 256 0c-11.1 0-22.1 .7-32.8 2.1c-10.3 1.3-18 9.7-19.3 20l-2.9 23.1c-.8 6.4-5.4 11.6-11.5 13.7c-9.6 3.2-19 7.2-27.9 11.7c-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4c-16.6 13-31.5 28-44.4 44.7c-6.3 8.2-5.9 19.6 .5 27.8l14.2 18.3c4 5.1 4.4 12 1.5 17.8c-4.4 8.8-8.2 17.9-11.3 27.4c-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6 .6 21.1 1.9 31.4c1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4 .8 11.7 5.4 13.7 11.6c3.1 9.5 6.9 18.7 11.3 27.5c2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8c12.9 16.7 27.8 31.7 44.4 44.7c8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5c9 4.6 18.3 8.5 27.9 11.7c6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20c10.7 1.4 21.7 2.1 32.8 2.1c10.1 0 20.1-.6 29.9-1.7c10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8c10-3.2 19.7-7.2 29-11.8c5.8-2.9 12.7-2.4 17.8 1.5L385 457.9c8.2 6.4 19.6 6.8 27.8 .5c2.8-2.2 5.5-4.4 8.2-6.7L451.7 421c1.8-2.2 3.6-4.4 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18c4.8-9.4 9-19.3 12.3-29.5c2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4c.2-1.7 .4-3.5 .6-5.2V230.1c-.2-1.7-.4-3.5-.6-5.2c-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6c-3.4-10.2-7.5-20.1-12.3-29.5c-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7 .4-27.9c-1.8-2.2-3.6-4.4-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7c-8.2-6.4-19.6-5.9-27.8 .5L366.7 68.3c-5.1 4-12.1 4.4-17.8 1.5c-9.3-4.6-19-8.6-29-11.8c-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]]
};
var faFileMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'file-magnifying-glass',
  icon: [384, 512, ["file-search"], "f865", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM272 304c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L263 425.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zM272 304c0 17.8-4.9 34.5-13.3 48.9L297 391.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-38.4-38.4C210.4 395.2 193.8 400 176 400c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm-96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
};
var faFileSearch = faFileMagnifyingGlass;
var faUpRight = {
  prefix: 'fad',
  iconName: 'up-right',
  icon: [384, 512, [], "e2be", ["M145.4 206.6L11.3 340.7C4.1 347.9 0 357.8 0 368s4.1 20.1 11.3 27.3l41.4 41.4C59.9 443.9 69.8 448 80 448s20.1-4.1 27.3-11.3L241.4 302.6l-96-96z", "M336 80H96c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l240 240c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V112c0-17.7-14.3-32-32-32z"]]
};
var faCircleChevronUp = {
  prefix: 'fad',
  iconName: 'circle-chevron-up',
  icon: [512, 512, ["chevron-circle-up"], "f139", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z", "M239 167c9.4-9.4 24.6-9.4 33.9 0L377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167z"]]
};
var faChevronCircleUp = faCircleChevronUp;
var faUserPolice = {
  prefix: 'fad',
  iconName: 'user-police',
  icon: [448, 512, [], "e333", ["M101.7 154.2C98 166.1 96 178.8 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-13.2-2-25.9-5.7-37.8C308.2 168.3 267 176 224 176s-84.2-7.7-122.3-21.8z", "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6l23.8 20.4c-.1 1-.1 2-.1 3.1v21.2c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2V105.7c0-1-.1-2.1-.1-3.1l23.8-20.4c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM227 48.6l32 12.8c3 1.2 5 4.2 5 7.4c0 17.2-7 46.1-36.9 58.6c-2 .8-4.2 .8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8c1.9-.8 4-.8 5.9 0zm-84.9 306c-2.2-1.7-4.9-2.6-7.7-2.6C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352c-2.8 0-5.5 .9-7.7 2.6l-72.3 54.2c-5.7 4.3-13.5 4.3-19.2 0l-72.3-54.2zm217.5 59l5.4 16.6 17.4 0c3.5 0 6.6 2.2 7.6 5.5s-.1 6.9-2.9 9L373 454.8l5.4 16.6c1.1 3.3-.1 6.9-2.9 9s-6.6 2-9.4 0L352 470.1l-14.1 10.3c-2.8 2-6.6 2.1-9.4 0s-4-5.7-2.9-9l5.4-16.6-14.1-10.2c-2.8-2-4-5.7-2.9-9s4.2-5.5 7.6-5.5l17.4 0 5.4-16.6c1.1-3.3 4.1-5.5 7.6-5.5s6.5 2.2 7.6 5.5z"]]
};
var faLariSign = {
  prefix: 'fad',
  iconName: 'lari-sign',
  icon: [384, 512, [], "e1c8", ["M144 32c-17.7 0-32 14.3-32 32v49.4c19.8-9.1 41.3-14.9 64-16.8L176 64c0-17.7-14.3-32-32-32zM112 188.1V256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-95c-24 3-46 12.7-64 27.1zM208 161v95c0 17.7 14.3 32 32 32s32-14.3 32-32V188.1c-18-14.4-40-24.1-64-27.1zm64-47.6V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96.7c22.7 1.9 44.2 7.7 64 16.8z", "M64 288c0-70.7 57.3-128 128-128c61.9 0 113.6 44 125.4 102.4c3.5 17.3 20.4 28.5 37.7 25s28.5-20.4 25-37.7C362.4 162 284.9 96 192 96C86 96 0 182 0 288c0 49.2 18.5 94 48.9 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192 352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-70.7 0-128-57.3-128-128z"]]
};
var faVolcano = {
  prefix: 'fad',
  iconName: 'volcano',
  icon: [512, 512, [127755], "f770", ["M173.3 343.1l17.8-11.9c11-7.3 23.9-11.2 37.1-11.2c17.8 0 34.8 7.1 47.3 19.6l34.5 34.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l37.2-55.8 99.6 112c8.5 9.6 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l83.6-94 17.9 12c8.7 5.8 18.9 8.9 29.3 8.9s20.6-3.1 29.3-8.9z", "M160 144c14.7 0 28.3-5 39.1-13.3l32 48C236.7 187 246 192 256 192s19.3-5 24.9-13.3l32-48C323.7 139 337.3 144 352 144c35.3 0 64-28.7 64-64s-28.7-64-64-64c-15.7 0-30 5.6-41.2 15C299.6 12.4 279.3 0 256 0s-43.6 12.4-54.8 31C190 21.6 175.7 16 160 16c-35.3 0-64 28.7-64 64s28.7 64 64 64zm31.1 187.2c11-7.3 23.9-11.2 37.1-11.2c17.8 0 34.8 7.1 47.3 19.6l34.5 34.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l37.2-55.8-50.6-56.9c-18.2-20.5-44.3-32.2-71.8-32.2H235.1c-27.4 0-53.5 11.7-71.8 32.2L96.7 331.2l17.9 12c8.7 5.8 18.9 8.9 29.3 8.9s20.6-3.1 29.3-8.9l17.8-11.9z"]]
};
var faTeddyBear = {
  prefix: 'fad',
  iconName: 'teddy-bear',
  icon: [576, 512, [], "e3cf", ["M236.6 36.7C228.7 15.3 208.2 0 184 0c-30.9 0-56 25.1-56 56c0 20.2 10.7 37.9 26.7 47.7c9.1-37.9 40.4-58.5 81.9-67zM448 56c0-30.9-25.1-56-56-56c-24.2 0-44.7 15.3-52.6 36.7c41.5 8.5 72.8 29.1 81.9 67C437.3 93.9 448 76.2 448 56zM288 224c35.3 0 64-21.5 64-48s-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48zm0-32c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zM192 416H384c0-35.3-28.7-64-64-64H256c-35.3 0-64 28.7-64 64z", "M288 256c-75.1 0-136-57.3-136-128s60.9-96 136-96s136 25.3 136 96s-60.9 128-136 128zM240 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64c0-26.5-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48zm-32-8c0 13.3-14.3 24-32 24s-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24zM50.3 178.3c20.8-16.4 51-12.8 67.4 8L143.5 219c73.7 93.5 215.4 93.5 289.1 0l25.8-32.7c16.4-20.8 46.6-24.4 67.4-8s24.4 46.6 8 67.4l-25.8 32.7c-17.7 22.4-37.9 41.3-59.9 56.7V400h16.6c3.9-27.1 27.2-48 55.4-48c30.9 0 56 25.1 56 56c0 2.7-.2 5.4-.6 8l-13 53.3c-5.8 23.8-26.3 40.9-50.4 42.6v.1h-4H480 96 68 64v-.1c-24.1-1.7-44.6-18.8-50.4-42.6L.6 416c-.4-2.6-.6-5.3-.6-8c0-30.9 25.1-56 56-56c28.2 0 51.6 20.9 55.4 48H128V335.1c-22-15.4-42.3-34.3-59.9-56.7L42.3 245.7c-16.4-20.8-12.8-51 8-67.4zM256 352c-35.3 0-64 28.7-64 64H384c0-35.3-28.7-64-64-64H256z"]]
};
var faStocking = {
  prefix: 'fad',
  iconName: 'stocking',
  icon: [384, 512, [], "f7d5", ["M96 96V238.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9v2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6l66-44c-20.4-20.3-33-48.3-33-79.4c0-61.9 50.1-112 112-112c5.4 0 10.8 .4 16 1.1V96H96z", "M96 0C78.3 0 64 14.3 64 32V64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zM352 315.5V257.1c-5.2-.7-10.6-1.1-16-1.1c-61.9 0-112 50.1-112 112c0 31 12.6 59.1 33 79.4L295 422c35.6-23.7 57-63.7 57-106.5z"]]
};
var faPersonWalkingDashedLineArrowRight = {
  prefix: 'fad',
  iconName: 'person-walking-dashed-line-arrow-right',
  icon: [640, 512, [], "e553", ["", "M392 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM505.4 153.4c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L530.7 288H384c-17.7 0-32-14.3-32-32s14.3-32 32-32H530.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3zM416 152v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zM392 320c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-13.3 10.7-24 24-24zm24 120v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V440c0-13.3 10.7-24 24-24s24 10.7 24 24zM160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"]]
};
var faImageSlash = {
  prefix: 'fad',
  iconName: 'image-slash',
  icon: [640, 512, [], "e1b7", ["M64.7 86.4l63.9 50.1c-.4 2.5-.6 5-.6 7.5c0 26.5 21.5 48 48 48c6.6 0 12.9-1.3 18.6-3.8L301 271.6l-20.4 29.9L259 273.4c-4.4-5.8-11.2-9.2-18.5-9.4s-14.2 3-18.9 8.5l-88 104c-6 7.1-7.4 17.1-3.5 25.6s12.4 13.9 21.8 13.9h96 72H485.2l65.3 51.1c-10.7 8.1-24 12.9-38.5 12.9H128c-35.3 0-64-28.7-64-64V96c0-3.3 .2-6.5 .7-9.6zM223.6 150c.2-2 .4-4 .4-6c0-26.5-21.5-48-48-48c-6.1 0-11.9 1.1-17.2 3.2L89.5 44.9C100.2 36.8 113.6 32 128 32H512c35.3 0 64 28.7 64 64V416c0 3.3-.2 6.5-.7 9.6l-75.9-59.5L387.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-20 29.4L223.6 150z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faMaskSnorkel = {
  prefix: 'fad',
  iconName: 'mask-snorkel',
  icon: [576, 512, [], "e3b7", ["M576 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96h64V64zm0 128H512V367.4c0 44.5-36.1 80.6-80.6 80.6c-39.4 0-73-28.5-79.5-67.4l-.3-1.9c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.3 1.9c11.6 69.7 72 120.8 142.6 120.8C511.3 512 576 447.3 576 367.4V192z", "M64 64C28.7 64 0 92.7 0 128v96c0 35.3 28.7 64 64 64h79.7c28.6 0 53.7-18.9 61.5-46.4l3.4-11.7c4.4-15.5 26.3-15.5 30.8 0l3.4 11.7c7.8 27.5 33 46.4 61.5 46.4H384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm512 96H512v32h64V160z"]]
};
var faSmoke = {
  prefix: 'fad',
  iconName: 'smoke',
  icon: [640, 512, [], "f760", ["M144 192c-29.2 0-56.7 7.1-80.9 19.6C43.7 189.2 32 160 32 128C32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298 32 320 32c44.3 0 83.4 22.5 106.4 56.8c-11.5 7.3-22 16-31.2 25.9C372.7 102.8 347.2 96 320 96c-66.5 0-123.5 40.6-147.7 98.3c-9.2-1.5-18.7-2.3-28.3-2.3zm320 64c-5.2 0-10.3 .3-15.4 .8C419.5 217.5 372.7 192 320 192c-31.5 0-60.9 9.1-85.7 24.9c-9.6-5.8-19.8-10.6-30.5-14.5C224 158.5 268.4 128 320 128c31.3 0 60.1 11.3 82.3 30c22.4-37.1 63.1-62 109.7-62c70.7 0 128 57.3 128 128c0 42.2-20.4 79.6-51.9 102.9C563.1 284.5 516.9 256 464 256z", "M0 368c0 79.5 64.5 144 144 144H464c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C411.8 251.7 369.1 224 320 224c-32.6 0-62.4 12.2-85.1 32.3C210.1 236.1 178.5 224 144 224C64.5 224 0 288.5 0 368z"]]
};
var faSterlingSign = {
  prefix: 'fad',
  iconName: 'sterling-sign',
  icon: [320, 512, [163, "gbp", "pound-sign"], "f154", ["M48 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48V224zm64 64H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112v64z", "M176.4 96c-35.5 0-64.4 28.8-64.4 64.4V332.5c0 29-7.9 57.5-22.8 82.3l-.7 1.1H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l29.8-49.6c9-14.9 13.7-32 13.7-49.4V160.4C48 89.5 105.5 32 176.4 32c13.8 0 27.5 2.2 40.6 6.6l81.2 27.1c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L196.7 99.3c-6.6-2.2-13.4-3.3-20.4-3.3z"]]
};
var faGbp = faSterlingSign;
var faPoundSign = faSterlingSign;
var faBatteryExclamation = {
  prefix: 'fad',
  iconName: 'battery-exclamation',
  icon: [576, 512, [], "e0b0", ["M80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H198.7c-4.3-9.8-6.7-20.6-6.7-32s2.4-22.2 6.7-32H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H208V96H80zM345.3 416H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H336v64H464c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H345.3c4.3 9.8 6.7 20.6 6.7 32s-2.4 22.2-6.7 32z", "M296 120c0-13.3-10.7-24-24-24s-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V120zM272 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faViruses = {
  prefix: 'fad',
  iconName: 'viruses',
  icon: [640, 512, [], "e076", ["M192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM480 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352 48c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C417.5 312.1 401 352 368 352c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C440.1 446.5 480 463 480 496c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C574.5 423.9 591 384 624 384c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C551.9 289.5 512 273 512 240zM448 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faSquarePersonConfined = {
  prefix: 'fad',
  iconName: 'square-person-confined',
  icon: [448, 512, [], "e577", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7V248z", "M208 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm88 0c-30.9 0-56 25.1-56 56v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L184.8 342l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V248c0-30.9-25.1-56-56-56z"]]
};
var faUserTie = {
  prefix: 'fad',
  iconName: 'user-tie',
  icon: [448, 512, [], "f508", ["M352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z", "M190.5 328.2l18.6 31L175.8 483.1 136.3 321.9C59.1 333.9 0 400.7 0 481.3c0 17 13.8 30.7 30.7 30.7H182.9h82.3H417.3c17 0 30.7-13.8 30.7-30.7c0-80.6-59.1-147.4-136.3-159.4L272.2 483.1 238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2z"]]
};
var faArrowDownLong = {
  prefix: 'fad',
  iconName: 'arrow-down-long',
  icon: [384, 512, ["long-arrow-down"], "f175", ["M160 402.7V32c0-17.7 14.3-32 32-32s32 14.3 32 32V402.7l-32 32-32-32z", "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 434.7 86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"]]
};
var faLongArrowDown = faArrowDownLong;
var faTentArrowDownToLine = {
  prefix: 'fad',
  iconName: 'tent-arrow-down-to-line',
  icon: [640, 512, [], "e57e", ["M403.4 134.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160-.7 4.7H384V320l76.8 128H608c.1 0 .2 0 .4 0l-.7-4.7-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z", "M240.1 145.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-39.9 36L168 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faCertificate = {
  prefix: 'fad',
  iconName: 'certificate',
  icon: [512, 512, [], "f0a3", ["M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z", ""]]
};
var faCrystalBall = {
  prefix: 'fad',
  iconName: 'crystal-ball',
  icon: [448, 512, [], "e362", ["M362.6 400c52-41 85.4-104.6 85.4-176C448 100.3 347.7 0 224 0S0 100.3 0 224c0 71.4 33.4 135 85.4 176H362.6zM152.5 84.3c2.6-7 12.4-7 15 0l9.8 26.4 26.4 9.8c7 2.6 7 12.4 0 15l-26.4 9.8-9.8 26.4c-2.6 7-12.4 7-15 0l-9.8-26.4-26.4-9.8c-7-2.6-7-12.4 0-15l26.4-9.8 9.8-26.4zm159 48l18.4 49.8 49.8 18.4c7 2.6 7 12.4 0 15l-49.8 18.4-18.4 49.8c-2.6 7-12.4 7-15 0l-18.4-49.8-49.8-18.4c-7-2.6-7-12.4 0-15l49.8-18.4 18.4-49.8c2.6-7 12.4-7 15 0z", "M362.6 400H85.4L21.7 473.4c-3.7 4.2-5.7 9.7-5.7 15.3C16 501.6 26.4 512 39.3 512H408.7c12.9 0 23.3-10.4 23.3-23.3c0-5.6-2-11-5.7-15.3L362.6 400z"]]
};
var faReplyAll = {
  prefix: 'fad',
  iconName: 'reply-all',
  icon: [576, 512, ["mail-reply-all"], "f122", ["M205 34.8c11.5 5.1 19 16.6 19 29.2v43.3l-85.4 76.9c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8L224 308.7V352c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z", "M333 34.8c11.5 5.1 19 16.6 19 29.2v64h48c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H352v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144c-6.7-6.1-10.6-14.7-10.6-23.8s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"]]
};
var faMailReplyAll = faReplyAll;
var faSuitcase = {
  prefix: 'fad',
  iconName: 'suitcase',
  icon: [512, 512, [129523], "f0f2", ["M96 96h32V480H96V96zm288 0h32V480H384V96z", "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z"]]
};
var faPersonSkating = {
  prefix: 'fad',
  iconName: 'person-skating',
  icon: [448, 512, ["skating"], "f7c5", ["M135.2 478.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-6.2 3.1c-9.2 4.6-20.4 2.8-27.7-4.5L27.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l59.6 59.6c17 17 43.1 21.3 64.6 10.5l6.2-3.1zm280.4-10.4c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-.4 1.7c-2.7 10.7-12.3 18.2-23.3 18.2H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h88.8c25.7 0 48.1-17.5 54.3-42.4l.4-1.7z", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H319.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V349.3l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3z"]]
};
var faSkating = faPersonSkating;
var faStarShooting = {
  prefix: 'fad',
  iconName: 'star-shooting',
  icon: [512, 512, [127776], "e036", ["M313 7c-9.4-9.4-24.6-9.4-33.9 0L231 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9zM505 199c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9zM505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L327 151c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 41z", "M213.4 157.4c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94z"]]
};
var faBinaryLock = {
  prefix: 'fad',
  iconName: 'binary-lock',
  icon: [640, 512, [], "e33d", ["M336 32c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H256c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H336V32zM112 320c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16C5.1 311.2-3.9 329.4 1.7 346.1s23.7 25.8 40.5 20.2l5.9-2V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H80h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V320zM0 64v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64zm128 0v96H64V64h64zM256 288c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H256zm0 64h64v96H256V352z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faFilterCircleDollar = {
  prefix: 'fad',
  iconName: 'filter-circle-dollar',
  icon: [576, 512, ["funnel-dollar"], "f662", ["M40 0C24.5 0 10.5 8.9 3.9 22.9S-.7 53.4 9 65.3L192 288.9V368c0 10.1 4.7 19.6 12.8 25.6l64 48c1.5 1.1 3 2.1 4.7 2.9C262.3 421.4 256 395.4 256 368c0-85 60.2-155.9 140.4-172.4L503 65.3c9.8-12 11.8-28.5 5.2-42.5S487.5 0 472 0H40z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z"]]
};
var faFunnelDollar = faFilterCircleDollar;
var faCameraRetro = {
  prefix: 'fad',
  iconName: 'camera-retro',
  icon: [512, 512, [128247], "f083", ["M0 128v32H256 512V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H64C28.7 64 0 92.7 0 128z", "M64 48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V64H64V48zM0 416V160H512V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm256-16a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]]
};
var faCircleArrowDown = {
  prefix: 'fad',
  iconName: 'circle-arrow-down',
  icon: [512, 512, ["arrow-circle-down"], "f0ab", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM385 281c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71V136c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 393c9.4 9.4 24.6 9.4 33.9 0L385 281z", "M239 393c9.4 9.4 24.6 9.4 33.9 0L385 281c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71V136c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 393z"]]
};
var faArrowCircleDown = faCircleArrowDown;
var faCommentPen = {
  prefix: 'fad',
  iconName: 'comment-pen',
  icon: [512, 512, ["comment-edit"], "f4ae", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm84.8-293c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L272.6 170 287.5 155c14.7-14.7 38.6-14.7 53.3 0zM178.1 264.5L250 192.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z", "M287.5 155L272.6 170l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3s-38.6-14.7-53.3 0zM250 192.6l-71.9 71.9c-4.1 4.1-7 9.2-8.4 14.9L160.5 316c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 192.6z"]]
};
var faCommentEdit = faCommentPen;
var faFileImport = {
  prefix: 'fad',
  iconName: 'file-import',
  icon: [512, 512, ["arrow-right-to-file"], "f56f", ["M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64z", "M512 160L352 0V128c0 17.7 14.3 32 32 32H512zM297 215c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]]
};
var faArrowRightToFile = faFileImport;
var faBanjo = {
  prefix: 'fad',
  iconName: 'banjo',
  icon: [512, 512, [129685], "f8a3", ["M24 320a168 168 0 1 1 336 0A168 168 0 1 1 24 320zm280 0A112 112 0 1 0 80 320a112 112 0 1 0 224 0zM155.3 308.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z", "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41L286 180.7c2.2 1.5 4.4 3.1 6.6 4.7c12.9 9.6 24.3 21.1 33.9 33.9c1.6 2.2 3.2 4.4 4.7 6.6l76.1-76.1 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM192 128c-13.3 0-24 10.7-24 24v1.7c7.8-1.1 15.9-1.7 24-1.7s16.2 .6 24 1.7V152c0-13.3-10.7-24-24-24zM360 320c0 8.1-.6 16.2-1.7 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.7c1.1 7.8 1.7 15.9 1.7 24zM292.6 454.6l1.2 1.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-1.2-1.2c-9.6 12.9-21.1 24.3-33.9 33.9zM192 488c-8.1 0-16.2-.6-24-1.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-1.7c-7.8 1.1-15.9 1.7-24 1.7zM57.4 420.6l-1.2 1.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l1.2-1.2c-12.9-9.6-24.3-21.1-33.9-33.9zM24 320c0-8.1 .6-16.2 1.7-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h1.7c-1.1-7.8-1.7-15.9-1.7-24zM91.4 185.4l-1.2-1.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l1.2 1.2c9.6-12.9 21.1-24.3 33.9-33.9zm41.3 123.2c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48c-6.2-6.2-16.4-6.2-22.6 0z"]]
};
var faSquareArrowUpRight = {
  prefix: 'fad',
  iconName: 'square-arrow-up-right',
  icon: [448, 512, ["external-link-square"], "f14c", ["M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z", "M312 144H160c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24z"]]
};
var faExternalLinkSquare = faSquareArrowUpRight;
var faLightEmergencyOn = {
  prefix: 'fad',
  iconName: 'light-emergency-on',
  icon: [640, 512, [], "e420", ["M320 32c-88.4 0-160 71.6-160 160V352H480V192c0-88.4-71.6-160-160-160zM240 192c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z", "M69.3 36c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM597.3 76c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24H88c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H552zM128 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H128z"]]
};
var faKerning = {
  prefix: 'fad',
  iconName: 'kerning',
  icon: [640, 512, [], "f86f", ["M17.7 99.4c15.8-7.9 35-1.5 42.9 14.3L160 312.4l99.4-198.8c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-128 256C183.2 409.2 172.1 416 160 416s-23.2-6.8-28.6-17.7l-128-256c-7.9-15.8-1.5-35 14.3-42.9zm320 313.2c-15.8-7.9-22.2-27.1-14.3-42.9l128-256C456.8 102.8 467.9 96 480 96s23.2 6.8 28.6 17.7l128 256c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L556.2 352H403.8l-23.2 46.3c-7.9 15.8-27.1 22.2-42.9 14.3zM524.2 288L480 199.6 435.8 288h88.4z", "M447.2 1.7c7.9 4 11.1 13.6 7.2 21.5l-240 480c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l240-480c4-7.9 13.6-11.1 21.5-7.2z"]]
};
var faBoxOpen = {
  prefix: 'fad',
  iconName: 'box-open',
  icon: [640, 512, [], "f49e", ["M17.2 125.5c-9 17.9 .6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 64 75.2 33.4c-6.7-.8-13.3 2.7-16.3 8.7L17.2 125.5zm605.5 0L581.1 42.1c-3-6.1-9.6-9.6-16.3-8.7L320 64l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1z", "M320 64L236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L64 178.3V378.5c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.6 20.9 2.6 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6V178.3l-136.4 39c-13.9 4-28.8-1.9-36.2-14.3L320 64z"]]
};
var faSquareF = {
  prefix: 'fad',
  iconName: 'square-f',
  icon: [448, 512, [], "e270", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24z", "M128 152c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152z"]]
};
var faScroll = {
  prefix: 'fad',
  iconName: 'scroll',
  icon: [576, 512, [128220], "f70e", ["M128 96V400c0 44.2 35.8 80 80 80s80-35.8 80-80V384c0-17.7 14.3-32 32-32H480V96c0-35.3-28.7-64-64-64H64c35.3 0 64 28.7 64 64z", "M128 160H32c-17.7 0-32-14.3-32-32V96C0 60.7 28.7 32 64 32s64 28.7 64 64v64zM288 400V384c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32c0 53-43 96-96 96H208c44.2 0 80-35.8 80-80z"]]
};
var faSpa = {
  prefix: 'fad',
  iconName: 'spa',
  icon: [576, 512, [], "f5bb", ["M183.1 235.3c44 27.1 80.3 65.5 104.9 111.6c24.5-46 60.9-84.5 104.9-111.6c-19.6-113-73.8-178.8-91.3-197.7C298 33.9 293.1 32 288 32s-10 1.9-13.5 5.6c-17.5 18.8-71.8 84.7-91.3 197.7z", "M267.9 480H288h20.1C456.1 480 576 360.1 576 212.1c0-11.1-9-20.1-20.1-20.1H546c-110.8 0-208.5 62-258 154.9C238.5 254 140.8 192 30 192H20.1C9 192 0 201 0 212.1C0 360.1 119.9 480 267.9 480z"]]
};
var faArrowLeftFromLine = {
  prefix: 'fad',
  iconName: 'arrow-left-from-line',
  icon: [448, 512, [8612, "arrow-from-right"], "f344", ["M416 448c-17.7 0-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32z", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224l66.7 0 112 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-112 0-66.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"]]
};
var faArrowFromRight = faArrowLeftFromLine;
var faStrawberry = {
  prefix: 'fad',
  iconName: 'strawberry',
  icon: [512, 512, [], "e32b", ["M192.2 64C96.2 64 0 160 0 336C0 464 48 512 176 512c176 0 272-96 272-192c0-32.8-12.5-65.5-37.5-90.5l-128-128C257.6 76.6 224.9 64.1 192.2 64zm-10.8 74.5c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm55.3 98.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 96c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 96c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm104.7-66.3c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm32-96c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm55.3 98.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-224-96c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-23.3 61.7c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7z", "M481.5 1.9c12.2 5.2 17.8 19.3 12.6 31.5c-13.4 31.2-36.9 59-56.3 78.7c32.8 1.8 57.4 18 68.2 26.6c4 3.2 6 8.1 6 13.2s-2 10-6 13.3C495 174.4 469.7 192 440 192c-40 0-55.3-15.3-80-40s-40-40-40-80c0-29.7 17.6-55 26.7-66c3.3-4 8.2-6 13.3-6s10 2 13.2 6C382.3 17.4 400 44.3 400 80c0 .7 0 1.4 0 2.1c.7-.7 1.4-1.3 2-2c18.2-18.2 37.7-41.7 47.9-65.5c5.2-12.2 19.3-17.8 31.5-12.6zm-300 136.6c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm55.3 98.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 96c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 96c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm104.7-66.3c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm32-96c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm55.3 98.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-224-96c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-23.3 61.7c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7z"]]
};
var faLocationPinLock = {
  prefix: 'fad',
  iconName: 'location-pin-lock',
  icon: [512, 512, [], "e51f", ["M256 446.8c-15.3 20.6-29.3 38.6-40.3 52.3c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0c95.7 0 175 70 189.6 161.5C328.5 170.3 288 216.4 288 272v24.6c-19.1 11.1-32 31.7-32 55.4v94.8zM256 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z", "M368 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faPause = {
  prefix: 'fad',
  iconName: 'pause',
  icon: [320, 512, [9208], "f04c", ["M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z", ""]]
};
var faClockEightThirty = {
  prefix: 'fad',
  iconName: 'clock-eight-thirty',
  icon: [512, 512, [], "e346", ["M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V300.8L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M256 416c-13.3 0-24-10.7-24-24V300.8L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256V392c0 13.3-10.7 24-24 24z"]]
};
var faPlaneEngines = {
  prefix: 'fad',
  iconName: 'plane-engines',
  icon: [576, 512, [9992, "plane-alt"], "f3de", ["M368 192L265.3 15.9C259.5 6 249 0 237.6 0H181.3C170.7 0 163 10.2 166 20.5L216 192H368zm0 128H216L166 491.5c-3 10.2 4.7 20.5 15.4 20.5h56.3c11.4 0 21.9-6 27.6-15.9L368 320z", "M576 256c0-35-59.5-64-93.7-64L112 192 68.8 134.4c-3-4-7.8-6.4-12.8-6.4l-42 0c-7.8 0-14 6.3-14 14c0 1.3 .2 2.6 .5 3.9l22.7 79.3C9.8 229 0 241.4 0 256s9.8 27 23.2 30.8L.5 366.1c-.4 1.3-.5 2.6-.5 3.9c0 7.8 6.3 14 14 14l42 0c5 0 9.8-2.4 12.8-6.4L112 320l370.3 0c34.2 0 93.7-28 93.7-64zM329.8 126.5C342.7 122.3 352 110.3 352 96c0-17.7-14.3-32-32-32l-26.7 0 36.4 62.5zm0 259L293.3 448l26.7 0c17.7 0 32-14.3 32-32c0-14.3-9.3-26.3-22.2-30.5z"]]
};
var faPlaneAlt = faPlaneEngines;
var faHillAvalanche = {
  prefix: 'fad',
  iconName: 'hill-avalanche',
  icon: [576, 512, [], "e507", ["M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4s-90.1-34.4-124.5 0l33.9 33.9c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9zM480 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M54.6 73.4c-9.2-9.2-22.9-11.9-34.9-6.9S0 83.1 0 96V480c0 17.7 14.3 32 32 32H416c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-384-384z"]]
};
var faTemperatureEmpty = {
  prefix: 'fad',
  iconName: 'temperature-empty',
  icon: [320, 512, ["temperature-0", "thermometer-0", "thermometer-empty"], "f2cb", ["M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M112 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]]
};
var faTemperature0 = faTemperatureEmpty;
var faThermometer0 = faTemperatureEmpty;
var faThermometerEmpty = faTemperatureEmpty;
var faBomb = {
  prefix: 'fad',
  iconName: 'bomb',
  icon: [512, 512, [128163], "f1e2", ["M504.8 69.2L459.1 52.4 442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4z", "M281.4 105.4c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3l2.9-2.9zM96 296c0-57.4 46.6-104 104-104h8c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8c-75.1 0-136 60.9-136 136v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8z"]]
};
var faGaugeLow = {
  prefix: 'fad',
  iconName: 'gauge-low',
  icon: [512, 512, ["tachometer-alt-slow"], "f627", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-.6 0-1.3 0-1.9 0L190 142.3c-5.3-12.1-19.5-17.6-31.6-12.3s-17.6 19.5-12.3 31.6l64.1 145.7C198.9 318.9 192 334.6 192 352c0 35.3 28.7 64 64 64zM128 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M190 142.3c-5.3-12.1-19.5-17.6-31.6-12.3s-17.6 19.5-12.3 31.6l64.1 145.7C198.9 318.9 192 334.6 192 352c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-.6 0-1.3 0-1.9 0L190 142.3z"]]
};
var faTachometerAltSlow = faGaugeLow;
var faRegistered = {
  prefix: 'fad',
  iconName: 'registered',
  icon: [512, 512, [174], "f25d", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z", "M184 128c-13.3 0-24 10.7-24 24V264v96c0 13.3 10.7 24 24 24s24-10.7 24-24V288h60.9l37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80H184zm88 112H208V176h64c17.7 0 32 14.3 32 32s-14.3 32-32 32z"]]
};
var faTrashCanPlus = {
  prefix: 'fad',
  iconName: 'trash-can-plus',
  icon: [448, 512, [], "e2ac", ["M416 96H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V96zM200 376V312H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V200c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM200 376V312H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V200c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]]
};
var faAddressCard = {
  prefix: 'fad',
  iconName: 'address-card',
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M176 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H144z"]]
};
var faContactCard = faAddressCard;
var faVcard = faAddressCard;
var faScaleUnbalancedFlip = {
  prefix: 'fad',
  iconName: 'scale-unbalanced-flip',
  icon: [640, 512, ["balance-scale-right"], "f516", ["M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42z", "M128 163.8L55.6 288H200.4L128 163.8zM254 305.1C243.2 350 190.9 384 128 384S12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1zm256.9-13.3L438.4 416H583.3L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"]]
};
var faBalanceScaleRight = faScaleUnbalancedFlip;
var faGlobeSnow = {
  prefix: 'fad',
  iconName: 'globe-snow',
  icon: [448, 512, [], "f7a3", ["M448 224c0 71.4-33.4 135-85.4 176H256V352h64c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 256H288c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64v48H85.4C33.4 359 0 295.4 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM256 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z", "M235.3 164.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64v48H85.4L21.7 473.4c-3.7 4.2-5.7 9.7-5.7 15.3C16 501.6 26.4 512 39.3 512H408.7c12.9 0 23.3-10.4 23.3-23.3c0-5.6-2-11-5.7-15.3L362.6 400H256V352h64c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 256H288c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64z"]]
};
var faSubscript = {
  prefix: 'fad',
  iconName: 'subscript',
  icon: [512, 512, [], "f12c", ["M0 96C0 78.3 14.3 64 32 64H64c10.4 0 20.2 5.1 26.2 13.6L176 200.2 261.8 77.6c6-8.6 15.8-13.6 26.2-13.6h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H304.7L215.1 256l89.6 128H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c-10.4 0-20.2-5.1-26.2-13.6L176 311.8 90.2 434.4C84.2 442.9 74.4 448 64 448H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H47.3l89.6-128L47.3 128H32C14.3 128 0 113.7 0 96z", "M464.8 292.8c9.4 5.8 15.2 16.1 15.2 27.2V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H448 416c-17.7 0-32-14.3-32-32s14.3-32 32-32V368c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l32-16c9.9-5 21.7-4.4 31.1 1.4z"]]
};
var faDiamondTurnRight = {
  prefix: 'fad',
  iconName: 'diamond-turn-right',
  icon: [512, 512, ["directions"], "f5eb", ["M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z", "M297.9 145.2c6-2.5 12.9-1.1 17.4 3.5l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8V264H224c-8.8 0-16 7.2-16 16v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V280c0-35.3 28.7-64 64-64h64V160c0-6.5 3.9-12.3 9.9-14.8z"]]
};
var faDirections = faDiamondTurnRight;
var faIntegral = {
  prefix: 'fad',
  iconName: 'integral',
  icon: [320, 512, [], "f667", ["M216 64c-13.3 0-24 10.7-24 24V424c0 48.6-39.4 88-88 88s-88-39.4-88-88v-8c0-17.7 14.3-32 32-32s32 14.3 32 32v8c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-48.6 39.4-88 88-88s88 39.4 88 88v8c0 17.7-14.3 32-32 32s-32-14.3-32-32V88c0-13.3-10.7-24-24-24z", ""]]
};
var faBurst = {
  prefix: 'fad',
  iconName: 'burst',
  icon: [512, 512, [], "e4dc", ["M7 7c8.2-8.2 21-9.4 30.5-2.8l163.3 112 32.3-99.6C236.4 6.7 245.6 0 256 0s19.6 6.7 22.8 16.6l34.5 106.5 70.4-25.7c8.8-3.2 18.6-1 25.2 5.6s8.8 16.4 5.6 25.2l-25.7 70.4 106.5 34.5c9.9 3.2 16.6 12.4 16.6 22.8s-6.7 19.6-16.6 22.8L392.3 312.2l52.9 100.6c4.9 9.3 3.2 20.7-4.3 28.1s-18.8 9.2-28.1 4.3L312.2 392.3 278.8 495.4c-3.2 9.9-12.4 16.6-22.8 16.6s-19.6-6.7-22.8-16.6L199.8 392.3 99.2 445.2c-9.3 4.9-20.7 3.2-28.1-4.3s-9.2-18.8-4.3-28.1l52.9-100.6L16.6 278.8C6.7 275.6 0 266.4 0 256s6.7-19.6 16.6-22.8l99.6-32.3L4.2 37.6C-2.3 28-1.1 15.2 7 7zM285.1 185.8L256 96l-29.1 89.8L96 96l89.8 130.9L96 256l89.8 29.1-45.6 86.8 86.8-45.6L256 416l29.1-89.8 86.8 45.6-45.6-86.8L416 256l-89.8-29.1 23.6-64.7-64.7 23.6z", "M256 96l29.1 89.8 64.7-23.6-23.6 64.7L416 256l-89.8 29.1 45.6 86.8-86.8-45.6L256 416l-29.1-89.8-86.8 45.6 45.6-86.8L96 256l89.8-29.1L96 96l130.9 89.8L256 96z"]]
};
var faHouseLaptop = {
  prefix: 'fad',
  iconName: 'house-laptop',
  icon: [640, 512, ["laptop-house"], "e066", ["M261.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S18.8 256 32 256H64V368c0 26.5 21.5 48 48 48H272V288H208c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v37.7c11.7-13.3 28.9-21.7 48-21.7H480c0-8.8-3.6-17.3-10.3-23.5l-208-192z", "M352 448H544V304H352V448zm-48 0V288c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H544 352 304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32z"]]
};
var faLaptopHouse = faHouseLaptop;
var faFaceTired = {
  prefix: 'fad',
  iconName: 'face-tired',
  icon: [512, 512, [128555, "tired"], "f5c8", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z", "M116 157.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm280 0c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]]
};
var faTired = faFaceTired;
var faMoneyBills = {
  prefix: 'fad',
  iconName: 'money-bills',
  icon: [640, 512, [], "e1f3", ["M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120zM224 96c0 35.3-28.7 64-64 64v96c35.3 0 64 28.7 64 64H512c0-35.3 28.7-64 64-64V160c-35.3 0-64-28.7-64-64H224zm64 112a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM512 96c0 35.3 28.7 64 64 64v96c-35.3 0-64 28.7-64 64H224c0-35.3-28.7-64-64-64V160c35.3 0 64-28.7 64-64H512z"]]
};
var faBlindsRaised = {
  prefix: 'fad',
  iconName: 'blinds-raised',
  icon: [512, 512, [], "f8fd", ["M128 128H20.4C9.1 128 0 118.9 0 107.6c0-2.4 .4-4.7 1.2-7L32 16H480l30.8 84.6c.8 2.2 1.2 4.6 1.2 7c0 11.3-9.1 20.4-20.4 20.4H160V32H128v96zm0 32v64H20.1C9 224 0 215 0 203.9c0-2.6 .5-5.1 1.4-7.5L16 160H128zm32 64V160H496l14.6 36.4c1 2.4 1.4 4.9 1.4 7.5c0 11.1-9 20.1-20.1 20.1H160z", "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H160V418.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V64H32C14.3 64 0 49.7 0 32z"]]
};
var faSmog = {
  prefix: 'fad',
  iconName: 'smog',
  icon: [640, 512, [], "f75f", ["M640 392c0-13.3-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24zm-64 96c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24zm-192 0c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24zM200 368H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24z", "M176 288C96.5 288 32 223.5 32 144S96.5 0 176 0c34.5 0 66.1 12.1 90.9 32.3C289.6 12.2 319.4 0 352 0c49.1 0 91.8 27.7 113.2 68.3C475 65.5 485.3 64 496 64c61.9 0 112 50.1 112 112s-50.1 112-112 112H468.7c-22.6 19.9-52.2 32-84.7 32s-62.1-12.1-84.7-32H176z"]]
};
var faUfoBeam = {
  prefix: 'fad',
  iconName: 'ufo-beam',
  icon: [576, 512, [], "e048", ["M288 192c110.8 0 144-53.3 144-53.3C432 74.7 385.9 0 288 0S144 74.7 144 138.7c0 0 33.2 53.3 144 53.3zM2.3 477.7c-5.7 12-.6 26.3 11.4 32s26.3 .6 32-11.4l92.2-194.7c-16.7-4-32.3-8.6-46.6-13.8L2.3 477.7zm528 20.5c5.7 12 20 17.1 32 11.4s17.1-20 11.4-32l-89-187.9c-14.2 5.2-29.9 9.8-46.6 13.8l92.2 194.7z", "M288 192c110.8 0 144-53.3 144-53.3c0-9.3-1-18.8-2.9-28.3C516.8 129.5 576 166.1 576 208c0 61.9-128.9 112-288 112S0 269.9 0 208c0-41.9 59.2-78.5 146.9-97.7c-2 9.5-2.9 19-2.9 28.3c0 0 33.2 53.3 144 53.3zM120 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]]
};
var faCircleCaretUp = {
  prefix: 'fad',
  iconName: 'circle-caret-up',
  icon: [512, 512, ["caret-circle-up"], "f331", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-368c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H152c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z", "M273.6 151.7c-4.5-4.9-10.9-7.7-17.6-7.7s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9s12.5 14.4 22 14.4H360c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"]]
};
var faCaretCircleUp = faCircleCaretUp;
var faUserVneckHairLong = {
  prefix: 'fad',
  iconName: 'user-vneck-hair-long',
  icon: [448, 512, [], "e463", ["M257.9 66.2C241 93.7 210.6 112 176 112H128l0 32c0 53 43 96 96 96s96-43 96-96l0-48h-8c-22.8 0-42.8-11.9-54.1-29.8z", "M176 112H128h0v32c0 53 43 96 96 96s96-43 96-96V128h0V96h-8c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112zm48 160H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128h0C96 57.3 153.3 0 224 0c70.6 0 127.8 57.1 128 127.6v.8l0 .2V139c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224zm-78.1 42.9L210.7 412c6.3 9.5 20.3 9.5 26.6 0l64.8-97.1c3.5-5.2 9.8-8 15.9-6.6c74.5 17.2 130 84 130 163.7v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-79.7 55.5-146.5 130-163.7c6.1-1.4 12.4 1.4 15.9 6.6z"]]
};
var faSquareALock = {
  prefix: 'fad',
  iconName: 'square-a-lock',
  icon: [576, 512, [], "e44d", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v65.1c-54.3 7.8-96 54.4-96 110.9v24.6c-9.9 5.7-18.1 14-23.8 24L245.8 141.9c-3.9-8.5-12.4-13.9-21.8-13.9s-17.9 5.4-21.8 13.9l-96 208c-5.6 12-.3 26.3 11.7 31.8s26.3 .3 31.8-11.7l12-26.1H286.2l12 26.1c4 8.8 12.7 13.9 21.8 13.9v96H64c-35.3 0-64-28.7-64-64V96zM264 296H184l40-86.7L264 296z", "M432 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faCrutch = {
  prefix: 'fad',
  iconName: 'crutch',
  icon: [512, 512, [], "f7f7", ["M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3z", "M201.4 153.4L298.7 56 344 101.3 269.3 176 336 242.7 410.7 168 456 213.3l-97.3 97.3c0 0-.1 .1-.1 .1s-.1 .1-.1 .1l-34.7 34.7c-12.9 12.9-29.2 21.9-47.1 25.8L169.1 395.2c-5.9 1.3-11.4 4.3-15.7 8.6L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l98.8-98.8c4.3-4.3 7.3-9.7 8.6-15.7l23.9-107.6c4-17.8 12.9-34.1 25.8-47.1l34.8-34.8zM224 221.3l-12.2 12.2c-4.3 4.3-7.3 9.7-8.6 15.7l-17 76.7 76.7-17c5.9-1.3 11.4-4.3 15.7-8.6L290.7 288 224 221.3z"]]
};
var faGasPumpSlash = {
  prefix: 'fad',
  iconName: 'gas-pump-slash',
  icon: [640, 512, [], "f5f4", ["M558.6 412.5C569.5 397.9 576 379.7 576 360V224 192 168 154.5c0-17-6.7-33.3-18.7-45.3L480 32c-8.8-8.8-23.2-8.8-32 0s-8.8 23.2 0 32l32 32v64c0 29.8 20.4 54.9 48 62V360c0 8.5-2.7 16.4-7.2 22.9l37.8 29.6zM384 275.7V64c0-35.3-28.7-64-64-64H160c-30.9 0-56.7 21.9-62.7 51L384 275.7zM96 171.6V416H384V398.5L96 171.6zM64 480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faFontAwesome = {
  prefix: 'fad',
  iconName: 'font-awesome',
  icon: [448, 512, [62501, 62694, "font-awesome-flag", "font-awesome-logo-full"], "f2b4", ["M64 140.7c15.3-3 28.2-7.9 41.2-12.8c21.2-8 42.5-15.9 74-15.9c31.4 0 53 8 74.6 16c21.6 8 43.3 16 74.7 16c20.4 0 35.6-3 55.5-9.3v208c-19.9 6.3-35.1 9.3-55.5 9.3c-31.4 0-53.1-8-74.7-16c-21.6-8-43.3-16-74.6-16c-20.6 0-36.6 3.6-51.2 8.2v64c14.6-4.6 30.6-8.2 51.2-8.2c31.4 0 53 8 74.6 16c21.6 8 43.3 16 74.7 16s50-6.8 93.3-22.5c7.8-2.9 16.5-6 26.2-9.5V48c-9.7 3.5-18.4 6.6-26.2 9.5C378.6 73.2 360 80 328.5 80s-53.1-8-74.7-16c-21.6-8-43.3-16-74.6-16c-31.5 0-52.8 8-74 15.9c-13 4.9-25.9 9.7-41.2 12.8v64z", "M64 76.7V64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V140.7v-64z"]]
};
var faFontAwesomeFlag = faFontAwesome;
var faFontAwesomeLogoFull = faFontAwesome;
var faCloudArrowUp = {
  prefix: 'fad',
  iconName: 'cloud-arrow-up',
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", ["M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z", "M223 297c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39L344 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-134.1-39 39c-9.4 9.4-24.6 9.4-33.9 0z"]]
};
var faCloudUpload = faCloudArrowUp;
var faCloudUploadAlt = faCloudArrowUp;
var faPalette = {
  prefix: 'fad',
  iconName: 'palette',
  icon: [512, 512, [127912], "f53f", ["M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-96 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faTransporter4 = {
  prefix: 'fad',
  iconName: 'transporter-4',
  icon: [512, 512, [], "e2a5", ["M224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224zm-48 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM480 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 160l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 160zM56.7 358.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 384 6.6 391.3C2.7 392.4 0 395.9 0 400s2.7 7.6 6.6 8.7L32 416l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 416l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 384l-7.3-25.4z", "M128 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z"]]
};
var faChartMixedUpCircleCurrency = {
  prefix: 'fad',
  iconName: 'chart-mixed-up-circle-currency',
  icon: [576, 512, [], "e5d8", ["M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.8L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L480 105v39c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H400zM160 256V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32s-32 14.3-32 32z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L374 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L396.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z"]]
};
var faObjectsAlignRight = {
  prefix: 'fad',
  iconName: 'objects-align-right',
  icon: [512, 512, [], "e3bf", ["M384 112c0-26.5-21.5-48-48-48L48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-64zm0 224c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64z", "M488 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24z"]]
};
var faArrowsTurnRight = {
  prefix: 'fad',
  iconName: 'arrows-turn-right',
  icon: [448, 512, [], "e4c0", ["M246.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 352H96c-53 0-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448c0-17.7 14.3-32 32-32H242.7l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96z", "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96H128C57.3 96 0 153.3 0 224v32c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-35.3 28.7-64 64-64H338.7l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96z"]]
};
var faVest = {
  prefix: 'fad',
  iconName: 'vest',
  icon: [448, 512, [], "e085", ["M224 88c-31.4 0-55.4-8.3-72.8-18.3L131.6 10.9C129.5 4.6 123.7 .3 117.1 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c-6.6 .3-12.4 4.6-14.6 10.9L296.8 69.7C279.4 79.7 255.4 88 224 88zM123.3 356.7c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l48-48c6.2-6.2 16.4-6.2 22.6 0zm201.4 0c6.2-6.2 16.4-6.2 22.6 0l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6z", "M131.6 10.9C129.5 4.4 123.4 0 116.5 0H112C85.5 0 64 21.5 64 48v97.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48H176c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1L131.6 10.9zM224 295.8V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6V48c0-26.5-21.5-48-48-48h-4.5c-6.9 0-13 4.4-15.2 10.9L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2zm123.3 60.9l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-246.6 0c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l48-48z"]]
};
var faPig = {
  prefix: 'fad',
  iconName: 'pig',
  icon: [640, 512, [128022], "f706", ["M513.5 32c8 0 14.5 6.5 14.5 14.5V78c0 19.7-9 37.8-23.6 49.7c6.4 4.9 12.7 10.1 18.6 15.7c17.6-15.9 28.5-38.6 29-63.3h40c8.8 0 16 7.2 16 16v16c0 32.8-24.6 59.8-56.3 63.5l6.8 9C570 200 585 212.5 602.2 221.1L608 224h8c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24H572.5c-22.2 21.2-49.7 36.2-79.8 43.3l-13 45.5C475.8 470.5 463.3 480 449 480H416c-17.7 0-32-14.3-32-32V416H320 272v32c0 17.7-14.3 32-32 32H207c-14.3 0-26.8-9.5-30.8-23.2L155 382.4C110.3 358 80 310.5 80 256V240c0-88.4 71.6-160 160-160H362.4c14.5 0 28.8 1.3 42.7 3.9c8.1-19.5 25.4-34.4 47-39.1l58.4-12.5c1-.2 2-.3 3-.3zM476 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z", "M80 240c0-11 1.1-21.7 3.2-32H47.4c-8.5 0-15.4-6.9-15.4-15.4c0-7.1 4.8-13.3 11.7-15l8.2-2c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-8.2 2C14.8 151.8 0 170.8 0 192.6C0 218.8 21.2 240 47.4 240H80zm396 16a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]]
};
var faInboxFull = {
  prefix: 'fad',
  iconName: 'inbox-full',
  icon: [512, 512, [], "e1ba", ["M121 96H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96zm55 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-32 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z", "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"]]
};
var faCircleEnvelope = {
  prefix: 'fad',
  iconName: 'circle-envelope',
  icon: [512, 512, ["envelope-circle"], "e10c", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v9.3L264.7 255.6c-2.7 1.2-5.7 1.9-8.7 1.9s-5.9-.6-8.7-1.9L128 201.3V192zm149.9 92.7L384 236.5V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V236.5l106.1 48.3c6.9 3.1 14.3 4.8 21.9 4.8s15-1.6 21.9-4.8z", "M160 160c-17.7 0-32 14.3-32 32v9.3l119.3 54.3c2.7 1.2 5.7 1.9 8.7 1.9s5.9-.6 8.7-1.9L384 201.3V192c0-17.7-14.3-32-32-32H160zm224 76.5L277.9 284.7c-6.9 3.1-14.3 4.8-21.9 4.8s-15-1.6-21.9-4.8L128 236.5V320c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V236.5z"]]
};
var faEnvelopeCircle = faCircleEnvelope;
var faTrianglePersonDigging = {
  prefix: 'fad',
  iconName: 'triangle-person-digging',
  icon: [640, 512, ["construction"], "f85d", ["M354.5 51.8C347.3 39.5 334.2 32 320 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S89.7 480 104 480H536c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368zM216.9 304.7l15.6 9.8 64 40c4.7 2.9 7.5 8.1 7.5 13.6v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V376.9l-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8zm112-45.7l19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1H384c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8c22.7 0 43.2 13.8 51.6 34.9zM288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm40.8 74.9l19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1H384c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8c22.7 0 43.2 13.8 51.6 34.9zm-96.3 55.5l64 40c4.7 2.9 7.5 8.1 7.5 13.6v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V376.9l-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8 15.6 9.8z"]]
};
var faConstruction = faTrianglePersonDigging;
var faFerry = {
  prefix: 'fad',
  iconName: 'ferry',
  icon: [576, 512, [], "e4ea", ["M269.5 421.9c11.1-7.9 25.9-7.9 37 0C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1z", "M192 32H116.9C96.3 32 85.3 56.3 98.8 71.8L120 96H456l21.2-24.2C490.8 56.3 479.7 32 459.1 32H384c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zm288 96H96c-17.7 0-32 14.3-32 32V283.5c0 13.3 4.2 26.3 11.9 37.2l51.4 71.9c1.9 1.1 3.8 2.2 5.6 3.5c15.5 10.7 34 18 51 19.9h16.6c18.2-1.9 35.8-9.7 50.6-19.9c22.1-15.5 51.6-15.5 73.7 0c15.8 10.9 33.7 18.1 50.8 19.9h16.5c17-1.8 35.6-9.2 51-19.9c1.8-1.3 3.6-2.4 5.5-3.5l51.4-71.9c7.8-10.9 11.9-23.9 11.9-37.2V160c0-17.7-14.3-32-32-32zm-32 64v96H128V192H448z"]]
};
var faBullseyeArrow = {
  prefix: 'fad',
  iconName: 'bullseye-arrow',
  icon: [512, 512, [127919], "f648", ["M335.2 244.7c.5 3.7 .8 7.5 .8 11.3c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80c3.8 0 7.6 .3 11.3 .8l31.2-31.2L293.7 117c-12-3.3-24.7-5-37.7-5c-79.5 0-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144c0-13.1-1.7-25.7-5-37.7l-28.6-4.8-31.2 31.2zm110.1-20.8c1.8 10.4 2.7 21.1 2.7 32.1c0 106-86 192-192 192S64 362 64 256S150 64 256 64c10.9 0 21.6 .9 32.1 2.7l9.3-9.3 43.1-43.1C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5l-43.1 43.1-9.3 9.3z", "M331.2 146.9l-8.4-50.7c-1.7-10.2 1.6-20.6 8.9-27.9l51.2-51.2C391 9 404.7 11.9 409 22.5L432 80l57.5 23c10.7 4.3 13.5 18 5.4 26.2l-51.2 51.2c-7.3 7.3-17.7 10.6-27.9 8.9l-50.7-8.4L273 273c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l92.1-92.1z"]]
};
var faArrowsDownToPeople = {
  prefix: 'fad',
  iconName: 'arrows-down-to-people',
  icon: [640, 512, [], "e4b9", ["M360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5z", "M144 0c-13.3 0-24 10.7-24 24V142.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"]]
};
var faSeedling = {
  prefix: 'fad',
  iconName: 'seedling',
  icon: [512, 512, [127793, "sprout"], "f4d8", ["M480 0c17.7 0 32 14.3 32 32c0 123.7-100.3 224-224 224h-2.3c-5.9-41.1-22.9-78.7-48-109.4C269.2 61 351.5 0 448 0h32z", "M32 64C14.3 64 0 78.3 0 96C0 219.7 100.3 320 224 320V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320 288C288 164.3 187.7 64 64 64H32z"]]
};
var faSprout = faSeedling;
var faClockSeven = {
  prefix: 'fad',
  iconName: 'clock-seven',
  icon: [512, 512, [], "e350", ["M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V248.7l-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z", "M256 96c-13.3 0-24 10.7-24 24V248.7l-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3V120c0-13.3-10.7-24-24-24z"]]
};
var faLeftRight = {
  prefix: 'fad',
  iconName: 'left-right',
  icon: [512, 512, [8596, "arrows-alt-h"], "f337", ["M512 256c0-6.7-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-96 0 0 96 96 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104c4.9-4.5 7.7-10.9 7.7-17.6z", "M0 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 56 96 0 0 96-96 0 0 56c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104C2.8 269 0 262.7 0 256z"]]
};
var faArrowsAltH = faLeftRight;
var faBoxesPacking = {
  prefix: 'fad',
  iconName: 'boxes-packing',
  icon: [640, 512, [], "e4c7", ["M304 0c-26.5 0-48 21.5-48 48v80H368c26.5 0 48 21.5 48 48v32c0 20.9-13.4 38.7-32 45.3V496c0 5.6-1 11-2.7 16H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H304zM571.3 324.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 310.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-121.4-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64z", "M16 160H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm16 96H352V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256zm96 80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16z"]]
};
var faCircleArrowLeft = {
  prefix: 'fad',
  iconName: 'circle-arrow-left',
  icon: [512, 512, ["arrow-circle-left"], "f0a8", ["M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z", "M119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273z"]]
};
var faArrowCircleLeft = faCircleArrowLeft;
var faFlashlight = {
  prefix: 'fad',
  iconName: 'flashlight',
  icon: [640, 512, [128294], "f8b8", ["M576 96c-112 0-192 64-192 64H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H384s80 64 192 64V96zM224 256c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32z", "M608 96H576V416h32c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zM256 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H256z"]]
};
var faGroupArrowsRotate = {
  prefix: 'fad',
  iconName: 'group-arrows-rotate',
  icon: [512, 512, [], "e4f6", ["M222.7 32.2c5 16.9-4.6 34.8-21.5 39.8c-14.6 4.3-28.5 10.4-41.4 17.9c.2 2 .3 4.1 .3 6.1c0 35.3-28.7 64-64 64c-2.1 0-4.1-.1-6.1-.3c-7.5 12.9-13.6 26.8-17.9 41.4c-5 16.9-22.9 26.6-39.8 21.5s-26.6-22.9-21.5-39.8c6.4-21.5 15.5-41.8 27-60.6C34 114.3 32 105.4 32 96c0-35.3 28.7-64 64-64c9.4 0 18.3 2 26.3 5.6c18.7-11.5 39-20.6 60.6-27c16.9-5 34.8 4.6 39.8 21.5zm66.7 0c5-16.9 22.9-26.6 39.8-21.5c21.5 6.4 41.8 15.5 60.6 27c8-3.6 16.9-5.6 26.3-5.6c35.3 0 64 28.7 64 64c0 9.4-2 18.3-5.6 26.3c11.5 18.7 20.6 39 27 60.6c5 16.9-4.6 34.8-21.5 39.8s-34.8-4.6-39.8-21.5c-4.3-14.6-10.4-28.5-17.9-41.4c-2 .2-4.1 .3-6.2 .3c-35.3 0-64-28.7-64-64c0-2.1 .1-4.1 .3-6.1c-12.9-7.5-26.8-13.6-41.4-17.9c-16.9-5-26.6-22.9-21.5-39.8zM32.1 289.3c16.9-5 34.8 4.6 39.8 21.5c4.3 14.6 10.4 28.5 17.9 41.4c2-.2 4.1-.3 6.2-.3c35.3 0 64 28.7 64 64c0 2.1-.1 4.1-.3 6.2c12.9 7.5 26.8 13.6 41.4 17.9c16.9 5 26.6 22.9 21.5 39.8s-22.9 26.6-39.8 21.5c-21.5-6.4-41.8-15.5-60.6-27c-8 3.6-16.9 5.6-26.3 5.6c-35.3 0-64-28.7-64-64c0-9.4 2-18.3 5.6-26.3c-11.5-18.7-20.6-39-27-60.6c-5-16.9 4.6-34.8 21.5-39.8zm447.7 0c16.9 5 26.6 22.9 21.5 39.8c-6.4 21.5-15.5 41.8-27 60.6c3.6 8 5.6 16.9 5.6 26.3c0 35.3-28.7 64-64 64c-9.4 0-18.3-2-26.3-5.6c-18.7 11.5-39 20.6-60.6 27c-16.9 5-34.8-4.6-39.8-21.5s4.6-34.8 21.5-39.8c14.6-4.3 28.5-10.4 41.4-17.9c-.2-2-.3-4.1-.3-6.2c0-35.3 28.7-64 64-64c2.1 0 4.1 .1 6.2 .3c7.5-12.9 13.6-26.8 17.9-41.4c5-16.9 22.9-26.6 39.8-21.5z", "M227.7 313.8c-20.8-10.6-34.9-32.2-34.9-57c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4l0-60.5c0-5.7-4.7-10.4-10.4-10.4l-60.5 0c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3zm93.1-58.6c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4l0 60.5c0 5.7 4.7 10.4 10.4 10.4l60.5 0c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3c20.8 10.6 34.9 32.2 34.9 57z"]]
};
var faBowlFood = {
  prefix: 'fad',
  iconName: 'bowl-food',
  icon: [512, 512, [], "e4c6", ["M8.6 224C3.1 214.6 0 203.7 0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6z", "M27.4 256C12.3 256 0 268.3 0 283.4c0 70.5 44.4 130.7 106.7 154.1l1.8 14.4c2 16 15.6 28 31.8 28H371.8c16.1 0 29.8-12 31.8-28l1.8-14.4C467.6 414.1 512 353.9 512 283.4c0-15.1-12.3-27.4-27.4-27.4H27.4z"]]
};
var faSquare9 = {
  prefix: 'fad',
  iconName: 'square-9',
  icon: [448, 512, [], "e25e", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 272a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C305.8 287.2 320 256.4 320 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z", "M272 224a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-74 92.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C305.8 287.2 320 256.4 320 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z"]]
};
var faCandyCane = {
  prefix: 'fad',
  iconName: 'candy-cane',
  icon: [512, 512, [], "f786", ["M288.1 18.8c-2.4 1.3-4.8 2.7-7.1 4.2L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l7.7-4.8-.8-2.4-40-120-.8-2.3zm70.2 109.4c.9-.1 1.8-.2 2.7-.2c.1 0 .3 0 .4 0l0 0 11.3-11.3 80-80 3.2-3.2C429.9 12.6 396.9 0 361 0c-14.7 0-29.3 2.2-43.3 6.3l1.5 4.6 39.1 117.2zm120.2-72l-3.2 3.2-80 80L384 150.6l0 0c0 .1 0 .3 0 .4v.1l5.1 1.7 118.8 39.6c2.7-11.6 4.1-23.6 4.1-35.8V151c0-35.9-12.6-69-33.5-94.9zm18.9 166.5L378.9 183.2l-7.8-2.6c-.2 .1-.4 .3-.6 .4l-71 44.4 117 73.1 3.8 2.4 18.1-11.3c26.2-16.3 46.4-39.7 59-66.8zm-107.3 97L271.5 245.6l-2.2-1.4-77 48.1 112.2 70.1 8.6 5.4 77-48.1zm-107.2 67L162.1 311.2l-73 45.6 111.4 69.6 9.4 5.9 73-45.6zM179.7 451.2L58.9 375.7l-28.8 18C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4l81.8-51.1z", "M329.6 143.5l-.8-2.4-40-120-.8-2.3c9.4-5.2 19.3-9.4 29.6-12.4l1.5 4.6 39.1 117.2c-3.4 .4-6.6 1.5-9.5 3.3l-19.1 12zm54.4 7.2c-.2-12.4-10.2-22.4-22.6-22.6l0 0 11.3-11.3 80-80 3.2-3.2c8.3 6.7 15.9 14.3 22.6 22.6l-3.2 3.2-80 80L384 150.6l0 0zm-12.9 29.9c8-5.3 12.9-14.3 12.9-23.9v-5.5l5.1 1.7 118.8 39.6c-2.5 10.5-6 20.6-10.5 30.2L378.9 183.2l-7.8-2.6zM269.3 244.2l30.2-18.9 117 73.1 3.8 2.4-30.2 18.9L271.5 245.6l-2.2-1.4zm-107.2 67l30.2-18.9 112.2 70.1 8.6 5.4-30.2 18.9L162.1 311.2zM58.9 375.7l30.2-18.9 111.4 69.6 9.4 5.9-30.2 18.9L58.9 375.7z"]]
};
var faArrowDownWideShort = {
  prefix: 'fad',
  iconName: 'arrow-down-wide-short',
  icon: [576, 512, ["sort-amount-asc", "sort-amount-down"], "f160", ["M288 448c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0-128c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0-128c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0-128c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32z", "M128 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L160 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L63.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C110.5 476.2 119 480 128 480z"]]
};
var faSortAmountAsc = faArrowDownWideShort;
var faSortAmountDown = faArrowDownWideShort;
var faSquareDollar = {
  prefix: 'fad',
  iconName: 'square-dollar',
  icon: [448, 512, ["dollar-square", "usd-square"], "f2e9", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM244.8 133.6v14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7V133.6c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z", "M223.2 112c11.9 0 21.6 9.7 21.6 21.6v14.2c11.6 1.4 23.2 5 34.5 8.2c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-8.5-2.3-17.1-4.9-25.8-6.6c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c11.9 7.6 26.8 10.7 40.1 14.5c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c13.7 4.5 27.8 9.9 42 12.1c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-12-8.2-27.5-11.5-41.3-15.4c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7V133.6c0-11.9 9.7-21.6 21.6-21.6z"]]
};
var faDollarSquare = faSquareDollar;
var faUsdSquare = faSquareDollar;
var faPhoneArrowRight = {
  prefix: 'fad',
  iconName: 'phone-arrow-right',
  icon: [512, 512, [], "e5be", ["M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z", "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H312c-13.3 0-24-10.7-24-24s10.7-24 24-24H430.1L391 41c-9.4-9.4-9.4-24.6 0-33.9z"]]
};
var faHandHoldingSeedling = {
  prefix: 'fad',
  iconName: 'hand-holding-seedling',
  icon: [576, 512, [], "f4bf", ["M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z", "M96 14.5C96 6.5 102.5 0 110.5 0H160c88.4 0 160 71.6 160 160v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V160H241.5C161.1 160 96 94.9 96 14.5zm384 0C480 89 424.1 150.3 352 159c-.2-44.9-15.9-86.2-42-118.8C338.2 15.2 375.3 0 416 0h49.5c8 0 14.5 6.5 14.5 14.5z"]]
};
var faMessageCheck = {
  prefix: 'fad',
  iconName: 'message-check',
  icon: [512, 512, ["comment-alt-check"], "f4a2", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm369 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 153z", "M369 119c9.4 9.4 9.4 24.6 0 33.9L241 281c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 119c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faCommentAltCheck = faMessageCheck;
var faCloudBolt = {
  prefix: 'fad',
  iconName: 'cloud-bolt',
  icon: [512, 512, [127785, "thunderstorm"], "f76c", ["M334.3 247.2c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8z", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H352 333.7l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2L143.2 320H96z"]]
};
var faThunderstorm = faCloudBolt;
var faChartLineUpDown = {
  prefix: 'fad',
  iconName: 'chart-line-up-down',
  icon: [512, 512, [], "e5d7", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M358.6 102.6l18.7 18.7L288 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l112-112 18.7 18.7c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6V96.2v-.3V80c0-8.8-7.2-16-16-16H374.6C362.1 64 352 74.1 352 86.6c0 6 2.4 11.8 6.6 16zm64 178.7l-34.7-34.7-45.3 45.3 34.7 34.7-18.7 18.7c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6l89.4 0c8.8 0 16-7.2 16-16V278.6c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6l-18.7 18.7z"]]
};
var faTextSlash = {
  prefix: 'fad',
  iconName: 'text-slash',
  icon: [640, 512, ["remove-format"], "f87d", ["M355.7 253.5L400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2 55.1 43.2c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l54.4 42.7zM327.3 353.9L272.9 311 243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faRemoveFormat = faTextSlash;
var faWatch = {
  prefix: 'fad',
  iconName: 'watch',
  icon: [384, 512, [8986], "f2e1", ["M192 448a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm24-272v67.2L253.3 268c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32C172 271.5 168 264 168 256V176c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M64 48C64 21.5 85.5 0 112 0H272c26.5 0 48 21.5 48 48v64.9C286 82.5 241.2 64 192 64s-94 18.5-128 48.9V48zM192 448c49.2 0 94-18.5 128-48.9V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V399.1C98 429.5 142.8 448 192 448zm24-272v67.2L253.3 268c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32C172 271.5 168 264 168 256V176c0-13.3 10.7-24 24-24s24 10.7 24 24z"]]
};
var faCircleDownLeft = {
  prefix: 'fad',
  iconName: 'circle-down-left',
  icon: [512, 512, [], "e107", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM160 198.6V336c0 8.8 7.2 16 16 16H313.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L296 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7C322 146 317.1 144 312 144s-10 2-13.7 5.7L232 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6z", "M160 336V198.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6L232 216l66.3-66.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7l36.7 36.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L296 280l33.4 33.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H176c-8.8 0-16-7.2-16-16z"]]
};
var faText = {
  prefix: 'fad',
  iconName: 'text',
  icon: [448, 512, [], "f893", ["M64 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V80C0 53.5 21.5 32 48 32H224 400c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H256l0 320h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H144c-17.7 0-32-14.3-32-32s14.3-32 32-32h48l0-320H64z", ""]]
};
var faProjector = {
  prefix: 'fad',
  iconName: 'projector',
  icon: [640, 512, [], "f8d6", ["M440 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM281 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L281 39zM585 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L495 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56-56zm-9 247c0 64-37.5 119.2-91.8 144.8l5.7 23c3.6 14.2 16.4 24.2 31 24.2h14c14.7 0 27.5-10 31-24.2L576 448c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H512c38.9 29.2 64 75.7 64 128zM160 448H320c-38.9-29.2-64-75.7-64-128s25.1-98.8 64-128H64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64l9.9 39.8C77.5 502 90.3 512 105 512h14c14.7 0 27.5-10 31-24.2L160 448zM64 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M512 320a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-256 0a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faFaceSmileWink = {
  prefix: 'fad',
  iconName: 'face-smile-wink',
  icon: [512, 512, [128521, "smile-wink"], "f4da", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm124.4-6.4c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z"]]
};
var faSmileWink = faFaceSmileWink;
var faTombstoneBlank = {
  prefix: 'fad',
  iconName: 'tombstone-blank',
  icon: [448, 512, [129702, "tombstone-alt"], "f721", ["M32 192C32 86 118 0 224 0S416 86 416 192V448H32V192z", "M0 480c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
};
var faTombstoneAlt = faTombstoneBlank;
var faChessKingPiece = {
  prefix: 'fad',
  iconName: 'chess-king-piece',
  icon: [256, 512, ["chess-king-alt"], "f440", ["M208 416H48L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416z", "M128 0c8.8 0 16 7.2 16 16V32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H144V96h51.8c11.2 0 20.2 9.1 20.2 20.2c0 2.5-.5 4.9-1.3 7.3L182.2 208H184c13.3 0 24 10.7 24 24s-10.7 24-24 24h-2.7L208 416H48L74.7 256H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h1.8L41.3 123.5c-.9-2.3-1.3-4.8-1.3-7.3C40 105.1 49.1 96 60.2 96H112V64H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16z"]]
};
var faChessKingAlt = faChessKingPiece;
var faCircle6 = {
  prefix: 'fad',
  iconName: 'circle-6',
  icon: [512, 512, [], "e0f3", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C174.2 224.8 160 255.6 160 288z", "M311.6 170.2c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C174.2 224.8 160 255.6 160 288c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4zM304 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]]
};
var faLeft = {
  prefix: 'fad',
  iconName: 'left',
  icon: [448, 512, ["arrow-alt-left"], "f355", ["M224 320V192H408c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40l-184 0z", "M224 192h0V96c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V320h0V192z"]]
};
var faArrowAltLeft = faLeft;
var faFileWord = {
  prefix: 'fad',
  iconName: 'file-word',
  icon: [384, 512, [], "f1c2", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM111 257.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10 12 16.9 22.4 17.1s19.8-6.2 23.2-16.1L192 336.6l33.3 95.3c3.4 9.8 12.8 16.3 23.2 16.1s19.5-7.1 22.4-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-26.8 89.2-31.6-90.3c-3.4-9.6-12.5-16.1-22.7-16.1s-19.3 6.4-22.7 16.1l-31.6 90.3L111 257.1z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM111 257.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10 12 16.9 22.4 17.1s19.8-6.2 23.2-16.1L192 336.6l33.3 95.3c3.4 9.8 12.8 16.3 23.2 16.1s19.5-7.1 22.4-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-26.8 89.2-31.6-90.3c-3.4-9.6-12.5-16.1-22.7-16.1s-19.3 6.4-22.7 16.1l-31.6 90.3L111 257.1z"]]
};
var faFilePowerpoint = {
  prefix: 'fad',
  iconName: 'file-powerpoint',
  icon: [384, 512, [], "f1c4", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM136 240c-13.3 0-24 10.7-24 24V368v56c0 13.3 10.7 24 24 24s24-10.7 24-24V392h44c42 0 76-34 76-76s-34-76-76-76H136zm68 104H160V288h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM136 240c-13.3 0-24 10.7-24 24V368v56c0 13.3 10.7 24 24 24s24-10.7 24-24V392h44c42 0 76-34 76-76s-34-76-76-76H136zm68 104H160V288h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z"]]
};
var faSquareDown = {
  prefix: 'fad',
  iconName: 'square-down',
  icon: [448, 512, [11015, "arrow-alt-square-down"], "f350", ["M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zm39.1-185.4l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3H272V160c0-17.7-14.3-32-32-32H208c-17.7 0-32 14.3-32 32v96H118.3C106 256 96 266 96 278.3c0 6.2 2.6 12.1 7.1 16.3z", "M210.2 394.5L103.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3C96 266 106 256 118.3 256H176V160c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v96h57.7c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3L237.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5z"]]
};
var faArrowAltSquareDown = faSquareDown;
var faObjectsAlignCenterVertical = {
  prefix: 'fad',
  iconName: 'objects-align-center-vertical',
  icon: [512, 512, [], "e3bd", ["M64 432c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-64 0C85.5 32 64 53.5 64 80l0 352zm224-64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 224z", "M24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0 48-40 0zm264 0l-64 0 0-48 64 0 0 48zm160 0l0-48 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0z"]]
};
var faArrowsLeftRight = {
  prefix: 'fad',
  iconName: 'arrows-left-right',
  icon: [512, 512, ["arrows-h"], "f07e", ["M502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 288 256 288l0-64 146.7 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96z", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 256 288l0-64-146.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96z"]]
};
var faArrowsH = faArrowsLeftRight;
var faHouseLock = {
  prefix: 'fad',
  iconName: 'house-lock',
  icon: [640, 512, [], "e510", ["M392.6 512c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-48.8 31.2-90.3 74.7-105.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64 24c0 22.1 17.9 40 40 40h.6z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faCloudArrowDown = {
  prefix: 'fad',
  iconName: 'cloud-arrow-down',
  icon: [640, 512, [62337, "cloud-download", "cloud-download-alt"], "f0ed", ["M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z", "M223 279c-9.4 9.4-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 134.1-39-39c-9.4-9.4-24.6-9.4-33.9 0z"]]
};
var faCloudDownload = faCloudArrowDown;
var faCloudDownloadAlt = faCloudArrowDown;
var faWreath = {
  prefix: 'fad',
  iconName: 'wreath',
  icon: [448, 512, [], "f7e2", ["M182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 35.3-28.7 64-64 64c-6.3 0-12.5-.9-18.2-2.6c-1.5 4.2-3.4 8.3-5.8 12.1V403.8c0-10.9-8.9-19.8-19.8-19.8c-2.8 0-5.5 .6-8 1.7L224 416l-68.2-30.3c-2.5-1.1-5.3-1.7-8-1.7c-10.9 0-19.8 8.9-19.8 19.8v13.6c-2.3-3.8-4.3-7.8-5.8-12.1c-5.8 1.7-11.9 2.6-18.2 2.6c-35.3 0-64-28.7-64-64c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6C131 17.8 154.7 0 182.6 0zM203 142.4c-5.7 6-13.6 9.4-21.9 9.1c-16.6-.6-30.2 13-29.6 29.6c.3 8.3-3 16.3-9.1 21.9c-12.1 11.3-12.1 30.6 0 41.9c6 5.7 9.4 13.6 9.1 21.9c-.6 16.6 13 30.2 29.6 29.6c8.3-.3 16.3 3 21.9 9.1c11.3 12.1 30.6 12.1 41.9 0c5.7-6 13.6-9.4 21.9-9.1c16.6 .6 30.2-13 29.6-29.6c-.3-8.3 3-16.3 9.1-21.9c12.1-11.3 12.1-30.6 0-41.9c-6-5.7-9.4-13.6-9.1-21.9c.6-16.6-13-30.2-29.6-29.6c-8.3 .3-16.3-3-21.9-9.1c-11.3-12.1-30.6-12.1-41.9 0z", "M128 492.2V403.8c0-10.9 8.9-19.8 19.8-19.8c2.8 0 5.5 .6 8 1.7L224 416l68.2-30.3c2.5-1.1 5.3-1.7 8-1.7c10.9 0 19.8 8.9 19.8 19.8v88.4c0 10.9-8.9 19.8-19.8 19.8c-2.8 0-5.5-.6-8-1.7L224 480l-68.2 30.3c-2.5 1.1-5.3 1.7-8 1.7c-10.9 0-19.8-8.9-19.8-19.8z"]]
};
var faChildren = {
  prefix: 'fad',
  iconName: 'children',
  icon: [640, 512, [], "e4e1", ["M544 64A64 64 0 1 0 416 64a64 64 0 1 0 128 0zM472 480V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5L564.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9H473.8c-33 0-63.7 16.9-81.2 44.9L340.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L408 300.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400H88z"]]
};
var faMeterDroplet = {
  prefix: 'fad',
  iconName: 'meter-droplet',
  icon: [640, 512, [], "e1ea", ["M400.6 467.3C359.5 495.5 309.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C366.8 0 461.2 70.4 496.8 169c-8.5 5.3-15.7 12.9-20.6 22.1L400.9 332.2C389.8 353.1 384 376.4 384 400c0 24.3 6 47.2 16.6 67.3zM160 128c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zm96 0c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zm96 0c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32z", "M429.2 347.3l75.3-141.2c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7z"]]
};
var faChalkboard = {
  prefix: 'fad',
  iconName: 'chalkboard',
  icon: [576, 512, ["blackboard"], "f51b", ["M96 32C60.7 32 32 60.7 32 96V416c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32V96c0-35.3-28.7-64-64-64H96zM480 416H96V96l384 0V416z", "M480 96H96V416H224V384c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v32h64V96z"]]
};
var faBlackboard = faChalkboard;
var faUserLargeSlash = {
  prefix: 'fad',
  iconName: 'user-large-slash',
  icon: [640, 512, ["user-alt-slash"], "f4fa", ["M464 144C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L381.9 274c48.5-23.2 82.1-72.7 82.1-130zm81.5 368H528L284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H545.3l.3 0z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faUserAltSlash = faUserLargeSlash;
var faSignalStrong = {
  prefix: 'fad',
  iconName: 'signal-strong',
  icon: [640, 512, ["signal-4"], "f68f", ["M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32z", "M480 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V128zM352 224c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224zM192 288c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416z"]]
};
var faSignal4 = faSignalStrong;
var faLollipop = {
  prefix: 'fad',
  iconName: 'lollipop',
  icon: [512, 512, [127853, "lollypop"], "e424", ["M303.2 348.5c17.5-12.5 32.8-27.8 45.3-45.3L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L303.2 348.5z", "M48 192c0 57.4 46.6 104 104 104h8c53 0 96-43 96-96v-8c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-61.9 50.1-112 112-112s112 50.1 112 112v8c0 61.6-38.7 114.2-93.2 134.8C281.4 325.6 336 265.2 336 192c0-79.5-64.5-144-144-144S48 112.5 48 192zM0 192a192 192 0 1 1 384 0A192 192 0 1 1 0 192z"]]
};
var faLollypop = faLollipop;
var faListTree = {
  prefix: 'fad',
  iconName: 'list-tree',
  icon: [512, 512, [], "e1d2", ["M160 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM288 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zm32 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M24 48C10.7 48 0 58.7 0 72v48c0 13.3 10.7 24 24 24V256 384c0 30.9 25.1 56 56 56h48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24H80c-4.4 0-8-3.6-8-8V280h56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24H72V144c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H24z"]]
};
var faEnvelopeOpen = {
  prefix: 'fad',
  iconName: 'envelope-open',
  icon: [512, 512, [62135], "f2b6", ["M256 65.9L64 208.1v47.4L222.5 373c9.7 7.2 21.4 11 33.5 11s23.8-3.9 33.5-11L448 255.5V208.1L256 65.9z", "M64 208.1L256 65.9 448 208.1v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5V208.1zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"]]
};
var faDrawCircle = {
  prefix: 'fad',
  iconName: 'draw-circle',
  icon: [512, 512, [], "f5ed", ["M320 64c0 15.1-5.2 29-14 40c48.2 15.8 86.2 53.9 102 102c11-8.8 24.8-14 40-14c8.5 0 16.6 1.7 24.1 4.7c-20.8-76-80.7-135.9-156.7-156.7c3 7.4 4.7 15.5 4.7 24.1zM472.1 315.3c-7.4 3-15.6 4.7-24.1 4.7c-15.1 0-29-5.2-40-14c-15.8 48.2-53.9 86.2-102 102c8.8 11 14 24.8 14 40c0 8.5-1.7 16.6-4.7 24.1c76-20.8 135.9-80.7 156.7-156.7zM196.7 472.1c-3-7.4-4.7-15.6-4.7-24.1c0-15.1 5.2-29 14-40c-48.2-15.8-86.2-53.9-102-102c-11 8.8-24.8 14-40 14c-8.5 0-16.6-1.7-24.1-4.7c20.8 76 80.7 135.9 156.7 156.7zm0-432.1c-76 20.8-135.9 80.7-156.7 156.7c7.4-3 15.6-4.7 24.1-4.7c15.1 0 29 5.2 40 14c15.8-48.2 53.9-86.2 102-102c-8.8-11-14-24.8-14-40c0-8.5 1.7-16.6 4.7-24.1z", "M256 128A64 64 0 1 0 256 0a64 64 0 1 0 0 128zm0 384a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM128 256A64 64 0 1 0 0 256a64 64 0 1 0 128 0zm320 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faCatSpace = {
  prefix: 'fad',
  iconName: 'cat-space',
  icon: [640, 512, [], "e001", ["M288 160a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zm64 0c0 53 43 96 96 96s96-43 96-96V42.7c0-5.9-4.8-10.7-10.7-10.7c-3.4 0-6.5 1.6-8.5 4.3l-40 53.3c-3 4-7.8 6.4-12.8 6.4H424c-5 0-9.8-2.4-12.8-6.4l-40-53.3c-2-2.7-5.2-4.3-8.5-4.3c-5.9 0-10.7 4.8-10.7 10.7V160zM231.5 12.3l10.7 28.8c.8 2.2 2.5 3.9 4.7 4.7l28.8 10.7c7 2.6 7 12.4 0 15L246.9 82.2c-2.2 .8-3.9 2.5-4.7 4.7l-10.7 28.8c-2.6 7-12.4 7-15 0L205.8 86.9c-.8-2.2-2.5-3.9-4.7-4.7L172.3 71.5c-7-2.6-7-12.4 0-15l28.8-10.7c2.2-.8 3.9-2.5 4.7-4.7l10.7-28.8c2.6-7 12.4-7 15 0z", "M352 42.7c0-5.9 4.8-10.7 10.7-10.7c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3c5.9 0 10.7 4.8 10.7 10.7V160c0 53-43 96-96 96s-96-43-96-96V42.7zM416 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM160 277.8c29.4-44.3 76.8-75.6 131.6-83.8C307.3 266.1 371.3 320 448 320c11 0 21.7-1.1 32-3.2V352 480c0 17.7-14.3 32-32 32s-32-14.3-32-32V386.1L300 448h36c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3z"]]
};
var faHandshakeSimpleSlash = {
  prefix: 'fad',
  iconName: 'handshake-simple-slash',
  icon: [640, 512, ["handshake-alt-slash"], "e05f", ["M495.8 363.3c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2L495.8 363.3zM296.9 207.4l77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6 63.2 49.6zm-89.1-69.8l81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7 43.3 34zM413.6 421.9L41.2 128.5C17.9 131.8 0 151.8 0 176V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faHandshakeAltSlash = faHandshakeSimpleSlash;
var faRabbitRunning = {
  prefix: 'fad',
  iconName: 'rabbit-running',
  icon: [576, 512, ["rabbit-fast"], "f709", ["M458.6 37.2l2.2 2.1c36.2 35.5 52.3 86.2 43.9 135.5c5.1 2.9 9.9 6.3 14.5 10L553.8 213c14 11.4 22.2 28.6 22.2 46.7c0 33.3-27 60.3-60.3 60.3H414.4l-6.4 3.7-56 32.4V340.5c0-57.2-37.9-107.4-92.8-123.1l-30.8-8.8c-8.5-2.4-17.4 2.5-19.8 11s2.5 17.4 11 19.8l30.8 8.8C291.6 260 320 297.6 320 340.5V384h15.2H352h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H300.4c-16 0-31.4-6-43.2-16.8L115 300.8c-34.8-31.9-42.4-84-18.1-124.5l2.1-3.4C115.7 145 145.7 128 178.2 128c35.6 0 70.6 9.3 101.5 26.9L384.8 215c1.2-7.8 3.9-15.1 7.6-21.8c-37.1-18.3-66.5-50.2-81.4-89.7c-4.4-11.6 .4-24.9 11.2-31.1c5.6-3.2 12.3-4.2 18.5-2.6l3.4 .9C391.3 82.6 429.4 116 447.8 160c.6 0 1.1 0 1.7 0c8.5 0 16.9 1 25 2.9c-10.3-31-29-58.1-53.3-78.8c.4-11.9 2.3-23.9 5.5-35.6l.8-2.9c1.8-6.3 6.8-11.3 13.1-13s13.2 .1 17.9 4.7zM142.2 421.4l32.9-22 48.6 44.5-46 30.7c-14.7 9.8-34.6 5.8-44.4-8.9s-5.8-34.6 8.9-44.4zM512 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z", "M99 172.9l.3-.4C89 159.9 73.4 152 56 152c-30.9 0-56 25.1-56 56s25.1 56 56 56c11.3 0 21.8-3.3 30.6-9.1c-7.4-25.8-4.3-54.3 10.3-78.6l2.1-3.4zM496 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faRabbitFast = faRabbitRunning;
var faMemoPad = {
  prefix: 'fad',
  iconName: 'memo-pad',
  icon: [448, 512, [], "e1da", ["M448 128H0V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V128zM112 208H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M448 128H0V64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64v64zM112 208H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faMattressPillow = {
  prefix: 'fad',
  iconName: 'mattress-pillow',
  icon: [640, 512, [], "e525", ["M64 448l192 0 0-384H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64zM96 128h64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32z", "M256 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H256V64z"]]
};
var faAlarmPlus = {
  prefix: 'fad',
  iconName: 'alarm-plus',
  icon: [512, 512, [], "f844", ["M390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM256 176c-13.3 0-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24z", "M14.9 146.4L160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200zM352 25.4L497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4z"]]
};
var faAlicorn = {
  prefix: 'fad',
  iconName: 'alicorn',
  icon: [640, 512, [], "f6b0", ["M560 90.7l73.6-24.5c3.8-1.3 6.4-4.8 6.4-8.8c0-5.1-4.2-9.3-9.3-9.3H551.4c5.4 9.4 8.6 20.3 8.6 32V90.7zM48 256c0-13.4 6.6-25.2 16.7-32.5c-.4-3.5-.7-7.1-.7-10.7c0-16.1 4.5-31.2 12.3-44.1C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256z", "M448 238.1V160l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H544c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 464 448C378.4 0 321.7 55.6 320 124.8L184.9 34.7c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1c0 48.1 3.8 99.9 26 139.8c9.2 16.6 21.7 31.3 38.2 42.7c-7.2-2.5-14-5.4-20.3-8.8c-22.5-12.1-38.6-29.4-49.9-49.8c-7.3-13.2-12.7-27.8-16.5-43C96 134.3 64 169.8 64 212.8c0 16.8 5 33.1 14.2 47.1l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faCommentQuestion = {
  prefix: 'fad',
  iconName: 'comment-question',
  icon: [512, 512, [], "e14b", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM169.8 149.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 248.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V234.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M222.6 112c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V248c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6zM256 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faGingerbreadMan = {
  prefix: 'fad',
  iconName: 'gingerbread-man',
  icon: [448, 512, [], "f79d", ["M296.9 158.5c-5.2 6-1.2 17.5 6.7 17.5H368c35.3 0 64 28.7 64 64s-28.7 64-64 64H347.1c-19 0-29.4 22.2-17.2 36.7L385.2 407c22.6 27.2 19 67.5-8.2 90.1s-67.5 19-90.1-8.2l-45.6-54.8c-9-10.7-25.5-10.7-34.4 0L161.2 489c-22.6 27.2-63 30.8-90.1 8.2s-30.8-63-8.2-90.1l55.2-66.3c12.2-14.6 1.8-36.7-17.2-36.7H80c-35.3 0-64-28.7-64-64s28.7-64 64-64h64.4c7.9 0 11.9-11.5 6.7-17.5C136.7 141.7 128 119.9 128 96c0-53 43-96 96-96s96 43 96 96c0 23.9-8.7 45.7-23.1 62.5zM192 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z", "M208 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faGuaraniSign = {
  prefix: 'fad',
  iconName: 'guarani-sign',
  icon: [384, 512, [], "e19a", ["M192 0c-17.7 0-32 14.3-32 32V66.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7V32c0-17.7-14.3-32-32-32zm32 132c-10.2-2.6-20.9-4-32-4s-21.8 1.4-32 4V380c10.2 2.6 21 4 32 4s21.8-1.4 32-4V288 224 132zm0 313.3c-10.4 1.7-21.1 2.7-32 2.7s-21.6-.9-32-2.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3z", "M192 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c59.6 0 109.8-40.8 124-96H224V224H352c17.7 0 32 14.3 32 32c0 106-86 192-192 192S0 362 0 256S86 64 192 64c52.3 0 99.8 21 134.4 54.9c12.6 12.4 12.8 32.6 .5 45.3s-32.6 12.8-45.3 .4C258.5 141.9 226.9 128 192 128z"]]
};
var faBurgerFries = {
  prefix: 'fad',
  iconName: 'burger-fries',
  icon: [640, 512, [], "e0cd", ["M167.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l32 16c5.4 2.7 8.8 8.1 8.8 14.1v238c-9.2 1.4-19.8 2.2-32 2.2s-22.8-.8-32-2.2V206.7l0 0V16c0-5.5 2.9-10.7 7.6-13.6zM128 261c-4.8-2.1-8.7-4.4-11.8-6.6c-12-8.4-16.7-18-18.7-24.3c-.4-1.1-.8-2.3-1.2-3.4l-32-192c-1.2-6.9 2.3-13.8 8.6-16.9l32-16c4.5-2.3 9.9-2.3 14.4 .1s7.7 6.6 8.5 11.6l.2 1.3V261zM58.2 193c-3.2-.7-6.6-1-10.2-1H21.4c-1.6 0-3.2 .1-4.7 .2L.2 98.8C-.7 93.4 1.1 88 5.1 84.3s9.5-5.1 14.8-3.8l20.4 5.1L58.2 193zm312.1-18.1c-13.8 4.9-26.1 10.7-37.1 17.2c-2.1 .1-4.1 .3-6.1 .7L346.2 85l17.9-4.5c5.3-1.3 10.8 .1 14.8 3.8s5.8 9.1 4.8 14.5l-13.4 76.1zM256.1 295.2c.7 16.8 8.4 31.7 20.2 42.1C263.8 348.9 256 365.5 256 384c0 16.7 6.4 32 17 43.4c-10.4 8.8-17 21.9-17 36.6c0 18 6 34.6 16 48H89.2c-14.8 0-27.6-10.1-31.1-24.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224H48c8.8 0 16.3 7.2 18.9 15.7C74.3 263 100.3 304 192 304c26.4 0 47.4-3.4 64.1-8.8zm14.1-42.6c-.8 .6-1.5 1.2-2.4 1.7c-3.2 2.2-7.1 4.5-11.8 6.6V54.6l.2-1.4C257.3 47 262 42 268.1 40.5l32-8c5.3-1.3 10.8 .1 14.8 3.8s5.8 9.1 4.8 14.5L289.4 223c-1.1 2.4-2.1 4.7-2.8 7c-.1 .3-.2 .6-.3 .9c-6.7 7.7-12 15.1-16.1 21.6z", "M612.5 319.8c15.2 0 27.5-12.3 27.5-27.5c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5H612.5zM368 255.8a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-240 128c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0 80c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16z"]]
};
var faMugTea = {
  prefix: 'fad',
  iconName: 'mug-tea',
  icon: [576, 512, [], "f875", ["M144 114.7V64h32v50.7c0 8.5 3.4 16.6 9.4 22.6l29.3 29.3c6 6 9.4 14.1 9.4 22.6V256c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V189.3c0-8.5 3.4-16.6 9.4-22.6l29.3-29.3c6-6 9.4-14.1 9.4-22.6z", "M144 64v50.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6V256c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V189.3c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6V64H384h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H416v32c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32h80zM416 256h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H416V256z"]]
};
var faBorderTop = {
  prefix: 'fad',
  iconName: 'border-top',
  icon: [448, 512, [], "f855", ["M64 160A32 32 0 1 0 0 160a32 32 0 1 0 64 0zm384 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-256 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 352A32 32 0 1 0 0 352a32 32 0 1 0 64 0zm320 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm448 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-256 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 448A32 32 0 1 0 0 448a32 32 0 1 0 64 0zm320 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64z"]]
};
var faArrowsRotate = {
  prefix: 'fad',
  iconName: 'arrows-rotate',
  icon: [512, 512, [128472, "refresh", "sync"], "f021", ["M80 396.9V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H125.6l17.2 17.1c62.5 62.5 163.8 62.5 226.3 0c17.5-17.5 30.1-38 37.8-59.8c5.9-16.7 24.2-25.4 40.8-19.5s25.4 24.2 19.5 40.8c-10.8 30.6-28.4 59.3-52.9 83.8c-87.5 87.5-229.3 87.5-316.7 0L80 396.9z", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5z"]]
};
var faRefresh = faArrowsRotate;
var faSync = faArrowsRotate;
var faCircleBookOpen = {
  prefix: 'fad',
  iconName: 'circle-book-open',
  icon: [512, 512, ["book-circle"], "e0ff", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 336c-23.1 0-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5V346.1c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2C225 347.1 207.1 336 184 336zm144 0c-23.1 0-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5V346.1c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2C369 347.1 351.1 336 328 336z", "M230.3 350.8C225 347.1 207.1 336 184 336s-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5V346.1c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2zm144 0C369 347.1 351.1 336 328 336s-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5V346.1c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2z"]]
};
var faBookCircle = faCircleBookOpen;
var faArrowsToDottedLine = {
  prefix: 'fad',
  iconName: 'arrows-to-dotted-line',
  icon: [448, 512, [], "e0a6", ["M64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z", "M224 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM137.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H256v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9z"]]
};
var faFireExtinguisher = {
  prefix: 'fad',
  iconName: 'fire-extinguisher',
  icon: [512, 512, [129519], "f134", ["M289 56H224v48h65c-.7-2.6-1-5.2-1-8V64c0-2.8 .4-5.4 1-8zM2.5 159.5c-5.8 11.9-.9 26.3 11.1 32.1s26.3 .9 32.1-11.1C62 146.9 91.8 121.1 128 110V60.4C72.7 72.6 26.7 109.8 2.5 159.5zM288 416H64v32c0 35.3 28.7 64 64 64h96c35.3 0 64-28.7 64-64V416z", "M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32c-15-3-25.7-16.1-25.7-31.4V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM128 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V138.8c37.8 18 64 56.5 64 101.2V416H64V240c0-44.7 26.2-83.2 64-101.2V32zm48 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faGarageOpen = {
  prefix: 'fad',
  iconName: 'garage-open',
  icon: [640, 512, [], "e00b", ["M194.1 320l-5.2 15c-17.2 9.5-28.9 27.9-28.9 49v96c0 17.7 14.3 32 32 32s32-14.3 32-32V464H416v16c0 17.7 14.3 32 32 32s32-14.3 32-32V384c0-21.1-11.7-39.5-28.9-49l-5.2-15H395l2.8 8H242.2l2.8-8H194.1zM240 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM512 224v64H128V224H512z"]]
};
var faShelvesEmpty = {
  prefix: 'fad',
  iconName: 'shelves-empty',
  icon: [640, 512, [], "e246", ["M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V192 448v32c0 17.7 14.3 32 32 32s32-14.3 32-32H576c0 17.7 14.3 32 32 32s32-14.3 32-32V448 192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V160H64V32zm0 192H576V416H64V224z", ""]]
};
var faCruzeiroSign = {
  prefix: 'fad',
  iconName: 'cruzeiro-sign',
  icon: [448, 512, [], "e152", ["M256 416V320v-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32v55.3V320v82.7c19.6 8.6 41.2 13.3 64 13.3z", "M256 96C167.6 96 96 167.6 96 256s71.6 160 160 160c41 0 78.3-15.4 106.7-40.7c13.2-11.8 33.4-10.7 45.2 2.5s10.7 33.4-2.5 45.2c-39.6 35.5-92 57-149.3 57C132.3 480 32 379.7 32 256S132.3 32 256 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C334.3 111.4 297 96 256 96z"]]
};
var faWatchApple = {
  prefix: 'fad',
  iconName: 'watch-apple',
  icon: [384, 512, [], "e2cb", ["M80 64C35.8 64 0 99.8 0 144V368c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80H80zM192 213.3a42.7 42.7 0 1 1 0 85.3 42.7 42.7 0 1 1 0-85.3zM213.3 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm74.7-160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M112.3 0C85.6 0 64 21.6 64 48.3V65.6c5.2-1 10.5-1.6 16-1.6H304c5.5 0 10.8 .6 16 1.6V48.3C320 21.6 298.4 0 271.7 0H112.3zM64 464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V446.4c-5.2 1-10.5 1.6-16 1.6H80c-5.5 0-10.8-.6-16-1.6V464zm181.3-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faWatchCalculator = {
  prefix: 'fad',
  iconName: 'watch-calculator',
  icon: [384, 512, [], "f8f0", ["M80 64C35.8 64 0 99.8 0 144V368c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80H80zm0 64H304c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm32 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM88 384a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48z", "M112.3 0C85.6 0 64 21.6 64 48.3V65.6c5.2-1 10.5-1.6 16-1.6H304c5.5 0 10.8 .6 16 1.6V48.3C320 21.6 298.4 0 271.7 0H112.3zM64 464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V446.4c-5.2 1-10.5 1.6-16 1.6H80c-5.5 0-10.8-.6-16-1.6V464zm0-192a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm104 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm128-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM64 360a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm128-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm80 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"]]
};
var faListDropdown = {
  prefix: 'fad',
  iconName: 'list-dropdown',
  icon: [512, 512, [], "e1cf", ["M128 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H384c13.3 0 24-10.7 24-24s-10.7-24-24-24H128zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24H384c13.3 0 24-10.7 24-24s-10.7-24-24-24H128z", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 96V416H448V192H64zM363.3 96c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c3.1 3.1 8.2 3.1 11.3 0l36.7-36.7c5-5 1.5-13.7-5.7-13.7H363.3z"]]
};
var faCabinetFiling = {
  prefix: 'fad',
  iconName: 'cabinet-filing',
  icon: [448, 512, [128452], "f64b", ["M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V240H0V64zM0 272H448V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V272zM128 128v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm0 256v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z", "M160 96c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7-14.3-32-32-32H160zm0 256c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384c0-17.7-14.3-32-32-32H160zM0 272H448V240H0v32z"]]
};
var faBurgerSoda = {
  prefix: 'fad',
  iconName: 'burger-soda',
  icon: [640, 512, [], "f858", ["M194.8 43.2C200.8 17.9 223.4 0 249.3 0H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H249.3c-3.7 0-6.9 2.6-7.8 6.2L224.2 128H352c17.7 0 32 14.3 32 32c0 3.9-.7 7.6-2 11.1c-18.5 5.5-34.7 12.7-48.6 20.9H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H174.9l20-84.8zM292.6 224c-18.4 19.1-28 37.5-32.2 47c-3.4 7.7-4.4 15.3-4.4 21.5c0 17.8 7.9 33.9 20.3 44.8C263.8 348.9 256 365.5 256 384c0 16.7 6.4 32 17 43.4c-10.4 8.8-17 21.9-17 36.6c0 18 6 34.6 16 48H108.2c-25 0-45.8-19.1-47.8-44L40 224H292.6z", "M612.5 319.8c15.2 0 27.5-12.3 27.5-27.5c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5H612.5zM368 255.8a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-240 128c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0 80c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16z"]]
};
var faSquareArrowUp = {
  prefix: 'fad',
  iconName: 'square-arrow-up',
  icon: [448, 512, ["arrow-square-up"], "f33c", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm177 87L353 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 119c9.4-9.4 24.6-9.4 33.9 0z", "M207 119c9.4-9.4 24.6-9.4 33.9 0L353 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 119z"]]
};
var faArrowSquareUp = faSquareArrowUp;
var faGreaterThanEqual = {
  prefix: 'fad',
  iconName: 'greater-than-equal',
  icon: [448, 512, [], "f532", ["M34.3 52.1c-6.6 16.4 1.4 35 17.8 41.6L297.8 192 52.1 290.3c-16.4 6.6-24.4 25.2-17.8 41.6s25.2 24.4 41.6 17.8l320-128C408 216.9 416 205.1 416 192s-8-24.9-20.1-29.7l-320-128c-16.4-6.6-35 1.4-41.6 17.8z", "M448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"]]
};
var faPalletBox = {
  prefix: 'fad',
  iconName: 'pallet-box',
  icon: [640, 512, [], "e208", ["M256 0V16v96c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V16 0H368 272 256zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 128V384H288v64H128zm224 0V384H512v64H352z", "M256 0H176c-26.5 0-48 21.5-48 48V208c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H384V112c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L320 99.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V0z"]]
};
var faFaceConfounded = {
  prefix: 'fad',
  iconName: 'face-confounded',
  icon: [512, 512, [], "e36c", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM116 205.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zm-161.6 160L256 380.8l39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 387.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0L208 387.2l-39.1 26.1c-4.8 3.2-10.9 3.6-16 1l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l23.7 11.8 40.3-26.8c5.4-3.6 12.4-3.6 17.8 0z", "M116 205.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm280 0c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]]
};
var faShieldHalved = {
  prefix: 'fad',
  iconName: 'shield-halved',
  icon: [512, 512, ["shield-alt"], "f3ed", ["M256 0c.2 0 .5 0 .7 0c4.6 0 9.2 1 13.4 2.9L458.4 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-8.3 4-17.4 6-26.4 6V0H256z", "M256.7 0c-.2 0-.5 0-.7 0c-4.6 0-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c8.3 4 17.4 6 26.4 6V0h.7z"]]
};
var faShieldAlt = faShieldHalved;
var faTruckPlow = {
  prefix: 'fad',
  iconName: 'truck-plow',
  icon: [640, 512, [], "f7de", ["M128 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm224 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M269.9 96l57.6 96H192V96h77.9zm132.2 96L324.8 63.1C313.2 43.8 292.4 32 269.9 32H176c-26.5 0-48 21.5-48 48V192H32c-17.7 0-32 14.3-32 32v96c0 16 11.7 29.2 27 31.6C45 314 83.5 288 128 288c44.7 0 83.2 26.2 101.2 64h21.6c18-37.8 56.5-64 101.2-64s83.2 26.2 101.2 64H512v16c0 7.3 2.5 14.3 7 20l64 80c11 13.8 31.2 16 45 5s16-31.2 5-45l-57-71.2V320 187.2L633 116c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-64 80c-4.5 5.7-7 12.7-7 20V288H480V224c0-17.7-14.3-32-32-32H402.1z"]]
};
var faBookAtlas = {
  prefix: 'fad',
  iconName: 'book-atlas',
  icon: [448, 512, ["atlas"], "f558", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 256 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H256h96 64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zM247.4 283.8c3.8-3.7 8-10 11.8-18.9c6.2-14.5 10.8-34.3 12.2-56.9h-63c1.5 22.6 6 42.4 12.2 56.9c3.8 8.9 8 15.2 11.8 18.9c3.7 3.7 6.2 4.2 7.4 4.2s3.7-.5 7.4-4.2zm42.7-9.9c23.2-14.2 39.9-38 44.5-65.9H303.5c-1.4 24.7-6.1 47.5-13.4 65.9zm0-163.8c7.3 18.3 12 41.1 13.4 65.9h31.1c-4.7-27.9-21.4-51.7-44.5-65.9zM112 192a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm33.3 16c4.7 27.9 21.4 51.7 44.5 65.9c-7.3-18.3-12-41.1-13.4-65.9H145.3zm31.1-32c1.4-24.7 6.1-47.5 13.4-65.9c-23.2 14.2-39.9 38-44.5 65.9h31.1zm56.1-75.8c-3.8 3.7-8 10-11.8 18.9c-6.2 14.5-10.8 34.3-12.2 56.9h63c-1.5-22.6-6-42.4-12.2-56.9c-3.8-8.9-8-15.2-11.8-18.9c-3.7-3.7-6.2-4.2-7.4-4.2s-3.7 .5-7.4 4.2z"]]
};
var faAtlas = faBookAtlas;
var faVirus = {
  prefix: 'fad',
  iconName: 'virus',
  icon: [512, 512, [], "e074", ["M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M224 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96z"]]
};
var faGridRound2 = {
  prefix: 'fad',
  iconName: 'grid-round-2',
  icon: [512, 512, [], "e5db", ["M384 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM128 288a96 96 0 1 0 0 192 96 96 0 1 0 0-192z", "M128 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM384 288a96 96 0 1 0 0 192 96 96 0 1 0 0-192z"]]
};
var faCommentMiddleTop = {
  prefix: 'fad',
  iconName: 'comment-middle-top',
  icon: [512, 512, [], "e14a", ["M188.3 103.3l44.5-89C237.2 5.5 246.2 0 256 0s18.8 5.5 23.2 14.3l44.5 89C432.2 127.5 512 208.2 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-95.8 79.8-176.5 188.3-200.7z", ""]]
};
var faEnvelopeCircleCheck = {
  prefix: 'fad',
  iconName: 'envelope-circle-check',
  icon: [640, 512, [], "e4e8", ["M0 112C0 85.5 21.5 64 48 64H464c26.5 0 48 21.5 48 48c0 15.1-7.1 29.3-19.2 38.4l-13.9 10.4c-66.6 6.4-122.4 50-146.3 109.8l-57.4 43c-11.4 8.5-27 8.5-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112zM320.8 319.4c-.5 5.5-.8 11-.8 16.6c0 42.5 15.1 81.6 40.2 112H64c-35.3 0-64-28.7-64-64V176L217.6 339.2c22.8 17.1 54 17.1 76.8 0l26.4-19.8z", "M496 480a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faLayerGroup = {
  prefix: 'fad',
  iconName: 'layer-group',
  icon: [576, 512, [], "f5fd", ["M324.9 279.8l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z", "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 337.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2z"]]
};
var faRestroomSimple = {
  prefix: 'fad',
  iconName: 'restroom-simple',
  icon: [640, 512, [], "e23a", ["M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6zM512 128A64 64 0 1 0 512 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H448v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V384h21.6c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H496.3z", "M320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"]]
};
var faArrowsToDot = {
  prefix: 'fad',
  iconName: 'arrows-to-dot',
  icon: [512, 512, [], "e4be", ["", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 50.7-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 82.7 288 32zM393.4 342.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64zM118.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H82.7l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64zm50.7 269.3c12.5 12.5 32.8 12.5 45.3 0l9.4-9.4 0 50.7c0 17.7 14.3 32 32 32s32-14.3 32-32V429.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3zM256 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]]
};
var faBorderOuter = {
  prefix: 'fad',
  iconName: 'border-outer',
  icon: [448, 512, [], "f851", ["M256 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-96 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z", "M384 96V416H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]]
};
var faHashtagLock = {
  prefix: 'fad',
  iconName: 'hashtag-lock',
  icon: [576, 512, [], "e415", ["M207.6 69.3c2.9-17.4-8.9-33.9-26.3-36.8s-33.9 8.9-36.8 26.3L132.9 128H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h58.2L100.9 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H90.2l-9.8 58.7c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3L155.1 384h95.1l-9.8 58.7c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3L320 354.7V352c0-8.1 1.5-15.9 4.3-23.1L347.1 192h38.5c16.6-16.3 38.2-27.4 62.4-30.9c0-.4 0-.8 0-1.1c0-17.7-14.3-32-32-32H357.8l9.8-58.7c2.9-17.4-8.9-33.9-26.3-36.8s-33.9 8.9-36.8 26.3L292.9 128H197.8l9.8-58.7zM165.8 320l21.3-128h95.1L260.9 320H165.8z", "M432 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faClockTwoThirty = {
  prefix: 'fad',
  iconName: 'clock-two-thirty',
  icon: [512, 512, [], "e35b", ["M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V256c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M256 416c-13.3 0-24-10.7-24-24V256c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8V392c0 13.3-10.7 24-24 24z"]]
};
var faArchway = {
  prefix: 'fad',
  iconName: 'archway',
  icon: [512, 512, [], "f557", ["M480 96H32v64H480V96zm0 96H32V416c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 32V416 352c0-53 43-96 96-96s96 43 96 96v64 64h32 96c17.7 0 32-14.3 32-32s-14.3-32-32-32V192z", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM480 160H32v32H480V160z"]]
};
var faHeartCircleCheck = {
  prefix: 'fad',
  iconName: 'heart-circle-check',
  icon: [576, 512, [], "e4fd", ["M228.3 469.1L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 6.6-.4 13.2-1.3 19.6C487 198.7 460.3 192 432 192c-97.2 0-176 78.8-176 176c0 36.6 11.2 70.6 30.3 98.7l-2.6 2.4c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faHouseChimneyCrack = {
  prefix: 'fad',
  iconName: 'house-chimney-crack',
  icon: [576, 512, ["house-damage"], "f6f1", ["M64.1 448L64 270.5l224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.6-64-64z", "M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2L512 185.5V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v37.5L309.1 7.9z"]]
};
var faHouseDamage = faHouseChimneyCrack;
var faFileZipper = {
  prefix: 'fad',
  iconName: 'file-zipper',
  icon: [384, 512, ["file-archive"], "f1c6", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM96 48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM66.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8H120.6c-14.5 0-27.2 9.7-30.9 23.8L66.1 335.9z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM96 48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm-6.3 71.8L66.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8H120.6c-14.5 0-27.2 9.7-30.9 23.8zM112 336h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faFileArchive = faFileZipper;
var faHeartHalf = {
  prefix: 'fad',
  iconName: 'heart-half',
  icon: [512, 512, [], "e1ab", ["M256 480V96l12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9z", "M256 96L244 84l0 0c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9l0-50.7 0-265.4V96z"]]
};
var faCommentCheck = {
  prefix: 'fad',
  iconName: 'comment-check',
  icon: [512, 512, [], "f4ac", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM369 193L241 321c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 159c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M369 159c9.4 9.4 9.4 24.6 0 33.9L241 321c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 159c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faSquare = {
  prefix: 'fad',
  iconName: 'square',
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z", ""]]
};
var faMemo = {
  prefix: 'fad',
  iconName: 'memo',
  icon: [384, 512, [], "e1d8", ["M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z", "M80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]]
};
var faMartiniGlassEmpty = {
  prefix: 'fad',
  iconName: 'martini-glass-empty',
  icon: [512, 512, ["glass-martini"], "f000", ["M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM256 210.7L109.3 64H402.7L256 210.7z", ""]]
};
var faGlassMartini = faMartiniGlassEmpty;
var faCouch = {
  prefix: 'fad',
  iconName: 'couch',
  icon: [640, 512, [], "f4b8", ["M192 32C121.3 32 64 89.3 64 160v66.7c18.6 6.6 32 24.4 32 45.3v80H544V272c0-20.9 13.4-38.7 32-45.3V160c0-70.7-57.3-128-128-128H192z", "M48 224c-26.5 0-48 21.5-48 48V448c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32H544c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V272c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H96V272c0-26.5-21.5-48-48-48z"]]
};
var faCediSign = {
  prefix: 'fad',
  iconName: 'cedi-sign',
  icon: [384, 512, [], "e0df", ["M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7V32zm0 100c-10.2-2.6-20.9-4-32-4c-11 0-21.8 1.4-32 4V380c10.2 2.6 21 4 32 4c11.1 0 21.8-1.4 32-4V132zm0 313.3c-10.4 1.7-21.1 2.7-32 2.7s-21.6-.9-32-2.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3z", "M224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8C307.1 433.7 267.2 448 224 448C118 448 32 362 32 256S118 64 224 64c43.2 0 83.1 14.3 115.2 38.4c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128z"]]
};
var faItalic = {
  prefix: 'fad',
  iconName: 'italic',
  icon: [384, 512, [], "f033", ["M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z", ""]]
};
var faGlassCitrus = {
  prefix: 'fad',
  iconName: 'glass-citrus',
  icon: [512, 512, [], "f869", ["M8.3 138.5C14.3 131.8 23 128 32 128H320c9 0 17.7 3.8 23.7 10.5s9 15.7 8.1 24.7L322.7 454.4C319.5 487.1 291.9 512 259 512H93c-32.9 0-60.4-24.9-63.7-57.6L.2 163.2c-.9-9 2-18 8.1-24.7zM67.4 192L93 448 259 448l25.6-256H67.4z", "M448 144c0 44.2-35.8 80-80 80c-7.6 0-15-1.1-21.9-3l-6.4 64.3c9.2 1.8 18.7 2.8 28.4 2.8c79.5 0 144-64.5 144-144S447.5 0 368 0C293.9 0 232.8 56 224.9 128h64.7C297 91.5 329.3 64 368 64c44.2 0 80 35.8 80 80zM73.8 256L93 448 259 448l19.2-192H73.8z"]]
};
var faCalendarLinesPen = {
  prefix: 'fad',
  iconName: 'calendar-lines-pen',
  icon: [576, 512, [], "e472", ["M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H258.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L448 235.6V192zM96 296c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm24 72h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M493.2 235.7l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L311.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 358.7l-71-71z"]]
};
var faChurch = {
  prefix: 'fad',
  iconName: 'church',
  icon: [640, 512, [9962], "f51d", ["M160 256L24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48H160V256zM480 512H592c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L480 256V512z", "M320 0c13.3 0 24 10.7 24 24V48h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H344v46.4L456.7 210c14.5 8.7 23.3 24.3 23.3 41.2V512H384V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v96H160V251.2c0-16.9 8.8-32.5 23.3-41.2L296 142.4V96H264c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V24c0-13.3 10.7-24 24-24z"]]
};
var faPersonSnowmobiling = {
  prefix: 'fad',
  iconName: 'person-snowmobiling',
  icon: [640, 512, ["snowmobile"], "f7d1", ["M288 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 288H264l-72-32 32-48 29.3 29.3c12 12 28.3 18.7 45.3 18.7H312l48-64H304l-61.7-55.6c-11.8-10.6-27-16.4-42.8-16.4h-.9c-23.7 0-45.5 13.1-56.6 34.1l-35.3 66.6c-11.4 21.6-9.4 47.8 5.3 67.4zM450 416l36 48H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H576c6.4 0 12.5-2.5 17-7l40-40c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-33 33H546l-46-61.3L480 416H450zM0 464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48s-21.5-48-48-48H48c-26.5 0-48 21.5-48 48z", "M373.5 85.3c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l37.4 74.7L288 288H99.8c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-2.5 5-3.6 10.2-3.4 15.2c4-.6 8.1-.9 12.3-.9H272c26.2 0 49.4 12.6 64 32H480l88.9-59.3c4.5-3 7.1-8 7.1-13.3V265.9c0-6.1-3.4-11.6-8.8-14.3L419.8 177.9 373.5 85.3z"]]
};
var faSnowmobile = faPersonSnowmobiling;
var faFaceHushed = {
  prefix: 'fad',
  iconName: 'face-hushed',
  icon: [512, 512, [], "e37b", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM256 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z", "M192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-15.6 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 160.9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]]
};
var faCommentsDollar = {
  prefix: 'fad',
  iconName: 'comments-dollar',
  icon: [640, 512, [], "f653", ["M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM228 72V85.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V280c0 11-9 20-20 20s-20-9-20-20V265.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V72c0-11 9-20 20-20s20 9 20 20z", "M228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"]]
};
var faPickaxe = {
  prefix: 'fad',
  iconName: 'pickaxe',
  icon: [512, 512, [], "e5bf", ["M360.2 208.8L54.2 503.1c-12.6 12.1-32.5 11.9-44.8-.4S-3.1 470.4 8.9 457.8l294.2-306c9.9 8.6 19.8 17.7 29.5 27.5s18.9 19.7 27.5 29.5zm100.2-96.3c-16.9-23.4-37.5-43.9-60.9-60.9l9.4-9.8c6-6.2 14.2-9.7 22.8-9.8s16.9 3.3 22.9 9.4l16 16c6.1 6.1 9.5 14.3 9.4 22.9s-3.6 16.8-9.8 22.8l-9.8 9.4z", "M462.4 373.5l0 0 0 0c2.3 6.2 8.2 10.4 14.8 10.5s12.6-3.9 15.1-10C505 342.5 512 308 512 272C512 121.8 390.2 0 240 0c-36 0-70.5 7-102 19.8c-6.1 2.5-10.1 8.5-10 15.1s4.3 12.5 10.5 14.8l0 0 0 0 .2 .1 .8 .3c.7 .3 1.8 .7 3.3 1.3c2.9 1.2 7.2 3 12.7 5.5c11 5 26.7 12.6 45.3 23.1c37.3 21 86 53.6 132 99.5s78.5 94.7 99.5 132c10.5 18.6 18.1 34.3 23.1 45.3c2.5 5.5 4.3 9.8 5.5 12.7c.6 1.4 1 2.5 1.3 3.3l.3 .8 .1 .2z"]]
};
var faLinkSimpleSlash = {
  prefix: 'fad',
  iconName: 'link-simple-slash',
  icon: [640, 512, [], "e1ce", ["M121 191.4c-15.5 17.1-25 39.7-25 64.6c0 53 43 96 96 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-88.4 0-160-71.6-160-160c0-39.9 14.6-76.3 38.7-104.3L121 191.4zM399.7 288l-81.7-64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H399.7zM532.4 392l-56.3-44.1c39.3-12 67.9-48.6 67.9-91.8c0-53-43-96-96-96H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c88.4 0 160 71.6 160 160c0 57.4-30.2 107.7-75.6 136zm-296-232L159.1 99.4C169.7 97.2 180.7 96 192 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H236.4z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faDemocrat = {
  prefix: 'fad',
  iconName: 'democrat',
  icon: [640, 512, [], "f747", ["M192 320H544v32 64 64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416H288v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416 352 320z", "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H480l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"]]
};
var faFaceConfused = {
  prefix: 'fad',
  iconName: 'face-confused',
  icon: [512, 512, [], "e36d", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.1 395.6l-1.1 .9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l1.1-.9C205 327.5 272 304 341 304h11c8.8 0 16 7.2 16 16s-7.2 16-16 16H341c-61.8 0-121.7 21-169.9 59.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faPinball = {
  prefix: 'fad',
  iconName: 'pinball',
  icon: [448, 512, [], "e229", ["", "M412.1 463.4c-7.2 13.2-23.1 19.9-37.9 15L66.3 379.3c-12.1-3.9-22.8-10-32-17.7c-40.6-34.1-46-94.7-11.9-135.3s94.6-45.9 135.2-11.8l246 208.3c12.6 9.8 15.8 27.1 8.4 40.6zM96 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192z"]]
};
var faZ = {
  prefix: 'fad',
  iconName: 'z',
  icon: [384, 512, [122], "5a", ["M0 64C0 46.3 14.3 32 32 32H352c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z", ""]]
};
var faPersonSkiing = {
  prefix: 'fad',
  iconName: 'person-skiing',
  icon: [512, 512, [9975, "skiing"], "f7c9", ["M174.3 71.2l-8.3 16.5 177.1 83 8.4 25.1c2.6 7.9 7.2 14.9 13.2 20.3l-3.6-1.7L151.7 116.3l-9.4 18.9c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9.1-18.1-17.5-8.2c-8-3.8-11.4-13.3-7.7-21.3s13.3-11.4 21.3-7.7l18.3 8.6 8.6-17.2c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L418.5 457.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9z", "M428.7 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-35.6 22.1c-11.6-34.9-50.3-52.9-84.5-39.2l-83.4 33.4c-1.2 .5-2.3 1-3.5 1.5l121.4 56.9 1 2.9 7.4 22.2c2.6 7.9 7.2 14.9 13.2 20.3l0 0c3.2 2.9 6.9 5.4 10.8 7.4l58.1 29c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2zM203.7 216.9l75.1 75.1-46.2 69.2L289.8 391l49.5-74.3c12.7-19 10.2-44.4-6-60.6l-39.3-39.3-108.8-52c-2 18.3 3.7 37.5 18.4 52.1z"]]
};
var faSkiing = faPersonSkiing;
var faDeer = {
  prefix: 'fad',
  iconName: 'deer',
  icon: [512, 512, [129420], "f78e", ["M240 0c8.8 0 16 7.2 16 16V40c0 13.3 10.7 24 24 24h8 8c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16V40c0 8.6-1.9 16.7-5.4 24H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H296h-8-8c-30.9 0-56-25.1-56-56V16c0-8.8 7.2-16 16-16zM456 0c8.8 0 16 7.2 16 16V40c0 21.7-12.3 40.4-30.3 49.8C428.3 77 411.5 68.6 393.4 65.4c2-.9 4.2-1.4 6.6-1.4h16c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16z", "M320 96l32 0c8.8 0 16-7.2 16-16c0-5.6-2.9-10.6-7.3-13.5c5.3-1.7 10.9-2.5 16.6-2.5c24.8 0 48.6 9.9 66.2 27.4l55.3 55.3c8.5 8.5 13.3 20 13.3 32c0 25-20.3 45.3-45.3 45.3H416h-5.3L384 304v64V480c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V368H251.7c-28.8 0-55.3-9.8-76.3-26.4c-2.1 16.9-9.8 32.6-21.9 44.8L142.9 397c-4.6 4.6-6.2 11.5-4 17.7l19.3 54.7c7.3 20.8-8.1 42.6-30.2 42.6H94.1c-13.6 0-25.7-8.6-30.2-21.4l-15.5-44c-11.4-32.4-7.4-67.8 10-96.3C65 339.4 65 324.9 56 315.9c-3-3-5.7-6.1-8.1-9.5c-1.3 12.9-12.7 22.5-25.7 21.5C8.9 326.9-.9 315.4 .1 302.2L2.4 272c4.2-54.2 49.3-96 103.7-96h7.9H128h64c.6 0 1.2 0 1.7 0c.8 0 1.7 0 2.5 0H302.4l9.6-32H274c-9.9 0-18-8-18-18c0-8.2 5.6-15.4 13.6-17.4L320 96zm96 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
};
var faInputPipe = {
  prefix: 'fad',
  iconName: 'input-pipe',
  icon: [640, 512, [], "e1be", ["M576 128V384H64V128H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z", "M104 184c0-13.3 10.7-24 24-24s24 10.7 24 24V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184z"]]
};
var faRoadLock = {
  prefix: 'fad',
  iconName: 'road-lock',
  icon: [640, 512, [], "e567", ["M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l30.4 85.9C460.6 165.8 416 213.7 416 272v24.6c-19.1 11.1-32 31.7-32 55.4V480H352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM320 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faA = {
  prefix: 'fad',
  iconName: 'a',
  icon: [384, 512, [97], "41", ["M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384H290.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320H120l72-172.8L264 320z", ""]]
};
var faBookmarkSlash = {
  prefix: 'fad',
  iconName: 'bookmark-slash',
  icon: [640, 512, [], "e0c2", ["M512 376V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48V75L512 376zm-2.2 121.7L128 196.8V487.7c0 13.4 10.9 24.3 24.3 24.3c5 0 9.9-1.5 14-4.4L320 400 473.7 507.6c4.1 2.9 9 4.4 14 4.4c9.9 0 18.4-5.9 22.2-14.3z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faTemperatureArrowDown = {
  prefix: 'fad',
  iconName: 'temperature-arrow-down',
  icon: [576, 512, ["temperature-down"], "e03f", ["M176 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C102.2 332.6 96 349.5 96 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM64 112C64 50.2 114.1 0 176 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S32 447.5 32 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M480 352h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V64c0-17.7 14.3-32 32-32s32 14.3 32 32V352zM224 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"]]
};
var faTemperatureDown = faTemperatureArrowDown;
var faMace = {
  prefix: 'fad',
  iconName: 'mace',
  icon: [512, 512, [], "f6f8", ["M171.9 294.9L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L217.1 340.1c-18.4-11.3-34-26.8-45.3-45.3z", "M272.8 10.9L244.8 95c-40.4 13.5-72.3 45.4-85.8 85.8l-84.1 28C68.4 211 64 217.1 64 224s4.4 13 10.9 15.2l84.1 28c13.5 40.4 45.4 72.3 85.8 85.8l28 84.1c2.2 6.5 8.3 10.9 15.2 10.9s13-4.4 15.2-10.9l28-84.1c40.4-13.5 72.3-45.4 85.8-85.8l84.1-28c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-84.1-28c-13.5-40.4-45.4-72.3-85.8-85.8l-28-84.1C301 4.4 294.9 0 288 0s-13 4.4-15.2 10.9zM288 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faFeatherPointed = {
  prefix: 'fad',
  iconName: 'feather-pointed',
  icon: [512, 512, ["feather-alt"], "f56b", ["M41 505l81.3-81.3c10 7.6 21 13.7 33.3 17C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c3.3 12.2 9.4 23.2 17 33.3L7 471c-9.4 9.4-9.4 24.6 0 33.9c4.7 4.7 10.8 7 17 7c.6 0 1.2 0 1.8-.1c3.4-.3 6.7-1.2 9.8-2.9c1.9-1.1 3.7-2.4 5.4-4z", "M24 512c-6.2 0-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9L311 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-4.7 4.7-10.8 7-17 7z"]]
};
var faFeatherAlt = faFeatherPointed;
var faSausage = {
  prefix: 'fad',
  iconName: 'sausage',
  icon: [512, 512, [], "f820", ["M320 160c0-42 26.9-77.7 64.5-90.7L369.2 27.4c-.8-2.2-1.2-4.6-1.2-7C368 9.1 377.1 0 388.4 0h55.2C454.9 0 464 9.1 464 20.4c0 2.4-.4 4.7-1.2 7L447.5 69.3C485.1 82.3 512 118 512 160c0 194.4-157.6 352-352 352c-42 0-77.7-26.9-90.7-64.5L27.4 462.8c-2.2 .8-4.6 1.2-7 1.2C9.1 464 0 454.9 0 443.6V388.4C0 377.1 9.1 368 20.4 368c2.4 0 4.7 .4 7 1.2l41.9 15.2C82.3 346.9 118 320 160 320c88.4 0 160-71.6 160-160zm80 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 114.9-93.1 208-208 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240-107.5 240-240z", "M384 144c8.8 0 16 7.2 16 16c0 132.5-107.5 240-240 240c-8.8 0-16-7.2-16-16s7.2-16 16-16c114.9 0 208-93.1 208-208c0-8.8 7.2-16 16-16z"]]
};
var faTrashCanClock = {
  prefix: 'fad',
  iconName: 'trash-can-clock',
  icon: [576, 512, [], "e2aa", ["M32 96H416v96.7c-29.3 2.6-56.6 12.5-80 27.7V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v71.2c-29.8 31.5-48 74-48 120.8c0 59.5 29.6 112.1 74.8 144H96c-35.3 0-64-28.7-64-64V96zm96 64c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16z", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]]
};
var faP = {
  prefix: 'fad',
  iconName: 'p',
  icon: [320, 512, [112], "50", ["M0 96C0 60.7 28.7 32 64 32h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V320 96zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z", ""]]
};
var faBroomWide = {
  prefix: 'fad',
  iconName: 'broom-wide',
  icon: [512, 512, [], "e5d1", ["M502.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128 45.3 45.3 128-128z", "M313.6 121.6c-15.2-15.2-38.5-18.4-57.3-8l-32.5 18L380.4 288.1l18-32.5c10.4-18.7 7.1-42.1-8-57.3l-76.8-76.8zM187.5 151.8L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l43.2 43.2c2.1 2.1 5.3 2.9 8.2 1.9l52.1-17.4c6.3-2.1 12.2 3.9 10.1 10.1l-17.4 52.1c-1 2.9-.2 6 1.9 8.2L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4l95.1-171.1L187.5 151.8z"]]
};
var faSnowflake = {
  prefix: 'fad',
  iconName: 'snowflake',
  icon: [448, 512, [10052, 10054], "f2dc", ["M192 62.1v67.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15zM130.6 164.5L71.7 130.1l-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1zM41.2 186.4l58.4 34.1L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8zM99.6 291.5L41.2 325.6l-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1zM71.7 381.9l58.9-34.4-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3zm120.3 .2v67.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49zm64 67.9V382.1l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15zm61.4-102.4l58.9 34.4 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1zm89.4-21.9l-58.4-34.1 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8zM348.4 220.5l58.4-34.1 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1zm27.9-90.4l-58.9 34.4 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3zM256 129.9V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49z", "M224 0c17.7 0 32 14.3 32 32V200.3l143.9-83.9c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8L287.5 256l144.6 84.4c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5L256 311.7V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V311.7L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8L160.5 256 15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5L192 200.3V32c0-17.7 14.3-32 32-32z"]]
};
var faStomach = {
  prefix: 'fad',
  iconName: 'stomach',
  icon: [512, 512, [], "f623", ["M216.5 415.4l-1.7-1.4c53.2-9.5 94.9-51.9 103.6-105.4c8.6-2.5 17.8-4.5 25.6-4.6c16.8-.3 28.4 7.9 40 16s23.2 16.2 40 16c6.5-.1 13.9-1.5 21.1-3.3C431.9 398.5 373.7 448 304 448c-24 0-40.5-4.2-53.1-9.8c-12.8-5.7-23.1-13.3-34.4-22.8z", "M160 0c17.7 0 32 14.3 32 32V96c0 35.3 28.7 64 64 64h17.1c22.1-38.3 63.5-64 110.9-64c70.7 0 128 57.3 128 128v80c0 114.9-93.1 208-208 208c-32 0-57.5-5.8-78.9-15.2c-21.2-9.3-36.9-21.7-49.6-32.2c-1.8-1.5-3.6-3-5.3-4.4l0 0C148 441.5 136.6 432 112 432c-26.5 0-48 21.5-48 48c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7 57.3-128 128-128h64c35.3 0 64-28.7 64-64V224c-70.7 0-128-57.3-128-128V32c0-17.7 14.3-32 32-32zm54.8 414c.6 .5 1.1 1 1.7 1.4c11.4 9.5 21.6 17.1 34.4 22.8c12.6 5.5 29.1 9.8 53.1 9.8c79.5 0 144-64.5 144-144V224c0-35.3-28.7-64-64-64s-64 28.7-64 64v64c0 62.9-45.4 115.2-105.2 126z"]]
};
var faNewspaper = {
  prefix: 'fad',
  iconName: 'newspaper',
  icon: [512, 512, [128240], "f1ea", ["M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H96 48c26.5 0 48-21.5 48-48V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z", "M0 160V432c0 26.5 21.5 48 48 48s48-21.5 48-48V96H64C28.7 96 0 124.7 0 160zM384 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384zM176 288c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]]
};
var faRectangleAd = {
  prefix: 'fad',
  iconName: 'rectangle-ad',
  icon: [576, 512, ["ad"], "f641", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z", "M208 160c9.1 0 17.4 5.1 21.5 13.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3zm21.2 120L208 237.7 186.8 280h42.3zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"]]
};
var faAd = faRectangleAd;
var faGuitarElectric = {
  prefix: 'fad',
  iconName: 'guitar-electric',
  icon: [512, 512, [127928], "f8be", ["M233.4 450.1c7.5-25.2 22.5-65.6 47.2-90.6c10-10.1 20-16 28.3-19.3c.4-.2 .8-.3 1.1-.5c11.3-4.6 23-9.4 31.6-18l21.6-21.8c6.5-6.6 6.5-17.3 0-23.8s-17.3-6.6-25.8-3c-14.6 6.2-39.3 8.7-68.5-20.9L257 240.2c-31.9-32.2-20.7-64.5-10-82c4.8-7.9 4.8-18.7-1.7-25.3s-17.1-6.6-23.6 0l-29.9 30.2c-9.1 9.2-14.7 21.5-20.2 33.5c-1.2 2.6-2.3 5.1-3.5 7.6c-3.5 7.3-8.9 15.7-17.1 24c-24.7 25-64.7 40.2-89.6 47.7c-14.5 4.4-28.1 11.7-38.7 22.4c-30 30.4-30 79.6 0 110l79.9 80.8c30 30.4 78.7 30.4 108.8 0c10.7-10.8 17.9-24.5 22.2-39.2zM195.3 268.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-64 64l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z", "M352 81.1v33.6L243.8 223c3.2 5.7 7.5 11.5 13.2 17.2l11.8 11.9c7 7.1 13.8 12.3 20.2 16.1L461.3 96H464c26.5 0 48-21.5 48-48s-21.5-48-48-48h-1.1c-9.7 0-19.2 2.9-27.3 8.3L366.2 54.5C357.3 60.4 352 70.4 352 81.1zM195.3 268.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48zm-64 64c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48z"]]
};
var faArrowTurnDownRight = {
  prefix: 'fad',
  iconName: 'arrow-turn-down-right',
  icon: [512, 512, [], "e3d6", ["M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V224c0 53 43 96 96 96H402.7l32-32-32-32H96c-17.7 0-32-14.3-32-32V64z", "M329.4 137.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288 329.4 182.6c-12.5-12.5-12.5-32.8 0-45.3z"]]
};
var faMoonCloud = {
  prefix: 'fad',
  iconName: 'moon-cloud',
  icon: [640, 512, [], "f754", ["M256.5 240.3C264.5 124 361.2 32 479.5 32c6.4 0 12.7 .3 19 .8c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-53.3 30.2-89.3 87.6-89.3 153.3c0 97.2 78.6 176 175.5 176c10.3 0 20.3-.9 30.1-2.6c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7C595 455.8 540 480 479.5 480c-60.9 0-116.1-24.4-156.4-64c17.9-18.7 29-44.1 29-72c0-54.6-42-99.3-95.5-103.7z", "M0 352c0 35.3 28.7 64 64 64H248c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C208.8 246.5 179 224 144 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64z"]]
};
var faBreadSliceButter = {
  prefix: 'fad',
  iconName: 'bread-slice-butter',
  icon: [512, 512, [], "e3e1", ["M233.4 214.6l-50.7 50.7c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0l50.7-50.7c12.5-12.5 12.5-32.8 0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0z", "M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64zm182.6 73.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0l50.7-50.7c12.5-12.5 12.5-32.8 0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-50.7 50.7z"]]
};
var faCircleArrowRight = {
  prefix: 'fad',
  iconName: 'circle-arrow-right',
  icon: [512, 512, ["arrow-circle-right"], "f0a9", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z", "M393 239c9.4 9.4 9.4 24.6 0 33.9L281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239z"]]
};
var faArrowCircleRight = faCircleArrowRight;
var faUserGroupCrown = {
  prefix: 'fad',
  iconName: 'user-group-crown',
  icon: [640, 512, ["users-crown"], "f6a5", ["M432 256c-27.7 0-53-10.1-72.6-26.7c.5-.8 1-1.5 1.4-2.3c12.1-19.9 20-42.6 22.4-67c.5-5.3 .8-10.6 .8-16V42.8C398.5 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM352 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128H352z", "M352 80v48H320 304 144 128 96V80 42.3v-.1V39 16c0-8.8 7.2-16 16-16h2.4c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3 .2 .6 .4 .8 .6l.1 .1c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2 .6-.4 .8-.6l3-2.4L323.6 3.5c2.8-2.3 6.4-3.5 10-3.5H336c8.8 0 16 7.2 16 16V39v3.2 .1V80zM0 472c0-92.8 75.2-168 168-168H280c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8z"]]
};
var faUsersCrown = faUserGroupCrown;
var faCircleI = {
  prefix: 'fad',
  iconName: 'circle-i',
  icon: [512, 512, [], "e111", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V336h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M160 152c0-13.3 10.7-24 24-24h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V336h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176H184c-13.3 0-24-10.7-24-24z"]]
};
var faToiletPaperCheck = {
  prefix: 'fad',
  iconName: 'toilet-paper-check',
  icon: [640, 512, [], "e5b2", ["M20.2 495.8C25.8 505.8 36.5 512 48 512H317.9c22.3 0 45.4-12.1 55.4-36.1C388.7 439 416 350.8 416 192C416 86 459 0 512 0H160C107 0 64 86 64 192c0 85.3-.4 193.7-43.5 271.6c-5.9 9.9-6.1 22.1-.4 32.2zM313 193l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-40-40c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M399.6 384H512c53 0 96-86 96-192S565 0 512 0s-96 86-96 192c0 81.9-7.3 145-16.4 192zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"]]
};
var faFilterCircleXmark = {
  prefix: 'fad',
  iconName: 'filter-circle-xmark',
  icon: [576, 512, [], "e17b", ["M40 0C24.5 0 10.5 8.9 3.9 22.9S-.7 53.4 9 65.3L192 288.9V368c0 10.1 4.7 19.6 12.8 25.6l64 48c1.5 1.1 3 2.1 4.7 2.9C262.3 421.4 256 395.4 256 368c0-85 60.2-155.9 140.4-172.4L503 65.3c9.8-12 11.8-28.5 5.2-42.5S487.5 0 472 0H40z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faLocust = {
  prefix: 'fad',
  iconName: 'locust',
  icon: [576, 512, [], "e520", ["M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4c29.8 11.6 51 40.6 51 74.6V280C576 143 465 32 328 32H312z", "M286.1 142.5c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400H496c44.2 0 80-35.8 80-80s-35.8-80-80-80H431.8l-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7zM379.6 240H333l29.5-40 17.1 40zm-106.3 0H225.1l32.7-41.5 16.9 39.5-1.4 1.9zm-146.6 0H88.8C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240zM480 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]]
};
var faSort = {
  prefix: 'fad',
  iconName: 'sort',
  icon: [320, 512, ["unsorted"], "f0dc", ["M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z", "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]]
};
var faUnsorted = faSort;
var faListOl = {
  prefix: 'fad',
  iconName: 'list-ol',
  icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", ["M192 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H488c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M48 32C34.7 32 24 42.8 24 56s10.7 24 24 24h8v96H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H104V56c0-13.3-10.7-24-24-24H48zM62.6 342.4c5.7-8.1 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H86.8l34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9L12.5 330.1c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z"]]
};
var faList12 = faListOl;
var faListNumeric = faListOl;
var faChartWaterfall = {
  prefix: 'fad',
  iconName: 'chart-waterfall',
  icon: [512, 512, [], "e0eb", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M352 64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-64 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V256zM480 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V96z"]]
};
var faSparkle = {
  prefix: 'fad',
  iconName: 'sparkle',
  icon: [448, 512, [], "e5d6", ["M245.8 45.9C241.9 37.4 233.4 32 224 32s-17.9 5.4-21.8 13.9L142.7 174.7 13.9 234.2C5.4 238.1 0 246.6 0 256s5.4 17.9 13.9 21.8l128.8 59.5 59.5 128.8c3.9 8.5 12.4 13.9 21.8 13.9s17.9-5.4 21.8-13.9l59.5-128.8 128.8-59.5c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8L305.3 174.7 245.8 45.9z", ""]]
};
var faFaceParty = {
  prefix: 'fad',
  iconName: 'face-party',
  icon: [640, 512, [], "e383", ["M531.7 400C485.6 467.6 408 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0C433.4 0 529.7 73.8 563.3 176H560c-44.2 0-80 35.8-80 80c0 18 6 34.6 16 48H416c-1 0-2 0-3 .1c-1.2-2.3-2.7-4.4-4.3-6.4c-4.3-5.2-10.1-9.7-16.7-13.4C378.7 276.9 361.4 272 344 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c1.6-2 3.1-4.1 4.3-6.4c1 .1 2 .1 3 .1H531.7zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm89.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z", "M51.3 152.2l-20-52C46.6 71.8 66 46 88.8 23.4L132 37.8C96.5 68.5 68.5 107.7 51.3 152.2zM55.1 12.2C40.9 27.6 28 44.4 16.6 62.1L1.1 21.7C-1.2 16 .2 9.4 4.4 4.9S15.2-1.1 21.1 .8L55.1 12.2zM204.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zm160 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zM512 256c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H400c-8.8 0-16-7.2-16-16s7.2-16 16-16H592c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H560c-26.5 0-48-21.5-48-48z"]]
};
var faKidneys = {
  prefix: 'fad',
  iconName: 'kidneys',
  icon: [640, 512, [], "f5fb", ["M196.3 233c-1.4-16.8 3.2-33.5 12.8-47.3l64 32c19 9.5 31 28.9 31 50.1V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V267.8c0-3-1.7-5.8-4.4-7.2L196.3 233zm234.7-47.3c9.6 13.7 14.2 30.4 12.8 47.3l-55.3 27.7c-2.7 1.4-4.4 4.1-4.4 7.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V267.8c0-21.2 12-40.6 31-50.1l64-32z", "M87.7 23.8C106.5 6.3 130.5 0 152 0h3.2c19.9 0 39.4 5.9 55.9 16.9l3.4 2.3C240.4 36.5 256 65.6 256 96.7c0 22.8-8.4 44.8-23.5 61.9l-18.2 20.5c-13.4 15.1-19.9 35.1-17.9 55.1l4.1 41.2c5.8 58.1-39.8 108.5-98.2 108.5c-46.5 0-88.2-32.9-95.3-80.9C3.5 278.7 0 248.9 0 224C0 119.6 56.4 52.8 87.7 23.8zm464.6 0C583.6 52.8 640 119.6 640 224c0 24.9-3.5 54.7-7.1 79.1c-7.1 48-48.8 80.9-95.3 80.9c-58.4 0-104-50.4-98.2-108.5l4.1-41.2c2-20.1-4.5-40.1-17.9-55.1l-18.2-20.5C392.4 141.6 384 119.6 384 96.7c0-31.2 15.6-60.2 41.5-77.5l3.4-2.3C445.5 5.9 464.9 0 484.8 0H488c21.5 0 45.5 6.3 64.3 23.8z"]]
};
var faWifiExclamation = {
  prefix: 'fad',
  iconName: 'wifi-exclamation',
  icon: [640, 512, [], "e2cf", ["M253.2 37c-8.6 13.7-13.1 30.1-11.9 47.6l1.4 19.3c-72.3 14.8-137.2 49.9-188.5 99.1c-12.8 12.2-33 11.8-45.2-.9s-11.8-33 .9-45.2C75.1 94.1 159.4 51 253.2 37zm133.7 0c93.8 14 178 57.1 243.3 119.8c12.8 12.2 13.2 32.5 .9 45.2s-32.5 13.2-45.2 .9c-51.3-49.2-116.2-84.3-188.5-99.1l1.4-19.3c1.2-17.4-3.3-33.9-11.9-47.6zM249.6 200.7l4.7 65.1c-30.8 9.4-58.8 25.4-82.4 46.2c-13.3 11.7-33.5 10.4-45.2-2.8s-10.4-33.5 2.8-45.2c33.9-29.9 74.9-52 120.1-63.3zm136.2 65.1l4.6-65.1c45.2 11.4 86.2 33.4 120.1 63.3c13.2 11.7 14.5 31.9 2.8 45.2s-31.9 14.5-45.2 2.8c-23.6-20.8-51.6-36.7-82.4-46.2z", "M320 32c-27.2 0-48.7 23.1-46.8 50.2l14.9 208C289.3 307 303.2 320 320 320s30.7-13 31.9-29.7l14.9-208C368.7 55.1 347.2 32 320 32zm0 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faChartNetwork = {
  prefix: 'fad',
  iconName: 'chart-network',
  icon: [640, 512, [], "f78a", ["M276.4 100.7C264.9 117.2 245.7 128 224 128c-1.9 0-3.7-.1-5.6-.2l29.2 62.5C221.8 210.4 203 239 195.6 272H119.4c5.4 9.4 8.6 20.3 8.6 32s-3.1 22.6-8.6 32h76.1c14.6 64.1 71.9 112 140.4 112c40.8 0 77.7-17 103.9-44.3L512 446.9c.4-23.6 13.6-44.1 32.9-54.9l-72-43.2c4.6-14.1 7.1-29.2 7.1-44.8c0-20.3-4.2-39.7-11.8-57.2l82-60.2c-20.5-9-35.3-28.5-37.8-51.6l-82.1 60.2C405 173.3 372.1 160 336 160c-10.4 0-20.6 1.1-30.4 3.2l-29.2-62.5zM336 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z", "M224 128A64 64 0 1 0 224 0a64 64 0 1 0 0 128zm352 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm64 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 368a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faPersonDressBurst = {
  prefix: 'fad',
  iconName: 'person-dress-burst',
  icon: [640, 512, [], "e544", ["M176 8c6.6 0 12.4 4 14.9 10.1l29.4 74 76.2-23.1c6.3-1.9 13.1 .2 17.2 5.3s4.6 12.2 1.4 17.9l-39.5 69.1 65.6 45.1c5.4 3.7 8 10.3 6.5 16.7s-6.7 11.2-13.1 12.2l-78.7 12.2 5.6 79.4c.5 6.5-3.1 12.7-9 15.5s-12.9 1.8-17.8-2.6L176 286.1l-58.6 53.9c-4.8 4.4-11.9 5.5-17.8 2.6s-9.5-9-9-15.5l5.6-79.4L17.6 235.4c-6.5-1-11.7-5.9-13.1-12.2s1.1-13 6.5-16.7l65.6-45.1L37 92.2c-3.3-5.7-2.7-12.8 1.4-17.9s10.9-7.2 17.2-5.3l76.2 23.1 29.4-74C163.6 12 169.4 8 176 8z", "M480 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM408 384H390.2c-10.9 0-18.6-10.7-15.2-21.1l38.3-114.8-33.9 56.3c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L585 362.9c3.5 10.4-4.3 21.1-15.2 21.1H552v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H472v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"]]
};
var faDiceD4 = {
  prefix: 'fad',
  iconName: 'dice-d4',
  icon: [512, 512, [], "f6d0", ["M240 16c0-7-4.5-13.2-11.2-15.3s-13.9 .3-17.9 6.1l-208 296c-4.7 6.7-3.6 15.8 2.5 21.2l208 184c4.7 4.2 11.4 5.2 17.2 2.6s9.4-8.3 9.4-14.6V16z", "M272 16c0-7 4.5-13.2 11.2-15.3s13.9 .3 17.9 6.1l208 296c4.7 6.7 3.6 15.8-2.5 21.2l-208 184c-4.7 4.2-11.4 5.2-17.2 2.6s-9.4-8.3-9.4-14.6V16z"]]
};
var faMoneyCheckDollar = {
  prefix: 'fad',
  iconName: 'money-check-dollar',
  icon: [576, 512, ["money-check-alt"], "f53d", ["M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164 152v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z", "M164 152c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V360c0 11 9 20 20 20s20-9 20-20V346.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V152zm108 40c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H272z"]]
};
var faMoneyCheckAlt = faMoneyCheckDollar;
var faVectorSquare = {
  prefix: 'fad',
  iconName: 'vector-square',
  icon: [448, 512, [], "f5cb", ["M320 64H128v64H320V64zm0 320H128v64H320V384zM32 160V352H96V160H32zm384 0H352V352h64V160z", "M368 80h32v32H368V80zM352 32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM48 432V400H80v32H48zM0 384v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm368 48V400h32v32H368zm-48-48v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zM48 112V80H80v32H48zM0 64v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64z"]]
};
var faBreadSlice = {
  prefix: 'fad',
  iconName: 'bread-slice',
  icon: [512, 512, [], "f7ec", ["M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64zM128 400a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0-96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z", "M144 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm96 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]]
};
var faLanguage = {
  prefix: 'fad',
  iconName: 'language',
  icon: [640, 512, [], "f1ab", ["M0 128C0 92.7 28.7 64 64 64H320V448H64c-35.3 0-64-28.7-64-64V128zm160 36c-7.9 0-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144c-3.2-7.2-10.4-11.9-18.3-11.9zM141 276l19-42.8L179 276H141z", "M640 128c0-35.3-28.7-64-64-64H320V448H576c35.3 0 64-28.7 64-64V128zM500 184v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H480 408c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20s20 9 20 20zM160 164c-7.9 0-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144c-3.2-7.2-10.4-11.9-18.3-11.9zm0 69.2L179 276H141l19-42.8z"]]
};
var faWheatAwnSlash = {
  prefix: 'fad',
  iconName: 'wheat-awn-slash',
  icon: [640, 512, [], "e338", ["M362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L550.5 231c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L569 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L473 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L393.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L369.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L335.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4l137.8 108zm-68.7 68.7l-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM569 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L447 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faFaceKissWinkHeart = {
  prefix: 'fad',
  iconName: 'face-kiss-wink-heart',
  icon: [512, 512, [128536, "kiss-wink-heart"], "f598", ["M512 256c0 29.3-4.9 57.4-14 83.7c-11.1-4.7-23.5-6.6-36.2-5c-13.7-33.8-50.3-54.4-87.5-44c-40.1 11.2-61.9 53.1-51.8 92.1l22.9 89.3c1.9 7.6 5.6 14.2 10.4 19.7c-30.6 13-64.4 20.2-99.7 20.2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM288.7 313.7c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 292.9 241.4 288 224 288c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l0 0 0 0 0 0 .2 .1 .3 .2 .6 .4c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3zM208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm92.4 25.6c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z", "M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm162.8 25.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"]]
};
var faKissWinkHeart = faFaceKissWinkHeart;
var faDagger = {
  prefix: 'fad',
  iconName: 'dagger',
  icon: [384, 512, [], "f6cb", ["M152 192H128v24V414.8c0 10.5 2.9 20.8 8.5 29.7l35.1 56.2c4.4 7 12.1 11.3 20.4 11.3s16-4.3 20.4-11.3l35.1-56.2c5.6-8.9 8.5-19.2 8.5-29.7V216 192H232 152z", "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H48c-26.5 0-48 21.5-48 48s21.5 48 48 48c20.9 0 38.7-13.4 45.3-32H192h98.7c6.6 18.6 24.4 32 45.3 32c26.5 0 48-21.5 48-48s-21.5-48-48-48H224V32z"]]
};
var faPodium = {
  prefix: 'fad',
  iconName: 'podium',
  icon: [448, 512, [], "f680", ["M310.7 512H137.3c-32.6 0-60-24.5-63.6-56.9L44.4 192H403.6L374.3 455.1c-3.6 32.4-31 56.9-63.6 56.9z", "M182.4 72H168c-22.1 0-40 17.9-40 40v32H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H80V112c0-48.6 39.4-88 88-88h14.4C190.7 9.7 206.2 0 224 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H224c-17.8 0-33.3-9.7-41.6-24z"]]
};
var faMemoCircleCheck = {
  prefix: 'fad',
  iconName: 'memo-circle-check',
  icon: [576, 512, [], "e1d9", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c3.3 0 6.6-.3 9.7-.7C285.1 479.3 256 427.1 256 368c0-80.6 54.1-148.5 128-169.4V64c0-35.3-28.7-64-64-64H64zM80 128H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faRouteHighway = {
  prefix: 'fad',
  iconName: 'route-highway',
  icon: [448, 512, [], "f61a", ["M32 192H416c0 1.1 0 2.2 0 3.2c0 14.9 2.8 29.7 8.4 43.6l14.3 35.7c6.2 15.4 9.3 31.9 9.3 48.5c0 49.5-28 94.8-72.2 116.9L238.3 508.6c-9 4.5-19.6 4.5-28.6 0L72.2 439.9C28 417.8 0 372.5 0 323c0-16.6 3.2-33.1 9.3-48.5l14.3-35.7C29.2 225 32 210.2 32 195.2c0-1.1 0-2.2 0-3.2zM384 323l0 .1v-.2l0 .1z", "M240.5 4.6c-10.1-6.1-22.8-6.1-32.9 0l-4.7 2.8c-37.5 22.5-84 24.3-123.1 4.7l-1.4-.7c-15.2-7.6-33.7-2-42.1 12.7l-32 56c-5.3 9.3-5.6 20.6-.8 30.2l16.2 32.5C27.3 158.1 31.5 174.9 32 192H416c.5-17.1 4.7-33.9 12.3-49.2l16.2-32.5c4.8-9.6 4.5-20.9-.8-30.2l-32-56c-8.4-14.7-26.9-20.3-42.1-12.7l-1.4 .7c-39.1 19.6-85.6 17.8-123.1-4.7l-4.7-2.8z"]]
};
var faDownToLine = {
  prefix: 'fad',
  iconName: 'down-to-line',
  icon: [384, 512, ["arrow-alt-to-bottom"], "f34a", ["M0 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M219.3 372.7L342.1 249.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9L256 192l0-128c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 128-62.1 0C47.2 192 32 207.2 32 225.9c0 9 3.6 17.6 9.9 24L164.7 372.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3z"]]
};
var faArrowAltToBottom = faDownToLine;
var faFilter = {
  prefix: 'fad',
  iconName: 'filter',
  icon: [512, 512, [], "f0b0", ["M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z", ""]]
};
var faSquareG = {
  prefix: 'fad',
  iconName: 'square-g',
  icon: [448, 512, [], "e271", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80z", "M224 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176z"]]
};
var faCirclePhone = {
  prefix: 'fad',
  iconName: 'circle-phone',
  icon: [512, 512, ["phone-circle"], "e11b", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.7 128.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L200 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C368.9 378 361 384 352 384c-123.7 0-224-100.3-224-224c0-9 6-16.9 14.7-19.3l44-12z", "M210.5 140.3c-3.9-9.3-14-14.2-23.7-11.6l-44 12C134 143.1 128 151 128 160c0 123.7 100.3 224 224 224c9 0 16.9-6 19.3-14.7l12-44c2.6-9.7-2.3-19.9-11.6-23.7l-48-20c-8.2-3.4-17.6-1-23.2 5.8L280.3 312c-35.2-16.6-63.7-45.1-80.3-80.3l24.7-20.2c6.8-5.6 9.2-15 5.8-23.2l-20-48z"]]
};
var faPhoneCircle = faCirclePhone;
var faClipboardPrescription = {
  prefix: 'fad',
  iconName: 'clipboard-prescription',
  icon: [384, 512, [], "f5e8", ["M113.2 66.3c.1-.8 .3-1.6 .4-2.3H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H270.4c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z", "M113.2 66.3C93.9 72.6 80 90.7 80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112c0-21.3-13.9-39.4-33.2-45.7C264.4 28.7 231.5 0 192 0s-72.4 28.7-78.8 66.3zM168 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM104 196c-11 0-20 9-20 20v80 64c0 11 9 20 20 20s20-9 20-20V316h20c.7 .9 1.5 1.8 2.3 2.6l64.8 60.8-32.6 29.9c-8.1 7.5-8.7 20.1-1.2 28.3s20.1 8.7 28.3 1.2l34.9-32 33.9 31.8c8.1 7.6 20.7 7.1 28.3-.9s7.1-20.7-.9-28.3L270 379.7l31.6-28.9c8.1-7.5 8.7-20.1 1.2-28.3s-20.1-8.7-28.3-1.2l-33.8 31-43-40.3c22.4-8.7 38.3-30.5 38.3-55.9c0-33.1-26.9-60-60-60H104zm72 80H124V236h52c11 0 20 9 20 20s-9 20-20 20z"]]
};
var faUserNurseHair = {
  prefix: 'fad',
  iconName: 'user-nurse-hair',
  icon: [448, 512, [], "e45d", ["M192 176H120c-8.5 0-16.6-1.9-23.8-5.3C99.4 236 153.4 288 219.6 288h8.8C296.7 288 352 232.7 352 164.4c0-1.5 0-3-.1-4.4H328c-22.8 0-42.8-11.9-54.1-29.8C257 157.7 226.6 176 192 176z", "M96 96v32 42.6c7.3 3.5 15.4 5.4 24 5.4h72c34.6 0 65-18.3 81.9-45.8C285.2 148.1 305.2 160 328 160h24V128 96 70.2c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2V96zm45.3 240.2c-7.6-8.1-18.9-11.9-29.4-8.5C47 348.5 0 409.4 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-71.9-47-132.7-111.9-153.6c-10.5-3.4-21.8 .4-29.4 8.5l-71 75.5c-6.3 6.7-17 6.7-23.3 0l-71-75.5zM208 48c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8V64h16c4.4 0 8 3.6 8 8V88c0 4.4-3.6 8-8 8H240v16c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8V96H192c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h16V48z"]]
};
var faQuestion = {
  prefix: 'fad',
  iconName: 'question',
  icon: [320, 512, [10067, 10068, 61736], "3f", ["M120 440a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z", "M144 96c-35.3 0-64 28.7-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128v3.6c0 43.6-22.1 84.1-58.8 107.7L203 298.4c-6.9 4.4-11 12-11 20.2V320c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.4c0-29.9 15.2-57.8 40.4-74l42.2-27.1c18.3-11.8 29.4-32.1 29.4-53.8V160c0-35.3-28.7-64-64-64H144z"]]
};
var faFileSignature = {
  prefix: 'fad',
  iconName: 'file-signature',
  icon: [576, 512, [], "f573", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V390.8l-1.1 1.1c-4.1 4.1-9.2 7-14.9 8.4L310 414.9c-1.8 .7-3.9 1.1-6 1.1H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h41.6l12-48.2c1.4-5.6 4.3-10.8 8.4-14.9L384 248.9V160H256c-17.7 0-32-14.3-32-32V0H64z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zm165.8-20.3l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 321L441.1 191.8l71 71L382.9 391.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]]
};
var faToggleLargeOn = {
  prefix: 'fad',
  iconName: 'toggle-large-on',
  icon: [576, 512, [], "e5b1", ["M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 64a128 128 0 1 1 0 256 128 128 0 1 1 0-256z", "M384 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z"]]
};
var faUpDownLeftRight = {
  prefix: 'fad',
  iconName: 'up-down-left-right',
  icon: [512, 512, ["arrows-alt"], "f0b2", ["M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96l64 0V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM288 288l-64 0v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288z", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 32 256 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-256 0 0 32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64z"]]
};
var faArrowsAlt = faUpDownLeftRight;
var faDryerHeat = {
  prefix: 'fad',
  iconName: 'dryer-heat',
  icon: [448, 512, ["dryer-alt"], "f862", ["M160 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-3.3 124.7c6.2-6.2 16.4-6.2 22.6 0L200 233.4c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L168 374.6c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6zm102.6 0L280 233.4c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L248 374.6c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faDryerAlt = faDryerHeat;
var faHouseChimneyUser = {
  prefix: 'fad',
  iconName: 'house-chimney-user',
  icon: [576, 512, [], "e065", ["M64 270.5L64.1 448c0 35.3 28.7 64 64 64H448.5c35.4 0 64.1-28.7 64-64.1l-.4-177.3L288 74.5 64 270.5zM288 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z", "M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2L512 185.5V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v37.5L309.1 7.9zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"]]
};
var faHandHoldingHeart = {
  prefix: 'fad',
  iconName: 'hand-holding-heart',
  icon: [576, 512, [], "f4be", ["M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z", "M224.6 0C182.3 0 148 34.3 148 76.6c0 20.3 8.1 39.8 22.4 54.1L273.9 234.1c7.8 7.8 20.5 7.8 28.3 0L405.6 130.7C419.9 116.4 428 96.9 428 76.6C428 34.3 393.7 0 351.4 0c-20.3 0-39.8 8.1-54.1 22.4L288 31.7l-9.3-9.3C264.4 8.1 244.9 0 224.6 0z"]]
};
var faArrowUpSmallBig = {
  prefix: 'fad',
  iconName: 'arrow-up-small-big',
  icon: [576, 512, ["sort-size-up-alt"], "f88f", ["M368 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368zm0 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H368z", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z"]]
};
var faSortSizeUpAlt = faArrowUpSmallBig;
var faTrainTrack = {
  prefix: 'fad',
  iconName: 'train-track',
  icon: [576, 512, [], "e453", ["M147.6 96l-21.3 64H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h35.6zM104.9 224L83.6 288H72c-17.7 0-32-14.3-32-32s14.3-32 32-32h32.9zm46.1 64l21.3-64H403.6l21.3 64H151.1zM62.3 352L40.9 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H62.3zm46.1 64l21.3-64H446.3l21.3 64H108.4zm426.7 0l-21.3-64H544c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8.9zM492.4 288l-21.3-64H504c17.7 0 32 14.3 32 32s-14.3 32-32 32H492.4zM449.7 160L428.4 96H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H449.7zM360.9 96l21.3 64H193.7l21.3-64H360.9z", "M202.1 33.6c16.8 5.6 25.8 23.7 20.2 40.5l-128 384c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l128-384c5.6-16.8 23.7-25.8 40.5-20.2zm171.8 0c16.8-5.6 34.9 3.5 40.5 20.2l128 384c5.6 16.8-3.5 34.9-20.2 40.5s-34.9-3.5-40.5-20.2l-128-384c-5.6-16.8 3.5-34.9 20.2-40.5z"]]
};
var faPuzzlePiece = {
  prefix: 'fad',
  iconName: 'puzzle-piece',
  icon: [512, 512, [129513], "f12e", ["M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8v0c0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2v0c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2v0c-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48H279.2c-12.8 0-23.2-10.4-23.2-23.2v0c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8v0c0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320v0c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256v0C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48H168.8c12.8 0 23.2-10.4 23.2-23.2v0z", ""]]
};
var faMoneyCheck = {
  prefix: 'fad',
  iconName: 'money-check',
  icon: [576, 512, [], "f53c", ["M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM408 160h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H408c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z", "M408 160c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H408zM112 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]]
};
var faStarHalfStroke = {
  prefix: 'fad',
  iconName: 'star-half-stroke',
  icon: [640, 512, ["star-half-alt"], "f5c0", ["M320.1 376.3l-.1 .1v63.5l.1-.1 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L470.5 329 574.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L413.2 150.3 348.9 18C343.6 7 332.4 0 320.1 0c-.5 0-1.1 0-1.6 0H320V87.1l.1-.3 42.7 87.9 12.9 26.6 29.3 4.3 96.1 14.2-70.1 69.3-20.7 20.5 4.8 28.7 16.5 97.6-85.2-45.5-26.4-14.1zM178.3 512c-1.1 .1-2.1 .1-3.2 0h3.2z", "M321.7 0H320V87.1 376.4v63.5L191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18c.5 0 1.1 0 1.6 0zM465.2 512c-1.1 .1-2.1 .1-3.2 0h3.2z"]]
};
var faStarHalfAlt = faStarHalfStroke;
var faFileExclamation = {
  prefix: 'fad',
  iconName: 'file-exclamation',
  icon: [384, 512, [], "f31a", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 192c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM192 192c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
};
var faCode = {
  prefix: 'fad',
  iconName: 'code',
  icon: [640, 512, [], "f121", ["M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6z", "M473.4 121.4c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"]]
};
var faWhiskeyGlass = {
  prefix: 'fad',
  iconName: 'whiskey-glass',
  icon: [512, 512, [129347, "glass-whiskey"], "f7a0", ["M7.8 43.1C13.9 36 22.7 32 32 32H480c9.3 0 18.1 4 24.2 11.1s8.8 16.4 7.5 25.5l-50 342.9c-5.7 39.3-39.4 68.5-79.2 68.5h-253c-39.7 0-73.4-29.1-79.2-68.5L.3 68.6C-1 59.4 1.7 50.1 7.8 43.1zM69 96l44.7 306.3c1.1 7.9 7.9 13.7 15.8 13.7h253c7.9 0 14.7-5.8 15.8-13.7L443 96H69z", "M424.3 224H87.7l26 178.3c1.1 7.9 7.9 13.7 15.8 13.7h253c7.9 0 14.7-5.8 15.8-13.7l26-178.3z"]]
};
var faGlassWhiskey = faWhiskeyGlass;
var faMoonStars = {
  prefix: 'fad',
  iconName: 'moon-stars',
  icon: [512, 512, [], "f755", ["M284.8 99.2l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11zM387.2 252.8l16.6 58c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2s3.8 10.7 9.2 12.2l58 16.6z", "M191.8 128C85.8 128 0 214.1 0 320.2S85.8 512.4 191.8 512.4c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.2-25.1 2.2c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-5.4-.5-10.8-.7-16.3-.7z"]]
};
var faBuildingCircleExclamation = {
  prefix: 'fad',
  iconName: 'building-circle-exclamation',
  icon: [640, 512, [], "e4d3", ["M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faClothesHanger = {
  prefix: 'fad',
  iconName: 'clothes-hanger',
  icon: [640, 512, [], "e136", ["M209.8 84.8C222.3 35 267.1 0 318.5 0H320c61.9 0 112 50.1 112 112v6.3c0 36.5-17.8 70.8-47.8 91.8l-8.3 5.8L608.2 377.2C628.1 391 640 413.7 640 438c0 40.9-33.1 74-74 74H74c-40.9 0-74-33.1-74-74c0-24.2 11.9-47 31.8-60.8L301.6 189.8l.1-.1 45.8-32c12.8-9 20.5-23.7 20.5-39.3V112c0-26.5-21.5-48-48-48h-1.5c-22 0-41.2 15-46.6 36.4l-.9 3.4c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l.9-3.4zM320 255L68.3 429.7c-2.7 1.9-4.3 4.9-4.3 8.2c0 5.5 4.5 10 10 10H566c5.5 0 10-4.5 10-10c0-3.3-1.6-6.4-4.3-8.2L320 255z", ""]]
};
var faMobileNotch = {
  prefix: 'fad',
  iconName: 'mobile-notch',
  icon: [384, 512, ["mobile-iphone"], "e1ee", ["M256 64V80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V64H96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H256zM16 80C16 35.8 51.8 0 96 0H288c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80V80z", "M128 64H96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H256V80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V64z"]]
};
var faMobileIphone = faMobileNotch;
var faMagnifyingGlassChart = {
  prefix: 'fad',
  iconName: 'magnifying-glass-chart',
  icon: [512, 512, [], "e522", ["M208 416A208 208 0 1 0 208 0a208 208 0 1 0 0 416zM104 216c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24V216zm80-96c0-13.3 10.7-24 24-24s24 10.7 24 24V280c0 13.3-10.7 24-24 24s-24-10.7-24-24V120zm80 64c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V184z", "M104 216c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24V216zm80-96c0-13.3 10.7-24 24-24s24 10.7 24 24V280c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-160zm80 64c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V184zM457.4 502.6L330.7 376C348 363.3 363.3 348 376 330.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"]]
};
var faArrowUpRightFromSquare = {
  prefix: 'fad',
  iconName: 'arrow-up-right-from-square',
  icon: [512, 512, ["external-link"], "f08e", ["M0 112C0 67.8 35.8 32 80 32H192c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V320c0-17.7 14.3-32 32-32s32 14.3 32 32V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112z", "M288 32c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32V192c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L246.6 310.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 64H320c-17.7 0-32-14.3-32-32z"]]
};
var faExternalLink = faArrowUpRightFromSquare;
var faCubesStacked = {
  prefix: 'fad',
  iconName: 'cubes-stacked',
  icon: [448, 512, [], "e4e6", ["M71 250.7c-8.8-15.3-3.6-34.9 11.7-43.7l55.4-32c15.3-8.8 34.9-3.6 43.7 11.7l32 55.4c8.8 15.3 3.6 34.9-11.7 43.7l-55.4 32c-15.3 8.8-34.9 3.6-43.7-11.7L71 250.7zM320 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384zM32 352H96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32z", "M224 32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224zm32 192v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32zM160 384v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32z"]]
};
var faImagesUser = {
  prefix: 'fad',
  iconName: 'images-user',
  icon: [576, 512, [], "e1b9", ["M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM272 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM224 301.7c0-25.2 20.5-45.7 45.7-45.7H402.3c25.2 0 45.7 20.5 45.7 45.7c0 10.1-8.2 18.3-18.3 18.3H242.3c-10.1 0-18.3-8.2-18.3-18.3z", "M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm352 40a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM224 301.7c0 10.1 8.2 18.3 18.3 18.3H429.7c10.1 0 18.3-8.2 18.3-18.3c0-25.2-20.5-45.7-45.7-45.7H269.7c-25.2 0-45.7 20.5-45.7 45.7z"]]
};
var faWonSign = {
  prefix: 'fad',
  iconName: 'won-sign',
  icon: [512, 512, [8361, "krw", "won"], "f159", ["M51.6 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H72.9L51.6 224zM167 288l16-64h-64l21.3 64H167zm66 0h46l-16-64H249l-16 64zm96-64l16 64h26.6l21.3-64H329zm131.4 0l-21.3 64H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4z", "M21.9 33.6c16.8-5.6 34.9 3.5 40.5 20.2l93.2 279.7L225 56.2C228.5 42 241.3 32 256 32s27.5 10 31 24.2l69.3 277.4L449.6 53.9c5.6-16.8 23.7-25.8 40.5-20.2s25.8 23.7 20.2 40.5l-128 384c-4.5 13.5-17.4 22.4-31.6 21.9s-26.4-10.4-29.8-24.2L256 195.9 191 455.8c-3.5 13.8-15.6 23.7-29.8 24.2s-27.1-8.4-31.6-21.9L1.6 74.1C-3.9 57.4 5.1 39.2 21.9 33.6z"]]
};
var faKrw = faWonSign;
var faWon = faWonSign;
var faImagePolaroidUser = {
  prefix: 'fad',
  iconName: 'image-polaroid-user',
  icon: [448, 512, [], "e1b6", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H352c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32z", "M96 96c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32h16c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64h16c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96zm64 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]]
};
var faVirusCovid = {
  prefix: 'fad',
  iconName: 'virus-covid',
  icon: [512, 512, [], "e4a8", ["M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V73.6c32.9 4.3 63 17.2 88 36.5L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9 402 144c19.2 25 32.2 55.2 36.5 88H464V216c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H438.4c-4.3 32.9-17.2 63-36.5 88L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420 368 402c-25 19.2-55.2 32.2-88 36.5V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V438.4c-32.9-4.3-63-17.2-88-36.5L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1 110 368c-19.2-25-32.2-55.2-36.5-88H48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v16H73.6c4.3-32.9 17.2-63 36.5-88L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92 144 110c25-19.2 55.2-32.2 88-36.5V48H216c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M192 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96z"]]
};
var faSquareEllipsis = {
  prefix: 'fad',
  iconName: 'square-ellipsis',
  icon: [448, 512, [], "e26e", ["M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm160-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M128 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faPie = {
  prefix: 'fad',
  iconName: 'pie',
  icon: [576, 512, [129383], "f705", ["M47.3 301.9L81.4 404.2c8.7 26.1 33.2 43.8 60.7 43.8H433.9c27.5 0 52-17.6 60.7-43.8l34.1-102.3c-11.7-2.6-22.8-7.2-32.2-12.1c-7-3.6-12.7-7.3-16.6-10c-2-1.4-3.5-2.5-4.5-3.2c-.5-.4-.9-.7-1.1-.8l-.2-.2 0 0 0 0 0 0 0 0 0 0 0 0c-6.1-4.9-14.8-4.7-20.7 .4l-.1 .1c-.2 .2-.5 .4-.9 .8c-.9 .7-2.2 1.8-4.1 3.1c-3.7 2.6-9.1 6.2-16.1 9.8C418.2 297 398.7 304 376 304s-42.2-7-56.1-14.2c-7-3.6-12.4-7.2-16.1-9.8c-1.8-1.3-3.2-2.4-4.1-3.1c-.4-.4-.7-.6-.9-.8l-.1-.1 0 0c-6.1-5.4-15.2-5.4-21.2 0l-.1 .1c-.2 .2-.5 .4-.9 .8c-.9 .7-2.2 1.8-4.1 3.1c-3.7 2.6-9.1 6.2-16.1 9.8C242.2 297 222.7 304 200 304s-42.2-7-56.1-14.2c-7-3.6-12.4-7.2-16.1-9.8c-1.8-1.3-3.2-2.4-4.1-3.1c-.4-.4-.7-.6-.9-.8l-.2-.1 0 0c-5.9-5.2-14.6-5.4-20.7-.4l0 0 0 0-.2 .2c-.2 .2-.6 .5-1.1 .8c-1 .7-2.5 1.9-4.5 3.2c-4 2.7-9.7 6.4-16.7 10c-9.4 4.9-20.5 9.5-32.2 12.1zm54.6-26.3l20.7 .4s0 0 0 0l-20.7-.4z", "M544 240c-7.6 0-14.3-4.9-17-12C490 132.1 397 64 288 64S86 132.1 49 228c-2.7 7.1-9.4 12-17 12c-17.7 0-32 14.3-32 32c0 17.2 13.6 31.3 30.7 32c17.7-.5 35-7 48.7-14.2c7-3.6 12.7-7.3 16.7-10c2-1.4 3.5-2.5 4.5-3.2c.5-.4 .9-.7 1.1-.8l.2-.2 0 0 20.7 .4 0 0 .2 .1c.2 .2 .5 .4 .9 .8c.9 .7 2.2 1.8 4.1 3.1c3.7 2.6 9.1 6.2 16.1 9.8c14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8c1.8-1.3 3.2-2.4 4.1-3.1c.4-.4 .7-.6 .9-.8l.1-.1c6.1-5.4 15.2-5.4 21.2 0l0 0 .1 .1c.2 .2 .5 .4 .9 .8c.9 .7 2.2 1.8 4.1 3.1c3.7 2.6 9.1 6.2 16.1 9.8c14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8c1.8-1.3 3.2-2.4 4.1-3.1c.4-.4 .7-.6 .9-.8l.1-.1c5.9-5.2 14.6-5.4 20.7-.4l0 0 0 0 0 0 0 0 0 0 0 0 .2 .2c.2 .2 .6 .5 1.1 .8c1 .7 2.5 1.9 4.5 3.2c4 2.7 9.7 6.4 16.7 10c13.7 7.2 31.1 13.7 48.7 14.2c17.1-.7 30.7-14.7 30.7-32c0-17.7-14.3-32-32-32zM122.6 276c-5.9-5.2-14.6-5.4-20.7-.4l0 0 20.7 .4s0 0 0 0zm76.6-146.3c7.9 4 11.1 13.6 7.2 21.5l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2zm177.7 0c7.9-4 17.5-.7 21.5 7.2l16 32c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5zM288 128c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z"]]
};
var faChessKnightPiece = {
  prefix: 'fad',
  iconName: 'chess-knight-piece',
  icon: [320, 512, ["chess-knight-alt"], "f442", ["M272 416H48L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L272 416z", "M50.7 109.3l6.9-6.9L40.7 94C35.4 91.3 32 85.8 32 79.8C32 71.1 39.1 64 47.8 64h81.5C225.8 64 304 142.2 304 238.7c0 11.5-1.1 23-3.4 34.3L272 416H48V389.7c0-29.8 13.8-57.9 37.5-76.1l71.2-54.7c8.1-6.2 8-18.5-.2-24.7c-5.5-4.1-13.1-4.1-18.6 0L99.1 263.3c-2 1.5-4.2 2.9-6.5 4c-13.7 6.9-30 5.8-42.8-2.7l-3.5-2.4C37.3 256.4 32 246.4 32 235.7V154.5c0-17 6.7-33.3 18.7-45.3zm42.1 63.5a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faChessKnightAlt = faChessKnightPiece;
var faAustralSign = {
  prefix: 'fad',
  iconName: 'austral-sign',
  icon: [448, 512, [], "e0a9", ["M122.7 224L96 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h90.7zm-40 96L56 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H82.7zm42.7 64L152 320H296l26.7 64H125.3zM392 384l-26.7-64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H392zm-40-96l-26.7-64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H352zM192 224h64l26.7 64H165.3L192 224z", "M224 32c12.9 0 24.6 7.8 29.5 19.7l160 384c6.8 16.3-.9 35-17.2 41.8s-35-.9-41.8-17.2L224 147.2 93.5 460.3c-6.8 16.3-25.5 24-41.8 17.2s-24-25.5-17.2-41.8l160-384C199.4 39.8 211.1 32 224 32z"]]
};
var faCloudPlus = {
  prefix: 'fad',
  iconName: 'cloud-plus',
  icon: [640, 512, [], "e35e", ["M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM296 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H232c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z", "M296 312v64c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H232c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faF = {
  prefix: 'fad',
  iconName: 'f',
  icon: [320, 512, [102], "46", ["M64 32C28.7 32 0 60.7 0 96V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z", ""]]
};
var faLeaf = {
  prefix: 'fad',
  iconName: 'leaf',
  icon: [512, 512, [], "f06c", ["M96.4 260.1C102.5 168.5 178.8 96 272 96l104 0c42.7 0 79.9-23.9 98.8-59.1c3.5-6.5 13.6-6.8 16.2 .1c13.5 36.5 21.1 77 21.1 119.6C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C131.7 289 171.9 272 216 272h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-44.2 0-85.4 13.3-119.6 36.1z", "M216 272c-92.8 0-168 75.2-168 168v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440C0 320.7 96.7 224 216 224h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H216z"]]
};
var faBedBunk = {
  prefix: 'fad',
  iconName: 'bed-bunk',
  icon: [576, 512, [], "f8f8", ["M192 48A48 48 0 1 0 96 48a48 48 0 1 0 96 0zm0 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM256 0c-17.7 0-32 14.3-32 32v96H576C576 57.3 518.7 0 448 0H256zM240 256c-8.8 0-16 7.2-16 16V384H512V256H240z", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96 64V480c0 17.7 14.3 32 32 32s32-14.3 32-32V448H256 512v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448 416 288 192 160 128H544 256 64V32zM512 288v96H256 64V192H256 512v96z"]]
};
var faRoad = {
  prefix: 'fad',
  iconName: 'road',
  icon: [576, 512, [128739], "f018", ["M256 32h64V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm32 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zm0 192c17.7 0 32 14.3 32 32v64H256V416c0-17.7 14.3-32 32-32z", "M256 32H181.2c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480H256V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64H521.4c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z"]]
};
var faTaxi = {
  prefix: 'fad',
  iconName: 'taxi',
  icon: [512, 512, [128662, "cab"], "f1ba", ["M192 0H320c17.7 0 32 14.3 32 32V64H160V32c0-17.7 14.3-32 32-32zM135.2 149.4c4.5-12.8 16.6-21.4 30.2-21.4H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 224H109.1l26.1-74.6zM96 432v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V432H96zm320 0h96v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V432z", "M135.2 149.4L109.1 224H402.9l-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 228.8L74.8 128.3C88.3 89.8 124.6 64 165.4 64H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V432H0V288c0-26.7 16.4-49.6 39.6-59.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faCab = faTaxi;
var faPersonCirclePlus = {
  prefix: 'fad',
  iconName: 'person-circle-plus',
  icon: [576, 512, [], "e541", ["M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]]
};
var faChartPie = {
  prefix: 'fad',
  iconName: 'chart-pie',
  icon: [576, 512, ["pie-chart"], "f200", ["M32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272z", "M527.4 240H304V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16zm31 48c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"]]
};
var faPieChart = faChartPie;
var faBoltLightning = {
  prefix: 'fad',
  iconName: 'bolt-lightning',
  icon: [384, 512, [], "e0b7", ["", "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"]]
};
var faClockEight = {
  prefix: 'fad',
  iconName: 'clock-eight',
  icon: [512, 512, [], "e345", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V256c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3L232 243.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M256 96c13.3 0 24 10.7 24 24V256c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3L232 243.2V120c0-13.3 10.7-24 24-24z"]]
};
var faSackXmark = {
  prefix: 'fad',
  iconName: 'sack-xmark',
  icon: [512, 512, [], "e56a", ["M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 320l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z", "M192 96H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zM175 401c-9.4-9.4-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0z"]]
};
var faFileExcel = {
  prefix: 'fad',
  iconName: 'file-excel',
  icon: [384, 512, [], "f1c3", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM155.7 250.2c-7.6-10.9-22.6-13.5-33.4-5.9s-13.5 22.6-5.9 33.4L162.7 344l-46.4 66.2c-7.6 10.9-5 25.8 5.9 33.4s25.8 5 33.4-5.9L192 385.8l36.3 51.9c7.6 10.9 22.6 13.5 33.4 5.9s13.5-22.6 5.9-33.4L221.3 344l46.4-66.2c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L192 302.1l-36.3-51.9z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM155.7 250.2c-7.6-10.9-22.6-13.5-33.4-5.9s-13.5 22.6-5.9 33.4L162.7 344l-46.4 66.2c-7.6 10.9-5 25.8 5.9 33.4s25.8 5 33.4-5.9L192 385.8l36.3 51.9c7.6 10.9 22.6 13.5 33.4 5.9s13.5-22.6 5.9-33.4L221.3 344l46.4-66.2c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L192 302.1l-36.3-51.9z"]]
};
var faFileContract = {
  prefix: 'fad',
  iconName: 'file-contract',
  icon: [384, 512, [], "f56c", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm54.2 253.8L144 349l16.7 55.6c1.9 6.3 7.4 10.8 13.9 11.3s12.8-2.9 15.7-8.8l8.8-17.7c1.7-3.4 5.1-5.5 8.8-5.5s7.2 2.1 8.8 5.5l8.8 17.7c2.7 5.4 8.3 8.8 14.3 8.8h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H249.9l-4.4-8.8C238.4 361 223.9 352 208 352c-10 0-19.4 3.5-26.8 9.7l-11.6-38.6C166.2 311.7 155.8 304 144 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.2c21.2 0 39.9-13.9 46-34.2z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM134.2 381.8L144 349l16.7 55.6c1.9 6.3 7.4 10.8 13.9 11.3s12.8-2.9 15.7-8.8l8.8-17.7c1.7-3.4 5.1-5.5 8.8-5.5s7.2 2.1 8.8 5.5l8.8 17.7c2.7 5.4 8.3 8.8 14.3 8.8h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H249.9l-4.4-8.8C238.4 361 223.9 352 208 352c-10 0-19.4 3.5-26.8 9.7l-11.6-38.6C166.2 311.7 155.8 304 144 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.2c21.2 0 39.9-13.9 46-34.2z"]]
};
var faFishFins = {
  prefix: 'fad',
  iconName: 'fish-fins',
  icon: [576, 512, [], "e4f2", ["M182 150.4C221.3 120.9 273.7 96 336 96s114.7 24.9 154 54.4c39.2 29.4 67.2 64.7 81.6 89.5c5.8 9.9 5.8 22.2 0 32.1c-14.4 24.8-42.5 60.1-81.6 89.5C450.7 391.1 398.3 416 336 416s-114.7-24.9-154-54.4c-15.3-11.5-29-23.9-40.7-36.3L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l93.1 54.3c11.8-12.3 25.4-24.8 40.7-36.3zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M238.9 36.9C227.7 44 222 57.3 224.6 70.3l9.7 48.6C264.1 105.1 298.2 96 336 96c5.7 0 11.3 .2 16.8 .6L275.2 38.4c-10.6-8-25-8.5-36.3-1.5zm-4.6 356.2l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c-5.5 .4-11.1 .6-16.8 .6c-37.8 0-71.9-9.1-101.7-22.9z"]]
};
var faCircleQ = {
  prefix: 'fad',
  iconName: 'circle-q',
  icon: [512, 512, [], "e11e", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L377 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z", "M256 176c44.2 0 80 35.8 80 80c0 13.4-3.3 25.9-9.1 37l-30-30c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l30 30c-11.1 5.8-23.7 9.1-37 9.1c-44.2 0-80-35.8-80-80s35.8-80 80-80zM361.9 327.9c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c26.7 0 51.4-8.2 71.9-22.1L343 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-15.1-15.1z"]]
};
var faBuildingFlag = {
  prefix: 'fad',
  iconName: 'building-flag',
  icon: [640, 512, [], "e4d5", ["M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M480 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480z"]]
};
var faFaceGrinBeam = {
  prefix: 'fad',
  iconName: 'face-grin-beam',
  icon: [512, 512, [128516, "grin-beam"], "f582", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z", "M217.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]]
};
var faGrinBeam = faFaceGrinBeam;
var faObjectUngroup = {
  prefix: 'fad',
  iconName: 'object-ungroup',
  icon: [640, 512, [], "f248", ["M608 279.4c19.1-11.1 32-31.7 32-55.4c0-35.3-28.7-64-64-64c-23.7 0-44.4 12.9-55.4 32H416v40.6c9.7 5.6 17.8 13.7 23.4 23.4h81.1c5.6 9.7 13.7 17.8 23.4 23.4V392.6c-9.7 5.6-17.8 13.7-23.4 23.4H311.4c-5.6-9.7-13.7-17.8-23.4-23.4V320H224v72.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64c23.7 0 44.4-12.9 55.4-32H520.6c11.1 19.1 31.7 32 55.4 32c35.3 0 64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V279.4z", "M0 64c0 23.7 12.9 44.4 32 55.4V232.6C12.9 243.6 0 264.3 0 288c0 35.3 28.7 64 64 64c23.7 0 44.4-12.9 55.4-32H328.6c11.1 19.1 31.7 32 55.4 32c35.3 0 64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V119.4c19.1-11.1 32-31.7 32-55.4c0-35.3-28.7-64-64-64c-23.7 0-44.4 12.9-55.4 32H119.4C108.4 12.9 87.7 0 64 0C28.7 0 0 28.7 0 64zM328.6 96c5.6 9.7 13.7 17.8 23.4 23.4V232.6c-9.7 5.6-17.8 13.7-23.4 23.4H119.4c-5.6-9.7-13.7-17.8-23.4-23.4V119.4c9.7-5.6 17.8-13.7 23.4-23.4H328.6z"]]
};
var faFaceDisguise = {
  prefix: 'fad',
  iconName: 'face-disguise',
  icon: [512, 512, [], "e370", ["M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256c0-16.4 1.5-32.5 4.5-48H72c0 50.1 38.4 91.2 87.3 95.6c-9.6 7.9-15.3 19.7-15.3 32.4c0 15.9 9 30.4 23.1 37.5L147.5 398c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l23.9-29.9 7.3 3.6-10.5 26.3c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l10-24.9c2.4 .7 4.8 1.3 7.2 1.8V432c0 8.8 7.2 16 16 16s16-7.2 16-16V406.8c2.4-.5 4.8-1.1 7.2-1.8l10 24.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-10.5-26.3 7.3-3.6L339.5 418c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-19.6-24.5C359 366.4 368 351.9 368 336c0-12.7-5.7-24.5-15.3-32.4c49-4.4 87.3-45.5 87.3-95.6h67.5c3 15.5 4.5 31.6 4.5 48zM256 0C369.4 0 465.7 73.8 499.3 176H434.5c-5.3-14.9-14.1-28-25.4-38.5l5.2-10.3c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-3.5 7c-4.6-2-9.3-3.6-14.2-4.9V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v16.3c-4.4 .4-8.7 1-13 2l-4.7-9.5c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l3.6 7.3c-16.4 10.2-29.5 25.3-37.3 43.1c-7.8-17.9-20.9-32.9-37.3-43.1l3.6-7.3c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-4.7 9.5c-4.2-.9-8.6-1.6-13-2V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v19c-4.9 1.3-9.6 2.9-14.2 4.9l-3.5-7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l5.2 10.3C91.5 148 82.7 161.1 77.5 176H12.7C46.3 73.8 142.6 0 256 0z", "M160 80c8.8 0 16 7.2 16 16v16.3c4.4 .4 8.7 1 13 2l4.7-9.5c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-3.6 7.3c16.4 10.2 29.5 25.3 37.3 43.1c7.8-17.9 20.9-32.9 37.3-43.1l-3.6-7.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.7 9.5c4.2-.9 8.6-1.6 13-2V96c0-8.8 7.2-16 16-16s16 7.2 16 16v19c4.9 1.3 9.6 2.9 14.2 4.9l3.5-7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-5.2 10.3c11.3 10.5 20.1 23.7 25.4 38.5H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H440c0 50.1-38.4 91.2-87.3 95.6c9.6 7.9 15.3 19.7 15.3 32.4c0 15.9-9 30.4-23.1 37.5L364.5 398c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5l-23.9-29.9-7.3 3.6 10.5 26.3c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9l-10-24.9c-2.4 .7-4.8 1.3-7.2 1.8V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V406.8c-2.4-.5-4.8-1.1-7.2-1.8l-10 24.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l10.5-26.3-7.3-3.6L172.5 418c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l19.6-24.5C153 366.4 144 351.9 144 336c0-12.7 5.7-24.5 15.3-32.4C110.4 299.2 72 258.1 72 208H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H77.5c5.3-14.9 14.1-28 25.4-38.5l-5.2-10.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l3.5 7c4.6-2 9.3-3.6 14.2-4.9V96c0-8.8 7.2-16 16-16zM317.9 266.5c7.9 3.5 16.8 5.5 26.1 5.5c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 2.5 .1 4.9 .4 7.3c5.4 3.6 10.1 8.4 13.5 14.1l21.4 35.7c1.1 .6 1.9 1 2.6 1.3zM232 208c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c9.3 0 18.1-2 26.1-5.5c.6-.3 1.5-.7 2.6-1.3L218 229.5c3.5-5.8 8.1-10.6 13.5-14.1c.3-2.4 .4-4.9 .4-7.3zm24 32c-4.3 0-8.3 2.3-10.5 6l-39.8 66.3-2.4 4-4.2 2.1-17.7 8.8c-3.4 1.7-5.5 5.1-5.5 8.8s2.1 7.2 5.5 8.8l53.1 26.5c13.5 6.8 29.4 6.8 42.9 0l53.1-26.5c3.4-1.7 5.5-5.1 5.5-8.8s-2.1-7.2-5.5-8.8l-17.7-8.8-4.2-2.1-2.4-4L266.5 246c-2.2-3.7-6.2-6-10.5-6zM144 216a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faCircleArrowDownRight = {
  prefix: 'fad',
  iconName: 'circle-arrow-down-right',
  icon: [512, 512, [], "e0fa", ["M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM192 368c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L151 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24V344c0 13.3-10.7 24-24 24H192z", "M344 368H192c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L151 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24V344c0 13.3-10.7 24-24 24z"]]
};
var faAlien8bit = {
  prefix: 'fad',
  iconName: 'alien-8bit',
  icon: [576, 512, [128126, "alien-monster"], "f8f6", ["M96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h48c8.8 0 16 7.2 16 16v48H352V80c0-8.8 7.2-16 16-16h48V48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H416v32 32h48c8.8 0 16 7.2 16 16v48h32V144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16H512v80c0 8.8-7.2 16-16 16H448v80c0 8.8-7.2 16-16 16H384 336c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16h48V384H192v32h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H192 144c-8.8 0-16-7.2-16-16V384H80c-8.8 0-16-7.2-16-16V288H16c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16v80H96V176c0-8.8 7.2-16 16-16h48V128 96H112c-8.8 0-16-7.2-16-16V48zm64 192v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm192 0v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16z", "M176 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176zm192 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H368z"]]
};
var faAlienMonster = faAlien8bit;
var faHandPointRibbon = {
  prefix: 'fad',
  iconName: 'hand-point-ribbon',
  icon: [448, 512, [], "e1a6", ["M64 32C64 14.3 78.3 0 96 0s32 14.3 32 32L64 32zm0 208V160h64v80H64zm192-48c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H194.3c-42.4 0-83.1-16.9-113.1-46.9L69.5 453.5C45.5 429.5 32 396.9 32 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z", "M176 112V48c0-8.8-7.2-16-16-16H11.8C5.3 32 0 37.3 0 43.8c0 3.9 1.9 7.5 5.1 9.7L43.6 80 5.1 106.5c-3.2 2.2-5.1 5.8-5.1 9.7C0 122.7 5.3 128 11.8 128H160c8.8 0 16-7.2 16-16z"]]
};
var faPoop = {
  prefix: 'fad',
  iconName: 'poop',
  icon: [512, 512, [], "f619", ["M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 5.5 .7 10.9 2 16H414c1.3-5.1 2-10.5 2-16c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM394.3 240H117.7s0 0 0 0H104c-39.8 0-72 32.2-72 72c0 8.4 1.4 16.5 4.1 24H475.9c2.7-7.5 4.1-15.6 4.1-24c0-39.8-32.2-72-72-72H394.3s0 0 0 0zm58.9 128H58.7c.4 .3 .8 .7 1.3 1c-34.1 5.7-60 35.3-60 71c0 14.8 4.5 28.6 12.1 40H499.9c7.7-11.4 12.1-25.2 12.1-40c0-35.7-25.9-65.3-60-71c.4-.3 .8-.7 1.3-1zM440.2 512H71.8c.1 0 .1 0 .2 0H440c.1 0 .1 0 .2 0z", "M117.7 240c-9.4-8.3-16.4-19.4-19.7-32H414c-3.2 12.6-10.2 23.7-19.7 32H117.7zM58.7 368c-10.2-8.3-18.2-19.3-22.6-32H475.9c-4.5 12.7-12.4 23.7-22.6 32H58.7zM71.8 512c-24.9-.1-46.8-12.8-59.7-32H499.9c-12.9 19.2-34.8 31.9-59.7 32H71.8z"]]
};
var faObjectExclude = {
  prefix: 'fad',
  iconName: 'object-exclude',
  icon: [512, 512, [], "e49c", ["M224 160c-35.3 0-64 28.7-64 64V352H288c35.3 0 64-28.7 64-64V160H224zm80 48v96H208V208h96z", "M64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h96v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H352V64c0-35.3-28.7-64-64-64H64zM352 160V288c0 35.3-28.7 64-64 64H160V224c0-35.3 28.7-64 64-64H352z"]]
};
var faTelescope = {
  prefix: 'fad',
  iconName: 'telescope',
  icon: [576, 512, [128301], "e03e", ["M361 76.6c.7 2.4 1.7 4.8 3 7.1L460 250c.2 .4 .5 .8 .7 1.2l-77.5 41.6C377.8 253.9 344.4 224 304 224c-44.2 0-80 35.8-80 80c0 20.1 7.4 38.5 19.7 52.5l-5.8 14.2-88.4 47.4c-15.2 8.2-34.2 2.8-42.8-12.2l-.8-1.4L61.7 430.1c-11.5 6.6-26.2 2.7-32.8-8.8L3.1 376.4c-6.6-11.5-2.7-26.2 8.8-32.8l44.1-25.5-4-6.9c-8.5-14.8-4-33.7 10.4-42.9L361 76.6z", "M375.7 40c-15.3 8.8-20.6 28.4-11.7 43.7L460 250c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-96-166.3C466 4.4 446.4-.8 431.1 8L375.7 40zM364.3 356.5C376.6 342.5 384 324.1 384 304c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 20.1 7.4 38.5 19.7 52.5L193.8 478.9c-5 12.3 .9 26.3 13.2 31.3s26.3-.9 31.3-13.2l47-115.3c6 1.5 12.3 2.2 18.8 2.2s12.8-.8 18.8-2.2l47 115.3c5 12.3 19 18.2 31.3 13.2s18.2-19 13.2-31.3L364.3 356.5zM272 304a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faLocationPin = {
  prefix: 'fad',
  iconName: 'location-pin',
  icon: [384, 512, ["map-marker"], "f041", ["M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z", ""]]
};
var faMapMarker = faLocationPin;
var faSquareList = {
  prefix: 'fad',
  iconName: 'square-list',
  icon: [448, 512, [], "e489", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zM168 352c0 13.3 10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-13.3 0-24 10.7-24 24zm24-120c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H192z", "M168 160c0-13.3 10.7-24 24-24H352c13.3 0 24 10.7 24 24s-10.7 24-24 24H192c-13.3 0-24-10.7-24-24zm0 192c0-13.3 10.7-24 24-24H352c13.3 0 24 10.7 24 24s-10.7 24-24 24H192c-13.3 0-24-10.7-24-24zm24-120H352c13.3 0 24 10.7 24 24s-10.7 24-24 24H192c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faKaaba = {
  prefix: 'fad',
  iconName: 'kaaba',
  icon: [576, 512, [128331], "f66b", ["M60 120L288 48.8 516 120 288 191.2 60 120zM0 229.2l52.8 16.5c8.4 2.6 13.1 11.6 10.5 20s-11.6 13.1-20 10.5L0 262.8V229.2zm576 33.5l-43.2 13.5c-8.4 2.6-17.4-2.1-20-10.5s2.1-17.4 10.5-20L576 229.2v33.5zM96.7 276.2c2.6-8.4 11.6-13.1 20-10.5l64 20c8.4 2.6 13.1 11.6 10.5 20s-11.6 13.1-20 10.5l-64-20c-8.4-2.6-13.1-11.6-10.5-20zm382.5 0c2.6 8.4-2.1 17.4-10.5 20l-64 20c-8.4 2.6-17.4-2.1-20-10.5s2.1-17.4 10.5-20l64-20c8.4-2.6 17.4 2.1 20 10.5zm-254.5 40c2.6-8.4 11.6-13.1 20-10.5l38.5 12c3.1 1 6.4 1 9.5 0l38.5-12c8.4-2.6 17.4 2.1 20 10.5s-2.1 17.4-10.5 20l-38.5 12c-9.3 2.9-19.3 2.9-28.6 0l-38.5-12c-8.4-2.6-13.1-11.6-10.5-20z", "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v16 0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2V128 112C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2V182.8l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"]]
};
var faToiletPaper = {
  prefix: 'fad',
  iconName: 'toilet-paper',
  icon: [640, 512, [129531], "f71e", ["M20.2 495.8C25.8 505.8 36.5 512 48 512H317.9c22.3 0 45.4-12.1 55.4-36.1C388.7 439 416 350.8 416 192C416 86 459 0 512 0H160C107 0 64 86 64 192c0 85.3-.4 193.7-43.5 271.6c-5.9 9.9-6.1 22.1-.4 32.2zM128 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z", "M512 384H399.6c9.1-47 16.4-110.1 16.4-192C416 86 459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM128 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]]
};
var faHelmetSafety = {
  prefix: 'fad',
  iconName: 'helmet-safety',
  icon: [576, 512, ["hard-hat", "hat-hard"], "f807", ["M559.4 384H16.6C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6z", "M224 64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v2.3 99.6c0 5.6 4.5 10.1 10.1 10.1c3.6 0 7-1.9 8.8-5.1l48-83.9C492.3 123.1 543.1 198.4 544 285.6l0 98.4H32V288c0-88.2 51-164.5 125.1-201l48 83.9c1.8 3.2 5.2 5.1 8.8 5.1c5.6 0 10.1-4.5 10.1-10.1V66.3 64z"]]
};
var faHardHat = faHelmetSafety;
var faHatHard = faHelmetSafety;
var faCommentCode = {
  prefix: 'fad',
  iconName: 'comment-code',
  icon: [512, 512, [], "e147", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM217 193l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM329 159l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z", "M217 159c9.4 9.4 9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0zm78.1 0c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]]
};
var faSimCards = {
  prefix: 'fad',
  iconName: 'sim-cards',
  icon: [448, 512, [], "e251", ["M96 64c0-35.3 28.7-64 64-64H306.7c17 0 33.3 6.7 45.3 18.7L429.3 96c12 12 18.7 28.3 18.7 45.3V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64zm96 80c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H192z", "M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm144 24c-17.7 0-32 14.3-32 32v16h48V144H192zM160 272h64 96 64V224H320 224 160v48zm224-96c0-17.7-14.3-32-32-32H336v48h48V176zM240 144v48h64V144H240zm96 160v48h16c17.7 0 32-14.3 32-32V304H336zm-32 0H240v48h64V304zm-96 0H160v16c0 17.7 14.3 32 32 32h16V304z"]]
};
var faStarship = {
  prefix: 'fad',
  iconName: 'starship',
  icon: [640, 512, [], "e039", ["M448 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 256a192 192 0 1 0 0-384 192 192 0 1 0 0 384zM0 128c0 17.7 14.3 32 32 32H208c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128zM32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z", "M129.1 216.8L64.1 160H137l50.4 44.1L269 186.4c-8.4 21.6-13 45.1-13 69.6s4.6 48 13 69.6l-81.6-17.7L137 352H64.1l64.9-56.8-1.8-.4C109 290.8 96 274.7 96 256s13-34.8 31.3-38.8l1.8-.4zM384 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faEject = {
  prefix: 'fad',
  iconName: 'eject',
  icon: [448, 512, [9167], "f052", ["M0 432c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z", "M259.4 47.6C250.3 37.6 237.5 32 224 32s-26.3 5.6-35.4 15.6l-176 192c-12.9 14-16.2 34.3-8.6 51.8S29 320 48 320H400c19 0 36.3-11.2 43.9-28.7s4.3-37.7-8.6-51.8l-176-192z"]]
};
var faCircleRight = {
  prefix: 'fad',
  iconName: 'circle-right',
  icon: [512, 512, [61838, "arrow-alt-circle-right"], "f35a", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L294.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C266 384 256 374 256 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z", "M394.5 242.2L294.6 135.1c-4.2-4.5-10.1-7.1-16.3-7.1C266 128 256 138 256 150.3l0 57.7-96 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l96 0 0 57.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8z"]]
};
var faArrowAltCircleRight = faCircleRight;
var faPlaneCircleCheck = {
  prefix: 'fad',
  iconName: 'plane-circle-check',
  icon: [640, 512, [], "e555", ["M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l77.1 44.1C350.6 254 320 307.4 320 368c0 54.2 24.5 102.7 63.1 135c-2 5.3-7.1 9-13.1 9c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faSeal = {
  prefix: 'fad',
  iconName: 'seal',
  icon: [512, 512, [], "e241", ["M289.9 18.4c-18.7-18.7-49.1-18.7-67.9 0L176.5 64H112c-26.5 0-48 21.5-48 48v64.5L18.4 222.1c-18.7 18.7-18.7 49.1 0 67.9L64 335.5V400c0 26.5 21.5 48 48 48h64.5l45.6 45.6c18.7 18.7 49.1 18.7 67.9 0L335.5 448H400c26.5 0 48-21.5 48-48V335.5l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176.5V112c0-26.5-21.5-48-48-48H335.5L289.9 18.4z", ""]]
};
var faUserCowboy = {
  prefix: 'fad',
  iconName: 'user-cowboy',
  icon: [448, 512, [], "f8ea", ["M96 221.7c0 .8 0 1.5 0 2.3c0 70.7 57.3 128 128 128s128-57.3 128-128c0-.8 0-1.5 0-2.3C317.2 241.9 274 256 224 256s-93.2-14.1-128-34.3z", "M208.5 9.9C201.9 5.4 194 0 176 0c-35.2 0-58.3 58.1-72 110.4C131.6 120 171 128 224 128s92.4-8 120-17.6C330.3 58.1 307.2 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1s-10.8-2.8-15.5-6.1zM28.8 102.4c-4.7-6.3-13.3-8.2-20.2-4.6s-10.2 11.8-7.8 19.2c9.3 27.9 35 62.4 72.5 89.9c38 27.7 89.2 49.1 150.6 49.1s112.7-21.4 150.6-49.1c37.6-27.4 63.2-62 72.5-89.9c2.5-7.4-.8-15.6-7.8-19.2s-15.5-1.7-20.2 4.6c-5.6 7.5-22.6 22-55 34.7C332.2 149.6 286.2 160 224 160s-108.2-10.4-140.2-22.9c-32.4-12.7-49.4-27.2-55-34.7zM100.7 384c-48.4 0-89.3 36.1-95.3 84.1l-1 7.9C2.1 495.1 17 512 36.2 512H411.8c19.2 0 34.1-16.9 31.8-36l-1-7.9c-6-48-46.8-84.1-95.3-84.1H100.7z"]]
};
var faHexagonVerticalNft = {
  prefix: 'fad',
  iconName: 'hexagon-vertical-nft',
  icon: [448, 512, [], "e505", ["M260.9 495.5c-22.3 12.9-49.7 12.9-72 0L36 407.2C13.7 394.4 0 370.6 0 344.9V168.3c0-25.7 13.7-49.5 36-62.4L188.9 17.7c22.3-12.9 49.7-12.9 72 0l152.9 88.3c22.3 12.9 36 36.6 36 62.4V344.9c0 25.7-13.7 49.5-36 62.4L260.9 495.5zM95.8 170.6c-2.8-7.1-10.3-11.2-17.9-9.8s-13 8-13 15.7v160c0 8.8 7.2 16 16 16s16-7.2 16-16V259.7l33.1 82.9c2.8 7.1 10.3 11.2 17.9 9.8s13-8 13-15.7v-160c0-8.8-7.2-16-16-16s-16 7.2-16 16v76.9L95.8 170.6zm97.1 5.9v80 80c0 8.8 7.2 16 16 16s16-7.2 16-16v-64h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-144h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64z", "M77.9 160.9c7.5-1.5 15 2.6 17.9 9.8l33.1 82.9V176.6c0-8.8 7.2-16 16-16s16 7.2 16 16v160c0 7.7-5.4 14.3-13 15.7s-15-2.6-17.9-9.8L96.9 259.7v76.9c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.7 5.4-14.3 13-15.7zm115 15.7c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80-80zm112-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v144c0 8.8-7.2 16-16 16s-16-7.2-16-16v-144h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faFaceRollingEyes = {
  prefix: 'fad',
  iconName: 'face-rolling-eyes',
  icon: [512, 512, [128580, "meh-rolling-eyes"], "f5a5", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 224a64 64 0 1 1 128 0A64 64 0 1 1 96 224zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M195.6 180.4c0 19.6-15.9 35.6-35.6 35.6s-35.6-15.9-35.6-35.6c0-3 .4-6 1.1-8.8c9.6-7.3 21.5-11.6 34.5-11.6s24.9 4.3 34.5 11.6c.7 2.8 1.1 5.8 1.1 8.8zM384 184c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-6.9 2.2-13.2 5.8-18.4c8-3.6 16.8-5.6 26.2-5.6s18.2 2 26.2 5.6c3.7 5.2 5.8 11.6 5.8 18.4z"]]
};
var faMehRollingEyes = faFaceRollingEyes;
var faBreadLoaf = {
  prefix: 'fad',
  iconName: 'bread-loaf',
  icon: [640, 512, [127838], "f7eb", ["M240 32C176 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C480 64 304 32 240 32z", "M368 480H528c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C640 64 464 32 400 32H240c64 0 240 32 240 160c0 35.3-28.7 64-64 64V432c0 26.5-21.5 48-48 48z"]]
};
var faRingsWedding = {
  prefix: 'fad',
  iconName: 'rings-wedding',
  icon: [512, 512, [], "f81b", ["M128 0h96c6.1 0 11.6 3.4 14.3 8.8l16 32c2.3 4.5 2.3 9.8 0 14.3l-24.6 49.2c-16.9-5.4-35-8.3-53.7-8.3s-36.8 2.9-53.7 8.3L97.7 55.2c-2.3-4.5-2.3-9.8 0-14.3l16-32C116.4 3.4 121.9 0 128 0zm32 336c0-64.4 34.5-120.7 86.1-151.3c16.8 13.5 29.7 31.8 36.5 52.9c-34.9 19-58.6 56-58.6 98.5c0 61.9 50.1 112 112 112s112-50.1 112-112c0-46.1-27.8-85.7-67.6-102.9c-5-26.2-14.8-50.7-28.6-72.4C441.6 168.7 512 244.1 512 336c0 97.2-78.8 176-176 176s-176-78.8-176-176z", "M176 160c-61.9 0-112 50.1-112 112c0 58.7 45.1 106.8 102.5 111.6c6.5 23.3 17.7 44.6 32.5 62.9c-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272S78.8 96 176 96s176 78.8 176 176c0 52.3-22.8 99.2-59 131.5c-18.7-11.9-32.1-31.5-35.9-54.2C276.2 329.2 288 302 288 272c0-61.9-50.1-112-112-112z"]]
};
var faObjectGroup = {
  prefix: 'fad',
  iconName: 'object-group',
  icon: [576, 512, [], "f247", ["M0 64c0 23.7 12.9 44.4 32 55.4V392.6C12.9 403.6 0 424.3 0 448c0 35.3 28.7 64 64 64c23.7 0 44.4-12.9 55.4-32H456.6c11.1 19.1 31.7 32 55.4 32c35.3 0 64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V119.4c19.1-11.1 32-31.7 32-55.4c0-35.3-28.7-64-64-64c-23.7 0-44.4 12.9-55.4 32H119.4C108.4 12.9 87.7 0 64 0C28.7 0 0 28.7 0 64zM480 392.6c-9.7 5.6-17.8 13.7-23.4 23.4H119.4c-5.6-9.7-13.7-17.8-23.4-23.4V119.4c9.7-5.6 17.8-13.7 23.4-23.4H456.6c5.6 9.7 13.7 17.8 23.4 23.4V392.6z", "M160 128c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H160zm96 224c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H352v32c0 35.3-28.7 64-64 64H256v32z"]]
};
var faFrenchFries = {
  prefix: 'fad',
  iconName: 'french-fries',
  icon: [384, 512, [127839], "f803", ["M183.2 1.7c-5-2.5-10.8-2.2-15.6 .7S160 10.5 160 16V206.7l0 0v63.2c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2V31.8c-.1-6-3.5-11.4-8.8-14.1l-32-16zM128 14.7l-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6V14.7zM40.3 85.6L19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2H48c3.6 0 7 .4 10.2 1L40.3 85.6zM383.8 98.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8L346.2 85l-19 107.8c2.8-.5 5.7-.8 8.8-.8h26.6c1.6 0 3.2 .1 4.7 .2l16.5-93.4zm-64-48c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2l-.2 1.4V261c4.8-2.1 8.7-4.4 11.8-6.6c12-8.4 16.7-18 18.7-24.3c.7-2.3 1.7-4.7 2.8-7L319.8 50.8z", "M58.1 487.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224H48c8.8 0 16.3 7.2 18.9 15.7C74.3 263 100.3 304 192 304s117.7-41 125.1-64.3c2.7-8.4 10.1-15.7 18.9-15.7h26.6c11.8 0 21.4 9.6 21.4 21.4c0 1.7-.2 3.4-.6 5.1l-57.5 237c-3.5 14.4-16.3 24.5-31.1 24.5H89.2c-14.8 0-27.6-10.1-31.1-24.5z"]]
};
var faChartLine = {
  prefix: 'fad',
  iconName: 'chart-line',
  icon: [512, 512, ["line-chart"], "f201", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0L240 221.3l-89.4 89.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l112-112c12.5-12.5 32.8-12.5 45.3 0L320 210.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]]
};
var faLineChart = faChartLine;
var faCalendarArrowDown = {
  prefix: 'fad',
  iconName: 'calendar-arrow-down',
  icon: [448, 512, ["calendar-download"], "e0d0", ["M448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM248 264V366.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V264c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM248 264c0-13.3-10.7-24-24-24s-24 10.7-24 24V366.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V264z"]]
};
var faCalendarDownload = faCalendarArrowDown;
var faSendBack = {
  prefix: 'fad',
  iconName: 'send-back',
  icon: [640, 512, [], "f87e", ["M64 64V192H192V64H64zM0 64C0 28.7 28.7 0 64 0H192c35.3 0 64 28.7 64 64V192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM448 320V448H576V320H448zm-64 0c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H448c-35.3 0-64-28.7-64-64V320z", "M160 352V256h32c35.3 0 64-28.7 64-64V96H416c35.3 0 64 28.7 64 64v96H448c-35.3 0-64 28.7-64 64v96H224c-35.3 0-64-28.7-64-64z"]]
};
var faMaskVentilator = {
  prefix: 'fad',
  iconName: 'mask-ventilator',
  icon: [640, 512, [], "e524", ["M454.5 128c9.8 15.2 18.6 31.5 26.1 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c-5.8 20.6-15.5 39.6-28.2 56.5l71.6-17.9C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H454.5zM162.2 403.3c-12.6-16.9-22.1-36-27.9-56.5l-31.8-7.9C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H159.1c7.5-16.5 16.2-32.8 26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8zM320 288c-17.7 0-32 14.3-32 32V512h64V320c0-17.7-14.3-32-32-32z", "M128 300.8C128 201.9 214 32 320 32c105 0 192 169.9 192 268.8c0 78.6-53.9 144.5-128 169V393.2c19.6-16.3 32-40.1 32-66.8c0-49.5-43.5-134.4-96-134.4c-53 0-96 84.9-96 134.4c0 26.6 12.3 50.5 32 66.9v76.6c-75-24.5-128-91-128-169.1z"]]
};
var faSignatureLock = {
  prefix: 'fad',
  iconName: 'signature-lock',
  icon: [640, 512, [], "e3ca", ["M128 96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-53 43-96 96-96s96 43 96 96v7.8c0 20.8-1.2 41.6-3.6 62.3l122.4-36.7c11.4-3.4 23.8-.2 32.2 8.4s11.2 21.1 7.4 32.4l-18 53.9h52.7c-.7 5.2-1.1 10.6-1.1 16v24.6c-9.7 5.6-17.8 13.7-23.4 23.4H320c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l12.5-37.5-94.4 28.3c-11.9 52.8-31.6 103.5-58.4 150.5l-13.9 24.3C122.5 466.1 98.5 480 72.5 480C32.5 480 0 447.5 0 407.5V335.6c0-42.4 27.8-79.8 68.4-92l84.4-25.3c4.8-27.2 7.1-54.9 7.1-82.5V128c0-17.7-14.3-32-32-32zM384 368v48H187.5c8.2-15.7 15.6-31.7 22.3-48H384zM135.8 290.3L86.8 305C73.3 309 64 321.5 64 335.6v71.9c0 4.7 3.8 8.5 8.5 8.5c3 0 5.9-1.6 7.4-4.3l13.9-24.3c17.6-30.8 31.7-63.4 42.1-97.2z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faArrowRight = {
  prefix: 'fad',
  iconName: 'arrow-right',
  icon: [448, 512, [8594], "f061", ["M338.7 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0 32-32-32-32z", "M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 256 233.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"]]
};
var faSignsPost = {
  prefix: 'fad',
  iconName: 'signs-post',
  icon: [512, 512, ["map-signs"], "f277", ["M224 32V64h64V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm64 160H224v32h64V192zm0 288V352H224V480c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M64 64H441.4c4.2 0 8.3 1.7 11.3 4.7l48 48c6.2 6.2 6.2 16.4 0 22.6l-48 48c-3 3-7.1 4.7-11.3 4.7H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM448 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H70.6c-4.2 0-8.3-1.7-11.3-4.7l-48-48c-6.2-6.2-6.2-16.4 0-22.6l48-48c3-3 7.1-4.7 11.3-4.7H448z"]]
};
var faMapSigns = faSignsPost;
var faOctagonPlus = {
  prefix: 'fad',
  iconName: 'octagon-plus',
  icon: [512, 512, ["plus-octagon"], "f301", ["M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z", "M232 280v64c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faPlusOctagon = faOctagonPlus;
var faCashRegister = {
  prefix: 'fad',
  iconName: 'cash-register',
  icon: [512, 512, [], "f788", ["M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32h64V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 168a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z", "M0 448V378.4c0-4.8 .4-9.6 1.1-14.4L23.8 214.4C28.5 183.1 55.4 160 87 160H425c31.6 0 58.5 23.1 63.3 54.4l22.7 149.6c.7 4.8 1.1 9.6 1.1 14.4V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64-16c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm48-216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]]
};
var faPersonCircleQuestion = {
  prefix: 'fad',
  iconName: 'person-circle-question',
  icon: [576, 512, [], "e542", ["M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM409.6 280c-23 0-41.6 18.6-41.6 41.6l0 6.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6z"]]
};
var faMelonSlice = {
  prefix: 'fad',
  iconName: 'melon-slice',
  icon: [512, 512, [], "e311", ["M385.2 16.6c-.7 .5-1.3 1-1.9 1.6L321.6 79.8c-3.9 3.9-5.4 9.4-4.5 14.8c1.9 10.8 2.9 22 2.9 33.3c0 106-86 192-192 192c-11.4 0-22.5-1-33.3-2.9c-5.4-.9-11 .6-14.8 4.5L18.2 383.3c-.6 .6-1.1 1.2-1.6 1.9c8.3-2.7 17.8-.8 24.4 5.9c96.9 96.9 253.6 97.1 350.4 .3s96.6-253.5-.3-350.4c-6.6-6.6-8.6-16.1-5.9-24.4z", "M7 391c9.4-9.4 24.6-9.4 33.9 0c96.9 96.9 253.6 97.1 350.4 .3s96.6-253.5-.3-350.4c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c115.6 115.6 116 302.6 .3 418.3S122.6 540.5 7 425c-9.4-9.4-9.4-24.6 0-33.9z"]]
};
var faSpaceStationMoon = {
  prefix: 'fad',
  iconName: 'space-station-moon',
  icon: [512, 512, [], "e033", ["M512 256c0 7.8-.3 15.5-1 23.1C438.8 304.7 351.2 320 256 320s-182.8-15.3-255-40.9c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0S512 114.6 512 256zM256 512C134.9 512 33.4 427.9 6.8 314.8C79.4 338.4 164.7 352 256 352s176.6-13.6 249.2-37.2C478.6 427.9 377.1 512 256 512zM192 240a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M224 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM6.8 314.8C4.1 303.2 2.1 291.3 1 279.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9c-1.1 12.2-3 24.1-5.8 35.8C432.6 338.4 347.3 352 256 352s-176.6-13.6-249.2-37.2z"]]
};
var faMessageSmile = {
  prefix: 'fad',
  iconName: 'message-smile',
  icon: [512, 512, ["comment-alt-smile"], "f4aa", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z", "M224 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184.4 240c-8.8-9.9-24-10.7-33.9-1.9s-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32z"]]
};
var faCommentAltSmile = faMessageSmile;
var faCupStraw = {
  prefix: 'fad',
  iconName: 'cup-straw',
  icon: [384, 512, [129380], "e363", ["M59.7 468.8L32 192H352L324.3 468.8c-2.5 24.5-23.1 43.2-47.8 43.2H107.4c-24.7 0-45.3-18.7-47.8-43.2z", "M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H249.3z"]]
};
var faLeftFromLine = {
  prefix: 'fad',
  iconName: 'left-from-line',
  icon: [448, 512, ["arrow-alt-from-right"], "f348", ["M416 448c-17.7 0-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32z", "M11.3 283.3L134.1 406.1c6.4 6.4 15 9.9 24 9.9c18.7 0 33.9-15.2 33.9-33.9l0-62.1 128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0 0-62.1c0-18.7-15.2-33.9-33.9-33.9c-9 0-17.6 3.6-24 9.9L11.3 228.7C4.1 235.9 0 245.8 0 256s4.1 20.1 11.3 27.3z"]]
};
var faArrowAltFromRight = faLeftFromLine;
var faH = {
  prefix: 'fad',
  iconName: 'h',
  icon: [384, 512, [104], "48", ["M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z", ""]]
};
var faBasketShoppingSimple = {
  prefix: 'fad',
  iconName: 'basket-shopping-simple',
  icon: [576, 512, ["shopping-basket-alt"], "e0af", ["M393 192l33.1 73.8c5.4 12.1 19.6 17.5 31.7 12.1s17.5-19.6 12.1-31.7L445.6 192H544c17.7 0 32 14.3 32 32s-14.3 32-32 32L492.1 463.5C485 492 459.4 512 430 512H146c-29.4 0-55-20-62.1-48.5L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32h98.4l-24.3 54.2c-5.4 12.1 0 26.3 12.1 31.7s26.3 0 31.7-12.1L183 192H393z", "M253.9 33.8c5.4-12.1 0-26.3-12.1-31.7s-26.3 0-31.7 12.1l-104 232c-5.4 12.1 0 26.3 12.1 31.7s26.3 0 31.7-12.1l104-232zm68.2 0l104 232c5.4 12.1 19.6 17.5 31.7 12.1s17.5-19.6 12.1-31.7l-104-232C360.5 2.1 346.3-3.3 334.2 2.1s-17.5 19.6-12.1 31.7z"]]
};
var faShoppingBasketAlt = faBasketShoppingSimple;
var faHandsHoldingHeart = {
  prefix: 'fad',
  iconName: 'hands-holding-heart',
  icon: [640, 512, ["hands-heart"], "f4c3", ["M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z", "M256.6 0C214.3 0 180 34.3 180 76.6c0 20.3 8.1 39.8 22.4 54.1L305.9 234.1c7.8 7.8 20.5 7.8 28.3 0L437.6 130.7C451.9 116.4 460 96.9 460 76.6C460 34.3 425.7 0 383.4 0c-20.3 0-39.8 8.1-54.1 22.4L320 31.7l-9.3-9.3C296.4 8.1 276.9 0 256.6 0z"]]
};
var faHandsHeart = faHandsHoldingHeart;
var faClockNine = {
  prefix: 'fad',
  iconName: 'clock-nine',
  icon: [512, 512, [], "e34c", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V256c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V120c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M256 96c13.3 0 24 10.7 24 24V256c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V120c0-13.3 10.7-24 24-24z"]]
};
var faTarp = {
  prefix: 'fad',
  iconName: 'tarp',
  icon: [576, 512, [], "e57b", ["M512 64c35.3 0 64 28.7 64 64V288l-128 0c-17.7 0-32 14.3-32 32l0 128L64 448c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64H512zM96 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M576 288L416 448l0-128c0-17.7 14.3-32 32-32l128 0z"]]
};
var faFaceSleepy = {
  prefix: 'fad',
  iconName: 'face-sleepy',
  icon: [512, 512, [], "e38e", ["M256 512c47.1 0 91.2-12.7 129.1-34.9c-.7-4.3-1.1-8.7-1.1-13.1c0-16.3-.2-37.2-6.5-56.6c-5.9-18.2-16.4-33.3-37.4-41.7c-14.2-5.7-22.4-20.7-19.5-35.8s16.1-25.9 31.4-25.9c31.6 0 77.6 14.7 115.4 39.1c7.6 4.9 15.3 10.5 22.7 16.7c14.1-31.7 22-66.9 22-103.9C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM194.3 405.9c-12.3 4.2-25.1-5.3-18.3-16.4C191.1 364.8 221.3 348 256 348s64.9 16.8 80.1 41.5c6.8 11.1-6 20.7-18.3 16.4c-18.9-6.5-39.8-10.1-61.8-10.1s-42.9 3.6-61.8 10.1zM387.2 246.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2z", "M195.2 246.4c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zm192 0c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zM512 464c0-80-112-128-160-128c64 25.6 64 96 64 128c0 26.5 21.5 48 48 48s48-21.5 48-48z"]]
};
var faHandHorns = {
  prefix: 'fad',
  iconName: 'hand-horns',
  icon: [384, 512, [], "e1a9", ["M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM320 96c0-17.7 14.3-32 32-32s32 14.3 32 32v96 96 64c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c35.3 0 64-28.7 64-64V192 96z", "M160 128c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zm96 32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32z"]]
};
var faScrewdriverWrench = {
  prefix: 'fad',
  iconName: 'screwdriver-wrench',
  icon: [512, 512, ["tools"], "f7d9", ["M168.4 247.6L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7zM429 274.5c49-23 83-72.8 83-130.5c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144c0 .3 0 .5 0 .8l85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M47 7c8.5-8.5 22-9.4 31.6-2.1l104 80c5.9 4.5 9.4 11.6 9.4 19v54.1l109 109c29-14.7 65.4-10 89.6 14.3l112 112c12.5 12.5 12.5 32.8 0 45.3l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-112-112c-24.2-24.2-29-60.6-14.3-89.6l-109-109H104c-7.5 0-14.5-3.5-19-9.4L5 78.6C-2.4 69.1-1.5 55.6 7 47L47 7z"]]
};
var faTools = faScrewdriverWrench;
var faArrowsToEye = {
  prefix: 'fad',
  iconName: 'arrows-to-eye',
  icon: [640, 512, [], "e4bf", ["M49 15C39.6 5.7 24.4 5.7 15 15S5.7 39.6 15 49l63 63H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h96c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24s-24 10.7-24 24V78.1L49 15zM591 15l-63 63V40c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H561.9l63-63c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM15 497c9.4 9.4 24.6 9.4 33.9 0l63-63V472c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H78.1L15 463c-9.4 9.4-9.4 24.6 0 33.9zm576 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-63-63H600c13.3 0 24-10.7 24-24s-10.7-24-24-24H504c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V433.9l63 63z", "M133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faCircleThreeQuarters = {
  prefix: 'fad',
  iconName: 'circle-three-quarters',
  icon: [512, 512, [], "e125", ["M512 256C512 114.6 397.4 0 256 0V256H512z", "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256H256V0z"]]
};
var faTrophyStar = {
  prefix: 'fad',
  iconName: 'trophy-star',
  icon: [576, 512, ["trophy-alt"], "f2eb", ["M446.1 64c-1 16.9-2.5 32.9-4.3 48h85.3c-7.5 97.9-60.9 150.6-114.6 179.9c-11 6-22 11-32.6 15.2c-24.5 37.8-50.6 57.4-68.6 67.3c7.5-1 17.8-2.7 30-5.4c25.5-5.7 59.8-16.1 94.3-35C505.6 295.7 576 222.5 576 88c0-13.3-10.7-24-24-24H446.1zM264.7 374.5c-18.1-9.9-44.1-29.5-68.6-67.3c-10.6-4.2-21.6-9.2-32.6-15.2C109.8 262.6 56.4 209.9 48.9 112h85.3c-1.8-15.1-3.3-31.1-4.3-48H24C10.7 64 0 74.7 0 88C0 222.5 70.4 295.7 140.5 334.1c34.5 18.9 68.8 29.3 94.3 35c12.2 2.7 22.5 4.4 30 5.4zM295.2 86.5c-2.9-5.9-11.4-5.9-14.3 0l-19.2 38.9c-1.2 2.4-3.4 4-6 4.4L212.7 136c-6.6 1-9.2 9-4.4 13.6l31 30.2c1.9 1.8 2.7 4.5 2.3 7.1l-7.3 42.7c-1.1 6.5 5.7 11.5 11.6 8.4L284.3 218c2.3-1.2 5.1-1.2 7.4 0l38.4 20.2c5.9 3.1 12.7-1.9 11.6-8.4L334.4 187c-.4-2.6 .4-5.2 2.3-7.1l31-30.2c4.7-4.6 2.1-12.7-4.4-13.6l-42.9-6.2c-2.6-.4-4.9-2-6-4.4L295.2 86.5z", "M235.2 353.4c12.2 10.8 20.8 25.7 20.8 42V400c0 26.5-21.5 48-48 48H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H368c-26.5 0-48-21.5-48-48v-4.5c0-16.3 8.6-31.2 20.8-42C383.8 315.3 438.7 231 447 48c1.2-26.5-20.4-48-47-48H176c-26.5 0-48.1 21.6-47 48c8.2 183 63.2 267.2 106.2 305.4zm60-266.9l19.2 38.9c1.2 2.4 3.4 4 6 4.4l42.9 6.2c6.6 1 9.2 9 4.4 13.6l-31 30.2c-1.9 1.8-2.7 4.5-2.3 7.1l7.3 42.7c1.1 6.5-5.7 11.5-11.6 8.4L291.7 218c-2.3-1.2-5.1-1.2-7.4 0l-38.4 20.2c-5.9 3.1-12.7-1.9-11.6-8.4l7.3-42.7c.4-2.6-.4-5.2-2.3-7.1l-31-30.2c-4.7-4.6-2.1-12.7 4.4-13.6l42.9-6.2c2.6-.4 4.9-2 6-4.4l19.2-38.9c2.9-5.9 11.4-5.9 14.3 0z"]]
};
var faTrophyAlt = faTrophyStar;
var faPlugCircleBolt = {
  prefix: 'fad',
  iconName: 'plug-circle-bolt',
  icon: [576, 512, [], "e55b", ["M128 32v96H64V32C64 14.3 78.3 0 96 0s32 14.3 32 32zm192 0v96H256V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V412.8C87 398 32 333.4 32 256V224c-17.7 0-32-14.3-32-32z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm194.5-66.2c2.8-5 1.7-11.1-2.6-14.9s-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H452.4l30.1-54.2z"]]
};
var faFaceThermometer = {
  prefix: 'fad',
  iconName: 'face-thermometer',
  icon: [576, 512, [], "e39a", ["M544 256c0 141.4-114.6 256-256 256S32 397.4 32 256S146.6 0 288 0C400 0 495.2 72 530 172.2c-14-4.1-29.8-.7-41 10.2l-150.8 146c-14.9-5.2-31.6-8.4-50.2-8.4c-55.1 0-93.8 27.9-116.1 53.5c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6C214 373.8 244.6 352 288 352s74 21.8 91.9 42.5c5.8 6.7 15.9 7.4 22.6 1.6c5.2-4.5 6.8-11.6 4.5-17.7l136.8-132c.1 3.2 .2 6.4 .2 9.6zM240.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M548 182.8c-16.2-16.2-42.5-16.5-59-.5l-150.8 146c29.2 10.2 51.2 28.2 65.9 45.2c1.3 1.5 2.2 3.1 2.9 4.8l25.7-24.7-25.1-25.1c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.4 25.4 15.3-14.8-25.7-25.7c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26 26 15.3-14.8-26.3-26.3c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.6 26.6 15.3-14.8-26.9-26.9c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l27.2 27.2c16.7-16.4 16.9-43.3 .3-59.8zM240.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
};
var faGridRound4 = {
  prefix: 'fad',
  iconName: 'grid-round-4',
  icon: [448, 512, [], "e5dd", ["M119.5 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM44.8 151.5a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 238.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zM164.3 270.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm74.7-74.7a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm44.8 194.1a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zM358.4 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm44.8 194.1a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6z", "M44.8 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 238.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm74.7-74.7a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm44.8 194.1a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zM238.9 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm44.8 194.1a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm74.7-74.7a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm44.8 194.1a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6z"]]
};
var faShirtRunning = {
  prefix: 'fad',
  iconName: 'shirt-running',
  icon: [384, 512, [], "e3c8", ["M80 0c17.7 0 32 14.3 32 32V80c0 44.2 35.8 80 80 80s80-35.8 80-80V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 33.3 2.6 61.5 6.5 85.2L0 393.8V282.5c0-17 6.7-33.5 14.7-48.4C28.8 207.6 48 155 48 64V32C48 14.3 62.3 0 80 0zM3.8 469.8L360.4 215c3 7.5 6 13.8 8.9 19c8 15 14.7 31.5 14.7 48.4V448c0 35.3-28.7 64-64 64H64c-27.7 0-51.3-17.6-60.2-42.2z", "M342.5 149.2L0 393.8V448c0 7.6 1.3 15 3.8 21.8L360.4 215c-6.6-16.2-13.2-37.9-17.9-65.9z"]]
};
var faBookCircleArrowUp = {
  prefix: 'fad',
  iconName: 'book-circle-arrow-up',
  icon: [640, 512, [], "e0bd", ["M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V198.6C374.1 219.5 320 287.4 320 368c0 5.4 .2 10.7 .7 16H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H339.2c13.1 25.6 32.2 47.6 55.6 64H384 96c-53 0-96-43-96-96V96z", "M640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM428.7 348.7l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6l0 89.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"]]
};
var faFaceNauseated = {
  prefix: 'fad',
  iconName: 'face-nauseated',
  icon: [512, 512, [], "e381", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-12.3-84.7l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM168 282.7c19.5 11.3 33.8 30.5 38.4 53.3h99.2c4.6-22.8 18.9-42 38.4-53.3c7.7-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6c7.6 4.4 10.3 14.2 5.8 21.9s-14.2 10.3-21.9 5.8c-19.5-11.3-33.8-30.5-38.4-53.3H206.4c-4.6 22.8-18.9 42-38.4 53.3c-7.6 4.4-17.4 1.8-21.9-5.8s-1.8-17.4 5.8-21.9c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8z", "M195.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zM175.6 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-18.9-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.1 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]]
};
var faHeart = {
  prefix: 'fad',
  iconName: 'heart',
  icon: [512, 512, [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578], "f004", ["M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z", ""]]
};
var faFileChartPie = {
  prefix: 'fad',
  iconName: 'file-chart-pie',
  icon: [384, 512, [], "f65a", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM296 320c8.8 0 16.1-7.2 14.9-16c-7.1-53.5-49.5-95.9-103-103c-8.8-1.2-16 6.1-16 14.9v88c0 8.8 7.2 16 16 16h88zM160 230c0-10.1-9.3-17.7-18.8-14.1C96.1 233.1 64 276.8 64 328c0 66.3 53.7 120 120 120c51.2 0 94.9-32.1 112.1-77.2c3.6-9.5-4-18.8-14.1-18.8H176c-8.8 0-16-7.2-16-16V230z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zM141.2 215.9c9.5-3.6 18.8 4 18.8 14.1V336c0 8.8 7.2 16 16 16H282c10.1 0 17.7 9.3 14.1 18.8C278.9 415.9 235.2 448 184 448c-66.3 0-120-53.7-120-120c0-51.2 32.1-94.9 77.2-112.1z"]]
};
var faMarsAndVenus = {
  prefix: 'fad',
  iconName: 'mars-and-venus',
  icon: [512, 512, [9893], "f224", ["M192 224a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z", "M337.8 14.8C341.5 5.8 350.3 0 360 0H472c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59.1 146.7-136.1 158.2c0 .6 .1 1.2 .1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-24 0-24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456H208c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2 .1-1.8C155.1 370.7 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48l0 0h0v0zM256 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24h24zm96-264a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]]
};
var faHouseUser = {
  prefix: 'fad',
  iconName: 'house-user',
  icon: [576, 512, ["home-user"], "e1b0", ["M64 270.5L64.1 448c0 35.3 28.7 64 64 64H448.5c35.4 0 64.1-28.7 64-64.1l-.4-177.3L288 74.5 64 270.5zM288 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224zM224 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm32 96h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z"]]
};
var faHomeUser = faHouseUser;
var faCircleArrowDownLeft = {
  prefix: 'fad',
  iconName: 'circle-arrow-down-left',
  icon: [512, 512, [], "e0f9", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm64-144c13.3 0 24-10.7 24-24s-10.7-24-24-24H225.9L361 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V344c0 13.3 10.7 24 24 24H320z", "M168 368H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H225.9L361 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V344c0 13.3 10.7 24 24 24z"]]
};
var faDumpsterFire = {
  prefix: 'fad',
  iconName: 'dumpster-fire',
  icon: [640, 512, [], "f794", ["M48 32h92.5L114.9 160H32c-9.9 0-19.2-4.5-25.2-12.3S-1.4 129.8 1 120.2l16-64C20.5 42 33.3 32 48 32zM272 160H147.5L173.1 32H272V160zm32 0V32h98.9l14.4 72.1c-1.7 1.1-3.3 2.4-4.8 3.8c-18.4 16.4-35.4 34-50.5 52.1H304zm209.9-23.7c-1.7 1.6-3.4 3.2-5 4.8C498 129.6 486.7 118.6 475 108c-7.6-6.9-17-10.8-26.6-11.8L435.5 32H528c14.7 0 27.5 10 31 24.2l16 64c1.2 4.8 1.3 9.8 .2 14.6c-17.8-14.7-44.1-14.2-61.3 1.5zM530 401c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z", "M453.5 131.8c-5.6-5-14.2-5-19.8 0c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 64.2-32.4 90.6C320 405.8 390.3 480 480 480c88.7 0 160-74.1 160-161.9c0-20.2-9.6-48.9-24.2-76.9c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96zM32 192l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4c3.8-6.2 7.9-12.5 12.3-18.7H32z"]]
};
var faHexagonMinus = {
  prefix: 'fad',
  iconName: 'hexagon-minus',
  icon: [512, 512, ["minus-hexagon"], "f307", ["M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z", "M160 256c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24z"]]
};
var faMinusHexagon = faHexagonMinus;
var faLeftToLine = {
  prefix: 'fad',
  iconName: 'left-to-line',
  icon: [448, 512, ["arrow-alt-to-left"], "f34b", ["M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64z", "M107.3 283.3L230.1 406.1c6.4 6.4 15 9.9 24 9.9c18.7 0 33.9-15.2 33.9-33.9l0-62.1 128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0 0-62.1c0-18.7-15.2-33.9-33.9-33.9c-9 0-17.6 3.6-24 9.9L107.3 228.7C100.1 235.9 96 245.8 96 256s4.1 20.1 11.3 27.3z"]]
};
var faArrowAltToLeft = faLeftToLine;
var faHouseCrack = {
  prefix: 'fad',
  iconName: 'house-crack',
  icon: [576, 512, [], "e3b1", ["M64.1 448L64 270.5l224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.6-64-64z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z"]]
};
var faPawSimple = {
  prefix: 'fad',
  iconName: 'paw-simple',
  icon: [448, 512, ["paw-alt"], "f701", ["M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm160 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm144 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 240a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M97.7 286c6.2-2.3 11.8-6.3 15-12.2l40-71.9c14.4-25.9 41.7-42 71.3-42s56.9 16.1 71.3 42l40 71.9c3.2 5.8 8.8 9.9 15 12.2c38.3 14 65.7 50.8 65.7 94c0 55.2-44.8 100-100 100c-21.2 0-40.8-6.6-56.9-17.8c-17.4-12-52.8-12-70.1 0C172.8 473.4 153.2 480 132 480C76.8 480 32 435.2 32 380c0-43.2 27.4-80 65.7-94z"]]
};
var faPawAlt = faPawSimple;
var faArrowLeftLongToLine = {
  prefix: 'fad',
  iconName: 'arrow-left-long-to-line',
  icon: [640, 512, [], "e3d4", ["M32 64C14.3 64 0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32z", "M137.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L237.3 224 608 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-370.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"]]
};
var faBracketsRound = {
  prefix: 'fad',
  iconName: 'brackets-round',
  icon: [512, 512, ["parentheses"], "e0c5", ["M357.4 46.2c-9.8 14.7-5.8 34.6 8.9 44.4C391.9 107.7 448 167 448 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C440.1 449 512 371.8 512 256s-71.9-193.1-110.2-218.6c-14.7-9.8-34.6-5.8-44.4 8.9z", "M154.6 46.2c9.8 14.7 5.8 34.6-8.9 44.4C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4c14.7 9.8 18.7 29.7 8.9 44.4s-29.7 18.7-44.4 8.9C71.9 449 0 371.8 0 256S71.9 62.9 110.2 37.4c14.7-9.8 34.6-5.8 44.4 8.9z"]]
};
var faParentheses = faBracketsRound;
var faMartiniGlassCitrus = {
  prefix: 'fad',
  iconName: 'martini-glass-citrus',
  icon: [576, 512, ["cocktail"], "f561", ["M24 128c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l177 177V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h88 88c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V345.9L409 169c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H24z", "M432 240c53 0 96-43 96-96s-43-96-96-96c-47.6 0-87.1 34.6-94.7 80H288.9c8-72 69-128 143.1-128c79.5 0 144 64.5 144 144s-64.5 144-144 144c-39.3 0-74.9-15.7-100.8-41.2l33.9-33.9C382.4 229.7 406 240 432 240z"]]
};
var faCocktail = faMartiniGlassCitrus;
var faUserShakespeare = {
  prefix: 'fad',
  iconName: 'user-shakespeare',
  icon: [448, 512, [], "e2c2", ["M224 0c-53 0-96 43-96 96v64c0 49 36.6 89.4 84 95.3V224c0-6.6 5.4-12 12-12s12 5.4 12 12v31.3c47.4-5.9 84-46.3 84-95.3V96c0-53-43-96-96-96zM192 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5c4.7-4.7 12.3-4.7 17 0zM96 336v37.3c0 15.6 16.7 25.4 30.4 17.9c25.1-13.9 53-21.8 81.6-23V288H144c-26.5 0-48 21.5-48 48zm225.6 55.1c13.6 7.6 30.4-2.3 30.4-17.9V336c0-26.5-21.5-48-48-48H240v80.2c28.6 1.2 56.6 9 81.6 23z", "M128 96v64c0 33.4 17 62.8 42.9 80H105.1C82.4 240 64 221.6 64 198.9c0-9.6 3.4-18.9 9.5-26.3l19.3-23.2c7.2-8.6 11.1-19.5 11.1-30.7V112c0-19.4 11.5-36.1 28-43.7c-2.6 8.8-4 18-4 27.7zm192 0c0-9.6-1.4-18.9-4-27.7c16.5 7.6 28 24.3 28 43.7v6.6c0 11.2 3.9 22.1 11.1 30.7l19.3 23.2c6.2 7.4 9.5 16.7 9.5 26.3c0 22.7-18.4 41.1-41.1 41.1H277.1C303 222.8 320 193.4 320 160V96zM192 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-4 96v32c0 6.6-5.4 12-12 12s-12-5.4-12-12V224c0-6.6 5.4-12 12-12s12 5.4 12 12zm-20.5-56.5c4.7-4.7 12.3-4.7 17 0c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5zM96 336v37.3c0 15.6 16.7 25.4 30.4 17.9c27.3-15.2 58-23.1 89.3-23.1h16.7c31.2 0 62 8 89.3 23.1c13.6 7.6 30.4-2.3 30.4-17.9V336c0-.8 0-1.5-.1-2.3c56.6 25 96.1 81.7 96.1 147.5c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-65.9 39.5-122.5 96.1-147.5c0 .8-.1 1.5-.1 2.3zm144 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faArrowRightToArc = {
  prefix: 'fad',
  iconName: 'arrow-right-to-arc',
  icon: [512, 512, [], "e4b2", ["M256 64c106 0 192 86 192 192s-86 192-192 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c141.4 0 256-114.6 256-256S397.4 0 256 0c-17.7 0-32 14.3-32 32s14.3 32 32 32z", "M185.4 121.4c12.5-12.5 32.8-12.5 45.3 0l112 112c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H242.7l-57.4-57.4c-12.5-12.5-12.5-32.8 0-45.3z"]]
};
var faFaceSurprise = {
  prefix: 'fad',
  iconName: 'face-surprise',
  icon: [512, 512, [128558, "surprise"], "f5c2", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faSurprise = faFaceSurprise;
var faBottleWater = {
  prefix: 'fad',
  iconName: 'bottle-water',
  icon: [320, 512, [], "e4c5", ["M120 0h80c13.3 0 24 10.7 24 24V64H96V24c0-13.3 10.7-24 24-24zM32 151.7c0-15.6 9-29.8 23.2-36.5L96.3 96H223.7l41.1 19.3c14.1 6.6 23.2 20.8 23.2 36.5c0 14.4-7.5 27-18.9 34.1c11.5 8.8 18.9 22.6 18.9 38.2c0 16.7-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48c0-16.7 8.5-31.4 21.5-40C40.5 415.4 32 400.7 32 384s8.5-31.4 21.5-40C40.5 335.4 32 320.7 32 304s8.5-31.4 21.5-40C40.5 255.4 32 240.7 32 224c0-15.6 7.4-29.4 18.9-38.2C39.5 178.7 32 166.1 32 151.7zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z", "M120 0C106.7 0 96 10.7 96 24V96H224V24c0-13.3-10.7-24-24-24H120zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"]]
};
var faCirclePause = {
  prefix: 'fad',
  iconName: 'circle-pause',
  icon: [512, 512, [62092, "pause-circle"], "f28b", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z", "M192 160c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm128 0c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"]]
};
var faPauseCircle = faCirclePause;
var faGaugeCirclePlus = {
  prefix: 'fad',
  iconName: 'gauge-circle-plus',
  icon: [640, 512, [], "e498", ["M504 192.2c-2.6-.1-5.3-.2-8-.2c-97.2 0-176 78.8-176 176c0 45.9 17.6 87.7 46.4 119C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2zM256 416c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM368 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"]]
};
var faFolders = {
  prefix: 'fad',
  iconName: 'folders',
  icon: [576, 512, [], "f660", ["M24 96c13.3 0 24 10.7 24 24V344c0 48.6 39.4 88 88 88H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 480 0 419.1 0 344V120c0-13.3 10.7-24 24-24z", "M160 384H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7L322.7 50.7c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64z"]]
};
var faAngel = {
  prefix: 'fad',
  iconName: 'angel',
  icon: [576, 512, [], "f779", ["M384 64.2c0-.1 0-.1 0-.2s0-.1 0-.2s-.1-.3-.2-.6c-.3-.6-.9-1.8-2.3-3.5c-2.9-3.5-8.4-7.9-17.3-12.4C346.4 38.4 319.5 32 288 32s-58.4 6.4-76.2 15.4c-8.9 4.5-14.4 8.9-17.3 12.4c-1.4 1.7-2 2.8-2.3 3.5c-.1 .3-.2 .5-.2 .6s0 .1 0 .2s0 .1 0 .2s.1 .3 .2 .6c.3 .6 .9 1.8 2.3 3.5c1.4 1.7 3.4 3.6 6.2 5.6c-6.7 8.3-12.2 17.6-16.3 27.7C169 91 160 78 160 64c0-35.3 57.3-64 128-64s128 28.7 128 64c0 14-9 27-24.3 37.5c-4.1-10-9.6-19.3-16.3-27.7c2.7-2 4.8-4 6.2-5.6c1.4-1.7 2-2.8 2.3-3.5c.1-.3 .2-.5 .2-.6zM96 512H45.3C20.3 512 0 491.7 0 466.7c0-7 1.6-14 4.8-20.3l39.8-79.7c2.2-4.4 3.4-9.3 3.4-14.3v-.9c0-5-1.2-9.9-3.4-14.3L26.2 300.5C19.5 287 16 272 16 256.9c0-53.1 43.1-96.9 96.2-96.9c25.5 0 50 10.1 68 28.2l73.6 73.6c-25 8.8-46.2 26.9-58.4 51.4L96 512zM380.6 313.2c-12.2-24.5-33.4-42.7-58.4-51.4l73.6-73.6c18-18 42.5-28.2 68-28.2c53.1 0 96.2 43.8 96.2 96.9c0 15.1-3.5 30.1-10.2 43.6l-18.4 36.7c-2.2 4.4-3.4 9.3-3.4 14.3v.9c0 5 1.2 9.9 3.4 14.3l39.8 79.7c3.1 6.3 4.8 13.2 4.8 20.3c0 25-20.3 45.3-45.3 45.3H480L380.6 313.2z", "M288 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM96 512l99.4-198.8C212.9 278.2 248.8 256 288 256s75.1 22.2 92.6 57.2L480 512H96z"]]
};
var faValueAbsolute = {
  prefix: 'fad',
  iconName: 'value-absolute',
  icon: [512, 512, [], "f6a6", ["M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm448 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z", "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 301.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 210.7l-73.4-73.4z"]]
};
var faRabbit = {
  prefix: 'fad',
  iconName: 'rabbit',
  icon: [512, 512, [128007], "f708", ["M321.4 128c4.8 0 9.6 .3 14.3 .9c1.1-24-2.6-47.9-10.9-70.1c7.6-17.8 18.6-34.2 32.7-48.3l4.6-4.6c3.7-3.7 8.8-5.8 14-5.8c9.2 0 17.2 6.4 19.3 15.4l1 4.4c9.8 42.4 1.8 86.5-21 122.4c5.5 3.1 10.7 6.6 15.6 10.6L425.8 181c14 11.4 22.2 28.6 22.2 46.7c0 33.3-27 60.3-60.3 60.3H352v25.8l61.7 154.3c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-39.4-98.6L265.6 448H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H208 160c-35.3 0-64-28.7-64-64V432c0-95.1 69.2-174.1 160-189.3V193.4c0-10.9 2.7-21.2 7.4-30.2c-34.3-36.5-50.3-86.8-43.2-136.8l.7-4.9C222.7 9.2 233.2 0 245.7 0c6.6 0 12.9 2.6 17.6 7.3l3.1 3.1c31.8 31.5 47.9 74.8 45.4 118.4c3.1-.5 6.3-.7 9.6-.7zM368 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z", "M368 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 432v16c0 6.9 1.1 13.5 3.1 19.8C88.8 480.1 73.3 488 56 488c-30.9 0-56-25.1-56-56s25.1-56 56-56c17.4 0 33 8 43.3 20.5C97.1 408 96 419.9 96 432z"]]
};
var faToiletPaperSlash = {
  prefix: 'fad',
  iconName: 'toilet-paper-slash',
  icon: [640, 512, [], "e072", ["M521.1 383.1C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l80.7 63.3zM381.4 273.6c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6l285.8 224zM367.3 385.4L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faCircleEuro = {
  prefix: 'fad',
  iconName: 'circle-euro',
  icon: [512, 512, [], "e5ce", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 272h16c-.6-5-.9-10.1-.9-15.2c0-5.7 .4-11.3 1.1-16.8H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h24.7c19.2-46.9 65.4-80 119.2-80H313c13.3 0 24 10.7 24 24s-10.7 24-24 24H271.9c-26.3 0-49.6 12.6-64.4 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H192.9c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H206.4c14.7 20.3 38.5 33.5 65.5 33.5H313c13.3 0 24 10.7 24 24s-10.7 24-24 24H271.9c-54.4 0-101-33.8-119.8-81.5H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M144.2 240c-.7 5.5-1.1 11.1-1.1 16.8c0 5.2 .3 10.2 .9 15.2H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h24.1c18.8 47.7 65.4 81.5 119.8 81.5H313c13.3 0 24-10.7 24-24s-10.7-24-24-24H271.9c-27 0-50.8-13.2-65.5-33.5H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H192.6c-.9-4.9-1.4-10-1.4-15.2c0-5.7 .6-11.4 1.7-16.8H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H207.5c14.7-19.4 38.1-32 64.4-32H313c13.3 0 24-10.7 24-24s-10.7-24-24-24H271.9c-53.9 0-100 33.1-119.2 80H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h16.2z"]]
};
var faAppleWhole = {
  prefix: 'fad',
  iconName: 'apple-whole',
  icon: [448, 512, [127822, 127823, "apple-alt"], "f5d1", ["M240 112H224c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80z", "M112 128C35.7 128 0 211.7 0 288C0 416 80 512 160 512c16.5 0 38.1-6.6 51.5-11.3c8.1-2.8 16.9-2.8 25 0c13.4 4.7 35 11.3 51.5 11.3c80 0 160-96 160-224c0-76.3-35.7-160-112-160c-27.3 0-59.7 10.3-82.7 19.3c-18.8 7.3-39.9 7.3-58.7 0C171.7 138.3 139.3 128 112 128z"]]
};
var faAppleAlt = faAppleWhole;
var faKitchenSet = {
  prefix: 'fad',
  iconName: 'kitchen-set',
  icon: [576, 512, [], "e51a", ["M144 224a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM256 296c0 13.3 10.7 24 24 24H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H424v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H280c-13.3 0-24 10.7-24 24z", "M224 144A80 80 0 1 0 64 144a80 80 0 1 0 160 0zm60.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zm336-64V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V320H512z"]]
};
var faDiamondHalf = {
  prefix: 'fad',
  iconName: 'diamond-half',
  icon: [512, 512, [], "e5b7", ["M256 512V0c10.2 0 20.5 3.9 28.3 11.7l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-7.8 7.8-18 11.7-28.3 11.7z", "M256 0c-10.2 0-20.5 3.9-28.3 11.7l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c7.8 7.8 18 11.7 28.3 11.7V0z"]]
};
var faLockKeyhole = {
  prefix: 'fad',
  iconName: 'lock-keyhole',
  icon: [448, 512, ["lock-alt"], "f30d", ["M224 64c-44.2 0-80 35.8-80 80v48H80V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48H304V144c0-44.2-35.8-80-80-80z", "M64 192c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H64zM256 320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32z"]]
};
var faLockAlt = faLockKeyhole;
var faR = {
  prefix: 'fad',
  iconName: 'r',
  icon: [320, 512, [114], "52", ["M64 32C28.7 32 0 60.7 0 96V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H64zM176 256H64V96H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z", ""]]
};
var faTemperatureQuarter = {
  prefix: 'fad',
  iconName: 'temperature-quarter',
  icon: [320, 512, ["temperature-1", "thermometer-1", "thermometer-quarter"], "f2ca", ["M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M176 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272z"]]
};
var faTemperature1 = faTemperatureQuarter;
var faThermometer1 = faTemperatureQuarter;
var faThermometerQuarter = faTemperatureQuarter;
var faSquareInfo = {
  prefix: 'fad',
  iconName: 'square-info',
  icon: [448, 512, [8505, "info-square"], "f30f", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM184 336h24V272H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M224 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V272H184c-13.3 0-24-10.7-24-24z"]]
};
var faInfoSquare = faSquareInfo;
var faWifiSlash = {
  prefix: 'fad',
  iconName: 'wifi-slash',
  icon: [640, 512, [], "f6ac", ["M364.6 260.4c39.2 7.9 74.7 26.1 103.6 51.6c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192c-13.3 0-26.5 .9-39.3 2.7l83.9 65.8zM185.6 120.2C227.4 104.5 272.7 96 320 96c103.2 0 196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32c-68.7 0-133.7 15.5-191.9 43.1l57.5 45.1zM380.8 396l-55.6-43.8c-1.7-.1-3.4-.2-5.2-.2c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-7-1.1-13.7-3.2-20zM228 275.7L173 232.3c-15.5 9.2-30.1 19.8-43.5 31.7c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c16.7-14.8 35.6-27 56.2-36.3zM93.6 169.8L41.7 128.9C30.7 137.7 20 147 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9c12.4-11.9 25.6-23 39.5-33.1z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faToiletPaperXmark = {
  prefix: 'fad',
  iconName: 'toilet-paper-xmark',
  icon: [512, 512, [], "e5b3", ["M96 384C43 384 0 298 0 192S43 0 96 0H416c-53 0-96 86-96 192s43 192 96 192H128 96zM233 257c9.4-9.4 9.4-24.6 0-33.9l-31-31 31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 31 31c9.4 9.4 24.6 9.4 33.9 0z", "M416 384c-52.4 0-94.9-83.8-96-188.1c0-1.3 0-2.6 0-3.9C320 86 363 0 416 0s96 86 96 192V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V384H416zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z"]]
};
var faHandsHoldingDollar = {
  prefix: 'fad',
  iconName: 'hands-holding-dollar',
  icon: [640, 512, ["hands-usd"], "f4c5", ["M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z", "M320 0c13.3 0 24 10.7 24 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24z"]]
};
var faHandsUsd = faHandsHoldingDollar;
var faCube = {
  prefix: 'fad',
  iconName: 'cube',
  icon: [512, 512, [], "f1b2", ["M64 189.4v188l160 57.1v-188L64 189.4zm384 188v-188L288 246.6v188l160-57.1z", "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zM64 377.4l160 57.1v-188L64 189.4l0 188zm224 57.1l160-57.1v-188L288 246.6v188z"]]
};
var faArrowDownTriangleSquare = {
  prefix: 'fad',
  iconName: 'arrow-down-triangle-square',
  icon: [576, 512, ["sort-shapes-down"], "f888", ["M416 32c11 0 21.3 5.7 27.1 15l80 128c6.2 9.9 6.5 22.3 .9 32.5s-16.4 16.5-28 16.5H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6 .9-32.5l80-128c5.8-9.4 16.1-15 27.1-15zM368 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48z", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z"]]
};
var faSortShapesDown = faArrowDownTriangleSquare;
var faBitcoinSign = {
  prefix: 'fad',
  iconName: 'bitcoin-sign',
  icon: [320, 512, [], "e0b4", ["M48 32V64h64V32C112 14.3 97.7 0 80 0S48 14.3 48 32zm0 416v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H48zm96 0v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H144zM207.7 68.5c.2-1.5 .3-3 .3-4.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64h32c11 0 21.6 1.6 31.7 4.5z", "M64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zM0 265.7V224 101.6C0 80.8 16.8 64 37.6 64H176c61.9 0 112 50.1 112 112c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112H41.7C18.7 448 0 429.3 0 406.3V288 265.7zM176 288H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"]]
};
var faShutters = {
  prefix: 'fad',
  iconName: 'shutters',
  icon: [512, 512, [], "e449", ["M491.4 224H20.6C9.2 224 0 214.8 0 203.4c0-2.2 .4-4.4 1.1-6.5L24 128H488l22.9 68.8c.7 2.1 1.1 4.3 1.1 6.5c0 11.4-9.2 20.6-20.6 20.6zm0 128H20.6C9.2 352 0 342.8 0 331.4c0-2.2 .4-4.4 1.1-6.5L24 256H488l22.9 68.8c.7 2.1 1.1 4.3 1.1 6.5c0 11.4-9.2 20.6-20.6 20.6zM20.6 480C9.2 480 0 470.8 0 459.4c0-2.2 .4-4.4 1.1-6.5L24 384H488l22.9 68.8c.7 2.1 1.1 4.3 1.1 6.5c0 11.4-9.2 20.6-20.6 20.6H20.6z", "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64z"]]
};
var faShieldDog = {
  prefix: 'fad',
  iconName: 'shield-dog',
  icon: [512, 512, [], "e573", ["M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM200 160h8 24 52.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8L168 272h-8c-17.7 0-32-14.3-32-32V176c0-8.8 7.2-16 16-16h56z", "M168 272l-22.1 44.2c-1.2 2.5-1.9 5.2-1.9 8c0 7.1 4.3 13.6 10.8 16.4l98.7 42.3c1.7 .7 3.4 1.1 5.2 1.1c7.3 0 13.3-5.9 13.3-13.3V320h48c44.2 0 80-35.8 80-80V208c0-8.8-7.2-16-16-16H320l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7H232 208v72c0 22.1-17.9 40-40 40zm88-64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]]
};
var faSolarPanel = {
  prefix: 'fad',
  iconName: 'solar-panel',
  icon: [640, 512, [], "f5ba", ["M59.5 51.4C65.5 21.5 91.7 0 122.2 0H517.8c30.5 0 56.8 21.5 62.8 51.4l51.2 256c7.9 39.6-22.4 76.6-62.8 76.6H71C30.6 384 .4 347 8.3 307.4l51.2-256zM517.8 64H122.2L71 320 569 320 517.8 64l31.4-6.3L517.8 64z", "M379.1 64H260.9L250.5 168h139L379.1 64zM212.7 64H122.2L101.4 168H202.3L212.7 64zM197.5 216H91.8L71 320h116l10.4-104zm196.8 0H245.7L235.3 320l169.4 0L394.3 216zm58.6 104H569L548.2 216H442.5l10.4 104zM517.8 64H427.3l10.4 104H538.6L517.8 64zM416 448H352V384H288v64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32z"]]
};
var faLockOpen = {
  prefix: 'fad',
  iconName: 'lock-open',
  icon: [576, 512, [], "f3c1", ["M432 64c-44.2 0-80 35.8-80 80v48H288V144C288 64.5 352.5 0 432 0s144 64.5 144 144v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V144c0-44.2-35.8-80-80-80z", "M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z"]]
};
var faTableTree = {
  prefix: 'fad',
  iconName: 'table-tree',
  icon: [512, 512, [], "e293", ["M144 368c-26.5 0-48-21.5-48-48V224 160h32v64c0 8.8 7.2 16 16 16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-5.6 0-11-1-16-2.7V320c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144zm96-144H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm64 96h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 160V416H64V160H448z"]]
};
var faHouseChimneyHeart = {
  prefix: 'fad',
  iconName: 'house-chimney-heart',
  icon: [576, 512, [], "e1b2", ["M64.1 448L64 270.5l224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1H128.1c-35.3 0-64-28.6-64-64zM176 317.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9L416 101.5V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185.5l53.1 46.4c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224zM237.3 256c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3c0-33.8 27.4-61.3 61.3-61.3z"]]
};
var faTally3 = {
  prefix: 'fad',
  iconName: 'tally-3',
  icon: [640, 512, [], "e296", ["M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z", "M384 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"]]
};
var faElevator = {
  prefix: 'fad',
  iconName: 'elevator',
  icon: [512, 512, [], "e16d", ["M64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z", "M132.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H80c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zm224 86.6l-64-64c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9H432c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-64 64c-6.2 6.2-16.4 6.2-22.6 0zM160 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]]
};
var faMoneyBillTransfer = {
  prefix: 'fad',
  iconName: 'money-bill-transfer',
  icon: [640, 512, [], "e528", ["M337.9 64H96c-35.3 0-64 28.7-64 64V342.5l19.2-19.2c20.3-20.3 53.2-20.3 73.5 0C138 336.5 142.6 355 138.6 372L256 372c28.7 0 52 23.3 52 52c0 8.7-2.1 16.8-5.9 24H544c35.3 0 64-28.7 64-64V169.5l-19.2 19.2c-20.3 20.3-53.2 20.3-73.5 0C502 175.5 497.4 157 501.4 140L384 140c-28.7 0-52-23.3-52-52c0-8.7 2.1-16.8 5.9-24zM96 192V128h64c0 35.3-28.7 64-64 64zM480 384c0-35.3 28.7-64 64-64v64H480zM224 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z", "M558.1 64L384 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l174.1 0-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c4.5-4.5 7-10.6 7-17s-2.5-12.5-7-17L569 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l23 23zM81.9 400l23-23c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 407c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-23-23L256 448c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 400z"]]
};
var faMoneyBillTrendUp = {
  prefix: 'fad',
  iconName: 'money-bill-trend-up',
  icon: [512, 512, [], "e529", ["M48 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zM96 464H48V416c26.5 0 48 21.5 48 48zM48 352V304H96c0 26.5-21.5 48-48 48zM416 464c0-26.5 21.5-48 48-48v48H416zm48-112c-26.5 0-48-21.5-48-48h48v48zM256 320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M477.6 19.8c-1.5-3.7-3.8-7.3-6.9-10.3c0 0-.1-.1-.1-.1C464.8 3.6 456.8 0 448 0h0H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h18.7l-84.4 84.4L196.8 71.7c-12-10.3-29.7-10.3-41.7 0l-112 96c-13.4 11.5-15 31.7-3.5 45.1s31.7 15 45.1 3.5L176 138.1l91.2 78.1c12.7 10.9 31.6 10.2 43.5-1.7L416 109.3V128c0 17.7 14.3 32 32 32s32-14.3 32-32V32v0c0 0 0-.1 0-.1c0-4.3-.9-8.4-2.4-12.2z"]]
};
var faHouseFloodWaterCircleArrowRight = {
  prefix: 'fad',
  iconName: 'house-flood-water-circle-arrow-right',
  icon: [640, 512, [], "e50f", ["M250.2 284.3c42.4-32.1 69.8-83 69.8-140.3c0-28.6-6.8-55.7-19-79.6L381.2 6.1c11.2-8.2 26.4-8.2 37.6 0l176 128c11.2 8.2 15.9 22.6 11.6 35.8S589.9 192 576 192H559.4l.3 84.4c-2.3-1.5-4.4-3.2-6.5-4.9c-22.2-18.7-54.3-20.1-78.1-3.4c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-10 6.9-21.2 12.6-33 16.2zm51.3 25.6c11.1-7.9 25.9-7.9 37 0C361 325.4 388.5 336 416 336c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C481.5 389.7 449 400 416 400c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C168.7 325.2 197.1 336 224 336c27.5 0 55-10.6 77.5-26.1zM416 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C481.5 501.7 449 512 416 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C168.7 437.2 197.1 448 224 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0C361 437.4 388.5 448 416 448z", "M144 288A144 144 0 1 0 144 0a144 144 0 1 0 0 288zM163.3 76.7l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]]
};
var faSquarePollHorizontal = {
  prefix: 'fad',
  iconName: 'square-poll-horizontal',
  icon: [448, 512, ["poll-h"], "f682", ["M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z", "M224 128c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32h96zm96 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32z"]]
};
var faPollH = faSquarePollHorizontal;
var faCircle = {
  prefix: 'fad',
  iconName: 'circle',
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z", ""]]
};
var faCartCircleExclamation = {
  prefix: 'fad',
  iconName: 'cart-circle-exclamation',
  icon: [640, 512, [], "e3f2", ["M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5h121c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H339.2c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faSword = {
  prefix: 'fad',
  iconName: 'sword',
  icon: [512, 512, [128481], "f71c", ["M507.3 4.7c3.7 3.7 5.3 8.8 4.5 13.9L499.2 94.4c-2.7 16.4-10.6 31.6-22.3 43.4L246.6 368 144 265.4 374.2 35.2c11.8-11.8 27-19.6 43.4-22.3L493.4 .2c5.1-.8 10.3 .8 13.9 4.5z", "M107.3 228.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-5.4 5.4-6.2 13.8-2 20.2l53.1 79.6c2.1 3.2 1.7 7.4-1 10.1L79.2 394.2c-2.1 2.1-5.3 2.9-8.2 1.9L37.1 384.8c-5.7-1.9-12.1-.4-16.4 3.9l-16 16c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l16-16c4.3-4.3 5.8-10.6 3.9-16.4L115.9 441c-1-2.9-.2-6 1.9-8.2l39.6-39.6c2.7-2.7 6.9-3.1 10.1-1l79.6 53.1c6.3 4.2 14.8 3.4 20.2-2l16-16c6.2-6.2 6.2-16.4 0-22.6l-176-176z"]]
};
var faBackwardFast = {
  prefix: 'fad',
  iconName: 'backward-fast',
  icon: [512, 512, [9198, "fast-backward"], "f049", ["M32 448c-17.7 0-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V416c0 17.7-14.3 32-32 32z", "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L64 214.3v83.3L235.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V297.7L459.5 440.6z"]]
};
var faFastBackward = faBackwardFast;
var faRecycle = {
  prefix: 'fad',
  iconName: 'recycle',
  icon: [512, 512, [9842, 9850, 9851], "f1b8", ["M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7-55.5 32L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM429.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L320 448V384l96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31l55.5 32L68.8 335.3c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z", "M292 155.2c-8.4 4.9-13.1 14.3-11.8 23.9s8.2 17.5 17.6 20l87.4 23.4c12.8 3.4 26-4.2 29.4-17L438 118.2c2.5-9.4-.9-19.3-8.6-25.3s-18.2-6.6-26.6-1.7L292 155.2zM320 352c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V352zM173.5 266.5c7.7-5.9 11.1-15.9 8.6-25.3l-23.4-87.4c-3.4-12.8-16.6-20.4-29.4-17L41.8 160.2c-9.4 2.5-16.3 10.4-17.6 20s3.4 19.1 11.8 23.9l110.9 64c8.4 4.9 18.9 4.2 26.6-1.7z"]]
};
var faUserAstronaut = {
  prefix: 'fad',
  iconName: 'user-astronaut',
  icon: [448, 512, [], "f4fb", ["M112 144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144zm77.3 18.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM160 416H288c17.7 0 32 14.3 32 32v64H192V464c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V448c0-17.7 14.3-32 32-32zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z", "M224 0c65.7 0 122.1 39.5 146.7 96.1C387.1 97.5 400 111.2 400 128v64c0 16.8-12.9 30.5-29.3 31.9C346.1 280.5 289.7 320 224 320s-122.1-39.5-146.7-96.1C60.9 222.5 48 208.8 48 192V128c0-16.8 12.9-30.5 29.3-31.9C101.9 39.5 158.3 0 224 0zM336 160V144c0-26.5-21.5-48-48-48H160c-26.5 0-48 21.5-48 48v16c0 53 43 96 96 96h32c53 0 96-43 96-96zM112.7 316.5C144.1 338.8 182.5 352 224 352s79.9-13.2 111.3-35.5C401.3 342.6 448 407 448 482.3c0 16.4-13.3 29.7-29.7 29.7L320 512V448c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v64H29.7C13.3 512 0 498.7 0 482.3C0 407 46.7 342.6 112.7 316.5z"]]
};
var faInterrobang = {
  prefix: 'fad',
  iconName: 'interrobang',
  icon: [320, 512, [8253], "e5ba", ["M144 96c-35.3 0-64 28.7-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128v3.6c0 43.6-22.1 84.1-58.8 107.7L203 298.4c-6.9 4.4-11 12-11 20.2V229.4l18.6-12c18.3-11.8 29.4-32.1 29.4-53.8V160c0-35.3-28.7-64-64-64H144z", "M192 176c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V176zM160 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]]
};
var faPlaneSlash = {
  prefix: 'fad',
  iconName: 'plane-slash',
  icon: [640, 512, [], "e069", ["M41.5 128.7l321 252.9L297.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6H144l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4H46c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L64 256 32.5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-6.2 4-11.4 9.5-13.3zM514.3 320H440.6L238.1 161.3 197.8 20.4C194.9 10.2 202.6 0 213.2 0h56.2c11.5 0 22.1 6.2 27.8 16.1L397.7 192l116.6 0c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faCircleDashed = {
  prefix: 'fad',
  iconName: 'circle-dashed',
  icon: [512, 512, [], "e105", ["M138.3 104.3c26.6-20.6 58.7-34.5 93.7-38.8V1.1C179.3 6 131.3 26.9 92.7 58.8l45.5 45.5zM280 446.5v64.4c52.7-4.9 100.7-25.8 139.3-57.7l-45.5-45.5c-26.6 20.6-58.7 34.5-93.7 38.8zM58.8 419.3l45.5-45.5C83.7 347.2 69.9 315.1 65.5 280H1.1C6 332.7 26.9 380.7 58.8 419.3zm348.9-281c20.6 26.6 34.5 58.7 38.8 93.7h64.4c-4.9-52.7-25.8-100.7-57.7-139.3l-45.5 45.5z", "M1.1 232C6 179.3 26.9 131.3 58.8 92.7l45.5 45.5C83.7 164.8 69.9 196.9 65.5 232H1.1zM407.7 373.7c20.6-26.6 34.5-58.7 38.8-93.7h64.4c-4.9 52.7-25.8 100.7-57.7 139.3l-45.5-45.5zM92.7 453.2l45.5-45.5c26.6 20.6 58.7 34.5 93.7 38.8v64.4c-52.7-4.9-100.7-25.8-139.3-57.7zM419.3 58.8l-45.5 45.5C347.2 83.7 315.1 69.9 280 65.5V1.1C332.7 6 380.7 26.9 419.3 58.8z"]]
};
var faTrademark = {
  prefix: 'fad',
  iconName: 'trademark',
  icon: [640, 512, [8482], "f25c", ["M309.9 97.6c13.1-4.4 27.5 .1 35.7 11.2L464 266.7 582.4 108.8c8.3-11 22.7-15.5 35.7-11.2S640 114.2 640 128V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V224L489.6 339.2c-6 8.1-15.5 12.8-25.6 12.8s-19.6-4.7-25.6-12.8L352 224V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-13.8 8.8-26 21.9-30.4z", "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32H96V384c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faBasketball = {
  prefix: 'fad',
  iconName: 'basketball',
  icon: [512, 512, [127936, "basketball-ball"], "f434", ["M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z", "M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4c10.4-2.2 21-3.8 31.9-4.7C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64c8 7.1 15.6 14.6 22.6 22.6L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8c-.9 10.8-2.5 21.5-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c-7.1 8-14.6 15.6-22.6 22.6l-85.2-85.2C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4c-10.4 2.2-21 3.8-31.9 4.7C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124L256 278.6 86.6 448c-8-7.1-15.6-14.6-22.6-22.6L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240c-16.2 0-32-2-47.1-5.8c.9-10.8 2.5-21.5 4.7-31.9C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6c7.1-8 14.6-15.6 22.6-22.6z"]]
};
var faBasketballBall = faBasketball;
var faForkKnife = {
  prefix: 'fad',
  iconName: 'fork-knife',
  icon: [576, 512, ["utensils-alt"], "f2e6", ["M265.4 220.1L52.5 7.3C47.9 2.6 41.5 0 34.9 0c-11.2 0-21 7.5-23.5 18.4C6.7 38.6 0 71.5 0 96c0 83.3 48.2 130.5 128.9 209.4c6.5 6.4 13.3 13 20.3 19.9c1.9 1.8 3.8 3.5 5.9 5.1L265.4 220.1zm45.3 135.8L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L355.9 310.6l-45.3 45.3z", "M476.4 5.9c5.2 6.4 4.8 15.6-1.1 21.5L384 118.6c-5.2 5.2-5.2 13.6 0 18.8c4.9 4.9 12.8 5.2 18.1 .6l99.4-86.1c6.3-5.5 15.9-5.2 21.8 .8s6.3 15.4 .8 21.8L438 173.9c-4.6 5.3-4.3 13.2 .6 18.1c5.2 5.2 13.6 5.2 18.8 0l91.3-91.3c5.8-5.8 15.1-6.3 21.5-1.1s7.7 14.4 3.2 21.2l-71 106.5c-18.6 27.9-49.9 44.6-83.4 44.6c-19.3 0-37.9-5.5-53.9-15.7L118.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L319.7 211c-10.2-16-15.7-34.7-15.7-53.9c0-33.5 16.8-64.8 44.6-83.4l106.5-71c6.8-4.6 16-3.2 21.2 3.2z"]]
};
var faUtensilsAlt = faForkKnife;
var faSatelliteDish = {
  prefix: 'fad',
  iconName: 'satellite-dish',
  icon: [512, 512, [128225], "f7c0", ["M224 0c-17.7 0-32 14.3-32 32s14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192z", "M60.6 220.6c-14.5-14.5-38.8-11.8-46.3 7.3C5.1 251.5 0 277.1 0 304C0 418.9 93.1 512 208 512c26.9 0 52.5-5.1 76.1-14.4c19-7.5 21.8-31.8 7.3-46.3L187.3 347.3l28.4-28.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3l-28.4 28.4L60.6 220.6z"]]
};
var faBadgeCheck = {
  prefix: 'fad',
  iconName: 'badge-check',
  icon: [512, 512, [], "f336", ["M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faCircleUp = {
  prefix: 'fad',
  iconName: 'circle-up',
  icon: [512, 512, [61467, "arrow-alt-circle-up"], "f35b", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H304v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V256H150.3C138 256 128 246 128 233.7c0-6.2 2.6-12.1 7.1-16.3z", "M242.2 117.5L135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3c0 12.3 10 22.3 22.3 22.3H208v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h57.7c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L269.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5z"]]
};
var faArrowAltCircleUp = faCircleUp;
var faSlider = {
  prefix: 'fad',
  iconName: 'slider',
  icon: [512, 512, [], "e252", ["M32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32H224v64H32zm448 0H416V224h64c17.7 0 32 14.3 32 32s-14.3 32-32 32z", "M352 160V352H320l0-192h32zM320 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H320z"]]
};
var faMobileScreenButton = {
  prefix: 'fad',
  iconName: 'mobile-screen-button',
  icon: [384, 512, ["mobile-alt"], "f3cd", ["M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64H80V384H304V64z", "M80 64H304V384H80V64z"]]
};
var faMobileAlt = faMobileScreenButton;
var faClockOneThirty = {
  prefix: 'fad',
  iconName: 'clock-one-thirty',
  icon: [512, 512, [], "e34f", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V263.3l60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3V392c0 13.3 10.7 24 24 24s24-10.7 24-24z", "M256 416c13.3 0 24-10.7 24-24V263.3l60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3V392c0 13.3 10.7 24 24 24z"]]
};
var faInboxOut = {
  prefix: 'fad',
  iconName: 'inbox-out',
  icon: [512, 512, [128228, "inbox-arrow-up"], "f311", ["M124.2 320H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7z", "M256 320c17.7 0 32-14.3 32-32V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3V288c0 17.7 14.3 32 32 32z"]]
};
var faInboxArrowUp = faInboxOut;
var faCloudSlash = {
  prefix: 'fad',
  iconName: 'cloud-slash',
  icon: [640, 512, [], "e137", ["M97.2 172.6L487.4 480H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-6.6 .4-13.1 1.2-19.4zM640 352c0 36.6-15.4 69.6-40 93L138.6 83.3C167.8 51.8 209.6 32 256 32c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faVolumeHigh = {
  prefix: 'fad',
  iconName: 'volume-high',
  icon: [640, 512, [128266, "volume-up"], "f028", ["M499.9 36c8.4-10.3 23.5-11.8 33.8-3.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8zm-60.5 74.5c8.4-10.3 23.5-11.8 33.8-3.5c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8zM378.8 185c8.4-10.3 23.5-11.8 33.8-3.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8z", "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"]]
};
var faVolumeUp = faVolumeHigh;
var faUsersRays = {
  prefix: 'fad',
  iconName: 'users-rays',
  icon: [640, 512, [], "e593", ["M175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z", "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72z"]]
};
var faWallet = {
  prefix: 'fad',
  iconName: 'wallet',
  icon: [512, 512, [], "f555", ["M0 80C0 53.5 21.5 32 48 32H432c26.5 0 48 21.5 48 48V96v32 8.6c-9.4-5.4-20.3-8.6-32-8.6l-64 0v0H48C21.5 128 0 106.5 0 80z", "M48 128H96v0l352 0c.4 0 .9 0 1.3 0c11.2 .2 21.6 3.6 30.7 8.9v-.3c19.1 11.1 32 31.7 32 55.4V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V240 192 80c0 26.5 21.5 48 48 48zM416 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faOctagonCheck = {
  prefix: 'fad',
  iconName: 'octagon-check',
  icon: [512, 512, [], "e426", ["M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faFlatbreadStuffed = {
  prefix: 'fad',
  iconName: 'flatbread-stuffed',
  icon: [576, 512, [129369], "e40c", ["M233.4 10.1C243.4-.6 259.4-3.1 272.2 4l59.9 32.9c5.8 3.2 12.6 4.5 19.2 3.7l67.9-8.1c7.5-.9 14.9 .9 21 4.8c-5.8 2.7-11.1 6.5-15.8 11.1L304.5 168.3C284.3 153.1 259.2 144 232 144c-66.3 0-120 53.7-120 120c0 27.2 9.1 52.3 24.3 72.5L80.4 392.4c-4 4-7.3 8.5-9.9 13.3l-.9-41.2c-.1-6.7-2.4-13.1-6.4-18.5L22.4 291.3c-8.7-11.7-8.5-27.8 .7-39.2l42.8-53.3c4.2-5.2 6.6-11.6 7-18.2l3.8-68.3c.8-14.6 11.4-26.8 25.7-29.6l67.1-13.3c6.5-1.3 12.5-4.6 17.1-9.5l46.8-49.8zm48.1 181.2L159.3 313.5C149.6 299.4 144 282.4 144 264c0-48.6 39.4-88 88-88c18.4 0 35.4 5.6 49.5 15.3z", "M465.4 64c6.8 .4 13.2 3.7 17.4 9C519.1 118.8 544 175.3 544 240c0 150.2-121.8 272-272 272c-64.7 0-121.2-24.9-166.9-61.2c-5.4-4.3-8.6-10.6-9-17.4s2.2-13.5 7-18.3l86-86 86-86 86-86 43-43 43-43c4.8-4.8 11.5-7.4 18.3-7zM272 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faClipboardCheck = {
  prefix: 'fad',
  iconName: 'clipboard-check',
  icon: [384, 512, [], "f46c", ["M113.2 66.3c.1-.8 .3-1.6 .4-2.3H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H270.4c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M113.2 66.3C93.9 72.6 80 90.7 80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112c0-21.3-13.9-39.4-33.2-45.7C264.4 28.7 231.5 0 192 0s-72.4 28.7-78.8 66.3zM168 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM305 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L305 273z"]]
};
var faCartCirclePlus = {
  prefix: 'fad',
  iconName: 'cart-circle-plus',
  icon: [640, 512, [], "e3f3", ["M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5h121c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H339.2c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16z"]]
};
var faTruckClock = {
  prefix: 'fad',
  iconName: 'truck-clock',
  icon: [640, 512, ["shipping-timed"], "f48c", ["M224 112v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16zM96 432a80 80 0 1 1 160 0A80 80 0 1 1 96 432zm288 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576h-1.1c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H286.9c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM208 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]]
};
var faShippingTimed = faTruckClock;
var faPool8Ball = {
  prefix: 'fad',
  iconName: 'pool-8-ball',
  icon: [512, 512, [], "e3c5", ["M293.3 174.2C300 166 304 155.5 304 144c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.5 4 22 10.7 30.2C207.2 184.5 200 199.4 200 216c0 30.9 25.1 56 56 56s56-25.1 56-56c0-16.6-7.2-31.5-18.7-41.8zM240 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-448a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]]
};
var faFileAudio = {
  prefix: 'fad',
  iconName: 'file-audio',
  icon: [384, 512, [], "f1c7", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM258 226.3c-7.6-4.6-17.4-2.1-22 5.4s-2.1 17.4 5.4 22C269.4 270.5 288 301.1 288 336s-18.6 65.5-46.5 82.3c-7.6 4.6-10 14.4-5.4 22s14.4 10 22 5.4c37.1-22.4 62-63.1 62-109.7s-24.9-87.3-62-109.7zm-91.9 30.9c-6-2.5-12.9-1.1-17.4 3.5L113.4 296H80c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h33.4l35.3 35.3c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V272c0-6.5-3.9-12.3-9.9-14.8zm51 34.9c-6.6 5.9-7.1 16-1.3 22.6c5.1 5.7 8.1 13.1 8.1 21.3s-3.1 15.7-8.1 21.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C249.8 367.4 256 352.4 256 336s-6.2-31.4-16.3-42.7c-5.9-6.6-16-7.1-22.6-1.3z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM258 226.3c-7.6-4.6-17.4-2.1-22 5.4s-2.1 17.4 5.4 22C269.4 270.5 288 301.1 288 336s-18.6 65.5-46.5 82.3c-7.6 4.6-10 14.4-5.4 22s14.4 10 22 5.4c37.1-22.4 62-63.1 62-109.7s-24.9-87.3-62-109.7zm-91.9 30.9c-6-2.5-12.9-1.1-17.4 3.5L113.4 296H80c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h33.4l35.3 35.3c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V272c0-6.5-3.9-12.3-9.9-14.8zm51 34.9c-6.6 5.9-7.1 16-1.3 22.6c5.1 5.7 8.1 13.1 8.1 21.3s-3.1 15.7-8.1 21.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C249.8 367.4 256 352.4 256 336s-6.2-31.4-16.3-42.7c-5.9-6.6-16-7.1-22.6-1.3z"]]
};
var faTurnDownLeft = {
  prefix: 'fad',
  iconName: 'turn-down-left',
  icon: [512, 512, [], "e331", ["M192 240v96H400c61.9 0 112-50.1 112-112V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32V224c0 8.8-7.2 16-16 16H192z", "M151.5 441.4c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22l0-272c0-9.6-5.7-18.2-14.5-22s-19-2-26 4.6l-144 136C2.7 275.1 0 281.4 0 288s2.7 12.9 7.5 17.4l144 136z"]]
};
var faLockHashtag = {
  prefix: 'fad',
  iconName: 'lock-hashtag',
  icon: [448, 512, [], "e423", ["M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80zm96 48c-8.8 0-16 7.2-16 16v32H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v64H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V320h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H192V256c0-8.8-7.2-16-16-16zm16 144V320h64v64H192z", "M192 256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v64H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416l64 0v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V320h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H192V256zm64 128H192V320l64 0v64z"]]
};
var faChartRadar = {
  prefix: 'fad',
  iconName: 'chart-radar',
  icon: [512, 512, [], "e0e7", ["M107.1 63.8C118.6 44.1 139.6 32 162.4 32H349.6c22.8 0 43.8 12.1 55.3 31.8l93.3 160c11.6 19.9 11.6 44.6 0 64.5l-93.3 160c-11.5 19.7-32.5 31.8-55.3 31.8H162.4c-22.8 0-43.8-12.1-55.3-31.8l-93.3-160c-11.6-19.9-11.6-44.6 0-64.5l93.3-160zM349.6 96L162.4 96 69 256l93.3 160H349.6L443 256 349.6 96z", "M290.2 180.8c3.7-6.1 5.8-13.2 5.8-20.8c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 3.9 .6 7.7 1.6 11.2L160 248c-22.1 0-40 17.9-40 40s17.9 40 40 40c10.2 0 19.6-3.9 26.7-10.2l97.2 19.4c6.4 13.5 20.2 22.7 36.1 22.7c22.1 0 40-17.9 40-40c0-18.5-12.6-34.1-29.6-38.6L290.2 180.8zm-8.9 107L202 271.9l47.5-63.4 31.7 79.2z"]]
};
var faStaff = {
  prefix: 'fad',
  iconName: 'staff',
  icon: [512, 512, [], "f71b", ["M156.1 288H112c-8.8 0-16 7.2-16 16v44.1L156.1 288zm205-.7l38.6 21.8c7.7 4.3 17.5 1.6 21.8-6.1l22.2-39.4-82.6 23.6z", "M284.2 44.2C297.8 17.1 325.5 0 355.8 0H432c44.2 0 80 35.8 80 80V183.9c0 35.7-23.7 67.1-58 76.9L269.1 313.6c-2.6 .7-5 2.1-6.9 4.1L81.9 497.9c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9L200.2 243.9c9.6-9.6 21.5-16.6 34.6-20.4l169.6-48.5c6.9-2 11.6-8.2 11.6-15.4V112c0-8.8-7.2-16-16-16H371.8c-3.7 0-7.2 2.1-8.8 5.5v0c-11.9 23.7-40.7 33.3-64.4 21.5s-33.3-40.7-21.5-64.4l7.2-14.3z"]]
};
var faBurger = {
  prefix: 'fad',
  iconName: 'burger',
  icon: [512, 512, ["hamburger"], "f805", ["M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM48 384H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400c0-8.8 7.2-16 16-16z", "M16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48z"]]
};
var faHamburger = faBurger;
var faUtilityPole = {
  prefix: 'fad',
  iconName: 'utility-pole',
  icon: [512, 512, [], "e2c3", ["M128 64V56c0-13.3-10.7-24-24-24S80 42.7 80 56v8h48zM48 64V56c0-13.3-10.7-24-24-24S0 42.7 0 56v8H48zm35.2 64L224 221.9V183.4L140.8 128H83.2zM288 183.4v38.5L428.8 128H371.2L288 183.4zM384 64h48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8zm80 0h48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8z", "M256 0c17.7 0 32 14.3 32 32V64H512V96c0 17.7-14.3 32-32 32H288V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32C14.3 128 0 113.7 0 96V64H224V32c0-17.7 14.3-32 32-32z"]]
};
var faTransporter6 = {
  prefix: 'fad',
  iconName: 'transporter-6',
  icon: [512, 512, [], "e2a7", ["M64 32L56.7 6.6C55.6 2.7 52.1 0 48 0s-7.6 2.7-8.7 6.6L32 32 6.6 39.3C2.7 40.4 0 43.9 0 48s2.7 7.6 6.6 8.7L32 64l7.3 25.4C40.4 93.3 43.9 96 48 96s7.6-2.7 8.7-6.6L64 64l25.4-7.3C93.3 55.6 96 52.1 96 48s-2.7-7.6-6.6-8.7L64 32zM480 384l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 384l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 416l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 416l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 384zM224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z", "M96 480c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z"]]
};
var faWrench = {
  prefix: 'fad',
  iconName: 'wrench',
  icon: [512, 512, [128295], "f0ad", ["M201.5 214.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c-44.5-16.1-79.9-51.5-96-96zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160s71.6 160 160 160z"]]
};
var faBugs = {
  prefix: 'fad',
  iconName: 'bugs',
  icon: [576, 512, [], "e4d0", ["M496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.2-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.8-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z", "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184H64v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.8 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6z"]]
};
var faVectorPolygon = {
  prefix: 'fad',
  iconName: 'vector-polygon',
  icon: [448, 512, [], "e2c7", ["M128 64v64H320V64H128zm194.2 75.7L292.3 192H320c15.5 0 28.4 11 31.4 25.6l28.4-49.7 4.5-7.9H352c-13.6 0-25.1-8.4-29.8-20.3zM292.3 320l29.9 52.3c4.7-11.9 16.2-20.3 29.8-20.3h32.3l-4.5-7.9-28.4-49.7C348.4 309 335.5 320 320 320H292.3zM320 448V384H128v64H320zM96 352V160H32V352H96z", "M32 32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32zM80 80v32H48V80H80zM352 32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zm48 48v32H368V80h32zM0 384v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm48 16H80v32H48V400zm304-48c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352zm48 48v32H368V400h32zM224 224v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32zm48 16h32v32H272V240z"]]
};
var faDiagramNested = {
  prefix: 'fad',
  iconName: 'diagram-nested',
  icon: [448, 512, [], "e157", ["M64 320V224h64v96c0 17.7 14.3 32 32 32h96v64H160c-53 0-96-43-96-96z", "M48 32C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM304 288c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H304z"]]
};
var faRupeeSign = {
  prefix: 'fad',
  iconName: 'rupee-sign',
  icon: [448, 512, [8360, "rupee"], "f156", ["M330 260.4c-6.3 3.3-8.9 7.6-9.5 12c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8c.4 .2 .9 .3 1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.5-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17c-1-.3-2-.7-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5l0 0c-14.6-2.7-25.8-.4-32.6 3.2z", "M32 32C14.3 32 0 46.3 0 64V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h42.3l56 139.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6L170.3 307.7C220.8 285.3 256 234.8 256 176c0-79.5-64.5-144-144-144H32zm80 224H64V96h48c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]]
};
var faRupee = faRupeeSign;
var faFileImage = {
  prefix: 'fad',
  iconName: 'file-image',
  icon: [384, 512, [128443], "f1c5", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm88 32c-5.3 0-10.2 2.6-13.2 6.9l-48.3 70.2-12.8-21.4c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8l-48 80c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1h48 48 40 88c5.9 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-88-128c-3-4.3-7.9-6.9-13.2-6.9z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM229.2 294.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-48.3 70.2-12.8-21.4c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8l-48 80c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1h48 48 40 88c5.9 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-88-128z"]]
};
var faCircleQuestion = {
  prefix: 'fad',
  iconName: 'circle-question',
  icon: [512, 512, [62108, "question-circle"], "f059", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M222.6 128c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faQuestionCircle = faCircleQuestion;
var faImageUser = {
  prefix: 'fad',
  iconName: 'image-user',
  icon: [512, 512, [], "e1b8", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4z", "M256 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-43.4 32c-37.9 0-68.6 30.7-68.6 68.6c0 15.1 12.3 27.4 27.4 27.4H340.6c15.1 0 27.4-12.3 27.4-27.4c0-37.9-30.7-68.6-68.6-68.6H212.6z"]]
};
var faBuoy = {
  prefix: 'fad',
  iconName: 'buoy',
  icon: [576, 512, [], "e5b5", ["M192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z", "M391 64H325.8l9.8 49L288 168.5 240.4 113l9.8-49H185L133.8 320H96c-17.7 0-32 14.3-32 32v16c0 8.2 .7 16.1 2 23.9c21-11.1 46.9-9.9 66.9 4.2c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c20-14.1 45.9-15.3 66.9-4.2c1.3-7.8 2-15.8 2-23.9V352c0-17.7-14.3-32-32-32H442.2L391 64zM347.5 172.8l17 84.9-44.9-52.4 27.9-32.6zm-91.1 32.6l-44.9 52.4 17-84.9 27.9 32.6zM221.3 320L288 242.2 354.7 320H221.3z"]]
};
var faPlaneDeparture = {
  prefix: 'fad',
  iconName: 'plane-departure',
  icon: [640, 512, [128747], "f5b0", ["M0 480c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9z"]]
};
var faHandshakeSlash = {
  prefix: 'fad',
  iconName: 'handshake-slash',
  icon: [640, 512, [], "e060", ["M495.8 363.3c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2L495.8 363.3zM296.9 207.4l77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6 63.2 49.6zm-89.1-69.8l81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7 43.3 34zM413.6 421.9L128 196.8V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM96 171.6L40.6 128H16c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V171.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faBookBookmark = {
  prefix: 'fad',
  iconName: 'book-bookmark',
  icon: [448, 512, [], "e0bb", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 256 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H256h96 64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 352V190.7c0 13.4-15.5 20.9-26 12.5L272 160l-54 43.2c-10.5 8.4-26 .9-26-12.5V0H96z"]]
};
var faBorderCenterH = {
  prefix: 'fad',
  iconName: 'border-center-h',
  icon: [448, 512, [], "f89c", ["M32 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-448a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-448a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64z", "M0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z"]]
};
var faCanFood = {
  prefix: 'fad',
  iconName: 'can-food',
  icon: [384, 512, [129387], "e3e6", ["M192 128c97.2 0 176-28.7 176-64s-78.8-64-176-64S16 28.7 16 64s78.8 64 176 64zm0 256a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M320 434.3V275.4c-14.1 6.1-30.7 11.2-49.2 15C264.4 252.7 231.5 224 192 224s-72.4 28.7-78.8 66.4c-18.5-3.8-35.1-8.9-49.2-15V434.3c3.4 3 10.2 7.5 21.7 12.2C110.5 456.6 148.1 464 192 464s81.5-7.4 106.3-17.5c11.5-4.7 18.3-9.2 21.7-12.2zm48 5.7c0 39.8-78.8 72-176 72s-176-32.2-176-72V72c0-1.4 .1-2.8 .3-4.2C21.7 101.4 98.3 128 192 128s170.3-26.6 175.7-60.2c.2 1.4 .3 2.8 .3 4.2V440z"]]
};
var faTypewriter = {
  prefix: 'fad',
  iconName: 'typewriter',
  icon: [512, 512, [], "f8e7", ["M64 64C64 28.7 92.7 0 128 0H354.7c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3V192H365.3c-8.5 0-16.6 3.4-22.6 9.4l-13.3 13.3c-6 6-14.1 9.4-22.6 9.4H205.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H64V64z", "M448 93.3V96H384c-17.7 0-32-14.3-32-32V0h2.7c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3zM0 256V224c0-17.7 14.3-32 32-32H146.7c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3c6 6 14.1 9.4 22.6 9.4H306.7c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288c-17.7 0-32-14.3-32-32zm176 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 304a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 128c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zm0-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faArrowRightFromArc = {
  prefix: 'fad',
  iconName: 'arrow-right-from-arc',
  icon: [512, 512, [], "e4b1", ["M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z", "M345.4 121.4c12.5-12.5 32.8-12.5 45.3 0l112 112c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 288H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H402.7l-57.4-57.4c-12.5-12.5-12.5-32.8 0-45.3z"]]
};
var faCircleK = {
  prefix: 'fad',
  iconName: 'circle-k',
  icon: [512, 512, [], "e113", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm89.1-343.2l-73.1 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L238 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V298.5 152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8L310.9 135.2c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5 .3 33.9z", "M344.8 134.9c9.5 9.3 9.6 24.5 .3 33.9l-73.1 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L238 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V298.5 152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8L310.9 135.2c9.3-9.5 24.5-9.6 33.9-.3z"]]
};
var faFaceHandOverMouth = {
  prefix: 'fad',
  iconName: 'face-hand-over-mouth',
  icon: [512, 512, [129762], "e378", ["M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L207 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V384v32.8c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M208.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm90.9 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7V330.4c0-11-9-20-20-20s-20 9-20 20V384v32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3zM336.4 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faPopcorn = {
  prefix: 'fad',
  iconName: 'popcorn',
  icon: [448, 512, [127871], "f819", ["M32 156c0 1.8 .1 3.5 .3 5.2c3.3-.8 6.7-1.2 10.2-1.2h77.3H328.2h77.3c3.5 0 6.9 .4 10.2 1.2c.2-1.7 .3-3.5 .3-5.2c0-20.9-14.5-38.3-34-42.9c1.3-4.2 2-8.6 2-13.1c0-24.3-19.7-44-44-44c-1.9 0-3.7 .1-5.6 .3C329.3 37.7 312.3 24 292 24c-8.5 0-16.5 2.4-23.2 6.6C261.8 12.7 244.4 0 224 0s-37.8 12.7-44.8 30.6C172.5 26.4 164.5 24 156 24c-20.3 0-37.3 13.7-42.4 32.3c-1.8-.2-3.7-.3-5.6-.3c-24.3 0-44 19.7-44 44c0 4.6 .7 9 2 13.1c-19.5 4.5-34 22-34 42.9z", "M1.4 213.3L70.6 476.2C76.1 497.3 95.2 512 117 512H331c21.8 0 40.9-14.7 46.4-35.8l69.2-262.9c.9-3.5 1.4-7.2 1.4-10.8c0-23.5-19-42.5-42.5-42.5H42.5C19 160 0 179 0 202.5c0 3.7 .5 7.3 1.4 10.8zm126.4 8.4l32 224c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6l-32-224c-1.2-8.7 4.8-16.9 13.6-18.1s16.9 4.8 18.1 13.6zm224 4.5l-32 224c-1.2 8.7-9.4 14.8-18.1 13.6s-14.8-9.4-13.6-18.1l32-224c1.3-8.7 9.4-14.8 18.1-13.6s14.8 9.4 13.6 18.1zM240 224V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faHouseWater = {
  prefix: 'fad',
  iconName: 'house-water',
  icon: [576, 512, ["house-flood"], "f74f", ["M575.8 255.5c0 18-15 32.1-32 32.1h-32l.5 105.6c-21.3-12.4-48.3-11.6-69.1 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-19 0-41.2-7.9-59.2-20.3c-20.6-14.5-47.5-15.4-68.8-3.1V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H248z", "M269.5 421.9c11.1-7.9 25.9-7.9 37 0C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1z"]]
};
var faHouseFlood = faHouseWater;
var faObjectSubtract = {
  prefix: 'fad',
  iconName: 'object-subtract',
  icon: [512, 512, [], "e49e", ["M64 288L64 64l224 0 0 224L64 288zm224 64c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l224 0z", "M448 512c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-96 0 0 128c0 35.3-28.7 64-64 64l-128 0 0 96c0 35.3 28.7 64 64 64l224 0z"]]
};
var faCodeBranch = {
  prefix: 'fad',
  iconName: 'code-branch',
  icon: [448, 512, [], "f126", ["M112 153.3c-9.8 4.3-20.6 6.7-32 6.7s-22.2-2.4-32-6.7L48 352l0 6.7c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7V352c0-35.3 28.7-64 64-64h96c70.7 0 128-57.3 128-128v-6.7c-9.8 4.3-20.6 6.7-32 6.7s-22.2-2.4-32-6.7V160c0 35.3-28.7 64-64 64H176c-23.3 0-45.2 6.2-64 17.1V153.3z", "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 80 0a80 80 0 1 0 0 160zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 368 0a80 80 0 1 0 0 160zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0A80 80 0 1 0 0 432a80 80 0 1 0 160 0z"]]
};
var faWarehouseFull = {
  prefix: 'fad',
  iconName: 'warehouse-full',
  icon: [640, 512, ["warehouse-alt"], "f495", ["M128 248c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V248zM352 408c0-13.3 10.7-24 24-24H488c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V408zM152 384H296c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V408c0-13.3 10.7-24 24-24z", "M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3z"]]
};
var faWarehouseAlt = faWarehouseFull;
var faHatCowboy = {
  prefix: 'fad',
  iconName: 'hat-cowboy',
  icon: [640, 512, [], "f8c0", ["M144.3 286.1C189.1 304.7 248 320 320.1 320c72 0 130.8-15.3 175.6-33.8c-1.1-6.8-5.4-32.2-12.4-64.4C444.2 239.6 389.5 256 320 256s-124.2-16.4-163.3-34.2c-7 32.2-11.3 57.5-12.4 64.4z", "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c42.7 0 74.7 113.9 91.3 189.8C444.2 239.6 389.5 256 320 256s-124.2-16.4-163.3-34.2C173.3 145.9 205.3 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"]]
};
var faBridge = {
  prefix: 'fad',
  iconName: 'bridge',
  icon: [576, 512, [], "e4c8", ["M0 64C0 46.3 14.3 32 32 32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H504v64H456V96H376v64H328V96H248v64H200V96H120v64H72V96H32C14.3 96 0 81.7 0 64z", "M0 160H576V288c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96s-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160z"]]
};
var faPhoneFlip = {
  prefix: 'fad',
  iconName: 'phone-flip',
  icon: [512, 512, [128381, "phone-alt"], "f879", ["M6.3 412.3l8.5 31.2c71.8-8.7 138.9-32.9 197.8-69.1l-20.5-25C136.7 382.8 73.7 404.8 6.3 412.3zM412.3 6.3c-7.5 67.4-29.5 130.4-62.9 185.8l25 20.5c36.2-58.9 60.4-125.9 69.2-197.8L412.3 6.3z", "M443.6 14.8l39 10.6C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-10.6-39c224-27.2 401.6-204.8 428.8-428.8zM6.3 412.3L1.4 394.5c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6l25.1 30.7C136.7 382.8 73.7 404.8 6.3 412.3zM349.4 192.1L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96c7.7-18.6 28-28.5 47.4-23.2l17.8 4.9c-7.5 67.4-29.5 130.4-62.9 185.8z"]]
};
var faPhoneAlt = faPhoneFlip;
var faArrowDownFromDottedLine = {
  prefix: 'fad',
  iconName: 'arrow-down-from-dotted-line',
  icon: [448, 512, [], "e090", ["M0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zm96 0a32 32 0 1 0 64 0A32 32 0 1 0 96 64zM224 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM416 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M201.4 470.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 370.7V304 192c0-17.7-14.3-32-32-32s-32 14.3-32 32V304v66.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"]]
};
var faFileDoc = {
  prefix: 'fad',
  iconName: 'file-doc',
  icon: [512, 512, [], "e5ed", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM176 352c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H176zm16 128V384h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H192zM456 352c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 4.4-3.6 8-8 8H456c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-22.1-17.9-40-40-40H456zM288 392v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8z"]]
};
var faSquareQuarters = {
  prefix: 'fad',
  iconName: 'square-quarters',
  icon: [448, 512, [], "e44e", ["M224 256L384 96V416L224 256zM64 416V96L224 256 64 416z", "M384 96V416H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]]
};
var faTruckFront = {
  prefix: 'fad',
  iconName: 'truck-front',
  icon: [512, 512, [], "e2b7", ["M112 224l17.9-71.8c3.6-14.2 16.4-24.2 31-24.2H351c14.7 0 27.5 10 31 24.2L400 224H112zM32 480V432c13.4 10 30 16 48 16h48v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zm352 0V448h48c18 0 34.6-6 48-16v48c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32z", "M80 0C35.8 0 0 35.8 0 80V368c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80zm32 224l17.9-71.8c3.6-14.2 16.4-24.2 31-24.2H351c14.7 0 27.5 10 31 24.2L400 224H112zM64 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faCat = {
  prefix: 'fad',
  iconName: 'cat',
  icon: [576, 512, [128008], "f6be", ["M300.6 193l-9.7 48.4c-1.3 6.3-9 8.6-13.5 4.1L241 209c18.5-8.4 38.6-13.9 59.6-16zM224 217.7v57.4c0 5.9-6.3 9.8-11.6 7.2l-40.6-20.3c14.6-17.7 32.2-32.7 52.2-44.2z", "M320 192h17.1c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4v4 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L280 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3l0 63.5 0 21.8c3.7-5.5 7.6-10.8 11.8-15.9l40.6 20.3c5.3 2.7 11.6-1.2 11.6-7.2V217.7c5.5-3.2 11.2-6.1 17-8.7l36.5 36.5c4.5 4.5 12.2 2.2 13.5-4.1l9.7-48.4c6.4-.6 12.8-1 19.4-1zm160 26.5v0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32h0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128v0V32 12 10.7C352 4.8 356.7 .1 362.6 0h.2c3.3 0 6.4 1.6 8.4 4.2l0 .1L384 21.3l27.2 36.3L416 64h64l4.8-6.4L512 21.3 524.8 4.3l0-.1c2-2.6 5.1-4.2 8.4-4.2h.2C539.3 .1 544 4.8 544 10.7V12 32v96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faTrashXmark = {
  prefix: 'fad',
  iconName: 'trash-xmark',
  icon: [448, 512, [], "e2b4", ["M416 96H32L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2H346.7c25.4 0 46.5-19.8 47.9-45.2L416 96zM143 207c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM143 207c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]]
};
var faCircleCaretLeft = {
  prefix: 'fad',
  iconName: 'circle-caret-left',
  icon: [512, 512, ["caret-circle-left"], "f32e", ["M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-368 0c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z", "M151.7 238.4c-4.9 4.5-7.7 10.9-7.7 17.6s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-208c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104z"]]
};
var faCaretCircleLeft = faCircleCaretLeft;
var faFiles = {
  prefix: 'fad',
  iconName: 'files',
  icon: [448, 512, [], "e178", ["M160 0H352V64c0 17.7 14.3 32 32 32h64V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64z", "M352 0V64c0 17.7 14.3 32 32 32h64L352 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]]
};
var faAnchorCircleExclamation = {
  prefix: 'fad',
  iconName: 'anchor-circle-exclamation',
  icon: [640, 512, [], "e4ab", ["M288 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 32c0 33.4-17 62.8-42.9 80H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H320V368v80h19.2c12.6 24.7 30.9 46 53 62.2c-7.9 1.2-16 1.8-24.2 1.8H288 208c-88.4 0-160-71.6-160-160v-6.1l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56-56c9.4-9.4 24.6-9.4 33.9 0l56 56c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7V352c0 53 43 96 96 96h48V240H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h10.9C209 158.8 192 129.4 192 96c0-53 43-96 96-96s96 43 96 96z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faFaceClouds = {
  prefix: 'fad',
  iconName: 'face-clouds',
  icon: [640, 512, [], "e47d", ["M72.1 192c-5.3 20.5-8.1 41.9-8.1 64c0 114.6 75.4 211.7 179.3 244.3c-12.1-17-19.3-37.8-19.3-60.3c0-50.6 36.2-92.8 84.1-102.1C321.2 290.7 364.6 256 416 256c29.1 0 55.6 11.1 75.5 29.2c8.9-3.4 18.5-5.2 28.5-5.2c20 0 38.3 7.3 52.3 19.5c2.4-14.1 3.7-28.7 3.7-43.5C576 114.6 461.4 0 320 0c-20.6 0-40.7 2.4-59.9 7C295.2 21.3 320 55.8 320 96c0 39.6-24 73.6-58.2 88.3c6.5 5.9 10.5 14.3 10.5 23.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H72.1zm328.3-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M128 0C104.3 0 83.6 12.9 72.6 32H64C28.7 32 0 60.7 0 96s28.7 64 64 64H224c35.3 0 64-28.7 64-64s-28.7-64-64-64c-13.2 0-25.4 4-35.6 10.8C179.7 17.9 155.9 0 128 0zM416 288c-44.2 0-80 35.8-80 80h-8c-39.8 0-72 32.2-72 72s32.2 72 72 72H568c39.8 0 72-32.2 72-72s-32.2-72-72-72h-.7c.4-2.6 .7-5.3 .7-8c0-26.5-21.5-48-48-48c-13.9 0-26.4 5.9-35.1 15.3C470.9 303.8 445.3 288 416 288z"]]
};
var faUserCrown = {
  prefix: 'fad',
  iconName: 'user-crown',
  icon: [448, 512, [], "f6a4", ["M96 128H352c0 70.7-57.3 128-128 128s-128-57.3-128-128z", "M352 80v48H320 304 144 128 96V80 42.3v-.1V39 16c0-8.8 7.2-16 16-16h2.4c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3 .2 .6 .4 .8 .6l.1 .1c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2 .6-.4 .8-.6l3-2.4L323.6 3.5c2.8-2.3 6.4-3.5 10-3.5H336c8.8 0 16 7.2 16 16V39v3.2 .1V80zM0 472c0-92.8 75.2-168 168-168H280c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8z"]]
};
var faTruckField = {
  prefix: 'fad',
  iconName: 'truck-field',
  icon: [640, 512, [], "e58d", ["M176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm288 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M32 96c0-35.3 28.7-64 64-64H320c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2H544c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H574.9c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H286.9c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96zM384 224h85.9l-42.7-96H384v96z"]]
};
var faRoute = {
  prefix: 'fad',
  iconName: 'route',
  icon: [512, 512, [], "f4d7", ["M358.6 192c17.1 26 35.4 48 44.1 58c3.3 3.9 8.2 6 13.3 6H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H96c5.1 0 9.9-2.1 13.3-6c8.7-10.1 27-32 44.1-58H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-53 0-96-43-96-96s43-96 96-96h38.6z", "M320 96c0 54.5 63.8 132.1 82.7 154c3.3 3.9 8.2 6 13.3 6s9.9-2.1 13.3-6c19-21.9 82.7-99.6 82.7-154c0-53-43-96-96-96s-96 43-96 96zm64 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 352c0 54.5 63.8 132.1 82.7 154c3.3 3.9 8.2 6 13.3 6s9.9-2.1 13.3-6c19-21.9 82.7-99.6 82.7-154c0-53-43-96-96-96s-96 43-96 96zm64 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faCartCircleCheck = {
  prefix: 'fad',
  iconName: 'cart-circle-check',
  icon: [640, 512, [], "e3f1", ["M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5h121c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H339.2c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faClipboardQuestion = {
  prefix: 'fad',
  iconName: 'clipboard-question',
  icon: [384, 512, [], "e4e3", ["M270.8 66.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7c.1-.8 .3-1.6 .4-2.3H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H270.4c.2 .8 .3 1.6 .4 2.3zm-165 178.9c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 344.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V330.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M270.8 66.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM105.8 245.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 344.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V330.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faPanorama = {
  prefix: 'fad',
  iconName: 'panorama',
  icon: [640, 512, [], "e209", ["M45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z", "M387.8 170.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L234.7 265c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-69.4 86.7c-6.2 7.8-7 18.6-1.9 27.2s14.9 13.1 24.7 11.5C196.6 382.5 254.4 376 320 376c65.2 0 122.7 6.4 168.4 14.2c9.5 1.6 19-2.6 24.2-10.7s5.1-18.5-.4-26.5L387.8 170.5z"]]
};
var faCommentMedical = {
  prefix: 'fad',
  iconName: 'comment-medical',
  icon: [512, 512, [], "f7f5", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272H176c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z", "M240 144c-8.8 0-16 7.2-16 16v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272h48c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16l-48 0V160c0-8.8-7.2-16-16-16H240z"]]
};
var faTeethOpen = {
  prefix: 'fad',
  iconName: 'teeth-open',
  icon: [576, 512, [], "f62f", ["M224 96c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V144c0-26.5-21.5-48-48-48zm128 0c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V144c0-26.5-21.5-48-48-48zM48 176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm432-48c-26.5 0-48 21.5-48 48v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 368c0 26.5 21.5 48 48 48s48-21.5 48-48V344c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V344c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V344c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V344c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z", "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96zM224 96c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V144c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V144zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V176c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V176zM96 480H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"]]
};
var faUserTieHairLong = {
  prefix: 'fad',
  iconName: 'user-tie-hair-long',
  icon: [448, 512, [], "e460", ["M257.9 66.2C241 93.7 210.6 112 176 112H128l0 48c0 53 43 96 96 96s96-43 96-96l0-64h-8c-22.8 0-42.8-11.9-54.1-29.8z", "M176 112H128h0v48c0 53 43 96 96 96s96-43 96-96V128h0V96h-8c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112zm48 160H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128h0C96 57.3 153.3 0 224 0c70.6 0 127.8 57.1 128 127.6v.8l0 .2V139c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224zm-14.9 87.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 39.5-161.2c77.2 12 136.3 78.8 136.3 159.4c0 17-13.8 30.7-30.7 30.7H265.1 182.9 30.7C13.8 512 0 498.2 0 481.3c0-80.6 59.1-147.4 136.3-159.4l39.5 161.2 33.4-123.9z"]]
};
var faFileCircleMinus = {
  prefix: 'fad',
  iconName: 'file-circle-minus',
  icon: [576, 512, [], "e4ed", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]]
};
var faHeadSideMedical = {
  prefix: 'fad',
  iconName: 'head-side-medical',
  icon: [512, 512, [], "f809", ["M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM192 112v48H144c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H256V112c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z", "M208 96c-8.8 0-16 7.2-16 16v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16l-48 0V112c0-8.8-7.2-16-16-16H208z"]]
};
var faTags = {
  prefix: 'fad',
  iconName: 'tags',
  icon: [512, 512, [], "f02c", ["M311.1 38.9c9.4-9.3 24.6-9.2 33.9 .2L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9z", "M0 80V229.5c0 17 6.7 33.3 18.7 45.3l168 168c25 25 65.5 25 90.5 0L410.7 309.3c25-25 25-65.5 0-90.5l-168-168c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faWineGlass = {
  prefix: 'fad',
  iconName: 'wine-glass',
  icon: [320, 512, [127863], "f4e3", ["M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z", "M88.1 128l-6.3 75.1C78 248.8 114.1 288 160 288s82-39.2 78.1-84.9L231.9 128H88.1z"]]
};
var faForwardFast = {
  prefix: 'fad',
  iconName: 'forward-fast',
  icon: [512, 512, [9197, "fast-forward"], "f050", ["M480 448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32z", "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4L448 214.3v83.3L276.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V297.7L52.5 440.6z"]]
};
var faFastForward = faForwardFast;
var faFaceMehBlank = {
  prefix: 'fad',
  iconName: 'face-meh-blank',
  icon: [512, 512, [128566, "meh-blank"], "f5a4", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faMehBlank = faFaceMehBlank;
var faUserRobot = {
  prefix: 'fad',
  iconName: 'user-robot',
  icon: [448, 512, [], "e04b", ["M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64h32V16zM64 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H80V128H64zM176 464c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h32V464zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h32V464zm48-16c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zM416 160c0-17.7-14.3-32-32-32H368V256h16c17.7 0 32-14.3 32-32V160z", "M80 128c0-35.3 28.7-64 64-64H304c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V128zm112 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 256a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM0 448c0-53 43-96 96-96H352c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32H352V448c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32-14.3-32-32V448z"]]
};
var faSquareParking = {
  prefix: 'fad',
  iconName: 'square-parking',
  icon: [448, 512, [127359, "parking"], "f540", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 256h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64zm48 64H192v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z", "M192 192h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H192V192zm0 128h48c53 0 96-43 96-96s-43-96-96-96H168c-22.1 0-40 17.9-40 40V288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"]]
};
var faParking = faSquareParking;
var faCardDiamond = {
  prefix: 'fad',
  iconName: 'card-diamond',
  icon: [384, 512, [], "e3ea", ["M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm180.7 84.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0z", "M203.3 148.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"]]
};
var faFaceZipper = {
  prefix: 'fad',
  iconName: 'face-zipper',
  icon: [512, 512, [], "e3a5", ["M512 256c0 34.9-7 68.1-19.6 98.4l-51.8-25.9c-18.5-9.2-40.8-5.6-55.4 9l-15.7 15.7c-14.6 14.6-18.2 36.9-9 55.4l29.1 58.1c1 2 2 3.9 3.1 5.7C353.2 497.5 306.3 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 320c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336zm48-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336z", "M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM389.2 394.3l29.1 58.1c14.7 29.3 53.7 35.6 76.9 12.5l1.8-1.8c23.2-23.2 16.8-62.2-12.5-76.9l-58.1-29.1c-6.2-3.1-13.6-1.9-18.5 3l-15.7 15.7c-4.9 4.9-6.1 12.3-3 18.5zm91.3 38.2l-16 16c-4.7 4.7-12.3 4.7-17 0s-4.7-12.3 0-17l16-16c4.7-4.7 12.3-4.7 17 0s4.7 12.3 0 17zM336.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faFaceRaisedEyebrow = {
  prefix: 'fad',
  iconName: 'face-raised-eyebrow',
  icon: [512, 512, [], "e388", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM328.8 141.8c10.7-10.7 28.5-8.9 36.9 3.7l4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5zM128 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z", "M328.8 141.8c10.7-10.7 28.5-8.9 36.9 3.7l4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5zM128 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128zm80.4 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
};
var faHouseSignal = {
  prefix: 'fad',
  iconName: 'house-signal',
  icon: [576, 512, [], "e012", ["M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34c18.3 5.3 35.9 12.6 52.3 21.6H160v5.7c56.8 34.2 99.6 89.1 118.1 154.3H464c26.5 0 48-21.5 48-48V256h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V208z", "M0 280c0-13.3 10.7-24 24-24c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24zM0 480a32 32 0 1 1 64 0A32 32 0 1 1 0 480zM24 352c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faSquareChevronUp = {
  prefix: 'fad',
  iconName: 'square-chevron-up',
  icon: [448, 512, ["chevron-square-up"], "f32c", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM241 167L345 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167c9.4-9.4 24.6-9.4 33.9 0z", "M207 167c9.4-9.4 24.6-9.4 33.9 0L345 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167z"]]
};
var faChevronSquareUp = faSquareChevronUp;
var faNfcSymbol = {
  prefix: 'fad',
  iconName: 'nfc-symbol',
  icon: [512, 512, [], "e531", ["M386.3 475.7c-12 6.9-27.1 5.4-37.4-3.9l-178.3-160c-13.2-11.8-14.2-32-2.4-45.2s32-14.2 45.2-2.4L373.2 407.7C418.5 373.2 448 317.4 448 256c0-69.6-37.9-132-93.7-164.3C339 82.9 333.7 63.3 342.6 48s28.4-20.5 43.7-11.7C461.6 79.9 512 163.2 512 256s-50.3 176.1-125.7 219.7z", "M125.7 36.3c12-6.9 27.1-5.4 37.4 3.9l178.3 160c13.2 11.8 14.2 32 2.4 45.2s-32 14.2-45.2 2.4L138.8 104.4C93.5 138.8 64 194.6 64 256c0 69.6 37.9 132 93.7 164.3c15.3 8.8 20.5 28.4 11.7 43.7s-28.4 20.5-43.7 11.7C50.3 432.1 0 348.8 0 256S50.3 79.9 125.7 36.3z"]]
};
var faBarsProgress = {
  prefix: 'fad',
  iconName: 'bars-progress',
  icon: [512, 512, ["tasks-alt"], "f828", ["M320 224H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H320v64H448v32H320v64zM192 448H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H192v64H448v32H192v64z", "M0 112C0 85.5 21.5 64 48 64H320V224H48c-26.5 0-48-21.5-48-48V112zM0 336c0-26.5 21.5-48 48-48H192V448H48c-26.5 0-48-21.5-48-48V336z"]]
};
var faTasksAlt = faBarsProgress;
var faFaucetDrip = {
  prefix: 'fad',
  iconName: 'faucet-drip',
  icon: [512, 512, [128688], "e006", ["M192 32V44l32 4 32-4V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 52v76H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 192H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V84l-32-4-32 4z", "M224 80L96 96C78.3 96 64 81.7 64 64s14.3-32 32-32L224 48 352 32c17.7 0 32 14.3 32 32s-14.3 32-32 32L224 80zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"]]
};
var faArrowsToLine = {
  prefix: 'fad',
  iconName: 'arrows-to-line',
  icon: [448, 512, [], "e0a7", ["M0 256c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224c-17.7 0-32 14.3-32 32z", "M224 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM137.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H256v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9z"]]
};
var faDolphin = {
  prefix: 'fad',
  iconName: 'dolphin',
  icon: [512, 512, [], "e168", ["M477.3 24.9c3.5-5.3 3.6-12.2 .1-17.6S467.7-.8 461.4 .2c-16.7 2.8-43.1 8.6-68.8 17C378 22 362.5 28 349 35.3C306.5 12.8 258 0 206.5 0H176C96.5 0 32 64.5 32 144c0 18.6 3.5 36.4 10 52.7L20.5 209.6C7.8 217.2 0 231 0 245.8C0 269.1 18.9 288 42.2 288H176h16 11.2l92 61.3c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V288h6.6c31.7 0 57.4 25.7 57.4 57.4c0 30.6-24 55.8-54.5 57.3l-53.4 2.7c-20.2-33-56.3-53.4-95.4-53.4H176c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6L190.1 432l-28.4 56.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h4.7c35.9 0 69.2-17.1 90.1-45.4l68 3.8c94.1 5.2 173.3-70 173.3-164.3c0-80.8-31.4-154.5-82.7-209.3l48-72zM176 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M152 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
};
var faArrowUpRight = {
  prefix: 'fad',
  iconName: 'arrow-up-right',
  icon: [384, 512, [], "e09f", ["M288 205.3L86.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 160H288v45.3z", "M352 128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H288V352c0 17.7 14.3 32 32 32s32-14.3 32-32V128z"]]
};
var faCircleR = {
  prefix: 'fad',
  iconName: 'circle-r',
  icon: [512, 512, [], "e120", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H288c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L252 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24zm80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64h56z", "M160 152c0-13.3 10.7-24 24-24H288c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L252 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h56 24c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z"]]
};
var faCartFlatbed = {
  prefix: 'fad',
  iconName: 'cart-flatbed',
  icon: [640, 512, ["dolly-flatbed"], "f474", ["M192 80c0-26.5 21.5-48 48-48h96V176c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L400 163.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V32h96c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V80zM160 464c0-5.6 1-11 2.7-16h90.5c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48zm288 0c0-5.6 1-11 2.7-16h90.5c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48z", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM336 176c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L400 163.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V32H448 432 368 352 336V176z"]]
};
var faDollyFlatbed = faCartFlatbed;
var faBanSmoking = {
  prefix: 'fad',
  iconName: 'ban-smoking',
  icon: [512, 512, [128685, "smoking-ban"], "f54d", ["M269.3 224l32 32H384v32H333.3l32 32H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H269.3zm-90.5 0H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H274.7l-96-96zM288 112c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16z", "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]]
};
var faSmokingBan = faBanSmoking;
var faCircleSortUp = {
  prefix: 'fad',
  iconName: 'circle-sort-up',
  icon: [512, 512, ["sort-circle-up"], "e032", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H352c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zM244.7 411.3c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96z", "M267.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H352c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96z"]]
};
var faSortCircleUp = faCircleSortUp;
var faTerminal = {
  prefix: 'fad',
  iconName: 'terminal',
  icon: [576, 512, [], "f120", ["M224 448c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32z", "M9.4 41.4C-3.1 53.9-3.1 74.1 9.4 86.6L178.7 256 9.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0z"]]
};
var faMobileButton = {
  prefix: 'fad',
  iconName: 'mobile-button',
  icon: [384, 512, [], "f10b", ["M368 384H16v64c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V384zM192 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V384H16V64z"]]
};
var faHouseMedicalFlag = {
  prefix: 'fad',
  iconName: 'house-medical-flag',
  icon: [640, 512, [], "e514", ["M276.8 39.7L416 159V512h1l-.2 0H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z", "M512 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512z"]]
};
var faBasketShopping = {
  prefix: 'fad',
  iconName: 'basket-shopping',
  icon: [576, 512, ["shopping-basket"], "f291", ["M393 192l33.1 73.8c5.4 12.1 19.6 17.5 31.7 12.1s17.5-19.6 12.1-31.7L445.6 192H544c17.7 0 32 14.3 32 32s-14.3 32-32 32L492.1 463.5C485 492 459.4 512 430 512H146c-29.4 0-55-20-62.1-48.5L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32h98.4l-24.3 54.2c-5.4 12.1 0 26.3 12.1 31.7s26.3 0 31.7-12.1L183 192H393zM192 320c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V320zm96-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16zm128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V320z", "M253.9 33.8c5.4-12.1 0-26.3-12.1-31.7s-26.3 0-31.7 12.1l-104 232c-5.4 12.1 0 26.3 12.1 31.7s26.3 0 31.7-12.1l104-232zm68.2 0l104 232c5.4 12.1 19.6 17.5 31.7 12.1s17.5-19.6 12.1-31.7l-104-232C360.5 2.1 346.3-3.3 334.2 2.1s-17.5 19.6-12.1 31.7z"]]
};
var faShoppingBasket = faBasketShopping;
var faTape = {
  prefix: 'fad',
  iconName: 'tape',
  icon: [576, 512, [], "f4db", ["M224 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 224a160 160 0 1 0 0-320 160 160 0 1 0 0 320z", "M64 256a160 160 0 1 1 320 0A160 160 0 1 1 64 256zM380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8z"]]
};
var faChestnut = {
  prefix: 'fad',
  iconName: 'chestnut',
  icon: [448, 512, [127792], "e3f6", ["M4 384H444c-14.2 55.2-64.3 96-124 96H128C68.4 480 18.2 439.2 4 384z", "M224 32c5.3 0 10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c7.5 6.8 16.7 14.3 27.2 22.8l3.1 2.5 0 0c20.3 16.4 44.7 36.1 68.2 59.6C400.8 190.2 448 258 448 352c0 11-1.4 21.8-4 32H4c-2.6-10.2-4-21-4-32c0-94 47.2-161.8 96.7-211.3c23.5-23.5 47.9-43.2 68.2-59.6l3.1-2.5c10.6-8.5 19.7-16 27.2-22.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1z"]]
};
var faBusSimple = {
  prefix: 'fad',
  iconName: 'bus-simple',
  icon: [448, 512, ["bus-alt"], "f55e", ["M64 128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V256c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM32 448h96v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448zm384 0v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V448h96z", "M224 0C348.8 0 448 35.2 448 80V96 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V96 80C0 35.2 99.2 0 224 0zM64 128V256c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faBusAlt = faBusSimple;
var faEye = {
  prefix: 'fad',
  iconName: 'eye',
  icon: [576, 512, [128065], "f06e", ["M95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 400a144 144 0 1 0 0-288 144 144 0 1 0 0 288z", "M224 256c35.3 0 64-28.7 64-64c0-7.1-1.2-13.9-3.3-20.3c-1.8-5.5 1.6-11.9 7.4-11.7c40.8 1.7 77.5 29.6 88.6 71.1c13.7 51.2-16.7 103.9-67.9 117.6s-103.9-16.7-117.6-67.9c-1.9-6.9-2.9-13.9-3.2-20.7c-.3-5.8 6.1-9.2 11.7-7.4c6.4 2.1 13.2 3.3 20.3 3.3z"]]
};
var faFaceSadCry = {
  prefix: 'fad',
  iconName: 'face-sad-cry',
  icon: [512, 512, [128557, "sad-cry"], "f5b3", ["M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V477.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V493.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48z", "M195.2 233.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM128 477.8V288c0-8.8 7.2-16 16-16s16 7.2 16 16V493.4c-11.1-4.5-21.8-9.7-32-15.6zm224 15.6V288c0-8.8 7.2-16 16-16s16 7.2 16 16V477.8c-10.2 5.9-20.9 11.2-32 15.6zM316.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]]
};
var faSadCry = faFaceSadCry;
var faHeat = {
  prefix: 'fad',
  iconName: 'heat',
  icon: [448, 512, [], "e00c", ["M176 32c17.7 0 32 14.3 32 32v80c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V400c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144V64c0-17.7 14.3-32 32-32z", "M64 128c0-17.7-14.3-32-32-32S0 110.3 0 128v32c0 48.5 15.7 95.6 44.8 134.4L64 320c20.8 27.7 32 61.4 32 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416c0-48.5-15.7-95.6-44.8-134.4L96 256c-20.8-27.7-32-61.4-32-96V128zm288 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 48.5 15.7 95.6 44.8 134.4L352 320c20.8 27.7 32 61.4 32 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416c0-48.5-15.7-95.6-44.8-134.4L384 256c-20.8-27.7-32-61.4-32-96V128z"]]
};
var faTicketAirline = {
  prefix: 'fad',
  iconName: 'ticket-airline',
  icon: [640, 512, [], "e29a", ["M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V336c0-8.8-7.3-15.8-15.8-18c-27.7-7-48.2-32.1-48.2-62s20.5-55 48.2-62c8.6-2.2 15.8-9.1 15.8-18V128c0-35.3-28.7-64-64-64H64zm352 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM176 224l-28.5-85.5c-1.7-5.2 2.1-10.5 7.6-10.5h31.1c8.5 0 16.4 4.5 20.7 11.9L256 224h46.9c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5C334.4 281.6 319 288 302.9 288H256l-49.1 84.1c-4.3 7.4-12.2 11.9-20.7 11.9H155.1c-5.5 0-9.3-5.4-7.6-10.5L176 288H120l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H74.2c-5.2 0-9-4.9-7.8-9.9L79 259.9c.6-2.5 .6-5.2 0-7.8L66.5 201.9c-1.3-5 2.6-9.9 7.8-9.9H88c5 0 9.8 2.4 12.8 6.4L120 224h56z", "M147.5 138.5L176 224H120l-19.2-25.6c-3-4-7.8-6.4-12.8-6.4H74.2c-5.2 0-9 4.9-7.8 9.9L79 252.1c.6 2.5 .6 5.2 0 7.8L66.5 310.1c-1.3 5 2.6 9.9 7.8 9.9H88c5 0 9.8-2.4 12.8-6.4L120 288h56l-28.5 85.5c-1.7 5.2 2.1 10.5 7.6 10.5h31.1c8.5 0 16.4-4.5 20.7-11.9L256 288h46.9c16.1 0 31.5-6.4 42.8-17.7c7.9-7.9 7.9-20.7 0-28.5C334.4 230.4 319 224 302.9 224H256l-49.1-84.1c-4.3-7.4-12.2-11.9-20.7-11.9H155.1c-5.5 0-9.3 5.3-7.6 10.5z"]]
};
var faBootHeeled = {
  prefix: 'fad',
  iconName: 'boot-heeled',
  icon: [512, 512, [], "e33f", ["M480 464H320L160 416H32v72c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V472.9l125 34.7c10.5 2.9 21.3 4.4 32.1 4.4H456h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8z", "M63.3 0H128V240c0 8.8 7.2 16 16 16s16-7.2 16-16V0H264c13.3 0 24 10.7 24 24V244.7c0 27.3 15.4 52.2 39.8 64.4l112.4 56.2c24.4 12.2 39.8 37.1 39.8 64.4V464H320L160 416H32V391.8c0-12.5 1.6-24.8 4.3-36.6C43.2 325.5 56 265.2 56 232C56 154.3 34.6 47.1 32.6 37.4c-.5-2.3-.6-4.3-.6-6.2C32 14 46 0 63.3 0z"]]
};
var faArrowsMinimize = {
  prefix: 'fad',
  iconName: 'arrows-minimize',
  icon: [512, 512, ["compress-arrows"], "e0a5", ["M457.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L397.3 160H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v50.7L457.4 9.4zM32 320c0-17.7 14.3-32 32-32H192c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352H64c-17.7 0-32-14.3-32-32z", "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h50.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM288 320c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H397.3L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 397.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V320z"]]
};
var faCompressArrows = faArrowsMinimize;
var faAudioDescription = {
  prefix: 'fad',
  iconName: 'audio-description',
  icon: [576, 512, [], "f29e", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM192 237.7l-21.1 42.2h42.2L192 237.7zM328 160h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24zm24 144h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96z", "M192 160c9.1 0 17.4 5.1 21.5 13.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3zM170.9 279.8h42.2L192 237.7l-21.1 42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"]]
};
var faPersonMilitaryToPerson = {
  prefix: 'fad',
  iconName: 'person-military-to-person',
  icon: [512, 512, [], "e54c", ["M384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H352zM288 432c0 6.9 3 13.5 8.2 18.1l64 56c10 8.7 25.1 7.7 33.9-2.3s7.7-25.1-2.3-33.9L375.9 456 488 456c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112.1 0 15.9-13.9c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-64 56c-5.2 4.6-8.2 11.1-8.2 18.1z", "M71 12.5L182.2 .1C191.7-1 200 6.5 200 16V30.1c0 8.8-7.1 15.9-15.9 16H72.7C63.5 46 56 38.5 56 29.2c0-8.6 6.5-15.8 15-16.8zM189.5 78.1c1.6 5.7 2.5 11.7 2.5 17.9c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-6.2 .9-12.2 2.5-17.9H189.5zM32 256c0-18.8 8.1-35.7 21-47.4l144.2 111c-1.7 .3-3.4 .4-5.2 .4H64c-17.7 0-32-14.3-32-32V256zm190.2 42.5L85.1 192.9c3.6-.6 7.2-.9 10.9-.9h64c35.3 0 64 28.7 64 64v32c0 3.7-.6 7.2-1.8 10.5zM224 432c0 6.9-3 13.5-8.2 18.1l-64 56c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9L136.1 456 24 456c-13.3 0-24-10.7-24-24s10.7-24 24-24l112.1 0-15.9-13.9c-10-8.7-11-23.9-2.3-33.9s23.9-11 33.9-2.3l64 56c5.2 4.6 8.2 11.1 8.2 18.1z"]]
};
var faFileShield = {
  prefix: 'fad',
  iconName: 'file-shield',
  icon: [576, 512, [], "e4f0", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zm39.1 65.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"]]
};
var faHexagon = {
  prefix: 'fad',
  iconName: 'hexagon',
  icon: [512, 512, [11043], "f312", ["M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36H344.3c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.7c-25.7 0-49.5 13.7-62.4 36L17.1 220z", ""]]
};
var faManhole = {
  prefix: 'fad',
  iconName: 'manhole',
  icon: [512, 512, [], "e1d6", ["M305 103.6c-9-2.9-17.8 4.3-23.6 11.8c-5.8 7.6-15.1 12.6-25.4 12.6s-19.6-4.9-25.4-12.6c-5.8-7.5-14.5-14.7-23.6-11.8C142.6 124.3 96 184.7 96 256s46.6 131.7 111 152.4c9 2.9 17.8-4.3 23.6-11.8c5.8-7.6 15.1-12.6 25.4-12.6s19.6 4.9 25.4 12.6c5.8 7.5 14.5 14.7 23.6 11.8c64.4-20.7 111-81.1 111-152.4s-46.6-131.7-111-152.4zM176 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48-144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80-112a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-32 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-448a192 192 0 1 1 0 384 192 192 0 1 1 0-384z"]]
};
var faUserSlash = {
  prefix: 'fad',
  iconName: 'user-slash',
  icon: [640, 512, [], "f506", ["M448 128c0 59.2-40.1 109-94.7 123.6L192 125.2C193.5 55.8 250.2 0 320 0c70.7 0 128 57.3 128 128zM264.3 304.3l261 205.6c-3.4 1.4-7.1 2.1-11 2.1H125.7C109.3 512 96 498.7 96 482.3c0-95.1 74.5-172.9 168.3-178z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faPen = {
  prefix: 'fad',
  iconName: 'pen',
  icon: [512, 512, [128394], "f304", ["M362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c25 25 25 65.5 0 90.5L433 209 303 79l59.7-59.7z", "M433 209L303 79 52.8 329.3c-6.6 6.6-11.5 14.8-14.1 23.8L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l128.2-37.7c9-2.6 17.2-7.5 23.8-14.1L433 209z"]]
};
var faTowerObservation = {
  prefix: 'fad',
  iconName: 'tower-observation',
  icon: [512, 512, [], "e586", ["M100.9 448l32-192h64.9l-4.7 28.3L256 336.8l62.9-52.5L314.2 256h64.9l32 192H314.5L256 399.2 197.5 448H100.9zm26.6 64h1.1c-.4 0-.8 0-1.1 0zm255.9 0h1.1c-.4 0-.8 0-1.1 0zM183.9 339.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368z", "M270.3 3.4c-9-4.5-19.6-4.5-28.6 0l-160 80c-15.8 7.9-22.2 27.1-14.3 42.9C73 137.5 84.3 144 96 144v80c0 17.7 14.3 32 32 32h4.9 64.9H314.2h64.9H384c17.7 0 32-14.3 32-32V144c11.7 0 23-6.5 28.6-17.7c7.9-15.8 1.5-35-14.3-42.9l-160-80zM480 448H411.1 314.5h-117H100.9 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h95.5c.4 0 .8 0 1.1 0H383.4c.4 0 .8 0 1.1 0H480c17.7 0 32-14.3 32-32s-14.3-32-32-32zM160 144c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"]]
};
var faFloppyDisks = {
  prefix: 'fad',
  iconName: 'floppy-disks',
  icon: [512, 512, [], "e183", ["M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zM304 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z", "M152 0C121.1 0 96 25.1 96 56V360c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V141.3c0-14.9-5.9-29.1-16.4-39.6L410.3 16.4C399.8 5.9 385.6 0 370.7 0H152zm8 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96zM304 224a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]]
};
var faToiletPaperBlankUnder = {
  prefix: 'fad',
  iconName: 'toilet-paper-blank-under',
  icon: [512, 512, ["toilet-paper-reverse-alt"], "e29f", ["M0 192C0 298 43 384 96 384h32H416c-53 0-96-86-96-192S363 0 416 0H96C43 0 0 86 0 192z", "M416 384c-52.4 0-94.9-83.8-96-188.1c0-1.3 0-2.6 0-3.9C320 86 363 0 416 0s96 86 96 192V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V384H416zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z"]]
};
var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
var faFileCode = {
  prefix: 'fad',
  iconName: 'file-code',
  icon: [384, 512, [], "f1c9", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM153 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM265 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM153 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM265 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"]]
};
var faSignal = {
  prefix: 'fad',
  iconName: 'signal',
  icon: [640, 512, [128246, "signal-5", "signal-perfect"], "f012", ["", "M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM352 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"]]
};
var faSignal5 = faSignal;
var faSignalPerfect = faSignal;
var faPump = {
  prefix: 'fad',
  iconName: 'pump',
  icon: [640, 512, [], "e442", ["M64 224h96V64H320V224h32V384H64V224z", "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zM64 208c0-17.7-14.3-32-32-32s-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32V208zM431.9 106.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3V413.7c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3c10.5 7 22.9 10.7 35.5 10.7H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H467.4c-12.6 0-25 3.7-35.5 10.7zM448 208c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16z"]]
};
var faBus = {
  prefix: 'fad',
  iconName: 'bus',
  icon: [576, 512, [128653], "f207", ["M128 160c0-17.7 14.3-32 32-32H272V288H160c-17.7 0-32-14.3-32-32V160zM304 288V128H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H304zM96 448h96v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V448zm288 0h96v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448z", "M288 0C422.4 0 512 35.2 512 80V96l0 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h0V96h0V80C64 35.2 153.6 0 288 0zM128 160v96c0 17.7 14.3 32 32 32H272V128H160c-17.7 0-32 14.3-32 32zM304 288H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H304V288zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16z"]]
};
var faHeartCircleXmark = {
  prefix: 'fad',
  iconName: 'heart-circle-xmark',
  icon: [576, 512, [], "e501", ["M507 208.7C484.3 198 458.8 192 432 192c-97.2 0-176 78.8-176 176c0 35.7 10.6 68.9 28.9 96.6l-5.4 5.6c-13 13-34 13-45.9 0L39.7 270.5c-55.9-57.9-52.9-153.8 10-207.8c53.9-47 136.8-38 186.8 13l20 21 19-21c49.9-50.9 131.8-59.9 187.8-13c42.9 37.4 57.5 95 43.8 146.1z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faArrowUpLeftFromCircle = {
  prefix: 'fad',
  iconName: 'arrow-up-left-from-circle',
  icon: [512, 512, [], "e09e", ["M288.4 93.4c2.9-17.4 19.4-29.2 36.9-26.3C431.3 84.9 512 177 512 288c0 123.7-100.3 224-224 224C177 512 84.9 431.3 67.1 325.3c-2.9-17.4 8.8-33.9 26.3-36.9s33.9 8.8 36.9 26.3C142.9 390.4 208.8 448 288 448c88.4 0 160-71.6 160-160c0-79.2-57.6-145.1-133.3-157.8c-17.4-2.9-29.2-19.4-26.3-36.9z", "M32 0H192c17.7 0 32 14.3 32 32s-14.3 32-32 32H109.3L342.6 297.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L64 109.3V192c0 17.7-14.3 32-32 32s-32-14.3-32-32V32C0 14.3 14.3 0 32 0z"]]
};
var faHouseChimney = {
  prefix: 'fad',
  iconName: 'house-chimney',
  icon: [576, 512, [63499, "home-lg"], "e3af", ["M64 270.5L64.1 472c0 22.1 17.9 40 40 40H184c22.1 0 40-17.9 40-40V383.7c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V472c0 22.1 17.9 40 40 40h80.5c22.1 0 40-18 40-40.1l-.4-201.3L288 74.5 64 270.5z", "M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2L512 185.5V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v37.5L309.1 7.9z"]]
};
var faHomeLg = faHouseChimney;
var faWindowMaximize = {
  prefix: 'fad',
  iconName: 'window-maximize',
  icon: [512, 512, [128470], "f2d0", ["M64 128c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32z", "M448 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64l384 0zM96 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]]
};
var faDryer = {
  prefix: 'fad',
  iconName: 'dryer',
  icon: [448, 512, [], "f861", ["M184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM368 304c0 79.5-64.5 144-144 144c-74.1 0-135.2-56-143.1-128H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H80.9c8-72 69-128 143.1-128c79.5 0 144 64.5 144 144z", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faFaceFrown = {
  prefix: 'fad',
  iconName: 'face-frown',
  icon: [512, 512, [9785, "frown"], "f119", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faFrown = faFaceFrown;
var faChessBishopPiece = {
  prefix: 'fad',
  iconName: 'chess-bishop-piece',
  icon: [256, 512, ["chess-bishop-alt"], "f43b", ["M208 416H48L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416z", "M104 32C90.7 32 80 42.7 80 56c0 12.2 9.1 22.3 20.9 23.8C79.6 100.1 48 139 48 192c0 26.3 13.6 40.5 26.3 48H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4.4L48 416H208L179.6 288H184c13.3 0 24-10.7 24-24s-10.7-24-24-24h-2.3c12.7-7.5 26.3-21.7 26.3-48c0-25.9-7.5-48.4-17.7-67l-48.6 48.6c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L181.7 111c-8.8-12.9-18.5-23.4-26.6-31.2C166.9 78.3 176 68.2 176 56c0-13.3-10.7-24-24-24H104z"]]
};
var faChessBishopAlt = faChessBishopPiece;
var faShirtTankTop = {
  prefix: 'fad',
  iconName: 'shirt-tank-top',
  icon: [384, 512, [], "e3c9", ["M112 32C112 14.3 97.7 0 80 0S48 14.3 48 32V64c0 91-19.2 143.6-33.3 170.1C6.7 249.1 0 265.5 0 282.5V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V282.5c0-17-6.7-33.5-14.7-48.4C355.2 207.6 336 155 336 64V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V80c0 44.2-35.8 80-80 80s-80-35.8-80-80V32z", ""]]
};
var faDiploma = {
  prefix: 'fad',
  iconName: 'diploma',
  icon: [640, 512, ["scroll-ribbon"], "f5ea", ["M256 144H96c-65.1 .3-96 71.5-96 128c0 56.9 24.1 119.2 81 140.7c10.5 4 22.5 4.2 33.4 1.8L256 383V160 144zm128 0v16V383l141.6 31.5c10.9 2.4 22.9 2.2 33.4-1.8c56.9-21.5 81-83.8 81-140.7c0-56.5-30.9-127.7-96-128H384z", "M302 59.7l18 20.6 18-20.6C353.4 42.1 375.6 32 399 32h1c44.2 0 80 35.8 80 80c0 11.4-2.4 22.2-6.7 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1c-1.2 0-2.3 .1-3.5 .2c-8.2 .9-15.8 4.8-21.3 11.1l-34.5 39.5c-4.5 5.2-.9 13.3 6 13.3H368h16v16V464c0 6.2-3.6 11.9-9.2 14.5s-12.3 1.8-17-2.2L320 444.8l-37.8 31.5c-4.8 4-11.4 4.8-17 2.2s-9.2-8.3-9.2-14.5V160 144h16 22.4c6.9 0 10.5-8.1 6-13.3L265.9 91.3C259.6 84.1 250.5 80 241 80h-1c-17.7 0-32 14.3-32 32s14.3 32 32 32H166.7c-4.3-9.8-6.7-20.6-6.7-32c0-44.2 35.8-80 80-80h1c23.4 0 45.6 10.1 61 27.7z"]]
};
var faScrollRibbon = faDiploma;
var faScreencast = {
  prefix: 'fad',
  iconName: 'screencast',
  icon: [576, 512, [], "e23e", ["M64 96H512V416H285c2 13 3 26.4 3 40v24H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v96H24c13.6 0 27 1 40 3V96z", "M0 248c0-13.3 10.7-24 24-24c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zM24 320c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faWalker = {
  prefix: 'fad',
  iconName: 'walker',
  icon: [448, 512, [], "f831", ["M320 448a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z", "M194 64H320c17.7 0 32 14.3 32 32v64H145l17.9-71.8C166.5 74 179.3 64 194 64zM63 487.8L129 224H352V392.6c9.4-5.4 20.3-8.6 32-8.6s22.6 3.1 32 8.6V96c0-53-43-96-96-96H194c-44.1 0-82.4 30-93.1 72.7L1 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3z"]]
};
var faPrescription = {
  prefix: 'fad',
  iconName: 'prescription',
  icon: [448, 512, [], "f5b1", ["M438.6 201.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l256-256c12.5-12.5 32.8-12.5 45.3 0z", "M0 32C0 14.3 14.3 0 32 0H176c61.9 0 112 50.1 112 112c0 52.8-36.6 97.1-85.8 108.9L288 306.7 242.7 352l-128-128H64v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192 32zM288 397.3L333.3 352 438.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 397.3zM64 160H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96z"]]
};
var faShop = {
  prefix: 'fad',
  iconName: 'shop',
  icon: [640, 512, ["store-alt"], "f54f", ["M64 192H96h32H320h64H512h32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H384V384v80c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V384 192zm256 32H128V384H320V224z", "M603.2 192H36.8C16.5 192 0 175.5 0 155.2c0-7.3 2.2-14.4 6.2-20.4L81.8 21.4C90.7 8 105.6 0 121.7 0H518.3c16.1 0 31 8 39.9 21.4l75.6 113.3c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8z"]]
};
var faStoreAlt = faShop;
var faFloppyDisk = {
  prefix: 'fad',
  iconName: 'floppy-disk',
  icon: [448, 512, [128190, 128426, "save"], "f0c7", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M224 288a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"]]
};
var faSave = faFloppyDisk;
var faVihara = {
  prefix: 'fad',
  iconName: 'vihara',
  icon: [640, 512, [], "f6a7", ["M160 192V128h64v64H160zM96 352V288h64v64H96zM64 480V448h64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32zm448 0V448h64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32zM288 448h64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448zM480 288h64v64H480V288zM416 128h64v64H416V128z", "M305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9H320 152.5c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22L305.8 4.7zM472 192h7.3l6 4 11.1 7.4c22.1 14.8 46.6 25.6 72.4 32l21 5.2c11.8 2.9 19.5 14.2 18 26.2S596.1 288 584 288H376 352 288 264 56c-12.1 0-22.3-9-23.8-21.1s6.2-23.3 18-26.2l21-5.2c25.8-6.4 50.3-17.3 72.4-32l11.1-7.4 6-4H168h96 24 64 24 96zM95.6 352H104 296h24 24H536h8.4l6.6 5.3 10.4 8.3c17.8 14.2 37.6 25.8 58.8 34.2l4.8 1.9c10.7 4.3 16.8 15.5 14.7 26.8S627.5 448 616 448H344 320 296 24c-11.5 0-21.4-8.2-23.6-19.5s4-22.5 14.7-26.8l4.8-1.9c21.2-8.5 41-20 58.8-34.2L89 357.3l6.6-5.3z"]]
};
var faFaceKissClosedEyes = {
  prefix: 'fad',
  iconName: 'face-kiss-closed-eyes',
  icon: [512, 512, [], "e37d", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-93.5-80.1c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z", "M140.8 233.6c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zm160 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z"]]
};
var faScaleUnbalanced = {
  prefix: 'fad',
  iconName: 'scale-unbalanced',
  icon: [640, 512, ["balance-scale-left"], "f515", ["M521 62.4c16.8-5.6 25.8-23.7 20.2-40.5S517.5-3.9 500.7 1.6l-113 37.7C373.8 15.8 348.2 0 318.8 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L116.7 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-160V153.3c21-9.2 37.2-27 44.2-49L521 62.4z", "M510.8 163.8L583.3 288H438.4l72.4-124.2zm-126 141.3C395.7 350 448 384 510.8 384s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L534.9 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L391.6 273.1c-5.7 9.8-9.3 21.1-6.7 32.1zM128 291.8L200.4 416H55.6L128 291.8zM2 433.1C12.8 478 65.1 512 128 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L152.1 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L8.7 401.1C3 410.8-.6 422.1 2 433.1z"]]
};
var faBalanceScaleLeft = faScaleUnbalanced;
var faFileUser = {
  prefix: 'fad',
  iconName: 'file-user',
  icon: [384, 512, [], "f65c", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 432c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H160c-44.2 0-80 35.8-80 80z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM256 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 432c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H160c-44.2 0-80 35.8-80 80z"]]
};
var faUserPoliceTie = {
  prefix: 'fad',
  iconName: 'user-police-tie',
  icon: [448, 512, [], "e334", ["M101.7 154.2C98 166.1 96 178.8 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-13.2-2-25.9-5.7-37.8C308.2 168.3 267 176 224 176s-84.2-7.7-122.3-21.8z", "M230.1 .8l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6l-23.8 20.4c.1 1 .1 2 .1 3.1v21.2c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 147.7 80 137.6 80 126.9V105.7c0-1 0-2.1 .1-3.1L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40c4-1.1 8.2-1.1 12.2 0zM227 48.6c-1.9-.8-4-.8-5.9 0L189 61.4c-3 1.2-5 4.2-5 7.4c0 17.2 7 46.1 36.9 58.6c2 .8 4.2 .8 6.2 0C257 114.9 264 86 264 68.8c0-3.3-2-6.2-5-7.4L227 48.6zM208 416l-20.4-40.8c-5.3-10.6 2.4-23.2 14.3-23.2h44.2c11.9 0 19.6 12.5 14.3 23.2L240 416l12.2 48.9L315 360.3c3-5 8.6-8.1 14.4-7.4C396.2 360.8 448 417.5 448 486.4c0 14.1-11.5 25.6-25.6 25.6H256v0H192v0H25.6C11.5 512 0 500.5 0 486.4c0-68.9 51.8-125.6 118.6-133.5c5.8-.7 11.4 2.4 14.4 7.4l62.8 104.6L208 416zm144-8c-3.5 0-6.5 2.2-7.6 5.5L339 430.2l-17.4 0c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9L331 454.8l-5.4 16.6c-1.1 3.3 .1 6.9 2.9 9s6.6 2 9.4 0L352 470.1l14.1 10.3c2.8 2 6.6 2.1 9.4 0s4-5.7 2.9-9L373 454.8l14.1-10.2c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5l-17.4 0-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5z"]]
};
var faFaceTongueMoney = {
  prefix: 'fad',
  iconName: 'face-tongue-money',
  icon: [512, 512, [], "e39d", ["M163.1 494.6C67.7 457.5 0 364.6 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 108.6-67.7 201.5-163.1 238.6C360.9 476.8 368 455.2 368 432V421.5c22.4-20.1 39-46.1 47.2-75.4c3.8-13.7-7.4-26.1-21.6-26.1H118.4c-14.2 0-25.5 12.4-21.6 26.1c8.2 29.4 24.9 55.3 47.2 75.4V432c0 23.2 7.1 44.8 19.1 62.6zM176 88c-8.8 0-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.3 9 27.2 11.2l1.1 .3c9.6 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8l0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6V248c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7V104c0-8.8-7.2-16-16-16zm176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.4 9 27.2 11.2l1.1 .3c9.5 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8l0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6V248c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7V104z", "M176 88c8.8 0 16 7.2 16 16v9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c3 6.6 3.5 13.9 2.2 21.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2V248c0 8.8-7.2 16-16 16s-16-7.2-16-16V237.2c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1V104c0-8.8 7.2-16 16-16zm160 0c8.8 0 16 7.2 16 16v9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c3 6.6 3.5 13.9 2.2 21.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2V248c0 8.8-7.2 16-16 16s-16-7.2-16-16V237.2c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1V104c0-8.8 7.2-16 16-16zm0 264v80c0 44.2-35.8 80-80 80s-80-35.8-80-80V352H336zm-80 16c-5.9 0-10.7 4.9-10.7 10.9v6.4c-3.8 .8-7.8 2.2-11.3 4.9c-5 3.7-8.4 9.2-9.6 16.1c-.8 5-.5 9.9 1.5 14.4c1.9 4.5 5.1 7.7 8.3 9.9c5.6 4 12.9 6.1 18.1 7.6l.8 .2c6.4 1.9 10.2 3.1 12.6 4.8c1.7 1.2 1.4 4.4-.4 5.5c-.8 .5-2.5 1.1-5.9 1c-6.8-.1-15-2.7-21.3-4.8c-5.6-1.9-11.6 1.2-13.5 6.9s1.2 11.9 6.8 13.8c3.4 1.1 8.4 2.8 14 4.1v7.3c0 6 4.8 10.9 10.7 10.9s10.7-4.9 10.7-10.9V471c3.2-.6 6.5-1.7 9.6-3.6c6.1-3.7 10-9.8 11.3-17.7c.8-5 .5-9.9-1.5-14.4c-1.9-4.5-5.1-7.7-8.3-9.9c-4.8-3.4-10.4-4.9-15.9-6.4c-5.5-1.5-10.9-3-15.5-6.2c-1.6-1.1-1.6-3.6 .2-4.9c.7-.5 2.1-1.1 4.7-1.4c5.4-.6 12.5 .6 18 2.2c5.7 1.5 11.5-1.9 13-7.7s-1.9-11.8-7.6-13.3c-2.3-.6-5-1.3-8.1-1.8v-6.7c0-6-4.8-10.9-10.7-10.9z"]]
};
var faTennisBall = {
  prefix: 'fad',
  iconName: 'tennis-ball',
  icon: [512, 512, [127934], "f45e", ["M.2 245.1C.1 248.7 0 252.3 0 256C0 397.4 114.6 512 256 512c3.7 0 7.3-.1 10.9-.2c-3.8-10.7-6.6-21.8-8.4-33.1c-4.4-27.2-2.9-55 4.4-81.6s20.2-51.2 37.9-72.4s39.7-38.2 64.5-50.1s52-18.2 79.5-18.7c22.8-.4 45.5 3.3 67 10.9c.2-3.6 .2-7.2 .2-10.9C512 114.6 397.4 0 256 0c-3.7 0-7.3 .1-10.9 .2c10.7 30.5 13.7 63.4 8.2 95.6c-7.1 42.4-28.3 81.2-60 110.1s-72.4 46.4-115.2 49.6c-26.6 2-53.1-1.7-77.9-10.4zM206.8 4.7C104.9 24.6 24.6 104.9 4.7 206.8C26.9 216 51.1 220 75.3 218.2c34.5-2.5 67.2-16.6 92.8-39.9s42.6-54.5 48.4-88.7c4.8-28.7 1.4-58.2-9.7-84.9zM445.4 293.4c-22.2 .4-44 5.5-64 15.1s-37.7 23.3-52 40.3s-24.6 36.9-30.5 58.3s-7.1 43.8-3.5 65.7c1.9 11.9 5.2 23.5 9.8 34.6c101.9-19.8 182.2-100.2 202.1-202.1c-19.6-8.1-40.6-12.1-61.9-11.8z", "M305.2 507.3c-12.5 2.4-25.3 3.9-38.3 4.5c-3.8-10.7-6.6-21.8-8.4-33.1c-4.4-27.2-2.9-55 4.4-81.6s20.2-51.2 37.9-72.4s39.7-38.2 64.5-50.1s52-18.2 79.5-18.7c22.8-.4 45.5 3.3 67 10.9c-.5 13-2.1 25.8-4.5 38.3c-19.6-8.1-40.6-12.1-61.9-11.8c-22.2 .4-44 5.5-64 15.1s-37.7 23.3-52 40.3s-24.6 36.9-30.5 58.3s-7.1 43.8-3.5 65.7c1.9 11.9 5.2 23.5 9.8 34.6zM245.1 .2c10.7 30.5 13.7 63.4 8.2 95.6c-7.1 42.4-28.3 81.2-60 110.1s-72.4 46.4-115.2 49.6c-26.6 2-53.1-1.7-77.9-10.4c.5-13 2.1-25.8 4.5-38.3C26.9 216 51.1 220 75.3 218.2c34.5-2.5 67.2-16.6 92.8-39.9s42.6-54.5 48.4-88.7c4.8-28.7 1.4-58.2-9.7-84.9c12.5-2.4 25.3-3.9 38.3-4.5z"]]
};
var faSquareL = {
  prefix: 'fad',
  iconName: 'square-l',
  icon: [448, 512, [], "e275", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM176 152V336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M152 128c13.3 0 24 10.7 24 24V336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"]]
};
var faSortUp = {
  prefix: 'fad',
  iconName: 'sort-up',
  icon: [320, 512, ["sort-asc"], "f0de", ["M137.4 470.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128zM109.3 352H210.7L160 402.7 109.3 352z", "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]]
};
var faSortAsc = faSortUp;
var faCalendarArrowUp = {
  prefix: 'fad',
  iconName: 'calendar-arrow-up',
  icon: [448, 512, ["calendar-upload"], "e0d1", ["M448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM248 321.9V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V321.9l-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39z", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM248 424V321.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V424c0 13.3 10.7 24 24 24s24-10.7 24-24z"]]
};
var faCalendarUpload = faCalendarArrowUp;
var faCommentDots = {
  prefix: 'fad',
  iconName: 'comment-dots',
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M96 240a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faCommenting = faCommentDots;
var faPlantWilt = {
  prefix: 'fad',
  iconName: 'plant-wilt',
  icon: [512, 512, [], "e5aa", ["M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c9.6-3.3 20.4-5 32-5s22.4 1.7 32 5V120C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120v13c9.6-3.3 20.4-5 32-5s22.4 1.7 32 5V248c0-30.9 25.1-56 56-56s56 25.1 56 56v32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V280 248 120z", "M432 128c-47.1 0-80 27.8-80 75.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-47.3-32.9-75.1-80-75.1zM80 256c-47.1 0-80 27.8-80 75.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-47.3-32.9-75.1-80-75.1z"]]
};
var faScarf = {
  prefix: 'fad',
  iconName: 'scarf',
  icon: [512, 512, [129507], "f7c1", ["M4.7 388.7l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm288 22.6L288 406.6 310.6 384 411.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0zm48-48L336 358.6l11.3-11.3L358.6 336 459.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0zm48-48L384 310.6 406.6 288 507.3 388.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0z", "M396.1 232.2C409 213.7 416 191.6 416 168.8c0-19-4.9-37.7-14.2-54.2L360.3 40.8C346.1 15.6 319.5 0 290.6 0H221.4c-28.9 0-55.6 15.6-69.7 40.8l-41.5 73.8C100.9 131.1 96 149.8 96 168.8c0 29.3 11.7 57.5 32.4 78.2L276.7 395.3 288 406.6l11.3-11.3 48-48 48-48L406.6 288l-11.3-11.3L384 265.4l-9.4-9.4L256 137.4 218.2 99.6C228.9 97.5 241.7 96 256 96s27.1 1.5 37.8 3.6l-15.1 15.1L396.1 232.2z"]]
};
var faAlbumCirclePlus = {
  prefix: 'fad',
  iconName: 'album-circle-plus',
  icon: [576, 512, [], "e48c", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H296.2c-16.2-19.7-28.3-42.9-34.8-68.4c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160c69.3 0 128.3 44 150.5 105.6c18-6.2 37.4-9.6 57.5-9.6c5.4 0 10.7 .2 16 .7V96c0-35.3-28.7-64-64-64H64zM256 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]]
};
var faUserNurseHairLong = {
  prefix: 'fad',
  iconName: 'user-nurse-hair-long',
  icon: [448, 512, [], "e45e", ["M257.9 114.2C241 141.7 210.6 160 176 160H128c0 53 43 96 96 96s96-43 96-96l0-16h-8c-22.8 0-42.8-11.9-54.1-29.8z", "M96 152.8V68c0-13.3 8.3-25.3 20.8-30l96-36C220-.7 228-.7 235.2 2l96 36C343.7 42.7 352 54.7 352 68v84.8c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H70.6c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5zM212.3 409.4c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 346.4 448 407.3 448 479.1c0 17-13.8 30.7-30.7 30.7H30.7c-17 0-30.7-13.8-30.7-30.7c0-71.9 47-132.7 111.9-153.6c10.5-3.4 21.8 .4 29.4 8.5l71 75.5zM216 40c-4.4 0-8 3.6-8 8V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216zM176 160H128c0 53 43 96 96 96s96-43 96-96l0-16h-8c-22.8 0-42.8-11.9-54.1-29.8C241 141.7 210.6 160 176 160z"]]
};
var faDiamond = {
  prefix: 'fad',
  iconName: 'diamond',
  icon: [512, 512, [9830], "f219", ["M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z", ""]]
};
var faSquareLeft = {
  prefix: 'fad',
  iconName: 'square-left',
  icon: [448, 512, [11013, "arrow-alt-square-left"], "f351", ["M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zm185.4-39.1L85.5 269.8C82 266.1 80 261.1 80 256s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1z", "M85.5 269.8l99.9 107.1c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L85.5 242.2C82 245.9 80 250.9 80 256s2 10.1 5.5 13.8z"]]
};
var faArrowAltSquareLeft = faSquareLeft;
var faFaceGrinSquint = {
  prefix: 'fad',
  iconName: 'face-grin-squint',
  icon: [512, 512, [128518, "grin-squint"], "f585", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z", "M116 157.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm280 0c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]]
};
var faGrinSquint = faFaceGrinSquint;
var faCircleEllipsisVertical = {
  prefix: 'fad',
  iconName: 'circle-ellipsis-vertical',
  icon: [512, 512, [], "e10b", ["M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M256 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faHandHoldingDollar = {
  prefix: 'fad',
  iconName: 'hand-holding-dollar',
  icon: [576, 512, ["hand-holding-usd"], "f4c0", ["M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z", "M288 0c13.3 0 24 10.7 24 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24z"]]
};
var faHandHoldingUsd = faHandHoldingDollar;
var faGridDividers = {
  prefix: 'fad',
  iconName: 'grid-dividers',
  icon: [512, 512, [], "e3ad", ["M64 96c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zm0 288c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H64zM192 128v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zm32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H224zM352 128v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H384c-17.7 0-32 14.3-32 32zm32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H384z", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 288c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]]
};
var faBacterium = {
  prefix: 'fad',
  iconName: 'bacterium',
  icon: [512, 512, [], "e05a", ["M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7l0 0-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM92.1 363.3l0 0L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]]
};
var faHandPointer = {
  prefix: 'fad',
  iconName: 'hand-pointer',
  icon: [448, 512, [], "f25a", ["M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v48 16 48c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z", "M224 288c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm80 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faDrumSteelpan = {
  prefix: 'fad',
  iconName: 'drum-steelpan',
  icon: [576, 512, [], "f56a", ["M473 209.8c47.1-19.9 55-39.9 55-49.8s-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5zM288 192c-28.9 0-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7c-8-26.2-32.4-45.3-61.2-45.3zM103 110.2C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8c-25.2 5-47.4 11.6-66 19.4zM224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8C224.5 87 224 91.5 224 96z", "M288 32c159.1 0 288 48 288 128V352c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"]]
};
var faHandScissors = {
  prefix: 'fad',
  iconName: 'hand-scissors',
  icon: [512, 512, [], "f257", ["M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9l0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z", ""]]
};
var faHandsPraying = {
  prefix: 'fad',
  iconName: 'hands-praying',
  icon: [640, 512, ["praying-hands"], "f684", ["M361.2 .7c-3.5 .8-6.9 2.1-10 4.1c-7.5 4.6-12.4 11.9-14.3 19.9c-1.1 4.6-1.2 9.4-.1 14.1c.7 3.2 1.9 6.3 3.6 9.3l86.4 151.2c3.5 6 5.3 12.9 5.3 19.8V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-17.7-14.3-32-32-32s-32 14.3-32 32V342.2c0 58 39 108.7 95 123.7l168.7 45c9.6 2.6 19.9 .5 27.7-5.5s12.5-15.4 12.5-25.4V384c0-13.8-8.8-26-21.9-30.4l-79.2-26.4c-6.5-2.2-10.9-8.3-10.9-15.2V238.5c0-15.8-4.7-31.2-13.4-44.4L394.8 14.5C390.1 7.4 383.1 2.7 375.4 .9c-4.6-1.1-9.4-1.2-14.1-.1z", "M278.8 .7c3.5 .8 6.9 2.1 10 4.1c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32V342.2c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 489.9 0 480V384c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2V238.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1z"]]
};
var faPrayingHands = faHandsPraying;
var faFacePensive = {
  prefix: 'fad',
  iconName: 'face-pensive',
  icon: [512, 512, [], "e384", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 384h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM387.2 270.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM65.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8L87.2 222.3c-7.9 4-17.5 .7-21.5-7.2zm373.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L402 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z", "M439.2 193.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L402 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4zM65.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8L87.2 222.3c-7.9 4-17.5 .7-21.5-7.2zm59.1 55.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm192 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2z"]]
};
var faUserMusic = {
  prefix: 'fad',
  iconName: 'user-music',
  icon: [640, 512, [], "f8eb", ["M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c36.3 0 70.1 10.9 98.3 29.5v51.6c-18 2.5-34.8 9.1-48.5 19.4c-17.6 13.2-31.5 34-31.5 59.5c0 19.1 7.7 35.4 18.9 48H29.7C13.3 512 0 498.7 0 482.3z", "M640 184c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-192 64c-9.8 3.3-16.4 12.4-16.4 22.8v48V417.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48V313.3l144-48v88.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.5-.1-3-.3-4.4c.2-1.2 .3-2.4 .3-3.6V232 184z"]]
};
var faArrowRotateRight = {
  prefix: 'fad',
  iconName: 'arrow-rotate-right',
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", ["M386.3 160l-17.1-17.1c-62.5-62.5-163.8-62.5-226.3 0s-62.5 163.8 0 226.3s163.8 62.5 226.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-229.3 87.5-316.8 0s-87.5-229.3 0-316.8s229.3-87.5 316.8 0L432 115.2V160H386.3z", "M496 192c0 17.7-14.3 32-32 32H336c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64c0-17.7 14.3-32 32-32s32 14.3 32 32V192z"]]
};
var faArrowRightRotate = faArrowRotateRight;
var faArrowRotateForward = faArrowRotateRight;
var faRedo = faArrowRotateRight;
var faMessagesDollar = {
  prefix: 'fad',
  iconName: 'messages-dollar',
  icon: [640, 512, ["comments-alt-dollar"], "f652", ["M64 0C28.7 0 0 28.7 0 64V256c0 35.3 28.7 64 64 64H96v48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM228 56V69.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V264c0 11-9 20-20 20s-20-9-20-20V249.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V56c0-11 9-20 20-20s20 9 20 20z", "M228 56V69.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V264c0 11-9 20-20 20s-20-9-20-20V249.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V56c0-11 9-20 20-20s20 9 20 20zm28 328V352h96c53 0 96-43 96-96V128H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H544v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320c-35.3 0-64-28.7-64-64z"]]
};
var faCommentsAltDollar = faMessagesDollar;
var faSensorOn = {
  prefix: 'fad',
  iconName: 'sensor-on',
  icon: [640, 512, [], "e02b", ["", "M604 74.7c7.4 11 4.4 25.9-6.7 33.3l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7zM512 256c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H536c-13.3 0-24-10.7-24-24zm4 122.7c7.4-11 22.3-14 33.3-6.7l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 88V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]]
};
var faBalloon = {
  prefix: 'fad',
  iconName: 'balloon',
  icon: [384, 512, [], "e2e3", ["M176 96c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16z", "M0 192C0 86 86 0 192 0S384 86 384 192c0 102.6-102.8 194.9-143.6 227.5c-9.3 7.4-12.5 20.4-7.1 31l21.4 42.7c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9H140.9c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8l21.4-42.7c5.3-10.6 2.1-23.6-7.1-31C102.8 386.9 0 294.6 0 192zm96-16c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.1 64 64 114.1 64 176c0 8.8 7.2 16 16 16s16-7.2 16-16z"]]
};
var faBiohazard = {
  prefix: 'fad',
  iconName: 'biohazard',
  icon: [576, 512, [9763], "f780", ["M122.1 146.5c2.6 16.4 7.6 32 14.6 46.4c-15.4 1.7-30.6 5.4-45.4 11.4c7.2-21 17.7-40.5 30.9-57.9zM80 267.9c21.3-4.2 43.4-3.3 64 4.1c0 55.4 31.3 103.5 77.2 127.6c-3.5 21.6-13.8 41.2-28.5 57.3C125.7 422.3 80 352.5 80 272c0-1.4 0-2.7 0-4.1zM363.9 149.6c-22-13.7-48.1-21.6-75.9-21.6s-53.9 7.9-75.9 21.6c-16.6-14.3-28-33.3-34.3-54C209.7 75.6 247.5 64 288 64s78.3 11.6 110.3 31.6c-6.3 20.8-17.7 39.7-34.3 54zm-9.1 250C400.7 375.5 432 327.4 432 272c20.6-7.3 42.7-8.3 64-4.1c0 1.3 0 2.7 0 4.1c0 80.5-45.7 150.3-112.7 184.9c-14.7-16.2-25.1-35.7-28.5-57.3zm-35.9 78.1c-10.1 1.5-20.4 2.3-30.9 2.3s-20.8-.8-30.9-2.3c11.9-9.1 22.2-19.5 30.9-31c8.7 11.4 19 21.9 30.9 31zM484.8 204.4c-14.8-6-30.1-9.8-45.4-11.4c7-14.4 11.9-30 14.6-46.4c13.2 17.4 23.6 36.9 30.9 57.9z", "M168.4 2c1.3-1.3 3-2 4.8-2c5 0 8.4 5.2 6.7 9.9C154.3 80.5 190.4 176 288 176s133.7-95.5 108.1-166.1c-1.7-4.7 1.6-9.9 6.7-9.9c1.8 0 3.5 .7 4.8 2c30 30.3 48.4 72 48.4 118c0 26.2-6 50.9-16.6 73c22 2.4 43.8 9.1 64.2 20.5c34.5 19.3 59.1 48.9 72.1 82.5c.7 1.7 .5 3.7-.5 5.2c-2.2 3.7-7.4 4.3-10.6 1.3C511.8 254.3 418 245.1 371 324s8.1 153.1 77.6 173.2c4.2 1.2 6.3 5.9 4.1 9.6c-1 1.6-2.6 2.7-4.5 3c-36.5 5.9-75.2 .1-109.7-19.2c-20.4-11.4-37.4-26.5-50.5-43.8c-13.1 17.3-30.1 32.4-50.5 43.8c-34.5 19.3-73.3 25.2-109.7 19.2c-1.9-.3-3.5-1.4-4.5-3c-2.2-3.7-.1-8.4 4.1-9.6C196.9 477.1 252 403 205 324s-140.7-69.8-193.5-21.4c-3.2 2.9-8.4 2.3-10.6-1.3c-1-1.6-1.1-3.5-.5-5.2c12.9-33.6 37.5-63.2 72.1-82.5c20.4-11.4 42.2-18.1 64.2-20.5C126 170.9 120 146.2 120 120c0-46 18.5-87.7 48.4-118zM288 320a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
};
var faChessQueenPiece = {
  prefix: 'fad',
  iconName: 'chess-queen-piece',
  icon: [256, 512, ["chess-queen-alt"], "f446", ["M208 416H48L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416z", "M152 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM67.6 192.4C56.5 194.5 48 204.2 48 216c0 12.9 10.2 23.4 23 24L48 416H208L185 240c12.8-.5 23-11.1 23-24c0-11.8-8.5-21.5-19.6-23.6l41.5-67.5c3.7-6 3-13.6-1.6-18.9s-12.1-6.9-18.6-4.1c-3 1.3-6.3 2.1-9.8 2.1c-11.8 0-21.6-8.5-23.6-19.7c-1.1-6.3-6-11.4-12.3-12.8s-12.8 1.1-16.5 6.4C143.2 84 136.1 88 128 88s-15.2-4-19.6-10.1c-3.7-5.3-10.2-7.8-16.5-6.4S80.8 78 79.6 84.3C77.6 95.5 67.8 104 56 104c-3.5 0-6.8-.7-9.8-2.1c-6.4-2.9-13.9-1.2-18.6 4.1s-5.3 13-1.6 18.9l41.5 67.5z"]]
};
var faChessQueenAlt = faChessQueenPiece;
var faLocationCrosshairs = {
  prefix: 'fad',
  iconName: 'location-crosshairs',
  icon: [512, 512, ["location"], "f601", ["M256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0z"]]
};
var faLocation = faLocationCrosshairs;
var faMarsDouble = {
  prefix: 'fad',
  iconName: 'mars-double',
  icon: [640, 512, [9891], "f227", ["M368 480c-22.6 0-44.2-4.3-64-12c18.9-14.8 35.2-32.8 48.1-53.1c5.2 .7 10.6 1.1 16 1.1c61.9 0 112-50.1 112-112c0-33.1-14.3-62.8-37.1-83.3c.9-.3 1.7-.6 2.5-1c20.9-8.7 34.6-29.1 34.6-51.7V146.7l40.4-40.4L487 73c-4.5-4.5-7-10.6-7-16.8V56l0-.2c0-3 .6-6.1 1.8-9c3.7-9 12.5-14.8 22.2-14.8H616c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L513 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176zM592 80l0 0h0v0zM176 224a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312zm88 48h0v0l0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zm320 0c0 28.3-5.7 55.4-15.9 80c44.2 0 79.9-35.8 79.9-80s-35.8-80-79.9-80c10.3 24.6 15.9 51.7 15.9 80z"]]
};
var faHousePersonLeave = {
  prefix: 'fad',
  iconName: 'house-person-leave',
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", ["M261.7 16.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S18.8 264 32 264H64V376c0 26.5 21.5 48 48 48H317.5l44-44 32.6-81.6c-14.1 6.3-30.5 7.5-46.3 2.3c-33.5-11.2-51.7-47.4-40.5-81l2.6-7.8c12.2-36.5 37-67.2 69.6-86.7L261.7 16.5zM160 192h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16z", "M480 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM446.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L601 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L567 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM388.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L388.7 398z"]]
};
var faHouseLeave = faHousePersonLeave;
var faHousePersonDepart = faHousePersonLeave;
var faRulerTriangle = {
  prefix: 'fad',
  iconName: 'ruler-triangle',
  icon: [512, 512, [128208], "f61c", ["M54.6 9.4C45.5 .2 31.7-2.5 19.8 2.4S0 19.1 0 32V448c0 35.3 28.7 64 64 64H480c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-52.7-52.7-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-57.4-57.4-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-57.4-57.4-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-57.4-57.4-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6L129.9 84.7l-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6L54.6 9.4zM128 256L256 384H128V256z", "M107.3 62.1L84.7 84.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6L107.3 62.1zm80 80l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6-22.6-22.6zm80 80l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6-22.6-22.6zm80 80l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6-22.6-22.6zm80 80l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6-22.6-22.6z"]]
};
var faCardClub = {
  prefix: 'fad',
  iconName: 'card-club',
  icon: [384, 512, [], "e3e9", ["M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM130.1 208.3C101.9 211.3 80 235.1 80 264c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8V336H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V303.2c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56c0-28.9-21.9-52.7-50.1-55.7c1.4-5.2 2.1-10.7 2.1-16.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6 .7 11.1 2.1 16.3z", "M253.9 208.3c1.4-5.2 2.1-10.7 2.1-16.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6 .7 11.1 2.1 16.3C101.9 211.3 80 235.1 80 264c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8V336H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V303.2c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56c0-28.9-21.9-52.7-50.1-55.7z"]]
};
var faChildDress = {
  prefix: 'fad',
  iconName: 'child-dress',
  icon: [320, 512, [], "e59c", ["M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64z", "M86.2 285.5L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.7-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H152v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4z"]]
};
var faUsersBetweenLines = {
  prefix: 'fad',
  iconName: 'users-between-lines',
  icon: [640, 512, [], "e591", ["M147.2 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM96 256c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96zm480 96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4H576zm-115.9 0c-10.8-30.7-36.8-54.2-68.9-61.6c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32zm39.1-128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-97.6-48a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]]
};
var faLungsVirus = {
  prefix: 'fad',
  iconName: 'lungs-virus',
  icon: [640, 512, [], "e067", ["M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V156.2c8.5-7.6 19.7-12.2 32-12.2s23.5 4.6 32 12.2V32zm32 157.5c18.6-12.4 44-10.3 60.5 6.1c18.7 18.7 18.7 49.1 0 67.9c-1.5 1.5-1.9 3.4-1.1 5.5s2.5 3.1 4.6 3.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-2.2 0-3.8 1.1-4.6 3.1s-.5 3.9 1.1 5.5c18.7 18.7 18.7 49.1 0 67.9c-10.7 10.7-25.3 15.3-39.2 13.8c12.8 15.9 30.6 27.7 51.5 32.9l72.7 18.2c7.1 1.8 14.3 2.7 21.6 2.7c49.1 0 89-39.8 89-89v-7c0-1.3-.1-2.7-.2-4c-7.2-57.9-33.1-119.4-59.6-170.3c-26.8-51.5-55.6-94.8-71-116.9c-13-18.6-34-28.8-55.8-28.8C415 96 384 127 384 165.3v24.1zM234.8 458.2c-14 1.5-28.5-3-39.2-13.8c-18.7-18.7-18.7-49.1 0-67.9c1.5-1.5 1.9-3.4 1.1-5.5s-2.5-3.1-4.6-3.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c2.2 0 3.8-1.1 4.6-3.1s.5-3.9-1.1-5.5c-18.7-18.7-18.7-49.1 0-67.9c16.4-16.4 41.8-18.5 60.5-6.1V165.3C256 127 225 96 186.7 96c-21.7 0-42.8 10.2-55.8 28.8c-15.4 22.1-44.3 65.4-71 116.9C33.4 292.6 7.5 354.2 .2 412c-.2 1.3-.2 2.6-.2 4v7c0 49.1 39.8 89 89 89c7.3 0 14.5-.9 21.6-2.7l72.7-18.2c20.9-5.2 38.7-17.1 51.5-32.9z", "M336 192c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C241.5 264.1 225 304 192 304c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C264.1 398.5 304 415 304 448c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C398.5 375.9 415 336 448 336c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C375.9 241.5 336 225 336 192zM272 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faSpinnerThird = {
  prefix: 'fad',
  iconName: 'spinner-third',
  icon: [512, 512, [], "f3f4", ["M256 64C150 64 64 150 64 256s86 192 192 192c70.1 0 131.3-37.5 164.9-93.6l.1 .1c-6.9 14.9-1.5 32.8 13 41.2c15.3 8.9 34.9 3.6 43.7-11.7c.2-.3 .4-.6 .5-.9l0 0C434.1 460.1 351.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0c-17.7 0-32 14.3-32 32s14.3 32 32 32z", "M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z"]]
};
var faFaceGrinTears = {
  prefix: 'fad',
  iconName: 'face-grin-tears',
  icon: [640, 512, [128514, "grin-tears"], "f588", ["M320 512c99.9 0 186.4-57.2 228.6-140.6c-4.5-2.9-8.7-6.3-12.7-10.3c-8.1-8.1-13.2-18.6-16.5-26.6c-3.6-8.8-6.5-18.4-8.8-27.5c-4.6-18.2-7.7-37-9.3-48.2c-3.9-26.5 18.8-49.2 45.2-45.4c6.8 .9 16.2 2.4 26.6 4.4C554.7 94.5 448.4 0 320 0S85.3 94.5 66.8 217.7c10.3-2 19.8-3.5 26.6-4.4c26.5-3.9 49.2 18.8 45.2 45.4c-1.6 11.3-4.6 30-9.3 48.2c-2.3 9.1-5.2 18.8-8.8 27.5c-3.3 8.1-8.4 18.5-16.5 26.6c-3.9 3.9-8.2 7.4-12.7 10.3C133.6 454.8 220.1 512 320 512zM452.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C446.4 390.6 388.2 432 320.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2-.4-.5-.4-.5c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z", "M281.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm184.8 41.8c-14.1-14.1-62.8-22.6-84.4-25.5c-5.4-.8-9.9 3.7-9 9c3.1 21.5 11.4 70.2 25.5 84.4c18.4 18.4 48.5 18 67.2-.7s19.1-48.8 .7-67.2zM97.9 245c-21.6 3-70.2 11.4-84.4 25.5c-18.4 18.4-18 48.5 .7 67.2s48.8 19.1 67.2 .7c14.1-14.1 22.5-62.9 25.5-84.4c.8-5.4-3.7-9.9-9-9z"]]
};
var faGrinTears = faFaceGrinTears;
var faPhone = {
  prefix: 'fad',
  iconName: 'phone',
  icon: [512, 512, [128222, 128379], "f095", ["M505.7 412.3l-8.5 31.2c-71.8-8.7-138.9-32.9-197.8-69.1l20.5-25c55.4 33.4 118.4 55.4 185.8 62.9zM99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8l-25 20.5C101.4 153.7 77.2 86.6 68.4 14.8L99.7 6.3z", "M68.4 14.8l-39 10.6C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l10.6-39C273.2 416.4 95.6 238.8 68.4 14.8zM505.7 412.3l4.9-17.8c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6l-25.1 30.7c55.4 33.4 118.4 55.4 185.8 62.9zM162.6 192.1L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2L99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8z"]]
};
var faComputerMouseScrollwheel = {
  prefix: 'fad',
  iconName: 'computer-mouse-scrollwheel',
  icon: [384, 512, ["mouse-alt"], "f8cd", ["M160 0C71.6 0 0 71.6 0 160V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V160C384 71.6 312.4 0 224 0H160zm64 128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32s32 14.3 32 32z", "M192 96c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32z"]]
};
var faMouseAlt = faComputerMouseScrollwheel;
var faCalendarXmark = {
  prefix: 'fad',
  iconName: 'calendar-xmark',
  icon: [512, 512, ["calendar-times"], "f273", ["M480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM337 305l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M160 0c-17.7 0-32 14.3-32 32V64H80c-26.5 0-48 21.5-48 48v80H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32zM337 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"]]
};
var faCalendarTimes = faCalendarXmark;
var faChildReaching = {
  prefix: 'fad',
  iconName: 'child-reaching',
  icon: [384, 512, [], "e59d", ["M128 64a64 64 0 1 1 128 0A64 64 0 1 1 128 64z", "M155.7 170.2c11.7 3.8 24 5.8 36.6 5.8c39.9 0 77.1-20.2 98.8-53.6l18.1-27.9c9.6-14.8 29.5-19 44.3-9.4s19 29.5 9.4 44.3l-18.2 27.9c-18.2 28-43.5 50-72.7 64.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H176v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V221.4C83.6 207.4 58.9 186.1 40.9 159L21.4 129.8c-9.8-14.7-5.8-34.6 8.9-44.4s34.6-5.8 44.4 8.9l19.5 29.2c14.3 21.5 35.1 37.4 58.8 45.8c.9 .3 1.8 .6 2.7 .9z"]]
};
var faTableLayout = {
  prefix: 'fad',
  iconName: 'table-layout',
  icon: [512, 512, [], "e290", ["M64 160v64l64 0V416h64V224l256 0V160H64z", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 96V416H64V96H448z"]]
};
var faNarwhal = {
  prefix: 'fad',
  iconName: 'narwhal',
  icon: [640, 512, [], "f6fe", ["M25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112l0 54.7c0 26.1 12.7 50.6 34.1 65.5L64 253.1V352c0 88.4 71.6 160 160 160H464c97.2 0 176-78.8 176-176s-79.7-176-176.9-176c-50.9 0-100.7 17.5-140.2 49.6L154.1 346.8c-10.5 8.5-26.1 1.1-26.1-12.4V253.1l29.9-20.9c21.4-15 34.1-39.4 34.1-65.5l0-54.7c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M639.3 20.7c2.4-7.8-1.4-16.1-8.9-19.4s-16.2-.4-20.2 6.6L516.7 168.3c24.6 7.8 46.9 20.9 65.6 37.8l57-185.4zM496 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faRampLoading = {
  prefix: 'fad',
  iconName: 'ramp-loading',
  icon: [448, 512, [], "f4d4", ["M32 48C32 21.5 53.5 0 80 0H368c26.5 0 48 21.5 48 48V440.4l-64-128V64H96V312.4l-64 128V48z", "M128 320H320l84.4 168.8c5.3 10.6-2.4 23.2-14.3 23.2H57.9c-11.9 0-19.6-12.5-14.3-23.2L128 320z"]]
};
var faCalendarCirclePlus = {
  prefix: 'fad',
  iconName: 'calendar-circle-plus',
  icon: [576, 512, [], "e470", ["M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32zM416 192.7c-89.7 8.1-160 83.5-160 175.3c0 59.5 29.6 112.1 74.8 144H48c-26.5 0-48-21.5-48-48V192H416v.7z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]]
};
var faToothbrush = {
  prefix: 'fad',
  iconName: 'toothbrush',
  icon: [576, 512, [129701], "f635", ["M80 280c0-13.3-10.7-24-24-24s-24 10.7-24 24V416H80V280zm80 136V280c0-13.3-10.7-24-24-24s-24 10.7-24 24V416h48zm80 0V280c0-13.3-10.7-24-24-24s-24 10.7-24 24V416h48zm80 0V280c0-13.3-10.7-24-24-24s-24 10.7-24 24V416h48zm80 0V280c0-13.3-10.7-24-24-24s-24 10.7-24 24V416h48z", "M64 224c-35.3 0-64-28.7-64-64s28.7-64 64-64H288c31.2 0 38.2-22.7 39.6-48c.5-8.8 7.6-16.1 16.4-15.2c52.4 5.3 104 36.7 104 95.2c0 53-43 96-96 96H64zM32 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]]
};
var faBorderInner = {
  prefix: 'fad',
  iconName: 'border-inner',
  icon: [448, 512, [], "f84e", ["M448 448a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 352A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM384 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 160A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM384 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 64a32 32 0 1 1 64 0A32 32 0 1 1 0 64zM64 448A32 32 0 1 1 0 448a32 32 0 1 1 64 0zM288 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm64 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z", "M192 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 0 160z"]]
};
var faPawClaws = {
  prefix: 'fad',
  iconName: 'paw-claws',
  icon: [512, 512, [], "f702", ["M178.1 15.3L138.9 58.4C121.6 77.4 112 102.3 112 128h0c-.2 11.3 1.5 23.2 5.5 35.1c14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8C226.3 100.2 210.3 81 192 71.2V20.7c0-7.3-9-10.8-13.9-5.4zm132 206.3c32.3 10.6 70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1h0c0-25.7-9.6-50.6-26.9-69.6L333.9 15.3C329 9.9 320 13.4 320 20.7V71.2c-18.3 9.8-34.3 28.9-42.5 53.6c-14.3 42.9 .3 86.2 32.6 96.8zM90.2 314.7c24.5-14 29.1-51.7 10.2-84.1C91.1 214.7 77.9 203 64 196.8V152.6c0-7.7-9.9-11-14.5-4.7L12.2 199.2C4.3 210.1 0 223.3 0 236.8V240H0c-.1 13.3 3.7 27.8 11.6 41.4c18.9 32.4 54 47.3 78.5 33.3zm331.7 0c24.5 14 59.7-.9 78.5-33.3c7.9-13.6 11.7-28.1 11.6-41.4h0v-3.2c0-13.5-4.3-26.7-12.2-37.6l-37.3-51.3c-4.6-6.3-14.5-3-14.5 4.7v44.2c-13.9 6.1-27.1 17.8-36.4 33.7c-18.9 32.4-14.3 70.1 10.2 84.1z", "M69.2 433.2C121.6 291.9 214.7 256 256 256s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 512 64 491.1 64 465.3v-1.6c0-10.4 1.6-20.8 5.2-30.5z"]]
};
var faKiwiFruit = {
  prefix: 'fad',
  iconName: 'kiwi-fruit',
  icon: [448, 512, [], "e30c", ["M224 320c123.7 0 224-64.5 224-144S347.7 32 224 32S0 96.5 0 176s100.3 144 224 144zM240 80v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zM80 160h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm256 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-96 88v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V248c0-8.8 7.2-16 16-16s16 7.2 16 16zM116.7 92.7c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16zm-153.4 128c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0zm137.4 0c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zM224 200c-30.9 0-56-10.7-56-24s25.1-24 56-24s56 10.7 56 24s-25.1 24-56 24z", "M224 64c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zM64 176c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm256 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm-96 56c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-8.8-7.2-16-16-16zM116.7 92.7c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16c-6.2-6.2-16.4-6.2-22.6 0zm192 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zm-153.4 128c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm137.4 0c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16c-6.2-6.2-16.4-6.2-22.6 0zM224 480c123.7 0 224-100.3 224-224V176c0 79.5-100.3 144-224 144S0 255.5 0 176v80C0 379.7 100.3 480 224 480z"]]
};
var faTrafficLightSlow = {
  prefix: 'fad',
  iconName: 'traffic-light-slow',
  icon: [320, 512, [], "f639", ["M160 192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]]
};
var faRectangleCode = {
  prefix: 'fad',
  iconName: 'rectangle-code',
  icon: [512, 512, [], "e322", ["M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm294.2 71.9c-8.9 9.9-8.1 25 1.8 33.9L356.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L155.9 256l60.2-54.2z", "M216.1 201.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L155.9 256l60.2-54.2zm79.9 0L356.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9z"]]
};
var faHeadSideVirus = {
  prefix: 'fad',
  iconName: 'head-side-virus',
  icon: [512, 512, [], "e064", ["M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16z", "M240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80zM176 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faKeyboardBrightness = {
  prefix: 'fad',
  iconName: 'keyboard-brightness',
  icon: [640, 512, [], "e1c0", ["M134.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 192c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96zm153.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64zM0 384c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm512 0c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H544c-17.7 0-32 14.3-32 32z", "M192 384c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32z"]]
};
var faBooksMedical = {
  prefix: 'fad',
  iconName: 'books-medical',
  icon: [576, 512, [], "f7e8", ["M96 0h64c17.7 0 32 14.3 32 32V96H64V32C64 14.3 78.3 0 96 0zM64 480V416H192v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM224 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96H224V32zm0 96H352V384H224V128zm0 288H352v64c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V416zM353.4 117.8L476.2 85l8.2 30.9L361.6 148.8l-8.2-30.9zm74.2 278.3l122.8-32.9 8.2 30.9L435.8 427l-8.2-30.9z", "M353.4 117.9l-1.4-5.2 0 15.4H224V96H352l0-75.3c2.3-1.3 4.8-2.4 7.5-3.1L420.9 1.1c16.9-4.6 34.4 5.5 38.9 22.6L476.2 85 353.4 117.9zm8.2 30.9l122.8-32.9 66 247.4L427.6 396.1l-66-247.4zM435.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L435.8 427zM192 96v32H64V96H192zM64 416V384H192v32H64zm160-32H352v32H224V384zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H128v48c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V288H16c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16H64V176z"]]
};
var faLightbulbSlash = {
  prefix: 'fad',
  iconName: 'lightbulb-slash',
  icon: [640, 512, [], "f673", ["M435.9 316.3c4.4-6.2 8.9-12.4 13.4-18.6l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C249.7 0 189.1 41.2 160.8 100.8l52.4 41.1C227.7 96.7 270 64 320 64c8.8 0 16 7.2 16 16s-7.2 16-16 16c-40 0-73.1 29.3-79 67.6L435.9 316.3zM152.4 229.8c5.4 16.8 13.2 32.4 23 46.6c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H348.1L152.4 229.8zM240 416v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-7.1L388.7 416H240z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faHouseBlank = {
  prefix: 'fad',
  iconName: 'house-blank',
  icon: [576, 512, ["home-blank"], "e487", ["M64 270.5L64.1 448c0 35.3 28.7 64 64 64H448.5c35.4 0 64.1-28.7 64-64.1l-.4-177.3L288 74.5 64 270.5z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z"]]
};
var faHomeBlank = faHouseBlank;
var faSquare5 = {
  prefix: 'fad',
  iconName: 'square-5',
  icon: [448, 512, [], "e25a", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm112 96H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H196l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z", "M152.4 147.7c2.1-11.4 12-19.7 23.6-19.7H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H196l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88z"]]
};
var faSquareHeart = {
  prefix: 'fad',
  iconName: 'square-heart',
  icon: [448, 512, [128159, "heart-square"], "f4c8", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM99.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L246.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 280.9z", "M99.9 172.9c-29.4 29.8-29.4 78.2 0 108L201.5 384.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L348.1 280.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0l-17.7 18-17.7-18c-29.4-29.8-77-29.8-106.4 0z"]]
};
var faHeartSquare = faSquareHeart;
var faPuzzle = {
  prefix: 'fad',
  iconName: 'puzzle',
  icon: [512, 512, [], "e443", ["M320 0H448c35.3 0 64 28.7 64 64V192c0 8.8-7.2 16-16 16H444c-6.6 0-12 5.4-12 12v4c0 17.7-14.3 32-32 32s-32-14.3-32-32v-4c0-6.6-5.4-12-12-12l-36 0c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-8.8 0-16-7.2-16-16V16c0-8.8 7.2-16 16-16zM224 448v64H64c-35.3 0-64-28.7-64-64V288H64c8.8 0 16-7.2 16-16V256c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 8.8 7.2 16 16 16h64v64c0 8.8-7.2 16-16 16H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c8.8 0 16 7.2 16 16z", "M0 288H64c8.8 0 16-7.2 16-16V256c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 8.8 7.2 16 16 16h64V220c0-6.6 5.4-12 12-12h4c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4c-6.6 0-12-5.4-12-12V80c0-8.8-7.2-16-16-16H64C28.7 64 0 92.7 0 128V288zm224 0v64c0 8.8-7.2 16-16 16H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c8.8 0 16 7.2 16 16v64H384c35.3 0 64-28.7 64-64V304c0-8.8-7.2-16-16-16H384c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V304c0-8.8-7.2-16-16-16H224z"]]
};
var faUserGear = {
  prefix: 'fad',
  iconName: 'user-gear',
  icon: [640, 512, ["user-cog"], "f4fe", ["M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3z", "M447.3 203.4c-6.8 1.5-11.3 7.8-11.3 14.8v17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9l0 17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8l0-17.7c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7V218.2c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7zM480 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faUserCog = faUserGear;
var faPipeCircleCheck = {
  prefix: 'fad',
  iconName: 'pipe-circle-check',
  icon: [640, 512, [], "e436", ["M64 128V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32s32 14.3 32 32zm448 0v64.7c-5.3-.5-10.6-.7-16-.7c-16.6 0-32.7 2.3-48 6.6V128c0-17.7 14.3-32 32-32s32 14.3 32 32zm-96 83.2c-57 29.1-96 88.4-96 156.8c0 5.4 .2 10.7 .7 16H96V128H416v83.2z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faArrowUp19 = {
  prefix: 'fad',
  iconName: 'arrow-up-1-9',
  icon: [576, 512, ["sort-numeric-up"], "f163", ["M464 64v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V108.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4s13.3 15.7 13.3 26zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z"]]
};
var faSortNumericUp = faArrowUp19;
var faOctagonExclamation = {
  prefix: 'fad',
  iconName: 'octagon-exclamation',
  icon: [512, 512, [], "e204", ["M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faDialLow = {
  prefix: 'fad',
  iconName: 'dial-low',
  icon: [576, 512, [], "e15d", ["M256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M129.4 311.6c11.6 77 78 136 158.2 136c88.4 0 160-71.6 160-160s-71.6-160-160-160c-80.2 0-146.6 59-158.2 136l158.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-158.2 0z"]]
};
var faDoorClosed = {
  prefix: 'fad',
  iconName: 'door-closed',
  icon: [576, 512, [128682], "f52a", ["M160 0C124.7 0 96 28.7 96 64V512H480V64c0-35.3-28.7-64-64-64H160zM384 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M384 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 480c0-17.7 14.3-32 32-32H96v64H32c-17.7 0-32-14.3-32-32zm576 0c0 17.7-14.3 32-32 32H480V448h64c17.7 0 32 14.3 32 32z"]]
};
var faLaptopMobile = {
  prefix: 'fad',
  iconName: 'laptop-mobile',
  icon: [640, 512, ["phone-laptop"], "f87a", ["M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H352V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM576 448V192H448V448H576z", "M448 192H576V448H448V192zm-16-64c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432z"]]
};
var faPhoneLaptop = faLaptopMobile;
var faConveyorBeltBoxes = {
  prefix: 'fad',
  iconName: 'conveyor-belt-boxes',
  icon: [640, 512, ["conveyor-belt-alt"], "f46f", ["M96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M96 0C78.3 0 64 14.3 64 32V224c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zM416 64c-17.7 0-32 14.3-32 32V224c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H416z"]]
};
var faConveyorBeltAlt = faConveyorBeltBoxes;
var faShieldVirus = {
  prefix: 'fad',
  iconName: 'shield-virus',
  icon: [512, 512, [], "e06c", ["M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16z", "M272 128c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C177.5 200.1 161 240 128 240c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C200.1 334.5 240 351 240 384c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C334.5 311.9 351 272 384 272c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C311.9 177.5 272 161 272 128zM208 232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faStarfighterTwinIonEngineAdvanced = {
  prefix: 'fad',
  iconName: 'starfighter-twin-ion-engine-advanced',
  icon: [640, 512, ["starfighter-alt-advanced"], "e28e", ["M171.6 196.1C164.1 214.6 160 234.8 160 256s4.1 41.4 11.6 59.9L64 294.4V217.6l107.6-21.5zM480 256c0-21.2-4.1-41.4-11.6-59.9L576 217.6v76.8L468.4 315.9c7.5-18.5 11.6-38.7 11.6-59.9z", "M148.8 7.7c-13.4-11.5-33.6-9.9-45.1 3.5l-88.3 103C5.5 125.8 0 140.6 0 155.8V356.2c0 15.3 5.5 30.1 15.4 41.7l88.3 103c11.5 13.4 31.7 15 45.1 3.5s15-31.7 3.5-45.1L64 356.2V155.8l88.3-103c11.5-13.4 9.9-33.6-3.5-45.1zM414.7 272c-2.4 14.6-8.2 28.1-16.4 39.6l-23.1-23.1c3-5.1 5.3-10.6 6.8-16.5h32.7zm-39 62.3c-11.6 8.2-25 14-39.6 16.4V318c5.9-1.5 11.4-3.8 16.5-6.8l23.1 23.1zM304 350.7c-14.6-2.4-28.1-8.2-39.6-16.4l23.1-23.1c5.1 3 10.6 5.3 16.5 6.8v32.7zm-62.3-39c-8.2-11.6-14-25-16.4-39.6H258c1.5 5.9 3.8 11.4 6.8 16.5l-23.1 23.1zM414.7 240H382c-1.5-5.9-3.8-11.4-6.8-16.5l23.1-23.1c8.2 11.6 14 25 16.4 39.6zm-39-62.3l-23.1 23.1c-5.1-3-10.6-5.3-16.5-6.8V161.3c14.6 2.4 28.1 8.2 39.6 16.4zM304 194c-5.9 1.5-11.4 3.8-16.5 6.8l-23.1-23.1c11.6-8.2 25-14 39.6-16.4V194zm-39.1 29.5c-3 5.1-5.3 10.6-6.8 16.5H225.3c2.4-14.6 8.2-28.1 16.4-39.6l23.1 23.1zM320 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm22.8-137.5l-.3 .3c-5.8 5.7-13.7 9.2-22.5 9.2c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32c0 8.8-3.5 16.7-9.2 22.5zM488.5 53.7L576 148.5V348.8L487 460c-11 13.8-8.8 33.9 5 45s33.9 8.8 45-5l89-111.2c9.1-11.3 14-25.4 14-40V148.5c0-16.1-6.1-31.6-17-43.4L535.5 10.3c-12-13-32.2-13.8-45.2-1.8s-13.8 32.2-1.8 45.2z"]]
};
var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
var faDiceSix = {
  prefix: 'fad',
  iconName: 'dice-six',
  icon: [448, 512, [9861], "f526", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faStarfighterTwinIonEngine = {
  prefix: 'fad',
  iconName: 'starfighter-twin-ion-engine',
  icon: [576, 512, ["starfighter-alt"], "e038", ["M139.6 196.1C132.1 214.6 128 234.8 128 256s4.1 41.4 11.6 59.9L64 300.8V211.2l75.6-15.1zM436.4 315.9c7.5-18.5 11.6-38.7 11.6-59.9s-4.1-41.4-11.6-59.9L512 211.2v89.6l-75.6 15.1z", "M32 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm512 0c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM272 350.7V318c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39l23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5H193.3c2.4 14.6 8.2 28.1 16.4 39.6zM193.3 240H226c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3l23.1 23.1c5.1-3 10.6-5.3 16.5-6.8V161.3c-14.6 2.4-28.1 8.2-39.6 16.4zM343.6 334.3l-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8v32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6H350c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM350 240h32.7c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4V194c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zM128 256a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zm182.8 22.5c5.7-5.8 9.2-13.7 9.2-22.5c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z"]]
};
var faStarfighterAlt = faStarfighterTwinIonEngine;
var faRocketLaunch = {
  prefix: 'fad',
  iconName: 'rocket-launch',
  icon: [512, 512, [128640], "e027", ["M118.5 288H24c-8.7 0-16.7-4.7-20.9-12.2s-4.1-16.8 .4-24.2l52.8-86.9C69.3 143.2 92.6 130 117.8 130h80.8c-28.5 45.8-60.7 114.5-80.1 158zM382 313.4v80.8c0 25.2-13.1 48.5-34.6 61.5l-86.9 52.8c-7.4 4.5-16.7 4.7-24.2 .4s-12.2-12.2-12.2-20.9l0-96.2c43.9-19.1 112.4-50.3 158-78.4zM166.5 470C132.3 504.3 66 511 28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5zm-46.7-36.4c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3c-.5 8 5.9 14.3 13.9 13.9c12.8-.7 31.2-3.7 41.3-13.7z", "M223.7 391.9c-4-56-49.1-100.6-105.3-103.8c21.4-47.9 58.4-126.6 88.8-171.5C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-44.7 30.3-123.1 66.2-171.6 87.2zM424 128a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"]]
};
var faMosquitoNet = {
  prefix: 'fad',
  iconName: 'mosquito-net',
  icon: [640, 512, [], "e52c", ["M161.7 440.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c1.1-2.2 1.7-4.7 1.7-7.2l0-41.4 32-32v50c0 17.7 14.3 32 32 32s32-14.3 32-32v-50l42.9 42.9c3-3.7 6.6-6.9 10.6-9.5c-12.9-8.6-21.5-23.3-21.5-40c0-2.1 .1-4.2 .4-6.2L320 265.4V242.2l40.2 35c6.1-9.1 15.2-15.9 25.9-19.2c6-19.7 24.3-34.1 45.9-34.1c16.7 0 31.4 8.5 40 21.5c8.6-12.9 23.3-21.5 40-21.5s31.4 8.5 40 21.5c2.1-3.1 4.5-6 7.3-8.6c-12.9-16.9-32.2-28.6-54.7-31.4L344.7 181.6l49.6-41.3c5.1-4.2 7-11.1 4.9-17.4L385.3 81.2l29-58.1c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-32 64c-1.9 3.8-2.2 8.2-.9 12.2l12.5 37.6L320 160.5V137.9c0-14.9-10.1-27.3-23.8-31V63.7c0-4.5-3.7-8.2-8.2-8.2s-8.2 3.7-8.2 8.2V107c-13.7 3.6-23.8 16.1-23.8 31v22.6l-45.4-37.8 12.5-37.6c1.3-4 1-8.4-.9-12.2l-32-64c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l29 58.1-13.9 41.7c-2.1 6.2-.1 13.1 4.9 17.4l49.6 41.3L71.4 205.5C30.6 210.6 0 245.2 0 286.3c0 72.6 87.8 109 139.2 57.6L256 242.2v23.1l-59.3 59.3c-3 3-4.7 7.1-4.7 11.3l0 44.2-30.3 60.6z", "M528 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H448V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16l0 48H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16l0 48H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V480h48v16c0 8.8 7.2 16 16 16s16-7.2 16-16V480h48v16c0 8.8 7.2 16 16 16s16-7.2 16-16V480h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V400h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V320h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H528V272zm48 48v48H528V320h48zm0 80v48H528V400h48zM448 368V320h48v48H448zm0 80V400h48v48H448z"]]
};
var faVentDamper = {
  prefix: 'fad',
  iconName: 'vent-damper',
  icon: [640, 512, [], "e465", ["M64 160H32c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32H64V160zM576 352h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H576V352z", "M128 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H128zm56 80H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 88H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 88H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faBridgeWater = {
  prefix: 'fad',
  iconName: 'bridge-water',
  icon: [576, 512, [], "e4ce", ["M269.5 389.9c11.1-7.9 25.9-7.9 37 0C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1z", "M32 64C14.3 64 0 78.3 0 96v35.6C0 147.3 12.7 160 28.4 160C65.8 160 96 190.2 96 227.6V352.5c12.9 0 25.8 3.9 36.9 11.7c18 12.4 40.1 20.3 59.1 20.3c0-.2 0-.3 0-.5V256c0-53 43-96 96-96s96 43 96 96V384c0 .2 0 .3 0 .5c0 0 0 0 0 0c19 0 41.2-7.9 59.2-20.3c11.1-7.8 24-11.7 36.8-11.7V227.6c0-37.3 30.2-67.6 67.6-67.6c15.7 0 28.4-12.7 28.4-28.4V96c0-17.7-14.3-32-32-32H32z"]]
};
var faBanBug = {
  prefix: 'fad',
  iconName: 'ban-bug',
  icon: [512, 512, ["debug"], "f7f9", ["M345 299.7l19.9 4c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7V246.7l35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-22-5.5L307.8 163c-14-11.9-32.1-19-51.8-19c-18.7 0-35.9 6.4-49.6 17.2L345 299.7zm-39.4 51.1L176 221.3c0 .9 0 1.8 0 2.7v41.3l-35.1 7c-8.7 1.7-14.3 10.2-12.6 18.8s10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5L204.2 349c14 11.9 32.1 19 51.8 19c18.7 0 35.9-6.4 49.6-17.2z", "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]]
};
var faDebug = faBanBug;
var faPersonBooth = {
  prefix: 'fad',
  iconName: 'person-booth',
  icon: [576, 512, [], "f756", ["M224 0c17.7 0 32 14.3 32 32V192H192V32c0-17.7 14.3-32 32-32zM544 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM192 480V320h64l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32zM295.8 11C301.9 4 310.7 0 320 0H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32c0 17.7-14.3 32-32 32c-16.8 0-30.6-12.9-31.9-29.4l-.7 3.6c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7l30.9-154.6L288.3 36.5C287 27.3 289.7 18 295.8 11z", "M64 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm48 237.3v72.1l38.4 51.2c6.2 8.3 9.6 18.4 9.6 28.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V426.7L64 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.3l0-.9V221.6c0-34 27.6-61.6 61.6-61.6c20.3 0 39.7 8.1 54 22.4L157.3 224H224c17.7 0 32 14.3 32 32s-14.3 32-32 32H150.6c-12.7 0-24.9-5.1-33.9-14.1l-4.7-4.7z"]]
};
var faTextWidth = {
  prefix: 'fad',
  iconName: 'text-width',
  icon: [448, 512, [], "f035", ["M64 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V80C0 53.5 21.5 32 48 32H224 400c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H256l0 128h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16l0-128H64z", "M9.4 406.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32H320V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H128v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64z"]]
};
var faGarageCar = {
  prefix: 'fad',
  iconName: 'garage-car',
  icon: [640, 512, [], "e00a", ["M261.8 288H378.2c3.4 0 6.4 2.2 7.6 5.4L397.8 328H242.2l12.1-34.6c1.1-3.2 4.2-5.4 7.6-5.4zM209 277.5L188.9 335c-17.2 9.5-28.9 27.9-28.9 49v96c0 17.7 14.3 32 32 32s32-14.3 32-32V464H416v16c0 17.7 14.3 32 32 32s32-14.3 32-32V384c0-21.1-11.7-39.5-28.9-49L431 277.5C423.2 255.1 402 240 378.2 240H261.8c-23.8 0-45 15.1-52.9 37.5zM216 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3z"]]
};
var faSquareKanban = {
  prefix: 'fad',
  iconName: 'square-kanban',
  icon: [448, 512, [], "e488", ["M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zm64-160c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V288c0 17.7 14.3 32 32 32zm160 32c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V352zm-64-96c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32z", "M288 352c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V352zM96 288c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V288zm128-32c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32z"]]
};
var faHatWizard = {
  prefix: 'fad',
  iconName: 'hat-wizard',
  icon: [512, 512, [], "f6e8", ["M272 136c-3.4 0-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2c-1.1-3.3-4.1-5.5-7.6-5.5zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z", "M168.5 180.1L48 448H464L355.5 207.7c-2.3-5.1-3.5-10.6-3.5-16.1c0-5 1-9.9 2.8-14.6L414.6 27.6c1-2.4 1.4-4.9 1.4-7.5V18.6C416 8.3 407.7 0 397.4 0c-3.5 0-7 1-10 2.9L240.1 97.2c-31.4 20.1-56.3 48.9-71.6 82.9zm70.6 86.8l13.5 40.4 40.4 13.5c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-40.4 13.5-13.5 40.4C237 411.6 230.9 416 224 416s-13-4.4-15.2-10.9l-13.5-40.4-40.4-13.5C148.4 349 144 342.9 144 336s4.4-13 10.9-15.2l40.4-13.5 13.5-40.4c2.2-6.5 8.3-10.9 15.2-10.9s13 4.4 15.2 10.9zM272 136c3.4 0 6.5 2.2 7.6 5.5l6.7 20.2 20.2 6.7c3.3 1.1 5.5 4.1 5.5 7.6s-2.2 6.5-5.5 7.6l-20.2 6.7-6.7 20.2c-1.1 3.3-4.1 5.5-7.6 5.5s-6.5-2.2-7.6-5.5l-6.7-20.2-20.2-6.7c-3.3-1.1-5.5-4.1-5.5-7.6s2.2-6.5 5.5-7.6l20.2-6.7 6.7-20.2c1.1-3.3 4.1-5.5 7.6-5.5z"]]
};
var faPenFancy = {
  prefix: 'fad',
  iconName: 'pen-fancy',
  icon: [512, 512, [128395, 10002], "f5ac", ["M174.1 256l-1.7 .4L77.7 278.3c-11.4 2.6-20.5 11.3-23.6 22.6L1.7 487.7l95.4-95.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1L24.4 510.3 211.2 458c11.3-3.2 19.9-12.2 22.6-23.6l21.9-94.7 .4-1.7 0 0 0 0L174.1 256zM512 79.3c0-.1 0-.2 0-.4s0-.2 0-.4v.7z", "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L256 337.9l0 0v0L174.1 256 373.5 27.1z"]]
};
var faCoffeePot = {
  prefix: 'fad',
  iconName: 'coffee-pot',
  icon: [512, 512, [], "e002", ["M160.4 176C103.4 202.9 64 260.8 64 328v16c0 55.5 34.6 99.4 55.9 121.2c9.9 10.2 23.9 14.8 38.1 14.8H418c14.2 0 28.1-4.7 38.1-14.8C477.4 443.4 512 399.5 512 344V328c0-67.2-39.4-125.1-96.4-152H160.4zM448 328v16c0 27.4-16.8 53.7-33.5 72H161.5c-16.7-18.3-33.5-44.6-33.5-72V328c0-57.4 46.6-104 104-104H344c57.4 0 104 46.6 104 104z", "M96 96c-17.7 0-32 14.3-32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128C0 75 43 32 96 32h25.3H192 454.7c14 0 25.3 11.3 25.3 25.3c0 4.4-1.1 8.7-3.3 12.5L416 176H160L114.3 96H96zM448 344c0 27.4-16.8 53.7-33.5 72H161.5c-16.7-18.3-33.5-44.6-33.5-72V328c0-2.7 .1-5.4 .3-8H447.7c.2 2.6 .3 5.3 .3 8v16z"]]
};
var faMouseField = {
  prefix: 'fad',
  iconName: 'mouse-field',
  icon: [512, 512, [], "e5a8", ["M272 88c0-22.1 17.9-40 40-40s40 17.9 40 40v24c0 8.8-7.2 16-16 16H312c-22.1 0-40-17.9-40-40z", "M396.4 112.9C398.8 105 400 96.6 400 88c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 29.9 14.9 56.3 37.6 72.2C169.5 164.3 96 240.4 96 333.6c0 12.3 2.7 24 7.5 34.4H72c-39.8 0-72 32.2-72 72s32.2 72 72 72H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24H178.4 232h8 19H382.6c18.5 0 33.4-15 33.4-33.4c0-14.1-8.8-26.6-22-31.4l-43.7-15.9 23.8-63.5c2 .1 4 .2 6 .2H482.9c16.1 0 29.1-13 29.1-29.1c0-41.5-19.3-78.4-49.4-102.4C473.5 125.8 480 107.7 480 88c0-46.4-35.9-84.4-81.4-87.8C419.2 20.6 432 48.8 432 80c0 13.9-2.5 27.2-7.2 39.5c-9.1-3.2-18.6-5.5-28.4-6.6zM400 196a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM312 48c22.1 0 40 17.9 40 40v24c0 8.8-7.2 16-16 16H312c-22.1 0-40-17.9-40-40s17.9-40 40-40z"]]
};
var faPersonDigging = {
  prefix: 'fad',
  iconName: 'person-digging',
  icon: [576, 512, ["digging"], "f85e", ["M9.8 214.8c5.1-12.2 19.1-18 31.4-12.9l347 144.6 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4z", "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM60.6 292.9l32 13.7 112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33zm.1-82.9l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7L60.7 210z"]]
};
var faDigging = faPersonDigging;
var faShowerDown = {
  prefix: 'fad',
  iconName: 'shower-down',
  icon: [384, 512, ["shower-alt"], "e24d", ["M52.8 295.4L34.7 337.7c-1.8 4.1-2.7 8.6-2.7 13.1V352c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.2c0-4.5-.9-8.9-2.7-13.1L75.2 295.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4zm109.8 42.4c-1.8 4.1-2.7 8.6-2.7 13.1V352c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4l-18.2 42.4zm64 128c-1.8 4.1-2.7 8.6-2.7 13.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4l-18.2 42.4zm82.2-170.4l-18.2 42.4c-1.8 4.1-2.7 8.6-2.7 13.1V352c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4zM98.7 465.7c-1.8 4.1-2.7 8.6-2.7 13.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4L98.7 465.7z", "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v3.2C87 50 32 114.6 32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-77.4-55-142-128-156.8V32z"]]
};
var faShowerAlt = faShowerDown;
var faBoxCircleCheck = {
  prefix: 'fad',
  iconName: 'box-circle-check',
  icon: [576, 512, [], "e0c4", ["M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H416h32L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm176 32H0V416c0 35.3 28.7 64 64 64H296.2C271.1 449.6 256 410.5 256 368c0-91.8 70.3-167.2 160-175.3V192z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faBrightness = {
  prefix: 'fad',
  iconName: 'brightness',
  icon: [512, 512, [], "e0c9", ["M224 80c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V80zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H80c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H432zM256 512c17.7 0 32-14.3 32-32V432c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zM73.4 438.6c12.5 12.5 32.8 12.5 45.3 0l32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32c-12.5 12.5-12.5 32.8 0 45.3zm288-333.3c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32zm77.3 333.3c12.5-12.5 12.5-32.8 0-45.3l-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0zm-333.3-288c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32z", "M160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]]
};
var faCarSideBolt = {
  prefix: 'fad',
  iconName: 'car-side-bolt',
  icon: [640, 512, [], "e344", ["M347.2 116.6c5.3 5.2 6.3 13.3 2.5 19.6L316.3 192H368c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L259.7 224H208c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2zM64 432a80 80 0 1 1 160 0A80 80 0 1 1 64 432zm352 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M528.2 225l-100-125c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 228.4C16.8 237.8 0 260.9 0 288V400c0 17.7 14.3 32 32 32c0-61.9 50.1-112 112-112s112 50.1 112 112H384c0-61.9 50.1-112 112-112s112 50.1 112 112c17.7 0 32-14.3 32-32V352c0-65.2-48.8-119-111.8-127zm-181-108.4c5.3 5.2 6.3 13.3 2.5 19.6L316.3 192H368c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L259.7 224H208c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z"]]
};
var faOrnament = {
  prefix: 'fad',
  iconName: 'ornament',
  icon: [384, 512, [], "f7b8", ["M192 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-32c0 11.7-3.1 22.6-8.6 32H192 136.6c-5.4-9.4-8.6-20.3-8.6-32c0-35.3 28.7-64 64-64s64 28.7 64 64zM384 320c0 22.4-3.8 44-10.9 64H10.9C3.8 364 0 342.4 0 320s3.8-44 10.9-64H373.1c7.1 20 10.9 41.6 10.9 64z", "M96 128c0-17.7 14.3-32 32-32H256c17.7 0 32 14.3 32 32v25.7c39.3 22.7 69.7 58.9 85.1 102.3H10.9C26.3 212.6 56.7 176.4 96 153.7V128zM10.9 384H373.1C346.7 458.6 275.6 512 192 512s-154.7-53.4-181.1-128z"]]
};
var faPhoneArrowDownLeft = {
  prefix: 'fad',
  iconName: 'phone-arrow-down-left',
  icon: [512, 512, ["phone-arrow-down", "phone-incoming"], "e223", ["M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z", "M505 7c9.4 9.4 9.4 24.6 0 33.9l-135 135H416c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24v46.1L471 7c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faPhoneArrowDown = faPhoneArrowDownLeft;
var faPhoneIncoming = faPhoneArrowDownLeft;
var faCloudWord = {
  prefix: 'fad',
  iconName: 'cloud-word',
  icon: [640, 512, [], "e138", ["M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm512 32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16zM240 352c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96zM128 304c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm272-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M128 304c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm112 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96zm256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H496zm-96-64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faHandFingersCrossed = {
  prefix: 'fad',
  iconName: 'hand-fingers-crossed',
  icon: [384, 512, [], "e1a3", ["M110.3 55.6L93 18.5C85.5 2.5 66.5-4.5 50.5 3S27.5 29.5 35 45.5l40 85.8 35.3-75.7zM150.6 272l0 0H115.3l0 0H80l0 0H64c-35.3 0-64 28.7-64 64v27c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9H224c88.4 0 160-71.6 160-160v-8.6c-9.4 5.4-20.3 8.6-32 8.6c-27.9 0-51.7-17.9-60.4-42.8C281.4 316 269.2 320 256 320c-11.7 0-22.6-3.1-32-8.6c0 .2 0 .4 0 .6c0 39.8-32.2 72-72 72H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c22.1 0 40-17.9 40-40s-17.9-40-40-40h-1.4zM192 230.6L181 207l-16 34.2c9.8 1.8 19 5.6 27 11V230.6zM59.6 240h70.6L221 45.5c7.5-16 .5-35.1-15.5-42.5s-35.1-.5-42.5 15.5L59.6 240z", "M256 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32zm96 32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32z"]]
};
var faTrash = {
  prefix: 'fad',
  iconName: 'trash',
  icon: [448, 512, [], "f1f8", ["M394.6 466.8L416 96H32L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2H346.7c25.4 0 46.5-19.8 47.9-45.2z", "M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8z"]]
};
var faGaugeSimple = {
  prefix: 'fad',
  iconName: 'gauge-simple',
  icon: [512, 512, ["gauge-simple-med", "tachometer-average"], "f629", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z", "M280 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V88z"]]
};
var faGaugeSimpleMed = faGaugeSimple;
var faTachometerAverage = faGaugeSimple;
var faArrowDownSmallBig = {
  prefix: 'fad',
  iconName: 'arrow-down-small-big',
  icon: [576, 512, ["sort-size-down-alt"], "f88d", ["M368 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368zm0 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H368z", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z"]]
};
var faSortSizeDownAlt = faArrowDownSmallBig;
var faBookMedical = {
  prefix: 'fad',
  iconName: 'book-medical',
  icon: [448, 512, [], "f7e6", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 256 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H256h96 64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zM208 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272v48c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V224H160c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48V112z"]]
};
var faFaceMelting = {
  prefix: 'fad',
  iconName: 'face-melting',
  icon: [640, 512, [129760], "e483", ["M571.4 304.8c-4.5 23.2 11.8 47.2 35.4 47.2H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H44.9c36.8 0 58.4-50.7 42.9-84.1C72.5 331.1 64 294.5 64 256C64 114.6 178.6 0 320 0S576 114.6 576 256c0 16.7-1.6 33-4.6 48.8zM247.2 219.9a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8zM441 238.7a32 32 0 1 0 -61.8-16.6A32 32 0 1 0 441 238.7zM213.2 299.4c-3.9-7.9-13.4-11.3-21.4-7.4s-11.3 13.4-7.4 21.4c14.8 30.5 45.1 67.5 98.3 81.7s97.9-2.6 126-21.7c7.3-5 9.2-14.9 4.3-22.2s-14.9-9.2-22.2-4.3c-22.7 15.4-57.9 28.5-99.8 17.2s-65.8-40.2-77.8-64.8z", "M247.2 219.9a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8zm154.6 41.4a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8z"]]
};
var faPoo = {
  prefix: 'fad',
  iconName: 'poo',
  icon: [512, 512, [128169], "f2fe", ["M192 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72H394.3c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3H339.7c6.8 0 12.3 5.5 12.3 12.3z"]]
};
var faPenClipSlash = {
  prefix: 'fad',
  iconName: 'pen-clip-slash',
  icon: [640, 512, ["pen-alt-slash"], "e20f", ["M195.8 250.3L341.2 364.8l-47.7 47.7c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8l32.3-32.3zm68.5-68.5L318.1 128 305 114.9c-9.4-9.4-24.6-9.4-33.9 0l-40.5 40.5-38.1-29.8L237.1 81c28.1-28.1 73.7-28.1 101.8 0L352 94.1l17 17 96 96 16 16 1 1-17 17-55 55L264.2 181.8zM426.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1 0 0-1-1 0 0-16-16-96-96-17-17 52.1-52.1z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faPenAltSlash = faPenClipSlash;
var faQuoteRight = {
  prefix: 'fad',
  iconName: 'quote-right',
  icon: [448, 512, [8221, "quote-right-alt"], "f10e", ["M72 416c66.3 0 120-53.7 120-120V224 192 160c0-35.3-28.7-64-64-64H64C28.7 96 0 124.7 0 160v64c0 35.3 28.7 64 64 64h64v8c0 30.9-25.1 56-56 56H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h8z", "M328 416c66.3 0 120-53.7 120-120V224 192 160c0-35.3-28.7-64-64-64H320c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h64v8c0 30.9-25.1 56-56 56h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8z"]]
};
var faQuoteRightAlt = faQuoteRight;
var faScrollOld = {
  prefix: 'fad',
  iconName: 'scroll-old',
  icon: [576, 512, [], "f70f", ["M128 96v88 1.4c0 4.2 1.7 8.3 4.7 11.3l21.7 21.7c3.1 3.1 3.1 8.2 0 11.3l-21.7 21.7c-3 3-4.7 7.1-4.7 11.3V264 400c0 44.2 35.8 80 80 80s80-35.8 80-80V384c0-17.7 14.3-32 32-32h24 1.4c4.2 0 8.3 1.7 11.3 4.7l21.7 21.7c3.1 3.1 8.2 3.1 11.3 0l21.7-21.7c3-3 7.1-4.7 11.3-4.7H424h56V296v-1.4c0-4.2-1.7-8.3-4.7-11.3l-21.7-21.7c-3.1-3.1-3.1-8.2 0-11.3l21.7-21.7c3-3 4.7-7.1 4.7-11.3V216 200v-1.4c0-4.2-1.7-8.3-4.7-11.3l-21.7-21.7c-3.1-3.1-3.1-8.2 0-11.3l21.7-21.7c3-3 4.7-7.1 4.7-11.3V120 96c0-35.3-28.7-64-64-64H64c35.3 0 64 28.7 64 64z", "M32 160h96V96c0-35.3-28.7-64-64-64S0 60.7 0 96v32c0 17.7 14.3 32 32 32zM288 384v16c0 44.2-35.8 80-80 80H480c53 0 96-43 96-96c0-17.7-14.3-32-32-32H424h-1.4c-4.2 0-8.3 1.7-11.3 4.7l-21.7 21.7c-3.1 3.1-8.2 3.1-11.3 0l-21.7-21.7c-3-3-7.1-4.7-11.3-4.7H344 320c-17.7 0-32 14.3-32 32z"]]
};
var faGuitars = {
  prefix: 'fad',
  iconName: 'guitars',
  icon: [512, 512, [], "f8bf", ["M472 304c0 33.5 17 70.9 28.8 92.9c6.9 12.7 11.2 26.9 11.2 41.3c0 40.8-33 73.8-73.8 73.8H329.8C289 512 256 479 256 438.2c0-14.5 4.3-28.6 11.2-41.3C279 374.9 296 337.5 296 304c0-11.2-2-20.5-4.5-27.8c-.9-2.5-1.8-5-2.7-7.5c-4.3-11.8-8.8-23.8-8.8-36.2V192c0-8.8 7.2-16 16-16s16.1 7.2 18.2 15.8c4.5 19 18.6 48.2 61.8 48.2h16c39.7 0 54.8-18.5 60.5-32.5c3.3-8.2 10.7-15.5 19.5-15.5s16 7.2 16 16v29.3c0 11.6-4.8 22.8-9.3 33.5l-.5 1.1c-3.3 7.8-6.2 18.5-6.2 32.1zM336 320c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zM231.2 346.5c5.9 6.5 10.9 13.7 14.8 21.3c-2.3 4.9-4.7 9.6-7 13.9c-8.8 16.3-15 35.6-15 56.5c0 11.6 1.9 22.8 5.4 33.3C205.9 496.1 169.3 512 128 512C57.3 512 0 465.4 0 408c0-23 9.2-44.3 24.8-61.5c10.3-11.4 11.1-30.4 2.9-43.4C20.2 291.3 16 278 16 264c0-42.1 37.7-77.3 88-86v94c-9.7 7.3-16 18.9-16 32c0 22.1 17.9 40 40 40s40-17.9 40-40c0-13.1-6.3-24.7-16-32V178c50.3 8.6 88 43.8 88 86c0 14-4.2 27.3-11.6 39.1c-8.2 13-7.5 32 2.9 43.4z", "M80 24C80 10.7 90.7 0 104 0h48c13.3 0 24 10.7 24 24V76.2c0 6.2-1.4 12.3-4.2 17.9L152 133.7V272c-6.7-5-15-8-24-8s-17.3 3-24 8V133.7L84.2 94.1C81.4 88.6 80 82.4 80 76.2V24zM338.6 124.1c-6.7-7.6-9.3-17.9-7.2-27.8l13.9-64.8C349.2 13.1 365.4 0 384.2 0c22 0 39.8 17.8 39.8 39.8v4.6c0 12.4-6.4 23.3-16 29.7V238.9c-4.8 .7-10.1 1.1-16 1.1H376c-5.9 0-11.2-.5-16-1.5V148.6l-21.4-24.5zM352 304h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faPhoneXmark = {
  prefix: 'fad',
  iconName: 'phone-xmark',
  icon: [640, 512, [], "e227", ["M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 247.4 200.6 448 448 448c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368C298.3 334.7 241.3 277.7 208 207.3L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z", "M433 15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47L433 15z"]]
};
var faHose = {
  prefix: 'fad',
  iconName: 'hose',
  icon: [448, 512, [], "e419", ["M64 176c0-44.2 35.8-80 80-80H288V32H144C64.5 32 0 96.5 0 176s64.5 144 144 144H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-44.2 0-80-35.8-80-80zM32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z", "M312 128c-13.3 0-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24v2.3l80.2 11.5C417.3 30 423.9 24 432 24c8.8 0 16 7.2 16 16V88c0 8.8-7.2 16-16 16c-8.1 0-14.7-6-15.8-13.7L336 101.7V104c0 13.3-10.7 24-24 24z"]]
};
var faClockSix = {
  prefix: 'fad',
  iconName: 'clock-six',
  icon: [512, 512, [], "e352", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M256 96c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24z"]]
};
var faShirt = {
  prefix: 'fad',
  iconName: 'shirt',
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", ["M320 112c61.9 0 112-50.1 112-112h8.8c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0H208c0 61.9 50.1 112 112 112z", "M208 0c0 61.9 50.1 112 112 112s112-50.1 112-112H400c0 44.2-35.8 80-80 80s-80-35.8-80-80H208z"]]
};
var faTShirt = faShirt;
var faTshirt = faShirt;
var faBillboard = {
  prefix: 'fad',
  iconName: 'billboard',
  icon: [640, 512, [], "e5cd", ["M224 0c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32s-14.3 32-32 32H224 192c-17.7 0-32-14.3-32-32s14.3-32 32-32V32c0-17.7 14.3-32 32-32zM416 0c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32s-14.3 32-32 32H416 384c-17.7 0-32-14.3-32-32s14.3-32 32-32V32c0-17.7 14.3-32 32-32zM288 416h64v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416z", "M192 32H80C53.5 32 32 53.5 32 80V352c-17.7 0-32 14.3-32 32s14.3 32 32 32H80 560h48c17.7 0 32-14.3 32-32s-14.3-32-32-32V80c0-26.5-21.5-48-48-48H448V96h96V352H96V96h96V32zm64 64H384V32H256V96z"]]
};
var faSquareR = {
  prefix: 'fad',
  iconName: 'square-r',
  icon: [448, 512, [], "e27c", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H256c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288H176v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24zm80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H176v64h56z", "M128 152c0-13.3 10.7-24 24-24H256c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288H176v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h56 24c17.7 0 32-14.3 32-32s-14.3-32-32-32H176v64z"]]
};
var faCubes = {
  prefix: 'fad',
  iconName: 'cubes',
  icon: [576, 512, [], "f1b3", ["M184 121v89.6l80 30.3V151.7L184 121zm208 89.6V121l-80 30.7v89.2l80-30.3zM256 323.2l-80 30.7V454.3l80-35.2V323.2zm-208 0v90.7c0 3.2 1.9 6 4.8 7.3L128 454.3V353.9L48 323.2zm400 30.7V454.3l75.2-33.1c2.9-1.3 4.8-4.2 4.8-7.3V323.2l-80 30.7zM400 454.3V353.9l-80-30.7v95.9l80 35.2z", "M290.8 48.6c-1.8-.7-3.8-.7-5.7 0L206.8 78.4 288 109.5l81.2-31.1L290.8 48.6zM184 210.6l80 30.3V151.7L184 121v89.6zm128 30.3l80-30.3V121l-80 30.7v89.2zM288 457.5L174.5 507.4c-14.4 6.3-30.7 6.3-45.1 0l-96-42.2C13.1 456.2 0 436.1 0 413.9V294.7c0-23.3 14.4-44.1 36.1-52.4l96-36.4c1.3-.5 2.6-.9 3.9-1.3V92.5c0-23.3 14.4-44.1 36.1-52.4l96-36.4c12.8-4.8 26.9-4.8 39.7 0l96 36.4C425.6 48.4 440 69.3 440 92.5V204.7c1.3 .4 2.6 .8 3.9 1.3l96 36.4c21.8 8.2 36.1 29.1 36.1 52.4V413.9c0 22.2-13.1 42.3-33.5 51.3l-96 42.2c-14.4 6.3-30.7 6.3-45.1 0L288 457.5zM149.2 250.9L70.8 280.6 152 311.7l81.2-31.1-78.4-29.7c-1.8-.7-3.8-.7-5.7 0zm26.8 103V454.3l80-35.2V323.2l-80 30.7zm-48 0L48 323.2v90.7c0 3.2 1.9 6 4.8 7.3L128 454.3V353.9zm293.2-103l-78.4 29.7L424 311.7l81.2-31.1-78.4-29.7c-1.8-.7-3.8-.7-5.7 0zM448 454.3l75.2-33.1c2.9-1.3 4.8-4.2 4.8-7.3V323.2l-80 30.7V454.3zM400 353.9l-80-30.7v95.9l80 35.2V353.9z"]]
};
var faEnvelopeOpenDollar = {
  prefix: 'fad',
  iconName: 'envelope-open-dollar',
  icon: [512, 512, [], "f657", ["M96 32C78.3 32 64 46.3 64 64V249.7L236.7 377.6c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4L448 249.7V64c0-17.7-14.3-32-32-32H96zm180 72v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V312c0 11-9 20-20 20s-20-9-20-20V297.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V104c0-11 9-20 20-20s20 9 20 20z", "M511.8 202.5c-1.6-18.1-10.9-34.9-25.7-45.8L448 128.5v79.6 41.6l63.8-47.2zM512 448V242.1L294.4 403.3C283.3 411.6 269.8 416 256 416s-27.3-4.4-38.4-12.7L0 242.1V448v0c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64v0zM64 249.7V208.1l0-79.6L25.9 156.7C11.1 167.6 1.8 184.4 .2 202.5L64 249.7zM289.5 11.1C279.8 3.9 268.1 0 256 0s-23.8 3.9-33.5 11L194.2 32H317.8L289.5 11.1zM276 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"]]
};
var faDivide = {
  prefix: 'fad',
  iconName: 'divide',
  icon: [448, 512, [10135, 247], "f529", ["M432 256c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z", "M224 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 320a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
};
var faSunCloud = {
  prefix: 'fad',
  iconName: 'sun-cloud',
  icon: [640, 512, [127780], "f763", ["M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.4-51c-42.1-1.5-77.4-30.2-88.7-69c-11.4 3.3-23.4 5.1-35.8 5.1c-70.7 0-128-57.3-128-128s57.3-128 128-128c61.3 0 112.6 43.1 125.1 100.7c20.5-22.5 50-36.7 82.9-36.7c8.6 0 17 1 25.1 2.8l20.1-29.1c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zm-83 333.4c2.2-39.3 28.1-72.3 63.7-85c.1-1.8 .2-3.7 .2-5.5c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c11.3 0 22.1-1.9 32.2-5.5z", "M320 352c0 35.3 28.7 64 64 64H568c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64z"]]
};
var faLampFloor = {
  prefix: 'fad',
  iconName: 'lamp-floor',
  icon: [640, 512, [], "e015", ["M352 224H288V448h64V224z", "M194.3 20.1C199.1 8 210.9 0 224 0H416c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1H160c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM224 448h96 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]]
};
var faSquare7 = {
  prefix: 'fad',
  iconName: 'square-7',
  icon: [448, 512, [], "e25c", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H296c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M128 152c0-13.3 10.7-24 24-24H296c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H152c-13.3 0-24-10.7-24-24z"]]
};
var faTengeSign = {
  prefix: 'fad',
  iconName: 'tenge-sign',
  icon: [384, 512, [8376, "tenge"], "f7d7", ["M32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V224H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z", "M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64z"]]
};
var faTenge = faTengeSign;
var faHeadphones = {
  prefix: 'fad',
  iconName: 'headphones',
  icon: [512, 512, [127911], "f025", ["M49.6 262C62.4 159.4 149.9 80 256 80s193.6 79.4 206.4 182c29.1 12 49.6 40.6 49.6 74V288C512 146.6 397.4 32 256 32S0 146.6 0 288v48c0-33.4 20.5-62.1 49.6-74z", "M80 256c-44.2 0-80 35.8-80 80v64c0 44.2 35.8 80 80 80c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm352 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48c44.2 0 80-35.8 80-80V336c0-44.2-35.8-80-80-80z"]]
};
var faHandsHolding = {
  prefix: 'fad',
  iconName: 'hands-holding',
  icon: [640, 512, [], "f4c2", ["M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z", ""]]
};
var faCampfire = {
  prefix: 'fad',
  iconName: 'campfire',
  icon: [512, 512, [], "f6ba", ["M223.4 0c3.2 0 6.3 1.2 8.8 3.4C250 19.6 266.6 37 282.1 55.9c7.1-9 15.1-18.8 23.8-26.8c5.1-4.7 12.9-4.6 18 0C346.2 49.7 365 77 378.3 102.9c13.1 25.5 21.7 53.5 21.7 71.8C400 254.5 335.9 320 256 320c-80.7 0-144-65.5-144-145.3c0-24 11.4-55.2 29.2-84.2c18-29.4 43.3-60.1 73.2-87.1c2.5-2.3 5.8-3.4 9-3.4zm33.5 261.8c16.2 0 30.6-4.5 44.1-13.6c27-19.1 34.2-57.3 18-87.3c-1.8-3.6-3.6-7.3-6.3-10.9l-32.4 38.2s-52.2-67.3-55.8-71.8c-27 33.6-40.5 52.7-40.5 74.5c0 44.5 32.4 70.9 72.9 70.9z", "M1.9 309.2c5.9-16.6 24.3-25.3 40.9-19.4L256 366l213.2-76.2c16.6-5.9 35 2.7 40.9 19.4s-2.7 35-19.4 40.9L351.1 400l139.6 49.9c16.6 5.9 25.3 24.3 19.4 40.9s-24.3 25.3-40.9 19.4L256 434 42.8 510.1c-16.6 5.9-35-2.7-40.9-19.4s2.7-35 19.4-40.9L160.9 400 21.2 350.1C4.6 344.2-4.1 325.9 1.9 309.2z"]]
};
var faCircleAmpersand = {
  prefix: 'fad',
  iconName: 'circle-ampersand',
  icon: [512, 512, [], "e0f8", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 191.6c0 4.1 1.6 8.1 4.6 11L235 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2H231.6c-8.6 0-15.6 7-15.6 15.6zm71 46.9l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L361 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4H210.5c-36.7 0-66.5-29.8-66.5-66.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9c0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z", "M231.6 176h19.2c7.3 0 13.2 5.9 13.2 13.2c0 4.2-2 8.1-5.4 10.6L235 217.1l-14.5-14.5c-2.9-2.9-4.6-6.9-4.6-11c0-8.6 7-15.6 15.6-15.6zm37.8 75.4L287 238.5c15.7-11.5 25-29.8 25-49.3c0-33.8-27.4-61.2-61.2-61.2H231.6c-35.1 0-63.6 28.5-63.6 63.6c0 16.9 6.7 33 18.6 45l9.2 9.2-24.7 18.1c-17.1 12.5-27.2 32.4-27.2 53.6c0 36.7 29.8 66.5 66.5 66.5h32.2c24.1 0 46.9-10.9 62-29.4L327 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-28.4-28.4 31.1-45c7.5-10.9 4.8-25.8-6.1-33.4s-25.8-4.8-33.4 6.1l-26.2 37.8-28.7-28.7zm-39.2 28.7l40.1 40.1-1.4 2c-6 8.6-15.8 13.8-26.3 13.8H210.5c-10.2 0-18.5-8.3-18.5-18.5c0-5.9 2.8-11.4 7.5-14.9l30.7-22.5z"]]
};
var faSnowflakes = {
  prefix: 'fad',
  iconName: 'snowflakes',
  icon: [640, 512, [], "f7cf", ["M567 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L487 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L567 7zM519 199c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z", "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"]]
};
var faHandsClapping = {
  prefix: 'fad',
  iconName: 'hands-clapping',
  icon: [512, 512, [], "e1a8", ["M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V80c0 8.8 7.2 16 16 16s16-7.2 16-16V16zm-98.7 7.1c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l32 48c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-32-48zM355.4 508c26.8-1 53.5-8.6 77.7-23.1c49-29.4 78.9-82.3 78.9-139.4V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v39.4c0 9.6-7.8 16-16 16l0 98.1c0 63.4-28.5 122.8-76.6 162.4zM424.9 18.7c-7.4-4.9-17.3-2.9-22.2 4.4l-32 48c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l32-48c4.9-7.4 2.9-17.3-4.4-22.2z", "M135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9z"]]
};
var faRepublican = {
  prefix: 'fad',
  iconName: 'republican',
  icon: [640, 512, [], "f75e", ["M320 288H128 0v96 64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384H320v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384 352h32v48c0 44.2 35.8 80 80 80s80-35.8 80-80V352c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V320 288H512 448 416 320z", "M160 32C71.6 32 0 103.6 0 192v96H544V192c0-88.4-71.6-160-160-160H160zm261.7 99.4l12.6 24.6 28.2 4c2.4 .3 4.4 2 5.2 4.2s.1 4.7-1.6 6.3l-20.4 19.2 4.8 27.1c.4 2.3-.6 4.7-2.5 6s-4.6 1.6-6.7 .5l-25.2-12.8-25.2 12.8c-2.2 1.1-4.8 .9-6.7-.5s-3-3.7-2.5-6l4.8-27.1-20.4-19.2c-1.7-1.6-2.4-4.1-1.6-6.3s2.8-3.9 5.2-4.2l28.2-4 12.6-24.6c1.1-2.1 3.3-3.4 5.7-3.4s4.7 1.3 5.7 3.4zM271.9 128c2.4 0 4.7 1.3 5.7 3.4l12.6 24.6 28.2 4c2.4 .3 4.4 2 5.2 4.2s.1 4.7-1.6 6.3l-20.4 19.2 4.8 27.1c.4 2.3-.6 4.7-2.5 6s-4.6 1.6-6.7 .5l-25.2-12.8-25.2 12.8c-2.2 1.1-4.8 .9-6.7-.5s-3-3.7-2.5-6l4.8-27.1-20.4-19.2c-1.7-1.6-2.4-4.1-1.6-6.3s2.8-3.9 5.2-4.2l28.2-4 12.6-24.6c1.1-2.1 3.3-3.4 5.7-3.4zm-138.3 3.4l12.6 24.6 28.2 4c2.4 .3 4.4 2 5.2 4.2s.1 4.7-1.6 6.3l-20.4 19.2 4.8 27.1c.4 2.3-.6 4.7-2.5 6s-4.6 1.6-6.7 .5l-25.2-12.8-25.2 12.8c-2.2 1.1-4.8 .9-6.7-.5s-3-3.7-2.5-6l4.8-27.1L77.9 170.5c-1.7-1.6-2.4-4.1-1.6-6.3s2.8-3.9 5.2-4.2l28.2-4 12.6-24.6c1.1-2.1 3.3-3.4 5.7-3.4s4.7 1.3 5.7 3.4z"]]
};
var faLeafMaple = {
  prefix: 'fad',
  iconName: 'leaf-maple',
  icon: [512, 512, [127809], "f6f6", ["M355.6 39.2L339.8 7.5c-2.3-4.6-7-7.5-12.2-7.5c-4.7 0-9.1 2.4-11.6 6.4l-61.2 97.9c-4.3 6.8-14.8 3.8-14.8-4.2V61.8c0-7.6-6.2-13.8-13.8-13.8c-1.5 0-2.9 .2-4.4 .7l-25.5 8.5c-12.3 4.1-25.9 .3-34.4-9.5L132.6 13.4C129.7 10 125.4 8 120.9 8c-5.5 0-10.6 3-13.4 7.7L91.1 44.6C84.4 56.3 71.2 62.5 58 60.3L32.9 56.2c-.6-.1-1.3-.2-1.9-.2c-7.6 0-13.2 7.2-11.2 14.6l40.4 155c2.1 8.2-2.4 16.6-10.4 19.2l-25.4 8.5c-5 1.7-8.4 6.3-8.4 11.6c0 4.4 2.4 8.5 6.3 10.7l115.9 64.4L279.9 198.1c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L172.1 373.8l64.4 115.9c2.2 3.9 6.2 6.3 10.7 6.3c5.3 0 9.9-3.4 11.6-8.4l8.5-25.4c2.7-8 11.1-12.6 19.2-10.4l155 40.4c7.4 1.9 14.6-3.6 14.6-11.2c0-.6-.1-1.3-.2-1.9L451.7 454c-2.2-13.2 4.1-26.4 15.7-33l28.9-16.5c4.8-2.7 7.8-7.8 7.8-13.4c0-4.5-2-8.8-5.4-11.7L464.3 350c-9.9-8.5-13.6-22.1-9.5-34.4l8.5-25.5c.5-1.4 .7-2.9 .7-4.4c0-7.6-6.2-13.8-13.8-13.8H411.9c-8 0-11.1-10.5-4.2-14.8L505.6 196c4-2.5 6.4-6.9 6.4-11.6c0-5.2-2.9-9.9-7.5-12.2l-31.6-15.8c-14.2-7.1-21.1-23.6-16-38.7l22.5-67.6c.5-1.4 .7-2.9 .7-4.4c0-7.6-6.2-13.8-13.8-13.8c-1.5 0-3 .2-4.4 .7L394.3 55.2c-15.1 5-31.6-1.8-38.7-16z", "M7 505c-9.4-9.4-9.4-24.6 0-33.9L279.9 198.1c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0z"]]
};
var faArrowLeft = {
  prefix: 'fad',
  iconName: 'arrow-left',
  icon: [448, 512, [8592], "f060", ["M109.3 288L416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0-32 32 32 32z", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L77.3 256 214.6 393.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160z"]]
};
var faPersonCircleXmark = {
  prefix: 'fad',
  iconName: 'person-circle-xmark',
  icon: [576, 512, [], "e543", ["M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faRuler = {
  prefix: 'fad',
  iconName: 'ruler',
  icon: [512, 512, [128207], "f545", ["M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z", "M260.7 91.3l22.6-22.6 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48zm-64 64l22.6-22.6 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48zm-64 64l22.6-22.6 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48zm-64 64l22.6-22.6 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48z"]]
};
var faCupStrawSwoosh = {
  prefix: 'fad',
  iconName: 'cup-straw-swoosh',
  icon: [384, 512, [], "e364", ["M55.9 431.5l3.7 37.3c2.5 24.5 23.1 43.2 47.8 43.2H276.6c24.7 0 45.3-18.7 47.8-43.2l16.5-164.6c-42.8 1.1-67.5 8.3-83.6 17c-17.2 9.3-26.9 21.2-39.9 37.2l-.7 .8c-13.3 16.4-29.5 35.9-58.7 50.4c-24.6 12.2-56.8 20-101.9 22zm-4.8-47.8c42.3-1.6 68.2-8.6 85.4-17.2c19.3-9.6 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7c25.9-14 60.5-22.2 111.2-22.8l6.4-64H32L51.2 383.6z", "M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H249.3z"]]
};
var faTemperatureSun = {
  prefix: 'fad',
  iconName: 'temperature-sun',
  icon: [640, 512, ["temperature-hot"], "f76a", ["M464 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C390.2 332.6 384 349.5 384 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM352 112C352 50.2 402.1 0 464 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-33.2 11.3-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M320.6 98.5c-.4 4.4-.6 8.9-.6 13.5V258.8c-20.2 28.6-32 63.5-32 101.2c0 18.7 2.9 36.7 8.3 53.7c-.7 .4-1.4 .8-2.1 1.1c-5.1 2.1-10.9 1.5-15.4-1.6L208 363.5l-70.8 49.6c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6s8.7 6.7 9.6 12.1l14.1 84.7 2.7 .5zM208 144a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM464 96c8.8 0 16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16z"]]
};
var faTemperatureHot = faTemperatureSun;
var faAlignLeft = {
  prefix: 'fad',
  iconName: 'align-left',
  icon: [448, 512, [], "f036", ["M256 352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256zm0-256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H256z", "M416 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416zm0-256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416z"]]
};
var faDiceD6 = {
  prefix: 'fad',
  iconName: 'dice-d6',
  icon: [448, 512, [], "f6d1", ["M247 10.3c-14.3-7.8-31.6-7.8-46 0L25.7 106c-5.1 2.8-8.3 8.2-8.3 14s3.2 11.2 8.3 14L216.3 238c4.8 2.6 10.5 2.6 15.3 0L422.3 134c5.1-2.8 8.3-8.2 8.3-14s-3.2-11.2-8.3-14L247 10.3z", "M7.8 170.2c4.9-2.9 10.9-3 15.8-.3l176 96c5.1 2.8 8.3 8.2 8.3 14V496c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381V184c0-5.6 3-10.9 7.8-13.8zm432.3 0c4.9 2.9 7.8 8.1 7.8 13.8V381c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96c5-2.7 11-2.6 15.8 .3z"]]
};
var faRestroom = {
  prefix: 'fad',
  iconName: 'restroom',
  icon: [640, 512, [], "f7bd", ["M128 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-8 480c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120V480zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480V384H422.2c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H504v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z", "M320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"]]
};
var faHighDefinition = {
  prefix: 'fad',
  iconName: 'high-definition',
  icon: [576, 512, ["rectangle-hd"], "e1ae", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm72 128c13.3 0 24 10.7 24 24v48h64V184c0-13.3 10.7-24 24-24s24 10.7 24 24v72 72c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V256 184c0-13.3 10.7-24 24-24zm168 24c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 120h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96z", "M160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v72 72c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V256 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v48H160V184zm168-24c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96H328zm56 144H352V208h32c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]]
};
var faRectangleHd = faHighDefinition;
var faJ = {
  prefix: 'fad',
  iconName: 'j',
  icon: [320, 512, [106], "4a", ["M288 32c17.7 0 32 14.3 32 32V320c0 88.4-71.6 160-160 160S0 408.4 0 320V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z", ""]]
};
var faGalaxy = {
  prefix: 'fad',
  iconName: 'galaxy',
  icon: [512, 512, [], "e008", ["M320 0h11.5C342.8 0 352 9.2 352 20.5c0 7.1-3.7 13.7-9.8 17.5l-12.5 7.7c-35.2 21.7-60.9 54.9-73.3 93.1c19.9-7 41.3-10.8 63.5-10.8c106 0 192 86 192 192v11.5c0 11.3-9.2 20.5-20.5 20.5c-7.1 0-13.7-3.7-17.5-9.8l-7.7-12.5c-21.7-35.2-54.9-60.9-93.1-73.3c7 19.9 10.8 41.3 10.8 63.5c0 106-86 192-192 192H180.5c-11.3 0-20.5-9.2-20.5-20.5c0-7.1 3.7-13.7 9.8-17.5l12.5-7.7c35.2-21.7 60.9-54.9 73.3-93.1c-19.9 7-41.3 10.8-63.5 10.8C86 384 0 298 0 192V180.5C0 169.2 9.2 160 20.5 160c7.1 0 13.7 3.7 17.5 9.8l7.7 12.5c21.7 35.2 54.9 60.9 93.1 73.3c-7-19.9-10.8-41.3-10.8-63.5C128 86 214 0 320 0zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M154.8 94.2c.1-13 1.6-26.1 4.7-39l3.4-14.2c1.7-6.9-.4-14.2-5.5-19.3c-8-8-21-8-29 0l-8.1 8.1C70.5 79.4 53.8 149.6 70 213.1c19.3 19.4 42.9 34 68.8 42.4c-7-19.9-10.8-41.3-10.8-63.5c0-35.7 9.8-69.2 26.8-97.8zM94.2 357.2c-13-.1-26.1-1.6-39-4.7l-14.2-3.4c-6.9-1.7-14.2 .4-19.3 5.5c-8 8-8 21 0 29l8.1 8.1c49.7 49.7 119.9 66.5 183.4 50.3c19.4-19.3 34-42.9 42.4-68.8c-19.9 7-41.3 10.8-63.5 10.8c-35.7 0-69.2-9.8-97.8-26.8zm263.1 60.6c-.1 13-1.6 26.1-4.7 39l-3.4 14.2c-1.7 6.9 .4 14.2 5.5 19.3c8 8 21 8 29 0l8.1-8.1c49.7-49.7 66.5-119.9 50.3-183.4c-19.3-19.4-42.9-34-68.8-42.4c7 19.9 10.8 41.3 10.8 63.5c0 35.7-9.8 69.2-26.8 97.8zm60.6-263.1c13 .1 26.1 1.6 39 4.7l14.2 3.4c6.9 1.7 14.2-.4 19.3-5.5c8-8 8-21 0-29l-8.1-8.1C432.6 70.5 362.4 53.8 298.9 70c-19.4 19.3-34 42.9-42.4 68.8c19.9-7 41.3-10.8 63.5-10.8c35.7 0 69.2 9.8 97.8 26.8z"]]
};
var faUsersViewfinder = {
  prefix: 'fad',
  iconName: 'users-viewfinder',
  icon: [640, 512, [], "e595", ["M175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z", "M136 48H48v88c0 13.3-10.7 24-24 24s-24-10.7-24-24V32C0 14.3 14.3 0 32 0H136c13.3 0 24 10.7 24 24s-10.7 24-24 24zm368 0c-13.3 0-24-10.7-24-24s10.7-24 24-24H608c17.7 0 32 14.3 32 32V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V48H504zM48 464h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-17.7 0-32-14.3-32-32V376c0-13.3 10.7-24 24-24s24 10.7 24 24v88zm456 0h88V376c0-13.3 10.7-24 24-24s24 10.7 24 24V480c0 17.7-14.3 32-32 32H504c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faFileVideo = {
  prefix: 'fad',
  iconName: 'file-video',
  icon: [384, 512, [], "f1c8", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 288v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM300.9 397.9c2 1.3 4.4 2.1 6.8 2.1c6.8 0 12.3-5.5 12.3-12.3V284.3c0-6.8-5.5-12.3-12.3-12.3c-2.4 0-4.8 .7-6.8 2.1L256 304v64l44.9 29.9z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM64 288v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM300.9 397.9c2 1.3 4.4 2.1 6.8 2.1c6.8 0 12.3-5.5 12.3-12.3V284.3c0-6.8-5.5-12.3-12.3-12.3c-2.4 0-4.8 .7-6.8 2.1L256 304v64l44.9 29.9z"]]
};
var faCherries = {
  prefix: 'fad',
  iconName: 'cherries',
  icon: [640, 512, [], "e0ec", ["M0 336C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-56 0-96 32-96 32s-40-32-96-32c0 0-96 0-96 112zM448 512c48 0 192-16 192-176c0-112-96-112-96-112c-56 0-96 32-96 32s-30.4-24.3-75.2-30.5C397.3 247.7 416 282.9 416 336c0 71.9-26.1 120.9-62.1 152.9C390.4 506.3 427.7 512 448 512z", "M302.4 4.8l.3 .2c.3 .2 .8 .6 1.4 1c1.2 .9 2.9 2.2 5 3.9c4.3 3.3 10.3 8.2 17.5 14.5c14.4 12.6 33.7 30.9 53.6 53.9c35.1 40.6 73.3 97.7 87.6 165.3C455.2 250.3 448 256 448 256s-11.6-9.3-31-17.8c-14-50.1-43.6-94.2-73.1-128.5c-14.3-16.6-28.3-30.5-40.1-41.2c-3.1 12.9-7.3 28.2-13 45.1c-11.7 35-29.6 77.5-56.7 120.2c-26 9.4-42 22.3-42 22.3s-8.3-6.6-22.6-13.8c38.4-49.1 61.8-101.8 75.8-143.7c7.7-23 12.4-42.5 15.3-56.3c1.4-6.9 2.4-12.2 2.9-15.8c.3-1.8 .5-3.1 .6-4l.1-.9c.6-5.3 2.9-10.1 6.3-13.8C274.9 2.9 281.1 0 288 0c5.4 0 10.4 1.8 14.4 4.8z"]]
};
var faUpRightFromSquare = {
  prefix: 'fad',
  iconName: 'up-right-from-square',
  icon: [512, 512, ["external-link-alt"], "f35d", ["M0 112C0 67.8 35.8 32 80 32H192c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V320c0-17.7 14.3-32 32-32s32 14.3 32 32V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112z", "M322.4 19.8C327.4 7.8 339.1 0 352 0H480c17.7 0 32 14.3 32 32V160c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9L416 141.3 246.6 310.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 96 329.4 54.6c-9.2-9.2-11.9-22.9-6.9-34.9z"]]
};
var faExternalLinkAlt = faUpRightFromSquare;
var faCircleSort = {
  prefix: 'fad',
  iconName: 'circle-sort',
  icon: [512, 512, ["sort-circle"], "e030", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H352c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zM244.7 411.3c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96z", "M244.7 100.7c6.2-6.2 16.4-6.2 22.6 0l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96zm0 310.6l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9H352c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0z"]]
};
var faSortCircle = faCircleSort;
var faTableCells = {
  prefix: 'fad',
  iconName: 'table-cells',
  icon: [512, 512, ["th"], "f00a", ["M144 160V96h64v64h96V96h64v64h80v64H368v64h80v64H368v64H304V352H208v64H144V352H64V288h80V224H64V160h80zm64 64v64h96V224H208z", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 96V416H64V96H448z"]]
};
var faTh = faTableCells;
var faFilePdf = {
  prefix: 'fad',
  iconName: 'file-pdf',
  icon: [512, 512, [], "f1c1", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM176 352c-8.8 0-16 7.2-16 16v80 48c0 8.8 7.2 16 16 16s16-7.2 16-16V464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56H176zm32 80H192V384h16c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H304zm32 128H320V384h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16zm80-112v64 64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V384h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16z"]]
};
var faSiren = {
  prefix: 'fad',
  iconName: 'siren',
  icon: [448, 512, [], "e02d", ["M48 352L73 152.1C77 120 104.2 96 136.5 96h175c32.3 0 59.5 24 63.5 56.1L400 352H138.1l21.8-174c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9L105.9 352H48z", "M32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"]]
};
var faArrowUpToDottedLine = {
  prefix: 'fad',
  iconName: 'arrow-up-to-dotted-line',
  icon: [448, 512, [], "e0a1", ["M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm96 0A32 32 0 1 1 96 64a32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z", "M201.4 169.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 269.3V336 448c0 17.7-14.3 32-32 32s-32-14.3-32-32V336 269.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z"]]
};
var faImageLandscape = {
  prefix: 'fad',
  iconName: 'image-landscape',
  icon: [576, 512, ["landscape"], "e1b5", ["M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm328 64c-8 0-15.5 4-20 10.7l-56 84L234.7 265c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H424c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C343.5 196 336 192 328 192zM160 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M328 192c8 0 15.5 4 20 10.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S432.9 384 424 384H280 232 152c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C312.5 196 320 192 328 192z"]]
};
var faLandscape = faImageLandscape;
var faTankWater = {
  prefix: 'fad',
  iconName: 'tank-water',
  icon: [448, 512, [], "e452", ["M212.2 71c2.4-4.3 6.9-7 11.8-7s9.5 2.7 11.8 7L273 139.2c4.6 8.4 7 17.9 7 27.5V168c0 30.9-25.1 56-56 56s-56-25.1-56-56v-1.4c0-9.6 2.4-19 7-27.5L212.2 71zM64 416V348 297.9c8.3-3 16.2-6.8 23.3-10.8c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 18.9 12.7c15.8 9 35.5 16.8 55.2 16.9h.4c19.6 0 39.3-7.9 55.2-16.9c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 19 12.8c7.1 4 15 7.9 23.4 10.8V348v68H64z", "M285.9 96l-22-40.3L251 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H197L184.1 55.7 162.1 96H64l0 320H384V96H285.9z"]]
};
var faCurlingStone = {
  prefix: 'fad',
  iconName: 'curling-stone',
  icon: [576, 512, [129356, "curling"], "f44a", ["M576 336H0V320c0-53 43-96 96-96H480c53 0 96 43 96 96v16zm0 32v16c0 53-43 96-96 96H96c-53 0-96-43-96-96V368H576z", "M224 128c0-17.7 14.3-32 32-32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-53 0-96 43-96 96v32c-35.3 0-64 28.7-64 64H480c0-35.3-28.7-64-64-64H224V128z"]]
};
var faCurling = faCurlingStone;
var faGamepadModern = {
  prefix: 'fad',
  iconName: 'gamepad-modern',
  icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", ["M0 369.4v2.8C0 431.7 48.3 480 107.8 480c49.5 0 92.6-33.7 104.6-81.7L216 384H424l3.6 14.3c12 48 55.1 81.7 104.6 81.7C591.7 480 640 431.7 640 372.2v-2.8c0-6.3-.5-12.5-1.6-18.7L605.7 159.8c-8.6-50.2-40.9-93.2-90.3-105.5C469.5 42.9 403.8 32 320 32s-149.5 10.9-195.3 22.3C75.2 66.6 42.9 109.6 34.3 159.8L1.6 350.7C.5 356.9 0 363.1 0 369.4zM432 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24-56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-240-8v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M192 144c13.3 0 24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24z"]]
};
var faGamepadAlt = faGamepadModern;
var faMessagesQuestion = {
  prefix: 'fad',
  iconName: 'messages-question',
  icon: [640, 512, [], "e1e7", ["M64 0C28.7 0 0 28.7 0 64V256c0 35.3 28.7 64 64 64H96v48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm72.2 92.4c6.6-18.6 24.2-31.1 44-31.1h48.5c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 175c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20V163.5c0-7.2 3.8-13.8 10-17.3L235 124.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6H180.2c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1zM181.3 248a26.7 26.7 0 1 1 53.3 0 26.7 26.7 0 1 1 -53.3 0z", "M136.2 92.4c6.6-18.6 24.2-31.1 44-31.1h48.5c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 175c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20V163.5c0-7.2 3.8-13.8 10-17.3L235 124.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6H180.2c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1zM181.3 248a26.7 26.7 0 1 1 53.3 0 26.7 26.7 0 1 1 -53.3 0zM256 384V352h96c53 0 96-43 96-96V128H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H544v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320c-35.3 0-64-28.7-64-64z"]]
};
var faBookBible = {
  prefix: 'fad',
  iconName: 'book-bible',
  icon: [448, 512, ["bible"], "f647", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H352 256 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H256h96 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM208 80v48H160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48V304c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H272V80c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16z"]]
};
var faBible = faBookBible;
var faO = {
  prefix: 'fad',
  iconName: 'o',
  icon: [448, 512, [111], "4f", ["M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z", ""]]
};
var faSuitcaseMedical = {
  prefix: 'fad',
  iconName: 'suitcase-medical',
  icon: [512, 512, ["medkit"], "f0fa", ["M96 480h32V96H96V480zM384 96V480h32V96H384z", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96v32V480H384V128 96 56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H96V96zM416 480h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H416V480zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"]]
};
var faMedkit = faSuitcaseMedical;
var faBriefcaseArrowRight = {
  prefix: 'fad',
  iconName: 'briefcase-arrow-right',
  icon: [512, 512, [], "e2f2", ["M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM297 191l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H152c-13.3 0-24-10.7-24-24s10.7-24 24-24H302.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z", "M263 191c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H152c-13.3 0-24-10.7-24-24s10.7-24 24-24H302.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9z"]]
};
var faExpandWide = {
  prefix: 'fad',
  iconName: 'expand-wide',
  icon: [512, 512, [], "f320", ["M512 192c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32v96zM0 320c0-17.7 14.3-32 32-32s32 14.3 32 32v64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V320z", "M0 192c0 17.7 14.3 32 32 32s32-14.3 32-32V128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 64 0 78.3 0 96v96zM512 320c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V320z"]]
};
var faClockElevenThirty = {
  prefix: 'fad',
  iconName: 'clock-eleven-thirty',
  icon: [512, 512, [], "e348", ["M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V263.3l-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M256 416c-13.3 0-24-10.7-24-24V263.3l-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3V392c0 13.3-10.7 24-24 24z"]]
};
var faRv = {
  prefix: 'fad',
  iconName: 'rv',
  icon: [640, 512, [], "f7be", ["M176 512a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm320 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z", "M224 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16V32H512c53 0 96 43 96 96c0 17.7-14.3 32-32 32H384V416H266.5c-13.2-37.3-48.7-64-90.5-64c-38.9 0-72.5 23.2-87.5 56.5L18.7 338.7C6.7 326.7 0 310.5 0 293.5V96C0 60.7 28.7 32 64 32H224V16zM96 144v64c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM416 320V288 216 192h24 76.6c12.9 0 25.5 4.5 35.5 12.7l67.4 55.2c13 10.6 20.5 26.5 20.5 43.3V320v64c0 17.7-14.3 32-32 32H586.5c-13.2-37.3-48.7-64-90.5-64c-33.4 0-62.8 17-80 42.9V320zm162.1-32l-56.5-46.2c-1.4-1.2-3.2-1.8-5.1-1.8H464v48H578.1z"]]
};
var faUserSecret = {
  prefix: 'fad',
  iconName: 'user-secret',
  icon: [448, 512, [128373], "f21b", ["M128 169.6V184c0 22.1 17.9 40 40 40h12.4c16.5 0 31.1-10.6 36.3-26.2c2.3-7 12.2-7 14.5 0c5.2 15.6 19.9 26.2 36.3 26.2H280c22.1 0 40-17.9 40-40V169.6c5.5-.8 10.9-1.7 16-2.6v17c0 61.9-50.1 112-112 112s-112-50.1-112-112V167c5.1 .9 10.5 1.8 16 2.6z", "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 17.8 38.6 33.3 96 41.6V184c0 22.1 17.9 40 40 40h12.4c16.5 0 31.1-10.6 36.3-26.2c2.3-7 12.2-7 14.5 0c5.2 15.6 19.9 26.2 36.3 26.2H280c22.1 0 40-17.9 40-40V169.6c57.4-8.3 96-23.8 96-41.6c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm44.1 496H417.3c17 0 30.7-13.8 30.7-30.7c0-57-29.6-107.1-74.2-135.8L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4h-59L273.7 490.5l-34-116.6 17.8-29.6c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2l17.8 29.6-34 116.6L104.4 224h-59C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5L74.2 345.5C29.6 374.2 0 424.3 0 481.3c0 17 13.8 30.7 30.7 30.7H179.9h88.1z"]]
};
var faOtter = {
  prefix: 'fad',
  iconName: 'otter',
  icon: [640, 512, [129446], "f700", ["M184.9 185c4.5-3 7.1-8 7.1-13.3V168c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v3.7c0 5.3 2.7 10.3 7.1 13.3l11.8 7.9-21.2 10.6c-5.9 3-12.4 4.5-19.1 4.5C83.1 208 64 188.9 64 165.4V144c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v21.4c0 23.5-19.1 42.6-42.6 42.6c-6.6 0-13.1-1.5-19.1-4.5l-21.2-10.6 11.8-7.9zM96 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 96l12.9 6.4c12.6 6.3 26.5 9.6 40.5 9.6c5.3 0 10.5-.5 15.6-1.3c12.8 38 48.7 65.3 91 65.3h64v64H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-35.3 0-64-28.7-64-64v-.6c3.5 .4 7 .6 10.6 .6c14.1 0 27.9-3.3 40.5-9.6L160 240z", "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V336 320c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6V240c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16v32 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V204.3c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1h0c0 123.7-100.3 224-224 224h-1.1H256h-.6C132 480 32 380 32 256.6V256 216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64H320c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6z"]]
};
var faDreidel = {
  prefix: 'fad',
  iconName: 'dreidel',
  icon: [448, 512, [], "f792", ["M438.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 146.7 225.9 84.7c-18.7-18.7-49.1-18.7-67.9 0L89.4 153.4 326.6 390.6l68.7-68.7c18.7-18.7 18.7-49.1 0-67.9L333.3 192 438.6 86.6z", "M326.6 390.6L89.4 153.4 18.7 224C6.7 236 0 252.3 0 269.3V416c0 35.3 28.7 64 64 64H210.7c17 0 33.3-6.7 45.3-18.7l70.6-70.6z"]]
};
var faPersonDress = {
  prefix: 'fad',
  iconName: 'person-dress',
  icon: [320, 512, ["female"], "f182", ["M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z", "M88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"]]
};
var faFemale = faPersonDress;
var faCommentDollar = {
  prefix: 'fad',
  iconName: 'comment-dollar',
  icon: [512, 512, [], "f651", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z", "M256 116c11 0 20 9 20 20v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20z"]]
};
var faBusinessTime = {
  prefix: 'fad',
  iconName: 'business-time',
  icon: [640, 512, ["briefcase-clock"], "f64a", ["M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64v32.7c-5.3-.5-10.6-.7-16-.7c-54.7 0-103.5 24.9-135.8 64H352 192 0V160c0-35.3 28.7-64 64-64h64zM320.7 352c-.5 5.3-.7 10.6-.7 16c0 42.5 15.1 81.6 40.2 112H64c-35.3 0-64-28.7-64-64V288H192v32c0 17.7 14.3 32 32 32h96c.2 0 .5 0 .7 0z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faBriefcaseClock = faBusinessTime;
var faFlowerTulip = {
  prefix: 'fad',
  iconName: 'flower-tulip',
  icon: [512, 512, [127799], "f801", ["M224 256V394.8C192.1 349.5 139.5 320 80 320H29.5C13.2 320 0 333.2 0 349.5C0 439.3 72.7 512 162.5 512H224h32 32 61.5C439.3 512 512 439.3 512 349.5c0-16.3-13.2-29.5-29.5-29.5H432c-59.5 0-112.1 29.5-144 74.8V256H224z", "M96 128V44c0-6.6 5.4-12 12-12c2.6 0 5.1 .8 7.2 2.4L176 80 243.2 5.3c3-3.4 7.4-5.3 11.9-5.3h1.7c4.5 0 8.9 1.9 11.9 5.3L336 80l60.8-45.6c2.1-1.6 4.6-2.4 7.2-2.4c6.6 0 12 5.4 12 12v84c0 70.7-57.3 128-128 128H224c-70.7 0-128-57.3-128-128z"]]
};
var faPeoplePantsSimple = {
  prefix: 'fad',
  iconName: 'people-pants-simple',
  icon: [512, 512, [], "e21a", ["M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm256 0A64 64 0 1 0 384 0a64 64 0 1 0 0 128z", "M25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zm256 0c3.5-41.5 38.1-73.4 79.7-73.4h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z"]]
};
var faCloudDrizzle = {
  prefix: 'fad',
  iconName: 'cloud-drizzle',
  icon: [512, 512, [], "f738", ["M64 352c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24zm96 64c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V440c0-13.3 10.7-24 24-24zm216 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V440c0-13.3 10.7-24 24-24s24 10.7 24 24zM256 352c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24zm216 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M0 224c0 53 43 96 96 96H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z"]]
};
var faTableCellsLarge = {
  prefix: 'fad',
  iconName: 'table-cells-large',
  icon: [512, 512, ["th-large"], "f009", ["M224 288V416h64V288l160 0V224l-160 0V96H224V224L64 224v64l160 0z", "M448 96V416H64V96H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]]
};
var faThLarge = faTableCellsLarge;
var faBookTanakh = {
  prefix: 'fad',
  iconName: 'book-tanakh',
  icon: [448, 512, ["tanakh"], "f827", ["M384 416c0-17.7-14.3-32-32-32H32v64H352c17.7 0 32-14.3 32-32z", "M448 96c0-53-43-96-96-96H64 32C14.3 0 0 14.3 0 32V352c0 17.7 14.3 32 32 32H96h96H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 96 32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 352c53 0 96-43 96-96V96zM138.7 208l-13.9 24h27.7l-13.9-24zm13.9-24l27.7 48h55.4l27.7-48-27.7-48H180.3l-27.7 48zm-27.7 0L97.1 136c-6.2-10.7 1.5-24 13.9-24h55.4l27.7-48c6.2-10.7 21.6-10.7 27.7 0l27.7 48H305c12.3 0 20 13.3 13.9 24l-27.7 48 27.7 48c6.2 10.7-1.5 24-13.9 24H249.6l-27.7 48c-6.2 10.7-21.6 10.7-27.7 0l-27.7-48H111c-12.3 0-20-13.3-13.9-24l27.7-48zm27.7-48H124.9l13.9 24 13.9-24zm41.6-24h27.7L208 88l-13.9 24zm69.3 24l13.9 24 13.9-24H263.4zm13.9 72l-13.9 24h27.7l-13.9-24zm-55.4 48H194.1L208 280l13.9-24z"]]
};
var faTanakh = faBookTanakh;
var faSolarSystem = {
  prefix: 'fad',
  iconName: 'solar-system',
  icon: [512, 512, [], "e02f", ["M411.8 368.2C434.6 336.6 448 297.9 448 256c0-106-86-192-192-192c-29 0-56.6 6.4-81.2 18c-4-22.5-17.4-41.8-36-53.6C173.9 10.2 213.7 0 256 0C397.4 0 512 114.6 512 256c0 56.3-18.2 108.3-48.9 150.6c-4.4-22-23.8-38.6-47.1-38.6c-1.4 0-2.8 .1-4.2 .2zm-74.7 61.9c3.8 22.6 17.1 41.9 35.6 53.8c-35 18-74.7 28.1-116.8 28.1C114.6 512 0 397.4 0 256c0-56.3 18.2-108.3 48.9-150.6C53.3 127.4 72.7 144 96 144c1.4 0 2.8-.1 4.2-.2C77.4 175.4 64 214.1 64 256c0 106 86 192 192 192c29 0 56.5-6.4 81.1-17.9zM256 152c-57.4 0-104 46.6-104 104s46.6 104 104 104s104-46.6 104-104c0-17.4-4.3-33.8-11.8-48.2c1.3 .1 2.5 .2 3.8 .2c16.9 0 31.3-10.5 37.2-25.3c12 21.7 18.8 46.7 18.8 73.3c0 83.9-68.1 152-152 152s-152-68.1-152-152s68.1-152 152-152c31.3 0 60.4 9.5 84.5 25.7C324 134.6 312 149.9 312 168c0 .1 0 .2 0 .4C295.8 158 276.6 152 256 152z", "M96 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM416 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM392 168a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM256 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faSealQuestion = {
  prefix: 'fad',
  iconName: 'seal-question',
  icon: [512, 512, [], "e243", ["M222.1 18.4c18.7-18.7 49.1-18.7 67.9 0L335.5 64H400c26.5 0 48 21.5 48 48v64.5l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.5V400c0 26.5-21.5 48-48 48H335.5l-45.6 45.6c-18.7 18.7-49.1 18.7-67.9 0L176.5 448H112c-26.5 0-48-21.5-48-48V335.5L18.4 289.9c-18.7-18.7-18.7-49.1 0-67.9L64 176.5V112c0-26.5 21.5-48 48-48h64.5l45.6-45.6zM169.8 165.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M222.6 128c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faPhoneVolume = {
  prefix: 'fad',
  iconName: 'phone-volume',
  icon: [512, 512, ["volume-control-phone"], "f2a0", ["M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z", "M256 24c0-13.3 10.7-24 24-24C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24zm0 200a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM280 96c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faVolumeControlPhone = faPhoneVolume;
var faDiscDrive = {
  prefix: 'fad',
  iconName: 'disc-drive',
  icon: [512, 512, [], "f8b5", ["M256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 192a160 160 0 1 0 0-320 160 160 0 1 0 0 320z", "M32 96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H416 96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0z"]]
};
var faHatCowboySide = {
  prefix: 'fad',
  iconName: 'hat-cowboy-side',
  icon: [640, 512, [], "f8c1", ["M502.7 233.2l6.7 34.7 17.7 4.4c33.8 8.4 61.7 32 75.9 63.8c3.3 7.5 5.1 15.6 5.1 23.8V368c0 26.5-21.5 48-48 48h-.9c-6.6 0-13-2-18.3-5.8L273 222.8c-28.6-20-62.7-30.8-97.7-30.8C110.9 192 51.9 228.4 23 286.1l-9.2 18.4C4.7 322.7 0 342.8 0 363.2c0 33.4 14 63.5 36.5 84.8h80.3C70 448 32 410 32 363.2c0-15.4 3.6-30.6 10.5-44.4l9.2-18.4C75.1 253.6 123 224 175.4 224c28.4 0 56.1 8.7 79.3 25L522.4 436.4C533.2 444 546 448 559.1 448h.9c44.2 0 80-35.8 80-80v-8.1c0-12.7-2.7-25.2-7.8-36.8c-18.1-40.8-54-71-97.4-81.8l-32.1-8z", "M141.9 195.3l10.8-59.4c4.4-24.4 22.5-44 46.5-50.4L391.9 34.2c5.4-1.4 10.9-2.2 16.5-2.2h2.7c30.7 0 57.1 21.8 62.8 51.9l28.7 149.3 2.9 15.2 3.7 19.5 17.7 4.4c33.8 8.4 61.7 32 75.9 63.8c3.3 7.5 5.1 15.6 5.1 23.8V368c0 26.5-21.5 48-48 48h-.9c-6.6 0-13-2-18.3-5.8L273 222.8c-28.6-20-62.7-30.8-97.7-30.8c-11.4 0-22.5 1.1-33.4 3.3zM116.8 448C70 448 32 410 32 363.2c0-15.4 3.6-30.6 10.5-44.4l9.2-18.4C75.1 253.6 123 224 175.4 224c28.4 0 56.1 8.7 79.3 25L522.4 436.4C533.2 444 546 448 559.1 448H544 116.8zM560 448c2.5 0 5-.1 7.5-.3l.5 .3h-8z"]]
};
var faTableRows = {
  prefix: 'fad',
  iconName: 'table-rows',
  icon: [512, 512, ["rows"], "e292", ["M448 224H128v64H448V224z", "M128 416l320 0 0-320L128 96l0 320zM64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480z"]]
};
var faRows = faTableRows;
var faLocationExclamation = {
  prefix: 'fad',
  iconName: 'location-exclamation',
  icon: [384, 512, ["map-marker-exclamation"], "f608", ["M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 96c13.3 0 24 10.7 24 24V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M216 120c0-13.3-10.7-24-24-24s-24 10.7-24 24V232c0 13.3 10.7 24 24 24s24-10.7 24-24V120zM192 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faMapMarkerExclamation = faLocationExclamation;
var faFaceFearful = {
  prefix: 'fad',
  iconName: 'face-fearful',
  icon: [512, 512, [], "e375", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM96 224a64 64 0 1 1 128 0A64 64 0 1 1 96 224zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 112c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm173 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z", "M176 112c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-15.6 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM349 112.9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]]
};
var faClipboardUser = {
  prefix: 'fad',
  iconName: 'clipboard-user',
  icon: [384, 512, [], "f7f3", ["M113.2 66.3c.1-.8 .3-1.6 .4-2.3H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H270.4c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z", "M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"]]
};
var faBusSchool = {
  prefix: 'fad',
  iconName: 'bus-school',
  icon: [512, 512, [], "f5dd", ["M112 160c0-17.7 14.3-32 32-32h96V256H144c-17.7 0-32-14.3-32-32V160zm160 96V128h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H272zM64 480V448h96v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm288 0V448h96v32c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32z", "M256 0C380.8 0 464 35.2 464 80V96v16h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H464v20.3c9.6 5.5 16 15.9 16 27.7V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V288c0-11.8 6.4-22.2 16-27.7V240H32c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32H48V96 80C48 35.2 131.2 0 256 0zM112 160v64c0 17.7 14.3 32 32 32h96V128H144c-17.7 0-32 14.3-32 32zm160 96h96c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H272V256zM112 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 80c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16z"]]
};
var faFilmSlash = {
  prefix: 'fad',
  iconName: 'film-slash',
  icon: [640, 512, [], "e179", ["M400.4 411.5l87 68.5H128c-35.3 0-64-28.7-64-64V146.4l98.8 77.8c-.9-.2-1.8-.2-2.8-.2H128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-2.3-.5-4.4-1.3-6.4l71.1 56C233.1 293.9 224 305.9 224 320v64c0 17.7 14.3 32 32 32H384c6 0 11.6-1.7 16.4-4.5zM576 416c0 3.3-.2 6.5-.7 9.6L318.1 224H384c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v22.3L89.5 44.9C100.2 36.8 113.6 32 128 32H512c35.3 0 64 28.7 64 64V416zM112 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zM464 240v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H480c-8.8 0-16 7.2-16 16zM480 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H480z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faSquareArrowDownRight = {
  prefix: 'fad',
  iconName: 'square-arrow-down-right',
  icon: [448, 512, [], "e262", ["M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384zM160 368c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24V344c0 13.3-10.7 24-24 24H160z", "M312 368H160c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24V344c0 13.3-10.7 24-24 24z"]]
};
var faBookSparkles = {
  prefix: 'fad',
  iconName: 'book-sparkles',
  icon: [448, 512, ["book-spells"], "f6b8", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H352 256 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H256h96 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM264 200l-38.8 16.6c-6.5 2.8-6.5 11.9 0 14.7L264 248l16.6 38.8c2.8 6.5 11.9 6.5 14.7 0L312 248l38.8-16.6c6.5-2.8 6.5-11.9 0-14.7L312 200l-16.6-38.8c-2.8-6.5-11.9-6.5-14.7 0L264 200zM168.8 78.3L160 96l-17.7 8.8c-5.9 2.9-5.9 11.4 0 14.3L160 128l8.8 17.7c2.9 5.9 11.4 5.9 14.3 0L192 128l17.7-8.8c5.9-2.9 5.9-11.4 0-14.3L192 96l-8.8-17.7c-2.9-5.9-11.4-5.9-14.3 0z"]]
};
var faBookSpells = faBookSparkles;
var faWashingMachine = {
  prefix: 'fad',
  iconName: 'washing-machine',
  icon: [448, 512, ["washer"], "f898", ["M184 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 336c77.6 0 140.9-61.4 143.9-138.2C350 315.4 328.1 320 304 320c-32 0-56-16-80-32s-48-32-80-32c-19.7 0-40.6 4.7-59 10.4c-3.2 12-5 24.6-5 37.6c0 79.5 64.5 144 144 144z", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faWasher = faWashingMachine;
var faChild = {
  prefix: 'fad',
  iconName: 'child',
  icon: [320, 512, [], "f1ae", ["M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64z", "M144 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H144z"]]
};
var faLiraSign = {
  prefix: 'fad',
  iconName: 'lira-sign',
  icon: [320, 512, [8356], "f195", ["M48 192v64H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48zm0 96v44.5c0 6.6-.7 13.1-2 19.5H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48zm62.8 64c.8-6.4 1.2-12.9 1.2-19.5V288H224c17.7 0 32 14.3 32 32s-14.3 32-32 32H110.8zm1.2-96V192H224c17.7 0 32 14.3 32 32s-14.3 32-32 32H112z", "M176.4 96c-35.5 0-64.4 28.8-64.4 64.4V332.5c0 29-7.9 57.5-22.8 82.3l-.7 1.1H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l29.8-49.6c9-14.9 13.7-32 13.7-49.4V160.4C48 89.5 105.5 32 176.4 32c13.8 0 27.5 2.2 40.6 6.6l81.2 27.1c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L196.7 99.3c-6.6-2.2-13.4-3.3-20.4-3.3z"]]
};
var faUserVisor = {
  prefix: 'fad',
  iconName: 'user-visor',
  icon: [448, 512, [], "e04c", ["M336 176c2.4 0 4.7-.3 7-.8C324.2 222.5 278 256 224 256s-100.2-33.5-119-80.8c2.3 .5 4.6 .8 7 .8H336zM224 0c40.4 0 76.5 18.7 99.9 48H124.1C147.5 18.7 183.6 0 224 0zM328.9 437.4c-9.5 0-22.5 11.4-31.7 19.5c-2.6 2.2-4.8 4.2-6.6 5.6c-2.8 2-6.8 .1-6.5-3.5c3.9-36.5 15.9-66.5 35.7-89.5c1.5-1.8 4.9-1.9 6.1 .1c18.9 24.6 29 55 30.1 90.2c0 3.9-4.9 5.7-7.3 2.5c-12.2-17.2-17.6-23-19.9-25z", "M80 80c0-17.7 14.3-32 32-32H336c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V80zm48 32c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zm348.7-19.9c2.4 3.2 7.3 1.4 7.3-2.5c-1.1-35.3-11.3-65.6-30.1-90.2c-1.2-2-4.6-1.9-6.1-.1c-19.9 23-31.9 53-35.7 89.5c-.3 3.5 3.7 5.5 6.5 3.5c1.8-1.4 4.1-3.4 6.6-5.6l0 0c9.2-8.1 22.3-19.5 31.7-19.5c2.3 2 7.6 7.8 19.9 25z"]]
};
var faFilePlusMinus = {
  prefix: 'fad',
  iconName: 'file-plus-minus',
  icon: [384, 512, [], "e177", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM208 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V288h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V208zM128 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM208 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V288h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V208zM128 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]]
};
var faChessClockFlip = {
  prefix: 'fad',
  iconName: 'chess-clock-flip',
  icon: [640, 512, ["chess-clock-alt"], "f43e", ["M384 56c0-13.3 10.7-24 24-24H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H488v48H440V80H408c-13.3 0-24-10.7-24-24zM96 112c0-8.8 7.2-16 16-16H240c8.8 0 16 7.2 16 16v16H96V112zM235.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l48-48c6.2-6.2 16.4-6.2 22.6 0zM480 240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M0 192c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zM464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]]
};
var faChessClockAlt = faChessClockFlip;
var faSatellite = {
  prefix: 'fad',
  iconName: 'satellite',
  icon: [512, 512, [128752], "f7bf", ["M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4L322.3 96.4 233 7zM375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4L285.7 319.6 375 409z", "M377.4 41.4c12.5-12.5 32.8-12.5 45.3 0l48 48c12.5 12.5 12.5 32.8 0 45.3L270.2 335.1c11.4 24.6 17.8 52 17.8 80.9c0 31.7-7.7 61.5-21.2 87.8c-4.7 9-16.7 10.3-23.8 3.1L135.3 399.3l-16.4 16.4c.7 2.6 1.1 5.4 1.1 8.3c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32c2.9 0 5.6 .4 8.3 1.1l16.4-16.4L5.1 269.1c-7.2-7.2-5.9-19.2 3.1-23.8C34.5 231.7 64.3 224 96 224c28.9 0 56.3 6.4 80.9 17.8L377.4 41.4z"]]
};
var faPlaneLock = {
  prefix: 'fad',
  iconName: 'plane-lock',
  icon: [640, 512, [], "e558", ["M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c7.8 0 14-6.3 14-14V480 456c0-5-2.4-9.8-6.4-12.8L320 400V329.1l64.2 18.3c1.5-21.8 13.9-40.6 31.8-50.9V272c0-12.4 2-24.4 5.8-35.6L320 178.3V93.7C320 59.5 292 0 256 0z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faSteeringWheel = {
  prefix: 'fad',
  iconName: 'steering-wheel',
  icon: [512, 512, [], "f622", ["M288 445.3c-10.4 1.7-21.1 2.7-32 2.7s-21.6-.9-32-2.7V358.9L168.9 288H66.7c-1.7-10.4-2.7-21.1-2.7-32s.9-21.6 2.7-32H160l7.2-14.3c5.4-10.8 16.5-17.7 28.6-17.7H316.2c12.1 0 23.2 6.8 28.6 17.7L352 224h93.3c1.7 10.4 2.7 21.1 2.7 32s-.9 21.6-2.7 32H343.1L288 358.9v86.5z", "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]]
};
var faTag = {
  prefix: 'fad',
  iconName: 'tag',
  icon: [448, 512, [127991], "f02b", ["M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", ""]]
};
var faStretcher = {
  prefix: 'fad',
  iconName: 'stretcher',
  icon: [640, 512, [], "f825", ["M327.2 366.5L219.2 288h81.6L368 336.9 435.2 288h81.6l-108 78.5 37.3 27.1c9.8-6.1 21.4-9.7 33.9-9.7c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-5.3 .7-10.5 1.9-15.5L368 396.2l-49.9 36.3c1.2 5 1.9 10.2 1.9 15.5c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c12.4 0 24 3.5 33.9 9.7l37.3-27.1zM256 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm224 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z", "M15.2 77C34.5 58.9 64.9 59.8 83 79.2L188.8 192H592c26.5 0 48 21.5 48 48s-21.5 48-48 48H181.9c-22.1 0-43.2-9.2-58.4-25.3L13 144.8C-5.1 125.5-4.2 95.1 15.2 77z"]]
};
var faBookSection = {
  prefix: 'fad',
  iconName: 'book-section',
  icon: [448, 512, ["book-law"], "e0c1", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 256 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H256h96 64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zM228.5 241.3c-22.1-5.9-68-18.1-59.5-62.7c2.1-11.2 7.9-20.4 16.7-27.5c-12.2-9.4-20.7-23.1-16.7-44.5c6.1-31.8 40.4-48 87.5-41.3c8.3 1.2 18 3.5 30.2 7.3c8.4 2.6 13.2 11.6 10.5 20c-2.6 8.4-11.7 13.1-20 10.5c-10.6-3.3-18.6-5.3-25.2-6.2c-27.8-4-49.1 2.5-51.6 15.7c-1.8 9.3-.2 16.1 36.2 25.8l7.3 1.9 0 0c30.1 7.8 75.6 19.6 67 64.7c-2.1 11.2-8 20.5-16.7 27.6c12.6 9.5 20.7 23.2 16.7 44.4c-5.2 27-30.8 42.8-67.3 42.8c-6.4 0-13.2-.5-20.2-1.5c-12.9-1.8-26.6-6.2-38.6-10.1l0 0-5.8-1.9c-8.4-2.7-13.1-11.7-10.4-20.1c2.7-8.4 11.7-13.1 20.1-10.4l5.9 1.9c10.7 3.5 22.9 7.5 33.1 8.9c28 3.9 49.2-2.5 51.7-15.7c2.4-12.8-5.7-17.9-43.6-27.7l-7.5-2zm-2.9-72.8c-8.7 1.2-23 4.8-25.2 16.1c-1.8 9.3-.2 16.1 36.2 25.8c0 0 14.1 3.7 17.7 4.7c8.7-1.2 23-4.8 25.2-16.1c2.4-12.8-5.7-17.9-43.6-27.7c0 0-9.4-2.5-10.3-2.7z"]]
};
var faBookLaw = faBookSection;
var faInboxes = {
  prefix: 'fad',
  iconName: 'inboxes',
  icon: [512, 512, [], "e1bb", ["M79.3 160l38.4-96H394.3l38.4 96h-45c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7h-45zM48 352h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z", "M79.3 160l38.4-96H394.3l38.4 96h-45c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7h-45zm33-160c-22.9 0-43.5 13.9-52 35.2L4 175.8c-2.6 6.6-4 13.7-4 20.8V264c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V196.6c0-7.1-1.4-14.2-4-20.8L451.7 35.2C443.2 13.9 422.6 0 399.8 0H112.2z"]]
};
var faCoffeeBean = {
  prefix: 'fad',
  iconName: 'coffee-bean',
  icon: [448, 512, [], "e13e", ["M337 208.9c25.6-25.8 47.1-69.8 61.6-104.2c3.4-8 6.4-15.7 9.2-22.8c66 75.9 44.1 210.4-51.7 306.2C270.2 474 153.2 500.4 75.2 457.5c3.9-9.1 8.6-19.5 13.9-30.5c16.5-34.5 37.1-71.1 55.9-90.1c28.7-28.9 57.5-43.4 89.7-59.4l.8-.4c31.9-15.9 67-33.4 101.5-68.2zM36.5 426.5c-67-75.7-45.3-211 50.9-307.1c86-86 203.2-112.4 281.1-69.2c-3.7 10.2-8.5 22.7-14.1 36c-14.5 34.5-33 70.5-51.4 89c-28.7 28.9-57.5 43.4-89.7 59.4l-.8 .4c-31.9 15.9-67 33.4-101.5 68.2c-25.2 25.4-48.7 68.8-65.1 103.2c-3.4 7-6.5 13.8-9.4 20.2z", "M337 208.9c25.6-25.8 47.1-69.8 61.6-104.2c3.4-8 6.4-15.7 9.2-22.8c-2.2-2.5-4.5-5-6.9-7.4c-9.8-9.8-20.7-17.9-32.5-24.4c-3.7 10.2-8.5 22.7-14.1 36c-14.5 34.5-33 70.5-51.4 89c-28.7 28.9-57.5 43.4-89.7 59.4l-.8 .4c-31.9 15.9-67 33.4-101.5 68.2c-25.2 25.4-48.7 68.8-65.1 103.2c-3.4 7-6.5 13.8-9.4 20.2c1.9 2.2 4 4.3 6.1 6.4c9.8 9.8 20.8 18 32.7 24.6c3.9-9.1 8.6-19.5 13.9-30.5c16.5-34.5 37.1-71.1 55.9-90.1c28.7-28.9 57.5-43.4 89.7-59.4l.8-.4c31.9-15.9 67-33.4 101.5-68.2z"]]
};
var faCircleYen = {
  prefix: 'fad',
  iconName: 'circle-yen',
  icon: [512, 512, [], "e5d0", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.9 150.2c9.8-8.9 25-8.2 33.9 1.6L256 220.3l62.2-68.5c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9L303 240h25c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v25c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V288H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h25l-50.8-55.9c-8.9-9.8-8.2-25 1.6-33.9z", "M193.8 151.9c-8.9-9.8-24.1-10.5-33.9-1.6s-10.5 24.1-1.6 33.9L209 240H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v16H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v25c0 13.3 10.7 24 24 24s24-10.7 24-24V352h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V288h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H303l50.8-55.9c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6L256 220.3l-62.2-68.5z"]]
};
var faBracketsCurly = {
  prefix: 'fad',
  iconName: 'brackets-curly',
  icon: [576, 512, [], "f7ea", ["M512 128c0-53-43-96-96-96H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32 14.3 32 32v37.5c0 25.5 10.1 49.9 28.1 67.9L498.7 256l-22.6 22.6c-18 18-28.1 42.4-28.1 67.9V384c0 17.7-14.3 32-32 32H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c53 0 96-43 96-96V346.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3l-45.3-45.3c-6-6-9.4-14.1-9.4-22.6V128z", "M64 128c0-53 43-96 96-96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32 14.3-32 32v37.5c0 25.5-10.1 49.9-28.1 67.9L77.3 256l22.6 22.6c18 18 28.1 42.4 28.1 67.9V384c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-53 0-96-43-96-96V346.5c0-8.5-3.4-16.6-9.4-22.6L9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l45.3-45.3c6-6 9.4-14.1 9.4-22.6V128z"]]
};
var faEllipsisStrokeVertical = {
  prefix: 'fad',
  iconName: 'ellipsis-stroke-vertical',
  icon: [192, 512, ["ellipsis-v-alt"], "f39c", ["M96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96a72 72 0 1 0 0-144 72 72 0 1 0 0 144z", "M96 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 96A72 72 0 1 1 96 24a72 72 0 1 1 0 144zm0 224a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 96a72 72 0 1 1 0-144 72 72 0 1 1 0 144z"]]
};
var faEllipsisVAlt = faEllipsisStrokeVertical;
var faComment = {
  prefix: 'fad',
  iconName: 'comment',
  icon: [512, 512, [128489, 61669], "f075", ["M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z", ""]]
};
var faSquare1 = {
  prefix: 'fad',
  iconName: 'square-1',
  icon: [448, 512, [], "e256", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm236 35.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L200 193.4V336H160c-13.3 0-24 10.7-24 24s10.7 24 24 24h64 64c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V152c0-8.6-4.6-16.5-12-20.8z", "M248 152c0-8.6-4.6-16.5-12-20.8s-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L200 193.4V336H160c-13.3 0-24 10.7-24 24s10.7 24 24 24h64 64c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V152z"]]
};
var faCakeCandles = {
  prefix: 'fad',
  iconName: 'cake-candles',
  icon: [448, 512, [127874, "birthday-cake", "cake"], "f1fd", ["M86.4 5.5C88.4 2.1 92 0 96 0s7.6 2.1 9.6 5.5l24.5 42.1c3.8 6.5 5.8 14 5.8 21.6V72c0 22.1-17.9 40-40 40s-40-17.9-40-40V69.2c0-7.6 2-15 5.8-21.6L86.4 5.5zM0 288c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64v89.2c-8.4 4-18.1 6.8-28.8 6.8c-35.9 0-67.2-32-67.2-32s-28.1 32-64 32s-64-32-64-32s-28.1 32-64 32s-64-32-64-32s-31.3 32-67.2 32c-10.7 0-20.4-2.8-28.8-6.8V288zM189.8 47.6L214.4 5.5C216.4 2.1 220 0 224 0s7.6 2.1 9.6 5.5l24.5 42.1c3.8 6.5 5.8 14 5.8 21.6V72c0 22.1-17.9 40-40 40s-40-17.9-40-40V69.2c0-7.6 2-15 5.8-21.6zM342.4 5.5C344.4 2.1 348 0 352 0s7.6 2.1 9.6 5.5l24.5 42.1c3.8 6.5 5.8 14 5.8 21.6V72c0 22.1-17.9 40-40 40s-40-17.9-40-40V69.2c0-7.6 2-15 5.8-21.6L342.4 5.5z", "M128 176v48H64V176c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v48H192V176c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v48H320V176c0-17.7 14.3-32 32-32s32 14.3 32 32zM0 464V377.2c8.4 4 18.1 6.8 28.8 6.8C64.7 384 96 352 96 352s28.1 32 64 32s64-32 64-32s28.1 32 64 32s64-32 64-32s31.3 32 67.2 32c10.7 0 20.4-2.8 28.8-6.8V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"]]
};
var faBirthdayCake = faCakeCandles;
var faCake = faCakeCandles;
var faHeadSide = {
  prefix: 'fad',
  iconName: 'head-side',
  icon: [512, 512, [], "f6e9", ["M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M320 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faEnvelope = {
  prefix: 'fad',
  iconName: 'envelope',
  icon: [512, 512, [128386, 9993, 61443], "f0e0", ["M0 112V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V112c0 15.1-7.1 29.3-19.2 38.4L275.2 313.6c-11.4 8.5-27 8.5-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112z", "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48z"]]
};
var faDollyEmpty = {
  prefix: 'fad',
  iconName: 'dolly-empty',
  icon: [576, 512, [], "f473", ["M256 512a96 96 0 1 0 0-192 96 96 0 1 0 0 192z", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64h72.9L197 340.2c16.3-12.7 36.7-20.2 59-20.2c.6 0 1.2 0 1.7 0L165.7 43.8C156.9 17.6 132.5 0 104.9 0H32zM331.8 357c12.7 16.3 20.2 36.7 20.2 59c0 .6 0 1.2 0 1.7l202.1-67.4c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2L331.8 357z"]]
};
var faFaceTissue = {
  prefix: 'fad',
  iconName: 'face-tissue',
  icon: [512, 512, [], "e39c", ["M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 11.5 .8 22.9 2.2 34c1.9-.6 3.9-1 5.9-1.4l192-32c15.3-2.5 30.9 2.4 41.8 13.4s16 26.5 13.4 41.8l-7.9 47.2 8.5 5.7 39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 371.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0l-5.4-3.6L223.3 503.9c-.3 2-.8 4-1.4 5.9c11.1 1.5 22.5 2.2 34 2.2zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9z", "M223.8 306.6c.8-5.1-.8-10.3-4.5-13.9s-8.8-5.3-13.9-4.5l-192 32c-6.7 1.1-11.9 6.3-13.1 13s1.9 13.4 7.8 16.7l45.5 26L32.5 460.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l84.2-21.1 26 45.5c3.4 5.9 10 9 16.7 7.8s11.9-6.4 13-13.1l32-192z"]]
};
var faAnglesUp = {
  prefix: 'fad',
  iconName: 'angles-up',
  icon: [448, 512, ["angle-double-up"], "f102", ["M201.4 233.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 86.6 438.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z", "M201.4 41.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 109.3 86.6 246.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"]]
};
var faAngleDoubleUp = faAnglesUp;
var faBinRecycle = {
  prefix: 'fad',
  iconName: 'bin-recycle',
  icon: [576, 512, [], "e5f7", ["M0 64C0 46.3 14.3 32 32 32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm32 64H544L517.3 421.8c-3 33-30.6 58.2-63.7 58.2H122.4c-33.1 0-60.7-25.2-63.7-58.2L32 128zm256 88c2.2 0 4.3 1.1 5.5 2.9l20.7 29.6c7.3 10.5 21.6 13.4 32.4 6.6c11.7-7.3 14.8-22.9 6.9-34.1l-20.7-29.6c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3l-20.7 29.6c-7.9 11.3-4.7 26.8 6.9 34.1c10.8 6.8 25.1 3.9 32.4-6.6l20.7-29.6c1.3-1.8 3.3-2.9 5.5-2.9zm-88.3 77.1c-10.8-6.8-25.1-3.9-32.4 6.6l-21.5 30.7c-6.4 9.1-9.8 20-9.8 31.2c0 30.1 24.4 54.4 54.4 54.4H240c13.3 0 24-10.7 24-24s-10.7-24-24-24H190.4c-3.5 0-6.4-2.9-6.4-6.4c0-1.3 .4-2.6 1.2-3.7l21.5-30.7c7.9-11.3 4.7-26.8-6.9-34.1zM312 392c0 13.3 10.7 24 24 24h49.6c30.1 0 54.4-24.4 54.4-54.4c0-11.2-3.4-22.1-9.8-31.2l-21.5-30.7c-7.3-10.5-21.6-13.4-32.4-6.6c-11.7 7.3-14.8 22.9-6.9 34.1l21.5 30.7c.8 1.1 1.2 2.4 1.2 3.7c0 3.5-2.9 6.4-6.4 6.4H336c-13.3 0-24 10.7-24 24z", "M282.5 218.9c1.3-1.8 3.3-2.9 5.5-2.9s4.3 1.1 5.5 2.9l20.7 29.6c7.3 10.5 21.6 13.4 32.4 6.6c11.7-7.3 14.8-22.9 6.9-34.1l-20.7-29.6c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3l-20.7 29.6c-7.9 11.3-4.7 26.8 6.9 34.1c10.8 6.8 25.1 3.9 32.4-6.6l20.7-29.6zM206.6 327.2c7.9-11.3 4.7-26.8-6.9-34.1c-10.8-6.8-25.1-3.9-32.4 6.6l-21.5 30.7c-6.4 9.1-9.8 20-9.8 31.2c0 30.1 24.4 54.4 54.4 54.4H240c13.3 0 24-10.7 24-24s-10.7-24-24-24H190.4c-3.5 0-6.4-2.9-6.4-6.4c0-1.3 .4-2.6 1.2-3.7l21.5-30.7zM336 368c-13.3 0-24 10.7-24 24s10.7 24 24 24h49.6c30.1 0 54.4-24.4 54.4-54.4c0-11.2-3.4-22.1-9.8-31.2l-21.5-30.7c-7.3-10.5-21.6-13.4-32.4-6.6c-11.7 7.3-14.8 22.9-6.9 34.1l21.5 30.7c.8 1.1 1.2 2.4 1.2 3.7c0 3.5-2.9 6.4-6.4 6.4H336z"]]
};
var faPaperclip = {
  prefix: 'fad',
  iconName: 'paperclip',
  icon: [448, 512, [128206], "f0c6", ["M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z", ""]]
};
var faChartLineDown = {
  prefix: 'fad',
  iconName: 'chart-line-down',
  icon: [512, 512, [128201], "f64d", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M326.6 121.4c-12.5-12.5-32.8-12.5-45.3 0L208 194.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0L304 189.3l57.4 57.4L329 279c-15.1 15.1-4.4 41 17 41H456c13.3 0 24-10.7 24-24V185.9c0-21.4-25.9-32.1-41-17l-32.4 32.4-80-80z"]]
};
var faArrowRightToCity = {
  prefix: 'fad',
  iconName: 'arrow-right-to-city',
  icon: [640, 512, [], "e4b3", ["M336 0c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48h96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16zm144 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16z", "M121.4 153.4c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3z"]]
};
var faLockA = {
  prefix: 'fad',
  iconName: 'lock-a',
  icon: [448, 512, [], "e422", ["M224 64c44.2 0 80 35.8 80 80v48H144V144c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H368V144C368 64.5 303.5 0 224 0S80 64.5 80 144zm49.7 280.8L209.6 265c.8-1.6 1.8-3 3-4.3c1.4-1.5 3.1-2.6 5-3.4c2.1-.9 4.2-1.3 6.4-1.3s4.3 .4 6.4 1.3c1.8 .8 3.5 1.9 5 3.4c1.3 1.3 2.3 2.7 3.1 4.3l79.9 159.9c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L270.1 400H177.9l-19.6 39.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5zM193.9 368h60.2L224 307.8 193.9 368z", "M235.3 260.7c-1.4-1.4-3.1-2.6-4.9-3.4c-2.1-.9-4.2-1.3-6.4-1.3s-4.3 .4-6.4 1.3c-1.8 .8-3.5 1.9-4.9 3.4c-1.3 1.3-2.3 2.7-3.1 4.3L129.7 424.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L177.9 400h92.2l19.6 39.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5L238.4 265c-.8-1.6-1.8-3-3.1-4.3zM254.1 368l-60.2 0L224 307.8 254.1 368z"]]
};
var faRibbon = {
  prefix: 'fad',
  iconName: 'ribbon',
  icon: [448, 512, [127895], "f4d6", ["M146 118.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L352 64 328 32C312.9 11.9 289.2 0 264 0H184c-25.2 0-48.9 11.9-64 32L96 64l50 54.6zm-2.4 172.7L27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l97.7-106.3-83.3-95.6z", "M96 64L420.9 418.5c13.9 15.1 10.1 39.2-7.7 49.4L358.8 499c-13.2 7.6-30 4.7-40-6.8L87.6 227.1C72.4 209.6 64 187.2 64 164v-23c0-19 5.6-37.5 16.1-53.3L96 64zM328.4 270.2L245.7 180 352 64l19.4 33.9c8.3 14.5 12.6 30.9 12.6 47.6v25.8c0 23.6-8.7 46.4-24.5 64l-31.2 34.8z"]]
};
var faLungs = {
  prefix: 'fad',
  iconName: 'lungs',
  icon: [640, 512, [129729], "f604", ["M256 210.8V165.3C256 127 225 96 186.7 96c-21.7 0-42.8 10.2-55.8 28.8c-15.4 22.1-44.3 65.4-71 116.9C33.4 292.6 7.5 354.2 .2 412c-.2 1.3-.2 2.6-.2 4v7c0 49.1 39.8 89 89 89c7.3 0 14.5-.9 21.6-2.7l72.7-18.2C226 480.5 256 442.1 256 398V286.7L161.2 347c-14.9 9.5-34.7 5.1-44.2-9.8s-5.1-34.7 9.8-44.2L256 210.8zM478.8 347L384 286.7V398c0 44.1 30 82.5 72.7 93.1l72.7 18.2c7.1 1.8 14.3 2.7 21.6 2.7c49.1 0 89-39.8 89-89v-7c0-1.3-.1-2.7-.2-4c-7.2-57.9-33.1-119.4-59.6-170.3c-26.8-51.5-55.6-94.8-71-116.9c-13-18.6-34-28.8-55.8-28.8C415 96 384 127 384 165.3v45.5L513.2 293c14.9 9.5 19.3 29.3 9.8 44.2s-29.3 19.3-44.2 9.8z", "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V164.1c0 16.4-8.4 31.7-22.2 40.5L126.8 293c-14.9 9.5-19.3 29.3-9.8 44.2s29.3 19.3 44.2 9.8l139-88.4c7.3-4.6 13.9-10.1 19.9-16.1c5.9 6 12.6 11.5 19.9 16.1l139 88.4c14.9 9.5 34.7 5.1 44.2-9.8s5.1-34.7-9.8-44.2l-139-88.4c-13.8-8.8-22.2-24.1-22.2-40.5V32z"]]
};
var faPersonPinball = {
  prefix: 'fad',
  iconName: 'person-pinball',
  icon: [640, 512, [], "e21d", ["M544 0c-17.7 0-32 14.3-32 32V74.8c0 6.9 1.1 13.7 3.3 20.2l32.8 98.5-295 49.2c1.9 4 2.9 8.6 2.9 13.3c0 17.7-14.3 32-32 32H192V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384H576v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224v-8V178.2 32c0-17.7-14.3-32-32-32H544zM256 312a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM96 241.7v65.1l49.9 49.9c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L18.7 320C6.7 308 0 291.7 0 274.7V186.6C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64H224c17.7 0 32 14.3 32 32s-14.3 32-32 32H152.6c-16 0-31-8-39.9-21.4L96 241.7zM0 480L0 346.5l64 64V480v0c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]]
};
var faArrowUp91 = {
  prefix: 'fad',
  iconName: 'arrow-up-9-1',
  icon: [576, 512, ["sort-numeric-up-alt"], "f887", ["M445.7 148.9A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2zM464 320v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4s13.3 15.7 13.3 26z", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z"]]
};
var faSortNumericUpAlt = faArrowUp91;
var faAppleCore = {
  prefix: 'fad',
  iconName: 'apple-core',
  icon: [384, 512, [], "e08f", ["M208 112H192c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80z", "M29.9 462.4c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137c-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c19.3 0 36.1 5.4 50.3 14.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3c-34.9 0-69.8-18.3-98.1-49.6z"]]
};
var faCircleY = {
  prefix: 'fad',
  iconName: 'circle-y',
  icon: [512, 512, [], "e12f", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM170.1 152.3L256 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L280 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24V297L133.9 183.7c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z", "M136.3 149.9c10-8.7 25.2-7.6 33.9 2.4L256 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L280 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24V297L133.9 183.7c-8.7-10-7.6-25.2 2.4-33.9z"]]
};
var faH6 = {
  prefix: 'fad',
  iconName: 'h6',
  icon: [640, 512, [], "e413", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M537 116c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L389 198.5c-24 29.9-37 67.1-37 105.5c0 79.5 64.5 144 144 144s144-64.5 144-144c0-77.6-61.4-140.9-138.3-143.9L537 116zm39 188a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z"]]
};
var faLitecoinSign = {
  prefix: 'fad',
  iconName: 'litecoin-sign',
  icon: [384, 512, [], "e1d3", ["M64 213.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L64 280.1V213.6zm64 48.3l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3v66.6z", "M96 32c17.7 0 32 14.3 32 32V416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"]]
};
var faCircleSmall = {
  prefix: 'fad',
  iconName: 'circle-small',
  icon: [320, 512, [], "e122", ["M0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z", ""]]
};
var faBorderNone = {
  prefix: 'fad',
  iconName: 'border-none',
  icon: [448, 512, [], "f850", ["M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z", ""]]
};
var faArrowTurnDownLeft = {
  prefix: 'fad',
  iconName: 'arrow-turn-down-left',
  icon: [512, 512, [], "e2e1", ["M448 64c0-17.7 14.3-32 32-32s32 14.3 32 32V224c0 53-43 96-96 96H109.3l-32-32 32-32H416c17.7 0 32-14.3 32-32V64z", "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 288 182.6 182.6c12.5-12.5 12.5-32.8 0-45.3z"]]
};
var faCircleNodes = {
  prefix: 'fad',
  iconName: 'circle-nodes',
  icon: [512, 512, [], "e4e2", ["M418.4 157.9c-5.9 1.4-12 2.1-18.4 2.1c-16.5 0-31.9-5-44.6-13.6L317.6 354.1c5.9-1.4 12-2.1 18.4-2.1c16.5 0 31.9 5 44.6 13.6l37.8-207.7zM114.1 280.4L259.7 407.8c6.8-21.3 22.2-38.7 42.1-48.2L156.3 232.2c-6.8 21.3-22.2 38.7-42.1 48.2zM160 210.5l183.8-73.5C329.1 122.4 320 102.3 320 80c0-.8 0-1.7 0-2.5L136.2 151.1C150.9 165.6 160 185.7 160 208c0 .8 0 1.7 0 2.5z", "M320 80a80 80 0 1 1 160 0A80 80 0 1 1 320 80zM256 432a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM80 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]]
};
var faParachuteBox = {
  prefix: 'fad',
  iconName: 'parachute-box',
  icon: [512, 512, [], "f4cd", ["M24.9 192L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.8-1.9-15.2-5.2-21.7L487.1 192H443.8L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2H272V192H240V320H208c-7 0-13.7 1.5-19.7 4.2L68.2 192H24.9z", "M128.5 192H383.5c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16zM358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h77.6c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7zm-205.7 0C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192H96.5c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3z"]]
};
var faMessageMedical = {
  prefix: 'fad',
  iconName: 'message-medical',
  icon: [512, 512, ["comment-alt-medical"], "f7f4", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm224 64v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240h48c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H288V128c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z", "M240 112c-8.8 0-16 7.2-16 16v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240h48c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16l-48 0V128c0-8.8-7.2-16-16-16H240z"]]
};
var faCommentAltMedical = faMessageMedical;
var faRugbyBall = {
  prefix: 'fad',
  iconName: 'rugby-ball',
  icon: [512, 512, [], "e3c6", ["M368 16H336C159.3 16 16 159.3 16 336v32c0 30.1 10.4 57.7 27.7 79.6C17.9 395.7 73.4 280.2 176.8 176.8S395.7 17.9 447.5 43.7C425.7 26.4 398.1 16 368 16zM468.3 64.5c25.8 51.9-29.7 167.3-133.1 270.7S116.3 494.1 64.4 468.3C86.3 485.6 113.9 496 144 496h32c176.7 0 320-143.3 320-320V144c0-30.1-10.4-57.7-27.7-79.5z", "M64.4 468.3c-7.7-6.1-14.6-13.1-20.7-20.7C17.9 395.7 73.4 280.2 176.8 176.8S395.7 17.9 447.5 43.7c7.7 6.1 14.6 13.1 20.7 20.7c25.8 51.9-29.7 167.3-133.1 270.7S116.3 494.1 64.4 468.3z"]]
};
var faCommentMusic = {
  prefix: 'fad',
  iconName: 'comment-music',
  icon: [512, 512, [], "f8b0", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm96-320v32V288c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V183.1l-96 36V320c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V208 176c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z", "M345.1 114.8c4.3 3 6.9 7.9 6.9 13.2v32V288c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V183.1l-96 36V320c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V208 176c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8z"]]
};
var faIndent = {
  prefix: 'fad',
  iconName: 'indent',
  icon: [448, 512, [], "f03c", ["M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM224 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zM192 320c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z", "M127.8 243.4c8.2 6.4 8.2 18.9 0 25.3L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3z"]]
};
var faTreeDeciduous = {
  prefix: 'fad',
  iconName: 'tree-deciduous',
  icon: [512, 512, [127795, "tree-alt"], "f400", ["M351.6 86.8c9.9-4.4 20.9-6.8 32.4-6.8c44.2 0 80 35.8 80 80c0 14.4-3.8 27.9-10.5 39.6C487.9 214.2 512 248.3 512 288c0 53-43 96-96 96H288V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V384H96c-53 0-96-43-96-96c0-39.7 24.1-73.8 58.5-88.4C51.8 187.9 48 174.4 48 160c0-44.2 35.8-80 80-80c11.5 0 22.5 2.4 32.4 6.8C165 38.1 206.1 0 256 0s91 38.1 95.6 86.8z", "M256 128c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32z"]]
};
var faTreeAlt = faTreeDeciduous;
var faPuzzlePieceSimple = {
  prefix: 'fad',
  iconName: 'puzzle-piece-simple',
  icon: [640, 512, ["puzzle-piece-alt"], "e231", ["M264.8 64C277.6 64 288 74.4 288 87.2v0c0 9.2-5.8 17.3-13.2 22.8c-11.6 8.7-18.8 20.7-18.8 34c0 26.5 28.7 48 64 48s64-21.5 64-48c0-13.3-7.2-25.3-18.8-34c-7.4-5.5-13.2-13.6-13.2-22.8v0C352 74.4 362.4 64 375.2 64H464c26.5 0 48 21.5 48 48v88.8c0 12.8 10.4 23.2 23.2 23.2v0c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2v0c-12.8 0-23.2 10.4-23.2 23.2V400c0 26.5-21.5 48-48 48H375.2c-12.8 0-23.2-10.4-23.2-23.2v0c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8v0c0 12.8-10.4 23.2-23.2 23.2H176c-26.5 0-48-21.5-48-48V311.2c0-12.8-10.4-23.2-23.2-23.2v0c-9.2 0-17.3 5.8-22.8 13.2C73.3 312.8 61.3 320 48 320c-26.5 0-48-28.7-48-64s21.5-64 48-64c13.3 0 25.3 7.2 34 18.8c5.5 7.4 13.6 13.2 22.8 13.2v0c12.8 0 23.2-10.4 23.2-23.2V112c0-26.5 21.5-48 48-48h88.8z", ""]]
};
var faPuzzlePieceAlt = faPuzzlePieceSimple;
var faTruckFieldUn = {
  prefix: 'fad',
  iconName: 'truck-field-un',
  icon: [640, 512, [], "e58e", ["M176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm288 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M96 32C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96h66.3c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38H375.4C364.4 44.9 343.7 32 320 32H96zm288 96h43.2l42.7 96H384V128zm-130.7 7.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faNfcTrash = {
  prefix: 'fad',
  iconName: 'nfc-trash',
  icon: [640, 512, [], "e1fd", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H381.6l-6.1-84.8C366.9 407.8 352.4 416 336 416H112c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16V240 144c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16v66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-26.5 21.5-48 48-48h80c26.5 0 48 21.5 48 48v50.7c5-1.8 10.4-2.7 16-2.7h18.3l2.7-5.5c5.7-11.3 15.4-19.7 26.9-23.8V96c0-35.3-28.7-64-64-64H64z", "M464 192c-6.1 0-11.6 3.4-14.3 8.8L438.1 224H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H576h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H585.9l-11.6-23.2c-2.7-5.4-8.2-8.8-14.3-8.8H464zm-64 96l13.9 194.3C415.1 499 429 512 445.8 512H578.2c16.8 0 30.7-13 31.9-29.7L624 288H400z"]]
};
var faHourglass = {
  prefix: 'fad',
  iconName: 'hourglass',
  icon: [384, 512, [9203, 62032, "hourglass-empty"], "f254", ["M32 75V64H96V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64h64V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11H32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1l22.6-22.6L78.9 188.1C48.9 158.1 32 117.4 32 75z", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faHourglassEmpty = faHourglass;
var faMountain = {
  prefix: 'fad',
  iconName: 'mountain',
  icon: [512, 512, [127956], "f6fc", ["M396.6 224H272c-10.1 0-19.6 4.7-25.6 12.8l-25.6 34.1c-6.4 8.5-19.2 8.5-25.6 0l-59.5-79.3L225.2 49c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17L396.6 224z", "M396.6 224H272c-10.1 0-19.6 4.7-25.6 12.8l-25.6 34.1c-6.4 8.5-19.2 8.5-25.6 0l-59.5-79.3L8.6 394.4C3 403.3 0 413.6 0 424.1C0 455 25 480 55.9 480H456.1c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L396.6 224z"]]
};
var faFileXmark = {
  prefix: 'fad',
  iconName: 'file-xmark',
  icon: [384, 512, ["file-times"], "f317", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM111 239c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zM111 239c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]]
};
var faFileTimes = faFileXmark;
var faHouseHeart = {
  prefix: 'fad',
  iconName: 'house-heart',
  icon: [576, 512, ["home-heart"], "f4c9", ["M64.1 448L64 270.5l224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1H128.1c-35.3 0-64-28.6-64-64zM176 317.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z", "M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2l-256-224zM176 317.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]]
};
var faHomeHeart = faHouseHeart;
var faHouseChimneyBlank = {
  prefix: 'fad',
  iconName: 'house-chimney-blank',
  icon: [576, 512, [], "e3b0", ["M64 270.5L64.1 448c0 35.3 28.7 64 64 64H448.5c35.4 0 64.1-28.7 64-64.1l-.4-177.3L288 74.5 64 270.5z", "M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2L512 185.5V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v37.5L309.1 7.9z"]]
};
var faMeterBolt = {
  prefix: 'fad',
  iconName: 'meter-bolt',
  icon: [640, 512, [], "e1e9", ["M442.8 431c-46.7 49.8-113.1 81-186.8 81C114.6 512 0 397.4 0 256S114.6 0 256 0C393 0 504.8 107.5 511.7 242.8L402 330.5c-15.9 12.7-22.1 34.1-15.3 53.4s24.9 32.1 45.3 32.1h18.3l-7.5 15zM160 128c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zm96 0c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zm96 0c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32z", "M606.3 247.2c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L449.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H553.9l52.4-104.8z"]]
};
var faUserDoctor = {
  prefix: 'fad',
  iconName: 'user-doctor',
  icon: [448, 512, ["user-md"], "f0f0", ["M352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z", "M280 304c2.7 0 5.3 .1 8 .2V362c-27.6 7.1-48 32.2-48 62v40c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16V424c0-17.7 14.3-32 32-32s32 14.3 32 32v24c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V424c0-29.8-20.4-54.9-48-62V308.8C393.5 326.7 448 393 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-79 54.5-145.3 128-163.2v61.5c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V304.2c2.7-.1 5.3-.2 8-.2H280zM144 400a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faUserMd = faUserDoctor;
var faSlashBack = {
  prefix: 'fad',
  iconName: 'slash-back',
  icon: [320, 512, [], "5c", ["M16.1 4.2C.8 13-4.6 32.5 4.2 47.9l256 448c8.8 15.3 28.3 20.7 43.7 11.9s20.7-28.3 11.9-43.7l-256-448C51 .8 31.5-4.6 16.1 4.2z", ""]]
};
var faCircleInfo = {
  prefix: 'fad',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V272H216c-13.3 0-24-10.7-24-24z"]]
};
var faInfoCircle = faCircleInfo;
var faFishingRod = {
  prefix: 'fad',
  iconName: 'fishing-rod',
  icon: [448, 512, [], "e3a8", ["M287 49.2c2.9-.8 5.8-1.2 8.8-1.2C313.6 48 328 62.4 328 80.1V136c0 13.3 10.7 24 24 24s24-10.7 24-24V80.1C376 35.9 340.1 0 295.9 0c-7.4 0-14.9 1-22 3.1L196.7 25.1C103.9 51.6 40 136.4 40 232.8V288H32c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H88V232.8c0-75 49.7-140.9 121.8-161.5L287 49.2z", "M345 195.9c-33.5 20.3-89 76.6-89 148.1c0 32 16 80 64 112l-27.3 27.3c-3 3-4.7 7.1-4.7 11.3V496c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-1.4c0-4.2-1.7-8.3-4.7-11.3L384 456c48-32 64-80 64-112c0-71.6-55.6-127.8-89-148.1c-4.3-2.6-9.6-2.6-14 0zM360 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faHammerCrash = {
  prefix: 'fad',
  iconName: 'hammer-crash',
  icon: [640, 512, [], "e414", ["M302.2 318.4l-18.3 60.1c-1.9 6.3 .2 13.1 5.3 17.2s12.2 4.6 17.9 1.4l91.4-52.2 59.7 86.8c3.7 5.4 10.3 8 16.7 6.5s11.2-6.7 12.2-13.1l16.2-104.1 105.1 7.4c6.5 .5 12.7-3.1 15.5-9s1.8-12.9-2.6-17.8L550.1 224l71.3-77.5c4.4-4.8 5.5-11.9 2.6-17.8s-9-9.5-15.5-9l-105.1 7.4L487.3 23c-1-6.5-5.9-11.7-12.2-13.1s-13 1.1-16.7 6.5L405.6 93c12 18.4 14.2 42.5 3.7 63.6l-64 128c-8.9 17.8-25 29.7-43.1 33.8z", "M43.4 33.7C48.8 22.8 59.9 16 72 16H192c5 0 9.9 1.2 14.3 3.4l160 80c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-7.9 15.8-27.1 22.2-42.9 14.3l-65.9-32.9 0 0L122 208.8l0 0L17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80zM5.1 442.5L107.6 237.4l85.9 42.9L90.9 485.5c-11.9 23.7-40.7 33.3-64.4 21.5S-6.8 466.2 5.1 442.5z"]]
};
var faMessageHeart = {
  prefix: 'fad',
  iconName: 'message-heart',
  icon: [512, 512, [], "e5c9", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM144 173.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z", "M205.3 112c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]]
};
var faCloudMeatball = {
  prefix: 'fad',
  iconName: 'cloud-meatball',
  icon: [512, 512, [], "f73b", ["M221.2 320c-12.5-11.7-32.2-11.4-44.4 .8c-12.5 12.5-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3c-12.2-12.2-31.9-12.5-44.4-.8H288c0-17.7-14.3-32-32-32s-32 14.3-32 32h-2.8zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H371.3c-9.5-23.5-32.5-40-59.3-40c-2 0-3.9 .1-5.8 .3C294.4 265.5 276.3 256 256 256s-38.4 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-26.9 0-49.9 16.5-59.3 40H96z"]]
};
var faCameraPolaroid = {
  prefix: 'fad',
  iconName: 'camera-polaroid',
  icon: [576, 512, [], "f8aa", ["M288 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM0 361.7c0-3.3 .2-6.5 .7-9.7H575.3c.5 3.2 .7 6.4 .7 9.7V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V361.7zM112 400c-8.8 0-16 7.2-16 16s7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z", "M64 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V246.3l53.3 79.9c5.2 7.8 8.6 16.6 10 25.8H.7c1.4-9.2 4.8-18 10-25.8L64 246.3V96zM288 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM448 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
};
var faCamera = {
  prefix: 'fad',
  iconName: 'camera',
  icon: [512, 512, [62258, "camera-alt"], "f030", ["M256 384a96 96 0 1 0 0-192 96 96 0 1 0 0 192z", "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]]
};
var faCameraAlt = faCamera;
var faSquareVirus = {
  prefix: 'fad',
  iconName: 'square-virus',
  icon: [448, 512, [], "e578", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24z", "M247.8 117.7c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 29.3-35.4 43.9-56.1 23.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.7 20.7 6 56.1-23.2 56.1c-13.3 0-24 10.7-24 24s10.7 24 24 24c29.3 0 43.9 35.4 23.2 56.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.7-20.7 56.1-6 56.1 23.2c0 13.3 10.7 24 24 24s24-10.7 24-24c0-29.3 35.4-43.9 56.1-23.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.7-20.7-6-56.1 23.2-56.1c13.3 0 24-10.7 24-24s-10.7-24-24-24c-29.3 0-43.9-35.4-23.2-56.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.7 20.7-56.1 6-56.1-23.2zM160 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faCartArrowUp = {
  prefix: 'fad',
  iconName: 'cart-arrow-up',
  icon: [576, 512, [], "e3ee", ["M312 288H170.7L124.5 45.5c-.9-4.8-2.4-9.3-4.4-13.5h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H360l0-110.1 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23L312 288z", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-51.6-271C119.5 19.1 96.4 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM312 177.9L312 288h48V177.9l23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23z"]]
};
var faMeteor = {
  prefix: 'fad',
  iconName: 'meteor',
  icon: [512, 512, [9732], "f753", ["M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256z", "M64 320a128 128 0 1 1 256 0A128 128 0 1 1 64 320zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faCarOn = {
  prefix: 'fad',
  iconName: 'car-on',
  icon: [512, 512, [], "e4dd", ["M256 0c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM39 39c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L39 73c-9.4-9.4-9.4-24.6 0-33.9zm400 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48z", "M170.8 234.6L151.7 288H360.3l-19.1-53.4c-2.3-6.4-8.3-10.6-15.1-10.6H185.8c-6.8 0-12.8 4.3-15.1 10.6zM82.2 292.4l28.3-79.3C121.9 181.3 152 160 185.8 160H326.2c33.8 0 64 21.3 75.3 53.1l28.3 79.3c20.1 8.5 34.2 28.4 34.2 51.6v40 64 32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V448 384 344c0-23.2 14.1-43.1 34.2-51.6zM152 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faSleigh = {
  prefix: 'fad',
  iconName: 'sleigh',
  icon: [640, 512, [], "f7cc", ["M608 352c17.7 0 32 14.3 32 32v8c0 48.6-39.4 88-88 88H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H552c13.3 0 24-10.7 24-24v-8c0-17.7 14.3-32 32-32z", "M0 64C0 46.3 14.3 32 32 32H55h9c2.3 0 4.6 .2 6.7 .7c54.2 4.9 103.5 34.9 132.7 81.6l4.3 6.9c40 64 110.1 102.9 185.6 102.9c30.2 0 54.7-24.5 54.7-54.7V128c0-17.7 14.3-32 32-32h32 32c17.7 0 32 14.3 32 32s-14.3 32-32 32v96c0 53-43 96-96 96v64H384V352H192v64H128V352c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64z"]]
};
var faArrowDown19 = {
  prefix: 'fad',
  iconName: 'arrow-down-1-9',
  icon: [576, 512, ["sort-numeric-asc", "sort-numeric-down"], "f162", ["M464 64v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V108.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4s13.3 15.7 13.3 26zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z"]]
};
var faSortNumericAsc = faArrowDown19;
var faSortNumericDown = faArrowDown19;
var faBuoyMooring = {
  prefix: 'fad',
  iconName: 'buoy-mooring',
  icon: [576, 512, [], "e5b6", ["M288 0c-17.7 0-32 14.3-32 32V68.7c-38 11.5-67.8 43.2-75.9 83.7L153 288H423L395.9 152.5C387.8 111.9 358 80.3 320 68.7V32c0-17.7-14.3-32-32-32zm18.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z", "M153 288L131.5 395.2c.4 .3 .9 .6 1.3 .9c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c.4-.3 .9-.6 1.3-.9L423 288H357.8 218.2 153z"]]
};
var faSquare4 = {
  prefix: 'fad',
  iconName: 'square-4',
  icon: [448, 512, [], "e259", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm191.6 33.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10H240v40c0 13.3 10.7 24 24 24s24-10.7 24-24V320h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H169.3l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z", "M206.8 159.6c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10H240v40c0 13.3 10.7 24 24 24s24-10.7 24-24V320h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H169.3l37.5-112.4z"]]
};
var faHandHoldingDroplet = {
  prefix: 'fad',
  iconName: 'hand-holding-droplet',
  icon: [576, 512, ["hand-holding-water"], "f4c1", ["M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z", "M209.2 103L275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3z"]]
};
var faHandHoldingWater = faHandHoldingDroplet;
var faTricycleAdult = {
  prefix: 'fad',
  iconName: 'tricycle-adult',
  icon: [640, 512, [], "e5c4", ["M94.1 117.2c-6-16.6-24.3-25.3-40.9-19.3s-25.3 24.3-19.3 40.9l14.9 41.7c9.4 26.2 31.7 45.6 58.9 51.3l77.7 16.3c17.3 3.6 34.3-7.4 37.9-24.7s-7.4-34.3-24.7-37.9l-77.7-16.3c-5.4-1.1-9.9-5-11.8-10.3L94.1 117.2zM96 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144c17.5 0 33.9-4.7 48-12.8c14.1 8.2 30.5 12.8 48 12.8c53 0 96-43 96-96c0-4.1-.3-8.2-.8-12.2l-52.8-10.3c3.6 6.7 5.6 14.4 5.6 22.5c0 26.5-21.5 48-48 48c-4.1 0-8.2-.5-12-1.5c7.6-13.8 12-29.6 12-46.5c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm400-96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm144 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z", "M312 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h31.4c2.6 0 5 1.3 6.5 3.4l79.2 112.5-48.2 64.3c-5.6 7.5-14.4 11.9-23.7 11.9c-1.9 0-3.8-.2-5.7-.5l-322.9-63c-13-2.5-25.6 6-28.2 19s6 25.6 19 28.2l4.6 .9C41.6 268.6 67.4 256 96 256c41.9 0 77.5 26.8 90.6 64.2l155.7 30.4c4.9 1 9.9 1.4 14.9 1.4c24.4 0 47.4-11.5 62.1-31.1l38.8-51.8 13.7 19.5c10.6-12.1 24.2-21.5 39.7-27L389.2 87.8C378.7 72.9 361.6 64 343.4 64H312z"]]
};
var faWaveform = {
  prefix: 'fad',
  iconName: 'waveform',
  icon: [640, 512, [], "f8f1", ["M320 0c12 0 22.1 8.8 23.8 20.7l42 304.4L424.3 84.2c1.9-11.7 12-20.3 23.9-20.2s21.9 8.9 23.6 20.6l28.2 197.3 20.5-102.6c2.2-10.8 11.3-18.7 22.3-19.3s20.9 6.4 24.2 16.9L593.7 264H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H576c-10.5 0-19.8-6.9-22.9-16.9l-4.1-13.4-29.4 147c-2.3 11.5-12.5 19.6-24.2 19.3s-21.4-9-23.1-20.6L446.7 248.3l-39 243.5c-1.9 11.7-12.1 20.3-24 20.2s-21.9-8.9-23.5-20.7L320 199.6 279.8 491.3c-1.6 11.8-11.6 20.6-23.5 20.7s-22.1-8.5-24-20.2l-39-243.5L167.8 427.4c-1.7 11.6-11.4 20.3-23.1 20.6s-21.9-7.8-24.2-19.3l-29.4-147-4.1 13.4C83.8 305.1 74.5 312 64 312H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H46.3l26.8-87.1c3.2-10.5 13.2-17.5 24.2-16.9s20.2 8.5 22.3 19.3l20.5 102.6L168.2 84.6c1.7-11.7 11.7-20.5 23.6-20.6s22 8.5 23.9 20.2l38.5 240.9 42-304.4C297.9 8.8 308 0 320 0z", ""]]
};
var faWater = {
  prefix: 'fad',
  iconName: 'water',
  icon: [576, 512, [], "f773", ["M269.5 213.9c11.1-7.9 25.9-7.9 37 0C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1z", "M306.5 69.9c-11.1-7.9-25.9-7.9-37 0C247 85.4 219.5 96 192 96c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7C61 83.5 42.8 92.6 24.7 96.8c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 149.7 159 160 192 160c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 85.2 410.9 96 384 96c-27.5 0-55-10.6-77.5-26.1zM384 384c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 373.4 219.5 384 192 384c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 437.7 159 448 192 448c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 373.2 410.9 384 384 384z"]]
};
var faStarSharpHalfStroke = {
  prefix: 'fad',
  iconName: 'star-sharp-half-stroke',
  icon: [576, 512, ["star-sharp-half-alt"], "e28d", ["M288 406.4l0 0 112.2 87.3 .3 .3 3.7 2.9 13 10.1c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27l-5-15.7-1.4-4.5-.1-.4L403.9 320.7l114-88.7 .1-.1 2-1.5 14.7-11.5c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2H501.3h-2.5-.1H361.6L317.4 37.2l-.1-.3-1.3-4-5.2-16.2C307.7 6.8 298.5 0 288 0c0 0 0 0 0 0V129.5l0 0L308.2 193l12.4 39h41 65.2l-57.2 44.5-30.8 24 11.8 37.2 19.7 61.8-47.9-37.2L288 335.5l0 0v70.9z", "M254.4 50.4L214.5 176H90.3 88 74.7 56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L56 230.4l10.5 8.2 1.8 1.4 103.7 80.7L132 446.7l-1.1 3.5L126.1 465l-5 15.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7l13-10.1 12.3-9.5 2.9-2.3L288 406.4V325.3 155.9 0c-10.5 0-19.7 6.8-22.9 16.7L260 32.9l0 0-4.6 14.3-1 3.2z"]]
};
var faStarSharpHalfAlt = faStarSharpHalfStroke;
var faNfcSignal = {
  prefix: 'fad',
  iconName: 'nfc-signal',
  icon: [512, 512, [], "e1fb", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H224.1c.7-22.1 4-43.6 9.8-64H112c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H245.3c21.9-51.1 59.5-93.9 106.7-122.3V144c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16v66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-26.5 21.5-48 48-48h80c26.5 0 48 21.5 48 48V245.3c20.2-8.7 41.6-14.9 64-18.3V96c0-35.3-28.7-64-64-64H64z", "M512 280c0-13.3-10.7-24-24-24c-128.1 0-232 103.9-232 232c0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184c13.3 0 24-10.7 24-24zM448 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40-128c-75.1 0-136 60.9-136 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]]
};
var faPlaneProp = {
  prefix: 'fad',
  iconName: 'plane-prop',
  icon: [576, 512, [], "e22b", ["M231.7 317.6L254.2 498c1 8 7.8 14 15.9 14h35.8c8.1 0 14.9-6 15.9-14L344 320H256l-24.3-2.4zm0-123.1L256 192h88L321.8 14c-1-8-7.8-14-15.9-14H270.1c-8.1 0-14.9 6-15.9 14L231.7 194.4z", "M231.7 317.6L256 320h88l138.3 0c34.2 0 93.7-28 93.7-64c0-35-59.5-64-93.7-64H344 256l-24.3 2.4-110 11L113.8 142c-1-8-7.8-14-15.9-14H62.1c-8.1 0-14.9 6-15.9 14L36 224.2c-1.3-.2-2.6-.2-4-.2c-17.7 0-32 14.3-32 32s14.3 32 32 32c1.3 0 2.7-.1 4-.2L46.2 370c1 8 7.8 14 15.9 14H97.9c8.1 0 14.9-6 15.9-14l7.9-63.4 110 11zM336 128h32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V112c8.8 0 16-7.2 16-16s-7.2-16-16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H328l8 64zM248 64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h16l8-64zm-8 320H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h24l-8-64zm88 64h40v16c0 8.8 7.2 16 16 16s16-7.2 16-16V432c8.8 0 16-7.2 16-16s-7.2-16-16-16V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H336l-8 64z"]]
};
var faCalendarCheck = {
  prefix: 'fad',
  iconName: 'calendar-check',
  icon: [448, 512, [], "f274", ["M448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM329 305L217 417c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"]]
};
var faClockDesk = {
  prefix: 'fad',
  iconName: 'clock-desk',
  icon: [448, 512, [], "e134", ["M224 448A224 224 0 1 0 224 0a224 224 0 1 0 0 448zm24-328v94.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17V120c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M248 120c0-13.3-10.7-24-24-24s-24 10.7-24 24V224c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41V120zM448 224c0 123.7-100.3 224-224 224S0 347.7 0 224V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V224z"]]
};
var faCalendarClock = {
  prefix: 'fad',
  iconName: 'calendar-clock',
  icon: [576, 512, ["calendar-time"], "e0d2", ["M432 192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368c0-97.2 78.8-176 176-176zm0 0c5.4 0 10.7 .2 16 .7V192H432z", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]]
};
var faCalendarTime = faCalendarClock;
var faBraille = {
  prefix: 'fad',
  iconName: 'braille',
  icon: [640, 512, [], "f2a1", ["M592 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM576 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z", "M64 160A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm0 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 96A64 64 0 1 0 160 96a64 64 0 1 0 128 0zm128 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faPrescriptionBottleMedical = {
  prefix: 'fad',
  iconName: 'prescription-bottle-medical',
  icon: [384, 512, ["prescription-bottle-alt"], "f486", ["M352 96H32V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V96zM160 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V320H112c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z", "M32 0C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96H352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM160 208v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H224V208c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]]
};
var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
var faPlateUtensils = {
  prefix: 'fad',
  iconName: 'plate-utensils',
  icon: [640, 512, [58713], "e43b", ["M152 383.8C192.5 441.9 259.8 480 336 480c89.4 0 166.6-52.4 202.6-128.2c-23.9-2-44-17.2-53.2-38.2C462.2 373.5 404.1 416 336 416c-88.4 0-160-71.6-160-160c0-.2 0-.4 0-.6c-7.4 4.8-15.5 8.6-24 11.4V383.8zm69.4-239.4C250.5 114.5 291.1 96 336 96c63.3 0 118.1 36.8 144 90.2V160c0-25 4.3-46.7 11.3-65.5C451 55.8 396.3 32 336 32c-48.9 0-94.2 15.7-131.1 42.3l16.3 69.2c.1 .3 .1 .5 .2 .8zM464 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z", "M48 23.5c-.2-4-3.3-7.2-7.3-7.5s-7.6 2.3-8.5 6.1L1.9 150.9C.6 156.3 0 161.9 0 167.5c0 39.9 32.2 72.2 72 72.5V472c0 13.3 10.7 24 24 24s24-10.7 24-24V240c39.8-.3 72-32.6 72-72.5c0-5.6-.6-11.2-1.9-16.6L159.8 22.2c-.9-3.9-4.5-6.5-8.5-6.1s-7.1 3.5-7.3 7.5L136.5 152H119.1L103.9 23.1c-.5-4-3.9-7.1-7.9-7.1s-7.5 3-7.9 7.1L72.9 152H55.5L48 23.5zM512 160V288c0 17.7 14.3 32 32 32h48V472c0 13.3 10.7 24 24 24s24-10.7 24-24V320 216 36.9c0-11.5-9.3-20.9-20.9-20.9c-2.1 0-4.1 .3-6.1 1C596.2 23.2 512 59.2 512 160z"]]
};
var faFamilyPants = {
  prefix: 'fad',
  iconName: 'family-pants',
  icon: [512, 512, [], "e302", ["M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM25.9 233.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c13.5 0 25.7-5.6 34.4-14.5c-1.6-5.5-2.4-11.4-2.4-17.5V423.6c-19.6-17.6-32-43.1-32-71.6V336c0-43.1 24.3-80.5 60-99.2c-17.1-14.7-28-36.5-28-60.8c0-3.9 .3-7.8 .8-11.5c-8.3-2.9-17.2-4.5-26.4-4.5H105.6c-41.6 0-76.3 31.9-79.7 73.4zM333.6 497.5c8.7 9 20.9 14.5 34.4 14.5h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C482.7 191.9 448 160 406.4 160H361.6c-9.2 0-18.1 1.6-26.4 4.5c.5 3.8 .8 7.6 .8 11.5c0 24.3-10.9 46.1-28 60.8c35.7 18.7 60 56.1 60 99.2v16c0 28.4-12.4 54-32 71.6V480c0 6.1-.8 11.9-2.4 17.5zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0z", "M208 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM176 336c0-44.2 35.8-80 80-80s80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V407.4c-19.1-11.1-32-31.7-32-55.4V336z"]]
};
var faHoseReel = {
  prefix: 'fad',
  iconName: 'hose-reel',
  icon: [640, 512, [], "e41a", ["M128 256c0-106 86-192 192-192s192 86 192 192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256C576 114.6 461.4 0 320 0S64 114.6 64 256s114.6 256 256 256c54.3 0 104.8-17 146.3-45.9c14.5-10.1 18-30.1 7.9-44.6s-30.1-18-44.6-7.9C398.6 435.3 360.8 448 320 448c-106 0-192-86-192-192zm192 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM160 256a160 160 0 1 0 320 0 160 160 0 1 0 -320 0zm224 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z", "M480 376c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-2.3l-11.5 80.2c7.8 1.1 13.7 7.8 13.7 15.8c0 8.8-7.2 16-16 16H520c-8.8 0-16-7.2-16-16c0-8.1 6-14.7 13.7-15.8L506.3 400H504c-13.3 0-24-10.7-24-24z"]]
};
var faHouseWindow = {
  prefix: 'fad',
  iconName: 'house-window',
  icon: [576, 512, [], "e3b3", ["M64.1 448L64 270.5l224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1H128.1c-35.3 0-64-28.6-64-64zM248 240c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H248z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z"]]
};
var faLandmark = {
  prefix: 'fad',
  iconName: 'landmark',
  icon: [512, 512, [127963], "f66f", ["M128 192H64V420.3c-.6 .3-1.2 .7-1.7 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V192H384V416H344V192H280V416H232V192H168V416H128V192z", "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128c-12.6 7.2-18.8 22-15.1 36S17.5 192 32 192H480c14.5 0 27.2-9.8 30.9-23.8s-2.5-28.8-15-36l-224-128z"]]
};
var faTruck = {
  prefix: 'fad',
  iconName: 'truck',
  icon: [640, 512, [128666, 9951], "f0d1", ["M176 512a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm288 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96h66.3c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H576h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160z"]]
};
var faCrosshairs = {
  prefix: 'fad',
  iconName: 'crosshairs',
  icon: [512, 512, [], "f05b", ["M42.4 224C56.3 130.3 130.3 56.3 224 42.4v65C165.7 119.9 119.9 165.7 107.4 224h-65zm0 64h65c12.5 58.3 58.4 104.1 116.6 116.6v65C130.3 455.7 56.3 381.7 42.4 288zM288 469.6v-65c58.3-12.5 104.1-58.4 116.6-116.6h65c-13.9 93.7-88 167.7-181.6 181.6zM469.6 224h-65C392.1 165.7 346.3 119.9 288 107.4v-65c93.7 13.9 167.7 88 181.6 181.6z", "M256 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm256 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32zM256 352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32zM128 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32z"]]
};
var faCloudRainbow = {
  prefix: 'fad',
  iconName: 'cloud-rainbow',
  icon: [576, 512, [], "f73e", ["M560 64.4c8.8-.5 16-7.6 16-16.4V16c0-8.8-7.2-16-16-15.6C430.9 6.1 319.9 81.4 263.6 189.7c6.5 5 12.5 10.4 18 16.4c16.1-9 34.7-14.1 54.4-14.1c.2 0 .3 0 .5 0C385.4 119 466.8 69.5 560 64.4zM424 234.7c32.1-41.5 80.7-69.5 136-74c8.8-.7 16-7.8 16-16.7V112c0-8.8-7.2-16.1-16-15.5c-76.9 4.7-144.6 43.4-188.4 101.3c20.9 7 39 20 52.3 36.9zm23.4 57.2c15.2 3.8 29.3 10.4 41.8 19.1c13.2-27.9 39.5-48.4 70.9-53.7c8.7-1.5 15.9-8.5 15.9-17.3V208c0-8.8-7.2-16.1-16-15.2c-49.9 4.9-93 32.8-118.8 72.9c3 8.3 5.1 17.1 6.1 26.2zm-165.8 110c-13.8 14.9-30.8 26.9-49.9 34.9c5.9 6.8 14.6 11.2 24.3 11.2c17.5 0 31.7-14 32-31.4l0-.6 0-1.4v-9.3c-2.2-1-4.3-2.1-6.4-3.3z", "M0 416c0 53 43 96 96 96H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28c-18.7-35.7-56.1-60-99.2-60c-61.9 0-112 50.1-112 112c0 7.1 .7 14.1 1.9 20.8C27.6 337.4 0 373.5 0 416z"]]
};
var faPersonCane = {
  prefix: 'fad',
  iconName: 'person-cane',
  icon: [448, 512, [], "e53c", ["M360 368c-4.4 0-8 3.6-8 8v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-30.9 25.1-56 56-56s56 25.1 56 56V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-4.4-3.6-8-8-8z", "M176 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM120 256.9L91.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6H213c28.6 0 55.6 12.7 73.9 34.7l73.7 88.9c11.3 13.6 9.4 33.8-4.2 45.1s-33.8 9.4-45.1-4.2L264 235.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H184V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9z"]]
};
var faAlien = {
  prefix: 'fad',
  iconName: 'alien',
  icon: [448, 512, [128125], "f8f5", ["M224 0C100.3 0 0 100.3 0 224C0 359.3 148.8 471.7 194.7 503.2c8.6 5.9 18.9 8.8 29.3 8.8s20.7-2.9 29.3-8.8C299.2 471.7 448 359.3 448 224C448 100.3 347.7 0 224 0zm32 306.3c0-45.4 36.8-82.3 82.3-82.3h32c7.6 0 13.7 6.1 13.7 13.7c0 45.4-36.8 82.3-82.3 82.3h-32c-7.6 0-13.7-6.1-13.7-13.7zM109.7 224c45.4 0 82.3 36.8 82.3 82.3c0 7.6-6.1 13.7-13.7 13.7h-32C100.8 320 64 283.2 64 237.7c0-7.6 6.1-13.7 13.7-13.7h32z", "M109.7 224c45.4 0 82.3 36.8 82.3 82.3c0 7.6-6.1 13.7-13.7 13.7h-32C100.8 320 64 283.2 64 237.7c0-7.6 6.1-13.7 13.7-13.7h32zm228.6 0h32c7.6 0 13.7 6.1 13.7 13.7c0 45.4-36.8 82.3-82.3 82.3h-32c-7.6 0-13.7-6.1-13.7-13.7c0-45.4 36.8-82.3 82.3-82.3z"]]
};
var faTent = {
  prefix: 'fad',
  iconName: 'tent',
  icon: [576, 512, [], "e57d", ["M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H448L288 256V512H32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z", "M288 256V512H448L288 256z"]]
};
var faLaptopBinary = {
  prefix: 'fad',
  iconName: 'laptop-binary',
  icon: [640, 512, [], "e5e7", ["M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z", "M512 96H128V352h64V304c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16v64h80 64 48V304c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16v64h64V96zM368 352V312c0-22.1-17.9-40-40-40H312c-22.1 0-40 17.9-40 40v40l32 0V312c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v40l32 0zM200 128h16c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40zm-8 40v32c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm112-40h16c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm80 40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40H424c-22.1 0-40-17.9-40-40V168zm40-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H424z"]]
};
var faVestPatches = {
  prefix: 'fad',
  iconName: 'vest-patches',
  icon: [448, 512, [], "e086", ["M224 88c-31.4 0-55.4-8.3-72.8-18.3L131.6 10.9C129.5 4.6 123.7 .3 117.1 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c-6.6 .3-12.4 4.6-14.6 10.9L296.8 69.7C279.4 79.7 255.4 88 224 88zm80 200v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H320c-8.8 0-16-7.2-16-16V288zM56 416a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z", "M207.1 237.4l-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6V48C64 21.5 85.5 0 112 0h4.5c6.9 0 13 4.4 15.2 10.9l75.5 226.5zM224 464V295.8c0-5.2 .8-10.3 2.5-15.2L316.4 10.9C318.5 4.4 324.6 0 331.5 0H336c26.5 0 48 21.5 48 48v97.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280v8 32c0 8.8 7.2 16 16 16h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]]
};
var faPeopleDressSimple = {
  prefix: 'fad',
  iconName: 'people-dress-simple',
  icon: [512, 512, [], "e218", ["M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm256 0A64 64 0 1 0 384 0a64 64 0 1 0 0 128z", "M50.7 206.4c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192v80c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4zm256 0c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V384H298.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"]]
};
var faCheckDouble = {
  prefix: 'fad',
  iconName: 'check-double',
  icon: [448, 512, [], "f560", ["M342.6 41.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 178.7 297.4 41.4c12.5-12.5 32.8-12.5 45.3 0z", "M438.6 169.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 393.4 169.4c12.5-12.5 32.8-12.5 45.3 0z"]]
};
var faArrowDownAZ = {
  prefix: 'fad',
  iconName: 'arrow-down-a-z',
  icon: [576, 512, ["sort-alpha-asc", "sort-alpha-down"], "f15d", ["M416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176zM352 352c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352z", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z"]]
};
var faSortAlphaAsc = faArrowDownAZ;
var faSortAlphaDown = faArrowDownAZ;
var faBowlingBallPin = {
  prefix: 'fad',
  iconName: 'bowling-ball-pin',
  icon: [576, 512, [], "e0c3", ["M416 64v1.1c0 7.4 1 14.8 2.9 22l17.7 64.8c.7 2.7 1.3 5.4 1.8 8.1h83.1c.5-2.7 1.1-5.4 1.8-8.1L541 87.1c2-7.2 3-14.6 3-22V64c0-35.3-28.7-64-64-64s-64 28.7-64 64zm22.8 128c-1 6.3-2.6 12.4-4.8 18.4l-2.4 6.5c10.5 27 16.3 56.4 16.3 87.1c0 53.8-17.7 103.4-47.5 143.4l17.8 44.5C423.1 504 434.9 512 448 512h64c13.1 0 24.9-8 29.7-20.1L564.5 435c7.6-19.1 11.5-39.4 11.5-59.9c0-19-3.4-37.9-10-55.8L525.9 210.4c-2.2-6-3.8-12.1-4.8-18.4H438.8zM196 200a28 28 0 1 0 0-56 28 28 0 1 0 0 56zm28 60a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zM124 248a28 28 0 1 0 0-56 28 28 0 1 0 0 56z", "M0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zM224 172a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zM196 288a28 28 0 1 0 0-56 28 28 0 1 0 0 56zm-44-68a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zm286.5-60h83.1c-1 5.7-1.5 11.4-1.5 17.2c0 5 .4 9.9 1.2 14.8H438.8c.8-4.9 1.2-9.9 1.2-14.8c0-5.8-.5-11.5-1.5-17.2z"]]
};
var faBellSchoolSlash = {
  prefix: 'fad',
  iconName: 'bell-school-slash',
  icon: [640, 512, [], "f5d6", ["M570.7 422c3.4-6.6 5.3-14.1 5.3-22c0-26.5-21.5-48-48-48c-12.1 0-23.1 4.5-31.5 11.8L570.7 422zM445 323.5c22.1-33 35-72.8 35-115.5C480 93.1 386.9 0 272 0C211.2 0 156.6 26.1 118.5 67.6L220 147.2c14-11.9 32.1-19.2 52-19.2c44.2 0 80 35.8 80 80c0 12.9-3.1 25.1-8.5 35.9L445 323.5zm-127.6-100c1.7-4.9 2.6-10.1 2.6-15.5c0-26.5-21.5-48-48-48c-9.5 0-18.4 2.8-25.9 7.6l71.3 55.9zm190.9 273L465.8 463c-3.2 .7-6.4 1-9.8 1H416V423.8l-16.1-12.7C362.9 434.5 319 448 272 448c-54 0-103.9-17.9-144-48v64c0 26.5 21.5 48 48 48H384h32 40c19.3 0 37.3-5.7 52.3-15.5zM373 389.9L71.5 152.4C66.6 170.1 64 188.7 64 208c0 114.9 93.1 208 208 208c36.7 0 71.1-9.5 101-26.1z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faPlusLarge = {
  prefix: 'fad',
  iconName: 'plus-large',
  icon: [512, 512, [], "e59e", ["M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H224V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V32z", ""]]
};
var faMoneyBillWheat = {
  prefix: 'fad',
  iconName: 'money-bill-wheat',
  icon: [512, 512, [], "e52a", ["M48 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zM96 464H48V416c26.5 0 48 21.5 48 48zM48 352V304H96c0 26.5-21.5 48-48 48zM416 464c0-26.5 21.5-48 48-48v48H416zm48-112c-26.5 0-48-21.5-48-48h48v48zM256 320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M160 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM32 40c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 64 32 53.3 32 40zM0 112C0 98.7 10.7 88 24 88H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm56 48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM288 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm96 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zm80 112c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM240 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z"]]
};
var faCameraViewfinder = {
  prefix: 'fad',
  iconName: 'camera-viewfinder',
  icon: [512, 512, ["screenshot"], "e0da", ["M24 0C10.7 0 0 10.7 0 24V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM488 0H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zM0 488c0 13.3 10.7 24 24 24H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V488zm488 24c13.3 0 24-10.7 24-24V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H376c-13.3 0-24 10.7-24 24s10.7 24 24 24H488z", "M186.2 111.6L180 128H144c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H332l-6.2-16.4c-3.5-9.4-12.5-15.6-22.5-15.6H208.6c-10 0-19 6.2-22.5 15.6zM256 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]]
};
var faScreenshot = faCameraViewfinder;
var faMessageMusic = {
  prefix: 'fad',
  iconName: 'message-music',
  icon: [512, 512, ["comment-alt-music"], "f8af", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM352 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V128 96z", "M345.1 82.8c4.3 3 6.9 7.9 6.9 13.2v32V256c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V151.1l-96 36V288c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V176 144c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8z"]]
};
var faCommentAltMusic = faMessageMusic;
var faCarBuilding = {
  prefix: 'fad',
  iconName: 'car-building',
  icon: [640, 512, [], "f859", ["M0 48C0 21.5 21.5 0 48 0H272c26.5 0 48 21.5 48 48v88.4c-29.5 12.1-53.1 36.6-63.7 68.2l-.5 1.4c-1-7.9-7.7-14-15.9-14H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h31.2l-5.6 16.9C208.5 290.2 192 319.2 192 352v96 32H48c-26.5 0-48-21.5-48-48V48zM64 208v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm0-96v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM208 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H208zM64 304v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z", "M347.4 234.9L329.7 288H534.3l-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9H362.6c-6.9 0-13 4.4-15.2 10.9zm-87.3 59.4l26.6-79.7C297.6 182 328.2 160 362.6 160H501.4c34.4 0 65 22 75.9 54.7l26.6 79.7C625.2 304.7 640 326.6 640 352v96h0v32c0 17.7-14.3 32-32 32H592c-17.7 0-32-14.3-32-32V448H304v32c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V448h0V352c0-25.4 14.8-47.3 36.1-57.6zM328 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faBorderBottomRight = {
  prefix: 'fad',
  iconName: 'border-bottom-right',
  icon: [448, 512, ["border-style-alt"], "f854", ["M32 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM128 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64z", "M416 32c17.7 0 32 14.3 32 32l0 336c0 44.2-35.8 80-80 80L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l336 0c8.8 0 16-7.2 16-16l0-336c0-17.7 14.3-32 32-32z"]]
};
var faBorderStyleAlt = faBorderBottomRight;
var faOctagon = {
  prefix: 'fad',
  iconName: 'octagon',
  icon: [512, 512, [128721], "f306", ["M191.5 .1c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5v129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1h129c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9v-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1h-129z", ""]]
};
var faCommentArrowUpRight = {
  prefix: 'fad',
  iconName: 'comment-arrow-up-right',
  icon: [512, 512, [], "e145", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM200 160H312c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V241.9l-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M176 184c0-13.3 10.7-24 24-24H312c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V241.9l-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87H200c-13.3 0-24-10.7-24-24z"]]
};
var faOctagonDivide = {
  prefix: 'fad',
  iconName: 'octagon-divide',
  icon: [512, 512, [], "e203", ["M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H168zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M224 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 96c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24zm112 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faCookie = {
  prefix: 'fad',
  iconName: 'cookie',
  icon: [512, 512, [127850], "f563", ["M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faArrowRotateLeft = {
  prefix: 'fad',
  iconName: 'arrow-rotate-left',
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", ["M125.7 160l17.1-17.1c62.5-62.5 163.8-62.5 226.3 0s62.5 163.8 0 226.3s-163.8 62.5-226.3 0c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c87.5 87.5 229.3 87.5 316.8 0s87.5-229.3 0-316.8s-229.3-87.5-316.8 0L80 115.2V160h45.7z", "M16 192c0 17.7 14.3 32 32 32H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H80V64c0-17.7-14.3-32-32-32S16 46.3 16 64V192z"]]
};
var faArrowLeftRotate = faArrowRotateLeft;
var faArrowRotateBack = faArrowRotateLeft;
var faArrowRotateBackward = faArrowRotateLeft;
var faUndo = faArrowRotateLeft;
var faTvMusic = {
  prefix: 'fad',
  iconName: 'tv-music',
  icon: [640, 512, [], "f8e6", ["M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M576 64H64V352H576V64zM416 112v40V256c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V175.1l-96 36V288c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V200 160c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z"]]
};
var faHardDrive = {
  prefix: 'fad',
  iconName: 'hard-drive',
  icon: [512, 512, [128436, "hdd"], "f0a0", ["M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V320c0 5.5-.7 10.9-2 16c-7.1-27.6-32.2-48-62-48H64c-29.8 0-54.9 20.4-62 48c-1.3-5.1-2-10.5-2-16V96zM320 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M0 352c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352zm352 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faHdd = faHardDrive;
var faReel = {
  prefix: 'fad',
  iconName: 'reel',
  icon: [448, 512, [], "e238", ["M384 64H64V88c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24V64zM88 400c-13.3 0-24 10.7-24 24v24H384V424c0-13.3-10.7-24-24-24H88zM80 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faFaceGrinSquintTears = {
  prefix: 'fad',
  iconName: 'face-grin-squint-tears',
  icon: [512, 512, [129315, "grin-squint-tears"], "f586", ["M382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.6c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zm34.3 169.1c-4.8-11.9-20.9-10.9-26.9 .4c-19.4 36.7-46.3 73.2-79.8 106.7s-70 60.3-106.7 79.8c-11.3 6-12.3 22.1-.4 26.9c59.4 24.1 129.9 12.2 177.9-35.8s59.9-118.5 35.8-177.9zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z", "M497.1 14.9c19.6 19.6 20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2C446-5 477.5-4.6 497.1 14.9zM87.1 285.1c-6.3-6.3-3.6-17.2 4.9-19.8l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4zM265.3 92c2.6-8.6 13.4-11.3 19.8-4.9c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z"]]
};
var faGrinSquintTears = faFaceGrinSquintTears;
var faDumbbell = {
  prefix: 'fad',
  iconName: 'dumbbell',
  icon: [640, 512, [], "f44b", ["M0 256c0-17.7 14.3-32 32-32v64c-17.7 0-32-14.3-32-32zm448 32H192V224H448v64zm160 0V224c17.7 0 32 14.3 32 32s-14.3 32-32 32z", "M128 32c-17.7 0-32 14.3-32 32v64H64c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H128zm384 0H480c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384h32c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H544V64c0-17.7-14.3-32-32-32z"]]
};
var faRectangleList = {
  prefix: 'fad',
  iconName: 'rectangle-list',
  icon: [576, 512, ["list-alt"], "f022", ["M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zM200 352c0 13.3 10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224c-13.3 0-24 10.7-24 24zm24-120c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z", "M200 160c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 192c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm24-120H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faListAlt = faRectangleList;
var faTarpDroplet = {
  prefix: 'fad',
  iconName: 'tarp-droplet',
  icon: [576, 512, [], "e57c", ["M64 128H197.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64V352l-128 0c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M288 160c35.3 0 64-26.9 64-60c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C257.7 29.9 224 76 224 100c0 33.1 28.7 60 64 60zM416 512L576 352H448c-17.7 0-32 14.3-32 32V512z"]]
};
var faAlarmExclamation = {
  prefix: 'fad',
  iconName: 'alarm-exclamation',
  icon: [512, 512, [], "f843", ["M390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-200c0-13.3-10.7-24-24-24s-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184z", "M160 25.4L14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4zm192 0C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-200V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]]
};
var faHouseMedicalCircleCheck = {
  prefix: 'fad',
  iconName: 'house-medical-circle-check',
  icon: [640, 512, [], "e511", ["M394.8 512C349.5 480.1 320 427.5 320 368c0-5.4 .2-10.7 .7-16H320v16c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h40.2c32.3-39.1 81.1-64 135.8-64c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H394.8z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faTrafficCone = {
  prefix: 'fad',
  iconName: 'traffic-cone',
  icon: [512, 512, [], "f636", ["M173.7 128H338.3l25.1 64H148.6l25.1-64zM110.9 288H401.1l25.1 64H85.7l25.1-64z", "M173.7 128L216 20.3C220.8 8.1 232.7 0 245.8 0h20.4c13.2 0 25 8.1 29.8 20.3L338.3 128H173.7zm-25.1 64H363.4l37.7 96H110.9l37.7-96zM48 448l37.7-96H426.3L464 448h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48z"]]
};
var faGrate = {
  prefix: 'fad',
  iconName: 'grate',
  icon: [448, 512, [], "e193", ["M96 224V96h64V224h32V96h64V224h32V96h64V224h40v64H352V416H288V288H256V416H192V288H160V416H96V288H64V224H96z", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0V416H384V96H64z"]]
};
var faArrowDownRight = {
  prefix: 'fad',
  iconName: 'arrow-down-right',
  icon: [384, 512, [], "e093", ["M288 306.7L86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 352H288V306.7z", "M352 384c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V160c0-17.7 14.3-32 32-32s32 14.3 32 32V384z"]]
};
var faPersonSkiingNordic = {
  prefix: 'fad',
  iconName: 'person-skiing-nordic',
  icon: [576, 512, ["skiing-nordic"], "f7ca", ["M402.3 464l27.1-176H448c5.1 0 10-1.2 14.2-3.3L434.6 464H504c13.3 0 24-10.7 24-24v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 39.8-32.2 72-72 72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H67l55.6-264.2c8.7 7.8 20.7 10 31.3 6.6L99.7 464H402.3z", "M336 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM227.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C166.4 108.3 196.2 96 227.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H426.7c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L302 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L357.8 464H291.3l23.3-81.6-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zM202.8 464H132.2l58.7-125.7c5.9 6.6 12.8 12.5 20.6 17.3l32.4 20.3L202.8 464zm-42.1 48c-.4 0-.9 0-1.4 0h1.4zm160.1 0c-.5 0-1 0-1.4 0h1.4z"]]
};
var faSkiingNordic = faPersonSkiingNordic;
var faCalendarPlus = {
  prefix: 'fad',
  iconName: 'calendar-plus',
  icon: [512, 512, [], "f271", ["M32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zm224 56c-13.3 0-24 10.7-24 24v56H176c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v56c0 13.3 10.7 24 24 24s24-10.7 24-24V376h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V272c0-13.3-10.7-24-24-24z", "M128 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v80H32V112c0-26.5 21.5-48 48-48h48V32zM256 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H176c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"]]
};
var faPersonFromPortal = {
  prefix: 'fad',
  iconName: 'person-from-portal',
  icon: [512, 512, ["portal-exit"], "e023", ["M154.2 352c3.8-29.6 5.8-62.1 5.8-96c0-18.3-.6-36.1-1.7-53.4c-1.7-1.2-3.4-2.5-4.9-4c-12.5-12.5-12.5-32.7-.1-45.2C141 63.1 112.8 0 80 0C35.8 0 0 114.6 0 256S35.8 512 80 512c25.3 0 47.8-37.5 62.5-96H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h26.2z", "M416 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM221.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L233.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L334 299l30.9-82.4 5.1 12.3C385 264.7 419.9 288 458.7 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM187.2 352H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L253 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L187.2 352z"]]
};
var faPortalExit = faPersonFromPortal;
var faPlaneArrival = {
  prefix: 'fad',
  iconName: 'plane-arrival',
  icon: [640, 512, [128748], "f5af", ["M128 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 480c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM256 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M0 68l.2 98.9c0 8.4 3.4 16.5 9.3 22.5l82.9 83.5c8.1 8.1 18.2 14 29.3 16.9l298.4 77.7c42.6 11.1 87.6 8.6 128.8-7c28.8-10.9 34.8-49 10.7-68.2l-34.4-27.6c-13-10.4-27.8-18.1-43.7-22.8L374.2 210.2 265.2 16.3C259.5 6.2 248.8 0 237.3 0L197.2 0c-10.6 0-18.3 10.2-15.4 20.4l41.5 145.2L96 128 78.1 80.2c-3.8-10.1-12.5-17.7-23-20L19.5 52.3C9.5 50.1 0 57.7 0 68z"]]
};
var faCowbellCirclePlus = {
  prefix: 'fad',
  iconName: 'cowbell-circle-plus',
  icon: [576, 512, ["cowbell-more"], "f8b4", ["M128 96H112c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416H262.6c-4.3-15.3-6.6-31.4-6.6-48c0-86.4 62.3-158.3 144.4-173.2l-18.3-64C376.3 110.2 357.4 96 336 96H320V40c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40V96zM275.2 448H160c0 35.3 28.7 64 64 64c29.2 0 53.9-19.6 61.5-46.4c-3.8-5.7-7.2-11.5-10.3-17.6zM176 96V48h96V96H176z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]]
};
var faCowbellMore = faCowbellCirclePlus;
var faCircleLeft = {
  prefix: 'fad',
  iconName: 'circle-left',
  icon: [512, 512, [61840, "arrow-alt-circle-left"], "f359", ["M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9L117.5 269.8c-3.5-3.8-5.5-8.7-5.5-13.8s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1z", "M117.5 269.8l99.9 107.1c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8z"]]
};
var faArrowAltCircleLeft = faCircleLeft;
var faDistributeSpacingVertical = {
  prefix: 'fad',
  iconName: 'distribute-spacing-vertical',
  icon: [512, 512, [], "e366", ["M96 208c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V208z", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]]
};
var faSignalBarsFair = {
  prefix: 'fad',
  iconName: 'signal-bars-fair',
  icon: [640, 512, ["signal-alt-2"], "f692", ["M560 0c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V48c0-26.5-21.5-48-48-48zM400 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48z", "M240 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z"]]
};
var faSignalAlt2 = faSignalBarsFair;
var faSportsball = {
  prefix: 'fad',
  iconName: 'sportsball',
  icon: [512, 512, [], "e44b", ["M487.6 48.9c-.1-.5-.2-1-.3-1.5L365.3 169.3c34.8 30.2 79 49.8 127.6 53.9c9.3-63 4.7-125.5-5.4-174.3zM464.8 24.6c-1.1-.3-2.2-.5-3.3-.7c-65.6-11-122.9-12.5-172.8-6c3.9 49.1 23.6 93.7 54 128.8L464.8 24.6zM446 358.4c19.8-32.3 33-67.7 41.1-103.6c-55.1-5.3-105.1-28.1-144.4-62.8l-64 64L418.5 395.9c10.3-11.8 19.4-24.4 27.4-37.5zM320 169.4C285 129.7 262.1 79 257 23.3c-17 3.6-33 8.3-48.1 13.9c-37 13.7-67.8 33-93.1 56L256 233.4l64-64zM233.4 256L93.4 116.1C83.2 127.9 74.1 140.5 66 153.6c-19.8 32.3-33 67.7-41.1 103.6c55.1 5.3 105.1 28.1 144.4 62.8l64-64zM192 342.6c35 39.7 58 90.3 63 146.1c17-3.6 33-8.3 48.1-13.9c37-13.7 67.8-33 93.1-56L256 278.6l-64 64zm-45.3 .1c-34.8-30.2-79-49.8-127.6-53.9c-9.3 63-4.7 125.5 5.4 174.3c.1 .5 .2 1 .3 1.5L146.7 342.7zm22.6 22.6L47.2 487.4c1.1 .3 2.2 .5 3.3 .7c65.6 11 123 12.5 172.8 6c-3.9-49.1-23.6-93.7-54-128.8z", "M464.8 24.6L256 233.4 115.8 93.2c-8 7.3-15.4 14.9-22.3 22.9L233.4 256 24.8 464.6c2.9 11.1 11.4 19.8 22.4 22.9L256 278.6 396.2 418.8c8-7.3 15.4-14.9 22.3-22.9L278.6 256 487.2 47.4c-2.9-11.1-11.4-19.8-22.4-22.9z"]]
};
var faGameConsoleHandheldCrank = {
  prefix: 'fad',
  iconName: 'game-console-handheld-crank',
  icon: [576, 512, [], "e5b9", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm16 224c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H128v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H96V336c0-8.8 7.2-16 16-16zm112 40a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM504 144c-13.3 0-24 10.7-24 24v56h48 24c13.3 0 24-10.7 24-24V168c0-13.3-10.7-24-24-24H504z", "M96 96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96zM528 296V224H480v48H448v48h56c13.3 0 24-10.7 24-24z"]]
};
var faTrainSubway = {
  prefix: 'fad',
  iconName: 'train-subway',
  icon: [448, 512, ["subway"], "f239", ["M64 128v96c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM81.1 446.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H96c-5.1 0-10-.4-14.9-1.1zM288 448l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c-4.8 .8-9.8 1.1-14.9 1.1H288zM272 96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H272z", "M0 96C0 43 43 0 96 0H352c53 0 96 43 96 96V352c0 53-43 96-96 96H96c-53 0-96-43-96-96V96zm64 32v96c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM272 96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H272zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm224 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faSubway = faTrainSubway;
var faChartGantt = {
  prefix: 'fad',
  iconName: 'chart-gantt',
  icon: [512, 512, [], "e0e4", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H384z"]]
};
var faFaceSmileUpsideDown = {
  prefix: 'fad',
  iconName: 'face-smile-upside-down',
  icon: [512, 512, [], "e395", ["M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm91.9 186.5C330 165.8 299.4 144 256 144s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM367.6 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z", "M175.6 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm160 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]]
};
var faBallPile = {
  prefix: 'fad',
  iconName: 'ball-pile',
  icon: [576, 512, [], "f77e", ["M288 160A80 80 0 1 0 288 0a80 80 0 1 0 0 160zM80 512a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm288-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm128 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M176 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm224 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]]
};
var faBadgeDollar = {
  prefix: 'fad',
  iconName: 'badge-dollar',
  icon: [512, 512, [], "f645", ["M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zm20.9 140.4c0-11-9-20-20-20s-20 9-20 20v17.4c-8.8 1.8-17.7 4.8-25.7 9.6c-15 8.9-27.7 24.4-27.6 46.9c.1 21.5 12.6 35.1 26.3 43.4c11.9 7.2 27 11.7 39.1 15.4l1.9 .6c13.9 4.2 24.4 7.6 31.7 12.2c6.1 3.8 7.5 6.8 7.6 11c.1 6.5-2.5 10.4-7.6 13.6c-6 3.7-15.2 5.9-25.1 5.6c-12.7-.4-24.6-4.4-39.7-9.6l0 0 0 0 0 0 0 0c-2.6-.9-5.2-1.8-8-2.7c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c2.2 .7 4.5 1.5 6.8 2.3c9.7 3.3 20.9 7.2 32.8 9.6v18c0 11 9 20 20 20s20-9 20-20V354.4c9.3-1.7 18.6-4.9 26.8-10.1c15.3-9.5 26.8-25.7 26.5-48.1c-.3-21.6-12.4-35.6-26.3-44.3c-12.5-7.9-28.3-12.6-40.8-16.4l-.6-.2c-14.1-4.3-24.6-7.5-31.9-11.9c-6.2-3.7-7-6.3-7-9.3c0-5.1 2.1-8.8 7.9-12.3c6.5-3.8 16-6 25-5.8c10.9 .2 22.9 2.6 35.2 5.8c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-7.8-2.1-16.3-4.1-25.1-5.4V140.4z", "M256.9 120.4c11 0 20 9 20 20v17.3c8.9 1.4 17.4 3.4 25.1 5.4c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-12.3-3.3-24.2-5.7-35.2-5.8c-9.1-.1-18.5 2-25 5.8c-5.8 3.4-8 7.2-7.9 12.3c0 3 .8 5.6 7 9.3c7.3 4.4 17.8 7.7 31.9 11.9l.6 .2c12.5 3.8 28.3 8.5 40.8 16.4c13.9 8.7 26 22.8 26.3 44.3c.3 22.4-11.2 38.6-26.5 48.1c-8.2 5.1-17.5 8.3-26.8 10.1v17.1c0 11-9 20-20 20s-20-9-20-20l0-18c-12-2.4-23.1-6.3-32.8-9.6c-2.4-.8-4.6-1.6-6.8-2.3c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.8 .9 5.4 1.8 8 2.7l0 0 0 0c15.1 5.1 27 9.2 39.7 9.6c9.8 .3 19.1-1.9 25.1-5.6c5.1-3.2 7.7-7.1 7.6-13.6c-.1-4.1-1.4-7.1-7.6-11c-7.3-4.6-17.8-8-31.7-12.2l-1.9-.6c-12.1-3.7-27.2-8.2-39.1-15.4c-13.7-8.3-26.2-21.9-26.3-43.4c-.1-22.5 12.6-38 27.6-46.9c8-4.7 16.9-7.8 25.7-9.6V140.4c0-11 9-20 20-20z"]]
};
var faMoneyBillsSimple = {
  prefix: 'fad',
  iconName: 'money-bills-simple',
  icon: [640, 512, ["money-bills-alt"], "e1f4", ["M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120zM368 288a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm208 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]]
};
var faMoneyBillsAlt = faMoneyBillsSimple;
var faListTimeline = {
  prefix: 'fad',
  iconName: 'list-timeline',
  icon: [512, 512, [], "e1d1", ["M153.1 83.2c-8.5 6.4-8.5 19.2 0 25.6l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4H424c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H210.7c-6.9 0-13.7 2.2-19.2 6.4L153.1 83.2zm38.4 131.2l-38.4 28.8c-8.5 6.4-8.5 19.2 0 25.6l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4H488c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H210.7c-6.9 0-13.7 2.2-19.2 6.4zm0 160l-38.4 28.8c-8.5 6.4-8.5 19.2 0 25.6l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4H424c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H210.7c-6.9 0-13.7 2.2-19.2 6.4z", "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]]
};
var faIndianRupeeSign = {
  prefix: 'fad',
  iconName: 'indian-rupee-sign',
  icon: [320, 512, ["indian-rupee", "inr"], "e1bc", ["M185.3 144H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H185.3c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32zm67.1 64H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H252.4c2.3 10.3 3.6 21 3.6 32s-1.2 21.7-3.6 32z", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H96h16c44.2 0 80 35.8 80 80s-35.8 80-80 80H32c-13.9 0-26.2 9-30.5 22.2S2.1 306 13.4 314l224 160c14.4 10.3 34.4 6.9 44.6-7.4s6.9-34.4-7.4-44.6L130.3 318.9C201.2 309.9 256 249.3 256 176c0-29.6-8.9-57.1-24.2-80H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H112 96 32z"]]
};
var faIndianRupee = faIndianRupeeSign;
var faInr = faIndianRupeeSign;
var faCropSimple = {
  prefix: 'fad',
  iconName: 'crop-simple',
  icon: [512, 512, ["crop-alt"], "f565", ["M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V384c0 35.3 28.7 64 64 64H384V384H128V32zM480 384H448v64h32c17.7 0 32-14.3 32-32s-14.3-32-32-32z", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H64V64H32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352c0-35.3-28.7-64-64-64H128v64l256 0 0 352z"]]
};
var faCropAlt = faCropSimple;
var faMoneyBill1 = {
  prefix: 'fad',
  iconName: 'money-bill-1',
  icon: [576, 512, ["money-bill-alt"], "f3d1", ["M448 128H128c0 35.3-28.7 64-64 64V320c35.3 0 64 28.7 64 64H448c0-35.3 28.7-64 64-64V192c-35.3 0-64-28.7-64-64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm128 0c0 35.3-28.7 64-64 64V320c35.3 0 64 28.7 64 64H448c0-35.3 28.7-64 64-64V192c-35.3 0-64-28.7-64-64H128zm144 60h16c11 0 20 9 20 20v68h4c11 0 20 9 20 20s-9 20-20 20H288 264c-11 0-20-9-20-20s9-20 20-20h4V227.6c-9.1-1.9-16-9.9-16-19.6c0-11 9-20 20-20z"]]
};
var faMoneyBillAlt = faMoneyBill1;
var faLeftLong = {
  prefix: 'fad',
  iconName: 'left-long',
  icon: [512, 512, ["long-arrow-alt-left"], "f30a", ["M192 192l0 128 0 0 0 0 288 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-160 0 0 0-128 0z", "M151.5 102.6c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 0 128 0 72c0 9.6-5.7 18.2-14.5 22s-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136z"]]
};
var faLongArrowAltLeft = faLeftLong;
var faKeyboardDown = {
  prefix: 'fad',
  iconName: 'keyboard-down',
  icon: [576, 512, [], "e1c2", ["M0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm304-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H464zM160 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM272 64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H272zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM464 64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H464z", "M80 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm73.8 302.8c3.7-9 12.5-14.8 22.2-14.8H400c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2L305 505c-9.4 9.4-24.6 9.4-33.9 0L159 393c-6.9-6.9-8.9-17.2-5.2-26.2zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176zm400-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM160 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V80zM272 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80zM464 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16z"]]
};
var faCircleUpRight = {
  prefix: 'fad',
  iconName: 'circle-up-right',
  icon: [512, 512, [], "e129", ["M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm96 313.4V176c0-8.8-7.2-16-16-16H198.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L216 232l-66.3 66.3C146 302 144 306.9 144 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L280 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z", "M352 176V313.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6L280 296l-66.3 66.3C210 366 205.1 368 200 368s-10-2-13.7-5.7l-36.7-36.7C146 322 144 317.1 144 312s2-10 5.7-13.7L216 232l-33.4-33.4c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H336c8.8 0 16 7.2 16 16z"]]
};
var faCloudBoltMoon = {
  prefix: 'fad',
  iconName: 'cloud-bolt-moon',
  icon: [576, 512, ["thunderstorm-moon"], "f76d", ["M481.2 0c3.7 0 7.3 .2 10.9 .5c7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-26.9 15.1-44.9 43.6-44.9 76.1c0 48.1 39.4 87.4 88.4 87.4c5.2 0 10.3-.4 15.2-1.3c6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-23.3 22.4-55 36.1-89.9 36.1c-.8 0-1.6 0-2.4 0c-5.4-37.8-29.7-69.5-63-85.3c-1.8-38.6-23.1-72.1-54.3-90.8C380.6 33 427.1 0 481.2 0zM282.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L233.9 352H304c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L182.1 384H112c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z", "M447.9 271.9c0 44.2-35.8 80-80 80H349.2C342.4 332.8 324.3 320 304 320H285.7l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2L82 330.5c-6 4.8-10.5 10.7-13.6 17.4C28.8 336 0 299.4 0 255.9c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"]]
};
var faThunderstormMoon = faCloudBoltMoon;
var faDna = {
  prefix: 'fad',
  iconName: 'dna',
  icon: [448, 512, [129516], "f471", ["M416 512c17.7 0 32-14.3 32-32c0-59.8-30.3-107.5-69.4-146.6c-28-28-62.5-53.5-97.3-77.4c-13.1 9-26.4 17.9-39.5 26.6l-4 2.7c-4.6 3.1-9.2 6.2-13.8 9.2c20.9 14 40.8 27.7 59.3 41.5H164.8c-21.6 16.2-40.2 32.1-55.4 48H338.6c29.5 31 45.4 61.8 45.4 96c0 17.7 14.3 32 32 32zM166.7 256c11.8-8.1 23.8-16.1 35.6-24l3.9-2.6c6-4 11.9-8 17.8-11.9c-41.8-28.1-80.1-54.9-109.4-84.1C102.2 120.9 91.9 108.5 83.9 96H364.1c13-20.5 19.9-41.5 19.9-64H64C64 14.3 49.7 0 32 0S0 14.3 0 32C0 91.8 30.3 139.5 69.4 178.6c28 28 62.5 53.5 97.3 77.4z", "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 34.2-15.9 65-45.4 96H109.4c15.2 15.9 33.8 31.8 55.4 48H283.3c-23.6 17.7-49.7 35.2-77 53.4l-1.6 1 0 0 0 0c-46.9 31.2-97.1 64.7-135.3 102.9C30.3 372.5 0 420.2 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32H384c0-22.6-7-43.6-19.9-64H83.9c8-12.5 18.3-24.9 30.7-37.4c33.3-33.3 78.4-63.5 127.1-96l1.6-1 0 0c46.9-31.2 97.1-64.7 135.3-102.9C417.7 139.5 448 91.8 448 32z"]]
};
var faVirusSlash = {
  prefix: 'fad',
  iconName: 'virus-slash',
  icon: [640, 512, [], "e075", ["M476.5 348.1c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L264.6 182.1c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7L476.5 348.1zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faBracketRoundRight = {
  prefix: 'fad',
  iconName: 'bracket-round-right',
  icon: [192, 512, [], "29", ["M37.4 46.2C27.6 61 31.5 80.8 46.3 90.6C71.9 107.7 128 167 128 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C120.1 449 192 371.8 192 256S120.1 62.9 81.8 37.4C67 27.6 47.2 31.5 37.4 46.2z", ""]]
};
var faCircleSterling = {
  prefix: 'fad',
  iconName: 'circle-sterling',
  icon: [512, 512, [], "e5cf", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm5.5-352c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H231.7c-.6 16.4-3.8 32.6-9.5 48H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c6.8-13.2 10.7-27.6 11.4-42.4c-13.1-.2-23.6-10.9-23.6-24c0-13.1 10.5-23.7 23.5-24l-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9c10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z", "M231.2 190.5c-.1-16.8 13.5-30.5 30.3-30.5c3.9 0 7.7 .7 11.3 2.2l30.3 12.1c12.3 4.9 26.3-1.1 31.2-13.4s-1.1-26.3-13.4-31.2l-30.3-12.1c-9.2-3.7-19.1-5.6-29.1-5.6c-43.5 0-78.6 35.4-78.3 78.9l.2 33.1c-13 .3-23.5 10.9-23.5 24c0 13.1 10.6 23.8 23.6 24c-.7 14.8-4.6 29.2-11.4 42.4L162.7 333c-3.8 7.4-3.5 16.3 .8 23.5s12.1 11.5 20.5 11.5H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H222.2c5.7-15.4 9-31.6 9.5-48H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H231.5l-.2-33.5z"]]
};
var faCircle5 = {
  prefix: 'fad',
  iconName: 'circle-5',
  icon: [512, 512, [], "e0f2", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H228l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z", "M184.4 147.7c2.1-11.4 12-19.7 23.6-19.7H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H228l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88z"]]
};
var faMinus = {
  prefix: 'fad',
  iconName: 'minus',
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", ["M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z", ""]]
};
var faSubtract = faMinus;
var faFireFlame = {
  prefix: 'fad',
  iconName: 'fire-flame',
  icon: [384, 512, ["flame"], "f6df", ["M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zM188.8 148.3c2-2.7 5.2-4.3 8.5-4.3c5.9 0 10.7 4.8 10.7 10.7v11.4c0 8.9 3.6 17.4 9.9 23.6l51.5 50.7C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109h-3c-61.9 0-112-50.1-112-112v-8.2c0-21.2 7.8-41.6 21.8-57.4l6.9-7.8c2.1-2.4 5.1-3.7 8.3-3.7c6.1 0 11 4.9 11 11v44c0 24.3 19.8 44 44.1 44c24.2 0 43.9-19.6 43.9-43.8c0-11.6-4.6-22.8-12.8-31l-13.2-13.2c-14-14-21.9-33.1-21.9-53c0-16.2 5.3-32 15-44.9l5.8-7.8z", "M183 156l5.8-7.8c2-2.7 5.2-4.3 8.5-4.3c5.9 0 10.7 4.8 10.7 10.7v11.4c0 8.9 3.6 17.4 9.9 23.6l51.5 50.7C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109h-3c-61.9 0-112-50.1-112-112v-8.2c0-21.2 7.8-41.6 21.8-57.4l6.9-7.8c2.1-2.4 5.1-3.7 8.3-3.7c6.1 0 11 4.9 11 11v44c0 24.3 19.8 44 44.1 44c24.2 0 43.9-19.6 43.9-43.8c0-11.6-4.6-22.8-12.8-31l-13.2-13.2c-14-14-21.9-33.1-21.9-53c0-16.2 5.3-32 15-44.9z"]]
};
var faFlame = faFireFlame;
var faRightToLine = {
  prefix: 'fad',
  iconName: 'right-to-line',
  icon: [448, 512, ["arrow-alt-to-right"], "f34c", ["M416 448c-17.7 0-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32z", "M340.7 228.7L217.9 105.9c-6.4-6.4-15-9.9-24-9.9c-18.7 0-33.9 15.2-33.9 33.9l0 62.1L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0 0 62.1c0 18.7 15.2 33.9 33.9 33.9c9 0 17.6-3.6 24-9.9L340.7 283.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3z"]]
};
var faArrowAltToRight = faRightToLine;
var faGif = {
  prefix: 'fad',
  iconName: 'gif',
  icon: [576, 512, [], "e190", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 192c-35.3 0-64 28.7-64 64s28.7 64 64 64c11.7 0 22.6-3.1 32-8.6V280H184c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c8.8 0 16 7.2 16 16v56c0 5-2.4 9.8-6.4 12.8c-16 12.1-36 19.2-57.6 19.2c-53 0-96-43-96-96s43-96 96-96c21.6 0 41.6 7.1 57.6 19.2c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2c-10.7-8-24-12.8-38.4-12.8zm112-32c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm48 16c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v48h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V256 176z", "M128 256c0-35.3 28.7-64 64-64c14.4 0 27.7 4.8 38.4 12.8c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4c-16-12.1-36-19.2-57.6-19.2c-53 0-96 43-96 96s43 96 96 96c21.6 0 41.6-7.1 57.6-19.2c4-3 6.4-7.8 6.4-12.8V264c0-8.8-7.2-16-16-16H184c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v31.4c-9.4 5.4-20.3 8.6-32 8.6c-35.3 0-64-28.7-64-64zm192-80c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176zm48-16c-8.8 0-16 7.2-16 16v80 80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H368z"]]
};
var faChess = {
  prefix: 'fad',
  iconName: 'chess',
  icon: [512, 512, [], "f439", ["M304 208v51.9c0 7.8 2.8 15.3 8 21.1L339.2 312 337 384H462.5l-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7V208c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v16H424V208c0-8.8-7.2-16-16-16H392c-8.8 0-16 7.2-16 16v16H352V208c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16v32H384V304zM292.8 473.6c-3.1 4.2-4.8 9.2-4.8 14.4c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L464 416H336l-43.2 57.6z", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H60.2C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384H196L180 256h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48z"]]
};
var faTrashSlash = {
  prefix: 'fad',
  iconName: 'trash-slash',
  icon: [640, 512, [], "e2b3", ["M132.5 200.4L488 480.5C481.2 499 463.5 512 442.9 512H197.1c-25.3 0-46.3-19.7-47.9-45L132.5 200.4zM512 128L497.2 364.4 195.6 128H512zm0-32H154.8L98.4 51.8C103.2 40.2 114.6 32 128 32h96l7.2-14.3C236.6 6.8 247.7 0 259.8 0H380.2c12.1 0 23.2 6.8 28.6 17.7L416 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faArrowLeftLong = {
  prefix: 'fad',
  iconName: 'arrow-left-long',
  icon: [512, 512, ["long-arrow-left"], "f177", ["M109.3 288L480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0-32 32 32 32z", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L77.3 256 182.6 361.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"]]
};
var faLongArrowLeft = faArrowLeftLong;
var faPlugCircleCheck = {
  prefix: 'fad',
  iconName: 'plug-circle-check',
  icon: [576, 512, [], "e55c", ["M128 32v96H64V32C64 14.3 78.3 0 96 0s32 14.3 32 32zm192 0v96H256V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V412.8C87 398 32 333.4 32 256V224c-17.7 0-32-14.3-32-32z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faFontCase = {
  prefix: 'fad',
  iconName: 'font-case',
  icon: [640, 512, [], "f866", ["M512 160c-70.7 0-128 57.3-128 128v64c0 70.7 57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V352 288 192c0-17.7-14.3-32-32-32c-13 0-24.1 7.7-29.2 18.8C559.4 166.9 536.5 160 512 160zm64 128v64c0 35.3-28.7 64-64 64s-64-28.7-64-64V288c0-35.3 28.7-64 64-64s64 28.7 64 64z", "M206 52.8C201.3 40.3 189.3 32 176 32s-25.3 8.3-30 20.8L2 436.8c-6.2 16.5 2.2 35 18.7 41.2s35-2.2 41.2-18.7L96.2 368H255.8L290 459.2c6.2 16.5 24.7 24.9 41.2 18.7s24.9-24.6 18.7-41.2L206 52.8zM231.8 304H120.2L176 155.1 231.8 304z"]]
};
var faStreetView = {
  prefix: 'fad',
  iconName: 'street-view',
  icon: [512, 512, [], "f21d", ["M197.5 337.8c-41.1 2.6-79 8-109.9 16C65.2 359.6 45 367.1 29.8 377C15.1 386.6 0 401.9 0 424s15.1 37.4 29.8 47c15.2 9.9 35.5 17.5 57.8 23.3C132.7 505.9 192.9 512 256 512s123.3-6.1 168.4-17.8c22.4-5.8 42.6-13.3 57.8-23.3c14.7-9.6 29.8-24.9 29.8-47s-15.1-37.4-29.8-47c-15.2-9.9-35.5-17.5-57.8-23.3c-30.9-8-68.8-13.4-109.9-16l-5.3 47.8c39.6 2.4 75.3 7.5 103.2 14.7c56.6 14.6 56.6 32.9 0 47.5C372.5 458.1 316.6 464 256 464s-116.5-5.9-156.4-16.2c-56.6-14.6-56.6-32.9 0-47.5c27.9-7.2 63.6-12.3 103.2-14.7l-5.3-47.8z", "M256 0a64 64 0 1 1 0 128A64 64 0 1 1 256 0zM160 224c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v48c0 17.7-14.3 32-32 32h-1.8l-11.1 99.5c-1.8 16.2-15.5 28.5-31.8 28.5H236.6c-16.3 0-30-12.3-31.8-28.5L193.8 304H192c-17.7 0-32-14.3-32-32V224z"]]
};
var faArrowDownLeft = {
  prefix: 'fad',
  iconName: 'arrow-down-left',
  icon: [384, 512, [], "e091", ["M96 306.7L297.4 105.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L141.3 352H96V306.7z", "M32 384c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V384z"]]
};
var faFrancSign = {
  prefix: 'fad',
  iconName: 'franc-sign',
  icon: [320, 512, [], "e18f", ["M48 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48V320zm64 64h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112v64z", "M80 32C62.3 32 48 46.3 48 64V224 448c0 17.7 14.3 32 32 32s32-14.3 32-32V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]]
};
var faFlaskRoundPoison = {
  prefix: 'fad',
  iconName: 'flask-round-poison',
  icon: [448, 512, ["flask-poison"], "f6e0", ["M328.5 172.1c-5.2-3-8.5-8.4-8.5-14.4V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H304 256 192 144 128C110.3 0 96 14.3 96 32s14.3 32 32 32v93.7c0 6-3.3 11.4-8.5 14.4l0 0c-5.3 3.1-10.4 6.4-15.4 9.9C50.8 219.7 16 281.8 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9zM300 376.6c-7.1 5.2-12 13-12 21.8V408c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24v-9.6c0-8.8-4.9-16.7-12-21.8c-22.1-16.1-36-39.1-36-64.6c0-48.6 50.1-88 112-88s112 39.4 112 88c0 25.5-13.9 48.6-36 64.6z", "M288 398.4c0-8.8 4.9-16.7 12-21.8c22.1-16.1 36-39.1 36-64.6c0-48.6-50.1-88-112-88s-112 39.4-112 88c0 25.5 13.9 48.6 36 64.6c7.1 5.2 12 13 12 21.8V408c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-9.6zM160 312a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faFlaskPoison = faFlaskRoundPoison;
var faVolumeOff = {
  prefix: 'fad',
  iconName: 'volume-off',
  icon: [320, 512, [], "f026", ["", "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"]]
};
var faBookCircleArrowRight = {
  prefix: 'fad',
  iconName: 'book-circle-arrow-right',
  icon: [640, 512, [], "e0bc", ["M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V198.6C374.1 219.5 320 287.4 320 368c0 5.4 .2 10.7 .7 16H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H339.2c13.1 25.6 32.2 47.6 55.6 64H384 96c-53 0-96-43-96-96V96z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm19.3-211.3l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]]
};
var faChartUser = {
  prefix: 'fad',
  iconName: 'chart-user',
  icon: [640, 512, ["user-chart"], "f6a3", ["M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H576V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm252.7 75.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h88c8.8 0 16 7.2 16 16v88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 55.7-55.7-27-27z", "M160 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-26.7 32C59.7 352 0 411.7 0 485.3C0 500.1 11.9 512 26.7 512H293.3c14.7 0 26.7-11.9 26.7-26.7C320 411.7 260.3 352 186.7 352H133.3z"]]
};
var faUserChart = faChartUser;
var faHandsAslInterpreting = {
  prefix: 'fad',
  iconName: 'hands-asl-interpreting',
  icon: [640, 512, ["american-sign-language-interpreting", "asl-interpreting", "hands-american-sign-language-interpreting"], "f2a3", ["M497.7 508.6c-15.8-7.9-22.2-27.1-14.3-42.9l23-46L404.5 504.6c-13.6 11.3-33.8 9.5-45.1-4.1s-9.5-33.8 4.1-45.1l81.6-68L344.4 414.9c-17 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3l80.8-22c-24.9-7.9-45.6-25-58.4-47.1c-8.9-15.3-3.6-34.9 11.7-43.7s34.9-3.6 43.7 11.7c7 12 19.9 20 34.7 20c22.1 0 40-17.9 40-40s-17.9-40-40-40c-14.8 0-27.7 8-34.7 20c-8.9 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.7-28.8 46.9-49 82.1-51.7V128h8 72c70.7 0 128 57.3 128 128v9.3c0 19.9-4.6 39.5-13.5 57.2L540.6 494.3c-7.9 15.8-27.1 22.2-42.9 14.3z", "M142.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9l-23 46L235.5 7.4c13.6-11.3 33.8-9.5 45.1 4.1s9.5 33.8-4.1 45.1l-81.6 68L295.6 97.1c17.1-4.7 34.6 5.4 39.3 22.5s-5.4 34.6-22.5 39.3l-80.8 22c24.9 7.9 45.6 24.9 58.4 47.1c8.8 15.3 3.6 34.9-11.7 43.7s-34.9 3.6-43.7-11.7c-7-12-19.9-20-34.7-20c-22.1 0-40 17.9-40 40s17.9 40 40 40c14.8 0 27.7-8 34.7-20c8.8-15.3 28.4-20.5 43.7-11.7s20.5 28.4 11.7 43.7c-16.7 28.8-46.9 49-82.1 51.7v.3h-8H128C57.3 384 0 326.7 0 256v-9.3c0-19.9 4.6-39.5 13.5-57.2L99.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3z"]]
};
var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faAslInterpreting = faHandsAslInterpreting;
var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faPresentationScreen = {
  prefix: 'fad',
  iconName: 'presentation-screen',
  icon: [576, 512, ["presentation"], "f685", ["M32 288V64H96V288H480V64h64V288c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64z", "M0 32C0 14.3 14.3 0 32 0H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 64 0 49.7 0 32zM256 386.7V352h64v34.7l70.6 70.6c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 445.3l-57.4 57.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L256 386.7z"]]
};
var faPresentation = faPresentationScreen;
var faCircleBolt = {
  prefix: 'fad',
  iconName: 'circle-bolt',
  icon: [512, 512, [], "e0fe", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm74.1-396.4c5.8 4.7 7.6 12.9 4.2 19.6L281.9 240H352c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 272H160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z", "M334.3 135.2c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8z"]]
};
var faFaceSmileHalo = {
  prefix: 'fad',
  iconName: 'face-smile-halo',
  icon: [512, 512, [], "e38f", ["M45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5C413.9 178.3 339 192 256 192s-157.9-13.7-210.4-35.5zm95.9 199.4c6.7-5.8 16.8-5.1 22.6 1.6C182 378.2 212.6 400 256 400s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 404.1 311.1 432 256 432s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6zm76.1-55.1l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zm160 0l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0z", "M512 80c0 44.2-114.6 80-256 80S0 124.2 0 80S114.6 0 256 0S512 35.8 512 80zm-64 0c0-17.7-86-32-192-32S64 62.3 64 80s86 32 192 32s192-14.3 192-32zM217.6 300.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0z"]]
};
var faCartCircleArrowDown = {
  prefix: 'fad',
  iconName: 'cart-circle-arrow-down',
  icon: [640, 512, [], "e3ef", ["M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5h121c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H339.2c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M352 368a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm211.3 19.3l-56 56c-6.2 6.2-16.4 6.2-22.6 0l-56-56c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 393.4l0-89.4c0-8.8 7.2-16 16-16s16 7.2 16 16l0 89.4 28.7-28.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faHousePersonReturn = {
  prefix: 'fad',
  iconName: 'house-person-return',
  icon: [640, 512, ["house-person-arrive", "house-return"], "e011", ["M261.7 16.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S18.8 264 32 264H64V376c0 26.5 21.5 48 48 48H340l12.9-51.6c3.2-12.9 9.6-24.8 18.6-34.7l6.8-7.5c-31.2 14.1-68.2 1.2-83.6-29.7c-15.8-31.6-3-70.1 28.6-85.9l10.7-5.4 10.7-25.8c8.9-21.3 22.6-39.7 39.5-54L261.7 16.5zM160 192h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16z", "M384 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM513.5 199.3c1 .4 1.9 .8 2.9 1.2l8 3.5c16.4 7.3 29 21.2 34.7 38.2l2.6 7.8c5.6 16.8 23.7 25.8 40.5 20.2s25.8-23.7 20.2-40.5l-2.6-7.8c-11.4-34.1-36.6-61.9-69.4-76.5l-8-3.5c-20.8-9.2-43.3-14-66.1-14c-44.6 0-84.8 26.8-101.9 67.9L359 232.7l-21.4 10.7c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3L393 287.3c10.3-5.2 18.4-13.8 22.8-24.5l9.6-23 19.3 65.5-49.5 54c-5.4 5.9-9.2 13-11.2 20.8l-23 92.1c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.1 70.7-77.1c14.8-16.1 20.3-38.6 14.7-59.7l-16.9-63.5zM571.3 398l-25-62.4c-2.1 3-4.5 5.8-7 8.6l-40.7 44.4 14.5 36.2c2.4 6 6 11.5 10.6 16.1l61.7 61.7c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L571.3 398z"]]
};
var faHousePersonArrive = faHousePersonReturn;
var faHouseReturn = faHousePersonReturn;
var faMessageXmark = {
  prefix: 'fad',
  iconName: 'message-xmark',
  icon: [512, 512, ["comment-alt-times", "message-times"], "f4ab", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm175 63c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z", "M209 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faCommentAltTimes = faMessageXmark;
var faMessageTimes = faMessageXmark;
var faFileCertificate = {
  prefix: 'fad',
  iconName: 'file-certificate',
  icon: [512, 512, ["file-award"], "f5f3", ["M192 0c-35.3 0-64 28.7-64 64V168.6c1 0 2.1-.2 3-.6l15.8-6.5c10-4.1 21.5-1 28.1 7.5l10.5 13.5c1.3 1.7 3.2 2.7 5.2 3l16.9 2.3c10.7 1.5 19.1 9.9 20.5 20.5l2.3 16.9c.3 2.1 1.4 4 3 5.2l13.5 10.5c8.5 6.6 11.6 18.1 7.5 28.1L248 285c-.8 1.9-.8 4.1 0 6.1l6.5 15.8c4.1 10 1 21.5-7.5 28.1l-13.5 10.5c-1.7 1.3-2.7 3.2-3 5.2l-2.3 16.9c-1.5 10.7-9.9 19.1-20.5 20.6L192 390.2V496c0 5.9-3.2 11.3-8.5 14.1c-.7 .4-1.5 .7-2.3 1c3.5 .6 7.1 .9 10.7 .9H448c35.3 0 64-28.7 64-64V160H384c-17.7 0-32-14.3-32-32V0H192z", "M512 160L352 0V128c0 17.7 14.3 32 32 32H512zm-402.8 1.6c-10-4.1-21.5-1-28.1 7.5L70.6 182.6c-1.3 1.7-3.2 2.7-5.2 3l-16.9 2.3c-10.7 1.5-19.1 9.9-20.5 20.5l-2.3 16.9c-.3 2.1-1.4 4-3 5.2L9.1 241.1c-8.5 6.6-11.6 18.1-7.5 28.1L8 285c.8 1.9 .8 4.1 0 6.1L1.6 306.8c-4.1 10-1 21.5 7.5 28.1l13.5 10.5c1.7 1.3 2.7 3.2 3 5.2l2.3 16.9c1.5 10.7 9.9 19.1 20.5 20.6L64 390.2V496c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L128 483.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V390.2l15.5-2.1c10.7-1.5 19.1-9.9 20.5-20.6l2.3-16.9c.3-2.1 1.4-4 3-5.2l13.5-10.5c8.5-6.6 11.6-18.1 7.5-28.1L248 291c-.8-1.9-.8-4.1 0-6.1l6.5-15.8c4.1-10 1-21.5-7.5-28.1l-13.5-10.5c-1.7-1.3-2.7-3.2-3-5.2l-2.3-16.9c-1.5-10.7-9.9-19.1-20.5-20.5l-16.9-2.3c-2.1-.3-4-1.4-5.2-3l-10.5-13.5c-6.6-8.5-18.1-11.6-28.1-7.5L131 168c-1.9 .8-4.1 .8-6.1 0l-15.8-6.5zM64 288a64 64 0 1 1 128 0A64 64 0 1 1 64 288z"]]
};
var faFileAward = faFileCertificate;
var faUserDoctorHairLong = {
  prefix: 'fad',
  iconName: 'user-doctor-hair-long',
  icon: [448, 512, [], "e459", ["M257.9 66.2C241 93.7 210.6 112 176 112H128l0 32c0 53 43 96 96 96s96-43 96-96l0-48h-8c-22.8 0-42.8-11.9-54.1-29.8z", "M176 112H128h0v32c0 53 43 96 96 96s96-43 96-96V128h0V96h-8c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112zm48 160H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128h0C96 57.3 153.3 0 224 0c70.6 0 127.8 57.1 128 127.6v.8l0 .2V139c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224zm64 32.2V362c-27.6 7.1-48 32.2-48 62v40c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16V424c0-17.7 14.3-32 32-32s32 14.3 32 32v24c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V424c0-29.8-20.4-54.9-48-62V308.8C393.5 326.7 448 393 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-79 54.5-145.3 128-163.2v61.5c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V304.2c2.7-.1 5.3-.2 8-.2H280c2.7 0 5.3 .1 8 .2zM120 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
};
var faCameraSecurity = {
  prefix: 'fad',
  iconName: 'camera-security',
  icon: [448, 512, ["camera-home"], "f8fe", ["M224 304a96 96 0 1 0 0-192 96 96 0 1 0 0 192z", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H310l59 36.9c12.1 7.6 17.7 22.2 13.8 36S366.3 512 352 512H96c-14.3 0-26.8-9.5-30.8-23.2s1.7-28.4 13.8-36L138 416H64c-35.3 0-64-28.7-64-64V64zM224 336a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]]
};
var faCameraHome = faCameraSecurity;
var faGear = {
  prefix: 'fad',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", ["M192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z", "M489.6 191.2c6.9-6.2 9.6-15.9 6.4-24.6c-4.4-11.9-9.7-23.3-15.8-34.3l-4.7-8.1c-6.6-11-14-21.4-22.1-31.2c-5.9-7.2-15.7-9.6-24.5-6.8L389.1 98.8c-10 3.2-20.8 1.1-29.7-4.6c-4.9-3.1-9.9-6.1-15.1-8.7c-9.3-4.8-16.5-13.2-18.8-23.4l-8.9-40.7c-2-9.1-9-16.3-18.2-17.8C284.7 1.2 270.5 0 256 0s-28.7 1.2-42.5 3.5c-9.2 1.5-16.2 8.7-18.2 17.8l-8.9 40.7c-2.2 10.2-9.5 18.6-18.8 23.4c-5.2 2.7-10.2 5.6-15.1 8.7c-8.8 5.7-19.7 7.7-29.7 4.6L83.1 86.1c-8.8-2.8-18.6-.3-24.5 6.8c-8.1 9.8-15.5 20.2-22.1 31.2l-4.7 8.1c-6.1 11-11.4 22.4-15.8 34.3c-3.2 8.7-.5 18.4 6.4 24.6l30.9 28.1c7.7 7.1 11.4 17.5 10.9 27.9c-.1 2.9-.2 5.8-.2 8.8s.1 5.9 .2 8.8c.5 10.5-3.1 20.9-10.9 27.9L22.4 320.8c-6.9 6.2-9.6 15.9-6.4 24.6c4.4 11.9 9.7 23.3 15.8 34.3l4.7 8.1c6.6 11 14 21.4 22.1 31.2c5.9 7.2 15.7 9.6 24.5 6.8l39.7-12.6c10-3.2 20.8-1.1 29.7 4.6c4.9 3.1 9.9 6.1 15.1 8.7c9.3 4.8 16.5 13.2 18.8 23.4l8.9 40.7c2 9.1 9 16.3 18.2 17.8c13.8 2.3 28 3.5 42.5 3.5s28.7-1.2 42.5-3.5c9.2-1.5 16.2-8.7 18.2-17.8l8.9-40.7c2.2-10.2 9.4-18.6 18.8-23.4c5.2-2.7 10.2-5.6 15.1-8.7c8.8-5.7 19.7-7.7 29.7-4.6l39.7 12.6c8.8 2.8 18.6 .3 24.5-6.8c8.1-9.8 15.5-20.2 22.1-31.2l4.7-8.1c6.1-11 11.3-22.4 15.8-34.3c3.2-8.7 .5-18.4-6.4-24.6l-30.9-28.1c-7.7-7.1-11.4-17.5-10.9-27.9c.1-2.9 .2-5.8 .2-8.8s-.1-5.9-.2-8.8c-.5-10.5 3.1-20.9 10.9-27.9l30.9-28.1zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]]
};
var faCog = faGear;
var faDropletSlash = {
  prefix: 'fad',
  iconName: 'droplet-slash',
  icon: [640, 512, ["tint-slash"], "f5c7", ["M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM205.8 136L505.2 370.7c4.4-16.1 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faTintSlash = faDropletSlash;
var faBookHeart = {
  prefix: 'fad',
  iconName: 'book-heart',
  icon: [448, 512, [], "f499", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 256 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H256h96 64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm32 157.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4C258.9 102.5 274.5 96 290.7 96c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]]
};
var faMosque = {
  prefix: 'fad',
  iconName: 'mosque',
  icon: [640, 512, [128332], "f678", ["M412.8 6.4C409.8 2.4 405 0 400 0s-9.8 2.4-12.8 6.4c-34.7 46.3-78.1 74.9-133.5 111.5l0 0c-5.2 3.5-10.6 7-16 10.6c-28.9 19.2-45.7 51.7-45.7 86.1c0 28.6 11.3 54.5 29.8 73.4H578.2c18.4-19 29.8-44.9 29.8-73.4c0-34.4-16.7-66.9-45.7-86.1c-5.4-3.6-10.8-7.1-16-10.6l0 0C490.9 81.3 447.5 52.7 412.8 6.4zM89.6 5.2C83.9 .9 76.1 .9 70.4 5.2l-16 12C20.2 42.9 0 83.2 0 126v34H160V126c0-42.8-20.2-83.1-54.4-108.8l-16-12z", "M160 160V264.6c-19.1 11.1-32 31.7-32 55.4V480c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176 160H160zM352 512H288V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H560V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H448V454c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58z"]]
};
var faDuck = {
  prefix: 'fad',
  iconName: 'duck',
  icon: [512, 512, [129414], "f6d8", ["M400 224c.2-8.5 3.9-16.4 9.2-23c14.3-17.8 22.8-40.4 22.8-65c0-3.4-.2-6.7-.5-10.1l.6 .1c10.5 1.3 21.2 1.3 31.8 0l35.3-4.4c6.8-.8 12.8 4.4 12.8 11.3c0 50.3-40.8 91.1-91.1 91.1H400z", "M409.2 201c-5.4 6.8-9.2 15-9.2 23.7v24c0 6.6 2.8 12.8 7.2 17.7C427.6 289.1 440 319.1 440 352c0 70.7-57.3 128-128 128H196C87.8 480 0 392.2 0 284v-5.4C0 266.1 10.1 256 22.6 256c6 0 11.8 2.4 16 6.6L54 278c6.2 6.2 15.2 8.5 23.6 6.1l172.8-49.4c10.4-3 15.7-14.5 7.8-21.7v0c-21-19-34.1-46.5-34.1-77c0-57.4 46.6-104 104-104s104 46.6 104 104c0 24.6-8.5 47.2-22.8 65zM368 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM340.6 296.9c.5-8.8-6.2-16.4-15-16.9s-16.4 6.2-16.9 15c-2.4 41.2-32.6 79-77.3 90.1c-40.3 10.1-80.5-4.6-103.7-33.5c-5.5-6.9-15.6-8-22.5-2.5s-8 15.6-2.5 22.5c31.1 38.7 84 57.6 136.4 44.5c58-14.5 98.3-63.8 101.5-119.3z"]]
};
var faMosquito = {
  prefix: 'fad',
  iconName: 'mosquito',
  icon: [640, 512, [], "e52b", ["M320 237.1L154.6 388.3C97.6 448.2 0 405.8 0 321.1c0-48 34-88.4 79.3-94.3l219.3-34.4 42.7 0 219.3 34.4c45.3 5.9 79.4 46.4 79.4 94.4c0 84.7-97.6 127.1-154.6 67.2L320 237.1z", "M463.6 505.6c9.8-8.9 10.7-24.3 2.1-34.3l-42-49V367.6c0-5.5-1.8-10.8-5.1-15.1L352 266v0l-32-29.2L288 266v0l-66.6 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.4l0 63.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.2 24.4 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1zm-231.3-303l66.4-10.4h42.7l66.3 10.4 40.8-40.8c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.3l38.2-50.8c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.2-33.2 4.4l-48 63.8c-5.9 7.9-6.6 18.6-1.7 27.2l22.6 39.4L352 190.4l0-38.1c0-14.9-10.2-27.4-24-31l0-57.1c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.1c-13.8 3.6-24 16.1-24 31l0 38.1-50.2-50.2 22.6-39.4c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.8c-8-10.6-22.9-12.6-33.2-4.4s-12.3 23.5-4.3 34.1l38.2 50.8L187.6 132c-5.5 9.7-3.9 21.9 3.9 29.8l40.8 40.8z"]]
};
var faStarOfDavid = {
  prefix: 'fad',
  iconName: 'star-of-david',
  icon: [512, 512, [10017], "f69a", ["M229 400l27 44L371.4 256l32.9 53.5-111.7 182C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H229zM128.9 344L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l-34.4 56H86.6l108 176H128.9zM229 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87-32.9-53.5L425.4 168H194.6L229 112z", "M283 112L256 68 140.6 256l-32.9-53.5 111.7-182C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H283zm100.1 56L490.5 343c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l34.4-56h42.3l-108-176h65.7zM283 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87 32.9 53.5L86.6 344H317.4L283 400z"]]
};
var faFlagSwallowtail = {
  prefix: 'fad',
  iconName: 'flag-swallowtail',
  icon: [448, 512, ["flag-alt"], "f74c", ["M424 32H64V352H424c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24z", "M32 0C49.7 0 64 14.3 64 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32C0 14.3 14.3 0 32 0z"]]
};
var faFlagAlt = faFlagSwallowtail;
var faPersonMilitaryRifle = {
  prefix: 'fad',
  iconName: 'person-military-rifle',
  icon: [512, 512, [], "e54b", ["M437.9 40l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7l-30.4 52.7c-1.9 3.2-4.2 6-6.9 8.3c-16.1-22.6-38.6-39.5-64.2-48.8L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9zM182.7 78.6H329.4c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-11.4 2.4-22.2 6.7-32zm148.4 430L149.7 249.5c8.6-6.4 18-11.8 27.9-16L351.8 482.4c-1.4 12.1-9.6 22.2-20.7 26.2z", "M178.1 19.5L334.1 .8C343.6-.4 352 7.1 352 16.6v46c0 8.8-7.2 16-16 16H181.7c-16.4 0-29.7-13.3-29.7-29.7c0-15 11.2-27.7 26.1-29.5zM113.7 289.4c9.4-15.8 21.7-29.3 36-40L331.1 508.6c-3.5 1.3-7.2 2-11.1 2H192c-17.7 0-32-14.3-32-32V368.3L106.4 459C95.2 478 70.7 484.3 51.7 473s-25.3-35.8-14.1-54.8l76.1-128.8zM352 478.6c0 1.3-.1 2.5-.2 3.8L177.5 233.5c16.6-7.1 34.6-10.9 53.3-10.9h50.4c48.1 0 92.6 25.4 117.1 66.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1L352 368.3V478.6zm-56-160a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faCarGarage = {
  prefix: 'fad',
  iconName: 'car-garage',
  icon: [640, 512, [], "f5e2", ["M296.2 6.3c14.8-8.4 32.9-8.4 47.6 0L615.9 161.8c15.3 8.8 20.7 28.3 11.9 43.7s-28.3 20.7-43.7 11.9L320 66.4 55.9 217.4c-15.3 8.8-34.9 3.4-43.7-11.9s-3.4-34.9 11.9-43.7L296.2 6.3z", "M234.8 234.6L215.7 288H424.3l-19.1-53.4c-2.3-6.4-8.3-10.6-15.1-10.6H249.8c-6.8 0-12.8 4.3-15.1 10.6zm-88.6 57.8l28.3-79.3C185.9 181.3 216 160 249.8 160H390.2c33.8 0 64 21.3 75.3 53.1l28.3 79.3c20.1 8.5 34.2 28.4 34.2 51.6v40 64 32c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V448H192v32c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V448 384 344c0-23.2 14.1-43.1 34.2-51.6zM216 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faCartShopping = {
  prefix: 'fad',
  iconName: 'cart-shopping',
  icon: [576, 512, [128722, "shopping-cart"], "f07a", ["M170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411c2 4.2 3.5 8.8 4.4 13.5L170.7 288z", "M0 24C0 10.7 10.7 0 24 0H69.5c26.9 0 50 19.1 55 45.5l51.6 271c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faShoppingCart = faCartShopping;
var faBookFont = {
  prefix: 'fad',
  iconName: 'book-font',
  icon: [448, 512, [], "e0bf", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 256 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H256h96 64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zM254.3 72.8l64 128 32 64c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L294.1 224H185.9l-27.6 55.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l32-64 64-128c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8zM240 115.8L201.9 192h76.2L240 115.8z"]]
};
var faShieldPlus = {
  prefix: 'fad',
  iconName: 'shield-plus',
  icon: [512, 512, [], "e24a", ["M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M232 280v64c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faVials = {
  prefix: 'fad',
  iconName: 'vials',
  icon: [512, 512, [], "f493", ["M0 64C0 46.3 14.3 32 32 32H88h48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80L32 96C14.3 96 0 81.7 0 64zM136 96H88V400c0 13.3 10.7 24 24 24s24-10.7 24-24V96zM288 64c0-17.7 14.3-32 32-32h56 48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zM424 96H376V400c0 13.3 10.7 24 24 24s24-10.7 24-24V96z", "M136 256H88V400c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm288 0H376V400c0 13.3 10.7 24 24 24s24-10.7 24-24V256z"]]
};
var faEyeDropperFull = {
  prefix: 'fad',
  iconName: 'eye-dropper-full',
  icon: [512, 512, [], "e172", ["M198.7 180L55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L332 313.3 286.7 268 143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L244 225.3 198.7 180z", "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM143.4 411.3L261.4 293.4l-42.7-42.7L100.7 368.6c-3 3-4.7 7.1-4.7 11.3V416h36.1c4.2 0 8.3-1.7 11.3-4.7z"]]
};
var faDistributeSpacingHorizontal = {
  prefix: 'fad',
  iconName: 'distribute-spacing-horizontal',
  icon: [512, 512, [], "e365", ["M160 144c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V144z", "M56 0C42.7 0 32 10.7 32 24V488c0 13.3 10.7 24 24 24s24-10.7 24-24V24C80 10.7 69.3 0 56 0zM456 0c-13.3 0-24 10.7-24 24V488c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24z"]]
};
var faTabletRugged = {
  prefix: 'fad',
  iconName: 'tablet-rugged',
  icon: [448, 512, [], "f48f", ["M32 176L8.8 164.4C3.4 161.7 0 156.2 0 150.1V73.9c0-6.1 3.4-11.6 8.8-14.3L34.3 46.8C41.8 19.8 66.6 0 96 0H352c29.4 0 54.2 19.8 61.7 46.8l25.5 12.7c5.4 2.7 8.8 8.3 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3L416 176v16l23.2 11.6c5.4 2.7 8.8 8.3 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3L416 320v16l23.2 11.6c5.4 2.7 8.8 8.2 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3l-25.5 12.7c-7.5 27-32.3 46.8-61.7 46.8H96c-29.4 0-54.2-19.8-61.7-46.8L8.8 452.4C3.4 449.7 0 444.2 0 438.1V361.9c0-6.1 3.4-11.6 8.8-14.3L32 336V320L8.8 308.4C3.4 305.7 0 300.2 0 294.1V217.9c0-6.1 3.4-11.6 8.8-14.3L32 192V176zM112 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112z", "M96 80c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V80z"]]
};
var faTemperatureSnow = {
  prefix: 'fad',
  iconName: 'temperature-snow',
  icon: [576, 512, ["temperature-frigid"], "f768", ["M432 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C358.2 332.6 352 349.5 352 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM320 112C320 50.2 370.1 0 432 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M288 131.6l-88 50.8V126.6l35.3-35.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L200 81.4V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V81.4L139.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L152 126.6v55.8l-48.3-27.9L90.7 106.3C88.5 97.7 79.7 92.7 71.2 95s-13.6 11.1-11.3 19.6l4.6 17.3-22-12.7C31 112.6 16.3 116.5 9.7 128s-2.7 26.2 8.8 32.8l22 12.7-17.3 4.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l48.2-12.9L128 224 79.7 251.9 31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l17.3 4.6-22 12.7C7 293.8 3.1 308.5 9.7 320s21.3 15.4 32.8 8.8l22-12.7-4.6 17.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l12.9-48.2L152 265.6v55.8l-35.3 35.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L152 366.6V392c0 13.3 10.7 24 24 24s24-10.7 24-24V366.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L200 321.4V265.6l67.7 39.1c5.2-13.5 12-26.2 20.3-37.9v-5.8l-64-37 64-37V131.6zM432 256c-8.8 0-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16z"]]
};
var faTemperatureFrigid = faTemperatureSnow;
var faMoped = {
  prefix: 'fad',
  iconName: 'moped',
  icon: [640, 512, [], "e3b9", ["M128 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H128zM512 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM64 384c0 53 43 96 96 96s96-43 96-96H208c0 26.5-21.5 48-48 48s-48-21.5-48-48H64z", "M328 56c0-13.3 10.7-24 24-24h41.3c23.8 0 45.1 15.1 52.9 37.6l8.1 23.3 51-25.5c4.4-2.2 9.3-3.4 14.3-3.4H528c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-8.4c-5 0-9.9-1.2-14.3-3.4l-34.9-17.5L500 224.4c4-.3 8-.4 12-.4c43.7 0 83.3 17.5 112.1 45.8c9.5 9.3 9.6 24.5 .3 33.9s-24.5 9.6-33.9 .3C570.2 284.2 542.6 272 512 272c-55.1 0-101 39.8-110.3 92.3c-2 11.5-12 19.8-23.6 19.8H336c-.9 0-1.7 0-2.6-.1H32c-17.7 0-32-14.3-32-32V320c0-70.7 57.3-128 128-128h96c17.7 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32h77.3c16.8-38.5 48.4-69.2 87.6-84.7L400.8 85.4c-1.1-3.2-4.2-5.4-7.6-5.4H352c-13.3 0-24-10.7-24-24z"]]
};
var faFaceSmilePlus = {
  prefix: 'fad',
  iconName: 'face-smile-plus',
  icon: [640, 512, ["smile-plus"], "f5b9", ["M224 512a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM144.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM140 346.1c20.5 23.3 50.6 37.9 84 37.9s63.5-14.6 84-37.9c5.8-6.6 16-7.3 22.6-1.4s7.3 16 1.4 22.6C305.6 397.1 267 416 224 416s-81.6-18.9-108-48.7c-5.8-6.6-5.2-16.7 1.4-22.6s16.7-5.2 22.6 1.4z", "M544 0c13.3 0 24 10.7 24 24V72h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H568v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V120H472c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V24c0-13.3 10.7-24 24-24zM144.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faSmilePlus = faFaceSmilePlus;
var faRadioTuner = {
  prefix: 'fad',
  iconName: 'radio-tuner',
  icon: [512, 512, ["radio-alt"], "f8d8", ["M64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zM384 320a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM64 352c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM96 192H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M511 17.2c3.7 12.7-3.6 26.1-16.3 29.8L218.5 128H64c-13.9 0-26.9 4.5-37.4 12c7.3-5.9 15.7-10.4 25.1-13.2L481.3 1C494-2.8 507.3 4.5 511 17.2zM64 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM320 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]]
};
var faRadioAlt = faRadioTuner;
var faFaceSwear = {
  prefix: 'fad',
  iconName: 'face-swear',
  icon: [640, 512, [], "e399", ["M64 256H576C576 114.6 461.4 0 320 0S64 114.6 64 256zm208.4-64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-10.9-3.6c.2 1.5 .3 2.9 .3 4.4zm128 32c-17.7 0-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8c0 17.7-14.3 32-32 32z", "M0 336c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm416 32c0-8.8-7.2-16-16-16l-16 0V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H320V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V448h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V384h16c8.8 0 16-7.2 16-16zm-64 16v32H320V384h32zm220.1-29.6c5.8-6.7 5-16.8-1.7-22.6s-16.8-5-22.6 1.7l-96 112c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7l96-112zM472 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336zM208 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 320c-8.8 0-16 7.2-16 16v1.5c-5.6 1.2-11.6 3.3-16.9 7c-7.5 5.3-12.7 13.3-14.5 23.5c-1.3 7.2-.6 14.4 2.5 20.9c3 6.4 7.8 10.9 12.4 14.1c8.1 5.5 18.7 8.7 26.4 11l1.5 .5c9.4 2.8 15.2 4.9 18.7 7.4c1.4 1 1.6 1.5 1.6 1.6l0 0c0 .1 .1 .2 .1 .6c0 .4 0 1.2-.2 2.3c-.5 3.1-1.5 3.7-2 4l0 0c-1.1 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c4.9 1.6 12.1 4 20.2 5.9v3c0 8.8 7.2 16 16 16s16-7.2 16-16v-.8c5.1-.8 10.4-2.4 15.3-5.4c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.1c-2.8-6.6-7.4-11.3-12.1-14.7c-8.5-6.2-19.6-9.5-27.6-11.9l-.7-.2c-9.6-2.9-15.5-4.8-19.2-7.3c-1-.7-1.4-1.1-1.5-1.3c0-.2-.1-.8 .1-1.8c.3-1.9 .9-2.4 1.5-2.9c1.1-.8 3.3-1.7 7.4-2.2c8.3-.9 18.9 .8 26.8 2.9c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.6V336c0-8.8-7.2-16-16-16zM96.1 375.4c0 0 0 0 0-.1c0 0 0 .1 0 .1s0 0 0 0z"]]
};
var faWaterArrowDown = {
  prefix: 'fad',
  iconName: 'water-arrow-down',
  icon: [576, 512, ["water-lower"], "f774", ["M306.5 293.9c-11.1-7.9-25.9-7.9-37 0C247 309.4 219.5 320 192 320c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 373.7 159 384 192 384c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 309.2 410.9 320 384 320c-27.5 0-55-10.6-77.5-26.1zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z", "M320 135.7l34.5-31.3c13.1-11.9 33.3-10.9 45.2 2.2s10.9 33.3-2.2 45.2l-88 80c-12.2 11.1-30.8 11.1-43.1 0l-88-80c-13.1-11.9-14-32.1-2.2-45.2s32.1-14 45.2-2.2L256 135.7 256 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 103.7z"]]
};
var faWaterLower = faWaterArrowDown;
var faScannerTouchscreen = {
  prefix: 'fad',
  iconName: 'scanner-touchscreen',
  icon: [512, 512, [], "f48a", ["M64 96C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm24 64H264c13.3 0 24 10.7 24 24V424c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z", "M152 0c-13.3 0-24 10.7-24 24V64h64V24c0-13.3-10.7-24-24-24H152zM312 0c-13.3 0-24 10.7-24 24V64h64V24c0-13.3-10.7-24-24-24H312zM224 16V64h32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM400 0c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zm48 24V264c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zM88 160c-13.3 0-24 10.7-24 24V424c0 13.3 10.7 24 24 24H264c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H88z"]]
};
var faCircle7 = {
  prefix: 'fad',
  iconName: 'circle-7',
  icon: [512, 512, [], "e0f4", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M160 152c0-13.3 10.7-24 24-24H328c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H184c-13.3 0-24-10.7-24-24z"]]
};
var faPlugCirclePlus = {
  prefix: 'fad',
  iconName: 'plug-circle-plus',
  icon: [576, 512, [], "e55f", ["M128 32v96H64V32C64 14.3 78.3 0 96 0s32 14.3 32 32zm192 0v96H256V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V412.8C87 398 32 333.4 32 256V224c-17.7 0-32-14.3-32-32z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]]
};
var faPersonSkiJumping = {
  prefix: 'fad',
  iconName: 'person-ski-jumping',
  icon: [512, 512, ["ski-jump"], "f7c7", ["M488 168c13.3 0 24 10.7 24 24v7.3c0 38.9-21.7 74.5-56.2 92.4L35 509.3C23.3 515.4 8.8 510.8 2.7 499s-1.5-26.3 10.3-32.3L433.7 249.1c18.6-9.6 30.3-28.8 30.3-49.7V192c0-13.3 10.7-24 24-24z", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H304.5c46 0 65.7 58.4 29 86.2L230.1 260.8l-6.4 7.5c-2.4 2.8-4.4 6.1-5.7 9.6L179.5 380.6l-55.3 28.6c-10.7-8.4-15.2-23-10.2-36.4l44-117.4c3.9-10.5 9.7-20.2 17-28.8L232.1 160H160c-17.7 0-32-14.3-32-32z"]]
};
var faSkiJump = faPersonSkiJumping;
var faPlaceOfWorship = {
  prefix: 'fad',
  iconName: 'place-of-worship',
  icon: [640, 512, [], "f67f", ["M160 272L28.3 331.3C11.1 339 0 356.2 0 375v89c0 26.5 21.5 48 48 48H160V272zM480 512H592c26.5 0 48-21.5 48-48V375c0-18.9-11.1-36-28.3-43.8L480 272V512z", "M224 201.6V109.3c0-8.5 3.4-16.6 9.4-22.6l75.3-75.3c6.2-6.2 16.4-6.2 22.6 0l75.3 75.3c6 6 9.4 14.1 9.4 22.6v92.3L456.7 226c14.5 8.7 23.3 24.3 23.3 41.2V512H384V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v96H160V267.2c0-16.9 8.8-32.5 23.3-41.2L224 201.6z"]]
};
var faWaterArrowUp = {
  prefix: 'fad',
  iconName: 'water-arrow-up',
  icon: [576, 512, ["water-rise"], "f775", ["M306.5 293.9c-11.1-7.9-25.9-7.9-37 0C247 309.4 219.5 320 192 320c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 373.7 159 384 192 384c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 309.2 410.9 320 384 320c-27.5 0-55-10.6-77.5-26.1zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z", "M320 104.3l34.5 31.3c13.1 11.9 33.3 10.9 45.2-2.2s10.9-33.3-2.2-45.2l-88-80c-12.2-11.1-30.8-11.1-43.1 0l-88 80c-13.1 11.9-14 32.1-2.2 45.2s32.1 14 45.2 2.2L256 104.3 256 208c0 17.7 14.3 32 32 32s32-14.3 32-32l0-103.7z"]]
};
var faWaterRise = faWaterArrowUp;
var faWaveformLines = {
  prefix: 'fad',
  iconName: 'waveform-lines',
  icon: [640, 512, ["waveform-path"], "f8f2", ["M320 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM128 192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32z", "M256 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V160zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm576 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]]
};
var faWaveformPath = faWaveformLines;
var faSplit = {
  prefix: 'fad',
  iconName: 'split',
  icon: [512, 512, [], "e254", ["M165.5 288c8.5 0 16.6 3.4 22.6 9.4l90.5 90.5c18 18 42.4 28.1 67.9 28.1H384v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H346.5c-8.5 0-16.6-3.4-22.6-9.4L237.3 256l-3.9 3.9c-18 18-42.4 28.1-67.9 28.1z", "M438.6 41.4c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6V96H346.5c-25.5 0-49.9 10.1-67.9 28.1l-90.5 90.5c-6 6-14.1 9.4-22.6 9.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H165.5c25.5 0 49.9-10.1 67.9-28.1l90.5-90.5c6-6 14.1-9.4 22.6-9.4H384v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64z"]]
};
var faFilmCanister = {
  prefix: 'fad',
  iconName: 'film-canister',
  icon: [576, 512, ["film-cannister"], "f8b7", ["M32 96H320V448H32V96z", "M96 32c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H96zM0 480c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM320 128H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32 14.3-32 32v32c0 17.7-14.3 32-32 32H320V128zm72 56v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V184c0-8.8-7.2-16-16-16H408c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V184c0-8.8-7.2-16-16-16H504zM392 344v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V344c0-8.8-7.2-16-16-16H408c-8.8 0-16 7.2-16 16z"]]
};
var faFilmCannister = faFilmCanister;
var faFolderXmark = {
  prefix: 'fad',
  iconName: 'folder-xmark',
  icon: [512, 512, ["folder-times"], "f65f", ["M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM175 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z", "M209 207c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faFolderTimes = faFolderXmark;
var faToiletPaperBlank = {
  prefix: 'fad',
  iconName: 'toilet-paper-blank',
  icon: [640, 512, ["toilet-paper-alt"], "f71f", ["M48 512c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2C63.6 385.7 64 277.3 64 192C64 86 107 0 160 0H512c-53 0-96 86-96 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48z", "M399.6 384H512c53 0 96-86 96-192S565 0 512 0s-96 86-96 192c0 81.9-7.3 145-16.4 192zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"]]
};
var faToiletPaperAlt = faToiletPaperBlank;
var faTabletScreen = {
  prefix: 'fad',
  iconName: 'tablet-screen',
  icon: [448, 512, ["tablet-android-alt"], "f3fc", ["M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 448c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM384 64H64V384H384V64z", "M64 64H384V384H64V64z"]]
};
var faTabletAndroidAlt = faTabletScreen;
var faHexagonVerticalNftSlanted = {
  prefix: 'fad',
  iconName: 'hexagon-vertical-nft-slanted',
  icon: [448, 512, [], "e506", ["M260.9 495.5c-22.3 12.9-49.7 12.9-72 0L36 407.2C13.7 394.4 0 370.6 0 344.9V168.3c0-25.7 13.7-49.5 36-62.4L188.9 17.7c22.3-12.9 49.7-12.9 72 0l152.9 88.3c22.3 12.9 36 36.6 36 62.4V344.9c0 25.7-13.7 49.5-36 62.4L260.9 495.5zm11.1-372c0-5.7-3.1-11-8.1-13.9L216.1 82.3c-2-1.2-4.3-2-6.8-2.2c-.5 0-1-.1-1.4-.1l-.1 0c-3.3 0-6.3 1-8.8 2.6c-1.5 1-2.9 2.2-4 3.7c-1.2 1.5-2.1 3.3-2.6 5.2c-.4 1.6-.6 3.1-.6 4.7V256.6v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-117l24.2 13.8c10.7 6.1 23.9-1.6 23.9-13.9zm16 27.4c0 5.7 3.1 11 8.1 13.9l23.8 13.6V352.6c0 8.8 7.2 16 16 16s16-7.2 16-16V196.6l16.2 9.3c7.7 4.4 17.4 1.7 21.8-6s1.7-17.4-6-21.8l-72-41.1c-10.7-6.1-23.9 1.6-23.9 13.9zM143.8 128.6c-8.8 0-16 7.2-16 16V270L95 171.5c-2.5-7.4-10-12-17.7-10.7s-13.4 7.9-13.4 15.8v160c0 8.8 7.2 16 16 16s16-7.2 16-16V275.2l32.8 98.5c2.5 7.4 10 12 17.7 10.7s13.4-7.9 13.4-15.8v-224c0-8.8-7.2-16-16-16z", "M263.9 109.6c5 2.8 8.1 8.2 8.1 13.9c0 12.3-13.3 20-23.9 13.9l-24.2-13.8v117h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v128c0 8.8-7.2 16-16 16s-16-7.2-16-16v-144V96.3c0-1.6 .2-3.2 .6-4.7c.5-1.9 1.4-3.7 2.6-5.2c1.1-1.5 2.5-2.8 4-3.7c2.5-1.7 5.6-2.6 8.8-2.6c0 0 .1 0 .1 0c.5 0 1 0 1.4 .1c2.5 .2 4.8 1 6.8 2.2l47.8 27.3zm32.1 55.2c-5-2.8-8.1-8.2-8.1-13.9c0-12.3 13.3-20 23.9-13.9l72 41.1c7.7 4.4 10.3 14.2 6 21.8s-14.2 10.3-21.8 6l-16.2-9.3V352.6c0 8.8-7.2 16-16 16s-16-7.2-16-16V178.4l-23.8-13.6zM159.8 144.6v224c0 7.8-5.7 14.5-13.4 15.8s-15.3-3.3-17.7-10.7L95.8 275.2v61.4c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.8 5.7-14.5 13.4-15.8s15.3 3.3 17.7 10.7L127.8 270V144.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faFolderMusic = {
  prefix: 'fad',
  iconName: 'folder-music',
  icon: [512, 512, [], "e18d", ["M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM352 192c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V283.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V224 192z", "M345.1 178.8c4.3 3 6.9 7.9 6.9 13.2v32V352c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V247.1l-96 36V384c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V272 240c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8z"]]
};
var faDisplayMedical = {
  prefix: 'fad',
  iconName: 'display-medical',
  icon: [576, 512, ["desktop-medical"], "e166", ["M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z", "M64 64H512V352H64V64zM346.7 448H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416h96l10.7 32zM256 128v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240h48c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H320V128c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"]]
};
var faDesktopMedical = faDisplayMedical;
var faShareAll = {
  prefix: 'fad',
  iconName: 'share-all',
  icon: [576, 512, [], "f367", ["M371 34.8c-11.5 5.1-19 16.6-19 29.2v43.3l85.4 76.9c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8L352 308.7V352c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z", "M243 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h32v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"]]
};
var faPeapod = {
  prefix: 'fad',
  iconName: 'peapod',
  icon: [512, 512, [], "e31c", ["M368 200a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-56 56a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM200 368A56 56 0 1 0 88 368a56 56 0 1 0 112 0z", "M464 0H416C186.2 0 0 186.2 0 416v48c0 26.5 21.5 48 48 48H96c229.8 0 416-186.2 416-416V48c0-26.5-21.5-48-48-48zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0A56 56 0 1 1 88 368zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]]
};
var faChessClock = {
  prefix: 'fad',
  iconName: 'chess-clock',
  icon: [640, 512, [], "f43d", ["M256 56c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v48h48V80h32c13.3 0 24-10.7 24-24zm128 56v16H544V112c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16zM523.3 244.7c-6.2-6.2-16.4-6.2-22.6 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6zM160 240v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16s-16 7.2-16 16z", "M0 192c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zM464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]]
};
var faAxe = {
  prefix: 'fad',
  iconName: 'axe',
  icon: [640, 512, [129683], "f6b2", ["M486.6 9.4l16 16c12.5 12.5 12.5 32.8 0 45.3L469.3 104 408 42.7 441.4 9.4c12.5-12.5 32.8-12.5 45.3 0zM266.7 184L328 245.3 70.6 502.6c-12.5 12.5-32.8 12.5-45.3 0l-16-16c-12.5-12.5-12.5-32.8 0-45.3L266.7 184zM576 160h32c17.7 0 32 14.3 32 32c0 123.7-100.3 224-224 224c-17.7 0-32-14.3-32-32V352h32c11 0 21.7-1.1 32-3.2c62.7-12.7 112.1-62.1 124.8-124.8c2.1-10.3 3.2-21 3.2-32V160z", "M329.4 9.4c12.5-12.5 32.8-12.5 45.3 0L525.3 160H576v32c0 88.4-71.6 160-160 160H384V301.3L233.4 150.6c-12.5-12.5-12.5-32.8 0-45.3l96-96z"]]
};
var faSquareD = {
  prefix: 'fad',
  iconName: 'square-d',
  icon: [448, 512, [], "e268", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h72c70.7 0 128 57.3 128 128s-57.3 128-128 128H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm24 208h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H176V336z", "M128 152c0-13.3 10.7-24 24-24h72c70.7 0 128 57.3 128 128s-57.3 128-128 128H152c-13.3 0-24-10.7-24-24V152zm48 24V336h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H176z"]]
};
var faGripVertical = {
  prefix: 'fad',
  iconName: 'grip-vertical',
  icon: [320, 512, [], "f58e", ["M232 480c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zm0-160c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zm0-288l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z", "M40 480l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zm0-160l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM40 32C17.9 32 0 49.9 0 72l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32z"]]
};
var faMobileSignalOut = {
  prefix: 'fad',
  iconName: 'mobile-signal-out',
  icon: [512, 512, [], "e1f0", ["M224 64H64V448H288V288h64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H224V64zM128 400c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16z", "M256 24c0-13.3 10.7-24 24-24C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24zm0 200a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM280 96c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faArrowTurnUp = {
  prefix: 'fad',
  iconName: 'arrow-turn-up',
  icon: [384, 512, ["level-up"], "f148", ["M160 109.3L160 416c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96-43 96-96l0-306.7-32-32-32 32z", "M41.4 182.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 77.3 86.6 182.6c-12.5 12.5-32.8 12.5-45.3 0z"]]
};
var faLevelUp = faArrowTurnUp;
var faU = {
  prefix: 'fad',
  iconName: 'u',
  icon: [384, 512, [117], "55", ["M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z", ""]]
};
var faArrowUpFromDottedLine = {
  prefix: 'fad',
  iconName: 'arrow-up-from-dotted-line',
  icon: [448, 512, [], "e09b", ["M64 448A32 32 0 1 1 0 448a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z", "M201.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 141.3V208 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V208 141.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z"]]
};
var faSquareRootVariable = {
  prefix: 'fad',
  iconName: 'square-root-variable',
  icon: [576, 512, ["square-root-alt"], "f698", ["M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1z", "M521.4 233.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L480 274.7l41.4-41.4z"]]
};
var faSquareRootAlt = faSquareRootVariable;
var faLightSwitchOn = {
  prefix: 'fad',
  iconName: 'light-switch-on',
  icon: [384, 512, [], "e019", ["M160 96c-35.3 0-64 28.7-64 64v96H288V160c0-35.3-28.7-64-64-64H160z", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm96 96V352c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM208 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
};
var faArrowDownArrowUp = {
  prefix: 'fad',
  iconName: 'arrow-down-arrow-up',
  icon: [576, 512, ["sort-alt"], "f883", ["M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L448 141.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V141.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z", "M137.4 470.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 370.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96z"]]
};
var faSortAlt = faArrowDownArrowUp;
var faRaindrops = {
  prefix: 'fad',
  iconName: 'raindrops',
  icon: [448, 512, [], "f75c", ["M148.5 39.2l-46.1 94.4c-4.2 8.6-6.4 18-6.4 27.6c0 34.7 28.1 62.8 62.8 62.8h2.4c34.7 0 62.8-28.1 62.8-62.8c0-9.6-2.2-19-6.4-27.6L171.5 39.2c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2zm-96 192L6.4 325.6c-4.2 8.6-6.4 18-6.4 27.6C0 387.9 28.1 416 62.8 416h2.4c34.7 0 62.8-28.1 62.8-62.8c0-9.6-2.2-19-6.4-27.6L75.5 231.2c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2z", "M210 294.2l97.8-159.4c2.6-4.2 7.2-6.8 12.2-6.8s9.6 2.6 12.2 6.8L430 294.2c11.8 19.2 18 41.3 18 63.8c0 67.4-54.6 122-122 122H314c-67.4 0-122-54.6-122-122c0-22.5 6.2-44.6 18-63.8z"]]
};
var faDash = {
  prefix: 'fad',
  iconName: 'dash',
  icon: [512, 512, ["minus-large"], "e404", ["M0 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", ""]]
};
var faMinusLarge = faDash;
var faClock = {
  prefix: 'fad',
  iconName: 'clock',
  icon: [512, 512, [128339, "clock-four"], "f017", ["M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z", "M256 96c-13.3 0-24 10.7-24 24V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24z"]]
};
var faClockFour = faClock;
var faInputNumeric = {
  prefix: 'fad',
  iconName: 'input-numeric',
  icon: [640, 512, [], "e1bd", ["M576 128V384H64V128H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z", "M294.6 214.4c5.7-8 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H318.8l34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6zM128 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H184V184c0-13.3-10.7-24-24-24H128z"]]
};
var faTruckTow = {
  prefix: 'fad',
  iconName: 'truck-tow',
  icon: [640, 512, [], "e2b8", ["M96 0h49.5c9.2 0 18 4 24.1 10.9L384 256H192L96 64V176c0 26.5-21.5 48-48 48s-48-21.5-48-48V160c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V32C64 14.3 78.3 0 96 0zm0 432a80 80 0 1 1 160 0A80 80 0 1 1 96 432zm400-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M416 96c-17.7 0-32 14.3-32 32V256H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H384h1.1c7.8-54.3 54.4-96 110.9-96c56.2 0 102.8 41.4 110.8 95.4c18.9-3.2 33.2-19.6 33.2-39.4V288 256 237.3c0-17-6.7-33.3-18.7-45.3L544 114.7c-12-12-28.3-18.7-45.3-18.7H416zM576 256H448V160h50.7L576 237.3V256z"]]
};
var faBackwardStep = {
  prefix: 'fad',
  iconName: 'backward-step',
  icon: [320, 512, ["step-backward"], "f048", ["M32 448c-17.7 0-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V416c0 17.7-14.3 32-32 32z", "M301.6 445c-11.2 5.3-24.5 3.6-34.1-4.4l-192-160L64 271V241l11.5-9.6 192-160c9.5-7.9 22.8-9.7 34.1-4.4S320 83.6 320 96V416c0 12.4-7.2 23.7-18.4 29z"]]
};
var faStepBackward = faBackwardStep;
var faPallet = {
  prefix: 'fad',
  iconName: 'pallet',
  icon: [640, 512, [], "f482", ["M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z", ""]]
};
var faCarBolt = {
  prefix: 'fad',
  iconName: 'car-bolt',
  icon: [512, 512, [], "e341", ["M96 400H0v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V400zm416 0H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V400z", "M74.8 96.3L39.6 196.8C16.4 206.4 0 229.3 0 256V400H512V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM96 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM318.3 119.2L281.9 192H336c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4L230.1 224H176c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9 .5s7.4 12.8 4.1 19.4z"]]
};
var faArrowsMaximize = {
  prefix: 'fad',
  iconName: 'arrows-maximize',
  icon: [512, 512, ["expand-arrows"], "f31d", ["M192 32c17.7 0 32 14.3 32 32s-14.3 32-32 32H141.3L256 210.7 210.7 256 96 141.3V192c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192zm64 269.3L301.3 256 416 370.7V320c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h50.7L256 301.3z", "M288 64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V192c0 17.7-14.3 32-32 32s-32-14.3-32-32V141.3L141.3 416H192c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32v50.7L370.7 96H320c-17.7 0-32-14.3-32-32z"]]
};
var faExpandArrows = faArrowsMaximize;
var faFaucet = {
  prefix: 'fad',
  iconName: 'faucet',
  icon: [512, 512, [], "e005", ["M192 96v12l32 4 32-4V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 52v76H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 256H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V148l-32-4-32 4z", "M96 160l128-16 128 16c17.7 0 32-14.3 32-32s-14.3-32-32-32L224 112 96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32z"]]
};
var faCloudSleet = {
  prefix: 'fad',
  iconName: 'cloud-sleet',
  icon: [512, 512, [], "f741", ["M94.1 385.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112zm272 0c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112zM192 352c-13.3 0-24 10.7-24 24v16H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V376c0-13.3-10.7-24-24-24zm256 0c-13.3 0-24 10.7-24 24v16H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H472V376c0-13.3-10.7-24-24-24z", "M0 224c0 53 43 96 96 96H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z"]]
};
var faLampStreet = {
  prefix: 'fad',
  iconName: 'lamp-street',
  icon: [512, 512, [], "e1c5", ["M176 64C114.1 64 64 114.1 64 176V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V176C0 78.8 78.8 0 176 0s176 78.8 176 176v18.7c-10.4-1.7-21.1-2.7-32-2.7s-21.6 .9-32 2.7V176c0-61.9-50.1-112-112-112zM384 384c0 35.3-28.7 64-64 64s-64-28.7-64-64H384z", "M320 192c-95.2 0-174.2 69.3-189.4 160.1C127.7 369.6 142.3 384 160 384H480c17.7 0 32.3-14.4 29.4-31.9C494.2 261.3 415.2 192 320 192z"]]
};
var faListRadio = {
  prefix: 'fad',
  iconName: 'list-radio',
  icon: [512, 512, [], "e1d0", ["M160 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm32 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M64 160A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm0 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faPenNibSlash = {
  prefix: 'fad',
  iconName: 'pen-nib-slash',
  icon: [640, 512, [], "e4a1", ["M306.4 337.4L404.9 415c-3.3 1.8-6.8 3.4-10.5 4.6L130.2 508.2c-11.3 3.8-23.9 1-32.4-7.3L251.3 347.3c6.3 3 13.3 4.7 20.7 4.7c13.5 0 25.7-5.6 34.4-14.6zm-160-126.1l85 67c-4.7 7.4-7.4 16.2-7.4 25.7c0 7.4 1.7 14.4 4.7 20.7L75.1 478.3c-8.3-8.6-11.2-21.1-7.3-32.4l78.6-234.5zm332.3 21.9l-28.3 94.4L208.1 137.8 342.8 97.3l9.2-2.8L481.4 224l-2.8 9.2zM432.4 18.3c21.9-21.9 57.3-21.9 79.2 0l46.1 46.1c21.9 21.9 21.9 57.3 0 79.2l-55.7 55.7L376.7 74.1l55.7-55.7z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faBaseballBatBall = {
  prefix: 'fad',
  iconName: 'baseball-bat-ball',
  icon: [512, 512, [], "f432", ["M150.1 294.1l67.9 67.9-27.6 17.4c-11.5 7.3-22.2 15.8-31.9 25.5l-51.9 51.9L55.3 405.4l51.9-51.9c9.6-9.6 18.2-20.3 25.5-31.9l17.4-27.6zM432 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6l-55.7 88.2 67.9 67.9 88.2-55.7c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zM49 399c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399z"]]
};
var faSquareUpLeft = {
  prefix: 'fad',
  iconName: 'square-up-left',
  icon: [448, 512, [], "e282", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 281.4V176c0-8.8 7.2-16 16-16H281.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L264 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C290 366 285.1 368 280 368s-10-2-13.7-5.7L200 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6z", "M128 176V313.4c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L200 296l66.3 66.3c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l36.7-36.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L264 232l33.4-33.4c4.2-4.2 6.6-10 6.6-16c0-12.5-10.1-22.6-22.6-22.6H144c-8.8 0-16 7.2-16 16z"]]
};
var faOverline = {
  prefix: 'fad',
  iconName: 'overline',
  icon: [448, 512, [], "f876", ["M400 304A176 176 0 1 1 48 304a176 176 0 1 1 352 0zM224 192a112 112 0 1 0 0 224 112 112 0 1 0 0-224z", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64z"]]
};
var faS = {
  prefix: 'fad',
  iconName: 's',
  icon: [320, 512, [115], "53", ["M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z", ""]]
};
var faTimeline = {
  prefix: 'fad',
  iconName: 'timeline',
  icon: [640, 512, [], "e29c", ["M512 176c11.4 0 22.2-2.4 32-6.7V224h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H352v54.7c-9.8-4.3-20.6-6.7-32-6.7s-22.2 2.4-32 6.7V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V169.3c9.8 4.3 20.6 6.7 32 6.7s22.2-2.4 32-6.7V224H480V169.3c9.8 4.3 20.6 6.7 32 6.7z", "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM512 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM296 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]]
};
var faKeyboard = {
  prefix: 'fad',
  iconName: 'keyboard',
  icon: [576, 512, [9000], "f11c", ["M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336zM272 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM368 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240zM464 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z", "M80 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zM64 336v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H176zM160 240v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM272 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H272zM256 240v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM368 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H368zM352 240v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM464 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H464zM448 240v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H464z"]]
};
var faArrowsFromDottedLine = {
  prefix: 'fad',
  iconName: 'arrows-from-dotted-line',
  icon: [448, 512, [], "e0a3", ["M64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z", "M201.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H256v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l64-64zM192 384V352c0-17.7 14.3-32 32-32s32 14.3 32 32v32h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32z"]]
};
var faUsbDrive = {
  prefix: 'fad',
  iconName: 'usb-drive',
  icon: [640, 512, [], "f8e9", ["M480 128H608c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H480V128zm56 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48z", "M0 160c0-35.3 28.7-64 64-64H448c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V160z"]]
};
var faBallot = {
  prefix: 'fad',
  iconName: 'ballot',
  icon: [448, 512, [], "f732", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112zm0 128c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zM80 352h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm112 32c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16-272H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM192 256c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16z", "M64 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112zm0 128c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zM80 352h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16z"]]
};
var faCaretDown = {
  prefix: 'fad',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", ["M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z", ""]]
};
var faLocationDotSlash = {
  prefix: 'fad',
  iconName: 'location-dot-slash',
  icon: [640, 512, ["map-marker-alt-slash"], "f605", ["M459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4l90.2 70.7C255 134.7 284.9 112 320 112c44.2 0 80 35.8 80 80c0 28.3-14.7 53.1-36.8 67.4L459 334.5zm-52.8 81.6L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0c16.2-20.2 39-49.6 62.5-83.1z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faMapMarkerAltSlash = faLocationDotSlash;
var faCards = {
  prefix: 'fad',
  iconName: 'cards',
  icon: [640, 512, [], "e3ed", ["M306.4 472.3l137-79.1c3.3-1.9 6.4-4.1 9.2-6.6c19.4-17.2 24.7-46.2 11.2-69.5L324.8 76.4C334.4 68.7 346.7 64 360 64H584c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H360c-25.3 0-46.6-16.7-53.6-39.7zM582 187.6c14-14.5 13.2-38.5-2.2-51.9c-14-11.7-34.5-9.5-46.9 3.2l-4.7 5.2-5-5.2c-12.5-12.7-33.2-15-46.7-3.2c-15.7 13.5-16.5 37.5-2.5 51.9l48.4 49.9c3 3.2 8.2 3.2 11.5 0L582 187.6z", "M27.8 118.8C1.2 134.2-7.9 168.2 7.5 194.9l167 289.3c15.4 26.6 49.4 35.8 76.1 20.4L443.4 393.2c26.6-15.4 35.8-49.4 20.4-76.1L296.8 27.8C281.4 1.2 247.3-7.9 220.7 7.5L27.8 118.8zm143.6 55.5c3-11.1 14.4-17.7 25.6-14.8l26.9 7.2 76.1 20.4c26 7 41.4 33.7 34.4 59.7s-33.7 41.4-59.7 34.4l-8.8-2.4c-.4-.1-.8-.2-1.1-.3l17.7 30.7 12.1-7c6.7-3.8 15.2-1.6 19 5.1s1.6 15.2-5.1 19l-48.2 27.8c-6.7 3.8-15.2 1.6-19-5.1s-1.6-15.2 5.1-19l12.1-7-17.7-30.7c-.1 .4-.2 .7-.3 1.1l-2.4 8.8c-7 26-33.7 41.4-59.7 34.4s-41.4-33.7-34.4-59.7l20.4-76.1 7.2-26.9z"]]
};
var faHouseChimneyMedical = {
  prefix: 'fad',
  iconName: 'house-chimney-medical',
  icon: [576, 512, ["clinic-medical"], "f7f2", ["M64.1 448L64 270.5l224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1H128.1c-35.3 0-64-28.6-64-64zM256 240v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H320V240c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9L416 101.5V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185.5l53.1 46.4c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V352H208c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"]]
};
var faClinicMedical = faHouseChimneyMedical;
var faBoxingGlove = {
  prefix: 'fad',
  iconName: 'boxing-glove',
  icon: [448, 512, [129354, "glove-boxing"], "f438", ["M163.2 400H32v48c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V400H220.8l28 18.7c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4L192 419.2l-39.1 26.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l28-18.7z", "M96 0C43 0 0 43 0 96V288c0 28.4 12.4 54 32 71.6V400H163.2l-28-18.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4L192 380.8l39.1-26.1c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2l-28 18.7h132c2.2-13.1 8.4-25.2 17.9-34.7l49.1-49.1c18-18 28.1-42.4 28.1-67.9V224c0-35.3-28.7-64-64-64H352c-26.5 0-48 21.5-48 48c0 22.3 15.3 41.2 36 46.5c8.6 2.2 13.7 10.9 11.5 19.5s-10.9 13.7-19.5 11.5c-34.5-8.9-60-40.2-60-77.5c0-5.5 .6-10.8 1.6-16H144c-26.8 0-45.7-6.7-58.2-14.3c-6.2-3.7-10.7-7.6-13.8-10.7c-1.5-1.5-2.7-2.9-3.6-4c-.4-.5-.8-1-1.1-1.4l-.4-.5-.1-.2-.1-.1 0 0 0 0c0 0 0 0 13.3-8.9l-13.3 8.9c-4.9-7.4-2.9-17.3 4.4-22.2c7.3-4.8 17-3 22 4.2l0 0 .1 .1c.2 .2 .6 .8 1.3 1.5c1.4 1.4 3.9 3.6 7.7 5.8c7.4 4.5 20.6 9.7 41.8 9.7H288c14.6-19.4 37.8-32 64-32h32V96c0-53-43-96-96-96H96z"]]
};
var faGloveBoxing = faBoxingGlove;
var faTemperatureThreeQuarters = {
  prefix: 'fad',
  iconName: 'temperature-three-quarters',
  icon: [320, 512, ["temperature-3", "thermometer-3", "thermometer-three-quarters"], "f2c8", ["M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M176 176c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V176z"]]
};
var faTemperature3 = faTemperatureThreeQuarters;
var faThermometer3 = faTemperatureThreeQuarters;
var faThermometerThreeQuarters = faTemperatureThreeQuarters;
var faBellSchool = {
  prefix: 'fad',
  iconName: 'bell-school',
  icon: [512, 512, [], "f5d5", ["M288 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM0 208a208 208 0 1 1 416 0A208 208 0 1 1 0 208z", "M208 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 256c55.9 0 106.6-22 144-57.9V464h40c18.6 0 34.7-10.6 42.7-26c-11.4-8.8-18.7-22.5-18.7-38c0-26.5 21.5-48 48-48s48 21.5 48 48c0 19.4-11.5 36.1-28 43.7c-11.9 39.5-48.6 68.3-92 68.3l-40 0H112c-26.5 0-48-21.5-48-48V358.1C101.4 394 152.1 416 208 416z"]]
};
var faMobileScreen = {
  prefix: 'fad',
  iconName: 'mobile-screen',
  icon: [384, 512, ["mobile-android-alt"], "f3cf", ["M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z", "M80 64H304V384H80V64z"]]
};
var faMobileAndroidAlt = faMobileScreen;
var faPlaneUp = {
  prefix: 'fad',
  iconName: 'plane-up',
  icon: [512, 512, [], "e22d", ["M192 160L14.2 278.5C5.3 284.4 0 294.4 0 305.1v56.7c0 10.9 10.7 18.6 21.1 15.2L192 320V160zm128 0V320l170.9 57c10.4 3.5 21.1-4.3 21.1-15.2V305.1c0-10.7-5.3-20.7-14.2-26.6L320 160z", "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7L320 400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400V93.7z"]]
};
var faFolderHeart = {
  prefix: 'fad',
  iconName: 'folder-heart',
  icon: [512, 512, [], "e189", ["M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM144 253.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z", "M205.3 192c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]]
};
var faCircleLocationArrow = {
  prefix: 'fad',
  iconName: 'circle-location-arrow',
  icon: [512, 512, ["location-circle"], "f602", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM358.2 182.7l-84 196c-3.5 8.1-11.4 13.3-20.2 13.3c-1.4 0-2.9-.1-4.4-.4C239.4 389.5 232 380.4 232 370V280H142c-10.4 0-19.5-7.4-21.5-17.6c-2.1-10.2 3.3-20.5 12.9-24.6l196-84c8.5-3.5 18-1.7 24.2 4.7c6.4 6.3 8.2 15.9 4.7 24.2z", "M274.2 378.7l84-196c3.6-8.3 1.7-17.9-4.7-24.2c-6.3-6.3-15.8-8.2-24.2-4.7l-196 84c-9.6 4.1-15 14.5-12.9 24.6c2.1 10.2 11.1 17.6 21.5 17.6h90v90c0 10.4 7.4 19.5 17.6 21.6c1.5 .3 2.9 .4 4.4 .4c8.8 0 16.7-5.2 20.2-13.3z"]]
};
var faLocationCircle = faCircleLocationArrow;
var faFaceHeadBandage = {
  prefix: 'fad',
  iconName: 'face-head-bandage',
  icon: [576, 512, [], "e37a", ["M544 256c0 141.4-114.6 256-256 256c-99.5 0-185.8-56.8-228.2-139.8c2.5-3.8 4.8-7.5 6.7-10.7c1.9-3.1 3.5-5.7 4.7-7.5c29.1-43.1 64.6-81.6 105.1-114c0 17.7 14.3 32 32 32s32-14.3 32-32c0-14.1-9.2-26.1-21.9-30.4c9-5.8 18.2-11.4 27.6-16.6c13.9-.7 27.9-1 41.9-1c83.4 0 163.9 12.3 239.8 35.1l15 4.5c.8 8 1.1 16.2 1.1 24.4zM210.5 67.1c-37.5 3-74.5 8.2-110.7 15.4C146.6 31.8 213.6 0 288 0c28 0 54.9 4.5 80.1 12.8C312.6 24 259.7 42.5 210.5 67.1zM373.2 397.5c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6C373.2 354.3 340.2 336 296 336c-16.4 0-31.4 2.5-44.8 6.8c-8.4 2.7-13.1 11.6-10.5 20.1s11.6 13.1 20.1 10.5c10.4-3.3 22.1-5.3 35.2-5.3c34.8 0 60.4 14.2 77.2 29.5zM368.4 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M476.2 82.4c-16.4-17.8-35.3-33.2-56.1-45.7c-41.3 5.1-81.2 14.4-119.5 27.4c60 .8 118.7 7.1 175.6 18.4zM506 121.8c-32.7-7.9-66.1-14-100.1-18.3C367.3 98.5 328 96 288 96c-23.1 0-46.1 .8-68.8 2.5c-51 3.7-100.9 11.6-149.3 23.2c-14.1 22.8-24.6 47.9-31 74.7c19.1-5.7 38.5-10.8 58.1-15.3c45.4-10.2 92.2-16.9 140-19.7c16.9-1 33.8-1.5 51-1.5c86.6 0 170.2 12.7 249 36.4c-6.4-26.8-17-51.9-31-74.7zM177 199.3c-43.4 5.8-85.7 14.9-126.6 27.1c-6.2 6.7-12.3 13.5-18.2 20.5c-.1 3-.2 6.1-.2 9.1c0 28 4.5 54.9 12.8 80.1c35.7-52.9 80.5-99.3 132.2-136.7zm41.6 10.3c-14.6 9.4-28.6 19.6-42.1 30.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-14.1-9.2-26.1-21.9-30.4zM368.4 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faSushiRoll = {
  prefix: 'fad',
  iconName: 'sushi-roll',
  icon: [448, 512, ["maki-roll", "makizushi"], "e48b", ["M308.2 198.4c-35.3-13.5-63.8-36.1-82-63.4c-16 3.8-36.4 10.5-56.9 20.8c-18.6 9.3-36.6 21.3-51.4 36.1c-15.1-5.4-27.7-11.8-36.9-19.1c20.4-23.3 45.9-40.4 70.3-52.7c20.1-10.1 40.2-17.3 57.5-21.9c-1.7-5.8-3-11.7-3.8-17.7c6.2-.3 12.5-.4 18.9-.4c7.4 0 14.7 .2 21.8 .6c9.3 42.5 53.3 85.3 122.8 90.8c-13.2 11.2-34.3 20.6-60.4 27z", "M448 368V144C448 82.1 347.7 32 224 32S0 82.1 0 144V368c0 61.9 100.3 112 224 112s224-50.1 224-112zM224 208c-88.4 0-160-28.7-160-64s71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64z"]]
};
var faMakiRoll = faSushiRoll;
var faMakizushi = faSushiRoll;
var faCarBump = {
  prefix: 'fad',
  iconName: 'car-bump',
  icon: [640, 512, [], "f5e0", ["M589.1 512H402.9c-9.9 0-17.4-8.9-14.1-18.2C400.6 460.4 432 416 496 416s95.4 44.4 107.2 77.8c3.3 9.3-4.2 18.2-14.1 18.2z", "M121.6 148.1l-7 63.6 249.6-66.9L326.4 93.2c-7.8-10.6-21.3-15.4-34.1-12L145.1 120.6c-12.7 3.4-22.1 14.3-23.5 27.4zM47.8 234.2L58 141.1c4.3-39.4 32.3-72 70.6-82.3L275.8 19.4c38.2-10.2 78.9 4 102.3 36l55.4 75.5c25.3 3 47.4 20.9 54.4 47L521 301.5l12.4 46.4c4.6 17.1-5.6 34.6-22.6 39.2l-30.9 8.3c-17.1 4.6-34.6-5.6-39.2-22.6l-12.4-46.4L150 400.9l12.4 46.4c4.6 17.1-5.6 34.6-22.6 39.2l-30.9 8.3c-17.1 4.6-34.6-5.6-39.2-22.6L57.3 425.8 24.2 302.1c-7-26.1 3.2-52.7 23.6-67.9zm108.3 65.7A32 32 0 1 0 94.3 316.5a32 32 0 1 0 61.8-16.6zm255.6-35.3a32 32 0 1 0 -16.6-61.8 32 32 0 1 0 16.6 61.8z"]]
};
var faPiggyBank = {
  prefix: 'fad',
  iconName: 'piggy-bank',
  icon: [576, 512, [], "f4d3", ["M400 96c0 11.3-2 22.2-5.6 32.3c-3.4-.2-6.9-.3-10.4-.3H256c-14 0-27.6 1.8-40.5 5.2c-4.8-11.4-7.5-24-7.5-37.2c0-53 43-96 96-96s96 43 96 96z", "M507 115.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H256v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24H68c-11 0-20 9-20 20s9 20 20 20H99.2C114 183 178.6 128 256 128H384c7.8 0 15.5 .6 23 1.6C424.6 109.1 450.8 96 480 96h11.5c10.4 0 18 9.8 15.5 19.9zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faRacquet = {
  prefix: 'fad',
  iconName: 'racquet',
  icon: [512, 512, [], "f45a", ["M65.4 369.4c12.5-12.5 32.8-12.5 45.3 0l32 32c12.5 12.5 12.5 32.8 0 45.3l-56 56c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l56-56z", "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3c40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-54.4 54.4-131.9 78.7-198.2 61.7c-29.4-7.5-62.9-5.5-84.3 16L148.3 409c-1.5-2.7-3.3-5.3-5.6-7.6l-32-32c-2.3-2.3-4.9-4.2-7.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84C129.8 250.9 128 236 128 221c0-54.2 23.4-110.5 66.9-154z"]]
};
var faCarMirrors = {
  prefix: 'fad',
  iconName: 'car-mirrors',
  icon: [576, 512, [], "e343", ["M197.4 96c-13.6 0-25.7 8.6-30.2 21.4L141.1 192H434.9l-26.1-74.6C404.3 104.6 392.2 96 378.6 96H197.4zM32 400v48c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H32zm512 0H448v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V400z", "M167.2 117.4c4.5-12.8 16.6-21.4 30.2-21.4H378.6c13.6 0 25.7 8.6 30.2 21.4L434.9 192H141.1l26.1-74.6zM32 224h8.6c-5.4 9.4-8.6 20.3-8.6 32V400H544V256c0-11.7-3.1-22.6-8.6-32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H491.5L469.2 96.3C455.7 57.8 419.4 32 378.6 32H197.4c-40.8 0-77.1 25.8-90.6 64.3L84.5 160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32zm64 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faIndustryWindows = {
  prefix: 'fad',
  iconName: 'industry-windows',
  icon: [576, 512, [127981, "industry-alt"], "f3b3", ["M32 64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V210.1v5.3 50L352 155.6v54.4 5.3 50L544 155.6V304 432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V352 304 64zM136 312c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H136zm128 0c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H264zm112 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H392c-8.8 0-16 7.2-16 16z", "M363.9 148.8c11.5-6.6 15.5-21.2 8.9-32.7s-21.2-15.5-32.7-8.9L160 210.1v55.3L363.9 148.8zm192 0c11.5-6.6 15.5-21.2 8.9-32.7s-21.2-15.5-32.7-8.9L352 210.1v55.3L555.9 148.8zM136 312c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H136zm128 0c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H264zm112 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H392c-8.8 0-16 7.2-16 16z"]]
};
var faIndustryAlt = faIndustryWindows;
var faBoltAuto = {
  prefix: 'fad',
  iconName: 'bolt-auto',
  icon: [576, 512, [], "e0b6", ["M317.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224C.9 240.7-2.6 254.8 2 267.3S18.7 288 32 288H143.5L66.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H240.5L317.4 44.6z", "M492.6 305.7C487.2 294.8 476.1 288 464 288s-23.2 6.8-28.6 17.7l-80 160c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-80-160zM480.2 424H447.8L464 391.6 480.2 424z"]]
};
var faBatteryHalf = {
  prefix: 'fad',
  iconName: 'battery-half',
  icon: [576, 512, ["battery-3"], "f242", ["M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z", "M96 192H288V320H96z"]]
};
var faBattery3 = faBatteryHalf;
var faFluxCapacitor = {
  prefix: 'fad',
  iconName: 'flux-capacitor',
  icon: [448, 512, [], "f8ba", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM172.1 226.7L208 262.6v11c-36.5 7.4-64 39.7-64 78.4c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4v-11l35.9-35.9c12.6 8.4 27.8 13.3 44.1 13.3c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0 16.3 4.9 31.5 13.3 44.1L224 233.4l-29.3-29.3c8.4-12.6 13.3-27.8 13.3-44.1c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c16.3 0 31.5-4.9 44.1-13.3z", "M171.3 180.7c3-6.3 4.7-13.3 4.7-20.7c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c7.4 0 14.4-1.7 20.7-4.7L208 262.6v44.1c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V262.6l59.3-59.3c6.3 3 13.3 4.7 20.7 4.7c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48c0 7.4 1.7 14.4 4.7 20.7L224 233.4l-52.7-52.7z"]]
};
var faMountainCity = {
  prefix: 'fad',
  iconName: 'mountain-city',
  icon: [640, 512, [], "e52e", ["M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16z", "M150.4 310.8L175 352l48-64h60.8L224 188.9 150.4 310.8zM224 128c12 0 23.1 6.3 29.4 16.7L442.9 458.9c6.5 10.8 6.7 24.3 .7 35.3s-17.6 17.8-30.1 17.8H34.5c-12.5 0-24-6.8-30.1-17.8s-5.8-24.5 .7-35.3L194.6 144.7C200.9 134.3 212 128 224 128z"]]
};
var faCoins = {
  prefix: 'fad',
  iconName: 'coins',
  icon: [512, 512, [], "f51e", ["M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6c-.4-.2-.7-.4-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM416 341.3V278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 29.6-38.6 55.5-96 69.3zm0-96V240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9c-14.6 7.4-32.2 13.6-52.2 18.4z", "M384 240c0 18-14.3 34.6-38.4 48c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-44.2 86-80 192-80s192 35.8 192 80zM192 352c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V336c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352zm148.1 70.1c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448s108.6-9.4 148.1-25.9z"]]
};
var faHoneyPot = {
  prefix: 'fad',
  iconName: 'honey-pot',
  icon: [448, 512, [127855], "e418", ["M128 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V32H128zM448 224H0c0 50.4 10.5 93 25.5 128h397c15-35 25.5-77.6 25.5-128z", "M64 32h64V136c0 13.3 10.7 24 24 24s24-10.7 24-24V32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32c38.9 29.2 64 75.7 64 128H0c0-52.3 25.1-98.8 64-128C46.3 96 32 81.7 32 64s14.3-32 32-32zM25.5 352h397c-26.3 61.4-66.4 99.8-87.8 117.1c-9.3 7.5-21.1 10.9-33.1 10.9H146.4c-12 0-23.7-3.3-33.1-10.9C91.9 451.8 51.8 413.4 25.5 352z"]]
};
var faOlive = {
  prefix: 'fad',
  iconName: 'olive',
  icon: [448, 512, [], "e316", ["M374.9 214.9c-18.2 18.2-57.5 8.4-87.8-21.9s-40.1-69.6-21.9-87.8s57.5-8.4 87.8 21.9s40.1 69.6 21.9 87.8z", "M160 480C71.6 480 0 408.4 0 320C0 128 181.9 32 280 32c56 0 112 56 112 56s56 56 56 112c0 98.1-96 280-288 280zM287.1 192.9c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8s-69.6-40.1-87.8-21.9s-8.4 57.5 21.9 87.8z"]]
};
var faKhanda = {
  prefix: 'fad',
  iconName: 'khanda',
  icon: [512, 512, [9772], "f66d", ["M266.2 3.7c-5.9-4.9-14.6-4.9-20.5 0l-48 40c-5.9 4.9-7.5 13.2-3.8 19.9l0 0 0 0 0 0 .1 .1 .3 .6c.3 .5 .7 1.3 1.2 2.3c1 2 2.6 5 4.4 8.6c3.6 7.4 8.5 17.7 13.3 29.4c10 24.1 18.8 51.5 18.8 71.3s-8.8 47.2-18.8 71.3c-4.8 11.7-9.7 22-13.3 29.4c-1.8 3.7-3.3 6.6-4.4 8.6c-.5 1-.9 1.8-1.2 2.3l-.3 .6-.1 .1 0 0 0 0 0 0c-3.6 6.7-2 15 3.8 19.9L240 343.5v19.1l16.5 11.4L272 363.3V343.5l42.2-35.2c5.9-4.9 7.5-13.2 3.8-19.9l0 0 0 0-.1-.1-.3-.6c-.3-.5-.7-1.3-1.2-2.3c-1-2-2.6-5-4.4-8.6c-3.6-7.4-8.5-17.7-13.3-29.4c-10-24.1-18.8-51.5-18.8-71.3s8.8-47.2 18.8-71.3c4.8-11.7 9.7-22 13.3-29.4c1.8-3.7 3.3-6.6 4.4-8.6c.5-1 .9-1.8 1.2-2.3l.3-.6 .1-.1 0 0 0 0 0 0 0 0c3.6-6.7 2-15-3.8-19.9l-48-40zM288 480c0-11.8-6.4-22.2-16-27.7V423.4l-15.5-10.6L240 424.1v28.1c-9.6 5.5-16 15.9-16 27.7c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M389.1 69.4c4.8-5.4 12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3l0 0 0 0 .1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1 0 0 0 0s0 0-10.2-12.3l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21l-55.7-38.3-56.8 39.1C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3l0 0 0 0-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0 0 0 0 0s0 0 7.2 14.3l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2 51.1 35.1 51.1-35.1 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5zM144 176c0-42 23.1-78.6 57.3-97.8c3.4 7.1 7.7 16.3 11.9 26.5c2.4 5.9 4.8 12.1 7 18.2c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1c-2.2 6.2-4.6 12.3-7 18.2c-4.2 10.2-8.5 19.4-11.9 26.5C167.1 254.6 144 218 144 176zm154.8-71.3c4.2-10.2 8.5-19.4 11.9-26.5C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c-3.4-7.1-7.7-16.3-11.9-26.5c-2.4-5.9-4.8-12.1-7-18.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1c2.2-6.2 4.6-12.3 7-18.2z"]]
};
var faFilterList = {
  prefix: 'fad',
  iconName: 'filter-list',
  icon: [512, 512, [], "e17c", ["M3.5 87.7C9.9 73.3 24.2 64 40 64H312c15.8 0 30.1 9.3 36.5 23.7s3.8 31.3-6.8 43L240 243.8V416c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V243.8L10.3 130.8C-.3 119-3 102.2 3.5 87.7z", "M416 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s14.3-32 32-32zM320 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-17.7 0-32-14.3-32-32z"]]
};
var faOutlet = {
  prefix: 'fad',
  iconName: 'outlet',
  icon: [448, 512, [], "e01c", ["M113.7 139.4C94.8 156.9 64 194.9 64 256s30.8 99 49.7 116.6c8.8 8.2 20.7 11.4 32.6 11.4H301.6c12 0 23.9-3.3 32.6-11.4C353.2 355 384 317.1 384 256s-30.8-99.1-49.7-116.6c-8.8-8.2-20.7-11.4-32.6-11.4H146.4c-12 0-23.9 3.3-32.6 11.4zM160 192c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm128 0c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm-64 96c13.3 0 24 10.7 24 24v16c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8V312c0-13.3 10.7-24 24-24z", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm0 224c0-61.1 30.8-99.1 49.7-116.6c8.8-8.2 20.7-11.4 32.6-11.4H301.6c12 0 23.9 3.3 32.6 11.4C353.2 156.9 384 194.9 384 256s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4H146.4c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256z"]]
};
var faSliders = {
  prefix: 'fad',
  iconName: 'sliders',
  icon: [512, 512, ["sliders-h"], "f1de", ["M0 416c0-17.7 14.3-32 32-32l54.7 0c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32L32 448c-17.7 0-32-14.3-32-32zm233.3 32c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32L480 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-246.7 0zM0 256c0-17.7 14.3-32 32-32l246.7 0c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32L32 288c-17.7 0-32-14.3-32-32zm425.3 32c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32l54.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-54.7 0zM32 64l86.7 0c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32L32 128C14.3 128 0 113.7 0 96S14.3 64 32 64zm233.3 64c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32L480 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-214.7 0z", "M128 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0A80 80 0 1 0 80 416a80 80 0 1 0 160 0zm80-160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-112a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]]
};
var faSlidersH = faSliders;
var faCauldron = {
  prefix: 'fad',
  iconName: 'cauldron',
  icon: [448, 512, [], "f6bf", ["M128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 128V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V160h64zM272 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z", "M35.1 224C16.5 257 0 297.1 0 334.4c0 37.4 11.9 69.4 32 95.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24V473c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39v15c0 13.3 10.7 24 24 24s24-10.7 24-24V429.9c20.1-26.1 32-58.1 32-95.5c0-37.3-16.5-77.4-35.1-110.4H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H368 224 160V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V160H80 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h3.1z"]]
};
var faPeople = {
  prefix: 'fad',
  iconName: 'people',
  icon: [640, 512, [], "e216", ["M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.3 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9z"]]
};
var faFolderTree = {
  prefix: 'fad',
  iconName: 'folder-tree',
  icon: [576, 512, [], "f802", ["M32 0C49.7 0 64 14.3 64 32V96H288v64H64V384H288v64H64c-35.3 0-64-28.7-64-64V128 32C0 14.3 14.3 0 32 0z", "M288 32V192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32zm0 288V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32z"]]
};
var faNetworkWired = {
  prefix: 'fad',
  iconName: 'network-wired',
  icon: [640, 512, [], "f6ff", ["M352 224H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512v32H448V288H192v32H128V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V192h64v32z", "M256 64H384v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 384H224v64H96V384zM80 320c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H80zM416 448V384H544v64H416zm-64-80v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H400c-26.5 0-48 21.5-48 48z"]]
};
var faCroissant = {
  prefix: 'fad',
  iconName: 'croissant',
  icon: [512, 512, [129360], "f7f6", ["M259.4 1.4c3.9 5.9 7 12.5 9.1 19.5l59.9 199.7c1.2 4.1 2 8.2 2.4 12.4L440.3 92.2c13.6-17.4 10.5-42.8-8.6-53.9C389.4 14 340.3 0 288 0c-9.7 0-19.2 .5-28.6 1.4zM233 330.8c-4.1-.4-8.3-1.2-12.4-2.4L20.9 268.5c-7-2.1-13.6-5.2-19.5-9.1C.5 268.8 0 278.3 0 288c0 52.3 14 101.4 38.4 143.7c11 19.1 36.4 22.2 53.9 8.6L233 330.8z", "M232.7 19l0 0 0 0c2 3 3.6 6.4 4.8 10c-1.2-3.6-2.8-6.9-4.8-10zm235.8 88.8c17.2 20.5 31.2 43.8 41.3 69c1.5 3.9 2.3 8 2.3 12.2v5.4c0 16.3-13.2 29.6-29.6 29.6c-1.6 0-3.3-.1-4.9-.4L390 209l75.6-97.1c1-1.3 2-2.6 2.9-4zM223.6 477.6c.3 1.6 .4 3.2 .4 4.9c0 16.3-13.2 29.6-29.6 29.6H189c-4.2 0-8.3-.7-12.2-2.3c-25.2-10.1-48.5-24.1-69-41.3c1.4-.9 2.7-1.9 4-2.9L209 390l14.6 87.6zM19 232.7l0 0 0 0C7.4 225 0 211.8 0 197.4c0-4.6 .7-9.2 2.3-13.5C33 99.7 99.7 33 183.9 2.3C188.2 .7 192.8 0 197.4 0c18.7 0 35.1 12.2 40.5 30.1l59.9 199.7c3.4 11.3 .3 23.5-8 31.8l-28.1 28.1c-8.3 8.3-20.5 11.4-31.8 8L30.1 237.8c-1.3-.4-2.6-.8-3.8-1.3c-2.6-1-5-2.3-7.3-3.8z"]]
};
var faMapPin = {
  prefix: 'fad',
  iconName: 'map-pin',
  icon: [320, 512, [128205], "f276", ["M128 284.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V284.4c-10.3 2.3-21 3.6-32 3.6s-21.7-1.2-32-3.6z", "M160 288A144 144 0 1 0 160 0a144 144 0 1 0 0 288zM96 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-53 43-96 96-96c8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64z"]]
};
var faHamsa = {
  prefix: 'fad',
  iconName: 'hamsa',
  icon: [512, 512, [], "f665", ["M80 288H34.6C15.5 288 0 303.5 0 322.6c0 8.6 3.2 16.9 9 23.3L95.4 441c41.1 45.2 99.4 71 160.6 71s119.4-25.8 160.6-71L503 345.9c5.8-6.4 9-14.7 9-23.3c0-19.1-15.5-34.6-34.6-34.6H432c-8.8 0-16-7.2-16-16V72c0-22.1-17.9-40-40-40s-40 17.9-40 40V204c0 11-9 20-20 20s-20-9-20-20V40c0-22.1-17.9-40-40-40s-40 17.9-40 40V204c0 11-9 20-20 20s-20-9-20-20V72c0-22.1-17.9-40-40-40s-40 17.9-40 40V272c0 8.8-7.2 16-16 16zm85.4 50.2C179.2 323.8 217.6 288 256 288s76.8 35.8 90.6 50.2c3.6 3.7 5.4 8.7 5.4 13.8s-1.8 10.1-5.4 13.8C332.8 380.2 294.4 416 256 416s-76.8-35.8-90.6-50.2c-3.6-3.7-5.4-8.7-5.4-13.8s1.8-10.1 5.4-13.8z", "M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faCentSign = {
  prefix: 'fad',
  iconName: 'cent-sign',
  icon: [384, 512, [], "e3f5", ["M224 0c-17.7 0-32 14.3-32 32V66.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7V32c0-17.7-14.3-32-32-32zM192 445.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-34.7c-10.4 1.7-21.1 2.7-32 2.7s-21.6-.9-32-2.7z", "M224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8C307.1 433.7 267.2 448 224 448C118 448 32 362 32 256S118 64 224 64c43.2 0 83.1 14.3 115.2 38.4c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128z"]]
};
var faSwordsLaser = {
  prefix: 'fad',
  iconName: 'swords-laser',
  icon: [640, 512, [], "e03d", ["M135 7c9.1-9.1 23.7-9.4 33.2-.7L384 203.7V313.1L134.3 40.2c-8.7-9.5-8.3-24.1 .7-33.2zm87.8 227l24.7-22.6 50.7 55.5L224 348.1V240c0-2.1-.4-4.1-1.1-5.9zM505.7 40.2l-115.3 126-46.7-42.7L471.8 6.3c9.5-8.7 24.1-8.3 33.2 .7s9.4 23.7 .7 33.2z", "M384 322.7c0 12.7 5.1 24.9 14.1 33.9l49 49 27.3-27.3 32-32L533.7 319 411.3 196.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V322.7zM545.9 504.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5l3.5-3.5L480 395.3 458.3 417l87.5 87.5zM617.7 469L512 363.3 491.3 384 597 489.7 617.7 469zm14.8-14.8c4.8-4.8 7.5-11.3 7.5-18.1s-2.7-13.3-7.5-18.1L545 330.3 523.3 352 629 457.7l3.5-3.5zM224 240c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-25.4 25.4-4.9-4.9c-12.5-12.3-32.6-12.2-45 .2c-12.5 12.5-12.5 32.8 0 45.3l4.7 4.7L7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l50.3 50.3c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5L209.9 388.7c9-9 14.1-21.2 14.1-33.9V240zM152 344a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]]
};
var faFlask = {
  prefix: 'fad',
  iconName: 'flask',
  icon: [448, 512, [], "f0c3", ["M160 0H288h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V196.8c0 11.8 3.3 23.5 9.5 33.5L437.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V196.8c0 23.7-6.6 46.9-19 67.1L64.8 439.8c-.5 .9-.8 1.8-.8 2.8c0 3 2.4 5.4 5.4 5.4H378.6c3 0 5.4-2.4 5.4-5.4c0-1-.3-2-.8-2.8L275 263.9c-12.4-20.2-19-43.4-19-67.1V64H192z", "M309.5 320h-171L64.8 439.8c-.5 .9-.8 1.8-.8 2.8c0 3 2.4 5.4 5.4 5.4H378.6c3 0 5.4-2.4 5.4-5.4c0-1-.3-2-.8-2.8L309.5 320z"]]
};
var faPersonPregnant = {
  prefix: 'fad',
  iconName: 'person-pregnant',
  icon: [384, 512, [], "e31e", ["M144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z", "M196.1 128.3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 264v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h-8-8v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V383c-13.8-3.6-24-16.1-24-31V296.9l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1h1.1 12.5H192c1.4 0 2.8 .1 4.1 .3z"]]
};
var faSquareU = {
  prefix: 'fad',
  iconName: 'square-u',
  icon: [448, 512, [], "e281", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 136V288c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M136 144c13.3 0 24 10.7 24 24V288c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24z"]]
};
var faWandSparkles = {
  prefix: 'fad',
  iconName: 'wand-sparkles',
  icon: [512, 512, [], "f72b", ["M208 0c-3.7 0-6.9 2.5-7.8 6.1l-6.8 27.3-27.3 6.8c-3.6 .9-6.1 4.1-6.1 7.8s2.5 6.9 6.1 7.8l27.3 6.8 6.8 27.3c.9 3.6 4.1 6.1 7.8 6.1s6.9-2.5 7.8-6.1l6.8-27.3 27.3-6.8c3.6-.9 6.1-4.1 6.1-7.8s-2.5-6.9-6.1-7.8l-27.3-6.8L215.8 6.1C214.9 2.5 211.7 0 208 0zM87.7 69.8c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.4-7.7 5.8L57.5 121.5 5.8 136.3c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8L87.7 69.8zm352 224c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.4-7.7 5.8l-14.8 51.7-51.7 14.8c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8-14.8-51.7z", "M497 7c-9-9-23.5-9.4-33-.9L189.3 251.9c-2.9 2.6-6.7 4.1-10.7 4.1H144c-8.8 0-16 7.2-16 16v27.6c0 4.6-1.9 8.9-5.3 11.9L11.1 411.3C4 417.7 0 426.7 0 436.2c0 8.8 3.5 17.3 9.7 23.5l42.6 42.6c6.2 6.2 14.7 9.8 23.5 9.8c9.5 0 18.5-4 24.8-11.1L372.3 197.3c3-3.4 7.4-5.3 11.9-5.3H400c8.8 0 16-7.2 16-16V154.6c0-3.9 1.5-7.7 4.1-10.7L505.9 48c8.5-9.5 8.1-24-.9-33l-8-8z"]]
};
var faRouter = {
  prefix: 'fad',
  iconName: 'router',
  icon: [576, 512, [], "f8da", ["M352 48c-58.8 0-112.5 21.8-153.4 57.9c-9.9 8.8-25.1 7.8-33.9-2.1s-7.8-25.1 2.1-33.9C216.2 26.4 281.1 0 352 0s135.8 26.4 185.1 69.9c9.9 8.8 10.9 23.9 2.1 33.9s-23.9 10.9-33.9 2.1C464.5 69.8 410.8 48 352 48zM64 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM276.5 186.7c-10.3 8.3-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C275.2 126 312 112 352 112s76.8 14 105.7 37.4c10.3 8.3 11.9 23.5 3.5 33.8s-23.5 11.9-33.8 3.5C406.9 170 380.6 160 352 160s-54.9 10-75.5 26.7z", "M376 248c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H376V248zM96 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faEllipsisVertical = {
  prefix: 'fad',
  iconName: 'ellipsis-vertical',
  icon: [128, 512, ["ellipsis-v"], "f142", ["M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256z", "M120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0zm0 320A56 56 0 1 0 8 416a56 56 0 1 0 112 0z"]]
};
var faEllipsisV = faEllipsisVertical;
var faSwordLaserAlt = {
  prefix: 'fad',
  iconName: 'sword-laser-alt',
  icon: [512, 512, [], "e03c", ["M505 7c9.1 9.1 9.4 23.7 .7 33.2L307.8 256.5c-1.2-.3-2.5-.5-3.8-.5H198.9L471.8 6.3c9.5-8.7 24.1-8.3 33.2 .7z", "M155.3 270.1c9-9 21.2-14.1 33.9-14.1H304c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L193 405.7l-27.3-27.3-32-32L106.3 319l49-49zM95 330.3L116.7 352 11 457.7l-3.5-3.5C2.7 449.3 0 442.8 0 436s2.7-13.3 7.5-18.1L95 330.3zM22.3 469L128 363.3 148.7 384 43 489.7 22.3 469zm32 32L160 395.3 181.7 417 94.1 504.5C89.3 509.3 82.8 512 76 512s-13.3-2.7-18.1-7.5L54.3 501z"]]
};
var faTicket = {
  prefix: 'fad',
  iconName: 'ticket',
  icon: [576, 512, [127903], "f145", ["M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 96l0 192H448V160H128zm-32 0c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z", "M448 160V352H128l0-192H448zM128 128c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H128z"]]
};
var faPowerOff = {
  prefix: 'fad',
  iconName: 'power-off',
  icon: [512, 512, [9211], "f011", ["M256 0c17.7 0 32 14.3 32 32V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32z", "M147.7 75.5c11.3 13.6 9.4 33.8-4.1 45.1C104.7 152.9 80 201.6 80 256c0 97.2 78.8 176 176 176s176-78.8 176-176c0-54.4-24.7-103.1-63.5-135.4c-13.6-11.3-15.4-31.5-4.1-45.1s31.5-15.4 45.1-4.1C462.2 115.4 496 181.8 496 256c0 132.5-107.5 240-240 240S16 388.6 16 256c0-74.2 33.7-140.6 86.6-184.6c13.6-11.3 33.8-9.4 45.1 4.1z"]]
};
var faCoin = {
  prefix: 'fad',
  iconName: 'coin',
  icon: [512, 512, [129689], "f85c", ["M0 208c0 79.5 114.6 144 256 144s256-64.5 256-144s-114.6-144-256-144S0 128.5 0 208zm64-8c0-20.5 10.5-36.7 22.6-48.2c12-11.4 27.7-20.1 44.4-26.8c33.6-13.4 77.8-21 125-21s91.4 7.6 125 21c16.7 6.7 32.4 15.4 44.4 26.8C437.5 163.3 448 179.5 448 200s-10.5 36.7-22.6 48.2c-12 11.4-27.7 20.1-44.4 26.8c-33.6 13.4-77.8 21-125 21s-91.4-7.6-125-21c-16.7-6.7-32.4-15.4-44.4-26.8C74.5 236.7 64 220.5 64 200zm192 64c88.4 0 160-28.7 160-64s-71.6-64-160-64s-160 28.7-160 64s71.6 64 160 64z", "M464 394.6c30.2-21 48-46.8 48-74.6l0-29.9c-13.2 15.6-29.7 29.3-48 40.9l0 63.7zM336 377.3l0 64.3c36.2-6 68.9-15.9 96-28.7l0-64.7c-28.4 13.1-60.9 23-96 29zM208 445.8c15.5 1.5 31.6 2.2 48 2.2s32.5-.8 48-2.2l0-64.1c-15.7 1.6-31.7 2.4-48 2.4s-32.3-.8-48-2.4l0 64.1zM80 348.3L80 413c27.1 12.8 59.8 22.7 96 28.7l0-64.3c-35.1-6-67.6-15.9-96-29zM48 331c-18.3-11.5-34.8-25.2-48-40.9L0 320c0 27.9 17.8 53.6 48 74.6L48 331zM64 200c0 20.5 10.5 36.7 22.6 48.2c12 11.4 27.7 20.1 44.4 26.8c33.6 13.4 77.8 21 125 21s91.4-7.6 125-21c16.7-6.7 32.4-15.4 44.4-26.8C437.5 236.7 448 220.5 448 200s-10.5-36.7-22.6-48.2c-12-11.4-27.7-20.1-44.4-26.8c-33.6-13.4-77.8-21-125-21s-91.4 7.6-125 21c-16.7 6.7-32.4 15.4-44.4 26.8C74.5 163.3 64 179.5 64 200zm192 64c-88.4 0-160-28.7-160-64s71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64z"]]
};
var faLaptopSlash = {
  prefix: 'fad',
  iconName: 'laptop-slash',
  icon: [640, 512, [], "e1c7", ["M365.5 384H19.2C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H487.4L365.5 384zM64 146.4V352h64V196.8L64 146.4zM522.2 384l94.6 74.2c14.3-13.9 23.2-33.4 23.2-55c0-10.6-8.6-19.2-19.2-19.2H522.2zM89.5 44.9L154.8 96H512V352h64V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faRightLong = {
  prefix: 'fad',
  iconName: 'right-long',
  icon: [512, 512, ["long-arrow-alt-right"], "f30b", ["M320 320l0-128 0 0 0 0L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0 0 0 128 0z", "M360.5 409.4c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22l0-72 0-128 0-72c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136z"]]
};
var faLongArrowAltRight = faRightLong;
var faCircleB = {
  prefix: 'fad',
  iconName: 'circle-b',
  icon: [512, 512, [], "e0fd", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C356.3 261.6 368 283.4 368 308c0 42-34 76-76 76H184c-13.3 0-24-10.7-24-24V256 152zm144 52c0-15.5-12.5-28-28-28H208v56h68c15.5 0 28-12.5 28-28zM208 336h84c15.5 0 28-12.5 28-28s-12.5-28-28-28H276 208v56z", "M184 128c-13.3 0-24 10.7-24 24V256 360c0 13.3 10.7 24 24 24H292c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3c8.7-12.4 13.8-27.4 13.8-43.7c0-42-34-76-76-76H184zm92 104H208V176h68c15.5 0 28 12.5 28 28s-12.5 28-28 28zm-68 48h68 16c15.5 0 28 12.5 28 28s-12.5 28-28 28H208V280z"]]
};
var faPersonDressSimple = {
  prefix: 'fad',
  iconName: 'person-dress-simple',
  icon: [256, 512, [], "e21c", ["M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64z", "M112.3 160c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384H64v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V384h21.6c21.3 0 36.6-20.3 30.8-40.8L205.3 206.4c-7.9-27.5-33-46.4-61.5-46.4H112.3z"]]
};
var faPipeCollar = {
  prefix: 'fad',
  iconName: 'pipe-collar',
  icon: [512, 512, [], "e437", ["M80 64A16 16 0 1 0 48 64a16 16 0 1 0 32 0zm0 384a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320z", "M18.7 18.7c25-25 65.5-25 90.5 0L126 35.4C164.1 12.9 208.5 0 256 0s91.9 12.9 130 35.4l16.7-16.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L476.6 126c22.5 38.1 35.4 82.6 35.4 130s-12.9 91.9-35.4 130l16.7 16.7c25 25 25 65.5 0 90.5s-65.5 25-90.5 0L386 476.6C347.9 499.1 303.5 512 256 512s-91.9-12.9-130-35.4l-16.7 16.7c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5L35.4 386C12.9 347.9 0 303.5 0 256s12.9-91.9 35.4-130L18.7 109.3c-25-25-25-65.5 0-90.5zM64 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM80 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
};
var faLightsHoliday = {
  prefix: 'fad',
  iconName: 'lights-holiday',
  icon: [640, 512, [], "f7b2", ["M139.9 227.4c-41.5-15.1-87.4 6.3-102.5 47.8C21 320.3 46.2 414.6 68.8 422.8s102.5-47.8 119-92.9c15.1-41.5-6.3-87.4-47.8-102.5zM320 256c-44.2 0-80 35.8-80 80c0 48 56 128 80 128s80-80 80-128c0-44.2-35.8-80-80-80zm282.6 19.2c-15.1-41.5-61-62.9-102.5-47.8s-62.9 61-47.8 102.5c16.4 45.1 96.4 101.1 119 92.9s47.8-102.5 31.4-147.6z", "M5.4 78.2c9.8-14.7 29.6-18.7 44.3-9l0 0 .4 .3c.5 .3 1.3 .8 2.5 1.5c2.4 1.4 6.3 3.6 11.7 6.3C75 82.7 91.6 90.1 114.1 97.6C159 112.6 227.6 128 320 128s161-15.4 205.9-30.4c22.5-7.5 39.1-14.9 49.8-20.3c5.4-2.7 9.3-4.9 11.7-6.3c1.2-.7 2.1-1.2 2.5-1.5l.4-.2 0 0 0 0c14.7-9.7 34.5-5.8 44.3 8.9c9.8 14.7 5.8 34.6-8.9 44.4L608 96c17.8 26.6 17.7 26.6 17.7 26.6l0 0-.1 0-.2 .1-.4 .3c-.3 .2-.7 .5-1.2 .8c-1 .6-2.4 1.5-4.2 2.5c-3.6 2.1-8.7 4.9-15.3 8.2c-13.3 6.6-32.7 15.2-58.2 23.7c-10.2 3.4-21.4 6.8-33.5 10l19.8 54.3c-10.7-.7-21.7 .8-32.3 4.7s-20.1 9.8-27.8 17.2l-22.8-62.7c-28.9 4.7-61.4 8.2-97.4 9.6v71.2c-9.8-4.3-20.6-6.7-32-6.7s-22.2 2.4-32 6.7V191.4c-36-1.3-68.5-4.8-97.4-9.6l-22.8 62.7c-7.7-7.4-17.1-13.3-27.8-17.2s-21.7-5.4-32.3-4.7l19.8-54.3c-12.1-3.2-23.3-6.6-33.5-10c-25.5-8.5-44.9-17.1-58.2-23.7c-6.6-3.3-11.7-6.1-15.3-8.2c-1.8-1-3.2-1.9-4.2-2.5c-.5-.3-.9-.6-1.2-.8l-.4-.3-.1-.1-.1 0 0 0c0 0 0 0 17.7-26.6L14.2 122.6C-.5 112.8-4.4 93 5.4 78.2z"]]
};
var faCitrus = {
  prefix: 'fad',
  iconName: 'citrus',
  icon: [512, 512, [], "e2f4", ["M304 128h80c19 0 36.8-5.5 51.7-15.1C473.2 155.3 496 211 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272S123.5 32 256 32c17.8 0 35.1 1.9 51.8 5.6C295.4 53.8 288 74 288 96v16c0 8.8 7.2 16 16 16z", "M384 128H304c-8.8 0-16-7.2-16-16V96c0-53 43-96 96-96h80c8.8 0 16 7.2 16 16V32c0 53-43 96-96 96z"]]
};
var faFlagUsa = {
  prefix: 'fad',
  iconName: 'flag-usa',
  icon: [448, 512, [], "f74d", ["M192 185.9V122.1c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9zm0-96V27c18.8 2.2 37.2 7.7 54.4 16.3c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9zM128.3 383.9L64 400V331.8l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4zm-.7-98.5L64 299.1V235.8l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3z", "M192 122.1V89.9 27c-19.6-2.3-39.6-1.1-59 3.8L64 48V32C64 14.3 49.7 0 32 0S0 14.3 0 32V64v56.8 32.7 63.3 32.7 63.3 32.7V416v64c0 17.7 14.3 32 32 32s32-14.3 32-32V400 331.8 299.1 235.8 224 203.1l63.5-13.6c21.3-4.6 43-5.7 64.5-3.6V122.1zM80 96a16 16 0 1 1 32 0A16 16 0 1 1 80 96zm64-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faLaptopFile = {
  prefix: 'fad',
  iconName: 'laptop-file',
  icon: [640, 512, [], "e51d", ["M64 64C64 28.7 92.7 0 128 0H448c35.3 0 64 28.7 64 64V96H448V64H128V288H320v96H76.8C34.4 384 0 349.6 0 307.2C0 296.6 8.6 288 19.2 288H64V64z", "M400 128H512v96c0 17.7 14.3 32 32 32h96V464c0 26.5-21.5 48-48 48H400c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48zm240 96H544V128l96 96z"]]
};
var faTty = {
  prefix: 'fad',
  iconName: 'tty',
  icon: [512, 512, ["teletype"], "f1e4", ["M15.1 200.6l23.1 40.7c7.5 13.2 23.3 19.3 37.8 14.6l81.1-26.6c13.1-4.3 22-16.6 22-30.4V144c49.6-18.1 104-18.1 153.6 0v54.8c0 13.8 8.9 26.1 22 30.4l81.1 26.6c14.5 4.7 30.3-1.4 37.8-14.6l23.1-40.7c9.2-16.2 8.4-36.5-4.5-50C450.6 106.8 367.3 48 256 48S61.4 106.8 19.6 150.6c-12.9 13.5-13.7 33.8-4.5 50z", "M48 320c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H80c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H48zm0 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H80c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H48zm80-80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H240zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H432zM416 432v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H432c-8.8 0-16 7.2-16 16zM144 416c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H144z"]]
};
var faTeletype = faTty;
var faChartTreeMap = {
  prefix: 'fad',
  iconName: 'chart-tree-map',
  icon: [512, 512, [], "e0ea", ["M304 192c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H304zM48 272c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48H48z", "M0 80C0 53.5 21.5 32 48 32H176c26.5 0 48 21.5 48 48V192c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zm256 0c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80zm48 272H464c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"]]
};
var faDiagramNext = {
  prefix: 'fad',
  iconName: 'diagram-next',
  icon: [512, 512, [], "e476", ["M379.3 337.9c14.4-14.4 17.1-33.7 11.3-49.9H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l57.4 0c-5.8 16.2-3.1 35.5 11.3 49.9l89.4 89.4c18.7 18.7 49.1 18.7 67.9 0l89.4-89.4z", "M448 224c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H232v64l-46.1 0c-21.4 0-32.1 25.9-17 41L239 399c9.4 9.4 24.6 9.4 33.9 0L343 329c15.1-15.1 4.4-41-17-41L280 288V224H448z"]]
};
var faPersonRifle = {
  prefix: 'fad',
  iconName: 'person-rifle',
  icon: [576, 512, [], "e54e", ["M336 211.9c-21-12.8-45.4-19.9-70.8-19.9H214.8c-48.1 0-92.6 25.4-117.1 66.8L21.6 387.7c-11.2 19-4.9 43.5 14.1 54.8s43.5 4.9 54.8-14.1L144 337.7V512H336V211.9zM240 160A80 80 0 1 0 240 0a80 80 0 1 0 0 160z", "M432 0h16c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16z"]]
};
var faClockFiveThirty = {
  prefix: 'fad',
  iconName: 'clock-five-thirty',
  icon: [512, 512, [], "e34a", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V335.3l20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23V392c0 13.3 10.7 24 24 24s24-10.7 24-24z", "M256 416c13.3 0 24-10.7 24-24V335.3l20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23V392c0 13.3 10.7 24 24 24z"]]
};
var faPipeValve = {
  prefix: 'fad',
  iconName: 'pipe-valve',
  icon: [512, 512, [], "e439", ["M256 32c17.7 0 32 14.3 32 32V76l-32 4-32-4V64c0-17.7 14.3-32 32-32zm0 80l32 4v76H448V448H64V192H224V116l32-4z", "M128 128l128-16 128 16c17.7 0 32-14.3 32-32s-14.3-32-32-32L256 80 128 64c-17.7 0-32 14.3-32 32s14.3 32 32 32zM32 160c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32zm480 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V192z"]]
};
var faArrowUpFromArc = {
  prefix: 'fad',
  iconName: 'arrow-up-from-arc',
  icon: [512, 512, [], "e4b4", ["M64 256c0 106 86 192 192 192s192-86 192-192c0-17.7 14.3-32 32-32s32 14.3 32 32c0 141.4-114.6 256-256 256S0 397.4 0 256c0-17.7 14.3-32 32-32s32 14.3 32 32z", "M121.4 166.6c-12.5-12.5-12.5-32.8 0-45.3l112-112c12.5-12.5 32.8-12.5 45.3 0l112 112c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3 288 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-210.7-57.4 57.4c-12.5 12.5-32.8 12.5-45.3 0z"]]
};
var faFaceSpiralEyes = {
  prefix: 'fad',
  iconName: 'face-spiral-eyes',
  icon: [512, 512, [], "e485", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56.9-137.1l14.8-9.9c14.3-9.6 32.7-10.7 48.1-3l15.4 7.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-15.4-7.7c-5.1-2.6-11.3-2.2-16 1l-14.8 9.9c-16.1 10.7-37.1 10.7-53.3 0l-12.5-8.3c-5.4-3.6-12.4-3.6-17.8 0l-12.5 8.3c-16.1 10.7-37.1 10.7-53.3 0l-14.8-9.9c-4.8-3.2-10.9-3.6-16-1l-15.4 7.7c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l15.4-7.7c15.4-7.7 33.8-6.6 48.1 3l14.8 9.9c5.4 3.6 12.4 3.6 17.8 0l12.5-8.3c16.1-10.7 37.1-10.7 53.3 0l12.5 8.3c5.4 3.6 12.4 3.6 17.8 0zm-147-263.3c.3 6.6-4.9 12.2-11.5 12.5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-5.5-53.8 41.1-108.1 101-110.5c6.6-.3 12.2 4.9 12.5 11.5zM357.6 292c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.9-2.8-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5c-6.6 .3-12.2-4.9-12.5-11.5s4.9-12.2 11.5-12.5z", "M154.4 124c6.6-.3 11.8-5.8 11.5-12.5s-5.8-11.8-12.5-11.5c-59.9 2.4-106.5 56.7-101 110.5c2.9 53.9 53.7 94.3 102.5 89.1c49.1-3 85.9-47.9 80.6-91.2c-3.3-43.5-44.7-74.4-82.9-69.3c-38.4 3.4-65.7 39.2-60.3 72.1c3.8 33 35.9 54.5 63.6 49.2c27.7-4.1 45.3-30.8 39.5-53.6c-2.4-11.5-9.5-20-17.9-24.8c-8-4.7-18.3-6.6-27.5-3.3c-8.9 2.8-14.9 9-17.8 16c-2.6 6.3-3.2 15 1.8 21.8c4.2 6.3 11.1 9.2 17.6 8.5c5.3-.6 15.1-5.3 14.1-16.4c-.2-2.7-1.3-5.1-3-6.9c.8 .3 1.7 .6 2.6 1.2c3.1 1.8 5.7 4.9 6.5 9.2l.1 .4 .1 .4c2.1 7.7-4.7 21.9-19.9 24l-.3 0-.3 .1c-14 2.8-33.3-9.1-35.5-28.6l0-.4-.1-.4c-3.1-18.3 13.2-42.4 38.9-44.5l.3 0 .3 0c24.7-3.5 53.8 17.7 56 47.5l0 .3 0 .3c3.7 28.8-22.1 62.5-58.4 64.5l-.3 0-.3 0c-35.4 4-74.2-26.5-76.2-66.7l0-.3 0-.3c-4.2-39.3 31.1-82.4 78.1-84.3zM357.6 292c-6.6 .3-11.8 5.8-11.5 12.5s5.8 11.8 12.5 11.5c59.9-2.4 106.5-56.7 101-110.5c-2.9-53.9-53.7-94.3-102.5-89.1c-49.1 3-85.9 47.9-80.6 91.2c3.3 43.5 44.7 74.4 82.9 69.3c38.4-3.4 65.7-39.2 60.3-72.1c-3.8-33-35.9-54.5-63.6-49.2c-27.7 4.1-45.3 30.8-39.5 53.6c2.4 11.5 9.6 20 17.9 24.8c8 4.7 18.3 6.6 27.5 3.3c8.9-2.8 14.9-9 17.8-16c2.6-6.3 3.2-15-1.8-21.8c-4.2-6.3-11.1-9.2-17.6-8.5c-5.3 .6-15.1 5.3-14.1 16.4c.2 2.7 1.3 5.1 3 6.9c-.8-.3-1.7-.6-2.6-1.2c-3.1-1.8-5.7-4.9-6.5-9.2l-.1-.4-.1-.4c-2.1-7.7 4.7-21.9 19.9-24l.3 0 .3-.1c14-2.8 33.3 9.1 35.5 28.6l0 .4 .1 .4c3.1 18.3-13.2 42.4-38.9 44.5l-.3 0-.3 0c-24.7 3.5-53.9-17.7-56-47.5l0-.3 0-.3c-3.7-28.8 22.1-62.5 58.4-64.5l.3 0 .3 0c35.4-4 74.2 26.5 76.2 66.7l0 .3 0 .3c4.2 39.3-31.1 82.4-78.1 84.3z"]]
};
var faCompressWide = {
  prefix: 'fad',
  iconName: 'compress-wide',
  icon: [512, 512, [], "f326", ["M352 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V96zM160 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32v96z", "M160 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V96zM352 416c0 17.7 14.3 32 32 32s32-14.3 32-32V352h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H384c-17.7 0-32 14.3-32 32v96z"]]
};
var faCirclePhoneHangup = {
  prefix: 'fad',
  iconName: 'circle-phone-hangup',
  icon: [512, 512, ["phone-circle-down"], "e11d", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM391.4 310c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4 .2-26.7-8.5L98.8 274.8c-4.8-7.8-3.4-17.5 3.4-23.8c84.9-78.6 222.6-78.6 307.5 0c6.8 6.3 8.2 16.1 3.4 23.8L391.4 310z", "M364.7 318.5c9.9 3.8 21.4 .2 26.7-8.5l21.7-35.2c4.8-7.8 3.4-17.5-3.4-23.8c-84.9-78.6-222.6-78.6-307.5 0c-6.8 6.3-8.2 16.1-3.4 23.8L120.6 310c5.3 8.6 16.8 12.3 26.7 8.5l46.2-17.6c8.7-3.3 14.1-11.6 13.1-20.3L203.7 254c33.8-10.8 70.8-10.8 104.6 0l-2.9 26.7c-.9 8.7 4.4 16.9 13.1 20.3l46.2 17.6z"]]
};
var faPhoneCircleDown = faCirclePhoneHangup;
var faGearComplexCode = {
  prefix: 'fad',
  iconName: 'gear-complex-code',
  icon: [512, 512, [], "e5eb", ["M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1 .6 266.1 0 256 0c-11.1 0-22.1 .7-32.8 2.1c-10.3 1.3-18 9.7-19.3 20l-2.9 23.1c-.8 6.4-5.4 11.6-11.5 13.7c-9.6 3.2-19 7.2-27.9 11.7c-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4c-16.6 13-31.5 28-44.4 44.7c-6.3 8.2-5.9 19.6 .5 27.8l14.2 18.3c4 5.1 4.4 12 1.5 17.8c-4.4 8.8-8.2 17.9-11.3 27.4c-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6 .6 21.1 1.9 31.4c1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4 .8 11.7 5.4 13.7 11.6c3.1 9.5 6.9 18.7 11.3 27.5c2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8c12.9 16.7 27.8 31.7 44.4 44.7c8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5c9 4.6 18.3 8.5 27.9 11.7c6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20c10.7 1.4 21.7 2.1 32.8 2.1c10.1 0 20.1-.6 29.9-1.7c10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8c10-3.2 19.7-7.2 29-11.8c5.8-2.9 12.7-2.4 17.8 1.5L385 457.9c8.2 6.4 19.6 6.8 27.8 .5c2.8-2.2 5.5-4.4 8.2-6.7L451.7 421c1.8-2.2 3.6-4.4 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18c4.8-9.4 9-19.3 12.3-29.5c2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4c.2-1.7 .4-3.5 .6-5.2V230.1c-.2-1.7-.4-3.5-.6-5.2c-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6c-3.4-10.2-7.5-20.1-12.3-29.5c-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7 .4-27.9c-1.8-2.2-3.6-4.4-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7c-8.2-6.4-19.6-5.9-27.8 .5L366.7 68.3c-5.1 4-12.1 4.4-17.8 1.5c-9.3-4.6-19-8.6-29-11.8c-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zM287.8 162.6l-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM187.3 227.3L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm160-22.6l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 256l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z", "M274.6 144.2c8.7 1.5 14.6 9.7 13.2 18.4l-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2zm-87.3 60.5c6.2 6.2 6.2 16.4 0 22.6L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0zm137.4 0c6.2-6.2 16.4-6.2 22.6 0l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 256l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]]
};
var faHouseMedicalCircleExclamation = {
  prefix: 'fad',
  iconName: 'house-medical-circle-exclamation',
  icon: [640, 512, [], "e512", ["M394.8 512C349.5 480.1 320 427.5 320 368c0-5.4 .2-10.7 .7-16H320v16c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h40.2c32.3-39.1 81.1-64 135.8-64c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H394.8z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faBadminton = {
  prefix: 'fad',
  iconName: 'badminton',
  icon: [576, 512, [], "e33a", ["M512 352c-26.5 0-48 21.5-48 48v32h96V400c0-26.5-21.5-48-48-48zm-50.3 96l-13 43.4c-2.5 8.5 2.3 17.4 10.7 19.9s17.4-2.3 19.9-10.7L495.1 448H461.7zm34.3 0v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448H496zm32.9 0l15.8 52.6c2.5 8.5 11.5 13.3 19.9 10.7s13.3-11.5 10.7-19.9l-13-43.4H528.9zM110.6 369.4c-12.5-12.5-32.8-12.5-45.3 0l-56 56c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l56-56c12.5-12.5 12.5-32.8 0-45.3l-32-32z", "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3c40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-54.4 54.4-131.9 78.7-198.2 61.7c-29.4-7.5-62.9-5.5-84.3 16L148.3 409c-1.5-2.7-3.3-5.3-5.6-7.6l-32-32c-2.3-2.3-4.9-4.2-7.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84C129.8 250.9 128 236 128 221c0-54.2 23.4-110.5 66.9-154z"]]
};
var faClosedCaptioning = {
  prefix: 'fad',
  iconName: 'closed-captioning',
  icon: [576, 512, [], "f20a", ["M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z", "M152 256c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48zm192 0c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"]]
};
var faPersonHiking = {
  prefix: 'fad',
  iconName: 'person-hiking',
  icon: [384, 512, ["hiking"], "f6ec", ["M136.5 125.8L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8zM360 160c13.3 0 24 10.7 24 24v55.7c-.1-17.6-14.4-31.7-32-31.7H336V184c0-13.3 10.7-24 24-24zM336 272h16c17.6 0 31.9-14.2 32-31.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272z", "M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H296.6c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1z"]]
};
var faHiking = faPersonHiking;
var faRightFromLine = {
  prefix: 'fad',
  iconName: 'right-from-line',
  icon: [448, 512, ["arrow-alt-from-left"], "f347", ["M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64z", "M436.7 228.7L313.9 105.9c-6.4-6.4-15-9.9-24-9.9c-18.7 0-33.9 15.2-33.9 33.9l0 62.1-128 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0 0 62.1c0 18.7 15.2 33.9 33.9 33.9c9 0 17.6-3.6 24-9.9L436.7 283.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3z"]]
};
var faArrowAltFromLeft = faRightFromLine;
var faVenusDouble = {
  prefix: 'fad',
  iconName: 'venus-double',
  icon: [640, 512, [9890], "f226", ["M344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1c-26.6-4.9-51.1-15.7-72-31.1zM192 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zm32 0c0-19.8-2.8-39-8-57.2C406.5 104.7 426.2 96 448 96c44.2 0 80 35.8 80 80s-35.8 80-80 80c-21.8 0-41.5-8.7-56-22.8c5.2-18.2 8-37.3 8-57.2z"]]
};
var faImages = {
  prefix: 'fad',
  iconName: 'images',
  icon: [576, 512, [], "f302", ["M96 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96zm280 32c-8 0-15.5 4-20 10.7l-56 84L282.7 201c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H472c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C391.5 132 384 128 376 128zM224 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm348 18.7C391.5 132 384 128 376 128s-15.5 4-20 10.7l-56 84L282.7 201c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H472c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144z"]]
};
var faCalculator = {
  prefix: 'fad',
  iconName: 'calculator',
  icon: [384, 512, [128425], "f1ec", ["M96 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]]
};
var faShuttlecock = {
  prefix: 'fad',
  iconName: 'shuttlecock',
  icon: [512, 512, [], "f45b", ["M192 464L48 320 29.8 338.2C10.7 357.3 0 383.2 0 410.2C0 466.4 45.6 512 101.8 512c27 0 52.9-10.7 72-29.8L192 464z", "M320 32c0 8.8-7.2 16-16 16c-24.4 0-46 15.8-53.4 39.1l-29.3 92.8c-1.3 4.1-4.2 7.6-8.1 9.5l-32.4 16.2c-3.1 1.5-5.6 4.1-7.2 7.2l-32.5 64.9c-3.1 6.2-1.9 13.6 3 18.5L163 315l71.9-71.9L281.1 96.8C284.3 86.8 293.5 80 304 80H408c13.3 0 24 10.7 24 24V208c0 10.5-6.8 19.7-16.8 22.9L268.8 277.1 197 349l18.9 18.9c4.9 4.9 12.3 6.1 18.5 3l64.9-32.5c3.1-1.5 5.6-4.1 7.2-7.2l16.2-32.4c1.9-3.9 5.4-6.8 9.5-8.1l92.8-29.3c23.3-7.4 39.1-29 39.1-53.4c0-8.8 7.2-16 16-16h8c13.3 0 24 10.7 24 24v51.7c0 12.4-7.2 23.7-18.4 29L250.1 411.2c-6.7 3.1-12.8 7.4-18 12.7L192 464 48 320l40.1-40.1c5.2-5.2 9.5-11.3 12.7-18L215.4 18.4C220.6 7.2 231.9 0 244.3 0H296c13.3 0 24 10.7 24 24v8z"]]
};
var faUserHair = {
  prefix: 'fad',
  iconName: 'user-hair',
  icon: [448, 512, [], "e45a", ["M176 112H120c-7.9 0-15.5-1.7-22.3-4.6C96.6 114.1 96 121 96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11-1.4-21.8-4-32H312c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112z", "M120 112h56c34.6 0 65-18.3 81.9-45.8C269.2 84.1 289.2 96 312 96h36C333.8 40.8 283.6 0 224 0C160.3 0 107.5 46.5 97.7 107.4c6.8 3 14.4 4.6 22.3 4.6zm41.3 208C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320H161.3z"]]
};
var faEyeEvil = {
  prefix: 'fad',
  iconName: 'eye-evil',
  icon: [640, 512, [], "f6db", ["M294.8 222c-3.9 9.4-6.8 20.8-6.8 34c0 31.5 16.5 52.7 23.8 60.6c2.1 2.3 5.1 3.4 8.2 3.4s6.1-1.1 8.2-3.4c7.3-7.9 23.8-29.2 23.8-60.6c0-13.2-2.9-24.6-6.8-34c-8.2 1.3-16.6 2-25.2 2s-17-.7-25.2-2z", "M224 122.6c9.8-4.1 20.1-7.6 30.9-10.4l42.7-97.6C301.5 5.8 310.3 0 320 0s18.5 5.8 22.4 14.7l42.7 97.6c10.7 2.8 21.1 6.3 30.9 10.4L525.6 76.1c8.7-3.7 18.7-1 24.4 6.5s5.5 17.9-.4 25.2l-57.3 70.8c7 9 12.8 18.6 17.3 28.6l114.9 28.7c9.1 2.3 15.5 10.5 15.5 19.9s-6.4 17.6-15.5 19.9L509.6 304.6c-4.5 10.1-10.3 19.7-17.3 28.6l57.3 70.8c5.9 7.3 6.1 17.7 .4 25.2s-15.7 10.2-24.4 6.5L416 389.4c-9.8 4.1-20.1 7.6-30.9 10.4l-42.7 97.6c-3.9 8.9-12.7 14.7-22.4 14.7s-18.5-5.8-22.4-14.7l-42.7-97.6c-10.7-2.8-21.1-6.3-30.9-10.4L114.4 435.9c-8.7 3.7-18.7 1-24.4-6.5s-5.5-17.9 .4-25.2l57.3-70.8c-7-9-12.8-18.6-17.3-28.6L15.5 275.9C6.4 273.6 0 265.4 0 256s6.4-17.6 15.5-19.9l114.9-28.7c4.5-10.1 10.3-19.6 17.3-28.6L90.4 107.9c-5.9-7.3-6.1-17.7-.4-25.2s15.7-10.2 24.4-6.5L224 122.6zM416 256c0-19.7-6-38.1-16.2-53.3C376.3 216.2 349.1 224 320 224s-56.3-7.8-79.8-21.3C230 217.9 224 236.3 224 256c0 53 43 96 96 96s96-43 96-96z"]]
};
var faPeoplePulling = {
  prefix: 'fad',
  iconName: 'people-pulling',
  icon: [576, 512, [], "e535", ["M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-58-260.8 102.4 42.6c-3.9-7.4-4.9-16.4-2-25l2.6-7.8c3.6-10.8 8.5-20.9 14.7-30.2L155.2 135.4c-11.7-4.9-24.2-7.4-36.9-7.4H64z", "M416 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM382.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L537 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L503 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM324.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L324.7 398z"]]
};
var faN = {
  prefix: 'fad',
  iconName: 'n',
  icon: [384, 512, [110], "4e", ["M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 50.5 8.4 38.5 21.1 33.9z", ""]]
};
var faGarage = {
  prefix: 'fad',
  iconName: 'garage',
  icon: [640, 512, [], "e009", ["M512 224v96H128V224H512zM128 352H512V512H128V352zm128 80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3z"]]
};
var faCableCar = {
  prefix: 'fad',
  iconName: 'cable-car',
  icon: [512, 512, [128673, 57551, "tram"], "f7da", ["M492.9 103.5c13-2.7 21.3-15.4 18.6-28.4s-15.4-21.3-28.4-18.6l-232 48-232 48c-13 2.7-21.3 15.4-18.6 28.4s15.4 21.3 28.4 18.6l203.1-42V200v24h48V200 147.5l212.9-44zM96 288c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352z", "M320 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 88a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 224c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H96zm0 64h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V304zm144-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H352c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]]
};
var faTram = faCableCar;
var faShovelSnow = {
  prefix: 'fad',
  iconName: 'shovel-snow',
  icon: [512, 512, [], "f7c3", ["M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-31.4 31.4c-15.1 15.1-35.6 23.6-57 23.6c-13.5 0-26.2-3.3-37.4-9.2l-83.5 83.5-33.9-33.9 83.5-83.5c-5.9-11.2-9.2-23.9-9.2-37.4c0-21.4 8.5-41.9 23.6-57L391 7zm17 50.9L393.5 72.4c-6.1 6.1-9.5 14.4-9.5 23c0 18 14.6 32.6 32.6 32.6c8.6 0 16.9-3.4 23-9.5L454.1 104 408 57.9zM203.3 267.3l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm64 64l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z", "M172.8 166.4c12.7-9.6 30.6-8.3 41.8 3l128 128c11.3 11.3 12.5 29.1 3 41.8l-120 160c-5.6 7.4-14.1 12.1-23.3 12.7s-18.3-2.7-24.9-9.3l-168-168C2.8 328.1-.6 319 .1 309.7s5.3-17.8 12.7-23.3l160-120zm30.5 100.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80zm64 64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80z"]]
};
var faCloudRain = {
  prefix: 'fad',
  iconName: 'cloud-rain',
  icon: [512, 512, [127783, 9926], "f73d", ["M54.2 436.6L89.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3zm160 0L249.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3zM409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L409.2 372z", "M0 224c0 53 43 96 96 96H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z"]]
};
var faFaceLying = {
  prefix: 'fad',
  iconName: 'face-lying',
  icon: [512, 512, [], "e37e", ["M494 350.5c-4.5 1-9.2 1.5-14 1.5H352c-8.8 0-16-7.2-16-16s7.2-16 16-16H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-8.8 0-16-7.2-16-16s7.2-16 16-16H480c11.2 0 21.7 2.9 30.9 7.9C498.8 101.8 389.3 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c108 0 200.4-66.9 238-161.5zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM188.8 393.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4C180.7 351.1 208.6 336 240 336c13.6 0 26.6 2.8 38.4 8c8.1 3.5 11.8 13 8.3 21.1s-13 11.8-21.1 8.3c-7.8-3.4-16.5-5.3-25.6-5.3c-20.9 0-39.5 10-51.2 25.6z", "M176.4 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faSprinkler = {
  prefix: 'fad',
  iconName: 'sprinkler',
  icon: [512, 512, [], "e035", ["M0 24a24 24 0 1 1 48 0A24 24 0 1 1 0 24zm24 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM88 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM512 232a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM488 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM424 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 136a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-88-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H123.8C108.4 256 96 268.4 96 283.8c0 7.8 3.3 15.2 9 20.5L192 384v96c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384l87-79.7c5.7-5.3 9-12.7 9-20.5c0-15.3-12.4-27.8-27.8-27.8H288V96z"]]
};
var faBuildingCircleXmark = {
  prefix: 'fad',
  iconName: 'building-circle-xmark',
  icon: [640, 512, [], "e4d4", ["M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faPersonSledding = {
  prefix: 'fad',
  iconName: 'person-sledding',
  icon: [512, 512, ["sledding"], "f7cb", ["M2.7 236.9c6.1-11.8 20.6-16.3 32.4-10.2L418.5 425.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 269.3C1.2 263.2-3.4 248.7 2.7 236.9z", "M400 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM361 196.3L301.3 256H336c26.5 0 48 21.5 48 48v80c0 7.6-2.7 14.7-7.2 20.2L320 374.6V320H214.7L171 297.3c-12.2-20.2-9.8-48.8 13.8-64.9L244 192H160c-17.7 0-32-14.3-32-32s14.3-32 32-32H332.7c35.6 0 53.5 43.1 28.3 68.3z"]]
};
var faSledding = faPersonSledding;
var faGameConsoleHandheld = {
  prefix: 'fad',
  iconName: 'game-console-handheld',
  icon: [384, 512, [], "f8bb", ["M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V64zM96 80V192c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM232 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 304v16H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H96v16c0 8.8 7.2 16 16 16s16-7.2 16-16V352h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H128V304c0-8.8-7.2-16-16-16s-16 7.2-16 16z", "M96 80c0-8.8 7.2-16 16-16H272c8.8 0 16 7.2 16 16V192c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V80z"]]
};
var faShip = {
  prefix: 'fad',
  iconName: 'ship',
  icon: [576, 512, [128674], "f21a", ["M269.5 421.9c11.1-7.9 25.9-7.9 37 0C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1z", "M224 0c-17.7 0-32 14.3-32 32V64H144c-26.5 0-48 21.5-48 48V240L51.6 254.8c-23.1 7.7-29.5 37.5-11.5 53.9l101 92.6c16.2 9.4 34.7 15.1 50.9 15.1c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c16.2 0 34.7-5.7 50.9-15.1l101-92.6c18-16.5 11.6-46.2-11.5-53.9L480 240V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32H224zm43.8 182.7L160 218.7V128H416v90.7L308.2 182.7c-13.1-4.4-27.3-4.4-40.5 0z"]]
};
var faClockSixThirty = {
  prefix: 'fad',
  iconName: 'clock-six-thirty',
  icon: [512, 512, [], "e353", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V256c0-13.3-10.7-24-24-24s-24 10.7-24 24V392c0 13.3 10.7 24 24 24s24-10.7 24-24z", "M256 416c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24s-24 10.7-24 24V392c0 13.3 10.7 24 24 24z"]]
};
var faBatterySlash = {
  prefix: 'fad',
  iconName: 'battery-slash',
  icon: [640, 512, [], "f377", ["M324.9 352H112c-8.8 0-16-7.2-16-16V176c0-1.4 .2-2.7 .5-4L45.4 131.7C36.9 144.4 32 159.6 32 176V336c0 44.2 35.8 80 80 80H406.2l-81.2-64zM496 352H481.4l61.9 48.5C563.1 386 576 362.5 576 336V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H154.8l81.7 64H496c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faTugrikSign = {
  prefix: 'fad',
  iconName: 'tugrik-sign',
  icon: [384, 512, [], "e2ba", ["M160 199v66L71.8 287c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8L160 199zm0 96v66L71.8 383c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8L160 295zm64 50V279L312.2 257c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8L224 345zm0-96V183L312.2 161c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8L224 249z", "M0 64C0 46.3 14.3 32 32 32H192 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H32C14.3 96 0 81.7 0 64z"]]
};
var faArrowsDownToLine = {
  prefix: 'fad',
  iconName: 'arrows-down-to-line',
  icon: [576, 512, [], "e4b8", ["M576 448c0-17.7-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32z", "M521.4 233.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L416 274.7 416 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 41.4-41.4zm-320 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L96 274.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 41.4-41.4z"]]
};
var faDownload = {
  prefix: 'fad',
  iconName: 'download',
  icon: [512, 512, [], "f019", ["M178.7 352H64c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H333.3l-54.6 54.6c-12.5 12.5-32.8 12.5-45.3 0L178.7 352zM408 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M256 0c17.7 0 32 14.3 32 32V306.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 306.7V32c0-17.7 14.3-32 32-32z"]]
};
var faShelves = {
  prefix: 'fad',
  iconName: 'shelves',
  icon: [640, 512, ["inventory"], "f480", ["M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V192 448v32c0 17.7 14.3 32 32 32s32-14.3 32-32H576c0 17.7 14.3 32 32 32s32-14.3 32-32V448 192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V160H64V32zm0 192H576V416H64V224z", "M384 0c-17.7 0-32 14.3-32 32V96c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384zM96 288v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm160 0v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32z"]]
};
var faInventory = faShelves;
var faCloudSnow = {
  prefix: 'fad',
  iconName: 'cloud-snow',
  icon: [512, 512, [127784], "f742", ["M88 376c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H40v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H88V376zm192 32c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24V472h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V408zm168-56c-13.3 0-24 10.7-24 24v16H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H472V376c0-13.3-10.7-24-24-24z", "M0 224c0 53 43 96 96 96H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z"]]
};
var faFaceGrin = {
  prefix: 'fad',
  iconName: 'face-grin',
  icon: [512, 512, [128512, "grin"], "f580", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faGrin = faFaceGrin;
var faDeleteLeft = {
  prefix: 'fad',
  iconName: 'delete-left',
  icon: [576, 512, [9003, "backspace"], "f55a", ["M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM433 175c9.4 9.4 9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0z", "M399 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47z"]]
};
var faBackspace = faDeleteLeft;
var faOven = {
  prefix: 'fad',
  iconName: 'oven',
  icon: [448, 512, [], "e01d", ["M448 160v32H0V160H448zM64 256H384V448H64V256zm32 48c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z", "M96 0H352c53 0 96 43 96 96v64H0V96C0 43 43 0 96 0zM80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM200 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM64 256l0 192H384V256H64zM0 192H64 384h64v64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256 192z"]]
};
var faCloudBinary = {
  prefix: 'fad',
  iconName: 'cloud-binary',
  icon: [640, 512, [], "e601", ["M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm16-280v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm88-16c0 8.8 7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm136-16c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H424zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V200zM176 320c0 8.8 7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm96 24v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V344c0-22.1-17.9-40-40-40H312c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8zm104-32c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16H416z", "M200 160c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H200zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V200zm112-40c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16H304zm80 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H424c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zM192 304c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16H192zm120 0c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V344c0-22.1-17.9-40-40-40H312zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8V344zm96-24c0 8.8 7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16z"]]
};
var faEyeDropper = {
  prefix: 'fad',
  iconName: 'eye-dropper',
  icon: [512, 512, ["eye-dropper-empty", "eyedropper"], "f1fb", ["M198.7 180L55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L332 313.3 286.7 268 143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L244 225.3 198.7 180z", "M240.1 130.8L341.6 29.2c39-39 102.2-39 141.1 0s39 102.2 0 141.1L381.2 271.9l9.4 9.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l9.4 9.4z"]]
};
var faEyeDropperEmpty = faEyeDropper;
var faEyedropper = faEyeDropper;
var faCommentCaptions = {
  prefix: 'fad',
  iconName: 'comment-captions',
  icon: [512, 512, [], "e146", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM120 208H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm224 0h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24s10.7-24 24-24zM120 288h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm128 0H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M96 232c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm224 0c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zM96 312c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24z"]]
};
var faCommentsQuestion = {
  prefix: 'fad',
  iconName: 'comments-question',
  icon: [640, 512, [], "e14e", ["M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM136.2 108.4c6.6-18.6 24.2-31.1 44-31.1h48.5c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20V179.5c0-7.2 3.8-13.8 10-17.3L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6H180.2c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1zM181.3 264a26.7 26.7 0 1 1 53.3 0 26.7 26.7 0 1 1 -53.3 0z", "M136.2 108.4l-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4h48.5c7 0 12.6 5.7 12.6 12.6c0 4.5-2.4 8.7-6.3 10.9L198 162.1c-6.2 3.6-10 10.2-10 17.3v11.2c0 11 9 20 20 20c10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6c0-29.1-23.6-52.6-52.6-52.6H180.2c-19.8 0-37.4 12.4-44 31.1zM234.7 264a26.7 26.7 0 1 0 -53.3 0 26.7 26.7 0 1 0 53.3 0zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 3.9 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1s-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.5-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5zm-32 0c0 50.1-24.8 95.3-64.5 127.4C391.2 271.3 416 226.1 416 176c0-5.2-.3-10.3-.8-15.4l0 0c.5 5.1 .8 10.2 .8 15.4z"]]
};
var faScribble = {
  prefix: 'fad',
  iconName: 'scribble',
  icon: [512, 512, [], "e23f", ["M170 23.3C186.5 8.3 208 0 230.3 0h1.1C280.3 0 320 39.7 320 88.6c0 23.5-9.3 46-25.9 62.6L103.2 342.1c-4.6 4.6-7.2 10.9-7.2 17.4C96 373 107 384 120.6 384c6.5 0 12.8-2.6 17.4-7.2L360.8 153.9c16.6-16.6 39.1-25.9 62.6-25.9c48.9 0 88.6 39.7 88.6 88.6c0 23.5-9.3 46-25.9 62.6l-88.2 88.2c-8.8 8.8-13.8 20.9-13.8 33.4c0 26 21.1 47.1 47 47.1c6.2 0 12.4-1.5 18-4.2l16.7-8.4c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L477.6 501c-14.5 7.2-30.4 11-46.6 11c-61.4 0-111-49.9-111-111.1c0-29.5 11.7-57.8 32.6-78.7l88.2-88.2c4.6-4.6 7.2-10.9 7.2-17.4c0-13.6-11-24.6-24.6-24.6c-6.5 0-12.8 2.6-17.4 7.2L183.2 422.1c-16.6 16.6-39.1 25.9-62.6 25.9C71.7 448 32 408.3 32 359.4c0-23.5 9.3-46 25.9-62.6L248.8 105.9c4.6-4.6 7.2-10.9 7.2-17.4C256 75 245 64 231.4 64h-1.1c-6.4 0-12.6 2.4-17.3 6.7L53.5 215.7c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2L170 23.3z", ""]]
};
var faRotateExclamation = {
  prefix: 'fad',
  iconName: 'rotate-exclamation',
  icon: [512, 512, [], "e23c", ["M432 117.4C391 65.4 327.4 32 256 32C158.4 32 75.5 94.4 44.8 181.3c-5.9 16.7 2.8 34.9 19.5 40.8s34.9-2.8 40.8-19.5C127.1 140.5 186.4 96 256 96c52.3 0 98.8 25.1 128 64H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h84.3c.5 0 1 0 1.5 0H464c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v37.4zm35.2 213.2c5.9-16.7-2.8-34.9-19.5-40.8s-34.9 2.8-40.8 19.5C384.9 371.5 325.6 416 256 416c-52.3 0-98.8-25.1-128-64h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32V432c0 17.7 14.3 32 32 32s32-14.3 32-32V394.6c41 52 104.6 85.4 176 85.4c97.6 0 180.5-62.4 211.2-149.3z", "M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faFileCircleCheck = {
  prefix: 'fad',
  iconName: 'file-circle-check',
  icon: [576, 512, [], "e5a0", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faGlass = {
  prefix: 'fad',
  iconName: 'glass',
  icon: [384, 512, [129371], "f804", ["M8.6 10.2C14.6 3.7 23.1 0 32 0H352c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1L355.1 437.7c-3 41.9-37.8 74.3-79.8 74.3H108.7c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64L92.7 433.1c.6 8.4 7.6 14.9 16 14.9H275.3c8.4 0 15.4-6.5 16-14.9L317.6 64H66.4z", "M313.1 128H70.9L92.7 433.1c.6 8.4 7.6 14.9 16 14.9H275.3c8.4 0 15.4-6.5 16-14.9L313.1 128z"]]
};
var faLoader = {
  prefix: 'fad',
  iconName: 'loader',
  icon: [512, 512, [], "e1d4", ["M346.5 120.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L437 120.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-45.3 45.3zM384 256c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H416c-17.7 0-32 14.3-32 32zM256 384c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416c0-17.7-14.3-32-32-32zm135.8-37.5c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L391.8 437c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-45.3-45.3zM75 437c12.5 12.5 32.8 12.5 45.3 0l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L75 391.8c-12.5 12.5-12.5 32.8 0 45.3z", "M256 0c-17.7 0-32 14.3-32 32V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32zM0 256c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l45.3 45.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L120.2 75z"]]
};
var faForward = {
  prefix: 'fad',
  iconName: 'forward',
  icon: [512, 512, [9193], "f04e", ["M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L256 271V241L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z", "M308.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160z"]]
};
var faUserPilot = {
  prefix: 'fad',
  iconName: 'user-pilot',
  icon: [448, 512, [], "e2c0", ["M101.7 154.2C98 166.1 96 178.8 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-13.2-2-25.9-5.7-37.8C308.2 168.3 267 176 224 176s-84.2-7.7-122.3-21.8z", "M230.1 .8l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6l-23.8 20.4c.1 1 .1 2 .1 3.1v21.2c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 147.7 80 137.6 80 126.9V105.7c0-1 0-2.1 .1-3.1L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40c4-1.1 8.2-1.1 12.2 0zM161.7 72.8c-4 7.9-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1 183.2 65.7c-7.9-4-17.5-.7-21.5 7.2zM142.1 354.6l72.3 54.2c5.7 4.3 13.5 4.3 19.2 0l72.3-54.2c2.2-1.7 4.9-2.6 7.7-2.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352c2.8 0 5.5 .9 7.7 2.6zM320 432c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"]]
};
var faMobile = {
  prefix: 'fad',
  iconName: 'mobile',
  icon: [384, 512, [128241, "mobile-android", "mobile-phone"], "f3ce", ["M368 384H16v64c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V384zM160 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V384H16V64z"]]
};
var faMobileAndroid = faMobile;
var faMobilePhone = faMobile;
var faCodePullRequestClosed = {
  prefix: 'fad',
  iconName: 'code-pull-request-closed',
  icon: [512, 512, [], "e3f9", ["M144 153.3c-9.8 4.3-20.6 6.7-32 6.7s-22.2-2.4-32-6.7V358.7c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7V153.3zM400 192c-17.7 0-32 14.3-32 32V358.7c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7V224c0-17.7-14.3-32-32-32z", "M329.4 9.4c12.5-12.5 32.8-12.5 45.3 0L400 34.7 425.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L445.3 80l25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L400 125.3l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L354.7 80 329.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zM136 80A24 24 0 1 0 88 80a24 24 0 1 0 48 0zM32 80a80 80 0 1 1 160 0A80 80 0 1 1 32 80zm80 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-104a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM400 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-104a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]]
};
var faFaceMeh = {
  prefix: 'fad',
  iconName: 'face-meh',
  icon: [512, 512, [128528, "meh"], "f11a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faMeh = faFaceMeh;
var faAlignCenter = {
  prefix: 'fad',
  iconName: 'align-center',
  icon: [448, 512, [], "f037", ["M128 352c-17.7 0-32-14.3-32-32s14.3-32 32-32H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H128zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H128z", "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"]]
};
var faBookSkull = {
  prefix: 'fad',
  iconName: 'book-skull',
  icon: [448, 512, ["book-dead"], "f6b7", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 256 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H256h96 64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zM320 112c0 20.9-12.6 39.5-32 51.2V176c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V163.2c-19.4-11.7-32-30.3-32-51.2c0-35.3 35.8-64 80-64s80 28.7 80 64zM208 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM134.3 209.3L240 254.6l105.7-45.3c8.1-3.5 17.5 .3 21 8.4s-.3 17.5-8.4 21L280.6 272l77.7 33.3c8.1 3.5 11.9 12.9 8.4 21s-12.9 11.9-21 8.4L240 289.4 134.3 334.7c-8.1 3.5-17.5-.3-21-8.4s.3-17.5 8.4-21L199.4 272l-77.7-33.3c-8.1-3.5-11.9-12.9-8.4-21s12.9-11.9 21-8.4z"]]
};
var faBookDead = faBookSkull;
var faIdCard = {
  prefix: 'fad',
  iconName: 'id-card',
  icon: [576, 512, [62147, "drivers-license"], "f2c2", ["M576 128H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128zM117.3 352H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7c0-29.5 23.9-53.3 53.3-53.3zM112 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM240 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 405.3c0 5.9 4.8 10.7 10.7 10.7H277.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H117.3C87.9 352 64 375.9 64 405.3z"]]
};
var faDriversLicense = faIdCard;
var faFaceDotted = {
  prefix: 'fad',
  iconName: 'face-dotted',
  icon: [512, 512, [129765], "e47f", ["M216 3.1C229 1.1 242.4 0 256 0s27 1.1 40 3.1c17.5 2.7 29.4 19.1 26.6 36.6s-19.1 29.4-36.6 26.6C276.3 64.8 266.3 64 256 64s-20.3 .8-30.1 2.3c-17.5 2.7-33.8-9.2-36.6-26.6S198.5 5.9 216 3.1zM150.2 55.9c10.4 14.3 7.2 34.3-7 44.7c-16.3 11.9-30.7 26.2-42.5 42.5c-10.4 14.3-30.4 17.4-44.7 7s-17.4-30.4-7-44.7c15.8-21.7 34.9-40.8 56.6-56.6c14.3-10.4 34.3-7.2 44.7 7zm211.6 0c10.4-14.3 30.4-17.4 44.7-7c21.7 15.8 40.8 34.9 56.6 56.6c10.4 14.3 7.2 34.3-7 44.7s-34.3 7.2-44.7-7c-11.9-16.3-26.2-30.7-42.5-42.5c-14.3-10.4-17.4-30.4-7-44.7zM472.3 189.3c17.5-2.7 33.8 9.2 36.6 26.6c2.1 13.1 3.1 26.4 3.1 40s-1.1 27-3.1 40c-2.7 17.5-19.1 29.4-36.6 26.6s-29.4-19.1-26.6-36.6c1.5-9.8 2.3-19.8 2.3-30.1s-.8-20.3-2.3-30.1c-2.7-17.5 9.2-33.8 26.6-36.6zm-432.6 0c17.5 2.7 29.4 19.1 26.6 36.6C64.8 235.7 64 245.7 64 256s.8 20.3 2.3 30.1c2.7 17.5-9.2 33.8-26.6 36.6S5.9 313.5 3.1 296C1.1 283 0 269.6 0 256s1.1-27 3.1-40c2.7-17.5 19.1-29.4 36.6-26.6zM55.9 361.8c14.3-10.4 34.3-7.2 44.7 7c11.9 16.3 26.2 30.7 42.5 42.5c14.3 10.4 17.4 30.4 7 44.7s-30.4 17.4-44.7 7c-21.7-15.8-40.8-34.9-56.6-56.6c-10.4-14.3-7.2-34.3 7-44.7zm400.1 0c14.3 10.4 17.4 30.4 7 44.7c-15.8 21.7-34.9 40.8-56.6 56.6c-14.3 10.4-34.3 7.2-44.7-7s-7.2-34.3 7-44.7c16.3-11.9 30.7-26.2 42.5-42.5c10.4-14.3 30.4-17.4 44.7-7zM189.3 472.3c2.7-17.5 19.1-29.4 36.6-26.6c9.8 1.5 19.8 2.3 30.1 2.3s20.3-.8 30.1-2.3c17.5-2.7 33.8 9.2 36.6 26.6s-9.2 33.8-26.6 36.6c-13.1 2.1-26.4 3.1-40 3.1s-27-1.1-40-3.1c-17.5-2.7-29.4-19.1-26.6-36.6z", "M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]]
};
var faFaceWorried = {
  prefix: 'fad',
  iconName: 'face-worried',
  icon: [512, 512, [], "e3a3", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-73.6-97.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z", "M192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-15.6 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 160.9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]]
};
var faOutdent = {
  prefix: 'fad',
  iconName: 'outdent',
  icon: [448, 512, ["dedent"], "f03b", ["M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM224 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zM192 320c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z", "M.2 243.4c-8.2 6.4-8.2 18.9 0 25.3l101.9 79.3c10.5 8.2 25.8 .7 25.8-12.6V176.7c0-13.3-15.3-20.8-25.8-12.6L.2 243.4z"]]
};
var faDedent = faOutdent;
var faHeartCircleExclamation = {
  prefix: 'fad',
  iconName: 'heart-circle-exclamation',
  icon: [576, 512, [], "e4fe", ["M228.3 469.1L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 6.6-.4 13.2-1.3 19.6C487 198.7 460.3 192 432 192c-97.2 0-176 78.8-176 176c0 36.6 11.2 70.6 30.3 98.7l-2.6 2.4c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faHouse = {
  prefix: 'fad',
  iconName: 'house',
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", ["M64 270.5L64.1 472c0 22.1 17.9 40 40 40H184c22.1 0 40-17.9 40-40V383.7c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V472c0 22.1 17.9 40 40 40h80.5c22.1 0 40-18 40-40.1l-.4-201.3L288 74.5 64 270.5z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z"]]
};
var faHome = faHouse;
var faHomeAlt = faHouse;
var faHomeLgAlt = faHouse;
var faVectorCircle = {
  prefix: 'fad',
  iconName: 'vector-circle',
  icon: [512, 512, [], "e2c6", ["M41.3 192C62.8 119.8 119.8 62.8 192 41.3V96c0 4.3 .9 8.5 2.4 12.3c-38.9 16.2-70 47.3-86.2 86.2c-3.8-1.6-7.9-2.4-12.3-2.4H41.3zm0 128H96c4.3 0 8.5-.9 12.3-2.4c16.2 38.9 47.3 70 86.2 86.2c-1.6 3.8-2.4 7.9-2.4 12.3v54.7C119.8 449.2 62.8 392.2 41.3 320zm429.4 0C449.2 392.2 392.2 449.2 320 470.7V416c0-4.3-.9-8.5-2.4-12.3c38.9-16.2 70-47.3 86.2-86.2c3.8 1.6 7.9 2.4 12.3 2.4h54.7zm0-128H416c-4.3 0-8.5 .9-12.3 2.4c-16.2-38.9-47.3-70-86.2-86.2c1.6-3.8 2.4-7.9 2.4-12.3V41.3C392.2 62.8 449.2 119.8 470.7 192z", "M240 80h32V48H240V80zM192 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V32zM48 272H80V240H48v32zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224zM240 432v32h32V432H240zm-16-48h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zM432 272h32V240H432v32zm-48-48c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V224z"]]
};
var faCarCircleBolt = {
  prefix: 'fad',
  iconName: 'car-circle-bolt',
  icon: [640, 512, [], "e342", ["M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256V400v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V400H322.9c-1.9-10.4-2.9-21.1-2.9-32c0-88.8 65.8-162.3 151.3-174.3L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM96 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm194.5-66.2c2.8-5 1.7-11.1-2.6-14.9s-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H516.4l30.1-54.2z"]]
};
var faCalendarWeek = {
  prefix: 'fad',
  iconName: 'calendar-week',
  icon: [448, 512, [], "f784", ["M448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM80 256H368c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16z", "M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v80H0V112C0 85.5 21.5 64 48 64H96V32z"]]
};
var faFlyingDisc = {
  prefix: 'fad',
  iconName: 'flying-disc',
  icon: [448, 512, [], "e3a9", ["M313 77.9c30.7 30.7-4.1 115.4-77.9 189.2S76.7 375.8 46 345s4.1-115.4 77.9-189.2S282.3 47.2 313 77.9z", "M424.3 55.7c55.3 55.3 10.5 189.8-100.2 300.5S79 511.6 23.7 456.3C-1.5 431.1-5.9 389.6 7.1 341.4c3.2 9.5 8.4 18.5 16.2 26.3c15.6 15.6 36 20.7 55 20.5c18.9-.1 38.8-5.3 58.2-13.3c39-16.1 82-46 121.2-85.1s69-82.2 85.1-121.2c8-19.4 13.2-39.4 13.3-58.2c.1-19-5-39.5-20.5-55c-7.8-7.8-16.8-13-26.3-16.2c48.2-13 89.8-8.6 114.9 16.6z"]]
};
var faLaptopMedical = {
  prefix: 'fad',
  iconName: 'laptop-medical',
  icon: [640, 512, [], "f812", ["M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z", "M512 96H128V352H512V96zM288 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V256H240c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16l48 0V144z"]]
};
var faSquareDownRight = {
  prefix: 'fad',
  iconName: 'square-down-right',
  icon: [448, 512, [], "e26c", ["M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384zM320 198.6V336c0 8.8-7.2 16-16 16H166.6c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L184 280l-66.3-66.3C114 210 112 205.1 112 200s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6z", "M320 336V198.6c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6L248 216l-66.3-66.3C178 146 173.1 144 168 144s-10 2-13.7 5.7l-36.7 36.7C114 190 112 194.9 112 200s2 10 5.7 13.7L184 280l-33.4 33.4c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6H304c8.8 0 16-7.2 16-16z"]]
};
var faB = {
  prefix: 'fad',
  iconName: 'b',
  icon: [320, 512, [98], "42", ["M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H192c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128H64zm96 192H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288h96 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z", ""]]
};
var faSeatAirline = {
  prefix: 'fad',
  iconName: 'seat-airline',
  icon: [448, 512, [], "e244", ["M216 416v48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H264V416H216zM108 256H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H80.5L108 256z", "M32 0C49.7 0 64 14.3 64 32V143.6c0 6.5 1.3 12.9 3.9 18.9L121.7 288H416c12.1 0 23.2 6.8 28.6 17.7s4.3 23.8-3 33.5l-43.2 57.6C389.3 408.9 375.1 416 360 416H170.2c-38.4 0-73.1-22.9-88.2-58.2L9.1 187.7c-6-13.9-9.1-29-9.1-44.1V32C0 14.3 14.3 0 32 0z"]]
};
var faMoonOverSun = {
  prefix: 'fad',
  iconName: 'moon-over-sun',
  icon: [512, 512, ["eclipse-alt"], "f74a", ["M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zM256 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288z", "M257 142c-63.4 0-115 50.9-115 114s51.6 114 115 114c31.1 0 59.4-12.3 80.1-32.2c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.2 .7-8.5 1.1-13 1.1c-41.8 0-75.4-33.5-75.4-74.5c0-27.7 15.3-52 38.3-64.8c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.2-.3-6.5-.4-9.7-.4z"]]
};
var faEclipseAlt = faMoonOverSun;
var faPipe = {
  prefix: 'fad',
  iconName: 'pipe',
  icon: [64, 512, [], "7c", ["M32 0C49.7 0 64 14.3 64 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32C0 14.3 14.3 0 32 0z", ""]]
};
var faFileMedical = {
  prefix: 'fad',
  iconName: 'file-medical',
  icon: [384, 512, [], "f477", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"]]
};
var faPotato = {
  prefix: 'fad',
  iconName: 'potato',
  icon: [512, 512, [129364], "e440", ["M512 144c0 41.5-17.6 78.9-45.7 105.2c-25.8 24.2-46.1 57.9-55.2 92.1c-12.9 48.3-49 84.3-93.1 99.2c-32.3 10.9-64.4 26.9-92.5 46.2C202.4 502.7 174.3 512 144 512C64.5 512 0 447.5 0 368c0-39.8 16.2-75.9 42.3-102C69.8 238.6 95 205 113.6 170.9c13.2-24.1 33.1-44 57.3-57.3C205 95 238.6 69.8 266 42.3C292.1 16.2 328.2 0 368 0c79.5 0 144 64.5 144 144z", "M360 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM168 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-8 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faDiceOne = {
  prefix: 'fad',
  iconName: 'dice-one',
  icon: [448, 512, [9856], "f525", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faCircleA = {
  prefix: 'fad',
  iconName: 'circle-a',
  icon: [512, 512, [], "e0f7", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L321.2 320H190.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L214.8 272h82.3L256 189.7z", "M277.5 125.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-104 208c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L190.8 320H321.2l17.4 34.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-104-208zM297.2 272H214.8L256 189.7 297.2 272z"]]
};
var faHelmetBattle = {
  prefix: 'fad',
  iconName: 'helmet-battle',
  icon: [576, 512, [], "f6eb", ["M66.4 .2c8.3 1.2 14.2 8.6 13.6 17L65.1 225.7c-1.2 17-15.4 30.2-32.5 30.2H30.4C13.6 256 0 242.4 0 225.6c0-2.3 .3-4.6 .8-6.8L48.4 12.4c1.9-8.1 9.7-13.5 18-12.2zm443.2 0c8.3-1.2 16.1 4.1 18 12.2l47.6 206.4c.5 2.2 .8 4.5 .8 6.8c0 16.8-13.6 30.4-30.4 30.4h-2.2c-17.1 0-31.3-13.2-32.5-30.2L496 17.1c-.6-8.3 5.3-15.7 13.6-17z", "M320 352V488c0 18.4 20.8 30.1 36.5 20.5l144-88c9.2-5.6 13.5-16.7 10.6-27.1C494.1 333.6 480 270.2 480 208c0-85-89.1-149.2-153.1-189c-1.9-1.2-4-2.6-6.3-4.1C311.2 8.4 298.7 0 288 0s-23.2 8.4-32.7 14.9c-2.3 1.5-4.4 3-6.3 4.1C185.1 58.8 96 123 96 208c0 62.2-14.1 125.6-31.1 185.4c-3 10.4 1.4 21.4 10.6 27.1l144 88c15.7 9.6 36.5-2.1 36.5-20.5V296h0V267.5c0-6.9-4.4-13-10.9-15.2l-72.3-24.1c-7.6-2.5-12.7-9.6-12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H397.4c10.3 0 18.6 8.3 18.6 18.6c0 8-5.1 15.1-12.7 17.6l-72.3 24.1c-6.5 2.2-10.9 8.3-10.9 15.2V352h0z"]]
};
var faButter = {
  prefix: 'fad',
  iconName: 'butter',
  icon: [640, 512, [129480], "e3e4", ["M128 64c-35.3 0-64 28.7-64 64V320H448V64H128zm384 0H480V320h96V128c0-35.3-28.7-64-64-64z", "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faBlanketFire = {
  prefix: 'fad',
  iconName: 'blanket-fire',
  icon: [640, 512, [], "e3da", ["M0 96V320c0 70.7 57.3 128 128 128H314.4c-11.3-19.5-19.4-41.2-23.4-64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64H317.4c2.5-4.5 5.1-8.9 7.8-13.3c21.7-35.2 51.9-71.2 87.3-102.8c10-8.9 23-12.8 35.5-11.7V96c0-53-43-96-96-96H96C43 0 0 43 0 96zM288 350.1c0-20.2 5.3-41.3 13.8-62.1H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H288l0-1.9zm193 97.8c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z", "M433.8 163.6c5.6-5 14.2-5 19.8 0c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 56.7 24.2 76.9c0 87.8-71.3 161.9-160 161.9c-89.7 0-160-74.2-160-161.9c0-26.4 12.7-58.6 32.4-90.6c20-32.4 48.1-66.1 81.4-95.8zM481 447.9c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z"]]
};
var faKiwiBird = {
  prefix: 'fad',
  iconName: 'kiwi-bird',
  icon: [576, 512, [], "f535", ["M477.6 348.6L546 471.8c3.5 6.4 10.9 9.5 18 7.7s12-8.2 12-15.5V224.3c-.1 60.4-42.1 111-98.4 124.3zM208 415.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V405.1c-15.2 5.4-31.3 8.9-48 10.3zm-112-25V456c0 13.3 10.7 24 24 24s24-10.7 24-24V410c-17-4.4-33.1-11-48-19.6z", "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c70.7 0 128-57.3 128-128s-57.3-128-128-128H392.3c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224S86 416 192 416c36.3 0 70.3-10.1 99.2-27.6zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faCastle = {
  prefix: 'fad',
  iconName: 'castle',
  icon: [640, 512, [], "e0de", ["M128 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h48V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h48V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64 208v16H496 464 176 144 128V208 64 16z", "M0 176c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16v48H576V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v96V464c0 26.5-21.5 48-48 48H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64V512H48c-26.5 0-48-21.5-48-48V272 176z"]]
};
var faGolfClub = {
  prefix: 'fad',
  iconName: 'golf-club',
  icon: [512, 512, [], "f451", ["M508.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L264 392.5l0-.5L42.1 318C21.4 311.1 0 326.6 0 348.4V376H48c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v32H48c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v8c0 17.7 14.3 32 32 32H255.3c12 .3 23.6-6.3 29.3-17.7l224-448z", "M0 408H48c8.8 0 16-7.2 16-16s-7.2-16-16-16H0v32zm0 64H48c8.8 0 16-7.2 16-16s-7.2-16-16-16H0v32z"]]
};
var faArrowRightArrowLeft = {
  prefix: 'fad',
  iconName: 'arrow-right-arrow-left',
  icon: [448, 512, [8644, "exchange"], "f0ec", ["M9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96z", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160 32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l306.7 0L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96z"]]
};
var faExchange = faArrowRightArrowLeft;
var faRotateRight = {
  prefix: 'fad',
  iconName: 'rotate-right',
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", ["M413.4 96.6l-45.3 45.3c-62.6-61.5-163.1-61.2-225.3 1c-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-229.3 87.5-316.8 0s-87.5-229.3 0-316.8c87.2-87.2 228.3-87.5 315.8-1z", "M344 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8z"]]
};
var faRedoAlt = faRotateRight;
var faRotateForward = faRotateRight;
var faUtensils = {
  prefix: 'fad',
  iconName: 'utensils',
  icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", ["M288 176C288 32 400 0 416 0c17.7 0 32 14.3 32 32V352H352c-35.3 0-64-28.7-64-64V176zM49.7 .1C57.9 1 64 7.8 64 16V150.2c0 5.4 4.4 9.8 9.8 9.8c5.1 0 9.3-3.9 9.8-9L96.1 14.6C96.8 6.3 103.7 0 112 0s15.2 6.3 15.9 14.6L140.3 151c.5 5.1 4.7 9 9.8 9c5.4 0 9.8-4.4 9.8-9.8V16c0-8.2 6.1-15 14.3-15.9s15.6 4.5 17.4 12.4l30.3 136.3c1.4 6.3 2.1 12.7 2.1 19.1c0 48.6-39.4 88.1-88.1 88.1H88.1C39.4 256 0 216.6 0 167.9c0-6.4 .7-12.8 2.1-19.1L32.4 12.5C34.2 4.6 41.6-.8 49.7 .1zM112 167.4l-.3 .7 .3 0 .3 0-.3-.7z", "M144 480V256H80V480c0 17.7 14.3 32 32 32s32-14.3 32-32zm304 0V352H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"]]
};
var faCutlery = faUtensils;
var faArrowUpWideShort = {
  prefix: 'fad',
  iconName: 'arrow-up-wide-short',
  icon: [576, 512, ["sort-amount-up"], "f161", ["M288 448c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0-128c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0-128c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0-128c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32z", "M128 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L160 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L63.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C110.5 35.8 119 32 128 32z"]]
};
var faSortAmountUp = faArrowUpWideShort;
var faChartPieSimpleCircleDollar = {
  prefix: 'fad',
  iconName: 'chart-pie-simple-circle-dollar',
  icon: [640, 512, [], "e605", ["M509.8 192.5c-4.6-.4-9.2-.5-13.8-.5c-46.8 0-89.3 18.2-120.8 48H272V16.6c0-9 7-16.6 16-16.6C401 0 494.5 83.7 509.8 192.5zM339.2 288c-12.3 24-19.2 51.2-19.2 80c0 42.5 15 81.4 40.1 111.8C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V288H339.2z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM472.1 339l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z"]]
};
var faBalloons = {
  prefix: 'fad',
  iconName: 'balloons',
  icon: [640, 512, [], "e2e4", ["M324.7 261.9c18.5 76.2 86.8 139.7 113 161.8c5.9 5 7.8 13.4 4.4 20.3l-24.7 49.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9H531.1c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L518 443.9c-3.5-6.9-1.6-15.3 4.4-20.3C552.8 398 640 316.5 640 224c0-88.4-71.6-160-160-160c-53.7 0-101.2 26.4-130.2 67c1.4 9.5 2.2 19.2 2.2 29c0 37.2-11.5 71.8-27.3 101.9zM464 160c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16z", "M160 0c88.4 0 160 71.6 160 160c0 92.5-87.2 174-117.7 199.7c-5.9 5-7.8 13.4-4.4 20.3l24.7 49.3c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9H108.9c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8L122 379.9c3.5-6.9 1.6-15.3-4.4-20.3C87.2 334 0 252.5 0 160C0 71.6 71.6 0 160 0zM96 144c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16z"]]
};
var faMillSign = {
  prefix: 'fad',
  iconName: 'mill-sign',
  icon: [384, 512, [], "e1ed", ["M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1C226.1 103.4 248.2 96 272 96c3.7 0 7.3 .2 10.9 .5l19.2-53.8zM259.7 161.6C239.1 167 224 185.7 224 208v53.5l35.7-100zM163.6 430.7c-2.3-4.4-3.6-9.4-3.6-14.7V250.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60z", "M112 160c-26.5 0-48 21.5-48 48V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V208 128c0-17.7 14.3-32 32-32c10.9 0 20.5 5.4 26.3 13.7C74.2 101 92.5 96 112 96c31.3 0 59.7 12.9 80 33.6C212.3 108.9 240.7 96 272 96c61.9 0 112 50.1 112 112V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V208c0-26.5-21.5-48-48-48s-48 21.5-48 48V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V208c0-26.5-21.5-48-48-48z"]]
};
var faBowlRice = {
  prefix: 'fad',
  iconName: 'bowl-rice',
  icon: [512, 512, [], "e2eb", ["M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zM32 200c0-13.3 10.7-24 24-24H72c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zm192 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M27.4 256C12.3 256 0 268.3 0 283.4c0 70.5 44.4 130.7 106.7 154.1l1.8 14.4c2 16 15.6 28 31.8 28H371.8c16.1 0 29.8-12 31.8-28l1.8-14.4C467.6 414.1 512 353.9 512 283.4c0-15.1-12.3-27.4-27.4-27.4H27.4z"]]
};
var faTimelineArrow = {
  prefix: 'fad',
  iconName: 'timeline-arrow',
  icon: [640, 512, [], "e29d", ["M352 176c11.4 0 22.2-2.4 32-6.7V224H530.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L530.7 288H256v54.7c-9.8-4.3-20.6-6.7-32-6.7s-22.2 2.4-32 6.7V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V169.3c9.8 4.3 20.6 6.7 32 6.7s22.2-2.4 32-6.7V224H320V169.3c9.8 4.3 20.6 6.7 32 6.7z", "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM352 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM200 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]]
};
var faSkull = {
  prefix: 'fad',
  iconName: 'skull',
  icon: [512, 512, [128128], "f54c", ["M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1v64c0 26.5 21.5 48 48 48h48V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48V400c0-.4 0-.7 0-1.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M160 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm192 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faGameBoardSimple = {
  prefix: 'fad',
  iconName: 'game-board-simple',
  icon: [448, 512, ["game-board-alt"], "f868", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 96V416H64V96H384z", "M64 96l0 160H224V96H64zM224 256V416H384l0-160H224z"]]
};
var faGameBoardAlt = faGameBoardSimple;
var faCircleVideo = {
  prefix: 'fad',
  iconName: 'circle-video',
  icon: [512, 512, ["video-circle"], "e12b", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 192c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192zM396.9 317.9L352 288V224l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V307.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z", "M160 160c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160zM352 288l44.9 29.9c2 1.3 4.4 2.1 6.8 2.1c6.8 0 12.3-5.5 12.3-12.3V204.3c0-6.8-5.5-12.3-12.3-12.3c-2.4 0-4.8 .7-6.8 2.1L352 224v64z"]]
};
var faVideoCircle = faCircleVideo;
var faChartScatterBubble = {
  prefix: 'fad',
  iconName: 'chart-scatter-bubble',
  icon: [512, 512, [], "e0e9", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M384 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-96-16a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 176a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-176 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
};
var faHouseTurret = {
  prefix: 'fad',
  iconName: 'house-turret',
  icon: [640, 512, [], "e1b4", ["M24 0C10.7 0 0 10.7 0 24V96v8 93.5c0 17 6.7 33.3 18.7 45.3L64 288V464c0 26.5 21.5 48 48 48H240c-10-13.4-16-30-16-48V277.1c0-22.4 9.4-43.8 25.9-59L352 124.6V104 96 24c0-13.3-10.7-24-24-24H280c-13.3 0-24 10.7-24 24V96H224V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24V96H96V24C96 10.7 85.3 0 72 0H24zM176 160c22.1 0 40 17.9 40 40v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V200c0-22.1 17.9-40 40-40z", "M256 464V277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4V464c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48zM424 272c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V296c0-13.3-10.7-24-24-24H424z"]]
};
var faBanana = {
  prefix: 'fad',
  iconName: 'banana',
  icon: [576, 512, [], "e2e5", ["M304 144c0 47.1-12.7 91.2-34.9 129.2c2.9 1.9 5.7 3.9 8.3 6l48.1 38.5 96.7-25.8c6.1-1.6 12.3-2.7 18.5-3.4c4.8-20.8 7.3-42.4 7.3-64.6c0-84.7-36.6-160.9-94.8-213.6C345.6 3.6 335.9 0 326.1 0c-29.4 0-47.5 29.4-38 55c10.3 27.7 15.9 57.7 15.9 89z", "M177.1 315.2c9.7-7.3 21.5-11.2 33.6-11.2h1.3c10.3 0 20.4 2.8 29.1 8.2C194.1 366 125 400 48 400c-26.5 0-48 21.5-48 48v16c0 26.5 21.5 48 48 48l112 0c117.3 0 218.2-70.1 263.1-170.6l12-3.2c5.4-1.4 10.9-2.2 16.5-2.2h2.6c22.5 0 43.3 11.8 54.9 31.1l22.4 37.3c6.8 11.4 21.6 15 32.9 8.2s15-21.6 8.2-32.9l-22.4-37.3c-20.2-33.7-56.7-54.4-96-54.4h-2.6c-9.7 0-19.4 1.3-28.9 3.8l-.3 .1c-.1 0-.1 0-.2 .1l-96.7 25.8-48.1-38.5-.5-.4c-18.4-14.8-41.4-22.8-65-22.8h-1.3c-22.5 0-44.4 7.3-62.4 20.8l-42.7 32c-10.6 8-12.8 23-4.8 33.6s23 12.8 33.6 4.8l42.7-32z"]]
};
var faHandHoldingSkull = {
  prefix: 'fad',
  iconName: 'hand-holding-skull',
  icon: [576, 512, [], "e1a4", ["M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z", "M363.6 250c-1.4-7 2-13.9 8-17.7C408.2 209 432 171 432 128C432 57.3 367.5 0 288 0S144 57.3 144 128c0 43 23.8 81 60.4 104.2c6 3.8 9.4 10.8 8 17.7l-4.1 20.6c-.2 .9-.3 1.9-.3 2.9c0 8 6.5 14.6 14.6 14.6H353.4c8 0 14.6-6.5 14.6-14.6c0-1-.1-1.9-.3-2.9L363.6 250zM208 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faPeopleDress = {
  prefix: 'fad',
  iconName: 'people-dress',
  icon: [640, 512, [], "e217", ["M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M70.2 384H88v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L226.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-53.6-89.2c-20.3-33.7-56.7-54.3-96-54.3H154.2c-39.3 0-75.7 20.6-96 54.3L4.6 271.5c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L55 362.9C51.6 373.3 59.3 384 70.2 384z"]]
};
var faLoveseat = {
  prefix: 'fad',
  iconName: 'loveseat',
  icon: [512, 512, ["couch-small"], "f4cc", ["M192 32C121.3 32 64 89.3 64 160v66.7c18.6 6.6 32 24.4 32 45.3v80H416V272c0-20.9 13.4-38.7 32-45.3V160c0-70.7-57.3-128-128-128H192z", "M48 224c-26.5 0-48 21.5-48 48V448c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32H416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V272c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H96V272c0-26.5-21.5-48-48-48z"]]
};
var faCouchSmall = faLoveseat;
var faTowerBroadcast = {
  prefix: 'fad',
  iconName: 'tower-broadcast',
  icon: [576, 512, ["broadcast-tower"], "f519", ["M80.3 44C86.9 27.6 79 9 62.6 2.3S27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84zM555.1 20C548.4 3.6 529.8-4.3 513.4 2.3S489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108zM170.6 76.8c7.1-16.2-.3-35.1-16.5-42.1s-35.1 .3-42.1 16.5C101.7 74.8 96 100.8 96 128s5.7 53.2 16 76.8c7.1 16.2 25.9 23.6 42.1 16.5s23.6-25.9 16.5-42.1C163.8 163.6 160 146.3 160 128s3.8-35.6 10.6-51.2zM464 51.2c-7.1-16.2-25.9-23.6-42.1-16.5s-23.6 25.9-16.5 42.1C412.2 92.4 416 109.7 416 128s-3.8 35.6-10.6 51.2c-7.1 16.2 .3 35.1 16.5 42.1s35.1-.3 42.1-16.5c10.3-23.6 16-49.6 16-76.8s-5.7-53.2-16-76.8z", "M320 183.4c19.1-11.1 32-31.7 32-55.4c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 23.7 12.9 44.4 32 55.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V183.4z"]]
};
var faBroadcastTower = faTowerBroadcast;
var faTruckPickup = {
  prefix: 'fad',
  iconName: 'truck-pickup',
  icon: [640, 512, [128763], "f63c", ["M160 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm320 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M288 96v96H445.4L368.6 96H288zM418.6 56L527.4 192H576c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H581.2c-18-37.8-56.5-64-101.2-64s-83.2 26.2-101.2 64H261.2c-18-37.8-56.5-64-101.2-64s-83.2 26.2-101.2 64H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V224c0-17.7 14.3-32 32-32H224V80c0-26.5 21.5-48 48-48h96.6c19.4 0 37.8 8.8 50 24z"]]
};
var faBlockQuote = {
  prefix: 'fad',
  iconName: 'block-quote',
  icon: [448, 512, [], "e0b5", ["M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM128 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm32 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M0 256c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256z"]]
};
var faUpLong = {
  prefix: 'fad',
  iconName: 'up-long',
  icon: [320, 512, ["long-arrow-alt-up"], "f30c", ["M224 192H96v0h0l0 288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32l0-160h0V192z", "M313.4 151.5c6.6 7 8.4 17.2 4.6 26s-12.5 14.5-22 14.5H224L96 192H24c-9.6 0-18.2-5.7-22-14.5s-2-19 4.6-26l136-144C147.1 2.7 153.4 0 160 0s12.9 2.7 17.4 7.5l136 144z"]]
};
var faLongArrowAltUp = faUpLong;
var faStop = {
  prefix: 'fad',
  iconName: 'stop',
  icon: [384, 512, [9209], "f04d", ["M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z", ""]]
};
var faCodeMerge = {
  prefix: 'fad',
  iconName: 'code-merge',
  icon: [448, 512, [], "f387", ["M112.4 153.2c-9.9 4.4-20.9 6.8-32.4 6.8c-11.4 0-22.2-2.4-32-6.7V358.7c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7V272c26.7 20.1 60 32 96 32h86.7c-4.3-9.8-6.7-20.6-6.7-32s2.4-22.2 6.7-32H208c-49.9 0-91-38.1-95.6-86.8z", "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 80 0a80 80 0 1 0 0 160zm0 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]]
};
var faMoneyCheckDollarPen = {
  prefix: 'fad',
  iconName: 'money-check-dollar-pen',
  icon: [640, 512, ["money-check-edit-alt"], "f873", ["M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H330.5l6-23.9c2.8-11.3 8.6-21.5 16.8-29.7L534.6 213.1c11.6-11.6 26.3-18.5 41.4-20.5V128c0-35.3-28.7-64-64-64H64zM272 288h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16-80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm-92-56v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z", "M557.2 235.7l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71z"]]
};
var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
var faUpFromLine = {
  prefix: 'fad',
  iconName: 'up-from-line',
  icon: [384, 512, ["arrow-alt-from-bottom"], "f346", ["M0 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M164.7 43.3L41.9 166.1c-6.4 6.4-9.9 15-9.9 24C32 208.8 47.2 224 65.9 224H128V352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224h62.1c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24L219.3 43.3C212.1 36.1 202.2 32 192 32s-20.1 4.1-27.3 11.3z"]]
};
var faArrowAltFromBottom = faUpFromLine;
var faUpload = {
  prefix: 'fad',
  iconName: 'upload',
  icon: [512, 512, [], "f093", ["M288 352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H64c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H288zm120 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M256 416c17.7 0 32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3V384c0 17.7 14.3 32 32 32z"]]
};
var faHurricane = {
  prefix: 'fad',
  iconName: 'hurricane',
  icon: [384, 512, [], "f751", ["M174.9 2.6C75.7 18.5 0 104.4 0 208C0 312.4 77 398.9 177.3 413.7c8.3 1.2 14.7 8.1 14.7 16.5v63.3c0 9.3 8 16.7 17.1 15.2C308.3 492.9 384 407 384 303.4C384 199 307 112.5 206.7 97.6c-8.3-1.2-14.7-8.1-14.7-16.5V17.9c0-9.3-8-16.7-17.1-15.2zM192 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faGridRound2Plus = {
  prefix: 'fad',
  iconName: 'grid-round-2-plus',
  icon: [512, 512, [], "e5dc", ["M224 128A96 96 0 1 1 32 128a96 96 0 1 1 192 0zm0 256A96 96 0 1 1 32 384a96 96 0 1 1 192 0zM384 224a96 96 0 1 1 0-192 96 96 0 1 1 0 192z", "M408 296c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H296c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24V408h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H408V296z"]]
};
var faPeoplePants = {
  prefix: 'fad',
  iconName: 'people-pants',
  icon: [640, 512, [], "e219", ["M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9z"]]
};
var faMound = {
  prefix: 'fad',
  iconName: 'mound',
  icon: [576, 512, [], "e52d", ["M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z", ""]]
};
var faWindsock = {
  prefix: 'fad',
  iconName: 'windsock',
  icon: [512, 512, [], "f777", ["M272 78V338l96-20V98L272 78zM486.5 293.3c14.8-3.1 25.5-16.2 25.5-31.3V154c0-15.2-10.6-28.2-25.5-31.3L432 111.3V304.7l54.5-11.4zM208 64.7L166.5 56c-19.9-4.1-38.5 11-38.5 31.3V96H64v48h64V272H64v48h64v8.6c0 20.3 18.7 35.5 38.5 31.3l41.5-8.6V64.7z", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM208 64.7V351.3L272 338V78L208 64.7zM368 318l64-13.3V111.3L368 98V318z"]]
};
var faCircleHalf = {
  prefix: 'fad',
  iconName: 'circle-half',
  icon: [512, 512, [], "e110", ["M256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256V0z", "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512V0z"]]
};
var faBrakeWarning = {
  prefix: 'fad',
  iconName: 'brake-warning',
  icon: [640, 512, [], "e0c7", ["M320 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm0-352c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M91.1 109c7.2-11.1 4-26-7.2-33.2s-26-4-33.2 7.2C18.6 132.9 0 192.3 0 256s18.6 123.1 50.7 173c7.2 11.1 22 14.4 33.2 7.2s14.4-22 7.2-33.2C63.8 360.6 48 310.2 48 256s15.8-104.6 43.1-147zM589.3 83c-7.2-11.1-22-14.4-33.2-7.2s-14.4 22-7.2 33.2c27.3 42.4 43.1 92.8 43.1 147s-15.8 104.6-43.1 147c-7.2 11.1-4 26 7.2 33.2s26 4 33.2-7.2C621.4 379.1 640 319.7 640 256s-18.6-123.1-50.7-173zM320 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
};
var faToiletPortable = {
  prefix: 'fad',
  iconName: 'toilet-portable',
  icon: [320, 512, [], "e583", ["M0 64H24 296h24V88 488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V88 64zM256 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240z", "M32 0C14.3 0 0 14.3 0 32V64H320V32c0-17.7-14.3-32-32-32H32zM256 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]]
};
var faCompactDisc = {
  prefix: 'fad',
  iconName: 'compact-disc',
  icon: [512, 512, [128191, 128192, 128440], "f51f", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-160a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM96 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-45.4 22.3-89.2 54.5-121.5S194.6 64 240 64c8.8 0 16 7.2 16 16s-7.2 16-16 16c-35 0-71.1 17.5-98.8 45.2S96 205 96 240z", "M256 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 32a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z"]]
};
var faFileArrowDown = {
  prefix: 'fad',
  iconName: 'file-arrow-down',
  icon: [384, 512, ["file-download"], "f56d", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM216 232c0-13.3-10.7-24-24-24s-24 10.7-24 24V334.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V232z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM216 232c0-13.3-10.7-24-24-24s-24 10.7-24 24V334.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V232z"]]
};
var faFileDownload = faFileArrowDown;
var faSaxophoneFire = {
  prefix: 'fad',
  iconName: 'saxophone-fire',
  icon: [640, 512, ["sax-hot"], "f8db", ["M237.5 224L171.4 338.1c-2.2 3.8-3.4 8.2-3.4 12.6v2.6c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L319 257l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L367 209l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L415 161l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8 44.3-44.3c12-12 28.3-18.7 45.3-18.7h30.3c15 0 29.5 5.2 41 14.8l24.3 20.3c3.7 3.1 5.9 7.7 5.9 12.6c0 9-7.3 16.3-16.3 16.3H559.5c-9.8 0-19 4.5-25.1 12.1L288.6 450.6C257.9 489.4 211.2 512 161.8 512C72.4 512 0 439.6 0 350.2v-3.1c0-12.7 1.5-25.4 4.4-37.8L24.5 224H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H240c13.3 0 24 10.7 24 24s-10.7 24-24 24h-2.5zM120 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M102.6 0c2.5 0 4.9 .9 6.9 2.6c13.8 12.4 26.8 25.9 38.8 40.4c5.5-6.9 11.8-14.5 18.5-20.7c3.9-3.6 10.1-3.6 14 0c17.3 15.9 31.9 36.9 42.3 56.8c10.2 19.6 16.9 41.2 16.9 55.3c0 14.6-2.8 28.6-8 41.5H176.8c8.9-15.4 9.3-35.4 .2-52.1c-1.4-2.8-2.8-5.6-4.9-8.4l-25.2 29.4s-40.6-51.8-43.4-55.3C82.5 115.5 72 130.2 72 147c0 11.2 2.7 21 7.5 29H23.9c-5.1-12.9-7.9-26.9-7.9-41.5C16 116 24.9 92 38.7 69.7c14-22.7 33.7-46.3 57-67.1c2-1.8 4.5-2.6 7-2.6zM353 223L319 257l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8zm48-48L367 209l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8zm48-48L415 161l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8zM128 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faSaxHot = faSaxophoneFire;
var faCameraWebSlash = {
  prefix: 'fad',
  iconName: 'camera-web-slash',
  icon: [640, 512, ["webcam-slash"], "f833", ["M359.4 379.1c-12.6 3.2-25.8 4.9-39.4 4.9c-88.4 0-160-71.6-160-160c0-.6 0-1.3 0-1.9l-58.8-46.3C97.8 191.3 96 207.4 96 224c0 79.5 41.4 149.3 103.8 189.1l-58.2 40.7c-11.4 8-16.4 22.5-12.2 35.8S146 512 160 512H480c11.6 0 22.1-6.2 27.7-16L359.4 379.1zM194.5 249.2C206.2 307.8 257.9 352 320 352c1.6 0 3.2 0 4.8-.1L194.5 249.2zM448 224c0-70.7-57.3-128-128-128c-41.3 0-78.1 19.6-101.5 50l37.8 29.6C270.9 156.4 294 144 320 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-15.8 0-29.8 7.6-38.5 19.3L420 303.9c17.5-21.9 28-49.7 28-79.9zm32 0c0 37.7-13 72.3-34.8 99.6l50.4 39.5C525.9 324.9 544 276.6 544 224C544 100.3 443.7 0 320 0C248 0 183.9 34 143 86.7l50.4 39.5C222.6 88.4 268.5 64 320 64c88.4 0 160 71.6 160 160z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faWebcamSlash = faCameraWebSlash;
var faFolderMedical = {
  prefix: 'fad',
  iconName: 'folder-medical',
  icon: [512, 512, [], "e18c", ["M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z", "M240 192c-8.8 0-16 7.2-16 16v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16l-48 0V208c0-8.8-7.2-16-16-16H240z"]]
};
var faFolderGear = {
  prefix: 'fad',
  iconName: 'folder-gear',
  icon: [512, 512, ["folder-cog"], "e187", ["M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM368.6 259.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM216 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z", "M375.5 242c2.6 6.8-.5 14.3-6.8 18l-3 1.7c-9.2 5.3-13.7 15.8-13.7 26.4s4.5 21.1 13.7 26.4l3 1.7c6.3 3.6 9.5 11.1 6.8 17.9c-2.1 5.5-4.6 10.7-7.4 15.8l-2.4 4.2c-3 5.1-6.4 9.9-10.1 14.5c-4.6 5.7-12.7 6.7-19 3l-2.9-1.7c-9.2-5.3-20.4-4-29.6 1.3s-16.1 14.5-16.1 25.1v3.4c0 7.3-4.9 13.8-12.1 14.9c-6.5 1-13.1 1.5-19.9 1.5s-13.4-.5-19.9-1.5c-7.2-1.1-12.1-7.6-12.1-14.9v-3.4c0-10.6-6.9-19.8-16.1-25.1s-20.4-6.6-29.6-1.3l-2.9 1.7c-6.3 3.6-14.4 2.6-19-3c-3.7-4.6-7.1-9.4-10.1-14.5l-2.4-4.1c-2.8-5.1-5.3-10.4-7.4-15.8c-2.6-6.8 .5-14.3 6.8-17.9l3-1.7c9.2-5.3 13.7-15.8 13.7-26.4s-4.5-21.1-13.7-26.4l-2.9-1.7c-6.3-3.6-9.5-11.1-6.8-18c2.1-5.5 4.6-10.8 7.4-15.9l2.3-3.9c3.1-5.1 6.5-10 10.2-14.6c4.6-5.7 12.7-6.7 19-3l2.9 1.7c9.2 5.3 20.4 4 29.6-1.3s16.1-14.5 16.1-25.1v-3.4c0-7.3 4.9-13.8 12.1-14.9c6.5-1 13.1-1.5 19.9-1.5s13.4 .5 19.9 1.5c7.2 1.1 12.1 7.6 12.1 14.9v3.4c0 10.6 6.9 19.8 16.1 25.1s20.4 6.6 29.6 1.3l2.9-1.7c6.3-3.6 14.4-2.6 19 3c3.7 4.6 7.1 9.5 10.2 14.5l2.3 4c2.8 5.1 5.3 10.4 7.4 15.9zM256 328a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]]
};
var faFolderCog = faFolderGear;
var faHandWave = {
  prefix: 'fad',
  iconName: 'hand-wave',
  icon: [512, 512, [], "e1a7", ["M185.4 70.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192c3.3 3.3 9.4 1.1 9.4-3.7l0-77.7c0-22.1 17.9-40 40-40s40 17.9 40 40V312.3c0 60.2-27.9 116.9-75.5 153.7C385.7 505.3 321 515.7 263 498.7c-28.4-7.1-55.3-21.8-77.6-44.1l-4.9-4.9L73.4 342.6l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l31.9 31.9 .1 .1L165.3 344c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L57.4 198.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L229.3 280c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L105.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L293.3 216c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L185.4 70.6z", "M352.2 82.3c1.3 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1l-1.2-8.5c-5-35.2-32.7-62.9-67.9-67.9L306.3 .2c-8.7-1.2-16.9 4.8-18.1 13.6s4.8 16.9 13.6 18.1l8.5 1.2c21.1 3 37.7 19.6 40.7 40.7l1.2 8.5zM31.8 365.7c-1.2-8.7-9.4-14.8-18.1-13.6S-1.1 361.5 .2 370.3l1.2 8.5c5 35.2 32.7 62.9 67.9 67.9l8.5 1.2c8.7 1.2 16.9-4.8 18.1-13.6s-4.8-16.9-13.6-18.1L73.8 415c-21.1-3-37.7-19.6-40.7-40.7l-1.2-8.5z"]]
};
var faArrowUpArrowDown = {
  prefix: 'fad',
  iconName: 'arrow-up-arrow-down',
  icon: [576, 512, ["sort-up-down"], "e099", ["M393.4 470.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L448 370.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V370.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96z", "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 141.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V141.3L86.6 182.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z"]]
};
var faSortUpDown = faArrowUpArrowDown;
var faCaravan = {
  prefix: 'fad',
  iconName: 'caravan',
  icon: [640, 512, [], "f8ff", ["M64 160c0-17.7 14.3-32 32-32H224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160zm256 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64H416c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v96H348.8c-7.7-15-17.4-28.7-28.8-40.8V160zM192 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M0 112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0H302.9c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H80c-44.2 0-80-35.8-80-80V112zM348.8 352H448V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V311.2c11.4 12.1 21.2 25.8 28.8 40.8zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96z"]]
};
var faShieldCat = {
  prefix: 'fad',
  iconName: 'shield-cat',
  icon: [512, 512, [], "e572", ["M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4z", "M160 272V154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96zm72 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faMessageSlash = {
  prefix: 'fad',
  iconName: 'message-slash',
  icon: [640, 512, ["comment-alt-slash"], "f4a9", ["M406.2 416L64 146.4V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416h32.8zm142.3-11.4C565.1 393 576 373.8 576 352V64c0-35.3-28.7-64-64-64H128C104.4 0 83.8 12.7 72.7 31.7L548.5 404.6z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faCommentAltSlash = faMessageSlash;
var faBolt = {
  prefix: 'fad',
  iconName: 'bolt',
  icon: [448, 512, [9889, "zap"], "f0e7", ["M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z", ""]]
};
var faZap = faBolt;
var faTrashCanCheck = {
  prefix: 'fad',
  iconName: 'trash-can-check',
  icon: [448, 512, [], "e2a9", ["M416 96H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V96zM337 241L209 369c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 207c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM337 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 241z"]]
};
var faGlassWater = {
  prefix: 'fad',
  iconName: 'glass-water',
  icon: [384, 512, [], "e4f4", ["M8.6 10.2C14.6 3.7 23.1 0 32 0H352c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1L355.1 437.7c-3 41.9-37.8 74.3-79.8 74.3H108.7c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64L92.7 433.1c.6 8.4 7.6 14.9 16 14.9H275.3c8.4 0 15.4-6.5 16-14.9L317.6 64H66.4z", "M311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5 92.7 433.1c.6 8.4 7.6 14.9 16 14.9H275.3c8.4 0 15.4-6.5 16-14.9L311 156.5z"]]
};
var faOilWell = {
  prefix: 'fad',
  iconName: 'oil-well',
  icon: [576, 512, [], "e532", ["M302.2 149.4l6.3 18.1-80.4 20.8 13.6-39c4.5-12.8 16.6-21.4 30.2-21.4s25.7 8.6 30.2 21.4zM137.3 448l53.1-151.7L265 277l-26.3 75h66.6l-27.4-78.4L340 257.5 406.7 448H338.9l-11.2-32H216.3l-11.2 32H137.3z", "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3z"]]
};
var faPersonSimple = {
  prefix: 'fad',
  iconName: 'person-simple',
  icon: [256, 512, [], "e220", ["M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64z", "M105.6 160c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6z"]]
};
var faVault = {
  prefix: 'fad',
  iconName: 'vault',
  icon: [576, 512, [], "e2c5", ["M64 0C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H80l16 32h64l16-32H400l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 240a160 160 0 1 1 320 0A160 160 0 1 1 64 240zm416-18.7V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z", "M304 240a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM64 240a160 160 0 1 1 320 0A160 160 0 1 1 64 240zm448-64c0 20.9-13.4 38.7-32 45.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48z"]]
};
var faMars = {
  prefix: 'fad',
  iconName: 'mars',
  icon: [448, 512, [9794], "f222", ["M96 304a80 80 0 1 1 160 0A80 80 0 1 1 96 304z", "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]]
};
var faToilet = {
  prefix: 'fad',
  iconName: 'toilet',
  icon: [448, 512, [128701], "f7d8", ["M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm88 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z", "M416 196.9c1.9 1.4 3.8 2.9 5.6 4.4C437.1 214.5 448 232.9 448 256c0 46.9-14.3 84.1-37 112.5c-14.2 17.7-31.1 31.3-48.5 41.8l19.8 59.5c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H96c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l19.8-59.5C68.1 399.8 51.2 386.2 37 368.5C14.3 340.1 0 302.9 0 256c0-23.1 10.9-41.5 26.4-54.6c1.8-1.5 3.7-3 5.6-4.4V48H416V196.9zM384 256l0-.1c0-1 0-2.5-3.8-5.8c-4.8-4.1-14-9-29.3-13.4C320.5 228 276.1 224 224 224s-96.5 4-126.9 12.8c-15.3 4.4-24.5 9.3-29.3 13.4C64 253.4 64 255 64 255.9l0 .1 0 .3c0 1 .3 2.6 3.8 5.6c4.8 4.1 14 9 29.3 13.4C127.5 284 171.9 288 224 288s96.5-4 126.9-12.8c15.3-4.4 24.5-9.3 29.3-13.4c3.5-3 3.8-4.6 3.8-5.6l0-.3zM112 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]]
};
var faPlaneCircleXmark = {
  prefix: 'fad',
  iconName: 'plane-circle-xmark',
  icon: [640, 512, [], "e557", ["M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l77.1 44.1C350.6 254 320 307.4 320 368c0 54.2 24.5 102.7 63.1 135c-2 5.3-7.1 9-13.1 9c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faYenSign = {
  prefix: 'fad',
  iconName: 'yen-sign',
  icon: [320, 512, [165, "cny", "jpy", "rmb", "yen"], "f157", ["M100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80V265.7L100.2 224zM192 288h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H219.8L192 265.7V288zm-64 32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80V320zm64 64h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64z", "M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7L128 265.7V448c0 17.7 14.3 32 32 32s32-14.3 32-32V265.7L314.6 81.7c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"]]
};
var faCny = faYenSign;
var faJpy = faYenSign;
var faRmb = faYenSign;
var faYen = faYenSign;
var faGearCode = {
  prefix: 'fad',
  iconName: 'gear-code',
  icon: [512, 512, [], "e5e8", ["M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-30.9 28.1c-7.7 7.1-11.4 17.5-10.9 27.9c.1 2.9 .2 5.8 .2 8.8s-.1 5.9-.2 8.8c-.5 10.5 3.1 20.9 10.9 27.9l30.9 28.1c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-39.7-12.6c-10-3.2-20.8-1.1-29.7 4.6c-4.9 3.1-9.9 6.1-15.1 8.7c-9.3 4.8-16.5 13.2-18.8 23.4l-8.9 40.7c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-8.9-40.7c-2.2-10.2-9.5-18.6-18.8-23.4c-5.2-2.7-10.2-5.6-15.1-8.7c-8.8-5.7-19.7-7.8-29.7-4.6L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l30.9-28.1c7.7-7.1 11.4-17.5 10.9-27.9c-.1-2.9-.2-5.8-.2-8.8s.1-5.9 .2-8.8c.5-10.5-3.1-20.9-10.9-27.9L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l39.7 12.6c10 3.2 20.8 1.1 29.7-4.6c4.9-3.1 9.9-6.1 15.1-8.7c9.3-4.8 16.5-13.2 18.8-23.4l8.9-40.7c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l8.9 40.7c2.2 10.2 9.4 18.6 18.8 23.4c5.2 2.7 10.2 5.6 15.1 8.7c8.8 5.7 19.7 7.7 29.7 4.6l39.7-12.6c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zm-208.2-3.9c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-32 192c-1.5 8.7 4.4 17 13.2 18.4s17-4.4 18.4-13.2l32-192zM187.3 227.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-40 40c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L158.6 256l28.7-28.7zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L353.4 256l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l40-40c6.2-6.2 6.2-16.4 0-22.6l-40-40z", "M274.6 144.2c8.7 1.5 14.6 9.7 13.2 18.4l-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2zm-87.3 60.5c6.2 6.2 6.2 16.4 0 22.6L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0zm137.4 0c6.2-6.2 16.4-6.2 22.6 0l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 256l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]]
};
var faNotes = {
  prefix: 'fad',
  iconName: 'notes',
  icon: [512, 512, [], "e202", ["M160 32c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64H352V320c0-17.7 14.3-32 32-32h96V96c0-35.3-28.7-64-64-64H160z", "M296 464c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296zm56-48V320c0-17.7 14.3-32 32-32h96L352 416z"]]
};
var faRubleSign = {
  prefix: 'fad',
  iconName: 'ruble-sign',
  icon: [384, 512, [8381, "rouble", "rub", "ruble"], "f158", ["M64 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V352zm64 64H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128v64z", "M64 64c0-17.7 14.3-32 32-32H240c79.5 0 144 64.5 144 144s-64.5 144-144 144H128V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V64zm64 192H240c44.2 0 80-35.8 80-80s-35.8-80-80-80H128V256z"]]
};
var faRouble = faRubleSign;
var faRub = faRubleSign;
var faRuble = faRubleSign;
var faTrashUndo = {
  prefix: 'fad',
  iconName: 'trash-undo',
  icon: [448, 512, ["trash-arrow-turn-left"], "f895", ["M32 96H416L394.6 466.8c-1.5 25.4-22.5 45.2-47.9 45.2H101.3c-25.4 0-46.5-19.8-47.9-45.2L32 96zm185.8 71.9c-8.9-9.9-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L182.5 280H240c22.1 0 40 17.9 40 40v40c0 13.3 10.7 24 24 24s24-10.7 24-24V320c0-48.6-39.4-88-88-88H182.5l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9z", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zm54.1 167.9c8.9 9.9 8.1 25-1.8 33.9L182.5 232H240c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V320c0-22.1-17.9-40-40-40H182.5l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z"]]
};
var faTrashArrowTurnLeft = faTrashUndo;
var faChampagneGlass = {
  prefix: 'fad',
  iconName: 'champagne-glass',
  icon: [320, 512, ["glass-champagne"], "f79e", ["M56.3 27.9C58.3 12 71.9 0 88 0H232c16.1 0 29.7 12 31.7 27.9l23 180.1c8.4 65.4-34.1 124.3-94.8 140V448h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H160 80c-17.7 0-32-14.3-32-32s14.3-32 32-32h48V348C67.3 332.4 24.9 273.4 33.2 208l23-180.1zM116.2 64L96.7 216.1C91.9 254.3 121.6 288 160 288s68.1-33.7 63.3-71.9L203.8 64H116.2z", "M212 128H108L96.7 216.1C91.9 254.3 121.6 288 160 288s68.1-33.7 63.3-71.9L212 128z"]]
};
var faGlassChampagne = faChampagneGlass;
var faObjectsAlignCenterHorizontal = {
  prefix: 'fad',
  iconName: 'objects-align-center-horizontal',
  icon: [512, 512, [], "e3bc", ["M80 64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H80zm64 224c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H144z", "M232 24c0-13.3 10.7-24 24-24s24 10.7 24 24V64H232V24zm0 264V224h48v64H232zm0 160h48v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448z"]]
};
var faSun = {
  prefix: 'fad',
  iconName: 'sun',
  icon: [512, 512, [9728], "f185", ["M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256z", "M256 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z"]]
};
var faTrashCanSlash = {
  prefix: 'fad',
  iconName: 'trash-can-slash',
  icon: [640, 512, ["trash-alt-slash"], "e2ad", ["M431.5 436l66.3 52.2C486.1 502.7 468.1 512 448 512H192c-35.3 0-64-28.7-64-64V196.8l80 63V432c0 8.8 7.2 16 16 16s16-7.2 16-16V285.1l64 50.4V432c0 8.8 7.2 16 16 16s16-7.2 16-16V360.7l64 50.4V432c0 8.8 7.2 16 16 16c7.5 0 13.7-5.1 15.5-12zM336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v5L195.6 128H512V376l-80-62.7V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v80.2L336 238V208zM512 96H154.8L98.4 51.8C103.2 40.2 114.6 32 128 32h96l7.2-14.3C236.6 6.8 247.7 0 259.8 0H380.2c12.1 0 23.2 6.8 28.6 17.7L416 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faTrashAltSlash = faTrashCanSlash;
var faScreenUsers = {
  prefix: 'fad',
  iconName: 'screen-users',
  icon: [640, 512, ["users-class"], "f63d", ["M32 64C32 28.7 60.7 0 96 0H544c35.3 0 64 28.7 64 64V248.4c-17-15.2-39.4-24.4-64-24.4V64L96 64V224c-24.6 0-47 9.2-64 24.4V64z", "M96 384a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64zm256-32a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H288zm320-96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM448 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H512c-35.3 0-64 28.7-64 64z"]]
};
var faUsersClass = faScreenUsers;
var faGuitar = {
  prefix: 'fad',
  iconName: 'guitar',
  icon: [512, 512, [], "f7a6", ["M284.6 182.2c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l-73.9 73.9c0 .9 .1 1.8 .1 2.7c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c.9 0 1.8 0 2.7 .1l73.9-73.9z", "M431 7c9.4-9.4 24.6-9.4 33.9 0l40 40c9.4 9.4 9.4 24.6 0 33.9l-48 48c-2.4 2.4-5.3 4.3-8.5 5.5l-41 15.4L255.9 301.3c-1.3-24.4-20.9-43.9-45.3-45.3L362.1 104.6l15.4-41c1.2-3.2 3.1-6.1 5.5-8.5L431 7z"]]
};
var faSquareArrowLeft = {
  prefix: 'fad',
  iconName: 'square-arrow-left',
  icon: [448, 512, ["arrow-square-left"], "f33a", ["M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM87 239L199 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L344 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L87 273c-9.4-9.4-9.4-24.6 0-33.9z", "M87 273c-9.4-9.4-9.4-24.6 0-33.9L199 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L344 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L87 273z"]]
};
var faArrowSquareLeft = faSquareArrowLeft;
var faSquare8 = {
  prefix: 'fad',
  iconName: 'square-8',
  icon: [448, 512, [], "e25d", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm232 32H216c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0H216s0 0 0 0zm0 48c0 0 0 0 0 0h16c0 0 0 0 0 0h8c17.7 0 32 14.3 32 32s-14.3 32-32 32H208c-17.7 0-32-14.3-32-32s14.3-32 32-32h8z", "M304 200c0-39.8-32.2-72-72-72H216c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42zm-72 72h8c17.7 0 32 14.3 32 32s-14.3 32-32 32H208c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c0 0 0 0 0 0h16c0 0 0 0 0 0zm0-48H216c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]]
};
var faFaceSmileHearts = {
  prefix: 'fad',
  iconName: 'face-smile-hearts',
  icon: [640, 512, [], "e390", ["M468.7 89.2c-15-15.1-21.8-35.2-20.5-54.9C410.5 12.5 366.7 0 320 0C178.6 0 64 114.6 64 256c0 25.7 3.8 50.5 10.8 73.8c1.8 1.1 3.5 2.2 5.2 3.4c27.7-19.9 66.4-17.3 91.3 7.7c27.6 27.7 27.6 72.6 0 100.4l-13.1 13.1C202.4 490.4 258.7 512 320 512c53.3 0 102.8-16.3 143.8-44.2c-22.6-27.9-21-68.9 4.9-94.9c23-23.1 57.8-27 84.8-11.8C568 329 576 293.4 576 256c0-34-6.6-66.4-18.6-96.1c-12.1-.6-24-5.6-33.2-14.9L468.7 89.2zM228.1 325.5C246 346.2 276.6 368 320 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C413.8 372.1 375.1 400 320 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z", "M573.7 11.5L560 25.3 546.3 11.4c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm160 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM628.6 395.5c-15.2-15.3-39.8-15.3-54.9 0L560 409.3l-13.7-13.8c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2zm-534.9-32L80 377.3 66.3 363.4c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0z"]]
};
var faBracketsSquare = {
  prefix: 'fad',
  iconName: 'brackets-square',
  icon: [448, 512, ["brackets"], "f7e9", ["M448 96c0-35.3-28.7-64-64-64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h64V416H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c35.3 0 64-28.7 64-64V96z", "M0 96C0 60.7 28.7 32 64 32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64V416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V96z"]]
};
var faBrackets = faBracketsSquare;
var faLaptopArrowDown = {
  prefix: 'fad',
  iconName: 'laptop-arrow-down',
  icon: [640, 512, [], "e1c6", ["M296 32H128C92.7 32 64 60.7 64 96V352h64V96H296V32zm48 64H512V352h64V96c0-35.3-28.7-64-64-64H344V96zM0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2C8.6 384 0 392.6 0 403.2z", "M296 96H128V352H512V96H344V206.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V96z"]]
};
var faHockeyStickPuck = {
  prefix: 'fad',
  iconName: 'hockey-stick-puck',
  icon: [640, 512, [], "e3ae", ["M476.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L252.2 352H96V480v32h32 32 44.2c24.2 0 46.4-13.7 57.2-35.4L476.6 46.3zM32 352c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H64V352H32z", "M96 352H64V512H96V352zm320 64c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H416z"]]
};
var faHouseTree = {
  prefix: 'fad',
  iconName: 'house-tree',
  icon: [640, 512, [], "e1b3", ["M438.6 9.4c-12.5-12.5-32.8-12.5-45.3 0L282.9 119.9l107.2 98.3c16.5 15.2 25.9 36.5 25.9 59V464c0 18-6 34.6-16 48H608c12.3 0 23.5-7 28.8-18.1s3.8-24.2-3.9-33.9L546.6 352H576c12.3 0 23.5-7 28.8-18.1s3.8-24.2-3.9-33.9L514.6 192H544c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z", "M0 464V277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zM168 272c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V296c0-13.3-10.7-24-24-24H168z"]]
};
var faSignalFair = {
  prefix: 'fad',
  iconName: 'signal-fair',
  icon: [640, 512, ["signal-2"], "f68d", ["M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM352 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z", "M224 320c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416z"]]
};
var faSignal2 = faSignalFair;
var faFaceLaughWink = {
  prefix: 'fad',
  iconName: 'face-laugh-wink',
  icon: [512, 512, ["laugh-wink"], "f59c", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z", "M176.4 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm124.4-6.4c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z"]]
};
var faLaughWink = faFaceLaughWink;
var faCircleDollar = {
  prefix: 'fad',
  iconName: 'circle-dollar',
  icon: [512, 512, ["dollar-circle", "usd-circle"], "f2e8", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392v15.8c10.8 1.3 21.6 4.4 32.2 7.4c2.1 .6 4.1 1.2 6.2 1.7c12.8 3.5 20.3 16.8 16.8 29.5s-16.8 20.3-29.5 16.7c-1.7-.5-3.4-1-5.2-1.4c-7.8-2.2-15.6-4.4-23.5-5.9c-14.6-2.8-31.6-1.5-45.4 4.4c-12.3 5.3-22.3 18.2-8.4 27.1c10.9 7 24.2 10.6 36.8 14c2.6 .7 5.2 1.4 7.8 2.1c17.3 4.9 39.5 11.2 56.1 22.6c21.6 14.8 31.7 38.8 26.9 64.6c-4.6 24.9-21.9 41.2-42.7 49.6c-8.7 3.5-18.1 5.7-28 6.9l0 16.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19.3c-16.1-3.6-31.9-8.8-47.5-13.9c-12.6-4.2-19.4-17.7-15.3-30.3s17.7-19.4 30.3-15.3c2.8 .9 5.6 1.9 8.4 2.8c12.6 4.3 25.4 8.6 38.3 10.6c18.9 2.8 34 1.1 43.9-2.9c13.4-5.4 19.6-21.2 6.6-30.1c-11.2-7.7-25.1-11.4-38.4-15c-2.5-.7-5-1.4-7.5-2.1c-16.8-4.7-37.7-10.7-53.5-20.8c-21.7-13.8-32.7-37-28-62.6c4.5-24.3 23.3-40.4 43.3-49c6.1-2.6 12.6-4.7 19.5-6.3V120c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M256 96c13.3 0 24 10.7 24 24v15.8c12.9 1.6 25.8 5.6 38.4 9.1c12.8 3.5 20.3 16.8 16.8 29.5s-16.8 20.3-29.5 16.7c-9.5-2.6-19-5.5-28.7-7.3c-14.6-2.8-31.6-1.5-45.4 4.4c-12.3 5.3-22.3 18.2-8.4 27.1c13.2 8.4 29.7 11.9 44.6 16.1c17.3 4.9 39.5 11.2 56.1 22.6c21.6 14.8 31.7 38.8 26.9 64.6c-4.6 24.9-21.9 41.2-42.7 49.6c-8.7 3.5-18.1 5.7-28 6.9l0 16.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19.3c-16.1-3.6-31.9-8.8-47.5-13.9c-12.6-4.2-19.4-17.7-15.3-30.3s17.7-19.4 30.3-15.3c15.2 5 30.9 11 46.7 13.4c18.9 2.8 34 1.1 43.9-2.9c13.4-5.4 19.6-21.2 6.6-30.1c-13.4-9.1-30.5-12.7-45.9-17.1c-16.8-4.7-37.7-10.7-53.5-20.8c-21.7-13.8-32.7-37-28-62.6c4.5-24.3 23.3-40.4 43.3-49c6.1-2.6 12.6-4.7 19.5-6.3V120c0-13.3 10.7-24 24-24z"]]
};
var faDollarCircle = faCircleDollar;
var faUsdCircle = faCircleDollar;
var faHorseHead = {
  prefix: 'fad',
  iconName: 'horse-head',
  icon: [640, 512, [], "f7ab", ["M306.8 348.1c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l-23.8-35.8z", "M64 464V316.9c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H112c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faArrowsRepeat = {
  prefix: 'fad',
  iconName: 'arrows-repeat',
  icon: [512, 512, ["repeat-alt"], "f364", ["M490.1 257.6c16.8 5.6 25.8 23.7 20.2 40.5C486.9 368.5 421 416 346.8 416H173.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L173.3 352H346.8c46.7 0 88.1-29.9 102.8-74.1c5.6-16.8 23.7-25.8 40.5-20.2z", "M21.9 254.4C5.1 248.8-3.9 230.6 1.6 213.9C25.1 143.5 91 96 165.2 96H338.7L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160H165.2c-46.7 0-88.1 29.9-102.8 74.1c-5.6 16.8-23.7 25.8-40.5 20.2z"]]
};
var faRepeatAlt = faArrowsRepeat;
var faBoreHole = {
  prefix: 'fad',
  iconName: 'bore-hole',
  icon: [512, 512, [], "e4c3", ["M48 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H384c-17.7 0-32 14.3-32 32V352c0 53-43 96-96 96s-96-43-96-96V160c0-17.7-14.3-32-32-32H48z", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V296.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32z"]]
};
var faIndustry = {
  prefix: 'fad',
  iconName: 'industry',
  icon: [576, 512, [], "f275", ["M64 32C46.3 32 32 46.3 32 64V304v48 80c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304 155.6L352 265.4v-50-5.3V155.6L160 265.4v-50-5.3V64c0-17.7-14.3-32-32-32H64z", "M372.8 116.1c6.6 11.5 2.6 26.2-8.9 32.7L160 265.4V210.1L340.1 107.2c11.5-6.6 26.2-2.6 32.7 8.9zm192 0c6.6 11.5 2.6 26.2-8.9 32.7L352 265.4V210.1L532.1 107.2c11.5-6.6 26.2-2.6 32.7 8.9z"]]
};
var faImagePolaroid = {
  prefix: 'fad',
  iconName: 'image-polaroid',
  icon: [448, 512, [], "f8c4", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H352c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32z", "M64 128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zm184 32c-5.3 0-10.2 2.6-13.2 6.9l-52.4 76.3-9.6-12.8c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4l-48 64c-3.6 4.8-4.2 11.3-1.5 16.8s8.3 8.8 14.3 8.8h48 48 40 88c5.9 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-88-128c-3-4.3-7.9-6.9-13.2-6.9zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faWaveTriangle = {
  prefix: 'fad',
  iconName: 'wave-triangle',
  icon: [640, 512, [], "f89a", ["M176 32c10.1 0 19.6 4.7 25.6 12.8L464 394.7 582.4 236.8c10.6-14.1 30.7-17 44.8-6.4s17 30.7 6.4 44.8l-144 192c-6 8.1-15.5 12.8-25.6 12.8s-19.6-4.7-25.6-12.8L176 117.3 57.6 275.2c-10.6 14.1-30.7 17-44.8 6.4s-17-30.7-6.4-44.8l144-192c6-8.1 15.5-12.8 25.6-12.8z", ""]]
};
var faPersonRunningFast = {
  prefix: 'fad',
  iconName: 'person-running-fast',
  icon: [512, 512, [], "e5ff", ["M16 95.8H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zM187.2 352l54.9-123.6L233.6 254c-9.3 28 1.7 58.8 26.8 74.5l5.7 3.6-24.6 55.4c-7.7 17.3-24.9 28.5-43.9 28.5H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h59.2zM0 175.8c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm16 48H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M368 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM259.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C198.4 108.3 228.2 96 259.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H458.7c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L334 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L382.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3z"]]
};
var faCircleDown = {
  prefix: 'fad',
  iconName: 'circle-down',
  icon: [512, 512, [61466, "arrow-alt-circle-down"], "f358", ["M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM135.1 294.6l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3H304V160c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32v96H150.3C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3z", "M242.2 394.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3H208V160c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v96h57.7c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5z"]]
};
var faArrowAltCircleDown = faCircleDown;
var faGrill = {
  prefix: 'fad',
  iconName: 'grill',
  icon: [448, 512, [], "e5a3", ["M106.1 352.8L129.2 299c14.4 6.7 29.7 12 45.6 15.6L151.8 368H296.2l-22.9-53.4c15.9-3.6 31.1-8.8 45.6-15.6l63.2 147.5c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L316.7 416H160s0 0 0 0c0-31.9-23.3-58.4-53.9-63.2z", "M40 32C17.9 32 0 49.9 0 72V96C0 219.7 100.3 320 224 320s224-100.3 224-224V72c0-22.1-17.9-40-40-40H40zM72 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 32 416a64 64 0 1 0 128 0z"]]
};
var faArrowsTurnToDots = {
  prefix: 'fad',
  iconName: 'arrows-turn-to-dots',
  icon: [512, 512, [], "e4c1", ["M262.6 281.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 352 96 352c-53 0-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448c0-17.7 14.3-32 32-32l146.7 0-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM448 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z", "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"]]
};
var faChartMixed = {
  prefix: 'fad',
  iconName: 'chart-mixed',
  icon: [512, 512, ["analytics"], "f643", ["M192 224c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32zM64 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32zm224 0V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32zm160-96c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32z", "M505 44c11 13.8 8.8 33.9-5 45L340 217c-11.4 9.1-27.5 9.4-39.2 .6L192.6 136.5 52 249c-13.8 11-33.9 8.8-45-5s-8.8-33.9 5-45L172 71c11.4-9.1 27.5-9.4 39.2-.6l108.2 81.1L460 39c13.8-11 33.9-8.8 45 5z"]]
};
var faAnalytics = faChartMixed;
var faFlorinSign = {
  prefix: 'fad',
  iconName: 'florin-sign',
  icon: [384, 512, [], "e184", ["M170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80l26.7-64zm42.7 64H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H240l-26.7 64z", "M226.1 91.1C241 55.3 275.9 32 314.7 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H314.7c-12.9 0-24.6 7.8-29.5 19.7L157.9 420.9C143 456.7 108.1 480 69.3 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H69.3c12.9 0 24.6-7.8 29.5-19.7L226.1 91.1z"]]
};
var faArrowDownShortWide = {
  prefix: 'fad',
  iconName: 'arrow-down-short-wide',
  icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", ["M288 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32z", "M128 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L160 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L63.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C110.5 476.2 119 480 128 480z"]]
};
var faSortAmountDesc = faArrowDownShortWide;
var faSortAmountDownAlt = faArrowDownShortWide;
var faLessThan = {
  prefix: 'fad',
  iconName: 'less-than',
  icon: [384, 512, [62774], "3c", ["M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z", ""]]
};
var faDisplayCode = {
  prefix: 'fad',
  iconName: 'display-code',
  icon: [576, 512, ["desktop-code"], "e165", ["M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z", "M64 64H512V352H64V64zM346.7 448H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416h96l10.7 32zM249 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM361 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"]]
};
var faDesktopCode = faDisplayCode;
var faFaceDrooling = {
  prefix: 'fad',
  iconName: 'face-drooling',
  icon: [512, 512, [], "e372", ["M384 477.8c76.5-44.3 128-127 128-221.8C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c33.9 0 66.4-6.6 96-18.6V370.9c-9.7 6.4-20.3 12.2-32 16.9V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V397.1c-10.1 1.9-20.8 2.9-32 2.9c-67 0-113.8-36.7-140.5-70c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5c22.8 28.5 61.3 58 115.5 58s92.7-29.5 115.5-58c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5c-3.8 4.7-7.9 9.5-12.5 14.2V477.8zM158.6 189.6c-8.4 8-13.5 17.7-15.4 23.5c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2c3.4-10.2 11.1-24.6 23.8-36.5C149.5 154.2 167.9 144 192 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-14.3 0-25.2 5.8-33.4 13.6zm210.2 23.5c-1.9-5.8-7-15.4-15.4-23.5c-8.2-7.8-19-13.6-33.4-13.6c-8.8 0-16-7.2-16-16s7.2-16 16-16c24.1 0 42.5 10.2 55.4 22.4c12.6 12 20.4 26.3 23.8 36.5c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1z", "M158.6 189.6c8.2-7.8 19.1-13.6 33.4-13.6c8.8 0 16-7.2 16-16s-7.2-16-16-16c-24.1 0-42.5 10.2-55.4 22.4c-12.6 12-20.4 26.3-23.8 36.5c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1c1.9-5.8 7-15.4 15.4-23.5zm194.8 0c8.4 8 13.5 17.7 15.4 23.5c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2c-3.4-10.2-11.1-24.6-23.8-36.5C362.5 154.2 344.1 144 320 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c14.3 0 25.2 5.8 33.4 13.6zM288 448c0 8.8 7.2 16 16 16s16-7.2 16-16V387.8c-9.9 4-20.6 7.2-32 9.3V448zm64 48c0 8.8 7.2 16 16 16s16-7.2 16-16V344.2c-9.1 9.4-19.7 18.6-32 26.8V496z"]]
};
var faOilTemperature = {
  prefix: 'fad',
  iconName: 'oil-temperature',
  icon: [576, 512, ["oil-temp"], "f614", ["M380 367.9c12.6-18.1 20-40.2 20-63.9c0-.4 0-.8 0-1.2c21.9-3.2 43.7-12.6 61.5-24.9l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 357.7 417 368 384 368c-1.4 0-2.7 0-4-.1zm-183.9 0c-1.3 0-2.7 .1-4 .1c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0c17.8 12.3 39.6 21.7 61.4 24.9c0 .4 0 .8 0 1.2c0 23.8 7.4 45.8 20 63.9zm110.5 54C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z", "M288 0c-17.7 0-32 14.3-32 32v96V230.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V160h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V64h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H288z"]]
};
var faOilTemp = faOilTemperature;
var faSquareQuestion = {
  prefix: 'fad',
  iconName: 'square-question',
  icon: [448, 512, ["question-square"], "f2fd", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm73.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H190.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M190.6 128c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H190.6zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faQuestionSquare = faSquareQuestion;
var faAirConditioner = {
  prefix: 'fad',
  iconName: 'air-conditioner',
  icon: [576, 512, [], "f8f4", ["M80 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 96V416c0 53-43 96-96 96s-96-43-96-96c0-35.6 19.4-66.6 48-83.1c15.3-8.9 34.9-3.6 43.7 11.7s3.6 34.9-11.7 43.7c-9.6 5.6-16 15.9-16 27.7c0 17.7 14.3 32 32 32s32-14.3 32-32V224h64zm64 0h64V384c0 17.7 14.3 32 32 32s32-14.3 32-32c0-11.8-6.4-22.2-16-27.7c-15.3-8.9-20.5-28.4-11.7-43.7s28.4-20.5 43.7-11.7c28.6 16.6 48 47.6 48 83.1c0 53-43 96-96 96s-96-43-96-96V224z", "M64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faAngleDown = {
  prefix: 'fad',
  iconName: 'angle-down',
  icon: [448, 512, [8964], "f107", ["M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z", ""]]
};
var faMountains = {
  prefix: 'fad',
  iconName: 'mountains',
  icon: [640, 512, [9968], "f6fd", ["M412.7 249.7l48.2-79C465 164.1 472.2 160 480 160s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1H456.1c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L412.7 249.7z", "M55.9 480H456.1c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1C0 455 25 480 55.9 480z"]]
};
var faOmega = {
  prefix: 'fad',
  iconName: 'omega',
  icon: [448, 512, [], "f67a", ["M224 96C135.6 96 64 167.6 64 256c0 56.4 29.1 106 73.3 134.5c13.3 8.6 22.7 23.7 22.7 41.2c0 26.7-21.6 48.3-48.3 48.3H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H67.2C25.8 375.4 0 318.7 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 62.7-25.8 119.4-67.2 160H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H336.3c-26.7 0-48.3-21.6-48.3-48.3c0-17.5 9.4-32.6 22.7-41.2C354.9 362 384 312.4 384 256c0-88.4-71.6-160-160-160z", ""]]
};
var faCarTunnel = {
  prefix: 'fad',
  iconName: 'car-tunnel',
  icon: [512, 512, [], "e4de", ["M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h42.8c-6.6-5.9-10.8-14.4-10.8-24V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6V488c0 9.6-4.2 18.1-10.8 24H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24V448H160v40c0 9.6-4.2 18.1-10.8 24H362.8z", "M198.4 272H313.6c3.5 0 6.5 2.2 7.6 5.5L335 320H177l13.8-42.5c1.1-3.3 4.1-5.5 7.6-5.5zm-53.3-9.3l-21 64.7C107.3 337.1 96 355.2 96 376V488c0 9.6 4.2 18.1 10.8 24h42.3c6.6-5.9 10.8-14.4 10.8-24V448H352v40c0 9.6 4.2 18.1 10.8 24h42.3c6.6-5.9 10.8-14.4 10.8-24V376c0-20.8-11.3-38.9-28.2-48.6l-21-64.7c-7.5-23.1-29-38.7-53.3-38.7H198.4c-24.3 0-45.8 15.6-53.3 38.7zM144 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faPersonDollyEmpty = {
  prefix: 'fad',
  iconName: 'person-dolly-empty',
  icon: [512, 512, [], "f4d1", ["M218.2 168.7c12.9-3.2 25.9 4.6 29.1 17.5l49.6 198.4c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1L351.4 456.9C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64c0-21.3 10.4-40.1 26.3-51.7L200.7 197.8c-3.2-12.9 4.6-25.9 17.5-29.1zM288 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM96 306.7V241.7l16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4h70.7l-16-64H161.1l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32v0V410.5l-64-64z"]]
};
var faPanFood = {
  prefix: 'fad',
  iconName: 'pan-food',
  icon: [640, 512, [129368], "e42b", ["M112 256a208 208 0 1 1 416 0 208 208 0 1 1 -416 0zM320 80c-37.2 0-69.3 26.3-76.6 62.8l-.6 3.2c-1.5 7.3 4.1 14 11.5 14H385.7c7.4 0 12.9-6.8 11.5-14l-.6-3.2C389.3 106.3 357.2 80 320 80zM243.3 268.7c-6.2-6.2-16.4-6.2-22.6 0l-8 8-8 8c-6.2 6.2-6.2 16.4 0 22.6c2.1 2.1 4.6 3.5 7.3 4.2c1.7 .4 3.4 .8 5.1 1.1c5.4 1.1 11 2.1 14.7 5.9l3.4 3.4c3 3 4.7 7.1 4.7 11.3V360c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56H269.3c-4.2 0-8.3-1.7-11.3-4.7l-3.4-3.4c-3.8-3.8-4.8-9.3-5.9-14.7c-.3-1.7-.7-3.5-1.1-5.1c-.7-2.7-2.1-5.2-4.2-7.3zM440 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM230.1 214.1c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0l-32 32c-7.8 7.8-7.8 20.5 0 28.3s20.5 7.8 28.3 0l32-32zM344 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm32.2 39.8c-4.5 4.5-4.5 11.9 0 16.4l2.4 2.4c13.7 13.7 32.4 21.4 51.8 21.4l4.1 0c14 0 27.6-4.8 38.5-13.5c14.6-11.7 23.1-29.4 23.1-48.1v-4.8c0-19-7.5-37.2-21-50.6l-2.8-2.8c-4.5-4.5-11.9-4.5-16.4 0l-79.6 79.6z", "M528 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM64 256a256 256 0 1 1 512 0A256 256 0 1 1 64 256zM48 184V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm568-24c13.3 0 24 10.7 24 24V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24zM230.1 214.1l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80.2 39.8l79.6-79.6c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6v4.8c0 18.7-8.5 36.4-23.1 48.1C462 299.2 448.4 304 434.4 304l-4.1 0c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4z"]]
};
var faHeadSideCough = {
  prefix: 'fad',
  iconName: 'head-side-cough',
  icon: [640, 512, [], "e061", ["M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416v16c0 26.5-21.5 48-48 48H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M592 288a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm128 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faGripLines = {
  prefix: 'fad',
  iconName: 'grip-lines',
  icon: [448, 512, [], "f7a4", ["M416 288c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0z", "M416 160c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0z"]]
};
var faThumbsDown = {
  prefix: 'fad',
  iconName: 'thumbs-down',
  icon: [512, 512, [128078, 61576], "f165", ["M351.1 422.6c5.2 26-11.7 51.3-37.7 56.5s-51.3-11.7-56.5-37.7L254.6 430c-6.6-33.2-24.8-63-51.2-84.2l-7.4-5.9c-22.8-18.2-36-45.8-36-75V240 192 153.7c0-32.1 16-62.1 42.7-79.9l38.5-25.7C257.1 37.6 275.6 32 294.5 32H392c26.5 0 48 21.5 48 48c0 3.6-.4 7-1.1 10.4C458.1 96.6 472 114.7 472 136c0 9.1-2.5 17.6-6.9 24.9c22.2 4.2 38.9 23.7 38.9 47.1c0 15.1-7 28.6-17.9 37.4c15.4 8 25.9 24.1 25.9 42.6c0 26.5-21.5 48-48 48H320c13.7 23.1 23.5 48.5 28.8 75.2l2.3 11.4z", "M0 352c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352z"]]
};
var faUserLock = {
  prefix: 'fad',
  iconName: 'user-lock',
  icon: [640, 512, [], "f502", ["M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3V480c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faArrowRightLong = {
  prefix: 'fad',
  iconName: 'arrow-right-long',
  icon: [512, 512, ["long-arrow-right"], "f178", ["M402.7 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0 32-32-32-32z", "M502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 256 329.4 150.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z"]]
};
var faLongArrowRight = faArrowRightLong;
var faTicketsAirline = {
  prefix: 'fad',
  iconName: 'tickets-airline',
  icon: [640, 512, [], "e29b", ["M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V272c0-8.8-7.4-15.7-15.7-18.6C605.5 246.9 592 229 592 208s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V96c0-35.3-28.7-64-64-64H160zM528 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM288.4 176l-23.2-69.5c-1.7-5.2 2.1-10.5 7.6-10.5H304c8.5 0 16.4 4.5 20.7 11.9L364.4 176h40.3c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5c-11.4 11.4-26.8 17.7-42.8 17.7H364.4l-39.7 68.1c-4.3 7.4-12.2 11.9-20.7 11.9H272.9c-5.5 0-9.3-5.3-7.6-10.5L288.4 240H245.8l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H200c-5.2 0-9-4.9-7.8-9.9l12.5-50.2c.6-2.5 .6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9h13.8c5 0 9.8 2.4 12.8 6.4L245.8 176h42.7z", "M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120zm240.4 56H245.8l-19.2-25.6c-3-4-7.8-6.4-12.8-6.4H200c-5.2 0-9 4.9-7.8 9.9l12.5 50.2c.6 2.5 .6 5.2 0 7.8l-12.5 50.2c-1.3 5 2.6 9.9 7.8 9.9h13.8c5 0 9.8-2.4 12.8-6.4L245.8 240h42.7l-23.2 69.5c-1.7 5.2 2.1 10.5 7.6 10.5H304c8.5 0 16.4-4.5 20.7-11.9L364.4 240h40.3c16.1 0 31.5-6.4 42.8-17.7c7.9-7.9 7.9-20.7 0-28.5c-11.4-11.4-26.8-17.7-42.8-17.7H364.4l-39.7-68.1C320.4 100.5 312.5 96 304 96H272.9c-5.5 0-9.3 5.3-7.6 10.5L288.4 176z"]]
};
var faAnchorCircleXmark = {
  prefix: 'fad',
  iconName: 'anchor-circle-xmark',
  icon: [640, 512, [], "e4ac", ["M288 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 32c0 33.4-17 62.8-42.9 80H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H320V368v80h19.2c12.6 24.7 30.9 46 53 62.2c-7.9 1.2-16 1.8-24.2 1.8H288 208c-88.4 0-160-71.6-160-160v-6.1l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56-56c9.4-9.4 24.6-9.4 33.9 0l56 56c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7V352c0 53 43 96 96 96h48V240H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h10.9C209 158.8 192 129.4 192 96c0-53 43-96 96-96s96 43 96 96z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faEllipsis = {
  prefix: 'fad',
  iconName: 'ellipsis',
  icon: [448, 512, ["ellipsis-h"], "f141", ["M168 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z", "M64 312a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm320 0a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]]
};
var faEllipsisH = faEllipsis;
var faNfcSlash = {
  prefix: 'fad',
  iconName: 'nfc-slash',
  icon: [640, 512, [], "e1fc", ["M406.2 416H208c-26.5 0-48-21.5-48-48V222.1L96 171.6V416c0 35.3 28.7 64 64 64H480c2.3 0 4.6-.1 6.9-.4L406.2 416zM192 247.3V368c0 8.8 7.2 16 16 16H365.5L192 247.3zM208 128c-3.3 0-6.4 1-8.9 2.7l103 80.7c.6-.3 1.3-.5 1.9-.7V144c0-26.5 21.5-48 48-48h80c26.5 0 48 21.5 48 48V350.9l64 50.2V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1l65.8 51.6c8.7-9 21-14.7 34.5-14.7h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H208zM448 325.8V144c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16v66.7c18.6 6.6 32 24.4 32 45.3c0 2.3-.2 4.6-.5 6.8L448 325.8z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faChessPawn = {
  prefix: 'fad',
  iconName: 'chess-pawn',
  icon: [320, 512, [9823], "f443", ["M256 432H64L22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432z", "M264 136c0 37.1-19.4 69.6-48.5 88H224c17.7 0 32 14.3 32 32c0 15.7-11.3 28.8-26.3 31.5L256 432H64L90.3 287.5C75.3 284.8 64 271.7 64 256c0-17.7 14.3-32 32-32h8.5C75.4 205.6 56 173.1 56 136C56 78.6 102.6 32 160 32s104 46.6 104 104z"]]
};
var faKitMedical = {
  prefix: 'fad',
  iconName: 'kit-medical',
  icon: [576, 512, ["first-aid"], "f479", ["M96 480h32V32H96V480zM448 32V480h32V32H448z", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H96V32H64zm64 0V480H448V32H128zM512 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480V480h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"]]
};
var faFirstAid = faKitMedical;
var faGrid2Plus = {
  prefix: 'fad',
  iconName: 'grid-2-plus',
  icon: [512, 512, [], "e197", ["M32 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zm0 256c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336zM336 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48z", "M408 296c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H296c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24V408h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H408V296z"]]
};
var faBells = {
  prefix: 'fad',
  iconName: 'bells',
  icon: [640, 512, [], "f77f", ["M230.8 245.5l18.7 51.2c11.7 31.8 12.9 66.5 3.5 99.1l-1.1 3.9L21.4 315.8C10 311.7 2 301.5 .6 289.5s4.1-23.8 14.3-30.4l8.2-5.4C57.6 231 84 197.8 98.2 159l14.7-40C138 50.4 214 15.1 282.6 40.1c4.8 1.7 9.4 3.7 13.9 6c-64.1 42.2-93.3 124.2-65.7 199.5zm30.1-10.9c-26.1-71.3 10.5-150.2 81.9-176.2s150.4 10.8 176.5 82.1L538 191.7c14 38.2 39.8 71 73.6 93.6l13.7 9.2c10 6.7 15.4 18.5 14 30.4s-9.5 22.1-20.8 26.2L321.1 459.4c-11.3 4.1-24 1.5-32.8-6.7s-12.3-20.7-9-32.2l4.6-15.8c11.2-39 9.7-80.7-4.3-118.9l-18.8-51.2z", "M211.9 419.5L94.3 376.1c-.3 2.5-.4 5-.4 7.5c0 35.5 28.9 64.3 64.5 64.3c22.3 0 41.9-11.3 53.5-28.4zM480.8 480c35.6 0 64.5-28.8 64.5-64.3c0-1.3 0-2.6-.1-3.9L429.1 454.1c11.8 15.7 30.6 25.9 51.7 25.9z"]]
};
var faPersonThroughWindow = {
  prefix: 'fad',
  iconName: 'person-through-window',
  icon: [640, 512, [], "e5a9", ["M352 73.8l0-9.8H288l0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10.2 1.6-20.1 4.7-29.5L341.4 497.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48h83.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z", "M64 64V384h64c0 17.7 14.3 32 32 32s32-14.3 32-32h73.5l42.7 64H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0H592c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H385.1l-42.7-64H576V64L352 64l-64 0L64 64z"]]
};
var faToolbox = {
  prefix: 'fad',
  iconName: 'toolbox',
  icon: [512, 512, [129520], "f552", ["M176 88v40H128V88c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56v40H336V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM0 320H128v32c0 17.7 14.3 32 32 32s32-14.3 32-32V320H320v32c0 17.7 14.3 32 32 32s32-14.3 32-32V320H512v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320z", "M0 320V234.5c0-17 6.7-33.3 18.7-45.3l42.5-42.5c12-12 28.3-18.7 45.3-18.7h299c17 0 33.3 6.7 45.3 18.7l42.5 42.5c12 12 18.7 28.3 18.7 45.3V320H384V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H192V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H0z"]]
};
var faEnvelopeDot = {
  prefix: 'fad',
  iconName: 'envelope-dot',
  icon: [576, 512, ["envelope-badge"], "e16f", ["M417.6 64c-1 5.2-1.6 10.5-1.6 16c0 39.3 28.3 72 65.7 78.7L275.2 313.6c-11.4 8.5-27 8.5-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112C0 85.5 21.5 64 48 64H417.6zM0 384V176L217.6 339.2c22.8 17.1 54 17.1 76.8 0L512 176V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z", "M416 80a80 80 0 1 1 160 0A80 80 0 1 1 416 80z"]]
};
var faEnvelopeBadge = faEnvelopeDot;
var faHandsHoldingCircle = {
  prefix: 'fad',
  iconName: 'hands-holding-circle',
  icon: [640, 512, [], "e4fb", ["M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z", "M320 0a128 128 0 1 0 0 256A128 128 0 1 0 320 0z"]]
};
var faBug = {
  prefix: 'fad',
  iconName: 'bug',
  icon: [512, 512, [], "f188", ["M256 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H323.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96zm0 480c5.4 0 10.7-.3 16-.8V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c5.3 .5 10.6 .8 16 .8z", "M86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c.7 .7 1.4 1.3 2.1 1.9c-6.2 12-10.1 25.3-11.1 39.5H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V240c0-8.8 7.2-16 16-16s16 7.2 16 16V479.2c34.5-3.4 65.8-17.8 90.3-39.6l63.1 63.1c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-1.9-1.9-3.9-3.4-6-4.8c9.9-20.8 15.4-44.1 15.4-68.6h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H415.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C345.2 164.1 329.1 160 312 160H200c-17.1 0-33.2 4.1-47.5 11.4c-.6-.7-1.2-1.4-1.9-2.1l-64-64z"]]
};
var faBowlChopsticks = {
  prefix: 'fad',
  iconName: 'bowl-chopsticks',
  icon: [512, 512, [], "e2e9", ["M18.5 125.1l473.8-74c11.3-1.8 19.7-11.5 19.7-23c0-14.6-13.3-25.6-27.6-22.9L13.1 93.6C5.5 95 0 101.6 0 109.3c0 9.8 8.8 17.3 18.5 15.8zm-2.7 18.4C7 143.8 0 151 0 159.7c0 9 7.3 16.2 16.2 16.2H488.4c13 0 23.6-10.6 23.6-23.6c0-13.3-11-24-24.4-23.6L15.7 143.5z", "M33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35H332.7c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5H33.6z"]]
};
var faCreditCard = {
  prefix: 'fad',
  iconName: 'credit-card',
  icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", ["M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z", "M576 224H0V128H576v96z"]]
};
var faCreditCardAlt = faCreditCard;
var faCircleS = {
  prefix: 'fad',
  iconName: 'circle-s',
  icon: [512, 512, [], "e121", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM207.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z", "M223 180.4c-10.3 4.1-14.2 9.6-15.4 15.8c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4c.7 .2 1.3 .4 2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4c-.7-.2-1.3-.4-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7l3.6-23.7-3.6 23.7c-20.3-3.1-36.8-1.4-47.8 2.9z"]]
};
var faBoxBallot = {
  prefix: 'fad',
  iconName: 'box-ballot',
  icon: [576, 512, [128499], "f735", ["M48 160h80v64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H448h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V160h80c26.5 0 48 21.5 48 48V320H0V208c0-26.5 21.5-48 48-48z", "M160 0H416c17.7 0 32 14.3 32 32V256H128V32c0-17.7 14.3-32 32-32zM32 512c-17.7 0-32-14.3-32-32V320H576V480c0 17.7-14.3 32-32 32H32z"]]
};
var faCar = {
  prefix: 'fad',
  iconName: 'car',
  icon: [512, 512, [128664, "automobile"], "f1b9", ["M165.4 96c-13.6 0-25.7 8.6-30.2 21.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4zM0 400v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V400H0zm512 0H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V400z", "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400H0V256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faAutomobile = faCar;
var faHandHoldingHand = {
  prefix: 'fad',
  iconName: 'hand-holding-hand',
  icon: [576, 512, [], "e4f7", ["M16.3 151.8c-17.8 13.1-21.6 38.1-8.5 55.9s38.1 21.6 55.9 8.5L183.4 128H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h64 16 78.3c29.1 0 57.3-9.9 80-28l44.9-36H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H384 223.5c-29 0-57.3 9.3-80.7 26.5L16.3 151.8zm366.1 8.3a.5 .5 0 1 1 .9-.1 .5 .5 0 1 1 -.9 .1z", "M559.7 360.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 384H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 352H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .1 .5 .5 0 1 1 .9-.1z"]]
};
var faUserTieHair = {
  prefix: 'fad',
  iconName: 'user-tie-hair',
  icon: [448, 512, [], "e45f", ["M176 112H120c-7.9 0-15.5-1.7-22.3-4.6C96.6 114.1 96 121 96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11-1.4-21.8-4-32H312c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112z", "M120 112c-7.9 0-15.5-1.7-22.3-4.6C107.5 46.5 160.3 0 224 0c59.6 0 109.8 40.8 124 96H312c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112H120zm89.1 247.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 39.5-161.2c77.2 12 136.3 78.8 136.3 159.4c0 17-13.8 30.7-30.7 30.7H265.1 182.9 30.7C13.8 512 0 498.2 0 481.3c0-80.6 59.1-147.4 136.3-159.4l39.5 161.2 33.4-123.9z"]]
};
var faPodiumStar = {
  prefix: 'fad',
  iconName: 'podium-star',
  icon: [448, 512, [], "f758", ["M137.3 512H310.7c32.6 0 60-24.5 63.6-56.9L403.6 192H44.4L73.7 455.1c3.6 32.4 31 56.9 63.6 56.9zm94-251.2l20.2 45.4c1.2 2.6 3.6 4.4 6.3 4.8l47.9 5.9c6.8 .8 9.5 9.5 4.5 14.3l-35.4 34c-2 2-3 4.9-2.4 7.7l9.4 49.1c1.3 6.9-5.8 12.3-11.8 8.9l-42.1-24.4c-2.4-1.4-5.4-1.4-7.8 0L178 430.9c-6 3.5-13.1-1.9-11.8-8.9l9.4-49.1c.5-2.8-.4-5.8-2.4-7.7l-35.4-34c-5-4.8-2.3-13.5 4.5-14.3l47.9-5.9c2.8-.3 5.2-2.1 6.3-4.8l20.2-45.4c2.9-6.4 11.7-6.4 14.5 0z", "M182.4 72H168c-22.1 0-40 17.9-40 40v32H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H80V112c0-48.6 39.4-88 88-88h14.4C190.7 9.7 206.2 0 224 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H224c-17.8 0-33.3-9.7-41.6-24z"]]
};
var faUserHairMullet = {
  prefix: 'fad',
  iconName: 'user-hair-mullet',
  icon: [448, 512, ["business-front", "party-back", "trian-balbot"], "e45c", ["M144 112h0c33.4 0 62.8-17 80-42.9C241.2 95 270.6 112 304 112h0 8 31.1c.6 5.2 .9 10.6 .9 16c0 70.7-49.3 128-120 128s-120-57.3-120-128c0-5.4 .3-10.8 .9-16H136h8z", "M144 112h0c33.4 0 62.8-17 80-42.9C241.2 95 270.6 112 304 112h0 8 32c8.8 0 16-7.2 16-16V94.8c0-9.1-5.1-17.4-13.3-21.5l-9.2-4.6C316.1 27.9 273.3 0 224 0c-48.4 0-90.5 26.8-112.2 66.4l-11.7 6.7C92.6 77.4 88 85.3 88 93.9V96c0 8.8 7.2 16 16 16h32 8zm196.1 49.9c-11.4 47.7-46.9 84.3-95.4 92.4L283 287.2c4.2 3.6 9.7 5.3 15.2 4.7s10.5-3.5 13.8-7.9l14-18.6 17.1 8.5c8.8 4.4 19.4 1.8 25.2-6.2s4.9-18.9-2.1-25.8c-13.9-13.9-19.7-24.7-22.7-37.4c-2.6-11-3.3-23.9-3.4-42.5zM204.5 254.5c-49.1-7.7-85-44.5-96.6-92.6c-.2 18.6-.8 31.5-3.4 42.5c-3 12.7-8.8 23.6-22.7 37.4c-6.9 6.9-7.8 17.9-2.1 25.8s16.4 10.6 25.2 6.2l17.1-8.5L136 284c3.3 4.4 8.2 7.2 13.6 7.9s10.9-1 15.1-4.5l39.8-32.9zM161.3 320C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320H161.3z"]]
};
var faBusinessFront = faUserHairMullet;
var faPartyBack = faUserHairMullet;
var faTrianBalbot = faUserHairMullet;
var faMicrophoneStand = {
  prefix: 'fad',
  iconName: 'microphone-stand',
  icon: [512, 512, [127908], "f8cb", ["M316.1 37.5L293.5 60.1 451.9 218.5l11.3-11.3 11.3-11.3L316.1 37.5zM41.4 502.6c11.9 11.9 30.9 12.6 43.6 1.6L371.4 255.9 256.1 140.6 7.8 427c-11 12.7-10.3 31.7 1.6 43.6l32 32z", "M479.2 32.8c43.7 43.7 43.7 114.7 0 158.4l-4.7 4.7L316.1 37.5l4.7-4.7c43.7-43.7 114.7-43.7 158.4 0zM293.5 60.1L451.9 218.5l-4.7 4.7c-21 21-48.3 31.9-75.8 32.8l0 0L256.1 140.6l0 0c.8-27.5 11.7-54.8 32.8-75.8l4.7-4.7zM224 480V383.7l64-55.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]]
};
var faBookOpenReader = {
  prefix: 'fad',
  iconName: 'book-open-reader',
  icon: [512, 512, ["book-reader"], "f5da", ["", "M256 0a96 96 0 1 0 0 192A96 96 0 1 0 256 0zM240 512V248c-52.1-36.4-114.1-56-177.7-56H32c-17.7 0-32 14.3-32 32V427c0 16.4 12.5 30.2 28.8 31.8l96 9.6c23.2 2.3 45.9 8.9 66.8 19.3L240 512zm32 0l48.4-24.2c20.9-10.4 43.5-17 66.8-19.3l96-9.6c16.4-1.6 28.8-15.4 28.8-31.8V224c0-17.7-14.3-32-32-32H449.7c-63.6 0-125.6 19.6-177.7 56V512z"]]
};
var faBookReader = faBookOpenReader;
var faFamilyDress = {
  prefix: 'fad',
  iconName: 'family-dress',
  icon: [512, 512, [], "e301", ["M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM112.3 160h31.4c11.8 0 23 3.2 32.6 8.9c-.2 2.3-.3 4.7-.3 7.1c0 24.3 10.9 46.1 28 60.8c-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1 .8 11.9 2.4 17.5c-8.7 9-20.9 14.5-34.4 14.5H112c-26.5 0-48-21.5-48-48V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4c7.8-27.5 33-46.4 61.5-46.4zM368 512c-13.5 0-25.7-5.6-34.4-14.5c1.6-5.5 2.4-11.4 2.4-17.5V423.6c19.6-17.6 32-43.1 32-71.6V336c0-43.1-24.3-80.5-60-99.2c17.1-14.7 28-36.5 28-60.8c0-2.4-.1-4.8-.3-7.1c9.6-5.7 20.8-8.9 32.6-8.9h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48H368zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0z", "M208 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM176 336c0-44.2 35.8-80 80-80s80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V407.4c-19.1-11.1-32-31.7-32-55.4V336z"]]
};
var faCircleX = {
  prefix: 'fad',
  iconName: 'circle-x',
  icon: [512, 512, [], "e12e", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.3 136.5L256 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L287.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L256 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L224.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z", "M152.5 133.7c10.1-8.6 25.3-7.3 33.8 2.8L256 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L287.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L256 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L224.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8z"]]
};
var faCabin = {
  prefix: 'fad',
  iconName: 'cabin',
  icon: [512, 512, [], "e46d", ["M32 280c0-13.3 10.7-24 24-24H168c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V280zm24 72H168c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24zm0 96H168c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V472c0-13.3 10.7-24 24-24zM344 256H456c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V280c0-13.3 10.7-24 24-24zM320 472c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V472zm24-120H456c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24z", "M237.4 6C248.5-2 263.5-2 274.6 6L384 84.1V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v88.7L498.6 166c11.3 8.1 16.1 22.6 11.9 35.8S493.9 224 480 224H448 416 32c-13.9 0-26.2-9-30.5-22.2S2.1 174 13.4 166L237.4 6zM256 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faMountainSun = {
  prefix: 'fad',
  iconName: 'mountain-sun',
  icon: [640, 512, [], "e52f", ["M480 80a80 80 0 1 1 160 0A80 80 0 1 1 480 80z", "M381.1 512H55.9C25 512 0 487 0 456.1c0-10.5 3-20.8 8.6-29.7L225.2 81c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7 48.2-79C465 196.1 472.2 192 480 192s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1H456.1h-75z"]]
};
var faChartSimpleHorizontal = {
  prefix: 'fad',
  iconName: 'chart-simple-horizontal',
  icon: [448, 512, [], "e474", ["M400 320c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 192c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l352 0z", "M384 112c0 26.5-21.5 48-48 48L48 160c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l288 0c26.5 0 48 21.5 48 48l0 32zM256 432c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32z"]]
};
var faBluetooth = {
  prefix: 'fad',
  iconName: 'bluetooth',
  icon: [384, 512, [], "f293", ["M178.8 2.9c11.4-5.2 24.8-3.2 34.3 5.1l128 112C348 126 352 134.8 352 144s-4 18-10.9 24.1L240.6 256l100.5 87.9C348 350 352 358.8 352 368s-4 18-10.9 24.1l-128 112c-9.4 8.3-22.9 10.2-34.3 5.1S160 492.6 160 480V326.5L85.1 392.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2L143.4 256 42.9 168.1c-13.3-11.6-14.6-31.9-3-45.2s31.9-14.6 45.2-3L160 185.5V32c0-12.6 7.3-24 18.8-29.1zM224 326.5v83L271.4 368 224 326.5zm0-141L271.4 144 224 102.5v83z", ""]]
};
var faArrowsLeftRightToLine = {
  prefix: 'fad',
  iconName: 'arrows-left-right-to-line',
  icon: [640, 512, [], "e4ba", ["M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96zm576 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96z", "M246.6 137.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0z"]]
};
var faHandBackPointLeft = {
  prefix: 'fad',
  iconName: 'hand-back-point-left',
  icon: [512, 512, [], "e19f", ["M0 184c0-22.1 17.9-40 40-40l200 0h7l73 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-55.7 0c1.4-2 3-3.9 4.5-5.8l16-19.2C297 72.4 315 64 334 64L372 64c38 0 74 16.9 98.3 46.1l4.5 5.4c24 28.8 37.1 65 37.1 102.4V336c0 70.7-57.3 128-128 128l-64 0H288c-26.5 0-48-21.5-48-48c0-12.4 4.7-23.6 12.3-32.1C227.5 382 208 361.3 208 336c0-12.4 4.7-23.6 12.3-32.1C195.5 302 176 281.3 176 256c0-12.3 4.6-23.5 12.2-32L40 224c-22.1 0-40-17.9-40-40z", ""]]
};
var faMessageDots = {
  prefix: 'fad',
  iconName: 'message-dots',
  icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM128 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M96 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faCommentAltDots = faMessageDots;
var faMessaging = faMessageDots;
var faFileHeart = {
  prefix: 'fad',
  iconName: 'file-heart',
  icon: [384, 512, [], "e176", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM80 301.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9C107.4 240 80 267.4 80 301.3z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zM80 301.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 344.6C86.5 333.1 80 317.5 80 301.3z"]]
};
var faBeerMug = {
  prefix: 'fad',
  iconName: 'beer-mug',
  icon: [512, 512, ["beer-foam"], "e0b3", ["M32 163.2V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64v-2.3l82.4-36.6c27.7-12.3 45.6-39.8 45.6-70.2V236.8c0-42.4-34.4-76.8-76.8-76.8H389.1c-15.2 10.1-33.5 16-53.1 16c-18.7 0-36.2-5.4-51-14.7c-20 19-47.2 30.7-77 30.7s-57-11.7-77-30.7C116.2 170.6 98.7 176 80 176c-17.5 0-33.9-4.7-48-12.8zM295.5 64c-5.5 1.1-10.9 1.4-15.8 1c-2.4-.2-4.9-.5-7.5-1H143.8c-2.6 .5-5.1 .9-7.5 1c-5 .4-10.4 .1-15.8-1H96c-18.9 0-35.9 8.2-47.6 21.2C50.9 100.4 64.1 112 80 112c7.3 0 14-2.4 19.3-6.5c11.6-8.8 25.4-11.4 37-10.5c11.6 .8 25.5 5.4 35.9 17c8.8 9.9 21.6 16 35.8 16s27-6.1 35.8-16c10.3-11.6 24.3-16.2 35.9-17c11.6-.8 25.4 1.7 37 10.5c5.4 4.1 12 6.5 19.3 6.5c15.9 0 29.1-11.6 31.6-26.8C355.9 72.2 338.9 64 320 64H295.5zM384 224h51.2c7.1 0 12.8 5.7 12.8 12.8V338.9c0 5.1-3 9.6-7.6 11.7L384 375.6V224zm-240 0c8.8 0 16 7.2 16 16V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16z", "M267.7 133.3c6.9-7.7 21.4-8.6 29.6-2.3c10.8 8.2 24.2 13 38.7 13c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.6 0-28 4.9-38.7 13c-8.2 6.3-22.7 5.4-29.6-2.3C253 10.3 231.7 0 208 0s-45 10.3-59.7 26.7c-6.9 7.7-21.4 8.6-29.6 2.3C108 20.9 94.6 16 80 16C44.7 16 16 44.7 16 80s28.7 64 64 64c14.6 0 28-4.9 38.7-13c8.2-6.3 22.7-5.4 29.6 2.3C163 149.7 184.3 160 208 160s45-10.3 59.7-26.7zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]]
};
var faBeerFoam = faBeerMug;
var faDiceD20 = {
  prefix: 'fad',
  iconName: 'dice-d20',
  icon: [512, 512, [], "f6cf", ["M47.9 98.8L189.9 1.4c1.4-.9 3-1.4 4.6-1.4c6.2 0 10.1 6.7 7.1 12.1L124.1 151.7c-4.4 7.9-14.5 10.6-22.2 5.9L48.7 125.8c-10-6-10.4-20.3-.8-26.9zM317.5 0c1.6 0 3.3 .5 4.6 1.4L464.1 98.8c9.6 6.6 9.2 20.9-.8 26.9l-53.2 31.9c-7.8 4.7-17.8 2-22.2-5.9L310.4 12.1c-3-5.4 .9-12.1 7.1-12.1zm20.1 176H174.4c-12.2 0-19.9-13.1-14-23.8l80-144c2.8-5.1 8.2-8.2 14-8.2h3.2c5.8 0 11.2 3.2 14 8.2l80 144c5.9 10.7-1.8 23.8-14 23.8z", "M40.2 158C29.6 151.6 16 159.3 16 171.7V295.3c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158zm431.5 0l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7c0-12.4-13.6-20.1-24.2-13.7zM464 433.1c0-9.3-8.1-16.5-17.3-15.4L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5zM240 505.2V452.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4c3.7 0 6.8-3 6.8-6.8zM30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2zm439.5 24.5c11.8-1.4 18-14.7 11.5-24.6L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20zm-222-13.6c3.7 6.4 13 6.4 16.7 0l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H183.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2z"]]
};
var faDrone = {
  prefix: 'fad',
  iconName: 'drone',
  icon: [512, 512, [], "f85f", ["M213.3 159.9c6.9-14.5 10.7-30.8 10.7-47.9C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c17.2 0 33.4-3.9 47.9-10.7l-29.9-39.8c-5.7 1.7-11.8 2.6-18.1 2.6c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 6.3-.9 12.3-2.6 18.1l39.8 29.9zm138.8 53.3c14.5 6.9 30.8 10.7 47.9 10.7c61.9 0 112-50.1 112-112S461.9 0 400 0S288 50.1 288 112c0 17.2 3.9 33.4 10.7 47.9l39.8-29.9c-1.7-5.7-2.6-11.8-2.6-18.1c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-6.3 0-12.3-.9-18.1-2.6l-29.9 39.8zM298.7 352.1C291.9 366.6 288 382.8 288 400c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112c-17.2 0-33.4 3.9-47.9 10.7l29.9 39.8c5.7-1.7 11.8-2.6 18.1-2.6c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-6.3 .9-12.3 2.6-18.1l-39.8-29.9zM159.9 298.7C145.4 291.9 129.2 288 112 288C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-17.2-3.9-33.4-10.7-47.9l-39.8 29.9c1.7 5.7 2.6 11.8 2.6 18.1c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c6.3 0 12.3 .9 18.1 2.6l29.9-39.8z", "M80 112c0 16.2 12.1 29.7 27.8 31.7L160 213.3v85.3l-52.2 69.6C92.1 370.3 80 383.8 80 400c0 17.7 14.3 32 32 32c16.2 0 29.7-12.1 31.7-27.8L213.3 352h85.3l69.6 52.2c2.1 15.7 15.5 27.8 31.7 27.8c17.7 0 32-14.3 32-32c0-16.2-12.1-29.7-27.8-31.7L352 298.7V213.3l52.2-69.6c15.7-2.1 27.8-15.5 27.8-31.7c0-17.7-14.3-32-32-32c-16.2 0-29.7 12.1-31.7 27.8L298.7 160H213.3l-69.6-52.2C141.7 92.1 128.2 80 112 80c-17.7 0-32 14.3-32 32z"]]
};
var faTruckDroplet = {
  prefix: 'fad',
  iconName: 'truck-droplet',
  icon: [640, 512, [], "e58c", ["M280 190c0 36.5-32.2 66-72 66s-72-29.6-72-66c0-27 39.4-82.9 59.9-110.3c6.1-8.2 18.1-8.2 24.2 0C240.6 107 280 163 280 190zM96 432a80 80 0 1 1 160 0A80 80 0 1 1 96 432zm368-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576h-1.1c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H286.9c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zm-208 0c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 107 136 163 136 190c0 36.5 32.2 66 72 66z"]]
};
var faFileCircleXmark = {
  prefix: 'fad',
  iconName: 'file-circle-xmark',
  icon: [576, 512, [], "e5a1", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faTemperatureArrowUp = {
  prefix: 'fad',
  iconName: 'temperature-arrow-up',
  icon: [576, 512, ["temperature-up"], "e040", ["M176 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C102.2 332.6 96 349.5 96 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM64 112C64 50.2 114.1 0 176 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S32 447.5 32 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M480 160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V160zM224 368c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48z"]]
};
var faTemperatureUp = faTemperatureArrowUp;
var faMedal = {
  prefix: 'fad',
  iconName: 'medal',
  icon: [512, 512, [127941], "f5a2", ["M124.6 218.9L4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0H133.9c11.2 0 21.7 5.9 27.4 15.5L248 160l-.4 .2c-48.9 2.3-92.5 24.5-123 58.7zm262.8 0c-30.5-34.2-74.2-56.4-123-58.7l-.4-.2L350.7 15.5C356.5 5.9 366.9 0 378.1 0H487.4C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6L387.4 218.9z", "M256 512a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm30.8-225.5c1.4 2.8 4 4.7 7 5.1l50.1 7.3c7.7 1.1 10.7 10.5 5.2 16l-36.3 35.4c-2.2 2.2-3.2 5.2-2.7 8.3l8.6 49.9c1.3 7.6-6.7 13.5-13.6 9.9l-44.8-23.6c-2.7-1.4-6-1.4-8.7 0l-44.8 23.6c-6.9 3.6-14.9-2.2-13.6-9.9l8.6-49.9c.5-3-.5-6.1-2.7-8.3l-36.3-35.4c-5.6-5.4-2.5-14.8 5.2-16l50.1-7.3c3-.4 5.7-2.4 7-5.1l22.4-45.4c3.4-7 13.3-7 16.8 0l22.4 45.4z"]]
};
var faBed = {
  prefix: 'fad',
  iconName: 'bed',
  icon: [640, 512, [128716], "f236", ["M176 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm112 32c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96v64 32H608 320 288V288 160z", "M32 32c17.7 0 32 14.3 32 32V320H608h32v32 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32z"]]
};
var faBookCopy = {
  prefix: 'fad',
  iconName: 'book-copy',
  icon: [576, 512, [], "e0be", ["M160 96H96C43 96 0 139 0 192V416c0 53 43 96 96 96H320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 272 96c-17.7 0-32-14.3-32-32s14.3-32 32-32h74.8c-6.9-14.5-10.8-30.8-10.8-48V96z", "M288 0c-53 0-96 43-96 96V320c0 53 43 96 96 96H512h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H512 288zm0 288H480v64H288c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]]
};
var faSquareH = {
  prefix: 'fad',
  iconName: 'square-h',
  icon: [448, 512, ["h-square"], "f0fd", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM336 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M312 128c13.3 0 24 10.7 24 24l0 104V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24z"]]
};
var faHSquare = faSquareH;
var faSquareC = {
  prefix: 'fad',
  iconName: 'square-c',
  icon: [448, 512, [], "e266", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM167.4 199.4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0z", "M280.6 199.4c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"]]
};
var faClockTwo = {
  prefix: 'fad',
  iconName: 'clock-two',
  icon: [512, 512, [], "e35a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392v91.2L338.7 172c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256V120c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M256 96c13.3 0 24 10.7 24 24v91.2L338.7 172c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256V120c0-13.3 10.7-24 24-24z"]]
};
var faSquareEllipsisVertical = {
  prefix: 'fad',
  iconName: 'square-ellipsis-vertical',
  icon: [448, 512, [], "e26f", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M192 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faCalendarUsers = {
  prefix: 'fad',
  iconName: 'calendar-users',
  icon: [640, 512, [], "e5e2", ["M192 32V64H144c-26.5 0-48 21.5-48 48v48h32H512h32V112c0-26.5-21.5-48-48-48H448V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H256V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm55.4 480H392.6c-5.4-9.4-8.6-20.3-8.6-32c0-43.8 29.4-80.8 69.6-92.3c-23-20.5-37.6-50.4-37.6-83.7c0-56.4 41.7-103.1 96-110.9V192H128v1.1c54.3 7.8 96 54.4 96 110.9c0 33.3-14.5 63.2-37.6 83.7C226.6 399.2 256 436.2 256 480c0 11.7-3.1 22.6-8.6 32z", "M32 304a80 80 0 1 1 160 0A80 80 0 1 1 32 304zM0 480c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 304a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM416 480c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32z"]]
};
var faPodcast = {
  prefix: 'fad',
  iconName: 'podcast',
  icon: [448, 512, [], "f2ce", ["M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1c.1 .3 .1 .6 .2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1c.1-.4 .1-.7 .2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9z", "M224 168a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM160 355.8c0-35.1 31.1-43.8 64-43.8s64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8z"]]
};
var faBee = {
  prefix: 'fad',
  iconName: 'bee',
  icon: [576, 512, [], "e0b2", ["M208.5 120.9c-22-15.6-50-24.9-80.5-24.9C57.3 96 0 146.1 0 208s57.3 112 128 112c5.8 0 11.5-.3 17.1-1c-.7-5-1.1-10-1.1-15c0-60.3 37-111.9 89.6-133.4c-13.7-12.7-22.9-30.2-25.1-49.7zm133.9 49.7C395 192.1 432 243.7 432 304c0 5-.4 10-1.1 15c5.6 .6 11.3 1 17.1 1c70.7 0 128-50.1 128-112s-57.3-112-128-112c-30.5 0-58.5 9.3-80.5 24.9c-2.2 19.6-11.4 37-25.1 49.7z", "M196.7 4.7c6.2-6.2 16.4-6.2 22.6 0l34.8 34.8C264.4 34.7 275.9 32 288 32s23.6 2.7 33.9 7.5L356.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L347.8 58.8C360.4 73 368 91.6 368 112c0 23.2-9.8 44-25.6 58.6c37.9 15.5 67.7 46.6 81.4 85.4H152.2c13.7-38.8 43.5-69.9 81.4-85.4C217.8 156 208 135.2 208 112c0-20.4 7.6-39 20.2-53.2L196.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zM144 304c0-5.4 .3-10.7 .9-16H431.1c.6 5.3 .9 10.6 .9 16c0 10.5-1.6 21.3-4.6 32H148.6c-2.9-10.7-4.6-21.5-4.6-32zm45.9 112c-11.1-15.2-21.3-31.4-29.2-48H415.3c-8 16.6-18.1 32.8-29.2 48H189.9zm84 90.8c-10.8-9.4-34.3-30.9-58.5-58.8H360.6c-24.2 27.9-47.8 49.4-58.5 58.8c-3.9 3.4-8.9 5.2-14.1 5.2s-10.2-1.8-14.1-5.2z"]]
};
var faTemperatureFull = {
  prefix: 'fad',
  iconName: 'temperature-full',
  icon: [320, 512, ["temperature-4", "thermometer-4", "thermometer-full"], "f2c7", ["M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M176 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112z"]]
};
var faTemperature4 = faTemperatureFull;
var faThermometer4 = faTemperatureFull;
var faThermometerFull = faTemperatureFull;
var faBell = {
  prefix: 'fad',
  iconName: 'bell',
  icon: [448, 512, [128276, 61602], "f0f3", ["M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32z", "M288 448c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0h64z"]]
};
var faCandyBar = {
  prefix: 'fad',
  iconName: 'candy-bar',
  icon: [640, 512, [127851, "chocolate-bar"], "e3e8", ["M288 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H288V64z", "M0 224v96H128V224H0zM0 352v32c0 35.3 28.7 64 64 64h64V352H0zm160 96H288V352H160v96zM288 320V224H160v96H288zm0-128V64H160V192H288zM44.2 192H96v0h32V160h0V108.2c0-7.1-9-11.1-15-7.4C101 107.9 87 112 72 112c-4 0-7.9-.3-11.7-.9c-7-1-14.2 6.2-13.1 13.1c.6 3.8 .9 7.7 .9 11.7c0 15-4.1 29-11.3 41c-3.6 6.1 .4 15 7.4 15z"]]
};
var faChocolateBar = faCandyBar;
var faXmarkLarge = {
  prefix: 'fad',
  iconName: 'xmark-large',
  icon: [448, 512, [], "e59b", ["M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256 438.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0L224 210.7 393.4 41.4z", ""]]
};
var faPinata = {
  prefix: 'fad',
  iconName: 'pinata',
  icon: [512, 512, [], "e3c3", ["M400 435.2V400H224v35.2l-7.4 4.9c-9.6 6.4-21.8 7.1-32.1 2L168 433.9l-17.7 8.8c-9 4.5-19.6 4.5-28.6 0l-9.7-4.8V402.1l24 12 17.7-8.8c9-4.5 19.6-4.5 28.6 0l16.5 8.3 16.3-10.9c2.6-1.8 5.7-2.7 8.9-2.7H400c3.2 0 6.2 .9 8.9 2.7l16.3 10.9 16.5-8.3c9-4.5 19.6-4.5 28.6 0l17.7 8.8 24-12v35.8l-9.7 4.8c-9 4.5-19.6 4.5-28.6 0L456 433.9l-16.5 8.3c-10.3 5.1-22.5 4.4-32.1-2l-7.4-4.9zM512 317.2v34.5l-11.4 4.6c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-2.4-1.2V318.1l16.7 8.4 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 23.3-9.3zM240 198.1V224h19.8l-76.8 38.4c-14.1 7-30.5 7.8-45.1 2.2L112 254.7V224L38.8 192.6c-1.5-.6-2.9-1.3-4.3-2.1l114.8 44.2c6.3 2.4 13.3 2.1 19.3-.9L240 198.1z", "M112 318.1V254.7l25.8 9.9c14.7 5.6 31.1 4.9 45.1-2.2L259.8 224H288 432c44.2 0 80 35.8 80 80v13.2l-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7L112 318.1zm0 35.8l2.4 1.2c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l11.4-4.6v50.5l-24 12-17.7-8.8c-9-4.5-19.6-4.5-28.6 0l-16.5 8.3-16.3-10.8c-2.6-1.8-5.7-2.7-8.9-2.7H224c-3.2 0-6.2 .9-8.9 2.7l-16.3 10.8-16.5-8.3c-9-4.5-19.6-4.5-28.6 0L136 414.1l-24-12V353.9zm37.3-119.2L34.4 190.6C13.4 179.6 0 157.8 0 133.8V128C0 92.7 28.7 64 64 64H176V32c0-17.7 14.3-32 32-32s32 14.3 32 32V198.1l-71.4 35.7c-6 3-13.1 3.4-19.3 .9zM112 437.9l9.7 4.8c9 4.5 19.6 4.5 28.6 0l17.7-8.8 16.5 8.3c10.3 5.1 22.5 4.4 32.1-2l7.4-4.9V480c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V437.9zm288-2.7l7.4 4.9c9.6 6.4 21.8 7.1 32.1 2l16.5-8.3 17.7 8.8c9 4.5 19.6 4.5 28.6 0l9.7-4.8V480c0 17.7-14.3 32-32 32H432c-17.7 0-32-14.3-32-32V435.2zM200 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]]
};
var faArrowsFromLine = {
  prefix: 'fad',
  iconName: 'arrows-from-line',
  icon: [448, 512, [], "e0a4", ["M0 256c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224c-17.7 0-32 14.3-32 32z", "M201.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H256v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l64-64zM192 384V352c0-17.7 14.3-32 32-32s32 14.3 32 32v32h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32z"]]
};
var faSuperscript = {
  prefix: 'fad',
  iconName: 'superscript',
  icon: [512, 512, [], "f12b", ["M0 96C0 78.3 14.3 64 32 64H64c10.4 0 20.2 5.1 26.2 13.6L176 200.2 261.8 77.6c6-8.6 15.8-13.6 26.2-13.6h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H304.7L215.1 256l89.6 128H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c-10.4 0-20.2-5.1-26.2-13.6L176 311.8 90.2 434.4C84.2 442.9 74.4 448 64 448H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H47.3l89.6-128L47.3 128H32C14.3 128 0 113.7 0 96z", "M464.8 4.8C474.3 10.6 480 20.9 480 32V160c17.7 0 32 14.3 32 32s-14.3 32-32 32H448 416c-17.7 0-32-14.3-32-32s14.3-32 32-32V80c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l32-16c9.9-5 21.7-4.4 31.1 1.4z"]]
};
var faBowlSpoon = {
  prefix: 'fad',
  iconName: 'bowl-spoon',
  icon: [512, 512, [129379], "e3e0", ["M217.6 128c-15.4 37.3-56.9 64-105.6 64C50.1 192 0 149 0 96S50.1 0 112 0c48.8 0 90.3 26.7 105.6 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H217.6z", "M33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35H332.7c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5H33.6z"]]
};
var faHexagonCheck = {
  prefix: 'fad',
  iconName: 'hexagon-check',
  icon: [512, 512, [], "e416", ["M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faPlugCircleXmark = {
  prefix: 'fad',
  iconName: 'plug-circle-xmark',
  icon: [576, 512, [], "e560", ["M128 32v96H64V32C64 14.3 78.3 0 96 0s32 14.3 32 32zm192 0v96H256V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V412.8C87 398 32 333.4 32 256V224c-17.7 0-32-14.3-32-32z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faStarOfLife = {
  prefix: 'fad',
  iconName: 'star-of-life',
  icon: [512, 512, [], "f621", ["M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z", ""]]
};
var faPhoneSlash = {
  prefix: 'fad',
  iconName: 'phone-slash',
  icon: [640, 512, [], "f3dd", ["M325.7 343.7l-91.3 72C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3zM64 64c0 107.4 37.8 206 100.8 283.1L253 278c-17.8-21.5-32.9-45.2-45-70.7L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64z", "M634.9 9.2c-8.2-10.4-23.3-12.3-33.7-4.1l-592 464c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7z"]]
};
var faTrafficLightStop = {
  prefix: 'fad',
  iconName: 'traffic-light-stop',
  icon: [320, 512, [], "f63a", ["M160 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]]
};
var faPaintRoller = {
  prefix: 'fad',
  iconName: 'paint-roller',
  icon: [512, 512, [], "f5aa", ["M512 160c0-53-43-96-96-96v64c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H272c-44.2 0-80 35.8-80 80v16c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V304c0-8.8 7.2-16 16-16H416c53 0 96-43 96-96V160z", "M64 0C28.7 0 0 28.7 0 64v64c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"]]
};
var faAccentGrave = {
  prefix: 'fad',
  iconName: 'accent-grave',
  icon: [192, 512, [], "60", ["M108.3 204.8L41.2 95c-6-9.8-9.2-21.2-9.2-32.7C32 28.1 59.7 0 93.9 0c29.2 0 54.4 20.4 60.6 49l27.1 126.6C187 200.5 168 224 142.5 224c-14 0-26.9-7.3-34.2-19.2z", ""]]
};
var faHandshakeAngle = {
  prefix: 'fad',
  iconName: 'handshake-angle',
  icon: [640, 512, ["hands-helping"], "f4c4", ["M534.6 260.7c-6 6-14.1 9.4-22.6 9.4h-4.5c2.9-6.8 4.5-14.2 4.5-22.1c0-30.9-25.1-56-56-56H320v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V137.1 128h.6c4.5-36.1 35.3-64 72.6-64H416l.8 0 39.6-39.6c21.9-21.9 57.3-21.9 79.2 0l78.1 78.1c21.9 21.9 21.9 57.3 0 79.2l-79 79z", "M218.2 128c-38.4 0-73.1 22.9-88.2 58.2L101 253.7 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1H384c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16H432c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.8-5 45.2-27.7 45.2-55c0-30.9-25.1-56-56-56H320v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V128h-5.8z"]]
};
var faHandsHelping = faHandshakeAngle;
var faCircle0 = {
  prefix: 'fad',
  iconName: 'circle-0',
  icon: [512, 512, [], "e0ed", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48V224c0-26.5-21.5-48-48-48s-48 21.5-48 48z", "M160 224c0-53 43-96 96-96s96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224zm96-48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48V224c0-26.5-21.5-48-48-48z"]]
};
var faDialMedLow = {
  prefix: 'fad',
  iconName: 'dial-med-low',
  icon: [576, 512, [], "e160", ["M256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M158.9 192.4c-46.2 62.6-41 151.3 15.7 208c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-56.7-56.7-145.4-62-208-15.7L304.7 270.4c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L158.9 192.4z"]]
};
var faLocationDot = {
  prefix: 'fad',
  iconName: 'location-dot',
  icon: [384, 512, ["map-marker-alt"], "f3c5", ["M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M192 144a48 48 0 1 0 0 96 48 48 0 1 0 0-96z"]]
};
var faMapMarkerAlt = faLocationDot;
var faCrab = {
  prefix: 'fad',
  iconName: 'crab',
  icon: [512, 512, [129408], "e3ff", ["M208 128c-8.8 0-16 7.2-16 16v49c5.2-.7 10.6-1 16-1h16V144c0-8.8-7.2-16-16-16zM89.3 272H51.8L23.2 257.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l32 16c2.2 1.1 4.7 1.7 7.2 1.7H81c1.4-11.2 4.2-21.9 8.3-32zM80 329.8l-21.1 7c-2.4 .8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L72.6 366l28-9.3L80 336v-6.2zm51.4 57.5L90.9 400.8c-2.4 .8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L104.6 430l52-17.3-25.3-25.3zm41 41l-36.6 21.9c-4.8 2.9-7.8 8.1-7.8 13.7v32c0 8.8 7.2 16 16 16s16-7.2 16-16V473.1L201.8 448H192l-19.7-19.7zM310.2 448L352 473.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V464c0-5.6-3-10.8-7.8-13.7l-36.6-21.9L320 448h-9.8zm45.1-35.4l52 17.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-40.4-13.5-25.3 25.3zm56-56l28 9.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-21.1-7V336l-20.6 20.6zM431 304h33c2.5 0 4.9-.6 7.2-1.7l32-16c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L460.2 272H422.7c4.1 10.1 6.9 20.8 8.3 32zM320 193V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h16c5.4 0 10.8 .3 16 1z", "M128 0C60 0 4.4 53 .2 120c0 .2 0 .3 0 .5L0 128H7.9l.1 0H0v33.3c0 28.1 16.3 53.6 41.8 65.4L98.9 253C86.9 272.5 80 295.4 80 320v16L192 448H320L432 336V320c0-24.6-6.9-47.5-18.9-67l57.1-26.3c25.5-11.8 41.8-37.3 41.8-65.4V128h-8c0 0 .1 0 .1 0H512l-.2-7.5c0-.1 0-.3 0-.4l0 0 0 0C507.6 53 452 0 384 0H339.3c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c5 5 1.5 13.7-5.7 13.7H328c-4.4 0-8.1 3.6-7.5 8c3.9 31.6 30.9 56 63.5 56h80v33.3c0 9.4-5.4 17.9-13.9 21.8L378.7 216c-21-15.1-46.8-24-74.7-24H208c-27.9 0-53.7 8.9-74.7 24L61.9 183.1C53.4 179.2 48 170.6 48 161.3V128h80c32.6 0 59.6-24.4 63.5-56c.5-4.4-3.1-8-7.5-8H147.3c-7.1 0-10.7-8.6-5.7-13.7l36.7-36.7c5-5 1.5-13.7-5.7-13.7H128z"]]
};
var faBoxOpenFull = {
  prefix: 'fad',
  iconName: 'box-open-full',
  icon: [640, 512, ["box-full"], "f49c", ["M17.2 253.5c-9 17.9 .6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 192 75.2 161.4c-6.7-.8-13.3 2.7-16.3 8.7L17.2 253.5zm605.5 0l-41.7-83.4c-3-6.1-9.6-9.6-16.3-8.7L320 192l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1z", "M480.9 3.1c24.8 9.3 37.4 37 28.1 61.8l-27.5 73.4L320 158.5l-7.2-.9c4.6-8.8 7.2-18.9 7.2-29.6c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.1 .6 10 1.7 14.7l-65.5-8.2c-.1-2.2-.2-4.3-.2-6.5C128 57.3 185.3 0 256 0c69.6 0 126.2 55.6 128 124.7l35.1-93.6c9.3-24.8 37-37.4 61.8-28.1zM236.6 331L320 192l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l136.4-39V410.5c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.5-20.9 2.5-31 0l-204.1-51C79 451.7 64 432.5 64 410.5V306.3l136.4 39c13.9 4 28.8-1.9 36.2-14.3z"]]
};
var faBoxFull = faBoxOpenFull;
var faFile = {
  prefix: 'fad',
  iconName: 'file',
  icon: [384, 512, [128196, 128459, 61462], "f15b", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64z", "M224 0L384 160H256c-17.7 0-32-14.3-32-32V0z"]]
};
var faGreaterThan = {
  prefix: 'fad',
  iconName: 'greater-than',
  icon: [384, 512, [62769], "3e", ["M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z", ""]]
};
var faQuotes = {
  prefix: 'fad',
  iconName: 'quotes',
  icon: [576, 512, [], "e234", ["M256 320c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48l0 24 0 24v56c0 48.6-39.4 88-88 88h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c13.3 0 24-10.7 24-24v-8H304c-26.5 0-48-21.5-48-48V320zM488 512h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c13.3 0 24-10.7 24-24v-8H480c-26.5 0-48-21.5-48-48V320c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v24 24 56c0 48.6-39.4 88-88 88z", "M88 0C39.4 0 0 39.4 0 88v56 24 24c0 26.5 21.5 48 48 48H96c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H64V88c0-13.3 10.7-24 24-24h8c17.7 0 32-14.3 32-32s-14.3-32-32-32H88zM264 0c-48.6 0-88 39.4-88 88v56 24 24c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H240V88c0-13.3 10.7-24 24-24h8c17.7 0 32-14.3 32-32s-14.3-32-32-32h-8z"]]
};
var faPretzel = {
  prefix: 'fad',
  iconName: 'pretzel',
  icon: [512, 512, [129384], "e441", ["M0 170.6C0 94.1 62.1 32 138.6 32H148c42.6 0 81 18 108 46.8C283 50 321.4 32 364 32h9.4C449.9 32 512 94.1 512 170.6c0 82.7-40.9 155.9-103.7 200.4l32.4 46c12.7 18.1 8.4 43-9.7 55.7s-43 8.4-55.7-9.7l-40-56.8c-21.8 6.4-44.9 9.8-68.7 9.8H256 245.4c-23.9 0-46.9-3.4-68.7-9.8l-40 56.8C124 481.1 99 485.4 81 472.7S58.6 435 71.3 417l32.4-46C40.9 326.5 0 253.3 0 170.6zM148 112h-9.4C106.2 112 80 138.2 80 170.6c0 55.7 27.5 105 69.7 134.9l52.5-74.7c8.9-12.7 13.7-27.9 13.7-43.4V180c0-37.6-30.4-68-68-68zm78.8 223c6.1 .7 12.3 1 18.6 1H256h10.6c6.3 0 12.5-.3 18.6-1L256 293.5 226.8 335zm135.5-29.4c42.2-30 69.7-79.2 69.7-134.9c0-32.4-26.2-58.6-58.6-58.6H364c-37.6 0-68 30.4-68 68v7.4c0 15.5 4.8 30.7 13.7 43.4l52.5 74.7zM112 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM448 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM176 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM288 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM400 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM64 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm400-80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z", "M112 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM432 288a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM176 352a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM48 192a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM464 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM272 128a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM400 416a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]]
};
var faPersonSwimming = {
  prefix: 'fad',
  iconName: 'person-swimming',
  icon: [576, 512, [127946, "swimmer"], "f5c4", ["M269.5 325.9c11.1-7.9 25.9-7.9 37 0C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1z", "M447.9 297.1L309.5 178.4C331.7 166.6 357.1 160 384 160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H384c-121.8 0-220.9 97.2-223.9 218.2c10.8 4 21.8 6.2 31.9 6.2c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.6-1.1 3.1-2.1 4.8-3zM96 224A64 64 0 1 0 96 96a64 64 0 1 0 0 128z"]]
};
var faSwimmer = faPersonSwimming;
var faArrowDown = {
  prefix: 'fad',
  iconName: 'arrow-down',
  icon: [384, 512, [8595], "f063", ["M160 370.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V370.7l-32 32-32-32z", "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7 54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]]
};
var faUserRobotXmarks = {
  prefix: 'fad',
  iconName: 'user-robot-xmarks',
  icon: [448, 512, [], "e4a7", ["M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64h32V16zM64 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H80V128H64zM176 464c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h32V464zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h32V464zm48-16c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zM416 160c0-17.7-14.3-32-32-32H368V256h16c17.7 0 32-14.3 32-32V160z", "M80 128c0-35.3 28.7-64 64-64H304c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V128zm64 128a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM136.5 119.5c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17L143 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L160 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L177 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L160 143l-23.5-23.5zm111 0c-4.7 4.7-4.7 12.3 0 17L271 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L288 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L305 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L288 143l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0zM0 448c0-53 43-96 96-96H352c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32H352V448c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32-14.3-32-32V448z"]]
};
var faMessageQuote = {
  prefix: 'fad',
  iconName: 'message-quote',
  icon: [512, 512, ["comment-alt-quote"], "e1e4", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm160 48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V192 168 144c0-17.7-14.3-32-32-32H160zm224 80V168 144c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V192z", "M128 144c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V224H160c-17.7 0-32-14.3-32-32V144zm256 87.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V224H304c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24 39.3z"]]
};
var faCommentAltQuote = faMessageQuote;
var faCandyCorn = {
  prefix: 'fad',
  iconName: 'candy-corn',
  icon: [640, 512, [], "f6bd", ["M640 56c0-17.2-11-32.5-27.4-37.9C570.4 4.2 524.1 0 480 0c-44 0-90 4.4-132.2 17.9C331.4 23.4 320 38.8 320 56c0 14.3 3.6 34.7 8.7 56.8C357 105.7 408.8 96 480 96s123 9.7 151.3 16.8C636.4 90.7 640 70.3 640 56zM380.7 278.8c10.3 27 21 52.4 31.2 72.9c13.4 27 32.9 64.3 68.1 64.3s54.6-37.3 68.1-64.3c10.2-20.6 20.9-46 31.2-72.9c-26.8-3.8-60.1-6.8-99.3-6.8s-72.5 2.9-99.3 6.8zm-142.9-155c-12.2-12.2-30.8-15.2-46.2-7.5c-39.6 20.1-75.4 49.9-106.6 81C54 228.4 24.5 264 4.3 303.4c-7.7 15.4-4.9 34.4 7.3 46.6c10.1 10.1 27 22 46.3 33.9c15-25 44.8-68.5 95.1-118.8s93.8-80.1 118.8-95.1c-12-19.3-23.8-36.2-33.9-46.3zM212 464.6c26.3 11.8 51.9 22.2 73.6 29.5c28.6 9.6 68.7 22.2 93.6-2.7s12.2-65 2.7-93.6c-7.3-21.8-17.7-47.3-29.5-73.6c-21.6 16.2-47.3 37.7-75 65.4s-49.2 53.3-65.4 75z", "M336.4 142.9C365.9 136.1 414.8 128 480 128s114.1 8.1 143.6 14.9c-9 33.1-21 71.2-33.9 107.5c-3.4 9.5-6.9 19-10.4 28.3c-26.8-3.8-60.1-6.8-99.3-6.8s-72.5 2.9-99.3 6.8c-3.5-9.3-7-18.8-10.4-28.3c-12.9-36.3-24.9-74.4-33.9-107.5zM84.6 399.9c16.1-25.7 44.9-66 91-112.1s86.4-74.9 112.1-91c17.1 29.8 35.5 65.2 52 100c4.3 9.2 8.6 18.3 12.7 27.4c-21.6 16.2-47.3 37.7-75 65.4s-49.2 53.3-65.4 75c-9.1-4.1-18.3-8.3-27.4-12.7c-34.8-16.5-70.2-35-100-52z"]]
};
var faFolderMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'folder-magnifying-glass',
  icon: [512, 512, ["folder-search"], "e18b", ["M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM336 272c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L327 393.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z", "M322.7 320.9c8.5-14.3 13.3-31 13.3-48.9c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L327 393.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3zM192 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]]
};
var faFolderSearch = faFolderMagnifyingGlass;
var faNotebook = {
  prefix: 'fad',
  iconName: 'notebook',
  icon: [512, 512, [], "e201", ["M192 0H432c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H192V0z", "M112 0C85.5 0 64 21.5 64 48v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v80H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v80H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56c0 26.5 21.5 48 48 48h80V0H112z"]]
};
var faDroplet = {
  prefix: 'fad',
  iconName: 'droplet',
  icon: [384, 512, [128167, "tint"], "f043", ["M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z", "M80 320c8.8 0 16 7.2 16 16c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16z"]]
};
var faTint = faDroplet;
var faBullseyePointer = {
  prefix: 'fad',
  iconName: 'bullseye-pointer',
  icon: [512, 512, [], "f649", ["M448 256c0 106-86 192-192 192c-3.9 0-7.8-.1-11.7-.4l-18.4 62.6c9.9 1.2 19.9 1.8 30.1 1.8c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 10.2 .6 20.2 1.8 30.1l62.6-18.4c-.2-3.9-.4-7.8-.4-11.7C64 150 150 64 256 64s192 86 192 192zm-48 0c0-79.5-64.5-144-144-144c-78.8 0-142.8 63.2-144 141.7L179.1 234c9.6-33.5 40.4-58 76.9-58c44.2 0 80 35.8 80 80c0 36.5-24.5 67.4-58 76.9l-19.7 67C336.8 398.8 400 334.8 400 256z", "M243.9 248.3L39 308.5c-13.9 4.1-15.6 23.2-2.6 29.7l57.3 28.7c1.3 .7 2.6 1.5 3.7 2.5l-88 88c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l88-88c1 1.1 1.9 2.3 2.5 3.7l28.7 57.3c6.5 13 25.6 11.3 29.7-2.6l60.2-204.8c3.6-12.1-7.7-23.4-19.9-19.9z"]]
};
var faEraser = {
  prefix: 'fad',
  iconName: 'eraser',
  icon: [576, 512, [], "f12d", ["M409.9 393.9l-45.3-45.3L297.4 416H288l-105.4 0-80-80L227.3 211.3l-45.3-45.3L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9l22.1-22.1z", "M409.9 393.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0L182.1 166.1l45.3 45.3L364.7 348.7l45.3 45.3z"]]
};
var faHexagonImage = {
  prefix: 'fad',
  iconName: 'hexagon-image',
  icon: [512, 512, [], "e504", ["M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36H344.3c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.7c-25.7 0-49.5 13.7-62.4 36L17.1 220zm141.2 59.8c4.5-4.9 10.8-7.7 17.4-7.8s13 2.6 17.6 7.4L232.2 320l71.6-86.2c4.6-5.5 11.3-8.7 18.5-8.7s13.9 3.2 18.5 8.7l72.6 87.4-55.2 95.7c-2.9 5-8.1 8-13.9 8l-176.6 0c-5.7 0-11-3-13.9-8l-46.8-81 51.2-56.1zM192 120a40 40 0 1 1 0 80 40 40 0 1 1 0-80z", "M158.3 279.8l-51.2 56.1 46.8 81c2.9 5 8.1 8 13.9 8l176.6 0c5.7 0 11-3 13.9-8l55.2-95.7-72.6-87.4c-4.6-5.5-11.3-8.7-18.5-8.7s-13.9 3.2-18.5 8.7L232.2 320l-38.9-40.6c-4.6-4.8-11-7.5-17.6-7.4s-13 2.9-17.4 7.8z"]]
};
var faEarthAmericas = {
  prefix: 'fad',
  iconName: 'earth-americas',
  icon: [512, 512, [127758, "earth", "earth-america", "globe-americas"], "f57d", ["M23.9 147.8L67 212.4c8.4 12.6 21.1 21.9 35.7 26L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l16.1-18.8c8.6-10 10.2-24.3 3.9-36L241.4 .4c4.8-.3 9.7-.4 14.6-.4c97.3 0 182 54.3 225.3 134.3l-70.2 30.1c-15.3 6.6-23 23.7-17.8 39.5l17.6 52.9c3.2 9.6 10.7 17.1 20.2 20.2l76.6 25.5C485.9 421.7 381.5 512 256 512C114.6 512 0 397.4 0 256c0-38.6 8.6-75.3 23.9-108.2z", "M241.5 .4C145 5.8 62.7 64.7 23.9 147.8L67 212.4c8.4 12.6 21.1 21.9 35.7 26L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l16.1-18.8c8.6-10 10.2-24.3 3.9-36L241.5 .4zM481.3 134.3l-70.2 30.1c-15.3 6.6-23 23.7-17.8 39.5l17.6 52.9c3.2 9.6 10.7 17.1 20.2 20.2l76.6 25.5c2.8-15.1 4.2-30.7 4.2-46.6c0-44-11.1-85.5-30.7-121.7z"]]
};
var faEarth = faEarthAmericas;
var faEarthAmerica = faEarthAmericas;
var faGlobeAmericas = faEarthAmericas;
var faCrateApple = {
  prefix: 'fad',
  iconName: 'crate-apple',
  icon: [512, 512, ["apple-crate"], "f6b1", ["M48 224c-26.5 0-48 21.5-48 48v80H512V272c0-26.5-21.5-48-48-48H48zM512 384H0v80c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V384zM64 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM48 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z", "M160 54.9C160 24.6 184.6 0 214.9 0c5 0 9.1 4.1 9.1 9.1C224 39.4 199.4 64 169.1 64c-5 0-9.1-4.1-9.1-9.1zM32 171.4C32 127.8 52.4 80 96 80c15.6 0 34.1 5.9 47.2 11c10.7 4.2 22.8 4.2 33.5 0c13.1-5.1 31.6-11 47.2-11c43.6 0 64 47.8 64 91.4c0 19-3.1 36.7-8.4 52.6H40.4c-5.4-15.9-8.4-33.6-8.4-52.6zM313 224c4.5-16.4 7-34.1 7-52.6c0-26.1-6-55.1-20.3-78.6c-2.7-4.4-5.7-8.7-9-12.7c15 .6 32.2 6.1 44.6 11c10.7 4.2 22.8 4.2 33.5 0c13.1-5.1 31.6-11 47.2-11c43.6 0 64 47.8 64 91.4c0 19-3.1 36.7-8.4 52.6H313zM406.9 0c5 0 9.1 4.1 9.1 9.1C416 39.4 391.4 64 361.1 64c-5 0-9.1-4.1-9.1-9.1C352 24.6 376.6 0 406.9 0zM48 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]]
};
var faAppleCrate = faCrateApple;
var faPersonBurst = {
  prefix: 'fad',
  iconName: 'person-burst',
  icon: [640, 512, [], "e53b", ["M176 8c6.6 0 12.4 4 14.9 10.1l29.4 74 76.2-23.1c6.3-1.9 13.1 .2 17.2 5.3s4.6 12.2 1.4 17.9l-39.5 69.1 65.6 45.1c5.4 3.7 8 10.3 6.5 16.7s-6.7 11.2-13.1 12.2l-78.7 12.2 5.6 79.4c.5 6.5-3.1 12.7-9 15.5s-12.9 1.8-17.8-2.6L176 286.1l-58.6 53.9c-4.8 4.4-11.9 5.5-17.8 2.6s-9.5-9-9-15.5l5.6-79.4L17.6 235.4c-6.5-1-11.7-5.9-13.1-12.2s1.1-13 6.5-16.7l65.6-45.1L37 92.2c-3.3-5.7-2.7-12.8 1.4-17.9s10.9-7.2 17.2-5.3l76.2 23.1 29.4-74C163.6 12 169.4 8 176 8z", "M432 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L552 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H472z"]]
};
var faGameBoard = {
  prefix: 'fad',
  iconName: 'game-board',
  icon: [448, 512, [], "f867", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 96V416H64V96H384z", "M64 256l0 80h80V256H64zM384 416l0-80H304v80h80zm-240 0h80V336H144v80 0zM64 96l0 80h80V96H64zm160 80H144v80h80V176zm0 80v80h80V256H224zm160 0V176H304v80h80zM304 96H224v80h80V96z"]]
};
var faHatChef = {
  prefix: 'fad',
  iconName: 'hat-chef',
  icon: [512, 512, [], "f86b", ["M256 0c-41.9 0-79 20.1-102.4 51.2C137.6 39.1 117.6 32 96 32c-7.1 0-14.4 .8-21.6 2.5C30 44.7-.1 84.3 0 128c0 7.1 .8 14.4 2.5 21.6C16 224 64 320 64 320h74.4L112.2 162.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2L170.9 320H240V160c0-8.8 7.2-16 16-16s16 7.2 16 16V320h69.1l27.1-162.6c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4L373.6 320H448s48-96 61.5-170.4c1.7-7.2 2.5-14.5 2.5-21.6c0-43.7-30-83.3-74.4-93.5C430.3 32.8 423.1 32 416 32c-21.6 0-41.5 7.1-57.6 19.2C335 20.1 297.9 0 256 0z", "M64 320H448V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V320z"]]
};
var faHandBackPointRight = {
  prefix: 'fad',
  iconName: 'hand-back-point-right',
  icon: [512, 512, [], "e1a1", ["M512 168c0-22.1-17.9-40-40-40l-200 0-7 0-73 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l55.7 0c-1.4-2-3-3.9-4.5-5.8L227.2 71C215 56.4 197 48 178 48L140 48c-38 0-74 16.9-98.3 46.1l-4.5 5.4C13.1 128.3 0 164.5 0 201.9L0 320c0 70.7 57.3 128 128 128l64 0 32 0c26.5 0 48-21.5 48-48c0-12.4-4.7-23.6-12.3-32.1C284.5 366 304 345.3 304 320c0-12.4-4.7-23.6-12.3-32.1C316.5 286 336 265.3 336 240c0-12.3-4.6-23.5-12.2-32L472 208c22.1 0 40-17.9 40-40z", ""]]
};
var faDove = {
  prefix: 'fad',
  iconName: 'dove',
  icon: [512, 512, [128330], "f4ba", ["M32 176C32 112.1 46.8 65.9 57.9 43c3.4-7.1 10.9-11 18.8-11c11.3 0 20.8 8 24.1 18.8C135 164.2 259.2 202.9 320 208l0-64c0-44.2 35.8-80 80-80h99.7c6.8 0 12.3 5.5 12.3 12.3c0 2.4-.7 4.8-2.1 6.8L480 128V288c0 88.4-71.6 160-160 160H245.6L170 508.5c-2.8 2.3-6.4 3.5-10 3.5C77.3 512 21.7 466.2 3.2 441.6C0 437.4-.9 431.8 .9 426.8s5.8-8.8 10.9-10.2l138.6-37.8C112.1 356.5 32 292.9 32 176zm368-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z", "M209.2 9.3c-16.7 19.3-42.9 60.1-59.4 121.8c-.1 .2-.1 .5-.2 .7C201.9 183.9 276.9 204.4 320 208l0-33.4C282.2 139.4 250.6 90.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8z"]]
};
var faSnowflakeDroplets = {
  prefix: 'fad',
  iconName: 'snowflake-droplets',
  icon: [640, 512, [], "e5c1", ["M320 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.7 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L383.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 21.5 12.6-29.3 57-22.7-13.2 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L352 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L145 395.1l-29.3-57 21.5-12.6-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L256.5 256l-60.9-35.5-67.7 18.1c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8-25.3-14.8c-15.3-8.9-20.4-28.5-11.5-43.8s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L288 200.3V129.9L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z", "M54.7 325.7L7.1 418.1C2.4 427.2 0 437.4 0 447.7C0 483 28.7 512 64 512s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5L73.3 325.7c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7zm512 0l-47.5 92.4c-4.7 9.1-7.1 19.3-7.1 29.5c0 35.3 28.7 64.3 64 64.3s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5l-47.5-92.4c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7z"]]
};
var faBatteryEmpty = {
  prefix: 'fad',
  iconName: 'battery-empty',
  icon: [576, 512, ["battery-0"], "f244", ["M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z", ""]]
};
var faBattery0 = faBatteryEmpty;
var faGrid4 = {
  prefix: 'fad',
  iconName: 'grid-4',
  icon: [448, 512, [], "e198", ["M119.5 48v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H135.5c-8.8 0-16 7.2-16 16zM16 151.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H16zm0 238.9c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H16zM135.5 270.9c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H135.5zM238.9 167.5v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16zm16 222.9c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H254.9zM358.4 48v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H374.4c-8.8 0-16 7.2-16 16zm16 222.9c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H374.4z", "M16 32C7.2 32 0 39.2 0 48v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H16zm0 238.9c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H16zM119.5 167.5v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H135.5c-8.8 0-16 7.2-16 16zm16 222.9c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H135.5zM238.9 48v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16zm16 222.9c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H254.9zM358.4 167.5v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H374.4c-8.8 0-16 7.2-16 16zm16 222.9c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H374.4z"]]
};
var faSocks = {
  prefix: 'fad',
  iconName: 'socks',
  icon: [512, 512, [129510], "f696", ["M298.7 8.1C291 3 281.9 0 272 0H176c-26.5 0-48 21.5-48 48V64H288V48c0-14.5 3.9-28.2 10.7-39.9zM128 96v32H288V96H128zm0 64v80c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V160H128zM320 64V96H512V64H320zm192 64H320v32H512V128z", "M320 128H512V96H320v32zm0 32v80c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V160H320zM512 64V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V64H512zM128 64V96H288V64H128zm160 64H128v32H288V128z"]]
};
var faFaceSunglasses = {
  prefix: 'fad',
  iconName: 'face-sunglasses',
  icon: [512, 512, [], "e398", ["M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256c0-22.8 3-44.8 8.5-65.8c2.2 1.2 4.8 1.8 7.5 1.8H50.7l6.6 39.9C61.2 255 81.2 272 104.7 272h78.7c23.5 0 43.5-17 47.3-40.1l8-48c.4-2.7 .7-5.3 .7-7.9h33.3c0 2.6 .2 5.2 .7 7.9l8 48c3.9 23.1 23.9 40.1 47.3 40.1h78.7c23.5 0 43.5-17 47.3-40.1l6.6-39.9H496c2.7 0 5.2-.7 7.5-1.8c5.6 21 8.5 43.1 8.5 65.8zM256 0C363.4 0 455.4 66.2 493.4 160H460.6c-6.5-18.4-24.1-32-45.3-32H320.7c-14.4 0-27.1 6.2-35.8 16H227.1c-8.7-9.8-21.4-16-35.8-16H96.7c-21.2 0-38.7 13.6-45.3 32H18.6C56.6 66.2 148.6 0 256 0zM164.1 341.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5z", "M183.3 272H104.7c-23.5 0-43.5-17-47.3-40.1L50.7 192H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H51.4c6.5-18.4 24.1-32 45.3-32h94.7c14.4 0 27.1 6.2 35.8 16h57.8c8.7-9.8 21.4-16 35.8-16h94.7c21.2 0 38.7 13.6 45.3 32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H461.3l-6.6 39.9C450.8 255 430.8 272 407.3 272H328.7c-23.5 0-43.5-17-47.3-40.1l-8-48c-.4-2.7-.7-5.3-.7-7.9H239.3c0 2.6-.2 5.2-.7 7.9l-8 48C226.8 255 206.8 272 183.3 272z"]]
};
var faInbox = {
  prefix: 'fad',
  iconName: 'inbox',
  icon: [512, 512, [], "f01c", ["M391 96H121L73 288h51.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H439L391 96z", "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"]]
};
var faSquare0 = {
  prefix: 'fad',
  iconName: 'square-0',
  icon: [448, 512, [], "e255", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48V224c0-26.5-21.5-48-48-48s-48 21.5-48 48z", "M128 224c0-53 43-96 96-96s96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224zm96-48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48V224c0-26.5-21.5-48-48-48z"]]
};
var faSection = {
  prefix: 'fad',
  iconName: 'section',
  icon: [256, 512, [], "e447", ["M1.7 243c4.8-28 20.6-48.9 41.7-62.5c22.2 15.2 50.8 24.2 73.7 31.4l0 0 3.7 1.2c17.5 5.5 31.8 10.3 43.1 15.5l-16.4-2.6c-26.7-4.2-48-1.7-62.1 4.3c-12.6 5.4-18.6 13-20.5 22.7c-.8 8.1 .5 12.7 2.1 15.7c1.7 3.3 4.9 7.1 11 11.3c13.8 9.3 34.3 15.6 61.7 23.8l1.4 .4c24.1 7.2 54.7 16.4 77.5 33c12.4 9.1 23.7 21.2 30.7 37.6c7 16.5 8.4 34.6 5 53.9c-6 35-29.2 58.9-58.5 71.4c-28.3 12.1-62.7 14.1-97.2 8.7l-.2 0 0 0c-18.8-3-48.7-13.3-67.3-19.6c-3.5-1.2-6.7-2.3-9.2-3.1C5.1 480.7-3.9 462.6 1.6 445.8s23.7-25.8 40.5-20.3c3.8 1.3 8 2.7 12.3 4.1l0 0c19 6.5 41.4 14.1 54.1 16.2c26.6 4.2 48 1.6 62-4.4c13-5.6 18.9-13.4 20.7-23.5c1.6-9.5 .4-14.9-.9-18.1c-1.4-3.3-4.1-6.9-9.5-10.9c-12.5-9.2-32.2-15.6-59.4-23.8l-3.7-1.1 0 0c-23.5-7-53-15.8-75.4-31c-12.5-8.5-24.4-19.9-32.3-35.5c-8-15.9-10.7-33.7-8.4-53c.1-.6 .1-1.1 .2-1.7z", "M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c22.5 16.1 52.1 25.4 75.6 32.8l0 0 3.7 1.2c27.2 8.6 46.8 15.4 59.2 25c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3c24 7.2 54.3 16.3 76.9 32.9c1 .8 2.1 1.5 3.1 2.3c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5z"]]
};
var faSquareThisWayUp = {
  prefix: 'fad',
  iconName: 'square-this-way-up',
  icon: [448, 512, ["box-up"], "f49f", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM80 384H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM265.4 192c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L306.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4H352V304c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V192H265.4zm-192 0c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L114.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4H160V304c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V192H73.4z", "M73.4 192c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L114.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4H160V304c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V192H73.4zM352 192V304c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V192H265.4c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L306.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4H352z"]]
};
var faBoxUp = faSquareThisWayUp;
var faGaugeHigh = {
  prefix: 'fad',
  iconName: 'gauge-high',
  icon: [512, 512, [62461, "tachometer-alt", "tachometer-alt-fast"], "f625", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M322 142.3c5.3-12.1 19.5-17.6 31.6-12.3s17.6 19.5 12.3 31.6L301.9 307.4C313.1 318.9 320 334.6 320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c.6 0 1.3 0 1.9 0L322 142.3z"]]
};
var faTachometerAlt = faGaugeHigh;
var faTachometerAltFast = faGaugeHigh;
var faSquareAmpersand = {
  prefix: 'fad',
  iconName: 'square-ampersand',
  icon: [448, 512, [], "e260", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM184 191.6c0 4.1 1.6 8.1 4.6 11L203 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2H199.6c-8.6 0-15.6 7-15.6 15.6zm71 46.9l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L329 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4H178.5c-36.7 0-66.5-29.8-66.5-66.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9c0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z", "M199.6 176h19.2c7.3 0 13.2 5.9 13.2 13.2c0 4.2-2 8.1-5.4 10.6L203 217.1l-14.5-14.5c-2.9-2.9-4.6-6.9-4.6-11c0-8.6 7-15.6 15.6-15.6zm37.8 75.4L255 238.5c15.7-11.5 25-29.8 25-49.3c0-33.8-27.4-61.2-61.2-61.2H199.6c-35.1 0-63.6 28.5-63.6 63.6c0 16.9 6.7 33 18.6 45l9.2 9.2-24.7 18.1c-17.1 12.5-27.2 32.4-27.2 53.6c0 36.7 29.8 66.5 66.5 66.5h32.2c24.1 0 46.9-10.9 62-29.4L295 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-28.4-28.4 31.1-45c7.5-10.9 4.8-25.8-6.1-33.4s-25.8-4.8-33.4 6.1l-26.2 37.8-28.7-28.7zm-39.2 28.7l40.1 40.1-1.4 2c-6 8.6-15.8 13.8-26.3 13.8H178.5c-10.2 0-18.5-8.3-18.5-18.5c0-5.9 2.8-11.4 7.5-14.9l30.7-22.5z"]]
};
var faEnvelopeOpenText = {
  prefix: 'fad',
  iconName: 'envelope-open-text',
  icon: [512, 512, [], "f658", ["M96 32C78.3 32 64 46.3 64 64V249.7L236.7 377.6c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4L448 249.7V64c0-17.7-14.3-32-32-32H96zm80 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M511.8 202.5c-1.6-18.1-10.9-34.9-25.7-45.8L448 128.5v79.6 41.6l63.8-47.2zM512 448V242.1L294.4 403.3C283.3 411.6 269.8 416 256 416s-27.3-4.4-38.4-12.7L0 242.1V448v0c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64v0zM64 249.7V208.1l0-79.6L25.9 156.7C11.1 167.6 1.8 184.4 .2 202.5L64 249.7zM289.5 11.1C279.8 3.9 268.1 0 256 0s-23.8 3.9-33.5 11L194.2 32H317.8L289.5 11.1zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]]
};
var faLampDesk = {
  prefix: 'fad',
  iconName: 'lamp-desk',
  icon: [512, 512, [], "e014", ["M105.4 233.4L218.7 120 256 157.3v16l-92.6 92.6L209 448H143L97 263.8c-2.7-10.9 .5-22.4 8.4-30.4zM183.3 512c.5 0 .9 0 1.4 0h-1.4zM446.2 175.1c11 10.2 17.8 24.8 17.8 40.9c0 30.9-25.1 56-56 56c-16.2 0-30.7-6.8-40.9-17.8l79.1-79.1z", "M192 65.9C192 29.5 221.5 0 257.9 0c17.5 0 34.3 6.9 46.6 19.3L349.3 64H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-192 192c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V157.3l-44.7-44.7C198.9 100.2 192 83.4 192 65.9zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]]
};
var faHospital = {
  prefix: 'fad',
  iconName: 'hospital',
  icon: [640, 512, [127973, 62589, "hospital-alt", "hospital-wide"], "f0f8", ["M48 96C21.5 96 0 117.5 0 144v48H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H0V464c0 26.5 21.5 48 48 48H160V96H48zm544 0H480V512H592c26.5 0 48-21.5 48-48V320H560c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V224H560c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V144c0-26.5-21.5-48-48-48z", "M208 0c-26.5 0-48 21.5-48 48V512H272V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80H480V48c0-26.5-21.5-48-48-48H208zM640 224V192H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80zm0 96V288H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80zM80 224c8.8 0 16-7.2 16-16s-7.2-16-16-16H0v32H80zm0 96c8.8 0 16-7.2 16-16s-7.2-16-16-16H0v32H80zM312 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H344v24c0 8.8-7.2 16-16 16H312c-8.8 0-16-7.2-16-16V152H272c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16z"]]
};
var faHospitalAlt = faHospital;
var faHospitalWide = faHospital;
var faPollPeople = {
  prefix: 'fad',
  iconName: 'poll-people',
  icon: [640, 512, [], "f759", ["M480 192H592c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H480V96h96v32H480v64zM384 480H592c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H384v64H576v32H384v64z", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64zm64 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64zM224 80c0-26.5 21.5-48 48-48H480V192H272c-26.5 0-48-21.5-48-48V80zm0 288c0-26.5 21.5-48 48-48H384V480H272c-26.5 0-48-21.5-48-48V368z"]]
};
var faWhiskeyGlassIce = {
  prefix: 'fad',
  iconName: 'whiskey-glass-ice',
  icon: [512, 512, ["glass-whiskey-rocks"], "f7a1", ["M7.8 43.1C13.9 36 22.7 32 32 32H480c9.3 0 18.1 4 24.2 11.1s8.8 16.4 7.5 25.5l-50 342.9c-5.7 39.3-39.4 68.5-79.2 68.5h-253c-39.7 0-73.4-29.1-79.2-68.5L.3 68.6C-1 59.4 1.7 50.1 7.8 43.1zM69 96l44.7 306.3c1.1 7.9 7.9 13.7 15.8 13.7h253c7.9 0 14.7-5.8 15.8-13.7L443 96H69z", "M83 192H429L398.3 402.3c-1.1 7.9-7.9 13.7-15.8 13.7h-253c-7.9 0-14.7-5.8-15.8-13.7L83 192zm93 32c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h48c3.4 0 6.6-.5 9.7-1.5c-1.1-4.4-1.7-9-1.7-13.7v-1.7c0-14.9 5.9-29.1 16.4-39.6L256 272V256c0-17.7-14.3-32-32-32H176zm89.4 72.5c-6 6-9.4 14.1-9.4 22.6v1.7c0 8.5 3.4 16.6 9.4 22.6l31.2 31.2c6 6 14.1 9.4 22.6 9.4h1.7c8.5 0 16.6-3.4 22.6-9.4l31.2-31.2c6-6 9.4-14.1 9.4-22.6v-1.7c0-8.5-3.4-16.6-9.4-22.6l-31.2-31.2c-6-6-14.1-9.4-22.6-9.4h-1.7c-8.5 0-16.6 3.4-22.6 9.4l-31.2 31.2z"]]
};
var faGlassWhiskeyRocks = faWhiskeyGlassIce;
var faWineBottle = {
  prefix: 'fad',
  iconName: 'wine-bottle',
  icon: [512, 512, [], "f72f", ["M417.9 161.9L350.1 94.1l32-32 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-32 32zM54.7 278.7L180.2 153.3c.8-.8 1.7-1.7 2.5-2.5l82.6 82.6c12.5 12.5 12.5 32.8 0 45.3l-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0L54.7 278.7z", "M350.1 94.1l67.9 67.9-16.8 16.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l36-36 82.6 82.6c12.5 12.5 32.8 12.5 45.3 0l82.7-82.7c12.5-12.5 12.5-32.8 0-45.3l-82.6-82.6c31.7-30 75.1-40.4 115-31.3c12.6 2.9 26.4 .5 35.5-8.6l16.8-16.8z"]]
};
var faChessRook = {
  prefix: 'fad',
  iconName: 'chess-rook',
  icon: [448, 512, [9820], "f447", ["M368 432H80L38.6 473.4c-4.2 4.2-6.6 10-6.6 16C32 501.9 42.1 512 54.6 512H393.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L368 432z", "M32 48V192c0 10.1 4.7 19.6 12.8 25.6L96 256 80 432H368L352 256l51.2-38.4c8.1-6 12.8-15.5 12.8-25.6V48c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16V88c0 4.4-3.6 8-8 8H280c-4.4 0-8-3.6-8-8V48c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16V88c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8V48c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM192 304V256c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16z"]]
};
var faUserBountyHunter = {
  prefix: 'fad',
  iconName: 'user-bounty-hunter',
  icon: [448, 512, [], "e2bf", ["M64 16C64 7.2 71.2 0 80 0H96c8.8 0 16 7.2 16 16s-7.2 16-16 16V70c-13.5 21-22 45.6-23.7 72.2L65 256.5c-.2 3.5 0 6.9 .6 10.2c-1-3.4-1.6-7-1.6-10.7V16zm49.3 236.6l5.3-82.4c29 16.3 64.2 48.1 71.9 97.8l-77.2-15.4zM257.5 268c7.6-49.7 42.9-81.5 71.9-97.8l5.3 82.4L257.5 268zM166.4 459.2l48-36c5.7-4.3 13.5-4.3 19.2 0l48 36c4 3 6.4 7.8 6.4 12.8v40H160V472c0-5 2.4-9.8 6.4-12.8z", "M224 48c46 0 85.4 30 99 72H125c13.6-42 52.9-72 99-72zm24 123.5l80.5-15.1 6.2 96.2L248 269.9V171.5zm-48 0v98.4l-86.7-17.3 6.2-96.2L200 171.5zM224 0C143.9 0 77.5 62.2 72.3 142.2L65 256.5c-1.3 20 12.4 37.9 32.1 41.8l100.8 20.2c5.2 1 10.4 1.6 15.7 1.6h20.9c5.3 0 10.5-.5 15.7-1.6L351 298.3c19.7-3.9 33.4-21.8 32.1-41.8l-7.4-114.3C370.5 62.2 304.1 0 224 0zM0 486.4C0 500.5 11.5 512 25.6 512H160V472c0-5 2.4-9.8 6.4-12.8l48-36c5.7-4.3 13.5-4.3 19.2 0l48 36c4 3 6.4 7.8 6.4 12.8v40H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352H134.4C60.2 352 0 412.2 0 486.4z"]]
};
var faBarsStaggered = {
  prefix: 'fad',
  iconName: 'bars-staggered',
  icon: [512, 512, ["reorder", "stream"], "f550", ["M64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32z", "M448 96c0-17.7-14.3-32-32-32H32C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32zm0 320c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"]]
};
var faReorder = faBarsStaggered;
var faStream = faBarsStaggered;
var faDiagramSankey = {
  prefix: 'fad',
  iconName: 'diagram-sankey',
  icon: [576, 512, [], "e158", ["M32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32H141.9l86.7 144.5c5.8 9.6 16.2 15.5 27.4 15.5H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H274.1l-57.6-96H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z", "M294.4 44.8c6-8.1 15.5-12.8 25.6-12.8H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H336L249.6 211.2c-6 8.1-15.5 12.8-25.6 12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H208L294.4 44.8z"]]
};
var faCloudHailMixed = {
  prefix: 'fad',
  iconName: 'cloud-hail-mixed',
  icon: [512, 512, [], "f73a", ["M214.1 385.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112zm232 0c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112zM313.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-10.3 24c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24c5.2-12.2-.4-26.3-12.6-31.5zM94.1 385.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-10.3 24c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24zM64 480A32 32 0 1 0 0 480a32 32 0 1 0 64 0zm192 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M0 224c0 53 43 96 96 96H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z"]]
};
var faCircleUpLeft = {
  prefix: 'fad',
  iconName: 'circle-up-left',
  icon: [512, 512, [], "e128", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 313.4V176c0-8.8 7.2-16 16-16H313.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L296 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C322 366 317.1 368 312 368s-10-2-13.7-5.7L232 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6z", "M160 176V313.4c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L232 296l66.3 66.3c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l36.7-36.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L296 232l33.4-33.4c4.2-4.2 6.6-10 6.6-16c0-12.5-10.1-22.6-22.6-22.6H176c-8.8 0-16 7.2-16 16z"]]
};
var faDharmachakra = {
  prefix: 'fad',
  iconName: 'dharmachakra',
  icon: [512, 512, [9784], "f655", ["M337.8 205.7l48.6-42.5c-10.3-14.5-23-27.2-37.6-37.6l-42.5 48.6c12.8 7.9 23.6 18.7 31.5 31.5zm76 23.7l-64.4 4.3c1.7 7.1 2.6 14.6 2.6 22.3s-.9 15.1-2.6 22.3l64.4 4.3c1.4-8.6 2.2-17.5 2.2-26.6s-.8-17.9-2.2-26.6zm64.1 57.4l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1c1.4 10.1 2.1 20.4 2.1 30.8s-.7 20.8-2.1 30.8zm-91.5 62l-48.6-42.5c-7.9 12.8-18.7 23.6-31.5 31.5l42.5 48.6c14.5-10.3 27.2-23 37.6-37.6zm4.7 85.9l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c-12.5 16.5-27.1 31.1-43.6 43.6zM282.6 413.8l-4.3-64.4c-7.1 1.7-14.6 2.6-22.3 2.6s-15.1-.9-22.3-2.6l-4.3 64.4c8.6 1.4 17.5 2.2 26.6 2.2s17.9-.8 26.6-2.2zm-57.4 64.1l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c-10.1 1.4-20.4 2.1-30.8 2.1s-20.8-.7-30.8-2.1zm-62-91.5l42.5-48.6c-12.8-7.9-23.6-18.7-31.5-31.5l-48.6 42.5c10.3 14.5 23 27.2 37.6 37.6zm-85.9 4.7l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c-16.5-12.5-31.1-27.1-43.6-43.6zM98.2 282.6l64.4-4.3c-1.7-7.1-2.6-14.6-2.6-22.3s.9-15.1 2.6-22.3l-64.4-4.3C96.8 238.1 96 247 96 256s.8 17.9 2.2 26.6zM34.1 225.2l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1C32.7 276.8 32 266.5 32 256s.7-20.8 2.1-30.8zm91.5-62l48.6 42.5c7.9-12.8 18.7-23.6 31.5-31.5l-42.5-48.6c-14.5 10.3-27.2 23-37.6 37.6zm-4.7-85.9l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c12.5-16.5 27.1-31.1 43.6-43.6zM229.4 98.2l4.3 64.4c7.1-1.7 14.6-2.6 22.3-2.6s15.1 .9 22.3 2.6l4.3-64.4C273.9 96.8 265 96 256 96s-17.9 .8-26.6 2.2zm57.4-64.1l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1C235.2 32.7 245.5 32 256 32s20.8 .7 30.8 2.1zm147.9 86.8l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c16.5 12.5 31.1 27.1 43.6 43.6z", "M256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 384a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm96-224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faObjectsAlignLeft = {
  prefix: 'fad',
  iconName: 'objects-align-left',
  icon: [512, 512, [], "e3be", ["M128 112c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-64zm0 224c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-64z", "M24 0C10.7 0 0 10.7 0 24L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24L48 24C48 10.7 37.3 0 24 0z"]]
};
var faOilCanDrip = {
  prefix: 'fad',
  iconName: 'oil-can-drip',
  icon: [640, 512, [], "e205", ["M352 96c0 17.7-14.3 32-32 32H288v32H224V128H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H320c17.7 0 32 14.3 32 32zM592 448c-26.5 0-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8c5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400c0 32-21.5 48-48 48z", "M368.9 160c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48V346.7l-67.5-30C11.2 309 0 291.8 0 272.8V208c0-26.5 21.5-48 48-48H96h48H368.9zM96 208H48v64.8l48 21.3V208z"]]
};
var faFaceSmilingHands = {
  prefix: 'fad',
  iconName: 'face-smiling-hands',
  icon: [640, 512, [], "e396", ["M320 512c-32.1 0-62.8-5.9-91.1-16.7c17-21.6 27.1-48.9 27.1-78.5V386c18.1 8.4 39.4 14 64 14s45.9-5.6 64-14v30.8c0 29.6 10.1 56.9 27.1 78.5c-28.3 10.8-59 16.7-91.1 16.7zM64.3 242.6C71.3 107.5 183.1 0 320 0S568.7 107.5 575.7 242.6c-16.8-5.8-36.2-2-49.6 11.4L479 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52v19.2c-16.8 10.6-38.1 18.4-64 18.4s-47.2-7.7-64-18.4V330.4c0-28.7-23.3-52-52-52c-17.9 0-33.6 9-43 22.7l-47.1-47.1c-13.4-13.4-32.8-17.2-49.6-11.4zm217.3-13.8l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z", "M281.6 228.8l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zM68.7 276.7c-6.2 6.2-6.2 16.4 0 22.6L120 350.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L43.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L88 382.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L56 414.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 404.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.8 56.8C79.3 502 103.6 512 128.8 512c52.6 0 95.2-42.6 95.2-95.2V384 330.4c0-11-9-20-20-20s-20 9-20 20v19.7c0 7.1-8.6 10.7-13.7 5.7l-79-79c-6.2-6.2-16.4-6.2-22.6 0zm502.6 0c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7V330.4c0-11-9-20-20-20s-20 9-20 20V384v32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L593.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L561.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L529.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6zM441.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]]
};
var faBroccoli = {
  prefix: 'fad',
  iconName: 'broccoli',
  icon: [512, 512, [129382], "e3e2", ["M112 352s47.7 54.5 80.2 138.3c5 12.8 17.1 21.7 30.9 21.7h65.9c13.8 0 25.9-8.9 30.9-21.7C352.3 406.5 400 352 400 352H288v.9c0 9.9-2.3 19.7-6.8 28.6l-18.1 36.2c-2.9 5.9-11.4 5.9-14.3 0l-18.1-36.2c-4.4-8.9-6.8-18.7-6.8-28.6V352H112z", "M416 352H96c-53 0-96-43-96-96c0-45.5 31.6-83.6 74.1-93.5C67.7 152.6 64 140.7 64 128c0-35.3 28.7-64 64-64c12.7 0 24.6 3.7 34.5 10.1C172.4 31.6 210.5 0 256 0s83.6 31.6 93.5 74.1C359.4 67.7 371.3 64 384 64c35.3 0 64 28.7 64 64c0 12.7-3.7 24.6-10.1 34.5c42.5 9.9 74.1 48 74.1 93.5c0 53-43 96-96 96z"]]
};
var faRouteInterstate = {
  prefix: 'fad',
  iconName: 'route-interstate',
  icon: [512, 512, [], "f61b", ["M21.2 192h469c-.8 51.2-9 97.7-27.2 139.8c-32.5 75.1-94.6 130.9-190.3 175.7c-10.2 4.8-22.1 5-32.5 .6c-98.4-41.4-161-97.6-193-173.9C29.3 291.5 21.7 244 21.2 192z", "M235.1 7.3c12.8-7.8 29-7.8 41.8 0c27.5 16.8 50.2 26 73.4 30c23.3 4 49.2 3.2 83.7-3.2c22.1-4.1 43.6 11 46.9 33.6c6.5 44.2 10 85.6 9.4 124.3H21.2c-.3-38.9 3.4-80.4 9.8-124.3C34.4 45 55.9 30 78 34.1c34.4 6.3 60.3 7.2 83.7 3.2c23.2-4 45.9-13.2 73.4-30z"]]
};
var faEarMuffs = {
  prefix: 'fad',
  iconName: 'ear-muffs',
  icon: [640, 512, [], "f795", ["M160 224c0-88.4 71.6-160 160-160s160 71.6 160 160v2.7c5-1.8 10.4-2.7 16-2.7c22.1 0 40.8 15 46.3 35.4c.6-.2 1.1-.4 1.7-.6V224C544 100.3 443.7 0 320 0S96 100.3 96 224v34.7c.6 .2 1.1 .4 1.7 .6C103.2 239 121.9 224 144 224c5.6 0 11 1 16 2.7V224z", "M192 272c0 12.3-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48c-22.1 0-40.8-15-46.3-35.4C92.2 478.8 86.2 480 80 480c-26.5 0-48-21.5-48-48c0-6.2 1.2-12.2 3.4-17.7C15 408.8 0 390.1 0 368s15-40.8 35.4-46.3C33.2 316.2 32 310.2 32 304c0-26.5 21.5-48 48-48c6.2 0 12.2 1.2 17.7 3.4C103.2 239 121.9 224 144 224c26.5 0 48 21.5 48 48zm256 0c0-26.5 21.5-48 48-48c22.1 0 40.8 15 46.3 35.4c5.5-2.2 11.4-3.4 17.7-3.4c26.5 0 48 21.5 48 48c0 6.2-1.2 12.2-3.4 17.7C625 327.2 640 345.9 640 368s-15 40.8-35.4 46.3c2.2 5.5 3.4 11.4 3.4 17.7c0 26.5-21.5 48-48 48c-6.2 0-12.2-1.2-17.7-3.4C536.8 497 518.1 512 496 512c-26.5 0-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32z"]]
};
var faHotdog = {
  prefix: 'fad',
  iconName: 'hotdog',
  icon: [512, 512, [127789], "f80f", ["M488.6 136.6c31.2-31.2 31.2-81.9 0-113.1s-81.9-31.2-113.1 0l-352 352c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0l352-352zm-45.3-21.3c-19.5 19.5-38.9 23.6-54.4 26.4l-.9 .2c-14.7 2.7-23.5 4.3-32.7 13.4c-9.6 9.6-12.3 20.5-15.7 36.1l-.2 1c-3.2 14.9-7.4 34.2-24.1 50.9s-36 20.9-50.9 24.1l-1 .2c-15.6 3.4-26.4 6-36.1 15.7s-12.3 20.5-15.7 36.1l-.2 1c-3.2 14.9-7.4 34.2-24.1 50.9c-16.4 16.4-34.2 19.5-48 22l-2.5 .4c-13.7 2.5-25.1 5.1-37.5 17.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c19.5-19.5 38.9-23.6 54.4-26.4l.9-.2 0 0c14.7-2.7 23.5-4.3 32.7-13.4c9.6-9.6 12.3-20.5 15.7-36.1l.2-1c3.2-14.9 7.4-34.2 24.1-50.9s36-20.9 50.9-24.1l1-.2c15.6-3.4 26.4-6 36.1-15.7s12.3-20.5 15.7-36.1l.2-1v0c3.2-14.9 7.4-34.2 24.1-50.9c16.4-16.4 34.2-19.5 48-22l2.5-.4c13.7-2.5 25.1-5.1 37.5-17.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z", "M495 257L257 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-22.5-22.5 320-320L495 175c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41zM359.4 39.4l-320 320L17 337C6.1 326.1 0 311.4 0 296s6.1-30.1 17-41L255 17C265.9 6.1 280.6 0 296 0s30.1 6.1 41 17l22.5 22.5zm83.9 75.9c-19.5 19.5-38.9 23.6-54.4 26.4l-.9 .2c-14.7 2.7-23.5 4.3-32.7 13.4c-9.6 9.6-12.3 20.5-15.7 36.1l-.2 1c-3.2 14.9-7.4 34.2-24.1 50.9s-36 20.9-50.9 24.1l-1 .2c-15.6 3.4-26.4 6-36.1 15.7s-12.3 20.5-15.7 36.1l-.2 1c-3.2 14.9-7.4 34.2-24.1 50.9c-16.4 16.4-34.2 19.5-48 22l-2.5 .4c-13.7 2.5-25.1 5.1-37.5 17.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c19.5-19.5 38.9-23.6 54.4-26.4l.9-.2 0 0c14.7-2.7 23.5-4.3 32.7-13.4c9.6-9.6 12.3-20.5 15.7-36.1l.2-1c3.2-14.9 7.4-34.2 24.1-50.9s36-20.9 50.9-24.1l1-.2c15.6-3.4 26.4-6 36.1-15.7s12.3-20.5 15.7-36.1l.2-1v0c3.2-14.9 7.4-34.2 24.1-50.9c16.4-16.4 34.2-19.5 48-22l2.5-.4c13.7-2.5 25.1-5.1 37.5-17.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faTransporterEmpty = {
  prefix: 'fad',
  iconName: 'transporter-empty',
  icon: [512, 512, [], "e046", ["", "M96 480c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z"]]
};
var faPersonWalkingWithCane = {
  prefix: 'fad',
  iconName: 'person-walking-with-cane',
  icon: [512, 512, ["blind"], "f29d", ["M332.6 334.3L450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9z", "M128 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM81.7 181.1C98 148.5 131.2 128 167.6 128H192c30.2 0 58.7 14.2 76.8 38.4l76.8 102.4c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L224 213.3v93.4l49.9 49.9c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L146.7 320c-12-12-18.7-28.3-18.7-45.3V231.6L92.6 302.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l46.3-92.6zM97 472.2l31.4-125.4 52.8 52.8-22 88.2c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8z"]]
};
var faBlind = faPersonWalkingWithCane;
var faAngle90 = {
  prefix: 'fad',
  iconName: 'angle-90',
  icon: [448, 512, [], "e08d", ["M225.8 139.9l-27.4 39.6c-30.9-17.6-65.5-29.3-102.4-33.6V97.6c47 4.7 91 19.5 129.8 42.3zm72.3 137.6c-18.7-31.5-43.5-58.9-72.9-80.5l27.3-39.5c35.2 25.7 65 58.5 87.2 96.2l-41.7 23.8zM312.8 306L354.7 282c14.6 31.6 24.1 65.9 27.7 102H334.1c-3.2-27.5-10.5-53.7-21.3-78z", "M32 32c17.7 0 32 14.3 32 32V416H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32z"]]
};
var faRectangleTerminal = {
  prefix: 'fad',
  iconName: 'rectangle-terminal',
  icon: [512, 512, [], "e236", ["M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm102.3 55.8c-9 9.8-8.3 25 1.5 33.9L180.5 256l-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM248 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z", "M103.8 185.7c-9.8-9-10.4-24.1-1.5-33.9s24.1-10.4 33.9-1.5l96 88c5 4.5 7.8 11 7.8 17.7s-2.8 13.1-7.8 17.7l-96 88c-9.8 9-25 8.3-33.9-1.5s-8.3-25 1.5-33.9L180.5 256l-76.7-70.3zM248 336H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faKite = {
  prefix: 'fad',
  iconName: 'kite',
  icon: [640, 512, [129665], "f6f4", ["M321 319s0 0 0 0l-79.6 79.6c-6.6-6.6-9.9-15.5-9.3-24.6l-85.4 85.4c-2.9 2.9-6.9 4.6-11 4.6c-8.6 0-15.6-7-15.6-15.6V324l-9.7-4.8c-9-4.5-19.6-4.5-28.6 0L72 324V448.4c0 35.1 28.5 63.6 63.6 63.6c16.9 0 33-6.7 45-18.6L266 407.9c1.8-.1 3.5-.4 5.2-.8l344-80c7.9-1.8 14.6-6.6 19-12.9L480 160 630.6 9.4C624.8 3.6 616.8 0 608 0H344c-6.7 0-13 2.1-18.3 5.7L480 160 321 319zM24 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h8c22.1 0 40 17.9 40 40v68l9.7 4.8c9 4.5 19.6 4.5 28.6 0L120 284V216c0-48.6-39.4-88-88-88H24z", "M312.8 24.8c1.8-7.9 6.6-14.6 12.9-19L480 160 241.4 398.6c-7.8-7.8-11-19.1-8.5-29.9l80-344zM480 160L630.6 9.4c5.8 5.8 9.4 13.8 9.4 22.6V296c0 6.7-2.1 13-5.7 18.3L480 160zM0 268.9C0 261.8 5.8 256 12.9 256c2 0 4 .5 5.8 1.4l63 31.5c9 4.5 19.6 4.5 28.6 0l63-31.5c1.8-.9 3.8-1.4 5.8-1.4c7.1 0 12.9 5.8 12.9 12.9v70.1c0 7.1-5.8 12.9-12.9 12.9c-2 0-4-.5-5.8-1.4l-63-31.5c-9-4.5-19.6-4.5-28.6 0l-63 31.5c-1.8 .9-3.8 1.4-5.8 1.4C5.8 352 0 346.2 0 339.1V268.9z"]]
};
var faDrum = {
  prefix: 'fad',
  iconName: 'drum',
  icon: [512, 512, [129345], "f569", ["M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9l-232 152c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l232-152zM256 480c8.1 0 16.1-.2 24-.5V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V479.5c7.9 .3 15.9 .5 24 .5zM72 446.7c14.3 6.4 30.5 12 48 16.7V344c0-13.3-10.7-24-24-24s-24 10.7-24 24V446.7zm320 16.7c17.5-4.7 33.7-10.3 48-16.7V344c0-13.3-10.7-24-24-24s-24 10.7-24 24V463.4z", "M370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208V368c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24V463.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24V479.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24V446.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l-53 34.7c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6l62.8-41.1z"]]
};
var faScrubber = {
  prefix: 'fad',
  iconName: 'scrubber',
  icon: [512, 512, [], "f2f8", ["M256 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]]
};
var faIceCream = {
  prefix: 'fad',
  iconName: 'ice-cream',
  icon: [448, 512, [127848], "f810", ["M368 144c0 5.4-.3 10.7-.9 16h.9c26.5 0 48 21.5 48 48s-21.5 48-48 48H314.5h-181H80c-26.5 0-48-21.5-48-48s21.5-48 48-48h.9c-.6-5.3-.9-10.6-.9-16C80 64.5 144.5 0 224 0s144 64.5 144 144z", "M199.8 495.6L80 256H372.6L252.7 495.6c-5 10-15.3 16.4-26.5 16.4s-21.5-6.3-26.5-16.4z"]]
};
var faHeartCircleBolt = {
  prefix: 'fad',
  iconName: 'heart-circle-bolt',
  icon: [576, 512, [], "e4fc", ["M228.3 469.1L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 6.6-.4 13.2-1.3 19.6C487 198.7 460.3 192 432 192c-97.2 0-176 78.8-176 176c0 36.6 11.2 70.6 30.3 98.7l-2.6 2.4c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm194.5-66.2c2.8-5 1.7-11.1-2.6-14.9s-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H452.4l30.1-54.2z"]]
};
var faFishBones = {
  prefix: 'fad',
  iconName: 'fish-bones',
  icon: [576, 512, [], "e304", ["M96 166.9V192h0v40 48 40h0v25.1c0 7.2-3.3 14.1-8.9 18.7l-48 38.9c-8.8 7.1-21.3 7.1-30.1 .1s-11.5-19.2-6.6-29.3L54.9 266.6c3.3-6.7 3.3-14.5 0-21.2L2.5 138.6c-5-10.1-2.2-22.3 6.6-29.3s21.3-7 30.1 .1l48 38.9c5.6 4.6 8.9 11.4 8.9 18.7zM416 280h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H416V130.9c0-16.9 17.1-28.4 31.8-20c16 9.1 30.6 19.7 43.7 30.7c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8c-13.1 11-27.7 21.6-43.7 30.7c-14.7 8.4-31.8-3.1-31.8-20V280z", "M184 160c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H96v48h40v72c0 13.3 10.7 24 24 24s24-10.7 24-24V280h48v72c0 13.3 10.7 24 24 24s24-10.7 24-24V280h48v72c0 13.3 10.7 24 24 24s24-10.7 24-24V280h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H376V160c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H280V160c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H184V160z"]]
};
var faDeerRudolph = {
  prefix: 'fad',
  iconName: 'deer-rudolph',
  icon: [576, 512, [], "f78f", ["M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 30.9 25.1 56 56 56h8 8 56c8.8 0 16-7.2 16-16s-7.2-16-16-16h-5.4c3.5-7.3 5.4-15.4 5.4-24V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24h-8-8c-13.3 0-24-10.7-24-24V16zm216 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24H400c-2.3 0-4.6 .5-6.6 1.4c18 3.2 34.9 11.6 48.3 24.3C459.7 80.4 472 61.7 472 40V16zm48 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z", "M320 96l-50.4 12.6c-8 2-13.6 9.2-13.6 17.4c0 9.9 8 18 18 18h38l-9.6 32H196.3c-.8 0-1.7 0-2.5 0c-.6 0-1.2 0-1.7 0H128 113.9h-7.9C51.7 176 6.6 217.8 2.4 272L.1 302.2c-1 13.2 8.9 24.8 22.1 25.8c13 1 24.4-8.6 25.7-21.5c2.4 3.3 5.2 6.5 8.1 9.5c9 9 9 23.5 2.4 34.4c-17.4 28.6-21.5 63.9-10 96.3l15.5 44C68.4 503.4 80.5 512 94.1 512H128c22.1 0 37.5-21.8 30.2-42.6l-19.3-54.7c-2.2-6.2-.6-13 4-17.7l10.6-10.6c12.1-12.1 19.8-27.9 21.9-44.8c21 16.5 47.5 26.4 76.3 26.4H288V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V368 304l26.7-80H416h50.7c25 0 45.3-20.3 45.3-45.3c0-1.2 0-2.4-.1-3.6C493.7 171.4 480 155.3 480 136c0-2.5 .2-5 .7-7.3L443.4 91.4C425.9 73.9 402.1 64 377.3 64c-5.7 0-11.3 .9-16.6 2.5c4.4 2.8 7.3 7.8 7.3 13.5c0 8.8-7.2 16-16 16l-32 0zm80 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faFax = {
  prefix: 'fad',
  iconName: 'fax',
  icon: [512, 512, [128224, 128439], "f1ac", ["M192 0c-35.3 0-64 28.7-64 64V192h64V64H386.7L416 93.3V192h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192zm96 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M32 128c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32zm448 64H128V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faParagraph = {
  prefix: 'fad',
  iconName: 'paragraph',
  icon: [448, 512, [182], "f1dd", ["M320 448l0-352 64 0V448c0 17.7-14.3 32-32 32s-32-14.3-32-32z", "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"]]
};
var faHeadSideHeart = {
  prefix: 'fad',
  iconName: 'head-side-heart',
  icon: [512, 512, [], "e1aa", ["M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm128-35c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z", "M189.3 128c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]]
};
var faSquareE = {
  prefix: 'fad',
  iconName: 'square-e',
  icon: [448, 512, [], "e26d", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V256 152c0-13.3 10.7-24 24-24z", "M128 152c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V256 152z"]]
};
var faMeterFire = {
  prefix: 'fad',
  iconName: 'meter-fire',
  icon: [640, 512, [], "e1eb", ["M351.1 493.7C321.7 505.5 289.6 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C361.7 0 452.5 64.1 491.5 155.5c-5.4-5.3-10.9-10.4-16.6-15.5c-17.7-16-44.7-16-62.5-.1c-9.9 8.9-19.4 18.1-28.5 27.5V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 13.2 7.9 24.5 19.3 29.4c-5 7.1-9.8 14.2-14.1 21.3C304.3 276.5 288 314.9 288 350.1c0 56.1 24.1 107.8 63.1 143.7zM160 128c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zm96 0c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32z", "M443.7 159.9c3.5 0 7 1.3 9.8 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79c0 87.8-71.3 159.8-160 159.8c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7zm37.3 288c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z"]]
};
var faCloudHail = {
  prefix: 'fad',
  iconName: 'cloud-hail',
  icon: [512, 512, [], "f739", ["M128 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M0 224c0 53 43 96 96 96H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z"]]
};
var faCheckToSlot = {
  prefix: 'fad',
  iconName: 'check-to-slot',
  icon: [576, 512, ["vote-yea"], "f772", ["M144 32c-26.5 0-48 21.5-48 48V400H480V80c0-26.5-21.5-48-48-48H144zM409 161L281 289c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L375 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M409 161L281 289c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L375 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 288H96v80H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V288h48c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48z"]]
};
var faVoteYea = faCheckToSlot;
var faMoneyFromBracket = {
  prefix: 'fad',
  iconName: 'money-from-bracket',
  icon: [640, 512, [], "e312", ["M512 448l0-352L128 96l0 352c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64zM192 384c35.3 0 64 28.7 64 64l-64 0 0-64zm192 64c0-35.3 28.7-64 64-64l0 64-64 0zM224 272c0-44.2 43-80 96-80s96 35.8 96 80s-43 80-96 80s-96-35.8-96-80z", "M96 64C78.3 64 64 78.3 64 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 43 43 0 96 0H544c53 0 96 43 96 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7-14.3-32-32-32H96z"]]
};
var faStarHalf = {
  prefix: 'fad',
  iconName: 'star-half',
  icon: [576, 512, [61731], "f089", ["M143.1 512h3.2c-1.1 .1-2.1 .1-3.2 0zM288 439.8V0c0 0 .1 0 .1 0c12.2 0 23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8l-.1 .1z", "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zM429.9 512c1.1 .1 2.1 .1 3.2 0h-3.2z"]]
};
var faCarBus = {
  prefix: 'fad',
  iconName: 'car-bus',
  icon: [640, 512, [], "f85a", ["M48 416H32c-17.7 0-32-14.3-32-32V74.5c0-16.2 9.2-31 23.7-38.3C71.2 12.4 123.7 0 176.9 0h30.3c53.2 0 105.6 12.4 153.2 36.2C374.8 43.4 384 58.2 384 74.5V128H362.6c-14.9 0-29.4 3-42.6 8.4V120c0-13.3-10.7-24-24-24H208V224h41.9l-16.3 48.9C208.5 290.2 192 319.2 192 352v64H128v32c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V416zM64 120v80c0 13.3 10.7 24 24 24h88V96H88c-13.3 0-24 10.7-24 24zm56 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z", "M347.4 234.9L329.7 288H534.3l-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9H362.6c-6.9 0-13 4.4-15.2 10.9zm-87.3 59.4l26.6-79.7C297.6 182 328.2 160 362.6 160H501.4c34.4 0 65 22 75.9 54.7l26.6 79.7C625.2 304.7 640 326.6 640 352v96h0v32c0 17.7-14.3 32-32 32H592c-17.7 0-32-14.3-32-32V448H304v32c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V448h0V352c0-25.4 14.8-47.3 36.1-57.6zM328 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faSpeaker = {
  prefix: 'fad',
  iconName: 'speaker',
  icon: [384, 512, [], "f8df", ["M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM304 336A112 112 0 1 0 80 336a112 112 0 1 0 224 0zM192 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M192 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM128 336a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]]
};
var faTimer = {
  prefix: 'fad',
  iconName: 'timer',
  icon: [512, 512, [], "e29e", ["M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256C0 184.4 29.5 119.6 76.8 73.1c12.6-12.4 32.9-12.2 45.3 .5s12.2 32.9-.5 45.3C86 153.7 64 202.3 64 256c0 106 86 192 192 192s192-86 192-192c0-95.1-69.2-174.1-160-189.3V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32z", "M159 159c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9z"]]
};
var faBoxesStacked = {
  prefix: 'fad',
  iconName: 'boxes-stacked',
  icon: [576, 512, [62625, "boxes", "boxes-alt"], "f468", ["M248 80V16c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM104 336V256h80v80c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16zm288-80h80v80c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V256z", "M248 0H208c-26.5 0-48 21.5-48 48V160c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48H328V80c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V0zM64 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H184v80c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V256H64zM352 512H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H472v80c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V256H352c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2V464c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"]]
};
var faBoxes = faBoxesStacked;
var faBoxesAlt = faBoxesStacked;
var faGrillHot = {
  prefix: 'fad',
  iconName: 'grill-hot',
  icon: [448, 512, [], "e5a5", ["M144 24c0-13.3-10.7-24-24-24S96 10.7 96 24v2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C192 80 181.3 60 163.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v2.6C208 48 218.7 68 236.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C304 80 293.3 60 275.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24z", "M0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 78.1-46.6 145.3-113.6 175.3l47.7 111.2c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L327 472H155.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l7.5-17.5C46.6 337.3 0 270.1 0 192zM155.3 424H306.5l-18.3-42.7C277.7 383.1 267 384 256 384H192c-11 0-21.7-.9-32.2-2.7L147.5 410c3.2 4.3 5.8 9 7.8 14zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faBallotCheck = {
  prefix: 'fad',
  iconName: 'ballot-check',
  icon: [448, 512, [], "f733", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112zm0 256c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368zm144 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM192 128c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 112H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-52.7-27.3c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0l-24-24c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L96 249.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0z", "M64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm0 256v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm91.3-132.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L96 249.4 83.3 236.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48z"]]
};
var faLink = {
  prefix: 'fad',
  iconName: 'link',
  icon: [640, 512, [128279, "chain"], "f0c1", ["M579.8 63.2c56.5 56.5 56.5 148 0 204.5L467.5 380c-56.5 56.5-148 56.5-204.5 0c-50-50-56.5-128.8-15.4-186.3l1.1-1.6c10.3-14.4 30.3-17.7 44.6-7.4s17.7 30.3 7.4 44.6l-1.1 1.6c-22.9 32.1-19.3 76 8.6 103.8c31.5 31.5 82.5 31.5 114 0L534.5 222.5c31.5-31.5 31.5-82.5 0-114C506.7 80.6 462.7 77 430.7 99.9l-1.6 1.1c-14.4 10.3-34.4 6.9-44.6-7.4s-6.9-34.4 7.4-44.6l1.6-1.1C451 6.7 529.8 13.3 579.8 63.2z", "M60.2 448.8c-56.5-56.5-56.5-148 0-204.5L172.5 132c56.5-56.5 148-56.5 204.5 0c50 50 56.5 128.8 15.4 186.3l-1.1 1.6c-10.3 14.4-30.3 17.7-44.6 7.4s-17.7-30.3-7.4-44.6l1.1-1.6c22.9-32.1 19.3-76-8.6-103.9c-31.5-31.5-82.5-31.5-114 0L105.5 289.5C74 321 74 372 105.5 403.5c27.9 27.9 71.8 31.5 103.8 8.6l1.6-1.1c14.4-10.3 34.4-6.9 44.6 7.4s6.9 34.4-7.4 44.6l-1.6 1.1C189 505.3 110.2 498.7 60.2 448.8z"]]
};
var faChain = faLink;
var faEarListen = {
  prefix: 'fad',
  iconName: 'ear-listen',
  icon: [512, 512, ["assistive-listening-systems"], "f2a2", ["M355.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3L384 32C398.3 3.4 398.3 3.4 398.3 3.4l0 0 .1 0 .2 .1 .4 .2c.3 .2 .7 .4 1.2 .7c1 .5 2.3 1.3 4 2.2c3.3 1.9 7.7 4.7 13 8.3c10.5 7.3 24.4 18.3 38.3 33.3C483.5 78.6 512 126 512 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-46-19.5-78.6-39.5-100.3c-10.1-10.9-20.2-18.9-27.7-24.2c-3.7-2.6-6.8-4.5-8.7-5.6c-1-.6-1.7-1-2.1-1.2l-.4-.2c-15.7-7.9-22-27.1-14.2-42.9zM160 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm54.6-86.6l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-64-64c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z", "M128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"]]
};
var faAssistiveListeningSystems = faEarListen;
var faFileMinus = {
  prefix: 'fad',
  iconName: 'file-minus',
  icon: [384, 512, [], "f318", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM120 304c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM120 304c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"]]
};
var faTreeCity = {
  prefix: 'fad',
  iconName: 'tree-city',
  icon: [640, 512, [], "e587", ["M336 0c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48h96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16zm144 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16z", "M222 176c1-5 2-10 2-16c0-53-43-96-96-96c-54 0-96 43-96 96c0 6 0 11 1 16C13 190 0 214 0 240c0 45 35 80 80 80H96V480c0 18 14 32 32 32c17 0 32-14 32-32V320h16c44 0 80-35 80-80c0-26-14-50-34-64z"]]
};
var faPlay = {
  prefix: 'fad',
  iconName: 'play',
  icon: [384, 512, [9654], "f04b", ["", "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"]]
};
var faFont = {
  prefix: 'fad',
  iconName: 'font',
  icon: [448, 512, [], "f031", ["M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z", ""]]
};
var faCupTogo = {
  prefix: 'fad',
  iconName: 'cup-togo',
  icon: [448, 512, ["coffee-togo"], "f6c5", ["M70 392l5.1 61.3c2.8 33.2 30.5 58.7 63.8 58.7H309.1c33.3 0 61-25.5 63.8-58.7L378 392H70zM56.7 232H391.3L400 128H48l8.7 104z", "M55.2 17.7L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32L392.8 17.7C387.4 6.8 376.3 0 364.2 0H83.8C71.7 0 60.6 6.8 55.2 17.7zM378 392l13.3-160H56.7L70 392H378z"]]
};
var faCoffeeTogo = faCupTogo;
var faSquareDownLeft = {
  prefix: 'fad',
  iconName: 'square-down-left',
  icon: [448, 512, [], "e26b", ["M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zm64-281.4V336c0 8.8 7.2 16 16 16H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L264 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7C290 146 285.1 144 280 144s-10 2-13.7 5.7L200 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6z", "M128 336V198.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6L200 216l66.3-66.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7l36.7 36.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L264 280l33.4 33.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H144c-8.8 0-16-7.2-16-16z"]]
};
var faBurgerLettuce = {
  prefix: 'fad',
  iconName: 'burger-lettuce',
  icon: [512, 512, [], "e3e3", ["M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM48 384H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400c0-8.8 7.2-16 16-16z", "M136.2 333c-12 7.2-31.6 19-56.2 19c-21.5 0-38.4-5.4-50.3-11.4c-5.9-3-10.5-6-13.9-8.5c-1.7-1.3-3.1-2.4-4.1-3.3c-.5-.5-1-.9-1.4-1.2l-.5-.5-.2-.2-.1-.1 0 0 0 0c0 0 0 0 22.4-22.4L9.4 326.6c-12.5-12.5-12.5-32.8 0-45.3c12.3-12.3 32-12.5 44.5-.7c.1 .1 .2 .1 .3 .2c.6 .5 2 1.4 4.1 2.5c4.1 2 11.2 4.6 21.7 4.6c5.6 0 10.7-2.4 25.9-11.5c.2-.1 .3-.2 .5-.3c13.2-7.9 33.9-20.2 61.6-20.2c27.5 0 46.3 12.2 58.3 20c.6 .4 1.2 .8 1.8 1.1c11.9 7.7 18 10.9 28 10.9c9.7 0 14.6-2.9 26.2-10.6c.3-.2 .5-.3 .8-.5c12.4-8.3 31.3-20.9 61-20.9c29.5 0 50.1 12.3 63.8 20.7c15.1 9.3 19 11.3 24.2 11.3c10.5 0 17.6-2.6 21.7-4.6c2.1-1 3.5-2 4.1-2.5c.1-.1 .2-.2 .3-.2c12.5-11.8 32.3-11.6 44.5 .7c12.5 12.5 12.5 32.8 0 45.3L480 304c22.6 22.6 22.6 22.6 22.6 22.6l0 0 0 0-.1 .1-.2 .2-.5 .5c-.4 .4-.8 .8-1.4 1.2c-1.1 .9-2.4 2.1-4.1 3.3c-3.4 2.5-8 5.6-13.9 8.5c-11.9 6-28.8 11.4-50.3 11.4c-24.7 0-43.6-11.9-55-19c-1-.6-1.9-1.2-2.8-1.7C361.9 323.7 354.5 320 344 320c-9.7 0-14.6 2.9-26.2 10.6c-.3 .2-.5 .3-.8 .5c-12.4 8.3-31.3 20.9-61 20.9c-29.8 0-49.5-12.6-62.4-21l-.2-.1c-13-8.4-17.7-10.9-25.4-10.9c-8.5 0-15.7 3.3-29.3 11.5c-.8 .5-1.6 1-2.5 1.5z"]]
};
var faRupiahSign = {
  prefix: 'fad',
  iconName: 'rupiah-sign',
  icon: [512, 512, [], "e23d", ["M288 192c0-17.7 14.3-32 32-32h80c61.9 0 112 50.1 112 112s-50.1 112-112 112H352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 192zm64 128h48c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96z", "M32 32C14.3 32 0 46.3 0 64V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h42.3l56 139.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6L170.3 307.7C220.8 285.3 256 234.8 256 176c0-79.5-64.5-144-144-144H32zm80 224H64V96h48c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]]
};
var faMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'magnifying-glass',
  icon: [512, 512, [128269, "search"], "f002", ["M208 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 352A208 208 0 1 0 208 0a208 208 0 1 0 0 416z", "M330.7 376L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376z"]]
};
var faSearch = faMagnifyingGlass;
var faTableTennisPaddleBall = {
  prefix: 'fad',
  iconName: 'table-tennis-paddle-ball',
  icon: [512, 512, [127955, "ping-pong-paddle-ball", "table-tennis"], "f45d", ["", "M416 320a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM301.4 358.8c21-42 64.4-70.8 114.6-70.8c29 0 55.8 9.6 77.2 25.9c35.9-82 20.3-181.2-46.8-248.3c-87.5-87.5-229.3-87.5-316.8 0L69.5 125.7l-.6 .6L301.4 358.8zm-11.3 33.9L49.3 151.9C38.1 171.3 32 193.5 32 216.2V219c0 33.9 13.5 66.5 37.5 90.5l9.8 9.8c13.1 13.1 12.4 34.6-1.7 46.8L11 423.8C4.3 429.6 .3 438 0 446.9s3.1 17.5 9.4 23.8l32 32c6.3 6.3 14.9 9.7 23.8 9.4s17.2-4.3 23-11l57.7-66.6c12.2-14 33.7-14.8 46.8-1.7l9.8 9.8c24 24 56.6 37.5 90.5 37.5h2.7c3.1 0 6.1-.1 9.2-.3C294.2 460.9 288 439.2 288 416c0-7.9 .7-15.7 2.1-23.3z"]]
};
var faPingPongPaddleBall = faTableTennisPaddleBall;
var faTableTennis = faTableTennisPaddleBall;
var faPersonDotsFromLine = {
  prefix: 'fad',
  iconName: 'person-dots-from-line',
  icon: [640, 512, ["diagnoses"], "f470", ["M232 88a88 88 0 1 1 176 0A88 88 0 1 1 232 88zM208 322.7c-47.3 15.8-82.3 37.7-97.3 50.1c-20.4 17-50.6 14.2-67.6-6.1s-14.2-50.6 6.1-67.6c8-6.6 18.6-14.4 31.7-22.5c8.4 7.1 19.2 11.4 31 11.4c26.5 0 48-21.5 48-48c0-.7 0-1.4 0-2.1c45.1-17 99.8-29.9 160-29.9c47.3 0 91.1 7.9 129.6 19.6c-1.1 4-1.6 8.1-1.6 12.4c0 26.5 21.5 48 48 48c17.7 0 33.2-9.6 41.5-23.9c23.1 12.5 41.2 25 53.2 35c20.4 17 23.1 47.2 6.1 67.6s-47.2 23.1-67.6 6.1c-15-12.5-50-34.4-97.3-50.1V432H208V322.7zM304 280a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M96 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM32 488c0-13.3 10.7-24 24-24H584c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM496 224a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faDiagnoses = faPersonDotsFromLine;
var faChevronsDown = {
  prefix: 'fad',
  iconName: 'chevrons-down',
  icon: [512, 512, ["chevron-double-down"], "f322", ["M278.6 278.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 210.7 425.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192z", "M278.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 402.7 425.4 233.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192z"]]
};
var faChevronDoubleDown = faChevronsDown;
var faTrashCanArrowUp = {
  prefix: 'fad',
  iconName: 'trash-can-arrow-up',
  icon: [448, 512, ["trash-restore-alt"], "f82a", ["M32 96H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V96zM248 241.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V376c0 13.3 10.7 24 24 24s24-10.7 24-24V241.9z", "M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8zM248 241.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V376c0 13.3 10.7 24 24 24s24-10.7 24-24V241.9z"]]
};
var faTrashRestoreAlt = faTrashCanArrowUp;
var faSignalGood = {
  prefix: 'fad',
  iconName: 'signal-good',
  icon: [640, 512, ["signal-3"], "f68e", ["M608 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM480 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V128z", "M320 192c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"]]
};
var faSignal3 = faSignalGood;
var faLocationQuestion = {
  prefix: 'fad',
  iconName: 'location-question',
  icon: [384, 512, ["map-marker-question"], "f60b", ["M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM105.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 232.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V218.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M158.6 96c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V232c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H158.6zM192 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faMapMarkerQuestion = faLocationQuestion;
var faFloppyDiskCircleXmark = {
  prefix: 'fad',
  iconName: 'floppy-disk-circle-xmark',
  icon: [576, 512, ["floppy-disk-times", "save-circle-xmark", "save-times"], "e181", ["M0 96C0 60.7 28.7 32 64 32H306.7c17 0 33.3 6.7 45.3 18.7L429.3 128c12 12 18.7 28.3 18.7 45.3v19.5c-5.3-.5-10.6-.7-16-.7c-75 0-139.1 47-164.4 113.1C256.1 294.5 240.8 288 224 288c-35.3 0-64 28.7-64 64s28.7 64 64 64c13.3 0 25.7-4.1 35.9-11c6 28.1 18.7 53.7 36.3 75H64c-35.3 0-64-28.7-64-64V96zm96 0c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faFloppyDiskTimes = faFloppyDiskCircleXmark;
var faSaveCircleXmark = faFloppyDiskCircleXmark;
var faSaveTimes = faFloppyDiskCircleXmark;
var faNairaSign = {
  prefix: 'fad',
  iconName: 'naira-sign',
  icon: [448, 512, [], "e1f6", ["M64 256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V256zm64 64H228.2l-42.7-64H128v64zm134.5-64l42.7 64H320V256H262.5zM384 256v64h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384z", "M86.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L320 342.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 14.1-9.2 26.5-22.7 30.6s-28.1-1.1-35.9-12.9L128 169.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-14.1 9.2-26.5 22.7-30.6z"]]
};
var faPeach = {
  prefix: 'fad',
  iconName: 'peach',
  icon: [512, 512, [], "e20b", ["M218.9 119.9c-16.1-5.1-33.2-7.9-50.9-7.9C75.2 112 0 187.2 0 280C0 416.2 199.3 494.6 240.6 509.4c5 1.8 10.1 2.6 15.4 2.6s10.4-.8 15.4-2.6C312.7 494.6 512 416.2 512 280c0-92.8-75.2-168-168-168c-18.3 0-35.9 2.9-52.3 8.3c-.8 .3-1.5 .5-2.3 .7c43.8 33.5 73.4 84.7 78 143c.7 8.8-6.5 16-15.4 16s-15.9-7.2-16.8-16c-6.4-68-53.3-124.1-116.3-144.2z", "M377.5 82.8C366.6 81 355.4 80 344 80c-31.5 0-61.4 7.3-88 20.4C229.4 87.3 199.5 80 168 80c-11.4 0-22.6 1-33.5 2.8C120.5 67.2 112 46.6 112 24c0-13.3 10.7-24 24-24h24c53 0 96 43 96 96c0-53 43-96 96-96h24c13.3 0 24 10.7 24 24c0 22.6-8.5 43.2-22.5 58.8z"]]
};
var faTaxiBus = {
  prefix: 'fad',
  iconName: 'taxi-bus',
  icon: [640, 512, [], "e298", ["M32 416H48v32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V416h64V352c0-32.8 16.5-61.8 41.6-79.1L249.9 224H208V96h88c13.3 0 24 10.7 24 24v16.4c5.7-2.4 11.7-4.3 17.8-5.6C343.6 110.7 362.1 96 384 96V74.5c0-16.2-9.2-31-23.7-38.3C312.8 12.4 260.3 0 207.1 0H176.9C123.7 0 71.2 12.4 23.7 36.2C9.2 43.4 0 58.2 0 74.5V384c0 17.7 14.3 32 32 32zM88 96h88V224H88c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm8 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M392 128c-13.3 0-24 10.7-24 24v8h-5.4c-34.4 0-65 22-75.9 54.7l-26.6 79.7C238.8 304.7 224 326.6 224 352v96h0v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H560v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448h0V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H496v-8c0-13.3-10.7-24-24-24H392zm-29.4 96H501.4c6.9 0 13 4.4 15.2 10.9L534.3 288H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
};
var faBracketCurly = {
  prefix: 'fad',
  iconName: 'bracket-curly',
  icon: [256, 512, ["bracket-curly-left"], "7b", ["M64 128c0-53 43-96 96-96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32 14.3-32 32v37.5c0 25.5-10.1 49.9-28.1 67.9L77.3 256l22.6 22.6c18 18 28.1 42.4 28.1 67.9V384c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-53 0-96-43-96-96V346.5c0-8.5-3.4-16.6-9.4-22.6L9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l45.3-45.3c6-6 9.4-14.1 9.4-22.6V128z", ""]]
};
var faBracketCurlyLeft = faBracketCurly;
var faLobster = {
  prefix: 'fad',
  iconName: 'lobster',
  icon: [512, 512, [129438], "e421", ["M160.2 29.4c-1.5 8.7 4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7v91.1c9.3-14.4 21.2-25.8 32-33.7V80.7c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2zM192 256H143.1c-7.5 0-14.8-1.7-21.5-5.1L87.2 233.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4H192V256zm0 48H122.4c-5.2 0-10.3-.8-15.2-2.5L69.1 288.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1H192V304zm0 48H175.1c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1H192l0 0V352zm128 32h16.9c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4H320v32l0 0zm0-48h69.6c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5H320v32zm0-48h48.9c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1H320v32zM304 171.8V80.7c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7V138c10.8 8 22.7 19.4 32 33.7z", "M80 8.2c0-3.7-2.5-6.9-6.1-7.5C70.7 .3 67.4 0 64 0C28.7 0 0 28.7 0 64v64c0 35.3 28.7 64 64 64l.7 0 41.8 27.9C126.2 233 149.4 240 173.1 240H192V384l21.4 64.1c-29.8 1.8-53.4 26.5-53.4 56.8c0 3.9 3.2 7.1 7.1 7.1H344.9c3.9 0 7.1-3.2 7.1-7.1c0-30.2-23.6-55-53.4-56.8L320 384V240h18.9c23.7 0 46.9-7 66.6-20.2L447.3 192l.7 0c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64c-3.4 0-6.7 .3-9.9 .8c-3.6 .6-6.1 3.8-6.1 7.5V72c0 7.7-9.8 11-14.4 4.8L397.4 49.9c-3.7-4.9-11.2-3.9-12.3 2.1c-.7 3.9-1.1 7.9-1.1 11.9v64c0 14.9 5.1 28.6 13.6 39.4l-18.7 12.5C367 187.8 353.1 192 338.9 192H314.2c-10.8-29.1-34.4-49.8-51.2-60.1c-4.3-2.6-9.7-2.6-13.9 0c-16.8 10.3-40.4 31-51.2 60.1H173.1c-14.2 0-28.1-4.2-39.9-12.1l-18.7-12.5c8.5-10.9 13.6-24.6 13.6-39.4V64c0-4.1-.4-8.1-1.1-11.9c-1.1-6-8.6-7.1-12.3-2.1L94.4 76.8C89.8 83 80 79.7 80 72V8.2z"]]
};
var faCartFlatbedEmpty = {
  prefix: 'fad',
  iconName: 'cart-flatbed-empty',
  icon: [640, 512, ["dolly-flatbed-empty"], "f476", ["M162.7 448c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H162.7zm288 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7z", "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32z"]]
};
var faDollyFlatbedEmpty = faCartFlatbedEmpty;
var faColon = {
  prefix: 'fad',
  iconName: 'colon',
  icon: [192, 512, [], "3a", ["M32 384a64 64 0 1 1 128 0A64 64 0 1 1 32 384z", "M32 128a64 64 0 1 1 128 0A64 64 0 1 1 32 128z"]]
};
var faCartArrowDown = {
  prefix: 'fad',
  iconName: 'cart-arrow-down',
  icon: [576, 512, [], "f218", ["M312 32H120.1c2 4.2 3.5 8.8 4.4 13.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360l0 110.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L312 32z", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-51.6-271C119.5 19.1 96.4 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM360 142.1V32l-48 0V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23z"]]
};
var faWand = {
  prefix: 'fad',
  iconName: 'wand',
  icon: [512, 512, [], "f72a", ["", "M497 7c-9-9-23.5-9.4-33-.9L189.3 251.9c-2.9 2.6-6.7 4.1-10.7 4.1H144c-8.8 0-16 7.2-16 16v27.6c0 4.6-1.9 8.9-5.3 11.9L11.1 411.3C4 417.7 0 426.7 0 436.2c0 8.8 3.5 17.3 9.7 23.5l42.6 42.6c6.2 6.2 14.7 9.8 23.5 9.8c9.5 0 18.5-4 24.8-11.1L372.3 197.3c3-3.4 7.4-5.3 11.9-5.3H400c8.8 0 16-7.2 16-16V154.6c0-3.9 1.5-7.7 4.1-10.7L505.9 48c8.5-9.5 8.1-24-.9-33l-8-8z"]]
};
var faWalkieTalkie = {
  prefix: 'fad',
  iconName: 'walkie-talkie',
  icon: [384, 512, [], "f8ef", ["M192 64c17.7 0 32 14.3 32 32h32c0-17.7 14.3-32 32-32s32 14.3 32 32h16c26.5 0 48 21.5 48 48V300.1c0 12.7-5.1 24.9-14.1 33.9l-3.9 3.9c-9 9-14.1 21.2-14.1 33.9V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V371.9c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-14.1-21.2-14.1-33.9V144c0-26.5 21.5-48 48-48H160c0-17.7 14.3-32 32-32zm-80 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z", "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96h48V24zm0 136c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]]
};
var faFilePen = {
  prefix: 'fad',
  iconName: 'file-pen',
  icon: [576, 512, [128221, "file-edit"], "f31c", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V299.5l-94.7 94.7c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19.1 1.4 27.9H64c-35.3 0-64-28.7-64-64V64z", "M384 160H256c-17.7 0-32-14.3-32-32V0L384 160zm165.9 75.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.5-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417.1L441.2 287.8l71 71L382.9 488.1c-4.1 4.1-9.2 7-14.9 8.4l-60.2 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.2c1.4-5.6 4.3-10.8 8.4-14.9z"]]
};
var faFileEdit = faFilePen;
var faReceipt = {
  prefix: 'fad',
  iconName: 'receipt',
  icon: [384, 512, [129534], "f543", ["M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z", "M80 160c0-8.8 7.2-16 16-16H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm0 192c0-8.8 7.2-16 16-16H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM96 240H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faTablePicnic = {
  prefix: 'fad',
  iconName: 'table-picnic',
  icon: [512, 512, [], "e32d", ["M320.7 64h-1.5c.5 0 1 0 1.5 0zM416 128L96 128c-14.6 0-26.8-9.7-30.7-23c3.9 13.3 16.2 23 30.7 23h48.7l-38.4 96h68.9l38.4-96h84.7l38.4 96h68.9l-38.4-96H416zM0 256c0 17.7 14.3 32 32 32H80.7L34.3 404.1c-6.6 16.4 1.4 35 17.8 41.6s35-1.4 41.6-17.8l56-139.9H362.3l56 139.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6L431.3 288H480L32 288c-17.7 0-32-14.3-32-32zM191.3 64c.5 0 1 0 1.5 0h-1.5zM64 96s0 0 0 0z", "M96 64C78.3 64 64 78.3 64 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H96zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faSquarePen = {
  prefix: 'fad',
  iconName: 'square-pen',
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z", "M269.2 139.7l-21.4 21.4 71 71 21.4-21.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-44 44L119.9 289c-4.1 4.1-7 9.2-8.4 14.9L96.5 364c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L296.1 254.7l-71-71z"]]
};
var faPenSquare = faSquarePen;
var faPencilSquare = faSquarePen;
var faCircleMicrophoneLines = {
  prefix: 'fad',
  iconName: 'circle-microphone-lines',
  icon: [512, 512, ["microphone-circle-alt"], "e117", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 96c-26.5 0-48 21.5-48 48V256c0 26.5 21.5 48 48 48s48-21.5 48-48V240H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c0-26.5-21.5-48-48-48zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 65.3 48.9 119.1 112 127v17c0 8.8 7.2 16 16 16s16-7.2 16-16V383c63.1-7.9 112-61.7 112-127V240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53-43 96-96 96s-96-43-96-96V240z", "M208 144c0-26.5 21.5-48 48-48s48 21.5 48 48H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v16c0 26.5-21.5 48-48 48s-48-21.5-48-48V144zm-64 80c8.8 0 16 7.2 16 16v16c0 53 43 96 96 96s96-43 96-96V240c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 65.3-48.9 119.1-112 127v17c0 8.8-7.2 16-16 16s-16-7.2-16-16V383c-63.1-7.9-112-61.7-112-127V240c0-8.8 7.2-16 16-16z"]]
};
var faMicrophoneCircleAlt = faCircleMicrophoneLines;
var faDisplaySlash = {
  prefix: 'fad',
  iconName: 'display-slash',
  icon: [640, 512, ["desktop-slash"], "e2fa", ["M446.8 448H378.7L368 416h38.2l-81.2-64H96V171.6L32 121.2V352c0 35.3 28.7 64 64 64H272l-10.7 32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H448c17.7 0 32-14.3 32-32c0-2.2-.2-4.3-.6-6.3L446.8 448zM544 352H481.4l79 61.9c27.4-7.2 47.6-32.2 47.6-61.9V64c0-35.3-28.7-64-64-64H96C79.6 0 64.6 6.2 53.2 16.4L113.9 64H544V352z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faDesktopSlash = faDisplaySlash;
var faSuitcaseRolling = {
  prefix: 'fad',
  iconName: 'suitcase-rolling',
  icon: [384, 512, [], "f5c1", ["M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72h48V56c0-30.9-25.1-56-56-56H152C121.1 0 96 25.1 96 56v72h48V56zM96 512c17.7 0 32-14.3 32-32H64c0 17.7 14.3 32 32 32zm192 0c17.7 0 32-14.3 32-32H256c0 17.7 14.3 32 32 32z", "M64 128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm48 96H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faPersonCircleExclamation = {
  prefix: 'fad',
  iconName: 'person-circle-exclamation',
  icon: [576, 512, [], "e53f", ["M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faTransporter2 = {
  prefix: 'fad',
  iconName: 'transporter-2',
  icon: [512, 512, [], "e044", ["M64 32L56.7 6.6C55.6 2.7 52.1 0 48 0s-7.6 2.7-8.7 6.6L32 32 6.6 39.3C2.7 40.4 0 43.9 0 48s2.7 7.6 6.6 8.7L32 64l7.3 25.4C40.4 93.3 43.9 96 48 96s7.6-2.7 8.7-6.6L64 64l25.4-7.3C93.3 55.6 96 52.1 96 48s-2.7-7.6-6.6-8.7L64 32zM480 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 352zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm8 464H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H296 216zM351.3 164l48.1 60H112.6l48.1-60c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36zM96 256.5v-1c0 .3 0 .7 0 1z"]]
};
var faHandsHoldingDiamond = {
  prefix: 'fad',
  iconName: 'hands-holding-diamond',
  icon: [640, 512, ["hand-receiving"], "f47c", ["M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z", "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96z"]]
};
var faHandReceiving = faHandsHoldingDiamond;
var faMoneyBillSimpleWave = {
  prefix: 'fad',
  iconName: 'money-bill-simple-wave',
  icon: [576, 512, [], "e1f2", ["M288 352c44.2 0 80-43 80-96s-35.8-96-80-96s-80 43-80 96s35.8 96 80 96z", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]]
};
var faChevronDown = {
  prefix: 'fad',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", ["M278.6 406.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 338.7 425.4 169.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192z", ""]]
};
var faBatteryFull = {
  prefix: 'fad',
  iconName: 'battery-full',
  icon: [576, 512, [128267, "battery", "battery-5"], "f240", ["M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z", "M96 192H448V320H96z"]]
};
var faBattery = faBatteryFull;
var faBattery5 = faBatteryFull;
var faBellPlus = {
  prefix: 'fad',
  iconName: 'bell-plus',
  icon: [448, 512, [], "f849", ["M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm0 152c13.3 0 24 10.7 24 24v40h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264H160c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V176c0-13.3 10.7-24 24-24z", "M224 152c13.3 0 24 10.7 24 24v40h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264H160c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V176c0-13.3 10.7-24 24-24zm45.3 341.3c-12 12-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3h64 64c0 17-6.7 33.3-18.7 45.3z"]]
};
var faBookArrowRight = {
  prefix: 'fad',
  iconName: 'book-arrow-right',
  icon: [640, 512, [], "e0b9", ["M553 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H248c-13.3 0-24 10.7-24 24s10.7 24 24 24H558.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80zM96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H416V384H96z", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 256 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H256h96 64c17.7 0 32-14.3 32-32V232H248c-13.3 0-24-10.7-24-24s10.7-24 24-24H448V32c0-17.7-14.3-32-32-32H384 96z"]]
};
var faHospitals = {
  prefix: 'fad',
  iconName: 'hospitals',
  icon: [576, 512, [], "f80e", ["M256 48c0-26.5 21.5-48 48-48H528c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H311.4c5.4-9.4 8.6-20.3 8.6-32V128c0-35.3-28.7-64-64-64V48zM424 80c-8.8 0-16 7.2-16 16v24H384c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168h24c8.8 0 16-7.2 16-16V136c0-8.8-7.2-16-16-16H456V96c0-8.8-7.2-16-16-16H424zM576 288H432c-8.8 0-16-7.2-16-16s7.2-16 16-16H576v32zm0 96V352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16H576z", "M408 96v24H384c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168h24c8.8 0 16-7.2 16-16V136c0-8.8-7.2-16-16-16H456V96c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16zM48 96C21.5 96 0 117.5 0 144V384H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v48c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H48zm88 80h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H168v24c0 8.8-7.2 16-16 16H136c-8.8 0-16-7.2-16-16V264H96c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16h24V192c0-8.8 7.2-16 16-16z"]]
};
var faClub = {
  prefix: 'fad',
  iconName: 'club',
  icon: [512, 512, [9827], "f327", ["M288 372.7V256c0-17.7-14.3-32-32-32s-32 14.3-32 32V372.7c-23.5 26.6-57.8 43.3-96 43.3C57.3 416 0 358.7 0 288s57.3-128 128-128c1.4 0 2.7 0 4 .1c-2.6-10.2-4-21-4-32.1C128 57.3 185.3 0 256 0s128 57.3 128 128c0 11.1-1.4 21.8-4 32.1c1.3 0 2.7-.1 4-.1c70.7 0 128 57.3 128 128s-57.3 128-128 128c-38.2 0-72.5-16.8-96-43.3z", "M256 224c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V256c0-17.7 14.3-32 32-32z"]]
};
var faSkullCrossbones = {
  prefix: 'fad',
  iconName: 'skull-crossbones',
  icon: [448, 512, [128369, 9760], "f714", ["M46.3 259.4c-15.8-7.9-35-1.5-42.9 14.3s-1.5 35 14.3 42.9L152.4 384 17.7 451.4C1.9 459.3-4.5 478.5 3.4 494.3s27.1 22.2 42.9 14.3L224 419.8l177.7 88.8c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L295.6 384l134.8-67.4c15.8-7.9 22.2-27.1 14.3-42.9s-27.1-22.2-42.9-14.3L224 348.2 46.3 259.4z", "M304 234.4c38.6-23 64-62.1 64-106.4C368 57.3 303.5 0 224 0S80 57.3 80 128c0 44.4 25.4 83.5 64 106.4V256c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V234.4zM136 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm144-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faDropletDegree = {
  prefix: 'fad',
  iconName: 'droplet-degree',
  icon: [512, 512, ["dewpoint"], "f748", ["M432 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320z"]]
};
var faDewpoint = faDropletDegree;
var faCodeCompare = {
  prefix: 'fad',
  iconName: 'code-compare',
  icon: [512, 512, [], "e13a", ["M400 153.3c9.8 4.3 20.6 6.7 32 6.7s22.2-2.4 32-6.7V320c0 70.7-57.3 128-128 128H320v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v40h16c35.3 0 64-28.7 64-64V153.3zM112 358.7c-9.8-4.3-20.6-6.7-32-6.7s-22.2 2.4-32 6.7V192c0-70.7 57.3-128 128-128h16V24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V128H176c-35.3 0-64 28.7-64 64V358.7z", "M408 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0A80 80 0 1 0 352 80a80 80 0 1 0 160 0zM104 432a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM0 432a80 80 0 1 0 160 0A80 80 0 1 0 0 432z"]]
};
var faListUl = {
  prefix: 'fad',
  iconName: 'list-ul',
  icon: [512, 512, ["list-dots"], "f0ca", ["M160 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm32 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]]
};
var faListDots = faListUl;
var faHandHoldingMagic = {
  prefix: 'fad',
  iconName: 'hand-holding-magic',
  icon: [576, 512, [], "f6e5", ["M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z", "M208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c17.7 0 32 14.3 32 32s-14.3 32-32 32H208c-44.2 0-80-35.8-80-80s35.8-80 80-80H320c70.7 0 128 57.3 128 128s-57.3 128-128 128H288c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32h64c35.3 0 64-28.7 64-64s-28.7-64-64-64H208z"]]
};
var faWatermelonSlice = {
  prefix: 'fad',
  iconName: 'watermelon-slice',
  icon: [512, 512, [], "e337", ["M16.2 385.3L385.3 16.2c-2.9 8.4-1 18.1 5.7 24.8c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391c-6.7-6.7-16.4-8.6-24.8-5.7zM339.3 156.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm-80 80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm88 8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm-168 72c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm88 8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16z", "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391zM339.3 156.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm-80 80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm88 8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm-168 72c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm88 8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16z"]]
};
var faCircleEllipsis = {
  prefix: 'fad',
  iconName: 'circle-ellipsis',
  icon: [512, 512, [], "e10a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M128 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faSchoolLock = {
  prefix: 'fad',
  iconName: 'school-lock',
  icon: [640, 512, [], "e56f", ["M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0H384c0-23.7 12.9-44.4 32-55.4V272c0-61.9 50.1-112 112-112s112 50.1 112 112V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faTowerCell = {
  prefix: 'fad',
  iconName: 'tower-cell',
  icon: [576, 512, [], "e585", ["M80.3 44C86.9 27.6 79 9 62.6 2.3S27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84zM555.1 20C548.4 3.6 529.8-4.3 513.4 2.3S489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z", "M340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448H398.3l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32H354.7l14.5 32zM288 205.3L325.6 288H250.4L288 205.3z"]]
};
var faSdCards = {
  prefix: 'fad',
  iconName: 'sd-cards',
  icon: [448, 512, [], "e240", ["M304 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V88zm80 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V88zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z", "M448 64c0-35.3-28.7-64-64-64H237.3C220.3 0 204 6.7 192 18.7L114.7 96c-12 12-18.7 28.3-18.7 45.3V352c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64zM304 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"]]
};
var faJugBottle = {
  prefix: 'fad',
  iconName: 'jug-bottle',
  icon: [640, 512, [], "e5fb", ["M448 88c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v40H448V88zM416 392.6c.3-.2 .7-.4 1-.6c-.3-.2-.7-.4-1-.6V256c0-24.7-5.6-48.1-15.6-69c5.1-5.3 11.1-9.8 18-13l13.1-6.2c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l13.1 6.2c21 9.9 34.5 31 34.5 54.2c0 22.8-12.7 42.6-31.5 52.7C627.4 292 640 312.5 640 336c0 24.1-13.3 45.1-33 56c19.7 10.9 33 31.9 33 56c0 35.3-28.7 64-64 64H448c-17 0-32.5-6.7-44-17.5c7.6-13.8 12-29.6 12-46.5V392.6z", "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]]
};
var faDownLong = {
  prefix: 'fad',
  iconName: 'down-long',
  icon: [320, 512, ["long-arrow-alt-down"], "f309", ["M224 320H96v0h0L96 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l0 160h0V320z", "M313.4 360.5c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5H224L96 320H24c-9.6 0-18.2 5.7-22 14.5s-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144z"]]
};
var faLongArrowAltDown = faDownLong;
var faEnvelopes = {
  prefix: 'fad',
  iconName: 'envelopes',
  icon: [576, 512, [], "e170", ["M96.7 86.7l220 163c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4l220-163C570.8 55.7 544.2 32 512 32H160c-32.2 0-58.8 23.7-63.3 54.7zM576 126L374.4 275.3C363.3 283.6 349.8 288 336 288s-27.3-4.4-38.4-12.7L96 126V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V126z", "M96 96v30L297.6 275.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L576 126V96c0-3.2-.2-6.3-.7-9.3l-220 163c-5.6 4.1-12.4 6.4-19.3 6.4s-13.7-2.2-19.3-6.4l-220-163c-.4 3-.7 6.2-.7 9.3zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]]
};
var faPhoneOffice = {
  prefix: 'fad',
  iconName: 'phone-office',
  icon: [576, 512, [], "f67d", ["M128 0C110.3 0 96 14.3 96 32V384c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H128zM320 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM320 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z", "M64 32H96V384c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32zM352 96c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H352zM320 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm160-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM448 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-96-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]]
};
var faRankingStar = {
  prefix: 'fad',
  iconName: 'ranking-star',
  icon: [640, 512, [], "e561", ["M224 288c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V288zM0 352c0-17.7 14.3-32 32-32H160c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V352zm480 32H608c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z", "M330.2 6.3l23.6 47.8 52.3 7.5c9.3 1.4 13.2 12.9 6.4 19.8l-38 36.6 9 52.1c1.4 9.3-8.2 16.5-16.8 12.2l-46.6-24.4-46.9 24.8c-8.6 4.3-18.3-2.9-16.8-12.2l9-52.1-38-37c-6.8-6.8-2.9-18.3 6.4-19.8l52.3-7.5L309.8 6.3c4.3-8.6 16.5-8.3 20.4 0z"]]
};
var faChessKing = {
  prefix: 'fad',
  iconName: 'chess-king',
  icon: [448, 512, [9818], "f43f", ["M368 432H80L38.6 473.4c-4.2 4.2-6.6 10-6.6 16C32 501.9 42.1 512 54.6 512H393.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L368 432z", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V48H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v48H40.9C18.3 160 0 178.3 0 200.9c0 4.7 .8 9.3 2.4 13.8L80 432H368l77.6-217.3c1.6-4.4 2.4-9.1 2.4-13.8c0-22.6-18.3-40.9-40.9-40.9H256V112h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V32z"]]
};
var faNfcPen = {
  prefix: 'fad',
  iconName: 'nfc-pen',
  icon: [576, 512, [], "e1fa", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H258.5l14-55.9c.7-2.8 1.6-5.5 2.6-8.1H112c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H299.6L352 331.6V144c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16v66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-26.5 21.5-48 48-48h80c26.5 0 48 21.5 48 48V299.6l64-64V96c0-35.3-28.7-64-64-64H64z", "M493.2 235.7l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L311.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 358.7l-71-71z"]]
};
var faPersonHarassing = {
  prefix: 'fad',
  iconName: 'person-harassing',
  icon: [576, 512, [], "e549", ["M432 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm88 0c-30.9 0-56 25.1-56 56v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56z", "M144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM88 256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6H181c28.6 0 55.6 12.7 73.9 34.7l73.7 88.9c11.3 13.6 9.4 33.8-4.2 45.1s-33.8 9.4-45.1-4.2L232 235.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9zM288 48c0-8.8 7.2-16 16-16h56c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm-.8 49.7l48 24c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-48-24c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2z"]]
};
var faHatWinter = {
  prefix: 'fad',
  iconName: 'hat-winter',
  icon: [512, 512, [], "f7a8", ["M256 0c-12.7 0-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C185.8 57 176 67.3 176 80s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C233 150.2 243.3 160 256 160s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C326.2 103 336 92.7 336 80s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2C279 9.8 268.7 0 256 0zM48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48H464c26.5 0 48-21.5 48-48s-21.5-48-48-48H48z", "M199 136.1c.1 .2 .3 .3 .4 .4c8.9 8.9 23.2 9.4 32.6 1.2C233 150.2 243.3 160 256 160s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2c.1-.1 .3-.3 .4-.4c78.9 24 120.7 96.7 142.8 162.1l-.7 .3c-4.5 2.3-9.8 2.3-14.3 0l-35.4-17.7c-13.5-6.8-29.4-6.8-42.9 0l-35.4 17.7c-4.5 2.3-9.8 2.3-14.3 0l-35.4-17.7c-13.5-6.8-29.4-6.8-42.9 0l-35.4 17.7c-4.5 2.3-9.8 2.3-14.3 0l-35.4-17.7c-13.5-6.8-29.4-6.8-42.9 0L71.2 298.5c-4.5 2.3-9.8 2.3-14.3 0l-.7-.3c22.1-65.3 64-138.1 142.8-162.1zM46.9 329.1c12.5 4.8 26.5 4.1 38.6-1.9l35.4-17.7c4.5-2.3 9.8-2.3 14.3 0l35.4 17.7c13.5 6.8 29.4 6.8 42.9 0l35.4-17.7c4.5-2.3 9.8-2.3 14.3 0l35.4 17.7c13.5 6.8 29.4 6.8 42.9 0l35.4-17.7c4.5-2.3 9.8-2.3 14.3 0l35.4 17.7c12.1 6 26.1 6.7 38.6 1.9C477.9 377.7 480 416 480 416v2.7c-5-1.8-10.4-2.7-16-2.7H48c-5.6 0-11 1-16 2.7V416s2.1-38.3 14.9-86.9z"]]
};
var faBrazilianRealSign = {
  prefix: 'fad',
  iconName: 'brazilian-real-sign',
  icon: [512, 512, [], "e46c", ["M400 0c17.7 0 32 14.3 32 32V50.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V460.6c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2V32c0-17.7 14.3-32 32-32z", "M32 32C14.3 32 0 46.3 0 64V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h42.3l56 139.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6L170.3 307.7C220.8 285.3 256 234.8 256 176c0-79.5-64.5-144-144-144H32zm80 224H64V96h48c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]]
};
var faLandmarkDome = {
  prefix: 'fad',
  iconName: 'landmark-dome',
  icon: [512, 512, ["landmark-alt"], "f752", ["M128 256H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V256H384V416H344V256H280V416H232V256H168V416H128V256z", "M248 0c-13.3 0-24 10.7-24 24V34.7C143.6 48.1 80.1 111.6 66.7 192H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H448c17.7 0 32-14.3 32-32s-14.3-32-32-32h-2.7C431.9 111.6 368.4 48.1 288 34.7V24c0-13.3-10.7-24-24-24H248z"]]
};
var faLandmarkAlt = faLandmarkDome;
var faBoneBreak = {
  prefix: 'fad',
  iconName: 'bone-break',
  icon: [640, 512, [], "f5d8", ["M80 192c26.1 0 49.3 12.5 63.9 31.8c10.1 13.3 25.7 23.8 42.1 20.5l70.6-14.1c17.3-3.5 34.2 7.8 37.7 25.1L320 384 210.6 405.9C199 408.2 192 420.1 192 432c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-24.5 11.1-46.5 28.5-61.2c3.7-3.1 5.7-7.9 4.8-12.6s-4.7-8.4-9.3-9.8C23.5 338.1 0 307.8 0 272c0-44.2 35.8-80 80-80zm416.1 31.8C510.7 204.5 533.9 192 560 192c44.2 0 80 35.8 80 80c0 35.8-23.5 66.1-55.9 76.3c-4.6 1.5-8.3 5.1-9.3 9.8s1.1 9.5 4.8 12.6C596.9 385.5 608 407.5 608 432c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-11.9-7-23.8-18.6-26.1L320 384l25.7-128.6c3.5-17.3 20.3-28.6 37.7-25.1L454 244.4c16.4 3.3 32.1-7.2 42.1-20.5z", "M320 0c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM167 71c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9zM473 71c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faArrowUp = {
  prefix: 'fad',
  iconName: 'arrow-up',
  icon: [384, 512, [8593], "f062", ["M160 141.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l-32-32-32 32z", "M169.4 41.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 109.3 54.6 246.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"]]
};
var faDownFromDottedLine = {
  prefix: 'fad',
  iconName: 'down-from-dotted-line',
  icon: [448, 512, [], "e407", ["M384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM224 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z", "M196.7 468.7L73.9 345.9c-6.4-6.4-9.9-15-9.9-24C64 303.2 79.2 288 97.9 288H160V160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V288h62.1c18.7 0 33.9 15.2 33.9 33.9c0 9-3.6 17.6-9.9 24L251.3 468.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3z"]]
};
var faTv = {
  prefix: 'fad',
  iconName: 'tv',
  icon: [640, 512, [63717, "television", "tv-alt"], "f26c", ["M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M64 64H576V352H64V64z"]]
};
var faTelevision = faTv;
var faTvAlt = faTv;
var faBorderLeft = {
  prefix: 'fad',
  iconName: 'border-left',
  icon: [448, 512, [], "f84f", ["M128 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-448a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64z", "M32 480c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32s32 14.3 32 32l0 384c0 17.7-14.3 32-32 32z"]]
};
var faCircleDivide = {
  prefix: 'fad',
  iconName: 'circle-divide',
  icon: [512, 512, [], "e106", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM168 232H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M224 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 96c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24zm112 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faShrimp = {
  prefix: 'fad',
  iconName: 'shrimp',
  icon: [512, 512, [129424], "e448", ["M0 96C0 60.7 28.7 32 64 32H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H64C46.3 64 32 78.3 32 96s14.3 32 32 32v32C28.7 160 0 131.3 0 96zM288 320V128h32V320H288zm76.9 8.5l133.5-92.4c4.3 10.2 7.6 20.9 9.9 32.1L382.8 355.1c-2.6-10.9-9.1-20.2-17.9-26.6zm17.2 50.3L472.6 415c-7.3 9-15.5 17.3-24.5 24.7l-86.5-34.6c9.7-5.7 17.2-15 20.5-26.2zM352 409.4v69.9c-5.3 .5-10.6 .7-16 .7H320V407.8l3.2 1.1c9.9 3.4 19.9 3.3 28.8 .5z", "M64 128H88.8 256h32V320H256 232h0c-92.8 0-168-75.2-168-168V128zM320 320V128h16c73.1 0 135.8 44.6 162.4 108.1L364.9 328.5c-7.5-5.4-16.7-8.5-26.6-8.5H320zm62.8 35.1l125.6-86.9c2.4 11.6 3.7 23.6 3.7 35.9c0 42.1-14.8 80.7-39.4 111l-90.5-36.2c1.2-4.1 1.9-8.5 1.9-13.1c0-3.7-.4-7.2-1.2-10.6zm-21.2 50l86.5 34.6c-26.6 22-59.8 36.3-96.1 39.6V409.4c3.4-1.1 6.6-2.5 9.6-4.3zM320 407.8V480H248c-13.3 0-24-10.7-24-24c0-12.1 9-22.1 20.6-23.8l-4.5-1.6c-12.5-4.4-19.1-18.1-14.7-30.6s18.1-19.1 30.6-14.7L320 407.8zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faListCheck = {
  prefix: 'fad',
  iconName: 'list-check',
  icon: [512, 512, ["tasks"], "f0ae", ["M160 416c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm64-160c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-17.7 0-32 14.3-32 32zm32-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-17.7 0-32 14.3-32 32s14.3 32 32 32z", "M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM48 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
};
var faTasks = faListCheck;
var faDiagramSubtask = {
  prefix: 'fad',
  iconName: 'diagram-subtask',
  icon: [512, 512, [], "e479", ["M96 320V224h64v96c0 17.7 14.3 32 32 32h32v64H192c-53 0-96-43-96-96z", "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM288 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H288z"]]
};
var faJugDetergent = {
  prefix: 'fad',
  iconName: 'jug-detergent',
  icon: [384, 512, [], "e519", ["M120 0C106.7 0 96 10.7 96 24V48H88C74.7 48 64 58.7 64 72s10.7 24 24 24H232c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V24c0-13.3-10.7-24-24-24H120z", "M128 128C57.3 128 0 185.3 0 256V480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V256c0-70.7-57.3-128-128-128H128zm160 96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32z"]]
};
var faCircleUser = {
  prefix: 'fad',
  iconName: 'circle-user',
  icon: [512, 512, [62142, "user-circle"], "f2bd", ["M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z", "M256 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 176c56.8 0 107.8-24.7 143-63.8C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8z"]]
};
var faUserCircle = faCircleUser;
var faSquareY = {
  prefix: 'fad',
  iconName: 'square-y',
  icon: [448, 512, [], "e287", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm74.1 120.3L224 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24V297L101.9 183.7c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z", "M104.3 149.9c10-8.7 25.2-7.6 33.9 2.4L224 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24V297L101.9 183.7c-8.7-10-7.6-25.2 2.4-33.9z"]]
};
var faUserDoctorHair = {
  prefix: 'fad',
  iconName: 'user-doctor-hair',
  icon: [448, 512, [], "e458", ["M176 112H120c-7.9 0-15.5-1.7-22.3-4.6C96.6 114.1 96 121 96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11-1.4-21.8-4-32H312c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112z", "M120 112h56c34.6 0 65-18.3 81.9-45.8C269.2 84.1 289.2 96 312 96h36C333.8 40.8 283.6 0 224 0C160.3 0 107.5 46.5 97.7 107.4c6.8 3 14.4 4.6 22.3 4.6zM288 304.2c-2.7-.1-5.3-.2-8-.2H168c-2.7 0-5.3 .1-8 .2v66.1c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V308.8C54.5 326.7 0 393 0 472v8c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32v-8c0-79-54.5-145.3-128-163.2V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.2zM168 424a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]]
};
var faPlanetRinged = {
  prefix: 'fad',
  iconName: 'planet-ringed',
  icon: [512, 512, [129680], "e020", ["M503.9 8.1c35.2 35.2-47.3 174.7-184.2 311.6S43.3 539.1 8.1 503.9c-22.1-22.1 2.3-85.6 57.6-163.7c9.1 20.7 21.8 40.2 38 57.5c-5.7 8.8-11.1 17.8-16.3 26.9c69.3-39.6 130.8-94 187-150.1s110.6-117.7 150.1-187c-9.1 5.2-18 10.6-26.9 16.3c-17.4-16.2-36.9-28.9-57.5-38C418.3 10.4 481.7-14 503.9 8.1z", "M408.3 114.3C370.3 73.5 316.1 48 256 48C141.1 48 48 141.1 48 256c0 60.1 25.5 114.3 66.3 152.3c58.5-37.6 111.3-85 160.1-133.8s96.3-101.7 133.8-160.1zm38 57.5c-32.6 46-75.8 97.1-126.6 147.9s-101.8 94-147.9 126.6C197.6 457.7 226 464 256 464c114.9 0 208-93.1 208-208c0-30-6.3-58.4-17.7-84.2z"]]
};
var faMushroom = {
  prefix: 'fad',
  iconName: 'mushroom',
  icon: [512, 512, [127812], "e425", ["M224 176c44.2 0 80-35.8 80-80c0-26-12.4-49.2-31.7-63.8c-3.5-.2-6.9-.2-10.4-.2H250.1c-33.1 0-64.5 7.1-92.9 19.9C148.9 64.5 144 79.7 144 96c0 44.2 35.8 80 80 80zm208-64c-35.3 0-64 28.7-64 64s28.7 64 64 64c21.2 0 40-10.3 51.7-26.2c-7.6-38.3-24.9-73.1-49.2-101.7c-.8 0-1.7 0-2.5 0zM160 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm153 96H199L169 440.2c-2.4 9.6-.2 19.7 5.8 27.5s15.4 12.3 25.2 12.3H312c9.9 0 19.2-4.5 25.2-12.3s8.2-17.9 5.8-27.5L313 320z", "M224 176c44.2 0 80-35.8 80-80c0-26-12.4-49.2-31.7-63.8c65 2.9 122.8 33.3 162.2 79.8c-.8 0-1.7 0-2.5 0c-35.3 0-64 28.7-64 64s28.7 64 64 64c21.2 0 40-10.3 51.7-26.2c2.8 14.3 4.3 29.1 4.3 44.3c0 34.2-27.7 61.9-61.9 61.9H85.9C51.7 320 24 292.3 24 258.1C24 166.3 78.7 87.3 157.3 51.9C148.9 64.5 144 79.7 144 96c0 44.2 35.8 80 80 80zm-96 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faUserShield = {
  prefix: 'fad',
  iconName: 'user-shield',
  icon: [640, 512, [], "f505", ["M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c17.6 0 34.6 2.6 50.7 7.3c3.3 59.2 26.8 145.1 103.1 200.2c-1.7 .3-3.5 .5-5.3 .5H29.7C13.3 512 0 498.7 0 482.3z", "M504.9 225.7c-5.7-2.3-12.1-2.3-17.8 0l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48zm-8.9 236V273.8L591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7z"]]
};
var faMegaphone = {
  prefix: 'fad',
  iconName: 'megaphone',
  icon: [576, 512, [128227], "f675", ["M64 190.9L512 64V448L64 321.1C63.4 338.2 49.3 352 32 352c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32c17.3 0 31.4 13.8 32 30.9z", "M544 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32zM160 384c0 53 43 96 96 96c46.8 0 85.8-33.5 94.3-77.8L303.7 389c-2.5 24.2-22.9 43-47.7 43c-26.5 0-48-21.5-48-48c0-7.4 1.7-14.5 4.7-20.8L166.2 350c-4 10.6-6.2 22-6.2 34z"]]
};
var faWreathLaurel = {
  prefix: 'fad',
  iconName: 'wreath-laurel',
  icon: [640, 512, [], "e5d2", ["M384 0c61.9 0 112 50.1 112 112v1c10.2-26.2 29-49.2 55.3-64.4c7.7-4.4 17.4-1.8 21.9 5.9l8 13.9c24.5 42.4 21.9 93.1-2.3 131.9c14.1-5.3 29.3-8.2 45.2-8.2c8.8 0 16 7.2 16 16v16c0 49-27.5 91.6-68 113.1c14.8 2.4 29.5 7.5 43.2 15.5c7.7 4.4 10.3 14.2 5.9 21.9l-8 13.9c-33.6 58.1-105.8 80-165.4 51.8c-5.3 3.7-10.7 7.1-16.3 10.3c-31.8-12.1-65.6-18.4-99.8-18.4H320c97.2 0 176-78.8 176-176c0-40.6-13.1-79.9-37-112.1C399.5 141.3 352 92.2 352 32V16c0-8.8 7.2-16 16-16h16zM208.6 450.4C241.4 469.2 279.5 480 320 480H308.4c-36 0-71.5 8.4-103.8 24.5l-9.9 5c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l9.9-5c8.3-4.2 16.8-7.9 25.4-11.2z", "M144 112C144 50.1 194.1 0 256 0h16c8.8 0 16 7.2 16 16V32c0 60.2-47.5 109.3-107 111.9c-23.9 32.2-37 71.5-37 112.1c0 97.2 78.8 176 176 176h11.6c43.5 0 86.3 10.1 125.2 29.6l9.9 5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-9.9-5C403.1 488.4 367.6 480 331.6 480H320c-47.5 0-91.5-14.8-127.7-39.9c-59.6 28.2-131.9 6.3-165.4-51.8l-8-13.9c-4.4-7.7-1.8-17.4 5.9-21.9c13.8-8 28.4-13.1 43.3-15.5C27.5 315.6 0 273 0 224V208c0-8.8 7.2-16 16-16c15.9 0 31.1 2.9 45.2 8.2c-24.3-38.8-26.8-89.5-2.3-131.9l8-13.9c4.4-7.7 14.2-10.3 21.9-5.9C115 63.7 133.8 86.8 144 113v-1z"]]
};
var faCircleExclamationCheck = {
  prefix: 'fad',
  iconName: 'circle-exclamation-check',
  icon: [640, 512, [], "e10d", ["M480 229.5L506.5 203C482.1 87 379.2 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c94.8 0 177.5-51.5 221.8-128c-15.6-.5-31.1-6.8-43-18.7l-64-64c-25-25-25-65.5 0-90.5s65.5-25 90.5 0L480 229.5zM256 128c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM625 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L625 209z"]]
};
var faWind = {
  prefix: 'fad',
  iconName: 'wind',
  icon: [512, 512, [], "f72e", ["M352 384c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32z", "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"]]
};
var faBoxDollar = {
  prefix: 'fad',
  iconName: 'box-dollar',
  icon: [448, 512, ["box-usd"], "f4a0", ["M93.7 32C75.5 32 58.9 42.3 50.7 58.5L0 160H208V32H93.7zM240 32V160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240z", "M448 160H240V32H208V160H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V160zM244 216v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2 0 0c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V424c0 11-9 20-20 20s-20-9-20-20V409.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4l0 0c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V216c0-11 9-20 20-20s20 9 20 20z"]]
};
var faBoxUsd = faBoxDollar;
var faCarBurst = {
  prefix: 'fad',
  iconName: 'car-burst',
  icon: [640, 512, ["car-crash"], "f5e1", ["M160.6 18.8c2.7-6.7 12.2-6.7 14.9 0l26.3 66.6c1.5 3.9 5.8 5.9 9.8 4.7l68.5-21c6.9-2.1 12.9 5.3 9.3 11.6L266.7 120l-36.3 52.5c-27.4 8.9-49.9 31-57.9 60.9L166.8 255c-1.5 .2-3 .9-4.2 2L110 305.6c-5.3 4.9-13.9 .8-13.4-6.5l5.2-71.4c.3-4.2-2.6-7.9-6.8-8.5L24.2 208.4c-7.2-1.1-9.3-10.4-3.3-14.5L80 153.5c3.4-2.4 4.5-7 2.4-10.6L46.8 80.8c-3.6-6.3 2.3-13.8 9.3-11.6l68.5 21c4 1.2 8.3-.8 9.8-4.7l26.3-66.6zm42.9 222.9c1.5-5.6 3.8-10.8 6.7-15.4c-2.9 4.7-5.2 9.8-6.7 15.4l0 0z", "M350.4 167.8l-32.2 46.6 201.5 54L515 212c-.5-6.7-5.3-12.4-11.8-14.2L367.7 161.5c-6.5-1.8-13.5 .8-17.3 6.4zM249.8 200.7l47.9-69.3c19.2-27.8 53.9-40.5 86.5-31.8L519.8 136c32.7 8.8 56.3 37.1 59 70.8l6.8 84c17.2 13.4 25.6 36.3 19.6 58.7L595 388l-16.6 61.8-8.3 30.9c-4.6 17.1-22.1 27.2-39.2 22.6l-15.5-4.1c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9L253.8 362.9l-8.3 30.9c-4.6 17.1-22.1 27.2-39.2 22.6l-15.5-4.1c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9 16.6-61.8 10.4-38.6c6-22.4 24.7-38 46.3-41zm47.9 91.1a24 24 0 1 0 -46.4-12.4 24 24 0 1 0 46.4 12.4zm217.9 83.2A24 24 0 1 0 528 328.7a24 24 0 1 0 -12.4 46.4z"]]
};
var faCarCrash = faCarBurst;
var faY = {
  prefix: 'fad',
  iconName: 'y',
  icon: [384, 512, [121], "59", ["M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z", ""]]
};
var faUserHeadset = {
  prefix: 'fad',
  iconName: 'user-headset',
  icon: [448, 512, [], "f82d", ["M96 192c0-70.7 57.3-128 128-128s128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256h-8.6c-11.1-19.1-31.7-32-55.4-32H208c-35.3 0-64 28.7-64 64c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192z", "M224 32C135.6 32 64 103.6 64 192v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192C32 86 118 0 224 0S416 86 416 192v16c0 61.9-50.1 112-112 112H240 224 208c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80V192c0-88.4-71.6-160-160-160zM134.4 352H313.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352z"]]
};
var faArrowsRetweet = {
  prefix: 'fad',
  iconName: 'arrows-retweet',
  icon: [640, 512, ["retweet-alt"], "f361", ["M304 128c0-17.7 14.3-32 32-32H448c53 0 96 43 96 96V338.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L480 338.7V192c0-17.7-14.3-32-32-32H336c-17.7 0-32-14.3-32-32z", "M105.4 73.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L160 173.3V320c0 17.7 14.3 32 32 32H304c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V173.3L54.6 214.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z"]]
};
var faRetweetAlt = faArrowsRetweet;
var faPersonSnowboarding = {
  prefix: 'fad',
  iconName: 'person-snowboarding',
  icon: [512, 512, [127938, "snowboarding"], "f7ce", ["M7 295c9.4-9.4 24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1L429.5 461.4c4.6 1.7 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H443.8c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9z", "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21L297.9 411c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1l-39.2-15c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faSnowboarding = faPersonSnowboarding;
var faSquareChevronRight = {
  prefix: 'fad',
  iconName: 'square-chevron-right',
  icon: [448, 512, ["chevron-square-right"], "f32b", ["M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM313 273L209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239c9.4 9.4 9.4 24.6 0 33.9z", "M313 239c9.4 9.4 9.4 24.6 0 33.9L209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239z"]]
};
var faChevronSquareRight = faSquareChevronRight;
var faLacrosseStickBall = {
  prefix: 'fad',
  iconName: 'lacrosse-stick-ball',
  icon: [576, 512, [], "e3b6", ["M9.4 457.4l136-136c11 18.7 26.6 34.3 45.3 45.3l-136 136c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zM496 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M264.8 117.7l-3.3 11.5c-5.6 19.6-15.1 37.9-27.8 53.9L205.8 218c-8.9 11.1-13.8 25-13.8 39.2c0 34.7 28.1 62.8 62.8 62.8c14.3 0 28.1-4.9 39.2-13.8l34.9-27.9c15.9-12.8 34.3-22.2 53.9-27.8l11.5-3.3c31.8-9.1 53.7-38.1 53.7-71.2h0c0-.1 0-.2 0-.3c0-19.9-13.6-48.1-38.6-73.1s-53.2-38.6-73.1-38.6c-.1 0-.2 0-.3 0v0c-33.1 0-62.1 21.9-71.2 53.7zM512 176h0c0 61.6-40.9 115.8-100.1 132.7L400.3 312c-11.5 3.3-22.2 8.8-31.5 16.2l-34.9 27.9c-22.5 18-50.4 27.8-79.2 27.8c-70 0-126.8-56.8-126.8-126.8c0-28.8 9.8-56.7 27.8-79.2l27.9-34.9c7.4-9.3 13-20 16.2-31.5l3.3-11.5C220.2 40.9 274.4 0 336 0V0c.1 0 .2 0 .3 0c43.8 0 87.4 26.4 118.4 57.3s57.3 74.5 57.3 118.4c0 .1 0 .2 0 .3z"]]
};
var faTruckFast = {
  prefix: 'fad',
  iconName: 'truck-fast',
  icon: [640, 512, ["shipping-fast"], "f48b", ["M288 112c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H272c8.8 0 16 7.2 16 16zm-48 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H240zm-32 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H208zM96 432a80 80 0 1 1 160 0A80 80 0 1 1 96 432zm288 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M64 48C64 21.5 85.5 0 112 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576h-1.1c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H286.9c-7.8-54.3-54.4-96-110.9-96c-48.1 0-89.2 30.4-105 73c-4.4-7.3-7-15.8-7-25V256H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V192H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V128H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V48zM416 256H544V237.3L466.7 160H416v96z"]]
};
var faShippingFast = faTruckFast;
var faUserMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'user-magnifying-glass',
  icon: [640, 512, [], "e5c5", ["M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c6.4 0 12.7 .3 19 1c-.5 4.9-.7 9.9-.7 15c0 88.4 71.6 160 160 160c0 .8 0 1.5 0 2.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z", "M528 320.2a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM519.9 426c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426z"]]
};
var faStarSharp = {
  prefix: 'fad',
  iconName: 'star-sharp',
  icon: [576, 512, [], "e28b", ["M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176H56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L172.1 320.7 121.1 480.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4 417.3 506.9c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27L403.9 320.7 534.7 218.9c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2H361.6L310.9 16.7z", ""]]
};
var faCommentHeart = {
  prefix: 'fad',
  iconName: 'comment-heart',
  icon: [512, 512, [], "e5c8", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM144 205.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z", "M205.3 144c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]]
};
var faCircle1 = {
  prefix: 'fad',
  iconName: 'circle-1',
  icon: [512, 512, [], "e0ee", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 131.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L232 193.4V336H192c-13.3 0-24 10.7-24 24s10.7 24 24 24h64 64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V152c0-8.6-4.6-16.5-12-20.8z", "M280 152c0-8.6-4.6-16.5-12-20.8s-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L232 193.4V336H192c-13.3 0-24 10.7-24 24s10.7 24 24 24h64 64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V152z"]]
};
var faCircleStar = {
  prefix: 'fad',
  iconName: 'circle-star',
  icon: [512, 512, ["star-circle"], "e123", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 104c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L256 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z", "M270.3 112.9c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-36.2 73.4-81.1 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.9 1.2L256 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81-11.8-36.2-73.4z"]]
};
var faStarCircle = faCircleStar;
var faFish = {
  prefix: 'fad',
  iconName: 'fish',
  icon: [576, 512, [128031], "f578", ["M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M416 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]]
};
var faCloudFog = {
  prefix: 'fad',
  iconName: 'cloud-fog',
  icon: [640, 512, [127787, "fog"], "f74e", ["M24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm64 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zm208 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H296z", "M64 224c0 53 43 96 96 96H480c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C320.5 24.3 283.1 0 240 0C178.1 0 128 50.1 128 112c0 7.1 .7 14.1 1.9 20.8C91.6 145.4 64 181.5 64 224z"]]
};
var faFog = faCloudFog;
var faWaffle = {
  prefix: 'fad',
  iconName: 'waffle',
  icon: [512, 512, [129479], "e466", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 80c-8.8 0-16 7.2-16 16v48H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V368h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16V368h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V368h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V176h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H272V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H176V96c0-8.8-7.2-16-16-16zm16 256V272h64v64H176zm96 0V272h64v64H272zm64-160v64H272V176h64zm-96 0v64H176V176h64z", "M272 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v80l-64 0V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V368h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16V368h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V368h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V176h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v48l-64 0V64zm64 272H272V272h64v64zm-96 0H176V272h64v64zm0-96H176V176l64 0v64zm96 0H272V176h64v64z"]]
};
var faMusicNote = {
  prefix: 'fad',
  iconName: 'music-note',
  icon: [384, 512, ["music-alt"], "f8cf", ["M384 32c0-9.9-4.5-19.2-12.3-25.2S353.8-1.4 344.2 1l-128 32C202 36.5 192 49.3 192 64v64V359.7c37.8 12.8 64 40.4 64 72.3V153L359.8 127C374 123.5 384 110.7 384 96V32z", "M144 352a112 80 0 1 0 0 160 112 80 0 1 0 0-160z"]]
};
var faMusicAlt = faMusicNote;
var faHexagonExclamation = {
  prefix: 'fad',
  iconName: 'hexagon-exclamation',
  icon: [512, 512, [], "e417", ["M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faCartShoppingFast = {
  prefix: 'fad',
  iconName: 'cart-shopping-fast',
  icon: [640, 512, [], "e0dc", ["M523.2 288H234.7L188.5 45.5c-.9-4.8-2.4-9.3-4.4-13.5h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3zM24 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M64 24C64 10.7 74.7 0 88 0h45.5c26.9 0 50 19.1 55 45.5l51.6 271c2.2 11.3 12.1 19.5 23.6 19.5H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H263.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H88C74.7 48 64 37.3 64 24zM192 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faObjectUnion = {
  prefix: 'fad',
  iconName: 'object-union',
  icon: [512, 512, [], "e49f", ["", "M64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h96v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H352V64c0-35.3-28.7-64-64-64H64z"]]
};
var faUserGraduate = {
  prefix: 'fad',
  iconName: 'user-graduate',
  icon: [448, 512, [], "f501", ["M96 160V144H352v16c0 70.7-57.3 128-128 128s-128-57.3-128-128z", "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V144H96V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"]]
};
var faStarfighter = {
  prefix: 'fad',
  iconName: 'starfighter',
  icon: [640, 512, [], "e037", ["M48 72c13.3 0 24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24zm544 0c13.3 0 24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24zM320 224c17.7 0 32 14.3 32 32v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V256c0-17.7 14.3-32 32-32zM128 320c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V320zm352-32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h32z", "M353.8 14c-1-8-7.8-14-15.9-14H302.1c-8.1 0-14.9 6-15.9 14L256 256v96H224v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V352H72v92l88 26.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32h48 96 48c0 17.7 14.3 32 32 32s32-14.3 32-32v-9.6L568 444V352H512v64c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352H384V256L353.8 14zM288 256c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V256z"]]
};
var faCircleHalfStroke = {
  prefix: 'fad',
  iconName: 'circle-half-stroke',
  icon: [512, 512, [9680, "adjust"], "f042", ["M512 256C512 114.6 397.4 0 256 0V64c106 0 192 86 192 192s-86 192-192 192v64c141.4 0 256-114.6 256-256z", "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512V0z"]]
};
var faAdjust = faCircleHalfStroke;
var faArrowRightLongToLine = {
  prefix: 'fad',
  iconName: 'arrow-right-long-to-line',
  icon: [640, 512, [], "e3d5", ["M608 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32z", "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]]
};
var faSquareArrowDown = {
  prefix: 'fad',
  iconName: 'square-arrow-down',
  icon: [448, 512, ["arrow-square-down"], "f339", ["M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zm177-87L353 281c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71V136c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L207 393c9.4 9.4 24.6 9.4 33.9 0z", "M207 393c9.4 9.4 24.6 9.4 33.9 0L353 281c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71V136c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L207 393z"]]
};
var faArrowSquareDown = faSquareArrowDown;
var faDiamondHalfStroke = {
  prefix: 'fad',
  iconName: 'diamond-half-stroke',
  icon: [512, 512, [], "e5b8", ["M256 512c10.2 0 20.5-3.9 28.3-11.7l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216C276.5 3.9 266.2 0 256 0V78.5L433.5 256 256 433.5V512z", "M256 0c-10.2 0-20.5 3.9-28.3 11.7l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c7.8 7.8 18 11.7 28.3 11.7V0z"]]
};
var faClapperboard = {
  prefix: 'fad',
  iconName: 'clapperboard',
  icon: [512, 512, [], "e131", ["M0 160H512V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160z", "M453.8 32.3L327 159l-1 1H233.9L361 33l1-1H448c2 0 3.9 .1 5.8 .3zM393.9 160L498 56c8.8 11 14 24.9 14 40v64H393.9zM201.9 32h92.1L167 159l-1 1H73.9L201 33l1-1zm-67.9 0L7 159l-1 1H0V96C0 60.7 28.7 32 64 32h70.1z"]]
};
var faSquareChevronLeft = {
  prefix: 'fad',
  iconName: 'square-chevron-left',
  icon: [448, 512, ["chevron-square-left"], "f32a", ["M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM135 239L239 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273c-9.4-9.4-9.4-24.6 0-33.9z", "M135 273c-9.4-9.4-9.4-24.6 0-33.9L239 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273z"]]
};
var faChevronSquareLeft = faSquareChevronLeft;
var faPhoneIntercom = {
  prefix: 'fad',
  iconName: 'phone-intercom',
  icon: [512, 512, [], "e434", ["M224 32c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H224zm48 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm80 16c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zM256 96H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32z", "M48 32C21.5 32 0 53.5 0 80V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM368 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368z"]]
};
var faLinkHorizontal = {
  prefix: 'fad',
  iconName: 'link-horizontal',
  icon: [640, 512, ["chain-horizontal"], "e1cb", ["M640 303.4C640 383.3 575.3 448 495.4 448H336.6C256.7 448 192 383.3 192 303.4c0-70.7 51.1-131 120.8-142.6l1.9-.3c17.4-2.9 33.9 8.9 36.8 26.3s-8.9 33.9-26.3 36.8l-1.9 .3C284.5 230.4 256 264 256 303.4c0 44.5 36.1 80.6 80.6 80.6H495.4c44.5 0 80.6-36.1 80.6-80.6c0-39.4-28.5-73-67.4-79.5l-1.9-.3c-17.4-2.9-29.2-19.4-26.3-36.8s19.4-29.2 36.8-26.3l1.9 .3c69.7 11.6 120.8 72 120.8 142.6z", "M0 208.6C0 128.7 64.7 64 144.6 64H303.4C383.3 64 448 128.7 448 208.6c0 70.7-51.1 131-120.8 142.6l-1.9 .3c-17.4 2.9-33.9-8.9-36.8-26.3s8.9-33.9 26.3-36.8l1.9-.3c38.9-6.5 67.4-40.1 67.4-79.5c0-44.5-36.1-80.6-80.6-80.6H144.6C100.1 128 64 164.1 64 208.6c0 39.4 28.5 73 67.4 79.5l1.9 .3c17.4 2.9 29.2 19.4 26.3 36.8s-19.4 29.2-36.8 26.3l-1.9-.3C51.1 339.6 0 279.3 0 208.6z"]]
};
var faChainHorizontal = faLinkHorizontal;
var faMango = {
  prefix: 'fad',
  iconName: 'mango',
  icon: [512, 512, [], "e30f", ["M320 96c-49.1 0-98.3 18.7-135.8 56.2c-45.8 37.2-67.8 76.7-88.4 113.5c-19.1 34.1-36.9 66-71.2 91.8C15 365 7.4 375.4 3.3 387.9c-11.1 33.5 7.1 69.8 40.6 80.9c0 0 100.1 43.3 244.1 43.3c166.5 0 224-147.4 224-224c0-49.1-18.7-98.3-56.2-135.8c-25.2-25.2-55.6-41.9-87.8-50.2V128c0 13.3-10.7 24-24 24s-24-10.7-24-24V96zm96 192c8.8 0 16 7.2 16 16c0 70.7-57.3 128-128 128c-8.8 0-16-7.2-16-16s7.2-16 16-16c53 0 96-43 96-96c0-8.8 7.2-16 16-16z", "M352 0h-8c-13.3 0-24 10.7-24 24V128c0 13.3 10.7 24 24 24s24-10.7 24-24V53.1C385.2 79 414.6 96 448 96h40c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H384h-8H352z"]]
};
var faMusicNoteSlash = {
  prefix: 'fad',
  iconName: 'music-note-slash',
  icon: [640, 512, ["music-alt-slash"], "f8d0", ["M512 32c0-9.9-4.5-19.2-12.3-25.2S481.8-1.4 472.2 1l-128 32C330 36.5 320 49.3 320 64v64 97.5l64 50.2V153L487.8 127C502 123.5 512 110.7 512 96V32zM320 348.1v11.6c-14.5-4.9-30.8-7.7-48-7.7c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V398.5l-64-50.4z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faMusicAltSlash = faMusicNoteSlash;
var faCircleRadiation = {
  prefix: 'fad',
  iconName: 'circle-radiation',
  icon: [512, 512, [9762, "radiation-alt"], "f7ba", ["M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5z"]]
};
var faRadiationAlt = faCircleRadiation;
var faFaceTongueSweat = {
  prefix: 'fad',
  iconName: 'face-tongue-sweat',
  icon: [576, 512, [], "e39e", ["M99.6 429.3c28.9 31.4 65.5 55.5 106.9 69.4C197.3 484 192 466.6 192 448V416.7c-10.2-7.2-16-15.7-16-24.7c0-26.5 50.1-48 112-48s112 21.5 112 48c0 9-5.8 17.5-16 24.7V448c0 18.6-5.3 36-14.5 50.8C470.9 464.7 544 368.9 544 256C544 114.6 429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3zM399.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm19.7-91.3c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm121.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z", "M227.3 148.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zM207.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-18.9-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM352 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM48 416c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C67.6 308.6 96 349 96 369c0 26-21.5 47-48 47z"]]
};
var faGlobeStand = {
  prefix: 'fad',
  iconName: 'globe-stand',
  icon: [640, 512, [], "f5f6", ["", "M304 64a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM111 367c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l18.5-18.5c34.3 27.7 74.9 43.8 116.5 48.3V464H184c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H328V430.7c49.1-5.3 96.8-26.7 134.4-64.3c81.7-81.7 87.1-211 16.1-298.9L497 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L428.5 49.6c-9.4 9.4-9.4 24.6 0 33.9c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0c-9.4-9.4-24.6-9.4-33.9 0L111 367z"]]
};
var faBaseball = {
  prefix: 'fad',
  iconName: 'baseball',
  icon: [512, 512, [129358, 9918, "baseball-ball"], "f433", ["M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z", "M48 224c4.9 0 9.8-.2 14.7-.6c8.8-.7 16.5 5.8 17.3 14.6s-5.8 16.5-14.6 17.3c-5.7 .5-11.5 .7-17.3 .7c-16.5 0-32.6-1.9-47.9-5.6c.2-11 1.2-21.7 2.7-32.3C17.2 222 32.4 224 48 224zM250.4 .1C254.1 15.4 256 31.5 256 48c0 5.8-.2 11.6-.7 17.3c-.7 8.8-8.5 15.4-17.3 14.6s-15.4-8.5-14.6-17.3c.4-4.8 .6-9.7 .6-14.7c0-15.6-2-30.8-5.9-45.2c10.6-1.6 21.4-2.5 32.3-2.7zM511.9 261.6c-.2 11-1.2 21.7-2.7 32.3C494.8 290 479.6 288 464 288c-5 0-9.8 .2-14.7 .6c-8.8 .7-16.5-5.8-17.3-14.6s5.8-16.5 14.6-17.3c5.7-.5 11.5-.7 17.3-.7c16.5 0 32.6 1.9 47.9 5.6zM293.9 509.2c-10.6 1.6-21.4 2.5-32.3 2.7c-3.6-15.4-5.6-31.4-5.6-47.9c0-5.8 .2-11.6 .7-17.3c.7-8.8 8.5-15.4 17.3-14.6s15.4 8.5 14.6 17.3c-.4 4.8-.6 9.7-.6 14.7c0 15.6 2 30.8 5.9 45.2zm-180.4-280c-3.7-8-.2-17.5 7.9-21.2c38.3-17.6 69.2-48.5 86.7-86.7c3.7-8 13.2-11.6 21.2-7.9s11.6 13.2 7.9 21.2c-20.8 45.2-57.2 81.7-102.5 102.5c-8 3.7-17.5 .2-21.2-7.9zm285.1 53.5c3.7 8 .2 17.5-7.9 21.2c-38.3 17.6-69.2 48.5-86.7 86.7c-3.7 8-13.2 11.6-21.2 7.9s-11.6-13.2-7.9-21.2c20.8-45.2 57.2-81.7 102.5-102.5c8-3.7 17.5-.2 21.2 7.9z"]]
};
var faBaseballBall = faBaseball;
var faCircleP = {
  prefix: 'fad',
  iconName: 'circle-p',
  icon: [512, 512, [], "e11a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128h92c50.8 0 92 41.2 92 92s-41.2 92-92 92H208v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V288 152c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44H208v88h68z", "M160 152c0-13.3 10.7-24 24-24h92c50.8 0 92 41.2 92 92s-41.2 92-92 92H208v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V288 152zm48 112h68c24.3 0 44-19.7 44-44s-19.7-44-44-44H208v88z"]]
};
var faAwardSimple = {
  prefix: 'fad',
  iconName: 'award-simple',
  icon: [384, 512, [], "e0ab", ["M95.4 357.9l-31 134.5c-1.3 5.5 .5 11.3 4.6 15.2s10 5.3 15.4 3.8L192 480.6l107.6 30.7c5.4 1.6 11.3 .1 15.4-3.8s5.8-9.7 4.6-15.2l-31-134.5c-5.8 3.5-12.5 5.3-19.4 5.1l-20.9-.5c-6.9-.2-13.7 1.7-19.6 5.2l-17.9 10.9c-11.5 7-26 7-37.5 0l-17.9-10.9c-5.9-3.6-12.7-5.4-19.6-5.2l-20.9 .5c-7 .2-13.7-1.7-19.4-5.1z", "M210.7 5.3c-11.5-7-26-7-37.5 0L155.4 16.1c-5.9 3.6-12.7 5.4-19.6 5.2l-20.9-.5c-13.5-.3-26 6.9-32.5 18.7L72.4 58c-3.3 6.1-8.3 11-14.3 14.3l-18.4 10c-11.8 6.5-19.1 19-18.7 32.5l.5 20.9c.2 6.9-1.7 13.7-5.2 19.6L5.3 173.3c-7 11.5-7 26 0 37.5l10.9 17.9c3.6 5.9 5.4 12.7 5.2 19.6l-.5 20.9c-.3 13.5 6.9 26 18.7 32.5l18.4 10c6.1 3.3 11 8.3 14.3 14.3l10 18.4c6.5 11.8 19 19.1 32.5 18.7l20.9-.5c6.9-.2 13.7 1.7 19.6 5.2l17.9 10.9c11.5 7 26 7 37.5 0l17.9-10.9c5.9-3.6 12.7-5.4 19.6-5.2l20.9 .5c13.5 .3 26-6.9 32.5-18.7l10-18.4c3.3-6.1 8.3-11 14.3-14.3l18.4-10c11.8-6.5 19.1-19 18.7-32.5l-.5-20.9c-.2-6.9 1.7-13.7 5.2-19.6l10.9-17.9c7-11.5 7-26 0-37.5l-10.9-17.9c-3.6-5.9-5.4-12.7-5.2-19.6l.5-20.9c.3-13.5-6.9-26-18.7-32.5L326 72.4c-6.1-3.3-11-8.3-14.3-14.3l-10-18.4c-6.5-11.8-19-19.1-32.5-18.7l-20.9 .5c-6.9 .2-13.7-1.7-19.6-5.2L210.7 5.3zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]]
};
var faJetFighterUp = {
  prefix: 'fad',
  iconName: 'jet-fighter-up',
  icon: [512, 512, [], "e518", ["M48 384V296l144-80V384H48zm416 0H320V216l144 80v88z", "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2V416.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96V448c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16V480c0-4.6-2-9-5.5-12L320 416.7V137.9c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7zM24 256c-13.3 0-24 10.7-24 24V392c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-13.3-10.7-24-24-24zm488 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V392c0 13.3 10.7 24 24 24s24-10.7 24-24V280z"]]
};
var faDiagramProject = {
  prefix: 'fad',
  iconName: 'diagram-project',
  icon: [576, 512, ["project-diagram"], "f542", ["M144 224l80.3 107c2.5-24.2 22.9-43 47.7-43L191.7 181c-2.5 24.2-22.9 43-47.7 43zm48-64H384V96H192v64z", "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM224 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336zM432 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48z"]]
};
var faProjectDiagram = faDiagramProject;
var faPedestal = {
  prefix: 'fad',
  iconName: 'pedestal',
  icon: [448, 512, [], "e20d", ["M32 64C32 28.7 60.7 0 96 0H352c35.3 0 64 28.7 64 64V448H32V64zM144 88A24 24 0 1 0 96 88a24 24 0 1 0 48 0zm184 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M144 88A24 24 0 1 0 96 88a24 24 0 1 0 48 0zm208 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faChartPyramid = {
  prefix: 'fad',
  iconName: 'chart-pyramid',
  icon: [512, 512, [], "e0e6", ["M144.3 192L51 352H461L367.7 192H144.3z", "M221.4 59.7L144.3 192H367.7L290.6 59.7c-15.4-26.5-53.7-26.5-69.1 0zM51 352L11.4 419.8C-4.2 446.5 15.1 480 45.9 480H466.1c30.9 0 50.1-33.5 34.6-60.2L461 352H51z"]]
};
var faSidebar = {
  prefix: 'fad',
  iconName: 'sidebar',
  icon: [512, 512, [], "e24e", ["M512 96c0-35.3-28.7-64-64-64H224V480H448c35.3 0 64-28.7 64-64V96z", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H224V32H64zM88 96h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24zM64 216c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm24 72h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faSnowmanHead = {
  prefix: 'fad',
  iconName: 'snowman-head',
  icon: [448, 512, ["frosty-head"], "f79b", ["M310.8 512c12.6 0 25.1-3.5 34.9-11.5C388.6 465.3 416 411.8 416 352c0-35-9.4-67.8-25.7-96H57.7C41.3 284.2 32 317 32 352c0 59.8 27.4 113.3 70.3 148.5c9.7 8 22.3 11.5 34.9 11.5H310.8zM195.5 398.9c-2.3-4.5-3.5-9.6-3.5-14.7c0-17.7 14.3-32.2 32-32.2s32 14.5 32 32.2c0 5.1-1.2 10.2-3.5 14.7l-23.8 46.3c-.9 1.7-2.7 2.8-4.7 2.8s-3.8-1.1-4.7-2.8l-23.8-46.3z", "M64 64C64 28.7 92.7 0 128 0H320c35.3 0 64 28.7 64 64v96H64V64zm88 224a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm144 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 192H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]]
};
var faFrostyHead = faSnowmanHead;
var faCopy = {
  prefix: 'fad',
  iconName: 'copy',
  icon: [512, 512, [], "f0c5", ["M192 128H48c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V416H256v32H64V192H192V128z", "M224 48c0-26.5 21.5-48 48-48H396.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V48z"]]
};
var faBurgerGlass = {
  prefix: 'fad',
  iconName: 'burger-glass',
  icon: [640, 512, [], "e0ce", ["M8.6 10.2C14.6 3.7 23.1 0 32 0H352c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1L374 173.6c-24.6 8.3-44.7 19.6-60.9 32c-32.2 24.8-47.2 52.7-52.7 65.3c-3.4 7.7-4.4 15.3-4.4 21.5c0 17.8 7.9 33.9 20.3 44.8C263.8 348.9 256 365.5 256 384c0 16.7 6.4 32 17 43.4c-10.4 8.8-17 21.9-17 36.6c0 18 6 34.6 16 48H108.7c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64l6.9 96H310.8l6.9-96H66.4z", "M612.5 319.8c15.2 0 27.5-12.3 27.5-27.5c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5H612.5zM368 255.8a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-240 128c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0 80c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16z"]]
};
var faVolumeXmark = {
  prefix: 'fad',
  iconName: 'volume-xmark',
  icon: [576, 512, ["volume-mute", "volume-times"], "f6a9", ["M391 167c9.4-9.4 24.6-9.4 33.9 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9z", "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"]]
};
var faVolumeMute = faVolumeXmark;
var faVolumeTimes = faVolumeXmark;
var faHandSparkles = {
  prefix: 'fad',
  iconName: 'hand-sparkles',
  icon: [640, 512, [], "e05d", ["M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L131.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L188.8 448c43.1 41.1 100.4 64 160 64H368c41.9 0 80.4-14.6 110.6-39.1c-18.1-5.3-30.6-22-30.6-40.9c0-19 12.6-35.7 30.9-41l31.2-8.9 8.9-31.2c3.7-12.9 13.1-23 25-27.8V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM320 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L320 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L288 384l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L288 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L320 352z", "M90.2 71.7L104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7zm480 288L584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7z"]]
};
var faBarsFilter = {
  prefix: 'fad',
  iconName: 'bars-filter',
  icon: [448, 512, [], "e0ad", ["M64 256c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32z", "M448 96c0-17.7-14.3-32-32-32H32C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM288 416c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32z"]]
};
var faPaintbrushPencil = {
  prefix: 'fad',
  iconName: 'paintbrush-pencil',
  icon: [576, 512, [], "e206", ["M164.7 19.3L298.5 153.1 194.4 257.2c-6-.8-12.2-1.2-18.4-1.2c-.8 0-1.7 0-2.5 0L50.7 133.3c-25-25-25-65.5 0-90.5L74.2 19.3c25-25 65.5-25 90.5 0zM384.6 467.1L320 402.5c0-.8 0-1.7 0-2.5c0-6.2-.4-12.4-1.2-18.4L422.9 277.5l75.6 75.6c6.7 6.7 11.6 15.1 14.2 24.2l29.7 104c2.4 8.4 .1 17.4-6.1 23.6s-15.2 8.5-23.6 6.1l-104-29.7c-9.1-2.6-17.5-7.5-24.2-14.2z", "M559.6 16.4c21.9 21.9 21.9 57.3 0 79.2L306.9 348.3l-79.2-79.2L480.4 16.4c21.9-21.9 57.3-21.9 79.2 0zM205.1 291.7l79.2 79.2-.1 .1c2.5 9.3 3.8 19 3.8 29c0 61.9-50.1 112-112 112H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h4.8c17.6 0 29.6-18.9 27.8-36.4c-.4-3.8-.6-7.7-.6-11.6c0-61.9 50.1-112 112-112c10 0 19.8 1.3 29 3.8l.1-.1z"]]
};
var faPartyBell = {
  prefix: 'fad',
  iconName: 'party-bell',
  icon: [512, 512, [], "e31a", ["M448 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM320 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM393 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8.2 8.3c24.4 24.4 56.4 39.8 90.7 43.6l27.4 3c13.2 1.5 25-8 26.5-21.2s-8-25-21.2-26.5l-27.4-3c-23.5-2.6-45.4-13.1-62.1-29.8L393 167zM167 359c-9.4 9.4-9.4 24.6 0 33.9l8.3 8.3c16.7 16.7 27.2 38.6 29.8 62.1l3 27.4c1.5 13.2 13.3 22.7 26.5 21.2s22.7-13.3 21.2-26.5l-3-27.4c-3.8-34.3-19.2-66.3-43.6-90.7L201 359c-9.4-9.4-24.6-9.4-33.9 0zM469.7 503.5c8.6 10.1 23.7 11.4 33.8 2.8s11.4-23.7 2.8-33.8l-8.5-10c-4.9-5.8-7.5-13.2-7.3-20.7c1.1-42.5-31.7-78.3-74.2-80.8l-30-1.8c-16.6-1-29.4-15-29-31.6c.5-19.4-6.1-38.2-18.6-53l-8.5-10c-8.6-10.1-23.7-11.4-33.8-2.8s-11.4 23.7-2.8 33.8l8.5 10c4.9 5.8 7.5 13.2 7.3 20.7c-1.1 42.5 31.7 78.3 74.2 80.8l30 1.8c16.6 1 29.4 15 29 31.6c-.5 19.4 6.1 38.2 18.6 53l8.5 10z", "M224 0C100.3 0 0 100.3 0 224c0 35.3 8.2 68.9 22.8 98.7C32.3 341.9 51.7 352 70.7 352c14.5 0 28.3-5.7 38.5-16L336 109.2c10.2-10.2 16-24.1 16-38.5c0-19-10.1-38.4-29.3-47.8C292.9 8.2 259.3 0 224 0z"]]
};
var faUserVneckHair = {
  prefix: 'fad',
  iconName: 'user-vneck-hair',
  icon: [448, 512, [], "e462", ["M176 112H120c-7.9 0-15.5-1.7-22.3-4.6C96.6 114.1 96 121 96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11-1.4-21.8-4-32H312c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112z", "M120 112h56c34.6 0 65-18.3 81.9-45.8C269.2 84.1 289.2 96 312 96h36C333.8 40.8 283.6 0 224 0C160.3 0 107.5 46.5 97.7 107.4c6.8 3 14.4 4.6 22.3 4.6zm25.9 202.9c-3.5-5.2-9.8-8-15.9-6.6C55.5 325.5 0 392.3 0 472v8c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32v-8c0-79.7-55.5-146.5-130-163.7c-6.1-1.4-12.4 1.4-15.9 6.6L237.3 412c-6.3 9.5-20.3 9.5-26.6 0l-64.8-97.1z"]]
};
var faJackOLantern = {
  prefix: 'fad',
  iconName: 'jack-o-lantern',
  icon: [576, 512, [127875], "f30e", ["M157.5 171.7c-7.5 4.5-16-3.4-10.4-10.1c9.6-11.4 20.6-21.7 32.7-30.5c-.6-.1-1.2-.2-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320S68.1 512 152 512c19.3 0 37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8c83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8c-.6 .1-1.2 .2-1.8 .3c12.1 8.8 23.1 19.1 32.7 30.5c5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7zM208 208c5.3 0 10.3 2.7 13.3 7.1l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H176c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1zm173.3 7.1l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H336c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1zM368 437.5C346.2 444 319.8 448 288 448s-58.2-4-80-10.5V416c0-8.8-7.2-16-16-16H176c-8.6 0-15.7 6.9-16 15.4c-36.9-24.7-49.9-56.7-54.1-71.4c-1.4-5 .3-10.2 4-13.8c5.8-5.8 15.1-6.6 22.2-2.4c18 10.6 55.5 29.1 107.9 36.8V384c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V368c77.6 0 132.8-26.6 155.9-40.2c7.1-4.2 16.4-3.4 22.2 2.4c3.7 3.7 5.4 8.8 4 13.8c-4.2 14.7-17.3 46.8-54.1 71.4c-.3-8.6-7.3-15.4-16-15.4H384c-8.8 0-16 7.2-16 16v21.5z", "M275.5 10.4l-40.9 93.5C251.5 98.8 269.4 96 288 96c22.5 0 44.1 4 64 11.4v-72c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4zM221.3 215.1c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5h64c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48zm160 0c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5h64c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48zM416 415.4c36.9-24.7 49.9-56.7 54.1-71.4c1.4-5-.3-10.2-4-13.8c-5.8-5.8-15.1-6.6-22.2-2.4C420.8 341.4 365.6 368 288 368v16c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V364.5c-52.4-7.7-89.9-26.2-107.9-36.8c-7.1-4.2-16.4-3.4-22.2 2.4c-3.7 3.7-5.4 8.8-4 13.8c4.2 14.7 17.2 46.8 54.1 71.4c.3-8.6 7.3-15.4 16-15.4h16c8.8 0 16 7.2 16 16v21.5c21.8 6.5 48.2 10.5 80 10.5s58.2-4 80-10.5V416c0-8.8 7.2-16 16-16h16c8.6 0 15.7 6.9 16 15.4z"]]
};
var faGrip = {
  prefix: 'fad',
  iconName: 'grip',
  icon: [448, 512, ["grip-horizontal"], "f58d", ["M0 328c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zm160 0c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zm288 0l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40z", "M0 136c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zm160 0c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zm288 0l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40z"]]
};
var faGripHorizontal = faGrip;
var faShareFromSquare = {
  prefix: 'fad',
  iconName: 'share-from-square',
  icon: [576, 512, [61509, "share-square"], "f14d", ["M80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z", "M352 224v64c0 17.7 14.3 32 32 32h3.7c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7V96H272c-79.5 0-144 64.5-144 144c0 93.4 82.8 134.8 100.6 142.6c2.2 1 4.6 1.4 7.1 1.4h2.5c9.8 0 17.8-8 17.8-17.8c0-8.3-5.9-15.5-12.8-20.3c-8.9-6.2-19.2-18.2-19.2-40.5c0-45 36.5-81.5 81.5-81.5H352z"]]
};
var faShareSquare = faShareFromSquare;
var faKeynote = {
  prefix: 'fad',
  iconName: 'keynote',
  icon: [512, 512, [], "f66c", ["M184 72h14.4c8.3 14.3 23.8 24 41.6 24h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H240c-17.8 0-33.3 9.7-41.6 24H184c-48.6 0-88 39.4-88 88v48h48V112c0-22.1 17.9-40 40-40zM160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V352H224v96H160z", "M80 160c-12.1 0-23.2 6.8-28.6 17.7l-48 96C1.2 278.1 0 283 0 288v32c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V288c0-5-1.2-9.9-3.4-14.3l-48-96C455.2 166.8 444.1 160 432 160H80z"]]
};
var faChildCombatant = {
  prefix: 'fad',
  iconName: 'child-combatant',
  icon: [576, 512, ["child-rifle"], "e4e0", ["M112 64a64 64 0 1 1 128 0A64 64 0 1 1 112 64zm56 288V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L91.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L248 300.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H168z", "M432 0h16c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16z"]]
};
var faChildRifle = faChildCombatant;
var faGun = {
  prefix: 'fad',
  iconName: 'gun',
  icon: [576, 512, [], "e19b", ["M80 128H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM321.4 352H217l12-48h92.5c3.4 0 6.4-2.1 7.5-5.3l21-58.7h51l-26.7 74.8c-8 22.3-29.1 37.2-52.7 37.2z", "M504 32c13.3 0 24 10.7 24 24v8h16c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H477.3l-22.6 22.6c-6 6-14.1 9.4-22.6 9.4H245L191 455.8C187.5 470 174.7 480 160 480H64c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L73.1 279.8c5-20.2-10.2-39.8-31-39.8H32c-17.7 0-32-14.3-32-32V96C0 78.3 14.3 64 32 64H480V56c0-13.3 10.7-24 24-24zM80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]]
};
var faSquarePhone = {
  prefix: 'fad',
  iconName: 'square-phone',
  icon: [448, 512, ["phone-square"], "f098", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z", "M178.5 140.3c-3.9-9.3-14-14.2-23.7-11.6l-44 12C102 143.1 96 151 96 160c0 123.7 100.3 224 224 224c9 0 16.9-6 19.3-14.7l12-44c2.6-9.7-2.3-19.9-11.6-23.7l-48-20c-8.2-3.4-17.6-1-23.2 5.8L248.3 312c-35.2-16.6-63.7-45.1-80.3-80.3l24.7-20.2c6.8-5.6 9.2-15 5.8-23.2l-20-48z"]]
};
var faPhoneSquare = faSquarePhone;
var faHatBeach = {
  prefix: 'fad',
  iconName: 'hat-beach',
  icon: [640, 512, [], "e606", ["M464 304l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3c-22.3 0-40.9-16.2-44.6-37.4C364.9 286.1 343 288 320 288c-88.4 0-160-28.7-160-64c0-18 3-35.4 8.5-51.5C174.7 201.3 240.1 224 320 224c23.6 0 46-2 66-5.5c-1.3-4.2-2-8.7-2-13.2c0-25 20.3-45.3 45.3-45.3c12 0 23.5 4.8 32 13.3L464 176l2.7-2.7c8.5-8.5 20-13.3 32-13.3c25 0 45.3 20.3 45.3 45.3c0 12-4.8 23.5-13.3 32L528 240l2.7 2.7c8.5 8.5 13.3 20 13.3 32c0 25-20.3 45.3-45.3 45.3c-12 0-23.5-4.8-32-13.3L464 304zm0-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M320 448c176.7 0 320-57.3 320-128c0-19.3-11.8-36.7-29.7-43.9L533 245.2c7 8.2 11 18.7 11 29.5c0 25-20.3 45.3-45.3 45.3c-12 0-23.5-4.8-32-13.3L464 304l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3c-22.3 0-40.9-16.2-44.6-37.4C364.9 286.1 343 288 320 288c-88.4 0-160-28.7-160-64L29.7 276.1C11.8 283.3 0 300.7 0 320c0 70.7 143.3 128 320 128zM470.6 169.8C448.4 108.1 389.3 64 320 64c-70.3 0-130.1 45.4-151.5 108.5C174.7 201.3 240.1 224 320 224c23.6 0 46-2 66-5.5c-1.3-4.2-2-8.7-2-13.2c0-25 20.3-45.3 45.3-45.3c12 0 23.5 4.8 32 13.3L464 176l2.7-2.7c1.2-1.2 2.5-2.4 3.8-3.4z"]]
};
var faPlus = {
  prefix: 'fad',
  iconName: 'plus',
  icon: [448, 512, [10133, 61543, "add"], "2b", ["M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z", ""]]
};
var faAdd = faPlus;
var faExpand = {
  prefix: 'fad',
  iconName: 'expand',
  icon: [448, 512, [], "f065", ["M448 64c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352c0-17.7-14.3-32-32-32z", "M0 64C0 46.3 14.3 32 32 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H64v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zM416 320c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h64V352c0-17.7 14.3-32 32-32z"]]
};
var faComputer = {
  prefix: 'fad',
  iconName: 'computer',
  icon: [640, 512, [], "e4e5", ["M528 32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M64 96H384V320H64V96zM48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H181.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H277.3l-10.7-32H400c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48z"]]
};
var faFort = {
  prefix: 'fad',
  iconName: 'fort',
  icon: [640, 512, [], "e486", ["M16 0C7.2 0 0 7.2 0 16V96v16 64c0 26.5 21.5 48 48 48H208c26.5 0 48-21.5 48-48V112 96 16c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16V64H160V16c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16V64H64V16C64 7.2 56.8 0 48 0H16zM448 64V16c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16V96v16 64c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V112 96 16c0-8.8-7.2-16-16-16H592c-8.8 0-16 7.2-16 16V64H544V16c0-8.8-7.2-16-16-16H496c-8.8 0-16 7.2-16 16V64H448z", "M384 160H256v16c0 26.5-21.5 48-48 48H48c-5.6 0-11-1-16-2.7V464c0 26.5 21.5 48 48 48H256V384c0-35.3 28.7-64 64-64s64 28.7 64 64V512H560c26.5 0 48-21.5 48-48V221.3c-5 1.8-10.4 2.7-16 2.7H432c-26.5 0-48-21.5-48-48V160z"]]
};
var faCloudCheck = {
  prefix: 'fad',
  iconName: 'cloud-check',
  icon: [640, 512, [], "e35c", ["M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM433 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z", "M433 207c9.4 9.4 9.4 24.6 0 33.9L305 369c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L399 207c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faXmark = {
  prefix: 'fad',
  iconName: 'xmark',
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", ["M297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6z", ""]]
};
var faClose = faXmark;
var faMultiply = faXmark;
var faRemove = faXmark;
var faTimes = faXmark;
var faFaceSmirking = {
  prefix: 'fad',
  iconName: 'face-smirking',
  icon: [512, 512, [], "e397", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM375.8 338.6l-.2 1.2c-5.8 34.7-35.8 60.2-71 60.2H192c-8.8 0-16-7.2-16-16s7.2-16 16-16H304.6c19.6 0 36.2-14.1 39.5-33.4l.2-1.2c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z", "M96 208c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16zm192 0c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z"]]
};
var faArrowsUpDownLeftRight = {
  prefix: 'fad',
  iconName: 'arrows-up-down-left-right',
  icon: [512, 512, ["arrows"], "f047", ["M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224h32 32V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 288H256 224V402.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288z", "M118.6 169.4c12.5 12.5 12.5 32.8 0 45.3l-9.4 9.4H256 402.7l-9.4-9.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l9.4-9.4H256 109.3l9.4 9.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-64-64c-12.5-12.5-12.5-32.8 0-45.3l64-64c12.5-12.5 32.8-12.5 45.3 0z"]]
};
var faArrows = faArrowsUpDownLeftRight;
var faChalkboardUser = {
  prefix: 'fad',
  iconName: 'chalkboard-user',
  icon: [640, 512, ["chalkboard-teacher"], "f51c", ["M224 0c-35.3 0-64 28.7-64 64V96c23.3 0 45.2 6.2 64 17.1V64l352 0V352H284.4c22.4 16.5 40.6 38.5 52.4 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224z", "M64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM0 485.3C0 411.7 59.7 352 133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3zM416 288h64c17.7 0 32 14.3 32 32v32H384V320c0-17.7 14.3-32 32-32z"]]
};
var faChalkboardTeacher = faChalkboardUser;
var faRhombus = {
  prefix: 'fad',
  iconName: 'rhombus',
  icon: [448, 512, [], "e23b", ["M254.4 14.1C246.8 5.1 235.7 0 224 0s-22.8 5.1-30.4 14.1l-184 216C-3.2 245-3.2 267 9.6 281.9l184 216c7.6 8.9 18.7 14.1 30.4 14.1s22.8-5.1 30.4-14.1l184-216c12.7-14.9 12.7-36.9 0-51.9l-184-216z", ""]]
};
var faClawMarks = {
  prefix: 'fad',
  iconName: 'claw-marks',
  icon: [576, 512, [], "f6c2", ["M310.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L288 77.3V128c0 17.7 14.3 32 32 32h50.7L416 205.3V256c0 17.7 14.3 32 32 32h50.7l22.6 22.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-64-64-64-64-64-64-32-32zm-224 224c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L96 333.3V416c0 17.7 14.3 32 32 32h82.7l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64-96-96-64-64z", "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4l96 96 64 64 160 160 64 64 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L434.7 448H384c-17.7 0-32-14.3-32-32V365.3L210.7 224H160c-17.7 0-32-14.3-32-32V141.3L41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3z"]]
};
var faPesoSign = {
  prefix: 'fad',
  iconName: 'peso-sign',
  icon: [384, 512, [], "e222", ["M32 128l0 64c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96l0 64c-17.7 0-32-14.3-32-32s14.3-32 32-32zm64 64V224H286.9c-3.6 24.9-15.3 47.2-32.5 64H96zm236.8 0c10-19.5 16.4-41.1 18.5-64h.7c17.7 0 32 14.3 32 32s-14.3 32-32 32H332.8zm18.5-96c-2.1-22.9-8.5-44.5-18.5-64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-.7zM96 128H254.4c17.1 16.8 28.9 39.1 32.5 64H96V128z", "M32 64c0-17.7 14.3-32 32-32H176c97.2 0 176 78.8 176 176s-78.8 176-176 176H96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 64zM96 320h80c61.9 0 112-50.1 112-112s-50.1-112-112-112H96V320z"]]
};
var faFaceSmileTongue = {
  prefix: 'fad',
  iconName: 'face-smile-tongue',
  icon: [512, 512, [], "e394", ["M503.4 322c5.6-21.1 8.6-43.2 8.6-66C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c61.5 0 118-21.7 162.1-57.9c-2.8-1.2-5.5-2.7-8.2-4.2l-68.1-40.4C316.3 423.8 287.1 432 256 432c-84.1 0-154-59.7-175.5-139.9c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3C129.5 351.5 187.9 400 256 400s126.5-48.5 144.5-116.1c2.3-8.5 11.1-13.6 19.6-11.3c1.5 .4 2.9 1 4.2 1.8l65.4 37.8c5 2.9 9.6 6.2 13.7 10zM217.6 228.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z", "M217.6 228.8l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm207.5 82.9c-11.7 30.4-30.5 57.1-54.5 77.6l55.7 33.1c22.6 13.4 51.8 5.8 65-17c13.3-23 5.4-52.3-17.6-65.6l-48.6-28.1zm-47.5-82.9l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]]
};
var faCartCircleXmark = {
  prefix: 'fad',
  iconName: 'cart-circle-xmark',
  icon: [640, 512, [], "e3f4", ["M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5h121c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H339.2c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]]
};
var faBuildingShield = {
  prefix: 'fad',
  iconName: 'building-shield',
  icon: [576, 512, [], "e4d8", ["M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c6.7 0 13.1-1.4 18.9-3.9c-74.6-56.7-96.4-143.4-98.7-201.5c-.1-.8-.2-1.7-.2-2.6v-7.8V272 240c0-8.8 7.2-16 16-16h32 37.6L384 207V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z", "M440.9 225.7c-5.7-2.3-12.1-2.3-17.8 0l-120 48C294 277.4 288 286.2 288 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C550.1 464.8 576 359.3 576 296c0-9.8-6-18.6-15.1-22.3l-120-48zm-8.9 236V273.8L527.4 312c-3.9 50.7-27.2 116.7-95.4 149.7z"]]
};
var faCirclePhoneFlip = {
  prefix: 'fad',
  iconName: 'circle-phone-flip',
  icon: [512, 512, ["phone-circle-alt"], "e11c", ["M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm69.3 128.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L312 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C143.1 378 151 384 160 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z", "M301.5 140.3c3.9-9.3 14-14.2 23.7-11.6l44 12C378 143.1 384 151 384 160c0 123.7-100.3 224-224 224c-9 0-16.9-6-19.3-14.7l-12-44c-2.6-9.7 2.3-19.9 11.6-23.7l48-20c8.2-3.4 17.6-1 23.2 5.8L231.7 312c35.2-16.6 63.7-45.1 80.3-80.3l-24.7-20.2c-6.8-5.6-9.2-15-5.8-23.2l20-48z"]]
};
var faPhoneCircleAlt = faCirclePhoneFlip;
var faBaby = {
  prefix: 'fad',
  iconName: 'baby',
  icon: [448, 512, [], "f77c", ["M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z", "M192 384l-64-56V288H320v40l-64 56H192z"]]
};
var faUsersLine = {
  prefix: 'fad',
  iconName: 'users-line',
  icon: [640, 512, [], "e592", ["M147.2 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM96 192c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96zm480 96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4H576zm-115.9 0c-10.8-30.7-36.8-54.2-68.9-61.6c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32zm39.1-128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-97.6-48a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z", "M0 448c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
};
var faQuoteLeft = {
  prefix: 'fad',
  iconName: 'quote-left',
  icon: [448, 512, [8220, "quote-left-alt"], "f10d", ["M376 96c-66.3 0-120 53.7-120 120v72 32 32c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H320v-8c0-30.9 25.1-56 56-56h8c17.7 0 32-14.3 32-32s-14.3-32-32-32h-8z", "M120 96C53.7 96 0 149.7 0 216v72 32 32c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H64v-8c0-30.9 25.1-56 56-56h8c17.7 0 32-14.3 32-32s-14.3-32-32-32h-8z"]]
};
var faQuoteLeftAlt = faQuoteLeft;
var faTractor = {
  prefix: 'fad',
  iconName: 'tractor',
  icon: [640, 512, [128668], "f722", ["M128 192c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v8.2c4.8 1.7 9.5 3.7 14.1 5.8l5.8-5.8c12.5-12.5 32.8-12.5 45.3 0l22.6 22.6c12.5 12.5 12.5 32.8 0 45.3l-5.8 5.8c2.2 4.6 4.1 9.3 5.8 14.1H320c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c12.5-12.5 32.8-12.5 45.3 0l5.8 5.8c4.6-2.2 9.3-4.1 14.1-5.8V192zM256 336A80 80 0 1 0 96 336a80 80 0 1 0 160 0zm296 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-112 0a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z", "M160 0C124.7 0 96 28.7 96 64v96 32 .6c4.4 1.5 8.6 4.1 12.1 7.6l5.8 5.8c4.6-2.2 9.3-4.1 14.1-5.8V192c0-17.7 14.3-32 32-32V64H266.3l38.4 96H192c17.7 0 32 14.3 32 32v8.2c4.8 1.7 9.5 3.7 14.1 5.8l5.8-5.8c12.5-12.5 32.8-12.5 45.3 0l22.6 22.6c12.5 12.5 12.5 32.8 0 45.3l-5.8 5.8c2.2 4.6 4.1 9.3 5.8 14.1H320c17.7 0 32 14.3 32 32v32h80c21.9-29.1 56.7-48 96-48c16.3 0 31.9 3.3 46.1 9.2l43.3-27.1c14-8.8 22.6-24.2 22.6-40.7V200c0-22.1-17.9-40-40-40H544V126.2c0-14.9 3.5-29.6 10.1-42.9l2.5-5c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.5 5C485.8 76.9 480 101.4 480 126.2V160H373.7L325.8 40.2C316 15.9 292.5 0 266.3 0H160z"]]
};
var faKeySkeleton = {
  prefix: 'fad',
  iconName: 'key-skeleton',
  icon: [448, 512, [128477], "f6f3", ["M182.1 220.7L9.4 393.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 416 96 397.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 352l86.1-86.1c-18.3-11.5-33.8-27-45.3-45.3z", "M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224A144 144 0 1 0 304 0a144 144 0 1 0 0 288z"]]
};
var faTrashArrowUp = {
  prefix: 'fad',
  iconName: 'trash-arrow-up',
  icon: [448, 512, ["trash-restore"], "f829", ["M32 96H416L394.6 466.8c-1.5 25.4-22.5 45.2-47.9 45.2H101.3c-25.4 0-46.5-19.8-47.9-45.2L32 96zM248 241.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V376c0 13.3 10.7 24 24 24s24-10.7 24-24V241.9z", "M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8zM248 241.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V376c0 13.3 10.7 24 24 24s24-10.7 24-24V241.9z"]]
};
var faTrashRestore = faTrashArrowUp;
var faArrowDownUpLock = {
  prefix: 'fad',
  iconName: 'arrow-down-up-lock',
  icon: [640, 512, [], "e4b0", ["M246.6 406.6l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L96 402.7V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0h64l128 0V109.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c6-6 14.1-9.4 22.6-9.4s16.6 3.4 22.6 9.4l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V224h74.8c-6.9 14.5-10.8 30.8-10.8 48v16H160V402.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM160 64V192H96V64c0-17.7 14.3-32 32-32s32 14.3 32 32zM288 448V320h64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faArrowDownToBracket = {
  prefix: 'fad',
  iconName: 'arrow-down-to-bracket',
  icon: [448, 512, [], "e094", ["M32 320c17.7 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96V352c0-17.7 14.3-32 32-32z", "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V242.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"]]
};
var faLinesLeaning = {
  prefix: 'fad',
  iconName: 'lines-leaning',
  icon: [384, 512, [], "e51e", ["M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zM384 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z", "M261.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8l-64 384c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l64-384c2.9-17.4 19.4-29.2 36.8-26.3z"]]
};
var faSquareQ = {
  prefix: 'fad',
  iconName: 'square-q',
  icon: [448, 512, [], "e27b", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L345 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z", "M224 176c44.2 0 80 35.8 80 80c0 13.4-3.3 25.9-9.1 37l-30-30c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l30 30c-11.1 5.8-23.7 9.1-37 9.1c-44.2 0-80-35.8-80-80s35.8-80 80-80zM329.9 327.9c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c26.7 0 51.4-8.2 71.9-22.1L311 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-15.1-15.1z"]]
};
var faRulerCombined = {
  prefix: 'fad',
  iconName: 'ruler-combined',
  icon: [512, 512, [], "f546", ["M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z", "M112 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0V96H112zm80 96l-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V192zm0 96l-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0v80c0 8.8 7.2 16 16 16s16-7.2 16-16V320H192V288zm128 32H288v80c0 8.8 7.2 16 16 16s16-7.2 16-16V320zm96 80V320H384v80c0 8.8 7.2 16 16 16s16-7.2 16-16z"]]
};
var faSymbols = {
  prefix: 'fad',
  iconName: 'symbols',
  icon: [512, 512, [128291, "icons-alt"], "f86e", ["M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM502.6 342.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zM0 128c0 17.7 14.3 32 32 32H80v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H112 32C14.3 96 0 110.3 0 128zM368 328a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM472 512a40 40 0 1 0 0-80 40 40 0 1 0 0 80z", "M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zm-374 356.9l19.6 20.7 23.5-23.5c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-24.7 24.7L215.2 458c12.2 12.8 11.6 33.1-1.2 45.2s-33.1 11.6-45.2-1.2l-24.1-25.4-12.8 12.8C117.4 503.9 97.7 512 77.3 512C34.6 512 0 477.4 0 434.7v-.9c0-19.4 7.2-38.2 20.3-52.6l14.5-15.9C23.2 353.7 16 337.7 16 320c0-35.3 28.7-64 64-64s64 28.7 64 64c0 17.1-6.7 32.7-17.7 44.2zM67.7 424.3c-2.4 2.6-3.7 6-3.7 9.5v.9c0 7.3 5.9 13.3 13.3 13.3c3.5 0 6.9-1.4 9.4-3.9l14-14L81.1 409.5 67.7 424.3zM96 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
};
var faIconsAlt = faSymbols;
var faCopyright = {
  prefix: 'fad',
  iconName: 'copyright',
  icon: [512, 512, [169], "f1f9", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z", "M312.6 199.4c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"]]
};
var faFlaskGear = {
  prefix: 'fad',
  iconName: 'flask-gear',
  icon: [640, 512, [], "e5f1", ["M160 0H288h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V196.8c0 11.8 3.3 23.5 9.5 33.5L336 241c-4.9 6.4-9.5 13.1-13.6 20.3c-7 12.1-12.4 24.7-16.4 37.6c-1.3 4.1-1.9 8.2-2 12.2l-29-47.1c-12.4-20.2-19-43.4-19-67.1V64H192V196.8c0 23.7-6.6 46.9-19 67.1L118.8 352h207c.1 .1 .2 .1 .2 .2c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 6.7 1.5 13.5 4.2 19.7c-9 4.3-19 6.6-29.7 6.6H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32z", "M447.3 203.4c-6.8 1.5-11.3 7.8-11.3 14.8v17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9l0 17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8l0-17.7c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7V218.2c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7zM480 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faHighlighterLine = {
  prefix: 'fad',
  iconName: 'highlighter-line',
  icon: [576, 512, [], "e1af", ["M183.3 183.3L360.7 360.7l-26.3 35.7c-9 12.3-23.4 19.5-38.6 19.5H224l-57.4 57.4c-12.5 12.5-32.8 12.5-45.3 0L70.6 422.6c-12.5-12.5-12.5-32.8 0-45.3L128 320l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6l35.7-26.3zM224 464H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M360.7 360.7L183.3 183.3 420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L360.7 360.7zM7 466.3l56-56c1.5 4.5 4.1 8.7 7.6 12.2l50.7 50.7c3.6 3.6 7.8 6.1 12.2 7.6l-24 24c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"]]
};
var faBracketSquare = {
  prefix: 'fad',
  iconName: 'bracket-square',
  icon: [192, 512, ["bracket", "bracket-left"], "5b", ["M0 96C0 60.7 28.7 32 64 32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64V416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V96z", ""]]
};
var faBracket = faBracketSquare;
var faBracketLeft = faBracketSquare;
var faIslandTropical = {
  prefix: 'fad',
  iconName: 'island-tropical',
  icon: [512, 512, [127965, "island-tree-palm"], "f811", ["M246.8 158l30-30h24.7c28 79.9 21.2 170.2 9.9 226.1c-7.6-1.4-15.4-2.1-23.4-2.1H224c29.7-79.3 29.4-150.9 22.8-194z", "M108.7 96c2.1 0 4.2-.8 5.7-2.3l24-24c3.1-3.1 8.2-3.1 11.3 0l24 24c.3 .3 .6 .6 1 .8c-1.4 1.3-2.8 2.6-4.1 4c-54.7 54.7-50.8 114.1-32.3 145.7c4.5 7.6 14.7 7.6 21 1.4L276.8 128H380.7c2.1 0 4.2-.8 5.7-2.3l24-24c3.1-3.1 8.2-3.1 11.3 0l24 24c1.5 1.5 3.5 2.3 5.7 2.3H496c8.8 0 16.1-7.2 13.8-15.8C500.6 76.8 461.4 32 384 32c-33.8 0-60.4 8.6-80.3 21.2C285.2 25.5 248.6 0 190.2 0C112.8 0 73.6 44.8 64.4 80.2C62.2 88.8 69.4 96 78.2 96h30.4zM160 352C89.3 352 32 409.3 32 480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32c0-70.7-57.3-128-128-128H160z"]]
};
var faIslandTreePalm = faIslandTropical;
var faArrowRightFromLine = {
  prefix: 'fad',
  iconName: 'arrow-right-from-line',
  icon: [448, 512, [8614, "arrow-from-left"], "f343", ["M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64z", "M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 288 272 288l-112 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l112 0 66.7 0-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z"]]
};
var faArrowFromLeft = faArrowRightFromLine;
var faH2 = {
  prefix: 'fad',
  iconName: 'h2',
  icon: [640, 512, [], "f314", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M491.5 128c-15.3 0-30.1 5.5-41.7 15.4l-29 24.9c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l29-24.9C431.4 74.9 461 64 491.5 64H496c70.7 0 128 57.3 128 128v5.8c0 35.9-15.1 70.1-41.5 94.4L482.3 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H400c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L539.2 244.9c13.2-12.1 20.8-29.2 20.8-47.2V192c0-35.3-28.7-64-64-64h-4.5z"]]
};
var faEquals = {
  prefix: 'fad',
  iconName: 'equals',
  icon: [448, 512, [62764], "3d", ["M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z", ""]]
};
var faCakeSlice = {
  prefix: 'fad',
  iconName: 'cake-slice',
  icon: [512, 512, [127856, "shortcake"], "e3e5", ["M448 288H0v80H448V288zm0 112H0v48c0 17.7 14.3 32 32 32H448V400z", "M296 32c-7.2 0-14.2 2.4-19.8 6.9l-264 208C4.5 252.9 0 262.2 0 272v16H64 448v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .1 32 .1 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2 .3 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 64c35.3 0 64-28.6 64-64v-.2-.2-.2-.2-.2V415v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V413v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V411v-.2-.2-.2-.2V410v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V406v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V401v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V398v-.2-.2-.2-.2-.2-.2-.2-.2V396v-.2-.2-.2-.2-.2-.2-.2-.2V394v-.2-.2-.2V393v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V390v-.2-.2-.2V389v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.3-.2-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V379v-.3-.3-.3V378v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V374v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V371v-.3-.3-.3-.3-.3-.3V369v-.3-.3-.3-.3-.3-.3V367v-.3-.3-.3-.3-.3-.3V365v-.3-.3-.3-.3-.3-.3V363v-.3-.3-.3-.3-.3-.3-.3-.3-.3V360v-.3-.3-.3-.3-.3-.3-.3-.3-.3V357v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V353v-.3-.3V352v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V346v-.3-.3V345v-.3-.3V344v-.3-.3V343v-.3-.3V342v-.3-.3V341v-.3-.3V340v-.3-.3V339v-.3-.3V338v-.3-.3V337v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.4-.4V330v-.4-.4V329v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V325v-.4-.4V324v-.4-.4-.4-.4-.4-.4-.4V321v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V312v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V307v-.4-.4-.4-.4V305v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V297v-.4-.4-.4-.4V295v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V290v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V285v-.4-.4-.4-.4-.4-.4V282v-.4-.4-.4-.4-.4-.4V279v-.4-.4-.4-.4-.4-.4-.4-.4V275v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.5V267v-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5V262v-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5V256c0-74.3-32.8-130.8-76.1-168.2C393.6 51.2 340.3 32 296 32z"]]
};
var faShortcake = faCakeSlice;
var faPeanut = {
  prefix: 'fad',
  iconName: 'peanut',
  icon: [512, 512, [], "e430", ["M432 0H364c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C245 57.8 234.4 74 227.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364v68c0 44.2 35.8 80 80 80h68c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C495.6 225.4 512 188.6 512 148V80c0-44.2-35.8-80-80-80zM396.8 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm0 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 0a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM192 396.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm0-64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z", "M416 147.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 0a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-224 224a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM211.2 416a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm0-64a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z"]]
};
var faWrenchSimple = {
  prefix: 'fad',
  iconName: 'wrench-simple',
  icon: [384, 512, [], "e2d1", ["M96 342.3V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V342.3c-28.2 16.3-61 25.7-96 25.7s-67.8-9.4-96-25.7z", "M203.3 212.7c-6.2 6.2-16.4 6.2-22.6 0l-48-48c-3-3-4.7-7.1-4.7-11.3V17.6c0-11-10.9-18.7-20.8-13.8C43.7 35 0 100.4 0 176C0 282 86 368 192 368s192-86 192-192c0-75.6-43.7-141-107.2-172.3C266.9-1.2 256 6.5 256 17.6V153.4c0 4.2-1.7 8.3-4.7 11.3l-48 48z"]]
};
var faBlender = {
  prefix: 'fad',
  iconName: 'blender',
  icon: [512, 512, [], "f517", ["M64 0C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64h85.3L160 384H416l24-96H336c-8.8 0-16-7.2-16-16s7.2-16 16-16H448l16-64H336c-8.8 0-16-7.2-16-16s7.2-16 16-16H472l16-64H336c-8.8 0-16-7.2-16-16s7.2-16 16-16H496l6.1-24.2C507.1 19.6 491.8 0 471 0H160 128 64zm69.3 64L144 192H64V64h69.3z", "M336 64H496l-8 32H336c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H472l-8 32H336c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H448l-8 32H336c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 432c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432zm224 16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
};
var faTeeth = {
  prefix: 'fad',
  iconName: 'teeth',
  icon: [576, 512, [], "f62e", ["M224 128c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zm128 0c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z", "M0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"]]
};
var faTally2 = {
  prefix: 'fad',
  iconName: 'tally-2',
  icon: [640, 512, [], "e295", ["M128 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32z", "M256 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"]]
};
var faShekelSign = {
  prefix: 'fad',
  iconName: 'shekel-sign',
  icon: [448, 512, [8362, "ils", "shekel", "sheqel", "sheqel-sign"], "f20b", ["M448 352c0 70.7-57.3 128-128 128H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32V416H320c35.3 0 64-28.7 64-64V64c0-17.7 14.3-32 32-32s32 14.3 32 32V352z", "M0 64C0 46.3 14.3 32 32 32H192c70.7 0 128 57.3 128 128V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-35.3-28.7-64-64-64H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64z"]]
};
var faIls = faShekelSign;
var faShekel = faShekelSign;
var faSheqel = faShekelSign;
var faSheqelSign = faShekelSign;
var faCars = {
  prefix: 'fad',
  iconName: 'cars',
  icon: [640, 512, [], "f85b", ["M138.6 64H277.4c6.9 0 13 4.4 15.2 10.9L310.3 128H105.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zM62.7 54.7L36.1 134.4C14.8 144.7 0 166.6 0 192v96H0v32c0 17.7 14.3 32 32 32H48c17.7 0 32-14.3 32-32V288H216.5c5.1-5.7 10.8-10.7 17.1-15.1l22.8-68.3c15.2-45.7 58-76.6 106.3-76.6h15.1L353.3 54.7C342.4 22 311.8 0 277.4 0H138.6c-34.4 0-65 22-75.9 54.7zM80 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M347.4 234.9L329.7 288H534.3l-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9H362.6c-6.9 0-13 4.4-15.2 10.9zm-87.3 59.4l26.6-79.7C297.6 182 328.2 160 362.6 160H501.4c34.4 0 65 22 75.9 54.7l26.6 79.7C625.2 304.7 640 326.6 640 352v96h0v32c0 17.7-14.3 32-32 32H592c-17.7 0-32-14.3-32-32V448H304v32c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V448h0V352c0-25.4 14.8-47.3 36.1-57.6zM328 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faAxeBattle = {
  prefix: 'fad',
  iconName: 'axe-battle',
  icon: [512, 512, [], "f6b3", ["M95.9 14.1l0-.1 0 0C95.1 7.7 90.6 2.5 84.5 .7c-6.1-1.8-12.7 .2-16.8 5L80 16C67.8 5.7 67.8 5.7 67.8 5.7l0 0 0 0-.1 .1L67.5 6l-.6 .8c-.5 .7-1.3 1.6-2.3 2.9c-1.9 2.5-4.6 6.1-7.7 10.6c-6.3 9.2-14.7 22.4-23.1 38.9C17 92.1 0 138.7 0 192s17 99.9 33.7 132.7c8.4 16.5 16.8 29.7 23.1 38.9c3.2 4.6 5.8 8.2 7.7 10.6c1 1.2 1.7 2.2 2.3 2.9l.6 .8 .2 .2 .1 .1 0 0 0 0s0 0 12.2-10.3L67.8 378.3c3.9 4.6 10 6.6 15.8 5.3s10.4-5.9 11.9-11.7l0 0 0-.1 .2-.8c.2-.7 .6-1.9 1.1-3.5c1-3.1 2.7-7.6 5.1-13.1c4.8-11 12.6-25.7 24.5-40.3c19.4-23.9 50-48 97.6-55.6V126c-54.6-7.1-85.4-31.9-103.2-55.6c-10.7-14.3-17-28.7-20.6-39.5c-1.8-5.4-2.9-9.8-3.5-12.8c-.3-1.5-.5-2.6-.6-3.3c-.1-.4-.1-.6-.1-.7zM288 126V258.4c47.6 7.6 78.2 31.7 97.6 55.6c13.6 16.8 25 36.7 30.9 57.7c1.5 5.8 6.1 10.5 11.9 11.8s12.3-1 16.1-5.6c33.1-41.1 56.5-93.6 64.5-146.6c.5-3.5-1.4-7-4.7-8.4l-55.1-23.6c-6.5-2.8-6.5-11.9 0-14.7L504.3 161c3.3-1.4 5.3-4.8 4.7-8.4c-5.6-36.8-18.3-68.9-30.7-93.4c-9.5-18.7-20.7-37.2-33.9-53.4c-4.1-4.9-10.8-7-16.9-5.2c-6.1 1.8-10.5 7-11.3 13.3c-3.3 20-12.9 40.3-24.9 56.4C373.4 94.1 342.6 119 288 126z", "M256 32c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"]]
};
var faUserHairLong = {
  prefix: 'fad',
  iconName: 'user-hair-long',
  icon: [448, 512, [], "e45b", ["M257.9 66.2C241 93.7 210.6 112 176 112H128l0 48c0 53 43 96 96 96s96-43 96-96l0-64h-8c-22.8 0-42.8-11.9-54.1-29.8z", "M176 112H128h0v48c0 53 43 96 96 96s96-43 96-96V128h0V96h-8c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112zm48 160H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128h0C96 57.3 153.3 0 224 0c70.6 0 127.8 57.1 128 127.6v.8l0 .2V139c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224zm-62.7 48H286.7C375.8 320 448 392.2 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3C0 392.2 72.2 320 161.3 320z"]]
};
var faMap = {
  prefix: 'fad',
  iconName: 'map',
  icon: [576, 512, [128506, 62072], "f279", ["M192.1 416L384 480V96L192 32l.1 384z", "M0 114.5V464c0 11.3 11.5 19 22 14.8L192 416l-.1-384L10.1 99.6C4 102 0 107.9 0 114.5zM554 33.2L384 96V480l181.9-67.6c6.1-2.4 10.1-8.3 10.1-14.9V48c0-11.3-11.4-19.1-22-14.9z"]]
};
var faFileCircleInfo = {
  prefix: 'fad',
  iconName: 'file-circle-info',
  icon: [576, 512, [58604], "e493", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-32 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v64c8.8 0 16 7.2 16 16s-7.2 16-16 16H432 416c-8.8 0-16-7.2-16-16s7.2-16 16-16h0V384h0c-8.8 0-16-7.2-16-16z"]]
};
var faFaceDisappointed = {
  prefix: 'fad',
  iconName: 'face-disappointed',
  icon: [512, 512, [], "e36f", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z", "M211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]]
};
var faLassoSparkles = {
  prefix: 'fad',
  iconName: 'lasso-sparkles',
  icon: [576, 512, [], "e1c9", ["M290.7 0c-.9 0-1.8 0-2.7 0C128.9 0 0 78.8 0 176c0 57.2 44.7 108.1 113.9 140.2l-.2 .4L160.5 340c19.3 9.7 31.5 29.4 31.5 51c0 31.5-25.5 57-57 57H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h71c66.8 0 121-54.2 121-121c0-14.1-2.4-27.8-7-40.6c12.8 1.1 25.8 1.6 39 1.6c159.1 0 288-78.8 288-176c0-76.4-79.6-141.4-191-165.8l5.6 15.1 26 9.6C435.5 42 448 59.9 448 80c0 5.6-1 11.1-2.8 16.2C486.4 116.5 512 144.8 512 176c0 61.9-100.3 112-224 112S64 237.9 64 176c0-51 68.2-94 161.4-107.6c3.8-15.2 14.8-27.9 29.9-33.4l26-9.6L290.7 0z", "M336 0c6.7 0 12.7 4.2 15 10.4l14.7 39.8L405.6 65c6.3 2.3 10.4 8.3 10.4 15s-4.2 12.7-10.4 15l-39.8 14.7L351 149.6c-2.3 6.3-8.3 10.4-15 10.4s-12.7-4.2-15-10.4l-14.7-39.8L266.4 95c-6.3-2.3-10.4-8.3-10.4-15s4.2-12.7 10.4-15l39.8-14.7L321 10.4C323.3 4.2 329.3 0 336 0zM496 352c6.7 0 12.7 4.2 15 10.4l14.7 39.8L565.6 417c6.3 2.3 10.4 8.3 10.4 15s-4.2 12.7-10.4 15l-39.8 14.7L511 501.6c-2.3 6.3-8.3 10.4-15 10.4s-12.7-4.2-15-10.4l-14.7-39.8L426.4 447c-6.3-2.3-10.4-8.3-10.4-15s4.2-12.7 10.4-15l39.8-14.7L481 362.4c2.3-6.3 8.3-10.4 15-10.4z"]]
};
var faClockEleven = {
  prefix: 'fad',
  iconName: 'clock-eleven',
  icon: [512, 512, [], "e347", ["M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120v56.7l-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z", "M256 96c-13.3 0-24 10.7-24 24v56.7l-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V120c0-13.3-10.7-24-24-24z"]]
};
var faRocket = {
  prefix: 'fad',
  iconName: 'rocket',
  icon: [512, 512, [], "f135", ["M198.6 130c-28.5 45.8-60.7 114.5-80.1 158H24c-8.7 0-16.7-4.7-20.9-12.2s-4.1-16.8 .4-24.2l52.8-86.9C69.3 143.2 92.6 130 117.8 130h80.8zM224 391.8c43.9-19.1 112.4-50.3 158-78.4v80.8c0 25.2-13.1 48.5-34.6 61.5l-86.9 52.8c-7.4 4.5-16.7 4.7-24.2 .4s-12.2-12.2-12.2-20.9l0-96.2z", "M166.5 394.8l-50.7-50.7c-9.2-9.2-11.9-23-6.7-34.9c18.3-41.9 62.7-140.2 98.1-192.5C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7C342.6 340.5 243 383.9 201 401.7c-11.8 5-25.4 2.2-34.5-6.9zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]]
};
var faSirenOn = {
  prefix: 'fad',
  iconName: 'siren-on',
  icon: [640, 512, [], "e02e", ["M144 352l25-199.9c4-32 31.2-56.1 63.5-56.1h175c32.3 0 59.5 24 63.5 56.1L496 352H234.1l21.8-174c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9L201.9 352H144z", "M69.3 36c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM597.3 76c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24H88c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H552zM128 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H128z"]]
};
var faClockTen = {
  prefix: 'fad',
  iconName: 'clock-ten',
  icon: [512, 512, [], "e354", ["M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120v91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z", "M256 96c-13.3 0-24 10.7-24 24v91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256V120c0-13.3-10.7-24-24-24z"]]
};
var faCandleHolder = {
  prefix: 'fad',
  iconName: 'candle-holder',
  icon: [448, 512, [128367], "f6bc", ["M80 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-39.6-49.1-90.1-66.2-106.6C170.1 1.9 165.2 0 160 0s-10.1 1.9-13.8 5.4C129.1 21.9 80 72.4 80 112zM376 416a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96c39.8 0 72-32.2 72-72s-32.2-72-72-72s-72 32.2-72 72c0 8.4 1.4 16.5 4.1 24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H376z", "M128 224v48c0 8.8 7.2 16 16 16s16-7.2 16-16V224h64c17.7 0 32 14.3 32 32V464H64V256c0-17.7 14.3-32 32-32h32z"]]
};
var faVideoArrowDownLeft = {
  prefix: 'fad',
  iconName: 'video-arrow-down-left',
  icon: [576, 512, [], "e2c8", ["M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM232 352H120c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v54.1L247 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-103 103H232c13.3 0 24 10.7 24 24s-10.7 24-24 24z", "M559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6L384 315.8V196.2l142.2-94.8c9.8-6.5 22.4-7.2 32.9-1.6zM232 352H120c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v54.1L247 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-103 103H232c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]]
};
var faPhotoFilm = {
  prefix: 'fad',
  iconName: 'photo-film',
  icon: [640, 512, ["photo-video"], "f87c", ["M192 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64zM456 96c-8 0-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C471.5 100 464 96 456 96zM304 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M476 106.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S560.9 288 552 288H408 360 280c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C440.5 100 448 96 456 96s15.5 4 20 10.7zM64 128H192v64c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V352H512v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"]]
};
var faPhotoVideo = faPhotoFilm;
var faFloppyDiskCircleArrowRight = {
  prefix: 'fad',
  iconName: 'floppy-disk-circle-arrow-right',
  icon: [576, 512, ["save-circle-arrow-right"], "e180", ["M0 96C0 60.7 28.7 32 64 32H306.7c17 0 33.3 6.7 45.3 18.7L429.3 128c12 12 18.7 28.3 18.7 45.3v19.5c-5.3-.5-10.6-.7-16-.7c-75 0-139.1 47-164.4 113.1C256.1 294.5 240.8 288 224 288c-35.3 0-64 28.7-64 64s28.7 64 64 64c13.3 0 25.7-4.1 35.9-11c6 28.1 18.7 53.7 36.3 75H64c-35.3 0-64-28.7-64-64V96zm96 0c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm19.3-211.3l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]]
};
var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
var faFolderMinus = {
  prefix: 'fad',
  iconName: 'folder-minus',
  icon: [512, 512, [], "f65d", ["M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z", "M160 296c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24z"]]
};
var faPlanetMoon = {
  prefix: 'fad',
  iconName: 'planet-moon',
  icon: [576, 512, [], "e01f", ["M224 512c123.7 0 224-100.3 224-224c0-112.8-83.4-206.2-192-221.7v82.1c0 7.5-2.6 14.7-7.4 20.5l-52.7 63.2c-11.3 13.5-10.4 33.5 2.1 45.9c6.4 6.4 15.1 10 24.1 10H288c17.7 0 32 14.3 32 32v15.9c0 10.6-2.6 21-7.6 30.3l-41.3 76.6c-4.4 8.1-12.8 13.2-22 13.2c-13.8 0-25-11.2-25-25V384c-17.7 0-32-14.3-32-32V320l-49.9-49.9c-9-9-21.2-14.1-33.9-14.1H74.5c-17 0-33.3-6.7-45.3-18.7L10.9 218.9C3.8 240.6 0 263.9 0 288C0 411.7 100.3 512 224 512z", "M512 128A64 64 0 1 0 512 0a64 64 0 1 0 0 128zM224 64C124.4 64 40 129 10.9 218.9l18.4 18.4c12 12 28.3 18.7 45.3 18.7h33.6c12.7 0 24.9 5.1 33.9 14.1L192 320v32c0 17.7 14.3 32 32 32v47c0 13.8 11.2 25 25 25c9.2 0 17.7-5.1 22-13.2l41.3-76.6c5-9.3 7.6-19.8 7.6-30.3V320c0-17.7-14.3-32-32-32H222.1c-9 0-17.7-3.6-24.1-10c-12.5-12.5-13.4-32.4-2.1-45.9l52.7-63.2c4.8-5.8 7.4-13 7.4-20.5V66.3c-10.5-1.5-21.1-2.3-32-2.3z"]]
};
var faFaceEyesXmarks = {
  prefix: 'fad',
  iconName: 'face-eyes-xmarks',
  icon: [512, 512, [], "e374", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM123.3 132.7L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm192 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM256 304c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z", "M196.7 132.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 169.4l36.7-36.7zm96 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"]]
};
var faChartScatter = {
  prefix: 'fad',
  iconName: 'chart-scatter',
  icon: [512, 512, [], "f7ee", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M384 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faDisplayArrowDown = {
  prefix: 'fad',
  iconName: 'display-arrow-down',
  icon: [576, 512, [], "e164", ["M264 0H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H312V64H512V352H64V64H264V0z", "M264 64H64V352H512V64H312V206.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V64zm82.7 384L336 416H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7z"]]
};
var faStore = {
  prefix: 'fad',
  iconName: 'store',
  icon: [576, 512, [], "f54e", ["M64 219.1V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 219.1c-5.1 2-10.6 3.4-16.5 4.1c-4 .5-7.9 .8-12.1 .8c-12.7 0-24.6-2.7-35.4-7.5V384H128V216.5c-10.8 4.8-22.9 7.5-35.6 7.5c-4.1 0-8.2-.3-12.1-.8c-5.7-.8-11.2-2.2-16.2-4.1z", "M490.3 13.1l57.3 90.7c29.7 46.9 3.4 112-52.1 119.4c-4 .5-7.9 .8-12.1 .8c-26.1 0-49.2-11.4-65.2-29c-15.9 17.6-39 29-65.2 29c-26.1 0-49.3-11.4-65.2-29c-15.9 17.6-39 29-65.2 29c-26.1 0-49.3-11.4-65.2-29c-15.9 17.6-39.1 29-65.2 29c-4.1 0-8.2-.3-12.1-.8c-55.3-7.4-81.5-72.6-51.9-119.4L85.7 13.1C90.8 5 99.9 0 109.6 0H466.4c9.7 0 18.8 5 23.9 13.1z"]]
};
var faArrowTrendUp = {
  prefix: 'fad',
  iconName: 'arrow-trend-up',
  icon: [576, 512, [], "e098", ["M466.7 160L320 306.7 214.6 201.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 269.3 297.4 374.6c12.5 12.5 32.8 12.5 45.3 0L512 205.3V160H466.7z", "M352 128c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V160H384c-17.7 0-32-14.3-32-32z"]]
};
var faPlugCircleMinus = {
  prefix: 'fad',
  iconName: 'plug-circle-minus',
  icon: [576, 512, [], "e55e", ["M128 32v96H64V32C64 14.3 78.3 0 96 0s32 14.3 32 32zm192 0v96H256V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V412.8C87 398 32 333.4 32 256V224c-17.7 0-32-14.3-32-32z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]]
};
var faOliveBranch = {
  prefix: 'fad',
  iconName: 'olive-branch',
  icon: [640, 512, [], "e317", ["M336 512c79.5 0 144-86 144-192s-64.5-192-144-192s-144 86-144 192s64.5 192 144 192zm269.4-67.2c56.2-58.3 41-168.6-33.9-246.4c-42.9-44.5-96.1-68.7-144.2-70.3c13.6 10.4 25.7 22.9 36.2 36.9C494 205.8 512 260.7 512 320c0 57.8-17.1 111.4-46.3 151.8c52.9 16.5 105.5 8.4 139.6-27z", "M128 0C59 0 13.8 41.6 2.7 53.1C.9 55 0 57.4 0 60s.9 5 2.7 6.9c8.6 8.9 37.7 35.9 82.5 47.6C34.5 141.4 0 194.6 0 256v16c0 8.8 7.2 16 16 16H32c86.6 0 157.1-68.7 159.9-154.6L326.4 70.1C357.3 55.5 391.1 48 425.2 48H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H425.2C384 0 343.3 9.1 306 26.7L252.2 52C239.4 39.1 194.9 0 128 0z"]]
};
var faAngle = {
  prefix: 'fad',
  iconName: 'angle',
  icon: [448, 512, [], "e08c", ["M315.5 253.2c-20.7-30.1-46.1-56.7-75.1-78.9l-21.9 43.8c21.4 17.4 40.4 37.7 56.2 60.4l40.8-25.3zm-23.9 52.5c13.3 24.2 23.3 50.5 29.5 78.3h49c-7-37-19.8-71.9-37.6-103.7l-40.8 25.3z", "M238.3 35.4c15.8 7.9 22.2 27.1 14.3 42.9L83.8 416H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l192-384c7.9-15.8 27.1-22.2 42.9-14.3z"]]
};
var faVacuumRobot = {
  prefix: 'fad',
  iconName: 'vacuum-robot',
  icon: [512, 512, [], "e04e", ["M212.7 212.7c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM155.3 155.3c55.6-55.6 145.8-55.6 201.4 0s55.6 145.8 0 201.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c68.1-68.1 68.1-178.5 0-246.6s-178.5-68.1-246.6 0c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm80 57.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64zm-80 16c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zm-38.6 80c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0z"]]
};
var faSignHanging = {
  prefix: 'fad',
  iconName: 'sign-hanging',
  icon: [512, 512, ["sign"], "f4d9", ["M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V480c0 17.7 14.3 32 32 32s32-14.3 32-32V128l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L128 64V32z", "M192 160c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H192z"]]
};
var faSign = faSignHanging;
var faSquareDivide = {
  prefix: 'fad',
  iconName: 'square-divide',
  icon: [448, 512, [], "e26a", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM136 232H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M192 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 96c0-13.3 10.7-24 24-24H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-13.3 0-24-10.7-24-24zm112 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faSignalStreamSlash = {
  prefix: 'fad',
  iconName: 'signal-stream-slash',
  icon: [640, 512, [], "e250", ["M576 256c0 51.3-13.4 99.5-36.9 141.2l-51.1-40.1C503.3 326.8 512 292.4 512 256c0-53-18.4-101.6-49.1-140c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5C552.3 125.3 576 187.9 576 256zm-112 0c0 25.2-5.3 49.1-14.8 70.8l-53-41.6c2.5-9.3 3.8-19.1 3.8-29.2c0-28.7-10.8-54.8-28.5-74.7c-11.8-13.2-10.7-33.4 2.5-45.2s33.4-10.7 45.2 2.5C447 169.8 464 210.9 464 256zM288 200c26.5 0 48.7 18.4 54.5 43.2L287.5 200l.5 0zm-164.5-6.7l54.3 42.8c-1.2 6.5-1.8 13.1-1.8 19.9c0 28.7 10.8 54.8 28.5 74.7c11.8 13.2 10.7 33.4-2.5 45.2s-33.4 10.7-45.2-2.5C129 342.2 112 301.1 112 256c0-22.1 4.1-43.2 11.5-62.7zM33 122l51.4 40.5C71.3 190.9 64 222.6 64 256c0 53 18.4 101.6 49.1 140c11.1 13.8 8.8 33.9-5 45s-33.9 8.8-45-5C23.7 386.7 0 324.1 0 256c0-48.4 11.9-94 33-134z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faBezierCurve = {
  prefix: 'fad',
  iconName: 'bezier-curve',
  icon: [640, 512, [], "f55b", ["M240 84H121.6C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180h56.2c5.9-67 48.5-123.4 107.5-149.1C243 163.2 240 154 240 144V84zm151.8 86.9c59 25.7 101.6 82.1 107.5 149.1h56.2c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400v60c0 10-3 19.2-8.2 26.9z", "M296 136h48V88H296v48zM240 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288c-26.5 0-48-21.5-48-48V80zM88 376v48h48V376H88zm-8-56h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm424 56v48h48V376H504zm-8-56h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48z"]]
};
var faEyeDropperHalf = {
  prefix: 'fad',
  iconName: 'eye-dropper-half',
  icon: [512, 512, [], "e173", ["M198.7 180L55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L332 313.3 286.7 268 143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L244 225.3 198.7 180z", "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM143.4 411.3L234.7 320H149.3l-48.6 48.6c-3 3-4.7 7.1-4.7 11.3V416h36.1c4.2 0 8.3-1.7 11.3-4.7z"]]
};
var faStoreLock = {
  prefix: 'fad',
  iconName: 'store-lock',
  icon: [640, 512, [], "e4a6", ["M490.3 13.1l57.3 90.7c11.9 18.8 14.8 40.5 10.4 60.3c-9.6-2.7-19.7-4.1-30.1-4.1c-38.7 0-72.8 19.6-92.9 49.5c-6.2-4.1-11.9-9-16.8-14.4c-15.9 17.6-39 29-65.2 29c-26.1 0-49.3-11.4-65.2-29c-15.9 17.6-39 29-65.2 29c-26.1 0-49.3-11.4-65.2-29c-15.9 17.6-39.1 29-65.2 29c-4.1 0-8.2-.3-12.1-.8c-55.3-7.4-81.5-72.6-51.9-119.4L85.7 13.1C90.8 5 99.9 0 109.6 0H466.4c9.7 0 18.8 5 23.9 13.1zM384 384v96c0 11.7 3.1 22.6 8.6 32H128c-35.3 0-64-28.7-64-64V384 252.6c3.9 1 7.9 1.7 12 2.3l.1 0c5.3 .7 10.7 1.1 16.3 1.1c12.5 0 24.4-1.9 35.6-5.4V384H384z", "M496 272v48h64V272c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48V272c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32z"]]
};
var faBellSlash = {
  prefix: 'fad',
  iconName: 'bell-slash',
  icon: [640, 512, [128277, 61943], "f1f6", ["M540.6 398.4c.2-.4 .4-.9 .6-1.3c5.2-11.5 3.1-25-5.3-34.4l-7.4-8.3C497.3 319.2 480 273.9 480 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L540.6 398.4zM406.2 416L160 222.1v4.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416H406.2zm-40.9 77.3c12-12 18.7-28.3 18.7-45.3H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faCloudBoltSun = {
  prefix: 'fad',
  iconName: 'cloud-bolt-sun',
  icon: [640, 512, ["thunderstorm-sun"], "f76e", ["M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm266.1 83.5c5.8 4.7 7.6 12.9 4.3 19.6L425.9 352H496c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L374.1 384H304c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z", "M639.9 303.9c0 44.2-35.8 80-80 80H541.3c3.5-10.1 3.7-21.3 0-31.8C534.5 332.9 516.4 320 496 320H477.7l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2l-160 128c-14.5 11.6-20.9 30.5-16.8 48.4c-37.9-12.8-65.2-48.7-65.2-90.9c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"]]
};
var faThunderstormSun = faCloudBoltSun;
var faCameraSlash = {
  prefix: 'fad',
  iconName: 'camera-slash',
  icon: [640, 512, [], "e0d9", ["M356.4 376.8c-11.2 4.6-23.5 7.2-36.4 7.2c-53 0-96-43-96-96c0-5 .4-9.9 1.1-14.6L65.2 147.4c-.8 4.1-1.2 8.3-1.2 12.6V416c0 35.3 28.7 64 64 64H487.4L356.4 376.8zM416 288c0 4.1-.3 8.2-.8 12.2l160 125.4c.5-3.1 .7-6.3 .7-9.6V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8L202.7 96H154.8L285.4 198.4c10.7-4.1 22.4-6.4 34.6-6.4c53 0 96 43 96 96z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faCommentQuote = {
  prefix: 'fad',
  iconName: 'comment-quote',
  icon: [512, 512, [], "e14c", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM160 144h48c17.7 0 32 14.3 32 32v24 24 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256H160c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32zm224 80v39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256H304c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24z", "M128 176c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256H160c-17.7 0-32-14.3-32-32V176zm256 87.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256H304c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24 39.3z"]]
};
var faTablet = {
  prefix: 'fad',
  iconName: 'tablet',
  icon: [448, 512, ["tablet-android"], "f3fb", ["M448 384H0v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V384H0V64z"]]
};
var faTabletAndroid = faTablet;
var faSchoolFlag = {
  prefix: 'fad',
  iconName: 'school-flag',
  icon: [576, 512, [], "e56e", ["M255.3 96l-89.6 64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H240V400c0-26.5 21.5-48 48-48s48 21.5 48 48V512H512c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H410.3L320.7 96H255.3zM288 192a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm400-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM64 368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368zm384 0c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V368z", "M297.4 1.4c2-.9 4.2-1.4 6.6-1.4h96c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H320 304 256V32c0-17.7 14.3-32 32-32c3.3 0 6.4 .5 9.4 1.4zM80 224h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm384 0h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM64 368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368zm400-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16z"]]
};
var faMessageCode = {
  prefix: 'fad',
  iconName: 'message-code',
  icon: [512, 512, [], "e1df", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm217 97c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM329 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z", "M217 127c9.4 9.4 9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0zm78.1 0c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]]
};
var faGlassHalf = {
  prefix: 'fad',
  iconName: 'glass-half',
  icon: [384, 512, ["glass-half-empty", "glass-half-full"], "e192", ["M8.6 10.2C14.6 3.7 23.1 0 32 0H352c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1L355.1 437.7c-3 41.9-37.8 74.3-79.8 74.3H108.7c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64L92.7 433.1c.6 8.4 7.6 14.9 16 14.9H275.3c8.4 0 15.4-6.5 16-14.9L317.6 64H66.4z", "M306.2 224H77.8L92.7 433.1c.6 8.4 7.6 14.9 16 14.9H275.3c8.4 0 15.4-6.5 16-14.9L306.2 224z"]]
};
var faGlassHalfEmpty = faGlassHalf;
var faGlassHalfFull = faGlassHalf;
var faFill = {
  prefix: 'fad',
  iconName: 'fill',
  icon: [512, 512, [], "f575", ["M386.7 288H67.5c-2.7 10.6 .1 22.3 8.4 30.6L193.4 436.1c12.5 12.5 32.8 12.5 45.3 0L386.7 288z", "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L238.6 436.1c-12.5 12.5-32.8 12.5-45.3 0L75.9 318.6c-12.5-12.5-12.5-32.8 0-45.3L168 181.3z"]]
};
var faMessageMinus = {
  prefix: 'fad',
  iconName: 'message-minus',
  icon: [512, 512, ["comment-alt-minus"], "f4a7", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM184 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z", "M160 208c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24z"]]
};
var faCommentAltMinus = faMessageMinus;
var faAngleUp = {
  prefix: 'fad',
  iconName: 'angle-up',
  icon: [448, 512, [8963], "f106", ["M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z", ""]]
};
var faDinosaur = {
  prefix: 'fad',
  iconName: 'dinosaur',
  icon: [640, 512, [], "e5fe", ["M446.2 0H448C554 0 640 86 640 192v30.6c0 88-51.5 165.6-128 201.5V480c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V458c-15.3 3.9-31.4 6-48 6c-6.8 0-13.5-.4-20.1-1c-7.5-18.9-24.4-33.3-45.4-36.8L162 408.1c-19.6-3.3-34-20.2-34-40.1c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.5 25.7 65.8 60.7 71.7l108.5 18.1c13.2 2.2 22.8 13.6 22.8 26.9c0 15.1-12.2 27.3-27.3 27.3H256 224 192 120.7C54.1 512 0 457.9 0 391.3c0-34 14.4-66.5 39.5-89.3l89.7-81.6C172 181.5 227.6 160 285.3 160c50.2 0 99 16.3 139.2 46.4L480 248c6.9 5.2 15.3 8 24 8c22.1 0 40-17.9 40-40V192c0-35.3-28.7-64-64-64H448 415.7c-26.3 0-47.7-21.4-47.7-47.7V75.6c0-16.7 10.1-31.6 25.6-37.8l1.7-.7c8.2-3.3 14.8-9.4 18.7-17.2C420.2 7.7 432.6 0 446.2 0zM464 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z", "M448 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]]
};
var faDrumstickBite = {
  prefix: 'fad',
  iconName: 'drumstick-bite',
  icon: [512, 512, [], "f6d7", ["M160.2 278.2c3 39.2 34.3 70.5 73.5 73.5l-36.4 36.4c-12.3 12.3-11.4 32.5-7.2 49.4c1.1 4.6 1.8 9.5 1.8 14.5c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c5 0 9.8 .6 14.5 1.8c16.9 4.2 37.1 5.2 49.4-7.2l36.4-36.4z", "M160 272V176C160 78.8 238.8 0 336 0c86.5 0 158.5 62.5 173.2 144.8c2.1 11.8-10.3 20.1-22 17.6c-7.5-1.6-15.3-2.4-23.2-2.4c-61.9 0-112 50.1-112 112c0 19.2 4.8 37.2 13.3 53c5.7 10.5 1.1 24.8-10.8 26c-6.1 .6-12.3 1-18.5 1H240c-44.2 0-80-35.8-80-80z"]]
};
var faLinkHorizontalSlash = {
  prefix: 'fad',
  iconName: 'link-horizontal-slash',
  icon: [640, 512, ["chain-horizontal-slash"], "e1cc", ["M574.1 424.7c39.6-25.8 65.9-70.5 65.9-121.3c0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9 .3c38.9 6.5 67.4 40.1 67.4 79.5c0 36.6-24.4 67.6-57.9 77.4l56.1 43.9zM415.3 300.2c20.5-25.1 32.7-57.1 32.7-91.6C448 128.7 383.3 64 303.4 64H144.6c-9.4 0-18.5 .9-27.4 2.6L195.6 128H303.4c44.5 0 80.6 36.1 80.6 80.6c0 19.7-7.1 38-19.1 52.1l50.4 39.5zM446.8 448l-81.2-64H336.6c-44.5 0-80.6-36.1-80.6-80.6c0-1.9 .1-3.7 .2-5.5l-55.5-43.8c-5.6 15.4-8.6 32.1-8.6 49.3C192 383.3 256.7 448 336.6 448H446.8zM30.4 119.9C11.3 144.4 0 175.2 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9 .3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-18.5 6.2-35.5 16.6-49.1L30.4 119.9z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faChainHorizontalSlash = faLinkHorizontalSlash;
var faHollyBerry = {
  prefix: 'fad',
  iconName: 'holly-berry',
  icon: [512, 512, [], "f7aa", ["M280 384c-1.1 0-2.2-.1-3.2-.2c5.1-10.7 6.8-23.2 4-35.9L275.4 324c-1.9-8.3-2-16.9-.5-25.3l6.3-34.8c2.1-11.5 .5-22.6-3.7-32.3c2.8-.3 5.8-.1 8.7 .7l29.6 8.1c18.3 5 37.6 4.4 55.6-1.5l12.8-4.3c15.5-5.2 31.6 6.4 31.6 22.8v32c0 34.6 28.1 62.7 62.7 62.7c16.4 0 27.9 16 22.8 31.6l-4.3 12.8c-6 18-6.5 37.3-1.5 55.6l5.3 19.4c4.9 17.9-11.6 34.4-29.5 29.5L452 495.6c-18.3-5-37.6-4.5-55.6 1.5l-12.8 4.3c-15.5 5.2-31.6-6.4-31.6-22.8V456c0-39.8-32.2-72-72-72zM96 257.3c0-16.4 16-27.9 31.6-22.8l12.8 4.3c18 6 37.3 6.5 55.6 1.5l19.4-5.3c17.9-4.9 34.4 11.6 29.5 29.5L239.6 284c-5 18.3-4.4 37.6 1.5 55.6l4.3 12.8c5.2 15.5-6.4 31.6-22.8 31.6c-34.6 0-62.7 28.1-62.7 62.7v32c0 16.4-16 27.9-31.6 22.8l-12.8-4.3c-18-6-37.3-6.5-55.6-1.5L40.5 501c-17.9 4.9-34.4-11.6-29.5-29.5L16.4 452c5-18.3 4.4-37.6-1.5-55.6l-4.3-12.8C5.4 368 16.9 352 33.3 352C67.9 352 96 323.9 96 289.3v-32z", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]]
};
var faNose = {
  prefix: 'fad',
  iconName: 'nose',
  icon: [448, 512, [], "e5bd", ["M88 0C74.7 0 64 10.7 64 24V254.5c0 6.6 6.6 11.3 13 9.7c6.7-1.7 13.6-2.9 20.7-3.6l44.7-4.5c8.8-.9 16.6 5.5 17.5 14.3s-5.5 16.6-14.3 17.5l-44.7 4.5C44.3 298 1 345.3 0 401.9c1 61 50.8 110.1 112 110.1h12c-7.5-10-12-22.5-12-36c0-33.1 26.9-60 60-60h4.8c19.7 0 38.3 9 50.6 24.3l15.4 19.2c25.8 32.3 64.6 51.4 105.8 52.4c55.2-1.6 99.4-46.8 99.4-102.3c0-28.1-11.4-54.4-30.4-74.1C369.9 286 259.3 163 181.3 12.9C177.2 5 169 0 160 0H88z", "M124 512c-7.5-10-12-22.5-12-36c0-33.1 26.9-60 60-60h4.8c19.7 0 38.3 9 50.6 24.3l15.4 19.2c25.8 32.3 64.6 51.4 105.8 52.4L124 512z"]]
};
var faChevronLeft = {
  prefix: 'fad',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", ["M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z", ""]]
};
var faBacteria = {
  prefix: 'fad',
  iconName: 'bacteria',
  icon: [640, 512, [], "e059", ["M304.9 .7c9.6 2.7 15.1 12.7 12.4 22.3l-4.5 15.6c13.5 7.5 24.9 18.7 32.6 32.6L361 66.7c9.6-2.7 19.5 2.8 22.3 12.4s-2.8 19.5-12.4 22.3l-15.2 4.3c1.3 16.6-2.4 32.7-10.1 46.6l9 9c7 7 7 18.4 0 25.5s-18.4 7-25.5 0l-7.2-7.2c-9 6.7-19.5 11.7-31.1 14.4c-4.2 1-8.1 2-11.9 3.1l2.3 8.1c2.7 9.6-2.8 19.5-12.4 22.3s-19.5-2.8-22.3-12.4l-1.3-4.4c-19.7 10.8-30.5 23.3-36.9 33.3l8.6 3.7c9.1 3.9 13.4 14.5 9.5 23.6s-14.5 13.4-23.6 9.5l-7.1-3c-1.1 16.7-7 32-16.3 44.5l7.2 7.2c7 7 7 18.4 0 25.5s-18.4 7-25.5 0l-9-9c-12.7 7-27.4 10.7-43 10.2c-1.2 0-2.4-.1-3.6-.2l-4.3 15.2c-2.7 9.6-12.7 15.1-22.3 12.4S64 370.6 66.7 361l4.5-15.6c-13.7-7.6-25-19-32.6-32.6l-15.6 4.5C13.4 320 3.4 314.5 .7 304.9s2.8-19.5 12.4-22.3l15.2-4.3c-.2-3-.3-6-.2-9.1l29.1 .9 .1 0c-29.1-1-29.1-1-29.1-1l0-.1 0-.2 0-.5 .1-1.1c0-.8 .1-1.7 .2-2.8c.2-2.1 .4-4.8 .8-7.8c.7-6.1 2-14.1 4.1-23.4c.2-.8 .4-1.5 .5-2.3l-10.4-4.2c-9.2-3.7-13.7-14.2-10-23.4s14.2-13.7 23.4-10l8 3.2c4.2-10.5 9.4-21.6 16-33c1.6-2.8 3.4-5.7 5.1-8.5l-11.1-8.9c-7.8-6.2-9-17.5-2.8-25.3s17.5-9 25.3-2.8l10 8C97.5 113.8 109.4 102 123 91l-6-9c-5.5-8.3-3.3-19.4 5-25s19.4-3.3 25 5l5.5 8.3c13.7-8.4 28.8-16.1 45.4-22.8l-4.4-10.4c-3.9-9.1 .3-19.7 9.5-23.6s19.7 .3 23.6 9.5L232 35.6c6.8-2 13.9-3.8 21.1-5.5c8.5-2 17-2.6 25.2-1.9l4.3-15.2C285.4 3.5 295.4-2 304.9 .7zM112 272c-20.7-.7-36.3-1.2-48-1.6l0 0 48 1.5zm16-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 416a32 32 0 1 1 0-64 32 32 0 1 1 0 64z", "M322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1l.1 0 29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.2 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5l0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faClouds = {
  prefix: 'fad',
  iconName: 'clouds',
  icon: [640, 512, [], "f744", ["M304 160c-74.1 0-135.2 56-143.1 128H96c-53 0-96-43-96-96s43-96 96-96l1.1 0C104.9 41.7 151.6 0 208 0c47.9 0 88.8 30.1 104.8 72.4C324.8 67 338 64 352 64c53 0 96 43 96 96c0 12.1-2.2 23.6-6.3 34.2c-11.4 2.3-22.2 6.4-32.1 11.9C383.3 177.7 345.7 160 304 160z", "M128 416c0 53 43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28c-18.7-35.7-56.1-60-99.2-60c-61.9 0-112 50.1-112 112c0 7.1 .7 14.1 1.9 20.8C155.6 337.4 128 373.5 128 416z"]]
};
var faMoneyBillSimple = {
  prefix: 'fad',
  iconName: 'money-bill-simple',
  icon: [576, 512, [], "e1f1", ["M288 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm224 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]]
};
var faHandLizard = {
  prefix: 'fad',
  iconName: 'hand-lizard',
  icon: [512, 512, [], "f258", ["M0 112C0 85.5 21.5 64 48 64H160h80 46.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v12 16 48c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V402.2L273.9 352H240 160 112c-26.5 0-48-21.5-48-48s21.5-48 48-48h48 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160 48c-26.5 0-48-21.5-48-48z", ""]]
};
var faTablePivot = {
  prefix: 'fad',
  iconName: 'table-pivot',
  icon: [512, 512, [], "e291", ["M0 192V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160V160H448V416H128V192H0z", "M64 32h64V160H0V96C0 60.7 28.7 32 64 32zM414.8 246.1c-2.5 6-8.3 9.9-14.8 9.9H384v48c0 26.5-21.5 48-48 48H288v16c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-32-32c-6.2-6.2-6.2-16.4 0-22.6l32-32c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8v16h48c8.8 0 16-7.2 16-16V256H336c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l32-32c6.2-6.2 16.4-6.2 22.6 0l32 32c4.6 4.6 5.9 11.5 3.5 17.4z"]]
};
var faFilterSlash = {
  prefix: 'fad',
  iconName: 'filter-slash',
  icon: [640, 512, [], "e17d", ["M202.5 255.5L384 398.5V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9l-53.5-65.4zM567 97.3l-160.4 196L81.7 38.8C88.2 34.4 95.9 32 104 32H536c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faTrashCanUndo = {
  prefix: 'fad',
  iconName: 'trash-can-undo',
  icon: [448, 512, ["trash-can-arrow-turn-left", "trash-undo-alt"], "f896", ["M32 96H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V96zm185.8 71.9c-8.9-9.9-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L182.5 280H240c22.1 0 40 17.9 40 40v40c0 13.3 10.7 24 24 24s24-10.7 24-24V320c0-48.6-39.4-88-88-88H182.5l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9z", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zm54.1 167.9c8.9 9.9 8.1 25-1.8 33.9L182.5 232H240c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V320c0-22.1-17.9-40-40-40H182.5l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z"]]
};
var faTrashCanArrowTurnLeft = faTrashCanUndo;
var faTrashUndoAlt = faTrashCanUndo;
var faNotdef = {
  prefix: 'fad',
  iconName: 'notdef',
  icon: [384, 512, [], "e1fe", ["M64 64l0 0v57.7L153.5 256 64 390.3V448h38.5L192 313.7 281.5 448H320V390.3L230.5 256 320 121.7V64H281.5L192 198.3 102.5 64H64z", "M64 64V448H320V64H64zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"]]
};
var faDisease = {
  prefix: 'fad',
  iconName: 'disease',
  icon: [512, 512, [], "f7fa", ["M236.4 61.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6h10c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M304 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM288 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faPersonToDoor = {
  prefix: 'fad',
  iconName: 'person-to-door',
  icon: [576, 512, [58704], "e433", ["M432 0c-26.5 0-48 21.5-48 48V224c17.7 0 32 14.3 32 32s-14.3 32-32 32V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H432z", "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"]]
};
var faTurntable = {
  prefix: 'fad',
  iconName: 'turntable',
  icon: [576, 512, [], "f8e4", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm272 0c8.8 0 16 7.2 16 16V272.4c0 7.5-1.7 14.8-5.1 21.5l-16.2 32.4c6.1 9.2 7.2 21.4 1.9 31.9l-16 32c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32c5.3-10.6 15.7-17 26.7-17.6l16.2-32.5c1.1-2.2 1.7-4.7 1.7-7.2V112c0-8.8 7.2-16 16-16z", "M64 256a160 160 0 1 1 320 0A160 160 0 1 1 64 256zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM496 96c8.8 0 16 7.2 16 16V272.4c0 7.5-1.7 14.8-5.1 21.5l-16.2 32.4c6.1 9.2 7.2 21.4 1.9 31.9l-16 32c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32c5.3-10.6 15.7-17 26.7-17.6l16.2-32.5c1.1-2.2 1.7-4.7 1.7-7.2V112c0-8.8 7.2-16 16-16z"]]
};
var faBriefcaseMedical = {
  prefix: 'fad',
  iconName: 'briefcase-medical',
  icon: [512, 512, [], "f469", ["M184 48c-4.4 0-8 3.6-8 8V96H128V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96H336V56c0-4.4-3.6-8-8-8H184z", "M64 96C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"]]
};
var faGenderless = {
  prefix: 'fad',
  iconName: 'genderless',
  icon: [384, 512, [], "f22d", ["M112 256a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"]]
};
var faChevronRight = {
  prefix: 'fad',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", ["M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z", ""]]
};
var faSignalWeak = {
  prefix: 'fad',
  iconName: 'signal-weak',
  icon: [640, 512, ["signal-1"], "f68c", ["M608 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM480 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V128zM320 192c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32zM224 320c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320z", "M64 384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"]]
};
var faSignal1 = faSignalWeak;
var faClockFive = {
  prefix: 'fad',
  iconName: 'clock-five',
  icon: [512, 512, [], "e349", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V248.7l60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3V120c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M256 96c13.3 0 24 10.7 24 24V248.7l60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3V120c0-13.3 10.7-24 24-24z"]]
};
var faRetweet = {
  prefix: 'fad',
  iconName: 'retweet',
  icon: [576, 512, [], "f079", ["M272 128c0-17.7 14.3-32 32-32l112 0c53 0 96 43 96 96l0 128 32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l32 0 0-128c0-17.7-14.3-32-32-32l-112 0c-17.7 0-32-14.3-32-32z", "M304 384c0 17.7-14.3 32-32 32l-112 0c-53 0-96-43-96-96l0-128-32 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-32 0 0 128c0 17.7 14.3 32 32 32l112 0c17.7 0 32 14.3 32 32z"]]
};
var faCarRear = {
  prefix: 'fad',
  iconName: 'car-rear',
  icon: [512, 512, ["car-alt"], "f5de", ["M135.2 117.4c4.5-12.8 16.6-21.4 30.2-21.4H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6zM32 448V391.4c9.4 5.4 20.3 8.6 32 8.6h64v48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zm352 0V400h64c11.7 0 22.6-3.1 32-8.6V448c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32z", "M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faCarAlt = faCarRear;
var faPumpSoap = {
  prefix: 'fad',
  iconName: 'pump-soap',
  icon: [448, 512, [], "e06b", ["M117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z", "M128 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h60.1c21.2 0 41.6 8.4 56.6 23.4l33.9 33.9c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-33.9-33.9c-3-3-7.1-4.7-11.3-4.7H256v64H128V32zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"]]
};
var faComputerClassic = {
  prefix: 'fad',
  iconName: 'computer-classic',
  icon: [448, 512, [], "f8b1", ["M0 48C0 21.5 21.5 0 48 0H400c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48zM32 480V448H416v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM96 64C78.3 64 64 78.3 64 96V224c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96zM80 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm144-24c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z", "M64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96z"]]
};
var faFrame = {
  prefix: 'fad',
  iconName: 'frame',
  icon: [448, 512, [], "e495", ["M64 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 288H64L64 64zm0 384V416h64l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32zm320 0c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-288 64 0 0 288zm0-384V96l-64 0V64c0-17.7 14.3-32 32-32s32 14.3 32 32z", "M416 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0V96H416zM32 96H64v64l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 320c-17.7 0-32-14.3-32-32s14.3-32 32-32l288 0v64L32 416zm384 0H384V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32z"]]
};
var faVideoSlash = {
  prefix: 'fad',
  iconName: 'video-slash',
  icon: [640, 512, [], "f4e2", ["M32.3 121.5L407 416.7c-11.2 18.7-31.6 31.3-55 31.3H96c-35.3 0-64-28.7-64-64V128c0-2.2 .1-4.4 .3-6.5zM448 325.8V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6s16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-13.8-9.2L448 325.8zM113.9 64H352c35.3 0 64 28.7 64 64V300.8L113.9 64z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faBatteryQuarter = {
  prefix: 'fad',
  iconName: 'battery-quarter',
  icon: [576, 512, ["battery-2"], "f243", ["M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z", "M96 192h96V320H96z"]]
};
var faBattery2 = faBatteryQuarter;
var faEllipsisStroke = {
  prefix: 'fad',
  iconName: 'ellipsis-stroke',
  icon: [512, 512, ["ellipsis-h-alt"], "f39b", ["M256 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-96a72 72 0 1 0 0 144 72 72 0 1 0 0-144z", "M392 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm96 0a72 72 0 1 1 -144 0 72 72 0 1 1 144 0zM72 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm96 0A72 72 0 1 1 24 256a72 72 0 1 1 144 0z"]]
};
var faEllipsisHAlt = faEllipsisStroke;
var faRadio = {
  prefix: 'fad',
  iconName: 'radio',
  icon: [512, 512, [128251], "f8d7", ["M0 192c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zM448 320a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 304c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z", "M511 17.2c3.7 12.7-3.6 26.1-16.3 29.8L218.5 128H64c-13.9 0-26.9 4.5-37.4 12c7.3-5.9 15.7-10.4 25.1-13.2L481.3 1C494-2.8 507.3 4.5 511 17.2zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]]
};
var faBabyCarriage = {
  prefix: 'fad',
  iconName: 'baby-carriage',
  icon: [512, 512, ["carriage-baby"], "f77d", ["M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z", "M448 96c-35.3 0-64 28.7-64 64v64H224L0 224c0 25.2 5.8 50.2 17.1 73.5s27.8 44.5 48.6 62.3s45.5 32 72.7 41.6S194.6 416 224 416s58.5-5 85.7-14.6s51.9-23.8 72.7-41.6s37.3-39 48.6-62.3s17-48.3 17-73.5V160h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448z"]]
};
var faCarriageBaby = faBabyCarriage;
var faFaceExpressionless = {
  prefix: 'fad',
  iconName: 'face-expressionless',
  icon: [512, 512, [], "e373", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zM128 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm176-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M144 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"]]
};
var faDownToDottedLine = {
  prefix: 'fad',
  iconName: 'down-to-dotted-line',
  icon: [448, 512, [], "e408", ["M0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm96 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M251.3 372.7L374.1 249.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9L288 192l0-128c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 128-62.1 0C79.2 192 64 207.2 64 225.9c0 9 3.6 17.6 9.9 24L196.7 372.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3z"]]
};
var faCloudMusic = {
  prefix: 'fad',
  iconName: 'cloud-music',
  icon: [640, 512, [], "f8ae", ["M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM416 207.1c0-22.3-22.3-37.8-43.2-30l-96 36c-12.5 4.7-20.8 16.6-20.8 30v87.2c-5-1.5-10.4-2.3-16-2.3c-26.5 0-48 17.9-48 40s21.5 40 48 40s48-17.9 48-40v0V275.1l96-36v59.2c-5-1.5-10.4-2.3-16-2.3c-26.5 0-48 17.9-48 40s21.5 40 48 40s48-17.9 48-40v0V207.1z", "M372.8 177.1c20.9-7.8 43.2 7.6 43.2 30V336v0c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c5.6 0 11 .8 16 2.3V239.1l-96 36V368v0c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c5.6 0 11 .8 16 2.3V243.1c0-13.3 8.3-25.3 20.8-30l96-36z"]]
};
var faTrafficLight = {
  prefix: 'fad',
  iconName: 'traffic-light',
  icon: [320, 512, [128678], "f637", ["M160 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 32a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0 128a48 48 0 1 0 0 96 48 48 0 1 0 0-96z", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]]
};
var faCloudMinus = {
  prefix: 'fad',
  iconName: 'cloud-minus',
  icon: [640, 512, [], "e35d", ["M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM248 264c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z", "M224 288c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24z"]]
};
var faThermometer = {
  prefix: 'fad',
  iconName: 'thermometer',
  icon: [512, 512, [], "f491", ["M96 382.1V293.3c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4H129.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z", "M139.7 226.3l57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57-22.6 22.6zm64-64l57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57-22.6 22.6zm64-64l57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57L267.7 98.3z"]]
};
var faShieldMinus = {
  prefix: 'fad',
  iconName: 'shield-minus',
  icon: [512, 512, [], "e249", ["M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M160 256c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24z"]]
};
var faVrCardboard = {
  prefix: 'fad',
  iconName: 'vr-cardboard',
  icon: [640, 512, [], "f729", ["M576 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H184.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M160 304a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm320 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faCarTilt = {
  prefix: 'fad',
  iconName: 'car-tilt',
  icon: [640, 512, [], "f5e5", ["M0 496c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48v16H0V496z", "M145.1 120.6L292.4 81.2c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6L114.6 211.6l7-63.6c1.4-13.1 10.8-24 23.5-27.4zM58 141.1L47.8 234.2C27.4 249.4 17.2 276 24.2 302.1L57.3 425.8l6 22.2 99.4 0c-.1-.2-.1-.5-.2-.7L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5 487.8 177.9c-7-26.1-29.1-44.1-54.4-47L378.1 55.3c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1zm58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1 -16.6-61.8zm255.6-35.3a32 32 0 1 1 61.8-16.6 32 32 0 1 1 -61.8 16.6z"]]
};
var faGaugeCircleMinus = {
  prefix: 'fad',
  iconName: 'gauge-circle-minus',
  icon: [640, 512, [], "e497", ["M504 192.2c-2.6-.1-5.3-.2-8-.2c-97.2 0-176 78.8-176 176c0 45.9 17.6 87.7 46.4 119C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2zM256 416c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM368 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]]
};
var faBrightnessLow = {
  prefix: 'fad',
  iconName: 'brightness-low',
  icon: [512, 512, [], "e0ca", ["M256 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM432 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM48 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM160 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z", "M160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]]
};
var faHandMiddleFinger = {
  prefix: 'fad',
  iconName: 'hand-middle-finger',
  icon: [448, 512, [128405], "f806", ["M232 0c-22.1 0-40 17.9-40 40V204.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z", ""]]
};
var faPercent = {
  prefix: 'fad',
  iconName: 'percent',
  icon: [384, 512, [62101, 62785, "percentage"], "25", ["M374.6 73.4c12.5 12.5 12.5 32.8 0 45.3l-320 320c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l320-320c12.5-12.5 32.8-12.5 45.3 0z", "M64 192A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faPercentage = faPercent;
var faTruckMoving = {
  prefix: 'fad',
  iconName: 'truck-moving',
  icon: [640, 512, [], "f4df", ["M96 352a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm160 0a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm288 0a64 64 0 1 0 0 128 64 64 0 1 0 0-128z", "M64 32C28.7 32 0 60.7 0 96V384H5.5c13.2-37.3 48.7-64 90.5-64c33.4 0 62.8 17 80 42.9C193.2 337 222.6 320 256 320c41.8 0 77.4 26.7 90.5 64H416h37.5c13.2-37.3 48.7-64 90.5-64c38.2 0 71.2 22.3 86.6 54.6c5.8-5.8 9.4-13.8 9.4-22.6V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256z"]]
};
var faGlassWaterDroplet = {
  prefix: 'fad',
  iconName: 'glass-water-droplet',
  icon: [384, 512, [], "e4f5", ["M8.6 10.2C14.6 3.7 23.1 0 32 0H352c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1L355.1 437.7c-3 41.9-37.8 74.3-79.8 74.3H108.7c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64L92.7 433.1c.6 8.4 7.6 14.9 16 14.9H275.3c8.4 0 15.4-6.5 16-14.9L317.6 64H66.4z", "M301 297.5L288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5 9.7 135.6c.6 8.4 7.6 14.9 16 14.9H275.3c8.4 0 15.4-6.5 16-14.9L301 297.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"]]
};
var faConveyorBelt = {
  prefix: 'fad',
  iconName: 'conveyor-belt',
  icon: [640, 512, [], "f46e", ["M256 0h16 96 16V16v96c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L320 99.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V16 0zM0 416c0-53 43-96 96-96H544c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M256 0H176c-26.5 0-48 21.5-48 48V208c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H384V112c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L320 99.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V0z"]]
};
var faLocationCheck = {
  prefix: 'fad',
  iconName: 'location-check',
  icon: [384, 512, ["map-marker-check"], "f606", ["M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM305 145L177 273c-9.4 9.4-24.6 9.4-33.9 0L79 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 111c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M305 111c9.4 9.4 9.4 24.6 0 33.9L177 273c-9.4 9.4-24.6 9.4-33.9 0L79 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 111c9.4-9.4 24.6-9.4 33.9 0z"]]
};
var faMapMarkerCheck = faLocationCheck;
var faCoinVertical = {
  prefix: 'fad',
  iconName: 'coin-vertical',
  icon: [384, 512, [], "e3fd", ["M144 512c79.5 0 144-114.6 144-256S223.5 0 144 0S0 114.6 0 256S64.5 512 144 512zm-8-64c-20.5 0-36.7-10.5-48.2-22.6C76.5 413.4 67.7 397.7 61 381c-13.4-33.6-21-77.8-21-125s7.6-91.4 21-125c6.7-16.7 15.4-32.4 26.8-44.4C99.3 74.5 115.5 64 136 64s36.7 10.5 48.2 22.6c11.4 12 20.1 27.7 26.8 44.4c13.4 33.6 21 77.8 21 125s-7.6 91.4-21 125c-6.7 16.7-15.4 32.4-26.8 44.4C172.7 437.5 156.5 448 136 448zm64-192c0-88.4-28.7-160-64-160s-64 71.6-64 160s28.7 160 64 160s64-71.6 64-160z", "M330.6 48C309.6 17.8 283.8 0 256 0H226.1c15.6 13.2 29.3 29.7 40.9 48h63.7zM313.3 176h64.3c-6-36.2-15.9-68.9-28.7-96H284.3c13.2 28.4 23 60.9 29 96zm68.4 128c1.5-15.5 2.2-31.6 2.2-48s-.8-32.5-2.2-48H317.6c1.6 15.7 2.4 31.7 2.4 48s-.8 32.3-2.4 48h64.1zM284.3 432H349c12.8-27.1 22.7-59.8 28.7-96H313.3c-6 35.1-15.9 67.6-29 96zM267 464c-11.5 18.3-25.2 34.8-40.9 48H256c27.9 0 53.6-17.8 74.6-48H267zM136 448c20.5 0 36.7-10.5 48.2-22.6c11.4-12 20.1-27.7 26.8-44.4c13.4-33.6 21-77.8 21-125s-7.6-91.4-21-125c-6.7-16.7-15.4-32.4-26.8-44.4C172.7 74.5 156.5 64 136 64s-36.7 10.5-48.2 22.6C76.5 98.6 67.7 114.3 61 131c-13.4 33.6-21 77.8-21 125s7.6 91.4 21 125c6.7 16.7 15.4 32.4 26.8 44.4C99.3 437.5 115.5 448 136 448zm64-192c0 88.4-28.7 160-64 160s-64-71.6-64-160s28.7-160 64-160s64 71.6 64 160z"]]
};
var faDisplay = {
  prefix: 'fad',
  iconName: 'display',
  icon: [576, 512, [], "e163", ["M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z", "M512 64H64V352H512V64zM416 448H346.7L336 416H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32z"]]
};
var faPersonSign = {
  prefix: 'fad',
  iconName: 'person-sign',
  icon: [512, 512, [], "f757", ["M438.1 32.2c4.5-12.5-1.9-26.2-14.3-30.8S397.5 3.3 393 15.8l-4.6 12.7L328.7 6.7c-12.5-4.5-26.2 1.9-30.8 14.3L259.6 126.3c-4.5 12.5 1.9 26.2 14.3 30.8l59.7 21.7L289 301.5c-4.5 12.5 1.9 26.2 14.3 30.8s26.2-1.9 30.8-14.3l44.6-122.6 60.6 22c12.5 4.5 26.2-1.9 30.8-14.3L508.4 97.7c4.5-12.5-1.9-26.2-14.3-30.8l-60.6-22 4.6-12.7z", "M318.3 221.2l-28.8-10.8c-9.7-3.7-18.4-9.6-25.4-17.4L235 160.2c-18.2-20.5-44.3-32.2-71.8-32.2H135.6c-36.4 0-69.6 20.5-85.9 53.1L3.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L80 263.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h20.2L192 407.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V407.6c0-9.9-2.3-19.7-6.8-28.6L216 312.4V235.2l.3 .3c13.8 15.6 31.2 27.5 50.7 34.8l29.3 11 21.9-60.1zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
};
var faFaceSmile = {
  prefix: 'fad',
  iconName: 'face-smile',
  icon: [512, 512, [128578, "smile"], "f118", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faSmile = faFaceSmile;
var faPhoneHangup = {
  prefix: 'fad',
  iconName: 'phone-hangup',
  icon: [640, 512, [], "e225", ["M224 225.6c-64.2 8-128.3 25.8-203.8 59.8l13 29.2c71.2-32.1 131.2-49 190.8-56.8V225.6zM416 240s0 0 0 0v17.9c59.6 7.9 119.7 24.8 190.8 56.8l13-29.2c-75.5-34-139.6-51.8-203.8-59.8V240z", "M20.2 285.5l-8.5-19.2c-7.2-16.2-5.1-35.1 7.4-47.7C69.2 168.1 175.8 96 320 96s250.8 72.1 300.9 122.6c12.5 12.6 14.6 31.5 7.4 47.7l-8.5 19.2C507.2 234.7 420 220.1 320 220.1s-187.2 14.7-299.8 65.4zm13 29.2c71.2-32.1 131.2-49 190.8-56.8v67.9c0 15.3-10.8 28.4-25.7 31.4L89.1 379c-14.7 2.9-29.4-4.7-35.5-18.4L33.2 314.7zM416 257.9c59.6 7.9 119.7 24.8 190.8 56.8l-20.4 45.9c-6.1 13.7-20.8 21.3-35.5 18.4L441.7 357.1c-15-3-25.7-16.1-25.7-31.4V257.9z"]]
};
var faSignatureSlash = {
  prefix: 'fad',
  iconName: 'signature-slash',
  icon: [640, 512, [], "e3cb", ["M345.2 368H305.9c-6.7 16.3-14.2 32.3-22.3 48H406.2l-60.9-48zM181.1 238.7l-16.7 5c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c17.5-30.5 31.9-62.7 43.1-95.9L181.1 238.7zm217.1 1.7l-12.3 36.8L440.6 320H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96c-37 0-69.1 20.9-85.1 51.6l53.2 41.7C193.5 108.9 207.2 96 224 96c17.7 0 32 14.3 32 32v7.8c0 12.8-.5 25.6-1.5 38.3l100.9 79.1 42.8-12.8zM501.8 368L563 416h53c13.3 0 24-10.7 24-24s-10.7-24-24-24H501.8zm-270-77.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7l49-14.7zM64 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faThumbtack = {
  prefix: 'fad',
  iconName: 'thumbtack',
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", ["M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H224V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32z", "M192 224c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32z"]]
};
var faThumbTack = faThumbtack;
var faWheatSlash = {
  prefix: 'fad',
  iconName: 'wheat-slash',
  icon: [640, 512, [], "e339", ["M362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L550.5 231c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9L369.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L335.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4l137.8 108zm-68.7 68.7l-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM536 0c-48.6 0-88 39.4-88 88v24c0 8.8 7.2 16 16 16h24c48.6 0 88-39.4 88-88V16c0-8.8-7.2-16-16-16H536z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faTrophy = {
  prefix: 'fad',
  iconName: 'trophy',
  icon: [576, 512, [127942], "f091", ["M441.8 112c1.8-15.1 3.3-31.1 4.3-48H552c13.3 0 24 10.7 24 24c0 134.5-70.4 207.7-140.5 246.1c-34.5 18.9-68.8 29.3-94.3 35c-12.2 2.7-22.5 4.4-30 5.4c18.1-9.9 44.1-29.5 68.6-67.3c10.6-4.2 21.6-9.2 32.6-15.2c53.7-29.4 107.1-82 114.6-179.9H441.8zM196.1 307.2c24.5 37.8 50.6 57.4 68.6 67.3c-7.5-1-17.8-2.7-30-5.4c-25.5-5.7-59.8-16.1-94.3-35C70.4 295.7 0 222.5 0 88C0 74.7 10.7 64 24 64H129.9c1 16.9 2.5 32.9 4.3 48H48.9c7.5 97.9 60.9 150.6 114.6 179.9c11 6 22 11 32.6 15.2z", "M256 395.5c0-16.3-8.6-31.2-20.8-42C192.2 315.3 137.3 231 129 48c-1.2-26.5 20.4-48 47-48H400c26.5 0 48.1 21.6 47 48c-8.2 183-63.2 267.2-106.2 305.4c-12.2 10.8-20.8 25.7-20.8 42V400c0 26.5 21.5 48 48 48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h16c26.5 0 48-21.5 48-48v-4.5z"]]
};
var faCloudsSun = {
  prefix: 'fad',
  iconName: 'clouds-sun',
  icon: [640, 512, [], "f746", ["M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 30.7 5.1c-26.4 10.6-47 32.6-55.7 59.9C276.8 132.7 244.8 112 208 112c-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17.1c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z", "M495.9 224c-12.9 0-25.3 2.2-36.8 6.2C435.9 206.6 403.7 192 368 192c-16.7 0-32.6 3.2-47.3 9c-.4-2.9-.6-5.9-.6-8.9c0-35.3 28.6-64 64-64c7.4 0 14.6 1.3 21.2 3.6c11.5-30.1 40.6-51.6 74.8-51.6c38.9 0 71.3 27.8 78.5 64.6c3.1-.4 6.3-.6 9.5-.6c39.8 0 72 32.2 72 72c0 30.4-18.8 56.3-45.4 66.9c-18.9-35.1-56-59-98.7-59zm144 207.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"]]
};
var faPersonPraying = {
  prefix: 'fad',
  iconName: 'person-praying',
  icon: [640, 512, [128720, "pray"], "f683", ["M320 64a64 64 0 1 1 128 0A64 64 0 1 1 320 64z", "M283.7 354l116.1 85.8c13.9 10.3 19.6 28.3 14.2 44.7s-20.7 27.5-38 27.5H168c-22.1 0-40-17.9-40-40s17.9-40 40-40h86.6l-53.2-39.3c-34.9-25.8-45.8-73.3-25.6-111.8l48.7-92.5C238.9 161.1 267.2 144 298 144c26.6 0 51.6 12.7 67.2 34.2l26.2 36L446.7 169c17.1-14 42.3-11.5 56.3 5.6s11.5 42.3-5.6 56.3l-88 72c-8.5 7-19.5 10.1-30.4 8.7s-20.8-7.2-27.2-16.1L328.7 264l-45 90z"]]
};
var faPray = faPersonPraying;
var faHammer = {
  prefix: 'fad',
  iconName: 'hammer',
  icon: [576, 512, [128296], "f6e3", ["M285.5 162.1L27.4 377.1C10.1 391.6 0 413.1 0 435.7C0 477.8 34.1 512 76.3 512c22.6 0 44.1-10.1 58.6-27.4L350.7 225.6c-6.1-3.7-11.9-8.2-17.2-13.5l-38.1-38.1c-3.7-3.7-6.9-7.7-9.8-11.9z", "M333.5 212.1c21.8 21.8 51.9 30.2 80 25.4L431 255l-8 8c-9.4 9.4-9.4 24.6 0 33.9l24 24c9.4 9.4 24.6 9.4 33.9 0l88-88c9.4-9.4 9.4-24.6 0-33.9l-24-24c-9.4-9.4-24.6-9.4-33.9 0l-8 8-15.9-15.9c6.6-30.3-2.4-63.2-26.6-86l-44.6-42C389.2 14 353.9 0 317.2 0H299.2C279 0 259.1 4.2 240.7 12.4l-47.2 21c-5.6 2.5-9.2 7.9-9.5 14s3 11.8 8.3 14.7L272 105.5v12.1c0 21.1 8.4 41.4 23.3 56.3l38.1 38.1z"]]
};
var faFaceVomit = {
  prefix: 'fad',
  iconName: 'face-vomit',
  icon: [576, 512, [], "e3a0", ["M465.5 440.5C513.9 393.9 544 328.5 544 256C544 114.6 429.4 0 288 0S32 114.6 32 256c0 72.5 30.1 137.9 78.5 184.5l16.7-5.6c11.9-4 21.5-12.3 27.2-22.9c-16.7-12.6-26.4-27.7-26.4-44c0-44.2 71.6-80 160-80s160 35.8 160 80c0 16.3-9.7 31.4-26.4 44c5.7 10.6 15.2 19 27.2 22.9l16.7 5.6zm-300-309.8l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM428 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z", "M192 396.1V338.7c23.6-11.1 57.3-18.7 96-18.7s72.4 7.6 96 18.7v57.4c0 31 19.8 58.5 49.2 68.3l34.1 11.4c7.6 2.5 12.7 9.6 12.7 17.6c0 10.3-8.3 18.6-18.6 18.6H114.6c-10.3 0-18.6-8.3-18.6-18.6c0-8 5.1-15.1 12.7-17.6l34.1-11.4c29.4-9.8 49.2-37.3 49.2-68.3zM304 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm256 16a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 480a32 32 0 1 1 64 0A32 32 0 1 1 0 480z"]]
};
var faSpeakers = {
  prefix: 'fad',
  iconName: 'speakers',
  icon: [640, 512, [], "f8e0", ["M256 64c0-24.6 9.2-47 24.4-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H280.4c-15.2-17-24.4-39.4-24.4-64V414.4c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6V64zM128 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM352 0c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352zM464 224a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM416 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z", "M176 224c31.3 0 59.7 12.9 80 33.6V414.4c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112zm0-160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm64 272a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM416 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM352 336a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm112 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faTtyAnswer = {
  prefix: 'fad',
  iconName: 'tty-answer',
  icon: [640, 512, ["teletype-answer"], "e2b9", ["M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z", "M304 0c-8.8 0-16 7.2-16 16V48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H304zm0 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H304zm32-80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zM400 0c-8.8 0-16 7.2-16 16V48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H400zm32 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H448c-8.8 0-16 7.2-16 16zM496 0c-8.8 0-16 7.2-16 16V48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H496zm32 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H544c-8.8 0-16 7.2-16 16zM592 0c-8.8 0-16 7.2-16 16V48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H592zM576 208v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H592c-8.8 0-16 7.2-16 16zM400 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H528c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H400z"]]
};
var faTeletypeAnswer = faTtyAnswer;
var faMugTeaSaucer = {
  prefix: 'fad',
  iconName: 'mug-tea-saucer',
  icon: [640, 512, [], "e1f5", ["M208 32V82.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6V224c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V157.3c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6V32H208zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z", "M208 32V82.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6V224c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V157.3c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6V32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64c0-17.7 14.3-32 32-32h80zM480 224h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H480V224z"]]
};
var faDiagramLeanCanvas = {
  prefix: 'fad',
  iconName: 'diagram-lean-canvas',
  icon: [640, 512, [], "e156", ["M128 96H64V304h64V96zm448 0H512V304h64V96z", "M512 96V304h64V96H512zm-48 0H400v80h64V96zM352 96H288V304h64V96zM240 96H176v80h64V96zM128 96H64V304h64V96zM64 352v64H296V352H64zm280 64H576V352H344v64zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM240 304V224H176v80h64zm224-80H400v80h64V224z"]]
};
var faAlt = {
  prefix: 'fad',
  iconName: 'alt',
  icon: [640, 512, [], "e08a", ["M416 416c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-17.7 0-32-14.3-32-32z", "M423 76c6.1-7.6 15.3-12 25-12H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H463.4L217 436c-6.1 7.6-15.3 12-25 12H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H176.6L423 76z"]]
};
var faDial = {
  prefix: 'fad',
  iconName: 'dial',
  icon: [576, 512, ["dial-med-high"], "e15b", ["M256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M383.2 158.5c-62.6-46.2-151.3-41-208 15.7c-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c56.7-56.7 61.9-145.4 15.7-208L305.2 304.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L383.2 158.5z"]]
};
var faDialMedHigh = faDial;
var faHandPeace = {
  prefix: 'fad',
  iconName: 'hand-peace',
  icon: [512, 512, [9996], "f25b", ["M224 0c17.7 0 32 14.3 32 32V240H192V32c0-17.7 14.3-32 32-32zM93.3 51.2L175.9 240H106.1L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5h69.9H216c22.1 0 40 17.9 40 40s-17.9 40-40 40H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H226.3c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363V336c0-32.7 24.6-59.7 56.3-63.5z", "M320 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32zm96 32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32z"]]
};
var faCircleTrash = {
  prefix: 'fad',
  iconName: 'circle-trash',
  icon: [512, 512, ["trash-circle"], "e126", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128h41.4l11.3-11.3c3-3 7.1-4.7 11.3-4.7h64c4.2 0 8.3 1.7 11.3 4.7L310.6 128H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H352L338.4 354.7c-1.4 16.6-15.2 29.3-31.9 29.3H205.4c-16.6 0-30.5-12.8-31.9-29.3L160 192z", "M212.7 116.7L201.4 128H160c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H310.6l-11.3-11.3c-3-3-7.1-4.7-11.3-4.7H224c-4.2 0-8.3 1.7-11.3 4.7zM160 192l13.6 162.7c1.4 16.6 15.2 29.3 31.9 29.3H306.6c16.6 0 30.5-12.8 31.9-29.3L352 192H160z"]]
};
var faTrashCircle = faCircleTrash;
var faRotate = {
  prefix: 'fad',
  iconName: 'rotate',
  icon: [512, 512, [128260, "sync-alt"], "f2f1", ["M16 319.6l0-7.6c0-13.3 10.7-24 24-24h7.6c.2 0 .5 0 .7 0H168c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-41.1 41.1c62.6 61.5 163.1 61.2 225.3-1c17.5-17.5 30.1-38 37.8-59.8c5.9-16.7 24.2-25.4 40.8-19.5s25.4 24.2 19.5 40.8c-10.8 30.6-28.4 59.3-52.9 83.8c-87.2 87.2-228.3 87.5-315.8 1L57 457c-6.9 6.9-17.2 8.9-26.2 5.2S16 449.7 16 440l0-119.6c0-.2 0-.5 0-.7z", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5z"]]
};
var faSyncAlt = faRotate;
var faCircleQuarters = {
  prefix: 'fad',
  iconName: 'circle-quarters',
  icon: [512, 512, [], "e3f8", ["M256 256L120.2 391.8C155 426.5 203 448 256 448s101-21.5 135.8-56.2L256 256zM391.8 120.2C357 85.5 309 64 256 64s-101 21.5-135.8 56.2L256 256 391.8 120.2z", "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]]
};
var faSpinner = {
  prefix: 'fad',
  iconName: 'spinner',
  icon: [512, 512, [], "f110", ["M369.1 75A48 48 0 1 1 437 142.9 48 48 0 1 1 369.1 75zM416 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM208 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM75 369.1A48 48 0 1 1 142.9 437 48 48 0 1 1 75 369.1zm294.2 0A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 256A48 48 0 1 0 0 256a48 48 0 1 0 96 0zM75 142.9A48 48 0 1 0 142.9 75 48 48 0 1 0 75 142.9z"]]
};
var faTowerControl = {
  prefix: 'fad',
  iconName: 'tower-control',
  icon: [448, 512, [], "e2a2", ["M74.4 192H128V320H111c-.1-.3-.1-.5-.2-.8L74.4 192zM176 192h96V320H176V192zm144 0h53.6L337.2 319.2c-.1 .3-.1 .5-.2 .8H320V192zM4.1 179L44.5 320.2C28.5 321.9 16 335.5 16 352c0 17.7 14.3 32 32 32l352 0c17.7 0 32-14.3 32-32c0-16.5-12.5-30.1-28.5-31.8L443.9 179c7.3-25.6-11.9-51-38.5-51H42.6C16 128-3.2 153.4 4.1 179z", "M160 24c0-13.3 10.7-24 24-24h40 40c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V96h40c17.7 0 32 14.3 32 32H288 248 200 160 128c0-17.7 14.3-32 32-32h40V48H184c-13.3 0-24-10.7-24-24zM368 384v96c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V384H368z"]]
};
var faArrowUpTriangleSquare = {
  prefix: 'fad',
  iconName: 'arrow-up-triangle-square',
  icon: [576, 512, ["sort-shapes-up"], "f88a", ["M416 32c11 0 21.3 5.7 27.1 15l80 128c6.2 9.9 6.5 22.3 .9 32.5s-16.4 16.5-28 16.5H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6 .9-32.5l80-128c5.8-9.4 16.1-15 27.1-15zM368 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48z", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z"]]
};
var faSortShapesUp = faArrowUpTriangleSquare;
var faWhale = {
  prefix: 'fad',
  iconName: 'whale',
  icon: [640, 512, [128011], "f72c", ["M175.8 13.4c-1-5.9-5.2-10.8-10.9-12.6s-12-.3-16.2 3.9L108 45.4C89.7 63.7 81.4 89.6 85.6 115.1l7.9 47.4L43.6 212.4C15.7 240.3 0 278.2 0 317.6C0 407.3 72.7 480 162.4 480H544c53 0 96-43 96-96V272.1C640 192.5 575.5 128 495.9 128c-82.5 0-162.4 29.5-225 83.2L156.4 309.4c-8 6.8-18.1 10.6-28.6 10.6h-1.1c-18.3 0-34.5-11.7-40.3-29c-4-12-2.4-25.2 4.3-35.9l37.6-60.1 44.7 7.5c25.5 4.2 51.5-4.1 69.7-22.3l40.7-40.7c4.2-4.2 5.8-10.5 3.9-16.2s-6.7-9.9-12.6-10.9L189.9 98.1 175.8 13.4zM400 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M376 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
};
var faRobot = {
  prefix: 'fad',
  iconName: 'robot',
  icon: [640, 512, [129302], "f544", ["M320 0c-17.7 0-32 14.3-32 32V96h64V32c0-17.7-14.3-32-32-32zM192 400c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm96 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm96 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400c-8.8 0-16 7.2-16 16zM80 224c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H96V224H80zm480 0H544V416h16c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48z", "M168 96c-39.8 0-72 32.2-72 72V440c0 39.8 32.2 72 72 72H472c39.8 0 72-32.2 72-72V168c0-39.8-32.2-72-72-72H168zm40 288h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16zM184 256a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm232-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]]
};
var faPeace = {
  prefix: 'fad',
  iconName: 'peace',
  icon: [512, 512, [9774], "f67c", ["M288 445.3c-10.4 1.7-21.1 2.7-32 2.7s-21.6-.9-32-2.7V323.5l-94.3 77.1c-16.1-14.1-29.9-30.8-40.6-49.5L224 240.8V66.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7V240.8L422.8 351.1c-10.7 18.7-24.4 35.4-40.6 49.5L288 323.5V445.3z", "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]]
};
var faPartyHorn = {
  prefix: 'fad',
  iconName: 'party-horn',
  icon: [512, 512, [], "e31b", ["M32 32a32 32 0 1 1 64 0A32 32 0 1 1 32 32zM448 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM167 153c-9.4-9.4-9.4-24.6 0-33.9l8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4C209.6 8.2 221.5-1.3 234.7 .1s22.7 13.3 21.2 26.5l-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153c-9.4 9.4-24.6 9.4-33.9 0zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3c13.2-1.5 25 8 26.5 21.2s-8 25-21.2 26.5l-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM506.3 8.5c8.6 10.1 7.3 25.3-2.8 33.8l-10 8.5c-14.8 12.5-33.7 19.1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2c-7.6-.2-15 2.4-20.7 7.3l-10 8.5c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l10-8.5c14.8-12.5 33.7-19.1 53-18.6c16.6 .4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2c7.6 .2 15-2.4 20.7-7.3l10-8.5c10.1-8.6 25.3-7.3 33.8 2.8zM83.1 252.5L259.5 428.9l-32.9 12.3L70.8 285.4l12.3-32.9zM48.2 345.6L166.4 463.8l-32.9 12.3L35.9 378.5l12.3-32.9z", "M121.2 192.7c10.6-2.3 21.7 1 29.4 8.6l160 160c7.7 7.7 11 18.8 8.6 29.4s-9.9 19.4-20 23.2l-39.7 14.9L83.1 252.5 98 212.8c3.8-10.2 12.6-17.7 23.2-20zM70.8 285.4L226.6 441.2l-60.2 22.6L48.2 345.6l22.6-60.2zm62.7 190.7L43.2 510c-11.7 4.4-25 1.5-33.9-7.3S-2.4 480.5 2 468.8l33.8-90.3 97.6 97.6z"]]
};
var faGears = {
  prefix: 'fad',
  iconName: 'gears',
  icon: [640, 512, ["cogs"], "f085", ["M529.7 506.7c-8.7 3.7-18.6 .9-25-6.2l-19.8-22.2c-6.8 1.1-13.8 1.7-20.9 1.7s-14.1-.6-20.9-1.7l-19.8 22.2c-6.3 7.1-16.2 9.9-25 6.2c-5.3-2.3-10.5-4.8-15.5-7.6l-5.4-3.1c-5-3-9.9-6.3-14.6-9.8c-7.6-5.7-10.1-15.7-7.1-24.7l9.3-28.2c-8.8-10.7-16-23-20.9-36.2L315.1 391c-9.3-1.9-16.7-9.1-17.8-18.5c-.8-6.7-1.2-13.5-1.2-20.4s.4-13.7 1.2-20.4c1.1-9.4 8.6-16.6 17.8-18.5l29.1-6.1c5-13.3 12.1-25.5 20.9-36.2l-9.3-28.2c-3-9-.5-19 7.1-24.7c4.7-3.5 9.6-6.8 14.6-9.9l5.2-3c5-2.8 10.2-5.3 15.6-7.6c8.7-3.7 18.6-.9 25 6.2l19.8 22.2c6.8-1.1 13.8-1.7 20.9-1.7s14.1 .6 20.9 1.7l19.8-22.2c6.3-7.1 16.2-9.9 25-6.2c5.3 2.3 10.5 4.8 15.6 7.6l5.3 3c5.1 3 9.9 6.3 14.6 9.9c7.6 5.7 10.1 15.7 7.1 24.7l-9.3 28.2c8.8 10.7 16 23 20.9 36.2l29.1 6.1c9.3 1.9 16.7 9.1 17.8 18.5c.8 6.7 1.2 13.5 1.2 20.4s-.4 13.7-1.2 20.4c-1.1 9.4-8.6 16.6-17.8 18.5L583.9 397c-5 13.3-12.1 25.5-20.9 36.2l9.3 28.2c3 9 .5 19-7.1 24.7c-4.7 3.5-9.5 6.8-14.6 9.8l-5.4 3.1c-5 2.8-10.2 5.3-15.5 7.6zM416 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z", "M314.7 110.3c3.7 8.7 .9 18.6-6.2 25l-22.2 19.8c1.1 6.8 1.7 13.8 1.7 20.9s-.6 14.1-1.7 20.9l22.2 19.8c7.1 6.3 9.9 16.2 6.2 25c-2.3 5.3-4.8 10.5-7.6 15.5l-3.1 5.4c-3 5-6.3 9.9-9.8 14.6c-5.7 7.6-15.7 10.1-24.7 7.1l-28.2-9.3c-10.7 8.8-23 16-36.2 20.9L199 324.9c-1.9 9.3-9.1 16.7-18.5 17.8c-6.7 .8-13.5 1.2-20.4 1.2s-13.7-.4-20.4-1.2c-9.4-1.1-16.6-8.6-18.5-17.8L115 295.9c-13.3-5-25.5-12.1-36.2-20.9l-28.2 9.3c-9 3-19 .5-24.7-7.1c-3.5-4.7-6.8-9.6-9.9-14.6l-3-5.2c-2.8-5-5.3-10.2-7.6-15.6c-3.7-8.7-.9-18.6 6.2-25l22.2-19.8C32.6 190.1 32 183.1 32 176s.6-14.1 1.7-20.9L11.5 135.3c-7.1-6.3-9.9-16.2-6.2-25c2.3-5.3 4.8-10.5 7.6-15.6l3-5.3c3-5.1 6.3-9.9 9.9-14.6c5.7-7.6 15.7-10.1 24.7-7.1l28.2 9.3c10.7-8.8 23-16 36.2-20.9L121 27.1c1.9-9.3 9.1-16.7 18.5-17.8C146.3 8.4 153.1 8 160 8s13.7 .4 20.4 1.2c9.4 1.1 16.6 8.6 18.5 17.8L205 56.1c13.3 5 25.5 12.1 36.2 20.9l28.2-9.3c9-3 19-.5 24.7 7.1c3.5 4.7 6.8 9.5 9.8 14.6l3.1 5.4c2.8 5 5.3 10.2 7.6 15.5zM160 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
};
var faCogs = faGears;
var faSunBright = {
  prefix: 'fad',
  iconName: 'sun-bright',
  icon: [512, 512, ["sun-alt"], "e28f", ["M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V88c0 13.3 10.7 24 24 24s24-10.7 24-24V24zm0 400c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V424zM512 256c0-13.3-10.7-24-24-24H424c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24zM88 280c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H88zM437 75c-9.4-9.4-24.6-9.4-33.9 0l-45.3 45.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9c9.4-9.4 9.4-24.6 0-33.9zM154.2 391.8c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l45.3-45.3zM437 437c9.4-9.4 9.4-24.6 0-33.9l-45.3-45.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L403.1 437c9.4 9.4 24.6 9.4 33.9 0zM120.2 154.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l45.3 45.3z", "M256 144a112 112 0 1 0 0 224 112 112 0 1 0 0-224z"]]
};
var faSunAlt = faSunBright;
var faWarehouse = {
  prefix: 'fad',
  iconName: 'warehouse',
  icon: [640, 512, [], "f494", ["M512 488c0 13.3-10.7 24-24 24l-336 0c-13.3 0-24-10.7-24-24V432H512l0 56zm0-88H128V336H512v64zm0-96H128V224H512l0 80z", "M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3z"]]
};
var faConveyorBeltArm = {
  prefix: 'fad',
  iconName: 'conveyor-belt-arm',
  icon: [640, 512, [], "e5f8", ["M96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M240.9 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H267.1l-5.7 34c.8 1 1.5 2 2.3 3l204.5 27.3c17.5 2.3 29.8 18.4 27.5 35.9c-1.4 10.2-7.4 18.7-15.7 23.5V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V190.1L255.2 164.5c-8.4 7.2-19.3 11.6-31.2 11.6c-26.5 0-48-21.5-48-48c0-17.1 8.9-32 22.3-40.6L202.2 64H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h79c.6 0 1.2 0 1.9 0zM240 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40H96V280zm184-24h48c13.3 0 24 10.7 24 24v40H256V280c0-13.3 10.7-24 24-24zm160 0h48c13.3 0 24 10.7 24 24v40H416V280c0-13.3 10.7-24 24-24z"]]
};
var faLockKeyholeOpen = {
  prefix: 'fad',
  iconName: 'lock-keyhole-open',
  icon: [576, 512, ["lock-open-alt"], "f3c2", ["M432 64c-44.2 0-80 35.8-80 80v48H288V144C288 64.5 352.5 0 432 0s144 64.5 144 144v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V144c0-44.2-35.8-80-80-80z", "M64 192c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H64zM256 384H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32z"]]
};
var faLockOpenAlt = faLockKeyholeOpen;
var faSquareFragile = {
  prefix: 'fad',
  iconName: 'square-fragile',
  icon: [448, 512, ["box-fragile", "square-wine-glass-crack"], "f49b", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm86.3 64H297.7C310 96 320 106 320 118.3V208c0 47.6-34.6 87.1-80 94.7V384h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V302.7c-45.4-7.6-80-47.1-80-94.7V118.3C128 106 138 96 150.3 96z", "M150.3 96C138 96 128 106 128 118.3V208c0 47.6 34.6 87.1 80 94.7l0 81.3H160c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H240l0-81.3c45.4-7.6 80-47.1 80-94.7V118.3C320 106 310 96 297.7 96H240l32 64-48 32 32 64-80-64 32-32L176 96H150.3z"]]
};
var faBoxFragile = faSquareFragile;
var faSquareWineGlassCrack = faSquareFragile;
var faArrowUpRightDots = {
  prefix: 'fad',
  iconName: 'arrow-up-right-dots',
  icon: [576, 512, [], "e4b7", ["M528 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 256a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm128 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm336-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z", "M128 32c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32V160c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L54.6 310.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 64H160c-17.7 0-32-14.3-32-32z"]]
};
var faSquareN = {
  prefix: 'fad',
  iconName: 'square-n',
  icon: [448, 512, [], "e277", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.3 104.5L288 294.5V152c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 10.1-6.3 19.1-15.7 22.5s-20.1 .7-26.6-7L160 217.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.1 6.3-19.1 15.7-22.5s20.1-.7 26.6 7z", "M127.7 129.5c9.5-3.5 20.1-.7 26.6 7L288 294.5V152c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 10.1-6.3 19.1-15.7 22.5s-20.1 .7-26.6-7L160 217.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.1 6.3-19.1 15.7-22.5z"]]
};
var faSplotch = {
  prefix: 'fad',
  iconName: 'splotch',
  icon: [512, 512, [], "f5bc", ["M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z", ""]]
};
var faFaceGrinHearts = {
  prefix: 'fad',
  iconName: 'face-grin-hearts',
  icon: [512, 512, [128525, "grin-hearts"], "f584", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z", "M158.4 152.7c4.8-17.8 23.1-28.4 40.8-23.6s28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1zm195.2 0l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"]]
};
var faGrinHearts = faFaceGrinHearts;
var faMeter = {
  prefix: 'fad',
  iconName: 'meter',
  icon: [512, 512, [], "e1e8", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z", "M160 128c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32z"]]
};
var faMandolin = {
  prefix: 'fad',
  iconName: 'mandolin',
  icon: [512, 512, [], "f6f9", ["M276.9 189.8C189.6 188.3 0 200.5 0 336c0 97.2 78.8 176 176 176c135.5 0 147.7-189.6 146.2-276.9l-66.2 66.2c0 .9 .1 1.8 .1 2.7c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c.9 0 1.8 0 2.7 .1l66.2-66.2z", "M465 7c-7.9-7.9-20.2-9.3-29.7-3.4l-64 40c-5.1 3.2-8.8 8.2-10.4 14L342.8 124 210.7 256.1c24.4 1.3 43.9 20.9 45.3 45.3L388 169.2l66.3-18.1c5.8-1.6 10.8-5.3 14-10.4l40-64c5.9-9.5 4.5-21.8-3.4-29.7L465 7z"]]
};
var faDiceFour = {
  prefix: 'fad',
  iconName: 'dice-four',
  icon: [448, 512, [9859], "f524", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faSimCard = {
  prefix: 'fad',
  iconName: 'sim-card',
  icon: [384, 512, [], "f7c4", ["M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H96z", "M128 192H96c-17.7 0-32 14.3-32 32v32h64V192zM64 288v64h80 96 80V288H240 144 64zm256-32V224c0-17.7-14.3-32-32-32H256v64h64zm-96-64H160v64h64V192zm96 192H256v64h32c17.7 0 32-14.3 32-32V384zm-96 64V384H160v64h64zm-96 0V384H64v32c0 17.7 14.3 32 32 32h32z"]]
};
var faTransgender = {
  prefix: 'fad',
  iconName: 'transgender',
  icon: [512, 512, [9895, "transgender-alt"], "f225", ["M192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z", "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V414.2C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]]
};
var faTransgenderAlt = faTransgender;
var faMercury = {
  prefix: 'fad',
  iconName: 'mercury',
  icon: [384, 512, [9791], "f223", ["M112 224a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z", "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z"]]
};
var faUpFromBracket = {
  prefix: 'fad',
  iconName: 'up-from-bracket',
  icon: [448, 512, [], "e590", ["M32 320c17.7 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96V352c0-17.7 14.3-32 32-32z", "M196.7 11.3L73.9 134.1c-6.4 6.4-9.9 15-9.9 24C64 176.8 79.2 192 97.9 192H160V320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V192h62.1c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24L251.3 11.3C244.1 4.1 234.2 0 224 0s-20.1 4.1-27.3 11.3z"]]
};
var faKnifeKitchen = {
  prefix: 'fad',
  iconName: 'knife-kitchen',
  icon: [576, 512, [128298], "f6f5", ["M273.3 222.7L262 211.4l-11.3 11.3-246 246c-3.9 3.9-5.5 9.6-4.3 15s5.3 9.8 10.5 11.5L16 480c-5.1 15.2-5.1 15.2-5.1 15.2l0 0 0 0 0 0 .1 0 .5 .2c.4 .1 1 .3 1.8 .6c1.5 .5 3.7 1.1 6.5 1.9c5.5 1.6 13.3 3.7 22.7 5.7c18.6 4.1 43.9 8.4 69.5 8.4c123.3 0 209.4-62.8 287.3-140.7c6.2-6.2 6.2-16.4 0-22.6l-126-126z", "M463 10.3C469.7 3.7 478.6 0 488 0s18.3 3.7 25 10.3L557.7 55c6.6 6.6 10.3 15.6 10.3 25s-3.7 18.3-10.3 25l-97 97c-3 3-4.7 7.1-4.7 11.3v31.9c0 17.4-9.4 33.5-24.7 42L375.8 318l-4.6 2.6-97.9-97.9L262 211.4l6.7-6.7L463 10.3zM448 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faBorderRight = {
  prefix: 'fad',
  iconName: 'border-right',
  icon: [448, 512, [], "f852", ["M320 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192-32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M416 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32z"]]
};
var faArrowTurnDown = {
  prefix: 'fad',
  iconName: 'arrow-turn-down',
  icon: [384, 512, ["level-down"], "f149", ["M160 402.7L160 96c0-17.7-14.3-32-32-32H32C14.3 64 0 49.7 0 32S14.3 0 32 0h96c53 0 96 43 96 96l0 306.7-32 32-32-32z", "M41.4 329.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 434.7 86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0z"]]
};
var faLevelDown = faArrowTurnDown;
var faSpade = {
  prefix: 'fad',
  iconName: 'spade',
  icon: [512, 512, [9824], "f2f4", ["M278 12.5c-12.3-11.7-31.7-11.7-44 0L168 75.1 40 196.3c-51.3 48.6-53.5 129.6-4.9 181s129.6 53.5 181 4.9l8-7.6V256c0-17.7 14.3-32 32-32s32 14.3 32 32V374.6l8 7.6c51.3 48.6 132.3 46.4 181-4.9s46.4-132.3-4.9-181L344 75.1 278 12.5z", "M256 224c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V256c0-17.7 14.3-32 32-32z"]]
};
var faCardSpade = {
  prefix: 'fad',
  iconName: 'card-spade',
  icon: [384, 512, [], "e3ec", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM175 137.8c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6 64 64c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-7.4-7.4c-.3-.3-.6-.6-1-.9V336h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V295.2c-.3 .3-.7 .6-1 .9l-7.4 7.4c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l64-64L175 137.8z", "M209 137.8c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6-64 64c-21.9 21.9-21.9 57.3 0 79.2s57.3 21.9 79.2 0l7.4-7.4c.3-.3 .6-.6 1-.9V336H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V295.2c.3 .3 .7 .6 1 .9l7.4 7.4c21.9 21.9 57.3 21.9 79.2 0s21.9-57.3 0-79.2l-64-64L209 137.8z"]]
};
var faLineColumns = {
  prefix: 'fad',
  iconName: 'line-columns',
  icon: [512, 512, [], "f870", ["M512 64c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32zm0 128c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32zM288 320c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zM512 448c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32z", "M224 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H192c17.7 0 32-14.3 32-32zm0 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192c17.7 0 32-14.3 32-32zM0 320c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM224 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192c17.7 0 32-14.3 32-32z"]]
};
var faArrowRightToLine = {
  prefix: 'fad',
  iconName: 'arrow-right-to-line',
  icon: [448, 512, [8677, "arrow-to-right"], "f340", ["M416 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32z", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l178.7 0-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z"]]
};
var faArrowToRight = faArrowRightToLine;
var faPersonFallingBurst = {
  prefix: 'fad',
  iconName: 'person-falling-burst',
  icon: [640, 512, [], "e547", ["M398.9 343.6c2.4-.7 4.6-1.9 6.5-3.6L464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L379.5 314l14.1 18.8c2.5 3.3 4.2 7 5.3 10.8z", "M224 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L240.5 256l71.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L304 320l-80 0h-1.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L100.5 249.2c-2.9 9.2-4.5 19-4.5 29L96 352c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2C32 213 71.6 154.5 132.1 130.3C168.3 115.8 192 80.8 192 41.8l0-9.8c0-17.7 14.3-32 32-32zM48 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faFlagPennant = {
  prefix: 'fad',
  iconName: 'flag-pennant',
  icon: [448, 512, [128681, "pennant"], "f456", ["M64 352L433 213.6c9-3.4 15-12 15-21.6s-6-18.2-15-21.6L64 32V352z", "M32 0C49.7 0 64 14.3 64 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32C0 14.3 14.3 0 32 0z"]]
};
var faPennant = faFlagPennant;
var faConveyorBeltEmpty = {
  prefix: 'fad',
  iconName: 'conveyor-belt-empty',
  icon: [640, 512, [], "e150", ["M96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", ""]]
};
var faUserGroupSimple = {
  prefix: 'fad',
  iconName: 'user-group-simple',
  icon: [640, 512, [], "e603", ["M480 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208zM448 480c-38.3 0-72.7-16.8-96.1-43.5c.1-1.5 .1-3 .1-4.5V416c0-34.9-11.2-67.1-30.1-93.4c5.8-20 24.2-34.6 46.1-34.6H592c26.5 0 48 21.5 48 48v16c0 70.7-57.3 128-128 128H448z", "M160 240a104 104 0 1 0 0-208 104 104 0 1 0 0 208zm-32 48C57.3 288 0 345.3 0 416v16c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V416c0-70.7-57.3-128-128-128H128z"]]
};
var faAward = {
  prefix: 'fad',
  iconName: 'award',
  icon: [384, 512, [], "f559", ["M56.9 309.7L1.3 441.8c-2.2 5.3-1.4 11.4 2.1 16s9.3 6.9 15 6l56.1-8.3 32.2 49.2c3.2 5 8.9 7.7 14.8 7.2s11-4.3 13.3-9.7l50.1-119c-3.9-.9-7.6-2.4-11-4.7L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7l-1.8-.9zm142.3 73.5l50.1 119c2.3 5.5 7.4 9.2 13.3 9.7s11.6-2.2 14.8-7.2l32.2-49.2 56.1 8.3c5.7 .8 11.4-1.5 15-6s4.3-10.7 2.1-16L327.1 309.7l-1.8 .9c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-3.4 2.3-7.2 3.8-11 4.7z", "M210.2 5.5c-11-7.3-25.4-7.3-36.4 0L156 17.2c-6 3.9-13 5.8-20.1 5.4l-21.3-1.3c-13.2-.8-25.6 6.4-31.5 18.2L73.4 58.6C70.2 65 65 70.2 58.6 73.4L39.5 83c-11.8 5.9-19 18.3-18.2 31.5l1.3 21.3c.4 7.1-1.5 14.2-5.4 20.1L5.5 173.8c-7.3 11-7.3 25.4 0 36.4L17.2 228c3.9 6 5.8 13 5.4 20.1l-1.3 21.3c-.8 13.2 6.4 25.6 18.2 31.5l19.1 9.6c6.4 3.2 11.5 8.4 14.7 14.7L83 344.5c5.9 11.8 18.3 19 31.5 18.2l21.3-1.3c7.1-.4 14.2 1.5 20.1 5.4l17.8 11.8c11 7.3 25.4 7.3 36.4 0L228 366.8c6-3.9 13-5.8 20.1-5.4l21.3 1.3c13.2 .8 25.6-6.4 31.5-18.2l9.6-19.1c3.2-6.4 8.4-11.5 14.7-14.7l19.1-9.6c11.8-5.9 19-18.3 18.2-31.5l-1.3-21.3c-.4-7.1 1.5-14.2 5.4-20.1l11.8-17.8c7.3-11 7.3-25.4 0-36.4L366.8 156c-3.9-6-5.8-13-5.4-20.1l1.3-21.3c.8-13.2-6.4-25.6-18.2-31.5l-19.1-9.6c-6.4-3.2-11.5-8.4-14.7-14.7L301 39.5c-5.9-11.8-18.3-19-31.5-18.2l-21.3 1.3c-7.1 .4-14.2-1.5-20.1-5.4L210.2 5.5zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]]
};
var faTicketSimple = {
  prefix: 'fad',
  iconName: 'ticket-simple',
  icon: [576, 512, ["ticket-alt"], "f3ff", ["M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192V128z", ""]]
};
var faTicketAlt = faTicketSimple;
var faBuilding = {
  prefix: 'fad',
  iconName: 'building',
  icon: [384, 512, [127970, 61687], "f1ad", ["M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z", "M80 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80zm0 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm96 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM160 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM272 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272z"]]
};
var faAnglesLeft = {
  prefix: 'fad',
  iconName: 'angles-left',
  icon: [512, 512, [171, "angle-double-left"], "f100", ["M233.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]]
};
var faAngleDoubleLeft = faAnglesLeft;
var faCamcorder = {
  prefix: 'fad',
  iconName: 'camcorder',
  icon: [576, 512, [128249, "video-handheld"], "f8a8", ["M128 96c-17.7 0-32 14.3-32 32v32H320c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-23.7 12.9-44.4 32-55.4V128c0-53 43-96 96-96H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H128zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z", "M559.1 163.8c10.4 5.6 16.9 16.4 16.9 28.2V448c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6L384 379.8V260.2l142.2-94.8c9.8-6.5 22.4-7.2 32.9-1.6zM80 224H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
};
var faVideoHandheld = faCamcorder;
var faPancakes = {
  prefix: 'fad',
  iconName: 'pancakes',
  icon: [512, 512, [129374], "e42d", ["M0 160c0-9.5 5.3-18.6 14.9-27c2.2 2.5 4.5 4.8 6.8 6.8c10.9 9.6 24.9 17 39.6 22.9c1.2 .5 2 1.2 2.4 1.8c.1 .2 .2 .3 .2 .4v48.1C24.2 198.8 0 180.3 0 160zm512 0c0 41-98.7 74.8-225.9 79.5c1.2-4.9 1.9-10.1 1.9-15.5l0-32s.1-.1 .1-.2c.3-.3 .7-.5 1.2-.5c56.2-2.3 107.3-10.4 145.3-22.8c18.8-6.2 36.3-14 49.8-24c4.2-3.1 8.6-7 12.7-11.5c9.7 8.4 14.9 17.5 14.9 27zM64 246.7V272c0 7.8 1.4 15.4 4 22.3C25.8 280 0 261 0 240c0-6.5 2.5-12.8 7.2-18.9c15.7 10.3 35.3 18.7 56.8 25.6zm110.6 69.2c9.2-9.8 15.4-22.5 17-36.7c9.5 5.6 20.6 8.8 32.4 8.8c16.3 0 31.1-6.1 42.4-16.1c69-.8 132.4-9.9 180.2-24.8c22-6.9 42.2-15.5 58.3-26c4.7 6.1 7.2 12.4 7.2 18.9c0 44.2-114.6 80-256 80c-28.5 0-55.8-1.5-81.4-4.1zm330.2-14.8c4.7 6.1 7.2 12.4 7.2 18.9c0 44.2-114.6 80-256 80S0 364.2 0 320c0-6.5 2.5-12.8 7.2-18.9c16.1 10.6 36.2 19.1 58.3 26C115.6 342.8 183 352 256 352s140.4-9.2 190.6-24.9c22-6.9 42.2-15.4 58.3-26zm0 80c4.7 6.1 7.2 12.4 7.2 18.9c0 44.2-114.6 80-256 80S0 444.2 0 400c0-6.5 2.5-12.8 7.2-18.9c16.1 10.6 36.2 19.1 58.3 26C115.6 422.8 183 432 256 432s140.4-9.2 190.6-24.9c22-6.9 42.2-15.4 58.3-26z", "M288 159.4c-17.7 .7-32 15-32 32.6v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V171.7c0-8.1-6.5-14.9-14.5-15.7c-9.4-1-17.5 6.3-17.5 15.7V272c0 17.7-14.3 32-32 32s-32-14.3-32-32V164.8c0-14.2-9.5-26.5-22.7-31.8C47.3 122.6 32 109.8 32 96c0-35.3 100.3-64 224-64s224 28.7 224 64c0 32.2-83.4 58.9-192 63.4zM208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]]
};
var faAlbumCircleUser = {
  prefix: 'fad',
  iconName: 'album-circle-user',
  icon: [576, 512, [], "e48d", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H296.2c-16.2-19.7-28.3-42.9-34.8-68.4c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160c69.3 0 128.3 44 150.5 105.6c18-6.2 37.4-9.6 57.5-9.6c5.4 0 10.7 .2 16 .7V96c0-35.3-28.7-64-64-64H64zM256 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-30.2 0-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7C489.5 468.1 462.2 480 432 480zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faQrcode = {
  prefix: 'fad',
  iconName: 'qrcode',
  icon: [448, 512, [], "f029", ["M48 32C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm80 64v64H64V96h64zM48 288c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48zm80 64v64H64V352h64zM256 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zm64 16h64v64H320V96z", "M256 464V304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z"]]
};
var faDiceD10 = {
  prefix: 'fad',
  iconName: 'dice-d10',
  icon: [512, 512, [], "f6cd", ["M198 0c8.5 0 14.4 8.3 11.7 16.3L142.6 217.8c-1.8 5.3-6.2 9.3-11.7 10.6L13.2 254.4C6.4 256 0 250.8 0 243.8c0-2.5 .8-4.9 2.4-6.8L188.3 4.6C190.6 1.7 194.2 0 198 0zM512 243.8c0 7-6.4 12.1-13.2 10.6L381.2 228.3c-5.5-1.2-9.9-5.2-11.7-10.6L302.3 16.3C299.6 8.3 305.6 0 314 0c3.8 0 7.3 1.7 9.7 4.6L509.6 237c1.5 1.9 2.4 4.3 2.4 6.8zM256 0c4.3 0 8 2.7 9.4 6.8l71.8 215.5c2.2 6.7-.2 14.2-6.1 18.2l-66.1 45.7c-5.5 3.8-12.7 3.8-18.2 0l-66.1-45.7c-5.8-4-8.3-11.5-6.1-18.2L246.6 6.8C248 2.7 251.7 0 256 0z", "M0 299.1c0-5.2 3.6-9.8 8.7-10.9l133.1-29.6c4.4-1 8.9-.1 12.6 2.5l78.7 54.5c4.3 3 6.9 7.9 6.9 13.2V500.5c0 6.3-5.1 11.5-11.5 11.5c-2.9 0-5.7-1.1-7.8-3.1L3.6 307.3c-2.3-2.1-3.6-5.1-3.6-8.2zM283.5 512c-6.3 0-11.5-5.1-11.5-11.5V328.8c0-5.3 2.6-10.2 6.9-13.2l78.7-54.5c3.7-2.5 8.2-3.4 12.6-2.5l133.1 29.6c5.1 1.1 8.7 5.7 8.7 10.9c0 3.1-1.3 6.1-3.6 8.2L291.3 508.9c-2.1 2-4.9 3.1-7.8 3.1z"]]
};
var faFireplace = {
  prefix: 'fad',
  iconName: 'fireplace',
  icon: [640, 512, [], "f79a", ["M32 0C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96H608c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4c-10.7-20.7-25.9-42.5-43.9-59c-4.1-3.7-10.4-3.8-14.5 0c-7 6.4-13.5 14.3-19.2 21.5c-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8z", "M32 96H608V480c0 17.7-14.3 32-32 32H480V352c0-88.4-71.6-160-160-160s-160 71.6-160 160V512H64c-17.7 0-32-14.3-32-32V96zM320.6 465.5c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8c-10.9 7.3-22.5 10.9-35.6 10.9z"]]
};
var faBrowser = {
  prefix: 'fad',
  iconName: 'browser',
  icon: [512, 512, [128468], "f37e", ["M96 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM448 480c35.3 0 64-28.7 64-64V224L0 224V416c0 35.3 28.7 64 64 64l384 0z", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V224H0V96zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm120-24c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]]
};
var faPenPaintbrush = {
  prefix: 'fad',
  iconName: 'pen-paintbrush',
  icon: [576, 512, ["pencil-paintbrush"], "f618", ["M226.3 147.1L95.6 16.4C73.7-5.5 38.3-5.5 16.4 16.4s-21.9 57.3 0 79.2L147.1 226.3l79.2-79.2zm64.2 276.8c11 50.3 55.8 88.1 109.4 88.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4.8c-17.6 0-29.6-18.9-27.8-36.4c.4-3.8 .6-7.7 .6-11.6c0-53.6-37.7-98.5-88.1-109.4L290.6 423.9z", "M410.7 19.3L354.3 75.7 468.3 189.7l56.4-56.4c25-25 25-65.5 0-90.5L501.3 19.3c-25-25-65.5-25-90.5 0zm-79 79L76.9 353.2c-6.7 6.7-11.6 15.1-14.2 24.2l-29.7 104c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l104-29.7c9.2-2.6 17.5-7.5 24.2-14.2L445.7 212.3 331.7 98.3z"]]
};
var faPencilPaintbrush = faPenPaintbrush;
var faFishCooked = {
  prefix: 'fad',
  iconName: 'fish-cooked',
  icon: [576, 512, [], "f7fe", ["M320 64c120 0 256 128 256 192s-136 192-256 192c-74.8 0-155.9-49.8-206.3-102.8c-6-6.3-15.8-7.2-22.5-1.7L26.1 396.4c-5.3 4.3-12.9 4.8-18.7 1.1s-8.6-10.7-6.9-17.4L30.5 259.9c.6-2.5 .6-5.2 0-7.8L.5 131.9c-1.6-6.5 .9-13.2 6.4-17s12.7-3.8 18.2 0l72 49.5c6.6 4.5 15.5 3.5 21.1-2.2C168.9 110.9 247.4 64 320 64zm-4.7 84.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zm112 16c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6zm16 112c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6z", "M315.3 148.7c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0zm112 16c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0zm16 112c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0z"]]
};
var faChairOffice = {
  prefix: 'fad',
  iconName: 'chair-office',
  icon: [448, 512, [], "f6c1", ["M160 0C124.7 0 96 28.7 96 64V288H352V64c0-35.3-28.7-64-64-64H160zm0 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V384H192v64H160z", "M64 160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm384 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160zM80 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S52.9 384 64 384H384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C391.2 294.8 380.1 288 368 288H80z"]]
};
var faNestingDolls = {
  prefix: 'fad',
  iconName: 'nesting-dolls',
  icon: [640, 512, [], "e3ba", ["M80 112C80 50.1 130.1 0 192 0s112 50.1 112 112V256H80V112zM200.7 64.9c-4.1-5.3-13.2-5.3-17.3 0c-11.7 15.1-28.7 26-48.2 29.7c-4 .8-7.2 4.2-6.8 8.2c1.5 14 7.6 27.7 18.4 38.5c25 25 65.5 25 90.5 0c10.8-10.8 16.9-24.4 18.4-38.5c.4-4.1-2.7-7.5-6.8-8.2c-19.5-3.7-36.5-14.6-48.2-29.7zm254.7 256c4.1-5.3 13.2-5.3 17.3 0C487.3 339.8 510.2 352 536 352c4.3 0 8 3.3 7.6 7.6c-1.7 17.9-9.4 35.3-23.1 49c-31.2 31.2-81.9 31.2-113.1 0c-13.7-13.7-21.4-31.1-23.1-49c-.4-4.3 3.3-7.6 7.6-7.6c25.8 0 48.7-12.2 63.3-31.1z", "M637.3 499c4.1-8 3.4-17.6-1.8-24.9l0 0 0 0-.2-.3c-.2-.3-.6-.8-1-1.5c-.9-1.4-2.3-3.5-4-6.3c-3.4-5.6-7.9-13.8-12.5-23.8C608.6 421.7 600 395.3 600 368v-8c0-75.1-60.9-136-136-136s-136 60.9-136 136v8c0 27.3-8.6 53.7-17.8 74.1c-4.6 10-9.1 18.2-12.5 23.8c-1.7 2.8-3.1 5-4 6.3c-.5 .7-.8 1.2-1 1.5l-.2 .3 0 0c-5.2 7.3-5.9 16.9-1.8 24.9c4.1 8 12.3 13 21.3 13H616c9 0 17.2-5 21.3-13zM472.7 320.9C487.3 339.8 510.2 352 536 352c4.3 0 8 3.3 7.6 7.6c-1.7 17.9-9.4 35.3-23.1 49c-31.2 31.2-81.9 31.2-113.1 0c-13.7-13.7-21.4-31.1-23.1-49c-.4-4.3 3.3-7.6 7.6-7.6c25.8 0 48.7-12.2 63.3-31.1c4.1-5.3 13.2-5.3 17.3 0zM296 360c0-39.3 13.5-75.4 36.1-104H51.9c-5.9 0-11.3 3.3-14 8.6C20.2 299.6 0 339.6 0 384c0 48.8 17.9 85.7 31.8 107.1C41.1 505.3 57.5 512 74.5 512H261.4c-8.7-18.2-6.8-39.8 4.9-56.3l0 0 0 0 0-.1 0 0c.1-.1 .3-.5 .7-1c.7-1 1.8-2.8 3.2-5.2c2.9-4.8 6.8-11.9 10.8-20.6c8.2-18.1 15-39.8 15-60.8v-8z"]]
};
var faClockRotateLeft = {
  prefix: 'fad',
  iconName: 'clock-rotate-left',
  icon: [512, 512, ["history"], "f1da", ["M120.2 120.2C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8z", "M256 128c13.3 0 24 10.7 24 24v94.1l65 65c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72c-4.5-4.5-7-10.6-7-17V152c0-13.3 10.7-24 24-24z"]]
};
var faHistory = faClockRotateLeft;
var faTrumpet = {
  prefix: 'fad',
  iconName: 'trumpet',
  icon: [640, 512, [127930], "f8e3", ["M448 258.2c22.7 4 44.3 13.4 64 25.4V320c0 70.7-57.3 128-128 128H288 192c-70.7 0-128-57.3-128-128c0-23.3 6.2-45.2 17.1-64H224V384h40V256h48V384h40V256h48V382c27.6-7.1 48-32.2 48-62V258.2zM400 192H352V160c0-13.3 10.7-24 24-24s24 10.7 24 24v32zm-88 0H264V160c0-13.3 10.7-24 24-24s24 10.7 24 24v32zm-87.9 0H176V160c0-13.3 10.7-24 24-24s24 10.7 24 24v32c0 0 .1 0 .1 0zM176 258c-27.6 7.1-48 32.2-48 62s20.4 54.9 48 62V258z", "M640 80c0-7-4.6-13.2-11.3-15.3s-14 .4-17.9 6.2l0 0 0 0-.1 .2-.7 .9c-.6 .8-1.5 2.1-2.8 3.8c-2.5 3.3-6.2 8.1-11 13.9c-9.6 11.6-23.6 26.9-40.8 42.3c-35 31.1-81.3 60-131.4 60H46.6c-3.3-9.3-12.2-16-22.6-16c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24c10.4 0 19.3-6.7 22.6-16H424c50.1 0 96.4 28.8 131.4 60c17.3 15.3 31.2 30.7 40.8 42.3c4.8 5.8 8.5 10.6 11 13.9c1.2 1.7 2.2 2.9 2.8 3.8l.7 .9 .1 .2 0 0 0 0c4 5.8 11.2 8.3 17.9 6.2s11.3-8.3 11.3-15.3V80z"]]
};
var faFaceGrinBeamSweat = {
  prefix: 'fad',
  iconName: 'face-grin-beam-sweat',
  icon: [512, 512, [128517, "grin-beam-sweat"], "f583", ["M256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM388.1 312.8c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5c5-11.8-7-22.5-19.3-18.7zm-170.5-84l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z", "M512 81c0 26-21.5 47-48 47s-48-21-48-47c0-20 28.4-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81zM217.6 228.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]]
};
var faGrinBeamSweat = faFaceGrinBeamSweat;
var faFireSmoke = {
  prefix: 'fad',
  iconName: 'fire-smoke',
  icon: [640, 512, [], "f74b", ["M283.7 0c3.5 0 7 1.3 9.8 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79c0 35.9-11.9 69.1-32 95.9c-14.3-19-32.6-34.7-53.8-45.8c8.1-20.4 7.1-44.6-4.2-65.2c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 11.9 2.1 22.7 6 32.1c-21.3 11.1-39.8 27-54.2 46.1c-20.1-26.8-31.9-60.1-31.9-96c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7z", "M112 512C50.1 512 0 461.9 0 400s50.1-112 112-112c37 0 69.9 18 90.3 45.7C221.8 288 267.2 256 320 256s98.2 32 117.7 77.7C458.1 306 491 288 528 288c61.9 0 112 50.1 112 112s-50.1 112-112 112H320 112z"]]
};
var faPhoneMissed = {
  prefix: 'fad',
  iconName: 'phone-missed',
  icon: [640, 512, [], "e226", ["M537.5 509c19.9 7.6 42.7 .3 53.4-17l43.5-70.5c9.6-15.5 6.7-35-6.9-47.6c-169.8-157.2-445.1-157.2-615 0c-13.6 12.6-16.5 32.1-6.9 47.6L49.1 492c10.7 17.3 33.5 24.5 53.4 17l92.4-35.2c17.5-6.7 28.1-23.1 26.3-40.6l-5.8-53.3c67.6-21.7 141.5-21.7 209.1 0l-5.8 53.3c-1.9 17.4 8.8 33.9 26.3 40.6L537.5 509z", "M120 0H232c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-39 39 58.7 58.7C282.3 152.4 300.8 160 320 160s37.7-7.6 51.3-21.3L503 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L405.3 172.7C382.6 195.3 352 208 320 208s-62.6-12.7-85.3-35.3L176 113.9l-39 39c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V24c0-13.3 10.7-24 24-24z"]]
};
var faFileExport = {
  prefix: 'fad',
  iconName: 'file-export',
  icon: [576, 512, ["arrow-right-from-file"], "f56e", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zm105 55c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H494.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]]
};
var faArrowRightFromFile = faFileExport;
var faShield = {
  prefix: 'fad',
  iconName: 'shield',
  icon: [512, 512, [128737, "shield-blank"], "f132", ["M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z", ""]]
};
var faShieldBlank = faShield;
var faArrowUpShortWide = {
  prefix: 'fad',
  iconName: 'arrow-up-short-wide',
  icon: [576, 512, ["sort-amount-up-alt"], "f885", ["M288 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32z", "M128 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L160 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L63.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C110.5 35.8 119 32 128 32z"]]
};
var faSortAmountUpAlt = faArrowUpShortWide;
var faArrowsRepeat1 = {
  prefix: 'fad',
  iconName: 'arrows-repeat-1',
  icon: [512, 512, ["repeat-1-alt"], "f366", ["M1.6 213.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2C77.1 189.9 118.5 160 165.2 160H416c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96H165.2C91 96 25.1 143.5 1.6 213.9zm508.7 84.2c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2C434.9 322.1 393.5 352 346.8 352H96c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L173.3 416H346.8c74.2 0 140.1-47.5 163.6-117.9z", "M278 196.5c6.3 4.5 10 11.8 10 19.5v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3z"]]
};
var faRepeat1Alt = faArrowsRepeat1;
var faGunSlash = {
  prefix: 'fad',
  iconName: 'gun-slash',
  icon: [640, 512, [], "e19c", ["M412.3 297.8L432.9 240H464c8.5 0 16.6-3.4 22.6-9.4L509.3 208H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H560V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H113.9l81.7 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H236.4l102.1 80h43.4l-9.5 26.6 39.8 31.2zM324.9 352L32 121.2V208c0 17.7 14.3 32 32 32H74c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480h96c14.7 0 27.5-10 31-24.2L249 352h75.9z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faAvocado = {
  prefix: 'fad',
  iconName: 'avocado',
  icon: [512, 512, [], "e0aa", ["M459.4 255.3c-18.5 15.2-33.5 35.6-38.1 59.1c-10.2 51.9-34 104.5-66.3 136.7c-81.2 81.2-212.9 81.2-294.2 0s-81.2-212.9 0-294.2c32.3-32.3 84.9-56.1 136.7-66.3c23.5-4.6 43.9-19.6 59.1-38.1C283.1 20.5 323.2 0 368 0c79.5 0 144 64.5 144 144c0 44.8-20.5 84.9-52.6 111.3zM283.2 347.2c41.7-41.7 49.1-102.1 16.4-134.8s-93-25.3-134.8 16.4s-49.1 102.1-16.4 134.8s93 25.3 134.8-16.4z", "M299.6 212.4c32.7 32.7 25.3 93-16.4 134.8s-102.1 49.1-134.8 16.4s-25.3-93 16.4-134.8s102.1-49.1 134.8-16.4z"]]
};
var faBinary = {
  prefix: 'fad',
  iconName: 'binary',
  icon: [384, 512, [], "e33b", ["M64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 64h64v96H64V64zM256 288c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H256zm0 64h64v96H256V352z", "M336 32c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H256c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H336V32zM112 320c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16C5.1 311.2-3.9 329.4 1.6 346.1s23.7 25.8 40.5 20.2l5.9-2V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H80h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V320z"]]
};
var faGlassesRound = {
  prefix: 'fad',
  iconName: 'glasses-round',
  icon: [576, 512, [128083, "glasses-alt"], "f5f5", ["M136 432a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm304 0a88 88 0 1 0 0-176 88 88 0 1 0 0 176z", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L64.4 228.3C85.2 215.4 109.7 208 136 208c55.1 0 102.6 32.8 124 80H316c21.3-47.2 68.8-80 124-80c26.3 0 50.8 7.4 71.6 20.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l40.5 173.7c4.9 20.9 7.3 42.2 7.3 63.6V336c0 .8 0 1.6-.1 2.4c.1 1.9 .1 3.8 .1 5.6c0 75.1-60.9 136-136 136c-72.4 0-131.6-56.6-135.8-128H271.8c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0-1.9 0-3.8 .1-5.6c-.1-.8-.1-1.6-.1-2.4V325.5c0-21.4 2.5-42.8 7.3-63.6L47.9 88.2C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM136 432a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm392-88a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"]]
};
var faGlassesAlt = faGlassesRound;
var faPhonePlus = {
  prefix: 'fad',
  iconName: 'phone-plus',
  icon: [640, 512, [], "f4d2", ["M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 247.4 200.6 448 448 448c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368C298.3 334.7 241.3 277.7 208 207.3L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z", "M456 136v64c0 13.3 10.7 24 24 24s24-10.7 24-24V136h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H504V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V88H392c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faDitto = {
  prefix: 'fad',
  iconName: 'ditto',
  icon: [320, 512, [], "22", ["M0 98.3V96C0 60.7 28.7 32 64 32s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L101.5 256.5C98.3 274.7 82.5 288 64 288s-34.3-13.3-37.5-31.5L1 109.6c-.7-3.8-1-7.5-1-11.4z", "M192 98.3V96c0-35.3 28.7-64 64-64s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L293.5 256.5c-3.2 18.2-19 31.5-37.5 31.5s-34.3-13.3-37.5-31.5L193 109.6c-.7-3.8-1-7.5-1-11.4z"]]
};
var faPersonSeat = {
  prefix: 'fad',
  iconName: 'person-seat',
  icon: [384, 512, [], "e21e", ["M32 128c17.7 0 32 14.3 32 32V320c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H128C57.3 448 0 390.7 0 320V160c0-17.7 14.3-32 32-32z", "M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm96 176v32h53.6c40.3 0 74.4 30 79.4 70.1l7.2 57.9H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H304c-16.1 0-29.8-12-31.8-28l-10.7-86c-1-8-7.8-14-15.9-14H160c-35.3 0-64-28.7-64-64V208c0-26.5 21.5-48 48-48c20.9 0 38.7 13.4 45.3 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H192z"]]
};
var faHouseMedical = {
  prefix: 'fad',
  iconName: 'house-medical',
  icon: [576, 512, [], "e3b2", ["M64 270.5L64.1 448c0 35.3 28.7 64 64 64H448.5c35.4 0 64.1-28.7 64-64.1l-.4-177.3L288 74.5 64 270.5zM272 224h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V352H208c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240c0-8.8 7.2-16 16-16z", "M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2l-256-224zM256 240v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H320V240c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"]]
};
var faGolfBallTee = {
  prefix: 'fad',
  iconName: 'golf-ball-tee',
  icon: [384, 512, ["golf-ball"], "f450", ["M85.8 352H298.2c51.7-34.4 85.8-93.2 85.8-160C384 86 298 0 192 0S0 86 0 192c0 66.8 34.1 125.6 85.8 160zm122.8-61.9c18.5 0 33.5-15 33.5-33.5c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4zm14.7-116.3c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4c18.5 0 33.5-15 33.5-33.5zm46.5 49.5c18.5 0 33.5-15 33.5-33.5c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4z", "M128 384c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c8.8 0 16 7.2 16 16v16c0 17.7 14.3 32 32 32s32-14.3 32-32V464c0-8.8 7.2-16 16-16h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 128z"]]
};
var faGolfBall = faGolfBallTee;
var faCircleChevronLeft = {
  prefix: 'fad',
  iconName: 'circle-chevron-left',
  icon: [512, 512, ["chevron-circle-left"], "f137", ["M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z", "M167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273z"]]
};
var faChevronCircleLeft = faCircleChevronLeft;
var faHouseChimneyWindow = {
  prefix: 'fad',
  iconName: 'house-chimney-window',
  icon: [576, 512, [], "e00d", ["M64.1 448L64 270.5l224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1H128.1c-35.3 0-64-28.6-64-64zM248 240c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H248z", "M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2L512 185.5V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v37.5L309.1 7.9z"]]
};
var faScythe = {
  prefix: 'fad',
  iconName: 'scythe',
  icon: [640, 512, [], "f710", ["M582.1 0H352C114.8 0 15 151.1 1.6 173.3c-1.1 1.8-1.6 3.8-1.6 6c0 7 5.7 12.7 12.7 12.7H541L576.7 25.3 582.1 0z", "M639 24.1C636.1 12.7 627 3.3 614.7 .7c-2.2-.5-4.5-.7-6.7-.7H582.1l-5.4 25.3s0 0 0 0l-7.7 36L520.4 288H416c-17.7 0-32 14.3-32 32s14.3 32 32 32h90.7l-26 121.3c-3.7 17.3 7.3 34.3 24.6 38s34.3-7.3 38-24.6l34.3-160L634.4 61.3l4.8-22.6s0 0 0 0c1.1-5 .9-10-.3-14.6z"]]
};
var faPenNib = {
  prefix: 'fad',
  iconName: 'pen-nib',
  icon: [512, 512, [10001], "f5ad", ["M293.9 92.8L419.2 218.1l-4.5 15.1L371.4 377.3c-6 19.9-21.2 35.7-41 42.3L66.2 508.2c-11.3 3.8-23.9 1-32.4-7.4L187.3 347.3c6.3 3 13.3 4.7 20.7 4.7c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48c0 7.4 1.7 14.4 4.7 20.7L11.1 478.3C2.8 469.7 0 457.2 3.8 445.8L92.4 181.5c6.6-19.7 22.4-35 42.3-41L278.8 97.4l15.1-4.5 0 0z", "M368.4 18.3c21.9-21.9 57.3-21.9 79.2 0l46.1 46.1c21.9 21.9 21.9 57.3 0 79.2l-71 71-3.4 3.4 0 0L293.9 92.8l0 0 0 0 3.4-3.4 71-71z"]]
};
var faBanParking = {
  prefix: 'fad',
  iconName: 'ban-parking',
  icon: [512, 512, ["parking-circle-slash"], "f616", ["M342.3 297c20.6-17.6 33.7-43.8 33.7-73c0-53-43-96-96-96H208c-9.7 0-18.6 3.5-25.5 9.2L237.3 192H280c17.7 0 32 14.3 32 32c0 11.6-6.2 21.7-15.4 27.4L342.3 297zM168 288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V325.3l-64-64V288z", "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]]
};
var faParkingCircleSlash = faBanParking;
var faTentArrowTurnLeft = {
  prefix: 'fad',
  iconName: 'tent-arrow-turn-left',
  icon: [576, 512, [], "e580", ["M268.6 166.5c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160c1.4 9.2-1.3 18.6-7.4 25.6s-14.9 11.1-24.2 11.1H384L288 352V512H96c-9.3 0-18.2-4.1-24.2-11.1s-8.8-16.4-7.4-25.6l24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128z", "M121.8 7.9c8.9 9.9 8.1 25-1.8 33.9L86.5 72 456 72c66.3 0 120 53.7 120 120l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-39.8-32.2-72-72-72L86.5 120l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72C2.9 109.3 0 102.8 0 96s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z"]]
};
var faFaceDiagonalMouth = {
  prefix: 'fad',
  iconName: 'face-diagonal-mouth',
  icon: [512, 512, [129764], "e47e", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM372.4 319.4l-224 64c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8l224-64c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faDiagramCells = {
  prefix: 'fad',
  iconName: 'diagram-cells',
  icon: [512, 512, [], "e475", ["M448 480c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0z", "M448 224c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l384 0z"]]
};
var faCricketBatBall = {
  prefix: 'fad',
  iconName: 'cricket-bat-ball',
  icon: [512, 512, [127951, "cricket"], "f449", ["M192 158.1L16.1 334C6.1 344-.6 358.4 .5 374.4c.8 11.3 2.8 28.6 8.2 46.4C13.8 438.1 22.9 457.9 39 473c15 16.2 34.9 25.2 52.2 30.4c17.8 5.4 35.1 7.4 46.4 8.2c16 1.1 30.4-5.6 40.4-15.6L353.9 320H240c-26.5 0-48-21.5-48-48V158.1zM385.9 288l23-23c4.5-4.5 7-10.6 7-17s-2.5-12.5-7-17L281 103c-9.4-9.4-24.6-9.4-33.9 0l-23 23V272c0 8.8 7.2 16 16 16H385.9z", "M502.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-135 135 45.3 45.3 135-135c12.5-12.5 12.5-32.8 0-45.3zM385.9 288H240c-8.8 0-16-7.2-16-16V126.1l-32 32V272c0 26.5 21.5 48 48 48H353.9l32-32zM512 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]]
};
var faCricket = faCricketBatBall;
var faTents = {
  prefix: 'fad',
  iconName: 'tents',
  icon: [640, 512, [], "e582", ["M435.4 6.5c-11.5-8.7-27.3-8.7-38.8 0L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z", "M204.6 166.5c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160c1.4 9.2-1.3 18.6-7.4 25.6s-14.9 11.1-24.2 11.1H320L224 352V512H32c-9.3 0-18.2-4.1-24.2-11.1S-1 484.5 .4 475.3l24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128z"]]
};
var faWandMagic = {
  prefix: 'fad',
  iconName: 'wand-magic',
  icon: [512, 512, ["magic"], "f0d0", ["M387.2 227.2L497.9 116.5c18.7-18.7 18.7-49.1 0-67.9L463.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L284.7 124.7l39.6 39.6 105-105 23.3 23.3-105 105 39.6 39.6z", "M387.2 227.2L284.7 124.7 14.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L387.2 227.2z"]]
};
var faMagic = faWandMagic;
var faDog = {
  prefix: 'fad',
  iconName: 'dog',
  icon: [576, 512, [128021], "f6d3", ["M421.6 222.5l-112-64L304 192h-.2L416 256.1V256l5.6-33.5z", "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7l-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16H303.8L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
};
var faPenLine = {
  prefix: 'fad',
  iconName: 'pen-line',
  icon: [576, 512, [], "e212", ["M453.3 19.3c-25-25-65.5-25-90.5 0L303 79 433 209l59.7-59.7c25-25 25-65.5 0-90.5L453.3 19.3zM248 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z", "M433 209L303 79 52.8 329.3c-6.6 6.6-11.5 14.8-14.1 23.8L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l128.2-37.7c9-2.6 17.2-7.5 23.8-14.1L433 209z"]]
};
var faAtomSimple = {
  prefix: 'fad',
  iconName: 'atom-simple',
  icon: [512, 512, ["atom-alt"], "f5d3", ["M100.9 411.1c-1.3-1.3-12.4-16.8 3.3-64c3.5-10.4 8-21.4 13.6-32.9c11.6 14.2 24.3 28.3 38 41.9s27.7 26.4 41.9 38c-11.4 5.6-22.4 10.2-32.8 13.6c-47.2 15.7-62.7 4.6-64 3.3zM153.7 256c13.5-18.3 29.3-36.8 47.4-54.9s36.6-33.9 54.9-47.4c18.3 13.5 36.8 29.3 54.9 47.4s33.9 36.6 47.4 54.9c-13.5 18.3-29.3 36.8-47.4 54.9s-36.6 33.9-54.9 47.4c-18.3-13.5-36.8-29.3-54.9-47.4s-33.9-36.6-47.4-54.9zm44.1-138.1c-14.2 11.6-28.3 24.3-41.9 38s-26.4 27.7-38 41.9c-5.6-11.4-10.2-22.4-13.6-32.8c-15.7-47.2-4.6-62.7-3.3-64s16.8-12.4 64 3.3c10.4 3.5 21.4 8 32.8 13.6zM256 76.8C173.9 27.6 94.9 16.5 55.7 55.7S27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8zm58.2 41.1c11.4-5.6 22.4-10.2 32.9-13.6c47.2-15.7 62.7-4.6 64-3.3s12.4 16.8-3.3 64c-3.5 10.4-8 21.4-13.6 32.8c-11.6-14.2-24.3-28.3-38-41.9s-27.7-26.4-41.9-38zm79.9 196.3c5.6 11.4 10.2 22.4 13.6 32.9c15.7 47.2 4.6 62.7 3.3 64s-16.8 12.4-64-3.3c-10.4-3.5-21.4-8-32.9-13.6c14.2-11.6 28.3-24.3 41.9-38s26.4-27.7 38-41.9z", "M224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faAtomAlt = faAtomSimple;
var faAmpersand = {
  prefix: 'fad',
  iconName: 'ampersand',
  icon: [448, 512, [], "26", ["M180.7 96h38c20.6 0 37.3 16.7 37.3 37.3c0 11.8-5.5 22.8-14.9 29.9l-48 36-39-41.3c-6.4-6.8-10-15.8-10-25.2c0-20.3 16.4-36.7 36.7-36.7zm56.6 150l42.2-31.6C305 195.3 320 165.2 320 133.3C320 77.4 274.6 32 218.7 32h-38C125.1 32 80 77.1 80 132.7c0 25.7 9.8 50.4 27.5 69.1l34 36L74.7 288C47.8 308.1 32 339.8 32 373.3C32 432.2 79.8 480 138.7 480h74.5c37.4 0 72.4-18.7 93.2-49.9l6.9-10.4L360.7 470c12.1 12.8 32.4 13.4 45.2 1.3s13.4-32.4 1.3-45.2l-57.5-60.9 60.9-91.4c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9l-52.7 79.1L237.3 246zm-51.5 38.6L268.2 372l-15.1 22.6C244.2 408 229.2 416 213.2 416H138.7C115.1 416 96 396.9 96 373.3c0-13.4 6.3-26.1 17.1-34.1l72.7-54.5z", ""]]
};
var faCarrot = {
  prefix: 'fad',
  iconName: 'carrot',
  icon: [512, 512, [129365], "f787", ["M142.9 184.2c24.6-30.1 61.7-48.2 101.7-48.2C317.2 136 376 194.8 376 267.4c0 51.2-29.7 97.7-76.2 119.2L199.7 433l-60.4-60.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.1 52.1L34.1 509.8C25 514 14.1 512.1 7 505s-9-17.9-4.8-27.1L125.4 212.2c0 0 0-.1 0-.1l55.3 55.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-60.5-60.5z", "M320 72c0-29.7 17.6-55 26.7-66c3.3-4 8.2-6 13.3-6s10 2 13.2 6C382.3 17.4 400 44.3 400 80c0 32-8 40-8 40s8-8 40-8c35.7 0 62.6 17.7 74 26.8c4 3.2 6 8.1 6 13.2s-2 10-6 13.3C495 174.4 469.7 192 440 192c-40 0-55.3-15.3-80-40s-40-40-40-80z"]]
};
var faArrowUpFromLine = {
  prefix: 'fad',
  iconName: 'arrow-up-from-line',
  icon: [384, 512, [8613, "arrow-from-bottom"], "f342", ["M0 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M169.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 141.3V208 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V208 141.3L86.6 214.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z"]]
};
var faArrowFromBottom = faArrowUpFromLine;
var faMoon = {
  prefix: 'fad',
  iconName: 'moon',
  icon: [384, 512, [127769, 9214], "f186", ["", "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"]]
};
var faPenSlash = {
  prefix: 'fad',
  iconName: 'pen-slash',
  icon: [640, 512, [], "e213", ["M195.8 250.3L341.2 364.8l-88.6 88.6c-10.4 10.4-23.3 18-37.4 22.2L94.8 511c-8.4 2.5-17.5 .2-23.7-6.1s-8.5-15.3-6.1-23.7l35.4-120.3c4.2-14.1 11.8-27 22.2-37.4l73.2-73.2zm289.9-30L409.9 296 264.3 181.8l91.5-91.5L485.7 220.3zm-58.9-201c25-25 65.5-25 90.5 0l39.4 39.4c25 25 25 65.5 0 90.5l-48.4 48.4L378.3 67.7l48.4-48.4z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faWineGlassEmpty = {
  prefix: 'fad',
  iconName: 'wine-glass-empty',
  icon: [320, 512, ["wine-glass-alt"], "f5ce", ["M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z", ""]]
};
var faWineGlassAlt = faWineGlassEmpty;
var faSquareStar = {
  prefix: 'fad',
  iconName: 'square-star',
  icon: [448, 512, [], "e27f", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 8c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L224 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z", "M238.3 112.9c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-36.2 73.4L92.4 198.1c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.9 1.2L224 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81-11.8-36.2-73.4z"]]
};
var faCheese = {
  prefix: 'fad',
  iconName: 'cheese',
  icon: [512, 512, [], "f7ef", ["M512 256V240.2C512 125.2 418.8 32 303.8 32c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256H512z", "M0 256H512V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z"]]
};
var faSendBackward = {
  prefix: 'fad',
  iconName: 'send-backward',
  icon: [512, 512, [], "f87f", ["M448 224V448H224V224H448zM224 160c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H224z", "M0 64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64v96H224c-35.3 0-64 28.7-64 64V352H64c-35.3 0-64-28.7-64-64V64z"]]
};
var faYinYang = {
  prefix: 'fad',
  iconName: 'yin-yang',
  icon: [512, 512, [9775], "f6ad", ["M512 256c0 141.4-114.6 256-256 256c-70.7 0-128-57.3-128-128s57.3-128 128-128s128-57.3 128-128S326.7 0 256 0C397.4 0 512 114.6 512 256zM224 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M0 256C0 114.6 114.6 0 256 0c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128 57.3-128 128s57.3 128 128 128C114.6 512 0 397.4 0 256zM288 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]]
};
var faMusic = {
  prefix: 'fad',
  iconName: 'music',
  icon: [512, 512, [127925], "f001", ["M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0-34.8-26.7-64.5-64-75.4V147L192 223.8V432c0-34.8-26.7-64.5-64-75.4V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z", "M416 448c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80zM96 512c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80z"]]
};
var faCompassSlash = {
  prefix: 'fad',
  iconName: 'compass-slash',
  icon: [640, 512, [], "f5e9", ["M535.4 394.4C561.1 354.5 576 307 576 256C576 114.6 461.4 0 320 0C246.8 0 180.9 30.7 134.2 79.9l136 106.6 143.3-55.1c19.4-7.5 38.5 11.6 31 31L397.1 285.9 535.4 394.4zm-67.3 70.5L317 345.8l-90.6 34.8c-19.4 7.5-38.5-11.6-31-31l29.4-76.5L82.3 160.8C70.5 190.2 64 222.4 64 256c0 141.4 114.6 256 256 256c55.2 0 106.3-17.5 148.1-47.2z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faClockOne = {
  prefix: 'fad',
  iconName: 'clock-one',
  icon: [512, 512, [], "e34e", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392v56.7l20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23V120c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M256 96c13.3 0 24 10.7 24 24v56.7l20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23V120c0-13.3 10.7-24 24-24z"]]
};
var faFileMusic = {
  prefix: 'fad',
  iconName: 'file-music',
  icon: [384, 512, [], "f8b6", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM288 224c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V315.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V256 224z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zm-96 64c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V315.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V256 224z"]]
};
var faCodeCommit = {
  prefix: 'fad',
  iconName: 'code-commit',
  icon: [640, 512, [], "f386", ["M476.8 288c2.1-10.3 3.2-21 3.2-32s-1.1-21.7-3.2-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8zm-313.6 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2c-2.1 10.3-3.2 21-3.2 32s1.1 21.7 3.2 32z", "M320 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 240a160 160 0 1 0 0-320 160 160 0 1 0 0 320z"]]
};
var faTemperatureLow = {
  prefix: 'fad',
  iconName: 'temperature-low',
  icon: [512, 512, [], "f76b", ["M144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112z", "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM144 256c-8.8 0-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16z"]]
};
var faPersonBiking = {
  prefix: 'fad',
  iconName: 'person-biking',
  icon: [640, 512, [128692, "biking"], "f84a", ["M200 384A72 72 0 1 0 56 384a72 72 0 1 0 144 0zM0 384a128 128 0 1 1 256 0A128 128 0 1 1 0 384zm584 0a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-200 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z", "M400 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM365.4 111.2L427.2 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-7.3 0-14.3-2.5-20-7l-40.7-32.6L295 232.9l42.7 28.5c8.9 5.9 14.2 15.9 14.2 26.6V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V305.1l-60.5-38.4c-32.8-20.8-35-67.9-4.3-91.6l83.1-64.2c17.4-13.5 41.8-13.3 59.1 .3z"]]
};
var faBiking = faPersonBiking;
var faDisplayChartUpCircleCurrency = {
  prefix: 'fad',
  iconName: 'display-chart-up-circle-currency',
  icon: [640, 512, [], "e5e5", ["M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H394.8C349.5 480.1 320 427.5 320 368c0-5.4 .2-10.7 .7-16H64V64H512V192.7c22.9 2.1 44.5 8.5 64 18.5V64c0-35.3-28.7-64-64-64H64zM480 192.7V120c0-13.3-10.7-24-24-24H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h22.1L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111V200c0 1.3 .1 2.6 .3 3.9c15-5.8 31-9.7 47.7-11.2z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM460.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L460.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426c-21.6 13.2-49.1 13.2-70.7 0z"]]
};
var faSkeleton = {
  prefix: 'fad',
  iconName: 'skeleton',
  icon: [512, 512, [], "f620", ["M224 64H96C78.3 64 64 78.3 64 96s14.3 32 32 32H224V64zm0 96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H224V160zm64 64H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H288v64zm-64 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V256zm64 64h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288v64zm0-192H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H288v64z", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V386.3l-67.5-28.9c-8.3-3.5-17.2-5.4-26.1-5.4C93.7 352 64 381.7 64 418.4v1.5c0 18 7.2 35.3 19.9 48l25.8 25.8c11.7 11.7 27.6 18.3 44.1 18.3H358.1c16.6 0 32.4-6.6 44.1-18.3l25.8-25.8c12.7-12.7 19.9-30 19.9-48v-1.5c0-36.7-29.7-66.4-66.4-66.4c-9 0-17.9 1.8-26.1 5.4L288 386.3V32zM136 440a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
};
var faCircleG = {
  prefix: 'fad',
  iconName: 'circle-g',
  icon: [512, 512, [], "e10f", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C295.2 183.7 276.5 176 256 176c-44.2 0-80 35.8-80 80z", "M256 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C295.2 183.7 276.5 176 256 176z"]]
};
var faCircleArrowUpLeft = {
  prefix: 'fad',
  iconName: 'circle-arrow-up-left',
  icon: [512, 512, [], "e0fb", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm64-368c13.3 0 24 10.7 24 24s-10.7 24-24 24H225.9L361 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24H320z", "M168 144H320c13.3 0 24 10.7 24 24s-10.7 24-24 24H225.9L361 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24z"]]
};
var faCoinBlank = {
  prefix: 'fad',
  iconName: 'coin-blank',
  icon: [512, 512, [], "e3fb", ["M256 352C114.6 352 0 287.5 0 208S114.6 64 256 64s256 64.5 256 144s-114.6 144-256 144z", "M48 331c-18.3-11.5-34.8-25.2-48-40.9L0 320c0 27.9 17.8 53.6 48 74.6L48 331zm32 17.3L80 413c27.1 12.8 59.8 22.7 96 28.7l0-64.3c-35.1-6-67.6-15.9-96-29zM256 448c-16.4 0-32.5-.8-48-2.2l0-64.1c15.7 1.6 31.7 2.4 48 2.4s32.3-.8 48-2.4l0 64.1c-15.5 1.5-31.6 2.2-48 2.2zm80-70.7l0 64.3c36.2-6 68.9-15.9 96-28.7l0-64.7c-28.4 13.1-60.9 23-96 29zM512 320c0 27.9-17.8 53.6-48 74.6l0-63.7c18.3-11.5 34.8-25.2 48-40.9l0 29.9z"]]
};
var faBroom = {
  prefix: 'fad',
  iconName: 'broom',
  icon: [576, 512, [129529], "f51a", ["M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192-45.3-45.3 192-192c12.5-12.5 32.8-12.5 45.3 0z", "M409.4 281.4L294.6 166.6c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16zm-68.3 72L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l29.9-15c8.3-4.2 15.9 6.9 8.9 13.1L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"]]
};
var faVacuum = {
  prefix: 'fad',
  iconName: 'vacuum',
  icon: [640, 512, [], "e04d", ["M416 128c-35.3 0-64 28.7-64 64V325.5c10-3.5 20.8-5.5 32-5.5c53 0 96 43 96 96s-43 96-96 96H544c35.3 0 64-28.7 64-64V320c0-106-86-192-192-192z", "M301.6 64H512c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.8 52.8c15.5 14.7 28.6 32 38.5 51.2C619 208.7 640 170.8 640 128C640 57.3 582.7 0 512 0H301.6C241.3 0 189.1 42.2 176.4 101.2L150.1 224h65.5L239 114.6C245.4 85.1 271.4 64 301.6 64zM208.7 256H143.3L109 416H83.8c-33.8 0-64.7 18.9-80 49C1.4 469.5 0 474.6 0 480c0 17.7 14.3 32 32 32h95.4c.4 0 .9 0 1.3 0H176c26.5 0 48-21.5 48-48s-21.5-48-48-48h-1.6l34.3-160zM384 512a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faShieldHeart = {
  prefix: 'fad',
  iconName: 'shield-heart',
  icon: [512, 512, [], "e574", ["M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z", "M205.3 160c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]]
};
var faCardHeart = {
  prefix: 'fad',
  iconName: 'card-heart',
  icon: [384, 512, [], "e3eb", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM202.2 351.7c-5.7 5.7-14.9 5.7-20.1 0L97.4 264.3C72.9 239 74.2 197 101.7 173.4c23.6-20.5 59.9-16.6 81.7 5.7l8.7 9.2 8.3-9.2c21.8-22.3 57.7-26.2 82.2-5.7c27.1 23.6 28.4 65.6 3.9 90.9l-84.3 87.4z", "M286.6 264.3l-84.3 87.4c-5.7 5.7-14.9 5.7-20.1 0L97.4 264.3C72.9 239 74.2 197 101.7 173.4c23.6-20.5 59.9-16.6 81.7 5.7l8.7 9.2 8.3-9.2c21.8-22.3 57.7-26.2 82.2-5.7c27.1 23.6 28.4 65.6 3.9 90.9z"]]
};
var faLightbulbCflOn = {
  prefix: 'fad',
  iconName: 'lightbulb-cfl-on',
  icon: [640, 512, [], "e5a7", ["M327.8 63l-128 32c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l128-32c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zM479 88.2c4.3 17.1-6.1 34.5-23.3 38.8l-256 64c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3zm0 96c4.3 17.1-6.1 34.5-23.3 38.8L259.9 272l-3.9 1L199.8 287c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3zM256 306l48-12v90H256V306zm223-25.7c4.3 17.1-6.1 34.5-23.3 38.8l-64 16L384 337v47H336V308.7c0-.5 0-.9 0-1.4V304l.2 0c1.6-12.7 10.8-23.7 24-27l16-4 64-16c17.1-4.3 34.5 6.1 38.8 23.3z", "M53.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S42.3-3.3 53.3 4zM613.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM101.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm464-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM224 416c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H352c0 17.7-14.3 32-32 32s-32-14.3-32-32H256c-17.7 0-32-14.3-32-32V416z"]]
};
var faMelon = {
  prefix: 'fad',
  iconName: 'melon',
  icon: [512, 512, [], "e310", ["M256 512c-38.5 0-75-8.5-107.7-23.7c67.1-5.8 149.8-48.2 220.8-119.2s113.4-153.8 119.2-220.8C503.5 181 512 217.5 512 256c0 141.4-114.6 256-256 256zM74.7 436.8c-19.1-19.4-26.8-55.8-11.9-108c14.6-51.2 49.6-110.2 102.7-163.3s112.1-88.1 163.3-102.7c52.4-15 88.9-7.1 108.2 12.2s27.2 55.9 12.2 108.2c-14.6 51.2-49.6 110.2-102.7 163.3s-112.1 88.1-163.3 102.7c-52.1 14.9-88.6 7.2-108-11.9c-.2-.2-.4-.4-.5-.5zm-51-73.1C8.5 331 0 294.5 0 256C0 114.6 114.6 0 256 0c38.5 0 75 8.5 107.7 23.7c-67.1 5.8-149.8 48.2-220.8 119.2s-113.4 153.8-119.2 220.8z", "M363.7 23.7c54.8 25.5 99.2 69.8 124.6 124.6c-5.8 67.1-48.2 149.8-119.2 220.8s-153.8 113.4-220.8 119.2c-27.3-12.7-52-30-73.1-51c19.4 19.1 55.8 26.8 108 11.9c51.2-14.6 110.2-49.6 163.3-102.7s88.1-112.1 102.7-163.3c15-52.4 7.1-88.9-12.2-108.2s-55.9-27.2-108.2-12.2c-51.2 14.6-110.2 49.6-163.3 102.7S77.4 277.6 62.8 328.8c-14.9 52.1-7.2 88.6 11.9 108c-21-21.1-38.4-45.8-51-73.1c5.8-67.1 48.2-149.8 119.2-220.8s153.8-113.4 220.8-119.2z"]]
};
var faGopuram = {
  prefix: 'fad',
  iconName: 'gopuram',
  icon: [512, 512, [], "f664", ["M320 128v96h32V128H320zm64 224V224H352V352h32zm0 0V512h32V352H384zM160 224H128V352H96V512h32V352h32V224zm0 0h32V128H160v96z", "M120 0c13.3 0 24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64v64c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H416V352H384V224H352V128H320v96h32V352h32V512H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H128V352h32V224h32V128H160v96H128V352H96V512H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V256c0-17.7 14.3-32 32-32V160c0-17.7 14.3-32 32-32V64 32 24c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32v48h64V304c0-17.7-14.3-32-32-32zm-32-80v32h64V192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]]
};
var faEarthOceania = {
  prefix: 'fad',
  iconName: 'earth-oceania',
  icon: [512, 512, ["globe-oceania"], "e47b", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z", "M273.8 142.5c-9.5-9.5-23-13.6-36.1-10.9l-38.5 7.7c-15.3 3.1-17.6 24-3.4 30.3l42.8 19c5.1 2.3 10.6 3.4 16.2 3.4h29.9c14.3 0 21.4-17.2 11.3-27.3l-22.2-22.2zM169.6 343.8l39 13.5c2.4 .8 4.7 2 6.9 3.4L240.9 377c7.1 4.6 15.3 7 23.7 7c13.4 0 26.1-6.2 34.4-16.8L311 351.8c5.8-7.4 9-16.6 9-26s-3.2-18.6-9-26l-17.9-22.9c-4.8-6.1-8.7-12.9-11.5-20.2l-10.1-25.9c-1.6-4.1-5.6-6.8-10-6.8c-3.4 0-6.7 1.6-8.7 4.4l-10.4 14.2c-4.7 6.4-12.7 9.5-20.4 7.9c-3.2-.7-6.1-2.5-8.1-5.1l-4.6-6.1c-7.2-9.6-18.6-15.3-30.6-15.3s-23.4 5.7-30.6 15.3l-5.3 7c-1.6 2.1-3.6 3.7-5.9 4.8l-35.3 16.8c-20.5 9.8-28.8 34.6-18.2 54.7l3.3 6.2c9 17.1 29 25.4 47.5 19.5l15.3-4.9c6.6-2.1 13.6-2 20.1 .3zM248 432c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H264c-8.8 0-16 7.2-16 16zM431.2 298.9c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l8 24c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-8-24zm-19.9 80.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"]]
};
var faGlobeOceania = faEarthOceania;
var faContainerStorage = {
  prefix: 'fad',
  iconName: 'container-storage',
  icon: [640, 512, [], "f4b7", ["M608 96H32V416H608V96zM176 152V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faFacePouting = {
  prefix: 'fad',
  iconName: 'face-pouting',
  icon: [512, 512, [], "e387", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM161.3 382.1c-5.4 12.3 8.7 21.6 21.1 16.4c22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4c-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M133.1 176.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32zm256 30.4c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1z"]]
};
var faSquareXmark = {
  prefix: 'fad',
  iconName: 'square-xmark',
  icon: [448, 512, [10062, "times-square", "xmark-square"], "f2d3", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z", "M177 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faTimesSquare = faSquareXmark;
var faXmarkSquare = faSquareXmark;
var faFaceExplode = {
  prefix: 'fad',
  iconName: 'face-explode',
  icon: [512, 512, ["exploding-head"], "e2fe", ["M481.4 265.2L512 253.5c0 .8 0 1.7 0 2.5c0 141.4-114.6 256-256 256S0 397.4 0 256c0-.8 0-1.7 0-2.5l30.5 11.7c14.1 5.4 29.9 3.9 42.7-4.1l20.7-12.9c5.2-3.2 11.8-3.2 17 0L128.2 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c5.2-3.2 11.8-3.2 17 0L230.6 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c5.2-3.2 11.8-3.2 17 0L333 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c5.2-3.2 11.8-3.2 17 0l20.7 12.9c12.8 8 28.6 9.5 42.7 4.1zM176.4 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-123 48c-29.5 0-53.3 23.9-53.3 53.3c0 5.9 4.8 10.7 10.7 10.7H309.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H245.3z", "M320 197.3c0 7.3 2.1 14.3 5.9 20.2c-14.3-6.1-30.8-4.9-44.2 3.5l-17.3 10.8c-5.2 3.2-11.8 3.2-17 0L230.2 221c-13.4-8.4-29.9-9.5-44.2-3.5c3.8-6 5.9-13 5.9-20.2V192c0-17.7-14.3-32-32-32H120c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8c7.5-3.7 15.9-5.8 24.8-5.8c30.9 0 56 25.1 56 56s-25.1 56-56 56H352c-17.7 0-32 14.3-32 32v5.3zM144.4 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faExplodingHead = faFaceExplode;
var faHashtag = {
  prefix: 'fad',
  iconName: 'hashtag',
  icon: [448, 512, [62098], "23", ["M207.6 69.3c2.9-17.4-8.9-33.9-26.3-36.8s-33.9 8.9-36.8 26.3L132.9 128h64.9l9.8-58.7zM187.1 192H122.2L80.4 442.7c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3L187.1 192zM367.6 69.3c2.9-17.4-8.9-33.9-26.3-36.8s-33.9 8.9-36.8 26.3L260.9 320h64.9L367.6 69.3zM315.1 384H250.2l-9.8 58.7c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3L315.1 384z", "M292.9 128H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H282.2l10.7-64zm54.2 64H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.8l-10.7 64zm-192 192H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H165.8l-10.7 64zm-54.2-64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H90.2l10.7-64z"]]
};
var faUpRightAndDownLeftFromCenter = {
  prefix: 'fad',
  iconName: 'up-right-and-down-left-from-center',
  icon: [512, 512, ["expand-alt"], "f424", ["M24 512H168c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-39-39 87-87c9.4-9.4 9.4-24.6 0-33.9l-32-32c-9.4-9.4-24.6-9.4-33.9 0l-87 87L41 327c-6.9-6.9-17.2-8.9-26.2-5.2S0 334.3 0 344V488c0 13.3 10.7 24 24 24z", "M488 0H344c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-87 87c-9.4 9.4-9.4 24.6 0 33.9l32 32c9.4 9.4 24.6 9.4 33.9 0l87-87 39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24z"]]
};
var faExpandAlt = faUpRightAndDownLeftFromCenter;
var faOilCan = {
  prefix: 'fad',
  iconName: 'oil-can',
  icon: [640, 512, [], "f613", ["M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32h64V128h32z", "M368.9 160c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48V346.7l-67.5-30C11.2 309 0 291.8 0 272.8V208c0-26.5 21.5-48 48-48H96h48H368.9zM96 208H48v64.8l48 21.3V208z"]]
};
var faT = {
  prefix: 'fad',
  iconName: 't',
  icon: [384, 512, [116], "54", ["M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z", ""]]
};
var faTransformerBolt = {
  prefix: 'fad',
  iconName: 'transformer-bolt',
  icon: [384, 512, [], "e2a4", ["M136 24c0-13.3-10.7-24-24-24S88 10.7 88 24v8H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H136V24zm160 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H296V24zM48 112c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm31.2 133.1c2.3-6.8-.3-14.3-6.3-18.3s-13.9-3.6-19.3 1.1l-112 96c-5.1 4.4-6.9 11.4-4.6 17.7s8.3 10.4 15 10.4h57.8l-25 74.9c-2.3 6.8 .3 14.3 6.3 18.3s13.9 3.6 19.3-1.1l112-96c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4H214.2l25-74.9z", "M0 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V224c-17.7 0-32-14.3-32-32zm232.9 34.7c-6-4-13.9-3.6-19.3 1.1l-112 96c-5.1 4.4-6.9 11.4-4.6 17.7s8.3 10.4 15 10.4h57.8l-25 74.9c-2.3 6.8 .3 14.3 6.3 18.3s13.9 3.6 19.3-1.1l112-96c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4H214.2l25-74.9c2.3-6.8-.3-14.3-6.3-18.3z"]]
};
var faHippo = {
  prefix: 'fad',
  iconName: 'hippo',
  icon: [640, 512, [129435], "f6ed", ["M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 44.2-35.8 80-80 80H432c-18 0-34.6-6-48-16c-1-.7-1.9-1.5-2.9-2.3C363.3 287.1 352 264.9 352 240c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V372c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h7.2H256h32c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z", "M480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 176H544v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V304c-13.4 10-30 16-48 16zm-128 0c-5.5 0-10.8-.6-16-1.6V336c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320H432z"]]
};
var faChartColumn = {
  prefix: 'fad',
  iconName: 'chart-column',
  icon: [512, 512, [], "e0e3", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M480 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM288 160c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V256zm160-64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32z"]]
};
var faCassetteVhs = {
  prefix: 'fad',
  iconName: 'cassette-vhs',
  icon: [576, 512, [128252, "vhs"], "f8ec", ["M576 128H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128zM108.1 384C90.5 362.1 80 334.3 80 304s10.5-58.1 28.1-80H160V384H108.1zm359.9 0H416V224h51.9c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80zM256 224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32z", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64v32H0V96zM160 384H108.1C90.5 362.1 80 334.3 80 304s10.5-58.1 28.1-80H160v34.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3V384zm307.9 0H416V349.3c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3V224h51.9c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80z"]]
};
var faVhs = faCassetteVhs;
var faInfinity = {
  prefix: 'fad',
  iconName: 'infinity',
  icon: [640, 512, [8734, 9854], "f534", ["M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z", ""]]
};
var faVialCircleCheck = {
  prefix: 'fad',
  iconName: 'vial-circle-check',
  icon: [512, 512, [], "e596", ["M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V384c0 53 43 96 96 96c32.6 0 61.5-16.3 78.8-41.2C197.3 417.1 192 393.2 192 368c0-37.7 11.8-72.6 32-101.2V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32zM160 96v96H96V96h64z", "M368 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L352 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faChimney = {
  prefix: 'fad',
  iconName: 'chimney',
  icon: [448, 512, [], "f78b", ["M128 192H32V320h96V192zm288 0H160V320H416V192zM288 352H32V480H288V352zm128 0H320V480h96V352z", "M32 32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32z"]]
};
var faObjectIntersect = {
  prefix: 'fad',
  iconName: 'object-intersect',
  icon: [512, 512, [], "e49d", ["M64 64H288v96h64v64h96V448H224V352H160V288H64V64zm96 288v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H352V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h96z", "M160 224c0-35.3 28.7-64 64-64H352V288c0 35.3-28.7 64-64 64H160V224z"]]
};
var faPersonArrowDownToLine = {
  prefix: 'fad',
  iconName: 'person-arrow-down-to-line',
  icon: [640, 512, [], "e538", ["M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96h64V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448h64z", "M496 32c-17.7 0-32 14.3-32 32l0 242.7-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7 528 64c0-17.7-14.3-32-32-32zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]]
};
var faVoicemail = {
  prefix: 'fad',
  iconName: 'voicemail',
  icon: [640, 512, [], "f897", ["M144 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]]
};
var faBlockBrick = {
  prefix: 'fad',
  iconName: 'block-brick',
  icon: [448, 512, ["wall-brick"], "e3db", ["M96 32v80H352V32H96zM64 112V32C28.7 32 0 60.7 0 96v16H64zM0 144v96H208V144H0zM0 368H64V272H0v96zm0 32v16c0 35.3 28.7 64 64 64H208V400H0zm240 0v80H384c35.3 0 64-28.7 64-64V400H240zm208-32V272H384v96h64zm-96 0V272H96v96H352zm96-224H240v96H448V144zm0-32V96c0-35.3-28.7-64-64-64v80h64z", "M64 112H0v32H208v96H0v32H64v96H0v32H208v80h32V400H448V368H384V272h64V240H240V144H448V112H384V32H352v80H96V32H64v80zM352 368H96V272H352v96z"]]
};
var faWallBrick = faBlockBrick;
var faFan = {
  prefix: 'fad',
  iconName: 'fan',
  icon: [512, 512, [], "f863", ["M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M256 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]]
};
var faBagsShopping = {
  prefix: 'fad',
  iconName: 'bags-shopping',
  icon: [576, 512, [128717], "f847", ["M224 48c-26.5 0-48 21.5-48 48v64h96V96c0-26.5-21.5-48-48-48zM64 160h64V96c0-53 43-96 96-96s96 43 96 96v64h64c35.3 0 64 28.7 64 64H240c-44.2 0-80 35.8-80 80V464c0 5.5 .6 10.8 1.6 16H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64zM320 336v16c0 35.3 28.7 64 64 64s64-28.7 64-64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 53-43 96-96 96s-96-43-96-96V336c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M256 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H256zm64 80v16c0 35.3 28.7 64 64 64s64-28.7 64-64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 53-43 96-96 96s-96-43-96-96V336c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faParagraphLeft = {
  prefix: 'fad',
  iconName: 'paragraph-left',
  icon: [384, 512, ["paragraph-rtl"], "f878", ["M144 0h16H320c17.7 0 32 14.3 32 32s-14.3 32-32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224H224l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64H144C82.1 224 32 173.9 32 112S82.1 0 144 0z", "M128 384V337.6c0-9.7-7.9-17.6-17.6-17.6c-4.2 0-8.2 1.5-11.3 4.2l-93 78.7C2.2 406.1 0 410.9 0 416s2.2 9.9 6.1 13.2l93 78.7c3.2 2.7 7.2 4.2 11.3 4.2c9.7 0 17.6-7.9 17.6-17.6V448H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z"]]
};
var faParagraphRtl = faParagraphLeft;
var faPersonWalkingLuggage = {
  prefix: 'fad',
  iconName: 'person-walking-luggage',
  icon: [576, 512, [], "e554", ["M261.9 296c4.4-7.7 1.8-17.4-5.9-21.9s-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296z", "M384 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM350.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L505 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L471 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM292.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L292.7 398z"]]
};
var faCaravanSimple = {
  prefix: 'fad',
  iconName: 'caravan-simple',
  icon: [640, 512, ["caravan-alt"], "e000", ["M64 160v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm256 0v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zM192 512a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M80 32C35.8 32 0 67.8 0 112V336c0 44.2 35.8 80 80 80h1.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H576l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V192c0-88.4-71.6-160-160-160H80zM64 160c0-17.7 14.3-32 32-32H224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160zm288-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32z"]]
};
var faCaravanAlt = faCaravanSimple;
var faTurtle = {
  prefix: 'fad',
  iconName: 'turtle',
  icon: [576, 512, [128034], "f726", ["M474.1 287.7c1.9 .2 3.9 .3 5.9 .3h32c35.3 0 64-28.7 64-64V208c0-53-43-96-96-96c-35.3 0-64 28.7-64 64v16 32 24c0 39.8-32.2 72-72 72H312 264 152 104 32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v56c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V384h32v56c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V383.8c57.8-3.4 105.9-42.8 122.1-96zM496 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z", "M384 249.2V208c0-97.2-78.8-176-176-176S32 110.8 32 208v41.2C32 270.6 49.4 288 70.8 288H345.2c21.4 0 38.8-17.4 38.8-38.8z"]]
};
var faPencilMechanical = {
  prefix: 'fad',
  iconName: 'pencil-mechanical',
  icon: [512, 512, [], "e5ca", ["M500.7 36.7L475.3 11.3C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3L365.5 66.5c5.1 1.9 9.8 4.9 13.8 8.9l57.4 57.4c3.9 3.9 6.9 8.6 8.9 13.8l55.1-55.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3z", "M253.7 87.6c-3.1-3.1-8.2-3.1-11.3 0L137 193c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L208.4 53.7c21.9-21.9 57.3-21.9 79.2 0L317 83l7.7-7.7C331.9 68.1 341.8 64 352 64s20.1 4.1 27.3 11.3l57.4 57.4c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L184.8 439.2c-5.8 5.8-12.9 10-20.8 12.2L66.7 479.2 41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l25.7-25.7L60.6 348c2.2-7.8 6.4-15 12.2-20.8L283 117 253.7 87.6zM106.4 362.4L89.1 422.9l60.5-17.3-43.2-43.2z"]]
};
var faUpDown = {
  prefix: 'fad',
  iconName: 'up-down',
  icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", ["M128 512c6.7 0 13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V256H80v96H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7z", "M128 0c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H176v96H80V160H24c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112C115 2.8 121.3 0 128 0z"]]
};
var faArrowsAltV = faUpDown;
var faCloudMoonRain = {
  prefix: 'fad',
  iconName: 'cloud-moon-rain',
  icon: [576, 512, [], "f73c", ["M353.6 107.6C363.5 46.5 417 0 481.2 0c3.7 0 7.3 .2 10.9 .5c7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-26.9 15.1-44.9 43.6-44.9 76.1c0 48.1 39.4 87.4 88.4 87.4c5.2 0 10.3-.4 15.2-1.3c6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-23.3 22.4-55 36.1-89.9 36.1c-4.1 0-8.2-.2-12.3-.6c-11.1-23.1-29.9-41.8-53.1-52.7c-1.9-41.7-26.7-77.5-62.1-95.1zM92.1 453.4l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3zm96 0l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3zm96 0l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3zm96 0l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3z", "M367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H367.9z"]]
};
var faBoothCurtain = {
  prefix: 'fad',
  iconName: 'booth-curtain',
  icon: [512, 512, [], "f734", ["M0 64C0 28.7 28.7 0 64 0h96V64L64 64V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zM448 0c35.3 0 64 28.7 64 64V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V64 0z", "M160 0h96 96 96V400c0 26.5-21.5 48-48 48s-48-21.5-48-48c0 26.5-21.5 48-48 48s-48-21.5-48-48c0 26.5-21.5 48-48 48s-48-21.5-48-48V0z"]]
};
var faCalendar = {
  prefix: 'fad',
  iconName: 'calendar',
  icon: [448, 512, [128197, 128198], "f133", ["M0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192z", "M160 32c0-17.7-14.3-32-32-32S96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32z"]]
};
var faBoxHeart = {
  prefix: 'fad',
  iconName: 'box-heart',
  icon: [448, 512, [], "f49d", ["M93.7 32C75.5 32 58.9 42.3 50.7 58.5L0 160H208V32H93.7zM240 32V160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240z", "M448 160H240V32H208V160H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V160zM212.7 404.7l-77.3-77.3c-20.5-20.5-20.5-53.8 0-74.3s53.8-20.5 74.3 0L224 267.4l14.3-14.3c20.5-20.5 53.8-20.5 74.3 0s20.5 53.8 0 74.3l-77.3 77.3c-6.2 6.2-16.4 6.2-22.6 0z"]]
};
var faTrailer = {
  prefix: 'fad',
  iconName: 'trailer',
  icon: [640, 512, [], "e041", ["M80 96c-8.8 0-16 7.2-16 16V264.2c9.8-8.1 20.6-15.2 32-21L96 112c0-8.8-7.2-16-16-16zm96 128c5.4 0 10.7 .2 16 .7L192 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112.7c5.3-.5 10.6-.7 16-.7zm80 19.2c11.4 5.9 22.2 12.9 32 21L288 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 131.2zM368 96c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16zm112 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160z", "M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faUserDoctorMessage = {
  prefix: 'fad',
  iconName: 'user-doctor-message',
  icon: [640, 512, ["user-md-chat"], "f82e", ["M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z", "M384 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H544l-83.2 62.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2V224H432c-26.5 0-48-21.5-48-48V48z"]]
};
var faUserMdChat = faUserDoctorMessage;
var faBahai = {
  prefix: 'fad',
  iconName: 'bahai',
  icon: [576, 512, ["haykal"], "f666", ["M288 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z", "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"]]
};
var faHaykal = faBahai;
var faAmpGuitar = {
  prefix: 'fad',
  iconName: 'amp-guitar',
  icon: [512, 512, [], "f8a1", ["M134.4 53.8C163.5 28.8 207.1 0 256 0s92.5 28.8 121.6 53.8c15 12.9 27.3 25.7 35.8 35.3c2.3 2.6 4.3 4.9 6 6.9H352.9c-2.1-1.9-4.3-3.8-6.5-5.8C319.5 67.2 287.1 48 256 48s-63.5 19.2-90.4 42.2c-2.3 1.9-4.4 3.9-6.5 5.8H92.5c1.7-2.1 3.7-4.4 6-6.9c8.5-9.6 20.8-22.4 35.8-35.3zM112 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM368 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z", "M64 96C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm32 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 80V448H64V256H448z"]]
};
var faSdCard = {
  prefix: 'fad',
  iconName: 'sd-card',
  icon: [384, 512, [], "f7c2", ["M160 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V88zm80 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V88zm80 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V88z", "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"]]
};
var faVolumeSlash = {
  prefix: 'fad',
  iconName: 'volume-slash',
  icon: [640, 512, [128263], "f2e2", ["M82.9 161.3L352 373.3V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L163.8 352H96c-35.3 0-64-28.7-64-64V224c0-30.9 21.8-56.6 50.9-62.7zM410.8 296.7c1-1.2 2.2-2.4 3.4-3.4C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5C466.1 199.1 480 225.9 480 256c0 27.9-12 53.1-31 70.6l-38.2-29.9zm76.3 59.8c25.3-26 40.9-61.4 40.9-100.5c0-45.1-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5c43.2 35.2 70.9 88.9 70.9 149c0 50.3-19.3 96-50.9 130.2l-37.9-29.7zM197.8 129.8L298.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3S352 51.4 352 64V250.6L197.8 129.8z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faBorderBottom = {
  prefix: 'fad',
  iconName: 'border-bottom',
  icon: [448, 512, [], "f84d", ["M384 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 352a32 32 0 1 0 64 0A32 32 0 1 0 0 352zm256 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 160A32 32 0 1 0 0 160a32 32 0 1 0 64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm256 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm256 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 64A32 32 0 1 0 0 64a32 32 0 1 0 64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM96 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z", "M448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"]]
};
var faWifiWeak = {
  prefix: 'fad',
  iconName: 'wifi-weak',
  icon: [640, 512, ["wifi-1"], "f6aa", ["M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM171.8 312c39.5-34.9 91.3-56 148.2-56s108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8z", "M256 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]]
};
var faWifi1 = faWifiWeak;
var faDragon = {
  prefix: 'fad',
  iconName: 'dragon',
  icon: [640, 512, [128009], "f6d5", ["M130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1L352 220.8V227c0 33.6 10.6 66.1 29.8 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z", "M300.1 111.5l51.9 13v57V227c0 42.4 16.9 83.1 46.9 113.1l44.4 44.4c3 3 4.7 7.1 4.7 11.4c0 8.4-6.4 15.4-14.7 16.1L29.5 448.1c-3.3 .3-6.6 1-9.5 2.2C11 454 4.2 461.5 1.4 470.7c-1 3.4-1.5 7-1.3 10.7c.2 3.8 1 7.3 2.3 10.7c3.6 9 11.2 15.8 20.4 18.6c3 .9 6.3 1.4 9.6 1.4H432h64 34.2C590.9 512 640 462.9 640 402.2c0-37.8-19.5-73-51.6-93.1L481.8 242.5c-21.1-13.2-33.8-36.2-33.8-61.1V160h32l13.3 13.3c12 12 28.3 18.7 45.3 18.7H560c26.5 0 48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L540.8 38.4C522.7 14.2 494.2 0 464 0H448 416 304c-6.9 0-13 4.4-15.2 10.9s.1 13.7 5.6 17.9l43.3 32.5L296.8 81.7c-6 3-9.5 9.4-8.7 16.1s5.5 12.2 12 13.8zM510.7 79.7C507.5 89.2 498.6 96 488 96c-13.3 0-24-10.7-24-24c0-1.3 .1-2.6 .3-3.9l46.4 11.6zm1.3-7.4v-.6c0 .1 0 .2 0 .3s0 .2 0 .3z"]]
};
var faShoePrints = {
  prefix: 'fad',
  iconName: 'shoe-prints',
  icon: [640, 512, [], "f54b", ["M128 480s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32V480zm-64 0H96V352H64c-35.3 0-64 28.7-64 64s28.7 64 64 64z", "M256 32s96.3-32 160-32c96 0 224 48 224 128s-119.6 96-176 96c-48 0-76-16-104-32s-56-32-104-32V32zm-64 0h32V160H192c-35.3 0-64-28.7-64-64s28.7-64 64-64z"]]
};
var faCirclePlus = {
  prefix: 'fad',
  iconName: 'circle-plus',
  icon: [512, 512, ["plus-circle"], "f055", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M232 280v64c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faPlusCircle = faCirclePlus;
var faFaceGrinTongueWink = {
  prefix: 'fad',
  iconName: 'face-grin-tongue-wink',
  icon: [512, 512, [128540, "grin-tongue-wink"], "f58b", ["M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128z", "M336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM195.2 233.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM320 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6z"]]
};
var faGrinTongueWink = faFaceGrinTongueWink;
var faHandHolding = {
  prefix: 'fad',
  iconName: 'hand-holding',
  icon: [576, 512, [], "f4bd", ["M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z", ""]]
};
var faPlugCircleExclamation = {
  prefix: 'fad',
  iconName: 'plug-circle-exclamation',
  icon: [576, 512, [], "e55d", ["M128 32v96H64V32C64 14.3 78.3 0 96 0s32 14.3 32 32zm192 0v96H256V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V412.8C87 398 32 333.4 32 256V224c-17.7 0-32-14.3-32-32z", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faLinkSlash = {
  prefix: 'fad',
  iconName: 'link-slash',
  icon: [640, 512, ["chain-broken", "chain-slash", "unlink"], "f127", ["M220.9 270L406.6 416.4C357.4 431 301.9 418.9 263 380c-29.9-29.9-44.3-70.2-42.2-110zM116.6 187.9l50.6 39.9-61.8 61.8C74 321 74 372 105.5 403.5c27.9 27.9 71.8 31.5 103.8 8.6l1.6-1.1c14.4-10.3 34.4-6.9 44.6 7.4s6.9 34.4-7.4 44.6l-1.6 1.1C189 505.3 110.2 498.7 60.2 448.8c-56.5-56.5-56.5-148 0-204.5l56.4-56.4zm215.1-10.6C306.6 152.1 269.1 147 239 162l-53.2-41.7C242.5 75.8 324.7 79.7 377 132c43.1 43.1 53.9 107.6 29.7 161.5l-53.2-41.7c5.8-26.2-1.7-54.5-21.7-74.5zm248 90.5l-90.5 90.5-50.7-39.8 96-96c31.5-31.5 31.5-82.5 0-114C506.7 80.6 462.7 77 430.7 99.9l-1.6 1.1c-14.4 10.3-34.4 6.9-44.6-7.4s-6.9-34.4 7.4-44.6l1.6-1.1C451 6.7 529.8 13.3 579.8 63.2c56.5 56.5 56.5 148 0 204.5z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faChainBroken = faLinkSlash;
var faChainSlash = faLinkSlash;
var faUnlink = faLinkSlash;
var faClone = {
  prefix: 'fad',
  iconName: 'clone',
  icon: [512, 512, [], "f24d", ["M288 448H64V224h96V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V352H288v96z", "M160 288c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288z"]]
};
var faPersonWalkingArrowLoopLeft = {
  prefix: 'fad',
  iconName: 'person-walking-arrow-loop-left',
  icon: [640, 512, [], "e551", ["", "M486.6 454.6c-12.5 12.5-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L461.3 320H480c53 0 96-43 96-96s-43-96-96-96l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c88.4 0 160 71.6 160 160s-71.6 160-160 160H461.3l25.4 25.4c12.5 12.5 12.5 32.8 0 45.3zM160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"]]
};
var faArrowUpZA = {
  prefix: 'fad',
  iconName: 'arrow-up-z-a',
  icon: [576, 512, ["sort-alpha-up-alt"], "f882", ["M352 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352zm64 160c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z"]]
};
var faSortAlphaUpAlt = faArrowUpZA;
var faFireFlameCurved = {
  prefix: 'fad',
  iconName: 'fire-flame-curved',
  icon: [384, 512, ["fire-alt"], "f7e4", ["M169.6 8.5l-16 21.3C137 52 128 79.1 128 106.8c0 33.9 13.5 66.7 37.5 90.7l38.6 38.6c12.7 12.7 19.9 30 19.9 48V288c0 35.3-28.7 64-64 64s-64-28.7-64-64V198.6C96 186.1 85.9 176 73.4 176c-6 0-11.8 2.4-16 6.6l-3.5 3.5C19.4 220.6 0 267.4 0 316.2V320C0 426 86 512 192 512h17.7C306 512 384 434 384 337.7c0-67.5-27.6-132-76.4-178.6L222.9 78.2C213.4 69.1 208 56.6 208 43.5V21.3C208 9.6 198.4 0 186.7 0c-6.7 0-13 3.2-17.1 8.5zM118.3 424.7c-7.3-5.1 .2-14.6 8.8-12.1c97.6 27.5 182.5-86.7 148.5-179.8c-1.9-5.3 5.3-11 8.8-6.6c25.9 32 35.6 69.8 35.6 111.6C320 398.6 270.6 448 209.7 448H192c-27.4 0-52.8-8.6-73.7-23.3z", "M127.1 412.6c-8.6-2.4-16.1 7-8.8 12.1C139.2 439.4 164.6 448 192 448h17.7C270.6 448 320 398.6 320 337.7c0-41.8-9.7-79.6-35.6-111.6c-3.6-4.4-10.8 1.4-8.8 6.6c34 93.1-50.9 207.4-148.5 179.8z"]]
};
var faFireAlt = faFireFlameCurved;
var faTornado = {
  prefix: 'fad',
  iconName: 'tornado',
  icon: [448, 512, [127786], "f76f", ["M0 32V45.6C0 62.7 1.7 79.6 5 96H357.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z", "M13.6 128C10.1 117.6 7.2 106.9 5 96H357.8c-3.8 8.3-5.8 17.3-5.8 26.6c0 1.8 .1 3.6 .2 5.4H13.6zm96.6 128c-13.7-9.5-26.3-20.2-37.8-32H412l6 8c5.7 7.5 10.6 15.6 14.7 24H110.2zM288 384c-.2-.5-.5-1-.7-1.5c-5.7-11.4-13.2-21.7-22.1-30.5H445c-2.3 11-5.8 21.8-10.4 32H288z"]]
};
var faFileCirclePlus = {
  prefix: 'fad',
  iconName: 'file-circle-plus',
  icon: [576, 512, [58606], "e494", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faDeleteRight = {
  prefix: 'fad',
  iconName: 'delete-right',
  icon: [576, 512, [], "e154", ["M0 128C0 92.7 28.7 64 64 64H370.7c17 0 33.3 6.7 45.3 18.7L566.6 233.4c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6L416 429.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V128zm143 47c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z", "M177 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faBookQuran = {
  prefix: 'fad',
  iconName: 'book-quran',
  icon: [448, 512, ["quran"], "f687", ["M384 416c0-17.7-14.3-32-32-32H32v64H352c17.7 0 32-14.3 32-32z", "M448 96c0-53-43-96-96-96H64 32C14.3 0 0 14.3 0 32V352c0 17.7 14.3 32 32 32H96h96H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 96 32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 352c53 0 96-43 96-96V96zM274.1 150.2c2.2-5.3 9.6-5.3 11.8 0l8.9 21.4 23.1 1.9c5.7 .5 8 7.5 3.7 11.2L304 199.8l5.4 22.6c1.3 5.5-4.7 9.9-9.6 6.9L280 217.2l-19.8 12.1c-4.9 3-10.9-1.4-9.6-6.9l5.4-22.6-17.6-15.1c-4.3-3.7-2-10.8 3.7-11.2l23.1-1.9 8.9-21.4zM96 192c0-70.7 57.3-128 128-128c25.6 0 49.5 7.5 69.5 20.5c3.2 2.1 4.5 6.2 3.1 9.7s-5.2 5.6-9 4.8c-6.1-1.2-12.5-1.9-19-1.9c-52.4 0-94.9 42.5-94.9 94.9s42.5 94.9 94.9 94.9c6.5 0 12.8-.7 19-1.9c3.8-.8 7.5 1.3 9 4.8s.2 7.6-3.1 9.7c-20 13-43.9 20.5-69.5 20.5c-70.7 0-128-57.3-128-128z"]]
};
var faQuran = faBookQuran;
var faCircleQuarter = {
  prefix: 'fad',
  iconName: 'circle-quarter',
  icon: [512, 512, [], "e11f", ["M256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256H256V0z", "M0 256C0 114.6 114.6 0 256 0V256H0z"]]
};
var faAnchor = {
  prefix: 'fad',
  iconName: 'anchor',
  icon: [576, 512, [9875], "f13d", ["M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-53 0-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1C367 158.8 384 129.4 384 96c0-53-43-96-96-96z", "M256 448V240h64V448h48c53 0 96-43 96-96v-6.1l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56-56c9.4-9.4 24.6-9.4 33.9 0l56 56c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7V352c0 88.4-71.6 160-160 160H288 208c-88.4 0-160-71.6-160-160v-6.1l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56-56c9.4-9.4 24.6-9.4 33.9 0l56 56c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7V352c0 53 43 96 96 96h48z"]]
};
var faBorderAll = {
  prefix: 'fad',
  iconName: 'border-all',
  icon: [448, 512, [], "f84c", ["M192 288V432h64V288H400V224H256V80H192V224H48v64H192z", "M384 96V416H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]]
};
var faFunction = {
  prefix: 'fad',
  iconName: 'function',
  icon: [640, 512, [], "f661", ["M330.7 177.7C303.7 218.4 288 267.3 288 320s15.7 101.6 42.7 142.3c9.8 14.7 5.7 34.6-9 44.3s-34.6 5.7-44.3-9C243.6 446.7 224 385.6 224 320s19.6-126.7 53.3-177.7c9.8-14.7 29.6-18.8 44.3-9s18.8 29.6 9 44.3zm202.6 0c-9.8-14.7-5.7-34.6 9-44.3s34.6-5.7 44.3 9C620.4 193.3 640 254.4 640 320s-19.6 126.7-53.3 177.7c-9.8 14.7-29.6 18.8-44.3 9s-18.8-29.6-9-44.3c27-40.7 42.7-89.6 42.7-142.3s-15.7-101.6-42.7-142.3z", "M160 0C107 0 64 43 64 96v96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V383.5c0 16.1-12 29.8-28 31.8l-7.9 1C10.5 418.4-1.9 434.4 .3 452s18.2 30 35.7 27.8l7.9-1c48-6 84.1-46.8 84.1-95.3V256h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V96c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zM398.6 241.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L386.7 320l-33.4 33.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L432 365.3l33.4 33.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L477.3 320l33.4-33.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L432 274.7l-33.4-33.4z"]]
};
var faFaceAngry = {
  prefix: 'fad',
  iconName: 'face-angry',
  icon: [512, 512, [128544, "angry"], "f556", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM338.7 395.9c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M133.1 176.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32zm256 30.4c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1z"]]
};
var faAngry = faFaceAngry;
var faPeopleSimple = {
  prefix: 'fad',
  iconName: 'people-simple',
  icon: [512, 512, [], "e21b", ["M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm256 0A64 64 0 1 0 384 0a64 64 0 1 0 0 128z", "M25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zm280.9-26.9c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V384H298.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"]]
};
var faCookieBite = {
  prefix: 'fad',
  iconName: 'cookie-bite',
  icon: [512, 512, [], "f564", ["M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faArrowTrendDown = {
  prefix: 'fad',
  iconName: 'arrow-trend-down',
  icon: [576, 512, [], "e097", ["M466.7 352L320 205.3 214.6 310.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 242.7 297.4 137.4c12.5-12.5 32.8-12.5 45.3 0L512 306.7V352H466.7z", "M352 384c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32V352H384c-17.7 0-32 14.3-32 32z"]]
};
var faRss = {
  prefix: 'fad',
  iconName: 'rss',
  icon: [448, 512, ["feed"], "f09e", ["M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96c194.4 0 352 157.6 352 352c0 17.7 14.3 32 32 32s32-14.3 32-32C448 218.2 261.8 32 32 32zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-159.1-128.9-288-288-288z", "M0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416z"]]
};
var faFeed = faRss;
var faFaceMonocle = {
  prefix: 'fad',
  iconName: 'face-monocle',
  icon: [512, 512, [], "e380", ["M427.2 446.3C381.9 487.2 321.8 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 62.8-22.6 120.3-60.1 164.9c-2.5-8.6-3.9-17.7-3.9-26.9V224c0-61.9-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6v91.5c0 18.4 3.9 36.2 11.2 52.4zM176.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM144 352c0 8.8 7.2 16 16 16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59C205.3 339.5 177.7 336 160 336c-8.8 0-16 7.2-16 16zM305.2 89.9c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L376.3 61c-12.7-8.5-27.6-13-42.8-13c-17.5 0-34.5 6-48.2 16.9L262 83.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6z", "M305.2 89.9L282 108.5c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l23.2-18.6C298.9 54 315.9 48 333.5 48c15.2 0 30.1 4.5 42.8 13l8.6 5.7c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-8.6-5.7c-7.4-5-16.2-7.6-25.1-7.6c-10.3 0-20.2 3.5-28.2 9.9zM416 224a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm0 169.9V302.4c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112V393.9c0 33.1 17.1 63.9 45.1 81.4l11.4 7.1c7.5 4.7 9.8 14.6 5.1 22s-14.6 9.8-22 5.1l-11.4-7.1C438.7 479.1 416 438.1 416 393.9zM112.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
};
var faDrawPolygon = {
  prefix: 'fad',
  iconName: 'draw-polygon',
  icon: [448, 512, [], "f5ee", ["M128 96c0 11.7-3.1 22.6-8.6 32H328.6c-5.4-9.4-8.6-20.3-8.6-32s3.1-22.6 8.6-32H119.4c5.4 9.4 8.6 20.3 8.6 32zM96 360.6V151.4c-9.4 5.4-20.3 8.6-32 8.6s-22.6-3.1-32-8.6V360.6c9.4-5.4 20.3-8.6 32-8.6s22.6 3.1 32 8.6zM119.4 448H328.6c-5.4-9.4-8.6-20.3-8.6-32s3.1-22.6 8.6-32H119.4c5.4 9.4 8.6 20.3 8.6 32s-3.1 22.6-8.6 32zM384 352l.3 0-4.5-7.9-32-56-2.3-4c-9.8 20.1-29.8 34.2-53.3 35.7l0 0 32 56 4.5 7.9c11.1-19 31.7-31.7 55.3-31.7zM292.2 192.1c23.5 1.5 43.5 15.7 53.3 35.7l2.3-4 32-56 4.5-7.9-.3 0c-23.6 0-44.2-12.8-55.3-31.7l-4.5 7.9-32 56 0 0z", "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zm320 0a64 64 0 1 1 128 0A64 64 0 1 1 320 96zM64 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM288 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]]
};
var faScaleBalanced = {
  prefix: 'fad',
  iconName: 'scale-balanced',
  icon: [640, 512, [9878, "balance-scale"], "f24e", ["M384 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32z", "M126.8 195.8L199.3 320H54.4l72.4-124.2zM.9 337.1C11.7 382 64 416 126.8 416s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L150.9 141.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L7.6 305.1c-5.7 9.8-9.3 21.1-6.7 32.1zM512 195.8L584.4 320H439.6L512 195.8zM386 337.1C396.8 382 449.1 416 512 416s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 141.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 305.1c-5.7 9.8-9.3 21.1-6.7 32.1z"]]
};
var faBalanceScale = faScaleBalanced;
var faCalendarLines = {
  prefix: 'fad',
  iconName: 'calendar-lines',
  icon: [448, 512, ["calendar-note"], "e0d5", ["M0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM96 296c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z", "M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v80H0V112C0 85.5 21.5 64 48 64H96V32zm0 264c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm24 72H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]]
};
var faCalendarNote = faCalendarLines;
var faArrowDownBigSmall = {
  prefix: 'fad',
  iconName: 'arrow-down-big-small',
  icon: [576, 512, ["sort-size-down"], "f88c", ["M368 32c-26.5 0-48 21.5-48 48V208c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368zm0 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H368z", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z"]]
};
var faSortSizeDown = faArrowDownBigSmall;
var faGaugeSimpleHigh = {
  prefix: 'fad',
  iconName: 'gauge-simple-high',
  icon: [512, 512, [61668, "tachometer", "tachometer-fast"], "f62a", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm192 96c0-35.3 28.7-64 64-64c2.1 0 4.1 .1 6.1 .3l76.6-147.4c6.1-11.8 20.6-16.3 32.4-10.2s16.3 20.6 10.2 32.4L304.7 310.4c9.6 11.2 15.3 25.7 15.3 41.6c0 35.3-28.7 64-64 64s-64-28.7-64-64z", "M338.7 140.9c6.1-11.8 20.6-16.3 32.4-10.2s16.3 20.6 10.2 32.4L304.7 310.4c9.6 11.2 15.3 25.7 15.3 41.6c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c2.1 0 4.1 .1 6.1 .3l76.6-147.4z"]]
};
var faTachometer = faGaugeSimpleHigh;
var faTachometerFast = faGaugeSimpleHigh;
var faDoNotEnter = {
  prefix: 'fad',
  iconName: 'do-not-enter',
  icon: [512, 512, [], "f5ec", ["M80 224c0-8.8 7.2-16 16-16H416c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V224z", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96 208H416c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16z"]]
};
var faShower = {
  prefix: 'fad',
  iconName: 'shower',
  icon: [512, 512, [128703], "f2cc", ["M384 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-32 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M99.9 96C80.1 96 64 112.1 64 131.9V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V131.9C0 76.7 44.7 32 99.9 32c26.5 0 51.9 10.5 70.6 29.3l16.2 16.2c38.9-21 87.5-17.4 123 10.9L311 87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L185 281c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l1.3-1.3c-28.3-35.5-31.9-84.2-10.9-123l-16.2-16.2C118.5 99.8 109.4 96 99.9 96z"]]
};
var faDiceD8 = {
  prefix: 'fad',
  iconName: 'dice-d8',
  icon: [512, 512, [], "f6d2", ["M230 1.2C236 3.6 240 9.5 240 16V312c0 5.3-2.6 10.2-6.9 13.2s-9.9 3.6-14.8 1.7l-208-80c-5-1.9-8.7-6.2-9.9-11.5s.4-10.7 4.1-14.6l208-216C217 .2 223.9-1.3 230 1.2zm52 0c6.1-2.4 13-1 17.5 3.7l208 216c3.7 3.9 5.3 9.3 4.1 14.6s-4.9 9.5-9.9 11.5l-208 80c-4.9 1.9-10.5 1.2-14.8-1.7s-6.9-7.9-6.9-13.2V16c0-6.5 4-12.4 10-14.8z", "M34.6 307.5c-4.1 6.3-3.3 14.6 1.9 20l176 179.7c4.5 4.6 11.5 6.1 17.5 3.6s10-8.3 10-14.8V384c0-6.6-4.1-12.6-10.3-14.9l-176-67.7c-7-2.7-15-.1-19.1 6.1zm442.7 0c-4.1-6.3-12.1-8.8-19.1-6.1l-176 67.7c-6.2 2.4-10.3 8.3-10.3 14.9V496c0 6.5 3.9 12.4 10 14.8s12.9 1 17.5-3.6l176-179.7c5.3-5.4 6.1-13.7 1.9-20z"]]
};
var faDesktop = {
  prefix: 'fad',
  iconName: 'desktop',
  icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", ["M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z", "M512 64H64V288H512V64zM416 448H346.7L336 416H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32z"]]
};
var faDesktopAlt = faDesktop;
var faM = {
  prefix: 'fad',
  iconName: 'm',
  icon: [448, 512, [109], "4d", ["M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.3c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 49.9 9.2 37.5 22.7 33.4z", ""]]
};
var faGripDotsVertical = {
  prefix: 'fad',
  iconName: 'grip-dots-vertical',
  icon: [256, 512, [], "e411", ["M160 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm0 160a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96z", "M0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
};
var faFaceViewfinder = {
  prefix: 'fad',
  iconName: 'face-viewfinder',
  icon: [512, 512, [], "e2ff", ["M0 56C0 25.1 25.1 0 56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56zM352 24c0-13.3 10.7-24 24-24h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-4.4-3.6-8-8-8H376c-13.3 0-24-10.7-24-24zM24 352c13.3 0 24 10.7 24 24v80c0 4.4 3.6 8 8 8h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56V376c0-13.3 10.7-24 24-24zm464 0c13.3 0 24 10.7 24 24v80c0 30.9-25.1 56-56 56H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8V376c0-13.3 10.7-24 24-24z", "M256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM200 192a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-95.5 76.9C208.5 309.6 231 320 256 320s47.5-10.4 63.5-27.1c6.1-6.4 16.2-6.6 22.6-.5s6.6 16.2 .5 22.6C320.8 337.8 290 352 256 352s-64.8-14.2-86.6-36.9c-6.1-6.4-5.9-16.5 .5-22.6s16.5-5.9 22.6 .5z"]]
};
var faSoftServe = {
  prefix: 'fad',
  iconName: 'soft-serve',
  icon: [384, 512, [127846, "creemee"], "e400", ["M310.6 161.5c6-9.7 9.4-21.2 9.4-33.5C320 57.3 262.7 0 192 0l6.1 6.1c6.4 6.4 9.9 15 9.9 24C208 48.8 192.8 64 174.1 64H128c-35.3 0-64 28.7-64 64c0 12.3 3.5 23.7 9.4 33.5C40.7 168.2 16 197.2 16 232c0 39.8 32.2 72 72 72H296c39.8 0 72-32.2 72-72c0-34.8-24.7-63.8-57.4-70.5z", "M80 304c-17.7 0-32 14.3-32 32v16c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5H259.4c16.3 0 30-12.3 31.8-28.5L302.2 384H304c17.7 0 32-14.3 32-32V336c0-17.7-14.3-32-32-32H80z"]]
};
var faCreemee = faSoftServe;
var faH5 = {
  prefix: 'fad',
  iconName: 'h5',
  icon: [640, 512, [], "e412", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M400.7 89.4C403.8 74.6 416.9 64 432 64H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H458l-18.5 88H524c64.1 0 116 51.9 116 116s-51.9 116-116 116H456.4c-37.9 0-71.5-24.2-83.5-60.2l-3.2-9.7c-5.6-16.8 3.5-34.9 20.2-40.5s34.9 3.5 40.5 20.2l3.2 9.7c3.3 9.8 12.4 16.4 22.8 16.4H524c28.7 0 52-23.3 52-52s-23.3-52-52-52H400c-9.6 0-18.8-4.3-24.8-11.8s-8.5-17.3-6.5-26.8l32-152z"]]
};
var faHandBackPointDown = {
  prefix: 'fad',
  iconName: 'hand-back-point-down',
  icon: [448, 512, [], "e19e", ["M136 512c-22.1 0-40-17.9-40-40V272v-7V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v55.7c-2-1.4-3.9-3-5.8-4.5L39 227.2C24.4 215 16 197 16 178V140c0-38 16.9-74 46.1-98.3l5.4-4.5C96.3 13.1 132.5 0 169.9 0H288c70.7 0 128 57.3 128 128v64 32c0 26.5-21.5 48-48 48c-12.4 0-23.6-4.7-32.1-12.3C334 284.5 313.3 304 288 304c-12.4 0-23.6-4.7-32.1-12.3C254 316.5 233.3 336 208 336c-12.3 0-23.5-4.6-32-12.2V472c0 22.1-17.9 40-40 40z", ""]]
};
var faTableList = {
  prefix: 'fad',
  iconName: 'table-list',
  icon: [512, 512, ["th-list"], "f00b", ["M128 160V96h64v64H448v64H192v64H448v64H192v64H128V352H64V288h64V224H64V160h64z", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 96V416H64V96H448z"]]
};
var faThList = faTableList;
var faCommentSms = {
  prefix: 'fad',
  iconName: 'comment-sms',
  icon: [512, 512, ["sms"], "f7cd", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM202.9 176.8c6.5-2.2 13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2zm173.1 38c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.2-.4-23.7-4.4-32.6-7.4l0 0 0 0c-1.4-.5-2.7-.9-4-1.4c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7 .6 3.3 1.1 4.9 1.6l0 0 0 0c9.1 3.1 15.6 5.3 22.6 5.5c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6c-9-5.4-17.7-14.7-17.7-29.4c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c10 .2 19.7 2.3 27.9 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9zm-272 0c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.3-.4-24.2-4.5-33.2-7.6l0 0 0 0c-1.3-.4-2.5-.8-3.6-1.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4 .5 2.8 .9 4.1 1.4l0 0 0 0c9.5 3.2 16.5 5.6 23.7 5.8c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4 0 0c-7.2-2.2-16.7-5-24.3-9.6C80.8 239 72.1 229.7 72 215c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c9.5 .1 22.2 2.1 31.1 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9z", "M220.8 182.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 185.1 192 192v96c0 8.8 7.2 16 16 16s16-7.2 16-16V240l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 240v48c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 229.3l-35.2-46.9zM376.5 213c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.1 .1 12.9 1.4 20.1 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4c-9.3-.1-20.4 1.9-29.7 7.4c-9.9 5.9-18.6 16.4-18.5 31.6c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7-.2-13.5-2.4-22.6-5.5l0 0c-1.5-.5-3.2-1.1-4.9-1.6c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.3 .4 2.6 .9 4 1.4l0 0c8.8 3 20.4 7 32.6 7.4c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.2-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4c0-1.1 .2-1.6 .4-1.9zm-272 0c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.6 .1 16.7 1.6 23.3 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4c-9.3-.1-20.4 1.9-29.7 7.4C80.6 189.3 72 199.8 72 215c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7.2-.2-14.2-2.6-23.7-5.8l0 0 0 0c-1.3-.4-2.7-.9-4.1-1.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1 .4 2.4 .8 3.6 1.2l0 0 0 0 0 0c9 3.1 20.9 7.2 33.2 7.6c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4c0-1.1 .2-1.6 .4-1.9z"]]
};
var faSms = faCommentSms;
var faRectangle = {
  prefix: 'fad',
  iconName: 'rectangle',
  icon: [512, 512, [9644, "rectangle-landscape"], "f2fa", ["M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z", ""]]
};
var faRectangleLandscape = faRectangle;
var faClipboardListCheck = {
  prefix: 'fad',
  iconName: 'clipboard-list-check',
  icon: [384, 512, [], "f737", ["M113.2 66.3c.1-.8 .3-1.6 .4-2.3H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H270.4c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zm74.2 162.3c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 281.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0zM192 304c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm112 80c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16H304zM72 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM187.3 228.7c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 281.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0zM72 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
};
var faTurkey = {
  prefix: 'fad',
  iconName: 'turkey',
  icon: [640, 512, [], "f725", ["M472 56c0 22.1-1.2 49.3-19.3 62l-31.6 22.3C375.9 112.2 327.9 96 288 96C176 96 0 224 0 384C0 512 160 512 288 512s288 0 288-128c0-63-27.3-121.1-67.3-168.3c-.4 .2-.7 .4-1 .6l-28.3 20c-8.3 5.9-15.1 15-21.2 28.3c-6.1 13.4-10.5 28.6-15.4 46l-.3 1c-7.9 27.5-24 53-47.9 72.3c-61.8 50-152.5 40.5-202.5-21.4c-13.9-17.2-23.2-36.6-28.1-56.7c-2.3-9.4 5.3-17.9 15-17.9c8.1 0 14.8 6 17 13.8c4 14.4 10.9 28.3 20.9 40.7c19.5 24 46.8 37.9 75.3 40.9c24.1 2.5 49-2.7 70.6-16.1c4-2.5 7.9-5.2 11.6-8.2c18.6-15 31.1-34.8 37.2-56.2c.2-.7 .4-1.3 .6-2c9.6-33.7 20.1-70.5 48.7-90.6L486.7 192l2.5-1.8c18.3-12.9 43.3-10.4 67.4-8c9.4 .9 18.6 1.8 27.3 1.8c30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.1 0-2-1.1-1.7-2.2c1.1-4.4 1.7-9 1.7-13.8c0-30.9-25.1-56-56-56s-56 25.1-56 56z", "M486.7 192l-25.8 18.2c-28.6 20.2-39 56.9-48.7 90.6l-.6 2c-6.1 21.4-18.6 41.2-37.2 56.2c-48.1 38.9-118.6 31.5-157.5-16.6c-10-12.4-17-26.2-20.9-40.7c-2.1-7.8-8.9-13.8-17-13.8c-9.7 0-17.3 8.5-15 17.9c4.9 20.1 14.2 39.5 28.1 56.7c50 61.8 140.7 71.4 202.5 21.4c23.9-19.3 40-44.8 47.9-72.3l.3-1c5-17.4 9.3-32.6 15.4-46c6.1-13.3 12.9-22.5 21.2-28.3l28.3-20c.3-.2 .6-.4 1-.6c-7-8.2-14.3-16.2-22-23.7z"]]
};
var faBook = {
  prefix: 'fad',
  iconName: 'book',
  icon: [448, 512, [128212], "f02d", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H352 256 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H256h96 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zm144 32c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm-16 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16z"]]
};
var faUserPlus = {
  prefix: 'fad',
  iconName: 'user-plus',
  icon: [640, 512, [], "f234", ["M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z", "M504 248v64c0 13.3 10.7 24 24 24s24-10.7 24-24V248h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H552V136c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H440c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
};
var faIceSkate = {
  prefix: 'fad',
  iconName: 'ice-skate',
  icon: [576, 512, [9976], "f7ac", ["M24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24V464zm552-32c0-13.3-10.7-24-24-24s-24 10.7-24 24h48zm0 8v-8H528v8h48zM24 512h96V464H24v48zM96 384V488h48V384H96zm24 128H408V464H120v48zm288 0h96V464H408v48zm24-24V384H384V488h48zm96-48c0 13.3-10.7 24-24 24v48c39.8 0 72-32.2 72-72H528z", "M32 336c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V315c0-44.1-30-82.4-72.7-93.1L320 192H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V128H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32L66.8 86.1C46.2 91.9 32 110.8 32 132.2V336z"]]
};
var faCheck = {
  prefix: 'fad',
  iconName: 'check',
  icon: [448, 512, [10003, 10004], "f00c", ["", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]]
};
var faBatteryThreeQuarters = {
  prefix: 'fad',
  iconName: 'battery-three-quarters',
  icon: [576, 512, ["battery-4"], "f241", ["M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z", "M96 192H352V320H96z"]]
};
var faBattery4 = faBatteryThreeQuarters;
var faTomato = {
  prefix: 'fad',
  iconName: 'tomato',
  icon: [512, 512, [], "e330", ["M146.1 144H112c-6 0-11.4-3.4-14.1-8.5C38.3 170.7 0 228.4 0 304C0 434.9 114.6 512 256 512s256-77.1 256-208c0-75.5-38.1-133-97.5-168.3c-2.8 5-8.1 8.3-14 8.3H365.9l15.4 23.1c3.9 5.9 3.5 13.7-1 19.1s-12.1 7.3-18.6 4.5L256 145.4 150.3 190.7c-6.5 2.8-14.1 1-18.6-4.5s-4.9-13.2-1-19.1L146.1 144z", "M252.6 11.7C245.8 .3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c5 8.4 8.3 17.6 9.6 27.2c-46.3 3-89.6 14.3-126.5 32.9c-6.6 3.3-10.1 10.8-8.4 18s8.2 12.3 15.6 12.3h34.1l-15.4 23.1c-3.9 5.9-3.5 13.7 1 19.1s12.1 7.3 18.6 4.5L256 145.4l105.7 45.3c6.5 2.8 14.1 1 18.6-4.5s4.9-13.2 1-19.1L365.9 144h34.6c7.4 0 13.8-5.1 15.6-12.3s-1.7-14.6-8.3-18c-37.5-19-81.3-30.2-128.2-33c-1.5-18.3-7.2-36-16.7-51.8L252.6 11.7z"]]
};
var faSwordLaser = {
  prefix: 'fad',
  iconName: 'sword-laser',
  icon: [512, 512, [], "e03b", ["M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L207.1 248.5l56.4 56.4L505.7 40.2z", "M172.7 236.7c-6.1 6.1-6.2 15.8-.5 22.1l81 81c6.3 5.8 16 5.6 22.1-.5c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0zm-11.3 33.9l-23.7 23.7 80 80 23.7-23.7-80-80zm45 115l-80-80-20.7 20.7 80 80 20.7-20.7zM181.7 425L87 330.3l-2.3 2.3L10.3 407C3.7 413.7 0 422.6 0 432s3.7 18.3 10.3 25L55 501.7c6.6 6.6 15.6 10.3 25 10.3s18.3-3.7 25-10.3l74.3-74.3 2.3-2.3z"]]
};
var faHouseCircleCheck = {
  prefix: 'fad',
  iconName: 'house-circle-check',
  icon: [640, 512, [], "e509", ["M496 192c-91.8 0-167.2 70.3-175.3 160l-.7 0H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faBuildings = {
  prefix: 'fad',
  iconName: 'buildings',
  icon: [512, 512, [], "e0cc", ["M256 0c-35.3 0-64 28.7-64 64v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256 448c35.3 0 64-28.7 64-64V192 64c0-35.3-28.7-64-64-64H256zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V304zm208 16c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272zm112-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM256 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V80zM400 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM256 208V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400z", "M256 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V80zM80 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM272 320c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272zM80 288h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm304 16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM400 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM256 208V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400z"]]
};
var faAngleLeft = {
  prefix: 'fad',
  iconName: 'angle-left',
  icon: [320, 512, [8249], "f104", ["M41.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 246.6 393.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160z", ""]]
};
var faCartFlatbedBoxes = {
  prefix: 'fad',
  iconName: 'cart-flatbed-boxes',
  icon: [640, 512, ["dolly-flatbed-alt"], "f475", ["M224 32c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224zm224 0c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H448zM416 224v64c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32zM160 464c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H162.7c-1.8 5-2.7 10.4-2.7 16zm288 0c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16z", "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32z"]]
};
var faDollyFlatbedAlt = faCartFlatbedBoxes;
var faDiagramSuccessor = {
  prefix: 'fad',
  iconName: 'diagram-successor',
  icon: [512, 512, [], "e47a", ["M224 224c35.3 0 64-28.7 64-64V96l80 0c8.8 0 16 7.2 16 16v16H345.9c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41H448V112c0-44.2-35.8-80-80-80H224 208 64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64l160 0z", "M448 480c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0z"]]
};
var faTruckArrowRight = {
  prefix: 'fad',
  iconName: 'truck-arrow-right',
  icon: [640, 512, [], "e58b", ["M223 79c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H96c-13.3 0-24-10.7-24-24s10.7-24 24-24H262.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9zM96 432a80 80 0 1 1 160 0A80 80 0 1 1 96 432zm368-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576h-1.1c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H286.9c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM257 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 79z"]]
};
var faSquareW = {
  prefix: 'fad',
  iconName: 'square-w',
  icon: [448, 512, [], "e285", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm54.9 136.7L160 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L224 254.7 182.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z", "M88.7 153.1c12.6-4 26.1 2.9 30.2 15.5L160 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L224 254.7 182.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2z"]]
};
var faArrowsSplitUpAndLeft = {
  prefix: 'fad',
  iconName: 'arrows-split-up-and-left',
  icon: [512, 512, [], "e4bc", ["M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0-47.4-25.7-88.7-64-110.9V109.3l-41.4 41.4z", "M2.4 275.8c1.6-3.8 3.9-7.3 6.9-10.4l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 224 256c70.7 0 128 57.3 128 128c0 35.3 28.7 64 64 64l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64l-114.7 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96s0 0 0 0c0 0 0 0-.1-.1C3.6 304.8 0 296.9 0 288.1c0-.1 0-.1 0-.2c0-4.1 .8-8.3 2.4-12.2zM0 288.1c0 0 0-.1 0-.1s0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2"]]
};
var faLamp = {
  prefix: 'fad',
  iconName: 'lamp',
  icon: [448, 512, [], "f4ca", ["M288 256H160v48s-64 66.5-64 128c0 24.4 8.3 44.6 16.4 58.7c8.5 14.7 25.2 21.3 42.1 21.3h139c17 0 33.6-6.6 42.1-21.3c8.1-14 16.4-34.3 16.4-58.7c0-61.5-64-128-64-128V256z", "M112 0C99.1 0 87.4 7.8 82.5 19.7l-80 192c-4.1 9.9-3 21.2 2.9 30.1S21.3 256 32 256H416c10.7 0 20.7-5.3 26.6-14.2s7-20.2 2.9-30.1l-80-192C360.6 7.8 348.9 0 336 0H112z"]]
};
var faAirplay = {
  prefix: 'fad',
  iconName: 'airplay',
  icon: [576, 512, [], "e089", ["M96 96H480c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H410.5l50.7 50.7c4 4 7.4 8.5 10.2 13.3H480c53 0 96-43 96-96V128c0-53-43-96-96-96H96C43 32 0 75 0 128V320c0 53 43 96 96 96h8.6c2.8-4.8 6.2-9.2 10.2-13.3L165.5 352H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32z", "M310.6 297.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H416c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]]
};
var faHandFist = {
  prefix: 'fad',
  iconName: 'hand-fist',
  icon: [448, 512, [9994, "fist-raised"], "f6de", ["M256 215.4c0 .2 0 .4 0 .6c0 39.8-32.2 72-72 72H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-35.3 0-64 28.7-64 64v27c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c13.7 13.7 29.6 24.6 46.9 32.5V480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384c38.9-29.2 64-75.7 64-128v-8.6c-9.4 5.4-20.3 8.6-32 8.6c-27.9 0-51.7-17.9-60.4-42.8C313.4 220 301.2 224 288 224c-11.7 0-22.6-3.1-32-8.6z", "M160 32V144h64V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM96 32C78.3 32 64 46.3 64 64v80h64V64c0-17.7-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32zm96 64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32z"]]
};
var faFistRaised = faHandFist;
var faShieldQuartered = {
  prefix: 'fad',
  iconName: 'shield-quartered',
  icon: [512, 512, [], "e575", ["M256.7 0L256 0c-4.6 0-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.1 24 2.6 52.9 8.7 84H256V0h.7zM488 224H256.7V509.1c9 0 18.1-2 26.4-6C413.7 440.7 468.8 321.3 488 224z", "M256.4 0l.3 0c4.6 0 9.2 1 13.4 2.9L458.4 82.8c22 9.3 38.4 31 38.3 57.2c-.1 24-2.6 52.9-8.7 84H256.7V0H256l0 0h-.7l.7 0 .3 0zM229.6 503.2C99 440.7 44 321.3 24.7 224H256V509.1c-9 0-18.1-2-26.4-6z"]]
};
var faSlashForward = {
  prefix: 'fad',
  iconName: 'slash-forward',
  icon: [320, 512, [], "2f", ["M303.9 4.2c15.3 8.8 20.7 28.3 11.9 43.7l-256 448c-8.8 15.3-28.3 20.7-43.7 11.9S-4.6 479.5 4.2 464.1l256-448C269 .8 288.5-4.6 303.9 4.2z", ""]]
};
var faLocationPen = {
  prefix: 'fad',
  iconName: 'location-pen',
  icon: [384, 512, ["map-marker-edit"], "f607", ["M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM276.8 107c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L208.6 122 223.5 107c14.7-14.7 38.6-14.7 53.3 0zM114.1 216.5L186 144.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z", "M223.5 107L208.6 122l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3c-14.7-14.7-38.6-14.7-53.3 0zM186 144.6l-71.9 71.9c-4.1 4.1-7 9.2-8.4 14.9L96.5 268c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L186 144.6z"]]
};
var faMapMarkerEdit = faLocationPen;
var faCloudMoon = {
  prefix: 'fad',
  iconName: 'cloud-moon',
  icon: [640, 512, [], "f6c3", ["M304 192.2C304 86.1 389.8 0 495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-3.5 0-7-.1-10.5-.3c-13.6-28.6-39-50.6-69.9-59.6c-5.7-55.6-52-99.1-108.8-100.4c-1.7-10.4-2.6-21-2.6-31.8z", "M383.9 511.9H96c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16h1.6c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]]
};
var faPotFood = {
  prefix: 'fad',
  iconName: 'pot-food',
  icon: [640, 512, [127858], "e43f", ["M112 24c0 26.5 10.5 38.7 25.9 56.1l.4 .4C154.8 99 176 122.9 176 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C85.2 93 64 69.1 64 24C64 10.7 74.7 0 88 0s24 10.7 24 24zm112 0c0 26.5 10.5 38.7 25.9 56.1l.4 .4C266.8 99 288 122.9 288 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C197.2 93 176 69.1 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24zm208 88c61.9 0 112 50.1 112 112H320c0-61.9 50.1-112 112-112z", "M65.9 256c-.2-17.5 14-32 31.7-32H542.4c17.7 0 31.9 14.5 31.7 32H592c17.7 0 32 14.3 32 32s-14.3 32-32 32H562.3c-20.6 64-66.1 116.7-124.7 147.2l-1.2 9.7c-2.5 20-19.5 35-39.7 35H243.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C143.8 436.7 98.3 384 77.7 320H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H65.9z"]]
};
var faBriefcase = {
  prefix: 'fad',
  iconName: 'briefcase',
  icon: [512, 512, [128188], "f0b1", ["M192 288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288z", "M384 96h80c25.6 0 48 22.4 48 48V288H0V144c0-25.6 22.4-48 48-48h80V56 48c0-25.6 22.4-48 48-48h8H328h8c25.6 0 48 22.4 48 48v8V96zm-48 0V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8V96H336z"]]
};
var faPersonFalling = {
  prefix: 'fad',
  iconName: 'person-falling',
  icon: [512, 512, [], "e546", ["M64 80a48 48 0 1 1 96 0A48 48 0 1 1 64 80z", "M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C135.6 154.5 96 213 96 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L325.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L286.6 320H288l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C405.3 263.1 391.1 256 376 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8z"]]
};
var faImagePortrait = {
  prefix: 'fad',
  iconName: 'image-portrait',
  icon: [384, 512, ["portrait"], "f3e0", ["M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z", "M192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-43.4 32C110.7 288 80 318.7 80 356.6c0 15.1 12.3 27.4 27.4 27.4H276.6c15.1 0 27.4-12.3 27.4-27.4c0-37.9-30.7-68.6-68.6-68.6H148.6z"]]
};
var faPortrait = faImagePortrait;
var faUserTag = {
  prefix: 'fad',
  iconName: 'user-tag',
  icon: [640, 512, [], "f507", ["M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c17.5 0 34.3 2.5 50.3 7.2v33c0 21.1 8.4 41.2 23.3 56.1l99.2 99.2c-5.4 7.5-14.2 12.5-24.2 12.5H29.7C13.3 512 0 498.7 0 482.3z", "M352 256c0-17.7 14.3-32 32-32h82.7c17 0 33.3 6.7 45.3 18.7L619.3 350.1c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.4c-18.7 18.7-49.1 18.7-67.9 0L370.7 384c-12-12-18.7-28.3-18.7-45.3V256zm80 72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faRug = {
  prefix: 'fad',
  iconName: 'rug',
  icon: [640, 512, [], "e569", ["M80 64V448h80V64H80zm400 0V448h80V64H480zm-32 0H192V448H448V64z", "M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24h8v40H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v40H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H56 80V424 336 256 176 88 64H56 24zm592 0H584 560V88v88 80 80 88 24h24 32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V360h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V280h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V200h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V112h8c13.3 0 24-10.7 24-24s-10.7-24-24-24zM160 64V448h32V64H160zm320 0H448V448h32V64z"]]
};
var faPrintSlash = {
  prefix: 'fad',
  iconName: 'print-slash',
  icon: [640, 512, [], "f686", ["M446.8 448l51 40.2C486.1 502.7 468.1 512 448 512H192c-35.3 0-64-28.7-64-64V384H96c-17.7 0-32-14.3-32-32V256c0-33.4 25.6-60.8 58.2-63.7L324.9 352H192v16 16 64H446.8zM544 384H522.2l-245-192H512c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32zM192 64v61.2L128 75V64c0-35.3 28.7-64 64-64H418.7c17 0 33.3 6.7 45.3 18.7L493.3 48c12 12 18.7 28.3 18.7 45.3V160H448V93.3L418.7 64H192zM520 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faEarthEurope = {
  prefix: 'fad',
  iconName: 'earth-europe',
  icon: [512, 512, ["globe-europe"], "f7a2", ["M192 210.3v-4.3c0-9 3.6-17.6 9.9-24l17.9-17.9c2.6-2.6 4.1-6.2 4.1-10c0-6.1 3.9-11.5 9.6-13.4l26.5-8.8c7.8-2.6 14.9-7 20.7-12.8l19.9-19.9c2.1-2.1 3.3-5 3.3-8c0-6.2-5.1-11.3-11.3-11.3h-1c-2.4 0-4.8 .7-6.8 2.1l-41.8 27.9c-2 1.3-4.4 2.1-6.8 2.1c-6.8 0-12.3-5.5-12.3-12.3V91.2c0-7 3.5-13.5 9.3-17.3l95.1-63.4C305.5 3.6 281.2 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c5.4 0 10.7-.2 16-.5V477.3c0-25-20.3-45.3-45.3-45.3c-12 0-23.5-4.8-32-13.3l-16-16c-12-12-18.7-28.3-18.7-45.3v-3.2c0-21.4 10.7-41.4 28.5-53.3l27.4-18.3c10.5-7 22.9-10.7 35.5-10.7h20.9c15.3 0 30.1 5.5 41.7 15.4l26.6 22.8c7.4 6.3 16.8 9.8 26.6 9.8c10.8 0 21.2 4.3 28.9 12l4 4c10.2 10.2 24.1 16 38.6 16h54.8c4.2-10.3 7.7-21 10.5-32H446.6c-14.5 0-28.4-5.8-38.6-16l-18.3-18.3C386 282 384 277.1 384 272s2-10 5.7-13.7l7.5-7.5c1.8-1.8 2.8-4.3 2.8-6.8s-1-5-2.8-6.8l-6.5-6.5c-4.2-4.2-10-6.6-16-6.6H363.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L360 200c5.1-5.1 12.1-8 19.3-8H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H370.6c-10.3 0-18.6 8.3-18.6 18.6c0 8-5.1 15.1-12.7 17.6l-21.2 7.1c-7.5 2.5-11 11-7.5 18l1.1 2.3c3.8 7.5-1.7 16.4-10.1 16.4c-3.6 0-6.9-1.7-9.1-4.5l-16.3-21.7c-2.7-3.6-6.9-5.7-11.4-5.7c-5.4 0-10.4 3.1-12.8 7.9l-4 8.1c-4.9 9.8-15.1 16-26.1 16c-16.4 0-29.9-13.3-29.9-29.7zm-4.7-87l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z", "M192 210.3v-4.3c0-9 3.6-17.6 9.9-24l17.9-17.9c2.6-2.6 4.1-6.2 4.1-10c0-6.1 3.9-11.5 9.6-13.4l26.5-8.8c7.8-2.6 14.9-7 20.7-12.8l19.9-19.9c2.1-2.1 3.3-5 3.3-8c0-6.2-5.1-11.3-11.3-11.3h-1c-2.4 0-4.8 .7-6.8 2.1l-41.8 27.9c-2 1.3-4.4 2.1-6.8 2.1c-6.8 0-12.3-5.5-12.3-12.3V91.2c0-7 3.5-13.5 9.3-17.3l95.1-63.4C434.5 41.6 512 139.8 512 256c0 22.1-2.8 43.5-8.1 64H446.6c-14.5 0-28.4-5.8-38.6-16l-18.3-18.3C386 282 384 277.1 384 272s2-10 5.7-13.7l7.5-7.5c1.8-1.8 2.8-4.3 2.8-6.8s-1-5-2.8-6.8l-6.5-6.5c-4.2-4.2-10-6.6-16-6.6H363.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L360 200c5.1-5.1 12.1-8 19.3-8H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H370.6c-10.3 0-18.6 8.3-18.6 18.6c0 8-5.1 15.1-12.7 17.6l-21.2 7.1c-7.5 2.5-11 11-7.5 18l1.1 2.3c3.8 7.5-1.7 16.4-10.1 16.4c-3.6 0-6.9-1.7-9.1-4.5l-16.3-21.7c-2.7-3.6-6.9-5.7-11.4-5.7c-5.4 0-10.4 3.1-12.8 7.9l-4 8.1c-4.9 9.8-15.1 16-26.1 16c-16.4 0-29.9-13.3-29.9-29.7zM493.4 352C457.3 441.1 372.5 505.3 272 511.5V477.3c0-25-20.3-45.3-45.3-45.3c-12 0-23.5-4.8-32-13.3l-16-16c-12-12-18.7-28.3-18.7-45.3v-3.2c0-21.4 10.7-41.4 28.5-53.2l27.4-18.3c10.5-7 22.9-10.7 35.5-10.7h20.9c15.3 0 30.1 5.5 41.7 15.4l26.6 22.8c7.4 6.3 16.8 9.8 26.6 9.8c10.8 0 21.2 4.3 28.9 12l4 4c10.2 10.2 24.1 16 38.6 16h54.8zM187.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0z"]]
};
var faGlobeEurope = faEarthEurope;
var faCartFlatbedSuitcase = {
  prefix: 'fad',
  iconName: 'cart-flatbed-suitcase',
  icon: [640, 512, ["luggage-cart"], "f59d", ["M344 48h80c4.4 0 8 3.6 8 8V96H336V56c0-4.4 3.6-8 8-8zm-56 8V96 320H480V96 56c0-30.9-25.1-56-56-56H344c-30.9 0-56 25.1-56 56zM512 320h16c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H512V320zM240 96c-26.5 0-48 21.5-48 48V272c0 26.5 21.5 48 48 48h16V96H240zM160 464c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H162.7c-1.8 5-2.7 10.4-2.7 16zm288 0c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16z", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM256 96V320h32V96H256zm224 0V320h32V96H480z"]]
};
var faLuggageCart = faCartFlatbedSuitcase;
var faHandBackPointRibbon = {
  prefix: 'fad',
  iconName: 'hand-back-point-ribbon',
  icon: [448, 512, [], "e1a0", ["M112.8 32C116.5 13.7 132.6 0 152 0s35.5 13.7 39.2 32H112.8zM112 240V160h80v28.2c8.5-7.6 19.7-12.2 32-12.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v32 64c0 70.7-57.3 128-128 128H185.9c-37.4 0-73.7-13.1-102.4-37.1l-5.4-4.5C48.9 446.1 32 410 32 372V334c0-19 8.4-37 23-49.2l19.2-16c1.9-1.6 3.8-3.1 5.8-4.5V320c0 8.8 7.2 16 16 16s16-7.2 16-16V247v-7z", "M224 112V48c0-8.8-7.2-16-16-16H43.8C37.3 32 32 37.3 32 43.8c0 3.9 1.9 7.5 5.1 9.7L75.6 80 37.1 106.5c-3.2 2.2-5.1 5.8-5.1 9.7c0 6.5 5.3 11.8 11.8 11.8H208c8.8 0 16-7.2 16-16z"]]
};
var faRectangleXmark = {
  prefix: 'fad',
  iconName: 'rectangle-xmark',
  icon: [512, 512, [62164, "rectangle-times", "times-rectangle", "window-close"], "f410", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z", "M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faRectangleTimes = faRectangleXmark;
var faTimesRectangle = faRectangleXmark;
var faWindowClose = faRectangleXmark;
var faTireRugged = {
  prefix: 'fad',
  iconName: 'tire-rugged',
  icon: [512, 512, [], "f634", ["M256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-224a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-75.9 96.6a24 24 0 1 1 14.8-45.7 24 24 0 1 1 -14.8 45.7zm167.2-30.2a24 24 0 1 1 -45.7 14.8 24 24 0 1 1 45.7-14.8zm-29.6 73.8a24 24 0 1 1 -38.8 28.2 24 24 0 1 1 38.8-28.2zM199.6 333.7a24 24 0 1 1 28.2-38.8 24 24 0 1 1 -28.2 38.8z", "M296 0c13.3 0 24 10.7 24 24V40c0 .4 0 .8 0 1.3c14.9 4.4 29.2 10.4 42.6 17.7c.3-.3 .6-.6 .9-.9l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9L454 148.5c-.3 .3-.6 .6-.9 .9c7.3 13.4 13.2 27.7 17.7 42.6c.4 0 .8 0 1.3 0h16c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H472c-.4 0-.8 0-1.3 0c-4.4 14.9-10.4 29.2-17.7 42.6c.3 .3 .6 .6 .9 .9l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0L363.5 454c-.3-.3-.6-.6-.9-.9c-13.4 7.3-27.7 13.2-42.6 17.7c0 .4 0 .8 0 1.3v16c0 13.3-10.7 24-24 24H216c-13.3 0-24-10.7-24-24V472c0-.4 0-.8 0-1.3c-14.9-4.4-29.2-10.4-42.6-17.7c-.3 .3-.6 .6-.9 .9l-11.3 11.3c-9.4 9.4-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9L58 363.5c.3-.3 .6-.6 .9-.9c-7.3-13.4-13.2-27.7-17.7-42.6c-.4 0-.8 0-1.3 0H24c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24H40c.4 0 .8 0 1.3 0c4.4-14.9 10.4-29.2 17.7-42.6c-.3-.3-.6-.6-.9-.9L46.7 137.2c-9.4-9.4-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0L148.5 58c.3 .3 .6 .6 .9 .9c13.4-7.3 27.7-13.2 42.6-17.7c0-.4 0-.8 0-1.3V24c0-13.3 10.7-24 24-24h80zm88 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]]
};
var faLightbulbDollar = {
  prefix: 'fad',
  iconName: 'lightbulb-dollar',
  icon: [384, 512, [], "f670", ["M321.2 297.8c-19.8 27.1-39.7 54.4-49.2 86.2H112c-9.6-31.9-29.5-59.1-49.2-86.2c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4zM212 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V296c0 11 9 20 20 20s20-9 20-20V282.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V88z", "M192 512c44.2 0 80-35.8 80-80V384H112v48c0 44.2 35.8 80 80 80z"]]
};
var faCowbell = {
  prefix: 'fad',
  iconName: 'cowbell',
  icon: [448, 512, [], "f8b3", ["M112 96c-22 0-41.2 15-46.6 36.4l-64 256c-3.6 14.3-.4 29.5 8.7 41.2S33.2 448 48 448H400c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-64-256C377.2 111 358 96 336 96V40c0-22.1-17.9-40-40-40H152c-22.1 0-40 17.9-40 40V96zm48 0V48H288V96H160z", "M224 512c35.3 0 64-28.7 64-64H160c0 35.3 28.7 64 64 64z"]]
};
var faBahtSign = {
  prefix: 'fad',
  iconName: 'baht-sign',
  icon: [320, 512, [], "e0ac", ["M144 0c17.7 0 32 14.3 32 32V64H112V32c0-17.7 14.3-32 32-32zm32 288v96H112V288h64zm0-160v96H112V128h64zM112 448h64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448z", "M64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zM0 265.7V224 101.6C0 80.8 16.8 64 37.6 64H176c61.9 0 112 50.1 112 112c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112H41.7C18.7 448 0 429.3 0 406.3V288 265.7zM176 288H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"]]
};
var faCorner = {
  prefix: 'fad',
  iconName: 'corner',
  icon: [448, 512, [], "e3fe", ["M0 192c0-17.7 14.3-32 32-32H384c35.3 0 64 28.7 64 64V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z", ""]]
};
var faChevronsRight = {
  prefix: 'fad',
  iconName: 'chevrons-right',
  icon: [512, 512, ["chevron-double-right"], "f324", ["M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 41.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z", "M470.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 256 233.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]]
};
var faChevronDoubleRight = faChevronsRight;
var faBookOpen = {
  prefix: 'fad',
  iconName: 'book-open',
  icon: [576, 512, [128214, 128366], "f518", ["M288 72V480s92.8-32 144-32c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-64 0-128 24-144 40z", "M288 72V480s-92.8-32-144-32c-38.5 0-88.4 12.1-119.9 22.6C12.8 474.3 0 466 0 454.1V83.8C0 71.7 6.8 60.5 18.1 56.1C46.3 45.3 93.5 32 144 32c64 0 128 24 144 40z"]]
};
var faBookJournalWhills = {
  prefix: 'fad',
  iconName: 'book-journal-whills',
  icon: [448, 512, ["journal-whills"], "f66a", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 256 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H256h96 64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm58.4 181.6c3.1 3.1 8.1 3.1 11.2 0s3.1-8.1 0-11.2l-26.4-26.5c8.2-17 20.6-31.6 35.8-42.6c2.7-1.9 6.2 1.4 5 4.5c-8.5 22.4-3.5 48 13.1 65.5c3.2 3.4 3.6 8.8 .9 12.7c-9.8 14-12.7 31.9-7.6 48.5c5.9 19.4 22 34.1 41.9 38.3l1.4-32.8-10.4 7.1c-.6 .4-1.5 .6-2.2 .6c-1 0-2-.4-2.8-1c-.8-.9-1.2-1.9-1.2-3c0-.6 .2-1.4 .5-2l8.6-14.2-18-3.8c-1.8-.4-3.1-2.1-3.1-4s1.4-3.5 3.1-3.9l18-3.7-8.6-14.3c-.9-1.6-.6-3.7 .8-5s3.5-1.5 5-.4l12 8.1L236 87.9c.1-2.2 1.9-3.9 4-3.9s3.9 1.6 4 3.9l4.8 112.3 14.1-9.6c.6-.5 1.4-.6 2.1-.7l.1 0c1.5 0 2.7 .7 3.5 2s.6 2.9-.1 4.1L260 210.1l18 3.7c1.8 .4 3.1 2 3.1 3.9s-1.4 3.6-3.1 4l-18 3.6 8.5 14.4c.8 1.2 .9 2.7 .1 4s-2 2-3.5 2c-.8 0-1.6-.2-2.3-.6l-12.6-8.6 1.4 34.3c19.9-4.1 36-18.9 41.9-38.3c5.1-16.5 2.2-34.5-7.5-48.5c-2.7-3.9-2.4-9.3 .9-12.7c16.6-17.5 21.6-43.1 13-65.6c-1.2-3.1 2.3-6.4 5-4.5c15.3 10.9 27.7 25.6 35.9 42.6l-26.4 26.5c-3.1 3.1-3.1 8.1 0 11.2s8.1 3.1 11.3 0l21.2-21.2c3 10.1 5.1 20.6 5.1 31.6c0 .2 0 .5-.1 .8s-.1 .5-.1 .8L314.8 226c-1.6 1.6-2.6 3.8-2.8 6c.1 1.9 .7 3.8 2 5.2c1.6 1.6 3.8 2.6 6 2.8c2 0 3.9-.8 5.3-2l23.6-20.6C337.3 267 293.1 304 240 304s-97.2-37-108.9-86.6L154.8 238c1.5 1.2 3.4 1.9 5.2 2c3.4 0 6.2-2.1 7.5-5.1c1.1-3.1 .2-6.7-2.3-8.9l-37.1-32.5c0-.3 0-.5-.1-.8s-.1-.5-.1-.8c0-11 2.1-21.5 5.1-31.6l21.2 21.2z"]]
};
var faJournalWhills = faBookJournalWhills;
var faInhaler = {
  prefix: 'fad',
  iconName: 'inhaler',
  icon: [576, 512, [], "f5f9", ["M429.8 32.7c-12.7-3.2-25.6 4.4-29 17l-24.2 89.9c2.6 .7 5 2.1 7.1 4.2L523.5 283.5 575.2 94.3c1.7-6.2 .8-12.9-2.4-18.4s-8.6-9.6-14.9-11.2l-128-32zM32 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M534.1 305.5c1.5-5.5-.1-11.5-4.1-15.5L383.8 143.8c-8.7-8.7-23.6-4.7-26.8 7.2l-16.5 61.2c-1.9 7-8.2 11.8-15.4 11.8H232c-22.1 0-40 17.9-40 40V440c0 22.1 17.9 40 40 40H456c18 0 33.8-12.1 38.6-29.5l39.5-145z"]]
};
var faHandcuffs = {
  prefix: 'fad',
  iconName: 'handcuffs',
  icon: [640, 512, [], "e4f8", ["M272 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 80h64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm320 0h64c0-17.7-14.3-32-32-32s-32 14.3-32 32zM400 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M96 184c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184zm64 264a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]]
};
var faSnake = {
  prefix: 'fad',
  iconName: 'snake',
  icon: [512, 512, [128013], "f716", ["M192 64H176c-5.4 0-10.7 .3-16 .9V112c0 8.8 7.2 16 16 16s16-7.2 16-16V64zm64 0v48c0 8.8 7.2 16 16 16s16-7.2 16-16V64H256zM64 426.7V464c0 8.8 7.2 16 16 16s16-7.2 16-16V417.3c-5 .8-9.9 2-14.8 3.7L64 426.7zM160 416v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416H160zm96 0v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416H256zm72.3-1.1l28.4 28.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-28.4-28.4c-2.9 11-11.6 19.7-22.6 22.6zm22.6-39.2l28.4-28.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-28.4 28.4c11 2.9 19.7 11.6 22.6 22.6zM288 352V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h32zm-96 0V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v47.1c5.3 .6 10.6 .9 16 .9h16zM86.1 320.5l21.2-21.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L63.5 297.9c6.7 8.4 14.3 15.9 22.6 22.6zM32.9 224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H32.9c-.6 5.3-.9 10.6-.9 16s.3 10.7 .9 16zM86.1 95.5c-8.4 6.7-15.9 14.3-22.6 22.6l21.2 21.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.1 95.5z", "M403.6 25.8l79.8 39.9C500.9 74.5 512 92.4 512 112s-11.1 37.5-28.6 46.3l-79.8 39.9c-30.8 15.4-68 9.4-92.3-15L288 160H176c-26.5 0-48 21.5-48 48s21.5 48 48 48H320c70.7 0 128 57.3 128 128s-57.3 128-128 128H176l-.1 0H111.6c-10.3 0-20.6-1.7-30.4-4.9l-66-22C6.1 482 0 473.6 0 464s6.1-18 15.2-21.1L64 426.7V464c0 8.8 7.2 16 16 16s16-7.2 16-16V417.3c5.1-.8 10.4-1.3 15.6-1.3H160v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h32c2.9 0 5.6-.4 8.3-1.1l28.4 28.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-28.4-28.4c.7-2.6 1.1-5.4 1.1-8.3s-.4-5.6-1.1-8.3l28.4-28.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-28.4 28.4c-2.6-.7-5.4-1.1-8.3-1.1H288V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H192V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v47.1c-27.8-3.1-53.2-14-73.9-30.6l21.2-21.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L63.5 297.9C46.9 277.2 35.9 251.8 32.9 224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H32.9c3.1-27.8 14-53.2 30.6-73.9l21.2 21.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.1 95.5c20.7-16.6 46.1-27.5 73.9-30.6V112c0 8.8 7.2 16 16 16s16-7.2 16-16V64h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V64l23.2-23.2c24.3-24.3 61.5-30.4 92.3-15zM368 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
};
var faTriangleExclamation = {
  prefix: 'fad',
  iconName: 'triangle-exclamation',
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", ["M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184zM256 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faExclamationTriangle = faTriangleExclamation;
var faWarning = faTriangleExclamation;
var faNoteMedical = {
  prefix: 'fad',
  iconName: 'note-medical',
  icon: [448, 512, [], "e200", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320H320c-17.7 0-32 14.3-32 32V480H64c-35.3 0-64-28.7-64-64V96zm192 48v48H144c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H256V144c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z", "M192 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48l48 0c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H256v48c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V256H144c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16l48 0V144zm96 336V352c0-17.7 14.3-32 32-32H448v5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7H288z"]]
};
var faDatabase = {
  prefix: 'fad',
  iconName: 'database',
  icon: [448, 512, [], "f1c0", ["M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z", "M0 186.1V128c0 44.2 100.3 80 224 80s224-35.8 224-80v58.1c-14.9 11.8-34 21.2-54.8 28.6C348.3 230.7 288.5 240 224 240s-124.3-9.3-169.2-25.3C34 207.3 14.9 197.8 0 186.1zm0 160V288c0 44.2 100.3 80 224 80s224-35.8 224-80v58.1c-14.9 11.8-34 21.2-54.8 28.6C348.3 390.7 288.5 400 224 400s-124.3-9.3-169.2-25.3C34 367.3 14.9 357.8 0 346.1z"]]
};
var faDownLeft = {
  prefix: 'fad',
  iconName: 'down-left',
  icon: [384, 512, [], "e16a", ["M238.6 305.4L372.7 171.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L331.3 75.3C324.1 68.1 314.2 64 304 64s-20.1 4.1-27.3 11.3L142.6 209.4l96 96z", "M48 432H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-240-240c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6V400c0 17.7 14.3 32 32 32z"]]
};
var faShare = {
  prefix: 'fad',
  iconName: 'share',
  icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", ["M288 288V128H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96z", "M288 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2V64z"]]
};
var faArrowTurnRight = faShare;
var faMailForward = faShare;
var faFaceThinking = {
  prefix: 'fad',
  iconName: 'face-thinking',
  icon: [512, 512, [], "e39b", ["M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 45 11.6 87.3 32 124V352c0-30.9 25.1-56 56-56s56 25.1 56 56v3l92.2-33.5-82.4-34.7c-8.1-3.4-12-12.8-8.5-21s12.8-12 21-8.5l122.5 51.6c22.7 9.6 37.9 31.2 39.2 55.6c1.5 24.2-12.9 47.4-36.8 56.1l-35.8 13-21 57.7c-2.5 6.8-5.8 13.1-9.8 18.8c10.3 1.3 20.8 1.9 31.4 1.9zM176.4 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-88-63.2c-20.5-17.6-49.9-20.4-73.4-7l-7.1 4c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l7.1-4c35.2-20.1 79.3-15.9 110.1 10.5l13.2 11.3c6.7 5.8 7.5 15.9 1.7 22.6s-15.9 7.5-22.6 1.7l-13.2-11.3z", "M143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4zM176.4 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM112 352c0-13.3-10.7-24-24-24s-24 10.7-24 24V464c0 26.5 21.5 48 48 48h47.2c20.2 0 38.2-12.6 45.1-31.6l26.1-71.7 49.8-18.1c12.5-4.5 18.9-18.3 14.4-30.8s-18.3-18.9-30.8-14.4L112 400.6V352zM368.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
};
var faTurnDownRight = {
  prefix: 'fad',
  iconName: 'turn-down-right',
  icon: [512, 512, [], "e455", ["M320 240v96H112C50.1 336 0 285.9 0 224V64C0 46.3 14.3 32 32 32H64c17.7 0 32 14.3 32 32V224c0 8.8 7.2 16 16 16H320z", "M360.5 441.4c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22l0-272c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136z"]]
};
var faBottleDroplet = {
  prefix: 'fad',
  iconName: 'bottle-droplet',
  icon: [320, 512, [], "e4c4", ["M104 120.9V48H216v72.9c0 12.2 7.2 23.1 17.2 30.1c33.1 23.1 54.8 61.5 54.8 105V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V256c0-43.5 21.7-81.9 54.8-105c10-7 17.2-17.9 17.2-30.1zM160 384c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C135 284 112 313.8 112 336c0 26.5 21.5 48 48 48z", "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 0zm64 384c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C135 284 112 313.8 112 336c0 26.5 21.5 48 48 48z"]]
};
var faMaskFace = {
  prefix: 'fad',
  iconName: 'mask-face',
  icon: [640, 512, [], "e1d7", ["M128 128H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27c-26.6-17.1-49.3-39.7-66.5-66.1l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96V160c0-17.7 14.3-32 32-32zM441.1 412.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512c17.7 0 32 14.3 32 32v16h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-29.8 7.4c-17.3 26.4-40 49-66.5 66.1z", "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H128c-17.7 0-32 14.3-32 32v64c0 123.7 100.3 224 224 224s224-100.3 224-224V160c0-17.7-14.3-32-32-32H486.8c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM192 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]]
};
var faHillRockslide = {
  prefix: 'fad',
  iconName: 'hill-rockslide',
  icon: [576, 512, [], "e508", ["M192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm60.4 24.2c-2.7 4.9-2.7 10.8 0 15.7l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2H293.4c-5.8 0-11.1 3.1-13.9 8.2l-27 48zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9V309.4c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M54.6 73.4c-9.2-9.2-22.9-11.9-34.9-6.9S0 83.1 0 96V480c0 17.7 14.3 32 32 32H416c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-384-384z"]]
};
var faScannerKeyboard = {
  prefix: 'fad',
  iconName: 'scanner-keyboard',
  icon: [512, 512, [], "f489", ["M64 96C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm24 64H264c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24zM80 288h64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zM64 400c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V400zM208 288h64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zM192 400c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V400z", "M152 0h16c13.3 0 24 10.7 24 24V64H128V24c0-13.3 10.7-24 24-24zM312 0h16c13.3 0 24 10.7 24 24V64H288V24c0-13.3 10.7-24 24-24zM224 16c0-8.8 7.2-16 16-16s16 7.2 16 16V64H224V16zM400 0c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zm48 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24H472c-13.3 0-24-10.7-24-24V24zM88 160H264c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"]]
};
var faCircleO = {
  prefix: 'fad',
  iconName: 'circle-o',
  icon: [512, 512, [], "e119", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z", "M256 176a80 80 0 1 0 0 160 80 80 0 1 0 0-160zm128 80a128 128 0 1 1 -256 0 128 128 0 1 1 256 0z"]]
};
var faGridHorizontal = {
  prefix: 'fad',
  iconName: 'grid-horizontal',
  icon: [448, 512, [], "e307", ["M160 168c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V168zM0 328c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V328zm360-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V328c0-22.1 17.9-40 40-40z", "M0 168c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V168zM160 328c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V328zM448 168v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z"]]
};
var faMessageDollar = {
  prefix: 'fad',
  iconName: 'message-dollar',
  icon: [512, 512, ["comment-alt-dollar"], "f650", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm276 40c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z", "M256 84c11 0 20 9 20 20v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V312c0 11-9 20-20 20s-20-9-20-20V297.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V104c0-11 9-20 20-20z"]]
};
var faCommentAltDollar = faMessageDollar;
var faRightLeft = {
  prefix: 'fad',
  iconName: 'right-left',
  icon: [512, 512, ["exchange-alt"], "f362", ["M512 384c0-17.7-14.3-32-32-32l-320 0 0-64c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-96 96c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6l96 96c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-64 320 0c17.7 0 32-14.3 32-32z", "M0 128c0-17.7 14.3-32 32-32l320 0 0-64c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-64L32 160c-17.7 0-32-14.3-32-32z"]]
};
var faExchangeAlt = faRightLeft;
var faColumns3 = {
  prefix: 'fad',
  iconName: 'columns-3',
  icon: [640, 512, [], "e361", ["M192 96h64V416H192V96zm192 0h64V416H384V96z", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM576 96V416H64V96H576z"]]
};
var faPaperPlane = {
  prefix: 'fad',
  iconName: 'paper-plane',
  icon: [512, 512, [61913], "f1d8", ["M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L224 402.7V389.4L380.7 185.8c5.2-6.7 4.2-16.4-2.3-21.9s-16.1-5.1-22 1.1L178.8 350.6l-14.1 14.1c-3 3-4.7 7.1-4.7 11.3l-28.3-11.8-112-46.7C8.4 312.8 .8 302.2 .1 290s5.5-23.7 16.1-29.8l448-256c10.7-6.1 23.9-5.5 34 1.4z", "M380.7 185.8c5.1-6.7 4.2-16.2-2.1-21.8s-15.9-5.3-21.9 .7l-179 179-13 13c-3 3-4.7 7.1-4.7 11.3v8 56 48c0 13.2 8.1 25 20.3 29.8s26.2 1.6 35.2-8.1L284 427.7l-60-25V389.4L380.7 185.8z"]]
};
var faRoadCircleExclamation = {
  prefix: 'fad',
  iconName: 'road-circle-exclamation',
  icon: [640, 512, [], "e565", ["M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32l.7 0c-.5-5.3-.7-10.6-.7-16c0-16.9 2.4-33.3 6.8-48.7c-2.2 .5-4.5 .7-6.8 .7c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32v42.8c31.9-45.2 84.5-74.8 144-74.8c11.6 0 22.9 1.1 33.8 3.2L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"]]
};
var faDungeon = {
  prefix: 'fad',
  iconName: 'dungeon',
  icon: [512, 512, [], "f6d9", ["M256 176c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16zm-64 32c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16zm128 0c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16z", "M327.1 125.3l30.5-76.2c5.2-12.9 20.3-18.8 32.1-11.6c21.2 13 40.3 29 56.9 47.4c9.1 10.2 6.3 25.8-5.1 33.4l-67.6 45.1c-10.3 6.9-24.1 4.6-33.4-3.6c-1.3-1.1-2.6-2.3-3.9-3.3c-9.3-7.5-13.9-20.1-9.5-31.2zM313 6.4c13.4 3.1 20.1 17.6 15 30.5l-30.3 75.8c-4.5 11.3-16.8 17.2-29 16c-4.2-.4-8.4-.6-12.7-.6s-8.6 .2-12.7 .6c-12.1 1.2-24.4-4.7-29-16L184 36.8C178.8 24 185.5 9.4 199 6.4C217.3 2.2 236.4 0 256 0s38.7 2.2 57 6.4zM70.5 118.5C59.1 110.9 56.3 95.2 65.5 85C82 66.6 101.1 50.6 122.3 37.6c11.9-7.3 26.9-1.4 32.1 11.6l30.5 76.2c4.4 11.1-.2 23.6-9.5 31.2c-1.3 1.1-2.7 2.2-4 3.3c-9.3 8.2-23 10.5-33.4 3.6L70.5 118.5zm319 73.1l68.6-45.7c11.7-7.8 27.6-4 33.1 8.9c10.4 24.1 17.2 50.1 19.7 77.3c1.2 13.2-9.6 24-22.9 24H408c-13.3 0-23.8-10.8-26.2-23.9c-.6-3.4-1.4-6.7-2.3-10c-3.1-11.4 .2-24 10-30.5zM20.8 154.7c5.5-12.9 21.4-16.6 33.1-8.9l68.6 45.7c9.8 6.5 13.2 19.2 10 30.5c-.9 3.3-1.7 6.6-2.3 10c-2.5 13-13 23.9-26.2 23.9H24C10.7 256-.1 245.2 1.1 232c2.5-27.2 9.3-53.2 19.7-77.3zM128 312v48c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V312c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24zm256 0c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H408c-13.3 0-24-10.7-24-24V312zM0 440c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V440zm384 0c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H408c-13.3 0-24-10.7-24-24V440z"]]
};
var faHandHoldingBox = {
  prefix: 'fad',
  iconName: 'hand-holding-box',
  icon: [576, 512, [], "f47b", ["M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z", "M224 0V121.7c0 3.5 2.8 6.3 6.3 6.3c1.1 0 2.2-.3 3.1-.8l46.6-26.6c4.9-2.8 11-2.8 15.9 0l46.6 26.6c1 .5 2 .8 3.1 .8c3.5 0 6.3-2.8 6.3-6.3V0h80c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48h80z"]]
};
var faInputText = {
  prefix: 'fad',
  iconName: 'input-text',
  icon: [640, 512, [], "e1bf", ["M576 128V384H64V128H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z", "M205.9 174.3c-3.9-8.7-12.4-14.3-21.9-14.3s-18.1 5.6-21.9 14.3l-64 144c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l4.3-9.7h75.5l4.3 9.7c5.4 12.1 19.6 17.6 31.7 12.2s17.6-19.6 12.2-31.7l-64-144zM200.4 280H167.6L184 243.1 200.4 280zM304 184v8 64 64 8c0 13.3 10.7 24 24 24h68c33.1 0 60-26.9 60-60c0-18.6-8.5-35.3-21.8-46.3c3.7-7.8 5.8-16.5 5.8-25.7c0-33.1-26.9-60-60-60H328c-13.3 0-24 10.7-24 24zm48 24h28c6.6 0 12 5.4 12 12s-5.4 12-12 12H352V208zm0 96V280h28 16c6.6 0 12 5.4 12 12s-5.4 12-12 12H352z"]]
};
var faWindowFlip = {
  prefix: 'fad',
  iconName: 'window-flip',
  icon: [512, 512, ["window-alt"], "f40f", ["M384 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64V224L0 224V416zM320 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M448 32c35.3 0 64 28.7 64 64V224H0V96C0 60.7 28.7 32 64 32H448zM416 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faWindowAlt = faWindowFlip;
var faAlignRight = {
  prefix: 'fad',
  iconName: 'align-right',
  icon: [448, 512, [], "f038", ["M192 352c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H192zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H192z", "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"]]
};
var faScannerGun = {
  prefix: 'fad',
  iconName: 'scanner-gun',
  icon: [576, 512, ["scanner"], "f488", ["M112 32C50.1 32 0 82.1 0 144c0 50.7 33.8 93.6 80 107.4L8.1 374.7c-13.3 22.8-5.7 52.2 17.1 65.6l53.4 31.4c22.8 13.4 52.3 5.8 65.7-17L261.2 256H304c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H112z", "M440 32c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H440zm0 160c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H440zM416 440v16c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zm16-312c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432zM416 304c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"]]
};
var faScanner = faScannerGun;
var faTire = {
  prefix: 'fad',
  iconName: 'tire',
  icon: [512, 512, [], "f631", ["M239.9 318l0 65c-44.2-5.5-81.5-33.6-99.8-72.4l61.9-20.1c8.6 13.4 22.1 23.4 37.9 27.5zm32 0c15.9-4.1 29.4-14.1 38-27.6l61.9 20.1c-18.3 38.8-55.6 66.9-99.8 72.4l0-65zm47.9-58c.1-1.3 .1-2.7 .1-4c0-15.4-5.5-29.6-14.5-40.6l38.2-52.6C368.5 186.1 384 219.2 384 256c0 8.3-.8 16.3-2.3 24.2L319.9 260zm-40.2-63.5c-7.3-2.9-15.3-4.5-23.6-4.5s-16.3 1.6-23.6 4.5l-10-13.8-28.1-38.8C212.5 133.8 233.6 128 256 128s43.5 5.8 61.8 15.9l-38.2 52.6zm-73.1 18.9c-9.1 11-14.5 25.2-14.5 40.6c0 1.4 0 2.7 .1 4l-61.8 20.1c-1.5-7.8-2.3-15.9-2.3-24.2c0-36.8 15.5-69.9 40.3-93.3l28.1 38.7 10.1 13.9zM256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm416 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faEngine = {
  prefix: 'fad',
  iconName: 'engine',
  icon: [640, 512, [], "e16e", ["M424 88c0-13.3-10.7-24-24-24H208c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0v32h48V112l72 0c13.3 0 24-10.7 24-24zM24 136c-13.3 0-24 10.7-24 24V352c0 13.3 10.7 24 24 24s24-10.7 24-24V280H96V232H48V160c0-13.3-10.7-24-24-24zm552 56c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H576z", "M96 176c0-17.7 14.3-32 32-32h32 48H409.5c14.5 0 28.6 4.9 40 14L488 188.8c15.2 12.1 24 30.5 24 50V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H128c-17.7 0-32-14.3-32-32V176zM288 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faMoneyBill1Wave = {
  prefix: 'fad',
  iconName: 'money-bill-1-wave',
  icon: [576, 512, ["money-bill-wave-alt"], "f53b", ["M512 160c-33.9 0-61.6-26.3-63.9-59.7c-40 .9-83.5 10.5-134.2 23.2c-4.6 1.2-9.4 2.3-14.2 3.6l0 0c-51.1 12.8-110.4 27.8-172.9 28.6C121.5 185.4 95.4 208 64 208V352c33.9 0 61.6 26.3 63.9 59.7c40-.9 83.5-10.5 134.2-23.2c4.7-1.2 9.4-2.3 14.2-3.6l0 0c51.1-12.8 110.4-27.8 172.9-28.6c5.5-29.8 31.6-52.4 63-52.4V160zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z", "M0 418.3V115.8C0 92 25.4 76.2 48.4 82.4C128.2 103.9 208.1 84 288 64c86.9-21.7 173.8-43.5 260.7-11.8C565.8 58.5 576 75.5 576 93.7V396.2c0 23.8-25.4 39.5-48.3 33.3C447.8 408.1 367.9 428 288 448c-86.9 21.7-173.8 43.4-260.7 11.8C10.2 453.5 0 436.5 0 418.3zm448.1-318c-40 .9-83.5 10.5-134.2 23.2c-4.6 1.2-9.4 2.3-14.2 3.6l0 0c-51.1 12.8-110.4 27.8-172.9 28.6C121.5 185.4 95.4 208 64 208V352c33.9 0 61.6 26.3 63.9 59.7c40-.9 83.5-10.5 134.2-23.2c4.7-1.2 9.4-2.3 14.2-3.6l0 0c51.1-12.8 110.4-27.8 172.9-28.6c5.5-29.8 31.6-52.4 63-52.4V160c-33.9 0-61.6-26.3-63.9-59.7zM272 188h16c11 0 20 9 20 20v68h4c11 0 20 9 20 20s-9 20-20 20H288 264c-11 0-20-9-20-20s9-20 20-20h4V227.6c-9.1-1.9-16-9.9-16-19.6c0-11 9-20 20-20z"]]
};
var faMoneyBillWaveAlt = faMoneyBill1Wave;
var faLifeRing = {
  prefix: 'fad',
  iconName: 'life-ring',
  icon: [512, 512, [], "f1cd", ["M214.7 169.5c12.5-6 26.5-9.5 41.3-9.5s28.8 3.5 41.3 9.5c-.1 .1 .1-.1 0 0L412.8 53.9C369.5 20.3 315.2 0 256 0S142.5 20.3 99.2 53.9L214.7 169.5c.1 .1-.1-.1 0 0zM169.5 297.3c-6-12.5-9.5-26.5-9.5-41.3s3.5-28.8 9.5-41.3c-.1-.1 .1 .1 0 0L53.9 99.2C20.3 142.5 0 196.8 0 256s20.3 113.5 53.9 156.8L169.5 297.3c.1-.1-.1 .1 0 0zM458.1 99.2L342.5 214.7c-.1 .1 .1-.1 0 0c6 12.5 9.5 26.5 9.5 41.3s-3.5 28.8-9.5 41.3c-.1-.1 .1 .1 0 0L458.1 412.8C491.7 369.5 512 315.2 512 256s-20.3-113.5-53.9-156.8zM297.3 342.5c-12.5 6-26.5 9.5-41.3 9.5s-28.8-3.5-41.3-9.5c-.1 .1 .1-.1 0 0L99.2 458.1C142.5 491.7 196.8 512 256 512s113.5-20.3 156.8-53.9L297.3 342.5c.1 .1-.1-.1 0 0z", "M57.4 57.4c-12.5 12.5-12.5 32.8 0 45.3l112 112c9.5-19.8 25.5-35.8 45.3-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm112 240l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c-19.8-9.5-35.8-25.5-45.3-45.3zm128 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-112-112c-9.5 19.8-25.5 35.8-45.3 45.3zm45.3-128l112-112c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-112 112c19.8 9.5 35.8 25.5 45.3 45.3z"]]
};
var faHands = {
  prefix: 'fad',
  iconName: 'hands',
  icon: [576, 512, ["sign-language", "signing"], "f2a7", ["M544 160c0-17.7-14.3-32-32-32s-32 14.3-32 32l-.1 49.3L426.1 116l0 0 0 0L368.6 16.5C362 5 347.3 1.1 335.8 7.7s-15.4 21.3-8.8 32.8l51.5 89.1c3.3 5.7 1.3 13.1-4.4 16.4s-13.1 1.3-16.4-4.4L290.3 24.8C283.6 13.3 269 9.4 257.5 16s-15.4 21.3-8.8 32.8l45.9 79.5c9.4 1 18.7 4.1 27.3 9.4l60.2 37.6C443 213.4 480 280.2 480 352v8c0 1.9 0 3.8-.1 5.7c40.1-32.1 64-80.9 64-133.1L544 160zM268.5 131L243.9 88.5c-6.6-11.5-21.3-15.4-32.8-8.8s-15.4 21.3-8.8 32.8l28.9 50c.8-1.5 1.6-3 2.5-4.4c8.4-13.4 20.8-22.6 34.7-27zm-44.1 67.5l-26.8-46.4c-6.6-11.5-21.3-15.4-32.8-8.8s-15.4 21.3-8.8 32.8L179 216h31.8l0 0H224h4.7c-2.2-5.6-3.7-11.4-4.3-17.4z", "M305 164.9c-15-9.4-34.7-4.8-44.1 10.2s-4.8 34.7 10.2 44.1L317.2 248H224l0 0 0 0H88c-13.3 0-24 10.7-24 24s10.7 24 24 24H212c6.6 0 12 5.4 12 12s-5.4 12-12 12H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H212c6.6 0 12 5.4 12 12s-5.4 12-12 12H88c-13.3 0-24 10.7-24 24s10.7 24 24 24H212c6.6 0 12 5.4 12 12s-5.4 12-12 12H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H296c83.9 0 152-68.1 152-152v-8c0-60.8-31.3-117.3-82.9-149.5L305 164.9z"]]
};
var faSignLanguage = faHands;
var faSigning = faHands;
var faCircleCaretRight = {
  prefix: 'fad',
  iconName: 'circle-caret-right',
  icon: [512, 512, ["caret-circle-right"], "f330", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm368 0c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z", "M360.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 208c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"]]
};
var faCaretCircleRight = faCircleCaretRight;
var faWheat = {
  prefix: 'fad',
  iconName: 'wheat',
  icon: [512, 512, [], "f72d", ["M281.9 184.8l-30.5 30.5c2.1 17 .8 34.4-4 51c15.6-4.5 31.8-5.9 47.8-4.3l31.9-31.9-10.4-10.4L294.2 197l-12.2-12.2zM225.4 331.9L215 321.5l0 0-34.8-34.8-30.5 30.5c2.1 17 .8 34.4-4 51c15.6-4.5 31.8-5.9 47.8-4.3l31.9-31.9zM123.5 433.7l-10.4-10.4 0 0L78.3 388.5 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9z", "M384 88c0-48.6 39.4-88 88-88h24c8.8 0 16 7.2 16 16V40c0 48.6-39.4 88-88 88H400c-8.8 0-16-7.2-16-16V88zM181 129.1c6.2-6.2 16.4-6.2 22.6 0L215 140.5c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0L215 321.5l0 0-45.3-45.3c-37.5-37.5-37.5-98.3 0-135.8L181 129.1zM282.8 27.3c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-22.6-22.6 0 0-45.3-45.3c-37.5-37.5-37.5-98.3 0-135.8l11.3-11.3zM79.2 231c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5L282.8 412c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-22.6-22.6s0 0 0 0L67.9 378c-37.5-37.5-37.5-98.3 0-135.8L79.2 231z"]]
};
var faFileSpreadsheet = {
  prefix: 'fad',
  iconName: 'file-spreadsheet',
  icon: [384, 512, [], "f65b", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM88 224c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H296c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H88z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM88 224c-17.7 0-32 14.3-32 32v16 80 64c0 17.7 14.3 32 32 32h64 80 64c17.7 0 32-14.3 32-32V352 272 256c0-17.7-14.3-32-32-32H88zm0 112V288h48v48H88zm80 0V288h48v48H168zm80 0V288h48v48H248zm0 32h48v48H248V368zm-32 0v48H168V368h48zm-80 0v48H88V368h48z"]]
};
var faAudioDescriptionSlash = {
  prefix: 'fad',
  iconName: 'audio-description-slash',
  icon: [640, 512, [], "e0a8", ["M314.3 343.6L487.4 480H96c-35.3 0-64-28.7-64-64V121.2L173 232.3l-42.5 85c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l9.4-18.9h82.2l9.4 18.9c5.9 11.9 20.3 16.7 32.2 10.7c3-1.5 5.5-3.5 7.5-5.9zM211.5 262.6l21.8 17.2H202.9l8.6-17.2zM608 416c0 10.7-2.6 20.7-7.2 29.6L464.6 338.8C493 322.1 512 291.3 512 256c0-53-43-96-96-96H360c-13.3 0-24 10.7-24 24v54L76.8 34.9C82.9 33 89.3 32 96 32H544c35.3 0 64 28.7 64 64V416zM464 256c0 25.2-19.4 45.8-44.1 47.8L384 275.7V208h32c26.5 0 48 21.5 48 48z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faCalendarDay = {
  prefix: 'fad',
  iconName: 'calendar-day',
  icon: [448, 512, [], "f783", ["M448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM80 256h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16z", "M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v80H0V112C0 85.5 21.5 64 48 64H96V32z"]]
};
var faWaterLadder = {
  prefix: 'fad',
  iconName: 'water-ladder',
  icon: [576, 512, ["ladder-water", "swimming-pool"], "f5c5", ["M269.5 389.9c11.1-7.9 25.9-7.9 37 0C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1z", "M223.7 32C170.9 32 128 74.9 128 127.7V361c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.1 20.3V288H384v96.5s0 0 0 0c19 0 41.2-7.9 59.2-20.3c1.6-1.1 3.2-2.1 4.8-3.1V127.7c0-17.5 14.2-31.7 31.7-31.7c16 0 29.5 11.9 31.5 27.8l1 8.2c2.2 17.5 18.2 30 35.7 27.8s30-18.2 27.8-35.7l-1-8.2C568.7 68 528 32 479.7 32C426.9 32 384 74.9 384 127.7V224H192V127.7c0-17.5 14.2-31.7 31.7-31.7c16 0 29.5 11.9 31.5 27.8l1 8.2c2.2 17.5 18.2 30 35.7 27.8s30-18.2 27.8-35.7l-1-8.2C312.7 68 272 32 223.7 32z"]]
};
var faLadderWater = faWaterLadder;
var faSwimmingPool = faWaterLadder;
var faArrowsUpDown = {
  prefix: 'fad',
  iconName: 'arrows-up-down',
  icon: [320, 512, ["arrows-v"], "f07d", ["M182.6 502.6c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L128 402.7V256h64V402.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96z", "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V256h64V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"]]
};
var faArrowsV = faArrowsUpDown;
var faChessPawnPiece = {
  prefix: 'fad',
  iconName: 'chess-pawn-piece',
  icon: [256, 512, ["chess-pawn-alt"], "f444", ["M208 416H48L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416z", "M176 240c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4.4L48 416H208L179.6 288H184c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8z"]]
};
var faChessPawnAlt = faChessPawnPiece;
var faFaceGrimace = {
  prefix: 'fad',
  iconName: 'face-grimace',
  icon: [512, 512, [128556, "grimace"], "f57f", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-112h-8V360l55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344V304h8c23.8 0 43.5 17.3 47.3 40zM328 344H264V304h64v40zm0 56H264V360h64v40zm-80-96v40l-64 0V304h64zm0 56v40H184V360l64 0zm-80-16H112.7c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faGrimace = faFaceGrimace;
var faWheelchairMove = {
  prefix: 'fad',
  iconName: 'wheelchair-move',
  icon: [448, 512, ["wheelchair-alt"], "e2ce", ["M160 512a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-256a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM172.8 54.4c9.5-7.1 22.1-8.4 32.8-3.4l116.5 54.8c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288H306.7c-20.5-46.9-62.9-82.1-114.3-92.7l54.2-54.2-50.8-23.9-48.6 36.4c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l64-48z"]]
};
var faWheelchairAlt = faWheelchairMove;
var faTurnDown = {
  prefix: 'fad',
  iconName: 'turn-down',
  icon: [384, 512, [10549, "level-down-alt"], "f3be", ["M144 320l96 0 0-208C240 50.1 189.9 0 128 0L32 0C14.3 0 0 14.3 0 32L0 64C0 81.7 14.3 96 32 96l96 0c8.8 0 16 7.2 16 16l0 208z", "M40.3 368.3L178.3 506.3c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L343.7 368.3c5.3-5.3 8.3-12.5 8.3-20c0-15.6-12.7-28.3-28.3-28.3L60.3 320C44.7 320 32 332.7 32 348.3c0 7.5 3 14.7 8.3 20z"]]
};
var faLevelDownAlt = faTurnDown;
var faSquareS = {
  prefix: 'fad',
  iconName: 'square-s',
  icon: [448, 512, [], "e27d", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6 0 0c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z", "M191 180.4c-10.3 4.1-14.2 9.6-15.4 15.8c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4c.7 .2 1.3 .4 2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4c-.7-.2-1.3-.4-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7l3.6-23.7-3.6 23.7c-20.3-3.1-36.8-1.4-47.8 2.9z"]]
};
var faRectangleBarcode = {
  prefix: 'fad',
  iconName: 'rectangle-barcode',
  icon: [576, 512, ["barcode-alt"], "f463", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 96c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm56 16c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm88-16c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm88 24c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm112-24c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z", "M96 152c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm80-8c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm88-16c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm88 24c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm112-24c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z"]]
};
var faBarcodeAlt = faRectangleBarcode;
var faPersonWalkingArrowRight = {
  prefix: 'fad',
  iconName: 'person-walking-arrow-right',
  icon: [640, 512, [], "e552", ["", "M505.4 153.4c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L530.7 288H384c-17.7 0-32-14.3-32-32s14.3-32 32-32H530.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3zM160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"]]
};
var faSquareEnvelope = {
  prefix: 'fad',
  iconName: 'square-envelope',
  icon: [448, 512, ["envelope-square"], "f199", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z", "M64.2 172.4L218 271.7c1.8 1.2 3.9 1.8 6 1.8s4.2-.6 6-1.8l153.8-99.3C382 156.4 368.5 144 352 144H96c-16.5 0-30 12.4-31.8 28.4zm319.8 38L247.4 298.6c-7 4.5-15.1 6.9-23.4 6.9s-16.4-2.4-23.4-6.9L64 210.4V336c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V210.4z"]]
};
var faEnvelopeSquare = faSquareEnvelope;
var faDice = {
  prefix: 'fad',
  iconName: 'dice',
  icon: [640, 512, [127922], "f522", ["M173.1 34.3c28.1-28.1 73.7-28.1 101.8 0L413.7 173.1c28.1 28.1 28.1 73.7 0 101.8L274.9 413.7c-28.1 28.1-73.7 28.1-101.8 0L34.3 274.9c-28.1-28.1-28.1-73.7 0-101.8L173.1 34.3zM224 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM248 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM376 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM248 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z", "M224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm128 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 176a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM320 448V413.8L436.3 297.5c28.6-28.6 37-69.6 25.4-105.5H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H384c-35.3 0-64-28.7-64-64zm160-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faUnicorn = {
  prefix: 'fad',
  iconName: 'unicorn',
  icon: [640, 512, [129412], "f727", ["M560 90.7l73.6-24.5c3.8-1.3 6.4-4.8 6.4-8.8c0-5.1-4.2-9.3-9.3-9.3H551.4c5.4 9.4 8.6 20.3 8.6 32V90.7zM48 256c0-13.4 6.6-25.2 16.7-32.5c-.4-3.5-.7-7.1-.7-10.7c0-16.1 4.5-31.2 12.3-44.1C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256z", "M448 238.1V160l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H544c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 464 448C377.3 0 320 57.3 320 128H224 203.2 148.8C102 128 64 166 64 212.8c0 16.8 5 33.1 14.2 47.1l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faBowlingBall = {
  prefix: 'fad',
  iconName: 'bowling-ball',
  icon: [512, 512, [], "f436", ["M208 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faPompebled = {
  prefix: 'fad',
  iconName: 'pompebled',
  icon: [512, 512, [], "e43d", ["M460.3 172c-46.2-33.2-117-14.1-165.1 44.3c-5.9 8.6-17.2 10.6-25.6 4.5s-10.3-17.6-4.4-26.2c36.9-66.9 29-141.3-17.7-173.5C188.6-20.6 103.1 1.5 56.9 70.4c-85.5 126.3-77.6 313.4 44.2 400.4c121.4 87 296.3 27.7 381.8-98.6c46.2-68.4 36.4-158.5-22.6-200.2z", ""]]
};
var faBrain = {
  prefix: 'fad',
  iconName: 'brain',
  icon: [512, 512, [129504], "f5dc", ["M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z", "M240 456V56h32V456H240z"]]
};
var faWatchSmart = {
  prefix: 'fad',
  iconName: 'watch-smart',
  icon: [384, 512, [], "e2cc", ["M80 64C35.8 64 0 99.8 0 144V368c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80H80zm136 96v86.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17V160c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M112.3 0C85.6 0 64 21.6 64 48.3V65.6c5.2-1 10.5-1.6 16-1.6H304c5.5 0 10.8 .6 16 1.6V48.3C320 21.6 298.4 0 271.7 0H112.3zM64 464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V446.4c-5.2 1-10.5 1.6-16 1.6H80c-5.5 0-10.8-.6-16-1.6V464zM216 160c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41V160z"]]
};
var faBookUser = {
  prefix: 'fad',
  iconName: 'book-user',
  icon: [448, 512, [], "f7e7", ["M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 256 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H256h96 64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm80 128a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM128 304c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16z"]]
};
var faSensorCloud = {
  prefix: 'fad',
  iconName: 'sensor-cloud',
  icon: [640, 512, ["sensor-smoke"], "e02c", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V234.8c-14.5-6.9-30.8-10.8-48-10.8c-60.1 0-109.1 47.3-111.9 106.7C250.2 348.7 224 387.3 224 432c0 17.2 3.9 33.5 10.8 48H64c-35.3 0-64-28.7-64-64V96zm88 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24z", "M256 432c0 44.2 35.8 80 80 80H560c44.2 0 80-35.8 80-80c0-39-27.9-71.5-64.8-78.6c.5-3.1 .8-6.2 .8-9.4c0-30.9-25.1-56-56-56c-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C284.4 359.9 256 392.6 256 432z"]]
};
var faSensorSmoke = faSensorCloud;
var faClapperboardPlay = {
  prefix: 'fad',
  iconName: 'clapperboard-play',
  icon: [512, 512, [], "e132", ["M512 160H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160zM216.5 241.9c5.2-2.8 11.5-2.5 16.4 .8l96 64c4.4 3 7.1 8 7.1 13.3s-2.7 10.3-7.1 13.3l-96 64c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V256c0-5.9 3.2-11.3 8.5-14.1z", "M448 32H361.9l-1 1-127 127h92.1l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40l-104 104H512zM294.1 32H201.9l-1 1L73.9 160h92.1l1-1 127-127zM64 32C28.7 32 0 60.7 0 96v64H6.1l1-1 127-127H64zM216.5 241.9c-5.2 2.8-8.5 8.2-8.5 14.1V384c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l96-64c4.4-3 7.1-8 7.1-13.3s-2.7-10.3-7.1-13.3l-96-64c-4.9-3.3-11.2-3.6-16.4-.8z"]]
};
var faBandage = {
  prefix: 'fad',
  iconName: 'bandage',
  icon: [640, 512, [129657, "band-aid"], "f462", ["M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M192 96H160V416h32V96zm288 0H448V416h32V96z"]]
};
var faBandAid = faBandage;
var faCalendarMinus = {
  prefix: 'fad',
  iconName: 'calendar-minus',
  icon: [512, 512, [], "f272", ["M480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM344 376H168c-13.3 0-24-10.7-24-24s10.7-24 24-24H344c13.3 0 24 10.7 24 24s-10.7 24-24 24z", "M160 0c-17.7 0-32 14.3-32 32V64H80c-26.5 0-48 21.5-48 48v80H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32zM344 376c13.3 0 24-10.7 24-24s-10.7-24-24-24H168c-13.3 0-24 10.7-24 24s10.7 24 24 24H344z"]]
};
var faCircleXmark = {
  prefix: 'fad',
  iconName: 'circle-xmark',
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z", "M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faTimesCircle = faCircleXmark;
var faXmarkCircle = faCircleXmark;
var faCircle4 = {
  prefix: 'fad',
  iconName: 'circle-4',
  icon: [512, 512, [], "e0f1", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM223.6 129.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10H272v40c0 13.3 10.7 24 24 24s24-10.7 24-24V320h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H201.3l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z", "M238.8 159.6c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10H272v40c0 13.3 10.7 24 24 24s24-10.7 24-24V320h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H201.3l37.5-112.4z"]]
};
var faGifts = {
  prefix: 'fad',
  iconName: 'gifts',
  icon: [640, 512, [], "f79c", ["M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l9.4 28.3L71.2 37.4C60.9 29 45.8 30.5 37.4 40.8S30.5 66.2 40.8 74.6L67 96H221l26.2-21.4c10.3-8.4 11.8-23.5 3.4-33.8s-23.5-11.8-33.8-3.4L191.3 58.3 200.6 32zM592 224h-4.1c-9.9 28-36.6 48-67.9 48H448v80H640V272c0-26.5-21.5-48-48-48zM448 384V512H592c26.5 0 48-21.5 48-48V384H448zm-32 0H224v80c0 26.5 21.5 48 48 48H416V384zm0-32V272H400 344c-31.3 0-58-20-67.9-48H272c-26.5 0-48 21.5-48 48v80H416z", "M48 96C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H200.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96H48zm315.5 89.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM344 272h56 16v80H224v32H416V512h32V384H640V352H448V272h72c39.8 0 72-32.2 72-72c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72c0 39.8 32.2 72 72 72zm175.8-96c13.4 0 24.2 10.9 24.2 24c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5z"]]
};
var faAlbumCollection = {
  prefix: 'fad',
  iconName: 'album-collection',
  icon: [512, 512, [], "f8a0", ["M12 176.2C21.1 165.9 34.2 160 48 160H464c13.8 0 26.9 5.9 36 16.2s13.4 24.1 11.6 37.7l-32 256c-3 24-23.4 42-47.6 42H80c-24.2 0-44.6-18-47.6-42L.4 214c-1.7-13.7 2.5-27.4 11.6-37.7zM256 480c101.6 0 184-60.9 184-136s-82.4-136-184-136S72 268.9 72 344s82.4 136 184 136z", "M32 24c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C42.7 0 32 10.7 32 24zM256 480c101.6 0 184-60.9 184-136s-82.4-136-184-136S72 268.9 72 344s82.4 136 184 136zm0-104c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H472c13.3 0 24-10.7 24-24s-10.7-24-24-24H40z"]]
};
var faHotel = {
  prefix: 'fad',
  iconName: 'hotel',
  icon: [512, 512, [127976], "f594", ["M480 64H32V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H208V464c0-26.5 21.5-48 48-48s48 21.5 48 48v48H480c17.7 0 32-14.3 32-32s-14.3-32-32-32V64zM96 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V112zM240 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V112zM112 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V208zm144-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM328 384H184c-13.3 0-24.3-10.9-21-23.8c10.6-41.5 48.2-72.2 93-72.2s82.5 30.7 93 72.2c3.3 12.8-7.8 23.8-21 23.8z", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm80 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H112zm128 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H240zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H368zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8H328z"]]
};
var faEarthAsia = {
  prefix: 'fad',
  iconName: 'earth-asia',
  icon: [512, 512, [127759, "globe-asia"], "f57e", ["M1.1 280.3l81.7 20.4c8.2 2 16.8-.4 22.8-6.3l14.8-14.8c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17.6-4.4c7.2-1.8 13.1-6.8 16.1-13.5l37.7-84.9C443.2 53 512 146.5 512 256c0 25.2-3.6 49.6-10.4 72.6c-.3-.3-.7-.6-1.1-.8l-31.9-23c-5.9-4.3-13.4-5.6-20.5-3.6l-13.5 3.8c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.4 21.1l3.7-1.4c9.4-3.5 20-2.4 28.4 3.1l45.1 28.9C382.7 486.8 322.3 512 256 512C122.8 512 13.4 410.3 1.1 280.3zm162.7 56.2c-8.6-2.1-17.3 3.1-19.4 11.6s3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8zm84.2 11c8.6 2.1 17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32c-2.1 8.6 3.1 17.3 11.6 19.4zM350.3 135.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32z", "M1.1 280.3l81.7 20.4c8.2 2 16.8-.4 22.8-6.3l14.8-14.8c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17.6-4.4c7.2-1.8 13.1-6.8 16.1-13.5l37.7-84.9C318.3 5.8 287.8 0 256 0C114.6 0 0 114.6 0 256c0 8.2 .4 16.3 1.1 24.3zm500.4 48.3c-.3-.3-.7-.6-1.1-.8l-31.9-23c-5.9-4.3-13.4-5.6-20.5-3.6l-13.5 3.8c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.4 21.1l3.7-1.4c9.4-3.5 20-2.4 28.4 3.1l45.1 28.9c34.2-31.1 60-71.4 73.5-116.9zM144.5 348.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"]]
};
var faGlobeAsia = faEarthAsia;
var faIdCardClip = {
  prefix: 'fad',
  iconName: 'id-card-clip',
  icon: [576, 512, ["id-card-alt"], "f47f", ["M64 64H224v64H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H352V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z", "M256 0c-17.7 0-32 14.3-32 32v96H352V32c0-17.7-14.3-32-32-32H256zm96 288a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3z"]]
};
var faIdCardAlt = faIdCardClip;
var faMagnifyingGlassPlus = {
  prefix: 'fad',
  iconName: 'magnifying-glass-plus',
  icon: [512, 512, ["search-plus"], "f00e", ["M208 416A208 208 0 1 0 208 0a208 208 0 1 0 0 416zM184 296V232H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V120c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H232v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M184 296V232H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V120c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H232v64c0 13.3-10.7 24-24 24s-24-10.7-24-24zM457.4 502.6L330.7 376C348 363.3 363.3 348 376 330.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"]]
};
var faSearchPlus = faMagnifyingGlassPlus;
var faThumbsUp = {
  prefix: 'fad',
  iconName: 'thumbs-up',
  icon: [512, 512, [128077, 61575], "f164", ["M351.1 89.4c5.2-26-11.7-51.3-37.7-56.5s-51.3 11.7-56.5 37.7L254.6 82c-6.6 33.2-24.8 63-51.2 84.2l-7.4 5.9c-22.8 18.2-36 45.8-36 75V272v48 38.3c0 32.1 16 62.1 42.7 79.9l38.5 25.7c15.8 10.5 34.3 16.1 53.3 16.1H392c26.5 0 48-21.5 48-48c0-3.6-.4-7-1.1-10.4c19.2-6.3 33.1-24.3 33.1-45.6c0-9.1-2.5-17.6-6.9-24.9c22.2-4.2 38.9-23.7 38.9-47.1c0-15.1-7-28.6-17.9-37.4c15.4-8 25.9-24.1 25.9-42.6c0-26.5-21.5-48-48-48H320c13.7-23.1 23.5-48.5 28.8-75.2l2.3-11.4z", "M0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224z"]]
};
var faCloudShowers = {
  prefix: 'fad',
  iconName: 'cloud-showers',
  icon: [512, 512, [], "f73f", ["M136 376c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V376zm192 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V376zm-120 8c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V408c0-13.3-10.7-24-24-24zm216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V408z", "M0 224c0 53 43 96 96 96H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z"]]
};
var faUserClock = {
  prefix: 'fad',
  iconName: 'user-clock',
  icon: [640, 512, [], "f4fd", ["M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
};
var faOnion = {
  prefix: 'fad',
  iconName: 'onion',
  icon: [448, 512, [129477], "e427", ["M213.5 10.9l3.4 6.8c2.9 5.9 11.4 5.9 14.3 0l3.4-6.8C237.9 4.2 244.7 0 252.2 0c10.9 0 19.6 9 21.3 19.8C281 67.8 316 96.2 352.7 126C399 163.7 448 203.5 448 288c0 112-112.8 174.4-224 176C112.8 462.4 0 400 0 288c0-84.5 49-124.3 95.3-162C132 96.2 167 67.8 174.5 19.8C176.2 9 184.9 0 195.8 0c7.5 0 14.3 4.2 17.7 10.9zM97.5 185.2l-.4 .9c-.4 .8-.9 1.9-1.6 3.4c-1.3 2.9-3.2 7.1-5.4 12.3c-4.3 10.4-9.8 25-14.5 41.8c-9.2 32.7-16.5 76.9-2.6 114c3.1 8.3 12.3 12.5 20.6 9.4s12.5-12.3 9.4-20.6c-10.1-27-5.4-62.7 3.4-94c4.3-15.3 9.3-28.6 13.3-38.2c2-4.8 3.7-8.6 4.9-11.2c.6-1.3 1.1-2.3 1.4-2.9l.3-.7c.6-1.1 1-2.3 1.3-3.6c.5-2 .6-4 .3-5.9c-.6-4.5-3.1-8.6-7-11.2c-1.6-1-3.3-1.8-5.2-2.2s-3.8-.5-5.6-.3c-4.7 .6-8.8 3.2-11.3 6.9c-.5 .7-.9 1.4-1.2 2.2zm111.9-63.9l-.6 1.2c-.5 1.1-1.2 2.6-2.1 4.6c-1.8 4-4.3 9.7-7.1 17c-5.7 14.5-12.9 35.2-19.1 60c-12.3 49.4-20.9 116.3-4 183.8c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-15.1-60.5-7.7-121.6 4-168.2c5.8-23.2 12.6-42.5 17.9-56c2.6-6.7 4.9-12 6.5-15.5c.8-1.8 1.4-3.1 1.8-4l.5-1 0 0c.6-1.2 1.1-2.4 1.4-3.7c.4-1.9 .5-3.8 .3-5.6c-.6-4.7-3.2-8.8-7-11.4c-1.6-1-3.3-1.8-5.2-2.2s-3.8-.5-5.6-.3c-4.5 .6-8.7 3-11.4 7c-.4 .7-.8 1.4-1.2 2.1l-.1 .1zm84.2 50.9c0 0 0 .1 .1 .1c1.6 3.1 3.9 7.6 6.5 13.2c5.3 11.4 12.2 27.3 18.4 45.6c12.6 37.3 21.2 81.4 11.2 116.5c-2.4 8.5 2.5 17.3 11 19.8s17.4-2.5 19.8-11c12.7-44.9 1.4-96.8-11.7-135.5c-6.7-19.7-14-36.8-19.8-48.9c-2.9-6.1-5.3-11-7.1-14.3c-.9-1.7-1.6-3-2.1-3.9l-.6-1.1-.2-.3 0-.1 0 0 0 0s0 0-1 .5c0 0 0 0 0 0l1-.6c-3-5.4-8.8-8.4-14.6-8.2c-.2 0-.4 0-.6 0c-8.8 0-16 7.2-16 16c0 4.9 2.2 9.3 5.7 12.2z", "M131.9 448.3l-10.7 32.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2L178.6 460c-16-2.6-31.7-6.5-46.7-11.6zM200 462.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24V462.7c-8 .7-16 1.2-24 1.3c-8-.1-16-.5-24-1.3zm69.4-2.7l11.9 35.6c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-10.7-32.1c-15 5.1-30.7 9-46.7 11.6z"]]
};
var faClockTwelveThirty = {
  prefix: 'fad',
  iconName: 'clock-twelve-thirty',
  icon: [512, 512, [], "e359", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-360V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M256 128c13.3 0 24 10.7 24 24V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"]]
};
var faArrowDownToDottedLine = {
  prefix: 'fad',
  iconName: 'arrow-down-to-dotted-line',
  icon: [448, 512, [], "e095", ["M0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7V176 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V176v66.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"]]
};
var faHandDots = {
  prefix: 'fad',
  iconName: 'hand-dots',
  icon: [512, 512, ["allergies"], "f461", ["M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z", "M304 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM192 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]]
};
var faAllergies = faHandDots;
var faFileInvoice = {
  prefix: 'fad',
  iconName: 'file-invoice',
  icon: [384, 512, [], "f570", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm0 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 112c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zM224 432c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM96 224c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96zm0 32H288v64H96V256zM240 416c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"]]
};
var faWindowMinimize = {
  prefix: 'fad',
  iconName: 'window-minimize',
  icon: [512, 512, [128469], "f2d1", ["M0 448c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", ""]]
};
var faRectangleWide = {
  prefix: 'fad',
  iconName: 'rectangle-wide',
  icon: [640, 512, [], "f2fc", ["M0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z", ""]]
};
var faCommentArrowUp = {
  prefix: 'fad',
  iconName: 'comment-arrow-up',
  icon: [512, 512, [], "e144", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm24-120c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V328z", "M256 352c13.3 0 24-10.7 24-24V209.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V328c0 13.3 10.7 24 24 24z"]]
};
var faGarlic = {
  prefix: 'fad',
  iconName: 'garlic',
  icon: [512, 512, [129476], "e40e", ["M122.1 137.6c-1 4.2-2.1 8.2-3.3 11.9c-5.4 17.1-12.7 30.1-20.5 43.3c-.8 1.4-1.6 2.8-2.5 4.2c-7.1 11.9-14.8 24.8-20.7 40.5c-6.7 17.8-11 38.8-11 66.5c0 48.6 21 86.5 52.7 111.2C85.5 411.7 0 392.6 0 288c0-55.3 42.3-87.5 83.4-118.9c13.5-10.3 26.9-20.6 38.7-31.5zM314.3 416c32.2-24.7 53.7-62.8 53.7-112c0-52.8-20.4-80.5-39.4-106.3l0 0c-1.2-1.7-2.4-3.3-3.6-5c-9.8-13.4-18.8-26.6-25.5-43.8c-6.7-17-11.4-38.7-11.4-69V0h16c26.5 0 48 21.5 48 48V64c0 46.6 37.8 75.5 76.6 105.1C469.7 200.5 512 232.7 512 288c0 128-128 128-128 128H314.3zM256 0V80c0 33.8 5.3 59.5 13.6 80.7c8.3 21.1 19.3 37 29.5 50.9c1.2 1.6 2.3 3.1 3.4 4.7l0 0C321 241.5 336 261.9 336 304c0 69.3-54.9 112-120 112s-120-42.7-120-112c0-24.2 3.7-41.3 9-55.2c4.9-12.8 11.1-23.3 18.3-35.5l2.5-4.2c8.2-13.8 16.9-29.3 23.5-49.9C155.8 138.5 160 113.4 160 80V64 48c0-26.5 21.5-48 48-48h48z", "M136 488V448h48v40c0 13.3-10.7 24-24 24s-24-10.7-24-24zm64 0V448h48v40c0 13.3-10.7 24-24 24s-24-10.7-24-24zm64 0V448h48v40c0 13.3-10.7 24-24 24s-24-10.7-24-24zm64 0V448h48v40c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]]
};
var faMugSaucer = {
  prefix: 'fad',
  iconName: 'mug-saucer',
  icon: [640, 512, ["coffee"], "f0f4", ["M0 448c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M128 32c-17.7 0-32 14.3-32 32V288c0 53 43 96 96 96H384c53 0 96-43 96-96h32c70.7 0 128-57.3 128-128s-57.3-128-128-128H448 128zM480 96h32c35.3 0 64 28.7 64 64s-28.7 64-64 64H480V96z"]]
};
var faCoffee = faMugSaucer;
var faBrush = {
  prefix: 'fad',
  iconName: 'brush',
  icon: [384, 512, [], "f55d", ["M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48V256v22.4V288H9.6 374.4 384v-9.6V256 48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6z", "M0 288H384v32c0 35.3-28.7 64-64 64H256v64c0 35.3-28.7 64-64 64s-64-28.7-64-64V384H64c-35.3 0-64-28.7-64-64V288zM192 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faTreeDecorated = {
  prefix: 'fad',
  iconName: 'tree-decorated',
  icon: [448, 512, [], "f7dc", ["M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L28.5 313.7c-2.9 4.1-4.5 9-4.5 14.1C24 341.1 34.8 352 48.2 352H80L3.8 474c-2.5 4-3.8 8.5-3.8 13.2C0 500.9 11.1 512 24.9 512H423.1c13.7 0 24.9-11.1 24.9-24.9c0-4.7-1.3-9.2-3.8-13.2L368 352h31.8c13.4 0 24.2-10.9 24.2-24.2c0-5-1.6-10-4.5-14.1L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9zM160 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M256 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm32 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
};
var faMask = {
  prefix: 'fad',
  iconName: 'mask',
  icon: [576, 512, [], "f6fa", ["M288 64C64 64 0 160 0 272S80 448 176 448h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4H400c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M160 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
};
var faCalendarHeart = {
  prefix: 'fad',
  iconName: 'calendar-heart',
  icon: [448, 512, [], "e0d3", ["M448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM112 317.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM112 317.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]]
};
var faMagnifyingGlassMinus = {
  prefix: 'fad',
  iconName: 'magnifying-glass-minus',
  icon: [512, 512, ["search-minus"], "f010", ["M208 416A208 208 0 1 0 208 0a208 208 0 1 0 0 416zM136 184H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136zM330.7 376L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376z"]]
};
var faSearchMinus = faMagnifyingGlassMinus;
var faFlower = {
  prefix: 'fad',
  iconName: 'flower',
  icon: [448, 512, [127804, 10047], "f7ff", ["M128 480c38.2 0 72.5-16.8 96-43.3c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128c0-38.2-16.8-72.5-43.3-96c26.6-23.5 43.3-57.8 43.3-96c0-70.7-57.3-128-128-128c-38.2 0-72.5 16.8-96 43.3C200.5 48.8 166.2 32 128 32C57.3 32 0 89.3 0 160c0 38.2 16.8 72.5 43.3 96C16.8 279.5 0 313.8 0 352c0 70.7 57.3 128 128 128zm96-304a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M224 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]]
};
var faRightLeftLarge = {
  prefix: 'fad',
  iconName: 'right-left-large',
  icon: [640, 512, [], "e5e1", ["M133.8 491c13.4 13.4 31.6 21 50.6 21c37 0 67.4-28 71.2-64l64.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0H208c-8.8 0-16 7.2-16 16v16 24.4c0 4.2-3.4 7.6-7.6 7.6c-2 0-3.9-.8-5.4-2.2L69.3 336 179 226.2c1.4-1.4 3.4-2.2 5.4-2.2c4.2 0 7.6 3.4 7.6 7.6V256v16c0 8.8 7.2 16 16 16h16 96l0-64H255.6c-3.8-36-34.2-64-71.2-64c-19 0-37.2 7.5-50.6 21L15 299.7C5.4 309.3 0 322.4 0 336s5.4 26.7 15 36.3L133.8 491z", "M506.2 21C492.8 7.5 474.6 0 455.6 0c-37 0-67.4 28-71.2 64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0h16c8.8 0 16-7.2 16-16V96 71.6c0-4.2 3.4-7.6 7.6-7.6c2 0 3.9 .8 5.4 2.2L570.7 176 461 285.8c-1.4 1.4-3.4 2.2-5.4 2.2c-4.2 0-7.6-3.4-7.6-7.6V256 240c0-8.8-7.2-16-16-16H416 320v64h64.4c3.8 36 34.2 64 71.2 64c19 0 37.2-7.5 50.6-21L625 212.3c9.6-9.6 15-22.7 15-36.3s-5.4-26.7-15-36.3L506.2 21z"]]
};
var faRulerVertical = {
  prefix: 'fad',
  iconName: 'ruler-vertical',
  icon: [256, 512, [], "f548", ["M0 48C0 21.5 21.5 0 48 0H208c26.5 0 48 21.5 48 48V96H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z", "M176 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V96H176zM160 208c0 8.8 7.2 16 16 16h80V192H176c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V288H176zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V384H176z"]]
};
var faCirclesOverlap = {
  prefix: 'fad',
  iconName: 'circles-overlap',
  icon: [640, 512, [], "e600", ["M213.4 383.7c10.9 23.1 25.7 44 43.4 62c-10.7 1.6-21.7 2.4-32.8 2.4C100.3 448 0 347.7 0 224S100.3 0 224 0c62.3 0 118.6 25.4 159.2 66.4C393.9 64.8 404.8 64 416 64c123.7 0 224 100.3 224 224s-100.3 224-224 224c-62.3 0-118.6-25.4-159.2-66.4c25.6-3.8 49.8-11.9 71.8-23.5C353.8 438.5 383.8 448 416 448c88.4 0 160-71.6 160-160c0-84.8-66-154.2-149.4-159.7c-10.9-23.1-25.7-44-43.4-62c-25.6 3.8-49.8 11.9-71.8 23.5C286.2 73.5 256.2 64 224 64C135.6 64 64 135.6 64 224c0 84.8 66 154.2 149.4 159.7z", "M256.8 445.6C365 429.7 448 336.6 448 224c0-61.5-24.8-117.1-64.8-157.6C275 82.3 192 175.4 192 288c0 61.5 24.8 117.1 64.8 157.6z"]]
};
var faUserLarge = {
  prefix: 'fad',
  iconName: 'user-large',
  icon: [512, 512, ["user-alt"], "f406", ["M112 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0z", "M0 481.3C0 392.2 72.2 320 161.3 320H350.7C439.8 320 512 392.2 512 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3z"]]
};
var faUserAlt = faUserLarge;
var faStarshipFreighter = {
  prefix: 'fad',
  iconName: 'starship-freighter',
  icon: [576, 512, [], "e03a", ["M0 256C0 379.7 100.3 480 224 480c34.3 0 68.3-5.2 100.9-15.3c-1-1.1-2-2.2-2.9-3.4L225.2 336l-1.2 0c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 7.4-1 14.5-2.9 21.3L383.6 384H432c17.7 0 33.2 9.6 41.5 23.9l82.1-31.9c12.3-4.8 20.4-16.6 20.4-29.8V304c0-8.8-7.2-16-16-16H445.7 432c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h13.7H560c8.8 0 16-7.2 16-16V165.9c0-13.2-8.1-25-20.4-29.8L347.6 55.2C308.2 39.9 266.3 32 224 32C100.3 32 0 132.3 0 256zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z", "M128 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM301.1 277.3c1.9-6.8 2.9-13.9 2.9-21.3c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80l1.2 0L322 461.4c9.1 11.8 23.1 18.6 38 18.6h72c26.5 0 48-21.5 48-48s-21.5-48-48-48H383.6L301.1 277.3zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
};
var faTrainTram = {
  prefix: 'fad',
  iconName: 'train-tram',
  icon: [448, 512, [128650], "e5b4", ["M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0H361.2c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15H248V96H200V48H86.8zM35.1 492.9l65.5-65.5c16.3 12.9 37 20.6 59.4 20.6l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1zm307.5 9.7L288 448c22.4 0 43.1-7.7 59.4-20.6l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1H365.3c-8.5 0-16.6-3.4-22.6-9.4zM160 160H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z", "M160 96c-53 0-96 43-96 96V352c0 53 43 96 96 96H288c53 0 96-43 96-96V192c0-53-43-96-96-96H160zm0 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zM128 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faBridgeSuspension = {
  prefix: 'fad',
  iconName: 'bridge-suspension',
  icon: [640, 512, [], "e4cd", ["M128 8c9.1 0 17 5 21 12.5C184.2 81.6 249.7 120 320 120c70.3 0 135.8-38.4 170.9-99.5C495 13.1 502.9 8 512 8c8.8 0 16.5 4.7 20.6 11.8c13.1 21.2 26.6 42.2 42.1 59.8c15.5 17.7 31.7 30.6 49.4 36.9c12.5 4.5 18.9 18.2 14.4 30.7s-18.2 18.9-30.7 14.4c-25.5-9.2-46.4-25.8-63.9-44.5V256H480V108.1c-12.4 10.7-25.8 20.1-40 28.2V256H392V157c-15.5 4.8-31.6 8.1-48 9.8V256H296V166.8c-16.4-1.6-32.5-4.9-48-9.8v99H200V136.3c-14.2-8-27.6-17.5-40-28.2V256H96V117.1c-17.4 18.7-38.4 35.3-63.9 44.5c-12.5 4.5-26.2-2-30.7-14.4s2-26.2 14.4-30.7c17.7-6.4 33.9-19.3 49.4-36.9c15.4-17.6 29-38.5 42-59.7C111.5 12.7 119.2 8 128 8z", "M32 256c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32c35.3 0 64 28.7 64 64v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-53 43-96 96-96h64c53 0 96 43 96 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V416c0-35.3 28.7-64 64-64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H32z"]]
};
var faTrashCheck = {
  prefix: 'fad',
  iconName: 'trash-check',
  icon: [448, 512, [], "e2af", ["M416 96H32L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2H346.7c25.4 0 46.5-19.8 47.9-45.2L416 96zM337 241L209 369c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 207c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM337 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 241z"]]
};
var faUserNurse = {
  prefix: 'fad',
  iconName: 'user-nurse',
  icon: [448, 512, [], "f82f", ["M96 160H352c0 70.7-57.3 128-128 128s-128-57.3-128-128z", "M96 70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V160H96V70.2zm15.9 257.5c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.5 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"]]
};
var faBoombox = {
  prefix: 'fad',
  iconName: 'boombox',
  icon: [640, 512, [128254], "f8a5", ["M0 224c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224zM288 336A112 112 0 1 0 64 336a112 112 0 1 0 224 0zM464 448a112 112 0 1 0 0-224 112 112 0 1 0 0 224z", "M120 48C97.9 48 80 65.9 80 88v72H64c-11.7 0-22.6 3.1-32 8.6V88C32 39.4 71.4 0 120 0H520c48.6 0 88 39.4 88 88v80.6c-9.4-5.4-20.3-8.6-32-8.6H560V88c0-22.1-17.9-40-40-40H120zM448 160H384c0-17.7 14.3-32 32-32s32 14.3 32 32zm-96 0H288c0-17.7 14.3-32 32-32s32 14.3 32 32zm-96 0H192c0-17.7 14.3-32 32-32s32 14.3 32 32zM176 416a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM544 336a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z"]]
};
var faSyringe = {
  prefix: 'fad',
  iconName: 'syringe',
  icon: [512, 512, [128137], "f48e", ["M294.1 72l-83.7 83.7 57 57c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-57-57-41.4 41.4 57 57c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-57-57L80.4 285.7C69.9 296.2 64 310.4 64 325.3v88.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h88.8c14.9 0 29.1-5.9 39.6-16.4L440 217.9c-.3-.3-.7-.6-1-.9l-16-16-56-56L311 89 295 73c-.3-.3-.6-.7-.9-1z", "M441 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15 15L384 94.1 329 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72 72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L456 89.9l15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L473 39 441 7zM210.3 155.7l-22.6 22.6 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57zm-64 64l-22.6 22.6 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"]]
};
var faCloudSun = {
  prefix: 'fad',
  iconName: 'cloud-sun',
  icon: [640, 512, [9925], "f6c4", ["M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1c0-.4 0-.7 0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17.1c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z", "M559.9 511.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.3 242.6 402.8 224 368 224c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H559.9z"]]
};
var faShieldExclamation = {
  prefix: 'fad',
  iconName: 'shield-exclamation',
  icon: [512, 512, [], "e247", ["M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 128c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faStopwatch20 = {
  prefix: 'fad',
  iconName: 'stopwatch-20',
  icon: [448, 512, [], "e06f", ["M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176zM288 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52V256c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12V256c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20H128c-11 0-20-9-20-20V368.3c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z", "M147.6 252.6c1.7-5.1 6.5-8.6 11.9-8.6c6.9 0 12.5 5.6 12.5 12.5v2.2c0 3.6-1.3 7.1-3.7 9.8l-39 43.9c-13.7 15.4-21.2 35.2-21.2 55.8V384c0 11 9 20 20 20h64c11 0 20-9 20-20s-9-20-20-20H148.2c.9-9.2 4.7-17.9 10.9-24.9l39-43.9c8.9-10 13.8-23 13.8-36.4v-2.2c0-29-23.5-52.5-52.5-52.5c-22.6 0-42.7 14.5-49.8 35.9l-.6 1.7c-3.5 10.5 2.2 21.8 12.6 25.3s21.8-2.2 25.3-12.6l.6-1.7zM288 204c-28.7 0-52 23.3-52 52v96c0 28.7 23.3 52 52 52s52-23.3 52-52V256c0-28.7-23.3-52-52-52zm-12 52c0-6.6 5.4-12 12-12s12 5.4 12 12v96c0 6.6-5.4 12-12 12s-12-5.4-12-12V256z"]]
};
var faSquareFull = {
  prefix: 'fad',
  iconName: 'square-full',
  icon: [512, 512, [128997, 128998, 128999, 129000, 129001, 129002, 129003, 11035, 11036], "f45c", ["M0 0H512V512H0V0z", ""]]
};
var faGripDots = {
  prefix: 'fad',
  iconName: 'grip-dots',
  icon: [448, 512, [], "e410", ["M384 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM112 336a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z", "M384 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM112 176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]]
};
var faCommentExclamation = {
  prefix: 'fad',
  iconName: 'comment-exclamation',
  icon: [512, 512, [], "f4af", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm0-336c13.3 0 24 10.7 24 24V248c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24zM224 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M280 136c0-13.3-10.7-24-24-24s-24 10.7-24 24V248c0 13.3 10.7 24 24 24s24-10.7 24-24V136zM256 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faPenSwirl = {
  prefix: 'fad',
  iconName: 'pen-swirl',
  icon: [512, 512, [], "e214", ["M256 8c30.1 0 59 5.4 85.7 15.2L303.6 61.7C288.3 58 272.4 56 256 56C145.5 56 56 145.5 56 256s89.5 200 200 200c13.3 0 24 10.7 24 24s-10.7 24-24 24C119 504 8 393 8 256S119 8 256 8zM456 256c0-16-1.9-31.7-5.5-46.6L489 170.9c9.7 26.5 15 55.2 15 85.1c0 83.9-68.1 152-152 152c-13.1 0-25.8-1.7-38-4.8c-12.8-3.3-20.6-16.4-17.3-29.2s16.4-20.6 29.2-17.3c8.3 2.1 17 3.3 26 3.3c57.4 0 104-46.6 104-104z", "M406.1 16L366.4 55.7l89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4 .4-68.2L473.9 16c-18.8-18.8-49.2-18.7-67.9 0zM343.7 78.4L200.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15L432.8 167.5 343.7 78.4z"]]
};
var faFalafel = {
  prefix: 'fad',
  iconName: 'falafel',
  icon: [576, 512, [129478], "e40a", ["M565.4 373.4c-21.9 21.9-70.8 8.6-109.1-29.8s-51.7-87.2-29.8-109.1s70.8-8.6 109.1 29.8s51.7 87.2 29.8 109.1z", "M166.6 125.5c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-.3 1.3-.6 2.6-.7 3.9c17.2 .6 33.9 8.6 45.1 22.8c28.3 .2 52.1 20.3 58.1 47.4c4.8 2.4 9.2 5.4 13.1 8.8c3.9-3.4 8.3-6.4 13.1-8.8c6-27.1 29.8-47.1 58.1-47.4c17.3-21.9 47.4-29.2 72.8-17c1.5-.7 3-1.4 4.5-1.9c.1-2.6-.2-5.2-.9-7.8c-2.3-9-.1-18.6 5.7-25.7c8.8-10.7 8.8-26.3 0-37c-5.9-7.1-8-16.7-5.7-25.7c3.4-13.5-3.2-27.6-15.7-33.3c-8.3-3.8-14.3-11.5-16.1-20.6c-2.7-13.7-14.6-23.5-28.3-23.1c-9.1 .3-17.8-4-23.2-11.4C344 .3 329.1-3.2 316.9 3.2c-8.1 4.3-17.7 4.3-25.8 0C278.9-3.2 264 .3 255.8 11.4c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7zm76.4 141.4c-3.7-12.1-14.9-20.4-27.6-20.1c-3.6 .1-7.2-.5-10.5-1.8c-5-1.9-9.4-5.2-12.7-9.6c-8.2-11.2-23.2-14.6-35.3-8.2c-8.1 4.3-17.7 4.3-25.8 0c-12.2-6.4-27.1-2.9-35.3 8.2c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-3.4 13.5 3.2 27.6 15.7 33.3c8.3 3.8 14.3 11.5 16.1 20.6c2.7 13.7 14.6 23.5 28.3 23.1c9.1-.3 17.8 4 23.2 11.4c8.2 11.2 23.2 14.6 35.3 8.2c8.1-4.3 17.7-4.3 25.8 0c12.2 6.4 27.1 2.9 35.3-8.2c5.5-7.4 14.1-11.7 23.2-11.4c13.7 .4 25.7-9.4 28.3-23.1c1.8-9.1 7.8-16.8 16.1-20.6c4.1-1.9 7.6-4.7 10.3-8.1c-3.1-10.1-3.7-21-1.2-31.7c-17.3-22.1-17.3-53.3 0-75.4c-2.4-10.7-1.9-21.7 1.2-31.7c-2.7-3.4-6.2-6.2-10.3-8.1c-8.3-3.8-14.3-11.5-16.1-20.6c-.2-1-.5-2-.8-3zM240 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM64 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm469.4-58.6c-21.9 21.9-70.8 8.6-109.1-29.8s-51.7-87.2-29.8-109.1c1.6-1.6 3.3-2.9 5.1-4.2c-4.3-.1-8.6-1.1-12.5-3.2c-12.2-6.4-27.1-2.9-35.3 8.2c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-3.4 13.5 3.2 27.6 15.7 33.3c8.3 3.8 14.3 11.5 16.1 20.6c2.7 13.7 14.6 23.5 28.3 23.1c9.1-.3 17.8 4 23.2 11.4c8.2 11.2 23.2 14.6 35.3 8.2c8.1-4.3 17.7-4.3 25.8 0c12.2 6.4 27.1 2.9 35.3-8.2c5.5-7.4 14.1-11.7 23.2-11.4c13.7 .4 25.7-9.4 28.3-23.1c1.8-9.1 7.8-16.8 16.1-20.6c12.5-5.7 19.2-19.8 15.7-33.3c-2.3-9-.1-18.6 5.7-25.7c6.7-8.1 8.3-19 4.9-28.4c-1.7 5.9-4.6 11.2-8.8 15.4zM456.8 224c1.9 0 3.8 .2 5.8 .4c-1.9-.3-3.8-.5-5.8-.4zM368 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]]
};
var faCircle2 = {
  prefix: 'fad',
  iconName: 'circle-2',
  icon: [512, 512, [], "e0ef", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM222.7 168.7l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L244.7 320H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L276.3 224.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z", "M248 160.3c-9.1-.1-18 2.8-25.3 8.3l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L244.7 320H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L276.3 224.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.5-37.1l-3.4-.1z"]]
};
var faMagnet = {
  prefix: 'fad',
  iconName: 'magnet',
  icon: [448, 512, [129522], "f076", ["M0 160H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v96zm320 0H448V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v96z", "M0 160v96C0 379.7 100.3 480 224 480s224-100.3 224-224V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H0z"]]
};
var faJar = {
  prefix: 'fad',
  iconName: 'jar',
  icon: [320, 512, [], "e516", ["M64 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM96 192H224c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z", "M64 0C46.3 0 32 14.3 32 32s14.3 32 32 32H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM96 192c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H96z"]]
};
var faGramophone = {
  prefix: 'fad',
  iconName: 'gramophone',
  icon: [384, 512, [], "f8bd", ["M150.6 15.9C147.1 6.1 137.5-.4 127 0c-10.5 .4-19.5 7.7-22.2 17.8L32.8 289.7c-.1 .3-.2 .7-.3 1c-.7 3.3-.8 6.5-.2 9.6c.6 3.1 1.7 6.1 3.5 8.8c2.4 3.7 5.9 6.8 10.2 8.7c1.4 .6 2.8 1.1 4.3 1.5c3.4 .8 6.8 .9 10 .2c3-.6 5.9-1.7 8.7-3.5c.3-.2 .7-.5 1-.7c108.2-77.3 197.2-76.6 241.4-69.4c4.7 .8 9.3 3.7 12.4 8.6c2.6 4.9 4 10.3 4.1 15.6c-.2 18.7-15.3 33.7-34 33.7l-110 0c-11.6 0-21.3 8.2-23.5 19.2c-.3 1.6-.5 3.2-.5 4.8v56h48V352l86.6 0c45 0 81.4-36.5 81.4-81.4l0-.3 0-.3c0-12-2.8-24.1-8.2-35c-8.5-17.5-22.9-31.7-40.1-40.4C257.9 159.3 213.4 114 186.4 77.8c-13.5-18.1-22.6-34-28.2-45.1c-2.8-5.6-4.8-9.9-6-12.8c-.6-1.4-1-2.5-1.3-3.2l-.3-.7 0-.1z", "M64 384c-17.7 0-32 14.3-32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32V416c0-17.7-14.3-32-32-32H64z"]]
};
var faDiceD12 = {
  prefix: 'fad',
  iconName: 'dice-d12',
  icon: [512, 512, [], "f6ce", ["M330.2 3.2c-3.6-2.1-7.8-3.2-12-3.2H193.8c-4.2 0-8.4 1.1-12 3.2l-72 41.6c-5.9 3.4-5.1 12.2 1.3 14.5l136.8 48.9c5.2 1.9 10.9 1.9 16.1 0L400.9 59.3c6.4-2.3 7.2-11.1 1.3-14.5l-72-41.6zM12.7 165.3c-3.6 6.3-2.6 14.2 2.5 19.3L123 292.4c4.9 4.9 12.3 6.1 18.5 3l89.7-44.8c5.4-2.7 8.8-8.3 8.8-14.3V150.6c0-6.8-4.3-12.8-10.6-15.1L76.6 80.9c-7.3-2.6-15.4 .4-19.2 7.1L12.7 165.3zM435.4 80.9L282.6 135.5c-6.4 2.3-10.6 8.3-10.6 15.1v85.7c0 6.1 3.4 11.6 8.8 14.3l89.7 44.8c6.2 3.1 13.6 1.9 18.5-3L496.7 184.7c5.1-5.1 6.2-13 2.5-19.3L454.6 88c-3.9-6.7-12-9.7-19.2-7.1z", "M161.6 481c2.2 7-5.3 13-11.6 9.3L74.2 446.6c-3.6-2.1-6.7-5.1-8.8-8.8L3.2 330.2c-2.1-3.6-3.2-7.8-3.2-12V233.9c0-7.1 8.6-10.7 13.7-5.7l96.1 96.1c2.7 2.7 4.8 6.1 5.9 9.8L161.6 481zM498.3 228.3c5-5 13.7-1.5 13.7 5.7v84.2c0 4.2-1.1 8.4-3.2 12L446.6 437.8c-2.1 3.6-5.1 6.7-8.8 8.8l-75.8 43.7c-6.3 3.6-13.8-2.4-11.6-9.3l45.9-146.9c1.2-3.7 3.2-7.1 5.9-9.8l96.1-96.1zM310.7 500.8c-2.1 6.7-8.3 11.2-15.3 11.2H216.5c-7 0-13.2-4.5-15.3-11.2L151.4 341.2c-2.3-7.5 1.1-15.6 8.1-19.1l89.3-44.7c4.5-2.3 9.8-2.3 14.3 0l89.3 44.7c7 3.5 10.5 11.6 8.1 19.1L310.7 500.8z"]]
};
var faNoteSticky = {
  prefix: 'fad',
  iconName: 'note-sticky',
  icon: [448, 512, [62026, "sticky-note"], "f249", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H288V352c0-17.7 14.3-32 32-32H448V96c0-35.3-28.7-64-64-64H64z", "M288 352V480h5.5c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3V320H320c-17.7 0-32 14.3-32 32z"]]
};
var faStickyNote = faNoteSticky;
var faDown = {
  prefix: 'fad',
  iconName: 'down',
  icon: [384, 512, ["arrow-alt-down"], "f354", ["M256 256H128V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40l0 184z", "M128 256v0l-96 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l160 160c12.5 12.5 32.8 12.5 45.3 0l160-160c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-96 0v0H128z"]]
};
var faArrowAltDown = faDown;
var faHundredPoints = {
  prefix: 'fad',
  iconName: 'hundred-points',
  icon: [512, 512, [128175, "100"], "e41c", ["M484.5 351.7c17.5-2.5 29.7-18.7 27.2-36.2s-18.7-29.7-36.2-27.2l-448 64C10 354.8-2.2 371 .3 388.5S19 418.2 36.5 415.7l448-64zm0 96c17.5-2.5 29.7-18.7 27.2-36.2s-18.7-29.7-36.2-27.2l-224 32c-17.5 2.5-29.7 18.7-27.2 36.2s18.7 29.7 36.2 27.2l224-32z", "M163 101.8C168 61.9 201.9 32 242 32c47.9 0 85 42 79 89.5L309 218.2c-5 39.8-38.9 69.8-79 69.8c-47.9 0-85-42-79-89.5L163 101.8zM242 96c-7.9 0-14.5 5.9-15.5 13.7l-12.1 96.7c-1.2 9.3 6.1 17.6 15.5 17.6c7.9 0 14.5-5.9 15.5-13.7l12.1-96.7c1.2-9.3-6.1-17.6-15.5-17.6zM123.5 38.3c9.2 6.9 13.8 18.2 12.2 29.7l-32 224c-2.5 17.5-18.7 30-36.2 27.7S37.8 301.5 40.3 284L64.3 116.5l-19.7 8.7c-16.2 7.2-35.1 0-42-16.1s.6-35.1 16.8-42.3l72-32c10.6-4.7 22.9-3.4 32.1 3.5zM427.7 32c46.9 0 83.7 40.3 79.5 87l-7.3 80.4c-3.7 41.1-38.2 72.6-79.5 72.6c-46.9 0-83.7-40.3-79.5-87l7.3-80.4C351.9 63.5 386.4 32 427.7 32zm-15.7 78.4l-7.3 80.4c-.8 9.3 6.4 17.2 15.7 17.2c8.2 0 15-6.2 15.7-14.4l7.3-80.4c.8-9.3-6.4-17.2-15.7-17.2c-8.2 0-15 6.2-15.7 14.4z"]]
};
var fa100 = faHundredPoints;
var faPaperclipVertical = {
  prefix: 'fad',
  iconName: 'paperclip-vertical',
  icon: [384, 512, [], "e3c2", ["M32 128C32 57.3 89.3 0 160 0s128 57.3 128 128V320c0 44.2-35.8 80-80 80s-80-35.8-80-80V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-35.3-28.7-64-64-64s-64 28.7-64 64V336c0 61.9 50.1 112 112 112s112-50.1 112-112V160c0-17.7 14.3-32 32-32s32 14.3 32 32V336c0 97.2-78.8 176-176 176s-176-78.8-176-176V128z", ""]]
};
var faWindWarning = {
  prefix: 'fad',
  iconName: 'wind-warning',
  icon: [640, 512, ["wind-circle-exclamation"], "f776", ["M433.3 336C401.1 420.2 319.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 5.4-.2 10.7-.6 16H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h49.3zM248 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M433.3 176c7.7 20.1 12.6 41.6 14.1 64H544c53 0 96-43 96-96s-43-96-96-96H512c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H433.3zM472 432c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H536c17.7 0 32 14.3 32 32s-14.3 32-32 32H504c-17.7 0-32 14.3-32 32zM224 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
};
var faWindCircleExclamation = faWindWarning;
var faLocationPinSlash = {
  prefix: 'fad',
  iconName: 'location-pin-slash',
  icon: [640, 512, ["map-marker-slash"], "f60c", ["M459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4l305 239zm-52.8 81.6L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0c16.2-20.2 39-49.6 62.5-83.1z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faMapMarkerSlash = faLocationPinSlash;
var faFaceSadSweat = {
  prefix: 'fad',
  iconName: 'face-sad-sweat',
  icon: [576, 512, [], "e38a", ["M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512zm82.7-100.1c-6.6 5.9-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C220.2 371.4 248.3 352 288 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6zM227.3 148.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zM207.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-18.9-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z", "M227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM239.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM348.7 148.7c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM48 416c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C67.6 308.6 96 349 96 369c0 26-21.5 47-48 47z"]]
};
var faBugSlash = {
  prefix: 'fad',
  iconName: 'bug-slash',
  icon: [640, 512, [], "e490", ["M336 360.7l94.8 74.7c-25.1 24.1-58.2 40.1-94.8 43.8V360.7zM166.7 227.3L304 335.5V479.2c-34.5-3.4-65.8-17.8-90.3-39.6l-63.1 63.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C165.5 367.8 160 344.6 160 320H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h64.3c.8-10 2.9-19.7 6.4-28.7zM480 320c0 9.9-.9 19.5-2.6 28.9L240 162.8c7.7-1.8 15.8-2.8 24-2.8H376c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480zM320 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H252.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faCupcake = {
  prefix: 'fad',
  iconName: 'cupcake',
  icon: [448, 512, [129473], "e402", ["M225.2 9.9c2.5-6 8.3-9.9 14.8-9.9h4.6C303.9 0 352 48.1 352 107.4c0 7.3-.9 14.3-2.6 21c4.2 .5 8.4 1.5 12.5 2.8l22.6 7.5C422.4 151.5 448 187 448 227c0 51.4-41.6 93-93 93H93c-51.4 0-93-41.6-93-93c0-40 25.6-75.6 63.6-88.2l22.6-7.5c3.2-1.1 6.5-1.9 9.9-2.4c0-.3 0-.6 0-.8c0-35.3 28.7-64 64-64h62.1C232 64 240 56 240 46.1c0-4.8-1.9-9.3-5.3-12.7l-6.1-6.1c-4.6-4.6-5.9-11.5-3.5-17.4z", "M64.6 315.6l25 156c3.7 23.3 23.8 40.4 47.4 40.4h10.9l-24-192H93c-9.9 0-19.5-1.5-28.4-4.4zm91.6 4.4l24 192h87.8l24-192H156.1zm168 0l-24 192h10.9c23.6 0 43.7-17.1 47.4-40.4l25-156c-9 2.9-18.5 4.4-28.4 4.4H324.1z"]]
};
var faLightSwitchOff = {
  prefix: 'fad',
  iconName: 'light-switch-off',
  icon: [384, 512, [], "e018", ["M160 416c-35.3 0-64-28.7-64-64V256H288v96c0 35.3-28.7 64-64 64H160z", "M0 448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zm96-96V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64zm80 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0-416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]]
};
var faToggleLargeOff = {
  prefix: 'fad',
  iconName: 'toggle-large-off',
  icon: [576, 512, [], "e5b0", ["M192 128c-70.7 0-128 57.3-128 128s57.3 128 128 128H384c70.7 0 128-57.3 128-128s-57.3-128-128-128H192zM384 64c106 0 192 86 192 192s-86 192-192 192H192C86 448 0 362 0 256S86 64 192 64H384z", "M192 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z"]]
};
var faPenFancySlash = {
  prefix: 'fad',
  iconName: 'pen-fancy-slash',
  icon: [640, 512, [], "e210", ["M211 262.3l107 84.3-18.1 78.6c-3.9 17.1-16.9 30.7-33.8 35.4L88.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L65.7 487.6 115.5 310c4.7-16.9 18.3-29.9 35.4-33.8L211 262.3zM548.9 138.5l-161 140.2-100.8-79L437.5 27.1C452.5 9.9 474.2 0 497 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
};
var faTruckContainer = {
  prefix: 'fad',
  iconName: 'truck-container',
  icon: [640, 512, [], "f4dc", ["M48 32C21.5 32 0 53.5 0 80V224c0 26.5 21.5 48 48 48H352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM80 72c8.8 0 16 7.2 16 16V216c0 8.8-7.2 16-16 16s-16-7.2-16-16V88c0-8.8 7.2-16 16-16zM224 88c0-8.8 7.2-16 16-16s16 7.2 16 16V216c0 8.8-7.2 16-16 16s-16-7.2-16-16V88zM160 72c8.8 0 16 7.2 16 16V216c0 8.8-7.2 16-16 16s-16-7.2-16-16V88c0-8.8 7.2-16 16-16zM304 88c0-8.8 7.2-16 16-16s16 7.2 16 16V216c0 8.8-7.2 16-16 16s-16-7.2-16-16V88zM32 416a64 64 0 1 0 128 0A64 64 0 1 0 32 416zm160 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm288 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z", "M456 144c-13.3 0-24 10.7-24 24v88 32 16H32c-17.7 0-32 14.3-32 32v16c0 8.8 3.6 16.8 9.4 22.6C24.8 342.3 57.8 320 96 320c33.4 0 62.8 17 80 42.9C193.2 337 222.6 320 256 320c41.8 0 77.4 26.7 90.5 64H432h21.5c13.2-37.3 48.7-64 90.5-64c38.2 0 71.2 22.3 86.6 54.6c5.8-5.8 9.4-13.8 9.4-22.6V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H456zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256z"]]
};
var faBoot = {
  prefix: 'fad',
  iconName: 'boot',
  icon: [512, 512, [129406], "f782", ["M0 96V448H512V379c0-44.1-30-82.4-72.7-93.1L320 256H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V192H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V96H0z", "M32 0C14.3 0 0 14.3 0 32V96H320c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM0 448v9.4c0 14.5 5.8 28.4 16 38.6s24.1 16 38.6 16H69.5c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h11c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h11c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h14.9c14.5 0 28.4-5.8 38.6-16s16-24.1 16-38.6V448H0z"]]
};
var faArrowUpFromWaterPump = {
  prefix: 'fad',
  iconName: 'arrow-up-from-water-pump',
  icon: [576, 512, [], "e4b6", ["M112 0C85.5 0 64 21.5 64 48V256H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400V304c0-26.5-21.5-48-48-48H288V48c0-26.5-21.5-48-48-48H112z", "M550.6 134.6c12.5-12.5 12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256h64l0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"]]
};
var faFileCheck = {
  prefix: 'fad',
  iconName: 'file-check',
  icon: [384, 512, [], "f316", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM305 281c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L305 281z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM305 281c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L305 281z"]]
};
var faBone = {
  prefix: 'fad',
  iconName: 'bone',
  icon: [576, 512, [129460], "f5d7", ["M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z", ""]]
};
var faCardsBlank = {
  prefix: 'fad',
  iconName: 'cards-blank',
  icon: [640, 512, [], "e4df", ["M306.4 472.3l137-79.1c3.3-1.9 6.4-4.1 9.2-6.6c19.4-17.2 24.7-46.2 11.2-69.5L324.8 76.4C334.4 68.7 346.7 64 360 64H584c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H360c-25.3 0-46.6-16.7-53.6-39.7z", "M7.5 194.9c-15.4-26.6-6.3-60.7 20.4-76.1L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.4 26.6 6.2 60.7-20.4 76.1L250.5 504.5c-26.6 15.4-60.7 6.3-76.1-20.4L7.5 194.9z"]]
};
var faCircle3 = {
  prefix: 'fad',
  iconName: 'circle-3',
  icon: [512, 512, [], "e0f0", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H312c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2H240c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L250.3 176H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M160 152c0-13.3 10.7-24 24-24H312c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2H240c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L250.3 176H184c-13.3 0-24-10.7-24-24z"]]
};
var faBenchTree = {
  prefix: 'fad',
  iconName: 'bench-tree',
  icon: [640, 512, [], "e2e7", ["M606.8 111.1c.8-4.9 1.2-10 1.2-15.1c0-53-43-96-96-96s-96 43-96 96c0 5.1 .4 10.2 1.2 15.1C397.1 125.7 384 149.3 384 176c0 44.2 35.8 80 80 80h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256h16c44.2 0 80-35.8 80-80c0-26.7-13.1-50.3-33.2-64.9z", "M64 192H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM0 384c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c-17.7 0-32-14.3-32-32z"]]
};
var faKeyboardBrightnessLow = {
  prefix: 'fad',
  iconName: 'keyboard-brightness-low',
  icon: [640, 512, [], "e1c1", ["M288 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM128 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M192 384c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32z"]]
};
var faSkiBootSki = {
  prefix: 'fad',
  iconName: 'ski-boot-ski',
  icon: [640, 512, [], "e3cd", ["M269.5 32H184c-15.3 0-28.4 10.8-31.4 25.7L116.8 237c39.8-9.3 125.1-47.4 152.7-205zM640 416c0-17.7-14.3-32-32-32s-32 14.3-32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c53 0 96-43 96-96z", "M415.4 38.3c3.5-17.3-7.8-34.2-25.1-37.7s-34.2 7.8-37.7 25.1L351.4 32H269.5c-27.6 157.6-113 195.8-152.7 205L88.6 377.7c-1.9 9.4 .6 19.1 6.6 26.6s15.2 11.7 24.7 11.7H448c17.7 0 32-14.3 32-32V304c0-12.7-7.5-24.2-19.1-29.3L382.2 240H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h61.4l9.6-48H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h61.4L409 70.3l6.4-32z"]]
};
var faBrainCircuit = {
  prefix: 'fad',
  iconName: 'brain-circuit',
  icon: [512, 512, [], "e0c6", ["M240 56c0-30.9-25.1-56-56-56c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1c30.9 0 56-25.1 56-56V272H192c-8.8 0-16 7.2-16 16v34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V288c0-26.5 21.5-48 48-48h48V160H205.3c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.9 0 38.7 13.4 45.3 32H240V56zm32 104V352h34.7c6.6-18.6 24.4-32 45.3-32c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32H272v72c0 30.9 25.1 56 56 56c28.9 0 52.7-21.9 55.7-50.1c5.2 1.4 10.7 2.1 16.3 2.1c35.3 0 64-28.7 64-64c0-7.4-1.3-14.6-3.6-21.2C490.6 367.4 512 338.2 512 304c0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56v72h48c26.5 0 48 21.5 48 48v2.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V176c0-8.8-7.2-16-16-16H272z", "M240 272V456h32V384h34.7c6.6 18.6 24.4 32 45.3 32c26.5 0 48-21.5 48-48s-21.5-48-48-48c-20.9 0-38.7 13.4-45.3 32H272V160h48c8.8 0 16 7.2 16 16v2.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V176c0-26.5-21.5-48-48-48H272V56H240v72H205.3c-6.6-18.6-24.4-32-45.3-32c-26.5 0-48 21.5-48 48s21.5 48 48 48c20.9 0 38.7-13.4 45.3-32H240v80H192c-26.5 0-48 21.5-48 48v34.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V288c0-8.8 7.2-16 16-16h48zM176 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm176 96a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM176 368a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm192 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z"]]
};
var faUserInjured = {
  prefix: 'fad',
  iconName: 'user-injured',
  icon: [448, 512, [], "f728", ["M96 128c0-11 1.4-21.8 4-32H348c2.6 10.2 4 21 4 32c0 70.7-57.3 128-128 128s-128-57.3-128-128zM272 512h-9.6l-57.6-96H272c26.5 0 48 21.5 48 48s-21.5 48-48 48zm0-128H185.6l-45.5-75.9c12.3-2.7 25.1-4.1 38.2-4.1h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H336c10-13.4 16-30 16-48c0-44.2-35.8-80-80-80zM0 482.3c0-55 24.9-104.1 64-136.8V512H29.7C13.3 512 0 498.7 0 482.3z", "M348 96c-6.7-25.9-21.3-48.7-41.1-65.5L222.6 96H348zM224 0C164.4 0 114.2 40.8 100 96h70.5L278.4 12.1C261.9 4.3 243.4 0 224 0zm38.4 512L140.1 308.1c-28.5 6.2-54.5 19.3-76.1 37.3V512H262.4z"]]
};
var faBlockBrickFire = {
  prefix: 'fad',
  iconName: 'block-brick-fire',
  icon: [640, 512, ["firewall"], "e3dc", ["M384 32H128v80H384V32zM96 32C60.7 32 32 60.7 32 96v16H96V32zM32 240H240V144H32v96zm0 32v96H96V272H32zm0 144c0 35.3 28.7 64 64 64H240V400H32v16zm240 64h65.6c-20.2-22.6-35.1-50-43.1-80H272v80zM480 144.6V144h-.6c.2 .2 .4 .4 .6 .6zm-72.1-.6H272v96h54.9c20.6-32.8 48.5-66.2 81-96zM309 272H128v96H288.8c-.5-5.9-.8-11.9-.8-17.9c0-25.4 8.5-52.4 21-78.1zM480 96c0-35.3-28.7-64-64-64v80h64V96z", "M443.7 160c3.5 0 7 1.3 9.8 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7zM481 448c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z"]]
};
var faFirewall = faBlockBrickFire;
var faFaceSadTear = {
  prefix: 'fad',
  iconName: 'face-sad-tear',
  icon: [512, 512, [128546, "sad-tear"], "f5b4", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M303.6 208a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM112 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C140.6 308.6 112 349 112 369zm63.6-129a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faSadTear = faFaceSadTear;
var faPlane = {
  prefix: 'fad',
  iconName: 'plane',
  icon: [576, 512, [], "f072", ["M214.9 320l150.9 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6zM365.7 192l-150.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192z", "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l370.3 0z"]]
};
var faTentArrowsDown = {
  prefix: 'fad',
  iconName: 'tent-arrows-down',
  icon: [576, 512, [], "e581", ["M268.6 166.5c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160c1.4 9.2-1.3 18.6-7.4 25.6s-14.9 11.1-24.2 11.1H384L288 352V512H96c-9.3 0-18.2-4.1-24.2-11.1s-8.8-16.4-7.4-25.6l24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128z", "M208.1 145.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72zm352 0c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72z"]]
};
var faExclamation = {
  prefix: 'fad',
  iconName: 'exclamation',
  icon: [64, 512, [10069, 10071, 61738], "21", ["M-8 440a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z", "M32 32c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32z"]]
};
var faArrowsSpin = {
  prefix: 'fad',
  iconName: 'arrows-spin',
  icon: [512, 512, [], "e4bb", ["M72 49.4H177.4c8.8 0 16 7.2 16 16V170.7c0 14.3-17.2 21.4-27.3 11.3l-30.5-30.5c-23.9 28-38.4 64.3-38.4 104c0 11.1 1.1 22 3.3 32.5h-65c-1.5-10.6-2.3-21.4-2.3-32.5c0-57.4 21.6-109.7 57-149.3L60.7 76.7C50.6 66.6 57.7 49.4 72 49.4zM348.2 332.2l29 29c24.8-28.2 39.9-65.2 39.9-105.7c0-10.8-1.1-21.3-3.1-31.5h64.9c1.5 10.3 2.2 20.8 2.2 31.5c0 58.2-22.2 111.2-58.6 151l31 31c10.1 10.1 2.9 27.3-11.3 27.3H336.9c-8.8 0-16-7.2-16-16V343.5c0-14.3 17.2-21.4 27.3-11.3z", "M35.5 288l0 0h65l0 0h-65zM257.1 95.5c-11.4 0-22.4 1.2-33.1 3.4V34c10.8-1.6 21.9-2.4 33.1-2.4c58.2 0 111.2 22.2 151 58.6l29.4-29.4c10.1-10.1 27.3-2.9 27.3 11.3l0 105.4c0 8.8-7.2 16-16 16l-105.4 0c-14.3 0-21.4-17.2-11.3-27.3l30.6-30.6c-28.2-24.8-65.2-39.9-105.7-39.9zM182.1 348.2l-28.9 28.9c28 23.9 64.3 38.4 104 38.4c10.6 0 20.9-1 30.9-3v64.9c-10.1 1.4-20.4 2.1-30.9 2.1c-57.4 0-109.7-21.6-149.3-57L76.7 453.6c-10.1 10.1-27.3 2.9-27.3-11.3l0-105.4c0-8.8 7.2-16 16-16l105.4 0c14.3 0 21.4 17.2 11.3 27.3z"]]
};
var faFaceSmileRelaxed = {
  prefix: 'fad',
  iconName: 'face-smile-relaxed',
  icon: [512, 512, [], "e392", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z", "M140.8 233.6c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zm160 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z"]]
};
var faCommentXmark = {
  prefix: 'fad',
  iconName: 'comment-xmark',
  icon: [512, 512, ["comment-times"], "f4b5", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM175 159c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z", "M209 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
};
var faCommentTimes = faCommentXmark;
var faPrint = {
  prefix: 'fad',
  iconName: 'print',
  icon: [512, 512, [128424, 128438, 9113], "f02f", ["M128 0C92.7 0 64 28.7 64 64V192h64V64H354.7L384 93.3V192h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM64 384v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384H384v64H128V384H64z", "M0 256c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32H384V352H128v32H32c-17.7 0-32-14.3-32-32V256zm456 16a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]]
};
var faTurkishLiraSign = {
  prefix: 'fad',
  iconName: 'turkish-lira-sign',
  icon: [384, 512, ["try", "turkish-lira"], "e2bb", ["M64 117.6v66.6l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6zm0 96v66.6l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6zm64 48.3V195.3l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9zm0-96V99.3L247.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9z", "M96 32c17.7 0 32 14.3 32 32V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480H96c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"]]
};
var faTry = faTurkishLiraSign;
var faTurkishLira = faTurkishLiraSign;
var faFaceNoseSteam = {
  prefix: 'fad',
  iconName: 'face-nose-steam',
  icon: [512, 512, [], "e382", ["M512 256c0 29.1-4.9 57-13.8 83.1c-5.3-1.7-10.8-2.8-16.3-3.1c-1.2-1.4-2.4-2.7-3.7-4c-23.3-23.3-60.1-24.9-85.3-4.7l-56.5-33.9c-12.6-7.6-28.7-5.6-39.1 4.8s-12.4 26.5-4.8 39.1l33.9 56.5c-20.2 25.1-18.6 62 4.7 85.3c1.3 1.3 2.6 2.5 4 3.7c.3 5.3 1.3 10.6 2.9 15.8c-25.8 8.7-53.3 13.4-82 13.4c-29.4 0-57.6-5-83.9-14.1c1.7-5.2 2.7-10.6 3-16c1.4-1.2 2.7-2.4 4-3.7c23.3-23.3 24.9-60.1 4.7-85.3l33.9-56.5c7.6-12.6 5.6-28.7-4.8-39.1s-26.5-12.4-39.1-4.8l-56.5 33.9c-25.1-20.2-62-18.6-85.3 4.7l4 4-4-4c-1.3 1.3-2.5 2.6-3.7 4c-5.1 .3-10.1 1.2-15 2.7C4.7 312.1 0 284.6 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm304 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h96zM389.1 143.2c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1c-41.3 13.8-74.2 39.9-86.3 51.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c9.3-9.3 38.2-32.3 73.7-44.1zm-266.1 0c35.5 11.8 64.4 34.8 73.7 44.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-12-12-45-38.1-86.3-51.9c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2z", "M9.4 421.7c2.1 2.1 4.3 3.8 6.7 5.2C1.7 445.6 3 472.7 20.3 489.9s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7c12.5 12.5 32.8 12.5 45.3 0c9.9-9.9 11.9-24.6 6.2-36.5c6-1.2 11.7-4.1 16.4-8.8c12.5-12.5 12.5-32.8 0-45.3c-3.6-3.6-7.9-6.2-12.5-7.7l44.9-69.8c1.8-2.8 1.4-6.5-.9-8.8c-2.3-2.3-5.9-2.7-8.7-1L108 367.5c-1.5-5-4.2-9.7-8.1-13.7c-12.5-12.5-32.8-12.5-45.3 0c-4.7 4.7-7.6 10.4-8.8 16.4c-11.9-5.7-26.6-3.6-36.5 6.2c-12.5 12.5-12.5 32.8 0 45.3zm491.5 .9c12.5-12.5 12.5-32.8 0-45.3c-9.9-9.9-24.6-11.9-36.5-6.2c-1.2-6-4.1-11.7-8.8-16.4c-12.5-12.5-32.8-12.5-45.3 0c-3.7 3.7-6.3 8.1-7.8 12.8L332.8 323c-2.8-1.8-6.5-1.4-8.8 1c-2.3 2.3-2.7 6-1 8.8l44.2 70.4c-4.9 1.5-9.6 4.1-13.4 8c-12.5 12.5-12.5 32.8 0 45.3c4.7 4.7 10.4 7.6 16.4 8.8c-5.7 11.9-3.6 26.6 6.2 36.5c12.5 12.5 32.8 12.5 45.3 0c2.1-2.1 3.8-4.3 5.2-6.7c18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2z"]]
};
var faCircleWaveformLines = {
  prefix: 'fad',
  iconName: 'circle-waveform-lines',
  icon: [512, 512, ["waveform-circle"], "e12d", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-368V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zM160 176V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24V312c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-8.8 7.2-16 16-16s16 7.2 16 16zM224 216v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V216c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M272 128c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM144 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm192 24c8.8 0 16 7.2 16 16V312c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-8.8 7.2-16 16-16zM208 200c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V216c0-8.8 7.2-16 16-16zm192 24c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16z"]]
};
var faWaveformCircle = faCircleWaveformLines;
var faDollarSign = {
  prefix: 'fad',
  iconName: 'dollar-sign',
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", ["M160 0c17.7 0 32 14.3 32 32V67.7c-21.9-2.9-43.6-3-64-.3V32c0-17.7 14.3-32 32-32zM128 445.1c21.9 3.2 43.6 3.8 64 1.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1z", "M108.5 137.8c-19.4 7.7-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3c.9 .3 1.9 .5 2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-31.6 12.9-70.3 15.2-109.7 9.3l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3c-.9-.2-1.8-.5-2.8-.7C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c32.4-12.9 72.1-15.9 111.9-10c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2z"]]
};
var faDollar = faDollarSign;
var faUsd = faDollarSign;
var faFerrisWheel = {
  prefix: 'fad',
  iconName: 'ferris-wheel',
  icon: [512, 512, [], "e174", ["M293 286.6c6.9-8.3 11-19 11-30.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.6 4.1 22.3 11 30.6L130.2 477.9c-3.5 7.4-2.9 16.1 1.5 23s12 11.1 20.2 11.1H360c8.2 0 15.8-4.2 20.2-11.1s5-15.6 1.5-23L293 286.6z", "M302.7 36.9c27.7 5.9 53.5 16.9 76.4 31.9c6.3-3.1 13.4-4.8 20.9-4.8c26.5 0 48 21.5 48 48c0 7.5-1.7 14.6-4.8 20.9c15.1 22.9 26 48.7 31.9 76.4c21.1 5 36.9 24 36.9 46.7s-15.7 41.7-36.9 46.7c-5.9 27.7-16.9 53.5-31.9 76.4c3.1 6.3 4.8 13.4 4.8 20.9c0 26.5-21.5 48-48 48c-7.5 0-14.6-1.7-20.9-4.8c-3.4 2.2-6.9 4.4-10.4 6.4l-27.1-58.4c5-3.2 9.8-6.6 14.4-10.3c4.8-11.2 13.8-20.2 25.1-25.1c17.2-21.5 29-47.5 33.2-75.9H297.6c4.1-7.1 6.4-15.3 6.4-24c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 8.7 2.3 16.9 6.4 24H97.8c4.3 28.5 16.1 54.4 33.2 75.9c11.2 4.8 20.2 13.8 25.1 25.1c4.6 3.7 9.4 7.1 14.4 10.3l-27.1 58.4c-3.5-2.1-7-4.2-10.4-6.4c-6.3 3.1-13.4 4.8-20.9 4.8c-26.5 0-48-21.5-48-48c0-7.5 1.7-14.6 4.8-20.9c-15.1-22.9-26.1-48.7-31.9-76.4C15.7 297.7 0 278.7 0 256s15.7-41.7 36.9-46.7c5.9-27.7 16.9-53.5 31.9-76.4C65.7 126.6 64 119.5 64 112c0-26.5 21.5-48 48-48c7.5 0 14.6 1.7 20.9 4.8c22.9-15.1 48.7-26.1 76.4-31.9C214.3 15.7 233.3 0 256 0s41.7 15.7 46.7 36.9zM127.2 161.1c-15.1 20.5-25.4 44.6-29.4 70.9H198.1l-70.9-70.9zm33.9-33.9L232 198.1V97.8c-26.3 4-50.4 14.3-70.9 29.4zM280 97.8V198.1l70.9-70.9c-20.5-15.1-44.6-25.4-70.9-29.4zm104.8 63.3L313.9 232H414.2c-3.9-26.3-14.3-50.4-29.4-70.9z"]]
};
var faComputerSpeaker = {
  prefix: 'fad',
  iconName: 'computer-speaker',
  icon: [640, 512, [], "f8b2", ["M288 432V416H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H304c-10-13.4-16-30-16-48zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H288V320H64V96H288V80c0-18 6-34.6 16-48H64zm304 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368zM480 224a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm-32-96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M64 96H288V320H64V96zm384 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]]
};
var faSkullCow = {
  prefix: 'fad',
  iconName: 'skull-cow',
  icon: [640, 512, [], "f8de", ["M576.8 21.1c-2.5-7.4 .7-15.4 7.5-19.1s15.3-2 20.1 4.1l7.5 9.3c18.2 22.7 28 51.1 28 80.1C640 166.1 582.8 224 512 224H480V176c0-18-6-34.6-16-48h48 23c28.7 0 52.7-21.7 55.6-50.3c.8-7.8-.1-15.8-2.6-23.2L576.8 21.1zM176 128c-10 13.4-16 30-16 48v48H128C57.2 224 0 166.1 0 95.5C0 66.4 9.9 38 28 15.3L35.5 6C40.3 0 48.8-1.8 55.6 1.9s10 11.8 7.5 19.1L52 54.5c-2.5 7.5-3.4 15.4-2.6 23.2C52.3 106.3 76.3 128 105 128h23 48z", "M240 96c-44.2 0-80 35.8-80 80V288c0 37 25.2 68.2 59.3 77.3l27.6 110.3c5.3 21.4 24.5 36.4 46.6 36.4h53c22 0 41.2-15 46.6-36.4l27.6-110.3C454.8 356.2 480 325 480 288V176c0-44.2-35.8-80-80-80H240zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faX = {
  prefix: 'fad',
  iconName: 'x',
  icon: [384, 512, [120], "58", ["M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z", ""]]
};
var faMagnifyingGlassDollar = {
  prefix: 'fad',
  iconName: 'magnifying-glass-dollar',
  icon: [512, 512, ["search-dollar"], "f688", ["M208 416A208 208 0 1 0 208 0a208 208 0 1 0 0 416zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V312c0 11-9 20-20 20s-20-9-20-20V297.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V104c0-11 9-20 20-20s20 9 20 20z", "M228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104zM330.7 376L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376z"]]
};
var faSearchDollar = faMagnifyingGlassDollar;
var faUsersGear = {
  prefix: 'fad',
  iconName: 'users-gear',
  icon: [640, 512, ["users-cog"], "f509", ["M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7z", "M631.5 338c2.6 6.8-.5 14.3-6.8 18l-3 1.7c-9.2 5.3-13.7 15.8-13.7 26.4s4.5 21.1 13.7 26.4l3 1.7c6.3 3.6 9.5 11.1 6.8 17.9c-2.1 5.5-4.6 10.7-7.4 15.8l-2.4 4.2c-3 5.1-6.4 9.9-10.1 14.5c-4.6 5.7-12.7 6.7-19 3l-2.9-1.7c-9.2-5.3-20.4-4-29.6 1.3s-16.1 14.5-16.1 25.1v3.4c0 7.3-4.9 13.8-12.1 14.9c-6.5 1-13.1 1.5-19.9 1.5s-13.4-.5-19.9-1.5c-7.2-1.1-12.1-7.6-12.1-14.9v-3.4c0-10.6-6.9-19.8-16.1-25.1s-20.4-6.6-29.6-1.3l-2.9 1.7c-6.3 3.6-14.4 2.6-19-3c-3.7-4.6-7.1-9.4-10.1-14.5l-2.4-4.1c-2.8-5.1-5.3-10.4-7.4-15.8c-2.6-6.8 .5-14.3 6.8-17.9l3-1.7c9.2-5.3 13.7-15.8 13.7-26.4s-4.5-21.1-13.7-26.4l-2.9-1.7c-6.3-3.6-9.5-11.1-6.8-17.9c2.1-5.5 4.6-10.8 7.4-15.9l2.3-3.9c3.1-5.1 6.5-10 10.2-14.6c4.6-5.7 12.7-6.7 19-3l2.9 1.7c9.2 5.3 20.4 4 29.6-1.3s16.1-14.5 16.1-25.1v-3.4c0-7.3 4.9-13.8 12.1-14.9c6.5-1 13.1-1.5 19.9-1.5s13.4 .5 19.9 1.5c7.2 1.1 12.1 7.6 12.1 14.9v3.4c0 10.6 6.9 19.8 16.1 25.1s20.4 6.6 29.6 1.3l2.9-1.7c6.3-3.6 14.4-2.6 19 3c3.7 4.6 7.1 9.5 10.2 14.5l2.3 4c2.8 5.1 5.3 10.4 7.4 15.9zM512 424a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]]
};
var faUsersCog = faUsersGear;
var faPersonMilitaryPointing = {
  prefix: 'fad',
  iconName: 'person-military-pointing',
  icon: [576, 512, [], "e54a", ["M240 112c0-11.4 2.4-22.2 6.7-32H393.3c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80s-80-35.8-80-80zM386.8 230.5c10.9 3.5 21.2 8.3 30.9 14.4L246.6 416H416v32H224V393.4L386.8 230.5z", "M237.8 28.5c-12.6 2-21.8 12.9-21.8 25.6C216 68.4 227.6 80 241.9 80H400c8.8 0 16-7.2 16-16V18.8c0-9.8-8.8-17.4-18.5-15.8L237.8 28.5zM345.2 224H240 72c-22.1 0-40 17.9-40 40s17.9 40 40 40H224v89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5zM224 480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V448H224v32zm22.6-64H416V369.7l53.6 90.7c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9L246.6 416z"]]
};
var faBuildingColumns = {
  prefix: 'fad',
  iconName: 'building-columns',
  icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", ["M128 192H64V420.3c-.6 .3-1.2 .7-1.7 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V192H384V416H344V192H280V416H232V192H168V416H128V192z", "M268.6 2.6c-8-3.4-17.2-3.4-25.2 0l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24l0-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
};
var faBank = faBuildingColumns;
var faInstitution = faBuildingColumns;
var faMuseum = faBuildingColumns;
var faUniversity = faBuildingColumns;
var faCircleT = {
  prefix: 'fad',
  iconName: 'circle-t',
  icon: [512, 512, [], "e124", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152 144H256 360c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M128 168c0-13.3 10.7-24 24-24H256 360c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H152c-13.3 0-24-10.7-24-24z"]]
};
var faSack = {
  prefix: 'fad',
  iconName: 'sack',
  icon: [512, 512, [], "f81c", ["M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4z", "M176 112c0-8.8 7.2-16 16-16H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"]]
};
var faGrid2 = {
  prefix: 'fad',
  iconName: 'grid-2',
  icon: [512, 512, [], "e196", ["M480 72c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40V184c0 22.1 17.9 40 40 40H440c22.1 0 40-17.9 40-40V72zM224 328c0-22.1-17.9-40-40-40H72c-22.1 0-40 17.9-40 40V440c0 22.1 17.9 40 40 40H184c22.1 0 40-17.9 40-40V328z", "M224 80c0-26.5-21.5-48-48-48H80C53.5 32 32 53.5 32 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zM480 336c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z"]]
};
var faCameraCctv = {
  prefix: 'fad',
  iconName: 'camera-cctv',
  icon: [576, 512, ["cctv"], "f8ac", ["M362.6 330l150.8 68.5c3.9 1.8 8.4 1.9 12.5 .3s7.2-4.7 8.9-8.7l40-96c3.3-8-.3-17.2-8.3-20.8l-71.3-31.7L362.6 330zM236.9 320l-59.1-24.6L137.9 400H64V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v48 48c0 17.7 14.3 32 32 32s32-14.3 32-32V464h96c13.3 0 25.2-8.2 29.9-20.6l47-123.4z", "M140.3 2.5c-14.9-6.2-32.1-.3-40.1 13.7l-96 168c-4.6 8-5.5 17.5-2.5 26.2s9.5 15.7 18 19.2l288 120c9.9 4.1 21.2 3 30.1-2.9l192-128c9.8-6.5 15.2-18 14.1-29.7s-8.6-21.9-19.5-26.5l-384-160z"]]
};
var faCctv = faCameraCctv;
var faUmbrella = {
  prefix: 'fad',
  iconName: 'umbrella',
  icon: [576, 512, [], "f0e9", ["M256 278.7c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V278.7z", "M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V49.7C124.2 63.4 18.3 161 2.1 285.9c-2 15.6 17.3 24.4 27.8 12.7C43.9 283 71.2 272 96 272c38.7 0 71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C217 299.5 249.3 272 288 272s71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C409 299.5 441.3 272 480 272c24.8 0 52.1 11 66.1 26.7c10.5 11.7 29.8 2.9 27.8-12.7C557.7 161 451.8 63.4 320 49.7V32z"]]
};
var faTrowel = {
  prefix: 'fad',
  iconName: 'trowel',
  icon: [512, 512, [], "e589", ["M298.6 168.1c.1 .1 .2 .2 .3 .3l44.7 44.7c.1 .1 .2 .2 .3 .3L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6z", "M298.9 115.6c-14.6 14.6-14.6 38.2 0 52.8l44.7 44.7c14.6 14.6 38.2 14.6 52.8 0l95.4-95.4c26.9-26.9 26.9-70.5 0-97.5s-70.5-26.9-97.5 0l-95.4 95.4z"]]
};
var faHorizontalRule = {
  prefix: 'fad',
  iconName: 'horizontal-rule',
  icon: [640, 512, [8213], "f86c", ["M0 256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", ""]]
};
var faBedFront = {
  prefix: 'fad',
  iconName: 'bed-front',
  icon: [512, 512, ["bed-alt"], "f8f7", ["M0 288c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v32 32H480 32 0V320 288z", "M32 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V232.6c-9.4-5.4-20.3-8.6-32-8.6H432V160c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v64H240V160c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32v64H64c-11.7 0-22.6 3.1-32 8.6V80zm0 272H480h32v32 64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V384 352H32z"]]
};
var faBedAlt = faBedFront;
var faD = {
  prefix: 'fad',
  iconName: 'd',
  icon: [384, 512, [100], "44", ["M0 96C0 60.7 28.7 32 64 32h96c123.7 0 224 100.3 224 224s-100.3 224-224 224H64c-35.3 0-64-28.7-64-64V96zm160 0H64V416h96c88.4 0 160-71.6 160-160s-71.6-160-160-160z", ""]]
};
var faStapler = {
  prefix: 'fad',
  iconName: 'stapler',
  icon: [640, 512, [], "e5af", ["M448 288v64H96c-17.7 0-32-14.3-32-32V219.4L448 288z", "M640 304v-4.7c0-36.4-20.5-69.6-53.1-85.9L260.7 50.4C236.6 38.3 209.9 32 182.9 32C128.2 32 76.7 57.8 43.8 101.6L8.2 149.1C2.9 156.2 0 164.8 0 173.7c0 19.9 14.2 36.9 33.8 40.4L448 288V416H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H448h64 80c26.5 0 48-21.5 48-48V304z"]]
};
var faMasksTheater = {
  prefix: 'fad',
  iconName: 'masks-theater',
  icon: [640, 512, [127917, "theater-masks"], "f630", ["M240.7 446.9c-58.2 8.8-124.5-37.5-166.1-73.7c-28.3-24.5-44.3-59.8-49.8-97.2L.6 111.8C-.8 102 0 91.9 5.7 83.9C20.5 63 63 22.7 175.7 5.6s164.9 8.9 185.1 24.5c7.8 6 11.5 15.4 12.9 25.2l1.2 8.1c-53 3.2-81.9 18.8-95.7 29.5c-7.8 6-11.5 15.4-12.9 25.2L246.9 249.4c-12.3-4.4-25.8-6-39.5-3.9c-35.2 5.3-61.8 32.7-68.2 66.3c-1.6 8.2 8.3 12.2 14.8 7c17-13.5 37.5-22.9 60.4-26.4c9-1.4 17.9-1.7 26.7-1.2c-3.5 34.5 2.3 69.5 20.7 98.8c7.5 11.9 16.3 24.9 26.2 37.9c-14.9 9.7-30.7 16.6-47.1 19.1zM174.1 157c-1-5.3-7.4-6.4-11.8-3.3c-7.7 5.5-16.8 9.3-26.8 10.8s-19.8 .6-28.7-2.4c-5.1-1.7-10.9 1.3-10.3 6.7c.1 .5 .1 1.1 .2 1.6c3.2 21.8 23.2 36.8 44.7 33.5s36.3-23.5 33.1-45.3c-.1-.5-.2-1.1-.3-1.6z", "M399.3 509.7c-58.2-8.8-108.2-72.8-137.6-119.7c-20-31.9-25.1-70.3-19.6-107.7L266.3 118c1.4-9.8 5.1-19.2 12.9-25.2c20.2-15.6 72.4-41.5 185.1-24.5s155.2 57.4 170 78.3c5.7 8 6.5 18.1 5.1 27.9L615.2 338.8c-5.5 37.3-21.5 72.6-49.8 97.2c-41.7 36.1-108 82.5-166.1 73.7zm17.1-277.7c.1-.5 .2-1.1 .3-1.6c3.2-21.8-11.6-42-33.1-45.3s-41.5 11.8-44.7 33.5c-.1 .5-.1 1.1-.2 1.6c-.6 5.4 5.2 8.4 10.3 6.7c9-3 18.8-3.9 28.7-2.4s19.1 5.3 26.8 10.8c4.4 3.1 10.8 2 11.8-3.3zm112.6 22.2c4.4 3.1 10.8 2 11.8-3.3c.1-.5 .2-1.1 .3-1.6c3.2-21.8-11.6-42-33.1-45.3s-41.5 11.8-44.7 33.5c-.1 .5-.1 1.1-.2 1.6c-.6 5.4 5.2 8.4 10.3 6.7c9-3 18.8-3.9 28.7-2.4s19.1 5.3 26.8 10.8zm-11.5 85.2c-28.8 12.8-61.4 17.8-94.9 12.8s-63.2-19.5-87-40.3c-6.3-5.5-16.2-1.7-15.2 6.7c5.9 48.5 43 89.1 93 96.7s97.2-20.2 116.8-64.9c3.4-7.7-5-14.3-12.6-10.9z"]]
};
var faTheaterMasks = faMasksTheater;
var faKipSign = {
  prefix: 'fad',
  iconName: 'kip-sign',
  icon: [384, 512, [], "e1c4", ["M64 224v32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64zm118.5 64l-37.3-32 37.3-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H182.5z", "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L145.2 256 340.8 88.3z"]]
};
var faFaceWoozy = {
  prefix: 'fad',
  iconName: 'face-woozy',
  icon: [512, 512, [], "e3a2", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM411.3 347.3L372 386.6c-13.7 13.7-32.3 21.4-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1L267.4 388c-18.2-11.4-40.8-13.4-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4l11.5 7.7c18.5 12.3 41.8 14.7 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2c10.9 0 21.3-4.3 29-12l39.3-39.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM200.9 98.7c7.4 4.9 9.3 14.8 4.4 22.2c-28 42-69.6 64.1-88.3 70.3c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2c13.4-4.5 48.5-22.9 71.7-57.7c4.9-7.4 14.8-9.3 22.2-4.4zm22.6 121.4c2.1 8.6-3.1 17.3-11.6 19.4l-64 16c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l64-16c8.6-2.1 17.3 3.1 19.4 11.6zM336 272c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z", "M205.3 120.9c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4c-23.2 34.8-58.4 53.2-71.7 57.7c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1c18.6-6.2 60.3-28.3 88.3-70.3zm6.6 118.6c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-64 16c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l64-16zM336 272c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z"]]
};
var faCloudQuestion = {
  prefix: 'fad',
  iconName: 'cloud-question',
  icon: [640, 512, [], "e492", ["M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm89.8-282.7l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V296c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H286.6c-23.7 0-44.8 14.9-52.8 37.3zM352 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M286.6 160c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V296c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H286.6zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
};
var faPineapple = {
  prefix: 'fad',
  iconName: 'pineapple',
  icon: [512, 512, [], "e31f", ["M45.3 429.3l37.5 37.5c29 29 68.3 45.3 109.3 45.3s80.3-16.3 109.3-45.3L402.7 365.3c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-37.5-37.5C336.3 80.3 297 64 256 64s-80.3 16.3-109.3 45.3L45.3 210.7C16.3 239.7 0 279 0 320s16.3 80.3 45.3 109.3zM187.3 212.7L208 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80L128 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM288 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 313.4zM164.7 372.7c6.2-6.2 16.4-6.2 22.6 0L208 393.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6z", "M423.1 1.7c4.2 2.1 7.3 5.9 8.4 10.5l3.6 14.3C447 19.6 460.6 16 474.5 16H480c8.8 0 16 7.2 16 16v5.5c0 13.9-3.6 27.5-10.4 39.4l14.3 3.6c4.5 1.1 8.4 4.2 10.5 8.4s2.2 9.1 .4 13.4c-6.8 15.9-19.5 26.7-34.1 31.6l14.7 14.7c6.2 6.2 6.2 16.4 0 22.6c-15.4 15.4-35.3 23.6-55.5 24.5c-7.7-18.2-18.8-34.8-33-49.1l-37.5-37.5C351 95 334.4 83.9 316.2 76.2c.9-20.2 9.1-40.1 24.5-55.5c6.2-6.2 16.4-6.2 22.6 0l14.7 14.7C383 20.8 393.8 8.1 409.7 1.3c4.3-1.8 9.2-1.7 13.4 .4zm-235.8 211L208 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80L128 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm160 0L288 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-102.6 80c6.2-6.2 16.4-6.2 22.6 0L208 393.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6z"]]
};
var faHandPointLeft = {
  prefix: 'fad',
  iconName: 'hand-point-left',
  icon: [512, 512, [], "f0a5", ["M0 128c0 17.7 14.3 32 32 32l208 0 0-64L32 96C14.3 96 0 110.3 0 128zM312 288l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72z", "M160 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm32 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H224c-17.7 0-32 14.3-32 32z"]]
};
var faGalleryThumbnails = {
  prefix: 'fad',
  iconName: 'gallery-thumbnails',
  icon: [576, 512, [], "e3aa", ["M32 416c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H32zm160 0c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H192zm128 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H512z", "M512 64V288H64L64 64H512zM64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"]]
};
var faCircleJ = {
  prefix: 'fad',
  iconName: 'circle-j',
  icon: [512, 512, [], "e112", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-360V288c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M312 128c13.3 0 24 10.7 24 24V288c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24z"]]
};
var faEyes = {
  prefix: 'fad',
  iconName: 'eyes',
  icon: [640, 512, [], "e367", ["M65.3 231.8c-.8 7.9-1.3 15.9-1.3 24.2c0 36.2 8.5 69 22.4 95.3c3.1 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8zM374.4 351.3c3.1 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8c-.8 7.9-1.3 15.9-1.3 24.2c0 36.2 8.5 69 22.4 95.3z", "M64 256c0-46.8 14.3-87.9 35.8-116.6C121.3 110.8 148.6 96 176 96s54.7 14.8 76.2 43.4C273.7 168.1 288 209.2 288 256s-14.3 87.9-35.8 116.6S203.4 416 176 416s-54.7-14.8-76.2-43.4S64 302.8 64 256zM320 126.7c-5-9.1-10.5-17.6-16.6-25.7C272.8 60.2 228.1 32 176 32s-96.8 28.2-127.4 69C18 141.8 0 196.7 0 256s18 114.2 48.6 155c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69c6-8 11.6-16.6 16.6-25.7c5 9.1 10.5 17.6 16.6 25.7c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69C622 370.2 640 315.3 640 256s-18-114.2-48.6-155C560.8 60.2 516.1 32 464 32s-96.8 28.2-127.4 69c-6 8-11.6 16.6-16.6 25.7zM352 256c0-46.8 14.3-87.9 35.8-116.6C409.3 110.8 436.6 96 464 96s54.7 14.8 76.2 43.4C561.7 168.1 576 209.2 576 256s-14.3 87.9-35.8 116.6S491.4 416 464 416s-54.7-14.8-76.2-43.4S352 302.8 352 256z"]]
};
var faHandshakeSimple = {
  prefix: 'fad',
  iconName: 'handshake-simple',
  icon: [640, 512, [129309, "handshake-alt"], "f4c6", ["M576 128h16c26.5 0 48 21.5 48 48V304c0 26.5-21.5 48-48 48H509.3c-2.5-7.2-6.8-13.9-12.8-19.4L341.1 190.2l-57.2 40.8c-21.6 15.4-51.6 10.4-67-11.2s-10.4-51.6 11.2-67l98.6-70.4c16.9-12 37-18.5 57.7-18.5c19.6 0 38.8 5.8 55.1 16.7l71 47.3H576z", "M48 352H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c7.4-8.1 11.5-18 12.4-28.2l7.8 7.1c19.5 17.9 49.9 16.6 67.8-2.9c12.9-14 15.8-33.7 9.2-50.3c-2.6-6.5-6.6-12.5-12.1-17.5L354.2 202.3l-13.1-12-57.2 40.8c-21.6 15.4-51.6 10.4-67-11.2s-10.4-51.6 11.2-67l89.3-63.8-2.7-2.3C297.5 72.1 275.5 64 252.8 64C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48V304c0 26.5 21.5 48 48 48z"]]
};
var faHandshakeAlt = faHandshakeSimple;
var faPageCaretUp = {
  prefix: 'fad',
  iconName: 'page-caret-up',
  icon: [384, 512, ["file-caret-up"], "e42a", ["M320 512c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320zM192 192c4.5 0 8.8 1.9 11.8 5.2l75.7 82.6c14.1 15.4 3.2 40.2-17.7 40.2H122.2c-20.9 0-31.8-24.8-17.7-40.2l75.7-82.6c3-3.3 7.3-5.2 11.8-5.2z", "M203.8 197.2c-3-3.3-7.3-5.2-11.8-5.2s-8.8 1.9-11.8 5.2l-75.7 82.6c-14.1 15.4-3.2 40.2 17.7 40.2H261.8c20.9 0 31.8-24.8 17.7-40.2l-75.7-82.6z"]]
};
var faFileCaretUp = faPageCaretUp;
var faJetFighter = {
  prefix: 'fad',
  iconName: 'jet-fighter',
  icon: [640, 512, ["fighter-jet"], "f0fb", ["M192 192V48h88L384 192H192zm0 128H384L280 464H192V320z", "M160 24c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm32 168H160l-54.6-54.6c-6-6-14.1-9.4-22.6-9.4H48c-8.8 0-16 7.2-16 16v80c-17.7 0-32 14.3-32 32s14.3 32 32 32v80c0 8.8 7.2 16 16 16H82.7c8.5 0 16.6-3.4 22.6-9.4L160 320h32H500.4c7.7 0 15.3-1.4 22.5-4.1L625 277.6c9-3.4 15-12 15-21.6s-6-18.2-15-21.6L522.9 196.1c-7.2-2.7-14.8-4.1-22.5-4.1H192zM80 240h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM184 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]]
};
var faFighterJet = faJetFighter;
var faComet = {
  prefix: 'fad',
  iconName: 'comet',
  icon: [512, 512, [], "e003", ["M299.4 75.6L493.7 .9c1.5-.6 3.2-.9 4.8-.9C506 0 512 6 512 13.5c0 1.7-.3 3.3-.9 4.8L436.4 212.6l29.3-2.3c12.8-1 21.5 12.8 15.1 24L378.6 410.7C342.3 473.4 275.4 512 203 512C90.9 512 0 421.1 0 309c0-72.4 38.6-139.4 101.3-175.7L277.7 31.2c11.1-6.5 25 2.2 24 15.1l-2.3 29.3zM192 200c-6.1 0-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2L192 402.1l58.4 30.7c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2c-2.7-5.5-8.3-8.9-14.3-8.9z", "M206.3 208.9c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2L192 402.1l58.4 30.7c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2z"]]
};
var faSquareShareNodes = {
  prefix: 'fad',
  iconName: 'square-share-nodes',
  icon: [448, 512, ["share-alt-square"], "f1e1", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z", "M320 224c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 2.5 .1 4.9 .4 7.3L174.5 212c-11.7-12.3-28.2-20-46.5-20c-35.3 0-64 28.7-64 64s28.7 64 64 64c18.3 0 34.8-7.7 46.5-20l81.9 44.7c-.3 2.4-.4 4.9-.4 7.3c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-15.4 0-29.5 5.4-40.6 14.5L194.1 256l85.3-46.5c11 9.1 25.2 14.5 40.6 14.5z"]]
};
var faShareAltSquare = faSquareShareNodes;
var faShieldKeyhole = {
  prefix: 'fad',
  iconName: 'shield-keyhole',
  icon: [512, 512, [], "e248", ["M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM312 208c0 22.3-13.1 41.6-32 50.6V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V258.6c-18.9-9-32-28.3-32-50.6c0-30.9 25.1-56 56-56s56 25.1 56 56z", "M280 258.6c18.9-9 32-28.3 32-50.6c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6V328c0 13.3 10.7 24 24 24s24-10.7 24-24V258.6z"]]
};
var faBarcode = {
  prefix: 'fad',
  iconName: 'barcode',
  icon: [512, 512, [], "f02a", ["M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z", ""]]
};
var faPlusMinus = {
  prefix: 'fad',
  iconName: 'plus-minus',
  icon: [384, 512, [], "e43c", ["M0 480c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V320c0 17.7 14.3 32 32 32s32-14.3 32-32V208H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32z"]]
};
var faSquareSlidersVertical = {
  prefix: 'fad',
  iconName: 'square-sliders-vertical',
  icon: [448, 512, ["sliders-v-square"], "f3f2", ["M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 0c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176V128c0-17.7-14.3-32-32-32zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V288H256c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v32c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H336V128z", "M96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96zM256 288c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256z"]]
};
var faSlidersVSquare = faSquareSlidersVertical;
var faVideo = {
  prefix: 'fad',
  iconName: 'video',
  icon: [576, 512, ["video-camera"], "f03d", ["M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z", "M576 128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6L384 196.2V315.8l142.2 94.8c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128z"]]
};
var faVideoCamera = faVideo;
var faMessageMiddle = {
  prefix: 'fad',
  iconName: 'message-middle',
  icon: [512, 512, ["comment-middle-alt"], "e1e1", ["M343.5 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H168.5l75.2 90.2c3 3.6 7.5 5.8 12.3 5.8s9.3-2.1 12.3-5.8L343.5 416z", ""]]
};
var faCommentMiddleAlt = faMessageMiddle;
var faGraduationCap = {
  prefix: 'fad',
  iconName: 'graduation-cap',
  icon: [640, 512, [127891, "mortar-board"], "f19d", ["M325.6 139.8c8.3-3.1 12.5-12.3 9.4-20.6s-12.3-12.5-20.6-9.4L154.9 169.6C92.4 193.1 50.4 251.8 48.1 318.2c-.1 .6-.1 1.2-.1 1.8c0 28.4-10.8 57.8-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7c-3.2-14-7.5-28.3-13.4-41.5c2.8-52.5 36.4-98.7 86-117.3l159.4-59.8z", "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l77.4 27.9c16.8-17.8 37.8-31.9 61.7-40.9l159.4-59.8c8.3-3.1 17.5 1.1 20.6 9.4s-1.1 17.5-9.4 20.6L166.2 199.6c-14.6 5.5-27.8 13.4-39.3 23.1l169.5 61.2c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"]]
};
var faMortarBoard = faGraduationCap;
var faHandHoldingMedical = {
  prefix: 'fad',
  iconName: 'hand-holding-medical',
  icon: [576, 512, [], "e05c", ["M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z", "M248 0c-13.3 0-24 10.7-24 24V80H168c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176h56c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H320V24c0-13.3-10.7-24-24-24H248z"]]
};
var faPersonCircleCheck = {
  prefix: 'fad',
  iconName: 'person-circle-check',
  icon: [576, 512, [], "e53e", ["M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
};
var faSquareZ = {
  prefix: 'fad',
  iconName: 'square-z',
  icon: [448, 512, [], "e288", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm72 96H312c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176H136c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M112 152c0-13.3 10.7-24 24-24H312c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176H136c-13.3 0-24-10.7-24-24z"]]
};
var faMessageText = {
  prefix: 'fad',
  iconName: 'message-text',
  icon: [512, 512, ["comment-alt-text"], "e1e6", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm168 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h64V296c0 13.3 10.7 24 24 24s24-10.7 24-24V160h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 168z", "M144 136c0-13.3 10.7-24 24-24h88 88c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V160H168c-13.3 0-24-10.7-24-24z"]]
};
var faCommentAltText = faMessageText;
var faTurnUp = {
  prefix: 'fad',
  iconName: 'turn-up',
  icon: [384, 512, [10548, "level-up-alt"], "f3bf", ["M144 192h96V400c0 61.9-50.1 112-112 112H32c-17.7 0-32-14.3-32-32V448c0-17.7 14.3-32 32-32h96c8.8 0 16-7.2 16-16V192z", "M345.4 151.5c6.6 7 8.4 17.2 4.6 26s-12.5 14.5-22 14.5L56 192c-9.6 0-18.2-5.7-22-14.5s-2-19 4.6-26l136-144C179.1 2.7 185.4 0 192 0s12.9 2.7 17.4 7.5l136 144z"]]
};
var faLevelUpAlt = faTurnUp;
var icons = {
  fa0: fa0,
  fa1: fa1,
  fa2: fa2,
  fa3: fa3,
  fa4: fa4,
  fa5: fa5,
  fa6: fa6,
  fa7: fa7,
  fa8: fa8,
  fa9: fa9,
  faFillDrip: faFillDrip,
  faArrowsToCircle: faArrowsToCircle,
  faCircleChevronRight: faCircleChevronRight,
  faChevronCircleRight: faChevronCircleRight,
  faWagonCovered: faWagonCovered,
  faLineHeight: faLineHeight,
  faBagel: faBagel,
  faTransporter7: faTransporter7,
  faAt: faAt,
  faRectanglesMixed: faRectanglesMixed,
  faPhoneArrowUpRight: faPhoneArrowUpRight,
  faPhoneArrowUp: faPhoneArrowUp,
  faPhoneOutgoing: faPhoneOutgoing,
  faTrashCan: faTrashCan,
  faTrashAlt: faTrashAlt,
  faCircleL: faCircleL,
  faHeadSideGoggles: faHeadSideGoggles,
  faHeadVr: faHeadVr,
  faTextHeight: faTextHeight,
  faUserXmark: faUserXmark,
  faUserTimes: faUserTimes,
  faFaceHandYawn: faFaceHandYawn,
  faGaugeSimpleMin: faGaugeSimpleMin,
  faTachometerSlowest: faTachometerSlowest,
  faStethoscope: faStethoscope,
  faCoffin: faCoffin,
  faMessage: faMessage,
  faCommentAlt: faCommentAlt,
  faSalad: faSalad,
  faBowlSalad: faBowlSalad,
  faInfo: faInfo,
  faRobotAstromech: faRobotAstromech,
  faRingDiamond: faRingDiamond,
  faFonduePot: faFonduePot,
  faTheta: faTheta,
  faFaceHandPeeking: faFaceHandPeeking,
  faSquareUser: faSquareUser,
  faDownLeftAndUpRightToCenter: faDownLeftAndUpRightToCenter,
  faCompressAlt: faCompressAlt,
  faExplosion: faExplosion,
  faFileLines: faFileLines,
  faFileAlt: faFileAlt,
  faFileText: faFileText,
  faWaveSquare: faWaveSquare,
  faRing: faRing,
  faBuildingUn: faBuildingUn,
  faDiceThree: faDiceThree,
  faTirePressureWarning: faTirePressureWarning,
  faWifiFair: faWifiFair,
  faWifi2: faWifi2,
  faCalendarDays: faCalendarDays,
  faCalendarAlt: faCalendarAlt,
  faMp3Player: faMp3Player,
  faAnchorCircleCheck: faAnchorCircleCheck,
  faTally4: faTally4,
  faRectangleHistory: faRectangleHistory,
  faBuildingCircleArrowRight: faBuildingCircleArrowRight,
  faVolleyball: faVolleyball,
  faVolleyballBall: faVolleyballBall,
  faSunHaze: faSunHaze,
  faTextSize: faTextSize,
  faUfo: faUfo,
  faFork: faFork,
  faUtensilFork: faUtensilFork,
  faArrowsUpToLine: faArrowsUpToLine,
  faMobileSignal: faMobileSignal,
  faBarcodeScan: faBarcodeScan,
  faSortDown: faSortDown,
  faSortDesc: faSortDesc,
  faFolderArrowDown: faFolderArrowDown,
  faFolderDownload: faFolderDownload,
  faCircleMinus: faCircleMinus,
  faMinusCircle: faMinusCircle,
  faFaceIcicles: faFaceIcicles,
  faShovel: faShovel,
  faDoorOpen: faDoorOpen,
  faFilms: faFilms,
  faRightFromBracket: faRightFromBracket,
  faSignOutAlt: faSignOutAlt,
  faFaceGlasses: faFaceGlasses,
  faNfc: faNfc,
  faAtom: faAtom,
  faSoap: faSoap,
  faIcons: faIcons,
  faHeartMusicCameraBolt: faHeartMusicCameraBolt,
  faMicrophoneLinesSlash: faMicrophoneLinesSlash,
  faMicrophoneAltSlash: faMicrophoneAltSlash,
  faClosedCaptioningSlash: faClosedCaptioningSlash,
  faCalculatorSimple: faCalculatorSimple,
  faCalculatorAlt: faCalculatorAlt,
  faBridgeCircleCheck: faBridgeCircleCheck,
  faSlidersUp: faSlidersUp,
  faSlidersV: faSlidersV,
  faLocationMinus: faLocationMinus,
  faMapMarkerMinus: faMapMarkerMinus,
  faPumpMedical: faPumpMedical,
  faFingerprint: faFingerprint,
  faSkiBoot: faSkiBoot,
  faStandardDefinition: faStandardDefinition,
  faRectangleSd: faRectangleSd,
  faH1: faH1,
  faHandPointRight: faHandPointRight,
  faMagnifyingGlassLocation: faMagnifyingGlassLocation,
  faSearchLocation: faSearchLocation,
  faMessageBot: faMessageBot,
  faForwardStep: faForwardStep,
  faStepForward: faStepForward,
  faFaceSmileBeam: faFaceSmileBeam,
  faSmileBeam: faSmileBeam,
  faLightCeiling: faLightCeiling,
  faMessageExclamation: faMessageExclamation,
  faCommentAltExclamation: faCommentAltExclamation,
  faBowlScoop: faBowlScoop,
  faBowlShavedIce: faBowlShavedIce,
  faSquareX: faSquareX,
  faUtilityPoleDouble: faUtilityPoleDouble,
  faFlagCheckered: faFlagCheckered,
  faChevronsUp: faChevronsUp,
  faChevronDoubleUp: faChevronDoubleUp,
  faFootball: faFootball,
  faFootballBall: faFootballBall,
  faUserVneck: faUserVneck,
  faSchoolCircleExclamation: faSchoolCircleExclamation,
  faCrop: faCrop,
  faAnglesDown: faAnglesDown,
  faAngleDoubleDown: faAngleDoubleDown,
  faUsersRectangle: faUsersRectangle,
  faPeopleRoof: faPeopleRoof,
  faSquareArrowRight: faSquareArrowRight,
  faArrowSquareRight: faArrowSquareRight,
  faLocationPlus: faLocationPlus,
  faMapMarkerPlus: faMapMarkerPlus,
  faLightbulbExclamationOn: faLightbulbExclamationOn,
  faPeopleLine: faPeopleLine,
  faBeerMugEmpty: faBeerMugEmpty,
  faBeer: faBeer,
  faCrateEmpty: faCrateEmpty,
  faDiagramPredecessor: faDiagramPredecessor,
  faTransporter: faTransporter,
  faCalendarCircleUser: faCalendarCircleUser,
  faArrowUpLong: faArrowUpLong,
  faLongArrowUp: faLongArrowUp,
  faPersonCarryBox: faPersonCarryBox,
  faPersonCarry: faPersonCarry,
  faFireFlameSimple: faFireFlameSimple,
  faBurn: faBurn,
  faPerson: faPerson,
  faMale: faMale,
  faLaptop: faLaptop,
  faFileCsv: faFileCsv,
  faMenorah: faMenorah,
  faUnion: faUnion,
  faChevronsLeft: faChevronsLeft,
  faChevronDoubleLeft: faChevronDoubleLeft,
  faCircleHeart: faCircleHeart,
  faHeartCircle: faHeartCircle,
  faTruckPlane: faTruckPlane,
  faRecordVinyl: faRecordVinyl,
  faBringForward: faBringForward,
  faSquareP: faSquareP,
  faFaceGrinStars: faFaceGrinStars,
  faGrinStars: faGrinStars,
  faSigma: faSigma,
  faCameraMovie: faCameraMovie,
  faBong: faBong,
  faClarinet: faClarinet,
  faTruckFlatbed: faTruckFlatbed,
  faSpaghettiMonsterFlying: faSpaghettiMonsterFlying,
  faPastafarianism: faPastafarianism,
  faArrowDownUpAcrossLine: faArrowDownUpAcrossLine,
  faLeafHeart: faLeafHeart,
  faHouseBuilding: faHouseBuilding,
  faCheeseSwiss: faCheeseSwiss,
  faSpoon: faSpoon,
  faUtensilSpoon: faUtensilSpoon,
  faJarWheat: faJarWheat,
  faEnvelopesBulk: faEnvelopesBulk,
  faMailBulk: faMailBulk,
  faFileCircleExclamation: faFileCircleExclamation,
  faBowArrow: faBowArrow,
  faCartXmark: faCartXmark,
  faHexagonXmark: faHexagonXmark,
  faTimesHexagon: faTimesHexagon,
  faXmarkHexagon: faXmarkHexagon,
  faCircleH: faCircleH,
  faHospitalSymbol: faHospitalSymbol,
  faMerge: faMerge,
  faPager: faPager,
  faCartMinus: faCartMinus,
  faAddressBook: faAddressBook,
  faContactBook: faContactBook,
  faPanFrying: faPanFrying,
  faGrid: faGrid,
  faGrid3: faGrid3,
  faFootballHelmet: faFootballHelmet,
  faHandLove: faHandLove,
  faTrees: faTrees,
  faStrikethrough: faStrikethrough,
  faPage: faPage,
  faK: faK,
  faDiagramPrevious: faDiagramPrevious,
  faGaugeMin: faGaugeMin,
  faTachometerAltSlowest: faTachometerAltSlowest,
  faFolderGrid: faFolderGrid,
  faEggplant: faEggplant,
  faRam: faRam,
  faLandmarkFlag: faLandmarkFlag,
  faLips: faLips,
  faPencil: faPencil,
  faPencilAlt: faPencilAlt,
  faBackward: faBackward,
  faCaretRight: faCaretRight,
  faComments: faComments,
  faPaste: faPaste,
  faFileClipboard: faFileClipboard,
  faDesktopArrowDown: faDesktopArrowDown,
  faCodePullRequest: faCodePullRequest,
  faPumpkin: faPumpkin,
  faClipboardList: faClipboardList,
  faPenField: faPenField,
  faBlueberries: faBlueberries,
  faTruckRampBox: faTruckRampBox,
  faTruckLoading: faTruckLoading,
  faNote: faNote,
  faArrowDownToSquare: faArrowDownToSquare,
  faUserCheck: faUserCheck,
  faCloudXmark: faCloudXmark,
  faVialVirus: faVialVirus,
  faBookBlank: faBookBlank,
  faBookAlt: faBookAlt,
  faGolfFlagHole: faGolfFlagHole,
  faMessageArrowDown: faMessageArrowDown,
  faCommentAltArrowDown: faCommentAltArrowDown,
  faFaceUnamused: faFaceUnamused,
  faSheetPlastic: faSheetPlastic,
  faCircle9: faCircle9,
  faBlog: faBlog,
  faUserNinja: faUserNinja,
  faPencilSlash: faPencilSlash,
  faBowlingPins: faBowlingPins,
  faPersonArrowUpFromLine: faPersonArrowUpFromLine,
  faDownRight: faDownRight,
  faScrollTorah: faScrollTorah,
  faTorah: faTorah,
  faWebhook: faWebhook,
  faBlindsOpen: faBlindsOpen,
  faFence: faFence,
  faUp: faUp,
  faArrowAltUp: faArrowAltUp,
  faBroomBall: faBroomBall,
  faQuidditch: faQuidditch,
  faQuidditchBroomBall: faQuidditchBroomBall,
  faDrumstick: faDrumstick,
  faSquareV: faSquareV,
  faFaceAwesome: faFaceAwesome,
  faGaveDandy: faGaveDandy,
  faDialOff: faDialOff,
  faToggleOff: faToggleOff,
  faFaceSmileHorns: faFaceSmileHorns,
  faBoxArchive: faBoxArchive,
  faArchive: faArchive,
  faGrapes: faGrapes,
  faPersonDrowning: faPersonDrowning,
  faDialMax: faDialMax,
  faCircleM: faCircleM,
  faCalendarImage: faCalendarImage,
  faCircleCaretDown: faCircleCaretDown,
  faCaretCircleDown: faCaretCircleDown,
  faArrowDown91: faArrowDown91,
  faSortNumericDesc: faSortNumericDesc,
  faSortNumericDownAlt: faSortNumericDownAlt,
  faFaceGrinTongueSquint: faFaceGrinTongueSquint,
  faGrinTongueSquint: faGrinTongueSquint,
  faShishKebab: faShishKebab,
  faSprayCan: faSprayCan,
  faAlarmSnooze: faAlarmSnooze,
  faScarecrow: faScarecrow,
  faTruckMonster: faTruckMonster,
  faGiftCard: faGiftCard,
  faW: faW,
  faCodePullRequestDraft: faCodePullRequestDraft,
  faSquareB: faSquareB,
  faElephant: faElephant,
  faEarthAfrica: faEarthAfrica,
  faGlobeAfrica: faGlobeAfrica,
  faRainbow: faRainbow,
  faCircleNotch: faCircleNotch,
  faTabletScreenButton: faTabletScreenButton,
  faTabletAlt: faTabletAlt,
  faPaw: faPaw,
  faMessageQuestion: faMessageQuestion,
  faCloud: faCloud,
  faTrowelBricks: faTrowelBricks,
  faSquare3: faSquare3,
  faFaceFlushed: faFaceFlushed,
  faFlushed: faFlushed,
  faHospitalUser: faHospitalUser,
  faMicrowave: faMicrowave,
  faChfSign: faChfSign,
  faTentArrowLeftRight: faTentArrowLeftRight,
  faCartCircleArrowUp: faCartCircleArrowUp,
  faTrashClock: faTrashClock,
  faGavel: faGavel,
  faLegal: faLegal,
  faSprinklerCeiling: faSprinklerCeiling,
  faBrowsers: faBrowsers,
  faTrillium: faTrillium,
  faMusicSlash: faMusicSlash,
  faTruckRamp: faTruckRamp,
  faBinoculars: faBinoculars,
  faMicrophoneSlash: faMicrophoneSlash,
  faBoxTissue: faBoxTissue,
  faCircleC: faCircleC,
  faStarChristmas: faStarChristmas,
  faChartBullet: faChartBullet,
  faMotorcycle: faMotorcycle,
  faTreeChristmas: faTreeChristmas,
  faTireFlat: faTireFlat,
  faSunglasses: faSunglasses,
  faBadge: faBadge,
  faMessagePen: faMessagePen,
  faCommentAltEdit: faCommentAltEdit,
  faMessageEdit: faMessageEdit,
  faBellConcierge: faBellConcierge,
  faConciergeBell: faConciergeBell,
  faPenRuler: faPenRuler,
  faPencilRuler: faPencilRuler,
  faArrowProgress: faArrowProgress,
  faChessRookPiece: faChessRookPiece,
  faChessRookAlt: faChessRookAlt,
  faSquareRoot: faSquareRoot,
  faAlbumCollectionCirclePlus: faAlbumCollectionCirclePlus,
  faPeopleArrows: faPeopleArrows,
  faPeopleArrowsLeftRight: faPeopleArrowsLeftRight,
  faFaceAngryHorns: faFaceAngryHorns,
  faMarsAndVenusBurst: faMarsAndVenusBurst,
  faTombstone: faTombstone,
  faSquareCaretRight: faSquareCaretRight,
  faCaretSquareRight: faCaretSquareRight,
  faScissors: faScissors,
  faCut: faCut,
  faListMusic: faListMusic,
  faSunPlantWilt: faSunPlantWilt,
  faToiletsPortable: faToiletsPortable,
  faHockeyPuck: faHockeyPuck,
  faMustache: faMustache,
  faHyphen: faHyphen,
  faTable: faTable,
  faUserChef: faUserChef,
  faMessageImage: faMessageImage,
  faCommentAltImage: faCommentAltImage,
  faUsersMedical: faUsersMedical,
  faSensorTriangleExclamation: faSensorTriangleExclamation,
  faSensorAlert: faSensorAlert,
  faMagnifyingGlassArrowRight: faMagnifyingGlassArrowRight,
  faTachographDigital: faTachographDigital,
  faDigitalTachograph: faDigitalTachograph,
  faFaceMask: faFaceMask,
  faPickleball: faPickleball,
  faStarSharpHalf: faStarSharpHalf,
  faUsersSlash: faUsersSlash,
  faClover: faClover,
  faMeat: faMeat,
  faReply: faReply,
  faMailReply: faMailReply,
  faStarAndCrescent: faStarAndCrescent,
  faEmptySet: faEmptySet,
  faHouseFire: faHouseFire,
  faSquareMinus: faSquareMinus,
  faMinusSquare: faMinusSquare,
  faHelicopter: faHelicopter,
  faBird: faBird,
  faCompass: faCompass,
  faSquareCaretDown: faSquareCaretDown,
  faCaretSquareDown: faCaretSquareDown,
  faHeartHalfStroke: faHeartHalfStroke,
  faHeartHalfAlt: faHeartHalfAlt,
  faFileCircleQuestion: faFileCircleQuestion,
  faLaptopCode: faLaptopCode,
  faJoystick: faJoystick,
  faGrillFire: faGrillFire,
  faRectangleVerticalHistory: faRectangleVerticalHistory,
  faSwatchbook: faSwatchbook,
  faPrescriptionBottle: faPrescriptionBottle,
  faBars: faBars,
  faNavicon: faNavicon,
  faKeyboardLeft: faKeyboardLeft,
  faPeopleGroup: faPeopleGroup,
  faHourglassEnd: faHourglassEnd,
  faHourglass3: faHourglass3,
  faHeartCrack: faHeartCrack,
  faHeartBroken: faHeartBroken,
  faFaceBeamHandOverMouth: faFaceBeamHandOverMouth,
  faDropletPercent: faDropletPercent,
  faHumidity: faHumidity,
  faSquareUpRight: faSquareUpRight,
  faExternalLinkSquareAlt: faExternalLinkSquareAlt,
  faFaceKissBeam: faFaceKissBeam,
  faKissBeam: faKissBeam,
  faCorn: faCorn,
  faRollerCoaster: faRollerCoaster,
  faPhotoFilmMusic: faPhotoFilmMusic,
  faRadar: faRadar,
  faSickle: faSickle,
  faFilm: faFilm,
  faCoconut: faCoconut,
  faRulerHorizontal: faRulerHorizontal,
  faShieldCross: faShieldCross,
  faCassetteTape: faCassetteTape,
  faSquareTerminal: faSquareTerminal,
  faPeopleRobbery: faPeopleRobbery,
  faLightbulb: faLightbulb,
  faCaretLeft: faCaretLeft,
  faCommentMiddle: faCommentMiddle,
  faTrashCanList: faTrashCanList,
  faBlock: faBlock,
  faCircleExclamation: faCircleExclamation,
  faExclamationCircle: faExclamationCircle,
  faSchoolCircleXmark: faSchoolCircleXmark,
  faArrowRightFromBracket: faArrowRightFromBracket,
  faSignOut: faSignOut,
  faFaceFrownSlight: faFaceFrownSlight,
  faCircleChevronDown: faCircleChevronDown,
  faChevronCircleDown: faChevronCircleDown,
  faSidebarFlip: faSidebarFlip,
  faUnlockKeyhole: faUnlockKeyhole,
  faUnlockAlt: faUnlockAlt,
  faTemperatureList: faTemperatureList,
  faCloudShowersHeavy: faCloudShowersHeavy,
  faHeadphonesSimple: faHeadphonesSimple,
  faHeadphonesAlt: faHeadphonesAlt,
  faSitemap: faSitemap,
  faPipeSection: faPipeSection,
  faSpaceStationMoonConstruction: faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt: faSpaceStationMoonAlt,
  faCircleDollarToSlot: faCircleDollarToSlot,
  faDonate: faDonate,
  faMemory: faMemory,
  faFaceSleeping: faFaceSleeping,
  faRoadSpikes: faRoadSpikes,
  faFireBurner: faFireBurner,
  faSquirrel: faSquirrel,
  faArrowUpToLine: faArrowUpToLine,
  faArrowToTop: faArrowToTop,
  faFlag: faFlag,
  faFaceCowboyHat: faFaceCowboyHat,
  faHanukiah: faHanukiah,
  faChartScatter3d: faChartScatter3d,
  faDisplayChartUp: faDisplayChartUp,
  faSquareCode: faSquareCode,
  faFeather: faFeather,
  faVolumeLow: faVolumeLow,
  faVolumeDown: faVolumeDown,
  faXmarkToSlot: faXmarkToSlot,
  faTimesToSlot: faTimesToSlot,
  faVoteNay: faVoteNay,
  faBoxTaped: faBoxTaped,
  faBoxAlt: faBoxAlt,
  faCommentSlash: faCommentSlash,
  faSwords: faSwords,
  faCloudSunRain: faCloudSunRain,
  faAlbum: faAlbum,
  faCircleN: faCircleN,
  faCompress: faCompress,
  faWheatAwn: faWheatAwn,
  faWheatAlt: faWheatAlt,
  faAnkh: faAnkh,
  faHandsHoldingChild: faHandsHoldingChild,
  faAsterisk: faAsterisk,
  faKeySkeletonLeftRight: faKeySkeletonLeftRight,
  faCommentLines: faCommentLines,
  faLuchadorMask: faLuchadorMask,
  faLuchador: faLuchador,
  faMaskLuchador: faMaskLuchador,
  faSquareCheck: faSquareCheck,
  faCheckSquare: faCheckSquare,
  faShredder: faShredder,
  faBookOpenCover: faBookOpenCover,
  faBookOpenAlt: faBookOpenAlt,
  faSandwich: faSandwich,
  faPesetaSign: faPesetaSign,
  faSquareParkingSlash: faSquareParkingSlash,
  faParkingSlash: faParkingSlash,
  faTrainTunnel: faTrainTunnel,
  faHeading: faHeading,
  faHeader: faHeader,
  faGhost: faGhost,
  faFaceAnguished: faFaceAnguished,
  faHockeySticks: faHockeySticks,
  faAbacus: faAbacus,
  faFilmSimple: faFilmSimple,
  faFilmAlt: faFilmAlt,
  faList: faList,
  faListSquares: faListSquares,
  faTreePalm: faTreePalm,
  faSquarePhoneFlip: faSquarePhoneFlip,
  faPhoneSquareAlt: faPhoneSquareAlt,
  faCartPlus: faCartPlus,
  faGamepad: faGamepad,
  faBorderCenterV: faBorderCenterV,
  faCircleDot: faCircleDot,
  faDotCircle: faDotCircle,
  faClipboardMedical: faClipboardMedical,
  faFaceDizzy: faFaceDizzy,
  faDizzy: faDizzy,
  faEgg: faEgg,
  faUpToLine: faUpToLine,
  faArrowAltToTop: faArrowAltToTop,
  faHouseMedicalCircleXmark: faHouseMedicalCircleXmark,
  faWatchFitness: faWatchFitness,
  faClockNineThirty: faClockNineThirty,
  faCampground: faCampground,
  faFolderPlus: faFolderPlus,
  faJug: faJug,
  faFutbol: faFutbol,
  faFutbolBall: faFutbolBall,
  faSoccerBall: faSoccerBall,
  faSnowBlowing: faSnowBlowing,
  faPaintbrush: faPaintbrush,
  faPaintBrush: faPaintBrush,
  faLock: faLock,
  faArrowDownFromLine: faArrowDownFromLine,
  faArrowFromTop: faArrowFromTop,
  faGasPump: faGasPump,
  faSignalBarsSlash: faSignalBarsSlash,
  faSignalAltSlash: faSignalAltSlash,
  faMonkey: faMonkey,
  faRectanglePro: faRectanglePro,
  faPro: faPro,
  faHouseNight: faHouseNight,
  faHotTubPerson: faHotTubPerson,
  faHotTub: faHotTub,
  faBlanket: faBlanket,
  faMapLocation: faMapLocation,
  faMapMarked: faMapMarked,
  faHouseFloodWater: faHouseFloodWater,
  faCommentsQuestionCheck: faCommentsQuestionCheck,
  faTree: faTree,
  faArrowsCross: faArrowsCross,
  faBackpack: faBackpack,
  faSquareSmall: faSquareSmall,
  faFolderArrowUp: faFolderArrowUp,
  faFolderUpload: faFolderUpload,
  faBridgeLock: faBridgeLock,
  faCrosshairsSimple: faCrosshairsSimple,
  faSackDollar: faSackDollar,
  faPenToSquare: faPenToSquare,
  faEdit: faEdit,
  faSquareSliders: faSquareSliders,
  faSlidersHSquare: faSlidersHSquare,
  faCarSide: faCarSide,
  faMessageMiddleTop: faMessageMiddleTop,
  faCommentMiddleTopAlt: faCommentMiddleTopAlt,
  faLightbulbOn: faLightbulbOn,
  faKnife: faKnife,
  faUtensilKnife: faUtensilKnife,
  faShareNodes: faShareNodes,
  faShareAlt: faShareAlt,
  faDisplayChartUpCircleDollar: faDisplayChartUpCircleDollar,
  faWaveSine: faWaveSine,
  faHeartCircleMinus: faHeartCircleMinus,
  faCircleW: faCircleW,
  faCircleCalendar: faCircleCalendar,
  faCalendarCircle: faCalendarCircle,
  faHourglassHalf: faHourglassHalf,
  faHourglass2: faHourglass2,
  faMicroscope: faMicroscope,
  faSunset: faSunset,
  faSink: faSink,
  faCalendarExclamation: faCalendarExclamation,
  faTruckContainerEmpty: faTruckContainerEmpty,
  faHandHeart: faHandHeart,
  faBagShopping: faBagShopping,
  faShoppingBag: faShoppingBag,
  faArrowDownZA: faArrowDownZA,
  faSortAlphaDesc: faSortAlphaDesc,
  faSortAlphaDownAlt: faSortAlphaDownAlt,
  faMitten: faMitten,
  faReplyClock: faReplyClock,
  faReplyTime: faReplyTime,
  faPersonRays: faPersonRays,
  faRight: faRight,
  faArrowAltRight: faArrowAltRight,
  faCircleF: faCircleF,
  faUsers: faUsers,
  faFacePleading: faFacePleading,
  faEyeSlash: faEyeSlash,
  faFlaskVial: faFlaskVial,
  faPoliceBox: faPoliceBox,
  faCucumber: faCucumber,
  faHeadSideBrain: faHeadSideBrain,
  faHand: faHand,
  faHandPaper: faHandPaper,
  faPersonBikingMountain: faPersonBikingMountain,
  faBikingMountain: faBikingMountain,
  faUtensilsSlash: faUtensilsSlash,
  faPrintMagnifyingGlass: faPrintMagnifyingGlass,
  faPrintSearch: faPrintSearch,
  faFolderBookmark: faFolderBookmark,
  faOm: faOm,
  faPi: faPi,
  faFlaskRoundPotion: faFlaskRoundPotion,
  faFlaskPotion: faFlaskPotion,
  faFaceShush: faFaceShush,
  faWorm: faWorm,
  faHouseCircleXmark: faHouseCircleXmark,
  faPlug: faPlug,
  faCalendarCircleExclamation: faCalendarCircleExclamation,
  faSquareI: faSquareI,
  faChevronUp: faChevronUp,
  faFaceSaluting: faFaceSaluting,
  faGaugeSimpleLow: faGaugeSimpleLow,
  faTachometerSlow: faTachometerSlow,
  faFacePersevering: faFacePersevering,
  faCircleCamera: faCircleCamera,
  faCameraCircle: faCameraCircle,
  faHandSpock: faHandSpock,
  faSpiderWeb: faSpiderWeb,
  faCircleMicrophone: faCircleMicrophone,
  faMicrophoneCircle: faMicrophoneCircle,
  faBookArrowUp: faBookArrowUp,
  faPopsicle: faPopsicle,
  faCommand: faCommand,
  faBlinds: faBlinds,
  faStopwatch: faStopwatch,
  faSaxophone: faSaxophone,
  faSquare2: faSquare2,
  faFieldHockeyStickBall: faFieldHockeyStickBall,
  faFieldHockey: faFieldHockey,
  faArrowUpSquareTriangle: faArrowUpSquareTriangle,
  faSortShapesUpAlt: faSortShapesUpAlt,
  faFaceScream: faFaceScream,
  faSquareM: faSquareM,
  faCameraWeb: faCameraWeb,
  faWebcam: faWebcam,
  faCommentArrowDown: faCommentArrowDown,
  faLightbulbCfl: faLightbulbCfl,
  faWindowFrameOpen: faWindowFrameOpen,
  faFaceKiss: faFaceKiss,
  faKiss: faKiss,
  faBridgeCircleXmark: faBridgeCircleXmark,
  faPeriod: faPeriod,
  faFaceGrinTongue: faFaceGrinTongue,
  faGrinTongue: faGrinTongue,
  faUpToDottedLine: faUpToDottedLine,
  faThoughtBubble: faThoughtBubble,
  faSkeletonRibs: faSkeletonRibs,
  faRaygun: faRaygun,
  faFlute: faFlute,
  faAcorn: faAcorn,
  faVideoArrowUpRight: faVideoArrowUpRight,
  faGrateDroplet: faGrateDroplet,
  faSealExclamation: faSealExclamation,
  faChessBishop: faChessBishop,
  faMessageSms: faMessageSms,
  faCoffeeBeans: faCoffeeBeans,
  faHatWitch: faHatWitch,
  faFaceGrinWink: faFaceGrinWink,
  faGrinWink: faGrinWink,
  faClockThreeThirty: faClockThreeThirty,
  faEarDeaf: faEarDeaf,
  faDeaf: faDeaf,
  faDeafness: faDeafness,
  faHardOfHearing: faHardOfHearing,
  faAlarmClock: faAlarmClock,
  faEclipse: faEclipse,
  faFaceRelieved: faFaceRelieved,
  faRoadCircleCheck: faRoadCircleCheck,
  faDiceFive: faDiceFive,
  faOctagonMinus: faOctagonMinus,
  faMinusOctagon: faMinusOctagon,
  faSquareRss: faSquareRss,
  faRssSquare: faRssSquare,
  faFaceZany: faFaceZany,
  faTricycle: faTricycle,
  faLandMineOn: faLandMineOn,
  faSquareArrowUpLeft: faSquareArrowUpLeft,
  faICursor: faICursor,
  faChartMixedUpCircleDollar: faChartMixedUpCircleDollar,
  faSaltShaker: faSaltShaker,
  faStamp: faStamp,
  faFilePlus: faFilePlus,
  faDrawSquare: faDrawSquare,
  faToiletPaperUnderSlash: faToiletPaperUnderSlash,
  faToiletPaperReverseSlash: faToiletPaperReverseSlash,
  faStairs: faStairs,
  faDroneFront: faDroneFront,
  faDroneAlt: faDroneAlt,
  faGlassEmpty: faGlassEmpty,
  faDialHigh: faDialHigh,
  faUserHelmetSafety: faUserHelmetSafety,
  faUserConstruction: faUserConstruction,
  faUserHardHat: faUserHardHat,
  faI: faI,
  faHryvniaSign: faHryvniaSign,
  faHryvnia: faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter: faArrowDownLeftAndArrowUpRightToCenter,
  faPills: faPills,
  faFaceGrinWide: faFaceGrinWide,
  faGrinAlt: faGrinAlt,
  faTooth: faTooth,
  faBasketballHoop: faBasketballHoop,
  faObjectsAlignBottom: faObjectsAlignBottom,
  faV: faV,
  faSparkles: faSparkles,
  faSquid: faSquid,
  faLeafyGreen: faLeafyGreen,
  faCircleArrowUpRight: faCircleArrowUpRight,
  faCalendars: faCalendars,
  faBangladeshiTakaSign: faBangladeshiTakaSign,
  faBicycle: faBicycle,
  faHammerWar: faHammerWar,
  faCircleD: faCircleD,
  faSpiderBlackWidow: faSpiderBlackWidow,
  faStaffSnake: faStaffSnake,
  faRodAsclepius: faRodAsclepius,
  faRodSnake: faRodSnake,
  faStaffAesculapius: faStaffAesculapius,
  faPear: faPear,
  faHeadSideCoughSlash: faHeadSideCoughSlash,
  faTriangle: faTriangle,
  faApartment: faApartment,
  faTruckMedical: faTruckMedical,
  faAmbulance: faAmbulance,
  faPepper: faPepper,
  faPiano: faPiano,
  faGunSquirt: faGunSquirt,
  faWheatAwnCircleExclamation: faWheatAwnCircleExclamation,
  faSnowman: faSnowman,
  faUserAlien: faUserAlien,
  faShieldCheck: faShieldCheck,
  faMortarPestle: faMortarPestle,
  faRoadBarrier: faRoadBarrier,
  faChartCandlestick: faChartCandlestick,
  faBriefcaseBlank: faBriefcaseBlank,
  faSchool: faSchool,
  faIgloo: faIgloo,
  faBracketRound: faBracketRound,
  faParenthesis: faParenthesis,
  faJoint: faJoint,
  faHorseSaddle: faHorseSaddle,
  faMugMarshmallows: faMugMarshmallows,
  faFilters: faFilters,
  faBellOn: faBellOn,
  faAngleRight: faAngleRight,
  faDialMed: faDialMed,
  faHorse: faHorse,
  faQ: faQ,
  faMonitorWaveform: faMonitorWaveform,
  faMonitorHeartRate: faMonitorHeartRate,
  faLinkSimple: faLinkSimple,
  faWhistle: faWhistle,
  faG: faG,
  faWineGlassCrack: faWineGlassCrack,
  faFragile: faFragile,
  faSlotMachine: faSlotMachine,
  faNotesMedical: faNotesMedical,
  faCarWash: faCarWash,
  faEscalator: faEscalator,
  faCommentImage: faCommentImage,
  faTemperatureHalf: faTemperatureHalf,
  faTemperature2: faTemperature2,
  faThermometer2: faThermometer2,
  faThermometerHalf: faThermometerHalf,
  faDongSign: faDongSign,
  faDonut: faDonut,
  faDoughnut: faDoughnut,
  faCapsules: faCapsules,
  faPooStorm: faPooStorm,
  faPooBolt: faPooBolt,
  faTally1: faTally1,
  faFaceFrownOpen: faFaceFrownOpen,
  faFrownOpen: faFrownOpen,
  faSquareDashed: faSquareDashed,
  faSquareJ: faSquareJ,
  faHandPointUp: faHandPointUp,
  faMoneyBill: faMoneyBill,
  faArrowUpBigSmall: faArrowUpBigSmall,
  faSortSizeUp: faSortSizeUp,
  faBarcodeRead: faBarcodeRead,
  faBaguette: faBaguette,
  faBowlSoftServe: faBowlSoftServe,
  faFaceHoldingBackTears: faFaceHoldingBackTears,
  faSquareUp: faSquareUp,
  faArrowAltSquareUp: faArrowAltSquareUp,
  faTrainSubwayTunnel: faTrainSubwayTunnel,
  faSubwayTunnel: faSubwayTunnel,
  faSquareExclamation: faSquareExclamation,
  faExclamationSquare: faExclamationSquare,
  faSemicolon: faSemicolon,
  faBookmark: faBookmark,
  faFanTable: faFanTable,
  faAlignJustify: faAlignJustify,
  faBatteryLow: faBatteryLow,
  faBattery1: faBattery1,
  faCreditCardFront: faCreditCardFront,
  faBrainArrowCurvedRight: faBrainArrowCurvedRight,
  faMindShare: faMindShare,
  faUmbrellaBeach: faUmbrellaBeach,
  faHelmetUn: faHelmetUn,
  faLocationSmile: faLocationSmile,
  faMapMarkerSmile: faMapMarkerSmile,
  faArrowLeftToLine: faArrowLeftToLine,
  faArrowToLeft: faArrowToLeft,
  faBullseye: faBullseye,
  faSushi: faSushi,
  faNigiri: faNigiri,
  faMessageCaptions: faMessageCaptions,
  faCommentAltCaptions: faCommentAltCaptions,
  faTrashList: faTrashList,
  faBacon: faBacon,
  faOption: faOption,
  faHandPointDown: faHandPointDown,
  faArrowUpFromBracket: faArrowUpFromBracket,
  faTrashPlus: faTrashPlus,
  faObjectsAlignTop: faObjectsAlignTop,
  faFolder: faFolder,
  faFolderBlank: faFolderBlank,
  faFaceAnxiousSweat: faFaceAnxiousSweat,
  faCreditCardBlank: faCreditCardBlank,
  faFileWaveform: faFileWaveform,
  faFileMedicalAlt: faFileMedicalAlt,
  faMicrochipAi: faMicrochipAi,
  faMug: faMug,
  faPlaneUpSlash: faPlaneUpSlash,
  faRadiation: faRadiation,
  faPenCircle: faPenCircle,
  faBagSeedling: faBagSeedling,
  faChartSimple: faChartSimple,
  faCrutches: faCrutches,
  faCircleParking: faCircleParking,
  faParkingCircle: faParkingCircle,
  faMarsStroke: faMarsStroke,
  faLeafOak: faLeafOak,
  faSquareBolt: faSquareBolt,
  faVial: faVial,
  faGauge: faGauge,
  faDashboard: faDashboard,
  faGaugeMed: faGaugeMed,
  faTachometerAltAverage: faTachometerAltAverage,
  faWandMagicSparkles: faWandMagicSparkles,
  faMagicWandSparkles: faMagicWandSparkles,
  faLambda: faLambda,
  faE: faE,
  faPizza: faPizza,
  faBowlChopsticksNoodles: faBowlChopsticksNoodles,
  faH3: faH3,
  faPenClip: faPenClip,
  faPenAlt: faPenAlt,
  faBridgeCircleExclamation: faBridgeCircleExclamation,
  faBadgePercent: faBadgePercent,
  faUser: faUser,
  faSensor: faSensor,
  faComma: faComma,
  faSchoolCircleCheck: faSchoolCircleCheck,
  faToiletPaperUnder: faToiletPaperUnder,
  faToiletPaperReverse: faToiletPaperReverse,
  faLightEmergency: faLightEmergency,
  faArrowDownToArc: faArrowDownToArc,
  faDumpster: faDumpster,
  faVanShuttle: faVanShuttle,
  faShuttleVan: faShuttleVan,
  faBuildingUser: faBuildingUser,
  faLightSwitch: faLightSwitch,
  faSquareCaretLeft: faSquareCaretLeft,
  faCaretSquareLeft: faCaretSquareLeft,
  faHighlighter: faHighlighter,
  faWavePulse: faWavePulse,
  faHeartRate: faHeartRate,
  faKey: faKey,
  faHatSanta: faHatSanta,
  faTamale: faTamale,
  faBoxCheck: faBoxCheck,
  faBullhorn: faBullhorn,
  faSteak: faSteak,
  faLocationCrosshairsSlash: faLocationCrosshairsSlash,
  faLocationSlash: faLocationSlash,
  faPersonDolly: faPersonDolly,
  faGlobe: faGlobe,
  faSynagogue: faSynagogue,
  faFileChartColumn: faFileChartColumn,
  faFileChartLine: faFileChartLine,
  faPersonHalfDress: faPersonHalfDress,
  faFolderImage: faFolderImage,
  faCalendarPen: faCalendarPen,
  faCalendarEdit: faCalendarEdit,
  faRoadBridge: faRoadBridge,
  faFaceSmileTear: faFaceSmileTear,
  faMessagePlus: faMessagePlus,
  faCommentAltPlus: faCommentAltPlus,
  faLocationArrow: faLocationArrow,
  faC: faC,
  faTabletButton: faTabletButton,
  faRectangleHistoryCircleUser: faRectangleHistoryCircleUser,
  faBuildingLock: faBuildingLock,
  faChartLineUp: faChartLineUp,
  faMailbox: faMailbox,
  faTruckBolt: faTruckBolt,
  faPizzaSlice: faPizzaSlice,
  faMoneyBillWave: faMoneyBillWave,
  faChartArea: faChartArea,
  faAreaChart: faAreaChart,
  faHouseFlag: faHouseFlag,
  faCircleThreeQuartersStroke: faCircleThreeQuartersStroke,
  faPersonCircleMinus: faPersonCircleMinus,
  faScalpel: faScalpel,
  faBan: faBan,
  faCancel: faCancel,
  faBellExclamation: faBellExclamation,
  faCircleBookmark: faCircleBookmark,
  faBookmarkCircle: faBookmarkCircle,
  faEggFried: faEggFried,
  faFaceWeary: faFaceWeary,
  faUniformMartialArts: faUniformMartialArts,
  faCameraRotate: faCameraRotate,
  faSunDust: faSunDust,
  faCommentText: faCommentText,
  faSprayCanSparkles: faSprayCanSparkles,
  faAirFreshener: faAirFreshener,
  faSignalBars: faSignalBars,
  faSignalAlt: faSignalAlt,
  faSignalAlt4: faSignalAlt4,
  faSignalBarsStrong: faSignalBarsStrong,
  faDiamondExclamation: faDiamondExclamation,
  faStar: faStar,
  faDialMin: faDialMin,
  faRepeat: faRepeat,
  faCross: faCross,
  faPageCaretDown: faPageCaretDown,
  faFileCaretDown: faFileCaretDown,
  faBox: faBox,
  faVenusMars: faVenusMars,
  faClockSevenThirty: faClockSevenThirty,
  faArrowPointer: faArrowPointer,
  faMousePointer: faMousePointer,
  faClockFourThirty: faClockFourThirty,
  faSignalBarsGood: faSignalBarsGood,
  faSignalAlt3: faSignalAlt3,
  faCactus: faCactus,
  faLightbulbGear: faLightbulbGear,
  faMaximize: faMaximize,
  faExpandArrowsAlt: faExpandArrowsAlt,
  faChargingStation: faChargingStation,
  faShapes: faShapes,
  faTriangleCircleSquare: faTriangleCircleSquare,
  faPlaneTail: faPlaneTail,
  faGaugeSimpleMax: faGaugeSimpleMax,
  faTachometerFastest: faTachometerFastest,
  faCircleU: faCircleU,
  faShieldSlash: faShieldSlash,
  faSquarePhoneHangup: faSquarePhoneHangup,
  faPhoneSquareDown: faPhoneSquareDown,
  faArrowUpLeft: faArrowUpLeft,
  faTransporter1: faTransporter1,
  faPeanuts: faPeanuts,
  faShuffle: faShuffle,
  faRandom: faRandom,
  faPersonRunning: faPersonRunning,
  faRunning: faRunning,
  faMobileRetro: faMobileRetro,
  faGripLinesVertical: faGripLinesVertical,
  faBinBottlesRecycle: faBinBottlesRecycle,
  faArrowUpFromSquare: faArrowUpFromSquare,
  faFileDashedLine: faFileDashedLine,
  faPageBreak: faPageBreak,
  faBracketCurlyRight: faBracketCurlyRight,
  faSpider: faSpider,
  faClockThree: faClockThree,
  faHandsBound: faHandsBound,
  faScalpelLineDashed: faScalpelLineDashed,
  faScalpelPath: faScalpelPath,
  faFileInvoiceDollar: faFileInvoiceDollar,
  faPipeSmoking: faPipeSmoking,
  faFaceAstonished: faFaceAstonished,
  faWindow: faWindow,
  faPlaneCircleExclamation: faPlaneCircleExclamation,
  faEar: faEar,
  faFileLock: faFileLock,
  faDiagramVenn: faDiagramVenn,
  faXRay: faXRay,
  faGoalNet: faGoalNet,
  faCoffinCross: faCoffinCross,
  faSpellCheck: faSpellCheck,
  faLocationXmark: faLocationXmark,
  faMapMarkerTimes: faMapMarkerTimes,
  faMapMarkerXmark: faMapMarkerXmark,
  faCircleQuarterStroke: faCircleQuarterStroke,
  faLasso: faLasso,
  faSlash: faSlash,
  faPersonToPortal: faPersonToPortal,
  faPortalEnter: faPortalEnter,
  faCalendarStar: faCalendarStar,
  faComputerMouse: faComputerMouse,
  faMouse: faMouse,
  faArrowRightToBracket: faArrowRightToBracket,
  faSignIn: faSignIn,
  faPegasus: faPegasus,
  faFilesMedical: faFilesMedical,
  faNfcLock: faNfcLock,
  faPersonSkiLift: faPersonSkiLift,
  faSkiLift: faSkiLift,
  faSquare6: faSquare6,
  faShopSlash: faShopSlash,
  faStoreAltSlash: faStoreAltSlash,
  faWindTurbine: faWindTurbine,
  faSlidersSimple: faSlidersSimple,
  faGridRound: faGridRound,
  faBadgeSheriff: faBadgeSheriff,
  faServer: faServer,
  faVirusCovidSlash: faVirusCovidSlash,
  faIntersection: faIntersection,
  faShopLock: faShopLock,
  faFamily: faFamily,
  faHourglassStart: faHourglassStart,
  faHourglass1: faHourglass1,
  faUserHairBuns: faUserHairBuns,
  faBlenderPhone: faBlenderPhone,
  faHourglassClock: faHourglassClock,
  faPersonSeatReclined: faPersonSeatReclined,
  faPaperPlaneTop: faPaperPlaneTop,
  faPaperPlaneAlt: faPaperPlaneAlt,
  faSend: faSend,
  faMessageArrowUp: faMessageArrowUp,
  faCommentAltArrowUp: faCommentAltArrowUp,
  faLightbulbExclamation: faLightbulbExclamation,
  faLayerMinus: faLayerMinus,
  faLayerGroupMinus: faLayerGroupMinus,
  faChartPieSimpleCircleCurrency: faChartPieSimpleCircleCurrency,
  faCircleE: faCircleE,
  faBuildingWheat: faBuildingWheat,
  faGaugeMax: faGaugeMax,
  faTachometerAltFastest: faTachometerAltFastest,
  faPersonBreastfeeding: faPersonBreastfeeding,
  faApostrophe: faApostrophe,
  faFireHydrant: faFireHydrant,
  faRightToBracket: faRightToBracket,
  faSignInAlt: faSignInAlt,
  faVideoPlus: faVideoPlus,
  faSquareRight: faSquareRight,
  faArrowAltSquareRight: faArrowAltSquareRight,
  faCommentSmile: faCommentSmile,
  faVenus: faVenus,
  faPassport: faPassport,
  faInboxIn: faInboxIn,
  faInboxArrowDown: faInboxArrowDown,
  faHeartPulse: faHeartPulse,
  faHeartbeat: faHeartbeat,
  faCircle8: faCircle8,
  faCloudsMoon: faCloudsMoon,
  faClockTenThirty: faClockTenThirty,
  faPeopleCarryBox: faPeopleCarryBox,
  faPeopleCarry: faPeopleCarry,
  faFolderUser: faFolderUser,
  faTrashCanXmark: faTrashCanXmark,
  faTemperatureHigh: faTemperatureHigh,
  faMicrochip: faMicrochip,
  faLeftLongToLine: faLeftLongToLine,
  faCrown: faCrown,
  faWeightHanging: faWeightHanging,
  faXmarksLines: faXmarksLines,
  faFilePrescription: faFilePrescription,
  faCalendarRange: faCalendarRange,
  faFlowerDaffodil: faFlowerDaffodil,
  faHandBackPointUp: faHandBackPointUp,
  faWeightScale: faWeightScale,
  faWeight: faWeight,
  faStarExclamation: faStarExclamation,
  faBooks: faBooks,
  faUserGroup: faUserGroup,
  faUserFriends: faUserFriends,
  faArrowUpAZ: faArrowUpAZ,
  faSortAlphaUp: faSortAlphaUp,
  faLayerPlus: faLayerPlus,
  faLayerGroupPlus: faLayerGroupPlus,
  faPlayPause: faPlayPause,
  faBlockQuestion: faBlockQuestion,
  faSnooze: faSnooze,
  faZzz: faZzz,
  faScannerImage: faScannerImage,
  faTvRetro: faTvRetro,
  faSquareT: faSquareT,
  faFarm: faFarm,
  faBarnSilo: faBarnSilo,
  faChessKnight: faChessKnight,
  faBarsSort: faBarsSort,
  faPalletBoxes: faPalletBoxes,
  faPaletteBoxes: faPaletteBoxes,
  faPalletAlt: faPalletAlt,
  faFaceLaughSquint: faFaceLaughSquint,
  faLaughSquint: faLaughSquint,
  faCodeSimple: faCodeSimple,
  faBoltSlash: faBoltSlash,
  faPanelFire: faPanelFire,
  faBinaryCircleCheck: faBinaryCircleCheck,
  faCommentMinus: faCommentMinus,
  faBurrito: faBurrito,
  faViolin: faViolin,
  faObjectsColumn: faObjectsColumn,
  faSquareChevronDown: faSquareChevronDown,
  faChevronSquareDown: faChevronSquareDown,
  faCommentPlus: faCommentPlus,
  faTriangleInstrument: faTriangleInstrument,
  faTriangleMusic: faTriangleMusic,
  faWheelchair: faWheelchair,
  faUserPilotTie: faUserPilotTie,
  faPianoKeyboard: faPianoKeyboard,
  faBedEmpty: faBedEmpty,
  faCircleArrowUp: faCircleArrowUp,
  faArrowCircleUp: faArrowCircleUp,
  faToggleOn: faToggleOn,
  faRectangleVertical: faRectangleVertical,
  faRectanglePortrait: faRectanglePortrait,
  faPersonWalking: faPersonWalking,
  faWalking: faWalking,
  faL: faL,
  faSignalStream: faSignalStream,
  faDownToBracket: faDownToBracket,
  faCircleZ: faCircleZ,
  faStars: faStars,
  faFire: faFire,
  faBedPulse: faBedPulse,
  faProcedures: faProcedures,
  faHouseDay: faHouseDay,
  faShuttleSpace: faShuttleSpace,
  faSpaceShuttle: faSpaceShuttle,
  faShirtLongSleeve: faShirtLongSleeve,
  faChartPieSimple: faChartPieSimple,
  faChartPieAlt: faChartPieAlt,
  faFaceLaugh: faFaceLaugh,
  faLaugh: faLaugh,
  faFolderOpen: faFolderOpen,
  faAlbumCollectionCircleUser: faAlbumCollectionCircleUser,
  faCandy: faCandy,
  faBowlHot: faBowlHot,
  faSoup: faSoup,
  faFlatbread: faFlatbread,
  faHeartCirclePlus: faHeartCirclePlus,
  faCodeFork: faCodeFork,
  faCity: faCity,
  faSignalBarsWeak: faSignalBarsWeak,
  faSignalAlt1: faSignalAlt1,
  faMicrophoneLines: faMicrophoneLines,
  faMicrophoneAlt: faMicrophoneAlt,
  faClockTwelve: faClockTwelve,
  faPepperHot: faPepperHot,
  faCitrusSlice: faCitrusSlice,
  faSheep: faSheep,
  faUnlock: faUnlock,
  faColonSign: faColonSign,
  faHeadset: faHeadset,
  faBadgerHoney: faBadgerHoney,
  faH4: faH4,
  faStoreSlash: faStoreSlash,
  faRoadCircleXmark: faRoadCircleXmark,
  faSignalSlash: faSignalSlash,
  faUserMinus: faUserMinus,
  faMarsStrokeUp: faMarsStrokeUp,
  faMarsStrokeV: faMarsStrokeV,
  faChampagneGlasses: faChampagneGlasses,
  faGlassCheers: faGlassCheers,
  faTaco: faTaco,
  faHexagonPlus: faHexagonPlus,
  faPlusHexagon: faPlusHexagon,
  faClipboard: faClipboard,
  faHouseCircleExclamation: faHouseCircleExclamation,
  faFileArrowUp: faFileArrowUp,
  faFileUpload: faFileUpload,
  faWifi: faWifi,
  faWifi3: faWifi3,
  faWifiStrong: faWifiStrong,
  faMessages: faMessages,
  faCommentsAlt: faCommentsAlt,
  faBath: faBath,
  faBathtub: faBathtub,
  faUmbrellaSimple: faUmbrellaSimple,
  faUmbrellaAlt: faUmbrellaAlt,
  faRectangleHistoryCirclePlus: faRectangleHistoryCirclePlus,
  faUnderline: faUnderline,
  faPrescriptionBottlePill: faPrescriptionBottlePill,
  faUserPen: faUserPen,
  faUserEdit: faUserEdit,
  faBinarySlash: faBinarySlash,
  faSquareO: faSquareO,
  faSignature: faSignature,
  faStroopwafel: faStroopwafel,
  faBold: faBold,
  faAnchorLock: faAnchorLock,
  faBuildingNgo: faBuildingNgo,
  faTransporter3: faTransporter3,
  faEngineWarning: faEngineWarning,
  faEngineExclamation: faEngineExclamation,
  faCircleDownRight: faCircleDownRight,
  faSquareK: faSquareK,
  faManatSign: faManatSign,
  faMoneyCheckPen: faMoneyCheckPen,
  faMoneyCheckEdit: faMoneyCheckEdit,
  faNotEqual: faNotEqual,
  faBorderTopLeft: faBorderTopLeft,
  faBorderStyle: faBorderStyle,
  faMapLocationDot: faMapLocationDot,
  faMapMarkedAlt: faMapMarkedAlt,
  faTilde: faTilde,
  faJedi: faJedi,
  faSquarePollVertical: faSquarePollVertical,
  faPoll: faPoll,
  faArrowDownSquareTriangle: faArrowDownSquareTriangle,
  faSortShapesDownAlt: faSortShapesDownAlt,
  faMugHot: faMugHot,
  faDogLeashed: faDogLeashed,
  faCarBattery: faCarBattery,
  faBatteryCar: faBatteryCar,
  faFaceDowncastSweat: faFaceDowncastSweat,
  faMailboxFlagUp: faMailboxFlagUp,
  faMemoCircleInfo: faMemoCircleInfo,
  faGift: faGift,
  faDiceTwo: faDiceTwo,
  faVolume: faVolume,
  faVolumeMedium: faVolumeMedium,
  faTransporter5: faTransporter5,
  faGaugeCircleBolt: faGaugeCircleBolt,
  faCoinFront: faCoinFront,
  faFileSlash: faFileSlash,
  faMessageArrowUpRight: faMessageArrowUpRight,
  faTreasureChest: faTreasureChest,
  faChessQueen: faChessQueen,
  faPaintbrushFine: faPaintbrushFine,
  faPaintBrushAlt: faPaintBrushAlt,
  faPaintBrushFine: faPaintBrushFine,
  faPaintbrushAlt: faPaintbrushAlt,
  faGlasses: faGlasses,
  faHoodCloak: faHoodCloak,
  faSquareQuote: faSquareQuote,
  faUpLeft: faUpLeft,
  faBringFront: faBringFront,
  faChessBoard: faChessBoard,
  faBurgerCheese: faBurgerCheese,
  faCheeseburger: faCheeseburger,
  faBuildingCircleCheck: faBuildingCircleCheck,
  faRepeat1: faRepeat1,
  faArrowDownToLine: faArrowDownToLine,
  faArrowToBottom: faArrowToBottom,
  faGrid5: faGrid5,
  faRightLongToLine: faRightLongToLine,
  faPersonChalkboard: faPersonChalkboard,
  faMarsStrokeRight: faMarsStrokeRight,
  faMarsStrokeH: faMarsStrokeH,
  faHandBackFist: faHandBackFist,
  faHandRock: faHandRock,
  faGridRound5: faGridRound5,
  faTally: faTally,
  faTally5: faTally5,
  faSquareCaretUp: faSquareCaretUp,
  faCaretSquareUp: faCaretSquareUp,
  faCloudShowersWater: faCloudShowersWater,
  faChartBar: faChartBar,
  faBarChart: faBarChart,
  faHandsBubbles: faHandsBubbles,
  faHandsWash: faHandsWash,
  faLessThanEqual: faLessThanEqual,
  faTrain: faTrain,
  faUpFromDottedLine: faUpFromDottedLine,
  faEyeLowVision: faEyeLowVision,
  faLowVision: faLowVision,
  faTrafficLightGo: faTrafficLightGo,
  faFaceExhaling: faFaceExhaling,
  faSensorFire: faSensorFire,
  faUserUnlock: faUserUnlock,
  faHexagonDivide: faHexagonDivide,
  fa00: fa00,
  faCrow: faCrow,
  faCassetteBetamax: faCassetteBetamax,
  faBetamax: faBetamax,
  faSailboat: faSailboat,
  faWindowRestore: faWindowRestore,
  faNfcMagnifyingGlass: faNfcMagnifyingGlass,
  faFileBinary: faFileBinary,
  faCircleV: faCircleV,
  faSquarePlus: faSquarePlus,
  faPlusSquare: faPlusSquare,
  faBowlScoops: faBowlScoops,
  faMistletoe: faMistletoe,
  faCustard: faCustard,
  faLacrosseStick: faLacrosseStick,
  faHockeyMask: faHockeyMask,
  faSunrise: faSunrise,
  faPanelEws: faPanelEws,
  faToriiGate: faToriiGate,
  faCloudExclamation: faCloudExclamation,
  faMessageLines: faMessageLines,
  faCommentAltLines: faCommentAltLines,
  faFrog: faFrog,
  faBucket: faBucket,
  faFloppyDiskPen: faFloppyDiskPen,
  faImage: faImage,
  faWindowFrame: faWindowFrame,
  faMicrophone: faMicrophone,
  faCow: faCow,
  faFileZip: faFileZip,
  faSquareRing: faSquareRing,
  faDownFromLine: faDownFromLine,
  faArrowAltFromTop: faArrowAltFromTop,
  faCaretUp: faCaretUp,
  faShieldXmark: faShieldXmark,
  faShieldTimes: faShieldTimes,
  faScrewdriver: faScrewdriver,
  faCircleSortDown: faCircleSortDown,
  faSortCircleDown: faSortCircleDown,
  faFolderClosed: faFolderClosed,
  faHouseTsunami: faHouseTsunami,
  faSquareNfi: faSquareNfi,
  faForklift: faForklift,
  faArrowUpFromGroundWater: faArrowUpFromGroundWater,
  faBracketSquareRight: faBracketSquareRight,
  faMartiniGlass: faMartiniGlass,
  faGlassMartiniAlt: faGlassMartiniAlt,
  faRotateLeft: faRotateLeft,
  faRotateBack: faRotateBack,
  faRotateBackward: faRotateBackward,
  faUndoAlt: faUndoAlt,
  faTableColumns: faTableColumns,
  faColumns: faColumns,
  faSquareA: faSquareA,
  faTick: faTick,
  faLemon: faLemon,
  faHeadSideMask: faHeadSideMask,
  faHandshake: faHandshake,
  faGem: faGem,
  faDolly: faDolly,
  faDollyBox: faDollyBox,
  faSmoking: faSmoking,
  faMinimize: faMinimize,
  faCompressArrowsAlt: faCompressArrowsAlt,
  faRefrigerator: faRefrigerator,
  faMonument: faMonument,
  faOctagonXmark: faOctagonXmark,
  faTimesOctagon: faTimesOctagon,
  faXmarkOctagon: faXmarkOctagon,
  faAlignSlash: faAlignSlash,
  faSnowplow: faSnowplow,
  faAnglesRight: faAnglesRight,
  faAngleDoubleRight: faAngleDoubleRight,
  faTruckRampCouch: faTruckRampCouch,
  faTruckCouch: faTruckCouch,
  faCannabis: faCannabis,
  faCirclePlay: faCirclePlay,
  faPlayCircle: faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter: faArrowUpRightAndArrowDownLeftFromCenter,
  faTablets: faTablets,
  fa360Degrees: fa360Degrees,
  faEthernet: faEthernet,
  faEuroSign: faEuroSign,
  faEur: faEur,
  faEuro: faEuro,
  faChair: faChair,
  faCircleCheck: faCircleCheck,
  faCheckCircle: faCheckCircle,
  faSquareDashedCirclePlus: faSquareDashedCirclePlus,
  faMoneySimpleFromBracket: faMoneySimpleFromBracket,
  faBat: faBat,
  faCircleStop: faCircleStop,
  faStopCircle: faStopCircle,
  faHeadSideHeadphones: faHeadSideHeadphones,
  faPhoneRotary: faPhoneRotary,
  faCompassDrafting: faCompassDrafting,
  faDraftingCompass: faDraftingCompass,
  faPlateWheat: faPlateWheat,
  faCalendarCircleMinus: faCalendarCircleMinus,
  faChopsticks: faChopsticks,
  faCarWrench: faCarWrench,
  faCarMechanic: faCarMechanic,
  faIcicles: faIcicles,
  faPersonShelter: faPersonShelter,
  faNeuter: faNeuter,
  faIdBadge: faIdBadge,
  faKazoo: faKazoo,
  faMarker: faMarker,
  faBinBottles: faBinBottles,
  faFaceLaughBeam: faFaceLaughBeam,
  faLaughBeam: faLaughBeam,
  faSquareArrowDownLeft: faSquareArrowDownLeft,
  faBatteryBolt: faBatteryBolt,
  faTreeLarge: faTreeLarge,
  faHelicopterSymbol: faHelicopterSymbol,
  faAperture: faAperture,
  faUniversalAccess: faUniversalAccess,
  faGearComplex: faGearComplex,
  faFileMagnifyingGlass: faFileMagnifyingGlass,
  faFileSearch: faFileSearch,
  faUpRight: faUpRight,
  faCircleChevronUp: faCircleChevronUp,
  faChevronCircleUp: faChevronCircleUp,
  faUserPolice: faUserPolice,
  faLariSign: faLariSign,
  faVolcano: faVolcano,
  faTeddyBear: faTeddyBear,
  faStocking: faStocking,
  faPersonWalkingDashedLineArrowRight: faPersonWalkingDashedLineArrowRight,
  faImageSlash: faImageSlash,
  faMaskSnorkel: faMaskSnorkel,
  faSmoke: faSmoke,
  faSterlingSign: faSterlingSign,
  faGbp: faGbp,
  faPoundSign: faPoundSign,
  faBatteryExclamation: faBatteryExclamation,
  faViruses: faViruses,
  faSquarePersonConfined: faSquarePersonConfined,
  faUserTie: faUserTie,
  faArrowDownLong: faArrowDownLong,
  faLongArrowDown: faLongArrowDown,
  faTentArrowDownToLine: faTentArrowDownToLine,
  faCertificate: faCertificate,
  faCrystalBall: faCrystalBall,
  faReplyAll: faReplyAll,
  faMailReplyAll: faMailReplyAll,
  faSuitcase: faSuitcase,
  faPersonSkating: faPersonSkating,
  faSkating: faSkating,
  faStarShooting: faStarShooting,
  faBinaryLock: faBinaryLock,
  faFilterCircleDollar: faFilterCircleDollar,
  faFunnelDollar: faFunnelDollar,
  faCameraRetro: faCameraRetro,
  faCircleArrowDown: faCircleArrowDown,
  faArrowCircleDown: faArrowCircleDown,
  faCommentPen: faCommentPen,
  faCommentEdit: faCommentEdit,
  faFileImport: faFileImport,
  faArrowRightToFile: faArrowRightToFile,
  faBanjo: faBanjo,
  faSquareArrowUpRight: faSquareArrowUpRight,
  faExternalLinkSquare: faExternalLinkSquare,
  faLightEmergencyOn: faLightEmergencyOn,
  faKerning: faKerning,
  faBoxOpen: faBoxOpen,
  faSquareF: faSquareF,
  faScroll: faScroll,
  faSpa: faSpa,
  faArrowLeftFromLine: faArrowLeftFromLine,
  faArrowFromRight: faArrowFromRight,
  faStrawberry: faStrawberry,
  faLocationPinLock: faLocationPinLock,
  faPause: faPause,
  faClockEightThirty: faClockEightThirty,
  faPlaneEngines: faPlaneEngines,
  faPlaneAlt: faPlaneAlt,
  faHillAvalanche: faHillAvalanche,
  faTemperatureEmpty: faTemperatureEmpty,
  faTemperature0: faTemperature0,
  faThermometer0: faThermometer0,
  faThermometerEmpty: faThermometerEmpty,
  faBomb: faBomb,
  faGaugeLow: faGaugeLow,
  faTachometerAltSlow: faTachometerAltSlow,
  faRegistered: faRegistered,
  faTrashCanPlus: faTrashCanPlus,
  faAddressCard: faAddressCard,
  faContactCard: faContactCard,
  faVcard: faVcard,
  faScaleUnbalancedFlip: faScaleUnbalancedFlip,
  faBalanceScaleRight: faBalanceScaleRight,
  faGlobeSnow: faGlobeSnow,
  faSubscript: faSubscript,
  faDiamondTurnRight: faDiamondTurnRight,
  faDirections: faDirections,
  faIntegral: faIntegral,
  faBurst: faBurst,
  faHouseLaptop: faHouseLaptop,
  faLaptopHouse: faLaptopHouse,
  faFaceTired: faFaceTired,
  faTired: faTired,
  faMoneyBills: faMoneyBills,
  faBlindsRaised: faBlindsRaised,
  faSmog: faSmog,
  faUfoBeam: faUfoBeam,
  faCircleCaretUp: faCircleCaretUp,
  faCaretCircleUp: faCaretCircleUp,
  faUserVneckHairLong: faUserVneckHairLong,
  faSquareALock: faSquareALock,
  faCrutch: faCrutch,
  faGasPumpSlash: faGasPumpSlash,
  faFontAwesome: faFontAwesome,
  faFontAwesomeFlag: faFontAwesomeFlag,
  faFontAwesomeLogoFull: faFontAwesomeLogoFull,
  faCloudArrowUp: faCloudArrowUp,
  faCloudUpload: faCloudUpload,
  faCloudUploadAlt: faCloudUploadAlt,
  faPalette: faPalette,
  faTransporter4: faTransporter4,
  faChartMixedUpCircleCurrency: faChartMixedUpCircleCurrency,
  faObjectsAlignRight: faObjectsAlignRight,
  faArrowsTurnRight: faArrowsTurnRight,
  faVest: faVest,
  faPig: faPig,
  faInboxFull: faInboxFull,
  faCircleEnvelope: faCircleEnvelope,
  faEnvelopeCircle: faEnvelopeCircle,
  faTrianglePersonDigging: faTrianglePersonDigging,
  faConstruction: faConstruction,
  faFerry: faFerry,
  faBullseyeArrow: faBullseyeArrow,
  faArrowsDownToPeople: faArrowsDownToPeople,
  faSeedling: faSeedling,
  faSprout: faSprout,
  faClockSeven: faClockSeven,
  faLeftRight: faLeftRight,
  faArrowsAltH: faArrowsAltH,
  faBoxesPacking: faBoxesPacking,
  faCircleArrowLeft: faCircleArrowLeft,
  faArrowCircleLeft: faArrowCircleLeft,
  faFlashlight: faFlashlight,
  faGroupArrowsRotate: faGroupArrowsRotate,
  faBowlFood: faBowlFood,
  faSquare9: faSquare9,
  faCandyCane: faCandyCane,
  faArrowDownWideShort: faArrowDownWideShort,
  faSortAmountAsc: faSortAmountAsc,
  faSortAmountDown: faSortAmountDown,
  faSquareDollar: faSquareDollar,
  faDollarSquare: faDollarSquare,
  faUsdSquare: faUsdSquare,
  faPhoneArrowRight: faPhoneArrowRight,
  faHandHoldingSeedling: faHandHoldingSeedling,
  faMessageCheck: faMessageCheck,
  faCommentAltCheck: faCommentAltCheck,
  faCloudBolt: faCloudBolt,
  faThunderstorm: faThunderstorm,
  faChartLineUpDown: faChartLineUpDown,
  faTextSlash: faTextSlash,
  faRemoveFormat: faRemoveFormat,
  faWatch: faWatch,
  faCircleDownLeft: faCircleDownLeft,
  faText: faText,
  faProjector: faProjector,
  faFaceSmileWink: faFaceSmileWink,
  faSmileWink: faSmileWink,
  faTombstoneBlank: faTombstoneBlank,
  faTombstoneAlt: faTombstoneAlt,
  faChessKingPiece: faChessKingPiece,
  faChessKingAlt: faChessKingAlt,
  faCircle6: faCircle6,
  faLeft: faLeft,
  faArrowAltLeft: faArrowAltLeft,
  faFileWord: faFileWord,
  faFilePowerpoint: faFilePowerpoint,
  faSquareDown: faSquareDown,
  faArrowAltSquareDown: faArrowAltSquareDown,
  faObjectsAlignCenterVertical: faObjectsAlignCenterVertical,
  faArrowsLeftRight: faArrowsLeftRight,
  faArrowsH: faArrowsH,
  faHouseLock: faHouseLock,
  faCloudArrowDown: faCloudArrowDown,
  faCloudDownload: faCloudDownload,
  faCloudDownloadAlt: faCloudDownloadAlt,
  faWreath: faWreath,
  faChildren: faChildren,
  faMeterDroplet: faMeterDroplet,
  faChalkboard: faChalkboard,
  faBlackboard: faBlackboard,
  faUserLargeSlash: faUserLargeSlash,
  faUserAltSlash: faUserAltSlash,
  faSignalStrong: faSignalStrong,
  faSignal4: faSignal4,
  faLollipop: faLollipop,
  faLollypop: faLollypop,
  faListTree: faListTree,
  faEnvelopeOpen: faEnvelopeOpen,
  faDrawCircle: faDrawCircle,
  faCatSpace: faCatSpace,
  faHandshakeSimpleSlash: faHandshakeSimpleSlash,
  faHandshakeAltSlash: faHandshakeAltSlash,
  faRabbitRunning: faRabbitRunning,
  faRabbitFast: faRabbitFast,
  faMemoPad: faMemoPad,
  faMattressPillow: faMattressPillow,
  faAlarmPlus: faAlarmPlus,
  faAlicorn: faAlicorn,
  faCommentQuestion: faCommentQuestion,
  faGingerbreadMan: faGingerbreadMan,
  faGuaraniSign: faGuaraniSign,
  faBurgerFries: faBurgerFries,
  faMugTea: faMugTea,
  faBorderTop: faBorderTop,
  faArrowsRotate: faArrowsRotate,
  faRefresh: faRefresh,
  faSync: faSync,
  faCircleBookOpen: faCircleBookOpen,
  faBookCircle: faBookCircle,
  faArrowsToDottedLine: faArrowsToDottedLine,
  faFireExtinguisher: faFireExtinguisher,
  faGarageOpen: faGarageOpen,
  faShelvesEmpty: faShelvesEmpty,
  faCruzeiroSign: faCruzeiroSign,
  faWatchApple: faWatchApple,
  faWatchCalculator: faWatchCalculator,
  faListDropdown: faListDropdown,
  faCabinetFiling: faCabinetFiling,
  faBurgerSoda: faBurgerSoda,
  faSquareArrowUp: faSquareArrowUp,
  faArrowSquareUp: faArrowSquareUp,
  faGreaterThanEqual: faGreaterThanEqual,
  faPalletBox: faPalletBox,
  faFaceConfounded: faFaceConfounded,
  faShieldHalved: faShieldHalved,
  faShieldAlt: faShieldAlt,
  faTruckPlow: faTruckPlow,
  faBookAtlas: faBookAtlas,
  faAtlas: faAtlas,
  faVirus: faVirus,
  faGridRound2: faGridRound2,
  faCommentMiddleTop: faCommentMiddleTop,
  faEnvelopeCircleCheck: faEnvelopeCircleCheck,
  faLayerGroup: faLayerGroup,
  faRestroomSimple: faRestroomSimple,
  faArrowsToDot: faArrowsToDot,
  faBorderOuter: faBorderOuter,
  faHashtagLock: faHashtagLock,
  faClockTwoThirty: faClockTwoThirty,
  faArchway: faArchway,
  faHeartCircleCheck: faHeartCircleCheck,
  faHouseChimneyCrack: faHouseChimneyCrack,
  faHouseDamage: faHouseDamage,
  faFileZipper: faFileZipper,
  faFileArchive: faFileArchive,
  faHeartHalf: faHeartHalf,
  faCommentCheck: faCommentCheck,
  faSquare: faSquare,
  faMemo: faMemo,
  faMartiniGlassEmpty: faMartiniGlassEmpty,
  faGlassMartini: faGlassMartini,
  faCouch: faCouch,
  faCediSign: faCediSign,
  faItalic: faItalic,
  faGlassCitrus: faGlassCitrus,
  faCalendarLinesPen: faCalendarLinesPen,
  faChurch: faChurch,
  faPersonSnowmobiling: faPersonSnowmobiling,
  faSnowmobile: faSnowmobile,
  faFaceHushed: faFaceHushed,
  faCommentsDollar: faCommentsDollar,
  faPickaxe: faPickaxe,
  faLinkSimpleSlash: faLinkSimpleSlash,
  faDemocrat: faDemocrat,
  faFaceConfused: faFaceConfused,
  faPinball: faPinball,
  faZ: faZ,
  faPersonSkiing: faPersonSkiing,
  faSkiing: faSkiing,
  faDeer: faDeer,
  faInputPipe: faInputPipe,
  faRoadLock: faRoadLock,
  faA: faA,
  faBookmarkSlash: faBookmarkSlash,
  faTemperatureArrowDown: faTemperatureArrowDown,
  faTemperatureDown: faTemperatureDown,
  faMace: faMace,
  faFeatherPointed: faFeatherPointed,
  faFeatherAlt: faFeatherAlt,
  faSausage: faSausage,
  faTrashCanClock: faTrashCanClock,
  faP: faP,
  faBroomWide: faBroomWide,
  faSnowflake: faSnowflake,
  faStomach: faStomach,
  faNewspaper: faNewspaper,
  faRectangleAd: faRectangleAd,
  faAd: faAd,
  faGuitarElectric: faGuitarElectric,
  faArrowTurnDownRight: faArrowTurnDownRight,
  faMoonCloud: faMoonCloud,
  faBreadSliceButter: faBreadSliceButter,
  faCircleArrowRight: faCircleArrowRight,
  faArrowCircleRight: faArrowCircleRight,
  faUserGroupCrown: faUserGroupCrown,
  faUsersCrown: faUsersCrown,
  faCircleI: faCircleI,
  faToiletPaperCheck: faToiletPaperCheck,
  faFilterCircleXmark: faFilterCircleXmark,
  faLocust: faLocust,
  faSort: faSort,
  faUnsorted: faUnsorted,
  faListOl: faListOl,
  faList12: faList12,
  faListNumeric: faListNumeric,
  faChartWaterfall: faChartWaterfall,
  faSparkle: faSparkle,
  faFaceParty: faFaceParty,
  faKidneys: faKidneys,
  faWifiExclamation: faWifiExclamation,
  faChartNetwork: faChartNetwork,
  faPersonDressBurst: faPersonDressBurst,
  faDiceD4: faDiceD4,
  faMoneyCheckDollar: faMoneyCheckDollar,
  faMoneyCheckAlt: faMoneyCheckAlt,
  faVectorSquare: faVectorSquare,
  faBreadSlice: faBreadSlice,
  faLanguage: faLanguage,
  faWheatAwnSlash: faWheatAwnSlash,
  faFaceKissWinkHeart: faFaceKissWinkHeart,
  faKissWinkHeart: faKissWinkHeart,
  faDagger: faDagger,
  faPodium: faPodium,
  faMemoCircleCheck: faMemoCircleCheck,
  faRouteHighway: faRouteHighway,
  faDownToLine: faDownToLine,
  faArrowAltToBottom: faArrowAltToBottom,
  faFilter: faFilter,
  faSquareG: faSquareG,
  faCirclePhone: faCirclePhone,
  faPhoneCircle: faPhoneCircle,
  faClipboardPrescription: faClipboardPrescription,
  faUserNurseHair: faUserNurseHair,
  faQuestion: faQuestion,
  faFileSignature: faFileSignature,
  faToggleLargeOn: faToggleLargeOn,
  faUpDownLeftRight: faUpDownLeftRight,
  faArrowsAlt: faArrowsAlt,
  faDryerHeat: faDryerHeat,
  faDryerAlt: faDryerAlt,
  faHouseChimneyUser: faHouseChimneyUser,
  faHandHoldingHeart: faHandHoldingHeart,
  faArrowUpSmallBig: faArrowUpSmallBig,
  faSortSizeUpAlt: faSortSizeUpAlt,
  faTrainTrack: faTrainTrack,
  faPuzzlePiece: faPuzzlePiece,
  faMoneyCheck: faMoneyCheck,
  faStarHalfStroke: faStarHalfStroke,
  faStarHalfAlt: faStarHalfAlt,
  faFileExclamation: faFileExclamation,
  faCode: faCode,
  faWhiskeyGlass: faWhiskeyGlass,
  faGlassWhiskey: faGlassWhiskey,
  faMoonStars: faMoonStars,
  faBuildingCircleExclamation: faBuildingCircleExclamation,
  faClothesHanger: faClothesHanger,
  faMobileNotch: faMobileNotch,
  faMobileIphone: faMobileIphone,
  faMagnifyingGlassChart: faMagnifyingGlassChart,
  faArrowUpRightFromSquare: faArrowUpRightFromSquare,
  faExternalLink: faExternalLink,
  faCubesStacked: faCubesStacked,
  faImagesUser: faImagesUser,
  faWonSign: faWonSign,
  faKrw: faKrw,
  faWon: faWon,
  faImagePolaroidUser: faImagePolaroidUser,
  faVirusCovid: faVirusCovid,
  faSquareEllipsis: faSquareEllipsis,
  faPie: faPie,
  faChessKnightPiece: faChessKnightPiece,
  faChessKnightAlt: faChessKnightAlt,
  faAustralSign: faAustralSign,
  faCloudPlus: faCloudPlus,
  faF: faF,
  faLeaf: faLeaf,
  faBedBunk: faBedBunk,
  faRoad: faRoad,
  faTaxi: faTaxi,
  faCab: faCab,
  faPersonCirclePlus: faPersonCirclePlus,
  faChartPie: faChartPie,
  faPieChart: faPieChart,
  faBoltLightning: faBoltLightning,
  faClockEight: faClockEight,
  faSackXmark: faSackXmark,
  faFileExcel: faFileExcel,
  faFileContract: faFileContract,
  faFishFins: faFishFins,
  faCircleQ: faCircleQ,
  faBuildingFlag: faBuildingFlag,
  faFaceGrinBeam: faFaceGrinBeam,
  faGrinBeam: faGrinBeam,
  faObjectUngroup: faObjectUngroup,
  faFaceDisguise: faFaceDisguise,
  faCircleArrowDownRight: faCircleArrowDownRight,
  faAlien8bit: faAlien8bit,
  faAlienMonster: faAlienMonster,
  faHandPointRibbon: faHandPointRibbon,
  faPoop: faPoop,
  faObjectExclude: faObjectExclude,
  faTelescope: faTelescope,
  faLocationPin: faLocationPin,
  faMapMarker: faMapMarker,
  faSquareList: faSquareList,
  faKaaba: faKaaba,
  faToiletPaper: faToiletPaper,
  faHelmetSafety: faHelmetSafety,
  faHardHat: faHardHat,
  faHatHard: faHatHard,
  faCommentCode: faCommentCode,
  faSimCards: faSimCards,
  faStarship: faStarship,
  faEject: faEject,
  faCircleRight: faCircleRight,
  faArrowAltCircleRight: faArrowAltCircleRight,
  faPlaneCircleCheck: faPlaneCircleCheck,
  faSeal: faSeal,
  faUserCowboy: faUserCowboy,
  faHexagonVerticalNft: faHexagonVerticalNft,
  faFaceRollingEyes: faFaceRollingEyes,
  faMehRollingEyes: faMehRollingEyes,
  faBreadLoaf: faBreadLoaf,
  faRingsWedding: faRingsWedding,
  faObjectGroup: faObjectGroup,
  faFrenchFries: faFrenchFries,
  faChartLine: faChartLine,
  faLineChart: faLineChart,
  faCalendarArrowDown: faCalendarArrowDown,
  faCalendarDownload: faCalendarDownload,
  faSendBack: faSendBack,
  faMaskVentilator: faMaskVentilator,
  faSignatureLock: faSignatureLock,
  faArrowRight: faArrowRight,
  faSignsPost: faSignsPost,
  faMapSigns: faMapSigns,
  faOctagonPlus: faOctagonPlus,
  faPlusOctagon: faPlusOctagon,
  faCashRegister: faCashRegister,
  faPersonCircleQuestion: faPersonCircleQuestion,
  faMelonSlice: faMelonSlice,
  faSpaceStationMoon: faSpaceStationMoon,
  faMessageSmile: faMessageSmile,
  faCommentAltSmile: faCommentAltSmile,
  faCupStraw: faCupStraw,
  faLeftFromLine: faLeftFromLine,
  faArrowAltFromRight: faArrowAltFromRight,
  faH: faH,
  faBasketShoppingSimple: faBasketShoppingSimple,
  faShoppingBasketAlt: faShoppingBasketAlt,
  faHandsHoldingHeart: faHandsHoldingHeart,
  faHandsHeart: faHandsHeart,
  faClockNine: faClockNine,
  faTarp: faTarp,
  faFaceSleepy: faFaceSleepy,
  faHandHorns: faHandHorns,
  faScrewdriverWrench: faScrewdriverWrench,
  faTools: faTools,
  faArrowsToEye: faArrowsToEye,
  faCircleThreeQuarters: faCircleThreeQuarters,
  faTrophyStar: faTrophyStar,
  faTrophyAlt: faTrophyAlt,
  faPlugCircleBolt: faPlugCircleBolt,
  faFaceThermometer: faFaceThermometer,
  faGridRound4: faGridRound4,
  faShirtRunning: faShirtRunning,
  faBookCircleArrowUp: faBookCircleArrowUp,
  faFaceNauseated: faFaceNauseated,
  faHeart: faHeart,
  faFileChartPie: faFileChartPie,
  faMarsAndVenus: faMarsAndVenus,
  faHouseUser: faHouseUser,
  faHomeUser: faHomeUser,
  faCircleArrowDownLeft: faCircleArrowDownLeft,
  faDumpsterFire: faDumpsterFire,
  faHexagonMinus: faHexagonMinus,
  faMinusHexagon: faMinusHexagon,
  faLeftToLine: faLeftToLine,
  faArrowAltToLeft: faArrowAltToLeft,
  faHouseCrack: faHouseCrack,
  faPawSimple: faPawSimple,
  faPawAlt: faPawAlt,
  faArrowLeftLongToLine: faArrowLeftLongToLine,
  faBracketsRound: faBracketsRound,
  faParentheses: faParentheses,
  faMartiniGlassCitrus: faMartiniGlassCitrus,
  faCocktail: faCocktail,
  faUserShakespeare: faUserShakespeare,
  faArrowRightToArc: faArrowRightToArc,
  faFaceSurprise: faFaceSurprise,
  faSurprise: faSurprise,
  faBottleWater: faBottleWater,
  faCirclePause: faCirclePause,
  faPauseCircle: faPauseCircle,
  faGaugeCirclePlus: faGaugeCirclePlus,
  faFolders: faFolders,
  faAngel: faAngel,
  faValueAbsolute: faValueAbsolute,
  faRabbit: faRabbit,
  faToiletPaperSlash: faToiletPaperSlash,
  faCircleEuro: faCircleEuro,
  faAppleWhole: faAppleWhole,
  faAppleAlt: faAppleAlt,
  faKitchenSet: faKitchenSet,
  faDiamondHalf: faDiamondHalf,
  faLockKeyhole: faLockKeyhole,
  faLockAlt: faLockAlt,
  faR: faR,
  faTemperatureQuarter: faTemperatureQuarter,
  faTemperature1: faTemperature1,
  faThermometer1: faThermometer1,
  faThermometerQuarter: faThermometerQuarter,
  faSquareInfo: faSquareInfo,
  faInfoSquare: faInfoSquare,
  faWifiSlash: faWifiSlash,
  faToiletPaperXmark: faToiletPaperXmark,
  faHandsHoldingDollar: faHandsHoldingDollar,
  faHandsUsd: faHandsUsd,
  faCube: faCube,
  faArrowDownTriangleSquare: faArrowDownTriangleSquare,
  faSortShapesDown: faSortShapesDown,
  faBitcoinSign: faBitcoinSign,
  faShutters: faShutters,
  faShieldDog: faShieldDog,
  faSolarPanel: faSolarPanel,
  faLockOpen: faLockOpen,
  faTableTree: faTableTree,
  faHouseChimneyHeart: faHouseChimneyHeart,
  faTally3: faTally3,
  faElevator: faElevator,
  faMoneyBillTransfer: faMoneyBillTransfer,
  faMoneyBillTrendUp: faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight: faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal: faSquarePollHorizontal,
  faPollH: faPollH,
  faCircle: faCircle,
  faCartCircleExclamation: faCartCircleExclamation,
  faSword: faSword,
  faBackwardFast: faBackwardFast,
  faFastBackward: faFastBackward,
  faRecycle: faRecycle,
  faUserAstronaut: faUserAstronaut,
  faInterrobang: faInterrobang,
  faPlaneSlash: faPlaneSlash,
  faCircleDashed: faCircleDashed,
  faTrademark: faTrademark,
  faBasketball: faBasketball,
  faBasketballBall: faBasketballBall,
  faForkKnife: faForkKnife,
  faUtensilsAlt: faUtensilsAlt,
  faSatelliteDish: faSatelliteDish,
  faBadgeCheck: faBadgeCheck,
  faCircleUp: faCircleUp,
  faArrowAltCircleUp: faArrowAltCircleUp,
  faSlider: faSlider,
  faMobileScreenButton: faMobileScreenButton,
  faMobileAlt: faMobileAlt,
  faClockOneThirty: faClockOneThirty,
  faInboxOut: faInboxOut,
  faInboxArrowUp: faInboxArrowUp,
  faCloudSlash: faCloudSlash,
  faVolumeHigh: faVolumeHigh,
  faVolumeUp: faVolumeUp,
  faUsersRays: faUsersRays,
  faWallet: faWallet,
  faOctagonCheck: faOctagonCheck,
  faFlatbreadStuffed: faFlatbreadStuffed,
  faClipboardCheck: faClipboardCheck,
  faCartCirclePlus: faCartCirclePlus,
  faTruckClock: faTruckClock,
  faShippingTimed: faShippingTimed,
  faPool8Ball: faPool8Ball,
  faFileAudio: faFileAudio,
  faTurnDownLeft: faTurnDownLeft,
  faLockHashtag: faLockHashtag,
  faChartRadar: faChartRadar,
  faStaff: faStaff,
  faBurger: faBurger,
  faHamburger: faHamburger,
  faUtilityPole: faUtilityPole,
  faTransporter6: faTransporter6,
  faWrench: faWrench,
  faBugs: faBugs,
  faVectorPolygon: faVectorPolygon,
  faDiagramNested: faDiagramNested,
  faRupeeSign: faRupeeSign,
  faRupee: faRupee,
  faFileImage: faFileImage,
  faCircleQuestion: faCircleQuestion,
  faQuestionCircle: faQuestionCircle,
  faImageUser: faImageUser,
  faBuoy: faBuoy,
  faPlaneDeparture: faPlaneDeparture,
  faHandshakeSlash: faHandshakeSlash,
  faBookBookmark: faBookBookmark,
  faBorderCenterH: faBorderCenterH,
  faCanFood: faCanFood,
  faTypewriter: faTypewriter,
  faArrowRightFromArc: faArrowRightFromArc,
  faCircleK: faCircleK,
  faFaceHandOverMouth: faFaceHandOverMouth,
  faPopcorn: faPopcorn,
  faHouseWater: faHouseWater,
  faHouseFlood: faHouseFlood,
  faObjectSubtract: faObjectSubtract,
  faCodeBranch: faCodeBranch,
  faWarehouseFull: faWarehouseFull,
  faWarehouseAlt: faWarehouseAlt,
  faHatCowboy: faHatCowboy,
  faBridge: faBridge,
  faPhoneFlip: faPhoneFlip,
  faPhoneAlt: faPhoneAlt,
  faArrowDownFromDottedLine: faArrowDownFromDottedLine,
  faFileDoc: faFileDoc,
  faSquareQuarters: faSquareQuarters,
  faTruckFront: faTruckFront,
  faCat: faCat,
  faTrashXmark: faTrashXmark,
  faCircleCaretLeft: faCircleCaretLeft,
  faCaretCircleLeft: faCaretCircleLeft,
  faFiles: faFiles,
  faAnchorCircleExclamation: faAnchorCircleExclamation,
  faFaceClouds: faFaceClouds,
  faUserCrown: faUserCrown,
  faTruckField: faTruckField,
  faRoute: faRoute,
  faCartCircleCheck: faCartCircleCheck,
  faClipboardQuestion: faClipboardQuestion,
  faPanorama: faPanorama,
  faCommentMedical: faCommentMedical,
  faTeethOpen: faTeethOpen,
  faUserTieHairLong: faUserTieHairLong,
  faFileCircleMinus: faFileCircleMinus,
  faHeadSideMedical: faHeadSideMedical,
  faTags: faTags,
  faWineGlass: faWineGlass,
  faForwardFast: faForwardFast,
  faFastForward: faFastForward,
  faFaceMehBlank: faFaceMehBlank,
  faMehBlank: faMehBlank,
  faUserRobot: faUserRobot,
  faSquareParking: faSquareParking,
  faParking: faParking,
  faCardDiamond: faCardDiamond,
  faFaceZipper: faFaceZipper,
  faFaceRaisedEyebrow: faFaceRaisedEyebrow,
  faHouseSignal: faHouseSignal,
  faSquareChevronUp: faSquareChevronUp,
  faChevronSquareUp: faChevronSquareUp,
  faNfcSymbol: faNfcSymbol,
  faBarsProgress: faBarsProgress,
  faTasksAlt: faTasksAlt,
  faFaucetDrip: faFaucetDrip,
  faArrowsToLine: faArrowsToLine,
  faDolphin: faDolphin,
  faArrowUpRight: faArrowUpRight,
  faCircleR: faCircleR,
  faCartFlatbed: faCartFlatbed,
  faDollyFlatbed: faDollyFlatbed,
  faBanSmoking: faBanSmoking,
  faSmokingBan: faSmokingBan,
  faCircleSortUp: faCircleSortUp,
  faSortCircleUp: faSortCircleUp,
  faTerminal: faTerminal,
  faMobileButton: faMobileButton,
  faHouseMedicalFlag: faHouseMedicalFlag,
  faBasketShopping: faBasketShopping,
  faShoppingBasket: faShoppingBasket,
  faTape: faTape,
  faChestnut: faChestnut,
  faBusSimple: faBusSimple,
  faBusAlt: faBusAlt,
  faEye: faEye,
  faFaceSadCry: faFaceSadCry,
  faSadCry: faSadCry,
  faHeat: faHeat,
  faTicketAirline: faTicketAirline,
  faBootHeeled: faBootHeeled,
  faArrowsMinimize: faArrowsMinimize,
  faCompressArrows: faCompressArrows,
  faAudioDescription: faAudioDescription,
  faPersonMilitaryToPerson: faPersonMilitaryToPerson,
  faFileShield: faFileShield,
  faHexagon: faHexagon,
  faManhole: faManhole,
  faUserSlash: faUserSlash,
  faPen: faPen,
  faTowerObservation: faTowerObservation,
  faFloppyDisks: faFloppyDisks,
  faToiletPaperBlankUnder: faToiletPaperBlankUnder,
  faToiletPaperReverseAlt: faToiletPaperReverseAlt,
  faFileCode: faFileCode,
  faSignal: faSignal,
  faSignal5: faSignal5,
  faSignalPerfect: faSignalPerfect,
  faPump: faPump,
  faBus: faBus,
  faHeartCircleXmark: faHeartCircleXmark,
  faArrowUpLeftFromCircle: faArrowUpLeftFromCircle,
  faHouseChimney: faHouseChimney,
  faHomeLg: faHomeLg,
  faWindowMaximize: faWindowMaximize,
  faDryer: faDryer,
  faFaceFrown: faFaceFrown,
  faFrown: faFrown,
  faChessBishopPiece: faChessBishopPiece,
  faChessBishopAlt: faChessBishopAlt,
  faShirtTankTop: faShirtTankTop,
  faDiploma: faDiploma,
  faScrollRibbon: faScrollRibbon,
  faScreencast: faScreencast,
  faWalker: faWalker,
  faPrescription: faPrescription,
  faShop: faShop,
  faStoreAlt: faStoreAlt,
  faFloppyDisk: faFloppyDisk,
  faSave: faSave,
  faVihara: faVihara,
  faFaceKissClosedEyes: faFaceKissClosedEyes,
  faScaleUnbalanced: faScaleUnbalanced,
  faBalanceScaleLeft: faBalanceScaleLeft,
  faFileUser: faFileUser,
  faUserPoliceTie: faUserPoliceTie,
  faFaceTongueMoney: faFaceTongueMoney,
  faTennisBall: faTennisBall,
  faSquareL: faSquareL,
  faSortUp: faSortUp,
  faSortAsc: faSortAsc,
  faCalendarArrowUp: faCalendarArrowUp,
  faCalendarUpload: faCalendarUpload,
  faCommentDots: faCommentDots,
  faCommenting: faCommenting,
  faPlantWilt: faPlantWilt,
  faScarf: faScarf,
  faAlbumCirclePlus: faAlbumCirclePlus,
  faUserNurseHairLong: faUserNurseHairLong,
  faDiamond: faDiamond,
  faSquareLeft: faSquareLeft,
  faArrowAltSquareLeft: faArrowAltSquareLeft,
  faFaceGrinSquint: faFaceGrinSquint,
  faGrinSquint: faGrinSquint,
  faCircleEllipsisVertical: faCircleEllipsisVertical,
  faHandHoldingDollar: faHandHoldingDollar,
  faHandHoldingUsd: faHandHoldingUsd,
  faGridDividers: faGridDividers,
  faBacterium: faBacterium,
  faHandPointer: faHandPointer,
  faDrumSteelpan: faDrumSteelpan,
  faHandScissors: faHandScissors,
  faHandsPraying: faHandsPraying,
  faPrayingHands: faPrayingHands,
  faFacePensive: faFacePensive,
  faUserMusic: faUserMusic,
  faArrowRotateRight: faArrowRotateRight,
  faArrowRightRotate: faArrowRightRotate,
  faArrowRotateForward: faArrowRotateForward,
  faRedo: faRedo,
  faMessagesDollar: faMessagesDollar,
  faCommentsAltDollar: faCommentsAltDollar,
  faSensorOn: faSensorOn,
  faBalloon: faBalloon,
  faBiohazard: faBiohazard,
  faChessQueenPiece: faChessQueenPiece,
  faChessQueenAlt: faChessQueenAlt,
  faLocationCrosshairs: faLocationCrosshairs,
  faLocation: faLocation,
  faMarsDouble: faMarsDouble,
  faHousePersonLeave: faHousePersonLeave,
  faHouseLeave: faHouseLeave,
  faHousePersonDepart: faHousePersonDepart,
  faRulerTriangle: faRulerTriangle,
  faCardClub: faCardClub,
  faChildDress: faChildDress,
  faUsersBetweenLines: faUsersBetweenLines,
  faLungsVirus: faLungsVirus,
  faSpinnerThird: faSpinnerThird,
  faFaceGrinTears: faFaceGrinTears,
  faGrinTears: faGrinTears,
  faPhone: faPhone,
  faComputerMouseScrollwheel: faComputerMouseScrollwheel,
  faMouseAlt: faMouseAlt,
  faCalendarXmark: faCalendarXmark,
  faCalendarTimes: faCalendarTimes,
  faChildReaching: faChildReaching,
  faTableLayout: faTableLayout,
  faNarwhal: faNarwhal,
  faRampLoading: faRampLoading,
  faCalendarCirclePlus: faCalendarCirclePlus,
  faToothbrush: faToothbrush,
  faBorderInner: faBorderInner,
  faPawClaws: faPawClaws,
  faKiwiFruit: faKiwiFruit,
  faTrafficLightSlow: faTrafficLightSlow,
  faRectangleCode: faRectangleCode,
  faHeadSideVirus: faHeadSideVirus,
  faKeyboardBrightness: faKeyboardBrightness,
  faBooksMedical: faBooksMedical,
  faLightbulbSlash: faLightbulbSlash,
  faHouseBlank: faHouseBlank,
  faHomeBlank: faHomeBlank,
  faSquare5: faSquare5,
  faSquareHeart: faSquareHeart,
  faHeartSquare: faHeartSquare,
  faPuzzle: faPuzzle,
  faUserGear: faUserGear,
  faUserCog: faUserCog,
  faPipeCircleCheck: faPipeCircleCheck,
  faArrowUp19: faArrowUp19,
  faSortNumericUp: faSortNumericUp,
  faOctagonExclamation: faOctagonExclamation,
  faDialLow: faDialLow,
  faDoorClosed: faDoorClosed,
  faLaptopMobile: faLaptopMobile,
  faPhoneLaptop: faPhoneLaptop,
  faConveyorBeltBoxes: faConveyorBeltBoxes,
  faConveyorBeltAlt: faConveyorBeltAlt,
  faShieldVirus: faShieldVirus,
  faStarfighterTwinIonEngineAdvanced: faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced: faStarfighterAltAdvanced,
  faDiceSix: faDiceSix,
  faStarfighterTwinIonEngine: faStarfighterTwinIonEngine,
  faStarfighterAlt: faStarfighterAlt,
  faRocketLaunch: faRocketLaunch,
  faMosquitoNet: faMosquitoNet,
  faVentDamper: faVentDamper,
  faBridgeWater: faBridgeWater,
  faBanBug: faBanBug,
  faDebug: faDebug,
  faPersonBooth: faPersonBooth,
  faTextWidth: faTextWidth,
  faGarageCar: faGarageCar,
  faSquareKanban: faSquareKanban,
  faHatWizard: faHatWizard,
  faPenFancy: faPenFancy,
  faCoffeePot: faCoffeePot,
  faMouseField: faMouseField,
  faPersonDigging: faPersonDigging,
  faDigging: faDigging,
  faShowerDown: faShowerDown,
  faShowerAlt: faShowerAlt,
  faBoxCircleCheck: faBoxCircleCheck,
  faBrightness: faBrightness,
  faCarSideBolt: faCarSideBolt,
  faOrnament: faOrnament,
  faPhoneArrowDownLeft: faPhoneArrowDownLeft,
  faPhoneArrowDown: faPhoneArrowDown,
  faPhoneIncoming: faPhoneIncoming,
  faCloudWord: faCloudWord,
  faHandFingersCrossed: faHandFingersCrossed,
  faTrash: faTrash,
  faGaugeSimple: faGaugeSimple,
  faGaugeSimpleMed: faGaugeSimpleMed,
  faTachometerAverage: faTachometerAverage,
  faArrowDownSmallBig: faArrowDownSmallBig,
  faSortSizeDownAlt: faSortSizeDownAlt,
  faBookMedical: faBookMedical,
  faFaceMelting: faFaceMelting,
  faPoo: faPoo,
  faPenClipSlash: faPenClipSlash,
  faPenAltSlash: faPenAltSlash,
  faQuoteRight: faQuoteRight,
  faQuoteRightAlt: faQuoteRightAlt,
  faScrollOld: faScrollOld,
  faGuitars: faGuitars,
  faPhoneXmark: faPhoneXmark,
  faHose: faHose,
  faClockSix: faClockSix,
  faShirt: faShirt,
  faTShirt: faTShirt,
  faTshirt: faTshirt,
  faBillboard: faBillboard,
  faSquareR: faSquareR,
  faCubes: faCubes,
  faEnvelopeOpenDollar: faEnvelopeOpenDollar,
  faDivide: faDivide,
  faSunCloud: faSunCloud,
  faLampFloor: faLampFloor,
  faSquare7: faSquare7,
  faTengeSign: faTengeSign,
  faTenge: faTenge,
  faHeadphones: faHeadphones,
  faHandsHolding: faHandsHolding,
  faCampfire: faCampfire,
  faCircleAmpersand: faCircleAmpersand,
  faSnowflakes: faSnowflakes,
  faHandsClapping: faHandsClapping,
  faRepublican: faRepublican,
  faLeafMaple: faLeafMaple,
  faArrowLeft: faArrowLeft,
  faPersonCircleXmark: faPersonCircleXmark,
  faRuler: faRuler,
  faCupStrawSwoosh: faCupStrawSwoosh,
  faTemperatureSun: faTemperatureSun,
  faTemperatureHot: faTemperatureHot,
  faAlignLeft: faAlignLeft,
  faDiceD6: faDiceD6,
  faRestroom: faRestroom,
  faHighDefinition: faHighDefinition,
  faRectangleHd: faRectangleHd,
  faJ: faJ,
  faGalaxy: faGalaxy,
  faUsersViewfinder: faUsersViewfinder,
  faFileVideo: faFileVideo,
  faCherries: faCherries,
  faUpRightFromSquare: faUpRightFromSquare,
  faExternalLinkAlt: faExternalLinkAlt,
  faCircleSort: faCircleSort,
  faSortCircle: faSortCircle,
  faTableCells: faTableCells,
  faTh: faTh,
  faFilePdf: faFilePdf,
  faSiren: faSiren,
  faArrowUpToDottedLine: faArrowUpToDottedLine,
  faImageLandscape: faImageLandscape,
  faLandscape: faLandscape,
  faTankWater: faTankWater,
  faCurlingStone: faCurlingStone,
  faCurling: faCurling,
  faGamepadModern: faGamepadModern,
  faGamepadAlt: faGamepadAlt,
  faMessagesQuestion: faMessagesQuestion,
  faBookBible: faBookBible,
  faBible: faBible,
  faO: faO,
  faSuitcaseMedical: faSuitcaseMedical,
  faMedkit: faMedkit,
  faBriefcaseArrowRight: faBriefcaseArrowRight,
  faExpandWide: faExpandWide,
  faClockElevenThirty: faClockElevenThirty,
  faRv: faRv,
  faUserSecret: faUserSecret,
  faOtter: faOtter,
  faDreidel: faDreidel,
  faPersonDress: faPersonDress,
  faFemale: faFemale,
  faCommentDollar: faCommentDollar,
  faBusinessTime: faBusinessTime,
  faBriefcaseClock: faBriefcaseClock,
  faFlowerTulip: faFlowerTulip,
  faPeoplePantsSimple: faPeoplePantsSimple,
  faCloudDrizzle: faCloudDrizzle,
  faTableCellsLarge: faTableCellsLarge,
  faThLarge: faThLarge,
  faBookTanakh: faBookTanakh,
  faTanakh: faTanakh,
  faSolarSystem: faSolarSystem,
  faSealQuestion: faSealQuestion,
  faPhoneVolume: faPhoneVolume,
  faVolumeControlPhone: faVolumeControlPhone,
  faDiscDrive: faDiscDrive,
  faHatCowboySide: faHatCowboySide,
  faTableRows: faTableRows,
  faRows: faRows,
  faLocationExclamation: faLocationExclamation,
  faMapMarkerExclamation: faMapMarkerExclamation,
  faFaceFearful: faFaceFearful,
  faClipboardUser: faClipboardUser,
  faBusSchool: faBusSchool,
  faFilmSlash: faFilmSlash,
  faSquareArrowDownRight: faSquareArrowDownRight,
  faBookSparkles: faBookSparkles,
  faBookSpells: faBookSpells,
  faWashingMachine: faWashingMachine,
  faWasher: faWasher,
  faChild: faChild,
  faLiraSign: faLiraSign,
  faUserVisor: faUserVisor,
  faFilePlusMinus: faFilePlusMinus,
  faChessClockFlip: faChessClockFlip,
  faChessClockAlt: faChessClockAlt,
  faSatellite: faSatellite,
  faPlaneLock: faPlaneLock,
  faSteeringWheel: faSteeringWheel,
  faTag: faTag,
  faStretcher: faStretcher,
  faBookSection: faBookSection,
  faBookLaw: faBookLaw,
  faInboxes: faInboxes,
  faCoffeeBean: faCoffeeBean,
  faCircleYen: faCircleYen,
  faBracketsCurly: faBracketsCurly,
  faEllipsisStrokeVertical: faEllipsisStrokeVertical,
  faEllipsisVAlt: faEllipsisVAlt,
  faComment: faComment,
  faSquare1: faSquare1,
  faCakeCandles: faCakeCandles,
  faBirthdayCake: faBirthdayCake,
  faCake: faCake,
  faHeadSide: faHeadSide,
  faEnvelope: faEnvelope,
  faDollyEmpty: faDollyEmpty,
  faFaceTissue: faFaceTissue,
  faAnglesUp: faAnglesUp,
  faAngleDoubleUp: faAngleDoubleUp,
  faBinRecycle: faBinRecycle,
  faPaperclip: faPaperclip,
  faChartLineDown: faChartLineDown,
  faArrowRightToCity: faArrowRightToCity,
  faLockA: faLockA,
  faRibbon: faRibbon,
  faLungs: faLungs,
  faPersonPinball: faPersonPinball,
  faArrowUp91: faArrowUp91,
  faSortNumericUpAlt: faSortNumericUpAlt,
  faAppleCore: faAppleCore,
  faCircleY: faCircleY,
  faH6: faH6,
  faLitecoinSign: faLitecoinSign,
  faCircleSmall: faCircleSmall,
  faBorderNone: faBorderNone,
  faArrowTurnDownLeft: faArrowTurnDownLeft,
  faCircleNodes: faCircleNodes,
  faParachuteBox: faParachuteBox,
  faMessageMedical: faMessageMedical,
  faCommentAltMedical: faCommentAltMedical,
  faRugbyBall: faRugbyBall,
  faCommentMusic: faCommentMusic,
  faIndent: faIndent,
  faTreeDeciduous: faTreeDeciduous,
  faTreeAlt: faTreeAlt,
  faPuzzlePieceSimple: faPuzzlePieceSimple,
  faPuzzlePieceAlt: faPuzzlePieceAlt,
  faTruckFieldUn: faTruckFieldUn,
  faNfcTrash: faNfcTrash,
  faHourglass: faHourglass,
  faHourglassEmpty: faHourglassEmpty,
  faMountain: faMountain,
  faFileXmark: faFileXmark,
  faFileTimes: faFileTimes,
  faHouseHeart: faHouseHeart,
  faHomeHeart: faHomeHeart,
  faHouseChimneyBlank: faHouseChimneyBlank,
  faMeterBolt: faMeterBolt,
  faUserDoctor: faUserDoctor,
  faUserMd: faUserMd,
  faSlashBack: faSlashBack,
  faCircleInfo: faCircleInfo,
  faInfoCircle: faInfoCircle,
  faFishingRod: faFishingRod,
  faHammerCrash: faHammerCrash,
  faMessageHeart: faMessageHeart,
  faCloudMeatball: faCloudMeatball,
  faCameraPolaroid: faCameraPolaroid,
  faCamera: faCamera,
  faCameraAlt: faCameraAlt,
  faSquareVirus: faSquareVirus,
  faCartArrowUp: faCartArrowUp,
  faMeteor: faMeteor,
  faCarOn: faCarOn,
  faSleigh: faSleigh,
  faArrowDown19: faArrowDown19,
  faSortNumericAsc: faSortNumericAsc,
  faSortNumericDown: faSortNumericDown,
  faBuoyMooring: faBuoyMooring,
  faSquare4: faSquare4,
  faHandHoldingDroplet: faHandHoldingDroplet,
  faHandHoldingWater: faHandHoldingWater,
  faTricycleAdult: faTricycleAdult,
  faWaveform: faWaveform,
  faWater: faWater,
  faStarSharpHalfStroke: faStarSharpHalfStroke,
  faStarSharpHalfAlt: faStarSharpHalfAlt,
  faNfcSignal: faNfcSignal,
  faPlaneProp: faPlaneProp,
  faCalendarCheck: faCalendarCheck,
  faClockDesk: faClockDesk,
  faCalendarClock: faCalendarClock,
  faCalendarTime: faCalendarTime,
  faBraille: faBraille,
  faPrescriptionBottleMedical: faPrescriptionBottleMedical,
  faPrescriptionBottleAlt: faPrescriptionBottleAlt,
  faPlateUtensils: faPlateUtensils,
  faFamilyPants: faFamilyPants,
  faHoseReel: faHoseReel,
  faHouseWindow: faHouseWindow,
  faLandmark: faLandmark,
  faTruck: faTruck,
  faCrosshairs: faCrosshairs,
  faCloudRainbow: faCloudRainbow,
  faPersonCane: faPersonCane,
  faAlien: faAlien,
  faTent: faTent,
  faLaptopBinary: faLaptopBinary,
  faVestPatches: faVestPatches,
  faPeopleDressSimple: faPeopleDressSimple,
  faCheckDouble: faCheckDouble,
  faArrowDownAZ: faArrowDownAZ,
  faSortAlphaAsc: faSortAlphaAsc,
  faSortAlphaDown: faSortAlphaDown,
  faBowlingBallPin: faBowlingBallPin,
  faBellSchoolSlash: faBellSchoolSlash,
  faPlusLarge: faPlusLarge,
  faMoneyBillWheat: faMoneyBillWheat,
  faCameraViewfinder: faCameraViewfinder,
  faScreenshot: faScreenshot,
  faMessageMusic: faMessageMusic,
  faCommentAltMusic: faCommentAltMusic,
  faCarBuilding: faCarBuilding,
  faBorderBottomRight: faBorderBottomRight,
  faBorderStyleAlt: faBorderStyleAlt,
  faOctagon: faOctagon,
  faCommentArrowUpRight: faCommentArrowUpRight,
  faOctagonDivide: faOctagonDivide,
  faCookie: faCookie,
  faArrowRotateLeft: faArrowRotateLeft,
  faArrowLeftRotate: faArrowLeftRotate,
  faArrowRotateBack: faArrowRotateBack,
  faArrowRotateBackward: faArrowRotateBackward,
  faUndo: faUndo,
  faTvMusic: faTvMusic,
  faHardDrive: faHardDrive,
  faHdd: faHdd,
  faReel: faReel,
  faFaceGrinSquintTears: faFaceGrinSquintTears,
  faGrinSquintTears: faGrinSquintTears,
  faDumbbell: faDumbbell,
  faRectangleList: faRectangleList,
  faListAlt: faListAlt,
  faTarpDroplet: faTarpDroplet,
  faAlarmExclamation: faAlarmExclamation,
  faHouseMedicalCircleCheck: faHouseMedicalCircleCheck,
  faTrafficCone: faTrafficCone,
  faGrate: faGrate,
  faArrowDownRight: faArrowDownRight,
  faPersonSkiingNordic: faPersonSkiingNordic,
  faSkiingNordic: faSkiingNordic,
  faCalendarPlus: faCalendarPlus,
  faPersonFromPortal: faPersonFromPortal,
  faPortalExit: faPortalExit,
  faPlaneArrival: faPlaneArrival,
  faCowbellCirclePlus: faCowbellCirclePlus,
  faCowbellMore: faCowbellMore,
  faCircleLeft: faCircleLeft,
  faArrowAltCircleLeft: faArrowAltCircleLeft,
  faDistributeSpacingVertical: faDistributeSpacingVertical,
  faSignalBarsFair: faSignalBarsFair,
  faSignalAlt2: faSignalAlt2,
  faSportsball: faSportsball,
  faGameConsoleHandheldCrank: faGameConsoleHandheldCrank,
  faTrainSubway: faTrainSubway,
  faSubway: faSubway,
  faChartGantt: faChartGantt,
  faFaceSmileUpsideDown: faFaceSmileUpsideDown,
  faBallPile: faBallPile,
  faBadgeDollar: faBadgeDollar,
  faMoneyBillsSimple: faMoneyBillsSimple,
  faMoneyBillsAlt: faMoneyBillsAlt,
  faListTimeline: faListTimeline,
  faIndianRupeeSign: faIndianRupeeSign,
  faIndianRupee: faIndianRupee,
  faInr: faInr,
  faCropSimple: faCropSimple,
  faCropAlt: faCropAlt,
  faMoneyBill1: faMoneyBill1,
  faMoneyBillAlt: faMoneyBillAlt,
  faLeftLong: faLeftLong,
  faLongArrowAltLeft: faLongArrowAltLeft,
  faKeyboardDown: faKeyboardDown,
  faCircleUpRight: faCircleUpRight,
  faCloudBoltMoon: faCloudBoltMoon,
  faThunderstormMoon: faThunderstormMoon,
  faDna: faDna,
  faVirusSlash: faVirusSlash,
  faBracketRoundRight: faBracketRoundRight,
  faCircleSterling: faCircleSterling,
  faCircle5: faCircle5,
  faMinus: faMinus,
  faSubtract: faSubtract,
  faFireFlame: faFireFlame,
  faFlame: faFlame,
  faRightToLine: faRightToLine,
  faArrowAltToRight: faArrowAltToRight,
  faGif: faGif,
  faChess: faChess,
  faTrashSlash: faTrashSlash,
  faArrowLeftLong: faArrowLeftLong,
  faLongArrowLeft: faLongArrowLeft,
  faPlugCircleCheck: faPlugCircleCheck,
  faFontCase: faFontCase,
  faStreetView: faStreetView,
  faArrowDownLeft: faArrowDownLeft,
  faFrancSign: faFrancSign,
  faFlaskRoundPoison: faFlaskRoundPoison,
  faFlaskPoison: faFlaskPoison,
  faVolumeOff: faVolumeOff,
  faBookCircleArrowRight: faBookCircleArrowRight,
  faChartUser: faChartUser,
  faUserChart: faUserChart,
  faHandsAslInterpreting: faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
  faAslInterpreting: faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting: faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen: faPresentationScreen,
  faPresentation: faPresentation,
  faCircleBolt: faCircleBolt,
  faFaceSmileHalo: faFaceSmileHalo,
  faCartCircleArrowDown: faCartCircleArrowDown,
  faHousePersonReturn: faHousePersonReturn,
  faHousePersonArrive: faHousePersonArrive,
  faHouseReturn: faHouseReturn,
  faMessageXmark: faMessageXmark,
  faCommentAltTimes: faCommentAltTimes,
  faMessageTimes: faMessageTimes,
  faFileCertificate: faFileCertificate,
  faFileAward: faFileAward,
  faUserDoctorHairLong: faUserDoctorHairLong,
  faCameraSecurity: faCameraSecurity,
  faCameraHome: faCameraHome,
  faGear: faGear,
  faCog: faCog,
  faDropletSlash: faDropletSlash,
  faTintSlash: faTintSlash,
  faBookHeart: faBookHeart,
  faMosque: faMosque,
  faDuck: faDuck,
  faMosquito: faMosquito,
  faStarOfDavid: faStarOfDavid,
  faFlagSwallowtail: faFlagSwallowtail,
  faFlagAlt: faFlagAlt,
  faPersonMilitaryRifle: faPersonMilitaryRifle,
  faCarGarage: faCarGarage,
  faCartShopping: faCartShopping,
  faShoppingCart: faShoppingCart,
  faBookFont: faBookFont,
  faShieldPlus: faShieldPlus,
  faVials: faVials,
  faEyeDropperFull: faEyeDropperFull,
  faDistributeSpacingHorizontal: faDistributeSpacingHorizontal,
  faTabletRugged: faTabletRugged,
  faTemperatureSnow: faTemperatureSnow,
  faTemperatureFrigid: faTemperatureFrigid,
  faMoped: faMoped,
  faFaceSmilePlus: faFaceSmilePlus,
  faSmilePlus: faSmilePlus,
  faRadioTuner: faRadioTuner,
  faRadioAlt: faRadioAlt,
  faFaceSwear: faFaceSwear,
  faWaterArrowDown: faWaterArrowDown,
  faWaterLower: faWaterLower,
  faScannerTouchscreen: faScannerTouchscreen,
  faCircle7: faCircle7,
  faPlugCirclePlus: faPlugCirclePlus,
  faPersonSkiJumping: faPersonSkiJumping,
  faSkiJump: faSkiJump,
  faPlaceOfWorship: faPlaceOfWorship,
  faWaterArrowUp: faWaterArrowUp,
  faWaterRise: faWaterRise,
  faWaveformLines: faWaveformLines,
  faWaveformPath: faWaveformPath,
  faSplit: faSplit,
  faFilmCanister: faFilmCanister,
  faFilmCannister: faFilmCannister,
  faFolderXmark: faFolderXmark,
  faFolderTimes: faFolderTimes,
  faToiletPaperBlank: faToiletPaperBlank,
  faToiletPaperAlt: faToiletPaperAlt,
  faTabletScreen: faTabletScreen,
  faTabletAndroidAlt: faTabletAndroidAlt,
  faHexagonVerticalNftSlanted: faHexagonVerticalNftSlanted,
  faFolderMusic: faFolderMusic,
  faDisplayMedical: faDisplayMedical,
  faDesktopMedical: faDesktopMedical,
  faShareAll: faShareAll,
  faPeapod: faPeapod,
  faChessClock: faChessClock,
  faAxe: faAxe,
  faSquareD: faSquareD,
  faGripVertical: faGripVertical,
  faMobileSignalOut: faMobileSignalOut,
  faArrowTurnUp: faArrowTurnUp,
  faLevelUp: faLevelUp,
  faU: faU,
  faArrowUpFromDottedLine: faArrowUpFromDottedLine,
  faSquareRootVariable: faSquareRootVariable,
  faSquareRootAlt: faSquareRootAlt,
  faLightSwitchOn: faLightSwitchOn,
  faArrowDownArrowUp: faArrowDownArrowUp,
  faSortAlt: faSortAlt,
  faRaindrops: faRaindrops,
  faDash: faDash,
  faMinusLarge: faMinusLarge,
  faClock: faClock,
  faClockFour: faClockFour,
  faInputNumeric: faInputNumeric,
  faTruckTow: faTruckTow,
  faBackwardStep: faBackwardStep,
  faStepBackward: faStepBackward,
  faPallet: faPallet,
  faCarBolt: faCarBolt,
  faArrowsMaximize: faArrowsMaximize,
  faExpandArrows: faExpandArrows,
  faFaucet: faFaucet,
  faCloudSleet: faCloudSleet,
  faLampStreet: faLampStreet,
  faListRadio: faListRadio,
  faPenNibSlash: faPenNibSlash,
  faBaseballBatBall: faBaseballBatBall,
  faSquareUpLeft: faSquareUpLeft,
  faOverline: faOverline,
  faS: faS,
  faTimeline: faTimeline,
  faKeyboard: faKeyboard,
  faArrowsFromDottedLine: faArrowsFromDottedLine,
  faUsbDrive: faUsbDrive,
  faBallot: faBallot,
  faCaretDown: faCaretDown,
  faLocationDotSlash: faLocationDotSlash,
  faMapMarkerAltSlash: faMapMarkerAltSlash,
  faCards: faCards,
  faHouseChimneyMedical: faHouseChimneyMedical,
  faClinicMedical: faClinicMedical,
  faBoxingGlove: faBoxingGlove,
  faGloveBoxing: faGloveBoxing,
  faTemperatureThreeQuarters: faTemperatureThreeQuarters,
  faTemperature3: faTemperature3,
  faThermometer3: faThermometer3,
  faThermometerThreeQuarters: faThermometerThreeQuarters,
  faBellSchool: faBellSchool,
  faMobileScreen: faMobileScreen,
  faMobileAndroidAlt: faMobileAndroidAlt,
  faPlaneUp: faPlaneUp,
  faFolderHeart: faFolderHeart,
  faCircleLocationArrow: faCircleLocationArrow,
  faLocationCircle: faLocationCircle,
  faFaceHeadBandage: faFaceHeadBandage,
  faSushiRoll: faSushiRoll,
  faMakiRoll: faMakiRoll,
  faMakizushi: faMakizushi,
  faCarBump: faCarBump,
  faPiggyBank: faPiggyBank,
  faRacquet: faRacquet,
  faCarMirrors: faCarMirrors,
  faIndustryWindows: faIndustryWindows,
  faIndustryAlt: faIndustryAlt,
  faBoltAuto: faBoltAuto,
  faBatteryHalf: faBatteryHalf,
  faBattery3: faBattery3,
  faFluxCapacitor: faFluxCapacitor,
  faMountainCity: faMountainCity,
  faCoins: faCoins,
  faHoneyPot: faHoneyPot,
  faOlive: faOlive,
  faKhanda: faKhanda,
  faFilterList: faFilterList,
  faOutlet: faOutlet,
  faSliders: faSliders,
  faSlidersH: faSlidersH,
  faCauldron: faCauldron,
  faPeople: faPeople,
  faFolderTree: faFolderTree,
  faNetworkWired: faNetworkWired,
  faCroissant: faCroissant,
  faMapPin: faMapPin,
  faHamsa: faHamsa,
  faCentSign: faCentSign,
  faSwordsLaser: faSwordsLaser,
  faFlask: faFlask,
  faPersonPregnant: faPersonPregnant,
  faSquareU: faSquareU,
  faWandSparkles: faWandSparkles,
  faRouter: faRouter,
  faEllipsisVertical: faEllipsisVertical,
  faEllipsisV: faEllipsisV,
  faSwordLaserAlt: faSwordLaserAlt,
  faTicket: faTicket,
  faPowerOff: faPowerOff,
  faCoin: faCoin,
  faLaptopSlash: faLaptopSlash,
  faRightLong: faRightLong,
  faLongArrowAltRight: faLongArrowAltRight,
  faCircleB: faCircleB,
  faPersonDressSimple: faPersonDressSimple,
  faPipeCollar: faPipeCollar,
  faLightsHoliday: faLightsHoliday,
  faCitrus: faCitrus,
  faFlagUsa: faFlagUsa,
  faLaptopFile: faLaptopFile,
  faTty: faTty,
  faTeletype: faTeletype,
  faChartTreeMap: faChartTreeMap,
  faDiagramNext: faDiagramNext,
  faPersonRifle: faPersonRifle,
  faClockFiveThirty: faClockFiveThirty,
  faPipeValve: faPipeValve,
  faArrowUpFromArc: faArrowUpFromArc,
  faFaceSpiralEyes: faFaceSpiralEyes,
  faCompressWide: faCompressWide,
  faCirclePhoneHangup: faCirclePhoneHangup,
  faPhoneCircleDown: faPhoneCircleDown,
  faGearComplexCode: faGearComplexCode,
  faHouseMedicalCircleExclamation: faHouseMedicalCircleExclamation,
  faBadminton: faBadminton,
  faClosedCaptioning: faClosedCaptioning,
  faPersonHiking: faPersonHiking,
  faHiking: faHiking,
  faRightFromLine: faRightFromLine,
  faArrowAltFromLeft: faArrowAltFromLeft,
  faVenusDouble: faVenusDouble,
  faImages: faImages,
  faCalculator: faCalculator,
  faShuttlecock: faShuttlecock,
  faUserHair: faUserHair,
  faEyeEvil: faEyeEvil,
  faPeoplePulling: faPeoplePulling,
  faN: faN,
  faGarage: faGarage,
  faCableCar: faCableCar,
  faTram: faTram,
  faShovelSnow: faShovelSnow,
  faCloudRain: faCloudRain,
  faFaceLying: faFaceLying,
  faSprinkler: faSprinkler,
  faBuildingCircleXmark: faBuildingCircleXmark,
  faPersonSledding: faPersonSledding,
  faSledding: faSledding,
  faGameConsoleHandheld: faGameConsoleHandheld,
  faShip: faShip,
  faClockSixThirty: faClockSixThirty,
  faBatterySlash: faBatterySlash,
  faTugrikSign: faTugrikSign,
  faArrowsDownToLine: faArrowsDownToLine,
  faDownload: faDownload,
  faShelves: faShelves,
  faInventory: faInventory,
  faCloudSnow: faCloudSnow,
  faFaceGrin: faFaceGrin,
  faGrin: faGrin,
  faDeleteLeft: faDeleteLeft,
  faBackspace: faBackspace,
  faOven: faOven,
  faCloudBinary: faCloudBinary,
  faEyeDropper: faEyeDropper,
  faEyeDropperEmpty: faEyeDropperEmpty,
  faEyedropper: faEyedropper,
  faCommentCaptions: faCommentCaptions,
  faCommentsQuestion: faCommentsQuestion,
  faScribble: faScribble,
  faRotateExclamation: faRotateExclamation,
  faFileCircleCheck: faFileCircleCheck,
  faGlass: faGlass,
  faLoader: faLoader,
  faForward: faForward,
  faUserPilot: faUserPilot,
  faMobile: faMobile,
  faMobileAndroid: faMobileAndroid,
  faMobilePhone: faMobilePhone,
  faCodePullRequestClosed: faCodePullRequestClosed,
  faFaceMeh: faFaceMeh,
  faMeh: faMeh,
  faAlignCenter: faAlignCenter,
  faBookSkull: faBookSkull,
  faBookDead: faBookDead,
  faIdCard: faIdCard,
  faDriversLicense: faDriversLicense,
  faFaceDotted: faFaceDotted,
  faFaceWorried: faFaceWorried,
  faOutdent: faOutdent,
  faDedent: faDedent,
  faHeartCircleExclamation: faHeartCircleExclamation,
  faHouse: faHouse,
  faHome: faHome,
  faHomeAlt: faHomeAlt,
  faHomeLgAlt: faHomeLgAlt,
  faVectorCircle: faVectorCircle,
  faCarCircleBolt: faCarCircleBolt,
  faCalendarWeek: faCalendarWeek,
  faFlyingDisc: faFlyingDisc,
  faLaptopMedical: faLaptopMedical,
  faSquareDownRight: faSquareDownRight,
  faB: faB,
  faSeatAirline: faSeatAirline,
  faMoonOverSun: faMoonOverSun,
  faEclipseAlt: faEclipseAlt,
  faPipe: faPipe,
  faFileMedical: faFileMedical,
  faPotato: faPotato,
  faDiceOne: faDiceOne,
  faCircleA: faCircleA,
  faHelmetBattle: faHelmetBattle,
  faButter: faButter,
  faBlanketFire: faBlanketFire,
  faKiwiBird: faKiwiBird,
  faCastle: faCastle,
  faGolfClub: faGolfClub,
  faArrowRightArrowLeft: faArrowRightArrowLeft,
  faExchange: faExchange,
  faRotateRight: faRotateRight,
  faRedoAlt: faRedoAlt,
  faRotateForward: faRotateForward,
  faUtensils: faUtensils,
  faCutlery: faCutlery,
  faArrowUpWideShort: faArrowUpWideShort,
  faSortAmountUp: faSortAmountUp,
  faChartPieSimpleCircleDollar: faChartPieSimpleCircleDollar,
  faBalloons: faBalloons,
  faMillSign: faMillSign,
  faBowlRice: faBowlRice,
  faTimelineArrow: faTimelineArrow,
  faSkull: faSkull,
  faGameBoardSimple: faGameBoardSimple,
  faGameBoardAlt: faGameBoardAlt,
  faCircleVideo: faCircleVideo,
  faVideoCircle: faVideoCircle,
  faChartScatterBubble: faChartScatterBubble,
  faHouseTurret: faHouseTurret,
  faBanana: faBanana,
  faHandHoldingSkull: faHandHoldingSkull,
  faPeopleDress: faPeopleDress,
  faLoveseat: faLoveseat,
  faCouchSmall: faCouchSmall,
  faTowerBroadcast: faTowerBroadcast,
  faBroadcastTower: faBroadcastTower,
  faTruckPickup: faTruckPickup,
  faBlockQuote: faBlockQuote,
  faUpLong: faUpLong,
  faLongArrowAltUp: faLongArrowAltUp,
  faStop: faStop,
  faCodeMerge: faCodeMerge,
  faMoneyCheckDollarPen: faMoneyCheckDollarPen,
  faMoneyCheckEditAlt: faMoneyCheckEditAlt,
  faUpFromLine: faUpFromLine,
  faArrowAltFromBottom: faArrowAltFromBottom,
  faUpload: faUpload,
  faHurricane: faHurricane,
  faGridRound2Plus: faGridRound2Plus,
  faPeoplePants: faPeoplePants,
  faMound: faMound,
  faWindsock: faWindsock,
  faCircleHalf: faCircleHalf,
  faBrakeWarning: faBrakeWarning,
  faToiletPortable: faToiletPortable,
  faCompactDisc: faCompactDisc,
  faFileArrowDown: faFileArrowDown,
  faFileDownload: faFileDownload,
  faSaxophoneFire: faSaxophoneFire,
  faSaxHot: faSaxHot,
  faCameraWebSlash: faCameraWebSlash,
  faWebcamSlash: faWebcamSlash,
  faFolderMedical: faFolderMedical,
  faFolderGear: faFolderGear,
  faFolderCog: faFolderCog,
  faHandWave: faHandWave,
  faArrowUpArrowDown: faArrowUpArrowDown,
  faSortUpDown: faSortUpDown,
  faCaravan: faCaravan,
  faShieldCat: faShieldCat,
  faMessageSlash: faMessageSlash,
  faCommentAltSlash: faCommentAltSlash,
  faBolt: faBolt,
  faZap: faZap,
  faTrashCanCheck: faTrashCanCheck,
  faGlassWater: faGlassWater,
  faOilWell: faOilWell,
  faPersonSimple: faPersonSimple,
  faVault: faVault,
  faMars: faMars,
  faToilet: faToilet,
  faPlaneCircleXmark: faPlaneCircleXmark,
  faYenSign: faYenSign,
  faCny: faCny,
  faJpy: faJpy,
  faRmb: faRmb,
  faYen: faYen,
  faGearCode: faGearCode,
  faNotes: faNotes,
  faRubleSign: faRubleSign,
  faRouble: faRouble,
  faRub: faRub,
  faRuble: faRuble,
  faTrashUndo: faTrashUndo,
  faTrashArrowTurnLeft: faTrashArrowTurnLeft,
  faChampagneGlass: faChampagneGlass,
  faGlassChampagne: faGlassChampagne,
  faObjectsAlignCenterHorizontal: faObjectsAlignCenterHorizontal,
  faSun: faSun,
  faTrashCanSlash: faTrashCanSlash,
  faTrashAltSlash: faTrashAltSlash,
  faScreenUsers: faScreenUsers,
  faUsersClass: faUsersClass,
  faGuitar: faGuitar,
  faSquareArrowLeft: faSquareArrowLeft,
  faArrowSquareLeft: faArrowSquareLeft,
  faSquare8: faSquare8,
  faFaceSmileHearts: faFaceSmileHearts,
  faBracketsSquare: faBracketsSquare,
  faBrackets: faBrackets,
  faLaptopArrowDown: faLaptopArrowDown,
  faHockeyStickPuck: faHockeyStickPuck,
  faHouseTree: faHouseTree,
  faSignalFair: faSignalFair,
  faSignal2: faSignal2,
  faFaceLaughWink: faFaceLaughWink,
  faLaughWink: faLaughWink,
  faCircleDollar: faCircleDollar,
  faDollarCircle: faDollarCircle,
  faUsdCircle: faUsdCircle,
  faHorseHead: faHorseHead,
  faArrowsRepeat: faArrowsRepeat,
  faRepeatAlt: faRepeatAlt,
  faBoreHole: faBoreHole,
  faIndustry: faIndustry,
  faImagePolaroid: faImagePolaroid,
  faWaveTriangle: faWaveTriangle,
  faPersonRunningFast: faPersonRunningFast,
  faCircleDown: faCircleDown,
  faArrowAltCircleDown: faArrowAltCircleDown,
  faGrill: faGrill,
  faArrowsTurnToDots: faArrowsTurnToDots,
  faChartMixed: faChartMixed,
  faAnalytics: faAnalytics,
  faFlorinSign: faFlorinSign,
  faArrowDownShortWide: faArrowDownShortWide,
  faSortAmountDesc: faSortAmountDesc,
  faSortAmountDownAlt: faSortAmountDownAlt,
  faLessThan: faLessThan,
  faDisplayCode: faDisplayCode,
  faDesktopCode: faDesktopCode,
  faFaceDrooling: faFaceDrooling,
  faOilTemperature: faOilTemperature,
  faOilTemp: faOilTemp,
  faSquareQuestion: faSquareQuestion,
  faQuestionSquare: faQuestionSquare,
  faAirConditioner: faAirConditioner,
  faAngleDown: faAngleDown,
  faMountains: faMountains,
  faOmega: faOmega,
  faCarTunnel: faCarTunnel,
  faPersonDollyEmpty: faPersonDollyEmpty,
  faPanFood: faPanFood,
  faHeadSideCough: faHeadSideCough,
  faGripLines: faGripLines,
  faThumbsDown: faThumbsDown,
  faUserLock: faUserLock,
  faArrowRightLong: faArrowRightLong,
  faLongArrowRight: faLongArrowRight,
  faTicketsAirline: faTicketsAirline,
  faAnchorCircleXmark: faAnchorCircleXmark,
  faEllipsis: faEllipsis,
  faEllipsisH: faEllipsisH,
  faNfcSlash: faNfcSlash,
  faChessPawn: faChessPawn,
  faKitMedical: faKitMedical,
  faFirstAid: faFirstAid,
  faGrid2Plus: faGrid2Plus,
  faBells: faBells,
  faPersonThroughWindow: faPersonThroughWindow,
  faToolbox: faToolbox,
  faEnvelopeDot: faEnvelopeDot,
  faEnvelopeBadge: faEnvelopeBadge,
  faHandsHoldingCircle: faHandsHoldingCircle,
  faBug: faBug,
  faBowlChopsticks: faBowlChopsticks,
  faCreditCard: faCreditCard,
  faCreditCardAlt: faCreditCardAlt,
  faCircleS: faCircleS,
  faBoxBallot: faBoxBallot,
  faCar: faCar,
  faAutomobile: faAutomobile,
  faHandHoldingHand: faHandHoldingHand,
  faUserTieHair: faUserTieHair,
  faPodiumStar: faPodiumStar,
  faUserHairMullet: faUserHairMullet,
  faBusinessFront: faBusinessFront,
  faPartyBack: faPartyBack,
  faTrianBalbot: faTrianBalbot,
  faMicrophoneStand: faMicrophoneStand,
  faBookOpenReader: faBookOpenReader,
  faBookReader: faBookReader,
  faFamilyDress: faFamilyDress,
  faCircleX: faCircleX,
  faCabin: faCabin,
  faMountainSun: faMountainSun,
  faChartSimpleHorizontal: faChartSimpleHorizontal,
  faBluetooth: faBluetooth,
  faArrowsLeftRightToLine: faArrowsLeftRightToLine,
  faHandBackPointLeft: faHandBackPointLeft,
  faMessageDots: faMessageDots,
  faCommentAltDots: faCommentAltDots,
  faMessaging: faMessaging,
  faFileHeart: faFileHeart,
  faBeerMug: faBeerMug,
  faBeerFoam: faBeerFoam,
  faDiceD20: faDiceD20,
  faDrone: faDrone,
  faTruckDroplet: faTruckDroplet,
  faFileCircleXmark: faFileCircleXmark,
  faTemperatureArrowUp: faTemperatureArrowUp,
  faTemperatureUp: faTemperatureUp,
  faMedal: faMedal,
  faBed: faBed,
  faBookCopy: faBookCopy,
  faSquareH: faSquareH,
  faHSquare: faHSquare,
  faSquareC: faSquareC,
  faClockTwo: faClockTwo,
  faSquareEllipsisVertical: faSquareEllipsisVertical,
  faCalendarUsers: faCalendarUsers,
  faPodcast: faPodcast,
  faBee: faBee,
  faTemperatureFull: faTemperatureFull,
  faTemperature4: faTemperature4,
  faThermometer4: faThermometer4,
  faThermometerFull: faThermometerFull,
  faBell: faBell,
  faCandyBar: faCandyBar,
  faChocolateBar: faChocolateBar,
  faXmarkLarge: faXmarkLarge,
  faPinata: faPinata,
  faArrowsFromLine: faArrowsFromLine,
  faSuperscript: faSuperscript,
  faBowlSpoon: faBowlSpoon,
  faHexagonCheck: faHexagonCheck,
  faPlugCircleXmark: faPlugCircleXmark,
  faStarOfLife: faStarOfLife,
  faPhoneSlash: faPhoneSlash,
  faTrafficLightStop: faTrafficLightStop,
  faPaintRoller: faPaintRoller,
  faAccentGrave: faAccentGrave,
  faHandshakeAngle: faHandshakeAngle,
  faHandsHelping: faHandsHelping,
  faCircle0: faCircle0,
  faDialMedLow: faDialMedLow,
  faLocationDot: faLocationDot,
  faMapMarkerAlt: faMapMarkerAlt,
  faCrab: faCrab,
  faBoxOpenFull: faBoxOpenFull,
  faBoxFull: faBoxFull,
  faFile: faFile,
  faGreaterThan: faGreaterThan,
  faQuotes: faQuotes,
  faPretzel: faPretzel,
  faPersonSwimming: faPersonSwimming,
  faSwimmer: faSwimmer,
  faArrowDown: faArrowDown,
  faUserRobotXmarks: faUserRobotXmarks,
  faMessageQuote: faMessageQuote,
  faCommentAltQuote: faCommentAltQuote,
  faCandyCorn: faCandyCorn,
  faFolderMagnifyingGlass: faFolderMagnifyingGlass,
  faFolderSearch: faFolderSearch,
  faNotebook: faNotebook,
  faDroplet: faDroplet,
  faTint: faTint,
  faBullseyePointer: faBullseyePointer,
  faEraser: faEraser,
  faHexagonImage: faHexagonImage,
  faEarthAmericas: faEarthAmericas,
  faEarth: faEarth,
  faEarthAmerica: faEarthAmerica,
  faGlobeAmericas: faGlobeAmericas,
  faCrateApple: faCrateApple,
  faAppleCrate: faAppleCrate,
  faPersonBurst: faPersonBurst,
  faGameBoard: faGameBoard,
  faHatChef: faHatChef,
  faHandBackPointRight: faHandBackPointRight,
  faDove: faDove,
  faSnowflakeDroplets: faSnowflakeDroplets,
  faBatteryEmpty: faBatteryEmpty,
  faBattery0: faBattery0,
  faGrid4: faGrid4,
  faSocks: faSocks,
  faFaceSunglasses: faFaceSunglasses,
  faInbox: faInbox,
  faSquare0: faSquare0,
  faSection: faSection,
  faSquareThisWayUp: faSquareThisWayUp,
  faBoxUp: faBoxUp,
  faGaugeHigh: faGaugeHigh,
  faTachometerAlt: faTachometerAlt,
  faTachometerAltFast: faTachometerAltFast,
  faSquareAmpersand: faSquareAmpersand,
  faEnvelopeOpenText: faEnvelopeOpenText,
  faLampDesk: faLampDesk,
  faHospital: faHospital,
  faHospitalAlt: faHospitalAlt,
  faHospitalWide: faHospitalWide,
  faPollPeople: faPollPeople,
  faWhiskeyGlassIce: faWhiskeyGlassIce,
  faGlassWhiskeyRocks: faGlassWhiskeyRocks,
  faWineBottle: faWineBottle,
  faChessRook: faChessRook,
  faUserBountyHunter: faUserBountyHunter,
  faBarsStaggered: faBarsStaggered,
  faReorder: faReorder,
  faStream: faStream,
  faDiagramSankey: faDiagramSankey,
  faCloudHailMixed: faCloudHailMixed,
  faCircleUpLeft: faCircleUpLeft,
  faDharmachakra: faDharmachakra,
  faObjectsAlignLeft: faObjectsAlignLeft,
  faOilCanDrip: faOilCanDrip,
  faFaceSmilingHands: faFaceSmilingHands,
  faBroccoli: faBroccoli,
  faRouteInterstate: faRouteInterstate,
  faEarMuffs: faEarMuffs,
  faHotdog: faHotdog,
  faTransporterEmpty: faTransporterEmpty,
  faPersonWalkingWithCane: faPersonWalkingWithCane,
  faBlind: faBlind,
  faAngle90: faAngle90,
  faRectangleTerminal: faRectangleTerminal,
  faKite: faKite,
  faDrum: faDrum,
  faScrubber: faScrubber,
  faIceCream: faIceCream,
  faHeartCircleBolt: faHeartCircleBolt,
  faFishBones: faFishBones,
  faDeerRudolph: faDeerRudolph,
  faFax: faFax,
  faParagraph: faParagraph,
  faHeadSideHeart: faHeadSideHeart,
  faSquareE: faSquareE,
  faMeterFire: faMeterFire,
  faCloudHail: faCloudHail,
  faCheckToSlot: faCheckToSlot,
  faVoteYea: faVoteYea,
  faMoneyFromBracket: faMoneyFromBracket,
  faStarHalf: faStarHalf,
  faCarBus: faCarBus,
  faSpeaker: faSpeaker,
  faTimer: faTimer,
  faBoxesStacked: faBoxesStacked,
  faBoxes: faBoxes,
  faBoxesAlt: faBoxesAlt,
  faGrillHot: faGrillHot,
  faBallotCheck: faBallotCheck,
  faLink: faLink,
  faChain: faChain,
  faEarListen: faEarListen,
  faAssistiveListeningSystems: faAssistiveListeningSystems,
  faFileMinus: faFileMinus,
  faTreeCity: faTreeCity,
  faPlay: faPlay,
  faFont: faFont,
  faCupTogo: faCupTogo,
  faCoffeeTogo: faCoffeeTogo,
  faSquareDownLeft: faSquareDownLeft,
  faBurgerLettuce: faBurgerLettuce,
  faRupiahSign: faRupiahSign,
  faMagnifyingGlass: faMagnifyingGlass,
  faSearch: faSearch,
  faTableTennisPaddleBall: faTableTennisPaddleBall,
  faPingPongPaddleBall: faPingPongPaddleBall,
  faTableTennis: faTableTennis,
  faPersonDotsFromLine: faPersonDotsFromLine,
  faDiagnoses: faDiagnoses,
  faChevronsDown: faChevronsDown,
  faChevronDoubleDown: faChevronDoubleDown,
  faTrashCanArrowUp: faTrashCanArrowUp,
  faTrashRestoreAlt: faTrashRestoreAlt,
  faSignalGood: faSignalGood,
  faSignal3: faSignal3,
  faLocationQuestion: faLocationQuestion,
  faMapMarkerQuestion: faMapMarkerQuestion,
  faFloppyDiskCircleXmark: faFloppyDiskCircleXmark,
  faFloppyDiskTimes: faFloppyDiskTimes,
  faSaveCircleXmark: faSaveCircleXmark,
  faSaveTimes: faSaveTimes,
  faNairaSign: faNairaSign,
  faPeach: faPeach,
  faTaxiBus: faTaxiBus,
  faBracketCurly: faBracketCurly,
  faBracketCurlyLeft: faBracketCurlyLeft,
  faLobster: faLobster,
  faCartFlatbedEmpty: faCartFlatbedEmpty,
  faDollyFlatbedEmpty: faDollyFlatbedEmpty,
  faColon: faColon,
  faCartArrowDown: faCartArrowDown,
  faWand: faWand,
  faWalkieTalkie: faWalkieTalkie,
  faFilePen: faFilePen,
  faFileEdit: faFileEdit,
  faReceipt: faReceipt,
  faTablePicnic: faTablePicnic,
  faSquarePen: faSquarePen,
  faPenSquare: faPenSquare,
  faPencilSquare: faPencilSquare,
  faCircleMicrophoneLines: faCircleMicrophoneLines,
  faMicrophoneCircleAlt: faMicrophoneCircleAlt,
  faDisplaySlash: faDisplaySlash,
  faDesktopSlash: faDesktopSlash,
  faSuitcaseRolling: faSuitcaseRolling,
  faPersonCircleExclamation: faPersonCircleExclamation,
  faTransporter2: faTransporter2,
  faHandsHoldingDiamond: faHandsHoldingDiamond,
  faHandReceiving: faHandReceiving,
  faMoneyBillSimpleWave: faMoneyBillSimpleWave,
  faChevronDown: faChevronDown,
  faBatteryFull: faBatteryFull,
  faBattery: faBattery,
  faBattery5: faBattery5,
  faBellPlus: faBellPlus,
  faBookArrowRight: faBookArrowRight,
  faHospitals: faHospitals,
  faClub: faClub,
  faSkullCrossbones: faSkullCrossbones,
  faDropletDegree: faDropletDegree,
  faDewpoint: faDewpoint,
  faCodeCompare: faCodeCompare,
  faListUl: faListUl,
  faListDots: faListDots,
  faHandHoldingMagic: faHandHoldingMagic,
  faWatermelonSlice: faWatermelonSlice,
  faCircleEllipsis: faCircleEllipsis,
  faSchoolLock: faSchoolLock,
  faTowerCell: faTowerCell,
  faSdCards: faSdCards,
  faJugBottle: faJugBottle,
  faDownLong: faDownLong,
  faLongArrowAltDown: faLongArrowAltDown,
  faEnvelopes: faEnvelopes,
  faPhoneOffice: faPhoneOffice,
  faRankingStar: faRankingStar,
  faChessKing: faChessKing,
  faNfcPen: faNfcPen,
  faPersonHarassing: faPersonHarassing,
  faHatWinter: faHatWinter,
  faBrazilianRealSign: faBrazilianRealSign,
  faLandmarkDome: faLandmarkDome,
  faLandmarkAlt: faLandmarkAlt,
  faBoneBreak: faBoneBreak,
  faArrowUp: faArrowUp,
  faDownFromDottedLine: faDownFromDottedLine,
  faTv: faTv,
  faTelevision: faTelevision,
  faTvAlt: faTvAlt,
  faBorderLeft: faBorderLeft,
  faCircleDivide: faCircleDivide,
  faShrimp: faShrimp,
  faListCheck: faListCheck,
  faTasks: faTasks,
  faDiagramSubtask: faDiagramSubtask,
  faJugDetergent: faJugDetergent,
  faCircleUser: faCircleUser,
  faUserCircle: faUserCircle,
  faSquareY: faSquareY,
  faUserDoctorHair: faUserDoctorHair,
  faPlanetRinged: faPlanetRinged,
  faMushroom: faMushroom,
  faUserShield: faUserShield,
  faMegaphone: faMegaphone,
  faWreathLaurel: faWreathLaurel,
  faCircleExclamationCheck: faCircleExclamationCheck,
  faWind: faWind,
  faBoxDollar: faBoxDollar,
  faBoxUsd: faBoxUsd,
  faCarBurst: faCarBurst,
  faCarCrash: faCarCrash,
  faY: faY,
  faUserHeadset: faUserHeadset,
  faArrowsRetweet: faArrowsRetweet,
  faRetweetAlt: faRetweetAlt,
  faPersonSnowboarding: faPersonSnowboarding,
  faSnowboarding: faSnowboarding,
  faSquareChevronRight: faSquareChevronRight,
  faChevronSquareRight: faChevronSquareRight,
  faLacrosseStickBall: faLacrosseStickBall,
  faTruckFast: faTruckFast,
  faShippingFast: faShippingFast,
  faUserMagnifyingGlass: faUserMagnifyingGlass,
  faStarSharp: faStarSharp,
  faCommentHeart: faCommentHeart,
  faCircle1: faCircle1,
  faCircleStar: faCircleStar,
  faStarCircle: faStarCircle,
  faFish: faFish,
  faCloudFog: faCloudFog,
  faFog: faFog,
  faWaffle: faWaffle,
  faMusicNote: faMusicNote,
  faMusicAlt: faMusicAlt,
  faHexagonExclamation: faHexagonExclamation,
  faCartShoppingFast: faCartShoppingFast,
  faObjectUnion: faObjectUnion,
  faUserGraduate: faUserGraduate,
  faStarfighter: faStarfighter,
  faCircleHalfStroke: faCircleHalfStroke,
  faAdjust: faAdjust,
  faArrowRightLongToLine: faArrowRightLongToLine,
  faSquareArrowDown: faSquareArrowDown,
  faArrowSquareDown: faArrowSquareDown,
  faDiamondHalfStroke: faDiamondHalfStroke,
  faClapperboard: faClapperboard,
  faSquareChevronLeft: faSquareChevronLeft,
  faChevronSquareLeft: faChevronSquareLeft,
  faPhoneIntercom: faPhoneIntercom,
  faLinkHorizontal: faLinkHorizontal,
  faChainHorizontal: faChainHorizontal,
  faMango: faMango,
  faMusicNoteSlash: faMusicNoteSlash,
  faMusicAltSlash: faMusicAltSlash,
  faCircleRadiation: faCircleRadiation,
  faRadiationAlt: faRadiationAlt,
  faFaceTongueSweat: faFaceTongueSweat,
  faGlobeStand: faGlobeStand,
  faBaseball: faBaseball,
  faBaseballBall: faBaseballBall,
  faCircleP: faCircleP,
  faAwardSimple: faAwardSimple,
  faJetFighterUp: faJetFighterUp,
  faDiagramProject: faDiagramProject,
  faProjectDiagram: faProjectDiagram,
  faPedestal: faPedestal,
  faChartPyramid: faChartPyramid,
  faSidebar: faSidebar,
  faSnowmanHead: faSnowmanHead,
  faFrostyHead: faFrostyHead,
  faCopy: faCopy,
  faBurgerGlass: faBurgerGlass,
  faVolumeXmark: faVolumeXmark,
  faVolumeMute: faVolumeMute,
  faVolumeTimes: faVolumeTimes,
  faHandSparkles: faHandSparkles,
  faBarsFilter: faBarsFilter,
  faPaintbrushPencil: faPaintbrushPencil,
  faPartyBell: faPartyBell,
  faUserVneckHair: faUserVneckHair,
  faJackOLantern: faJackOLantern,
  faGrip: faGrip,
  faGripHorizontal: faGripHorizontal,
  faShareFromSquare: faShareFromSquare,
  faShareSquare: faShareSquare,
  faKeynote: faKeynote,
  faChildCombatant: faChildCombatant,
  faChildRifle: faChildRifle,
  faGun: faGun,
  faSquarePhone: faSquarePhone,
  faPhoneSquare: faPhoneSquare,
  faHatBeach: faHatBeach,
  faPlus: faPlus,
  faAdd: faAdd,
  faExpand: faExpand,
  faComputer: faComputer,
  faFort: faFort,
  faCloudCheck: faCloudCheck,
  faXmark: faXmark,
  faClose: faClose,
  faMultiply: faMultiply,
  faRemove: faRemove,
  faTimes: faTimes,
  faFaceSmirking: faFaceSmirking,
  faArrowsUpDownLeftRight: faArrowsUpDownLeftRight,
  faArrows: faArrows,
  faChalkboardUser: faChalkboardUser,
  faChalkboardTeacher: faChalkboardTeacher,
  faRhombus: faRhombus,
  faClawMarks: faClawMarks,
  faPesoSign: faPesoSign,
  faFaceSmileTongue: faFaceSmileTongue,
  faCartCircleXmark: faCartCircleXmark,
  faBuildingShield: faBuildingShield,
  faCirclePhoneFlip: faCirclePhoneFlip,
  faPhoneCircleAlt: faPhoneCircleAlt,
  faBaby: faBaby,
  faUsersLine: faUsersLine,
  faQuoteLeft: faQuoteLeft,
  faQuoteLeftAlt: faQuoteLeftAlt,
  faTractor: faTractor,
  faKeySkeleton: faKeySkeleton,
  faTrashArrowUp: faTrashArrowUp,
  faTrashRestore: faTrashRestore,
  faArrowDownUpLock: faArrowDownUpLock,
  faArrowDownToBracket: faArrowDownToBracket,
  faLinesLeaning: faLinesLeaning,
  faSquareQ: faSquareQ,
  faRulerCombined: faRulerCombined,
  faSymbols: faSymbols,
  faIconsAlt: faIconsAlt,
  faCopyright: faCopyright,
  faFlaskGear: faFlaskGear,
  faHighlighterLine: faHighlighterLine,
  faBracketSquare: faBracketSquare,
  faBracket: faBracket,
  faBracketLeft: faBracketLeft,
  faIslandTropical: faIslandTropical,
  faIslandTreePalm: faIslandTreePalm,
  faArrowRightFromLine: faArrowRightFromLine,
  faArrowFromLeft: faArrowFromLeft,
  faH2: faH2,
  faEquals: faEquals,
  faCakeSlice: faCakeSlice,
  faShortcake: faShortcake,
  faPeanut: faPeanut,
  faWrenchSimple: faWrenchSimple,
  faBlender: faBlender,
  faTeeth: faTeeth,
  faTally2: faTally2,
  faShekelSign: faShekelSign,
  faIls: faIls,
  faShekel: faShekel,
  faSheqel: faSheqel,
  faSheqelSign: faSheqelSign,
  faCars: faCars,
  faAxeBattle: faAxeBattle,
  faUserHairLong: faUserHairLong,
  faMap: faMap,
  faFileCircleInfo: faFileCircleInfo,
  faFaceDisappointed: faFaceDisappointed,
  faLassoSparkles: faLassoSparkles,
  faClockEleven: faClockEleven,
  faRocket: faRocket,
  faSirenOn: faSirenOn,
  faClockTen: faClockTen,
  faCandleHolder: faCandleHolder,
  faVideoArrowDownLeft: faVideoArrowDownLeft,
  faPhotoFilm: faPhotoFilm,
  faPhotoVideo: faPhotoVideo,
  faFloppyDiskCircleArrowRight: faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight: faSaveCircleArrowRight,
  faFolderMinus: faFolderMinus,
  faPlanetMoon: faPlanetMoon,
  faFaceEyesXmarks: faFaceEyesXmarks,
  faChartScatter: faChartScatter,
  faDisplayArrowDown: faDisplayArrowDown,
  faStore: faStore,
  faArrowTrendUp: faArrowTrendUp,
  faPlugCircleMinus: faPlugCircleMinus,
  faOliveBranch: faOliveBranch,
  faAngle: faAngle,
  faVacuumRobot: faVacuumRobot,
  faSignHanging: faSignHanging,
  faSign: faSign,
  faSquareDivide: faSquareDivide,
  faSignalStreamSlash: faSignalStreamSlash,
  faBezierCurve: faBezierCurve,
  faEyeDropperHalf: faEyeDropperHalf,
  faStoreLock: faStoreLock,
  faBellSlash: faBellSlash,
  faCloudBoltSun: faCloudBoltSun,
  faThunderstormSun: faThunderstormSun,
  faCameraSlash: faCameraSlash,
  faCommentQuote: faCommentQuote,
  faTablet: faTablet,
  faTabletAndroid: faTabletAndroid,
  faSchoolFlag: faSchoolFlag,
  faMessageCode: faMessageCode,
  faGlassHalf: faGlassHalf,
  faGlassHalfEmpty: faGlassHalfEmpty,
  faGlassHalfFull: faGlassHalfFull,
  faFill: faFill,
  faMessageMinus: faMessageMinus,
  faCommentAltMinus: faCommentAltMinus,
  faAngleUp: faAngleUp,
  faDinosaur: faDinosaur,
  faDrumstickBite: faDrumstickBite,
  faLinkHorizontalSlash: faLinkHorizontalSlash,
  faChainHorizontalSlash: faChainHorizontalSlash,
  faHollyBerry: faHollyBerry,
  faNose: faNose,
  faChevronLeft: faChevronLeft,
  faBacteria: faBacteria,
  faClouds: faClouds,
  faMoneyBillSimple: faMoneyBillSimple,
  faHandLizard: faHandLizard,
  faTablePivot: faTablePivot,
  faFilterSlash: faFilterSlash,
  faTrashCanUndo: faTrashCanUndo,
  faTrashCanArrowTurnLeft: faTrashCanArrowTurnLeft,
  faTrashUndoAlt: faTrashUndoAlt,
  faNotdef: faNotdef,
  faDisease: faDisease,
  faPersonToDoor: faPersonToDoor,
  faTurntable: faTurntable,
  faBriefcaseMedical: faBriefcaseMedical,
  faGenderless: faGenderless,
  faChevronRight: faChevronRight,
  faSignalWeak: faSignalWeak,
  faSignal1: faSignal1,
  faClockFive: faClockFive,
  faRetweet: faRetweet,
  faCarRear: faCarRear,
  faCarAlt: faCarAlt,
  faPumpSoap: faPumpSoap,
  faComputerClassic: faComputerClassic,
  faFrame: faFrame,
  faVideoSlash: faVideoSlash,
  faBatteryQuarter: faBatteryQuarter,
  faBattery2: faBattery2,
  faEllipsisStroke: faEllipsisStroke,
  faEllipsisHAlt: faEllipsisHAlt,
  faRadio: faRadio,
  faBabyCarriage: faBabyCarriage,
  faCarriageBaby: faCarriageBaby,
  faFaceExpressionless: faFaceExpressionless,
  faDownToDottedLine: faDownToDottedLine,
  faCloudMusic: faCloudMusic,
  faTrafficLight: faTrafficLight,
  faCloudMinus: faCloudMinus,
  faThermometer: faThermometer,
  faShieldMinus: faShieldMinus,
  faVrCardboard: faVrCardboard,
  faCarTilt: faCarTilt,
  faGaugeCircleMinus: faGaugeCircleMinus,
  faBrightnessLow: faBrightnessLow,
  faHandMiddleFinger: faHandMiddleFinger,
  faPercent: faPercent,
  faPercentage: faPercentage,
  faTruckMoving: faTruckMoving,
  faGlassWaterDroplet: faGlassWaterDroplet,
  faConveyorBelt: faConveyorBelt,
  faLocationCheck: faLocationCheck,
  faMapMarkerCheck: faMapMarkerCheck,
  faCoinVertical: faCoinVertical,
  faDisplay: faDisplay,
  faPersonSign: faPersonSign,
  faFaceSmile: faFaceSmile,
  faSmile: faSmile,
  faPhoneHangup: faPhoneHangup,
  faSignatureSlash: faSignatureSlash,
  faThumbtack: faThumbtack,
  faThumbTack: faThumbTack,
  faWheatSlash: faWheatSlash,
  faTrophy: faTrophy,
  faCloudsSun: faCloudsSun,
  faPersonPraying: faPersonPraying,
  faPray: faPray,
  faHammer: faHammer,
  faFaceVomit: faFaceVomit,
  faSpeakers: faSpeakers,
  faTtyAnswer: faTtyAnswer,
  faTeletypeAnswer: faTeletypeAnswer,
  faMugTeaSaucer: faMugTeaSaucer,
  faDiagramLeanCanvas: faDiagramLeanCanvas,
  faAlt: faAlt,
  faDial: faDial,
  faDialMedHigh: faDialMedHigh,
  faHandPeace: faHandPeace,
  faCircleTrash: faCircleTrash,
  faTrashCircle: faTrashCircle,
  faRotate: faRotate,
  faSyncAlt: faSyncAlt,
  faCircleQuarters: faCircleQuarters,
  faSpinner: faSpinner,
  faTowerControl: faTowerControl,
  faArrowUpTriangleSquare: faArrowUpTriangleSquare,
  faSortShapesUp: faSortShapesUp,
  faWhale: faWhale,
  faRobot: faRobot,
  faPeace: faPeace,
  faPartyHorn: faPartyHorn,
  faGears: faGears,
  faCogs: faCogs,
  faSunBright: faSunBright,
  faSunAlt: faSunAlt,
  faWarehouse: faWarehouse,
  faConveyorBeltArm: faConveyorBeltArm,
  faLockKeyholeOpen: faLockKeyholeOpen,
  faLockOpenAlt: faLockOpenAlt,
  faSquareFragile: faSquareFragile,
  faBoxFragile: faBoxFragile,
  faSquareWineGlassCrack: faSquareWineGlassCrack,
  faArrowUpRightDots: faArrowUpRightDots,
  faSquareN: faSquareN,
  faSplotch: faSplotch,
  faFaceGrinHearts: faFaceGrinHearts,
  faGrinHearts: faGrinHearts,
  faMeter: faMeter,
  faMandolin: faMandolin,
  faDiceFour: faDiceFour,
  faSimCard: faSimCard,
  faTransgender: faTransgender,
  faTransgenderAlt: faTransgenderAlt,
  faMercury: faMercury,
  faUpFromBracket: faUpFromBracket,
  faKnifeKitchen: faKnifeKitchen,
  faBorderRight: faBorderRight,
  faArrowTurnDown: faArrowTurnDown,
  faLevelDown: faLevelDown,
  faSpade: faSpade,
  faCardSpade: faCardSpade,
  faLineColumns: faLineColumns,
  faArrowRightToLine: faArrowRightToLine,
  faArrowToRight: faArrowToRight,
  faPersonFallingBurst: faPersonFallingBurst,
  faFlagPennant: faFlagPennant,
  faPennant: faPennant,
  faConveyorBeltEmpty: faConveyorBeltEmpty,
  faUserGroupSimple: faUserGroupSimple,
  faAward: faAward,
  faTicketSimple: faTicketSimple,
  faTicketAlt: faTicketAlt,
  faBuilding: faBuilding,
  faAnglesLeft: faAnglesLeft,
  faAngleDoubleLeft: faAngleDoubleLeft,
  faCamcorder: faCamcorder,
  faVideoHandheld: faVideoHandheld,
  faPancakes: faPancakes,
  faAlbumCircleUser: faAlbumCircleUser,
  faQrcode: faQrcode,
  faDiceD10: faDiceD10,
  faFireplace: faFireplace,
  faBrowser: faBrowser,
  faPenPaintbrush: faPenPaintbrush,
  faPencilPaintbrush: faPencilPaintbrush,
  faFishCooked: faFishCooked,
  faChairOffice: faChairOffice,
  faNestingDolls: faNestingDolls,
  faClockRotateLeft: faClockRotateLeft,
  faHistory: faHistory,
  faTrumpet: faTrumpet,
  faFaceGrinBeamSweat: faFaceGrinBeamSweat,
  faGrinBeamSweat: faGrinBeamSweat,
  faFireSmoke: faFireSmoke,
  faPhoneMissed: faPhoneMissed,
  faFileExport: faFileExport,
  faArrowRightFromFile: faArrowRightFromFile,
  faShield: faShield,
  faShieldBlank: faShieldBlank,
  faArrowUpShortWide: faArrowUpShortWide,
  faSortAmountUpAlt: faSortAmountUpAlt,
  faArrowsRepeat1: faArrowsRepeat1,
  faRepeat1Alt: faRepeat1Alt,
  faGunSlash: faGunSlash,
  faAvocado: faAvocado,
  faBinary: faBinary,
  faGlassesRound: faGlassesRound,
  faGlassesAlt: faGlassesAlt,
  faPhonePlus: faPhonePlus,
  faDitto: faDitto,
  faPersonSeat: faPersonSeat,
  faHouseMedical: faHouseMedical,
  faGolfBallTee: faGolfBallTee,
  faGolfBall: faGolfBall,
  faCircleChevronLeft: faCircleChevronLeft,
  faChevronCircleLeft: faChevronCircleLeft,
  faHouseChimneyWindow: faHouseChimneyWindow,
  faScythe: faScythe,
  faPenNib: faPenNib,
  faBanParking: faBanParking,
  faParkingCircleSlash: faParkingCircleSlash,
  faTentArrowTurnLeft: faTentArrowTurnLeft,
  faFaceDiagonalMouth: faFaceDiagonalMouth,
  faDiagramCells: faDiagramCells,
  faCricketBatBall: faCricketBatBall,
  faCricket: faCricket,
  faTents: faTents,
  faWandMagic: faWandMagic,
  faMagic: faMagic,
  faDog: faDog,
  faPenLine: faPenLine,
  faAtomSimple: faAtomSimple,
  faAtomAlt: faAtomAlt,
  faAmpersand: faAmpersand,
  faCarrot: faCarrot,
  faArrowUpFromLine: faArrowUpFromLine,
  faArrowFromBottom: faArrowFromBottom,
  faMoon: faMoon,
  faPenSlash: faPenSlash,
  faWineGlassEmpty: faWineGlassEmpty,
  faWineGlassAlt: faWineGlassAlt,
  faSquareStar: faSquareStar,
  faCheese: faCheese,
  faSendBackward: faSendBackward,
  faYinYang: faYinYang,
  faMusic: faMusic,
  faCompassSlash: faCompassSlash,
  faClockOne: faClockOne,
  faFileMusic: faFileMusic,
  faCodeCommit: faCodeCommit,
  faTemperatureLow: faTemperatureLow,
  faPersonBiking: faPersonBiking,
  faBiking: faBiking,
  faDisplayChartUpCircleCurrency: faDisplayChartUpCircleCurrency,
  faSkeleton: faSkeleton,
  faCircleG: faCircleG,
  faCircleArrowUpLeft: faCircleArrowUpLeft,
  faCoinBlank: faCoinBlank,
  faBroom: faBroom,
  faVacuum: faVacuum,
  faShieldHeart: faShieldHeart,
  faCardHeart: faCardHeart,
  faLightbulbCflOn: faLightbulbCflOn,
  faMelon: faMelon,
  faGopuram: faGopuram,
  faEarthOceania: faEarthOceania,
  faGlobeOceania: faGlobeOceania,
  faContainerStorage: faContainerStorage,
  faFacePouting: faFacePouting,
  faSquareXmark: faSquareXmark,
  faTimesSquare: faTimesSquare,
  faXmarkSquare: faXmarkSquare,
  faFaceExplode: faFaceExplode,
  faExplodingHead: faExplodingHead,
  faHashtag: faHashtag,
  faUpRightAndDownLeftFromCenter: faUpRightAndDownLeftFromCenter,
  faExpandAlt: faExpandAlt,
  faOilCan: faOilCan,
  faT: faT,
  faTransformerBolt: faTransformerBolt,
  faHippo: faHippo,
  faChartColumn: faChartColumn,
  faCassetteVhs: faCassetteVhs,
  faVhs: faVhs,
  faInfinity: faInfinity,
  faVialCircleCheck: faVialCircleCheck,
  faChimney: faChimney,
  faObjectIntersect: faObjectIntersect,
  faPersonArrowDownToLine: faPersonArrowDownToLine,
  faVoicemail: faVoicemail,
  faBlockBrick: faBlockBrick,
  faWallBrick: faWallBrick,
  faFan: faFan,
  faBagsShopping: faBagsShopping,
  faParagraphLeft: faParagraphLeft,
  faParagraphRtl: faParagraphRtl,
  faPersonWalkingLuggage: faPersonWalkingLuggage,
  faCaravanSimple: faCaravanSimple,
  faCaravanAlt: faCaravanAlt,
  faTurtle: faTurtle,
  faPencilMechanical: faPencilMechanical,
  faUpDown: faUpDown,
  faArrowsAltV: faArrowsAltV,
  faCloudMoonRain: faCloudMoonRain,
  faBoothCurtain: faBoothCurtain,
  faCalendar: faCalendar,
  faBoxHeart: faBoxHeart,
  faTrailer: faTrailer,
  faUserDoctorMessage: faUserDoctorMessage,
  faUserMdChat: faUserMdChat,
  faBahai: faBahai,
  faHaykal: faHaykal,
  faAmpGuitar: faAmpGuitar,
  faSdCard: faSdCard,
  faVolumeSlash: faVolumeSlash,
  faBorderBottom: faBorderBottom,
  faWifiWeak: faWifiWeak,
  faWifi1: faWifi1,
  faDragon: faDragon,
  faShoePrints: faShoePrints,
  faCirclePlus: faCirclePlus,
  faPlusCircle: faPlusCircle,
  faFaceGrinTongueWink: faFaceGrinTongueWink,
  faGrinTongueWink: faGrinTongueWink,
  faHandHolding: faHandHolding,
  faPlugCircleExclamation: faPlugCircleExclamation,
  faLinkSlash: faLinkSlash,
  faChainBroken: faChainBroken,
  faChainSlash: faChainSlash,
  faUnlink: faUnlink,
  faClone: faClone,
  faPersonWalkingArrowLoopLeft: faPersonWalkingArrowLoopLeft,
  faArrowUpZA: faArrowUpZA,
  faSortAlphaUpAlt: faSortAlphaUpAlt,
  faFireFlameCurved: faFireFlameCurved,
  faFireAlt: faFireAlt,
  faTornado: faTornado,
  faFileCirclePlus: faFileCirclePlus,
  faDeleteRight: faDeleteRight,
  faBookQuran: faBookQuran,
  faQuran: faQuran,
  faCircleQuarter: faCircleQuarter,
  faAnchor: faAnchor,
  faBorderAll: faBorderAll,
  faFunction: faFunction,
  faFaceAngry: faFaceAngry,
  faAngry: faAngry,
  faPeopleSimple: faPeopleSimple,
  faCookieBite: faCookieBite,
  faArrowTrendDown: faArrowTrendDown,
  faRss: faRss,
  faFeed: faFeed,
  faFaceMonocle: faFaceMonocle,
  faDrawPolygon: faDrawPolygon,
  faScaleBalanced: faScaleBalanced,
  faBalanceScale: faBalanceScale,
  faCalendarLines: faCalendarLines,
  faCalendarNote: faCalendarNote,
  faArrowDownBigSmall: faArrowDownBigSmall,
  faSortSizeDown: faSortSizeDown,
  faGaugeSimpleHigh: faGaugeSimpleHigh,
  faTachometer: faTachometer,
  faTachometerFast: faTachometerFast,
  faDoNotEnter: faDoNotEnter,
  faShower: faShower,
  faDiceD8: faDiceD8,
  faDesktop: faDesktop,
  faDesktopAlt: faDesktopAlt,
  faM: faM,
  faGripDotsVertical: faGripDotsVertical,
  faFaceViewfinder: faFaceViewfinder,
  faSoftServe: faSoftServe,
  faCreemee: faCreemee,
  faH5: faH5,
  faHandBackPointDown: faHandBackPointDown,
  faTableList: faTableList,
  faThList: faThList,
  faCommentSms: faCommentSms,
  faSms: faSms,
  faRectangle: faRectangle,
  faRectangleLandscape: faRectangleLandscape,
  faClipboardListCheck: faClipboardListCheck,
  faTurkey: faTurkey,
  faBook: faBook,
  faUserPlus: faUserPlus,
  faIceSkate: faIceSkate,
  faCheck: faCheck,
  faBatteryThreeQuarters: faBatteryThreeQuarters,
  faBattery4: faBattery4,
  faTomato: faTomato,
  faSwordLaser: faSwordLaser,
  faHouseCircleCheck: faHouseCircleCheck,
  faBuildings: faBuildings,
  faAngleLeft: faAngleLeft,
  faCartFlatbedBoxes: faCartFlatbedBoxes,
  faDollyFlatbedAlt: faDollyFlatbedAlt,
  faDiagramSuccessor: faDiagramSuccessor,
  faTruckArrowRight: faTruckArrowRight,
  faSquareW: faSquareW,
  faArrowsSplitUpAndLeft: faArrowsSplitUpAndLeft,
  faLamp: faLamp,
  faAirplay: faAirplay,
  faHandFist: faHandFist,
  faFistRaised: faFistRaised,
  faShieldQuartered: faShieldQuartered,
  faSlashForward: faSlashForward,
  faLocationPen: faLocationPen,
  faMapMarkerEdit: faMapMarkerEdit,
  faCloudMoon: faCloudMoon,
  faPotFood: faPotFood,
  faBriefcase: faBriefcase,
  faPersonFalling: faPersonFalling,
  faImagePortrait: faImagePortrait,
  faPortrait: faPortrait,
  faUserTag: faUserTag,
  faRug: faRug,
  faPrintSlash: faPrintSlash,
  faEarthEurope: faEarthEurope,
  faGlobeEurope: faGlobeEurope,
  faCartFlatbedSuitcase: faCartFlatbedSuitcase,
  faLuggageCart: faLuggageCart,
  faHandBackPointRibbon: faHandBackPointRibbon,
  faRectangleXmark: faRectangleXmark,
  faRectangleTimes: faRectangleTimes,
  faTimesRectangle: faTimesRectangle,
  faWindowClose: faWindowClose,
  faTireRugged: faTireRugged,
  faLightbulbDollar: faLightbulbDollar,
  faCowbell: faCowbell,
  faBahtSign: faBahtSign,
  faCorner: faCorner,
  faChevronsRight: faChevronsRight,
  faChevronDoubleRight: faChevronDoubleRight,
  faBookOpen: faBookOpen,
  faBookJournalWhills: faBookJournalWhills,
  faJournalWhills: faJournalWhills,
  faInhaler: faInhaler,
  faHandcuffs: faHandcuffs,
  faSnake: faSnake,
  faTriangleExclamation: faTriangleExclamation,
  faExclamationTriangle: faExclamationTriangle,
  faWarning: faWarning,
  faNoteMedical: faNoteMedical,
  faDatabase: faDatabase,
  faDownLeft: faDownLeft,
  faShare: faShare,
  faArrowTurnRight: faArrowTurnRight,
  faMailForward: faMailForward,
  faFaceThinking: faFaceThinking,
  faTurnDownRight: faTurnDownRight,
  faBottleDroplet: faBottleDroplet,
  faMaskFace: faMaskFace,
  faHillRockslide: faHillRockslide,
  faScannerKeyboard: faScannerKeyboard,
  faCircleO: faCircleO,
  faGridHorizontal: faGridHorizontal,
  faMessageDollar: faMessageDollar,
  faCommentAltDollar: faCommentAltDollar,
  faRightLeft: faRightLeft,
  faExchangeAlt: faExchangeAlt,
  faColumns3: faColumns3,
  faPaperPlane: faPaperPlane,
  faRoadCircleExclamation: faRoadCircleExclamation,
  faDungeon: faDungeon,
  faHandHoldingBox: faHandHoldingBox,
  faInputText: faInputText,
  faWindowFlip: faWindowFlip,
  faWindowAlt: faWindowAlt,
  faAlignRight: faAlignRight,
  faScannerGun: faScannerGun,
  faScanner: faScanner,
  faTire: faTire,
  faEngine: faEngine,
  faMoneyBill1Wave: faMoneyBill1Wave,
  faMoneyBillWaveAlt: faMoneyBillWaveAlt,
  faLifeRing: faLifeRing,
  faHands: faHands,
  faSignLanguage: faSignLanguage,
  faSigning: faSigning,
  faCircleCaretRight: faCircleCaretRight,
  faCaretCircleRight: faCaretCircleRight,
  faWheat: faWheat,
  faFileSpreadsheet: faFileSpreadsheet,
  faAudioDescriptionSlash: faAudioDescriptionSlash,
  faCalendarDay: faCalendarDay,
  faWaterLadder: faWaterLadder,
  faLadderWater: faLadderWater,
  faSwimmingPool: faSwimmingPool,
  faArrowsUpDown: faArrowsUpDown,
  faArrowsV: faArrowsV,
  faChessPawnPiece: faChessPawnPiece,
  faChessPawnAlt: faChessPawnAlt,
  faFaceGrimace: faFaceGrimace,
  faGrimace: faGrimace,
  faWheelchairMove: faWheelchairMove,
  faWheelchairAlt: faWheelchairAlt,
  faTurnDown: faTurnDown,
  faLevelDownAlt: faLevelDownAlt,
  faSquareS: faSquareS,
  faRectangleBarcode: faRectangleBarcode,
  faBarcodeAlt: faBarcodeAlt,
  faPersonWalkingArrowRight: faPersonWalkingArrowRight,
  faSquareEnvelope: faSquareEnvelope,
  faEnvelopeSquare: faEnvelopeSquare,
  faDice: faDice,
  faUnicorn: faUnicorn,
  faBowlingBall: faBowlingBall,
  faPompebled: faPompebled,
  faBrain: faBrain,
  faWatchSmart: faWatchSmart,
  faBookUser: faBookUser,
  faSensorCloud: faSensorCloud,
  faSensorSmoke: faSensorSmoke,
  faClapperboardPlay: faClapperboardPlay,
  faBandage: faBandage,
  faBandAid: faBandAid,
  faCalendarMinus: faCalendarMinus,
  faCircleXmark: faCircleXmark,
  faTimesCircle: faTimesCircle,
  faXmarkCircle: faXmarkCircle,
  faCircle4: faCircle4,
  faGifts: faGifts,
  faAlbumCollection: faAlbumCollection,
  faHotel: faHotel,
  faEarthAsia: faEarthAsia,
  faGlobeAsia: faGlobeAsia,
  faIdCardClip: faIdCardClip,
  faIdCardAlt: faIdCardAlt,
  faMagnifyingGlassPlus: faMagnifyingGlassPlus,
  faSearchPlus: faSearchPlus,
  faThumbsUp: faThumbsUp,
  faCloudShowers: faCloudShowers,
  faUserClock: faUserClock,
  faOnion: faOnion,
  faClockTwelveThirty: faClockTwelveThirty,
  faArrowDownToDottedLine: faArrowDownToDottedLine,
  faHandDots: faHandDots,
  faAllergies: faAllergies,
  faFileInvoice: faFileInvoice,
  faWindowMinimize: faWindowMinimize,
  faRectangleWide: faRectangleWide,
  faCommentArrowUp: faCommentArrowUp,
  faGarlic: faGarlic,
  faMugSaucer: faMugSaucer,
  faCoffee: faCoffee,
  faBrush: faBrush,
  faTreeDecorated: faTreeDecorated,
  faMask: faMask,
  faCalendarHeart: faCalendarHeart,
  faMagnifyingGlassMinus: faMagnifyingGlassMinus,
  faSearchMinus: faSearchMinus,
  faFlower: faFlower,
  faRightLeftLarge: faRightLeftLarge,
  faRulerVertical: faRulerVertical,
  faCirclesOverlap: faCirclesOverlap,
  faUserLarge: faUserLarge,
  faUserAlt: faUserAlt,
  faStarshipFreighter: faStarshipFreighter,
  faTrainTram: faTrainTram,
  faBridgeSuspension: faBridgeSuspension,
  faTrashCheck: faTrashCheck,
  faUserNurse: faUserNurse,
  faBoombox: faBoombox,
  faSyringe: faSyringe,
  faCloudSun: faCloudSun,
  faShieldExclamation: faShieldExclamation,
  faStopwatch20: faStopwatch20,
  faSquareFull: faSquareFull,
  faGripDots: faGripDots,
  faCommentExclamation: faCommentExclamation,
  faPenSwirl: faPenSwirl,
  faFalafel: faFalafel,
  faCircle2: faCircle2,
  faMagnet: faMagnet,
  faJar: faJar,
  faGramophone: faGramophone,
  faDiceD12: faDiceD12,
  faNoteSticky: faNoteSticky,
  faStickyNote: faStickyNote,
  faDown: faDown,
  faArrowAltDown: faArrowAltDown,
  faHundredPoints: faHundredPoints,
  fa100: fa100,
  faPaperclipVertical: faPaperclipVertical,
  faWindWarning: faWindWarning,
  faWindCircleExclamation: faWindCircleExclamation,
  faLocationPinSlash: faLocationPinSlash,
  faMapMarkerSlash: faMapMarkerSlash,
  faFaceSadSweat: faFaceSadSweat,
  faBugSlash: faBugSlash,
  faCupcake: faCupcake,
  faLightSwitchOff: faLightSwitchOff,
  faToggleLargeOff: faToggleLargeOff,
  faPenFancySlash: faPenFancySlash,
  faTruckContainer: faTruckContainer,
  faBoot: faBoot,
  faArrowUpFromWaterPump: faArrowUpFromWaterPump,
  faFileCheck: faFileCheck,
  faBone: faBone,
  faCardsBlank: faCardsBlank,
  faCircle3: faCircle3,
  faBenchTree: faBenchTree,
  faKeyboardBrightnessLow: faKeyboardBrightnessLow,
  faSkiBootSki: faSkiBootSki,
  faBrainCircuit: faBrainCircuit,
  faUserInjured: faUserInjured,
  faBlockBrickFire: faBlockBrickFire,
  faFirewall: faFirewall,
  faFaceSadTear: faFaceSadTear,
  faSadTear: faSadTear,
  faPlane: faPlane,
  faTentArrowsDown: faTentArrowsDown,
  faExclamation: faExclamation,
  faArrowsSpin: faArrowsSpin,
  faFaceSmileRelaxed: faFaceSmileRelaxed,
  faCommentXmark: faCommentXmark,
  faCommentTimes: faCommentTimes,
  faPrint: faPrint,
  faTurkishLiraSign: faTurkishLiraSign,
  faTry: faTry,
  faTurkishLira: faTurkishLira,
  faFaceNoseSteam: faFaceNoseSteam,
  faCircleWaveformLines: faCircleWaveformLines,
  faWaveformCircle: faWaveformCircle,
  faDollarSign: faDollarSign,
  faDollar: faDollar,
  faUsd: faUsd,
  faFerrisWheel: faFerrisWheel,
  faComputerSpeaker: faComputerSpeaker,
  faSkullCow: faSkullCow,
  faX: faX,
  faMagnifyingGlassDollar: faMagnifyingGlassDollar,
  faSearchDollar: faSearchDollar,
  faUsersGear: faUsersGear,
  faUsersCog: faUsersCog,
  faPersonMilitaryPointing: faPersonMilitaryPointing,
  faBuildingColumns: faBuildingColumns,
  faBank: faBank,
  faInstitution: faInstitution,
  faMuseum: faMuseum,
  faUniversity: faUniversity,
  faCircleT: faCircleT,
  faSack: faSack,
  faGrid2: faGrid2,
  faCameraCctv: faCameraCctv,
  faCctv: faCctv,
  faUmbrella: faUmbrella,
  faTrowel: faTrowel,
  faHorizontalRule: faHorizontalRule,
  faBedFront: faBedFront,
  faBedAlt: faBedAlt,
  faD: faD,
  faStapler: faStapler,
  faMasksTheater: faMasksTheater,
  faTheaterMasks: faTheaterMasks,
  faKipSign: faKipSign,
  faFaceWoozy: faFaceWoozy,
  faCloudQuestion: faCloudQuestion,
  faPineapple: faPineapple,
  faHandPointLeft: faHandPointLeft,
  faGalleryThumbnails: faGalleryThumbnails,
  faCircleJ: faCircleJ,
  faEyes: faEyes,
  faHandshakeSimple: faHandshakeSimple,
  faHandshakeAlt: faHandshakeAlt,
  faPageCaretUp: faPageCaretUp,
  faFileCaretUp: faFileCaretUp,
  faJetFighter: faJetFighter,
  faFighterJet: faFighterJet,
  faComet: faComet,
  faSquareShareNodes: faSquareShareNodes,
  faShareAltSquare: faShareAltSquare,
  faShieldKeyhole: faShieldKeyhole,
  faBarcode: faBarcode,
  faPlusMinus: faPlusMinus,
  faSquareSlidersVertical: faSquareSlidersVertical,
  faSlidersVSquare: faSlidersVSquare,
  faVideo: faVideo,
  faVideoCamera: faVideoCamera,
  faMessageMiddle: faMessageMiddle,
  faCommentMiddleAlt: faCommentMiddleAlt,
  faGraduationCap: faGraduationCap,
  faMortarBoard: faMortarBoard,
  faHandHoldingMedical: faHandHoldingMedical,
  faPersonCircleCheck: faPersonCircleCheck,
  faSquareZ: faSquareZ,
  faMessageText: faMessageText,
  faCommentAltText: faCommentAltText,
  faTurnUp: faTurnUp,
  faLevelUpAlt: faLevelUpAlt
};




/***/ }),

/***/ 38914:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FV7": function() { return /* binding */ faCameraAlt; },
/* harmony export */   "Fuz": function() { return /* binding */ faQuestionCircle; },
/* harmony export */   "HEx": function() { return /* binding */ faSignOut; },
/* harmony export */   "IV4": function() { return /* binding */ faCalendarAlt; },
/* harmony export */   "ImE": function() { return /* binding */ faEmptySet; },
/* harmony export */   "KN3": function() { return /* binding */ faCloudUpload; },
/* harmony export */   "L4e": function() { return /* binding */ faStickyNote; },
/* harmony export */   "NBC": function() { return /* binding */ faTimes; },
/* harmony export */   "RLE": function() { return /* binding */ faExclamationCircle; },
/* harmony export */   "SZw": function() { return /* binding */ faClock; },
/* harmony export */   "VmB": function() { return /* binding */ faImage; },
/* harmony export */   "aj4": function() { return /* binding */ faMoneyBillWave; },
/* harmony export */   "f8k": function() { return /* binding */ faCheckCircle; },
/* harmony export */   "fyl": function() { return /* binding */ faFaceSadSweat; },
/* harmony export */   "gMD": function() { return /* binding */ faFile; },
/* harmony export */   "gSj": function() { return /* binding */ faFilePdf; },
/* harmony export */   "lH_": function() { return /* binding */ faBallotCheck; },
/* harmony export */   "lcn": function() { return /* binding */ faHourglass2; },
/* harmony export */   "nYk": function() { return /* binding */ faTimesCircle; },
/* harmony export */   "u8Q": function() { return /* binding */ faThumbsUp; }
/* harmony export */ });
/* unused harmony exports fal, prefix, fa0, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, faFillDrip, faArrowsToCircle, faCircleChevronRight, faChevronCircleRight, faWagonCovered, faLineHeight, faBagel, faTransporter7, faAt, faRectanglesMixed, faPhoneArrowUpRight, faPhoneArrowUp, faPhoneOutgoing, faTrashCan, faTrashAlt, faCircleL, faHeadSideGoggles, faHeadVr, faTextHeight, faUserXmark, faUserTimes, faFaceHandYawn, faGaugeSimpleMin, faTachometerSlowest, faStethoscope, faCoffin, faMessage, faCommentAlt, faSalad, faBowlSalad, faInfo, faRobotAstromech, faRingDiamond, faFonduePot, faTheta, faFaceHandPeeking, faSquareUser, faDownLeftAndUpRightToCenter, faCompressAlt, faExplosion, faFileLines, faFileAlt, faFileText, faWaveSquare, faRing, faBuildingUn, faDiceThree, faTirePressureWarning, faWifiFair, faWifi2, faCalendarDays, faMp3Player, faAnchorCircleCheck, faTally4, faRectangleHistory, faBuildingCircleArrowRight, faVolleyball, faVolleyballBall, faSunHaze, faTextSize, faUfo, faFork, faUtensilFork, faArrowsUpToLine, faMobileSignal, faBarcodeScan, faSortDown, faSortDesc, faFolderArrowDown, faFolderDownload, faCircleMinus, faMinusCircle, faFaceIcicles, faShovel, faDoorOpen, faFilms, faRightFromBracket, faSignOutAlt, faFaceGlasses, faNfc, faAtom, faSoap, faIcons, faHeartMusicCameraBolt, faMicrophoneLinesSlash, faMicrophoneAltSlash, faClosedCaptioningSlash, faCalculatorSimple, faCalculatorAlt, faBridgeCircleCheck, faSlidersUp, faSlidersV, faLocationMinus, faMapMarkerMinus, faPumpMedical, faFingerprint, faSkiBoot, faStandardDefinition, faRectangleSd, faH1, faHandPointRight, faMagnifyingGlassLocation, faSearchLocation, faMessageBot, faForwardStep, faStepForward, faFaceSmileBeam, faSmileBeam, faLightCeiling, faMessageExclamation, faCommentAltExclamation, faBowlScoop, faBowlShavedIce, faSquareX, faUtilityPoleDouble, faFlagCheckered, faChevronsUp, faChevronDoubleUp, faFootball, faFootballBall, faUserVneck, faSchoolCircleExclamation, faCrop, faAnglesDown, faAngleDoubleDown, faUsersRectangle, faPeopleRoof, faSquareArrowRight, faArrowSquareRight, faLocationPlus, faMapMarkerPlus, faLightbulbExclamationOn, faPeopleLine, faBeerMugEmpty, faBeer, faCrateEmpty, faDiagramPredecessor, faTransporter, faCalendarCircleUser, faArrowUpLong, faLongArrowUp, faPersonCarryBox, faPersonCarry, faFireFlameSimple, faBurn, faPerson, faMale, faLaptop, faFileCsv, faMenorah, faUnion, faChevronsLeft, faChevronDoubleLeft, faCircleHeart, faHeartCircle, faTruckPlane, faRecordVinyl, faBringForward, faSquareP, faFaceGrinStars, faGrinStars, faSigma, faCameraMovie, faBong, faClarinet, faTruckFlatbed, faSpaghettiMonsterFlying, faPastafarianism, faArrowDownUpAcrossLine, faLeafHeart, faHouseBuilding, faCheeseSwiss, faSpoon, faUtensilSpoon, faJarWheat, faEnvelopesBulk, faMailBulk, faFileCircleExclamation, faBowArrow, faCartXmark, faHexagonXmark, faTimesHexagon, faXmarkHexagon, faCircleH, faHospitalSymbol, faMerge, faPager, faCartMinus, faAddressBook, faContactBook, faPanFrying, faGrid, faGrid3, faFootballHelmet, faHandLove, faTrees, faStrikethrough, faPage, faK, faDiagramPrevious, faGaugeMin, faTachometerAltSlowest, faFolderGrid, faEggplant, faRam, faLandmarkFlag, faLips, faPencil, faPencilAlt, faBackward, faCaretRight, faComments, faPaste, faFileClipboard, faDesktopArrowDown, faCodePullRequest, faPumpkin, faClipboardList, faPenField, faBlueberries, faTruckRampBox, faTruckLoading, faNote, faArrowDownToSquare, faUserCheck, faCloudXmark, faVialVirus, faBookBlank, faBookAlt, faGolfFlagHole, faMessageArrowDown, faCommentAltArrowDown, faFaceUnamused, faSheetPlastic, faCircle9, faBlog, faUserNinja, faPencilSlash, faBowlingPins, faPersonArrowUpFromLine, faDownRight, faScrollTorah, faTorah, faWebhook, faBlindsOpen, faFence, faUp, faArrowAltUp, faBroomBall, faQuidditch, faQuidditchBroomBall, faDrumstick, faSquareV, faFaceAwesome, faGaveDandy, faDialOff, faToggleOff, faFaceSmileHorns, faBoxArchive, faArchive, faGrapes, faPersonDrowning, faDialMax, faCircleM, faCalendarImage, faCircleCaretDown, faCaretCircleDown, faArrowDown91, faSortNumericDesc, faSortNumericDownAlt, faFaceGrinTongueSquint, faGrinTongueSquint, faShishKebab, faSprayCan, faAlarmSnooze, faScarecrow, faTruckMonster, faGiftCard, faW, faCodePullRequestDraft, faSquareB, faElephant, faEarthAfrica, faGlobeAfrica, faRainbow, faCircleNotch, faTabletScreenButton, faTabletAlt, faPaw, faMessageQuestion, faCloud, faTrowelBricks, faSquare3, faFaceFlushed, faFlushed, faHospitalUser, faMicrowave, faChfSign, faTentArrowLeftRight, faCartCircleArrowUp, faTrashClock, faGavel, faLegal, faSprinklerCeiling, faBrowsers, faTrillium, faMusicSlash, faTruckRamp, faBinoculars, faMicrophoneSlash, faBoxTissue, faCircleC, faStarChristmas, faChartBullet, faMotorcycle, faTreeChristmas, faTireFlat, faSunglasses, faBadge, faMessagePen, faCommentAltEdit, faMessageEdit, faBellConcierge, faConciergeBell, faPenRuler, faPencilRuler, faArrowProgress, faChessRookPiece, faChessRookAlt, faSquareRoot, faAlbumCollectionCirclePlus, faPeopleArrows, faPeopleArrowsLeftRight, faFaceAngryHorns, faMarsAndVenusBurst, faTombstone, faSquareCaretRight, faCaretSquareRight, faScissors, faCut, faListMusic, faSunPlantWilt, faToiletsPortable, faHockeyPuck, faMustache, faHyphen, faTable, faUserChef, faMessageImage, faCommentAltImage, faUsersMedical, faSensorTriangleExclamation, faSensorAlert, faMagnifyingGlassArrowRight, faTachographDigital, faDigitalTachograph, faFaceMask, faPickleball, faStarSharpHalf, faUsersSlash, faClover, faMeat, faReply, faMailReply, faStarAndCrescent, faHouseFire, faSquareMinus, faMinusSquare, faHelicopter, faBird, faCompass, faSquareCaretDown, faCaretSquareDown, faHeartHalfStroke, faHeartHalfAlt, faFileCircleQuestion, faLaptopCode, faJoystick, faGrillFire, faRectangleVerticalHistory, faSwatchbook, faPrescriptionBottle, faBars, faNavicon, faKeyboardLeft, faPeopleGroup, faHourglassEnd, faHourglass3, faHeartCrack, faHeartBroken, faFaceBeamHandOverMouth, faDropletPercent, faHumidity, faSquareUpRight, faExternalLinkSquareAlt, faFaceKissBeam, faKissBeam, faCorn, faRollerCoaster, faPhotoFilmMusic, faRadar, faSickle, faFilm, faCoconut, faRulerHorizontal, faShieldCross, faCassetteTape, faSquareTerminal, faPeopleRobbery, faLightbulb, faCaretLeft, faCommentMiddle, faTrashCanList, faBlock, faCircleExclamation, faSchoolCircleXmark, faArrowRightFromBracket, faFaceFrownSlight, faCircleChevronDown, faChevronCircleDown, faSidebarFlip, faUnlockKeyhole, faUnlockAlt, faTemperatureList, faCloudShowersHeavy, faHeadphonesSimple, faHeadphonesAlt, faSitemap, faPipeSection, faSpaceStationMoonConstruction, faSpaceStationMoonAlt, faCircleDollarToSlot, faDonate, faMemory, faFaceSleeping, faRoadSpikes, faFireBurner, faSquirrel, faArrowUpToLine, faArrowToTop, faFlag, faFaceCowboyHat, faHanukiah, faChartScatter3d, faDisplayChartUp, faSquareCode, faFeather, faVolumeLow, faVolumeDown, faXmarkToSlot, faTimesToSlot, faVoteNay, faBoxTaped, faBoxAlt, faCommentSlash, faSwords, faCloudSunRain, faAlbum, faCircleN, faCompress, faWheatAwn, faWheatAlt, faAnkh, faHandsHoldingChild, faAsterisk, faKeySkeletonLeftRight, faCommentLines, faLuchadorMask, faLuchador, faMaskLuchador, faSquareCheck, faCheckSquare, faShredder, faBookOpenCover, faBookOpenAlt, faSandwich, faPesetaSign, faSquareParkingSlash, faParkingSlash, faTrainTunnel, faHeading, faHeader, faGhost, faFaceAnguished, faHockeySticks, faAbacus, faFilmSimple, faFilmAlt, faList, faListSquares, faTreePalm, faSquarePhoneFlip, faPhoneSquareAlt, faCartPlus, faGamepad, faBorderCenterV, faCircleDot, faDotCircle, faClipboardMedical, faFaceDizzy, faDizzy, faEgg, faUpToLine, faArrowAltToTop, faHouseMedicalCircleXmark, faWatchFitness, faClockNineThirty, faCampground, faFolderPlus, faJug, faFutbol, faFutbolBall, faSoccerBall, faSnowBlowing, faPaintbrush, faPaintBrush, faLock, faArrowDownFromLine, faArrowFromTop, faGasPump, faSignalBarsSlash, faSignalAltSlash, faMonkey, faRectanglePro, faPro, faHouseNight, faHotTubPerson, faHotTub, faBlanket, faMapLocation, faMapMarked, faHouseFloodWater, faCommentsQuestionCheck, faTree, faArrowsCross, faBackpack, faSquareSmall, faFolderArrowUp, faFolderUpload, faBridgeLock, faCrosshairsSimple, faSackDollar, faPenToSquare, faEdit, faSquareSliders, faSlidersHSquare, faCarSide, faMessageMiddleTop, faCommentMiddleTopAlt, faLightbulbOn, faKnife, faUtensilKnife, faShareNodes, faShareAlt, faDisplayChartUpCircleDollar, faWaveSine, faHeartCircleMinus, faCircleW, faCircleCalendar, faCalendarCircle, faHourglassHalf, faMicroscope, faSunset, faSink, faCalendarExclamation, faTruckContainerEmpty, faHandHeart, faBagShopping, faShoppingBag, faArrowDownZA, faSortAlphaDesc, faSortAlphaDownAlt, faMitten, faReplyClock, faReplyTime, faPersonRays, faRight, faArrowAltRight, faCircleF, faUsers, faFacePleading, faEyeSlash, faFlaskVial, faPoliceBox, faCucumber, faHeadSideBrain, faHand, faHandPaper, faPersonBikingMountain, faBikingMountain, faUtensilsSlash, faPrintMagnifyingGlass, faPrintSearch, faFolderBookmark, faOm, faPi, faFlaskRoundPotion, faFlaskPotion, faFaceShush, faWorm, faHouseCircleXmark, faPlug, faCalendarCircleExclamation, faSquareI, faChevronUp, faFaceSaluting, faGaugeSimpleLow, faTachometerSlow, faFacePersevering, faCircleCamera, faCameraCircle, faHandSpock, faSpiderWeb, faCircleMicrophone, faMicrophoneCircle, faBookArrowUp, faPopsicle, faCommand, faBlinds, faStopwatch, faSaxophone, faSquare2, faFieldHockeyStickBall, faFieldHockey, faArrowUpSquareTriangle, faSortShapesUpAlt, faFaceScream, faSquareM, faCameraWeb, faWebcam, faCommentArrowDown, faLightbulbCfl, faWindowFrameOpen, faFaceKiss, faKiss, faBridgeCircleXmark, faPeriod, faFaceGrinTongue, faGrinTongue, faUpToDottedLine, faThoughtBubble, faSkeletonRibs, faRaygun, faFlute, faAcorn, faVideoArrowUpRight, faGrateDroplet, faSealExclamation, faChessBishop, faMessageSms, faCoffeeBeans, faHatWitch, faFaceGrinWink, faGrinWink, faClockThreeThirty, faEarDeaf, faDeaf, faDeafness, faHardOfHearing, faAlarmClock, faEclipse, faFaceRelieved, faRoadCircleCheck, faDiceFive, faOctagonMinus, faMinusOctagon, faSquareRss, faRssSquare, faFaceZany, faTricycle, faLandMineOn, faSquareArrowUpLeft, faICursor, faChartMixedUpCircleDollar, faSaltShaker, faStamp, faFilePlus, faDrawSquare, faToiletPaperUnderSlash, faToiletPaperReverseSlash, faStairs, faDroneFront, faDroneAlt, faGlassEmpty, faDialHigh, faUserHelmetSafety, faUserConstruction, faUserHardHat, faI, faHryvniaSign, faHryvnia, faArrowDownLeftAndArrowUpRightToCenter, faPills, faFaceGrinWide, faGrinAlt, faTooth, faBasketballHoop, faObjectsAlignBottom, faV, faSparkles, faSquid, faLeafyGreen, faCircleArrowUpRight, faCalendars, faBangladeshiTakaSign, faBicycle, faHammerWar, faCircleD, faSpiderBlackWidow, faStaffSnake, faRodAsclepius, faRodSnake, faStaffAesculapius, faPear, faHeadSideCoughSlash, faTriangle, faApartment, faTruckMedical, faAmbulance, faPepper, faPiano, faGunSquirt, faWheatAwnCircleExclamation, faSnowman, faUserAlien, faShieldCheck, faMortarPestle, faRoadBarrier, faChartCandlestick, faBriefcaseBlank, faSchool, faIgloo, faBracketRound, faParenthesis, faJoint, faHorseSaddle, faMugMarshmallows, faFilters, faBellOn, faAngleRight, faDialMed, faHorse, faQ, faMonitorWaveform, faMonitorHeartRate, faLinkSimple, faWhistle, faG, faWineGlassCrack, faFragile, faSlotMachine, faNotesMedical, faCarWash, faEscalator, faCommentImage, faTemperatureHalf, faTemperature2, faThermometer2, faThermometerHalf, faDongSign, faDonut, faDoughnut, faCapsules, faPooStorm, faPooBolt, faTally1, faFaceFrownOpen, faFrownOpen, faSquareDashed, faSquareJ, faHandPointUp, faMoneyBill, faArrowUpBigSmall, faSortSizeUp, faBarcodeRead, faBaguette, faBowlSoftServe, faFaceHoldingBackTears, faSquareUp, faArrowAltSquareUp, faTrainSubwayTunnel, faSubwayTunnel, faSquareExclamation, faExclamationSquare, faSemicolon, faBookmark, faFanTable, faAlignJustify, faBatteryLow, faBattery1, faCreditCardFront, faBrainArrowCurvedRight, faMindShare, faUmbrellaBeach, faHelmetUn, faLocationSmile, faMapMarkerSmile, faArrowLeftToLine, faArrowToLeft, faBullseye, faSushi, faNigiri, faMessageCaptions, faCommentAltCaptions, faTrashList, faBacon, faOption, faHandPointDown, faArrowUpFromBracket, faTrashPlus, faObjectsAlignTop, faFolder, faFolderBlank, faFaceAnxiousSweat, faCreditCardBlank, faFileWaveform, faFileMedicalAlt, faMicrochipAi, faMug, faPlaneUpSlash, faRadiation, faPenCircle, faBagSeedling, faChartSimple, faCrutches, faCircleParking, faParkingCircle, faMarsStroke, faLeafOak, faSquareBolt, faVial, faGauge, faDashboard, faGaugeMed, faTachometerAltAverage, faWandMagicSparkles, faMagicWandSparkles, faLambda, faE, faPizza, faBowlChopsticksNoodles, faH3, faPenClip, faPenAlt, faBridgeCircleExclamation, faBadgePercent, faUser, faSensor, faComma, faSchoolCircleCheck, faToiletPaperUnder, faToiletPaperReverse, faLightEmergency, faArrowDownToArc, faDumpster, faVanShuttle, faShuttleVan, faBuildingUser, faLightSwitch, faSquareCaretLeft, faCaretSquareLeft, faHighlighter, faWavePulse, faHeartRate, faKey, faHatSanta, faTamale, faBoxCheck, faBullhorn, faSteak, faLocationCrosshairsSlash, faLocationSlash, faPersonDolly, faGlobe, faSynagogue, faFileChartColumn, faFileChartLine, faPersonHalfDress, faFolderImage, faCalendarPen, faCalendarEdit, faRoadBridge, faFaceSmileTear, faMessagePlus, faCommentAltPlus, faLocationArrow, faC, faTabletButton, faRectangleHistoryCircleUser, faBuildingLock, faChartLineUp, faMailbox, faTruckBolt, faPizzaSlice, faChartArea, faAreaChart, faHouseFlag, faCircleThreeQuartersStroke, faPersonCircleMinus, faScalpel, faBan, faCancel, faBellExclamation, faCircleBookmark, faBookmarkCircle, faEggFried, faFaceWeary, faUniformMartialArts, faCameraRotate, faSunDust, faCommentText, faSprayCanSparkles, faAirFreshener, faSignalBars, faSignalAlt, faSignalAlt4, faSignalBarsStrong, faDiamondExclamation, faStar, faDialMin, faRepeat, faCross, faPageCaretDown, faFileCaretDown, faBox, faVenusMars, faClockSevenThirty, faArrowPointer, faMousePointer, faClockFourThirty, faSignalBarsGood, faSignalAlt3, faCactus, faLightbulbGear, faMaximize, faExpandArrowsAlt, faChargingStation, faShapes, faTriangleCircleSquare, faPlaneTail, faGaugeSimpleMax, faTachometerFastest, faCircleU, faShieldSlash, faSquarePhoneHangup, faPhoneSquareDown, faArrowUpLeft, faTransporter1, faPeanuts, faShuffle, faRandom, faPersonRunning, faRunning, faMobileRetro, faGripLinesVertical, faBinBottlesRecycle, faArrowUpFromSquare, faFileDashedLine, faPageBreak, faBracketCurlyRight, faSpider, faClockThree, faHandsBound, faScalpelLineDashed, faScalpelPath, faFileInvoiceDollar, faPipeSmoking, faFaceAstonished, faWindow, faPlaneCircleExclamation, faEar, faFileLock, faDiagramVenn, faXRay, faGoalNet, faCoffinCross, faSpellCheck, faLocationXmark, faMapMarkerTimes, faMapMarkerXmark, faCircleQuarterStroke, faLasso, faSlash, faPersonToPortal, faPortalEnter, faCalendarStar, faComputerMouse, faMouse, faArrowRightToBracket, faSignIn, faPegasus, faFilesMedical, faNfcLock, faPersonSkiLift, faSkiLift, faSquare6, faShopSlash, faStoreAltSlash, faWindTurbine, faSlidersSimple, faGridRound, faBadgeSheriff, faServer, faVirusCovidSlash, faIntersection, faShopLock, faFamily, faHourglassStart, faHourglass1, faUserHairBuns, faBlenderPhone, faHourglassClock, faPersonSeatReclined, faPaperPlaneTop, faPaperPlaneAlt, faSend, faMessageArrowUp, faCommentAltArrowUp, faLightbulbExclamation, faLayerMinus, faLayerGroupMinus, faChartPieSimpleCircleCurrency, faCircleE, faBuildingWheat, faGaugeMax, faTachometerAltFastest, faPersonBreastfeeding, faApostrophe, faFireHydrant, faRightToBracket, faSignInAlt, faVideoPlus, faSquareRight, faArrowAltSquareRight, faCommentSmile, faVenus, faPassport, faInboxIn, faInboxArrowDown, faHeartPulse, faHeartbeat, faCircle8, faCloudsMoon, faClockTenThirty, faPeopleCarryBox, faPeopleCarry, faFolderUser, faTrashCanXmark, faTemperatureHigh, faMicrochip, faLeftLongToLine, faCrown, faWeightHanging, faXmarksLines, faFilePrescription, faCalendarRange, faFlowerDaffodil, faHandBackPointUp, faWeightScale, faWeight, faStarExclamation, faBooks, faUserGroup, faUserFriends, faArrowUpAZ, faSortAlphaUp, faLayerPlus, faLayerGroupPlus, faPlayPause, faBlockQuestion, faSnooze, faZzz, faScannerImage, faTvRetro, faSquareT, faFarm, faBarnSilo, faChessKnight, faBarsSort, faPalletBoxes, faPaletteBoxes, faPalletAlt, faFaceLaughSquint, faLaughSquint, faCodeSimple, faBoltSlash, faPanelFire, faBinaryCircleCheck, faCommentMinus, faBurrito, faViolin, faObjectsColumn, faSquareChevronDown, faChevronSquareDown, faCommentPlus, faTriangleInstrument, faTriangleMusic, faWheelchair, faUserPilotTie, faPianoKeyboard, faBedEmpty, faCircleArrowUp, faArrowCircleUp, faToggleOn, faRectangleVertical, faRectanglePortrait, faPersonWalking, faWalking, faL, faSignalStream, faDownToBracket, faCircleZ, faStars, faFire, faBedPulse, faProcedures, faHouseDay, faShuttleSpace, faSpaceShuttle, faShirtLongSleeve, faChartPieSimple, faChartPieAlt, faFaceLaugh, faLaugh, faFolderOpen, faAlbumCollectionCircleUser, faCandy, faBowlHot, faSoup, faFlatbread, faHeartCirclePlus, faCodeFork, faCity, faSignalBarsWeak, faSignalAlt1, faMicrophoneLines, faMicrophoneAlt, faClockTwelve, faPepperHot, faCitrusSlice, faSheep, faUnlock, faColonSign, faHeadset, faBadgerHoney, faH4, faStoreSlash, faRoadCircleXmark, faSignalSlash, faUserMinus, faMarsStrokeUp, faMarsStrokeV, faChampagneGlasses, faGlassCheers, faTaco, faHexagonPlus, faPlusHexagon, faClipboard, faHouseCircleExclamation, faFileArrowUp, faFileUpload, faWifi, faWifi3, faWifiStrong, faMessages, faCommentsAlt, faBath, faBathtub, faUmbrellaSimple, faUmbrellaAlt, faRectangleHistoryCirclePlus, faUnderline, faPrescriptionBottlePill, faUserPen, faUserEdit, faBinarySlash, faSquareO, faSignature, faStroopwafel, faBold, faAnchorLock, faBuildingNgo, faTransporter3, faEngineWarning, faEngineExclamation, faCircleDownRight, faSquareK, faManatSign, faMoneyCheckPen, faMoneyCheckEdit, faNotEqual, faBorderTopLeft, faBorderStyle, faMapLocationDot, faMapMarkedAlt, faTilde, faJedi, faSquarePollVertical, faPoll, faArrowDownSquareTriangle, faSortShapesDownAlt, faMugHot, faDogLeashed, faCarBattery, faBatteryCar, faFaceDowncastSweat, faMailboxFlagUp, faMemoCircleInfo, faGift, faDiceTwo, faVolume, faVolumeMedium, faTransporter5, faGaugeCircleBolt, faCoinFront, faFileSlash, faMessageArrowUpRight, faTreasureChest, faChessQueen, faPaintbrushFine, faPaintBrushAlt, faPaintBrushFine, faPaintbrushAlt, faGlasses, faHoodCloak, faSquareQuote, faUpLeft, faBringFront, faChessBoard, faBurgerCheese, faCheeseburger, faBuildingCircleCheck, faRepeat1, faArrowDownToLine, faArrowToBottom, faGrid5, faRightLongToLine, faPersonChalkboard, faMarsStrokeRight, faMarsStrokeH, faHandBackFist, faHandRock, faGridRound5, faTally, faTally5, faSquareCaretUp, faCaretSquareUp, faCloudShowersWater, faChartBar, faBarChart, faHandsBubbles, faHandsWash, faLessThanEqual, faTrain, faUpFromDottedLine, faEyeLowVision, faLowVision, faTrafficLightGo, faFaceExhaling, faSensorFire, faUserUnlock, faHexagonDivide, fa00, faCrow, faCassetteBetamax, faBetamax, faSailboat, faWindowRestore, faNfcMagnifyingGlass, faFileBinary, faCircleV, faSquarePlus, faPlusSquare, faBowlScoops, faMistletoe, faCustard, faLacrosseStick, faHockeyMask, faSunrise, faPanelEws, faToriiGate, faCloudExclamation, faMessageLines, faCommentAltLines, faFrog, faBucket, faFloppyDiskPen, faWindowFrame, faMicrophone, faCow, faFileZip, faSquareRing, faDownFromLine, faArrowAltFromTop, faCaretUp, faShieldXmark, faShieldTimes, faScrewdriver, faCircleSortDown, faSortCircleDown, faFolderClosed, faHouseTsunami, faSquareNfi, faForklift, faArrowUpFromGroundWater, faBracketSquareRight, faMartiniGlass, faGlassMartiniAlt, faRotateLeft, faRotateBack, faRotateBackward, faUndoAlt, faTableColumns, faColumns, faSquareA, faTick, faLemon, faHeadSideMask, faHandshake, faGem, faDolly, faDollyBox, faSmoking, faMinimize, faCompressArrowsAlt, faRefrigerator, faMonument, faOctagonXmark, faTimesOctagon, faXmarkOctagon, faAlignSlash, faSnowplow, faAnglesRight, faAngleDoubleRight, faTruckRampCouch, faTruckCouch, faCannabis, faCirclePlay, faPlayCircle, faArrowUpRightAndArrowDownLeftFromCenter, faTablets, fa360Degrees, faEthernet, faEuroSign, faEur, faEuro, faChair, faCircleCheck, faSquareDashedCirclePlus, faMoneySimpleFromBracket, faBat, faCircleStop, faStopCircle, faHeadSideHeadphones, faPhoneRotary, faCompassDrafting, faDraftingCompass, faPlateWheat, faCalendarCircleMinus, faChopsticks, faCarWrench, faCarMechanic, faIcicles, faPersonShelter, faNeuter, faIdBadge, faKazoo, faMarker, faBinBottles, faFaceLaughBeam, faLaughBeam, faSquareArrowDownLeft, faBatteryBolt, faTreeLarge, faHelicopterSymbol, faAperture, faUniversalAccess, faGearComplex, faFileMagnifyingGlass, faFileSearch, faUpRight, faCircleChevronUp, faChevronCircleUp, faUserPolice, faLariSign, faVolcano, faTeddyBear, faStocking, faPersonWalkingDashedLineArrowRight, faImageSlash, faMaskSnorkel, faSmoke, faSterlingSign, faGbp, faPoundSign, faBatteryExclamation, faViruses, faSquarePersonConfined, faUserTie, faArrowDownLong, faLongArrowDown, faTentArrowDownToLine, faCertificate, faCrystalBall, faReplyAll, faMailReplyAll, faSuitcase, faPersonSkating, faSkating, faStarShooting, faBinaryLock, faFilterCircleDollar, faFunnelDollar, faCameraRetro, faCircleArrowDown, faArrowCircleDown, faCommentPen, faCommentEdit, faFileImport, faArrowRightToFile, faBanjo, faSquareArrowUpRight, faExternalLinkSquare, faLightEmergencyOn, faKerning, faBoxOpen, faSquareF, faScroll, faSpa, faArrowLeftFromLine, faArrowFromRight, faStrawberry, faLocationPinLock, faPause, faClockEightThirty, faPlaneEngines, faPlaneAlt, faHillAvalanche, faTemperatureEmpty, faTemperature0, faThermometer0, faThermometerEmpty, faBomb, faGaugeLow, faTachometerAltSlow, faRegistered, faTrashCanPlus, faAddressCard, faContactCard, faVcard, faScaleUnbalancedFlip, faBalanceScaleRight, faGlobeSnow, faSubscript, faDiamondTurnRight, faDirections, faIntegral, faBurst, faHouseLaptop, faLaptopHouse, faFaceTired, faTired, faMoneyBills, faBlindsRaised, faSmog, faUfoBeam, faCircleCaretUp, faCaretCircleUp, faUserVneckHairLong, faSquareALock, faCrutch, faGasPumpSlash, faFontAwesome, faFontAwesomeFlag, faFontAwesomeLogoFull, faCloudArrowUp, faCloudUploadAlt, faPalette, faTransporter4, faChartMixedUpCircleCurrency, faObjectsAlignRight, faArrowsTurnRight, faVest, faPig, faInboxFull, faCircleEnvelope, faEnvelopeCircle, faTrianglePersonDigging, faConstruction, faFerry, faBullseyeArrow, faArrowsDownToPeople, faSeedling, faSprout, faClockSeven, faLeftRight, faArrowsAltH, faBoxesPacking, faCircleArrowLeft, faArrowCircleLeft, faFlashlight, faGroupArrowsRotate, faBowlFood, faSquare9, faCandyCane, faArrowDownWideShort, faSortAmountAsc, faSortAmountDown, faSquareDollar, faDollarSquare, faUsdSquare, faPhoneArrowRight, faHandHoldingSeedling, faMessageCheck, faCommentAltCheck, faCloudBolt, faThunderstorm, faChartLineUpDown, faTextSlash, faRemoveFormat, faWatch, faCircleDownLeft, faText, faProjector, faFaceSmileWink, faSmileWink, faTombstoneBlank, faTombstoneAlt, faChessKingPiece, faChessKingAlt, faCircle6, faLeft, faArrowAltLeft, faFileWord, faFilePowerpoint, faSquareDown, faArrowAltSquareDown, faObjectsAlignCenterVertical, faArrowsLeftRight, faArrowsH, faHouseLock, faCloudArrowDown, faCloudDownload, faCloudDownloadAlt, faWreath, faChildren, faMeterDroplet, faChalkboard, faBlackboard, faUserLargeSlash, faUserAltSlash, faSignalStrong, faSignal4, faLollipop, faLollypop, faListTree, faEnvelopeOpen, faDrawCircle, faCatSpace, faHandshakeSimpleSlash, faHandshakeAltSlash, faRabbitRunning, faRabbitFast, faMemoPad, faMattressPillow, faAlarmPlus, faAlicorn, faCommentQuestion, faGingerbreadMan, faGuaraniSign, faBurgerFries, faMugTea, faBorderTop, faArrowsRotate, faRefresh, faSync, faCircleBookOpen, faBookCircle, faArrowsToDottedLine, faFireExtinguisher, faGarageOpen, faShelvesEmpty, faCruzeiroSign, faWatchApple, faWatchCalculator, faListDropdown, faCabinetFiling, faBurgerSoda, faSquareArrowUp, faArrowSquareUp, faGreaterThanEqual, faPalletBox, faFaceConfounded, faShieldHalved, faShieldAlt, faTruckPlow, faBookAtlas, faAtlas, faVirus, faGridRound2, faCommentMiddleTop, faEnvelopeCircleCheck, faLayerGroup, faRestroomSimple, faArrowsToDot, faBorderOuter, faHashtagLock, faClockTwoThirty, faArchway, faHeartCircleCheck, faHouseChimneyCrack, faHouseDamage, faFileZipper, faFileArchive, faHeartHalf, faCommentCheck, faSquare, faMemo, faMartiniGlassEmpty, faGlassMartini, faCouch, faCediSign, faItalic, faGlassCitrus, faCalendarLinesPen, faChurch, faPersonSnowmobiling, faSnowmobile, faFaceHushed, faCommentsDollar, faPickaxe, faLinkSimpleSlash, faDemocrat, faFaceConfused, faPinball, faZ, faPersonSkiing, faSkiing, faDeer, faInputPipe, faRoadLock, faA, faBookmarkSlash, faTemperatureArrowDown, faTemperatureDown, faMace, faFeatherPointed, faFeatherAlt, faSausage, faTrashCanClock, faP, faBroomWide, faSnowflake, faStomach, faNewspaper, faRectangleAd, faAd, faGuitarElectric, faArrowTurnDownRight, faMoonCloud, faBreadSliceButter, faCircleArrowRight, faArrowCircleRight, faUserGroupCrown, faUsersCrown, faCircleI, faToiletPaperCheck, faFilterCircleXmark, faLocust, faSort, faUnsorted, faListOl, faList12, faListNumeric, faChartWaterfall, faSparkle, faFaceParty, faKidneys, faWifiExclamation, faChartNetwork, faPersonDressBurst, faDiceD4, faMoneyCheckDollar, faMoneyCheckAlt, faVectorSquare, faBreadSlice, faLanguage, faWheatAwnSlash, faFaceKissWinkHeart, faKissWinkHeart, faDagger, faPodium, faMemoCircleCheck, faRouteHighway, faDownToLine, faArrowAltToBottom, faFilter, faSquareG, faCirclePhone, faPhoneCircle, faClipboardPrescription, faUserNurseHair, faQuestion, faFileSignature, faToggleLargeOn, faUpDownLeftRight, faArrowsAlt, faDryerHeat, faDryerAlt, faHouseChimneyUser, faHandHoldingHeart, faArrowUpSmallBig, faSortSizeUpAlt, faTrainTrack, faPuzzlePiece, faMoneyCheck, faStarHalfStroke, faStarHalfAlt, faFileExclamation, faCode, faWhiskeyGlass, faGlassWhiskey, faMoonStars, faBuildingCircleExclamation, faClothesHanger, faMobileNotch, faMobileIphone, faMagnifyingGlassChart, faArrowUpRightFromSquare, faExternalLink, faCubesStacked, faImagesUser, faWonSign, faKrw, faWon, faImagePolaroidUser, faVirusCovid, faSquareEllipsis, faPie, faChessKnightPiece, faChessKnightAlt, faAustralSign, faCloudPlus, faF, faLeaf, faBedBunk, faRoad, faTaxi, faCab, faPersonCirclePlus, faChartPie, faPieChart, faBoltLightning, faClockEight, faSackXmark, faFileExcel, faFileContract, faFishFins, faCircleQ, faBuildingFlag, faFaceGrinBeam, faGrinBeam, faObjectUngroup, faFaceDisguise, faCircleArrowDownRight, faAlien8bit, faAlienMonster, faHandPointRibbon, faPoop, faObjectExclude, faTelescope, faLocationPin, faMapMarker, faSquareList, faKaaba, faToiletPaper, faHelmetSafety, faHardHat, faHatHard, faCommentCode, faSimCards, faStarship, faEject, faCircleRight, faArrowAltCircleRight, faPlaneCircleCheck, faSeal, faUserCowboy, faHexagonVerticalNft, faFaceRollingEyes, faMehRollingEyes, faBreadLoaf, faRingsWedding, faObjectGroup, faFrenchFries, faChartLine, faLineChart, faCalendarArrowDown, faCalendarDownload, faSendBack, faMaskVentilator, faSignatureLock, faArrowRight, faSignsPost, faMapSigns, faOctagonPlus, faPlusOctagon, faCashRegister, faPersonCircleQuestion, faMelonSlice, faSpaceStationMoon, faMessageSmile, faCommentAltSmile, faCupStraw, faLeftFromLine, faArrowAltFromRight, faH, faBasketShoppingSimple, faShoppingBasketAlt, faHandsHoldingHeart, faHandsHeart, faClockNine, faTarp, faFaceSleepy, faHandHorns, faScrewdriverWrench, faTools, faArrowsToEye, faCircleThreeQuarters, faTrophyStar, faTrophyAlt, faPlugCircleBolt, faFaceThermometer, faGridRound4, faShirtRunning, faBookCircleArrowUp, faFaceNauseated, faHeart, faFileChartPie, faMarsAndVenus, faHouseUser, faHomeUser, faCircleArrowDownLeft, faDumpsterFire, faHexagonMinus, faMinusHexagon, faLeftToLine, faArrowAltToLeft, faHouseCrack, faPawSimple, faPawAlt, faArrowLeftLongToLine, faBracketsRound, faParentheses, faMartiniGlassCitrus, faCocktail, faUserShakespeare, faArrowRightToArc, faFaceSurprise, faSurprise, faBottleWater, faCirclePause, faPauseCircle, faGaugeCirclePlus, faFolders, faAngel, faValueAbsolute, faRabbit, faToiletPaperSlash, faCircleEuro, faAppleWhole, faAppleAlt, faKitchenSet, faDiamondHalf, faLockKeyhole, faLockAlt, faR, faTemperatureQuarter, faTemperature1, faThermometer1, faThermometerQuarter, faSquareInfo, faInfoSquare, faWifiSlash, faToiletPaperXmark, faHandsHoldingDollar, faHandsUsd, faCube, faArrowDownTriangleSquare, faSortShapesDown, faBitcoinSign, faShutters, faShieldDog, faSolarPanel, faLockOpen, faTableTree, faHouseChimneyHeart, faTally3, faElevator, faMoneyBillTransfer, faMoneyBillTrendUp, faHouseFloodWaterCircleArrowRight, faSquarePollHorizontal, faPollH, faCircle, faCartCircleExclamation, faSword, faBackwardFast, faFastBackward, faRecycle, faUserAstronaut, faInterrobang, faPlaneSlash, faCircleDashed, faTrademark, faBasketball, faBasketballBall, faForkKnife, faUtensilsAlt, faSatelliteDish, faBadgeCheck, faCircleUp, faArrowAltCircleUp, faSlider, faMobileScreenButton, faMobileAlt, faClockOneThirty, faInboxOut, faInboxArrowUp, faCloudSlash, faVolumeHigh, faVolumeUp, faUsersRays, faWallet, faOctagonCheck, faFlatbreadStuffed, faClipboardCheck, faCartCirclePlus, faTruckClock, faShippingTimed, faPool8Ball, faFileAudio, faTurnDownLeft, faLockHashtag, faChartRadar, faStaff, faBurger, faHamburger, faUtilityPole, faTransporter6, faWrench, faBugs, faVectorPolygon, faDiagramNested, faRupeeSign, faRupee, faFileImage, faCircleQuestion, faImageUser, faBuoy, faPlaneDeparture, faHandshakeSlash, faBookBookmark, faBorderCenterH, faCanFood, faTypewriter, faArrowRightFromArc, faCircleK, faFaceHandOverMouth, faPopcorn, faHouseWater, faHouseFlood, faObjectSubtract, faCodeBranch, faWarehouseFull, faWarehouseAlt, faHatCowboy, faBridge, faPhoneFlip, faPhoneAlt, faArrowDownFromDottedLine, faFileDoc, faSquareQuarters, faTruckFront, faCat, faTrashXmark, faCircleCaretLeft, faCaretCircleLeft, faFiles, faAnchorCircleExclamation, faFaceClouds, faUserCrown, faTruckField, faRoute, faCartCircleCheck, faClipboardQuestion, faPanorama, faCommentMedical, faTeethOpen, faUserTieHairLong, faFileCircleMinus, faHeadSideMedical, faTags, faWineGlass, faForwardFast, faFastForward, faFaceMehBlank, faMehBlank, faUserRobot, faSquareParking, faParking, faCardDiamond, faFaceZipper, faFaceRaisedEyebrow, faHouseSignal, faSquareChevronUp, faChevronSquareUp, faNfcSymbol, faBarsProgress, faTasksAlt, faFaucetDrip, faArrowsToLine, faDolphin, faArrowUpRight, faCircleR, faCartFlatbed, faDollyFlatbed, faBanSmoking, faSmokingBan, faCircleSortUp, faSortCircleUp, faTerminal, faMobileButton, faHouseMedicalFlag, faBasketShopping, faShoppingBasket, faTape, faChestnut, faBusSimple, faBusAlt, faEye, faFaceSadCry, faSadCry, faHeat, faTicketAirline, faBootHeeled, faArrowsMinimize, faCompressArrows, faAudioDescription, faPersonMilitaryToPerson, faFileShield, faHexagon, faManhole, faUserSlash, faPen, faTowerObservation, faFloppyDisks, faToiletPaperBlankUnder, faToiletPaperReverseAlt, faFileCode, faSignal, faSignal5, faSignalPerfect, faPump, faBus, faHeartCircleXmark, faArrowUpLeftFromCircle, faHouseChimney, faHomeLg, faWindowMaximize, faDryer, faFaceFrown, faFrown, faChessBishopPiece, faChessBishopAlt, faShirtTankTop, faDiploma, faScrollRibbon, faScreencast, faWalker, faPrescription, faShop, faStoreAlt, faFloppyDisk, faSave, faVihara, faFaceKissClosedEyes, faScaleUnbalanced, faBalanceScaleLeft, faFileUser, faUserPoliceTie, faFaceTongueMoney, faTennisBall, faSquareL, faSortUp, faSortAsc, faCalendarArrowUp, faCalendarUpload, faCommentDots, faCommenting, faPlantWilt, faScarf, faAlbumCirclePlus, faUserNurseHairLong, faDiamond, faSquareLeft, faArrowAltSquareLeft, faFaceGrinSquint, faGrinSquint, faCircleEllipsisVertical, faHandHoldingDollar, faHandHoldingUsd, faGridDividers, faBacterium, faHandPointer, faDrumSteelpan, faHandScissors, faHandsPraying, faPrayingHands, faFacePensive, faUserMusic, faArrowRotateRight, faArrowRightRotate, faArrowRotateForward, faRedo, faMessagesDollar, faCommentsAltDollar, faSensorOn, faBalloon, faBiohazard, faChessQueenPiece, faChessQueenAlt, faLocationCrosshairs, faLocation, faMarsDouble, faHousePersonLeave, faHouseLeave, faHousePersonDepart, faRulerTriangle, faCardClub, faChildDress, faUsersBetweenLines, faLungsVirus, faSpinnerThird, faFaceGrinTears, faGrinTears, faPhone, faComputerMouseScrollwheel, faMouseAlt, faCalendarXmark, faCalendarTimes, faChildReaching, faTableLayout, faNarwhal, faRampLoading, faCalendarCirclePlus, faToothbrush, faBorderInner, faPawClaws, faKiwiFruit, faTrafficLightSlow, faRectangleCode, faHeadSideVirus, faKeyboardBrightness, faBooksMedical, faLightbulbSlash, faHouseBlank, faHomeBlank, faSquare5, faSquareHeart, faHeartSquare, faPuzzle, faUserGear, faUserCog, faPipeCircleCheck, faArrowUp19, faSortNumericUp, faOctagonExclamation, faDialLow, faDoorClosed, faLaptopMobile, faPhoneLaptop, faConveyorBeltBoxes, faConveyorBeltAlt, faShieldVirus, faStarfighterTwinIonEngineAdvanced, faStarfighterAltAdvanced, faDiceSix, faStarfighterTwinIonEngine, faStarfighterAlt, faRocketLaunch, faMosquitoNet, faVentDamper, faBridgeWater, faBanBug, faDebug, faPersonBooth, faTextWidth, faGarageCar, faSquareKanban, faHatWizard, faPenFancy, faCoffeePot, faMouseField, faPersonDigging, faDigging, faShowerDown, faShowerAlt, faBoxCircleCheck, faBrightness, faCarSideBolt, faOrnament, faPhoneArrowDownLeft, faPhoneArrowDown, faPhoneIncoming, faCloudWord, faHandFingersCrossed, faTrash, faGaugeSimple, faGaugeSimpleMed, faTachometerAverage, faArrowDownSmallBig, faSortSizeDownAlt, faBookMedical, faFaceMelting, faPoo, faPenClipSlash, faPenAltSlash, faQuoteRight, faQuoteRightAlt, faScrollOld, faGuitars, faPhoneXmark, faHose, faClockSix, faShirt, faTShirt, faTshirt, faBillboard, faSquareR, faCubes, faEnvelopeOpenDollar, faDivide, faSunCloud, faLampFloor, faSquare7, faTengeSign, faTenge, faHeadphones, faHandsHolding, faCampfire, faCircleAmpersand, faSnowflakes, faHandsClapping, faRepublican, faLeafMaple, faArrowLeft, faPersonCircleXmark, faRuler, faCupStrawSwoosh, faTemperatureSun, faTemperatureHot, faAlignLeft, faDiceD6, faRestroom, faHighDefinition, faRectangleHd, faJ, faGalaxy, faUsersViewfinder, faFileVideo, faCherries, faUpRightFromSquare, faExternalLinkAlt, faCircleSort, faSortCircle, faTableCells, faTh, faSiren, faArrowUpToDottedLine, faImageLandscape, faLandscape, faTankWater, faCurlingStone, faCurling, faGamepadModern, faGamepadAlt, faMessagesQuestion, faBookBible, faBible, faO, faSuitcaseMedical, faMedkit, faBriefcaseArrowRight, faExpandWide, faClockElevenThirty, faRv, faUserSecret, faOtter, faDreidel, faPersonDress, faFemale, faCommentDollar, faBusinessTime, faBriefcaseClock, faFlowerTulip, faPeoplePantsSimple, faCloudDrizzle, faTableCellsLarge, faThLarge, faBookTanakh, faTanakh, faSolarSystem, faSealQuestion, faPhoneVolume, faVolumeControlPhone, faDiscDrive, faHatCowboySide, faTableRows, faRows, faLocationExclamation, faMapMarkerExclamation, faFaceFearful, faClipboardUser, faBusSchool, faFilmSlash, faSquareArrowDownRight, faBookSparkles, faBookSpells, faWashingMachine, faWasher, faChild, faLiraSign, faUserVisor, faFilePlusMinus, faChessClockFlip, faChessClockAlt, faSatellite, faPlaneLock, faSteeringWheel, faTag, faStretcher, faBookSection, faBookLaw, faInboxes, faCoffeeBean, faCircleYen, faBracketsCurly, faEllipsisStrokeVertical, faEllipsisVAlt, faComment, faSquare1, faCakeCandles, faBirthdayCake, faCake, faHeadSide, faEnvelope, faDollyEmpty, faFaceTissue, faAnglesUp, faAngleDoubleUp, faBinRecycle, faPaperclip, faChartLineDown, faArrowRightToCity, faLockA, faRibbon, faLungs, faPersonPinball, faArrowUp91, faSortNumericUpAlt, faAppleCore, faCircleY, faH6, faLitecoinSign, faCircleSmall, faBorderNone, faArrowTurnDownLeft, faCircleNodes, faParachuteBox, faMessageMedical, faCommentAltMedical, faRugbyBall, faCommentMusic, faIndent, faTreeDeciduous, faTreeAlt, faPuzzlePieceSimple, faPuzzlePieceAlt, faTruckFieldUn, faNfcTrash, faHourglass, faHourglassEmpty, faMountain, faFileXmark, faFileTimes, faHouseHeart, faHomeHeart, faHouseChimneyBlank, faMeterBolt, faUserDoctor, faUserMd, faSlashBack, faCircleInfo, faInfoCircle, faFishingRod, faHammerCrash, faMessageHeart, faCloudMeatball, faCameraPolaroid, faCamera, faSquareVirus, faCartArrowUp, faMeteor, faCarOn, faSleigh, faArrowDown19, faSortNumericAsc, faSortNumericDown, faBuoyMooring, faSquare4, faHandHoldingDroplet, faHandHoldingWater, faTricycleAdult, faWaveform, faWater, faStarSharpHalfStroke, faStarSharpHalfAlt, faNfcSignal, faPlaneProp, faCalendarCheck, faClockDesk, faCalendarClock, faCalendarTime, faBraille, faPrescriptionBottleMedical, faPrescriptionBottleAlt, faPlateUtensils, faFamilyPants, faHoseReel, faHouseWindow, faLandmark, faTruck, faCrosshairs, faCloudRainbow, faPersonCane, faAlien, faTent, faLaptopBinary, faVestPatches, faPeopleDressSimple, faCheckDouble, faArrowDownAZ, faSortAlphaAsc, faSortAlphaDown, faBowlingBallPin, faBellSchoolSlash, faPlusLarge, faMoneyBillWheat, faCameraViewfinder, faScreenshot, faMessageMusic, faCommentAltMusic, faCarBuilding, faBorderBottomRight, faBorderStyleAlt, faOctagon, faCommentArrowUpRight, faOctagonDivide, faCookie, faArrowRotateLeft, faArrowLeftRotate, faArrowRotateBack, faArrowRotateBackward, faUndo, faTvMusic, faHardDrive, faHdd, faReel, faFaceGrinSquintTears, faGrinSquintTears, faDumbbell, faRectangleList, faListAlt, faTarpDroplet, faAlarmExclamation, faHouseMedicalCircleCheck, faTrafficCone, faGrate, faArrowDownRight, faPersonSkiingNordic, faSkiingNordic, faCalendarPlus, faPersonFromPortal, faPortalExit, faPlaneArrival, faCowbellCirclePlus, faCowbellMore, faCircleLeft, faArrowAltCircleLeft, faDistributeSpacingVertical, faSignalBarsFair, faSignalAlt2, faSportsball, faGameConsoleHandheldCrank, faTrainSubway, faSubway, faChartGantt, faFaceSmileUpsideDown, faBallPile, faBadgeDollar, faMoneyBillsSimple, faMoneyBillsAlt, faListTimeline, faIndianRupeeSign, faIndianRupee, faInr, faCropSimple, faCropAlt, faMoneyBill1, faMoneyBillAlt, faLeftLong, faLongArrowAltLeft, faKeyboardDown, faCircleUpRight, faCloudBoltMoon, faThunderstormMoon, faDna, faVirusSlash, faBracketRoundRight, faCircleSterling, faCircle5, faMinus, faSubtract, faFireFlame, faFlame, faRightToLine, faArrowAltToRight, faGif, faChess, faTrashSlash, faArrowLeftLong, faLongArrowLeft, faPlugCircleCheck, faFontCase, faStreetView, faArrowDownLeft, faFrancSign, faFlaskRoundPoison, faFlaskPoison, faVolumeOff, faBookCircleArrowRight, faChartUser, faUserChart, faHandsAslInterpreting, faAmericanSignLanguageInterpreting, faAslInterpreting, faHandsAmericanSignLanguageInterpreting, faPresentationScreen, faPresentation, faCircleBolt, faFaceSmileHalo, faCartCircleArrowDown, faHousePersonReturn, faHousePersonArrive, faHouseReturn, faMessageXmark, faCommentAltTimes, faMessageTimes, faFileCertificate, faFileAward, faUserDoctorHairLong, faCameraSecurity, faCameraHome, faGear, faCog, faDropletSlash, faTintSlash, faBookHeart, faMosque, faDuck, faMosquito, faStarOfDavid, faFlagSwallowtail, faFlagAlt, faPersonMilitaryRifle, faCarGarage, faCartShopping, faShoppingCart, faBookFont, faShieldPlus, faVials, faEyeDropperFull, faDistributeSpacingHorizontal, faTabletRugged, faTemperatureSnow, faTemperatureFrigid, faMoped, faFaceSmilePlus, faSmilePlus, faRadioTuner, faRadioAlt, faFaceSwear, faWaterArrowDown, faWaterLower, faScannerTouchscreen, faCircle7, faPlugCirclePlus, faPersonSkiJumping, faSkiJump, faPlaceOfWorship, faWaterArrowUp, faWaterRise, faWaveformLines, faWaveformPath, faSplit, faFilmCanister, faFilmCannister, faFolderXmark, faFolderTimes, faToiletPaperBlank, faToiletPaperAlt, faTabletScreen, faTabletAndroidAlt, faHexagonVerticalNftSlanted, faFolderMusic, faDisplayMedical, faDesktopMedical, faShareAll, faPeapod, faChessClock, faAxe, faSquareD, faGripVertical, faMobileSignalOut, faArrowTurnUp, faLevelUp, faU, faArrowUpFromDottedLine, faSquareRootVariable, faSquareRootAlt, faLightSwitchOn, faArrowDownArrowUp, faSortAlt, faRaindrops, faDash, faMinusLarge, faClockFour, faInputNumeric, faTruckTow, faBackwardStep, faStepBackward, faPallet, faCarBolt, faArrowsMaximize, faExpandArrows, faFaucet, faCloudSleet, faLampStreet, faListRadio, faPenNibSlash, faBaseballBatBall, faSquareUpLeft, faOverline, faS, faTimeline, faKeyboard, faArrowsFromDottedLine, faUsbDrive, faBallot, faCaretDown, faLocationDotSlash, faMapMarkerAltSlash, faCards, faHouseChimneyMedical, faClinicMedical, faBoxingGlove, faGloveBoxing, faTemperatureThreeQuarters, faTemperature3, faThermometer3, faThermometerThreeQuarters, faBellSchool, faMobileScreen, faMobileAndroidAlt, faPlaneUp, faFolderHeart, faCircleLocationArrow, faLocationCircle, faFaceHeadBandage, faSushiRoll, faMakiRoll, faMakizushi, faCarBump, faPiggyBank, faRacquet, faCarMirrors, faIndustryWindows, faIndustryAlt, faBoltAuto, faBatteryHalf, faBattery3, faFluxCapacitor, faMountainCity, faCoins, faHoneyPot, faOlive, faKhanda, faFilterList, faOutlet, faSliders, faSlidersH, faCauldron, faPeople, faFolderTree, faNetworkWired, faCroissant, faMapPin, faHamsa, faCentSign, faSwordsLaser, faFlask, faPersonPregnant, faSquareU, faWandSparkles, faRouter, faEllipsisVertical, faEllipsisV, faSwordLaserAlt, faTicket, faPowerOff, faCoin, faLaptopSlash, faRightLong, faLongArrowAltRight, faCircleB, faPersonDressSimple, faPipeCollar, faLightsHoliday, faCitrus, faFlagUsa, faLaptopFile, faTty, faTeletype, faChartTreeMap, faDiagramNext, faPersonRifle, faClockFiveThirty, faPipeValve, faArrowUpFromArc, faFaceSpiralEyes, faCompressWide, faCirclePhoneHangup, faPhoneCircleDown, faGearComplexCode, faHouseMedicalCircleExclamation, faBadminton, faClosedCaptioning, faPersonHiking, faHiking, faRightFromLine, faArrowAltFromLeft, faVenusDouble, faImages, faCalculator, faShuttlecock, faUserHair, faEyeEvil, faPeoplePulling, faN, faGarage, faCableCar, faTram, faShovelSnow, faCloudRain, faFaceLying, faSprinkler, faBuildingCircleXmark, faPersonSledding, faSledding, faGameConsoleHandheld, faShip, faClockSixThirty, faBatterySlash, faTugrikSign, faArrowsDownToLine, faDownload, faShelves, faInventory, faCloudSnow, faFaceGrin, faGrin, faDeleteLeft, faBackspace, faOven, faCloudBinary, faEyeDropper, faEyeDropperEmpty, faEyedropper, faCommentCaptions, faCommentsQuestion, faScribble, faRotateExclamation, faFileCircleCheck, faGlass, faLoader, faForward, faUserPilot, faMobile, faMobileAndroid, faMobilePhone, faCodePullRequestClosed, faFaceMeh, faMeh, faAlignCenter, faBookSkull, faBookDead, faIdCard, faDriversLicense, faFaceDotted, faFaceWorried, faOutdent, faDedent, faHeartCircleExclamation, faHouse, faHome, faHomeAlt, faHomeLgAlt, faVectorCircle, faCarCircleBolt, faCalendarWeek, faFlyingDisc, faLaptopMedical, faSquareDownRight, faB, faSeatAirline, faMoonOverSun, faEclipseAlt, faPipe, faFileMedical, faPotato, faDiceOne, faCircleA, faHelmetBattle, faButter, faBlanketFire, faKiwiBird, faCastle, faGolfClub, faArrowRightArrowLeft, faExchange, faRotateRight, faRedoAlt, faRotateForward, faUtensils, faCutlery, faArrowUpWideShort, faSortAmountUp, faChartPieSimpleCircleDollar, faBalloons, faMillSign, faBowlRice, faTimelineArrow, faSkull, faGameBoardSimple, faGameBoardAlt, faCircleVideo, faVideoCircle, faChartScatterBubble, faHouseTurret, faBanana, faHandHoldingSkull, faPeopleDress, faLoveseat, faCouchSmall, faTowerBroadcast, faBroadcastTower, faTruckPickup, faBlockQuote, faUpLong, faLongArrowAltUp, faStop, faCodeMerge, faMoneyCheckDollarPen, faMoneyCheckEditAlt, faUpFromLine, faArrowAltFromBottom, faUpload, faHurricane, faGridRound2Plus, faPeoplePants, faMound, faWindsock, faCircleHalf, faBrakeWarning, faToiletPortable, faCompactDisc, faFileArrowDown, faFileDownload, faSaxophoneFire, faSaxHot, faCameraWebSlash, faWebcamSlash, faFolderMedical, faFolderGear, faFolderCog, faHandWave, faArrowUpArrowDown, faSortUpDown, faCaravan, faShieldCat, faMessageSlash, faCommentAltSlash, faBolt, faZap, faTrashCanCheck, faGlassWater, faOilWell, faPersonSimple, faVault, faMars, faToilet, faPlaneCircleXmark, faYenSign, faCny, faJpy, faRmb, faYen, faGearCode, faNotes, faRubleSign, faRouble, faRub, faRuble, faTrashUndo, faTrashArrowTurnLeft, faChampagneGlass, faGlassChampagne, faObjectsAlignCenterHorizontal, faSun, faTrashCanSlash, faTrashAltSlash, faScreenUsers, faUsersClass, faGuitar, faSquareArrowLeft, faArrowSquareLeft, faSquare8, faFaceSmileHearts, faBracketsSquare, faBrackets, faLaptopArrowDown, faHockeyStickPuck, faHouseTree, faSignalFair, faSignal2, faFaceLaughWink, faLaughWink, faCircleDollar, faDollarCircle, faUsdCircle, faHorseHead, faArrowsRepeat, faRepeatAlt, faBoreHole, faIndustry, faImagePolaroid, faWaveTriangle, faPersonRunningFast, faCircleDown, faArrowAltCircleDown, faGrill, faArrowsTurnToDots, faChartMixed, faAnalytics, faFlorinSign, faArrowDownShortWide, faSortAmountDesc, faSortAmountDownAlt, faLessThan, faDisplayCode, faDesktopCode, faFaceDrooling, faOilTemperature, faOilTemp, faSquareQuestion, faQuestionSquare, faAirConditioner, faAngleDown, faMountains, faOmega, faCarTunnel, faPersonDollyEmpty, faPanFood, faHeadSideCough, faGripLines, faThumbsDown, faUserLock, faArrowRightLong, faLongArrowRight, faTicketsAirline, faAnchorCircleXmark, faEllipsis, faEllipsisH, faNfcSlash, faChessPawn, faKitMedical, faFirstAid, faGrid2Plus, faBells, faPersonThroughWindow, faToolbox, faEnvelopeDot, faEnvelopeBadge, faHandsHoldingCircle, faBug, faBowlChopsticks, faCreditCard, faCreditCardAlt, faCircleS, faBoxBallot, faCar, faAutomobile, faHandHoldingHand, faUserTieHair, faPodiumStar, faUserHairMullet, faBusinessFront, faPartyBack, faTrianBalbot, faMicrophoneStand, faBookOpenReader, faBookReader, faFamilyDress, faCircleX, faCabin, faMountainSun, faChartSimpleHorizontal, faBluetooth, faArrowsLeftRightToLine, faHandBackPointLeft, faMessageDots, faCommentAltDots, faMessaging, faFileHeart, faBeerMug, faBeerFoam, faDiceD20, faDrone, faTruckDroplet, faFileCircleXmark, faTemperatureArrowUp, faTemperatureUp, faMedal, faBed, faBookCopy, faSquareH, faHSquare, faSquareC, faClockTwo, faSquareEllipsisVertical, faCalendarUsers, faPodcast, faBee, faTemperatureFull, faTemperature4, faThermometer4, faThermometerFull, faBell, faCandyBar, faChocolateBar, faXmarkLarge, faPinata, faArrowsFromLine, faSuperscript, faBowlSpoon, faHexagonCheck, faPlugCircleXmark, faStarOfLife, faPhoneSlash, faTrafficLightStop, faPaintRoller, faAccentGrave, faHandshakeAngle, faHandsHelping, faCircle0, faDialMedLow, faLocationDot, faMapMarkerAlt, faCrab, faBoxOpenFull, faBoxFull, faGreaterThan, faQuotes, faPretzel, faPersonSwimming, faSwimmer, faArrowDown, faUserRobotXmarks, faMessageQuote, faCommentAltQuote, faCandyCorn, faFolderMagnifyingGlass, faFolderSearch, faNotebook, faDroplet, faTint, faBullseyePointer, faEraser, faHexagonImage, faEarthAmericas, faEarth, faEarthAmerica, faGlobeAmericas, faCrateApple, faAppleCrate, faPersonBurst, faGameBoard, faHatChef, faHandBackPointRight, faDove, faSnowflakeDroplets, faBatteryEmpty, faBattery0, faGrid4, faSocks, faFaceSunglasses, faInbox, faSquare0, faSection, faSquareThisWayUp, faBoxUp, faGaugeHigh, faTachometerAlt, faTachometerAltFast, faSquareAmpersand, faEnvelopeOpenText, faLampDesk, faHospital, faHospitalAlt, faHospitalWide, faPollPeople, faWhiskeyGlassIce, faGlassWhiskeyRocks, faWineBottle, faChessRook, faUserBountyHunter, faBarsStaggered, faReorder, faStream, faDiagramSankey, faCloudHailMixed, faCircleUpLeft, faDharmachakra, faObjectsAlignLeft, faOilCanDrip, faFaceSmilingHands, faBroccoli, faRouteInterstate, faEarMuffs, faHotdog, faTransporterEmpty, faPersonWalkingWithCane, faBlind, faAngle90, faRectangleTerminal, faKite, faDrum, faScrubber, faIceCream, faHeartCircleBolt, faFishBones, faDeerRudolph, faFax, faParagraph, faHeadSideHeart, faSquareE, faMeterFire, faCloudHail, faCheckToSlot, faVoteYea, faMoneyFromBracket, faStarHalf, faCarBus, faSpeaker, faTimer, faBoxesStacked, faBoxes, faBoxesAlt, faGrillHot, faLink, faChain, faEarListen, faAssistiveListeningSystems, faFileMinus, faTreeCity, faPlay, faFont, faCupTogo, faCoffeeTogo, faSquareDownLeft, faBurgerLettuce, faRupiahSign, faMagnifyingGlass, faSearch, faTableTennisPaddleBall, faPingPongPaddleBall, faTableTennis, faPersonDotsFromLine, faDiagnoses, faChevronsDown, faChevronDoubleDown, faTrashCanArrowUp, faTrashRestoreAlt, faSignalGood, faSignal3, faLocationQuestion, faMapMarkerQuestion, faFloppyDiskCircleXmark, faFloppyDiskTimes, faSaveCircleXmark, faSaveTimes, faNairaSign, faPeach, faTaxiBus, faBracketCurly, faBracketCurlyLeft, faLobster, faCartFlatbedEmpty, faDollyFlatbedEmpty, faColon, faCartArrowDown, faWand, faWalkieTalkie, faFilePen, faFileEdit, faReceipt, faTablePicnic, faSquarePen, faPenSquare, faPencilSquare, faCircleMicrophoneLines, faMicrophoneCircleAlt, faDisplaySlash, faDesktopSlash, faSuitcaseRolling, faPersonCircleExclamation, faTransporter2, faHandsHoldingDiamond, faHandReceiving, faMoneyBillSimpleWave, faChevronDown, faBatteryFull, faBattery, faBattery5, faBellPlus, faBookArrowRight, faHospitals, faClub, faSkullCrossbones, faDropletDegree, faDewpoint, faCodeCompare, faListUl, faListDots, faHandHoldingMagic, faWatermelonSlice, faCircleEllipsis, faSchoolLock, faTowerCell, faSdCards, faJugBottle, faDownLong, faLongArrowAltDown, faEnvelopes, faPhoneOffice, faRankingStar, faChessKing, faNfcPen, faPersonHarassing, faHatWinter, faBrazilianRealSign, faLandmarkDome, faLandmarkAlt, faBoneBreak, faArrowUp, faDownFromDottedLine, faTv, faTelevision, faTvAlt, faBorderLeft, faCircleDivide, faShrimp, faListCheck, faTasks, faDiagramSubtask, faJugDetergent, faCircleUser, faUserCircle, faSquareY, faUserDoctorHair, faPlanetRinged, faMushroom, faUserShield, faMegaphone, faWreathLaurel, faCircleExclamationCheck, faWind, faBoxDollar, faBoxUsd, faCarBurst, faCarCrash, faY, faUserHeadset, faArrowsRetweet, faRetweetAlt, faPersonSnowboarding, faSnowboarding, faSquareChevronRight, faChevronSquareRight, faLacrosseStickBall, faTruckFast, faShippingFast, faUserMagnifyingGlass, faStarSharp, faCommentHeart, faCircle1, faCircleStar, faStarCircle, faFish, faCloudFog, faFog, faWaffle, faMusicNote, faMusicAlt, faHexagonExclamation, faCartShoppingFast, faObjectUnion, faUserGraduate, faStarfighter, faCircleHalfStroke, faAdjust, faArrowRightLongToLine, faSquareArrowDown, faArrowSquareDown, faDiamondHalfStroke, faClapperboard, faSquareChevronLeft, faChevronSquareLeft, faPhoneIntercom, faLinkHorizontal, faChainHorizontal, faMango, faMusicNoteSlash, faMusicAltSlash, faCircleRadiation, faRadiationAlt, faFaceTongueSweat, faGlobeStand, faBaseball, faBaseballBall, faCircleP, faAwardSimple, faJetFighterUp, faDiagramProject, faProjectDiagram, faPedestal, faChartPyramid, faSidebar, faSnowmanHead, faFrostyHead, faCopy, faBurgerGlass, faVolumeXmark, faVolumeMute, faVolumeTimes, faHandSparkles, faBarsFilter, faPaintbrushPencil, faPartyBell, faUserVneckHair, faJackOLantern, faGrip, faGripHorizontal, faShareFromSquare, faShareSquare, faKeynote, faChildCombatant, faChildRifle, faGun, faSquarePhone, faPhoneSquare, faHatBeach, faPlus, faAdd, faExpand, faComputer, faFort, faCloudCheck, faXmark, faClose, faMultiply, faRemove, faFaceSmirking, faArrowsUpDownLeftRight, faArrows, faChalkboardUser, faChalkboardTeacher, faRhombus, faClawMarks, faPesoSign, faFaceSmileTongue, faCartCircleXmark, faBuildingShield, faCirclePhoneFlip, faPhoneCircleAlt, faBaby, faUsersLine, faQuoteLeft, faQuoteLeftAlt, faTractor, faKeySkeleton, faTrashArrowUp, faTrashRestore, faArrowDownUpLock, faArrowDownToBracket, faLinesLeaning, faSquareQ, faRulerCombined, faSymbols, faIconsAlt, faCopyright, faFlaskGear, faHighlighterLine, faBracketSquare, faBracket, faBracketLeft, faIslandTropical, faIslandTreePalm, faArrowRightFromLine, faArrowFromLeft, faH2, faEquals, faCakeSlice, faShortcake, faPeanut, faWrenchSimple, faBlender, faTeeth, faTally2, faShekelSign, faIls, faShekel, faSheqel, faSheqelSign, faCars, faAxeBattle, faUserHairLong, faMap, faFileCircleInfo, faFaceDisappointed, faLassoSparkles, faClockEleven, faRocket, faSirenOn, faClockTen, faCandleHolder, faVideoArrowDownLeft, faPhotoFilm, faPhotoVideo, faFloppyDiskCircleArrowRight, faSaveCircleArrowRight, faFolderMinus, faPlanetMoon, faFaceEyesXmarks, faChartScatter, faDisplayArrowDown, faStore, faArrowTrendUp, faPlugCircleMinus, faOliveBranch, faAngle, faVacuumRobot, faSignHanging, faSign, faSquareDivide, faSignalStreamSlash, faBezierCurve, faEyeDropperHalf, faStoreLock, faBellSlash, faCloudBoltSun, faThunderstormSun, faCameraSlash, faCommentQuote, faTablet, faTabletAndroid, faSchoolFlag, faMessageCode, faGlassHalf, faGlassHalfEmpty, faGlassHalfFull, faFill, faMessageMinus, faCommentAltMinus, faAngleUp, faDinosaur, faDrumstickBite, faLinkHorizontalSlash, faChainHorizontalSlash, faHollyBerry, faNose, faChevronLeft, faBacteria, faClouds, faMoneyBillSimple, faHandLizard, faTablePivot, faFilterSlash, faTrashCanUndo, faTrashCanArrowTurnLeft, faTrashUndoAlt, faNotdef, faDisease, faPersonToDoor, faTurntable, faBriefcaseMedical, faGenderless, faChevronRight, faSignalWeak, faSignal1, faClockFive, faRetweet, faCarRear, faCarAlt, faPumpSoap, faComputerClassic, faFrame, faVideoSlash, faBatteryQuarter, faBattery2, faEllipsisStroke, faEllipsisHAlt, faRadio, faBabyCarriage, faCarriageBaby, faFaceExpressionless, faDownToDottedLine, faCloudMusic, faTrafficLight, faCloudMinus, faThermometer, faShieldMinus, faVrCardboard, faCarTilt, faGaugeCircleMinus, faBrightnessLow, faHandMiddleFinger, faPercent, faPercentage, faTruckMoving, faGlassWaterDroplet, faConveyorBelt, faLocationCheck, faMapMarkerCheck, faCoinVertical, faDisplay, faPersonSign, faFaceSmile, faSmile, faPhoneHangup, faSignatureSlash, faThumbtack, faThumbTack, faWheatSlash, faTrophy, faCloudsSun, faPersonPraying, faPray, faHammer, faFaceVomit, faSpeakers, faTtyAnswer, faTeletypeAnswer, faMugTeaSaucer, faDiagramLeanCanvas, faAlt, faDial, faDialMedHigh, faHandPeace, faCircleTrash, faTrashCircle, faRotate, faSyncAlt, faCircleQuarters, faSpinner, faTowerControl, faArrowUpTriangleSquare, faSortShapesUp, faWhale, faRobot, faPeace, faPartyHorn, faGears, faCogs, faSunBright, faSunAlt, faWarehouse, faConveyorBeltArm, faLockKeyholeOpen, faLockOpenAlt, faSquareFragile, faBoxFragile, faSquareWineGlassCrack, faArrowUpRightDots, faSquareN, faSplotch, faFaceGrinHearts, faGrinHearts, faMeter, faMandolin, faDiceFour, faSimCard, faTransgender, faTransgenderAlt, faMercury, faUpFromBracket, faKnifeKitchen, faBorderRight, faArrowTurnDown, faLevelDown, faSpade, faCardSpade, faLineColumns, faArrowRightToLine, faArrowToRight, faPersonFallingBurst, faFlagPennant, faPennant, faConveyorBeltEmpty, faUserGroupSimple, faAward, faTicketSimple, faTicketAlt, faBuilding, faAnglesLeft, faAngleDoubleLeft, faCamcorder, faVideoHandheld, faPancakes, faAlbumCircleUser, faQrcode, faDiceD10, faFireplace, faBrowser, faPenPaintbrush, faPencilPaintbrush, faFishCooked, faChairOffice, faNestingDolls, faClockRotateLeft, faHistory, faTrumpet, faFaceGrinBeamSweat, faGrinBeamSweat, faFireSmoke, faPhoneMissed, faFileExport, faArrowRightFromFile, faShield, faShieldBlank, faArrowUpShortWide, faSortAmountUpAlt, faArrowsRepeat1, faRepeat1Alt, faGunSlash, faAvocado, faBinary, faGlassesRound, faGlassesAlt, faPhonePlus, faDitto, faPersonSeat, faHouseMedical, faGolfBallTee, faGolfBall, faCircleChevronLeft, faChevronCircleLeft, faHouseChimneyWindow, faScythe, faPenNib, faBanParking, faParkingCircleSlash, faTentArrowTurnLeft, faFaceDiagonalMouth, faDiagramCells, faCricketBatBall, faCricket, faTents, faWandMagic, faMagic, faDog, faPenLine, faAtomSimple, faAtomAlt, faAmpersand, faCarrot, faArrowUpFromLine, faArrowFromBottom, faMoon, faPenSlash, faWineGlassEmpty, faWineGlassAlt, faSquareStar, faCheese, faSendBackward, faYinYang, faMusic, faCompassSlash, faClockOne, faFileMusic, faCodeCommit, faTemperatureLow, faPersonBiking, faBiking, faDisplayChartUpCircleCurrency, faSkeleton, faCircleG, faCircleArrowUpLeft, faCoinBlank, faBroom, faVacuum, faShieldHeart, faCardHeart, faLightbulbCflOn, faMelon, faGopuram, faEarthOceania, faGlobeOceania, faContainerStorage, faFacePouting, faSquareXmark, faTimesSquare, faXmarkSquare, faFaceExplode, faExplodingHead, faHashtag, faUpRightAndDownLeftFromCenter, faExpandAlt, faOilCan, faT, faTransformerBolt, faHippo, faChartColumn, faCassetteVhs, faVhs, faInfinity, faVialCircleCheck, faChimney, faObjectIntersect, faPersonArrowDownToLine, faVoicemail, faBlockBrick, faWallBrick, faFan, faBagsShopping, faParagraphLeft, faParagraphRtl, faPersonWalkingLuggage, faCaravanSimple, faCaravanAlt, faTurtle, faPencilMechanical, faUpDown, faArrowsAltV, faCloudMoonRain, faBoothCurtain, faCalendar, faBoxHeart, faTrailer, faUserDoctorMessage, faUserMdChat, faBahai, faHaykal, faAmpGuitar, faSdCard, faVolumeSlash, faBorderBottom, faWifiWeak, faWifi1, faDragon, faShoePrints, faCirclePlus, faPlusCircle, faFaceGrinTongueWink, faGrinTongueWink, faHandHolding, faPlugCircleExclamation, faLinkSlash, faChainBroken, faChainSlash, faUnlink, faClone, faPersonWalkingArrowLoopLeft, faArrowUpZA, faSortAlphaUpAlt, faFireFlameCurved, faFireAlt, faTornado, faFileCirclePlus, faDeleteRight, faBookQuran, faQuran, faCircleQuarter, faAnchor, faBorderAll, faFunction, faFaceAngry, faAngry, faPeopleSimple, faCookieBite, faArrowTrendDown, faRss, faFeed, faFaceMonocle, faDrawPolygon, faScaleBalanced, faBalanceScale, faCalendarLines, faCalendarNote, faArrowDownBigSmall, faSortSizeDown, faGaugeSimpleHigh, faTachometer, faTachometerFast, faDoNotEnter, faShower, faDiceD8, faDesktop, faDesktopAlt, faM, faGripDotsVertical, faFaceViewfinder, faSoftServe, faCreemee, faH5, faHandBackPointDown, faTableList, faThList, faCommentSms, faSms, faRectangle, faRectangleLandscape, faClipboardListCheck, faTurkey, faBook, faUserPlus, faIceSkate, faCheck, faBatteryThreeQuarters, faBattery4, faTomato, faSwordLaser, faHouseCircleCheck, faBuildings, faAngleLeft, faCartFlatbedBoxes, faDollyFlatbedAlt, faDiagramSuccessor, faTruckArrowRight, faSquareW, faArrowsSplitUpAndLeft, faLamp, faAirplay, faHandFist, faFistRaised, faShieldQuartered, faSlashForward, faLocationPen, faMapMarkerEdit, faCloudMoon, faPotFood, faBriefcase, faPersonFalling, faImagePortrait, faPortrait, faUserTag, faRug, faPrintSlash, faEarthEurope, faGlobeEurope, faCartFlatbedSuitcase, faLuggageCart, faHandBackPointRibbon, faRectangleXmark, faRectangleTimes, faTimesRectangle, faWindowClose, faTireRugged, faLightbulbDollar, faCowbell, faBahtSign, faCorner, faChevronsRight, faChevronDoubleRight, faBookOpen, faBookJournalWhills, faJournalWhills, faInhaler, faHandcuffs, faSnake, faTriangleExclamation, faExclamationTriangle, faWarning, faNoteMedical, faDatabase, faDownLeft, faShare, faArrowTurnRight, faMailForward, faFaceThinking, faTurnDownRight, faBottleDroplet, faMaskFace, faHillRockslide, faScannerKeyboard, faCircleO, faGridHorizontal, faMessageDollar, faCommentAltDollar, faRightLeft, faExchangeAlt, faColumns3, faPaperPlane, faRoadCircleExclamation, faDungeon, faHandHoldingBox, faInputText, faWindowFlip, faWindowAlt, faAlignRight, faScannerGun, faScanner, faTire, faEngine, faMoneyBill1Wave, faMoneyBillWaveAlt, faLifeRing, faHands, faSignLanguage, faSigning, faCircleCaretRight, faCaretCircleRight, faWheat, faFileSpreadsheet, faAudioDescriptionSlash, faCalendarDay, faWaterLadder, faLadderWater, faSwimmingPool, faArrowsUpDown, faArrowsV, faChessPawnPiece, faChessPawnAlt, faFaceGrimace, faGrimace, faWheelchairMove, faWheelchairAlt, faTurnDown, faLevelDownAlt, faSquareS, faRectangleBarcode, faBarcodeAlt, faPersonWalkingArrowRight, faSquareEnvelope, faEnvelopeSquare, faDice, faUnicorn, faBowlingBall, faPompebled, faBrain, faWatchSmart, faBookUser, faSensorCloud, faSensorSmoke, faClapperboardPlay, faBandage, faBandAid, faCalendarMinus, faCircleXmark, faXmarkCircle, faCircle4, faGifts, faAlbumCollection, faHotel, faEarthAsia, faGlobeAsia, faIdCardClip, faIdCardAlt, faMagnifyingGlassPlus, faSearchPlus, faCloudShowers, faUserClock, faOnion, faClockTwelveThirty, faArrowDownToDottedLine, faHandDots, faAllergies, faFileInvoice, faWindowMinimize, faRectangleWide, faCommentArrowUp, faGarlic, faMugSaucer, faCoffee, faBrush, faTreeDecorated, faMask, faCalendarHeart, faMagnifyingGlassMinus, faSearchMinus, faFlower, faRightLeftLarge, faRulerVertical, faCirclesOverlap, faUserLarge, faUserAlt, faStarshipFreighter, faTrainTram, faBridgeSuspension, faTrashCheck, faUserNurse, faBoombox, faSyringe, faCloudSun, faShieldExclamation, faStopwatch20, faSquareFull, faGripDots, faCommentExclamation, faPenSwirl, faFalafel, faCircle2, faMagnet, faJar, faGramophone, faDiceD12, faNoteSticky, faDown, faArrowAltDown, faHundredPoints, fa100, faPaperclipVertical, faWindWarning, faWindCircleExclamation, faLocationPinSlash, faMapMarkerSlash, faBugSlash, faCupcake, faLightSwitchOff, faToggleLargeOff, faPenFancySlash, faTruckContainer, faBoot, faArrowUpFromWaterPump, faFileCheck, faBone, faCardsBlank, faCircle3, faBenchTree, faKeyboardBrightnessLow, faSkiBootSki, faBrainCircuit, faUserInjured, faBlockBrickFire, faFirewall, faFaceSadTear, faSadTear, faPlane, faTentArrowsDown, faExclamation, faArrowsSpin, faFaceSmileRelaxed, faCommentXmark, faCommentTimes, faPrint, faTurkishLiraSign, faTry, faTurkishLira, faFaceNoseSteam, faCircleWaveformLines, faWaveformCircle, faDollarSign, faDollar, faUsd, faFerrisWheel, faComputerSpeaker, faSkullCow, faX, faMagnifyingGlassDollar, faSearchDollar, faUsersGear, faUsersCog, faPersonMilitaryPointing, faBuildingColumns, faBank, faInstitution, faMuseum, faUniversity, faCircleT, faSack, faGrid2, faCameraCctv, faCctv, faUmbrella, faTrowel, faHorizontalRule, faBedFront, faBedAlt, faD, faStapler, faMasksTheater, faTheaterMasks, faKipSign, faFaceWoozy, faCloudQuestion, faPineapple, faHandPointLeft, faGalleryThumbnails, faCircleJ, faEyes, faHandshakeSimple, faHandshakeAlt, faPageCaretUp, faFileCaretUp, faJetFighter, faFighterJet, faComet, faSquareShareNodes, faShareAltSquare, faShieldKeyhole, faBarcode, faPlusMinus, faSquareSlidersVertical, faSlidersVSquare, faVideo, faVideoCamera, faMessageMiddle, faCommentMiddleAlt, faGraduationCap, faMortarBoard, faHandHoldingMedical, faPersonCircleCheck, faSquareZ, faMessageText, faCommentAltText, faTurnUp, faLevelUpAlt */
var prefix = "fal";
var fa0 = {
  prefix: 'fal',
  iconName: '0',
  icon: [320, 512, [], "30", "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 64C89.3 64 32 121.3 32 192V320c0 70.7 57.3 128 128 128s128-57.3 128-128V192c0-70.7-57.3-128-128-128z"]
};
var fa1 = {
  prefix: 'fal',
  iconName: '1',
  icon: [256, 512, [], "31", "M144 48c0-5.9-3.2-11.3-8.5-14.1s-11.5-2.5-16.4 .8l-96 64c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L112 77.9V448l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H128 240c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0V48z"]
};
var fa2 = {
  prefix: 'fal',
  iconName: '2',
  icon: [320, 512, [], "32", "M148 64c-28.8 0-56.9 11.5-77.2 31.8L43.3 123.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L48.2 73.1C74.6 46.8 110.9 32 148 32c76.5 0 140 61.9 140 138.8c0 38.4-15.9 75-43.9 101.3L56.5 448H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-6.6 0-12.5-4-14.9-10.1s-.9-13.1 3.9-17.6L222.2 248.7c21.5-20.2 33.8-48.4 33.8-77.9C256 112 207.2 64 148 64z"]
};
var fa3 = {
  prefix: 'fal',
  iconName: '3',
  icon: [320, 512, [], "33", "M0 48c0-8.8 7.2-16 16-16H288c6.6 0 12.5 4 14.9 10.2s.8 13.1-4 17.6L120.9 224H192c70.7 0 128 57.3 128 128s-57.3 128-128 128H89.4c-36.4 0-69.6-20.5-85.9-53.1l-1.9-3.8c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l1.9 3.8C43 434.3 65.2 448 89.4 448H192c53 0 96-43 96-96s-43-96-96-96H80c-6.6 0-12.5-4-14.9-10.2s-.8-13.1 4-17.6L247.1 64H16C7.2 64 0 56.8 0 48z"]
};
var fa4 = {
  prefix: 'fal',
  iconName: '4',
  icon: [384, 512, [], "34", "M174.3 55.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-144 288c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H288V464c0 8.8 7.2 16 16 16s16-7.2 16-16V352h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V320H41.9L174.3 55.2z"]
};
var fa5 = {
  prefix: 'fal',
  iconName: '5',
  icon: [320, 512, [], "35", "M48.5 44.1C50.3 37 56.7 32 64 32H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H76.5l-40 160H192c70.7 0 128 57.3 128 128s-57.3 128-128 128H84.5c-33.3 0-63.8-18.8-78.7-48.6l-4.1-8.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.1 8.2c9.5 19 28.9 31 50.1 31H192c53 0 96-43 96-96s-43-96-96-96H16c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l48-192z"]
};
var fa6 = {
  prefix: 'fal',
  iconName: '6',
  icon: [320, 512, [], "36", "M288 320c0-70.7-57.3-128-128-128C90.3 192 33.7 247.7 32 316.9c0 1 0 2 0 3.1c0 70.7 57.3 128 128 128s128-57.3 128-128zM126.8 163.5c10.7-2.3 21.8-3.5 33.2-3.5c88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-2 0-3.9 .1-5.9C1.5 276.2 16 239.9 41.2 211.5L196 37.4c5.9-6.6 16-7.2 22.6-1.3s7.2 16 1.3 22.6L126.8 163.5z"]
};
var fa7 = {
  prefix: 'fal',
  iconName: '7',
  icon: [320, 512, [], "37", "M0 48c0-8.8 7.2-16 16-16H304c5.8 0 11.1 3.1 14 8.2s2.7 11.3-.3 16.2l-256 416c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22L275.4 64H16C7.2 64 0 56.8 0 48z"]
};
var fa8 = {
  prefix: 'fal',
  iconName: '8',
  icon: [320, 512, [], "38", "M304 152c0-66.3-53.7-120-120-120H136C69.7 32 16 85.7 16 152c0 41.4 20.9 77.9 52.8 99.4C28.1 270.6 0 312 0 360c0 66.3 53.7 120 120 120h80c66.3 0 120-53.7 120-120c0-48-28.1-89.4-68.8-108.6C283.1 229.9 304 193.4 304 152zM184.1 272H200c48.6 0 88 39.4 88 88s-39.4 88-88 88H120c-48.6 0-88-39.4-88-88s39.4-88 88-88h15.9c0 0 .1 0 .1 0h48c0 0 0 0 .1 0zm0-32c0 0 0 0-.1 0H136c0 0 0 0-.1 0C87.4 240 48 200.6 48 152c0-48.6 39.4-88 88-88l48 0c48.6 0 88 39.4 88 88c0 48.6-39.4 88-87.9 88z"]
};
var fa9 = {
  prefix: 'fal',
  iconName: '9',
  icon: [320, 512, [], "39", "M32 192c0 70.7 57.3 128 128 128c69.7 0 126.3-55.7 128-124.9c0-1 0-2 0-3.1c0-70.7-57.3-128-128-128S32 121.3 32 192zM193.2 348.5c-10.7 2.3-21.8 3.5-33.2 3.5C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 2 0 3.9-.1 5.9c-1.4 37.9-15.9 74.2-41.1 102.6L124 474.6c-5.9 6.6-16 7.2-22.6 1.3s-7.2-16-1.3-22.6l93.2-104.8z"]
};
var faFillDrip = {
  prefix: 'fal',
  iconName: 'fill-drip',
  icon: [576, 512, [], "f576", "M36.7 4.7c6.2-6.2 16.4-6.2 22.6 0l97.4 97.4 64.4-64.4c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L134.1 124.7 36.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zm208 230.6l-88-88L53.3 250.7C42.8 261.2 36.7 274.4 35 288H432l19.7-19.7c15.6-15.6 15.6-40.9 0-56.6L300.3 60.3c-15.6-15.6-40.9-15.6-56.6 0l-64.4 64.4 88 88c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0zM39.2 320c3.1 7.7 7.8 15 14.1 21.3L170.7 458.7c25 25 65.5 25 90.5 0L400 320H39.2zM544 448s0 0 0 0v0c0-.1-.1-1.2-.6-3.4c-.6-2.4-1.5-5.4-2.8-9.1c-2.7-7.4-6.8-16.2-11.7-25.8c-5.2-10.2-11.2-20.6-16.9-30.3c-5.8 9.7-11.7 20.1-16.9 30.3c-4.9 9.6-8.9 18.4-11.7 25.8c-1.4 3.7-2.3 6.7-2.8 9.1c-.5 2.2-.6 3.3-.6 3.4c0 0 0 0 0 0c0 17.7 14.3 32 32 32s32-14.3 32-32zm32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448z"]
};
var faArrowsToCircle = {
  prefix: 'fal',
  iconName: 'arrows-to-circle',
  icon: [640, 512, [], "e4bd", "M27.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L137.4 160H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.4L27.3 4.7zM320 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM464 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H502.6L635.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 137.4V80c0-8.8-7.2-16-16-16zM176 448c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L160 374.6V432c0 8.8 7.2 16 16 16zm288 0c8.8 0 16-7.2 16-16V374.6L612.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L502.6 352H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16z"]
};
var faCircleChevronRight = {
  prefix: 'fal',
  iconName: 'circle-chevron-right',
  icon: [512, 512, ["chevron-circle-right"], "f138", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM235.3 379.3l112-112c6.2-6.2 6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L313.4 256 212.7 356.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"]
};
var faChevronCircleRight = faCircleChevronRight;
var faWagonCovered = {
  prefix: 'fal',
  iconName: 'wagon-covered',
  icon: [640, 512, [], "f8ee", "M239.4 34.1C250.1 13.8 271.4 0 296 0h48c24.6 0 45.9 13.8 56.6 34.1c13.1-12.6 30.6-20.8 50.1-22.1L565.8 4.4c41.7-2.8 71.7 39.5 55.2 77.9L560.3 224c8.7 .1 15.7 7.2 15.7 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V256h-8H392 376 264 248 104 96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.7 7-15.9 15.7-16L19 82.3C2.5 43.9 32.5 1.6 74.2 4.4l115.1 7.7c19.5 1.3 36.9 9.5 50.1 22.1zM114.6 224H232V91.9c0-25.3-19.6-46.2-44.8-47.9L72.1 36.3C54.2 35.1 41.4 53.2 48.4 69.7L114.6 224zM408 224H525.4L591.6 69.7c7.1-16.5-5.8-34.6-23.7-33.4L452.8 44C427.6 45.7 408 66.6 408 91.9V224zM264 91.9V224H376V64c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32V91.9zM176 512c-61.9 0-112-50.1-112-112s50.1-112 112-112c56.4 0 103.1 41.7 110.9 96h66.3c7.8-54.3 54.4-96 110.9-96c61.9 0 112 50.1 112 112s-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96H286.9c-7.8 54.3-54.4 96-110.9 96zm16-33.6c31.3-6.4 56-31.1 62.4-62.4H192v62.4zm-32 0V416H97.6c6.4 31.3 31.1 56 62.4 62.4zM96 399.6l0 .4 0 .4v-.8zM97.6 384H160V321.6c-31.3 6.4-56 31.1-62.4 62.4zM192 321.6V384h62.4c-6.4-31.3-31.1-56-62.4-62.4zM542.4 416H480v62.4c31.3-6.4 56-31.1 62.4-62.4zM448 416H385.6c6.4 31.3 31.1 56 62.4 62.4V416zm-64-16l0-.4v.8l0-.4zm64-16V321.6c-31.3 6.4-56 31.1-62.4 62.4H448zm32 0h62.4c-6.4-31.3-31.1-56-62.4-62.4V384z"]
};
var faLineHeight = {
  prefix: 'fal',
  iconName: 'line-height',
  icon: [576, 512, [], "f871", "M107.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L80 86.6V425.4L27.3 372.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 425.4V86.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM272 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zM256 416c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"]
};
var faBagel = {
  prefix: 'fal',
  iconName: 'bagel',
  icon: [640, 512, [129391], "e3d7", "M608 208c0-97.2-78.8-176-176-176c-49.3 0-93.9 20.3-125.8 52.9c-10.5-4.7-21.3-8.7-32.5-11.8C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208s-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c5.4-10.2 10-20.7 13.9-31.7C530.5 382.7 608 304.4 608 208zM364.6 84.4l17.6-.5c6.2-.2 12.1-2.1 17.2-5.6l14.5-10c10.9-7.5 25.3-7.5 36.2 0l14.5 10c5.1 3.5 11 5.4 17.2 5.6l17.6 .5c13.2 .4 24.8 8.8 29.3 21.3l5.9 16.6c2.1 5.8 5.8 10.9 10.6 14.6l14 10.7c10.5 8.1 14.9 21.7 11.2 34.4l-5 16.9c-1.7 5.9-1.7 12.2 0 18.1l5 16.9c3.7 12.7-.7 26.3-11.2 34.4l-14 10.7c-4.9 3.8-8.6 8.8-10.6 14.6l-5.9 16.6c-4.4 12.5-16.1 20.9-29.3 21.3l-17.6 .5c-6.2 .2-12.1 2.1-17.2 5.6l-14.5 10c-2.1 1.5-4.4 2.6-6.7 3.5c2.6-13.2 4.2-26.9 4.5-40.8c9.8-6.4 21.3-9.9 33-10.3l17.6-.5 5.9-16.6c4.1-11.6 11.5-21.8 21.3-29.3l14-10.7-5-16.9c-3.5-11.8-3.5-24.4 0-36.2l5-16.9-14-10.7c-9.8-7.5-17.1-17.7-21.3-29.3l-5.9-16.6-17.6-.5c-12.3-.3-24.3-4.2-34.4-11.2L432 94.8l-14.5 10c-10.2 7-22.1 10.8-34.4 11.2l-17.6 .5-1.8 4.9c-8.4-7.2-17.3-13.8-26.6-19.7c5.3-10.2 15.8-16.9 27.5-17.2zM384 304A176 176 0 1 0 32 304a176 176 0 1 0 352 0zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm208-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM112 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm128 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTransporter7 = {
  prefix: 'fal',
  iconName: 'transporter-7',
  icon: [512, 512, [], "e2a8", "M480 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V48zM64 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V272zm64 224c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faAt = {
  prefix: 'fal',
  iconName: 'at',
  icon: [512, 512, [61946], "40", "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v24c0 48.6-39.4 88-88 88c-33.4 0-62.5-18.7-77.4-46.1c-20.4 28-53.4 46.1-90.6 46.1c-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6V176c0-8.8 7.2-16 16-16s16 7.2 16 16v80 24c0 30.9 25.1 56 56 56s56-25.1 56-56V256C480 132.3 379.7 32 256 32zm80 224a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faRectanglesMixed = {
  prefix: 'fal',
  iconName: 'rectangles-mixed',
  icon: [576, 512, [], "e323", "M272 64c8.8 0 16 7.2 16 16V208c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16H272zM48 32C21.5 32 0 53.5 0 80V208c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM528 64c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h96zM432 32c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H432zM112 336H288c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16zM64 352v80c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V352c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z"]
};
var faPhoneArrowUpRight = {
  prefix: 'fal',
  iconName: 'phone-arrow-up-right',
  icon: [512, 512, ["phone-arrow-up", "phone-outgoing"], "e224", "M292.7 196.7L457.4 32H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16V144c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6L315.3 219.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm36.4 90c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faPhoneArrowUp = faPhoneArrowUpRight;
var faPhoneOutgoing = faPhoneArrowUpRight;
var faTrashCan = {
  prefix: 'fal',
  iconName: 'trash-can',
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zm80 80V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTrashAlt = faTrashCan;
var faCircleL = {
  prefix: 'fal',
  iconName: 'circle-l',
  icon: [512, 512, [], "e114", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 17.7 14.3 32 32 32H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V144z"]
};
var faHeadSideGoggles = {
  prefix: 'fal',
  iconName: 'head-side-goggles',
  icon: [512, 512, ["head-vr"], "f6ea", "M2.3 256c5.8 40.5 22.4 77.5 46.8 108C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4c-20-25-33.9-55-39.4-88H2.3zM80.9 96C116 56.7 167.1 32 224 32h24c36 0 69.3 11.9 96 32H288c-28.4 0-54 12.4-71.6 32H80.9zm-45.1 6.6C14.6 113 0 134.8 0 160c0 35.3 28.7 64 64 64H216.4c17.6 19.6 43.1 32 71.6 32H400h64c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H400h-8.9C356 24.7 304.9 0 248 0H224C145 0 75.6 40.8 35.7 102.6zM197.5 192H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H197.5c-3.5 10-5.5 20.8-5.5 32s1.9 22 5.5 32zm313.3 96H477.2c-4.5 9.5-14.2 16-25.4 16H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c29.1 0 53.3-20.6 58.9-48zM288 96h96V224H288c-35.3 0-64-28.7-64-64s28.7-64 64-64zM416 224V96h48c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H416z"]
};
var faHeadVr = faHeadSideGoggles;
var faTextHeight = {
  prefix: 'fal',
  iconName: 'text-height',
  icon: [576, 512, [], "f034", "M491.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L464 86.6V425.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 425.4V86.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM32 32C14.3 32 0 46.3 0 64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64H144l0 384H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H176l0-384H288v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7-14.3-32-32-32H32z"]
};
var faUserXmark = {
  prefix: 'fal',
  iconName: 'user-xmark',
  icon: [640, 512, ["user-times"], "f235", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zM468.7 148.7c-6.2 6.2-6.2 16.4 0 22.6L521.4 224l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L544 246.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L566.6 224l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L544 201.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faUserTimes = faUserXmark;
var faFaceHandYawn = {
  prefix: 'fal',
  iconName: 'face-hand-yawn',
  icon: [512, 512, [], "e379", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm233.3 45.3L248 318.6l0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3l0 0-16 16-34 34L280 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5l0 0-5.1 5.1-26.9 26.9-2 2L312 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2V352 298.4c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3v11.7 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 0 0 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6l0 0-34 34zm-11.3-79.2L207 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V352v32.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0zM220.5 110c-5.5-6.9-15.6-8-22.5-2.5l-80 64c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l80-64c6.9-5.5 8-15.6 2.5-22.5zM294 132.5l80 64c6.9 5.5 17 4.4 22.5-2.5s4.4-17-2.5-22.5l-80-64c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5z"]
};
var faGaugeSimpleMin = {
  prefix: 'fal',
  iconName: 'gauge-simple-min',
  icon: [512, 512, ["tachometer-slowest"], "f62d", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64s-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4L104.2 242.3c-7.6-4.5-17.4-2.1-22 5.5s-2.1 17.4 5.5 22l106.8 64.1c-1.7 5.8-2.6 11.9-2.6 18.2c0 35.3 28.7 64 64 64z"]
};
var faTachometerSlowest = faGaugeSimpleMin;
var faStethoscope = {
  prefix: 'fal',
  iconName: 'stethoscope',
  icon: [576, 512, [129658], "f0f1", "M127 10.4c3.1 8.3-1.1 17.5-9.4 20.6L74.4 47.2C68.1 49.5 64 55.5 64 62.2V192c0 70.7 57.3 128 128 128s128-57.3 128-128V62.2c0-6.7-4.1-12.6-10.4-15L266.4 31c-8.3-3.1-12.5-12.3-9.4-20.6s12.3-12.5 20.6-9.4l43.2 16.2c18.7 7 31.1 24.9 31.1 44.9V192c0 83-63.1 151.2-144 159.2v.8c0 70.7 57.3 128 128 128s128-57.3 128-128V254c-27.6-7.1-48-32.2-48-62c0-35.3 28.7-64 64-64s64 28.7 64 64c0 29.8-20.4 54.9-48 62v98c0 88.4-71.6 160-160 160s-160-71.6-160-160v-.8C95.1 343.2 32 275 32 192V62.2c0-20 12.4-37.9 31.1-44.9L106.4 1c8.3-3.1 17.5 1.1 20.6 9.4zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCoffin = {
  prefix: 'fal',
  iconName: 'coffin',
  icon: [384, 512, [9904], "f6c6", "M126.5 32l131 0 91 104c2.3 2.6 3.6 6 3.6 9.5c0 1.4-.2 2.7-.6 4L255.9 480l-127.9 0L32.6 149.4c-.4-1.3-.6-2.6-.6-4c0-3.5 1.3-6.9 3.6-9.5l91-104zM102.4 10.9l-91 104C4.1 123.3 0 134.2 0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1H255.9c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0h-131c-9.2 0-18 4-24.1 10.9z"]
};
var faMessage = {
  prefix: 'fal',
  iconName: 'message',
  icon: [512, 512, ["comment-alt"], "f27a", "M160 384c17.7 0 32 14.3 32 32v48l98.1-73.6c5.5-4.2 12.3-6.4 19.2-6.4H448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32h96zM0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V448 416H128 64c-35.3 0-64-28.7-64-64V64z"]
};
var faCommentAlt = faMessage;
var faSalad = {
  prefix: 'fal',
  iconName: 'salad',
  icon: [512, 512, [129367, "bowl-salad"], "f81e", "M241.1 32c37.1 0 68.9 22.7 82.3 55c2.8 6.6 9.6 10.6 16.7 9.7c3.9-.5 7.8-.7 11.8-.7c7.4 0 14.6 .8 21.5 2.4C382.1 96.8 391 96 400 96c15.3 0 30 2.4 43.8 6.8C420.5 78.9 388 64 352 64c-1.3 0-2.7 0-4 .1C327.6 26 287.4 0 241.1 0c-46.3 0-86.5 26-106.9 64.1c-2.1-.1-4.1-.1-6.2-.1C57.3 64 0 121.3 0 192c0 23.3 6.2 45.2 17.1 64H56.4C41.2 239 32 216.6 32 192c0-53 43-96 96-96c4.6 0 9.2 .3 13.6 1c7.2 1 14.3-3 17-9.7C172 54.8 203.9 32 241.1 32zM400 160c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16h32.5c.7-5.2 1.1-10.6 1.1-16c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 5.4 .4 10.8 1.1 16h32.5c-1-5.2-1.6-10.5-1.6-16c0-44.2 35.8-80 80-80zM129.3 457.1c-2.7-9-9.2-16.4-17.8-20.2C65.9 417 33.9 372.3 32.1 320H479.9c-1.8 52.3-33.9 97-79.4 116.9c-8.6 3.8-15.2 11.2-17.8 20.2C378.7 470.4 366.5 480 352 480H160c-14.5 0-26.7-9.6-30.7-22.9zM27.4 288C12.3 288 0 300.3 0 315.4c0 67.4 40.6 125.4 98.6 150.8C106.5 492.7 131 512 160 512H352c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4H27.4zM256 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V240c0 8.8 7.2 16 16 16s16-7.2 16-16V112zM107.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80z"]
};
var faBowlSalad = faSalad;
var faInfo = {
  prefix: 'fal',
  iconName: 'info',
  icon: [192, 512, [], "f129", "M64 64a32 32 0 1 1 64 0A32 32 0 1 1 64 64zM16 176c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16V448h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H80V192H32c-8.8 0-16-7.2-16-16z"]
};
var faRobotAstromech = {
  prefix: 'fal',
  iconName: 'robot-astromech',
  icon: [512, 512, [], "e2d2", "M256 0C176.5 0 112 64.5 112 144v16H96c-35.3 0-64 28.7-64 64V420.2L2.4 479.5C.8 482.6 0 486 0 489.5C0 501.9 10.1 512 22.5 512H128c8.8 0 16-7.2 16-16V406.6l36.7 36.7c3 3 7.1 4.7 11.3 4.7H320c4.2 0 8.3-1.7 11.3-4.7L368 406.6V496c0 8.8 7.2 16 16 16H489.5c12.4 0 22.5-10.1 22.5-22.5c0-3.5-.8-6.9-2.4-10L480 420.2V224c0-35.3-28.7-64-64-64H400V144C400 64.5 335.5 0 256 0zM400 192h16c17.7 0 32 14.3 32 32V424c0 2.5 .6 4.9 1.7 7.2L474.1 480H400V368 192zm-32 0V361.4L313.4 416H198.6L144 361.4V192H368zm-256 0V368 480H37.9l24.4-48.8c1.1-2.2 1.7-4.7 1.7-7.2V224c0-17.7 14.3-32 32-32h16zm32-48c0-61.9 50.1-112 112-112s112 50.1 112 112v16H144V144zm80-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z"]
};
var faRingDiamond = {
  prefix: 'fal',
  iconName: 'ring-diamond',
  icon: [384, 512, [], "e5ab", "M136 0c-5.7 0-11 3.1-13.9 8.1l-32 56c-3 5.3-2.8 11.8 .6 16.8l38.4 57.7C54 164.6 0 236 0 320C0 426 86 512 192 512s192-86 192-192c0-84-54-155.4-129.1-181.5l38.4-57.7c3.4-5 3.6-11.6 .6-16.8l-32-56C259 3.1 253.7 0 248 0H136zm85.9 130.3c-9.7-1.5-19.7-2.3-29.9-2.3s-20.2 .8-29.9 2.3l-39.3-59L145.3 32h93.4l22.5 39.4-39.3 59zM32 320a160 160 0 1 1 320 0A160 160 0 1 1 32 320z"]
};
var faFonduePot = {
  prefix: 'fal',
  iconName: 'fondue-pot',
  icon: [512, 512, [129749], "e40d", "M282.1 32.3c-4.3-1.2-8.7 1.4-9.8 5.6l-24 88c-1.2 4.3 1.4 8.7 5.6 9.8s8.7-1.4 9.8-5.6l24-88c1.2-4.3-1.4-8.7-5.6-9.8zM262.5 167.5L255.1 192H221.7l9.7-32.4c-12.3-9.6-18.4-26-14-42.1l24-88c5.8-21.3 27.8-33.9 49.1-28.1s33.9 27.8 28.1 49.1l-24 88c-4.3 15.6-17.2 26.5-32.1 29zM223.4 256h1.2c-.4 0-.8 0-1.2 0zm88 0h1.1c-.4 0-.7 0-1.1 0zm65.7-88.6L361.5 192H323.6l26.9-42.2c-8.3-12.7-8.9-29.6-.2-43.3l56-88C418.1-.1 442.8-5.6 461.5 6.3s24.1 36.6 12.3 55.2l-56 88c-8.9 14-25.2 20.6-40.6 17.9zM444.3 33.3c-3.7-2.4-8.7-1.3-11 2.5l-56 88c-2.4 3.7-1.3 8.7 2.5 11s8.7 1.3 11-2.5l56-88c2.4-3.7 1.3-8.7-2.5-11zM32 256v64c0 70.7 57.3 128 128 128H288c70.7 0 128-57.3 128-128V256H160v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H32zM0 256c0-17.7 14.3-32 32-32H416h8 24 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v64c0 52.3-25.1 98.8-64 128v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V466.7c-19.6 8.6-41.2 13.3-64 13.3H160c-22.8 0-44.4-4.8-64-13.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V448C25.1 418.8 0 372.3 0 320V256z"]
};
var faTheta = {
  prefix: 'fal',
  iconName: 'theta',
  icon: [384, 512, [], "f69e", "M48 256c0-58.9 17.1-111.6 43.9-149.1C118.7 69.4 154.3 48 192 48s73.3 21.4 100.1 58.9C318.9 144.4 336 197.1 336 256s-17.1 111.6-43.9 149.1C265.3 442.6 229.7 464 192 464s-73.3-21.4-100.1-58.9C65.1 367.6 48 314.9 48 256zM192 16C141.3 16 96.9 44.8 65.8 88.3C34.7 131.9 16 191.2 16 256s18.7 124.1 49.8 167.7C96.9 467.2 141.3 496 192 496s95.1-28.8 126.2-72.3C349.3 380.1 368 320.8 368 256s-18.7-124.1-49.8-167.7C287.1 44.8 242.7 16 192 16zM112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faFaceHandPeeking = {
  prefix: 'fal',
  iconName: 'face-hand-peeking',
  icon: [640, 512, [129763], "e481", "M185.6 76.8C223 48.7 269.6 32 320 32c66.3 0 125.9 28.8 167 74.7c5.9 6.6 16 7.1 22.6 1.3s7.1-16 1.3-22.6C464 33 395.8 0 320 0C262.4 0 209.2 19.1 166.4 51.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2zM130.5 375.5c-4.7-7.5-14.6-9.7-22.1-5s-9.7 14.6-5 22.1C148.7 464.3 228.8 512 320 512c65.6 0 125.4-24.7 170.7-65.2c6.6-5.9 7.1-16 1.3-22.6s-16-7.1-22.6-1.3c-39.6 35.5-91.9 57-149.3 57c-79.8 0-149.8-41.7-189.5-104.5zM415 232c.7-2.6 1-5.2 1-8c0-1.6-.1-3.2-.4-4.8L433.6 232H415zm-53.8 14.5c-5.8 6.9-9.2 15.8-9.2 25.5c0 13.4 6.6 25.3 16.7 32.5c-.5 2.4-.7 4.9-.7 7.5c0 22.1 17.9 40 40 40h8c0 .3 0 .6 0 .9c0 22.1 17.9 40 40 40h64.8c31.6 0 61.9-12.6 84.3-34.9c46.2-46.2 46.5-120.9 1-167.6l0 0-.2-.1-.8-.8-.1-.1L560 144.3c-17.2-17.2-45-17.2-62.2 0c-7.3 7.3-11.5 16.6-12.6 26.2l-37.9-27.1c-18-12.8-43-8.7-55.8 9.3c-8.5 11.9-9.6 26.9-4 39.4c-1.1-.1-2.3-.2-3.4-.2c-17.7 0-32 14.3-32 32c0 8.8 3.5 16.7 9.2 22.5zM289.7 376.7c7.1-5.1 17.8-8.7 30.3-8.7s23.2 3.6 30.3 8.7c7.2 5.1 9.7 10.7 9.7 15.3s-2.5 10.2-9.7 15.3c-7.1 5.1-17.8 8.7-30.3 8.7s-23.2-3.6-30.3-8.7c-7.2-5.1-9.7-10.7-9.7-15.3s2.5-10.2 9.7-15.3zm-18.6-26C258 360.1 248 374.4 248 392s10 31.9 23.1 41.3c13.1 9.4 30.5 14.7 48.9 14.7s35.8-5.3 48.9-14.7C382 423.9 392 409.6 392 392s-10-31.9-23.1-41.3C355.8 341.3 338.4 336 320 336s-35.8 5.3-48.9 14.7zM379.4 144.1c-2-6.3-8.7-9.8-15-7.9C327.1 147.9 300 182.8 300 224c0 20.7 6.8 39.8 18.4 55.2c4 5.3 11.5 6.4 16.8 2.4s6.4-11.5 2.4-16.8C329.1 253.4 324 239.3 324 224c0-30.4 20-56.2 47.6-64.9c6.3-2 9.8-8.7 7.9-15zM96 88.3L34.9 149.4l0 0-.8 .8 0 0-.1 .2c-45.5 46.6-45.2 121.3 1 167.6c22.4 22.4 52.7 34.9 84.3 34.9H184c22.1 0 40-17.9 40-40c0-.3 0-.6 0-.9h8c22.1 0 40-17.9 40-40c0-2.6-.2-5.1-.7-7.5c10.1-7.3 16.7-19.1 16.7-32.5s-6.6-25.3-16.7-32.5c.5-2.4 .7-4.9 .7-7.5c0-22.1-17.9-40-40-40H156.8l1.5-1.5c17.2-17.2 17.2-45 0-62.2s-45-17.2-62.2 0zm92.9 209.3c6.2 2 10.7 7.6 11.1 14.3c0 .3 0 .6 0 .9c0 8.8-7.2 16-16 16H119.2c-25.2 0-49.5-10-67.3-27.9c-36.9-36.9-37.2-96.6-.8-133.8l.8-.8L113 105.3c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L122.8 152l-.5 .5-4.2 4.2-5.7 5.7c-5 5-1.5 13.7 5.7 13.7h8H132h.7H232c8.8 0 16 7.2 16 16v0l0 .2 0 0c-.1 8.8-7.2 15.8-16 15.8l-42.8 0H169.6c-2.2 0-4 1.8-4 4s1.8 4 4 4h19.6H232h16c4.6 0 8.7 1.9 11.6 5c2.7 2.9 4.4 6.8 4.4 11s-1.7 8.2-4.4 11c-2.9 3.1-7 5-11.6 5H232l-42.8 0H169.6c-2.2 0-4 1.8-4 4s1.8 4 4 4h19.6H232c8.8 0 16 7.1 16 15.9l0 0 0 .1v0c0 8.8-7.2 16-16 16H215.3 189.1 184 170c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5h14c1.7 0 3.3 .3 4.9 .8zM376 272c0-8.8 7.2-16 16-16h74.6c7.4 0 13.4-6 13.4-13.4c0-4.3-2.1-8.4-5.6-10.9L414.7 189c-7.2-5.1-8.9-15.1-3.7-22.3s15.1-8.9 22.3-3.7l73.1 52.2 3.6 2.5 3.6 2.5 1.5 1.1c2.3 1.6 5.1 2.3 7.8 2c9.3-1.1 13.2-12.4 6.6-19l-1.3-1.3-3.1-3.1-3.1-3.1-7.3-7.3c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l45.1 45.1 .8 .8c36.4 37.2 36.1 96.9-.8 133.8c-17.9 17.9-42.1 27.9-67.3 27.9H456c-8.8 0-16-7.2-16-16c0-.3 0-.6 0-.9c.5-8.4 7.4-15.1 16-15.1h.5 19c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5h-19H456l-31.3 0H408c-8.8 0-16-7.2-16-16v-.1c0-8.8 7.2-15.9 16-15.9h48.4H476c2.2 0 4-1.8 4-4s-1.8-4-4-4H456.4 408 392c-4.6 0-8.7-1.9-11.6-5c-2.7-2.9-4.4-6.8-4.4-11z"]
};
var faSquareUser = {
  prefix: 'fal',
  iconName: 'square-user',
  icon: [448, 512, [], "e283", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32c0-70.7-57.3-128-128-128H192c-70.7 0-128 57.3-128 128c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM352 448H96c0-53 43-96 96-96h64c53 0 96 43 96 96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"]
};
var faDownLeftAndUpRightToCenter = {
  prefix: 'fal',
  iconName: 'down-left-and-up-right-to-center',
  icon: [512, 512, ["compress-alt"], "f422", "M447 256c18.2 0 33-14.8 33-33c0-8.7-3.5-17.1-9.7-23.3L442.6 172l55.7-55.7c15.6-15.6 15.6-40.9 0-56.6L452.3 13.7C436.7-2 411.3-2 395.7 13.7L340 69.4 312.3 41.7C306.1 35.5 297.7 32 289 32c-18.2 0-33 14.8-33 33l0 159c0 17.7 14.3 32 32 32l159 0zm.7-33.7c.2 .2 .3 .4 .3 .7c0 .5-.4 1-1 1l-159 0 0-159c0-.5 .4-1 1-1c.3 0 .5 .1 .7 .3l39 39c6.2 6.2 16.4 6.2 22.6 0l67-67c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-67 67c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39zM65 256c-18.2 0-33 14.8-33 33c0 8.7 3.5 17.1 9.7 23.3L69.4 340 13.7 395.7C-2 411.3-2 436.7 13.7 452.3l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0L172 442.6l27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7c18.2 0 33-14.8 33-33V288c0-17.7-14.3-32-32-32H65zm-1 33c0-.5 .4-1 1-1H224V447c0 .5-.4 1-1 1c-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-67 67c-3.1 3.1-8.2 3.1-11.3 0L36.3 429.7c-3.1-3.1-3.1-8.2 0-11.3l67-67c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7z"]
};
var faCompressAlt = faDownLeftAndUpRightToCenter;
var faExplosion = {
  prefix: 'fal',
  iconName: 'explosion',
  icon: [576, 512, [], "e4e9", "M543.4 20.4c2.2-7.7-1.7-15.9-9-19.1s-16-.4-20.1 6.4L342.2 294.6 303.5 140.1C301.7 133 295.3 128 288 128s-13.7 5-15.5 12.1L231.3 304.7l-108-108c-5.2-5.2-13.4-6.2-19.7-2.3s-9.1 11.6-6.8 18.7l39.8 119.5L49.2 320.2c-6.6-.9-13 2.3-16.2 8.1s-2.5 13 1.8 18.1l81 96 4.8 5.7h41.9l-22.2-26.3-54-64 71.5 10.1c5.5 .8 11-1.3 14.5-5.6s4.6-10 2.9-15.3l-26.6-79.7 80.1 80.1c4.1 4.1 10 5.6 15.6 4.1s9.9-5.9 11.3-11.5L288 210l32.5 129.9c1.6 6.3 6.8 11 13.2 11.9s12.7-2 16.1-7.6L479.3 128.3 416.6 347.6c-1.5 5.3-.2 11 3.4 15.1s9.2 6 14.6 5.1l53.5-8.9-52.4 62.9L413.8 448h41.7l4.8-5.8 80-96c4.3-5.1 4.9-12.4 1.6-18.2s-9.9-8.9-16.5-7.8l-71 11.8 89-311.7zM304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V80c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H208 368 560c8.8 0 16-7.2 16-16s-7.2-16-16-16H382.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H16zm210 0c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48H226z"]
};
var faFileLines = {
  prefix: 'fal',
  iconName: 'file-lines',
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm48 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faFileAlt = faFileLines;
var faFileText = faFileLines;
var faWaveSquare = {
  prefix: 'fal',
  iconName: 'wave-square',
  icon: [640, 512, [], "f83e", "M192 64c-8.8 0-16 7.2-16 16V224c0 26.5-21.5 48-48 48H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H128c8.8 0 16-7.2 16-16V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V432c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V288c0-26.5 21.5-48 48-48H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H512c-8.8 0-16 7.2-16 16V432c0 26.5-21.5 48-48 48H352c-26.5 0-48-21.5-48-48V80c0-8.8-7.2-16-16-16H192z"]
};
var faRing = {
  prefix: 'fal',
  iconName: 'ring',
  icon: [512, 512, [], "f70b", "M93.1 127.3C133.9 108.2 191.5 96 256 96s122.1 12.2 162.9 31.3C461.1 147 480 171 480 192c0 14.3-8.7 30-27.6 44.8c-6.3-3.7-13-7.2-19.9-10.4C386.5 204.8 324.1 192 256 192s-130.5 12.8-176.5 34.3c-6.9 3.2-13.6 6.7-19.9 10.4C40.7 222 32 206.3 32 192c0-21 18.9-45 61.1-64.7zM480 255.3V320c0 21-18.9 45-61.1 64.7C378.1 403.8 320.5 416 256 416s-122.1-12.2-162.9-31.3C50.9 365 32 341 32 320V255.3c13.2 11.8 29.5 22 47.5 30.4C125.5 307.2 187.9 320 256 320s130.5-12.8 176.5-34.3c18-8.4 34.4-18.6 47.5-30.4zM0 192V320c0 40.8 34.8 72.8 79.5 93.7C125.5 435.2 187.9 448 256 448s130.5-12.8 176.5-34.3C477.2 392.8 512 360.8 512 320V192c0-40.8-34.8-72.8-79.5-93.7C386.5 76.8 324.1 64 256 64S125.5 76.8 79.5 98.3C34.8 119.2 0 151.2 0 192zm93.1 64.7l-1.5-.7 1.5-.7C133.9 236.2 191.5 224 256 224s122.1 12.2 162.9 31.3l1.5 .7-1.5 .7C378.1 275.8 320.5 288 256 288s-122.1-12.2-162.9-31.3z"]
};
var faBuildingUn = {
  prefix: 'fal',
  iconName: 'building-un',
  icon: [384, 512, [], "e4d9", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM224 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm-96 96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256 224 160 128zM248 224h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm8 64h32V256H256v32zM64 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V248zm32 8v32h32V256H96zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDiceThree = {
  prefix: 'fal',
  iconName: 'dice-three',
  icon: [448, 512, [9858], "f527", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTirePressureWarning = {
  prefix: 'fal',
  iconName: 'tire-pressure-warning',
  icon: [512, 512, [], "f633", "M416 0c-8.8 0-16 7.2-16 16V27.6c0 42.2 9.8 83.9 28.7 121.6l5 9.9c.2 .3 .3 .6 .5 .9c18 30.9 36.4 73.1 35.8 120.5c-.6 45.5-18.7 97.9-76.2 151.4H118.2C60.7 378.5 42.6 326.1 42 280.6c-.6-47.4 17.8-89.7 35.8-120.5c.2-.3 .3-.6 .5-.9l5-9.9C102.2 111.4 112 69.8 112 27.6V16c0-8.8-7.2-16-16-16S80 7.2 80 16V27.6c0 37.3-8.7 74-25.3 107.3l-4.7 9.5C30.7 177.5 9.3 225.5 10 281c.7 55 23.1 115.3 86 174.1c0 .3 0 .6 0 .9v40c0 8.8 7.2 16 16 16s16-7.2 16-16V464h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16V456c0-.3 0-.6 0-.9c63-58.8 85.3-119.1 86-174.1c.7-55.5-20.7-103.5-39.9-136.6l-4.7-9.5C440.7 101.6 432 64.8 432 27.6V16c0-8.8-7.2-16-16-16zM256 96c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faWifiFair = {
  prefix: 'fal',
  iconName: 'wifi-fair',
  icon: [640, 512, ["wifi-2"], "f6ab", "M139.3 298.7C185.6 252.5 249.5 224 320 224s134.4 28.5 180.7 74.7c6.3 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-52.1-51.9-123.9-84-203.3-84s-151.2 32.1-203.3 84c-6.3 6.2-6.3 16.4 0 22.6s16.4 6.3 22.6 0zM288 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faWifi2 = faWifiFair;
var faCalendarDays = {
  prefix: 'fal',
  iconName: 'calendar-days',
  icon: [448, 512, ["calendar-alt"], "f073", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H312v72H416V192zm0 104H312v80H416V296zm0 112H312v72h72c17.7 0 32-14.3 32-32V408zM280 376V296H168v80H280zM168 408v72H280V408H168zm-32-32V296H32v80H136zM32 408v40c0 17.7 14.3 32 32 32h72V408H32zm0-144H136V192H32v72zm136 0H280V192H168v72zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32z"]
};
var faCalendarAlt = faCalendarDays;
var faMp3Player = {
  prefix: 'fal',
  iconName: 'mp3-player',
  icon: [384, 512, [], "f8ce", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 336a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 112a112 112 0 1 1 0-224 112 112 0 1 1 0 224zM168 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 96v64H288V96H96zM64 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96z"]
};
var faAnchorCircleCheck = {
  prefix: 'fal',
  iconName: 'anchor-circle-check',
  icon: [640, 512, [], "e4aa", "M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V480H240c-79.5 0-144-64.5-144-144V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h48 48c17.2 0 33.8-2.5 49.5-7c-9.8-7.9-18.8-16.9-26.7-26.7c-7.4 1.2-15 1.8-22.8 1.8H304V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faTally4 = {
  prefix: 'fal',
  iconName: 'tally-4',
  icon: [640, 512, [], "e297", "M144 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48zM384 32c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zM528 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48z"]
};
var faRectangleHistory = {
  prefix: 'fal',
  iconName: 'rectangle-history',
  icon: [512, 512, [], "e4a2", "M480 192c0-17.7-14.3-32-32-32L64 160c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-256zm-32-64c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l384 0zm0-64c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0zM400 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L112 32c-8.8 0-16-7.2-16-16s7.2-16 16-16L400 0z"]
};
var faBuildingCircleArrowRight = {
  prefix: 'fal',
  iconName: 'building-circle-arrow-right',
  icon: [640, 512, [], "e4d1", "M64 32H320c17.7 0 32 14.3 32 32V266.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm240-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-3.3-211.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faVolleyball = {
  prefix: 'fal',
  iconName: 'volleyball',
  icon: [512, 512, [127952, "volleyball-ball"], "f45f", "M415.1 413.7c-85.3 20-177.8 6.8-256.2-42.8c-13.5 21.4-24.2 44.4-31.9 68.2c36.5 25.8 81 40.9 129.1 40.9c62.2 0 118.5-25.4 159.1-66.3zm34-44c10.9-18.4 19.2-38.5 24.4-59.8c-72 12.5-148.4 1.8-217.2-35.5c-31 19.1-57.5 43.1-78.9 70.2c83.6 52.2 184.6 59.1 271.7 25zm30.1-93.4c.6-6.7 .9-13.4 .9-20.3c0-99.3-64.6-183.5-154.1-212.9c52.5 65.3 80.6 150 72.9 239.3c27.1 1.5 54.1-.6 80.3-6.2zM272.8 32.6c-5.5-.4-11.1-.6-16.8-.6c-21.5 0-42.3 3-62 8.7c46.8 56.1 75.7 127.6 77.9 205.8C302.4 263 334.5 273.7 367 279c8-95.3-29.1-184.8-94.2-246.4zM162 52.6C85.2 88.2 32 165.9 32 256c0 7.5 .4 14.9 1.1 22.1c34.4-69.3 92.8-127.1 169.6-159.7l3.7-1.6c-12-23.3-27-44.9-44.4-64.2zM45.3 332.3c11.8 32.5 30.9 61.5 55.3 85C125.7 348.8 173.2 288 239.9 247c-1-35.5-8.2-69.5-20.4-100.9l-4.4 1.9C131.4 183.5 71.8 252.2 45.3 332.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faVolleyballBall = faVolleyball;
var faSunHaze = {
  prefix: 'fal',
  iconName: 'sun-haze',
  icon: [640, 512, [], "f765", "M435.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L320 65.1 229.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L185 121 77.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L129.1 256l0 0h35.4c0-3.2-.9-6.4-2.8-9.1l-54.5-79.1 94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-1.9 2.7-2.8 5.9-2.8 9.1h35.4l0 0 62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L455 121 435.1 13.1zM448 256c0-70.7-57.3-128-128-128s-128 57.3-128 128v0h32v0c0-53 43-96 96-96s96 43 96 96v0h32v0zM80 288c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H496zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"]
};
var faTextSize = {
  prefix: 'fal',
  iconName: 'text-size',
  icon: [640, 512, [], "f894", "M32 32C14.3 32 0 46.3 0 64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64H176l0 384H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H208l0-384H352v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7-14.3-32-32-32H32zM352 224c-17.7 0-32 14.3-32 32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256H464l0 192H416c-8.8 0-16 7.2-16 16s7.2 16 16 16H544c8.8 0 16-7.2 16-16s-7.2-16-16-16H496l0-192H608v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-17.7-14.3-32-32-32H480 352z"]
};
var faUfo = {
  prefix: 'fal',
  iconName: 'ufo',
  icon: [640, 512, [128760], "e047", "M176.6 238.3c-11.7 11-11.7 11-11.6 11l0 0 0 0 .1 .1 .2 .2c.2 .2 .4 .4 .6 .6c.5 .5 1.1 1.1 1.9 1.8c1.6 1.5 4 3.4 7 5.7c6.1 4.5 15.2 10.3 27.7 16c25 11.4 63.1 22.3 117.5 22.3s92.5-10.9 117.5-22.3c12.5-5.7 21.6-11.5 27.7-16c3.1-2.3 5.4-4.2 7-5.7c.8-.7 1.5-1.3 1.9-1.8c.2-.2 .4-.4 .6-.6l.2-.2 .1-.1 0 0 0 0c0 0 0 0-11.6-11l11.7 11c2.5-2.6 4-6 4.3-9.6c.8-9.6 .8-19 .1-28.1c38.3 10.3 69.8 24.1 92.1 39.7C597.1 269.1 608 287.5 608 304c0 12.2-5.8 25.2-19.2 38.5c-13.5 13.4-33.7 26.2-60.1 37.3C476.1 401.9 402.3 416 320 416s-156.1-14.1-208.8-36.2c-26.3-11.1-46.6-23.9-60.1-37.3C37.8 329.2 32 316.2 32 304c0-16.5 10.9-34.9 36.5-52.8c22.3-15.6 53.7-29.3 92.1-39.7c-.7 9.1-.7 18.5 .1 28.1c.3 3.6 1.8 7 4.3 9.6l11.7-11zm296.3-61.5C452.3 110.2 390.3 64 320 64s-132.3 46.2-152.8 112.9C120 188.1 79.5 204.5 50.1 225C20.7 245.6 0 272.3 0 304c0 23.2 11.2 43.9 28.6 61.2c17.3 17.2 41.6 32 70.2 44.1C156.2 433.4 234.4 448 320 448s163.8-14.6 221.2-38.7c28.7-12.1 52.9-26.9 70.2-44.1c17.4-17.3 28.6-38 28.6-61.2c0-31.7-20.7-58.4-50.1-79c-29.3-20.5-69.9-36.9-117-48.1zm-21.1 50.5l.1-.1 0 0 0 0 0 0 0 0zm-3.9 3.3c-.5 .4-1.1 .8-1.7 1.3c-4.5 3.3-11.7 7.9-22 12.6C403.5 254 370 264 320 264s-83.5-10-104.2-19.4c-10.4-4.7-17.6-9.4-22-12.6c-.6-.5-1.2-.9-1.7-1.3C189.1 154.3 249.4 96 320 96s130.9 58.3 127.9 134.7zM152 312a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFork = {
  prefix: 'fal',
  iconName: 'fork',
  icon: [512, 512, ["utensil-fork"], "f2e3", "M401.5 28.9c7.1-5.2 8.7-15.2 3.4-22.4s-15.2-8.7-22.4-3.4L268.2 86.9c-4.4 3.3-8.6 6.9-12.5 10.7l-1.6 1.6C234.8 118.5 224 144.7 224 172c0 25 9.1 49.1 25.5 67.8L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272.2 262.5C290.9 278.9 315 288 340 288c27.3 0 53.5-10.8 72.8-30.1l1.6-1.6c3.9-3.9 7.5-8.1 10.7-12.5l83.8-114.3c5.2-7.1 3.7-17.1-3.4-22.4s-17.1-3.7-22.4 3.4L399.3 224.9c-2.3 3.1-4.8 6.1-7.6 8.8l-1.6 1.6C376.8 248.5 358.8 256 340 256s-36.8-7.5-50.1-20.8l-13.1-13.1C263.5 208.8 256 190.8 256 172s7.5-36.8 20.8-50.1l1.6-1.6c2.7-2.7 5.7-5.3 8.8-7.6L401.5 28.9zM442.5 60c6.6-5.8 7.3-15.9 1.5-22.6s-15.9-7.3-22.6-1.5l-128 112c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l128-112zM476 90.5c5.8-6.7 5.1-16.8-1.5-22.6s-16.8-5.1-22.6 1.5l-112 128c-5.8 6.7-5.1 16.8 1.5 22.6s16.8 5.1 22.6-1.5l112-128z"]
};
var faUtensilFork = faFork;
var faArrowsUpToLine = {
  prefix: 'fal',
  iconName: 'arrows-up-to-line',
  icon: [576, 512, [], "e4c2", "M16 64l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 32C7.2 32 0 39.2 0 48s7.2 16 16 16zM4.7 228.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 166.6 112 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-297.4 84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112zm320 22.6c6.2 6.2 16.4 6.2 22.6 0L432 166.6 432 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-297.4 84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6z"]
};
var faMobileSignal = {
  prefix: 'fal',
  iconName: 'mobile-signal',
  icon: [512, 512, [], "e1ef", "M96 32H288c17.7 0 32 14.3 32 32V284.3c10.1-8.3 20.8-15.9 32-22.7V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H224V488c0-2.7 0-5.3 .1-8H96c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 400H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c2.2 0 4.3-.4 6.2-1.3c1.8-8.2 4-16.4 6.6-24.3c-2.9-3.9-7.6-6.4-12.8-6.4zM496 256c-132.5 0-240 107.5-240 240c0 8.8 7.2 16 16 16s16-7.2 16-16c0-114.9 93.1-208 208-208c8.8 0 16-7.2 16-16s-7.2-16-16-16zM480 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-144c0-8.8-7.2-16-16-16c-79.5 0-144 64.5-144 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9 50.1-112 112-112c8.8 0 16-7.2 16-16z"]
};
var faBarcodeScan = {
  prefix: 'fal',
  iconName: 'barcode-scan',
  icon: [640, 512, [], "f465", "M64 48V192H96V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm0 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H64V464zm96 0V320H128V464c0 8.8 7.2 16 16 16s16-7.2 16-16zM128 48V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H192V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H288V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H352V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H448V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H544V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zM0 256c0 8.8 7.2 16 16 16l608 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 240c-8.8 0-16 7.2-16 16z"]
};
var faSortDown = {
  prefix: 'fal',
  iconName: 'sort-down',
  icon: [320, 512, ["sort-desc"], "f0dd", "M154.4 445.8c1.4 1.3 3.5 2.2 5.6 2.2s4.2-.8 5.6-2.2L285.8 332.3c1.4-1.3 2.2-3.2 2.2-5.2c0-3.9-3.2-7.1-7.1-7.1H39.1c-3.9 0-7.1 3.2-7.1 7.1c0 2 .8 3.8 2.2 5.2L154.4 445.8zm-22 23.3L12.3 355.6C4.4 348.2 0 337.9 0 327.1C0 305.5 17.5 288 39.1 288H280.9c21.6 0 39.1 17.5 39.1 39.1c0 10.8-4.4 21.1-12.3 28.5L187.6 469.1c-7.4 7-17.3 10.9-27.6 10.9s-20.1-3.9-27.6-10.9z"]
};
var faSortDesc = faSortDown;
var faFolderArrowDown = {
  prefix: 'fal',
  iconName: 'folder-arrow-down',
  icon: [512, 512, ["folder-download"], "e053", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM272 208c0-8.8-7.2-16-16-16s-16 7.2-16 16V329.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4V208z"]
};
var faFolderDownload = faFolderArrowDown;
var faCircleMinus = {
  prefix: 'fal',
  iconName: 'circle-minus',
  icon: [512, 512, ["minus-circle"], "f056", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faMinusCircle = faCircleMinus;
var faFaceIcicles = {
  prefix: 'fal',
  iconName: 'face-icicles',
  icon: [512, 512, [], "e37c", "M256 32C132.3 32 32 132.3 32 256c0 .5 0 .9-.1 1.4L24.2 443.9c-.1 2.3-2 4.1-4.3 4.1c-2.2 0-4.1-1.7-4.2-3.9L.2 258.7c-.1-.9-.2-1.8-.2-2.7C0 114.6 114.6 0 256 0S512 114.6 512 256c0 .7 0 1.4-.1 2L496.2 508.1c-.1 2.2-2 3.9-4.2 3.9c-2.3 0-4.1-1.8-4.2-4.1L480 257c0-.3 0-.7 0-1C480 132.3 379.7 32 256 32zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V320h-8zm40 48h32V320H208v48zm96 0V320H272v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zM168 288H344c30.9 0 56 25.1 56 56c0 15.7-6.4 29.8-16.8 40l-9.3 90.7c-.3 3-2.8 5.3-5.9 5.3s-5.6-2.3-5.9-5.3L354.4 399c-3.4 .6-6.8 1-10.4 1H317.3l-7.1 42.7c-.5 3-3.1 5.3-6.2 5.3s-5.7-2.2-6.2-5.3L290.7 400H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-15.6-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM256 512c-80.2 0-151.8-36.9-198.7-94.6l2.2-53.7C97.6 433 171.3 480 256 480c11.6 0 23-.9 34.1-2.6c4.3 1.7 9 2.6 13.9 2.6c9.7 0 18.7-3.6 25.5-9.7l.8 7.7c.8 7.7 3.9 14.7 8.5 20.3C312.8 507.2 285 512 256 512zm151.3-49.5l4.7-45.8c15.5-15 28.8-32.2 39.4-51.2l1.7 53.8c-13.4 16.2-28.8 30.7-45.8 43.1z"]
};
var faShovel = {
  prefix: 'fal',
  iconName: 'shovel',
  icon: [512, 512, [], "f713", "M396 34.6L352.9 77.8C342.1 88.6 336 103.2 336 118.5c0 31.8 25.8 57.5 57.5 57.5c15.3 0 29.9-6.1 40.7-16.9L477.4 116 396 34.6zM377.9 7.5C382.7 2.7 389.2 0 396 0s13.3 2.7 18.1 7.5l90.3 90.3c4.8 4.8 7.5 11.3 7.5 18.1s-2.7 13.3-7.5 18.1l-47.6 47.6c-16.8 16.8-39.6 26.2-63.3 26.2c-18.9 0-36.5-5.9-51-15.9L235.3 299.3l62.1 62.1c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32V386.3c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0l62.1 62.1L319.9 169.4c-10-14.5-15.9-32-15.9-51c0-23.7 9.4-46.5 26.2-63.3L377.9 7.5zM32 480h93.7c33.9 0 66.5-13.5 90.5-37.5L274.7 384 128 237.3 69.5 295.8c-24 24-37.5 56.6-37.5 90.5V480z"]
};
var faDoorOpen = {
  prefix: 'fal',
  iconName: 'door-open',
  icon: [576, 512, [], "f52b", "M288 480H96V86.2c0-7.5 5.1-13.9 12.4-15.6l166-38.3c.8-.2 1.7-.3 2.5-.3C283 32 288 37 288 43.1V480zm32 0V43.1C320 19.3 300.7 0 276.9 0c-3.3 0-6.5 .4-9.7 1.1l-166 38.3C79.4 44.4 64 63.8 64 86.2V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 80 96 288h32V480zM232 288c13.2 0 24-14.4 24-32s-10.8-32-24-32s-24 14.4-24 32s10.7 32 24 32zM464 64H352V96H464c8.8 0 16 7.2 16 16V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V112c0-26.5-21.5-48-48-48z"]
};
var faFilms = {
  prefix: 'fal',
  iconName: 'films',
  icon: [576, 512, [], "e17a", "M224 272V224H448v48 80H224V272zm0-80V144 64H448v80 48H224zM464 32H448 224 208 192 160c-35.3 0-64 28.7-64 64v32 16 16 96 16 16 32c0 35.3 28.7 64 64 64h32 16 16H448h16 16 32c35.3 0 64-28.7 64-64V288 272 256 160 144 128 96c0-35.3-28.7-64-64-64H480 464zM160 64h32v64H128V96c0-17.7 14.3-32 32-32zm-32 96h64v48 48H128V160zm0 160V288h64v64H160c-17.7 0-32-14.3-32-32zm384 32H480V288h64v32c0 17.7-14.3 32-32 32zm32-96H480V208 160h64v96zm0-128H480V64h32c17.7 0 32 14.3 32 32v32zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faRightFromBracket = {
  prefix: 'fal',
  iconName: 'right-from-bracket',
  icon: [512, 512, ["sign-out-alt"], "f2f5", "M479.2 254.2c.5 .5 .8 1.1 .8 1.8s-.3 1.4-.8 1.8L347.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-8.8-7.2-16-16-16l-120 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l120 0c8.8 0 16-7.2 16-16l0-57.3c0-3.7 3-6.7 6.7-6.7c1.7 0 3.3 .7 4.6 1.8L479.2 254.2zM512 256c0-9.5-3.9-18.6-10.8-25.1L369.2 106.5C362 99.8 352.5 96 342.7 96c-21.4 0-38.7 17.3-38.7 38.7l0 41.3-104 0c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l104 0 0 41.3c0 21.4 17.3 38.7 38.7 38.7c9.9 0 19.4-3.8 26.5-10.5L501.2 281.1c6.9-6.5 10.8-15.6 10.8-25.1zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 32C35.8 32 0 67.8 0 112L0 400c0 44.2 35.8 80 80 80l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l96 0z"]
};
var faSignOutAlt = faRightFromBracket;
var faFaceGlasses = {
  prefix: 'fal',
  iconName: 'face-glasses',
  icon: [512, 512, [], "e377", "M256 480C132.3 480 32 379.7 32 256c0-22.2 3.2-43.7 9.3-64h7.3c-.4 2.6-.6 5.3-.6 8v48c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V200c0-2.7-.2-5.4-.6-8h33.1c-.4 2.6-.6 5.3-.6 8v48c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V200c0-2.7-.2-5.4-.6-8h7.3c6 20.3 9.3 41.8 9.3 64c0 123.7-100.3 224-224 224zM224 160.8c-10.2-10.4-24.3-16.8-40-16.8H104c-15.3 0-29.1 6.1-39.2 16H53.6C89.5 84.3 166.6 32 256 32s166.5 52.3 202.4 128H447.2c-10.1-9.9-23.9-16-39.2-16H328c-15.7 0-29.8 6.4-40 16.8V160H224v.8zM256 0C148.6 0 56.6 66.2 18.6 160H16c-8.8 0-16 7.2-16 16c0 6.1 3.5 11.5 8.5 14.2C3 211.2 0 233.2 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22.8-3-44.8-8.5-65.8c5.1-2.7 8.5-8 8.5-14.2c0-8.8-7.2-16-16-16h-2.6C455.4 66.2 363.4 0 256 0zM141.5 339.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM304 200c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V200zM104 176h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24zm88.4 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faNfc = {
  prefix: 'fal',
  iconName: 'nfc',
  icon: [448, 512, [], "e1f7", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm0 96V384c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32v82.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V128H352V384H96V128l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-17.7 0-32 14.3-32 32zM224 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
};
var faAtom = {
  prefix: 'fal',
  iconName: 'atom',
  icon: [512, 512, [9883], "f5d2", "M322 421.3c-.3 .7-.6 1.3-.9 1.9C301.4 464.7 278 480 256 480s-45.4-15.3-65.1-56.7c-.3-.6-.6-1.3-.9-1.9c21.1-5 43.3-12.6 66-22.6c22.7 9.9 44.9 17.5 66 22.6zM217.1 379.8c-13.4 4.8-26.4 8.6-38.7 11.4c-4-12.6-7.4-26.3-10.1-40.9c8.4 5.7 17.1 11.2 26 16.6c7.6 4.6 15.2 8.9 22.8 13zm116.4 11.4c-12.3-2.8-25.3-6.5-38.7-11.4c7.6-4.1 15.2-8.4 22.8-13c8.9-5.4 17.6-10.9 26-16.6c-2.8 14.6-6.2 28.3-10.1 40.9zm-32.3-51.8c-15.3 9.2-30.4 17.2-45.2 24.2c-14.8-7-29.9-15.1-45.2-24.2c-17.5-10.5-33.7-21.5-48.5-32.8c-1.5-16.2-2.3-33.1-2.3-50.6s.8-34.4 2.3-50.6c14.8-11.3 31.1-22.3 48.5-32.8c15.3-9.2 30.4-17.2 45.2-24.2c14.8 7 29.9 15.1 45.2 24.2c17.5 10.5 33.7 21.5 48.5 32.8c1.5 16.2 2.3 33.1 2.3 50.6s-.8 34.4-2.3 50.6c-14.8 11.3-31.1 22.3-48.5 32.8zm64.3 56.7c6.6-22.1 11.5-46.6 14.6-72.7c16.7-13.5 31.7-27.5 44.7-41.8l.8 1.2c25 37.7 26.8 66.1 16 85.6c-10.4 18.7-33.6 31-76.1 27.7zm18.1-118.2c.3-7.2 .4-14.5 .4-21.9s-.1-14.7-.4-21.9c7.7 7.3 14.8 14.6 21.3 21.9c-6.5 7.3-13.6 14.7-21.3 21.9zm86 106.1c20.7-37.1 9.4-82.8-23.6-128c33-45.2 44.3-90.9 23.6-128c-20.2-36.3-62.5-49.3-115.2-43.2C332.4 32.7 298.8 0 256 0s-76.4 32.7-98.4 84.8c-52.7-6.1-95 6.8-115.2 43.2C21.7 165.1 33 210.8 66 256c-33 45.2-44.3 90.9-23.6 128c20.2 36.3 62.5 49.3 115.2 43.2c22 52.1 55.7 84.8 98.4 84.8s76.4-32.7 98.4-84.8c52.7 6.1 95-6.8 115.2-43.2zm-28-240.4c10.8 19.5 9.1 47.9-16 85.6l-.8 1.2c-13-14.2-28-28.2-44.7-41.8c-3.1-26.1-8-50.6-14.6-72.7c42.6-3.3 65.7 8.9 76.1 27.7zM321.1 88.7c.3 .6 .6 1.3 .9 1.9c-21.1 5-43.3 12.6-66 22.6c-22.7-9.9-44.9-17.5-66-22.6c.3-.7 .6-1.3 .9-1.9C210.6 47.3 234 32 256 32s45.4 15.3 65.1 56.7zm12.5 32.1c4 12.6 7.4 26.3 10.1 40.9c-8.4-5.7-17.1-11.2-26-16.5c-7.6-4.6-15.2-8.9-22.8-13c13.4-4.8 26.4-8.6 38.7-11.3zm-155.1 0c12.3 2.8 25.3 6.5 38.7 11.3c-7.6 4.1-15.2 8.4-22.8 13c-8.9 5.4-17.6 10.9-26 16.5c2.8-14.6 6.2-28.3 10.1-40.9zm-32-4.9c-6.6 22.1-11.5 46.6-14.6 72.7c-16.7 13.5-31.7 27.5-44.7 41.8l-.8-1.2c-25-37.7-26.8-66.1-16-85.6c10.4-18.7 33.6-31 76.1-27.7zM86.3 282.8l.8-1.2c13 14.2 28 28.2 44.7 41.8c3.1 26.1 8 50.6 14.6 72.7c-42.6 3.3-65.7-8.9-76.1-27.7c-10.8-19.5-9.1-47.9 16-85.6zm42.1-48.8c-.3 7.2-.4 14.5-.4 21.9s.1 14.7 .4 21.9c-7.7-7.3-14.8-14.6-21.3-21.9c6.5-7.3 13.6-14.7 21.3-21.9zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSoap = {
  prefix: 'fal',
  iconName: 'soap',
  icon: [512, 512, [129532], "e06e", "M224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 128 64zM96 192H225.3c1.9 11.5 5.9 22.3 11.5 32H96c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H403.2c5.6-9.7 9.6-20.5 11.5-32H416c53 0 96 43 96 96V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V288c0-53 43-96 96-96zm64 80H320h32c44.2 0 80 35.8 80 80s-35.8 80-80 80H160c-44.2 0-80-35.8-80-80s35.8-80 80-80zm-48 80c0 26.5 21.5 48 48 48H352c26.5 0 48-21.5 48-48s-21.5-48-48-48H160c-26.5 0-48 21.5-48 48zM400 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM352 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faIcons = {
  prefix: 'fal',
  iconName: 'icons',
  icon: [512, 512, ["heart-music-camera-bolt"], "f86d", "M473.7 4.1C493.5 .2 512 15.3 512 35.5V168h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V35.5L352 61.1V200h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V61.1c0-15.3 10.8-28.4 25.7-31.4l128-25.6zM480 172c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM320 204c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM105.4 54.6l-6-6c-9-9-21.8-13.1-34.4-11c-19 3.2-33 19.6-33 38.9v2.9c0 11.9 4.9 23.2 13.6 31.4L128 187.7l82.4-76.9c8.7-8.1 13.6-19.5 13.6-31.4V76.5c0-19.3-13.9-35.8-33-38.9c-12.6-2.1-25.4 2-34.4 11l-6 6L128 77.3 105.4 54.6zM59.7 6C82.5 2.3 105.7 9.7 122 26l0 0 6 6 6-6C150.3 9.7 173.5 2.3 196.3 6C230.7 11.8 256 41.6 256 76.5v2.9c0 20.8-8.6 40.6-23.8 54.8l-90.4 84.3c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L23.8 134.2C8.6 120 0 100.2 0 79.5V76.5C0 41.6 25.3 11.8 59.7 6zM72 320H48c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H216c-12.1 0-23.2-6.8-28.6-17.7L180.2 288H107.8l-7.2 14.3C95.2 313.2 84.1 320 72 320zm136.8-46.3L216 288h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H72l7.2-14.3c5.4-10.8 16.5-17.7 28.6-17.7h72.4c12.1 0 23.2 6.8 28.6 17.7zM112 392a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM475.3 283.3L390.6 368H480c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L441.4 400H352c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l112-112c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faHeartMusicCameraBolt = faIcons;
var faMicrophoneLinesSlash = {
  prefix: 'fal',
  iconName: 'microphone-lines-slash',
  icon: [640, 512, ["microphone-alt-slash"], "f539", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM395.5 397.1l-28.1-22.2c-14.7 5.8-30.6 9.1-47.4 9.1c-70.7 0-128-57.3-128-128V236.5l-32-25.3V256c0 83 63.1 151.2 144 159.2V480H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V415.2c21.3-2.1 41.4-8.4 59.5-18.1zM256 123.9V96c0-35.3 28.7-64 64-64s64 28.7 64 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32H336c-8.3 0-15.2 6.4-15.9 14.5L342.2 192H384v32h-1.2L416 250.2V240 176 112 96c0-53-43-96-96-96s-96 43-96 96v2.7l32 25.3zM446.7 274.5l28.1 22.2c3.4-13 5.2-26.6 5.2-40.7V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 6.3-.5 12.4-1.3 18.5z"]
};
var faMicrophoneAltSlash = faMicrophoneLinesSlash;
var faClosedCaptioningSlash = {
  prefix: 'fal',
  iconName: 'closed-captioning-slash',
  icon: [640, 512, [], "e135", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.4 480l-40.5-32H96c-17.7 0-32-14.3-32-32V135.4L32 110.2V416c0 35.3 28.7 64 64 64H500.4zM139.6 32l40.5 32H544c17.7 0 32 14.3 32 32V376.6l32 25.3V96c0-35.3-28.7-64-64-64H139.6zM373.5 216.7c11.7-15 30-24.7 50.5-24.7c17.4 0 33.2 7 44.8 18.3c6.3 6.2 16.4 6.1 22.6-.2s6.1-16.4-.2-22.6c-17.3-17-41-27.4-67.2-27.4c-30.7 0-58.1 14.4-75.6 36.9l25.1 19.8zM151.1 204.2C141.6 219.2 136 236.9 136 256c0 53 43 96 96 96c26.2 0 49.9-10.5 67.2-27.4c.7-.6 1.2-1.3 1.8-2l-25.2-19.9C264.3 313.4 249 320 232 320c-35.3 0-64-28.7-64-64c0-11.6 3.1-22.4 8.4-31.8l-25.3-20z"]
};
var faCalculatorSimple = {
  prefix: 'fal',
  iconName: 'calculator-simple',
  icon: [512, 512, ["calculator-alt"], "f64c", "M256 0c8.8 0 16 7.2 16 16V240H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V16c0-8.8 7.2-16 16-16zm88 96h40V56 48c0-8.8 7.2-16 16-16s16 7.2 16 16v8V96h40 8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8H416v40 8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8V128H344h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8zM53.1 341.1c6.2-6.2 16.4-6.2 22.6 0L112 377.4l36.3-36.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L134.6 400l36.3 36.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L112 422.6 75.7 458.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 400 53.1 363.7c-6.2-6.2-6.2-16.4 0-22.6zM48 96H176c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM336 352H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCalculatorAlt = faCalculatorSimple;
var faBridgeCircleCheck = {
  prefix: 'fal',
  iconName: 'bridge-circle-check',
  icon: [640, 512, [], "e4c9", "M48 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h80H256 384 512h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H528V64h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H512 384 256 128 48zM496 64v64H400V64h96zM368 64v64H272V64h96zM240 64v64H144V64h96zM48 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H64c35.3 0 64 28.7 64 64v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V336c0-35.3 28.7-64 64-64c9 0 17.5 1.8 25.2 5.2c5.6-9.3 12.1-18.1 19.3-26.2C351.2 244 336.1 240 320 240c-53 0-96 43-96 96v96c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336c0-53-43-96-96-96H48zm448 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faSlidersUp = {
  prefix: 'fal',
  iconName: 'sliders-up',
  icon: [512, 512, ["sliders-v"], "f3f1", "M96 0c8.8 0 16 7.2 16 16V81.6c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V238.4C43.5 231 16 198.7 16 160s27.5-71 64-78.4V16C80 7.2 87.2 0 96 0zm0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V430.4c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16V273.6c36.5 7.4 64 39.7 64 78.4zM464 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-32 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V270.4c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16v97.6c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4z"]
};
var faSlidersV = faSlidersUp;
var faLocationMinus = {
  prefix: 'fal',
  iconName: 'location-minus',
  icon: [384, 512, ["map-marker-minus"], "f609", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM96 176H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMapMarkerMinus = faLocationMinus;
var faPumpMedical = {
  prefix: 'fal',
  iconName: 'pump-medical',
  icon: [448, 512, [], "e06a", "M176 0h32c26.5 0 48 21.5 48 48h76.1c17 0 33.3 6.7 45.3 18.7l33.9 33.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L354.7 89.4c-6-6-14.1-9.4-22.6-9.4H256v48H224V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v80H128V48c0-26.5 21.5-48 48-48zM85.6 221.3l-18.7 224C65.3 464 80.1 480 98.8 480H285.2c18.7 0 33.4-16 31.9-34.7l-18.7-224c-1.4-16.6-15.2-29.3-31.9-29.3H117.4c-16.6 0-30.5 12.8-31.9 29.3zm-31.9-2.7c2.8-33.2 30.5-58.7 63.8-58.7H266.6c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zM208 288v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V288c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFingerprint = {
  prefix: 'fal',
  iconName: 'fingerprint',
  icon: [512, 512, [], "f577", "M32 256C32 132.3 132.3 32 256 32c70.3 0 133 32.4 174.1 83c5.6 6.9 15.6 7.9 22.5 2.4s7.9-15.6 2.4-22.5C408.1 37 336.3 0 256 0C114.6 0 0 114.6 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256zm470.8-68.3c-2.4-8.5-11.2-13.5-19.7-11.2s-13.5 11.2-11.2 19.7c5.2 19 8.1 39 8.1 59.7v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-23.6-3.2-46.5-9.2-68.3zM256 80c-22.8 0-44.6 4.3-64.6 12.2c-9.7 3.8-12 16.1-5.2 24.1c4.8 5.6 12.8 7.2 19.7 4.6c15.6-5.8 32.5-9 50.1-9c79.5 0 144 64.5 144 144v24.9c0 28.3-1.8 56.6-5.5 84.6c-1.3 9.7 6.2 18.5 16 18.5c7.9 0 14.6-5.8 15.6-13.6c3.9-29.6 5.8-59.5 5.8-89.5V256c0-97.2-78.8-176-176-176zM145.1 142.1c-6-7-16.8-7.6-22.8-.5C95.9 172.3 80 212.3 80 256v24.9c0 27.8-3.4 55.4-10.2 82.3c-2.6 10.4 5 20.8 15.7 20.8c7 0 13.2-4.6 15-11.4c7.7-29.9 11.6-60.7 11.6-91.7V256c0-34.7 12.3-66.5 32.7-91.4c5.4-6.5 5.9-16.1 .3-22.5zM256 160c-53 0-96 43-96 96v24.9c0 38.6-5.4 77-15.9 114c-3 10.4 4.7 21.1 15.5 21.1c6.9 0 13-4.5 14.9-11.1c11.6-40.2 17.5-82 17.5-124V256c0-35.3 28.7-64 64-64s64 28.7 64 64v24.9c0 38.8-3.9 77.5-11.7 115.4c-2.1 10.1 5.5 19.7 15.8 19.7c7.4 0 13.9-5.1 15.4-12.4c8.3-40.3 12.5-81.4 12.5-122.7V256c0-53-43-96-96-96zm16 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v24.9c0 60.9-11.2 121.2-33.1 178.1l-5.9 15.3c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2l5.9-15.3C260.1 410 272 345.7 272 280.9V256z"]
};
var faSkiBoot = {
  prefix: 'fal',
  iconName: 'ski-boot',
  icon: [512, 512, [], "e3cc", "M383.7 19.1c1.7-8.7-4-17.1-12.7-18.8s-17.1 4-18.8 12.7L348.6 32H130.3c-22.9 0-42.7 16.2-47.1 38.7L7.8 454.7C2 484.4 24.7 512 54.9 512H464h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V403.3c0-17.8-9.9-34.2-25.6-42.5L330 295.4 383.7 19.1zM239.4 64h103L317.5 192H256c-8.8 0-16 7.2-16 16s7.2 16 16 16h55.3l-12.4 64H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c1.2 0 2.3-.1 3.4-.4l132.1 69.5c5.3 2.8 8.5 8.2 8.5 14.2V480H54.9c-10.1 0-17.6-9.2-15.7-19.1l32-163.1c55-23.2 134.1-82.9 168.2-233.8zm-32.9 0C178.6 180.4 122.7 233.7 79 258.4L114.6 76.9c1.5-7.5 8.1-12.9 15.7-12.9h76.2z"]
};
var faStandardDefinition = {
  prefix: 'fal',
  iconName: 'standard-definition',
  icon: [576, 512, ["rectangle-sd"], "e28a", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 176V336c0 8.8 7.2 16 16 16h64c53 0 96-43 96-96s-43-96-96-96H320c-8.8 0-16 7.2-16 16zm32 16h48c35.3 0 64 28.7 64 64s-28.7 64-64 64H336V192zm-176.4 2.4c10.1-3.3 24.9-3.6 43.9-1.1c5.8 .8 23.7 3.8 29.2 5c8.6 2 17.2-3.4 19.2-12s-3.4-17.2-12-19.2c-6.8-1.6-25.8-4.7-32-5.5c-20.5-2.7-41-3.1-58 2.4c-18.2 5.9-32.3 18.7-36.6 40.1c-.1 .3-.1 .6-.1 .9c-1.6 11.1-.2 21.3 4.6 30.2c4.7 8.8 11.9 15 19.4 19.5c13.9 8.3 32.4 12.6 47.8 16.2l1.4 .3c17.3 4 31 7.4 40.1 12.8c4.2 2.5 6.4 4.9 7.6 7.1c1.1 2 2 5.1 1.2 10.6c-.7 4.6-2.3 7.5-4.2 9.5c-2 2.2-5.2 4.2-10.1 5.8c-10.3 3.3-25.6 3.6-44.5 1c-8.8-1.2-24-5.7-36.3-9.2l0 0c-2.7-.8-5.3-1.5-7.6-2.2c-8.5-2.4-17.4 2.5-19.8 11s2.5 17.4 11 19.8c1.8 .5 3.9 1.1 6.2 1.8l0 0c12.1 3.5 30.6 9 42 10.6l.1 0c20.4 2.7 41.4 3.2 58.5-2.2c8.8-2.8 17.2-7.3 23.8-14.4c6.8-7.2 10.9-16.3 12.5-26.7c1.6-11.1 .2-21.3-4.6-30.2c-4.7-8.8-11.9-15-19.4-19.5c-13.9-8.3-32.4-12.6-47.8-16.2l0 0-1.4-.3c-17.3-4-31-7.4-40.1-12.8c-4.2-2.5-6.4-4.9-7.6-7.1c-1-1.9-1.9-4.9-1.2-10.1c1.8-8.2 6.3-12.8 15.1-15.6z"]
};
var faRectangleSd = faStandardDefinition;
var faH1 = {
  prefix: 'fal',
  iconName: 'h1',
  icon: [576, 512, [], "f313", "M496 80c0-5.7-3-10.9-7.9-13.8s-10.9-2.9-15.9-.2l-72 40c-7.7 4.3-10.5 14-6.2 21.8s14 10.5 21.8 6.2L464 107.2V416H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H496V80zM32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80z"]
};
var faHandPointRight = {
  prefix: 'fal',
  iconName: 'hand-point-right',
  icon: [512, 512, [], "f0a4", "M456 128c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0-40 0 0-32c0-5.5-.6-10.8-1.6-16L456 128zM240 176l0 0 0 32 0 0 0 24c0 13.2-10.7 24-24 24l0 0c-13.3 0-24-10.7-24-24l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 15.7 6.4 29.8 16.8 40c-10.4 10.2-16.8 24.3-16.8 40c0 13.8 5 26.4 13.2 36.1C160.3 358.4 152 374.2 152 392c0 8.6 1.9 16.7 5.4 24C87.9 414.6 32 357.8 32 288l0-64C32 153.3 89.3 96 160 96l32 0c26.5 0 48 21.5 48 48l0 32zm32 32l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-31.9 0c0 0 0 0-.1 0l-13.4 0c3.5-7.3 5.4-15.4 5.4-24l0-24zm90.6 0l93.4 0c30.9 0 56-25.1 56-56s-25.1-56-56-56L256 96c-14.6-19.4-37.8-32-64-32l-32 0C71.6 64 0 135.6 0 224l0 64c0 88.4 71.6 160 160 160l48 0 32 0 24 0c30.9 0 56-25.1 56-56c0-12.1-3.8-23.3-10.4-32.5C325.5 349.6 336 332 336 312c0-9.7-2.5-18.8-6.8-26.7C351.7 278 368 256.9 368 232c0-8.6-1.9-16.7-5.4-24zM240 288l40 0c13.2 0 24 10.8 24 24c0 13.3-10.7 24-24 24l-16 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l0 0 24 0zm0 128l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0z"]
};
var faMagnifyingGlassLocation = {
  prefix: 'fal',
  iconName: 'magnifying-glass-location',
  icon: [512, 512, ["search-location"], "f689", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm26.2-178.4c-8.3 14.5-17.7 28.2-26.2 39.6c-8.5-11.4-17.9-25.1-26.2-39.6c-13.7-24-21.8-45.9-21.8-61.6c0-26.5 21.5-48 48-48s48 21.5 48 48c0 15.7-8.1 37.6-21.8 61.6zm-14.8 77c22.1-27 68.6-89.8 68.6-138.6c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0zM232 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSearchLocation = faMagnifyingGlassLocation;
var faMessageBot = {
  prefix: 'fal',
  iconName: 'message-bot',
  icon: [640, 512, [], "e3b8", "M224 384c17.7 0 32 14.3 32 32v48l98.1-73.6c5.5-4.2 12.3-6.4 19.2-6.4H480c17.7 0 32-14.3 32-32V192 64c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32V192 352c0 17.7 14.3 32 32 32h64zM544 64V176h36.3c5.5-9.6 15.9-16 27.7-16c17.7 0 32 14.3 32 32s-14.3 32-32 32c-11.8 0-22.2-6.4-27.7-16H544V352c0 35.3-28.7 64-64 64H373.3L249.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V448 416H192 160c-35.3 0-64-28.7-64-64V208H59.7c-5.5 9.6-15.9 16-27.7 16c-17.7 0-32-14.3-32-32s14.3-32 32-32c11.8 0 22.2 6.4 27.7 16H96V64c0-35.3 28.7-64 64-64H480c35.3 0 64 28.7 64 64zM208 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H208zm-48 16c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V144zm56 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faForwardStep = {
  prefix: 'fal',
  iconName: 'forward-step',
  icon: [320, 512, ["step-forward"], "f051", "M256 80c0-8.8 7.2-16 16-16s16 7.2 16 16V241.9v28.2V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V296.2L77.4 441.8c-5 4-11.2 6.2-17.6 6.2C44.4 448 32 435.6 32 420.2V91.8C32 76.4 44.4 64 59.8 64c6.4 0 12.6 2.2 17.6 6.2L256 215.8V80zM64 100.6V411.4L254.7 256 64 100.6z"]
};
var faStepForward = faForwardStep;
var faFaceSmileBeam = {
  prefix: 'fal',
  iconName: 'face-smile-beam',
  icon: [512, 512, [128522, "smile-beam"], "f5b8", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm-7.6-131c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 161.9 157.2 152 176 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 161.9 317.2 152 336 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"]
};
var faSmileBeam = faFaceSmileBeam;
var faLightCeiling = {
  prefix: 'fal',
  iconName: 'light-ceiling',
  icon: [512, 512, [], "e016", "M256 0c8.8 0 16 7.2 16 16V160.5c123.3 7.6 223 102.5 238 223.6c2.2 17.5-12.4 31.9-30 31.9H32C14.3 416-.2 401.6 2 384.1C17 262.9 116.7 168.1 240 160.5V16c0-8.8 7.2-16 16-16zM34.3 384H477.7C462.2 275.5 368.8 192 256 192S49.8 275.5 34.3 384zM256 512c-38.7 0-71-27.5-78.4-64h33.1c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32h33.1c-7.4 36.5-39.7 64-78.4 64z"]
};
var faMessageExclamation = {
  prefix: 'fal',
  iconName: 'message-exclamation',
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM256 80c-8.8 0-16 7.2-16 16V224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCommentAltExclamation = faMessageExclamation;
var faBowlScoop = {
  prefix: 'fal',
  iconName: 'bowl-scoop',
  icon: [448, 512, [127847, "bowl-shaved-ice"], "e3de", "M416 224H384c0-88.4-71.6-160-160-160S64 135.6 64 224H32C32 118 118 32 224 32s192 86 192 192zm29.9 65.9c-8.5 67.9-63.4 119.9-130.5 125.6c-4.1 .3-8.2 .5-12.4 .5H274.2l26.7 32 31.5 37.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2H128c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17L147.2 448l26.7-32H145c-4.2 0-8.3-.2-12.4-.5c-67.1-5.7-122-57.7-130.5-125.6L.1 274c-.6-4.6 .8-9.1 3.9-12.6s7.4-5.4 12-5.4H432c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9zM34.1 288c7.9 55 55.1 96 110.9 96h28.8 32 36.3 32H303c55.8 0 102.9-41 110.9-96H34.1zM198.4 436.5L162.2 480H285.8l-36.3-43.5L224 405.8l-25.6 30.7z"]
};
var faBowlShavedIce = faBowlScoop;
var faSquareX = {
  prefix: 'fal',
  iconName: 'square-x',
  icon: [448, 512, [], "e286", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm140.1 37.6L224 231.4l83.9-97.8c5.8-6.7 15.9-7.5 22.6-1.7s7.5 15.9 1.7 22.6L245.1 256l87.1 101.6c5.8 6.7 5 16.8-1.7 22.6s-16.8 5-22.6-1.7L224 280.6l-83.9 97.8c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.8-1.7-22.6L202.9 256 115.9 154.4c-5.8-6.7-5-16.8 1.7-22.6s16.8-5 22.6 1.7z"]
};
var faUtilityPoleDouble = {
  prefix: 'fal',
  iconName: 'utility-pole-double',
  icon: [512, 512, [], "e2c4", "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96h80V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96h15.8c.1 0 .2 0 .3 0H480V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96c0 17.7-14.3 32-32 32H437.5L304 231.8V288h80V240c0-8.8 7.2-16 16-16s16 7.2 16 16v48h15.8c.1 0 .2 0 .3 0H480V240c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 17.7-14.3 32-32 32H437.5L304 423.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V416.2c0-.1 0-.2 0-.3V320H240v95.9c0 .1 0 .2 0 .3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V423.8L74.5 320H32c-17.7 0-32-14.3-32-32V240c0-8.8 7.2-16 16-16s16 7.2 16 16v48H79.9c.1 0 .2 0 .3 0H96V240c0-8.8 7.2-16 16-16s16 7.2 16 16v48h80V231.8L74.5 128H32C14.3 128 0 113.7 0 96V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96H79.9c.1 0 .2 0 .3 0H96V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96h80V32zm-81.4 96L208 191.3V128H126.6zM240 224.2V288h32V224.2c0-.1 0-.2 0-.3V128H240v95.9c0 .1 0 .2 0 .3zm64-32.9L385.4 128H304v63.3zM126.6 320L208 383.3V320H126.6zM304 383.3L385.4 320H304v63.3zM272 32l-32 0V96h32V32z"]
};
var faFlagCheckered = {
  prefix: 'fal',
  iconName: 'flag-checkered',
  icon: [448, 512, [127937], "f11e", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V67.8 80 384v20.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V396.2l101.8-27.8c36.4-9.9 75.1-6.1 108.8 10.8c48.7 24.4 105.7 26 155.8 4.6l30.2-12.9c11.8-5 19.4-16.6 19.4-29.4V59.3c0-24.4-26.4-39.8-47.6-27.6l-15.8 9c-40.6 23.2-90.2 24.6-132.1 3.7c-37.9-18.9-81.4-23.2-122.2-12.1L32 59.1V16zm0 76.2L128 66v67.5L32 154.4V92.2zm0 94.9l96-20.9v71.3L32 258.4V187.2zm128-27.8l3.5-.8c18.3-4 37.4-3.3 55.4 2l64.4 18.9c1.6 .5 3.2 .9 4.8 1.3v70.7l-60.1-17.7c-22.1-6.5-45.3-7.6-67.9-3.3V159.3zm160 26.9c17.5 1.3 35.2-.1 52.5-4l43.5-10v71.2L365.3 255c-14.9 3.4-30.2 4.5-45.3 3.1V186.2zm-32 98.6v77.3c-10.6-2.7-21-6.5-31-11.5c-30.2-15.1-63.7-21.6-97-19V263.3l3.5-.8c18.3-4 37.4-3.3 55.4 2l64.4 18.9c1.6 .5 3.2 .9 4.8 1.3zm32 81.8V290.2c17.5 1.3 35.2-.1 52.5-4l43.5-10v65.3l-30.2 12.9c-21 9-43.5 13.1-65.8 12.3zm0-212.6v-63c27.8-.8 55.5-8.4 80.4-22.6L416 59.6v79.7L365.3 151c-14.9 3.4-30.2 4.5-45.3 3.1zM288 89v58.6l-60.1-17.7c-22.1-6.5-45.3-7.6-67.9-3.3V59.1c26.7-3 53.9 1.8 78.2 13.9c15.9 8 32.7 13.3 49.8 16zM32 291.2l96-20.9v66.6c-.9 .2-1.7 .4-2.6 .7L32 363.1V291.2z"]
};
var faChevronsUp = {
  prefix: 'fal',
  iconName: 'chevrons-up',
  icon: [512, 512, ["chevron-double-up"], "f325", "M267.3 52.7c-6.2-6.2-16.4-6.2-22.6 0l-192 192c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 86.6 436.7 267.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-192-192zm192 384l-192-192c-6.2-6.2-16.4-6.2-22.6 0l-192 192c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6 436.7 459.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"]
};
var faChevronDoubleUp = faChevronsUp;
var faFootball = {
  prefix: 'fal',
  iconName: 'football',
  icon: [512, 512, [127944, "football-ball"], "f44e", "M456.2 55.4c-48.9-8.2-92.4-10.8-130.9-8.7L464.8 186.2c3.4-47.1-.8-92.9-8.6-130.8zM220 67.1C161.1 89 120.4 126.1 93.3 170.3c-21.6 35.2-34.6 74.9-41.3 115L227.3 460.7c.2 .2 .3 .3 .5 .5c23.5-3.6 44.8-9.1 64.2-16.3c58.9-21.9 99.6-58.9 126.7-103.2c21.6-35.2 34.6-74.9 41.3-115L284.7 51.3c-.2-.2-.3-.3-.5-.5C260.7 54.4 239.4 60 220 67.1zM47.2 325.8c-3.4 47.1 .8 92.9 8.6 130.8c48.9 8.2 92.4 10.8 130.9 8.7L47.2 325.8zM208.9 37.1C274.4 12.8 357.6 6.5 461.5 23.8c13 2.2 23.4 12.1 26.1 25.1c17.5 84.8 18.6 211.3-41.6 309.5c-30.6 50-76.8 92-142.9 116.5c-65.6 24.3-148.7 30.7-252.6 13.3c-13-2.2-23.4-12.1-26.1-25.1C6.9 378.3 5.8 251.8 66 153.6c30.6-50 76.8-92 142.9-116.5zm82.4 119.5l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-56 56l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-56 56l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faFootballBall = faFootball;
var faUserVneck = {
  prefix: 'fal',
  iconName: 'user-vneck',
  icon: [448, 512, [], "e461", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm128-96A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM185.6 418.1l-57.2-76.3C72.6 358.8 32 410.7 32 472l0 8H416v-8c0-61.3-40.6-113.2-96.4-130.1l-57.2 76.3c-19.2 25.6-57.6 25.6-76.8 0zM132.1 307.8c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.1z"]
};
var faSchoolCircleExclamation = {
  prefix: 'fal',
  iconName: 'school-circle-exclamation',
  icon: [640, 512, [], "e56c", "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64V266.8c-9.1-12.9-19.9-24.5-32-34.6V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-2.9 10.2-4.8 20.8-5.8 31.7l-.7 0c-17.7 0-32 14.3-32 32v96h32 32 8.2c10 12.1 21.7 22.9 34.6 32H384 352 288 256 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H171.2l140-93.3zM416 192c0 7-.7 13.8-2.2 20.3c-31.3 16.5-57 42.2-73.5 73.5c-6.5 1.4-13.3 2.2-20.3 2.2c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zM128 160h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm0 32v64h32V192H128zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V352zm64 0H128v64h32V352zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faCrop = {
  prefix: 'fal',
  iconName: 'crop',
  icon: [512, 512, [], "f125", "M416 118.6l91.3-91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L393.4 96 160 96v32l201.4 0L128 361.4V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H96V368c0 26.5 21.5 48 48 48H352V384H150.6L384 150.6 384 496c0 8.8 7.2 16 16 16s16-7.2 16-16V416h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H416l0-265.4z"]
};
var faAnglesDown = {
  prefix: 'fal',
  iconName: 'angles-down',
  icon: [448, 512, ["angle-double-down"], "f103", "M235.3 459.3c-6.2 6.2-16.4 6.2-22.6 0l-160-160c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 425.4 372.7 276.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-160 160zm160-352l-160 160c-6.2 6.2-16.4 6.2-22.6 0l-160-160c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 233.4 372.7 84.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faAngleDoubleDown = faAnglesDown;
var faUsersRectangle = {
  prefix: 'fal',
  iconName: 'users-rectangle',
  icon: [640, 512, [], "e594", "M80 0C35.8 0 0 35.8 0 80V432c0 44.2 35.8 80 80 80H560c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80zM32 80c0-26.5 21.5-48 48-48H560c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM360 320c19.4 0 35.5 13.7 39.2 32H240.8c3.7-18.3 19.8-32 39.2-32h80zm-80-32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H320 280zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H152c-30.9 0-56 25.1-56 56v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8zM464.2 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM488 288c13.3 0 24 10.7 24 24v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-30.9-25.1-56-56-56H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h56z"]
};
var faPeopleRoof = {
  prefix: 'fal',
  iconName: 'people-roof',
  icon: [640, 512, [], "e537", "M328.5 2.5l304 192c7.5 4.7 9.7 14.6 5 22.1s-14.6 9.7-22.1 5L320 34.9 24.5 221.5c-7.5 4.7-17.4 2.5-22.1-5s-2.5-17.4 5-22.1l304-192c5.2-3.3 11.9-3.3 17.1 0zM336 192a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 208h48V289.5c-3.8-1-7.7-1.5-11.8-1.5H307.8c-4 0-8 .5-11.8 1.5V400zm122.4-15.6L376 315.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V315.5l-42.4 68.9c-.2 .3-.3 .5-.5 .8c1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 411.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V411.5L45.6 480.4c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 366.4 104 352 131.8 352h24.5c14.6 0 28.7 4 40.8 11.2l42.5-69.1C254.2 270.4 280 256 307.8 256h24.5c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2h24.5c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 411.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V411.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9c-.2-.3-.4-.5-.5-.8zM144 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 385.5V480h48V385.5c-3.8-1-7.7-1.5-11.8-1.5H131.8c-4 0-8 .5-11.8 1.5zM512 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 192h48V385.5c-3.8-1-7.7-1.5-11.8-1.5H483.8c-4 0-8 .5-11.8 1.5V480z"]
};
var faSquareArrowRight = {
  prefix: 'fal',
  iconName: 'square-arrow-right',
  icon: [448, 512, ["arrow-square-right"], "f33b", "M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM347.3 267.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 272 112 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l185.4 0-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6z"]
};
var faArrowSquareRight = faSquareArrowRight;
var faLocationPlus = {
  prefix: 'fal',
  iconName: 'location-plus',
  icon: [384, 512, ["map-marker-plus"], "f60a", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM176 288V208H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V96c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faMapMarkerPlus = faLocationPlus;
var faLightbulbExclamationOn = {
  prefix: 'fal',
  iconName: 'lightbulb-exclamation-on',
  icon: [640, 512, [], "e1ca", "M55.2 1.7l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zm544 28.6l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 160H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H560c-8.8 0-16-7.2-16-16s7.2-16 16-16zM119.2 318.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm416-28.6l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zm-96.8-31.6C454.5 234.8 464 206.6 464 176c0-79.5-64.5-144-144-144s-144 64.5-144 144c0 30.6 9.5 58.8 25.7 82.1c4.1 5.9 8.8 12.3 13.6 19l0 0c12.7 17.5 27.1 37.2 38 57.1c8.9 16.2 13.7 33.3 16.2 49.9H237c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0 0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H370.5c2.5-16.6 7.3-33.7 16.2-49.9c10.9-20 25.3-39.7 38-57.1c4.9-6.7 9.5-13 13.6-19zM320 480c20.9 0 38.7-13.4 45.3-32H274.7c6.6 18.6 24.4 32 45.3 32zm-80-53.3c0-5.9 4.8-10.7 10.7-10.7H389.3c5.9 0 10.7 4.8 10.7 10.7V432c0 44.2-35.8 80-80 80s-80-35.8-80-80v-5.3zM336 112V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 296a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPeopleLine = {
  prefix: 'fal',
  iconName: 'people-line',
  icon: [640, 512, [], "e534", "M336 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 208h48V177.5c-3.8-1-7.7-1.5-11.8-1.5H307.8c-4 0-8 .5-11.8 1.5V288zm122.4-15.6L376 203.5V288c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V203.5l-42.4 68.9c-.2 .3-.3 .5-.5 .8c1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 299.5V368c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V299.5L45.6 368.4c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 254.4 104 240 131.8 240h24.5c14.6 0 28.7 4 40.8 11.2l42.5-69.1C254.2 158.4 280 144 307.8 144h24.5c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2h24.5c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 299.5V368c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V299.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9c-.2-.3-.4-.5-.5-.8zM16 448H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zM144 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 273.5V368h48V273.5c-3.8-1-7.7-1.5-11.8-1.5H131.8c-4 0-8 .5-11.8 1.5zM512 176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 192h48V273.5c-3.8-1-7.7-1.5-11.8-1.5H483.8c-4 0-8 .5-11.8 1.5V368z"]
};
var faBeerMugEmpty = {
  prefix: 'fal',
  iconName: 'beer-mug-empty',
  icon: [512, 512, ["beer"], "f0fc", "M352 64H64V416c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V360.4c0-.2 0-.5 0-.7V64zm32 306.5V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h64c35.3 0 64 28.7 64 64V262.1c0 31.8-18.8 60.6-47.9 73.3l-80.1 35zM384 128V335.5l67.2-29.4c17.5-7.6 28.8-24.9 28.8-44V160c0-17.7-14.3-32-32-32H384zm-240 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z"]
};
var faBeer = faBeerMugEmpty;
var faCrateEmpty = {
  prefix: 'fal',
  iconName: 'crate-empty',
  icon: [512, 512, [], "e151", "M480 384v72c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V384H480zm0-32H32V280c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24v72zm32 0V280c0-30.9-25.1-56-56-56H56c-30.9 0-56 25.1-56 56v72 16 16 72c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V384 368 352zM96 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faDiagramPredecessor = {
  prefix: 'fal',
  iconName: 'diagram-predecessor',
  icon: [512, 512, [], "e477", "M480 352c0-17.7-14.3-32-32-32L64 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64zm32 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64zM256 96c0-17.7-14.3-32-32-32l-32 0L64 64C46.3 64 32 78.3 32 96l0 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-64zm23.4-32c5.4 9.4 8.6 20.3 8.6 32l0 64c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0 32 0 144 0c35.3 0 64 28.7 64 64l0 89.4 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L400 185.4 400 96c0-17.7-14.3-32-32-32l-88.6 0zM96 112l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTransporter = {
  prefix: 'fal',
  iconName: 'transporter',
  icon: [512, 512, [], "e042", "M464 0c8.8 0 16 7.2 16 16V32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16zM48 64c8.8 0 16 7.2 16 16V96H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V80c0-8.8 7.2-16 16-16zM256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM128 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm64-302.9c-.5 .6-1 1.3-1.5 1.9l-65.7 86.7c-5.3 7-15.4 8.4-22.4 3.1s-8.4-15.4-3.1-22.4L165 175.7c15.1-19.9 38.7-31.7 63.7-31.7h54.6c25 0 48.6 11.7 63.7 31.7l65.7 86.7c5.3 7 4 17.1-3.1 22.4s-17.1 4-22.4-3.1L321.5 195c-.5-.7-1-1.3-1.5-1.9V304v96 16H288V400 320H224v80 16H192V400 304 193.1zm32-16.8V288h64V176.2c-1.6-.2-3.1-.2-4.7-.2H228.7c-1.6 0-3.2 .1-4.7 .2z"]
};
var faCalendarCircleUser = {
  prefix: 'fal',
  iconName: 'calendar-circle-user',
  icon: [576, 512, [], "e471", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192H352h64 16 16V160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM492 462.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6h56.4c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8H403.8c-21.8 0-42.2 9.6-56.1 25.8C330.5 422.1 320 396.2 320 368c0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faArrowUpLong = {
  prefix: 'fal',
  iconName: 'arrow-up-long',
  icon: [384, 512, ["long-arrow-up"], "f176", "M203.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-144 144c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 54.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6L324.7 171.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-144-144z"]
};
var faLongArrowUp = faArrowUpLong;
var faPersonCarryBox = {
  prefix: 'fal',
  iconName: 'person-carry-box',
  icon: [384, 512, ["person-carry"], "f4cf", "M56 56a24 24 0 1 1 48 0A24 24 0 1 1 56 56zm80 0A56 56 0 1 0 24 56a56 56 0 1 0 112 0zM0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-130.5L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3L0 496zM60 176c7 0 13.8 1.5 20 4.2V319.4L39.1 292.2c-4.5-3-7.1-8-7.1-13.3V204c0-15.5 12.5-28 28-28zm52 38.5l37.8 58.8c5.9 9.2 16 14.7 26.9 14.7H224h16H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32V256H176.7l-47.8-74.4C113.9 158.2 87.9 144 60 144c-33.1 0-60 26.9-60 60v74.9c0 16 8 31 21.4 39.9l100.2 66.8 22.7 113.5c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L153 379.4c-1.7-8.3-6.6-15.6-13.6-20.3L112 340.8V214.5zM224 256V128H352V256H240 224z"]
};
var faPersonCarry = faPersonCarryBox;
var faFireFlameSimple = {
  prefix: 'fal',
  iconName: 'fire-flame-simple',
  icon: [384, 512, ["burn"], "f46a", "M341.8 265.5C310.2 178.6 258.9 100.2 192 36.4C125.1 100.2 73.8 178.6 42.2 265.5l-.7 1.9c-6.3 17.4-9.5 35.7-9.5 54.1C32 408.7 104.2 480 192 480s160-71.3 160-158.4c0-18.5-3.2-36.8-9.5-54.1l27.2-9.9-27.2 9.9-.7-1.9zm30.1-10.9l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3c72.9 68 128.7 152.4 162.7 246.1zM192 160c9.3 0 18.3 3.7 24.9 10.3l8.9 8.9c28.8 28.8 52.1 62.7 68.6 99.9l1.9 4.3c5 11.3 7.6 23.7 7.6 36C304 381.2 254 432 192 432s-112-50.8-112-112.5c0-12.4 2.6-24.7 7.6-36l1.9-4.3c16.5-37.2 39.8-71.1 68.6-99.9l8.9-8.9c6.6-6.6 15.6-10.3 24.9-10.3zm-2.3 32.9l-8.9 8.9c-26 26-47.1 56.6-62 90.3l-1.9 4.3c-3.2 7.2-4.9 15.1-4.9 23c0 44.3 35.9 80.5 80 80.5s80-36.2 80-80.5c0-7.9-1.7-15.8-4.9-23l-1.9-4.3c-15-33.6-36-64.3-62-90.3l-8.9-8.9c-.6-.6-1.4-.9-2.3-.9s-1.7 .4-2.3 .9z"]
};
var faBurn = faFireFlameSimple;
var faPerson = {
  prefix: 'fal',
  iconName: 'person',
  icon: [320, 512, [129485, "male"], "f183", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l58.8 110.2c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L224 202.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128z"]
};
var faMale = faPerson;
var faLaptop = {
  prefix: 'fal',
  iconName: 'laptop',
  icon: [640, 512, [128187], "f109", "M512 64H128c-17.7 0-32 14.3-32 32V352H64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H544V96c0-17.7-14.3-32-32-32zM76.8 448H563.2c20.3 0 37.4-13.5 42.9-32H33.9c5.5 18.5 22.7 32 42.9 32zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2z"]
};
var faFileCsv = {
  prefix: 'fal',
  iconName: 'file-csv',
  icon: [512, 512, [], "f6dd", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"]
};
var faMenorah = {
  prefix: 'fal',
  iconName: 'menorah',
  icon: [640, 512, [], "f676", "M48 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16C16 7.2 23.2 0 32 0s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM32 128c8.8 0 16 7.2 16 16l0 160c0 26.5 21.5 48 48 48h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352h64l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 208h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352h16c26.5 0 48-21.5 48-48l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 44.2-35.8 80-80 80H336v96H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 144c-8.8 0-16-7.2-16-16s7.2-16 16-16H304V384H96c-44.2 0-80-35.8-80-80l0-160c0-8.8 7.2-16 16-16z"]
};
var faUnion = {
  prefix: 'fal',
  iconName: 'union',
  icon: [384, 512, [8899], "f6a2", "M16 32c8.8 0 16 7.2 16 16V288c0 88.4 71.6 160 160 160s160-71.6 160-160V48c0-8.8 7.2-16 16-16s16 7.2 16 16V288c0 106-86 192-192 192S0 394 0 288V48c0-8.8 7.2-16 16-16z"]
};
var faChevronsLeft = {
  prefix: 'fal',
  iconName: 'chevrons-left',
  icon: [512, 512, ["chevron-double-left"], "f323", "M52.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 256 267.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-192 192zm384-192l-192 192c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256 459.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faChevronDoubleLeft = faChevronsLeft;
var faCircleHeart = {
  prefix: 'fal',
  iconName: 'circle-heart',
  icon: [512, 512, ["heart-circle"], "f4c7", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM131.9 164.9c-29.4 29.8-29.4 78.2 0 108L233.5 376.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L380.1 272.9c29.4-29.8 29.4-78.2 0-108c-27.8-28.2-71.9-29.7-101.5-4.6c-5.8 4.9-11 10.4-16.3 15.9c-2.1 2.2-4.2 4.5-6.4 6.6c-2.1-2.2-4.3-4.4-6.4-6.6c-5.2-5.5-10.5-11-16.3-15.9c-29.6-25.1-73.7-23.6-101.5 4.6zm83.6 22.5l29.1 29.6c6.3 6.4 16.5 6.4 22.8 0l29.1-29.6c16.8-17.1 44-17.1 60.8 0c17.1 17.4 17.1 45.7 0 63.1L256 353.3 154.7 250.4c-17.1-17.4-17.1-45.7 0-63.1c16.8-17.1 44-17.1 60.8 0z"]
};
var faHeartCircle = faCircleHeart;
var faTruckPlane = {
  prefix: 'fal',
  iconName: 'truck-plane',
  icon: [640, 512, [], "e58f", "M189.2 13.3C198.8 5.7 210.6 0 224 0c26.9 0 47.1 21.6 59.2 41.8c10.4 17.3 17.7 38 20 56.3c-12.3 3.3-23.1 10.2-31.2 19.4v-7.8c0-13.6-5.9-34.2-16.2-51.4C244.9 40.2 233.1 32 224 32c-4.1 0-9 1.7-14.8 6.3c-5.8 4.6-11.5 11.5-16.7 20C182.1 75.6 176 96.2 176 109.7v80c0 5.7-3.1 11-8.1 13.9L40.1 276.7c-5 2.8-8.1 8.2-8.1 13.9v56.2l123.6-35.3c4.8-1.4 10-.4 14 2.6s6.4 7.8 6.4 12.8l0 57.1c0 5-2.4 9.8-6.4 12.8L112 440v39.4l107.6-30.7c2.9-.8 5.9-.8 8.8 0l38.8 11.1c5.4 7.8 12.5 14.4 20.8 19.2v20l-64-18.3L118.3 510.8l0 0c-2.7 .8-5.5 1.2-8.3 1.2c-16.6 0-30-13.4-30-30V440c0-10.1 4.7-19.6 12.8-25.6L144 376l0-27.9L40.8 377.6C20.3 383.4 0 368 0 346.8V290.6c0-17.2 9.2-33.1 24.2-41.7L144 180.4V109.7c0-20.7 8.4-46.9 21.2-67.9c6.5-10.7 14.5-20.8 24-28.4zM592 160H336c-8.8 0-16 7.2-16 16V312.6c4.3-2.5 8.9-4.5 13.8-5.9l3.5-11.8 12.4-41.2c8.1-27.1 33-45.6 61.3-45.6H517c28.3 0 53.2 18.5 61.3 45.6l12.4 41.2 3.5 11.8c4.9 1.4 9.5 3.4 13.8 5.9V176c0-8.8-7.2-16-16-16zm48 208v48c0 20.9-13.4 38.7-32 45.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V464H352v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V461.3c-18.6-6.6-32-24.4-32-45.3V368 176c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V368zm-32 48V368c0-17.7-14.3-32-32-32H560 368 352c-17.7 0-32 14.3-32 32v48c0 8.8 7.2 16 16 16H592c8.8 0 16-7.2 16-16zM560 304l-9.6-32-2.8-9.2C543.6 249.3 531.1 240 517 240H411c-14.1 0-26.6 9.3-30.6 22.8l-2.8 9.2L368 304h33.4H526.6 560zM376 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faRecordVinyl = {
  prefix: 'fal',
  iconName: 'record-vinyl',
  icon: [512, 512, [], "f8d9", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBringForward = {
  prefix: 'fal',
  iconName: 'bring-forward',
  icon: [512, 512, [], "f856", "M224 480H448c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H384V160h64c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V384h32v64c0 17.7 14.3 32 32 32zM64 320H288c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V288c0 17.7 14.3 32 32 32zm224 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64zm-32-96V96H96V256H256zm32 0c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H256c17.7 0 32 14.3 32 32V256z"]
};
var faSquareP = {
  prefix: 'fal',
  iconName: 'square-p',
  icon: [448, 512, [], "e279", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32h88c48.6 0 88 39.4 88 88s-39.4 88-88 88H160v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288 144c0-8.8 7.2-16 16-16zm88 144c30.9 0 56-25.1 56-56s-25.1-56-56-56H160V272h72z"]
};
var faFaceGrinStars = {
  prefix: 'fal',
  iconName: 'face-grin-stars',
  icon: [512, 512, [129321, "grin-stars"], "f587", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm90-166.2c-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3s61.4-2.9 89.9-8.3zm33.8-41.1c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7c5.2-11.7-6.8-22.4-19.1-18.7zM160 104c-6.2 0-11.8 3.5-14.4 9.1l-19.3 40.4-44.4 5.9c-6.1 .8-11.2 5.1-13.1 10.9s-.3 12.3 4.2 16.5l32.5 30.9-8.2 44.1c-1.1 6.1 1.3 12.2 6.3 15.9s11.6 4.1 17 1.1L160 257.4l39.4 21.4c5.4 2.9 12 2.5 17-1.1s7.5-9.8 6.3-15.9l-8.2-44.1 32.5-30.9c4.5-4.2 6.1-10.7 4.2-16.5s-7-10.1-13.1-10.9l-44.4-5.9-19.3-40.4c-2.7-5.6-8.3-9.1-14.4-9.1zm0 53.2l8.6 18c2.3 4.9 7 8.3 12.3 9l19.8 2.6-14.5 13.7c-3.9 3.7-5.7 9.2-4.7 14.5l3.6 19.6-17.6-9.5c-4.8-2.6-10.5-2.6-15.3 0l-17.6 9.5 3.6-19.6c1-5.3-.8-10.8-4.7-14.5l-14.5-13.7 19.8-2.6c5.4-.7 10-4.1 12.3-9l8.6-18zM352 104c-6.2 0-11.8 3.5-14.4 9.1l-19.3 40.4-44.4 5.9c-6.1 .8-11.2 5.1-13.1 10.9s-.3 12.3 4.2 16.5l32.5 30.9-8.2 44.1c-1.1 6.1 1.3 12.2 6.3 15.9s11.6 4.1 17 1.1L352 257.4l39.4 21.4c5.4 2.9 12 2.5 17-1.1s7.4-9.8 6.3-15.9l-8.2-44.1 32.5-30.9c4.5-4.2 6.1-10.7 4.2-16.5s-7-10.1-13.1-10.9l-44.4-5.9-19.3-40.4c-2.7-5.6-8.3-9.1-14.4-9.1zm0 53.2l8.6 18c2.3 4.9 7 8.3 12.3 9l19.8 2.6-14.5 13.7c-3.9 3.7-5.7 9.2-4.7 14.5l3.6 19.6-17.6-9.5c-4.8-2.6-10.5-2.6-15.3 0l-17.6 9.5 3.6-19.6c1-5.3-.8-10.8-4.7-14.5l-14.5-13.7 19.8-2.6c5.4-.7 10-4.1 12.3-9l8.6-18z"]
};
var faGrinStars = faFaceGrinStars;
var faSigma = {
  prefix: 'fal',
  iconName: 'sigma',
  icon: [384, 512, [8721], "f68b", "M1.3 41.6C3.9 35.8 9.6 32 16 32H344c22.1 0 40 17.9 40 40v72c0 8.8-7.2 16-16 16s-16-7.2-16-16V72c0-4.4-3.6-8-8-8H52.5L219.8 245.1c5.7 6.1 5.7 15.6 0 21.7L52.5 448H344c4.4 0 8-3.6 8-8V368c0-8.8 7.2-16 16-16s16 7.2 16 16v72c0 22.1-17.9 40-40 40H16c-6.4 0-12.1-3.8-14.7-9.6s-1.4-12.6 2.9-17.3L186.2 256 4.2 58.9C-.1 54.2-1.2 47.4 1.3 41.6z"]
};
var faCameraMovie = {
  prefix: 'fal',
  iconName: 'camera-movie',
  icon: [576, 512, [127909, 127910], "f8a9", "M144 0c40.8 0 76.4 21.8 96 54.3C259.6 21.8 295.2 0 336 0c61.9 0 112 50.1 112 112s-50.1 112-112 112H144C82.1 224 32 173.9 32 112S82.1 0 144 0zM64 112c0 44.2 35.8 80 80 80H336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-39.6 0-72.5 28.8-78.9 66.6c-1.3 7.7-8 13.4-15.8 13.4h-2.7c-7.8 0-14.5-5.6-15.8-13.4C216.5 60.8 183.6 32 144 32c-44.2 0-80 35.8-80 80zm80-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 288h-8c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H136zm0-32H352c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V320c0-11.7 3.1-22.6 8.6-32H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H128h8zM448 440.9l85.4 38.4c1 .4 2 .7 3.1 .7c4.2 0 7.5-3.4 7.5-7.5V291.9c0-3.2-2.9-5.6-6-5.1c-.4 .1-.9 .2-1.3 .4L448 327.1V292l75.6-34c2.9-1.3 6-2.2 9.1-2.8c22.6-3.8 43.3 13.7 43.3 36.6V472.5c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L448 476V440.9z"]
};
var faBong = {
  prefix: 'fal',
  iconName: 'bong',
  icon: [448, 512, [], "f55c", "M128 208.5c0 17.4-9.3 32.4-22.5 40.9C79 266.4 58 291 45.3 320H338.7c-12.7-29-33.7-53.6-60.2-70.6c-13.2-8.5-22.5-23.5-22.5-40.9V32H128V208.5zM35.2 352c-2.1 10.3-3.2 21-3.2 32c0 32.9 9.9 63.4 26.9 88.8c2.4 3.5 8 7.2 17.2 7.2H307.9c9.2 0 14.9-3.7 17.2-7.2c17-25.4 26.9-55.9 26.9-88.8c0-11-1.1-21.7-3.2-32H35.2zM96 208.5V32H80c-8.8 0-16-7.2-16-16S71.2 0 80 0h32H272h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H288V208.5c0 5.7 3.1 10.9 7.9 14c13.4 8.6 25.7 18.9 36.5 30.5l45-45-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l32 32 32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L400 230.6l-47.7 47.7C372.3 308.6 384 345 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14z"]
};
var faClarinet = {
  prefix: 'fal',
  iconName: 'clarinet',
  icon: [640, 512, [], "f8ad", "M224 112c0-8.8 7.2-16 16-16h32 96 96 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v32h44.6c7.9 0 15.6-2.3 22.2-6.7L602.7 116c7.4-4.9 16.8-5.4 24.6-1.2S640 127.1 640 136V376c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-55.9-37.3c-6.6-4.4-14.3-6.7-22.2-6.7H113.4c-8.6 0-17.1-1.3-25.3-3.7L17.1 327C7 323.9 0 314.6 0 304V208c0-10.6 7-19.9 17.1-23l71-21.3c8.2-2.5 16.7-3.7 25.3-3.7H256V128H240c-8.8 0-16-7.2-16-16zm224 16H384v32h64V128zm-96 0H288v32h64V128zm256 22.9l-43.4 29c-11.8 7.9-25.7 12.1-39.9 12.1H113.4c-5.5 0-10.9 .8-16.1 2.4L32 214V298l65.3 19.6c5.2 1.6 10.6 2.4 16.1 2.4H524.6c14.2 0 28.1 4.2 39.9 12.1l43.4 29V150.9zM272 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTruckFlatbed = {
  prefix: 'fal',
  iconName: 'truck-flatbed',
  icon: [640, 512, [], "e2b6", "M408 96c-13.3 0-24 10.7-24 24V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H408zm8 160H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4V256zm154.9-32H416V128h65.3c4.7 0 9.1 2 12.1 5.6L570.9 224zM96 416a64 64 0 1 1 128 0A64 64 0 1 1 96 416zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSpaghettiMonsterFlying = {
  prefix: 'fal',
  iconName: 'spaghetti-monster-flying',
  icon: [640, 512, ["pastafarianism"], "f67b", "M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm42 80.3c13.5-11.7 22-29 22-48.3c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c4.6 0 9.1-.5 13.4-1.4L219 153.7c-24.9 14.5-43.8 33.5-59.2 52.1c-7.6 9.1-14.4 18.2-20.6 26.4l-.5 .7c-6.4 8.5-12 15.9-17.4 22.2c-11.3 13-18.7 17-25.2 17c-5 0-8.7-1.8-12.7-5.5c-4.5-4.4-8.5-10.5-13.8-18.9l-.5-.7c-4.7-7.5-10.6-16.9-18.3-24.3C42.3 214.2 31 208 16 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c5 0 8.7 1.8 12.7 5.5c4.5 4.4 8.5 10.5 13.8 18.9l.5 .7c4.7 7.5 10.6 16.9 18.3 24.3C69.7 297.8 81 304 96 304c19.4 0 34.1-11.4 45.7-23.9l1 1.5c4.4 6.5 10.2 14.3 17.2 22.6c-3 8.5-5.6 17-8 24.9l0 0-1.3 4.3c-3.4 11.2-6.5 20.8-10.2 28.8c-3.7 8-7.5 13.3-11.7 16.7c-3.8 3-8.8 5.2-16.7 5.2c-11 0-21-5.3-36.8-13.8l-.6-.3c-15-8-34.2-17.9-58.5-17.9c-8.8 0-16 7.2-16 16s7.2 16 16 16c15.6 0 28.5 6.1 43.5 14.1l3.1 1.7C75.9 407 92.7 416 112 416c14.6 0 26.8-4.2 36.7-12.2c9.6-7.6 16-17.9 20.8-28.2c4.8-10.3 8.4-21.9 11.8-32.9l1.3-4.4c.9-2.8 1.7-5.6 2.6-8.4c19.3 17 44.1 33.4 74.6 43.2l-1 3.4 0 0c-5.4 18.4-13 43.8-24.3 65.6c-13 25-27.2 37.9-42.4 37.9c-8.8 0-16 7.2-16 16s7.2 16 16 16c35.1 0 57.3-29.1 70.8-55.1c12.8-24.7 21.2-53.1 26.6-71.2c.5-1.8 1-3.5 1.5-5.1l.1-.3c9.2 1.4 18.9 2.1 29 2.1s19.7-.7 29-2.1l.1 .3c.5 1.6 1 3.3 1.5 5.1l0 0c5.3 18.1 13.8 46.5 26.6 71.2c13.5 26 35.8 55.1 70.8 55.1c8.8 0 16-7.2 16-16s-7.2-16-16-16c-15.2 0-29.4-12.9-42.4-37.9c-11.3-21.8-18.9-47.2-24.3-65.6l0 0 0 0-1-3.4c30.5-9.8 55.3-26.2 74.6-43.2c.9 2.8 1.7 5.6 2.6 8.4l1.3 4.4c3.4 11 7 22.6 11.8 32.9c4.8 10.3 11.2 20.6 20.8 28.2c9.9 7.9 22.1 12.2 36.7 12.2c19.3 0 36.1-9 49.4-16.2l3.1-1.7c15-8 27.8-14.1 43.5-14.1c8.8 0 16-7.2 16-16s-7.2-16-16-16c-24.4 0-43.5 9.9-58.5 17.9l-.6 .3C549 378.7 539 384 528 384c-7.9 0-12.9-2.1-16.7-5.2c-4.2-3.3-8-8.6-11.7-16.7c-3.7-8.1-6.8-17.7-10.2-28.8l-1.3-4.3c-2.4-7.9-5-16.4-8-24.9c7.1-8.3 12.8-16.1 17.2-22.6l1-1.5C509.9 292.6 524.6 304 544 304c15 0 26.3-6.2 34.8-14.5c7.7-7.4 13.6-16.8 18.3-24.3l0 0 0 0 .5-.7c5.3-8.4 9.2-14.6 13.8-18.9c3.9-3.8 7.6-5.5 12.7-5.5c8.8 0 16-7.2 16-16s-7.2-16-16-16c-15 0-26.3 6.2-34.8 14.5c-7.7 7.4-13.6 16.8-18.3 24.3l0 0 0 0-.5 .7c-5.3 8.4-9.2 14.6-13.8 18.9c-3.9 3.8-7.6 5.5-12.7 5.5c-6.5 0-13.9-4-25.2-17c-5.4-6.2-11-13.6-17.4-22.2l-.5-.7c-6.2-8.2-13-17.3-20.6-26.4c-15.5-18.6-34.4-37.5-59.2-52.1l13.5-27.1c4.3 .9 8.8 1.4 13.4 1.4c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 19.3 8.5 36.5 22 48.3L392.1 140c-20.4-7.5-44.2-12-72.1-12s-51.7 4.5-72.1 12L234 112.3zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm4.6 259.8c-.9 .8-1.7 1.7-2.5 2.6c-2.2 2.4-4.6 4.8-7.1 7.2c-27.3 26.3-67.9 52-123 52s-95.7-25.6-123-52c-2.5-2.4-4.8-4.8-7.1-7.2c-.7-1-1.5-1.8-2.5-2.6c-8.9-9.7-15.9-19-20.9-26.4c-2.3-3.4-4.2-6.4-5.7-8.9l3.4-4.5 .3-.4c6.3-8.4 12.7-16.9 19.8-25.4C212.5 192.3 250.4 160 320 160s107.5 32.3 135.7 66.2c7.1 8.5 13.5 17 19.8 25.4l.3 .4 3.4 4.5c-1.5 2.5-3.4 5.5-5.7 8.9c-5 7.4-12 16.7-20.9 26.4z"]
};
var faPastafarianism = faSpaghettiMonsterFlying;
var faArrowDownUpAcrossLine = {
  prefix: 'fal',
  iconName: 'arrow-down-up-across-line',
  icon: [576, 512, [], "e4af", "M148.7 507.3c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 457.4V272H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L400 54.6V240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H144V457.4L75.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96zM144 192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V192zM432 320H400V464c0 8.8 7.2 16 16 16s16-7.2 16-16V320z"]
};
var faLeafHeart = {
  prefix: 'fal',
  iconName: 'leaf-heart',
  icon: [512, 512, [], "f4cb", "M272 128l104 0c37.4 0 71.5-14.3 97.1-37.7c4.5 21.1 6.9 43.3 6.9 66.3c0 149-98.2 258.9-207.2 259.4l-.8 0h0c-79.5 0-144-64.5-144-144c0-79.5 64.5-144 144-144zM463.2 54.3C442.6 79.8 411.2 96 376 96L272 96C174.8 96 96 174.8 96 272c0 2.5 .1 4.9 .2 7.4c-.1-2.4-.2-4.9-.2-7.4c0-4 .1-8 .4-12C41.2 295.7 4 356.9 1.4 427.1L0 463.4c-.3 8.8 6.6 16.3 15.4 16.6s16.3-6.6 16.6-15.4l1.3-36.3C35.3 375.8 60 329.4 98 298.4l0 0C110.7 383.1 183.8 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-33.9-4.8-66.5-13.5-96.8l-.4-1.5c-1.1-3.6-2.2-7.2-3.4-10.8s-2.4-7.1-3.7-10.6c-2.6-6.9-12.7-6.6-16.2-.1c-1.4 2.7-3 5.3-4.6 7.8c-2 3.1-4.1 6.1-6.4 8.9l-.6 .8zM97.7 296.6c.1 .6 .2 1.2 .3 1.7l-.3-1.7zm124-53.8c0-11.9 9.6-21.5 21.5-21.5h1.5c6 0 11.7 2.3 16 6.5l16.1 15.6c6.2 6 16.1 6 22.3 0l16.1-15.6c4.3-4.2 10.1-6.5 16-6.5h1.5c11.9 0 21.5 9.6 21.5 21.5c0 5.8-2.3 11.4-6.5 15.4L288 316.4l-59.8-58.1c-4.2-4-6.5-9.6-6.5-15.4zm21.5-53.5c-29.5 0-53.5 23.9-53.5 53.5c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5z"]
};
var faHouseBuilding = {
  prefix: 'fal',
  iconName: 'house-building',
  icon: [640, 512, [], "e1b1", "M320 32H576c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H414.4c-2.4 11.8-7.4 22.7-14.4 32H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H320c-35.3 0-64 28.7-64 64V95.3l32 29.3V64c0-17.7 14.3-32 32-32zM496 208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H496zm0 32h32v32H496V240zM464 368v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V368c0-17.7-14.3-32-32-32H496c-17.7 0-32 14.3-32 32zm64 0v32H496V368h32zM368 80c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H368zm0 32h32v32H368V112zm96 0v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H496c-17.7 0-32 14.3-32 32zm64 0v32H496V112h32zM32 284.2c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V284.2zM0 448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237C7.5 249.1 0 266.2 0 284.2V448zM224 288v64H160V288h64zm-64-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H160z"]
};
var faCheeseSwiss = {
  prefix: 'fal',
  iconName: 'cheese-swiss',
  icon: [512, 512, [129472], "f7f0", "M480 240.2V256H413.3c-6.6-18.6-24.4-32-45.3-32s-38.7 13.4-45.3 32H32c0-9.3 4.6-18 12.4-23.1l148.7-99.2c-.7 3.3-1.1 6.7-1.1 10.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-23.6-17-43.2-39.4-47.2l44.1-29.4L274.9 40.7l17.8 26.6c3.3-2.2 7.2-3.4 11.1-3.4C401.1 64 480 142.9 480 240.2zM322.7 288c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32H480V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V288H322.7zm-19-256c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V256 240.2C512 125.2 418.8 32 303.8 32zM160 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm16-240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM352 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faSpoon = {
  prefix: 'fal',
  iconName: 'spoon',
  icon: [512, 512, [129348, 61873, "utensil-spoon"], "f2e5", "M274.7 205.3l32 32c12.5 12.5 28.7 18.7 45.1 18.7c27.5 0 59.3-17 85.5-48.5C463.3 176.4 480 135.5 480 96c0-35.3-28.7-64-64-64c-39.5 0-80.4 16.7-111.5 42.6C273 100.9 256 132.7 256 160.1c0 16.4 6.3 32.6 18.7 45.1zm-22.6 22.6c-18.7-18.7-28.1-43.2-28.1-67.7C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-24.5 0-49-9.4-67.7-28.1l-4.7-4.7L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L256.8 232.6l-4.7-4.7z"]
};
var faUtensilSpoon = faSpoon;
var faJarWheat = {
  prefix: 'fal',
  iconName: 'jar-wheat',
  icon: [320, 512, [], "e517", "M48 16c0 8.8 7.2 16 16 16H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H64C55.2 0 48 7.2 48 16zM256 96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H256zM64 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm80 384c0 8.8 7.2 16 16 16s16-7.2 16-16V432h8c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16H224c-26.2 0-49.4 12.6-64 32c-14.6-19.4-37.8-32-64-32H72c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80h8v16zm34.7-48c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zM96 368c20.9 0 38.7 13.4 45.3 32H136c-20.9 0-38.7-13.4-45.3-32H96zm82.7-176c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zM264 144c0-8.8-7.2-16-16-16H224c-26.2 0-49.4 12.6-64 32c-14.6-19.4-37.8-32-64-32l-24 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80h24 24c44.2 0 80-35.8 80-80zM96 160c20.9 0 38.7 13.4 45.3 32H136c-20.9 0-38.7-13.4-45.3-32H96zm82.7 136c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zM264 248c0-8.8-7.2-16-16-16H224c-26.2 0-49.4 12.6-64 32c-14.6-19.4-37.8-32-64-32H72c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80h24 24c44.2 0 80-35.8 80-80zM96 264c20.9 0 38.7 13.4 45.3 32H136c-20.9 0-38.7-13.4-45.3-32H96z"]
};
var faEnvelopesBulk = {
  prefix: 'fal',
  iconName: 'envelopes-bulk',
  icon: [640, 512, ["mail-bulk"], "f674", "M112 32H400c8.8 0 16 7.2 16 16V64h32V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48V192H96V48c0-8.8 7.2-16 16-16zM224 144c0-8.8 7.2-16 16-16H592c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H416v32H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48v48h32V144zM48 256H336c8.8 0 16 7.2 16 16v5L196.9 391.9c-1.4 1-3.1 1.6-4.9 1.6s-3.5-.6-4.9-1.6L32 277v-5c0-8.8 7.2-16 16-16zM32 464V316.8L168 417.6c6.9 5.1 15.3 7.9 24 7.9s17-2.8 24-7.9L352 316.8V464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16zM48 224c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm448-64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H496zm16 64V192h32v32H512z"]
};
var faMailBulk = faEnvelopesBulk;
var faFileCircleExclamation = {
  prefix: 'fal',
  iconName: 'file-circle-exclamation',
  icon: [576, 512, [], "e4eb", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faBowArrow = {
  prefix: 'fal',
  iconName: 'bow-arrow',
  icon: [512, 512, [127993], "f6b9", "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1 .3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16L397.4 92 153.7 335.7l-59.9-15c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-15-59.9L420 114.6l40.7 40.7c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zm-49.9 92.3L400.8 50.1 476 36l-14.1 75.2zm-81.2 88C403 234.1 416 275.5 416 320c0 47.9-15 92.3-40.7 128.7L253.3 326.6l-22.6 22.6L388.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-13-13C429.5 429.2 448 376.8 448 320c0-53.3-16.3-102.9-44.2-143.9l-23.1 23.1zM4.7 123.3L162.7 281.4l22.6-22.6L63.3 136.7C99.7 111 144.1 96 192 96c44.5 0 85.9 13 120.8 35.3l23.1-23.1C294.9 80.3 245.3 64 192 64C135.2 64 82.8 82.5 40.4 113.7l-13-13c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM99.3 436c-2.9-11.5-11.8-20.4-23.3-23.3l-36.3-9.1 50.8-50.8 54.9 13.7 13.7 54.9-50.8 50.8L99.3 436z"]
};
var faCartXmark = {
  prefix: 'fal',
  iconName: 'cart-xmark',
  icon: [576, 512, [], "e0dd", "M0 16C0 7.2 7.2 0 16 0H53.9c22.8 0 42.5 16 47 38.4L145.4 256H466.5c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM379.3 91.3L342.6 128l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 150.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 128 260.7 91.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L320 105.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faHexagonXmark = {
  prefix: 'fal',
  iconName: 'hexagon-xmark',
  icon: [512, 512, ["times-hexagon", "xmark-hexagon"], "f2ee", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zm137-59.3c6.2-6.2 16.4-6.2 22.6 0L256 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faTimesHexagon = faHexagonXmark;
var faXmarkHexagon = faHexagonXmark;
var faCircleH = {
  prefix: 'fal',
  iconName: 'circle-h',
  icon: [512, 512, [9405, "hospital-symbol"], "f47e", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96l-160 0V144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96H336v96c0 8.8 7.2 16 16 16s16-7.2 16-16V256 144z"]
};
var faHospitalSymbol = faCircleH;
var faMerge = {
  prefix: 'fal',
  iconName: 'merge',
  icon: [512, 512, [], "e526", "M0 80c0-8.8 7.2-16 16-16H96h47.7c15.4 0 29.8 7.3 38.8 19.8L291.4 233.4c3 4.1 7.8 6.6 12.9 6.6H457.4l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 272H304.3c-5.1 0-9.9 2.4-12.9 6.6L182.5 428.2c-9 12.4-23.5 19.8-38.8 19.8H96 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H96h47.7c5.1 0 9.9-2.4 12.9-6.6L265.5 259.8c1-1.3 2-2.6 3-3.8c-1.1-1.2-2.1-2.5-3-3.8L156.6 102.6c-3-4.1-7.8-6.6-12.9-6.6H96 16C7.2 96 0 88.8 0 80z"]
};
var faPager = {
  prefix: 'fal',
  iconName: 'pager',
  icon: [512, 512, [128223], "f815", "M448 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H448zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm0 272c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM96 160H416v96H96l0-96zm-32 0v96c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"]
};
var faCartMinus = {
  prefix: 'fal',
  iconName: 'cart-minus',
  icon: [576, 512, [], "e0db", "M0 16C0 7.2 7.2 0 16 0H53.9c22.8 0 42.5 16 47 38.4L145.4 256H466.5c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM256 112H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faAddressBook = {
  prefix: 'fal',
  iconName: 'address-book',
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M96 32C78.3 32 64 46.3 64 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H96zM32 64C32 28.7 60.7 0 96 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM272 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm32 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48H208zM512 80v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zM496 192c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm16 144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faContactBook = faAddressBook;
var faPanFrying = {
  prefix: 'fal',
  iconName: 'pan-frying',
  icon: [576, 512, [127859], "e42c", "M224 32a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 416c53 0 101.6-18.4 140-49.1l77 87c14.7 16.6 35.8 26.1 57.9 26.1c42.5 0 77.2-34.5 77.2-77c0-26.7-13.8-51.5-36.6-65.5L433.3 304c9.5-24.8 14.7-51.8 14.7-80C448 100.3 347.7 0 224 0S0 100.3 0 224S100.3 448 224 448zm240.9 16.7l-77.5-87.6c12.4-13.3 23.3-28 32.2-44l103 63.5c13.3 8.2 21.4 22.7 21.4 38.3c0 24.8-20.2 45-45.2 45c-13 0-25.4-5.6-33.9-15.3zM496 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM152.6 102.3c-14.5 13.9-22.6 32.1-24.3 50.7c-2.1 23.5-8.7 52.4-19.4 71C82.4 269.9 98.1 328.6 144 355.1s104.6 10.8 131.1-35.1c2.9-5.1 8.9-10.9 16.9-15.8c7.9-4.9 16.4-8 23.1-9c12.8-1.8 25.4-6.7 36.5-15c35.5-26.3 42.9-76.4 16.6-111.9c-11.4-15.3-27.2-25.5-44.4-29.8c-8.7-2.2-20-7.1-31-13.6s-20.9-13.8-27.1-20.3c-30.6-31.9-81.3-32.9-113.1-2.2zm90 24.4c8.9 9.3 21.4 18.4 34.1 25.8s26.7 13.8 39.2 17c10.3 2.6 19.8 8.7 26.6 17.9c15.8 21.3 11.3 51.4-10 67.1c-6.7 5-14.2 7.9-21.9 9c-11.9 1.7-24.6 6.7-35.4 13.4c-10.8 6.7-21.4 15.9-27.8 27.1c-17.7 30.6-56.8 41.1-87.4 23.4s-41.1-56.8-23.4-87.4c14-24.3 21.3-58.4 23.6-84.2c1-11.2 5.8-22 14.5-30.4c19.1-18.4 49.5-17.8 67.9 1.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
};
var faGrid = {
  prefix: 'fal',
  iconName: 'grid',
  icon: [448, 512, ["grid-3"], "e195", "M88 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8H88zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zM88 224c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8H88zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zm0 192H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zM0 392v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zM200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zm0 192h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200zM360 64h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360zm0 192h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40z"]
};
var faGrid3 = faGrid;
var faFootballHelmet = {
  prefix: 'fal',
  iconName: 'football-helmet',
  icon: [512, 512, [], "f44f", "M456 198.7L277.1 221.1c-30.3 3.8-53.1 29.6-53.1 60.1c0 9.4 2.2 18.7 6.4 27.1l38.2 76.4c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 17.7-14.3 32-32 32h-2.9c-4.3 0-8.6-.9-12.6-2.6l-93.9-40.2c-8-3.4-16.5-5.2-25.2-5.2H92c-27.6-35.3-44-79.7-44-128C48 141.1 141.1 48 256 48c95 0 175.2 63.7 200 150.7zm6.4 31.4c17.5-2.2 30.2-18.3 25.7-35.3C461.1 91.9 367.4 16 256 16C123.5 16 16 123.5 16 256c0 56.3 19.4 108.1 51.9 149.1c5.7 7.1 14.4 10.9 23.5 10.9h14c4.3 0 8.6 .9 12.6 2.6l93.9 40.2c8 3.4 16.5 5.2 25.2 5.2H240c35.3 0 64-28.7 64-64v-.9c0-9.9-2.3-19.7-6.8-28.6L288 352h39.7l9.6 50.9c10.1 54 57.2 93.1 112.1 93.1h17c25.2 0 45.6-20.4 45.6-45.6V400 368c0-26.5-21.5-48-48-48H354.3l-14-74.5 122.2-15.3zm-154 19.2L321.7 320H272l-13-26c-2-4-3-8.4-3-12.8c0-14.4 10.7-26.6 25.1-28.4l27.4-3.4zM200 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 48H366.3l-6-32H464c8.8 0 16 7.2 16 16v16zM374.7 416H480v34.4c0 7.5-6.1 13.6-13.6 13.6h-17c-32.7 0-61.6-19.3-74.7-48z"]
};
var faHandLove = {
  prefix: 'fal',
  iconName: 'hand-love',
  icon: [512, 512, [], "e1a5", "M184 32c13.3 0 24 10.7 24 24V200l0 0v96c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56V232 176 120c0-13.3 10.7-24 24-24s24 10.7 24 24V336c0 79.5-64.5 144-144 144h-8.5c-57.3 0-112.2-22.8-152.7-63.3L39 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V56c0-13.3 10.7-24 24-24zM288 296c0 13.3-10.7 24-24 24s-24-10.7-24-24V199.9c0-13.2 10.8-23.9 24-23.9c13.3 0 24 10.7 24 24l0 8v24 64zm32-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V232zm48-50.6c-7.3-3.5-15.4-5.4-24-5.4c-9.7 0-18.8 2.5-26.7 6.8C310 160.3 288.9 144 264 144c-8.6 0-16.7 1.9-24 5.4L240 80l0 0V56c0-30.9-25.1-56-56-56s-56 25.1-56 56V288.8L95.6 256.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2L120.2 439.4C166.7 485.9 229.8 512 295.5 512H304c97.2 0 176-78.8 176-176V120c0-30.9-25.1-56-56-56s-56 25.1-56 56v56 5.4z"]
};
var faTrees = {
  prefix: 'fal',
  iconName: 'trees',
  icon: [640, 512, [], "f724", "M167.6 11.9c12.8-15 35.9-15 48.7 0L318.5 131.8c4.1 4.8 6.4 11 6.4 17.4c0 14.8-12 26.8-26.8 26.8H286.1l61.4 67.4c4.5 4.9 7 11.3 7 17.9c0 14.7-11.9 26.6-26.6 26.6H312.7l65.6 84.4C382 377.2 384 383 384 389c0 14.9-12.1 27-27 27H235.1 208v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H148.9 27c-14.9 0-27-12.1-27-27c0-6 2-11.8 5.7-16.6L71.3 288H56.2c-14.7 0-26.6-11.9-26.6-26.6c0-6.6 2.5-13 7-17.9L97.9 176H85.9c-14.8 0-26.8-12-26.8-26.8c0-6.4 2.3-12.5 6.4-17.4L167.6 11.9zM235.1 384H346.8L267.4 281.8c-3.7-4.8-4.4-11.4-1.7-16.9s8.3-9 14.4-9h35.7L238 170.8c-4.3-4.7-5.4-11.4-2.8-17.2s8.3-9.5 14.6-9.5h37L192 32.7 97.1 144h37c6.3 0 12.1 3.7 14.6 9.5s1.5 12.6-2.8 17.2L68.3 256H104c6.1 0 11.7 3.5 14.4 9s2 12-1.7 16.9L37.2 384H148.9 176V208c0-8.8 7.2-16 16-16s16 7.2 16 16V384h27.1zM423.5 12.6c12.7-15.4 36.2-15.6 49.1-.4l102 119.7c4.1 4.8 6.4 11 6.4 17.4c0 14.8-12 26.8-26.8 26.8H542.1l61.4 67.4c4.5 4.9 7 11.3 7 17.9c0 14.7-11.9 26.6-26.6 26.6H568.7l65.6 84.4C638 377.2 640 383 640 389c0 14.9-12.1 27-27 27H464v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400 208c0-8.8 7.2-16 16-16s16 7.2 16 16V384H602.8L523.4 281.8c-3.8-4.8-4.4-11.4-1.7-16.9s8.3-9 14.4-9h35.7L494 170.8c-4.3-4.7-5.4-11.4-2.8-17.2s8.3-9.5 14.6-9.5h37L448.2 32.9 388 106.2c-5.6 6.8-15.7 7.8-22.5 2.2s-7.8-15.7-2.2-22.5l60.2-73.2z"]
};
var faStrikethrough = {
  prefix: 'fal',
  iconName: 'strikethrough',
  icon: [512, 512, [], "f0cc", "M129.7 132c4.8-25.9 22-44.8 49.7-56.2c28.3-11.7 67-15 111-8.4c13.8 2.1 56.1 10 69.7 13.5c8.6 2.2 17.3-3 19.5-11.5s-3-17.3-11.5-19.5c-15.1-3.9-58.6-12-72.9-14.1c-47.7-7.2-92.7-4.1-127.9 10.5c-35.7 14.7-62.1 41.6-69.1 80.6c-.1 .3-.1 .6-.1 .9c-2.8 22.9 .6 42.7 9.5 59.7c8.8 16.8 22.4 29.6 37.9 39.8c18.7 12.2 41.6 21.2 65.2 28.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H319.4c-18.1-6.6-37-12.1-55.3-17.3l-1.2-.3c-39-11.2-74.8-21.6-100.2-38.1c-12.5-8.1-21.5-17.2-27.1-27.8c-5.4-10.4-8.1-23.3-6.1-40.5zM379 336.8c4.7 10.8 6.6 24.5 3.4 42.7c-4.7 26.1-21.9 45.2-49.8 56.6c-28.3 11.7-66.9 15-110.9 8.4c-22.1-3.5-59.5-15.7-88-25.1l0 0 0 0c-6.1-2-11.8-3.9-16.8-5.5c-8.4-2.7-17.4 1.9-20.1 10.4s1.9 17.4 10.4 20.1c4.4 1.4 9.6 3.1 15.3 5c28.3 9.3 69.3 22.8 94.4 26.7l.1 0c47.7 7.2 92.7 4.1 127.9-10.5c35.7-14.7 62.1-41.6 69.1-80.6c4.2-23.3 2.2-43.7-5.6-61.3c-.6-1.3-1.2-2.7-1.9-4H367.7c4.9 5.2 8.6 10.8 11.3 16.8z"]
};
var faPage = {
  prefix: 'fal',
  iconName: 'page',
  icon: [384, 512, [], "e428", "M64 480H320c17.7 0 32-14.3 32-32V138.5c0-8.5-3.4-16.6-9.4-22.6L268.1 41.4c-6-6-14.1-9.4-22.6-9.4H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zm256 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64z"]
};
var faK = {
  prefix: 'fal',
  iconName: 'k',
  icon: [320, 512, [107], "4b", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V336 464c0 8.8 7.2 16 16 16s16-7.2 16-16V342.6l94.1-94.1 165 225c5.2 7.1 15.2 8.7 22.4 3.4s8.7-15.2 3.4-22.4L149 225.6 315.3 59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L32 297.4V48z"]
};
var faDiagramPrevious = {
  prefix: 'fal',
  iconName: 'diagram-previous',
  icon: [512, 512, [], "e478", "M480 352c0-17.7-14.3-32-32-32l-176 0H240L64 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32V352zM272 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64H240V182.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 182.6V288zM448 32c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h48c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 64c0 17.7 14.3 32 32 32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32l384 0z"]
};
var faGaugeMin = {
  prefix: 'fal',
  iconName: 'gauge-min',
  icon: [512, 512, ["tachometer-alt-slowest"], "f628", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM280 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-35.3-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4L104.2 242.3c-7.6-4.5-17.4-2.1-22 5.5s-2.1 17.4 5.5 22l106.8 64.1c-1.7 5.8-2.6 11.9-2.6 18.2c0 35.3 28.7 64 64 64s64-28.7 64-64zM168 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTachometerAltSlowest = faGaugeMin;
var faFolderGrid = {
  prefix: 'fal',
  iconName: 'folder-grid',
  icon: [512, 512, [], "e188", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zm48 272V272h32v32H112zM80 264v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H104c-13.3 0-24 10.7-24 24zm160 40V272h32v32H240zm-32-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24zm160 8h32v32H368V272zm-8-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H360z"]
};
var faEggplant = {
  prefix: 'fal',
  iconName: 'eggplant',
  icon: [512, 512, [], "e16c", "M482.7 51.9C491.1 64.5 496 79.7 496 96v96c0 17.7-14.3 32-32 32h-4c-24.3 0-44-19.7-44-44V170c0-1.1-.9-2-2-2c-38.7 0-70-31.3-70-70c0-1.1-.9-2-2-2H332c-24.3 0-44-19.7-44-44V48c0-17.7 14.3-32 32-32h96c16.3 0 31.5 4.9 44.1 13.3L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L482.7 51.9zM416 48H320v4c0 6.6 5.4 12 12 12h10c18.8 0 34 15.2 34 34c0 21 17 38 38 38c18.8 0 34 15.2 34 34v10c0 6.6 5.4 12 12 12h4V96c0-26.5-21.5-48-48-48zM169.9 139.3c32.9-16 66-32 94.7-52.2c5 9.6 12 18 20.5 24.7c-11.3 8.1-23.1 15.4-34.8 22.2c-21.2 12.2-45.5 24-68.4 35.1l0 0 0 0 0 0 0 0c-14.1 6.8-27.6 13.4-39.5 19.7c-34 17.8-61.7 35.7-80.9 58.3c-18.2 21.5-30 48.8-29.4 88.5C33.1 413.9 98 479.9 176.4 480c66.7 .1 127.2-45.1 176.8-113.6c27.4-37.8 49.9-80.7 66.7-121.9c9 5.6 19.2 9.3 30.1 10.8C400.8 377 304.5 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3z"]
};
var faRam = {
  prefix: 'fal',
  iconName: 'ram',
  icon: [640, 512, [128015], "f70a", "M336 56c0-30.9 25.1-56 56-56s56 25.1 56 56V66.8c7.7-1.8 15.7-2.8 24-2.8c14.2 0 27.7 2.8 40 8V56c0-30.9 25.1-56 56-56s56 25.1 56 56v8c0 8.8-7.2 16-16 16s-16-7.2-16-16V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V93c11 10.5 19.7 23.5 25.2 37.9l47.7 31.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4L576 173.9V240c0 53-43 96-96 96H464c-53 0-96-43-96-96V179.2l-15.1 10.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l37.3-24.9c7.3-23.9 22.9-44.2 43.5-57.5V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 8.8-7.2 16-16 16s-16-7.2-16-16V56zM304.2 69.9l.2-.2c1.6 11.3 7.9 21 16.9 27.2c-13.2 8.3-30.7 6-41.2-6c-5.9-6.8-14.5-11-24.1-11s-18.2 4.2-24.1 11c-11.3 12.9-30.6 14.6-44 4C182.4 90.6 175.6 88 168 88c-15 0-27.7 10.4-31.1 24.3c-3.9 16.1-19.6 26.6-36 24c-1.6-.2-3.2-.4-5-.4c-17.7 0-32 14.3-32 32c0 2.7 .3 5.3 .9 7.8c3.5 14.2-3 29-16 36c-10.2 5.4-17 16.1-17 28.3s6.8 22.8 17 28.3c12.9 6.9 19.5 21.7 16 36c-.6 2.5-.9 5.1-.9 7.8c0 17.7 14.3 32 32 32c1.7 0 3.4-.1 5-.4c16.4-2.5 32 7.9 36 24c3.4 14 16.1 24.3 31.1 24.3c7.6 0 14.4-2.6 19.9-6.9c13.4-10.6 32.8-8.9 44 4c5.9 6.8 14.5 11 24.1 11s18.2-4.2 24.1-11c11.3-12.9 30.6-14.6 44-4c5.5 4.3 12.3 6.9 19.9 6.9c15 0 27.7-10.4 31.1-24.3c1.4-5.8 4.3-10.8 8.2-14.8c6.2 5.2 13 9.9 20.1 14l20.1 5L397.6 475.6C392.2 497 373 512 351 512H336c-26.5 0-48-21.5-48-48V423.4c-9.4 5.4-20.3 8.6-32 8.6s-22.6-3.1-32-8.6V464c0 26.5-21.5 48-48 48H161c-22 0-41.2-15-46.6-36.4l-25-100C57.2 372.4 32 345.1 32 312c0-5.3 .7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 76.8 137.9 56 168 56c15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9zM344 424c-8.5 0-16.6-1.7-24-4.7V464c0 8.8 7.2 16 16 16h15c7.3 0 13.7-5 15.5-12.1l13.8-55.2C370 419.8 357.5 424 344 424zM131.7 412.7l13.8 55.2c1.8 7.1 8.2 12.1 15.5 12.1h15c8.8 0 16-7.2 16-16V419.3c-7.4 3-15.5 4.7-24 4.7c-13.5 0-26-4.2-36.3-11.3zM544 168c0-39.8-32.2-72-72-72c-36.1 0-66 26.6-71.2 61.2l.1 .1-.1 .1c-.5 3.5-.8 7-.8 10.6v72c0 35.3 28.7 64 64 64h16c35.3 0 64-28.7 64-64V168zm-96 8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faLandmarkFlag = {
  prefix: 'fal',
  iconName: 'landmark-flag',
  icon: [512, 512, [], "e51c", "M272 32V64h64V32H272zm80 64H272v32H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V96 64 24 16c0-8.8 7.2-16 16-16h8 8 80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16zM48 368c0-8.8 7.2-16 16-16V192H96V352h80V192h32V352h96V192h32V352h80V192h32V352c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM24 432c0-8.8 7.2-16 16-16H472c8.8 0 16 7.2 16 16s-7.2 16-16 16H40c-8.8 0-16-7.2-16-16zM0 496c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faLips = {
  prefix: 'fal',
  iconName: 'lips',
  icon: [576, 512, [128068, 128482], "f600", "M268.2 126.4c11.6 9.2 28.1 9.2 39.7 0C331.2 107.9 354.3 96 376 96c14.3 0 30.9 5.5 49.4 15.7c18.4 10.1 36 23.4 52.6 36.3c18 14 34.5 29 46.5 42.5l23.9-21.3-23.9 21.3C538.3 206 544 216.3 544 224c0 11.4-5.7 25.3-14.7 43.5C519.5 287 505 310 486 332c-38 44-94 84-166 84H256c-72 0-128-40-166-84c-23.7-27.5-43.6-58.4-54.3-90.6C33.3 234 32 228 32 224c0-7.7 5.7-18 19.5-33.5L28.1 169.7l23.4 20.8C63.5 177 80 162 98 148c16.5-12.8 34.2-26.1 52.6-36.3C169.1 101.5 185.7 96 200 96c21.7 0 44.8 11.9 68.2 30.4zM576 224c0-21.1-14.2-39.7-27.6-54.8c-13.6-15.3-31.7-31.7-50.8-46.5C464.5 97 420 64 376 64c-32.7 0-63 17.5-88 37.3C263 81.5 232.7 64 200 64c-44 0-88.5 33-121.6 58.7c-19.1 14.8-37.1 31.2-50.8 46.5C14.2 184.3 0 202.9 0 224c0 9.2 2.6 19.1 5.3 27.5c12.4 37.3 34.9 71.9 60.4 101.4C107.2 400.9 171.3 448 256 448h64c84.7 0 148.8-47.1 190.2-95.1c20.9-24.2 36.8-49.4 47.7-71.1C566.6 264.3 576 244 576 224zm-219.7-7.1c2-.6 3.8-.9 5.4-.9c38.1 .4 66.1 5.6 84.1 11.1c4.7 1.4 8.5 2.9 11.7 4.2c-.4 .4-.9 .9-1.3 1.3c-7.5 7.4-19 16.9-34.3 26.4c-30.5 18.8-75.6 37-133.9 37s-103.4-18.2-133.9-37c-15.3-9.4-26.8-19-34.3-26.4c-.5-.5-.9-.9-1.3-1.3c3.2-1.3 7-2.7 11.7-4.2c18-5.5 46-10.7 84.1-11.1c1.6 0 3.4 .2 5.4 .9c11.6 3.6 44 13.1 68.3 13.1s56.7-9.5 68.3-13.1zm5.7-32.9c-5.4-.1-10.5 .8-15.3 2.3c-12.1 3.8-40 11.7-58.8 11.7s-46.7-7.9-58.8-11.7c-4.7-1.5-9.9-2.4-15.3-2.3c-40.7 .5-71.7 5.9-93.1 12.5c-10.6 3.3-19.2 6.9-25.5 10.6c-3.1 1.8-6.2 3.9-8.7 6.4C85 215.1 80 220.2 80 228c0 3.1 .9 5.5 1.3 6.6c.5 1.3 1.1 2.5 1.6 3.4c1 1.8 2.3 3.6 3.6 5.4c2.7 3.5 6.4 7.7 11 12.1c9.2 9 22.6 20 39.9 30.7C172 307.6 222.8 328 288 328s116-20.4 150.7-41.8c17.3-10.7 30.7-21.7 39.9-30.7c4.6-4.5 8.3-8.6 11-12.2c1.3-1.7 2.6-3.6 3.6-5.4c.5-.9 1.1-2.1 1.6-3.4c.4-1.1 1.3-3.5 1.3-6.6c0-7.8-5-12.9-6.7-14.5c-2.5-2.5-5.6-4.6-8.7-6.4c-6.3-3.7-14.9-7.3-25.5-10.6c-21.4-6.6-52.4-12-93.1-12.5z"]
};
var faPencil = {
  prefix: 'fal',
  iconName: 'pencil',
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M395.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L417.6 171 341 94.4l54.8-54.8zM318.4 117L395 193.6l-219 219V400c0-8.8-7.2-16-16-16H128V352c0-8.8-7.2-16-16-16H99.4l219-219zM66.9 379.5c1.2-4 2.7-7.9 4.7-11.5H96v32c0 8.8 7.2 16 16 16h32v24.4c-3.7 1.9-7.5 3.5-11.6 4.7L39.6 472.4l27.3-92.8zM452.4 17c-21.9-21.9-57.3-21.9-79.2 0L60.4 329.7c-11.4 11.4-19.7 25.4-24.2 40.8L.7 491.5c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2L495 138.8c21.9-21.9 21.9-57.3 0-79.2L452.4 17zM331.3 202.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128z"]
};
var faPencilAlt = faPencil;
var faBackward = {
  prefix: 'fal',
  iconName: 'backward',
  icon: [512, 512, [9194], "f04a", "M37.6 256L256 414.1V97.9L37.6 256zM258 64c16.6 0 30 13.5 30 30V197.4L464.3 69.7C469.5 66 475.6 64 482 64c16.6 0 30 13.5 30 30V418c0 16.6-13.4 30-30 30c-6.3 0-12.5-2-17.6-5.7L288 314.6V418c0 16.6-13.5 30-30 30c-6.3 0-12.5-2-17.6-5.7L9.9 275.4C3.7 270.9 0 263.7 0 256s3.7-14.9 9.9-19.4L240.3 69.7C245.5 66 251.6 64 258 64zm30 211.1l192 139V97.9l-192 139v38.2z"]
};
var faCaretRight = {
  prefix: 'fal',
  iconName: 'caret-right',
  icon: [256, 512, [], "f0da", "M221.8 250.4c1.3 1.4 2.2 3.5 2.2 5.6s-.8 4.2-2.2 5.6L108.3 381.8c-1.3 1.4-3.2 2.2-5.2 2.2c-3.9 0-7.1-3.2-7.1-7.1l0-241.7c0-3.9 3.2-7.1 7.1-7.1c2 0 3.8 .8 5.2 2.2L221.8 250.4zm23.3-22L131.6 108.3c-7.4-7.8-17.7-12.3-28.4-12.3C81.5 96 64 113.5 64 135.1l0 241.7c0 21.6 17.5 39.1 39.1 39.1c10.8 0 21.1-4.4 28.4-12.3L245.1 283.6c7-7.4 10.9-17.3 10.9-27.6s-3.9-20.1-10.9-27.6z"]
};
var faComments = {
  prefix: 'fal',
  iconName: 'comments',
  icon: [640, 512, [128490, 61670], "f086", "M32 176c0-74.8 73.7-144 176-144s176 69.2 176 144s-73.7 144-176 144c-15.3 0-30.6-1.9-46.3-5c-3.5-.7-7.1-.2-10.2 1.4c-6.1 3.1-12 6-18 8.7c-28.4 12.9-60.2 23.1-91.5 26c14.9-19 26.8-39.7 37.6-59.9c3.3-6.1 2.3-13.6-2.5-18.6C50 244.2 32 213.1 32 176zM208 0C93.1 0 0 78.9 0 176c0 44.2 19.8 80.1 46 110c-11.7 21-24 40.6-39.5 57.5l0 0-.1 .1c-6.5 7-8.2 17.1-4.4 25.8C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.9-2.2 9.6-4.5 14.3-6.8c15.3 2.8 30.9 4.6 47 4.6c114.9 0 208-78.9 208-176S322.9 0 208 0zM447.4 160.5C541.6 167 608 233 608 304c0 37.1-18 68.2-45.1 96.6c-4.8 5-5.8 12.5-2.5 18.6c10.9 20.2 22.7 40.8 37.6 59.9c-31.3-3-63.2-13.2-91.5-26c-6-2.7-11.9-5.6-18-8.7c-3.2-1.6-6.8-2.1-10.2-1.4c-15.6 3.1-30.9 5-46.3 5c-68.2 0-123.6-30.7-153.1-73.3c-11 3-22.3 5.2-33.8 6.8C279 439.8 349.9 480 432 480c16.1 0 31.7-1.8 47-4.6c4.6 2.3 9.4 4.6 14.3 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.7 2-18.9-4.4-25.8l-.1-.1 0 0c-15.5-17-27.8-36.5-39.5-57.5c26.2-29.9 46-65.8 46-110c0-94.4-87.8-171.5-198.2-175.8c2.8 10.4 4.7 21.2 5.6 32.3z"]
};
var faPaste = {
  prefix: 'fal',
  iconName: 'paste',
  icon: [512, 512, ["file-clipboard"], "f0ea", "M136.5 51.2C138.7 40.2 148.4 32 160 32s21.3 8.2 23.5 19.2C185 58.6 191.6 64 199.2 64H208c8.8 0 16 7.2 16 16V96H96V80c0-8.8 7.2-16 16-16h8.8c7.6 0 14.2-5.4 15.7-12.8zM160 0c-22.3 0-41.6 13.1-50.6 32H64C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64H192V416H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h2.7C65 69 64 74.4 64 80V96c0 17.7 14.3 32 32 32H208c11.5-15.4 28.5-26.4 48-30.4c0-.5 0-1.1 0-1.6V80c0-5.6-1-11-2.7-16H256c17.7 0 32 14.3 32 32h32c0-35.3-28.7-64-64-64H210.6c-9-18.9-28.3-32-50.6-32zM448 480H288c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H396.1c4.2 0 8.3 1.7 11.3 4.7l67.9 67.9c3 3 4.7 7.1 4.7 11.3V448c0 17.7-14.3 32-32 32zm49.9-270.1l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H288c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V243.9c0-12.7-5.1-24.9-14.1-33.9z"]
};
var faFileClipboard = faPaste;
var faDesktopArrowDown = {
  prefix: 'fal',
  iconName: 'desktop-arrow-down',
  icon: [576, 512, [], "e155", "M64 0H240V32H64C46.3 32 32 46.3 32 64V256H544V64c0-17.7-14.3-32-32-32H336V0H512c35.3 0 64 28.7 64 64V256v32 64c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H360 216 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64H64c-35.3 0-64-28.7-64-64V288 256 64C0 28.7 28.7 0 64 0zM32 288v64c0 17.7 14.3 32 32 32H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H512c17.7 0 32-14.3 32-32V288H32zM234.9 480H341.1l-10.7-64H245.6l-10.7 64zM304 16V169.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 169.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCodePullRequest = {
  prefix: 'fal',
  iconName: 'code-pull-request',
  icon: [512, 512, [], "e13c", "M323.8 5.2c5.9 6.5 5.5 16.7-1.1 22.6L265.4 80H336c61.9 0 112 50.1 112 112V353.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V192c0-44.2-35.8-80-80-80H265.4l57.4 52.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1zM432 384a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM128 80A48 48 0 1 0 32 80a48 48 0 1 0 96 0zM96 158.4V353.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V158.4C27.5 151 0 118.7 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 38.7-27.5 71-64 78.4zM128 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faPumpkin = {
  prefix: 'fal',
  iconName: 'pumpkin',
  icon: [576, 512, [], "f707", "M299.1 36.1l20.9 9V98.9c11.1 2 21.8 5.1 32 9.1V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4l-41.1 94c12.2-3.9 25-6.5 38.3-7.7l26.5-60.5zM166 145.1c9.5-9.2 20.1-17.3 31.5-24.1c-14.3-5.8-29.5-9-45.5-9c-43.8 0-82.2 24.1-109 60.4S0 258.1 0 312s16.1 103.3 43 139.6S108.2 512 152 512c24.7 0 47.8-7.7 68-20.9c20.2 13.3 43.3 20.9 68 20.9s47.8-7.7 68-20.9c20.2 13.3 43.3 20.9 68 20.9c43.8 0 82.2-24.1 109-60.4s43-85.7 43-139.6s-16.1-103.3-43-139.6S467.8 112 424 112c-15.9 0-31.2 3.2-45.5 9c11.4 6.8 22 14.9 31.5 24.1c4.6-.8 9.3-1.1 14-1.1c31.3 0 60.9 17.1 83.3 47.4S544 264.3 544 312s-14.3 90.3-36.7 120.6s-52 47.4-83.3 47.4c-20.7 0-40.6-7.5-58.1-21.2c-5.8-4.5-13.9-4.5-19.7 0C328.6 472.5 308.7 480 288 480s-40.6-7.5-58.1-21.2c-5.8-4.5-13.9-4.5-19.7 0C192.6 472.5 172.7 480 152 480c-31.3 0-60.9-17.1-83.3-47.4S32 359.7 32 312s14.3-90.3 36.7-120.6s52-47.4 83.3-47.4c4.7 0 9.4 .4 14 1.1zM288 160c38.5 0 72.4 19.4 92.6 49c5 7.3 14.9 9.2 22.2 4.2s9.2-14.9 4.2-22.2c-25.9-38-69.6-63-119.1-63s-93.2 25-119.1 63c-5 7.3-3.1 17.3 4.2 22.2s17.3 3.1 22.2-4.2c20.2-29.6 54.1-49 92.6-49z"]
};
var faClipboardList = {
  prefix: 'fal',
  iconName: 'clipboard-list',
  icon: [384, 512, [], "f46d", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPenField = {
  prefix: 'fal',
  iconName: 'pen-field',
  icon: [640, 512, [], "e211", "M582.8 45.5l11.9 11.9c12.5 12.5 12.5 32.8 0 45.2L568 129.4l-57-57 26.4-26.8c12.5-12.6 32.8-12.7 45.4-.1zM346.2 239.2L488.5 95.1 545.4 152 402.3 295.2c-4.4 4.4-10 7.4-16.1 8.7l-61.5 12.9 12.9-61.7c1.3-6 4.2-11.5 8.6-15.9zM514.7 23.1L323.4 216.7c-8.6 8.7-14.6 19.8-17.1 31.8l-18 85.7c-1.1 5.3 .5 10.8 4.3 14.6s9.3 5.5 14.6 4.3l85.5-17.9c12.2-2.6 23.3-8.6 32.1-17.4L617.4 125.3c25-25 25-65.5 0-90.5L605.5 22.8c-25.1-25.1-65.8-25-90.8 .3zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm64 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faBlueberries = {
  prefix: 'fal',
  iconName: 'blueberries',
  icon: [512, 512, [], "e2e8", "M382.7 312.3C439.3 292.9 480 239.2 480 176c0-79.5-64.5-144-144-144c-63.2 0-116.9 40.7-136.3 97.3c-7.8-.9-15.7-1.3-23.7-1.3c-3.2 0-6.3 .1-9.4 .2C187.4 54.2 255.4 0 336 0c97.2 0 176 78.8 176 176c0 80.6-54.2 148.6-128.2 169.4c.1-3.1 .2-6.3 .2-9.4c0-8-.5-15.9-1.3-23.7zM320 336A144 144 0 1 0 32 336a144 144 0 1 0 288 0zM0 336a176 176 0 1 1 352 0A176 176 0 1 1 0 336zm176-96v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H176v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V304H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V240c0-8.8 7.2-16 16-16s16 7.2 16 16zM368 80v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H368v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V144H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTruckRampBox = {
  prefix: 'fal',
  iconName: 'truck-ramp-box',
  icon: [640, 512, ["truck-loading"], "f4de", "M432 0c-44.2 0-80 35.8-80 80V384c0 1.3 .2 2.5 .4 3.7L11.8 480.6C3.3 482.9-1.8 491.7 .6 500.2s11.1 13.6 19.6 11.2L416.1 403.6C417.9 463.8 467.3 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-51.2 0-94.4 34.4-107.7 81.3l-.5 .1L384 379.1V80c0-26.5 21.5-48 48-48H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H432zm96 320a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM84.9 191.2l14.5 54.1c3.4 12.8 16.6 20.4 29.4 17l46.4-12.4c12.8-3.4 20.4-16.6 17-29.4l-14.5-54.1 30.9-8.3L250 312.6 95.4 354 54 199.4l30.9-8.3zm30.9-8.3l30.9-8.3L159.2 221l-30.9 8.3-12.4-46.4zM45.7 168.5c-17.1 4.6-27.2 22.1-22.6 39.2L64.5 362.3c4.6 17.1 22.1 27.2 39.2 22.6l154.5-41.4c17.1-4.6 27.2-22.1 22.6-39.2L239.5 149.7c-4.6-17.1-22.1-27.2-39.2-22.6L45.7 168.5z"]
};
var faTruckLoading = faTruckRampBox;
var faNote = {
  prefix: 'fal',
  iconName: 'note',
  icon: [448, 512, [], "e1ff", "M384 64c17.7 0 32 14.3 32 32V304H320c-26.5 0-48 21.5-48 48v96H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm18.7 272L304 434.7V352c0-8.8 7.2-16 16-16h82.7zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H277.5c17 0 33.3-6.7 45.3-18.7L429.3 354.7c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H64zm64 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faArrowDownToSquare = {
  prefix: 'fal',
  iconName: 'arrow-down-to-square',
  icon: [512, 512, [], "e096", "M267.8 330.9l96-104c6-6.5 5.6-16.6-.9-22.6s-16.6-5.6-22.6 .9L272 279.1V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V279.1l-68.2-73.9c-6-6.5-16.1-6.9-22.6-.9s-6.9 16.1-.9 22.6l96 104c3 3.3 7.3 5.1 11.8 5.1s8.7-1.9 11.8-5.1zM64 32C28.7 32 0 60.7 0 96V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"]
};
var faUserCheck = {
  prefix: 'fal',
  iconName: 'user-check',
  icon: [640, 512, [], "f4fc", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zm457-116.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faCloudXmark = {
  prefix: 'fal',
  iconName: 'cloud-xmark',
  icon: [640, 512, [], "e35f", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM244.7 212.7c6.2-6.2 16.4-6.2 22.6 0L320 265.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 288l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faVialVirus = {
  prefix: 'fal',
  iconName: 'vial-virus',
  icon: [512, 512, [], "e597", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H32V384c0 53 43 96 96 96c31.4 0 59.3-15.1 76.8-38.4c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2C167.5 438 148.9 448 128 448c-35.3 0-64-28.7-64-64V224H208c8.8 0 16-7.2 16-16V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM192 192H64V64H192V192zM320 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM214.6 326.9c-13.3 0-24 10.7-24 24s10.7 24 24 24c29.3 0 43.9 35.4 23.2 56.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.7-20.7 56.1-6 56.1 23.2c0 13.3 10.7 24 24 24s24-10.7 24-24c0-29.3 35.4-43.9 56.1-23.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.7-20.7-6-56.1 23.2-56.1c13.3 0 24-10.7 24-24s-10.7-24-24-24c-29.3 0-43.9-35.4-23.2-56.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.7 20.7-56.1 6-56.1-23.2c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 29.3-35.4 43.9-56.1 23.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.7 20.7 6 56.1-23.2 56.1zm62.6-50.7c28.6 8.2 60.2-4.9 74.7-30.9c7.2 13 18.8 22.8 32.2 28.3c13.3 5.5 28.3 6.7 42.5 2.6c-8.2 28.6 4.9 60.2 30.9 74.7c-26 14.5-39.1 46.1-30.9 74.7c-28.6-8.2-60.2 4.9-74.7 30.9c-14.5-26-46.1-39.1-74.7-30.9c8.2-28.6-4.9-60.2-30.9-74.7c26-14.5 39.1-46.1 30.9-74.7z"]
};
var faBookBlank = {
  prefix: 'fal',
  iconName: 'book-blank',
  icon: [448, 512, [128213, 128215, 128216, 128217, "book-alt"], "f5d9", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H96V32H64C46.3 32 32 46.3 32 64l0 328.6zM128 32V384H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H128z"]
};
var faBookAlt = faBookBlank;
var faGolfFlagHole = {
  prefix: 'fal',
  iconName: 'golf-flag-hole',
  icon: [512, 512, [], "e3ac", "M135.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l224 112c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3L160 249.9v61.7c29.6-4.9 62.1-7.6 96-7.6c141.4 0 256 46.6 256 104s-114.6 104-256 104S0 465.4 0 408c0-32.8 37.5-62.1 96-81.2v33.8c-3.1 1.1-6.1 2.3-9 3.5c-20.9 8.5-35.7 17.8-44.7 26.5C33.3 399.2 32 405.1 32 408s1.3 8.8 10.3 17.4c9.1 8.7 23.8 18 44.7 26.5C128.7 468.8 188.4 480 256 480s127.3-11.2 169-28.1c20.9-8.5 35.7-17.8 44.7-26.5c9-8.6 10.3-14.5 10.3-17.4s-1.3-8.8-10.3-17.4c-9.1-8.7-23.8-18-44.7-26.5C383.3 347.2 323.6 336 256 336c-34.5 0-67 2.9-96 8v28.2c17-7.6 39.4-12.2 64-12.2c53 0 96 21.5 96 48s-43 48-96 48s-96-21.5-96-48V350.9 317.9 240 16c0-5.5 2.9-10.7 7.6-13.6zM160 214.1L332.2 128 160 41.9V214.1zM288.4 405.4a0 0 0 1 0 0 .1 0 0 0 1 0 0-.1zm-10.8-2.7c-12.1-6-31-10.7-53.6-10.7s-41.5 4.7-53.6 10.7c-4.3 2.1-6.9 4-8.5 5.3c1.6 1.4 4.2 3.2 8.5 5.3c12.1 6 31 10.7 53.6 10.7s41.5-4.7 53.6-10.7c4.3-2.1 6.9-4 8.5-5.3c-1.6-1.4-4.2-3.2-8.5-5.3zm10.8 7.9a.4 .4 0 1 0 .8-.4 .4 .4 0 1 0 -.8 .4z"]
};
var faMessageArrowDown = {
  prefix: 'fal',
  iconName: 'message-arrow-down',
  icon: [512, 512, ["comment-alt-arrow-down"], "e1db", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V265.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 265.4V112z"]
};
var faCommentAltArrowDown = faMessageArrowDown;
var faFaceUnamused = {
  prefix: 'fal',
  iconName: 'face-unamused',
  icon: [512, 512, [], "e39f", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 394.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z"]
};
var faSheetPlastic = {
  prefix: 'fal',
  iconName: 'sheet-plastic',
  icon: [384, 512, [], "e571", "M352 64V320H240c-26.5 0-48 21.5-48 48V480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32zm-.5 288c-.7 2.8-2.1 5.4-4.2 7.4L231.4 475.3c-2.1 2.1-4.6 3.5-7.4 4.2V368c0-8.8 7.2-16 16-16H351.5zM0 448c0 35.3 28.7 64 64 64H220.1c12.7 0 24.9-5.1 33.9-14.1L369.9 382.1c9-9 14.1-21.2 14.1-33.9V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM187.3 68.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zm96 54.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160z"]
};
var faCircle9 = {
  prefix: 'fal',
  iconName: 'circle-9',
  icon: [512, 512, [], "e0f6", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm-3.7 159.9C201 318 160 275.8 160 224c0-53 43-96 96-96s96 43 96 96c0 30-12.5 58.6-34.4 78.9l-82.7 76.8c-6.5 6-16.6 5.6-22.6-.8s-5.6-16.6 .8-22.6l39.1-36.3z"]
};
var faBlog = {
  prefix: 'fal',
  iconName: 'blog',
  icon: [512, 512, [], "f781", "M208 32c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240 107.5 240 240c0 8.8 7.2 16 16 16s16-7.2 16-16C480 153.8 358.2 32 208 32zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c79.5 0 144 64.5 144 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-97.2-78.8-176-176-176zM32 120c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h8c61.9 0 112 50.1 112 112s-50.1 112-112 112S32 429.9 32 368V120z"]
};
var faUserNinja = {
  prefix: 'fal',
  iconName: 'user-ninja',
  icon: [448, 512, [129399], "f504", "M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm32 0c0 70.7-57.3 128-128 128c-63.6 0-116.3-46.3-126.3-107.1L59.3 187.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 112 36.7 59.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l45.2 45.2C123 34 169.6 0 224 0c70.7 0 128 57.3 128 128zM211.1 452.9L128.6 344.7C72.9 364.8 33 417.7 32 480H231.7l-20.2-26.5c-.1-.2-.3-.4-.4-.6zm33.1-9.4L271.9 480H416c-1-62.3-40.9-115.2-96.6-135.3l-75.3 98.8zM418.3 512H264.2h-.4H29.7C13.3 512 0 498.7 0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7zM176 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPencilSlash = {
  prefix: 'fal',
  iconName: 'pencil-slash',
  icon: [640, 512, [], "e215", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM559 138.8c21.9-21.9 21.9-57.3 0-79.2L516.4 17c-21.9-21.9-57.3-21.9-79.2 0L297.5 156.7l25.3 20L382.4 117 459 193.6l-50.6 50.6 25.3 20L559 138.8zM317.2 335.3L240 412.6V400c0-8.8-7.2-16-16-16H192V352c0-8.8-7.2-16-16-16H163.4l68.2-68.2-25.3-20-81.9 81.9c-11.4 11.4-19.7 25.4-24.2 40.8l-35.6 121c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2l96.2-96.2-25.3-20zM493.8 39.6l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L481.6 171 405 94.4l54.8-54.8c9.4-9.4 24.6-9.4 33.9 0zM135.6 368H160v32c0 8.8 7.2 16 16 16h32v24.4c-3.7 1.9-7.5 3.5-11.6 4.7l-92.8 27.3 27.3-92.8c1.2-4 2.7-7.9 4.7-11.6z"]
};
var faBowlingPins = {
  prefix: 'fal',
  iconName: 'bowling-pins',
  icon: [512, 512, [], "f437", "M128 32c-22.1 0-40 17.9-40 40v4.4c0 6.4 .8 12.8 2.3 19l9.4 37.4c2.2 8.9 3.6 18 4.1 27.2h48.4c.5-9.2 1.9-18.3 4.1-27.2l9.4-37.4c1.6-6.2 2.3-12.6 2.3-19V72c0-22.1-17.9-40-40-40zM91.9 230.9L61.1 301.4C52.5 321.1 48 342.5 48 364.1c0 26.2 6.6 51.9 19.1 74.9L89.5 480h77l22.4-41.1c12.5-23 19.1-48.7 19.1-74.9c0-21.6-4.5-42.9-13.1-62.7l-30.8-70.4c-5.4-12.4-9.1-25.5-10.8-38.9H102.8c-1.8 13.4-5.4 26.5-10.8 38.9zM56 72C56 32.2 88.2 0 128 0s72 32.2 72 72v4.4c0 9-1.1 18-3.3 26.8l-9.4 37.4c-2.2 8.9-3.3 18-3.3 27.2v5.5c0 15.5 3.2 30.7 9.4 44.9l30.8 70.4c10.4 23.8 15.8 49.5 15.8 75.5c0 31.5-7.9 62.5-23 90.2l-24.7 45.2c-4.2 7.7-12.3 12.5-21.1 12.5H84.7c-8.8 0-16.9-4.8-21.1-12.5L39 454.2c-15.1-27.7-23-58.7-23-90.2c0-26 5.4-51.7 15.8-75.5l30.8-70.4C68.8 204 72 188.7 72 173.2v-5.5c0-9.2-1.1-18.3-3.3-27.2l-9.4-37.4C57.1 94.4 56 85.4 56 76.4V72zM384 32c-22.1 0-40 17.9-40 40v4.4c0 6.4 .8 12.8 2.3 19l9.4 37.4c2.2 8.9 3.6 18 4.1 27.2h48.4c.5-9.2 1.9-18.3 4.1-27.2l9.4-37.4c1.6-6.2 2.3-12.6 2.3-19V72c0-22.1-17.9-40-40-40zM347.9 230.9l-30.8 70.4c-8.6 19.8-13.1 41.1-13.1 62.7c0 26.2 6.6 51.9 19.1 74.9L345.5 480h77l22.4-41.1c12.5-23 19.1-48.7 19.1-74.9c0-21.6-4.5-42.9-13.1-62.7l-30.8-70.4c-5.4-12.4-9.1-25.5-10.8-38.9H358.8c-1.8 13.4-5.4 26.5-10.8 38.9zM312 72c0-39.8 32.2-72 72-72s72 32.2 72 72v4.4c0 9-1.1 18-3.3 26.8l-9.4 37.4c-2.2 8.9-3.3 18-3.3 27.2v5.5c0 15.5 3.2 30.7 9.4 44.9l30.8 70.4c10.4 23.8 15.8 49.5 15.8 75.5c0 31.5-7.9 62.5-23 90.2l-24.7 45.2c-4.2 7.7-12.3 12.5-21.1 12.5H340.7c-8.8 0-16.9-4.8-21.1-12.5L295 454.2c-15.1-27.7-23-58.7-23-90.2c0-26 5.4-51.7 15.8-75.5l30.8-70.4c6.2-14.2 9.4-29.4 9.4-44.9v-5.5c0-9.2-1.1-18.3-3.3-27.2l-9.4-37.4c-2.2-8.8-3.3-17.7-3.3-26.8V72z"]
};
var faPersonArrowUpFromLine = {
  prefix: 'fal',
  iconName: 'person-arrow-up-from-line',
  icon: [640, 512, [], "e539", "M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM179.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H160V164c6-2.6 12.5-4 19.3-4zM160 480V352h64V480H160zm-32 0H16c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0h96l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L275.3 170.3c-13.9-26-41-42.3-70.6-42.3H179.3c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L128 202.1V480zM603.3 132.7l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 86.6 480 400c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"]
};
var faDownRight = {
  prefix: 'fal',
  iconName: 'down-right',
  icon: [384, 512, [], "e16b", "M312 384c4.4 0 8-3.6 8-8V174.6c0-3.7-3-6.6-6.6-6.6c-1.8 0-3.4 .7-4.7 1.9l-61.4 61.4c-6.2 6.2-16.4 6.2-22.6 0L112 118.6c-4.2-4.2-10-6.6-16-6.6s-11.8 2.4-16 6.6L54.6 144c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16L167.3 288.7c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3l-61.4 61.4c-1.2 1.2-1.9 2.9-1.9 4.7c0 3.7 3 6.6 6.6 6.6H312zm40-8c0 22.1-17.9 40-40 40H110.6C89.3 416 72 398.7 72 377.4c0-10.2 4.1-20.1 11.3-27.3L133.4 300 32 198.6C21.8 188.4 16 174.5 16 160s5.8-28.4 16-38.6L57.4 96C67.6 85.8 81.5 80 96 80s28.4 5.8 38.6 16L236 197.4l50.1-50.1c7.2-7.2 17.1-11.3 27.3-11.3c21.3 0 38.6 17.3 38.6 38.6V376z"]
};
var faScrollTorah = {
  prefix: 'fal',
  iconName: 'scroll-torah',
  icon: [640, 512, ["torah"], "f6a0", "M96 448V64c0-17.7-14.3-32-32-32S32 46.3 32 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32zM64 0c23.7 0 44.4 12.9 55.4 32H128 512h8.6C531.6 12.9 552.3 0 576 0c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H512 128h-8.6c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM576 480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32zm-64-32V64H128V448H512zM172 322.9c0-4.1 1.1-8.2 3.2-11.8l32.3-55-32.3-55c-2.1-3.6-3.2-7.6-3.2-11.8c0-12.9 10.4-23.3 23.3-23.3h65l36-61.3c4.6-7.9 13.1-12.7 22.2-12.7s17.6 4.8 22.2 12.7l36 61.3h65c12.9 0 23.3 10.4 23.3 23.3c0 4.1-1.1 8.2-3.2 11.8l-32.3 55 32.3 55c2.1 3.6 3.2 7.6 3.2 11.8c0 12.9-10.4 23.3-23.3 23.3h-65l-36 61.3c-4.6 7.9-13.1 12.7-22.2 12.7s-17.6-4.8-22.2-12.7l-36-61.3h-65c-12.9 0-23.3-10.4-23.3-23.3zm146.5 59.2l21.1-35.9H297.4l21.1 35.9zm-39.9-67.9h79.7l34.1-58-34.1-58H278.6l-34.1 58 34.1 58zm147.9 0L411 287.7l-15.5 26.4h31zm0-116.1h-31L411 224.5 426.5 198zm-108-67.9L297.4 166h42.2l-21.1-35.9zM226 224.5L241.5 198h-31L226 224.5zm15.5 89.7L226 287.7l-15.5 26.4h31z"]
};
var faTorah = faScrollTorah;
var faWebhook = {
  prefix: 'fal',
  iconName: 'webhook',
  icon: [576, 512, [], "e5d5", "M192 128c0-53 43-96 96-96s96 43 96 96c0 8.8 7.2 16 16 16s16-7.2 16-16C416 57.3 358.7 0 288 0S160 57.3 160 128c0 40 18.4 75.8 47.1 99.2L147.3 323c-6.1-1.9-12.6-3-19.3-3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-17.1-6.7-32.6-17.6-44.1L238 238.2c7.2-11.5 3.2-25.5-6.5-32.7C207.5 188.1 192 159.9 192 128zM160 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64-32c0 35.3 28.7 64 64 64c6.7 0 13.2-1 19.3-3l63.5 101.7c7.2 11.5 21.6 14.1 32.2 8.4C416.5 292 431.7 288 448 288c53 0 96 43 96 96s-43 96-96 96c-18.7 0-36.1-5.3-50.9-14.6c-7.5-4.7-17.4-2.4-22.1 5.1s-2.4 17.4 5.1 22.1c19.7 12.3 43 19.5 67.9 19.5c70.7 0 128-57.3 128-128s-57.3-128-128-128c-19.2 0-37.4 4.2-53.8 11.8l-59.8-95.7c10.9-11.5 17.6-27 17.6-44.1c0-35.3-28.7-64-64-64s-64 28.7-64 64zM73.2 305.2c7.2-5.1 9-15 4-22.3s-15-9-22.3-4C21.7 302.1 0 340.5 0 384c0 70.7 57.3 128 128 128c65.3 0 119.1-48.9 127-112H386c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64s-28.7-64-64-64c-29.8 0-54.9 20.4-62 48H248c-13.5 0-23.4 10.8-24.2 22.9C220.2 440.7 178.7 480 128 480c-53 0-96-43-96-96c0-32.6 16.2-61.4 41.2-78.8zM480 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faBlindsOpen = {
  prefix: 'fal',
  iconName: 'blinds-open',
  icon: [512, 512, [], "f8fc", "M32 0C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96h96V258.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V96H480c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zm0 32H480V64H32V32zm96 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H96V160H16zm176 32H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H192v32zM0 496c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c-7-9.3-12-20.2-14.4-32H16zm480 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H222.4c-2.4 11.8-7.4 22.7-14.4 32H496z"]
};
var faFence = {
  prefix: 'fal',
  iconName: 'fence',
  icon: [512, 512, [], "e303", "M64 32c5 0 9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2V160h64V117.3c0-6.9 2.2-13.7 6.4-19.2l44.8-59.7c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2V160h64V117.3c0-6.9 2.2-13.7 6.4-19.2l44.8-59.7c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2V448c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V384H320v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V117.3c0-6.9 2.2-13.7 6.4-19.2L51.2 38.4c3-4 7.8-6.4 12.8-6.4zM288 384V352 192 160 117.3L256 74.7l-32 42.7V448h64V384zm32-32h64V192H320V352zm96 0v32 64h64V117.3L448 74.7l-32 42.7V352zM192 192H128V352h64V192zm-96 0V160 117.3L64 74.7 32 117.3V448H96V384 352 192z"]
};
var faUp = {
  prefix: 'fal',
  iconName: 'up',
  icon: [384, 512, ["arrow-alt-up"], "f357", "M189.7 64h4.6c4.4 0 8.6 1.8 11.6 5L348.5 218.8c2.2 2.3 3.5 5.4 3.5 8.7c0 6.9-5.6 12.6-12.6 12.6H256c-8.8 0-16 7.2-16 16V432c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V256c0-8.8-7.2-16-16-16H44.6c-6.9 0-12.6-5.6-12.6-12.6c0-3.2 1.2-6.3 3.5-8.7L178.1 69c3-3.2 7.2-5 11.6-5zM384 227.4c0-11.4-4.4-22.5-12.3-30.7L229 46.9C220 37.4 207.4 32 194.3 32h-4.6C176.6 32 164 37.4 155 46.9L12.3 196.7C4.4 205 0 216 0 227.4C0 252 20 272 44.6 272H112V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V272h67.4c24.6 0 44.6-20 44.6-44.6z"]
};
var faArrowAltUp = faUp;
var faBroomBall = {
  prefix: 'fal',
  iconName: 'broom-ball',
  icon: [576, 512, ["quidditch", "quidditch-broom-ball"], "f458", "M571.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-208 208 45.3 45.3c4.8 4.8 7.4 11.2 7.4 17.9c0 12.4-9 23-21.2 25l-54.7 9.1 1.4 9.8c6.6 46.3-9 93-42 126c-27.8 27.8-65.6 43.5-105 43.5L22.6 512C10.1 512 0 501.9 0 489.4c0-6 2.4-11.8 6.6-16l59.7-59.7 15-15L96 384H81.3c-8.3 0-15.3-5.8-16.9-13.6c-.3-1.2-.4-2.4-.4-3.7c0-29.9 11.9-58.5 33-79.7l10.5-10.5c33.1-33.1 79.7-48.6 126-42l9.8 1.4 9.1-54.7c2-12.2 12.6-21.2 25-21.2c6.7 0 13.2 2.7 17.9 7.4l45.3 45.3 208-208c6.2-6.2 16.4-6.2 22.6 0zm-238 296.6l43.5-7.2-94.9-94.9-7.2 43.5 58.7 58.7zm-79.6-31.6L229 266.2c-36.3-5.2-72.9 7-98.9 33l-10.5 10.5C108 321.3 100.3 336.1 97.3 352c12.4 .5 23.4 8.2 28.2 19.7c5 12 2.2 25.7-6.9 34.9L45.3 480l149.2 0c30.9 0 60.5-12.3 82.4-34.1c25.9-25.9 38.1-62.6 33-98.9l-3.5-24.7-52.6-52.6zM512 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faQuidditch = faBroomBall;
var faQuidditchBroomBall = faBroomBall;
var faDrumstick = {
  prefix: 'fal',
  iconName: 'drumstick',
  icon: [512, 512, [127831], "f6d6", "M192 272V176c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144H240c-26.5 0-48-21.5-48-48zm-32-96v96c0 3 .2 6 .5 8.9L121.4 320l-.1 0c-.1 0-.5 .1-1.2 .1c-1.5-.1-3.5-.7-5.2-2C102.9 309.3 88.1 304 72 304c-39.8 0-72 32.2-72 72c0 37.2 28.2 67.8 64.4 71.6C68.2 483.8 98.8 512 136 512c39.8 0 72-32.2 72-72c0-16.1-5.3-30.9-14.2-42.9c-1.2-1.7-1.9-3.7-2-5.2c0-.7 .1-1.1 .1-1.2l0-.1 0 0 39.1-39.1c2.9 .3 5.9 .5 8.9 .5h96c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176zm12.2 138.4c6.4 10.3 15.1 18.9 25.4 25.4L169.3 368c-15 15-9.9 36.5-1.2 48.1c4.9 6.7 7.9 14.9 7.9 23.8c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.1-10.9-24-24-24c-22.1 0-40-17.9-40-40s17.9-40 40-40c9 0 17.2 2.9 23.8 7.9c11.7 8.7 33.2 13.7 48.1-1.2l28.2-28.2z"]
};
var faSquareV = {
  prefix: 'fal',
  iconName: 'square-v',
  icon: [448, 512, [], "e284", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm126.3 56.8L224 348.2l97.7-195.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-112 224c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8l-112-224c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2z"]
};
var faFaceAwesome = {
  prefix: 'fal',
  iconName: 'face-awesome',
  icon: [512, 512, ["gave-dandy"], "e409", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 208H104V192c0-22.1 17.9-40 40-40c.5 0 .9 0 1.4 0c-.9 2.5-1.4 5.2-1.4 8c0 13.3 10.7 24 24 24c5.2 0 10.1-1.7 14-4.5c1.3 3.9 2 8.1 2 12.5v16zm-40-88c-39.8 0-72 32.2-72 72v16c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V192c0-39.8-32.2-72-72-72zm236.1 53.1c2.5 5.8 3.9 12.2 3.9 18.9v16H288V192c0-26.5 21.5-48 48-48c2 0 3.9 .1 5.8 .3c-3.6 4.2-5.8 9.7-5.8 15.7c0 13.3 10.7 24 24 24c8.4 0 15.8-4.3 20.1-10.9zM256 192v17.9c0 16.6 13.5 30.1 30.1 30.1h99.8c16.6 0 30.1-13.5 30.1-30.1V192c0-44.2-35.8-80-80-80s-80 35.8-80 80zm4.7 224H248c-2 0-4 0-5.9-.1c7.2-27.5 32.2-47.9 61.9-47.9c15.9 0 30.5 5.8 41.7 15.5c-2.8 2.7-5.7 5.2-8.7 7.6c-21.5 15.7-47.9 24.9-76.3 24.9zm-50.6-4.2c-51.5-12.9-91.9-54.6-102.3-107.8H388.8c-2.8 20.6-10.3 39.6-21.5 55.9C350.4 345 328.3 336 304 336c-46.1 0-84.6 32.5-93.9 75.8zm146.2 4.8c36-26.5 60.7-67.7 65-115.3c1.4-15.7-11-29.3-26.8-29.3H92.8c-11.2 0-19.9 9.6-18.9 20.7c8 88 81.7 155.3 170.1 155.3H248h12.7 4.7c34.2 0 65.8-11.7 90.9-31.4z"]
};
var faGaveDandy = faFaceAwesome;
var faDialOff = {
  prefix: 'fal',
  iconName: 'dial-off',
  icon: [576, 512, [], "e162", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM272 288V415c-63.1-7.9-112-61.7-112-127c0-70.7 57.3-128 128-128s128 57.3 128 128c0 65.3-48.9 119.1-112 127V288c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faToggleOff = {
  prefix: 'fal',
  iconName: 'toggle-off',
  icon: [576, 512, [], "f204", "M416 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H160C89.3 384 32 326.7 32 256s57.3-128 128-128H416zM576 256c0-88.4-71.6-160-160-160H160C71.6 96 0 167.6 0 256s71.6 160 160 160H416c88.4 0 160-71.6 160-160zm-352 0A64 64 0 1 1 96 256a64 64 0 1 1 128 0zM64 256a96 96 0 1 0 192 0A96 96 0 1 0 64 256z"]
};
var faFaceSmileHorns = {
  prefix: 'fal',
  iconName: 'face-smile-horns',
  icon: [640, 512, [], "e391", "M320 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM552.4 148.6c-12.2-26.4-28.8-50.4-48.8-71c13.1-3 27.6-6.8 42.3-11.2c17.7-5.3 36.2-11.7 53.2-19.1c-9.2 28.9-24.6 66.9-46.6 101.3zM94.1 66.4c14.7 4.4 29.2 8.1 42.3 11.2c-20 20.6-36.6 44.6-48.8 71C65.5 114.3 50.2 76.2 40.9 47.3c17 7.4 35.5 13.8 53.2 19.1zM205.5 347.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 370.2 363.4 392 320 392s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM240.4 296c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faBoxArchive = {
  prefix: 'fal',
  iconName: 'box-archive',
  icon: [512, 512, ["archive"], "f187", "M480 64H32v64H64 448h32V64zm0 96H448 64 32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32zM160 240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm288-48h32V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192H64V416c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192z"]
};
var faArchive = faBoxArchive;
var faGrapes = {
  prefix: 'fal',
  iconName: 'grapes',
  icon: [512, 512, [], "e306", "M447.5 221.1c-4.5-10.7-10.5-20.6-17.9-29.3c21.6-2 40.7-14.9 50.2-22.8l0-.1c.1-.1 .2-.4 .2-.9c0-.4-.1-.7-.1-.8C469.7 159.1 446.4 144 416 144c-14.7 0-22.9 1.8-26.9 3.2c-1.6 .6-2.6 1-2.9 1.2c-6.3 5.2-15.6 4.8-21.4-1.1s-6.2-15.2-1.1-21.4c.2-.4 .7-1.3 1.2-2.9c1.3-4 3.2-12.2 3.2-26.9c0-30.4-15.1-53.7-23.2-63.9c-.1 0-.4-.1-.8-.1c-.5 0-.8 .1-.9 .2l-.1 0c-7.9 9.6-20.8 28.6-22.8 50.2C311.5 75 301.7 69 290.9 64.5c6.1-24.5 20-43.7 27.4-52.7C325 3.7 334.8 0 344 0s19.1 3.7 25.8 12.1C379.8 24.8 400 55.1 400 96c0 6.3-.3 11.9-.8 16.8c4.9-.5 10.5-.8 16.8-.8c40.9 0 71.2 20.2 83.9 30.2c8.4 6.7 12.1 16.5 12.1 25.8c0 9.2-3.7 19-11.8 25.7c-9 7.4-28.2 21.3-52.7 27.4zM320 456c-18.4 0-35.2-6.9-47.9-18.2c-12.4 25-38.3 42.2-68.1 42.2c-19 0-36.3-7-49.6-18.4C142.6 491.1 113.7 512 80 512c-44.2 0-80-35.8-80-80c0-33.7 20.9-62.6 50.4-74.4C39 344.3 32 327 32 308c0-29.8 17.2-55.7 42.2-68.1C62.9 227.2 56 210.4 56 192c0-39.8 32.2-72 72-72c17.6 0 33.8 6.3 46.3 16.9C186.4 108.1 214.9 88 248 88c44.2 0 80 35.8 80 80c0 6.2-.7 12.2-2 18c5.8-1.3 11.8-2 18-2c44.2 0 80 35.8 80 80c0 33.1-20.1 61.6-48.9 73.7C385.7 350.2 392 366.4 392 384c0 39.8-32.2 72-72 72zM296 168a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 232a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm144 56a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM108 352a44 44 0 1 0 0-88 44 44 0 1 0 0 88zM80 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm124-32a44 44 0 1 0 0-88 44 44 0 1 0 0 88zm156-64a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-16-72a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faPersonDrowning = {
  prefix: 'fal',
  iconName: 'person-drowning',
  icon: [576, 512, [], "e545", "M144 32c8.8 0 16 7.2 16 16V89c0 63.4 41.9 119.2 102.7 137c47.9 14 98.7 14 146.5 0l114.2-33.3c8.5-2.5 17.4 2.4 19.8 10.9s-2.4 17.4-10.9 19.8L418.2 256.7c-16.9 4.9-34.1 8.3-51.5 10.1l-14 111.8c-9.6-3.5-19.1-8.4-28-14.5c-.8-.5-1.5-1-2.3-1.5l11.8-94.2c-27.1-.2-54.2-4.1-80.6-11.7c-5.6-1.6-11.1-3.5-16.4-5.7L218.2 380.3c-8.5 2.6-17.3 4.1-26.2 4.1c-2.2 0-4.5-.1-6.7-.3l22-148.8C158.8 203.7 128 149.2 128 89V48c0-8.8 7.2-16 16-16zM320 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM192 448c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z"]
};
var faDialMax = {
  prefix: 'fal',
  iconName: 'dial-max',
  icon: [576, 512, [], "e15e", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm90.5 322.5l-.4 .4 .8-.8-.4 .4zM299.3 276.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l89.8 89.8c-50.2 39.1-122.8 35.5-169-10.6c-50-50-50-131 0-181s131-50 181 0c46.2 46.2 49.7 118.8 10.6 169l-89.8-89.8zM401.1 401.1A160 160 0 1 0 174.9 174.9 160 160 0 1 0 401.1 401.1zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleM = {
  prefix: 'fal',
  iconName: 'circle-m',
  icon: [512, 512, [], "e115", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM157.1 134.8c-4-5.7-11.3-8.2-17.9-6.1S128 137 128 144V368c0 8.8 7.2 16 16 16s16-7.2 16-16V194.8l82.9 118.4c3 4.3 7.9 6.8 13.1 6.8s10.1-2.5 13.1-6.8L352 194.8V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-7-4.5-13.2-11.2-15.3s-13.9 .4-17.9 6.1L256 276.1 157.1 134.8z"]
};
var faCalendarImage = {
  prefix: 'fal',
  iconName: 'calendar-image',
  icon: [448, 512, [], "e0d4", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H32V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32zM230 265.4c12.5-18.1 39.2-18.4 52.2-.6l96.3 132.4c15.4 21.2 .3 50.8-25.9 50.8H95.1c-26 0-41.2-29.4-26-50.6l51-71.3c11.5-16.1 34.7-18 48.7-4l13.1 13.1L230 265.4zM352.6 416L256.3 283.6l-59.2 85.5c-2.7 3.9-7 6.4-11.7 6.8s-9.4-1.3-12.8-4.6L146 344.7 95.1 416H352.6zM96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCircleCaretDown = {
  prefix: 'fal',
  iconName: 'circle-caret-down',
  icon: [512, 512, ["caret-circle-down"], "f32d", "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm0 352c9.6 0 18.7-4 25.2-11l95.5-102.8c4.7-5.1 7.3-11.8 7.3-18.7c0-15.2-12.3-27.5-27.5-27.5l-201 0c-15.2 0-27.5 12.3-27.5 27.5c0 6.9 2.6 13.6 7.3 18.7L230.8 341c6.5 7 15.6 11 25.2 11zm1.7-32.7c-.4 .5-1.1 .7-1.7 .7s-1.3-.3-1.7-.7L165.8 224l180.3 0-88.4 95.3z"]
};
var faCaretCircleDown = faCircleCaretDown;
var faArrowDown91 = {
  prefix: 'fal',
  iconName: 'arrow-down-9-1',
  icon: [576, 512, ["sort-numeric-desc", "sort-numeric-down-alt"], "f886", "M428 64a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm-84 52c0-46.4 37.6-84 84-84s84 37.6 84 84c0 1.3 0 2.7-.1 4h.1c0 21.2-7.6 41.8-21.5 57.9l-62.4 72.5c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.9-1.7-22.6L429.3 200c-.4 0-.9 0-1.3 0c-46.4 0-84-37.6-84-84zM267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM448 304V448h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432 384c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V326.2l-26.9 9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13z"]
};
var faSortNumericDesc = faArrowDown91;
var faSortNumericDownAlt = faArrowDown91;
var faFaceGrinTongueSquint = {
  prefix: 'fal',
  iconName: 'face-grin-tongue-squint',
  icon: [512, 512, [128541, "grin-tongue-squint"], "f58a", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm104.5-65.7L171.9 208l-35.4 17.7c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32c5.4-2.7 8.8-8.3 8.8-14.3s-3.4-11.6-8.8-14.3l-64-32c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5zm246.2-21.5c-4-7.9-13.6-11.1-21.5-7.2l-64 32c-5.4 2.7-8.8 8.3-8.8 14.3s3.4 11.6 8.8 14.3l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5L340.2 208l35.4-17.7c7.9-4 11.1-13.6 7.2-21.5zM352 416V383.4c20.2-15.7 36.4-36.2 46.9-59.9c5.2-11.7-6.8-22.4-19.1-18.7c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c10.4 23.6 26.6 44.1 46.8 59.8V416c0 53 43 96 96 96s96-43 96-96zm-32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64V378.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"]
};
var faGrinTongueSquint = faFaceGrinTongueSquint;
var faShishKebab = {
  prefix: 'fal',
  iconName: 'shish-kebab',
  icon: [512, 512, [], "f821", "M352 96c0-35.3 28.7-64 64-64s64 28.7 64 64c0 14.4-4.8 27.7-12.8 38.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c12.1-16 19.2-36 19.2-57.6c0-53-43-96-96-96s-96 43-96 96c0 12.7 2.5 24.9 7 36.1c5.7 14 4.2 26.1-1.5 31.8l-8.8 8.8-30.1-30.1C272.1 128.1 252.5 120 232 120s-40.1 8.1-54.6 22.6l-18.7 18.7C144.1 175.9 136 195.5 136 216c0 6.2 .7 12.3 2.2 18.2c-5.9-1.4-12-2.2-18.2-2.2c-20.5 0-40.1 8.1-54.6 22.6L46.6 273.4C32.1 287.9 24 307.5 24 328s8.1 40.1 22.6 54.6l30.1 30.1-72 72c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l72-72 30.1 30.1C143.9 479.9 163.5 488 184 488s40.1-8.1 54.6-22.6l18.7-18.7C271.9 432.1 280 412.5 280 392c0-6.2-.7-12.3-2.2-18.2c5.9 1.4 12 2.2 18.2 2.2c20.5 0 40.1-8.1 54.6-22.6l18.7-18.7C383.9 320.1 392 300.5 392 280s-8.1-40.1-22.6-54.6l-30.1-30.1 8.8-8.8c19.3-19.3 16.2-47.7 8.6-66.4c-3-7.4-4.7-15.5-4.7-24.1zM181.3 248c-8.5-8.5-13.3-20-13.3-32s4.8-23.5 13.3-32L200 165.3c8.5-8.5 20-13.3 32-13.3s23.5 4.8 32 13.3L346.7 248c8.5 8.5 13.3 20 13.3 32s-4.8 23.5-13.3 32L328 330.7c-8.5 8.5-20 13.3-32 13.3s-23.5-4.8-32-13.3L181.3 248zM69.3 360C60.8 351.5 56 340 56 328s4.8-23.5 13.3-32L88 277.3c8.5-8.5 20-13.3 32-13.3s23.5 4.8 32 13.3L234.7 360c8.5 8.5 13.3 20 13.3 32s-4.8 23.5-13.3 32L216 442.7c-8.5 8.5-20 13.3-32 13.3s-23.5-4.8-32-13.3L69.3 360z"]
};
var faSprayCan = {
  prefix: 'fal',
  iconName: 'spray-can',
  icon: [512, 512, [], "f5bd", "M192 32V96h32V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32V96h32V32h64zm32 128c35.3 0 64 28.7 64 64V440c0 22.1-17.9 40-40 40H72c-22.1 0-40-17.9-40-40V224c0-35.3 28.7-64 64-64h32 64 32zm64-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM96 128c-53 0-96 43-96 96V440c0 39.8 32.2 72 72 72H248c39.8 0 72-32.2 72-72V224c0-53-43-96-96-96H192 128 96zm64 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM408 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM480 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM408 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faAlarmSnooze = {
  prefix: 'fal',
  iconName: 'alarm-snooze',
  icon: [512, 512, [], "f845", "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm-64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h94.7L179.5 358c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H225.3L332.5 218c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1H192z"]
};
var faScarecrow = {
  prefix: 'fal',
  iconName: 'scarecrow',
  icon: [448, 512, [], "f70d", "M224 176a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 32c-36.8 0-69.2-19.1-87.7-48H61.9c4 7 2.3 15.9-4.3 20.8L42.7 192l14.9 11.2c6.5 4.9 8.3 13.8 4.3 20.8h62.6c20.2 0 35.3 18.5 31.4 38.3L134.6 368.7l25.5-14.6c4.9-2.8 11-2.8 15.9 0L224 381.6l48.1-27.5c4.9-2.8 11-2.8 15.9 0l25.5 14.6L292.1 262.3c-4-19.8 11.2-38.3 31.4-38.3h62.6c-4-7-2.3-15.9 4.3-20.8L405.3 192l-14.9-11.2c-6.5-4.9-8.3-13.8-4.3-20.8H311.7c-18.5 28.9-50.8 48-87.7 48zM328 104c0 8.3-1 16.3-2.8 24H416c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4l-7.6 11.4 19.9 14.9c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-19.9 14.9 7.6 11.4c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H323.5l28.2 140.9c1.2 6.2-1.2 12.5-6.3 16.1s-11.8 4-17.3 .9L280 386.4l-48.1 27.5c-4.9 2.8-11 2.8-15.9 0L168 386.4l-48.1 27.5c-5.4 3.1-12.2 2.8-17.3-.9s-7.6-10-6.3-16.1L124.5 256H32c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l7.6-11.4L6.4 204.8C2.4 201.8 0 197 0 192s2.4-9.8 6.4-12.8l19.9-14.9-7.6-11.4c-3.3-4.9-3.6-11.2-.8-16.4s8.2-8.5 14.1-8.5h90.8c-1.8-7.7-2.8-15.7-2.8-24C120 46.6 166.6 0 224 0s104 46.6 104 104zM176 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM208 496V445.3c10.3 3.7 21.7 3.7 32 0V496c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faTruckMonster = {
  prefix: 'fal',
  iconName: 'truck-monster',
  icon: [640, 512, [], "f63b", "M264 32c-4.4 0-8 3.6-8 8v88H462.4L389.2 37.9c-3-3.7-7.6-5.9-12.4-5.9H264zM96 128H224V40c0-22.1 17.9-40 40-40H376.8c14.5 0 28.1 6.5 37.3 17.7L503.6 128H544c35.3 0 64 28.7 64 64v48h-1c4.4 3.9 8.6 8 12.6 12.2c6.1 6.4 5.8 16.6-.7 22.6s-16.6 5.8-22.6-.7C567.2 243.3 525.8 224 480 224c-56.2 0-105.6 28.9-134.1 72.7c-3 4.5-8 7.3-13.4 7.3H307.5c-5.4 0-10.4-2.7-13.4-7.3C265.6 252.9 216.2 224 160 224c-45.8 0-87.2 19.3-116.4 50.2c-6.1 6.4-16.2 6.7-22.6 .7s-6.7-16.2-.7-22.6c3.7-3.9 7.6-7.7 11.6-11.3V192c0-35.3 28.7-64 64-64zM64 217.7c28.2-16.3 61-25.7 96-25.7c64.3 0 121.1 31.6 156 80H324c34.8-48.4 91.7-80 156-80c35 0 67.8 9.4 96 25.7V192c0-17.7-14.3-32-32-32H496.1h-.3H240 96c-17.7 0-32 14.3-32 32v25.7zM154 272c-3.9 0-7.1 2.7-7.8 6.4c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8V370c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4H154zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5h12c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5H154c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6C33.2 411.5 24 397.8 24 382V370c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zM213.5 376a53.5 53.5 0 1 1 -107 0 53.5 53.5 0 1 1 107 0zm252.7-97.6c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8V370c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4H474c-3.9 0-7.1 2.7-7.8 6.4zM474 240h12c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5H474c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6c-13.3-6.5-22.5-20.1-22.5-36V370c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6c6.5-13.3 20.1-22.5 36-22.5zM458.5 376a21.5 21.5 0 1 0 43 0 21.5 21.5 0 1 0 -43 0zM480 429.5a53.5 53.5 0 1 1 0-107 53.5 53.5 0 1 1 0 107z"]
};
var faGiftCard = {
  prefix: 'fal',
  iconName: 'gift-card',
  icon: [576, 512, [], "f663", "M397.1 32c-17.6 0-33.9 9-43.2 23.9l-45 72.1H320h80c26.5 0 48-21.5 48-48s-21.5-48-48-48h-2.9zm-130 96l-45-72.1C212.8 41 196.5 32 178.9 32H176c-26.5 0-48 21.5-48 48s21.5 48 48 48h80 11.1zM288 101l38.8-62c15.1-24.2 41.7-39 70.3-39H400c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h48c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h48c-10-13.4-16-30-16-48c0-44.2 35.8-80 80-80h2.9c28.6 0 55.2 14.7 70.3 39L288 101zM176 160H64c-17.7 0-32 14.3-32 32v96H544V192c0-17.7-14.3-32-32-32H400 322.2l58.1 69.8c5.7 6.8 4.7 16.9-2 22.5s-16.9 4.7-22.5-2L288 169l-67.7 81.3c-5.7 6.8-15.7 7.7-22.5 2s-7.7-15.7-2-22.5L253.8 160H176zM32 320v64H544V320H32zM544 448V416H32v32c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32z"]
};
var faW = {
  prefix: 'fal',
  iconName: 'w',
  icon: [576, 512, [119], "57", "M10.5 33c8.3-3 17.5 1.2 20.5 9.5l135.2 370L272.6 43.6c2-6.8 8.2-11.6 15.4-11.6s13.4 4.7 15.4 11.6L409.8 412.5 545 42.5c3-8.3 12.2-12.6 20.5-9.5s12.6 12.2 9.5 20.5l-152 416c-2.4 6.5-8.7 10.7-15.6 10.5s-12.9-4.9-14.8-11.6L288 105.7 183.4 468.4c-1.9 6.7-7.9 11.3-14.8 11.6s-13.2-4-15.6-10.5L1 53.5C-2.1 45.2 2.2 36 10.5 33z"]
};
var faCodePullRequestDraft = {
  prefix: 'fal',
  iconName: 'code-pull-request-draft',
  icon: [448, 512, [], "e3fa", "M32 80a48 48 0 1 1 96 0A48 48 0 1 1 32 80zm64 78.4c36.5-7.4 64-39.7 64-78.4c0-44.2-35.8-80-80-80S0 35.8 0 80c0 38.7 27.5 71 64 78.4V353.6C27.5 361 0 393.3 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4V158.4zM32 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM400 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM368 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSquareB = {
  prefix: 'fal',
  iconName: 'square-b',
  icon: [448, 512, [], "e264", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 64c0-17.7 14.3-32 32-32h88c39.8 0 72 32.2 72 72c0 19.3-7.6 36.8-19.9 49.7C321.6 262.2 336 285.4 336 312c0 39.8-32.2 72-72 72H160c-17.7 0-32-14.3-32-32V256 160zm160 40c0-22.1-17.9-40-40-40H160v80h88c22.1 0 40-17.9 40-40zM160 352H264c22.1 0 40-17.9 40-40s-17.9-40-40-40H248 160v80z"]
};
var faElephant = {
  prefix: 'fal',
  iconName: 'elephant',
  icon: [640, 512, [128024], "f6da", "M224 111.8C224 67.7 259.7 32 303.8 32c41.5 0 76.1 31.8 79.6 73.2l.7 8.1c.7 8.8 8.5 15.3 17.3 14.6s15.4-8.5 14.6-17.3l-.7-8.1c-1.1-13-4.4-25.4-9.5-36.7C466.1 76.2 512 128.7 512 192V304c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-88.4-71.6-160-160-160h-1.9c-20.2-19.9-48-32-78.3-32c-30.5 0-58.2 12.3-78.4 32.1C118 35.6 32 123.7 32 232v32 0l0 19.1c0 25.4-8.7 50.1-24.5 70L3.5 358C-2 364.9-.9 375 6 380.5s17 4.4 22.5-2.5l3.9-4.9c20.4-25.5 31.6-57.3 31.6-90L64 264v0V232c0-82.4 59.3-150.9 137.4-165.2c-6.1 13.8-9.4 29-9.4 45.1c0 58.2 44.6 106.6 102.5 111.4l8.1 .7c8.8 .7 16.5-5.8 17.3-14.6s-5.8-16.5-14.6-17.3l-8.1-.7c-41.4-3.4-73.2-38-73.2-79.6zM413.4 295.3c-2.8-4.4-7.8-7.3-13.4-7.3c-8.8 0-16 7.2-16 16V464c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V384c0-.7 0-1.4-.1-2c.5-3.8-.4-7.8-2.7-11.2c-5.1-7.2-15-9-22.3-4C279.3 377.6 260.4 384 240 384s-39.3-6.4-54.8-17.2c-7.2-5.1-17.2-3.3-22.3 4c-2.4 3.4-3.2 7.4-2.7 11.2c-.1 .7-.1 1.4-.1 2v80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V352c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V406.7c14.8 6 31 9.3 48 9.3s33.2-3.3 48-9.3V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V349.6c7.2 7.2 14.7 13.2 22.8 18.1c3 1.9 6.1 3.5 9.2 5v10.4c0 53.5 43.4 96.9 96.9 96.9c44.4 0 83.2-30.2 94-73.4l.7-2.7c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-.7 2.7c-7.2 28.9-33.2 49.1-62.9 49.1C509 448 480 419 480 383.1v-.8c7.6 1.1 15.6 1.7 24 1.7c36.6 0 73.4-10.3 99.4-36.8c6.2-6.3 6.1-16.4-.2-22.6s-16.4-6.1-22.6 .2c-18 18.4-45.3 27.2-76.6 27.2c-20.5 0-35.4-3.6-48.6-11.7c-13.5-8.2-26.6-22-42-45zM480 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faEarthAfrica = {
  prefix: 'fal',
  iconName: 'earth-africa',
  icon: [512, 512, [127757, "globe-africa"], "f57c", "M480 256c0-16.8-1.8-33.1-5.3-48.8l-47.2-11.8c-4.1-1-8.4 .2-11.3 3.1c-2 2-3.6 4.2-4.9 6.7l-.3 .6c-7.9 15.8-22.1 27.3-38.6 31.9l15.1 15.1c8 8 12.5 18.9 12.5 30.2c0 19.5-13.2 36.5-32 41.4v6.2c0 17.3-5.6 34.2-16 48l-25.6 34.1C317.3 424.9 303.1 432 288 432c-26.5 0-48-21.5-48-48V336H208c-35.3 0-64-28.7-64-64V244c0-17.6 8.3-34.2 22.4-44.8l39.4-29.5c8.4-6.3 18.5-9.7 29-9.7c5.2 0 10.3 .8 15.3 2.5l32 10.7c4.3 1.4 9 1.6 13.4 .5l34.3-8.6c3.7-.9 6.3-4.3 6.3-8.1c0-2.8-1.4-5.4-3.7-6.9L306 132.6c-7.6 7.3-17.7 11.4-28.2 11.4c-6.3 0-12.5-1.5-18.2-4.3l-13.2-6.6c-23.9 36.9-83 14.6-74.9-30.2L175 84.3c.4-2 .2-4.1-.4-6.1l-9-27.1C86.9 85.8 32 164.5 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224zm-16.5-84.6C430.1 89.6 349.8 32 256 32c-20.9 0-41.2 2.9-60.4 8.2l9.3 27.8c2.4 7.1 2.9 14.6 1.6 22l-3.4 18.7c-1.9 10.2 12 15.2 17.1 6.1c7.4-13.4 24.1-18.5 37.8-11.7l16 8c1.2 .6 2.5 .9 3.8 .9c2.3 0 4.5-.9 6.1-2.5l3.5-3.5c8.5-8.5 21.7-9.8 31.7-3.1L350 123.5c11.2 7.5 18 20.1 18 33.5c0 18.5-12.6 34.6-30.5 39.1l-34.3 8.6c-10.3 2.6-21.2 2.2-31.3-1.2l-32-10.7c-1.7-.6-3.4-.8-5.1-.8c-3.5 0-7 1.1-9.8 3.3l-39.4 29.5c-6 4.5-9.6 11.6-9.6 19.2v28c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32v48c0 8.8 7.2 16 16 16c5 0 9.8-2.4 12.8-6.4l25.6-34.1c6.2-8.3 9.6-18.4 9.6-28.8V318.6c0-11.2 7.6-21 18.5-23.7l5.3-1.3c4.8-1.2 8.2-5.5 8.2-10.5c0-2.9-1.1-5.6-3.2-7.6l-40.2-40.2c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h19.7c11.3 0 21.6-6.4 26.7-16.5l.3-.6c2.8-5.6 6.4-10.7 10.9-15.1c10.9-10.9 26.8-15.3 41.7-11.6l28.2 7.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faGlobeAfrica = faEarthAfrica;
var faRainbow = {
  prefix: 'fal',
  iconName: 'rainbow',
  icon: [640, 512, [127752], "f75b", "M320 64C160.9 64 32 192.9 32 352V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352C0 175.3 143.3 32 320 32s320 143.3 320 320V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352C608 192.9 479.1 64 320 64zm0 192c-53 0-96 43-96 96V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-70.7 57.3-128 128-128s128 57.3 128 128V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-53-43-96-96-96zM128 352V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-123.7 100.3-224 224-224s224 100.3 224 224V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-106-86-192-192-192s-192 86-192 192z"]
};
var faCircleNotch = {
  prefix: 'fal',
  iconName: 'circle-notch',
  icon: [512, 512, [], "f1ce", "M207.4 20.4c2.4 8.5-2.6 17.3-11.2 19.7C101.5 66.2 32 153 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224c0-103-69.5-189.8-164.3-215.9c-8.5-2.4-13.5-11.2-11.2-19.7s11.2-13.5 19.7-11.2C432.5 39.1 512 138.2 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 138.2 79.5 39.1 187.7 9.2c8.5-2.4 17.3 2.6 19.7 11.2z"]
};
var faTabletScreenButton = {
  prefix: 'fal',
  iconName: 'tablet-screen-button',
  icon: [448, 512, ["tablet-alt"], "f3fa", "M384 32c17.7 0 32 14.3 32 32V320H32V64c0-17.7 14.3-32 32-32H384zm32 320v96c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V352H416zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM248 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTabletAlt = faTabletScreenButton;
var faPaw = {
  prefix: 'fal',
  iconName: 'paw',
  icon: [512, 512, [], "f1b0", "M197.4 143.2c-3.5 10.3-9 14.6-13.4 16.1c-4.5 1.5-11.7 1.2-20.8-5.1s-18.2-17.6-23.3-33.1s-4.7-29.9-1.2-40.2c3.5-10.3 9-14.6 13.4-16.1c4.5-1.5 11.7-1.2 20.8 5.1s18.2 17.6 23.3 33.1s4.7 29.9 1.2 40.2zm-3.5 46.5c32.3-10.6 46.9-53.9 32.6-96.8S174.4 23.8 142.1 34.3s-46.9 53.9-32.6 96.8s52.1 69.1 84.4 58.5zm-114.1 54c-.9 7.6-3.9 10.4-5.5 11.3c-1.6 .9-5.7 2.2-13-.9s-15.7-9.9-22-20.7s-8-21.4-7-29c.9-7.6 3.9-10.4 5.5-11.3c1.6-.9 5.7-2.2 13 .9s15.7 9.9 22 20.7s8 21.4 7 29zm10.4 39c24.5-14 29.1-51.7 10.2-84.1s-54-47.3-78.5-33.3s-29.1 51.7-10.2 84.1s54 47.3 78.5 33.3zM256 256c25.7 0 108.2 25.4 156.8 156.3c2.1 5.7 3.2 12.2 3.2 19.4v4.4c0 6.6-5.3 11.9-11.9 11.9c-10.1 0-20.1-1.5-29.7-4.5l-80.2-25.1c-24.9-7.8-51.5-7.8-76.4 0l-80.2 25.1c-9.6 3-19.7 4.5-29.7 4.5c-6.6 0-11.9-5.3-11.9-11.9v-4.4c0-7.1 1.1-13.7 3.2-19.4C147.8 281.4 230.3 256 256 256zm0-32c-41.3 0-134.4 35.9-186.8 177.2c-3.6 9.7-5.2 20.1-5.2 30.5v4.4c0 24.2 19.7 43.9 43.9 43.9c13.3 0 26.6-2 39.3-6l80.2-25.1c18.6-5.8 38.6-5.8 57.3 0L364.8 474c12.7 4 26 6 39.3 6c24.2 0 43.9-19.7 43.9-43.9v-4.4c0-10.4-1.6-20.8-5.2-30.5C390.4 259.9 297.3 224 256 224zm183.3-9.3c6.3-10.8 14.7-17.6 22-20.7s11.4-1.8 13-.9c1.6 .9 4.6 3.7 5.5 11.3c.9 7.7-.8 18.2-7 29s-14.7 17.6-22 20.7s-11.4 1.8-13 .9c-1.6-.9-4.6-3.7-5.5-11.3c-.9-7.7 .8-18.2 7-29zm-27.7-16.1c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3s14.3-70.1-10.2-84.1s-59.7 .9-78.5 33.3zM307.9 103c5.2-15.5 14.2-26.8 23.3-33.1s16.3-6.6 20.8-5.1c4.4 1.5 9.9 5.8 13.4 16.1c3.5 10.3 4 24.7-1.2 40.2s-14.2 26.8-23.3 33.1s-16.3 6.6-20.8 5.1c-4.4-1.5-9.9-5.8-13.4-16.1c-3.5-10.3-4-24.7 1.2-40.2zM277.5 92.9c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5s-.3-86.2-32.6-96.8S291.8 50 277.5 92.9z"]
};
var faMessageQuestion = {
  prefix: 'fal',
  iconName: 'message-question',
  icon: [512, 512, [], "e1e3", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168.7 121.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V240c0 8.8 7.2 16 16 16s16-7.2 16-16V220.3l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2C344 109 315.5 80 280 80H222.9c-25.5 0-47.7 17.2-54.2 41.8zM280 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCloud = {
  prefix: 'fal',
  iconName: 'cloud',
  icon: [640, 512, [9729], "f0c2", "M429.7 135.7c10.3-4.9 21.9-7.7 34.3-7.7c44.2 0 80 35.8 80 80c0 7.7-1.1 15-3 22c-4.1 14.5 2.5 30 15.8 37.1C587.3 283.2 608 315.2 608 352c0 53-43 96-96 96H144C82.1 448 32 397.9 32 336c0-48.8 31.2-90.3 74.8-105.7c12.3-4.3 20.8-15.7 21.3-28.8C131.5 125 194.6 64 272 64c48.7 0 91.7 24.1 117.8 61.2c9 12.7 25.8 17.2 39.9 10.5zM416 106.8C384.1 61.5 331.5 32 272 32c-94.6 0-171.7 74.6-175.8 168.1C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-49.1-27.7-91.8-68.3-113.2c2.8-9.8 4.3-20.1 4.3-30.8c0-61.9-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8z"]
};
var faTrowelBricks = {
  prefix: 'fal',
  iconName: 'trowel-bricks',
  icon: [512, 512, [], "e58a", "M32 128L224 32V224L32 128zM256 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-192 96C6.8 104.8 0 115.9 0 128s6.8 23.2 17.7 28.6l192 96c9.9 5 21.7 4.4 31.1-1.4s15.2-16.1 15.2-27.2V144l88 0c0 17.7 14.3 32 32 32h88c26.5 0 48-21.5 48-48s-21.5-48-48-48H376c-17.7 0-32 14.3-32 32l-88 0V32zm208 80c8.8 0 16 7.2 16 16s-7.2 16-16 16H376V112h88zM288 384h16 16H480v8 88H256V384h32zm-64 0v96H32V384H224zm256-32H320V256H480v96zM288 256v64 32H256 32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V392v-8V256c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32z"]
};
var faSquare3 = {
  prefix: 'fal',
  iconName: 'square-3',
  icon: [448, 512, [], "e258", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32H288c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-78.9 67.6 19.9-.1c44.4-.2 80.6 35.7 80.6 80.2c0 44.3-35.9 80.2-80.2 80.2h-36c-27.6 0-53.5-13-70.1-35l-2.5-3.4c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2l2.5 3.4c10.5 14 27 22.2 44.5 22.2h36c26.6 0 48.2-21.6 48.2-48.2c0-26.7-21.7-48.3-48.4-48.2l-63.5 .3c-6.7 0-12.7-4.1-15.1-10.4s-.5-13.4 4.6-17.7L244.7 160H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFaceFlushed = {
  prefix: 'fal',
  iconName: 'face-flushed',
  icon: [512, 512, [128563, "flushed"], "f579", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160.4-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faFlushed = faFaceFlushed;
var faHospitalUser = {
  prefix: 'fal',
  iconName: 'hospital-user',
  icon: [576, 512, [], "f80d", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H256c3.2 0 6.4-.2 9.5-.7c-5.5-9.2-8.9-19.9-9.4-31.3l-.1 0H64c-17.7 0-32-14.3-32-32V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V64c0-17.7 14.3-32 32-32H256c17.7 0 32 14.3 32 32V336v57.4c9.2-10.2 20-18.9 32-25.6V336 271.8 64c0-35.3-28.7-64-64-64H64zm80 80c-13.3 0-24 10.7-24 24v16H104c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h16v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V200h16c13.3 0 24-10.7 24-24V144c0-13.3-10.7-24-24-24H200V104c0-13.3-10.7-24-24-24H144zm8 56V112h16v24c0 8.8 7.2 16 16 16h24v16H184c-8.8 0-16 7.2-16 16v24H152V184c0-8.8-7.2-16-16-16H112V152h24c8.8 0 16-7.2 16-16zM384 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM320 477.1c0-33.7 27.4-61.1 61.1-61.1H482.9c33.7 0 61.1 27.4 61.1 61.1c0 1.6-1.3 2.9-2.9 2.9H322.9c-1.6 0-2.9-1.3-2.9-2.9zM381.1 384c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H432 381.1z"]
};
var faMicrowave = {
  prefix: 'fal',
  iconName: 'microwave',
  icon: [576, 512, [], "e01b", "M512 64c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H496 80 64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM480 448v16c0 8.8 7.2 16 16 16s16-7.2 16-16V448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16V448H480zM464 128V352c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16s-16 7.2-16 16zM128 320V160H384V320H128zM96 152V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"]
};
var faChfSign = {
  prefix: 'fal',
  iconName: 'chf-sign',
  icon: [640, 512, [], "e602", "M0 112C0 67.8 35.8 32 80 32h4.2c28 0 53.6 15.8 66.1 40.8c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2C114.6 73 100.1 64 84.2 64H80c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h4.2c15.9 0 30.4-9 37.5-23.2c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5c-12.5 25-38.1 40.8-66.1 40.8H80c-44.2 0-80-35.8-80-80V112zM208 32c8.8 0 16 7.2 16 16V224H384V48c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H224V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM448 48c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V224H592c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48z"]
};
var faTentArrowLeftRight = {
  prefix: 'fal',
  iconName: 'tent-arrow-left-right',
  icon: [576, 512, [], "e57f", "M482.8 4.2c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6L518.6 80 57.4 80l57.4-52.2c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80C1.9 87.2 0 91.5 0 96s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L57.4 112l461.2 0-57.4 52.2c-6.5 5.9-7 16.1-1.1 22.6s16.1 7 22.6 1.1l88-80c3.3-3 5.2-7.3 5.2-11.8s-1.9-8.8-5.2-11.8l-88-80zm-185.3 159c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8C65.1 486.5 87.5 512 116.4 512H459.6c29 0 51.3-25.5 47.6-54.2L489.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM272 207.7v112c0 .2 0 .4 0 .5V480H116.4c-9.7 0-17.1-8.5-15.9-18.1l17.5-134.4c.6-4.3 2.9-8.2 6.4-10.8L272 207.7zm32 168.5L368.2 480H304V376.2zm0-60.8V207.7L451.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1H405.9l-.3-.4L304 315.4z"]
};
var faCartCircleArrowUp = {
  prefix: 'fal',
  iconName: 'cart-circle-arrow-up',
  icon: [640, 512, [], "e3f0", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-211.3 3.3c6.2 6.2 16.4 6.2 22.6 0L480 342.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V342.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0l-56 56c-6.2 6.2-6.2 16.4 0 22.6z"]
};
var faTrashClock = {
  prefix: 'fal',
  iconName: 'trash-clock',
  icon: [576, 512, [], "e2b0", "M177.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L299.1 64H148.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0H177.7C161.2 0 145.8 8.5 137 22.6L111.1 64H64.1 32 16C7.2 64 0 71.2 0 80s7.2 16 16 16H34.3L59.8 452.6C62.1 486.1 90 512 123.6 512H324.4c2 0 4-.1 6-.3c-12.7-9-24.2-19.7-34.2-31.7H123.6c-16.8 0-30.7-13-31.9-29.7L66.4 96H381.6l-7.6 105.8c10.5-3.6 21.4-6.3 32.6-8l7-97.8H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416 383.9 336.9zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]
};
var faGavel = {
  prefix: 'fal',
  iconName: 'gavel',
  icon: [512, 512, ["legal"], "f0e3", "M315.3 4.7c6.2 6.2 6.2 16.4 0 22.6L302.6 40 472 209.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24 24-96 96-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 328 184 158.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24 96-96 24-24c6.2-6.2 16.4-6.2 22.6 0zM206.6 136L376 305.4 449.4 232 280 62.6 206.6 136zM144 320L32 432l48 48L192 368l-48-48zm-22.6-22.6c12.5-12.5 32.8-12.5 45.3 0l12.7 12.7 49.8-49.8 22.6 22.6-49.8 49.8 12.7 12.7c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-48-48c-12.5-12.5-12.5-32.8 0-45.3l112-112z"]
};
var faLegal = faGavel;
var faSprinklerCeiling = {
  prefix: 'fal',
  iconName: 'sprinkler-ceiling',
  icon: [384, 512, [], "e44c", "M0 0H32V83.8L128 110v33.2L11.8 111.4C4.8 109.5 0 103.2 0 96V0zM256 110l96-26.2V0h32V96c0 7.2-4.8 13.5-11.8 15.4L256 143.1V110zM192 32c8.8 0 16 7.2 16 16V224h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H192 80c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V48c0-8.8 7.2-16 16-16zM144 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-32 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM0 464a16 16 0 1 1 32 0A16 16 0 1 1 0 464z"]
};
var faBrowsers = {
  prefix: 'fal',
  iconName: 'browsers',
  icon: [576, 512, [], "e0cb", "M512 32c17.7 0 32 14.3 32 32V96H256V32H512zM160 32h64V96H128V64c0-17.7 14.3-32 32-32zM128 352V128H240 544V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zM160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faTrillium = {
  prefix: 'fal',
  iconName: 'trillium',
  icon: [448, 512, [], "e588", "M203.3 8.2c11.8-11 29.8-11 41.5 0c12.1 11.3 33.1 32.5 51.2 58.8c17.9 26 34.2 58.9 34.2 93.4c0 9.3-1.2 18.4-3.5 27c10.5 2.3 20.8 6.1 30.5 11.7l0 0c29.9 17.2 50.4 47.6 64.2 75.9c13.9 28.7 21.9 57.3 25.7 73.5c3.8 15.8-5.4 31.5-20.9 36.1c-16 4.8-44.9 12.2-76.8 14.6c-31.5 2.3-68.3-.1-98.2-17.2c-10.5-6-19.6-13.6-27.1-22.2c-7.5 8.7-16.6 16.2-27.1 22.2c-29.9 17.2-66.7 19.6-98.2 17.2c-31.9-2.4-60.9-9.8-76.8-14.6C6.3 380-2.9 364.4 .8 348.5c3.8-16.2 11.8-44.8 25.7-73.5c13.7-28.3 34.2-58.8 64.2-75.9l0 0c9.8-5.6 20.1-9.5 30.6-11.7c-2.3-8.6-3.5-17.7-3.5-27c0-34.4 16.4-67.4 34.2-93.4c18.1-26.3 39.1-47.5 51.2-58.8zM224 32.6c-11.4 10.7-29.8 29.6-45.6 52.5c-16.5 24-28.6 50.4-28.6 75.2c0 12 2.9 23.3 8.1 33.3c2.6 5 2.4 10.9-.6 15.7s-8.1 7.7-13.7 7.7c-12.6 0-25.4 3.2-37 9.9C84.9 239.4 68 263 55.3 289C43.3 314 36 339.2 32.3 354.4c15.1 4.4 40.8 10.9 68.7 12.9c29.1 2.2 58.2-.6 79.9-13.1c12.8-7.3 22.6-17.9 28.8-30.1c2.7-5.3 8.2-8.7 14.2-8.7s11.5 3.3 14.2 8.7c6.3 12.2 16 22.7 28.8 30.1c21.7 12.5 50.8 15.2 79.9 13.1c27.8-2.1 53.6-8.5 68.7-12.9c-3.7-15.2-10.9-40.5-23-65.4c-12.6-26.1-29.6-49.7-51.3-62.1c-11.6-6.7-24.4-9.8-36.9-9.9c-5.6 0-10.8-2.9-13.7-7.7s-3.1-10.7-.6-15.7c5.2-10 8.1-21.3 8.1-33.3c0-24.9-12.1-51.3-28.6-75.2C253.9 62.3 235.4 43.4 224 32.6zM224 216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm-6.2 183.2c-8.2 35.9-22.6 61.3-30.9 73.9c-9.1 13.7-28.8 13.7-37.9 0c-8.3-12.5-22.7-38-30.9-73.9c10.3-3.1 20.4-7.2 30-12.5c4.8 24 12.9 42.9 19.8 55.7c6.9-12.9 15-31.7 19.8-55.7c9.7 5.3 19.8 9.4 30 12.5zM9.9 105.4c14.7-1.9 44.2-2.8 82.7 10c-2.6 10.4-4.2 21.2-4.5 32.3c-25.6-9.3-46.4-11.4-60.4-11.3c6.4 11.1 17.2 26.4 35 42.3c-9.1 6.1-17.4 13.1-24.9 20.6C10.4 173.6-2.5 149.3-8 136.3c-5.8-13.8 3-29.1 17.9-31zm375.4 73.3c17.8-16 28.7-31.2 35.1-42.4c-14 0-34.9 2.1-60.4 11.3c-.3-11.1-2-21.9-4.5-32.3c38.5-12.8 68-11.8 82.7-10c14.9 1.9 23.7 17.1 17.9 31c-5.5 13-18.4 37.4-45.9 63c-7.5-7.6-15.7-14.6-24.9-20.6z"]
};
var faMusicSlash = {
  prefix: 'fal',
  iconName: 'music-slash',
  icon: [640, 512, [], "f8d1", "M575.5 376.2c.3-2.7 .5-5.4 .5-8.2V136.4l0-.3 0-.5V23c0-12.7-10.3-23-23-23c-2.3 0-4.6 .3-6.8 1l-311 95.7c-3 .9-5.6 2.7-7.5 5L256 123.9v-.1L544 35.2v89L337 187.9 367.5 212 544 157.7V308.4c-17-12.7-39.4-20.4-64-20.4c-5.1 0-10.1 .3-15 1l48 37.9c9.6 4.5 17.2 10.7 22.4 17.7l40.1 31.7zM256 287l-32-25.3V372.4c-17-12.7-39.4-20.4-64-20.4c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80V287zm-96 97c41.1 0 64 26.7 64 48s-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTruckRamp = {
  prefix: 'fal',
  iconName: 'truck-ramp',
  icon: [640, 512, [], "f4e0", "M432 0c-44.2 0-80 35.8-80 80V384c0 1.3 .2 2.5 .4 3.7L11.8 480.6C3.3 482.9-1.8 491.7 .6 500.2s11.1 13.6 19.6 11.2L416.1 403.6C417.9 463.8 467.3 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-51.2 0-94.4 34.4-107.7 81.3l-.5 .1L384 379.1V80c0-26.5 21.5-48 48-48H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H432zm96 320a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faBinoculars = {
  prefix: 'fal',
  iconName: 'binoculars',
  icon: [512, 512, [], "f1e5", "M112 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H336zM192 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V356.9c0-28.8 7.8-57.1 22.7-81.9c16-26.6 26.2-56.3 30.1-87.1L90.5 142c1-8 7.8-14 15.9-14H192v16V272 432zm32 0V288h64V432c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V356.9c0-34.6-9.4-68.6-27.2-98.3c-13.7-22.8-22.5-48.2-25.8-74.6L453.3 138c-3-24-23.4-42-47.6-42H312c-13.3 0-24 10.7-24 24v8H224v-8c0-13.3-10.7-24-24-24H106.4c-24.2 0-44.6 18-47.6 42L53 184c-3.3 26.4-12.1 51.8-25.8 74.6C9.4 288.3 0 322.3 0 356.9V432c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48zm0-176V160h64v96H224zm96 16V144 128h85.6c8.1 0 14.9 6 15.9 14l5.7 45.9c3.9 30.8 14.1 60.5 30.1 87.1c14.8 24.7 22.7 53 22.7 81.9V432c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V272z"]
};
var faMicrophoneSlash = {
  prefix: 'fal',
  iconName: 'microphone-slash',
  icon: [640, 512, [], "f131", "M474.8 296.7c3.4-13 5.2-26.6 5.2-40.7V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 6.3-.5 12.4-1.3 18.5l28.1 22.2zM416 250.2V96c0-53-43-96-96-96s-96 43-96 96v2.7l32 25.3V96c0-35.3 28.7-64 64-64s64 28.7 64 64V225l32 25.3zM192 236.5l-32-25.3V256c0 83 63.1 151.2 144 159.2V480H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V415.2c21.3-2.1 41.4-8.4 59.5-18.1l-28.1-22.2c-14.7 5.8-30.6 9.1-47.4 9.1c-70.7 0-128-57.3-128-128V236.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faBoxTissue = {
  prefix: 'fal',
  iconName: 'box-tissue',
  icon: [512, 512, [], "e05b", "M208 32c12.6 0 17.5 3.4 20.5 6.2c4.7 4.4 8.4 11.1 14.9 24.1l.7 1.5c5.5 11 13.7 27.5 27.4 40.4c16 15.2 37.1 23.8 64.5 23.8h77.5L343.1 304H165L97 32H208zM120 256l12 48H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H377.6l19.2-48 12.8-32 36.5-91.2c1.3-3.2 1.9-6.6 1.9-10C448 108 436 96 421.2 96H336c-40 0-52-24-64-48S248 0 208 0H92.5C76.8 0 64 12.8 64 28.5c0 2.3 .3 4.7 .9 6.9L112 224l8 32zm-33 0l-8-32H48c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H444.1l-12.8 32H464c8.8 0 16 7.2 16 16V384H32V272c0-8.8 7.2-16 16-16H87zM32 416H480v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V416z"]
};
var faCircleC = {
  prefix: 'fal',
  iconName: 'circle-c',
  icon: [512, 512, [], "e101", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM188.1 323.9c-37.5-37.5-37.5-98.3 0-135.8s98.3-37.5 135.8 0c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-37.5 37.5-98.3 37.5-135.8 0z"]
};
var faStarChristmas = {
  prefix: 'fal',
  iconName: 'star-christmas',
  icon: [512, 512, [], "f7d4", "M216.8 205.4L256 55.1l39.2 150.4c1.4 5.5 5.8 9.9 11.3 11.3L456.9 256 306.6 295.2c-5.5 1.4-9.9 5.8-11.3 11.3L256 456.9 216.8 306.6c-1.4-5.5-5.8-9.9-11.3-11.3L55.1 256l150.4-39.2c5.5-1.4 9.9-5.8 11.3-11.3zM256 .2c-10.8 0-20.3 7.3-23.1 17.8l0 0L188.5 188.5 18 232.9l0 0C7.5 235.7 .2 245.2 .2 256s7.3 20.3 17.8 23.1l0 0 170.5 44.5L232.9 494c2.7 10.5 12.2 17.8 23.1 17.8s20.3-7.3 23.1-17.8l44.5-170.5L494 279.1c10.5-2.7 17.8-12.2 17.8-23.1s-7.3-20.3-17.8-23.1L323.5 188.5 279.1 18l0 0C276.3 7.5 266.8 .2 256 .2zM68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm374.6 0c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zm-288 310.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm201.4-22.6c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faChartBullet = {
  prefix: 'fal',
  iconName: 'chart-bullet',
  icon: [512, 512, [], "e0e1", "M272 32c8.8 0 16 7.2 16 16V64H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H48c-26.5 0-48-21.5-48-48V112C0 85.5 21.5 64 48 64H256V48c0-8.8 7.2-16 16-16zM160 96v96h96V96H160zm128 0v96H464c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H288zM128 96H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h80V96zM368 256c8.8 0 16 7.2 16 16v16h80c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H384v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H352V272c0-8.8 7.2-16 16-16zM224 416H352V320H224v96zm160-96v96h80c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H384zm-192 0H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H192V320z"]
};
var faMotorcycle = {
  prefix: 'fal',
  iconName: 'motorcycle',
  icon: [640, 512, [127949], "f21c", "M411.8 96H480V64H453.4L411.8 96zM488 128H412.2L467 232.1c14-5.3 29.2-8.1 45-8.1c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128c0-43.4 21.6-81.8 54.7-104.9l-15-28.5C380.5 247.2 352 296.3 352 352v16c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16v-8c0-92.8-75.2-168-168-168H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h72c41.4 0 79.9 12.6 111.8 34.1l127.4-98L342.3 64H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h70.3c11.9 0 22.8 6.6 28.3 17.1L385 76.3 436.1 37c4.2-3.2 9.3-5 14.6-5H488c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zM257.5 214.7c36.7 34.7 60.2 83.3 62.4 137.3h.2c0-68 35.4-127.8 88.7-161.9l-34.4-65.3L257.5 214.7zM497.8 359.5l-44.1-83.8c-23 17.5-37.8 45.2-37.8 76.3c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-10.5 0-20.5 1.7-29.9 4.8l44.1 83.8c4.1 7.8 1.1 17.5-6.7 21.6s-17.5 1.1-21.6-6.7zM128 256c-53 0-96 43-96 96s43 96 96 96c47.6 0 87.1-34.6 94.7-80h-67c-5.5 9.6-15.9 16-27.7 16c-17.7 0-32-14.3-32-32s14.3-32 32-32c11.8 0 22.2 6.4 27.7 16h67c-7.6-45.4-47.1-80-94.7-80zM0 352a128 128 0 1 1 256 0A128 128 0 1 1 0 352z"]
};
var faTreeChristmas = {
  prefix: 'fal',
  iconName: 'tree-christmas',
  icon: [448, 512, [127876], "f7db", "M212.3 75c-1.6 4.3-5 7.7-9.4 9.4L171.8 96 203 107.7c4.3 1.6 7.7 5 9.4 9.4L224 148.2 235.7 117c1.6-4.3 5-7.7 9.4-9.4L276.2 96 245 84.3c-4.3-1.6-7.7-5-9.4-9.4L224 43.8 212.3 75zM224 0c10.7 0 20.2 6.6 24 16.6l15.1 40.3L303.4 72c10 3.7 16.6 13.3 16.6 24s-6.6 20.2-16.6 24l-40.3 15.1L248 175.4c-3.7 10-13.3 16.6-24 16.6s-20.2-6.6-24-16.6l-15.1-40.3L144.6 120c-10-3.7-16.6-13.3-16.6-24s6.6-20.2 16.6-24l40.3-15.1L200 16.6C203.8 6.6 213.3 0 224 0zM27.9 307.9l107-157.4 25.1 9.4 2.5 6.8L58.4 320h49.8c5.8 0 11.2 3.2 14 8.3s2.6 11.4-.6 16.3L35 480H413L326.4 344.6c-3.2-4.9-3.4-11.2-.6-16.3s8.2-8.3 14-8.3h48.8L285.3 167.1l2.7-7.2 24.8-9.3L419.4 308.3c2.8 4.2 4.5 9 4.8 14c1 16.1-11.8 29.7-28 29.7H369.1l74.4 116.3c2.9 4.6 4.5 9.9 4.5 15.3c0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6c0-5.4 1.6-10.7 4.5-15.3L78.9 352H51.3C35.7 352 23 339.4 23 323.8c0-5.7 1.7-11.2 4.9-15.9zM160 288a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTireFlat = {
  prefix: 'fal',
  iconName: 'tire-flat',
  icon: [512, 512, [], "f632", "M32 460.2c0 10.9 8.9 19.8 19.8 19.8H132 380h80.2c10.9 0 19.8-8.9 19.8-19.8c0-3.1-.7-6.1-2.1-8.8L460.2 416c-5.6-11.1-5.5-23.9-.6-34.7c13-28.4 20.3-60 20.3-93.3C480 164.3 379.7 64 256 64S32 164.3 32 288c0 33.4 7.3 65 20.3 93.3c5 10.8 5 23.6-.6 34.7L34.1 451.4 5.8 437.3l28.3 14.1c-1.4 2.7-2.1 5.8-2.1 8.8zM512 288c0 38.1-8.3 74.2-23.2 106.7c-1 2.2-1 4.8 .1 7l17.7 35.3c3.6 7.2 5.5 15.1 5.5 23.2c0 28.6-23.2 51.8-51.8 51.8H380 132 51.8C23.2 512 0 488.8 0 460.2c0-8 1.9-16 5.5-23.2l17.7-35.3c1.1-2.2 1.1-4.8 .1-7C8.3 362.2 0 326.1 0 288C0 146.6 114.6 32 256 32s256 114.6 256 256zm-128 0c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2zm-74.1 34.4c-8.6 13.5-22.1 23.5-38 27.6l0 65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1zm-70 27.5c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4l0-65zM128 288c0 8.3 .8 16.3 2.3 24.2L192.1 292c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 218.1 128 251.2 128 288zm128-64c8.3 0 16.3 1.6 23.6 4.5l38.2-52.6C299.5 165.8 278.4 160 256 160s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5zM96 288a160 160 0 1 1 320 0A160 160 0 1 1 96 288zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSunglasses = {
  prefix: 'fal',
  iconName: 'sunglasses',
  icon: [576, 512, [128374], "f892", "M86.3 87.6C89.9 73.7 102.4 64 116.8 64c4.9 0 9.7 1.1 14.1 3.3l22 11c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-22-11c-8.8-4.4-18.5-6.7-28.4-6.7c-29 0-54.2 19.6-61.5 47.6L4.6 276.3C1.6 287.9 0 299.8 0 311.8l0 .2v.2V352v16c0 61.9 50.1 112 112 112h44.3c59.4 0 108.5-46.4 111.8-105.8l3.4-54.2h32.9l3.4 54.2C311.1 433.6 360.2 480 419.7 480H464c61.9 0 112-50.1 112-112V352.5l0-.5V312.2c0-12.1-1.5-24.2-4.6-36L520.7 79.6c-7.2-28-32.5-47.6-61.5-47.6c-9.9 0-19.6 2.3-28.4 6.7l-22 11c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l22-11c4.4-2.2 9.2-3.3 14.1-3.3c14.4 0 26.9 9.7 30.5 23.6l48.2 186.8c-31-12-65-18.4-97.6-18.4c-40.1 0-82.2 9.6-118.5 27.3c-2.6 1.3-4.9 2.9-7 4.7H261.1c-2.1-1.8-4.4-3.4-7-4.7C217.9 265.6 175.8 256 135.7 256c-32.6 0-66.6 6.3-97.6 18.4L86.3 87.6zM32 312.2l0-.2c31.4-15.6 68.6-24 103.7-24c35.3 0 72.5 8.5 104.3 24c0 0 0 0 0 .1l0 0-3.8 60.2 0 0 0 .2c-2.4 42.4-37.4 75.6-79.9 75.6H112c-7.7 0-15.1-1.1-22.1-3.1l9.2-4.6 12-6 24-12 48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-48 24-24 12-12 6-12 6-12 6c-1.4 .7-2.6 1.6-3.7 2.5c-8.1-7.7-14.6-17-19-27.5c.3-.1 .7-.3 1-.5l96-48c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L32 366.1V352 312.2zM544 368c0 44.2-35.8 80-80 80H419.7c-8.5 0-16.7-1.3-24.3-3.8l91.8-45.9c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-96 48-12 6c-.6 .3-1.1 .6-1.7 1c-7.7-7.7-13.9-17-18-27.4l93.9-47c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-85.6 42.8L336 312l0 0c0 0 0 0 0-.1c31.8-15.5 69-24 104.3-24c35.1 0 72.2 8.4 103.7 24v56z"]
};
var faBadge = {
  prefix: 'fal',
  iconName: 'badge',
  icon: [512, 512, [], "f335", "M256 32c-28.3 0-53 15.9-65.4 39.4c-3.6 6.8-11.5 10.1-18.8 7.8c-25.4-7.8-54.1-1.6-74.1 18.4s-26.2 48.7-18.4 74.1c2.3 7.3-1 15.2-7.8 18.8C47.9 203 32 227.7 32 256s15.9 53 39.4 65.4c6.8 3.6 10.1 11.5 7.8 18.8c-7.8 25.4-1.6 54.1 18.4 74.1s48.7 26.2 74.1 18.4c7.3-2.3 15.2 1 18.8 7.8C203 464.1 227.7 480 256 480s53-15.9 65.4-39.4c3.6-6.8 11.5-10.1 18.8-7.8c25.4 7.8 54.1 1.6 74.1-18.4s26.2-48.7 18.4-74.1c-2.3-7.3 1-15.2 7.8-18.8C464.1 309 480 284.3 480 256s-15.9-53-39.4-65.4c-6.8-3.6-10.1-11.5-7.8-18.8c7.8-25.4 1.6-54.1-18.4-74.1s-48.7-26.2-74.1-18.4c-7.3 2.3-15.2-1-18.8-7.8C309 47.9 284.3 32 256 32zM168.9 45.6C188 18.1 219.9 0 256 0s68 18.1 87.1 45.6c33-6 68.3 3.8 93.9 29.4s35.3 60.9 29.4 93.9C493.9 188 512 219.9 512 256s-18.1 68-45.6 87.1c6 33-3.8 68.3-29.4 93.9s-60.9 35.3-93.9 29.4C324 493.9 292.1 512 256 512s-68-18.1-87.1-45.6c-33 6-68.3-3.8-93.9-29.4s-35.3-60.9-29.4-93.9C18.1 324 0 292.1 0 256s18.1-68 45.6-87.1c-6-33 3.8-68.3 29.4-93.9s60.9-35.3 93.9-29.4z"]
};
var faMessagePen = {
  prefix: 'fal',
  iconName: 'message-pen',
  icon: [512, 512, ["comment-alt-edit", "message-edit"], "f4a4", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM316.3 147.7c4.9 4.9 4.9 12.9 0 17.8l-8.1 8.1-17.8-17.8 8.1-8.1c4.9-4.9 12.9-4.9 17.8 0zM207.1 239.1l60.7-60.7 17.8 17.8L224.8 257c-2.1 2.1-4.6 3.5-7.4 4.2L198 266l4.9-19.5c.7-2.8 2.2-5.4 4.2-7.4zM275.8 125l-91.4 91.5c-6.1 6.2-10.5 13.9-12.6 22.3l-11.3 45.3c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l45.3-11.3c8.4-2.1 16.2-6.5 22.3-12.6l91.4-91.5c17.4-17.4 17.4-45.6 0-63c-17.4-17.4-45.7-17.4-63.1 0z"]
};
var faCommentAltEdit = faMessagePen;
var faMessageEdit = faMessagePen;
var faBellConcierge = {
  prefix: 'fal',
  iconName: 'bell-concierge',
  icon: [512, 512, [128718, "concierge-bell"], "f562", "M208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v48.6C123.8 152.8 32 249.7 32 368v16H64V368c0-106 86-192 192-192s192 86 192 192v16h32V368c0-118.3-91.8-215.2-208-223.4V96h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 208zM16 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faConciergeBell = faBellConcierge;
var faPenRuler = {
  prefix: 'fal',
  iconName: 'pen-ruler',
  icon: [512, 512, ["pencil-ruler"], "f5ae", "M429.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L341 94.4 417.6 171l54.8-54.8c9.4-9.4 9.4-24.6 0-33.9L429.8 39.6zM83.1 352.4c-7.6 7.6-13.1 16.9-16.1 27.2L39.6 472.4l92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L395 193.6 318.4 117 83.1 352.4zM373.2 17c21.9-21.9 57.3-21.9 79.2 0L495 59.6c21.9 21.9 21.9 57.3 0 79.2L182.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7 .1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L373.2 17zM82.7 27.3c25-25 65.5-25 90.5 0l70.9 70.9-22.6 22.6L189.7 89l-34.3 34.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L167 66.3 150.6 49.9c-12.5-12.5-32.8-12.5-45.3 0L49.9 105.4c-12.5 12.5-12.5 32.8 0 45.3l70.9 70.9L98.2 244.1 27.3 173.3c-25-25-25-65.5 0-90.5L82.7 27.3zm256 457.4l-70.9-70.9 22.6-22.6 70.9 70.9c12.5 12.5 32.8 12.5 45.3 0l55.4-55.4c12.5-12.5 12.5-32.8 0-45.3L445.7 345l-34.3 34.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L423 322.3l-31.8-31.8 22.6-22.6 70.9 70.9c25 25 25 65.5 0 90.5l-55.4 55.4c-25 25-65.5 25-90.5 0z"]
};
var faPencilRuler = faPenRuler;
var faArrowProgress = {
  prefix: 'fal',
  iconName: 'arrow-progress',
  icon: [512, 512, [], "e5df", "M281.6 3.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L288 48H112C50.1 48 0 98.1 0 160s50.1 112 112 112H400c44.2 0 80 35.8 80 80c0 39.5-28.7 72.3-66.3 78.8c-7.5-27-32.3-46.8-61.7-46.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c30.1 0 55.4-20.8 62.2-48.9C469.4 456.1 512 409 512 352c0-61.9-50.1-112-112-112H112c-44.2 0-80-35.8-80-80s35.8-80 80-80H288L262.4 99.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48zM351.9 480a32 32 0 1 1 .1-64 32 32 0 1 1 -.1 64zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 448 0a64 64 0 1 0 0 128zM126 432c-7.1-27.6-32.2-48-62-48c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h66l-25.6 19.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L192 432H126zM32 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faChessRookPiece = {
  prefix: 'fal',
  iconName: 'chess-rook-piece',
  icon: [320, 512, ["chess-rook-alt"], "f448", "M16 112c0-8.8 7.2-16 16-16H288c8.8 0 16 7.2 16 16V224c0 3.7-1.3 7.4-3.7 10.2l-35.9 43.1 4.4 74.6H236.7L232 272.9c-.2-4.1 1.1-8.1 3.7-11.2L272 218.2V128H224v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H128v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H48v90.2l36.3 43.6c2.6 3.1 3.9 7.1 3.7 11.2L83.3 352H51.3l4.4-74.6L19.7 234.2c-2.4-2.9-3.7-6.5-3.7-10.2V112zm144 96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16zM33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4H280.6c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L254.2 416 65.8 416 33.1 468.7zM254.2 384c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1H254.2z"]
};
var faChessRookAlt = faChessRookPiece;
var faSquareRoot = {
  prefix: 'fal',
  iconName: 'square-root',
  icon: [576, 512, [8730], "f697", "M352.1 64c-7.1 0-13.4 4.7-15.4 11.6L223.4 468.4c-1.8 6.3-7.2 10.8-13.7 11.5s-12.7-2.6-15.8-8.4L82.9 264.4c-2.8-5.2-8.2-8.4-14.1-8.4H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H68.8c17.7 0 34 9.7 42.3 25.3l92.4 172.4L306 66.7C311.9 46.1 330.7 32 352.1 32H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H352.1z"]
};
var faAlbumCollectionCirclePlus = {
  prefix: 'fal',
  iconName: 'album-collection-circle-plus',
  icon: [640, 512, [], "e48e", "M32 16c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H48C39.2 0 32 7.2 32 16zM16 80c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272C31.4 489.9 55.6 512 84.5 512H394.8c-12.9-9.1-24.5-19.9-34.6-32H84.5c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272C34.6 172.1 45.7 160 59.8 160H452.2c14.1 0 25.2 12.1 23.9 26.2l-.6 7c6.7-.8 13.6-1.2 20.5-1.2c3.9 0 7.8 .1 11.7 .4l.3-3.3c3-32.8-22.8-61.1-55.8-61.1H59.8zM256 192c-88.4 0-160 57.3-160 128s71.6 128 160 128c27.6 0 53.6-5.6 76.2-15.4c-3.9-9.9-6.9-20.2-9-30.8C304.4 410.6 281.7 416 256 416c-77.7 0-128-49.3-128-96s50.3-96 128-96c43.3 0 78 15.3 100.3 36.9c6.5-8.5 13.8-16.4 21.8-23.6C348.8 209.6 305 192 256 192zm0 152c13.3 0 24-9 24-20s-10.7-20-24-20s-24 9-24 20s10.7 20 24 20zm128 24a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"]
};
var faPeopleArrows = {
  prefix: 'fal',
  iconName: 'people-arrows',
  icon: [640, 512, ["people-arrows-left-right"], "e068", "M128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 192c-25 0-45.8 19.1-47.8 44l-4.1 49.3C52.1 304 66.8 320 85.6 320h45.2c2.3 6.6 6.1 12.7 11.3 17.9L156.1 352H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c28.3 0 53.4 14.8 67.7 37.3c-4.3 2.2-8.4 5.1-12 8.8l-12.6 12.6c-7.9-15.9-24.3-26.7-43-26.7H105.6zM160 496V355.9l32 32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16zm288 0V387.9l32-32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96-144H483.9l14.1-14.1c5.2-5.2 9-11.4 11.3-17.9h45.2c18.7 0 33.4-16 31.9-34.7L582.2 236c-2.1-24.9-22.9-44-47.8-44H489.6c-18.7 0-35.1 10.8-43 26.7l-12.6-12.6c-3.6-3.6-7.7-6.5-12-8.8c14.2-22.5 39.3-37.3 67.7-37.3h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352zM512 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM251.3 251.3L214.6 288H425.4l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L425.4 320H214.6l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPeopleArrowsLeftRight = faPeopleArrows;
var faFaceAngryHorns = {
  prefix: 'fal',
  iconName: 'face-angry-horns',
  icon: [640, 512, [], "e368", "M320 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM552.4 148.6c-12.2-26.4-28.8-50.4-48.8-71c13.1-3 27.6-6.8 42.3-11.2c17.7-5.3 36.2-11.7 53.2-19.1c-9.2 28.9-24.6 66.9-46.6 101.3zM94.1 66.4c14.7 4.4 29.2 8.1 42.3 11.2c-20 20.6-36.6 44.6-48.8 71C65.5 114.3 50.2 76.2 40.9 47.3c17 7.4 35.5 13.8 53.2 19.1zM402.7 411.9c6.6-5.9 7.1-16 1.2-22.6C387.8 371.4 359.7 352 320 352s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM240.4 296c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faMarsAndVenusBurst = {
  prefix: 'fal',
  iconName: 'mars-and-venus-burst',
  icon: [640, 512, [], "e523", "M528 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4l-75.6 75.6C481.1 80.6 442.5 64 400 64c-88.4 0-160 71.6-160 160c0 83 63.1 151.2 144 159.2V416H344c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V383.2c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L608 54.6V104c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H528zM272 224a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM176 8c-6.3 0-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.1 3.4 9.5 4.5 14.5 3.1c-13.9-17.5-24.9-37.4-32-59.1l-31.5-26.1c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l24.2-6c11.2-16.3 24.9-30.8 40.5-43L222.6 87.2 190.5 17.3C187.9 11.6 182.3 8 176 8z"]
};
var faTombstone = {
  prefix: 'fal',
  iconName: 'tombstone',
  icon: [448, 512, [], "f720", "M384 448V192c0-88.4-71.6-160-160-160S64 103.6 64 192V448H32V192C32 86 118 0 224 0S416 86 416 192V448H384zM0 496c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM240 144v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSquareCaretRight = {
  prefix: 'fal',
  iconName: 'square-caret-right',
  icon: [448, 512, ["caret-square-right"], "f152", "M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 9.6-4 18.7-11 25.2L206.2 376.7c-5.1 4.7-11.8 7.3-18.7 7.3c-15.2 0-27.5-12.3-27.5-27.5l0-201c0-15.2 12.3-27.5 27.5-27.5c6.9 0 13.6 2.6 18.7 7.3L309 230.8c7 6.5 11 15.6 11 25.2zm-32.7-1.7L192 165.8l0 180.3 95.3-88.4c.5-.4 .7-1.1 .7-1.7s-.3-1.3-.7-1.7z"]
};
var faCaretSquareRight = faSquareCaretRight;
var faScissors = {
  prefix: 'fal',
  iconName: 'scissors',
  icon: [512, 512, [9984, 9986, 9988, "cut"], "f0c4", "M508.2 442.4c5.7-6.7 4.9-16.8-1.8-22.6l-152-129.3c-6.7-5.7-16.8-4.9-22.6 1.8s-4.9 16.8 1.8 22.6l152 129.3c6.7 5.7 16.8 4.9 22.6-1.8zM287 235.1l-78.5-66.1c9.9-16.7 15.5-36.2 15.5-56.9C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c29.5 0 56.4-11.4 76.4-30.1L262.2 256l-73.8 62.1c-20-18.7-46.9-30.1-76.4-30.1C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-20.8-5.7-40.3-15.5-56.9L506.3 92.2c6.8-5.7 7.6-15.8 1.9-22.5s-15.8-7.6-22.5-1.9L287 235.1zM112 192a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm0 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faCut = faScissors;
var faListMusic = {
  prefix: 'fal',
  iconName: 'list-music',
  icon: [512, 512, [], "f8c9", "M489.1 0C501.8 0 512 10.2 512 22.9V136c0 6.9-4.5 13.1-11.1 15.2L384 188.9V432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c31.3 0 59.7 9.2 80 24V56c0-6.9 4.4-13 10.9-15.2L481.9 1.2c2.3-.8 4.8-1.2 7.2-1.2zM332.6 401.5C318.3 391.3 297 384 272 384s-46.3 7.3-60.6 17.5C197.1 411.7 192 422.9 192 432s5.1 20.3 19.4 30.5C225.7 472.7 247 480 272 480s46.3-7.3 60.6-17.5C346.9 452.3 352 441.1 352 432s-5.1-20.3-19.4-30.5zM384 155.3l96-30.9V35.5l-96 32v87.8zM16 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSunPlantWilt = {
  prefix: 'fal',
  iconName: 'sun-plant-wilt',
  icon: [640, 512, [], "e57a", "M160.5 0c-5.9 0-11.3 3.2-14.1 8.4l-27.5 51L63.4 42.7c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.6 55.4-51 27.5c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51 27.5L43.5 256.7c-1.7 5.6-.2 11.7 4 15.9s10.3 5.7 15.9 4L118.9 260l27.5 51c2.8 5.2 8.2 8.4 14.1 8.4s11.3-3.2 14.1-8.4l27.5-51 55.6 16.6c5.6 1.7 11.7 .1 15.9-4s5.7-10.3 4-15.9l-16.6-55.4 51-27.5c5.2-2.8 8.4-8.2 8.4-14.1s-3.2-11.3-8.4-14.1l-51-27.5 16.6-55.4c1.7-5.6 .2-11.7-4-15.9s-10.3-5.7-15.9-4L202.1 59.4l-27.5-51C171.8 3.2 166.4 0 160.5 0zm0 49.7L180.1 86c3.6 6.7 11.4 9.9 18.7 7.7l39.6-11.8-11.9 39.5c-2.2 7.3 1.1 15.1 7.7 18.7l36.3 19.6-36.3 19.6c-6.7 3.6-9.9 11.4-7.7 18.7l11.9 39.5-39.6-11.8c-7.3-2.2-15.1 1.1-18.7 7.7l-19.6 36.3-19.6-36.3c-3.6-6.7-11.4-9.9-18.7-7.7L82.6 237.4l11.9-39.5c2.2-7.3-1.1-15.1-7.7-18.7L50.4 159.7l36.3-19.6c6.7-3.6 9.9-11.4 7.7-18.7L82.6 81.9l39.6 11.8c7.3 2.2 15.1-1.1 18.7-7.7l19.6-36.3zm32.6 111.2a32 32 0 1 0 -63.9 0 32 32 0 1 0 63.9 0zm303.7 .1c0-17.6 14.3-32 32-32s32 14.3 32 32v49.5c-11.4 2.5-21.7 7.9-29.9 16.2c-11.9 12.1-18 28.9-18 48c0 14.4 7.5 30.9 16.5 45.3c9.4 15.1 22.3 30.7 36.5 44.1c6.2 5.8 15.8 5.8 22 0c14.2-13.4 27.1-29.1 36.5-44.2c9-14.4 16.5-30.9 16.5-45.2c0-19.1-6.1-35.9-18-48c-8.2-8.3-18.5-13.7-29.9-16.2V160.9c0-35.3-28.6-64-64-64s-64 28.6-64 64v43.9c-11.4-7.6-25.2-12.1-39.9-12.1c-39.7 0-71.9 32.2-71.9 71.9v9.6c-11.4 2.5-21.7 7.9-29.9 16.2c-11.9 12.1-18 28.9-18 48c0 14.4 7.5 30.9 16.5 45.3c9.5 15.1 22.3 30.7 36.5 44.1c6.2 5.8 15.8 5.8 22 0c14.2-13.4 27.1-29.1 36.5-44.2c9-14.4 16.5-30.9 16.5-45.2c0-19.1-6.1-35.9-18-48c-8.2-8.3-18.5-13.7-29.9-16.2v-9.6c0-22.1 17.9-39.9 39.9-39.9s39.9 17.9 39.9 39.9v15.9V480.1H17.3c-8.8 0-16 7.2-16 16s7.2 16 16 16H480.8 624.7c8.8 0 16-7.2 16-16s-7.2-16-16-16H496.8V280.6 264.7 160.9zM368.9 304.6c10.6 0 18.2 3.4 23.2 8.4c5 5 8.8 13.2 8.8 25.5c0 4.9-3.3 14.9-11.6 28.3c-5.5 8.8-12.5 18-20.3 26.7c-7.9-8.7-14.9-17.8-20.3-26.6c-8.3-13.3-11.6-23.3-11.6-28.3c0-12.3 3.8-20.5 8.8-25.5c5-5 12.6-8.4 23.2-8.4zM597 302.9c-5.5 8.8-12.5 18-20.3 26.7c-7.9-8.7-14.9-17.8-20.3-26.6c-8.3-13.3-11.6-23.3-11.6-28.3c0-12.3 3.8-20.5 8.8-25.5c5-5 12.6-8.4 23.2-8.4s18.2 3.4 23.2 8.4c5 5 8.8 13.2 8.8 25.5c0 4.9-3.3 14.9-11.6 28.3z"]
};
var faToiletsPortable = {
  prefix: 'fal',
  iconName: 'toilets-portable',
  icon: [576, 512, [], "e584", "M64 32H192c17.7 0 32 14.3 32 32V96H32V64c0-17.7 14.3-32 32-32zM32 448V128H224v80H200c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h24V448H32zM256 208V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V480H224v16c0 8.8 7.2 16 16 16s16-7.2 16-16V336 304 240 208zm-32 32v64H200c-4.4 0-8-3.6-8-8V248c0-4.4 3.6-8 8-8h24zM384 32H512c17.7 0 32 14.3 32 32V96H352V64c0-17.7 14.3-32 32-32zM352 448V128H544v80H520c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h24V448H352zM576 208V64c0-35.3-28.7-64-64-64H384c-35.3 0-64 28.7-64 64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V480H544v16c0 8.8 7.2 16 16 16s16-7.2 16-16V336 304 240 208zm-32 32v64H520c-4.4 0-8-3.6-8-8V248c0-4.4 3.6-8 8-8h24z"]
};
var faHockeyPuck = {
  prefix: 'fal',
  iconName: 'hockey-puck',
  icon: [512, 512, [], "f453", "M32 184c0 9 4.1 18.9 14.3 29.3c10.2 10.5 25.8 20.7 46.3 29.6c41 17.8 98.7 29.1 163.3 29.1s122.4-11.4 163.3-29.1c20.5-8.9 36.1-19.1 46.3-29.6C475.9 202.9 480 193 480 184s-4.1-18.9-14.3-29.3c-10.2-10.5-25.8-20.7-46.3-29.6C378.4 107.4 320.6 96 256 96s-122.4 11.4-163.3 29.1c-20.5 8.9-36.1 19.1-46.3 29.6C36.1 165.1 32 175 32 184zM0 184c0-19.7 9.3-37.2 23.4-51.7C37.5 117.9 57 105.7 79.9 95.8C125.8 75.9 188.1 64 256 64s130.2 11.9 176.1 31.8c22.9 9.9 42.5 22.2 56.5 36.6c14.1 14.5 23.4 32 23.4 51.7V328c0 19.7-9.3 37.2-23.4 51.7c-14.1 14.4-33.6 26.6-56.5 36.6C386.2 436.1 323.9 448 256 448s-130.2-11.9-176.1-31.8c-22.9-9.9-42.5-22.2-56.5-36.6C9.3 365.2 0 347.7 0 328V184zm480 59.6c-13 11-29.4 20.6-47.9 28.6C386.2 292.1 323.9 304 256 304s-130.2-11.9-176.1-31.8c-18.6-8-34.9-17.6-47.9-28.6V328c0 9 4.1 18.9 14.3 29.3c10.2 10.5 25.8 20.7 46.3 29.6c41 17.8 98.7 29.1 163.3 29.1s122.4-11.4 163.3-29.1c20.5-8.9 36.1-19.1 46.3-29.6C475.9 346.9 480 337 480 328V243.6z"]
};
var faMustache = {
  prefix: 'fal',
  iconName: 'mustache',
  icon: [640, 512, [], "e5bc", "M235 112c-31.7 0-62.2 12.6-84.6 35.1c-31.6 31.6-81.9 34.4-116.8 6.5l-7.5-6c-5.1-4.1-12-4.5-17.5-1.6c-1.4 .7-2.7 1.7-3.8 2.8C1.8 151.6 0 155.6 0 160v44C0 312.2 87.8 400 196 400c42.4 0 83.7-13.8 117.6-39.2L320 356l6.4 4.8C360.3 386.2 401.6 400 444 400c108.2 0 196-87.8 196-196V160c0-4.4-1.8-8.4-4.6-11.3c-1.1-1.2-2.4-2.1-3.8-2.8c-5.5-2.9-12.4-2.5-17.5 1.6l-7.5 6c-34.9 27.9-85.2 25.1-116.8-6.5C467.2 124.6 436.8 112 405 112h-3.3c-25.2 0-49.8 7.5-70.8 21.4l-11 7.3-11-7.3c-21-14-45.6-21.4-70.8-21.4H235zm373 78.7V204c0 90.6-73.4 164-164 164c-35.5 0-70-11.5-98.4-32.8l-16-12c-5.7-4.3-13.5-4.3-19.2 0l-16 12C266 356.5 231.5 368 196 368c-90.6 0-164-73.4-164-164V190.7c45.7 24.4 103.1 16.8 140.9-21c16.4-16.4 38.8-25.7 62-25.7h3.3c18.9 0 37.3 5.6 53 16.1l19.9 13.3c5.4 3.6 12.4 3.6 17.8 0l19.9-13.3c15.7-10.5 34.1-16.1 53-16.1H405c23.3 0 45.6 9.2 62 25.7c37.8 37.8 95.3 45.4 140.9 21z"]
};
var faHyphen = {
  prefix: 'fal',
  iconName: 'hyphen',
  icon: [320, 512, [], "2d", "M0 256c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faTable = {
  prefix: 'fal',
  iconName: 'table',
  icon: [512, 512, [], "f0ce", "M64 64C46.3 64 32 78.3 32 96l0 64 448 0V96c0-17.7-14.3-32-32-32L64 64zM32 192l0 112 208 0 0-112L32 192zm240 0l0 112H480l0-112-208 0zM240 336L32 336l0 80c0 17.7 14.3 32 32 32l176 0V336zm32 112H448c17.7 0 32-14.3 32-32V336H272V448zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"]
};
var faUserChef = {
  prefix: 'fal',
  iconName: 'user-chef',
  icon: [448, 512, [], "e3d2", "M96 64c0 13.9 8.9 25.8 21.3 30.2c6.4 2.3 10.7 8.3 10.7 15.1V144H320V109.3c0-6.8 4.3-12.8 10.7-15.1C343.1 89.8 352 77.9 352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32zM128 0c19.1 0 36.3 8.4 48 21.7C187.7 8.4 204.9 0 224 0s36.3 8.4 48 21.7C283.7 8.4 300.9 0 320 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V160v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V160 119.4C76.9 108.4 64 87.7 64 64C64 28.7 92.7 0 128 0zm96 272c53 0 96-43 96-96H128c0 53 43 96 96 96zM112 372.6c0 7.1-4.7 13.3-11.4 15.3C60.9 399.8 32 436.5 32 480h96V436.5c0-18.7 10.9-35.7 27.9-43.6l33.4-15.4L112 341.4v31.2zM160 480H416c0-43.5-28.9-80.2-68.6-92c-6.8-2-11.4-8.3-11.4-15.3V345L169.3 421.9c-5.7 2.6-9.3 8.3-9.3 14.5V480zM337.3 309.1l-1.4-3c3-1.4 6.2-2.1 9.5-2.1c12.5 0 22.5 10.1 22.5 22.5v34.8c46.9 19 80 65 80 118.7c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32c0-53.7 33.1-99.7 80-118.7V326.5c0-12.5 10.1-22.5 22.5-22.5c3.3 0 6.5 .7 9.5 2.1L224 358.3l111.9-52.2 1.4 3zM240 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faMessageImage = {
  prefix: 'fal',
  iconName: 'message-image',
  icon: [512, 512, ["comment-alt-image"], "e1e0", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm135.9 32.1L380.3 288H131.5l44.6-63.8 19 25.4c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.5zm-25.5-19.4L208 213.3l-6.5-8.7c-6-8-15.4-12.7-25.3-12.7c-10.3 0-20 5-26 13.5l-49.1 70.2c-3.3 4.7-5.1 10.4-5.1 16.2c0 15.6 12.6 28.2 28.2 28.2H387.9c15.5 0 28.1-12.6 28.1-28.1c0-5.9-1.9-11.7-5.3-16.4l-97-134.3c-6-8.3-15.6-13.2-25.8-13.2c-10 0-19.4 4.7-25.5 12.7z"]
};
var faCommentAltImage = faMessageImage;
var faUsersMedical = {
  prefix: 'fal',
  iconName: 'users-medical',
  icon: [640, 512, [], "f830", "M192 80A48 48 0 1 0 96 80a48 48 0 1 0 96 0zM64 80a80 80 0 1 1 160 0A80 80 0 1 1 64 80zM320 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM261.3 384c-54.2 0-98.4 42.5-101.2 96H448c0 11.7 3.1 22.6 8.6 32H154.7c-14.7 0-26.7-11.9-26.7-26.7C128 411.7 187.7 352 261.3 352H378.7c4.6 0 9.1 .2 13.5 .7c-5.2 9.3-8.2 19.9-8.2 31.3v.1c-1.8-.1-3.5-.1-5.3-.1H261.3zM512 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zm16 224H448c0-11-1.4-21.8-4-32h84c61.9 0 112 50.1 112 112c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2-35.8-80-80-80zm-336 0H112c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112h84c-2.6 10.2-4 21-4 32zm320 64h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H576v32c0 17.7-14.3 32-32 32H512c-17.7 0-32-14.3-32-32V448H448c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32h32V320c0-17.7 14.3-32 32-32zm0 80c0 8.8-7.2 16-16 16H448v32h48c8.8 0 16 7.2 16 16v48h32V432c0-8.8 7.2-16 16-16h48V384H560c-8.8 0-16-7.2-16-16V320H512v48z"]
};
var faSensorTriangleExclamation = {
  prefix: 'fal',
  iconName: 'sensor-triangle-exclamation',
  icon: [640, 512, ["sensor-alert"], "e029", "M64 64H384c17.7 0 32 14.3 32 32v39.4c9.8-4.8 20.7-7.4 32-7.4V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H225c-.6-4-1-8.1-1-12.3c0-6.7 .9-13.3 2.6-19.7H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm291.8 36.9C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9l-150.4 265c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3H595.7c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265zM440 196.7c1.6-2.9 4.7-4.7 8-4.7s6.4 1.8 8 4.7l150.4 265c1 1.9 1.6 3.9 1.6 6.1c0 6.8-5.5 12.3-12.3 12.3H300.3c-6.8 0-12.3-5.5-12.3-12.3c0-2.1 .6-4.2 1.6-6.1L440 196.7zM464 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM448 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSensorAlert = faSensorTriangleExclamation;
var faMagnifyingGlassArrowRight = {
  prefix: 'fal',
  iconName: 'magnifying-glass-arrow-right',
  icon: [512, 512, [], "e521", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm27.3-299.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265.4 192H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H265.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"]
};
var faTachographDigital = {
  prefix: 'fal',
  iconName: 'tachograph-digital',
  icon: [640, 512, ["digital-tachograph"], "f566", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm96 32v64H320V160H96zm-32 0c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160zm0 208c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faDigitalTachograph = faTachographDigital;
var faFaceMask = {
  prefix: 'fal',
  iconName: 'face-mask',
  icon: [576, 512, [], "e37f", "M444.8 416C404.4 455.6 349 480 288 480s-116.4-24.4-156.8-64h18.2c9 18.9 28.3 32 50.6 32H376c22.3 0 41.6-13.1 50.6-32h18.2zm27.1-32H432V312c0-3.8-.4-7.5-1.1-11l.6 1.2L512 259.2c-.7 46.4-15.4 89.3-40.1 124.8zm37.9-159.9l-92.9 49.6C406.6 262.8 392.1 256 376 256H200c-16.1 0-30.6 6.8-40.8 17.7L66.2 224.1C81.7 115.5 175.1 32 288 32s206.3 83.5 221.8 192.1zm29.9-15.5C517.4 89.9 413.2 0 288 0S58.6 89.9 36.4 208.6c-7.1-2-14.9 1.1-18.5 7.9c-4.2 7.8-1.2 17.5 6.6 21.6l7.9 4.2c-.2 4.5-.4 9.1-.4 13.7c0 141.4 114.6 256 256 256s256-114.6 256-256c0-4.6-.1-9.1-.4-13.7l7.9-4.2c7.8-4.2 10.7-13.8 6.6-21.6c-3.6-6.8-11.4-9.9-18.5-7.9zM64 259.2l80.4 42.9 .6-1.2c-.7 3.6-1.1 7.3-1.1 11v72H104.1C79.4 348.5 64.7 305.6 64 259.2zM376 288c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V312c0-13.3 10.7-24 24-24H376zM200 328c0 8.8 7.2 16 16 16H360c8.8 0 16-7.2 16-16s-7.2-16-16-16H216c-8.8 0-16 7.2-16 16zm0 48c0 8.8 7.2 16 16 16H360c8.8 0 16-7.2 16-16s-7.2-16-16-16H216c-8.8 0-16 7.2-16 16zm40-200c8.8 0 16-7.2 16-16s-7.2-16-16-16c-55.4 0-93.6 23-107.3 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C162.9 195.7 193 176 240 176zm180.7 27.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C429.6 167 391.4 144 336 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c47 0 77.1 19.7 84.7 27.3z"]
};
var faPickleball = {
  prefix: 'fal',
  iconName: 'pickleball',
  icon: [576, 512, [], "e435", "M363.6 50.7c-25-25-65.6-25-90.6 0L141 182.3 283.5 324.3c-4.5 11.3-7.8 23.2-9.7 35.5l-155.5-155-3.2 3.2c-13.8 13.7-17.9 34.4-10.4 52.3l24.9 59.8c10 23.9 4.5 51.5-13.9 69.8l-63 62.8c-6.3 6.2-6.3 16.3 0 22.6c6.3 6.2 16.4 6.2 22.7 0l63.3-63c18.3-18.2 45.7-23.7 69.6-13.9l58.5 24c3.4 1.4 6.9 2.4 10.5 3c3 11.4 7.3 22.2 12.6 32.4c-11.8 .7-23.9-1.2-35.3-5.8l-58.5-24c-12-4.9-25.7-2.2-34.8 7L98.1 498c-18.8 18.7-49.2 18.7-68 0s-18.8-49.1 0-67.8l63-62.8c9.2-9.2 11.9-22.9 6.9-34.9L75.1 272.7c-12.5-29.9-5.6-64.3 17.3-87.2L250.3 28.1c37.5-37.4 98.4-37.4 135.9 0L499.8 141.3c29.4 29.3 35.8 72.9 19.1 108.4c-8.9-5.8-18.5-10.7-28.5-14.7c10.4-23.5 6-51.9-13.3-71.1L363.6 50.7zm68.4 429.4a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-224a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-64 128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0-48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-64-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
};
var faStarSharpHalf = {
  prefix: 'fal',
  iconName: 'star-sharp-half',
  icon: [576, 512, [], "e28c", "M272 93.9L239.2 196.9C237.1 203.5 231 208 224 208H75.3l126 91c5.5 4 7.9 11.1 5.9 17.6L163.5 460.6 272 376.2V93.9zm-8.3-79.5C266.5 5.8 274.4 0 283.4 0C294.8 0 304 9.2 304 20.6V384c0 4.9-2.3 9.6-6.2 12.6l-142.7 111c-3.6 2.8-8.1 4.4-12.7 4.4c-13.9 0-23.9-13.4-19.8-26.8l50.8-167L43 224.1c-6.9-5-11-13-11-21.6C32 187.9 43.9 176 58.6 176H212.3L263.7 14.4z"]
};
var faUsersSlash = {
  prefix: 'fal',
  iconName: 'users-slash',
  icon: [640, 512, [], "e073", "M191.5 73l30.7 24.2c1.2-5.5 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-12.5 0-24.3 2.9-34.9 8l30.7 24.2c1.4-.1 2.8-.2 4.2-.2c24.1 0 44.1 17.8 47.5 41zM135.6 192H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h64.2l-40.5-32zM413 247.9c2-7.6 3-15.6 3-23.9c0-53-43-96-96-96c-16.2 0-31.4 4-44.8 11.1l29 22.9c5.1-1.3 10.4-2 15.8-2c35.3 0 64 28.7 64 64l0 1 29 22.9zM338.3 352H320 261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c13.5 0 24.7-10 26.4-23.1l-34.5-27.3c1.4 5.9 2.3 12.1 2.6 18.3H160.1c2.8-53.5 47-96 101.2-96H378.7l.2 0-40.5-32zM464 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM448 224h80c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112H444c2.6 10.2 4 21 4 32zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faClover = {
  prefix: 'fal',
  iconName: 'clover',
  icon: [448, 512, [], "e139", "M171.3 64c-17.1 0-31 13.9-31 31v3.3c0 7.9 2 15.7 5.8 22.6L190 200.3c3.4 6.2 2.4 14-2.7 19.1s-12.8 6.1-19.1 2.7L88.9 178.1c-6.9-3.8-14.7-5.8-22.6-5.8H63c-17.1 0-31 13.9-31 31c0 8.2 3.3 16.1 9.1 21.9l19.5 19.5c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3L41.1 286.8c-5.8 5.8-9.1 13.7-9.1 21.9c0 17.1 13.9 31 31 31h3.3c7.9 0 15.7-2 22.6-5.8L168.3 290c6.2-3.4 14-2.4 19.1 2.7s6.1 12.8 2.7 19.1l-43.9 79.4c-3.8 6.9-5.8 14.7-5.8 22.6V417c0 17.1 13.9 31 31 31c8.2 0 16.1-3.3 21.9-9.1l19.5-19.5c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7l19.5 19.5c5.8 5.8 13.7 9.1 21.9 9.1c17.1 0 31-13.9 31-31v-3.3c0-7.9-2-15.7-5.8-22.6L258 311.7c-3.4-6.2-2.4-14 2.7-19.1s12.8-6.1 19.1-2.7l79.4 43.9c6.9 3.8 14.7 5.8 22.6 5.8H385c17.1 0 31-13.9 31-31c0-8.2-3.3-16.1-9.1-21.9l-19.5-19.5c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l19.5-19.5c5.8-5.8 9.1-13.7 9.1-21.9c0-17.1-13.9-31-31-31h-3.1c-8 0-15.8 2-22.8 5.9L281 222c-6.2 3.5-14 2.4-19-2.6s-6.2-12.7-2.9-19L302 120.9c3.7-6.9 5.7-14.6 5.7-22.4V95c0-17.1-13.9-31-31-31c-8.2 0-16.1 3.3-21.9 9.1L235.3 92.5c-3 3-7.1 4.7-11.3 4.7s-8.3-1.7-11.3-4.7L193.2 73.1c-5.8-5.8-13.7-9.1-21.9-9.1zm-63 31c0-34.8 28.2-63 63-63c16.7 0 32.7 6.6 44.5 18.5l8.2 8.2 8.2-8.2C244 38.6 260 32 276.7 32c34.8 0 63 28.2 63 63v3.5c0 13.1-3.3 26-9.5 37.6l-16.7 31 30-16.8c11.7-6.6 25-10 38.4-10H385c34.8 0 63 28.2 63 63c0 16.7-6.6 32.7-18.5 44.5l-8.2 8.2 8.2 8.2C441.4 276 448 292 448 308.7c0 34.8-28.2 63-63 63h-3.3c-13.3 0-26.5-3.4-38.1-9.8l-30.8-17 17 30.8c6.5 11.7 9.8 24.8 9.8 38.1V417c0 34.8-28.2 63-63 63c-16.7 0-32.7-6.6-44.5-18.5l-8.2-8.2-8.2 8.2C204 473.4 188 480 171.3 480c-34.8 0-63-28.2-63-63v-3.3c0-13.3 3.4-26.5 9.8-38.1l17-30.8-30.8 17c-11.7 6.5-24.8 9.8-38.1 9.8H63c-34.8 0-63-28.2-63-63C0 292 6.6 276 18.5 264.2l8.2-8.2-8.2-8.2C6.6 236 0 220 0 203.3c0-34.8 28.2-63 63-63h3.3c13.3 0 26.5 3.4 38.1 9.8l30.8 17-17-30.8c-6.5-11.7-9.8-24.8-9.8-38.1V95z"]
};
var faMeat = {
  prefix: 'fal',
  iconName: 'meat',
  icon: [512, 512, [127830], "f814", "M288.9 223.1c30 30 65.3 51.2 99.4 60.2c12.2 3.2 25.2 5 38 4.7l-17.3 17.3c-30 30-70.7 46.8-113.1 46.8H208c-26.5 0-48-21.5-48-48V216c0-42.4 16.9-83.1 46.9-113.1l17.2-17.2c-.3 12.8 1.5 25.8 4.7 38c9 34.1 30.2 69.4 60.2 99.4zm175.8 17.7c-31.2 31.2-99.7 13.1-153.2-40.3s-71.5-122-40.3-153.2c9.9-9.9 23.5-14.8 39.2-15.2c8.9 .2 18.1 1.6 27.1 3.9c28.9 7.6 59.6 25.9 86.1 52.3s44.7 57.2 52.3 86.1c2.3 8.9 3.7 17.9 3.9 26.8c-.4 15.9-5.3 29.6-15.3 39.6zM347.6 4.8c-12-3.2-24.8-5-37.4-4.7c-25.7-.3-52.7 6.9-74 28.2l-52 52c-36 36-56.2 84.8-56.2 135.8v72 16 2.7c0 4.2-1.7 8.3-4.7 11.3l-2 2-.1 0c-.1 0-.5 .1-1.2 .1c-1.5-.1-3.5-.7-5.2-2C102.9 309.3 88.1 304 72 304c-39.8 0-72 32.2-72 72c0 37.2 28.2 67.8 64.4 71.6C68.2 483.8 98.8 512 136 512c39.8 0 72-32.2 72-72c0-16.1-5.3-30.9-14.2-42.9c-1.2-1.7-1.9-3.7-2-5.2c0-.7 .1-1.1 .1-1.2l0-.1 2-2c3-3 7.1-4.7 11.3-4.7H208h16 72c50.9 0 99.7-20.2 135.7-56.2l52.1-52.1c21.4-21.4 28.6-48.6 28.1-74.5c.2-12.5-1.6-25-4.7-36.9c-9-34.1-30.2-69.4-60.2-99.4s-65.3-51.2-99.4-60.2zM165.9 372c-10.6 14.6-5.7 33.5 2.2 44.1c4.9 6.7 7.9 14.9 7.9 23.8c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.1-10.9-24-24-24c-22.1 0-40-17.9-40-40s17.9-40 40-40c9 0 17.2 2.9 23.8 7.9c10.7 7.9 29.5 12.8 44.1 2.2c6.5 10.5 15.4 19.4 25.9 25.9zm186-211.9c15.3 15.3 34.9 20.4 43.8 11.5s3.8-28.5-11.5-43.8s-34.9-20.4-43.8-11.5s-3.8 28.5 11.5 43.8z"]
};
var faReply = {
  prefix: 'fal',
  iconName: 'reply',
  icon: [512, 512, [61714, "mail-reply"], "f3e5", "M216 160c-13.3 0-24-10.7-24-24v-8V112 64L32 208 192 352l0-48V288v-8c0-13.3 10.7-24 24-24h8 96c70.7 0 128 57.3 128 128c0 8.3-.7 16.1-2 23.2c18.2-23.4 34-57.1 34-103.2c0-79.5-64.5-144-144-144H224h-8zm8 144v16 32c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2V96v16 16h32 80c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H256 224v16z"]
};
var faMailReply = faReply;
var faStarAndCrescent = {
  prefix: 'fal',
  iconName: 'star-and-crescent',
  icon: [512, 512, [9770], "f699", "M32 256c0 118.4 91.9 215.4 208.3 223.5C151.1 444.4 88 357.6 88 256S151.1 67.6 240.3 32.5C123.9 40.6 32 137.6 32 256zM349.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0c33 0 64.6 6.3 93.6 17.7zm16.6 138.5l.3-.5 3.4-6.9 5.5-11.2c3.5-7.1 13.7-7.1 17.2 0l5.5 11.2 3.4 6.9 .3 .5 22.2 45.1c1.4 2.8 4.1 4.8 7.2 5.3l49.7 7.2 .6 .1 7.7 1.1 12.4 1.8c7.9 1.1 11 10.8 5.3 16.4l-9 8.7-5.5 5.4-.4 .4-36 35.1c-2.3 2.2-3.3 5.4-2.8 8.5l8.5 49.5 .1 .6 1.3 7.6 2.1 12.3c1.3 7.8-6.9 13.8-13.9 10.1l-11.1-5.8-6.8-3.6-.5-.3-44.5-23.4c-2.8-1.5-6.1-1.5-8.9 0L335 361.7l-.5 .3-6.8 3.6-11.1 5.8c-7 3.7-15.3-2.3-13.9-10.1l2.1-12.3 1.3-7.6 .1-.6 8.5-49.5c.5-3.1-.5-6.3-2.8-8.5l-36-35.1-.4-.4-5.5-5.4-9-8.7c-5.7-5.6-2.6-15.2 5.3-16.4l12.4-1.8 7.7-1.1 .6-.1 49.7-7.2c3.1-.5 5.8-2.4 7.2-5.3l22.2-45.1zm6.5 59.2c-6.1 12.3-17.8 20.8-31.3 22.8l-25.5 3.7 18.4 18c9.8 9.6 14.3 23.3 12 36.8L341.9 322l22.8-12c12.1-6.4 26.6-6.4 38.7 0l22.8 12-4.4-25.4c-2.3-13.5 2.2-27.3 12-36.8l18.4-18-25.5-3.7c-13.5-2-25.3-10.5-31.3-22.8L384 192.3l-11.4 23.1z"]
};
var faEmptySet = {
  prefix: 'fal',
  iconName: 'empty-set',
  icon: [512, 512, [8709, 216], "f656", "M491.3 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-66 66C363.4 52.6 312.1 32 256 32C132.3 32 32 132.3 32 256c0 56.1 20.6 107.4 54.7 146.7l-66 66c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l66-66C148.6 459.4 199.9 480 256 480c123.7 0 224-100.3 224-224c0-56.1-20.6-107.4-54.7-146.7l66-66zM380 109.4L109.4 380C81.1 346.5 64 303.3 64 256C64 150 150 64 256 64c47.3 0 90.5 17.1 124 45.4zM132 402.6L402.6 132c28.3 33.5 45.4 76.7 45.4 124c0 106-86 192-192 192c-47.3 0-90.5-17.1-124-45.4z"]
};
var faHouseFire = {
  prefix: 'fal',
  iconName: 'house-fire',
  icon: [640, 512, [], "e50c", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H374.3c-14.2-9.5-27.1-20.9-38.3-33.8V480H240V320h51.6c2.4-10.6 5.9-21.4 10.3-32H240c-17.7 0-32 14.3-32 32V480H144c-26.5 0-48-21.5-48-48V206.7L288 37.3 408.4 143.6c1.4-1.2 2.7-2.5 4.1-3.7c7.7-6.9 17.2-10.8 26.9-11.7L298.6 4zM509.4 253.5c9.6-.1 18.7-4.5 24.7-12.1c3.9-4.9 7.8-9.6 11.6-14c16.4 17.8 30.9 39.4 41.8 60.5C601 314 608 339.4 608 352.2C608 422.4 551 480 480 480c-71.8 0-128-57.5-128-127.8c0-17.9 9.4-46.2 27.6-75.8c15.9-25.8 37.9-53.1 64-78.1c14.3 13.7 27.9 28.3 40.8 43.7c6.2 7.4 15.3 11.6 25 11.5zm-21.8-56.4c-10.9-11.6-22.2-22.8-34-33.4c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-1.8 1.6-3.5 3.3-5.2 5c-7.7 7.7-14.8 16.4-21.2 24.5c-7-8.4-14.1-16.5-21.5-24.4zM445.1 256c-4.8 0-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C389 324.3 384 338.3 384 354c0 28.7 10.7 52.6 28.8 69.2c18 16.5 42.3 24.8 68.2 24.8c21.3 0 40.3-6 57.9-17.7l0 0 .3-.2c37.3-26.1 46.3-77.2 25-116.5l0-.1c-1.9-3.9-4.5-9-8.3-14.1c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5c-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5C508.6 412 495.7 416 481 416c-19.1 0-35.3-6.1-46.6-16.4C423.3 389.4 416 374.3 416 354c0-8.3 2.5-16.8 9.1-28.1c4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.4 1.8 2.4 .5 .6 .1 .2 0 0 0 0 0 0L507 351l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"]
};
var faSquareMinus = {
  prefix: 'fal',
  iconName: 'square-minus',
  icon: [448, 512, [61767, "minus-square"], "f146", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 240H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMinusSquare = faSquareMinus;
var faHelicopter = {
  prefix: 'fal',
  iconName: 'helicopter',
  icon: [640, 512, [128641], "f533", "M160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H352v96H144L110.4 83.2C101.3 71.1 87.1 64 72 64H44.8c-21 0-36.3 19.9-30.9 40.2l22.7 85.1c3.7 14 13.6 25.6 26.9 31.5l124.6 55.4c1.8 .8 3.4 1.9 4.8 3.3l90.4 90.4c9 9 21.3 14.1 34 14.1h.5 .5 .5 .5 .5 .4 .4 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4c30.9 0 56-25.1 56-56V272c0-79.5-64.5-144-144-144H384V32H576c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zM72 96c5 0 9.8 2.4 12.8 6.4l38.4 51.2c3 4 7.8 6.4 12.8 6.4H352V352h-.1-.4-.4-.4-.4-.4-.4H349h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H341h-.4-.4-.4-.4-.4-.4H338h-.4-.4-.4-.4-.4-.4H335h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H328h-.4-.4-.4-.4-.4-.4-.4-.4H324h-.4-.4-.4-.4-.4-.4-.4-.5H320h-.4-.5-.5-.5-.5-.5c-4.3 0-8.3-1.7-11.3-4.7l-90.4-90.4c-4.2-4.2-9.1-7.5-14.4-9.9L76.5 191.6c-4.4-2-7.7-5.8-9-10.5L44.8 96H72zM384.4 352H384V160h48c61.9 0 112 50.1 112 112v56c0 13.2-10.8 24-24 24h-.4-.4-.4-.4-.4-.4H517h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H512h-.4-.4-.4-.4H510h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H505h-.4-.4-.4-.4H503h-.4-.4-.4-.4H501h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H489h-.4-.4-.4-.4H487h-.4-.4-.4-.4H485h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H478h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H473h-.4-.4-.4-.4H471h-.4-.4-.4-.4-.4-.4-.4H468h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H463h-.4-.4-.4-.4-.4-.4-.4H460h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H455h-.4-.4-.4-.4-.4-.4-.4H452h-.4-.4-.4-.4-.4-.4-.4H449h-.4-.4-.4-.4-.4-.4-.4H446h-.4-.4-.4-.4-.4-.4-.4H443h-.4-.4-.4-.4-.4-.4-.4H440h-.4-.4-.4-.4-.4-.4-.4H437h-.4-.4-.4-.4-.4-.4-.4H434h-.4-.4-.4-.4-.4-.4-.4H431h-.4-.4-.4-.4-.4-.4-.4H428h-.4-.4-.4-.4-.4-.4-.4H425h-.4-.4-.4-.4-.4-.4-.4H422h-.4-.4-.4-.4-.4-.4-.4H419h-.4-.4-.4-.4-.4-.4-.4H416h-.4-.4-.4-.4-.4-.4-.4H413h-.4-.4-.4-.4-.4-.4-.4H410h-.4-.4-.4-.4-.4-.4-.4H407h-.4-.4-.4-.4-.4-.4-.4H404h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H399h-.4-.4-.4-.4-.4-.4-.4H396h-.4-.4-.4-.4H394h-.4-.4-.4-.4-.4-.4-.4H391h-.4-.4-.4-.4H389h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4zM635.3 475.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-8.6 8.6c-12 12-28.3 18.7-45.3 18.7H240c-8.8 0-16 7.2-16 16s7.2 16 16 16H558.9c25.5 0 49.9-10.1 67.9-28.1l8.6-8.6z"]
};
var faBird = {
  prefix: 'fal',
  iconName: 'bird',
  icon: [512, 512, [], "e469", "M32 192H192c35.3 0 64-28.7 64-64V104c0-39.8 32.2-72 72-72s72 32.2 72 72v96c0 101.6-82.4 184-184 184S32 301.6 32 200v-8zM0 188.4V200C0 306.2 76.7 394.6 177.8 412.6l48.1 90.9c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6L215.8 416l.2 0c19.3 0 37.9-2.5 55.7-7.3l50.2 94.7c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6l-47.9-90.4C378.6 364.8 432 288.6 432 200V185.1l72.2-43.3c4.8-2.9 7.8-8.1 7.8-13.7s-2.9-10.8-7.8-13.7L425.2 66.8C410.2 27.8 372.3 0 328 0C270.6 0 224 46.6 224 104v24c0 17.7-14.3 32-32 32H28.4C12.7 160 0 172.7 0 188.4zM464.9 128L432 147.7V108.3L464.9 128zM328 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCompass = {
  prefix: 'fal',
  iconName: 'compass',
  icon: [512, 512, [129517], "f14e", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm92.6-389.1L202.1 171.8c-14.3 4.8-25.6 16-30.4 30.4L122.9 348.6c-8.3 25 15.5 48.8 40.5 40.5l146.5-48.8c14.3-4.8 25.6-16 30.4-30.4l48.8-146.5c8.3-25-15.5-48.8-40.5-40.5zm10.1 30.4L309.9 299.8c-1.6 4.8-5.3 8.5-10.1 10.1L153.3 358.7l48.8-146.5c1.6-4.8 5.3-8.5 10.1-10.1l146.5-48.8zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSquareCaretDown = {
  prefix: 'fal',
  iconName: 'square-caret-down',
  icon: [448, 512, ["caret-square-down"], "f150", "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm224-64c9.6 0 18.7-4 25.2-11l95.5-102.8c4.7-5.1 7.3-11.8 7.3-18.7c0-15.2-12.3-27.5-27.5-27.5h-201C108.3 192 96 204.3 96 219.5c0 6.9 2.6 13.6 7.3 18.7L198.8 341c6.5 7 15.6 11 25.2 11zm-1.7-32.7L133.8 224H314.2l-88.4 95.3c-.4 .5-1.1 .7-1.7 .7s-1.3-.3-1.7-.7z"]
};
var faCaretSquareDown = faSquareCaretDown;
var faHeartHalfStroke = {
  prefix: 'fal',
  iconName: 'heart-half-stroke',
  icon: [512, 512, ["heart-half-alt"], "e1ac", "M272 126.1l7.9-8.9 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8c53.3 9.7 92 56.1 92 110.3v3.5c0 32.3-13.4 63.1-37 85.1L272 434.7V126.1zM256.3 448c-.1 0-.2 0-.3 0s-.2 0-.3 0h.5zM240 434.7L69.1 275.5C45.4 253.5 32 222.7 32 190.4v-3.5c0-54.2 38.7-100.6 92-110.3c38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 7.9 8.9V434.7zM393.7 45.1c-40.9-7.4-82.6 3.2-114.7 28.4c-1.8 1.4-3.6 2.9-5.4 4.5c-4.7 4.1-9.1 8.4-13.3 13.1L256 95.9l-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6C201 48.4 159.3 37.7 118.3 45.1C49.8 57.6 0 117.3 0 186.9v3.5c0 36 13.1 70.6 36.6 97.5c3.4 3.8 6.9 7.5 10.7 11l184 171.3c6.7 6.3 15.6 9.7 24.8 9.7c8 0 15.8-2.7 22.1-7.5c.9-.7 1.8-1.4 2.6-2.2L464.8 299c3.8-3.5 7.3-7.2 10.7-11C498.9 261 512 226.4 512 190.4v-3.5c0-69.6-49.8-129.3-118.3-141.8z"]
};
var faHeartHalfAlt = faHeartHalfStroke;
var faFileCircleQuestion = {
  prefix: 'fal',
  iconName: 'file-circle-question',
  icon: [576, 512, [], "e4ef", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64-86.4c0-23 18.6-41.6 41.6-41.6h40.5c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6l-23.7 12.5c-1.4 7.4-7.9 12.9-15.7 12.9c-8.8 0-16-7.2-16-16v-6.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9H409.6c-5.3 0-9.6 4.3-9.6 9.6V336c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.4z"]
};
var faLaptopCode = {
  prefix: 'fal',
  iconName: 'laptop-code',
  icon: [640, 512, [], "f5fc", "M128 64H512c17.7 0 32 14.3 32 32V352h32V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V352H96V96c0-17.7 14.3-32 32-32zM33.9 416H606.1c-5.5 18.5-22.6 32-42.9 32H76.8c-20.3 0-37.4-13.5-42.9-32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2zM283.3 171.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L230.6 224l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 224l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"]
};
var faJoystick = {
  prefix: 'fal',
  iconName: 'joystick',
  icon: [448, 512, [128377], "f8c5", "M304 112a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm32 0c0 56.4-41.7 103.1-96 110.9V320H208V222.9c-54.3-7.8-96-54.4-96-110.9C112 50.1 162.1 0 224 0s112 50.1 112 112zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zM416 416c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V416zM64 352H384c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM208 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGrillFire = {
  prefix: 'fal',
  iconName: 'grill-fire',
  icon: [576, 512, [], "e5a4", "M408 64H40c-4.4 0-8 3.6-8 8V96c0 106 86 192 192 192c4.7 0 9.4-.2 14-.5c-4.4 10.8-8 21.7-10.5 32.5c-1.2 0-2.4 0-3.6 0c-19.9 0-39.2-2.6-57.6-7.5l-26.1 57.3c4.3 4.2 8.1 8.9 11.1 14.1H227c1.9 11 4.8 21.7 8.5 32H160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c5.7 0 11.1 .7 16.4 2.1l23.7-52C56 267.9 0 188.5 0 96V72C0 49.9 17.9 32 40 32H408c22.1 0 40 17.9 40 40V96c0 24.1-3.8 47.3-10.9 69.1c-8.5-8.6-17.2-17-26.2-25.1l0 0c3.3-14.1 5.1-28.8 5.1-44V72c0-4.4-3.6-8-8-8zM96 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM445.4 253.5c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1c-18.3 29.6-27.6 57.9-27.6 75.8C288 422.5 344.2 480 416 480c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zm-21.8-56.4c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C576 440 504.7 512 416 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zM381.1 256c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0C457.3 442 438.3 448 417 448c-25.9 0-50.2-8.4-68.2-24.8C330.7 406.6 320 382.7 320 354c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L443 351l-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.4-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6C381.7 409.9 397.9 416 417 416c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5z"]
};
var faRectangleVerticalHistory = {
  prefix: 'fal',
  iconName: 'rectangle-vertical-history',
  icon: [576, 512, [], "e237", "M256 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H256zM192 64c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64zM96 64c0-8.8 7.2-16 16-16s16 7.2 16 16V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V64zM0 112c0-8.8 7.2-16 16-16s16 7.2 16 16V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V112z"]
};
var faSwatchbook = {
  prefix: 'fal',
  iconName: 'swatchbook',
  icon: [512, 512, [], "f5c3", "M0 416c0 53 43 96 96 96H456c30.9 0 56-25.1 56-56V376c0-30.9-25.1-56-56-56H331.7L419 232.7c21.9-21.9 21.9-57.3 0-79.2L362.4 97c-21.9-21.9-57.3-21.9-79.2 0L192 188.2V56c0-30.9-25.1-56-56-56H56C25.1 0 0 25.1 0 56V416zm456 64H171.7l128-128H456c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24zM396.4 210.1L192 414.5v-181L305.9 119.6c9.4-9.4 24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9zM96 480c-35.3 0-64-28.7-64-64l0-128H160V416c0 35.3-28.7 64-64 64zM32 256V160H160v96H32zm0-128V56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24v72H32zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPrescriptionBottle = {
  prefix: 'fal',
  iconName: 'prescription-bottle',
  icon: [384, 512, [], "f485", "M336 32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H336zM48 0C21.5 0 0 21.5 0 48V80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM32 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160H320V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V320h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V224h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V160H32z"]
};
var faBars = {
  prefix: 'fal',
  iconName: 'bars',
  icon: [448, 512, ["navicon"], "f0c9", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16z"]
};
var faNavicon = faBars;
var faKeyboardLeft = {
  prefix: 'fal',
  iconName: 'keyboard-left',
  icon: [640, 512, [], "e1c3", "M576 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H576zM224 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H224zm8 88v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152c0-8.8-7.2-16-16-16H248c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H248zM232 344v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V344c0-8.8-7.2-16-16-16H248c-8.8 0-16 7.2-16 16zM344 136c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152c0-8.8-7.2-16-16-16H344zM328 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H344c-8.8 0-16 7.2-16 16zM440 136c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152c0-8.8-7.2-16-16-16H440zM424 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H440c-8.8 0-16 7.2-16 16zM536 136c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152c0-8.8-7.2-16-16-16H536zM520 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H536c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V344c0-8.8-7.2-16-16-16H536zM320 352c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zM107.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 256l68.7-68.7z"]
};
var faPeopleGroup = {
  prefix: 'fal',
  iconName: 'people-group',
  icon: [640, 512, [], "e533", "M128 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM0 280c0 43.3 26.4 80.4 64 96v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H96V208.4c2.6-.3 5.3-.4 8-.4h48c9.3 0 18.1 1.7 26.2 4.9c8.2 3.2 17.5-.9 20.7-9.1s-.9-17.5-9.1-20.7c-11.7-4.6-24.5-7.1-37.8-7.1H104C46.6 176 0 222.6 0 280zm64 59.9C44.7 327 32 304.9 32 280c0-25 12.7-47 32-59.9V339.9zM512 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM640 280c0-57.4-46.6-104-104-104H488c-13.3 0-26.1 2.5-37.8 7.1c-8.2 3.2-12.3 12.5-9.1 20.7s12.5 12.3 20.7 9.1c8.1-3.2 16.9-4.9 26.2-4.9h48c2.7 0 5.4 .1 8 .4V416H480V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V376c37.6-15.7 64-52.7 64-96zm-64 59.9V220.1C595.3 233 608 255 608 280c0 24.9-12.7 47-32 59.9zM288 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 256 96a64 64 0 1 0 128 0zm-80 96c-57.4 0-104 46.6-104 104c0 40.1 22.7 74.9 56 92.3V456c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V388.3c33.3-17.3 56-52.1 56-92.3c0-57.4-46.6-104-104-104H304zm-48 50.3V349.7c-14.7-13.2-24-32.4-24-53.7c0-21.3 9.3-40.5 24-53.7zM288 448V225.8c5.1-1.2 10.5-1.8 16-1.8h32c5.5 0 10.9 .6 16 1.8V448H288zm96-98.3V242.3c14.7 13.2 24 32.3 24 53.7c0 21.3-9.3 40.5-24 53.7z"]
};
var faHourglassEnd = {
  prefix: 'fal',
  iconName: 'hourglass-end',
  icon: [384, 512, [8987, "hourglass-3"], "f253", "M0 16C0 7.2 7.2 0 16 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H352V76.7c0 31.6-10.4 62.4-29.6 87.5L252.1 256l70.2 91.9C341.6 373 352 403.7 352 435.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V435.3c0-31.6 10.4-62.4 29.6-87.5L131.9 256 61.6 164.1C42.4 139 32 108.3 32 76.7L32 32H16C7.2 32 0 24.8 0 16zM64 32l0 44.7c0 24.6 8.1 48.5 23 68l77.7 101.6c4.4 5.7 4.4 13.7 0 19.4L87 367.3c-14.9 19.5-23 43.4-23 68L64 480H320V435.3c0-24.6-8.1-48.5-23-68L219.3 265.7c-4.4-5.7-4.4-13.7 0-19.4L297 144.7c14.9-19.5 23-43.4 23-68V32H64zM205 310.7l80 112c3.5 4.9 3.9 11.3 1.2 16.6s-8.2 8.7-14.2 8.7H192 112c-6 0-11.5-3.4-14.2-8.7S95.5 427.6 99 422.7l80-112c3-4.2 7.9-6.7 13-6.7s10 2.5 13 6.7zM192 416h48.9L192 347.5 143.1 416H192z"]
};
var faHourglass3 = faHourglassEnd;
var faHeartCrack = {
  prefix: 'fal',
  iconName: 'heart-crack',
  icon: [512, 512, [128148, "heart-broken"], "f7a9", "M272 126.1l7.9-8.9 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8c53.3 9.7 92 56.1 92 110.3v3.5c0 32.3-13.4 63.1-37 85.1L259 446.8c-.8 .7-1.9 1.2-3 1.2s-2.2-.4-3-1.2L69.1 275.5C45.4 253.5 32 222.7 32 190.4v-3.5c0-54.2 38.7-100.6 92-110.3c38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 7.9 8.9V144c0 4.2 1.7 8.3 4.7 11.3l34.2 34.2-79.8 53.2c-3.7 2.5-6.2 6.4-6.9 10.9s.5 8.9 3.3 12.4l64 80c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-53.1-66.4 81.5-54.3c4-2.7 6.6-7 7-11.7s-1.2-9.5-4.6-12.9L272 137.4V126.1zM393.7 45.1c-40.9-7.4-82.6 3.2-114.7 28.4c-1.8 1.4-3.6 2.9-5.4 4.5c-4.7 4.1-9.1 8.4-13.3 13.1L256 95.9l-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6C201 48.4 159.3 37.7 118.3 45.1C49.8 57.6 0 117.3 0 186.9v3.5c0 36 13.1 70.6 36.6 97.5c3.4 3.8 6.9 7.5 10.7 11l184 171.3c6.7 6.3 15.6 9.7 24.8 9.7c8 0 15.8-2.7 22.1-7.5c.9-.7 1.8-1.4 2.6-2.2L464.8 299c3.8-3.5 7.3-7.2 10.7-11C498.9 261 512 226.4 512 190.4v-3.5c0-69.6-49.8-129.3-118.3-141.8z"]
};
var faHeartBroken = faHeartCrack;
var faFaceBeamHandOverMouth = {
  prefix: 'fal',
  iconName: 'face-beam-hand-over-mouth',
  icon: [512, 512, [129325], "e47c", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm111.5-76.1c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 121.9 194.8 112 176 112s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zm172.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 121.9 354.8 112 336 112s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zM265.3 301.3L248 318.6l0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3l0 0-16 16-34 34L280 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5l0 0-5.1 5.1-26.9 26.9-2 2L312 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2V352 298.4c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3v11.7 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 0 0 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6l0 0-34 34zm-11.3-79.2L207 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V352v32.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0z"]
};
var faDropletPercent = {
  prefix: 'fal',
  iconName: 'droplet-percent',
  icon: [384, 512, ["humidity"], "f750", "M192 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c11.9-27.6 28.5-57.5 46.6-86.8c35.9-58 76.4-110.9 94.5-133.7h1.3c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8C345.9 280.8 352 303.8 352 320c0 88.4-71.6 160-160 160zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm267.3-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM160 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHumidity = faDropletPercent;
var faSquareUpRight = {
  prefix: 'fal',
  iconName: 'square-up-right',
  icon: [448, 512, [8599, "external-link-square-alt"], "f360", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM304 184V297.4c0 3.7-3 6.6-6.6 6.6c-1.8 0-3.4-.7-4.7-1.9l-25.4-25.4c-6.2-6.2-16.4-6.2-22.6 0l-59.1 59.1c-3.6 3.6-9 4.9-13.9 3.3c-2-.7-3.8-1.8-5.3-3.3l-22.1-22.1c-1.5-1.5-2.6-3.3-3.3-5.3c-1.6-4.9-.4-10.3 3.3-13.9l59.1-59.1c6.2-6.2 6.2-16.4 0-22.6l-25.4-25.4c-1.2-1.2-1.9-2.9-1.9-4.7c0-3.7 3-6.6 6.6-6.6H296c4.4 0 8 3.6 8 8zm-8-40H182.6c-21.3 0-38.6 17.3-38.6 38.6c0 10.2 4.1 20.1 11.3 27.3L169.4 224l-47.7 47.7c-12.2 12.2-16.5 30.3-11 46.7c2.2 6.7 6 12.8 11 17.8l22.1 22.1c5 5 11.1 8.8 17.8 11c16.4 5.5 34.5 1.2 46.7-11L256 310.6l14.1 14.1c7.2 7.2 17.1 11.3 27.3 11.3c21.3 0 38.6-17.3 38.6-38.6V184c0-22.1-17.9-40-40-40z"]
};
var faExternalLinkSquareAlt = faSquareUpRight;
var faFaceKissBeam = {
  prefix: 'fal',
  iconName: 'face-kiss-beam',
  icon: [512, 512, [128537, "kiss-beam"], "f597", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm277.4 47.1c-11-5.4-25.7-9.3-39.1-11.2c-6.6-.9-11.1-7-10.2-13.6s7-11.1 13.6-10.2c15.1 2.1 32.4 6.6 46.3 13.4c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-1.1 .5-2.1 1-3.3 1.5c1.1 .5 2.2 1 3.3 1.5c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-13.9 6.8-31.2 11.3-46.3 13.4c-6.6 .9-12.6-3.6-13.6-10.2s3.6-12.6 10.2-13.6c13.4-1.9 28.1-5.8 39.1-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8c-10.9-5.4-25.5-9.3-38.8-11.2c-.9-.1-1.8-.3-2.7-.6c-1.7-.6-3.2-1.6-4.4-2.8s-2.2-2.7-2.8-4.4c-.5-1.3-.7-2.6-.7-4.1s.2-2.8 .7-4.1c.6-1.7 1.6-3.2 2.8-4.4s2.7-2.2 4.4-2.8c.9-.3 1.7-.5 2.7-.6c13.3-1.9 27.9-5.8 38.8-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8zM156.5 194.5c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 161.9 157.2 152 176 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 161.9 317.2 152 336 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"]
};
var faKissBeam = faFaceKissBeam;
var faCorn = {
  prefix: 'fal',
  iconName: 'corn',
  icon: [512, 512, [127805], "f6c7", "M448 0c-14.6 0-28.1 4.9-38.8 13.1C401.4 9.8 392.9 8 384 8c-20.3 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-20.3 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-21.9 0-41.2 11-52.7 27.7c7.7 10.3 14.7 21 21 32c0-.2 .1-.4 .1-.6C242.7 99.8 256 88 272 88c3.1 0 6.1 .4 8.9 1.3c7.3 2.1 15.1-1.2 18.6-8C304.9 71 315.7 64 328 64c3.1 0 6.1 .4 8.9 1.3c7.3 2.1 15.1-1.2 18.6-8C360.9 47 371.7 40 384 40c6.9 0 13.2 2.1 18.4 5.8c6.7 4.7 16 3.6 21.3-2.7C429.6 36.3 438.3 32 448 32c17.7 0 32 14.3 32 32c0 9.7-4.3 18.4-11.2 24.3c-6.2 5.4-7.4 14.6-2.6 21.3c3.7 5.2 5.8 11.5 5.8 18.4c0 12.3-7 23.1-17.3 28.4c-6.8 3.5-10.1 11.3-8 18.6c.8 2.8 1.3 5.8 1.3 8.9c0 12.3-7 23.1-17.3 28.4c-6.8 3.5-10.1 11.3-8 18.6c.8 2.8 1.3 5.8 1.3 8.9c0 10.9-5.4 20.5-13.7 26.3c8.7 6.3 17.1 13.4 24.9 21C448 275.6 456 258.7 456 240c0-2-.1-3.9-.3-5.8C470.5 222.5 480 204.3 480 184c0-2-.1-3.9-.3-5.8C494.5 166.5 504 148.3 504 128c0-8.9-1.8-17.4-5.1-25.2C507.1 92.1 512 78.6 512 64c0-35.3-28.7-64-64-64zM163.3 68.7c-3.9-3.9-9.6-5.5-15-4.3s-9.7 5.3-11.5 10.5l-22 65.9c-.7 2-1.7 3.9-3.1 5.5l-76.1 87C12.7 259.5 0 293.2 0 328.1V342c0 36.2 13.6 71.1 38.2 97.7l24 26C89.5 495.2 127.9 512 168 512H179c38.2 0 74.8-15.2 101.8-42.2l69.5-69.5c1.7-1.7 3.6-2.9 5.8-3.7L437.5 367c5.1-1.9 9-6.2 10.2-11.6s-.4-10.9-4.3-14.8l-29.1-29.1C378.6 276 330.3 256 280 256c-10.8 0-21.6 .9-32.1 2.7c-1.9-69.5-30.3-135.7-79.6-185l-5-5zM216 266v1.1c-26.2 9.4-50.2 24.5-70.2 44.5l-94 94C39 387 32 364.8 32 342V328.1c0-27.1 9.8-53.3 27.7-73.8l76.1-87c4.2-4.8 7.4-10.4 9.4-16.4l13.5-40.5C195.6 153.7 216 208.8 216 266zM85.7 444l-13-14.1 95.7-95.7C198 304.6 238.1 288 280 288s82 16.6 111.6 46.2l11.3 11.3-57.7 21c-6.6 2.4-12.6 6.2-17.5 11.2l-69.5 69.5c-21 21-49.5 32.8-79.2 32.8H168c-31.3 0-61.1-13.1-82.3-36z"]
};
var faRollerCoaster = {
  prefix: 'fal',
  iconName: 'roller-coaster',
  icon: [640, 512, [], "e324", "M144 64c-5.4 0-10.8 .4-16 1.1V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V74.8C58.2 92.8 32 131.3 32 176V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V176C0 96.5 64.5 32 144 32h6.6c46.2 0 89.7 22.2 116.7 59.7L392.7 265.4c24.8 34.3 64.5 54.6 106.8 54.6H512c53 0 96-43 96-96v-5c0-40.9-26.9-75.4-64-86.9V272c-6.7 5-15 8-24 8h-8V128.1c-22.5 .8-44.4 6.8-64 17.5V263.2c-9.2-6.3-17.3-14.2-23.9-23.4L416 228.5V169l-21.4 19L373.4 164l26.4-23.5C432.1 111.9 473.8 96 517 96c67.9 0 123 55.1 123 123v5V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V308.7c-23.5 26.6-57.8 43.3-96 43.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V350.8c-22.8-2.7-44.6-10.2-64-21.7V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304.3c-6.2-6.2-12-12.9-17.2-20.2L320 219.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V175l-46.7-64.6c-5.1-7-10.9-13.4-17.3-19V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V72c-13-5.2-27.1-8-41.4-8H144z"]
};
var faPhotoFilmMusic = {
  prefix: 'fal',
  iconName: 'photo-film-music',
  icon: [640, 512, [], "e228", "M544 32H224c-17.7 0-32 14.3-32 32V233.4L265.4 160c12.5-12.5 32.8-12.5 45.3 0L352 201.4 457.4 96c12.5-12.5 32.8-12.5 45.3 0l53.8 53.8-33.9 11.3L480 118.6 363.3 235.3 278.6 320H384v32H240h0H224c-35.3 0-64-28.7-64-64V272v0V64c0-35.3 28.7-64 64-64H544c35.3 0 64 28.7 64 64v72c-6.7 0-13.5 1.1-20.2 3.3L576 143.2V64c0-17.7-14.3-32-32-32zM233.4 320l96-96L288 182.6l-96 96V288c0 17.7 14.3 32 32 32h9.4zM232 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM112 96h16v32 80V336v48 32H308.6c-8.3 8.8-15 19.6-18.3 32H128 112 96 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H96h16zM32 192H96V128H64c-17.7 0-32 14.3-32 32v32zm0 160v32c0 17.7 14.3 32 32 32H96V352H32zm64-32V224H32v96H96zM640 198.2V248 392c0 1.1-.1 2.2-.3 3.2c.2 1.6 .3 3.2 .3 4.8c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V270.2L448 323.5V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V312 251.5c0-13.8 8.8-26 21.9-30.4l160-53.3c20.7-6.9 42.1 8.5 42.1 30.4zm-32 38.3V198.2L448 251.5v38.3l160-53.3zm-5.9 171.9c5.5-4.1 5.9-7.4 5.9-8.3s-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7zm-192 64c5.5-4.1 5.9-7.4 5.9-8.3s-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7z"]
};
var faRadar = {
  prefix: 'fal',
  iconName: 'radar',
  icon: [512, 512, [], "e024", "M32 256C32 132.3 132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7l-34.1 34.1C338.1 95.3 298.8 80 256 80c-72.2 0-134.2 43.5-161.3 105.6c-3.5 8.1 .2 17.5 8.3 21.1s17.5-.2 21.1-8.3c22.2-50.9 73-86.4 132-86.4c34 0 65.2 11.8 89.9 31.5l-34.3 34.3C295.9 166.6 276.7 160 256 160c-53 0-96 43-96 96s43 96 96 96s96-43 96-96c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c11.9 0 23 3.2 32.5 8.9l-43.8 43.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l224-224c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L425.4 64C380.2 24.2 320.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7-100.3 224-224 224S32 379.7 32 256zm384-16c-8.8 0-16 7.2-16 16c0 59-35.5 109.8-86.4 132c-8.1 3.5-11.8 13-8.3 21.1s13 11.8 21.1 8.3C388.5 390.2 432 328.2 432 256c0-8.8-7.2-16-16-16zM102.9 305.3c-8.1 3.5-11.8 13-8.3 21.1c17.7 40.6 50.3 73.2 90.9 90.9c8.1 3.5 17.5-.2 21.1-8.3s-.2-17.5-8.3-21.1c-33.2-14.5-59.9-41.2-74.4-74.4c-3.5-8.1-13-11.8-21.1-8.3zM120 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSickle = {
  prefix: 'fal',
  iconName: 'sickle',
  icon: [512, 512, [], "f822", "M320 0C214 0 128 86 128 192c0 71 38.5 132.9 95.7 166.1c6.3 3.6 14.2 2.6 19.4-2.5l36-36c5.3-5.3 6.2-13.5 2.2-19.9C270.3 282.5 264 262 264 240c0-61.9 50.1-112 112-112c48.1 0 89.1 30.3 105 72.9c2.7 7.2 10.1 11.5 17.7 10.2s13.2-7.8 13.3-15.5c0-1.2 0-2.4 0-3.6C512 86 426 0 320 0zM160 192c0-88.4 71.6-160 160-160c65.7 0 122.1 39.6 146.8 96.2C442 108.1 410.4 96 376 96c-79.5 0-144 64.5-144 144c0 23.6 5.7 45.9 15.8 65.6l-18.3 18.3C187.5 295.1 160 246.7 160 192zM115.3 300.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l4.7 4.7L13.2 412.2C4.7 420.6 0 432.1 0 444s4.7 23.4 13.2 31.8l23 23C44.6 507.3 56.1 512 68 512s23.4-4.7 31.8-13.2L184 414.6l4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16-64-64-16-16zM35.8 434.8L120 350.6 161.4 392 77.2 476.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8l-23-23c-2.4-2.4-3.8-5.7-3.8-9.2s1.4-6.7 3.8-9.2z"]
};
var faFilm = {
  prefix: 'fal',
  iconName: 'film',
  icon: [512, 512, [127902], "f008", "M128 448V352 272H384v80 96H128zM384 240H128V160 64H384v96 80zM96 448H64c-17.7 0-32-14.3-32-32V368H96v80zM32 272H96v64H32V272zm64-96v64H32V176H96zM96 64v80H32V96c0-17.7 14.3-32 32-32H96zM416 336V272h64v64H416zm0 112V368h64v48c0 17.7-14.3 32-32 32H416zm0-272h64v64H416V176zm64-80v48H416V64h32c17.7 0 32 14.3 32 32zM448 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z"]
};
var faCoconut = {
  prefix: 'fal',
  iconName: 'coconut',
  icon: [512, 512, [], "e2f6", "M272.5 40c45.4-14 79.7-8.9 98.6 9.9s23.9 53.2 9.9 98.6C367.2 193 336 244 290 290s-97 77.2-141.6 91c-45.4 14-79.7 8.9-98.6-9.9S26 317.9 40 272.5c13.8-44.6 45-95.6 91-141.6s97-77.2 141.6-91zM393.7 27.2C362.4-4.1 312.8-5.9 263.1 9.4c-50.5 15.6-105.8 50-154.8 98.9S25 212.6 9.4 263.1C-5.9 312.8-4.1 362.4 27.2 393.7l42.4 42.4C118.2 484.7 184.1 512 252.9 512C396 512 512 396 512 252.9c0-68.7-27.3-134.6-75.9-183.2L393.7 27.2zM421 100.1c37.9 41.7 59 96.1 59 152.8c0 4.1-.1 8.2-.3 12.2l-20.4-20.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l37.4 37.4c-8.5 36.5-25.9 69.7-49.7 97.1l-45.1-45.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l45.1 45.1c-27.4 23.8-60.5 41.1-97.1 49.7l-37.4-37.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265 479.7c-4 .2-8.1 .3-12.2 .3c-56.6 0-111-21.1-152.8-59c18.5 .1 38.1-3.3 57.8-9.4c50.5-15.6 105.8-50 154.8-98.9s83.4-104.3 98.9-154.8c6.1-19.7 9.4-39.3 9.4-57.8zm-102.7 3.2c3.5 3.5 9.6 17-1.7 48.8c-10.4 29.4-32.9 64.9-66.2 98.2s-68.9 55.9-98.2 66.2c-31.8 11.2-45.4 5.1-48.8 1.7s-9.6-17 1.7-48.8c10.4-29.4 32.9-64.9 66.2-98.2s68.9-55.9 98.2-66.2c31.8-11.2 45.4-5.1 48.8-1.7zm22.6-22.6c-34.4-34.4-120.5-4-192.3 67.9s-102.2 158-67.9 192.3s120.5 4 192.3-67.9s102.2-158 67.9-192.3z"]
};
var faRulerHorizontal = {
  prefix: 'fal',
  iconName: 'ruler-horizontal',
  icon: [640, 512, [], "f547", "M32 320c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32l-48 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H432v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H336v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160l-48 0c-17.7 0-32 14.3-32 32l0 128zm32 64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64L64 384z"]
};
var faShieldCross = {
  prefix: 'fal',
  iconName: 'shield-cross',
  icon: [512, 512, [9960], "f712", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H240V400c0 8.8 7.2 16 16 16s16-7.2 16-16V208H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112z"]
};
var faCassetteTape = {
  prefix: 'fal',
  iconName: 'cassette-tape',
  icon: [576, 512, [128429], "f8ab", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H478.1l-23.4-64.4c-6.9-19-24.9-31.6-45.1-31.6H166.4c-20.2 0-38.2 12.6-45.1 31.6L97.9 448H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM444.1 448H131.9l19.4-53.5c2.3-6.3 8.3-10.5 15-10.5H409.6c6.7 0 12.7 4.2 15 10.5L444.1 448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32s-3.1-22.6-8.6-32H360.6c-5.4 9.4-8.6 20.3-8.6 32s3.1 22.6 8.6 32H215.4zM160 288H416c35.3 0 64-28.7 64-64s-28.7-64-64-64H160c-35.3 0-64 28.7-64 64s28.7 64 64 64zm256-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSquareTerminal = {
  prefix: 'fal',
  iconName: 'square-terminal',
  icon: [448, 512, [], "e32a", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM83.9 149.6c-5.8 6.7-5 16.8 1.7 22.6L183.4 256 85.6 339.9c-6.7 5.8-7.5 15.8-1.7 22.6s15.9 7.5 22.6 1.7l112-96c3.5-3 5.6-7.5 5.6-12.1s-2-9.1-5.6-12.1l-112-96c-6.7-5.8-16.8-5-22.6 1.7zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]
};
var faPeopleRobbery = {
  prefix: 'fal',
  iconName: 'people-robbery',
  icon: [576, 512, [], "e536", "M400 144c54.3 0 101.9-36.2 116.4-88.5l12.2-43.8c2.4-8.5 11.2-13.5 19.7-11.1s13.5 11.2 11.1 19.7L547.3 64.1c-12.3 44.3-43.4 79.5-83.2 97.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H368V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V162c-39.8-18.4-70.9-53.6-83.3-97.9L240.6 20.3c-2.4-8.5 2.6-17.3 11.1-19.7s17.3 2.6 19.7 11.1l12.2 43.8C298.1 107.8 345.7 144 400 144zm32 28.6c-10.4 2.2-21.1 3.4-32 3.4s-21.6-1.2-32-3.4V320h64V172.6zM85.3 144c21.8 0 42.4 10.3 55.5 27.7L192 240h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184c-5 0-9.8-2.4-12.8-6.4l-56-74.7c-7.1-9.4-18.1-14.9-29.9-14.9C64.7 176 48 192.7 48 213.3L48 320h64V280c0-8.8 7.2-16 16-16s16 7.2 16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H48l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-282.7C16 175 47 144 85.3 144zM80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM424 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 344 56z"]
};
var faLightbulb = {
  prefix: 'fal',
  iconName: 'lightbulb',
  icon: [384, 512, [128161], "f0eb", "M310.3 258.1C326.5 234.8 336 206.6 336 176c0-79.5-64.5-144-144-144S48 96.5 48 176c0 30.6 9.5 58.8 25.7 82.1c4.1 5.9 8.8 12.3 13.6 19l0 0c12.7 17.5 27.1 37.2 38 57.1c8.9 16.2 13.7 33.3 16.2 49.9H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H242.5c2.5-16.6 7.3-33.7 16.2-49.9c10.9-20 25.3-39.7 38-57.1c4.9-6.7 9.5-13 13.6-19zM192 96c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16zM146.7 448c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32H146.7zM112 432v-5.3c0-5.9 4.8-10.7 10.7-10.7H261.3c5.9 0 10.7 4.8 10.7 10.7V432c0 44.2-35.8 80-80 80s-80-35.8-80-80z"]
};
var faCaretLeft = {
  prefix: 'fal',
  iconName: 'caret-left',
  icon: [256, 512, [], "f0d9", "M34.2 261.6c-1.3-1.4-2.2-3.5-2.2-5.6s.8-4.2 2.2-5.6L147.7 130.2c1.3-1.4 3.2-2.2 5.2-2.2c3.9 0 7.1 3.2 7.1 7.1l0 241.7c0 3.9-3.2 7.1-7.1 7.1c-2 0-3.8-.8-5.2-2.2L34.2 261.6zm-23.3 22L124.4 403.7c7.4 7.8 17.7 12.3 28.4 12.3c21.6 0 39.1-17.5 39.1-39.1l0-241.7c0-21.6-17.5-39.1-39.1-39.1c-10.8 0-21.1 4.4-28.5 12.3L10.9 228.4C3.9 235.9 0 245.8 0 256s3.9 20.1 10.9 27.6z"]
};
var faCommentMiddle = {
  prefix: 'fal',
  iconName: 'comment-middle',
  icon: [512, 512, [], "e149", "M216.9 394.3L256 472.4l39.1-78.1c4.3-8.6 12.3-14.8 21.7-16.9C415.4 355.5 480 284.4 480 208c0-91.3-93.8-176-224-176S32 116.7 32 208c0 76.4 64.6 147.5 163.3 169.4c9.4 2.1 17.4 8.3 21.7 16.9zm44.5 89s0 0 0 0l-5.5 2.7 5.5-2.7 0 0zm62.2-74.7l-44.5 89c-4.4 8.8-13.3 14.3-23.2 14.3s-18.8-5.5-23.2-14.3l-44.5-89C79.8 384.5 0 303.8 0 208C0 93.1 114.6 0 256 0S512 93.1 512 208c0 95.8-79.8 176.5-188.3 200.7z"]
};
var faTrashCanList = {
  prefix: 'fal',
  iconName: 'trash-can-list',
  icon: [640, 512, [], "e2ab", "M169.7 32h76.5c5.5 0 10.6 2.8 13.6 7.5L275.1 64H140.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM312.9 64L287 22.6C278.2 8.5 262.8 0 246.3 0H169.7C153.2 0 137.8 8.5 129 22.6L103.1 64H64 32 16C7.2 64 0 71.2 0 80s7.2 16 16 16H32V432c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H384 352 312.9zM352 96V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V96H352zM160 160c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm208-32c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H464zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H464zM448 400c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16z"]
};
var faBlock = {
  prefix: 'fal',
  iconName: 'block',
  icon: [448, 512, [], "e46a", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleExclamation = {
  prefix: 'fal',
  iconName: 'circle-exclamation',
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faExclamationCircle = faCircleExclamation;
var faSchoolCircleXmark = {
  prefix: 'fal',
  iconName: 'school-circle-xmark',
  icon: [640, 512, [], "e56d", "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64V266.8c-9.1-12.9-19.9-24.5-32-34.6V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-2.9 10.2-4.8 20.8-5.8 31.7l-.7 0c-17.7 0-32 14.3-32 32v96h32 32 8.2c10 12.1 21.7 22.9 34.6 32H384 352 288 256 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H171.2l140-93.3zM416 192c0 7-.7 13.8-2.2 20.3c-31.3 16.5-57 42.2-73.5 73.5c-6.5 1.4-13.3 2.2-20.3 2.2c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zM128 160h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm0 32v64h32V192H128zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V352zm64 0H128v64h32V352zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
var faArrowRightFromBracket = {
  prefix: 'fal',
  iconName: 'arrow-right-from-bracket',
  icon: [512, 512, ["sign-out"], "f08b", "M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 176 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l281.4 0L356.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 32C35.8 32 0 67.8 0 112L0 400c0 44.2 35.8 80 80 80l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l96 0z"]
};
var faSignOut = faArrowRightFromBracket;
var faFaceFrownSlight = {
  prefix: 'fal',
  iconName: 'face-frown-slight',
  icon: [512, 512, [], "e376", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM347.9 394.5C330 373.8 299.4 352 256 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCircleChevronDown = {
  prefix: 'fal',
  iconName: 'circle-chevron-down',
  icon: [512, 512, ["chevron-circle-down"], "f13a", "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM132.7 235.3l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 313.4 155.3 212.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"]
};
var faChevronCircleDown = faCircleChevronDown;
var faSidebarFlip = {
  prefix: 'fal',
  iconName: 'sidebar-flip',
  icon: [512, 512, [], "e24f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H288V64H64zm384 0H320V448H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm0-32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448zM432 96c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zm16 80c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16zm-16 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h64z"]
};
var faUnlockKeyhole = {
  prefix: 'fal',
  iconName: 'unlock-keyhole',
  icon: [448, 512, ["unlock-alt"], "f13e", "M224 32c-53 0-96 43-96 96v64H368c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80H96V128C96 57.3 153.3 0 224 0c58 0 107 38.6 122.7 91.4c2.5 8.5-2.3 17.4-10.8 19.9s-17.4-2.3-19.9-10.8C304.2 60.9 267.5 32 224 32zM80 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80zM264 368H184c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faUnlockAlt = faUnlockKeyhole;
var faTemperatureList = {
  prefix: 'fal',
  iconName: 'temperature-list',
  icon: [512, 512, [], "e299", "M80 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112S32 429.9 32 368c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM144 0C91 0 48 43 48 96V252.7c0 4.6-2.2 9.8-6.8 14.5C15.7 293.1 0 328.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM112 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM320 48c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm32 128c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H368c-8.8 0-16 7.2-16 16z"]
};
var faCloudShowersHeavy = {
  prefix: 'fal',
  iconName: 'cloud-showers-heavy',
  icon: [512, 512, [], "f740", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM94.3 375.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm120 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm112 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm120 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128z"]
};
var faHeadphonesSimple = {
  prefix: 'fal',
  iconName: 'headphones-simple',
  icon: [512, 512, ["headphones-alt"], "f58f", "M32 288C32 164.3 132.3 64 256 64s224 100.3 224 224V400c0 8.8 7.2 16 16 16s16-7.2 16-16V288C512 146.6 397.4 32 256 32S0 146.6 0 288V400c0 8.8 7.2 16 16 16s16-7.2 16-16V288zm128 0V448H144c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48h16zm-16-32c-44.2 0-80 35.8-80 80v64c0 44.2 35.8 80 80 80h16c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H144zm208 32h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H352V288zm16-32H352c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32h16c44.2 0 80-35.8 80-80V336c0-44.2-35.8-80-80-80z"]
};
var faHeadphonesAlt = faHeadphonesSimple;
var faSitemap = {
  prefix: 'fal',
  iconName: 'sitemap',
  icon: [576, 512, [], "f0e8", "M320 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304 272 256c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h64zM256 192h16v48H112c-26.5 0-48 21.5-48 48v32H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H96V288c0-8.8 7.2-16 16-16H272v48H256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H304V272H464c8.8 0 16 7.2 16 16v32H464c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288c0-26.5-21.5-48-48-48H304V192h16c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48zM48 352h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm208 0h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm208 0h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16z"]
};
var faPipeSection = {
  prefix: 'fal',
  iconName: 'pipe-section',
  icon: [640, 512, [], "e438", "M32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v32V368v32c0 8.8 7.2 16 16 16s16-7.2 16-16V384H608v16c0 8.8 7.2 16 16 16s16-7.2 16-16V368 144 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H256 32V112zM608 352H32V160H256 608V352z"]
};
var faSpaceStationMoonConstruction = {
  prefix: 'fal',
  iconName: 'space-station-moon-construction',
  icon: [512, 512, ["space-station-moon-alt"], "e034", "M32 256C32 132.3 132.3 32 256 32c61 0 116.3 24.4 156.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c6.1 0 11.6-3.4 14.3-8.9s2.1-11.9-1.5-16.8C414.1 40.2 339.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c91.2 0 171.3-47.7 216.6-119.5c3.1-4.9 3.3-11.2 .5-16.3s-8.2-8.3-14-8.3H416c-8.8 0-16 7.2-16 16s7.2 16 16 16h11.6c-41.1 48.9-102.7 80-171.6 80c-95.1 0-176.3-59.2-208.8-142.8c39.2 13.6 104 32.3 208.8 32.3c119.5 0 187-24.3 223.8-37.6c5-1.8 9.4-3.4 13.3-4.7c1.7-.6 3.2-1.4 4.6-2.4l1.7-1.3c3-2.3 5.1-5.5 5.9-9.1c4.4-18.7 6.7-38.3 6.7-58.3c0-5.7-.2-11.4-.6-17.1c-.6-8.4-7.5-14.9-16-14.9H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c0 14.8-1.4 29.3-4.2 43.3c-2.1 .7-4.2 1.5-6.5 2.3C433 314.7 369.9 337.4 256 337.4s-177-22.7-213.3-35.8c-2.3-.8-4.4-1.6-6.5-2.3c-2.7-14-4.2-28.5-4.2-43.3zm104-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-64 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H368z"]
};
var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
var faCircleDollarToSlot = {
  prefix: 'fal',
  iconName: 'circle-dollar-to-slot',
  icon: [512, 512, ["donate"], "f4b9", "M256 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384A208 208 0 1 0 256 0a208 208 0 1 0 0 416zM64 352H56c-30.9 0-56 25.1-56 56v48c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V408c0-30.9-25.1-56-56-56h-8c-8.6 11.5-18.3 22.2-28.8 32H456c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V408c0-13.3 10.7-24 24-24H92.8c-10.5-9.8-20.2-20.5-28.8-32zM272 104c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V312c0 8.8 7.2 16 16 16s16-7.2 16-16V294.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V104z"]
};
var faDonate = faCircleDollarToSlot;
var faMemory = {
  prefix: 'fal',
  iconName: 'memory',
  icon: [576, 512, [], "f538", "M32 128c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32c-19.4 14.6-32 37.8-32 64s12.6 49.5 32 64v32H32l0-32c19.4-14.6 32-37.8 32-64s-12.6-49.5-32-64zM0 248.6V304 416c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V304 248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6zM544 416H480V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H392V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H304V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H216V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H128V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H32l0-96H544v96zM176 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"]
};
var faFaceSleeping = {
  prefix: 'fal',
  iconName: 'face-sleeping',
  icon: [512, 512, [], "e38d", "M32 256C32 132.3 132.3 32 256 32c33.1 0 64.5 7.2 92.7 20c8 3.7 17.5 .1 21.2-7.9s.1-17.5-7.9-21.2C329.6 8.2 293.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-37.8-8.2-73.6-22.9-105.9c-3.7-8-13.1-11.6-21.2-7.9s-11.6 13.1-7.9 21.2c12.8 28.2 20 59.6 20 92.7c0 123.7-100.3 224-224 224S32 379.7 32 256zM232 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm8-256h25.4l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H358.6l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H320c-8.8 0-16 7.2-16 16s7.2 16 16 16zM416 16c0 8.8 7.2 16 16 16h25.4L420.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H470.6l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0H432c-8.8 0-16 7.2-16 16zM387.2 238.4c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zm-262.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0z"]
};
var faRoadSpikes = {
  prefix: 'fal',
  iconName: 'road-spikes',
  icon: [640, 512, [], "e568", "M93.3 108L160 208l32 48V198.3 116.8c0-15.8 20.5-22 29.3-8.9L288 208l32 48V198.3 116.8c0-15.8 20.5-22 29.3-8.9L416 208l32 48V198.3 116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 480h-6.5H448 384 352h-6.5H320 256 224h-6.5H192 96 64V320 116.8c0-15.8 20.5-22 29.3-8.9zM512 320h68.2L480 169.7V256v64h32zm-90.6-46.2L352 169.7V256v64h32 64 4.2l-30.8-46.2zm-128 0L224 169.7V256v64h32 64 4.2l-30.8-46.2zm-128 0L96 169.7V320h96 4.2l-30.8-46.2zM16 416H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFireBurner = {
  prefix: 'fal',
  iconName: 'fire-burner',
  icon: [640, 512, [], "e4f1", "M349.4 93.5c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1c-18.3 29.6-27.6 57.9-27.6 75.8C192 262.5 248.2 320 320 320c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zM327.5 37.1c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zM285.1 96c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 0 0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0C361.3 282 342.3 288 321 288c-25.9 0-50.2-8.4-68.2-24.8C234.7 246.6 224 222.7 224 194c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L347 191l-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.5-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6C285.7 249.9 301.9 256 321 256c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5zM32 272c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v96H576V288H528c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16V386.7c18.6 6.6 32 24.4 32 45.3v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V432c0-20.9 13.4-38.7 32-45.3V272zm0 160v32c0 8.8 7.2 16 16 16H592c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm160-8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSquirrel = {
  prefix: 'fal',
  iconName: 'squirrel',
  icon: [512, 512, [], "f71a", "M144 32C82.1 32 32 82.1 32 144s50.1 112 112 112c15.7 0 30.2 8.5 37.7 22.3c9.6 17.3 5.2 37-4.3 50.5c-11 15.6-17.4 34.6-17.4 55.2c0 53 43 96 96 96H368c35.3 0 64-28.7 64-64s-28.7-64-64-64c-6.7 0-13.2 1-19.2 2.9c-8.4 2.6-17.4-2-20.1-10.5s2-17.4 10.5-20.1c9.1-2.9 18.8-4.4 28.8-4.4c11.2 0 22 1.9 32 5.5V240c0-8.8 7.2-16 16-16h11.5c21.2 0 40.6-12 50.1-31l2-4.1-.3-3.4C476 152.9 448.5 128 415.6 128H400c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16V96c49.1 .2 90.2 37.5 95.1 86.4l.8 8c.3 3-.3 6-1.6 8.7l-4.1 8.2c-14.2 28.5-42.7 46.9-74.2 48.5v88.6c19.6 17.6 32 43.1 32 71.6c0 24.6-9.2 47-24.4 64H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H368 256c-70.7 0-128-57.3-128-128c0-27.4 8.6-52.8 23.2-73.6c4.5-6.3 4.6-12.8 2.4-16.7c-1.9-3.5-5.7-5.7-9.7-5.7C64.5 288 0 223.5 0 144S64.5 0 144 0s144 64.5 144 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-61.9-50.1-112-112-112zM352 80v76.2c0 39-7.1 66.6-21.2 91.9c-11.9 21.2-28.6 40.5-48.2 63l0 0 0 0c-2.8 3.2-5.7 6.5-8.6 9.9l-11.2 13C248.5 350.4 240 376.6 240 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-29.6 10.4-63.7 30.6-87l11.2-13c3-3.5 5.9-6.8 8.7-10c19.9-22.9 34.3-39.4 44.4-57.5c11-19.7 17.1-41.6 17.1-76.2V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faArrowUpToLine = {
  prefix: 'fal',
  iconName: 'arrow-up-to-line',
  icon: [384, 512, ["arrow-to-top"], "f341", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM203.3 132.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 182.6V288 464c0 8.8 7.2 16 16 16s16-7.2 16-16V288 182.6L308.7 283.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128z"]
};
var faArrowToTop = faArrowUpToLine;
var faFlag = {
  prefix: 'fal',
  iconName: 'flag',
  icon: [448, 512, [127988, 61725], "f024", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V64 367v33 96c0 8.8 7.2 16 16 16s16-7.2 16-16V392l96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L32 56V16zm0 73L140.7 61.8c30.7-7.7 63.1-4.1 91.4 10c55.3 27.7 120.4 27.7 175.8 0l8.1-4.1v278l-34.7 13c-37.9 14.2-80 12-116.2-6.1c-44.7-22.4-96-28-144.5-15.9L32 359V89z"]
};
var faFaceCowboyHat = {
  prefix: 'fal',
  iconName: 'face-cowboy-hat',
  icon: [512, 512, [], "e36e", "M168.1 118.9c5.7-17.2 13-35.7 21.4-51.9c6.9-13.2 13.7-23.2 19.8-29.4c3.5-3.5 5.7-4.9 6.7-5.4c.8 .4 2.2 1.3 4.2 3c20.3 17.8 51.2 17.8 71.5 0c2-1.8 3.4-2.6 4.2-3c1 .5 3.2 1.8 6.7 5.4c6.1 6.2 12.9 16.2 19.8 29.4c8.4 16.2 15.7 34.8 21.4 51.9c-27.7 5.9-57.2 9.1-87.9 9.1s-60.2-3.2-87.9-9.1zM296 0c-8.9 0-17.4 4.2-25.4 11.2c-8.2 7.2-21.1 7.2-29.3 0C233.4 4.2 224.9 0 216 0c-34.2 0-63 62.1-79 110.9C106.5 101.7 78.9 89 55.2 73.6l-.3-.2c-1-.6-2-1.3-2.9-1.9c-2.3-1.6-4.6-3.2-6.9-4.8C42.6 65 39.7 64 36.7 64C27.7 64 21 72.3 23.8 80.7c1.1 3.5 2.4 7 3.8 10.4c.4 1 .8 2 1.3 3l.2 .4C61.5 169.9 150.8 224 256 224s194.5-54.1 227-129.4l.2-.4c.4-1 .9-2 1.3-3c1.4-3.4 2.7-6.9 3.8-10.4C491 72.3 484.3 64 475.3 64c-3 0-6 1-8.4 2.8c-2.3 1.6-4.6 3.2-6.9 4.8c-1 .6-1.9 1.3-2.9 1.9l-.3 .2C433.1 89 405.5 101.7 375 110.9C359 62.1 330.2 0 296 0zM256 192c-69.9 0-129-26.2-166.1-64.1C138.7 148.5 195.7 160 256 160s117.3-11.5 166.1-32.1C385 165.8 325.9 192 256 192zM75.8 200C58.1 230.6 48 266.1 48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-37.9-10.1-73.4-27.8-104c-8.6 6.2-17.6 12-27 17.2C423.7 242.9 432 272.5 432 304c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-31.5 8.3-61.1 22.8-86.7c-9.4-5.3-18.5-11-27-17.2zM192 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 386.1c25.9 0 51-2.6 74.9-7.4c-19.5 23.7-46.5 37.4-74.9 37.4s-55.4-13.7-74.9-37.4c23.9 4.8 49 7.4 74.9 7.4zm124.5-29.6c4.8-12.1-7.8-22.5-20.2-18.5c-31.7 10.3-67.1 16.1-104.4 16.1s-72.7-5.8-104.4-16.1c-12.3-4-24.9 6.4-20.2 18.5c21.3 54 69 91.6 124.5 91.6s103.3-37.6 124.5-91.6z"]
};
var faHanukiah = {
  prefix: 'fal',
  iconName: 'hanukiah',
  icon: [640, 512, [128334], "f6e6", "M336 16V48c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM64 80v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm160 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 96c8.8 0 16 7.2 16 16V352h48V176c0-8.8 7.2-16 16-16s16 7.2 16 16V352h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16V352h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16V349.3c18.6-6.6 32-24.4 32-45.3V176c0-8.8 7.2-16 16-16s16 7.2 16 16V304c0 44.2-35.8 80-80 80H336v96H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 144c-8.8 0-16-7.2-16-16s7.2-16 16-16H304V384H112c-44.2 0-80-35.8-80-80V176c0-8.8 7.2-16 16-16s16 7.2 16 16V304c0 20.9 13.4 38.7 32 45.3V176c0-8.8 7.2-16 16-16s16 7.2 16 16V352h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16V352h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16V352h48V112c0-8.8 7.2-16 16-16z"]
};
var faChartScatter3d = {
  prefix: 'fal',
  iconName: 'chart-scatter-3d',
  icon: [512, 512, [], "e0e8", "M272 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V280.6L37.7 451.8c-6.7 5.7-7.6 15.8-1.9 22.6s15.8 7.6 22.5 1.9L256 309 453.7 476.2c6.7 5.7 16.8 4.9 22.6-1.9s4.9-16.8-1.9-22.6L272 280.6V48zM384 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM152 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM56 256A24 24 0 1 0 8 256a24 24 0 1 0 48 0zM256 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDisplayChartUp = {
  prefix: 'fal',
  iconName: 'display-chart-up',
  icon: [576, 512, [], "e5e3", "M512 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H344.3c-.2 0-.4 0-.6 0H232.3c-.2 0-.4 0-.6 0H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H512zM64 416H213.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H360h72c8.8 0 16-7.2 16-16s-7.2-16-16-16H373.6l-10.7-64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm170.9 64l10.7-64h84.9l10.7 64H234.9zM368 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6V208c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16H368z"]
};
var faSquareCode = {
  prefix: 'fal',
  iconName: 'square-code',
  icon: [448, 512, [], "e267", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM261.4 172c-6.6 5.9-7.2 16-1.3 22.6L314.6 256 260 317.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3l64-72c5.4-6.1 5.4-15.2 0-21.3l-64-72c-5.9-6.6-16-7.2-22.6-1.3zM188 194.6c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3l-64 72c-5.4 6.1-5.4 15.2 0 21.3l64 72c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L133.4 256 188 194.6z"]
};
var faFeather = {
  prefix: 'fal',
  iconName: 'feather',
  icon: [512, 512, [129718], "f52d", "M325.6 163.8L96 393.4 96 330c0-59.4 23.6-116.4 65.6-158.4L265.4 67.9c23-23 54.1-35.9 86.6-35.9s63.7 12.9 86.6 35.9l5.5 5.5c23 23 35.9 54.1 35.9 86.6c0 22.8-6.3 44.9-18 64H310.6l37.6-37.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zm-47 92.2H434.7l-64 64H214.6l64-64zm60.1 96c-41.8 41-98.1 64-156.8 64H118.6l64-64H338.7zM64 330v95.3L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448H182c67.9 0 133-27 181-75L466.7 269.3c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330z"]
};
var faVolumeLow = {
  prefix: 'fal',
  iconName: 'volume-low',
  icon: [448, 512, [128264, "volume-down"], "f027", "M151.6 188L288 66.7V445.3L151.6 324c-2.9-2.6-6.7-4-10.6-4H56c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h85c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM409.6 179.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C406 216.5 416 235.1 416 256s-10 39.5-25.6 51.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8z"]
};
var faVolumeDown = faVolumeLow;
var faXmarkToSlot = {
  prefix: 'fal',
  iconName: 'xmark-to-slot',
  icon: [576, 512, ["times-to-slot", "vote-nay"], "f771", "M144 64c-8.8 0-16 7.2-16 16V384H448V80c0-8.8-7.2-16-16-16H144zM480 80V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480 448 128 96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16H96V80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48zM48 320H64v32H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H528c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H512V320h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zM212.7 148.7c6.2-6.2 16.4-6.2 22.6 0L288 201.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L310.6 224l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L288 246.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 224l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faTimesToSlot = faXmarkToSlot;
var faVoteNay = faXmarkToSlot;
var faBoxTaped = {
  prefix: 'fal',
  iconName: 'box-taped',
  icon: [448, 512, ["box-alt"], "f49a", "M264 32H184 105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38H264zm24 128L270 64h72.4c12.6 0 24.1 7.4 29.2 19l34.2 77H304 288zm-32.6 0H192.6l18-96h26.9l18 96zm.6 32v64H192V192h64zm-96 0v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V192h16H416V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H144h16zm0-32H144L42.1 160 76.3 83c5.1-11.6 16.6-19 29.2-19H178l-18 96z"]
};
var faBoxAlt = faBoxTaped;
var faCommentSlash = {
  prefix: 'fal',
  iconName: 'comment-slash',
  icon: [640, 512, [], "f4b3", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm377.6 400C378.1 411.5 350 416 320 416c-31.9 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4l6.4 14.7-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6c14.3-23.8 22.6-49.3 25.7-76.3c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100c0-22.9 5.9-45.3 16.7-66.1L87 153.6C72.2 179.9 64 209.2 64 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C249.5 441.3 284 448 320 448c40.6 0 78.9-7.7 113-21.3l-29.4-23.2zM320 32c-51.1 0-98.6 12.1-138.6 33.1L209.2 87C241.3 72.5 278.8 64 320 64c130.2 0 224 84.6 224 176c0 31-10.8 61.2-30.1 87.5l25.3 20C562.6 316.1 576 279.3 576 240C576 125.2 461.5 32 320 32z"]
};
var faSwords = {
  prefix: 'fal',
  iconName: 'swords',
  icon: [512, 512, [9876], "f71d", "M130.7 278.6l-15.4 15.4-12.7-12.7c-12.5-12.5-32.8-12.5-45.3 0l-16 16c-9.4 9.4-12 23.5-6.6 35.6l23.1 51.9L9.4 433.4c-12.5 12.5-12.5 32.8 0 45.3l24 24c12.5 12.5 32.8 12.5 45.3 0l48.5-48.5L179 477.2c12.1 5.4 26.3 2.7 35.6-6.6l16-16c12.5-12.5 12.5-32.8 0-45.3l-12.7-12.7 15.4-15.4-22.6-22.6-15.4 15.4-57.4-57.4 15.4-15.4-22.6-22.6zm227.9-67.9l22.6 22.6L491.1 123.5c7.9-7.9 12.8-18.4 13.9-29.6l7-76.5c.4-4.7-1.3-9.4-4.6-12.8s-8-5.1-12.8-4.6L418.1 7c-11.2 1-21.7 5.9-29.6 13.9L278.6 130.7l22.6 22.6L411.1 43.5c2.6-2.6 6.1-4.3 9.9-4.6l57.3-5.2L473.1 91c-.3 3.7-2 7.2-4.6 9.9L358.6 210.7zM64 320l16-16L208 432l-16 16-62-27.5c-6-2.7-13.1-1.4-17.8 3.3L56 480 32 456l56.2-56.2c4.7-4.7 6-11.8 3.3-17.8L64 320zM38.9 91L33.7 33.7 91 38.9c3.7 .3 7.2 2 9.9 4.6L354.7 297.4l22.6-22.6L123.5 20.9C115.6 12.9 105.1 8 93.9 7L17.4 .1C12.7-.4 8 1.3 4.7 4.7S-.4 12.7 .1 17.4L7 93.9c1 11.2 5.9 21.7 13.9 29.6L274.7 377.4l22.6-22.6L43.5 100.9c-2.6-2.6-4.3-6.1-4.6-9.9zM409.4 281.4l-128 128c-12.5 12.5-12.5 32.8 0 45.3l16 16c9.4 9.4 23.5 12 35.6 6.6l51.9-23.1 48.5 48.5c12.5 12.5 32.8 12.5 45.3 0l24-24c12.5-12.5 12.5-32.8 0-45.3l-48.5-48.5L477.2 333c5.4-12.1 2.7-26.3-6.6-35.6l-16-16c-12.5-12.5-32.8-12.5-45.3 0zM432 304l16 16-27.5 62c-2.7 6.1-1.4 13.1 3.3 17.8L480 456l-24 24-56.2-56.2c-4.7-4.7-11.8-6-17.8-3.3L320 448l-16-16L432 304z"]
};
var faCloudSunRain = {
  prefix: 'fal',
  iconName: 'cloud-sun-rain',
  icon: [640, 512, [127782], "f743", "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-7.2-7.9-13.4-16.7-18.4-26.2l-35.2 24.6-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 8.5 51c8.8-7.5 18.7-13.9 29.3-18.8L303.8 13.4zM208 120c-48.6 0-88 39.4-88 88c0 31 16 58.2 40.1 73.9c.6-12.5 2.9-24.5 6.8-35.7c-9.3-10-15-23.4-15-38.1c0-30.9 25.1-56 56-56c13.2 0 25.4 4.6 35 12.3c2.4-11 6.3-21.4 11.3-31.1C240.8 124.8 225 120 208 120zm87.3 297.7c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c3.9-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zM304 192c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H290.9c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H557.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 114.6 402.9 96 368 96z"]
};
var faAlbum = {
  prefix: 'fal',
  iconName: 'album',
  icon: [448, 512, [128189], "f89f", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleN = {
  prefix: 'fal',
  iconName: 'circle-n',
  icon: [512, 512, [], "e118", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM189 134.7c-4-5.7-11.3-8.1-17.9-5.9S160 137 160 144V368c0 8.8 7.2 16 16 16s16-7.2 16-16V193.9L323 377.3c4 5.7 11.3 8.1 17.9 5.9s11.1-8.3 11.1-15.2V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V318.1L189 134.7z"]
};
var faCompress = {
  prefix: 'fal',
  iconName: 'compress',
  icon: [448, 512, [], "f066", "M160 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16V48zM16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16H128V464c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16H16zM320 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V176c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V48zM304 320c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V352H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"]
};
var faWheatAwn = {
  prefix: 'fal',
  iconName: 'wheat-awn',
  icon: [512, 512, ["wheat-alt"], "e2cd", "M491 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L341.6 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L319.8 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L281.8 26.4c-6.2-6.2-16.4-6.2-22.6 0L225.2 60.3c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0l-33.9 33.9c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0L44.3 241.3c-37.5 37.5-37.5 98.3 0 135.8L78.2 411l0 0L4.7 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l73.5-73.5 0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c22.8-1.3 45.2-10.6 62.5-28l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c22.8-1.3 45.2-10.6 62.5-28l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-5.8-5.8-12-10.9-18.6-15.4L491 145.1c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L414 176.9c-16.1-5.5-33-7.8-49.8-6.7L491 43.3zM191.6 297.5l-.3 .3-33.9-33.9c-25-25-25-65.5 0-90.5L180 150.8l11.3 11.3c37.4 37.4 37.5 97.9 .4 135.4zM247.9 82.9l22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5zM89.5 241.3l11.3 11.3c37.5 37.5 37.5 98.2 0 135.7L66.9 354.4c-25-25-25-65.5 0-90.5l22.6-22.6zm181 181l-22.6 22.6c-25 25-65.5 25-90.5 0L123.5 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zm90.5-90.5l-22.6 22.6c-25 25-65.5 25-90.5 0l-33.9-33.9c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zm90.5-90.5l-22.6 22.6c-25 25-65.5 25-90.5 0L304.4 230c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3z"]
};
var faWheatAlt = faWheatAwn;
var faAnkh = {
  prefix: 'fal',
  iconName: 'ankh',
  icon: [320, 512, [9765], "f644", "M64 128c0 48.2 25.8 88.6 55 118.7c14.4 14.8 28.8 26.4 39.7 34.2l1.3 .9 1.3-.9c10.9-7.8 25.3-19.3 39.7-34.2c29.2-30.1 55-70.5 55-118.7c0-53-43-96-96-96s-96 43-96 96zm52.1 160C79.1 255.9 32 200.8 32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 72.8-47.1 127.9-84.1 160H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H116.1z"]
};
var faHandsHoldingChild = {
  prefix: 'fal',
  iconName: 'hands-holding-child',
  icon: [640, 512, [], "e4fa", "M336 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 96c-2.9 0-5.7 .2-8.5 .7L307.8 208h24.4l-3.7-63.3c-2.8-.4-5.6-.7-8.5-.7zM304 272.9c-.5 8.8-8.1 15.6-16.9 15s-15.6-8.1-15-16.9l6.4-108.3L251.3 190c-6.2 6.3-16.4 6.3-22.6 0s-6.3-16.4 0-22.6l29.6-29.7C274.6 121.2 296.8 112 320 112s45.4 9.2 61.7 25.6l29.6 29.7c6.2 6.3 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-27.1-27.2L368 271.1c.5 8.8-6.2 16.4-15 16.9s-16.4-6.2-16.9-15L334.1 240H305.9L304 272.9zM64 64c35.3 0 64 28.7 64 64V252.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64V344.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V252.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 0 0 44-44 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.9c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16 0 0-44-44 0 0-10.7-10.8C106.8 305.4 96 279.4 96 252.3V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V344.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2V128C0 92.7 28.7 64 64 64z"]
};
var faAsterisk = {
  prefix: 'fal',
  iconName: 'asterisk',
  icon: [384, 512, [10033, 61545], "2a", "M192 32c8.8 0 16 7.2 16 16V226.9l151.4-96.4c7.5-4.7 17.3-2.5 22.1 4.9s2.5 17.3-4.9 22.1L221.8 256l154.8 98.5c7.5 4.7 9.7 14.6 4.9 22.1s-14.6 9.7-22.1 4.9L208 285.1V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V285.1L24.6 381.5c-7.5 4.7-17.3 2.5-22.1-4.9s-2.5-17.3 4.9-22.1L162.2 256 7.4 157.5c-7.5-4.7-9.7-14.6-4.9-22.1s14.6-9.7 22.1-4.9L176 226.9V48c0-8.8 7.2-16 16-16z"]
};
var faKeySkeletonLeftRight = {
  prefix: 'fal',
  iconName: 'key-skeleton-left-right',
  icon: [640, 512, [], "e3b4", "M608 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm32 0c0 70.7-57.3 128-128 128s-128-57.3-128-128v0H288v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H192l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16l212 0C402.2 40.8 452.4 0 512 0c70.7 0 128 57.3 128 128zM32 384a96 96 0 1 0 192 0A96 96 0 1 0 32 384zM0 384c0-70.7 57.3-128 128-128s128 57.3 128 128v0h96V320c0-8.8 7.2-16 16-16s16 7.2 16 16v64h64l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80c0 8.8-7.2 16-16 16H252c-14.2 55.2-64.3 96-124 96C57.3 512 0 454.7 0 384z"]
};
var faCommentLines = {
  prefix: 'fal',
  iconName: 'comment-lines',
  icon: [512, 512, [], "f4b0", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM144 176c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
};
var faLuchadorMask = {
  prefix: 'fal',
  iconName: 'luchador-mask',
  icon: [448, 512, ["luchador", "mask-luchador"], "f455", "M288 480H160C89.3 480 32 422.7 32 352V224C32 118 118 32 224 32s192 86 192 192V352c0 70.7-57.3 128-128 128zM224 0C100.3 0 0 100.3 0 224V352c0 88.4 71.6 160 160 160H288c88.4 0 160-71.6 160-160V224C448 100.3 347.7 0 224 0zM160 352h35.3 57.4H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm-6.4-31.7C121.2 323.5 96 350.8 96 384c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64c0-33.2-25.2-60.5-57.6-63.7c1-3.7 1.6-7.6 1.6-11.6c0-7.3-1.8-14.4-5.3-20.7H304c44.2 0 80-35.8 80-80c0-26.5-21.5-48-48-48H304c-44.2 0-80 35.8-80 80c0-44.2-35.8-80-80-80H112c-26.5 0-48 21.5-48 48c0 44.2 35.8 80 80 80h13.3c-3.4 6.3-5.3 13.4-5.3 20.7c0 4 .6 7.9 1.6 11.6zm41.7-.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8l8-8 4.2-4.2 .4-.4 10.3-10.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 288l.4 .4 4.2 4.2 8 8c2.1 2.1 3.3 5 3.3 8c0 6.2-5.1 11.3-11.3 11.3H241.4h-6-.6H213.3h-.6-6H195.3zM96 208c0-8.8 7.2-16 16-16h32c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16H144c-26.5 0-48-21.5-48-48zm240-16c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H272c-8.8 0-16-7.2-16-16c0-26.5 21.5-48 48-48h32z"]
};
var faLuchador = faLuchadorMask;
var faMaskLuchador = faLuchadorMask;
var faSquareCheck = {
  prefix: 'fal',
  iconName: 'square-check',
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM331.3 203.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L192 297.4 308.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faCheckSquare = faSquareCheck;
var faShredder = {
  prefix: 'fal',
  iconName: 'shredder',
  icon: [512, 512, [], "f68a", "M96 64V192H416V90.5c0-8.5-3.4-16.6-9.4-22.6L380.1 41.4c-6-6-14.1-9.4-22.6-9.4H128c-17.7 0-32 14.3-32 32zM64 192V64C64 28.7 92.7 0 128 0H357.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V192c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64zm0 32c-17.7 0-32 14.3-32 32v96H480V256c0-17.7-14.3-32-32-32H64zm344 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 496V416h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0V416h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0V416h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0V416h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faBookOpenCover = {
  prefix: 'fal',
  iconName: 'book-open-cover',
  icon: [640, 512, ["book-open-alt"], "e0c0", "M544 373.8V33.5L336 62.1V415.4l208-41.6zM304 415.4V62.1L96 33.5V373.8l208 41.6zM539.6 1.8C558.9-.8 576 14.1 576 33.5V373.8c0 15.3-10.8 28.4-25.7 31.4L332.6 448.7c-8.3 1.7-16.8 1.7-25.1 0L89.7 405.1c-15-3-25.7-16.1-25.7-31.4V33.5C64 14.1 81.1-.8 100.4 1.8L320 32 539.6 1.8zM0 65.5c0-17.9 14.6-32 32-32l0 32L32 160l0 258.6 281.7 56.3c4.1 .8 8.4 .8 12.6 0L608 418.6V160 65.5v-32c17.4 0 32 14.1 32 32V418.6c0 15.3-10.8 28.4-25.7 31.4L332.6 506.3c-8.3 1.7-16.8 1.7-25.1 0L25.7 449.9C10.8 447 0 433.8 0 418.6V65.5z"]
};
var faBookOpenAlt = faBookOpenCover;
var faSandwich = {
  prefix: 'fal',
  iconName: 'sandwich',
  icon: [512, 512, [129386], "f81f", "M480 96v64H32V96H480zM32 64C14.3 64 0 78.3 0 96v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H32zM0 352v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H392c-2.2 0-4.5 .5-6.5 1.4L320 350.5l-65.5-29.1c-2-.9-4.3-1.4-6.5-1.4H32c-17.7 0-32 14.3-32 32zm244.6 0l68.9 30.6c4.1 1.8 8.9 1.8 13 0L395.4 352H480v64H32V352H244.6zM16 288c10.5 0 20.9-2.6 30.5-5.8c8.5-2.9 17.2-6.6 25.6-10.1l0 0 3.2-1.3C94.6 262.6 111.7 256 128 256c20.4 0 36.7 6.7 56.6 14.8c19.5 8 42.2 17.2 71.4 17.2s51.8-9.2 71.4-17.2c19.9-8.1 36.2-14.8 56.6-14.8c16.3 0 33.4 6.6 52.8 14.7l3.2 1.3c8.3 3.5 17.1 7.2 25.6 10.1c9.6 3.2 20 5.8 30.5 5.8c8.8 0 16-7.2 16-16s-7.2-16-16-16c-5.5 0-12.1-1.4-20.3-4.2c-7.3-2.5-14.9-5.7-23.4-9.3l-3.2-1.3C430.6 233.4 407.7 224 384 224c-26.8 0-48.2 8.8-67 16.5l-1.8 .7c-19.6 8-37 14.8-59.3 14.8s-39.7-6.8-59.3-14.8l-1.8-.7c-18.8-7.7-40.2-16.5-67-16.5c-23.7 0-46.6 9.4-65.2 17.3l-3.2 1.3c-8.5 3.6-16.1 6.8-23.4 9.3C28.1 254.6 21.5 256 16 256c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faPesetaSign = {
  prefix: 'fal',
  iconName: 'peseta-sign',
  icon: [384, 512, [], "e221", "M72.7 32C50.2 32 32 50.2 32 72.7V160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32V304 464c0 8.8 7.2 16 16 16s16-7.2 16-16V320H208c74.1 0 135.2-56 143.1-128H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H351.1c-8-72-69-128-143.1-128H72.7zM318.9 160H64V72.7c0-4.8 3.9-8.7 8.7-8.7H208c56.4 0 103.1 41.7 110.9 96zM64 192H318.9c-7.8 54.3-54.4 96-110.9 96H64V192z"]
};
var faSquareParkingSlash = {
  prefix: 'fal',
  iconName: 'square-parking-slash',
  icon: [640, 512, ["parking-slash"], "f617", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM497.4 477.6L459.9 448H160c-17.7 0-32-14.3-32-32V186L96 160.7V416c0 35.3 28.7 64 64 64H480c6 0 11.9-.8 17.4-2.4zM142.6 34.4L180.1 64H480c17.7 0 32 14.3 32 32V326l32 25.3V96c0-35.3-28.7-64-64-64H160c-6 0-11.9 .8-17.4 2.4zm97.4 240V304v64c0 8.8 7.2 16 16 16s16-7.2 16-16V352 320 299.6l-32-25.3zm197.7-7c6.6-13 10.3-27.8 10.3-43.4c0-53-43-96-96-96H264c-.9 0-1.8 0-2.7 .1L301.7 160H352c35.3 0 64 28.7 64 64c0 8.1-1.5 15.8-4.2 22.9l25.9 20.4z"]
};
var faParkingSlash = faSquareParkingSlash;
var faTrainTunnel = {
  prefix: 'fal',
  iconName: 'train-tunnel',
  icon: [512, 512, [], "e454", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224V496c0 8.8 7.2 16 16 16s16-7.2 16-16V256C512 114.6 397.4 0 256 0S0 114.6 0 256V496c0 8.8 7.2 16 16 16s16-7.2 16-16V256zm336-48v48H144V208c0-26.5 21.5-48 48-48H320c26.5 0 48 21.5 48 48zM144 368V288H368v80c0 26.5-21.5 48-48 48h0H192h0c-26.5 0-48-21.5-48-48zm16 73.4l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L198.6 448H313.4l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L352 441.4c28.3-12.3 48-40.5 48-73.4V208c0-44.2-35.8-80-80-80H192c-44.2 0-80 35.8-80 80V368c0 32.8 19.8 61 48 73.4zM280 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHeading = {
  prefix: 'fal',
  iconName: 'heading',
  icon: [448, 512, ["header"], "f1dc", "M0 48c0-8.8 7.2-16 16-16H80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H96V224H352V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H384V240 448h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V256H96V448h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V240 64H16C7.2 64 0 56.8 0 48z"]
};
var faHeader = faHeading;
var faGhost = {
  prefix: 'fal',
  iconName: 'ghost',
  icon: [384, 512, [128123], "f6e2", "M242.7 506c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6l29.3-33.4c11.6-13.3 32.1-14 44.5-1.5l2.3 2.3c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6V192C384 86 298 0 192 0S0 86 0 192V457.4C0 469.9 10.1 480 22.6 480c6 0 11.8-2.4 16-6.6l2.3-2.3c12.5-12.5 32.9-11.8 44.5 1.5L114.7 506c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6l26.6-30.5c12.7-14.6 35.4-14.6 48.2 0L242.7 506zM32 438.1V192c0-88.4 71.6-160 160-160s160 71.6 160 160V438.1c-25.1-14-57.6-9.3-77.6 13.4L256 472.5l-15.8-18.1c-25.5-29.1-70.8-29.1-96.3 0L128 472.5l-18.4-21.1C89.6 428.7 57.1 424 32 438.1zM152 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFaceAnguished = {
  prefix: 'fal',
  iconName: 'face-anguished',
  icon: [512, 512, [], "e369", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.8 48h8.4c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2H180.2c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zm8.4 32h-8.4c-29 0-53.2 20.6-58.6 48H318.8c-5.5-27.4-29.6-48-58.6-48zM152.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faHockeySticks = {
  prefix: 'fal',
  iconName: 'hockey-sticks',
  icon: [640, 512, [], "f454", "M301.4 288H266.5L129.8 23.3c-4.1-7.9-1-17.5 6.9-21.6s17.5-1 21.6 6.9L302 286.9l-.6 1.1zm75 64L393 320H584c30.9 0 56 25.1 56 56v80c0 30.9-25.1 56-56 56H421.2c-23.9 0-45.9-13.4-56.9-34.6l-26.4-51 18-34.9 36.8 71.2c5.5 10.6 16.5 17.3 28.4 17.3H512V352H376.4zM544 352V480h40c13.3 0 24-10.7 24-24V376c0-13.3-10.7-24-24-24H544zM503.3 1.8c7.8 4.1 10.9 13.7 6.9 21.6l-234.6 454c-11 21.3-32.9 34.6-56.9 34.6H56c-30.9 0-56-25.1-56-56V376c0-30.9 25.1-56 56-56H320.9L481.8 8.7c4.1-7.9 13.7-10.9 21.6-6.9zM304.4 352H128V480h90.8c12 0 22.9-6.7 28.4-17.3L304.4 352zM56 352c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24H96V352H56z"]
};
var faAbacus = {
  prefix: 'fal',
  iconName: 'abacus',
  icon: [576, 512, [129518], "f640", "M512 64c17.7 0 32 14.3 32 32v96H448V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V64h64zm-96 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H288V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V64H416v64zm-160 0H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H160V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V64h96v64zm-128 0H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H32V96c0-17.7 14.3-32 32-32h64v64zM32 416V224h96v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64H64c-17.7 0-32-14.3-32-32zm128-32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V320h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V224h96v64H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64H160V384zm128-64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V224H416V352H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64H288V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V320zm160 64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V224h96V416c0 17.7-14.3 32-32 32H448V384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faFilmSimple = {
  prefix: 'fal',
  iconName: 'film-simple',
  icon: [512, 512, ["film-alt"], "f3a0", "M128 352v96H384V352 256 160 64H128v96 96 96zM96 368H32v48c0 17.7 14.3 32 32 32H96V368zm0-32V272H32v64H96zm0-96V176H32v64H96zm0-96V64H64C46.3 64 32 78.3 32 96v48H96zM416 272v64h64V272H416zm0 96v80h32c17.7 0 32-14.3 32-32V368H416zm0-128h64V176H416v64zm0-96h64V96c0-17.7-14.3-32-32-32H416v80zM64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32z"]
};
var faFilmAlt = faFilmSimple;
var faList = {
  prefix: 'fal',
  iconName: 'list',
  icon: [512, 512, ["list-squares"], "f03a", "M48 112V80H80v32H48zM16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40C26.7 48 16 58.7 16 72zm160 8c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM48 240H80v32H48V240zm-8-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40zm8 224V400H80v32H48zM16 392v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24z"]
};
var faListSquares = faList;
var faTreePalm = {
  prefix: 'fal',
  iconName: 'tree-palm',
  icon: [576, 512, [127796], "f82b", "M115.7 128c.7-.7 1.4-1.5 2.2-2.2c20.7-20.7 42.4-35.1 64.1-44.5c8.1-3.5 17.5 .2 21 8.3s-.2 17.5-8.3 21c-17.7 7.7-36.1 19.7-54.1 37.8c-3.6 3.6-6.9 7.1-10 10.7l-1.3 1.5c-51.1 60.1-42 123.1-21.3 156.1L244 180.7c3.2-3.2 7.5-4.9 12-4.7l0 0H432V144c0-8.8 7.2-16 16-16s16 7.2 16 16v32h78.1C532.8 135.5 490 80 400 80c-31.6 0-57.2 6.8-77.4 17.2c-7.2 3.7-16 1.4-20.6-5.3C281.2 60.9 241 32 176 32C86 32 43.2 87.5 33.9 128h81.7zM544 208H448 341.1c8 23.6 15.1 49.1 21 75.4c14.3 64.4 21.4 135.3 15.4 200.1C375.9 500 361.9 512 345.9 512H245.8c-21.7 0-36.7-21-30.8-41.3c27.4-94.3 34-166.1 30.8-216.1c-.6-10-1.7-19.1-3-27.4L129.1 340.8c-11.8 11.8-34.2 13.9-46-3.3C56.3 297.9 44.6 227.5 89.6 160H32c-16.7 0-34-14.3-30.1-34.9C12.3 70.1 67.6 0 176 0c68.6 0 116.2 28.1 144.4 63c22.6-9.4 49.1-15 79.6-15c108.4 0 163.7 70.1 174.1 125.1C578 193.7 560.7 208 544 208zm-272.3 0c2.8 13 4.9 27.8 5.9 44.5c3.5 54.5-3.8 130-32 227.1c0 .1 0 .1 0 .1l0 .1c0 0 0 .1 .1 .2l0 0h99.9c5.5-60.6-1.1-127.9-14.8-189.7c-6.5-29.4-14.6-57.2-23.7-82.3H271.7z"]
};
var faSquarePhoneFlip = {
  prefix: 'fal',
  iconName: 'square-phone-flip',
  icon: [448, 512, ["phone-square-alt"], "f87b", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM276.8 144.1l56 12c1.8 .4 3.2 2 3.2 3.9c0 114.9-93.1 208-208 208c-1.9 0-3.5-1.3-3.9-3.2l-12-56c-.4-1.9 .6-3.8 2.3-4.5l56-24c1.6-.7 3.5-.2 4.7 1.1l16.6 20.3c5 6.1 13.6 7.6 20.4 3.7c25.4-14.7 46.6-35.9 61.4-61.4c3.9-6.8 2.4-15.4-3.7-20.4l-20.3-16.6c-1.4-1.1-1.8-3-1.1-4.7l24-56c.8-1.8 2.6-2.7 4.5-2.3zm-33.9-10.3l-24 56c-6.3 14.7-2.1 31.9 10.3 42l9.2 7.5c-8.6 11.9-19.1 22.4-31 31l-7.5-9.2c-10.2-12.4-27.3-16.6-42-10.3l-56 24c-15.8 6.8-24.6 23.8-21 40.6l12 56C96.4 388.1 111 400 128 400c132.5 0 240-107.4 240-240c0-17-11.9-31.6-28.5-35.2l-56-12c-16.8-3.6-33.9 5.2-40.6 21z"]
};
var faPhoneSquareAlt = faSquarePhoneFlip;
var faCartPlus = {
  prefix: 'fal',
  iconName: 'cart-plus',
  icon: [576, 512, [], "f217", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H53.9c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H191.2c-15.2 0-28.3-10.7-31.4-25.6L152 288H466.5c29.4 0 55-20 62.1-48.5L575.5 51.9c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6L497.6 231.8C494 246 481.2 256 466.5 256H145.4L100.9 38.4C96.3 16 76.7 0 53.9 0H16zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM240 128c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V144h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H256c-8.8 0-16 7.2-16 16z"]
};
var faGamepad = {
  prefix: 'fal',
  iconName: 'gamepad',
  icon: [640, 512, [], "f11b", "M192 96C103.6 96 32 167.6 32 256s71.6 160 160 160H448c88.4 0 160-71.6 160-160s-71.6-160-160-160H192zM0 256C0 150 86 64 192 64H448c106 0 192 86 192 192s-86 192-192 192H192C86 448 0 362 0 256zm208-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V192c0-8.8 7.2-16 16-16s16 7.2 16 16zM408 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faBorderCenterV = {
  prefix: 'fal',
  iconName: 'border-center-v',
  icon: [448, 512, [], "f89d", "M208 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416zM56 448A24 24 0 1 0 8 448a24 24 0 1 0 48 0zm384 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM56 352A24 24 0 1 0 8 352a24 24 0 1 0 48 0zm384 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM392 160a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM56 160A24 24 0 1 0 8 160a24 24 0 1 0 48 0zm336 96a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM56 256A24 24 0 1 0 8 256a24 24 0 1 0 48 0zM392 64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM8 64a24 24 0 1 0 48 0A24 24 0 1 0 8 64zM296 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM344 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM296 448a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM152 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 448a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCircleDot = {
  prefix: 'fal',
  iconName: 'circle-dot',
  icon: [512, 512, [128280, "dot-circle"], "f192", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faDotCircle = faCircleDot;
var faClipboardMedical = {
  prefix: 'fal',
  iconName: 'clipboard-medical',
  icon: [384, 512, [], "e133", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM176 208c-17.7 0-32 14.3-32 32v32H112c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V368h32c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32H240V240c0-17.7-14.3-32-32-32H176zm0 80V240h32v48c0 8.8 7.2 16 16 16h48v32H224c-8.8 0-16 7.2-16 16v48H176V352c0-8.8-7.2-16-16-16H112V304h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z"]
};
var faFaceDizzy = {
  prefix: 'fal',
  iconName: 'face-dizzy',
  icon: [512, 512, ["dizzy"], "f567", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208 96a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faDizzy = faFaceDizzy;
var faEgg = {
  prefix: 'fal',
  iconName: 'egg',
  icon: [384, 512, [129370], "f7fb", "M192 464c-85.2 0-160-84.3-160-176c0-50.8 14.7-113.1 43.5-161.7C104.2 77.9 143.4 48 192 48s87.8 29.9 116.5 78.3C337.3 174.9 352 237.2 352 288c0 91.7-74.8 176-160 176zM0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zM170.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C85.7 226.1 80 259.7 80 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"]
};
var faUpToLine = {
  prefix: 'fal',
  iconName: 'up-to-line',
  icon: [384, 512, ["arrow-alt-to-top"], "f34d", "M16 64H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 32 0 39.2 0 48s7.2 16 16 16zm174.2 96.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L318.2 292.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7H256c-8.8 0-16 7.2-16 16V440c0 4.4-3.6 8-8 8H152c-4.4 0-8-3.6-8-8V320c0-8.8-7.2-16-16-16H70.7c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L190.2 160.8zM192 128c-9.5 0-18.6 3.9-25.1 10.8L42.5 270.8C35.8 278 32 287.5 32 297.3C32 318.7 49.3 336 70.7 336H112V440c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V336h41.3c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L217.1 138.8c-6.5-6.9-15.6-10.8-25.1-10.8z"]
};
var faArrowAltToTop = faUpToLine;
var faHouseMedicalCircleXmark = {
  prefix: 'fal',
  iconName: 'house-medical-circle-xmark',
  icon: [640, 512, [], "e513", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H394.8c-12.9-9.1-24.5-19.9-34.6-32H144c-26.5 0-48-21.5-48-48V206.7L288 37.3 466.1 194.5c9.7-1.7 19.7-2.5 29.9-2.5c5.6 0 11.1 .3 16.5 .8L298.6 4zM368 240H336V208c0-17.7-14.3-32-32-32H272c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c6.7 0 12.9-2 18-5.5c-1.3-8.6-2-17.5-2-26.5c0-22.6 4.3-44.2 12-64H320c-8.8 0-16 7.2-16 16v48H272V320c0-8.8-7.2-16-16-16H208V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208h32v48c0 8.8 7.2 16 16 16h28.5c7.5-11.4 16.2-22 26-31.3c-2.1-.4-4.3-.7-6.5-.7zm16 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-121.4 0l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"]
};
var faWatchFitness = {
  prefix: 'fal',
  iconName: 'watch-fitness',
  icon: [384, 512, [], "f63e", "M96 48V64H288V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48C64 21.5 85.5 0 112 0H272c26.5 0 48 21.5 48 48V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16V448H96v16zM80 96c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zm32 125.3c0 7.8 3.1 15.2 8.6 20.7L192 313.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6c-16.2 0-29.3 13.1-29.3 29.3zM141.3 160c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3c0-33.8 27.4-61.3 61.3-61.3z"]
};
var faClockNineThirty = {
  prefix: 'fal',
  iconName: 'clock-nine-thirty',
  icon: [512, 512, [], "e34d", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V256c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faCampground = {
  prefix: 'fal',
  iconName: 'campground',
  icon: [576, 512, [9978], "f6bb", "M394.3 3.7c6.8 5.7 7.7 15.8 2 22.5L308.9 130.4 532.8 397.2C540 405.8 544 416.7 544 428v36c0 26.5-21.5 48-48 48H288 80c-26.5 0-48-21.5-48-48V428c0-11.3 4-22.2 11.2-30.9L267.1 130.4 179.7 26.3c-5.7-6.8-4.8-16.9 2-22.5s16.9-4.8 22.5 2L288 105.5 371.7 5.7c5.7-6.8 15.8-7.7 22.5-2zM67.7 417.7c-2.4 2.9-3.7 6.5-3.7 10.3v36c0 8.8 7.2 16 16 16h49.9l1.5-1.9 144-184c3-3.9 7.7-6.1 12.6-6.1s9.6 2.3 12.6 6.1l144 184 1.5 1.9H496c8.8 0 16-7.2 16-16V428c0-3.8-1.3-7.4-3.7-10.3L288 155.3 67.7 417.7zM170.6 480H288 405.4L288 330 170.6 480z"]
};
var faFolderPlus = {
  prefix: 'fal',
  iconName: 'folder-plus',
  icon: [512, 512, [], "f65e", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM240 384c0 8.8 7.2 16 16 16s16-7.2 16-16V304h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faJug = {
  prefix: 'fal',
  iconName: 'jug',
  icon: [448, 512, [], "f8c6", "M176 85V32h96V85c0 14.2 4.7 28.1 13.5 39.3L363.8 225c13.1 16.9 20.2 37.6 20.2 58.9V288H64v-4.1c0-21.3 7.1-42.1 20.2-58.9l78.3-100.7C171.3 113.1 176 99.3 176 85zM128 16c0 8.8 7.2 16 16 16V85c0 7.1-2.4 14-6.7 19.6L59 205.3c-17.5 22.5-27 50.1-27 78.6V304v96 48c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V400 304 283.9c0-21.8-5.6-43.1-16-61.9c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64c-23.6 0-44.2 12.8-55.3 31.8l-18-23.1C306.4 99 304 92.1 304 85V32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272 176 144c-8.8 0-16 7.2-16 16zM378.3 191.5l-26.2-33.7c1.1-16.7 15-29.8 31.9-29.8c17.7 0 32 14.3 32 32s-14.3 32-32 32c-2 0-3.9-.2-5.7-.5zM64 384V320H384v64H64zm0 32H384v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416z"]
};
var faFutbol = {
  prefix: 'fal',
  iconName: 'futbol',
  icon: [512, 512, [9917, "futbol-ball", "soccer-ball"], "f1e3", "M299.3 475.8c.1-.8 .2-1.7 .4-2.6l21.7-85.8c1.5-5.9 1.4-12.4-2.2-17.3l-3.9-5.3c-6.6-9.1-18.5-12.2-29.8-12.2H226.4c-11.3 0-23.1 3.1-29.8 12.2l-3.9 5.3c-3.6 4.9-3.7 11.4-2.2 17.3l21.7 85.8c.2 .9 .4 1.7 .4 2.6c14 2.7 28.5 4.2 43.3 4.2s29.3-1.4 43.3-4.2zm35.3-10c38.3-14.3 71.6-38.8 96.6-70.2l-72.5-4.8c-1.4-.1-2.8 .3-4 1.2s-2 2.1-2.3 3.4l-17.8 70.5zM451.7 365.1c13.9-24.9 23.2-52.7 26.7-82.3c-.8-.3-1.5-.7-2.3-1.2l-74.9-47.1c-5.1-3.2-11.3-5.1-17.1-3.3l-6.3 2c-10.7 3.5-17.3 13.8-20.8 24.5L338.8 314c-3.5 10.7-4.2 22.9 2.4 32l3.9 5.3c3.6 4.9 9.7 7 15.8 7.4l88.3 5.9c.9 .1 1.7 .2 2.6 .4zm28.1-119c-1.8-41.9-15.1-80.7-36.9-113.6l-27 67.5c-.5 1.3-.6 2.7-.2 4.1l0 .1 0 .1c.5 1.3 1.3 2.4 2.5 3.2l61.5 38.7zM420.2 103.6c-19.7-21.2-43.4-38.6-70-50.9c-.6 .6-1.2 1.3-1.9 1.8l-68 56.6c-4.7 3.9-8.4 9.2-8.4 15.3l0 6.6c0 11.2 7.8 20.7 16.9 27.3l47.9 34.8c9.1 6.6 20.5 11.1 31.2 7.6l6.3-2c5.8-1.9 9.7-7.1 11.9-12.7l32.9-82.1c.3-.8 .7-1.6 1.1-2.3zM315.7 40.1c-19-5.3-39.1-8.1-59.7-8.1s-40.7 2.8-59.7 8.1l55.8 46.5c1.1 .9 2.5 1.4 3.9 1.4s2.8-.5 3.9-1.4l55.8-46.5zm-154 12.7c-26.6 12.3-50.3 29.7-70 50.9c.4 .7 .8 1.5 1.1 2.3L125.8 188c2.3 5.6 6.2 10.8 11.9 12.7l6.3 2c10.7 3.5 22.1-1 31.2-7.6l47.9-34.8c9.1-6.6 16.9-16.1 16.9-27.3l0-6.6c0-6.1-3.7-11.4-8.4-15.3l-68-56.6c-.7-.6-1.3-1.2-1.9-1.8zM69.1 132.5C47.4 165.3 34 204.2 32.2 246.1l61.5-38.7c1.2-.7 2.1-1.9 2.5-3.2l0-.1 0-.1c.4-1.3 .4-2.8-.2-4.1l-27-67.4zM33.6 282.8c3.5 29.6 12.8 57.4 26.7 82.3c.8-.2 1.7-.3 2.6-.4l88.3-5.9c6.1-.4 12.2-2.5 15.8-7.4l3.9-5.3c6.6-9.1 5.9-21.4 2.4-32l-18.3-56.3c-3.5-10.7-10.1-21.1-20.8-24.5l-6.3-2c-5.8-1.9-12 0-17.1 3.3L35.9 281.6c-.7 .5-1.5 .9-2.3 1.2zM80.8 395.6c25 31.4 58.3 55.9 96.6 70.2l-17.8-70.5c-.3-1.4-1.2-2.6-2.3-3.4s-2.6-1.2-4-1.2l-72.5 4.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm241.9-69.8L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8c-8.4-6.1-19.8-6.1-28.2 0z"]
};
var faFutbolBall = faFutbol;
var faSoccerBall = faFutbol;
var faSnowBlowing = {
  prefix: 'fal',
  iconName: 'snow-blowing',
  icon: [640, 512, [], "f761", "M192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v41.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L160 166.6v61.7l-53.4-30.8L90.7 138.3c-2.3-8.5-11.1-13.6-19.6-11.3s-13.6 11.1-11.3 19.6l7.6 28.3L31.6 154.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l35.8 20.7-28.3 7.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l59.2-15.9L144 256 90.6 286.8 31.4 271c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l28.3 7.6L15.6 330.1C7.9 334.6 5.3 344.3 9.7 352s14.2 10.3 21.9 5.9l35.8-20.7-7.6 28.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l15.9-59.2L160 283.7v61.7l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L160 390.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V390.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L192 345.4V283.7l53.4 30.8 15.9 59.2c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-7.6-28.3 35.8 20.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-35.8-20.7 28.3-7.6c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-59.2 15.9L208 256l53.4-30.8L320.6 241c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-28.3-7.6 35.8-20.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-35.8 20.7 7.6-28.3c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-15.9 59.2L192 228.3V166.6l43.3-43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 121.4V80zm288 0c0 8.8 7.2 16 16 16h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c44.2 0 80-35.8 80-80s-35.8-80-80-80H496c-8.8 0-16 7.2-16 16zm0 352c0 8.8 7.2 16 16 16h64c44.2 0 80-35.8 80-80s-35.8-80-80-80H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c26.5 0 48 21.5 48 48s-21.5 48-48 48H496c-8.8 0-16 7.2-16 16z"]
};
var faPaintbrush = {
  prefix: 'fal',
  iconName: 'paintbrush',
  icon: [576, 512, [128396, "paint-brush"], "f1fc", "M295.7 360c-5.4 0-10.6-.5-15.7-1.5l0-.1c-1.3-.3-2.6-.6-3.9-.9l-57.7-57.7c-.3-1.3-.6-2.6-.9-3.9l-.1 0c-1-5.1-1.5-10.3-1.5-15.7c0-25.5 12.2-49.5 32.8-64.5L493.1 38.1c12.7-9.3 30.3-7.9 41.4 3.2s12.5 28.7 3.3 41.4L360.2 327.2c-15 20.6-39 32.8-64.5 32.8zm-42.2 20.1c.3 1.3 .6 2.6 .9 4c1 5.1 1.6 10.4 1.6 15.9c0 44.2-35.8 80-80 80H36.8C58 480 74.3 468.5 84 455.1c9.5-13.1 14.2-30 12.5-46.7c-.3-2.7-.4-5.5-.4-8.3c0-44.2 35.8-80 80-80c5.4 0 10.7 .5 15.9 1.6c1.3 .3 2.7 .6 4 .9l57.7 57.7zm34.2 11.6c2.6 .2 5.3 .3 8 .3c35.7 0 69.3-17.1 90.4-46L563.7 101.6c18.5-25.5 15.8-60.6-6.5-82.9s-57.4-25-82.9-6.5L230 190c-28.9 21-46 54.6-46 90.3c0 2.7 .1 5.4 .3 8c-2.7-.2-5.5-.3-8.3-.3c-61.9 0-112 50.1-112 112c0 3.9 .2 7.8 .6 11.6C66.4 429.1 54.4 448 36.8 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H176c61.9 0 112-50.1 112-112c0-2.8-.1-5.5-.3-8.3z"]
};
var faPaintBrush = faPaintbrush;
var faLock = {
  prefix: 'fal',
  iconName: 'lock',
  icon: [448, 512, [128274], "f023", "M128 128v64H320V128c0-53-43-96-96-96s-96 43-96 96zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h16c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80H96zM32 272V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48z"]
};
var faArrowDownFromLine = {
  prefix: 'fal',
  iconName: 'arrow-down-from-line',
  icon: [384, 512, [8615, "arrow-from-top"], "f345", "M203.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 425.4V320 144c0-8.8 7.2-16 16-16s16 7.2 16 16V320 425.4L308.7 324.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128zM16 64C7.2 64 0 56.8 0 48s7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16z"]
};
var faArrowFromTop = faArrowDownFromLine;
var faGasPump = {
  prefix: 'fal',
  iconName: 'gas-pump',
  icon: [512, 512, [9981], "f52f", "M256 32c17.7 0 32 14.3 32 32V192H64V64c0-17.7 14.3-32 32-32H256zm32 192V480H64V224H288zM32 64V480l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 64 288h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0V288h16c26.5 0 48 21.5 48 48v48c0 35.3 28.7 64 64 64s64-28.7 64-64V157.1c0-17.9-7.5-35.1-20.8-47.2L410.8 36.2c-6.5-6-16.6-5.5-22.6 1s-5.5 16.6 1 22.6L416 84.4V160c0 35.3 28.7 64 64 64V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V336c0-44.2-35.8-80-80-80H320V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64zM480 192c-17.7 0-32-14.3-32-32V113.7l21.6 19.8c6.6 6.1 10.4 14.6 10.4 23.6V192z"]
};
var faSignalBarsSlash = {
  prefix: 'fal',
  iconName: 'signal-bars-slash',
  icon: [640, 512, ["signal-alt-slash"], "f694", "M448 176c0-26.5-21.5-48-48-48s-48 21.5-48 48v23.7L384 225V176c0-8.8 7.2-16 16-16s16 7.2 16 16v74.2l32 25.3V176zM384 464V388.1l-32-25.3V464c0 26.5 21.5 48 48 48s48-21.5 48-48V438.6l-32-25.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16zM288 312.3l-66.6-52.6C204.1 267 192 284.1 192 304V464c0 26.5 21.5 48 48 48s48-21.5 48-48V312.3zm256 39V48c0-8.8 7.2-16 16-16s16 7.2 16 16V376.6l32 25.3V48c0-26.5-21.5-48-48-48s-48 21.5-48 48V326l32 25.3zM256 304V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zM96 432v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48s-48 21.5-48 48zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faSignalAltSlash = faSignalBarsSlash;
var faMonkey = {
  prefix: 'fal',
  iconName: 'monkey',
  icon: [576, 512, [128018], "f6fb", "M160 416c0-82.3 44.3-154.2 110.4-193.1c4.7 9.7 10.5 18.7 17.1 27.1C230.4 283.2 192 345.1 192 416v64H416V432c0-44.2-35.8-80-80-80H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c31.3 0 59.7 12.9 80 33.6V320 303.1c14.7-1.6 28.7-5.5 41.7-11.2l79.2 84.1c25.1 26.7 39.1 62 39.1 98.7V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V474.8c0-28.5-10.9-56-30.4-76.8L448 328.3V432v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448 416 192 160 144C64.5 512 0 447.5 0 368V103.3C0 46.2 46.2 0 103.3 0c49 0 88.7 39.7 88.7 88.7V96c0 53-43 96-96 96H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H96c35.3 0 64-28.7 64-64V88.7C160 57.4 134.6 32 103.3 32C63.9 32 32 63.9 32 103.3V368c0 61.9 50.1 112 112 112h16V416zM480 160V144 112c0 20.8-13.2 38.4-31.6 45.1c-4.7 1.7-8.4 5.9-8.4 10.9c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-5-3.7-9.2-8.4-10.9C333.2 150.4 320 132.8 320 112v32 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM336 64s0 0 0 0H464s0 0 0 0c-14.6-19.4-37.8-32-64-32s-49.4 12.6-64 32zm64 208c-56.4 0-103.1-41.7-110.9-96H288c-35.3 0-64-28.7-64-64s28.7-64 64-64h20.1C328.3 19 361.9 0 400 0s71.7 19 91.9 48H512c35.3 0 64 28.7 64 64s-28.7 64-64 64h-1.1c-7.8 54.3-54.4 96-110.9 96zM544 112c0-17.7-14.3-32-32-32h-4.6c3 10.1 4.6 20.9 4.6 32v32c17.7 0 32-14.3 32-32zM288 144V112c0-11.1 1.6-21.9 4.6-32H288c-17.7 0-32 14.3-32 32s14.3 32 32 32zm80-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faRectanglePro = {
  prefix: 'fal',
  iconName: 'rectangle-pro',
  icon: [640, 512, ["pro"], "e235", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64h48c35.3 0 64 28.7 64 64s-28.7 64-64 64H112v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V272 176c0-8.8 7.2-16 16-16zm48 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H112v64h32zm96-80c0-8.8 7.2-16 16-16h48c35.3 0 64 28.7 64 64c0 23.2-12.4 43.6-30.9 54.8l35.7 47.6c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L304 288H272v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V272 176zm32 80h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H272v64zm208-96c44.2 0 80 35.8 80 80v32c0 44.2-35.8 80-80 80s-80-35.8-80-80V240c0-44.2 35.8-80 80-80zm-48 80v32c0 26.5 21.5 48 48 48s48-21.5 48-48V240c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faPro = faRectanglePro;
var faHouseNight = {
  prefix: 'fal',
  iconName: 'house-night',
  icon: [640, 512, [], "e010", "M127 1c-4.9-.7-9.9-1-15-1C50.1 0 0 50.1 0 112s50.1 112 112 112c30.6 0 58.4-12.3 78.6-32.2c.7-.6 1.3-1.3 1.9-2c2.9-3 5.7-6.2 8.2-9.5c2.3-3 4.5-6.2 6.5-9.5c3.9-6.2-3.2-13.3-10.4-12c-2.4 .4-4.9 .8-7.5 .9c-1.8 .1-3.6 .2-5.4 .2c-2.2 0-4.3-.1-6.5-.3c-.4 0-.8-.1-1.2-.1C140.2 155.8 112 125.2 112 88c0-20.8 8.8-39.5 22.9-52.7c.3-.3 .6-.5 .9-.8c2.9-2.7 6.1-5.1 9.4-7.2c2.1-1.4 4.3-2.6 6.6-3.7c6.6-3.3 8-13.2 1.1-15.9c-3.6-1.4-7.2-2.6-10.9-3.6c-4-1.1-8.1-2-12.3-2.7c-.9-.1-1.8-.3-2.7-.4zM80 88c0 43.9 27.1 81.4 65.5 96.7C135.3 189.4 124 192 112 192c-44.2 0-80-35.8-80-80c0-38.4 27.1-70.5 63.3-78.2C85.6 49.5 80 68.1 80 88zM410.4 99.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L224 283.9V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V283.9l37.6 32.2c6.7 5.7 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-224-192zM544 256.5V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V256.5L400 133.1 544 256.5zM336 304v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32zm96 0v64H368V304h64zM256 0c-8.8 0-16 7.2-16 16V48H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V80h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V16c0-8.8-7.2-16-16-16zM96 320c-8.8 0-16 7.2-16 16v32H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H80v32c0 8.8 7.2 16 16 16s16-7.2 16-16V400h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112V336c0-8.8-7.2-16-16-16z"]
};
var faHotTubPerson = {
  prefix: 'fal',
  iconName: 'hot-tub-person',
  icon: [512, 512, ["hot-tub"], "f593", "M240 0c-8.8 0-16 7.2-16 16c0 35.3 17.7 68.3 47.1 87.9l16.1 10.7C307.7 128.4 320 151.4 320 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9L288.8 77.3C268.3 63.6 256 40.6 256 16c0-8.8-7.2-16-16-16zM32 336V320 288H272c.5 0 1 0 1.6-.1c1.3 0 2.5 .1 3.8 .1H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336zm170.7-80H32c0-35.3 28.7-64 64-64c13.8 0 27.3 4.5 38.4 12.8L202.7 256zM0 272v48 16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v16zM384 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3 17.7 68.3 47.1 87.9l16.1 10.7C435.7 128.4 448 151.4 448 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9L416.8 77.3C396.3 63.6 384 40.6 384 16zM112 336c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zM32 64a32 32 0 1 1 64 0A32 32 0 1 1 32 64zm96 0A64 64 0 1 0 0 64a64 64 0 1 0 128 0z"]
};
var faHotTub = faHotTubPerson;
var faBlanket = {
  prefix: 'fal',
  iconName: 'blanket',
  icon: [448, 512, [], "f498", "M32 128V312.4C49 297.2 71.4 288 96 288H392c8.6 0 16.7 1.9 24 5.4V128c0-35.3-28.7-64-64-64H96c-35.3 0-64 28.7-64 64zM0 384V128C0 75 43 32 96 32H352c53 0 96 43 96 96V344c0 30.9-25.1 56-56 56H96c-8.8 0-16-7.2-16-16s7.2-16 16-16H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H96c-35.3 0-64 28.7-64 64s28.7 64 64 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-53 0-96-43-96-96z"]
};
var faMapLocation = {
  prefix: 'fal',
  iconName: 'map-location',
  icon: [576, 512, ["map-marked"], "f59f", "M376 120c0 7.4-2.7 19-9.4 35c-6.5 15.4-15.7 32.4-26.4 49.7c-17.1 27.8-36.9 54.7-52.2 74.4c-15.3-19.7-35.1-46.6-52.2-74.4c-10.7-17.3-19.9-34.3-26.4-49.7c-6.7-15.9-9.4-27.6-9.4-35c0-48.6 39.4-88 88-88s88 39.4 88 88zm32 0C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0C334.9 271.9 408 174.6 408 120zm-4.6 103.6c.9-.2 1.7-.4 2.5-.8L544 167.6V421.2L416 472.4V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V474.8L192 419.9V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V421.2L32 472.4V218.8l115.5-46.2c-3.9-10-7.2-20.4-9.2-30.8L15.1 191.1C6 194.8 0 203.6 0 213.4V484.2c0 17 17.1 28.6 32.9 22.3l144-57.6 218.7 62.5c3.4 1 7 .8 10.3-.5l155-62c9.1-3.6 15.1-12.5 15.1-22.3V155.8c0-17-17.1-28.6-32.9-22.3L425.2 180.7c-6.1 14.2-13.6 28.8-21.8 42.9z"]
};
var faMapMarked = faMapLocation;
var faHouseFloodWater = {
  prefix: 'fal',
  iconName: 'house-flood-water',
  icon: [576, 512, [], "e50e", "M297.1 2.8c-5.5-3.8-12.7-3.8-18.2 0l-208 144c-7.3 5-9.1 15-4 22.3s15 9.1 22.3 4L112 157.3V258.5c7.3 1.9 14.4 5.1 20.9 9.6c3.6 2.5 7.3 4.8 11.1 6.8V135.2L288 35.5l144 99.7V275c3.8-2.1 7.6-4.4 11.2-6.8c6.5-4.5 13.5-7.8 20.8-9.6V157.3l22.9 15.8c7.3 5 17.2 3.2 22.3-4s3.2-17.2-4-22.3l-208-144zM133.8 346.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 368.1 0 374.4 0 382.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 385.9 161.7 400 192 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 385.9 353.7 400 384 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 358 404.9 368 384 368s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 358 212.9 368 192 368s-41.7-9.9-58.2-21.2zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faCommentsQuestionCheck = {
  prefix: 'fal',
  iconName: 'comments-question-check',
  icon: [640, 512, [], "e14f", "M32 176c0-74.8 73.7-144 176-144s176 69.2 176 144s-73.7 144-176 144c-15.3 0-30.6-1.9-46.3-5c-3.5-.7-7.1-.2-10.2 1.4c-6.1 3.1-12 6-18 8.7c-28.4 12.9-60.2 23.1-91.5 26c14.9-19 26.8-39.7 37.6-59.9c3.3-6.1 2.3-13.6-2.5-18.6C50 244.2 32 213.1 32 176zM208 0C93.1 0 0 78.9 0 176c0 44.2 19.8 80.1 46 110c-11.7 21-24 40.6-39.5 57.5l0 0-.1 .1c-6.5 7-8.2 17.1-4.4 25.8C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.9-2.2 9.6-4.5 14.3-6.8c15.3 2.8 30.9 4.6 47 4.6c114.9 0 208-78.9 208-176S322.9 0 208 0zM447.4 160.5C541.6 167 608 233 608 304c0 37.1-18 68.2-45.1 96.6c-4.8 5-5.8 12.5-2.5 18.6c10.9 20.2 22.7 40.8 37.6 59.9c-31.3-3-63.2-13.2-91.5-26c-6-2.7-11.9-5.6-18-8.7c-3.2-1.6-6.8-2.1-10.2-1.4c-15.6 3.1-30.9 5-46.3 5c-68.2 0-123.6-30.7-153.1-73.3c-11 3-22.3 5.2-33.8 6.8C279 439.8 349.9 480 432 480c16.1 0 31.7-1.8 47-4.6c4.6 2.3 9.4 4.6 14.3 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.7 2-18.9-4.4-25.8l-.1-.1 0 0c-15.5-17-27.8-36.5-39.5-57.5c26.2-29.9 46-65.8 46-110c0-94.4-87.8-171.5-198.2-175.8c2.8 10.4 4.7 21.2 5.6 32.3zM539.3 266c-6.2-6.2-16.4-6.2-22.6 0l-74 74-31.4-31.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L431.4 374c6.2 6.2 16.4 6.2 22.6 0l85.3-85.3c6.2-6.2 6.2-16.4 0-22.6zM147.9 104.1l-.3 .9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4h41.3c6.5 0 11.7 5.3 11.7 11.7c0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9v9.5c0 8.8 7.2 16 16 16s16-7.2 16-16v-.3L247.4 160c13.6-7.8 22-22.3 22-37.9c0-24.2-19.6-43.7-43.7-43.7H184.3c-16.4 0-31 10.3-36.4 25.7zM230.7 236a22.7 22.7 0 1 0 -45.3 0 22.7 22.7 0 1 0 45.3 0z"]
};
var faTree = {
  prefix: 'fal',
  iconName: 'tree',
  icon: [448, 512, [127794], "f1bb", "M235.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L72 145.4c-5.1 5.1-8 12.1-8 19.3C64 179.8 76.2 192 91.3 192h17.9L38.7 274.3c-4.3 5-6.7 11.4-6.7 18C32 307.6 44.4 320 59.7 320H77.2L6.7 402.3c-4.3 5-6.7 11.4-6.7 18C0 435.6 12.4 448 27.7 448H160h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h48H420.3c15.3 0 27.7-12.4 27.7-27.7c0-6.6-2.4-13-6.7-18L370.8 320h17.5c15.3 0 27.7-12.4 27.7-27.7c0-6.6-2.4-13-6.7-18L338.8 192h17.9c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3L235.3 4.7zM240 416V208c0-8.8-7.2-16-16-16s-16 7.2-16 16V416H160 37.1l87.1-101.6c4.1-4.7 5-11.4 2.4-17.1s-8.3-9.3-14.5-9.3H69.1l87.1-101.6c4.1-4.7 5-11.4 2.4-17.1s-8.3-9.3-14.5-9.3H102.6L224 38.6 345.4 160H304c-6.2 0-11.9 3.6-14.5 9.3s-1.7 12.4 2.4 17.1L378.9 288H336c-6.2 0-11.9 3.6-14.5 9.3s-1.7 12.4 2.4 17.1L410.9 416H288 240z"]
};
var faArrowsCross = {
  prefix: 'fal',
  iconName: 'arrows-cross',
  icon: [448, 512, [], "e0a2", "M288 32c-8.8 0-16 7.2-16 16s7.2 16 16 16H393.4L4.7 452.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L416 86.6V192c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16H288zM27.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L173.1 227.7l22.6-22.6L27.3 36.7zm225 270.2L393.4 448H288c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16s-16 7.2-16 16V425.4L274.9 284.3l-22.6 22.6z"]
};
var faBackpack = {
  prefix: 'fal',
  iconName: 'backpack',
  icon: [448, 512, [127890], "f5d4", "M192 32h64c8.8 0 16 7.2 16 16V64H176V48c0-8.8 7.2-16 16-16zM144 48V64H128C57.3 64 0 121.3 0 192V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192c0-70.7-57.3-128-128-128H304V48c0-26.5-21.5-48-48-48H192c-26.5 0-48 21.5-48 48zm16 48H288h32c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32H368V368 320c0-35.3-28.7-64-64-64H144c-35.3 0-64 28.7-64 64v48V480H64c-17.7 0-32-14.3-32-32V192c0-53 43-96 96-96h32zM112 480V384H336v96H112zm32-320c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM336 352H112V320c0-17.7 14.3-32 32-32H304c17.7 0 32 14.3 32 32v32z"]
};
var faSquareSmall = {
  prefix: 'fal',
  iconName: 'square-small',
  icon: [320, 512, [], "e27e", "M256 128c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H256zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64z"]
};
var faFolderArrowUp = {
  prefix: 'fal',
  iconName: 'folder-arrow-up',
  icon: [512, 512, ["folder-upload"], "e054", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM272 246.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 246.6V368c0 8.8 7.2 16 16 16s16-7.2 16-16V246.6z"]
};
var faFolderUpload = faFolderArrowUp;
var faBridgeLock = {
  prefix: 'fal',
  iconName: 'bridge-lock',
  icon: [640, 512, [], "e4cc", "M48 32h80H256 384 512h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H528v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H528 512 384 256 128 48c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM320 240c40.6 0 75.4 25.3 89.4 60.9C394 312.6 384 331.2 384 352V336c0-35.3-28.7-64-64-64s-64 28.7-64 64v96c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V336c0-35.3-28.7-64-64-64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H64c53 0 96 43 96 96v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-53 43-96 96-96zM496 64H400v64h96V64zM368 64H272v64h96V64zM240 64H144v64h96V64zM528 224c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H608V352H448z"]
};
var faCrosshairsSimple = {
  prefix: 'fal',
  iconName: 'crosshairs-simple',
  icon: [512, 512, [], "e59f", "M479.4 240H384c-8.8 0-16 7.2-16 16s7.2 16 16 16h95.4C471.6 383 383 471.6 272 479.4V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v95.4C129 471.6 40.4 383 32.6 272H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H32.6C40.4 129 129 40.4 240 32.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V32.6C383 40.4 471.6 129 479.4 240zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z"]
};
var faSackDollar = {
  prefix: 'fal',
  iconName: 'sack-dollar',
  icon: [512, 512, [128176], "f81d", "M201.5 144h109l5.3 3.4C370.6 182.5 480 268.3 480 416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64c0-147.7 109.4-233.5 164.3-268.6l5.3-3.4zm98.4-32H212.1l-6.7-9.8L156.9 32H355.1l-48.4 70.2-6.7 9.8zM152.6 138.5C91.2 183.7 0 273.4 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-142.6-91.2-232.3-152.6-277.5c-9.7-7.1-18.6-13.2-26.4-18.1L351.2 94l38.9-56.4C401 21.7 389.6 0 370.3 0H141.7C122.4 0 111 21.7 121.9 37.6L160.8 94 179 120.4c-7.7 4.9-16.7 11-26.4 18.1zM272 216c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V424c0 8.8 7.2 16 16 16s16-7.2 16-16V406.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V216z"]
};
var faPenToSquare = {
  prefix: 'fal',
  iconName: 'pen-to-square',
  icon: [512, 512, ["edit"], "f044", "M454.6 45.3l12.1 12.1c12.5 12.5 12.5 32.8 0 45.3L440 129.4 382.6 72l26.7-26.7c12.5-12.5 32.8-12.5 45.3 0zM189 265.6l171-171L417.4 152l-171 171c-4.2 4.2-9.6 7.2-15.4 8.6l-65.6 15.1L180.5 281c1.3-5.8 4.3-11.2 8.6-15.4zm197.7-243L166.4 243c-8.5 8.5-14.4 19.2-17.1 30.9l-20.9 90.6c-1.2 5.4 .4 11 4.3 14.9s9.5 5.5 14.9 4.3l90.6-20.9c11.7-2.7 22.4-8.6 30.9-17.1L489.4 125.3c25-25 25-65.5 0-90.5L477.3 22.6c-25-25-65.5-25-90.5 0zM80 64C35.8 64 0 99.8 0 144V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faEdit = faPenToSquare;
var faSquareSliders = {
  prefix: 'fal',
  iconName: 'square-sliders',
  icon: [448, 512, ["sliders-h-square"], "f3f0", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 80c0-8.8 7.2-16 16-16l48 0 0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 40 0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24-48 0c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM96 336c0-8.8 7.2-16 16-16l112 0 0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 40 0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24-112 0c-8.8 0-16-7.2-16-16zm192 0c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16z"]
};
var faSlidersHSquare = faSquareSliders;
var faCarSide = {
  prefix: 'fal',
  iconName: 'car-side',
  icon: [640, 512, [128663], "f5e4", "M171.3 64H224V80v96 16H87.6l39.1-97.8C134.1 75.9 151.7 64 171.3 64zM256 192V176 80 64h97.2c14.6 0 28.4 6.6 37.5 18l88 110H256zm263.9 .2L415.7 62c-15.2-19-38.2-30-62.5-30H171.3c-32.7 0-62.1 19.9-74.3 50.3L52.8 193C22.8 198.3 0 224.5 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-68-53.1-123.7-120.1-127.8zM542 400c-7.1 27.6-32.2 48-62 48s-54.9-20.4-62-48c-1.3-5.1-2-10.5-2-16s.7-10.9 2-16c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48c1.3 5.1 2 10.5 2 16s-.7 10.9-2 16zM385.3 368H254.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H32V256c0-17.7 14.3-32 32-32H512c53 0 96 43 96 96v48H574.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80zM160 448c-29.8 0-54.9-20.4-62-48c-1.3-5.1-2-10.5-2-16s.7-10.9 2-16c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48c1.3 5.1 2 10.5 2 16s-.7 10.9-2 16c-7.1 27.6-32.2 48-62 48z"]
};
var faMessageMiddleTop = {
  prefix: 'fal',
  iconName: 'message-middle-top',
  icon: [512, 512, ["comment-middle-top-alt"], "e1e2", "M343.5 128H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H168.5c9.5 0 18.5-4.2 24.6-11.5L256 41l62.9 75.5C325 123.8 334 128 343.5 128zM268.3 26.3l0 0L256 16l12.3 10.2s0 0 0 0zM168.5 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H343.5L268.3 5.8C265.3 2.1 260.7 0 256 0s-9.3 2.1-12.3 5.8L168.5 96z"]
};
var faCommentMiddleTopAlt = faMessageMiddleTop;
var faLightbulbOn = {
  prefix: 'fal',
  iconName: 'lightbulb-on',
  icon: [640, 512, [], "f672", "M55.2 1.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H560zM119.2 318.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zm416-28.6c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zM464 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.7 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C185.5 234.8 176 206.6 176 176c0-79.5 64.5-144 144-144s144 64.5 144 144zm-224 0c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16zm80 304c-20.9 0-38.7-13.4-45.3-32h90.5c-6.6 18.6-24.4 32-45.3 32zm-80-53.3V432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H250.7c-5.9 0-10.7 4.8-10.7 10.7z"]
};
var faKnife = {
  prefix: 'fal',
  iconName: 'knife',
  icon: [512, 512, ["utensil-knife"], "f2e4", "M448 9.7C453.8 3.5 461.8 0 470.3 0c12.3 0 24.1 7.6 28.2 20.4c5 15.9 13.6 49.2 13.6 91.6c0 49.1-15.6 86.8-42.9 123.7c-22.7 30.6-54 61.2-91 97.4c-6.5 6.4-13.2 12.9-20 19.6l-9.8 9.8c-13.9 13.9-32.7 21.7-52.3 21.7s-38.4-7.8-52.3-21.7l-42-42L27.7 506.9c-6 6.5-16.2 6.8-22.6 .8s-6.8-16.2-.8-22.6L189.6 286.5 448 9.7zM223.5 297.1l42.8 42.8c7.9 7.9 18.5 12.3 29.7 12.3s21.8-4.4 29.7-12.3l9.9-9.9 .1-.1 0 0c7.1-7 13.9-13.7 20.5-20.1c37.2-36.4 66.3-64.9 87.3-93.2C467.4 184.2 480 153 480 112c0-34.9-6.5-63-10.9-78L223.5 297.1z"]
};
var faUtensilKnife = faKnife;
var faShareNodes = {
  prefix: 'fal',
  iconName: 'share-nodes',
  icon: [448, 512, ["share-alt"], "f1e0", "M448 112c0 44.2-35.8 80-80 80c-22.9 0-43.6-9.6-58.1-25l-151 75.5c.8 4.4 1.1 8.9 1.1 13.5s-.4 9.1-1.1 13.5l151 75.5c14.6-15.4 35.2-25 58.1-25c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-9.7 1.7-19 4.9-27.7L147.2 299.5c-14.3 22-39 36.5-67.2 36.5c-44.2 0-80-35.8-80-80s35.8-80 80-80c28.2 0 52.9 14.5 67.2 36.5l145.7-72.9c-3.2-8.6-4.9-17.9-4.9-27.7c0-44.2 35.8-80 80-80s80 35.8 80 80zM80 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM416 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faShareAlt = faShareNodes;
var faDisplayChartUpCircleDollar = {
  prefix: 'fal',
  iconName: 'display-chart-up-circle-dollar',
  icon: [640, 512, [], "e5e6", "M64 32H512c17.7 0 32 14.3 32 32V198.6c11.2 3.2 21.9 7.4 32 12.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H213.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H360h34.8c-12.9-9.1-24.5-19.9-34.6-32H341.1 288 234.9l10.7-64H288h38.6c-2.9-10.3-4.9-21-5.9-32H232.3c-.2 0-.4 0-.6 0H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM480 192.7V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6v48c10.3-2.9 21-4.9 32-5.9zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM472.8 335.4c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
var faWaveSine = {
  prefix: 'fal',
  iconName: 'wave-sine',
  icon: [640, 512, [8767], "f899", "M31.4 244.2l0 0 0 0 0-.1 .1-.3 .4-1.3c.3-1.2 .9-3 1.6-5.2c1.5-4.6 3.7-11.2 6.7-19.1c6-15.9 15.2-37 27.6-58C93.2 117 129.1 80 176 80c36.5 0 61.1 19.2 80.8 52.2c20.2 33.9 33.7 79.7 47.9 128.3l.4 1.3c13.7 47 28.2 96.6 50.7 134.4c23.3 39 56.8 67.8 108.2 67.8c65.1 0 109.2-51 135.8-95.9c13.6-23 23.5-45.9 29.9-63c3.2-8.6 5.6-15.7 7.3-20.8c.8-2.5 1.4-4.5 1.8-5.9c.2-.7 .4-1.2 .5-1.6l.1-.5 0-.1 0 0 0 0s0 0-15.4-4.2l15.4 4.2c2.3-8.5-2.7-17.3-11.2-19.6s-17.3 2.7-19.6 11.2l0 0 0 0 0 .1-.1 .3-.4 1.3c-.3 1.2-.9 3-1.6 5.2c-1.5 4.6-3.7 11.2-6.7 19.1c-6 15.9-15.2 37-27.6 58C546.8 395 510.9 432 464 432c-36.5 0-61.1-19.2-80.8-52.2c-20.2-33.9-33.7-79.7-47.9-128.3l-.4-1.3c-13.7-47-28.2-96.6-50.7-134.4C260.9 76.8 227.5 48 176 48C110.9 48 66.8 99 40.2 143.9c-13.6 23-23.5 45.9-29.9 63C7 215.4 4.6 222.5 3 227.6c-.8 2.5-1.4 4.5-1.8 5.9c-.2 .7-.4 1.2-.5 1.6l-.1 .5 0 .1 0 0 0 0s0 0 15.4 4.2L.6 235.8c-2.3 8.5 2.7 17.3 11.2 19.6s17.3-2.7 19.6-11.2z"]
};
var faHeartCircleMinus = {
  prefix: 'fal',
  iconName: 'heart-circle-minus',
  icon: [576, 512, [], "e4ff", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faCircleW = {
  prefix: 'fal',
  iconName: 'circle-w',
  icon: [512, 512, [], "e12c", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 170.8c-2.9-8.4-12-12.8-20.4-9.9s-12.8 12-9.9 20.4l72 208c2.3 6.5 8.4 10.8 15.3 10.8s13-4.6 15.1-11.1L256 236.5l48.8 152.4c2.1 6.6 8.2 11 15.1 11.1s13.1-4.3 15.3-10.8l72-208c2.9-8.4-1.5-17.5-9.9-20.4s-17.5 1.5-20.4 9.9L320.6 333.4 271.2 179.1C269.1 172.5 263 168 256 168s-13.1 4.5-15.2 11.1L191.4 333.4 135.1 170.8z"]
};
var faCircleCalendar = {
  prefix: 'fal',
  iconName: 'circle-calendar',
  icon: [512, 512, ["calendar-circle"], "e102", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 96c8.8 0 16 7.2 16 16v16h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c26.5 0 48 21.5 48 48v16 32V336c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V224 192 176c0-26.5 21.5-48 48-48h16V112c0-8.8 7.2-16 16-16zm-48 80v16H352V176c0-8.8-7.2-16-16-16H304 208 176c-8.8 0-16 7.2-16 16zm192 48H160V336c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16V224z"]
};
var faCalendarCircle = faCircleCalendar;
var faHourglassHalf = {
  prefix: 'fal',
  iconName: 'hourglass-half',
  icon: [384, 512, ["hourglass-2"], "f252", "M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16H32l0-44.7c0-31.6 10.4-62.4 29.6-87.5L131.9 256 61.6 164.1C42.4 139 32 108.3 32 76.7V32H16C7.2 32 0 24.8 0 16S7.2 0 16 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H352V76.7c0 31.6-10.4 62.4-29.6 87.5L252.1 256l70.2 91.9C341.6 373 352 403.7 352 435.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H16zm304-32V435.3c0-24.6-8.1-48.5-23-68L219.3 265.7c-4.4-5.7-4.4-13.7 0-19.4L297 144.7c14.9-19.5 23-43.4 23-68V32H64l0 44.7c0 24.6 8.1 48.5 23 68l77.7 101.6c4.4 5.7 4.4 13.7 0 19.4L87 367.3c-14.9 19.5-23 43.4-23 68L64 480H320zM192 208c-4.9 0-9.5-2.2-12.5-6l-64-80c-3.8-4.8-4.6-11.4-1.9-16.9s8.3-9.1 14.4-9.1h64 64c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9l-64 80c-3 3.8-7.6 6-12.5 6zm-30.7-80L192 166.4 222.7 128H192 161.3zM144 352h96c6.1 0 11.6 3.4 14.3 8.8l32 64c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6H192 112c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l32-64c2.7-5.4 8.3-8.8 14.3-8.8zm-6.1 64H192h54.1l-16-32H153.9l-16 32z"]
};
var faHourglass2 = faHourglassHalf;
var faMicroscope = {
  prefix: 'fal',
  iconName: 'microscope',
  icon: [512, 512, [128300], "f610", "M192 0c-17.7 0-32 14.3-32 32c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V160c88.4 0 160 71.6 160 160s-71.6 160-160 160H208 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H208h80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H394.2c51.7-34.4 85.8-93.2 85.8-160c0-106-86-192-192-192V64c0-17.7-14.3-32-32-32c0-17.7-14.3-32-32-32H192zm0 32h32V48c0 8.8 7.2 16 16 16h16V288H160V64h16c8.8 0 16-7.2 16-16V32zM160 368c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM96 432c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"]
};
var faSunset = {
  prefix: 'fal',
  iconName: 'sunset',
  icon: [576, 512, [127751], "f767", "M299.3 219.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 169.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16V169.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zm94.2 5.9c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L500.9 448H462.1l38.7-56.2-94.5-17.4c-6.5-1.2-11.6-6.3-12.8-12.8l-17.4-94.5-79.1 54.5c-5.5 3.8-12.7 3.8-18.2 0l-79.1-54.5-17.4 94.5c-1.2 6.5-6.3 11.6-12.8 12.8L75.2 391.8 113.9 448H75.1L34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM412 448H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H164c14.2-55.2 64.3-96 124-96s109.8 40.8 124 96zM16 480H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSink = {
  prefix: 'fal',
  iconName: 'sink',
  icon: [512, 512, [], "e06d", "M272 80c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-44.2-35.8-80-80-80s-80 35.8-80 80V288H160V272c0-26.5-21.5-48-48-48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16 7.2 16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H144 256 368 496c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V272c0-8.8 7.2-16 16-16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H400c-26.5 0-48 21.5-48 48v16H272V80zM32 352v48c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112V352H448v48c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V352H32z"]
};
var faCalendarExclamation = {
  prefix: 'fal',
  iconName: 'calendar-exclamation',
  icon: [448, 512, [], "f334", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H32V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32zM200 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm40-160v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTruckContainerEmpty = {
  prefix: 'fal',
  iconName: 'truck-container-empty',
  icon: [640, 512, [], "e2b5", "M448 160c0-17.7 14.3-32 32-32h56c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8V256v48 56c0 19.4-13.7 35.5-32 39.2l0 .8c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48H448V256 240 224 160zm144 64l-43.2-57.6c-3-4-7.8-6.4-12.8-6.4H480v64H592zm16 32H480v80c13.4-10 30-16 48-16c32.8 0 60.9 19.7 73.3 47.9c3.8-.6 6.7-3.9 6.7-7.9V304 256zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faHandHeart = {
  prefix: 'fal',
  iconName: 'hand-heart',
  icon: [512, 512, [], "f4bc", "M210.7 38.8C218 16.3 239.1 0 264 0s46 16.3 53.3 38.8c7.9-4.3 17-6.8 26.7-6.8c30.9 0 56 25.1 56 56v13.4c7.3-3.5 15.4-5.4 24-5.4c30.9 0 56 25.1 56 56V336c0 97.2-78.8 176-176 176h-8.5c-65.8 0-128.9-26.1-175.4-72.6L16.4 335.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0L128 288.8V88c0-30.9 25.1-56 56-56c9.7 0 18.8 2.5 26.7 6.8zM208 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V327.4c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L73 279c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L142.8 416.7c40.5 40.5 95.4 63.3 152.7 63.3H304c79.5 0 144-64.5 144-144V152c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V152.1l0-.1V88c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V88.1l0-.1 0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24V79.9l0 .1V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V88.1l0-.1zm13.7 250.8c0 5.8 2.3 11.4 6.5 15.4L288 412.4l59.8-58.1c4.2-4 6.5-9.6 6.5-15.4c0-11.9-9.6-21.5-21.5-21.5h-1.5c-6 0-11.7 2.3-16 6.5l-16.1 15.6c-6.2 6-16.1 6-22.3 0l-16.1-15.6c-4.3-4.2-10.1-6.5-16-6.5h-1.5c-11.9 0-21.5 9.6-21.5 21.5zm21.5-53.5h1.5c14.3 0 28.1 5.6 38.4 15.6l4.9 4.8 4.9-4.8c10.3-10 24-15.6 38.4-15.6h1.5c29.5 0 53.5 23.9 53.5 53.5c0 14.4-5.8 28.3-16.2 38.4l-70.9 69c-6.2 6-16.1 6-22.3 0l-70.9-69c-10.4-10.1-16.2-23.9-16.2-38.4c0-29.5 23.9-53.5 53.5-53.5z"]
};
var faBagShopping = {
  prefix: 'fal',
  iconName: 'bag-shopping',
  icon: [448, 512, ["shopping-bag"], "f290", "M160 96v32H288V96c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 64H48c-8.8 0-16 7.2-16 16V416c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V176c0-8.8-7.2-16-16-16H320v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H160v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160zm0-32V96c0-53 43-96 96-96s96 43 96 96v32h80c26.5 0 48 21.5 48 48V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V176c0-26.5 21.5-48 48-48h80z"]
};
var faShoppingBag = faBagShopping;
var faArrowDownZA = {
  prefix: 'fal',
  iconName: 'arrow-down-z-a',
  icon: [576, 512, ["sort-alpha-desc", "sort-alpha-down-alt"], "f881", "M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 32H480c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L385.3 192H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9L446.7 64H352c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 256c6.1 0 11.6 3.4 14.3 8.8l63.9 127.7c.1 .2 .2 .4 .3 .6l15.8 31.7c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L470.1 448H361.9l-11.6 23.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l15.8-31.7c.1-.2 .2-.4 .3-.6l63.9-127.7c2.7-5.4 8.2-8.8 14.3-8.8zM377.9 416h76.2L416 339.8 377.9 416z"]
};
var faSortAlphaDesc = faArrowDownZA;
var faSortAlphaDownAlt = faArrowDownZA;
var faMitten = {
  prefix: 'fal',
  iconName: 'mitten',
  icon: [448, 512, [], "f7b5", "M0 144.2C0 64.6 65.1 0 144.6 0C208 0 264.4 41.5 282.8 102.3l24.6 81.3c15.3-15 36-23.6 57.9-23.6h1.8c44.7 0 80.9 36.2 80.9 80.9c0 18.6-6.4 36.6-18.1 51l-61.8 76H328c.6-1.7 1.5-3.3 2.6-4.7L405 271.8c7.1-8.7 11-19.6 11-30.9c0-27-21.9-48.9-48.9-48.9h-1.8c-17.6 0-34 9.1-43.2 24.1l-7 11.4c-3.3 5.4-9.4 8.3-15.7 7.5s-11.4-5.2-13.3-11.2L252.2 111.6C237.9 64.4 194 32 144.6 32C82.6 32 32 82.4 32 144.2c0 9.2 1.1 18.3 3.3 27.2L84.5 368h-33L4.3 179.2C1.4 167.7 0 156 0 144.2zM64 432l0 48H352V432H64zm-32 0c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432z"]
};
var faReplyClock = {
  prefix: 'fal',
  iconName: 'reply-clock',
  icon: [640, 512, ["reply-time"], "e239", "M496 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256A144 144 0 1 0 496 0a144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V80c0-8.8-7.2-16-16-16zm16 272c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6c-5.7 0-11.4-.3-17-.8c.6 5.5 1 11.1 1 16.8c0 46.1-15.9 79.7-34 103.2c1.3-7.1 2-14.8 2-23.2c0-70.7-57.3-128-128-128H224h-8c-13.3 0-24 10.7-24 24v8 16l0 48L32 240 192 96v48 16 8c0 13.3 10.7 24 24 24h8H326.6c-2.9-10.3-4.9-21-5.9-32H256 224V144 128 96c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 222.3 0 230.9 0 240s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V352 336 320h32 64c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C430.5 499.9 512 449.3 512 336z"]
};
var faReplyTime = faReplyClock;
var faPersonRays = {
  prefix: 'fal',
  iconName: 'person-rays',
  icon: [512, 512, [], "e54d", "M4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0zm502.6 0c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zM27.3 507.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm480 0c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM232 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 200 56a56 56 0 1 0 112 0zM243.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H224V164c6-2.6 12.5-4 19.3-4zM224 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L339.3 170.3c-13.9-26-41-42.3-70.6-42.3H243.3c-29.5 0-56.7 16.3-70.6 42.3L113.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L192 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faRight = {
  prefix: 'fal',
  iconName: 'right',
  icon: [448, 512, [11157, "arrow-alt-right"], "f356", "M416 253.7l0 4.6c0 4.4-1.8 8.6-5 11.6L261.2 412.5c-2.3 2.2-5.4 3.5-8.7 3.5c-6.9 0-12.6-5.6-12.6-12.6l0-83.4c0-8.8-7.2-16-16-16L48 304c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l176 0c8.8 0 16-7.2 16-16l0-83.4c0-6.9 5.6-12.6 12.6-12.6c3.2 0 6.3 1.2 8.7 3.5L411 242.1c3.2 3 5 7.2 5 11.6zM252.6 448c11.4 0 22.5-4.4 30.7-12.3L433.1 293c9.5-9.1 14.9-21.6 14.9-34.8l0-4.6c0-13.1-5.4-25.7-14.9-34.8L283.3 76.3C275 68.4 264 64 252.6 64C228 64 208 84 208 108.6l0 67.4L48 176c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0 0 67.4c0 24.6 20 44.6 44.6 44.6z"]
};
var faArrowAltRight = faRight;
var faCircleF = {
  prefix: 'fal',
  iconName: 'circle-f',
  icon: [512, 512, [], "e10e", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 128c-17.7 0-32 14.3-32 32v96V368c0 8.8 7.2 16 16 16s16-7.2 16-16V272H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V160H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H192z"]
};
var faUsers = {
  prefix: 'fal',
  iconName: 'users',
  icon: [640, 512, [], "f0c0", "M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64H378.7c54.2 0 98.4 42.5 101.2 96H160.1c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112H444c2.6 10.2 4 21 4 32h80zm-336 0c0-11 1.4-21.8 4-32H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80z"]
};
var faFacePleading = {
  prefix: 'fal',
  iconName: 'face-pleading',
  icon: [512, 512, [], "e386", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280.1 410.7c-4.7-5.3-12.7-10.7-24.1-10.7s-19.4 5.4-24.1 10.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c9.2-10.2 25.2-21.3 47.9-21.3s38.7 11.1 47.9 21.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM331.6 96.6c8.5-2.4 17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8zM191.4 116.4l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18 6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8zM160 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm240-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-272 0c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z"]
};
var faEyeSlash = {
  prefix: 'fal',
  iconName: 'eye-slash',
  icon: [640, 512, [], "f070", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM605.5 268.3c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-51.2 0-96 14.8-133.9 36.8l27.3 21.5C244.6 74.2 280.2 64 320 64c70.4 0 127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-9.2 22.1-25.9 52-49.5 81.5l25.1 19.8c25.6-32 43.7-64.4 53.9-89zM88.4 154.7c-25.6 32-43.7 64.4-53.9 89c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c51.2 0 96-14.8 133.9-36.8l-27.3-21.5C395.4 437.8 359.8 448 320 448c-70.4 0-127.7-32-170.8-72C106.1 336 77.3 288 64 256c9.2-22.1 25.9-52 49.5-81.5L88.4 154.7zM320 384c16.7 0 32.7-3.2 47.4-9.1l-30.9-24.4c-5.4 .9-10.9 1.4-16.5 1.4c-51 0-92.8-39.8-95.8-90.1l-30.9-24.4c-.9 6-1.3 12.2-1.3 18.5c0 70.7 57.3 128 128 128zM448 256c0-70.7-57.3-128-128-128c-16.7 0-32.7 3.2-47.4 9.1l30.9 24.4c5.4-.9 10.9-1.4 16.5-1.4c51 0 92.8 39.8 95.8 90.1l30.9 24.4c.9-6 1.3-12.2 1.3-18.5z"]
};
var faFlaskVial = {
  prefix: 'fal',
  iconName: 'flask-vial',
  icon: [640, 512, [], "e4f3", "M224 32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H224 192 64 32 16C7.2 0 0 7.2 0 16s7.2 16 16 16H32V352c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5c0-14.2 3-28.3 8.8-41.2C157.7 410.5 143.5 416 128 416c-35.3 0-64-28.7-64-64V192H192V352c0 4-.4 7.8-1 11.6l33-53.7V32zM64 32H192V160H64V32zM304 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V219.5L201.8 411.6c-6.4 10.4-9.8 22.3-9.8 34.5c0 36.4 29.5 65.9 65.9 65.9H574.1c36.4 0 65.9-29.5 65.9-65.9c0-12.2-3.4-24.1-9.8-34.5L512 219.5V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zM480 32V224c0 3 .8 5.9 2.4 8.4L536.3 320H295.7l53.9-87.6c1.6-2.5 2.4-5.4 2.4-8.4V32H480zM229 428.4L276 352H556l47 76.4c3.3 5.3 5 11.5 5 17.8c0 18.7-15.2 33.9-33.9 33.9H257.9c-18.7 0-33.9-15.2-33.9-33.9c0-6.3 1.7-12.4 5-17.8z"]
};
var faPoliceBox = {
  prefix: 'fal',
  iconName: 'police-box',
  icon: [384, 512, [], "e021", "M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96C78.3 32 64 46.3 64 64v.8C45.7 68.5 32 84.6 32 104V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H352V104c0-19.4-13.7-35.5-32-39.2V64c0-17.7-14.3-32-32-32H208V16zm112 88V480H64V104c0-4.4 3.6-8 8-8h8c8.8 0 16-7.2 16-16V64h96 96V80c0 8.8 7.2 16 16 16h8c4.4 0 8 3.6 8 8zM112 328V280h48v48H112zM88 272v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zm24-120h20v20H112V152zm28 0h20v20H140V152zm0 28h20v20H140V180zm-8 20H112V180h20v20zm-28-72c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H104zm120 72V180h20v20H224zm28 0V180h20v20H252zm0-28V152h20v20H252zm-8-20v20H224V152h20zm-44-8v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16z"]
};
var faCucumber = {
  prefix: 'fal',
  iconName: 'cucumber',
  icon: [512, 512, [129362], "e401", "M195.9 451.9l256-256c37.5-37.5 37.5-98.3 0-135.8s-98.3-37.5-135.8 0l-256 256c-37.5 37.5-37.5 98.3 0 135.8s98.3 37.5 135.8 0zm21.8 23.4c-50 49.2-130.5 48.9-180.2-.8c-50-50-50-131 0-181l95.2-95.2c-7-9.4-6.2-22.7 2.3-31.2s21.9-9.3 31.2-2.3L293.5 37.5c50-50 131-50 181 0c49.7 49.7 50 130.2 .8 180.2c7 9.4 6.2 22.7-2.3 31.3s-21.8 9.3-31.2 2.3L251.3 441.7c7 9.4 6.2 22.7-2.3 31.2s-21.9 9.3-31.3 2.3zM128 308a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zm204-84a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm12-108a20 20 0 1 1 40 0 20 20 0 1 1 -40 0z"]
};
var faHeadSideBrain = {
  prefix: 'fal',
  iconName: 'head-side-brain',
  icon: [512, 512, [], "f808", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm171.1-99.8c4.1-7.3 12-12.2 20.9-12.2s16.8 4.9 20.9 12.2c4.3 7.6 13.9 10.4 21.6 6.2c2.8-1.5 6-2.4 9.5-2.4c7 0 13.2 3.6 16.8 9.1c3.4 5.2 9.5 8 15.7 7.1c1.1-.2 2.3-.3 3.5-.3c13.3 0 24 10.7 24 24s-10.7 24-24 24H268.7c-5.4 0-10.4 2.7-13.4 7.2s-3.4 10.2-1.3 15.2c1.3 2.9 2 6.2 2 9.6c0 11.6-8.2 21.3-19.2 23.5c-8.7 1.8-14.3 10.2-12.5 18.9s10.2 14.3 18.9 12.5c25.6-5.2 44.8-27.8 44.8-54.9h24c30.9 0 56-25.1 56-56c0-30.4-24.2-55.2-54.5-56c-9.5-9.9-22.8-16-37.5-16c-4 0-7.8 .4-11.5 1.3C254.3 86.6 239.9 80 224 80s-30.3 6.6-40.5 17.3C179.8 96.4 176 96 172 96c-22.2 0-41.1 13.9-48.6 33.4C98.6 135.1 80 157.4 80 184c0 19.2 9.7 36.1 24.3 46.2c3.1 28 26.8 49.8 55.7 49.8v24c0 8.8 7.2 16 16 16s16-7.2 16-16V260.7c0-5.4-2.7-10.4-7.2-13.4s-10.2-3.4-15.2-1.3c-2.9 1.3-6.2 2-9.6 2c-13.3 0-24-10.7-24-24c0-.7 0-1.3 .1-2c.6-6.8-3.3-13.3-9.6-16c-8.6-3.7-14.5-12.2-14.5-22c0-13.3 10.7-24 24-24l.2 0c8.2 0 15-6.1 15.9-14.2c1.1-10 9.6-17.8 19.9-17.8c3.5 0 6.7 .9 9.5 2.4c7.7 4.2 17.3 1.4 21.6-6.2z"]
};
var faHand = {
  prefix: 'fal',
  iconName: 'hand',
  icon: [512, 512, [129306, 9995, "hand-paper"], "f256", "M264 0c-24.9 0-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8c-30.9 0-56 25.1-56 56V288.8L95.6 256.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2L120.2 439.4C166.7 485.9 229.8 512 295.5 512H304c97.2 0 176-78.8 176-176V152c0-30.9-25.1-56-56-56c-8.6 0-16.7 1.9-24 5.4V88c0-30.9-25.1-56-56-56c-9.7 0-18.8 2.5-26.7 6.8C310 16.3 288.9 0 264 0zM184 64c13.3 0 24 10.7 24 24l0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V80l0-.1V56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V87.9C320 74.7 330.8 64 344 64c13.3 0 24 10.7 24 24v64c0 0 0 0 0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V151.9c0-13.2 10.8-23.9 24-23.9c13.3 0 24 10.7 24 24V336c0 79.5-64.5 144-144 144h-8.5c-57.3 0-112.2-22.8-152.7-63.3L39 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V88c0-13.3 10.7-24 24-24z"]
};
var faHandPaper = faHand;
var faPersonBikingMountain = {
  prefix: 'fal',
  iconName: 'person-biking-mountain',
  icon: [640, 512, [128693, "biking-mountain"], "f84b", "M416 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 336 56zM130 272c-3.9 0-7.1 2.7-7.8 6.4c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8V370c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4H130zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5h12c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5H130c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6C9.2 411.5 0 397.8 0 382V370c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zM189.5 376a53.5 53.5 0 1 1 -107 0 53.5 53.5 0 1 1 107 0zM498 272c-3.9 0-7.1 2.7-7.8 6.4c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8V370c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4H498zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5h12c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5H498c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6c-13.3-6.5-22.5-20.1-22.5-36V370c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zM557.5 376a53.5 53.5 0 1 1 -107 0 53.5 53.5 0 1 1 107 0zM330.2 166.7c-6-5.4-15-5.5-21.1-.3L250 217.1c-8 6.8-7.3 19.4 1.3 25.3l93.7 64.4c4.3 3 6.9 7.9 6.9 13.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V328.4l-86.8-59.7c-26-17.9-28-55.5-4-76l59.1-50.6c18.3-15.7 45.4-15.4 63.3 .8L406.1 192H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-4 0-7.8-1.5-10.7-4.1l-59.1-53.2zM169.3 166l69.9-63.1-3.7-3.5c-11.8-11-29.9-11.6-42.3-1.3l-49.6 41.2L169.3 166zm104.3-51l-94.4 85.2c-6.4 5.8-16.3 5.4-22.3-.8l-48.3-50.3c-6.4-6.7-5.8-17.5 1.3-23.4l62.8-52.2c24.8-20.6 61.1-19.5 84.7 2.6l16.4 15.4c6.8 6.4 6.7 17.3-.2 23.5z"]
};
var faBikingMountain = faPersonBikingMountain;
var faUtensilsSlash = {
  prefix: 'fal',
  iconName: 'utensils-slash',
  icon: [640, 512, [], "e464", "M151.8 18.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-.5 3L148.4 39l3.4-20.3zM197 77.3l3-60.5C200.4 8 193.6 .5 184.8 0S168.5 6.4 168 15.2L166.1 53 197 77.3zm56.4 44.5L248 15.2C247.5 6.4 240-.4 231.2 0s-15.6 8-15.2 16.8L220 95.5l33.4 26.3zM129.3 187L96.1 160.8c-.1 1.5-.1 3-.1 4.5V176c0 44.2 35.8 80 80 80h16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V261.8L176.2 224H176c-22.7 0-41.8-15.8-46.7-37zM320 174.5v-9.2c0-4.4-.4-8.8-1.1-13.2L295.8 13.4c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4l21.5 128.7L320 174.5zM544 351.3V336 320 32c0-17.7-14.3-32-32-32C496 0 384 32 384 176v49l32 25.3V176c0-62.5 23.8-97.7 47-117.8c12-10.4 24.4-17.2 34.5-21.3c7.6-3.1 12.6-4.2 14.3-4.6l.2-.1V320h-7.6L544 351.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faPrintMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'print-magnifying-glass',
  icon: [640, 512, ["print-search"], "f81a", "M160 160V64c0-17.7 14.3-32 32-32H421.5c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c6 6 9.4 14.1 9.4 22.6V160h32V90.5c0-17-6.7-33.3-18.7-45.3L466.7 18.7C454.7 6.7 438.5 0 421.5 0H192c-35.3 0-64 28.7-64 64v96h32zm-32 64H320c9.1-12.1 19.9-22.9 32-32H128c-35.3 0-64 28.7-64 64V384c0 17.7 14.3 32 32 32h32v64c0 17.7 14.3 32 32 32H480c15.8 0 29-11.5 31.6-26.6L498.2 472c-5.9 1.9-12 3.6-18.2 4.8V480H448 160l0-128H291.2c-2.1-10.3-3.2-21-3.2-32H160c-17.7 0-32 14.3-32 32v32H96V256c0-17.7 14.3-32 32-32zm320 .1a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9l86.2 86.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-86.2-86.2C566 377 576 349.7 576 320.2c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
var faPrintSearch = faPrintMagnifyingGlass;
var faFolderBookmark = {
  prefix: 'fal',
  iconName: 'folder-bookmark',
  icon: [512, 512, [], "e186", "M32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H416V304c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7L336 289.9l-56.8 28.4c-5 2.5-10.9 2.2-15.6-.7s-7.6-8.1-7.6-13.6V117c-3.3-2.3-6.5-4.8-9.4-7.7L210.7 73.4c-6-6-14.1-9.4-22.6-9.4H64C46.3 64 32 78.3 32 96zm352 32H291.9c-1.3 0-2.6 0-3.9-.1V278.1l40.8-20.4c4.5-2.3 9.8-2.3 14.3 0L384 278.1V128zm16-32h48c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H188.1c17 0 33.3 6.7 45.3 18.7l35.9 35.9c6 6 14.1 9.4 22.6 9.4H400z"]
};
var faOm = {
  prefix: 'fal',
  iconName: 'om',
  icon: [512, 512, [128329], "f679", "M321.4 33.4l24-24c12.5-12.5 32.8-12.5 45.3 0l24 24c12.5 12.5 12.5 32.8 0 45.3l-24 24c-12.5 12.5-32.8 12.5-45.3 0l-24-24c-12.5-12.5-12.5-32.8 0-45.3zM368 80l1.4-1.4 21.3-21.3L392 56l-1.4-1.4L369.4 33.4 368 32l-1.4 1.4L345.4 54.6 344 56l1.4 1.4 21.3 21.3L368 80zM144 128c-20.9 0-39.5 10-51.2 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4C84.7 111.1 112.6 96 144 96c53 0 96 43 96 96c0 24.6-9.2 47-24.4 64h43.5c25.4 0 50.1-8.7 70-24.5l22.2-17.8c17.5-14 39.3-21.7 61.8-21.7c54.6 0 98.9 44.3 98.9 98.9v94c0 52.5-42.6 95.1-95.1 95.1c-36 0-69-20.4-85.1-52.6l-10.1-20.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l10.1 20.3C371.1 434.5 393 448 416.9 448c34.9 0 63.1-28.3 63.1-63.1v-94c0-37-30-66.9-66.9-66.9c-15.2 0-29.9 5.2-41.8 14.7l-22.2 17.8c-25.5 20.4-57.3 31.6-90 31.6H244.7c26.6 23.5 43.3 57.8 43.3 96c0 70.7-57.3 128-128 128H144C64.5 512 0 447.5 0 368c0-8.8 7.2-16 16-16s16 7.2 16 16c0 61.9 50.1 112 112 112h16c53 0 96-43 96-96s-43-96-96-96H144c-8.8 0-16-7.2-16-16s7.2-16 16-16c35.3 0 64-28.7 64-64s-28.7-64-64-64zm154.4-12.2c.7 .5 1.9 1.3 3.6 2.3c3.2 1.9 8.1 4.6 14.4 7.3c12.6 5.4 30.4 10.7 51.7 10.7s39.1-5.3 51.7-10.7c6.3-2.7 11.1-5.3 14.4-7.3c1.6-1 2.8-1.7 3.6-2.3c.4-.3 .6-.4 .8-.5l.1-.1h0l0 0 0 0-140.9 0 141 0c7.1-5.2 17.1-3.8 22.3 3.3c5.3 7.1 3.8 17.1-3.2 22.4L448 128c9.6 12.8 9.6 12.8 9.6 12.8l0 0 0 0-.1 0-.1 .1-.4 .3c-.3 .2-.8 .6-1.4 1c-1.2 .8-2.9 1.9-5 3.2c-4.3 2.6-10.4 5.9-18.2 9.2C416.8 161.3 394.6 168 368 168s-48.8-6.7-64.2-13.3c-7.8-3.3-13.9-6.7-18.2-9.2c-2.1-1.3-3.8-2.4-5-3.2c-.6-.4-1.1-.7-1.4-1l-.4-.3-.1-.1-.1 0 0 0 0 0s0 0 9.6-12.8l-9.6 12.8c-7.1-5.3-8.5-15.3-3.2-22.4c5.3-7.1 15.3-8.5 22.3-3.3l0 0s0 0 0 0l0 0 .1 .1c.1 .1 .4 .3 .8 .5z"]
};
var faPi = {
  prefix: 'fal',
  iconName: 'pi',
  icon: [448, 512, [], "f67e", "M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H128V251c0 61.8-21 121.7-59.6 169.9l-.9 1.1c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l.9-1.1C136.5 387 160 320 160 251V96H320V382.6c0 36.1 29.3 65.4 65.4 65.4c24.8 0 47.4-14 58.5-36.2l2.3-4.7c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-2.3 4.7c-5.7 11.3-17.2 18.5-29.9 18.5C367 416 352 401 352 382.6V96h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faFlaskRoundPotion = {
  prefix: 'fal',
  iconName: 'flask-round-potion',
  icon: [448, 512, ["flask-potion"], "f6e1", "M160 32H288V157.7c0 18.2 10.1 33.7 24.4 42C364.8 230.3 400 287 400 351.9c-55.6-1.3-87.4-15.5-115.7-30.1c-2.9-1.5-5.7-3-8.6-4.5C248.3 302.9 220 288 176 288c-47 0-83.5 12.8-108.4 25.8c-6.6 3.5-12.4 6.9-17.4 10.2c8.5-53 40.6-98.1 85.4-124.2c14.3-8.3 24.4-23.9 24.4-42V32zM397.1 383.8c-6.3 34.7-22.8 65.8-46.3 90.2c-3.1 3.2-8.8 5.9-17 5.9H114.2c-8.2 0-13.9-2.7-17-5.9c-27.6-28.6-45.5-66.5-48.7-108.5c1-.6 1.9-1.4 2.8-2.2l0 0 0 0 .2-.2c.3-.2 .7-.6 1.3-1.2c1.2-1.1 3.2-2.7 5.8-4.7c5.2-4 13.2-9.5 23.8-15C103.5 331.2 135 320 176 320c35.8 0 57.7 11.4 85.1 25.8c2.8 1.4 5.6 2.9 8.5 4.4c30.6 15.8 66.7 31.9 127.5 33.6zM51.3 363.4l0 0 0 0c0 0 0 0 0 0zm0 0l0 0s0 0 0 0zM320 157.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304 144 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V157.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4z"]
};
var faFlaskPotion = faFlaskRoundPotion;
var faFaceShush = {
  prefix: 'fal',
  iconName: 'face-shush',
  icon: [512, 512, [], "e38c", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 45.8-13.7 88.4-37.3 123.9c-4.9 7.4-2.9 17.3 4.5 22.2s17.3 2.9 22.2-4.5C496.3 357 512 308.3 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 83.8 40.2 158.1 102.4 204.8c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4C67.2 394.3 32 329.3 32 256zM200.4 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm160 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM164.7 228.7c-6.2 6.2-6.2 16.4 0 22.6c10.3 10.3 24.7 20.8 43.3 28v28.4c-32.5 10.2-56 40.5-56 76.3v48c0 44.2 35.8 80 80 80h56 1.5c28.5 0 55.5-12.7 73.7-34.5l25.6-30.7c17-20.4 14.2-50.6-6.1-67.6c-11.6-9.7-26.4-12.9-40.1-10.2c-4.4-23.2-18.8-42.8-38.6-54.2V279.3c18.6-7.2 33.1-17.7 43.3-28c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-5.3 5.3-12.2 10.8-20.7 15.4V240c0-26.5-21.5-48-48-48s-48 21.5-48 48v4.1c-8.5-4.7-15.4-10.1-20.7-15.4c-6.2-6.2-16.4-6.2-22.6 0zM256 224c8.8 0 16 7.2 16 16v64H240V240c0-8.8 7.2-16 16-16zM217.2 378l76.7 69.7c7.9-1.1 15.1-5 20.2-11.2l25.6-30.7c5.7-6.8 15.7-7.7 22.5-2s7.7 15.7 2 22.5L338.7 457c-12.2 14.6-30.2 23-49.2 23H288 232c-26.5 0-48-21.5-48-48V384c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-8.8-7.2-16-16-16H232c-6.7 0-12.5 4.1-14.8 10z"]
};
var faWorm = {
  prefix: 'fal',
  iconName: 'worm',
  icon: [512, 512, [], "e599", "M432 192V164.2l-27.5-3.9-31.1-4.4c-30.7-4.4-53.4-30.6-53.4-61.6C320 59.9 347.9 32 382.3 32h40.1C454.2 32 480 57.8 480 89.6V160v48V356c0 68.5-55.5 124-124 124s-124-55.5-124-124V320c0-44.2-35.8-80-80-80c-39.8 0-72 32.2-72 72V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-66.3 53.7-120 120-120c70.7 0 128 57.3 128 128v36c0 42 34 76 76 76s76-34 76-76V192zM382.3 0C330.2 0 288 42.2 288 94.3c0 46.9 34.5 86.7 80.9 93.3L400 192V356c0 24.3-19.7 44-44 44s-44-19.7-44-44V320c0-88.4-71.6-160-160-160C68.1 160 0 228.1 0 312V456c0 30.9 25.1 56 56 56s56-25.1 56-56V312c0-22.1 17.9-40 40-40c26.5 0 48 21.5 48 48v36c0 86.2 69.8 156 156 156s156-69.8 156-156V208 160 89.6C512 40.1 471.9 0 422.4 0H382.3zM408 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHouseCircleXmark = {
  prefix: 'fal',
  iconName: 'house-circle-xmark',
  icon: [640, 512, [], "e50b", "M277.4 4c6-5.3 15.1-5.3 21.2 0L512.5 192.8c-5.4-.5-10.9-.8-16.5-.8c-10.2 0-20.2 .9-29.9 2.5L288 37.3 96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c1 0 2.1 .1 3.1 .1c-5.1 10.1-9.3 20.7-12.5 31.9H240V480h16 80 24.2c10 12.1 21.7 22.9 34.6 32H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
var faPlug = {
  prefix: 'fal',
  iconName: 'plug',
  icon: [384, 512, [128268], "f1e6", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c80.9-8 144-76.2 144-159.2V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM192 368c-70.7 0-128-57.3-128-128V176H320v64c0 70.7-57.3 128-128 128z"]
};
var faCalendarCircleExclamation = {
  prefix: 'fal',
  iconName: 'calendar-circle-exclamation',
  icon: [576, 512, [], "e46e", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192H352h64 16 16V160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faSquareI = {
  prefix: 'fal',
  iconName: 'square-i',
  icon: [448, 512, [], "e272", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32h80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16H240V352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V160H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faChevronUp = {
  prefix: 'fal',
  iconName: 'chevron-up',
  icon: [512, 512, [], "f077", "M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z"]
};
var faFaceSaluting = {
  prefix: 'fal',
  iconName: 'face-saluting',
  icon: [640, 512, [129761], "e484", "M368.8 32.6c-10.1-.8-20.1-.8-30-.3c-8.8 .5-16.4-6.2-16.9-15.1s6.2-16.4 15-16.9c11.2-.6 22.7-.6 34.2 .3c141 10.6 246.7 133.4 236.1 274.4s-133.4 246.7-274.4 236.1C221.7 503 132.5 424.8 104.9 323c-2.3-8.5 2.7-17.3 11.3-19.6s17.3 2.7 19.6 11.3C159.9 403.7 238 472.1 335.3 479.4c123.4 9.3 230.9-83.3 240.1-206.6s-83.3-230.9-206.6-240.1zM235 345.2c5.2-7.2 15.2-8.8 22.3-3.6c17.5 12.6 48.9 27 94.6 27s77.2-14.4 94.6-27c7.2-5.2 17.2-3.5 22.3 3.6s3.5 17.2-3.6 22.3c-22.7 16.4-60.7 33-113.4 33s-90.6-16.6-113.4-33c-7.2-5.2-8.8-15.2-3.6-22.3zm37.3-160.6a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM257.5 89.4l-38 23.9c5.2 3.6 9.8 8.3 13.4 14.1c14 22.5 7.2 52.2-15.2 66.3l-64 40.1 0 0-.1 .1-29 18.2C80.9 279.4 23.2 259.8 5.2 211.5c-13.6-36.4 .2-77.3 33.1-97.9L206.7 7.8c22.4-14.1 52-7.2 66 15.3s7.2 52.2-15.2 66.3zm-17-27.3c7.5-4.7 9.8-14.6 5.1-22s-14.6-9.8-22-5.1L54.7 140.4c-20 12.5-28.4 37.3-20.1 59.4c11 29.3 46 41.2 72.6 24.6l93.3-58.3c7.5-4.7 9.8-14.6 5.1-22s-14.6-9.8-22-5.1L128 173.7V132.4L240.5 62.1z"]
};
var faGaugeSimpleLow = {
  prefix: 'fal',
  iconName: 'gauge-simple-low',
  icon: [512, 512, ["tachometer-slow"], "f62c", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-18.6 7.9-35.3 20.5-47L129.9 151.6c-4.2-7.8-1.3-17.5 6.5-21.7s17.5-1.3 21.7 6.5l82.6 153.4c4.9-1.2 10-1.8 15.3-1.8c35.3 0 64 28.7 64 64s-28.7 64-64 64z"]
};
var faTachometerSlow = faGaugeSimpleLow;
var faFacePersevering = {
  prefix: 'fal',
  iconName: 'face-persevering',
  icon: [512, 512, [], "e385", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 410.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM129.3 232.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 272l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 272l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM211.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faCircleCamera = {
  prefix: 'fal',
  iconName: 'circle-camera',
  icon: [512, 512, ["camera-circle"], "e103", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.2 142.5L191.7 160H184c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56H328c30.9 0 56-25.1 56-56V216c0-30.9-25.1-56-56-56h-7.7l-7.5-17.5c-3.8-8.8-12.5-14.5-22.1-14.5H221.3c-9.6 0-18.3 5.7-22.1 14.5zM226.6 160h58.9l9.6 22.3c2.5 5.9 8.3 9.7 14.7 9.7H328c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h18.3c6.4 0 12.2-3.8 14.7-9.7l9.6-22.3zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCameraCircle = faCircleCamera;
var faHandSpock = {
  prefix: 'fal',
  iconName: 'hand-spock',
  icon: [576, 512, [128406], "f259", "M270.6 45.6l-15.4 4.2 15.4-4.2zM221.6 17.4l4.2 15.4-4.2-15.4zM329.4 263.2L314 267.4c1.9 7.2 8.5 12 15.9 11.8s13.7-5.5 15.2-12.8l-15.7-3.2zM368.8 71.9l-15.7-3.2v0l15.7 3.2zm47.2-31.1l-3.2 15.7v0l3.2-15.7zm31.1 47.2l15.7 3.2v0l-15.7-3.2zM409.3 272l-15.7-3.2c-1 4.7 .2 9.6 3.3 13.3s7.6 5.9 12.4 5.9V272zm5.8 0v16c7.3 0 13.6-4.9 15.5-11.9L415.1 272zm34.3-130.2l15.5 4.1v0l-15.5-4.1zm48.9-28.5l-4.1 15.5v0l4.1-15.5zm28.5 48.9l15.5 4.1v0l-15.5-4.1zM465.5 394.5l-15.5-4.1 15.5 4.1zM336 496l-.2-16c-8.7 .1-15.8 7.3-15.8 16h16zm0 0v16c8.8 0 16-7.2 16-16H336zM168.3 440.8l10.4-12.2-10.4 12.2zM62.1 350.5L51.7 362.7h0l10.4-12.2zm-4.6-56.4L45.3 283.7l0 0 12.2 10.4zm56.4-4.6l-10.4 12.2 0 0 10.4-12.2zm74.5 63.3L178.1 365c5.5 4.6 13.3 5.1 19.3 1.1s8.5-11.4 6.3-18.2l-15.2 4.9zM122 148.4l-15.2 4.9 15.2-4.9zM198 123.6l-15.2 4.9 0 0 15.2-4.9zM246.3 272L231 276.9c2.1 6.6 8.3 11.1 15.2 11.1V272zm2.7 0v16c5 0 9.7-2.3 12.7-6.3s4-9.1 2.7-13.9L248.9 272zM193.4 66.4l-15.4 4.2v0l15.4-4.2zm92.7-25C278 11.5 247.2-6.1 217.4 1.9l8.3 30.9c12.8-3.5 26 4.1 29.4 16.9l30.9-8.3zM344.9 259L286.1 41.4l-30.9 8.3L314 267.4l30.9-8.3zm8.3-190.3L313.8 260l31.3 6.5L384.5 75.2l-31.3-6.5zm66.1-43.6c-30.3-6.2-59.9 13.3-66.1 43.6l31.3 6.5c2.7-13 15.4-21.3 28.3-18.7l6.5-31.3zm43.6 66.1c6.2-30.3-13.3-59.9-43.6-66.1l-6.5 31.3c13 2.7 21.3 15.4 18.7 28.3l31.3 6.5zM425 275.2L462.9 91.3l-31.3-6.5L393.6 268.8l31.3 6.5zM409.3 288h5.8V256h-5.8v32zm24.5-150.3L399.6 267.9l30.9 8.1 34.3-130.2-30.9-8.1zm68.4-39.9c-29.9-7.9-60.5 10-68.4 39.9l30.9 8.1c3.4-12.8 16.5-20.5 29.3-17.1l8.1-30.9zm39.9 68.4c7.9-29.9-10-60.5-39.9-68.4l-8.1 30.9c12.8 3.4 20.5 16.5 17.1 29.3l30.9 8.1zM481 398.6l61.1-232.3-30.9-8.1L450.1 390.4l30.9 8.1zM336.2 512c68.1-1.1 127.4-47.3 144.8-113.4l-30.9-8.1c-13.7 52.2-60.5 88.7-114.3 89.6l.5 32zM352 496v0H320v0h32zm-18.1 16H336V480h-2.1v32zm-15.3 0h15.3V480H318.6v32zM158 453c44.8 38.1 101.8 59 160.6 59V480c-51.3 0-100.8-18.2-139.9-51.4L158 453zM51.7 362.7L158 453l20.7-24.4L72.5 338.3 51.7 362.7zm-6.4-78.9c-20 23.6-17.2 58.9 6.4 78.9l20.7-24.4c-10.1-8.6-11.3-23.7-2.7-33.8L45.3 283.7zm78.9-6.4c-23.6-20-58.9-17.2-78.9 6.4l24.4 20.7c8.6-10.1 23.7-11.3 33.8-2.7l20.7-24.4zm74.5 63.3l-74.5-63.3-20.7 24.4L178.1 365l20.7-24.4zm-92-187.4l66.5 204.5 30.4-9.9L137.2 143.4l-30.4 9.9zm35.9-70.6c-29.4 9.6-45.5 41.2-35.9 70.6l30.4-9.9c-4.1-12.6 2.8-26.1 15.4-30.2l-9.9-30.4zm70.6 35.9c-9.6-29.4-41.2-45.5-70.6-35.9l9.9 30.4c12.6-4.1 26.1 2.8 30.2 15.4l30.4-9.9zm48.2 148.4L213.3 118.7l-30.4 9.9L231 276.9l30.4-9.9zM246.3 288h2.7V256h-2.7v32zM177.9 70.6l55.6 205.6 30.9-8.3L208.8 62.3l-30.9 8.3zM217.4 1.9c-29.9 8.1-47.5 38.8-39.4 68.7l30.9-8.3c-3.5-12.8 4.1-26 16.9-29.4L217.4 1.9z"]
};
var faSpiderWeb = {
  prefix: 'fal',
  iconName: 'spider-web',
  icon: [576, 512, [128376], "f719", "M141.6 18.4c2.7-7.3 10.3-11.5 17.9-10.1l73.6 13.8c37 6.9 75 6.9 112 0L418.8 8.3c7.6-1.4 15.2 2.8 17.9 10.1l30.7 81.8c12 32 29.3 61.7 51.1 87.9l48.1 57.7c4.9 5.9 4.9 14.6 0 20.5L518.5 324c-21.8 26.2-39.1 55.9-51.1 87.9l-30.7 81.8c-2.7 7.3-10.3 11.5-17.9 10.1l-73.6-13.8c-37-6.9-75-6.9-112 0l-73.6 13.8c-7.6 1.4-15.2-2.8-17.9-10.1l-30.7-81.8c-12-32-29.3-61.7-51.1-87.9L11.7 266.2c-4.9-5.9-4.9-14.6 0-20.5L59.8 188c21.8-26.2 39.1-55.9 51.1-87.9l30.7-81.8zm17.8 43.7l-18.5 49.2c-13.2 35.3-32.3 68.1-56.5 97.1L58.2 240h70.5l2.6-2.9c25.4-29.1 45.1-62.7 57.9-99.1l5.2-14.7-35-61.2zM187 46l34.2 59.9c44.1 12 90.5 12 134.6 .2L390 46.2l-39 7.3c-40.9 7.7-82.9 7.7-123.8 0L187 46zM418.5 60.9l-35.2 61.7 5.4 15.4c12.8 36.4 32.5 70 57.9 99.1l2.6 2.9h71l-26.2-31.5c-24.1-29-43.2-61.8-56.5-97.1L418.5 60.9zM520.1 272H449l-1.1 1.3c-26.2 30-46.3 64.8-59.1 102.5l-5 14.6 34.7 60.7 18.9-50.5c13.2-35.3 32.3-68.1 56.5-97.1L520.1 272zM390 465.8l-32.2-56.4c-44.2-14.3-91.6-15.5-136.5-3.4L187 466l40.2-7.5c40.9-7.7 82.9-7.7 123.8 0l39 7.3zM159.4 449.9l35-61.2-5.2-14.8c-12.8-36.4-32.5-70-57.9-99.1l-2.4-2.8H58.2l26.2 31.5c24.1 29 43.2 61.8 56.5 97.1l18.5 49.3zM170.2 272c18.6 24.5 33.7 51.5 45 80.1L261 272H170.2zm72.3 96.8c30.9-4.7 62.4-4.1 93.1 1.8l-47.1-82.4-46 80.6zm120.2-15.3c11.1-29.2 26.3-56.6 45-81.6H316.1l46.6 81.6zM407.7 240c-18.8-24.7-34-51.9-45.3-80.9L316.1 240h91.6zm-73.1-96.8c-30.5 4.9-61.6 4.8-92.1-.1l46.1 80.6 46-80.5zM215.2 159.8c-11.3 28.7-26.4 55.7-45.1 80.2H261l-45.8-80.2z"]
};
var faCircleMicrophone = {
  prefix: 'fal',
  iconName: 'circle-microphone',
  icon: [512, 512, ["microphone-circle"], "e116", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 35.3-28.7 64-64 64s-64-28.7-64-64V160zm64-32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zM144 224c8.8 0 16 7.2 16 16v16c0 53 43 96 96 96s96-43 96-96V240c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 65.3-48.9 119.1-112 127v17c0 8.8-7.2 16-16 16s-16-7.2-16-16V383c-63.1-7.9-112-61.7-112-127V240c0-8.8 7.2-16 16-16z"]
};
var faMicrophoneCircle = faCircleMicrophone;
var faBookArrowUp = {
  prefix: 'fal',
  iconName: 'book-arrow-up',
  icon: [448, 512, [], "e0ba", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H176V480H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H176V384H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H304v32h80v64H304v32H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V413.3c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zm68.7 228.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 182.6 224 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-313.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96z"]
};
var faPopsicle = {
  prefix: 'fal',
  iconName: 'popsicle',
  icon: [320, 512, [], "e43e", "M288 160c0-70.7-57.3-128-128-128S32 89.3 32 160V336c0 8.8 7.2 16 16 16h96V192c0-8.8 7.2-16 16-16s16 7.2 16 16V352h96c8.8 0 16-7.2 16-16V160zM144 384H48c-26.5 0-48-21.5-48-48V160C0 71.6 71.6 0 160 0s160 71.6 160 160V336c0 26.5-21.5 48-48 48H176V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384z"]
};
var faCommand = {
  prefix: 'fal',
  iconName: 'command',
  icon: [512, 512, [], "e142", "M0 88C0 39.4 39.4 0 88 0s88 39.4 88 88v56H336V88c0-48.6 39.4-88 88-88s88 39.4 88 88s-39.4 88-88 88H368V336h56c48.6 0 88 39.4 88 88s-39.4 88-88 88s-88-39.4-88-88V368H176v56c0 48.6-39.4 88-88 88s-88-39.4-88-88s39.4-88 88-88h56V176H88C39.4 176 0 136.6 0 88zm144 56V88c0-30.9-25.1-56-56-56S32 57.1 32 88s25.1 56 56 56h56zm32 192H336V176H176V336zm-32 32H88c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56V368zm224 0v56c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56H368zm0-224h56c30.9 0 56-25.1 56-56s-25.1-56-56-56s-56 25.1-56 56v56z"]
};
var faBlinds = {
  prefix: 'fal',
  iconName: 'blinds',
  icon: [512, 512, [], "f8fb", "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H160V258.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V96H32C14.3 96 0 81.7 0 64V32zm480 0H32V64H480V32zM96 192v32H20.9C9.3 224 0 214.7 0 203.1c0-2.1 .3-4.1 .9-6.1l21.2-69H55.6L35.9 192H96zm96 32V192H476.1l-19.7-64h33.5l21.2 69c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9H192zM65.6 288c-1 5.2-1.6 10.5-1.6 16s.6 10.8 1.6 16H20.9C9.3 320 0 310.7 0 299.1c0-2.1 .3-4.1 .9-6.1l11.4-37H45.8l-9.8 32H65.6zm156.8 32c1-5.2 1.6-10.5 1.6-16s-.6-10.8-1.6-16H476.1l-9.8-32h33.5l11.4 37c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9H222.4zM144 384H476.1l-9.8-32h33.5l11.4 37c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9H20.9C9.3 416 0 406.7 0 395.1c0-2.1 .3-4.1 .9-6.1l11.4-37H45.8l-9.8 32H144zm322.2 64h33.5l11.4 37c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9H20.9C9.3 512 0 502.7 0 491.1c0-2.1 .3-4.1 .9-6.1l11.4-37H45.8l-9.8 32H476.1l-9.8-32zM144 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faStopwatch = {
  prefix: 'fal',
  iconName: 'stopwatch',
  icon: [448, 512, [9201], "f2f2", "M128 16c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240V96.6c49.4 3.8 94 24.8 127.7 57l37-37c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-38.2 38.2C416 212.6 432 256.4 432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-109.5 84.6-199.2 192-207.4V32H144c-8.8 0-16-7.2-16-16zM48 304a176 176 0 1 0 352 0A176 176 0 1 0 48 304zm192-96V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSaxophone = {
  prefix: 'fal',
  iconName: 'saxophone',
  icon: [640, 512, [127927], "f8dc", "M521.9 32c-20.8 0-40.8 8.1-55.7 22.6L221.1 292.3c-2.3 2.3-5.4 3.5-8.7 3.5c-6.9 0-12.5-5.6-12.5-12.5v-4.5c0-2.3 .5-4.7 1.4-6.8l49-112.1H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H240 48 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H28.3L3.6 277.2C1.2 288.6 0 300.2 0 311.8v5.6C0 407.2 72.8 480 162.6 480c48.8 0 94.9-21.9 125.8-59.6L522.8 133.9c3-3.7 7.6-5.9 12.4-5.9h77.5c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3L606.1 55.4c-15-15-35.4-23.4-56.6-23.4H521.9zM61 160H215.5l-43.4 99.3c-2.7 6.2-4.1 12.9-4.1 19.6v4.5c0 24.6 19.9 44.5 44.5 44.5c11.6 0 22.7-4.5 31-12.5L488.5 77.5c9-8.7 20.9-13.5 33.4-13.5h27.6c12.7 0 24.9 5.1 33.9 14.1L601.4 96H535.2c-14.4 0-28 6.5-37.2 17.6L263.6 400.1c-24.8 30.3-61.9 47.9-101 47.9C90.5 448 32 389.5 32 317.4v-5.6c0-9.4 1-18.8 2.9-28L61 160zm43 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40-104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSquare2 = {
  prefix: 'fal',
  iconName: 'square-2',
  icon: [448, 512, [], "e257", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm185 78.4L171 187.7c-6.4 6.1-16.6 5.7-22.6-.7s-5.7-16.6 .7-22.6l14.1-13.2c15.8-14.9 36.8-23 58.5-22.7C267.3 129 304 166.3 304 212c0 22.2-8.8 43.4-24.5 59.1L198.6 352H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L256.9 248.5c9.7-9.7 15.1-22.8 15.1-36.5c0-28.2-22.7-51.2-50.9-51.6c-13.4-.2-26.3 4.8-36.1 14z"]
};
var faFieldHockeyStickBall = {
  prefix: 'fal',
  iconName: 'field-hockey-stick-ball',
  icon: [512, 512, [127953, "field-hockey"], "f44c", "M500.3 100.9C520.7 72 513.7 32 484.9 11.7S416-1.8 395.7 27.1L147.6 379.4c-2 2.8-5.1 4.4-8.5 4.4c-5.3 0-10.5-4.7-10.5-11c0-1.6 .4-3.1 .9-4.4l17-38.5c14.3-32.3-.3-70.1-32.7-84.4s-70.1 .3-84.4 32.7l-17 38.5C4.8 334 .7 352.9 .6 371.8C0 448.3 61.9 512 139.4 511.8c44.9-.1 86.9-22 112.8-58.7L500.3 100.9zM474.2 82.4l-54 76.7-51.2-38.4 52.9-75.1C432 31.1 452 27.7 466.4 37.8S484.3 68 474.2 82.4zM401.7 185.3L226.1 434.6c-19.9 28.2-52.2 45-86.7 45.1C79.9 480 32.1 431 32.6 372c.1-14.6 3.2-29.1 9.1-42.5l17-38.5c7.1-16.2 26-23.5 42.2-16.3s23.5 26 16.3 42.2l-17 38.5c-2.4 5.3-3.6 11.2-3.7 17.1c-.2 23.9 19.2 43.3 42.6 43.2c13.8 0 26.7-6.8 34.6-18L350.5 146.9l51.2 38.4zM432 384a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faFieldHockey = faFieldHockeyStickBall;
var faArrowUpSquareTriangle = {
  prefix: 'fal',
  iconName: 'arrow-up-square-triangle',
  icon: [576, 512, ["sort-shapes-up-alt"], "f88b", "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 176V80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm64 147.5L490.7 448H341.3L416 323.5zM320 176c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v96zM307.6 442c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1H502.9c13.8 0 25.1-11.2 25.1-25.1c0-4.5-1.2-9-3.6-12.9L440.2 301.7c-5.1-8.5-14.3-13.7-24.2-13.7s-19.1 5.2-24.2 13.7L307.6 442z"]
};
var faSortShapesUpAlt = faArrowUpSquareTriangle;
var faFaceScream = {
  prefix: 'fal',
  iconName: 'face-scream',
  icon: [640, 512, [], "e38b", "M543.2 274.5c.5-6.1 .8-12.3 .8-18.5C544 132.3 443.7 32 320 32S96 132.3 96 256c0 6.2 .3 12.4 .8 18.5c-10.5-2.5-21.4-3.2-32.2-1.9c-.4-5.5-.5-11-.5-16.6C64 114.6 178.6 0 320 0S576 114.6 576 256c0 5.6-.2 11.1-.5 16.6c-10.8-1.3-21.7-.6-32.2 1.9zM407.6 462.2c-2.7 12.2-4.9 24.5-6.4 36.6C375.7 507.4 348.4 512 320 512c-28.4 0-55.6-4.6-81.1-13.1c-1.5-12.2-3.6-24.4-6.4-36.6C259.4 473.7 288.9 480 320 480c31.1 0 60.7-6.3 87.6-17.8zM224.3 164.4c-13.1 5.8-26.4 17.1-36.1 33c-9.7 15.9-13.3 32.2-12.1 45.3c1.2 13 6.9 21.7 14.7 26c8.1 4.4 19.5 4.7 32.7-1.1c13.1-5.8 26.4-17.1 36.1-33c9.7-15.9 13.3-32.2 12.1-45.3c-1.2-13-6.9-21.7-14.7-26c-8.1-4.4-19.5-4.7-32.7 1.1zm-12.9-29.3c19.4-8.6 41.8-10.4 61 .1c19.4 10.6 29.3 30.3 31.2 51.2c1.9 20.8-3.8 43.9-16.6 64.9c-12.8 21-30.9 37-50.5 45.6c-19.4 8.6-41.8 10.4-61-.1c-19.4-10.6-29.3-30.3-31.2-51.2c-1.9-20.8 3.8-43.9 16.6-64.9c12.8-21 30.9-37 50.5-45.6zm204.2 29.3c-13.2-5.8-24.6-5.5-32.7-1.1c-7.9 4.3-13.5 13-14.7 26c-1.2 13.1 2.4 29.4 12.1 45.3c9.7 15.9 23 27.2 36.1 33c13.2 5.8 24.6 5.5 32.7 1.1c7.9-4.3 13.5-13 14.7-26c1.2-13.1-2.4-29.4-12.1-45.3c-9.7-15.9-23-27.2-36.1-33zm12.9-29.3c19.5 8.6 37.7 24.6 50.5 45.6c12.8 21 18.5 44.1 16.6 64.9c-1.9 20.9-11.8 40.6-31.2 51.2c-19.2 10.5-41.5 8.7-61 .1c-19.5-8.6-37.7-24.6-50.5-45.6c-12.8-21-18.5-44.1-16.6-64.9c1.9-20.9 11.8-40.6 31.2-51.2c19.2-10.5 41.5-8.7 61-.1zM352 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V352zm-96 0c0-35.3 28.7-64 64-64s64 28.7 64 64v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V352zM113.6 317.8l0 0c29.4 24.5 52.9 60.4 69 97.8c13.7 31.8 22.5 65.7 24.8 96.4H65.8c-2.8-41.8-18-83.5-40-116.9c-6.6-9.9-9.8-21.2-9.8-32.3c0-19.2 9.5-38 26.9-49.2l0 0c22.5-14.5 51.3-12 70.8 4.2zm500.6 77.3c-22.1 33.4-37.2 75.1-40 116.9H432.6c2.3-30.7 11.1-64.6 24.8-96.4c16.1-37.4 39.6-73.2 69-97.8l0 0c19.5-16.2 48.3-18.8 70.8-4.2l0 0c18.2 11.8 27.7 31.8 26.8 52c-.5 10.2-3.7 20.5-9.7 29.6zM48 362.8c0 5 1.4 10.1 4.4 14.6l0 0C77.7 415.6 95 463.4 97.9 512l77.4 0c-2.3-26-9.9-55.5-22.1-83.8c-14.8-34.3-35.6-65.4-60-85.8c-9.1-7.5-22.5-8.7-32.9-2l0 0c-8 5.2-12.2 13.7-12.2 22.4zM592 364c.4-9.1-3.9-18.2-12.2-23.6l0 0c-10.4-6.7-23.9-5.6-32.9 2c-24.4 20.4-45.3 51.5-60.1 85.8C474.7 456.5 467 486 464.7 512l77.4 0c2.9-48.6 20.2-96.4 45.4-134.6l0 0c2.8-4.2 4.2-8.8 4.4-13.4z"]
};
var faSquareM = {
  prefix: 'fal',
  iconName: 'square-m',
  icon: [448, 512, [], "e276", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm125.1 38.8L224 276.1l98.9-141.3c4-5.7 11.3-8.2 17.9-6.1s11.2 8.3 11.2 15.3V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V194.8L237.1 313.2c-3 4.3-7.9 6.8-13.1 6.8s-10.1-2.5-13.1-6.8L128 194.8V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1z"]
};
var faCameraWeb = {
  prefix: 'fal',
  iconName: 'camera-web',
  icon: [448, 512, ["webcam"], "f832", "M224 32a192 192 0 1 1 0 384 192 192 0 1 1 0-384zM357.5 403.9C412.4 363 448 297.7 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 73.7 35.6 139 90.5 179.9L37 473.4c-5.6 7.2-6.5 17-2.5 25.2s12.4 13.4 21.5 13.4H392c9.1 0 17.5-5.2 21.5-13.4s3.1-18-2.5-25.2l-53.5-69.5zm-27.1 17.3L375.8 480H72.2l45.3-58.9C149.2 438.3 185.5 448 224 448s74.8-9.7 106.5-26.9zM224 112a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
var faWebcam = faCameraWeb;
var faCommentArrowDown = {
  prefix: 'fal',
  iconName: 'comment-arrow-down',
  icon: [512, 512, [], "e143", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 281.4V144z"]
};
var faLightbulbCfl = {
  prefix: 'fal',
  iconName: 'lightbulb-cfl',
  icon: [320, 512, [], "e5a6", "M176 57.7C176 22 142.5-4.1 107.9 4.5L41.5 21.1C17.1 27.2 0 49.2 0 74.3c0 16 6.8 30.1 17.3 40C6.6 124.4 0 138.7 0 154.3c0 16 6.8 30.1 17.3 40C6.6 204.4 0 218.7 0 234.3c0 35.7 33.5 61.8 68.1 53.2l63.7-15.9 .1 0 64-16 0 0 63.8-15.9c14.4-3.6 28.3 7.3 28.3 22.1c0 10.5-7.1 19.6-17.3 22.1l-82.6 20.7C181 306.3 176 312.7 176 320v32H144V309.5l-32 8V352H96c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h48v16c0 8.8 7.2 16 16 16s16-7.2 16-16V480h48c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H208V332.5l70.5-17.6c24.4-6.1 41.5-28 41.5-53.2c0-16-6.8-30.1-17.3-40c10.8-10.1 17.3-24.4 17.3-40c0-16-6.8-30.1-17.3-40c10.8-10.1 17.3-24.4 17.3-40c0-35.7-33.5-61.8-68.1-53.2L175.1 67.7c.6-3.3 .9-6.6 .9-10zM96 384h95.9l.1 0 .1 0H224v64H96V384zM270.7 203.8L124.1 240.5 60.3 256.4C45.9 260 32 249.1 32 234.3c0-10.5 7.1-19.6 17.3-22.1l18.6-4.6 .2-.1 191.7-47.9c14.3-3.5 28.2 7.4 28.2 22.2c0 10.5-7.1 19.6-17.3 22.1zm-136.2-93L259.7 79.6C274.1 76 288 86.9 288 101.7c0 10.5-7.1 19.6-17.3 22.1l-18.6 4.6-.2 .1L60.2 176.5C45.8 179.9 32 169.1 32 154.3c0-10.5 7.1-19.6 17.3-22.1L68 127.5l.1 0 66.4-16.6 .1 0zm-7.8-31l0 0L60.3 96.4l0 0C45.9 100 32 89.1 32 74.3c0-10.5 7.1-19.6 17.3-22.1l66.4-16.6C130.1 32 144 42.9 144 57.7c0 10.4-7.1 19.6-17.2 22.1z"]
};
var faWindowFrameOpen = {
  prefix: 'fal',
  iconName: 'window-frame-open',
  icon: [512, 512, [], "e050", "M272 32H416c17.7 0 32 14.3 32 32V256H272V32zM480 288V256 64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V256v32H64 448h32zM240 256H64V64c0-17.7 14.3-32 32-32H240V256zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H48 464h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V320H448V480H64V320H32V480H16z"]
};
var faFaceKiss = {
  prefix: 'fal',
  iconName: 'face-kiss',
  icon: [512, 512, [128535, "kiss"], "f596", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm277.4 39.1c-11-5.4-25.7-9.3-39.1-11.2c-6.6-.9-11.1-7-10.2-13.6s7-11.1 13.6-10.2c15.1 2.1 32.4 6.6 46.3 13.4c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-1.1 .5-2.1 1-3.3 1.5c1.1 .5 2.2 1 3.3 1.5c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-13.9 6.8-31.2 11.3-46.3 13.4c-6.6 .9-12.6-3.6-13.6-10.2s3.6-12.6 10.2-13.6c13.4-1.9 28.1-5.8 39.1-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8c-10.9-5.4-25.5-9.3-38.8-11.2c-.9-.1-1.8-.3-2.7-.6c-1.7-.6-3.2-1.6-4.4-2.8s-2.2-2.7-2.8-4.4c-.5-1.3-.7-2.6-.7-4.1s.2-2.8 .7-4.1c.6-1.7 1.6-3.2 2.8-4.4s2.7-2.2 4.4-2.8c.9-.3 1.7-.5 2.7-.6c13.3-1.9 27.9-5.8 38.8-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faKiss = faFaceKiss;
var faBridgeCircleXmark = {
  prefix: 'fal',
  iconName: 'bridge-circle-xmark',
  icon: [640, 512, [], "e4cb", "M48 32h80H256 384 512h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H528v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H512 384 256 128 48c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM496 64H400v64h96V64zM368 64H272v64h96V64zM240 64H144v64h96V64zM48 240H64c53 0 96 43 96 96v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-53 43-96 96-96c16.1 0 31.2 4 44.6 10.9c-7.2 8.1-13.7 16.9-19.3 26.2c-7.7-3.3-16.3-5.2-25.2-5.2c-35.3 0-64 28.7-64 64v96c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V336c0-35.3-28.7-64-64-64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPeriod = {
  prefix: 'fal',
  iconName: 'period',
  icon: [128, 512, [], "2e", "M64 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faFaceGrinTongue = {
  prefix: 'fal',
  iconName: 'face-grin-tongue',
  icon: [512, 512, [128539, "grin-tongue"], "f589", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm144.4-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM352 416V383.4c20.2-15.7 36.4-36.2 46.9-59.9c5.2-11.7-6.8-22.4-19.1-18.7c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c10.4 23.6 26.6 44.1 46.8 59.8V416c0 53 43 96 96 96s96-43 96-96zm-32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64V378.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"]
};
var faGrinTongue = faFaceGrinTongue;
var faUpToDottedLine = {
  prefix: 'fal',
  iconName: 'up-to-dotted-line',
  icon: [448, 512, [], "e457", "M222.2 160.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L350.2 292.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7L288 304c-8.8 0-16 7.2-16 16l0 120c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-120c0-8.8-7.2-16-16-16l-57.3 0c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L222.2 160.8zM224 128c-9.5 0-18.6 3.9-25.1 10.8L74.5 270.8C67.8 278 64 287.5 64 297.3c0 21.4 17.3 38.7 38.7 38.7l41.3 0 0 104c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-104 41.3 0c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L249.1 138.8c-6.5-6.9-15.6-10.8-25.1-10.8zM416 36a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 36a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM296 60a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM224 36a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM104 60a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"]
};
var faThoughtBubble = {
  prefix: 'fal',
  iconName: 'thought-bubble',
  icon: [512, 512, [], "e32e", "M256 0c-50.7 0-94.4 29.4-115.2 72.1c-1.6-.1-3.2-.1-4.8-.1C60.9 72 0 132.9 0 208s60.9 136 136 136c10.8 0 21.2-1.3 31.3-3.6C187.8 366.9 219.9 384 256 384s68.2-17.1 88.7-43.6c10.1 2.4 20.5 3.6 31.3 3.6c75.1 0 136-60.9 136-136s-60.9-136-136-136c-1.6 0-3.2 0-4.8 .1C350.4 29.4 306.7 0 256 0zM166 94.5C179.6 58 214.8 32 256 32s76.4 26 90 62.5c2.6 7 9.6 11.2 17 10.3c4.3-.5 8.6-.8 13-.8c57.4 0 104 46.6 104 104s-46.6 104-104 104c-11.5 0-22.6-1.9-32.9-5.3c-7.1-2.4-14.8 .5-18.7 6.9C310.3 336.6 284.9 352 256 352s-54.3-15.4-68.4-38.5c-3.9-6.4-11.6-9.2-18.7-6.9c-10.3 3.4-21.4 5.3-32.9 5.3C78.6 312 32 265.4 32 208s46.6-104 104-104c4.4 0 8.8 .3 13 .8c7.4 .9 14.4-3.3 17-10.3zM144 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 0A32 32 0 1 0 0 480a32 32 0 1 0 64 0z"]
};
var faSkeletonRibs = {
  prefix: 'fal',
  iconName: 'skeleton-ribs',
  icon: [640, 512, [], "e5cb", "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H254.1c-29.3 0-56.6 16-69.7 42.9c-14.9 30.8-36.9 79.1-55.2 132C111 291.5 96 349.8 96 400v11.2c0 38 30.8 68.8 68.8 68.8c9.6 0 19.1-2 27.9-5.9l81.8-36.3c9.5-4.2 19.4-7 29.5-8.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V429.2c10.1 1.5 20 4.3 29.5 8.5l81.8 36.3c8.8 3.9 18.3 5.9 27.9 5.9c38 0 68.8-30.8 68.8-68.8V400c0-50.2-15-108.5-33.2-161.1c-18.3-52.8-40.3-101.2-55.2-132C442.5 80 415.2 64 385.9 64H336V16zM304 96v82.9L176.2 204.4c13.3-33.2 26.8-62.5 37-83.5c7.4-15.3 23.2-24.9 40.9-24.9H304zM162.8 239.7l.3-.1L304 211.5V284L135.8 333.1c5.7-27.4 14.1-55.9 23.7-83.7c1.1-3.2 2.3-6.5 3.4-9.7zM130 367.9c.8-.1 1.6-.3 2.4-.5l171.5-50V397c-14.5 1.6-28.9 5.5-42.5 11.5l-81.8 36.3c-4.7 2.1-9.8 3.2-14.9 3.2c-20.3 0-36.8-16.5-36.8-36.8V400c0-10.3 .7-21 2-32.1zM336 397V317.3l171.5 50c.8 .2 1.6 .4 2.5 .5c1.3 11.1 2 21.9 2 32.1v11.2c0 20.3-16.5 36.8-36.8 36.8c-5.1 0-10.2-1.1-14.9-3.2l-81.8-36.3c-13.6-6.1-28-9.9-42.5-11.5zm168.2-63.9L336 284V211.5l140.9 28.2 .3 .1c1.1 3.2 2.3 6.4 3.4 9.7c9.6 27.7 18 56.2 23.7 83.7zM463.8 204.4L336 178.9V96h49.9c17.7 0 33.5 9.6 40.9 24.9c10.2 21 23.7 50.3 37 83.5zM0 128V240 496c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.6 4.9-16.6 12.6-20.4l44.5-22.2c23.8-11.9 38.9-36.3 38.9-63V128c0-35.3-28.7-64-64-64S0 92.7 0 128zm32 62.1V128c0-17.7 14.3-32 32-32s32 14.3 32 32v6.4c0 14.5-8.2 27.8-21.2 34.3L32 190.1zM576 64c-35.3 0-64 28.7-64 64v6.4c0 26.7 15.1 51 38.9 63l44.5 22.2c7.7 3.9 12.6 11.8 12.6 20.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V240 128c0-35.3-28.7-64-64-64zM565.2 168.7c-13-6.5-21.2-19.8-21.2-34.3V128c0-17.7 14.3-32 32-32s32 14.3 32 32v62.1l-42.8-21.4z"]
};
var faRaygun = {
  prefix: 'fal',
  iconName: 'raygun',
  icon: [576, 512, [], "e025", "M39.3 2.6c4.5-3 10.3-3.4 15.2-1.2L195.4 64H272c18 0 34.6 6 48 16V48c0-8.8 7.2-16 16-16s16 7.2 16 16v96 16h32V80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h32c0-6.1 3.4-11.6 8.8-14.3l96-48c5-2.5 10.9-2.2 15.6 .7s7.6 8.1 7.6 13.6V240c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-96-48c-5.4-2.7-8.8-8.3-8.8-14.3H416v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H352v16 96c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c-12.4 9.3-27.6 15.1-44.2 15.9l0 .1L172.6 494.3c-7.9 15.8-27.1 22.2-42.9 14.3l-80-40c-15.8-7.9-22.2-27.1-14.3-42.9l69-137.9C46.1 283.8 0 235.3 0 176c0-30.5 12.2-58.2 32-78.4V16c0-5.4 2.7-10.5 7.3-13.4zM480 176v6.1l64 32V137.9l-64 32V176zM192.3 96c-.2 0-.5 0-.7 0H112c-44.2 0-80 35.8-80 80s35.8 80 80 80h8.2H256h16c26.5 0 48-21.5 48-48V176 144c0-26.5-21.5-48-48-48H192.3zM64 40.6V74.8C78.5 67.9 94.8 64 112 64h4.6L64 40.6zM140 288L64 440l80 40 96-192H140zM112 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faFlute = {
  prefix: 'fal',
  iconName: 'flute',
  icon: [640, 512, [], "f8b9", "M160 320H576c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H160V320zm-32 0V192H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64zM64 160h64 16 16H576c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H160 144 128 64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64zm256 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faAcorn = {
  prefix: 'fal',
  iconName: 'acorn',
  icon: [448, 512, [], "f6ae", "M267.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-3.9 3.9C225.5 23.9 215.1 43.2 210.5 64H96C43 64 0 107 0 160v16c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-53-43-96-96-96H243.6c3.8-12.3 10.6-23.6 19.8-32.8l3.9-3.9zM352 96c35.3 0 64 28.7 64 64v16H32V160c0-35.3 28.7-64 64-64H352zM48.4 240c4.1 78.1 39 189.3 165.5 236.4c6.5 2.4 13.7 2.4 20.2 0C360.6 429.3 395.5 318.1 399.6 240h-32c-4 70.6-35.5 165.2-143.5 206C116 405.2 84.4 310.6 80.5 240h-32z"]
};
var faVideoArrowUpRight = {
  prefix: 'fal',
  iconName: 'video-arrow-up-right',
  icon: [576, 512, [], "e2c9", "M320 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V336.8 175.2 128c0-35.3-28.7-64-64-64H64zM416 354.4l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2V377.8c0 3.4-2.8 6.2-6.2 6.2c-1 0-2.1-.3-3-.8L416 317.9v36.5zM160 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h73.4L100.7 324.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 214.6V288c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16H160z"]
};
var faGrateDroplet = {
  prefix: 'fal',
  iconName: 'grate-droplet',
  icon: [576, 512, [], "e194", "M64 64H384c17.7 0 32 14.3 32 32v88.9c7.8-11.1 19.1-19.1 32-22.7V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H344.2c-6.6-9.9-12-20.6-16.1-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm320 64c0-17.7-14.3-32-32-32H296 224 152 96c-17.7 0-32 14.3-32 32V256 384c0 17.7 14.3 32 32 32h56 72 72 24.9c-.6-5.3-.9-10.6-.9-16c0-5.4 .3-10.7 .9-16H312V272h40v32l32-60V128zM96 128h40V240H96V128zm72 112V128h40V240H168zm72 0V128h40V240H240zm72 0V128h40V240H312zm-32 32V384H240V272h40zm-72 0V384H168V272h40zm-72 0V384H96V272h40zm257.4 90.4L464 230l70.6 132.4c6.2 11.6 9.4 24.5 9.4 37.6c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-13.1 3.2-26.1 9.4-37.6zm-28.2-15.1C356.5 363.5 352 381.6 352 400c0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.4-4.5-36.5-13.2-52.7L487.5 206.1c-4.6-8.7-13.7-14.1-23.5-14.1s-18.9 5.4-23.5 14.1L365.2 347.3z"]
};
var faSealExclamation = {
  prefix: 'fal',
  iconName: 'seal-exclamation',
  icon: [512, 512, [], "e242", "M176 96c8.5 0 16.6-3.4 22.6-9.4l46.1-46.1c6.2-6.2 16.4-6.2 22.6 0l46.1 46.1c6 6 14.1 9.4 22.6 9.4h64c8.8 0 16 7.2 16 16v64c0 8.5 3.4 16.6 9.4 22.6L471 244.2c6.2 6.2 6.2 16.4 0 22.6l-45.6 45.6c-6 6-9.4 14.1-9.4 22.6V400c0 8.8-7.2 16-16 16H335.1c-8.5 0-16.6 3.4-22.6 9.4l-45.1 45.1c-6.2 6.2-16.4 6.2-22.6 0l-45.1-45.1c-6-6-14.1-9.4-22.6-9.4H112c-8.8 0-16-7.2-16-16V335.1c0-8.5-3.4-16.6-9.4-22.6L41 266.8 18.4 289.5 41 266.8c-6.2-6.2-6.2-16.4 0-22.6l45.6-45.6c6-6 9.4-14.1 9.4-22.6V112c0-8.8 7.2-16 16-16h64zM18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1V400c0 26.5 21.5 48 48 48h64.9l45.1 45.1c18.7 18.7 49.1 18.7 67.9 0L335.1 448H400c26.5 0 48-21.5 48-48V335.1l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176V112c0-26.5-21.5-48-48-48H336L289.9 17.9c-18.7-18.7-49.1-18.7-67.9 0L176 64H112c-26.5 0-48 21.5-48 48v64L18.4 221.6zM240 144V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm40 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faChessBishop = {
  prefix: 'fal',
  iconName: 'chess-bishop',
  icon: [320, 512, [9821], "f43a", "M104 0C95.2 0 88 7.2 88 16s7.2 16 16 16h11.6C103.6 42.9 89.8 56.7 75.9 72.8C39 115.7 0 177.6 0 248.7c0 53.2 37.2 80 64 92.3V352H96V330.4c0-6.7-4.1-12.7-10.4-15C62.5 306.8 32 288.1 32 248.7c0-59.7 33-114.3 68.1-155c17.4-20.2 34.7-36.4 47.8-47.6c4.7-4 8.8-7.3 12.1-10c3.3 2.6 7.4 6 12.1 10c13.1 11.2 30.4 27.5 47.8 47.6c7.2 8.4 14.3 17.3 21.1 26.7l-76.2 76.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L258.6 148c17.3 30.4 29.4 64.6 29.4 100.7c0 39.4-30.5 58-53.6 66.7c-6.3 2.3-10.4 8.3-10.4 15V352h32V341.1c26.8-12.3 64-39.1 64-92.3c0-71.2-39-133-75.9-175.9C230.2 56.7 216.4 42.9 204.4 32H216c8.8 0 16-7.2 16-16s-7.2-16-16-16H160 104zM254.2 416l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L65.8 416l188.4 0zm0-32H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512H280.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"]
};
var faMessageSms = {
  prefix: 'fal',
  iconName: 'message-sms',
  icon: [512, 512, [], "e1e5", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM202.9 144.8C196.4 147 192 153.1 192 160v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208v48c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6zm-90.9 38c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.6 .1 16.7 1.6 23.3 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4c-9.3-.1-20.4 1.9-29.7 7.4C88.6 157.3 80 167.8 80 183c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7.2-.2-14.2-2.6-23.7-5.8l0 0 0 0 0 0 0 0c-1.3-.4-2.6-.9-4-1.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1 .4 2.4 .8 3.6 1.2l0 0 0 0c9 3.1 20.9 7.2 33.2 7.6c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4zm256 0c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.1 .1 12.9 1.4 20.1 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4c-9.3-.1-20.3 1.9-29.7 7.4c-9.9 5.9-18.6 16.4-18.5 31.6c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7-.2-13.5-2.4-22.6-5.5l0 0 0 0 0 0c-1.5-.5-3.2-1.1-4.9-1.6c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.2 .4 2.6 .9 4 1.4l0 0c8.8 3 20.4 7 32.6 7.4c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4z"]
};
var faCoffeeBeans = {
  prefix: 'fal',
  iconName: 'coffee-beans',
  icon: [512, 512, [], "e13f", "M476.8 258c50-50 39.9-141.2-22.6-203.6S300.5-18.2 250.5 31.8s-39.9 141.2 22.6 203.6S426.8 308 476.8 258zm-22.6-22.6c-33 33-103.4 32.3-158.4-22.6c-40.6-40.6-51.6-89.6-41.3-125.8c3.9 6.2 8 12 12.3 17.1c27.7 32.7 61.1 44.7 90.6 55.2l1 .3c30.1 10.8 56.2 20.4 78.2 46.3c6.4 7.5 12.6 17.8 18.4 28.7l-.7 .7zm6.3-49.7c-27.7-32.7-61.1-44.7-90.6-55.2l-1-.3c-30.1-10.8-56.2-20.4-78.2-46.3c-6.4-7.5-12.6-17.8-18.4-28.7l.7-.7c33-33 103.4-32.3 158.4 22.6c40.6 40.6 51.6 89.6 41.3 125.8c-3.9-6.2-8-12-12.3-17.1zM128 480c-46.7 0-96-50.3-96-128c0-57.4 26.9-99.8 59.8-118.1c-1.6 7.1-2.8 14.2-3.4 20.8c-3.6 42.7 11.6 74.8 25 103.1l.4 .9c13.7 28.9 25.4 54.2 22.5 88c-.8 9.8-3.6 21.5-7.3 33.3l-1 0zm39.6-30.7c3.6-42.7-11.6-74.8-25-103.1l-.4-.9c-13.7-28.9-25.4-54.2-22.5-88c.8-9.8 3.6-21.5 7.3-33.3l1 0c46.7 0 96 50.3 96 128c0 57.4-26.9 99.8-59.8 118.1c1.6-7.1 2.8-14.2 3.4-20.8zM128 512c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z"]
};
var faHatWitch = {
  prefix: 'fal',
  iconName: 'hat-witch',
  icon: [576, 512, [], "f6e7", "M96 384h34.9l80.9-185c13.8-31.5 37.3-57.7 67.2-74.8L436.8 34.1c2.4-1.4 5.2-2.1 7.9-2.1h1.5c3.8 0 7.5 1.4 10.4 3.9l82.5 70.7c3.1 2.7 4.9 6.5 4.9 10.6c0 2.2-.5 4.3-1.5 6.3L516.7 175l-1.1-4.3C509.4 145.6 486.9 128 461 128c-18.8 0-36.4 9.4-46.9 25.1l-14.3 21.5c-10.3 15.5-15.8 33.6-15.8 52.2c0 13.2 2.8 26.2 8.1 38.2L445 384h35L421.4 252c-3.5-7.9-5.4-16.5-5.4-25.2c0-12.3 3.6-24.3 10.4-34.5l14.3-21.5c4.5-6.8 12.1-10.8 20.2-10.8c11.2 0 20.9 7.6 23.6 18.4l7.1 28.3c2.5 10.2 11.7 17.3 22.2 17.3c8.7 0 16.6-4.9 20.5-12.6l36.8-73.6c3.2-6.4 4.9-13.4 4.9-20.6c0-13.4-5.9-26.2-16.1-34.9L477.5 11.6C468.8 4.1 457.7 0 446.2 0h-1.5c-8.4 0-16.6 2.2-23.8 6.3L263.2 96.5c-35.8 20.5-64.1 51.9-80.6 89.7L96 384zM52.8 448H523.2c-24.5 15.2-61.9 32-107.2 32H160c-45.3 0-82.7-16.8-107.2-32zM22.6 416C10.1 416 0 426.1 0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512H416c77.4 0 134.1-41.7 153.1-57.8c4.6-3.9 6.9-9.6 6.9-15.6c0-12.5-10.1-22.6-22.6-22.6H22.6zM304 352c8.8 0 16 7.2 16 16v16h32V368c0-26.5-21.5-48-48-48H272c-26.5 0-48 21.5-48 48v16h32V368c0-8.8 7.2-16 16-16h32z"]
};
var faFaceGrinWink = {
  prefix: 'fal',
  iconName: 'face-grin-wink',
  icon: [512, 512, ["grin-wink"], "f58c", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faGrinWink = faFaceGrinWink;
var faClockThreeThirty = {
  prefix: 'fal',
  iconName: 'clock-three-thirty',
  icon: [512, 512, [], "e357", "M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V256c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H272V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faEarDeaf = {
  prefix: 'fal',
  iconName: 'ear-deaf',
  icon: [512, 512, ["deaf", "deafness", "hard-of-hearing"], "f2a4", "M507.3 27.3l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-320 320l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM240 96C160.5 96 96 160.5 96 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-97.2 78.8-176 176-176s176 78.8 176 176c0 51.3-21.9 97.4-56.9 129.6c-4.8 4.4-7.1 9.7-7.1 14.4c0 70.7-57.3 128-128 128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c53 0 96-43 96-96c0-15.4 7.4-28.7 17.5-38c28.6-26.3 46.5-64.1 46.5-106c0-79.5-64.5-144-144-144zm0 64c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112s112 50.1 112 112c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2-35.8-80-80-80z"]
};
var faDeaf = faEarDeaf;
var faDeafness = faEarDeaf;
var faHardOfHearing = faEarDeaf;
var faAlarmClock = {
  prefix: 'fal',
  iconName: 'alarm-clock',
  icon: [512, 512, [9200], "f34e", "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V304c0 5 2.4 9.8 6.4 12.8l64 48c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4L272 296V176z"]
};
var faEclipse = {
  prefix: 'fal',
  iconName: 'eclipse',
  icon: [640, 512, [], "f749", "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.6-52.2c-10.3-4.5-20.2-9.9-29.6-15.9l-7 38-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 7 38.1c9.4-6.1 19.3-11.4 29.6-15.9l-9.6-52.2zM256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c13.7 0 27-2.2 39.4-6.2c-6.5-9-12.3-18.4-17.3-28.4c-7.1 1.7-14.5 2.6-22.1 2.6c-53 0-96-43-96-96s43-96 96-96c7.6 0 15 .9 22.1 2.6c5-9.9 10.8-19.4 17.3-28.4c-12.4-4-25.7-6.2-39.4-6.2zm64 128a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm320 0a176 176 0 1 0 -352 0 176 176 0 1 0 352 0z"]
};
var faFaceRelieved = {
  prefix: 'fal',
  iconName: 'face-relieved',
  icon: [512, 512, [], "e389", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm187.3 92.7c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C329.4 389.2 298.9 408 256 408s-73.4-18.8-91.3-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm82.4-131.5c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zm107.8 20.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 173.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z"]
};
var faRoadCircleCheck = {
  prefix: 'fal',
  iconName: 'road-circle-check',
  icon: [640, 512, [], "e564", "M157.5 74c9.2-25.2 33.2-42 60.1-42H422.4c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7c-1.5 0-2.9 0-4.4 .1L452.5 85c-4.6-12.6-16.6-21-30.1-21H336v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H217.6c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43H339.2c5.9 11.4 12.9 22.2 21 32H100.6c-44.5 0-75.4-44.2-60.1-86L157.5 74zM336 208v86.6c-3.5 7.6-6.5 15.6-8.9 23.8c-2.1 1.1-4.6 1.7-7.1 1.7c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faDiceFive = {
  prefix: 'fal',
  iconName: 'dice-five',
  icon: [448, 512, [9860], "f523", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm216 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faOctagonMinus = {
  prefix: 'fal',
  iconName: 'octagon-minus',
  icon: [512, 512, ["minus-octagon"], "f308", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM160 240H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMinusOctagon = faOctagonMinus;
var faSquareRss = {
  prefix: 'fal',
  iconName: 'square-rss',
  icon: [448, 512, ["rss-square"], "f143", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240 107.5 240 240c0 8.8 7.2 16 16 16s16-7.2 16-16c0-150.2-121.8-272-272-272zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c79.5 0 144 64.5 144 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-97.2-78.8-176-176-176z"]
};
var faRssSquare = faSquareRss;
var faFaceZany = {
  prefix: 'fal',
  iconName: 'face-zany',
  icon: [512, 512, [], "e3a4", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm272-64c-26.5 0-48-21.5-48-48c0-3.9 .5-7.7 1.4-11.4C261 143.9 271.5 152 284 152c15.5 0 28-12.5 28-28c0-12.5-8.1-23-19.4-26.6c3.6-.9 7.5-1.4 11.4-1.4c26.5 0 48 21.5 48 48s-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM144 184a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm24-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-4.5 166.7c-2.3 6.2-3.5 12.9-3.5 19.9V416c0 53 43 96 96 96s96-43 96-96v-5.4c0-2.3-.1-4.6-.4-6.9c57.3-37.6 82-108 64.4-173.2c-3.7-13.7-19.6-18.7-31.8-11.6L159.8 348.5c-12.3 7.1-15.8 23.4-5.8 33.4c3.1 3.1 6.2 6 9.5 8.8zm175.4-17c-10.8-13.2-27.1-21.6-45.5-21.6h-2c-13.3 0-25.6 4.6-35.4 12.5c-9.7-7.9-22.1-12.5-35.4-12.5h-2c-.3 0-.6 0-.9 0l170.5-98.4c6.9 46-11.6 92.6-49.3 120.1zM291.4 384h2c14.7 0 26.6 11.9 26.6 26.6V416c0 35.3-28.7 64-64 64s-64-28.7-64-64v-5.4c0-14.7 11.9-26.6 26.6-26.6h2c6.7 0 12.8 2.7 17.2 7.2l.2 .3c1.6 1.7 3 3.6 4.1 5.8c.9 1.8 1.6 3.7 2 5.7c2.8 12.6 20.8 12.6 23.6 0c.4-2 1.1-3.9 2-5.7c1.1-2.1 2.5-4.1 4.1-5.8l.2-.3c4.4-4.5 10.6-7.2 17.2-7.2z"]
};
var faTricycle = {
  prefix: 'fal',
  iconName: 'tricycle',
  icon: [512, 512, [], "e5c3", "M272 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3C372.1 64 384 75.9 384 90.7c0 8.4-4 16.3-10.7 21.3l-42.7 32H303.4c-58.4 0-113.2 24.5-152.1 66.1L117.9 160H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H79.4l51 76.5c-2.7 4-5.2 8.1-7.6 12.3l-4.2 7.4c-2.2-.1-4.4-.2-6.6-.2C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-48-30.1-88.9-72.5-104.8C183 209.2 240.8 176 303.4 176h20.1l14.2 56.6C289.9 251.2 256 297.6 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-5.2 0-10.3 .3-15.3 .9l-14.6-58.5 38.4-28.8c14.8-11.1 23.5-28.5 23.5-46.9C416 58.3 389.7 32 357.3 32H272zm73.5 232l23 91.9c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4l-23-91.8c2.5-.2 4.9-.3 7.4-.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-39.3 23.7-73.1 57.5-88zM112 288a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faLandMineOn = {
  prefix: 'fal',
  iconName: 'land-mine-on',
  icon: [640, 512, [], "e51b", "M320 0c-8.8 0-16 7.2-16 16V176c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM192 400h32H416h32 0 32.8c6.3 0 12.1 3.7 14.6 9.5L526.8 480H113.2l31.3-70.5c2.6-5.8 8.3-9.5 14.6-9.5H192h0zm32-32V336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32H224zm224 0V336c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48v32H160h-.8c-19 0-36.2 11.2-43.9 28.5L84 467c-9.4 21.2 6.1 45 29.2 45H526.8c23.2 0 38.6-23.8 29.2-45l-31.3-70.5C517 379.2 499.8 368 480.8 368H480 448h0zM57.6 131.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4l128 96c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4l-128-96zm547.2 3.2c-5.3-7.1-15.3-8.5-22.4-3.2l-128 96c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l128-96c7.1-5.3 8.5-15.3 3.2-22.4z"]
};
var faSquareArrowUpLeft = {
  prefix: 'fal',
  iconName: 'square-arrow-up-left',
  icon: [448, 512, [], "e263", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm280 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H182.6L315.3 324.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16H280z"]
};
var faICursor = {
  prefix: 'fal',
  iconName: 'i-cursor',
  icon: [256, 512, [], "f246", "M0 14.9C-.6 23.7 6 31.3 14.9 32l8 .6C73.1 36.1 112 77.9 112 128.3V240H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h48V383.7c0 50.4-38.9 92.2-89.2 95.8l-8 .6C6 480.7-.6 488.3 0 497.1S8.3 512.6 17.1 512l8-.6c44.6-3.2 82.5-29 102.9-65.7c20.4 36.7 58.3 62.5 102.9 65.7l8 .6c8.8 .6 16.5-6 17.1-14.8s-6-16.5-14.8-17.1l-8-.6c-50.2-3.6-89.2-45.4-89.2-95.8V272h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V128.3c0-50.4 38.9-92.2 89.2-95.8l8-.6c8.8-.6 15.4-8.3 14.8-17.1S247.7-.6 238.9 0l-8 .6c-44.6 3.2-82.5 29-102.9 65.7C107.6 29.6 69.7 3.8 25.1 .6l-8-.6C8.3-.6 .7 6 0 14.9z"]
};
var faChartMixedUpCircleDollar = {
  prefix: 'fal',
  iconName: 'chart-mixed-up-circle-dollar',
  icon: [576, 512, [], "e5d9", "M416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h72.2l-153 139.1L201.8 67.4c-5.6-4.4-13.5-4.5-19.2-.3l-176 128c-7.1 5.2-8.7 15.2-3.5 22.4s15.2 8.7 22.4 3.5L191.7 100 326.2 204.6c6.1 4.8 14.8 4.4 20.6-.8L512 53.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H416zM192 448c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16s16 7.2 16 16V432c0 8.8-7.2 16-16 16zm0-224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM80 432c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16v64zM64 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48V368c0-26.5-21.5-48-48-48zm256 48a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM408.1 339c-.1-1.9 .3-2.9 .8-3.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1z"]
};
var faSaltShaker = {
  prefix: 'fal',
  iconName: 'salt-shaker',
  icon: [384, 512, [129474], "e446", "M352 453.2c0-1.6-.1-3.2-.4-4.7L305.8 192H78.2L32.4 448.5c-.3 1.6-.4 3.1-.4 4.7C32 468 44 480 58.8 480H325.2c14.8 0 26.8-12 26.8-26.8zM300.1 160l-7.9-44.1C283.5 67.3 241.3 32 192 32s-91.5 35.3-100.2 83.9L83.9 160H300.1zm25.1 352H58.8C26.3 512 0 485.7 0 453.2c0-3.5 .3-6.9 .9-10.3L60.3 110.3C71.7 46.5 127.2 0 192 0s120.3 46.5 131.7 110.3l59.4 332.6c.6 3.4 .9 6.9 .9 10.3c0 32.5-26.3 58.8-58.8 58.8zM176 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM151.9 242l-24 192c-1.1 8.8-9.1 15-17.9 13.9s-15-9.1-13.9-17.9l24-192c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9zm112-4l24 192c1.1 8.8-5.1 16.8-13.9 17.9s-16.8-5.1-17.9-13.9l-24-192c-1.1-8.8 5.1-16.8 13.9-17.9s16.8 5.1 17.9 13.9z"]
};
var faStamp = {
  prefix: 'fal',
  iconName: 'stamp',
  icon: [512, 512, [], "f5bf", "M310.4 129.8c6.1-9.8 9.6-21.3 9.6-33.8c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 12.5 3.5 24 9.6 33.8c9.5 15.2 22.4 37.9 22.4 65.1c0 51.4-41.7 93.1-93.1 93.1H112c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H381.1c-51.4 0-93.1-41.7-93.1-93.1c0-27.1 12.9-49.9 22.4-65.1zm27.2 16.9c-9.2 14.8-17.5 30.8-17.5 48.2c0 33.8 27.4 61.1 61.1 61.1H400c61.9 0 112 50.1 112 112c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48c0-61.9 50.1-112 112-112h18.9c33.8 0 61.1-27.4 61.1-61.1c0-17.4-8.3-33.4-17.5-48.2C165.3 132 160 114.6 160 96c0-53 43-96 96-96s96 43 96 96c0 18.6-5.3 36-14.5 50.7zM64 456v8c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-8c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFilePlus = {
  prefix: 'fal',
  iconName: 'file-plus',
  icon: [384, 512, [], "f319", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM176 416c0 8.8 7.2 16 16 16s16-7.2 16-16V352h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64z"]
};
var faDrawSquare = {
  prefix: 'fal',
  iconName: 'draw-square',
  icon: [448, 512, [], "f5ef", "M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96c29.8 0 54.9 20.4 62 48H322c7.1-27.6 32.2-48 62-48c35.3 0 64 28.7 64 64c0 29.8-20.4 54.9-48 62V354c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64c-29.8 0-54.9-20.4-62-48H126c-7.1 27.6-32.2 48-62 48c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V158C20.4 150.9 0 125.8 0 96C0 60.7 28.7 32 64 32zm62 368H322c5.8-22.5 23.5-40.2 46-46V158c-22.5-5.8-40.2-23.5-46-46H126c-5.8 22.5-23.5 40.2-46 46V354c22.5 5.8 40.2 23.5 46 46zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faToiletPaperUnderSlash = {
  prefix: 'fal',
  iconName: 'toilet-paper-under-slash',
  icon: [640, 512, ["toilet-paper-reverse-slash"], "e2a1", "M500.4 480H240c-8.8 0-16-7.2-16-16V416H192v48c0 26.5 21.5 48 48 48H528c3.9 0 7.7-.5 11.3-1.3L500.4 480zM544 327.6v23.7l32 25.3V192c0-50.8-11.2-97.5-30.1-132.1C527.4 25.9 499.1 0 464 0H176c-19.3 0-36.5 7.8-51.1 20.4l25.8 20.4c8.5-6 17.1-8.8 25.3-8.8H401.3c-7.2 8.2-13.6 17.7-19.2 27.9C363.2 94.5 352 141.2 352 192c0 2.6 0 5.2 .1 7.8l33.9 26.7c-1.3-11.1-1.9-22.6-1.9-34.5c0-46.5 10.3-87.7 26.2-116.8C426.4 45.5 446.1 32 464 32s37.6 13.5 53.8 43.2C533.7 104.3 544 145.5 544 192s-10.3 87.7-26.2 116.8c-3 5.4-6 10.3-9.2 14.6l25.1 19.8c3.7-4.9 7.1-10.2 10.2-15.7zM64 192c0 50.8 11.2 97.5 30.1 132.1c18.6 34 46.8 59.9 81.9 59.9H378.8l-40.5-32H176c-17.9 0-37.6-13.5-53.8-43.2C106.3 279.7 96 238.5 96 192c0-10.3 .5-20.4 1.5-30.1L68.2 138.8c-2.8 17-4.2 34.8-4.2 53.2zm400 48c-6.4 0-11.9-11.3-14.5-27.6c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6zm0 32c16.2 0 26.6-9.9 31.4-16c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
var faStairs = {
  prefix: 'fal',
  iconName: 'stairs',
  icon: [576, 512, [], "e289", "M416 48c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H448V176c0 8.8-7.2 16-16 16H304V336c0 8.8-7.2 16-16 16H160V464c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H128V336c0-8.8 7.2-16 16-16H272V176c0-8.8 7.2-16 16-16H416V48z"]
};
var faDroneFront = {
  prefix: 'fal',
  iconName: 'drone-front',
  icon: [640, 512, ["drone-alt"], "f860", "M144 96c8.8 0 16 7.2 16 16v16H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H128V112c0-8.8 7.2-16 16-16zm352 0c8.8 0 16 7.2 16 16v16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H480V112c0-8.8 7.2-16 16-16zM128 256V192h32v55.1l12.6 7.9 50.6-33.7C251.9 202.2 285.5 192 320 192s68.1 10.2 96.8 29.3L467.4 255l12.6-7.9V192h32v64c0 5.5-2.8 10.6-7.5 13.6l-58.1 36.3 7.7 9.2c16.8 20.1 26 45.5 26 71.7V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V386.8c0-18.7-6.6-36.8-18.5-51.2L419 323l-42.5 26.6c-2.5 1.6-5.5 2.4-8.5 2.4H272c-3 0-5.9-.8-8.5-2.4L221 323l-10.5 12.6c-12 14.4-18.5 32.5-18.5 51.2V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V386.8c0-26.2 9.2-51.6 26-71.7l7.7-9.2-58.1-36.3c-4.7-2.9-7.5-8.1-7.5-13.6zm309.6 17.6l-38.5-25.7C375.7 232.3 348.1 224 320 224s-55.6 8.3-79.1 23.9l-38.5 25.7L276.6 320h86.8l74.2-46.4z"]
};
var faDroneAlt = faDroneFront;
var faGlassEmpty = {
  prefix: 'fal',
  iconName: 'glass-empty',
  icon: [384, 512, [], "e191", "M40.1 32c-4.7 0-8.4 4-8 8.7l34.6 410C68.1 467.3 81.9 480 98.6 480H285.4c16.6 0 30.5-12.7 31.9-29.3l34.6-410c.4-4.7-3.3-8.7-8-8.7H40.1zM.2 43.4C-1.7 20 16.7 0 40.1 0H343.8c23.4 0 41.8 20 39.9 43.4l-34.6 410c-2.8 33.1-30.5 58.6-63.8 58.6H98.6c-33.3 0-61-25.5-63.8-58.6L.2 43.4z"]
};
var faDialHigh = {
  prefix: 'fal',
  iconName: 'dial-high',
  icon: [576, 512, [], "e15c", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 248H415c-7.9 63.1-61.7 112-127 112c-70.7 0-128-57.3-128-128s57.3-128 128-128c65.3 0 119.1 48.9 127 112H288c-8.8 0-16 7.2-16 16s7.2 16 16 16zm160-16a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zm120 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faUserHelmetSafety = {
  prefix: 'fal',
  iconName: 'user-helmet-safety',
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", "M176 60.8c-28.7 16.6-48 47.6-48 83.2H320c0-35.5-19.3-66.6-48-83.2V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V32H208V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V60.8zM271.2 25C318.5 43.8 352 90 352 144l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c0-54 33.5-100.2 80.8-119C180 10.7 192.7 0 208 0h32c15.3 0 28 10.7 31.2 25zM224 320c-65.3 0-119.1-48.9-127-112h32.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H351c-7.9 63.1-61.7 112-127 112zM415.8 480c-3.3-53.6-47.8-96-102.2-96H134.4C80 384 35.5 426.4 32.2 480H415.8zM0 486.4C0 412.2 60.2 352 134.4 352H224h89.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4z"]
};
var faUserConstruction = faUserHelmetSafety;
var faUserHardHat = faUserHelmetSafety;
var faI = {
  prefix: 'fal',
  iconName: 'i',
  icon: [320, 512, [105], "49", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H144V448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V64H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H160 16z"]
};
var faHryvniaSign = {
  prefix: 'fal',
  iconName: 'hryvnia-sign',
  icon: [384, 512, [8372, "hryvnia"], "f6f2", "M99.7 86.1C121.3 71.7 146.7 64 172.6 64H231c40.3 0 73 32.7 73 73c0 21.4-9.3 41.3-25 55H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H220.2L106 281.1c-4.1 2.1-8.1 4.4-11.8 6.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H63.6C53.6 336.2 48 355.2 48 375c0 58 47 105 105 105h58.4c32.3 0 63.8-9.5 90.6-27.4l10.9-7.2c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4l-10.9 7.2c-21.6 14.4-46.9 22.1-72.9 22.1H153c-40.3 0-73-32.7-73-73c0-21.4 9.3-41.3 25-55H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H163.8L278 230.9c4.1-2.1 8.1-4.4 11.8-6.9H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H320.4c10-16.2 15.6-35.2 15.6-55c0-58-47-105-105-105H172.6c-32.3 0-63.8 9.5-90.6 27.4L71.1 66.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l10.9-7.2z"]
};
var faHryvnia = faHryvniaSign;
var faArrowDownLeftAndArrowUpRightToCenter = {
  prefix: 'fal',
  iconName: 'arrow-down-left-and-arrow-up-right-to-center',
  icon: [512, 512, [], "e092", "M507.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 169.4 320 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144c0 8.8 7.2 16 16 16l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-105.4 0L507.3 27.3zM4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 342.6 192 448c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16s7.2 16 16 16H169.4L4.7 484.7z"]
};
var faPills = {
  prefix: 'fal',
  iconName: 'pills',
  icon: [576, 512, [], "f484", "M112 64c44.2 0 80 35.8 80 80V256H32V144c0-44.2 35.8-80 80-80zM32 368V288H192v80c0 44.2-35.8 80-80 80s-80-35.8-80-80zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112S0 82.1 0 144zM416 448c-70.7 0-128-57.3-128-128c0-29.6 10-56.8 26.9-78.5L494.5 421.1C472.8 438 445.6 448 416 448zM337.5 218.9C359.2 202 386.4 192 416 192c70.7 0 128 57.3 128 128c0 29.6-10 56.8-26.9 78.5L337.5 218.9zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z"]
};
var faFaceGrinWide = {
  prefix: 'fal',
  iconName: 'face-grin-wide',
  icon: [512, 512, [128515, "grin-alt"], "f581", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm90-166.2c-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3s61.4-2.9 89.9-8.3zm33.8-41.1c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7c5.2-11.7-6.8-22.4-19.1-18.7zM192 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"]
};
var faGrinAlt = faFaceGrinWide;
var faTooth = {
  prefix: 'fal',
  iconName: 'tooth',
  icon: [448, 512, [129463], "f5c9", "M132 64c14.7 0 29 4.8 40.8 13.6l41.6 31.2 21.3 16c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4l-5.4-4 16.3-13.9c13-11.1 29.5-17.2 46.6-17.2c39.5 0 71.6 32.1 71.6 71.6v3c0 11.6-2.7 23-7.9 33.4L354 216.3c-6.2 12.3-10.5 25.5-13 39.1L307.4 443.6 279.3 331.2C272.9 305.8 250.1 288 224 288s-48.9 17.8-55.3 43.2L140.6 443.6 107 255.4c-2.4-13.6-6.8-26.7-13-39.1L71.9 172c-5.2-10.4-7.9-21.8-7.9-33.4V132c0-37.6 30.4-68 68-68zm91.3 11.5L192 52c-17.3-13-38.4-20-60-20C76.8 32 32 76.8 32 132v6.6c0 16.6 3.9 32.9 11.3 47.7l22.2 44.3c4.8 9.6 8.2 19.8 10.1 30.4l34.6 193.6c2.6 14.7 15.4 25.4 30.4 25.4c14.1 0 26.5-9.6 29.9-23.4l29.4-117.7c2.8-11.1 12.8-18.9 24.2-18.9s21.5 7.8 24.2 18.9l29.4 117.7c3.4 13.7 15.8 23.4 29.9 23.4c14.9 0 27.7-10.7 30.4-25.4L372.5 261c1.9-10.6 5.3-20.8 10.1-30.4l22.2-44.3c7.4-14.8 11.3-31.1 11.3-47.7v-3C416 78.4 369.6 32 312.4 32c-24.7 0-48.6 8.8-67.4 24.9L223.3 75.5z"]
};
var faBasketballHoop = {
  prefix: 'fal',
  iconName: 'basketball-hoop',
  icon: [640, 512, [], "f435", "M35.1 201.9C51.5 170.8 135.3 32 320 32s268.5 138.8 284.9 169.9c2.1 4 3.1 8.4 3.1 13V331.2c0 12.6-7.4 24.1-19 29.2l-79.2 35.2-5 37.2L602 389.7c23.1-10.3 38-33.2 38-58.5V214.9c0-8.9-1.8-18.6-6.8-28C615.3 153.1 523.3 0 320 0S24.7 153.1 6.8 187C1.8 196.3 0 206 0 214.9V331.2c0 25.3 14.9 48.2 38 58.5l97.2 43.2-5-37.2L51 360.4c-11.6-5.1-19-16.6-19-29.2V214.9c0-4.6 .9-9 3.1-13zM192 176c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16v32h32V176c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48v32h32V176zm-48 64H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h18l30.1 226.1c.8 6.2 5.2 11.4 11.3 13.2s12.6-.1 16.7-4.8l48.3-55.7 56.3 56.5c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7l56.3-56.5 48.3 55.7c4.1 4.8 10.6 6.7 16.7 4.8s10.4-7 11.3-13.2L494 272h18c8.8 0 16-7.2 16-16s-7.2-16-16-16H496 480.2c-.2 0-.3 0-.5 0H448 400.1c-.1 0-.1 0-.2 0H368.1c0 0-.1 0-.1 0H272.1c0 0-.1 0-.1 0H240.1c-.1 0-.1 0-.2 0H192 160.3c-.2 0-.3 0-.5 0H144zm34.3 32h54.4l1.4 1.7-48.6 53.1L178.3 272zM279 272H361l2.1 2.2-43 49.6-43-49.6L279 272zm128.3 0h54.4l-7.3 54.7-48.6-53.1 1.4-1.7zM320 473.3l-46.6-46.8L320 372.7l46.6 53.8L320 473.3zm-69.3-69.5l-48.1-48.3L255.2 298l43.6 50.3-48.1 55.5zm-21 24.2l-26.5 30.6-8.8-66.1 35.3 35.5zm159.6-24.2l-48.1-55.5L384.8 298l52.6 57.5-48.1 48.3zm21 24.2l35.3-35.5-8.8 66.1-26.5-30.6z"]
};
var faObjectsAlignBottom = {
  prefix: 'fal',
  iconName: 'objects-align-bottom',
  icon: [512, 512, [], "e3bb", "M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l480 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512zM176 352c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16h64zm-64 32c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0h64c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48H112zm288-32c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16h64zm-64 32c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48H336z"]
};
var faV = {
  prefix: 'fal',
  iconName: 'v',
  icon: [384, 512, [118], "56", "M9.8 33.3c8.1-3.4 17.5 .4 21 8.5L192 422.9 353.3 41.8c3.4-8.1 12.8-11.9 21-8.5s11.9 12.8 8.5 21l-176 416c-2.5 5.9-8.3 9.8-14.7 9.8s-12.2-3.8-14.7-9.8L1.3 54.2c-3.4-8.1 .4-17.5 8.5-21z"]
};
var faSparkles = {
  prefix: 'fal',
  iconName: 'sparkles',
  icon: [512, 512, [10024], "f890", "M432 32c8.8 0 16 7.2 16 16V96h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V48c0-8.8 7.2-16 16-16zm0 288c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V336c0-8.8 7.2-16 16-16zM136.8 216.4L54.2 254.6l82.6 38.1c6.9 3.2 12.4 8.7 15.6 15.6l38.1 82.6 38.1-82.6c3.2-6.9 8.7-12.4 15.6-15.6l82.6-38.1-82.6-38.1c-6.9-3.2-12.4-8.7-15.6-15.6l-38.1-82.6-38.1 82.6c-3.2 6.9-8.7 12.4-15.6 15.6zM123.4 321.8L9.3 269.1C3.6 266.5 0 260.8 0 254.6s3.6-11.9 9.3-14.5l114.1-52.7L176 73.3c2.6-5.7 8.3-9.3 14.5-9.3s11.9 3.6 14.5 9.3l52.7 114.1L371.8 240c5.7 2.6 9.3 8.3 9.3 14.5s-3.6 11.9-9.3 14.5L257.8 321.8 205.1 435.8c-2.6 5.7-8.3 9.3-14.5 9.3s-11.9-3.6-14.5-9.3L123.4 321.8z"]
};
var faSquid = {
  prefix: 'fal',
  iconName: 'squid',
  icon: [512, 512, [129425], "e450", "M245.6 4.6c3.5-3.4 8.3-5.1 13.2-4.5L391.1 15.8C419.3 9.3 450.4 4.3 484.9 1c15-1.4 27.6 11.2 26.2 26.2c-3.3 34.4-8.4 65.6-14.8 93.7L512.8 254c.6 4.9-1.1 9.8-4.6 13.3s-8.4 5.2-13.3 4.6l-57.9-7.1c-7.3 10.7-14.9 20.4-22.8 29.1c-43.9 48.9-94.7 68.2-136.9 72.9l40.1 40.1c6.1 6.1 15.9 6.3 22.2 .4l66.8-62c18.9-17.6 48.3-17 66.6 1.2l34.2 34.2c6 6 6.3 15.5 .7 21.9l-11 12.5c-30.5 34.8-84.1 36.6-116.8 3.9l-2.9-2.9-15.9 14.7c-18.9 17.6-48.3 17-66.6-1.2l-50.3-50.3-30.1 20.7 38.1 38.1c18.7 18.7 18.7 49.1 0 67.9l-1.4 1.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.4-1.4c6.2-6.2 6.2-16.4 0-22.6l-42.3-42.3L153.3 442c-5.8 4-9.1 10.5-9 17.5c.2 11.4 9.5 20.5 20.8 20.5h11.7c8.8 0 16 7.2 16 16s-7.2 16-16 16H165.2c-28.9 0-52.4-23.1-52.8-52c-.3-17.7 8.3-34.4 22.9-44.4l29.5-20.3-48.1-48.1L95.9 377.4C86.2 391.6 70.2 400 53 400C24.2 400 .9 376.7 .9 347.9V336c0-8.8 7.2-16 16-16s16 7.2 16 16v11.9c0 11.1 9 20.1 20.1 20.1c6.6 0 12.8-3.3 16.6-8.7l24.1-35L51.3 281.9c-6.2-6.2-16.4-6.2-22.6 0l-1.4 1.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.4-1.4c18.7-18.7 49.1-18.7 67.9 0l38.1 38.1 20.7-30.1L82.5 217.1c-18.3-18.3-18.8-47.7-1.2-66.6L96 134.6l-2.9-2.9C60.3 99 62.1 45.4 96.9 14.9L109.5 4c6.3-5.5 15.9-5.2 21.8 .7l34.2 34.2c18.3 18.3 18.8 47.7 1.2 66.6l-62 66.8c-5.9 6.3-5.7 16.1 .4 22.2l40.1 40.1c4.7-42.2 24-93 72.9-136.9c8.8-7.9 18.5-15.5 29.2-22.8L241 17.8c-.5-4.9 1.2-9.7 4.6-13.1zm31.9 52c11.7-6.2 24.4-12.1 38-17.6L275 34.3l2.5 22.4zM135.1 320.5l56.4 56.4 45.2-31.1c9.5-6.5 20.2-9.5 30.6-10.3c36.3-2.6 82.7-18 123.2-63.1c39.6-44.1 74.6-117.8 87.7-238.7C357.3 46.9 283.6 81.9 239.5 121.5C194.4 162 179 208.4 176.4 244.7c-.7 10.3-3.8 21.1-10.3 30.6l-31.1 45.2zm320.1-85.7l23.3 2.9-5.2-42c-5.6 14.1-11.7 27.1-18.1 39.1zM117.8 111.2l25.5-27.5c5.9-6.3 5.7-16.1-.4-22.2L119.3 37.9 118 39c-20.9 18.3-22 50.4-2.3 70.1l2.1 2.1zm283 283l2.1 2.1c19.6 19.6 51.8 18.6 70.1-2.3l1.1-1.3-23.6-23.6c-6.1-6.1-15.9-6.3-22.2-.4l-27.5 25.5zM208.9 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faLeafyGreen = {
  prefix: 'fal',
  iconName: 'leafy-green',
  icon: [576, 512, [129388], "e41d", "M233.8 27c-38-36.5-98.4-36-135.8 1.5C92 34.4 87 40.8 83 47.7C70 69.6 50.6 89.9 30.9 105.9c-2.3 1.8-4.4 3.8-6.5 5.9C-1.4 137.6-6.8 176.2 8.5 207.2c5.7 11.7 11 24.1 11 37.1v35.7c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2l0 12.9c0 2.9 .2 5.8 .7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6V336.9c-3.3-5-7-9.6-11.3-13.9L58.3 296.7c-4.4-4.4-6.9-10.4-6.9-16.6l0-35.7c0-21.1-8.5-39.3-14.3-51.2c-9.4-19.2-6-42.9 9.8-58.7L25.2 112.6 47 134.4c1.3-1.3 2.7-2.5 4-3.6C72.8 113.2 95.1 90.1 110.5 64c2.7-4.6 6.1-8.9 10.1-13c25.4-25.4 66.6-25.4 92.1 0l14.7-14.7L212.6 51.1c1.7 1.7 3.2 3.4 4.6 5.1c2.8-6.9 6.2-13.6 10.1-19.8c2-3.2 4.2-6.4 6.4-9.4zM68.7 507.3c6.2 6.2 16.4 6.2 22.6 0l0 0 40.6-40.6c12-12 28.3-18.7 45.3-18.7h68.4c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7h43c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3C540.9 317.9 568 282.1 568 240c0-3.4-.2-6.8-.5-10.1c-3.1-29.1-2.3-61.5 5-89.9c2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5c-28.4 7.3-60.8 8.1-89.9 5c-3.3-.3-6.7-.5-10.1-.5c-42.1 0-77.9 27.1-90.8 64.9c-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3v43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3v68.4c0 17-6.7 33.3-18.7 45.3L68.7 484.7c-6.2 6.2-6.2 16.4 0 22.6zM182.6 416L283.3 315.3 342.6 256H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H374.6l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96L288 265.4V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4l-96 96V330.5c0-8.5 3.4-16.6 9.4-22.6l10.5-10.5c18-18 28.1-42.4 28.1-67.9v-43c0-8.5 3.4-16.6 9.4-22.6l29.1-29.1c16.4-16.4 24-37.1 29-51.5C284.1 58 308 40 336 40c2.3 0 4.6 .1 6.8 .4c31.7 3.3 68.1 2.7 101.2-5.8c6.4-1.6 13-2.5 20-2.5c44.2 0 80 35.8 80 80c0 6.9-.9 13.6-2.5 20c-8.5 33.1-9.2 69.5-5.8 101.2c.2 2.2 .4 4.5 .4 6.8c0 28-18 51.9-43.2 60.6c-14.4 4.9-35.2 12.6-51.5 29l-29.1 29.1c-6 6-14.1 9.4-22.6 9.4h-43c-25.5 0-49.9 10.1-67.9 28.1l-10.5 10.5c-6 6-14.1 9.4-22.6 9.4H182.6z"]
};
var faCircleArrowUpRight = {
  prefix: 'fal',
  iconName: 'circle-arrow-up-right',
  icon: [512, 512, [], "e0fc", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 160H336c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V214.6L187.3 347.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 192H200c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCalendars = {
  prefix: 'fal',
  iconName: 'calendars',
  icon: [512, 512, [], "e0d7", "M208 0c8.8 0 16 7.2 16 16V64H384V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v64V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V192 128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zM160 96c-17.7 0-32 14.3-32 32v32H480V128c0-17.7-14.3-32-32-32H160zm320 96H128V352c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192zM32 208V384c0 53 43 96 96 96H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 512 0 454.7 0 384V208c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faBangladeshiTakaSign = {
  prefix: 'fal',
  iconName: 'bangladeshi-taka-sign',
  icon: [384, 512, [], "e2e6", "M50 32.1C41.2 31 33.2 37.2 32.1 46S37.2 62.8 46 63.9l7.9 1c24 3 42 23.4 42 47.6V192H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H96V400c0 44.2 35.8 80 80 80h32c97.2 0 176-78.8 176-176V272c0-44.2-35.8-80-80-80H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c26.5 0 48 21.5 48 48v32c0 79.5-64.5 144-144 144H176c-26.5 0-48-21.5-48-48V224h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H128V112.5c0-40.3-30-74.4-70.1-79.4l-7.9-1z"]
};
var faBicycle = {
  prefix: 'fal',
  iconName: 'bicycle',
  icon: [640, 512, [128690], "f206", "M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h38.3l50.5 96H223.5l-33.7-56.2c-2.9-4.8-8.1-7.8-13.7-7.8H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h54.9L197 178.2l-26.5 53.1c-13.3-4.7-27.6-7.2-42.5-7.2C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h65c5.9 0 11.2-3.2 14-8.3l83.4-152.9 21.2 40.3C405.6 270.2 384 308.6 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-15.8 0-31 2.9-45 8.1L368.4 44.8C364.3 36.9 356.1 32 347.2 32H304zM453.8 275.7l44.1 83.8c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6l-44.1-83.8c9.4-3.1 19.5-4.8 29.9-4.8c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-31.1 14.8-58.8 37.8-76.3zM156 260.2l-40 80.1c-6.4 12.8 2.9 27.8 17.2 27.8h89.5c-7.6 45.4-47.1 80-94.7 80c-53 0-96-43-96-96s43-96 96-96c9.8 0 19.2 1.5 28 4.2zM153.9 336l62.7-125.3L291.7 336H153.9zm88.8-144H389L319.3 319.8 242.7 192z"]
};
var faHammerWar = {
  prefix: 'fal',
  iconName: 'hammer-war',
  icon: [384, 512, [], "f6e4", "M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V53.2L36.7 32.4C17.7 29.5 0 44.7 0 64V256c0 19.3 17.7 34.5 36.7 31.6l150.5-22.6c3.1-.5 6.3-.5 9.5 0l150.5 22.6c19.1 2.9 36.7-12.4 36.7-31.6V64c0-19.3-17.7-34.5-36.7-31.6L208 53.2V16zm0 283.1l-16-2.4-16 2.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V299.1zM32 255.8V64.2c0 0 .1-.1 .1-.1s.1-.1 .1-.1L182.5 86.6c6.3 .9 12.7 .9 19 0L351.8 64c0 0 .1 .1 .1 .1s.1 .1 .1 .1V255.8c0 0-.1 .1-.1 .1c0 0 0 0-.1 0s0 0-.1 0L201.5 233.4c-6.3-.9-12.7-.9-19 0L32.2 256c0 0-.1-.1-.1-.1s-.1-.1-.1-.1z"]
};
var faCircleD = {
  prefix: 'fal',
  iconName: 'circle-d',
  icon: [512, 512, [], "e104", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-160H192V160h64c53 0 96 43 96 96s-43 96-96 96zM190.8 128c-17 0-30.8 13.8-30.8 30.8V353.2c0 17 13.8 30.8 30.8 30.8H256c70.7 0 128-57.3 128-128s-57.3-128-128-128H190.8z"]
};
var faSpiderBlackWidow = {
  prefix: 'fal',
  iconName: 'spider-black-widow',
  icon: [512, 512, [], "f718", "M151.2 1.7c7.9 4 11.1 13.6 7.2 21.5l-46.1 92.2c-3 6-2 13.2 2.6 18L176 199.3V152c0-32.2 19-59.9 46.3-72.6c7.7-3.6 16.8-.5 20.8 6.9L256 110.3l12.9-23.9c4-7.5 13.2-10.5 20.8-6.9C317 92.1 336 119.8 336 152v47.3l61.2-65.9c4.5-4.9 5.6-12.1 2.6-18L353.7 23.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2L428.4 101c8.9 17.9 5.9 39.5-7.8 54.1l-71.1 76.5 101.6-26.7c5.2-1.4 9.4-5.3 11.1-10.4l18.5-55.6c2.8-8.4 11.9-12.9 20.2-10.1s12.9 11.9 10.1 20.2l-18.5 55.6c-5.1 15.4-17.7 27.1-33.3 31.2L382.9 256l76.5 20.1c15.7 4.1 28.2 15.9 33.3 31.2l18.5 55.6c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-18.5-55.6c-1.7-5.1-5.9-9-11.1-10.4l-84-22.1L427 368.7c9.4 13.1 11.5 30.1 5.7 45.1l-33.8 87.9c-3.2 8.2-12.4 12.4-20.7 9.2s-12.4-12.4-9.2-20.7l33.8-87.9c1.9-5 1.2-10.7-1.9-15L367.9 341c-2.6 59.5-51.7 107-111.9 107s-109.3-47.5-111.9-107L111 387.3c-3.1 4.4-3.8 10-1.9 15l33.8 87.9c3.2 8.2-.9 17.5-9.2 20.7s-17.5-.9-20.7-9.2L79.2 413.8c-5.8-15.1-3.6-32 5.7-45.1L144.8 285l-84 22.1c-5.2 1.4-9.4 5.3-11.1 10.4L31.2 373.1c-2.8 8.4-11.9 12.9-20.2 10.1S-2 371.3 .8 362.9l18.5-55.6C24.5 292 37 280.2 52.7 276.1L129.1 256 52.7 235.9C37 231.8 24.5 220 19.3 204.6L.8 149.1c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1l18.5 55.6c1.7 5.1 5.9 9 11.1 10.4l101.6 26.7L91.4 155.1c-13.6-14.7-16.7-36.2-7.8-54.1L129.7 8.8c4-7.9 13.6-11.1 21.5-7.2zM270.1 151.6c-2.8 5.2-8.2 8.4-14.1 8.4s-11.3-3.2-14.1-8.4l-18.7-34.7c-9.4 8.8-15.2 21.3-15.2 35.1V256v0l0 .4c0 4.6-1.9 8.9-5.3 12C186.3 283 176 304.3 176 328v8c0 44.2 35.8 80 80 80s80-35.8 80-80v-8c0-23.7-10.3-45-26.7-59.6c-3.4-3-5.3-7.4-5.3-12l0-.4v0V152c0-13.8-5.9-26.3-15.2-35.1l-18.7 34.7zM218.4 307.2c-1.6-2.1-2.4-4.6-2.4-7.2c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12c0 2.6-.8 5.1-2.4 7.2L272 336l21.6 28.8c1.6 2.1 2.4 4.6 2.4 7.2c0 6.6-5.4 12-12 12H228c-6.6 0-12-5.4-12-12c0-2.6 .8-5.1 2.4-7.2L240 336l-21.6-28.8z"]
};
var faStaffSnake = {
  prefix: 'fal',
  iconName: 'staff-snake',
  icon: [384, 512, ["rod-asclepius", "rod-snake", "staff-aesculapius"], "e579", "M296 48H208V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V48H120 64C28.7 48 0 76.7 0 112s28.7 64 64 64h8c39.8 0 72-32.2 72-72V80h32V192v32 64H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V192H128c-35.3 0-64 28.7-64 64s28.7 64 64 64h48v96H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v2.7V496c0 8.8 7.2 16 16 16s16-7.2 16-16V450.7 448 416 320h32c26.5 0 48 21.5 48 48s-21.5 48-48 48v32c44.2 0 80-35.8 80-80s-35.8-80-80-80H208V224 192 80h88c30.9 0 56 25.1 56 56s-25.1 56-56 56H240v32h56c48.6 0 88-39.4 88-88s-39.4-88-88-88zM112 80v24c0 22.1-17.9 40-40 40H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h48zM72 120a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faRodAsclepius = faStaffSnake;
var faRodSnake = faStaffSnake;
var faStaffAesculapius = faStaffSnake;
var faPear = {
  prefix: 'fal',
  iconName: 'pear',
  icon: [512, 512, [], "e20c", "M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6L453.1 81.5C470 103.2 480 130.4 480 160c0 30.7-10.8 58.9-28.9 81c-29.9 36.5-61.4 81.8-73.3 127.4c-8.3 32-25 62.3-50.1 87.3c-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1c45.7-11.8 90.9-43.4 127.4-73.3c22.1-18 50.3-28.9 81-28.9c29.6 0 56.8 10 78.5 26.9L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0zm-118.6 96l18.9-18.9C391.9 70.6 372.7 64 352 64c-23.1 0-44.2 8.1-60.7 21.6c-37.1 30.3-86.9 65.8-139.7 79.5c-26.6 6.9-51.8 20.8-72.8 41.7c-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c20.9-20.9 34.8-46.1 41.7-72.8c13.7-52.8 49.2-102.6 79.5-139.7C439.9 204.2 448 183.1 448 160c0-20.7-6.6-39.9-17.7-55.6l-18.9 18.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM304 336c0 53-43 96-96 96c-8.8 0-16-7.2-16-16s7.2-16 16-16c35.3 0 64-28.7 64-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHeadSideCoughSlash = {
  prefix: 'fal',
  iconName: 'head-side-cough-slash',
  icon: [640, 512, [], "e062", "M224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 7.4-2.8 14.1-7.4 19.1l25.2 19.9c8.9-10.5 14.3-24.1 14.3-38.9c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0 0 0 0 0 0 0 0 0 0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224c-34.8 0-67.7 7.9-97.1 22.1l28.5 22.5C176.8 36.4 199.9 32 224 32zM31.3 109.7C11.4 143.1 0 182.2 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224c0-34.3 9-66.5 24.7-94.3l-25.4-20zM528.5 339.1l33.7 26.6c8.1-3.8 13.8-12.1 13.8-21.7c0-13.3-10.7-24-24-24c-11.6 0-21.2 8.2-23.5 19.1zm63.6 50.2l32 25.3c9.2-3.3 15.8-12.2 15.8-22.6c0-13.3-10.7-24-24-24c-12.3 0-22.5 9.3-23.9 21.3zM432 426l-23.6-18.7-66.5-5.5c-3.3-.3-5.8-3-5.8-6.4c0-3.2 2.3-5.9 5.5-6.3l37.1-5.3-34.7-27.4-7 1c-18.9 2.7-33 18.9-33 38c0 20 15.3 36.6 35.2 38.2l59.9 5C396.2 448.7 387 456 376 456H304c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-8h56c30.9 0 56-25.1 56-56v-6zM640 296a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTriangle = {
  prefix: 'fal',
  iconName: 'triangle',
  icon: [512, 512, [9650], "f2ec", "M235.5 75.8c4.2-7.3 12-11.8 20.5-11.8s16.2 4.5 20.5 11.8l201 344.6c1.6 2.8 2.5 6 2.5 9.3c0 10.2-8.2 18.4-18.4 18.4H50.4C40.2 448 32 439.8 32 429.6c0-3.3 .9-6.4 2.5-9.3l201-344.6zM207.9 59.6L6.9 404.2C2.4 411.9 0 420.7 0 429.6C0 457.4 22.6 480 50.4 480H461.6c27.8 0 50.4-22.6 50.4-50.4c0-8.9-2.4-17.7-6.9-25.4L304.1 59.6C294.1 42.5 275.8 32 256 32s-38.1 10.5-48.1 27.6z"]
};
var faApartment = {
  prefix: 'fal',
  iconName: 'apartment',
  icon: [576, 512, [], "e468", "M128 128H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H192h32V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h32H512c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448c-17.7 0-32-14.3-32-32V64c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32V96c0 17.7-14.3 32-32 32zM320 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm-96 96H192 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H96h32V64c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64v64 32h32 32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H384 352 336 240 224zm288-88c0 13.3-10.7 24-24 24H440c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48zm-32-8V384H448v32h32zM136 384H88c-13.3 0-24-10.7-24-24V312c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zm-8-64H96v32h32V320zm384-24c0 13.3-10.7 24-24 24H440c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48zm-32-8V256H448v32h32zM136 256H88c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zm-8-64H96v32h32V192zm208 72c0 13.3-10.7 24-24 24H264c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48zm-32-8V224H272v32h32zm8-96H264c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zm-8-64H272v32h32V96z"]
};
var faTruckMedical = {
  prefix: 'fal',
  iconName: 'truck-medical',
  icon: [640, 512, [128657, "ambulance"], "f0f9", "M352 32c17.7 0 32 14.3 32 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352zM416 128h65.3c4.7 0 9.1 2 12.1 5.6L570.9 224H416V128zm0 216.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM192 64c-17.7 0-32 14.3-32 32v32l-32 0c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224h32c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H256V96c0-17.7-14.3-32-32-32H192zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H240c-8.8 0-16 7.2-16 16v48H192V208c0-8.8-7.2-16-16-16H128V160h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V96z"]
};
var faAmbulance = faTruckMedical;
var faPepper = {
  prefix: 'fal',
  iconName: 'pepper',
  icon: [512, 512, [129745], "e432", "M195.7 5.8c5.7-6.8 15.7-7.7 22.5-2L208 16C218.2 3.7 218.2 3.7 218.3 3.7l0 0 0 0 .1 .1 .2 .2 .6 .5c.5 .4 1.1 1 1.9 1.7c1.6 1.5 3.7 3.6 6.2 6.3c5 5.5 11.7 13.5 18.3 23.9c10.6 16.8 21.2 40 25 69c19.5-9.3 42.2-12.2 64.7-6.5c10.5 2.6 20.1 6.9 28.7 12.4c21.5-13.8 48.5-19.1 75.3-12.4c51.4 12.9 82.7 65 69.8 116.4l-56 224c-12.9 51.4-65 82.7-116.4 69.8c-10.5-2.6-20.1-6.9-28.7-12.4c-5.7 3.7-11.8 6.7-18.3 9.2c-10.6 4-22 6.1-33.7 6.1c-11.7 0-23.1-2.1-33.7-6.1c-6.5-2.4-12.6-5.5-18.3-9.2c-8.6 5.5-18.3 9.8-28.7 12.4C123.8 522 71.7 490.7 58.9 439.3l-56-224C-10 163.8 21.3 111.7 72.7 98.9c26.8-6.7 53.8-1.4 75.3 12.4c7.5-4.9 15.9-8.7 24.9-11.4c.8-.2 1.5-.4 2.3-.6c.5-.1 1.1-.3 1.6-.4c21.2-5.3 42.6-3.1 61.2 4.9c-3.6-20.9-11.5-37.7-19.5-50.3c-5.4-8.5-10.8-15-14.7-19.3c-2-2.1-3.6-3.7-4.6-4.7c-.5-.5-.9-.9-1.2-1.1l-.2-.2c-6.8-5.7-7.7-15.7-2-22.5zM123.4 134.1c-12.9-6.1-28-8-42.9-4.2c-34.3 8.6-55.1 43.3-46.6 77.6l56 224c8.6 34.3 43.3 55.1 77.6 46.6c10-2.5 18.8-7.2 26.1-13.4c6-5.1 14.8-5.1 20.8 0c5.5 4.7 12 8.6 19.1 11.3l0 0c7.1 2.7 14.7 4.1 22.5 4.1h0c7.8 0 15.4-1.4 22.4-4.1l0 0c7.1-2.7 13.6-6.5 19.1-11.3c6-5.1 14.8-5.1 20.8 0c7.3 6.2 16.1 10.9 26.1 13.4c34.3 8.6 69-12.3 77.6-46.6l56-224c8.6-34.3-12.3-69-46.6-77.6c-20.9-5.2-41.9 .4-57.1 13.4c-6 5.1-14.8 5.1-20.8 0c-7.3-6.2-16.1-10.9-26.1-13.4c-22.4-5.6-44.9 1.3-60.3 16.4c-6.2 6.1-16.2 6.1-22.4 0c-15.4-15.1-38-22-60.3-16.4l0 0c-34.3 8.6-55.1 43.3-46.6 77.6L175.5 358c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6L106.9 215.3c-7.3-29.3-.3-58.8 16.5-81.1zM256 512h0l0-16 0 16h0z"]
};
var faPiano = {
  prefix: 'fal',
  iconName: 'piano',
  icon: [512, 512, [], "f8d4", "M432 384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H240v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H176v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H112v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H32v64c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V384H432zm-16-32h64V327.6c0-12.1-6.8-23.2-17.7-28.6l-58.4-29.2c-31.8-15.9-51.9-48.4-51.9-84C352 100.8 283.2 32 198.3 32H192C103.6 32 32 103.6 32 192V352H96h64 64H352h64zm96-24.4V352v16 16 64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384 368 352 192C0 86 86 0 192 0h6.3C300.8 0 384 83.2 384 185.7c0 23.5 13.2 44.9 34.2 55.4l58.4 29.2c21.7 10.8 35.4 33 35.4 57.2z"]
};
var faGunSquirt = {
  prefix: 'fal',
  iconName: 'gun-squirt',
  icon: [576, 512, [], "e19d", "M128 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V64C43 64 0 107 0 160c0 47.3 34.3 86.7 79.4 94.6L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480H168c14.7 0 27.5-10 31-24.2L225 352h63v16c0 8.8 7.2 16 16 16s16-7.2 16-16V336 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H233l16-64H448c35.6 0 66.6-19.3 83.2-48H536c22.1 0 40-17.9 40-40V152c0-22.1-17.9-40-40-40h-4.8C514.6 83.3 483.6 64 448 64H128V48zM112 96H448c26.2 0 48.8 15.8 58.7 38.4c2.5 5.8 8.3 9.6 14.7 9.6H536c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H521.3c-6.4 0-12.1 3.8-14.7 9.6C496.8 208.2 474.2 224 448 224H257 224 96c-35.3 0-64-28.7-64-64s28.7-64 64-64h16zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H448c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM64 448l48-192H216L168 448H64z"]
};
var faWheatAwnCircleExclamation = {
  prefix: 'fal',
  iconName: 'wheat-awn-circle-exclamation',
  icon: [640, 512, [], "e598", "M491.2 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L341.8 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L319.9 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L281.9 26.4c-6.2-6.2-16.4-6.2-22.6 0L225.4 60.3c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0l-33.9 33.9c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0L44.4 241.3C7 278.8 7 339.6 44.4 377.1L78.4 411l0 0L4.8 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L101 433.6l0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c8.3-.5 16.5-2 24.4-4.6c-2-10.5-3-21.4-3-32.4l0-.7c-23.6 10.9-52.5 6.6-72-12.9l-33.9-33.9c31.8-31.8 80.3-36.6 117.1-14.5c4.5-12 10.3-23.4 17.2-33.9c-3.5-2.3-6.9-5-9.9-8.1L304.6 230c29.9-29.8 74.5-35.9 110.3-18.2c11.6-6.1 24.1-10.9 37-14.2c-2.5-2-5-3.8-7.6-5.6l46.8-46.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-54.3 54.4c-16.1-5.5-33-7.8-49.8-6.7L491.2 43.3zM191.8 297.5l-.3 .3-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3c37.4 37.4 37.5 97.9 .4 135.4zM248 82.9l22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7L248 173.4c-25-25-25-65.5 0-90.5zM89.7 241.3l11.3 11.3c37.5 37.5 37.5 98.2 0 135.7L67.1 354.4c-25-25-25-65.5 0-90.5l22.6-22.6zm181 181L248 444.9c-25 25-65.5 25-90.5 0L123.6 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faSnowman = {
  prefix: 'fal',
  iconName: 'snowman',
  icon: [512, 512, [9731, 9924], "f7d0", "M256 0C194.1 0 144 50.1 144 112c0 17.6 4 34.2 11.3 49c-5.7 7.3-10.7 15.2-14.7 23.6L96 169.8V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v47.1L21.1 144.8C12.7 142 3.6 146.6 .8 154.9s1.7 17.4 10.1 20.2L130.4 215c-1.6 8.1-2.4 16.4-2.4 25c0 14 2.2 27.4 6.4 40C110.5 308 96 344.3 96 384c0 41.2 15.6 78.8 41.2 107.2c13.7 15.2 33.2 20.8 51 20.8H323.9c17.8 0 37.3-5.7 51-20.8c25.6-28.4 41.2-66 41.2-107.2c0-39.7-14.5-76-38.4-104c4.1-12.6 6.4-26.1 6.4-40c0-8.5-.8-16.9-2.4-25l119.5-39.8c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1L448 159.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.8l-44.6 14.9c-4.1-8.4-9-16.4-14.7-23.6c7.2-14.8 11.3-31.5 11.3-49C368 50.1 317.9 0 256 0zM176 112c0-44.2 35.8-80 80-80s80 35.8 80 80c0 15.6-4.5 30.2-12.2 42.5c-3.9 6.2-3.1 14.2 1.9 19.5C342 191.2 352 214.4 352 240c0 13.3-2.7 25.9-7.5 37.3c-2.5 5.9-1.2 12.8 3.3 17.4C370.2 317.8 384 349.3 384 384c0 33-12.5 63-32.9 85.7c-5.9 6.6-15.6 10.3-27.2 10.3H188.1c-11.6 0-21.3-3.7-27.2-10.3C140.5 447 128 417 128 384c0-34.7 13.8-66.2 36.3-89.3c4.5-4.6 5.8-11.5 3.3-17.4c-4.8-11.5-7.5-24.1-7.5-37.3c0-25.6 10-48.8 26.3-66c5-5.3 5.8-13.3 1.9-19.5C180.5 142.2 176 127.6 176 112zm96 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 43.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V136c0-8.8-7.2-16-16-16s-16 7.2-16 16v3.2z"]
};
var faUserAlien = {
  prefix: 'fal',
  iconName: 'user-alien',
  icon: [448, 512, [], "e04a", "M224 32C154.6 32 96 91.1 96 167c0 39.5 21.1 78.5 49.8 112.7c28.3 33.6 60.7 58.7 76 69.6c.1 .1 .8 .5 2.2 .5s2.1-.4 2.2-.5c15.2-10.9 47.7-35.9 76-69.6C330.9 245.5 352 206.5 352 167c0-75.9-58.6-135-128-135zM64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 101-106.6 185-139.2 208.3c-6.1 4.3-13.4 6.5-20.8 6.5s-14.7-2.1-20.8-6.5C170.6 352 64 268.1 64 167zm62.1 185.2c12.8 12.5 25.1 23.2 35.8 31.7H134.4C80 384 35.5 426.4 32.2 480H415.8c-3.3-53.6-47.8-96-102.2-96H286.2c10.6-8.6 23-19.3 35.8-31.7C392.3 356.6 448 415 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 415 55.7 356.6 126.1 352.3zm23-175.4l48 16c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-48-16c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1zm160 30.4l-48 16c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2z"]
};
var faShieldCheck = {
  prefix: 'fal',
  iconName: 'shield-check',
  icon: [512, 512, [], "f2f7", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zm82.3 195.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faMortarPestle = {
  prefix: 'fal',
  iconName: 'mortar-pestle',
  icon: [512, 512, [], "f5a7", "M478.2 35l0 0c-1.4-1.7-3.3-2.7-5.4-2.9c-1.2-.1-2.4 0-3.5 .4l0 0c-.7 .3-1.4 .6-2.1 1.1l-.3 .2 0 0L292.6 160H238.1L448.2 7.9c3.3-2.4 6.8-4.3 10.5-5.6c5.7-2 11.7-2.7 17.6-2.1c10.2 1.1 20 6.1 26.9 14.7c2.9 3.6 5.1 7.6 6.6 11.8c2 5.7 2.7 11.7 2.1 17.6c-1 9.7-5.6 19-13.4 25.8L398.1 160H350.1L477 46.3l.3-.3 0 0c1.5-1.3 2.4-3.1 2.7-5.2c.1-1.2 0-2.4-.4-3.5l0 0c-.3-.8-.7-1.6-1.3-2.3zM64 224v32c0 69.4 35.3 122.2 102.6 146.1c9.7 3.5 17.2 11.4 20.1 21.4s.7 20.7-5.8 28.7c-6.6 8.3-11.9 17.7-15.4 27.8H346.5c-3.6-10.1-8.8-19.5-15.4-27.8c-6.4-8.1-8.6-18.8-5.8-28.7s10.3-17.9 20.1-21.4C412.7 378.2 448 325.4 448 256V224H64zM352 480h0c.1 0 .1 0 0 0zm-192 0c-.1 0-.1 0 0 0h0zM512 208c0 8.8-7.2 16-16 16H480v32c0 71.6-32.7 130.1-93.8 163c-9.4 5-19.4 9.5-30.1 13.3c6.8 8.5 12.5 17.8 16.9 27.9c2.9 6.5 5.2 13.2 7 20.2c4.4 17.1-10.4 31.7-28.1 31.7H160c-17.7 0-32.4-14.6-28.1-31.7c1.8-7 4.1-13.7 7-20.2c4.5-10 10.2-19.4 16.9-27.9c-10.7-3.8-20.7-8.2-30.1-13.3C64.7 386.1 32 327.6 32 256V224H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32 480h16c8.8 0 16 7.2 16 16z"]
};
var faRoadBarrier = {
  prefix: 'fal',
  iconName: 'road-barrier',
  icon: [640, 512, [], "e562", "M16 32c8.8 0 16 7.2 16 16V80H608l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32v32V272v32l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160H32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 272 112 80 48c0-8.8 7.2-16 16-16zM608 272V112H569.9l-80 160H608zM32 272H70.1l80-160H32V272zM406.1 112H313.9l-80 160h92.2l80-160zm35.8 0l-80 160h92.2l80-160H441.9zm-256 0l-80 160h92.2l80-160H185.9z"]
};
var faChartCandlestick = {
  prefix: 'fal',
  iconName: 'chart-candlestick',
  icon: [512, 512, [], "e0e2", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zm288 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V96c0 .3 0 .5 0 .8c-18.3 3.7-32 19.8-32 39.2v80c0 19.4 13.8 35.5 32 39.2c0 .3 0 .5 0 .8v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-.3 0-.5 0-.8c18.3-3.7 32-19.8 32-39.2V136c0-19.4-13.8-35.5-32-39.2c0-.3 0-.5 0-.8V48zM176 64c-8.8 0-16 7.2-16 16v48c0 .3 0 .5 0 .8c-18.3 3.7-32 19.8-32 39.2V280c0 19.4 13.8 35.5 32 39.2c0 .3 0 .5 0 .8v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-.3 0-.5 0-.8c18.3-3.7 32-19.8 32-39.2V168c0-19.4-13.8-35.5-32-39.2c0-.3 0-.5 0-.8V80c0-8.8-7.2-16-16-16zm144 72v80c0 4.4-3.6 8-8 8H296c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8zm104 88h16c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8zm-8-32c0 .3 0 .5 0 .8c-18.3 3.7-32 19.8-32 39.2v48c0 19.4 13.8 35.5 32 39.2c0 .3 0 .5 0 .8v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-.3 0-.5 0-.8c18.3-3.7 32-19.8 32-39.2V232c0-19.4-13.8-35.5-32-39.2c0-.3 0-.5 0-.8V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48zM184 160c4.4 0 8 3.6 8 8V280c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8V168c0-4.4 3.6-8 8-8h16z"]
};
var faBriefcaseBlank = {
  prefix: 'fal',
  iconName: 'briefcase-blank',
  icon: [512, 512, [], "e0c8", "M160 48V96H352V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM128 96V48c0-26.5 21.5-48 48-48H336c26.5 0 48 21.5 48 48V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm240 32H144 64c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H368z"]
};
var faSchool = {
  prefix: 'fal',
  iconName: 'school',
  icon: [640, 512, [127979], "f549", "M328.9 2.7c-5.4-3.6-12.4-3.6-17.8 0L171.2 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H256h32 64 32H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H468.8L328.9 2.7zM384 384c0-35.3-28.7-64-64-64s-64 28.7-64 64v96H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H176c3.2 0 6.2-.9 8.9-2.7L320 35.2l135.1 90.1c2.6 1.8 5.7 2.7 8.9 2.7H576c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H384V384zm-32 96H288V384c0-17.7 14.3-32 32-32s32 14.3 32 32v96zM96 192v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm64 0v64H128V192h32zm320-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H480zm0 32h32v64H480V192zM96 352v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm64 0v64H128V352h32zm320-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H480zm0 32h32v64H480V352zM320 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm16-128c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V160z"]
};
var faIgloo = {
  prefix: 'fal',
  iconName: 'igloo',
  icon: [576, 512, [], "f7ae", "M576 320v32 64c0 35.3-28.7 64-64 64H384 192 64c-35.3 0-64-28.7-64-64V320C0 160.9 128.9 32 288 32s288 128.9 288 288zm-32 32H480 448 384v96H512c17.7 0 32-14.3 32-32V352zm0-32c0-46.6-12.5-90.3-34.2-128H480V320h64zM352 192H320 128V320h69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H448V192H352zM96 352H32v64c0 17.7 14.3 32 32 32H192V352H128 96zm0-32V192H66.2C44.5 229.7 32 273.4 32 320H96zM487.9 160C453.8 117.5 406.4 86.1 352 72.1V160H487.9zM320 66c-10.5-1.3-21.2-2-32-2c-80.8 0-152.9 37.5-199.9 96H320V66zM288 288c-35.3 0-64 28.7-64 64v96H352V352c0-35.3-28.7-64-64-64z"]
};
var faBracketRound = {
  prefix: 'fal',
  iconName: 'bracket-round',
  icon: [192, 512, ["parenthesis"], "28", "M158.1 40.4c4.2 7.8 1.3 17.5-6.4 21.7C111.5 83.8 32 153.4 32 256s79.5 172.2 119.6 193.9c7.8 4.2 10.7 13.9 6.4 21.7s-13.9 10.7-21.7 6.4C91.2 453.6 0 375.3 0 256S91.2 58.4 136.4 33.9c7.8-4.2 17.5-1.3 21.7 6.4z"]
};
var faParenthesis = faBracketRound;
var faJoint = {
  prefix: 'fal',
  iconName: 'joint',
  icon: [640, 512, [], "f595", "M448 16V43c0 42.4 16.9 83.1 46.9 113.1l21 21c18 18 28.1 42.4 28.1 67.9v27c0 8.8-7.2 16-16 16s-16-7.2-16-16V245c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 272V245c0-42.4-16.9-83.1-46.9-113.1l-21-21C522.1 92.9 512 68.4 512 43V16c0-8.8 7.2-16 16-16s16 7.2 16 16V43c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8v27c0 8.8-7.2 16-16 16s-16-7.2-16-16zM116.1 452.3c51.8 14 117 27.7 171.9 27.7h35.2l-71.5-85.8-6.6-7.9c-43.9 4.5-90.2 14.9-129.1 25.3c-22.9 6.2-45.6 12.8-67.8 20.3c22.3 7.4 45 14.2 67.8 20.3zM284.8 384l71.5 85.7 8.5 10.2H483.2l-71.5-85.8L403.2 384H288c-1 0-2.1 0-3.2 0zm160 0l71.5 85.8 8.5 10.2H600c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H444.8zM15.8 409.5c30.1-11 61.1-20.3 92-28.6C160.3 366.7 228.8 352 288 352H600c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H288c-59.2 0-127.7-14.7-180.2-28.8c-30.8-8.3-62-17.8-92-28.6C6.3 451.1 0 442.1 0 432s6.3-19.1 15.8-22.5z"]
};
var faHorseSaddle = {
  prefix: 'fal',
  iconName: 'horse-saddle',
  icon: [576, 512, [], "f8c3", "M336 144c0-61.9 50.1-112 112-112h24 8 5.8c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7c-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1H432c-8.8 0-16 7.2-16 16v52.8c-.3 1.5-.4 3-.3 4.5c.2 2.2 .3 4.4 .3 6.7c0 24-10.4 45.1-26.7 59.6c-3.4 3-5.3 7.4-5.3 11.9V472c0 4.4-3.6 8-8 8H344c-4.4 0-8-3.6-8-8V334.7c0-7.8-5.6-14.5-13.3-15.8c-1.4-.2-2.8-.5-4.3-.8L256 304V254.7c45.4-7.6 80-47.1 80-94.7V144zm-96 80c-35.3 0-64-28.7-64-64h16 40 72c0 35.3-28.7 64-64 64zm-16 30.7v42.1l-21.8-4.9c-5.2-1.2-10.6 .3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7c0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1H141.6c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9c0-4.6-.9-9.3-2.7-13.5L99.9 230.2C97.3 224 96 217.4 96 210.7c0-27.1 21.3-49.2 48-50.6c0 47.5 34.6 87 80 94.6zM192 128H160 146.7c-33.5 0-62.3 19.9-75.3 48.5C31.3 180.8 0 214.7 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-20.9 13.4-38.7 32-45.3c0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2 .4 .2 .8 .2 1.2c0 .4-.1 .9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3h33.2c26.5 0 45.6-25.2 38.5-50.7l-15.9-57.2c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4L304 347.6V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V318.4c19.6-20 32-47.5 32-78.4c0-1.9-.1-3.9-.1-5.8c.1-.7 .1-1.4 .1-2.2V192h7.4l1.7 2.5c19 28.6 57.4 36.8 86.5 18.6c20.4-12.7 31.8-35.9 29.6-59.9l-7.7-80.8c-1.5-15.5-7.3-29.7-16.3-41.3C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16H485.8 480h-8H448C373.9 0 312.8 56 304.9 128H232 192zM496 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faMugMarshmallows = {
  prefix: 'fal',
  iconName: 'mug-marshmallows',
  icon: [512, 512, [], "f7b7", "M357.7 103c6.6 6.6 10.3 15.6 10.3 25H336c0-.9-.3-1.7-1-2.3L277.2 67.8c-2.4-2.4-5.7-3.8-9.2-3.8s-6.7 1.4-9.2 3.8L201 125.7c-.6 .6-1 1.5-1 2.3H168c0-9.4 3.7-18.3 10.3-25l57.9-57.9C244.6 36.7 256.1 32 268 32s23.4 4.7 31.8 13.2L357.7 103zM64 80v48H32V80c0-26.5 21.5-48 48-48H204.1l-32 32H80c-8.8 0-16 7.2-16 16zM32 384c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V192H336 128v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H32V384zm0-224h80H336h16 48c61.9 0 112 50.1 112 112s-50.1 112-112 112H384c0 53-43 96-96 96H96c-53 0-96-43-96-96V192c0-17.7 14.3-32 32-32zM384 352h16c44.2 0 80-35.8 80-80s-35.8-80-80-80H384V352z"]
};
var faFilters = {
  prefix: 'fal',
  iconName: 'filters',
  icon: [640, 512, [], "e17e", "M231.1 32C209.5 32 192 49.5 192 71.1c0 9.7 3.6 19.1 10.2 26.3L352 262.2v97.7c0 10.2 4.9 19.9 13.2 25.9L445 443.8c3.8 2.7 8.3 4.2 13 4.2c12.2 0 22-9.9 22-22V262.2L629.8 97.4c6.5-7.2 10.2-16.6 10.2-26.3C640 49.5 622.5 32 600.9 32H231.1zM224 71.1c0-3.9 3.2-7.1 7.1-7.1H600.9c3.9 0 7.1 3.2 7.1 7.1c0 1.8-.7 3.5-1.8 4.8l-154 169.4c-2.7 2.9-4.2 6.8-4.2 10.8V406.4l-64-46.5V256c0-4-1.5-7.8-4.2-10.8L225.8 75.8c-1.2-1.3-1.8-3-1.8-4.8zM164.5 96H39.1C17.5 96 0 113.5 0 135.1c0 9.7 3.6 19.1 10.2 26.3L160 326.2v65.7c0 10.2 4.9 19.9 13.2 25.9L253 475.8c3.8 2.7 8.3 4.2 13 4.2c12.2 0 22-9.9 22-22V326.2L320 291V274.6L305.8 259l-45.7 50.3c-2.7 2.9-4.2 6.8-4.2 10.8V438.4l-64-46.5V320c0-4-1.5-7.8-4.2-10.8L33.8 139.8c-1.2-1.3-1.8-3-1.8-4.8c0-3.9 3.2-7.1 7.1-7.1H186.8l-8.3-9.1c-6.1-6.7-10.8-14.5-14-22.9z"]
};
var faBellOn = {
  prefix: 'fal',
  iconName: 'bell-on',
  icon: [640, 512, [128365], "f8fa", "M606.3 8.8c4 7.9 .7 17.5-7.2 21.5l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2zM304 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3H140.3C115.8 416 96 396.2 96 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8c30.9-30.9 48.3-72.8 48.3-116.6V192c0-83 63.1-151.2 144-159.2V16zm16 48c-70.7 0-128 57.3-128 128v29.1c0 52.2-20.7 102.3-57.7 139.2l-2.8 2.8c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3H499.7c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2V192c0-70.7-57.3-128-128-128zM289.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C371.6 494.2 347.9 512 320 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM0 176c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm544-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zM40.8 30.3c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32z"]
};
var faAngleRight = {
  prefix: 'fal',
  iconName: 'angle-right',
  icon: [320, 512, [8250], "f105", "M267.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256 84.7 107.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l160 160z"]
};
var faDialMed = {
  prefix: 'fal',
  iconName: 'dial-med',
  icon: [576, 512, [], "e15f", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm16 232V161c63.1 7.9 112 61.7 112 127c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-65.3 48.9-119.1 112-127V288c0 8.8 7.2 16 16 16s16-7.2 16-16zM288 128a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHorse = {
  prefix: 'fal',
  iconName: 'horse',
  icon: [576, 512, [128014], "f6f0", "M336 144c0 8.8-7.2 16-16 16H232 192 146.7c-28 0-50.7 22.7-50.7 50.7c0 6.7 1.3 13.3 3.9 19.5l33.4 80.1c1.8 4.3 2.7 8.9 2.7 13.5c0 4.8-1 9.5-2.8 13.9l-8.1 19c-9.3 21.7-10.9 46-4.6 68.8l13.5 48.6c1 3.5 4.1 5.9 7.7 5.9h33.2c5.3 0 9.1-5 7.7-10.1l-15.9-57.2c-3.4-12.3-2.5-25.3 2.5-37l8.1-19c4.4-10.4 6.7-21.5 6.7-32.8c0-4.6-.4-9.2-1.1-13.7c-.9-5.3 .9-10.6 4.8-14.3s9.3-5.2 14.5-4L318.4 318c1.4 .3 2.8 .6 4.3 .8c7.7 1.3 13.3 8 13.3 15.8V472c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V311.6c0-4.6 1.9-8.9 5.3-11.9C405.6 285.1 416 264 416 240c0-2.3-.1-4.5-.3-6.7c-.1-1.5 0-3.1 .3-4.5V176c0-8.8 7.2-16 16-16h32c5.4 0 10.3 2.7 13.3 7.1l6.4 9.6c9.4 14.2 28.5 18.3 42.9 9.2c10.1-6.3 15.8-17.8 14.7-29.7l-7.7-80.8c-2.3-24.6-23-43.4-47.8-43.4H480h-8H448c-61.9 0-112 50.1-112 112zM549.2 31.1c8.9 11.6 14.8 25.7 16.3 41.3l7.7 80.8c2.3 23.9-9.2 47.1-29.6 59.9c-29.1 18.2-67.4 10-86.5-18.6l-1.7-2.5H448v40c0 .7-.1 1.5-.1 2.2c.1 1.9 .1 3.9 .1 5.8c0 30.9-12.4 58.4-32 78.4V472c0 22.1-17.9 40-40 40H344c-22.1 0-40-17.9-40-40V347.6l-88.1-19.8c-.5 14.3-3.6 28.3-9.2 41.4l-8.1 19c-2.2 5-2.5 10.6-1.1 15.9l15.9 57.2c7.1 25.5-12.1 50.7-38.5 50.7H141.6c-18 0-33.7-12-38.5-29.3L89.6 434.1c-8.3-29.8-6.2-61.5 6-90l8.1-19c.2-.4 .3-.8 .3-1.3c0-.4-.1-.8-.2-1.2L70.4 242.5c-4.2-10.1-6.4-20.8-6.4-31.7c-18.6 6.6-32 24.4-32 45.3v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-41.3 31.3-75.2 71.4-79.5c13-28.6 41.8-48.5 75.3-48.5H192h40 72.9c8-72 69-128 143.1-128h24 8 5.8H544c8.8 0 16 7.2 16 16c0 7-4.5 13-10.8 15.1zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faQ = {
  prefix: 'fal',
  iconName: 'q',
  icon: [448, 512, [113], "51", "M32 256c0 106 86 192 192 192c42.6 0 81.9-13.9 113.8-37.3L227.9 282.4c-5.8-6.7-5-16.8 1.7-22.6s16.8-5 22.6 1.7l109.7 128C395.4 355 416 307.9 416 256c0-106-86-192-192-192S32 150 32 256zM358.7 435c-37.5 28.2-84.1 45-134.7 45C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 61.7-24.9 117.5-65.2 158l61.4 71.6c5.8 6.7 5 16.8-1.7 22.6s-16.8 5-22.6-1.7L358.7 435z"]
};
var faMonitorWaveform = {
  prefix: 'fal',
  iconName: 'monitor-waveform',
  icon: [576, 512, ["monitor-heart-rate"], "f611", "M64 64C46.3 64 32 78.3 32 96V256H176c5.3 0 10.3 2.7 13.3 7.1l30.8 46.2 53-139c2.3-5.9 7.8-10 14.2-10.3s12.3 3.1 15.1 8.8L345.9 256H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-6.1 0-11.6-3.4-14.3-8.8L290 215.7l-51 134c-2.1 5.6-7.2 9.5-13.2 10.2s-11.8-2-15.1-7L167.4 288H32V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faMonitorHeartRate = faMonitorWaveform;
var faLinkSimple = {
  prefix: 'fal',
  iconName: 'link-simple',
  icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H160C89.3 128 32 185.3 32 256s57.3 128 128 128h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c70.7 0 128-57.3 128-128s-57.3-128-128-128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c88.4 0 160 71.6 160 160zM152 240H424c8.8 0 16 7.2 16 16s-7.2 16-16 16H152c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faWhistle = {
  prefix: 'fal',
  iconName: 'whistle',
  icon: [640, 512, [], "f460", "M93.4 115.3C79.5 128.1 67.6 143 58 159.4c-14.8-2.8-26-15.8-26-31.4c0-17.7 14.3-32 32-32c13.2 0 24.5 7.9 29.4 19.3zM0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192c64.7 0 121.9-32 156.7-81L529 444.4c4.6 2.4 9.6 3.6 14.8 3.6h2c9 0 17.6-3.8 23.7-10.5l63.4-69.7c4.6-5 7.1-11.6 7.1-18.4c0-8.5-3.9-16.5-10.6-21.6L500.8 228.2c-5.2-4-12.4-4.5-18-1.1l-17.7 10.6c-10.3 6.2-23.4 5.5-33-1.7c-9.7-7.3-14-19.8-10.8-31.5l5.7-21c1.7-6.2-.5-12.9-5.6-16.9l-62.6-48.4c-.9-.7-1.8-1.3-2.7-1.7C321.6 84 275.2 64 224 64c-38.8 0-74.8 11.5-105 31.2C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128zM569.5 437.5l-23.4-21.3c-.1 .1-.1 .1-.2 .1h-2c-.1 0-.1 0-.1 0L395.4 338.9c-14-7.3-31.3-3.2-40.5 9.8c-29.1 41-76.9 67.7-130.9 67.7c-88.5 0-160.3-71.8-160.3-160.3s71.8-160.3 160.3-160.3c42.7 0 81.5 16.7 110.3 43.9c1.8 1.7 3.9 3.3 6.1 4.5l53.3 41.3-3 10.9c-6.6 24.2 2.2 50.1 22.3 65.1c19.9 14.9 46.9 16.3 68.3 3.5l8.5-5.1L606.3 350l-60.2 66.2 23.4 21.3zM256 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"]
};
var faG = {
  prefix: 'fal',
  iconName: 'g',
  icon: [448, 512, [103], "47", "M224 64C118 64 32 150 32 256s86 192 192 192c98.5 0 179.8-74.3 190.7-169.9c.2-1.5-.3-2.8-1.4-4c-1.2-1.2-3.1-2.2-5.3-2.2H242.3c-8.8 0-16-7.2-16-16s7.2-16 16-16H408c21.5 0 41.3 17.9 38.5 41.8C433.7 393.4 339 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c6.6 5.9 7.1 16 1.3 22.6s-16 7.1-22.6 1.3C318 82.5 273.2 64 224 64z"]
};
var faWineGlassCrack = {
  prefix: 'fal',
  iconName: 'wine-glass-crack',
  icon: [320, 512, ["fragile"], "f4bb", "M149.2 32L61.2 32 46.4 195.6C40.3 262.4 92.9 320 160 320s119.7-57.6 113.6-124.4L258.8 32l-75.1 0 23.2 58.1c3.1 7.7-.3 16.5-7.7 20.3L155 132.4l48.3 48.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-3.6-3.6-5.3-8.8-4.5-13.9s4-9.4 8.6-11.7l50.8-25.4L149.2 32zM160.3 0h98.4c16.6 0 30.4 12.6 31.9 29.1l14.9 163.6c7.3 80.2-51.4 150-129.5 158.5V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160 80c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.1C65.9 342.7 7.2 272.8 14.5 192.7L29.4 29.1C30.9 12.6 44.7 0 61.2 0h98.4c.2 0 .5 0 .7 0z"]
};
var faFragile = faWineGlassCrack;
var faSlotMachine = {
  prefix: 'fal',
  iconName: 'slot-machine',
  icon: [640, 512, [], "e3ce", "M416 416v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416H416zm23.4 64c5.4-9.4 8.6-20.3 8.6-32V416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64v32c0 35.3 28.7 64 64 64H384 528c44.2 0 80-35.8 80-80V221.3c18.6-6.6 32-24.4 32-45.3c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 20.9 13.4 38.7 32 45.3V432c0 26.5-21.5 48-48 48H439.4zM576 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 64V96H96V64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32zm32 64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H448zM112 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h40.9L113 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9H112zm120 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h40.9L233 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9H232zm120 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h40.9L353 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9H352z"]
};
var faNotesMedical = {
  prefix: 'fal',
  iconName: 'notes-medical',
  icon: [512, 512, [], "f481", "M128 96c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32V293.5c0 8.5-3.4 16.6-9.4 22.6l-58.5 58.5c-6 6-14.1 9.4-22.6 9.4H160c-17.7 0-32-14.3-32-32V96zM96 96V352c0 35.3 28.7 64 64 64H357.5c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM320 496c0-8.8-7.2-16-16-16H128c-53 0-96-43-96-96l0-240c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H304c8.8 0 16-7.2 16-16zM272 112c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V272h32c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32H336V144c0-17.7-14.3-32-32-32H272zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H320c-8.8 0-16 7.2-16 16v48H272V256c0-8.8-7.2-16-16-16H208V208h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V144z"]
};
var faCarWash = {
  prefix: 'fal',
  iconName: 'car-wash',
  icon: [448, 512, [], "f5e6", "M76.3 92.5C74.7 93.9 71 96 64 96c-8.8 0-16-7.2-16-16c0-1.7 1.6-8.3 8.6-19.6c2.3-3.7 4.8-7.5 7.4-11c2.6 3.6 5.2 7.3 7.4 11C78.4 71.7 80 78.3 80 80c0 8.4-2.6 11.4-3.7 12.5zM64 128c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2C69 5.1 59 5.1 53.2 11.8C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48zM240 80c0 8.4-2.6 11.4-3.7 12.5C234.7 93.9 231 96 224 96c-8.8 0-16-7.2-16-16c0-1.7 1.6-8.3 8.6-19.6c2.3-3.7 4.8-7.5 7.4-11c2.6 3.6 5.2 7.3 7.4 11C238.4 71.7 240 78.3 240 80zm32 0c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48s48-16 48-48zM156.2 208H291.8c14.3 0 26.8 9.5 30.8 23.2L338.8 288c-.9 0-1.9 0-2.8 0H112c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zM94.7 222.4L73 298.1C48.6 311.8 32 338 32 368v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H384v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H156.2c-28.6 0-53.7 18.9-61.5 46.4zM384 416v16H64V416 368c0-26.5 21.5-48 48-48H336c26.5 0 48 21.5 48 48v48zM112 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM400 80c0 8.4-2.6 11.4-3.7 12.5C394.7 93.9 391 96 384 96c-8.8 0-16-7.2-16-16c0-1.7 1.6-8.3 8.6-19.6c2.3-3.7 4.8-7.5 7.4-11c2.6 3.6 5.2 7.3 7.4 11C398.4 71.7 400 78.3 400 80zm32 0c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48s48-16 48-48z"]
};
var faEscalator = {
  prefix: 'fal',
  iconName: 'escalator',
  icon: [640, 512, [], "e171", "M264 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 184 56zm211.3 91.8C409.9 135 428.6 128 448 128H560c44.2 0 80 35.8 80 80s-35.8 80-80 80H478.1L244.7 492.2C230.1 505 211.4 512 192 512H80c-44.2 0-80-35.8-80-80s35.8-80 80-80h81.9L395.3 147.8zM448 160c-11.6 0-22.9 4.2-31.6 11.9L178.5 380c-2.9 2.6-6.7 4-10.5 4H80c-26.5 0-48 21.5-48 48s21.5 48 48 48H192c11.6 0 22.9-4.2 31.6-11.9L461.5 260c2.9-2.6 6.7-4 10.5-4h88c26.5 0 48-21.5 48-48s-21.5-48-48-48H448zM307.9 181.7l-24.6 21.5C275.6 187.1 259.1 176 240 176c-26.5 0-48 21.5-48 48v59.2l-32 28V224c0-44.2 35.8-80 80-80c28.7 0 53.8 15.1 67.9 37.7z"]
};
var faCommentImage = {
  prefix: 'fal',
  iconName: 'comment-image',
  icon: [512, 512, [], "e148", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM184 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104.2 16c.1 0 .2 .1 .3 .1L379.4 288H133.3L175 240.3c.1-.2 .4-.3 .6-.3c.2 0 .5 .1 .6 .3l19 25.3c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.4c.1-.1 .2-.2 .3-.2zm-25.9-19L208 229.3l-6.2-8.2c-6.2-8.3-15.9-13.1-26.2-13.1c-9.5 0-18.4 4.1-24.7 11.2l-48.1 55c-4.4 5-6.8 11.5-6.8 18.2c0 15.3 12.4 27.6 27.6 27.6H388.2c15.4 0 27.8-12.4 27.8-27.8c0-6.4-2.2-12.6-6.2-17.5L313.3 156c-6.2-7.6-15.4-12-25.1-12c-10.2 0-19.8 4.8-25.9 13z"]
};
var faTemperatureHalf = {
  prefix: 'fal',
  iconName: 'temperature-half',
  icon: [320, 512, [127777, "temperature-2", "thermometer-2", "thermometer-half"], "f2c9", "M160 32c-35.3 0-64 28.7-64 64V252.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96V252.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V208c0-8.8 7.2-16 16-16s16 7.2 16 16v98c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z"]
};
var faTemperature2 = faTemperatureHalf;
var faThermometer2 = faTemperatureHalf;
var faThermometerHalf = faTemperatureHalf;
var faDongSign = {
  prefix: 'fal',
  iconName: 'dong-sign',
  icon: [384, 512, [], "e169", "M304 32c-8.8 0-16 7.2-16 16V64H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V203.3c-23.5-26.6-57.8-43.3-96-43.3c-70.7 0-128 57.3-128 128s57.3 128 128 128c38.2 0 72.5-16.8 96-43.3V400c0 8.8 7.2 16 16 16s16-7.2 16-16V288 96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V48c0-8.8-7.2-16-16-16zM96 288a96 96 0 1 1 192 0A96 96 0 1 1 96 288zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faDonut = {
  prefix: 'fal',
  iconName: 'donut',
  icon: [512, 512, [127849, "doughnut"], "e406", "M32 208c0-29.2 19-60.4 59.9-86C132.4 96.7 190.3 80 256 80c3.1 0 6.2 0 9.3 .1l-20.6 20.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l39.8-39.8c44.4 6.1 83.3 20 112.9 38.5C461 147.6 480 178.8 480 208v15c-.6 8.5-3.7 16.5-8.8 23.2c-5.3 6.8-12.4 11.9-20.6 14.5l-.3 .1-.3 .1c-6.6 2.5-12.6 6-17.9 10.5c-.1-3.9-1.7-7.8-4.7-10.8l-32-32c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c3.6 3.6 8.6 5.1 13.3 4.6c-7.7 9.5-17.5 17.2-28.7 22.3c-12.6 5.9-26.6 8.3-40.4 7.2l-.6 0-.6 0c-15.9-.2-31.7 2.9-46.4 9l0 0-.1 0c-14.2 6.1-29.6 9.1-45 9v0l-.3 0c-15.5 .1-30.8-2.9-45.1-9l-.1 0c-14.7-6.1-30.5-9.2-46.4-9l-.6 0-.6 0c-13.9 1.1-27.8-1.4-40.4-7.2c-12.5-5.8-23.4-14.8-31.5-26.1c-7-10.6-17.2-18.8-29.1-23.2l-.4-.1-.4-.1c-8.2-2.6-15.3-7.7-20.6-14.5c-5.2-6.7-8.2-14.8-8.8-23.2V208zm0 73.4c5.9 4.1 12.3 7.3 19.2 9.6c5.5 2.1 10.2 6 13.4 10.9l.2 .3 .2 .3c11.3 15.9 26.6 28.5 44.2 36.7c17.5 8.1 36.7 11.6 55.9 10.2c11.4 0 22.7 2.2 33.2 6.6c18.2 7.7 37.9 11.6 57.7 11.5c19.8 .2 39.4-3.7 57.6-11.5c10.5-4.4 21.8-6.6 33.2-6.6c19.2 1.5 38.4-2 55.9-10.1c17.7-8.2 32.9-20.8 44.2-36.6l.2-.3 .2-.3c3.2-5 7.9-8.8 13.4-10.9c6.9-2.3 13.3-5.5 19.2-9.6V304c0 29.2-19 60.4-59.9 86c-40.5 25.3-98.4 42-164.1 42s-123.6-16.7-164.1-42C51 364.4 32 333.2 32 304V281.4zM256 48C114.6 48 0 119.6 0 208v96c0 88.4 114.6 160 256 160s256-71.6 256-160V208c0-88.4-114.6-160-256-160zM208 191.9c0 0 0-.1 .1-.3c.1-.3 .4-.9 1.1-1.7c1.5-1.7 4.2-4 8.7-6.2c8.9-4.5 22.4-7.7 38.1-7.7s29.2 3.2 38.1 7.7c4.5 2.2 7.2 4.5 8.7 6.2c.7 .8 1 1.4 1.1 1.7c.1 .2 .1 .3 .1 .3s0 .1 0 .1s0 0 0 .1s0 .1-.1 .3c-.1 .3-.4 .9-1.1 1.7c-1.5 1.7-4.2 4-8.7 6.2c-8.9 4.5-22.4 7.7-38.1 7.7s-29.2-3.2-38.1-7.7c-4.5-2.2-7.2-4.5-8.7-6.2c-.7-.8-1-1.4-1.1-1.7c-.1-.2-.1-.3-.1-.3c0 0 0 0 0-.1s0 0 0 0s0 0 0-.1zm-4.4-36.9C190.3 161.7 176 173.8 176 192s14.3 30.3 27.6 36.9c14.2 7.1 32.8 11.1 52.4 11.1s38.2-3.9 52.4-11.1c13.3-6.6 27.6-18.8 27.6-36.9s-14.3-30.3-27.6-36.9C294.2 147.9 275.6 144 256 144s-38.2 3.9-52.4 11.1zm-32.3-15.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm224-6.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zM64 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm91.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm176 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"]
};
var faDoughnut = faDonut;
var faCapsules = {
  prefix: 'fal',
  iconName: 'capsules',
  icon: [576, 512, [], "f46b", "M32 240H192V144c0-44.2-35.8-80-80-80s-80 35.8-80 80v96zM0 256V144C0 82.1 50.1 32 112 32s112 50.1 112 112v24.2c3-32.2 19.3-63 47.3-83c50.7-36.2 120.5-23.6 156 28.1L555.7 300.6c35.5 51.7 23.2 123-27.5 159.2s-120.5 23.6-156-28.1L243.8 244.4c-11.5-16.8-18-35.7-19.8-54.8V256 368c0 61.9-50.1 112-112 112S0 429.9 0 368V256zm192 16H32v96c0 44.2 35.8 80 80 80s80-35.8 80-80V272zM398.6 413.6c25.5 37.1 75.1 45.8 111 20.1c36.3-26 45.5-77.6 19.7-115.1l-52.7-76.8-2.2 1.6L344.4 334.6l54.2 79.1zm57.5-196.4l2.5-1.7-57.7-84.2c-25.5-37.1-75.1-45.8-111-20.1c-36.3 26-45.5 77.6-19.7 115.1l56.1 81.8 129.8-90.9z"]
};
var faPooStorm = {
  prefix: 'fal',
  iconName: 'poo-storm',
  icon: [448, 512, ["poo-bolt"], "f75a", "M173.8 6.7c3-4.2 7.9-6.7 13-6.7C257.3 0 326.2 46 335 119.6c28.9 13.3 49 42.5 49 76.4c0 3.5-.2 7-.6 10.4C421.1 220.7 448 257.2 448 300c0 55.2-44.8 100-100 100h-8.9l12.1-11.5c6.7-6.3 11.5-14.2 14.3-22.8C394.6 358 416 331.5 416 300c0-33-23.5-60.5-54.6-66.7c-4.5-.9-8.4-3.7-10.7-7.7s-2.8-8.8-1.3-13.1c1.7-5.2 2.7-10.7 2.7-16.5c0-23.4-15.5-43.2-36.8-49.7c-6.5-2-11-7.9-11.3-14.7c-2-50.8-42.9-88.8-94.2-97.6c.4 1.4 .8 2.7 1.3 4.1c2.3 7.8 5 17.8 5 25.4c0 34.8-17.7 55.5-35.3 66.9c-8.5 5.5-17 8.8-23.2 10.7c-3 .9-5.6 1.6-7.5 2c-1.5 .6-3.2 1-4.9 1.1C117.7 145.6 96 168.3 96 196c0 5.8 .9 11.4 2.7 16.5c1.5 4.4 1 9.1-1.3 13.1s-6.2 6.8-10.7 7.7C55.5 239.5 32 267 32 300c0 32 22.2 58.9 52 66.1c-2.6 6.4-4 13.3-4 20.3c0 4.1 .5 8 1.3 11.8C35 389.5 0 348.8 0 300c0-42.8 26.9-79.3 64.6-93.6c-.4-3.4-.6-6.9-.6-10.4c0-43.7 33.4-79.6 76.1-83.6c.5-.1 1.1-.2 1.6-.3l.2 0c.2 0 .6-.1 1.2-.2c1.1-.2 2.8-.7 5-1.3c4.3-1.3 9.8-3.5 15.3-7c10.4-6.7 20.7-18.2 20.7-40c0-2.2-1.2-7.8-3.7-16.2c-2.3-7.6-5.1-15.6-7.1-21.5l-.1-.2 0 0 0 0c-.6-1.6-1.1-3.1-1.5-4.3c-1.7-4.9-.9-10.3 2.1-14.5zM159.7 376H208c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L288.3 360H240c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L159.7 376zM281.6 224c14.7 0 24.4 15.2 18.2 28.5L265 328h49.4c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L180.2 506.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L183 408H133.6c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L267.8 229.5c3.7-3.5 8.7-5.5 13.8-5.5z"]
};
var faPooBolt = faPooStorm;
var faTally1 = {
  prefix: 'fal',
  iconName: 'tally-1',
  icon: [640, 512, [], "e294", "M128 32c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16z"]
};
var faFaceFrownOpen = {
  prefix: 'fal',
  iconName: 'face-frown-open',
  icon: [512, 512, [128550, "frown-open"], "f57a", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm22 192.1c-22.4-9.5-47.7-14.8-74.5-14.8c-26.8 0-52 5.3-74.4 14.8c-11.2 4.7-23.8 3.1-32.8-3.6c-9.7-7.2-14.9-20.4-9-33.9c19.2-44.1 64.2-74.7 116.2-74.7c52 0 97 30.6 116.2 74.7c5.9 13.6 .8 26.7-9 33.9c-9 6.6-21.5 8.3-32.8 3.5zm-74.4-80.2c-36.9 0-68.5 20.3-83.9 49.5c25.6-10.4 54-16.1 83.9-16.1c29.9 0 58.4 5.8 84 16.1c-15.4-29.2-47.1-49.5-84-49.5z"]
};
var faFrownOpen = faFaceFrownOpen;
var faSquareDashed = {
  prefix: 'fal',
  iconName: 'square-dashed',
  icon: [448, 512, [], "e269", "M88 32h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-30.9 0-56 25.1-56 56v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V120C0 71.4 39.4 32 88 32zM16 192c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm416 0c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0-32c-8.8 0-16-7.2-16-16V120c0-30.9-25.1-56-56-56H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h24c48.6 0 88 39.4 88 88v24c0 8.8-7.2 16-16 16zm16 208v24c0 48.6-39.4 88-88 88H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h24c30.9 0 56-25.1 56-56V368c0-8.8 7.2-16 16-16s16 7.2 16 16zM32 368v24c0 30.9 25.1 56 56 56h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-48.6 0-88-39.4-88-88V368c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176zM160 48c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"]
};
var faSquareJ = {
  prefix: 'fal',
  iconName: 'square-j',
  icon: [448, 512, [], "e273", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 48V288c0 53-43 96-96 96s-96-43-96-96V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 35.3 28.7 64 64 64s64-28.7 64-64V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHandPointUp = {
  prefix: 'fal',
  iconName: 'hand-point-up',
  icon: [384, 512, [9757], "f0a6", "M64 56c0-13.3 10.7-24 24-24s24 10.7 24 24V200v40H80c-5.5 0-10.8 .6-16 1.6V56zm48 216v0h32v0h24c13.2 0 24 10.7 24 24v0c0 13.3-10.7 24-24 24H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c13.8 0 26.4-5 36.1-13.2C294.4 351.7 310.2 360 328 360c8.6 0 16.7-1.9 24-5.4C350.6 424.1 293.8 480 224 480H160C89.3 480 32 422.7 32 352V320c0-26.5 21.5-48 48-48h32zm32-32V200c0-13.3 10.7-24 24-24s24 10.7 24 24v31.9c0 0 0 0 0 .1v13.4c-7.3-3.5-15.4-5.4-24-5.4H144zm0-90.6V56c0-30.9-25.1-56-56-56S32 25.1 32 56V256C12.6 270.6 0 293.8 0 320v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V304 272 248c0-30.9-25.1-56-56-56c-12.1 0-23.3 3.8-32.5 10.4C285.6 186.5 268 176 248 176c-9.7 0-18.8 2.5-26.7 6.8C214 160.3 192.9 144 168 144c-8.6 0-16.7 1.9-24 5.4zM224 272V232c0-13.2 10.8-24 24-24c13.3 0 24 10.7 24 24v16 48c0 13.3-10.7 24-24 24s-24-10.7-24-24v0l0-24zm128 0v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8V248c0-13.3 10.7-24 24-24s24 10.7 24 24v24z"]
};
var faMoneyBill = {
  prefix: 'fal',
  iconName: 'money-bill',
  icon: [576, 512, [], "f0d6", "M480 96c0 35.3 28.7 64 64 64V128c0-17.7-14.3-32-32-32H480zm-32 0H128c0 53-43 96-96 96V320c53 0 96 43 96 96H448c0-53 43-96 96-96V192c-53 0-96-43-96-96zM32 384c0 17.7 14.3 32 32 32H96c0-35.3-28.7-64-64-64v32zm512-32c-35.3 0-64 28.7-64 64h32c17.7 0 32-14.3 32-32V352zM64 96c-17.7 0-32 14.3-32 32v32c35.3 0 64-28.7 64-64H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faArrowUpBigSmall = {
  prefix: 'fal',
  iconName: 'arrow-up-big-small',
  icon: [576, 512, ["sort-size-up"], "f88e", "M148.7 36.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 86.6V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6L75.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zM352 432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v64zm-32 0V368c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48zM352 80V208c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48H496c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80z"]
};
var faSortSizeUp = faArrowUpBigSmall;
var faBarcodeRead = {
  prefix: 'fal',
  iconName: 'barcode-read',
  icon: [576, 512, [], "f464", "M48 32c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V48C0 21.5 21.5 0 48 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48zm96 96c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm48 16c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm224 0c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zM272 128c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zM544 48c0-8.8-7.2-16-16-16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c26.5 0 48 21.5 48 48v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zM48 480h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-26.5 0-48-21.5-48-48V368c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8 7.2 16 16 16zm496-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 26.5-21.5 48-48 48H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16-7.2 16-16z"]
};
var faBaguette = {
  prefix: 'fal',
  iconName: 'baguette',
  icon: [640, 512, [129366], "e3d8", "M591.9 74.8c-29.4-44.1-89-56-133.1-26.6l-79.2 52.8 47.8 47.8c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352.4 119l-88 58.7 51 51c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.5-55.5-88 58.7 54.2 54.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L122 272.6 74.7 304.1c-44.1 29.4-56 89-26.6 133.1s89 56 133.1 26.6l384-256c44.1-29.4 56-89 26.6-133.1zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z"]
};
var faBowlSoftServe = {
  prefix: 'fal',
  iconName: 'bowl-soft-serve',
  icon: [512, 512, [], "e46b", "M256 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7H164c-37.6 0-68 30.4-68 68c0 10.2 2.3 19.9 6.3 28.6C62.7 165.4 32 199.1 32 240c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80c0-41.4-31.4-75.4-71.7-79.6c4.9-9.7 7.7-20.8 7.7-32.4C416 57.3 358.7 0 288 0H256zm32 49.3c0-6-1.1-11.8-3.3-17.3H288c53 0 96 43 96 96c0 13.1-6.3 24.7-16 32H280c-8.8 0-16 7.2-16 16s7.2 16 16 16h92.9H384h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h16 8.3H168c8.8 0 16-7.2 16-16s-7.2-16-16-16H141.4c-8.2-6.6-13.4-16.7-13.4-28c0-19.9 16.1-36 36-36h77.3C267.1 96 288 75.1 288 49.3zM64 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 57.4 46.6 104 104 104h46.1l-20.4 40.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H336c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6L329.9 448H376c57.4 0 104-46.6 104-104v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 39.8-32.2 72-72 72H304c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6L310.1 480H201.9l20.4-40.8c2.5-5 2.2-10.9-.7-15.6s-8.1-7.6-13.6-7.6H136c-39.8 0-72-32.2-72-72v-8z"]
};
var faFaceHoldingBackTears = {
  prefix: 'fal',
  iconName: 'face-holding-back-tears',
  icon: [512, 512, [129401], "e482", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM320.6 116.4c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48s-6 34.6-16 48v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.7c-9.8 4.3-20.6 6.7-32 6.7c-44.2 0-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2zM180.4 96.6c8.5 2.4 13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6v32 16 16c0 8.8-7.2 16-16 16s-16-7.2-16-16c-13.4 10-30 16-48 16c-11.4 0-22.2-2.4-32-6.7V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c-10-13.4-16-30-16-48s6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11zM208 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm144 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM160 208c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32zm160 32c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm1.9 129.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C328.9 410.3 298.8 432 256 432s-72.9-21.7-90.1-41.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C203 384.4 224.9 400 256 400s53-15.6 65.9-30.5z"]
};
var faSquareUp = {
  prefix: 'fal',
  iconName: 'square-up',
  icon: [448, 512, [11014, "arrow-alt-square-up"], "f353", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 16c9.2 0 18 3.5 24.7 9.7l91 84c7.8 7.2 12.3 17.4 12.3 28.1c0 21.1-17.1 38.3-38.3 38.3H288v80c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V272H134.3C113.1 272 96 254.9 96 233.7c0-10.7 4.5-20.9 12.3-28.1l91-84c6.7-6.2 15.6-9.7 24.7-9.7zm-3 33.2l-91 84c-1.3 1.2-2 2.9-2 4.6c0 3.5 2.8 6.3 6.3 6.3H176c8.8 0 16 7.2 16 16v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256c0-8.8 7.2-16 16-16h41.7c3.5 0 6.3-2.8 6.3-6.3c0-1.7-.7-3.4-2-4.6l-91-84c-.8-.8-1.9-1.2-3-1.2s-2.2 .4-3 1.2z"]
};
var faArrowAltSquareUp = faSquareUp;
var faTrainSubwayTunnel = {
  prefix: 'fal',
  iconName: 'train-subway-tunnel',
  icon: [512, 512, ["subway-tunnel"], "e2a3", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224V496c0 8.8 7.2 16 16 16s16-7.2 16-16V256C512 114.6 397.4 0 256 0S0 114.6 0 256V496c0 8.8 7.2 16 16 16s16-7.2 16-16V256zm336-48v48H272V160h48c26.5 0 48 21.5 48 48zM240 288h32 96v80c0 26.5-21.5 48-48 48H192c-26.5 0-48-21.5-48-48V288h96zm0-128v96H144V208c0-26.5 21.5-48 48-48h48zm-48-32c-44.2 0-80 35.8-80 80V368c0 32.8 19.8 61 48 73.4l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L198.6 448H313.4l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L352 441.4c28.3-12.3 48-40.5 48-73.4V208c0-44.2-35.8-80-80-80H192zm8 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm136-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSubwayTunnel = faTrainSubwayTunnel;
var faSquareExclamation = {
  prefix: 'fal',
  iconName: 'square-exclamation',
  icon: [448, 512, ["exclamation-square"], "f321", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM200 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faExclamationSquare = faSquareExclamation;
var faSemicolon = {
  prefix: 'fal',
  iconName: 'semicolon',
  icon: [192, 512, [], "3b", "M64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 32 128a64 64 0 1 0 128 0zM128 350.4c0 5.6-1.5 11.1-4.5 15.9L55.4 477.9c-.8 1.3-2.3 2.1-3.8 2.1c-2.8 0-4.9-2.5-4.4-5.2L70.5 343.9C73 330.1 85 320 99 320c16 0 29 13 29 29v1.5zm32 0V349c0-33.7-27.3-61-61-61c-29.5 0-54.8 21.2-60 50.2L15.7 469.1c-4 22.3 13.2 42.9 35.9 42.9c12.7 0 24.5-6.6 31.1-17.4L150.8 383c6-9.8 9.2-21.1 9.2-32.6z"]
};
var faBookmark = {
  prefix: 'fal',
  iconName: 'bookmark',
  icon: [384, 512, [128278, 61591], "f02e", "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V489.9c0 12.2-9.9 22.1-22.1 22.1c-4.4 0-8.6-1.3-12.3-3.7L192 403.2 34.4 508.3c-3.6 2.4-7.9 3.7-12.3 3.7C9.9 512 0 502.1 0 489.9V48zM48 32c-8.8 0-16 7.2-16 16V471.4L183.1 370.7c5.4-3.6 12.4-3.6 17.8 0L352 471.4V48c0-8.8-7.2-16-16-16H48z"]
};
var faFanTable = {
  prefix: 'fal',
  iconName: 'fan-table',
  icon: [448, 512, [], "e004", "M416 224A192 192 0 1 0 32 224a192 192 0 1 0 384 0zm32 0c0 118.3-91.8 215.2-208 223.4V480H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H224 80c-8.8 0-16-7.2-16-16s7.2-16 16-16H208V447.4C91.8 439.2 0 342.3 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-55.4-99.7c-32.8 13.2-48.6 50.5-35.4 83.3c9.3 23 30.4 37.7 53.6 39.8c5.8 .5 10.9 4.2 13.2 9.6s1.5 11.6-2.1 16.2l-47.9 61.4c-2.7 3.5-2.1 8.5 1.4 11.2c27.9 21.8 68.1 16.8 89.8-11c15.3-19.5 17.4-45.2 7.6-66.3c-2.5-5.3-1.8-11.6 1.7-16.3s9.3-7.1 15.1-6.3l77.1 10.8c4.4 .6 8.4-2.4 9-6.8c4.9-35-19.5-67.4-54.5-72.3c-24.6-3.5-47.9 7.5-61.3 26.5c-3.4 4.8-9.1 7.3-14.9 6.7s-10.8-4.5-13-9.9L179 112.7c-1.7-4.1-6.3-6.1-10.4-4.4zm60 41.6c19.9-15.9 46-23.9 73.3-20c52.5 7.4 89.1 55.9 81.7 108.4c-3.1 21.9-23.3 37.1-45.2 34L285.8 265c3.8 25.2-2.3 51.8-19.3 73.5c-32.6 41.8-93 49.2-134.8 16.5c-17.4-13.6-20.5-38.7-6.9-56.1L157.6 257c-23.7-9.3-43.7-27.9-54-53.4c-19.9-49.2 3.9-105.1 53-125c20.5-8.3 43.8 1.6 52.1 22.1L228.6 150z"]
};
var faAlignJustify = {
  prefix: 'fal',
  iconName: 'align-justify',
  icon: [448, 512, [], "f039", "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 192c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faBatteryLow = {
  prefix: 'fal',
  iconName: 'battery-low',
  icon: [576, 512, ["battery-1"], "e0b1", "M432 128c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H432zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm-448 0v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0v96c0 26.5 21.5 48 48 48s48-21.5 48-48V208c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faBattery1 = faBatteryLow;
var faCreditCardFront = {
  prefix: 'fal',
  iconName: 'credit-card-front',
  icon: [576, 512, [], "f38a", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 304c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240zM400 144h64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H400c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V152c0-22.1-17.9-40-40-40H400c-22.1 0-40 17.9-40 40z"]
};
var faBrainArrowCurvedRight = {
  prefix: 'fal',
  iconName: 'brain-arrow-curved-right',
  icon: [640, 512, ["mind-share"], "f677", "M144.2 75.4c-.6 6.7-5.4 12.4-12 14C111.4 94.7 96 113.6 96 136c0 3.1 .3 6.2 .9 9.2c1.5 7.6-2.7 15.2-10 18C68.8 170 56 187.6 56 208c0 5.2 .8 10.3 2.4 15c2 6.1 .2 12.8-4.6 17C40.4 251.7 32 268.9 32 288c0 22.9 12 43 30.2 54.3c6.7 4.2 9.3 12.6 6.3 19.8C65.6 368.8 64 376.2 64 384c0 30.9 25.1 56 56 56c3.3 0 6.5-.3 9.5-.8c7.5-1.3 14.9 2.9 17.6 10c6.9 18 24.4 30.8 44.8 30.8c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48c-25 0-45.5 19.1-47.8 43.4zM256 480c-14.6 19.4-37.8 32-64 32c-29.6 0-55.5-16.1-69.3-40c-.9 0-1.8 0-2.7 0c-48.6 0-88-39.4-88-88c0-7.6 1-15 2.8-22C13.6 344.4 0 317.8 0 288c0-25.1 9.6-48 25.4-65c-.9-4.9-1.4-9.9-1.4-15c0-29.6 16.1-55.5 40-69.3c0-.9 0-1.8 0-2.7c0-33.6 20.7-62.4 50.1-74.2C122.3 26.4 154.1 0 192 0c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c37.9 0 69.7 26.4 77.9 61.8C427.3 73.6 448 102.4 448 136c0 .9 0 1.8 0 2.7c20.5 11.8 35.2 32.5 39.1 56.7c-15.4 5.6-27.7 17.3-34.2 32.3c0-1.6 .3-3.2 .8-4.7c1.5-4.7 2.4-9.7 2.4-15c0-20.4-12.8-38-30.9-44.9c-7.3-2.8-11.5-10.4-10-18c.6-3 .9-6 .9-9.2c0-22.4-15.4-41.3-36.2-46.5c-6.6-1.7-11.4-7.3-12-14C365.5 51.1 345 32 320 32c-26.5 0-48 21.5-48 48V432c0 25.6 20 46.5 45.2 47.9c5 11.8 10.9 22.1 17 30.8c-4.6 .8-9.4 1.3-14.2 1.3c-26.2 0-49.4-12.6-64-32zM526.7 232L635.3 340.7c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3L526.6 472c-5.1 5.1-12 8-19.1 8c-15.1 .1-27.5-12.2-27.5-27.3V400H464c-35.3 0-64 28.7-64 64v32c0 6.4-3.8 12.2-9.8 14.7s-12.8 1.2-17.4-3.2C358.2 493.3 336 459.4 336 416c0-61.9 50.1-112 112-112h32V251.4c0-15 12.1-27.2 27.2-27.3c7.3 0 14.3 2.8 19.5 8zM512 320c0 8.8-7.2 16-16 16H448c-44.2 0-80 35.8-80 80c0 8.5 1.2 16.6 3 24c10.7-41.4 48.2-72 93-72h32c8.8 0 16 7.2 16 16v57.4L601.4 352 512 262.6V320z"]
};
var faMindShare = faBrainArrowCurvedRight;
var faUmbrellaBeach = {
  prefix: 'fal',
  iconName: 'umbrella-beach',
  icon: [576, 512, [127958], "f5ca", "M471.6 99.4c46.8 45.1 72.2 109 68.3 174.7l-86.3-31.4c15.2-43.2 21.6-89 18.9-134.8c-.2-2.9-.5-5.7-.9-8.5zM402.8 54.3c21.7 10.1 36.3 31.4 37.7 55.6c2.5 41.4-3.3 82.8-17 121.9l-167.6-61c14.6-38.8 36.9-74.2 65.3-104.3c17.5-18.5 44.1-25.2 68.2-17.3c1.1 .4 2.2 .8 3.3 1.2c3.4 1.2 6.7 2.5 10 3.9zm-3.1-35.4c-109.8-38-228.4 3.2-292.6 94c-11.1 15.7-2.8 36.8 15.3 43.4l92.4 33.6 0 0L245 200.9l167.6 61 30.1 10.9 0 0 89.1 32.4c18.1 6.6 38-4.2 39.6-23.4c9-108.1-52-213.2-155.6-256.9c-2.4-1.1-4.9-2.1-7.4-3l-5.9-2.1c-.9-.3-1.8-.6-2.7-.9zM305.9 37c-2.7 2.3-5.4 4.8-7.9 7.5c-31.5 33.3-56 72.5-72.2 115.4l-89.6-32.6C176.5 73 239.2 40.1 305.9 37zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H253.4l77.8-213.7-30.1-10.9L219.4 480H16z"]
};
var faHelmetUn = {
  prefix: 'fal',
  iconName: 'helmet-un',
  icon: [512, 512, [], "e503", "M240 32c114.9 0 208 93.1 208 208v16H256c-6.9 0-13 4.4-15.2 10.9L212.5 352H77.2c-25 0-45.2-20.2-45.2-45.2V240C32 125.1 125.1 32 240 32zm96 419.4l-93.6-88.1L267.5 288H336V451.4zM368 480V288H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V240C480 107.5 372.5 0 240 0S0 107.5 0 240v66.8C0 349.4 34.6 384 77.2 384H217.7L349 507.7c3 2.8 6.9 4.3 11 4.3H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zM285.3 103.1c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3v96c0 8.8 7.2 16 16 16s16-7.2 16-16V164.8l34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v43.2l-34.7-52zM160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 26.5 21.5 48 48 48s48-21.5 48-48V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112z"]
};
var faLocationSmile = {
  prefix: 'fal',
  iconName: 'location-smile',
  icon: [384, 512, ["map-marker-smile"], "f60d", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM128 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM125.3 247.1C132.1 257.3 156 280 192 280s59.9-22.7 66.7-32.9c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2c-11 16.5-43.9 47.1-93.3 47.1s-82.3-30.6-93.3-47.1c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4z"]
};
var faMapMarkerSmile = faLocationSmile;
var faArrowLeftToLine = {
  prefix: 'fal',
  iconName: 'arrow-left-to-line',
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", "M0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 432zM100.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L150.6 272 256 272l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0-105.4 0L251.3 139.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128z"]
};
var faArrowToLeft = faArrowLeftToLine;
var faBullseye = {
  prefix: 'fal',
  iconName: 'bullseye',
  icon: [512, 512, [], "f140", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-288a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSushi = {
  prefix: 'fal',
  iconName: 'sushi',
  icon: [576, 512, [127843, "nigiri"], "e48a", "M535.2 288.7L430.5 253.9l59.3-100.4c17.4 20.9 29.7 46.3 34.7 74.7l10.7 60.5zM375.6 96.2c33.9 1.8 65.3 14.3 90.6 34.3L399.4 243.6l-66.2-22c-9.1-3-18.4-5.2-27.8-6.5L375.6 96.2zM268.8 214.1c-13 1.1-25.9 3.9-38.5 8.2L133.2 256 227.7 96H338.6L268.8 214.1zM86.5 272.2L41 287.9l10.5-59.7c12.4-70.1 69.2-122.7 138.4-131L86.5 272.2zM209.1 64C115.9 64 36.2 130.9 20 222.6L9.5 282.4c-4.2 24 18.9 43.8 42 35.8l189.4-65.6c26.6-9.2 55.5-9.4 82.3-.5l202 67.1c23 7.6 45.8-12.1 41.6-35.9L556 222.6C539.8 130.9 460.1 64 366.9 64H209.1zM32 352.9c.5 52.6 43.3 95.1 96 95.1c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c18.8 0 36.4-5.4 51.2-14.8c2.9-1.8 6.6-1.8 9.5 0c14.8 9.4 32.4 14.8 51.2 14.8c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c52.5 0 95.1-42.1 96-94.4c-8.4 .7-17.1-.2-25.8-3.1l-6.2-2V352c0 35.3-28.7 64-64 64c-11.6 0-22.4-3.1-31.7-8.4c-12.6-7.2-28-7.2-40.6 0c-9.3 5.3-20.1 8.4-31.7 8.4c-12.6 0-24.3-3.6-34.1-9.8c-13.4-8.4-30.4-8.4-43.7 0c-9.9 6.2-21.5 9.8-34.1 9.8c-11.6 0-22.4-3.1-31.7-8.4c-12.6-7.2-28-7.2-40.6 0c-9.3 5.3-20.1 8.4-31.7 8.4c-35.3 0-64-28.7-64-64v-4.3l-5.3 1.8c-9 3.1-18 4.1-26.7 3.4z"]
};
var faNigiri = faSushi;
var faMessageCaptions = {
  prefix: 'fal',
  iconName: 'message-captions',
  icon: [512, 512, ["comment-alt-captions"], "e1de", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm288 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zM80 288c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"]
};
var faCommentAltCaptions = faMessageCaptions;
var faTrashList = {
  prefix: 'fal',
  iconName: 'trash-list',
  icon: [640, 512, [], "e2b1", "M164.2 39.5L148.9 64H267.1L251.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM279 22.6L304.9 64h47.1H384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H381.7L356.2 452.6C353.9 486.1 326 512 292.4 512H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64.1h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h60.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480H292.4c16.8 0 30.7-13 31.9-29.7L349.6 96H66.4zM464 128H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H592c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16s7.2-16 16-16zM448 400c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16z"]
};
var faBacon = {
  prefix: 'fal',
  iconName: 'bacon',
  icon: [576, 512, [129363], "f7e5", "M566.6 105.4c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-27.5 24.3-48.4 54.6-69 84.7l-.5 .7C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6l-96-96c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C107 310.7 169.8 247 225.6 165.9c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8c11.2-3.2 23.2-.1 31.4 8.1l96 96zM68.1 420.1l4.8-2.4c122.1-61.1 168.8-129 211.7-191.4l2.3-3.3c21.9-31.9 43.9-63.5 75.1-90.9c29.9-26.4 67.7-48.5 121.2-64.9L448 32c-56 16-94 38-123.5 64S274 152 252 184C193.2 269.6 126.2 336.9 32 384l36.1 36.1zm23.8 23.8L128 480c125.8-62.9 174.5-133.7 217.8-196.8c22.3-32.5 45-65 74.7-91.2C450 166 488 144 544 128L508.9 92.9l-8.5 2.4c-54 15.4-89.8 36.3-117.3 60.6c-27.8 24.5-47.8 52.9-69.9 85.1l-2.2 3.3c-43.3 63.1-93 135.4-219 199.6z"]
};
var faOption = {
  prefix: 'fal',
  iconName: 'option',
  icon: [640, 512, [], "e318", "M178 107.7c-6.1-7.4-15.2-11.7-24.8-11.7H16C7.2 96 0 88.8 0 80s7.2-16 16-16H153.3c19.2 0 37.4 8.6 49.5 23.5L462 404.3c6.1 7.4 15.2 11.7 24.8 11.7H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H486.7c-19.2 0-37.4-8.6-49.5-23.5L178 107.7zM624 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16H624z"]
};
var faHandPointDown = {
  prefix: 'fal',
  iconName: 'hand-point-down',
  icon: [384, 512, [], "f0a7", "M64 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144 0-40-32 0c-5.5 0-10.8-.6-16-1.6L64 456zm48-216l0 0 32 0 0 0 24 0c13.2 0 24-10.7 24-24l0 0c0-13.3-10.7-24-24-24l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c15.7 0 29.8 6.4 40 16.8c10.2-10.4 24.3-16.8 40-16.8c13.8 0 26.4 5 36.1 13.2C294.4 160.3 310.2 152 328 152c8.6 0 16.7 1.9 24 5.4C350.6 87.9 293.8 32 224 32l-64 0C89.3 32 32 89.3 32 160l0 32c0 26.5 21.5 48 48 48l32 0zm32 32l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-31.9c0 0 0 0 0-.1l0-13.4c-7.3 3.5-15.4 5.4-24 5.4l-24 0zm0 90.6l0 93.4c0 30.9-25.1 56-56 56s-56-25.1-56-56l0-200C12.6 241.4 0 218.2 0 192l0-32C0 71.6 71.6 0 160 0l64 0c88.4 0 160 71.6 160 160l0 48 0 32 0 24c0 30.9-25.1 56-56 56c-12.1 0-23.3-3.8-32.5-10.4C285.6 325.5 268 336 248 336c-9.7 0-18.8-2.5-26.7-6.8C214 351.7 192.9 368 168 368c-8.6 0-16.7-1.9-24-5.4zM224 240l0 40c0 13.2 10.8 24 24 24c13.3 0 24-10.7 24-24l0-16 0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 0 0 24zm128 0l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24z"]
};
var faArrowUpFromBracket = {
  prefix: 'fal',
  iconName: 'arrow-up-from-bracket',
  icon: [448, 512, [], "e09a", "M235.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6V336c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6L340.7 155.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM32 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336z"]
};
var faTrashPlus = {
  prefix: 'fal',
  iconName: 'trash-plus',
  icon: [448, 512, [], "e2b2", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64h47.1H416h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H413.7L388.2 452.6C385.9 486.1 358 512 324.4 512H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64.1h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480H324.4c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zM208 384V304H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H240v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faObjectsAlignTop = {
  prefix: 'fal',
  iconName: 'objects-align-top',
  icon: [512, 512, [], "e3c0", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 0zM176 160c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16h64zm-64-32c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48H112zm288 32c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16h64zm-64-32c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48H336z"]
};
var faFolder = {
  prefix: 'fal',
  iconName: 'folder',
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H291.9c-17 0-33.3-6.7-45.3-18.7L210.7 73.4c-6-6-14.1-9.4-22.6-9.4H64zM0 96C0 60.7 28.7 32 64 32H188.1c17 0 33.3 6.7 45.3 18.7l35.9 35.9c6 6 14.1 9.4 22.6 9.4H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faFolderBlank = faFolder;
var faFaceAnxiousSweat = {
  prefix: 'fal',
  iconName: 'face-anxious-sweat',
  icon: [576, 512, [], "e36a", "M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-57.6 0-110.8-19.1-153.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2C191 463.3 237.5 480 288 480c123.7 0 224-100.3 224-224S411.7 32 288 32zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.5c0 .2 0 .2 0 .1C32 385.5 43.7 400 64 400s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.1-.7-.8-3.7-3.4-9.6c-3-6.7-7.4-14.5-12.8-23.1c-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0c17.6 21.7 55.5 72.2 55.5 97.2c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 38.1-75.5 55.5-97.2zM367.6 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-136 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM211.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm153.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM283.8 304h8.4c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2H212.2c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zm67 80c-5.5-27.4-29.6-48-58.6-48h-8.4c-29 0-53.2 20.6-58.6 48H350.8z"]
};
var faCreditCardBlank = {
  prefix: 'fal',
  iconName: 'credit-card-blank',
  icon: [576, 512, [], "f389", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 368c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faFileWaveform = {
  prefix: 'fal',
  iconName: 'file-waveform',
  icon: [448, 512, ["file-medical-alt"], "f478", "M416 448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L318.1 14.1c-9-9-21.2-14.1-33.9-14.1H128C92.7 0 64 28.7 64 64V288H96V64c0-17.7 14.3-32 32-32H256V144c0 26.5 21.5 48 48 48H416V448zm-.5-288H304c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L411.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM270.3 264.8c-2.7-5.4-8.3-8.8-14.3-8.8s-11.6 3.4-14.3 8.8L189.3 369.7l-32.5-43.3c-3-4-7.8-6.4-12.8-6.4H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H136l43.2 57.6c3.3 4.4 8.7 6.8 14.2 6.3s10.4-3.8 12.9-8.8L256 307.8l17.7 35.4c2.7 5.4 8.3 8.8 14.3 8.8h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H297.9l-27.6-55.2z"]
};
var faFileMedicalAlt = faFileWaveform;
var faMicrochipAi = {
  prefix: 'fal',
  iconName: 'microchip-ai',
  icon: [512, 512, [], "e1ec", "M160 0c8.8 0 16 7.2 16 16V64h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h16c35.3 0 64 28.7 64 64v16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v16c0 35.3-28.7 64-64 64H368v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H272v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H176v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H128c-35.3 0-64-28.7-64-64V368H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V176H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V128c0-35.3 28.7-64 64-64h16V16c0-8.8 7.2-16 16-16zM128 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H128zm94.7 89.6l56 128c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2L239.5 304H176.5l-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l56-128c2.5-5.8 8.3-9.6 14.7-9.6s12.1 3.8 14.7 9.6zM208 231.9L190.5 272h35.1L208 231.9zM352 192V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMug = {
  prefix: 'fal',
  iconName: 'mug',
  icon: [576, 512, [], "f874", "M64 96V352c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V96H368 64zm352 0V256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H416zm0 192v64c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32H368h16 80c61.9 0 112 50.1 112 112s-50.1 112-112 112H416z"]
};
var faPlaneUpSlash = {
  prefix: 'fal',
  iconName: 'plane-up-slash',
  icon: [640, 512, [], "e22e", "M464 461.4l-32-25.3V440v8 31.4L324.4 448.6c-2.9-.8-5.9-.8-8.8 0L208 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8V317.7c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L96 346.8V290.6c0-5.7 3.1-11 8.1-13.9l73.1-41.7L150 213.6 88.2 248.9c-15 8.5-24.2 24.5-24.2 41.7v56.2c0 21.3 20.3 36.6 40.8 30.8L240 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2l0 0L320 480.6l105.7 30.2 0 0c2.7 .8 5.5 1.2 8.2 1.2c16.6 0 30-13.4 30-30V461.4zm-223.6-360L272 126.4V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C311 33.7 315.9 32 320 32c9.1 0 20.9 8.2 31.8 26.3C362.1 75.5 368 96.1 368 109.7v61.7c0 5.7 3.1 11 8.1 13.9l159.9 91.4c5 2.8 8.1 8.2 8.1 13.9v50.5l27.6 21.8c2.8-4.7 4.4-10.2 4.4-16.2V290.6c0-17.2-9.2-33.1-24.2-41.7L400 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C367.1 21.6 346.9 0 320 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4c-11.1 18.3-19 40.6-20.8 59.7zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faRadiation = {
  prefix: 'fal',
  iconName: 'radiation',
  icon: [512, 512, [], "f7b9", "M117.4 80L174.6 179c-11.9 12.6-20.9 27.9-26 45L34.3 224c8.3-58.2 39-109.2 83.2-144zm55.4 384.1L230 365c8.4 2 17.1 3 26 3s17.6-1 26-3l57.2 99.1C313.5 474.3 285.4 480 256 480s-57.5-5.7-83.2-15.9zM394.6 80c44.2 34.8 74.9 85.9 83.2 144l-114.4 0c-5.1-17.1-14.1-32.4-26-45L394.6 80zM160 256c8.8 0 15.8-7.2 17.6-15.9c3.5-17.4 12.7-32.8 25.5-44.1c6.6-5.8 9.4-15.5 5-23.2L144 62c-8.8-15.3-28.6-20.7-42.7-10C47.8 92.7 10.7 154 2 224.1C-.2 241.6 14.3 256 32 256l128 0zm48 83.2L144 450.1c-8.8 15.3-3.7 35.1 12.6 41.9c30.6 12.9 64.2 20 99.4 20s68.9-7.1 99.4-20c16.3-6.9 21.4-26.6 12.6-41.9L304 339.2c-4.4-7.7-14.2-10.1-22.6-7.3c-8 2.7-16.5 4.1-25.4 4.1s-17.4-1.4-25.4-4.1c-8.4-2.8-18.2-.4-22.6 7.3zm126.4-99.1c1.7 8.7 8.7 15.9 17.6 15.9l128 0c17.7 0 32.2-14.4 30-31.9C501.3 154 464.2 92.7 410.7 52c-14.1-10.7-33.8-5.3-42.7 10L304 172.9c-4.4 7.6-1.7 17.3 5 23.2c12.8 11.3 22 26.7 25.5 44.1zM240 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faPenCircle = {
  prefix: 'fal',
  iconName: 'pen-circle',
  icon: [512, 512, [], "e20e", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm331.5-92.7c-6.2-6.2-16.4-6.2-22.6 0l-21.4 21.4 40 40 21.4-21.4c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zm-149 126.4c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l82.3-82.3-40-40-82.3 82.3zm103.8-149c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L245.1 352.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L286.2 140.7z"]
};
var faBagSeedling = {
  prefix: 'fal',
  iconName: 'bag-seedling',
  icon: [512, 512, [], "e5f2", "M89 96H423l12.6 50.3c8.2 33 12.4 66.9 12.4 100.9v17.7c0 34-4.2 67.9-12.4 100.9L423 416H89L76.4 365.7C68.2 332.7 64 298.9 64 264.8V247.2c0-34 4.2-67.9 12.4-100.9L89 96zM430.9 64H81.1L64.8 39.5c-.5-.8-.8-1.7-.8-2.7c0-2.7 2.2-4.8 4.8-4.8H443.2c2.7 0 4.8 2.2 4.8 4.8c0 1-.3 1.9-.8 2.7L430.9 64zM81.1 448H430.9l16.3 24.5c.5 .8 .8 1.7 .8 2.7c0 2.7-2.2 4.8-4.8 4.8H68.8c-2.7 0-4.8-2.2-4.8-4.8c0-1 .3-1.9 .8-2.7L81.1 448zM38.2 57.3l20 30L45.4 138.5C36.5 174 32 210.5 32 247.2v17.7c0 36.6 4.5 73.1 13.4 108.7l12.8 51.2-20 30c-4 6.1-6.2 13.2-6.2 20.4C32 495.5 48.5 512 68.8 512H443.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4l-20-30 12.8-51.2c8.9-35.5 13.4-72 13.4-108.7V247.2c0-36.6-4.5-73.1-13.4-108.7L453.8 87.3l20-30c4-6.1 6.2-13.2 6.2-20.4C480 16.5 463.5 0 443.2 0H68.8C48.5 0 32 16.5 32 36.8c0 7.3 2.2 14.4 6.2 20.4zM272 319c63.1-7.9 112-61.7 112-127v-1.6c0-16.8-13.6-30.4-30.4-30.4h-8.9c-37.2 0-68.9 17.9-88.7 44.5c-19.8-26.6-51.5-44.5-88.7-44.5h-8.9c-16.8 0-30.4 13.6-30.4 30.4V192c0 65.3 48.9 119.1 112 127v33c0 8.8 7.2 16 16 16s16-7.2 16-16V319zm-32-32.3c-45.4-7.6-80-47.1-80-94.7h7.3c33.6 0 61 20.5 72.7 48.4v46.2zm32 0V240.4c11.7-27.9 39.1-48.4 72.7-48.4H352c0 47.6-34.6 87.1-80 94.7z"]
};
var faChartSimple = {
  prefix: 'fal',
  iconName: 'chart-simple',
  icon: [448, 512, [], "e473", "M240 64c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zM208 32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208zM80 256c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16H80zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm320-96h32c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-48 16V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
};
var faCrutches = {
  prefix: 'fal',
  iconName: 'crutches',
  icon: [640, 512, [], "f7f8", "M443.3 4.7l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM290.4 199l34.2-34.2 .1-.1 .1-.1 94-94 22.6 22.6L358.6 176 464 281.4l82.7-82.7 22.6 22.6-94.1 94.1L441 349.6c-11.2 11.2-25.4 18.8-40.9 21.9l-122 24.4c-9.3 1.9-17.8 6.4-24.5 13.1l-98.3 98.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L231 386.4c6.7-6.7 11.3-15.2 13.1-24.5l24.4-122c3.1-15.5 10.7-29.7 21.9-40.9zM313 221.6c-6.7 6.7-11.3 15.2-13.1 24.5L276.4 363.6l117.5-23.5c9.3-1.9 17.8-6.4 24.5-13.1l23-23L336 198.6l-23 23zM196.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L198.6 48l98.7 98.7-22.6 22.6L176 70.6 70.6 176 176 281.4l66.7-66.7c-2.4 6.1-4.2 12.4-5.5 18.9l-8 39.9L198.6 304 219 324.4l-6.2 31.2c-.3 1.4-.8 2.8-1.4 4.1c-4.4-2.9-8.5-6.3-12.3-10.1l-34.3-34.3L48 198.6 27.3 219.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192zM384.5 407.2l21.9-4.4c5.1-1 10.1-2.4 15-4.1l85.9 85.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L386.4 409c-.6-.6-1.2-1.2-1.9-1.8z"]
};
var faCircleParking = {
  prefix: 'fal',
  iconName: 'circle-parking',
  icon: [512, 512, ["parking-circle"], "f615", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208 32h80c35.3 0 64-28.7 64-64s-28.7-64-64-64H208V288zm80 32H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 152c0-13.3 10.7-24 24-24h88c53 0 96 43 96 96s-43 96-96 96z"]
};
var faParkingCircle = faCircleParking;
var faMarsStroke = {
  prefix: 'fal',
  iconName: 'mars-stroke',
  icon: [512, 512, [9894], "f229", "M368 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L384 105.4 347.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L361.4 128l-40.7 40.7C290.1 143.3 250.8 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-42.8-15.3-82.1-40.7-112.6L384 150.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L406.6 128 480 54.6V144c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H368zM64 304a144 144 0 1 1 288 0A144 144 0 1 1 64 304z"]
};
var faLeafOak = {
  prefix: 'fal',
  iconName: 'leaf-oak',
  icon: [512, 512, [], "f6f7", "M300 0c-33.3 0-61.7 23.9-67.3 56.7l-1.4 8.2L217.9 54.8c-23.9-18-57.5-15.7-78.7 5.5c-13.4 13.4-19.7 32.3-17 51l6.7 47.1c-21.5-5.4-44.9 1.3-60.2 18.8l-6.6 7.5C42.9 206.6 38.8 238 51.9 264.1L64.3 289c7.8 15.6 11.8 32.7 11.8 50.1v74.1L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L102 432.6h67.6c17.4 0 34.5 4 50.1 11.8l24.9 12.4c26.1 13.1 57.5 9 79.5-10.2l7.5-6.6c17.5-15.3 24.2-38.7 18.8-60.2l47.1 6.7c18.7 2.7 37.6-3.6 51-17c21.2-21.2 23.5-54.8 5.5-78.7l-10.1-13.4 8.2-1.4c32.8-5.7 56.7-34.1 56.7-67.3c0-22.9-11.4-44.2-30.4-56.9L468 145l5.4-24.8c5.2-23.7-2-48.5-19.2-65.6S412.3 30.1 388.6 35.3l-24.8 5.4-6.9-10.3C344.2 11.4 322.9 0 300 0zM134 400.6L315.3 219.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L108.1 381.2l0-42.1c0-22.4-5.2-44.4-15.2-64.4L80.5 249.8c-7.2-14.5-5-31.9 5.7-44.1l6.6-7.5c9.4-10.7 25.3-12.8 37.2-4.9c15.5 10.3 35.9-2.5 33.3-21l-9.4-65.6c-1.3-8.8 1.7-17.6 8-23.9c9.9-9.9 25.6-11 36.8-2.6l23.9 18c14.3 10.8 35 2.6 38.1-15.1l3.6-21.1C267.2 44.7 282.3 32 300 32c12.2 0 23.5 6.1 30.2 16.2l6.9 10.3c7.3 11 20.6 16.3 33.5 13.5l24.8-5.4c13.1-2.9 26.7 1.1 36.1 10.6s13.4 23.1 10.6 36.1l-5.4 24.8c-2.8 12.9 2.5 26.2 13.5 33.5l10.3 6.9c10.1 6.7 16.2 18.1 16.2 30.2c0 17.7-12.7 32.8-30.2 35.8l-21.1 3.6c-17.7 3.1-25.9 23.8-15.1 38.1l18 23.9c8.4 11.2 7.3 26.9-2.6 36.8c-6.3 6.3-15.1 9.2-23.9 8l-65.6-9.4c-18.4-2.6-31.3 17.8-21 33.3c7.9 11.9 5.8 27.8-4.9 37.2l-7.5 6.6c-12.2 10.7-29.6 12.9-44.1 5.7L234 415.8c-20-10-42-15.2-64.4-15.2H134z"]
};
var faSquareBolt = {
  prefix: 'fal',
  iconName: 'square-bolt',
  icon: [448, 512, [], "e265", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM159.7 264H208c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L288.3 248H240c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L159.7 264zM281.6 112c14.7 0 24.4 15.2 18.2 28.5L265 216h49.4c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L180.2 394.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L183 296H133.6c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L267.8 117.5c3.7-3.5 8.7-5.5 13.8-5.5z"]
};
var faVial = {
  prefix: 'fal',
  iconName: 'vial',
  icon: [512, 512, [129514], "f492", "M292.7 4.7c6.2-6.2 16.4-6.2 22.6 0l32 32 128 128 32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 198.6l-84.7 84.7L181.8 480.8c-20 20-47.1 31.2-75.3 31.2C47.7 512 0 464.3 0 405.5c0-28.2 11.2-55.3 31.2-75.3l69.5-69.5L313.4 48 292.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zM336 70.6L150.6 256H361.4l80-80L336 70.6zM329.4 288H118.6L53.8 352.8c-14 14-21.8 32.9-21.8 52.7c0 41.1 33.4 74.5 74.5 74.5c19.8 0 38.7-7.8 52.7-21.8L329.4 288z"]
};
var faGauge = {
  prefix: 'fal',
  iconName: 'gauge',
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-194c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 194c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64zM144 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm296 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faDashboard = faGauge;
var faGaugeMed = faGauge;
var faTachometerAltAverage = faGauge;
var faWandMagicSparkles = {
  prefix: 'fal',
  iconName: 'wand-magic-sparkles',
  icon: [576, 512, ["magic-wand-sparkles"], "e2ca", "M458.3 34.9c3.1-3.1 8.2-3.1 11.3 0l39.4 39.4c3.1 3.1 3.1 8.2 0 11.3L388.7 206.1l-50.7-50.7L458.3 34.9zM66.9 426.3L315.3 177.9l50.7 50.7L117.7 477.1c-3.1 3.1-8.2 3.1-11.3 0L66.9 437.7c-3.1-3.1-3.1-8.2 0-11.3zM435.7 12.3L44.3 403.7c-15.6 15.6-15.6 40.9 0 56.6l39.4 39.4c15.6 15.6 40.9 15.6 56.6 0L531.7 108.3c15.6-15.6 15.6-40.9 0-56.6L492.3 12.3c-15.6-15.6-40.9-15.6-56.6 0zM128 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H128V80zM464 320c-8.8 0-16 7.2-16 16v48H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V336c0-8.8-7.2-16-16-16zM252.2 16c0-6.7-5.4-12.2-12.2-12.2s-12.2 5.4-12.2 12.2V35.8H208c-6.7 0-12.2 5.4-12.2 12.2s5.4 12.2 12.2 12.2h19.8V80c0 6.7 5.4 12.2 12.2 12.2s12.2-5.4 12.2-12.2V60.2H272c6.7 0 12.2-5.4 12.2-12.2s-5.4-12.2-12.2-12.2H252.2V16z"]
};
var faMagicWandSparkles = faWandMagicSparkles;
var faLambda = {
  prefix: 'fal',
  iconName: 'lambda',
  icon: [448, 512, [], "f66e", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H139.5c6.2 0 11.9 3.6 14.5 9.3l7.6 16.5-.3-.1-160 368c-3.5 8.1 .2 17.5 8.3 21.1s17.5-.2 21.1-8.3L179.4 128.3 328.9 452.1c7.8 17 24.9 27.9 43.6 27.9H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H372.5c-6.2 0-11.9-3.6-14.5-9.3L183.1 59.9c-7.8-17-24.9-27.9-43.6-27.9H16z"]
};
var faE = {
  prefix: 'fal',
  iconName: 'e',
  icon: [320, 512, [101], "45", "M48 32C21.5 32 0 53.5 0 80V256 432c0 26.5 21.5 48 48 48H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16V272H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V80c0-8.8 7.2-16 16-16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H48z"]
};
var faPizza = {
  prefix: 'fal',
  iconName: 'pizza',
  icon: [576, 512, [127829], "f817", "M344.2 389.5C318.9 406.2 288.6 416 256 416c-88.4 0-160-71.6-160-160s71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5l-99.6 99.6c-18.7 18.7-18.7 49.1 0 67.9l99.6 99.6zm24.9-20.4L267.3 267.3c-6.2-6.2-6.2-16.4 0-22.6L369.1 142.9l22.6-22.6 33.9-33.9C432 80 432 69.9 425.4 64C380.2 24.2 320.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c64.9 0 124.2-24.2 169.4-64c6.6-5.8 6.6-16 .3-22.3l-33.9-33.9-22.6-22.6zm-1.9 43.4l22.9 22.9C352.7 463.4 306.3 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c50.3 0 96.7 16.6 134.2 44.6L367.2 99.5C335.9 77.1 297.5 64 256 64C150 64 64 150 64 256s86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm132.2-22.4l-22.9-22.9C498.9 335.9 512 297.5 512 256s-13.1-79.9-35.5-111.2l22.9-22.9c28 37.4 44.6 83.8 44.6 134.2s-16.6 96.7-44.6 134.2zM480 256c0 32.6-9.8 62.9-26.5 88.2L365.3 256l88.2-88.2C470.2 193.1 480 223.4 480 256zm32 169.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4c-5.8-6.6-16-6.6-22.3-.3L331.3 244.7c-6.2 6.2-6.2 16.4 0 22.6L433.1 369.1l22.6 22.6 33.9 33.9c6.2 6.2 16.4 6.3 22.3-.3zM160 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-120a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBowlChopsticksNoodles = {
  prefix: 'fal',
  iconName: 'bowl-chopsticks-noodles',
  icon: [512, 512, [], "e2ea", "M499.1 31.7c8.7-1.7 14.3-10.2 12.6-18.8S501.5-1.4 492.9 .3L192 60.5V93.1L499.1 31.7zM160 150.4V99.5 66.9 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V73.3v32.6 46.6 32.1V224v0H96v0V186.7 154.6 112.3 79.7 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V86.1L12.9 96.3C4.2 98-1.4 106.5 .3 115.1s10.2 14.3 18.8 12.6l44.9-9v38L14.9 160c-8.8 .6-15.5 8.2-14.9 17s8.2 15.5 17 14.9L64 188.8V224H50.9C23.3 224 1.4 247.3 3 274.8l.6 10.3c4.9 84.1 55.9 155.1 127.5 189.2c7.6 21.9 28.4 37.6 52.9 37.6H328c24.5 0 45.3-15.7 52.9-37.6c71.6-34.1 122.5-105.1 127.5-189.2l.6-10.3c1.6-27.6-20.3-50.8-47.9-50.8H160v0V182.4 150.4zm32 29.9L497.1 160c8.8-.6 15.5-8.2 14.9-17s-8.2-15.5-17-14.9L192 148.2v32.1zM161.3 463.9c-2.8-8.1-8.7-14.7-16.5-18.4c-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9H461.1c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2c-7.7 3.7-13.7 10.3-16.5 18.4c-3.3 9.4-12.2 16.1-22.7 16.1H184c-10.4 0-19.4-6.7-22.7-16.1z"]
};
var faH3 = {
  prefix: 'fal',
  iconName: 'h3',
  icon: [640, 512, [], "f315", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM400 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H560L421 228.4c-4.7 4.5-6.3 11.5-3.8 17.5s8.3 10.1 14.9 10.1h96c44.2 0 80 35.8 80 80s-35.8 80-80 80H455.4c-19.6 0-36.2-14.1-39.5-33.4l-.2-1.2c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4l.2 1.2c5.8 34.7 35.8 60.2 71 60.2H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H472L611 91.6c4.7-4.5 6.3-11.5 3.8-17.5S606.5 64 600 64H400z"]
};
var faPenClip = {
  prefix: 'fal',
  iconName: 'pen-clip',
  icon: [512, 512, ["pen-alt"], "f305", "M385.4 41.9c12.5-12.5 32.8-12.5 45.3 0l39.4 39.4c12.5 12.5 12.5 32.8 0 45.3L421.7 175 337 90.3l48.4-48.4zM291.7 90.3L99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L492.7 149.3c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0L314.3 67.7 301.3 54.6c-25-25-65.5-25-90.5 0L100.7 164.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L233.4 77.3c12.5-12.5 32.8-12.5 45.3 0l13.1 13.1zM314.3 113L399 197.7 206.9 389.8c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4L314.3 113z"]
};
var faPenAlt = faPenClip;
var faBridgeCircleExclamation = {
  prefix: 'fal',
  iconName: 'bridge-circle-exclamation',
  icon: [640, 512, [], "e4ca", "M48 32h80H256 384 512h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H528v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H512 384 256 128 48c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM496 64H400v64h96V64zM368 64H272v64h96V64zM240 64H144v64h96V64zM48 240H64c53 0 96 43 96 96v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-53 43-96 96-96c16.1 0 31.2 4 44.6 10.9c-7.2 8.1-13.7 16.9-19.3 26.2c-7.7-3.3-16.3-5.2-25.2-5.2c-35.3 0-64 28.7-64 64v96c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V336c0-35.3-28.7-64-64-64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faBadgePercent = {
  prefix: 'fal',
  iconName: 'badge-percent',
  icon: [512, 512, [], "f646", "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zm91.3 164.7c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM320 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faUser = {
  prefix: 'fal',
  iconName: 'user',
  icon: [448, 512, [128100, 62144], "f007", "M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480H416c-1.2-79.7-66.2-144-146.3-144H178.3c-80 0-145 64.3-146.3 144zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"]
};
var faSensor = {
  prefix: 'fal',
  iconName: 'sensor',
  icon: [448, 512, [], "e028", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 48V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faComma = {
  prefix: 'fal',
  iconName: 'comma',
  icon: [192, 512, [], "2c", "M136 352.3c0-17.8-14.4-32.3-32.3-32.3c-16.1 0-29.7 11.8-31.9 27.7l-18 125.8c-.5 3.4 2.2 6.5 5.7 6.5c1.9 0 3.7-1 4.8-2.6l66-101.9c3.8-5.8 5.8-12.6 5.8-19.5v-3.7zm32 0v3.7c0 13.1-3.8 25.9-10.9 36.9l-66 101.9C84.2 505.5 72.3 512 59.5 512c-23 0-40.6-20.3-37.3-43l18-125.8c4.5-31.7 31.6-55.2 63.6-55.2c35.5 0 64.3 28.8 64.3 64.3z"]
};
var faSchoolCircleCheck = {
  prefix: 'fal',
  iconName: 'school-circle-check',
  icon: [640, 512, [], "e56b", "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64V266.8c-9.1-12.9-19.9-24.5-32-34.6V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-2.9 10.2-4.8 20.8-5.8 31.7l-.7 0c-17.7 0-32 14.3-32 32v96h32 32 8.2c10 12.1 21.7 22.9 34.6 32H384 352 288 256 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H171.2l140-93.3zM416 192c0 7-.7 13.8-2.2 20.3c-31.3 16.5-57 42.2-73.5 73.5c-6.5 1.4-13.3 2.2-20.3 2.2c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zM128 160h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm0 32v64h32V192H128zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V352zm64 0H128v64h32V352zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faToiletPaperUnder = {
  prefix: 'fal',
  iconName: 'toilet-paper-under',
  icon: [512, 512, ["toilet-paper-reverse"], "e2a0", "M32 192c0-46.5 10.3-87.7 26.2-116.8C74.4 45.5 94.1 32 112 32H337.3c-7.2 8.2-13.6 17.7-19.2 27.9C299.2 94.5 288 141.2 288 192s11.2 97.5 30.1 132.1c5.6 10.2 12 19.6 19.2 27.9H112c-17.9 0-37.6-13.5-53.8-43.2C42.3 279.7 32 238.5 32 192zM346.2 75.2C362.4 45.5 382.1 32 400 32s37.6 13.5 53.8 43.2C469.7 104.3 480 145.5 480 192s-10.3 87.7-26.2 116.8C437.6 338.5 417.9 352 400 352s-37.6-13.5-53.8-43.2C330.3 279.7 320 238.5 320 192s10.3-87.7 26.2-116.8zM480 327.6V464c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V416H128v48c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V192c0-50.8-11.2-97.5-30.1-132.1C463.4 25.9 435.1 0 400 0H112C76.9 0 48.6 25.9 30.1 59.9C11.2 94.5 0 141.2 0 192s11.2 97.5 30.1 132.1C48.6 358.1 76.9 384 112 384H400c33.9 0 61.4-24.1 80-56.4zM385.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM431.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM96 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faToiletPaperReverse = faToiletPaperUnder;
var faLightEmergency = {
  prefix: 'fal',
  iconName: 'light-emergency',
  icon: [448, 512, [], "e41f", "M352 320V192c0-70.7-57.3-128-128-128S96 121.3 96 192V320H64V192c0-88.4 71.6-160 160-160s160 71.6 160 160V320H352zM48 384c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H48zm0-32H400c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48zM160 192c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-53 43-96 96-96c8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64z"]
};
var faArrowDownToArc = {
  prefix: 'fal',
  iconName: 'arrow-down-to-arc',
  icon: [512, 512, [], "e4ae", "M256 480c123.7 0 224-100.3 224-224c0-8.8 7.2-16 16-16s16 7.2 16 16c0 141.4-114.6 256-256 256S0 397.4 0 256c0-8.8 7.2-16 16-16s16 7.2 16 16c0 123.7 100.3 224 224 224zM396 202.6l-128 144c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4l-128-144c-5.9-6.6-5.3-16.7 1.3-22.6s16.7-5.3 22.6 1.3L240 293.9 240 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 277.9L372 181.4c5.9-6.6 16-7.2 22.6-1.3s7.2 16 1.3 22.6z"]
};
var faDumpster = {
  prefix: 'fal',
  iconName: 'dumpster',
  icon: [576, 512, [], "f793", "M423.4 32H288l0 0 0 0H152.3c-.2 0-.4 0-.6 0H57c-14.7 0-27.5 10-31 24.2L.9 156.6c-.6 2.3-.9 4.6-.9 6.9C0 179.2 12.8 192 28.5 192h5.3H66h61.7 .6L288 192l159.7 0h.6H510h32.2 5.3c15.7 0 28.5-12.8 28.5-28.5c0-2.3-.3-4.7-.9-6.9L550.1 56.2C546.5 42 533.7 32 519 32H424c-.2 0-.4 0-.6 0zM37.5 224l3.8 32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H45.1L64 448.9V464c0 8.8 7.2 16 16 16s16-7.2 16-16V448H480v16c0 8.8 7.2 16 16 16s16-7.2 16-16V448.9L530.9 288H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H534.7l3.8-32H506.2L483.7 416H92.3L69.8 224H37.5zm490.2-64H461.2L443 64l76 0 24 96H528.2h-.4zM410.4 64l18.2 96H304V64l106.4 0zM272 64v96H147.3l18-96L272 64zM132.7 64l-18 96H48.2h-.4H33L57 64l75.7 0z"]
};
var faVanShuttle = {
  prefix: 'fal',
  iconName: 'van-shuttle',
  icon: [640, 512, [128656, "shuttle-van"], "f5b6", "M32 88V192H160V64H56C42.7 64 32 74.7 32 88zm0 136V328c0 13.3 10.7 24 24 24H69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H389.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H584c13.3 0 24-10.7 24-24V224H368 176 32zm160-32H352V64H192V192zm192 0H588.1L477.6 69.3c-3-3.4-7.4-5.3-11.9-5.3H384V192zM584 384h-8c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H56c-30.9 0-56-25.1-56-56V88C0 57.1 25.1 32 56 32H176 368h97.7c13.6 0 26.6 5.8 35.7 15.9L627.7 188.2c7.9 8.8 12.3 20.3 12.3 32.1V328c0 30.9-25.1 56-56 56zm-40 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM160 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faShuttleVan = faVanShuttle;
var faBuildingUser = {
  prefix: 'fal',
  iconName: 'building-user',
  icon: [640, 512, [], "e4da", "M64 32H320c17.7 0 32 14.3 32 32V393.4c9.2-10.2 20-18.9 32-25.6V271.8 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c3.2 0 6.4-.2 9.5-.7c-5.5-9.2-8.9-19.9-9.4-31.3l-.1 0H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm192-16a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM384 477.1c0-33.7 27.4-61.1 61.1-61.1H546.9c33.7 0 61.1 27.4 61.1 61.1c0 1.6-1.3 2.9-2.9 2.9H386.9c-1.6 0-2.9-1.3-2.9-2.9zM445.1 384c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H496 445.1z"]
};
var faLightSwitch = {
  prefix: 'fal',
  iconName: 'light-switch',
  icon: [384, 512, [], "e017", "M176 48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H176V464c0-8.8 7.2-16 16-16s16 7.2 16 16v16H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H208V48c0 8.8-7.2 16-16 16s-16-7.2-16-16zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 368c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272H128v96zm0-224v96H256V144c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V144z"]
};
var faSquareCaretLeft = {
  prefix: 'fal',
  iconName: 'square-caret-left',
  icon: [448, 512, ["caret-square-left"], "f191", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-9.6 4-18.7 11-25.2l102.8-95.5c5.1-4.7 11.8-7.3 18.7-7.3c15.2 0 27.5 12.3 27.5 27.5l0 201c0 15.2-12.3 27.5-27.5 27.5c-6.9 0-13.6-2.6-18.7-7.3L139 281.2c-7-6.5-11-15.6-11-25.2zm32.7 1.7L256 346.2l0-180.3-95.3 88.4c-.5 .4-.7 1.1-.7 1.7s.3 1.3 .7 1.7z"]
};
var faCaretSquareLeft = faSquareCaretLeft;
var faHighlighter = {
  prefix: 'fal',
  iconName: 'highlighter',
  icon: [576, 512, [], "f591", "M176 296.6v-48c0-5.2 2.5-10 6.7-13l27-19.4L343.7 350.4l-19.4 27c-3 4.2-7.8 6.7-13 6.7h-48c-8.5 0-16.6 3.4-22.6 9.4L197 437.1c-3.1 3.1-8.2 3.1-11.3 0l-62.8-62.8c-3.1-3.1-3.1-8.2 0-11.3l43.7-43.7c6-6 9.4-14.1 9.4-22.6zM523.8 99.5L362.6 324 236 197.4 460.5 36.2c3.8-2.7 8.4-4.2 13-4.2c5.9 0 11.6 2.4 15.8 6.5l32.2 32.2c4.2 4.2 6.5 9.9 6.5 15.8c0 4.7-1.5 9.2-4.2 13zM263.4 416h48c15.5 0 30-7.4 39-20L549.8 118.2C556.4 109 560 97.9 560 86.5c0-14.4-5.7-28.2-15.9-38.4L511.9 15.9C501.7 5.7 487.9 0 473.5 0C462.1 0 451 3.6 441.8 10.2L164 209.6c-12.6 9-20 23.5-20 39v48l-43.7 43.7c-11.4 11.4-14.5 27.9-9.3 42l-84 84c-4.5 4.5-7 10.6-7 17V488c0 13.3 10.7 24 24 24H124.7c6.4 0 12.5-2.5 17-7l36-36c14.2 5.2 30.7 2.1 42-9.3L263.4 416zm-111 33l-31 31H38.6L111 407.6 152.4 449z"]
};
var faWavePulse = {
  prefix: 'fal',
  iconName: 'wave-pulse',
  icon: [640, 512, ["heart-rate"], "f5f8", "M319.6 0c7.5-.2 14.1 4.9 15.9 12.1l84 336 37.6-93.9c7.3-18.2 24.9-30.2 44.6-30.2H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H501.7c-6.5 0-12.4 4-14.9 10.1l-56 139.9c-2.6 6.4-9 10.5-15.9 10s-12.8-5.4-14.4-12.1l-78.7-315-82 410.2c-1.5 7.3-7.8 12.7-15.3 12.9s-14.1-4.9-15.9-12.1L150.5 268.1C148.8 261 142.4 256 135 256H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H135c22 0 41.2 15 46.6 36.4l40.7 162.7 82-410.2C305.8 5.5 312.1 .2 319.6 0z"]
};
var faHeartRate = faWavePulse;
var faKey = {
  prefix: 'fal',
  iconName: 'key',
  icon: [512, 512, [128273], "f084", "M192 176c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144c-11.1 0-22-1.3-32.4-3.6c-5.4-1.2-11 .4-14.9 4.3L257.4 352H208c-8.8 0-16 7.2-16 16v48H144c-8.8 0-16 7.2-16 16v48H32V398.6L194.8 235.8c4.2-4.2 5.7-10.5 3.9-16.2c-4.4-13.8-6.7-28.4-6.7-43.7zM336 0C238.8 0 160 78.8 160 176c0 15.1 1.9 29.8 5.5 43.9L4.7 380.7c-3 3-4.7 7.1-4.7 11.3V496c0 8.8 7.2 16 16 16H144c8.8 0 16-7.2 16-16V448h48c8.8 0 16-7.2 16-16V384h40c4.2 0 8.3-1.7 11.3-4.7l30-30c10 1.8 20.2 2.7 30.7 2.7c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHatSanta = {
  prefix: 'fal',
  iconName: 'hat-santa',
  icon: [640, 512, [], "f7a7", "M357.9 243.4L396.2 320H432l-45.5-90.9c-1.7-3.3-2.5-7-2.5-10.7V216c0-13.3 10.7-24 24-24h4.1c2.6 0 5.1 .4 7.6 1.2l39.5 13.2c1.6-2.1 3.3-4.1 5.2-6c0-14.3 5.5-28.7 16.4-39.6c2.2-2.2 4.6-4.2 7.1-6L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8L76.8 320h34.5l68.1-170.3C200.1 97.9 250.2 64 305.9 64c40.1 0 78.2 17.7 104 48.3l51.9 61.3-32-10.7c-5.7-1.9-11.7-2.9-17.7-2.9H408c-30.9 0-56 25.1-56 56v2.3c0 8.7 2 17.3 5.9 25zM448 384c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448zM64 352c-35.3 0-64 28.7-64 64s28.7 64 64 64H448c35.3 0 64-28.7 64-64s-28.7-64-64-64H64zm524.7-83.3a40.6 40.6 0 1 1 -57.4-57.4 40.6 40.6 0 1 1 57.4 57.4zm-82.4-82.4c-7.8 7.8-10 18.9-6.8 28.7C490.3 219.5 484 229 484 240s6.3 20.5 15.5 25.1c-3.2 9.7-1 20.9 6.8 28.7s18.9 10 28.7 6.8C539.5 309.7 549 316 560 316s20.5-6.3 25.1-15.5c9.7 3.2 20.9 1 28.7-6.8s10-18.9 6.8-28.7C629.7 260.5 636 251 636 240s-6.3-20.5-15.5-25.1c3.2-9.7 1-20.9-6.8-28.7s-18.9-10-28.7-6.8C580.5 170.3 571 164 560 164s-20.5 6.3-25.1 15.5c-9.7-3.2-20.9-1-28.7 6.8z"]
};
var faTamale = {
  prefix: 'fal',
  iconName: 'tamale',
  icon: [320, 512, [129748], "e451", "M296.4 304l23.1 138.7c1.7 10.2-1.7 20.6-9 27.9C274 507 207.7 512 160 512s-114-5-150.6-41.3c-7.3-7.3-10.7-17.7-9-27.9L23.6 304l.4 0H52.8L28.8 447.5c-.2 1 .2 2 .9 2.8c12.8 12.6 32.4 21.3 56.8 26.5c24.2 5.2 50.4 6.4 73.4 6.4s49.2-1.2 73.4-6.4c24.5-5.2 44.1-13.9 56.8-26.5c.7-.8 1.1-1.8 .9-2.8L267.2 304H296l.4 0zM319.6 69.3L296.4 208l-.4 0H267.2L291.2 64.5c.2-1-.2-2-.9-2.8c-12.8-12.6-32.4-21.3-56.8-26.5c-24.2-5.2-50.4-6.4-73.4-6.4s-49.2 1.2-73.4 6.4c-24.5 5.2-44 13.9-56.8 26.5c-.7 .8-1.1 1.8-.9 2.8L52.8 208H24l-.4 0L.4 69.3c-1.7-10.2 1.7-20.6 9-27.9C46 5 112.3 0 160 0s114 5 150.6 41.3c7.3 7.3 10.7 17.7 9 27.9zM8 256c0-8.8 7.2-16 16-16H160 296c8.8 0 16 7.2 16 16s-7.2 16-16 16H192l28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272H24c-8.8 0-16-7.2-16-16zM160 56c8.8 0 16 7.2 16 16V208H160 144V72c0-8.8 7.2-16 16-16zm9.6 292.8c1.9 2.6 4.1 4.9 6.4 7V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V355.8c2.3-2.1 4.5-4.4 6.4-7L160 336l9.6 12.8zM95.9 78.6L107.7 208H75.6L64.1 81.4c-.8-8.8 5.7-16.6 14.5-17.4s16.6 5.7 17.4 14.5zM83.2 358.4c5.8 4.3 12.2 7.1 18.8 8.6l-6 66.5c-.8 8.8-8.6 15.3-17.4 14.5s-15.3-8.6-14.5-17.4l7.7-84.4c3 4.6 6.8 8.8 11.5 12.2zm153.6 0c4.6-3.5 8.5-7.6 11.5-12.2l7.7 84.4c.8 8.8-5.7 16.6-14.5 17.4s-16.6-5.7-17.4-14.5L218 367c6.6-1.4 13-4.2 18.8-8.6zM212.3 208L224.1 78.6c.8-8.8 8.6-15.3 17.4-14.5s15.3 8.6 14.5 17.4L244.4 208H212.3z"]
};
var faBoxCheck = {
  prefix: 'fal',
  iconName: 'box-check',
  icon: [448, 512, [], "f467", "M240 64H342.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128H416V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H208h32zm-32-32H42.1L76.3 83c5.1-11.6 16.6-19 29.2-19H208v96zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM331.3 251.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 345.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faBullhorn = {
  prefix: 'fal',
  iconName: 'bullhorn',
  icon: [512, 512, [128226, 128363], "f0a1", "M416 44.2c0-7.2-8.8-10.8-13.8-5.5L378.4 63.9C336.5 108 282.7 138.4 224 151.5V328.5c58.7 13.1 112.5 43.4 154.4 87.6l23.8 25.1c5 5.3 13.8 1.7 13.8-5.5V44.2zM192 323.1V156.9c-5.8 .7-11.6 1.1-17.5 1.5L144.9 160l-.4 0H144 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h80 .4l.4 0 29.7 1.6c5.8 .3 11.7 .8 17.5 1.5zM379 16.7c24.9-26.3 69-8.7 69 27.5V435.8c0 36.2-44.2 53.8-69 27.5l-23.8-25.1c-43.3-45.7-101-74.9-163.1-82.8V456c0 30.9-25.1 56-56 56H120c-30.9 0-56-25.1-56-56V352c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64l79.6 0 29.2-1.6c69.4-3.9 134.6-34.1 182.4-84.5L379 16.7zM96 352V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V352.9l-16.4-.9H96zM496 192c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16z"]
};
var faSteak = {
  prefix: 'fal',
  iconName: 'steak',
  icon: [576, 512, [129385], "f824", "M368 32c-31 0-57 9.9-77.4 28.9L268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512c-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5l21.8 23.4c-18.4 17.1-29.1 39-36.5 55.9c-4.3 9.8-7.8 18.3-11 26l-1.1 2.6c-9.5 23-17.5 42.4-35.9 60.7c-24.6 24.6-52.8 39.8-77.6 52.4c-2.8 1.4-5.5 2.8-8.2 4.2l0 0 0 0c-22.2 11.2-40.9 20.7-57.8 34.3C44.4 311.4 32 332.3 32 360c0 61.4 53 90.2 88.4 102.4C159.3 475.8 205.2 480 240 480c74 0 147.9-28.1 203.5-69.5C497.9 370 544 309.5 544 240c0-52.2-20.6-102.6-50.5-140C464.1 63.3 419.7 32 368 32zM352 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM121.9 297.7c28.3-11.9 65.5-27.6 106.8-69c23.4-23.4 35.6-52.6 47.2-81.3l.1-.2 0 0c2.4-5.9 4.8-11.9 7.3-17.6c7.1-16.3 15.7-32.9 29-45.3c14-13 32-20.3 55.6-20.3c38.6 0 74.7 23.8 100.5 56c26 32.5 43.5 75.9 43.5 120c0 55.2-37.2 107.3-87.6 144.8C373.6 422.6 306.3 448 240 448c-32.9 0-74.9-4.1-109.2-15.9C97.5 420.7 64 399 64 360c0-7.5 1.1-15.6 4.7-23.6c3.7-8.3 9.1-13.9 13.5-17.7c10.2-8.6 24.2-14.6 37.6-20.2l.8-.3 0 0 1.2-.5 0 0zm12.4 29.5l-1.2 .5c-15.2 6.4-24.3 10.5-30.2 15.5C98.6 346.8 96 351 96 360c0 16.7 14.1 31.2 45.2 41.9C170.9 412.1 209 416 240 416c58.6 0 119.4-22.6 165.3-56.8C451.7 324.6 480 280.8 480 240c0-35.9-14.5-72.5-36.5-100c-22.2-27.8-50.1-44-75.5-44c-16.3 0-26.3 4.7-33.9 11.7c-8.2 7.6-14.6 19-21.5 34.7c-2.3 5.3-4.6 11-7.1 17c-11.4 28.1-25.6 63.2-54.3 91.9c-45.8 45.8-87.7 63.5-117 75.8z"]
};
var faLocationCrosshairsSlash = {
  prefix: 'fal',
  iconName: 'location-crosshairs-slash',
  icon: [640, 512, ["location-slash"], "f603", "M395.5 397.1C373 409.2 347.3 416 320 416c-88.4 0-160-71.6-160-160c0-14 1.8-27.7 5.2-40.7l-27-21.3c-5 14.6-8.2 30-9.6 46H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48.7c7.7 93.3 82.1 167.6 175.3 175.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V447.3c31.6-2.6 61-12.9 86.4-28.9l-27-21.3zM304 64.7c-31.6 2.6-61 12.9-86.4 28.9l27 21.3C267 102.8 292.7 96 320 96c88.4 0 160 71.6 160 160c0 14-1.8 27.7-5.2 40.7l27 21.3c5-14.6 8.2-30 9.6-46H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H511.3C503.6 146.7 429.3 72.4 336 64.7V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64.7zM320 352c5.6 0 11.2-.5 16.5-1.4l-55.7-44c-.3-.2-.6-.5-.9-.7l-55.7-44c3 50.3 44.8 90.1 95.8 90.1zM303.5 161.4l55.7 44c.3 .2 .6 .5 .9 .7l55.7 44C412.8 199.8 371 160 320 160c-5.6 0-11.2 .5-16.5 1.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faLocationSlash = faLocationCrosshairsSlash;
var faPersonDolly = {
  prefix: 'fal',
  iconName: 'person-dolly',
  icon: [512, 512, [], "f4d0", "M56 56a24 24 0 1 1 48 0A24 24 0 1 1 56 56zm80 0A56 56 0 1 0 24 56a56 56 0 1 0 112 0zM0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-130.5L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3L0 496zM60 176c7 0 13.8 1.5 20 4.2V319.4L39.1 292.2c-4.5-3-7.1-8-7.1-13.3V204c0-15.5 12.5-28 28-28zm52 38.5l37.8 58.8c5.9 9.2 16 14.7 26.9 14.7h51.8L254 393.7c-18 11.3-30 31.4-30 54.3c0 35.3 28.7 64 64 64c33.8 0 61.5-26.2 63.8-59.5l148-37c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L346 421c-10.2-21.9-32.3-37-58-37c-1.1 0-2.3 0-3.4 .1L231.6 164.2c-2.1-8.6-10.7-13.9-19.3-11.8s-13.9 10.7-11.8 19.3L220.8 256h-44l-47.8-74.4C113.9 158.2 87.9 144 60 144c-33.1 0-60 26.9-60 60v74.9c0 16 8 31 21.4 39.9l100.2 66.8 22.7 113.5c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L153 379.4c-1.7-8.3-6.6-15.6-13.6-20.3L112 340.8V214.5zM256 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM441.2 322.3l-91.5 22.9-22.9-91.5 91.5-22.9 22.9 91.5zm31-7.8L449.4 223c-4.3-17.1-21.7-27.6-38.8-23.3L319 222.6c-17.1 4.3-27.6 21.7-23.3 38.8L318.6 353c4.3 17.1 21.7 27.6 38.8 23.3L449 353.4c17.1-4.3 27.6-21.7 23.3-38.8z"]
};
var faGlobe = {
  prefix: 'fal',
  iconName: 'globe',
  icon: [512, 512, [127760], "f0ac", "M256 480c16.7 0 40.4-14.4 61.9-57.3c9.9-19.8 18.2-43.7 24.1-70.7H170c5.9 27 14.2 50.9 24.1 70.7C215.6 465.6 239.3 480 256 480zM164.3 320H347.7c2.8-20.2 4.3-41.7 4.3-64s-1.5-43.8-4.3-64H164.3c-2.8 20.2-4.3 41.7-4.3 64s1.5 43.8 4.3 64zM170 160H342c-5.9-27-14.2-50.9-24.1-70.7C296.4 46.4 272.7 32 256 32s-40.4 14.4-61.9 57.3C184.2 109.1 175.9 133 170 160zm210 32c2.6 20.5 4 41.9 4 64s-1.4 43.5-4 64h90.8c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64H380zm78.5-32c-25.9-54.5-73.1-96.9-130.9-116.3c21 28.3 37.6 68.8 47.2 116.3h83.8zm-321.1 0c9.6-47.6 26.2-88 47.2-116.3C126.7 63.1 79.4 105.5 53.6 160h83.7zm-96 32c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64H132c-2.6-20.5-4-41.9-4-64s1.4-43.5 4-64H41.3zM327.5 468.3c57.8-19.5 105-61.8 130.9-116.3H374.7c-9.6 47.6-26.2 88-47.2 116.3zm-143 0c-21-28.3-37.5-68.8-47.2-116.3H53.6c25.9 54.5 73.1 96.9 130.9 116.3zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z"]
};
var faSynagogue = {
  prefix: 'fal',
  iconName: 'synagogue',
  icon: [640, 512, [128333], "f69b", "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166v78.1l53.3-48c6.1-5.5 15.3-5.5 21.4 0l69.4 62.5c10.1 9.1 15.9 22.1 15.9 35.7V464c0 26.5-21.5 48-48 48H464 384 352 288 256 176 64c-35.3 0-64-28.7-64-64V294.3c0-13.6 5.8-26.6 15.9-35.7l69.4-62.5c6.1-5.5 15.3-5.5 21.4 0l53.3 48V166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM480 480H592c8.8 0 16-7.2 16-16V294.3c0-4.5-1.9-8.9-5.3-11.9L544 229.5l-58.7 52.8c-3.4 3-5.3 7.4-5.3 11.9V480zM448 166c0-14.2-6.3-27.8-17.3-36.9L320 36.8 209.3 129.1C198.3 138.2 192 151.7 192 166V294.3 480h64V384c0-35.3 28.7-64 64-64s64 28.7 64 64v96h64V294.3 166zM352 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v96h64V384zM160 294.3c0-4.5-1.9-8.9-5.3-11.9L96 229.5 37.3 282.4c-3.4 3-5.3 7.4-5.3 11.9V448c0 17.7 14.3 32 32 32h96V294.3zM351.5 138.8l26-.2c17-.2 27.5 18.4 18.6 32.9L383.4 192 396 212.6c8.9 14.5-1.6 33-18.6 32.9l-26-.2-12.9 21.9c-8.3 14.2-28.9 14.2-37.3 0l-12.9-21.9-26 .2c-17 .2-27.5-18.4-18.6-32.9L256.6 192 244 171.4c-8.9-14.5 1.6-33 18.6-32.9l26 .2 12.9-21.9c8.3-14.2 28.9-14.2 37.3 0l12.9 21.9zM308 159.3c-2.5 4.2-7 6.8-11.9 6.7l-23.7-.2 11.7 19.1c2.7 4.4 2.7 9.9 0 14.2l-11.7 19.1 23.7-.2c4.9 0 9.4 2.5 11.9 6.7l12 20.5 12-20.5c2.5-4.2 7-6.8 11.9-6.7l23.7 .2-11.7-19.1c-2.7-4.4-2.7-9.9 0-14.2l11.7-19.1-23.7 .2c-4.9 0-9.4-2.5-11.9-6.7l-12-20.5-12 20.5z"]
};
var faFileChartColumn = {
  prefix: 'fal',
  iconName: 'file-chart-column',
  icon: [384, 512, ["file-chart-line"], "f659", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM112 368c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V368z"]
};
var faFileChartLine = faFileChartColumn;
var faPersonHalfDress = {
  prefix: 'fal',
  iconName: 'person-half-dress',
  icon: [320, 512, [], "e548", "M157.3 32.1c.9-.1 1.8-.1 2.7-.1c13.3 0 24 10.7 24 24c0 10.7-7.1 19.8-16.8 22.9c-2.3 .7-4.7 1.1-7.2 1.1c-1.8 0-3.5-.2-5.2-.6C144 77.1 136 67.5 136 56c0-12.3 9.3-22.5 21.3-23.9zm9.2 79.5C194.4 108.4 216 84.7 216 56c0-26.7-18.7-49.1-43.8-54.7C168.3 .5 164.2 0 160 0c-5.9 0-11.6 .9-16.9 2.6C120.4 9.8 104 31 104 56c0 30.9 25.1 56 56 56c1.4 0 2.7 0 4.1-.1c.8-.1 1.6-.1 2.4-.2zM192 320v32h0v64h0v80c0 8.8 7.2 16 16 16c1 0 2-.1 2.9-.3c1.1-.2 2.2-.5 3.3-1c5.7-2.4 9.8-8.1 9.8-14.7V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L243.3 170.3c-10.8-20.2-29.6-34.6-51.3-39.9V164l0 0V320h0zm-65.7-56.8c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H96v96c0 8.8 7.2 16 16 16c0 0 0 0 0 0l0 0H112l0 0 0 0 0 0c8.8 0 16-7.2 16-16V400h32V368H112 73.9l52.4-104.8zM160 160V128h0c-37.3 0-71.7 20.6-89.3 53.5L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L99 196.6c12-22.5 35.5-36.6 61-36.6h0z"]
};
var faFolderImage = {
  prefix: 'fal',
  iconName: 'folder-image',
  icon: [512, 512, [], "e18a", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zm88 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm135.9 32.1L380.3 352H131.5l44.6-63.8 19 25.4c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.5zm-25.5-19.4L208 277.3l-6.5-8.7c-6-8-15.4-12.7-25.3-12.7c-10.3 0-20 5-26 13.5l-49.1 70.2c-3.3 4.7-5.1 10.4-5.1 16.2c0 15.6 12.6 28.2 28.2 28.2H387.9c15.5 0 28.1-12.6 28.1-28.1c0-5.9-1.9-11.7-5.3-16.4l-97-134.3c-6-8.3-15.6-13.2-25.8-13.2c-10 0-19.4 4.7-25.5 12.7z"]
};
var faCalendarPen = {
  prefix: 'fal',
  iconName: 'calendar-pen',
  icon: [512, 512, ["calendar-edit"], "f333", "M144 0c8.8 0 16 7.2 16 16V64H352V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 160 128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zM448 192H64V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192zM416 96H96c-17.7 0-32 14.3-32 32v32H448V128c0-17.7-14.3-32-32-32zM327.6 257.9c-6.2-6.2-16.4-6.2-22.6 0l-12.2 12.2 29.1 29.1L334.1 287c6.2-6.2 6.2-16.4 0-22.6l-6.4-6.4zm-28.4 63.9l-29.1-29.1L182 381l-8.6 37.7L211 410l88.2-88.2zm-16.9-86.5c18.7-18.7 49.1-18.7 67.9 0l6.4 6.4c18.7 18.7 18.7 49.1 0 67.9l-123 123c-4.3 4.3-9.6 7.2-15.5 8.6L168 452.7c-17.3 4-32.7-11.5-28.8-28.8l11.5-50.2c1.3-5.9 4.3-11.2 8.6-15.5l123-123z"]
};
var faCalendarEdit = faCalendarPen;
var faRoadBridge = {
  prefix: 'fal',
  iconName: 'road-bridge',
  icon: [640, 512, [], "e563", "M576 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H496V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H384c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h80V96c0 8.8 7.2 16 16 16s16-7.2 16-16V32h80zm0-32H384c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM480 192c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zM16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H80v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H288V192H240V128h48V96H16zM264 288c-48.6 0-88 39.4-88 88v88c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V376c0-48.6-39.4-88-88-88H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h8c30.9 0 56 25.1 56 56v88c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V376c0-30.9 25.1-56 56-56h24V288H264zM208 128v64H112V128h96z"]
};
var faFaceSmileTear = {
  prefix: 'fal',
  iconName: 'face-smile-tear',
  icon: [512, 512, [], "e393", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM141.5 323.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5c8.8 0 16-7.2 16-16s-7.2-16-16-16c-43.4 0-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm194.3-1.5c5.1-7.7 10.7-15.1 16.2-22c5.5 6.9 11 14.3 16.2 22c11.4 17.1 15.8 29 15.8 34.9c0 12.2-11.7 26.7-32 26.7s-32-14.5-32-26.7c0-5.9 4.4-17.8 15.8-34.9zm7.7-62.3c-1.6 2-3.3 4.1-5.2 6.3c-18.9 23-50.3 61.2-50.3 90.8c0 32.5 28.7 58.7 64 58.7s64-26.2 64-58.7c0-29.2-30.8-66.9-49.6-90l0 0 0 0c-2.1-2.6-4.1-5-5.8-7.2c-4.3-5.5-12.8-5.5-17.1 0zM200.4 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faMessagePlus = {
  prefix: 'fal',
  iconName: 'message-plus',
  icon: [512, 512, ["comment-alt-plus"], "f4a8", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM240 304c0 8.8 7.2 16 16 16s16-7.2 16-16V224h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faCommentAltPlus = faMessagePlus;
var faLocationArrow = {
  prefix: 'fal',
  iconName: 'location-arrow',
  icon: [448, 512, [], "f124", "M224 224L48 224 400 80 256 432l0-176c0-17.7-14.3-32-32-32zm-32 32h32v32V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H192z"]
};
var faC = {
  prefix: 'fal',
  iconName: 'c',
  icon: [384, 512, [99], "43", "M356.9 120.3c-74.4-75-194.9-75-269.3 0s-74.4 196.5 0 271.4s194.9 75 269.3 0c6.2-6.3 16.3-6.3 22.5 0s6.2 16.4 0 22.7c-86.8 87.5-227.5 87.5-314.4 0s-86.8-229.4 0-316.9s227.5-87.5 314.4 0c6.2 6.3 6.2 16.4 0 22.7s-16.3 6.3-22.5 0z"]
};
var faTabletButton = {
  prefix: 'fal',
  iconName: 'tablet-button',
  icon: [448, 512, [], "f10a", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faRectangleHistoryCircleUser = {
  prefix: 'fal',
  iconName: 'rectangle-history-circle-user',
  icon: [640, 512, [], "e4a4", "M480 192v.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7V192c0-35.3-28.7-64-64-64L64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64l330.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32zM448 64L64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM400 0H112c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM556 462.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6h56.4c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8H467.8c-21.8 0-42.2 9.6-56.1 25.8C394.5 422.1 384 396.2 384 368c0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faBuildingLock = {
  prefix: 'fal',
  iconName: 'building-lock',
  icon: [576, 512, [], "e4d6", "M64 32H320c17.7 0 32 14.3 32 32V272c0-30.5 12.2-58.2 32-78.4V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c2.8 0 5.6-.2 8.3-.5c-5.3-9.3-8.3-20-8.3-31.5H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm208-64c26.5 0 48 21.5 48 48v48H416V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm160 80V480H384V352H544z"]
};
var faChartLineUp = {
  prefix: 'fal',
  iconName: 'chart-line-up',
  icon: [512, 512, [], "e0e5", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zm288 96c0 8.8 7.2 16 16 16h89.4L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0L448 182.6V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"]
};
var faMailbox = {
  prefix: 'fal',
  iconName: 'mailbox',
  icon: [576, 512, [128234], "f813", "M32 208V384c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V208c0-61.9-50.1-112-112-112S32 146.1 32 208zm256 0V384c0 11.7-3.1 22.6-8.6 32H512c17.7 0 32-14.3 32-32V208c0-61.9-50.1-112-112-112H234.5c32.6 26.4 53.5 66.8 53.5 112zM64 448c-35.3 0-64-28.7-64-64V208C0 128.5 64.5 64 144 64H432c79.5 0 144 64.5 144 144V384c0 35.3-28.7 64-64 64H224 64zm48-256h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 0h96 56c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H440c-13.3 0-24-10.7-24-24V224H336c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 96h32V224H448v64z"]
};
var faTruckBolt = {
  prefix: 'fal',
  iconName: 'truck-bolt',
  icon: [640, 512, [], "e3d0", "M352 32c17.7 0 32 14.3 32 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352zM416 128h65.3c4.7 0 9.1 2 12.1 5.6L570.9 224H416V128zm0 216.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM251.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h89.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H182.6l68.7-68.7z"]
};
var faPizzaSlice = {
  prefix: 'fal',
  iconName: 'pizza-slice',
  icon: [512, 512, [], "f818", "M167.5 32.8c-6.1-.4-12.4 3.7-14.4 11.1l-10 37.6C295 96.1 415.9 217 430.5 368.9l37.6-10c7.4-2 11.5-8.3 11.1-14.4C467.7 177.7 334.3 44.3 167.5 32.8zM38.6 473.4l360.5-96.1c-11-140.9-123.5-253.4-264.4-264.4L38.6 473.4zM4.7 507.3c-4-4-5.6-9.9-4.1-15.4L122.2 35.6C127.7 14.9 146.9-.7 169.7 .9C352.5 13.5 498.5 159.5 511.1 342.3c1.6 22.8-14 41.9-34.7 47.5L20.1 511.5c-5.5 1.5-11.4-.1-15.4-4.1zM176 216a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faMoneyBillWave = {
  prefix: 'fal',
  iconName: 'money-bill-wave',
  icon: [576, 512, [], "f53a", "M32 184c35.3 0 64-28.7 64-64v-.5c-18.5-1.4-37.1-4.4-55.8-9.5c-2.2-.6-4.9-.2-6.9 1.2c-.9 .6-1.2 1.1-1.3 1.2l0 0 0 0 0 0s0 0 0 0l0 .1V184zm0 192v46.3c0 6.8 3.7 10.4 6.2 11.3C57.3 440.8 76.5 445 96 446.8V440c0-35.3-28.7-64-64-64zm0-32c53 0 96 43 96 96v8c44.7-1 91.1-11.7 141.3-24.5c4.3-1.1 8.6-2.2 13-3.3c51.8-13.3 108-27.6 165.7-28.6c.2-52.8 43.1-95.6 96-95.6V168c-53 0-96-43-96-96V64c-44.7 1-91.1 11.7-141.3 24.5c-4.3 1.1-8.6 2.2-13 3.3c-51.8 13.3-108 27.6-165.7 28.6c-.2 52.8-43.1 95.6-96 95.6V344zm503.8 58c2.2 .6 4.9 .2 6.9-1.2c.9-.6 1.2-1.1 1.3-1.2c0 0 0 0 0 0s0 0 0-.1V328c-35.3 0-64 28.7-64 64v.5c18.5 1.4 37.1 4.4 55.8 9.5zM480 72c0 35.3 28.7 64 64 64V89.7c0-6.8-3.7-10.4-6.2-11.3C518.7 71.2 499.5 67 480 65.2V72zM0 422.3V112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM224 256c0 47 31.3 80 64 80s64-33 64-80s-31.3-80-64-80s-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112s-96-53-96-112s40.4-112 96-112z"]
};
var faChartArea = {
  prefix: 'fal',
  iconName: 'chart-area',
  icon: [512, 512, ["area-chart"], "f1fe", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM297.4 214.6c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l39.6-39.6 62 72.3c2.5 2.9 3.9 6.6 3.9 10.4V352H128V243.9c0-4.2 1.7-8.3 4.7-11.3L224 141.3l73.4 73.4zm0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-91.3 91.3c-9 9-14.1 21.2-14.1 33.9V352c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V257.8c0-11.5-4.1-22.5-11.6-31.2l-62-72.3c-12.1-14.2-33.7-15-46.9-1.8l-16.9 16.9L320 192l-22.6-22.6z"]
};
var faAreaChart = faChartArea;
var faHouseFlag = {
  prefix: 'fal',
  iconName: 'house-flag',
  icon: [640, 512, [], "e50d", "M464 0c-8.8 0-16 7.2-16 16V32 64v96 32V512h32V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480V16c0-8.8-7.2-16-16-16zm16 160V64H608v96H480zm-64-24L281.6 35.2c-5.7-4.3-13.5-4.3-19.2 0l-256 192c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2L64 224V440c0 39.8 32.2 72 72 72l272 0c2.7 0 5.4-.2 8-.4V479.2c-2.6 .5-5.3 .8-8 .8H344V352c0-17.7-14.3-32-32-32H232c-17.7 0-32 14.3-32 32V480H136c-22.1 0-40-17.9-40-40V200L272 68 416 176V136zM312 352V480l-80 0V352l80 0z"]
};
var faCircleThreeQuartersStroke = {
  prefix: 'fal',
  iconName: 'circle-three-quarters-stroke',
  icon: [512, 512, [], "e5d4", "M477.7 288H272c-26.5 0-48-21.5-48-48V34.3C115.4 49.8 32 143.2 32 256c0 123.7 100.3 224 224 224c112.8 0 206.2-83.4 221.7-192zm2.3-32C480 132.3 379.7 32 256 32V240c0 8.8 7.2 16 16 16H480zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faPersonCircleMinus = {
  prefix: 'fal',
  iconName: 'person-circle-minus',
  icon: [576, 512, [], "e540", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faScalpel = {
  prefix: 'fal',
  iconName: 'scalpel',
  icon: [512, 512, [], "f61d", "M200 288c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17H200zM411.9 45.7L234.4 256h98.2c4.7 0 9.2-2.1 12.2-5.7L470 102c6.5-7.7 10-17.4 10-27.5v-4C480 49.3 462.7 32 441.4 32c-11.4 0-22.2 5-29.5 13.7zM4.7 484.7L169.4 320h45.3L59.7 474.9c29.2-5 68.3-14.1 106.2-29.7C227.3 419.9 279.2 380.5 287 320h32.2c-8 80.6-76 128-141.1 154.8C108.1 503.6 34 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4z"]
};
var faBan = {
  prefix: 'fal',
  iconName: 'ban',
  icon: [512, 512, [128683, "cancel"], "f05e", "M402.7 425.3l-316-316C52.6 148.6 32 199.9 32 256c0 123.7 100.3 224 224 224c56.1 0 107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256C480 132.3 379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7l316 316zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faCancel = faBan;
var faBellExclamation = {
  prefix: 'fal',
  iconName: 'bell-exclamation',
  icon: [448, 512, [], "f848", "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3H44.3C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1V192c0-83 63.1-151.2 144-159.2V16zm16 48C153.3 64 96 121.3 96 192v29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3H403.7c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2V192c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM200 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm40-176V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCircleBookmark = {
  prefix: 'fal',
  iconName: 'circle-bookmark',
  icon: [512, 512, ["bookmark-circle"], "e100", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 176c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16V334.7l-54-43.2c-5.8-4.7-14.1-4.7-20 0l-54 43.2V176zm16-48c-26.5 0-48 21.5-48 48V368c0 6.2 3.5 11.8 9.1 14.4s12.1 1.9 16.9-1.9l70-56 70 56c4.8 3.8 11.4 4.6 16.9 1.9s9.1-8.3 9.1-14.4V176c0-26.5-21.5-48-48-48H208z"]
};
var faBookmarkCircle = faCircleBookmark;
var faEggFried = {
  prefix: 'fal',
  iconName: 'egg-fried',
  icon: [512, 512, [], "f7fc", "M461.1 182.8c31.6 42.6 22.6 102.7-19.9 134.3c-13.4 9.9-28.4 15.8-43.8 18c-23.8 3.3-49.1 13.4-70.9 26.8c-21.6 13.3-42.8 31.8-55.7 54.1C235.5 477.2 157.2 498.2 96 462.9S13.8 349.2 49.1 288c28.1-48.6 42.7-116.9 47.2-168.4c2-22.3 11.7-44 29.1-60.8c38.2-36.7 99-35.5 135.7 2.7c17.9 18.6 42.8 36.8 68.2 51.6s53.5 27.6 78.5 33.9c20.6 5.3 39.6 17.4 53.3 35.8zM415.8 116c-42.4-10.9-101.2-45.1-131.5-76.7c-49-51-130-52.6-181-3.6C80.1 58 67.1 87 64.5 116.8C60.2 166.1 46.2 229.1 21.4 272C-22.7 348.5 3.5 446.4 80 490.6s174.4 18 218.6-58.6c18.8-32.5 66.1-60 103.3-65.2c20.5-2.9 40.6-10.8 58.4-24c56.8-42.1 68.7-122.3 26.6-179.1c-18.2-24.6-43.5-40.7-71-47.8zM224 336a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM96 240a128 128 0 1 0 256 0A128 128 0 1 0 96 240zm88 0c0-22.1 17.9-40 40-40c8.8 0 16-7.2 16-16s-7.2-16-16-16c-39.8 0-72 32.2-72 72c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faFaceWeary = {
  prefix: 'fal',
  iconName: 'face-weary',
  icon: [512, 512, [], "e3a1", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 94c24.2 0 48.2 3.4 71.4 10c-3.5-5.1-7.7-10.3-12.6-15.2c-15.5-15.5-36.2-26.8-58.7-26.8s-43.2 11.3-58.7 26.8c-4.9 4.9-9.2 10.1-12.6 15.2c23.2-6.7 47.2-10 71.4-10zm0-64c33.5 0 61.8 16.7 81.3 36.2c9.8 9.8 17.8 20.8 23.4 31.5c5.5 10.4 9.3 21.8 9.3 32.4c0 5.2-2.5 10.1-6.8 13.1s-9.7 3.7-14.6 2l-16.5-5.9C307.7 386.4 282 382 256 382s-51.8 4.5-76.2 13.2L163.3 401c-4.9 1.8-10.3 1-14.6-2s-6.8-7.9-6.8-13.1c0-10.6 3.8-21.9 9.3-32.4c5.6-10.7 13.6-21.6 23.4-31.5c19.5-19.5 47.9-36.2 81.3-36.2zM211.3 164.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faUniformMartialArts = {
  prefix: 'fal',
  iconName: 'uniform-martial-arts',
  icon: [640, 512, [], "e3d1", "M176 0c-.9 0-1.8 .1-2.7 .2C135.2 2.6 100.8 24.3 82.2 58L15.8 178.8C5.5 197.7 0 218.9 0 240.4V368c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V288 240.4l32-58.2V288h32V121.2c0-6.7-4.2-12.7-10.4-15s-13.3-.5-17.7 4.5c-1.9 2.2-3.6 4.6-5.1 7.3L100 225c-2.6 4.7-4 10-4 15.4V368c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V240.4c0-16.2 4.1-32.1 11.9-46.3L110.3 73.4C123.8 49 149 33.3 176.7 32.1c.4 0 .7 0 1.1-.1h52.3l72 144-56 112h35.8l52.4-104.8L409.9 32h52.3c.4 0 .7 .1 1.1 .1c27.7 1.3 53 16.9 66.4 41.4l66.4 120.7c7.8 14.2 11.9 30.1 11.9 46.3V368c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V240.4c0-5.4-1.4-10.7-4-15.4L481.2 118c-1.4-2.6-3.1-5.1-5-7.3c-4.4-5.1-11.4-6.9-17.7-4.5s-10.4 8.3-10.4 15V288h32V182.3l32 58.2V288v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V240.4c0-21.6-5.4-42.8-15.8-61.7L557.8 58c-18.5-33.7-53-55.4-91.1-57.8c-.9-.1-1.8-.2-2.7-.2H400 240 176zm89.9 32H374.1L320 140.2 265.9 32zM448 384v72c0 13.3-10.7 24-24 24H216c-13.3 0-24-10.7-24-24V384H160v72c0 30.9 25.1 56 56 56H424c30.9 0 56-25.1 56-56V384H448zM144 336c0 8.8 7.2 16 16 16H290.1l-47.4 71.1c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l50.7-76 50.7 76c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L349.9 352H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H320 160c-8.8 0-16 7.2-16 16z"]
};
var faCameraRotate = {
  prefix: 'fal',
  iconName: 'camera-rotate',
  icon: [640, 512, [], "e0d8", "M255.1 32c-20.7 0-39 13.2-45.5 32.8L199.1 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H440.9L430.5 64.8C423.9 45.2 405.6 32 384.9 32H255.1zM239.9 74.9c2.2-6.5 8.3-10.9 15.2-10.9H384.9c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9H512c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h82.7c6.9 0 13-4.4 15.2-10.9l14-42.1zM416 272c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v25.4l-14.1-14.1C368.5 185.8 344.7 176 320 176c-39 0-73.3 19.9-93.3 50.1c-4.9 7.4-2.9 17.3 4.5 22.2s17.3 2.9 22.2-4.5C267.7 222.2 292.2 208 320 208c16.2 0 31.8 6.5 43.3 17.9L377.4 240H352c-8.8 0-16 7.2-16 16s7.2 16 16 16h64zM224 304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V358.6l14.1 14.1C271.5 390.2 295.3 400 320 400c39 0 73.3-19.9 93.3-50.1c4.9-7.4 2.9-17.3-4.5-22.2s-17.3-2.9-22.2 4.5C372.3 353.8 347.8 368 320 368c-16.2 0-31.8-6.5-43.3-17.9L262.6 336H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H224z"]
};
var faSunDust = {
  prefix: 'fal',
  iconName: 'sun-dust',
  icon: [512, 512, [], "f764", "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l0 0 25.1-25.1c-2.2-2.2-5.2-3.8-8.4-4.4L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c.6 3.3 2.2 6.2 4.4 8.4L391 121l0 0L371.1 13.1zM256 128c-70.7 0-128 57.3-128 128c0 35.3 14.3 67.3 37.5 90.5l22.6-22.6C170.7 306.5 160 282.5 160 256c0-53 43-96 96-96c26.5 0 50.5 10.7 67.9 28.1l22.6-22.6C323.4 142.3 291.3 128 256 128zm248 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM400 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM400 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM160 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm160 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM240 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM344 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCommentText = {
  prefix: 'fal',
  iconName: 'comment-text',
  icon: [512, 512, [], "e14d", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM192 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h48V304c0 8.8 7.2 16 16 16s16-7.2 16-16V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 192z"]
};
var faSprayCanSparkles = {
  prefix: 'fal',
  iconName: 'spray-can-sparkles',
  icon: [512, 512, ["air-freshener"], "f5d0", "M128 32v0 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V33v.1 .1 .1 .1 .1 .1 .1 .1 .1V34v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V35v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V36v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V37v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V38v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V39v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V40v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V41v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V42v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V43v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V44v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V45v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V46v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V47 47v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V48v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V49v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V50v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V51v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V52 52v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V53v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V54v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V55 55v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V56v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V57v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V58v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V59v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V60v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V61v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V62v.1 .1 .1 .1 .1 .1 .1 .1 .1V63v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V64v.1 .1 .1 .1 .1 .1 .1 .1 .1V65v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V66v.1 .1 .1 .1 .1 .1 .1 .1 .1V67v.1 .1 .1 .1 .1 .1 .1 .1 .1V68v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V69v.1 .1 .1 .1 .1 .1 .1 .1 .1V70v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V72v.1 .1 .1 .1 .1 .1 .1 .1 .1V73v.1 .1 .1 .1 .1 .1 .1 .1 .1V74v.1 .1 .1 .1 .1 .1 .1 .1V75v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V77v.1 .1 .1 .1 .1 .1 .1 .1V78v.1 .1 .1 .1 .1 .1 .1 .1V79v.1 .1 .1 .1 .1 .1 .1 .1V80 96H96V80v-.1-.1-.1-.1-.1-.1-.1-.1V79v-.1-.1-.1-.1-.1-.1-.1-.1V78v-.1-.1-.1-.1-.1-.1-.1-.1V77v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V75v-.1-.1-.1-.1-.1-.1-.1-.1V74v-.1-.1-.1-.1-.1-.1-.1-.1-.1V73v-.1-.1-.1-.1-.1-.1-.1-.1-.1V72v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V70v-.1-.1-.1-.1-.1-.1-.1-.1-.1V69v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V68v-.1-.1-.1-.1-.1-.1-.1-.1-.1V67v-.1-.1-.1-.1-.1-.1-.1-.1-.1V66v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V65v-.1-.1-.1-.1-.1-.1-.1-.1-.1V64v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V63v-.1-.1-.1-.1-.1-.1-.1-.1-.1V62v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V61v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V60v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V59v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V58v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V57v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V56v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V55 55v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V54v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V53v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V52 52v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V51v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V50v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V49v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V48v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V47 47v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V46v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V45v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V44v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V43v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V42v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V41v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V40v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V39v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V38v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V37v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V36v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V35v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V34v-.1-.1-.1-.1-.1-.1-.1-.1-.1V33v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V80 96H192V80 32H128zM96 160c-35.3 0-64 28.7-64 64V448c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H96zM0 224c0-53 43-96 96-96H224c53 0 96 43 96 96V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224zm208 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 320a80 80 0 1 1 160 0A80 80 0 1 1 80 320zM336 0c8.8 0 16 7.2 16 16V32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H352V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16zM480 16V32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 192v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64-96v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faAirFreshener = faSprayCanSparkles;
var faSignalBars = {
  prefix: 'fal',
  iconName: 'signal-bars',
  icon: [640, 512, ["signal-alt", "signal-alt-4", "signal-bars-strong"], "f690", "M576 464V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16zM512 48c0-26.5 21.5-48 48-48s48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V48zM416 176c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V176zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V176zM256 464V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16zM240 256c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V304c0-26.5 21.5-48 48-48zM96 432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z"]
};
var faSignalAlt = faSignalBars;
var faSignalAlt4 = faSignalBars;
var faSignalBarsStrong = faSignalBars;
var faDiamondExclamation = {
  prefix: 'fal',
  iconName: 'diamond-exclamation',
  icon: [512, 512, [], "e405", "M261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-216 216c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3l-216-216zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faStar = {
  prefix: 'fal',
  iconName: 'star',
  icon: [576, 512, [11088, 61446], "f005", "M226.5 168.8L287.9 42.3l61.4 126.5c4.6 9.5 13.6 16.1 24.1 17.7l137.4 20.3-99.8 98.8c-7.4 7.3-10.8 17.8-9 28.1l23.5 139.5L303 407.7c-9.4-5-20.7-5-30.2 0L150.2 473.2l23.5-139.5c1.7-10.3-1.6-20.7-9-28.1L65 206.8l137.4-20.3c10.5-1.5 19.5-8.2 24.1-17.7zM424.9 509.1c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2z"]
};
var faDialMin = {
  prefix: 'fal',
  iconName: 'dial-min',
  icon: [576, 512, [], "e161", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM276.7 276.7l-89.8 89.8c-39.1-50.2-35.5-122.9 10.6-169c50-50 131-50 181 0s50 131 0 181c-46.2 46.2-118.8 49.7-169 10.6l89.8-89.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM174.9 401.1A160 160 0 1 0 401.1 174.9 160 160 0 1 0 174.9 401.1zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faRepeat = {
  prefix: 'fal',
  iconName: 'repeat',
  icon: [512, 512, [128257], "f363", "M15.2 272C6.4 271.5-.4 264 0 255.2l.4-8C5.1 153.5 82.4 80 176.2 80H320V35.6C320 20.3 332.3 8 347.6 8c6.8 0 13.4 2.5 18.4 7.1l76.7 69c3.4 3 5.3 7.4 5.3 11.9s-1.9 8.9-5.3 11.9l-76.7 69c-5.1 4.6-11.6 7.1-18.4 7.1c-15.2 0-27.6-12.3-27.6-27.6V112H176.2c-76.7 0-140 60.2-143.8 136.8l-.4 8c-.4 8.8-8 15.6-16.8 15.2zM352 146.5L408.1 96 352 45.5l0 100.9zM496.8 240c8.8 .4 15.6 8 15.2 16.8l-.4 8c-4.7 93.7-82 167.2-175.8 167.2L192 432l0 44.4c0 15.2-12.3 27.6-27.6 27.6c-6.8 0-13.4-2.5-18.4-7.1l-76.7-69c-3.4-3-5.3-7.4-5.3-11.9s1.9-8.9 5.3-11.9l76.7-69c5.1-4.6 11.6-7.1 18.4-7.1c15.2 0 27.6 12.3 27.6 27.6l0 44.4 143.8 0c76.7 0 140-60.2 143.8-136.8l.4-8c.4-8.8 8-15.6 16.8-15.2zM160 365.5L103.9 416 160 466.5l0-100.9z"]
};
var faCross = {
  prefix: 'fal',
  iconName: 'cross',
  icon: [384, 512, [128327, 10013], "f654", "M128 40c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v88h88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H256V472c0 22.1-17.9 40-40 40H168c-22.1 0-40-17.9-40-40V256H40c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40h88V40zm40-8c-4.4 0-8 3.6-8 8V144c0 8.8-7.2 16-16 16H40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H144c8.8 0 16 7.2 16 16V472c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V240c0-8.8 7.2-16 16-16H344c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H240c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8H168z"]
};
var faPageCaretDown = {
  prefix: 'fal',
  iconName: 'page-caret-down',
  icon: [384, 512, ["file-caret-down"], "e429", "M352 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H245.5c8.5 0 16.6 3.4 22.6 9.4l74.5 74.5c6 6 9.4 14.1 9.4 22.6V448zM64 512H320c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64zM180.2 346.8c3 3.3 7.3 5.2 11.8 5.2s8.8-1.9 11.8-5.2l75.7-82.6c14.1-15.4 3.2-40.2-17.7-40.2l-139.6 0c-20.9 0-31.8 24.8-17.7 40.2l75.7 82.6zM140.4 256l103.3 0L192 312.3 140.4 256z"]
};
var faFileCaretDown = faPageCaretDown;
var faBox = {
  prefix: 'fal',
  iconName: 'box',
  icon: [448, 512, [128230], "f466", "M342.4 64H240v96H405.9L371.7 83c-5.1-11.6-16.6-19-29.2-19zM416 192H240 208 32V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192zM42.1 160H208V64H105.6c-12.6 0-24.1 7.4-29.2 19L42.1 160zM342.4 32c25.3 0 48.2 14.9 58.5 38l41.6 93.6c3.6 8.2 5.5 17 5.5 26V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V189.6c0-9 1.9-17.8 5.5-26L47.1 70c10.3-23.1 33.2-38 58.5-38H342.4z"]
};
var faVenusMars = {
  prefix: 'fal',
  iconName: 'venus-mars',
  icon: [640, 512, [9892], "f228", "M176 320a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM352 176c0 91.8-70.3 167.2-160 175.3V416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.3C70.3 343.2 0 267.8 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c9.7-5.1 19-10.9 27.8-17.4C325.6 368.5 361 384 400 384c79.5 0 144-64.5 144-144s-64.5-144-144-144c-10.5 0-20.7 1.1-30.6 3.3c-4.1-10.2-8.9-20.1-14.5-29.4C369.3 66 384.4 64 400 64c42.8 0 82.1 15.3 112.6 40.7L585.4 32H496c-8.8 0-16-7.2-16-16s7.2-16 16-16H624c8.8 0 16 7.2 16 16V144c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6l-72.7 72.7C560.7 157.9 576 197.2 576 240c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"]
};
var faClockSevenThirty = {
  prefix: 'fal',
  iconName: 'clock-seven-thirty',
  icon: [512, 512, [], "e351", "M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V308.8l-34.7 52c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l64-96c3.9-5.9 11.2-8.5 17.9-6.4s11.4 8.3 11.4 15.3V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faArrowPointer = {
  prefix: 'fal',
  iconName: 'arrow-pointer',
  icon: [320, 512, ["mouse-pointer"], "f245", "M0 426V55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5c0 12.2-9.9 22.1-22.1 22.1H161.5l61.1 137.5c3.6 8.1 0 17.5-8.1 21.1s-17.5 0-21.1-8.1l-61-137.2L38.6 440.5C34.4 445.3 28.4 448 22 448c-12.2 0-22-9.9-22-22zM32 72V400l86.4-100.8c6.1-7.1 15-11.2 24.3-11.2H272L32 72z"]
};
var faMousePointer = faArrowPointer;
var faClockFourThirty = {
  prefix: 'fal',
  iconName: 'clock-four-thirty',
  icon: [512, 512, [], "e34b", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V285.9l71.1 47.4c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-96-64c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faSignalBarsGood = {
  prefix: 'fal',
  iconName: 'signal-bars-good',
  icon: [640, 512, ["signal-alt-3"], "f693", "M416 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16V464zM400 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48zM256 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16V464zM240 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48zM96 432v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faSignalAlt3 = faSignalBarsGood;
var faCactus = {
  prefix: 'fal',
  iconName: 'cactus',
  icon: [512, 512, [127797], "f8a7", "M320 464c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V320 288 256 224 96c0-35.3 28.7-64 64-64s64 28.7 64 64V352v32 32 32 16zm32-112V96c0-53-43-96-96-96s-96 43-96 96V224H112c-8.8 0-16-7.2-16-16V144c0-26.5-21.5-48-48-48S0 117.5 0 144v64c0 61.9 50.1 112 112 112h48V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V448h48c61.9 0 112-50.1 112-112V272c0-26.5-21.5-48-48-48s-48 21.5-48 48v64c0 8.8-7.2 16-16 16H352zm0 32h48c26.5 0 48-21.5 48-48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 44.2-35.8 80-80 80H352V384zM112 288c-44.2 0-80-35.8-80-80V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5 21.5 48 48 48h48v32H112zM256 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLightbulbGear = {
  prefix: 'fal',
  iconName: 'lightbulb-gear',
  icon: [576, 512, [], "e5fd", "M336 176c0 13.7-1.9 27-5.5 39.5c3.3 1 6.5 2.3 9.5 4v-.9c0-17.8 10.2-35.6 28-43.3C367.6 78.4 289 0 192 0C94.8 0 16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32s144 64.5 144 144zM258.5 443c-5.1-8.8-9.3-17.8-12.8-27h-123c-5.9 0-10.7 4.8-10.7 10.7V432c0 44.2 35.8 80 80 80c35.2 0 65.1-22.8 75.8-54.4c-3.3-4.7-6.4-9.5-9.4-14.6zM192 96c8.8 0 16-7.2 16-16s-7.2-16-16-16C130.1 64 80 114.1 80 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80zM146.7 448h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM399.3 239.8H433c3 16.6 13.9 29.5 26.5 36.7c12.9 7.4 30 9.9 45.9 3.6l17.2 30.5c-12.8 11.4-18.5 27.7-18.5 42.4s5.7 31 18.5 42.4L505.3 426c-15.9-6.3-32.9-3.7-45.9 3.6c-12.6 7.2-23.5 20.2-26.5 36.7H399.3c-3.1-16.6-14-29.5-26.6-36.7c-13-7.4-30-9.9-46-3.7l-17.2-30.5c12.8-11.4 18.5-27.7 18.5-42.4s-5.7-31-18.5-42.4l17.2-30.5c15.9 6.3 33 3.7 46-3.7c12.6-7.2 23.6-20.1 26.6-36.7zm43.5-32H389.4c-11.7 0-21.3 9.5-21.3 21.3v1.4c0 7.6-4.6 14.4-11.3 18.2c-6.6 3.7-14.7 4.2-21.2 .3l-1.6-1c-10.7-6.3-24.4-2.6-30.5 8.2L277 303.1c-5.7 10.2-2.3 23.1 7.8 29c7.3 4.3 11.2 12.6 11.2 21s-3.9 16.7-11.2 21c-10 5.9-13.5 18.8-7.8 29L303.5 450c6.1 10.8 19.9 14.5 30.5 8.2l1.6-1c6.5-3.9 14.6-3.4 21.2 .3c6.6 3.8 11.3 10.6 11.3 18.2v1.4c0 11.7 9.5 21.3 21.3 21.3h53.4c11.8 0 21.4-9.6 21.4-21.4v-1.6c0-7.5 4.6-14.2 11.1-18c6.5-3.7 14.5-4.2 21-.3l1.8 1c10.7 6.3 24.4 2.6 30.5-8.2L555 403.1c5.7-10.2 2.3-23-7.8-29c-7.3-4.3-11.2-12.6-11.2-21s3.9-16.7 11.2-21c10-5.9 13.5-18.8 7.8-29l-26.4-46.9c-6.1-10.8-19.9-14.5-30.5-8.2l-1.8 1c-6.5 3.8-14.5 3.4-21-.3c-6.5-3.7-11.1-10.4-11.1-18v-1.6c0-11.8-9.6-21.4-21.4-21.4zM416.1 409.1a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-24-56a24 24 0 1 1 48.1 0 24 24 0 1 1 -48.1 0z"]
};
var faMaximize = {
  prefix: 'fal',
  iconName: 'maximize',
  icon: [512, 512, ["expand-arrows-alt"], "f31e", "M50.2 196.5l.6 .2c8.2 2 16.8-.4 22.8-6.3l47.1-47.1L233.4 256 120.7 368.7 73.6 321.6c-6-6-14.6-8.4-22.8-6.3l-.6 .2C39.5 318.1 32 327.7 32 338.7V456c0 13.3 10.7 24 24 24l117.3 0c11 0 20.6-7.5 23.3-18.2l.2-.6c2-8.2-.4-16.8-6.3-22.8l-47.1-47.1L256 278.6 368.7 391.3l-47.1 47.1c-6 6-8.4 14.6-6.3 22.8l.2 .6c2.7 10.7 12.3 18.2 23.3 18.2L456 480c13.3 0 24-10.7 24-24l0-117.3c0-11-7.5-20.6-18.2-23.3l-.6-.2c-8.2-2-16.8 .4-22.8 6.3l-47.1 47.1L278.6 256 391.3 143.3l47.1 47.1c6 6 14.6 8.4 22.8 6.3l.6-.2c10.7-2.7 18.2-12.3 18.2-23.3L480 56c0-13.3-10.7-24-24-24H338.7c-11 0-20.6 7.5-23.3 18.2l-.2 .6c-2 8.2 .4 16.8 6.3 22.8l47.1 47.1L256 233.4 143.3 120.7l47.1-47.1c6-6 8.4-14.6 6.3-22.8l-.2-.6C193.9 39.5 184.3 32 173.3 32H56C42.7 32 32 42.7 32 56V173.3c0 11 7.5 20.6 18.2 23.3zM64 154.7L64 64l90.7 0L64 154.7zM154.7 448L64 448l0-90.7L154.7 448zM448 154.7L357.3 64 448 64l0 90.7zM357.3 448L448 357.3l0 90.7-90.7 0z"]
};
var faExpandArrowsAlt = faMaximize;
var faChargingStation = {
  prefix: 'fal',
  iconName: 'charging-station',
  icon: [576, 512, [], "f5e7", "M256 32c17.7 0 32 14.3 32 32V480H64V64c0-17.7 14.3-32 32-32H256zM32 64V480l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 64 288h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0V288h16c26.5 0 48 21.5 48 48v48c0 35.3 28.7 64 64 64s64-28.7 64-64V270.4c36.5-7.4 64-39.7 64-78.4V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v48c0 38.7 27.5 71 64 78.4V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V336c0-44.2-35.8-80-80-80H320V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64zm432 96h64 16v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V160h16zM204.8 121.6c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2l-72 96c-3.6 4.8-4.2 11.3-1.5 16.8s8.3 8.8 14.3 8.8h80l-52.8 70.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2l72-96c3.6-4.8 4.2-11.3 1.5-16.8s-8.3-8.8-14.3-8.8H152l52.8-70.4z"]
};
var faShapes = {
  prefix: 'fal',
  iconName: 'shapes',
  icon: [512, 512, ["triangle-circle-square"], "f61f", "M411.4 175.5c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H192c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l96-160C266.3 5.9 276.8 0 288 0s21.7 5.9 27.4 15.5l96 160zM288 32L192 192H384L288 32zM472 304H328c-4.4 0-8 3.6-8 8V456c0 4.4 3.6 8 8 8H472c4.4 0 8-3.6 8-8V312c0-4.4-3.6-8-8-8zM328 272H472c22.1 0 40 17.9 40 40V456c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V312c0-22.1 17.9-40 40-40zM224 384A96 96 0 1 0 32 384a96 96 0 1 0 192 0zM0 384a128 128 0 1 1 256 0A128 128 0 1 1 0 384z"]
};
var faTriangleCircleSquare = faShapes;
var faPlaneTail = {
  prefix: 'fal',
  iconName: 'plane-tail',
  icon: [512, 512, [], "e22c", "M47.7 32H94.1c12.5 0 24.4 4.8 33.4 13.5L345 256H264.4c-7 0-13.9 .9-20.6 2.7L85.9 300.8 32 51.4C29.9 41.4 37.5 32 47.7 32zM.7 58.1L55 309l-6.7 1.8C19.8 318.4 0 344.2 0 373.7c0 27.3 17 51.7 42.7 61.1l197.1 72.3c8.8 3.2 18.1 4.9 27.5 4.9H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H267.4c-5.6 0-11.2-1-16.5-2.9L53.7 404.8C40.7 400 32 387.6 32 373.7c0-15 10.1-28.1 24.6-32L252 289.6c4-1.1 8.2-1.6 12.4-1.6H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H390.3l.4-.4-11.5-11.1L149.7 22.5C134.8 8.1 114.9 0 94.1 0H47.7C17.1 0-5.7 28.2 .7 58.1zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]
};
var faGaugeSimpleMax = {
  prefix: 'fal',
  iconName: 'gauge-simple-max',
  icon: [512, 512, ["tachometer-fastest"], "f62b", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64s28.7-64 64-64c17.5 0 33.4 7 44.9 18.4l106.9-64.1c7.6-4.5 17.4-2.1 22 5.5s2.1 17.4-5.5 22L317.4 333.8c1.7 5.8 2.6 11.9 2.6 18.2c0 35.3-28.7 64-64 64z"]
};
var faTachometerFastest = faGaugeSimpleMax;
var faCircleU = {
  prefix: 'fal',
  iconName: 'circle-u',
  icon: [512, 512, [], "e127", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 160c0-8.8-7.2-16-16-16s-16 7.2-16 16V288c0 61.9 50.1 112 112 112s112-50.1 112-112V160c0-8.8-7.2-16-16-16s-16 7.2-16 16V288c0 44.2-35.8 80-80 80s-80-35.8-80-80V160z"]
};
var faShieldSlash = {
  prefix: 'fal',
  iconName: 'shield-slash',
  icon: [640, 512, [], "e24b", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM418 414.9c-23.5 22.9-51.8 43.3-85.4 59.4c-7.9 3.8-17.2 3.8-25.1 0C169.2 408.2 122.9 270.7 113.8 174.7L80.1 148.2c2.6 100.7 45.8 274.7 213.5 355c16.7 8 36.1 8 52.8 0c38.6-18.5 70.6-41.9 97-68.2l-25.4-20zM295 7.8L174 59.2l28.6 22.6L307.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.2 45.8-9.6 108.6-37.1 169.6l25.8 20.4c32.5-68.7 43-139.7 43.3-189.8c.1-26.2-16.3-47.9-38.3-57.2L345 7.8c-16-6.8-34-6.8-50 0z"]
};
var faSquarePhoneHangup = {
  prefix: 'fal',
  iconName: 'square-phone-hangup',
  icon: [448, 512, ["phone-square-down"], "e27a", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM81.1 246.7c78.8-72.9 207-72.9 285.7 0c.8 .7 1 1.4 1.1 1.9s0 1.1-.4 1.8l-21.7 35.2c-1 1.7-4.1 3.2-7.4 1.9l-46.2-17.6c-2.4-.9-2.9-2.6-2.9-3.4l2.8-18.1c1.2-7.8-3.4-15.3-10.9-17.7c-37-11.9-77.4-11.9-114.3 0c-7.5 2.4-12.1 9.9-10.9 17.7l2.8 18.1c0 .9-.5 2.5-2.9 3.4l-46.2 17.6c-3.3 1.2-6.4-.3-7.4-1.9L80.4 250.4c-.4-.7-.5-1.2-.4-1.8s.3-1.2 1.1-1.9zm307.5-23.5c-91-84.3-238.2-84.3-329.2 0c-12.3 11.4-15.1 29.5-6.2 44l21.7 35.2c9.6 15.6 29.4 21.4 46 15l46.2-17.6c14.9-5.7 25.1-20.3 23.3-36.9c0-.2-.1-.5-.1-.7l-.7-4.5c22.5-5.1 46.1-5.1 68.6 0l-.7 4.5c0 .2-.1 .5-.1 .7c-1.8 16.6 8.5 31.3 23.3 36.9L327 317.5c16.6 6.3 36.4 .6 46-15l21.7-35.2c8.9-14.4 6.1-32.6-6.2-44z"]
};
var faPhoneSquareDown = faSquarePhoneHangup;
var faArrowUpLeft = {
  prefix: 'fal',
  iconName: 'arrow-up-left',
  icon: [384, 512, [], "e09d", "M48 96c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V150.6L324.7 411.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 128H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H48z"]
};
var faTransporter1 = {
  prefix: 'fal',
  iconName: 'transporter-1',
  icon: [512, 512, [], "e043", "M256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM464 128c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V144c0-8.8 7.2-16 16-16zM48 320c8.8 0 16 7.2 16 16v16H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V336c0-8.8 7.2-16 16-16zm80 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM320 193.1V288H288V176.2c-1.6-.2-3.1-.2-4.7-.2H228.7c-1.6 0-3.2 .1-4.7 .2V288H192V193.1c-.5 .6-1 1.3-1.5 1.9l-65.7 86.7c-5.3 7-15.4 8.4-22.4 3.1s-8.4-15.4-3.1-22.4L165 175.7c15.1-19.9 38.7-31.7 63.7-31.7h54.6c25 0 48.6 11.7 63.7 31.7l65.7 86.7c5.3 7 4 17.1-3.1 22.4s-17.1 4-22.4-3.1L321.5 195c-.5-.7-1-1.3-1.5-1.9zM176 320H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPeanuts = {
  prefix: 'fal',
  iconName: 'peanuts',
  icon: [640, 512, [129372], "e431", "M297.7 160.7c4.7-18.7 3.4-38.9-5.1-57.9L269.9 51.9c-7.5-16.9-27.4-24.5-44.3-17L174.7 57.6c-11.1 4.9-20.7 11.8-28.5 20.1l0 0c-7.8 8.2-14.2 18-18.5 29.3l-.1 .4 0 0c-4.3 11.3-6.1 22.8-5.8 34.1l0 0c.2 6.2 1 12.5 2.5 18.7l.1 .2 .1 .2c4.9 21.3 9.1 50.3-1.8 78.6s-33.4 47-51.3 59.6l-.2 .1-.2 .1c-5.3 3.6-10.1 7.7-14.3 12.2l0 0c-7.8 8.2-14.2 18.1-18.6 29.5c-4.4 11.4-6.2 23-5.9 34.3l0 0c.3 11.3 2.8 22.9 7.7 34l22.7 50.9c7.4 16.6 26.5 24.2 43.2 17.5c4.4 10 10.3 19.2 17.3 27.3l-3.2 1.4c-33.1 14.7-71.8-.2-86.6-33.2L10.5 422.2C3.8 407.2 .4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6C14 314 22.7 300.5 33.4 289.3c5.8-6.1 12.3-11.7 19.5-16.6c16.7-11.8 32.5-25.8 39.8-44.9s5-40.1 .4-60c-2.1-8.4-3.2-17-3.4-25.4c-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9c10.7-11.2 23.6-20.6 38.7-27.3L212.6 5.7c33.1-14.7 71.8 .1 86.6 33.2l22.5 50.6c-2.9 8.4-5.1 17.1-6.7 26c-3.9 19.7-9.2 34.7-17.3 45.3zm-42.3 89.1l-.2 0c-8.2 1.5-16 3.8-23.5 6.9l0 0c-13.7 5.6-26.5 14-37.7 25.2c-11.2 11.2-19.5 24-25.2 37.6l0 0c-5.7 13.6-8.8 28.6-8.8 44.4v68c0 26.5 21.5 48 48 48h68c32.4 0 61.6-13.2 82.7-34.6l0 0c10.8-11 19-23.6 24.5-37l0 0c3.1-7.5 5.4-15.3 6.9-23.5l0-.2 0-.2c5.1-25.9 14.4-58.5 39-83.1s57.2-33.9 83.1-39l.2 0 .2 0c8.2-1.5 16-3.8 23.5-6.9l0 0c13.7-5.6 26.5-14 37.7-25.2c11.2-11.2 19.5-24 25.2-37.6l0 0c5.7-13.6 8.8-28.6 8.8-44.4V80c0-26.5-21.5-48-48-48H492c-32.4 0-61.6 13.2-82.7 34.6l0 0c-10.8 11-19 23.6-24.5 37l0 0c-3.1 7.5-5.4 15.3-6.9 23.5l0 .2-.1 .2c-5.1 25.9-14.4 58.5-39 83.1s-57.2 33.9-83.1 39l-.2 0zm126.1 218C354.7 495.1 317.3 512 276 512H208c-44.2 0-80-35.8-80-80V364c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30c7.1-17.1 17.5-33.2 31.3-47.2C413.3 16.9 450.7 0 492 0h68c44.2 0 80 35.8 80 80v68c0 20.1-4 39.2-11.2 56.7c-7.2 17.5-17.9 33.8-32.1 48c-14.2 14.2-30.6 24.9-48.1 32.1c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2zM544 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm-64 64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm-224 224a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM300.8 416a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM544 172.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM300.8 352a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0z"]
};
var faShuffle = {
  prefix: 'fal',
  iconName: 'shuffle',
  icon: [512, 512, [128256, "random"], "f074", "M427.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 112H400 344c-20.1 0-39.1 9.5-51.2 25.6L244 202.7l20 26.7 54.4-72.5c6-8.1 15.5-12.8 25.6-12.8h56 57.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80zM124.8 361.6c-3 4-7.8 6.4-12.8 6.4H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c15.1 0 29.3-7.1 38.4-19.2L204 309.3l-20-26.7-59.2 78.9zM404.7 475.3c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 368H400 344c-10.1 0-19.6-4.7-25.6-12.8l-168-224C141.3 119.1 127.1 112 112 112H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c5 0 9.8 2.4 12.8 6.4l168 224C304.9 390.5 323.9 400 344 400h56 57.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6z"]
};
var faRandom = faShuffle;
var faPersonRunning = {
  prefix: 'fal',
  iconName: 'person-running',
  icon: [448, 512, [127939, "running"], "f70c", "M280 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 280 0zM140.6 116.4c12.7-3.2 26.1-3.2 38.8 0L274 140c16.6 4.2 29.8 16.9 34.5 33.4l20.3 71c2 6.9 8.2 11.6 15.4 11.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H344.1c-21.4 0-40.3-14.2-46.2-34.8l-13.6-47.7L247.2 317.1c-.2 .5-.3 .9-.5 1.3l37.5 21.1c13.6 7.6 19.7 23.9 14.5 38.5L255.1 501.3c-2.9 8.3-12.1 12.7-20.4 9.8s-12.7-12.1-9.8-20.4l43.5-123.3-93.3-52.5c-20-11.3-29.3-35.2-22-57l35.4-106.2-16.9-4.2c-7.6-1.9-15.6-1.9-23.3 0l-1.5 .4c-7.4 1.8-14.2 5.4-20 10.4L74.5 204c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l52.4-45.8c9.6-8.4 21-14.3 33.3-17.4l1.5-.4zm79.1 43.1L183.5 268c-2.4 7.3 .7 15.2 7.3 19l27.5 15.4 44.1-132.3-42.7-10.7zM101.3 384L130 314.1c5.9 10 14.1 18.7 24.1 25.4l-23.3 56.6c-4.9 12-16.6 19.8-29.6 19.8H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h85.3z"]
};
var faRunning = faPersonRunning;
var faMobileRetro = {
  prefix: 'fal',
  iconName: 'mobile-retro',
  icon: [320, 512, [], "e527", "M256 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H256zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 160v64H96V160H224zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
};
var faGripLinesVertical = {
  prefix: 'fal',
  iconName: 'grip-lines-vertical',
  icon: [192, 512, [], "f7a5", "M32 32c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16L48 48c0-8.8-7.2-16-16-16zm128 0c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16z"]
};
var faBinBottlesRecycle = {
  prefix: 'fal',
  iconName: 'bin-bottles-recycle',
  icon: [640, 512, [], "e5f6", "M384 16c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H400c-8.8 0-16 7.2-16 16zM352 192c0-28.1-12.1-53.4-31.4-71c-17.1-15.5-39.7-25-64.6-25H128c-53 0-96 43-96 96H64c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64h32zm223.1 0c-1.2-9.7-4.6-18.7-9.6-26.5c6.4-9.5 10.1-21 10.1-33.3c0-23.2-13.4-44.3-34.4-54.2L528 71.8c-11-5.1-23-7.8-35.1-7.8H402.3c-12.1 0-24.1 2.7-35.1 7.8L354.1 78c-7.2 3.4-13.5 8-18.6 13.6c8.4 6.7 16 14.4 22.5 22.9c2.6-3.2 5.9-5.8 9.7-7.6l13.2-6.2c6.7-3.2 14.1-4.8 21.5-4.8h90.6c7.4 0 14.8 1.6 21.5 4.8l13.1 6.2c9.8 4.6 16 14.4 16 25.2c0 5.8-1.7 11.1-4.7 15.5c-7.1 10.6-7.2 24.4-.4 35.1c1.8 2.8 3.2 5.9 4 9.2h32.5zm21.2 32H577.7 62.3 43.7 33.9 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H33.9L55.7 441.3c4.7 40.3 38.9 70.7 79.5 70.7H504.9c40.6 0 74.7-30.4 79.5-70.7L606.1 256H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H606.1h-9.8zM87.5 437.6L66.1 256H573.9L552.5 437.6c-2.8 24.2-23.3 42.4-47.7 42.4H135.1c-24.3 0-44.8-18.2-47.7-42.4zM319.9 320c4.6 0 9 2.3 11.5 6.2l8.5 12.9c4.8 7.3 14.5 9.4 21.8 4.8c7.6-4.8 9.8-14.9 4.9-22.4l-8.5-12.9c-8.5-12.9-22.8-20.6-38.2-20.6c-15.3 0-29.6 7.7-38.1 20.4l-7.6 11.4c-5 7.5-2.8 17.7 4.8 22.4c7.3 4.6 17 2.5 21.8-4.7l7.6-11.4c2.6-3.8 6.9-6.1 11.5-6.1zm-59.4 48.4c-7.3-4.6-17-2.5-21.8 4.7l-7.9 11.9c-4.4 6.7-6.8 14.5-6.8 22.5c0 22.4 18.2 40.6 40.6 40.6h25.2c8.8 0 16-7.2 16-16s-7.2-16-16-16H264.6c-4.7 0-8.6-3.8-8.6-8.6c0-1.7 .5-3.3 1.4-4.7l7.9-11.9c5-7.5 2.8-17.7-4.8-22.4zM337.7 432c0 8.8 7.2 16 16 16h20.9c22.4 0 40.6-18.2 40.6-40.6c0-7.9-2.3-15.7-6.7-22.4l-6.6-10.1c-4.8-7.3-14.5-9.4-21.8-4.8c-7.6 4.8-9.8 14.9-4.9 22.4l6.6 10.1c.9 1.4 1.4 3.1 1.4 4.7c0 4.8-3.9 8.6-8.6 8.6H353.7c-8.8 0-16 7.2-16 16zM160 0c-17.7 0-32 14.3-32 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V32h64V48c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16c0-17.7-14.3-32-32-32H160z"]
};
var faArrowUpFromSquare = {
  prefix: 'fal',
  iconName: 'arrow-up-from-square',
  icon: [512, 512, [], "e09c", "M267.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-104 104c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6V320c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-104-104zM64 32C28.7 32 0 60.7 0 96V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H416c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"]
};
var faFileDashedLine = {
  prefix: 'fal',
  iconName: 'file-dashed-line',
  icon: [640, 512, ["page-break"], "f877", "M480 448c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352H128v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352H480v96zm0-256v64h32V163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V256h32V64c0-17.7 14.3-32 32-32H320V144c0 26.5 21.5 48 48 48H480zm-.5-32H368c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM48 288c-8.8 0-16 7.2-16 16s7.2 16 16 16H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H464z"]
};
var faPageBreak = faFileDashedLine;
var faBracketCurlyRight = {
  prefix: 'fal',
  iconName: 'bracket-curly-right',
  icon: [256, 512, [], "7d", "M192 112c0-44.2-35.8-80-80-80H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c26.5 0 48 21.5 48 48v53.5c0 21.2 8.4 41.6 23.4 56.6L217.4 256l-33.9 33.9c-15 15-23.4 35.4-23.4 56.6V400c0 26.5-21.5 48-48 48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c44.2 0 80-35.8 80-80V346.5c0-12.7 5.1-24.9 14.1-33.9l45.3-45.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-45.3-45.3c-9-9-14.1-21.2-14.1-33.9V112z"]
};
var faSpider = {
  prefix: 'fal',
  iconName: 'spider',
  icon: [512, 512, [128375], "f717", "M158.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L83.6 101c-8.9 17.9-5.9 39.5 7.8 54.1l71.1 76.5L60.8 204.9c-5.2-1.4-9.4-5.3-11.1-10.4L31.2 138.9c-2.8-8.4-11.9-12.9-20.2-10.1S-2 140.7 .8 149.1l18.5 55.6C24.5 220 37 231.8 52.7 235.9L129.1 256 52.7 276.1C37 280.2 24.5 292 19.3 307.4L.8 362.9c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l18.5-55.6c1.7-5.1 5.9-9 11.1-10.4l84-22.1L85 368.7c-9.4 13.1-11.5 30.1-5.7 45.1l33.8 87.9c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7l-33.8-87.9c-1.9-5-1.2-10.7 1.9-15L144.1 341c2.6 59.5 51.7 107 111.9 107s109.3-47.5 111.9-107L401 387.3c3.1 4.4 3.8 10 1.9 15l-33.8 87.9c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2l33.8-87.9c5.8-15.1 3.6-32-5.7-45.1L367.2 285l84 22.1c5.2 1.4 9.4 5.3 11.1 10.4l18.5 55.6c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-18.5-55.6c-5.1-15.4-17.7-27.1-33.3-31.2L382.9 256l76.5-20.1c15.7-4.1 28.2-15.9 33.3-31.2l18.5-55.6c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-18.5 55.6c-1.7 5.1-5.9 9-11.1 10.4L349.6 231.7l71.1-76.5c13.6-14.7 16.7-36.2 7.8-54.1L382.3 8.8c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l46.1 92.2c3 6 2 13.2-2.6 18L336 199.3V152c0-32.2-19-59.9-46.3-72.6c-7.7-3.6-16.8-.5-20.8 6.9L256 110.3 243.1 86.3c-4-7.5-13.2-10.5-20.8-6.9C195 92.1 176 119.8 176 152v47.3l-61.2-65.9c-4.5-4.9-5.6-12.1-2.6-18l46.1-92.2zm130.4 93.8c9.4 8.8 15.2 21.3 15.2 35.1V256v0l0 .4c0 4.6 1.9 8.9 5.3 12C325.7 283 336 304.3 336 328v8c0 44.2-35.8 80-80 80s-80-35.8-80-80v-8c0-23.7 10.3-45 26.7-59.6c3.4-3 5.3-7.4 5.3-12l0-.4v0V152c0-13.8 5.9-26.3 15.2-35.1l18.7 34.7c2.8 5.2 8.2 8.4 14.1 8.4s11.3-3.2 14.1-8.4l18.7-34.7z"]
};
var faClockThree = {
  prefix: 'fal',
  iconName: 'clock-three',
  icon: [512, 512, [], "e356", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V256c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faHandsBound = {
  prefix: 'fal',
  iconName: 'hands-bound',
  icon: [640, 512, [], "e4f9", "M16.8 48C16.8 21.2 38.7-.4 65.5 0c26 .4 47.2 23.7 47.2 49.7L112 154.7 173.9 228c7.1 8.4 20.1-1.8 13.6-10.7l-28.6-39.2c-13.4-18.5-13.1-44.6 2.5-61.4c25.5-27.4 60.5-15.2 74.4 4l42.3 58.4c16.6 22.1 25.6 49.1 25.6 76.9V352H336V255.9c0-27.7 9-54.7 25.6-76.9l42.3-58.4c13.9-19.2 48.9-31.4 74.4-4c15.6 16.7 15.9 42.9 2.5 61.4l-28.6 39.2c-6.5 9 6.5 19.1 13.6 10.7l61.9-73.4-.7-104.9c0-26 21.2-49.4 47.2-49.7c26.8-.4 48.7 21.2 48.7 48l.8 138.2c0 11-3.7 21.5-10.5 30L506.4 349.9c-.5 .7-1.1 1.4-1.6 2.1H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h22.9c-.5-.7-1-1.4-1.6-2.1L26.5 216.2c-6.7-8.5-10.5-19-10.5-30L16.8 48zM170.2 352H271.9l-.1-96.1c0-20.6-6.7-41.1-19.5-58L210 139.6c-5.4-7.4-15.4-8.7-22.3-3.5c-7.9 5.6-8.4 15.7-3.5 22.2l30.5 42.2c.2 .2 .5 .5 .5 .8c26.1 39.7-33.8 86.7-70.7 42.4L87.4 175.2c-4.8-5.8-7.5-13.1-7.4-20.7l.6-105.9c0-22.4-32-21.7-32-.7L48 186.2c0 3.6 1.2 7.2 3.5 10L158.3 329.9c5 6.2 9 13.9 11.9 22.1zm311.2-22.1L588.3 196.2c2.2-2.7 3.5-6.4 3.5-10l-.7-138.3c0-21-32-21.6-32 .7l.6 105.9c0 7.5-2.6 14.9-7.4 20.7l-57.1 68.5c-36.8 44.4-96.8-2.6-70.7-42.4c0-.2 .2-.5 .5-.8l30.5-42.2c4.9-6.5 4.4-16.6-3.5-22.2c-7-5.2-17-3.9-22.3 3.5l-42.3 58.4c-12.7 16.9-19.5 37.4-19.5 58l-.1 96.1H469.6c2.9-8.2 6.9-15.9 11.9-22.1zM112 416H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H496v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H368v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H304v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H176v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faScalpelLineDashed = {
  prefix: 'fal',
  iconName: 'scalpel-line-dashed',
  icon: [576, 512, ["scalpel-path"], "f61e", "M441.4 32c-11.4 0-22.2 5-29.5 13.7L234.4 256h98.2c4.7 0 9.2-2.1 12.2-5.7L470 102c6.5-7.7 10-17.4 10-27.5v-4C480 49.3 462.7 32 441.4 32zm-54-6.9C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17H200c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1zM169.4 320h45.3L59.7 474.9c29.2-5 68.3-14.1 106.2-29.7C227.3 419.9 279.2 380.5 287 320h32.2c-8 80.6-76 128-141.1 154.8C108.1 503.6 34 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L169.4 320zM304 480c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zm64 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faScalpelPath = faScalpelLineDashed;
var faFileInvoiceDollar = {
  prefix: 'fal',
  iconName: 'file-invoice-dollar',
  icon: [384, 512, [], "f571", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm144 99.6v13.6c8.3 1.1 16.3 2.7 23.7 4.5c8.6 2 13.9 10.7 11.9 19.3s-10.7 13.9-19.3 11.9c-11.2-2.6-22.2-4.6-32.5-4.8c-8.7-.1-17.9 1.7-24.3 5.1c-6.1 3.2-7.4 6.3-7.4 9.4c0 1.5 .2 3.6 6.6 7c7 3.7 16.8 6.4 29.4 9.8l.5 .1c11.3 3 25.2 6.8 36.1 12.9c11.8 6.6 23.1 17.7 23.4 35.9c.3 18.9-10.6 31.7-23.6 38.9c-7.5 4.1-15.9 6.6-24.4 7.9v13.5c0 8.8-7.2 16-16 16s-16-7.2-16-16V414.4c-10.9-1.9-21.2-5-30.3-7.8l0 0 0 0c-2.1-.7-4.2-1.3-6.2-1.9c-8.5-2.5-13.3-11.4-10.8-19.9s11.4-13.3 19.9-10.8c2.4 .7 4.8 1.4 7.1 2.1c13.6 4.1 24.8 7.5 36.8 7.9c9.4 .3 18.5-1.6 24.4-4.9c5.4-3 7.2-6.2 7.1-10.4c0-2.4-.8-4.9-7-8.4c-6.9-3.9-16.8-6.7-29.2-10l-1.6-.4c-11-3-24.2-6.5-34.6-12.1c-11.5-6.2-23.3-16.9-23.4-35.1c-.1-19 11.9-31.3 24.5-37.9c7.3-3.8 15.4-6.2 23.4-7.5V243.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPipeSmoking = {
  prefix: 'fal',
  iconName: 'pipe-smoking',
  icon: [640, 512, [], "e3c4", "M586.6 32c-35.2 0-68.4 16.6-89.5 44.7L395 212.5c18.2 15.5 22.4 42.4 8.9 62.8L296 439.8C266.5 484.9 216.2 512 162.3 512H160C71.6 512 0 440.4 0 352V280c0-30.9 25.1-56 56-56H200c28.4 0 51.9 21.2 55.5 48.6l49.5-66c14.9-19.9 42.5-25 63.5-12.1l103-137C498.7 21.3 541.3 0 586.6 0H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H586.6zm-256 193.8L252.8 329.6c-4.1 5.5-11.3 7.8-17.9 5.6S224 326.9 224 320V280c0-13.3-10.7-24-24-24H56c-13.3 0-24 10.7-24 24v72c0 70.7 57.3 128 128 128h2.3c43.1 0 83.4-21.7 107-57.8L377.2 257.8c4.8-7.3 2.8-17.2-4.5-22.1l-20.4-13.6c-7.1-4.7-16.6-3.1-21.7 3.7z"]
};
var faFaceAstonished = {
  prefix: 'fal',
  iconName: 'face-astonished',
  icon: [512, 512, [], "e36b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V352zm-96 0c0-35.3 28.7-64 64-64s64 28.7 64 64v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V352zM152.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faWindow = {
  prefix: 'fal',
  iconName: 'window',
  icon: [512, 512, [], "f40e", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPlaneCircleExclamation = {
  prefix: 'fal',
  iconName: 'plane-circle-exclamation',
  icon: [640, 512, [], "e556", "M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2l0 0L256 480.6l105.7 30.2 0 0c2.7 .8 5.5 1.2 8.2 1.2c6.5 0 12.5-2 17.4-5.5c-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8V290.6c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faEar = {
  prefix: 'fal',
  iconName: 'ear',
  icon: [384, 512, [128066], "f5f0", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192V368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-16.4 8.2-32.2 22.5-41.4C322.8 298.1 352 248.5 352 192zm32 0c0 67.8-35.1 127.4-88.2 161.5c-4.9 3.2-7.8 8.6-7.8 14.5c0 79.5-64.5 144-144 144S0 447.5 0 368V192C0 86 86 0 192 0S384 86 384 192zm-272 0v6.3c0 10.7 5.3 20.7 14.2 26.6l8.9 5.9c15.5 10.4 24.9 27.8 24.9 46.5c0 16.6-7.4 32.3-20.1 42.9l-33.7 28c-6.8 5.7-16.9 4.7-22.5-2s-4.7-16.9 2-22.5l33.7-28c5.4-4.5 8.6-11.2 8.6-18.3c0-8-4-15.4-10.6-19.9l-8.9-5.9C90.7 239.7 80 219.7 80 198.3V192c0-61.9 50.1-112 112-112s112 50.1 112 112v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faFileLock = {
  prefix: 'fal',
  iconName: 'file-lock',
  icon: [576, 512, [], "e3a6", "M384 192H352 320 240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c0 11.4 3 22.2 8.3 31.5c-2.7 .3-5.5 .5-8.3 .5H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V192zM240 160H351.5c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16zm224 64c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H544V352H384z"]
};
var faDiagramVenn = {
  prefix: 'fal',
  iconName: 'diagram-venn',
  icon: [640, 512, [], "e15a", "M224 448C118 448 32 362 32 256S118 64 224 64c21.5 0 42.1 3.5 61.4 10C228.8 114.7 192 181 192 256s36.8 141.3 93.4 182c-19.3 6.5-39.9 10-61.4 10zM415.3 240H224.7c1.4-16.7 4.9-32.8 10.3-48H405.1c5.4 15.2 8.9 31.3 10.3 48zM224.7 272H415.3c-1.4 16.7-4.9 32.8-10.3 48H234.9c-5.4-15.2-8.9-31.3-10.3-48zm25 80H390.3c-16.9 29.1-41.2 53.5-70.3 70.3c-29.1-16.9-53.5-41.2-70.3-70.3zm0-192c16.9-29.1 41.2-53.5 70.3-70.3c29.1 16.9 53.5 41.2 70.3 70.3H249.7zM224 480c34.4 0 66.9-7.7 96-21.6c29.1 13.8 61.6 21.6 96 21.6c123.7 0 224-100.3 224-224S539.7 32 416 32c-34.4 0-66.9 7.7-96 21.6C290.9 39.7 258.4 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480zM416 64c106 0 192 86 192 192s-86 192-192 192c-21.5 0-42.1-3.5-61.4-10C411.2 397.3 448 331 448 256s-36.8-141.3-93.4-182c19.3-6.5 39.9-10 61.4-10z"]
};
var faXRay = {
  prefix: 'fal',
  iconName: 'x-ray',
  icon: [512, 512, [], "f497", "M0 48c0-8.8 7.2-16 16-16H48 464h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V448h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H464 48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V64H16C7.2 64 0 56.8 0 48zM64 64V448H448V64H64zM256 96c8.8 0 16 7.2 16 16v32h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v53.5l45.1-17.4c7-2.7 14.4-4.1 21.9-4.1h2.2c32.5 0 58.8 26.3 58.8 58.8c0 13.2-4.4 25.9-12.5 36.3l-18.2 23.2c-12.7 16.2-32.2 25.7-52.9 25.7H195.6c-20.6 0-40.1-9.5-52.9-25.7l-18.2-23.2C116.4 356.8 112 344 112 330.8c0-32.5 26.3-58.8 58.8-58.8H173c7.5 0 14.9 1.4 21.9 4.1L240 293.5V240H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V176H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V112c0-8.8 7.2-16 16-16zM144 330.8c0 6 2 11.8 5.7 16.5l18.2 23.2c6.7 8.5 16.9 13.5 27.7 13.5H316.4c10.8 0 21-5 27.7-13.5l18.2-23.2c3.7-4.7 5.7-10.5 5.7-16.5c0-14.8-12-26.8-26.8-26.8H339c-3.6 0-7.1 .7-10.4 1.9l-55.3 21.3c-11.1 4.3-23.4 4.3-34.5 0l-55.3-21.3c-3.3-1.3-6.9-1.9-10.4-1.9h-2.1C156 304 144 316 144 330.8zM192 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faGoalNet = {
  prefix: 'fal',
  iconName: 'goal-net',
  icon: [640, 512, [], "e3ab", "M32 112c0-26.5 21.5-48 48-48H560c26.5 0 48 21.5 48 48V464c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-44.2-35.8-80-80-80H80C35.8 32 0 67.8 0 112V464c0 8.8 7.2 16 16 16s16-7.2 16-16V112zm144 0c-8.8 0-16 7.2-16 16v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V320h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V128c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H384V128c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H288V128c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H192V128c0-8.8-7.2-16-16-16zm16 112h64v64H192V224zm96 0h64v64H288V224zm96 0h64v64H384V224zM192 384V320h64v64H192zm96 0V320h64v64H288zm96 0V320h64v64H384z"]
};
var faCoffinCross = {
  prefix: 'fal',
  iconName: 'coffin-cross',
  icon: [384, 512, [], "e051", "M35.6 136c-2.3 2.6-3.6 6-3.6 9.5c0 1.4 .2 2.7 .6 4L128.1 480l127.9 0 95.5-330.6c.4-1.3 .6-2.6 .6-4c0-3.5-1.3-6.9-3.6-9.5l-91-104-131 0-91 104zM11.5 114.9l91-104C108.5 4 117.3 0 126.5 0h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6zM208 112v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H208V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V208H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSpellCheck = {
  prefix: 'fal',
  iconName: 'spell-check',
  icon: [576, 512, [], "f891", "M126.7 9.7C124.2 3.8 118.4 0 112 0s-12.2 3.8-14.7 9.7l-96 224c-3.5 8.1 .3 17.5 8.4 21s17.5-.3 21-8.4L54 192H170l23.3 54.3c3.5 8.1 12.9 11.9 21 8.4s11.9-12.9 8.4-21l-96-224zM156.3 160H67.7L112 56.6 156.3 160zM256 16V128 240c0 8.8 7.2 16 16 16H376c39.8 0 72-32.2 72-72c0-31.1-19.7-57.6-47.3-67.6C410.3 104.1 416 88.7 416 72c0-39.8-32.2-72-72-72H272c-8.8 0-16 7.2-16 16zm88 96H288V32h56c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-56 32h56 32c22.1 0 40 17.9 40 40s-17.9 40-40 40H288V144zM571.3 299.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L352 473.4 251.3 372.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l208-208z"]
};
var faLocationXmark = {
  prefix: 'fal',
  iconName: 'location-xmark',
  icon: [384, 512, ["map-marker-times", "map-marker-xmark"], "f60e", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM116.7 116.7c6.2-6.2 16.4-6.2 22.6 0L192 169.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L214.6 192l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L192 214.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 192l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faMapMarkerTimes = faLocationXmark;
var faMapMarkerXmark = faLocationXmark;
var faCircleQuarterStroke = {
  prefix: 'fal',
  iconName: 'circle-quarter-stroke',
  icon: [512, 512, [], "e5d3", "M480 256C480 132.3 379.7 32 256 32V208c0 26.5-21.5 48-48 48H32c0 123.7 100.3 224 224 224s224-100.3 224-224zM224 34.3C125.9 48.3 48.3 125.9 34.3 224H208c8.8 0 16-7.2 16-16V34.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faLasso = {
  prefix: 'fal',
  iconName: 'lasso',
  icon: [576, 512, [], "f8c8", "M576 176c0 97.2-128.9 176-288 176c-22.9 0-45.3-1.6-66.7-4.7c11.9 17.2 18.7 38 18.7 59.7c0 58-47 105-105 105H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h87c40.3 0 73-32.7 73-73c0-27.6-15.6-52.9-40.4-65.3l-34.9-17.4C52.9 293 0 238.3 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 320c141.4 0 256-64.5 256-144S429.4 32 288 32S32 96.5 32 176s114.6 144 256 144z"]
};
var faSlash = {
  prefix: 'fal',
  iconName: 'slash',
  icon: [640, 512, [], "f715", "M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5s-15.5 8.1-22.5 2.6L6.1 28.6C-.8 23.1-2 13 3.4 6.1z"]
};
var faPersonToPortal = {
  prefix: 'fal',
  iconName: 'person-to-portal',
  icon: [512, 512, ["portal-enter"], "e022", "M256 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 224 56a56 56 0 1 0 112 0zM179.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L53.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L153.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L224.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L298.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L298 253.2c5.9 20.6 24.7 34.8 46.2 34.8H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H344.1c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7L218.3 302.4 190.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM130 314.1L101.3 384H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zM458.5 444.2C445.6 480 433.6 480 432 480h0 0c-1.6 0-13.6 0-26.4-35.8c-9.4-26.3-16.8-66.4-19.9-124.2h-32c7.3 140.7 39.7 192 78.4 192c44.2 0 80-66.6 80-256S476.2 0 432 0c-41.6 0-75.8 59-79.6 224h32c1.8-75.3 10.1-125.3 21.2-156.2C418.4 32 430.4 32 432 32l0 0 0 0c1.6 0 13.6 0 26.4 35.8C471.1 102.9 480 162.5 480 256s-8.9 153.1-21.5 188.2z"]
};
var faPortalEnter = faPersonToPortal;
var faCalendarStar = {
  prefix: 'fal',
  iconName: 'calendar-star',
  icon: [512, 512, [], "f736", "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H96c-35.3 0-64 28.7-64 64v32 32V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H384V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H160V16zM64 192H448V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V192zM96 96H416c17.7 0 32 14.3 32 32v32H64V128c0-17.7 14.3-32 32-32zM277.5 231.5c-8.8-17.8-34.2-17.8-43 0l-22 44.6-49.2 7.2c-19.7 2.9-27.5 27.1-13.3 40.9l35.6 34.7-8.4 49c-3.4 19.6 17.2 34.6 34.8 25.3l44-23.2 44 23.2c17.6 9.3 38.2-5.7 34.8-25.3l-8.4-49 35.6-34.7c14.2-13.9 6.4-38.1-13.3-40.9l-49.2-7.2-22-44.6zm-40.1 66.3L256 260.2l18.6 37.6 3.7 7.5 8.3 1.2 41.5 6-30 29.3-6 5.9 1.4 8.3 7.1 41.4-37.1-19.5-7.4-3.9-7.4 3.9-37.1 19.5 7.1-41.4 1.4-8.3-6-5.9-30-29.3 41.5-6 8.3-1.2 3.7-7.5z"]
};
var faComputerMouse = {
  prefix: 'fal',
  iconName: 'computer-mouse',
  icon: [384, 512, [128433, "mouse"], "f8cc", "M192 224H32V352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128V224H192zm192-32v16 16V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V224 208 192 160C0 71.6 71.6 0 160 0h16 16 16 16c88.4 0 160 71.6 160 160v32zM208 32V192H352V160c0-70.7-57.3-128-128-128H208zm-32 0H160C89.3 32 32 89.3 32 160v32H176V32z"]
};
var faMouse = faComputerMouse;
var faArrowRightToBracket = {
  prefix: 'fal',
  iconName: 'arrow-right-to-bracket',
  icon: [512, 512, ["sign-in"], "f090", "M347.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l281.4 0L196.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM336 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c44.2 0 80-35.8 80-80l0-288c0-44.2-35.8-80-80-80l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-96 0z"]
};
var faSignIn = faArrowRightToBracket;
var faPegasus = {
  prefix: 'fal',
  iconName: 'pegasus',
  icon: [576, 512, [], "f703", "M333 153.3c1.1-1.5 1.9-3.3 2.5-5.2c.4-1.4 .6-2.9 .5-4.4C336.1 82 386.2 32 448 32h24 8 5.8c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7c-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1H432c-8.8 0-16 7.2-16 16v52.8c-.3 1.5-.4 3-.3 4.5c.2 2.2 .3 4.4 .3 6.7c0 24-10.4 45.1-26.7 59.6c-3.4 3-5.3 7.4-5.3 11.9V472c0 4.4-3.6 8-8 8H344c-4.4 0-8-3.6-8-8V334.7c0-7.8-5.6-14.5-13.3-15.8c-1.4-.2-2.8-.5-4.3-.8L202.2 291.9c-5.2-1.2-10.6 .3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7c0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1H141.6c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9c0-4.6-.9-9.3-2.7-13.5L99.9 230.2C97.3 224 96 217.4 96 210.7c0-21.8 13.8-40.5 33.2-47.6c-4.4-9.4-8.4-19.3-11.8-29.8c-20.4 7.7-37 23.3-46 43.1C31.3 180.8 0 214.7 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-20.9 13.4-38.7 32-45.3c0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2 .4 .2 .8 .2 1.2c0 .4-.1 .9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3h33.2c26.5 0 45.6-25.2 38.5-50.7l-15.9-57.2c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4L304 347.6V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V318.4c19.6-20 32-47.5 32-78.4c0-1.9-.1-3.9-.1-5.8c.1-.7 .1-1.4 .1-2.2V192h7.4l1.7 2.5c19 28.6 57.4 36.8 86.5 18.6c20.4-12.7 31.8-35.9 29.6-59.9l-7.7-80.8c-1.5-15.5-7.3-29.7-16.3-41.3C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16H485.8 480h-8H448C377.4 0 318.7 50.8 306.4 117.8L159.9 34.1c-5-2.8-11-2.8-16 .1s-8 8.1-8 13.8c0 77.2 34.4 132.9 68.3 169c16.9 18 33.9 31.2 46.6 40c6.4 4.4 11.7 7.7 15.5 9.9c1.9 1.1 3.4 2 4.5 2.5c.5 .3 1 .5 1.3 .7l.4 .2 .1 .1 0 0 0 0s0 0 7.2-14.3l-7.2 14.3c7.9 4 17.5 .7 21.5-7.2s.8-17.5-7.1-21.5l0 0 0 0-.2-.1-.9-.5c-.8-.4-2-1.1-3.6-2c-3.2-1.8-7.8-4.7-13.5-8.6c-11.3-7.8-26.4-19.5-41.4-35.5c-25.6-27.2-50.8-66.2-57.8-118.4l142.2 81.2c3 1.7 6.4 2.4 9.6 2c2.3-.2 4.5-1 6.4-2.1s3.6-2.6 5-4.5zM480 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faFilesMedical = {
  prefix: 'fal',
  iconName: 'files-medical',
  icon: [448, 512, [], "f7fd", "M384 384c17.7 0 32-14.3 32-32V144.8c0-.3 0-.5 0-.8H336c-17.7 0-32-14.3-32-32V32H160c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H384zm6-272L336 57.5V112h54zM96 64c0-35.3 28.7-64 64-64H304c12.8 0 25.1 5.1 34.1 14.2l96 96.8c8.9 9 13.9 21.1 13.9 33.8V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64zM16 96c8.8 0 16 7.2 16 16V384c0 53 43 96 96 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 512 0 454.7 0 384V112c0-8.8 7.2-16 16-16zm245.3 64h21.3c17.7 0 32 14.3 32 32v21.3H336c17.7 0 32 14.3 32 32v21.3c0 17.7-14.3 32-32 32H314.7V320c0 17.7-14.3 32-32 32H261.3c-17.7 0-32-14.3-32-32V298.7H208c-17.7 0-32-14.3-32-32V245.3c0-17.7 14.3-32 32-32h21.3V192c0-17.7 14.3-32 32-32zm0 32v37.3c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7l-37.3 0v21.3h37.3c8.8 0 16 7.2 16 16V320h21.3V282.7c0-8.8 7.2-16 16-16l37.3 0V245.3H298.7c-8.8 0-16-7.2-16-16l0-37.3H261.3z"]
};
var faNfcLock = {
  prefix: 'fal',
  iconName: 'nfc-lock',
  icon: [576, 512, [], "e1f8", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H320v32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v65.1c-11.3 1.6-22.1 4.9-32 9.6V96c0-17.7-14.3-32-32-32zm0 64v65.6c-19.8 20.2-32 47.9-32 78.4V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32zM96 384H320v32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0V384zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm240-16c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm160 80H384V480H544V352z"]
};
var faPersonSkiLift = {
  prefix: 'fal',
  iconName: 'person-ski-lift',
  icon: [512, 512, ["ski-lift"], "f7c8", "M256 0c8.8 0 16 7.2 16 16V210.8c-1.9 .3-3.7 .6-5.6 1.1L240 218.5V16c0-8.8 7.2-16 16-16zM104.8 177.7c7.9-4 17.5-.7 21.5 7.2l42.3 84.5L274.2 243c15.1-3.8 29.8 7.7 29.8 23.3V402.8l150.7-59.7c15.3-6 25.3-20.8 25.3-37.2V304c0-8.8 7.2-16 16-16s16 7.2 16 16v1.9c0 29.5-18 56.1-45.5 66.9l-348.6 138c-8.2 3.3-17.5-.8-20.8-9s.8-17.5 9-20.8L272 415.5v-139l-95.7 23.9c-14.6 3.6-29.7-3.3-36.4-16.7L97.7 199.2c-4-7.9-.7-17.5 7.2-21.5zM9.1 161.6c8-3.8 17.5-.5 21.3 7.5L103.3 321c10 20.9 33.5 31.6 55.9 25.5l36.5-10c8.5-2.3 17.3 2.7 19.6 11.2s-2.7 17.3-11.2 19.6l-36.5 10c-37.3 10.2-76.5-7.7-93.2-42.6L1.6 182.9c-3.8-8-.5-17.5 7.5-21.3zM128 88A24 24 0 1 0 80 88a24 24 0 1 0 48 0zM48 88a56 56 0 1 1 112 0A56 56 0 1 1 48 88z"]
};
var faSkiLift = faPersonSkiLift;
var faSquare6 = {
  prefix: 'fal',
  iconName: 'square-6',
  icon: [448, 512, [], "e25b", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-96 64c0 53 43 96 96 96s96-43 96-96c0-51.8-41-94-92.3-95.9l39.1-36.3c6.5-6 6.9-16.1 .8-22.6s-16.1-6.9-22.6-.8l-82.7 76.8c-22 20.4-34.4 49-34.4 78.9z"]
};
var faShopSlash = {
  prefix: 'fal',
  iconName: 'shop-slash',
  icon: [640, 512, ["store-alt-slash"], "e070", "M0 185.8C0 206.9 17.1 224 38.2 224H64V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V388.1L338.3 352H96V224h80.2l-40.5-32H80 38.2c-3.4 0-6.2-2.8-6.2-6.2c0-1 .3-2.1 .8-3l27.4-50.3L34.7 112.3 4.7 167.4C1.6 173.1 0 179.4 0 185.8zM139.6 32h376c5.9 0 11.2 3.2 14 8.3l77.7 142.4c.5 .9 .8 1.9 .8 3c0 3.4-2.8 6.2-6.2 6.2H560 342.2l40.5 32H544V351.3l32 25.3V224h25.8c21.1 0 38.2-17.1 38.2-38.2c0-6.4-1.6-12.7-4.7-18.3L557.6 25C549.2 9.6 533.1 0 515.5 0h-391c-7 0-13.8 1.5-20 4.3l35 27.7zM96 464V384H352v80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faStoreAltSlash = faShopSlash;
var faWindTurbine = {
  prefix: 'fal',
  iconName: 'wind-turbine',
  icon: [512, 512, [], "f89b", "M302.1 431.2c18.2 29.6 64 13 58.9-21.4L332.7 217.6 425 46.8c16.5-30.6-20.8-61.9-48-40.3L224.8 127.1 30.7 132.6c-34.8 1-43.2 48.9-10.9 61.7l180.6 71.5L240 330.3V480H144c-8.8 0-16 7.2-16 16s7.2 16 16 16H256 368c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V382.3l30.1 49zM301 222.3l28.4 192.1L227.6 249c-3.6-5.9-9-10.4-15.5-13L31.5 164.5l194.1-5.4c6.9-.2 13.6-2.6 19-6.9L396.9 31.6 304.5 202.4c-3.3 6.1-4.5 13.1-3.5 19.9zM272 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSlidersSimple = {
  prefix: 'fal',
  iconName: 'sliders-simple',
  icon: [512, 512, [], "e253", "M80 320a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm78.4 32L496 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-337.6 0c-7.4 36.5-39.7 64-78.4 64c-44.2 0-80-35.8-80-80s35.8-80 80-80c38.7 0 71 27.5 78.4 64zM384 144a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-30.4-16C361 91.5 393.3 64 432 64c44.2 0 80 35.8 80 80s-35.8 80-80 80c-38.7 0-71-27.5-78.4-64L16 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l337.6 0z"]
};
var faGridRound = {
  prefix: 'fal',
  iconName: 'grid-round',
  icon: [448, 512, [], "e5da", "M96 96A32 32 0 1 1 32 96a32 32 0 1 1 64 0zM64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM96 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zM256 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm96 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 96a64 64 0 1 0 128 0A64 64 0 1 0 320 96zm96 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z"]
};
var faBadgeSheriff = {
  prefix: 'fal',
  iconName: 'badge-sheriff',
  icon: [448, 512, [], "f8a2", "M224 0c-35.3 0-64 28.7-64 64c0 14.7 5 28.3 13.4 39.1l-18.9 32.4-35.2 .1c-5.4-9.3-13.3-17.4-23.3-23.1C65.4 94.9 26.3 105.4 8.6 136S1.4 205.8 32 223.4c12.3 7.1 25.9 9.6 39 8.2L84.9 256 71 280.4c-13.1-1.4-26.7 1.1-39 8.2C1.4 306.2-9.1 345.4 8.6 376s56.8 41.1 87.4 23.4l-8-13.9 8 13.9c10-5.8 17.8-13.8 23.3-23.1l35.2 .1 18.9 32.4C165 419.7 160 433.3 160 448c0 35.3 28.7 64 64 64s64-28.7 64-64c0-14.7-5-28.3-13.4-39.1l18.9-32.4 35.2-.1c5.4 9.3 13.3 17.4 23.3 23.1c30.6 17.7 69.8 7.2 87.4-23.4s7.2-69.8-23.4-87.4c-12.3-7.1-25.9-9.6-39-8.2L363.1 256 377 231.6c13.1 1.4 26.7-1.1 39-8.2c30.6-17.7 41.1-56.8 23.4-87.4s-56.8-41.1-87.4-23.4c-10 5.8-17.8 13.8-23.3 23.1l-35.2-.1-18.9-32.4C283 92.3 288 78.7 288 64c0-35.3-28.7-64-64-64zM192 64c0-17.7 14.3-32 32-32s32 14.3 32 32c0 9.9-4.4 18.7-11.5 24.6c-6 5-7.5 13.6-3.6 20.3l24.9 42.8c5.7 9.8 16.2 15.8 27.5 15.9l45.4 .2c6.8 0 12.8-4.2 15.1-10.6c2.5-6.9 7.3-12.9 14.1-16.9c15.3-8.8 34.9-3.6 43.7 11.7s3.6 34.9-11.7 43.7c-8.2 4.8-17.7 5.4-26.1 2.7c-7.2-2.4-15.1 .6-18.9 7.2l-19.7 34.5c-5.6 9.8-5.6 21.9 0 31.8L355 306.4c3.8 6.6 11.7 9.6 18.9 7.2c8.4-2.8 17.8-2.1 26.1 2.7c15.3 8.8 20.5 28.4 11.7 43.7s-28.4 20.6-43.7 11.7c-6.8-3.9-11.6-10-14.1-16.9c-2.3-6.4-8.3-10.6-15.1-10.6l-45.4 .2c-11.3 0-21.8 6.1-27.5 15.9L241 403.1c-3.9 6.7-2.4 15.3 3.6 20.3c7 5.9 11.5 14.7 11.5 24.6c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-9.9 4.4-18.7 11.5-24.6c6-5 7.5-13.6 3.6-20.3l-24.9-42.8c-5.7-9.8-16.2-15.8-27.5-15.9l-45.4-.2c-6.8 0-12.8 4.2-15.1 10.6c-2.5 6.9-7.3 12.9-14.1 16.9c-15.3 8.8-34.9 3.6-43.7-11.7s-3.6-34.9 11.7-43.7c8.2-4.7 17.7-5.4 26.1-2.7c7.2 2.4 15.1-.6 18.9-7.2l19.7-34.5c5.6-9.8 5.6-21.9 0-31.8L93 205.6c-3.8-6.6-11.7-9.6-18.9-7.2c-8.4 2.8-17.8 2.1-26.1-2.7c-15.3-8.8-20.5-28.4-11.7-43.7s28.4-20.5 43.7-11.7c6.8 3.9 11.6 10 14.1 16.9c2.3 6.4 8.3 10.6 15.1 10.6l45.4-.2c11.3 0 21.8-6.1 27.5-15.9l-13.8-8.1 13.8 8.1L207 108.9c3.9-6.7 2.4-15.3-3.6-20.3C196.4 82.7 192 73.9 192 64zm64 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"]
};
var faServer = {
  prefix: 'fal',
  iconName: 'server',
  icon: [512, 512, [], "f233", "M64 64C46.3 64 32 78.3 32 96v64c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 320c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H64zM0 352c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352zm304 32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faVirusCovidSlash = {
  prefix: 'fal',
  iconName: 'virus-covid-slash',
  icon: [640, 512, [], "e4a9", "M503.3 272H544v24c0 8.8 7.2 16 16 16s16-7.2 16-16V216c0-8.8-7.2-16-16-16s-16 7.2-16 16v24H503.3c-3.3-38.8-18.7-74.1-42.4-102.3l28.8-28.8 0 0 17 17c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L472.7 46.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17 17 0 0-28.8 28.8C410.1 91.4 374.8 76 336 72.7V32l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H280c-8.8 0-16 7.2-16 16s7.2 16 16 16h24V72.7c-29 2.5-56.2 11.7-79.8 26.2l27.2 21.5C272 109.9 295.3 104 320 104c83.9 0 152 68.1 152 152c0 12.1-1.4 23.9-4.1 35.2l27.2 21.5c4.2-13 7-26.6 8.2-40.7zM168 256c0-12.1 1.4-23.9 4.1-35.2l-27.2-21.5c-4.2 13-7 26.6-8.2 40.7H96l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h40.7c3.3 38.8 18.7 74.1 42.4 102.3l-28.8 28.8 0 0-17-17c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17-17 0 0 28.8-28.8c28.2 23.7 63.5 39 102.3 42.4V480H280c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V439.3c29-2.5 56.2-11.8 79.8-26.2l-27.2-21.5C368 402.1 344.7 408 320 408c-83.9 0-152-68.1-152-152zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faIntersection = {
  prefix: 'fal',
  iconName: 'intersection',
  icon: [384, 512, [8898], "f668", "M16 480c8.8 0 16-7.2 16-16V224c0-88.4 71.6-160 160-160s160 71.6 160 160V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-106-86-192-192-192S0 118 0 224V464c0 8.8 7.2 16 16 16z"]
};
var faShopLock = {
  prefix: 'fal',
  iconName: 'shop-lock',
  icon: [640, 512, [], "e4a5", "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 12.4-5.9 23.3-14.9 30.3c-5.4-9.3-12.1-17.8-19.8-25.2c1.6-1.1 2.7-3 2.7-5.2c0-1-.3-2.1-.8-3L529.6 40.3c-2.8-5.1-8.2-8.3-14-8.3h-391c-5.9 0-11.2 3.2-14 8.3L32.8 182.8c-.5 .9-.8 1.9-.8 3c0 3.4 2.8 6.2 6.2 6.2H80 449.6c-9.4 9.2-17.1 20-22.8 32H96V352H352V272c0-8.8 7.2-16 16-16s16 7.2 16 16v79.6l0 .4V464.3c-.2 26.4-21.6 47.7-48 47.7H112c-26.5 0-48-21.5-48-48V224H38.2C17.1 224 0 206.9 0 185.8zM96 464c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16V384H96v80zM528 224c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H608V352H448z"]
};
var faFamily = {
  prefix: 'fal',
  iconName: 'family',
  icon: [512, 512, [], "e300", "M128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 192c-25 0-45.8 19.1-47.8 44l-4.1 49.3C52.1 304 66.8 320 85.6 320h59.6c-.7 5.2-1.1 10.6-1.1 16v16H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c7 0 13.8 .9 20.2 2.6c-1.7 6.9-2.6 14-2.6 21.4c0 3.9 .3 7.8 .8 11.6c-5.7-2.4-11.9-3.6-18.4-3.6H105.6zM416 384H366.4c1-5.2 1.6-10.5 1.6-16V352H469.6L430.5 215.2C426.6 201.5 414 192 399.7 192H368.3c-11.5 0-21.8 6.1-27.5 15.6c2.1-7.5 3.2-15.4 3.2-23.6c0-6.3-.7-12.5-1.9-18.4c8.1-3.6 17-5.6 26.2-5.6h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384zM384 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160c-26.5 0-48 21.5-48 48v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V336c0-26.5-21.5-48-48-48zM208 413.3c-18.6-6.6-32-24.4-32-45.3V336c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 20.9-13.4 38.7-32 45.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H240v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V413.3z"]
};
var faHourglassStart = {
  prefix: 'fal',
  iconName: 'hourglass-start',
  icon: [384, 512, ["hourglass-1"], "f251", "M0 496c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H352V435.3c0-31.6-10.4-62.4-29.6-87.5L252.1 256l70.2-91.9C341.6 139 352 108.3 352 76.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 0 0 7.2 0 16s7.2 16 16 16H32V76.7c0 31.6 10.4 62.4 29.6 87.5L131.9 256 61.6 347.9C42.4 373 32 403.7 32 435.3L32 480H16c-8.8 0-16 7.2-16 16zm64-16l0-44.7c0-24.6 8.1-48.5 23-68l77.7-101.6c4.4-5.7 4.4-13.7 0-19.4L87 144.7c-14.9-19.5-23-43.4-23-68L64 32H320V76.7c0 24.6-8.1 48.5-23 68L219.3 246.3c-4.4 5.7-4.4 13.7 0 19.4L297 367.3c14.9 19.5 23 43.4 23 68V480H64zM205 201.3l80-112c3.5-4.9 3.9-11.3 1.2-16.6S278 64 272 64H192 112c-6 0-11.5 3.3-14.2 8.7S95.5 84.4 99 89.3l80 112c3 4.2 7.9 6.7 13 6.7s10-2.5 13-6.7zM192 96h48.9L192 164.5 143.1 96H192z"]
};
var faHourglass1 = faHourglassStart;
var faUserHairBuns = {
  prefix: 'fal',
  iconName: 'user-hair-buns',
  icon: [448, 512, [], "e3d3", "M314.5 96h-32c-12.7 0-24.9-5.1-33.9-14.1L235.3 68.7c-6.2-6.2-16.4-6.2-22.6 0L199.4 81.9c-9 9-21.2 14.1-33.9 14.1h-32c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zm5.5 32v16c0 53-43 96-96 96s-96-43-96-96V128l37.5 0c21.2 0 41.6-8.4 56.6-23.4l1.9-1.9 1.9 1.9c15 15 35.4 23.4 56.6 23.4H320zM224 272c46.7 0 87.5-25 109.9-62.3c8.7 8.8 20.8 14.3 34.1 14.3c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48c-10.6 0-20.4 3.4-28.3 9.2C319.2 29.9 275.1 0 224 0s-95.2 29.9-115.7 73.2C100.4 67.4 90.6 64 80 64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48c13.4 0 25.4-5.5 34.1-14.3C136.5 247 177.3 272 224 272zm128-96V144 128 112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16zM168 336H280c75.1 0 136 60.9 136 136v8H32v-8c0-75.1 60.9-136 136-136zm0-32C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168zM96 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v16 16z"]
};
var faBlenderPhone = {
  prefix: 'fal',
  iconName: 'blender-phone',
  icon: [576, 512, [], "f6b6", "M226.8 32L535 32 519 96H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H511l-16 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H487L455 352H253.4L226.8 32zM487.1 355.4L566.1 39.8C571.1 19.6 555.8 0 535 0H226.8c-18.7 0-33.4 16-31.9 34.7l26.6 319.5c-35.3 8.3-61.5 40-61.5 77.9v32c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V432c0-36.1-24-66.7-56.9-76.6zM240 384H464c26.5 0 48 21.5 48 48v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V432c0-26.5 21.5-48 48-48zm136 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM120.1 116.7L95 114.2c-15.5-1.5-29.9 8.4-34 23.5c-9.6 35.5-9.6 73 0 108.6c4.1 15.1 18.5 25 34 23.5l25.1-2.5 21.8 53.5L96.3 350C10.6 261.5 10.6 122.5 96.3 34l45.6 29.2-21.8 53.5zm45-76.6L108.4 3.8C99-2.2 86-.9 78.1 6.8C-26 109.1-26 274.9 78.1 377.2c7.9 7.8 20.9 9.1 30.3 3.1l56.7-36.4c9.6-6.1 13.4-17.9 9.2-28.3l-26.9-66.1c-3.9-9.7-13.9-15.6-24.5-14.6l-31.1 3c-8.2-30-8.2-61.8 0-91.8l31 3c10.6 1 20.5-4.9 24.5-14.6l26.9-66.1c4.2-10.4 .4-22.2-9.2-28.3z"]
};
var faHourglassClock = {
  prefix: 'fal',
  iconName: 'hourglass-clock',
  icon: [576, 512, [], "e41b", "M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16H32l0-44.7c0-31.6 10.4-62.4 29.6-87.5L131.9 256 61.6 164.1C42.4 139 32 108.3 32 76.7V32H16C7.2 32 0 24.8 0 16S7.2 0 16 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H352V76.7c0 31.6-10.4 62.4-29.6 87.5L252.1 256l23.6 30.9c-5.7 11-10.3 22.7-13.6 34.9l-42.8-56c-4.4-5.7-4.4-13.7 0-19.4L297 144.7c14.9-19.5 23-43.4 23-68V32H64l0 44.7c0 24.6 8.1 48.5 23 68l77.7 101.6c4.4 5.7 4.4 13.7 0 19.4L87 367.3c-14.9 19.5-23 43.4-23 68L64 480H296.2c10 12.1 21.7 22.9 34.6 32H16zm176-96h70.6c3.2 11.2 7.4 21.9 12.6 32H192 112c-6 0-11.5-3.4-14.2-8.7S95.5 427.6 99 422.7l80-112c5.1-7.2 15.1-8.9 22.3-3.7s8.9 15.1 3.7 22.3L143.1 416H192zm0-208c-4.9 0-9.5-2.2-12.5-6l-64-80c-3.8-4.8-4.6-11.4-1.9-16.9s8.3-9.1 14.4-9.1h64 64c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9l-64 80c-3 3.8-7.6 6-12.5 6zm-30.7-80L192 166.4 222.7 128H192 161.3zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faPersonSeatReclined = {
  prefix: 'fal',
  iconName: 'person-seat-reclined',
  icon: [512, 512, [], "e21f", "M160 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM63.8 141.4L98.4 349.2c6.4 38.6 39.8 66.8 78.9 66.8H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H177.3c-54.8 0-101.5-39.6-110.5-93.6L32.2 146.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2zm120.4 98.5l11.1 66.7c1.3 7.7 8 13.4 15.8 13.4h42l-12.9-77.2-.1-.4-1.9-11.6c-2.2-13.2-13.6-22.9-27-22.9c-16.9 0-29.8 15.2-27 31.9zm27-63.9c28.5 0 52.9 20.2 58.3 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H274.9l10.7 64h33.2c26.7 0 50.6 16.5 59.9 41.5L410 445l50.2-12.5c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-64 16c-7.9 2-16-2.3-18.9-9.9l-36.3-96.9c-4.7-12.5-16.6-20.8-30-20.8H272.3c-.2 0-.4 0-.6 0H211.1c-23.5 0-43.5-17-47.3-40.1l-11.1-66.7c-6-36.2 21.9-69.2 58.6-69.2z"]
};
var faPaperPlaneTop = {
  prefix: 'fal',
  iconName: 'paper-plane-top',
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M3.4 78.3c-6-12-3.9-26.5 5.3-36.3s23.5-12.7 35.9-7.5l448 192c11.8 5 19.4 16.6 19.4 29.4s-7.6 24.4-19.4 29.4l-448 192c-12.3 5.3-26.7 2.3-35.9-7.5s-11.3-24.3-5.3-36.3L92.2 256 3.4 78.3zM120 272L32 448 442.7 272H120zm322.7-32L32 64l88 176H442.7z"]
};
var faPaperPlaneAlt = faPaperPlaneTop;
var faSend = faPaperPlaneTop;
var faMessageArrowUp = {
  prefix: 'fal',
  iconName: 'message-arrow-up',
  icon: [512, 512, ["comment-alt-arrow-up"], "e1dc", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM272 304V150.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 150.6V304c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faCommentAltArrowUp = faMessageArrowUp;
var faLightbulbExclamation = {
  prefix: 'fal',
  iconName: 'lightbulb-exclamation',
  icon: [384, 512, [], "f671", "M336 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.8 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32s144 64.5 144 144zM146.7 448h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM112 432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H122.7c-5.9 0-10.7 4.8-10.7 10.7V432zM192 96c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faLayerMinus = {
  prefix: 'fal',
  iconName: 'layer-minus',
  icon: [576, 512, ["layer-group-minus"], "f5fe", "M408 64H520c8.8 0 16 7.2 16 16s-7.2 16-16 16H408c-8.8 0-16-7.2-16-16s7.2-16 16-16zM266.2 132.7c6.9-3.1 14.3-4.7 21.8-4.7s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l217.4-97.5zM288 160c-3 0-6 .6-8.8 1.9L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1c-2.8-1.2-5.7-1.9-8.8-1.9zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9z"]
};
var faLayerGroupMinus = faLayerMinus;
var faChartPieSimpleCircleCurrency = {
  prefix: 'fal',
  iconName: 'chart-pie-simple-circle-currency',
  icon: [640, 512, [], "e604", "M288 224H394.8c-12.9 9.1-24.5 19.9-34.6 32H272c-8.8 0-16-7.2-16-16V17.7C256 8.1 263.4 0 273.1 0c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-7.1 0-14.2 .4-21.1 1.2C455.2 105.6 379.9 39.1 288 32.5V224zm-32 64h83.2c-5.2 10.1-9.4 20.8-12.6 32H224c-17.7 0-32-14.3-32-32V69.6C100.3 91.2 32 173.7 32 272c0 114.9 93.1 208 208 208c37.1 0 71.9-9.7 102-26.7c5.2 9.4 11.3 18.3 18.1 26.5C324.8 500.3 283.8 512 240 512C107.5 512 0 404.5 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V256v32h32zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm25.4 169.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-9.3 9.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l9.3-9.3c-13.2-21.6-13.2-49.1 0-70.7l-9.3-9.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l9.3 9.3c21.6-13.2 49.1-13.2 70.7 0l9.3-9.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-9.3 9.3c13.2 21.6 13.2 49.1 0 70.7l9.3 9.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-9.3-9.3z"]
};
var faCircleE = {
  prefix: 'fal',
  iconName: 'circle-e',
  icon: [512, 512, [], "e109", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 128c-17.7 0-32 14.3-32 32v96 96c0 17.7 14.3 32 32 32H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V272H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V160H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H192z"]
};
var faBuildingWheat = {
  prefix: 'fal',
  iconName: 'building-wheat',
  icon: [640, 512, [], "e4db", "M320 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H320zM192 384c17.7 0 32 14.3 32 32v64H160V416c0-17.7 14.3-32 32-32zM64 512h64 32 64 32 64c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64zM88 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88zm8 64V128h32v32H96zm128-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm32 8h32v32H256V128zM88 224c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88zm8 64V256h32v32H96zm128-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm32 8h32v32H256V256zm368-64H608c-33.4 0-62.8 17-80 42.9C510.8 209 481.4 192 448 192H432c-8.8 0-16 7.2-16 16v16c0 24.6 9.2 47 24.4 64H432c-8.8 0-16 7.2-16 16v16c0 24.6 9.2 47 24.4 64H432c-8.8 0-16 7.2-16 16v16c0 53 43 96 96 96h16 16c53 0 96-43 96-96V400c0-8.8-7.2-16-16-16h-8.4c15.2-17 24.4-39.4 24.4-64V304c0-8.8-7.2-16-16-16h-8.4c15.2-17 24.4-39.4 24.4-64V208c0-8.8-7.2-16-16-16zm-80 96c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64v0zm-32 0c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zm16 32h8.4c-3.1 3.4-5.9 7.1-8.4 10.9c-2.6-3.8-5.4-7.5-8.4-10.9H528zm0 106.9c-2.6-3.8-5.4-7.5-8.4-10.9H528h8.4c-3.1 3.4-5.9 7.1-8.4 10.9zM544 384v0c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64zm-32 0c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zm32 96c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64v0zm-32 0c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zM528 32c-8.8 0-16 7.2-16 16V160c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm64 48c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zM448 144c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v48z"]
};
var faGaugeMax = {
  prefix: 'fal',
  iconName: 'gauge-max',
  icon: [512, 512, ["tachometer-alt-fastest"], "f626", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-32 0c0-35.3 28.7-64 64-64c17.5 0 33.4 7 44.9 18.4l106.9-64.1c7.6-4.5 17.4-2.1 22 5.5s2.1 17.4-5.5 22L317.4 333.8c1.7 5.8 2.6 11.9 2.6 18.2c0 35.3-28.7 64-64 64s-64-28.7-64-64zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faTachometerAltFastest = faGaugeMax;
var faPersonBreastfeeding = {
  prefix: 'fal',
  iconName: 'person-breastfeeding',
  icon: [448, 512, [], "e53a", "M176 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 144 80a80 80 0 1 0 160 0zM103.3 273.9c20.8-31.2 55.7-49.9 93.2-49.9h68.1c30.9 0 60.5 12.8 81.6 35.3l55.5 59.1c14.6 15.6 14.4 39.9-.4 55.2l-76.8 79.2c-6.2 6.3-6 16.5 .3 22.6s16.5 6 22.6-.3l76.8-79.2c26.8-27.6 27.1-71.4 .8-99.4l-55.5-59.1c-27.2-29-65.2-45.4-105-45.4H196.5c-48.1 0-93.1 24.1-119.8 64.1L23 336.7C-1.5 373.4 12.6 423.4 52.7 442l148.6 68.6c8 3.7 17.5 .2 21.2-7.8s.2-17.5-7.8-21.2L66.1 412.9C43.8 402.6 36 374.8 49.6 354.4l53.7-80.5zM192 320c0-8.8-7.2-16-16-16s-16 7.2-16 16v43.4c0 6 1.7 11.9 4.9 17c26.3 42.1 72.4 67.6 122 67.6H288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-1.1c-38.6 0-74.4-19.9-94.9-52.6V320zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faApostrophe = {
  prefix: 'fal',
  iconName: 'apostrophe',
  icon: [192, 512, [], "27", "M78.7 320.1c-8.8 .7-15.3 8.5-14.6 17.3s8.5 15.3 17.3 14.6l8-.7c58-4.8 102.7-53.4 102.7-111.6V160 128 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h64c11.7 0 22.6-3.1 32-8.6v24.2c0 41.6-31.9 76.3-73.4 79.7l-8 .7zM160 160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32 32z"]
};
var faFireHydrant = {
  prefix: 'fal',
  iconName: 'fire-hydrant',
  icon: [384, 512, [], "e17f", "M192 0c8.8 0 16 7.2 16 16V33c57.9 7.2 103.8 53.1 111 111h17c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H65C72.2 86.1 118.1 40.2 176 33V16c0-8.8 7.2-16 16-16zm0 64c-47.6 0-87.1 34.6-94.7 80H286.7c-7.6-45.4-47.1-80-94.7-80zM32 496c0-8.8 7.2-16 16-16H64V400H48c-26.5 0-48-21.5-48-48V288c0-26.5 21.5-48 48-48H64V208H96v48V384v96H288V384 256 208h32v32h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H320v80h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H304 80 48c-8.8 0-16-7.2-16-16zM320 368h16c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H320v96zM64 368V272H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H64zm160-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faRightToBracket = {
  prefix: 'fal',
  iconName: 'right-to-bracket',
  icon: [512, 512, ["sign-in-alt"], "f2f6", "M319.2 257.8c.5-.5 .8-1.1 .8-1.8s-.3-1.4-.8-1.8L187.3 129.8c-1.2-1.2-2.9-1.8-4.6-1.8c-3.7 0-6.7 3-6.7 6.7l0 57.3c0 8.8-7.2 16-16 16L40 208c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l120 0c8.8 0 16 7.2 16 16l0 57.3c0 3.7 3 6.7 6.7 6.7c1.7 0 3.3-.6 4.6-1.8L319.2 257.8zM352 256c0 9.5-3.9 18.6-10.8 25.1L209.2 405.5c-7.2 6.8-16.7 10.5-26.5 10.5c-21.4 0-38.7-17.3-38.7-38.7l0-41.3L40 336c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40l104 0 0-41.3c0-21.4 17.3-38.7 38.7-38.7c9.9 0 19.3 3.8 26.5 10.5L341.2 230.9c6.9 6.5 10.8 15.6 10.8 25.1zM336 448l96 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c44.2 0 80 35.8 80 80l0 288c0 44.2-35.8 80-80 80l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSignInAlt = faRightToBracket;
var faVideoPlus = {
  prefix: 'fal',
  iconName: 'video-plus',
  icon: [576, 512, [], "f4e1", "M320 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V336.8 175.2 128c0-35.3-28.7-64-64-64H64zM416 354.4l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2V377.8c0 3.4-2.8 6.2-6.2 6.2c-1 0-2.1-.3-3-.8L416 317.9v36.5zM208 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V272h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V176z"]
};
var faSquareRight = {
  prefix: 'fal',
  iconName: 'square-right',
  icon: [448, 512, [10145, "arrow-alt-square-right"], "f352", "M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM368 256c0 9.2-3.5 18-9.7 24.7l-84 91c-7.2 7.8-17.4 12.3-28.1 12.3c-21.1 0-38.3-17.1-38.3-38.3l0-25.7-80 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l80 0 0-25.7c0-21.1 17.1-38.3 38.3-38.3c10.7 0 20.9 4.5 28.1 12.3l84 91c6.2 6.7 9.7 15.6 9.7 24.7zm-33.2-3l-84-91c-1.2-1.3-2.9-2-4.6-2c-3.5 0-6.3 2.8-6.3 6.3l0 41.7c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l96 0c8.8 0 16 7.2 16 16l0 41.7c0 3.5 2.8 6.3 6.3 6.3c1.7 0 3.4-.7 4.6-2l84-91c.8-.8 1.2-1.9 1.2-3s-.4-2.2-1.2-3z"]
};
var faArrowAltSquareRight = faSquareRight;
var faCommentSmile = {
  prefix: 'fal',
  iconName: 'comment-smile',
  icon: [512, 512, [], "f4b4", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM155.9 284.1c-6.6 5.9-7.1 16-1.3 22.6C179.5 334.5 215.7 352 256 352s76.5-17.5 101.4-45.3c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3C314.5 306.6 286.8 320 256 320s-58.5-13.4-77.5-34.7c-5.9-6.6-16-7.1-22.6-1.3z"]
};
var faVenus = {
  prefix: 'fal',
  iconName: 'venus',
  icon: [384, 512, [9792], "f221", "M48 176a144 144 0 1 1 288 0A144 144 0 1 1 48 176zM208 351.3c89.7-8.1 160-83.5 160-175.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 91.8 70.3 167.2 160 175.3V416H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V351.3z"]
};
var faPassport = {
  prefix: 'fal',
  iconName: 'passport',
  icon: [448, 512, [], "f5ab", "M384 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 400c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm33.3-192h39.1c1.6 30.4 7.7 53.8 14.6 70.8c-27.9-13.2-48.4-39.4-53.7-70.8zM224 288l-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5l-.3 0zm94.7-80c-5.3 31.4-25.8 57.6-53.7 70.8c6.8-17.1 12.9-40.4 14.6-70.8h39.1zm0-32H279.6c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8zM224 96l.3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5l.3 0zm-94.7 80c5.3-31.4 25.8-57.6 53.7-70.8c-6.8 17.1-12.9 40.4-14.6 70.8H129.3zM224 320a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]
};
var faInboxIn = {
  prefix: 'fal',
  iconName: 'inbox-in',
  icon: [512, 512, [128229, "inbox-arrow-down"], "f310", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 265.4V16zM48 352h66.3c6.1 0 11.6 3.4 14.3 8.8L143 389.5c8.1 16.3 24.8 26.5 42.9 26.5H326.1c18.2 0 34.8-10.3 42.9-26.5l-28.6-14.3L369 389.5l14.3-28.6c2.7-5.4 8.3-8.8 14.3-8.8H464c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm306.7-5.5l-14.3 28.6c-2.7 5.4-8.2 8.8-14.3 8.8H185.9c-6.1 0-11.6-3.4-14.3-8.8l-14.3-28.6c-8.1-16.3-24.8-26.5-42.9-26.5H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H397.7c-18.2 0-34.8 10.3-42.9 26.5z"]
};
var faInboxArrowDown = faInboxIn;
var faHeartPulse = {
  prefix: 'fal',
  iconName: 'heart-pulse',
  icon: [512, 512, ["heartbeat"], "f21e", "M244 130.6c3 3.4 7.4 5.4 12 5.4s8.9-2 12-5.4l12-13.5 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8c53.3 9.7 92 56.1 92 110.3v3.5c0 23.8-7.3 46.7-20.5 66c-1.1-.2-2.3-.4-3.5-.4H371.8c-6.1 0-11.6-3.4-14.3-8.8l-23.2-46.3c-2.7-5.4-8.2-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-48.9 97.9L198.6 169.4c-2.6-5.8-8.4-9.5-14.8-9.4s-12.1 4-14.5 9.8l-31.8 76.3c-2.5 6-8.3 9.8-14.8 9.8H56c-1.2 0-2.4 .1-3.5 .4C39.3 237.1 32 214.2 32 190.4v-3.5c0-54.2 38.7-100.6 92-110.3c38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 12 13.5zM429.6 288l0 0h45.8l.1-.1C498.9 261 512 226.4 512 190.4v-3.5c0-69.6-49.8-129.3-118.3-141.8c-40.9-7.4-82.6 3.2-114.7 28.4c-1.8 1.4-3.6 2.9-5.4 4.5c-4.7 4.1-9.1 8.4-13.3 13.1L256 95.9l-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6C201 48.4 159.3 37.7 118.3 45.1C49.8 57.6 0 117.3 0 186.9v3.5c0 36 13.1 70.6 36.6 97.5l.1 .1H82.4l0 0h40.2c19.4 0 36.9-11.7 44.3-29.5l17.6-42.2 56.8 126.3c2.5 5.6 8.1 9.3 14.3 9.4s11.9-3.3 14.6-8.8L320 243.8l8.8 17.7c8.1 16.3 24.8 26.5 42.9 26.5h57.8zM69.8 320L231.2 470.3c6.7 6.3 15.6 9.7 24.8 9.7c8 0 15.8-2.7 22.1-7.5c.9-.7 1.8-1.4 2.6-2.2L442.2 320h-47L259 446.8c-.8 .7-1.9 1.2-3 1.2s-2.2-.4-3-1.2L116.8 320h-47z"]
};
var faHeartbeat = faHeartPulse;
var faCircle8 = {
  prefix: 'fal',
  iconName: 'circle-8',
  icon: [512, 512, [], "e0f5", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 128c37.6 0 68 30.4 68 68c0 20.2-8.8 38.4-22.9 50.9C331.9 260.7 344 282.9 344 308c0 42-34 76-76 76H244c-42 0-76-34-76-76c0-25.1 12.1-47.3 30.9-61.1c-14-12.5-22.9-30.6-22.9-50.9c0-37.6 30.4-68 68-68h24zM244 232s0 0 0 0h24c19.9 0 36-16.1 36-36s-16.1-36-36-36H244c-19.9 0-36 16.1-36 36s16.1 36 36 36zm24 32H244c-24.3 0-44 19.7-44 44s19.7 44 44 44h24c24.3 0 44-19.7 44-44s-19.7-44-44-44z"]
};
var faCloudsMoon = {
  prefix: 'fal',
  iconName: 'clouds-moon',
  icon: [640, 512, [], "f745", "M384 160c0-57.7 38-106.5 90.3-122.5c-21.2 25.7-33.9 58.8-33.9 94.8c0 72.3 51.4 132.7 119.7 146.1c-14.9 6.2-31.3 9.6-48.5 9.6c-19.9 0-38.7-4.6-55.5-12.7c2.5 6.8 4.5 13.8 5.8 21.1c14.2 5.5 27.2 13.4 38.5 23.2c3.7 .3 7.4 .4 11.2 .4c43.2 0 82.5-17.3 111.2-45.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7c-64.3 0-116.5-52.3-116.5-116.9c0-43.7 23.9-81.8 59.3-101.9c6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1 .6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160c0 11.5 1.2 22.7 3.5 33.4c12.9 2 25.2 5.9 36.6 11.4c-5.2-14-8-29.1-8-44.8zm-48.1 96c35.3 0 64 28.7 64 64c0 4.4-.4 8.7-1.3 12.8c-1 4.8 .3 9.7 3.4 13.4s7.7 5.8 12.6 5.8c.2 0 .5 0 .7 0c.2 0 .4 0 .6 0c35.3 0 64 28.7 64 64s-28.7 64-64 64c-.8 0-1.6 0-2.3 0c-.1 0-.2 0-.3 0c-.1 0-.2 0-.2 0H146.3l-.2 0-.3 0c-.6 0-1.2 0-1.8 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l.2 0 0 0 8.3 0c5.7 0 11-3 13.9-8s2.9-11.1 0-16c-4.1-7-6.4-15.2-6.4-24c0-26.5 21.5-48 48-48c15.7 0 29.6 7.5 38.4 19.2c3.6 4.8 9.7 7.2 15.7 6.1s10.8-5.4 12.5-11.3c7.8-26.6 32.4-46 61.4-46zm96 64c0-53-43-96-96-96c-34.9 0-65.4 18.6-82.2 46.4c-13-9.1-28.7-14.4-45.8-14.4c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 432c0 44.2 35.8 80 80 80c.9 0 1.8 0 2.7 0H412.7c1.1 0 2.1 .1 3.2 .1c53 0 96-43 96-96c0-47.6-34.6-87-80-94.7l0-1.3zM320 192.1h0c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72l0 0h34.8c5.7-12 13.4-22.8 22.8-32H73.5c-.5 0-.9 0-1.4 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c1.8 0 3.6 .1 5.3 .3c16.8 2.2 32.3-9 35.6-25.6c4.3-22.1 23.8-38.7 47.1-38.7c20.4 0 38 12.8 44.9 30.9c6.2 16.2 24.1 24.6 40.5 18.8c3.3-1.1 6.8-1.8 10.6-1.8c17.7 0 32 14.3 32 32c0 .3 0 .6 0 .9c0 2.9-.3 5.8-.7 8.6c10.3-4.2 21.3-7.2 32.7-8.6l0-.9z"]
};
var faClockTenThirty = {
  prefix: 'fal',
  iconName: 'clock-ten-thirty',
  icon: [512, 512, [], "e355", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V256c0-5.3-2.7-10.3-7.1-13.3l-96-64c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2L240 264.6V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faPeopleCarryBox = {
  prefix: 'fal',
  iconName: 'people-carry-box',
  icon: [640, 512, ["people-carry"], "f4ce", "M136 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 136 0zM67.8 343.4l25.9 20.3L30.6 502.6c-3.7 8-13.1 11.6-21.2 7.9s-11.6-13.1-7.9-21.2l66.4-146zM96 193.2v87c0 5 2.3 9.7 6.2 12.7L128 312.7V179.4c-4.5-2.2-9.6-3.4-14.8-3.4c-9.5 0-17.2 7.7-17.2 17.2zm87.8 82.1L160 227.8V337.3l29 22.3c6.1 4.7 10.4 11.5 11.9 19.1l22.8 114.1c1.7 8.7-3.9 17.1-12.6 18.8s-17.1-3.9-18.8-12.6L169.5 385 82.7 318.3c-11.8-9.1-18.7-23.1-18.7-38v-87C64 166 86 144 113.2 144c24.9 0 47.7 14.1 58.9 36.4L212.4 261l11.6 7.7V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V268.8l11.6-7.7 40.3-80.7c11.1-22.3 33.9-36.4 58.9-36.4c27.2 0 49.2 22 49.2 49.2v87c0 14.9-6.9 29-18.7 38L470.5 385 447.7 499.1c-1.7 8.7-10.2 14.3-18.8 12.6s-14.3-10.2-12.6-18.8l22.8-114.1c1.5-7.6 5.7-14.4 11.9-19.1l29-22.3V227.8l-23.8 47.6c-2.5 5-6.2 9.2-10.9 12.3l-44.5 29.6c-3.7 2.5-8.1 3.2-12.2 2.3c-1.5 .2-3.1 .3-4.7 .3H256c-1.6 0-3.2-.1-4.7-.3c-4.1 .9-8.4 .1-12.2-2.3l-44.5-29.6c-4.6-3.1-8.4-7.3-10.9-12.3zM504 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 504 0zm68.2 343.4l66.4 146c3.7 8 .1 17.5-7.9 21.2s-17.5 .1-21.2-7.9L546.3 363.7l25.9-20.3zM544 193.2c0-9.5-7.7-17.2-17.2-17.2c-5.2 0-10.3 1.2-14.8 3.4V312.7l25.8-19.8c3.9-3 6.2-7.7 6.2-12.7v-87zM256 160V288H384V160H256z"]
};
var faPeopleCarry = faPeopleCarryBox;
var faFolderUser = {
  prefix: 'fal',
  iconName: 'folder-user',
  icon: [512, 512, [], "e18e", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM256 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 64h64c26.5 0 48 21.5 48 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80H224c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 21.5-48 48-48z"]
};
var faTrashCanXmark = {
  prefix: 'fal',
  iconName: 'trash-can-xmark',
  icon: [448, 512, [], "e2ae", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zm84.7 116.7c6.2-6.2 16.4-6.2 22.6 0L224 265.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 288l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faTemperatureHigh = {
  prefix: 'fal',
  iconName: 'temperature-high',
  icon: [512, 512, [], "f769", "M416 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM112 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM176 0C123 0 80 43 80 96V252.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V96c0-8.8-7.2-16-16-16s-16 7.2-16 16V306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faMicrochip = {
  prefix: 'fal',
  iconName: 'microchip',
  icon: [512, 512, [], "f2db", "M176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128c-35.3 0-64 28.7-64 64v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v16c0 35.3 28.7 64 64 64h16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h16c35.3 0 64-28.7 64-64V368h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V272h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V176h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V128c0-35.3-28.7-64-64-64H368V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H272V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H176V16zM416 128V384c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32zm-256 0c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H160zm192 32V352H160V160H352z"]
};
var faLeftLongToLine = {
  prefix: 'fal',
  iconName: 'left-long-to-line',
  icon: [640, 512, [], "e41e", "M0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80zM320 216l272 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-272 0c-17.7 0-32 14.3-32 32l0 49.3c0 3.7-3 6.7-6.7 6.7c-1.9 0-3.7-.8-5-2.2L163.8 256 276.3 130.2c1.3-1.4 3.1-2.2 5-2.2c3.7 0 6.7 3 6.7 6.7l0 49.3c0 17.7 14.3 32 32 32zM128 256c0 5.2 1.9 10.1 5.3 14L252.5 403.1c7.3 8.2 17.8 12.9 28.8 12.9c21.4 0 38.7-17.3 38.7-38.7l0-17.3 0-32 32 0 240 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48l-240 0-32 0 0-32 0-17.3c0-21.4-17.3-38.7-38.7-38.7c-11 0-21.5 4.7-28.8 12.9L133.3 242c-3.4 3.8-5.3 8.8-5.3 14z"]
};
var faCrown = {
  prefix: 'fal',
  iconName: 'crown',
  icon: [576, 512, [128081], "f521", "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40l.7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106zM117.9 421.7L78.8 206.4l62.3 49.9c31.8 25.5 79 15.1 97.2-21.4L288 135.6l49.7 99.4c18.2 36.4 65.4 46.8 97.2 21.4l62.3-49.9L458.1 421.7c-2.8 15.2-16 26.3-31.5 26.3H149.4c-15.5 0-28.7-11.1-31.5-26.3z"]
};
var faWeightHanging = {
  prefix: 'fal',
  iconName: 'weight-hanging',
  icon: [512, 512, [], "f5cd", "M208 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 48c10-13.4 16-30 16-48c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 18 6 34.6 16 48H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H320zm-64 32H392c7.3 0 13.7 5 15.5 12.1l72 288c1.2 4.8 .1 9.8-2.9 13.7s-7.7 6.2-12.6 6.2H48c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l72-288c1.8-7.1 8.2-12.1 15.5-12.1H256z"]
};
var faXmarksLines = {
  prefix: 'fal',
  iconName: 'xmarks-lines',
  icon: [640, 512, [], "e59a", "M16 32H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48s7.2-16 16-16zm0 416H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zM228.7 164.7c6.2-6.2 16.4-6.2 22.6 0L320 233.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 278.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 256l-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6zM118.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L96 278.6 27.3 347.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L73.4 256 4.7 187.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L96 233.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L118.6 256zm334.1-91.3c6.2-6.2 16.4-6.2 22.6 0L544 233.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L566.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L544 278.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 256l-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faFilePrescription = {
  prefix: 'fal',
  iconName: 'file-prescription',
  icon: [384, 512, [], "f572", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm48 224c-8.8 0-16 7.2-16 16v80 64c0 8.8 7.2 16 16 16s16-7.2 16-16V336h41.4l48 48-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 406.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L262.6 384l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 361.4l-31.2-31.2C227.3 321.1 240 302 240 280c0-30.9-25.1-56-56-56H112zm72 80h-8H128V256h56c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faCalendarRange = {
  prefix: 'fal',
  iconName: 'calendar-range',
  icon: [512, 512, [], "e0d6", "M144 0c8.8 0 16 7.2 16 16V64H352V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 160 128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zM448 192H64V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192zM416 96H96c-17.7 0-32 14.3-32 32v32H448V128c0-17.7-14.3-32-32-32zm0 176c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16H400c8.8 0 16 7.2 16 16zM272 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H272c8.8 0 16 7.2 16 16s-7.2 16-16 16zM128 272a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faFlowerDaffodil = {
  prefix: 'fal',
  iconName: 'flower-daffodil',
  icon: [512, 512, [9880], "f800", "M200 0c-48.6 0-88 39.4-88 88c0 21.3 7.6 40.8 20.1 56c-12.6 15.2-20.1 34.7-20.1 56c0 48.6 39.4 88 88 88c14.4 0 28-3.5 40-9.6V396.6C200.8 331.5 129.5 288 48 288H28c-15.5 0-28 12.5-28 28C0 424.2 87.8 512 196 512h44 16 16 44c108.2 0 196-87.8 196-196c0-15.5-12.5-28-28-28H464c-81.5 0-152.8 43.5-192 108.6V278.4c12 6.1 25.6 9.6 40 9.6c48.6 0 88-39.4 88-88c0-21.3-7.6-40.8-20.1-56c12.6-15.2 20.1-34.7 20.1-56c0-48.6-39.4-88-88-88c-21.3 0-40.8 7.6-56 20.1C240.8 7.6 221.3 0 200 0zM144 88c0-30.9 25.1-56 56-56c17.6 0 33.3 8.1 43.6 20.8c3 3.8 7.6 5.9 12.4 5.9s9.4-2.2 12.4-5.9C278.7 40.1 294.4 32 312 32c30.9 0 56 25.1 56 56c0 17.6-8.1 33.3-20.8 43.6c-3.8 3-5.9 7.6-5.9 12.4s2.2 9.4 5.9 12.4c12.7 10.3 20.8 26 20.8 43.6c0 30.9-25.1 56-56 56c-17.6 0-33.3-8.1-43.6-20.8c-3-3.8-7.6-5.9-12.4-5.9s-9.4 2.2-12.4 5.9c-10.3 12.7-26 20.8-43.6 20.8c-30.9 0-56-25.1-56-56c0-17.6 8.1-33.3 20.8-43.6c3.8-3 5.9-7.6 5.9-12.4s-2.2-9.4-5.9-12.4C152.1 121.3 144 105.6 144 88zM32 320H48c95.1 0 174.1 69.2 189.3 160H196c-89.2 0-161.8-71.3-164-160zM480 320c-2.1 88.7-74.7 160-164 160H274.7c15.2-90.8 94.2-160 189.3-160h16zM288 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faHandBackPointUp = {
  prefix: 'fal',
  iconName: 'hand-back-point-up',
  icon: [448, 512, [], "e1a2", "M136 0C105.1 0 80 25.1 80 56V256.6c-3.2 2-6.4 4.2-9.5 6.5L48 280c-20.1 15.1-32 38.8-32 64v19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H304c61.9 0 112-50.1 112-112v-8V304c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-8.5 0-16.6 1.7-24 4.7V56c0-30.9-25.1-56-56-56zM112 56c0-13.3 10.7-24 24-24s24 10.7 24 24V213.5c0 7.1 4.6 13.3 11.4 15.3s14-.6 18-6.5c5.8-8.7 15.6-14.3 26.7-14.3c15.6 0 28.6 11.2 31.4 25.9c1 5.1 4.4 9.5 9.2 11.6s10.3 1.8 14.8-.9c4.8-2.9 10.5-4.6 16.6-4.6c14.7 0 27.2 10 30.9 23.6c1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1 .6c3.6-1.4 7.6-2.2 11.8-2.2c17.7 0 32 14.3 32 32v88 8c0 44.2-35.8 80-80 80H168.3c-18.5 0-36.8-4.6-53.1-13.4l-7.6 14.1 7.6-14.1-8.3-4.5C70.6 442.6 48 404.7 48 363.5V344c0-15.1 7.1-29.3 19.2-38.4L80 296v48c0 8.8 7.2 16 16 16s16-7.2 16-16V265.7 264 56z"]
};
var faWeightScale = {
  prefix: 'fal',
  iconName: 'weight-scale',
  icon: [512, 512, ["weight"], "f496", "M112 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm320 0c0-28.8-6.9-56-19.2-80H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H99.2C86.9 120 80 147.2 80 176c0 97.2 78.8 176 176 176s176-78.8 176-176zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM320 224c0-20.6-9.7-39-24.9-50.7l23.6-55c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4l-23.6 55c-3.2-.5-6.4-.7-9.7-.7c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm-64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faWeight = faWeightScale;
var faStarExclamation = {
  prefix: 'fal',
  iconName: 'star-exclamation',
  icon: [576, 512, [], "f2f3", "M202.4 186.5L65 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L150.2 473.2l122.6-65.5c9.4-5 20.7-5 30.2 0l122.6 65.5L402.1 333.7c-1.7-10.3 1.6-20.7 9-28.1l99.8-98.8L373.4 186.5c-10.5-1.5-19.5-8.2-24.1-17.7L287.9 42.3 226.5 168.8c-4.6 9.5-13.6 16.1-24.1 17.7zM450.2 507.4c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5zM288 128c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM264 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faBooks = {
  prefix: 'fal',
  iconName: 'books',
  icon: [512, 512, [128218], "f5db", "M128 416v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V416h96zm-16 96c12.3 0 23.5-4.6 32-12.2c8.5 7.6 19.7 12.2 32 12.2h64c26.5 0 48-21.5 48-48V416 400 384 193.8l51.4 198.1 4 15.5 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-13.9-53.7-4-15.5-63.9-246-4-15.5-18-69.2C400 9.9 374.6-5.2 349.9 1.6L290.3 18.1c-3.5 1-6.8 2.3-9.9 4C271.9 8.8 257 0 240 0H176c-12.3 0-23.5 4.6-32 12.2C135.5 4.6 124.3 0 112 0H48C21.5 0 0 21.5 0 48V96v16 16V384v16 16 48c0 26.5 21.5 48 48 48h64zM288 64.8V63.5c.3-7.2 5.1-13 10.8-14.6l59.6-16.5c6.6-1.8 14.8 2 17.2 11l14.1 54.2-87.3 24.2L288.6 68.6c-.3-1.3-.5-2.6-.6-3.8zm-32-.6c0 0 0 0 0 0V96H160V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V64.2zM176 480c-8.8 0-16-7.2-16-16V416h96v48c0 8.8-7.2 16-16 16H176zM128 128V384H32V128h96zm0-80V96H32V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16zM256 384H160V128h96V384zM397.7 128.7l59.8 230.5-87.3 24.2L310.4 152.8l87.3-24.2zm67.9 261.5l13.8 53.2c2.4 9.4-3.2 17.7-10.3 19.6l-59.6 16.5c-6.6 1.8-14.8-2-17.2-11l-14.1-54.2 87.3-24.2z"]
};
var faUserGroup = {
  prefix: 'fal',
  iconName: 'user-group',
  icon: [640, 512, [128101, "user-friends"], "f500", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zm431 208c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320H417.3c-4.4 0-8.8 .2-13.2 .5c11.3 9.4 21.6 19.9 30.7 31.5h43.9c71 0 128.6 57.2 129.3 128H480c0 .8 0 1.5 0 2.3c0 10.8-2.8 20.9-7.6 29.7H609.3zM432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-24.8 0-47.7 8.1-66.3 21.7c5.2 9.8 9.3 20.3 12.4 31.2C392.3 71.9 411.2 64 432 64c44.2 0 80 35.8 80 80s-35.8 80-80 80c-25.2 0-47.6-11.6-62.3-29.8c-4.7 10.3-10.4 19.9-17 28.9C373 243.4 401 256 432 256z"]
};
var faUserFriends = faUserGroup;
var faArrowUpAZ = {
  prefix: 'fal',
  iconName: 'arrow-up-a-z',
  icon: [576, 512, ["sort-alpha-up"], "f15e", "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 288c-8.8 0-16 7.2-16 16s7.2 16 16 16h94.7L339.5 454c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H385.3L492.5 314c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1H352zM416 32c-6.1 0-11.6 3.4-14.3 8.8L337.8 168.6c-.1 .2-.2 .4-.3 .6l-15.8 31.7c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L361.9 192H470.1l11.6 23.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-15.8-31.7c-.1-.2-.2-.4-.3-.6L430.3 40.8c-2.7-5.4-8.2-8.8-14.3-8.8zM377.9 160L416 83.8 454.1 160H377.9z"]
};
var faSortAlphaUp = faArrowUpAZ;
var faLayerPlus = {
  prefix: 'fal',
  iconName: 'layer-plus',
  icon: [576, 512, ["layer-group-plus"], "f5ff", "M480 24c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H408c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v40c0 8.8 7.2 16 16 16s16-7.2 16-16V96h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V24zM288 128c-7.5 0-15 1.6-21.8 4.7L48.8 230.1C38.6 234.7 32 244.8 32 256s6.6 21.3 16.8 25.9l217.4 97.5c6.9 3.1 14.3 4.7 21.8 4.7s15-1.6 21.8-4.7l217.4-97.5c10.2-4.6 16.8-14.7 16.8-25.9s-6.6-21.3-16.8-25.9L309.8 132.7c-6.9-3.1-14.3-4.7-21.8-4.7zm-8.8 33.9c2.8-1.2 5.7-1.9 8.8-1.9s6 .6 8.8 1.9l210 94.1-210 94.1c-2.8 1.2-5.7 1.9-8.8 1.9s-6-.6-8.8-1.9L69.3 256l210-94.1zM94.7 337.5L48.8 358.1C38.6 362.7 32 372.8 32 384s6.6 21.3 16.8 25.9l217.4 97.5c6.9 3.1 14.3 4.7 21.8 4.7s15-1.6 21.8-4.7l217.4-97.5c10.2-4.6 16.8-14.7 16.8-25.9s-6.6-21.3-16.8-25.9l-45.9-20.6-39.1 17.5L506.7 384l-210 94.1c-2.8 1.2-5.7 1.9-8.8 1.9s-6-.6-8.8-1.9L69.3 384l64.5-28.9L94.7 337.5z"]
};
var faLayerGroupPlus = faLayerPlus;
var faPlayPause = {
  prefix: 'fal',
  iconName: 'play-pause',
  icon: [640, 512, [], "e22f", "M448 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM288 256L96 416 96 96 288 256zM116.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160z"]
};
var faBlockQuestion = {
  prefix: 'fal',
  iconName: 'block-question',
  icon: [448, 512, [], "e3dd", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm88 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM88 368a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136.7 177.8c6.5-24.6 28.7-41.8 54.2-41.8H248c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L240 276.3V296c0 8.8-7.2 16-16 16s-16-7.2-16-16V266.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H190.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM200 360a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSnooze = {
  prefix: 'fal',
  iconName: 'snooze',
  icon: [448, 512, [128164, "zzz"], "f880", "M176 32c-8.8 0-16-7.2-16-16s7.2-16 16-16H304c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L214.6 128H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L265.4 32H176zM0 240c0-8.8 7.2-16 16-16H208c6.1 0 11.6 3.4 14.3 8.8s2.1 11.9-1.5 16.8L48 480H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8L176 256H16c-8.8 0-16-7.2-16-16zm304-16H432c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L337.3 384H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9L398.7 256H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faZzz = faSnooze;
var faScannerImage = {
  prefix: 'fal',
  iconName: 'scanner-image',
  icon: [576, 512, [], "f8f3", "M55.2 33.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5L492.2 288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V392 352v-8.4c0-30.3-17.1-58-44.2-71.6L55.2 33.7zM544 352v40 24c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32zM104 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTvRetro = {
  prefix: 'fal',
  iconName: 'tv-retro',
  icon: [512, 512, [128250], "f401", "M154.4 3.9c-6.7-5.8-16.8-5-22.6 1.7s-5 16.8 1.7 22.6L212.7 96H80C35.8 96 0 131.8 0 176V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H299.3l79.2-67.9c6.7-5.8 7.5-15.9 1.7-22.6s-15.8-7.5-22.6-1.7L256 90.9 154.4 3.9zM256 128H432c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H256s0 0 0 0zm80 64c8.8 0 16 7.2 16 16V400c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16H336zM112 160c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112zm320 72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSquareT = {
  prefix: 'fal',
  iconName: 'square-t',
  icon: [448, 512, [], "e280", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm112 48H224 336c8.8 0 16 7.2 16 16s-7.2 16-16 16H240V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V176H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFarm = {
  prefix: 'fal',
  iconName: 'farm',
  icon: [576, 512, ["barn-silo"], "f864", "M48 480c-8.8 0-16-7.2-16-16V192H155.7l17.1-32H32V112c0-44.2 35.8-80 80-80s80 35.8 80 80v12l3-5.7c6.1-11.5 15.6-20.8 27.1-26.7C212.5 39.5 166.9 0 112 0C50.1 0 0 50.1 0 112V464c0 26.5 21.5 48 48 48h96c-7-9.3-12-20.2-14.4-32H48zM380.8 68.1c-8.2-3.6-17.5-3.6-25.7 0l-116.5 51c-6.6 2.9-12 7.9-15.4 14.3L163.8 244.9c-2.5 4.6-3.8 9.8-3.8 15.1V464c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48V260c0-5.3-1.3-10.4-3.8-15.1L512.7 133.4c-3.4-6.4-8.8-11.4-15.4-14.3l-116.5-51zM368 97.5l116.5 51L544 260V464c0 8.8-7.2 16-16 16H448V416c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v64H208c-8.8 0-16-7.2-16-16V260l59.5-111.6L368 97.5zM416 480H320V416c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64zM336 224h64v64H336V224zm0-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H336z"]
};
var faBarnSilo = faFarm;
var faChessKnight = {
  prefix: 'fal',
  iconName: 'chess-knight',
  icon: [448, 512, [9822], "f441", "M96 35.8c0-2.1 1.7-3.8 3.8-3.8H230.6C315.3 32 384 100.7 384 185.4c0 8.8-.8 17.6-2.3 26.3L357.3 352h32.5l23.5-134.9c1.8-10.5 2.7-21.1 2.7-31.8C416 83 333 0 230.6 0H99.8C80 0 64 16 64 35.8c0 13.6 7.7 25.9 19.8 32l1.3 .6c-13.5 14.7-21.1 33.9-21.1 54l-.3 104.4c-.1 23.2 11.1 45 30 58.5l1.9 1.4c4.5 3.2 9.3 5.8 14.3 7.8l-6.9 5c-17.8 13-30.4 31.6-35.8 52.5h33.7c4.4-10.5 11.5-19.7 21-26.6l53.8-39.1 89.9-65.4c7.1-5.2 8.7-15.2 3.5-22.4s-15.2-8.7-22.4-3.5l-89.9 65.4c-12.7 9.2-29.8 9.3-42.6 .2l-1.9-1.4c-10.4-7.5-16.6-19.5-16.6-32.4l.3-104.4c0-12.7 5.1-24.8 14.1-33.8l13.3-13.3c3.6-3.6 5.3-8.8 4.5-13.9s-4-9.4-8.6-11.7L98.1 39.2c-1.3-.6-2.1-1.9-2.1-3.4zM366.2 416l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H55.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L81.8 416l284.4 0zM81.8 384c-11.1 0-21.4 5.7-27.2 15.1L21.9 451.8C18.1 458 16 465.2 16 472.6C16 494.3 33.7 512 55.4 512H392.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1H81.8zM148 168a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
var faBarsSort = {
  prefix: 'fal',
  iconName: 'bars-sort',
  icon: [448, 512, [], "e0ae", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM192 400c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H176c8.8 0 16 7.2 16 16z"]
};
var faPalletBoxes = {
  prefix: 'fal',
  iconName: 'pallet-boxes',
  icon: [640, 512, [57863, "palette-boxes", "pallet-alt"], "f483", "M304 32H112c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16zM112 0H304c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V48C64 21.5 85.5 0 112 0zM528 128H432c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16zM432 96h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48zM0 368c0-8.8 7.2-16 16-16H80 320 560h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H576v96h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H560 320 80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V384H16c-8.8 0-16-7.2-16-16zM96 480H304V384H96v96zm240 0H544V384H336v96z"]
};
var faPaletteBoxes = faPalletBoxes;
var faPalletAlt = faPalletBoxes;
var faFaceLaughSquint = {
  prefix: 'fal',
  iconName: 'face-laugh-squint',
  icon: [512, 512, ["laugh-squint"], "f59b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288H385.5c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm2.9-135.2c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 192l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 192l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
var faLaughSquint = faFaceLaughSquint;
var faCodeSimple = {
  prefix: 'fal',
  iconName: 'code-simple',
  icon: [576, 512, [], "e13d", "M203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 256 203.3 91.3zm169.4 0L537.4 256 372.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"]
};
var faBoltSlash = {
  prefix: 'fal',
  iconName: 'bolt-slash',
  icon: [640, 512, [], "e0b8", "M351.4 362.3L236.6 463.6 290 313.9 263.5 293 197.2 478.7c-5.8 16.2 6.2 33.3 23.5 33.3c6.1 0 11.9-2.2 16.5-6.2L376.9 382.4l-25.5-20.2zM216.7 256H170.1L192 236.5l-25.5-20.1-29.8 26.5c-5.5 4.9-8.7 11.9-8.7 19.3c0 14.3 11.6 25.8 25.8 25.8H257.2l-40.5-32zm72.5-105.9L403.3 48.7 350 198.1 376.5 219 442.8 33.3C448.6 17.1 436.6 0 419.4 0c-6.1 0-12 2.2-16.5 6.3L263.7 130l25.5 20.1zM485 224H382.8l40.5 32h48.5l-22.9 20.2 25.5 20.2 28.4-25.1c5.8-5.1 9.1-12.5 9.1-20.3c0-14.9-12.1-27-27-27zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faPanelFire = {
  prefix: 'fal',
  iconName: 'panel-fire',
  icon: [640, 512, [], "e42f", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H314.4c6.6 11.4 14.4 22.2 23.2 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v32.2c-11.1-1-22.6 1.9-32 8.8V96c0-17.7-14.3-32-32-32zM327.2 239.5c-2.3 .4-4.7 .5-7.2 .5H128c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48H320c26.5 0 48 21.5 48 48v24.9c-15.5 17.9-29.3 36.3-40.8 54.5zM112 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm96 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM112 160v32c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm397.4 93.3c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1C361.4 305.8 352 334.1 352 352c0 70.3 56.2 127.8 128 127.8c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zM487.5 197c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79c0 87.8-71.3 159.8-160 159.8c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zm-42.5 58.9c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0c-17.5 11.7-36.6 17.7-57.9 17.7c-25.9 0-50.2-8.4-68.2-24.8c-18.2-16.6-28.8-40.5-28.8-69.2c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1l12.6-9.9-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.5-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6c11.3 10.3 27.5 16.4 46.6 16.4c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5z"]
};
var faBinaryCircleCheck = {
  prefix: 'fal',
  iconName: 'binary-circle-check',
  icon: [640, 512, [], "e33c", "M320 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V16zM96 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V304zM0 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80C35.8 0 0 35.8 0 80zM80 32h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zM272 288c-44.2 0-80 35.8-80 80v64c0 44.2 35.8 80 80 80h32c24 0 45.6-10.6 60.2-27.3c-7.4-8.3-14-17.3-19.7-27C336 471.1 321.1 480 304 480H272c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h32c7.6 0 14.9 1.8 21.3 5c2.6-10.5 6.2-20.7 10.7-30.3c-9.8-4.3-20.6-6.6-32-6.6H272zm224-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faCommentMinus = {
  prefix: 'fal',
  iconName: 'comment-minus',
  icon: [512, 512, [], "f4b1", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM160 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faBurrito = {
  prefix: 'fal',
  iconName: 'burrito',
  icon: [512, 512, [127791], "f7ed", "M242 62c8.2-35.5 40-62 78-62c11.4 0 22.2 2.4 32 6.7C361.8 2.4 372.6 0 384 0c34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32c0 38-26.5 69.8-62 78L241.9 478.1C220.2 499.8 190.7 512 160 512s-60.2-12.2-81.9-33.9L33.9 433.9C12.2 412.2 0 382.7 0 352s12.2-60.2 33.9-81.9L242 62zm44-15.9C307.5 78.8 320 117.9 320 160c0 11.9-1 23.6-2.9 34.9c11.4-1.9 23-2.9 34.9-2.9c42.1 0 81.2 12.5 113.9 33.9c8.7-8.7 14.1-20.7 14.1-34c0-8.8-2.3-16.9-6.4-24c-2.9-5-2.9-11.1 0-16c4.1-7 6.4-15.2 6.4-24c0-22.8-15.9-41.9-37.2-46.8c-6-1.4-10.6-6-12-12C425.9 47.9 406.8 32 384 32c-8.8 0-16.9 2.3-24 6.4c-5 2.9-11.1 2.9-16 0c-7-4.1-15.2-6.4-24-6.4c-13.3 0-25.3 5.4-33.9 14.1zM56.6 411.3l44.1 44.1C116.4 471.2 137.8 480 160 480s43.6-8.8 59.3-24.6L431.7 243c-23.9-12.2-51-19-79.7-19c-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-28.3 0-55.4-5.7-80-15.9c0 22.2 8.9 43.5 24.6 59.3zm0-118.6c-7.9 7.9-14 17.1-18.2 27.2C60.8 330.2 85.7 336 112 336c79.2 0 146.2-52.3 168.3-124.3c5-16.3 7.7-33.7 7.7-51.7c0-28.7-6.9-55.8-19-79.7L56.6 292.7z"]
};
var faViolin = {
  prefix: 'fal',
  iconName: 'violin',
  icon: [640, 512, [127931], "f8ed", "M347.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-320 320c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l320-320zm288 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L452.5 164.9c-53.3-45.5-111.2-44.7-152-19C290.6 152 288 164.4 288 176c0 35.3-28.7 64-64 64c-5.2 0-10.2-.6-15.1-1.8c-14.1-3.4-30.2-4-39.8 6.7C143.5 273.3 128 310.8 128 352c0 22.4 4.6 43.7 12.9 63.1l-1.4 .9c-7.2 4.4-11.5 12.2-11.5 20.6c0 6.4 2.6 12.6 7.1 17.1l51.2 51.2c4.5 4.5 10.7 7.1 17.1 7.1c8.4 0 16.2-4.4 20.6-11.5l.9-1.4c19.4 8.3 40.7 12.9 63.1 12.9c41.2 0 78.7-15.5 107-41.1c10.7-9.7 10.1-25.8 6.7-39.8c-1.2-4.8-1.8-9.9-1.8-15.1c0-35.3 28.7-64 64-64c11.6 0 24-2.6 30.1-12.4c25.7-40.9 26.5-98.7-19-152L635.3 27.3zM429.8 187.6L324.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L452.4 210.2c34.2 41.3 32.2 81.8 16.4 109.4l-.4 .1c-1.2 .2-2.6 .3-4.4 .3c-53 0-96 43-96 96c0 7.7 .9 15.3 2.7 22.6c.6 2.4 1 4.6 1.2 6.5c.2 1.6 .2 2.7 .1 3.6C349.5 468.2 320.1 480 288 480c-16.3 0-31.8-3-46.1-8.6l40.4-65.7c5.8-9.5 4.4-21.7-3.5-29.5l-15.1-15.1c-7.9-7.9-20.1-9.3-29.5-3.5l-65.7 40.4C163 383.8 160 368.3 160 352c0-32.1 11.8-61.5 31.4-83.9c.8-.1 2 0 3.6 .1c1.9 .2 4.1 .6 6.5 1.2c7.3 1.8 14.8 2.7 22.6 2.7c53 0 96-43 96-96c0-1.7 .1-3.2 .3-4.4l.1-.4c27.6-15.8 68.1-17.9 109.4 16.4zM496 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM544 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM245.6 388.2l6.1 6.1-49.8 80.9-37.3-37.3 80.9-49.8z"]
};
var faObjectsColumn = {
  prefix: 'fal',
  iconName: 'objects-column',
  icon: [448, 512, [], "e3c1", "M48 64c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H48zM0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM304 256c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H304zm-48 16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V272zM144 352H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM48 320h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zM304 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H304zM256 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80z"]
};
var faSquareChevronDown = {
  prefix: 'fal',
  iconName: 'square-chevron-down',
  icon: [448, 512, ["chevron-square-down"], "f329", "M384 448c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0zm64-32c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM212.7 347.3l-112-112c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 313.4 324.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-112 112c-6.2 6.2-16.4 6.2-22.6 0z"]
};
var faChevronSquareDown = faSquareChevronDown;
var faCommentPlus = {
  prefix: 'fal',
  iconName: 'comment-plus',
  icon: [512, 512, [], "f4b2", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM240 336c0 8.8 7.2 16 16 16s16-7.2 16-16V256h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faTriangleInstrument = {
  prefix: 'fal',
  iconName: 'triangle-instrument',
  icon: [576, 512, ["triangle-music"], "f8e2", "M304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V65.4c-24.6 4.4-46.5 19-60.1 40.5L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94H450c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L443.8 232.1l-23.2 23.2 81.8 129.5c6.3 9.9 9.6 21.4 9.6 33.1c0 34.3-27.8 62-62 62H126c-34.3 0-62-27.8-62-62c0-11.7 3.3-23.2 9.6-33.1L238.9 123.1C249.5 106.2 268.1 96 288 96s38.5 10.2 49.1 27.1l48.5 76.8-65.1 65.1c-9.5-5.6-20.6-8.9-32.5-8.9c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-11.9-3.2-23-8.9-32.5l59.9-59.9 23.2-23.2 113-113c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L408.8 176.6 364.1 106C350.5 84.4 328.6 69.9 304 65.4V16zm16 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faTriangleMusic = faTriangleInstrument;
var faWheelchair = {
  prefix: 'fal',
  iconName: 'wheelchair',
  icon: [512, 512, [], "f193", "M176 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 176 0a56 56 0 1 0 0 112zm-32.4 96c-2-8.6-10.5-14-19.1-12.1C53.2 212.1 0 275.8 0 352c0 88.4 71.6 160 160 160c69.7 0 128.9-44.5 150.9-106.7c2.9-8.3-1.4-17.5-9.8-20.4s-17.5 1.4-20.4 9.8C263.1 444.4 215.7 480 160 480C89.3 480 32 422.7 32 352c0-60.9 42.5-111.9 99.5-124.8c8.6-2 14-10.5 12.1-19.1zm56-51.6c-2-8.6-10.5-14-19.1-12.1s-14 10.5-12.1 19.1l34.3 151.1c5 21.9 24.4 37.4 46.8 37.4H358.1l59.6 119.2c1.9 3.8 5.2 6.7 9.3 8s8.4 1 12.2-.9l64-32c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-49.7 24.8L386.7 337.7c-5.4-10.8-16.5-17.7-28.6-17.7H249.5c-7.5 0-13.9-5.2-15.6-12.5L215 224H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H207.7l-8.1-35.5z"]
};
var faUserPilotTie = {
  prefix: 'fal',
  iconName: 'user-pilot-tie',
  icon: [448, 512, [], "e2c1", "M230.9 .8l144 32c11.4 2.5 20.5 11.1 23.8 22.3s.2 23.3-8.1 31.6l-6.2-6.2 6.2 6.2L368 109.3v1.6c0 15.6-7.6 31.8-23.2 40.1c-22.5 12-59.5 25-120.8 25s-98.3-13.1-120.8-25C87.6 142.7 80 126.5 80 110.9v-1.6L57.4 86.6C49.1 78.4 46 66.3 49.3 55.1s12.4-19.8 23.8-22.3l144-32c4.6-1 9.3-1 13.9 0zM80 64l27.3 27.3c3 3 4.7 7.1 4.7 11.3v8.2c0 5.8 2.8 10 6.2 11.8C135.8 132 167.6 144 224 144s88.2-12 105.8-21.3c3.4-1.8 6.2-6 6.2-11.8v-8.2c0-4.2 1.7-8.3 4.7-11.3L368 64 224 32 80 64zm96 304c0-8.8 7.2-16 16-16h32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-6.1l18.4 36.9 51.6-68.7C391.2 355.4 448 414.3 448 486.4c0 14.1-11.5 25.6-25.6 25.6H240 208 25.6C11.5 512 0 500.5 0 486.4c0-72.1 56.8-131 128.1-134.3l51.6 68.7L198.1 384H192c-8.8 0-16-7.2-16-16zm48 35.8l-22.9 45.7 2.9 3.8L224 480l0 0 0 0 20-26.7 2.9-3.8L224 403.8zM184 480l-70.4-93.9C69 395.3 35.1 433.4 32.2 480H184zm80 0H415.8c-2.9-46.6-36.8-84.7-81.4-93.9L264 480zM96 192c0-2.9 .1-5.8 .3-8.7c9.1 4.3 19.6 8.5 31.8 12.1c1.8 51.4 44.1 92.6 95.9 92.6s94.1-41.1 95.9-92.6c12.2-3.6 22.7-7.8 31.8-12.1c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128zM183.2 65.7L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2z"]
};
var faPianoKeyboard = {
  prefix: 'fal',
  iconName: 'piano-keyboard',
  icon: [576, 512, [127929], "f8d5", "M448 224v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V224h32zM416 333.3V416H304V333.3c18.6-6.6 32-24.4 32-45.3V224h48v64c0 20.9 13.4 38.7 32 45.3zM448 416V333.3c18.6-6.6 32-24.4 32-45.3V224h64V384c0 17.7-14.3 32-32 32H448zm-16 32h80c35.3 0 64-28.7 64-64V224 208 192 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v64 16 16V384c0 35.3 28.7 64 64 64h80H288 432zM272 416H160V333.3c18.6-6.6 32-24.4 32-45.3V224h48v64c0 20.9 13.4 38.7 32 45.3V416zm-144 0H64c-17.7 0-32-14.3-32-32V224H96v64c0 20.9 13.4 38.7 32 45.3V416zm16-112c-8.8 0-16-7.2-16-16V224h32v64c0 8.8-7.2 16-16 16zm144 0c-8.8 0-16-7.2-16-16V224h32v64c0 8.8-7.2 16-16 16zM464 192H400 320 256 176 112 32V128c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32v64H464z"]
};
var faBedEmpty = {
  prefix: 'fal',
  iconName: 'bed-empty',
  icon: [640, 512, [128719], "f8f9", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V208 336v64 64c0 8.8 7.2 16 16 16s16-7.2 16-16V416H608v48c0 8.8 7.2 16 16 16s16-7.2 16-16V400 336 304c0-61.9-50.1-112-112-112H32V48zM608 320H32V224H528c44.2 0 80 35.8 80 80v16zM32 352H608v32H32V352z"]
};
var faCircleArrowUp = {
  prefix: 'fal',
  iconName: 'circle-arrow-up',
  icon: [512, 512, ["arrow-circle-up"], "f0aa", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 228.7l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 182.6V368c0 8.8 7.2 16 16 16s16-7.2 16-16V182.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"]
};
var faArrowCircleUp = faCircleArrowUp;
var faToggleOn = {
  prefix: 'fal',
  iconName: 'toggle-on',
  icon: [576, 512, [], "f205", "M160 128C89.3 128 32 185.3 32 256s57.3 128 128 128H416c70.7 0 128-57.3 128-128s-57.3-128-128-128H160zM0 256C0 167.6 71.6 96 160 96H416c88.4 0 160 71.6 160 160s-71.6 160-160 160H160C71.6 416 0 344.4 0 256zm480 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faRectangleVertical = {
  prefix: 'fal',
  iconName: 'rectangle-vertical',
  icon: [384, 512, ["rectangle-portrait"], "f2fb", "M352 448c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 384zM384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384z"]
};
var faRectanglePortrait = faRectangleVertical;
var faPersonWalking = {
  prefix: 'fal',
  iconName: 'person-walking',
  icon: [320, 512, [128694, "walking"], "f554", "M200 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 200 0zM121.5 170.2c-1.3 .6-2.6 1.3-3.9 2l-12.7 6.9c-27.5 15-47.4 40.8-55 71.2l-2.4 9.6c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4l2.4-9.5c9.8-39 35.4-72.2 70.7-91.5l12.7-6.9c19.4-10.6 41.2-16.2 63.4-16.2c36.9 0 69.7 23.6 81.4 58.7l17.1 51.4c3.4 10.1 10 18.8 18.9 24.8l29.7 19.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-29.7-19.8c-14.8-9.9-25.9-24.4-31.5-41.3l-8.8-26.4L187.3 331l43.6 37.8c4.7 4.1 8.1 9.4 9.8 15.4l30.7 107.4c2.4 8.5-2.5 17.4-11 19.8s-17.4-2.5-19.8-11L209.9 393 109.4 305.8C94.9 293.3 89.3 273.4 95 255.2l26.6-85zm36.6-9.9L125.5 264.8c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 45-130c-10-11.5-24.7-18.4-40.6-18.4c-2.5 0-5 .1-7.5 .3zM126.3 375.2L95.5 436.8c-1.5 3.1-3.6 5.9-6 8.3L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l62.2-62.2 30.8-61.7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z"]
};
var faWalking = faPersonWalking;
var faL = {
  prefix: 'fal',
  iconName: 'l',
  icon: [320, 512, [108], "4c", "M48 32c8.8 0 16 7.2 16 16V448H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16z"]
};
var faSignalStream = {
  prefix: 'fal',
  iconName: 'signal-stream',
  icon: [576, 512, [], "f8dd", "M90.3 68.5c6.8 5.7 7.6 15.8 1.9 22.5C54.6 135.6 32 193.1 32 256s22.6 120.4 60.2 165c5.7 6.8 4.8 16.8-1.9 22.5s-16.8 4.8-22.5-1.9C25.5 391.5 0 326.7 0 256S25.5 120.5 67.8 70.4c5.7-6.8 15.8-7.6 22.5-1.9zm395.4 0c6.8-5.7 16.8-4.8 22.5 1.9C550.5 120.5 576 185.3 576 256s-25.5 135.5-67.8 185.6c-5.7 6.8-15.8 7.6-22.5 1.9s-7.6-15.8-1.9-22.5C521.4 376.4 544 318.9 544 256s-22.6-120.4-60.2-165c-5.7-6.8-4.8-16.8 1.9-22.5zM224 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM164.6 154.2C141.7 181.9 128 217.3 128 256s13.7 74.1 36.6 101.8c5.6 6.8 4.7 16.9-2.1 22.5s-16.9 4.7-22.5-2.1C112.5 345 96 302.4 96 256s16.5-89 43.9-122.2c5.6-6.8 15.7-7.8 22.5-2.1s7.8 15.7 2.1 22.5zm271.5-20.4C463.5 167 480 209.6 480 256s-16.5 89-43.9 122.2c-5.6 6.8-15.7 7.8-22.5 2.1s-7.8-15.7-2.1-22.5C434.3 330.1 448 294.7 448 256s-13.7-74.1-36.6-101.8c-5.6-6.8-4.7-16.9 2.1-22.5s16.9-4.7 22.5 2.1z"]
};
var faDownToBracket = {
  prefix: 'fal',
  iconName: 'down-to-bracket',
  icon: [448, 512, [], "e4e7", "M222.2 319.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L350.2 187.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7H288c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8V160c0 8.8-7.2 16-16 16H102.7c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L222.2 319.2zM224 352c-9.5 0-18.6-3.9-25.1-10.8L74.5 209.2C67.8 202 64 192.5 64 182.7c0-21.4 17.3-38.7 38.7-38.7H144V40c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40V144h41.3c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.3-10.5 26.5L249.1 341.2c-6.5 6.9-15.6 10.8-25.1 10.8zM32 336v96c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V336c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V336c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCircleZ = {
  prefix: 'fal',
  iconName: 'circle-z',
  icon: [512, 512, [], "e130", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H304.9L163 358.7c-3.5 4.9-3.9 11.3-1.2 16.6s8.2 8.7 14.2 8.7H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H207.1L349 153.3c3.5-4.9 3.9-11.3 1.2-16.6s-8.2-8.7-14.2-8.7H176z"]
};
var faStars = {
  prefix: 'fal',
  iconName: 'stars',
  icon: [512, 512, [], "f762", "M352 16V80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H352v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM152.8 265.5c-4.7 9.5-13.7 16-24.1 17.5L41.2 295.8l63.4 61.9c7.5 7.3 11 17.9 9.2 28.3l-15 87.3L177 432.1c9.3-4.9 20.5-4.9 29.8 0L285 473.3l-15-87.3c-1.8-10.4 1.7-20.9 9.2-28.3l63.4-61.9-87.5-12.7c-10.4-1.5-19.4-8.1-24.1-17.5l-39.1-79.4-39.1 79.4zm17.6-108.1c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94zM448 160c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176c0-8.8 7.2-16 16-16z"]
};
var faFire = {
  prefix: 'fal',
  iconName: 'fire',
  icon: [448, 512, [128293], "f06d", "M239.7 109.4c6.1 7.7 15.5 12.1 25.3 12s19.1-4.7 25.1-12.5c8.4-11 16.9-21.7 25.6-31.1c27.8 28.8 52.1 65.5 69.8 101.1c19.6 39.4 30.5 75.7 30.5 97.6C416 388.3 328.8 480 224 480C118 480 32 388.4 32 276.5c0-29.9 14.4-70.8 40.9-115.4c24.7-41.6 59.3-85.3 100.2-124.7c23.5 22.7 45.7 47 66.6 73zm25-20c-6.9-8.6-13.9-17-21-25.2C225.6 43.6 206.7 24 187 5.5c-7.8-7.3-19.9-7.3-27.7-.1c-46.5 43.2-86 92.3-113.9 139.3C17.8 191.2 0 238.1 0 276.5C0 404.1 98.4 512 224 512c124.2 0 224-107.8 224-235.5c0-29.3-13.5-71.1-33.8-111.9c-20.7-41.4-49.9-85-84.5-118c-7.8-7.5-20.1-7.5-28-.1c-5.7 5.4-11.2 11.3-16.5 17.4c-7.3 8.4-14.2 17.2-20.5 25.5zM128 306.8c0-23.7 13-46.3 47.1-89.1c16.8 21.3 46.2 58.7 62.6 79.6c12.5 15.9 36.3 16.3 49.4 1l23.4-27.2c17.8 38.8 9.4 86.6-24.9 110.7C267.1 394 247.7 400 225.7 400c-28.2 0-52.6-9-69.8-24.7c-17-15.5-28-38.4-28-68.5zm72-109.2c-12.7-16.1-37-16.2-49.8-.1C116.8 239.4 96 270.3 96 306.8c0 38.5 14.3 70.2 38.4 92.1c23.9 21.8 56.4 33.1 91.3 33.1c28.5 0 54.1-8 77.7-23.7l0 0 .3-.2c51.2-35.7 59.1-104.2 33.9-154.6c-10.7-21.4-37.3-19.7-49.9-5.1l-24.9 29 0 0c-16.5-21-46-58.5-62.8-79.8z"]
};
var faBedPulse = {
  prefix: 'fal',
  iconName: 'bed-pulse',
  icon: [640, 512, ["procedures"], "f487", "M478.3 8.8L505.9 64H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-6.1 0-11.6-3.4-14.3-8.8L465.6 55 414.9 181.9c-2.3 5.9-7.9 9.8-14.2 10s-12.2-3.2-15-8.8L342.1 96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16H352c6.1 0 11.6 3.4 14.3 8.8L398.4 137 449.1 10.1c2.3-5.9 7.9-9.8 14.2-10s12.2 3.2 15 8.8zM304 160h34.3l16 32H304c-8.8 0-16 7.2-16 16V352H608V272c0-44.2-35.8-80-80-80H445.3l12.8-32H528c61.9 0 112 50.1 112 112v96 64 64c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368 80c0-8.8 7.2-16 16-16s16 7.2 16 16V352H256V208c0-26.5 21.5-48 48-48zM608 416V384H272 32v32H608zM192 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 240a80 80 0 1 1 160 0A80 80 0 1 1 64 240z"]
};
var faProcedures = faBedPulse;
var faHouseDay = {
  prefix: 'fal',
  iconName: 'house-day',
  icon: [640, 512, [], "e00e", "M192 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H64c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM276.7 52.7l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM410.4 99.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L224 283.9V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V283.9l37.6 32.2c6.7 5.7 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-224-192zM544 256.5V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V256.5L400 133.1 544 256.5zM336 304v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32zm96 0v64H368V304h64zM144 176c0-17.7 14.3-32 32-32c13.9 0 25.8 8.9 30.2 21.3c2.9 8.3 12.1 12.7 20.4 9.8s12.7-12.1 9.8-20.4C227.6 129.8 203.9 112 176 112c-35.3 0-64 28.7-64 64c0 27.9 17.8 51.6 42.7 60.4c8.3 2.9 17.5-1.4 20.4-9.8s-1.4-17.5-9.8-20.4C152.9 201.8 144 189.9 144 176zm-36.7 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zM52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faShuttleSpace = {
  prefix: 'fal',
  iconName: 'shuttle-space',
  icon: [640, 512, ["space-shuttle"], "f197", "M245.2 448.1L405.3 352H464c64.7 0 123.5-27.4 164.8-76.3c9.6-11.4 9.6-28 0-39.4C587.5 187.4 528.7 160 464 160H405.3L245.2 63.9C210.4 43 170.6 32 130 32H80C53.5 32 32 53.5 32 80v48c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32v48c0 26.5 21.5 48 48 48h50c40.6 0 80.4-11 115.2-31.9zM64 384h48c5.5 0 10.8-.6 16-1.6V448H80c-8.8 0-16-7.2-16-16V384zm164.7 36.6c-21.2 12.7-44.5 21.2-68.7 25V368c5.5-4.2 10.5-9 14.8-14.5c.6-.7 1.2-1.2 1.6-1.4c.2-.1 .3-.1 .3-.1H343.1L228.7 420.6zM64 352H32V272H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V160H64h48c15.3 0 28.9 7.1 37.7 18.3c5.8 7.3 15.2 13.7 27 13.7H464c54.9 0 104.4 22.9 139.5 64c-35.1 41.1-84.6 64-139.5 64H176.7c-11.8 0-21.2 6.4-27 13.7C140.9 344.9 127.3 352 112 352H64zm0-224V80c0-8.8 7.2-16 16-16h48v65.6c-5.2-1.1-10.5-1.6-16-1.6H64zm110.8 30.5c-4.3-5.4-9.3-10.3-14.8-14.5V66.4c24.2 3.8 47.6 12.3 68.7 25L343.1 160H176.7c0 0-.2 0-.3-.1c-.4-.2-1-.7-1.6-1.4zM464 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"]
};
var faSpaceShuttle = faShuttleSpace;
var faShirtLongSleeve = {
  prefix: 'fal',
  iconName: 'shirt-long-sleeve',
  icon: [640, 512, [], "e3c7", "M110.3 73.4C124.3 47.9 151.2 32 180.4 32H192h4 28.3c4.1 49.3 45.3 88 95.7 88s91.6-38.7 95.7-88H444h4 11.6c29.2 0 56 15.9 70.1 41.4l66.4 120.7c7.8 14.2 11.9 30.1 11.9 46.3V368c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V240.4c0-5.4-1.4-10.7-4-15.4L481.2 118c-1.4-2.6-3.1-5.1-5-7.3c-4.4-5.1-11.4-6.9-17.7-4.5s-10.4 8.3-10.4 15V456c0 13.3-10.7 24-24 24H216c-13.3 0-24-10.7-24-24V121.2c0-6.7-4.2-12.7-10.4-15s-13.3-.5-17.7 4.5c-1.9 2.2-3.6 4.6-5.1 7.3L100 225c-2.6 4.7-4 10-4 15.4V368c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V240.4c0-16.2 4.1-32.1 11.9-46.3L110.3 73.4zM180.4 0c-40.8 0-78.5 22.2-98.1 58L15.8 178.8C5.5 197.7 0 218.9 0 240.4V368c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V240.4l32-58.2V456c0 30.9 25.1 56 56 56H424c30.9 0 56-25.1 56-56V182.3l32 58.2V368c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V240.4c0-21.6-5.4-42.8-15.8-61.7L557.8 58C538.1 22.2 500.5 0 459.6 0H448h-4H407.6c-1.5 0-2.9 .1-4.2 .4c-1.1-.2-2.2-.4-3.4-.4H240c-1.2 0-2.3 .1-3.4 .4c-1.3-.2-2.8-.4-4.2-.4H196h-4H180.4zm76.1 32h127c-3.9 31.6-30.9 56-63.5 56s-59.6-24.4-63.5-56z"]
};
var faChartPieSimple = {
  prefix: 'fal',
  iconName: 'chart-pie-simple',
  icon: [512, 512, ["chart-pie-alt"], "f64e", "M256 17.7v9.4V240c0 8.8 7.2 16 16 16H494.3c9.6 0 17.7-7.4 17.7-17.1C512 107 405 0 273.1 0C263.4 0 256 8.1 256 17.7zm32 14.8C390.4 39.8 472.2 121.6 479.5 224H288V32.5zM192 288c0 17.7 14.3 32 32 32H442.4C420.8 411.7 338.3 480 240 480C125.1 480 32 386.9 32 272c0-98.3 68.3-180.8 160-202.4V288zM224 66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.5 107.5 512 240 512c115.5 0 211.9-81.5 234.8-190.2c3.8-18.1-11-33.8-29.5-33.8H256 224V256 66.7z"]
};
var faChartPieAlt = faChartPieSimple;
var faFaceLaugh = {
  prefix: 'fal',
  iconName: 'face-laugh',
  icon: [512, 512, ["laugh"], "f599", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288H385.5c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm25.9-96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faLaugh = faFaceLaugh;
var faFolderOpen = {
  prefix: 'fal',
  iconName: 'folder-open',
  icon: [576, 512, [128194, 128449, 61717], "f07c", "M448 160v32h32V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384h80c19.6 0 37.3-11.9 44.6-30.2l64-160c5.9-14.8 4.1-31.5-4.8-44.7S543.9 224 528 224H128c-19.6 0-37.3 11.9-44.6 30.2L32 382.8V96c0-17.7 14.3-32 32-32H181.5c8.5 0 16.6 3.4 22.6 9.4l22.6-22.6L204.1 73.4l26.5 26.5c18 18 42.4 28.1 67.9 28.1H416c17.7 0 32 14.3 32 32zM384 448H64c-5.3 0-10.3-2.6-13.2-7s-3.6-10-1.6-14.9l64-160c2.4-6.1 8.3-10.1 14.9-10.1H528c5.3 0 10.3 2.6 13.2 7s3.6 10 1.6 14.9l-64 160C476.4 444 470.5 448 464 448H384z"]
};
var faAlbumCollectionCircleUser = {
  prefix: 'fal',
  iconName: 'album-collection-circle-user',
  icon: [640, 512, [], "e48f", "M32 16c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H48C39.2 0 32 7.2 32 16zM16 80c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272C31.4 489.9 55.6 512 84.5 512H394.8c-12.9-9.1-24.5-19.9-34.6-32H84.5c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272C34.6 172.1 45.7 160 59.8 160H452.2c14.1 0 25.2 12.1 23.9 26.2l-.6 7c6.7-.8 13.6-1.2 20.5-1.2c3.9 0 7.8 .1 11.7 .4l.3-3.3c3-32.8-22.8-61.1-55.8-61.1H59.8zM256 192c-88.4 0-160 57.3-160 128s71.6 128 160 128c27.6 0 53.6-5.6 76.2-15.4c-3.9-9.9-6.9-20.2-9-30.8C304.4 410.6 281.7 416 256 416c-77.7 0-128-49.3-128-96s50.3-96 128-96c43.3 0 78 15.3 100.3 36.9c6.5-8.5 13.8-16.4 21.8-23.6C348.8 209.6 305 192 256 192zm0 152c13.3 0 24-9 24-20s-10.7-20-24-20s-24 9-24 20s10.7 20 24 20zM556 462.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6h56.4c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8H467.8c-21.8 0-42.2 9.6-56.1 25.8C394.5 422.1 384 396.2 384 368c0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faCandy = {
  prefix: 'fal',
  iconName: 'candy',
  icon: [640, 512, [127852], "e3e7", "M376.9 405.6C359.2 412.3 340 416 320 416c-4.9 0-9.7-.2-14.4-.6L183.8 171.9c12.8-20.7 30.1-38.2 50.6-51.2L376.9 405.6zm28.6-14.3L263.1 106.4C280.8 99.7 300 96 320 96c4.9 0 9.7 .2 14.4 .6L456.2 340.1c-12.8 20.7-30.1 38.2-50.6 51.2zm-14.2 43.1l0 0c10-4 19.5-8.8 28.6-14.3l0 0c40.9-24.9 71.7-64.7 84.9-111.8l91.9 49c10.5 5.6 23.5 2.7 30.6-6.9c9.1-12.3 3.8-24.5-5.3-35.4c-5.4-6.4-12-12.3-17.9-17.5l0 0c-3.2-2.9-6.3-5.6-8.7-8c2.8-1 5.8-2 9-3c8.3-2.7 17.6-5.7 24.6-10.5c6.5-4.5 11.1-10.7 11.1-19.8s-4.6-15.3-11.1-19.8c-7-4.9-16.2-7.8-24.6-10.5c-3.2-1-6.3-2-9-3c2.4-2.4 5.4-5.1 8.7-8c5.9-5.2 12.6-11.2 17.9-17.5c9.2-10.9 14.4-23.1 5.3-35.4c-7.1-9.6-20.1-12.5-30.6-6.9l-91.9 49C485.2 134.3 427.4 80.7 355.5 67.3l0 0C344 65.1 332.2 64 320.1 64c0 0 0 0-.1 0c-25.2 0-49.2 4.8-71.3 13.7l0 0c-10 4-19.6 8.8-28.6 14.3l0 0c-40.9 24.9-71.7 64.7-84.9 111.8l-91.9-49c-10.5-5.6-23.5-2.7-30.6 6.9c-9.1 12.3-3.8 24.5 5.3 35.4c5.4 6.4 12 12.3 17.9 17.5l0 0c3.2 2.9 6.3 5.6 8.7 8c-2.8 1-5.8 2-9 3l0 0c-8.3 2.7-17.6 5.7-24.6 10.5C4.6 240.7 0 246.9 0 256s4.6 15.3 11.1 19.8c7 4.9 16.2 7.8 24.6 10.5c3.2 1 6.3 2 9 3c-2.4 2.4-5.4 5.1-8.7 8l0 0 0 0 0 0c-5.9 5.2-12.6 11.2-17.9 17.5C8.9 325.8 3.6 338 12.7 350.3c7.1 9.6 20.1 12.5 30.6 6.9l91.9-49c19.6 69.5 77.4 123.1 149.3 136.5l0 0c12.1 2.3 24.6 3.4 37.4 3.3l0 0c24.5-.2 47.9-5.1 69.4-13.7zm-126-27.9C203.9 384.1 160 325.2 160 256c0-16.2 2.4-31.8 6.9-46.5l98.5 196.9zM374.7 105.6C436.1 127.9 480 186.8 480 256c0 16.2-2.4 31.8-6.9 46.5L374.7 105.6zM512 256c0-6.3-.3-12.4-.9-18.5l54.9-29.3c-3.2 6.5-4.2 14-2.6 21.4c2.3 10.8 10 19.8 20.4 23.7c2.8 1.1 5.6 2 8.1 2.8l.1 0-.1 0c-2.4 .8-5.3 1.7-8.1 2.8c-10.4 3.9-18.1 12.8-20.4 23.7c-1.6 7.3-.6 14.8 2.6 21.4l-54.9-29.3c.6-6.1 .9-12.3 .9-18.5zM128.9 237.5c-.6 6.1-.9 12.3-.9 18.5s.3 12.4 .9 18.5L73.9 303.8c3.2-6.5 4.2-14 2.6-21.4c-2.3-10.8-10-19.8-20.4-23.7c-2.8-1.1-5.6-2-8.1-2.8l-.1 0 .1 0c2.4-.8 5.3-1.7 8.1-2.8c10.4-3.9 18.1-12.8 20.4-23.7c1.6-7.3 .6-14.8-2.6-21.4l54.9 29.3z"]
};
var faBowlHot = {
  prefix: 'fal',
  iconName: 'bowl-hot',
  icon: [512, 512, ["soup"], "f823", "M144 0c8.8 0 16 7.2 16 16V32c0 20.1 9.5 39.1 25.6 51.2C209.8 101.3 224 129.8 224 160v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-20.1-9.5-39.1-25.6-51.2C142.2 90.7 128 62.2 128 32V16c0-8.8 7.2-16 16-16zm.8 445.5c7.7 3.7 13.7 10.3 16.5 18.4c3.3 9.4 12.2 16.1 22.7 16.1H328c10.4 0 19.4-6.7 22.7-16.1c2.8-8.1 8.7-14.7 16.5-18.4c61.4-29.2 105-90.1 109.3-162.2l.6-10.3c.5-9.2-6.8-16.9-16-16.9H50.9c-9.2 0-16.5 7.7-16 16.9l.6 10.3c4.2 72.1 47.8 133 109.3 162.2zM3 274.8C1.4 247.2 23.3 224 50.9 224H461.1c27.6 0 49.5 23.2 47.9 50.8l-.6 10.3c-4.9 84.1-55.9 155.1-127.5 189.2C373.3 496.3 352.5 512 328 512H184c-24.5 0-45.3-15.7-52.9-37.6C59.5 440.3 8.5 369.3 3.6 285.2L3 274.8zM288 16V32c0 20.1 9.5 39.1 25.6 51.2C337.8 101.3 352 129.8 352 160v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-20.1-9.5-39.1-25.6-51.2C270.2 90.7 256 62.2 256 32V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSoup = faBowlHot;
var faFlatbread = {
  prefix: 'fal',
  iconName: 'flatbread',
  icon: [512, 512, [129747], "e40b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm363.3-84.7l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-112-70.6c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zm160 182.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faHeartCirclePlus = {
  prefix: 'fal',
  iconName: 'heart-circle-plus',
  icon: [576, 512, [], "e500", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCodeFork = {
  prefix: 'fal',
  iconName: 'code-fork',
  icon: [448, 512, [], "e13b", "M80 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4V192c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V158.4c-36.5-7.4-64-39.7-64-78.4c0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4V192c0 44.2-35.8 80-80 80H240v81.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V272H144c-44.2 0-80-35.8-80-80V158.4C27.5 151 0 118.7 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm64 304a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM416 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faCity = {
  prefix: 'fal',
  iconName: 'city',
  icon: [640, 512, [127961], "f64f", "M96 16V64h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64 80 96H176 64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H197.5c4.2 11.9 10.7 22.8 19 32H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64V16C64 7.2 71.2 0 80 0s16 7.2 16 16zM512 192c-17.7 0-32-14.3-32-32V64c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32h32H448 576c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H512zm0-128v64 32h32 32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H448 320 288c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64zM320 392V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm32-8h32V352H352v32zM344 64h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm8 64h32V96H352v32zM320 264V216c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm32-8h32V224H352v32zM504 448c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H504zm8-64v32h32V384H512zm-32-88V248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H504c-13.3 0-24-10.7-24-24zm32-8h32V256H512v32zM88 352c-13.3 0-24-10.7-24-24V280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88zm8-64v32h32V288H96zM64 200V152c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm32-8h32V160H96v32z"]
};
var faSignalBarsWeak = {
  prefix: 'fal',
  iconName: 'signal-bars-weak',
  icon: [640, 512, ["signal-alt-1"], "f691", "M96 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-8.8 7.2-16 16-16s16 7.2 16 16v32zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z"]
};
var faSignalAlt1 = faSignalBarsWeak;
var faMicrophoneLines = {
  prefix: 'fal',
  iconName: 'microphone-lines',
  icon: [384, 512, [127897, "microphone-alt"], "f3c9", "M256 160V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h48c0-35.3-28.7-64-64-64s-64 28.7-64 64V256c0 35.3 28.7 64 64 64s64-28.7 64-64H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h48zm32 16v64 16c0 53-43 96-96 96s-96-43-96-96V96c0-53 43-96 96-96s96 43 96 96v16 64zM48 192c8.8 0 16 7.2 16 16v48c0 70.7 57.3 128 128 128s128-57.3 128-128V208c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 83-63.1 151.2-144 159.2V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192 112c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V415.2C95.1 407.2 32 339 32 256V208c0-8.8 7.2-16 16-16z"]
};
var faMicrophoneAlt = faMicrophoneLines;
var faClockTwelve = {
  prefix: 'fal',
  iconName: 'clock-twelve',
  icon: [512, 512, [], "e358", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V256c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPepperHot = {
  prefix: 'fal',
  iconName: 'pepper-hot',
  icon: [512, 512, [127798], "f816", "M422.9 133.4l11.2 7.5 9.4 9.6C466.1 173.7 480 205.2 480 240c0 3-.1 5.9-.3 8.8C469.4 233.4 452 224 433.2 224H368V152c0-15.7-6.4-29.8-16.8-40l.8 0c26.3 0 50.6 7.9 70.9 21.4zM512 240c0-43.3-17.2-82.6-45.2-111.4l-.4-.4c1.5-3.3 2.9-6.6 4.2-10c9.4-25.6 10.6-53.8 2.7-80.5c-1.1-3.8-2.4-7.6-3.9-11.3l-6.5-16.3 0 0 0 0c-3.3-8.2-12.6-12.2-20.8-8.9s-12.2 12.6-8.9 20.8l0 0 6.5 16.3c2.5 6.3 4.3 12.7 5.4 19.2c.9 5.1 1.4 10.3 1.4 15.5c.1 11.6-1.8 23.1-5.8 34c-9-6-18.6-11.1-28.7-15.2C393.5 84.1 373.2 80 352 80c-24.3 0-47.3 5.4-67.9 15.1c-19.3 9-10.5 32.9 10.8 32.9l17.1 0c13.3 0 24 10.7 24 24v80c0 13.3 10.7 24 24 24h73.2c9.1 0 17.4 5.1 21.5 13.3l11.7 23.4c8.2 16.4 30.7 17.5 36.8 .1c5.8-16.5 8.9-34.3 8.9-52.8zM261.7 160L172.4 305.7c-18.1 29.6-47.5 50.5-81.4 58.1l-35.4 7.9C23.1 378.9 0 407.7 0 441c0 39.2 31.8 71 71 71h32.1c141.1 0 269.1-68.1 348.9-176.2l-16.2-32.5C362.9 411.3 239.6 480 103.2 480H71c-21.6 0-39-17.5-39-39c0-18.3 12.7-34.1 30.6-38.1L97.9 395c42.3-9.4 79-35.6 101.7-72.6L299.2 160l-37.5 0z"]
};
var faCitrusSlice = {
  prefix: 'fal',
  iconName: 'citrus-slice',
  icon: [512, 512, [], "e2f5", "M427.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-400 400c-6.2 6.2-6.2 16.4 0 22.6C58.9 481.5 132.5 512 209.1 512h4C378.2 512 512 378.2 512 213.2v-4c0-76.7-30.5-150.2-84.7-204.5zM278.8 175.8l89.4-89.4c21.5 25.2 36.9 55.9 43.7 89.7H279c-.1-.1-.1-.1-.2-.2zM295.6 208H415.8c.1 2.7 .2 5.3 .2 8c0 49.5-18 94.7-47.7 129.7l-82.5-82.5c10.7-16.5 14-36.5 9.8-55.2zm50.1 160.3C310.7 398 265.5 416 216 416c-2.7 0-5.3-.1-8-.2v-122c18.4 4.6 38.2 1.8 54.9-8.4l82.8 82.8zM176 412c-33.7-6.9-64.4-22.2-89.7-43.7L176 278.6V412zM448 216c0-58.3-21.5-111.6-57-152.3L415.6 39C457 85.8 480 146.3 480 209.1v4C480 360.5 360.5 480 213.2 480h-4C146.3 480 85.8 457 39 415.6L63.7 391c40.8 35.5 94 57 152.3 57c128.1 0 232-103.9 232-232zM256.2 198.5c13.1 15.7 12.2 39.1-2.5 53.8s-38.1 15.6-53.8 2.5l56.3-56.3z"]
};
var faSheep = {
  prefix: 'fal',
  iconName: 'sheep',
  icon: [640, 512, [128017], "f711", "M544 136c0-39.8-32.2-72-72-72c-36.1 0-66 26.6-71.2 61.2l.1 .1-.1 .1c-.5 3.5-.8 7-.8 10.6v72c0 35.3 28.7 64 64 64h16c35.3 0 64-28.7 64-64V136zM372.5 105.8C385.4 63.1 425.1 32 472 32c44.4 0 82.2 27.8 97.2 66.9l47.7 31.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4L576 141.9V208c0 53-43 96-96 96H464c-53 0-96-43-96-96V147.2l-15.1 10.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l37.3-24.9zM448 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 344c9.9 0 18.8-4.5 24.7-11.6c10.1 2.4 20.5 3.6 31.3 3.6c1.1 0 2.2 0 3.4 0c-8.7 21.5-28.8 37.3-52.8 39.7l-25 100C392.2 497 373 512 351 512H336c-26.5 0-48-21.5-48-48V423.4c-9.4 5.4-20.3 8.6-32 8.6s-22.6-3.1-32-8.6V464c0 26.5-21.5 48-48 48H161c-22 0-41.2-15-46.6-36.4l-25-100C57.2 372.4 32 345.1 32 312c0-5.3 .7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 76.8 137.9 56 168 56c15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9C315.1 61.2 329 56 344 56c5.7 0 11.2 .7 16.5 2.1c-6.4 9.2-11.7 19.2-15.8 29.9l-.7 0c-7.6 0-14.4 2.6-19.9 6.9c-13.4 10.6-32.8 8.9-44-4c-5.9-6.8-14.5-11-24.1-11s-18.2 4.2-24.1 11c-11.3 12.9-30.6 14.6-44 4C182.4 90.6 175.6 88 168 88c-15 0-27.7 10.4-31.1 24.3c-3.9 16.1-19.6 26.6-36 24c-1.6-.2-3.2-.4-5-.4c-17.7 0-32 14.3-32 32c0 2.7 .3 5.3 .9 7.8c3.5 14.2-3 29-16 36c-10.2 5.4-17 16.1-17 28.3s6.8 22.8 17 28.3c12.9 6.9 19.5 21.7 16 36c-.6 2.5-.9 5.1-.9 7.8c0 17.7 14.3 32 32 32c1.7 0 3.4-.1 5-.4c16.4-2.5 32 7.9 36 24c3.4 14 16.1 24.3 31.1 24.3c7.6 0 14.4-2.6 19.9-6.9c13.4-10.6 32.8-8.9 44 4c5.9 6.8 14.5 11 24.1 11s18.2-4.2 24.1-11c11.3-12.9 30.6-14.6 44-4c5.5 4.3 12.3 6.9 19.9 6.9c15 0 27.7-10.4 31.1-24.3c3.9-16.1 19.6-26.6 36-24c1.6 .2 3.2 .4 5 .4zm-72 80c-8.5 0-16.6-1.7-24-4.7V464c0 8.8 7.2 16 16 16h15c7.3 0 13.7-5 15.5-12.1l13.8-55.2C370 419.8 357.5 424 344 424zM131.7 412.7l13.8 55.2c1.8 7.1 8.2 12.1 15.5 12.1h15c8.8 0 16-7.2 16-16V419.3c-7.4 3-15.5 4.7-24 4.7c-13.5 0-26-4.2-36.3-11.3z"]
};
var faUnlock = {
  prefix: 'fal',
  iconName: 'unlock',
  icon: [448, 512, [128275], "f09c", "M128 128c0-53 43-96 96-96c43.5 0 80.2 28.9 92 68.6c2.5 8.5 11.4 13.3 19.9 10.8s13.3-11.4 10.8-19.9C331 38.6 282 0 224 0C153.3 0 96 57.3 96 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H128V128zM32 272c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272z"]
};
var faColonSign = {
  prefix: 'fal',
  iconName: 'colon-sign',
  icon: [384, 512, [], "e140", "M255.6 19.6c2-8.6-3.3-17.2-11.9-19.2s-17.2 3.3-19.2 11.9L212.2 64.6C111.6 72.5 32 154.9 32 256c0 70.8 39 132.4 96.9 165.7l-16.5 70.7c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9l14.9-64.1c14.2 5.3 29.1 9 44.6 10.9l-10.7 45.9c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9l12.1-51.8c41.1-1.6 79-15.5 109.8-38.2c7.1-5.2 8.7-15.2 3.4-22.4s-15.2-8.7-22.4-3.4c-23.6 17.3-52.2 28.6-83.3 31.4l69.2-296.5c4.9 2.9 9.6 6 14.1 9.3c7.1 5.2 17.1 3.7 22.4-3.4s3.7-17.1-3.4-22.4c-8-5.9-16.6-11.2-25.5-15.9l15.6-66.8c2-8.6-3.3-17.2-11.9-19.2s-17.2 3.3-19.2 11.9L290.1 73.8c-14.3-4.7-29.4-7.8-45-9.1l10.5-45.1zm-51.1 78l-68 291.2C92.7 360.1 64 311.2 64 256c0-80.3 60.8-147.3 140.5-158.4zM165.9 404.1L237.7 96.3c15.7 .9 30.9 4 45.1 8.9l-72.3 310c-15.6-1.6-30.6-5.4-44.6-11z"]
};
var faHeadset = {
  prefix: 'fal',
  iconName: 'headset',
  icon: [512, 512, [], "f590", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224V400.1c0 26.5-21.5 48-48 48l-82.7-.1c-6.6-18.6-24.4-32-45.3-32H240c-26.5 0-48 21.5-48 48s21.5 48 48 48h64c20.9 0 38.7-13.4 45.3-32l82.7 .1c44.2 0 80.1-35.8 80.1-80V256C512 114.6 397.4 0 256 0S0 114.6 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256zM320 464c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16M144 224h16V352H144c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zM64 272v32c0 44.2 35.8 80 80 80h16c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H144c-44.2 0-80 35.8-80 80zm288-48h16c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H352V224zm16-32H352c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32h16c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80z"]
};
var faBadgerHoney = {
  prefix: 'fal',
  iconName: 'badger-honey',
  icon: [640, 512, [129441], "f6b4", "M459.8 96c-21 0-41.8 4.9-60.6 14.3c-23.3 11.6-48.9 17.7-74.9 17.7H128c-5.3 0-10.5 .4-15.6 1.3C117.1 182.4 161.7 224 216 224h2c17.1 0 34-4.2 49.2-12.1l85.6-44.8C391.7 146.7 435 136 479 136H583.9c-.7-.4-1.5-.7-2.2-1l-61.1-26.7C502.2 100.2 482.3 96 462.2 96h-2.4zM32 224c0 43.2 28.5 79.8 67.8 91.8c8.3 2.6 13.1 11.3 10.7 19.7L99.2 374.9c-1.7 5.9-1.6 12.1 .1 18l13.1 43.7c2 6.8 8.3 11.4 15.3 11.4H149c10.7 0 18.4-10.3 15.3-20.6L156 399.7c-3.2-10.8-2.6-22.4 1.9-32.7l16-37.3c2.5-5.9 8.3-9.7 14.7-9.7H306.7c7.8 0 14.5 5.7 15.8 13.4l16.9 101.3c1.3 7.7 8 13.4 15.8 13.4h23.1c9.9 0 17.4-8.9 15.8-18.6L374.2 310.7c-1-5.8 1.3-11.6 5.9-15.2c42.5-33.4 112.3-71.5 187.8-78.4c11.5-1.1 21.7-5.3 28.7-12.4c7.2-7.2 11.3-17.1 11.3-27.3v-2.2c0-2.4-.2-4.8-.6-7.2H511.6c.3 1.3 .4 2.6 .4 4c0 11-9 20-20 20s-20-9-20-20c0-1.3 .1-2.6 .4-3.9c-36.5 1-72.3 10.3-104.8 27.3L282 240.2c-19.8 10.3-41.7 15.8-64 15.8h-2c-68.3 0-124.9-50.4-134.5-116C52 156.4 32 187.9 32 224zM75.7 340.9C58.9 333.3 44 322.3 32 308.7V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V224C0 153.3 57.3 96 128 96H324.2c21 0 41.8-4.9 60.6-14.3C408.1 70.1 433.8 64 459.8 64h2.4c24.5 0 48.8 5.1 71.2 14.9l61.1 26.7C622.1 117.7 640 145 640 175.2v2.2c0 18.7-7.4 36.7-20.7 49.9c-12.1 12.1-27.6 18.7-43.3 21.1V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V252.9c-53.3 10.6-102.6 36.9-136.6 62.1l18.2 109.1c4.9 29.3-17.7 55.9-47.3 55.9H355.1c-23.5 0-43.5-17-47.3-40.1L293.1 352h-94l-11.8 27.6c-1.5 3.4-1.7 7.3-.6 10.9l8.3 27.7c9.2 30.8-13.8 61.8-46 61.8H127.8c-21.2 0-39.9-13.9-46-34.2L68.7 402.1c-3.5-11.7-3.6-24.2-.2-36l7.2-25.2z"]
};
var faH4 = {
  prefix: 'fal',
  iconName: 'h4',
  icon: [640, 512, [], "f86a", "M447.7 83L411.4 272H608V80c0-8.8 7.2-16 16-16s16 7.2 16 16V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V304H392c-4.8 0-9.3-2.1-12.3-5.8s-4.3-8.5-3.4-13.2l40-208c1.7-8.7 10.1-14.4 18.7-12.7s14.4 10.1 12.7 18.7zM16 64c8.8 0 16 7.2 16 16V240H288V80c0-8.8 7.2-16 16-16s16 7.2 16 16V256 432c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H32V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V256 80c0-8.8 7.2-16 16-16z"]
};
var faStoreSlash = {
  prefix: 'fal',
  iconName: 'store-slash',
  icon: [640, 512, [], "e071", "M544 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v54l32 25.3V272zM385.1 224c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-.7 1.1 25.3 19.9 1.3-2.1H496.4l56.2 88.9 0 0c18.7 29.6 .3 66.6-29.2 70.6c-2.6 .3-5.2 .5-7.9 .5c-16.5 0-31.2-7.2-41.5-18.5c-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5c-4 0-7.9 .8-11.6 2.2L382.7 224c.8 0 1.6 0 2.3 0zm-220.9-9.5l-29.7-23.4c-3.3 .6-6.7 .9-10.1 .9c-2.6 0-5.2-.2-7.9-.5c-20.7-2.8-35.9-22.1-36.6-43.5l-29-22.9c-12 43.2 14 91.7 61.3 98.1c4 .5 8.1 .8 12.1 .8c14.4 0 27.9-3.5 39.8-9.5zM378.8 384l-40.5-32H128V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v80 16 16 64c0 35.3 28.7 64 64 64H480c15.9 0 30.4-5.8 41.6-15.3L495.4 476c-4.6 2.5-9.8 4-15.4 4H160c-17.7 0-32-14.3-32-32V384H378.8zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faRoadCircleXmark = {
  prefix: 'fal',
  iconName: 'road-circle-xmark',
  icon: [640, 512, [], "e566", "M157.5 74c9.2-25.2 33.2-42 60.1-42H422.4c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7c-1.5 0-2.9 0-4.4 .1L452.5 85c-4.6-12.6-16.6-21-30.1-21H336v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H217.6c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43H339.2c5.9 11.4 12.9 22.2 21 32H100.6c-44.5 0-75.4-44.2-60.1-86L157.5 74zM336 208v86.6c-3.5 7.6-6.5 15.6-8.9 23.8c-2.1 1.1-4.6 1.7-7.1 1.7c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
var faSignalSlash = {
  prefix: 'fal',
  iconName: 'signal-slash',
  icon: [640, 512, [], "f695", "M592 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V363.9l32 25.3V16zM432 496c0 8.8 7.2 16 16 16s16-7.2 16-16V451.2L432 426v70zm32-384c0-8.8-7.2-16-16-16s-16 7.2-16 16V262.9l32 25.3V112zM304 324.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V350.2l-32-25.3zM192 288c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400c0-8.8-7.2-16-16-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faUserMinus = {
  prefix: 'fal',
  iconName: 'user-minus',
  icon: [640, 512, [], "f503", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zM432 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"]
};
var faMarsStrokeUp = {
  prefix: 'fal',
  iconName: 'mars-stroke-up',
  icon: [320, 512, [9896, "mars-stroke-v"], "f22a", "M171.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 54.6V128H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32.8C63.1 200.8 0 269 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-83-63.1-151.2-144-159.2V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V54.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64zM160 480a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
var faMarsStrokeV = faMarsStrokeUp;
var faChampagneGlasses = {
  prefix: 'fal',
  iconName: 'champagne-glasses',
  icon: [640, 512, [129346, "glass-cheers"], "f79f", "M98.1 186.2C73.2 233.5 95.7 292 146 310.3s105.1-12 116.5-64.3l10.9-50.1L122 140.8 98.1 186.2zm182.1-21.9l19.2-88.6L179.3 32 137 112.2l143.2 52.1zm-210.4 7L150.9 17.1c7.5-14.2 24.2-20.6 39.3-15.2L310.4 45.7c3.6 1.3 6.8 3.2 9.6 5.6c2.8-2.4 6-4.3 9.6-5.6L449.8 1.9c15-5.5 31.8 1 39.3 15.2l81.2 154.2c31.4 59.7 7.4 132.3-50.6 162.6l42 115.4 56.9-20.7c8.3-3 17.5 1.3 20.5 9.6s-1.3 17.5-9.6 20.5l-71.9 26.2L485.6 511c-8.3 3-17.5-1.3-20.5-9.6s1.3-17.5 9.6-20.5l56.9-20.7-42-115.4c-63.9 14.1-129-26.1-143.3-92L320 131.8l-26.2 121c-14.3 65.9-79.4 106.2-143.3 92l-42 115.4L165.4 481c8.3 3 12.6 12.2 9.6 20.5s-12.2 12.6-20.5 9.6L82.5 484.9 10.5 458.7c-8.3-3-12.6-12.2-9.6-20.5s12.2-12.6 20.5-9.6l56.9 20.7 42-115.4c-58-30.3-82-102.9-50.6-162.6zm472.1 14.9L518 140.8 366.6 195.9 377.5 246c11.3 52.3 66.2 82.5 116.5 64.3s72.8-76.7 47.9-124.1zM359.8 164.3L503 112.2 460.7 32 340.6 75.7l19.2 88.6z"]
};
var faGlassCheers = faChampagneGlasses;
var faTaco = {
  prefix: 'fal',
  iconName: 'taco',
  icon: [512, 512, [127790], "f826", "M257.1 61.2l44.1 34.2 17-22-17 22c10.9 8.5 24.4 12.8 38.2 12.4l55.8-1.7c.8 0 1.6 .5 1.8 1.3l15.6 53.6c3.9 13.3 12.2 24.8 23.6 32.5l46.1 31.4c.7 .5 1 1.4 .7 2.1c-1.4 3.8-3.4 8.3-6.3 14.8c-1.9 4.2-4.1 9.1-6.2 14.2c7.6 8.5 14.6 17.4 21.2 26.7c2.7-10 7.3-20.3 11.5-29.7c2.6-5.8 5.1-11.3 6.8-16.2c4.7-13.1 0-27.8-11.6-35.7l-46.1-31.4c-5.9-4-10.2-9.9-12.2-16.8L424.7 99.3c-3.9-13.4-16.4-22.5-30.4-22.1L338.6 79c-7.1 .2-14.1-2-19.7-6.4L274.8 38.4c-11-8.6-26.5-8.6-37.5 0L193.1 72.6c-5.6 4.4-12.6 6.6-19.7 6.4l-55.8-1.7c-14-.4-26.5 8.6-30.4 22.1L71.7 152.9c-2 6.8-6.3 12.8-12.2 16.8L13.4 201C1.9 208.9-2.9 223.6 1.8 236.7C3.6 241.6 6 247.1 8.7 253c4.2 9.4 8.8 19.6 11.5 29.7c6.5-9.3 13.6-18.2 21.2-26.7c-2.1-5.1-4.3-10-6.2-14.2c-2.9-6.5-4.9-11-6.3-14.8c-.3-.8 0-1.7 .7-2.1l46.1-31.4c11.4-7.8 19.8-19.3 23.6-32.5L115 107.4c.2-.8 1-1.3 1.8-1.3l55.8 1.7c13.8 .4 27.3-4 38.2-12.4l44.1-34.2c.7-.5 1.6-.5 2.2 0zM256 224c123.7 0 224 100.3 224 224H32c0-123.7 100.3-224 224-224zM32 480H480c17.7 0 32-14.3 32-32c0-141.4-114.6-256-256-256S0 306.6 0 448c0 17.7 14.3 32 32 32zm80-96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faHexagonPlus = {
  prefix: 'fal',
  iconName: 'hexagon-plus',
  icon: [512, 512, ["plus-hexagon"], "f300", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM240 352V272H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faPlusHexagon = faHexagonPlus;
var faClipboard = {
  prefix: 'fal',
  iconName: 'clipboard',
  icon: [384, 512, [128203], "f328", "M192 32c-22.3 0-41.2 15.3-46.5 36c-1.8 7.1-8.2 12-15.5 12H112c-8.8 0-16 7.2-16 16v32h96 96V96c0-8.8-7.2-16-16-16H254c-7.3 0-13.7-4.9-15.5-12c-5.3-20.7-24.1-36-46.5-36zM118.7 48C131 19.8 159.2 0 192 0s61 19.8 73.3 48H272c20.9 0 38.7 13.4 45.3 32H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V144c0-35.3 28.7-64 64-64h2.7C73.3 61.4 91.1 48 112 48h6.7zM320 128c0 17.7-14.3 32-32 32H192 96c-17.7 0-32-14.3-32-32V112c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32v16zM192 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faHouseCircleExclamation = {
  prefix: 'fal',
  iconName: 'house-circle-exclamation',
  icon: [640, 512, [], "e50a", "M277.4 4c6-5.3 15.1-5.3 21.2 0L512.5 192.8c-5.4-.5-10.9-.8-16.5-.8c-10.2 0-20.2 .9-29.9 2.5L288 37.3 96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c1 0 2.1 .1 3.1 .1c-5.1 10.1-9.3 20.7-12.5 31.9H240V480h16 80 24.2c10 12.1 21.7 22.9 34.6 32H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faFileArrowUp = {
  prefix: 'fal',
  iconName: 'file-arrow-up',
  icon: [384, 512, ["file-upload"], "f574", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 278.6V400c0 8.8 7.2 16 16 16s16-7.2 16-16V278.6z"]
};
var faFileUpload = faFileArrowUp;
var faWifi = {
  prefix: 'fal',
  iconName: 'wifi',
  icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M27.3 184.4C102.4 110 205.8 64 320 64s217.6 46 292.7 120.4c6.3 6.2 16.4 6.2 22.6-.1s6.2-16.4-.1-22.6C554.3 81.5 442.9 32 320 32S85.7 81.5 4.7 161.7c-6.3 6.2-6.3 16.3-.1 22.6s16.3 6.3 22.6 .1zM320 224c70.5 0 134.4 28.5 180.7 74.7c6.3 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-52.1-51.9-123.9-84-203.3-84s-151.2 32.1-203.3 84c-6.3 6.2-6.3 16.4 0 22.6s16.4 6.3 22.6 0C185.6 252.5 249.5 224 320 224zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faWifi3 = faWifi;
var faWifiStrong = faWifi;
var faMessages = {
  prefix: 'fal',
  iconName: 'messages',
  icon: [640, 512, ["comments-alt"], "f4b6", "M202.7 288H352c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V256c0 17.7 14.3 32 32 32H96c17.7 0 32 14.3 32 32v16l55.5-41.6c5.5-4.2 12.3-6.4 19.2-6.4zM352 320H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V352 320H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64zM320 448c-35.3 0-64-28.7-64-64V352h32v32c0 17.7 14.3 32 32 32H437.3c6.9 0 13.7 2.2 19.2 6.4L512 464V448c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H448V128H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H544v32 16c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320z"]
};
var faCommentsAlt = faMessages;
var faBath = {
  prefix: 'fal',
  iconName: 'bath',
  icon: [512, 512, [128705, "bathtub"], "f2cd", "M93.3 32C77.1 32 64 45.1 64 61.3V256H448h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480 448 64 32 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V61.3C32 27.4 59.4 0 93.3 0c16.2 0 31.8 6.5 43.3 17.9L161.7 43c11.1-7 24.2-11 38.3-11c20.2 0 38.5 8.3 51.6 21.8l1.1-1.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-104 104c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.1-1.1C136.3 142.5 128 124.2 128 104c0-14.1 4-27.2 11-38.3L113.9 40.6C108.5 35.1 101 32 93.3 32zM32 320H64v48c0 26.2 12.6 49.4 32 64h0v0c13.4 10 30 16 48 16H368c18 0 34.6-6 48-16v0h0c19.4-14.6 32-37.8 32-64V320h32v48c0 30.5-12.2 58.2-32 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V469.2c-14.5 6.9-30.8 10.8-48 10.8H144c-17.2 0-33.5-3.9-48-10.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V446.4C44.2 426.2 32 398.5 32 368V320zM200 64c-22.1 0-40 17.9-40 40c0 11.4 4.8 21.7 12.4 29L229 76.4C221.7 68.8 211.4 64 200 64z"]
};
var faBathtub = faBath;
var faUmbrellaSimple = {
  prefix: 'fal',
  iconName: 'umbrella-simple',
  icon: [512, 512, ["umbrella-alt"], "e2bc", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32.5C116.7 40.1 17 134.9 2 256.1C-.2 273.6 14.3 288 32 288H480c17.7 0 32.2-14.4 30-31.9C495 134.9 395.3 40.1 272 32.5V16zm0 430.6V320H240V446.6c0 18.5-15 33.4-33.4 33.4c-12.7 0-24.2-7.2-29.9-18.5l-2.3-4.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l2.3 4.7C159.1 498 181.8 512 206.6 512c36.1 0 65.4-29.3 65.4-65.4zM256 64c112.8 0 206.2 83.5 221.7 192H34.3C49.8 147.5 143.2 64 256 64z"]
};
var faUmbrellaAlt = faUmbrellaSimple;
var faRectangleHistoryCirclePlus = {
  prefix: 'fal',
  iconName: 'rectangle-history-circle-plus',
  icon: [640, 512, [], "e4a3", "M480 192v.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7V192c0-35.3-28.7-64-64-64L64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64l330.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32zM448 64L64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM400 0H112c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"]
};
var faUnderline = {
  prefix: 'fal',
  iconName: 'underline',
  icon: [448, 512, [], "f0cd", "M0 48c0-8.8 7.2-16 16-16H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H96V224c0 70.7 57.3 128 128 128s128-57.3 128-128V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V64H16C7.2 64 0 56.8 0 48zM0 464c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faPrescriptionBottlePill = {
  prefix: 'fal',
  iconName: 'prescription-bottle-pill',
  icon: [576, 512, [], "e5c0", "M336 32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H336zM48 0C21.5 0 0 21.5 0 48V80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM32 160V448c0 35.3 28.7 64 64 64H288c11.6 0 22.4-3.1 31.8-8.4c-8.9-7.3-17-15.5-24.3-24.5c-2.4 .6-4.9 .9-7.5 .9H96c-17.7 0-32-14.3-32-32V416h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V320h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V224h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V160H32zm320 0H320v72.2c9.8-8.1 20.6-15.2 32-21V160zm80 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm36.7-84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96z"]
};
var faUserPen = {
  prefix: 'fal',
  iconName: 'user-pen',
  icon: [640, 512, ["user-edit"], "f4ff", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480H322.2l-1 3.8c-2.4 9.5-1.8 19.3 1.4 28.2H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c44.2 0 84.6 16.1 115.8 42.7l-22.7 22.7c-25.3-20.9-57.7-33.4-93.1-33.4H178.3c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM582.8 264c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L600.2 304c6.2-6.2 6.2-16.4 0-22.6L582.8 264zM406.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L552.7 351.4l-40-40L406.5 417.7zM537.5 241.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L469.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L537.5 241.4z"]
};
var faUserEdit = faUserPen;
var faBinarySlash = {
  prefix: 'fal',
  iconName: 'binary-slash',
  icon: [640, 512, [], "e33e", "M448 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192H368c-6.3 0-11.8 3.7-14.4 9l29.1 23H432h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V16zM320 144V80c0-44.2-35.8-80-80-80H208c-27.2 0-51.2 13.5-65.6 34.2l25.2 19.9C176.1 40.8 191 32 208 32h32c26.5 0 48 21.5 48 48v64c0 1.7-.1 3.4-.3 5l27.6 21.8c3-8.4 4.6-17.4 4.6-26.8zm0 224v64c0 44.2 35.8 80 80 80h32c27.2 0 51.2-13.5 65.6-34.2l-25.2-19.9C463.9 471.2 449 480 432 480H400c-26.5 0-48-21.5-48-48V368c0-1.7 .1-3.4 .3-5l-27.6-21.8c-3 8.4-4.6 17.4-4.6 26.8zm-96-64c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V304zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faSquareO = {
  prefix: 'fal',
  iconName: 'square-o',
  icon: [448, 512, [], "e278", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
var faSignature = {
  prefix: 'fal',
  iconName: 'signature',
  icon: [640, 512, [], "f5b7", "M160 128c0-35.3 28.7-64 64-64s64 28.7 64 64v3.4c0 26.2-2.4 52.3-7.2 78L155 243.7c-34.8 9.5-59 41.1-59 77.2v92.6c0 36.7 29.8 66.5 66.5 66.5c24 0 46.2-13 57.9-33.9L247.5 398c20.9-37.1 37.2-76.5 48.5-117.5l7.2-25.7c1.8-6.5 3.5-13 5-19.6l125.5-34.2-48 96c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H425.9l52.4-104.8c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3L314.8 200.1c3.4-22.7 5.2-45.7 5.2-68.7V128c0-53-43-96-96-96s-96 43-96 96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V128zm3.4 146.6l109.4-29.8-.4 1.4-7.2 25.7c-10.7 38.5-26 75.6-45.6 110.4l-27.1 48.1c-6.1 10.9-17.6 17.6-30.1 17.6c-19 0-34.5-15.4-34.5-34.5V320.9c0-21.6 14.5-40.6 35.4-46.3zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H48c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm320 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H336z"]
};
var faStroopwafel = {
  prefix: 'fal',
  iconName: 'stroopwafel',
  icon: [512, 512, [], "f551", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM142.9 120.2l45.3 45.3 45.3-45.3L210.7 97.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 97.6 278.6 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 45.3-45.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-45.3 45.3 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414.4 256 437 278.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 45.3 45.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-45.3-45.3-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 414.4 233.4 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3-45.3 45.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l45.3-45.3-45.3-45.3L97.6 301.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.6 256 75 233.4c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l22.6 22.6 45.3-45.3-45.3-45.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm45.3 90.5L142.9 256l45.3 45.3L233.4 256l-45.3-45.3zm181 45.3l-45.3-45.3L278.6 256l45.3 45.3L369.1 256zm-67.9 67.9L256 278.6l-45.3 45.3L256 369.1l45.3-45.3zM210.7 188.1L256 233.4l45.3-45.3L256 142.9l-45.3 45.3z"]
};
var faBold = {
  prefix: 'fal',
  iconName: 'bold',
  icon: [384, 512, [], "f032", "M0 48c0-8.8 7.2-16 16-16H48 80 232c66.3 0 120 53.7 120 120c0 38.8-18.4 73.3-46.9 95.2C351.1 264 384 308.1 384 360c0 66.3-53.7 120-120 120H80 48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V256 64H16C7.2 64 0 56.8 0 48zM64 448H80 264c48.6 0 88-39.4 88-88s-39.4-88-88-88H232 64V448zm0-208H232c48.6 0 88-39.4 88-88s-39.4-88-88-88H80 64V240z"]
};
var faAnchorLock = {
  prefix: 'fal',
  iconName: 'anchor-lock',
  icon: [640, 512, [], "e4ad", "M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V480H240c-79.5 0-144-64.5-144-144V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h48 48c18.3 0 36-2.8 52.6-8c-3-7.4-4.6-15.5-4.6-24v-8.2c-15 5.3-31.2 8.2-48 8.2H304V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faBuildingNgo = {
  prefix: 'fal',
  iconName: 'building-ngo',
  icon: [384, 512, [], "e4d7", "M320 32H64c-11.8 0-22.2 6.4-27.7 16H2C9.1 20.4 34.2 0 64 0H320c29.8 0 54.9 20.4 62 48H347.7c-5.5-9.6-15.9-16-27.7-16zM0 240H32V448c0 17.7 14.3 32 32 32h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V240h32V448c0 35.3-28.7 64-64 64H256 224 160 128 64c-35.3 0-64-28.7-64-64V240zM192 384c-17.7 0-32 14.3-32 32v64h64V416c0-17.7-14.3-32-32-32zM168 80h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V160c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V96c0-8.8 7.2-16 16-16zm136 32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V128zM61.3 87.1l34.7 52V96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 148.8V192c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM208 264c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H232c-13.3 0-24-10.7-24-24V264zm32 8v32h32V272H240zM104 240h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V264c0-13.3 10.7-24 24-24zm8 64h32V272H112v32z"]
};
var faTransporter3 = {
  prefix: 'fal',
  iconName: 'transporter-3',
  icon: [512, 512, [], "e045", "M480 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V80c0 8.8 7.2 16 16 16s16-7.2 16-16V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V16zM64 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V160H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V112zM256 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 256 0a56 56 0 1 0 0 112zM144 448c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16s7.2-16 16-16H368c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H144zm16-304c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16H400c8.8 0 16-7.1 16-15.9l0-.1 0-.1c0-8.8-7.2-15.9-16-15.9H112c-8.8 0-16 7.2-16 16zm64 64c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
};
var faEngineWarning = {
  prefix: 'fal',
  iconName: 'engine-warning',
  icon: [640, 512, ["engine-exclamation"], "f5f2", "M416 80c0 8.8-7.2 16-16 16l-80 0v32h16 60.6c12.6 0 25 3.7 35.5 10.7L483.5 173c17.8 11.9 28.5 31.9 28.5 53.3V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H144c-26.5 0-48-21.5-48-48V272H88 32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80H88h8V176c0-26.5 21.5-48 48-48h16H288V96l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H400c8.8 0 16 7.2 16 16zM304 160H160 144c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16h28.8c9.7 0 18.9 4.4 25 12l32 40c6.1 7.6 15.3 12 25 12H448c17.7 0 32-14.3 32-32V226.3c0-10.7-5.3-20.7-14.2-26.6l-51.4-34.3c-5.3-3.5-11.4-5.4-17.8-5.4H336 304l0 0 0 0zm16 48v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zM304 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM576 224V416h32V224H576zm-32 0c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224z"]
};
var faEngineExclamation = faEngineWarning;
var faCircleDownRight = {
  prefix: 'fal',
  iconName: 'circle-down-right',
  icon: [512, 512, [], "e108", "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm80 328c0 4.4-3.6 8-8 8H214.6c-3.7 0-6.6-3-6.6-6.6c0-1.8 .7-3.4 1.9-4.7l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6l-59.1-59.1c-3.6-3.6-4.9-9-3.3-13.9c.7-2 1.8-3.8 3.3-5.3l22.1-22.1c1.5-1.5 3.3-2.6 5.3-3.3c4.9-1.6 10.3-.4 13.9 3.3l59.1 59.1c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c1.2-1.2 2.9-1.9 4.7-1.9c3.7 0 6.6 3 6.6 6.6V328zm-8 40c22.1 0 40-17.9 40-40V214.6c0-21.3-17.3-38.6-38.6-38.6c-10.2 0-20.1 4.1-27.3 11.3L288 201.4l-47.7-47.7c-12.2-12.2-30.3-16.5-46.7-11c-6.7 2.2-12.8 6-17.8 11l-22.1 22.1c-5 5-8.8 11.1-11 17.8c-5.5 16.4-1.2 34.5 11 46.7L201.4 288l-14.1 14.1c-7.2 7.2-11.3 17.1-11.3 27.3c0 21.3 17.3 38.6 38.6 38.6H328z"]
};
var faSquareK = {
  prefix: 'fal',
  iconName: 'square-k',
  icon: [448, 512, [], "e274", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm315.1 59.5l-87.3 84.3 89 118.6c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L204.6 262.2 160 305.3V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V298.5 144c0-8.8 7.2-16 16-16s16 7.2 16 16V260.8L292.9 132.5c6.4-6.1 16.5-6 22.6 .4s6 16.5-.4 22.6z"]
};
var faManatSign = {
  prefix: 'fal',
  iconName: 'manat-sign',
  icon: [384, 512, [], "e1d5", "M192 32c-8.8 0-16 7.2-16 16V96.7C77.4 104.8 0 187.3 0 288V464c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-83 63.1-151.2 144-159.2V464c0 8.8 7.2 16 16 16s16-7.2 16-16V128.8c80.9 8 144 76.2 144 159.2V464c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-100.7-77.4-183.2-176-191.3V48c0-8.8-7.2-16-16-16z"]
};
var faMoneyCheckPen = {
  prefix: 'fal',
  iconName: 'money-check-pen',
  icon: [640, 512, ["money-check-edit"], "f872", "M64 96H512c17.7 0 32 14.3 32 32v69.6c10.2-4 21.1-5.9 32-5.6V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H330.2l8-32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm48 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM96 208c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm486.8 56l17.4 17.4c6.2 6.2 6.2 16.4 0 22.6l-24.8 24.8-40-40L560.2 264c6.2-6.2 16.4-6.2 22.6 0zM406.5 417.7L512.7 311.5l40 40L446.4 457.7c-2.1 2.1-4.6 3.5-7.4 4.2l-49 12.3 12.3-49c.7-2.8 2.2-5.4 4.2-7.4zM537.5 241.4L383.8 395.1c-6.2 6.2-10.5 13.9-12.6 22.3l-18.7 74.9c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2L446.8 493c8.4-2.1 16.1-6.5 22.3-12.6L622.8 326.6c18.7-18.7 18.7-49.1 0-67.9l-17.4-17.4c-18.7-18.7-49.1-18.7-67.9 0z"]
};
var faMoneyCheckEdit = faMoneyCheckPen;
var faNotEqual = {
  prefix: 'fal',
  iconName: 'not-equal',
  icon: [448, 512, [], "f53e", "M377.1 34.8c7.3 5 9.1 15 4 22.3L321 144h95c8.8 0 16 7.2 16 16s-7.2 16-16 16H298.8L188.1 336H416c8.8 0 16 7.2 16 16s-7.2 16-16 16H165.9L93.2 473.1c-5 7.3-15 9.1-22.3 4s-9.1-15-4-22.3L127 368H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H149.2L259.9 176H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H282.1L354.8 38.9c5-7.3 15-9.1 22.3-4z"]
};
var faBorderTopLeft = {
  prefix: 'fal',
  iconName: 'border-top-left',
  icon: [448, 512, ["border-style"], "f853", "M0 448c0 8.8 7.2 16 16 16s16-7.2 16-16L32 96c0-17.7 14.3-32 32-32l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32C28.7 32 0 60.7 0 96L0 448zm128-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm-96 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-144a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBorderStyle = faBorderTopLeft;
var faMapLocationDot = {
  prefix: 'fal',
  iconName: 'map-location-dot',
  icon: [576, 512, ["map-marked-alt"], "f5a0", "M366.6 155c6.7-15.9 9.4-27.6 9.4-35c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 7.4 2.7 19 9.4 35c6.5 15.4 15.7 32.4 26.4 49.7c17.1 27.8 36.9 54.7 52.2 74.4c15.3-19.7 35.1-46.6 52.2-74.4c10.7-17.3 19.9-34.3 26.4-49.7zM302.8 312c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120c0 54.6-73.1 151.9-105.2 192zm103.1-89.1c-.8 .3-1.7 .6-2.5 .8c8.2-14.2 15.7-28.7 21.8-42.9l117.9-47.2c15.8-6.3 32.9 5.3 32.9 22.3V426.6c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 448.9l-144 57.6C17.1 512.8 0 501.2 0 484.2V213.4c0-9.8 6-18.6 15.1-22.3l123.2-49.3c2.1 10.4 5.4 20.8 9.2 30.8L32 218.8V472.4l128-51.2V304c0-8.8 7.2-16 16-16s16 7.2 16 16V419.9l192 54.9V304c0-8.8 7.2-16 16-16s16 7.2 16 16V472.4l128-51.2V167.6L405.9 222.9zM288 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faMapMarkedAlt = faMapLocationDot;
var faTilde = {
  prefix: 'fal',
  iconName: 'tilde',
  icon: [448, 512, [63135], "7e", "M96.8 160C61.2 160 32 188.8 32 224v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-53.2 43.9-96 96.8-96c29.4 0 57.6 13.5 75.9 36.7l128 162.8c12.1 15.4 31 24.5 50.7 24.5c35.5 0 64.8-28.8 64.8-64V192c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 53.2-43.9 96-96.8 96c-29.4 0-57.6-13.5-75.9-36.7l-128-162.9c-12.1-15.4-31-24.5-50.7-24.5z"]
};
var faJedi = {
  prefix: 'fal',
  iconName: 'jedi',
  icon: [576, 512, [], "f669", "M288 0c8.8 0 16 7.2 16 16V280.9l36.1-24.1c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1l-23.9 35.8 42.2 8.4c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8l-42.2 8.4 23.9 35.8c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1L304 359.1v71.7c54.3-7.8 96-54.4 96-110.9c0-36.2-17.1-68.3-43.8-88.8c-4.2-3.2-6.5-8.3-6.2-13.6s3.2-10.1 7.8-12.8C397.5 181 424 137.6 424 88c0-20.3-4.5-39.6-12.4-56.9c-3-6.5-1.3-14.1 4-18.8s13.2-5.2 19.1-1.4C510 59.3 560 143.8 560 240c0 150.2-121.8 272-272 272S16 390.2 16 240C16 143.8 66 59.3 141.3 10.9c6-3.8 13.8-3.3 19.1 1.4s7 12.3 4 18.8C156.5 48.4 152 67.7 152 88c0 49.6 26.5 93 66.2 116.8c4.5 2.7 7.4 7.5 7.8 12.8s-2 10.4-6.2 13.6C193.1 251.7 176 283.8 176 320c0 56.4 41.7 103.1 96 110.9V359.1l-36.1 24.1c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1l23.9-35.8-42.2-8.4c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l42.2-8.4-23.9-35.8c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1L272 280.9V16c0-8.8 7.2-16 16-16zM64.1 153.5l43.2 43.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L53.6 188.2c-2.2 9.9-3.8 20.1-4.7 30.5c.8 .6 1.6 1.2 2.4 2l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L49.2 263.8C61.1 385.2 163.5 480 288 480s226.9-94.8 238.8-216.2l-35.5 35.5c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l56-56c.7-.7 1.5-1.4 2.4-2c-.9-10.4-2.5-20.5-4.7-30.5l-31.1 31.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l43.2-43.2c-12.7-32.8-32.3-62.1-57.2-86.1C455.6 74.1 456 81 456 88c0 53.6-25.1 101.4-64.2 132.1C416.7 246 432 281.2 432 320c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.8 15.3-74 40.2-99.9C145.1 189.4 120 141.6 120 88c0-7 .4-13.9 1.3-20.6c-24.8 24-44.5 53.3-57.2 86.1z"]
};
var faSquarePollVertical = {
  prefix: 'fal',
  iconName: 'square-poll-vertical',
  icon: [448, 512, ["poll"], "f681", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 224c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zM320 288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faPoll = faSquarePollVertical;
var faArrowDownSquareTriangle = {
  prefix: 'fal',
  iconName: 'arrow-down-square-triangle',
  icon: [576, 512, ["sort-shapes-down-alt"], "f889", "M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v96zm64 147.5L341.3 448H490.7L416 323.5zM320 176V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48zM307.6 442l84.2-140.3c5.1-8.5 14.3-13.7 24.2-13.7s19.1 5.2 24.2 13.7L524.4 442c2.3 3.9 3.6 8.4 3.6 12.9c0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9z"]
};
var faSortShapesDownAlt = faArrowDownSquareTriangle;
var faMugHot = {
  prefix: 'fal',
  iconName: 'mug-hot',
  icon: [512, 512, [9749], "f7b6", "M80 0C71.2 0 64 7.2 64 16c0 24.7 9.8 48.5 27.3 65.9l18.7 18.7C121.5 112.2 128 127.8 128 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.7-9.8-48.5-27.3-65.9L113.9 59.3C102.5 47.8 96 32.2 96 16C96 7.2 88.8 0 80 0zM32 224H336h16V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V224zm352 0h16c44.2 0 80 35.8 80 80s-35.8 80-80 80H384V224zm0 192h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 336 32c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96zM224 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 24.7 9.8 48.5 27.3 65.9l18.7 18.7C249.5 112.2 256 127.8 256 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.7-9.8-48.5-27.3-65.9L241.9 59.3C230.5 47.8 224 32.2 224 16z"]
};
var faDogLeashed = {
  prefix: 'fal',
  iconName: 'dog-leashed',
  icon: [576, 512, [129454], "f6d4", "M67.4 6.1C72.9-.8 82.9-2 89.9 3.4L307 174 331.9 24.8C334.2 10.5 346.6 0 361.2 0c9.3 0 18.1 4.4 23.8 11.9L400 32h44.1c12.7 0 24.9 5.1 33.9 14.1L496 64h32c26.5 0 48 21.5 48 48v16c0 53-43 96-96 96H437.3L432 256V456c0 30.9-25.1 56-56 56H360c-30.9 0-56-25.1-56-56V408.7 375.3c-10.3 3.3-21 5.7-32 7.1c-7.9 1-15.9 1.6-24 1.6s-16.1-.5-24-1.6c-11-1.4-21.7-3.8-32-7.1v33.3V456c0 30.9-25.1 56-56 56H120c-30.9 0-56-25.1-56-56V208c0-.7 0-1.4 .1-2c-.7-.2-1.4-.3-2.1-.5c-27.9-7.2-50.3-29.1-57.6-58.1L.5 131.9c-2.1-8.6 3.1-17.3 11.6-19.4s17.3 3.1 19.4 11.6l3.9 15.5c.3 1.4 .8 2.7 1.2 4.1c2 5.8 5.1 11.1 9 15.6C54.5 169.7 67.6 176 82 176H96h40 24 97.7L70.1 28.6C63.2 23.1 62 13.1 67.4 6.1zM322.9 349.5c8.2 6 13.1 15.6 13.1 25.8V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V261.9l-.1 0L307.6 208c-.3 0-.7 0-1 0H288V346.7c2.1-.6 4.2-1.2 6.3-1.9c9.7-3.1 20.4-1.4 28.6 4.6zM256 351.8V208H160 136 96V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V375.3c0-10.2 4.9-19.8 13.1-25.8s18.9-7.8 28.6-4.6c14.5 4.6 30.1 7.2 46.3 7.2c2.7 0 5.4-.1 8-.2zM405.8 218.7c2.6-15.4 15.9-26.7 31.6-26.7H480c35.3 0 64-28.7 64-64V112c0-8.8-7.2-16-16-16H496c-8.5 0-16.6-3.4-22.6-9.4L455.4 68.7c-3-3-7.1-4.7-11.3-4.7H400c-10.1 0-19.6-4.7-25.6-12.8L362.5 35.4 338.2 181.3c-.4 2.3-1 4.4-1.8 6.5l67.9 39.6 1.4-8.6zM432 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faCarBattery = {
  prefix: 'fal',
  iconName: 'car-battery',
  icon: [512, 512, ["battery-car"], "f5df", "M64 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm256 0c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16zM64 160c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H64zM0 192c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm368 16c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V224c0-8.8 7.2-16 16-16zM96 256h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBatteryCar = faCarBattery;
var faFaceDowncastSweat = {
  prefix: 'fal',
  iconName: 'face-downcast-sweat',
  icon: [512, 512, [], "e371", "M79.8 68.6c5.4 8.5 9.8 16.4 12.8 23.1c2.6 5.8 3.2 8.8 3.4 9.6c0 .2 0 .2 0 .1C96 113.5 84.3 128 64 128s-32-14.5-32-26.7c0 .1 0 .1 0-.1c.2-.7 .8-3.7 3.4-9.5c3-6.7 7.4-14.6 12.8-23.1c5-7.9 10.5-15.8 15.8-23c5.3 7.2 10.8 15.1 15.8 23zM72.5 4.1c-4.3-5.5-12.8-5.5-17.1 0C38.1 25.8 0 76.3 0 101.3C0 133.8 28.7 160 64 160s64-26.2 64-58.7c0-25-37.9-75.5-55.5-97.2zM256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224S32 379.7 32 256c0-20.7 2.8-40.7 8.1-59.7c2.4-8.5-2.6-17.3-11.2-19.7s-17.3 2.6-19.7 11.2C3.2 209.5 0 232.4 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0c-43.1 0-83.8 10.7-119.5 29.5c-7.8 4.1-10.8 13.8-6.7 21.6S143.7 62 151.5 57.8C182.7 41.3 218.2 32 256 32zM96 272c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm208-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zM173.3 411.9c6.6 5.9 16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2s7.1-16 1.2-22.6C323.8 371.4 295.7 352 256 352s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6z"]
};
var faMailboxFlagUp = {
  prefix: 'fal',
  iconName: 'mailbox-flag-up',
  icon: [576, 512, [], "e5bb", "M352 208V112 56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24l-72 0v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zM448 96V64l-64 0V96l64 0zM320 64V96H234.5c32.6 26.4 53.5 66.8 53.5 112V384c0 11.7-3.1 22.6-8.6 32H512c17.7 0 32-14.3 32-32V208c0-32.7-14-62-36.3-82.5c2.7-6.6 4.3-13.9 4.3-21.5V88.2c38.6 25.8 64 69.8 64 119.8V384c0 35.3-28.7 64-64 64H224 64c-35.3 0-64-28.7-64-64V208C0 128.5 64.5 64 144 64H320zM224 416c17.7 0 32-14.3 32-32V208c0-61.9-50.1-112-112-112S32 146.1 32 208V384c0 17.7 14.3 32 32 32H224zM96 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16z"]
};
var faMemoCircleInfo = {
  prefix: 'fal',
  iconName: 'memo-circle-info',
  icon: [576, 512, [], "e49a", "M320 32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6c-11.2 3.2-21.9 7.4-32 12.6V64c0-17.7-14.3-32-32-32zM64 144c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 80H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm464 48a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-32 96c0-8.8 7.2-16 16-16V384c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h0c8.8 0 16 7.2 16 16s-7.2 16-16 16H432 416c-8.8 0-16-7.2-16-16z"]
};
var faGift = {
  prefix: 'fal',
  iconName: 'gift',
  icon: [512, 512, [127873], "f06b", "M365.1 32c-17.6 0-33.9 9-43.2 23.9l-45 72.1H288h80c26.5 0 48-21.5 48-48s-21.5-48-48-48h-2.9zm-130 96l-45-72.1C180.8 41 164.5 32 146.9 32H144c-26.5 0-48 21.5-48 48s21.5 48 48 48h80 11.1zM256 101l38.8-62c15.2-24.2 41.7-39 70.3-39H368c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h32c26.5 0 48 21.5 48 48v64c0 20.9-13.4 38.7-32 45.3V288 448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288v-2.7C13.4 278.7 0 260.9 0 240V176c0-26.5 21.5-48 48-48H80C70 114.6 64 98 64 80C64 35.8 99.8 0 144 0h2.9c28.6 0 55.2 14.7 70.3 39L256 101zM144 160H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H64 240V160H224 144zm128 0v96H448h16c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368 288 272zM240 288H64V448c0 17.7 14.3 32 32 32H240V288zm32 192H416c17.7 0 32-14.3 32-32V288H272V480z"]
};
var faDiceTwo = {
  prefix: 'fal',
  iconName: 'dice-two',
  icon: [448, 512, [9857], "f528", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM320 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faVolume = {
  prefix: 'fal',
  iconName: 'volume',
  icon: [576, 512, [128265, "volume-medium"], "f6a8", "M320 66.7L183.6 188c-2.9 2.6-6.7 4-10.6 4H88c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h85c3.9 0 7.7 1.4 10.6 4L320 445.3V66.7zM302.4 39.5c5.5-4.8 12.5-7.5 19.8-7.5C338.7 32 352 45.3 352 61.8V450.2c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5l10.6-12-10.6 12L166.9 352H88c-30.9 0-56-25.1-56-56V216c0-30.9 25.1-56 56-56h78.9L302.4 39.5zM419.2 182.4c5.3-7.1 15.3-8.5 22.4-3.2C464.9 196.7 480 224.6 480 256s-15.1 59.3-38.4 76.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4C438 295.5 448 276.9 448 256s-10-39.5-25.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4zm87-74.5C548.8 143.1 576 196.4 576 256s-27.2 112.9-69.8 148.1c-6.8 5.6-16.9 4.7-22.5-2.1s-4.7-16.9 2.1-22.5C521.4 350.1 544 305.7 544 256s-22.6-94.1-58.2-123.4c-6.8-5.6-7.8-15.7-2.1-22.5s15.7-7.8 22.5-2.1z"]
};
var faVolumeMedium = faVolume;
var faTransporter5 = {
  prefix: 'fal',
  iconName: 'transporter-5',
  icon: [512, 512, [], "e2a6", "M464 0c-8.8 0-16 7.2-16 16V32H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V80c0 8.8 7.2 16 16 16s16-7.2 16-16V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V16c0-8.8-7.2-16-16-16zM48 128c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V192H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V144c0-8.8-7.2-16-16-16zM208 16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zM160 144c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm64 128c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 96c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faGaugeCircleBolt = {
  prefix: 'fal',
  iconName: 'gauge-circle-bolt',
  icon: [640, 512, [], "e496", "M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194c0-8.8 7.2-16 16-16s16 7.2 16 16l0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm191.9-81c4.3 3.7 5.4 9.9 2.6 14.9L516.4 356H552c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L475.6 380H440c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
var faCoinFront = {
  prefix: 'fal',
  iconName: 'coin-front',
  icon: [512, 512, [], "e3fc", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-416a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm16-272c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"]
};
var faFileSlash = {
  prefix: 'fal',
  iconName: 'file-slash',
  icon: [640, 512, [], "e3a7", "M512 163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-23 0-43.2 12.2-54.5 30.4L163 50.5C168.1 39.6 179.2 32 192 32H320V144c0 26.5 21.5 48 48 48H480V300.8L512 326V163.9zM160 448V211.2L128 186V448c0 35.3 28.7 64 64 64H448c23 0 43.2-12.2 54.5-30.4L477 461.5c-5.1 10.9-16.2 18.5-29 18.5H192c-17.7 0-32-14.3-32-32zM479.5 160H368c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faMessageArrowUpRight = {
  prefix: 'fal',
  iconName: 'message-arrow-up-right',
  icon: [512, 512, [], "e1dd", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM192 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L172.7 268.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 182.6V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16H192z"]
};
var faTreasureChest = {
  prefix: 'fal',
  iconName: 'treasure-chest',
  icon: [576, 512, [], "f723", "M128 64V256h64V224c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32h64V64H128zM320 384H256c-35.3 0-64-28.7-64-64V288H128V448H448V288H384v32c0 35.3-28.7 64-64 64zM96 69.5C58.7 82.6 32 118.2 32 160v96H96V69.5zM32 288V432c0 8.8 7.2 16 16 16H96V288H32zM480 448h48c8.8 0 16-7.2 16-16V288H480V448zm64-192V160c0-41.8-26.7-77.4-64-90.5V256h64zM0 160C0 89.3 57.3 32 128 32H448c70.7 0 128 57.3 128 128V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V160zm320 32H256c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zm-16 48v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChessQueen = {
  prefix: 'fal',
  iconName: 'chess-queen',
  icon: [512, 512, [9819], "f445", "M256 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 256 0a56 56 0 1 0 0 112zm-95.2 0c-14 0-24.5 10-28 21.3c-9 29.4-36.5 50.8-68.8 50.8c-12.1 0-23.4-3-33.4-8.2c-5.6-3-12.6-3.1-18.6 0c-10.1 5.4-13.5 18.2-7.5 28L97.1 352h37.7L49.3 215.1c4.8 .7 9.7 1 14.7 1c44.8 0 82.9-28.3 97.5-67.9C181.4 179.3 216.3 200 256 200s74.6-20.7 94.5-51.8c14.7 39.6 52.8 67.9 97.5 67.9c5 0 9.9-.4 14.7-1L377.1 352h37.7l92.6-148.2c5.9-9.5 2.8-22.1-7-27.6c-6.1-3.5-13.3-3.4-19.1-.3c-10 5.3-21.4 8.2-33.5 8.2c-32.4 0-59.8-21.4-68.8-50.8c-3.5-11.3-13.9-21.3-28-21.3c-11.3 0-20.6 6.6-25.4 15.2C312 151.6 285.9 168 256 168s-56-16.4-69.8-40.8c-4.8-8.6-14.1-15.2-25.4-15.2zm-31 304l252.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H103.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L129.8 416zm252.4-32H129.8c-11.1 0-21.4 5.7-27.2 15.1L69.9 451.8C66.1 458 64 465.2 64 472.6c0 21.8 17.7 39.4 39.4 39.4H408.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"]
};
var faPaintbrushFine = {
  prefix: 'fal',
  iconName: 'paintbrush-fine',
  icon: [576, 512, ["paint-brush-alt", "paint-brush-fine", "paintbrush-alt"], "f5a9", "M534.5 41.4c-12.5-12.5-32.8-12.5-45.3 0L324.6 206l45.3 45.3L534.5 86.6c12.5-12.5 12.5-32.8 0-45.3zM302 228.6l-36.6 36.6 0 0L224.6 306l45.3 45.3 4.6-4.6 0 0 36.1-36.1 36.6-36.6L302 228.6zM195.9 322.5c-6.3-1.6-13-2.5-19.9-2.5c-44.2 0-80 35.8-80 80c0 2.8 .1 5.6 .4 8.3c1.7 16.7-3 33.6-12.5 46.7C74.3 468.5 58 480 36.8 480H176c44.2 0 80-35.8 80-80c0-6.9-.9-13.5-2.5-19.9l-57.7-57.7zM557.2 109.3L286.3 380.2c1.1 6.4 1.7 13.1 1.7 19.8c0 61.9-50.1 112-112 112H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h4.8c17.6 0 29.6-18.9 27.8-36.4c-.4-3.8-.6-7.7-.6-11.6c0-61.9 50.1-112 112-112c6.7 0 13.3 .6 19.7 1.7l271-271c25-25 65.5-25 90.5 0s25 65.5 0 90.5z"]
};
var faPaintBrushAlt = faPaintbrushFine;
var faPaintBrushFine = faPaintbrushFine;
var faPaintbrushAlt = faPaintbrushFine;
var faGlasses = {
  prefix: 'fal',
  iconName: 'glasses',
  icon: [576, 512, [], "f530", "M116.8 64c-14.4 0-26.9 9.7-30.5 23.6L38.1 274.4c31-12 65-18.4 97.6-18.4c40.1 0 82.2 9.6 118.5 27.3c2.6 1.3 4.9 2.9 7 4.7h53.7c2.1-1.8 4.4-3.4 7-4.7c36.2-17.8 78.4-27.3 118.5-27.3c32.6 0 66.6 6.3 97.6 18.4L489.7 87.6C486.1 73.7 473.6 64 459.2 64c-4.9 0-9.7 1.1-14.1 3.3l-22 11c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l22-11c8.8-4.4 18.5-6.7 28.4-6.7c29 0 54.2 19.6 61.5 47.6l50.7 196.6c3 11.8 4.6 23.8 4.6 36V352c0 .2 0 .3 0 .5V368c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L304.4 320H271.6l-3.4 54.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 312.2 312l0-.2c0-12 1.6-23.9 4.6-35.5L55.3 79.6C62.5 51.6 87.8 32 116.8 32c9.9 0 19.6 2.3 28.4 6.7l22 11c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-22-11c-4.4-2.2-9.2-3.3-14.1-3.3zM32 312l0 .2V352v16c0 44.2 35.8 80 80 80h44.3c42.5 0 77.5-33.2 79.9-75.6l0-.2 0 0L240 312l0 0c0 0 0 0 0-.1c-31.8-15.5-69-24-104.3-24c-35.1 0-72.2 8.4-103.7 24zm512 0c-31.4-15.6-68.6-24-103.7-24c-35.3 0-72.5 8.5-104.3 24c0 0 0 0 0 .1l0 0 3.8 60.2 0 0 0 .2c2.4 42.4 37.4 75.6 79.9 75.6H464c44.2 0 80-35.8 80-80V312z"]
};
var faHoodCloak = {
  prefix: 'fal',
  iconName: 'hood-cloak',
  icon: [576, 512, [], "f6ef", "M32 480l.4-.4 .2-.2 0 0 .1-.1C81.7 427 96 348.2 96 288c0-128 44-192 90-224c46-32 94-32 102-32H412.6c-1.2 1-2.7 2.2-4.2 3.5c-4.4 3.6-9.8 8-13.7 11.6c-6.7 6.1-10.5 14.7-10.5 23.8s3.9 17.7 10.6 23.7C438.8 134.2 480 195.8 480 288c0 60.2 14.3 139 63.3 191.3l0 0 .1 .1c.2 .2 .4 .4 .6 .6H416V320c0-70.7-57.3-128-128-128s-128 57.3-128 128V480H32zm160 0V320c0-53 43-96 96-96s96 43 96 96V480H192zm381.6 12.2c4.9-11.9 2.2-25.6-6.8-34.7l0 0-.1-.1C525.8 413.8 512 345 512 288c0-87-33.1-150.3-73.1-194.6c-7.4-8.2-15-15.7-22.7-22.6c3.5-3.2 7.4-6.3 11.3-9.5l0 0c4.5-3.7 9.1-7.4 13.3-11.4c4-3.7 7.7-7.7 10.7-11.9c4.7-6.5 5.9-15 2.9-22.7C450.8 6.1 441.9 0 432 0H288c-9.8 0-66 0-120.3 37.7C111.4 76.9 64 151.8 64 288c0 57.1-13.9 125.9-54.6 169.4l-.2 .2c-9 9.1-11.7 22.8-6.8 34.7c5 12 16.6 19.8 29.6 19.8H544c12.9 0 24.6-7.8 29.6-19.8z"]
};
var faSquareQuote = {
  prefix: 'fal',
  iconName: 'square-quote',
  icon: [448, 512, [], "e329", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 286.4V232 216 200c0-22.1-17.9-40-40-40H136c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h32c2.7 0 5.4-.3 8-.8v15.2c0 15.9-11.7 29.4-27.5 31.7l-14.8 2.1c-8.7 1.3-14.8 9.4-13.6 18.1s9.4 14.8 18.1 13.6l14.8-2.1c31.5-4.5 54.9-31.5 54.9-63.4zM176 232c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v16 16zm176 0V216 200c0-22.1-17.9-40-40-40H280c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h32c2.7 0 5.4-.3 8-.8v15.2c0 15.9-11.7 29.4-27.5 31.7l-14.8 2.1c-8.7 1.3-14.8 9.4-13.6 18.1s9.4 14.8 18.1 13.6l14.8-2.1c31.5-4.5 54.9-31.5 54.9-63.4V232zm-32-16v16c0 4.4-3.6 8-8 8H280c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v16z"]
};
var faUpLeft = {
  prefix: 'fal',
  iconName: 'up-left',
  icon: [384, 512, [], "e2bd", "M72 128c-4.4 0-8 3.6-8 8V337.4c0 3.7 3 6.6 6.6 6.6c1.8 0 3.4-.7 4.7-1.9l61.4-61.4c6.2-6.2 16.4-6.2 22.6 0L272 393.4c4.2 4.2 10 6.6 16 6.6s11.8-2.4 16-6.6L329.4 368c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16L216.7 223.3c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l61.4-61.4c1.2-1.2 1.9-2.9 1.9-4.7c0-3.7-3-6.6-6.6-6.6H72zm-40 8c0-22.1 17.9-40 40-40H273.4c21.3 0 38.6 17.3 38.6 38.6c0 10.2-4.1 20.1-11.3 27.3L250.6 212 352 313.4c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6L326.6 416c-10.2 10.2-24.1 16-38.6 16s-28.4-5.8-38.6-16L148 314.6 97.9 364.7C90.7 371.9 80.9 376 70.6 376C49.3 376 32 358.7 32 337.4V136z"]
};
var faBringFront = {
  prefix: 'fal',
  iconName: 'bring-front',
  icon: [640, 512, [], "f857", "M64 32H192c17.7 0 32 14.3 32 32h32c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64h64V224H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM448 512H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H512v32h64c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32H384c0 35.3 28.7 64 64 64zM416 128c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H416zM224 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H224zm32 96H384V320H256V192zm-32 0V320c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"]
};
var faChessBoard = {
  prefix: 'fal',
  iconName: 'chess-board',
  icon: [448, 512, [], "f43c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm88 0h64 72 72 64c13.3 0 24 10.7 24 24v64 72 72 64c0 13.3-10.7 24-24 24H296 224 152 88c-13.3 0-24-10.7-24-24V328 256 184 120c0-13.3 10.7-24 24-24zm8 72h40V128H96v40zm72 0h40V128H168v40zm72 0h40V128H240v40zm72 0h40V128H312v40zm0 32v40h40V200H312zm0 72v40h40V272H312zm0 72v40h40V344H312zm-32 0H240v40h40V344zm-72 0H168v40h40V344zm-72 0H96v40h40V344zm0-32V272H96v40h40zm0-72V200H96v40h40zm32 0h40V200H168v40zm72 0h40V200H240v40zm0 32v40h40V272H240zm-32 0H168v40h40V272z"]
};
var faBurgerCheese = {
  prefix: 'fal',
  iconName: 'burger-cheese',
  icon: [512, 512, [127828, "cheeseburger"], "f7f1", "M445 221.8C428.9 132.1 350.4 64 256 64S83.1 132.1 67 221.8l0 .1c0 .1 .1 .2 .3 .3c.7 .8 2.4 1.7 4.7 1.7H440c2.4 0 4-1 4.7-1.7c.1-.1 .2-.2 .3-.3l0-.1zM72 256c-22.1 0-40.4-18.1-36.5-39.8C54.3 111.5 145.9 32 256 32s201.7 79.5 220.5 184.2c3.9 21.7-14.4 39.8-36.5 39.8H416 224 72zm358.5 96H448c17.7 0 32 14.3 32 32c0 53-43 96-96 96H128c-53 0-96-43-96-96c0-17.7 14.3-32 32-32H209.5l48 32H64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64H382.5l48-32zM160 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 288H224c3.2 0 6.2 .9 8.9 2.7L320 348.8l87.1-58.1c2.6-1.8 5.7-2.7 8.9-2.7h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H420.8l-92 61.3c-5.4 3.6-12.4 3.6-17.8 0l-92-61.3H32c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCheeseburger = faBurgerCheese;
var faBuildingCircleCheck = {
  prefix: 'fal',
  iconName: 'building-circle-check',
  icon: [640, 512, [], "e4d2", "M64 32H320c17.7 0 32 14.3 32 32V266.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm240-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faRepeat1 = {
  prefix: 'fal',
  iconName: 'repeat-1',
  icon: [512, 512, [128258], "f365", "M0 255.2C-.4 264 6.4 271.5 15.2 272s16.3-6.4 16.8-15.2l.4-8C36.2 172.2 99.5 112 176.2 112H320v44.4c0 15.2 12.3 27.6 27.6 27.6c6.8 0 13.4-2.5 18.4-7.1l76.7-69c3.4-3 5.3-7.4 5.3-11.9s-1.9-8.9-5.3-11.9L366 15.1C360.9 10.5 354.4 8 347.6 8C332.3 8 320 20.3 320 35.6V80H176.2C82.4 80 5.1 153.5 .4 247.2l-.4 8zM408.1 96L352 146.5l0-100.9L408.1 96zM512 256.8c.4-8.8-6.4-16.3-15.2-16.8s-16.3 6.4-16.8 15.2l-.4 8C475.8 339.8 412.5 400 335.8 400L192 400l0-44.4c0-15.2-12.3-27.6-27.6-27.6c-6.8 0-13.4 2.5-18.4 7.1l-76.7 69c-3.4 3-5.3 7.4-5.3 11.9s1.9 8.9 5.3 11.9l76.7 69c5.1 4.6 11.6 7.1 18.4 7.1c15.2 0 27.6-12.3 27.6-27.6l0-44.4 143.8 0c93.8 0 171.1-73.5 175.8-167.2l.4-8zM103.9 416L160 365.5l0 100.9L103.9 416zM288 208c0-6.1-3.4-11.6-8.8-14.3s-11.9-2.1-16.8 1.5l-32 24c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2L256 240v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"]
};
var faArrowDownToLine = {
  prefix: 'fal',
  iconName: 'arrow-down-to-line',
  icon: [384, 512, ["arrow-to-bottom"], "f33d", "M16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16zM203.3 379.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 329.4V224 48c0-8.8 7.2-16 16-16s16 7.2 16 16V224 329.4L308.7 228.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128z"]
};
var faArrowToBottom = faArrowDownToLine;
var faGrid5 = {
  prefix: 'fal',
  iconName: 'grid-5',
  icon: [448, 512, [], "e199", "M24 56H40V72H24V56zM16 32C7.2 32 0 39.2 0 48V80c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H16zm8 120H40v16H24V152zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H16zm8 136V248H40v16H24zM0 240v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM24 344H40v16H24V344zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H16zm8 136V440H40v16H24zM0 432v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM120 56h16V72H120V56zm-8-24c-8.8 0-16 7.2-16 16V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H112zm8 136V152h16v16H120zM96 144v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm24 104h16v16H120V248zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H112zm8 136V344h16v16H120zM96 336v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm24 104h16v16H120V440zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H112zM216 72V56h16V72H216zM192 48V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm24 104h16v16H216V152zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H208zm8 136V248h16v16H216zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm24 104h16v16H216V344zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H208zm8 136V440h16v16H216zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM312 56h16V72H312V56zm-8-24c-8.8 0-16 7.2-16 16V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H304zm8 136V152h16v16H312zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm24 104h16v16H312V248zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H304zm8 136V344h16v16H312zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm24 104h16v16H312V440zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H304zM408 72V56h16V72H408zM384 48V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16zm24 104h16v16H408V152zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H400zm8 136V248h16v16H408zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16zm24 104h16v16H408V344zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H400zm8 136V440h16v16H408zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16z"]
};
var faRightLongToLine = {
  prefix: 'fal',
  iconName: 'right-long-to-line',
  icon: [640, 512, [], "e444", "M640 80l0 352c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-352c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 216L48 216c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l272 0c17.7 0 32 14.3 32 32l0 49.3c0 3.7 3 6.7 6.7 6.7c1.9 0 3.7-.8 5-2.2L476.2 256 363.7 130.2c-1.3-1.4-3.1-2.2-5-2.2c-3.7 0-6.7 3-6.7 6.7l0 49.3c0 17.7-14.3 32-32 32zm192 40c0 5.2-1.9 10.1-5.3 14L387.5 403.1c-7.3 8.2-17.8 12.9-28.8 12.9c-21.4 0-38.7-17.3-38.7-38.7l0-17.3 0-32-32 0L48 328c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48l240 0 32 0 0-32 0-17.3c0-21.4 17.3-38.7 38.7-38.7c11 0 21.5 4.7 28.8 12.9L506.7 242c3.4 3.8 5.3 8.8 5.3 14z"]
};
var faPersonChalkboard = {
  prefix: 'fal',
  iconName: 'person-chalkboard',
  icon: [640, 512, [], "e53d", "M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM179.3 160H224V320H160V164c6-2.6 12.5-4 19.3-4zM160 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V160H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H352V48c0-8.8 7.2-16 16-16H592c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V192H320v80c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 179.3c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L128 202.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faMarsStrokeRight = {
  prefix: 'fal',
  iconName: 'mars-stroke-right',
  icon: [640, 512, [9897, "mars-stroke-h"], "f22b", "M64 256a144 144 0 1 1 288 0A144 144 0 1 1 64 256zm319.3-16C375.2 150.3 299.8 80 208 80C110.8 80 32 158.8 32 256s78.8 176 176 176c91.8 0 167.2-70.3 175.3-160H432v48c0 8.8 7.2 16 16 16s16-7.2 16-16V272h89.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L553.4 240H464V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H383.3z"]
};
var faMarsStrokeH = faMarsStrokeRight;
var faHandBackFist = {
  prefix: 'fal',
  iconName: 'hand-back-fist',
  icon: [448, 512, ["hand-rock"], "f255", "M96 64c0-35.3 28.7-64 64-64c23.9 0 44.8 13.1 55.7 32.5c2.7-.4 5.5-.5 8.3-.5c23.9 0 44.8 13.1 55.7 32.5c2.7-.4 5.5-.5 8.3-.5c23.9 0 44.8 13.1 55.7 32.5c2.7-.4 5.5-.5 8.3-.5c35.3 0 64 28.7 64 64v80c0 49.6-25.1 93.3-63.2 119.2c-.4 .3-.6 .6-.7 .7c0 .1 0 .1-.1 .1l0 0V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V360.1c0-11.6 6.3-21.5 14.8-27.4C364.5 312.6 384 278.6 384 240V160c0-17.7-14.3-32-32-32c-4.2 0-8.2 .8-11.8 2.2c-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C315.2 106 302.7 96 288 96c-4.2 0-8.2 .8-11.8 2.2c-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C251.2 74 238.7 64 224 64c-4.2 0-8.2 .8-11.8 2.2c-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C187.2 42 174.7 32 160 32c-17.7 0-32 14.3-32 32v48 96c0 8.8-7.2 16-16 16s-16-7.2-16-16V150.6L78.1 168.6c-9 9-14.1 21.2-14.1 33.9V256c0 44.2 29.9 81.5 70.6 92.6c13.5 3.7 25.4 15.8 25.4 32.1V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V380.7l0 0c0 0-.1-.1-.2-.3c-.3-.4-.8-.8-1.6-1C71.9 364.7 32 315 32 256V202.5c0-21.2 8.4-41.6 23.4-56.6L96 105.4V64z"]
};
var faHandRock = faHandBackFist;
var faGridRound5 = {
  prefix: 'fal',
  iconName: 'grid-round-5',
  icon: [448, 512, [], "e5de", "M40 64A8 8 0 1 1 24 64a8 8 0 1 1 16 0zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm8 128a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zM0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM136 64a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 56a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM328 64a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 56a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faTally = {
  prefix: 'fal',
  iconName: 'tally',
  icon: [640, 512, ["tally-5"], "f69c", "M128 32c8.8 0 16 7.2 16 16V297.8l96-32V48c0-8.8 7.2-16 16-16s16 7.2 16 16V255.1l96-32V48c0-8.8 7.2-16 16-16s16 7.2 16 16V212.5l96-32V48c0-8.8 7.2-16 16-16s16 7.2 16 16V169.8l74.9-25c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2L528 203.5V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V214.2l-96 32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V256.9l-96 32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V299.5l-96 32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.2l-74.9 25c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2L112 308.5V48c0-8.8 7.2-16 16-16z"]
};
var faTally5 = faTally;
var faSquareCaretUp = {
  prefix: 'fal',
  iconName: 'square-caret-up',
  icon: [448, 512, ["caret-square-up"], "f151", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 64c9.6 0 18.7 4 25.2 11l95.5 102.8c4.7 5.1 7.3 11.8 7.3 18.7c0 15.2-12.3 27.5-27.5 27.5h-201C108.3 320 96 307.7 96 292.5c0-6.9 2.6-13.6 7.3-18.7L198.8 171c6.5-7 15.6-11 25.2-11zm-1.7 32.7L133.8 288H314.2l-88.4-95.3c-.4-.5-1.1-.7-1.7-.7s-1.3 .3-1.7 .7z"]
};
var faCaretSquareUp = faSquareCaretUp;
var faCloudShowersWater = {
  prefix: 'fal',
  iconName: 'cloud-showers-water',
  icon: [576, 512, [], "e4e4", "M176.1 99.3C178.6 61.7 209.8 32 248 32c26.4 0 49.4 14.2 62 35.4c2.3 3.8 6 6.5 10.3 7.5s8.9 .1 12.5-2.4c7.7-5.3 17-8.4 27.2-8.4c23 0 42.2 16.1 46.9 37.7c1.6 7.3 8.1 12.6 15.6 12.6h18.6c21.5 0 38.9 17.4 38.9 38.9s-17.4 38.9-38.9 38.9H134.9C113.4 192 96 174.6 96 153.1s17.4-38.9 38.9-38.9h25.3c8.4 0 15.4-6.6 16-15zM248 0c-50 0-91.7 35.3-101.7 82.3H134.9C95.7 82.3 64 114 64 153.1s31.7 70.9 70.9 70.9H441.1c39.1 0 70.9-31.7 70.9-70.9s-31.7-70.9-70.9-70.9h-6.8C422.5 52.8 393.7 32 360 32c-11.1 0-21.7 2.3-31.3 6.4C309.6 15 280.6 0 248 0zM141.3 280.9c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480zM472.9 258.7c-7.4-4.9-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c4.9-7.4 2.9-17.3-4.4-22.2zM253.3 280.9c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96zm107.6-22.2c-7.4-4.9-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c4.9-7.4 2.9-17.3-4.4-22.2z"]
};
var faChartBar = {
  prefix: 'fal',
  iconName: 'chart-bar',
  icon: [512, 512, ["bar-chart"], "f080", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM128 144c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm16 80H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBarChart = faChartBar;
var faHandsBubbles = {
  prefix: 'fal',
  iconName: 'hands-bubbles',
  icon: [608, 512, ["hands-wash"], "e05e", "M432 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM240 448c0 3.2-.2 6.4-.5 9.5C271.3 491 316.2 512 366.1 512H496c26.5 0 48-21.5 48-48c0-6.2-1.2-12.2-3.4-17.7C561 440.8 576 422.1 576 400c0-6.2-1.2-12.2-3.4-17.7C593 376.8 608 358.1 608 336s-15-40.8-35.4-46.3c2.2-5.5 3.4-11.4 3.4-17.7c0-26.5-21.5-48-48-48H419.8c12.2-13.6 16-33.7 8.1-51.5c-10.8-24.2-39.1-35.1-63.4-24.4l-69.1 30.7C232.5 206.8 192 269.1 192 337.9c0 9.6 .8 19.1 2.3 28.3C221.7 383.1 240 413.4 240 448zM31.9 224.2c-.4 55 25.1 106 67.4 138.8c12.6-6.7 27-10.6 42.1-11c-47.7-24.3-77.9-73.6-77.5-127.6l.5-75.7c.1-8.8 7.3-15.9 16.1-15.9s15.9 7.3 15.9 16.1l-.3 46.2c-.1 7.6 5.2 14.1 12.6 15.7s14.9-2.1 18-9L198.1 44.2c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2l-39.6 87.4c-3.6 8-.1 17.5 8 21.2s17.5 .1 21.2-8l39.6-87.4 13.2-29.1c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2L285.6 83.8l-39.1 86.4c11.1-7.9 23.1-14.8 35.9-20.5l0 0 .4-.2 10.2-4.4L314.7 97c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2l-7.2 15.9L377 108.6c2.1-20-8.6-40-27.9-48.7c-5.7-2.6-11.6-4-17.5-4.2C335 34.8 324.2 13.4 304 4.3s-43.3-3.2-56.8 13.1c-4.1-4.2-9-7.8-14.7-10.4C208.3-3.9 179.9 6.8 169 31l-44.6 98.6c-7.4-16.7-24.1-28.5-43.6-28.6c-26.5-.2-48.2 21.2-48.3 47.7l-.5 75.6zm345.6-46.9c8.1-3.6 17.5 0 21.1 8.1s0 17.5-8.1 21.1l-42.2 18.8c-6.9 3.1-10.7 10.6-9.2 17.9s8.1 12.7 15.7 12.7H528c8.8 0 16 7.2 16 16c0 8.8-7.1 16-16 16H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h96l0 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544l0 0H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h96l0 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 0-15.9 0L432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 0c8.8 0 15.9 7.2 15.9 16c0 8.8-7.2 16-16 16H366.1C287.6 480 224 416.4 224 337.9c0-56.1 33.1-107 84.4-129.8l69.1-30.7zM112 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 80 448a64 64 0 1 0 128 0zM480 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faHandsWash = faHandsBubbles;
var faLessThanEqual = {
  prefix: 'fal',
  iconName: 'less-than-equal',
  icon: [448, 512, [], "f537", "M406.1 62.8c8.2-3.3 12.1-12.7 8.8-20.9s-12.7-12.1-20.9-8.8l-352 144c-6 2.5-9.9 8.3-9.9 14.8s3.9 12.3 9.9 14.8l352 144c8.2 3.3 17.5-.6 20.9-8.8s-.6-17.5-8.8-20.9L90.3 192 406.1 62.8zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faTrain = {
  prefix: 'fal',
  iconName: 'train',
  icon: [448, 512, [128646], "f238", "M352 32c35.3 0 64 28.7 64 64V224H32V96c0-35.3 28.7-64 64-64H352zM32 352V256H416v96c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zM96 0C43 0 0 43 0 96V352c0 46 32.4 84.4 75.6 93.8L36.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L118.6 448H329.4l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-38.9-38.9C415.6 436.4 448 398 448 352V96c0-53-43-96-96-96H96zM224 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faUpFromDottedLine = {
  prefix: 'fal',
  iconName: 'up-from-dotted-line',
  icon: [448, 512, [], "e456", "M222.2 64.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L350.2 196.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7H288c-8.8 0-16 7.2-16 16V344c0 4.4-3.6 8-8 8H184c-4.4 0-8-3.6-8-8V224c0-8.8-7.2-16-16-16H102.7c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L222.2 64.8zM224 32c-9.5 0-18.6 3.9-25.1 10.8L74.5 174.8C67.8 182 64 191.5 64 201.3c0 21.4 17.3 38.7 38.7 38.7H144V344c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V240h41.3c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L249.1 42.8C242.6 35.9 233.5 32 224 32zM32 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm384 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM152 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faEyeLowVision = {
  prefix: 'fal',
  iconName: 'eye-low-vision',
  icon: [640, 512, ["low-vision"], "f2a8", "M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5s-15.5 8.1-22.5 2.6L6.1 28.6C-.8 23.1-2 13 3.4 6.1zM605.5 268.3c-10.3 24.6-28.3 57-53.9 89l-25.1-19.8C550.1 308 566.8 278.1 576 256c-13.3-32-42.1-80-85.2-120C447.7 96 390.4 64 320 64c-39.8 0-75.4 10.2-106.6 26.3L186.1 68.8C224 46.8 268.8 32 320 32c80.8 0 145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6zM448 256c0 6.3-.5 12.4-1.3 18.5l-30.9-24.4C412.8 199.8 371 160 320 160c-5.6 0-11.2 .5-16.5 1.4l-30.9-24.4c14.7-5.8 30.6-9.1 47.4-9.1c70.7 0 128 57.3 128 128zM106 163.5l320 256c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5L86 188.5c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5zM67.5 238c5.5-6.9 15.6-8 22.5-2.5l250 200c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5L70 260.5c-6.9-5.5-8-15.6-2.5-22.5zM106 336.3l124 99.2c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5L86 361.3c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5z"]
};
var faLowVision = faEyeLowVision;
var faTrafficLightGo = {
  prefix: 'fal',
  iconName: 'traffic-light-go',
  icon: [320, 512, [], "f638", "M64 32C46.3 32 32 46.3 32 64V352c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM160 448a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z"]
};
var faFaceExhaling = {
  prefix: 'fal',
  iconName: 'face-exhaling',
  icon: [576, 512, [], "e480", "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c40.8 0 78.9-10.9 111.8-29.9c7.7-4.4 17.4-1.8 21.9 5.9s1.8 17.4-5.9 21.9C346.2 499.6 302.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C391.7 0 502.7 105.5 511.4 238.9c.6 8.8-6.1 16.4-14.9 17s-16.4-6.1-17-14.9C471.8 124.3 374.7 32 256 32zm.1 376.1a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm60.8-89.6c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm-121.6 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm299.6 49.6c26.1 0 47.4 19.2 51.3 44.1c17.9 10.3 29.9 29.7 29.9 51.9s-12 41.6-29.9 51.8c-3.9 24.9-25.3 44.2-51.3 44.2c-14.2 0-27-5.7-36.4-15c-2.2 .3-4.4 .4-6.6 .4c-27.3 0-49.4-21.1-51.7-47.7l-60.7-18.4c-6.7-2-11.4-8.3-11.4-15.3s4.6-13.3 11.4-15.3l62-18.8c5.5-22.9 25.9-40.1 50.5-40.1l.7 0c9.4-13.2 24.7-21.8 42.2-21.8zm-18.6 44.9c-3 7.7-11.2 11.8-19.2 9.6c-1.6-.5-3.4-.7-5.2-.7c-10.8 0-19.9 8.9-19.9 20.4c0 7-4.6 13.3-11.4 15.3l-21.4 6.5 22.1 6.7c7.8 2.4 12.6 10.3 11.1 18.4c-.2 1.3-.4 2.6-.4 4c0 11.4 9.1 20.4 19.9 20.4c2.5 0 4.8-.4 6.9-1.3c7.1-2.7 15.1 0 19.2 6.4c3.6 5.7 9.8 9.4 16.8 9.4c10.8 0 19.9-8.9 19.9-20.4c0-.4 0-.9 0-1.3c-.4-7.2 4-13.8 10.8-16.1c10.7-3.6 18.5-14 18.5-26.2s-7.8-22.6-18.5-26.2c-6.8-2.3-11.2-8.9-10.8-16.1c0-.4 0-.9 0-1.3c0-11.4-9.1-20.4-19.9-20.4c-8.3 0-15.6 5.2-18.6 12.9z"]
};
var faSensorFire = {
  prefix: 'fal',
  iconName: 'sensor-fire',
  icon: [640, 512, [], "e02a", "M64 64H384c17.7 0 32 14.3 32 32v41c9.4-6.9 20.9-9.8 32-8.8V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H337.6c-8.8-9.8-16.5-20.6-23.2-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM509.4 253.3c9.6-.1 18.7-4.5 24.7-12.1c3.9-4.9 7.8-9.6 11.6-14c16.4 17.8 30.9 39.4 41.8 60.5C601 313.8 608 339.3 608 352c0 70.2-57 127.8-128 127.8c-71.8 0-128-57.5-128-127.8c0-17.9 9.4-46.2 27.6-75.8c15.9-25.8 37.9-53.1 64-78.1c14.3 13.7 27.9 28.3 40.8 43.7c6.2 7.4 15.3 11.6 25 11.5zM487.5 197c-10.9-11.6-22.2-22.8-34-33.4c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8C332.7 291.3 320 325.6 320 352c0 87.8 70.3 159.8 160 159.8c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-1.8 1.6-3.5 3.3-5.2 5c-7.7 7.7-14.8 16.4-21.2 24.5c-7-8.4-14.1-16.5-21.5-24.4zm-42.5 58.9c-4.8 0-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C389 324.1 384 338.2 384 353.9c0 28.7 10.7 52.6 28.8 69.2c18 16.5 42.3 24.8 68.2 24.8c21.3 0 40.3-6 57.9-17.7l0 0 .3-.2c37.3-26.1 46.3-77.2 25-116.5l0-.1c-1.9-3.9-4.5-9-8.3-14.1c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5c-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5c-12.4 8.2-25.3 12.2-40 12.2c-19.1 0-35.3-6.1-46.6-16.4c-11.1-10.1-18.4-25.2-18.4-45.6c0-8.3 2.5-16.8 9.1-28.1c4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.5 1.8 2.4 .5 .6 .1 .2 0 0 0 0 0 0 12.6-9.9-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"]
};
var faUserUnlock = {
  prefix: 'fal',
  iconName: 'user-unlock',
  icon: [640, 512, [], "e058", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 336c-80 0-145 64.3-146.3 144H384c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3v39c-26.8-33.5-68-55-114.3-55H178.3zM480 272v48h32 64 32c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272c0-44.2 35.8-80 80-80s80 35.8 80 80H576c0-26.5-21.5-48-48-48s-48 21.5-48 48zM448 480H608V352H448V480z"]
};
var faHexagonDivide = {
  prefix: 'fal',
  iconName: 'hexagon-divide',
  icon: [512, 512, [], "e1ad", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM256 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 240H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var fa00 = {
  prefix: 'fal',
  iconName: '00',
  icon: [640, 512, [], "e467", "M144 32C64.5 32 0 96.5 0 176V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM32 176C32 114.1 82.1 64 144 64s112 50.1 112 112V336c0 61.9-50.1 112-112 112S32 397.9 32 336V176zM496 32c-79.5 0-144 64.5-144 144V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM384 176c0-61.9 50.1-112 112-112s112 50.1 112 112V336c0 61.9-50.1 112-112 112s-112-50.1-112-112V176z"]
};
var faCrow = {
  prefix: 'fal',
  iconName: 'crow',
  icon: [640, 512, [], "f520", "M25.7 412.7L63.2 384H272.6l48.6 118.1c3.4 8.2 12.7 12.1 20.9 8.7s12.1-12.7 8.7-20.9L307.2 384H320c16 0 31.4-1.9 46.3-5.6l50.9 123.7c3.4 8.2 12.7 12.1 20.9 8.7s12.1-12.7 8.7-20.9L396.6 368.1C464.5 338.5 512 270.8 512 192V144l128-32c0-44.2-35.8-80-80-80H487.6C470 12.4 444.4 0 416 0c-53 0-96 43-96 96v51L52.4 352l-8.6 6.6L6.3 387.3c-7 5.4-8.3 15.4-3 22.4s15.4 8.3 22.4 3zM506.5 64H560c18 0 33.7 9.9 41.9 24.5L512 111V96c0-11.2-1.9-22-5.5-32zM132.7 330.8l186.7-143C313.6 250 268 302.1 205.9 315.2l-73.2 15.5zM320 352H186.8l25.7-5.5c81.3-17.2 139.5-89 139.5-172.2V162.8l0 0V147 96c0-35.3 28.7-64 64-64s64 28.7 64 64v32 64c0 88.4-71.6 160-160 160zM440 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCassetteBetamax = {
  prefix: 'fal',
  iconName: 'cassette-betamax',
  icon: [576, 512, ["betamax"], "f8a4", "M32 160V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V160H32zm0-32H544V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96v32zM576 96v32 16 16V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160 144 128 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64zM240 304a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 304a96 96 0 1 1 192 0A96 96 0 1 1 80 304zm72 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-48v96h96V256H352zm-32 0c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V256z"]
};
var faBetamax = faCassetteBetamax;
var faSailboat = {
  prefix: 'fal',
  iconName: 'sailboat',
  icon: [576, 512, [], "e445", "M285.1 6.8c-4-5.7-11.3-8.2-17.9-6.1S256 9 256 16V336c0 8.8 7.2 16 16 16H496c6 0 11.4-3.3 14.2-8.6s2.3-11.7-1.1-16.6l-224-320zM288 320V66.8L465.3 320H288zM212.1 96.5c-7-1.9-14.4 1.2-18 7.5l-128 224c-2.8 5-2.8 11 .1 16s8.1 8 13.8 8H208c8.8 0 16-7.2 16-16V112c0-7.3-4.9-13.6-11.9-15.5zM107.6 320L192 172.2V320H107.6zM42.5 416H533.5c-13.5 38.1-49.6 64-90.5 64H133c-40.9 0-77-25.9-90.5-64zM21.1 384c-10.6 0-18.3 10.1-15.4 20.3l4 14.3C25.3 473.9 75.6 512 133 512H443c57.3 0 107.7-38.1 123.2-93.3l4-14.3c2.9-10.2-4.8-20.3-15.4-20.3H21.1z"]
};
var faWindowRestore = {
  prefix: 'fal',
  iconName: 'window-restore',
  icon: [512, 512, [], "f2d2", "M432 32H208c-26.5 0-48 21.5-48 48V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V352h16c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM320 160H64c-17.7 0-32 14.3-32 32v64H352V192c0-17.7-14.3-32-32-32zM32 448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V288H32V448zM64 128H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z"]
};
var faNfcMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'nfc-magnifying-glass',
  icon: [640, 512, [], "e1f9", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H352c16.6 12.5 35.8 21.8 56.6 27.1c-7.6 3.2-15.9 4.9-24.6 4.9H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v64c-11 0-21.7 1.1-32 3.2V96c0-17.7-14.3-32-32-32zm0 64v45.3c-11.4 5-22.2 11.3-32 18.7V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32zM320 416H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0V384H301.3c5 11.4 11.3 22.2 18.7 32zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM448 416.2a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 32c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 29.6-10 56.8-26.9 78.5l86.2 86.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-86.2-86.2c-21.7 16.9-48.9 26.9-78.5 26.9z"]
};
var faFileBinary = {
  prefix: 'fal',
  iconName: 'file-binary',
  icon: [384, 512, [], "e175", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm48 256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H112zM96 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V304zm144-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v96H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h32 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V272c0-8.8-7.2-16-16-16H240z"]
};
var faCircleV = {
  prefix: 'fal',
  iconName: 'circle-v',
  icon: [512, 512, [], "e12a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM158.3 152.8c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l112 224c2.7 5.4 8.3 8.8 14.3 8.8s11.6-3.4 14.3-8.8l112-224c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L256 348.2 158.3 152.8z"]
};
var faSquarePlus = {
  prefix: 'fal',
  iconName: 'square-plus',
  icon: [448, 512, [61846, "plus-square"], "f0fe", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM208 352V272H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H240v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faPlusSquare = faSquarePlus;
var faBowlScoops = {
  prefix: 'fal',
  iconName: 'bowl-scoops',
  icon: [448, 512, [127813], "e3df", "M335.3 64.7c-5-.5-10.1-.7-15.3-.7c-7.8 0-15.5 .6-23 1.6C279.4 45.1 253.2 32 224 32s-55.4 13.1-73 33.6c-7.5-1.1-15.2-1.6-23-1.6c-5.2 0-10.3 .2-15.3 .7C134.7 26.1 176.3 0 224 0s89.3 26.1 111.3 64.7zM200 118.2c-7.1 8-13.3 16.7-18.7 26C166.1 134 147.7 128 128 128c-53 0-96 43-96 96H0C0 153.3 57.3 96 128 96c26.7 0 51.5 8.2 72 22.2zM448 224H416c0-53-43-96-96-96s-96 43-96 96H192c0-70.7 57.3-128 128-128s128 57.3 128 128zm-2.1 65.9c-8.5 67.9-63.4 119.9-130.5 125.6c-4.1 .3-8.2 .5-12.4 .5H274.2l26.7 32 31.5 37.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2H128c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17L147.2 448l26.7-32H145c-4.2 0-8.3-.2-12.4-.5c-67.1-5.7-122-57.7-130.5-125.6L.1 274c-.6-4.6 .8-9.1 3.9-12.6s7.4-5.4 12-5.4H432c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9zM34.1 288c7.9 55 55.1 96 110.9 96h28.8 32 36.3 32H303c55.8 0 102.9-41 110.9-96H34.1zM198.4 436.5L162.2 480H285.8l-36.3-43.5L224 405.8l-25.6 30.7z"]
};
var faMistletoe = {
  prefix: 'fal',
  iconName: 'mistletoe',
  icon: [576, 512, [], "f7b4", "M288 0c8.8 0 16 7.2 16 16V89.4l91.3 91.3c.2 .2 .4 .5 .6 .7l5.9 1.1 82.9 15.9C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75c-54 0-100.3-38.3-110.5-91.3l-15.9-82.9-1.1-5.9c-.2-.2-.5-.4-.7-.7L304 134.6V277.3l4 5.3 56.8 75.7C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L268 282.7l4-5.3V134.6l-68.7 68.7c-.2 .2-.5 .4-.7 .7l-1.1 5.9-.4 2.2c-7.9-2.6-16.3-4-25.1-4c-18 0-34.6 5.9-48 16l-30.7 5.9C59.4 237.2 32 270.3 32 309c0 23.8 19.3 43 43 43c14.8 0 28.8-4 40.9-11.2c7.5 8.5 16.8 15.4 27.3 20.2c-19.1 14.5-42.8 23-68.2 23c-41.4 0-75-33.6-75-75c0-54 38.3-100.3 91.3-110.5l82.9-15.9 5.9-1.1c.2-.2 .4-.5 .7-.7L272 89.4V16c0-8.8 7.2-16 16-16zM478.7 229.9l-70.3-13.5 13.5 70.3c7.3 37.9 40.5 65.3 79.1 65.3c23.8 0 43-19.3 43-43c0-38.6-27.4-71.8-65.3-79.1zM236.8 377.6C228.5 388.7 224 402.2 224 416c0 35.3 28.7 64 64 64s64-28.7 64-64c0-13.8-4.5-27.3-12.8-38.4L288 309.3l-51.2 68.3zM368 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM176 272a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faCustard = {
  prefix: 'fal',
  iconName: 'custard',
  icon: [576, 512, [127854], "e403", "M49.8 384l66.3-271.2c7-28.6 32.7-48.8 62.2-48.8H397.8c29.5 0 55.2 20.2 62.2 48.8L526.2 384H493.3L452.7 218c-18.1-5.7-37.2-10-52.7-10c-18.7 0-32.3 6.4-49.1 14.4l-.7 .3C333.8 230.6 314.4 240 288 240s-45.8-9.4-62.2-17.2l-.7-.3c-16.7-8-30.4-14.4-49.1-14.4c-15.5 0-34.6 4.4-52.7 10L82.7 384H49.8zM132 182.3c14.7-3.7 30-6.3 44-6.3c26.4 0 45.8 9.4 62.2 17.2l.7 .3c16.7 8 30.4 14.4 49.1 14.4s32.3-6.4 49.1-14.4l.7-.3c16.4-7.9 35.8-17.2 62.2-17.2c14 0 29.3 2.6 44 6.3l-15.1-61.9C425.3 106.1 412.5 96 397.8 96H178.2c-14.7 0-27.6 10.1-31.1 24.4L132 182.3zM0 432c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faLacrosseStick = {
  prefix: 'fal',
  iconName: 'lacrosse-stick',
  icon: [512, 512, [], "e3b5", "M344 32v0l.2 0 .2 0c28.8 0 62.8 18.4 90 45.6c27.2 27.2 45.6 61.2 45.6 90.1l0 .1 0 .2 0 .1c0 44.3-28.4 83.6-70.4 97.6l0 0-.8 .3-1.8 .6c-18.7 6.2-42.9 14.3-64 31.5l-42 34.4c-15.4 12.6-34.7 19.5-54.7 19.5c-47.7 0-86.3-38.7-86.3-86.3c0-19.9 6.9-39.2 19.5-54.7l34.4-42c17.3-21.1 25.4-45.4 31.6-64.2l.8-2.4C260.3 60.4 299.7 32 344 32zM457 55C426.8 24.8 385.1 0 344.3 0L344 0C285.9 0 234.3 37.2 215.9 92.3l-.3 .8 0 0c-6.6 19.8-13 39.1-26.5 55.6l-34.4 42c-17.3 21.1-26.7 47.6-26.7 74.9c0 26.9 9 51.7 24.1 71.6L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L174.7 359.9C194.6 375 219.4 384 246.3 384c27.3 0 53.8-9.4 74.9-26.7l42-34.4c16.5-13.5 35.8-19.9 55.6-26.5l.8-.3c55.1-18.4 92.3-70 92.3-128.1l0-.3c0-40.8-24.8-82.5-55-112.7z"]
};
var faHockeyMask = {
  prefix: 'fal',
  iconName: 'hockey-mask',
  icon: [448, 512, [], "f6ee", "M32 240c0-59.7 14.9-111.7 44.7-148.1C105.8 56.5 152.1 32 224 32s118.2 24.5 147.3 59.9C401.1 128.3 416 180.3 416 240c0 95.4-12.4 153.6-39.3 188.4C351.6 460.9 308 480 224 480s-127.6-19.1-152.7-51.6C44.4 393.6 32 335.4 32 240zM224 0C64 0 0 111 0 240C0 432 48 512 224 512s224-80 224-272C448 111 384 0 224 0zM160 208c0 17.7-14.3 32-32 32s-32-14.3-32-32V192h64v16zm-32 64c35.3 0 64-28.7 64-64V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v16c0 35.3 28.7 64 64 64zm192-32c-17.7 0-32-14.3-32-32V192h64v16c0 17.7-14.3 32-32 32zm64-32V192c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32v16c0 35.3 28.7 64 64 64s64-28.7 64-64zM176 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM288 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSunrise = {
  prefix: 'fal',
  iconName: 'sunrise',
  icon: [576, 512, [127749], "f766", "M276.7 4.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L304 54.6V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zM393.5 225.2c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L500.9 448H462.1l38.7-56.2-94.5-17.4c-6.5-1.2-11.6-6.3-12.8-12.8l-17.4-94.5-79.1 54.5c-5.5 3.8-12.7 3.8-18.2 0l-79.1-54.5-17.4 94.5c-1.2 6.5-6.3 11.6-12.8 12.8L75.2 391.8 113.9 448H75.1L34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM412 448H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H164c14.2-55.2 64.3-96 124-96s109.8 40.8 124 96zM16 480H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPanelEws = {
  prefix: 'fal',
  iconName: 'panel-ews',
  icon: [512, 512, [], "e42e", "M64 32C46.3 32 32 46.3 32 64V289.6C68.5 297 96 329.3 96 368v16c0 17.7 14.3 32 32 32s32-14.3 32-32V352H144c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V368c0-20.9-13.4-38.7-32-45.3V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 80h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 144h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zM208 320V256H144v64h32 32zm112-64V416h64V256H320zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256z"]
};
var faToriiGate = {
  prefix: 'fal',
  iconName: 'torii-gate',
  icon: [512, 512, [9961], "f6a1", "M32 112c0 17.7 14.3 32 32 32l176 0h32l176 0c17.7 0 32-14.3 32-32V40.9l-23.5 9.4C433.8 59.3 409.6 64 385.2 64H126.8c-24.4 0-48.6-4.7-71.3-13.7L32 40.9V112zm208 64H96v80l144 0V176zM64 176c-35.3 0-64-28.7-64-64V13.4C0 6 6 0 13.4 0c1.7 0 3.4 .3 5 1l49 19.6C86.3 28.1 106.5 32 126.8 32H385.2c20.4 0 40.5-3.9 59.4-11.4L493.6 1c1.6-.6 3.3-1 5-1C506 0 512 6 512 13.4V112c0 35.3-28.7 64-64 64v80h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V288l-160 0L96 288V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V176zm352 0H272v80l144 0V176z"]
};
var faCloudExclamation = {
  prefix: 'fal',
  iconName: 'cloud-exclamation',
  icon: [640, 512, [], "e491", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm48 128c8.8 0 16 7.2 16 16V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM296 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faMessageLines = {
  prefix: 'fal',
  iconName: 'message-lines',
  icon: [512, 512, ["comment-alt-lines"], "f4a6", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm80 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
};
var faCommentAltLines = faMessageLines;
var faFrog = {
  prefix: 'fal',
  iconName: 'frog',
  icon: [576, 512, [], "f52e", "M368 64c-26.5 0-48 21.5-48 48c0 .6 0 1.1-.1 1.7c-.8 8-7.6 14.3-15.9 14.3h-3.2C152.3 128 32 248.3 32 396.8V416c0 17.7 14.3 32 32 32H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-4.1 0-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4 0-22.6l8.8-8.8c1.7-1.7 3.2-3.4 4.7-5.3c8.9-11.1 13.8-25 13.8-39.4c0-12.5-3.7-24.2-9.9-34c-11.2-17.5-30.9-29.2-53.3-29.2c-16.8 0-32.8 6.7-44.7 18.5l-40.8 40.8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l40.8-40.8C207.3 250 231.6 240 256.8 240c20.7 0 39.9 6.6 55.5 17.9c24 17.3 39.7 45.5 39.7 77.3c0 17.4-4.7 34.2-13.5 48.9c25.3 1.3 45.5 22.3 45.5 47.9c0 26.5-21.5 48-48 48H64c-35.3 0-64-28.7-64-64V396.8C0 234.4 128.6 102.1 289.6 96.2C296.9 59.6 329.2 32 368 32c41.4 0 75.4 31.4 79.6 71.7c38.1 7.3 69.1 18.5 90.1 27.6C562.6 142 576 166.7 576 192c0 25.5-13.4 49.1-35.2 62.2L423.7 324.4 519.8 448H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H512c-4.9 0-9.6-2.3-12.6-6.2l-112-144c-2.8-3.6-3.9-8.3-3.1-12.8s3.6-8.4 7.5-10.8l132.6-79.5c12.2-7.3 19.7-20.5 19.7-34.7c0-14.4-7.5-26.4-19-31.4c-21.5-9.3-54.8-21.1-95.7-27.7c-8.2-1.3-14.1-8.7-13.4-17.1c.1-1.3 .2-2.6 .2-3.9c0-26.5-21.5-48-48-48zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faBucket = {
  prefix: 'fal',
  iconName: 'bucket',
  icon: [448, 512, [], "e4cf", "M96 144c0 8.8-7.2 16-16 16s-16-7.2-16-16C64 64.5 128.5 0 208 0h32c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112H208C146.1 32 96 82.1 96 144zM0 208c0-8.8 7.2-16 16-16h8H56.2 391.8 424h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H420L389.3 470c-3 24-23.4 42-47.6 42H106.4c-24.2 0-44.6-18-47.6-42L28 224H16c-8.8 0-16-7.2-16-16zm60.2 16L90.5 466c1 8 7.8 14 15.9 14H341.6c8.1 0 14.9-6 15.9-14l30.2-242H60.2z"]
};
var faFloppyDiskPen = {
  prefix: 'fal',
  iconName: 'floppy-disk-pen',
  icon: [576, 512, [], "e182", "M32 96V416c0 17.7 14.3 32 32 32H266.3l-8 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v49.7l-32 32V170.5c0-8.5-3.4-16.6-9.4-22.6L332.1 73.4c-3.4-3.4-7.6-6-12.1-7.6V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64C46.3 64 32 78.3 32 96zM96 64v96H288V64H96zm80 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM518.8 264.1c-6.2-6.2-16.4-6.2-22.6 0L471.3 289l40 40 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zM342.5 417.8c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49L375 462c2.8-.7 5.4-2.2 7.4-4.2L488.7 351.6l-40-40L342.5 417.8zM473.5 241.5c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 480.5c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L473.5 241.5z"]
};
var faImage = {
  prefix: 'fal',
  iconName: 'image',
  icon: [512, 512, [], "f03e", "M64 64C46.3 64 32 78.3 32 96V329.4l67.7-67.7c15.6-15.6 40.9-15.6 56.6 0L224 329.4 355.7 197.7c15.6-15.6 40.9-15.6 56.6 0L480 265.4V96c0-17.7-14.3-32-32-32H64zM32 374.6V416c0 17.7 14.3 32 32 32h41.4l96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zM389.7 220.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448H448c17.7 0 32-14.3 32-32V310.6l-90.3-90.3zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faWindowFrame = {
  prefix: 'fal',
  iconName: 'window-frame',
  icon: [512, 512, [129695], "e04f", "M240 288V480H64V288H240zm32 192V288H448V480H272zm208 0V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 64 448h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480zM448 256H272V32H416c17.7 0 32 14.3 32 32V256zM96 32H240V256H64V64c0-17.7 14.3-32 32-32z"]
};
var faMicrophone = {
  prefix: 'fal',
  iconName: 'microphone',
  icon: [384, 512, [], "f130", "M256 96V256c0 35.3-28.7 64-64 64s-64-28.7-64-64V96c0-35.3 28.7-64 64-64s64 28.7 64 64zM96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96S96 43 96 96zM64 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 83 63.1 151.2 144 159.2V480H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V415.2c80.9-8 144-76.2 144-159.2V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 70.7-57.3 128-128 128s-128-57.3-128-128V208z"]
};
var faCow = {
  prefix: 'fal',
  iconName: 'cow',
  icon: [640, 512, [128004], "f6c8", "M128 144V408c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V352.2v-.5V336c0-53 43-96 96-96s96 43 96 96v15.8 .5V408c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V240c0-5.5 2.9-10.7 7.6-13.6s10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3v62.7c0 3 .9 6 2.5 8.6l37.3 58.6c5.6 8.8 15.3 14.1 25.7 14.1c16.8 0 30.5-13.6 30.5-30.5V298c0-3.3-1-6.4-2.8-9.1L594.8 274c-1.9-2.7-2.8-5.9-2.8-9.1V200c0-4.4-3.6-8-8-8c-4 0-7.3 2.9-7.9 6.7c-1.1 6.4-5.9 11.6-12.3 13s-12.9-1.1-16.7-6.5l-51.7-74.7C480.5 108.9 456 96 429.7 96h-30c-1.9 26.9-13.4 52.3-32.5 71.4l-3.1 3.1c-24 24-56.6 37.5-90.5 37.5h-3.2c-33.9 0-66.5-13.5-90.5-37.5l-3.1-3.1c-16.6-16.6-27.4-37.8-31.2-60.5C134.8 115.7 128 129 128 144zm71.4 .8l3.1 3.1c18 18 42.4 28.1 67.9 28.1h3.2c25.5 0 49.9-10.1 67.9-28.1l3.1-3.1c13.2-13.2 21.3-30.4 23.1-48.8H176.4c1.8 18.4 9.9 35.6 23.1 48.8zm8.6 231V408c0 22.1-17.9 40-40 40H136c-22.1 0-40-17.9-40-40V144c0-18 6-34.6 16-48c-26.5 0-48 21.5-48 48v80 16 28.8C64 297.1 41.1 320 12.8 320C5.7 320 0 314.3 0 307.2V288c0-23.7 12.9-44.4 32-55.4V144c0-44.2 35.8-80 80-80h64H429.7c36.8 0 71.2 18 92.1 48.2l38.5 55.6c6.6-4.9 14.9-7.8 23.7-7.8c22.1 0 40 17.9 40 40v59.9l7.5 10.8c5.6 8 8.5 17.6 8.5 27.3v87.5c0 34.5-28 62.5-62.5 62.5c-21.4 0-41.2-10.9-52.7-28.9l-37.3-58.6c-4.9-7.7-7.5-16.6-7.5-25.8V281.9l-32-16V408c0 22.1-17.9 40-40 40H376c-22.1 0-40-17.9-40-40V375.8c-6.6 2-14.6 3.8-24 5.3V392c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8.1c-2.6 .1-5.3 .1-8 .1s-5.4 0-8-.1V392c0 8.8-7.2 16-16 16s-16-7.2-16-16V381.1c-9.4-1.5-17.4-3.3-24-5.3zm0-33.8c2.1 .8 4.7 1.8 7.7 2.7c11.4 3.5 29.8 7.3 56.3 7.3s44.9-3.8 56.3-7.3c3-.9 5.6-1.9 7.7-2.7v-6c0-35.3-28.7-64-64-64s-64 28.7-64 64v6zm344-22a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faFileZip = {
  prefix: 'fal',
  iconName: 'file-zip',
  icon: [512, 512, [], "e5ee", "M64 480h96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM240 352h64c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384H240c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368zm32 64h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48z"]
};
var faSquareRing = {
  prefix: 'fal',
  iconName: 'square-ring',
  icon: [448, 512, [], "e44f", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM160 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faDownFromLine = {
  prefix: 'fal',
  iconName: 'down-from-line',
  icon: [384, 512, ["arrow-alt-from-top"], "f349", "M190.2 447.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L318.2 315.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7H256c-8.8 0-16-7.2-16-16V168c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8V288c0 8.8-7.2 16-16 16H70.7c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L190.2 447.2zM192 480c-9.5 0-18.6-3.9-25.1-10.8L42.5 337.2C35.8 330 32 320.5 32 310.7C32 289.3 49.3 272 70.7 272H112V168c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40V272h41.3c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.4-10.5 26.5L217.1 469.2c-6.5 6.9-15.6 10.8-25.1 10.8zM16 32H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48s7.2-16 16-16z"]
};
var faArrowAltFromTop = faDownFromLine;
var faCaretUp = {
  prefix: 'fal',
  iconName: 'caret-up',
  icon: [320, 512, [], "f0d8", "M154.4 162.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 275.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2L154.4 162.2zm-22-23.3L12.3 252.4C4.4 259.8 0 270.1 0 280.9C0 302.5 17.5 320 39.1 320H280.9c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.4L187.6 138.9c-7.4-7-17.3-10.9-27.6-10.9s-20.1 3.9-27.6 10.9z"]
};
var faShieldXmark = {
  prefix: 'fal',
  iconName: 'shield-xmark',
  icon: [512, 512, ["shield-times"], "e24c", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faShieldTimes = faShieldXmark;
var faScrewdriver = {
  prefix: 'fal',
  iconName: 'screwdriver',
  icon: [512, 512, [129691], "f54a", "M447.3 34.6l30.1 30.1L404.1 160H352V107.9l95.3-73.3zM342.7 192c.4 0 .9 0 1.3 0h64c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v64c0 .4 0 .9 0 1.3l-78.9 78.9c4.2 3.2 8.3 6.6 12.1 10.5s7.3 7.9 10.5 12.1L342.7 192zM208 304c17.7 17.7 17.7 46.3 0 64L96 480 32 416 144 304c17.7-17.7 46.3-17.7 64 0zm-86.6-22.6l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"]
};
var faCircleSortDown = {
  prefix: 'fal',
  iconName: 'circle-sort-down',
  icon: [512, 512, ["sort-circle-down"], "e031", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM244.7 411.3c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-192 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96zM198.6 320l114.7 0L256 377.4 198.6 320zM148.7 196.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 134.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96z"]
};
var faSortCircleDown = faCircleSortDown;
var faFolderClosed = {
  prefix: 'fal',
  iconName: 'folder-closed',
  icon: [512, 512, [], "e185", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v32H32V96zm0 128H480V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64z"]
};
var faHouseTsunami = {
  prefix: 'fal',
  iconName: 'house-tsunami',
  icon: [576, 512, [], "e515", "M32 200c0-92 78.8-168 177.9-168c20.6 0 40.4 3.3 58.7 9.4c8.4 2.8 17.4-1.8 20.2-10.2s-1.8-17.4-10.2-20.2C257.1 3.9 233.9 0 209.9 0C94.8 0 0 88.8 0 200C0 309.1 74 400 191.2 400c.1 0 .2 0 .3 0c.3 0 .6 0 .9 0c.2 0 .4 0 .6 0c29.9-.3 56.7-14.2 75.1-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 385.9 353.7 400 384 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 358 404.9 368 384 368s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 358 212.9 368 192 368v0c-66.4-.3-120-53.9-120-120c0-66.2 53.9-120 120.5-120c18.3 0 35.6 4 51 11.3c8 3.7 17.5 .3 21.3-7.7s.3-17.5-7.7-21.3C237.4 101.1 215.5 96 192.5 96C108.3 96 40 164 40 248c0 3 .1 6.1 .3 9.1C34.8 239.3 32 220.1 32 200zm320-56l96-72L543.5 144l.3 141.2c4.9 2.1 9.9 3.8 14.8 4.9c6.2 1.4 12 3.7 17.2 6.8l-.3-153c0-10-4.7-19.5-12.7-25.5L467.2 46.5c-11.4-8.6-27.1-8.6-38.5 0l-96 72c-8.1 6-12.8 15.5-12.8 25.6V265c1.7 1 3.3 2 4.8 3.1c8.6 5.9 17.8 10.7 27.2 14.2V144zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faSquareNfi = {
  prefix: 'fal',
  iconName: 'square-nfi',
  icon: [448, 512, [], "e576", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM75.7 160.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"]
};
var faForklift = {
  prefix: 'fal',
  iconName: 'forklift',
  icon: [640, 512, [], "f47a", "M160 0c-17.7 0-32 14.3-32 32V160H80c-44.2 0-80 35.8-80 80V384v32c0 53 43 96 96 96s96-43 96-96h64c0 53 43 96 96 96s96-43 96-96c0-28.4-12.4-54-32-71.6V288 259.5c0-4.7-1-9.3-3-13.5L306.8 18.5C301.6 7.2 290.2 0 277.8 0H160zM128 192h19.5l94.8 87.5C248.2 285 256 288 264 288H384v37.5c-10-3.5-20.8-5.5-32-5.5c-41.8 0-77.4 26.7-90.5 64H186.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4V240c0-26.5 21.5-48 48-48h48zm136 64L160 160V32l117.8 0L382.3 256H264zm88 224a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM96 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM512 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V16z"]
};
var faArrowUpFromGroundWater = {
  prefix: 'fal',
  iconName: 'arrow-up-from-ground-water',
  icon: [576, 512, [], "e4b5", "M288 352c8.8 0 16-7.2 16-16V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272 54.6V336c0 8.8 7.2 16 16 16zM64 192c-35.3 0-64 28.7-64 64V425c5.3-3.1 11.2-5.4 17.5-6.9c4.8-1.1 9.7-2.8 14.5-4.8V256c0-17.7 14.3-32 32-32H192V192H64zM576 425V256c0-35.3-28.7-64-64-64H384v32H512c17.7 0 32 14.3 32 32V413.3c4.8 2.1 9.7 3.7 14.5 4.8c6.3 1.5 12.1 3.8 17.5 6.9zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faBracketSquareRight = {
  prefix: 'fal',
  iconName: 'bracket-square-right',
  icon: [192, 512, [], "5d", "M192 80c0-26.5-21.5-48-48-48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48V80z"]
};
var faMartiniGlass = {
  prefix: 'fal',
  iconName: 'martini-glass',
  icon: [512, 512, [127864, "glass-martini-alt"], "f57b", "M32 33c0-.5 .4-1 1-1H479c.5 0 1 .4 1 1c0 .3-.1 .5-.3 .7l-94.4 94.4c-.4 0-.9-.1-1.3-.1H128c-.4 0-.9 0-1.3 .1L32.3 33.7c-.2-.2-.3-.4-.3-.7zM158.6 160H353.4L256 257.4 158.6 160zM9.7 56.3L240 286.6V480H144c-8.8 0-16 7.2-16 16s7.2 16 16 16H256 368c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V286.6L502.3 56.3c6.2-6.2 9.7-14.6 9.7-23.3c0-18.2-14.8-33-33-33H33C14.8 0 0 14.8 0 33c0 8.7 3.5 17.1 9.7 23.3z"]
};
var faGlassMartiniAlt = faMartiniGlass;
var faRotateLeft = {
  prefix: 'fal',
  iconName: 'rotate-left',
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M94.7 360.2c-3.2-5-8.7-8.2-14.7-8.2c-12.3 0-20.3 12.8-13.7 23.2C106 438.2 176.1 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7L78.6 56c-5.1-5.1-12.1-8-19.3-8C44.2 48 32 60.2 32 75.3V176c0 8.8 7.2 16 16 16H148.7c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3l-36-36C165.5 81.1 208.7 64 256 64c106 0 192 86 192 192s-86 192-192 192c-67.6 0-127.1-35-161.3-87.8zM64 86.6L137.4 160H64V86.6z"]
};
var faRotateBack = faRotateLeft;
var faRotateBackward = faRotateLeft;
var faUndoAlt = faRotateLeft;
var faTableColumns = {
  prefix: 'fal',
  iconName: 'table-columns',
  icon: [512, 512, ["columns"], "f0db", "M448 64c17.7 0 32 14.3 32 32v64L32 160l0-64c0-17.7 14.3-32 32-32l384 0zM32 416l0-224 208 0 0 256L64 448c-17.7 0-32-14.3-32-32zm240 32l0-256 208 0 0 224c0 17.7-14.3 32-32 32H272zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
};
var faColumns = faTableColumns;
var faSquareA = {
  prefix: 'fal',
  iconName: 'square-a',
  icon: [448, 512, [], "e25f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c6.1 0 11.6 3.4 14.3 8.8l112 224c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L294.1 320H153.9l-27.6 55.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l112-224c2.7-5.4 8.3-8.8 14.3-8.8zm0 51.8L169.9 288H278.1L224 179.8z"]
};
var faTick = {
  prefix: 'fal',
  iconName: 'tick',
  icon: [128, 512, [], "e32f", "M24.6 256.9C28.9 275.1 45.2 288 64 288s35.1-12.9 39.4-31.1L133.9 129c1.4-6 2.1-12.1 2.1-18.2V104c0-39.8-32.2-72-72-72S-8 64.2-8 104v6.8c0 6.1 .7 12.3 2.1 18.2L24.6 256.9zM24 104c0-22.1 17.9-40 40-40s40 17.9 40 40v6.8c0 3.6-.4 7.3-1.3 10.8L72.3 249.5c-.9 3.8-4.3 6.5-8.3 6.5s-7.4-2.7-8.3-6.5L25.3 121.6c-.8-3.5-1.3-7.2-1.3-10.8V104z"]
};
var faLemon = {
  prefix: 'fal',
  iconName: 'lemon',
  icon: [448, 512, [127819], "f094", "M368 64c-5.8 0-11.2 1-16.2 2.8c-18.9 6.8-44.1 12.9-70.1 7.1c-60.7-13.5-128.7 11-178.8 61s-74.5 118.1-61 178.8c5.8 26-.3 51.2-7.1 70.1C33 388.8 32 394.2 32 400c0 26.5 21.5 48 48 48c5.8 0 11.2-1 16.2-2.8c18.9-6.8 44.1-12.9 70.1-7.1c60.7 13.5 128.7-11 178.8-61s74.5-118.1 61-178.8c-5.8-26 .3-51.2 7.1-70.1c1.8-5 2.8-10.5 2.8-16.2c0-26.5-21.5-48-48-48zm0-32c44.2 0 80 35.8 80 80c0 9.5-1.7 18.6-4.7 27.1c-6 16.7-9.8 35-5.9 52.4c16.4 73.7-13.7 152.4-69.6 208.3s-134.7 86-208.3 69.6c-17.3-3.9-35.7-.1-52.4 5.9c-8.4 3-17.6 4.7-27.1 4.7c-44.2 0-80-35.8-80-80c0-9.5 1.7-18.6 4.7-27.1c6-16.7 9.8-35 5.9-52.4C-5.8 246.9 24.3 168.2 80.2 112.2s134.7-86 208.3-69.6c17.3 3.9 35.7 .1 52.4-5.9c8.4-3 17.6-4.7 27.1-4.7zM246.7 134.5L228.3 143c-51.8 23.9-93.4 65.5-117.3 117.3l-8.5 18.4c-3.7 8-13.2 11.5-21.2 7.8s-11.5-13.2-7.8-21.2l8.5-18.4c27.1-58.7 74.3-105.9 133-133l18.4-8.5c8-3.7 17.5-.2 21.2 7.8s.2 17.5-7.8 21.2z"]
};
var faHeadSideMask = {
  prefix: 'fal',
  iconName: 'head-side-mask',
  icon: [576, 512, [], "e063", "M78.7 150.2L276.5 272H288 511.7c-.9-6.6-4.1-12.7-9.2-17.2l-3.2-2.8c-32.6-29-50-70.3-65.4-106.9l0 0 0 0c-2.4-5.8-4.8-11.4-7.2-16.9C402.1 71.5 345.6 32 280 32H256C176.1 32 107.6 80.8 78.7 150.2zm-10 31.4C65.6 195.3 64 209.4 64 224c0 45.4 15.7 87.1 42.1 120c12.5 15.5 21.9 35.3 21.9 57.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V401.4c0-12.8-5.5-25.7-14.9-37.4C50.4 325.6 32 276.9 32 224C32 100.3 132.3 0 256 0h24c78.8 0 146.5 47.5 176.1 115.3c2.7 6.1 5.2 12.1 7.7 18.1l0 0 0 0c15.7 37.1 30.1 70.9 56.8 94.6l3.2 2.8c11.9 10.6 19.1 25.4 20.1 41.2h.1c0 10.6-1.5 21.2-4.4 31.4l-.2 .6L493.3 465.6c-7.8 27.5-33 46.4-61.5 46.4H288c-17.7 0-32-14.3-32-32V304v-7.1L68.7 181.7zM376 176a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM288 480H431.7c14.3 0 26.8-9.5 30.8-23.2l4.8-16.8H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H476.4l9.1-32H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H494.7l11.4-40H288V480z"]
};
var faHandshake = {
  prefix: 'fal',
  iconName: 'handshake',
  icon: [640, 512, [], "f2b5", "M263.9 64c-33.9 0-66.7 12-92.6 33.7L144 120.7v39.1c2.7-.5 5.3-1.7 7.4-3.5l40.5-34c13.3-11.2 28.9-19 45.5-23.1L272.6 64h-8.7zM112 352.5c8.1 1.3 15.7 5 21.6 10.8l46.1 44.6 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6c.8-.7 1.6-1.4 2.3-2.2c26.3 21.3 65.3 18.6 88.4-7.3c6-6.7 10.3-14.4 13-22.5c19.2 4 40-.8 55.7-14.8c11.3-10.1 18.2-23.2 20.6-37H528V368c0 26.5 21.5 48 48 48h16c26.5 0 48-21.5 48-48V160c0-17.7-14.3-32-32-32H560 528v32V318.8H473.1c-3.1-8.7-8.1-17-15.1-24l-85.6-85.6 8.1-7.5c6.5-6 6.9-16.1 .9-22.6s-16.1-6.9-22.6-.9l-76.1 70.2c-13.2 12.2-33.6 12.4-47 .4c-15.4-13.7-15.7-37.5-.8-51.6l79.4-75C332.2 105.4 355.8 96 380.4 96c22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.5 2.1 5.6 3.4 8.8 3.7V121.8L462.9 94.1C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35l-79.4 75c-28.6 27-27.9 72.7 1.5 98.8c25.8 22.9 64.7 22.5 90-.8l44.5-41 86.5 86.5c13 13 12.4 34.3-1.4 46.5c-10.9 9.7-26.7 10.6-38.6 3c-5-3.3-11.4-3.4-16.6-.5s-8.3 8.6-8 14.6c.4 8.1-2.3 16.3-8.1 22.9c-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8c-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-.3 .3-30.7-29.7c-11.9-11.5-27.4-18.5-43.8-20V160 128H80 32c-17.7 0-32 14.3-32 32V368c0 26.5 21.5 48 48 48H64c26.5 0 48-21.5 48-48V352.5zM80 160V368c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V160H80zm528 0V368c0 8.8-7.2 16-16 16H576c-8.8 0-16-7.2-16-16V160h48z"]
};
var faGem = {
  prefix: 'fal',
  iconName: 'gem',
  icon: [512, 512, [128142], "f3a5", "M128 32c-5.2 0-10.1 2.5-13.1 6.8l-112 160c-4.3 6.2-3.7 14.6 1.4 20.1l240 256c3 3.2 7.2 5.1 11.7 5.1s8.6-1.8 11.7-5.1l240-256c5.2-5.5 5.8-13.9 1.4-20.1l-112-160c-3-4.3-7.9-6.8-13.1-6.8H128zm.9 42.7L222.7 192H46.7L128.9 74.7zM52.9 224H256 459.1L256 440.6 52.9 224zm412.3-32h-176L383.1 74.7 465.3 192zM350.7 64L256 182.4 161.3 64H350.7z"]
};
var faDolly = {
  prefix: 'fal',
  iconName: 'dolly',
  icon: [576, 512, ["dolly-box"], "f472", "M24 0C15.2 0 8 7.2 8 16s7.2 16 16 16H88.9c6.9 0 13 4.4 15.2 10.9L211.6 365.4C190.1 379.8 176 404.2 176 432c0 44.2 35.8 80 80 80c43 0 78-33.9 79.9-76.4L565.5 351c8.3-3.1 12.5-12.3 9.5-20.5s-12.3-12.5-20.5-9.5L330.7 403.4C319.2 373.3 290.1 352 256 352c-5 0-9.9 .5-14.7 1.3L134.5 32.8C127.9 13.2 109.6 0 88.9 0H24zM256 384a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm96.8-201.1c3 8.3 12.2 12.6 20.5 9.6s12.6-12.2 9.6-20.5l-19.2-52.6 60.1-21.9 54.7 150.4L328.2 302.5 273.5 152.2l60.1-21.9 19.2 52.6zM243.4 163.1l54.7 150.4c6 16.6 24.4 25.2 41 19.1l150.4-54.7c16.6-6 25.2-24.4 19.1-41L453.9 86.5c-6-16.6-24.4-25.2-41-19.1L262.5 122.1c-16.6 6-25.2 24.4-19.1 41z"]
};
var faDollyBox = faDolly;
var faSmoking = {
  prefix: 'fal',
  iconName: 'smoking',
  icon: [640, 512, [128684], "f48d", "M464 0c-8.8 0-16 7.2-16 16V43c0 46.7 18.5 91.4 51.5 124.5l21 21c15 15 23.4 35.4 23.4 56.6v27c0 8.8 7.2 16 16 16s16-7.2 16-16V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C495.2 117.8 480 81.2 480 43V16c0-8.8-7.2-16-16-16zM624 288c8.8 0 16-7.2 16-16V245c0-46.7-18.5-91.4-51.5-124.5l-21-21C552.4 84.5 544 64.2 544 43V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v27c0 8.8 7.2 16 16 16zM64 384H192v96H64c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm160 0H480v96H224V384zM64 512H208 496c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H208 64c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64zM560 352c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-8.8-7.2-16-16-16z"]
};
var faMinimize = {
  prefix: 'fal',
  iconName: 'minimize',
  icon: [512, 512, ["compress-arrows-alt"], "f78c", "M507.3 27.3l-108 108 47.1 47.1c6 6 8.4 14.6 6.3 22.8l-.2 .6c-2.7 10.7-12.3 18.2-23.3 18.2H312c-13.3 0-24-10.7-24-24V82.7c0-11 7.5-20.6 18.2-23.3l.6-.2c8.2-2 16.8 .4 22.8 6.3l47.1 47.1 108-108c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM4.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l108 108 47.1-47.1c6-6 14.6-8.4 22.8-6.3l.6 .2C216.5 62.1 224 71.7 224 82.7V200c0 13.3-10.7 24-24 24H82.7c-11 0-20.6-7.5-23.3-18.2l-.2-.6c-2-8.2 .4-16.8 6.3-22.8l47.1-47.1L4.7 27.3zm502.6 480c-6.2 6.2-16.4 6.2-22.6 0l-108-108-47.1 47.1c-6 6-14.6 8.4-22.8 6.3l-.6-.2c-10.7-2.7-18.2-12.3-18.2-23.3V312c0-13.3 10.7-24 24-24H429.3c11 0 20.6 7.5 23.3 18.2l.2 .6c2 8.2-.4 16.8-6.3 22.8l-47.1 47.1 108 108c6.2 6.2 6.2 16.4 0 22.6zM4.7 484.7l108-108L65.6 329.6c-6-6-8.4-14.6-6.3-22.8l.2-.6C62.1 295.5 71.7 288 82.7 288H200c13.3 0 24 10.7 24 24V429.3c0 11-7.5 20.6-18.2 23.3l-.6 .2c-8.2 2-16.8-.4-22.8-6.3l-47.1-47.1-108 108c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM410.7 192L320 101.3V192h90.7zM192 101.3L101.3 192H192V101.3zM410.7 320H320v90.7L410.7 320zM192 410.7V320H101.3L192 410.7z"]
};
var faCompressArrowsAlt = faMinimize;
var faRefrigerator = {
  prefix: 'fal',
  iconName: 'refrigerator',
  icon: [384, 512, [], "e026", "M288 32c35.3 0 64 28.7 64 64v64H288V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H32V96c0-35.3 28.7-64 64-64H288zM256 192V368c0 8.8 7.2 16 16 16s16-7.2 16-16V192h64V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H256zM96 0C43 0 0 43 0 96V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V96c0-53-43-96-96-96H96z"]
};
var faMonument = {
  prefix: 'fal',
  iconName: 'monument',
  icon: [384, 512, [], "f5a6", "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.2 5.9 4.6 9.4l32 272c1 8.8-5.2 16.7-14 17.8s-16.7-5.2-17.8-14L256.8 103.4 192 38.6l-64.8 64.8L95.9 369.9c-1 8.8-9 15.1-17.8 14s-15.1-9-14-17.8l32-272c.4-3.6 2-6.9 4.6-9.4l80-80zM144 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16zM40 416H344c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V456c0-22.1 17.9-40 40-40zm-8 40v16c0 4.4 3.6 8 8 8H344c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8H40c-4.4 0-8 3.6-8 8z"]
};
var faOctagonXmark = {
  prefix: 'fal',
  iconName: 'octagon-xmark',
  icon: [512, 512, ["times-octagon", "xmark-octagon"], "f2f0", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM180.7 180.7c6.2-6.2 16.4-6.2 22.6 0L256 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faTimesOctagon = faOctagonXmark;
var faXmarkOctagon = faOctagonXmark;
var faAlignSlash = {
  prefix: 'fal',
  iconName: 'align-slash',
  icon: [640, 512, [], "f846", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM528 336c8.8 0 16-7.2 16-16s-7.2-16-16-16H484.1l40.5 32H528zm0-128c8.8 0 16-7.2 16-16s-7.2-16-16-16H322l40.5 32H528zm-372.1 0l-40.5-32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h43.9zM528 48H159.8l40.5 32H528c8.8 0 16-7.2 16-16s-7.2-16-16-16zM318 336l-40.5-32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H318zm121.6 96H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H480.2l-40.5-32z"]
};
var faSnowplow = {
  prefix: 'fal',
  iconName: 'snowplow',
  icon: [640, 512, [], "f7d2", "M128 32c0-17.7 14.3-32 32-32H298.9c19.2 0 36.6 11.4 44.1 29.1l85.1 198.6c2.6 6 3.9 12.4 3.9 18.9V288h96V240c0-3.7 1.3-7.4 3.7-10.2l80-96c5.7-6.8 15.7-7.7 22.5-2s7.7 15.7 2 22.5L560 245.8V394.2l76.3 91.5c5.7 6.8 4.7 16.9-2 22.5s-16.9 4.7-22.5-2l-80-96c-2.4-2.9-3.7-6.5-3.7-10.2V320H446.4c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112H112C50.1 512 0 461.9 0 400c0-44.7 26.2-83.2 64-101.2V168c0-22.1 17.9-40 40-40h24V32zM400 256H208c-5.3 0-10.3-2.7-13.3-7.1L135.4 160H104c-4.4 0-8 3.6-8 8V289.1c5.2-.7 10.6-1.1 16-1.1H368c11.1 0 21.9 1.6 32 4.6V256zM160 139.2L216.6 224H391.7L313.6 41.7c-2.5-5.9-8.3-9.7-14.7-9.7H160V139.2zM368 320H112c-44.2 0-80 35.8-80 80s35.8 80 80 80H368c44.2 0 80-35.8 80-80s-35.8-80-80-80zM120 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faAnglesRight = {
  prefix: 'fal',
  iconName: 'angles-right',
  icon: [512, 512, [187, "angle-double-right"], "f101", "M459.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256 276.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm-352 160l160-160c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256 84.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"]
};
var faAngleDoubleRight = faAnglesRight;
var faTruckRampCouch = {
  prefix: 'fal',
  iconName: 'truck-ramp-couch',
  icon: [640, 512, ["truck-couch"], "f4dd", "M352 80c0-44.2 35.8-80 80-80H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-26.5 0-48 21.5-48 48V379.1l35.8-9.8 .5-.1C433.6 322.4 476.8 288 528 288c61.9 0 112 50.1 112 112s-50.1 112-112 112c-60.7 0-110.1-48.2-111.9-108.4L20.2 511.4c-8.5 2.3-17.3-2.7-19.6-11.2s2.7-17.3 11.2-19.6l340.6-92.8c-.3-1.2-.4-2.5-.4-3.7V80zM608 400a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM225.7 128.2c36.4-9.8 73.6 4.8 94.3 33.7v75.5c-3.1-.4-6.3-.3-9.5 .6c-11.1 3-18.3 13.3-17.8 24.3c.8 15.1-9.1 28.6-23.7 32.5L127.6 332.8c-14.6 3.9-29.9-2.9-36.8-16.3c-5-9.9-16.5-15.2-27.6-12.2c-12.8 3.4-20.4 16.6-17 29.4l13.5 50.3c1.1 4.3 5.5 6.8 9.8 5.7l24.8-6.6c1.2-.3 2.4-.6 3.6-.8l180.3-48.3c.7-.2 1.5-.4 2.2-.5L320 322.7v33.1l-2.6 .7-30.9 8.3 0-.1-30.9 8.3L133.5 405.8 102.6 414l-.1-.2-24.8 6.6c-21.3 5.7-43.3-6.9-49-28.3L15.3 341.9c-3.9-14.7-1.6-29.7 5.3-42l-6.4-24C1.7 229 29.5 180.8 76.5 168.2l149.2-40zm8.3 30.9l-149.2 40c-29.9 8-47.6 38.7-39.6 68.6l2.2 8.3c2.4-1 5-1.9 7.6-2.6c26-7 52.6 5.5 64.3 28.5L260.8 264c-1.3-25.8 15.5-49.9 41.4-56.9c.8-.2 1.6-.4 2.4-.6l-2.1-7.8c-8-29.9-38.7-47.6-68.6-39.6z"]
};
var faTruckCouch = faTruckRampCouch;
var faCannabis = {
  prefix: 'fal',
  iconName: 'cannabis',
  icon: [512, 512, [], "f55f", "M269.3 7.1c-3-4.4-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1c-14.2 21.2-33.8 60-48 104.1c-10.3 31.7-18.1 67.2-18.7 101.4C124.5 176.5 61.4 156.8 27.1 150c-5.2-1-10.7 .6-14.4 4.4s-5.4 9.2-4.4 14.5c7.1 35.4 28.1 101.4 66.7 153.5c-21.4 8.8-40.3 19.5-52.8 26.6l0 0c-2.2 1.2-4.2 2.4-6 3.4c-5.1 2.8-8.2 8.2-8.2 14s3.2 11.2 8.2 14c14.1 7.8 41.4 22.7 72.2 33.1c20.7 7 44.6 12.7 67.8 11.8l-12.7 33c-2.3 6.1-.8 13 4 17.4s11.7 5.6 17.6 2.9l75-34.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V444.3l75 34.2c5.9 2.7 12.9 1.6 17.6-2.9s6.3-11.3 4-17.4l-12.7-33c23.2 .9 47.1-4.8 67.8-11.8c30.7-10.5 58.1-25.3 72.2-33.1c5.1-2.8 8.2-8.2 8.2-14s-3.2-11.2-8.2-14c-13-7.2-35.1-18.7-60.8-27.3c40-52.5 61.5-120.2 68.7-156.1c1.1-5.2-.6-10.7-4.4-14.5s-9.2-5.4-14.4-4.4c-34.3 6.8-97.4 26.5-148.9 62.6c-.6-34.2-8.4-69.8-18.7-101.4c-14.2-44-33.8-82.9-48-104.1zM272 409.1V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v73.1l-52.5 24 8.8-22.8c2.3-5.8 .9-12.4-3.5-16.9s-10.9-6-16.8-3.9c-20.8 7.4-48.7 3.3-77.2-6.4c-14.9-5-29-11.3-41-17.2c14.3-7.5 31.1-15.5 48.7-21c5.2-1.6 9.2-5.8 10.7-11s.1-10.9-3.5-14.9C79.1 280.5 57 226.4 45.9 187.5c41 11.6 98.7 35.2 137.7 72.3c5 4.8 12.5 5.8 18.6 2.5s9.4-10.1 8.2-16.9c-6.6-37.5 1.2-82.7 14.8-124.5c9.2-28.3 20.6-54.1 30.9-73.5c10.3 19.4 21.7 45.1 30.9 73.5c13.5 41.8 21.4 87 14.8 124.5c-1.2 6.8 2.1 13.6 8.2 16.9s13.6 2.2 18.6-2.5c39-37.1 96.7-60.7 137.7-72.3C454.6 227.7 431.4 284 395 322.7c-3.9 4.2-5.3 10.2-3.6 15.7s6.2 9.7 11.8 10.9c17.9 4 35.2 10.6 49.8 17.2c-11.8 5.7-25.4 11.7-39.7 16.6c-28.5 9.7-56.4 13.8-77.2 6.4c-5.9-2.1-12.5-.6-16.8 3.9s-5.7 11.1-3.5 16.9l8.8 22.8-52.5-24z"]
};
var faCirclePlay = {
  prefix: 'fal',
  iconName: 'circle-play',
  icon: [512, 512, [61469, "play-circle"], "f144", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.7-256L208 329.7V182.3L328.7 256zM212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z"]
};
var faPlayCircle = faCirclePlay;
var faArrowUpRightAndArrowDownLeftFromCenter = {
  prefix: 'fal',
  iconName: 'arrow-up-right-and-arrow-down-left-from-center',
  icon: [512, 512, [], "e0a0", "M292.7 196.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6V160c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16s7.2 16 16 16H457.4L292.7 196.7zM219.3 315.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L32 457.4V352c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16H160c8.8 0 16-7.2 16-16s-7.2-16-16-16H54.6L219.3 315.3z"]
};
var faTablets = {
  prefix: 'fal',
  iconName: 'tablets',
  icon: [640, 512, [], "f490", "M603.9 261.3c-3.4 4.1-6.9 8.1-10.8 11.9s-7.8 7.4-11.9 10.8c-62.8 51.5-155.7 47.9-214.4-10.8s-62.3-151.6-10.8-214.4c3.4-4.1 6.9-8.1 10.8-11.9s7.8-7.4 11.9-10.8c62.8-51.5 155.7-47.9 214.4 10.8s62.3 151.6 10.8 214.4zM570.5 69.5c-46.2-46.2-118.8-49.7-169-10.6L581.1 238.5c39.1-50.2 35.5-122.8-10.6-169zm-12 191.6L378.9 81.5c-39.1 50.2-35.5 122.8 10.6 169s118.8 49.7 169 10.6zM319.2 336c.5 5.3 .8 10.6 .8 16s-.3 10.7-.8 16c-8 80.9-76.2 144-159.2 144S8.8 448.9 .8 368c-.5-5.3-.8-10.6-.8-16s.3-10.7 .8-16C8.8 255.1 77 192 160 192s151.2 63.1 159.2 144zM160 224C94.7 224 40.9 272.9 33 336H287c-7.9-63.1-61.7-112-127-112zm0 256c65.3 0 119.1-48.9 127-112H33c7.9 63.1 61.7 112 127 112z"]
};
var fa360Degrees = {
  prefix: 'fal',
  iconName: '360-degrees',
  icon: [640, 512, [], "e2dc", "M608 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H127.3L35.4 214.2c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9H80c44.2 0 80 35.8 80 80v16c0 44.2-35.8 80-80 80H74.5c-12.7 0-24.9-5.1-33.9-14.1L27.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l13.3 13.3c15 15 35.4 23.4 56.6 23.4H80c61.9 0 112-50.1 112-112V320c0-61.6-49.8-111.6-111.3-112L172.6 89.8c3.8-4.8 4.4-11.4 1.7-16.9s-8.3-9-14.4-9H16zm432 80c0-26.5 21.5-48 48-48s48 21.5 48 48V368c0 26.5-21.5 48-48 48s-48-21.5-48-48V144zM576 368V144c0-44.2-35.8-80-80-80s-80 35.8-80 80V368c0 44.2 35.8 80 80 80s80-35.8 80-80zM256 176c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112V288l0 .2V368c0 44.2 35.8 80 80 80s80-35.8 80-80V272c0-44.2-35.8-80-80-80c-18 0-34.6 6-48 16V176zm48 48c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48s-48-21.5-48-48V272c0-26.5 21.5-48 48-48z"]
};
var faEthernet = {
  prefix: 'fal',
  iconName: 'ethernet',
  icon: [512, 512, [], "f796", "M128 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H400 304 208 112 32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H64V160c0-17.7 14.3-32 32-32h32V96zm224 0H160v48c0 8.8-7.2 16-16 16H96v48c0 8.8-7.2 16-16 16H32V416H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64V224H432c-8.8 0-16-7.2-16-16V160H368c-8.8 0-16-7.2-16-16V96z"]
};
var faEuroSign = {
  prefix: 'fal',
  iconName: 'euro-sign',
  icon: [320, 512, [8364, "eur", "euro"], "f153", "M34.3 224c-1.5 10.5-2.3 21.1-2.3 32s.8 21.5 2.3 32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H41.3C68.8 412.5 154.5 480 256 480h49c8.8 0 16-7.2 16-16s-7.2-16-16-16H256c-83.6 0-154.7-53.4-181.1-128H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H66.7c-1.7-10.4-2.7-21.1-2.7-32s.9-21.6 2.7-32H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H74.9C101.3 117.4 172.4 64 256 64h49c8.8 0 16-7.2 16-16s-7.2-16-16-16H256C154.5 32 68.8 99.5 41.3 192H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H34.3z"]
};
var faEur = faEuroSign;
var faEuro = faEuroSign;
var faChair = {
  prefix: 'fal',
  iconName: 'chair',
  icon: [448, 512, [129681], "f6c0", "M192 32V224H160V37.5C122.7 50.6 96 86.2 96 128v96H64V128C64 57.3 121.3 0 192 0h64c70.7 0 128 57.3 128 128v96H352V128c0-41.8-26.7-77.4-64-90.5V224H256V32H192zM64 288L32 352l384 0-32-64H64zM35.4 273.7C40.8 262.8 51.9 256 64 256H384c12.1 0 23.2 6.8 28.6 17.7l32 64c5 9.9 4.4 21.7-1.4 31.1s-16.1 15.2-27.2 15.2l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H64V496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l32-64z"]
};
var faCircleCheck = {
  prefix: 'fal',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faCheckCircle = faCircleCheck;
var faSquareDashedCirclePlus = {
  prefix: 'fal',
  iconName: 'square-dashed-circle-plus',
  icon: [576, 512, [], "e5c2", "M112 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-30.9 0-56 25.1-56 56v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V120C0 71.4 39.4 32 88 32h24zM0 304V208c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16zm16 48c8.8 0 16 7.2 16 16v24c0 30.9 25.1 56 56 56h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-48.6 0-88-39.4-88-88V368c0-8.8 7.2-16 16-16zM433.3 192.6c-9.1 .8-17.3-6.1-17.3-15.3V120c0-30.9-25.1-56-56-56H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h24c48.6 0 88 39.4 88 88v57.4c0 8.1-6.7 14.6-14.7 15.2zM160 464c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zM272 64H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMoneySimpleFromBracket = {
  prefix: 'fal',
  iconName: 'money-simple-from-bracket',
  icon: [640, 512, [], "e313", "M80 32C53.5 32 32 53.5 32 80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80C0 35.8 35.8 0 80 0H560c44.2 0 80 35.8 80 80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-26.5-21.5-48-48-48H80zM496 96c8.8 0 16 7.2 16 16l0 344c0 30.9-25.1 56-56 56H184c-30.9 0-56-25.1-56-56l0-344c0-8.8 7.2-16 16-16s16 7.2 16 16l0 344c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24l0-344c0-8.8 7.2-16 16-16zM320 208c-47 0-80 31.3-80 64s33 64 80 64s80-31.3 80-64s-33-64-80-64zm112 64c0 55.6-53 96-112 96s-112-40.4-112-96s53-96 112-96s112 40.4 112 96z"]
};
var faBat = {
  prefix: 'fal',
  iconName: 'bat',
  icon: [576, 512, [], "f6b5", "M366.3 187.7c8.9 4.5 19.3 4.6 28.3 .4l71.8-34.2c3.1-1.5 6.8-.7 9 1.9C519.7 207.5 544 273.2 544 341.2v7L507.6 330c-22.4-11.2-49.7-3.3-62.6 18.2l-19.3 32.2-22.1-22.1c-20.5-20.5-54.3-18.3-72 4.7L288 419.5l-43.5-56.6c-17.7-23-51.5-25.2-72-4.7l-22.1 22.1-19.3-32.2c-12.9-21.5-40.2-29.5-62.6-18.2L32 348.2v-7c0-68 24.3-133.7 68.6-185.4c2.2-2.6 5.9-3.4 9-1.9l71.8 34.2c9 4.3 19.4 4.1 28.3-.4s15.1-12.9 16.9-22.6L240.3 92l15.3 10.2c9.6 6.4 20.9 9.8 32.4 9.8s22.8-3.4 32.4-9.8L335.7 92l13.7 73.1c1.8 9.8 8.1 18.1 16.9 22.6zM358.2 77l0 0-9.9-14.9L358.2 77s0 0 0 0zm16.6 49.7L362.2 59.5c-1.3-6.7-7.1-11.5-13.9-11.5c-2.8 0-5.5 .8-7.8 2.4L302.7 75.6c-4.3 2.9-9.4 4.4-14.7 4.4s-10.3-1.5-14.7-4.4L235.6 50.4c-2.3-1.5-5-2.4-7.8-2.4c-6.8 0-12.6 4.8-13.9 11.5l-12.6 67.2-6.1 32.5L165.3 145 123.4 125c-16.2-7.7-35.5-3.6-47.1 10C27.1 192.4 0 265.6 0 341.2v37.6c0 9.7 10.2 16 18.9 11.7l63.8-31.9c7.5-3.7 16.6-1.1 20.9 6.1l29.8 49.7c5.4 8.9 17.7 10.4 25 3.1l36.6-36.6c6.8-6.8 18.1-6.1 24 1.6l56.2 73.1c6.4 8.3 19 8.3 25.4 0l56.2-73.1c5.9-7.7 17.2-8.4 24-1.6l36.6 36.6c7.4 7.4 19.7 5.8 25-3.1l29.8-49.7c4.3-7.2 13.4-9.8 20.9-6.1l63.8 31.9c8.7 4.3 18.9-2 18.9-11.7V341.2c0-75.6-27.1-148.8-76.3-206.2c-11.6-13.6-30.9-17.7-47.1-10L410.7 145l-29.9 14.2-6.1-32.5z"]
};
var faCircleStop = {
  prefix: 'fal',
  iconName: 'circle-stop',
  icon: [512, 512, [62094, "stop-circle"], "f28d", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192zm32 0V320H320V192H192z"]
};
var faStopCircle = faCircleStop;
var faHeadSideHeadphones = {
  prefix: 'fal',
  iconName: 'head-side-headphones',
  icon: [512, 512, [], "f8c2", "M176 38v62.6c10.1-3 20.9-4.6 32-4.6s21.9 1.6 32 4.6V32H224c-16.6 0-32.7 2.1-48 6zM144 49.4C77.9 79.7 32 146.5 32 224c0 45.4 15.7 87.1 42.1 120C86.5 359.5 96 379.3 96 401.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V401.4c0-12.8-5.5-25.7-14.9-37.4C18.4 325.6 0 276.9 0 224C0 100.3 100.3 0 224 0h16c78.6 0 150.8 47.3 182.7 115.3c3.8 8.1 7.3 16 10.8 23.8l0 0 0 0 0 0c5.9 13.2 11.6 26 18.2 38.7c10.3 19.6 21.7 36.8 36.9 50.3l3.2 2.8c12.8 11.4 20.2 27.8 20.2 45c0 33.2-26.9 60.2-60.2 60.2H448v48c0 35.3-28.7 64-64 64H320v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-8.8 7.2-16 16-16h80c17.7 0 32-14.3 32-32V320c0-8.8 7.2-16 16-16h19.8c15.6 0 28.2-12.6 28.2-28.2c0-8-3.4-15.7-9.5-21.1l-3.2-2.8c-19.2-17.1-32.8-38.1-44-59.4c-7-13.5-13.5-28-19.8-42l0 0 0 0 0 0c-3.4-7.5-6.6-14.9-9.9-21.7C371.5 81.4 325.2 45.6 272 35.1v81c29 20.2 48 53.9 48 91.9c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-38.1 19-71.7 48-91.9V49.4zM288 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faPhoneRotary = {
  prefix: 'fal',
  iconName: 'phone-rotary',
  icon: [512, 512, [9742], "f8d3", "M32 142.4V192h72.9L86.6 224H32c-17.7 0-32-14.3-32-32V141.3c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1V192c0 17.7-14.3 32-32 32H425.4l-18.3-32H480V142.4C453 120.1 373.2 64 256 64S59 120.1 32 142.4zm0-1.1s0 0 0 0v0zM32 401c0-11.1 2.9-22.1 8.4-31.8l101.1-177c10.5-18.4 29.5-30.4 50.4-32V128c0-8.8 7.2-16 16-16s16 7.2 16 16v32h64V128c0-8.8 7.2-16 16-16s16 7.2 16 16v32.2c21 1.7 39.9 13.6 50.4 32l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8v31c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V401zM304 192H208 197.1c-11.5 0-22.1 6.2-27.8 16.1L68.2 385.1C65.5 390 64 395.4 64 401v31c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V401c0-5.6-1.5-11-4.2-15.9l-101.1-177c-5.7-10-16.3-16.1-27.8-16.1H304zM208 320a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
var faCompassDrafting = {
  prefix: 'fal',
  iconName: 'compass-drafting',
  icon: [512, 512, ["drafting-compass"], "f568", "M320 96A64 64 0 1 0 192 96a64 64 0 1 0 128 0zm-21.7 86.2c-12.8 6.3-27.1 9.8-42.3 9.8s-29.5-3.5-42.3-9.8L142.2 307.4C176.1 325.6 214.8 336 256 336c88.8 0 166.4-48.2 207.9-120c4.4-7.6 14.2-10.3 21.9-5.8s10.3 14.2 5.8 21.9c-47 81.3-134.9 136-235.6 136c-47 0-91.1-11.9-129.7-32.8L29.9 503.9c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l97-169.8c-32.1-22.7-59-52.1-78.7-86.2c-4.4-7.6-1.8-17.4 5.8-21.9s17.4-1.8 21.9 5.8c16.9 29.2 39.8 54.6 67 74.3l72.5-126.9C170.5 146.1 160 122.3 160 96c0-53 43-96 96-96s96 43 96 96c0 26.3-10.5 50.1-27.6 67.4l48.4 84.7c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6l-46.7-81.7zM409 375.9c-4.4-7.7-1.7-17.4 6-21.8s17.4-1.7 21.8 6l73.1 128c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6L409 375.9z"]
};
var faDraftingCompass = faCompassDrafting;
var faPlateWheat = {
  prefix: 'fal',
  iconName: 'plate-wheat',
  icon: [512, 512, [], "e55a", "M224 112v5.3c-18.6-6.6-32-24.4-32-45.3V66.7c18.6 6.6 32 24.4 32 45.3zM160 48V72c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM48 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm16 96c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM336 117.3c-18.6-6.6-32-24.4-32-45.3V66.7c18.6 6.6 32 24.4 32 45.3v5.3zM288 32c-8.8 0-16 7.2-16 16V72c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80zm160 80v5.3c-18.6-6.6-32-24.4-32-45.3V66.7c18.6 6.6 32 24.4 32 45.3zM384 48V72c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM304 253.3V248c0-20.9 13.4-38.7 32-45.3V208c0 20.9-13.4 38.7-32 45.3zM352 168c-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V184c0-8.8-7.2-16-16-16zM192 248c0-20.9 13.4-38.7 32-45.3V208c0 20.9-13.4 38.7-32 45.3V248zm64-64c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V184zm160 69.3V248c0-20.9 13.4-38.7 32-45.3V208c0 20.9-13.4 38.7-32 45.3zM464 168c-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V184c0-8.8-7.2-16-16-16zM129.8 441.1c-5.5-9.5-15.5-15.6-26.5-16C64 423.6 32.5 391.5 32 352H480c-.5 39.5-32 71.6-71.3 73.1c-11 .4-21 6.5-26.5 16c-2.4 4.2-6.9 6.9-11.9 6.9H141.7c-5 0-9.5-2.7-11.9-6.9zM31 320c-17.1 0-31 13.9-31 31c0 57.3 45.3 103.9 102.1 106.1c7.9 13.7 22.7 22.9 39.6 22.9H370.3c17 0 31.8-9.2 39.6-22.9C466.7 454.9 512 408.2 512 351c0-17.1-13.9-31-31-31H31z"]
};
var faCalendarCircleMinus = {
  prefix: 'fal',
  iconName: 'calendar-circle-minus',
  icon: [576, 512, [], "e46f", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192H352h64 16 16V160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-144c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]
};
var faChopsticks = {
  prefix: 'fal',
  iconName: 'chopsticks',
  icon: [640, 512, [], "e3f7", "M43.6 464.5L333.7 42.7C339 36.1 346.9 32 355.7 32C371.1 32 384 44.7 384 61c0 6.7-2.2 12.8-5.9 17.7L43.6 464.5zM355.7 0c-19.4 0-36.5 9.2-47.5 23.4l-.3 .4-.3 .4L6.2 462.4c-10 13.4-7.7 32.4 5.5 42.9c13.3 10.6 32.5 8.3 43-4.8L402.6 99.3l.3-.3 .3-.4C411.2 88.2 416 75.1 416 61c0-33.5-26.8-61-60.3-61zM174.6 467.9L560.4 102.7c5-4.2 11.5-6.7 18.6-6.7c16.2 0 29 12.9 29 28.6c0 8.5-3.7 16.1-9.8 21.4L174.6 467.9zM579 64c-15.1 0-29 5.5-39.6 14.5l-.3 .3-.3 .3L138.5 458c-12.7 11.1-14.1 30.4-3 43.3c11 12.8 30.3 14.3 43.2 3.7L618 171.2l.3-.3 .3-.3c13-11.1 21.4-27.6 21.4-46C640 91 612.5 64 579 64z"]
};
var faCarWrench = {
  prefix: 'fal',
  iconName: 'car-wrench',
  icon: [512, 512, ["car-mechanic"], "f5e3", "M88 40c22 0 41 12.6 50.2 31.1l4.4 8.9h9.9 207 9.9l4.4-8.9C383 52.6 402 40 424 40c25.4 0 46.8 16.9 53.7 40H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h45.7c-6.9 23.1-28.3 40-53.7 40c-22 0-41-12.6-50.2-31.1l-4.4-8.9h-9.9-207-9.9l-4.4 8.9C129 139.4 110 152 88 152c-25.4 0-46.8-16.9-53.7-40H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H34.3C41.2 56.9 62.6 40 88 40zM0 96c0 48.6 39.4 88 88 88c30.9 0 58.1-15.9 73.8-40H350.2c15.7 24.1 42.9 40 73.8 40c48.6 0 88-39.4 88-88s-39.4-88-88-88c-30.9 0-58.1 15.9-73.8 40H161.8C146.1 23.9 118.9 8 88 8C39.4 8 0 47.4 0 96zM188.2 208H323.8c14.3 0 26.8 9.5 30.8 23.2L370.8 288c-.9 0-1.9 0-2.8 0H144c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L105 298.1C80.6 311.8 64 338 64 368v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H416v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H188.2c-28.6 0-53.7 18.9-61.5 46.4zM416 416v16H96V416 368c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v48zM144 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCarMechanic = faCarWrench;
var faIcicles = {
  prefix: 'fal',
  iconName: 'icicles',
  icon: [512, 512, [], "f7ad", "M0 36.6C0 16.4 16.4 0 36.6 0H474.1C495 0 512 17 512 37.9c0 2.4-.2 4.8-.7 7.2L423.7 499c-1.5 7.5-8.1 13-15.8 13s-14.3-5.5-15.7-13.1l-58.5-312-30.2 121c-1.8 7-8.1 12-15.3 12.1s-13.7-4.7-15.6-11.7l-22-79.4L215.7 403.1c-1.5 7.5-8.1 12.9-15.7 12.9s-14.2-5.4-15.7-12.9L148.1 222.2l-28.9 86.8C117 315.6 110.9 320 104 320s-13-4.4-15.2-10.9L1.9 48.2C.6 44.5 0 40.6 0 36.6zM36.6 32c-2.6 0-4.6 2.1-4.6 4.6c0 .5 .1 1 .2 1.5L104 253.4l32.8-98.5c2.3-6.9 8.9-11.4 16.2-10.9s13.3 5.7 14.7 12.8L200 318.4l32.3-161.6c1.5-7.3 7.7-12.6 15.1-12.9s14 4.6 16 11.7l23.8 85.6 33.3-133.2c1.8-7.3 8.5-12.3 16-12.1s13.9 5.7 15.2 13l56.5 301.3L479.9 39c.1-.4 .1-.7 .1-1.1c0-3.3-2.6-5.9-5.9-5.9H36.6z"]
};
var faPersonShelter = {
  prefix: 'fal',
  iconName: 'person-shelter',
  icon: [512, 512, [], "e54f", "M264.2 2.3c-5.1-3-11.4-3-16.5 0l-240 144C2.9 149.2 0 154.4 0 160V496c0 8.8 7.2 16 16 16s16-7.2 16-16V169.1L256 34.7 480 169.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-5.6-2.9-10.8-7.8-13.7l-240-144zM240 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-72 97.5c3.8-1 7.7-1.5 11.8-1.5h24.5c4 0 8 .5 11.8 1.5V368H232V265.5zM232 400h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V291.5l42.4 68.9c4.6 7.5 14.5 9.9 22 5.2s9.9-14.5 5.2-22l-45.3-73.5C321.8 246.4 296 232 268.2 232H243.8c-27.8 0-53.6 14.4-68.1 38.1l-45.3 73.5c-4.6 7.5-2.3 17.4 5.2 22s17.4 2.3 22-5.2L200 291.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V400z"]
};
var faNeuter = {
  prefix: 'fal',
  iconName: 'neuter',
  icon: [384, 512, [9906], "f22c", "M48 176a144 144 0 1 1 288 0A144 144 0 1 1 48 176zM208 351.3c89.7-8.1 160-83.5 160-175.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 91.8 70.3 167.2 160 175.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V351.3z"]
};
var faIdBadge = {
  prefix: 'fal',
  iconName: 'id-badge',
  icon: [384, 512, [], "f2c1", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM224 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm0-144c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zM112 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48H160c-26.5 0-48 21.5-48 48z"]
};
var faKazoo = {
  prefix: 'fal',
  iconName: 'kazoo',
  icon: [640, 512, [], "f8c7", "M416 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM523.3 352c22.8-25.5 36.7-59.1 36.7-96c0-37.3-14.2-71.2-37.4-96.8c.2 .3 .5 .5 .7 .8H576c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H523.3s0 0 0 0zM482 384h94c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H482c-19.8-10.2-42.2-16-66-16s-46.3 5.8-66 16H241.7c-11.8 0-23.4 1.6-34.7 4.8c-39.3 11.1-136.7 38.7-184 52.5C9.4 189.3 0 201.8 0 216v80c0 14.2 9.4 26.7 23 30.7c47.3 13.8 144.7 41.4 184 52.5c11.3 3.2 23 4.8 34.7 4.8H350c19.8 10.2 42.2 16 66 16s46.3-5.8 66-16zM308.7 352h-67c-8.8 0-17.6-1.2-26-3.6L207 379.2l8.7-30.8C176.4 337.3 79.1 309.7 32 296l0-80c47.1-13.7 144.4-41.3 183.7-52.4c8.5-2.4 17.2-3.6 26-3.6h67c-22.8 25.5-36.7 59.1-36.7 96s13.9 70.5 36.7 96zm56-147.3c-6.2 6.2-6.2 16.4 0 22.6L393.4 256l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L416 278.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L438.6 256l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L416 233.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faMarker = {
  prefix: 'fal',
  iconName: 'marker',
  icon: [512, 512, [], "f5a1", "M330.3 97L353 74.3l20.7-20.7c23.4-23.4 61.3-23.4 84.7 0s23.4 61.3 0 84.7L293.7 303 209 218.3 330.3 97zm-144 144L271 325.7l-64.2 64.2c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4L186.3 241zM307.7 74.3L285.1 97 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L481 161c35.9-35.9 35.9-94.1 0-129.9S386.9-4.8 351 31L330.3 51.7 317.3 38.6c-25-25-65.5-25-90.5 0l-94 94 0 0c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l94.1-94.1c9.1-9.1 22.3-11.6 33.6-7.4c4.2 1.5 8.2 4 11.6 7.4l13.1 13.1z"]
};
var faBinBottles = {
  prefix: 'fal',
  iconName: 'bin-bottles',
  icon: [640, 512, [], "e5f5", "M384 16c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM352 192H320c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64H32c0-53 43-96 96-96H256c24.9 0 47.6 9.5 64.6 25c19.3 17.6 31.4 42.9 31.4 71zm223.1 0H542.6c-.9-3.3-2.2-6.4-4-9.2c-6.9-10.7-6.8-24.5 .4-35.1c3-4.4 4.7-9.7 4.7-15.5c0-10.8-6.2-20.6-16-25.2l-13.1-6.2c-6.7-3.2-14.1-4.8-21.5-4.8H402.3c-7.4 0-14.8 1.6-21.5 4.8L367.6 107c-3.8 1.8-7.1 4.4-9.7 7.6c-6.5-8.5-14.1-16.2-22.5-22.9c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c11-5.1 23-7.8 35.1-7.8h90.6C505 64 517 66.7 528 71.8L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5zm2.6 32h18.6 9.8H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H606.1L584.3 441.3c-4.7 40.3-38.9 70.7-79.5 70.7H135.1c-40.6 0-74.7-30.4-79.5-70.7L33.9 256H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H33.9h9.8H62.3 577.7zM66.1 256L87.5 437.6c2.8 24.2 23.3 42.4 47.7 42.4H504.9c24.3 0 44.8-18.2 47.7-42.4L573.9 256H66.1zM160 0h64c17.7 0 32 14.3 32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V32H160V48c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16c0-17.7 14.3-32 32-32z"]
};
var faFaceLaughBeam = {
  prefix: 'fal',
  iconName: 'face-laugh-beam',
  icon: [512, 512, [128513, "laugh-beam"], "f59a", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288H385.5c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm30-99.5c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 155.9 157.2 146 176 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 155.9 317.2 146 336 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"]
};
var faLaughBeam = faFaceLaughBeam;
var faSquareArrowDownLeft = {
  prefix: 'fal',
  iconName: 'square-arrow-down-left',
  icon: [448, 512, [], "e261", "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm280-64c8.8 0 16-7.2 16-16s-7.2-16-16-16H182.6L315.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 297.4V192c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16H280z"]
};
var faBatteryBolt = {
  prefix: 'fal',
  iconName: 'battery-bolt',
  icon: [576, 512, [], "f376", "M80 384h66.4c1 12.1 6.2 23.4 14.4 32H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80H276l-33.8 32H80c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48zm156 32l33.8-32H432c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H365.6c-1-12.1-6.2-23.4-14.4-32H432c44.2 0 80 35.8 80 80V336c0 44.2-35.8 80-80 80H236zM560 192c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM191.7 264H240c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L320.3 248H272c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L191.7 264zM313.6 112c14.7 0 24.4 15.2 18.2 28.5L297 216h49.4c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L212.2 394.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L215 296H165.6c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L299.8 117.5c3.7-3.5 8.7-5.5 13.8-5.5z"]
};
var faTreeLarge = {
  prefix: 'fal',
  iconName: 'tree-large',
  icon: [448, 512, [], "f7dd", "M224 0c4.8 0 9.3 2.2 12.4 5.9L377.7 178.6c4.1 5 6.3 11.2 6.3 17.6c0 15.3-12.4 27.8-27.8 27.8H337.3l72.6 90.8c4 4.9 6.1 11.1 6.1 17.4c0 15.4-12.5 27.8-27.8 27.8H366.9l76 107.6c3.4 4.7 5.2 10.4 5.2 16.2c0 15.5-12.6 28.1-28.1 28.1H288 160 28.1C12.6 512 0 499.4 0 483.9c0-5.8 1.8-11.5 5.2-16.2L81.1 360H59.8C44.5 360 32 347.5 32 332.2c0-6.3 2.2-12.5 6.1-17.4L110.7 224H91.8C76.4 224 64 211.6 64 196.2c0-6.4 2.2-12.6 6.3-17.6L211.6 5.9c3-3.7 7.6-5.9 12.4-5.9zM160 480H288 412.4L322.9 353.2c-3.4-4.9-3.9-11.3-1.1-16.6s8.2-8.6 14.2-8.6h43.5l-88-110c-3.8-4.8-4.6-11.4-1.9-16.9s8.3-9.1 14.4-9.1h43.3L224 41.3 100.7 192H144c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9l-88 110H112c6 0 11.5 3.3 14.2 8.6s2.3 11.7-1.1 16.6L35.6 480H160z"]
};
var faHelicopterSymbol = {
  prefix: 'fal',
  iconName: 'helicopter-symbol',
  icon: [512, 512, [], "e502", "M469.7 224H502C487.9 110.9 400 20.7 288 3.1V35.6c94.3 17 168.1 93 181.7 188.4zM502 288H469.7C456.1 383.4 382.3 459.4 288 476.4v32.5C400 491.3 487.9 401.1 502 288zM-6 288C8.7 406.5 104.4 499.8 224 510.9V478.7C122.1 467.9 40.7 388.8 26.3 288H-6zm0-64H26.3C40.7 123.2 122.1 44.1 224 33.3V1.1C104.5 12.2 8.8 105.5-6 224zm182-80c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V272H336v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96H176V144z"]
};
var faAperture = {
  prefix: 'fal',
  iconName: 'aperture',
  icon: [512, 512, [], "e2df", "M256 480c-6.1 0-12.1-.2-18.1-.7L316 344l13.8-23.9c0 0 .1-.1 .1-.1l18.5-32 67 116.1 3.3 5.8C377.9 453.1 320.1 480 256 480zm73.9-288H464h6.7c6 20.3 9.3 41.8 9.3 64c0 47.3-14.6 91.1-39.7 127.3L362.2 248l-13.7-23.7c0-.1-.1-.2-.1-.3l-18.5-32zm-55.2-32c-.1 0-.2 0-.2 0h-37l67-116.1 3.4-5.8C374.6 53.9 429.7 99.5 458.4 160H302.2 274.7zM256 32c6.1 0 12.1 .2 18.1 .7L196 168l-13.9 24-18.5 32 0 0-67-116.1-3.3-5.8C134.1 58.9 191.9 32 256 32zM32 256c0-47.3 14.6-91.1 39.7-127.3L149.8 264l32.3 56H48 41.3c-6-20.3-9.3-41.8-9.3-64zM204.1 473.9C137.4 458.1 82.3 412.5 53.6 352H209.8h64.7l-67 116.1-3.4 5.8zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm46.1-207.9c-5.7 9.8-16.3 15.9-27.7 15.9H237.5c-11.4 0-22-6.1-27.7-16l-18.5-32c-5.7-9.9-5.7-22.1 0-32l18.5-32c5.7-9.9 16.2-15.9 27.5-16h37.3c11.3 .1 21.7 6.1 27.4 15.8l18.7 32.4c5.6 9.8 5.6 21.9 0 31.7c0 0 0 .1-.1 .1l-18.5 32c0 0 0 .1-.1 .1z"]
};
var faUniversalAccess = {
  prefix: 'fal',
  iconName: 'universal-access',
  icon: [512, 512, [], "f29a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM129.7 200.8c-4 7.9-.7 17.5 7.2 21.5l21.1 10.5c16 8 32.8 14 50.1 17.8v67.7l-15.7 78.4c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6L237.1 336h37.8l13.4 67.1c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L304 318.4V250.7c17.3-3.9 34.1-9.9 50.1-17.8l21.1-10.5c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-21.1 10.5c-26 13-54.7 19.8-83.8 19.8s-57.8-6.8-83.8-19.8l-21.1-10.5c-7.9-4-17.5-.7-21.5 7.2zM240 255.4c5.3 .4 10.7 .6 16 .6s10.7-.2 16-.6V304H240V255.4z"]
};
var faGearComplex = {
  prefix: 'fal',
  iconName: 'gear-complex',
  icon: [512, 512, [], "e5e9", "M215 62.8l4.9-24.3-15.7-3.1 15.7 3.1c.3-1.5 1-2.8 1.9-3.8C232.9 32.9 244.4 32 256 32s23.1 .9 34.2 2.6c1 1.1 1.6 2.4 1.9 3.8L297 62.8c2.9 14.4 13.2 25.2 25.5 30.3l0 0 1.5 .6 0 0c12.3 5.2 27.3 4.8 39.5-3.3l20.6-13.8c1.2-.8 2.6-1.3 4.1-1.3c9.1 6.7 17.7 14 25.6 21.9l.8 .8 0 0c7.9 8 15.3 16.5 21.9 25.6c-.1 1.4-.5 2.8-1.3 4.1l-13.8 20.6c-8.1 12.2-8.5 27.1-3.3 39.5l0 0 .6 1.5 0 0c5.1 12.4 15.9 22.6 30.3 25.5l24.3 4.9c1.5 .3 2.8 1 3.8 1.9c1.7 11.1 2.6 22.4 2.6 34v.4c0 11.6-.9 22.9-2.6 34c-1.1 1-2.4 1.6-3.8 1.9L449.2 297c-14.4 2.9-25.2 13.2-30.3 25.5l0 0-.6 1.5 0 0c-5.2 12.3-4.8 27.3 3.3 39.5l13.8 20.6c.8 1.2 1.3 2.6 1.3 4.1c-13.6 18.5-29.9 34.9-48.4 48.4c-1.4-.1-2.8-.5-4.1-1.3l-20.6-13.8c-12.2-8.1-27.1-8.5-39.5-3.3l0 0-1.5 .6 0 0c-12.4 5.1-22.6 15.9-25.5 30.3l-4.9 24.3c-.3 1.5-1 2.8-1.9 3.8c-11.1 1.7-22.6 2.6-34.2 2.6s-23.1-.9-34.2-2.6c-1-1.1-1.6-2.4-1.9-3.8L215 449.2c-2.9-14.4-13.2-25.2-25.5-30.3l0 0-1.5-.6 0 0c-12.3-5.2-27.3-4.8-39.5 3.3l-20.6 13.8c-1.2 .8-2.6 1.3-4.1 1.3c-18.5-13.6-34.9-29.9-48.4-48.4c.1-1.4 .5-2.8 1.3-4.1l13.8-20.6c8.1-12.2 8.5-27.1 3.3-39.5l0 0-.6-1.5 0 0c-5.1-12.4-15.9-22.6-30.3-25.5l-24.3-4.9c-1.5-.3-2.8-1-3.8-1.9C32.9 279.1 32 267.6 32 256s.9-23.1 2.6-34.2c1.1-1 2.4-1.6 3.8-1.9L62.8 215c14.4-2.9 25.2-13.2 30.3-25.5l0 0 .6-1.5 0 0c5.2-12.3 4.8-27.3-3.3-39.5L76.6 127.7c-.8-1.2-1.3-2.6-1.3-4.1c6.7-9.1 14-17.7 22-25.7l.8-.8 0 0c8-7.9 16.6-15.3 25.7-22c1.4 .1 2.8 .5 4.1 1.3l20.6 13.8c12.2 8.1 27.1 8.5 39.5 3.3l0 0 1.5-.6 0 0c12.4-5.1 22.7-15.9 25.5-30.3zM256 0c-14.8 0-29.3 1.3-43.4 3.7c-2 .3-3.9 1-5.6 2.1c-9.4 5.6-16.3 15.1-18.6 26.4l-4.9 24.3c-.5 2.6-2.6 5.4-6.3 6.9l0 0-.1 0-1.7 .7 0 0-.1 0c-3.7 1.5-7.1 1-9.4-.4L145.5 50c-9.6-6.4-21.2-8.2-31.7-5.6c-1.9 .5-3.8 1.3-5.4 2.5C96.6 55.2 85.6 64.4 75.4 74.5l0 0-.8 .8 0 0C64.4 85.6 55.2 96.6 46.9 108.3c-1.2 1.6-2 3.5-2.5 5.4c-2.6 10.6-.8 22.1 5.6 31.7l13.8 20.6c1.5 2.2 2 5.7 .4 9.4l0 .1-.7 1.7 0 0 0 .1c-1.5 3.7-4.3 5.8-6.9 6.3l-24.3 4.9c-11.4 2.3-20.8 9.2-26.4 18.6c-1 1.7-1.7 3.6-2.1 5.6C1.3 226.7 0 241.2 0 256s1.3 29.3 3.7 43.4c.3 2 1 3.9 2.1 5.6c5.6 9.4 15.1 16.3 26.4 18.6l24.3 4.9c2.6 .5 5.4 2.6 6.9 6.3l0 .1 .7 1.7 0 .1c1.5 3.7 1 7.1-.4 9.4L50 366.5c-6.4 9.6-8.2 21.2-5.6 31.7c.5 1.9 1.3 3.8 2.5 5.4c16.8 23.8 37.6 44.6 61.5 61.5c1.6 1.2 3.5 2 5.4 2.5c10.6 2.6 22.1 .8 31.7-5.6l20.6-13.8c2.2-1.5 5.7-2 9.4-.4l.1 0 1.7 .7 .1 0c3.7 1.5 5.8 4.3 6.3 6.9l4.9 24.3c2.3 11.4 9.2 20.8 18.6 26.4c1.7 1 3.6 1.7 5.6 2.1c14.1 2.4 28.6 3.7 43.4 3.7s29.3-1.3 43.4-3.7c2-.3 3.9-1 5.6-2.1c9.4-5.6 16.3-15.1 18.6-26.4l4.9-24.3c.5-2.6 2.6-5.4 6.3-6.9l.1 0 1.7-.7 .1 0c3.7-1.5 7.1-1 9.4 .4L366.5 462c9.6 6.4 21.2 8.2 31.7 5.6c1.9-.5 3.8-1.3 5.4-2.5c23.8-16.8 44.6-37.6 61.5-61.4c1.2-1.6 2-3.5 2.5-5.4c2.6-10.6 .8-22.1-5.6-31.7l-13.8-20.6c-1.5-2.2-2-5.7-.4-9.4l0-.1 .7-1.7 0-.1c1.5-3.7 4.3-5.8 6.9-6.3l24.3-4.9-3.1-15.7 3.1 15.7c11.4-2.3 20.8-9.2 26.4-18.6c1-1.7 1.7-3.6 2.1-5.6c2.4-14 3.7-28.5 3.7-43.2v0-.4 0c0-14.7-1.3-29.1-3.7-43.2c-.3-2-1-3.9-2.1-5.6c-5.6-9.4-15.1-16.3-26.4-18.6l-24.3-4.9c-2.6-.5-5.4-2.6-6.9-6.3l0-.1-.7-1.7 0-.1c-1.5-3.7-1-7.1 .4-9.4L462 145.5c6.4-9.6 8.2-21.2 5.6-31.7c-.5-1.9-1.3-3.8-2.5-5.4c-8.3-11.7-17.5-22.7-27.6-32.9l0 0-.9-.9 0 0c-10.1-10.1-21.1-19.3-32.9-27.6c-1.6-1.2-3.5-2-5.4-2.5c-10.6-2.6-22.1-.8-31.7 5.6L345.9 63.7c-2.2 1.5-5.7 2-9.4 .4l-.1 0-1.7-.7-.1 0c-3.7-1.5-5.8-4.3-6.3-6.9l-4.9-24.3c-2.3-11.4-9.2-20.8-18.6-26.4c-1.7-1-3.6-1.7-5.6-2.1C285.3 1.3 270.8 0 256 0zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faFileMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'file-magnifying-glass',
  icon: [384, 512, ["file-search"], "f865", "M240 320a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-8.4 78.3C215.9 409.4 196.7 416 176 416c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 20.7-6.6 39.9-17.7 55.6l45.1 45.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-45.1-45.1zM352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"]
};
var faFileSearch = faFileMagnifyingGlass;
var faUpRight = {
  prefix: 'fal',
  iconName: 'up-right',
  icon: [384, 512, [], "e2be", "M312 128c4.4 0 8 3.6 8 8V337.4c0 3.7-3 6.6-6.6 6.6c-1.8 0-3.4-.7-4.7-1.9l-61.4-61.4c-6.2-6.2-16.4-6.2-22.6 0L112 393.4c-4.2 4.2-10 6.6-16 6.6s-11.8-2.4-16-6.6L54.6 368c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16L167.3 223.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-61.4-61.4c-1.2-1.2-1.9-2.9-1.9-4.7c0-3.7 3-6.6 6.6-6.6H312zm40 8c0-22.1-17.9-40-40-40H110.6C89.3 96 72 113.3 72 134.6c0 10.2 4.1 20.1 11.3 27.3L133.4 212 32 313.4C21.8 323.6 16 337.5 16 352s5.8 28.4 16 38.6L57.4 416c10.2 10.2 24.1 16 38.6 16s28.4-5.8 38.6-16L236 314.6l50.1 50.1c7.2 7.2 17.1 11.3 27.3 11.3c21.3 0 38.6-17.3 38.6-38.6V136z"]
};
var faCircleChevronUp = {
  prefix: 'fal',
  iconName: 'circle-chevron-up',
  icon: [512, 512, ["chevron-circle-up"], "f139", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM379.3 276.7l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 198.6 356.7 299.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"]
};
var faChevronCircleUp = faCircleChevronUp;
var faUserPolice = {
  prefix: 'fal',
  iconName: 'user-police',
  icon: [448, 512, [], "e333", "M217.1 .8l-144 32C61.7 35.3 52.5 43.8 49.3 55.1s-.2 23.3 8.1 31.6L80 109.3v1.6c0 15.6 7.6 31.8 23.2 40.1c22.5 12 59.5 25 120.8 25s98.3-13.1 120.8-25c15.5-8.2 23.2-24.5 23.2-40.1v-1.6l22.6-22.6-6.2-6.2 6.2 6.2c8.3-8.3 11.4-20.4 8.1-31.6s-12.4-19.8-23.8-22.3l-144-32c-4.6-1-9.3-1-13.9 0zM224 32L368 64 340.7 91.3c-3 3-4.7 7.1-4.7 11.3v8.2c0 5.8-2.8 10-6.2 11.8c-11.9 6.3-30.3 13.8-58.4 18C284.2 121.1 288 98.9 288 83.2c0-6.5-4-12.4-10.1-14.9l-48-19.2c-3.8-1.5-8.1-1.5-11.9 0l-48 19.2C164 70.8 160 76.7 160 83.2c0 15.7 3.8 37.9 16.5 57.5c-28.1-4.2-46.5-11.7-58.4-18c-3.4-1.8-6.2-6-6.2-11.8v-8.2c0-4.2-1.7-8.3-4.7-11.3L80 64 224 32zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.9-.1-5.8-.3-8.7c-9.1 4.3-19.6 8.5-31.8 12.1C318.1 246.9 275.9 288 224 288s-94.1-41.1-95.9-92.6c-12.2-3.6-22.7-7.8-31.8-12.1c-.2 2.9-.3 5.8-.3 8.7zm128-49.7C203.5 131 195.1 111 192.7 93.7L224 81.2l31.3 12.5C252.9 111 244.5 131 224 142.3zM191.4 429.5c18.4 17 46.7 17 65.1 0L305.8 384h7.8c54.4 0 98.9 42.4 102.2 96H336V464h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16H32.2c3.3-53.6 47.8-96 102.2-96h7.8l49.3 45.5zM320.3 512H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352h-7.8c-8 0-15.8 3-21.7 8.5L234.9 406c-6.1 5.7-15.6 5.7-21.7 0l-49.3-45.5c-5.9-5.5-13.7-8.5-21.7-8.5h-7.8C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512H319.7c.1 0 .2 0 .3 0s.2 0 .3 0z"]
};
var faLariSign = {
  prefix: 'fal',
  iconName: 'lari-sign',
  icon: [384, 512, [], "e1c8", "M144 32c8.8 0 16 7.2 16 16V98.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v58.9c62.8 22.2 110.7 76.2 124.2 142.7c1.8 8.7-3.8 17.1-12.5 18.9s-17.1-3.8-18.9-12.5c-10.5-51.6-45.7-94.1-92.8-114.7L256 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-140.8c-10.3-2.1-21-3.2-32-3.2s-21.7 1.1-32 3.2L160 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-130.7C71.5 166 32 222.4 32 288c0 88.4 71.6 160 160 160H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H192 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H85.8C34.1 413.6 0 354.8 0 288c0-83.6 53.4-154.7 128-181.1V48c0-8.8 7.2-16 16-16z"]
};
var faVolcano = {
  prefix: 'fal',
  iconName: 'volcano',
  icon: [512, 512, [127755], "f770", "M213 58.7c-2.5 5-7.4 8.3-12.9 8.8s-11-2-14.3-6.4c-5.9-7.9-15.2-13-25.8-13c-17.7 0-32 14.3-32 32s14.3 32 32 32c9.7 0 18.3-4.3 24.2-11.1c3.1-3.6 7.7-5.6 12.4-5.5s9.2 2.3 12.2 6l46.7 58.4c.1 .2 .3 .2 .5 .2s.4-.1 .5-.2l46.7-58.4c3-3.7 7.4-5.9 12.2-6s9.3 1.9 12.4 5.5c5.9 6.8 14.5 11.1 24.2 11.1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-10.6 0-19.9 5.1-25.8 13c-3.3 4.5-8.7 6.9-14.3 6.4s-10.5-3.8-12.9-8.8C291.1 42.8 274.8 32 256 32s-35.1 10.8-43 26.7zM256 0c23.9 0 45.3 10.5 60 27.1c10.3-7 22.6-11.1 36-11.1c35.3 0 64 28.7 64 64s-28.7 64-64 64c-12.5 0-24.2-3.6-34.1-9.8l-36.4 45.6c-6.2 7.7-15.6 12.3-25.5 12.3s-19.3-4.5-25.5-12.3l-36.4-45.6c-9.9 6.2-21.5 9.8-34.1 9.8c-35.3 0-64-28.7-64-64s28.7-64 64-64c13.4 0 25.8 4.1 36 11.1C210.7 10.5 232.1 0 256 0zM32 459.8C32 471 41 480 52.2 480H459.8c11.1 0 20.2-9 20.2-20.2c0-4.9-1.8-9.7-5.1-13.4L387 347.5 362 385c-6.3 9.4-16.8 15-28 15c-8.9 0-17.5-3.6-23.8-9.9l-34.5-34.5C263.1 343.1 246 336 228.3 336c-13.2 0-26.1 3.9-37.1 11.2l-17.8 11.9c-8.7 5.8-18.9 8.9-29.3 8.9s-20.6-3.1-29.3-8.9L37.1 446.4c-3.3 3.7-5.1 8.5-5.1 13.4zm303.4-92.6L365 322.8l-40.3-45.3c-12.1-13.7-29.6-21.5-47.8-21.5H235.1c-18.3 0-35.7 7.8-47.8 21.5l-50.8 57.1c2.4 .9 4.9 1.4 7.5 1.4c4.1 0 8.1-1.2 11.6-3.5l17.8-11.9c16.3-10.8 35.4-16.6 54.9-16.6c26.2 0 51.4 10.4 70 29l34.5 34.5c.3 .3 .8 .5 1.2 .5c.6 0 1.1-.3 1.4-.8zm13.3-111l34.7 39.1 0 0 22 24.7 0 0 93.5 105.2c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l74.6-84 21.5-24.1 54.1-60.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2z"]
};
var faTeddyBear = {
  prefix: 'fal',
  iconName: 'teddy-bear',
  icon: [576, 512, [], "e3cf", "M160 64c0 12.5 7.2 23.4 17.8 28.7c6.9 3.4 10.3 11.2 8.3 18.6c-1.3 4.8-2.1 10.4-2.1 16.7c0 51.3 44.7 96 104 96s104-44.7 104-96c0-6.4-.8-11.9-2.1-16.7c-2-7.4 1.5-15.2 8.3-18.6C408.8 87.4 416 76.5 416 64c0-17.7-14.3-32-32-32c-15.1 0-27.8 10.5-31.2 24.7c-2 8.6-10.5 13.9-19.1 12C319 65.3 303 64 288 64s-31 1.3-45.7 4.6c-8.6 1.9-17.1-3.4-19.1-12C219.8 42.5 207.1 32 192 32c-17.7 0-32 14.3-32 32zM192 0c24.8 0 46.4 14.2 57 34.8c13.3-2 26.6-2.8 39-2.8s25.7 .8 39 2.8C337.6 14.2 359.2 0 384 0c35.3 0 64 28.7 64 64c0 20.6-9.8 38.9-24.9 50.6c.6 4.3 .9 8.8 .9 13.4c0 70.7-60.9 128-136 128s-136-57.3-136-128c0-4.6 .3-9.1 .9-13.4C137.8 102.9 128 84.6 128 64c0-35.3 28.7-64 64-64zm96 184c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zM56 190c27.6-22.1 67.9-17.6 90 10l10.8 13.5c67.3 84.1 195.1 84.1 262.4 0L430 200c22.1-27.6 62.4-32.1 90-10s32.1 62.4 10 90l-10.8 13.5c-27 33.7-59.5 59.8-95.1 78.2V384h26c7.1-27.6 32.2-48 62-48c35.3 0 64 28.7 64 64c0 35.7-15.5 70.2-25.3 88.7c-8.1 15.3-24 23.3-39.9 23.3H464l-.1 0H112.1l-.1 0H65.1c-15.9 0-31.8-8-39.9-23.3C15.5 470.2 0 435.7 0 400c0-35.3 28.7-64 64-64c29.8 0 54.9 20.4 62 48h26V371.7c-35.6-18.4-68.2-44.5-95.1-78.2L46 280c-22.1-27.6-17.6-67.9 10-90zm55.9 290l.1 0h96V464c0-26.5-21.5-48-48-48v0H112c-8.8 0-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 27.6 12.4 56.4 21.5 73.7c1.9 3.6 6.1 6.3 11.6 6.3h46.8zM184 387.7c4 1.3 7.9 2.8 11.6 4.7C205.7 359.7 236.1 336 272 336h32c35.9 0 66.3 23.7 76.4 56.3c3.7-1.8 7.6-3.4 11.6-4.7V361.8c0-6.2 3.6-11.8 9.2-14.5c34.9-16.5 66.8-41.1 93-73.8L505 260c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-10.8 13.5c-80.1 100.1-232.3 100.1-312.3 0L121 220c-11-13.8-31.2-16-45-5s-16 31.2-5 45l10.8 13.5c26.2 32.7 58.1 57.3 93 73.8c5.6 2.6 9.2 8.3 9.2 14.5v25.9zM224 416c10 13.4 16 30 16 48v16h96V464c0-18 6-34.6 16-48c0-26.5-21.5-48-48-48H272c-26.5 0-48 21.5-48 48zm192 0c-26.5 0-48 21.5-48 48v16h96l.1 0h46.8c5.5 0 9.7-2.7 11.6-6.3c9.2-17.3 21.5-46.1 21.5-73.7c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16H416v0zM240 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faStocking = {
  prefix: 'fal',
  iconName: 'stocking',
  icon: [384, 512, [], "f7d5", "M96 32H352V80H96V32zM64 32V80c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96C78.3 0 64 14.3 64 32zm64 206.9V144H96v94.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9v2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5V144H320V315.5c0 32.1-16 62.1-42.7 79.9L173.2 464.7c-14.9 9.9-32.4 15.3-50.4 15.3C72.7 480 32 439.3 32 389.2v-2.2c0-31.1 15.6-60.2 41.4-77.4l26.1-17.4c17.8-11.9 28.5-31.9 28.5-53.3z"]
};
var faPersonWalkingDashedLineArrowRight = {
  prefix: 'fal',
  iconName: 'person-walking-dashed-line-arrow-right',
  icon: [640, 512, [], "e553", "M176 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 144 56a56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L240.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2L66.9 422.5 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zM416 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V80c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM538.2 163.7c-6.8-5.7-16.9-4.7-22.5 2s-4.7 16.9 2 22.5L579.8 240H384c-8.8 0-16 7.2-16 16s7.2 16 16 16H579.8l-62.1 51.7c-6.8 5.7-7.7 15.7-2 22.5s15.7 7.7 22.5 2l96-80c3.6-3 5.8-7.5 5.8-12.3s-2.1-9.3-5.8-12.3l-96-80zM400 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm16 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336zm-16 80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V432c0-8.8-7.2-16-16-16z"]
};
var faImageSlash = {
  prefix: 'fal',
  iconName: 'image-slash',
  icon: [640, 512, [], "e1b7", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 96c0-35.3-28.7-64-64-64H139.6l40.5 32H512c17.7 0 32 14.3 32 32V265.4l-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0l-31 31 25.3 20 28.4-28.4c3.1-3.1 8.2-3.1 11.3 0L544 310.6v40.7l32 25.3V96zM297.6 319.8l-9.6 9.6-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0L96 329.4V160.7L64 135.4V416c0 35.3 28.7 64 64 64H500.4l-40.5-32H214.6L322.8 339.8l-25.3-20zM265.4 352l-96 96H128c-17.7 0-32-14.3-32-32V374.6l90.3-90.3c3.1-3.1 8.2-3.1 11.3 0L265.4 352z"]
};
var faMaskSnorkel = {
  prefix: 'fal',
  iconName: 'mask-snorkel',
  icon: [576, 512, [], "e3b7", "M560 32c8.8 0 16 7.2 16 16V160H544V48c0-8.8 7.2-16 16-16zM448 480c53 0 96-43 96-96V192h32V384c0 70.7-57.3 128-128 128s-128-57.3-128-128V368c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 53 43 96 96 96zM64 96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h79.7c14.3 0 26.8-9.5 30.8-23.2l3.4-11.7c13.3-46.4 79-46.4 92.3 0l3.4 11.7c3.9 13.7 16.5 23.2 30.8 23.2H384c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H384c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H304.3c-28.6 0-53.7-18.9-61.5-46.4l-3.4-11.7c-4.4-15.5-26.3-15.5-30.8 0l-3.4 11.7c-7.9 27.5-33 46.4-61.5 46.4H64c-35.3 0-64-28.7-64-64V128z"]
};
var faSmoke = {
  prefix: 'fal',
  iconName: 'smoke',
  icon: [640, 512, [], "f760", "M160 32c-53 0-96 43-96 96c0 28.1 12 53.3 31.2 70.8c-11.2 3.2-21.9 7.5-32.1 12.8C43.7 189.2 32 160 32 128C32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298.1 32 320 32c44.3 0 83.4 22.5 106.4 56.8c-9.1 5.8-17.5 12.4-25.3 19.8C384.1 81.8 354.1 64 320 64c-20.8 0-40 6.6-55.7 17.8c-3.6 2.6-8.1 3.5-12.4 2.7s-8.1-3.5-10.4-7.2C224.5 50 194.3 32 160 32zM144 256C82.1 256 32 306.1 32 368s50.1 112 112 112H464c44.2 0 80-35.8 80-80s-35.8-80-80-80c-11.7 0-22.7 2.5-32.7 7c-4 1.8-8.6 1.9-12.7 .2s-7.3-5-8.8-9.1c-13.7-36.3-48.8-62-89.8-62c-28.9 0-54.8 12.8-72.4 33c-2.9 3.4-7.1 5.4-11.6 5.5s-8.8-1.6-11.9-4.8C203.7 268.9 175.4 256 144 256zM0 368c0-79.5 64.5-144 144-144c34.5 0 66.2 12.1 90.9 32.3C257.5 236.2 287.3 224 320 224c49.1 0 91.8 27.7 113.2 68.3c9.8-2.8 20.1-4.3 30.8-4.3c61.9 0 112 50.1 112 112s-50.1 112-112 112H144C64.5 512 0 447.5 0 368zM608 224c0-53-43-96-96-96c-41.3 0-76.6 26.1-90.1 62.8c-2 5.4-6.7 9.3-12.4 10.3s-11.4-1.2-15-5.7C376.8 173.8 350 160 320 160c-38.7 0-72.1 22.9-87.3 56c-9.2-5.4-18.9-9.9-29-13.6C224 158.5 268.4 128 320 128c31.4 0 60.1 11.3 82.3 30c22.4-37.1 63.1-62 109.7-62c70.7 0 128 57.3 128 128c0 42.2-20.4 79.6-51.9 102.9c-5.5-9.2-11.9-17.8-19.2-25.6C592.6 283.9 608 255.7 608 224z"]
};
var faSterlingSign = {
  prefix: 'fal',
  iconName: 'sterling-sign',
  icon: [320, 512, [163, "gbp", "pound-sign"], "f154", "M80 152c0-48.6 39.4-88 88-88h7.1c9.5 0 18.9 1.5 27.8 4.5l80 26.7c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-80-26.7c-12.2-4.1-25-6.2-37.9-6.2H168C101.7 32 48 85.7 48 152V256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H47.9C46.3 346.2 31 403.1 3.1 454.3l-1.1 2c-2.7 5-2.6 11 .3 15.8S10.4 480 16 480H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H42.1c23.5-50.1 36.4-104.6 37.8-160H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H80V152z"]
};
var faGbp = faSterlingSign;
var faPoundSign = faSterlingSign;
var faBatteryExclamation = {
  prefix: 'fal',
  iconName: 'battery-exclamation',
  icon: [576, 512, [], "e0b0", "M208 96H80C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H216.6c-5.4-9.4-8.6-20.3-8.6-32H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H208V96zM432 416c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H336v32h96c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H336c0 11.7-3.1 22.6-8.6 32H432zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM272 96c-8.8 0-16 7.2-16 16V296c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm24 280a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faViruses = {
  prefix: 'fal',
  iconName: 'viruses',
  icon: [640, 512, [], "e076", "M78.9 327.8l15.2-15.2c30.2-30.2 81.9-8.8 81.9 33.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V346.5c0-42.8 51.7-64.2 81.9-33.9l15.2 15.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-15.2-15.2c-30.2-30.2-8.8-81.9 33.9-81.9H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H346.5c-42.8 0-64.2-51.7-33.9-81.9l15.2-15.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.9 71.4C259.7 101.7 208 80.3 208 37.5V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V37.5c0 42.8-51.7 64.2-81.9 33.9L78.9 56.2c-6.2-6.2-16.4-6.3-22.6 0s-6.2 16.4 0 22.6L71.4 94.1c30.2 30.2 8.8 81.9-33.9 81.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H37.5c42.8 0 64.2 51.7 33.9 81.9L56.2 305.1c-6.2 6.2-6.3 16.4 0 22.6s16.4 6.2 22.6 0zm7-135.8c22.8-17.4 34.9-46.6 31.1-75c28.5 3.8 57.6-8.3 75-31.1c8.4 11 19.5 19.5 32 24.9c13.4 5.8 28.3 8.1 43 6.1c-3.8 28.5 8.3 57.6 31.1 75c-22.8 17.4-34.9 46.6-31.1 75c-28.5-3.8-57.6 8.3-75 31.1c-17.4-22.8-46.6-34.9-75-31.1c3.8-28.5-8.3-57.6-31.1-75zm82.1 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM496 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm101.8 95.2C574.5 423.9 591 384 624 384c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C551.9 289.5 512 273 512 240c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C417.5 312.1 401 352 368 352c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C440.1 446.5 480 463 480 496c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM579.5 368c-17 14.5-26.3 36.8-24.5 59.1c-22.3-1.8-44.6 7.4-59.1 24.5c-14.5-17-36.8-26.3-59.1-24.5c1.8-22.3-7.4-44.6-24.5-59.1c17-14.5 26.3-36.8 24.5-59.1c22.3 1.8 44.6-7.4 59.1-24.5c8.5 10 19.7 17.3 32 21.3c8.7 2.8 17.9 3.9 27.1 3.2c-1.8 22.3 7.4 44.6 24.5 59.1z"]
};
var faSquarePersonConfined = {
  prefix: 'fal',
  iconName: 'square-person-confined',
  icon: [448, 512, [], "e577", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm296 96c30.9 0 56 25.1 56 56V360c0 30.9-25.1 56-56 56c-25.1 0-48.8-11.5-64.4-31.3l-53.5-68.2-52.2 91.4c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l64-112c2.6-4.6 7.4-7.6 12.7-8s10.5 1.9 13.8 6.1L240 343.6V248c0-30.9 25.1-56 56-56zm24 168V248c0-13.3-10.7-24-24-24s-24 10.7-24 24V360c0 13.3 10.7 24 24 24s24-10.7 24-24zM232 152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z"]
};
var faUserTie = {
  prefix: 'fal',
  iconName: 'user-tie',
  icon: [448, 512, [], "f508", "M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm96 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h9.8l-21.7 65-32.1-69.5c-2.9-6.3-9.5-10-16.3-8.8C56.8 336.5 0 402.3 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-79-56.8-144.7-131.8-158.6c-6.8-1.3-13.4 2.5-16.3 8.8L267.9 401l-21.7-65H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H224 192zm17.5 160.5l-9.7-21.1L224 370.6l24.3 72.8-9.7 21.1c-5.7 12.4-23.3 12.4-29.1 0zm-29.1 13.4c.3 .7 .7 1.4 1 2.1H32c.6-58.1 39.5-107.1 92.7-122.8l55.7 120.7zM416 480H266.6c.3-.7 .7-1.4 1-2.1l55.7-120.7c53.2 15.7 92.1 64.6 92.7 122.8z"]
};
var faArrowDownLong = {
  prefix: 'fal',
  iconName: 'arrow-down-long',
  icon: [384, 512, ["long-arrow-down"], "f175", "M180.7 507.3c6.2 6.2 16.4 6.2 22.6 0l144-144c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 457.4 208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 441.4L59.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l144 144z"]
};
var faLongArrowDown = faArrowDownLong;
var faTentArrowDownToLine = {
  prefix: 'fal',
  iconName: 'tent-arrow-down-to-line',
  icon: [640, 512, [], "e57e", "M243.8 117.2c-5.9-6.5-16.1-7-22.6-1.1L160 171.8 160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 155.8L66.8 116.2c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6l88 80c6.1 5.5 15.4 5.5 21.5 0l88-80c6.5-5.9 7-16.1 1.1-22.6zM0 496c0 8.8 7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM393.5 131.1c-5.7-4.2-13.4-4.2-19 0L201 259.3c-10.1 7.5-16.9 18.7-18.9 31.1l-22 139c-1.4 8.7 4.6 16.9 13.3 18.3s16.9-4.6 18.3-13.3l22-139.1c.7-4.1 2.9-7.9 6.3-10.4L368 175.7V287.8c0 .2 0 .3 0 .5V432c0 8.8 7.2 16 16 16s16-7.2 16-16V340.8l66.7 100c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L400 283.2V175.7L547.9 285.1c3.4 2.5 5.6 6.2 6.3 10.4l22 139.1c1.4 8.7 9.6 14.7 18.3 13.3s14.7-9.6 13.3-18.3l-22-139c-2-12.4-8.7-23.6-18.9-31.1L393.5 131.1z"]
};
var faCertificate = {
  prefix: 'fal',
  iconName: 'certificate',
  icon: [512, 512, [], "f0a3", "M170.7 108.3c7.5-4.3 12.9-11.5 15-19.8l12.3-48.6 35 36c6 6.2 14.3 9.7 22.9 9.7s16.9-3.5 22.9-9.7l35-36 12.3 48.6c2.1 8.4 7.5 15.5 15 19.8s16.4 5.4 24.7 3.1l48.3-13.6L400.6 146c-2.3 8.3-1.2 17.2 3.1 24.7s11.5 12.9 19.8 15l48.6 12.3-36 35c-6.2 6-9.7 14.3-9.7 22.9s3.5 16.9 9.7 22.9l36 35-48.6 12.3c-8.4 2.1-15.5 7.5-19.8 15s-5.4 16.4-3.1 24.7l13.6 48.3L366 400.6c-8.3-2.3-17.2-1.2-24.7 3.1s-12.9 11.5-15 19.8l-12.3 48.6-35-36c-6-6.2-14.3-9.7-22.9-9.7s-16.9 3.5-22.9 9.7l-35 36-12.3-48.6c-2.1-8.4-7.5-15.5-15-19.8s-16.4-5.4-24.7-3.1L97.8 414.2 111.4 366c2.3-8.3 1.2-17.2-3.1-24.7s-11.5-12.9-19.8-15L39.8 313.9l36-35c6.2-6 9.7-14.3 9.7-22.9s-3.5-16.9-9.7-22.9l-36-35 48.6-12.3c8.4-2.1 15.5-7.5 19.8-15s5.4-16.4 3.1-24.7L97.8 97.8 146 111.4c8.3 2.3 17.2 1.2 24.7-3.1zM49.6 162.6l-31.5 8c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l23.3 22.6L53.5 256 30.5 278.3 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l31.5 8 31 7.9-8.7 30.8-8.8 31.2c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l31.2-8.8 30.8-8.7 7.9 31 8 31.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l22.6-23.3L256 458.5l22.3 22.9L301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l8-31.5 7.9-31 30.8 8.7 31.2 8.8c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-8.8-31.2-8.7-30.8 31-7.9 31.5-8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-23.3-22.6L458.5 256l22.9-22.3L504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-31.5-8-31-7.9 8.7-30.8 8.8-31.2c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-31.2 8.8-30.8 8.7-7.9-31-8-31.5c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L278.3 30.5 256 53.5 233.7 30.5 211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-8 31.5-7.9 31-30.8-8.7L92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l8.8 31.2 8.7 30.8-31 7.9z"]
};
var faCrystalBall = {
  prefix: 'fal',
  iconName: 'crystal-ball',
  icon: [448, 512, [], "e362", "M416 224c0 49.2-18.5 94-48.9 128h40.7c25.3-36.3 40.2-80.4 40.2-128C448 100.3 347.7 0 224 0S0 100.3 0 224c0 47.6 14.8 91.7 40.2 128H80.9C50.5 318 32 273.2 32 224C32 118 118 32 224 32s192 86 192 192zM64 384c-5.6 0-10.8 2.9-13.7 7.8l-46.2 77C1.4 473.2 0 478.3 0 483.5C0 499.2 12.8 512 28.5 512H419.5c15.8 0 28.5-12.8 28.5-28.5c0-5.2-1.4-10.2-4.1-14.7l-46.2-77c-2.9-4.8-8.1-7.8-13.7-7.8H64zM34.7 480l38.4-64H374.9l38.4 64H34.7zM288 144c-8.8 0-16 7.2-16 16v48H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V240h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-8.8-7.2-16-16-16zM144 96c-8.8 0-16 7.2-16 16v16H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V112c0-8.8-7.2-16-16-16z"]
};
var faReplyAll = {
  prefix: 'fal',
  iconName: 'reply-all',
  icon: [576, 512, ["mail-reply-all"], "f122", "M202.8 59.8c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1L24.8 178.4c-17.5 15.9-17.5 43.3 0 59.2L181.2 379.8c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L46.3 213.9c-3.5-3.2-3.5-8.7 0-11.8L202.8 59.8zM320 160h80c79.5 0 144 64.5 144 144c0 46.1-15.9 79.7-34 103.2c1.3-7.1 2-14.8 2-23.2c0-70.7-57.3-128-128-128H320l0 0h-8c-13.3 0-24 10.7-24 24v8 16l0 48L128 208 288 64v48 16 8c0 13.3 10.7 24 24 24l8 0zm0 160V304 288h32 32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352 320V112 96 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C99.9 190.3 96 198.9 96 208s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V320z"]
};
var faMailReplyAll = faReplyAll;
var faSuitcase = {
  prefix: 'fal',
  iconName: 'suitcase',
  icon: [512, 512, [129523], "f0f2", "M160 48V96H352V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM128 96V48c0-26.5 21.5-48 48-48H336c26.5 0 48 21.5 48 48V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm240 32H144 128V448H384V128H368zM64 128c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H96V128H64zM448 448c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H416V448h32z"]
};
var faPersonSkating = {
  prefix: 'fal',
  iconName: 'person-skating',
  icon: [448, 512, ["skating"], "f7c5", "M392 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 392 0zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm280.4-10.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4zM274.7 144H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H316.2c28.6 0 51.8 23.2 51.8 51.8c0 18.2-9.5 35-25.1 44.4l-90.1 54L310.6 320c6 6 9.4 14.1 9.4 22.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.6l-70.5-70.5c-11.2-11.2-17.5-26.4-17.5-42.3c0-18.8 8.9-36.5 23.9-47.8L274.7 144zm49.9 1.9c-.9 1.1-1.9 2.1-3 2.9l-78.5 58.9c-7 5.2-11.1 13.5-11.1 22.2c0 2.4 .3 4.7 .9 6.9l93.5-56.1c5.9-3.6 9.6-10 9.6-16.9c0-7.9-4.7-14.8-11.4-17.9zM180.8 276.6c3.9 6.6 8.7 12.8 14.2 18.3l6.4 6.4-94.1 94.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96.1-96.1z"]
};
var faSkating = faPersonSkating;
var faStarShooting = {
  prefix: 'fal',
  iconName: 'star-shooting',
  icon: [512, 512, [127776], "e036", "M315.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm192 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm0 192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zM128.7 283.1c10.4-1.5 19.4-8.1 24.1-17.5l39.1-79.4L231 265.5c4.7 9.5 13.7 16 24.1 17.5l87.5 12.7-63.4 61.9c-7.5 7.3-11 17.9-9.2 28.3l15 87.3-78.2-41.2c-9.3-4.9-20.5-4.9-29.8 0L98.8 473.3l15-87.3c1.8-10.4-1.7-20.9-9.2-28.3L41.2 295.8l87.5-12.7zm84.7-125.6c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94z"]
};
var faBinaryLock = {
  prefix: 'fal',
  iconName: 'binary-lock',
  icon: [640, 512, [], "e33d", "M313.4 3c-4.2-3-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V16c0-5.1-2.5-10-6.6-13zM89.4 291c-4.2-3-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V304c0-5.1-2.5-10-6.6-13zM80 0C35.8 0 0 35.8 0 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80zM32 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zM192 368v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V368c0-44.2-35.8-80-80-80H272c-44.2 0-80 35.8-80 80zm80-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm256-96c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faFilterCircleDollar = {
  prefix: 'fal',
  iconName: 'filter-circle-dollar',
  icon: [576, 512, ["funnel-dollar"], "f662", "M0 39.5C0 17.7 17.7 0 39.5 0H472.5C494.3 0 512 17.7 512 39.5c0 9.2-3.2 18.1-9.1 25.2L394.2 196.1c-24.4 5.3-47 15.8-66.4 30.1L478.3 44.3c1.1-1.3 1.7-3 1.7-4.8c0-4.2-3.4-7.5-7.5-7.5H39.5c-4.2 0-7.5 3.4-7.5 7.5c0 1.8 .6 3.4 1.7 4.8L220.3 269.8c2.4 2.9 3.7 6.5 3.7 10.2v88.2l34 26.4c2.7 18.1 8.3 35.3 16.1 51.2c-3.1-1.2-6.1-2.8-8.7-4.9l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3V285.8L9.1 64.7C3.2 57.6 0 48.7 0 39.5zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM408.8 335.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z"]
};
var faFunnelDollar = faFilterCircleDollar;
var faCameraRetro = {
  prefix: 'fal',
  iconName: 'camera-retro',
  icon: [512, 512, [128247], "f083", "M192 112H64c-17.7 0-32 14.3-32 32v80H145.1c22.1-38.3 63.5-64 110.9-64s88.7 25.7 110.9 64H480V96c0-17.7-14.3-32-32-32H277.3c-6.9 0-13.7 2.2-19.2 6.4l-46.9 35.2c-5.5 4.2-12.3 6.4-19.2 6.4zM32 256V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256H380c2.6 10.2 4 21 4 32c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32H32zM0 416V144c0-35.3 28.7-64 64-64H192l46.9-35.2C250 36.5 263.5 32 277.3 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM352 288a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM64 48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16z"]
};
var faCircleArrowDown = {
  prefix: 'fal',
  iconName: 'circle-arrow-down',
  icon: [512, 512, ["arrow-circle-down"], "f0ab", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM363.3 283.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L240 329.4V144c0-8.8 7.2-16 16-16s16 7.2 16 16V329.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faArrowCircleDown = faCircleArrowDown;
var faCommentPen = {
  prefix: 'fal',
  iconName: 'comment-pen',
  icon: [512, 512, ["comment-edit"], "f4ae", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm60.3 147.7c4.9 4.9 4.9 12.9 0 17.8l-8.1 8.1-17.8-17.8 8.1-8.1c4.9-4.9 12.9-4.9 17.8 0zM207.1 271.1l60.7-60.7 17.8 17.8L224.8 289c-2.1 2.1-4.6 3.5-7.4 4.2L198 298l4.9-19.5c.7-2.8 2.2-5.4 4.2-7.4zM275.8 157l-91.4 91.5c-6.1 6.2-10.5 13.9-12.6 22.3l-11.3 45.3c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l45.3-11.3c8.4-2.1 16.2-6.5 22.3-12.6l91.4-91.5c17.4-17.4 17.4-45.6 0-63c-17.4-17.4-45.7-17.4-63.1 0z"]
};
var faCommentEdit = faCommentPen;
var faFileImport = {
  prefix: 'fal',
  iconName: 'file-import',
  icon: [512, 512, ["arrow-right-to-file"], "f56f", "M480 448c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V368H128v80c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V256h32V64c0-17.7 14.3-32 32-32H320V144c0 26.5 21.5 48 48 48H480V448zm-.5-288H368c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM283.3 212.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L329.4 304H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H329.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"]
};
var faArrowRightToFile = faFileImport;
var faBanjo = {
  prefix: 'fal',
  iconName: 'banjo',
  icon: [512, 512, [129685], "f8a3", "M445.7 33c.6-.6 1.5-1 2.3-1s1.7 .3 2.3 1L479 61.7c.6 .6 1 1.5 1 2.3s-.3 1.7-1 2.3l-39 39-42.9 9.5L406.6 72l39-39zM376.4 60.5l-15 67.5-62.4 62.4c-25.2-20.8-56.6-34.4-90.9-37.7V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v8.8c-34.4 3.2-65.8 16.9-90.9 37.7l-6.2-6.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l6.2 6.2C41.6 238.2 28 269.6 24.8 304H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.8c3.2 34.4 16.9 65.8 37.7 90.9l-6.2 6.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l6.2-6.2c25.2 20.8 56.6 34.4 90.9 37.7V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.8c34.4-3.2 65.8-16.9 90.9-37.7l6.2 6.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-6.2-6.2c20.8-25.2 34.4-56.6 37.7-90.9H368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8.8c-3.2-34.4-16.9-65.8-37.7-90.9L384 150.6l67.5-15c3-.7 5.7-2.2 7.8-4.3L501.7 89c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L473 10.3C466.3 3.7 457.4 0 448 0s-18.3 3.7-25 10.3L380.7 52.7c-2.2 2.2-3.6 4.9-4.3 7.8zM192 184a136 136 0 1 1 0 272 136 136 0 1 1 0-272zM124.7 316.7c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faSquareArrowUpRight = {
  prefix: 'fal',
  iconName: 'square-arrow-up-right',
  icon: [448, 512, ["external-link-square"], "f14c", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM168 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.4L132.7 324.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 214.6V320c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16H168z"]
};
var faExternalLinkSquare = faSquareArrowUpRight;
var faLightEmergencyOn = {
  prefix: 'fal',
  iconName: 'light-emergency-on',
  icon: [640, 512, [], "e420", "M55.2 33.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H560zm-112 0V320h32V192c0-88.4-71.6-160-160-160s-160 71.6-160 160V320h32V192c0-70.7 57.3-128 128-128s128 57.3 128 128zM128 400c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V400zm-32 0v32c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48zM320 128c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64z"]
};
var faKerning = {
  prefix: 'fal',
  iconName: 'kerning',
  icon: [640, 512, [], "f86f", "M454.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-240 480c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l240-480zm-424 81.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l144 288c2.7 5.4 8.3 8.8 14.3 8.8s11.6-3.4 14.3-8.8l144-288c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L160 364.2 30.3 104.8zm320 302.3L385.9 336H574.1l35.6 71.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-144-288c-2.7-5.4-8.2-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-144 288c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2zM480 147.8L558.1 304H401.9L480 147.8z"]
};
var faBoxOpen = {
  prefix: 'fal',
  iconName: 'box-open',
  icon: [640, 512, [], "f49e", "M80.4 49.5L320 77.2 559.6 49.5c14.1-1.6 27.5 6.2 33.1 19.2l32 74.7c9.8 22.9-3.5 49.1-27.8 54.7L437.8 234.8c-18.9 4.4-38.6-3.1-49.9-18.9L320 120.9l-67.9 95.1c-11.3 15.8-30.9 23.2-49.9 18.9L43 198c-24.3-5.6-37.6-31.8-27.8-54.7l32-74.7c5.6-13 19-20.8 33.1-19.2zM76.7 81.3l-32 74.7c-2 4.6 .7 9.8 5.6 10.9l159.2 36.7c6.3 1.5 12.9-1 16.6-6.3l65.1-91.2L76.7 81.3zM544 236.7l32-9.1v151c0 22-15 41.2-36.4 46.6l-208 52c-7.6 1.9-15.6 1.9-23.3 0l-208-52C79 419.7 64 400.5 64 378.5v-151l32 9.1V378.5c0 7.3 5 13.7 12.1 15.5L304 443V208c0-8.8 7.2-16 16-16s16 7.2 16 16V443l195.9-49c7.1-1.8 12.1-8.2 12.1-15.5V236.7zM348.8 106.1l65.1 91.2c3.8 5.3 10.3 7.7 16.6 6.3l159.2-36.7c4.9-1.1 7.5-6.4 5.6-10.9l-32-74.7L348.8 106.1z"]
};
var faSquareF = {
  prefix: 'fal',
  iconName: 'square-f',
  icon: [448, 512, [], "e270", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 32H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v80H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V256 160c0-17.7 14.3-32 32-32z"]
};
var faScroll = {
  prefix: 'fal',
  iconName: 'scroll',
  icon: [576, 512, [128220], "f70e", "M32 112c0-26.5 21.5-48 48-48s48 21.5 48 48V400c0 44.2 35.8 80 80 80H504c39.8 0 72-32.2 72-72V352c0-22.1-18-40-40-40h-.6-.6-.6-.6-.5-.6-.5-.5H531h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H524h-.5H523h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H513h-.5H512h-.5H511h-.5H510h-.5H509h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H499h-.5H498h-.5H497h-.5H496h-.5H495h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H485h-.5H484h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H477h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H471h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H466h-.5-.5-.5-.5-.4-.5-.4-.4H462h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H454h-.4-.4-.4-.4-.4-.4-.4-.4H450h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H443h-.4-.4-.4-.4-.4-.4H440h-.4-.4-.4-.4-.4-.4H437h-.4-.4-.4-.4-.4-.4H434h-.4-.4-.4-.4-.4-.4H431h-.4-.4-.4-.4-.4-.4H428h-.4-.4-.4-.4-.4-.4H425h-.4-.4-.4-.4-.4-.4H422h-.4-.4-.4-.4-.4-.4H419h-.4-.4-.4-.4-.4-.4H416h-.4-.4-.4-.4-.4-.4H413h-.4-.4-.4-.4-.4-.4H410h-.4-.4-.4-.4-.4-.4H407h-.4-.4-.4-.4-.4-.4H404h-.4-.4-.4-.4-.4-.4H401h-.4-.4-.4-.4-.4-.4H398h-.4-.4-.4-.4-.4-.4H395h-.4-.4-.4-.4-.4-.4H392h-.4-.4-.4-.4-.4-.4H389h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H382h-.4-.4-.4-.4-.4-.4-.4-.4H378h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H370h-.4-.4-.4-.5-.4-.5-.5-.5H366h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H361h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H355h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H348h-.5H347h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H337h-.5H336h-.5H335h-.5H334h-.5H333h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H323h-.5H322h-.5H321h-.5H320h-.5H319h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H309h-.5H308h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H301h-.5-.5-.5-.5-.5-.5-.6-.6H296c-22.1 0-40 17.9-40 40v48c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-18-6-34.6-16-48H400c26.5 0 48 21.5 48 48V288h32V112c0-44.2-35.8-80-80-80H80C35.8 32 0 67.8 0 112v72c0 22.1 17.9 40 40 40H96V192H40c-4.4 0-8-3.6-8-8V112zM504 448H272c10-13.4 16-30 16-48V352c0-4.4 3.6-8 8-8h.6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .5 .4 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .5 .6 .6 .6 .6c4.4 0 8 3.6 8 8v56c0 22.1-17.9 40-40 40z"]
};
var faSpa = {
  prefix: 'fal',
  iconName: 'spa',
  icon: [576, 512, [], "f5bb", "M371.3 219.5c9-6.5 18.5-12.6 28.2-18.1c-27.1-93.1-79.8-147.8-97.5-164.1c-3.8-3.5-8.8-5.2-13.9-5.2s-10.1 1.7-13.9 5.2c-17.7 16.4-70.4 71.1-97.5 164.1c9.7 5.5 19.1 11.6 28.2 18.1C225.7 140 267.2 89.6 288 68.3c20.8 21.3 62.3 71.7 83.3 151.2zM192 469.1c24.1 7.1 49.5 10.9 75.9 10.9h40.2c26.4 0 51.8-3.8 75.9-10.9c111-32.7 192-135.4 192-257c0-11.1-9.1-20.1-20.2-20.1c-64.5 0-124.1 21.6-171.8 57.9c-43.6 33.2-77.4 78.7-96 131.2c-18.6-52.6-52.4-98.1-96-131.2C144.2 213.6 84.6 192 20.2 192C9.1 192 0 201 0 212.1c0 121.6 81 224.3 192 257zm0-34.4C103.7 403.8 37.3 322.6 32.3 224.3c61.5 2.9 117.4 28 159.7 67.4c43 40.1 72 94.9 78.6 156.3c-27.3 0-53.8-4.7-78.6-13.3zm192 0c-24.8 8.6-51.2 13.3-78.6 13.3C312 386.6 341 331.7 384 291.7c42.3-39.4 98.2-64.4 159.7-67.4c-5 98.3-71.4 179.5-159.7 210.4z"]
};
var faArrowLeftFromLine = {
  prefix: 'fal',
  iconName: 'arrow-left-from-line',
  icon: [448, 512, [8612, "arrow-from-right"], "f344", "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 160 272l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0L54.6 240 155.3 139.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128zM416 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352z"]
};
var faArrowFromRight = faArrowLeftFromLine;
var faStrawberry = {
  prefix: 'fal',
  iconName: 'strawberry',
  icon: [512, 512, [], "e32b", "M495.4 20.4c-11.5 40.2-38.5 68.5-66.7 92.3c34.5 3.5 59.9 20.6 71.2 29.6c8.4 6.7 12.1 16.5 12.1 25.8c0 9.2-3.7 19-11.8 25.7c-9.2 7.6-29 21.9-54.1 27.8c-4-5-8.3-9.9-12.9-14.5l-15-15c1.9 .1 3.8 .1 5.9 .1c23.9 0 45.4-14.5 55.8-23l0-.1c.1-.1 .2-.4 .2-.9c0-.4-.1-.7-.1-.8C469.7 159.1 446.4 144 416 144c-14.7 0-22.9 1.8-26.9 3.2c-1.6 .6-2.6 1-2.9 1.2c-2.4 1.9-5.1 3.1-8 3.5l-18-18c.4-2.9 1.5-5.6 3.5-8c.2-.4 .7-1.3 1.2-2.9c1.3-4 3.2-12.2 3.2-26.9c0-30.4-15.1-53.7-23.2-63.9c-.1 0-.4-.1-.8-.1c-.5 0-.8 .1-.9 .2l-.1 0c-8.5 10.4-23 32-23 55.8c0 2 0 4 .1 5.9l-15-15c-4.6-4.6-9.5-8.9-14.5-12.9c5.9-25.2 20.2-44.9 27.8-54.1C325 3.7 334.8 0 344 0s19.1 3.7 25.8 12.1c10 12.5 29.8 42.4 30.2 82.7c29.8-24.3 54.6-48.1 64.6-83.1c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8zm-206 88L403.6 222.6l6.9 6.9c25 25 37.5 57.8 37.5 90.5c0 96-96 192-272 192C48 512 0 464 0 336C0 160 96.2 64 192.2 64c32.7 .1 65.3 12.6 90.3 37.5l6.9 6.9zM32 336c0 61.3 11.8 94.5 30.6 113.4S114.7 480 176 480c166.1 0 240-88.5 240-160c0-24.6-9.4-49.1-28.1-67.9l-128-128c-18.7-18.7-43.1-28.1-67.7-28.1C120.7 96 32 170 32 336zM189.5 154.5c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm47.3 98.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm96.7-66.3c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm24-80c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm55.3 90.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-192-80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-23.3 53.7c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7z"]
};
var faLocationPinLock = {
  prefix: 'fal',
  iconName: 'location-pin-lock',
  icon: [512, 512, [], "e51f", "M192 477.6c16.8-21.1 40.2-51.4 64-85.5v54.8c-15.3 20.6-29.3 38.6-40.3 52.3c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0c95.7 0 175 70 189.6 161.5c-10.9 1.8-21.3 5.2-30.9 9.9C340.6 92.8 273.4 32 192 32C103.6 32 32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140zM144 192a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm208-48c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H480V352H320z"]
};
var faPause = {
  prefix: 'fal',
  iconName: 'pause',
  icon: [320, 512, [9208], "f04c", "M48 96c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H48zM0 112C0 85.5 21.5 64 48 64H96c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112zM224 96c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H224zm-48 16c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H224c-26.5 0-48-21.5-48-48V112z"]
};
var faClockEightThirty = {
  prefix: 'fal',
  iconName: 'clock-eight-thirty',
  icon: [512, 512, [], "e346", "M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V285.9l-71.1 47.4c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l96-64c4.9-3.3 11.2-3.6 16.4-.8s8.5 8.2 8.5 14.1V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faPlaneEngines = {
  prefix: 'fal',
  iconName: 'plane-engines',
  icon: [576, 512, [9992, "plane-alt"], "f3de", "M576 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2l-96.9 0-11.1-18.7c15-5.8 25.6-20.3 25.6-37.3V104c0-22.1-17.9-40-40-40H303L274.4 15.7C268.7 6 258.2 0 246.9 0H170.7c-16 0-27.6 15.4-23 30.8l15.2-4.5-15.2 4.5 43 145.2L136 176 97.6 124.8C91.6 116.7 82.1 112 72 112H30c-16.6 0-30 13.4-30 30c0 2.8 .4 5.6 1.2 8.3l21.5 75.1C9.5 229.4 0 241.6 0 256s9.5 26.6 22.6 30.6L1.2 361.7C.4 364.4 0 367.2 0 370c0 16.6 13.4 30 30 30H72c10.1 0 19.6-4.7 25.6-12.8L136 336h54.7l-43 145.2c-4.6 15.4 7 30.8 23 30.8l76.2 0c11.3 0 21.8-6 27.5-15.7L303 448h41c22.1 0 40-17.9 40-40V392c0-17-10.6-31.6-25.6-37.3L369.4 336h96.9c20.6 0 46.8-8.1 67.9-20.8C554.4 303.1 576 282.9 576 256zM341 384h3c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H322l19-32zm3-256h-3L322 96h22c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8zm122.3 80c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2h-106c-5.7 0-10.9 3-13.8 7.8L246.9 480l-65.5 0 46.1-155.5c1.4-4.8 .5-10.1-2.5-14.1s-7.8-6.4-12.8-6.4L128 304c-5 0-9.8 2.4-12.8 6.4L72 368H32.6L63.4 260.4c.8-2.9 .8-5.9 0-8.8L32.6 144 72 144l43.2 57.6c3 4 7.8 6.4 12.8 6.4l84.1 0c5 0 9.8-2.4 12.8-6.4s4-9.3 2.5-14.1L181.4 32l65.5 0 99.6 168.2c2.9 4.9 8.1 7.8 13.8 7.8l106 0z"]
};
var faPlaneAlt = faPlaneEngines;
var faHillAvalanche = {
  prefix: 'fal',
  iconName: 'hill-avalanche',
  icon: [576, 512, [], "e507", "M191.7 48c-24.3 0-44.5 18.2-47.5 41.8L448 394.2c17.9 17.9 46.6 18.9 65.6 2.2l4.2-3.7c19.4-17 19.6-47.2 .5-64.5c-14.3-12.9-35.4-14.8-51.7-4.5l-3 1.9c-7.5 4.7-17.3 2.4-22-5.1s-2.4-17.4 5.1-22.1l3-1.9c28.4-17.8 65.2-14.6 90.1 7.9c33.3 30.2 32.9 82.7-.8 112.3l-4.2 3.7c-31.7 27.8-79.5 26.2-109.3-3.6L116.5 107.3c-3.3-3.3-4.9-7.8-4.7-12.2c.4-43.8 36-79.2 79.9-79.2c16.9 0 32.6 5.3 45.5 14.3c14.6-9 31.9-14.3 50.3-14.3c53 0 95.9 43 95.9 96c0 4.2-.3 8.3-.8 12.4c29.1 16.5 48.7 47.7 48.7 83.6c0 21.6-7.1 41.6-19.2 57.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c8-10.7 12.8-24 12.8-38.4c0-27.1-16.8-50.3-40.6-59.6c-7.6-3-11.8-11.3-9.6-19.2c1.5-5.4 2.3-11.2 2.3-17.2c0-35.4-28.6-64-63.9-64c-15.5 0-29.7 5.5-40.7 14.7c-6.3 5.3-15.6 4.9-21.5-.9C216.6 53.2 204.8 48 191.7 48zM415.2 64a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1 -63.9 0zm31.9 96a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1 -63.9 0zM54.6 96.1L415.3 457.4c20.1 20.2 5.8 54.6-22.6 54.6H64c-35.3 0-64-28.7-64-64V118.7C0 90.2 34.5 75.9 54.6 96.1zM32 448c0 17.7 14.3 32 32 32H392.6L32 118.7V448z"]
};
var faTemperatureEmpty = {
  prefix: 'fal',
  iconName: 'temperature-empty',
  icon: [320, 512, ["temperature-0", "thermometer-0", "thermometer-empty"], "f2cb", "M96 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112S48 429.9 48 368c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM160 0C107 0 64 43 64 96V252.7c0 4.6-2.2 9.8-6.8 14.5C31.7 293.1 16 328.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM128 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 96 368a64 64 0 1 0 128 0z"]
};
var faTemperature0 = faTemperatureEmpty;
var faThermometer0 = faTemperatureEmpty;
var faThermometerEmpty = faTemperatureEmpty;
var faBomb = {
  prefix: 'fal',
  iconName: 'bomb',
  icon: [512, 512, [128163], "f1e2", "M464 16V48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM301.1 130.9c-8.8 8.8-21.8 11.7-33.5 7.5C249.1 131.7 229 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-21-3.7-41.1-10.4-59.7c-4.2-11.7-1.3-24.7 7.5-33.5L384 208l-80-80-2.9 2.9zm-22.6-22.6l2.9-2.9c12.5-12.5 32.8-12.5 45.3 0l28.7 28.7 17.4-17.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-17.4 17.4 28.7 28.7c12.5 12.5 12.5 32.8 0 45.3l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"]
};
var faGaugeLow = {
  prefix: 'fal',
  iconName: 'gauge-low',
  icon: [512, 512, ["tachometer-alt-slow"], "f627", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-32 0c0-18.6 7.9-35.3 20.5-47L129.9 151.6c-4.2-7.8-1.3-17.5 6.5-21.7s17.5-1.3 21.7 6.5l82.6 153.4c4.9-1.2 10-1.8 15.3-1.8c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faTachometerAltSlow = faGaugeLow;
var faRegistered = {
  prefix: 'fal',
  iconName: 'registered',
  icon: [512, 512, [174], "f25d", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 176v96 96c0 8.8 7.2 16 16 16s16-7.2 16-16V288h71.4l59.3 88.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-50.5-75.7c31-11 53.2-40.6 53.2-75.4c0-44.2-35.8-80-80-80H208c-26.5 0-48 21.5-48 48zm32 80V176c0-8.8 7.2-16 16-16h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H192z"]
};
var faTrashCanPlus = {
  prefix: 'fal',
  iconName: 'trash-can-plus',
  icon: [448, 512, [], "e2ac", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zM208 384V304H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H240v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faAddressCard = {
  prefix: 'fal',
  iconName: 'address-card',
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM112 368c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80H160c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zM352 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H352zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H352zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H352z"]
};
var faContactCard = faAddressCard;
var faVcard = faAddressCard;
var faScaleUnbalancedFlip = {
  prefix: 'fal',
  iconName: 'scale-unbalanced-flip',
  icon: [640, 512, ["balance-scale-right"], "f516", "M112.2 10.9c-2.8 8.4 1.7 17.4 10.1 20.2L256.5 75.9c4.6 24.4 23.1 43.9 46.9 50.1V480h-192c-8.8 0-16 7.2-16 16s7.2 16 16 16h208c8.8 0 16-7.2 16-16V126c10.3-2.6 19.6-7.8 27.2-14.7l143.8 47.9c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2L380.3 83.5c2-6.1 3-12.7 3-19.5c0-35.3-28.7-64-64-64c-28 0-51.8 18-60.5 43L132.4 .8C124-2 115 2.6 112.2 10.9zm87.1 319.3C182.2 343.1 157.1 352 128 352s-54.2-8.9-71.3-21.7C39.6 317.5 32 302.2 32 288H224v-1.6l0 .1V288c0 14.2-7.6 29.5-24.7 42.3zM128 115.3L213.7 256H42.3L128 115.3zM256 288v-1.6c0-14.7-4-29.1-11.7-41.6l-92-151.2C147.2 85.2 137.9 80 128 80s-19.2 5.2-24.3 13.7l-92 151.2C4 257.4 0 271.8 0 286.4V288c0 53 57.3 96 128 96s128-43 128-96zM608 416c0 14.2-7.6 29.5-24.7 42.3C566.2 471.1 541.1 480 512 480s-54.2-8.9-71.3-21.7C423.6 445.5 416 430.2 416 416H608v-1.6l0 .1V416zm-10.3-32H426.3L512 243.3 597.7 384zM512 512c70.7 0 128-43 128-96v-1.6c0-14.7-4-29.1-11.7-41.6l-92-151.2c-5.2-8.5-14.4-13.7-24.3-13.7s-19.2 5.2-24.3 13.7l-92 151.2C388 385.4 384 399.8 384 414.4V416c0 53 57.3 96 128 96zM319.3 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBalanceScaleRight = faScaleUnbalancedFlip;
var faGlobeSnow = {
  prefix: 'fal',
  iconName: 'globe-snow',
  icon: [448, 512, [], "f7a3", "M416 224c0 49.2-18.5 94-48.9 128h40.7c25.3-36.3 40.2-80.4 40.2-128C448 100.3 347.7 0 224 0S0 100.3 0 224c0 47.6 14.8 91.7 40.2 128H80.9C50.5 318 32 273.2 32 224C32 118 118 32 224 32s192 86 192 192zM240 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-27.3 44.7l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 198.6v34.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 278.6V352h32V278.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 233.4V198.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM360 176a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM50.3 391.8l-46.2 77C1.4 473.2 0 478.3 0 483.5C0 499.2 12.8 512 28.5 512H419.5c15.8 0 28.5-12.8 28.5-28.5c0-5.2-1.4-10.2-4.1-14.7l-46.2-77c-2.9-4.8-8.1-7.8-13.7-7.8H64c-5.6 0-10.8 2.9-13.7 7.8zM73.1 416H374.9l38.4 64H34.7l38.4-64z"]
};
var faSubscript = {
  prefix: 'fal',
  iconName: 'subscript',
  icon: [512, 512, [], "f12c", "M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H55.2L157 256 55.2 416H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64c5.5 0 10.6-2.8 13.5-7.4L176 285.8l98.5 154.8c2.9 4.6 8 7.4 13.5 7.4h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H296.8L195 256 296.8 96H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H288c-5.5 0-10.6 2.8-13.5 7.4L176 226.2 77.5 71.4C74.6 66.8 69.5 64 64 64H16zM464 336c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H464V336z"]
};
var faDiamondTurnRight = {
  prefix: 'fal',
  iconName: 'diamond-turn-right',
  icon: [512, 512, ["directions"], "f5eb", "M261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-216 216c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3l-216-216zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm65 137c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 240H232c-13.3 0-24 10.7-24 24v56c0 8.8-7.2 16-16 16s-16-7.2-16-16V264c0-30.9 25.1-56 56-56h97.4l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faDirections = faDiamondTurnRight;
var faIntegral = {
  prefix: 'fal',
  iconName: 'integral',
  icon: [320, 512, [], "f667", "M216 32c-22.1 0-40 17.9-40 40V440c0 39.8-32.2 72-72 72s-72-32.2-72-72V416c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 22.1 17.9 40 40 40s40-17.9 40-40V72c0-39.8 32.2-72 72-72s72 32.2 72 72V96c0 8.8-7.2 16-16 16s-16-7.2-16-16V72c0-22.1-17.9-40-40-40z"]
};
var faBurst = {
  prefix: 'fal',
  iconName: 'burst',
  icon: [512, 512, [], "e4dc", "M146.5 211.2c3.3-9.6 1.8-20.1-3.9-28.4L54.9 54.9l127.9 87.7c8.3 5.7 18.9 7.2 28.4 3.9s17-10.8 20.1-20.4L256 50l26.9 83c2.7 8.3 8.6 15.1 16.4 18.9s16.8 4.3 25 1.3l54.3-19.8-19.8 54.3c-3 8.2-2.5 17.2 1.3 25s10.6 13.7 18.9 16.4L462 256l-79.6 25.8c-9 2.9-16.2 9.6-19.8 18.4s-3.1 18.6 1.3 27l40.9 77.8L327.1 364c-8.4-4.4-18.2-4.9-27-1.3s-15.5 10.8-18.4 19.8L256 462l-25.8-79.6c-2.9-9-9.6-16.2-18.4-19.8s-18.6-3.1-27 1.3l-77.8 40.9L148 327.1c4.4-8.4 4.9-18.2 1.3-27s-10.8-15.5-19.8-18.4L50 256l76.1-24.7c9.6-3.1 17.2-10.6 20.4-20.1zM173.4 97.3L37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5L97.3 173.4l18.9 27.5L84.5 211.2l-67.9 22C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l72.2 23.4 30.9 10L104.6 341 66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3L171 407.4l28.7-15.1 10 30.9 23.4 72.2c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l23.4-72.2 10-30.9L341 407.4l71.9 37.8c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L407.4 341l-15.1-28.7 30.9-10 72.2-23.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8l-76.1-24.6-30.5-9.9 11-30.1 14.7-40.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-40.4 14.7-30.1 11-9.9-30.5-24.6-76C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-22 67.9-10.3 31.7L173.4 97.3z"]
};
var faHouseLaptop = {
  prefix: 'fal',
  iconName: 'house-laptop',
  icon: [640, 512, ["laptop-house"], "e066", "M229.6 3.9c6-5.1 14.8-5.1 20.8 0l224 192c6.7 5.8 7.5 15.9 1.7 22.6c-3.1 3.7-7.6 5.6-12.1 5.6h-.2c-3.7 0-7.3-1.3-10.3-3.9L416 187.9V224H384V160.5L240 37.1 96 160.5V352c0 17.7 14.3 32 32 32H272v32H128c-35.3 0-64-28.7-64-64V187.9L26.4 220.1c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6l224-192zM352 256H544c26.5 0 48 21.5 48 48V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-26.5 21.5-48 48-48zM272 480H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM208 176h64c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V208H208v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32z"]
};
var faLaptopHouse = faHouseLaptop;
var faFaceTired = {
  prefix: 'fal',
  iconName: 'face-tired',
  icon: [512, 512, [128555, "tired"], "f5c8", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 94c24.2 0 48.2 3.4 71.4 10c-3.5-5.1-7.7-10.3-12.6-15.2c-15.5-15.5-36.2-26.8-58.7-26.8s-43.2 11.3-58.7 26.8c-4.9 4.9-9.2 10.1-12.6 15.2c23.2-6.7 47.2-10 71.4-10zm0-64c33.5 0 61.8 16.7 81.3 36.2c9.8 9.8 17.8 20.8 23.4 31.5c5.5 10.4 9.3 21.8 9.3 32.4c0 5.2-2.5 10.1-6.8 13.1s-9.7 3.7-14.6 2l-16.5-5.9C307.7 386.4 282 382 256 382s-51.8 4.5-76.2 13.2L163.3 401c-4.9 1.8-10.3 1-14.6-2s-6.8-7.9-6.8-13.1c0-10.6 3.8-21.9 9.3-32.4c5.6-10.7 13.6-21.6 23.4-31.5c19.5-19.5 47.9-36.2 81.3-36.2zM129.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 208l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
var faTired = faFaceTired;
var faMoneyBills = {
  prefix: 'fal',
  iconName: 'money-bills',
  icon: [640, 512, [], "e1f3", "M576 64c17.7 0 32 14.3 32 32v32c-35.3 0-64-28.7-64-64h32zM224 64H512c0 53 43 96 96 96v96c-53 0-96 43-96 96H224c0-53-43-96-96-96V160c53 0 96-43 96-96zM128 288c35.3 0 64 28.7 64 64H160c-17.7 0-32-14.3-32-32V288zm416 64c0-35.3 28.7-64 64-64v32c0 17.7-14.3 32-32 32H544zM192 64c0 35.3-28.7 64-64 64V96c0-17.7 14.3-32 32-32h32zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM368 272a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 61.9 50.1 112 112 112H528c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-44.2 0-80-35.8-80-80V112z"]
};
var faBlindsRaised = {
  prefix: 'fal',
  iconName: 'blinds-raised',
  icon: [512, 512, [], "f8fd", "M32 0C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96h96V418.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V96H480c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zm0 32H480V64H32V32zm96 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM35.9 160l9.8-32H12.3L.9 165c-.6 2-.9 4.1-.9 6.1C0 182.7 9.3 192 20.9 192H96V160H35.9zm0 96l9.8-32H12.3L.9 261c-.6 2-.9 4.1-.9 6.1C0 278.7 9.3 288 20.9 288H96V256H35.9zM192 256v32H491.1c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-11.4-37H466.2l9.8 32H192zm0-96v32H491.1c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-11.4-37H466.2l9.8 32H192z"]
};
var faSmog = {
  prefix: 'fal',
  iconName: 'smog',
  icon: [640, 512, [], "f75f", "M176 0C96.5 0 32 64.5 32 144s64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.7 0-62.5 12.2-85.1 32.3C242.2 12.1 210.5 0 176 0zM64 144C64 82.1 114.1 32 176 32c31.4 0 59.7 12.9 80.1 33.7c3.1 3.2 7.4 4.9 11.9 4.8s8.7-2.1 11.6-5.5c17.6-20.2 43.5-33 72.4-33c41 0 76.1 25.7 89.8 62c1.6 4.1 4.8 7.4 8.8 9.1s8.7 1.6 12.7-.2c10-4.5 21-7 32.7-7c44.2 0 80 35.8 80 80s-35.8 80-80 80H462.4c-4.2 0-8.2 1.6-11.2 4.6c-17.3 17-41 27.4-67.2 27.4s-49.9-10.4-67.2-27.4c-3-2.9-7-4.6-11.2-4.6H176c-61.9 0-112-50.1-112-112zM80 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"]
};
var faUfoBeam = {
  prefix: 'fal',
  iconName: 'ufo-beam',
  icon: [576, 512, [], "e048", "M141.3 166.7l11.3-11.4c-11.3 11.4-11.3 11.4-11.3 11.4l0 0 0 0 .1 .1 .2 .2 .6 .5c.5 .4 1.1 1 1.9 1.6c1.6 1.3 3.8 3 6.7 5.1c5.8 4 14.5 9.1 26.3 14.1C200.7 198.4 236.7 208 288 208s87.3-9.6 110.9-19.6c11.8-5 20.4-10.1 26.3-14.1c2.9-2 5.1-3.7 6.7-5.1c.8-.7 1.4-1.2 1.9-1.6l.6-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-11.3-11.4l11.3 11.4c2.7-2.7 4.3-6.2 4.7-9.9c.7-8.1 .8-16 .2-23.7c30.2 8 55.1 18.1 73.1 29.4c23.1 14.4 31.2 28.3 31.2 39.1c0 7.9-4.2 17.4-16 27.9c-11.8 10.5-29.7 20.7-53.3 29.5c-47 17.7-113 29-186.7 29s-139.7-11.3-186.7-29c-23.6-8.9-41.5-19-53.3-29.5c-11.8-10.5-16-20-16-27.9c0-10.9 8.2-24.7 31.2-39.1c18-11.3 42.9-21.4 73.1-29.4c-.6 7.7-.5 15.6 .2 23.7c.3 3.7 2 7.3 4.7 9.9zm2.3-68.3c-38.9 8.9-72.5 21.4-97.3 36.9C20.1 151.7 0 173.9 0 201.6c0 20.3 11 37.8 26.7 51.8c15.7 14 37.6 25.9 63.3 35.6c51.4 19.4 121.4 31 198 31s146.5-11.7 198-31c25.7-9.7 47.5-21.6 63.3-35.6c15.7-14 26.7-31.5 26.7-51.8c0-27.7-20.1-49.9-46.3-66.3c-24.8-15.5-58.4-28-97.3-36.9C412.1 39.7 353.1 0 288 0S163.9 39.7 143.5 98.4zM288 32c66.9 0 122 50.8 119.9 115.3l-.8 .6c-4.2 2.9-10.9 6.9-20.7 11.1C366.9 167.2 335.2 176 288 176s-78.9-8.8-98.4-17.1c-9.8-4.2-16.5-8.2-20.7-11.1l-.8-.6C166 82.8 221.1 32 288 32zM103.8 338c-7.7-4.3-17.5-1.5-21.8 6.2L2 488.2C-2.3 496 .5 505.7 8.2 510s17.5 1.5 21.8-6.2l80-144c4.3-7.7 1.5-17.5-6.2-21.8zm368.5 0c-7.7 4.3-10.5 14-6.2 21.8l80 144c4.3 7.7 14 10.5 21.8 6.2s10.5-14 6.2-21.8l-80-144c-4.3-7.7-14-10.5-21.8-6.2zM288 272a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleCaretUp = {
  prefix: 'fal',
  iconName: 'circle-caret-up',
  icon: [512, 512, ["caret-circle-up"], "f331", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352c-9.6 0-18.7 4-25.2 11L135.3 273.8c-4.7 5.1-7.3 11.8-7.3 18.7c0 15.2 12.3 27.5 27.5 27.5h201c15.2 0 27.5-12.3 27.5-27.5c0-6.9-2.6-13.6-7.3-18.7L281.2 171c-6.5-7-15.6-11-25.2-11zm-1.7 32.7c.4-.5 1.1-.7 1.7-.7s1.3 .3 1.7 .7L346.2 288H165.8l88.4-95.3z"]
};
var faCaretCircleUp = faCircleCaretUp;
var faUserVneckHairLong = {
  prefix: 'fal',
  iconName: 'user-vneck-hair-long',
  icon: [448, 512, [], "e463", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM224 0c70.7 0 128 57.3 128 128c0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9c0 20.6-16.7 37.3-37.3 37.3H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.7c2.9 0 5.3-2.4 5.3-5.3c0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3c0 2.9 2.4 5.3 5.3 5.3H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H69.3C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128C96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM185.6 418.1l-48-64C77.9 365.2 32.6 417.3 32 480H416c-.6-62.7-45.9-114.8-105.6-125.8l-48 64c-19.2 25.6-57.6 25.6-76.8 0zM143.7 321c5.3-.6 10.5 1.9 13.7 6.2l53.9 71.8c6.4 8.5 19.2 8.5 25.6 0l53.9-71.8c3.2-4.3 8.4-6.7 13.7-6.2C385.1 329.7 448 398.2 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3C0 398.2 62.9 329.7 143.7 321z"]
};
var faSquareALock = {
  prefix: 'fal',
  iconName: 'square-a-lock',
  icon: [576, 512, [], "e44d", "M64 64H384c17.7 0 32 14.3 32 32v74.8c9.9-4.7 20.7-8 32-9.6V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.6 0 96V416c0 35.3 28.7 64 64 64H320V448H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm174.3 72.8c-2.7-5.4-8.3-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-112 224c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L145.9 336H302.1L320 371.8V352c0-12.2 3.4-23.5 9.3-33.2l-91-181.9zM224 179.8L286.1 304H161.9L224 179.8zM464 224c26.5 0 48 21.5 48 48v48H416V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H544V480H384V352z"]
};
var faCrutch = {
  prefix: 'fal',
  iconName: 'crutch',
  icon: [512, 512, [], "f7f7", "M292.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0zM196.6 164.8L162.4 199c-11.2 11.2-18.8 25.4-21.9 40.9l-24.4 122c-1.9 9.3-6.4 17.8-13.1 24.5L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L125.6 409c6.7-6.7 15.2-11.3 24.5-13.1l122-24.4c15.5-3.1 29.7-10.7 40.9-21.9l34.3-34.3 94.1-94.1-22.6-22.6L336 281.4 230.6 176l82.7-82.7L290.7 70.6l-94 94c0 0-.1 .1-.1 .1s-.1 .1-.1 .1zM208 198.6L313.4 304l-23 23c-6.7 6.7-15.2 11.3-24.5 13.1L148.4 363.6l23.5-117.5c1.9-9.3 6.4-17.8 13.1-24.5l23-23z"]
};
var faGasPumpSlash = {
  prefix: 'fal',
  iconName: 'gas-pump-slash',
  icon: [640, 512, [], "f5f4", "M352 362.8V480H128V186L96 160.7V480l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H96h32H352h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0V388.1l-32-25.3zM144.6 36c4.6-2.5 9.8-4 15.4-4H320c17.7 0 32 14.3 32 32V199.7L384 225V64c0-35.3-28.7-64-64-64H160c-15.9 0-30.4 5.8-41.6 15.3L144.6 36zM576 157.1c0-17.9-7.5-35.1-20.8-47.2L474.8 36.2c-6.5-6-16.6-5.5-22.6 1s-5.5 16.6 1 22.6L480 84.4V160c0 35.3 28.7 64 64 64V351.3l32 25.3V157.1zm-64-43.4l21.6 19.8c6.6 6.1 10.4 14.6 10.4 23.6V192c-17.7 0-32-14.3-32-32V113.7zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faFontAwesome = {
  prefix: 'fal',
  iconName: 'font-awesome',
  icon: [448, 512, [62501, 62694, "font-awesome-flag", "font-awesome-logo-full"], "f2b4", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V464c0 8.8 7.2 16 16 16s16-7.2 16-16V111.9c25.5-.8 50.8-5.3 75-13.3l35.3-11.8C155.7 82.3 169.8 80 184 80s28.3 2.3 41.7 6.8l46.7 15.6c19.2 6.4 39.4 9.7 59.6 9.7s40.4-3.3 59.6-9.7L416 94.2V216v24V364.5L381.5 376c-16 5.3-32.7 8-49.5 8s-33.5-2.7-49.5-8l-46.7-15.6c-16.7-5.6-34.2-8.4-51.8-8.4s-35.1 2.8-51.8 8.4l-25.2 8.4c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l25.2-8.4c13.4-4.5 27.5-6.8 41.7-6.8s28.3 2.3 41.7 6.8l46.7 15.6c19.2 6.4 39.4 9.7 59.6 9.7s40.4-3.3 59.6-9.7l45.4-15.1 10.9-3.6V376 240 216 72 49.8l-21.1 7L381.5 72c-16 5.3-32.7 8-49.5 8s-33.5-2.7-49.5-8L235.8 56.4C219.1 50.8 201.6 48 184 48s-35.1 2.8-51.8 8.4L96.9 68.2c-21 7-42.8 10.9-64.9 11.7V48z"]
};
var faFontAwesomeFlag = faFontAwesome;
var faFontAwesomeLogoFull = faFontAwesome;
var faCloudArrowUp = {
  prefix: 'fal',
  iconName: 'cloud-arrow-up',
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM228.7 244.7l80-80c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 214.6V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V214.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"]
};
var faCloudUpload = faCloudArrowUp;
var faCloudUploadAlt = faCloudArrowUp;
var faPalette = {
  prefix: 'fal',
  iconName: 'palette',
  icon: [512, 512, [127912], "f53f", "M480 258.3c-.1 14.1-13.8 29.7-38.1 29.7H344c-44.2 0-80 35.8-80 80c0 5.6 .6 11.2 1.7 16.6c2.9 13.8 8.9 27.3 13.2 37c.8 1.7 1.5 3.3 2.1 4.8c5 11.6 6.9 18.2 6.9 23.5c0 19.2-12.3 29.6-22.7 30c-3.1 .1-6.2 .2-9.3 .2C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 .8 0 1.6 0 2.3zm32 .3c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48h97.9c36.5 0 69.7-24.8 70.1-61.3zM152 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faTransporter4 = {
  prefix: 'fal',
  iconName: 'transporter-4',
  icon: [512, 512, [], "e2a5", "M208 16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm-48 64c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm64 64c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM464 128c-8.8 0-16 7.2-16 16v16H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V192h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V144c0-8.8-7.2-16-16-16zM48 352c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V416H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V368c0-8.8-7.2-16-16-16zm80 144c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faChartMixedUpCircleCurrency = {
  prefix: 'fal',
  iconName: 'chart-mixed-up-circle-currency',
  icon: [576, 512, [], "e5d8", "M416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h72.2l-153 139.1L201.8 67.4c-5.6-4.4-13.5-4.5-19.2-.3l-176 128c-7.1 5.2-8.7 15.2-3.5 22.4s15.2 8.7 22.4 3.5L191.7 100 326.2 204.6c6.1 4.8 14.8 4.4 20.6-.8L512 53.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H416zM208 432c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8 7.2-16 16-16s16 7.2 16 16V432zM192 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM80 432c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16v64zM64 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48V368c0-26.5-21.5-48-48-48zm256 48a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM406.6 393.4a35.9 35.9 0 1 1 50.7-50.7 35.9 35.9 0 1 1 -50.7 50.7zm-10 32.6c21.6 13.2 49.1 13.2 70.7 0l9.3 9.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-9.3-9.3c13.2-21.6 13.2-49.1 0-70.7l9.3-9.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-9.3 9.3c-21.6-13.2-49.1-13.2-70.7 0l-9.3-9.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l9.3 9.3c-13.2 21.6-13.2 49.1 0 70.7l-9.3 9.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l9.3-9.3z"]
};
var faObjectsAlignRight = {
  prefix: 'fal',
  iconName: 'objects-align-right',
  icon: [512, 512, [], "e3bf", "M512 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16l0-480zM352 176c0 8.8-7.2 16-16 16L48 192c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16l0 64zm32-64c0-26.5-21.5-48-48-48L48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-64zM352 400c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 64zm32-64c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64z"]
};
var faArrowsTurnRight = {
  prefix: 'fal',
  iconName: 'arrows-turn-right',
  icon: [448, 512, [], "e4c0", "M292 5.5c5.8-6.7 15.9-7.3 22.6-1.5l128 112c3.5 3 5.5 7.4 5.5 12s-2 9-5.5 12l-128 112c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l96-84H112c-44.2 0-80 35.8-80 80v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-61.9 50.1-112 112-112H389.4l-96-84c-6.6-5.8-7.3-15.9-1.5-22.6zm-96 256c5.8-6.6 15.9-7.3 22.6-1.5l128 112c3.5 3 5.5 7.4 5.5 12s-2 9-5.5 12l-128 112c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l96-84H80c-26.5 0-48 21.5-48 48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448c0-44.2 35.8-80 80-80H293.4l-96-84c-6.7-5.8-7.3-15.9-1.5-22.6z"]
};
var faVest = {
  prefix: 'fal',
  iconName: 'vest',
  icon: [448, 512, [], "e085", "M96 0h18 6.4c20.5 0 36.7 13 46.7 24.7C176 35 192.9 48 224 48s48-13 56.9-23.3C290.9 13 307.1 0 327.6 0H334h18c26.5 0 48 21.5 48 48v80 58.7c0 5.8 1.6 11.5 4.6 16.5l34.3 57.2c6 9.9 9.1 21.3 9.1 32.9V464c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V296.9c0-7.8 1.4-15.6 4.2-22.9L274.6 69.1C261.3 75.6 244.6 80 224 80s-37.3-4.4-50.6-10.9l33.4 87.4-17.1 44.8L128.9 42.3C126.6 36.1 120.6 32 114 32H96c-8.8 0-16 7.2-16 16v80 58.7c0 11.6-3.2 23-9.1 32.9L36.6 276.8c-3 5-4.6 10.7-4.6 16.5V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-88 88c-.8 .8-1.6 1.4-2.4 2C35.1 475.5 41 480 48 480H161.6c2.4 11.8 7.4 22.7 14.4 32H48c-26.5 0-48-21.5-48-48V293.3c0-11.6 3.2-23 9.1-32.9l34.3-57.2c3-5 4.6-10.7 4.6-16.5V128 48C48 21.5 69.5 0 96 0zM368 48c0-8.8-7.2-16-16-16H334c-6.6 0-12.6 4.1-14.9 10.3l-93 243.1c-1.4 3.6-2.1 7.5-2.1 11.4V464c0 8.8 7.2 16 16 16H400c7 0 12.9-4.5 15.1-10.7c-.9-.6-1.7-1.2-2.4-2l-88-88c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 425.4V293.3c0-5.8-1.6-11.5-4.6-16.5l-34.3-57.2c-6-9.9-9.1-21.3-9.1-32.9V128 48z"]
};
var faPig = {
  prefix: 'fal',
  iconName: 'pig',
  icon: [640, 512, [128022], "f706", "M484.2 32c-4.4 0-8.7 .7-12.9 1.9L416.6 50.8C399.7 56 385.5 66.4 375.5 80H240C162.6 80 98 135 83.2 208H47.4c-8.5 0-15.4-6.9-15.4-15.4c0-7.1 4.8-13.3 11.7-15l8.2-2c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-8.2 2C14.8 151.8 0 170.8 0 192.6C0 218.8 21.2 240 47.4 240H80v16c0 53.4 29.1 100 72.2 124.8L180 458.8c4.5 12.7 16.6 21.2 30.1 21.2H256c17.7 0 32-14.3 32-32V416h32 48v32c0 17.7 14.3 32 32 32h45.9c13.5 0 25.6-8.5 30.1-21.2L494 408.5c25.9-9 48.8-25.5 65.3-47.7c.3-.4 .6-.6 .8-.7l.1 0 .1 0H600c22.1 0 40-17.9 40-40V240c0-22.1-17.9-40-40-40H581.3c-5.2-3.5-9.9-7.7-14.1-12.3c25-13.7 40.9-40 40.9-68.9C608 97.3 590.7 80 569.3 80H528V75.8C528 51.6 508.4 32 484.2 32zm40.9 80h44.1c3.7 0 6.7 3 6.7 6.7c0 18.6-11 35.3-28 42.7c-9-11.5-19.1-22-30.2-31.2c3.1-5.7 5.6-11.8 7.3-18.2zM480.7 64.5c1.1-.3 2.3-.5 3.5-.5c6.5 0 11.8 5.3 11.8 11.8V90.1c0 12.5-4.5 24.1-12 33.3c-2.8 3.4-4.1 7.8-3.6 12.2s2.9 8.4 6.5 11c17.9 13 33.5 29.3 45.8 48.5c8.2 12.7 18.9 23.5 31.3 31.9c5.4 3.6 11.4 5.1 17.1 5.1H600c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H560.2c-11.1 0-20.7 5.7-26.6 13.7c-14 18.8-33.8 32.3-56.3 38.5c-5 1.4-9 5.1-10.8 10L445.9 448H400V400c0-8.8-7.2-16-16-16H320 272c-8.8 0-16 7.2-16 16v48H210.1l-29.9-83.7c-1.4-3.8-4.1-7-7.7-8.8c-36-18.7-60.5-56.2-60.5-99.5V240c0-70.7 57.3-128 128-128H380.5c1.1 0 2.2 0 3.4 0c5.9 .1 11.4-3 14.3-8.2c5.9-10.6 15.7-18.8 27.9-22.5l54.7-16.8zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
var faInboxFull = {
  prefix: 'fal',
  iconName: 'inbox-full',
  icon: [512, 512, [], "e1ba", "M32 327.9V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V327.9c0-2.6-.3-5.2-1-7.8l0-.1H377.9l-23.2 46.3c-5.4 10.8-16.5 17.7-28.6 17.7H185.9c-12.1 0-23.2-6.8-28.6-17.7L134.1 320H33l0 .1c-.6 2.5-1 5.1-1 7.8zM421.1 88.2C417.5 74 404.7 64 390 64H122c-14.7 0-27.5 10-31 24.2L41 288h93.1c12.1 0 23.2 6.8 28.6 17.7L185.9 352H326.1l23.2-46.3c5.4-10.8 16.5-17.7 28.6-17.7H471L421.1 88.2zM0 416V327.9c0-5.2 .6-10.4 1.9-15.5l58-231.9C67 52 92.6 32 122 32H390c29.4 0 55 20 62.1 48.5l58 231.9c1.3 5.1 1.9 10.3 1.9 15.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM176 144H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 80H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleEnvelope = {
  prefix: 'fal',
  iconName: 'circle-envelope',
  icon: [512, 512, ["envelope-circle"], "e10c", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-96H352c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm192 48.5V192H160v16.5l88.5 47.1c2.3 1.2 4.9 1.9 7.5 1.9s5.2-.6 7.5-1.9L352 208.5zm0 36.2l-73.4 39.1c-7 3.7-14.7 5.6-22.6 5.6s-15.6-1.9-22.6-5.6L160 244.8V320H352V244.8z"]
};
var faEnvelopeCircle = faCircleEnvelope;
var faTrianglePersonDigging = {
  prefix: 'fal',
  iconName: 'triangle-person-digging',
  icon: [640, 512, ["construction"], "f85d", "M320 32c2.8 0 5.4 1.4 6.8 3.8l264.5 432c1.5 2.5 1.6 5.6 .2 8.1s-4.1 4.1-7 4.1H56c-2.9 0-5.6-1.6-7-4.1s-1.4-5.6 .2-8.1l264-432c1.5-2.4 4-3.8 6.8-3.8zm34.1-12.9C346.8 7.2 333.9 0 320 0s-26.9 7.3-34.1 19.1l-264 432c-7.5 12.3-7.8 27.8-.8 40.4S41.5 512 56 512H584.5c14.5 0 27.8-7.8 34.9-20.4s6.8-28.1-.8-40.4L354.1 19.1zM312 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-37 48c9.9 0 18.6 6.6 21.2 16.2l5.9 21.8-46.5-26.8 1.8-2.4c4.2-5.5 10.7-8.8 17.6-8.8zm66.5 60.7l-14.4-52.9C320.7 256.3 299.3 240 275 240c-17 0-33 8-43.2 21.6l-12.6 16.8c-2.7 3.7-3.8 8.3-2.9 12.8s3.7 8.4 7.7 10.6l155.9 89.9-9.6 16c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1h96c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1l-48-80c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8l-21.9 36.6-54.8-31.6zm-124.6-12l-7.5 16.8-32 72c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l24.5-55.2L272 392.9V416c0 8.8 7.2 16 16 16s16-7.2 16-16V384c0-5.5-2.8-10.6-7.5-13.6l-64-40-15.6-9.8zM451.7 400H412.3L432 367.1 451.7 400z"]
};
var faConstruction = faTrianglePersonDigging;
var faFerry = {
  prefix: 'fal',
  iconName: 'ferry',
  icon: [576, 512, [], "e4ea", "M224 0c-17.7 0-32 14.3-32 32H124c-17.1 0-28.7 17.4-22.2 33.2L114.7 96H112c-26.5 0-48 21.5-48 48V295.1c0 8.7 2.4 17.2 6.8 24.7l43.4 72.4c4.5 7.6 14.4 10 22 5.5s10-14.4 5.5-21.9L108.3 320H467.7l-33.5 55.8c-4.5 7.6-2.1 17.4 5.5 21.9s17.4 2.1 21.9-5.5l43.4-72.4c4.5-7.5 6.8-16 6.8-24.7V144c0-26.5-21.5-48-48-48h-2.7l12.8-30.8c6.6-15.8-5-33.2-22.2-33.2H384c0-17.7-14.3-32-32-32H224zM416 288H160V192H416v96zm32 0V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16V288H96V144c0-8.8 7.2-16 16-16h16H448h16c8.8 0 16 7.2 16 16V288H448zM426.7 96H149.3L136 64h56 32V32H352V64h32 56L426.7 96zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faBullseyeArrow = {
  prefix: 'fal',
  iconName: 'bullseye-arrow',
  icon: [512, 512, [127919], "f648", "M326.3 9.8C304 3.4 280.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-24.4-3.4-48-9.8-70.3l-22.8 25.4c-1.1 1.2-2.1 2.3-3.3 3.4c2.5 13.5 3.8 27.3 3.8 41.5c0 123.7-100.3 224-224 224S32 379.7 32 256S132.3 32 256 32c14.2 0 28.1 1.3 41.5 3.8c1.1-1.1 2.2-2.2 3.4-3.3L326.3 9.8zM274.6 97.1c-6.1-.7-12.3-1.1-18.6-1.1C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-6.3-.4-12.5-1.1-18.6c-2.7-.2-5.4-.5-8.1-.9l-25-4.2c1.4 7.7 2.2 15.6 2.2 23.7c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c8.1 0 16 .8 23.7 2.2l-4.2-25c-.5-2.7-.8-5.4-.9-8.1zm66.9 96.1l70.4 11.7c16.3 2.7 32.8-3.1 43.8-15.5L499.6 140c11.7-13.1 5.8-33.9-11-38.9L428.9 83.2 410.9 23.4c-5-16.8-25.8-22.7-38.9-11L322.6 56.3c-12.3 11-18.2 27.5-15.5 43.8l11.7 70.4-74.2 74.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l74.2-74.2zm27.8-27.8l51.3-51.3 46.8 14-35.6 40c-3.7 4.1-9.2 6.1-14.6 5.2l-47.9-8zm28.6-73.9l-51.3 51.3-8-47.9c-.9-5.4 1-10.9 5.2-14.6l40-35.6 14 46.8z"]
};
var faArrowsDownToPeople = {
  prefix: 'fal',
  iconName: 'arrows-down-to-people',
  icon: [640, 512, [], "e4b9", "M128 16c0-8.8 7.2-16 16-16s16 7.2 16 16V145.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L128 145.4V16zm292.7 92.7c6.2-6.2 16.4-6.2 22.6 0L480 145.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16V145.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zM336 192a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 208h48V289.5c-3.8-1-7.7-1.5-11.8-1.5H307.8c-4 0-8 .5-11.8 1.5V400zm122.4-15.6L376 315.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V315.5l-42.4 68.9c-.2 .3-.3 .5-.5 .8c1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 411.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V411.5L45.6 480.4c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 366.4 104 352 131.8 352h24.5c14.6 0 28.7 4 40.8 11.2l42.5-69.1C254.2 270.4 280 256 307.8 256h24.5c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2h24.5c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 411.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V411.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9c-.2-.3-.4-.5-.5-.8zM144 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 385.5V480h48V385.5c-3.8-1-7.7-1.5-11.8-1.5H131.8c-4 0-8 .5-11.8 1.5zM512 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 192h48V385.5c-3.8-1-7.7-1.5-11.8-1.5H483.8c-4 0-8 .5-11.8 1.5V480z"]
};
var faSeedling = {
  prefix: 'fal',
  iconName: 'seedling',
  icon: [512, 512, [127793, "sprout"], "f4d8", "M480 32c0 95.3-69.4 174.4-160.5 189.4c2.7 10.2 4.7 20.7 6.1 31.4C431.4 234.9 512 142.9 512 32c0-17.7-14.3-32-32-32H448C367 0 296 43 256.6 107.5c7.8 8.3 15.1 17.2 21.8 26.4C310.7 73.3 374.5 32 448 32h32zM64 96c106 0 192 86 192 192H224C118 288 32 202 32 96H64zM32 64C14.3 64 0 78.3 0 96C0 219.7 100.3 320 224 320h32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V320 304 288C288 164.3 187.7 64 64 64H32z"]
};
var faSprout = faSeedling;
var faClockSeven = {
  prefix: 'fal',
  iconName: 'clock-seven',
  icon: [512, 512, [], "e350", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V251.2l-61.3 92c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c1.8-2.6 2.7-5.7 2.7-8.9V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faLeftRight = {
  prefix: 'fal',
  iconName: 'left-right',
  icon: [512, 512, [8596, "arrows-alt-h"], "f337", "M502.3 231.3c6.2 6.7 9.7 15.6 9.7 24.7s-3.5 18-9.7 24.7l-84 91c-7.2 7.8-17.4 12.3-28.1 12.3c-21.1 0-38.3-17.1-38.3-38.3l0-25.7-192 0 0 25.7c0 21.1-17.1 38.3-38.3 38.3c-10.7 0-20.9-4.5-28.1-12.3l-84-91C3.5 274 0 265.2 0 256s3.5-18 9.7-24.7l84-91c7.2-7.8 17.4-12.3 28.1-12.3c21.1 0 38.3 17.1 38.3 38.3l0 25.7 192 0 0-25.7c0-21.1 17.1-38.3 38.3-38.3c10.7 0 20.9 4.5 28.1 12.3l84 91zM480 256c0-1.1-.4-2.2-1.2-3l-84-91c-1.2-1.3-2.8-2-4.6-2c-3.5 0-6.3 2.8-6.3 6.3l0 41.7c0 8.8-7.2 16-16 16l-224 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c-8.8 0-16-7.2-16-16l0-41.7c0-3.5-2.8-6.3-6.3-6.3c-1.7 0-3.4 .7-4.6 2l-84 91c-.8 .8-1.2 1.9-1.2 3s.4 2.2 1.2 3l84 91c1.2 1.3 2.9 2 4.6 2c3.5 0 6.3-2.8 6.3-6.3l0-41.7c0-8.8 7.2-16 16-16l0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 224 0c8.8 0 16 7.2 16 16l0 41.7c0 3.5 2.8 6.3 6.3 6.3c1.7 0 3.4-.7 4.6-2l84-91c.8-.8 1.2-1.9 1.2-3z"]
};
var faArrowsAltH = faLeftRight;
var faBoxesPacking = {
  prefix: 'fal',
  iconName: 'boxes-packing',
  icon: [640, 512, [], "e4c7", "M592 32H304c-8.8 0-16 7.2-16 16v80H256V48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V480H592c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16zM555.3 316.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 302.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V302.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64zM352 192H32l0 64H64 320h32V192zM0 256V192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-192c-17.7 0-32-14.3-32-32zm64 32V480H320V288H64zm80 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleArrowLeft = {
  prefix: 'fal',
  iconName: 'circle-arrow-left',
  icon: [512, 512, ["arrow-circle-left"], "f0a8", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM228.7 148.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L182.6 272 368 272c8.8 0 16-7.2 16-16s-7.2-16-16-16l-185.4 0 68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faArrowCircleLeft = faCircleArrowLeft;
var faFlashlight = {
  prefix: 'fal',
  iconName: 'flashlight',
  icon: [640, 512, [128294], "f8b8", "M401.8 325.4l31.5 21c24 16 50.8 27.1 78.7 32.9V132.7c-28 5.8-54.7 16.9-78.7 32.9l-31.5 21-8.1 5.4H384 48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16H384h9.7l8.1 5.4zM544 383.6c4.5 .3 9 .4 13.5 .4H592c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H557.5c-4.5 0-9 .1-13.5 .4V383.6zM0 304V208c0-26.5 21.5-48 48-48H384l31.5-21c42.1-28 91.5-43 142-43H592c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H557.5c-50.5 0-100-15-142-43L384 352H48c-26.5 0-48-21.5-48-48zm224-48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faGroupArrowsRotate = {
  prefix: 'fal',
  iconName: 'group-arrows-rotate',
  icon: [512, 512, [], "e4f6", "M207.3 36.7c2.5 8.5-2.3 17.4-10.8 19.9c-14.2 4.2-27.8 10-40.6 17c2.6 7 4 14.5 4 22.4c0 35.3-28.7 64-64 64c-7.9 0-15.4-1.4-22.4-4c-7 12.8-12.7 26.4-17 40.6c-2.5 8.5-11.4 13.3-19.9 10.8s-13.3-11.4-10.8-19.9c5.2-17.6 12.4-34.3 21.3-50C37.7 126.3 32 111.8 32 96c0-35.3 28.7-64 64-64c15.8 0 30.3 5.7 41.5 15.3c15.6-8.9 32.4-16.1 50-21.3c8.5-2.5 17.4 2.3 19.9 10.8zm97.3 0c2.5-8.5 11.4-13.3 19.9-10.8c17.6 5.2 34.3 12.4 50 21.3C385.7 37.7 400.2 32 416 32c35.3 0 64 28.7 64 64c0 15.8-5.7 30.3-15.3 41.5c8.9 15.6 16.1 32.4 21.3 50c2.5 8.5-2.3 17.4-10.8 19.9s-17.4-2.3-19.9-10.8c-4.2-14.2-10-27.8-17-40.6c-7 2.6-14.5 4-22.4 4c-35.3 0-64-28.7-64-64c0-7.9 1.4-15.4 4-22.4c-12.8-7-26.4-12.7-40.6-17c-8.5-2.5-13.3-11.4-10.8-19.9zm-268 268c8.5-2.5 17.4 2.3 19.9 10.8c4.2 14.2 10 27.8 17 40.6c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64c0 7.9-1.4 15.4-4 22.4c12.8 7 26.4 12.7 40.6 17c8.5 2.5 13.3 11.4 10.8 19.9s-11.4 13.3-19.9 10.8c-17.6-5.2-34.3-12.4-50-21.3C126.3 474.3 111.8 480 96 480c-35.3 0-64-28.7-64-64c0-15.8 5.7-30.3 15.3-41.5c-8.9-15.6-16.1-32.4-21.3-50c-2.5-8.5 2.3-17.4 10.8-19.9zm438.6 0c8.5 2.5 13.3 11.4 10.8 19.9c-5.2 17.6-12.4 34.3-21.3 50c9.5 11.2 15.3 25.7 15.3 41.5c0 35.3-28.7 64-64 64c-15.8 0-30.3-5.7-41.5-15.3c-15.6 8.9-32.4 16.1-50 21.3c-8.5 2.5-17.4-2.3-19.9-10.8s2.3-17.4 10.8-19.9c14.2-4.2 27.8-10 40.6-17c-2.6-7-4-14.5-4-22.4c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4c7-12.8 12.7-26.4 17-40.6c2.5-8.5 11.4-13.3 19.9-10.8zM96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM144.8 168.8c0-8.8 7.2-16 16-16h45.6c14.6 0 26.4 11.8 26.4 26.4v45.6c0 8.8-7.2 16-16 16s-16-7.2-16-16V211.5c-10 12.4-16 28.1-16 45.3c0 28 15.9 52.2 39.3 64.2c7.9 4 11 13.7 7 21.5s-13.7 11-21.5 7c-33.6-17.2-56.7-52.2-56.7-92.7c0-27.6 10.8-52.8 28.4-71.4c.2-.2 .4-.4 .6-.6h-21c-8.8 0-16-7.2-16-16zm208 192H307.2c-14.6 0-26.4-11.8-26.4-26.4V288.8c0-8.8 7.2-16 16-16s16 7.2 16 16v11.7c10-12.4 16-28.1 16-45.3c0-28-15.9-52.2-39.3-64.2c-7.9-4-11-13.7-7-21.5s13.7-11 21.5-7c33.6 17.2 56.7 52.2 56.7 92.7c0 27.6-10.8 52.8-28.4 71.4c-.8 .8-1.6 1.6-2.5 2.2h22.9c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faBowlFood = {
  prefix: 'fal',
  iconName: 'bowl-food',
  icon: [512, 512, [], "e4c6", "M203.8 98.2C213.9 77.5 233.8 64 256 64s42.1 13.5 52.2 34.2c2 4.1 5.6 7.2 10 8.4s9.1 .6 12.9-1.9C340 99.2 350.2 96 361 96c27.8 0 52.1 21.2 57.8 51c1.5 7.7 8.3 13.2 16.1 13c.4 0 .7 0 1.1 0c23.3 0 44 20.5 44 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-39.4-27.5-73.5-64.9-79.2C435 91.6 401.5 64 361 64c-11.4 0-22.3 2.2-32.3 6.2C312.2 47.2 286 32 256 32s-56.2 15.2-72.7 38.2c-10-4-20.9-6.2-32.3-6.2c-40.5 0-74 27.6-86.1 64.8C27.5 134.5 0 168.6 0 208c0 8.8 7.2 16 16 16s16-7.2 16-16c0-27.5 20.7-48 44-48c.4 0 .7 0 1.1 0c7.8 .2 14.7-5.3 16.1-13c5.7-29.8 30-51 57.8-51c10.8 0 21 3.2 29.8 8.7c3.8 2.4 8.6 3.1 12.9 1.9s8-4.3 10-8.4zM129.3 425.1c-2.7-9-9.2-16.4-17.8-20.2C65.9 385 33.9 340.3 32.1 288H479.9c-1.8 52.3-33.9 97-79.4 116.9c-8.6 3.8-15.2 11.2-17.8 20.2C378.7 438.4 366.5 448 352 448H160c-14.5 0-26.7-9.6-30.7-22.9zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480H352c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4H27.4z"]
};
var faSquare9 = {
  prefix: 'fal',
  iconName: 'square-9',
  icon: [448, 512, [], "e25e", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 288a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-3.7 31.9l-39.1 36.3c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8l82.7-76.8c22-20.4 34.4-49 34.4-78.9c0-53-43-96-96-96s-96 43-96 96c0 51.8 41 94 92.3 95.9z"]
};
var faCandyCane = {
  prefix: 'fal',
  iconName: 'candy-cane',
  icon: [512, 512, [], "f786", "M361 96c10.1 0 19.5 2.7 27.7 7.5c-.6-.3-1.2-.7-1.7-1l46.2-46.2c.5 .4 .9 .7 1.4 1.1C414.2 41.5 388.7 32 361 32c-11.3 0-22.5 1.6-33.2 4.7L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8c-.2 .1-.3 .2-.5 .3L271 66.9c-15 9.4-19.5 29.1-10.2 44.1s29.1 19.5 44.1 10.2l26.8-16.8 16.1 25.7-16.1-25.7c8.7-5.5 18.9-8.4 29.2-8.4zm48.6 29.1c4.1 7.7 6.5 16.6 6.5 25.9v5.6c0 1.7-.1 3.4-.2 5.1l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c-4.6 6.4-10.4 12-17.3 16.3l-57.8 36.1 60.4 37.7-30.2 18.9-60.4-37.7-77 48.1 60.4 37.7-30.2 18.9-60.4-37.7-73 45.6 60.4 37.7-30.2 18.9L89.1 394.6 47 420.9c-15 9.4-19.5 29.1-10.2 44.1s29.1 19.5 44.1 10.2L421.4 262.4c36.4-22.8 58.6-62.7 58.6-105.7V151c0-36.6-16.5-69.3-42.4-91.1c6.7 5.6 12.8 12 18.1 19l-46.2 46.2zM361 128c-4.3 0-8.6 1.2-12.2 3.5l-26.8 16.8c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L280.9 23C304.9 8 332.7 0 361 0c83.4 0 151 67.6 151 151v5.6c0 54-27.8 104.2-73.6 132.8L97.9 502.3c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L370.5 180.9c8.4-5.2 13.5-14.4 13.5-24.3V151c0-12.7-10.3-23-23-23z"]
};
var faArrowDownWideShort = {
  prefix: 'fal',
  iconName: 'arrow-down-wide-short',
  icon: [576, 512, ["sort-amount-asc", "sort-amount-down"], "f160", "M235.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM304 48h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSortAmountAsc = faArrowDownWideShort;
var faSortAmountDown = faArrowDownWideShort;
var faSquareDollar = {
  prefix: 'fal',
  iconName: 'square-dollar',
  icon: [448, 512, ["dollar-square", "usd-square"], "f2e9", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm240 24v23c13.5 1 26.6 4.6 39.6 8.3c1.5 .4 3.1 .9 4.6 1.3c8.5 2.4 13.5 11.2 11.2 19.7s-11.2 13.5-19.7 11.2c-2.4-.7-4.8-1.4-7.2-2.1c-7.5-2.2-15.2-4.4-22.9-5.5c-19.1-2.8-36.6-.4-49.3 5.1c-12.9 5.6-18.6 13.1-19.8 19.5c-1.8 9.8 2.1 16.5 10.2 21.7c10.6 6.8 26.5 11.3 45.8 16.8l.3 .1c17.7 5 38.9 11.1 54.3 21.7c19 13 27.8 33.8 23.6 56.5c-4 21.6-18.9 36-37.8 43.6c-9.9 4-21.1 6.3-33.1 6.9l0 24.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.9c-8.1-1.3-21.8-5.2-32.4-8.4c-6.9-2.1-13.8-4.3-20.7-6.5c-8.4-2.8-12.9-11.8-10.2-20.2s11.8-12.9 20.2-10.2c6.6 2.2 13.2 4.3 19.9 6.3c11.2 3.4 22.7 6.6 28.1 7.4c19.8 2.9 36.5 1.3 48-3.4c11.2-4.5 16.8-11.3 18.3-19.7c1.9-10.5-1.5-18.4-10.2-24.4c-12-8.2-26.8-12.3-40.9-16.2c-2.3-.6-4.7-1.3-6.9-1.9c-17.1-4.8-37-10.5-51.7-19.9c-8.1-5.2-15.7-12.1-20.5-21.7c-4.9-9.8-6.2-20.8-4-32.8c3.8-20.7 20-35.1 38.6-43.1c7.4-3.2 15.6-5.6 24.3-7.1V120c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDollarSquare = faSquareDollar;
var faUsdSquare = faSquareDollar;
var faPhoneArrowRight = {
  prefix: 'fal',
  iconName: 'phone-arrow-right',
  icon: [512, 512, [], "e5be", "M411.3 4.7l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 128H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H457.4L388.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faHandHoldingSeedling = {
  prefix: 'fal',
  iconName: 'hand-holding-seedling',
  icon: [576, 512, [], "f4bf", "M125.1 0H144c88.4 0 160 71.6 160 160v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V176H242.9C161.8 176 96 110.2 96 29.1C96 13 109 0 125.1 0zM144 32H128c1.5 62.1 52.4 112 114.9 112H271C263.1 80.9 209.3 32 144 32zM336 176V160c0-5.4-.2-10.7-.7-16C396.8 142.8 446.4 93.4 448 32H432c-45.7 0-85.8 23.9-108.4 59.9c-4.3-11.4-9.7-22.3-16-32.5C336.9 23.2 381.7 0 432 0h18.9C467 0 480 13 480 29.1c0 80.2-64.2 145.3-144 146.9zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7H80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faMessageCheck = {
  prefix: 'fal',
  iconName: 'message-check',
  icon: [512, 512, ["comment-alt-check"], "f4a2", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM363.3 147.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 241.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faCommentAltCheck = faMessageCheck;
var faCloudBolt = {
  prefix: 'fal',
  iconName: 'cloud-bolt',
  icon: [512, 512, [127785, "thunderstorm"], "f76c", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H384v23.4c2.6 2.6 5 5.5 7.1 8.6H408c57.4 0 104-46.6 104-104c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104h53.8l33.8-32H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zm95.7 264l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4H191.7zM313.6 224c-5.1 0-10.1 2-13.8 5.5L150.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6H215l-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5L361.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6H297l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"]
};
var faThunderstorm = faCloudBolt;
var faChartLineUpDown = {
  prefix: 'fal',
  iconName: 'chart-line-up-down',
  icon: [512, 512, [], "e5d7", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM368 96h57.4L288 233.4l-68.7-68.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 198.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0L448 118.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0 288h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.4l-68.7-68.7-22.6 22.6L425.4 352H368c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faTextSlash = {
  prefix: 'fal',
  iconName: 'text-slash',
  icon: [640, 512, ["remove-format"], "f87d", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM390.4 64l149.1 0-11 44.1c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l11-44.1c5-20.2-10.2-39.8-31-39.8h-383c-4.7 0-9.2 1-13.3 2.9L180.1 64l177.1 0L325.1 178.5 352.3 200 390.4 64zM287.7 312L249.6 448H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H282.9l32.1-114.5L287.7 312z"]
};
var faRemoveFormat = faTextSlash;
var faWatch = {
  prefix: 'fal',
  iconName: 'watch',
  icon: [384, 512, [8986], "f2e1", "M128 32H256c17.7 0 32 14.3 32 32V89.7C259.8 73.3 227 64 192 64s-67.8 9.3-96 25.7V64c0-17.7 14.3-32 32-32zM64 112h1C25.1 147.2 0 198.7 0 256s25.1 108.8 65 144H64v48c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64V400h-1c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144h1V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v48zM288 422.3V448c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32V422.3c28.2 16.3 61 25.7 96 25.7s67.8-9.4 96-25.7zM32 256a160 160 0 1 1 320 0A160 160 0 1 1 32 256zm176-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 5.3 2.7 10.3 7.1 13.3l48 32c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L208 247.4V176z"]
};
var faCircleDownLeft = {
  prefix: 'fal',
  iconName: 'circle-down-left',
  icon: [512, 512, [], "e107", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM176 328c0 4.4 3.6 8 8 8H297.4c3.7 0 6.6-3 6.6-6.6c0-1.8-.7-3.4-1.9-4.7l-25.4-25.4c-6.2-6.2-6.2-16.4 0-22.6l59.1-59.1c3.6-3.6 4.9-9 3.3-13.9c-.7-2-1.8-3.8-3.3-5.3l-22.1-22.1c-1.5-1.5-3.3-2.6-5.3-3.3c-4.9-1.6-10.3-.4-13.9 3.3l-59.1 59.1c-6.2 6.2-16.4 6.2-22.6 0l-25.4-25.4c-1.2-1.2-2.9-1.9-4.7-1.9c-3.7 0-6.6 3-6.6 6.6V328zm8 40c-22.1 0-40-17.9-40-40V214.6c0-21.3 17.3-38.6 38.6-38.6c10.2 0 20.1 4.1 27.3 11.3L224 201.4l47.7-47.7c12.2-12.2 30.3-16.5 46.7-11c6.7 2.2 12.8 6 17.8 11l22.1 22.1c5 5 8.8 11.1 11 17.8c5.5 16.4 1.2 34.5-11 46.7L310.6 288l14.1 14.1c7.2 7.2 11.3 17.1 11.3 27.3c0 21.3-17.3 38.6-38.6 38.6H184z"]
};
var faText = {
  prefix: 'fal',
  iconName: 'text',
  icon: [448, 512, [], "f893", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H240l0 384h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h64l0-384H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64z"]
};
var faProjector = {
  prefix: 'fal',
  iconName: 'projector',
  icon: [640, 512, [], "f8d6", "M432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM267.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64zm320 22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zM288 320a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm288 0c0-36-11.9-69.3-32-96h32c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H560 544c20.1-26.7 32-60 32-96zm0 128c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H512c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16V448H320c26.7 20.1 60 32 96 32c37.3 0 71.6-12.7 98.8-34.1c-.9 .7-1.8 1.4-2.8 2.1h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448zM80 416H64c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32H288c-20.1 26.7-32 60-32 96s11.9 69.3 32 96H80zm16-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faFaceSmileWink = {
  prefix: 'fal',
  iconName: 'face-smile-wink',
  icon: [512, 512, [128521, "smile-wink"], "f4da", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faSmileWink = faFaceSmileWink;
var faTombstoneBlank = {
  prefix: 'fal',
  iconName: 'tombstone-blank',
  icon: [448, 512, [129702, "tombstone-alt"], "f721", "M384 192V448h32V192C416 86 330 0 224 0S32 86 32 192V448H64V192c0-88.4 71.6-160 160-160s160 71.6 160 160zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faTombstoneAlt = faTombstoneBlank;
var faChessKingPiece = {
  prefix: 'fal',
  iconName: 'chess-king-piece',
  icon: [256, 512, ["chess-king-alt"], "f440", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H52.6C41.2 96 32 105.2 32 116.6c0 2.2 .4 4.4 1.1 6.5L66.7 224H56c-8.8 0-16 7.2-16 16s7.2 16 16 16H69.8L56.7 352H89l13.1-96h51.8L167 352h32.3l-13.1-96H200c8.8 0 16-7.2 16-16s-7.2-16-16-16H189.3l33.6-100.8c.7-2.1 1.1-4.3 1.1-6.5c0-11.4-9.2-20.6-20.6-20.6H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zm11.6 208H100.4l-32-96H128h59.6l-32 96zm34.6 160H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512H216.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1zM33.1 468.7L65.8 416l124.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9z"]
};
var faChessKingAlt = faChessKingPiece;
var faCircle6 = {
  prefix: 'fal',
  iconName: 'circle-6',
  icon: [512, 512, [], "e0f3", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm43.7-378.9c-6-6.5-16.1-6.9-22.6-.8l-82.7 76.8c-22 20.4-34.4 49-34.4 78.9c0 53 43 96 96 96s96-43 96-96c0-51.8-41-94-92.3-95.9l39.1-36.3c6.5-6 6.9-16.1 .8-22.6zM256 224a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faLeft = {
  prefix: 'fal',
  iconName: 'left',
  icon: [448, 512, ["arrow-alt-left"], "f355", "M32 258.3l0-4.6c0-4.4 1.8-8.6 5-11.6L186.8 99.5c2.3-2.2 5.4-3.5 8.7-3.5c6.9 0 12.6 5.6 12.6 12.6l0 83.4c0 8.8 7.2 16 16 16l176 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-176 0c-8.8 0-16 7.2-16 16l0 83.4c0 6.9-5.6 12.6-12.6 12.6c-3.2 0-6.3-1.2-8.7-3.5L37 269.9c-3.2-3-5-7.2-5-11.6zM195.4 64C184 64 173 68.4 164.7 76.3L14.9 219C5.4 228 0 240.6 0 253.7l0 4.6C0 271.4 5.4 284 14.9 293L164.7 435.7C173 443.6 184 448 195.4 448c24.6 0 44.6-20 44.6-44.6l0-67.4 160 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-160 0 0-67.4C240 84 220 64 195.4 64z"]
};
var faArrowAltLeft = faLeft;
var faFileWord = {
  prefix: 'fal',
  iconName: 'file-word',
  icon: [384, 512, [], "f1c2", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm39.2 235.1c-2.7-8.4-11.7-13.1-20.1-10.4s-13.1 11.7-10.4 20.1l56 176c2.2 6.8 8.5 11.3 15.6 11.1s13.2-4.9 15.1-11.8L192 300.8l32.6 119.4c1.9 6.8 8 11.6 15.1 11.8s13.4-4.4 15.6-11.1l56-176c2.7-8.4-2-17.4-10.4-20.1s-17.4 2-20.1 10.4L241.2 359.5 207.4 235.8c-1.9-7-8.2-11.8-15.4-11.8s-13.5 4.8-15.4 11.8L142.8 359.5 103.2 235.1z"]
};
var faFilePowerpoint = {
  prefix: 'fal',
  iconName: 'file-powerpoint',
  icon: [384, 512, [], "f1c4", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm64 240c-8.8 0-16 7.2-16 16V368v64c0 8.8 7.2 16 16 16s16-7.2 16-16V384h56c39.8 0 72-32.2 72-72s-32.2-72-72-72H128zm72 112H144V272h56c22.1 0 40 17.9 40 40s-17.9 40-40 40z"]
};
var faSquareDown = {
  prefix: 'fal',
  iconName: 'square-down',
  icon: [448, 512, [11015, "arrow-alt-square-down"], "f350", "M384 448c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0zm64-32c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 400c-9.2 0-18-3.5-24.7-9.7l-91-84c-7.8-7.2-12.3-17.4-12.3-28.1c0-21.1 17.1-38.3 38.3-38.3l25.7 0 0-80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 80 25.7 0c21.1 0 38.3 17.1 38.3 38.3c0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7zm3-33.2l91-84c1.3-1.2 2-2.9 2-4.6c0-3.5-2.8-6.3-6.3-6.3L272 272c-8.8 0-16-7.2-16-16l0-96c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 96c0 8.8-7.2 16-16 16l-41.7 0c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.4 2 4.6l91 84c.8 .8 1.9 1.2 3 1.2s2.2-.4 3-1.2z"]
};
var faArrowAltSquareDown = faSquareDown;
var faObjectsAlignCenterVertical = {
  prefix: 'fal',
  iconName: 'objects-align-center-vertical',
  icon: [512, 512, [], "e3bd", "M176 64c8.8 0 16 7.2 16 16l0 176 0 176c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16l0-176 0 0 0 0L96 80c0-8.8 7.2-16 16-16l64 0zm48 176l0-160c0-26.5-21.5-48-48-48l-64 0C85.5 32 64 53.5 64 80l0 160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64l0 160c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48l0-160 64 0v96c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V272h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448l0-96c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48l0 96-64 0zm96 16l0-112c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 112V368c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V256z"]
};
var faArrowsLeftRight = {
  prefix: 'fal',
  iconName: 'arrows-left-right',
  icon: [512, 512, ["arrows-h"], "f07e", "M503.3 271.3c6.1-6.1 6.3-15.9 .4-22.2l-96-104c-6-6.5-16.1-6.9-22.6-.9s-6.9 16.1-.9 22.6L455.5 244 50.6 244l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L50.6 276l402.7 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"]
};
var faArrowsH = faArrowsLeftRight;
var faHouseLock = {
  prefix: 'fal',
  iconName: 'house-lock',
  icon: [640, 512, [], "e510", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H392.6c-5.4-9.4-8.6-20.3-8.6-32H368V320c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32V480H144c-26.5 0-48-21.5-48-48V206.7L288 37.3 456.4 185.9c8.6-7.1 18.2-13 28.7-17.4L298.6 4zM336 480H240V320h96V480zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faCloudArrowDown = {
  prefix: 'fal',
  iconName: 'cloud-arrow-down',
  icon: [640, 512, [62337, "cloud-download", "cloud-download-alt"], "f0ed", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM228.7 299.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L304 329.4V176c0-8.8 7.2-16 16-16s16 7.2 16 16V329.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80z"]
};
var faCloudDownload = faCloudArrowDown;
var faCloudDownloadAlt = faCloudArrowDown;
var faWreath = {
  prefix: 'fal',
  iconName: 'wreath',
  icon: [448, 512, [], "f7e2", "M334.9 73.3c-16.3 4.8-33.6-3.9-39.3-20C291.2 40.9 279.3 32 265.4 32c-7.9 0-15.1 2.8-20.7 7.6c-11.9 10.1-29.5 10.1-41.4 0c-5.6-4.8-12.8-7.6-20.7-7.6c-13.9 0-25.8 8.9-30.2 21.3c-5.7 16.1-22.9 24.8-39.3 20c-2.9-.8-5.9-1.3-9.1-1.3c-17.7 0-32 14.3-32 32c0 3.2 .5 6.3 1.3 9.1c4.8 16.3-3.9 33.6-20 39.3C40.9 156.8 32 168.7 32 182.6c0 7.9 2.8 15.1 7.6 20.7c10.1 11.9 10.1 29.5 0 41.4c-4.8 5.6-7.6 12.8-7.6 20.7c0 13.9 8.9 25.8 21.3 30.2c16.1 5.7 24.8 22.9 20 39.3c-.8 2.9-1.3 5.9-1.3 9.1c0 17.7 14.3 32 32 32l.5 0c-5.4 8.2-8.5 18.1-8.5 28.7v2.9c-31.6-3.9-56-30.9-56-63.5c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 32.6-24.4 59.6-56 63.5v-2.9c0-10.6-3.1-20.4-8.5-28.7l.5 0c17.7 0 32-14.3 32-32c0-3.2-.5-6.3-1.3-9.1c-4.8-16.3 3.9-33.6 20-39.3c12.5-4.4 21.3-16.3 21.3-30.2c0-7.9-2.8-15.1-7.6-20.7c-10.1-11.9-10.1-29.5 0-41.4c4.8-5.6 7.6-12.8 7.6-20.7c0-13.9-8.9-25.8-21.3-30.2c-16.1-5.7-24.8-22.9-20-39.3c.8-2.9 1.3-5.9 1.3-9.1c0-17.7-14.3-32-32-32c-3.2 0-6.3 .5-9.1 1.3zM235.2 458L288 477.8V418.2L235.2 438c-7.2 2.7-15.2 2.7-22.5 0L160 418.2v59.6L212.8 458c7.2-2.7 15.2-2.7 22.5 0zM128 411.1c0-15 12.1-27.1 27.1-27.1c3.2 0 6.5 .6 9.5 1.7L224 408l59.4-22.3c3-1.1 6.3-1.7 9.5-1.7c15 0 27.1 12.1 27.1 27.1v73.8c0 15-12.1 27.1-27.1 27.1c-3.2 0-6.5-.6-9.5-1.7L224 488l-59.4 22.3c-3 1.1-6.3 1.7-9.5 1.7c-15 0-27.1-12.1-27.1-27.1V411.1zm55.5-227.6c-.3 15.1-6.3 29.6-16.8 40.5c10.4 10.9 16.4 25.4 16.8 40.5c15.1 .3 29.6 6.3 40.5 16.8c10.9-10.4 25.4-16.4 40.5-16.8c.3-15.1 6.3-29.6 16.8-40.5c-10.4-10.9-16.4-25.4-16.8-40.5c-8.1-.2-16-2-23.3-5.2c-6.3-2.8-12.2-6.7-17.2-11.6c-10.9 10.4-25.4 16.4-40.5 16.8zM203 142.4c11.3-12.1 30.6-12.1 41.9 0c5.7 6 13.6 9.4 21.9 9.1c16.6-.6 30.2 13 29.6 29.6c-.3 8.3 3 16.3 9.1 21.9c12.1 11.3 12.1 30.6 0 41.9c-6 5.7-9.4 13.6-9.1 21.9c.6 16.6-13 30.2-29.6 29.6c-8.3-.3-16.3 3-21.9 9.1c-11.3 12.1-30.6 12.1-41.9 0c-5.7-6-13.6-9.4-21.9-9.1c-16.6 .6-30.2-13-29.6-29.6c.3-8.3-3-16.3-9.1-21.9c-12.1-11.3-12.1-30.6 0-41.9c6-5.7 9.4-13.6 9.1-21.9c-.6-16.6 13-30.2 29.6-29.6c8.3 .3 16.3-3 21.9-9.1z"]
};
var faChildren = {
  prefix: 'fal',
  iconName: 'children',
  icon: [640, 512, [], "e4e1", "M192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm416 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 416 64zm64 128c-11.6 0-22.6 3.4-32 9.6V352h64V201.6c-9.4-6.2-20.4-9.6-32-9.6zM448 496c0 8.8-7.2 16-16 16s-16-7.2-16-16V243.3l-42.4 69.1c-4.6 7.5-14.5 9.9-22 5.3s-9.9-14.5-5.3-22L403.2 203c16.4-26.7 45.5-43 76.8-43s60.4 16.3 76.8 43l56.8 92.6c4.6 7.5 2.3 17.4-5.3 22s-17.4 2.3-22-5.3L544 243.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H448V496zM96 400H72c-5 0-9.7-2.3-12.7-6.3s-4-9.1-2.8-13.9l38-141.2L45.3 312.8c-4.9 7.4-14.8 9.4-22.2 4.5s-9.4-14.8-4.5-22.2L79.8 203c16.8-25.3 44.4-41.1 74.5-42.9c1.4-.1 2.9-.2 4.4-.2H160h1.3c1.5 0 2.9 .1 4.4 .2c30.1 1.8 57.7 17.6 74.5 42.9l61.1 92.1c4.9 7.4 2.9 17.3-4.5 22.2s-17.3 2.9-22.2-4.5l-49.2-74.2 38 141.2c1.3 4.8 .3 9.9-2.8 13.9s-7.7 6.3-12.7 6.3H224v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H128v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400zm60.5-207.9c-10 .9-18.4 7.9-21.1 17.7L92.9 368H227.1L184.5 209.8c-2.6-9.8-11.1-16.8-21.1-17.7c-1.2-.1-2.3-.1-3.5-.1s-2.3 0-3.5 .1z"]
};
var faMeterDroplet = {
  prefix: 'fal',
  iconName: 'meter-droplet',
  icon: [640, 512, [], "e1ea", "M256 480c49.7 0 95.5-16.2 132.7-43.5c2.8 10.8 6.9 21.1 12 30.7C359.5 495.5 309.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C366.8 0 461.2 70.4 496.8 169c-8.5 5.3-15.7 12.9-20.6 22.1l-3.8 7.1C447 102.5 359.7 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zM176 144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm89.4 218.4c-6.2 11.6-9.4 24.5-9.4 37.6c0 44.2 35.8 80 80 80s80-35.8 80-80c0-13.1-3.2-26.1-9.4-37.6L528 230 457.4 362.4zm-28.2-15.1l75.3-141.2c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7z"]
};
var faChalkboard = {
  prefix: 'fal',
  iconName: 'chalkboard',
  icon: [576, 512, ["blackboard"], "f51b", "M64 88c0-13.3 10.7-24 24-24H488c13.3 0 24 10.7 24 24V416h32V88c0-30.9-25.1-56-56-56H88C57.1 32 32 57.1 32 88V416H64V88zM224 400v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V400c0-26.5-21.5-48-48-48H272c-26.5 0-48 21.5-48 48zm48-16h96c8.8 0 16 7.2 16 16v40H256V400c0-8.8 7.2-16 16-16z"]
};
var faBlackboard = faChalkboard;
var faUserLargeSlash = {
  prefix: 'fal',
  iconName: 'user-large-slash',
  icon: [640, 512, ["user-alt-slash"], "f4fa", "M541 512l-40.5-32H96c.7-70.8 58.3-128 129.3-128h113l-40.5-32H225.3C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H541zM464 144C464 64.5 399.5 0 320 0C265.6 0 218.2 30.2 193.7 74.8l25.6 20.2C237.5 57.7 275.7 32 320 32c61.9 0 112 50.1 112 112c0 34.9-15.9 66-40.9 86.6l25.6 20.2C445.7 224.4 464 186.3 464 144zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faUserAltSlash = faUserLargeSlash;
var faSignalStrong = {
  prefix: 'fal',
  iconName: 'signal-strong',
  icon: [640, 512, ["signal-4"], "f68f", "M464 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V112zM320 192c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zM208 304c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM80 400c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400z"]
};
var faSignal4 = faSignalStrong;
var faLollipop = {
  prefix: 'fal',
  iconName: 'lollipop',
  icon: [512, 512, [127853, "lollypop"], "e424", "M192 352c-27 0-52.4-6.7-74.7-18.5c8.7 1.6 17.6 2.5 26.7 2.5h16c75.1 0 136-60.9 136-136v-8c0-57.4-46.6-104-104-104S88 134.6 88 192c0 35.3 28.7 64 64 64s64-28.7 64-64v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-39.8 32.2-72 72-72s72 32.2 72 72v8c0 57.4-46.6 104-104 104H144C82.1 304 32 253.9 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160zM0 192C0 298 86 384 192 384c47.3 0 90.5-17.1 124-45.4L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L338.6 316c28.3-33.5 45.4-76.7 45.4-124C384 86 298 0 192 0S0 86 0 192z"]
};
var faLollypop = faLollipop;
var faListTree = {
  prefix: 'fal',
  iconName: 'list-tree',
  icon: [512, 512, [], "e1d2", "M32 112H64V80H32v32zM0 72C0 58.7 10.7 48 24 48H72c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H64v96h64v-8c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24v-8H64V384c0 8.8 7.2 16 16 16h48v-8c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24v-8H80c-26.5 0-48-21.5-48-48V256 144H24c-13.3 0-24-10.7-24-24V72zM160 96c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zM288 256c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 160c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zM160 432h32V400H160v32zm0-192v32h32V240H160z"]
};
var faEnvelopeOpen = {
  prefix: 'fal',
  iconName: 'envelope-open',
  icon: [512, 512, [62135], "f2b6", "M241.6 36.8L45 182.4c-8.1 6-13 15.6-13 25.7v3.2l10.2 8.3L237.8 380.3c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5L469.8 219.6l10.2-8.3v-3.2c0-10.1-4.8-19.7-13-25.7L270.4 36.8c-4.2-3.1-9.2-4.8-14.4-4.8s-10.3 1.7-14.4 4.8zM32 252.7V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V252.7L294.5 405.1C283.7 414 270 418.9 256 418.9s-27.7-4.9-38.5-13.8L32 252.7zM222.5 11C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L486.1 156.7c16.3 12.1 25.9 31.1 25.9 51.4V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208.1c0-20.3 9.6-39.4 25.9-51.4L222.5 11z"]
};
var faDrawCircle = {
  prefix: 'fal',
  iconName: 'draw-circle',
  icon: [512, 512, [], "f5ed", "M256 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm58.5-6c-10 22.4-32.4 38-58.5 38s-48.6-15.6-58.5-38C147.4 107.6 107.6 147.4 90 197.5c22.4 10 38 32.4 38 58.5s-15.6 48.6-38 58.5c17.7 50.1 57.4 89.9 107.5 107.5c10-22.4 32.4-38 58.5-38s48.6 15.6 58.5 38c50.1-17.7 89.9-57.4 107.5-107.5c-22.4-10-38-32.4-38-58.5s15.6-48.6 38-58.5C404.4 147.4 364.6 107.6 314.5 90zM454.1 192.3c32.5 3.1 57.9 30.4 57.9 63.7s-25.4 60.7-57.9 63.7c-20.5 63.6-70.7 113.9-134.3 134.3C316.7 486.6 289.3 512 256 512s-60.7-25.4-63.7-57.9C128.7 433.6 78.4 383.3 57.9 319.7C25.4 316.7 0 289.3 0 256s25.4-60.7 57.9-63.7C78.4 128.7 128.7 78.4 192.3 57.9C195.3 25.4 222.7 0 256 0s60.7 25.4 63.7 57.9c63.6 20.5 113.9 70.7 134.3 134.3zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCatSpace = {
  prefix: 'fal',
  iconName: 'cat-space',
  icon: [640, 512, [], "e001", "M448 288c-70.7 0-128-57.3-128-128c0-32.5 12.1-62.1 32-84.7V160c0 53 43 96 96 96s96-43 96-96V75.3c19.9 22.6 32 52.2 32 84.7c0 70.7-57.3 128-128 128zm0-256c25.4 0 49.2 7.4 69.1 20.2L482.4 80H413.6L378.9 52.2C398.8 39.4 422.6 32 448 32zm64 274.7c56.5-24.7 96-81.1 96-146.7C608 71.6 536.4 0 448 0S288 71.6 288 160c0 4.6 .2 9.1 .6 13.6C218.8 192.1 161.5 238.4 128 299.2V176.5c0-40.3-30-74.4-70.1-79.4l-7.9-1C41.2 95 33.2 101.2 32.1 110s5.1 16.8 13.9 17.9l7.9 1c24 3 42 23.4 42 47.6V424v8c0 44.2 35.8 80 80 80h0H304l42.7 0c20.6 0 37.3-16.7 37.3-37.3c0-25.8-16.7-47.7-39.8-55.6L416 379.2V464c0 26.5 21.5 48 48 48s48-21.5 48-48V306.7zm-32 10.1V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-5.7-3-10.9-7.9-13.8s-10.9-3-15.9-.2L304 404.8V392c0-39.8-32.2-72-72-72h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h8c22.1 0 40 17.9 40 40v40 0c0 8.8 7.2 16 16 16h37.3c14.7 0 26.7 11.9 26.7 26.7c0 2.9-2.4 5.3-5.3 5.3H304l0 0H176c-26.5 0-48-21.5-48-48v-8c0-103.1 69.2-192 166.5-218.8C314 271.5 375.3 320 448 320c11 0 21.7-1.1 32-3.2zM240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V48H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V80h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V16zM384 97.3l14 11.2c2.8 2.3 6.4 3.5 10 3.5h80c3.6 0 7.2-1.2 10-3.5l14-11.2V160c0 35.3-28.7 64-64 64s-64-28.7-64-64V97.3zM416 168a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faHandshakeSimpleSlash = {
  prefix: 'fal',
  iconName: 'handshake-simple-slash',
  icon: [640, 512, ["handshake-alt-slash"], "e05f", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM368.5 212.8l11.9-11c6.5-6 6.9-16.1 .9-22.6s-16.1-6.9-22.6-.9l-15.6 14.4 25.4 20.1zm-81.7-64.5l27.5-26C332.2 105.4 355.8 96 380.4 96c22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.9 2.4 6.5 3.8 10.3 3.8H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H503.3L462.9 94.1C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35l-30.9 29.2 25.4 20zm-58.7-46.4c3.1-1 6.2-1.9 9.3-2.7L272.6 64h-8.7c-22.5 0-44.6 5.3-64.5 15.3l28.7 22.6zM54.6 128H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H95.1L54.6 128zm139 109.8c.2 .8 .4 1.5 .6 2.2h2.3l-2.8-2.2zM370.4 377.3c1.5 9.3-1.1 19.1-7.8 26.6c-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8c-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-28.6-28.6c-13.5-13.5-31.8-21.1-50.9-21.1H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h59.4c10.6 0 20.8 4.2 28.3 11.7l28.6 28.6 15.4 15.4 .1 .1 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6c.8-.7 1.6-1.4 2.3-2.2c26.3 21.3 65.3 18.6 88.4-7.3c6.5-7.3 11-15.6 13.6-24.4l-29.7-23.5zm132.5-58.5l40.5 32H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H502.9z"]
};
var faHandshakeAltSlash = faHandshakeSimpleSlash;
var faRabbitRunning = {
  prefix: 'fal',
  iconName: 'rabbit-running',
  icon: [576, 512, ["rabbit-fast"], "f709", "M480 224c7.1 0 13.1 4.6 15.2 10.9l1.3-.4c-.4 .2-.8 .4-1.2 .6c.5 1.5 .8 3.2 .8 4.9c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16zm-31-75.8c14.7 2.1 28.9 6.6 42 13.5c-.7-35-15-69-40.8-94.2l-1.4-1.4c-1.9-1.9-4.7-2.7-7.3-2.2l-1.6 .3c-2.3 .4-4.2 1.9-5.3 3.9C427.1 60.4 419 53.4 410.3 47c5.8-7.3 14.1-12.4 23.5-14.2l1.6-.3c13-2.5 26.4 1.5 35.8 10.8l1.4 1.4c37.1 36.4 55 87.5 49.4 138.2l23.7 17.7c19 14.2 30.2 36.5 30.2 60.3c0 41.5-33.7 75.2-75.2 75.2H406.6l-32 32H424c26.5 0 48 21.5 48 48s-21.5 48-48 48H306.5c-21.2 0-41.6-8.4-56.6-23.4L237 427.7l-66.4 44.3c-22.1 14.7-51.9 8.7-66.6-13.3s-8.7-51.9 13.3-66.6l50.4-33.6-55-55c-9.8-9.8-17.6-21.2-23.1-33.7C84 271.2 78.1 272 72 272c-39.8 0-72-32.2-72-72s32.2-72 72-72c16.3 0 31.3 5.4 43.3 14.5c20.1-18.9 47.1-30.5 76.9-30.5h9c17.3 0 34.4 3.7 50.2 10.9l66 30c-2.3-5.4-4.2-11-5.8-16.8l-10.2-37c-5.1-18.5 2.9-38.1 19.5-47.7l7.9 13.7-7.9-13.7 2.1-1.2c9-5.2 19.9-6.3 29.8-3.1c47 15.5 83.1 53.5 96.2 101.1zM81 239c-.7-4.9-1-9.8-1-14.8c0-20.7 5.6-40 15.3-56.7C88.8 162.8 80.7 160 72 160c-22.1 0-40 17.9-40 40s17.9 40 40 40c3.1 0 6.1-.4 9-1zm54.1 179.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L214 404.6l-23.1-23.1-55.8 37.2zm201-18.7c-3.7 0-7.2-1.2-10-3.4c-.6-.5-1.2-1-1.7-1.6c-2.2-2.3-3.8-5.3-4.3-8.7c-.1-.4-.1-.9-.1-1.3l-1.7-24.4c-3.3-46.1-34.6-85.5-78.8-99.1l-20.2-6.2c-8.4-2.6-13.2-11.6-10.6-20s11.6-13.2 20-10.6l20.2 6.2c53.6 16.5 92.4 62.4 100.2 117.3l39.6-39.6c3-3 7.1-4.7 11.3-4.7H500.8c23.9 0 43.2-19.3 43.2-43.2c0-13.6-6.4-26.5-17.4-34.6l-37.3-27.9c-15.7-11.7-34.4-18.4-53.8-19.3c-7-.3-13-5.2-14.8-12.1l-2-7.8c-9.7-38.5-38.4-69.3-76-81.7c-1.2-.4-2.6-.3-3.8 .4m0 0l-2.1 1.2c-4 2.3-5.9 7-4.7 11.5l10.2 37c5.5 20 16.5 37.9 31.4 51.9c5.7 5.4 6.7 14.1 2.4 20.6s-12.8 8.9-19.9 5.7L238.1 152c-11.6-5.3-24.2-8-36.9-8h-9c-44.3 0-80.2 35.9-80.2 80.2c0 21.3 8.4 41.7 23.5 56.7L272.6 417.9c9 9 21.2 14.1 33.9 14.1H424c8.8 0 16-7.2 16-16s-7.2-16-16-16H336.2"]
};
var faRabbitFast = faRabbitRunning;
var faMemoPad = {
  prefix: 'fal',
  iconName: 'memo-pad',
  icon: [448, 512, [], "e1da", "M32 128V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V128H32zm0-32H416V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V96zM448 64V96v16 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128 112 96 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64zM112 192H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMattressPillow = {
  prefix: 'fal',
  iconName: 'mattress-pillow',
  icon: [640, 512, [], "e525", "M256 96V416H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H256zm32 0H576c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H288V96zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm112 96c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h64zm-64-32c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H112z"]
};
var faAlarmPlus = {
  prefix: 'fal',
  iconName: 'alarm-plus',
  icon: [512, 512, [], "f844", "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 80c-8.8 0-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80c0 8.8 7.2 16 16 16s16-7.2 16-16V304h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V192c0-8.8-7.2-16-16-16z"]
};
var faAlicorn = {
  prefix: 'fal',
  iconName: 'alicorn',
  icon: [640, 512, [], "f6b0", "M335.5 148.1c-.5 1.9-1.3 3.6-2.5 5.2c-1.4 1.9-3.1 3.4-5 4.5s-4.1 1.8-6.4 2.1c-3.2 .3-6.6-.3-9.6-2L169.9 76.6c7 52.2 32.2 91.2 57.8 118.4c15.1 16 30.1 27.8 41.4 35.5c5.6 3.9 10.3 6.7 13.5 8.6c1.6 .9 2.8 1.6 3.6 2l.9 .5 .2 .1 0 0 0 0c7.9 4 11.1 13.6 7.1 21.5s-13.6 11.1-21.5 7.2L280 256c-7.2 14.3-7.2 14.3-7.2 14.3l0 0 0 0-.1-.1-.4-.2c-.3-.2-.7-.4-1.3-.7c-1.1-.6-2.6-1.4-4.5-2.5c-3.8-2.2-9.2-5.5-15.5-9.9c-12.7-8.7-29.6-22-46.6-40C170.4 180.9 136 125.2 136 48c0-5.7 3-11 8-13.8s11-2.9 16-.1l146.4 83.7C318.7 50.8 377.4 0 448 0h24 8 5.8H544c8.8 0 16 7.2 16 16c0 7-4.5 13-10.8 15.1c7.3 9.5 12.5 20.6 15 32.9h66.5c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8l-65.2 21.7 4.7 49.4c2.3 23.9-9.2 47.1-29.6 59.9c-29.1 18.2-67.4 10-86.5-18.6l-1.7-2.5H448v40c0 .7-.1 1.5-.1 2.2c.1 1.9 .1 3.9 .1 5.8c0 30.9-12.4 58.4-32 78.4V472c0 22.1-17.9 40-40 40H344c-22.1 0-40-17.9-40-40V347.6l-88.1-19.8c-.5 14.3-3.6 28.3-9.2 41.4l-8.1 19c-2.2 5-2.5 10.6-1.1 15.9l15.9 57.2c7.1 25.5-12.1 50.7-38.5 50.7H141.6c-18 0-33.7-12-38.5-29.3L89.6 434.1c-8.3-29.8-6.2-61.5 6-90l8.1-19c.2-.4 .3-.8 .3-1.3c0-.4-.1-.8-.2-1.2L70.4 242.5c-4.2-10.1-6.4-20.8-6.4-31.7c-18.6 6.6-32 24.4-32 45.3v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-41.3 31.3-75.2 71.4-79.5c9-19.8 25.6-35.4 46-43.1c3.4 10.4 7.4 20.4 11.8 29.8C109.8 170.2 96 188.8 96 210.7c0 6.7 1.3 13.3 3.9 19.5l33.4 80.1c1.8 4.3 2.7 8.9 2.7 13.5c0 4.8-1 9.5-2.8 13.9l-8.1 19c-9.3 21.7-10.9 46-4.6 68.8l13.5 48.6c1 3.5 4.1 5.9 7.7 5.9h33.2c5.3 0 9.1-5 7.7-10.1l-15.9-57.2c-3.4-12.3-2.5-25.3 2.5-37l8.1-19c4.4-10.4 6.7-21.5 6.7-32.8c0-4.6-.4-9.2-1.1-13.7c-.9-5.3 .9-10.6 4.8-14.3s9.3-5.2 14.5-4L318.4 318c1.4 .3 2.8 .6 4.3 .8c7.7 1.3 13.3 8 13.3 15.8V472c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V311.6c0-4.6 1.9-8.9 5.3-11.9C405.6 285.1 416 264 416 240c0-2.3-.1-4.5-.3-6.7c-.1-1.5 0-3.1 .3-4.5V176c0-8.8 7.2-16 16-16h32c5.4 0 10.3 2.7 13.3 7.1l6.4 9.6c9.4 14.2 28.5 18.3 42.9 9.2c10.1-6.3 15.8-17.8 14.7-29.7l-7.7-80.8c-2.3-24.6-23-43.4-47.8-43.4H480h-8H448c-61.8 0-111.9 50-112 111.7c0 1.5-.1 2.9-.5 4.4zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faCommentQuestion = {
  prefix: 'fal',
  iconName: 'comment-question',
  icon: [512, 512, [], "e14b", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM168.7 153.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V272c0 8.8 7.2 16 16 16s16-7.2 16-16V252.3l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3H222.9c-25.5 0-47.7 17.2-54.2 41.8zM280 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faGingerbreadMan = {
  prefix: 'fal',
  iconName: 'gingerbread-man',
  icon: [448, 512, [], "f79d", "M144 112c0-44.2 35.8-80 80-80s80 35.8 80 80c0 20.5-7.7 39.2-20.4 53.3c-4.2 4.7-5.3 11.4-2.7 17.2s8.3 9.5 14.6 9.5H368c26.5 0 48 21.5 48 48s-21.5 48-48 48h-7c-32.4 0-50.3 37.7-29.7 62.8l41.7 50.7c16.8 20.5 13.9 50.7-6.6 67.6s-50.7 13.9-67.6-6.6l-45.3-55c-15.4-18.7-43.9-18.7-59.3 0l-45.3 55c-16.8 20.5-47.1 23.4-67.6 6.6S58.1 422 74.9 401.5l41.7-50.7C137.3 325.7 119.4 288 87 288H80c-26.5 0-48-21.5-48-48s21.5-48 48-48h72.4c6.3 0 12-3.7 14.6-9.5s1.5-12.5-2.7-17.2C151.7 151.2 144 132.5 144 112zM224 0C162.1 0 112 50.1 112 112c0 17.2 3.9 33.4 10.8 48H80c-44.2 0-80 35.8-80 80s35.8 80 80 80h7c5.4 0 8.4 6.3 4.9 10.5L50.2 381.2c-28.1 34.1-23.2 84.5 10.9 112.6l9.1-11.1-9.1 11.1c34.1 28.1 84.5 23.2 112.6-10.9l45.3-55c2.6-3.1 7.3-3.1 9.9 0l45.3 55c28.1 34.1 78.5 39 112.6 10.9s39-78.5 10.9-112.6l-41.7-50.7c-3.4-4.2-.5-10.5 4.9-10.5h7c44.2 0 80-35.8 80-80s-35.8-80-80-80H325.2c6.9-14.6 10.8-30.8 10.8-48C336 50.1 285.9 0 224 0zM192 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faGuaraniSign = {
  prefix: 'fal',
  iconName: 'guarani-sign',
  icon: [384, 512, [], "e19a", "M176 0c-8.8 0-16 7.2-16 16V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c106 0 192-86 192-192c0-8.8-7.2-16-16-16H192V96c43.6 0 83.1 17.4 112 45.7c6.3 6.2 16.4 6.1 22.6-.2s6.1-16.4-.2-22.6C291.8 85 244.3 64 192 64l0-48c0-8.8-7.2-16-16-16zM160 99.2V412.8C87 398 32 333.4 32 256s55-142 128-156.8zM192 416V272H351.2c-8 80.9-76.2 144-159.2 144z"]
};
var faBurgerFries = {
  prefix: 'fal',
  iconName: 'burger-fries',
  icon: [640, 512, [], "e0cd", "M151.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3V266.4c-8.5 2.4-19 4.3-32 5.1V57.9l-32-16V271.5c-13-.9-23.5-2.7-32-5.1V16c0-5.5 2.9-10.7 7.6-13.6zM279.1 233.8c-1 4-2.9 9-7.1 14.1V208.6L299.1 84.5 272 89.9V57.3l44.9-9c5.3-1.1 10.8 .6 14.6 4.5s5.4 9.4 4.2 14.6l-28.4 130c-15.5 8-24.9 23.6-28 36.4zm88.7-55.6c-10.2 4.1-19.5 8.8-28.1 13.7h-7.2l19.8-99.1c1.7-8.7 10.2-14.3 18.8-12.6s14.3 10.2 12.6 18.8l-15.8 79.1zM192 304c27.6 0 48.8-3.7 65.2-9.5c-.9 6.3-1.2 12.4-1.2 18.1c0 5.3 .7 10.3 2.1 15.2c-18.6 5.3-40.4 8.2-66.1 8.2c-49.1 0-84.4-10.7-109.1-28.4C61 291.8 50 272.4 44.7 256H34.9L89.2 480H260c3.7 11.9 9.7 22.7 17.6 32H89.2c-14.8 0-27.6-10.1-31.1-24.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224H54.3c9.5 0 17.2 8.3 19.5 17.5C79.6 265 102.7 304 192 304zM21.4 192c-.9 0-1.7 0-2.5 .1L.3 99.1C-1.4 90.5 4.2 82 12.9 80.3s17.1 3.9 18.8 12.6L51.5 192H21.4zm98.8 63.6c-10.3-7.4-13.9-15.8-15.4-21.7c-3-12.1-11.4-26.5-25.2-34.9L56.2 58.6c-1.2-6.9 2.3-13.8 8.6-16.9L112 18.1V53.9L89.7 65l31.9 191.5c-.5-.3-1-.7-1.4-1zm210.7 23.9c-5.7 6.2-9.2 14.6-10.4 24.4h287c-1.2-9.8-4.7-18.2-10.4-24.4c-8.3-9-20.6-20.1-37.1-30.1c-.8 8.1-7.6 14.5-15.9 14.5c-8.8 0-16-7.2-16-16c0-4.6 1.9-8.7 5-11.6c-15.7-6.1-33.9-10.5-54.9-11.9c1.2 2.2 1.9 4.8 1.9 7.5c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7 .7-5.3 1.9-7.5c-21 1.4-39.2 5.9-54.9 11.9c3.1 2.9 5 7 5 11.6c0 8.8-7.2 16-16 16c-8.3 0-15.1-6.3-15.9-14.5c-16.6 10-28.8 21.1-37.1 30.1zM464 191.8c82 0 132.6 40 156.5 65.9c14.6 15.7 19.5 36.1 19.5 54.7c0 12.9-10.5 23.4-23.4 23.4H311.4c-12.9 0-23.4-10.5-23.4-23.4c0-18.7 4.9-39.1 19.5-54.7c24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3H602.7c20.6 0 37.3 16.7 37.3 37.3c0 32.4-26.3 58.7-58.7 58.7H346.7c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3c0 14.7 11.9 26.7 26.7 26.7H581.3c14.7 0 26.7-11.9 26.7-26.7c0-2.9-2.4-5.3-5.3-5.3H325.3z"]
};
var faMugTea = {
  prefix: 'fal',
  iconName: 'mug-tea',
  icon: [576, 512, [], "f875", "M144 96H64V352c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V272 96H352 176v40.5l36.5 30.4C219.8 173 224 182 224 191.5V256c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V191.5c0-9.5 4.2-18.5 11.5-24.6L144 136.5V96zm16-32H352h32 80c61.9 0 112 50.1 112 112s-50.1 112-112 112H416v64c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32h96zM464 96H416V256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80zM128 256h64V191.5l-32-26.7-32 26.7 0 64.5z"]
};
var faBorderTop = {
  prefix: 'fal',
  iconName: 'border-top',
  icon: [448, 512, [], "f855", "M0 48c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48zM56 160A24 24 0 1 1 8 160a24 24 0 1 1 48 0zm336 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-144 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 352a24 24 0 1 1 48 0A24 24 0 1 1 8 352zm432 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-240 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 256A24 24 0 1 1 8 256a24 24 0 1 1 48 0zm336 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-144 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 448a24 24 0 1 1 48 0A24 24 0 1 1 8 448zm432 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-240 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM152 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM104 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm240 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM296 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faArrowsRotate = {
  prefix: 'fal',
  iconName: 'arrows-rotate',
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M69.4 210.6C89.8 126.5 165.6 64 256 64c71.1 0 133.1 38.6 166.3 96H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h80.7H464c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v60.6C408.8 75.5 337.5 32 256 32C149.6 32 60.5 106.2 37.7 205.6C35.5 215.2 43.1 224 53 224c7.9 0 14.6-5.7 16.5-13.4zm373.2 90.9C422.2 385.5 346.4 448 256 448c-71.1 0-133.1-38.6-166.3-96h54.5c8.8 0 16-7.2 16-16s-7.2-16-16-16H63.3 48.2c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V371.8C103.4 436.6 174.7 480 256 480c106.4 0 195.5-74.2 218.3-173.6c2.2-9.6-5.4-18.4-15.3-18.4c-7.9 0-14.6 5.7-16.5 13.4z"]
};
var faRefresh = faArrowsRotate;
var faSync = faArrowsRotate;
var faCircleBookOpen = {
  prefix: 'fal',
  iconName: 'circle-book-open',
  icon: [512, 512, ["book-circle"], "e0ff", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144-69.7v130l.7-.1c12.3-2.1 29.3-4.2 47.3-4.2c18.4 0 35.4 5.9 48 11.8V186.3c-2.4-1-5.3-2.1-8.5-3.2c-10.8-3.7-25-7.2-39.5-7.2s-28.7 3.5-39.5 7.2c-3.2 1.1-6.1 2.2-8.5 3.2zM246 364.5l-.1-.1c-.2-.1-.4-.3-.8-.6c-.7-.5-1.8-1.3-3.3-2.3c-2.9-2-7.2-4.6-12.5-7.3C218.7 348.8 205.3 344 192 344c-15.7 0-30.8 1.9-42 3.8c-5.6 1-10.1 1.9-13.3 2.6c-1.6 .4-2.8 .6-3.6 .8l-.9 .2-.2 0 0 0 0 0c-4.8 1.3-9.9 .2-13.8-2.8s-6.2-7.7-6.2-12.7V176c0-5.9 3.3-11.4 8.5-14.1L128 176c-7.5-14.1-7.5-14.1-7.5-14.1l0 0 0 0 0 0 .1-.1 .4-.2c.3-.2 .7-.4 1.2-.6c1.1-.5 2.5-1.2 4.4-2.1c3.7-1.7 9-3.9 15.5-6c12.7-4.3 30.6-8.8 49.8-8.8s37.1 4.5 49.8 8.8c5.7 1.9 10.6 3.9 14.2 5.5c3.6-1.6 8.5-3.5 14.2-5.5c12.7-4.3 30.6-8.8 49.8-8.8s37.1 4.5 49.8 8.8c6.4 2.2 11.7 4.4 15.5 6c1.9 .8 3.4 1.5 4.4 2.1c.5 .3 .9 .5 1.2 .6l.4 .2 .1 .1 0 0 0 0 0 0s0 0-7.5 14.1l7.5-14.1c5.2 2.8 8.5 8.2 8.5 14.1V336c0 5-2.3 9.6-6.2 12.7s-9 4.1-13.8 2.8l0 0 0 0-.2 0-.9-.2c-.8-.2-2-.5-3.6-.8c-3.1-.7-7.7-1.6-13.3-2.6c-11.2-1.9-26.3-3.8-42-3.8c-13.3 0-26.7 4.8-37.4 10.3c-5.2 2.7-9.5 5.3-12.5 7.3c-1.5 1-2.6 1.8-3.3 2.3c-.4 .3-.6 .5-.8 .6l-.1 .1c-.3 .3-.7 .5-1 .8c-.3 .2-.6 .4-.9 .5c-2.3 1.4-5 2.1-7.6 2.2c-.4 0-.8 0-1.3 0c-2.7-.1-5.3-1-7.7-2.4c-.5-.3-1-.7-1.5-1zm26-40.7c12.6-6 29.6-11.8 48-11.8c18.1 0 35 2.1 47.3 4.2l.7 .1v-130c-2.4-1-5.3-2.1-8.5-3.2c-10.8-3.7-25-7.2-39.5-7.2s-28.7 3.5-39.5 7.2c-3.2 1.1-6.1 2.2-8.5 3.2V323.8z"]
};
var faBookCircle = faCircleBookOpen;
var faArrowsToDottedLine = {
  prefix: 'fal',
  iconName: 'arrows-to-dotted-line',
  icon: [448, 512, [], "e0a6", "M224 192c-4.2 0-8.3-1.7-11.3-4.7l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 137.4 208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 121.4 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-3 3-7.1 4.7-11.3 4.7zM56 256A24 24 0 1 1 8 256a24 24 0 1 1 48 0zm384 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM320 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-72-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM128 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm107.3 44.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 374.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V374.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7z"]
};
var faFireExtinguisher = {
  prefix: 'fal',
  iconName: 'fire-extinguisher',
  icon: [512, 512, [129519], "f134", "M320 96V80 64L480 32l0 96L320 96zM288 64H192V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64C104.5 64 55.6 92.3 27 135.1c-7.3 11-13.4 22.9-17.8 35.6c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8c3.6-10.1 8.4-19.7 14.3-28.4C76.5 118.6 115.6 96 160 96v33.1c-54.3 7.8-96 54.4-96 110.9V448c0 35.3 28.7 64 64 64h96c35.3 0 64-28.7 64-64V240c0-56.4-41.7-103.1-96-110.9V96h96v0c0 15.3 10.8 28.4 25.7 31.4l160 32c9.4 1.9 19.1-.6 26.6-6.6s11.7-15.2 11.7-24.7V32c0-9.6-4.3-18.7-11.7-24.7s-17.2-8.5-26.6-6.6l-160 32c-15 3-25.7 16.1-25.7 31.4zM176 160c44.2 0 80 35.8 80 80V384H96V240c0-44.2 35.8-80 80-80zm80 288c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416H256v32z"]
};
var faGarageOpen = {
  prefix: 'fal',
  iconName: 'garage-open',
  icon: [640, 512, [], "e00b", "M313.8 36c4-1.7 8.4-1.7 12.4 0L588.4 146.4c11.9 5 19.6 16.6 19.6 29.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V175.9c0-25.8-15.4-49-39.2-59L338.6 6.5c-11.9-5-25.3-5-37.3 0L39.2 116.9C15.4 126.9 0 150.1 0 175.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V175.9c0-12.9 7.7-24.5 19.6-29.5L313.8 36zM128 192c-17.7 0-32 14.3-32 32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V288H512V496c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7-14.3-32-32-32H128zm384 64H128V224H512v32zM212.5 320l-10.6 32.8C186.3 362.7 176 380.2 176 400v96c0 8.8 7.2 16 16 16s16-7.2 16-16V480H432v16c0 8.8 7.2 16 16 16s16-7.2 16-16V400c0-19.8-10.3-37.3-25.9-47.2L427.5 320H393.8l7.8 24H238.4l7.8-24H212.5zM432 400v48H208V400c0-13.3 10.7-24 24-24H408c13.3 0 24 10.7 24 24zM248 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm160-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faShelvesEmpty = {
  prefix: 'fal',
  iconName: 'shelves-empty',
  icon: [640, 512, [], "e246", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V176 432v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448H608v48c0 8.8 7.2 16 16 16s16-7.2 16-16V432 176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V160H32V16zm0 176H608V416H32V192z"]
};
var faCruzeiroSign = {
  prefix: 'fal',
  iconName: 'cruzeiro-sign',
  icon: [448, 512, [], "e152", "M64 256C64 150.1 150.6 64 257.7 64c49.6 0 94.9 18.5 129.2 48.9c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6c-39.9-35.4-92.7-57-150.4-57C133.2 32 32 132.2 32 256s101.2 224 225.7 224c57.7 0 110.5-21.6 150.4-57c6.6-5.9 7.2-16 1.3-22.6s-16-7.2-22.6-1.3C352.6 429.5 307.3 448 257.7 448c-11.5 0-22.7-1-33.7-2.9V320c0-26.5 21.5-48 48-48c15.1 0 29.3 7.1 38.4 19.2l4.8 6.4c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4L336 272c-15.1-20.1-38.8-32-64-32c-18 0-34.6 6-48 16V240c0-8.8-7.2-16-16-16s-16 7.2-16 16v80V436.7C117.3 410 64 339.1 64 256z"]
};
var faWatchApple = {
  prefix: 'fal',
  iconName: 'watch-apple',
  icon: [384, 512, [], "e2cb", "M96 48V64H288V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48C64 21.5 85.5 0 112 0H272c26.5 0 48 21.5 48 48V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16V448H96v16zM80 96c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zM192 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm16 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56-120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faWatchCalculator = {
  prefix: 'fal',
  iconName: 'watch-calculator',
  icon: [384, 512, [], "f8f0", "M96 48V64H288V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48C64 21.5 85.5 0 112 0H272c26.5 0 48 21.5 48 48V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16V448H96v16zM80 96c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zm16 96H288V160H96v32zM64 144c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144zm64 136a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm64 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm112-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM104 384a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm112-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm64 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"]
};
var faListDropdown = {
  prefix: 'fal',
  iconName: 'list-dropdown',
  icon: [512, 512, [], "e1cf", "M64 64C46.3 64 32 78.3 32 96v64H480V96c0-17.7-14.3-32-32-32H64zM32 192V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192H32zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352.2 90.3L384 109.3l31.8-19.1c7.6-4.5 17.4-2.1 21.9 5.5s2.1 17.4-5.5 22l-40 24c-5.1 3-11.4 3-16.5 0l-40-24c-7.6-4.5-10-14.4-5.5-22s14.4-10 21.9-5.5z"]
};
var faCabinetFiling = {
  prefix: 'fal',
  iconName: 'cabinet-filing',
  icon: [448, 512, [128452], "f64b", "M416 240H32V64c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V240zM0 256v16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V272 256 240 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V240v16zM416 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V272H416V448zM160 96c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7-14.3-32-32-32H160zm0 256c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384c0-17.7-14.3-32-32-32H160z"]
};
var faBurgerSoda = {
  prefix: 'fal',
  iconName: 'burger-soda',
  icon: [640, 512, [], "f858", "M202.4 36.4C207.8 15 227 0 249 0h23c8.8 0 16 7.2 16 16s-7.2 16-16 16H249c-7.3 0-13.7 5-15.5 12.1l-21 83.9H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 192.4c-.2 0-.5 0-.7 0H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H179.5l22.9-91.6zM60.3 468l-23-276H69.4L92.2 465.3c.7 8.3 7.6 14.7 15.9 14.7H260c3.7 11.9 9.7 22.7 17.5 32c-.6 0-1.1 0-1.7 0H108.2c-25 0-45.8-19.1-47.8-44zM330.9 279.4c-5.7 6.2-9.2 14.6-10.4 24.4h287c-1.2-9.8-4.7-18.2-10.4-24.4c-8.3-9-20.6-20.1-37.1-30.1c-.8 8.1-7.6 14.5-15.9 14.5c-8.8 0-16-7.2-16-16c0-4.6 1.9-8.7 5-11.6c-15.7-6.1-33.9-10.5-54.9-11.9c1.2 2.2 1.9 4.8 1.9 7.5c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7 .7-5.3 1.9-7.5c-21 1.4-39.2 5.9-54.9 11.9c3.1 2.9 5 7 5 11.6c0 8.8-7.2 16-16 16c-8.3 0-15.1-6.3-15.9-14.5c-16.6 10-28.8 21.1-37.1 30.1zM464 191.8c82 0 132.6 40 156.5 65.9c14.6 15.7 19.5 36.1 19.5 54.7c0 12.9-10.5 23.4-23.4 23.4H311.4c-12.9 0-23.4-10.5-23.4-23.4c0-18.7 4.9-39.1 19.5-54.7c24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3H602.7c20.6 0 37.3 16.7 37.3 37.3c0 32.4-26.3 58.7-58.7 58.7H346.7c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3c0 14.7 11.9 26.7 26.7 26.7H581.3c14.7 0 26.7-11.9 26.7-26.7c0-2.9-2.4-5.3-5.3-5.3H325.3z"]
};
var faSquareArrowUp = {
  prefix: 'fal',
  iconName: 'square-arrow-up',
  icon: [448, 512, ["arrow-square-up"], "f33c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm235.3 36.7l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 182.6V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V182.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faArrowSquareUp = faSquareArrowUp;
var faGreaterThanEqual = {
  prefix: 'fal',
  iconName: 'greater-than-equal',
  icon: [448, 512, [], "f532", "M41.9 62.8c-8.2-3.3-12.1-12.7-8.8-20.9s12.7-12.1 20.9-8.8l352 144c6 2.5 9.9 8.3 9.9 14.8s-3.9 12.3-9.9 14.8l-352 144c-8.2 3.3-17.5-.6-20.9-8.8s.6-17.5 8.8-20.9L357.7 192 41.9 62.8zM432 448c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432z"]
};
var faPalletBox = {
  prefix: 'fal',
  iconName: 'pallet-box',
  icon: [640, 512, [], "e208", "M464 32c8.8 0 16 7.2 16 16V240c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h64V144c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L320 116l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.3 8.8-14.3V32h64zM272 32h96v80L329.6 83.2c-5.7-4.3-13.5-4.3-19.2 0L272 112V32zM176 0c-26.5 0-48 21.5-48 48V240c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H176zM0 368c0 8.8 7.2 16 16 16H64v96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80 320 560h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H576V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H560 320 80 16c-8.8 0-16 7.2-16 16zM96 480V384H304v96H96zm240 0V384H544v96H336z"]
};
var faFaceConfounded = {
  prefix: 'fal',
  iconName: 'face-confounded',
  icon: [512, 512, [], "e36c", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216.9 98.7L256 380.8l39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 387.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0L208 387.2l-39.1 26.1c-4.8 3.2-10.9 3.6-16 1l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l23.7 11.8 40.3-26.8c5.4-3.6 12.4-3.6 17.8 0zM129.3 216.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 256l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 256l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
var faShieldHalved = {
  prefix: 'fal',
  iconName: 'shield-halved',
  icon: [512, 512, ["shield-alt"], "f3ed", "M240 38.8V472.6C86.8 397.1 48.5 233.2 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6L240 38.8zm32 433.8V38.8l173.2 73.5c11.3 4.8 18.9 15.5 18.8 27.6c-.5 93.3-38.8 257.3-192 332.8zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8z"]
};
var faShieldAlt = faShieldHalved;
var faTruckPlow = {
  prefix: 'fal',
  iconName: 'truck-plow',
  icon: [640, 512, [], "f7de", "M176 64h94.1c5.6 0 10.7 2.9 13.7 7.7L357.2 192H160V80c0-8.8 7.2-16 16-16zM394.8 192l-5.1-8.3L311 55c-8.7-14.3-24.2-23-41-23H176c-26.5 0-48 21.5-48 48V192H56c-30.9 0-56 25.1-56 56v96c0 19.4 13.7 35.5 32 39.2l0 .8c0 53 43 96 96 96s96-43 96-96h48c0 53 43 96 96 96s96-43 96-96h56.5l75.2 90.2c5.7 6.8 15.7 7.7 22.5 2s7.7-15.7 2-22.5L544 362.2V352 213.8l76.3-91.6c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2l-80 96c-2.4 2.9-3.7 6.5-3.7 10.2V352H479.2c.5-2.6 .8-5.3 .8-8V248c0-30.9-25.1-56-56-56H394.8zM448 330.9C430.8 305 401.4 288 368 288c-41.8 0-77.4 26.7-90.5 64H218.5c-13.2-37.3-48.7-64-90.5-64c-41.7 0-77.1 26.5-90.4 63.6c-3.2-1-5.6-4.1-5.6-7.6V248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24v82.9zM64 384a64 64 0 1 1 128 0A64 64 0 1 1 64 384zm304-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faBookAtlas = {
  prefix: 'fal',
  iconName: 'book-atlas',
  icon: [448, 512, ["atlas"], "f558", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM176.5 224h-31c4.8 26.1 21.1 48.2 43.5 60.8c-6.6-16.9-11-37.8-12.5-60.8zm0-32c1.4-22.9 5.9-43.8 12.5-60.8c-22.4 12.6-38.7 34.7-43.5 60.8h31zM112 208a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm206.5 16h-31c-1.4 22.9-5.9 43.8-12.5 60.8c22.4-12.6 38.7-34.7 43.5-60.8zM275 131.2c6.6 16.9 11 37.8 12.5 60.8h31c-4.8-26.1-21.1-48.2-43.5-60.8zM255.4 224H208.6c1.6 22.6 6.5 41.8 12.8 55.3c4.7 10.1 8.6 14.2 10.6 15.8c2-1.6 5.9-5.7 10.6-15.8c6.3-13.5 11.2-32.7 12.8-55.3zm-46.9-32h46.9c-1.6-22.6-6.5-41.8-12.8-55.3c-4.7-10.1-8.6-14.2-10.6-15.8c-2 1.6-5.9 5.7-10.6 15.8c-6.3 13.5-11.2 32.7-12.8 55.3z"]
};
var faAtlas = faBookAtlas;
var faVirus = {
  prefix: 'fal',
  iconName: 'virus',
  icon: [512, 512, [], "e074", "M75 75c-12.5 12.5-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75zm331.2 30.8C350.8 161.2 390.1 256 468.5 256c-78.4 0-117.7 94.8-62.2 150.2l0 0C350.8 350.8 256 390 256 468.4c0-78.4-94.8-117.6-150.2-62.2C161.2 350.8 121.9 256 43.5 256c78.4 0 117.7-94.8 62.2-150.2l0 0C161.2 161.2 256 121.9 256 43.5c0 78.4 94.8 117.7 150.2 62.2zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faGridRound2 = {
  prefix: 'fal',
  iconName: 'grid-round-2',
  icon: [512, 512, [], "e5db", "M128 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64A96 96 0 1 1 32 128a96 96 0 1 1 192 0zM128 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64A96 96 0 1 1 32 384a96 96 0 1 1 192 0zm96-256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z"]
};
var faCommentMiddleTop = {
  prefix: 'fal',
  iconName: 'comment-middle-top',
  icon: [512, 512, [], "e14a", "M216.9 117.7L256 39.6l39.1 78.1c4.3 8.6 12.3 14.8 21.7 16.9C415.4 156.5 480 227.6 480 304c0 91.3-93.8 176-224 176S32 395.3 32 304c0-76.4 64.6-147.5 163.3-169.4c9.4-2.1 17.4-8.3 21.7-16.9zm44.5-89l0 0L256 25.9l5.5 2.7s0 0 0 0zm62.2 74.7l-44.5-89C274.8 5.5 265.8 0 256 0s-18.8 5.5-23.2 14.3l-44.5 89C79.8 127.5 0 208.2 0 304C0 418.9 114.6 512 256 512s256-93.1 256-208c0-95.8-79.8-176.5-188.3-200.7z"]
};
var faEnvelopeCircleCheck = {
  prefix: 'fal',
  iconName: 'envelope-circle-check',
  icon: [640, 512, [], "e4e8", "M64 96H448c17.7 0 32 14.3 32 32v32.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H360.2c-8.1-9.8-15.2-20.6-21-32H64c-17.7 0-32-14.3-32-32V207.6L208.7 337.1c28.2 20.6 66.5 20.6 94.6 0l17.1-12.5c1-16.2 4.3-31.8 9.4-46.6l-45.4 33.3c-16.9 12.4-39.9 12.4-56.8 0L32 167.9V128c0-17.7 14.3-32 32-32zM496 224a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 353.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faLayerGroup = {
  prefix: 'fal',
  iconName: 'layer-group',
  icon: [576, 512, [], "f5fd", "M266.2 4.7C273 1.6 280.5 0 288 0s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 251.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 153.9C38.6 149.3 32 139.2 32 128s6.6-21.3 16.8-25.9L266.2 4.7zM288 32c-3 0-6 .6-8.8 1.9L69.3 128l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1C294 32.6 291 32 288 32zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9zM94.7 209.5l39.1 17.5L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l45.9-20.6z"]
};
var faRestroomSimple = {
  prefix: 'fal',
  iconName: 'restroom-simple',
  icon: [640, 512, [], "e23a", "M96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm96 0A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM57.8 236c2.1-24.9 22.9-44 47.8-44h44.8c25 0 45.8 19.1 47.8 44l4.1 49.3c1.6 18.7-13.2 34.7-31.9 34.7H85.6c-18.7 0-33.4-16-31.9-34.7L57.8 236zm-31.9-2.7l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6c-41.6 0-76.3 31.9-79.7 73.4zM320 0c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM512 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 512 0a64 64 0 1 0 0 128zm-15.7 64h31.4c14.3 0 26.8 9.5 30.8 23.2L597.6 352H426.4l39.1-136.8c3.9-13.7 16.5-23.2 30.8-23.2zm0-32c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H448V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384h21.6c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H496.3z"]
};
var faArrowsToDot = {
  prefix: 'fal',
  iconName: 'arrows-to-dot',
  icon: [512, 512, [], "e4be", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4L187.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 137.4 272 16zm16 240a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm59.3 171.3c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 374.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V374.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0zM84.7 164.7c-6.2 6.2-6.2 16.4 0 22.6L137.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H137.4L84.7 324.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0zm342.6 0c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L374.6 272H496c8.8 0 16-7.2 16-16s-7.2-16-16-16l-121.4 0 52.7-52.7c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faBorderOuter = {
  prefix: 'fal',
  iconName: 'border-outer',
  icon: [448, 512, [], "f851", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-72 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm72 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"]
};
var faHashtagLock = {
  prefix: 'fal',
  iconName: 'hashtag-lock',
  icon: [576, 512, [], "e415", "M195.6 32.4c8.6 2 14 10.6 12 19.2L186.3 144H313.4l23-99.6c2-8.6 10.6-14 19.2-12s14 10.6 12 19.2L346.3 144H432c8.8 0 16 7.2 16 16c0 .4 0 .8 0 1.1c-15.1 2.2-29.2 7.3-41.7 14.9H338.9L271.6 467.6c-2 8.6-10.6 14-19.2 12s-14-10.6-12-19.2L261.7 368H134.6l-23 99.6c-2 8.6-10.6 14-19.2 12s-14-10.6-12-19.2L101.7 368H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h93.1L146 176H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H153.4l23-99.6c2-8.6 10.6-14 19.2-12zM178.9 176L142 336H269.1L306 176H178.9zM464 224c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H544V352H384z"]
};
var faClockTwoThirty = {
  prefix: 'fal',
  iconName: 'clock-two-thirty',
  icon: [512, 512, [], "e35b", "M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V256c0-5.3 2.7-10.3 7.1-13.3l96-64c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2L272 264.6V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faArchway = {
  prefix: 'fal',
  iconName: 'archway',
  icon: [512, 512, [], "f557", "M0 48c0-8.8 7.2-16 16-16H48 464h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V448h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H464 424 368c-8.8 0-16-7.2-16-16V352c0-53-43-96-96-96s-96 43-96 96V464c0 8.8-7.2 16-16 16H88 48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V64H16C7.2 64 0 56.8 0 48zM64 64v64H448V64H64zm0 96V448H88h40V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96h40 24V160H64z"]
};
var faHeartCircleCheck = {
  prefix: 'fal',
  iconName: 'heart-circle-check',
  icon: [576, 512, [], "e4fd", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faHouseChimneyCrack = {
  prefix: 'fal',
  iconName: 'house-chimney-crack',
  icon: [576, 512, ["house-damage"], "f6f1", "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V192.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1V64H416v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48H274.1l-47.4-71.1c-4.9-7.4-2.9-17.3 4.4-22.2l79.8-53.2-82.2-82.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c3.4 3.4 5.1 8.1 4.6 12.9s-3.1 9.1-7 11.7l-82.7 55.1L312.6 480H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7z"]
};
var faHouseDamage = faHouseChimneyCrack;
var faFileZipper = {
  prefix: 'fal',
  iconName: 'file-zipper',
  icon: [384, 512, ["file-archive"], "f1c6", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm32 48h32c7.1 0 13.4 4.7 15.4 11.6L158 318.9c1.3 4.6 2 9.3 2 14V336c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3.1c0-4.7 .7-9.5 2-14l14.7-51.3c2-6.9 8.2-11.6 15.4-11.6zm.7 71.7c-.5 1.7-.7 3.5-.7 5.2V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-3.1c0-1.8-.2-3.5-.7-5.2L115.9 288h-7.9L96.7 327.7z"]
};
var faFileArchive = faFileZipper;
var faHeartHalf = {
  prefix: 'fal',
  iconName: 'heart-half',
  icon: [512, 512, [], "e1ab", "M256 451.5v-.3V96L244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5L224 465.1l.3 .2 3.5 3.2 9 8.4c2.1 2 4.9 3.1 7.8 3.1c6.3 0 11.5-5.1 11.5-11.5V456.2v-4.7zm-32-30.2L69.4 277C45.6 254.7 32 223.6 32 190.9v-5.8c0-54.2 39.2-100.5 92.7-109.4c35.3-5.9 71.4 5.6 96.7 31l2.6 2.6v312z"]
};
var faCommentCheck = {
  prefix: 'fal',
  iconName: 'comment-check',
  icon: [512, 512, [], "f4ac", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM363.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faSquare = {
  prefix: 'fal',
  iconName: 'square',
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faMemo = {
  prefix: 'fal',
  iconName: 'memo',
  icon: [384, 512, [], "e1d8", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm80 64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMartiniGlassEmpty = {
  prefix: 'fal',
  iconName: 'martini-glass-empty',
  icon: [512, 512, ["glass-martini"], "f000", "M33 32c-.5 0-1 .4-1 1c0 .3 .1 .5 .3 .7L256 257.4 479.7 33.7c.2-.2 .3-.4 .3-.7c0-.5-.4-1-1-1H33zM240 286.6L9.7 56.3C3.5 50.1 0 41.7 0 33C0 14.8 14.8 0 33 0H479c18.2 0 33 14.8 33 33c0 8.7-3.5 17.1-9.7 23.3L272 286.6V480h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H256 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V286.6z"]
};
var faGlassMartini = faMartiniGlassEmpty;
var faCouch = {
  prefix: 'fal',
  iconName: 'couch',
  icon: [640, 512, [], "f4b8", "M448 64c53 0 96 43 96 96v37.5c10-3.5 20.8-5.5 32-5.5V160c0-70.7-57.3-128-128-128H192C121.3 32 64 89.3 64 160v32c11.2 0 22 1.9 32 5.5V160c0-53 43-96 96-96H448zM96 320v96 16c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32zM80 480c20.9 0 38.7-13.4 45.3-32H514.7c6.6 18.6 24.4 32 45.3 32h32c26.5 0 48-21.5 48-48V288c0-35.3-28.7-64-64-64s-64 28.7-64 64H128c0-35.3-28.7-64-64-64s-64 28.7-64 64V432c0 26.5 21.5 48 48 48H80zm48-64V320H512v96H128zm416 16V416 320 288c0-17.7 14.3-32 32-32s32 14.3 32 32V432c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16z"]
};
var faCediSign = {
  prefix: 'fal',
  iconName: 'cedi-sign',
  icon: [384, 512, [], "e0df", "M208 0c8.8 0 16 7.2 16 16V64c1.3 0 2.7 0 4 0c44 0 84.7 14.2 117.5 38.3c7.1 5.2 8.7 15.2 3.4 22.4s-15.2 8.7-22.4 3.4C299.1 108 265 96 228 96c-1.3 0-2.7 0-4 0V416c1.3 0 2.7 0 4 0c37 0 71.1-12 98.5-32.1c7.1-5.2 17.1-3.7 22.4 3.4s3.7 17.1-3.4 22.4C312.7 433.8 272 448 228 448c-1.3 0-2.7 0-4 0v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V444.8C101.2 428.2 32 350.3 32 256s69.2-172.2 160-188.8V16c0-8.8 7.2-16 16-16zM64 256c0 76 54.5 140.1 128 156.1V99.9C118.5 115.9 64 180 64 256z"]
};
var faItalic = {
  prefix: 'fal',
  iconName: 'italic',
  icon: [384, 512, [], "f033", "M128 48c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H283L135.3 448H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h85L248.7 64H144c-8.8 0-16-7.2-16-16z"]
};
var faGlassCitrus = {
  prefix: 'fal',
  iconName: 'glass-citrus',
  icon: [512, 512, [], "f869", "M373.4 255.9C432.7 253.1 480 204 480 144c0-61.9-50.1-112-112-112c-44.7 0-83.2 26.2-101.2 64H232.2C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144c0 79-63.6 143.1-142.3 144l3.7-32.1zM40.9 160c-4.8 0-8.5 4.2-7.9 8.9L43 256H309l10-87.1c.5-4.7-3.2-8.9-7.9-8.9H40.9zM65.4 451.7C67.3 467.8 81 480 97.2 480H254.7c16.3 0 29.9-12.2 31.8-28.3L305.3 288H46.6L65.4 451.7zM1.2 172.6C-1.6 148.8 17 128 40.9 128H311c23.9 0 42.5 20.8 39.7 44.6L318.3 455.3c-3.7 32.3-31.1 56.7-63.6 56.7H97.2c-32.5 0-59.9-24.4-63.6-56.7L1.2 172.6z"]
};
var faCalendarLinesPen = {
  prefix: 'fal',
  iconName: 'calendar-lines-pen',
  icon: [576, 512, [], "e472", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H258.8c-3.1-8.8-3.7-18.4-1.4-27.8l1.1-4.2H64c-17.7 0-32-14.3-32-32V192H384h32 32V160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zm48 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM96 272c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm422.8-8l17.4 17.4c6.2 6.2 6.2 16.4 0 22.6l-24.8 24.8-40-40L496.2 264c6.2-6.2 16.4-6.2 22.6 0zM342.5 417.7L448.7 311.5l40 40L382.4 457.7c-2.1 2.1-4.6 3.5-7.4 4.2l-49 12.3 12.3-49c.7-2.8 2.2-5.4 4.2-7.4zM473.5 241.4L319.8 395.1c-6.2 6.2-10.5 13.9-12.6 22.3l-18.7 74.9c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2L382.8 493c8.4-2.1 16.1-6.5 22.3-12.6L558.8 326.6c18.7-18.7 18.7-49.1 0-67.9l-17.4-17.4c-18.7-18.7-49.1-18.7-67.9 0z"]
};
var faChurch = {
  prefix: 'fal',
  iconName: 'church',
  icon: [640, 512, [9962], "f51d", "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V48H264c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v39.4l-115.5 77c-17.8 11.9-28.5 31.9-28.5 53.3V480H64c-17.7 0-32-14.3-32-32V378.1c0-10.9 5.5-21 14.6-26.9L128 298.6V260.5L29.2 324.4C11 336.2 0 356.4 0 378.1V448c0 35.3 28.7 64 64 64H184v0h72 32 64 32 72v0H576c35.3 0 64-28.7 64-64V378.1c0-21.7-11-41.9-29.2-53.7L512 260.5v38.1l81.4 52.7c9.1 5.9 14.6 16 14.6 26.9V448c0 17.7-14.3 32-32 32H480V249.7c0-21.4-10.7-41.4-28.5-53.3L336 119.4V80h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V16zM448 480H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64v96H192V249.7c0-10.7 5.3-20.7 14.2-26.6L320 147.2l113.8 75.8C442.7 229 448 239 448 249.7V480zm-96-96v96H288V384c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faPersonSnowmobiling = {
  prefix: 'fal',
  iconName: 'person-snowmobiling',
  icon: [640, 512, ["snowmobile"], "f7d1", "M256 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 176 56zM335.8 74.3c7.6-4.5 17.4-2.1 21.9 5.5l43.8 73 156.8 78.4c10.8 5.4 17.7 16.5 17.7 28.6v59.1c0 10.7-5.3 20.7-14.2 26.6l-76.1 50.8 63.1 82c.4 .6 .8 1.2 1.2 1.8h19.5l43.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-3 3-7.1 4.7-11.3 4.7H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h77.7l-61.5-80H313.3c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64l39.2-78.3C76.6 278.8 87.7 272 99.8 272H288l36-48H280c-5 0-9.8-2.4-12.8-6.4l-33.4-44.5c-6.2-8.2-15.9-13.1-26.2-13.1c-12.9 0-24.6 7.6-29.9 19.4l-19.1 43.1c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l19.1-43.1c10.4-23.4 33.6-38.4 59.1-38.4c20.4 0 39.5 9.6 51.8 25.9L288 192h60l22.1-29.4L330.3 96.2c-4.5-7.6-2.1-17.4 5.5-22zM470.3 368L544 318.9V259.8L393.6 184.6l-80 106.6c-6 8.1-15.5 12.8-25.6 12.8H99.8L75.7 352.1c1.4-.1 2.8-.1 4.3-.1H240c18 0 34.6 6 48 16H455.8h.3 14.2zM80 384c-26.5 0-48 21.5-48 48s21.5 48 48 48H240c26.5 0 48-21.5 48-48s-21.5-48-48-48H80z"]
};
var faSnowmobile = faPersonSnowmobiling;
var faFaceHushed = {
  prefix: 'fal',
  iconName: 'face-hushed',
  icon: [512, 512, [], "e37b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faCommentsDollar = {
  prefix: 'fal',
  iconName: 'comments-dollar',
  icon: [640, 512, [], "f653", "M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6c4.8 5 5.8 12.5 2.5 18.6c-10.9 20.2-22.7 40.8-37.6 59.9c31.3-3 63.2-13.2 91.5-26c6-2.7 11.9-5.6 18-8.7c3.2-1.6 6.8-2.1 10.2-1.4c15.6 3.1 30.9 5 46.3 5c102.3 0 176-69.2 176-144s-73.7-144-176-144zM0 176C0 78.9 93.1 0 208 0S416 78.9 416 176s-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6c-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.7-2-18.9 4.4-25.8l.1-.1 0 0C22 326.6 34.3 307.1 46 286C19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110c11.7 21 24 40.6 39.5 57.5l0 0 .1 .1c6.5 7 8.2 17.1 4.4 25.8c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.9-2.2-9.6-4.5-14.3-6.8c-15.3 2.8-30.9 4.6-47 4.6c-82.1 0-153-40.2-186.8-98.5c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c15.3 0 30.6-1.9 46.3-5c3.5-.7 7.1-.2 10.2 1.4c6.1 3.1 12 6 18 8.7c28.4 12.9 60.2 23.1 91.5 26c-14.9-19-26.8-39.7-37.6-59.9c-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3zM224 83.6V97.4c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.1 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16V254.1c-9.7-1.9-18.8-5-26.7-7.7l0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2l0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6V83.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPickaxe = {
  prefix: 'fal',
  iconName: 'pickaxe',
  icon: [512, 512, [], "e5bf", "M474.7 321.8c16.1-78.2-7.8-162.5-65.3-219.8C352.2 45 268.3 21.2 190.5 37.2c61.8 30 118.3 73 164.8 119.5c46.9 46.9 89.3 103.4 119.4 165.1zM138.5 49.6c-13.4-5-13.7-24.5-.5-29.8C237.7-20.6 355.6 3.2 432 79.3C508.6 155.7 532.7 274 492.2 374c-5.4 13.3-24.9 13-29.8-.5C434.7 301.2 387 233.7 332.7 179.3C278.6 125.2 210.8 76.8 138.5 49.6zM10.1 448.5L271.9 167.3c8 6.6 16.1 13.7 24.1 21.1L33.5 470.3c-1 1.1-1.5 2.5-1.5 3.9c0 3.2 2.6 5.7 5.7 5.7c1.5 0 2.8-.6 3.9-1.5L323.6 216c7.4 8 14.5 16.1 21.1 24.1L63.5 501.9c-7 6.5-16.2 10.1-25.7 10.1C16.9 512 0 495.1 0 474.3c0-9.5 3.6-18.7 10.1-25.7zM443.3 20.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faLinkSimpleSlash = {
  prefix: 'fal',
  iconName: 'link-simple-slash',
  icon: [640, 512, [], "e1ce", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM608 256c0-88.4-71.6-160-160-160H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c70.7 0 128 57.3 128 128c0 35.5-14.4 67.6-37.7 90.8l25.3 19.9C591.1 338 608 299 608 256zM456 272c8.8 0 16-7.2 16-16s-7.2-16-16-16H403l40.5 32H456zM196.4 240H184c-8.8 0-16 7.2-16 16s7.2 16 16 16h53l-40.5-32zm-94.7-74.8L76.5 145.3C48.9 174 32 213 32 256c0 88.4 71.6 160 160 160h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-70.7 0-128-57.3-128-128c0-35.5 14.4-67.6 37.7-90.8z"]
};
var faDemocrat = {
  prefix: 'fal',
  iconName: 'democrat',
  icon: [640, 512, [], "f747", "M92.9 0C84.3 0 76 4.6 71.6 12.6c-2.4 4.3-6 11.3-9.2 18.7C59.6 37.9 56 47.5 56 56c0 16 6.9 29.6 14.8 40.1L19.5 155.5C6.9 170 0 188.6 0 207.8v5.4C0 254.5 33.5 288 74.7 288c17.5 0 34.4-6.1 47.8-17.3l13.7-11.4L160 330.6V336 464c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V416H432v48c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V336v-8V208c0-4.9-.4-9.7-1.3-14.4c2.9 2.9 5.5 5.8 8 8.7c9.2 10.9 15.9 21.8 20.2 30.1c2.2 4.1 3.7 7.5 4.7 9.8c.5 1.1 .9 2 1.1 2.6l.2 .6 0 .1 0 0 0 0 0 0 0 0c3 8.3 12.2 12.6 20.5 9.5s12.6-12.2 9.6-20.5L624 240c15-5.5 15-5.5 15-5.5l0 0 0 0 0-.1-.1-.3-.4-1c-.3-.9-.8-2-1.5-3.5c-1.3-2.9-3.2-7.1-5.7-12c-5.1-9.8-13-22.8-24.1-35.9c-22.2-26.2-58.3-53.6-111-53.7c0 0-.1 0-.1 0H277.5c-4.3 0-8.5-1.7-11.5-4.8L225.9 81.9c3.6-7.6 6.1-16.3 6.1-25.9c0-8.5-3.6-18.1-6.4-24.7c-3.1-7.4-6.8-14.4-9.2-18.7C212 4.6 203.7 0 195.1 0c-5.8 0-11.4 2-15.8 5.8L144 35.5 108.7 5.8C104.3 2 98.7 0 92.9 0zm403 160c0 0 0 0 .1 0c.1 0 .1 0 .2 0c26.4 .1 47.8 21.5 47.8 48V320H190.2l-31-93.1c-1.7-5-5.7-8.9-10.8-10.3s-10.6-.3-14.6 3.1l-31.7 26.4c-7.7 6.4-17.4 9.9-27.4 9.9C51.1 256 32 236.9 32 213.3v-5.4c0-11.5 4.1-22.7 11.7-31.4l60.4-69.9c5.5-6.3 5.1-15.9-.8-21.8C94.2 75.6 88 65.5 88 56l0 0s0-.1 0-.3c0-.2 .1-.5 .1-.9c.1-.8 .4-1.7 .7-2.9c.7-2.4 1.7-5.2 3-8.2c1.1-2.5 2.3-5.1 3.4-7.5l37.5 31.5c3.7 3.1 8.5 4.4 13.3 3.5c.6-.1 1.1-.2 1.7-.3c3-.4 5.7-1.7 8-3.6l37-31.1c1.2 2.4 2.3 4.9 3.4 7.5c1.3 3 2.3 5.8 3 8.2c.3 1.2 .6 2.1 .7 2.9c.1 .4 .1 .7 .1 .9c0 .2 0 .3 0 .3l0 0c0 6.1-2.5 12.5-7.2 19.1c-4.4 6.3-3.8 14.9 1.6 20.4l48.7 50c9 9.3 21.4 14.5 34.4 14.5H495.9zM192 464V352H544V464c0 8.8-7.2 16-16 16H480c-8.8 0-16-7.2-16-16V400c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm80-256c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V256h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V208zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V256h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V208zm96-16c-8.8 0-16 7.2-16 16v16H448c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V256h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H496V208c0-8.8-7.2-16-16-16z"]
};
var faFaceConfused = {
  prefix: 'fal',
  iconName: 'face-confused',
  icon: [512, 512, [], "e36d", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM171.1 395.6l-1.1 .9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l1.1-.9C205 327.5 272 304 341 304h11c8.8 0 16 7.2 16 16s-7.2 16-16 16H341c-61.8 0-121.7 21-169.9 59.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPinball = {
  prefix: 'fal',
  iconName: 'pinball',
  icon: [448, 512, [], "e229", "M352 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM120 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM383.9 448L76.2 348.9l0 0c-8.1-2.6-15.2-6.7-21.3-11.8c-27.1-22.7-30.6-63.2-7.9-90.2s63-30.6 90.1-7.9l0 0L383 447.2l.5 .4 .4 .3 0 .1 0 0zm19.8-25.2l-246-208.3c-40.6-34.1-101.2-28.8-135.2 11.8S-6.3 327.5 34.3 361.6c9.2 7.7 19.9 13.8 32 17.7l307.8 99.1c14.9 4.8 30.7-1.8 37.9-15c7.4-12.8 4.2-30.8-8.4-40.6z"]
};
var faZ = {
  prefix: 'fal',
  iconName: 'z',
  icon: [384, 512, [122], "5a", "M0 48c0-8.8 7.2-16 16-16H368c6.2 0 11.9 3.6 14.5 9.3s1.7 12.3-2.3 17.1L50.5 448H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L333.5 64H16C7.2 64 0 56.8 0 48z"]
};
var faPersonSkiing = {
  prefix: 'fal',
  iconName: 'person-skiing',
  icon: [512, 512, [9975, "skiing"], "f7c9", "M424 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 424 0zM1.7 280.8c4-7.9 13.6-11.1 21.5-7.1L236.4 380.9 306.4 297l-95-95c-8-8-12.5-17.9-13.7-28.1l59 28.1L329 274.4c11.7 11.7 12.6 30.4 2 43.1l-65.1 78.2 153.2 77c14 7 30.3 7.9 44.9 2.4l26.5-10c8.3-3.1 17.5 1.1 20.6 9.3s-1.1 17.5-9.3 20.6l-26.5 10c-23 8.7-48.6 7.3-70.6-3.7L8.8 302.3c-7.9-4-11.1-13.6-7.1-21.5zM118.9 65.6L137 74.2l8.7-17.3c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5L165.9 88l67.5 32.2 66.8-35.2c27.6-14.5 61.6 .8 69 31.1l18.9 77.6 66.5 31.8 .2 .1c4.9 2.3 8 6.8 8.9 11.8c.5 3.1 .1 6.5-1.3 9.6c0 0 0 0 0 0c-3.8 8-13.4 11.3-21.3 7.5l-.2-.1L151.6 116.6l-9.3 18.6c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.4-13.3-7.6-21.3s13.3-11.4 21.3-7.6zm150.6 71.7l81.4 38.8-12.8-52.4c-2.5-10.1-13.8-15.2-23-10.4l-45.6 24z"]
};
var faSkiing = faPersonSkiing;
var faDeer = {
  prefix: 'fal',
  iconName: 'deer',
  icon: [512, 512, [129420], "f78e", "M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 30.9 25.1 56 56 56h8 8 23.2l-40 26.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l13.8-9.2-10 35.9H120 104 99.2c-50.7 0-92.7 39.4-95.8 90L0 319c-.6 8.8 6.2 16.4 15 17s16.4-6.2 17-15l.6-9.9c.7 .8 1.4 1.5 2.2 2.3l3.9 3.9c6 6 9.4 14.1 9.4 22.6v4.3c0 3.4-.6 6.9-1.6 10.1l-8.5 25.4c-4.4 13.1-4.4 27.3 0 40.5l21.5 64.4C64.8 501 80.1 512 97.3 512h29.4c27.3 0 46.6-26.7 37.9-52.6l-11.6-34.8c-3.6-10.7 .5-22.4 9.8-28.6c15.2-10.1 24.4-26.8 25.3-44.6c21.3 10.9 45 16.6 69 16.6H272V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V311c0-3.1 .5-6.2 1.4-9.2L403.9 240h52.5c30.7 0 55.6-24.9 55.6-55.6c0-14.7-5.9-28.9-16.3-39.3L440.8 90.2C459.3 81.1 472 62 472 40V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24H385.4 346.6c3.5-7.3 5.4-15.4 5.4-24V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24h-8-8c-13.3 0-24-10.7-24-24V16zM385.4 96c10.2 0 20 4.1 27.2 11.3l60.4 60.4c4.4 4.4 6.9 10.4 6.9 16.7c0 13-10.6 23.6-23.6 23.6H392c-7.1 0-13.3 4.6-15.3 11.4l-22 73.3c-1.8 6-2.7 12.2-2.7 18.4V472c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8V352c0-8.8-7.2-16-16-16H257.2c-23.7 0-46.9-7-66.6-20.2l-13.7-9.2c-5.3-3.5-12.2-3.6-17.6-.1s-8.1 9.8-7.1 16.1l3.7 21.9c1.6 9.7-2.6 19.4-10.8 24.8c-21.4 14.2-30.5 41-22.4 65.3l11.6 34.8c1.7 5.2-2.1 10.5-7.6 10.5H97.3c-3.4 0-6.5-2.2-7.6-5.5L68.2 410.1c-2.2-6.6-2.2-13.7 0-20.2l8.5-25.4c2.2-6.5 3.3-13.4 3.3-20.2v-4.3c0-17-6.7-33.3-18.7-45.3l-3.9-3.9c-6-6-9.4-14.1-9.4-22.6V264c0-30.9 25.1-56 56-56h16H312.9c7.2 0 13.5-4.8 15.4-11.7l20-72.1C353 107.5 368.1 96 385.4 96zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faInputPipe = {
  prefix: 'fal',
  iconName: 'input-pipe',
  icon: [640, 512, [], "e1be", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm128 48V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faRoadLock = {
  prefix: 'fal',
  iconName: 'road-lock',
  icon: [640, 512, [], "e567", "M217.6 32c-26.9 0-50.9 16.8-60.1 42L40.5 394c-15.3 41.8 15.7 86 60.1 86H384V448H336V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H100.6c-22.2 0-37.7-22.1-30.1-43L187.5 85c4.6-12.6 16.6-21 30.1-21H304v48c0 8.8 7.2 16 16 16s16-7.2 16-16V64h86.4c13.4 0 25.4 8.4 30.1 21l30.8 84.3c9.7-4.2 20.1-7.1 31-8.4L482.5 74c-9.2-25.2-33.2-42-60.1-42H217.6zM336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm192 16c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faA = {
  prefix: 'fal',
  iconName: 'a',
  icon: [384, 512, [97], "41", "M206.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8l-176 416c-3.4 8.1 .4 17.5 8.5 21s17.5-.4 21-8.5L67.2 384H316.8l36.5 86.2c3.4 8.1 12.8 11.9 21 8.5s11.9-12.8 8.5-21l-176-416zM303.2 352H80.8L192 89.1 303.2 352z"]
};
var faBookmarkSlash = {
  prefix: 'fal',
  iconName: 'bookmark-slash',
  icon: [640, 512, [], "e0c2", "M512 48c0-26.5-21.5-48-48-48H176c-18.9 0-35.2 10.9-43.1 26.8L160 48.1V48c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16V300.8L512 326V48zM160 471.4V211.2L128 186V489.9c0 12.2 9.9 22.1 22.1 22.1c4.4 0 8.6-1.3 12.3-3.7L320 403.2 477.6 508.3c3.6 2.4 7.9 3.7 12.3 3.7c12.2 0 22.1-9.9 22.1-22.1v-.7l-32-25.3v7.6L328.9 370.7c-5.4-3.6-12.4-3.6-17.7 0L160 471.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTemperatureArrowDown = {
  prefix: 'fal',
  iconName: 'temperature-arrow-down',
  icon: [576, 512, ["temperature-down"], "e03f", "M112 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM176 0C123 0 80 43 80 96V252.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zm116.7 43.3l64 64c6.2 6.2 16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L448 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V425.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"]
};
var faTemperatureDown = faTemperatureArrowDown;
var faMace = {
  prefix: 'fal',
  iconName: 'mace',
  icon: [512, 512, [], "f6f8", "M278.3 95.8L288 66.6l9.7 29.2c3.3 10 11.4 17.7 21.5 20.6c36.8 10.6 65.8 39.7 76.4 76.4c2.9 10.1 10.6 18.1 20.6 21.5l29.2 9.7-29.2 9.7c-10 3.3-17.7 11.4-20.6 21.5c-10.6 36.8-39.7 65.8-76.4 76.4c-10.1 2.9-18.1 10.6-21.5 20.6L288 381.4l-9.7-29.2c-3.3-10-11.4-17.7-21.5-20.6c-36.8-10.6-65.8-39.7-76.4-76.4c-2.9-10.1-10.6-18.1-20.6-21.5L130.6 224l29.2-9.7c10-3.3 17.7-11.4 20.6-21.5c10.6-36.8 39.7-65.8 76.4-76.4c10.1-2.9 18.1-10.6 21.5-20.6zM149.7 183.9L74.9 208.8C68.4 211 64 217.1 64 224s4.4 13 10.9 15.2l74.7 24.9c5.3 18.4 14.2 35.2 25.8 49.8L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L198.1 336.5c14.6 11.6 31.4 20.5 49.8 25.8l24.9 74.7c2.2 6.5 8.3 10.9 15.2 10.9s13-4.4 15.2-10.9l24.9-74.7c47.3-13.7 84.6-51 98.3-98.3l74.7-24.9c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-74.7-24.9c-13.7-47.3-51-84.6-98.3-98.3L303.2 10.9C301 4.4 294.9 0 288 0s-13 4.4-15.2 10.9L247.9 85.7c-47.3 13.7-84.6 51-98.3 98.3zM288 240a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-48-16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z"]
};
var faFeatherPointed = {
  prefix: 'fal',
  iconName: 'feather-pointed',
  icon: [512, 512, ["feather-alt"], "f56b", "M102.2 348.1C89.9 302.4 89.8 224.5 160 154.3c40.6-40.6 98.9-69.8 159.1-89.6C379 44.9 438.2 35.3 477.9 32c0 0 .2 0 .4 .1c.3 .1 .6 .3 1 .7s.6 .7 .7 1c.1 .2 .1 .4 .1 .4c-3.3 39.7-12.9 98.9-32.7 158.7c-3.4 10.5-7.2 20.9-11.2 31.1H310.6l37.6-37.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L116.1 373.3c-7-8.6-11.6-16.9-13.9-25.2zM116 418.6c11.7 9.9 24.7 18 39.6 22c54.1 14.6 144.7 14 224.8-66.1C471.5 283.5 505 120.5 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c4 14.8 12.1 27.8 22 39.6L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L116 418.6zm22.7-22.7L182.6 352H357.7c-70.2 70.2-148.2 70.1-193.8 57.8c-8.3-2.2-16.6-6.9-25.2-13.9zM385 320H214.6l64-64H422.4c-10.8 22.9-23.2 44.6-37.4 64z"]
};
var faFeatherAlt = faFeatherPointed;
var faSausage = {
  prefix: 'fal',
  iconName: 'sausage',
  icon: [512, 512, [], "f820", "M400 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM32 400c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V400zM480 160c0 176.7-143.3 320-320 320c-35.3 0-64-28.7-64-64s28.7-64 64-64c106 0 192-86 192-192c0-35.3 28.7-64 64-64s64 28.7 64 64zm32 0c0-53-43-96-96-96s-96 43-96 96c0 88.4-71.6 160-160 160c-53 0-96 43-96 96s43 96 96 96c194.4 0 352-157.6 352-352zm-112 0c-8.8 0-16 7.2-16 16c0 114.9-93.1 208-208 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240-107.5 240-240c0-8.8-7.2-16-16-16z"]
};
var faTrashCanClock = {
  prefix: 'fal',
  iconName: 'trash-can-clock',
  icon: [576, 512, [], "e2aa", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v96.7c-11 1-21.7 3-32 5.9V96H64V432c0 26.5 21.5 48 48 48H296.2c10 12.1 21.7 22.9 34.6 32H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM336 176v44.5c-11.7 7.6-22.4 16.6-32 26.7V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm-192 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faP = {
  prefix: 'fal',
  iconName: 'p',
  icon: [320, 512, [112], "50", "M48 64H176c61.9 0 112 50.1 112 112s-50.1 112-112 112H32V80c0-8.8 7.2-16 16-16zM32 320H176c79.5 0 144-64.5 144-144s-64.5-144-144-144H48C21.5 32 0 53.5 0 80V304 464c0 8.8 7.2 16 16 16s16-7.2 16-16V320z"]
};
var faBroomWide = {
  prefix: 'fal',
  iconName: 'broom-wide',
  icon: [512, 512, [], "e5d1", "M507.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144-18.6-18.6c-20.2-20.2-51.4-24.6-76.3-10.7L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4L392.6 266.2c13.9-25 9.5-56.1-10.7-76.3l-18.6-18.6 144-144zM299.5 152.8l59.7 59.7c10.1 10.1 12.3 25.7 5.3 38.2l-21.2 38.1L223.2 168.6l38.1-21.2c12.5-6.9 28.1-4.8 38.2 5.3zm-105.4 32L327.2 317.9l-90 162.1L113.9 356.7l41.4-41.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L91.3 334.1 32.1 274.8l162.1-90z"]
};
var faSnowflake = {
  prefix: 'fal',
  iconName: 'snowflake',
  icon: [448, 512, [10052, 10054], "f2dc", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V89.4L171.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 134.6v93.7l-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3S72 100.2 74.3 108.7l13.4 50.1L24.2 122.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7L21.6 200C13 202.3 8 211 10.3 219.6s11.1 13.6 19.6 11.3l81-21.7L192 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3S13 309.7 21.6 312l50.1 13.4L8.2 362.1C.5 366.6-2.1 376.3 2.3 384s14.2 10.3 21.9 5.9l63.5-36.7L74.3 403.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81L208 283.7v93.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 422.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V422.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 377.4V283.7l81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1 63.5 36.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-63.5-36.7L426.4 312c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L256 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81L240 228.3V134.6l59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 89.4V16z"]
};
var faStomach = {
  prefix: 'fal',
  iconName: 'stomach',
  icon: [512, 512, [], "f623", "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V80c0 61.9 50.1 112 112 112h20c-2.6 10.2-4 21-4 32v48c0 44.2-35.8 80-80 80H112C57.5 352 12 391 2 442.6c-1.3 6.2-2 12.6-2 19.1V464v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464c0-5.2 .5-10.2 1.4-15.1c3.8-16.7 14.9-31.2 30.6-39c24.8-12.4 56.5-5.7 78.4 15.2C181.3 462.3 246.5 512 320 512c106 0 192-86 192-192V224c0-70.7-57.3-128-128-128c-47.4 0-88.7 25.7-110.9 64H240c-44.2 0-80-35.8-80-80V16zm4.5 386c-7.4-7.1-15.9-13.2-25-18H176c42.8 0 80-24 98.9-59.4c25.6-11.2 43.6-12.6 57.6-10.2c15.3 2.6 27.6 9.7 42.4 18.4l.5 .3c14.1 8.3 30.9 18.1 52.1 20.7c15.2 1.8 31.7-.2 50.4-7.3C465.2 422.2 399.4 480 320 480c-60.3 0-117.5-41.7-155.5-78zM480 310.5c-21.6 11-36.9 12.9-48.7 11.5c-13.9-1.7-25.4-8.1-40.2-16.8l-1.2-.7c-13.9-8.2-30.7-18-52.1-21.6c-15.1-2.5-31.7-1.8-50.7 3.4c.6-4.7 .9-9.4 .9-14.3V224c0-53 43-96 96-96s96 43 96 96v86.5z"]
};
var faNewspaper = {
  prefix: 'fal',
  iconName: 'newspaper',
  icon: [512, 512, [128240], "f1ea", "M160 64c-17.7 0-32 14.3-32 32V416c0 11.7-3.1 22.6-8.6 32H432c26.5 0 48-21.5 48-48V96c0-17.7-14.3-32-32-32H160zM64 480c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64v32c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V400c0 44.2-35.8 80-80 80H64zM384 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM160 304c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm32-144H320V128H192v96zM160 120c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24V232c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V120z"]
};
var faRectangleAd = {
  prefix: 'fal',
  iconName: 'rectangle-ad',
  icon: [576, 512, ["ad"], "f641", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm214.6 73.4l72 160c3.6 8.1 0 17.5-8 21.2s-17.5 0-21.2-8L247.3 320H152.7l-10.2 22.6c-3.6 8.1-13.1 11.7-21.2 8s-11.7-13.1-8-21.2l72-160c2.6-5.7 8.3-9.4 14.6-9.4s12 3.7 14.6 9.4zM200 215l-32.9 73h65.7L200 215zm176 25a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm40-19.9V176c0-8.8 7.2-16 16-16s16 7.2 16 16V280v56c0 8.8-7.2 16-16 16c-7.6 0-14-5.3-15.6-12.4C404.9 347.4 391 352 376 352c-39.8 0-72-32.2-72-72s32.2-72 72-72c14.8 0 28.6 4.5 40 12.1z"]
};
var faAd = faRectangleAd;
var faGuitarElectric = {
  prefix: 'fal',
  iconName: 'guitar-electric',
  icon: [512, 512, [127928], "f8be", "M391.1 67.8l52.6-35L473.3 55c7.6 5.7 8.3 16.7 1.7 23.4c-6.1 6.1-15.9 6.1-22 0l-9.7-9.7c-6.2-6.2-16.4-6.2-22.6 0L384 105.4V81.1c0-5.3 2.7-10.3 7.1-13.3zM352 136c0 .4 0 .9 .1 1.3l-68.2 68.2c-8-10.2-13.4-20.5-12.1-27.7c1.6-8.9 5.8-16.9 9.9-24.7c8.9-16.7 17.2-32.4-3.3-53.1c-15.9-16.1-41.8-16.1-57.7 0l-29.9 30.2c-9.4 9.5-15 21.1-20.6 32.8l0 0c-5.6 11.6-11.1 23.1-20.3 32.3c-16.5 16.7-38.1 23.8-59.8 30.8c-21.8 7.1-43.7 14.3-60.6 31.4c-39.3 39.7-39.3 104 0 143.7l79.9 80.8c39.4 39.9 103.5 39.9 142.9 0c17-17.2 24-39.3 31-61.3c6.9-21.9 13.8-43.7 30.5-60.5c8.7-8.8 19.5-13.8 30.3-18.8c10.9-5.1 21.8-10.1 30.6-19l21.6-21.8c15.8-15.9 15.8-41.7 0-57.6c-16.5-16.7-29.8-12.3-44-7.7c-7.2 2.4-14.7 4.8-22.9 4.6c-5.5-.2-14-4.9-22.8-11.9L432 102.6c18.7 17 47.5 16.5 65.6-1.6c20.5-20.5 18-54.3-5.1-71.6L461 5.7C456 2 450 0 443.8 0c-5.6 0-11.2 1.7-15.9 4.8L373.4 41.2C360 50.1 352 65.1 352 81.1V136zM238.6 172.1c-3 17.4 4.7 32.7 9.4 40.7c5.7 9.7 13.4 18.9 21 26.7c7.7 7.9 16.4 15.4 25.1 21.2c4.3 2.9 9.1 5.8 14.2 8c4.6 2.1 11.7 4.7 20 4.9c11.4 .3 21.1-2.1 27.9-4.1c2.3-.7 4.9-1.5 6.9-2.2l0 0 0 0 1.8-.6c2.4-.8 4-1.2 5.3-1.5l.3-.1c.5 .4 1.1 .9 1.8 1.7c2.8 2.8 2.8 7.5 0 10.3l-21.6 21.8c-3.8 3.9-9.1 6.7-20.8 12.1l-1.4 .7c-10.1 4.7-25.8 11.9-38.8 25c-22.4 22.7-31.5 51.3-37.9 71.8l-.8 2.4c-7.3 23.1-12.4 37.1-22.7 47.6c-26.3 26.6-68.8 26.6-95.1 0L53.4 377.7c-26.3-26.6-26.3-69.8 0-96.5c10.2-10.4 24-15.5 46.9-23l2.4-.8c20.3-6.6 48.7-15.8 71.1-38.4c13.2-13.3 20.9-29.3 26-40.1l.7-1.5c6-12.4 9.4-18.8 14.1-23.6l29.9-30.2c2.8-2.8 7.2-2.8 9.9 0c1.4 1.4 2.2 2.4 2.7 3.1c-.1 .2-.2 .5-.3 .7c-1 2.6-2.2 4.7-4 8.2l0 0 0 0c-1 1.9-2.2 4.1-3.7 7.1c-3.6 6.9-8.4 17.1-10.5 29.2l0 0zm130.9 92.3a.1 .1 0 1 0 0 .2 .1 .1 0 1 0 0-.2zM257.8 128a.1 .1 0 1 0 -.2 0 .1 .1 0 1 0 .2 0zM148.7 276.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm-48 48c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faArrowTurnDownRight = {
  prefix: 'fal',
  iconName: 'arrow-turn-down-right',
  icon: [512, 512, [], "e3d6", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V224c0 44.2 35.8 80 80 80H457.4L356.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 272H80c-26.5 0-48-21.5-48-48V48z"]
};
var faMoonCloud = {
  prefix: 'fal',
  iconName: 'moon-cloud',
  icon: [640, 512, [], "f754", "M446.6 66.8C359 82 291.8 156.8 288.1 248c-9.9-4.1-20.5-6.8-31.6-7.7C264.5 124 361.2 32 479.5 32c6.4 0 12.7 .3 19 .8c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-53.3 30.2-89.3 87.6-89.3 153.3c0 97.2 78.6 176 175.5 176c10.3 0 20.3-.9 30.1-2.6c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7C595 455.8 540 480 479.5 480c-60.9 0-116.1-24.4-156.4-64c7.5-7.8 13.8-16.8 18.6-26.7c34.8 36.2 83.7 58.7 137.8 58.7c34.2 0 66.3-9 94.1-24.7c-106.4-9-189.9-98.4-189.9-207.3c0-58.5 24.1-111.4 62.9-149.2zM144 224c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72H64c-35.3 0-64-28.7-64-64s28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64zm0 32c-26.5 0-48 21.5-48 48c0 .7 0 1.4 0 2.1c.2 5.3-2.2 10.4-6.5 13.5s-9.8 4-14.9 2.2c-3.3-1.2-6.9-1.8-10.7-1.8c-17.7 0-32 14.3-32 32s14.3 32 32 32H248c22.1 0 40-17.9 40-40s-17.9-40-40-40c-11.2 0-21.3 4.6-28.6 12c-4.6 4.7-11.5 6.1-17.5 3.6s-9.9-8.4-9.9-14.9l0-.8c0-26.5-21.5-48-48-48z"]
};
var faBreadSliceButter = {
  prefix: 'fal',
  iconName: 'bread-slice-butter',
  icon: [512, 512, [], "e3e1", "M96 256V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V256c0-17.7 14.3-32 32-32s32-14.3 32-32c0-44.3-32.4-76.2-84.6-98.6C344.1 71.4 284.5 64 256 64s-88.1 7.4-139.4 29.4C64.4 115.8 32 147.7 32 192c0 17.7 14.3 32 32 32s32 14.3 32 32zm352 0v32V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V288 256c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64zM193.9 276.7c-6.2 6.2-6.2 16.4 0 22.6l50.7 50.7c6.2 6.2 16.4 6.2 22.6 0l50.7-50.7c6.2-6.2 6.2-16.4 0-22.6l-50.7-50.7c-6.2-6.2-16.4-6.2-22.6 0l-50.7 50.7zm96-73.4l50.7 50.7c18.7 18.7 18.7 49.1 0 67.9l-50.7 50.7c-18.7 18.7-49.1 18.7-67.9 0l-50.7-50.7c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7c18.7-18.7 49.1-18.7 67.9 0z"]
};
var faCircleArrowRight = {
  prefix: 'fal',
  iconName: 'circle-arrow-right',
  icon: [512, 512, ["arrow-circle-right"], "f0a9", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM283.3 363.3l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L329.4 240 144 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l185.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"]
};
var faArrowCircleRight = faCircleArrowRight;
var faUserGroupCrown = {
  prefix: 'fal',
  iconName: 'user-group-crown',
  icon: [640, 512, ["users-crown"], "f6a5", "M224 0c5.2 0 10.3 1.5 14.7 4.4l32.5 21.6c5.4 3.6 12.4 3.6 17.8 0L324 2.7c2.6-1.8 5.7-2.7 8.9-2.7H336c8.8 0 16 7.2 16 16V128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128 16c0-8.8 7.2-16 16-16h3.2c3.2 0 6.2 .9 8.9 2.7l35.1 23.4c5.4 3.6 12.4 3.6 17.8 0L209.3 4.4C213.7 1.5 218.8 0 224 0zm96 43.8l-13.4 8.9c-16.1 10.7-37.1 10.7-53.3 0L224 33.1 194.6 52.7c-16.1 10.7-37.1 10.7-53.3 0L128 43.8V112H320V43.8zM224 240c53 0 96-43 96-96H128c0 53 43 96 96 96zM32 472v8H416v-8c0-75.1-60.9-136-136-136H168C92.9 336 32 396.9 32 472zM0 472c0-92.8 75.2-168 168-168H280c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8zM432 256c-27.7 0-53-10.1-72.6-26.7c1.9-2.9 3.6-6 5.3-9c3.6-6.7 6.8-13.7 9.5-21C388.8 214.5 409.3 224 432 224c44.2 0 80-35.8 80-80s-35.8-80-80-80c-18 0-34.6 6-48 16V42.8C398.5 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32H608c-.7-70.8-58.3-128-129.3-128H440c-8.8-11.7-18.8-22.4-29.8-31.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7z"]
};
var faUsersCrown = faUserGroupCrown;
var faCircleI = {
  prefix: 'fal',
  iconName: 'circle-i',
  icon: [512, 512, [], "e111", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V352H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 176z"]
};
var faToiletPaperCheck = {
  prefix: 'fal',
  iconName: 'toilet-paper-check',
  icon: [640, 512, [], "e5b2", "M16 479c.2-5.3 1.7-10.6 4.5-15.4l0-.1c2.6-4.6 5-9.4 7.3-14.3C63.6 372.8 64 272.2 64 192C64 86 107 0 160 0H464h32c40.7 0 69 32.2 85.2 64.6C598.3 98.8 608 143.9 608 192s-9.7 93.2-26.8 127.4C565 351.8 536.7 384 496 384c-24.1 0-43.8-11.3-59.3-27.2c2.1-14.2 4.1-29.6 5.7-46c14.2 25.6 33 41.2 53.6 41.2c44.2 0 80-71.6 80-160s-35.8-160-80-160s-80 71.6-80 160c0 44.7-2.2 83.7-5.6 117.7c-.3 2.5-.5 4.9-.8 7.4c-9 82.3-25.6 133.1-36.3 158.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2c-2.9-5.2-4.3-11-4.2-16.8zM160 32c-7.9 0-23.6 7.2-39.3 38.5C106 100 96 142.9 96 192c0 42.4-.1 92.6-5.8 142.2c-5.7 49.5-17.3 100.7-41.6 144.8c-.2 .3-.4 .6-.5 .9l0 0H317.9c11.4 0 21.6-6.1 25.9-16.3C357.3 431 384 347.1 384 192c0-48.1 9.7-93.2 26.8-127.4c5.7-11.3 12.8-22.6 21.5-32.6H160zM496 240c6.4 0 11.9-11.3 14.5-27.6c1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16c-5.1-6.4-8.2-13.8-10.3-20c-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20c4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20c4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20c-4.8 6.1-15.1 16-31.4 16zM307.3 187.3l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 225.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faFilterCircleXmark = {
  prefix: 'fal',
  iconName: 'filter-circle-xmark',
  icon: [576, 512, [], "e17b", "M0 39.5C0 17.7 17.7 0 39.5 0H472.5C494.3 0 512 17.7 512 39.5c0 9.2-3.2 18.1-9.1 25.2L394.2 196.1c-24.4 5.3-47 15.8-66.4 30.1L478.3 44.3c1.1-1.3 1.7-3 1.7-4.8c0-4.2-3.4-7.5-7.5-7.5H39.5c-4.2 0-7.5 3.4-7.5 7.5c0 1.8 .6 3.4 1.7 4.8L220.3 269.8c2.4 2.9 3.7 6.5 3.7 10.2v88.2l34 26.4c2.7 18.1 8.3 35.3 16.1 51.2c-3.1-1.2-6.1-2.8-8.7-4.9l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3V285.8L9.1 64.7C3.2 57.6 0 48.7 0 39.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faLocust = {
  prefix: 'fal',
  iconName: 'locust',
  icon: [576, 512, [], "e520", "M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c106.5 0 194.3 80 206.5 183.2C525.7 232.7 503.9 224 480 224H429.9L382 136.3c-2.6-4.8-7.5-7.9-13-8.3s-10.7 2.1-14 6.5l-45.3 61.4-40.5-60.8c-2.9-4.3-7.7-7-12.9-7.1s-10.1 2.2-13.2 6.4L176 224H102.1C63.4 224 32 255.4 32 294.1c0 27.5 16 52.4 41 63.8l1.9 .9L3.2 454.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2l75.9-101.2 51 23.3c4.7 2.2 9.5 4.2 14.4 6l-38.9 52.8c-5.2 7.1-3.7 17.1 3.4 22.4s17.1 3.7 22.4-3.4l45.9-62.3c15.1 3.2 30.5 4.8 46 4.8H281l-22.9 40.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l32-55.9H454.1l27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-20.7-41.3c48.5-4.8 86.4-45.8 86.4-95.5l0-.3V272C576 139.5 468.5 32 336 32H304zM480 256c35.3 0 63.9 28.5 64 63.7v.3l0 .1c-.1 35.3-28.7 63.9-64 63.9H464.3c-.1 0-.3 0-.4 0c-.1 0-.2 0-.3 0H248.8c-27.5 0-54.8-5.9-79.8-17.4l-44.6-20.4L192 256H319.8h.5H480zm-328 0L94.5 332.6l-8.3-3.8C72.7 322.6 64 309.1 64 294.1c0-21.1 17.1-38.1 38.1-38.1H152zm137.2-32H216l39.2-52.3 34.4 51.6-.5 .7zm104.2 0H328.9L366 173.7 393.4 224zM472 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSort = {
  prefix: 'fal',
  iconName: 'sort',
  icon: [320, 512, ["unsorted"], "f0dc", "M34.2 179.7L154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 179.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2zm-22-23.3C4.4 163.8 0 174.1 0 184.9C0 206.5 17.5 224 39.1 224H280.9c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.4L187.6 42.9C180.1 35.9 170.2 32 160 32s-20.1 3.9-27.6 10.9L12.3 156.4zm22 175.9c-1.4-1.3-2.2-3.2-2.2-5.2c0-3.9 3.2-7.1 7.1-7.1H280.9c3.9 0 7.1 3.2 7.1 7.1c0 2-.8 3.8-2.2 5.2L165.6 445.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 332.3zm-22 23.3L132.4 469.1c7.4 7 17.4 10.9 27.6 10.9s20.1-3.9 27.6-10.9L307.7 355.6c7.8-7.4 12.3-17.7 12.3-28.5c0-21.6-17.5-39.1-39.1-39.1H39.1C17.5 288 0 305.5 0 327.1c0 10.8 4.4 21.1 12.3 28.5z"]
};
var faUnsorted = faSort;
var faListOl = {
  prefix: 'fal',
  iconName: 'list-ol',
  icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M32 48c0 8.8 7.2 16 16 16H64V192H32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V48c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM192 96c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM58.7 323.9c11.1-11.1 29.2-10.5 39.6 1.3c9.2 10.5 8.9 26.2-.6 36.3L12.3 453.1c-4.3 4.7-5.5 11.5-3 17.3s8.3 9.6 14.7 9.6H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H60.8l60.3-64.6c20.7-22.2 21.2-56.4 1.3-79.3c-22.5-25.7-62.1-27.1-86.3-2.9L20.7 316.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l15.4-15.4z"]
};
var faList12 = faListOl;
var faListNumeric = faListOl;
var faChartWaterfall = {
  prefix: 'fal',
  iconName: 'chart-waterfall',
  icon: [512, 512, [], "e0eb", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM144 224c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm112-80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-80c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM448 80V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSparkle = {
  prefix: 'fal',
  iconName: 'sparkle',
  icon: [448, 512, [], "e5d6", "M224 32c6.2 0 11.9 3.6 14.5 9.3l63.2 136.9 136.9 63.2c5.7 2.6 9.3 8.3 9.3 14.5s-3.6 11.9-9.3 14.5L301.8 333.8 238.5 470.7c-2.6 5.7-8.3 9.3-14.5 9.3s-11.9-3.6-14.5-9.3L146.2 333.8 9.3 270.5C3.6 267.9 0 262.2 0 256s3.6-11.9 9.3-14.5l136.9-63.2L209.5 41.3c2.6-5.7 8.3-9.3 14.5-9.3zm0 54.2L172.8 197c-1.6 3.5-4.4 6.2-7.8 7.8L54.2 256 165 307.2c3.5 1.6 6.2 4.4 7.8 7.8L224 425.8 275.2 315c1.6-3.5 4.4-6.2 7.8-7.8L393.8 256 283 204.8c-3.5-1.6-6.2-4.4-7.8-7.8L224 86.2z"]
};
var faFaceParty = {
  prefix: 'fal',
  iconName: 'face-party',
  icon: [640, 512, [], "e383", "M96 256C96 132.3 196.3 32 320 32c91.8 0 170.8 55.3 205.4 134.4c3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1C515.2 63.2 425 0 320 0C263.2 0 210.7 18.5 168.2 49.9L21.1 .8C15.2-1.1 8.7 .5 4.4 4.9S-1.2 16 1.1 21.7L70 200.9c-3.9 17.8-6 36.2-6 55.1c0 141.4 114.6 256 256 256c75.8 0 144-33 190.8-85.3c5.9-6.6 5.3-16.7-1.3-22.6c-3-2.7-6.8-4.1-10.6-4.1h-.1c-4.4 0-8.7 1.8-11.9 5.3c-41 45.9-100.6 74.7-167 74.7C196.3 480 96 379.7 96 256zM139.8 74.1c-22.6 22.4-41.1 49-54.1 78.5L73.9 121.9c.5-.7 1-1.4 1.4-2.1c10.9-19.6 24.1-37.7 39.3-54.1l25.2 8.4zM81.6 54.7c-8 9.4-15.4 19.3-22.2 29.6L43.1 41.9 81.6 54.7zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm160 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm-53.8 69.5c5.5 2.7 9.5 5.5 11.9 8c2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8c-10.9 5.4-25.5 9.3-38.8 11.2c-.9 .1-1.8 .3-2.7 .6c-1.7 .6-3.2 1.6-4.4 2.8s-2.2 2.7-2.8 4.4c-.5 1.3-.7 2.7-.7 4.1s.2 2.8 .7 4.1c.6 1.7 1.6 3.2 2.8 4.4s2.7 2.2 4.4 2.8c.9 .3 1.7 .5 2.7 .6c13.3 1.9 27.9 5.8 38.8 11.2c5.5 2.7 9.5 5.5 11.9 8c2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8c-11 5.4-25.7 9.3-39.1 11.2c-6.6 .9-11.1 7-10.2 13.6s7 11.1 13.6 10.2c15.1-2.1 32.4-6.6 46.3-13.4c6.9-3.4 13.6-7.7 18.7-13c5.2-5.4 9.3-12.6 9.3-21.4c0-8-3.5-14.8-8-20H592c26.5 0 48-21.5 48-48V256c0-26.5-21.5-48-48-48H560c-26.5 0-48 21.5-48 48s21.5 48 48 48h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H560c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H412c4.5-5.2 8-12 8-20c0-8.8-4.1-16-9.3-21.4c-5.1-5.4-11.8-9.6-18.7-13c-13.9-6.8-31.2-11.3-46.3-13.4c-6.6-.9-12.6 3.6-13.6 10.2s3.7 12.6 10.2 13.6c13.4 1.9 28.1 5.8 39.1 11.2z"]
};
var faKidneys = {
  prefix: 'fal',
  iconName: 'kidneys',
  icon: [640, 512, [], "f5fb", "M115.7 352c-33.4 0-52.1-14.3-64.3-35.8C37.8 292.5 32 258.9 32 224c0-39 12.1-89.3 35.6-129c23.5-39.6 54.7-63 92.1-63c39.7 0 77.1 22.4 85.8 52.9c6 21.1-2.7 49.4-25.5 75.1c-28.7 32.4-24.6 71.3-22 95.6c.2 1.6 .3 3.2 .5 4.7c4.9 49.1-33.6 91.6-82.7 91.6zm0 32c68.1 0 121.3-58.9 114.6-126.8l-.3-2.8c-.6-6.1-1.2-12.2-1.6-18.3l18.8 9.4c5.4 2.7 8.8 8.3 8.8 14.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V259.8c0-18.2-10.3-34.8-26.5-42.9L231.8 202c2.4-7.2 6.2-14.1 12-20.7c26.6-30 42.6-69.3 32.4-105.1C262.2 26.9 207.7 0 159.7 0C53.7 0 0 135.2 0 224c0 74.9 24.3 160 115.7 160zM394.2 86.1c.1-.4 .3-.8 .4-1.2C403.2 54.4 440.6 32 480.3 32c37.4 0 68.5 23.4 92.1 63C595.9 134.7 608 185 608 224c0 34.9-5.8 68.5-19.4 92.2c-12.2 21.4-31 35.8-64.3 35.8c-49.1 0-87.6-42.5-82.7-91.6c.1-1.5 .3-3 .5-4.7l0 0 0 0c2.6-24.3 6.7-63.2-22-95.6c-23.7-26.7-32.4-54.2-25.9-73.9zm-30.4-10c-11.8 35.8 5.8 75.2 32.4 105.1c5.8 6.6 9.6 13.5 12 20.7l-29.7 14.8C362.3 225 352 241.6 352 259.8V496c0 8.8 7.2 16 16 16s16-7.2 16-16V259.8c0-6.1 3.4-11.6 8.8-14.3l18.8-9.4c-.3 6-.9 12.1-1.6 18.3l-.3 2.8C403 325.1 456.2 384 524.3 384C615.7 384 640 298.9 640 224C640 135.2 586.3 0 480.3 0c-48 0-102.5 26.9-116.5 76.2z"]
};
var faWifiExclamation = {
  prefix: 'fal',
  iconName: 'wifi-exclamation',
  icon: [640, 512, [], "e2cf", "M336 48V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16zM4.7 161.7C75.4 91.7 169.4 45 274 34.3c-1.3 4.3-2 8.9-2 13.7V66.7C177 77.7 91.8 120.6 27.3 184.4c-6.3 6.2-16.4 6.2-22.6-.1s-6.2-16.4 .1-22.6zM116.7 276c41.3-41.2 95.2-69.9 155.3-80v32.5c-51.3 9.7-97.2 34.8-132.7 70.2c-6.3 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM368 196c60.1 10.1 114 38.8 155.3 80c6.3 6.2 6.3 16.4 0 22.6s-16.4 6.3-22.6 0c-35.5-35.4-81.4-60.5-132.7-70.2V196zm0-148c0-4.7-.7-9.3-2-13.7C470.6 45 564.6 91.7 635.3 161.7c6.3 6.2 6.3 16.3 .1 22.6s-16.3 6.3-22.6 .1C548.2 120.6 463 77.7 368 66.7V48zM320 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faChartNetwork = {
  prefix: 'fal',
  iconName: 'chart-network',
  icon: [640, 512, [], "f78a", "M224 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c4.5 0 8.9-.5 13.1-1.3l38.1 83.2c-26.6 17.2-45.4 45.4-50.1 78.1H126c-7.1-27.6-32.2-48-62-48c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h99.2c7.8 54.3 54.4 96 110.9 96c35 0 66.3-16.1 86.8-41.2l91.8 55.1c-1.7 5.8-2.6 11.9-2.6 18.2c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4l-91.8-55.1c5.6-13.3 8.7-28 8.7-43.3c0-18.7-4.6-36.3-12.7-51.8l101.8-73.3c10.8 8.2 24.2 13.1 38.8 13.1c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 9.1 1.9 17.8 5.4 25.7L416.6 226.2c-20.4-21.1-49-34.2-80.6-34.2c-11 0-21.6 1.6-31.7 4.5l-38.5-84.1C279.4 100.7 288 83.4 288 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM576 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM544 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm272-48a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faPersonDressBurst = {
  prefix: 'fal',
  iconName: 'person-dress-burst',
  icon: [640, 512, [], "e544", "M456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM446.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368H528 432 393.9l52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C551.7 148.6 517.3 128 480 128s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L419 196.6c12-22.5 35.5-36.6 61-36.6zM190.5 17.3C187.9 11.6 182.3 8 176 8s-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.8 4 11.5 4.8 17.1 2.1s9.2-8.5 9.1-14.7L260 251l75.2-15.8c6.1-1.3 10.9-6 12.3-12.1s-.9-12.4-5.8-16.2l-60.9-46.8 34.6-68.6c2.8-5.6 2.1-12.3-1.8-17.2s-10.3-7.1-16.3-5.6L222.6 87.2 190.5 17.3zm-37.6 95.2L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l53.7-13.3-24.9 49.4c-3.5 6.9-1.6 15.2 4.5 19.9l43.8 33.7-54.1 11.3c-7.5 1.6-12.9 8.3-12.7 15.9l1 55.3-42.6-35.2c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9z"]
};
var faDiceD4 = {
  prefix: 'fal',
  iconName: 'dice-d4',
  icon: [512, 512, [], "f6d0", "M240.1 56.5L35.4 310.6 240.1 465.9V56.5zm32 409.2L476.6 310.6 272.1 56.7V465.8zM256 0c7.3 0 14.1 3.3 18.7 8.9l232 288c4.1 5.1 5.9 11.5 5.1 18s-4.1 12.3-9.3 16.2l-232 176c-8.6 6.5-20.4 6.5-29 0l-232-176c-5.2-3.9-8.5-9.8-9.3-16.2s1.1-12.9 5.1-18l232-288C241.9 3.3 248.7 0 256 0z"]
};
var faMoneyCheckDollar = {
  prefix: 'fal',
  iconName: 'money-check-dollar',
  icon: [576, 512, ["money-check-alt"], "f53d", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM272 288H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16-80c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm-96-56v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V360c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V152c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMoneyCheckAlt = faMoneyCheckDollar;
var faVectorSquare = {
  prefix: 'fal',
  iconName: 'vector-square',
  icon: [448, 512, [], "f5cb", "M408 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zM360 32c-22.1 0-40 17.9-40 40v8H128V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40h8l0 192H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40v-8H320v8c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40h-8V160h8c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360zM80 352l0-192h8c22.1 0 40-17.9 40-40v-8H320v8c0 22.1 17.9 40 40 40h8V352h-8c-22.1 0-40 17.9-40 40v8H128v-8c0-22.1-17.9-40-40-40H80zM40 384H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zm320 0h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zM40 64H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8z"]
};
var faBreadSlice = {
  prefix: 'fal',
  iconName: 'bread-slice',
  icon: [512, 512, [], "f7ec", "M64 224c-17.7 0-32-14.3-32-32c0-44.3 32.4-76.2 84.6-98.6C167.9 71.4 227.5 64 256 64s88.1 7.4 139.4 29.4C447.6 115.8 480 147.7 480 192c0 17.7-14.3 32-32 32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V256c0-17.7-14.3-32-32-32zm384 64V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64v32V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V288z"]
};
var faLanguage = {
  prefix: 'fal',
  iconName: 'language',
  icon: [640, 512, [], "f1ab", "M304 96V416H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H304zm32 0H576c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H336V96zm304 32c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128zM174.9 170.1C172.4 164 166.5 160 160 160s-12.4 4-14.9 10.1l-64 160c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l8.8-21.9h80.7l8.8 21.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-64-160zm-14.9 49L187.6 288H132.4L160 219.1zM496 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 41.2l-.2 .6c-8.2 22.6-21.4 42.9-38.2 59.4l-.8-.8-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.9 20.9c-5 3.2-10.1 6.2-15.5 8.8l-17.3 8.6c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l17.3-8.6c9.1-4.6 17.8-9.8 26-15.7c5.9 4.4 12.1 8.6 18.4 12.4l18.9 11.3c7.6 4.5 17.4 2.1 21.9-5.5s2.1-17.4-5.5-21.9l-18.9-11.3c-3.4-2-6.7-4.1-9.9-6.4c19.1-19.4 34.1-42.9 43.6-69l4.2-11.6H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H544 496V176z"]
};
var faWheatAwnSlash = {
  prefix: 'fal',
  iconName: 'wheat-awn-slash',
  icon: [640, 512, [], "e338", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm235.7 288l-37 37c1.9-31.2-7.5-62.9-28.2-88.5l-46.7-36.9c-2.8 .7-5.4 2.1-7.6 4.2l-33.9 33.9c-37.5 37.5-37.5 98.3 0 135.8L142.2 411l0 0L68.7 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l73.5-73.5 0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-27-27-63.2-39.4-98.5-37.2L287 311.4l-25.3-20zM289.2 60.3C270.5 79 261.2 103.5 261.1 128l40.4 31.9c-13.9-24.4-10.5-56.1 10.4-76.9l22.6-22.6 11.3 11.3c35.1 35.1 37.3 90.7 6.6 128.4l26.5 20.9c37.6-28.1 91.1-25.1 125.3 9.1l11.3 11.3-22.6 22.6c-10.3 10.3-23.2 16.3-36.6 18.2l30.6 24.2c10.3-4.6 20-11.2 28.5-19.7l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-5.8-5.8-12-10.9-18.6-15.4L555 145.1c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L478 176.9c-16.1-5.5-33-7.8-49.8-6.7L555 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L405.6 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L383.8 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L345.8 26.4c-6.2-6.2-16.4-6.2-22.6 0L289.2 60.3zM130.9 263.9l22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5zm181 181c-25 25-65.5 25-90.5 0L187.5 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3-22.6 22.6z"]
};
var faFaceKissWinkHeart = {
  prefix: 'fal',
  iconName: 'face-kiss-wink-heart',
  icon: [512, 512, [128536, "kiss-wink-heart"], "f598", "M325.2 469.1C303.4 476.2 280.2 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 25.9-4.4 50.8-12.5 73.9c10.9 1.2 21.2 4.5 30.6 9.5c9-26.2 13.9-54.2 13.9-83.4C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c28.6 0 56.1-4.7 81.8-13.4c-4.9-6.5-8.7-14.1-10.8-22.6l-1.8-7zM222.3 291.9c13.4 1.9 28.1 5.8 39.1 11.2c5.5 2.7 9.5 5.5 11.9 8c2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8c-10.9 5.4-25.5 9.3-38.8 11.2c-.9 .1-1.8 .3-2.7 .6c-1.7 .6-3.2 1.6-4.4 2.8s-2.2 2.7-2.8 4.4c-.5 1.3-.7 2.7-.7 4.1s.2 2.8 .7 4.1c.6 1.7 1.6 3.2 2.8 4.4s2.7 2.2 4.4 2.8c.9 .3 1.7 .5 2.7 .6c13.3 1.9 27.9 5.8 38.8 11.2c5.5 2.7 9.5 5.5 11.9 8c2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8c-11 5.4-25.7 9.3-39.1 11.2c-6.6 .9-11.1 7-10.2 13.6s7 11.1 13.6 10.2c15.1-2.1 32.4-6.6 46.3-13.4c6.9-3.4 13.6-7.7 18.7-13c5.2-5.4 9.3-12.6 9.3-21.4s-4.1-16-9.3-21.4c-5.1-5.4-11.8-9.6-18.7-13c-1.1-.5-2.1-1-3.3-1.5c1.1-.5 2.2-1 3.3-1.5c6.9-3.4 13.6-7.7 18.7-13c5.2-5.4 9.3-12.6 9.3-21.4s-4.1-16-9.3-21.4c-5.1-5.4-11.8-9.6-18.7-13c-13.9-6.8-31.2-11.3-46.3-13.4c-6.6-.9-12.6 3.6-13.6 10.2s3.6 12.6 10.2 13.6zm-46-59.9a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm194.8 1.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm70.1 127.5c-7.4-29-36.5-47.3-65.8-39.2c-28.9 8.1-45.1 38.6-37.7 67.4L358 468.1c4.5 17.4 22.3 27.7 39.6 22.9l74.9-21c28.9-8.1 45.1-38.6 37.7-67.4c-7.4-29-36.5-47.3-65.8-39.2l-2.4 .7-.8-3zm-57.1-8.3c10.8-3 22.9 3.5 26.1 16.3l4.8 18.9c1.1 4.2 3.8 7.7 7.5 9.9s8.2 2.7 12.3 1.5l18.1-5.1c10.8-3 22.9 3.5 26.1 16.3c3.3 13-4.2 25.5-15.3 28.6l-74.9 21-20.2-78.8c-3.3-13 4.2-25.5 15.3-28.6z"]
};
var faKissWinkHeart = faFaceKissWinkHeart;
var faDagger = {
  prefix: 'fal',
  iconName: 'dagger',
  icon: [384, 512, [], "f6cb", "M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V128H144 112 80 48c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48V160h16 32 48 48 32 16v16c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48H304 272 240 208V16zM48 160H64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16zm272 0h16c8.8 0 16 7.2 16 16s-7.2 16-16 16s-16-7.2-16-16V160zM240 397.9c0 4.9-1.5 9.7-4.3 13.8L192 474.1l-43.7-62.4c-2.8-4-4.3-8.8-4.3-13.8V192H112V397.9c0 11.5 3.5 22.7 10.1 32.1l50.2 71.7c4.5 6.4 11.8 10.2 19.7 10.2s15.2-3.8 19.7-10.2L261.9 430c6.6-9.4 10.1-20.6 10.1-32.1V192H240V397.9z"]
};
var faPodium = {
  prefix: 'fal',
  iconName: 'podium',
  icon: [448, 512, [], "f680", "M288 32H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16zM178.7 64H168c-26.5 0-48 21.5-48 48v48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H88V112c0-44.2 35.8-80 80-80h10.7C185.3 13.4 203.1 0 224 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H224c-20.9 0-38.7-13.4-45.3-32zM73.5 455.2L47.3 224H79.5l25.9 227.6c1.8 16.2 15.5 28.4 31.8 28.4H310.9c16.3 0 30-12.2 31.8-28.4L368.5 224h32.2L374.5 455.2c-3.7 32.3-31 56.8-63.6 56.8H137.1c-32.6 0-59.9-24.4-63.6-56.8z"]
};
var faMemoCircleCheck = {
  prefix: 'fal',
  iconName: 'memo-circle-check',
  icon: [576, 512, [], "e1d9", "M320 32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6c-11.2 3.2-21.9 7.4-32 12.6V64c0-17.7-14.3-32-32-32zM64 144c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 80H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm44.7 100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7z"]
};
var faRouteHighway = {
  prefix: 'fal',
  iconName: 'route-highway',
  icon: [448, 512, [], "f61a", "M232.2 2.3c-5.1-3-11.4-3-16.5 0L194.6 15c-31.9 19.2-71.5 20.7-104.8 4c-17.7-8.9-39.2-3.8-51.1 12.1L14.5 63.3c-10.7 14.2-11.9 33.5-3 49C24.9 135.9 32 162.5 32 189.7V203c0 22.4-4.3 44.6-12.6 65.4L8 296.9c-5.3 13.2-8 27.4-8 41.6C0 382.2 25.4 422 65.1 440.3l152.2 70.2c4.3 2 9.2 2 13.4 0l152.2-70.2C422.6 422 448 382.2 448 338.5c0-14.3-2.7-28.4-8-41.6l-11.4-28.5c-8.3-20.8-12.6-43-12.6-65.4V189.7c0-27.1 7.1-53.8 20.6-77.4c8.8-15.5 7.6-34.7-3-49L409.3 31.1C397.4 15.2 375.9 10.2 358.2 19c-33.3 16.7-72.8 15.1-104.8-4L232.2 2.3zM211 42.4l13-7.8 13 7.8c41.3 24.8 92.4 26.8 135.5 5.2c3.9-1.9 8.6-.8 11.2 2.6l24.2 32.3c3 4 3.4 9.5 .9 13.9c-11.3 19.7-18.8 41.3-22.4 63.6H61.6c-3.6-22.3-11.1-43.8-22.4-63.6c-2.5-4.4-2.2-9.8 .9-13.9L64.3 50.3c2.6-3.5 7.3-4.6 11.2-2.6c43.1 21.6 94.2 19.6 135.5-5.2zM64 192H384v11c0 26.5 5 52.7 14.9 77.2l11.4 28.5c3.8 9.5 5.7 19.6 5.7 29.8c0 31.2-18.2 59.6-46.5 72.7L224 478.4 78.5 411.2C50.2 398.1 32 369.8 32 338.5c0-10.2 1.9-20.3 5.7-29.8l11.4-28.5C59 255.7 64 229.5 64 203V192z"]
};
var faDownToLine = {
  prefix: 'fal',
  iconName: 'down-to-line',
  icon: [384, 512, ["arrow-alt-to-bottom"], "f34a", "M16 448H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm174.2-96.8c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L318.2 219.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7H256c-8.8 0-16-7.2-16-16V72c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8V192c0 8.8-7.2 16-16 16H70.7c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L190.2 351.2zM192 384c-9.5 0-18.6-3.9-25.1-10.8L42.5 241.2C35.8 234 32 224.5 32 214.7C32 193.3 49.3 176 70.7 176H112V72c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40V176h41.3c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.3-10.5 26.5L217.1 373.2c-6.5 6.9-15.6 10.8-25.1 10.8z"]
};
var faArrowAltToBottom = faDownToLine;
var faFilter = {
  prefix: 'fal',
  iconName: 'filter',
  icon: [512, 512, [], "f0b0", "M0 71.5C0 49.7 17.7 32 39.5 32H472.5C494.3 32 512 49.7 512 71.5c0 9.2-3.2 18.1-9.1 25.2L320 317.8V446.1c0 18.7-15.2 33.9-33.9 33.9c-7.5 0-14.8-2.5-20.8-7.1l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3V317.8L9.1 96.7C3.2 89.6 0 80.7 0 71.5zM39.5 64c-4.2 0-7.5 3.4-7.5 7.5c0 1.8 .6 3.4 1.7 4.8L220.3 301.8c2.4 2.9 3.7 6.5 3.7 10.2v88.2l61 47.4c.3 .3 .7 .4 1.1 .4c1 0 1.9-.8 1.9-1.9V312c0-3.7 1.3-7.3 3.7-10.2L478.3 76.3c1.1-1.3 1.7-3 1.7-4.8c0-4.2-3.4-7.5-7.5-7.5H39.5z"]
};
var faSquareG = {
  prefix: 'fal',
  iconName: 'square-g',
  icon: [448, 512, [], "e271", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256c0 53 43 96 96 96c47.6 0 87.1-34.6 94.7-80H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c8.8 0 16 7.2 16 16c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c6.6 5.9 7.1 16 1.3 22.6s-16 7.1-22.6 1.3c-17-15.2-39.4-24.4-64-24.4c-53 0-96 43-96 96z"]
};
var faCirclePhone = {
  prefix: 'fal',
  iconName: 'circle-phone',
  icon: [512, 512, ["phone-circle"], "e11b", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM203.2 144.1c1.9-.4 3.8 .6 4.5 2.3l24 56c.7 1.6 .2 3.5-1.1 4.7l-20.3 16.6c-6.1 5-7.6 13.6-3.7 20.4c14.7 25.4 35.9 46.6 61.4 61.4c6.8 3.9 15.4 2.4 20.4-3.7l16.6-20.3c1.1-1.4 3-1.8 4.7-1.1l56 24c1.8 .8 2.7 2.6 2.3 4.5l-12 56c-.4 1.8-2 3.2-3.9 3.2c-114.9 0-208-93.1-208-208c0-1.9 1.3-3.5 3.2-3.9l56-12zm33.9-10.3c-6.8-15.8-23.8-24.6-40.6-21l-56 12C123.9 128.4 112 143 112 160c0 132.5 107.4 240 240 240c17 0 31.6-11.9 35.2-28.5l12-56c3.6-16.8-5.2-33.9-21-40.6l-56-24c-14.7-6.3-31.9-2.1-42 10.3l-7.5 9.2c-11.9-8.6-22.4-19.1-31-31l9.2-7.5c12.4-10.2 16.6-27.3 10.3-42l-24-56z"]
};
var faPhoneCircle = faCirclePhone;
var faClipboardPrescription = {
  prefix: 'fal',
  iconName: 'clipboard-prescription',
  icon: [384, 512, [], "f5e8", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 208c-8.8 0-16 7.2-16 16v80 64c0 8.8 7.2 16 16 16s16-7.2 16-16V320h41.4l48 48-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L262.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 345.4l-31.2-31.2C227.3 305.1 240 286 240 264c0-30.9-25.1-56-56-56H112zm72 80h-8H128V240h56c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faUserNurseHair = {
  prefix: 'fal',
  iconName: 'user-nurse-hair',
  icon: [448, 512, [], "e45d", "M128 144V76.9l96-42 96 42V144H128zM96 76.9V144v16 16 0c0 70.7 57.3 128 128 128s128-57.3 128-128v0V160 144 76.9c0-12.7-7.5-24.2-19.2-29.3l-96-42c-8.2-3.6-17.5-3.6-25.7 0l-96 42C103.5 52.7 96 64.2 96 76.9zM320 176v0c0 53-43 96-96 96c-35.5 0-66.6-19.3-83.2-48h21.5c35.5 0 68.3-18.3 87-48H320zm-112.8 0c-12.4 10.2-28.2 16-44.8 16h-33c-.9-5.2-1.3-10.5-1.3-16v0h79.2zM121.1 356.3l69 69c18.7 18.7 49.1 18.7 67.9 0l69-69c51.4 16.8 88.5 64.9 89.1 121.6H32c.6-56.8 37.7-104.9 89.1-121.6zm21.7-23.5c-7.5-7.5-18.3-11-28.4-7.9C48.2 344.9 0 406.4 0 479.2c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-72.8-48.2-134.3-114.4-154.4c-10.1-3.1-20.9 .4-28.4 7.9l-69.8 69.8c-6.2 6.2-16.4 6.2-22.6 0l-69.8-69.8zM208 56V72H192c-4.4 0-8 3.6-8 8V96c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V104h16c4.4 0 8-3.6 8-8V80c0-4.4-3.6-8-8-8H240V56c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"]
};
var faQuestion = {
  prefix: 'fal',
  iconName: 'question',
  icon: [320, 512, [10067, 10068, 61736], "3f", "M144 64c-53 0-96 43-96 96c0 8.8-7.2 16-16 16s-16-7.2-16-16C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128c0 35.3-16.6 68.4-44.8 89.6l-60.8 45.6C184.3 305.8 176 322.4 176 340v12c0 8.8-7.2 16-16 16s-16-7.2-16-16V340c0-27.7 13-53.8 35.2-70.4L240 224c20.1-15.1 32-38.8 32-64c0-53-43-96-96-96H144zm-8 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faFileSignature = {
  prefix: 'fal',
  iconName: 'file-signature',
  icon: [576, 512, [], "f573", "M320 480c17.7 0 32-14.3 32-32V437.3l23.8-5.9c2.8-.7 5.6-1.6 8.2-2.7V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v39.8l-32 32V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320zM240 160H351.5c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16zM144 349l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l12.6 42.1c7.1-8.3 17.5-13.1 28.5-13.1c14.2 0 27.2 8 33.5 20.7l5.6 11.3h41.7l15.7-62.6c2.1-8.4 6.5-16.1 12.6-22.3L473.5 145.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 384.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-2 .5-4.1 .6-6.1 .3H240c-6.1 0-11.6-3.4-14.3-8.8L215.6 387c-.9-1.8-2.8-3-4.9-3c-1.7 0-3.3 .8-4.4 2.2l-17.6 23.4c-3.6 4.8-9.7 7.2-15.6 6.2s-10.8-5.4-12.5-11.2L144 349zM518.8 168c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L536.2 208c6.2-6.2 6.2-16.4 0-22.6L518.8 168zM342.5 321.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L488.7 255.4l-40-40L342.5 321.7z"]
};
var faToggleLargeOn = {
  prefix: 'fal',
  iconName: 'toggle-large-on',
  icon: [576, 512, [], "e5b1", "M416 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256zm0 288H160C71.6 416 0 344.4 0 256S71.6 96 160 96H416c88.4 0 160 71.6 160 160s-71.6 160-160 160zm-96-32c-38.9-29.2-64-75.7-64-128s25.1-98.8 64-128H160C89.3 128 32 185.3 32 256s57.3 128 128 128H320z"]
};
var faUpDownLeftRight = {
  prefix: 'fal',
  iconName: 'up-down-left-right',
  icon: [512, 512, ["arrows-alt"], "f0b2", "M252.9 33.4L196 96H316L259.1 33.4c-.8-.9-1.9-1.4-3.1-1.4s-2.3 .5-3.1 1.4zm29.8-21.5l61.7 67.9c4.8 5.3 7.5 12.2 7.5 19.4c0 15.9-12.9 28.8-28.8 28.8H272V240H384v32H272V384h51.2c15.9 0 28.8 12.9 28.8 28.8c0 7.2-2.7 14.1-7.5 19.4l-61.7 67.9c-6.9 7.5-16.6 11.8-26.8 11.8s-19.9-4.3-26.8-11.8l-61.7-67.9c-4.8-5.3-7.5-12.2-7.5-19.4c0-15.9 12.9-28.8 28.8-28.8H240V272H128l0 51.2c0 15.9-12.9 28.8-28.8 28.8c-7.2 0-14.1-2.7-19.4-7.5L11.8 282.8C4.3 275.9 0 266.2 0 256s4.3-19.9 11.8-26.8l67.9-61.7c5.3-4.8 12.2-7.5 19.4-7.5c15.9 0 28.8 12.9 28.8 28.8l0 51.2H240V128l-51.2 0c-15.9 0-28.8-12.9-28.8-28.8c0-7.2 2.7-14.1 7.5-19.4l61.7-67.9C236.1 4.3 245.8 0 256 0s19.9 4.3 26.8 11.8zM316 416H196l56.9 62.6c.8 .9 1.9 1.4 3.1 1.4s2.3-.5 3.1-1.4L316 416zM478.6 259.1c.9-.8 1.4-1.9 1.4-3.1s-.5-2.3-1.4-3.1L416 196V316l62.6-56.9zm-46.4 85.4c-5.3 4.8-12.2 7.5-19.4 7.5c-15.9 0-28.8-12.9-28.8-28.8V188.8c0-15.9 12.9-28.8 28.8-28.8c7.2 0 14.1 2.7 19.4 7.5l67.9 61.7c7.5 6.9 11.8 16.6 11.8 26.8s-4.3 19.9-11.8 26.8l-67.9 61.7zM33.4 252.9c-.9 .8-1.4 1.9-1.4 3.1s.5 2.3 1.4 3.1L96 316 96 196 33.4 252.9z"]
};
var faArrowsAlt = faUpDownLeftRight;
var faDryerHeat = {
  prefix: 'fal',
  iconName: 'dryer-heat',
  icon: [448, 512, ["dryer-alt"], "f862", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM336 304a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM80 304a144 144 0 1 1 288 0A144 144 0 1 1 80 304zm115.3-75.3l4.7 4.7c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l4.7 4.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm80 0l4.7 4.7c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l4.7 4.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faDryerAlt = faDryerHeat;
var faHouseChimneyUser = {
  prefix: 'fal',
  iconName: 'house-chimney-user',
  icon: [576, 512, [], "e065", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L512 192.3V56c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24V79.4L298.6 4zM416 107.6V64h64V164.1l-64-56.5zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zM256 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM248 352h80c22.1 0 40 17.9 40 40v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-39.8-32.2-72-72-72H248c-39.8 0-72 32.2-72 72v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-22.1 17.9-40 40-40z"]
};
var faHandHoldingHeart = {
  prefix: 'fal',
  iconName: 'hand-holding-heart',
  icon: [576, 512, [], "f4be", "M184 72.6c0 10.8 4.3 21.1 11.9 28.7L288 193.4l92.1-92.1c7.6-7.6 11.9-17.9 11.9-28.7C392 50.2 373.8 32 351.4 32c-10.8 0-21.1 4.3-28.7 11.9L299.3 67.3c-6.2 6.2-16.4 6.2-22.6 0L253.3 43.9C245.6 36.3 235.3 32 224.6 32C202.2 32 184 50.2 184 72.6zM224.6 0c19.2 0 37.7 7.6 51.3 21.3L288 33.4l12.1-12.1C313.7 7.6 332.2 0 351.4 0C391.5 0 424 32.5 424 72.6c0 19.2-7.6 37.7-21.3 51.3L299.3 227.3c-6.2 6.2-16.4 6.2-22.6 0L173.3 123.9C159.6 110.3 152 91.8 152 72.6C152 32.5 184.5 0 224.6 0zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7H80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faArrowUpSmallBig = {
  prefix: 'fal',
  iconName: 'arrow-up-small-big',
  icon: [576, 512, ["sort-size-up-alt"], "f88f", "M148.7 36.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 86.6V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6L75.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zM352 80v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80zm32 352c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16V432zm-32 0V304c0-26.5 21.5-48 48-48H496c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48z"]
};
var faSortSizeUpAlt = faArrowUpSmallBig;
var faTrainTrack = {
  prefix: 'fal',
  iconName: 'train-track',
  icon: [576, 512, [], "e453", "M207.1 53.2c2.9-8.4-1.5-17.5-9.9-20.4s-17.5 1.5-20.4 9.9L158.5 96H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h35.4l-33.2 96H72c-8.8 0-16 7.2-16 16s7.2 16 16 16h31.1L69.8 352H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H58.8L32.9 458.8c-2.9 8.3 1.5 17.5 9.9 20.4s17.5-1.5 20.4-9.9L92.6 384H483.4l29.5 85.2c2.9 8.3 12 12.8 20.4 9.9s12.8-12 9.9-20.4L517.2 384H544c8.8 0 16-7.2 16-16s-7.2-16-16-16H506.2l-33.2-96H504c8.8 0 16-7.2 16-16s-7.2-16-16-16H461.9l-33.2-96H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H417.5L399.1 42.8c-2.9-8.4-12-12.8-20.4-9.9s-12.8 12-9.9 20.4L383.7 96H192.3l14.8-42.8zM181.2 128H394.8L428 224H148l33.2-96zM472.3 352H103.7l33.2-96H439.1l33.2 96z"]
};
var faPuzzlePiece = {
  prefix: 'fal',
  iconName: 'puzzle-piece',
  icon: [512, 512, [129513], "f12e", "M62 333.2l-12.8 9.6L62 333.2zM178.8 450l-9.6 12.8 9.6-12.8zM414 242.8l-12.8-9.6 12.8 9.6zm-352 0l-12.8-9.6L62 242.8zM304 64c0-19.4-10.5-35.8-25.1-46.7S244.8 0 224 0V32c14.5 0 27.1 4.4 35.7 10.9S272 56.9 272 64h32zm-25.3 46.8C293.4 99.9 304 83.5 304 64H272c0 7.1-3.8 14.8-12.4 21.2l19.2 25.6zM336 128H279.2v32H336V128zm48 104.8V176H352v56.8h32zM448 208c-19.5 0-35.9 10.6-46.8 25.3l25.6 19.2c6.4-8.6 14.1-12.4 21.2-12.4V208zm64 80c0-20.8-6.3-40.2-17.3-54.9s-27.3-25.1-46.7-25.1v32c7.1 0 14.7 3.8 21.1 12.3s10.9 21.1 10.9 35.7h32zm-64 80c19.4 0 35.8-10.5 46.7-25.1s17.3-34.1 17.3-54.9H480c0 14.5-4.4 27.1-10.9 35.7s-14.1 12.3-21.1 12.3v32zm-46.8-25.3c11 14.7 27.4 25.3 46.8 25.3V336c-7.1 0-14.8-3.8-21.2-12.4l-25.6 19.2zM384 464V343.2H352V464h32zM279.2 512H336V480H279.2v32zM272 416c0 7.1-3.8 14.8-12.4 21.2l19.2 25.6c14.7-11 25.3-27.4 25.3-46.8H272zm-48-32c14.5 0 27.1 4.4 35.7 10.9s12.3 14.1 12.3 21.1h32c0-19.4-10.5-35.8-25.1-46.7s-34.1-17.3-54.9-17.3v32zm-48 32c0-7.1 3.8-14.7 12.3-21.1s21.1-10.9 35.7-10.9V352c-20.8 0-40.2 6.3-54.9 17.3s-25.1 27.3-25.1 46.7h32zm12.4 21.2c-8.6-6.4-12.4-14.1-12.4-21.2H144c0 19.5 10.6 35.9 25.3 46.8l19.2-25.6zM48 512H168.8V480H48v32zM0 343.2V464H32V343.2H0zM96 336c-7.1 0-14.8-3.8-21.2-12.4L49.2 342.7C60.1 357.4 76.5 368 96 368V336zm32-48c0 14.5-4.4 27.1-10.9 35.7S103.1 336 96 336v32c19.4 0 35.8-10.5 46.7-25.1s17.3-34.1 17.3-54.9H128zM96 240c7.1 0 14.7 3.8 21.1 12.3s10.9 21.1 10.9 35.7h32c0-20.8-6.3-40.2-17.3-54.9S115.4 208 96 208v32zM74.8 252.4C81.2 243.8 88.9 240 96 240V208c-19.5 0-35.9 10.6-46.8 25.3l25.6 19.2zM0 176v56.8H32V176H0zm168.8-48H48v32H168.8V128zM144 64c0 19.5 10.6 35.9 25.3 46.8l19.2-25.6C179.8 78.8 176 71.1 176 64H144zM224 0c-20.8 0-40.2 6.3-54.9 17.3S144 44.6 144 64h32c0-7.1 3.8-14.7 12.3-21.1S209.5 32 224 32V0zM208 120.8c0-16.2-9.9-28.4-19.6-35.6l-19.2 25.6c5.2 3.8 6.7 7.7 6.7 10h32zM39.2 336c2.3 0 6.1 1.6 10 6.7l25.6-19.2C67.6 313.9 55.4 304 39.2 304v32zM32 343.2c0-4 3.2-7.2 7.2-7.2V304C17.5 304 0 321.5 0 343.2H32zM48 480c-8.8 0-16-7.2-16-16H0c0 26.5 21.5 48 48 48V480zm128-7.2c0 4-3.2 7.2-7.2 7.2v32c21.6 0 39.2-17.5 39.2-39.2H176zm-6.7-10c5.2 3.8 6.7 7.7 6.7 10h32c0-16.2-9.9-28.4-19.6-35.6l-19.2 25.6zM352 464c0 8.8-7.2 16-16 16v32c26.5 0 48-21.5 48-48H352zm39.2-160c-21.7 0-39.2 17.5-39.2 39.2h32c0-4 3.2-7.2 7.2-7.2V304zm35.6 19.6c-7.2-9.7-19.4-19.6-35.6-19.6v32c2.3 0 6.1 1.6 10 6.7l25.6-19.2zM168.8 160c21.6 0 39.2-17.5 39.2-39.2H176c0 4-3.2 7.2-7.2 7.2v32zM391.2 272c16.2 0 28.4-9.9 35.6-19.6l-25.6-19.2c-3.8 5.2-7.7 6.7-10 6.7v32zM32 176c0-8.8 7.2-16 16-16V128c-26.5 0-48 21.5-48 48H32zm320 56.8c0 21.6 17.5 39.2 39.2 39.2V240c-4 0-7.2-3.2-7.2-7.2H352zM39.2 240c-4 0-7.2-3.2-7.2-7.2H0C0 254.5 17.5 272 39.2 272V240zM336 160c8.8 0 16 7.2 16 16h32c0-26.5-21.5-48-48-48v32zM272 472.8c0-2.3 1.6-6.1 6.7-10l-19.2-25.6c-9.7 7.2-19.6 19.4-19.6 35.6h32zM49.2 233.3c-3.8 5.2-7.7 6.7-10 6.7v32c16.2 0 28.4-9.9 35.6-19.6L49.2 233.3zM240 120.8c0 21.6 17.5 39.2 39.2 39.2V128c-4 0-7.2-3.2-7.2-7.2H240zM279.2 480c-4 0-7.2-3.2-7.2-7.2H240c0 21.7 17.5 39.2 39.2 39.2V480zM259.6 85.2c-9.7 7.2-19.6 19.4-19.6 35.6h32c0-2.3 1.6-6.1 6.7-10L259.6 85.2z"]
};
var faMoneyCheck = {
  prefix: 'fal',
  iconName: 'money-check',
  icon: [576, 512, [], "f53c", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm112 96H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM360 176c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8H360zm-40 8c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V184z"]
};
var faStarHalfStroke = {
  prefix: 'fal',
  iconName: 'star-half-stroke',
  icon: [640, 512, ["star-half-alt"], "f5c0", "M234.4 186.5L97 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L182.2 473.2 304 408.1V75.1l-45.5 93.7c-4.6 9.5-13.6 16.1-24.1 17.7zM336 408.2l121.6 65L434.1 333.7c-1.7-10.3 1.6-20.7 9-28.1l99.8-98.8L405.4 186.5c-10.5-1.5-19.5-8.2-24.1-17.7L336 75.4V408.2zm146.2 99.2c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L183 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L63.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L298.3 13.5C302.4 5.2 310.7 0 319.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L465.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5z"]
};
var faStarHalfAlt = faStarHalfStroke;
var faFileExclamation = {
  prefix: 'fal',
  iconName: 'file-exclamation',
  icon: [384, 512, [], "f31a", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM192 224c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zm24 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCode = {
  prefix: 'fal',
  iconName: 'code',
  icon: [640, 512, [], "f121", "M405.1 .8c-8.4-2.8-17.4 1.7-20.2 10.1l-160 480c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l160-480c2.8-8.4-1.7-17.4-10.1-20.2zM172 117.4c-5.9-6.6-16-7.2-22.6-1.3l-144 128C2 247.1 0 251.4 0 256s2 8.9 5.4 12l144 128c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6L40.1 256 170.6 140c6.6-5.9 7.2-16 1.3-22.6zm296.1 0c-5.9 6.6-5.3 16.7 1.3 22.6L599.9 256 469.4 372c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l144-128c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-144-128c-6.6-5.9-16.7-5.3-22.6 1.3z"]
};
var faWhiskeyGlass = {
  prefix: 'fal',
  iconName: 'whiskey-glass',
  icon: [512, 512, [129347, "glass-whiskey"], "f7a0", "M32 64L60 256H452L480 64H32zM64.7 288L82 406.9c3.4 23.6 23.7 41.1 47.5 41.1h253c23.8 0 44.1-17.5 47.5-41.1L447.3 288H64.7zM7.8 43.1C13.9 36 22.7 32 32 32H480c9.3 0 18.1 4 24.2 11.1s8.8 16.4 7.5 25.5l-50 342.9c-5.7 39.3-39.4 68.5-79.2 68.5h-253c-39.7 0-73.4-29.1-79.2-68.5L.3 68.6C-1 59.4 1.7 50.1 7.8 43.1z"]
};
var faGlassWhiskey = faWhiskeyGlass;
var faMoonStars = {
  prefix: 'fal',
  iconName: 'moon-stars',
  icon: [512, 512, [], "f755", "M304 0c8.8 0 16 7.2 16 16V48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H320v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V16c0-8.8 7.2-16 16-16zM156.6 163.9C85.3 180 32 243.8 32 320.2c0 88.5 71.6 160.2 159.8 160.2c25.7 0 50-6.1 71.5-16.9c-87.6-11.3-155.1-86.4-155.1-177.2c0-47.4 18.4-90.4 48.4-122.4zM0 320.2C0 214.1 85.8 128 191.8 128c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.2c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4C85.8 512.4 0 426.3 0 320.2zM432 160v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H432v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V160c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faBuildingCircleExclamation = {
  prefix: 'fal',
  iconName: 'building-circle-exclamation',
  icon: [640, 512, [], "e4d3", "M64 32H320c17.7 0 32 14.3 32 32V266.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm128 80a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faClothesHanger = {
  prefix: 'fal',
  iconName: 'clothes-hanger',
  icon: [640, 512, [], "e136", "M212.2 85.8C220.4 36.3 263.2 0 313.4 0C370.1 0 416 45.9 416 102.6v8.1c0 36.1-17.6 70-47.2 90.7l-20.7 14.5L612.5 396.8C629.7 408.5 640 428 640 448.9c0 34.9-28.3 63.1-63.1 63.1H63.1C28.3 512 0 483.7 0 448.9c0-20.8 10.3-40.3 27.5-52.1L310.9 202.8l39.5-27.7c21-14.7 33.6-38.8 33.6-64.5v-8.1c0-39-31.6-70.6-70.6-70.6c-34.5 0-64 25-69.7 59l-3.9 23.6c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l3.9-23.6zM320 235.4L45.6 423.2C37.1 429 32 438.6 32 448.9C32 466.1 45.9 480 63.1 480H576.9c17.2 0 31.1-13.9 31.1-31.1c0-10.3-5.1-19.9-13.6-25.7L320 235.4z"]
};
var faMobileNotch = {
  prefix: 'fal',
  iconName: 'mobile-notch',
  icon: [384, 512, ["mobile-iphone"], "e1ee", "M256 32V48c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V32H96C78.3 32 64 46.3 64 64V448c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H256zm-32 0H160V48h64V32zM32 64C32 28.7 60.7 0 96 0H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64z"]
};
var faMobileIphone = faMobileNotch;
var faMagnifyingGlassChart = {
  prefix: 'fal',
  iconName: 'magnifying-glass-chart',
  icon: [512, 512, [], "e522", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM128 224l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64-96V288c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 64v96c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faArrowUpRightFromSquare = {
  prefix: 'fal',
  iconName: 'arrow-up-right-from-square',
  icon: [512, 512, ["external-link"], "f08e", "M336 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H457.4L212.7 276.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H336zM64 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"]
};
var faExternalLink = faArrowUpRightFromSquare;
var faCubesStacked = {
  prefix: 'fal',
  iconName: 'cubes-stacked',
  icon: [448, 512, [], "e4e6", "M288 64H224v64h64V64zM224 32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM98.7 234.7l32 55.4 55.4-32-32-55.4-55.4 32zM71 250.7c-8.8-15.3-3.6-34.9 11.7-43.7l55.4-32c15.3-8.8 34.9-3.6 43.7 11.7l32 55.4c8.8 15.3 3.6 34.9-11.7 43.7l-55.4 32c-15.3 8.8-34.9 3.6-43.7-11.7L71 250.7zM352 224H288v64h64V224zm-96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V224zm96 224h64V384H352v64zm-32-64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384zm-64 0H192v64h64V384zm-64-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32zM32 384v64H96V384H32zM0 384c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384z"]
};
var faImagesUser = {
  prefix: 'fal',
  iconName: 'images-user',
  icon: [576, 512, [], "e1b9", "M512 64H160c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32h64V336c0-44.2 35.8-80 80-80h32 32c44.2 0 80 35.8 80 80v16h64c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM448 384H416 256 224 160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64H448zm-32-32V336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v16H416zM16 96c8.8 0 16 7.2 16 16V352c0 53 43 96 96 96H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 480 0 422.7 0 352V112c0-8.8 7.2-16 16-16zm352 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM336 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faWonSign = {
  prefix: 'fal',
  iconName: 'won-sign',
  icon: [512, 512, [8361, "krw", "won"], "f159", "M31.3 43.3c-2.6-8.4-11.6-13.2-20-10.6S-1.9 44.3 .7 52.7L63.3 256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H73.1l55.6 180.7c2.1 6.8 8.4 11.4 15.6 11.3s13.3-5 15.2-11.8L208 288H304l48.5 180.2c1.9 6.9 8 11.7 15.2 11.8s13.5-4.5 15.6-11.3L438.9 288H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H448.7L511.3 52.7c2.6-8.4-2.1-17.4-10.6-20s-17.4 2.1-20 10.6L415.3 256H328.6L271.5 43.8c-1.9-7-8.2-11.8-15.4-11.8s-13.6 4.9-15.4 11.8L183.4 256H96.7L31.3 43.3zM106.6 288h68.2L143 406.3 106.6 288zm110-32L256 109.5 295.4 256H216.6zm120.6 32h68.2L369 406.3 337.2 288z"]
};
var faKrw = faWonSign;
var faWon = faWonSign;
var faImagePolaroidUser = {
  prefix: 'fal',
  iconName: 'image-polaroid-user',
  icon: [448, 512, [], "e1b6", "M336 384H304 144 112 32v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V384H336zm-1.6-32H416V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96V352h81.6c7.4-36.5 39.7-64 78.4-64h32 32c38.7 0 71 27.5 78.4 64zm-187.7 0H301.3c-6.6-18.6-24.4-32-45.3-32H192c-20.9 0-38.7 13.4-45.3 32zM448 96V352v16 16 32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384 368 352 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64zM256 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faVirusCovid = {
  prefix: 'fal',
  iconName: 'virus-covid',
  icon: [512, 512, [], "e4a8", "M216 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h24V72.7c-38.8 3.3-74.1 18.7-102.3 42.4L108.9 86.3l0 0 17-17c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L46.7 103.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17-17 0 0 28.8 28.8C91.4 165.9 76 201.2 72.7 240H32l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24H72.7c3.3 38.8 18.7 74.1 42.4 102.3L86.3 403.1l0 0-17-17c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17-17 0 0 28.8-28.8c28.2 23.7 63.5 39 102.3 42.4V480H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V439.3c38.8-3.3 74.1-18.7 102.3-42.4l28.8 28.8 0 0-17 17c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-17 17 0 0-28.8-28.8c23.7-28.2 39-63.5 42.4-102.3H480v24c0 8.8 7.2 16 16 16s16-7.2 16-16V216c0-8.8-7.2-16-16-16s-16 7.2-16 16v24H439.3c-3.3-38.8-18.7-74.1-42.4-102.3l28.8-28.8 0 0 17 17c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L408.7 46.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17 17 0 0-28.8 28.8C346.1 91.4 310.8 76 272 72.7V32l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H216zm40 104a152 152 0 1 1 0 304 152 152 0 1 1 0-304zM192 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm112 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSquareEllipsis = {
  prefix: 'fal',
  iconName: 'square-ellipsis',
  icon: [448, 512, [], "e26e", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM200 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm168-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faPie = {
  prefix: 'fal',
  iconName: 'pie',
  icon: [576, 512, [129383], "f705", "M288 80c-98.6 0-183.4 59.5-220.3 144.6C64.2 232.6 56 240 44.8 240c-8.8 0-16 7.2-16 16s7.2 16 16 16c26 0 46-9.5 59.3-18.9c6.1-4.3 14.1-4.8 20.7-1.2c1.4 .8 2.8 1.5 4.3 2.3c17 8.8 41.6 17.8 70.8 17.8s53.8-9 70.8-17.8c10.8-5.6 23.6-5.6 34.4 0c17 8.8 41.6 17.8 70.8 17.8s53.8-9 70.8-17.8c1.5-.8 2.9-1.5 4.3-2.3c6.6-3.7 14.7-3.1 20.7 1.2c13.3 9.4 33.3 18.9 59.3 18.9c8.8 0 16-7.2 16-16s-7.2-16-16-16c-11.2 0-19.4-7.4-22.9-15.4C471.4 139.5 386.6 80 288 80zM40 208.2C82.6 113.8 177.6 48 288 48s205.4 65.8 248.1 160.2c24.2 2.4 43.1 22.9 43.1 47.8c0 26.5-21.5 48-48 48c-30.2 0-54.2-9.8-71.3-20.5c-20 10.1-49 20.5-83.9 20.5c-35.8 0-65.4-11-85.5-21.3c-1.6-.8-3.5-.8-5 0C265.4 293 235.8 304 200 304c-34.8 0-63.8-10.4-83.9-20.5C99 294.2 75 304 44.8 304c-26.5 0-48-21.5-48-48c0-24.9 18.9-45.3 43.2-47.8zM58.5 335.4c11.4-.9 22-3 31.8-5.8l21.5 64.4c4.4 13.1 16.6 21.9 30.4 21.9H433.9c13.8 0 26-8.8 30.4-21.9l21.5-64.4c9.8 2.8 20.4 4.8 31.8 5.8l-22.9 68.8c-8.7 26.1-33.2 43.8-60.7 43.8H142.1c-27.5 0-52-17.6-60.7-43.8L58.5 335.4zM206.3 151.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5zm192-14.3l16 32c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2zM304 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChessKnightPiece = {
  prefix: 'fal',
  iconName: 'chess-knight-piece',
  icon: [320, 512, ["chess-knight-alt"], "f442", "M53.3 96l80.4 0C210.1 96 272 157.9 272 234.3c0 12.7-1.7 25.3-5.2 37.5L244.3 352h33.2l20.1-71.5c4.2-15 6.4-30.6 6.4-46.2C304 140.3 227.7 64 133.7 64L45.3 64c-16 0-28.9 12.9-28.9 28.9c0 8.2 3.5 16 9.6 21.5l7.7 6.9c-11.1 14-17.3 31.5-17.3 49.5l-.2 65.1c-.1 26.9 17.6 49.7 42.1 57.3c-6.3 11.7-9.8 25-9.8 38.7L48.2 352h32l.2-19.8h0V332c0-15.6 7.4-30.3 19.9-39.7l76.1-46.7c7.5-4.6 9.9-14.5 5.3-22s-14.5-9.9-22-5.3l-36.5 22.4c-1.2 .4-2.3 .9-3.4 1.5L90.3 260c-4.4 2.6-9.4 4-14.5 4c-15.3-.1-27.7-12.6-27.7-27.9l.2-65.1c0-11.7 4.3-23 12.1-31.7l7.6-8.6c5.8-6.6 5.3-16.6-1.3-22.5L53.3 96zM96 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM65.8 416l188.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L65.8 416zm188.4-32H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512H280.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"]
};
var faChessKnightAlt = faChessKnightPiece;
var faAustralSign = {
  prefix: 'fal',
  iconName: 'austral-sign',
  icon: [448, 512, [], "e0a9", "M238.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8L132.2 224H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H118.6L91.6 320H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H78L33.3 457.8c-3.4 8.1 .4 17.5 8.5 21s17.5-.4 21-8.5l50-118.2H335.2l50 118.2c3.4 8.1 12.8 11.9 21 8.5s11.9-12.8 8.5-21L370 352h62c8.8 0 16-7.2 16-16s-7.2-16-16-16H356.5l-27.1-64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H315.8L238.7 41.8zM281.1 224H166.9L224 89.1 281.1 224zM153.4 256H294.6l27.1 64H126.3l27.1-64z"]
};
var faCloudPlus = {
  prefix: 'fal',
  iconName: 'cloud-plus',
  icon: [640, 512, [], "e35e", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm32 352V304H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H336v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faF = {
  prefix: 'fal',
  iconName: 'f',
  icon: [320, 512, [102], "46", "M48 32C21.5 32 0 53.5 0 80V248 464c0 8.8 7.2 16 16 16s16-7.2 16-16V272H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V80c0-8.8 7.2-16 16-16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H48z"]
};
var faLeaf = {
  prefix: 'fal',
  iconName: 'leaf',
  icon: [512, 512, [], "f06c", "M132 238.3c23.6-9.3 49.2-14.3 76-14.3h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-28.8 0-56 6.9-80 19.2C129.7 353.2 193.5 416 272 416h0l.8 0c109-.5 207.2-110.5 207.2-259.4c0-23-2.4-45.2-6.9-66.3C447.5 113.7 413.4 128 376 128l-104 0c-67.9 0-124.9 47-140 110.3zM96.7 256.3C104.7 166.4 180.1 96 272 96l104 0c35.2 0 66.6-16.2 87.2-41.7l.6-.8c2.3-2.9 4.4-5.8 6.4-8.9c1.6-2.5 3.2-5.1 4.6-7.8c3.5-6.5 13.6-6.8 16.2 .1c1.3 3.5 2.5 7 3.7 10.6s2.3 7.1 3.4 10.8l.4 1.5c8.8 30.3 13.5 62.8 13.5 96.8C512 317.1 405.1 447.3 273 448l-1 0c-89.4 0-163.2-66.7-174.5-153C57.5 327.3 32 376.7 32 432v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-73.9 38.6-138.9 96.7-175.7z"]
};
var faBedBunk = {
  prefix: 'fal',
  iconName: 'bed-bunk',
  icon: [576, 512, [], "f8f8", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V176 431.7 496c0 8.8 7.2 16 16 16s16-7.2 16-16V447.7H240 544V496c0 8.8 7.2 16 16 16s16-7.2 16-16V431.7 272 176 112C576 50.1 525.9 0 464 0H256c-17.7 0-32 14.3-32 32V160H32V16zM224 288V415.7H32V192H240 544v64H256c-17.7 0-32 14.3-32 32zM544 112v48H256V32H464c44.2 0 80 35.8 80 80zM256 288l288 0V415.7H256V288zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faRoad = {
  prefix: 'fal',
  iconName: 'road',
  icon: [576, 512, [128739], "f018", "M185.6 32c-26.9 0-50.9 16.8-60.1 42L8.5 394c-15.3 41.8 15.7 86 60.1 86H507.4c44.5 0 75.4-44.2 60.1-86L450.5 74c-9.2-25.2-33.2-42-60.1-42H185.6zM155.5 85c4.6-12.6 16.6-21 30.1-21H272v48c0 8.8 7.2 16 16 16s16-7.2 16-16V64h86.4c13.4 0 25.4 8.4 30.1 21L537.4 405c7.6 20.9-7.8 43-30.1 43H304V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H68.6c-22.2 0-37.7-22.1-30.1-43L155.5 85zM304 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"]
};
var faTaxi = {
  prefix: 'fal',
  iconName: 'taxi',
  icon: [512, 512, [128662, "cab"], "f1ba", "M192 48V64H320V48c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM160 64V48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V64h.4c35.3 0 66.5 23.2 76.6 57l34.3 114.4 .4 1.3C492.6 253.2 512 284.3 512 320v96 16 16 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 432 416 320c0-35.7 19.4-66.8 48.3-83.3l.4-1.3L83 121c10.2-33.8 41.3-57 76.6-57h.4zm-.4 32c-21.2 0-39.9 13.9-46 34.2L85.3 224.6c3.5-.4 7.1-.6 10.7-.6H416c3.6 0 7.2 .2 10.7 .6l-28.3-94.4c-6.1-20.3-24.8-34.2-46-34.2H159.6zM74.7 259.9l-.5-.1C49.6 268.7 32 292.3 32 320v96H480V320c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H96c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3zM80 328a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCab = faTaxi;
var faPersonCirclePlus = {
  prefix: 'fal',
  iconName: 'person-circle-plus',
  icon: [576, 512, [], "e541", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChartPie = {
  prefix: 'fal',
  iconName: 'chart-pie',
  icon: [576, 512, ["pie-chart"], "f200", "M511.3 208H336V32.7c93.3 7.7 167.6 82.1 175.3 175.3zM320 240H528.5c8.4 0 15.4-6.5 15.5-14.9l0-1.1C544 100.3 443.7 0 320 0l-1.1 0C310.5 0 304 7.1 304 15.5V224c0 8.8 7.2 16 16 16zm-86.6 70.6L375.3 452.6C344.9 470 309.6 480 272 480C157.1 480 64 386.9 64 272c0-98.3 68.3-180.8 160-202.4V288c0 8.5 3.4 16.6 9.4 22.6zM239 34.3C122.1 50.3 32 150.7 32 272c0 132.5 107.5 240 240 240c51.8 0 99.8-16.4 139-44.3c7.7-5.5 8.2-16.5 1.5-23.1L256 288V49.6c0-9.2-7.8-16.6-17-15.4zM489.6 412.3L397.3 320H538.4c-8.3 35-25.4 66.6-48.9 92.3zM573.8 305c1.3-9.2-6.1-17-15.4-17H358.6c-14.3 0-21.4 17.2-11.3 27.3L478.7 446.7c5.8 5.8 15.2 6.3 21.2 .7c39.3-36.7 66.2-86.5 73.9-142.3z"]
};
var faPieChart = faChartPie;
var faBoltLightning = {
  prefix: 'fal',
  iconName: 'bolt-lightning',
  icon: [384, 512, [], "e0b7", "M32 30.9C32 13.8 45.9 0 62.9 0H226.2C242.7 0 256 13.3 256 29.8c0 3.2-.5 6.4-1.5 9.4L214.2 160H355.8c15.6 0 28.2 12.6 28.2 28.2c0 5.7-1.7 11.2-4.9 15.9l-203.2 297c-4.6 6.8-12.3 10.8-20.5 10.8c-16.2 0-28-15.2-24.1-30.9L179.5 288H30.9C13.9 288 0 274.1 0 257.1c0-1.5 .1-2.9 .3-4.4L32 30.9zM64 32c0 1.1-.1 2.2-.3 3.3L32.2 256H200c4.9 0 9.6 2.3 12.6 6.2s4.1 8.9 2.9 13.7L171.9 450.2 348.6 192H192c-5.1 0-10-2.5-13-6.6s-3.8-9.5-2.2-14.4L223.1 32H64z"]
};
var faClockEight = {
  prefix: 'fal',
  iconName: 'clock-eight',
  icon: [512, 512, [], "e345", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V256c0 5.3-2.7 10.3-7.1 13.3l-96 64c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2L240 247.4V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSackXmark = {
  prefix: 'fal',
  iconName: 'sack-xmark',
  icon: [512, 512, [], "e56a", "M310.5 144h-109l-5.3 3.4C141.4 182.5 32 268.3 32 416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64c0-147.7-109.4-233.5-164.3-268.6l-5.3-3.4zm-3.8-41.8L355.1 32H156.9l48.4 70.2 6.7 9.8h87.8l6.7-9.8zM0 416C0 273.4 91.2 183.7 152.6 138.5c9.7-7.1 18.6-13.2 26.4-18.1L160.8 94 121.9 37.6C111 21.7 122.4 0 141.7 0H370.3c19.3 0 30.7 21.7 19.8 37.6L351.2 94 333 120.4c7.7 4.9 16.7 11 26.4 18.1C420.8 183.7 512 273.4 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96zM256 297.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 320l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 297.4z"]
};
var faFileExcel = {
  prefix: 'fal',
  iconName: 'file-excel',
  icon: [384, 512, [], "f1c3", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm85.1 246.8c-5.1-7.2-15-9-22.3-3.9s-9 15-3.9 22.3L172.5 336l-49.6 70.8c-5.1 7.2-3.3 17.2 3.9 22.3s17.2 3.3 22.3-3.9L192 363.9l42.9 61.3c5.1 7.2 15 9 22.3 3.9s9-15 3.9-22.3L211.5 336l49.6-70.8c5.1-7.2 3.3-17.2-3.9-22.3s-17.2-3.3-22.3 3.9L192 308.1l-42.9-61.3z"]
};
var faFileContract = {
  prefix: 'fal',
  iconName: 'file-contract',
  icon: [384, 512, [], "f56c", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM80 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm54.2 253.8L144 349l16.7 55.6c1.7 5.8 6.6 10.1 12.5 11.2s12-1.3 15.6-6.2l17.6-23.4c1-1.4 2.7-2.2 4.4-2.2c2.1 0 4 1.2 4.9 3l10.1 20.1c2.7 5.4 8.3 8.8 14.3 8.8h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H249.9l-5.6-11.3C237.9 360 224.9 352 210.7 352c-11 0-21.4 4.8-28.5 13.1l-12.6-42.1C166.2 311.7 155.8 304 144 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.2c21.2 0 39.9-13.9 46-34.2z"]
};
var faFishFins = {
  prefix: 'fal',
  iconName: 'fish-fins',
  icon: [576, 512, [], "e4f2", "M247.8 148c13.4-6.2 20.8-20.8 17.9-35.3L256 64l77.6 58.2c4.9 3.7 10.8 5.9 16.9 6.3c47.2 3.4 88 23.2 120.3 47.5c35.5 26.7 60.8 58.7 73.2 80c-12.4 21.3-37.6 53.3-73.2 80c-32.3 24.2-73.1 44.1-120.3 47.5c-6.1 .4-12 2.6-16.9 6.3L256 448l9.7-48.6c2.9-14.5-4.5-29.1-17.9-35.3c-17.1-7.9-32.7-17.6-46.6-28c-13.8-10.4-26.1-21.6-36.8-32.8c-10.2-10.7-26.5-13-39.3-5.5L32 352l45.8-80.1c5.6-9.8 5.6-21.9 0-31.8L32 160l93.1 54.3c12.8 7.5 29 5.2 39.3-5.5c10.7-11.2 23-22.4 36.8-32.8c13.9-10.5 29.6-20.2 46.6-28zM9.5 137.3C-.8 147.5-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleQ = {
  prefix: 'fal',
  iconName: 'circle-q',
  icon: [512, 512, [], "e11e", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 256c0-53 43-96 96-96s96 43 96 96c0 20.7-6.6 39.9-17.7 55.6l-50.9-50.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l50.9 50.9C295.9 345.4 276.7 352 256 352c-53 0-96-43-96-96zm224 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c29.6 0 56.8-10 78.5-26.9l22.2 22.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-22.2-22.2C374 312.8 384 285.6 384 256z"]
};
var faBuildingFlag = {
  prefix: 'fal',
  iconName: 'building-flag',
  icon: [640, 512, [], "e4d5", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM224 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm-96 96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256 224 160 128zM64 120c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V120zm32 8v32h32V128H96zM248 96h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm8 64h32V128H256v32zM64 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V248zm32 8v32h32V256H96zm152-32h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm8 64h32V256H256v32zM432 0c8.8 0 16 7.2 16 16V32H608c17.7 0 32 14.3 32 32V192c0 17.7-14.3 32-32 32H448V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224 192 64 32 16c0-8.8 7.2-16 16-16zm16 192H608V64H448V192z"]
};
var faFaceGrinBeam = {
  prefix: 'fal',
  iconName: 'face-grin-beam',
  icon: [512, 512, [128516, "grin-beam"], "f582", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zm-242.4-135c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 155.9 157.2 146 176 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 155.9 317.2 146 336 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"]
};
var faGrinBeam = faFaceGrinBeam;
var faObjectUngroup = {
  prefix: 'fal',
  iconName: 'object-ungroup',
  icon: [640, 512, [], "f248", "M0 64c0 29.8 20.4 54.9 48 62V226c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64c29.8 0 54.9-20.4 62-48H322c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62V126c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64c-29.8 0-54.9 20.4-62 48H126C118.9 20.4 93.8 0 64 0C28.7 0 0 28.7 0 64zM322 80c5.8 22.5 23.5 40.2 46 46V226c-22.5 5.8-40.2 23.5-46 46H126c-5.8-22.5-23.5-40.2-46-46V126c22.5-5.8 40.2-23.5 46-46H322zM480 208H464v32h16 34c5.8 22.5 23.5 40.2 46 46V386c-22.5 5.8-40.2 23.5-46 46H318c-5.8-22.5-23.5-40.2-46-46V352 336H240v16 34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64c29.8 0 54.9-20.4 62-48H514c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62V286c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64c-29.8 0-54.9 20.4-62 48H480zm96 48a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM544 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faFaceDisguise = {
  prefix: 'fal',
  iconName: 'face-disguise',
  icon: [512, 512, [], "e370", "M480 256c0 123.7-100.3 224-224 224S32 379.7 32 256c0-16.5 1.8-32.5 5.2-48H72c0 50.1 38.4 91.2 87.3 95.6c-9.6 7.9-15.3 19.7-15.3 32.4c0 15.9 9 30.4 23.1 37.5L147.5 398c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l23.9-29.9 7.3 3.6-10.5 26.3c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l10-24.9c2.4 .7 4.8 1.3 7.2 1.8V432c0 8.8 7.2 16 16 16s16-7.2 16-16V406.8c2.4-.5 4.8-1.1 7.2-1.8l10 24.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-10.5-26.3 7.3-3.6L339.5 418c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-19.6-24.5C359 366.4 368 351.9 368 336c0-12.7-5.7-24.5-15.3-32.4c49-4.4 87.3-45.5 87.3-95.6h34.8c3.4 15.5 5.2 31.5 5.2 48zM218 229.5l-21.4 35.7c-1.1 .6-1.9 1-2.6 1.3c-7.9 3.5-16.8 5.5-26.1 5.5c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 2.5-.1 4.9-.4 7.3c-5.4 3.6-10.1 8.4-13.5 14.1zm75.9 0c-3.5-5.8-8.1-10.6-13.5-14.1c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5c-.6-.3-1.5-.7-2.6-1.3L294 229.5zM465.3 176H434.5c-5.3-14.9-14.1-28-25.4-38.5l5.2-10.3c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-3.5 7c-4.6-2-9.3-3.6-14.2-4.9V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v16.3c-4.4 .4-8.7 1-13 2l-4.7-9.5c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l3.6 7.3c-16.4 10.2-29.5 25.3-37.3 43.1c-7.8-17.9-20.9-32.9-37.3-43.1l3.6-7.3c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-4.7 9.5c-4.2-.9-8.6-1.6-13-2V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v19c-4.9 1.3-9.6 2.9-14.2 4.9l-3.5-7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l5.2 10.3C91.5 148 82.7 161.1 77.5 176H46.7C78.9 91.8 160.5 32 256 32s177.1 59.8 209.3 144zm34.1 .4C465.9 74 369.6 0 256 0S46.1 74 12.6 176.4C5.4 177.9 0 184.3 0 192c0 4.7 2 9 5.3 11.9C1.8 220.7 0 238.1 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.9-1.8-35.3-5.3-52.1c3.3-2.9 5.3-7.2 5.3-11.9c0-7.7-5.4-14.1-12.6-15.6zM256 240c4.3 0 8.3 2.3 10.5 6l39.8 66.3 2.4 4 4.2 2.1 17.7 8.8c3.4 1.7 5.5 5.1 5.5 8.8s-2.1 7.2-5.5 8.8l-53.1 26.5c-13.5 6.8-29.4 6.8-42.9 0l-53.1-26.5c-3.4-1.7-5.5-5.1-5.5-8.8s2.1-7.2 5.5-8.8l17.7-8.8 4.2-2.1 2.4-4L245.5 246c2.2-3.7 6.2-6 10.5-6zm-64-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleArrowDownRight = {
  prefix: 'fal',
  iconName: 'circle-arrow-down-right',
  icon: [512, 512, [], "e0fa", "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM200 352H336c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16s-16 7.2-16 16V297.4L187.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 320H200c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faAlien8bit = {
  prefix: 'fal',
  iconName: 'alien-8bit',
  icon: [576, 512, [128126, "alien-monster"], "f8f6", "M128 32c-17.7 0-32 14.3-32 32V96c0 17.7 14.3 32 32 32h32v32H96V144c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32H64v32c0 17.7 14.3 32 32 32h32v64c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32h96c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V384h32c17.7 0 32-14.3 32-32V320h32c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32H512c-17.7 0-32 14.3-32 32v16H416V128h32c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32H352c-17.7 0-32 14.3-32 32v32H256V96c0-17.7-14.3-32-32-32H192c0-17.7-14.3-32-32-32H128zM480 192v48c0 8.8 7.2 16 16 16s16-7.2 16-16V176 144h32V288H496c-8.8 0-16 7.2-16 16v48H432 368 208 144 96V304c0-8.8-7.2-16-16-16H32V144H64v32 64c0 8.8 7.2 16 16 16s16-7.2 16-16V192h80c8.8 0 16-7.2 16-16V112 96h32v48c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V96h32v16 64c0 8.8 7.2 16 16 16h80zM128 96V64h32V80 96H128zm320 0H416V80 64h32V96zM160 448V384h32v16c0 8.8 7.2 16 16 16h32v32H160zm224-48V384h32v64H336V416h32c8.8 0 16-7.2 16-16zM224 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]
};
var faAlienMonster = faAlien8bit;
var faHandPointRibbon = {
  prefix: 'fal',
  iconName: 'hand-point-ribbon',
  icon: [448, 512, [], "e1a6", "M128 56c0-13.3 10.7-24 24-24s24 10.7 24 24v8H128V56zM96 64H32c-6.2 0-11.8 3.5-14.4 9.1s-1.9 12.1 1.9 16.9l24 30-24 30c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1H96v80c-19.4 14.6-32 37.8-32 64v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V304 272 248c0-30.9-25.1-56-56-56c-12.1 0-23.3 3.8-32.5 10.4C349.6 186.5 332 176 312 176c-9.7 0-18.8 2.5-26.7 6.8C278 160.3 256.9 144 232 144c-8.6 0-16.7 1.9-24 5.4V80 56c0-30.9-25.1-56-56-56S96 25.1 96 56v8zm80 32v48H65.3l11.2-14c4.7-5.8 4.7-14.1 0-20L65.3 96H176zm0 80v24 40H144c-5.5 0-10.8 .6-16 1.6V176h48zm0 96v0h32v0h24c13.2 0 24 10.7 24 24v0c0 13.3-10.7 24-24 24H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c13.8 0 26.4-5 36.1-13.2C358.4 351.7 374.2 360 392 360c8.6 0 16.7-1.9 24-5.4C414.6 424.1 357.8 480 288 480H224c-70.7 0-128-57.3-128-128V320c0-26.5 21.5-48 48-48h32zm32-32V200c0-13.3 10.7-24 24-24s24 10.7 24 24v31.9l0 .1v13.4c-7.3-3.5-15.4-5.4-24-5.4H208zm80 32V232c0-13.2 10.8-24 24-24c13.3 0 24 10.7 24 24v16 48c0 13.3-10.7 24-24 24s-24-10.7-24-24v0l0-24zm128 0v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8V248c0-13.3 10.7-24 24-24s24 10.7 24 24v24z"]
};
var faPoop = {
  prefix: 'fal',
  iconName: 'poop',
  icon: [512, 512, [], "f619", "M224 16V0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4L224 16zM359.4 131.9l-15.9 1.5c.6 6.3 4.8 11.6 10.7 13.6l5.2-15.1zm40.8 100.6L386 225.2c-2.4 4.7-2.3 10.2 .2 14.8s7.1 7.7 12.3 8.3l1.8-15.9zm42.9 122.1l-11.4-11.2c-4 4-5.5 9.9-4.1 15.4s5.7 9.8 11.2 11.3l4.3-15.4zm-374.5 0L73 370c5.5-1.5 9.7-5.8 11.2-11.3s-.1-11.3-4.1-15.4L68.8 354.6zm42.9-122.1l1.8 15.9c5.2-.6 9.8-3.7 12.3-8.3s2.6-10.1 .2-14.8l-14.3 7.2zM229.8 21.8L218.5 33.1l11.3-11.3zM232 0h-8V32h8V0zM375.4 130.4C368.5 57.2 306.9 0 232 0V32c58.3 0 106.2 44.5 111.5 101.4l31.9-3zM424 200c0-38.6-24.8-71.4-59.4-83.2L354.2 147c22 7.6 37.8 28.4 37.8 53h32zm-9.4 39.7c6-11.9 9.4-25.4 9.4-39.7H392c0 9.1-2.2 17.7-6 25.2l28.6 14.5zM480 304c0-45.2-34-82.4-77.9-87.4l-3.6 31.8c27.9 3.2 49.5 26.9 49.5 55.6h32zm-25.4 61.8C470.3 350 480 328.1 480 304H448c0 15.3-6.2 29.2-16.2 39.4l22.8 22.5zM512 424c0-40.5-27.3-74.5-64.5-84.8L439 370c23.7 6.5 41 28.3 41 54h32zm-88 88c48.6 0 88-39.4 88-88H480c0 30.9-25.1 56-56 56v32zM88 512H424V480H88v32zM0 424c0 48.6 39.4 88 88 88V480c-30.9 0-56-25.1-56-56H0zm64.5-84.8C27.3 349.5 0 383.5 0 424H32c0-25.7 17.4-47.4 41-54l-8.5-30.8zM32 304c0 24.1 9.7 46 25.4 61.8l22.8-22.5C70.2 333.2 64 319.3 64 304H32zm77.9-87.4C66 221.6 32 258.8 32 304H64c0-28.7 21.7-52.4 49.5-55.6l-3.6-31.8zM88 200c0 14.2 3.4 27.8 9.4 39.7L126 225.2c-3.8-7.6-6-16.1-6-25.2H88zm88-88c-48.6 0-88 39.4-88 88h32c0-30.9 25.1-56 56-56V112zm.9 0H176v32h.9V112zm17.8 0H176.9v32h17.8V112zM232 74.7c0 20.6-16.7 37.3-37.3 37.3v32C233 144 264 113 264 74.7H232zm0-8.9v8.9h32V65.8H232zM218.5 33.1c8.7 8.7 13.5 20.4 13.5 32.7h32c0-20.7-8.2-40.6-22.9-55.3L218.5 33.1zm-5.8-5.8l5.8 5.8 22.6-22.6-5.8-5.8L212.7 27.3z"]
};
var faObjectExclude = {
  prefix: 'fal',
  iconName: 'object-exclude',
  icon: [512, 512, [], "e49c", "M64 32H288c17.7 0 32 14.3 32 32v64h32V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h64V320H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm96 352v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H384v32h64c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V384H160zm128-32c35.3 0 64-28.7 64-64H320c0 17.7-14.3 32-32 32H256v32h32zm64-160V160H320 288v32h32v64h32V192zM224 352l0-32H192V256H160v64 32h32 32zM160 224h32c0-17.7 14.3-32 32-32h32V160H224c-35.3 0-64 28.7-64 64z"]
};
var faTelescope = {
  prefix: 'fal',
  iconName: 'telescope',
  icon: [576, 512, [128301], "e03e", "M447.1 35.7L357.9 87.2l96 166.3L543.1 202l-96-166.3zM344 127.2L79.6 295.2c0 0-.1 .1-.1 .1l0 0c0 0 0 .1-.1 .1s0 .1 0 .1l0 0s0 0 0 .1L134 390l0 .1 0 0 0 0c0 0 .1 0 .1 .1l.1 0c0 0 .1 0 .1 0l0 0 0 0 .1 0 97-52.5C226.7 327.5 224 316 224 304c0-44.2 35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80c-10 0-19.6-1.8-28.4-5.2L222.7 502.3c-3.5 8.1-12.9 11.9-21 8.4s-11.9-12.9-8.4-21l53.2-124.1-97 52.4c-15.2 8.2-34.3 2.9-42.9-12.1L52 311.4c-8.6-14.9-3.9-33.8 10.6-43L328.4 99.6c-6.2-14.6-.6-31.9 13.5-40.1L431.1 8C446.4-.8 466 4.4 474.8 19.7l96 166.3c8.8 15.3 3.6 34.9-11.7 43.7l-89.2 51.5c-15.3 8.8-34.9 3.6-43.7-11.7l-.5-.8-42.6 23.1c-1.7-10.9-5.5-21-11.1-30l37.9-20.5L344 127.2zM304 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm55.7 9.4c-7.8 7.5-17 13.5-27.3 17.4l52.9 123.5c3.5 8.1 12.9 11.9 21 8.4s11.9-12.9 8.4-21l-55-128.3zM29.9 352.1l32 56c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6l-32-56c-4.4-7.7-1.7-17.4 6-21.8s17.4-1.7 21.8 6z"]
};
var faLocationPin = {
  prefix: 'fal',
  iconName: 'location-pin',
  icon: [384, 512, ["map-marker"], "f041", "M335.4 255.4c-10.9 25.9-26.2 54-43.6 82.1c-34.1 55.3-74.4 108.2-99.9 140c-25.4-31.8-65.8-84.7-99.9-140c-17.3-28.1-32.7-56.3-43.6-82.1C37.4 229 32 207.6 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160c0 15.6-5.4 37-16.6 63.4zM215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0z"]
};
var faMapMarker = faLocationPin;
var faSquareList = {
  prefix: 'fal',
  iconName: 'square-list',
  icon: [448, 512, [], "e489", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm-64-72a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-24 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faKaaba = {
  prefix: 'fal',
  iconName: 'kaaba',
  icon: [576, 512, [128331], "f66b", "M544 112v0L288 192 32 112 288 32l256 80zM22.5 81.5C9.1 85.6 0 98 0 112V400c0 14 9.1 26.4 22.5 30.5l256 80c6.2 1.9 12.9 1.9 19.1 0l256-80C566.9 426.4 576 414 576 400V112c0-14-9.1-26.4-22.5-30.5l-256-80c-6.2-1.9-12.9-1.9-19.1 0l-256 80zM544 191.2L292.8 269.7c-3.1 1-6.4 1-9.5 0L32 191.2V145.5l246.5 77c6.2 1.9 12.9 1.9 19.1 0l246.5-77v45.7zm0 33.5v30.5l-20.8 6.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l11.2-3.5V400L288 480 32 400V288.8l11.2 3.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L32 255.2V224.8l241.7 75.5c9.3 2.9 19.3 2.9 28.6 0L544 224.8zm-427.2 57c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"]
};
var faToiletPaper = {
  prefix: 'fal',
  iconName: 'toilet-paper',
  icon: [640, 512, [129531], "f71e", "M16 479c.2-5.3 1.7-10.6 4.5-15.4l0-.1c2.6-4.6 5-9.4 7.3-14.3C63.6 372.8 64 272.2 64 192C64 86 107 0 160 0H464h32c40.7 0 69 32.2 85.2 64.6C598.3 98.8 608 143.9 608 192s-9.7 93.2-26.8 127.4C565 351.8 536.7 384 496 384c-24.1 0-43.8-11.3-59.3-27.2c2.1-14.2 4.1-29.6 5.7-46c14.2 25.6 33 41.2 53.6 41.2c44.2 0 80-71.6 80-160s-35.8-160-80-160s-80 71.6-80 160c0 44.7-2.2 83.7-5.6 117.7c-.3 2.5-.5 4.9-.8 7.4c-9 82.3-25.6 133.1-36.3 158.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2c-2.9-5.2-4.3-11-4.2-16.8zM160 32c-7.9 0-23.6 7.2-39.3 38.5C106 100 96 142.9 96 192c0 42.4-.1 92.6-5.8 142.2c-5.7 49.5-17.3 100.7-41.6 144.8c-.2 .3-.4 .6-.5 .9l0 0H317.9c11.4 0 21.6-6.1 25.9-16.3C357.3 431 384 347.1 384 192c0-48.1 9.7-93.2 26.8-127.4c5.7-11.3 12.8-22.6 21.5-32.6H160zM496 240c6.4 0 11.9-11.3 14.5-27.6c1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16c-5.1-6.4-8.2-13.8-10.3-20c-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20c4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20c4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20c-4.8 6.1-15.1 16-31.4 16zM128 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faHelmetSafety = {
  prefix: 'fal',
  iconName: 'helmet-safety',
  icon: [576, 512, ["hard-hat", "hat-hard"], "f807", "M240 80V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16zm-64-1.3v34.7C109.9 143.7 64 210.5 64 288v32H32V288c0-95.5 59.8-177.1 144-209.3zm224 34.7V78.7c83.5 31.9 143 112.4 144 206.9l0 2.4 0 32H512l0-34.3c-.9-76.5-46.5-142.3-112-172.3zM537.3 384H38.7c-3.7 0-6.7 3-6.7 6.7c0 .4 0 .7 .1 1C58.5 408.5 136.6 448 288 448s229.5-39.5 255.9-56.3c0-.2 .1-.6 .1-1c0-3.7-3-6.7-6.7-6.7zM38.7 352H537.3c21.4 0 38.7 17.3 38.7 38.7c0 11-4.7 21.4-13.9 27.3C531.3 437.9 447.1 480 288 480s-243.3-42.1-274.1-61.9C4.7 412.1 0 401.7 0 390.7C0 369.3 17.3 352 38.7 352z"]
};
var faHardHat = faHelmetSafety;
var faHatHard = faHelmetSafety;
var faCommentCode = {
  prefix: 'fal',
  iconName: 'comment-code',
  icon: [512, 512, [], "e147", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM219.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 240l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L345.4 240l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"]
};
var faSimCards = {
  prefix: 'fal',
  iconName: 'sim-cards',
  icon: [448, 512, [], "e251", "M112 368c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V154.5c0-8.5-3.4-16.6-9.4-22.6L316.1 41.4c-6-6-14.1-9.4-22.6-9.4H144c-17.7 0-32 14.3-32 32V368zM80 64c0-35.3 28.7-64 64-64H293.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V368c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V64zM16 96c8.8 0 16 7.2 16 16V384c0 53 43 96 96 96H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 512 0 454.7 0 384V112c0-8.8 7.2-16 16-16zm160 96v16h48V176H192c-8.8 0-16 7.2-16 16zm120 16h56V192c0-8.8-7.2-16-16-16H296 256v32h40zm0 32H240 176v32h56 40 80V240H296zm-8 64v32h48c8.8 0 16-7.2 16-16V304H288zm-56 0H176v16c0 8.8 7.2 16 16 16h40 24V304H232zM192 144h48 56 40c26.5 0 48 21.5 48 48v32 64 32c0 26.5-21.5 48-48 48H272 232 192c-26.5 0-48-21.5-48-48V288 224 192c0-26.5 21.5-48 48-48z"]
};
var faStarship = {
  prefix: 'fal',
  iconName: 'starship',
  icon: [640, 512, [], "e039", "M0 112C0 85.5 21.5 64 48 64H208c26.5 0 48 21.5 48 48s-21.5 48-48 48H161.2l47.6 34.6 60.1-8.2C296.8 114.8 366.5 64 448 64c106 0 192 86 192 192s-86 192-192 192c-81.5 0-151.2-50.8-179-122.4l-60.1-8.2L161.2 352H208c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48s21.5-48 48-48h58.8L163 311.1l-21.5-2.9C115.5 304.6 96 282.3 96 256s19.5-48.6 45.5-52.2l21.5-2.9L106.8 160H48c-26.5 0-48-21.5-48-48zM48 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm97.9 139.5C135.6 236.9 128 245.7 128 256s7.6 19.1 17.9 20.5l113.5 15.5c-2.2-11.6-3.4-23.7-3.4-35.9s1.2-24.3 3.4-35.9L145.9 235.5zM32 400c0 8.8 7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm416 16a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm32-160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faEject = {
  prefix: 'fal',
  iconName: 'eject',
  icon: [448, 512, [9167], "f052", "M224 96c-4.5 0-8.8 1.9-11.8 5.2l-176 192c-4.3 4.7-5.4 11.4-2.9 17.3s8.3 9.6 14.6 9.6H400c6.3 0 12.1-3.7 14.6-9.6s1.4-12.6-2.9-17.3l-176-192c-3-3.3-7.3-5.2-11.8-5.2zm0-32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 352 400 352H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 69.6 210.5 64 224 64zM16 416H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleRight = {
  prefix: 'fal',
  iconName: 'circle-right',
  icon: [512, 512, [61838, "arrow-alt-circle-right"], "f35a", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm400 0c0-9.2-3.5-18-9.7-24.7l-84-91c-7.2-7.8-17.4-12.3-28.1-12.3c-21.1 0-38.3 17.1-38.3 38.3l0 25.7-80 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l80 0 0 25.7c0 21.1 17.1 38.3 38.3 38.3c10.7 0 20.9-4.5 28.1-12.3l84-91c6.2-6.7 9.7-15.6 9.7-24.7zm-33.2-3c.8 .8 1.2 1.9 1.2 3s-.4 2.2-1.2 3l-84 91c-1.2 1.3-2.9 2-4.6 2c-3.5 0-6.3-2.8-6.3-6.3l0-41.7c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l96 0c8.8 0 16-7.2 16-16l0-41.7c0-3.5 2.8-6.3 6.3-6.3c1.7 0 3.4 .7 4.6 2l84 91z"]
};
var faArrowAltCircleRight = faCircleRight;
var faPlaneCircleCheck = {
  prefix: 'fal',
  iconName: 'plane-circle-check',
  icon: [640, 512, [], "e555", "M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2l0 0L256 480.6l105.7 30.2 0 0c2.7 .8 5.5 1.2 8.2 1.2c6.5 0 12.5-2 17.4-5.5c-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8V290.6c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faSeal = {
  prefix: 'fal',
  iconName: 'seal',
  icon: [512, 512, [], "e241", "M199.1 86.6c-6 6-14.1 9.4-22.6 9.4H112c-8.8 0-16 7.2-16 16v64.5c0 8.5-3.4 16.6-9.4 22.6L41 244.7c-6.2 6.2-6.2 16.4 0 22.6L18.4 289.9c-18.7-18.7-18.7-49.1 0-67.9L64 176.5V112c0-26.5 21.5-48 48-48h64.5l45.6-45.6c18.7-18.7 49.1-18.7 67.9 0L335.5 64H400c26.5 0 48 21.5 48 48v64.5l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.5V400c0 26.5-21.5 48-48 48H335.5l-45.6 45.6c-18.7 18.7-49.1 18.7-67.9 0L176.5 448H112c-26.5 0-48-21.5-48-48V335.5L18.4 289.9 41 267.3l45.6 45.6c6 6 9.4 14.1 9.4 22.6V400c0 8.8 7.2 16 16 16h64.5c8.5 0 16.6 3.4 22.6 9.4L244.7 471c6.2 6.2 16.4 6.2 22.6 0l45.6-45.6c6-6 14.1-9.4 22.6-9.4H400c8.8 0 16-7.2 16-16V335.5c0-8.5 3.4-16.6 9.4-22.6L471 267.3c6.2-6.2 6.2-16.4 0-22.6l-45.6-45.6c-6-6-9.4-14.1-9.4-22.6V112c0-8.8-7.2-16-16-16H335.5c-8.5 0-16.6-3.4-22.6-9.4L267.3 41c-6.2-6.2-16.4-6.2-22.6 0L199.1 86.6z"]
};
var faUserCowboy = {
  prefix: 'fal',
  iconName: 'user-cowboy',
  icon: [448, 512, [], "f8ea", "M176.1 32c4.8 0 7.3 .6 8.5 1c1 .3 1.9 .8 3.6 1.8c.1 .1 .4 .3 .7 .5l0 0C192.3 37.9 205.8 48 224 48s31.7-10.1 35.1-12.7c.3-.3 .6-.4 .7-.5c1.6-1.1 2.5-1.5 3.6-1.8c1.1-.4 3.6-1 8.5-1c.6 .2 3 1.2 7 5.7c5.8 6.6 12 17.3 18.1 31.9c6.5 15.4 11.9 33 16.3 50.1c-25 5-54.6 8.3-89.3 8.3s-64.4-3.2-89.3-8.3c4.4-17.1 9.8-34.7 16.3-50.1c6.1-14.6 12.4-25.3 18.1-31.9c4-4.6 6.3-5.6 7-5.7zm168.3 80C330.8 59.3 307.6 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1s-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-35.6 0-58.8 59.3-72.4 112c-7.1-2.2-13.7-4.5-19.8-6.9c-32.4-12.7-49.4-27.2-55-34.7c-4.7-6.3-13.3-8.2-20.2-4.6S-1.7 77.6 .8 85.1c9.3 27.9 35 62.4 72.5 89.9c38 27.7 89.2 49.1 150.6 49.1s112.7-21.4 150.6-49.1c37.6-27.4 63.2-62 72.5-89.9c2.5-7.4-.8-15.6-7.8-19.2s-15.5-1.7-20.2 4.6c-5.6 7.5-22.6 22-55 34.7c-6.1 2.4-12.7 4.7-19.8 6.9zM271.7 32a.1 .1 0 1 0 .1 .1 .1 .1 0 1 0 -.1-.1zm-95.6 0a.1 .1 0 1 0 .3 .1 .1 .1 0 1 0 -.3-.1zM92.2 149.1c-5.5-4-10.7-8.2-15.5-12.4C112.4 149.9 160.9 160 224 160s111.6-10.1 147.3-23.4c-4.8 4.2-10 8.4-15.5 12.4C322.5 173.4 277.8 192 224 192s-98.5-18.6-131.8-42.9zM100.7 416H347.3c32.3 0 59.5 24 63.5 56.1l1 7.9H36.2l1-7.9c4-32 31.2-56.1 63.5-56.1zm0-32c-48.4 0-89.3 36.1-95.3 84.1l-1 7.9C2.1 495.1 17 512 36.2 512H411.8c19.2 0 34.1-16.9 31.8-36l-1-7.9c-6-48-46.8-84.1-95.3-84.1H100.7zM224 352c70 0 126.9-56.2 128-126c-10.5 5.2-21.6 10-33.3 14.1C311 285.4 271.5 320 224 320s-87-34.6-94.7-79.9C117.7 236 106.5 231.3 96 226c1.1 69.8 58 126 128 126z"]
};
var faHexagonVerticalNft = {
  prefix: 'fal',
  iconName: 'hexagon-vertical-nft',
  icon: [448, 512, [], "e505", "M255.8 496.6c-19.8 11.4-44.2 11.4-64 0L32 404.3C12.2 392.9 0 371.7 0 348.9V164.3c0-22.9 12.2-44 32-55.4L191.8 16.6c19.8-11.4 44.2-11.4 64 0l159.8 92.3c19.8 11.4 32 32.6 32 55.4V348.9c0 22.9-12.2 44-32 55.4L255.8 496.6zm-48-27.7c9.9 5.7 22.1 5.7 32 0l159.8-92.3c9.9-5.7 16-16.3 16-27.7V164.3c0-11.4-6.1-22-16-27.7L239.8 44.3c-9.9-5.7-22.1-5.7-32 0L48 136.6c-9.9 5.7-16 16.3-16 27.7l0 184.6c0 11.4 6.1 22 16 27.7l159.8 92.3zM94.7 170.6l33.1 82.9V176.6c0-8.8 7.2-16 16-16s16 7.2 16 16v160c0 7.7-5.4 14.3-13 15.7s-15-2.6-17.9-9.8L95.8 259.7v76.9c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.7 5.4-14.3 13-15.7s15 2.6 17.9 9.8zm97.1 5.9c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80-80zm112-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v144c0 8.8-7.2 16-16 16s-16-7.2-16-16v-144h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFaceRollingEyes = {
  prefix: 'fal',
  iconName: 'face-rolling-eyes',
  icon: [512, 512, [128580, "meh-rolling-eyes"], "f5a5", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32-96c26.5 0 48-21.5 48-48c0-14.3-6.3-27.2-16.2-36c.2 1.3 .2 2.6 .2 4c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.4 .1-2.7 .2-4c-10 8.8-16.2 21.7-16.2 36c0 26.5 21.5 48 48 48zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80c0-14.3-6.3-27.2-16.2-36c.2 1.3 .2 2.6 .2 4c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.4 .1-2.7 .2-4c-10 8.8-16.2 21.7-16.2 36c0 26.5 21.5 48 48 48s48-21.5 48-48zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faMehRollingEyes = faFaceRollingEyes;
var faBreadLoaf = {
  prefix: 'fal',
  iconName: 'bread-loaf',
  icon: [640, 512, [127838], "f7eb", "M64 224c-17.7 0-32-14.3-32-32c0-45.8 30.4-77.3 77.4-98.9C156.4 71.4 211.6 64 240 64s83.6 7.4 130.6 29.1c47 21.7 77.4 53.1 77.4 98.9c0 17.7-14.3 32-32 32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H320 112c-8.8 0-16-7.2-16-16V256c0-17.7-14.3-32-32-32zm352 32H544V432c0 8.8-7.2 16-16 16H413.3c1.8-5 2.7-10.4 2.7-16V288 256zm155.3-31.7c-1.1-.2-2.2-.3-3.3-.3H471.4c5.4-9.4 8.6-20.3 8.6-32c0-64-44-104-96-128h16c28.4 0 83.6 7.4 130.6 29.1c47 21.7 77.4 53.1 77.4 98.9c0 17.7-14.3 32-32 32c-1.6 0-3.2 .1-4.7 .3zM112 480H320h48H528c26.5 0 48-21.5 48-48V288 256c35.3 0 64-28.7 64-64C640 64 464 32 400 32H272 240C176 32 0 64 0 192c0 35.3 28.7 64 64 64v32V432c0 26.5 21.5 48 48 48z"]
};
var faRingsWedding = {
  prefix: 'fal',
  iconName: 'rings-wedding',
  icon: [512, 512, [], "f81b", "M137.9 32l-8 16 24 48H176h22.1l24-48-8-16H137.9zM254.3 55.2l-24.6 49.2C300.6 127.1 352 193.5 352 272c0 64.4-34.5 120.7-86.1 151.3c-8.6-6.9-16.1-15-22.4-24.1C289 375 320 327.1 320 272c0-27.5-7.7-53.3-21.1-75.2C237.3 213.2 192 269.3 192 336c0 27.5 7.7 53.3 21.1 75.2c6 9.8 13.2 18.8 21.3 26.9c0 0 0 0 0 0C260.5 464 296.4 480 336 480c79.5 0 144-64.5 144-144c0-67.9-47-124.9-110.3-140c-4.9-12.4-10.9-24.2-17.9-35.3C441.6 168.7 512 244.1 512 336c0 97.2-78.8 176-176 176c-55.3 0-104.7-25.5-137-65.5c-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272c0-78.5 51.4-144.9 122.3-167.7L97.7 55.2c-2.3-4.5-2.3-9.8 0-14.3l16-32C116.4 3.4 121.9 0 128 0h96c6.1 0 11.6 3.4 14.3 8.8l16 32c2.3 4.5 2.3 9.8 0 14.3zM179.2 416c-12.3-24-19.2-51.2-19.2-80c0-76.7 49.1-142 117.6-166.1C251.5 144 215.6 128 176 128C96.5 128 32 192.5 32 272s64.5 144 144 144c1.1 0 2.1 0 3.2 0z"]
};
var faObjectGroup = {
  prefix: 'fal',
  iconName: 'object-group',
  icon: [576, 512, [], "f247", "M64 125.3C45.4 118.7 32 100.9 32 80c0-26.5 21.5-48 48-48c20.9 0 38.7 13.4 45.3 32H450.7c6.6-18.6 24.4-32 45.3-32c26.5 0 48 21.5 48 48c0 20.9-13.4 38.7-32 45.3V386.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32H125.3c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V125.3zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3V386.7c13.6 4.8 24.4 15.6 29.3 29.3H450.7c4.8-13.6 15.6-24.4 29.3-29.3V125.3c-13.6-4.8-24.4-15.6-29.3-29.3H125.3zM496 416a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM496 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 80A16 16 0 1 0 64 80a16 16 0 1 0 32 0zm80 48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48zm-16 48v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm192 64c0-8.8 7.2-16 16-16h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16s16 7.2 16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16-7.2-16-16z"]
};
var faFrenchFries = {
  prefix: 'fal',
  iconName: 'french-fries',
  icon: [384, 512, [127839], "f803", "M151.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3V266.4c-8.5 2.4-19 4.3-32 5.1V57.9l-32-16V271.5c-13-.9-23.5-2.7-32-5.1V16c0-5.5 2.9-10.7 7.6-13.6zM279.1 233.8c-1 4-2.9 9-7.1 14.1V208.6L299.1 84.5 272 89.9V57.3l44.9-9c5.3-1.1 10.8 .6 14.6 4.5s5.4 9.4 4.2 14.6l-28.4 130c-15.5 8-24.9 23.6-28 36.4zM362.6 192H332.5l19.8-99.1c1.7-8.7 10.2-14.3 18.8-12.6s14.3 10.2 12.6 18.8l-18.6 92.9c-.8 0-1.7-.1-2.5-.1zM21.4 192c-.9 0-1.7 0-2.5 .1L.3 99.1C-1.4 90.5 4.2 82 12.9 80.3s17.1 3.9 18.8 12.6L51.5 192H21.4zm98.8 63.6c-10.3-7.4-13.9-15.8-15.4-21.7c-3-12.1-11.4-26.5-25.2-34.9L56.2 58.6c-1.2-6.9 2.3-13.8 8.6-16.9L112 18.1V53.9L89.7 65l31.9 191.5c-.5-.3-1-.7-1.4-1zM89.2 480H294.8l54.3-224h-9.8c-5.3 16.4-16.3 35.8-38.2 51.6C276.4 325.3 241.1 336 192 336s-84.4-10.7-109.1-28.4C61 291.8 50 272.4 44.7 256H34.9L89.2 480zm-31.1 7.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224H54.3c9.5 0 17.2 8.3 19.5 17.5C79.6 265 102.7 304 192 304s112.4-39 118.2-62.5c2.3-9.2 10-17.5 19.5-17.5h32.9c11.8 0 21.4 9.6 21.4 21.4c0 1.7-.2 3.4-.6 5.1l-57.5 237c-3.5 14.4-16.3 24.5-31.1 24.5H89.2c-14.8 0-27.6-10.1-31.1-24.5z"]
};
var faChartLine = {
  prefix: 'fal',
  iconName: 'chart-line',
  icon: [512, 512, ["line-chart"], "f201", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM475.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0l144-144z"]
};
var faLineChart = faChartLine;
var faCalendarArrowDown = {
  prefix: 'fal',
  iconName: 'calendar-arrow-down',
  icon: [448, 512, ["calendar-download"], "e0d0", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM240 256c0-8.8-7.2-16-16-16s-16 7.2-16 16V377.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 377.4V256z"]
};
var faCalendarDownload = faCalendarArrowDown;
var faSendBack = {
  prefix: 'fal',
  iconName: 'send-back',
  icon: [640, 512, [], "f87e", "M192 32c17.7 0 32 14.3 32 32V192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192zM64 0C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM576 288c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32H576zM448 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H448zM160 288v64c0 35.3 28.7 64 64 64H352V384H224c-17.7 0-32-14.3-32-32V288H160zM416 96H288v32H416c17.7 0 32 14.3 32 32v64h32V160c0-35.3-28.7-64-64-64zM152 96c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V104c0-4.4 3.6-8 8-8h48zM104 64c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V104c0-22.1-17.9-40-40-40H104zM488 352h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H488c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V360c0-22.1-17.9-40-40-40H488c-22.1 0-40 17.9-40 40z"]
};
var faMaskVentilator = {
  prefix: 'fal',
  iconName: 'mask-ventilator',
  icon: [640, 512, [], "e524", "M160 300.8c0 44.6 21.7 85.6 56.9 112.9c-5.7-13.6-8.9-28.6-8.9-44.3c0-30.2 11.8-69.3 30.3-100.8c9.3-15.9 20.8-30.7 34.2-41.7c13.4-11 29.5-18.8 47.5-18.8c18 0 34 7.9 47.3 18.8s24.8 25.8 34.2 41.7C420 300 432 339.1 432 369.3c0 15.6-3.1 30.4-8.8 43.9C458.1 386 480 345.4 480 300.8c0-42-19.2-103.3-51.6-154.3C395 93.9 355.3 64 320 64c-35.8 0-75.5 30-108.7 82.4C179 197.4 160 258.8 160 300.8zm80 68.5c0 26.6 12.5 50.1 32 64.9v40.2c-51.6-12.3-94.5-43.9-119.7-86L83.5 370.3C34.3 357.4 0 312.9 0 262V176c0-26.5 21.5-48 48-48H185.1C219.8 73.8 267.4 32 320 32c52.1 0 99.7 41.8 134.5 96H592c26.5 0 48 21.5 48 48v86c0 50.9-34.3 95.4-83.5 108.3l-69 18.2C462.1 430.6 419 462 368 474.3V434c19.3-14.7 32-38 32-64.7c0-23.3-9.8-56.8-26.1-84.6c-8.1-13.7-17.3-25.3-26.9-33.2s-18.7-11.5-27-11.5c-8.4 0-17.6 3.6-27.2 11.5c-9.6 7.9-18.8 19.4-26.9 33.2C249.7 312.4 240 346 240 369.3zm264.4-18.4l43.9-11.6c35.1-9.2 59.6-41 59.6-77.4V176c0-8.8-7.2-16-16-16H472.9C497.4 207.8 512 260.3 512 300.8c0 17.4-2.7 34.3-7.6 50.1zM166.8 160H48c-8.8 0-16 7.2-16 16v86c0 36.3 24.5 68.1 59.6 77.4l43.9 11.6c-4.9-15.9-7.5-32.7-7.5-50.1c0-40.5 14.4-93 38.8-140.8zM304 320c0-8.8 7.2-16 16-16s16 7.2 16 16V512H304V320z"]
};
var faSignatureLock = {
  prefix: 'fal',
  iconName: 'signature-lock',
  icon: [640, 512, [], "e3ca", "M64 128c0-35.3 28.7-64 64-64s64 28.7 64 64v3.4c0 26.2-2.4 52.3-7.2 78L59 243.7c-34.8 9.5-59 41.1-59 77.2v92.6C0 450.2 29.8 480 66.5 480c24 0 46.2-13 57.9-33.9L151.5 398c20.9-37.1 37.2-76.5 48.5-117.5l7.2-25.7c1.8-6.5 3.5-13 5-19.6l125.5-34.2-48 96c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h88.6c5.6-9.7 13.7-17.8 23.4-23.4V288H329.9l52.4-104.8c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3L218.8 200.1c3.4-22.7 5.2-45.7 5.2-68.7V128c0-53-43-96-96-96s-96 43-96 96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V128zM240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H384V384H240zM67.4 274.6l109.4-29.8-.4 1.4-7.2 25.7c-10.7 38.5-26 75.6-45.6 110.4L96.5 430.4C90.4 441.3 78.9 448 66.5 448c-19 0-34.5-15.4-34.5-34.5V320.9c0-21.6 14.5-40.6 35.4-46.3zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm160 80V480H448V352H608z"]
};
var faArrowRight = {
  prefix: 'fal',
  iconName: 'arrow-right',
  icon: [448, 512, [8594], "f061", "M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0L244.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176z"]
};
var faSignsPost = {
  prefix: 'fal',
  iconName: 'signs-post',
  icon: [512, 512, ["map-signs"], "f277", "M240 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32H440.3c4.9 0 9.5 2.2 12.5 6L504 102c4.7 5.8 4.7 14.1 0 20l-51.2 64c-3 3.8-7.6 6-12.5 6H272v32H448c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H71.7c-4.9 0-9.5-2.2-12.5-6L8 314c-4.7-5.8-4.7-14.1 0-20l51.2-64c3-3.8 7.6-6 12.5-6H240V192H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H240V16zM432.6 64H64v96H432.6L471 112 432.6 64zM79.4 256L41 304l38.4 48H448V256H79.4z"]
};
var faMapSigns = faSignsPost;
var faOctagonPlus = {
  prefix: 'fal',
  iconName: 'octagon-plus',
  icon: [512, 512, ["plus-octagon"], "f301", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM240 352V272H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faPlusOctagon = faOctagonPlus;
var faCashRegister = {
  prefix: 'fal',
  iconName: 'cash-register',
  icon: [512, 512, [], "f788", "M272 32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H272zM80 0C53.5 0 32 21.5 32 48V80c0 26.5 21.5 48 48 48h80v32H87.5c-31.8 0-58.9 23.4-63.4 54.9L.6 379.5c-.4 3-.6 6-.6 9V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V388.5c0-3-.2-6.1-.6-9L487.8 214.9c-4.5-31.5-31.5-54.9-63.4-54.9H192V128h80c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H80zM32 448V416H480v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM456.2 219.5L479.7 384H32.3L55.8 219.5C58.1 203.7 71.6 192 87.5 192h337c15.9 0 29.4 11.7 31.7 27.5zM112 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faPersonCircleQuestion = {
  prefix: 'fal',
  iconName: 'person-circle-question',
  icon: [576, 512, [], "e542", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64-86.4c0-23 18.6-41.6 41.6-41.6h40.5c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6l-23.7 12.5c-1.4 7.4-7.9 12.9-15.7 12.9c-8.8 0-16-7.2-16-16v-6.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9H409.6c-5.3 0-9.6 4.3-9.6 9.6V336c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.4z"]
};
var faMelonSlice = {
  prefix: 'fal',
  iconName: 'melon-slice',
  icon: [512, 512, [], "e311", "M427.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L322.6 86.8c-3.6 3.6-5.2 8.6-4.5 13.6c1.3 9 2 18.2 2 27.6c0 106-86 192-192 192c-9.4 0-18.6-.7-27.6-2c-5-.7-10 1-13.6 4.5L4.7 404.7c-6.2 6.2-6.2 16.4 0 22.6C58.9 481.5 132.5 512 209.1 512h4C378.2 512 512 378.2 512 213.2v-4c0-76.7-30.5-150.2-84.7-204.5zM391 63.7L415.6 39C457 85.8 480 146.3 480 209.1v4C480 360.5 360.5 480 213.2 480h-4C146.3 480 85.8 457 39 415.6L63.7 391c40.8 35.5 94 57 152.3 57c128.1 0 232-103.9 232-232c0-58.3-21.5-111.6-57-152.3zM368.3 86.3C398 121.3 416 166.5 416 216c0 110.5-89.5 200-200 200c-49.5 0-94.7-18-129.7-47.7l17.6-17.6c7.9 .8 16 1.3 24.1 1.3c123.7 0 224-100.3 224-224c0-8.1-.4-16.2-1.3-24.1l17.6-17.6z"]
};
var faSpaceStationMoon = {
  prefix: 'fal',
  iconName: 'space-station-moon',
  icon: [512, 512, [], "e033", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 14.8-1.4 29.3-4.2 43.3c-2.1 .7-4.2 1.5-6.5 2.3C433 314.7 369.9 337.4 256 337.4s-177-22.7-213.3-35.8l0 0c-2.3-.8-4.4-1.6-6.5-2.3c-2.7-14-4.2-28.5-4.2-43.3zM256 369.4c104.8 0 169.6-18.7 208.8-32.3C432.3 420.8 351.1 480 256 480s-176.3-59.2-208.8-142.8c39.2 13.6 104 32.3 208.8 32.3zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM136 160a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faMessageSmile = {
  prefix: 'fal',
  iconName: 'message-smile',
  icon: [512, 512, ["comment-alt-smile"], "f4aa", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM192 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM155.9 252.1c-6.6 5.9-7.1 16-1.3 22.6C179.5 302.5 215.7 320 256 320s76.5-17.5 101.4-45.3c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3C314.5 274.6 286.8 288 256 288s-58.5-13.4-77.5-34.7c-5.9-6.6-16-7.1-22.6-1.3z"]
};
var faCommentAltSmile = faMessageSmile;
var faCupStraw = {
  prefix: 'fal',
  iconName: 'cup-straw',
  icon: [384, 512, [129380], "e363", "M249 0c-22 0-41.2 15-46.6 36.4L179.5 128H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H191.7c.2 0 .5 0 .7 0H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H212.5l21-83.9C235.2 37 241.6 32 249 32h23c8.8 0 16-7.2 16-16s-7.2-16-16-16H249zM37.3 192l23 276c2.1 24.9 22.9 44 47.8 44H275.8c25 0 45.8-19.1 47.8-44l23-276H314.6L291.8 465.3c-.7 8.3-7.6 14.7-15.9 14.7H108.2c-8.3 0-15.3-6.4-15.9-14.7L69.4 192H37.3z"]
};
var faLeftFromLine = {
  prefix: 'fal',
  iconName: 'left-from-line',
  icon: [448, 512, ["arrow-alt-from-right"], "f348", "M32.8 257.8c-.5-.5-.8-1.1-.8-1.8s.3-1.4 .8-1.8L164.7 129.8c1.2-1.2 2.9-1.8 4.6-1.8c3.7 0 6.7 3 6.7 6.7l0 57.3c0 8.8 7.2 16 16 16l120 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-120 0c-8.8 0-16 7.2-16 16l0 57.3c0 3.7-3 6.7-6.7 6.7c-1.7 0-3.3-.6-4.6-1.8L32.8 257.8zM0 256c0 9.5 3.9 18.6 10.8 25.1L142.8 405.5c7.2 6.8 16.7 10.5 26.5 10.5c21.4 0 38.7-17.3 38.7-38.7l0-41.3 104 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-104 0 0-41.3c0-21.4-17.3-38.7-38.7-38.7c-9.9 0-19.3 3.8-26.5 10.5L10.8 230.9C3.9 237.4 0 246.5 0 256zM448 432l0-352c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faArrowAltFromRight = faLeftFromLine;
var faH = {
  prefix: 'fal',
  iconName: 'h',
  icon: [384, 512, [104], "48", "M352 256l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V224L32 224 32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208 320 0z"]
};
var faBasketShoppingSimple = {
  prefix: 'fal',
  iconName: 'basket-shopping-simple',
  icon: [576, 512, ["shopping-basket-alt"], "e0af", "M322.2 24.1c-4.5-7.6-1.9-17.4 5.8-21.9s17.4-1.9 21.9 5.8L457.2 192H511h33 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H536L476.1 463.5C469 492 443.4 512 414 512H162c-29.4 0-55-20-62.1-48.5L40 224H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32 65h53.8L226.2 7.9c4.5-7.6 14.2-10.2 21.9-5.8s10.2 14.2 5.8 21.9L155.9 192H420.1l-98-167.9zM503 224H73l57.9 231.8c3.6 14.2 16.4 24.2 31 24.2H414c14.7 0 27.5-10 31-24.2L503 224zM144 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faShoppingBasketAlt = faBasketShoppingSimple;
var faHandsHoldingHeart = {
  prefix: 'fal',
  iconName: 'hands-holding-heart',
  icon: [640, 512, ["hands-heart"], "f4c3", "M216 76.6c0 10.8 4.3 21.1 11.9 28.7L320 197.4l92.1-92.1c7.6-7.6 11.9-17.9 11.9-28.7C424 54.2 405.8 36 383.4 36c-10.8 0-21.1 4.3-28.7 11.9L331.3 71.3c-6.2 6.2-16.4 6.2-22.6 0L285.3 47.9C277.6 40.3 267.3 36 256.6 36C234.2 36 216 54.2 216 76.6zM256.6 4c19.2 0 37.7 7.6 51.3 21.3L320 37.4l12.1-12.1C345.7 11.6 364.2 4 383.4 4C423.5 4 456 36.5 456 76.6c0 19.2-7.6 37.7-21.3 51.3L331.3 231.3c-6.2 6.2-16.4 6.2-22.6 0L205.3 127.9C191.6 114.3 184 95.8 184 76.6C184 36.5 216.5 4 256.6 4zM64 64c35.3 0 64 28.7 64 64V252.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64V344.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V252.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 0 0 44-44 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.9c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16 0 0-44-44 0 0-10.7-10.8C106.8 305.4 96 279.4 96 252.3V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V344.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2V128C0 92.7 28.7 64 64 64z"]
};
var faHandsHeart = faHandsHoldingHeart;
var faClockNine = {
  prefix: 'fal',
  iconName: 'clock-nine',
  icon: [512, 512, [], "e34c", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V256c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTarp = {
  prefix: 'fal',
  iconName: 'tarp',
  icon: [576, 512, [], "e57b", "M32 384l0-256c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32V256H432c-26.5 0-48 21.5-48 48l0 112L64 416c-17.7 0-32-14.3-32-32zm391.4 27.3c-2.1 2.1-4.6 3.5-7.4 4.2L416 304c0-8.8 7.2-16 16-16H543.5c-.7 2.8-2.1 5.4-4.2 7.4L423.4 411.3zM576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l348.1 0c12.7 0 24.9-5.1 33.9-14.1L561.9 318.1c9-9 14.1-21.2 14.1-33.9V128zM96 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFaceSleepy = {
  prefix: 'fal',
  iconName: 'face-sleepy',
  icon: [512, 512, [], "e38e", "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c31.9 0 62.2-6.7 89.6-18.6c8.1-3.5 17.5 .2 21.1 8.3s-.2 17.5-8.3 21.1C327 504.4 292.4 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 23.6-3.2 46.5-9.2 68.3c-2.4 8.5-11.2 13.5-19.7 11.2s-13.5-11.2-11.2-19.7c5.2-19 8.1-39 8.1-59.7C480 132.3 379.7 32 256 32zm64.3 285c1.4-7.5 8-13 15.7-13c27.8 0 70.8 13.3 106.7 36.6C478.5 363.7 512 399.9 512 448c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-16.2-.1-39.4-7.2-61.5c-6.9-21.5-20.2-41.1-46.7-51.7c-7.1-2.8-11.2-10.3-9.8-17.9zm76 34.8c4.7 8.1 8.3 16.5 11 25c8.8 27.2 8.8 54.9 8.8 70.8v.5c0 17.7 14.3 32 32 32s32-14.3 32-32c0-31.9-22.5-59.7-54.7-80.6c-9.4-6.1-19.3-11.3-29.1-15.7zm-87.3 78c-16.2-6.1-34-9.4-52.9-9.4c-18.8 0-36.7 3.4-52.9 9.4c-11.2 4.2-23.6 2.3-32.4-4.5c-4.5-3.5-8.4-8.6-10-15.1c-1.6-6.7-.5-13.5 2.7-19.5C180.9 358 215.9 336 256 336c40.1 0 75.2 22.1 92.5 54.7c3.2 6 4.3 12.8 2.7 19.5c-1.6 6.5-5.5 11.6-10 15.1c-8.8 6.8-21.2 8.7-32.4 4.5zM256 368c-24.9 0-46.7 12.1-59.6 30.2c18.5-6.4 38.6-9.8 59.6-9.8c21 0 41.1 3.5 59.6 9.9C302.7 380 280.9 368 256 368zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2z"]
};
var faHandHorns = {
  prefix: 'fal',
  iconName: 'hand-horns',
  icon: [384, 512, [], "e1a9", "M88 32c13.3 0 24 10.7 24 24V200v40H80c-5.5 0-10.8 .6-16 1.6V56c0-13.3 10.7-24 24-24zm56 117.4V56c0-30.9-25.1-56-56-56S32 25.1 32 56V256C12.6 270.6 0 293.8 0 320v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V240 120c0-30.9-25.1-56-56-56s-56 25.1-56 56v61.4c-7.3-3.5-15.4-5.4-24-5.4c-9.7 0-18.8 2.5-26.7 6.8C214 160.3 192.9 144 168 144c-8.6 0-16.7 1.9-24 5.4zm0 50.6c0-13.3 10.7-24 24-24s24 10.7 24 24v31.9c0 0 0 0 0 .1v13.4c-7.3-3.5-15.4-5.4-24-5.4H144V200zm80 72V232c0-13.2 10.8-24 24-24c13.3 0 24 10.7 24 24v8 56c0 13.3-10.7 24-24 24s-24-10.7-24-24v0l0-24zm-112 0v0h32v0h24c13.2 0 24 10.7 24 24v0c0 13.3-10.7 24-24 24H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56V240v-8V120c0-13.3 10.7-24 24-24s24 10.7 24 24V240 352c0 70.7-57.3 128-128 128H160C89.3 480 32 422.7 32 352V320c0-26.5 21.5-48 48-48h32z"]
};
var faScrewdriverWrench = {
  prefix: 'fal',
  iconName: 'screwdriver-wrench',
  icon: [512, 512, ["tools"], "f7d9", "M64.7 34.6L160 107.9V160H107.9L34.6 64.7 64.7 34.6zM192 169.3c0-.4 0-.9 0-1.3V104c0-7.5-3.5-14.5-9.4-19L78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h64c.4 0 .9 0 1.3 0L271.2 293.9c-19.5 30-16.2 70.5 10.1 96.8l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-26.3-26.3-66.8-29.7-96.8-10.1L192 169.3zM304 304c17.7-17.7 46.3-17.7 64 0L480 416l-64 64L304 368c-17.7-17.7-17.7-46.3 0-64zM104 424a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM23.2 376.8C8.3 391.7 0 411.8 0 432.8C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2L238.5 385.5c-5.7-11.2-9.3-23.1-10.9-35.3L112.1 465.7c-8.7 8.7-20.6 13.6-32.9 13.6c-25.7 0-46.6-20.8-46.6-46.6c0-12.3 4.9-24.2 13.6-32.9L189.1 257l-23.1-23.1L23.2 376.8zM479.4 160c0 44.8-23.1 84.1-58 106.8l23.5 23.5c40.7-29 67.2-76.6 67.2-130.3c0-24.8-5.7-48.3-15.7-69.3c-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7H368c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0C296.1 0 246.9 28.6 218.3 72.1l26 20C266.8 56.3 306.7 32.6 352 32.6c10.3 0 20.2 1.2 29.7 3.5L333.6 84.2c-9.1 9.1-14.2 21.5-14.2 34.4V144c0 26.9 21.8 48.6 48.6 48.6h25.4c12.9 0 25.3-5.1 34.4-14.2l48.1-48.1c2.3 9.5 3.5 19.5 3.5 29.7z"]
};
var faTools = faScrewdriverWrench;
var faArrowsToEye = {
  prefix: 'fal',
  iconName: 'arrows-to-eye',
  icon: [640, 512, [], "e4bf", "M43.3 20.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L105.4 128H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.4L43.3 20.7zm553.4 0L512 105.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H534.6l84.7-84.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM320 368c-77.3 0-132.6-65-156.7-112c24.1-47 79.4-112 156.7-112s132.6 65 156.7 112C452.6 303 397.3 368 320 368zm0-256c-97.3 0-161.4 81.6-186.5 131.9c-3.8 7.6-3.8 16.5 0 24.2C158.6 318.4 222.7 400 320 400s161.4-81.6 186.5-131.9c3.8-7.6 3.8-16.5 0-24.2C481.4 193.6 417.3 112 320 112zM596.7 491.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L534.6 384H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H496c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V406.6l84.7 84.7zm-576-22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L128 406.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L20.7 468.7zM272 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faCircleThreeQuarters = {
  prefix: 'fal',
  iconName: 'circle-three-quarters',
  icon: [512, 512, [], "e125", "M256 288c-17.7 0-32-14.3-32-32V34.3C115.5 49.8 32 143.2 32 256c0 123.7 100.3 224 224 224c112.8 0 206.2-83.5 221.7-192H256zM224.1 2C241.6-.2 256 14.3 256 32V224v32h32H480c17.7 0 32.2 14.4 30 31.9C494.3 414.2 386.6 512 256 512C114.6 512 0 397.4 0 256C0 125.4 97.8 17.7 224.1 2z"]
};
var faTrophyStar = {
  prefix: 'fal',
  iconName: 'trophy-star',
  icon: [576, 512, ["trophy-alt"], "f2eb", "M400 32H176c-9 0-15.4 7.3-15.1 15c6.2 163.9 44.9 239.2 76.1 273.5c15.5 17.1 29.9 24.8 39.3 28.3c4.8 1.8 8.5 2.6 10.6 3c.5 .1 .9 .1 1.2 .2c.3 0 .7-.1 1.2-.2c2.1-.3 5.8-1.1 10.6-3c9.4-3.5 23.8-11.3 39.3-28.3c31.2-34.2 69.8-109.6 76.1-273.5c.3-7.8-6.2-15-15.1-15zM176 0H400c26.5 0 48.1 21.8 47.1 48.2c-.2 5.3-.4 10.6-.7 15.8H528c26 0 49.3 21.6 46.2 49.7c-10.1 94-61.9 158.2-118.1 199.9c-55.9 41.4-117.1 61.3-149.3 66.9l-.1-.3c-.9 .3-1.8 .6-2.7 .8V480h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 176c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V381.1c-.9-.3-1.8-.5-2.7-.8l-.1 .3c-32.2-5.7-93.4-25.5-149.3-66.9C63.7 272 11.9 207.7 1.8 113.7C-1.3 85.6 22 64 48 64h81.6c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zM377.8 323.2c19.2-9.1 39.6-20.7 59.2-35.3c51.1-37.9 96.4-94.8 105.4-177.6c.8-7-5.1-14.3-14.4-14.3H444.2c-9.8 116.5-37.2 185.9-66.4 227.2zM131.8 96H48c-9.3 0-15.2 7.3-14.4 14.3C42.5 193.2 87.9 250.1 139 287.9c19.6 14.6 40 26.2 59.2 35.3C169 281.9 141.5 212.5 131.8 96zm177.8-.5L322.1 121l28.2 4.1c19.7 2.9 27.5 27.1 13.3 40.9l-20.4 19.9 4.8 28.1c3.4 19.6-17.2 34.6-34.8 25.3L288 226.1l-25.2 13.3c-17.6 9.3-38.2-5.7-34.8-25.3l4.8-28.1-20.4-19.9c-14.2-13.9-6.4-38.1 13.3-40.9l28.2-4.1 12.6-25.6c8.8-17.8 34.2-17.8 43 0zm-28.8 43.5c-3.5 7.1-10.3 12-18.1 13.1l-16.3 2.4L258.1 166c5.7 5.5 8.2 13.5 6.9 21.2l-2.8 16.3 14.6-7.7c7-3.7 15.3-3.7 22.3 0l14.6 7.7L311 187.2c-1.3-7.8 1.2-15.7 6.9-21.2l11.8-11.5-16.3-2.4c-7.8-1.1-14.6-6-18.1-13.1L288 124.2l-7.3 14.8z"]
};
var faTrophyAlt = faTrophyStar;
var faPlugCircleBolt = {
  prefix: 'fal',
  iconName: 'plug-circle-bolt',
  icon: [576, 512, [], "e55b", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-96.1-81c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H452.4l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
var faFaceThermometer = {
  prefix: 'fal',
  iconName: 'face-thermometer',
  icon: [576, 512, [], "e39a", "M288 32C164.3 32 64 132.3 64 256s100.3 224 224 224c95.3 0 176.7-59.5 209.1-143.4c3.2-8.2 12.4-12.4 20.7-9.2s12.4 12.4 9.2 20.7C490 444 396.9 512 288 512C146.6 512 32 397.4 32 256S146.6 0 288 0c83.8 0 158.1 40.2 204.8 102.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2C426.3 67.2 361.3 32 288 32zM402.5 396.1c-6.7 5.8-16.8 5.1-22.6-1.6C362 373.8 331.4 352 288 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5c13.5 0 26 1.7 37.5 4.6L477 179.4c19.6-18.8 50.6-18.4 69.8 .7c19.8 19.8 19.4 52.1-.9 71.4L408 382.9c.3 4.8-1.5 9.8-5.5 13.2zm-43.9-58.9c11.3 5.9 21.1 13 29.6 20.3l8.4-8-5.1-5.1c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0L414 333l15.4-14.7-5.8-5.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l6.3 6.3 15.4-14.7-6.6-6.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7 7 15.4-14.7-7.4-7.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7.8 7.8 11.5-11c7.3-6.9 7.4-18.5 .3-25.6c-6.9-6.9-18-7-25-.3L358.5 337.2zM208.4 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faGridRound4 = {
  prefix: 'fal',
  iconName: 'grid-round-4',
  icon: [448, 512, [], "e5dd", "M44.8 56a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 76.8a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 76.8zm44.8 98.7a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM65.6 315.7a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM44.8 270.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM185.1 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm65.6 119.5a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM304.5 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm65.6 119.5a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM424 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM424 315.7a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z"]
};
var faShirtRunning = {
  prefix: 'fal',
  iconName: 'shirt-running',
  icon: [384, 512, [], "e3c8", "M80 0c8.8 0 16 7.2 16 16V64c0 53 43 96 96 96s96-43 96-96V16c0-8.8 7.2-16 16-16s16 7.2 16 16c0 134.3 29.3 192.6 45.6 214.6c8.9 12 18.4 28.6 18.4 47.6V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V278.2c0-19 9.5-35.7 18.4-47.6C34.7 208.6 64 150.3 64 16C64 7.2 71.2 0 80 0zM44.1 249.6c-7.6 10.2-12.1 20-12.1 28.6V396.3L310.6 195l1.4-1c-5.5-15.9-10.5-34.9-14.6-57.5C274.4 170 235.8 192 192 192s-82.4-22-105.5-55.5c-10.7 59.8-28.4 94.1-42.4 113.1zM32 435.7V456c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24V278.2c0-8.6-4.6-18.4-12.1-28.6c-4.8-6.5-10-14.7-15.2-25.2L41.4 429 32 435.7z"]
};
var faBookCircleArrowUp = {
  prefix: 'fal',
  iconName: 'book-circle-arrow-up',
  icon: [640, 512, [], "e0bd", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H394.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H326.6c-2.9-10.3-4.9-21-5.9-32H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16V211.2c10.1-5.2 20.8-9.4 32-12.6V48c0-26.5-21.5-48-48-48H64zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-211.3 3.3c6.2 6.2 16.4 6.2 22.6 0L480 342.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V342.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0l-56 56c-6.2 6.2-6.2 16.4 0 22.6z"]
};
var faFaceNauseated = {
  prefix: 'fal',
  iconName: 'face-nauseated',
  icon: [512, 512, [], "e381", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM203.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zM175.6 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm160 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-26.9-60.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM146.2 272.6c4.4-7.6 14.2-10.3 21.9-5.8c19.5 11.3 33.8 30.5 38.4 53.3h99.2c4.6-22.8 18.9-42 38.4-53.3c7.7-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6c7.6 4.4 10.3 14.2 5.8 21.9s-14.2 10.3-21.9 5.8c-19.5-11.3-33.8-30.5-38.4-53.3H206.4c-4.6 22.8-18.9 42-38.4 53.3c-7.6 4.4-17.4 1.8-21.9-5.8s-1.8-17.4 5.8-21.9c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9z"]
};
var faHeart = {
  prefix: 'fal',
  iconName: 'heart',
  icon: [512, 512, [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578], "f004", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2L443 275.5c23.6-22 37-52.8 37-85.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zm34.9-57.1C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 36-13.1 70.6-36.6 97.5c-3.4 3.8-6.9 7.5-10.7 11l-184 171.3c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5z"]
};
var faFileChartPie = {
  prefix: 'fal',
  iconName: 'file-chart-pie',
  icon: [384, 512, [], "f65a", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM176 224v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16c0-61.9-50.1-112-112-112c-8.8 0-16 7.2-16 16zm32 17.6c31.3 6.4 56 31.1 62.4 62.4H208V241.6zm-56-21C105.7 234.4 72 277.3 72 328c0 61.9 50.1 112 112 112c50.7 0 93.6-33.7 107.4-80h-34c-12.3 28.3-40.5 48-73.3 48c-44.2 0-80-35.8-80-80c0-32.8 19.7-61 48-73.3v-34z"]
};
var faMarsAndVenus = {
  prefix: 'fal',
  iconName: 'mars-and-venus',
  icon: [512, 512, [9893], "f224", "M352 16c0 8.8 7.2 16 16 16h73.4l-75.6 75.6C337.1 80.6 298.5 64 256 64C167.6 64 96 135.6 96 224c0 83 63.1 151.2 144 159.2V416H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V383.2c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L464 54.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
var faHouseUser = {
  prefix: 'fal',
  iconName: 'house-user',
  icon: [576, 512, ["home-user"], "e1b0", "M277.4 4c6-5.3 15.1-5.3 21.2 0l272 240c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM96 206.7V432c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM208 392v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-39.8 32.2-72 72-72h80c39.8 0 72 32.2 72 72v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-22.1-17.9-40-40-40H248c-22.1 0-40 17.9-40 40z"]
};
var faHomeUser = faHouseUser;
var faCircleArrowDownLeft = {
  prefix: 'fal',
  iconName: 'circle-arrow-down-left',
  icon: [512, 512, [], "e0f9", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm56-160H176c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16V297.4L324.7 164.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L214.6 320H312c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faDumpsterFire = {
  prefix: 'fal',
  iconName: 'dumpster-fire',
  icon: [640, 512, [], "f794", "M423.4 32c.2 0 .4 0 .6 0h95c14.7 0 27.5 10 31 24.2l18.5 74c-10.5-5.9-22.7-7.5-34.2-4.7L519 64l-76 0 6.1 32.3c-10.7-1.3-21.8 1.2-31.2 7.3L410.4 64 304 64v96h58c-8.8 10.6-17 21.3-24.5 32H288l-159.7 0h-.6H66 33.8 28.5C12.8 192 0 179.2 0 163.5c0-2.3 .3-4.7 .9-6.9L25.9 56.2C29.5 42 42.3 32 57 32h94.7c.2 0 .4 0 .6 0H288l0 0 0 0H423.4zM337.6 448H96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V448.9L45.1 288H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H41.3l-3.8-32H69.8L92.3 416H314.4c6.6 11.4 14.4 22.2 23.2 32zM272 64L165.3 64l-18 96H272V64zM132.7 64L57 64 33 160H47.8h.4 66.5l18-96zM509.4 221.5c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1c-18.3 29.6-27.6 57.9-27.6 75.8C352 390.5 408.2 448 480 448c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zm-21.8-56.4c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 408 568.7 480 480 480c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zM445.1 224c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0C521.3 410 502.3 416 481 416c-25.9 0-50.2-8.4-68.2-24.8C394.7 374.6 384 350.7 384 322c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L507 319l-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.4-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6C445.7 377.9 461.9 384 481 384c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5z"]
};
var faHexagonMinus = {
  prefix: 'fal',
  iconName: 'hexagon-minus',
  icon: [512, 512, ["minus-hexagon"], "f307", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM160 240H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMinusHexagon = faHexagonMinus;
var faLeftToLine = {
  prefix: 'fal',
  iconName: 'left-to-line',
  icon: [448, 512, ["arrow-alt-to-left"], "f34b", "M32 432L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16zm96.8-174.2c-.5-.5-.8-1.1-.8-1.8s.3-1.4 .8-1.8L260.7 129.8c1.2-1.2 2.9-1.8 4.6-1.8c3.7 0 6.7 3 6.7 6.7l0 57.3c0 8.8 7.2 16 16 16l120 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-120 0c-8.8 0-16 7.2-16 16l0 57.3c0 3.7-3 6.7-6.7 6.7c-1.7 0-3.3-.6-4.6-1.8L128.8 257.8zM96 256c0 9.5 3.9 18.6 10.8 25.1L238.8 405.5c7.2 6.8 16.7 10.5 26.5 10.5c21.4 0 38.7-17.3 38.7-38.7l0-41.3 104 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-104 0 0-41.3c0-21.4-17.3-38.7-38.7-38.7c-9.9 0-19.3 3.8-26.5 10.5L106.8 230.9C99.9 237.4 96 246.5 96 256z"]
};
var faArrowAltToLeft = faLeftToLine;
var faHouseCrack = {
  prefix: 'fal',
  iconName: 'house-crack',
  icon: [576, 512, [], "e3b1", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H312.6l-50.4-75.6 82.7-55.1c4-2.7 6.6-7 7-11.7s-1.2-9.5-4.6-12.9l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l82.2 82.2-79.8 53.2c-7.4 4.9-9.3 14.8-4.4 22.2L274.1 480H144c-26.5 0-48-21.5-48-48z"]
};
var faPawSimple = {
  prefix: 'fal',
  iconName: 'paw-simple',
  icon: [448, 512, ["paw-alt"], "f701", "M152 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm31.2 73.2c7.7-15.5 23.5-25.2 40.8-25.2s33.1 9.8 40.8 25.2l33.8 67.5c8.3 16.5 23.1 25.9 36.8 30c28.1 8.4 48.6 34.4 48.6 65.2c0 37.6-30.4 68-68 68c-14.4 0-27.7-4.5-38.7-12.1c-16-11.1-36.5-14.7-53.3-14.7s-37.3 3.6-53.3 14.7c-11 7.6-24.3 12.1-38.7 12.1c-37.6 0-68-30.4-68-68c0-30.8 20.4-56.8 48.6-65.2c13.7-4.1 28.6-13.5 36.8-30l33.8-67.5zm-62.4 53.2c-3.4 6.9-10 11.5-17.3 13.7C62.1 296.4 32 334.7 32 380c0 55.2 44.8 100 100 100c21.2 0 40.8-6.6 56.9-17.8c17.4-12 52.8-12 70.1 0C275.2 473.4 294.8 480 316 480c55.2 0 100-44.8 100-100c0-45.3-30.1-83.6-71.4-95.9c-7.4-2.2-13.9-6.8-17.3-13.7l-33.8-67.5c-13.2-26.3-40-42.9-69.5-42.9s-56.3 16.6-69.5 42.9l-33.8 67.5zM272 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 240 88a56 56 0 1 0 112 0zm40 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM32 200a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 0 200a56 56 0 1 0 112 0z"]
};
var faPawAlt = faPawSimple;
var faArrowLeftLongToLine = {
  prefix: 'fal',
  iconName: 'arrow-left-long-to-line',
  icon: [640, 512, [], "e3d4", "M0 80V432c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16S0 71.2 0 80zM132.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L182.6 272 624 272c8.8 0 16-7.2 16-16s-7.2-16-16-16l-441.4 0L299.3 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144z"]
};
var faBracketsRound = {
  prefix: 'fal',
  iconName: 'brackets-round',
  icon: [512, 512, ["parentheses"], "e0c5", "M151.6 62.1C111.5 83.8 32 153.4 32 256s79.5 172.2 119.6 193.9c7.8 4.2 10.7 13.9 6.4 21.7s-13.9 10.7-21.7 6.4C91.2 453.6 0 375.3 0 256S91.2 58.4 136.4 33.9c7.8-4.2 17.5-1.3 21.7 6.4s1.3 17.5-6.4 21.7zm208.8 0c-7.8-4.2-10.7-13.9-6.4-21.7s13.9-10.7 21.7-6.4C420.8 58.4 512 136.7 512 256s-91.2 197.6-136.4 222.1c-7.8 4.2-17.5 1.3-21.7-6.4s-1.3-17.5 6.4-21.7C400.5 428.2 480 358.6 480 256s-79.5-172.2-119.6-193.9z"]
};
var faParentheses = faBracketsRound;
var faMartiniGlassCitrus = {
  prefix: 'fal',
  iconName: 'martini-glass-citrus',
  icon: [576, 512, ["cocktail"], "f561", "M432 256c-21.7 0-42-6.2-59.2-16.9l-23.1 23.1C373 278.5 401.4 288 432 288c79.5 0 144-64.5 144-144S511.5 0 432 0C369.3 0 316 40.1 296.2 96h34.6c18-37.8 56.5-64 101.2-64c61.9 0 112 50.1 112 112s-50.1 112-112 112zM16 128c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4L192 342.6V480H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96 96c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V342.6L411.3 155.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H16zm345.4 32L208 313.4 54.6 160H361.4z"]
};
var faCocktail = faMartiniGlassCitrus;
var faUserShakespeare = {
  prefix: 'fal',
  iconName: 'user-shakespeare',
  icon: [448, 512, [], "e2c2", "M304 160V112c0-44.2-35.8-80-80-80s-80 35.8-80 80v48c0 40.1 29.5 73.3 68 79.1V224c0-6.6 5.4-12 12-12s12 5.4 12 12v15.1c38.5-5.8 68-39 68-79.1zM114.1 90.5C124.1 38.9 169.5 0 224 0s99.9 38.9 109.9 90.5c11 8.8 18.1 22.3 18.1 37.5v9.5c0 9.5 2.8 18.7 8.1 26.6l16.7 25.1c4.7 7.1 7.2 15.4 7.2 23.8c0 23.7-19.2 43-43 43H281.7c-16.9 10.2-36.6 16-57.7 16s-40.9-5.8-57.7-16H107c-23.7 0-43-19.2-43-43c0-8.5 2.5-16.8 7.2-23.8l16.7-25.1c5.3-7.9 8.1-17.1 8.1-26.6V128c0-15.2 7.1-28.7 18.1-37.5zm219.7 91.9c-3.1 15.2-9.3 29.3-17.8 41.7H341c6.1 0 11-4.9 11-11c0-2.2-.6-4.3-1.8-6.1l-16.4-24.6zM132.1 224c-8.6-12.3-14.8-26.4-17.8-41.7L97.8 206.9c-1.2 1.8-1.8 3.9-1.8 6.1c0 6.1 4.9 11 11 11h25.1zM176 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5c4.7-4.7 12.3-4.7 17 0zM0 481.3c0-69.5 44-128.8 105.7-151.4c13.6-24.9 40-41.8 70.3-41.8h48 48c30.4 0 56.8 16.9 70.3 41.8C404 352.5 448 411.8 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3zM176 320c-26.5 0-48 21.5-48 48v3.6c1.6-.8 3.3-1.5 5.1-2.3c17.6-7.6 42.5-15 74.9-16.9V320H176zm64 32.5c32.5 1.9 57.3 9.3 74.9 16.9c1.8 .8 3.5 1.5 5.1 2.3V368c0-26.5-21.5-48-48-48H240v32.5zM224 384c-35.8 0-61.6 7.5-78.2 14.7c-8.3 3.6-14.4 7.1-18.2 9.7c-1.9 1.3-3.3 2.3-4.1 2.9c-.4 .3-.7 .5-.8 .7l-.1 .1c-4.7 4.1-11.4 5.2-17.1 2.6C99.7 412 96 406.3 96 400V369.7C58.1 391.9 32.5 432.9 32 480l176 0c0-8.8 7.2-16 16-16s16 7.2 16 16l176 0c-.5-47.1-26-88.1-64-110.3V400c0 6.3-3.7 12-9.5 14.6c-5.7 2.6-12.4 1.5-17.1-2.6l0 0 0 0-.1-.1-.3-.2-.6-.4c-.8-.6-2.2-1.6-4.1-2.9c-3.8-2.5-9.9-6.1-18.2-9.7C285.6 391.5 259.8 384 224 384zm-16 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faArrowRightToArc = {
  prefix: 'fal',
  iconName: 'arrow-right-to-arc',
  icon: [512, 512, [], "e4b2", "M480 256C480 132.3 379.7 32 256 32c-8.8 0-16-7.2-16-16s7.2-16 16-16C397.4 0 512 114.6 512 256s-114.6 256-256 256c-8.8 0-16-7.2-16-16s7.2-16 16-16c123.7 0 224-100.3 224-224zM202.6 116l144 128c3.4 3 5.4 7.4 5.4 12s-2 8.9-5.4 12l-144 128c-6.6 5.9-16.7 5.3-22.6-1.3s-5.3-16.7 1.3-22.6L293.9 272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H293.9L181.4 140c-6.6-5.9-7.2-16-1.3-22.6s16-7.2 22.6-1.3z"]
};
var faFaceSurprise = {
  prefix: 'fal',
  iconName: 'face-surprise',
  icon: [512, 512, [128558, "surprise"], "f5c2", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
var faSurprise = faFaceSurprise;
var faBottleWater = {
  prefix: 'fal',
  iconName: 'bottle-water',
  icon: [320, 512, [], "e4c5", "M128 96h2.7 58.6H192V32H128V96zm-32 6.3V96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V96v6.3c6.4 2.4 12.6 5.5 18.4 9.2l13.6 8.6c20 12.7 32.1 34.8 32.1 58.5c0 10.9-2.5 21.2-7 30.4c4.5 9.4 7 19.9 7 31c0 11.5-2.7 22.3-7.5 32c4.8 9.7 7.5 20.5 7.5 32s-2.7 22.3-7.5 32c4.8 9.7 7.5 20.5 7.5 32c0 13.1-3.5 25.4-9.6 36c6.1 10.6 9.6 22.9 9.6 36c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-13.1 3.5-25.4 9.6-36c-6.1-10.6-9.6-22.9-9.6-36c0-11.5 2.7-22.3 7.5-32c-4.8-9.7-7.5-20.5-7.5-32s2.7-22.3 7.5-32c-4.8-9.7-7.5-20.5-7.5-32c0-11.1 2.5-21.6 7-31c-4.5-9.2-7-19.5-7-30.4c0-23.7 12.1-45.8 32.1-58.5l13.6-8.6c5.8-3.7 12-6.8 18.4-9.2zM130.7 128c-12.7 0-25.1 3.6-35.9 10.5l-13.6 8.6C70.5 154 64 165.8 64 178.6c0 8.6 2.9 16.5 7.7 22.8c3.2 4.2 3.3 10.5 .2 14.7c-5 6.7-7.9 14.9-7.9 23.9c0 9.3 3.1 17.8 8.4 24.6c3.3 4.2 3.3 10.7 0 14.9C67.1 286.2 64 294.7 64 304s3.1 17.8 8.4 24.6c3.3 4.2 3.3 10.7 0 14.9C67.1 350.2 64 358.7 64 368c0 9.9 3.6 19 9.6 26c4.3 5.1 4.3 14.9 0 20c-6 7-9.6 16.1-9.6 26c0 22.1 17.9 40 40 40H216c22.1 0 40-17.9 40-40c0-9.9-3.6-19-9.6-26c-4.3-5.1-4.3-14.9 0-20c6-7 9.6-16.1 9.6-26c0-9.3-3.1-17.8-8.4-24.6c-3.3-4.2-3.3-10.7 0-14.9c5.3-6.8 8.4-15.3 8.4-24.6s-3.1-17.8-8.4-24.6c-3.3-4.2-3.3-10.7 0-14.9c5.3-6.8 8.4-15.3 8.4-24.6c0-8.9-2.9-17.2-7.9-23.9c-3.1-4.2-3-10.6 .2-14.7c4.8-6.3 7.7-14.2 7.7-22.8c0-12.8-6.5-24.7-17.3-31.5l-13.6-8.6C214.5 131.6 202 128 189.3 128H130.7zM96 240c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm16 112h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCirclePause = {
  prefix: 'fal',
  iconName: 'circle-pause',
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-80V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPauseCircle = faCirclePause;
var faGaugeCirclePlus = {
  prefix: 'fal',
  iconName: 'gauge-circle-plus',
  icon: [640, 512, [], "e498", "M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194c0-8.8 7.2-16 16-16s16 7.2 16 16l0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H512v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFolders = {
  prefix: 'fal',
  iconName: 'folders',
  icon: [576, 512, [], "f660", "M512 352H160c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H277.5c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c18 18 42.4 28.1 67.9 28.1H512c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32zM349.3 77.3L322.7 50.7c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faAngel = {
  prefix: 'fal',
  iconName: 'angel',
  icon: [576, 512, [], "f779", "M384 64.2c0 .1-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6s0-.1 0-.2s0-.1 0-.2s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6s0 .1 0 .2s0 .1 0 .2zM288 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM45.3 480C38 480 32 474 32 466.7c0-2.1 .5-4.1 1.4-5.9l39.8-79.7c4.4-8.9 6.8-18.7 6.8-28.6v-.9c0-9.9-2.3-19.7-6.8-28.6L54.9 286.2c-4.5-9-6.9-19.1-6.9-29.3c0-35.8 29-64.9 64.2-64.9c17 0 33.3 6.8 45.4 18.8l67 67c-12 9.3-22.1 21.4-29.1 35.5L112 480H45.3zM253.8 261.8l-73.6-73.6c-18-18-42.5-28.2-68-28.2C59.1 160 16 203.8 16 256.9c0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3H96h35.8H444.2 480h50.7c25 0 45.3-20.3 45.3-45.3c0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3v-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9c-25.5 0-50 10.1-68 28.2l-73.6 73.6C311.4 258 299.8 256 288 256s-23.4 2-34.2 5.8zm97.7 15.9l67-67c12-12 28.4-18.8 45.4-18.8c35.1 0 64.2 29.1 64.2 64.9c0 10.2-2.4 20.3-6.9 29.3l-18.4 36.7c-4.4 8.9-6.8 18.7-6.8 28.6v.9c0 9.9 2.3 19.7 6.8 28.6l39.8 79.7c.9 1.8 1.4 3.9 1.4 5.9c0 7.3-6 13.3-13.3 13.3H464L380.6 313.2c-7.1-14.1-17.1-26.2-29.1-35.5zm.5 49.8L428.2 480H147.8L224 327.6c12.1-24.2 36.9-39.6 64-39.6s51.9 15.3 64 39.6z"]
};
var faValueAbsolute = {
  prefix: 'fal',
  iconName: 'value-absolute',
  icon: [512, 512, [], "f6a6", "M16 32C7.2 32 0 39.2 0 48V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zM171.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256l-84.7 84.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l84.7-84.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-84.7-84.7zM512 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48z"]
};
var faRabbit = {
  prefix: 'fal',
  iconName: 'rabbit',
  icon: [512, 512, [128007], "f708", "M324.1 20.8c6.5 9.4 12.1 19.2 16.9 29.5c3.5-4.4 7.2-8.6 11.2-12.6l3.1-3.1c1.7-1.7 4-2.6 6.4-2.6c4.5 0 8.3 3.3 8.9 7.7l.7 4.9c3.3 22.7 1.2 45.6-5.6 66.8c-12.9-4.8-26.7-7.4-40.7-7.5c-6.3-33.2-22.5-64.4-47.4-89l-3.1-3.1L263.3 23.3l11.3-11.4C266.9 4.3 256.5 0 245.7 0C225.3 0 208 15 205.1 35.2l-.7 4.9c-7.6 53 8.6 106.2 43.6 145.9v37.6c-62.8 17.5-113.6 63.7-137.4 123.6C99.5 340.1 86.2 336 72 336c-39.8 0-72 32.2-72 72s32.2 72 72 72c12.4 0 24.1-3.1 34.3-8.7c13.7 24.2 39.6 40.5 69.3 40.7l.3 0 .1 0H304c26.5 0 48-21.5 48-48c0-25.9-20.5-47-46.2-48l21-22.2 55.9 94.6c13.5 22.8 42.9 30.4 65.7 16.9s30.4-42.9 16.9-65.7L380.5 296h7.3c42.1 0 76.3-34.1 76.3-76.3c0-22.9-10.3-44.6-28.1-59.1L399 130.5c-1.5-1.2-3.1-2.5-4.7-3.6c9.8-27.4 13-57.1 8.7-86.8l-.7-4.9C399.4 15 382.1 0 361.7 0c-10.8 0-21.2 4.3-28.9 11.9L329.7 15c-1.9 1.9-3.8 3.9-5.6 5.8zM96.4 439.7C89.6 444.9 81.2 448 72 448c-22.1 0-40-17.9-40-40s17.9-40 40-40c11.2 0 21.4 4.6 28.6 12.1c-3 14.2-4.6 28.9-4.6 43.9v8c0 2.6 .1 5.2 .4 7.7zm140.4-400c.6-4.4 4.4-7.7 8.9-7.7c2.4 0 4.7 .9 6.3 2.6l3.1 3.1c23.4 23.2 37.3 53.5 40.3 85.2c.4 4.6 2.8 8.7 6.5 11.4s8.4 3.7 12.9 2.7c3.1-.7 6.3-1 9.6-1c19.8 0 39 6.8 54.3 19.3l36.9 30.1c10.3 8.4 16.3 21 16.3 34.3c0 24.4-19.8 44.3-44.3 44.3H352.4c-5.7 0-11 3.1-13.9 8.1s-2.8 11.1 .1 16.1l99.1 167.7c4.5 7.6 2 17.4-5.6 21.9s-17.4 2-21.9-5.6L343.6 359.3c-2.6-4.3-7-7.2-12-7.8s-10 1.3-13.4 4.9L257 421c-4.4 4.6-5.6 11.5-3.1 17.3s8.3 9.7 14.7 9.7H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176h0l-.2 0c-26.4-.1-47.8-21.6-47.8-48v-8c0-84.6 59.7-155.3 139.3-172.2c7.4-1.6 12.7-8.1 12.7-15.7V180.4l0-.4c0-4.1-1.5-8.1-4.4-11.2c-31.3-33.1-46-78.8-39.5-124.2l.7-4.9zM352 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faToiletPaperSlash = {
  prefix: 'fal',
  iconName: 'toilet-paper-slash',
  icon: [640, 512, [], "e072", "M581.2 319.4C598.3 285.2 608 240.1 608 192s-9.7-93.2-26.8-127.4C565 32.2 536.7 0 496 0H464 160c-14.1 0-27.5 6.1-39.5 17l25.7 20.3c5.6-4 10.4-5.3 13.8-5.3H432.3c-8.6 9.9-15.8 21.2-21.5 32.6C393.7 98.8 384 143.9 384 192c0 11.3-.1 22.1-.4 32.7l31.2 24.6c.8-18 1.2-37 1.2-57.3c0-88.4 35.8-160 80-160s80 71.6 80 160c0 65.6-19.7 122-48 146.7l25.4 20c11.5-11.3 20.8-25.3 27.8-39.3zM368.6 375.9c-8.3 43.2-18.1 71.7-24.8 87.8c-4.3 10.3-14.5 16.3-25.9 16.3H48l0 0c.2-.3 .4-.6 .5-.9c24.4-44.1 35.9-95.4 41.6-144.8C95.9 284.6 96 234.4 96 192c0-10.4 .4-20.5 1.3-30.3L67.8 138.4c-2.5 17-3.8 35-3.8 53.6c0 80.2-.4 180.8-36.2 257.3c-2.3 4.9-4.7 9.6-7.3 14.3l0 .1c-2.8 4.7-4.3 10-4.5 15.4c-.2 5.8 1.2 11.6 4.2 16.8C25.8 505.8 36.5 512 48 512H317.9c22.3 0 45.4-12.1 55.4-36.1c6.6-15.9 15.5-41.4 23.4-77.9l-28.1-22.2zM481.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM527.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faCircleEuro = {
  prefix: 'fal',
  iconName: 'circle-euro',
  icon: [512, 512, [], "e5ce", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128 16h24.2c-.7-5-1-10.1-1-15.2c0-5.7 .4-11.3 1.2-16.8H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h34.2c18.2-37.9 56.9-64 101.7-64H305c8.8 0 16 7.2 16 16s-7.2 16-16 16H263.9c-26.3 0-49.6 12.6-64.4 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H184.9c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H198.4c14.7 20.3 38.5 33.5 65.5 33.5H305c8.8 0 16 7.2 16 16s-7.2 16-16 16H263.9c-45.4 0-84.5-26.8-102.4-65.5H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faAppleWhole = {
  prefix: 'fal',
  iconName: 'apple-whole',
  icon: [448, 512, [127822, 127823, "apple-alt"], "f5d1", "M228.6 96H224V91.4C224 58.6 250.6 32 283.4 32H288v4.6C288 69.4 261.4 96 228.6 96zm-18.3 32h18.3c50.5 0 91.4-40.9 91.4-91.4V18.3C320 8.2 311.8 0 301.7 0H283.4C232.9 0 192 40.9 192 91.4v18.3c0 10.1 8.2 18.3 18.3 18.3zM32 288c0-33.8 8-67.7 22.8-92c14.2-23.5 33-36 57.2-36c21 0 48.7 8.4 71.1 17.1c26.2 10.2 55.6 10.2 81.9 0C287.3 168.4 315 160 336 160c24.3 0 43 12.5 57.2 36C408 220.3 416 254.2 416 288c0 57.5-18 106.6-43.6 140.8C346.4 463.5 315 480 288 480c-13.2 0-32-2.7-45.3-5c-12.3-2.2-25-2.2-37.3 0c-13.3 2.3-32.1 5-45.3 5c-27 0-58.4-16.5-84.4-51.2C50 394.6 32 345.5 32 288zM160 512c16.2 0 37.4-3.2 50.8-5.5c8.7-1.5 17.6-1.5 26.3 0c13.5 2.4 34.6 5.5 50.8 5.5c80 0 160-96 160-224c0-76.3-35.7-160-112-160c-27.3 0-59.7 10.3-82.7 19.3c-18.8 7.3-39.9 7.3-58.7 0C171.7 138.3 139.3 128 112 128C35.7 128 0 211.7 0 288C0 416 80 512 160 512z"]
};
var faAppleAlt = faAppleWhole;
var faKitchenSet = {
  prefix: 'fal',
  iconName: 'kitchen-set',
  icon: [576, 512, [], "e51a", "M144 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm143.1-96c-8 72-69 128-143.1 128C64.5 288 0 223.5 0 144S64.5 0 144 0c74.1 0 135.2 56 143.1 128h67.6c6.6-18.6 24.4-32 45.3-32h96c26.5 0 48 21.5 48 48s-21.5 48-48 48H400c-20.9 0-38.7-13.4-45.3-32H287.1zM272 320h16 32V288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v32h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V352H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm80 0h96V288H352v32zm-32 32V464c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V352H320zM496 128H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zM192 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 144a80 80 0 1 1 160 0A80 80 0 1 1 64 144zM0 496c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM160 352v32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zm0-32h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16h80 16 16zm-32 64V352H64v64h64V384z"]
};
var faDiamondHalf = {
  prefix: 'fal',
  iconName: 'diamond-half',
  icon: [512, 512, [], "e5b7", "M227.7 11.7C235.5 3.9 245.8 0 256 0V32 480v32c-10.2 0-20.5-3.9-28.3-11.7l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM224 451.3V60.7L34.3 250.3c-3.1 3.1-3.1 8.2 0 11.3L224 451.3z"]
};
var faLockKeyhole = {
  prefix: 'fal',
  iconName: 'lock-keyhole',
  icon: [448, 512, ["lock-alt"], "f30d", "M224 32c53 0 96 43 96 96v64H128V128c0-53 43-96 96-96zM96 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM80 224H368c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm160 88c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V312z"]
};
var faLockAlt = faLockKeyhole;
var faR = {
  prefix: 'fal',
  iconName: 'r',
  icon: [320, 512, [114], "52", "M48 32C21.5 32 0 53.5 0 80V272 464c0 8.8 7.2 16 16 16s16-7.2 16-16V288H167.4L290.7 472.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L205.4 287.3C269.8 280.6 320 226.2 320 160c0-70.7-57.3-128-128-128H48zM176 256H32V80c0-8.8 7.2-16 16-16H192c53 0 96 43 96 96s-43 96-96 96H176z"]
};
var faTemperatureQuarter = {
  prefix: 'fal',
  iconName: 'temperature-quarter',
  icon: [320, 512, ["temperature-1", "thermometer-1", "thermometer-quarter"], "f2ca", "M160 32c-35.3 0-64 28.7-64 64V252.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96V252.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V272c0-8.8 7.2-16 16-16s16 7.2 16 16v34c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z"]
};
var faTemperature1 = faTemperatureQuarter;
var faThermometer1 = faTemperatureQuarter;
var faThermometerQuarter = faTemperatureQuarter;
var faSquareInfo = {
  prefix: 'fal',
  iconName: 'square-info',
  icon: [448, 512, [8505, "info-square"], "f30f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm200 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-16 64h40c8.8 0 16 7.2 16 16V352h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V256H184c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faInfoSquare = faSquareInfo;
var faWifiSlash = {
  prefix: 'fal',
  iconName: 'wifi-slash',
  icon: [640, 512, [], "f6ac", "M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5s-15.5 8.1-22.5 2.6L6.1 28.6C-.8 23.1-2 13 3.4 6.1zm394.7 230l-54.7-43.2c70 5.6 133 36.3 179.9 83.1c6.3 6.2 6.3 16.4 0 22.6s-16.4 6.3-22.6 0c-28.4-28.3-63.5-50-102.6-62.5zM208.5 249.5c-25.8 12.5-49.1 29.2-69.2 49.2c-6.3 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c19-18.9 40.6-35.2 64.2-48.3l27.6 21.8zM201.7 81.1L171.5 57.2C218 40.9 267.9 32 320 32c122.9 0 234.3 49.5 315.3 129.7c6.3 6.2 6.3 16.3 .1 22.6s-16.3 6.3-22.6 .1C537.6 110 434.2 64 320 64c-41.1 0-80.8 6-118.3 17.1zM48.8 123.4l26 20.5C57.9 156.2 42 169.8 27.3 184.4c-6.3 6.2-16.4 6.2-22.6-.1s-6.2-16.4 .1-22.6c13.8-13.7 28.5-26.5 44-38.3zM268.1 453.5a64 64 0 1 1 103.7-75 64 64 0 1 1 -103.7 75zM352 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faToiletPaperXmark = {
  prefix: 'fal',
  iconName: 'toilet-paper-xmark',
  icon: [512, 512, [], "e5b3", "M32 192c0-46.5 10.3-87.7 26.2-116.8C74.4 45.5 94.1 32 112 32H337.3c-7.2 8.2-13.6 17.7-19.2 27.9C299.2 94.5 288 141.2 288 192s11.2 97.5 30.1 132.1c5.6 10.2 12 19.6 19.2 27.9H112c-17.9 0-37.6-13.5-53.8-43.2C42.3 279.7 32 238.5 32 192zM346.2 75.2C362.4 45.5 382.1 32 400 32s37.6 13.5 53.8 43.2C469.7 104.3 480 145.5 480 192s-10.3 87.7-26.2 116.8C437.6 338.5 417.9 352 400 352s-37.6-13.5-53.8-43.2C330.3 279.7 320 238.5 320 192s10.3-87.7 26.2-116.8zM480 327.6V464c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V416H128v48c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V192c0-50.8-11.2-97.5-30.1-132.1C463.4 25.9 435.1 0 400 0H112C76.9 0 48.6 25.9 30.1 59.9C11.2 94.5 0 141.2 0 192s11.2 97.5 30.1 132.1C48.6 358.1 76.9 384 112 384H400c33.9 0 61.4-24.1 80-56.4zM385.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM431.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM227.3 132.7c-6.2-6.2-16.4-6.2-22.6 0L168 169.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L145.4 192l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L168 214.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 192l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faHandsHoldingDollar = {
  prefix: 'fal',
  iconName: 'hands-holding-dollar',
  icon: [640, 512, ["hands-usd"], "f4c5", "M320 0c8.8 0 16 7.2 16 16V32.8c11 1.2 21.6 3.7 31.2 6.3c8.5 2.3 13.5 11.1 11.2 19.7s-11.1 13.5-19.6 11.2c-12.1-3.3-24-5.8-35-5.9c-9.2-.1-19.1 2.1-26.1 6.3c-6.4 3.9-9.6 8.8-9.6 15.8c0 5.1 2 8.7 8.7 12.8c7.6 4.7 18.3 8.1 31.9 12.3l.4 .1c12.3 3.8 27.3 8.5 39.1 16.1c12.9 8.3 23.6 21.3 23.8 40.9c.3 20.6-9.9 35.6-24 44.5c-9.7 6.2-20.9 9.5-32 10.6V240c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-18.6c-11-2.4-21.3-6-30.4-9.3c-2.3-.8-4.6-1.6-6.7-2.4c-8.4-2.9-12.8-12-10-20.3s12-12.8 20.3-10c2.6 .9 5.2 1.8 7.7 2.7l0 0 0 0 0 0c14.7 5.1 26.8 9.3 39.7 9.8c10 .3 19.7-1.9 26.2-6.1c5.8-3.7 9.3-8.9 9.2-17.1c-.1-6.1-2.6-10.2-9.2-14.4c-7.6-4.9-18.2-8.4-31.7-12.6l-1.7-.5c-11.9-3.7-26.3-8.1-37.5-15.1c-12.8-7.9-23.7-20.4-23.8-39.9c-.1-20.6 11.1-34.9 25-43.3c7.1-4.3 15-7.2 22.9-8.9V16c0-8.8 7.2-16 16-16zM64 64c35.3 0 64 28.7 64 64V252.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64V344.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V252.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 0 0 44-44 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.9c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16 0 0-44-44 0 0-10.7-10.8C106.8 305.4 96 279.4 96 252.3V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V344.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2V128C0 92.7 28.7 64 64 64z"]
};
var faHandsUsd = faHandsHoldingDollar;
var faCube = {
  prefix: 'fal',
  iconName: 'cube',
  icon: [512, 512, [], "f1b2", "M261.5 35.1c-3.6-1.3-7.5-1.3-11 0L44.1 110.7 256 194l211.9-83.2L261.5 35.1zM32 385.7c0 6.7 4.2 12.7 10.5 15L240 473.1V222L32 140.3V385.7zm240 87.4l197.5-72.4c6.3-2.3 10.5-8.3 10.5-15V140.3L272 222v251zM239.5 5c10.7-3.9 22.4-3.9 33 0l208 76.3c18.9 6.9 31.5 24.9 31.5 45.1V385.7c0 20.1-12.6 38.1-31.5 45.1L272.5 507c-10.7 3.9-22.4 3.9-33 0l-208-76.3C12.6 423.8 0 405.8 0 385.7V126.4c0-20.1 12.6-38.1 31.5-45.1L239.5 5z"]
};
var faArrowDownTriangleSquare = {
  prefix: 'fal',
  iconName: 'arrow-down-triangle-square',
  icon: [576, 512, ["sort-shapes-down"], "f888", "M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 432c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v96zM416 67.5L341.3 192H490.7L416 67.5zM307.6 186L391.8 45.7C396.9 37.2 406.1 32 416 32s19.1 5.2 24.2 13.7L524.4 186c2.3 3.9 3.6 8.4 3.6 12.9c0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9zM320 432V336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48z"]
};
var faSortShapesDown = faArrowDownTriangleSquare;
var faBitcoinSign = {
  prefix: 'fal',
  iconName: 'bitcoin-sign',
  icon: [320, 512, [], "e0b4", "M64 16C64 7.2 71.2 0 80 0s16 7.2 16 16V64h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64.3c53.7 4.1 96 49 96 103.7c0 31.3-13.9 59.4-35.8 78.5C291.8 261.2 320 299.3 320 344c0 57.4-46.6 104-104 104H192v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H96v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H41.7C18.7 448 0 429.3 0 406.3V272 240 101.6C0 80.8 16.8 64 37.6 64H64V16zM176 416h40c39.8 0 72-32.2 72-72s-32.2-72-72-72H184 32V406.3c0 5.4 4.4 9.7 9.7 9.7H80h96zm0-320H80 37.6c-3.1 0-5.6 2.5-5.6 5.6V240H184c39.8 0 72-32.2 72-72s-32.2-72-72-72h-8z"]
};
var faShutters = {
  prefix: 'fal',
  iconName: 'shutters',
  icon: [512, 512, [], "e449", "M32 32C14.3 32 0 46.3 0 64V96c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32zm0 32H480V96H32V64zM.9 453c-.6 2-.9 4.1-.9 6.1C0 470.7 9.3 480 20.9 480H491.1c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-21.2-69H456.4l19.7 64H35.9l19.7-64H22.2L.9 453zM22.2 256L.9 325c-.6 2-.9 4.1-.9 6.1C0 342.7 9.3 352 20.9 352H491.1c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-21.2-69H456.4l19.7 64H35.9l19.7-64H22.2zm453.9-64H35.9l9.8-32H12.3L.9 197c-.6 2-.9 4.1-.9 6.1C0 214.7 9.3 224 20.9 224H491.1c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-11.4-37H466.2l9.8 32z"]
};
var faShieldDog = {
  prefix: 'fal',
  iconName: 'shield-dog',
  icon: [512, 512, [], "e573", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM200 128H178.7c-32.4 0-58.7 26.3-58.7 58.7V216c0 22.6 13.4 42.1 32.7 50.9l-15 29.9c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L186.4 271c26-4.9 45.6-27.7 45.6-55V160h60.2c6.1 0 11.6 3.4 14.3 8.8l7.2 14.3c2.7 5.4 8.2 8.8 14.3 8.8h56v16c0 35.3-28.7 64-64 64H272c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V304h32c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32H337.9l-2.7-5.5C327 138.3 310.4 128 292.2 128H232 216 200zM175.7 240c-13.1-.1-23.7-10.8-23.7-24V186.7c0-10.9 6.6-20.3 16-24.4c3.3-1.4 6.9-2.2 10.7-2.2H200v32 24c0 13.2-10.6 23.9-23.7 24l-.5 0zM272 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faSolarPanel = {
  prefix: 'fal',
  iconName: 'solar-panel',
  icon: [640, 512, [], "f5ba", "M221.2 0h16.1H402.7h16.1H533.5c26.9 0 50 19.1 55 45.6L613.2 176l3 16L639 312.6c1 5.1 1 10.2 1 15.4c0 30.9-25.1 56-56 56H436 419.9 336v96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V384H220.1 204 56c-30.9 0-56-25.1-56-56c0-5.2 0-10.3 1-15.4L23.8 192l3-16L51.5 45.6C56.5 19.1 79.6 0 106.5 0H221.2zM304 352h32 81.2L404.7 208H235.3L222.8 352H304zM250.5 32L238.1 176H401.9L389.5 32H250.5zM436.8 208l12.5 144H584c13.3 0 24-10.7 24-24c0-5.6-.1-7.8-.4-9.5L586.7 208H436.8zM434 176H580.6L557.1 51.5C554.9 40.2 545 32 533.5 32H421.6L434 176zM203.2 208H53.3L32.4 318.5c-.3 1.7-.4 3.9-.4 9.5c0 13.3 10.7 24 24 24H190.7l12.5-144zm2.8-32L218.4 32H106.5C95 32 85.1 40.2 82.9 51.5L59.4 176H206z"]
};
var faLockOpen = {
  prefix: 'fal',
  iconName: 'lock-open',
  icon: [576, 512, [], "f3c1", "M352 128c0-53 43-96 96-96s96 43 96 96v80c0 8.8 7.2 16 16 16s16-7.2 16-16V128C576 57.3 518.7 0 448 0S320 57.3 320 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H352V128zm-16 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48H336z"]
};
var faTableTree = {
  prefix: 'fal',
  iconName: 'table-tree',
  icon: [512, 512, [], "e293", "M64 64C46.3 64 32 78.3 32 96v64h80H480V96c0-17.7-14.3-32-32-32H64zm64 128v48c0 8.8 7.2 16 16 16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-5.6 0-11-1-16-2.7V336c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-26.5 0-48-21.5-48-48V240 192H32V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192H128zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 272c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16zm80 80h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faHouseChimneyHeart = {
  prefix: 'fal',
  iconName: 'house-chimney-heart',
  icon: [576, 512, [], "e1b2", "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V192.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1V64H416v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM237.3 256c-16.2 0-29.3 13.1-29.3 29.3c0 7.8 3.1 15.2 8.6 20.7L288 377.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6zM176 285.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
var faTally3 = {
  prefix: 'fal',
  iconName: 'tally-3',
  icon: [640, 512, [], "e296", "M128 32c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm128 0c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM400 48V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faElevator = {
  prefix: 'fal',
  iconName: 'elevator',
  icon: [512, 512, [], "e16d", "M155.3 4.7l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L144 38.6 91.3 91.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0zm160 0L368 57.4 420.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM64 160c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H64zM0 192c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm184 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM144 384c-17.7 0-32 14.3-32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416c0-17.7-14.3-32-32-32H144zm160 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416c0-17.7-14.3-32-32-32H336c-17.7 0-32 14.3-32 32z"]
};
var faMoneyBillTransfer = {
  prefix: 'fal',
  iconName: 'money-bill-transfer',
  icon: [640, 512, [], "e528", "M548.7 27.3L585.4 64l-45.3 0H524.6L384 64l-.3 0H96c-35.3 0-64 28.7-64 64V348.1l14.1-14.1L64 316.1V192c53 0 96-43 96-96H524.3h15.8l45.3 0-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-64-64c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM128 96c0 35.3-28.7 64-64 64V128c0-17.7 14.3-32 32-32h32zM54.6 448l45.3 0 0 0H544c35.3 0 64-28.7 64-64V163.9l-14.1 14.1L576 195.9V320h0c-53 0-96 43-96 96H256.4l-.4 0L54.6 416l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 448zM576 352h0v32c0 17.7-14.3 32-32 32H512c0-35.3 28.7-64 64-64zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faMoneyBillTrendUp = {
  prefix: 'fal',
  iconName: 'money-bill-trend-up',
  icon: [512, 512, [], "e529", "M352 16c0 8.8 7.2 16 16 16h57.4L287.2 170.2 186.4 83.9c-6-5.1-14.8-5.1-20.8 0l-112 96c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L176 117.1l101.6 87.1c6.3 5.4 15.8 5.1 21.7-.8L448 54.6V112c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM480 304v32c-26.5 0-48-21.5-48-48h32c8.8 0 16 7.2 16 16zM112 288H400c0 44.2 35.8 80 80 80v32c-44.2 0-80 35.8-80 80H112c0-44.2-35.8-80-80-80V368c44.2 0 80-35.8 80-80zM432 480c0-26.5 21.5-48 48-48v32c0 8.8-7.2 16-16 16H432zM32 432c26.5 0 48 21.5 48 48H48c-8.8 0-16-7.2-16-16V432zM80 288c0 26.5-21.5 48-48 48V304c0-8.8 7.2-16 16-16H80zM48 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faHouseFloodWaterCircleArrowRight = {
  prefix: 'fal',
  iconName: 'house-flood-water-circle-arrow-right',
  icon: [640, 512, [], "e50f", "M310.4 86.4c-3.6-10.3-8.1-20.2-13.4-29.6l78-54c5.5-3.8 12.7-3.8 18.2 0l208 144c7.3 5 9.1 15 4 22.3s-15 9.1-22.3 4L560 157.3V276.6c-2.4-1.6-4.6-3.3-6.8-5.1c-7.5-6.3-16.2-10.7-25.2-13V135.2L384 35.5l-73.6 51zM224 368c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C374.3 358 395.1 368 416 368s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C473.5 385.9 446.3 400 416 400s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C281.5 385.9 254.3 400 224 400s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C40 400.1 32 392 32 382.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C182.3 358 203.1 368 224 368zm-58.2 90.8C182.3 470 203.1 480 224 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C374.3 470 395.1 480 416 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C473.5 497.9 446.3 512 416 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C281.5 497.9 254.3 512 224 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C40 512.1 32 504 32 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM144 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM144 0a144 144 0 1 1 0 288A144 144 0 1 1 144 0zm-3.3 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faSquarePollHorizontal = {
  prefix: 'fal',
  iconName: 'square-poll-horizontal',
  icon: [448, 512, ["poll-h"], "f682", "M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM256 160c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16zm80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l224 0zM192 352c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0c8.8 0 16 7.2 16 16z"]
};
var faPollH = faSquarePollHorizontal;
var faCircle = {
  prefix: 'fal',
  iconName: 'circle',
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faCartCircleExclamation = {
  prefix: 'fal',
  iconName: 'cart-circle-exclamation',
  icon: [640, 512, [], "e3f2", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faSword = {
  prefix: 'fal',
  iconName: 'sword',
  icon: [512, 512, [128481], "f71c", "M507.3 4.7C503.7 1 498.5-.6 493.4 .2L417.6 12.8c-16.4 2.7-31.6 10.6-43.4 22.3L174.6 234.7l22.6 22.6L396.8 57.8c7.1-7.1 16.2-11.8 26.1-13.4l53.7-8.9-8.9 53.7c-1.6 9.9-6.3 19-13.4 26L254.6 314.7l22.6 22.6L476.8 137.8c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8c.8-5.1-.8-10.3-4.5-13.9zm-392 216c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-5.3 5.3-6.2 13.6-2.2 19.9l49.1 77.2L74.7 382.6l-31.6-6.3c-5.2-1-10.7 .6-14.5 4.4l-24 24c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l24-24c3.8-3.8 5.4-9.2 4.4-14.5l-6.3-31.6 32.9-32.9 77.2 49.1c6.3 4 14.6 3.1 19.9-2.2l32-32c6.2-6.2 6.2-16.4 0-22.6l-176-176zm26.2 122.7L92.4 266.2 104 254.6 257.4 408l-11.6 11.6-77.2-49.1c-6.3-4-14.6-3.1-19.9 2.2l-48 48c-3.8 3.8-5.4 9.2-4.4 14.5l6.3 31.6L96 473.4 38.6 416l6.6-6.6 31.6 6.3c5.2 1 10.7-.6 14.5-4.4l48-48c5.3-5.3 6.2-13.6 2.2-19.9z"]
};
var faBackwardFast = {
  prefix: 'fal',
  iconName: 'backward-fast',
  icon: [512, 512, [9198, "fast-backward"], "f049", "M16 64c8.8 0 16 7.2 16 16V215.8L210.6 70.2c5-4 11.2-6.2 17.6-6.2C243.6 64 256 76.4 256 91.8V241.9L466.6 70.2c5-4 11.2-6.2 17.6-6.2C499.6 64 512 76.4 512 91.8V420.2c0 15.4-12.4 27.8-27.8 27.8c-6.4 0-12.6-2.2-17.6-6.2L256 270.1V420.2c0 15.4-12.4 27.8-27.8 27.8c-6.4 0-12.6-2.2-17.6-6.2L32 296.2V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V270.1 241.9 80c0-8.8 7.2-16 16-16zM33.3 256L224 411.4V100.6L33.3 256zM480 100.6L289.3 256 480 411.4V100.6z"]
};
var faFastBackward = faBackwardFast;
var faRecycle = {
  prefix: 'fal',
  iconName: 'recycle',
  icon: [512, 512, [9842, 9850, 9851], "f1b8", "M193.7 35C206.9 13.3 230.5 0 256 0s49.1 13.3 62.3 35l77.8 127.8 11.1-54c1.8-8.7 10.2-14.2 18.9-12.4s14.2 10.2 12.4 18.9l-19.4 94.4c-.9 4.5-3.7 8.3-7.7 10.6s-8.7 2.8-13 1.3L307 191.2c-8.4-2.8-12.9-11.8-10.1-20.2s11.8-12.9 20.2-10.1l50.5 16.8L291 51.7C283.5 39.4 270.3 32 256 32s-27.5 7.4-35 19.7l-31.1 51.2c-4.6 7.5-14.4 9.9-21.9 5.4c-7.6-4.6-10-14.5-5.4-22L193.7 35zM435.2 257.8c7.5-4.5 17.3-2.1 21.9 5.4l46 75.6c5.8 9.5 8.8 20.3 8.9 31.4c.3 34.1-27.3 61.9-61.4 61.9l-184.5 0 40.5 36c6.6 5.9 7.2 16 1.3 22.6s-16 7.2-22.6 1.3l-72-64c-3.4-3-5.4-7.4-5.4-12s2-8.9 5.4-12l72-64c6.6-5.9 16.7-5.3 22.6 1.3s5.3 16.7-1.3 22.6L266.1 400l184.6 0c16.3 0 29.5-13.3 29.4-29.6c0-5.3-1.5-10.5-4.3-15l-46-75.6c-4.6-7.6-2.2-17.5 5.4-22zm-300-.2l-10-48.4L36.3 355.3c-2.8 4.5-4.2 9.7-4.3 15C31.9 386.7 45.1 400 61.4 400l82.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-82.7 0C27.3 432-.3 404.2 0 370.1c.1-11.1 3.2-21.9 8.9-31.4l92.4-151.9L45 205.5c-8.4 2.8-17.4-1.8-20.2-10.1S26.6 178 35 175.2l91.4-30.4c4.3-1.4 9.1-1 13 1.3s6.7 6.2 7.7 10.6l19.4 94.4c1.8 8.7-3.8 17.1-12.4 18.9s-17.1-3.8-18.9-12.4z"]
};
var faUserAstronaut = {
  prefix: 'fal',
  iconName: 'user-astronaut',
  icon: [448, 512, [], "f4fb", "M368 176A144 144 0 1 0 80 176a144 144 0 1 0 288 0zM48 176a176 176 0 1 1 352 0A176 176 0 1 1 48 176zM16 112c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16zm432 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16zM0 482.3c0-64.2 33.9-120.4 84.7-151.8c8.6 7.8 17.9 14.8 27.7 21.1C65.4 375.4 32.9 423.8 32 480H96V448c0-26.5 21.5-48 48-48H304c26.5 0 48 21.5 48 48v32h64c-.9-56.2-33.4-104.6-80.5-128.4c9.8-6.3 19.1-13.3 27.7-21.1c50.8 31.4 84.7 87.6 84.7 151.8c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM288 480h32V448c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v32h32V464c0-8.8 7.2-16 16-16s16 7.2 16 16v16h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v16zM205.3 162.7l21.2 6c3.3 .9 5.5 3.9 5.5 7.3s-2.2 6.4-5.5 7.3l-21.2 6-6 21.2c-.9 3.3-3.9 5.5-7.3 5.5s-6.4-2.2-7.3-5.5l-6-21.2-21.2-6c-3.3-.9-5.5-3.9-5.5-7.3s2.2-6.4 5.5-7.3l21.2-6 6-21.2c.9-3.3 3.9-5.5 7.3-5.5s6.4 2.2 7.3 5.5l6 21.2zM160 128c-17.7 0-32 14.3-32 32v16c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V160c0-17.7-14.3-32-32-32H160zM96 160c0-35.3 28.7-64 64-64H288c35.3 0 64 28.7 64 64v16c0 61.9-50.1 112-112 112H208c-61.9 0-112-50.1-112-112V160z"]
};
var faInterrobang = {
  prefix: 'fal',
  iconName: 'interrobang',
  icon: [320, 512, [8253], "e5ba", "M48 160c0-53 43-96 96-96h32c53 0 96 43 96 96c0 25.2-11.9 48.9-32 64l-60.8 45.6c-1.1 .8-2.2 1.7-3.2 2.5V160c0-8.8-7.2-16-16-16s-16 7.2-16 16V340v4 8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8-4c0-17.6 8.3-34.2 22.4-44.8l60.8-45.6C287.4 228.4 304 195.3 304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 8.8 7.2 16 16 16s16-7.2 16-16zM160 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPlaneSlash = {
  prefix: 'fal',
  iconName: 'plane-slash',
  icon: [640, 512, [], "e069", "M347.6 359.4L283.3 471.9c-2.8 5-8.2 8.1-13.9 8.1l-56.2 0 44.5-155.6c1.4-4.8 .4-10-2.6-14s-7.8-6.4-12.8-6.4H160c-5 0-9.8 2.4-12.8 6.4L104 368H64.6L95.4 260.4c.8-2.9 .8-5.9 0-8.8L64.6 144H74.8L43 118.8c-6.7 5.5-11 13.9-11 23.2c0 2.8 .4 5.6 1.2 8.3L63.4 256 33.2 361.7c-.8 2.7-1.2 5.5-1.2 8.2c0 16.6 13.4 30 30 30h42c10.1 0 19.6-4.7 25.6-12.8L168 336h53.1L182.4 471.2c-5.8 20.4 9.5 40.8 30.8 40.8l56.2 0c17.2 0 33.1-9.2 41.7-24.2L373 379.4l-25.4-20.1zM182.4 40.8l9.2 32.4 43 33.9L213.2 32l56.2 0c5.7 0 11 3.1 13.9 8.1l13.9-7.9-13.9 7.9 91.4 159.9c2.9 5 8.2 8.1 13.9 8.1l109.7 0c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2H484.1l37.1 29.3c15.2-3.4 31.2-9.7 45.1-18C586.4 303.1 608 282.9 608 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2l-100.5 0L311.1 24.2C302.6 9.2 286.7 0 269.4 0H213.2C192 0 176.6 20.3 182.4 40.8zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faCircleDashed = {
  prefix: 'fal',
  iconName: 'circle-dashed',
  icon: [512, 512, [], "e105", "M18.8 232c8.2 0 15.1-6.2 16.5-14.3C41 184.4 54.1 153.6 72.8 127c4.7-6.7 4.3-16-1.5-21.8C64.6 98.5 53.5 99 48 106.7c-22.5 31.4-38.2 68-44.6 107.7C1.8 223.8 9.3 232 18.8 232zM127 72.8c26.5-18.7 57.3-31.8 90.6-37.6C225.8 33.9 232 27 232 18.8c0-9.5-8.2-17-17.5-15.4C174.7 9.8 138.1 25.5 106.7 48c-7.7 5.5-8.2 16.6-1.5 23.3c5.8 5.8 15.1 6.3 21.8 1.5zM280 493.2c0 9.5 8.2 17 17.5 15.4c39.7-6.5 76.4-22.1 107.7-44.6c7.7-5.5 8.2-16.6 1.5-23.3c-5.8-5.8-15.1-6.3-21.8-1.5c-26.5 18.7-57.3 31.8-90.6 37.6c-8.1 1.4-14.3 8.2-14.3 16.5zM439.2 385c-4.7 6.7-4.3 16 1.5 21.8c6.7 6.7 17.8 6.2 23.3-1.5c22.5-31.4 38.2-68 44.6-107.7c1.5-9.4-5.9-17.5-15.4-17.5c-8.2 0-15.1 6.2-16.5 14.3c-5.7 33.3-18.8 64.1-37.6 90.6zM105.2 440.7c-6.7 6.7-6.2 17.8 1.5 23.3c31.4 22.5 68 38.2 107.7 44.6c9.4 1.5 17.5-5.9 17.5-15.4c0-8.2-6.2-15.1-14.3-16.5c-33.3-5.7-64.1-18.8-90.6-37.6c-6.7-4.7-16-4.3-21.8 1.5zM48 405.3c5.5 7.7 16.6 8.2 23.3 1.5c5.8-5.8 6.3-15.1 1.5-21.8C54.1 358.4 41 327.6 35.3 294.3C33.9 286.2 27 280 18.8 280c-9.5 0-17 8.2-15.4 17.5C9.8 337.3 25.5 373.9 48 405.3zm358.8-334c6.7-6.7 6.2-17.8-1.5-23.3c-31.4-22.5-68-38.2-107.7-44.6C288.2 1.8 280 9.3 280 18.8c0 8.2 6.2 15.1 14.3 16.5C327.6 41 358.4 54.1 385 72.8c6.7 4.7 16 4.3 21.8-1.5zM439.2 127c18.7 26.5 31.8 57.3 37.6 90.6c1.4 8.1 8.2 14.3 16.5 14.3c9.5 0 17-8.2 15.4-17.5c-6.5-39.7-22.1-76.4-44.6-107.7c-5.5-7.7-16.6-8.2-23.3-1.5c-5.8 5.8-6.3 15.1-1.5 21.8z"]
};
var faTrademark = {
  prefix: 'fal',
  iconName: 'trademark',
  icon: [640, 512, [8482], "f25c", "M0 112c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM112 400c0 8.8 7.2 16 16 16s16-7.2 16-16V128H112V400zM316.3 101.8c-4.3-5.2-11.4-7.1-17.7-4.8s-10.6 8.3-10.6 15V400c0 8.8 7.2 16 16 16s16-7.2 16-16V156.2L451.7 314.2c3 3.6 7.5 5.8 12.3 5.8s9.3-2.1 12.3-5.8L608 156.2V400c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-6.7-4.2-12.8-10.6-15s-13.4-.4-17.7 4.8L464 279 316.3 101.8z"]
};
var faBasketball = {
  prefix: 'fal',
  iconName: 'basketball',
  icon: [512, 512, [127936, "basketball-ball"], "f434", "M290.7 477.3c-1.8-9.5-2.7-19.3-2.7-29.3c0-38.4 13.5-73.7 36.1-101.3l78.6 78.6c-31 26.9-69.5 45.4-112 52zm-32 2.7c-.9 0-1.8 0-2.7 0c-56.1 0-107.4-20.6-146.7-54.7L256 278.6 301.4 324C273.1 357.5 256 400.7 256 448c0 10.9 .9 21.6 2.7 32zM324 301.4L278.6 256 425.3 109.3C459.4 148.6 480 199.9 480 256c0 .9 0 1.8 0 2.7c-10.4-1.7-21.1-2.7-32-2.7c-47.3 0-90.5 17.1-124 45.4zm22.7 22.7C374.3 301.5 409.6 288 448 288c10 0 19.8 .9 29.3 2.7c-6.6 42.5-25.1 81-52 112l-78.6-78.6zM256 233.4L210.6 188C238.9 154.5 256 111.3 256 64c0-10.9-.9-21.6-2.7-32c.9 0 1.8 0 2.7 0c56.1 0 107.4 20.6 146.7 54.7L256 233.4zm-68.1-68.1L109.3 86.7c31-26.9 69.5-45.4 112-52C223.1 44.2 224 54 224 64c0 38.4-13.5 73.7-36.1 101.3zm-22.6 22.6C137.7 210.5 102.4 224 64 224c-10 0-19.8-.9-29.3-2.7c6.6-42.5 25.1-81 52-112l78.6 78.6zM32 253.3c10.4 1.7 21.1 2.7 32 2.7c47.3 0 90.5-17.1 124-45.4L233.4 256 86.7 402.7C52.6 363.4 32 312.1 32 256c0-.9 0-1.8 0-2.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faBasketballBall = faBasketball;
var faForkKnife = {
  prefix: 'fal',
  iconName: 'fork-knife',
  icon: [576, 512, ["utensils-alt"], "f2e6", "M64 9.7L273.7 234.4 251.1 257 42.9 34C38.4 49 32 77.1 32 112c0 41 12.6 72.2 36.6 104.6c21 28.3 50.1 56.9 87.3 93.2l0 0 0 0c6.6 6.4 13.4 13.1 20.5 20.1l0 0 .1 .1 .8 .8-22.6 22.6-.8-.8c-6.8-6.7-13.5-13.3-20-19.6l0 0 0 0c-37-36.2-68.3-66.8-91-97.4C15.6 198.8 0 161.1 0 112C0 69.6 8.6 36.2 13.6 20.4C17.6 7.6 29.4 0 41.7 0C50.2 0 58.2 3.5 64 9.7zM484.3 506.9L316.6 327.3l22.6-22.6L507.7 485.1c6 6.5 5.7 16.6-.8 22.6s-16.6 5.7-22.6-.8zM468.9 6.5c5.2 7.1 3.7 17.1-3.4 22.4L351.1 112.7c-3.1 2.3-6.1 4.8-8.8 7.6l-1.6 1.6C327.5 135.2 320 153.2 320 172s7.5 36.8 20.8 50.1l13.1 13.1C367.2 248.5 385.2 256 404 256s36.8-7.5 50.1-20.8l1.6-1.6c2.7-2.7 5.3-5.7 7.6-8.8l83.8-114.3c5.2-7.1 15.2-8.7 22.4-3.4s8.7 15.2 3.4 22.4L489.1 243.8c-3.3 4.4-6.9 8.6-10.7 12.5l-1.6 1.6C457.5 277.2 431.3 288 404 288c-25 0-49.1-9.1-67.8-25.5L91.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L313.5 239.8C297.1 221.1 288 197 288 172c0-27.3 10.8-53.5 30.1-72.8l1.6-1.6c3.9-3.9 8.1-7.5 12.5-10.7L446.5 3.1c7.1-5.2 17.1-3.7 22.4 3.4zM508 37.5c5.8 6.7 5.1 16.8-1.5 22.6l-128 112c-6.6 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l128-112c6.7-5.8 16.8-5.1 22.6 1.5zM538.5 68c6.7 5.8 7.3 15.9 1.5 22.6l-112 128c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l112-128c5.8-6.7 15.9-7.3 22.6-1.5z"]
};
var faUtensilsAlt = faForkKnife;
var faSatelliteDish = {
  prefix: 'fal',
  iconName: 'satellite-dish',
  icon: [512, 512, [128225], "f7c0", "M208 0c-8.8 0-16 7.2-16 16s7.2 16 16 16c150.2 0 272 121.8 272 272c0 8.8 7.2 16 16 16s16-7.2 16-16C512 136.1 375.9 0 208 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c97.2 0 176 78.8 176 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-114.9-93.1-208-208-208zM32 304c0-24.5 5-47.7 13.9-68.8L276.8 466.1C255.7 475 232.5 480 208 480c-97.2 0-176-78.8-176-176zm33.5-94.5c-14-14-37.3-12.1-45.7 5.8C7.1 242.2 0 272.3 0 304C0 418.9 93.1 512 208 512c31.7 0 61.8-7.1 88.7-19.8c17.9-8.4 19.8-31.8 5.8-45.7L195.3 339.3l24-24c6.3 3 13.3 4.7 20.7 4.7c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48c0 7.4 1.7 14.4 4.7 20.7l-24 24L65.5 209.5zM224 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faBadgeCheck = {
  prefix: 'fal',
  iconName: 'badge-check',
  icon: [512, 512, [], "f336", "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faCircleUp = {
  prefix: 'fal',
  iconName: 'circle-up',
  icon: [512, 512, [61467, "arrow-alt-circle-up"], "f35b", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c-9.2 0-18 3.5-24.7 9.7l-91 84c-7.8 7.2-12.3 17.4-12.3 28.1c0 21.1 17.1 38.3 38.3 38.3H192v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V272h25.7c21.1 0 38.3-17.1 38.3-38.3c0-10.7-4.5-20.9-12.3-28.1l-91-84c-6.7-6.2-15.6-9.7-24.7-9.7zm-3 33.2c.8-.8 1.9-1.2 3-1.2s2.2 .4 3 1.2l91 84c1.3 1.2 2 2.9 2 4.6c0 3.5-2.8 6.3-6.3 6.3H304c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V256c0-8.8-7.2-16-16-16H166.3c-3.5 0-6.3-2.8-6.3-6.3c0-1.7 .7-3.4 2-4.6l91-84z"]
};
var faArrowAltCircleUp = faCircleUp;
var faSlider = {
  prefix: 'fal',
  iconName: 'slider',
  icon: [512, 512, [], "e252", "M352 128c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h32zM320 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V160c0-35.3-28.7-64-64-64H320zM0 256c0 8.8 7.2 16 16 16H224V240H16c-8.8 0-16 7.2-16 16z"]
};
var faMobileScreenButton = {
  prefix: 'fal',
  iconName: 'mobile-screen-button',
  icon: [384, 512, ["mobile-alt"], "f3cd", "M288 32c17.7 0 32 14.3 32 32V320H64V64c0-17.7 14.3-32 32-32H288zm32 320v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352H320zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM216 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faMobileAlt = faMobileScreenButton;
var faClockOneThirty = {
  prefix: 'fal',
  iconName: 'clock-one-thirty',
  icon: [512, 512, [], "e34f", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V260.8l61.3-92c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-1.8 2.6-2.7 5.7-2.7 8.9V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faInboxOut = {
  prefix: 'fal',
  iconName: 'inbox-out',
  icon: [512, 512, [128228, "inbox-arrow-up"], "f311", "M272 54.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6V304c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6zM48 352h66.3c6.1 0 11.6 3.4 14.3 8.8L143 389.5c8.1 16.3 24.8 26.5 42.9 26.5H326.1c18.2 0 34.8-10.3 42.9-26.5l-28.6-14.3L369 389.5l14.3-28.6c2.7-5.4 8.3-8.8 14.3-8.8H464c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm306.7-5.5l-14.3 28.6c-2.7 5.4-8.2 8.8-14.3 8.8H185.9c-6.1 0-11.6-3.4-14.3-8.8l-14.3-28.6c-8.1-16.3-24.8-26.5-42.9-26.5H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H397.7c-18.2 0-34.8 10.3-42.9 26.5z"]
};
var faInboxArrowUp = faInboxOut;
var faCloudSlash = {
  prefix: 'fal',
  iconName: 'cloud-slash',
  icon: [640, 512, [], "e137", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 352c0-49.1-27.7-91.8-68.3-113.2c2.8-9.8 4.3-20.1 4.3-30.8c0-61.9-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8C384.1 61.5 331.5 32 272 32c-35.5 0-68.6 10.5-96.2 28.6l26.8 21.2C223.2 70.5 246.8 64 272 64c48.7 0 91.7 24.1 117.8 61.2c9 12.7 25.8 17.2 39.9 10.5c10.3-4.9 21.9-7.7 34.3-7.7c44.2 0 80 35.8 80 80c0 7.7-1.1 15-3 22c-4.1 14.5 2.5 30 15.8 37.1C587.3 283.2 608 315.2 608 352c0 15.1-3.5 29.4-9.7 42.2l25.6 20.2C634.1 395.9 640 374.6 640 352zM101.3 164.9c-2.9 11.3-4.6 23.1-5.1 35.2C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144H500.4l-40.5-32H144C82.1 448 32 397.9 32 336c0-48.8 31.2-90.3 74.8-105.7c12.3-4.3 20.8-15.7 21.3-28.8c.2-4.9 .7-9.7 1.4-14.4l-28.2-22.2z"]
};
var faVolumeHigh = {
  prefix: 'fal',
  iconName: 'volume-high',
  icon: [640, 512, [128266, "volume-up"], "f028", "M151.6 188L288 66.7V445.3L151.6 324c-2.9-2.6-6.7-4-10.6-4H56c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h85c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM409.6 179.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C406 216.5 416 235.1 416 256s-10 39.5-25.6 51.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8zm42-69.2c-5.6 6.8-4.7 16.9 2.1 22.5C489.4 161.9 512 206.3 512 256s-22.6 94.1-58.2 123.4c-6.8 5.6-7.8 15.7-2.1 22.5s15.7 7.8 22.5 2.1C516.8 368.9 544 315.6 544 256s-27.2-112.9-69.8-148.1c-6.8-5.6-16.9-4.7-22.5 2.1zm86.7-73.6c-6.7-5.7-16.8-4.9-22.6 1.8s-4.9 16.8 1.8 22.6c55.3 47 90.4 117 90.4 195.2s-35.1 148.2-90.4 195.2c-6.7 5.7-7.6 15.8-1.8 22.6s15.8 7.6 22.6 1.8C600.5 422.8 640 344 640 256s-39.5-166.8-101.6-219.6z"]
};
var faVolumeUp = faVolumeHigh;
var faUsersRays = {
  prefix: 'fal',
  iconName: 'users-rays',
  icon: [640, 512, [], "e593", "M4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm630.6 0c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zM27.3 507.3l64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm608 0c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM360 320c19.4 0 35.5 13.7 39.2 32H240.8c3.7-18.3 19.8-32 39.2-32h80zm-80-32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H320 280zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H152c-30.9 0-56 25.1-56 56v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8zM464.2 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM488 288c13.3 0 24 10.7 24 24v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-30.9-25.1-56-56-56H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h56z"]
};
var faWallet = {
  prefix: 'fal',
  iconName: 'wallet',
  icon: [512, 512, [], "f555", "M80 32C35.8 32 0 67.8 0 112V400c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zM384 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faOctagonCheck = {
  prefix: 'fal',
  iconName: 'octagon-check',
  icon: [512, 512, [], "e426", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM363.3 203.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 297.4 340.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faFlatbreadStuffed = {
  prefix: 'fal',
  iconName: 'flatbread-stuffed',
  icon: [576, 512, [129369], "e40c", "M256.8 32l59.9 32.9c11.7 6.4 25.1 9 38.4 7.5l51.5-6.1 17.9-17.9c4.6-4.6 10-8.3 15.8-11.1c-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6 .8-13.3-.5-19.2-3.7L272.2 4c-12.8-7-28.7-4.5-38.7 6.1L186.6 59.9c-4.6 4.9-10.5 8.2-17.1 9.5L102.4 82.7c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2L23.1 252.1c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3L101.8 371l-.2-7.1c-.3-13.3-4.7-26.3-12.7-37L48 272.1l42.8-53.3c8.4-10.4 13.3-23.2 14-36.5l3.8-68.3 67.1-13.3c13.1-2.6 25-9.2 34.2-19L256.8 32zM426.7 136.7l36.6-36.6c29.7 39.8 48.8 87 48.8 139.9c0 132.5-107.5 240-240 240c-52.9 0-100.1-19.1-139.9-48.8l79.6-79.6 86-86 86-86 43-43zm56.1-63.6c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272c0-64.7-24.9-121.2-61.2-166.9zM272 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM232 144c-66.3 0-120 53.7-120 120c0 27.2 9.1 52.3 24.3 72.5l22.9-22.9C149.6 299.4 144 282.4 144 264c0-48.6 39.4-88 88-88c18.4 0 35.4 5.6 49.5 15.3l22.9-22.9C284.3 153.1 259.2 144 232 144z"]
};
var faClipboardCheck = {
  prefix: 'fal',
  iconName: 'clipboard-check',
  icon: [384, 512, [], "f46c", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm91.3 171.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 345.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faCartCirclePlus = {
  prefix: 'fal',
  iconName: 'cart-circle-plus',
  icon: [640, 512, [], "e3f3", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"]
};
var faTruckClock = {
  prefix: 'fal',
  iconName: 'truck-clock',
  icon: [640, 512, ["shipping-timed"], "f48c", "M64 32C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H384V64c0-17.7-14.3-32-32-32H64zm0 384c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V96h65.3c14 0 27.3 6.1 36.4 16.8l78.7 91.8c7.5 8.7 11.6 19.8 11.6 31.2V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96zM416 128v96H570.9l-77.5-90.4c-3-3.5-7.5-5.6-12.1-5.6H416zm0 128v88.4c17-15.2 39.4-24.4 64-24.4c41.8 0 77.4 26.7 90.5 64H576V256H416zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM208 256a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm16 64v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faShippingTimed = faTruckClock;
var faPool8Ball = {
  prefix: 'fal',
  iconName: 'pool-8-ball',
  icon: [512, 512, [], "e3c5", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm368-64a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm37.3 14.2C304.8 184.5 312 199.4 312 216c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.6 7.2-31.5 18.7-41.8C212 166 208 155.5 208 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 11.5-4 22-10.7 30.2zM256 192a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faFileAudio = {
  prefix: 'fal',
  iconName: 'file-audio',
  icon: [384, 512, [], "f1c7", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM258 226.3c-7.6-4.6-17.4-2.1-22 5.4s-2.1 17.4 5.4 22C269.4 270.5 288 301.1 288 336s-18.6 65.5-46.5 82.3c-7.6 4.6-10 14.4-5.4 22s14.4 10 22 5.4c37.1-22.4 62-63.1 62-109.7s-24.9-87.3-62-109.7zm-18.3 67c-5.9-6.6-16-7.1-22.6-1.3s-7.1 16-1.3 22.6c5.1 5.7 8.1 13.1 8.1 21.3s-3.1 15.7-8.1 21.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C249.8 367.4 256 352.4 256 336s-6.2-31.4-16.3-42.7zm-56.9-43.8c-5.6-2.6-12.3-1.8-17 2.2L122.2 288H80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h42.2l43.6 36.3c4.8 4 11.4 4.8 17 2.2s9.2-8.3 9.2-14.5V264c0-6.2-3.6-11.9-9.2-14.5zM160 298.2v75.7l-21.8-18.1c-2.9-2.4-6.5-3.7-10.2-3.7H96V320h32c3.7 0 7.4-1.3 10.2-3.7L160 298.2z"]
};
var faTurnDownLeft = {
  prefix: 'fal',
  iconName: 'turn-down-left',
  icon: [512, 512, [], "e331", "M160 208l0-57.3c0-3.7-3-6.7-6.7-6.7c-1.9 0-3.7 .8-5 2.2L35.8 272 148.3 397.8c1.3 1.4 3.1 2.2 5 2.2c3.7 0 6.7-3 6.7-6.7l0-57.3c0-17.7 14.3-32 32-32l176 0c61.9 0 112-50.1 112-112l0-112c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 112c0 26.5-21.5 48-48 48l-176 0c-17.7 0-32-14.3-32-32zM5.3 286C1.9 282.1 0 277.2 0 272s1.9-10.1 5.3-14L124.5 124.9c7.3-8.2 17.8-12.9 28.8-12.9c21.4 0 38.7 17.3 38.7 38.7l0 25.3 0 32 32 0 144 0c8.8 0 16-7.2 16-16l0-112c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 112c0 79.5-64.5 144-144 144l-144 0-32 0 0 32 0 25.3c0 21.4-17.3 38.7-38.7 38.7c-11 0-21.5-4.7-28.8-12.9L5.3 286z"]
};
var faLockHashtag = {
  prefix: 'fal',
  iconName: 'lock-hashtag',
  icon: [448, 512, [], "e423", "M128 128v64H320V128c0-53-43-96-96-96s-96 43-96 96zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h16c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80H96zM32 272V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48zm144-32c8.8 0 16 7.2 16 16v32h64V256c0-8.8 7.2-16 16-16s16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H288v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H288v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V320H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V256c0-8.8 7.2-16 16-16zm16 144h64V320H192v64z"]
};
var faChartRadar = {
  prefix: 'fal',
  iconName: 'chart-radar',
  icon: [512, 512, [], "e0e7", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM312 160c0 17.8-8.3 33.6-21.2 43.9l24.1 60.3c1.7-.2 3.4-.2 5.1-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56c-29.2 0-53.2-22.3-55.8-50.8l-54.7-10.9c-9.4 17.7-28 29.8-49.5 29.8c-30.9 0-56-25.1-56-56s25.1-56 56-56c6.8 0 13.4 1.2 19.4 3.5L211 193.3c-6.9-9.3-11-20.8-11-33.3c0-30.9 25.1-56 56-56s56 25.1 56 56zM270.5 293.8c3.6-6.9 8.7-12.9 14.7-17.7l-24.1-60.3c-1.7 .2-3.4 .2-5.1 .2c-6.8 0-13.4-1.2-19.4-3.5L205 254.7c5.9 8 9.8 17.7 10.8 28.2l54.7 10.9zM256 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-184-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faStaff = {
  prefix: 'fal',
  iconName: 'staff',
  icon: [512, 512, [], "f71b", "M284.2 44.2l-7.2 14.3c-11.9 23.7-2.2 52.5 21.5 64.4s52.5 2.2 64.4-21.5c1.7-3.4 5.1-5.5 8.8-5.5H400c8.8 0 16 7.2 16 16v47.7c0 7.1-4.7 13.4-11.6 15.4L234.8 223.6c-13.1 3.7-25 10.7-34.6 20.4l-39.4 39.4c-3 3-7.1 4.7-11.3 4.7H112c-8.8 0-16 7.2-16 16v37.5c0 4.2-1.7 8.3-4.7 11.3L14.1 430.1c-18.7 18.7-18.7 49.1 0 67.9s49.1 18.7 67.9 0L262.2 317.7c1.9-1.9 4.3-3.3 6.9-4.1l85.5-24.4c4.1-1.2 8.5-.7 12.3 1.5l32.8 18.5c7.7 4.3 17.5 1.6 21.8-6.1l19-33.6c2.1-3.7 5.5-6.4 9.5-7.5l3.9-1.1c34.3-9.8 58-41.2 58-76.9V80c0-44.2-35.8-80-80-80H355.8c-30.3 0-58 17.1-71.6 44.2zM355.8 32H432c26.5 0 48 21.5 48 48V183.9c0 21.4-14.2 40.3-34.8 46.2l-3.9 1.1c-12.1 3.5-22.4 11.6-28.6 22.6l-11.1 19.7-18.9-10.7c-11.2-6.3-24.4-7.9-36.8-4.4l-85.5 24.4c-7.8 2.2-15 6.4-20.8 12.2L59.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l77.3-77.3c9-9 14.1-21.2 14.1-33.9V320h21.5c12.7 0 24.9-5.1 33.9-14.1l39.4-39.4c5.8-5.8 12.9-10 20.8-12.2l169.6-48.5c20.6-5.9 34.8-24.7 34.8-46.2V112c0-26.5-21.5-48-48-48H371.8c-15.9 0-30.4 9-37.5 23.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l7.2-14.3C321 42.3 337.6 32 355.8 32z"]
};
var faBurger = {
  prefix: 'fal',
  iconName: 'burger',
  icon: [512, 512, ["hamburger"], "f805", "M256 64c94.4 0 172.9 68.1 189 157.8l0 .1c0 .1-.1 .2-.3 .3c-.7 .8-2.4 1.7-4.7 1.7H72c-2.4 0-4-1-4.7-1.7c-.1-.1-.2-.2-.3-.3l0-.1C83.1 132.1 161.6 64 256 64zM440 256c22.1 0 40.4-18.1 36.5-39.8C457.7 111.5 366.1 32 256 32S54.3 111.5 35.5 216.2C31.6 237.9 49.9 256 72 256H440zM128 448c-35.3 0-64-28.7-64-64H448c0 35.3-28.7 64-64 64H128zM32 384c0 53 43 96 96 96H384c53 0 96-43 96-96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zM16 304c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zM160 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faHamburger = faBurger;
var faUtilityPole = {
  prefix: 'fal',
  iconName: 'utility-pole',
  icon: [512, 512, [], "e2c3", "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96h80V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96h15.8c.1 0 .2 0 .3 0H480V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96c0 17.7-14.3 32-32 32H437.5L304 231.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224.2c0-.1 0-.2 0-.3V128H240v95.9c0 .1 0 .2 0 .3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V231.8L74.5 128H32C14.3 128 0 113.7 0 96V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96H79.9c.1 0 .2 0 .3 0H96V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96h80V32zm-81.4 96L208 191.3V128H126.6zM304 191.3L385.4 128H304v63.3zM272 32l-32 0V96h32V32z"]
};
var faTransporter6 = {
  prefix: 'fal',
  iconName: 'transporter-6',
  icon: [512, 512, [], "e2a7", "M48 0C39.2 0 32 7.2 32 16V32H16C7.2 32 0 39.2 0 48s7.2 16 16 16H32V80c0 8.8 7.2 16 16 16s16-7.2 16-16V64H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V16C64 7.2 56.8 0 48 0zM464 352c-8.8 0-16 7.2-16 16v16H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V416h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V368c0-8.8-7.2-16-16-16zM208 16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm32 224c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faWrench = {
  prefix: 'fal',
  iconName: 'wrench',
  icon: [512, 512, [128295], "f0ad", "M480 160c0-10.7-1.3-21.1-3.8-31l-48.9 48.9c-9 9-21.2 14.1-33.9 14.1H368c-26.5 0-48-21.5-48-48V118.6c0-12.7 5.1-24.9 14.1-33.9L383 35.8c-9.9-2.5-20.3-3.8-31-3.8c-70.7 0-128 57.3-128 128c0 9.2 1 18.1 2.8 26.7c3.2 15.2-.6 32.4-13.1 44.9L45.8 399.4C37 408.3 32 420.3 32 432.8C32 458.9 53.1 480 79.2 480c12.5 0 24.5-5 33.4-13.8L280.5 298.3c12.4-12.4 29.7-16.3 44.9-13.1c8.6 1.8 17.5 2.8 26.7 2.8c70.7 0 128-57.3 128-128zm32 0c0 88.4-71.6 160-160 160c-11.4 0-22.6-1.2-33.3-3.5c-5.6-1.2-11.5 .3-15.6 4.4L135.2 488.8c-14.9 14.9-35 23.2-56 23.2C35.5 512 0 476.5 0 432.8c0-21 8.3-41.1 23.2-56L191.1 208.9c4.1-4.1 5.6-10 4.4-15.6c-2.3-10.7-3.5-21.9-3.5-33.3C192 71.6 263.6 0 352 0c24.8 0 48.3 5.7 69.3 15.7c9.2 4.4 10.5 16.5 3.3 23.7l-67.9 67.9c-3 3-4.7 7.1-4.7 11.3V144c0 8.8 7.2 16 16 16h25.4c4.2 0 8.3-1.7 11.3-4.7l67.9-67.9c7.2-7.2 19.3-5.9 23.7 3.3c10.1 21 15.7 44.5 15.7 69.3zM88 408a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faBugs = {
  prefix: 'fal',
  iconName: 'bugs',
  icon: [576, 512, [], "e4d0", "M156.7 102.8l34-80.6c3.4-8.1-.4-17.5-8.5-21s-17.5 .4-21 8.5L128 88.6 94.7 9.8c-3.4-8.1-12.8-12-21-8.5s-12 12.8-8.5 21l34 80.6c-13.8 7-24.8 18.8-30.6 33.2H37.1l-5.4-27.1C30 100.2 21.5 94.6 12.9 96.3S-1.4 106.5 .3 115.1l8 40C9.8 162.6 16.4 168 24 168H64v49.8l-45.1 15c-5.7 1.9-9.9 6.9-10.8 12.9l-8 56c-1.2 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6l6.6-46.2 30.9-10.3C79.3 272.3 101.8 288 128 288s48.7-15.7 58.6-38.3l30.9 10.3 6.6 46.2c1.2 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1l-8-56c-.9-6-5-11-10.8-12.9l-45.1-15V168h40c7.6 0 14.2-5.4 15.7-12.9l8-40c1.7-8.7-3.9-17.1-12.6-18.8s-17.1 3.9-18.8 12.6L218.9 136H187.3c-5.8-14.4-16.8-26.2-30.6-33.2zM160 224c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32v64zm332.3 55.4l69.7-52.8c7-5.3 8.4-15.4 3.1-22.4s-15.4-8.4-22.4-3.1l-68.2 51.6 10.6-84.9c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9l-10.8 86.8c-15.4-.9-30.8 3.9-43.1 13.4l-27.3-15.8 8.9-26.2c2.8-8.4-1.7-17.5-10-20.3s-17.5 1.7-20.3 10l-13.1 38.6c-2.4 7.2 .6 15.2 7.2 19l34.6 20-24.9 43.1L308 323.1c-5.9-1.2-12.1 1-15.8 5.8l-34.9 44.5c-5.5 7-4.2 17 2.7 22.5s17 4.2 22.5-2.7l28.8-36.7 32 6.5c-2.7 24.5 8.9 49.4 31.6 62.4s50 10.7 69.9-3.8L466.4 446 449 489.3c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l21.1-52.5c2.3-5.6 1.1-12-2.9-16.6l-31.5-35.5 24.9-43.1 34.6 20c6.6 3.8 15 2.4 20-3.3l26.9-30.6c5.8-6.6 5.2-16.7-1.5-22.6s-16.7-5.2-22.6 1.5l-18.3 20.8-27.3-15.8c2.2-15.4-1.4-31.1-9.9-44.1zM434.6 386c-8.8 15.3-28.4 20.5-43.7 11.7s-20.6-28.4-11.7-43.7l32-55.4c8.8-15.3 28.4-20.5 43.7-11.7s20.5 28.4 11.7 43.7l-32 55.4z"]
};
var faVectorPolygon = {
  prefix: 'fal',
  iconName: 'vector-polygon',
  icon: [448, 512, [], "e2c7", "M408 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zM360 32c-22.1 0-40 17.9-40 40v8H128V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40h8l0 192H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40v-8H320v8c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H364.3l-25.4-42.3c8.1-7.3 13.2-17.9 13.2-29.7V232c0-11.8-5.1-22.3-13.2-29.7L364.3 160H408c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360zM307.7 320l25.4 42.3c-8.1 7.3-13.2 17.9-13.2 29.7v8H128v-8c0-22.1-17.9-40-40-40H80l0-192h8c22.1 0 40-17.9 40-40v-8H320v8c0 11.8 5.1 22.3 13.2 29.7L307.7 192H264c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h43.7zM40 384H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zm320 0h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zM264 224h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8zM88 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8H88z"]
};
var faDiagramNested = {
  prefix: 'fal',
  iconName: 'diagram-nested',
  icon: [448, 512, [], "e157", "M144 64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112 80 48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h96zM112 224h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48H80v96c0 44.2 35.8 80 80 80h96v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v32H160c-26.5 0-48-21.5-48-48V224zM288 368V336c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V400 368z"]
};
var faRupeeSign = {
  prefix: 'fal',
  iconName: 'rupee-sign',
  icon: [448, 512, [8360, "rupee"], "f156", "M0 80C0 53.5 21.5 32 48 32h64c79.5 0 144 64.5 144 144c0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3L119.9 319.8c-2.6 .1-5.3 .2-7.9 .2H32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 80zM32 288h80c61.9 0 112-50.1 112-112s-50.1-112-112-112H48c-8.8 0-16 7.2-16 16V288zm264.8-27.6c-1.5 9.7-.4 16.5 1.8 21.6c2.2 5.1 5.9 9.7 11.5 14c12.1 9.2 29.9 15.2 51.4 22.6l.1 0c20 6.8 43.6 14.8 60.7 28.8c8.9 7.3 16.6 16.6 21.2 28.4c4.6 11.9 5.7 25.3 3.4 40.3c-3.9 25.5-19 44-40.2 54.2c-20.6 9.9-46.3 11.8-72.8 7.2l-.1 0c-9-1.6-20.6-5.5-31-9.3c-7-2.5-14.2-5.3-20.2-7.6l0 0c-3-1.2-5.8-2.2-8.1-3.1c-8.3-3.1-12.5-12.3-9.4-20.6s12.3-12.5 20.6-9.4c2.7 1 5.7 2.2 8.8 3.4l0 0c5.8 2.2 12.3 4.7 19.1 7.2c10.5 3.8 19.8 6.8 25.9 7.9c22 3.9 40.4 1.7 53.3-4.5c12.3-5.9 20.2-15.7 22.5-30.3c1.6-10.6 .6-18.2-1.6-23.9c-2.2-5.7-6-10.7-11.6-15.2c-11.8-9.7-29.5-16-50.8-23.3l-2.8-1c-19.2-6.5-41.4-14-57.7-26.5c-9-6.8-16.8-15.6-21.6-27c-4.8-11.5-6.1-24.4-3.9-38.9c3.7-23.9 19-42 39.7-52.6c20.5-10.4 46.3-13.6 73.3-8.8c7.7 1.4 31 6.4 39.4 8.9c8.5 2.5 13.3 11.4 10.7 19.9s-11.4 13.3-19.9 10.7c-6.7-2-28.7-6.8-35.8-8.1c-21.4-3.8-40-.9-53.2 5.8c-13 6.6-20.7 16.8-22.6 28.9z"]
};
var faRupee = faRupeeSign;
var faFileImage = {
  prefix: 'fal',
  iconName: 'file-image',
  icon: [384, 512, [128443], "f1c5", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM181.3 368.9c-2.9 4.3-7.7 7-12.9 7.1s-10.1-2.2-13.2-6.4l-14.4-19.3L99 416H285.1L219.7 311.3l-38.4 57.6zM219.9 272c8 0 15.5 4.1 19.8 11l76 121.5c2.8 4.5 4.3 9.7 4.3 15.1c0 15.7-12.7 28.4-28.4 28.4H92.4C76.7 448 64 435.3 64 419.6c0-5.4 1.5-10.7 4.4-15.2l51.8-81.4c4.3-6.8 11.9-10.9 19.9-10.9c7.4 0 14.4 3.5 18.9 9.4l8.1 10.9 33.3-49.9c4.3-6.5 11.6-10.4 19.4-10.4z"]
};
var faCircleQuestion = {
  prefix: 'fal',
  iconName: 'circle-question',
  icon: [512, 512, [62108, "question-circle"], "f059", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8H280c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V258.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H222.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faQuestionCircle = faCircleQuestion;
var faImageUser = {
  prefix: 'fal',
  iconName: 'image-user',
  icon: [512, 512, [], "e1b8", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM299.4 320H212.6c-18.6 0-34 14-36.3 32H335.7c-2.2-18-17.6-32-36.3-32zm-86.9-32H256h43.4c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4c0-37.9 30.7-68.6 68.6-68.6z"]
};
var faBuoy = {
  prefix: 'fal',
  iconName: 'buoy',
  icon: [576, 512, [], "e5b5", "M192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h12.3L147 304H96c-17.7 0-32 14.3-32 32v16c0 13.3 1.8 26.1 5.2 38.3c10-4.6 20.9-6.5 31.7-5.7C97.7 374.3 96 363.4 96 352l0-16H480v16c0 11.4-1.7 22.3-4.8 32.6c10.8-.8 21.7 1.1 31.7 5.7c3.4-12.2 5.2-25.1 5.2-38.3V336c0-17.7-14.3-32-32-32H429L371.7 32H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H192zM339 32l9.8 46.4-60.8 76-60.8-76L237 32H339zM218.7 119l48.8 61L183.8 284.6 218.7 119zM288 205.6L366.7 304H209.3L288 205.6zm104.2 79L308.5 180l48.8-61 34.9 165.7zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faPlaneDeparture = {
  prefix: 'fal',
  iconName: 'plane-departure',
  icon: [640, 512, [128747], "f5b0", "M158.7 105.4c11.5-5.2 24.5-5.7 36.4-1.4L375 170c4.2 1.5 8.8 1.3 12.8-.8l88-45c15.8-8.1 33.3-12.3 51-12.3h61c12.7 0 21.1 13.1 15.8 24.6c-15.4 33.4-41.7 60.5-74.6 77L255.6 350.3c-2.2 1.1-4.7 1.7-7.2 1.7H109.3c-4.2 0-8.3-1.7-11.3-4.7L34.1 283.5l23.7-13.6c4.4-2.5 9.8-2.8 14.4-.7l57.2 25.4c4.4 2 9.5 1.8 13.8-.4l115-58.8c5.1-2.6 8.5-7.8 8.7-13.6s-2.6-11.2-7.5-14.3L121.9 122.2l-6.6-14.6 6.6 14.6 36.9-16.8zM206.1 74c-19.7-7.2-41.5-6.4-60.6 2.3L108.6 93.1c-23.3 10.6-25.4 42.8-3.6 56.3l113.5 70.5-83 42.4L85.3 240l-6.1 13.7L85.3 240c-14-6.2-30-5.4-43.3 2.2L18.2 255.7c-18.3 10.5-21.7 35.5-6.8 50.4l63.8 63.8c9 9 21.2 14.1 33.9 14.1H248.4c7.5 0 14.8-1.7 21.5-5.1L543.3 242.2c39.4-19.7 70.9-52.2 89.3-92.2c15.1-32.7-8.8-70-44.8-70h-61c-22.8 0-45.2 5.4-65.5 15.8l-81.8 41.8L206.1 74zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faHandshakeSlash = {
  prefix: 'fal',
  iconName: 'handshake-slash',
  icon: [640, 512, [], "e060", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 368V160c0-17.7-14.3-32-32-32H560 528v32V338.7l32 25.3V160h48V368c0 8.8-7.2 16-16 16h-6.6L617 409c13.8-8.4 23-23.6 23-41zM403.3 403.3L371 377.8c-.2 1.1-.2 2.2-.2 3.3c.4 8.1-2.3 16.3-8.1 22.9c-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8c-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-28.6-28.6c-12.4-12.4-28.9-19.8-46.3-20.9V173.3L54.6 128H32c-17.7 0-32 14.3-32 32V368c0 26.5 21.5 48 48 48H64c26.5 0 48-21.5 48-48V352.3c8.9 1 17.2 5 23.6 11.4l28.6 28.6 15.4 15.4 .1 .1 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6c.8-.7 1.6-1.4 2.3-2.2c26.3 21.3 65.3 18.6 88.4-7.3c6-6.7 10.3-14.4 13-22.5c1.2 .3 2.5 .5 3.8 .7zM196.4 240l-2.8-2.2c.2 .8 .4 1.5 .6 2.2h2.3zM292.3 99l-30.9 29.2 25.4 20 27.5-26C332.2 105.4 355.8 96 380.4 96c22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.5 2.1 5.6 3.4 8.8 3.7V121.8L462.9 94.1C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35zm-54.9 .2L272.6 64h-8.7c-22.5 0-44.6 5.3-64.5 15.3l28.7 22.6c3.1-1 6.2-1.9 9.3-2.7zm121.4 79.1l-15.6 14.4L366.3 211l18-14.6c2.4-5.6 1.5-12.4-2.9-17.2c-6-6.5-16.1-6.9-22.6-.9zM80 160V368c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V160H80z"]
};
var faBookBookmark = {
  prefix: 'fal',
  iconName: 'book-bookmark',
  icon: [448, 512, [], "e0bb", "M0 64C0 28.7 28.7 0 64 0H176 336h64c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM320 32H192V206.7l54-43.2c5.8-4.7 14.1-4.7 20 0l54 43.2V32zM160 32H64C46.3 32 32 46.3 32 64l0 328.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H352V240c0 6.2-3.5 11.8-9.1 14.4s-12.1 1.9-16.9-1.9l-70-56-70 56c-4.8 3.8-11.4 4.6-16.9 1.9s-9.1-8.3-9.1-14.4V32zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64z"]
};
var faBorderCenterH = {
  prefix: 'fal',
  iconName: 'border-center-h',
  icon: [448, 512, [], "f89c", "M16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 240zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM128 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM416 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-384a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM224 328a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 328a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM416 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 136a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCanFood = {
  prefix: 'fal',
  iconName: 'can-food',
  icon: [384, 512, [129387], "e3e6", "M336 432V285.6c-12.8 6.5-27.7 11.9-43.7 16.2c-6.5 1.7-13.3 3.3-20.4 4.7c-1.3 43-36.6 77.6-80 77.6s-78.7-34.5-80-77.6c-7-1.4-13.8-3-20.4-4.7c-16-4.3-30.8-9.7-43.7-16.2V432c0 3 1.5 7.5 7.6 13.3c6.1 5.8 15.9 11.8 29.2 17.1C111.4 473.1 149.3 480 192 480s80.6-6.9 107.2-17.6c13.4-5.3 23.1-11.3 29.2-17.1c6.1-5.8 7.6-10.3 7.6-13.3zm0-183.7V127.6c-7.4 4.7-15.9 8.9-24.9 12.5C279.8 152.6 237.7 160 192 160s-87.8-7.4-119.1-19.9c-9.1-3.6-17.5-7.8-24.9-12.5V248.3c11.7 8.5 29.3 16.4 51.9 22.5c5.6 1.5 11.4 2.9 17.5 4.1C129.1 245.1 158.1 224 192 224s62.9 21.1 74.5 50.9c6.1-1.2 11.9-2.6 17.5-4.1c22.7-6.1 40.3-14 51.9-22.5zM48 80c0 3 1.5 7.5 7.6 13.3c6.1 5.8 15.9 11.8 29.2 17.1C111.4 121.1 149.3 128 192 128s80.6-6.9 107.2-17.6c13.4-5.3 23.1-11.3 29.2-17.1C334.5 87.5 336 83 336 80s-1.5-7.5-7.6-13.3c-6.1-5.8-15.9-11.8-29.2-17.1C272.6 38.9 234.7 32 192 32s-80.6 6.9-107.2 17.6C71.4 54.9 61.7 60.9 55.6 66.7C49.5 72.5 48 77 48 80zm320 0V432v8c0 39.8-78.8 72-176 72s-176-32.2-176-72v-8V80 72C16 32.2 94.8 0 192 0s176 32.2 176 72v8zM192 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faTypewriter = {
  prefix: 'fal',
  iconName: 'typewriter',
  icon: [512, 512, [], "f8e7", "M128 32c-17.7 0-32 14.3-32 32v96H64V64C64 28.7 92.7 0 128 0H356.1c17 0 33.3 6.7 45.3 18.7l27.9 27.9c12 12 18.7 28.3 18.7 45.3V160H416V91.9c0-8.5-3.4-16.6-9.4-22.6L378.7 41.4c-6-6-14.1-9.4-22.6-9.4H128zM32 224v64H64 448h32V224H365.3L352 237.3c-12 12-28.3 18.7-45.3 18.7H205.3c-17 0-33.3-6.7-45.3-18.7l22.6-22.6c6 6 14.1 9.4 22.6 9.4H306.7c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V320c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H146.7c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3L160 237.3 146.7 224 32 224zm32 96V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V320H64zm96 96H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16-48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z"]
};
var faArrowRightFromArc = {
  prefix: 'fal',
  iconName: 'arrow-right-from-arc',
  icon: [512, 512, [], "e4b1", "M32 256C32 132.3 132.3 32 256 32c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.6 0 0 114.6 0 256S114.6 512 256 512c8.8 0 16-7.2 16-16s-7.2-16-16-16C132.3 480 32 379.7 32 256zM362.6 116c-6.6-5.9-16.7-5.3-22.6 1.3s-5.3 16.7 1.3 22.6L453.9 240H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H453.9L341.4 372c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l144-128c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-144-128z"]
};
var faCircleK = {
  prefix: 'fal',
  iconName: 'circle-k',
  icon: [512, 512, [], "e113", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm91.1-356.5c6.4-6.1 6.5-16.3 .4-22.6s-16.3-6.5-22.6-.4L192 260.8V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V298.5 368c0 8.8 7.2 16 16 16s16-7.2 16-16V305.3l44.6-43.1 86.6 115.4c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4l-89-118.6 87.3-84.3z"]
};
var faFaceHandOverMouth = {
  prefix: 'fal',
  iconName: 'face-hand-over-mouth',
  icon: [512, 512, [129762], "e378", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm144.4-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-95 125.3L248 318.6l0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3l0 0-16 16-34 34L280 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5l0 0-5.1 5.1-26.9 26.9-2 2L312 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2V352 298.4c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3v11.7 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 0 0 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6l0 0-34 34zm-11.3-79.2L207 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V352v32.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0z"]
};
var faPopcorn = {
  prefix: 'fal',
  iconName: 'popcorn',
  icon: [448, 512, [127871], "f819", "M178.9 22.9c-8-4.4-17.1-6.9-26.9-6.9c-25.5 0-47 17-53.8 40.3C70 59.2 48 83 48 112c0 4.4 .5 8.6 1.5 12.7C34.5 131.3 23 144.2 18.3 160H54.1c4.4-4.9 10.8-8 17.9-8c6.1 0 11.6-3.4 14.3-8.9s2.1-11.9-1.5-16.8c-3-4-4.8-9-4.8-14.4c0-13.3 10.7-24 24-24c1.7 0 3.3 .2 4.8 .5c4.7 1 9.6-.3 13.4-3.3s5.9-7.7 5.8-12.5l0-.7C128 58.7 138.8 48 152 48c8.1 0 15.2 4 19.6 10.1c3.7 5.3 10.2 7.8 16.5 6.4s11.1-6.4 12.3-12.8C202.4 40.5 212.2 32 224 32s21.6 8.5 23.6 19.7c1.1 6.3 6 11.4 12.3 12.8s12.8-1.1 16.5-6.4C280.8 52 287.9 48 296 48c13.2 0 24 10.7 24 23.9l0 .7c0 4.8 2.1 9.4 5.8 12.5s8.6 4.3 13.4 3.3c1.5-.3 3.2-.5 4.8-.5c13.3 0 24 10.7 24 24c0 3.5-.7 6.8-2.1 9.7c-2.1 4.7-1.8 10 .7 14.5s7 7.4 12.1 8c9.2 1 16.9 7.4 19.9 15.8h32.8c-2.7-19-14.9-34.9-31.7-42.7c.2-1.7 .2-3.5 .2-5.3c0-29-22-52.8-50.2-55.7C343 33 321.5 16 296 16c-9.7 0-18.9 2.5-26.9 6.9C258.9 9 242.5 0 224 0s-34.9 9-45.1 22.9zM33.2 224H98.1l30 210.3c1.2 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1L130.4 224H208V432c0 8.8 7.2 16 16 16s16-7.2 16-16V224h77.6L288.2 429.7c-1.2 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6l30-210.3h64.9L346.9 468.3c-1.9 6.9-8.2 11.7-15.4 11.7h-215c-7.2 0-13.5-4.8-15.4-11.7L33.2 224zM224 192H112.3h-.5H28.2C12.6 192 0 204.6 0 220.2c0 2.5 .3 5.1 1 7.5L70.2 476.8C76 497.6 94.9 512 116.5 512h215c21.6 0 40.5-14.4 46.2-35.2L447 227.7c.7-2.5 1-5 1-7.5c0-15.6-12.6-28.2-28.2-28.2H336.2h-.5H224z"]
};
var faHouseWater = {
  prefix: 'fal',
  iconName: 'house-water',
  icon: [576, 512, ["house-flood"], "f74f", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V393c9.9-5.7 20.9-8.6 32-8.6V206.7L288 37.3 480 206.7V384.5c11.1 0 22.1 2.9 32 8.6V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM208 208v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32zm128 0v96H240V208h96zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faHouseFlood = faHouseWater;
var faObjectSubtract = {
  prefix: 'fal',
  iconName: 'object-subtract',
  icon: [512, 512, [], "e49e", "M64 32l32 0V0H64C28.7 0 0 28.7 0 64V96H32l0-32c0-17.7 14.3-32 32-32zm160 0V0H128V32l96 0zM32 128H0v96H32l0-96zm0 128H0v32c0 35.3 28.7 64 64 64H96V320H64c-17.7 0-32-14.3-32-32l0-32zm96 96h32l32 0h32V320H192 160 128v32zm32 32l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64l-64 0v32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-64H160zM352 192l0-32V128H320v32 32 32h32V192zm0-128c0-35.3-28.7-64-64-64H256V32l32 0c17.7 0 32 14.3 32 32V96h32V64zM256 320v32h32c35.3 0 64-28.7 64-64V256H320v32c0 17.7-14.3 32-32 32H256z"]
};
var faCodeBranch = {
  prefix: 'fal',
  iconName: 'code-branch',
  icon: [448, 512, [], "f126", "M80 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4V273.6c20.3-20.7 48.7-33.6 80-33.6h96c44.2 0 80-35.8 80-80v-1.6c-36.5-7.4-64-39.7-64-78.4c0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4V160c0 61.9-50.1 112-112 112H176c-44.2 0-80 35.8-80 80v1.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V352 158.4C27.5 151 0 118.7 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faWarehouseFull = {
  prefix: 'fal',
  iconName: 'warehouse-full',
  icon: [640, 512, ["warehouse-alt"], "f495", "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H128V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224zM352 400v80h80c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H352zm-32 80V400H192v64c0 8.8 7.2 16 16 16H320zm0-176c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64H320V304zm112 64c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v32 32h32 48z"]
};
var faWarehouseAlt = faWarehouseFull;
var faHatCowboy = {
  prefix: 'fal',
  iconName: 'hat-cowboy',
  icon: [640, 512, [], "f8c0", "M249.7 64c4.3 .2 6.7 1.1 8.2 1.8c2.1 1 4.3 2.6 8.5 6.3c.6 .5 1.2 1.1 1.9 1.7l0 0C276.7 81.3 293 96 320 96s43.3-14.7 51.7-22.2l0 0c.7-.6 1.3-1.2 1.9-1.7c4.2-3.7 6.4-5.2 8.5-6.3c1.5-.7 3.9-1.6 8.2-1.8c.5 .4 1.2 1 2.3 1.9c3.9 3.7 8.8 10.5 14.4 21c11.1 21 21.4 50.4 30.2 81.7c8.7 30.9 15.5 62 20.2 85.5c.8 4 1.5 7.9 2.2 11.4c10.8-3.7 21-7.6 30.3-11.7C476.4 184.2 441.4 32 392 32c-21.3 0-31.6 9.1-41.2 17.6C342.3 57 334.4 64 320 64s-22.3-7-30.8-14.4C279.6 41.1 269.3 32 248 32c-49.3 0-84.4 152.2-97.9 221.9c9.4 4.1 19.5 8 30.3 11.7c.7-3.5 1.4-7.3 2.2-11.3c4.7-23.5 11.5-54.6 20.2-85.5C211.6 137.4 221.9 108 233 87c5.6-10.5 10.6-17.3 14.4-21c1-1 1.8-1.6 2.3-1.9zm139.9-.5a.1 .1 0 1 0 0 .2 .1 .1 0 1 0 0-.2zm-139.3 .1a.1 .1 0 1 0 .3 .1 .1 .1 0 1 0 -.3-.1zm-239 156c-9.5 5.9-13.5 17.9-9.9 28.5c13.5 37.7 38.4 72.3 66.1 100.6C116.4 398.9 196.4 448 320 448s203.7-49.1 252.6-99.2c27.7-28.3 52.6-62.9 66.1-100.6c3.6-10.6-.4-22.6-9.9-28.5c-9.5-5.9-21.7-4.5-29.6 3.3c-20.4 19.4-45.3 34.8-70.1 47.7C481.8 295.2 411.6 320 320.1 320s-161.8-24.8-209-49.3C86.3 257.8 61.3 242.4 40.9 223c-7.9-7.9-20.2-9.2-29.6-3.3zm533.1 80.6c14.9-7.7 30.5-16.6 45.5-27.1c-11.3 18.7-25.4 36.4-41.1 52.4c-43.3 44.4-115.1 89.2-228.8 89.2c-113.7 0-185.4-44.8-228.7-89.2c-15.6-16-29.8-33.7-41.1-52.4c15 10.4 30.6 19.3 45.5 27.1c51.1 26.6 126.7 53 224.4 53c97.7 0 173.2-26.5 224.3-53z"]
};
var faBridge = {
  prefix: 'fal',
  iconName: 'bridge',
  icon: [576, 512, [], "e4c8", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H80v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H96 224 352 480h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H496V64h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 352 224 96 16zM464 64v64H368V64h96zM336 64v64H240V64h96zM208 64v64H112V64h96zM16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H32c35.3 0 64 28.7 64 64v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V336c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V336c0-35.3 28.7-64 64-64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H544c-53 0-96 43-96 96v96c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V336c0-53-43-96-96-96s-96 43-96 96v96c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V336c0-53-43-96-96-96H16z"]
};
var faPhoneFlip = {
  prefix: 'fal',
  iconName: 'phone-flip',
  icon: [512, 512, [128381, "phone-alt"], "f879", "M136.2 275.2c16.4-7 35.4-2.4 46.7 11.4l33.2 40.6c46-26.7 84.4-65.1 111.1-111.1L286.7 183c-13.8-11.3-18.5-30.3-11.4-46.7l48-112C330.8 6.7 349.7-3.1 368.4 .9l112 24C498.8 28.8 512 45.1 512 64v0c0 236.7-183.5 430.5-416 446.9c-4.5 .3-9.1 .6-13.7 .8c0 0 0 0 0 0c0 0-.1 0-.1 0c-6.1 .2-12.1 .4-18.3 .4l0 0c-18.9 0-35.2-13.2-39.1-31.6l-24-112c-4-18.7 5.8-37.6 23.4-45.1l112-48zM64.3 480C293.9 479.8 480 293.7 480 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0-3.8-2.6-7-6.3-7.8l-112-24c-3.7-.8-7.5 1.2-9 4.7l-48 112c-1.4 3.3-.5 7.1 2.3 9.3l40.6 33.2c12.1 9.9 15.3 27.2 7.4 40.8c-29.5 50.9-71.9 93.3-122.7 122.7c-13.6 7.9-30.9 4.7-40.8-7.4l-33.2-40.6c-2.3-2.8-6.1-3.7-9.3-2.3l-112 48c-3.5 1.5-5.5 5.3-4.7 9l24 112c.8 3.7 4 6.3 7.8 6.3c.1 0 .2 0 .3 0z"]
};
var faPhoneAlt = faPhoneFlip;
var faArrowDownFromDottedLine = {
  prefix: 'fal',
  iconName: 'arrow-down-from-dotted-line',
  icon: [448, 512, [], "e090", "M235.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 425.4V320 176c0-8.8 7.2-16 16-16s16 7.2 16 16V320 425.4L340.7 324.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128zM32 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm384 0a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm72-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faFileDoc = {
  prefix: 'fal',
  iconName: 'file-doc',
  icon: [512, 512, [], "e5ed", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z"]
};
var faSquareQuarters = {
  prefix: 'fal',
  iconName: 'square-quarters',
  icon: [448, 512, [], "e44e", "M55.7 65.1L224 233.4 392.3 65.1c-2.6-.7-5.4-1.1-8.3-1.1H64c-2.9 0-5.6 .4-8.3 1.1zM33.1 87.7C32.4 90.4 32 93.1 32 96V416c0 2.9 .4 5.6 1.1 8.3L201.4 256 33.1 87.7zM55.7 446.9c2.6 .7 5.4 1.1 8.3 1.1H384c2.9 0 5.6-.4 8.3-1.1L224 278.6 55.7 446.9zm359.2-22.6c.7-2.6 1.1-5.4 1.1-8.3V96c0-2.9-.4-5.6-1.1-8.3L246.6 256 414.9 424.3zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faTruckFront = {
  prefix: 'fal',
  iconName: 'truck-front',
  icon: [512, 512, [], "e2b7", "M80 32C53.5 32 32 53.5 32 80V248.4c10.8-9.7 23.9-17 38.3-21l31.3-88.8c9-25.6 33.2-42.7 60.4-42.7H350c27.1 0 51.3 17.1 60.4 42.7l31.3 88.8c14.4 4 27.4 11.3 38.3 21V80c0-26.5-21.5-48-48-48H80zM32 320v48c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V320c0-35.3-28.7-64-64-64H96c-35.3 0-64 28.7-64 64zM0 320V80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V320v48c0 26.2-12.6 49.4-32 64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V446.4c-5.2 1-10.5 1.6-16 1.6H80c-5.5 0-10.8-.6-16-1.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V432C12.6 417.4 0 394.2 0 368V320zm105.4-96H406.6l-26.3-74.7C375.7 136.6 363.6 128 350 128H162c-13.6 0-25.7 8.6-30.2 21.3L105.4 224zM80 328a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCat = {
  prefix: 'fal',
  iconName: 'cat',
  icon: [576, 512, [128008], "f6be", "M352 33V144c0 44.2 35.8 80 80 80s80-35.8 80-80V33c0-.5-.4-1-1-1c-.3 0-.5 .1-.7 .3L472 70.6c-6 6-14.1 9.4-22.6 9.4H414.6c-8.5 0-16.6-3.4-22.6-9.4L353.7 32.3c-.2-.2-.4-.3-.7-.3c-.5 0-1 .4-1 1zm1-33c8.7 0 17.1 3.5 23.3 9.7L414.6 48h34.7L487.7 9.7C493.9 3.5 502.3 0 511 0c18.2 0 33 14.8 33 33V144c0 61.9-50.1 112-112 112s-112-50.1-112-112V33c0-18.2 14.8-33 33-33zM128 299.2c33.8-61.5 92.1-108.2 162.9-126.2c2.2 10.6 5.5 20.9 9.9 30.5C200.2 228.2 128 318.7 128 424v8c0 26.5 21.5 48 48 48H304l0 0h42.6c2.9 0 5.3-2.4 5.3-5.3c0-14.7-11.9-26.7-26.7-26.7H288c-8.8 0-16-7.2-16-16v0V392c0-22.1-17.9-40-40-40h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8c39.8 0 72 32.2 72 72v4.4L421.4 292c3-2.6 6.7-4 10.5-4l.1 0 .1 0c2.2 0 4.4 .5 6.4 1.4c5.7 2.6 9.4 8.3 9.4 14.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V279.8c11.4-4 22.1-9.4 32-16.1V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V339.6l-86.1 76.5c30.3 2.3 54.1 27.6 54.1 58.5c0 20.6-16.7 37.3-37.3 37.3L304 512H176l-.1 0c-44.1-.1-79.9-35.9-79.9-80v-8V176.5c0-24.2-18-44.6-42-47.6l-7.9-1c-8.8-1.1-15-9.1-13.9-17.9s9.1-15 17.9-13.9l7.9 1c40 5 70.1 39 70.1 79.4V299.2zM384 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTrashXmark = {
  prefix: 'fal',
  iconName: 'trash-xmark',
  icon: [448, 512, [], "e2b4", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64h47.1H416h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H413.7L388.2 452.6C385.9 486.1 358 512 324.4 512H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64.1h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480H324.4c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zm82.3 116.7c6.2-6.2 16.4-6.2 22.6 0L224 265.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 288l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faCircleCaretLeft = {
  prefix: 'fal',
  iconName: 'circle-caret-left',
  icon: [512, 512, ["caret-circle-left"], "f32e", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-352 0c0 9.6 4 18.7 11 25.2l102.8 95.5c5.1 4.7 11.8 7.3 18.7 7.3c15.2 0 27.5-12.3 27.5-27.5l0-201c0-15.2-12.3-27.5-27.5-27.5c-6.9 0-13.6 2.6-18.7 7.3L171 230.8c-7 6.5-11 15.6-11 25.2zm32.7 1.7c-.5-.4-.7-1.1-.7-1.7s.3-1.3 .7-1.7L288 165.8l0 180.3-95.3-88.4z"]
};
var faCaretCircleLeft = faCircleCaretLeft;
var faFiles = {
  prefix: 'fal',
  iconName: 'files',
  icon: [448, 512, [], "e178", "M160 384c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H304v80c0 17.7 14.3 32 32 32h80c0 .3 0 .5 0 .8V352c0 17.7-14.3 32-32 32H160zM336 57.5L390 112H336V57.5zM160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V144.8c0-12.7-5-24.8-13.9-33.8l-96-96.8C329.1 5.1 316.8 0 304 0H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faAnchorCircleExclamation = {
  prefix: 'fal',
  iconName: 'anchor-circle-exclamation',
  icon: [640, 512, [], "e4ab", "M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V480H240c-79.5 0-144-64.5-144-144V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h48 48c17.2 0 33.8-2.5 49.5-7c-9.8-7.9-18.8-16.9-26.7-26.7c-7.4 1.2-15 1.8-22.8 1.8H304V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zm96 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faFaceClouds = {
  prefix: 'fal',
  iconName: 'face-clouds',
  icon: [640, 512, [], "e47d", "M99.8 54.9C97.2 60.4 91.6 64 85.4 64H64C46.3 64 32 78.3 32 96s14.3 32 32 32H216c22.1 0 40-17.9 40-40s-17.9-40-40-40c-8.7 0-16.6 2.7-23.2 7.4c-3.6 2.6-8.1 3.5-12.4 2.7s-8.1-3.5-10.4-7.2C162.9 39.5 150.3 32 136 32c-15.9 0-29.7 9.3-36.2 22.9zM136 0c20.3 0 38.6 8.4 51.6 21.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72H64C28.7 160 0 131.3 0 96S28.7 32 64 32H76.1C89 12.7 111 0 136 0zM288.3 1.9C298.7 .7 309.3 0 320 0C461.4 0 576 114.6 576 256c0 7.3-.3 14.5-.9 21.7c-9.4-6-20-10.2-31.3-12.2c.1-3.1 .2-6.3 .2-9.4C544 132.3 443.7 32 320 32c-3.6 0-7.1 .1-10.7 .2C304 21 296.9 10.8 288.3 1.9zM96 256c0 90.7 54 168.9 131.6 204.1c4 15.5 11.2 29.7 20.9 41.8C141.9 470.9 64 372.6 64 256c0-22.1 2.8-43.5 8.1-64h33.2c-6 20.3-9.3 41.8-9.3 64zm120.4-48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM416 304c-35.3 0-64 28.7-64 64c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48s21.5 48 48 48H560c26.5 0 48-21.5 48-48c0-24.7-18.6-45-42.5-47.7c-4.4-.5-8.4-2.8-11-6.3s-3.7-8-2.9-12.4c.3-1.8 .5-3.7 .5-5.6c0-17.7-14.3-32-32-32c-9.2 0-17.6 3.9-23.4 10.2c-3.4 3.7-8.4 5.5-13.4 5s-9.5-3.4-12-7.8C459.9 316.6 439.4 304 416 304zm-94.9 49.4c7-46.1 46.8-81.4 94.9-81.4c28.7 0 54.5 12.6 72 32.5c9.4-5.4 20.3-8.5 32-8.5c33.9 0 61.6 26.3 63.9 59.6C616.4 365.8 640 396.1 640 432c0 44.2-35.8 80-80 80H336c-44.2 0-80-35.8-80-80c0-39.1 28-71.6 65.1-78.6z"]
};
var faUserCrown = {
  prefix: 'fal',
  iconName: 'user-crown',
  icon: [448, 512, [], "f6a4", "M238.7 4.4C234.3 1.5 229.2 0 224 0s-10.3 1.5-14.7 4.4L176.9 26.1c-5.4 3.6-12.4 3.6-17.8 0L124 2.7C121.4 .9 118.3 0 115.2 0H112c-8.8 0-16 7.2-16 16V128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128 16c0-8.8-7.2-16-16-16h-3.2c-3.2 0-6.2 .9-8.9 2.7L288.9 26.1c-5.4 3.6-12.4 3.6-17.8 0L238.7 4.4zM320 112H128V43.8l13.4 8.9c16.1 10.7 37.1 10.7 53.3 0L224 33.1l29.4 19.6c16.1 10.7 37.1 10.7 53.3 0L320 43.8V112zM128 144H320c0 53-43 96-96 96s-96-43-96-96zm40 192H280c75.1 0 136 60.9 136 136v8H32v-8c0-75.1 60.9-136 136-136zm0-32C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168z"]
};
var faTruckField = {
  prefix: 'fal',
  iconName: 'truck-field',
  icon: [640, 512, [], "e58d", "M320 64c17.7 0 32 14.3 32 32v96 32V352H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64V288 128 96c0-17.7 14.3-32 32-32H320zM32 128c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 64c0 53 43 96 96 96s96-43 96-96h96 32c0 53 43 96 96 96s96-43 96-96h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V256c0-35.3-28.7-64-64-64H521.6l-42.4-78.8C470.8 97.7 454.5 88 436.9 88H383.5c-3.9-31.6-30.9-56-63.5-56H96C60.7 32 32 60.7 32 96v32zm352 64V120h52.9c5.9 0 11.3 3.2 14.1 8.4L485.2 192H384zm5.5 160H384V224H511.7c.2 0 .4 0 .6 0H544c17.7 0 32 14.3 32 32v96h-5.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64zM96 384a64 64 0 1 1 128 0A64 64 0 1 1 96 384zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faRoute = {
  prefix: 'fal',
  iconName: 'route',
  icon: [512, 512, [], "f4d7", "M452.1 164.2c-11.7 18.7-25 36.5-36.1 50.4c-11.1-13.9-24.4-31.7-36.1-50.4C362.1 135.7 352 111.2 352 96c0-35.3 28.7-64 64-64s64 28.7 64 64c0 15.2-10.1 39.7-27.9 68.2zM427.4 251C452.9 221.1 512 146.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 38.7 35 91.9 62.7 128H336c-44.2 0-80 35.8-80 80s35.8 80 80 80h96c26.5 0 48 21.5 48 48s-21.5 48-48 48H166c-9.4 12.3-18.6 23.2-26.4 32H432c44.2 0 80-35.8 80-80s-35.8-80-80-80H336c-26.5 0-48-21.5-48-48s21.5-48 48-48h76.9c5.1 1.1 10.7-.6 14.5-5zM132.2 417.2C120.5 435 107.1 451.7 96 464.6C84.9 451.7 71.5 435 59.8 417.2C41.9 390.3 32 367 32 352c0-35.3 28.7-64 64-64s64 28.7 64 64c0 15-9.9 38.3-27.8 65.2zm-7.6 63.1C152.9 446.7 192 392.8 192 352c0-53-43-96-96-96s-96 43-96 96c0 50.5 59.8 121 85 148.4c6 6.5 16 6.5 21.9 0c1.6-1.7 3.3-3.6 5.1-5.6c1.8-2 3.8-4.2 5.8-6.6c2.2-2.5 4.4-5.1 6.7-7.9zM440 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCartCircleCheck = {
  prefix: 'fal',
  iconName: 'cart-circle-check',
  icon: [640, 512, [], "e3f1", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faClipboardQuestion = {
  prefix: 'fal',
  iconName: 'clipboard-question',
  icon: [384, 512, [], "e4e3", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM104.7 233.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H216c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V352c0 8.8 7.2 16 16 16s16-7.2 16-16V332.3l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3H158.9c-25.5 0-47.7 17.2-54.2 41.8zM216 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faPanorama = {
  prefix: 'fal',
  iconName: 'panorama',
  icon: [640, 512, [], "e209", "M45.6 64C38.1 64 32 70.1 32 77.6V434.4c0 7.5 6.1 13.6 13.6 13.6c1.6 0 3-.2 4.5-.7c2.5-.8 7.1-2.3 13.6-4.3l3.4-4.6L198.4 263.5c12.8-17.1 38.4-17.1 51.2 0L280 304l78.4-104.5c12.8-17.1 38.4-17.1 51.2 0L588.8 438.4l7.1 9.5c6.8-.8 12.1-6.5 12.1-13.5V77.6c0-7.5-6.1-13.6-13.6-13.6c-1.6 0-3 .2-4.5 .7C573.6 70.2 467.1 104 320 104S66.4 70.2 50.2 64.7c-1.5-.5-3-.7-4.5-.7zM546.1 434.9L384 218.7 292.8 340.3l-53.3 71.1c25.1-2.1 52-3.4 80.5-3.4c98.6 0 179 15.2 226.1 26.9zM196 415.9l64-85.3-36-48L113.3 430.3c22.7-5 50.6-10.2 82.8-14.4zM60.4 477.6c-4.7 1.6-9.7 2.4-14.7 2.4C20.4 480 0 459.6 0 434.4V77.6C0 52.4 20.4 32 45.6 32c5.1 0 10 .8 14.7 2.4C74.6 39.2 177.6 72 320 72s245.4-32.8 259.6-37.6c4.7-1.6 9.7-2.4 14.7-2.4C619.6 32 640 52.4 640 77.6V434.4c0 25.2-20.4 45.6-45.6 45.6c-5 0-10-.8-14.7-2.4C565.4 472.8 462.4 440 320 440s-245.4 32.8-259.6 37.6zM112 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCommentMedical = {
  prefix: 'fal',
  iconName: 'comment-medical',
  icon: [512, 512, [], "f7f5", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-16 96c-17.7 0-32 14.3-32 32v32H176c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V288h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H304V160c0-17.7-14.3-32-32-32H240zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H288c-8.8 0-16 7.2-16 16v48H240V272c0-8.8-7.2-16-16-16H176V224h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V160z"]
};
var faTeethOpen = {
  prefix: 'fal',
  iconName: 'teeth-open',
  icon: [576, 512, [], "f62f", "M96 64H480c35.3 0 64 28.7 64 64v64c0 17.7-14.3 32-32 32V192c0-35.3-28.7-64-64-64c-14 0-27 4.5-37.6 12.2C399.5 114.2 373.9 96 344 96c-22.6 0-42.8 10.4-56 26.7C274.8 106.4 254.6 96 232 96c-29.9 0-55.5 18.2-66.4 44.2C155 132.5 142 128 128 128c-35.3 0-64 28.7-64 64l0 32c-17.7 0-32-14.3-32-32V128c0-35.3 28.7-64 64-64zM416 224V192c0-17.7 14.3-32 32-32s32 14.3 32 32v32H416zm-112 0V168c0-22.1 17.9-40 40-40s40 17.9 40 40v24 32H304zm-72-96c22.1 0 40 17.9 40 40v56H192V192 168c0-22.1 17.9-40 40-40zM176 256H288 400h96 16c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H80h96zm-16-64v32H96V192c0-17.7 14.3-32 32-32s32 14.3 32 32zM480 448H96c-35.3 0-64-28.7-64-64V352c0-17.7 14.3-32 32-32l0 32c0 35.3 28.7 64 64 64c16.8 0 32-6.5 43.5-17c12.8 19.9 35.1 33 60.5 33c22.6 0 42.8-10.4 56-26.7c13.2 16.3 33.4 26.7 56 26.7c25.4 0 47.7-13.2 60.5-33c11.4 10.6 26.7 17 43.5 17c35.3 0 64-28.7 64-64V320c17.7 0 32 14.3 32 32v32c0 35.3-28.7 64-64 64zM272 360c0 22.1-17.9 40-40 40s-40-17.9-40-40v-8V320h80v40zm16-72H176 80 64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H496 400 288zm128 32h64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320zm-32 32v8c0 22.1-17.9 40-40 40s-40-17.9-40-40V320h80v32zm-224 0c0 17.7-14.3 32-32 32s-32-14.3-32-32V320h64v32z"]
};
var faUserTieHairLong = {
  prefix: 'fal',
  iconName: 'user-tie-hair-long',
  icon: [448, 512, [], "e460", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM224 0c70.7 0 128 57.3 128 128c0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9c0 20.6-16.7 37.3-37.3 37.3H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.7c2.9 0 5.3-2.4 5.3-5.3c0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3c0 2.9 2.4 5.3 5.3 5.3H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H69.3C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128C96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM180.4 477.9L124.7 357.2C71.5 372.9 32.6 421.9 32 480H181.4c-.3-.7-.7-1.4-1-2.1zM416 480c-.6-58.1-39.5-107.1-92.7-122.8L267.6 477.9c-.3 .7-.7 1.4-1 2.1H416zM131.8 322.7c6.8-1.3 13.4 2.5 16.3 8.8L180.1 401l21.7-65H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-9.8l21.7 65 32.1-69.5c2.9-6.3 9.5-10 16.3-8.8c75 13.8 131.8 79.6 131.8 158.6c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-79 56.8-144.7 131.8-158.6zM248.3 443.4L224 370.6l-24.3 72.8 9.7 21.1c5.7 12.4 23.3 12.4 29.1 0l9.7-21.1z"]
};
var faFileCircleMinus = {
  prefix: 'fal',
  iconName: 'file-circle-minus',
  icon: [576, 512, [], "e4ed", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faHeadSideMedical = {
  prefix: 'fal',
  iconName: 'head-side-medical',
  icon: [512, 512, [], "f809", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zM224 96c-17.7 0-32 14.3-32 32v32H160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H288V128c0-17.7-14.3-32-32-32H224zm0 80V128h32v48c0 8.8 7.2 16 16 16h48v32H272c-8.8 0-16 7.2-16 16v48H224V240c0-8.8-7.2-16-16-16H160V192h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z"]
};
var faTags = {
  prefix: 'fal',
  iconName: 'tags',
  icon: [512, 512, [], "f02c", "M204.1 32c12.7 0 24.9 5.1 33.9 14.1L410.7 218.7c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0L14.1 270.1c-9-9-14.1-21.2-14.1-33.9V80C0 53.5 21.5 32 48 32H204.1zM36.7 247.4L209.4 420.1c12.5 12.5 32.8 12.5 45.3 0L388.1 286.6c12.5-12.5 12.5-32.8 0-45.3L215.4 68.7c-3-3-7.1-4.7-11.3-4.7H48c-8.8 0-16 7.2-16 16V236.1c0 4.2 1.7 8.3 4.7 11.3zM308.4 36.9c6.1-6.4 16.2-6.6 22.6-.5l141.3 135c52.8 50.4 52.8 134.7 0 185.1l-124.6 119c-6.4 6.1-16.5 5.9-22.6-.5s-5.9-16.5 .5-22.6l124.6-119c39.6-37.8 39.6-101 0-138.8L308.9 59.6c-6.4-6.1-6.6-16.2-.5-22.6zM104 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faWineGlass = {
  prefix: 'fal',
  iconName: 'wine-glass',
  icon: [320, 512, [127863], "f4e3", "M49.6 160H270.4l3.2 35.6C279.7 262.4 227.1 320 160 320S40.3 262.4 46.4 195.6L49.6 160zm2.9-32l8.7-96 197.6 0 8.7 96H52.5zM29.4 29.1L14.5 192.7C7.2 272.8 65.9 342.7 144 351.1V480H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V351.1c78.1-8.5 136.8-78.3 129.5-158.5L290.6 29.1C289.1 12.6 275.3 0 258.8 0H61.2C44.7 0 30.9 12.6 29.4 29.1z"]
};
var faForwardFast = {
  prefix: 'fal',
  iconName: 'forward-fast',
  icon: [512, 512, [9197, "fast-forward"], "f050", "M496 64c-8.8 0-16 7.2-16 16V215.8L301.4 70.2c-5-4-11.2-6.2-17.6-6.2C268.4 64 256 76.4 256 91.8V241.9L45.4 70.2c-5-4-11.2-6.2-17.6-6.2C12.4 64 0 76.4 0 91.8V420.2C0 435.6 12.4 448 27.8 448c6.4 0 12.6-2.2 17.6-6.2L256 270.1V420.2c0 15.4 12.4 27.8 27.8 27.8c6.4 0 12.6-2.2 17.6-6.2L480 296.2V432c0 8.8 7.2 16 16 16s16-7.2 16-16V270.1 241.9 80c0-8.8-7.2-16-16-16zM478.7 256L288 411.4V100.6L478.7 256zM32 100.6L222.7 256 32 411.4V100.6z"]
};
var faFastForward = faForwardFast;
var faFaceMehBlank = {
  prefix: 'fal',
  iconName: 'face-meh-blank',
  icon: [512, 512, [128566, "meh-blank"], "f5a4", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faMehBlank = faFaceMehBlank;
var faUserRobot = {
  prefix: 'fal',
  iconName: 'user-robot',
  icon: [448, 512, [], "e04b", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H144c-44.2 0-80 35.8-80 80v96c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80H240V16zM96 144c0-26.5 21.5-48 48-48H304c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H240V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H176V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c-26.5 0-48-21.5-48-48V144zM16 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM160 176a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-48-16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm192 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM96 384H352c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16H368V448c0-17.7-14.3-32-32-32H288 224 112c-17.7 0-32 14.3-32 32v32H48c-8.8 0-16-7.2-16-16V448c0-35.3 28.7-64 64-64zm112 64v32H176V448h32zm-96 0h32v32H112V448zm112 64h64 48 32 32c26.5 0 48-21.5 48-48V448c0-53-43-96-96-96H96c-53 0-96 43-96 96v16c0 26.5 21.5 48 48 48H80h32 48 64zm16-64h32v32H240V448zm96 0v32H304V448h32z"]
};
var faSquareParking = {
  prefix: 'fal',
  iconName: 'square-parking',
  icon: [448, 512, [127359, "parking"], "f540", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM176 288h80c35.3 0 64-28.7 64-64s-28.7-64-64-64H176V288zm80 32H176v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 152c0-13.3 10.7-24 24-24h88c53 0 96 43 96 96s-43 96-96 96z"]
};
var faParking = faSquareParking;
var faCardDiamond = {
  prefix: 'fal',
  iconName: 'card-diamond',
  icon: [384, 512, [], "e3ea", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm203.3 84.7l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0zM192 329.4L265.4 256 192 182.6 118.6 256 192 329.4z"]
};
var faFaceZipper = {
  prefix: 'fal',
  iconName: 'face-zipper',
  icon: [512, 512, [], "e3a5", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 10.1-.7 20.1-2 29.9c-1.2 8.8 5 16.8 13.7 18s16.8-5 18-13.7c1.5-11.2 2.3-22.6 2.3-34.1C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c32.4 0 63.5-6 92.1-17.1c8.2-3.2 12.4-12.4 9.2-20.7s-12.4-12.4-20.7-9.2c-25 9.6-52.1 14.9-80.6 14.9C132.3 480 32 379.7 32 256zm192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336zm48-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16zM160 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336zm40.4-128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm34.7 84.7l-22.5 22.5c-9.6 9.6-12.1 24.1-6.3 36.3l29.2 61.8c21.7 45.9 82.3 56.4 118.2 20.5s25.4-96.5-20.5-118.2l-61.8-29.2c-12.2-5.8-26.7-3.2-36.3 6.3zm84.4 51.8c25.9 12.2 31.8 46.4 11.6 66.6s-54.4 14.3-66.6-11.6l-29.2-61.8 22.5-22.5 61.8 29.2zm1 40c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0l-16 16c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0l16-16z"]
};
var faFaceRaisedEyebrow = {
  prefix: 'fal',
  iconName: 'face-raised-eyebrow',
  icon: [512, 512, [], "e388", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200.4 240a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm29.4-118.5l4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5c10.7-10.7 28.5-8.9 36.9 3.7zM112 160c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm64 176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faHouseSignal = {
  prefix: 'fal',
  iconName: 'house-signal',
  icon: [576, 512, [], "e012", "M325.6 3.9c6-5.1 14.8-5.1 20.8 0l224 192c6.7 5.8 7.5 15.9 1.7 22.6s-15.8 7.5-22.6 1.7L512 187.9V352c0 35.3-28.7 64-64 64H278.1c-3.1-11-6.9-21.7-11.3-32H448c17.7 0 32-14.3 32-32V160.5L336 37.1 192 160.5V284.3c-10.1-8.3-20.8-15.9-32-22.7V187.9l-37.6 32.2c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6l224-192zM304 176h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32zm0 32v64h64V208H304zM16 256c132.5 0 240 107.5 240 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 368c0-8.8 7.2-16 16-16c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112c-8.8 0-16-7.2-16-16z"]
};
var faSquareChevronUp = {
  prefix: 'fal',
  iconName: 'square-chevron-up',
  icon: [448, 512, ["chevron-square-up"], "f32c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm235.3 68.7l112 112c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 198.6 123.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l112-112c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faChevronSquareUp = faSquareChevronUp;
var faNfcSymbol = {
  prefix: 'fal',
  iconName: 'nfc-symbol',
  icon: [512, 512, [], "e531", "M367.2 475.6c5.1 4.9 12.9 5.8 19 2.2C462.2 433.9 513.1 349.8 513.1 256s-50.9-177.9-126.8-221.8c-7.6-4.4-17.4-1.8-21.9 5.8s-1.8 17.4 5.8 21.9C436.4 100.1 481.1 173.8 481.1 256c0 78-40.2 148.2-100.8 187.9L203 276.4c-6.4-6.1-16.5-5.8-22.6 .6s-5.8 16.5 .6 22.6l186.2 176zM145.9 36.4c-5.1-4.9-12.9-5.8-19-2.3C50.9 78.1 0 162.2 0 256s50.9 177.9 126.8 221.8c7.6 4.4 17.4 1.8 21.9-5.8s1.8-17.4-5.8-21.9C76.7 411.9 32 338.2 32 256c0-77.9 40.2-148.2 100.8-187.9L309 235.6c6.4 6.1 16.5 5.8 22.6-.6s5.8-16.5-.6-22.6L145.9 36.4z"]
};
var faBarsProgress = {
  prefix: 'fal',
  iconName: 'bars-progress',
  icon: [512, 512, ["tasks-alt"], "f828", "M464 96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H320V96H464zM48 96H288v96H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm0-32C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM464 320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H192V320H464zM48 320H160v96H48c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"]
};
var faTasksAlt = faBarsProgress;
var faFaucetDrip = {
  prefix: 'fal',
  iconName: 'faucet-drip',
  icon: [512, 512, [128688], "e006", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H208v48H189.3c-12.7 0-24.9 5.1-33.9 14.1L121.4 160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H128c4.2 0 8.3-1.7 11.3-4.7l38.6-38.6c3-3 7.1-4.7 11.3-4.7H224h34.7c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7h48c61.9 0 112 50.1 112 112c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16c0-26.5-21.5-48-48-48H307.2c-5.7 0-11 3-13.8 8c-13.9 24-39.7 40-69.3 40s-55.5-16.1-69.3-40c-2.9-4.9-8.1-8-13.8-8H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H132.1c20.2 29 53.8 48 91.9 48s71.7-19 91.9-48H368c8.8 0 16 7.2 16 16c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48c0-79.5-64.5-144-144-144H326.6l-33.9-33.9c-9-9-21.2-14.1-33.9-14.1H240V64H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V16zM448 431.6l13.3 21.3c1.8 2.8 2.7 6.1 2.7 9.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-1.7c0-3.3 .9-6.6 2.7-9.4L448 431.6zm-12.2-40.8l-28.2 45.1c-4.9 7.9-7.6 17-7.6 26.4V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-1.7c0-9.3-2.6-18.5-7.6-26.4l-28.2-45.1c-2.6-4.2-7.3-6.8-12.2-6.8s-9.6 2.6-12.2 6.8z"]
};
var faArrowsToLine = {
  prefix: 'fal',
  iconName: 'arrows-to-line',
  icon: [448, 512, [], "e0a7", "M224 192c-4.2 0-8.3-1.7-11.3-4.7l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 137.4 208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 121.4 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-3 3-7.1 4.7-11.3 4.7zM0 256c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm235.3 68.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 374.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V374.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7z"]
};
var faDolphin = {
  prefix: 'fal',
  iconName: 'dolphin',
  icon: [512, 512, [], "e168", "M176 32h49.1c40.5 0 78.7 9.4 112.7 26.2c4 2 8.5 2.2 12.7 .7c32.4-12.1 73.2-24.6 105.2-26.6c-.8 3.3-2.2 7.6-4.2 13c-7.2 18.6-20.2 42.3-31.2 61.1c-3.4 5.8-2.8 13.1 1.5 18.3C458.1 168.8 480 225.2 480 286.9c0 54.4-33.6 100.9-81.2 119.9C409.7 391.3 416 372.4 416 352c0-46.5-33-85.2-76.8-94.1c-4.7-1-9.6 .3-13.3 3.3s-5.9 7.6-5.9 12.4V325c0 6.1-4.9 11-11 11c-2.9 0-5.6-1.1-7.7-3.1l-73.8-72.3c-3-2.9-7-4.6-11.2-4.6H216 176 50.2c-10 0-18.2-8.1-18.2-18.2c0-6.5 3.4-12.4 9-15.7l25.1-14.6c6.9-4.1 9.8-12.6 6.7-20c-5.6-13.4-8.8-28-8.8-43.5C64 82.1 114.1 32 176 32zm280.6-6.3a.1 .1 0 1 0 -.2 .1 .1 .1 0 1 0 .2-.1zM320 416H281.9l-1-2.1C261.9 376 223.1 352 180.7 352H176c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6L190.1 432l-28.4 56.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h4.7c42.4 0 81.2-24 100.2-61.9l1-2.1H320h30.9c89 0 161.1-72.1 161.1-161.1c0-65.3-21.8-125.6-58.6-173.8c10-17.5 21-38.4 27.9-56.2c3.9-10.2 7.4-21.4 7.3-30.9c0-4.8-1-11.5-5.6-17.3C477.9 2.3 470.6 0 464 0c-37 0-83.5 13.9-118.3 26.5C309 9.5 268.2 0 225.1 0H176C96.5 0 32 64.5 32 144c0 14.8 2.2 29.1 6.4 42.6l-13.5 7.9C9.5 203.5 0 220 0 237.8C0 265.5 22.5 288 50.2 288H176h33.8l69.1 67.7c8 7.9 18.8 12.3 30.1 12.3c23.7 0 43-19.2 43-43V296.6c19.1 11.1 32 31.8 32 55.4c0 35.3-28.7 64-64 64zM203.6 387.3c20.9 6.2 38.6 20.8 48.7 40.9l1.9 3.8-1.9 3.8c-10 20.1-27.8 34.7-48.7 40.9l18.8-37.5c2.3-4.5 2.3-9.8 0-14.3l-18.8-37.5zM152 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowUpRight = {
  prefix: 'fal',
  iconName: 'arrow-up-right',
  icon: [384, 512, [], "e09f", "M336 96c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V150.6L59.3 411.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 128H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H336z"]
};
var faCircleR = {
  prefix: 'fal',
  iconName: 'circle-r',
  icon: [512, 512, [], "e120", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 128c-17.7 0-32 14.3-32 32V272v96c0 8.8 7.2 16 16 16s16-7.2 16-16V288h71.4l59.3 88.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-50.5-75.7c31-11 53.2-40.6 53.2-75.4c0-44.2-35.8-80-80-80H192zm80 128H192V160h80c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
};
var faCartFlatbed = {
  prefix: 'fal',
  iconName: 'cart-flatbed',
  icon: [640, 512, ["dolly-flatbed"], "f474", "M0 16C0 7.2 7.2 0 16 0H80c26.5 0 48 21.5 48 48V368c0 8.8 7.2 16 16 16h80H512 624c8.8 0 16 7.2 16 16s-7.2 16-16 16H567.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H144c-26.5 0-48-21.5-48-48V48c0-8.8-7.2-16-16-16H16C7.2 32 0 24.8 0 16zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM320 64H240c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H480V192c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L400 164l-54.4 40.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.3-8.8-14.3V64zm32 0v96l38.4-28.8c5.7-4.3 13.5-4.3 19.2 0L448 160V64H352zM240 32H560c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48z"]
};
var faDollyFlatbed = faCartFlatbed;
var faBanSmoking = {
  prefix: 'fal',
  iconName: 'ban-smoking',
  icon: [512, 512, [128685, "smoking-ban"], "f54d", "M86.7 109.3L201.4 224l32 32 32 32 32 32L402.7 425.3C363.4 459.4 312.1 480 256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7zM278.6 256H384v32H310.6l-32-32zm64 64H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H246.6L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7L342.6 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM220.1 288H128V256h60.1l-32-32H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H252.1l-32-32z"]
};
var faSmokingBan = faBanSmoking;
var faCircleSortUp = {
  prefix: 'fal',
  iconName: 'circle-sort-up',
  icon: [512, 512, ["sort-circle-up"], "e032", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM244.7 100.7c6.2-6.2 16.4-6.2 22.6 0l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96zM198.6 192l114.7 0L256 134.6 198.6 192zM148.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 377.4l84.7-84.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96z"]
};
var faSortCircleUp = faCircleSortUp;
var faTerminal = {
  prefix: 'fal',
  iconName: 'terminal',
  icon: [576, 512, [], "f120", "M5.1 59.7c-6.5-6-6.9-16.1-.8-22.6s16.1-6.9 22.6-.8l224 208c3.3 3 5.1 7.3 5.1 11.7s-1.9 8.7-5.1 11.7l-224 208c-6.5 6-16.6 5.6-22.6-.8s-5.6-16.6 .8-22.6L216.5 256 5.1 59.7zM240 448H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMobileButton = {
  prefix: 'fal',
  iconName: 'mobile-button',
  icon: [384, 512, [], "f10b", "M96 32C78.3 32 64 46.3 64 64V448c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H96zM32 64C32 28.7 60.7 0 96 0H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHouseMedicalFlag = {
  prefix: 'fal',
  iconName: 'house-medical-flag',
  icon: [640, 512, [], "e514", "M480 16V32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H480V512H448V192 160 64 32 16c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 160V64H480v96H608zM281.6 35.2L416 136v40L272 68 96 200V440c0 22.1 17.9 40 40 40l272 0c2.7 0 5.4-.3 8-.8v32.4c-2.6 .3-5.3 .4-8 .4l-272 0c-39.8 0-72-32.2-72-72V224L25.6 252.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4l256-192c5.7-4.3 13.5-4.3 19.2 0zM256 176h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H320v32c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V336H192c-17.7 0-32-14.3-32-32V272c0-17.7 14.3-32 32-32h32V208c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7H192v32h48c8.8 0 16 7.2 16 16v48h32V320c0-8.8 7.2-16 16-16h48V272H304c-8.8 0-16-7.2-16-16V208H256z"]
};
var faBasketShopping = {
  prefix: 'fal',
  iconName: 'basket-shopping',
  icon: [576, 512, ["shopping-basket"], "f291", "M327.9 2.2c-7.6 4.5-10.2 14.2-5.8 21.9l98 167.9H155.9l98-167.9c4.5-7.6 1.9-17.4-5.8-21.9s-17.4-1.9-21.9 5.8L118.8 192H65 32 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H40L99.9 463.5C107 492 132.6 512 162 512H414c29.4 0 55-20 62.1-48.5L536 224h24c8.8 0 16-7.2 16-16s-7.2-16-16-16H544 511 457.2L349.8 7.9c-4.5-7.6-14.2-10.2-21.9-5.8zM73 224H503L445.1 455.8C441.5 470 428.7 480 414 480H162c-14.7 0-27.5-10-31-24.2L73 224zm151 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm64-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm96 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"]
};
var faShoppingBasket = faBasketShopping;
var faTape = {
  prefix: 'fal',
  iconName: 'tape',
  icon: [576, 512, [], "f4db", "M224 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zM339.4 448C404.5 408.8 448 337.5 448 256C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H339.4zM224 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faChestnut = {
  prefix: 'fal',
  iconName: 'chestnut',
  icon: [448, 512, [127792], "e3f6", "M328.7 163.3c-14.2-14.2-29.7-27.3-46.4-41c-2.8-2.3-5.6-4.5-8.4-6.9l0 0c-13.9-11.4-28.5-23.3-42.5-36c-2.5-2.3-5-4.6-7.4-7c-2.4 2.3-4.8 4.7-7.4 7c-14 12.7-28.6 24.6-42.5 36l0 0c-2.8 2.3-5.6 4.6-8.4 6.9c-16.6 13.7-32.2 26.8-46.4 41C72.8 209.8 32 270 32 352H416c0-82-40.8-142.2-87.3-188.7zM37.5 384c13.2 37.3 48.7 64 90.5 64H320c41.8 0 77.4-26.7 90.5-64H37.5zM351.3 140.7C400.8 190.2 448 258 448 352c0 70.7-57.3 128-128 128H128C57.3 480 0 422.7 0 352c0-94 47.2-161.8 96.7-211.3c18.1-18.1 37.7-34.1 57.3-50.2c13.9-11.4 27.8-22.7 41.1-34.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c13.3 12.1 27.2 23.4 41.1 34.8c19.6 16.1 39.3 32.1 57.3 50.2z"]
};
var faBusSimple = {
  prefix: 'fal',
  iconName: 'bus-simple',
  icon: [448, 512, ["bus-alt"], "f55e", "M33.2 90C49.2 70.2 106.1 32 224 32c126.8 0 175.9 38.1 190.7 57.5c.6 .8 1.3 2.5 1.3 5.6V96H32v-.8c0-3.2 .8-4.6 1.2-5.1zM32 128H416V256H32V128zM416 288v96c0 17.7-14.3 32-32 32H303.2 64c-17.7 0-32-14.3-32-32V288H416zM224 0C100.2 0 32.5 40.1 8.3 69.9C1.8 77.9 0 87.4 0 95.2V384c0 23.7 12.9 44.4 32 55.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48H303.2 384v48c0 8.8 7.2 16 16 16s16-7.2 16-16V439.4c19.1-11.1 32-31.7 32-55.4V95.2c0-7.8-1.8-17-7.8-25C417.2 40 356.6 0 224 0zM96 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faBusAlt = faBusSimple;
var faEye = {
  prefix: 'fal',
  iconName: 'eye',
  icon: [576, 512, [128065], "f06e", "M117.2 136C160.3 96 217.6 64 288 64s127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-13.3 32-42.1 80-85.2 120c-43.1 40-100.4 72-170.8 72s-127.7-32-170.8-72C74.1 336 45.3 288 32 256c13.3-32 42.1-80 85.2-120zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
};
var faFaceSadCry = {
  prefix: 'fal',
  iconName: 'face-sad-cry',
  icon: [512, 512, [128557, "sad-cry"], "f5b3", "M384 439.8V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V458.4c-29.1 13.8-61.6 21.6-96 21.6s-66.9-7.7-96-21.6V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V439.8C70 399.4 32 332.1 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 76.1-38 143.4-96 183.8zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32V328c0-17.7 14.3-32 32-32s32 14.3 32 32v24zm-32-88c-35.3 0-64 28.7-64 64v24c0 35.3 28.7 64 64 64s64-28.7 64-64V328c0-35.3-28.7-64-64-64z"]
};
var faSadCry = faFaceSadCry;
var faHeat = {
  prefix: 'fal',
  iconName: 'heat',
  icon: [448, 512, [], "e00c", "M176 32c8.8 0 16 7.2 16 16v96c0 38.1 12.4 75.1 35.2 105.6l19.2 25.6c27 36 41.6 79.8 41.6 124.8v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-38.1-12.4-75.1-35.2-105.6l-19.2-25.6C174.6 232.8 160 189 160 144V48c0-8.8 7.2-16 16-16zM16 96c8.8 0 16 7.2 16 16v45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.1c0-34.7-10.3-68.7-29.6-97.6L34.9 273.2C12.2 239.1 0 198.9 0 157.9V112c0-8.8 7.2-16 16-16zm336 16v45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.1c0-34.7-10.3-68.7-29.6-97.6l-31.5-47.3C332.2 239.1 320 198.9 320 157.9V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTicketAirline = {
  prefix: 'fal',
  iconName: 'ticket-airline',
  icon: [640, 512, [], "e29a", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V334.4c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64v66.4c0 8-8 13.6-16 13.6c-26.5 0-48 21.5-48 48s21.5 48 48 48c8 0 16 5.6 16 13.6V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm464 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM217.8 218.9c1.6 4.9 .8 10.2-2.2 14.4s-7.8 6.6-13 6.6H160c-5 0-9.8-2.4-12.8-6.4L128 208h-3.5l10.1 40.2c1.3 5.1 1.3 10.4 0 15.5L124.5 304H128l19.2-25.6c3-4 7.8-6.4 12.8-6.4h42.7c5.1 0 10 2.5 13 6.6s3.8 9.5 2.2 14.4L198.2 352h20c2.8 0 5.5-1.5 6.9-4l39.7-68.1c2.9-4.9 8.1-7.9 13.8-7.9h40.3c11.8 0 23.1-4.7 31.5-13c1.6-1.6 1.6-4.3 0-5.9c-8.4-8.4-19.7-13-31.5-13H278.7c-5.7 0-11-3-13.8-7.9L225.1 164c-1.4-2.5-4.1-4-6.9-4h-20l19.6 58.9zM187.1 128h31.1c14.2 0 27.4 7.6 34.6 19.8L287.9 208h31.1c20.3 0 39.8 8.1 54.1 22.4c14.1 14.1 14.1 37 0 51.2c-14.4 14.4-33.8 22.4-54.1 22.4H287.9l-35.1 60.2c-7.2 12.3-20.3 19.8-34.6 19.8H187.1c-16.4 0-27.9-16-22.8-31.6L180.5 304H168l-14.4 19.2c-6 8.1-15.5 12.8-25.6 12.8H114.2c-15.6 0-27.1-14.7-23.3-29.8L103.5 256 91 205.8c-3.8-15.1 7.7-29.8 23.3-29.8H128c10.1 0 19.6 4.7 25.6 12.8L168 208h12.5l-16.1-48.4c-5.2-15.5 6.4-31.6 22.8-31.6z"]
};
var faBootHeeled = {
  prefix: 'fal',
  iconName: 'boot-heeled',
  icon: [512, 512, [], "e33f", "M37 0C16.5 0 0 16.5 0 37c0 3.5 .5 7 1.5 10.3C6.5 65.1 32 158.5 32 232c0 15.4-3.7 37.3-9 60C17.9 314.4 11.6 336.3 7 351.5C2.6 366 0 381.3 0 396.9V432v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V449.5l118.9 52.8c14.3 6.4 29.8 9.7 45.5 9.7H464h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V445.7c0-24.2-13.7-46.4-35.4-57.2L300.2 316.2C273.1 302.7 256 275 256 244.7V40c0-22.1-17.9-40-40-40H112 37zM96 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32h88c4.4 0 8 3.6 8 8V244.7c0 42.4 24 81.2 61.9 100.2L430.3 417c10.8 5.4 17.7 16.5 17.7 28.6V480H292.4c-11.2 0-22.3-2.3-32.5-6.9L134.5 417.4c-2-.9-4.3-1.4-6.5-1.4H112 32V396.9c0-12.1 2-24.2 5.6-36.1c4.7-15.5 11.3-38.2 16.6-61.6c5.3-23 9.8-47.9 9.8-67.2C64 153.5 37.2 56.2 32.2 38.5c-.2-.6-.2-1.1-.2-1.6c0-2.7 2.2-5 5-5H96zm0 448H32V448H96v32z"]
};
var faArrowsMinimize = {
  prefix: 'fal',
  iconName: 'arrows-minimize',
  icon: [512, 512, ["compress-arrows"], "e0a5", "M36.7 36.7c6.2-6.2 16.4-6.2 22.6 0L192 169.4V64c0-8.8 7.2-16 16-16s16 7.2 16 16V208c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16H169.4L36.7 59.3c-6.2-6.2-6.2-16.4 0-22.6zm416 0c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 192H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16s16 7.2 16 16V169.4L452.7 36.7zM48 304c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.6L59.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 320H64c-8.8 0-16-7.2-16-16zm240 0c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H342.6L475.3 452.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 342.6V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V304z"]
};
var faCompressArrows = faArrowsMinimize;
var faAudioDescription = {
  prefix: 'fal',
  iconName: 'audio-description',
  icon: [576, 512, [], "f29e", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm192 64c6.1 0 11.6 3.4 14.3 8.8l80 160c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L238.1 304H145.9l-19.6 39.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l80-160c2.7-5.4 8.3-8.8 14.3-8.8zm30.1 112L192 211.8 161.9 272h60.2zM304 176c0-8.8 7.2-16 16-16h64c53 0 96 43 96 96s-43 96-96 96H320c-8.8 0-16-7.2-16-16V176zm32 16V320h48c35.3 0 64-28.7 64-64s-28.7-64-64-64H336z"]
};
var faPersonMilitaryToPerson = {
  prefix: 'fal',
  iconName: 'person-military-to-person',
  icon: [512, 512, [], "e54c", "M176 33.1V46.8H88V44.9l88-11.7zM180.8 .2L76.8 14.1C64.9 15.6 56 25.8 56 37.8V54.8c0 13.3 10.7 24 24 24H184c13.3 0 24-10.7 24-24V24C208 9.5 195.2-1.7 180.8 .2zM352 96.6a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM320 256.5c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v31.8H320V256.5zm-32 0v31.8c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256.5c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64zm-171.5-32H160c17.7 0 32 14.3 32 32v13.2l-75.5-45.2zm44.2 63.8H64V256.5c0-8.2 3.1-15.6 8.1-21.3l88.7 53.1zM96 192.5c-35.3 0-64 28.7-64 64v31.8c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32V256.5c0-35.3-28.7-64-64-64H96zM64 96.6c0 35.3 28.7 63.9 64 63.9s64-28.6 64-63.9H160c0 17.6-14.3 31.9-32 31.9s-32-14.3-32-31.9H64zm82.6 259.6c-6.6-5.9-16.7-5.3-22.6 1.3s-5.3 16.7 1.3 22.6l40.5 35.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H165.9l-40.5 35.9c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l72-63.9c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-72-63.9zm218.8 0l-72 63.9c-3.4 3-5.4 7.4-5.4 12s2 8.9 5.4 12l72 63.9c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6l-40.5-35.9H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H346.1l40.5-35.9c6.6-5.9 7.2-16 1.3-22.6s-16-7.2-22.6-1.3z"]
};
var faFileShield = {
  prefix: 'fal',
  iconName: 'file-shield',
  icon: [576, 512, [], "e4f0", "M320 480c1.3 0 2.6-.1 3.9-.2c7.9 8.6 16.6 16.9 26.3 24.7c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V207l-32 12.8V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320zm31.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM320.1 301.4c1.3 53 22.6 129.5 95.9 170V263l-95.9 38.4zm223.9 0L448 263V471.4c73.4-40.5 94.6-117.1 95.9-170zm-103-75.7l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48c5.7-2.3 12.1-2.3 17.8 0z"]
};
var faHexagon = {
  prefix: 'fal',
  iconName: 'hexagon',
  icon: [512, 512, [11043], "f312", "M16 224c-11.4 19.8-11.4 44.2 0 64l92.3 159.8c11.4 19.8 32.6 32 55.4 32l184.6 0c22.9 0 44-12.2 55.4-32L496 288c11.4-19.8 11.4-44.2 0-64L403.7 64.2c-11.4-19.8-32.6-32-55.4-32l-184.6 0c-22.9 0-44 12.2-55.4 32L16 224zm27.7 48c-5.7-9.9-5.7-22.1 0-32L136 80.2c5.7-9.9 16.3-16 27.7-16l184.6 0c11.4 0 22 6.1 27.7 16L468.3 240c5.7 9.9 5.7 22.1 0 32L376 431.8c-5.7 9.9-16.3 16-27.7 16l-184.6 0c-11.4 0-22-6.1-27.7-16L43.7 272z"]
};
var faManhole = {
  prefix: 'fal',
  iconName: 'manhole',
  icon: [512, 512, [], "e1d6", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM201.6 122.6C215.8 135.9 235 144 256 144s40.2-8.1 54.4-21.4C363 144.1 400 195.8 400 256s-37 111.9-89.6 133.4C296.2 376.1 277 368 256 368s-40.2 8.1-54.4 21.4C149 367.9 112 316.2 112 256s37-111.9 89.6-133.4zm-1-33.7C130.5 112.1 80 178.2 80 256s50.5 143.9 120.6 167.1c7.1 2.4 14.6-1.4 19.6-7C229 406.2 241.8 400 256 400s27 6.2 35.8 16.1c5 5.6 12.4 9.4 19.6 7C381.5 399.9 432 333.8 432 256s-50.5-143.9-120.6-167.1c-7.1-2.4-14.6 1.4-19.6 7C283 105.8 270.2 112 256 112s-27-6.2-35.8-16.1c-5-5.6-12.4-9.4-19.6-7zM176 192a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48-112a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-16 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-16 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]
};
var faUserSlash = {
  prefix: 'fal',
  iconName: 'user-slash',
  icon: [640, 512, [], "f506", "M448 128C448 57.3 390.7 0 320 0C266.1 0 219.9 33.4 201.1 80.6l26.6 21C239.2 61.4 276.1 32 320 32c53 0 96 43 96 96c0 35.9-19.7 67.2-48.9 83.7l26.6 21C426.6 209.5 448 171.2 448 128zm52.4 352H128c1.2-79.7 66.2-144 146.3-144H318l-40.5-32h-3.2C175.8 304 96 383.8 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c7 0 13.4-2.4 18.5-6.5L500.4 480zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faPen = {
  prefix: 'fal',
  iconName: 'pen',
  icon: [512, 512, [128394], "f304", "M395.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L417.6 171 341 94.4l54.8-54.8zM318.4 117L395 193.6 159.6 428.9c-7.6 7.6-16.9 13.1-27.2 16.1L39.6 472.4l27.3-92.8c3-10.3 8.6-19.6 16.1-27.2L318.4 117zM452.4 17c-21.9-21.9-57.3-21.9-79.2 0L60.4 329.7c-11.4 11.4-19.7 25.4-24.2 40.8L.7 491.5c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2L495 138.8c21.9-21.9 21.9-57.3 0-79.2L452.4 17z"]
};
var faTowerObservation = {
  prefix: 'fal',
  iconName: 'tower-observation',
  icon: [512, 512, [], "e586", "M248.8 1.7c4.5-2.3 9.8-2.3 14.3 0l176 88c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-8.8-4.4V192c0 26.5-21.5 48-48 48h-7.8l39.6 237.4c.1 .9 .2 1.8 .2 2.6h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c0-.9 .1-1.7 .2-2.6L151.8 240H144c-26.5 0-48-21.5-48-48V113.9l-8.8 4.4c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l176-88zM256 33.9l-128 64V128H384V97.9l-128-64zM128 160v32c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V160H128zM359.4 480L256 391.4 152.6 480H359.4zM184 240c0 .9-.1 1.7-.2 2.6l-6.5 39.1L256 349.2l78.7-67.5-6.5-39.1c-.1-.9-.2-1.8-.2-2.6H184zm-12.9 78.6L151 439.2l80.4-68.9-60.3-51.7zm109.5 51.7L361 439.2 340.9 318.6l-60.3 51.7z"]
};
var faFloppyDisks = {
  prefix: 'fal',
  iconName: 'floppy-disks',
  icon: [512, 512, [], "e183", "M128 352c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V138.5c0-8.5-3.4-16.6-9.4-22.6L396.1 41.4c-3.4-3.4-7.6-6-12.1-7.6V112c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V32c-17.7 0-32 14.3-32 32V352zM352 32H192v80H352V32zM192 0H373.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64h32zM32 112V368c0 61.9 50.1 112 112 112H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H144C64.5 512 0 447.5 0 368V112c0-8.8 7.2-16 16-16s16 7.2 16 16zM296 304a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-112a72 72 0 1 1 0 144 72 72 0 1 1 0-144z"]
};
var faToiletPaperBlankUnder = {
  prefix: 'fal',
  iconName: 'toilet-paper-blank-under',
  icon: [512, 512, ["toilet-paper-reverse-alt"], "e29f", "M58.2 75.2C42.3 104.3 32 145.5 32 192s10.3 87.7 26.2 116.8C74.4 338.5 94.1 352 112 352H337.3c-7.2-8.2-13.6-17.7-19.2-27.9C299.2 289.5 288 242.8 288 192s11.2-97.5 30.1-132.1c5.6-10.2 12-19.6 19.2-27.9H112C94.1 32 74.4 45.5 58.2 75.2zM400 32c-17.9 0-37.6 13.5-53.8 43.2C330.3 104.3 320 145.5 320 192s10.3 87.7 26.2 116.8C362.4 338.5 382.1 352 400 352s37.6-13.5 53.8-43.2C469.7 279.7 480 238.5 480 192s-10.3-87.7-26.2-116.8C437.6 45.5 417.9 32 400 32zm80 432V327.6c-18.6 32.3-46.1 56.4-80 56.4H112c-35.1 0-63.4-25.9-81.9-59.9C11.2 289.5 0 242.8 0 192S11.2 94.5 30.1 59.9C48.6 25.9 76.9 0 112 0H400c35.1 0 63.4 25.9 81.9 59.9C500.8 94.5 512 141.2 512 192V464c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V416h32v48c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16zM400 240c6.4 0 11.9-11.3 14.5-27.6c1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16c-5.1-6.4-8.2-13.8-10.3-20c-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20c4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20c4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20c-4.8 6.1-15.1 16-31.4 16z"]
};
var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
var faFileCode = {
  prefix: 'fal',
  iconName: 'file-code',
  icon: [384, 512, [], "f1c9", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm91.3 299.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L118.6 336l36.7-36.7zm144 25.4l-48-48c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265.4 336l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faSignal = {
  prefix: 'fal',
  iconName: 'signal',
  icon: [640, 512, [128246, "signal-5", "signal-perfect"], "f012", "M592 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM448 96c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zM336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM192 288c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400c0-8.8-7.2-16-16-16z"]
};
var faSignal5 = faSignal;
var faSignalPerfect = faSignal;
var faPump = {
  prefix: 'fal',
  iconName: 'pump',
  icon: [640, 512, [], "e442", "M76.9 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H96V208H32V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v32V384v32c0 8.8 7.2 16 16 16s16-7.2 16-16V400H320V368H32V240h80c8.8 0 16-7.2 16-16V32H256V224c0 8.8 7.2 16 16 16h48V208H288V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H272 112 76.9zM449.6 133.4c5.3-3.5 11.4-5.4 17.8-5.4H576c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H467.4c-6.3 0-12.5-1.9-17.8-5.4l-51.4-34.3c-8.9-5.9-14.2-15.9-14.2-26.6V194.3c0-10.7 5.3-20.7 14.2-26.6l51.4-34.3zM431.9 501.3c10.5 7 22.9 10.7 35.5 10.7H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H467.4c-12.6 0-25 3.7-35.5 10.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3V413.7c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3zM448 224c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16z"]
};
var faBus = {
  prefix: 'fal',
  iconName: 'bus',
  icon: [576, 512, [128653], "f207", "M288 32C170.1 32 113.2 70.2 97.2 90c-.4 .5-1.2 1.9-1.2 5.1V128H480V95.2c0-3.1-.8-4.9-1.3-5.6C463.9 70.1 414.8 32 288 32zM96 256H272V160H96v96zm208 0H480V160H304v96zM96 384c0 17.7 14.3 32 32 32H367.2 448c17.7 0 32-14.3 32-32V288H96v96zM72.3 69.9C96.5 40.1 164.2 0 288 0C420.6 0 481.2 40 504.2 70.2c6 7.9 7.8 17.2 7.8 25V384c0 23.7-12.9 44.4-32 55.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H367.2 128l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V439.4C76.9 428.4 64 407.7 64 384V95.2c0-7.7 1.8-17.2 8.3-25.3zM136 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM240 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16zM32 144v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm544 0v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHeartCircleXmark = {
  prefix: 'fal',
  iconName: 'heart-circle-xmark',
  icon: [576, 512, [], "e501", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faArrowUpLeftFromCircle = {
  prefix: 'fal',
  iconName: 'arrow-up-left-from-circle',
  icon: [512, 512, [], "e09e", "M176 0H16C7.2 0 0 7.2 0 16V176c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6L300.7 323.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 32H176c8.8 0 16-7.2 16-16s-7.2-16-16-16zM288 64c-8.8 0-16 7.2-16 16s7.2 16 16 16c106 0 192 86 192 192s-86 192-192 192S96 394 96 288c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z"]
};
var faHouseChimney = {
  prefix: 'fal',
  iconName: 'house-chimney',
  icon: [576, 512, [63499, "home-lg"], "e3af", "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V192.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1V64H416v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32V480h64c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM336 320H240V480h96V320z"]
};
var faHomeLg = faHouseChimney;
var faWindowMaximize = {
  prefix: 'fal',
  iconName: 'window-maximize',
  icon: [512, 512, [128470], "f2d0", "M64 64C46.3 64 32 78.3 32 96v96H480V96c0-17.7-14.3-32-32-32H64zM32 224V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V224H32zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faDryer = {
  prefix: 'fal',
  iconName: 'dryer',
  icon: [448, 512, [], "f861", "M384 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 96A24 24 0 1 0 80 96a24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 296c-56.4 0-103.1-41.7-110.9-96H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H113.1c7.8-54.3 54.4-96 110.9-96c61.9 0 112 50.1 112 112s-50.1 112-112 112zM80 304a144 144 0 1 0 288 0A144 144 0 1 0 80 304z"]
};
var faFaceFrown = {
  prefix: 'fal',
  iconName: 'face-frown',
  icon: [512, 512, [9785, "frown"], "f119", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faFrown = faFaceFrown;
var faChessBishopPiece = {
  prefix: 'fal',
  iconName: 'chess-bishop-piece',
  icon: [256, 512, ["chess-bishop-alt"], "f43b", "M96 32h32 32c8.8 0 16 7.2 16 16c0 6-3.3 11.2-8.1 13.9c4 4.2 8.2 8.8 12.4 13.8C201.4 101.1 224 138.7 224 184c0 16.6-4.4 30.1-10.8 40.9C219.5 227 224 233 224 240c0 8.8-7.2 16-16 16H196.1l9.6 96H173.5l-9.6-96H92.1l-9.6 96H50.3l9.6-96H48c-8.8 0-16-7.2-16-16c0-7 4.5-13 10.8-15.1C36.4 214.1 32 200.6 32 184c0-45.3 22.6-82.9 43.7-108.2c4.2-5 8.4-9.7 12.4-13.8C83.3 59.2 80 54 80 48c0-8.8 7.2-16 16-16zm75.5 192c10.2-7.5 20.5-19.8 20.5-40c0-18.9-5.2-36.6-13-52.4l-31.7 31.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l37-37c-2-2.6-3.9-5.1-5.9-7.5C146.4 85.1 137 76.2 130 70.1c-.7-.6-1.4-1.2-2-1.7c-.6 .5-1.3 1.1-2 1.7c-7 6.1-16.4 15-25.7 26.2C81.4 118.9 64 149.3 64 184c0 20.2 10.3 32.5 20.5 40h87.1zm45.9 175.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1H190.2c11.1 0 21.4 5.7 27.2 15.1zM65.8 416L33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4H216.6c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L190.2 416 65.8 416z"]
};
var faChessBishopAlt = faChessBishopPiece;
var faShirtTankTop = {
  prefix: 'fal',
  iconName: 'shirt-tank-top',
  icon: [384, 512, [], "e3c9", "M96 16C96 7.2 88.8 0 80 0S64 7.2 64 16c0 134.3-29.3 192.6-45.6 214.6C9.5 242.5 0 259.2 0 278.2V456c0 30.9 25.1 56 56 56H328c30.9 0 56-25.1 56-56V278.2c0-19-9.5-35.7-18.4-47.6C349.3 208.6 320 150.3 320 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64c0 53-43 96-96 96s-96-43-96-96V16zM86.5 136.5C109.6 170 148.2 192 192 192s82.4-22 105.5-55.5c10.7 59.8 28.4 94.1 42.4 113.1c7.6 10.2 12.1 20 12.1 28.6V456c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V278.2c0-8.6 4.6-18.4 12.1-28.6c14-19 31.7-53.3 42.4-113.1z"]
};
var faDiploma = {
  prefix: 'fal',
  iconName: 'diploma',
  icon: [640, 512, ["scroll-ribbon"], "f5ea", "M253.2 80.8C245 70.2 232.4 64 219 64h-3c-22.1 0-40 17.9-40 40s17.9 40 40 40h40 45.8L253.2 80.8zm-97 63.2c-7.7-11.4-12.1-25.2-12.1-40c0-39.8 32.2-72 72-72h3c23.3 0 45.3 10.8 59.5 29.3L320 115.2l41.5-53.9C375.7 42.8 397.7 32 421 32h3c39.8 0 72 32.2 72 72c0 14.8-4.5 28.6-12.1 40H544c65.1 .3 96 71.5 96 128c0 56.9-24.1 119.2-81 140.7c-10.5 4-22.5 4.2-33.4 1.8L400 386.6V464c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7L320 449.9l-56.8 28.4c-5 2.5-10.9 2.2-15.6-.7s-7.6-8.1-7.6-13.6V386.6L114.4 414.5l-6.9-31.2L240 353.8V176H216 96.1c-18.9 .1-33.9 9.9-45.5 28.1C38.5 223.1 32 248.8 32 272c0 50.8 21.4 96.1 60.3 110.8c3.5 1.3 9.1 1.8 15.1 .5l6.9 31.2c-10.9 2.4-22.9 2.2-33.4-1.8C24.1 391.2 0 328.9 0 272c0-56.5 30.9-127.7 96-128h60.1zM400 176V353.8l132.6 29.5c6 1.3 11.6 .9 15.1-.5c38.9-14.7 60.3-60 60.3-110.8c0-23.2-6.5-48.9-18.6-67.9c-11.6-18.2-26.6-28-45.5-28.1H424 400zm24-32c22.1 0 40-17.9 40-40s-17.9-40-40-40h-3c-13.4 0-26 6.2-34.1 16.8L338.2 144H384h40zm-88 32H304 272V438.1l40.8-20.4c4.5-2.3 9.8-2.3 14.3 0L368 438.1V176H336z"]
};
var faScrollRibbon = faDiploma;
var faScreencast = {
  prefix: 'fal',
  iconName: 'screencast',
  icon: [576, 512, [], "e23e", "M512 64H64C46.3 64 32 78.3 32 96v96.1c-2.7-.1-5.3-.1-8-.1H0V96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H288V456c0-2.7 0-5.3-.1-8H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM16 224c132.5 0 240 107.5 240 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 336c0-8.8 7.2-16 16-16c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112c-8.8 0-16-7.2-16-16z"]
};
var faWalker = {
  prefix: 'fal',
  iconName: 'walker',
  icon: [448, 512, [], "f831", "M178.8 32H320c26.5 0 48 21.5 48 48V192H103.4L132 69.1C137.1 47.4 156.5 32 178.8 32zM368 224V386c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62V80c0-44.2-35.8-80-80-80H178.8c-37.2 0-69.5 25.6-77.9 61.8L.4 492.4c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9L96 223.6v.4H368zm48 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faPrescription = {
  prefix: 'fal',
  iconName: 'prescription',
  icon: [448, 512, [], "f5b1", "M31.1 0C13.9 0 0 13.9 0 31.1V208v96c0 8.8 7.2 16 16 16s16-7.2 16-16V224H137.4l128 128L132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 374.6 420.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L310.6 352 443.3 219.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L288 329.4 182.4 223.8C241.3 220.5 288 171.7 288 112C288 50.1 237.9 0 176 0H31.1zM144 192s0 0 0 0H32V32H176c44.2 0 80 35.8 80 80s-35.8 80-80 80H144z"]
};
var faShop = {
  prefix: 'fal',
  iconName: 'shop',
  icon: [640, 512, ["store-alt"], "f54f", "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 21.1-17.1 38.2-38.2 38.2H576V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H96V352H352V272 256h32v16V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V224H38.2C17.1 224 0 206.9 0 185.8zM80 192H560h41.8c3.4 0 6.2-2.8 6.2-6.2c0-1-.3-2.1-.8-3L529.6 40.3c-2.8-5.1-8.2-8.3-14-8.3h-391c-5.9 0-11.2 3.2-14 8.3L32.8 182.8c-.5 .9-.8 1.9-.8 3c0 3.4 2.8 6.2 6.2 6.2H80zM96 464c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16V384H96v80z"]
};
var faStoreAlt = faShop;
var faFloppyDisk = {
  prefix: 'fal',
  iconName: 'floppy-disk',
  icon: [448, 512, [128190, 128426, "save"], "f0c7", "M32 96c0-17.7 14.3-32 32-32l0 96c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V65.8c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM96 64H288v96H96V64zM0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V170.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96zM272 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]
};
var faSave = faFloppyDisk;
var faVihara = {
  prefix: 'fal',
  iconName: 'vihara',
  icon: [640, 512, [], "f6a7", "M309.8 3.7l-26.3 21c-33.9 27.1-72.3 48-113.5 61.8l-31 10.3c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l10.9-3.6v47.2c-28.9 33.7-67.6 57.6-110.7 68.4l-4.8 1.2c-1.3 .3-2.5 .7-3.6 1.3c-2.1 1.1-4 2.6-5.4 4.4s-2.5 4-3 6.3c-.4 1.8-.5 3.6-.3 5.5s.8 3.6 1.6 5.2c1.1 2.1 2.6 4 4.4 5.4s4 2.5 6.3 3c1.2 .3 2.5 .4 3.9 .4H96v61.6c-14.7 31.3-38.9 57.3-69.2 74.1L8.5 417.9c-.6 .3-1.2 .7-1.7 1.1c-1.9 1.3-3.5 3-4.6 5s-1.9 4.1-2.1 6.4c-.2 1.9-.1 3.8 .4 5.7s1.3 3.6 2.4 5.2c1.3 1.9 3 3.5 5 4.6s4.1 1.9 6.4 2.1c.7 .1 1.3 .1 2 .1H64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448H224v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64 64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448H544v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h47.7c.7 0 1.4 0 2-.1c2.3-.2 4.5-1 6.4-2.1s3.6-2.7 5-4.6c1.1-1.6 1.9-3.3 2.4-5.2s.6-3.8 .4-5.7c-.2-2.3-1-4.5-2.1-6.4s-2.7-3.6-4.6-5c-.6-.4-1.1-.7-1.7-1.1l-18.3-10.2c-30.3-16.8-54.5-42.8-69.2-74.1V272h47.7c1.3 0 2.6-.1 3.9-.4c2.3-.5 4.5-1.6 6.3-3s3.4-3.3 4.4-5.4c.8-1.6 1.4-3.4 1.6-5.2s.1-3.7-.3-5.5c-.5-2.3-1.6-4.5-3-6.3s-3.3-3.4-5.4-4.4c-1.1-.6-2.4-1-3.6-1.3l-4.8-1.2c-43.2-10.8-81.8-34.7-110.7-68.4V123.5l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2L470 86.5c-41.2-13.7-79.6-34.6-113.5-61.8l-26.3-21c-1.1-.9-2.2-1.6-3.4-2.2C324.7 .5 322.3 0 320 0s-4.7 .5-6.8 1.5c-1.2 .6-2.4 1.3-3.4 2.2zM128 352H320 512h5.4c12.5 24.8 30 46.6 51.3 64H320 71.3c21.3-17.4 38.8-39.2 51.3-64H128zm0-32V272H320 512v48H320 128zm64-160V112.7c40.3-14.9 77.9-36.1 111.5-62.9L320 36.5l16.5 13.2c33.6 26.8 71.2 48.1 111.5 62.9V160H320 192zm128 80H128.1c20.8-13 39.7-29.2 55.9-48H320 456c16.2 18.8 35.1 35 55.9 48H320z"]
};
var faFaceKissClosedEyes = {
  prefix: 'fal',
  iconName: 'face-kiss-closed-eyes',
  icon: [512, 512, [], "e37d", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm277.4 47.1c-11-5.4-25.7-9.3-39.1-11.2c-6.6-.9-11.1-7-10.2-13.6s7-11.1 13.6-10.2c15.1 2.1 32.4 6.6 46.3 13.4c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-1.1 .5-2.1 1-3.3 1.5c1.1 .5 2.2 1 3.3 1.5c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-13.9 6.8-31.2 11.3-46.3 13.4c-6.6 .9-12.6-3.6-13.6-10.2s3.6-12.6 10.2-13.6c13.4-1.9 28.1-5.8 39.1-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8c-10.9-5.4-25.5-9.3-38.8-11.2c-.9-.1-1.8-.3-2.7-.6c-1.7-.6-3.2-1.6-4.4-2.8s-2.2-2.7-2.8-4.4c-.5-1.3-.7-2.6-.7-4.1s.2-2.8 .7-4.1c.6-1.7 1.6-3.2 2.8-4.4s2.7-2.2 4.4-2.8c.9-.3 1.7-.5 2.7-.6c13.3-1.9 27.9-5.8 38.8-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8zm-66.2-69.5c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faScaleUnbalanced = {
  prefix: 'fal',
  iconName: 'scale-unbalanced',
  icon: [640, 512, ["balance-scale-left"], "f515", "M527.8 10.9c2.8 8.4-1.7 17.4-10.1 20.2L383.5 75.9c-4.6 24.4-23.1 43.9-46.9 50.1V480h192c8.8 0 16 7.2 16 16s-7.2 16-16 16h-208c-8.8 0-16-7.2-16-16V126c-10.3-2.6-19.6-7.8-27.2-14.7L133.7 159.2c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2L259.7 83.5c-2-6.1-3-12.7-3-19.5c0-35.3 28.7-64 64-64c28 0 51.8 18 60.5 43L507.6 .8C516-2 525 2.6 527.8 10.9zM440.7 330.3C457.8 343.1 482.9 352 512 352s54.2-8.9 71.3-21.7C600.4 317.5 608 302.2 608 288H416v-1.6l0 .1V288c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 256H597.7L512 115.3zM384 288v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2C492.8 85.2 502.1 80 512 80s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V288c0 53-57.3 96-128 96s-128-43-128-96zM32 416c0 14.2 7.6 29.5 24.7 42.3C73.8 471.1 98.9 480 128 480s54.2-8.9 71.3-21.7C216.4 445.5 224 430.2 224 416H32v-1.6l0 .1V416zm10.3-32H213.7L128 243.3 42.3 384zM128 512C57.3 512 0 469 0 416v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V416c0 53-57.3 96-128 96zM320.7 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBalanceScaleLeft = faScaleUnbalanced;
var faFileUser = {
  prefix: 'fal',
  iconName: 'file-user',
  icon: [384, 512, [], "f65c", "M320 480H304V464c0-44.2-35.8-80-80-80H160c-44.2 0-80 35.8-80 80v16H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zm-48-16v16H112V464c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faUserPoliceTie = {
  prefix: 'fal',
  iconName: 'user-police-tie',
  icon: [448, 512, [], "e334", "M230.9 .8l144 32c11.4 2.5 20.5 11.1 23.8 22.3s.2 23.3-8.1 31.6l-6.2-6.2 6.2 6.2L368 109.3v1.6c0 15.6-7.6 31.8-23.2 40.1c-22.5 12-59.5 25-120.8 25s-98.3-13.1-120.8-25C87.6 142.7 80 126.5 80 110.9v-1.6L57.4 86.6C49.1 78.4 46 66.3 49.3 55.1s12.4-19.8 23.8-22.3l144-32c4.6-1 9.3-1 13.9 0zM80 64l27.3 27.3c3 3 4.7 7.1 4.7 11.3v8.2c0 5.8 2.8 10 6.2 11.8c11.9 6.3 30.3 13.8 58.4 18C163.8 121.1 160 98.9 160 83.2c0-6.5 4-12.4 10.1-14.9l48-19.2c3.8-1.5 8.1-1.5 11.9 0l48 19.2C284 70.8 288 76.7 288 83.2c0 15.7-3.8 37.9-16.5 57.5c28.1-4.2 46.5-11.7 58.4-18c3.4-1.8 6.2-6 6.2-11.8v-8.2c0-4.2 1.7-8.3 4.7-11.3L368 64 224 32 80 64zm96 304c0-8.8 7.2-16 16-16h32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-6.1l18.4 36.9 51.6-68.7C391.2 355.4 448 414.3 448 486.4c0 14.1-11.5 25.6-25.6 25.6H240 208 25.6C11.5 512 0 500.5 0 486.4c0-72.1 56.8-131 128.1-134.3l51.6 68.7L198.1 384H192c-8.8 0-16-7.2-16-16zm48 35.8l-22.9 45.7 2.9 3.8L224 480l0 0 0 0 20-26.7 2.9-3.8L224 403.8zM184 480l-70.4-93.9C69 395.3 35.1 433.4 32.2 480H184zm80 0H415.8c-2.9-46.5-36.8-84.7-81.4-93.9L264 480zM96 192c0-2.9 .1-5.8 .3-8.7c9.1 4.3 19.6 8.5 31.8 12.1c1.8 51.4 44.1 92.6 95.9 92.6s94.1-41.1 95.9-92.6c12.2-3.6 22.7-7.8 31.8-12.1c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128zm128-49.7c20.5-11.3 28.9-31.3 31.3-48.5L224 81.2 192.7 93.7c2.3 17.3 10.8 37.3 31.3 48.5z"]
};
var faFaceTongueMoney = {
  prefix: 'fal',
  iconName: 'face-tongue-money',
  icon: [512, 512, [], "e39d", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm96 32c-17.1 0-33.2 14.3-31 33.7c4.8 43.9 27.4 82.4 60.3 108.2l4.3 3.4C169.7 478 208.9 512 256 512s86.3-34 94.5-78.7l4.3-3.4c32.9-25.8 55.4-64.3 60.3-108.2c2.1-19.4-13.9-33.7-31-33.7H352 320 192 160 128zm160 32h32v32 64c0 35.3-28.7 64-64 64s-64-28.7-64-64V352 320h32 64zm-159 0h31v68.7c-16.6-18.8-27.8-42.5-31-68.7zm254 0c-3.3 26.1-14.4 49.9-31 68.7V320h31zM192 104c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.3 9 27.2 11.2l1.1 .3c9.6 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8l0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6V248c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7V104zM336 88c-8.8 0-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.4 9 27.2 11.2l1.1 .3c9.5 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8l0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6V248c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7V104c0-8.8-7.2-16-16-16zM267.2 347.6c0-6.4-5.4-11.6-12-11.6s-12 5.2-12 11.6v6.8c-4.3 .8-8.7 2.4-12.7 5.2c-5.6 4-9.5 9.8-10.8 17.2c-.9 5.3-.5 10.6 1.7 15.4c2.2 4.8 5.7 8.2 9.3 10.6c6.3 4.2 14.5 6.5 20.4 8.1l.8 .2c7.2 2 11.5 3.3 14.1 5.1c1.9 1.3 1.6 4.6-.4 5.8l0 0c-.9 .5-2.8 1.1-6.6 1.1c-7.6-.1-16.9-2.9-24-5.2c-6.3-2-13.1 1.3-15.2 7.4s1.3 12.7 7.6 14.7c3.8 1.2 9.5 3 15.8 4.4v7.8c0 6.4 5.4 11.6 12 11.6s12-5.2 12-11.6v-6.5c3.6-.6 7.3-1.8 10.8-3.8c6.8-4 11.2-10.5 12.7-18.9c.9-5.3 .5-10.6-1.7-15.4c-2.2-4.8-5.7-8.2-9.3-10.6c-5.4-3.6-11.7-5.2-17.9-6.8c-6.2-1.6-12.3-3.2-17.5-6.6c-1.8-1.2-1.8-3.9 .2-5.2c.7-.5 2.3-1.2 5.3-1.5c6.1-.6 14 .7 20.2 2.3c6.4 1.7 13-2 14.7-8.3s-2.1-12.6-8.5-14.2c-2.5-.7-5.7-1.4-9.1-2v-7.2z"]
};
var faTennisBall = {
  prefix: 'fal',
  iconName: 'tennis-ball',
  icon: [512, 512, [127934], "f45e", "M256.6 480c-4.5-58.4 15.6-118.4 60.3-163.1s104.6-64.8 163.1-60.3c0-.2 0-.4 0-.6C480 132.3 379.7 32 256 32c-.2 0-.4 0-.6 0c4.5 58.4-15.6 118.4-60.3 163.1S90.4 259.9 32 255.4c0 .2 0 .4 0 .6c0 123.7 100.3 224 224 224c.2 0 .4 0 .6 0zm31.9-2.3c97.7-14.2 174.9-91.4 189.1-189.1c-49.5-3.8-100.3 13.2-138.1 51s-54.8 88.6-51 138.1zM223.5 34.3C125.8 48.6 48.6 125.8 34.3 223.5c49.5 3.8 100.3-13.2 138.1-51s54.8-88.6 51-138.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faSquareL = {
  prefix: 'fal',
  iconName: 'square-l',
  icon: [448, 512, [], "e275", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 48V352H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSortUp = {
  prefix: 'fal',
  iconName: 'sort-up',
  icon: [320, 512, ["sort-asc"], "f0de", "M154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 179.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2L154.4 66.2zm-22-23.3L12.3 156.4C4.4 163.8 0 174.1 0 184.9C0 206.5 17.5 224 39.1 224H280.9c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.5L187.6 42.9C180.1 35.9 170.2 32 160 32s-20.1 3.9-27.6 10.9z"]
};
var faSortAsc = faSortUp;
var faCalendarArrowUp = {
  prefix: 'fal',
  iconName: 'calendar-arrow-up',
  icon: [448, 512, ["calendar-upload"], "e0d1", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM208 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 294.6 208 416z"]
};
var faCalendarUpload = faCalendarArrowUp;
var faCommentDots = {
  prefix: 'fal',
  iconName: 'comment-dots',
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM128 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCommenting = faCommentDots;
var faPlantWilt = {
  prefix: 'fal',
  iconName: 'plant-wilt',
  icon: [512, 512, [], "e5aa", "M288 96c0-35.3 28.7-64 64-64s64 28.7 64 64v33.1c-38.4 5.7-64 32.2-64 73.9c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-41.7-25.6-68.3-64-73.9V96c0-53-43-96-96-96s-96 43-96 96v65.6c-20.3-20.7-48.7-33.6-80-33.6c-61.9 0-112 50.1-112 112v17.1c-38.4 5.7-64 32.2-64 73.9C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-41.7-25.6-68.3-64-73.9V240c0-44.2 35.8-80 80-80s80 35.8 80 80v40V496c0 8.8 7.2 16 16 16s16-7.2 16-16V280 240 96zm128 65.7V192c0 8.8 7.2 16 16 16s16-7.2 16-16V161.7c8.9 2 15.5 5.6 20.1 9.8c6.6 6 11.9 15.8 11.9 31.6c0 5.8-3.3 18.8-13.5 36.5c-8.3 14.5-20.1 30-34.5 44.3c-14.4-14.3-26.2-29.9-34.5-44.3c-10.2-17.7-13.5-30.7-13.5-36.5c0-15.8 5.3-25.6 11.9-31.6c4.6-4.2 11.2-7.8 20.1-9.8zM43.9 299.5c4.6-4.2 11.2-7.8 20.1-9.8v30.6c0 8.8 7.2 16 16 16s16-7.2 16-16V289.7c8.9 2 15.5 5.6 20.1 9.8c6.6 6 11.9 15.8 11.9 31.6c0 5.8-3.3 18.8-13.5 36.5c-8.3 14.5-20.1 30-34.5 44.3C65.6 397.6 53.8 382 45.5 367.6C35.3 349.8 32 336.9 32 331.1c0-15.8 5.3-25.6 11.9-31.6z"]
};
var faScarf = {
  prefix: 'fal',
  iconName: 'scarf',
  icon: [512, 512, [129507], "f7c1", "M221.4 32h69.1c17.3 0 33.3 9.4 41.8 24.5l41.5 73.8c6.6 11.8 10.1 25.1 10.1 38.6c0 20.9-8.3 40.9-23 55.6l-9 9L246.6 128H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H227.3c-21.4 0-32.1 25.9-17 41L340.7 267.3 385.4 312 312 385.4l-161-161c-14.8-14.7-23-34.8-23-55.6c0-13.5 3.5-26.8 10.1-38.6l41.5-73.8C188.1 41.4 204.1 32 221.4 32zM374.6 256l9-9c20.8-20.8 32.4-48.9 32.4-78.2c0-19-4.9-37.7-14.2-54.2L360.3 40.8C346.1 15.6 319.5 0 290.6 0H221.4c-28.9 0-55.6 15.6-69.7 40.8l-41.5 73.8C100.9 131.1 96 149.8 96 168.8c0 29.3 11.7 57.5 32.4 78.2L300.7 419.3l8 8 0 0 3.3 3.3 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L334.6 408 360 382.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L382.6 360 408 334.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L430.6 312l-3.3-3.3 0 0-8-8L374.6 256zM233.4 397.3l-22.6-22.6L100.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L233.4 397.3zm-48-48l-22.6-22.6L52.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L185.4 349.3zm-48-48l-22.6-22.6L4.7 388.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L137.4 301.3z"]
};
var faAlbumCirclePlus = {
  prefix: 'fal',
  iconName: 'album-circle-plus',
  icon: [576, 512, [], "e48c", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H275.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V96c0-17.7-14.3-32-32-32zM224 96c69.3 0 128.3 44 150.5 105.6c-10.2 3.5-20 8-29.3 13.2C328.1 164.3 280.3 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c11.2 0 22-1.4 32.4-4.1c.7 10.9 2.4 21.5 5 31.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm0 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faUserNurseHairLong = {
  prefix: 'fal',
  iconName: 'user-nurse-hair-long',
  icon: [448, 512, [], "e45e", "M128 144V76.9l96-42 96 42V144H128zM96 76.9V144v16c0 35.3-16.6 68.4-44.8 89.6l-4.3 3.2C37.5 259.9 32 270.9 32 282.7C32 303.3 48.7 320 69.3 320H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H69.3c-2.9 0-5.3-2.4-5.3-5.3c0-1.7 .8-3.3 2.1-4.3l4.3-3.2c15.8-11.9 28.8-26.7 38.4-43.3C129.5 274.6 173.3 304 224 304s94.5-29.4 115.2-72.2c9.6 16.7 22.6 31.5 38.4 43.3l4.3 3.2c1.3 1 2.1 2.6 2.1 4.3c0 2.9-2.4 5.3-5.3 5.3H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h58.7c20.6 0 37.3-16.7 37.3-37.3c0-11.8-5.5-22.8-14.9-29.9l-4.3-3.2C368.6 228.4 352 195.3 352 160V144 76.9c0-12.7-7.5-24.2-19.2-29.3l-96-42c-8.2-3.6-17.5-3.6-25.7 0l-96 42C103.5 52.7 96 64.2 96 76.9zM320 176v0c0 53-43 96-96 96c-35.5 0-66.6-19.3-83.2-48h21.5c35.5 0 68.3-18.3 87-48H320zm-112.8 0c-12.4 10.2-28.2 16-44.8 16h-33c-.9-5.2-1.3-10.5-1.3-16v0h79.2zM130.8 382l59.3 59.3c18.7 18.7 49.1 18.7 67.9 0L317.2 382c52.8 1.8 95.4 43.5 98.6 95.9H32.2c3.2-52.4 45.9-94.1 98.6-95.9zm20-25.3c-4.3-4.3-10.2-6.8-16.4-6.8C60.2 349.9 0 410.1 0 484.3c0 14.1 11.5 25.6 25.6 25.6H422.4c14.1 0 25.6-11.5 25.6-25.6c0-74.2-60.2-134.4-134.4-134.4c-6.1 0-12 2.4-16.4 6.8l-61.9 61.9c-6.2 6.2-16.4 6.2-22.6 0l-61.9-61.9zM208 56V72H192c-4.4 0-8 3.6-8 8V96c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V104h16c4.4 0 8-3.6 8-8V80c0-4.4-3.6-8-8-8H240V56c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"]
};
var faDiamond = {
  prefix: 'fal',
  iconName: 'diamond',
  icon: [512, 512, [9830], "f219", "M250.3 34.3c3.1-3.1 8.2-3.1 11.3 0l216 216c3.1 3.1 3.1 8.2 0 11.3l-216 216c-3.1 3.1-8.2 3.1-11.3 0l-216-216c-3.1-3.1-3.1-8.2 0-11.3l216-216zm33.9-22.6c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"]
};
var faSquareLeft = {
  prefix: 'fal',
  iconName: 'square-left',
  icon: [448, 512, [11013, "arrow-alt-square-left"], "f351", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM80 256c0-9.2 3.5-18 9.7-24.7l84-91c7.2-7.8 17.4-12.3 28.1-12.3c21.1 0 38.3 17.1 38.3 38.3l0 25.7 80 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-80 0 0 25.7c0 21.1-17.1 38.3-38.3 38.3c-10.7 0-20.9-4.5-28.1-12.3l-84-91C83.5 274 80 265.2 80 256zm33.2 3l84 91c1.2 1.3 2.9 2 4.6 2c3.5 0 6.3-2.8 6.3-6.3l0-41.7c0-8.8 7.2-16 16-16l96 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16l0-41.7c0-3.5-2.8-6.3-6.3-6.3c-1.7 0-3.4 .7-4.6 2l-84 91c-.8 .8-1.2 1.9-1.2 3s.4 2.2 1.2 3z"]
};
var faArrowAltSquareLeft = faSquareLeft;
var faFaceGrinSquint = {
  prefix: 'fal',
  iconName: 'face-grin-squint',
  icon: [512, 512, [128518, "grin-squint"], "f585", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM129.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 208l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
var faGrinSquint = faFaceGrinSquint;
var faCircleEllipsisVertical = {
  prefix: 'fal',
  iconName: 'circle-ellipsis-vertical',
  icon: [512, 512, [], "e10b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHandHoldingDollar = {
  prefix: 'fal',
  iconName: 'hand-holding-dollar',
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M304 24V41.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.3 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V232c0 8.8-7.2 16-16 16s-16-7.2-16-16V214.2c-11.2-2.1-21.7-5.7-30.9-8.9c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3C224 71.1 234.9 57.7 247.9 50c7.5-4.4 15.8-7.2 24.1-8.7V24c0-8.8 7.2-16 16-16s16 7.2 16 16zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7H80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faHandHoldingUsd = faHandHoldingDollar;
var faGridDividers = {
  prefix: 'fal',
  iconName: 'grid-dividers',
  icon: [512, 512, [], "e3ad", "M0 16C0 7.2 7.2 0 16 0H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zM64 128v64h64V128H64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128zM64 416v64h64V416H64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V416zM288 128H224v64h64V128zM224 96h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm0 320v64h64V416H224zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416zM448 128H384v64h64V128zM384 96h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm0 320v64h64V416H384zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V416zM16 288H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBacterium = {
  prefix: 'fal',
  iconName: 'bacterium',
  icon: [512, 512, [], "e05a", "M415.4 20.4c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-6 20.9c-11.7-1.1-23.8-.4-35.8 2.4c-13.7 3.2-26.9 6.8-39.5 10.8l-8.6-20c-3.5-8.1-12.9-11.9-21-8.4s-11.9 12.9-8.4 21l7.8 18.2c-27.3 10.9-51.7 23.8-73.5 38L189.3 79.1c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l10.8 16.2c-24.5 19-45 39.8-62.1 61.1L98 163.5c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5L92.4 200c-3.7 5.5-7.1 10.9-10.4 16.4c-10.4 17.4-19.8 36-27.5 55.4l-16.5-6.6c-8.2-3.3-17.5 .7-20.8 8.9s.7 17.5 8.9 20.8L43.9 302c-5.5 18.4-9.4 37.2-11.4 55.9c-.9 9.7-.5 19.3 1 28.5l-21.9 6.2C3.1 395-1.8 403.9 .6 412.4s11.3 13.4 19.8 11l22.8-6.5c10.9 22.5 29.2 40.9 51.9 51.9l-6.5 22.8c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11l6.3-21.9c2.7 .4 5.4 .8 8.2 1c26.6 2.4 51.9-4.7 72.5-18.5l14.3 14.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-13.1-13.1c13.6-16.4 22.7-36.8 25.2-59.4c1.1-7.5 3.2-15 5.9-22.2l20.5 8.8c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21l-18.8-8.1c10.8-17.2 28.2-37.7 58.4-54.3l2.7 9.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8l-3.9-13.8c9.1-3.3 19-6.2 29.7-8.7c17.6-4.1 33.3-12.1 46.4-22.9l13.1 13.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L461 206.4c15.4-23 22.3-51.7 17.5-80.7l21.9-6.3c8.5-2.4 13.4-11.3 11-19.8s-11.3-13.4-19.8-11l-22.8 6.5c-12.3-25.4-33.6-44.8-59-55.1l5.6-19.7zm-74.9 216c-.3 .1-.6 .1-.9 .2c-1.7 .5-3.2 1.2-4.6 2.2c-47.2 21.1-73.2 51-88.4 76.4c-10.1 16.9-19.5 37.7-22.9 60.1c-.1 .5-.1 .9-.2 1.4c-4.7 43.3-43.2 74.9-86.8 71c-43.9-4-76.3-42.8-72.4-86.7C69 317.1 86 271.9 109.4 232.8C149.4 166.1 222.8 95.4 350 66c43.1-9.9 86 16.9 95.9 60s-16.9 86-60 95.9c-16.9 3.9-32 8.8-45.5 14.4zM264 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 320a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96z"]
};
var faHandPointer = {
  prefix: 'fal',
  iconName: 'hand-pointer',
  icon: [448, 512, [], "f25a", "M128 56c0-13.3 10.7-24 24-24s24 10.7 24 24V188.2c0 6.3 3.7 12 9.5 14.6s12.5 1.5 17.2-2.7c5.7-5.1 13.1-8.1 21.3-8.1c16.8 0 30.7 13 31.9 29.5c.5 6.1 4.3 11.4 10 13.7s12.1 1.1 16.7-3c5.7-5.1 13.2-8.2 21.4-8.2c16.8 0 30.7 13 31.9 29.5c.5 6.1 4.3 11.4 10 13.7s12.1 1.1 16.7-3c5.7-5.1 13.2-8.2 21.4-8.2c17.7 0 32 14.3 32 32v32 16 64c0 44.2-35.8 80-80 80H272 256 205.7c-36.1 0-70.3-16.3-93.1-44.3L37.4 343.1c-8.4-10.3-6.8-25.4 3.5-33.8s25.4-6.8 33.8 3.5l25 30.7c4.3 5.3 11.4 7.3 17.8 5s10.6-8.3 10.6-15.1V56zM152 0C121.1 0 96 25.1 96 56V288.8c-20-20.5-52.7-22.7-75.3-4.3C-3.3 304-7 339.3 12.5 363.3l75.2 92.5c28.9 35.5 72.2 56.2 118 56.2H256h16 64c61.9 0 112-50.1 112-112V336 320 288c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.5 0-10.9 .7-16 2V56c0-30.9-25.1-56-56-56zm72 320c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V320zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V320zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V320z"]
};
var faDrumSteelpan = {
  prefix: 'fal',
  iconName: 'drum-steelpan',
  icon: [576, 512, [], "f56a", "M544 160c0-19.9-16.1-43.9-64.8-64.5C454.6 85.1 424.5 77 390.3 71.6c-21.4 61.1-16.2 121.3 21.2 173c25.5-5.2 48.4-11.9 67.7-20.1C527.9 203.9 544 179.9 544 160zM348.3 174.5C333.1 182.9 311.5 192 288 192s-45.1-9.1-60.3-17.5c-4.2 26.2-13.5 51.7-28.6 75.9c27.5 3.7 57.4 5.6 88.8 5.6s61.3-2 88.8-5.6c-15-24.2-24.4-49.7-28.6-75.9zm-2.6-36.1c.4-23.5 4.5-47.4 12.2-71C335.8 65.2 312.4 64 288 64s-47.8 1.2-69.9 3.4c7.7 23.6 11.8 47.5 12.2 71c3.3 2.3 7.4 5 12.2 7.6C255.6 153.5 272 160 288 160s32.4-6.5 45.5-13.9c4.7-2.7 8.9-5.3 12.2-7.7zM96.8 224.5c19.3 8.2 42.2 14.9 67.7 20.1c37.5-51.8 42.6-112 21.2-173C151.5 77 121.4 85.1 96.8 95.5C48.1 116.1 32 140.1 32 160s16.1 43.9 64.8 64.5zM576 160V344c0 47.6-38.6 81.6-89.5 102.9C434.7 468.6 364.4 480 288 480s-146.7-11.4-198.5-33.1C38.6 425.6 0 391.6 0 344V160C0 80 128.9 32 288 32s288 48 288 128zm-32 62.8C496.1 264.4 399.5 288 288 288s-208.1-23.6-256-65.2V344c0 27.4 22.3 53.4 69.9 73.4C148.5 436.9 214.2 448 288 448s139.5-11.1 186.2-30.6c47.6-19.9 69.8-46 69.8-73.4V222.8z"]
};
var faHandScissors = {
  prefix: 'fal',
  iconName: 'hand-scissors',
  icon: [544, 512, [], "f257", "M4.2 284.4c-2.4-33 22.4-61.8 55.5-64.2l72.8-5.3-76.3-21c-32-8.8-50.7-41.8-41.9-73.8s41.8-50.7 73.8-41.9l177.4 48.8c1.8-2.9 3.8-5.7 5.8-8.4L288 96c15.1-20.1 38.8-32 64-32l19.5 0c53 0 101.7 29.1 126.8 75.7l4.5 8.3c11.3 21 17.2 44.4 17.2 68.3L520 336c0 70.7-57.3 128-128 128l-40 0-40 0-8 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-2.2 .1-4.3 .3-6.4L68.4 339.8c-33 2.4-61.8-22.4-64.2-55.5zM62 252.1c-15.4 1.1-27 14.5-25.9 30s14.5 27 30 25.9L229.3 296c5.9-.4 11.6 2.4 14.7 7.5s3.3 11.4 .3 16.5c-2.7 4.7-4.3 10.2-4.3 16c0 14.7 10 27.2 23.6 30.9c4.4 1.2 8.1 4.2 10.1 8.3s2.2 8.8 .6 13.1c-1.4 3.6-2.2 7.6-2.2 11.8c0 17.7 14.3 32 32 32l8 0 40 0 40 0c53 0 96-43 96-96l0-119.7c0-18.5-4.6-36.8-13.4-53.1l14.1-7.6-14.1 7.6-4.5-8.3C450.6 118.6 412.7 96 371.5 96L352 96c-15.1 0-29.3 7.1-38.4 19.2L297 137.4l51.6 15.3c8.5 2.5 13.3 11.4 10.8 19.9s-11.4 13.3-19.9 10.8L206.6 144 79.4 109c-14.9-4.1-30.3 4.7-34.4 19.6s4.7 30.3 19.6 34.4l165.8 45.6c7.5 2.1 12.4 9.2 11.7 17s-7 13.8-14.8 14.4L62 252.1z"]
};
var faHandsPraying = {
  prefix: 'fal',
  iconName: 'hands-praying',
  icon: [640, 512, ["praying-hands"], "f684", "M283.4 32c-6.8 0-13.2 3.4-17.1 9L179.5 168.4C166.8 187 160 209 160 231.5v50.3c0 20-12.4 37.9-31.1 44.9L21.6 367c-8.3 3.1-17.5-1.1-20.6-9.4s1.1-17.5 9.4-20.6l107.2-40.2c6.2-2.3 10.4-8.3 10.4-15V231.5c0-28.9 8.7-57.2 25-81.1L239.9 23C249.7 8.6 266 0 283.4 0c14.2 0 27.2 5.7 36.6 14.8C329.5 5.7 342.4 0 356.6 0c17.4 0 33.7 8.6 43.5 23L487 150.4c16.3 23.9 25 52.2 25 81.1v50.3c0 6.7 4.1 12.6 10.4 15L629.6 337c8.3 3.1 12.5 12.3 9.4 20.6s-12.3 12.5-20.6 9.4L511.1 326.8c-18.7-7-31.1-24.9-31.1-44.9V231.5c0-22.5-6.8-44.5-19.5-63.1L373.7 41c-3.8-5.6-10.2-9-17.1-9C345.2 32 336 41.2 336 52.6V59c0 5.3 1.6 10.5 4.5 15l51.3 76.9c15.8 23.7 24.2 51.4 24.2 79.9V232v72c0 8.8-7.2 16-16 16s-16-7.2-16-16V232c0-13.3-10.7-24-24-24s-24 10.7-24 24v74.2c0 48.9 31.7 92.1 78.3 106.8l214.5 67.8c8.4 2.7 13.1 11.6 10.4 20.1s-11.6 13.1-20.1 10.4L404.6 443.5c-37.5-11.8-67.4-38-84.6-71.3c-17.2 33.3-47.2 59.5-84.6 71.3L20.8 511.3c-8.4 2.7-17.4-2-20.1-10.4s2-17.4 10.4-20.1L225.7 413c46.6-14.7 78.3-57.9 78.3-106.8V232c0-13.3-10.7-24-24-24s-24 10.7-24 24v72c0 8.8-7.2 16-16 16s-16-7.2-16-16V232v-1.2c0-28.4 8.4-56.2 24.2-79.9L299.5 74c3-4.4 4.5-9.6 4.5-15V52.6c0-11.4-9.2-20.6-20.6-20.6zM320 100.8l-45.2 67.8c-1.8 2.7-3.5 5.5-5 8.3c3.3-.6 6.7-.9 10.2-.9c15.7 0 29.8 6.4 40 16.8c10.2-10.4 24.3-16.8 40-16.8c3.5 0 6.9 .3 10.2 .9c-1.6-2.8-3.2-5.6-5-8.3L320 100.8z"]
};
var faPrayingHands = faHandsPraying;
var faFacePensive = {
  prefix: 'fal',
  iconName: 'face-pensive',
  icon: [512, 512, [], "e384", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 384h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM387.2 270.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM81.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8l-22.9 11.4c-7.9 4-17.5 .7-21.5-7.2zm341.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L386 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z"]
};
var faUserMusic = {
  prefix: 'fal',
  iconName: 'user-music',
  icon: [640, 512, [], "f8eb", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480H289.4c2.5 12.2 8.2 23 16.1 32H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.5 0 83.3 15.6 114.3 41.4v40.2c-1.5 0-2.9 0-4.4 .1C352.8 355.3 313.5 336 269.7 336H178.3c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zm501.9 39.8c20.7-6.9 42.1 8.5 42.1 30.4V248 392c0 1.1-.1 2.2-.3 3.2c.2 1.6 .3 3.2 .3 4.8c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V270.2L448 323.5V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V312 251.5c0-13.8 8.8-26 21.9-30.4l160-53.3zM448 289.8l160-53.3V198.2L448 251.5v38.3zM608 400c0-.9-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7c5.5-4.1 5.9-7.4 5.9-8.3zM416 464c0-.9-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7c5.5-4.1 5.9-7.4 5.9-8.3z"]
};
var faArrowRotateRight = {
  prefix: 'fal',
  iconName: 'arrow-rotate-right',
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M464 192c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v92.6C408.8 75.5 337.5 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.9 0 150-41.8 189.7-104.8c6.6-10.4-1.4-23.2-13.7-23.2c-6 0-11.4 3.2-14.7 8.2C383.1 413 323.6 448 256 448C150 448 64 362 64 256S150 64 256 64c71.1 0 133.1 38.6 166.3 96H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H464z"]
};
var faArrowRightRotate = faArrowRotateRight;
var faArrowRotateForward = faArrowRotateRight;
var faRedo = faArrowRotateRight;
var faMessagesDollar = {
  prefix: 'fal',
  iconName: 'messages-dollar',
  icon: [640, 512, ["comments-alt-dollar"], "f652", "M183.5 294.4L128 336V320c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V256c0 17.7-14.3 32-32 32H202.7c-6.9 0-13.7 2.2-19.2 6.4zM202.7 320H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V256c0 35.3 28.7 64 64 64H96v32 16c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320zM256 384c0 35.3 28.7 64 64 64H437.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V480 448h32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448v32H576c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H544c-17.7 0-32 14.3-32 32v16l-55.5-41.6c-5.5-4.2-12.3-6.4-19.2-6.4H320c-17.7 0-32-14.3-32-32V352H256v32zM224 79.1c0-8.8-7.2-16-16-16s-16 7.2-16 16V89.6c-6 1.3-12.1 3.4-17.6 6.6c-11.1 6.4-20.9 17.8-20.8 34.7c.1 16.2 9.8 26.2 19.9 32.2c8.8 5.1 19.7 8.4 28.4 10.9l1.4 .4c10.1 3 17.4 5.3 22.5 8.4c4.2 2.5 4.5 4.1 4.5 5.9c0 3.5-1.2 5.7-4.6 7.7c-4 2.4-10.4 3.9-17.3 3.7c-9-.3-17.3-3-28.2-6.6l0 0 0 0c-1.8-.6-3.8-1.2-5.8-1.9c-8.4-2.7-17.4 1.9-20.2 10.3s1.9 17.4 10.3 20.2c1.6 .5 3.2 1 4.9 1.6l0 0 0 0c6.6 2.2 14.3 4.8 22.5 6.5v10.9c0 8.8 7.2 16 16 16s16-7.2 16-16V230.6c6.4-1.3 12.7-3.5 18.4-7c11.4-6.9 20.2-18.8 20-35.5c-.2-16.2-9.6-26.5-19.8-32.8c-9.2-5.6-20.7-9-29.6-11.6l-.5-.2c-10.2-3-17.6-5.2-22.7-8.2c-4.1-2.4-4.1-3.6-4.1-4.6l0-.1c0-2.5 .9-4.5 4.8-6.8c4.4-2.5 11-4 17.4-3.9c7.7 .1 16.2 1.8 25 4c8.6 2.2 17.3-2.9 19.5-11.5s-2.9-17.3-11.5-19.5c-5.2-1.3-10.9-2.7-16.8-3.6V79.1z"]
};
var faCommentsAltDollar = faMessagesDollar;
var faSensorOn = {
  prefix: 'fal',
  iconName: 'sensor-on',
  icon: [640, 512, [], "e02b", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 96c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zM600.2 93.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-21.9-5.5l-80 48c-7.6 4.5-10 14.4-5.5 22s14.4 10 21.9 5.5l80-48zM528 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H528zm-7.8 130.3c-7.6-4.5-17.4-2.1-21.9 5.5s-2.1 17.4 5.5 21.9l80 48c7.6 4.5 17.4 2.1 21.9-5.5s2.1-17.4-5.5-21.9l-80-48z"]
};
var faBalloon = {
  prefix: 'fal',
  iconName: 'balloon',
  icon: [384, 512, [], "e2e3", "M205.6 405.8l0 0 0 0 0 0L192 415.3l-13.6-9.5 0 0 0 0 0 0 0 0-.2-.2-1.1-.8c-1-.7-2.6-1.9-4.6-3.4c-4-3-9.9-7.6-17-13.5c-14.2-11.8-33.1-28.8-51.8-49.4C65 295.9 32 243.6 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160c0 51.6-33 103.9-71.7 146.5c-18.8 20.6-37.6 37.6-51.8 49.4c-7.1 5.9-12.9 10.5-17 13.5c-2 1.5-3.6 2.7-4.6 3.4l-1.1 .8-.2 .2 0 0zM192 439.6l3.4 6.8L212.2 480H171.8l16.8-33.7 3.4-6.8zM0 192C0 320 160 432 160 432l-30.6 61.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9H243.1c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L224 432s160-112 160-240C384 86 298 0 192 0S0 86 0 192zm112-16c0-35.3 28.7-64 64-64c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faBiohazard = {
  prefix: 'fal',
  iconName: 'biohazard',
  icon: [576, 512, [9763], "f780", "M147.2 6.4c3-4 7.8-6.4 12.8-6.4h.9c4.6 0 8.9 1.9 11.9 5.3s4.5 7.9 4 12.4c-3.5 30.8 4.4 62.5 22.7 86.3c18 23.3 47 40 88.5 40s70.4-16.6 88.5-40c18.4-23.7 26.2-55.5 22.7-86.3c-.5-4.5 .9-9.1 4-12.4s7.4-5.3 11.9-5.3h.9c5 0 9.8 2.4 12.8 6.4C450.9 35.8 464 72.4 464 112c0 18.6-2.9 36.5-8.2 53.3c15.5 3.9 30.6 10 45.1 18.3c34.3 19.8 59.4 49.4 73.9 83.3c2 4.6 1.7 9.9-.9 14.3l-.5 .8c-2.3 3.9-6.1 6.7-10.6 7.7s-9.1-.1-12.8-2.8c-24.9-18.4-56.3-27.5-86.1-23.4c-29.2 4-58.1 20.7-78.8 56.6s-20.8 69.3-9.6 96.6c11.4 27.8 35 50.4 63.3 62.8c4.2 1.8 7.4 5.3 8.8 9.7s.9 9.1-1.3 13l-.5 .8c-2.5 4.4-6.9 7.3-11.9 7.9c-36.5 4.4-74.8-2.5-109.1-22.3c-13.8-8-26.1-17.5-36.9-28.3c-10.7 10.8-23.1 20.4-36.9 28.3c-34.3 19.8-72.5 26.8-109.1 22.3c-5-.6-9.4-3.5-11.9-7.9l-.5-.8c-2.3-3.9-2.8-8.7-1.3-13s4.6-7.8 8.8-9.7c28.4-12.4 51.9-35 63.3-62.8c11.2-27.3 11.1-60.7-9.6-96.6s-49.6-52.7-78.8-56.6c-29.8-4-61.1 5.1-86.1 23.4c-3.7 2.7-8.3 3.7-12.8 2.8s-8.3-3.7-10.6-7.7l-.5-.8c-2.5-4.4-2.8-9.6-.9-14.3c14.4-33.8 39.6-63.5 73.9-83.3c14.5-8.3 29.6-14.4 45.1-18.3c-5.3-16.8-8.2-34.7-8.2-53.3c0-39.6 13.1-76.2 35.2-105.6zm2.2 66.5C145.9 85.3 144 98.4 144 112c0 21 4.5 40.9 12.5 58.8c2.1 4.6 1.8 9.9-.6 14.3s-6.9 7.4-11.9 8.1c-18.1 2.4-36.1 8.3-52.9 18.1C79.4 218.1 69 226.3 60 235.5c18.2-4.9 37.4-6.4 56.3-3.8c39.4 5.3 76.8 28.2 102.3 72.3s26.6 87.9 11.5 124.7c-7.3 17.7-18.1 33.5-31.5 46.9c12.5-3.2 24.8-8.1 36.5-14.9c16-9.2 29.5-21 40.4-34.6c3-3.8 7.6-6 12.5-6s9.4 2.2 12.5 6c10.9 13.5 24.4 25.4 40.4 34.6c11.7 6.8 24 11.7 36.5 14.9c-13.3-13.3-24.2-29.2-31.5-46.9c-15.1-36.8-14-80.6 11.5-124.7s62.9-67 102.3-72.3c19-2.6 38.1-1.1 56.3 3.8c-9-9.2-19.4-17.4-31.2-24.2c-16.8-9.7-34.8-15.6-52.9-18.1c-5-.7-9.4-3.7-11.9-8.1s-2.7-9.7-.6-14.3c8-17.9 12.5-37.9 12.5-58.9c0-13.6-1.9-26.7-5.4-39.1c-4.9 18.2-13.1 35.5-24.9 50.7C377.5 155.1 339 176 288 176s-89.5-20.9-113.8-52.4c-11.7-15.1-20-32.5-24.9-50.7zm5.1 358.6c-40.1-33.6-67.4-82.1-73.3-136.9c9-1.8 18.1-2.2 26.7-1.1c1.8 .2 3.7 .6 5.5 1c5.6 43.9 27.3 82.7 59 110.3l-.1 .3c-3.9 9.6-10.1 18.6-17.9 26.4zM288 96c-15.9 0-31.3 2.1-45.9 6.1c-7.6-4.6-13.7-10.4-18.5-16.6c-2.2-2.9-4.2-6-6.1-9.2C239.5 68.3 263.3 64 288 64s48.5 4.3 70.5 12.2c-1.8 3.2-3.8 6.3-6.1 9.2c-4.8 6.2-10.9 12-18.5 16.6c-14.6-3.9-30-6.1-45.9-6.1zM462.6 294.5c1.8-.4 3.7-.7 5.5-1c8.6-1.2 17.7-.8 26.7 1.1c-5.9 54.9-33.2 103.3-73.3 136.9c-7.8-7.8-13.9-16.8-17.9-26.4l-.1-.3c31.7-27.6 53.5-66.4 59.1-110.3zM288 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faChessQueenPiece = {
  prefix: 'fal',
  iconName: 'chess-queen-piece',
  icon: [256, 512, ["chess-queen-alt"], "f446", "M104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm67.8 41.4c6.5 1.2 11.6 6.2 12.8 12.7C187.4 92.9 200.4 104 216 104c5.6 0 10.7-1.4 15.3-3.9c6.1-3.3 13.7-2.3 18.8 2.5s6.3 12.4 3.2 18.7L201.9 224H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H192.7l4.4 96h-32l-4.4-96H95.3l-4.4 96h-32l4.4-96H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h6.1L2.8 121.3C-.3 115.1 1 107.5 6 102.7s12.6-5.9 18.8-2.5c4.5 2.5 9.7 3.9 15.3 3.9c15.6 0 28.6-11.1 31.4-25.9c1.3-6.5 6.3-11.5 12.8-12.7s13 1.7 16.5 7.3C106.4 81.9 116.5 88 128 88s21.6-6.1 27.3-15.2c3.5-5.6 10-8.5 16.5-7.3zM89.9 224h76.2l44.1-88.3c-19.2-1.7-35.9-11.9-46.4-26.7c-10.2 6.9-22.5 11-35.8 11s-25.6-4-35.8-11c-10.6 14.8-27.3 25-46.4 26.7L89.9 224zM190.2 384c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1H190.2zM65.8 416L33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4H216.6c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L190.2 416 65.8 416z"]
};
var faChessQueenAlt = faChessQueenPiece;
var faLocationCrosshairs = {
  prefix: 'fal',
  iconName: 'location-crosshairs',
  icon: [512, 512, ["location"], "f601", "M256 0c8.8 0 16 7.2 16 16V64.7c93.3 7.7 167.6 82.1 175.3 175.3H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H447.3c-7.7 93.3-82.1 167.6-175.3 175.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V447.3C146.7 439.6 72.4 365.3 64.7 272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64.7C72.4 146.7 146.7 72.4 240 64.7V16c0-8.8 7.2-16 16-16zM96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm224 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faLocation = faLocationCrosshairs;
var faMarsDouble = {
  prefix: 'fal',
  iconName: 'mars-double',
  icon: [640, 512, [9891], "f227", "M304 48c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16V160c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6L311.3 191.4C336.7 221.9 352 261.2 352 304c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c42.8 0 82.1 15.3 112.6 40.7L393.4 64H320c-8.8 0-16-7.2-16-16zM176 448a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM469.4 190.1c4.5-5.6 7.8-12.3 9.5-19.6L585.4 64H512c-8.8 0-16-7.2-16-16s7.2-16 16-16H624c8.8 0 16 7.2 16 16V160c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6l-100 100c22.6 30.6 36 68.4 36 109.4c0 101.6-82.4 184-184 184c-20.7 0-40.5-3.4-59.1-9.7c10.1-7.6 19.5-16.2 28.1-25.5c10 2.1 20.3 3.2 30.9 3.2c83.9 0 152-68.1 152-152c0-38.3-14.1-73.3-37.5-100l-5.1-5.9z"]
};
var faHousePersonLeave = {
  prefix: 'fal',
  iconName: 'house-person-leave',
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", "M250.4 3.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L64 187.9V352c0 35.3 28.7 64 64 64H336.8L354 398.8l7.4-14.8H352 320 128c-17.7 0-32-14.3-32-32V160.5L240 37.1 358.2 138.4c8.3-7.2 17.2-13.6 26.7-19.2L250.4 3.9zM192 192h64v64H192V192zm-8-32c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H184zM496 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 464 56a56 56 0 1 0 112 0zM437.6 172.3c1.3-.7 2.6-1.4 3.9-2l-26.6 85c-5.7 18.2 0 38.1 14.4 50.6L529.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L560.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L507.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2l-30.8 61.7-62.2 62.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5z"]
};
var faHouseLeave = faHousePersonLeave;
var faHousePersonDepart = faHousePersonLeave;
var faRulerTriangle = {
  prefix: 'fal',
  iconName: 'ruler-triangle',
  icon: [512, 512, [128208], "f61c", "M32 45.3V448c0 17.7 14.3 32 32 32H466.7c7.3 0 13.3-5.9 13.3-13.3c0-3.5-1.4-6.9-3.9-9.4l-39.4-39.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4L116.7 97.9 91.3 123.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L94.1 75.3 54.6 35.9c-2.5-2.5-5.9-3.9-9.4-3.9C37.9 32 32 37.9 32 45.3zm45.3-32L498.7 434.7c8.5 8.5 13.3 20 13.3 32c0 25-20.3 45.3-45.3 45.3H64c-35.3 0-64-28.7-64-64V45.3C0 20.3 20.3 0 45.3 0c12 0 23.5 4.8 32 13.3zm44.6 228c6-2.5 12.9-1.1 17.4 3.5l128 128c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H128c-8.8 0-16-7.2-16-16V256c0-6.5 3.9-12.3 9.9-14.8zM144 294.6V368h73.4L144 294.6z"]
};
var faCardClub = {
  prefix: 'fal',
  iconName: 'card-club',
  icon: [384, 512, [], "e3e9", "M320 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H320zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM208 331.9c7.5 2.7 15.6 4.1 24 4.1c39.8 0 72-32.2 72-72c0-28.3-16.3-52.7-40-64.5c-.3-39.5-32.4-71.5-72-71.5s-71.7 32-72 71.5C96.3 211.3 80 235.7 80 264c0 39.8 32.2 72 72 72c8.4 0 16.5-1.4 24-4.1V352H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V331.9zM152 200c0-22.1 17.9-40 40-40s40 17.9 40 40c0 2.5-.2 4.9-.6 7.2c-1.5 8.1 3.5 16 11.4 18.3c16.9 4.7 29.2 20.2 29.2 38.5c0 22.1-17.9 40-40 40c-11.2 0-21.3-4.6-28.6-12c-3-3.1-7.1-4.8-11.4-4.8s-8.4 1.7-11.4 4.8c-7.3 7.4-17.4 12-28.6 12c-22.1 0-40-17.9-40-40c0-18.3 12.3-33.8 29.2-38.5c8-2.2 12.9-10.1 11.4-18.3c-.4-2.3-.6-4.7-.6-7.2z"]
};
var faChildDress = {
  prefix: 'fal',
  iconName: 'child-dress',
  icon: [320, 512, [], "e59c", "M160 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM96 400H72c-5 0-9.7-2.3-12.7-6.3s-4-9.1-2.8-13.9L98 225.8 28.6 313.9c-5.5 6.9-15.5 8.1-22.5 2.7S-2 301 3.4 294.1l74.3-94.2c18.8-23.9 47.1-38.3 77.3-39.8c1.2-.1 2.5-.1 3.7-.1H160h1.3c1.2 0 2.5 0 3.7 .1c30.2 1.5 58.4 15.9 77.3 39.8l74.3 94.2c5.5 6.9 4.3 17-2.7 22.5s-17 4.3-22.5-2.7L222 225.8l41.5 154c1.3 4.8 .3 9.9-2.8 13.9s-7.7 6.3-12.7 6.3H224v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H128v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400zm60.8-207.9c-10.1 .8-18.7 7.8-21.4 17.7L92.9 368H227.1L184.5 209.8c-2.7-9.9-11.3-16.9-21.4-17.7c-1.1 0-2.1-.1-3.2-.1s-2.1 0-3.2 .1z"]
};
var faUsersBetweenLines = {
  prefix: 'fal',
  iconName: 'users-between-lines',
  icon: [640, 512, [], "e591", "M0 16C0 7.2 7.2 0 16 0H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zM0 496c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM147.2 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM369.6 320h-96c-35.3 0-64 28.7-64 64h224c0-35.3-28.7-64-64-64zm-192 64c0-53 43-96 96-96h96c53 0 96 43 96 96c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32zm144-160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM64 320v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c0-35.3 28.7-64 64-64h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-17.7 0-32 14.3-32 32zm480-32H456c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c0-17.7-14.3-32-32-32z"]
};
var faLungsVirus = {
  prefix: 'fal',
  iconName: 'lungs-virus',
  icon: [640, 512, [], "e067", "M320 0c8.8 0 16 7.2 16 16V146.7c-5-1.8-10.4-2.7-16-2.7s-11 1-16 2.7V16c0-8.8 7.2-16 16-16zm96 181.8c-11-1.3-22.4 1.3-32 7.7V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c12.2 1.4 24.9-2 35-10c7 5.5 15.2 9.7 24.2 11.9l72.7 18.2c4.5 1.1 9.2 1.7 13.8 1.7c31.5 0 57-25.5 57-57v-7c-6.5-52.2-30.3-109.7-56.3-159.5s-53.9-91.9-68.9-113.3c-6.7-9.6-17.7-15.1-29.5-15.1c-20.6 0-37.3 16.7-37.3 37.3v16.5zM234.8 458.2c-12.8 15.9-30.6 27.7-51.5 32.9l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-9.6-6.4-21-8.9-32-7.7V165.3c0-20.6-16.7-37.3-37.3-37.3c-11.8 0-22.8 5.5-29.5 15.1c-14.9 21.4-43 63.5-68.9 113.3S38.5 363.8 32 416v7c0 31.5 25.5 57 57 57c4.7 0 9.3-.6 13.8-1.7l72.7-18.2c9.1-2.3 17.3-6.4 24.2-11.9c10.2 8 22.8 11.4 35 10zm187-59c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2zM403.5 320a83.5 83.5 0 1 0 -167.1 0 83.5 83.5 0 1 0 167.1 0zM304 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 72a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faSpinnerThird = {
  prefix: 'fal',
  iconName: 'spinner-third',
  icon: [512, 512, [], "f3f4", "M463.9 376c7.6 4.4 17.5 1.8 21.4-6.1c17.1-34.3 26.7-73 26.7-113.9C512 120 405.9 8.8 272 .5c-8.8-.5-16 6.7-16 15.5v0c0 8.8 7.2 15.9 16 16.6C388.2 40.8 480 137.7 480 256c0 35.1-8.1 68.3-22.5 97.9c-3.9 8-1.3 17.7 6.4 22.2v0z"]
};
var faFaceGrinTears = {
  prefix: 'fal',
  iconName: 'face-grin-tears',
  icon: [640, 512, [128514, "grin-tears"], "f588", "M110.9 175.4C143.3 91.5 224.7 32 320 32s176.7 59.5 209.1 143.4c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C522 68 428.9 0 320 0S118 68 81.1 163.9c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2zm19.5 200c-4.7-7.5-14.6-9.7-22.1-5s-9.7 14.6-5 22.1C148.7 464.3 228.8 512 320 512s171.3-47.7 216.6-119.5c4.7-7.5 2.5-17.4-5-22.1s-17.4-2.5-22.1 5C469.8 438.3 399.8 480 320 480s-149.8-41.7-189.5-104.5zM320 354.1c31.2 0 61.4-2.9 89.9-8.3c-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3zm142.8-30.7c5.2-11.7-6.8-22.4-19.1-18.7c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7zm-242.4-129c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C273.6 161.9 258.8 152 240 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm147.1 25.4c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C433.6 161.9 418.8 152 400 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zm180.1 39.7c7.5 1.2 15.4 2.7 23 4.4c9.2 2.1 17.3 4.4 23.5 6.8c5 1.9 7.3 3.3 8 3.7c.1 .1 .2 .1 .2 .1s0 0 0 0c7.2 7.3 9.2 23.4-3.6 36.2c-12.8 12.8-28.8 10.8-36.2 3.6c0 0 0 0 0 0s0-.1-.1-.2c-.4-.6-1.8-2.9-3.7-7.9c-2.4-6.3-4.7-14.4-6.7-23.6c-1.7-7.6-3.2-15.5-4.4-23.1zm-35.5-24.2c2.9 26 11.1 84.8 27.7 101.4c21.6 21.6 58.1 19.9 81.5-3.5s25.1-60 3.5-81.5c-16.6-16.6-75.3-24.9-101.4-27.7c-6.5-.8-12.1 4.9-11.3 11.3zM88 282.6c-2.1 9.2-4.3 17.3-6.7 23.6c-1.9 5-3.3 7.3-3.7 7.9c-.1 .1-.1 .2-.1 .2s0 0 0 0c-7.3 7.2-23.4 9.1-36.2-3.6s-10.8-28.8-3.6-36.2c0 0 0 0 0 0s0 0 0 0s.1 0 .2-.1c.6-.4 2.9-1.8 8-3.7c6.3-2.4 14.4-4.7 23.5-6.8c7.6-1.7 15.5-3.2 23-4.4c-1.2 7.5-2.7 15.4-4.4 23.1zm12.2 54.2c16.6-16.6 24.8-75.4 27.7-101.4c.8-6.5-4.9-12.1-11.3-11.3c-26.1 2.8-84.8 11.1-101.4 27.7c-21.6 21.6-19.9 58.1 3.5 81.5s60 25.1 81.5 3.5z"]
};
var faGrinTears = faFaceGrinTears;
var faPhone = {
  prefix: 'fal',
  iconName: 'phone',
  icon: [512, 512, [128222, 128379], "f095", "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64v0C0 300.7 183.5 494.5 416 510.9c4.5 .3 9.1 .6 13.7 .8c0 0 0 0 0 0c0 0 0 0 .1 0c6.1 .2 12.1 .4 18.3 .4l0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM447.7 480C218.1 479.8 32 293.7 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0-3.8 2.6-7 6.3-7.8l112-24c3.7-.8 7.5 1.2 9 4.7l48 112c1.4 3.3 .5 7.1-2.3 9.3l-40.6 33.2c-12.1 9.9-15.3 27.2-7.4 40.8c29.5 50.9 71.9 93.3 122.7 122.7c13.6 7.9 30.9 4.7 40.8-7.4l33.2-40.6c2.3-2.8 6.1-3.7 9.3-2.3l112 48c3.5 1.5 5.5 5.3 4.7 9l-24 112c-.8 3.7-4.1 6.3-7.8 6.3c-.1 0-.2 0-.3 0z"]
};
var faComputerMouseScrollwheel = {
  prefix: 'fal',
  iconName: 'computer-mouse-scrollwheel',
  icon: [384, 512, ["mouse-alt"], "f8cd", "M352 352V160c0-70.7-57.3-128-128-128H160C89.3 32 32 89.3 32 160V352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128zM0 160C0 71.6 71.6 0 160 0h64c88.4 0 160 71.6 160 160V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V160zm208-48v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMouseAlt = faComputerMouseScrollwheel;
var faCalendarXmark = {
  prefix: 'fal',
  iconName: 'calendar-xmark',
  icon: [512, 512, ["calendar-times"], "f273", "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H96c-35.3 0-64 28.7-64 64v32 32V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H384V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H160V16zM64 192H448V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V192zM96 96H416c17.7 0 32 14.3 32 32v32H64V128c0-17.7 14.3-32 32-32zM331.3 283.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 313.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 336l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 358.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 336l52.7-52.7z"]
};
var faCalendarTimes = faCalendarXmark;
var faChildReaching = {
  prefix: 'fal',
  iconName: 'child-reaching',
  icon: [384, 512, [], "e59d", "M224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 128 64zM112 188c-27.8-14.9-51.4-37.4-67.5-65.8L34.1 103.9c-4.4-7.7-1.7-17.5 6-21.8s17.5-1.7 21.8 6l10.4 18.3c24.4 43 70.1 69.6 119.5 69.6c48.9 0 94.1-26 118.7-68.2l11.6-19.9c4.5-7.6 14.2-10.2 21.9-5.8s10.2 14.2 5.8 21.9l-11.6 19.9c-16 27.5-39.1 49.4-66.2 63.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H144V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V188zm32 13.1V352h96V201c-15.4 4.6-31.6 7-48.1 7c-16.4 0-32.5-2.4-47.9-6.9z"]
};
var faTableLayout = {
  prefix: 'fal',
  iconName: 'table-layout',
  icon: [512, 512, [], "e290", "M448 64c17.7 0 32 14.3 32 32v64L32 160l0-64c0-17.7 14.3-32 32-32l384 0zM32 416l0-224 128 0 0 256H64c-17.7 0-32-14.3-32-32zm160 32l0-256 288 0 0 224c0 17.7-14.3 32-32 32H192zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
};
var faNarwhal = {
  prefix: 'fal',
  iconName: 'narwhal',
  icon: [640, 512, [], "f6fe", "M630.6 1.4c8 3.7 11.6 13.1 7.9 21.2L562.2 190.6C609 222.3 640 275.6 640 336c0 97.2-78.8 176-176 176H240c-88.4 0-160-71.6-160-160V328.3 280 264.3L34.1 232.2C12.7 217.2 0 192.8 0 166.7L0 112c0-6 3.3-11.4 8.6-14.2s11.7-2.3 16.6 1.1L96 148.5l70.8-49.6c4.9-3.4 11.3-3.8 16.6-1.1s8.6 8.2 8.6 14.2l0 54.7c0 26.1-12.7 50.6-34.1 65.5L112 264.3V280v48.3c0 13.1 10.6 23.7 23.7 23.7c5.4 0 10.6-1.8 14.8-5.2L323.1 208.7c39.4-31.6 89.1-48.7 139.6-48.7c25.4 0 49.6 5.4 71.5 15L609.4 9.4c3.7-8 13.1-11.6 21.2-7.9zM464 480c79.5 0 144-64.5 144-144c0-79.2-65.5-144-145.4-144c-43.3 0-85.9 14.8-119.6 41.7L170.5 371.8c-9.9 7.9-22.1 12.2-34.8 12.2c-7.3 0-14.2-1.4-20.6-3.9C127.9 437.3 178.9 480 240 480H464zm40-208a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 166.7c0 15.7 7.6 30.3 20.5 39.3L96 236.5 139.5 206c12.8-9 20.5-23.7 20.5-39.3l0-23.9-54.8 38.4c-5.5 3.9-12.8 3.9-18.4 0L32 142.7l0 23.9z"]
};
var faRampLoading = {
  prefix: 'fal',
  iconName: 'ramp-loading',
  icon: [448, 512, [], "f4d4", "M96 32H352c17.7 0 32 14.3 32 32V341.7l32 58.7V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V400.4l32-58.7V64c0-17.7 14.3-32 32-32zm67.1 256c-17.6 0-33.8 9.6-42.2 25.1L38.7 464.8C27.2 486.1 42.6 512 66.9 512H381.1c24.2 0 39.7-25.9 28.1-47.2L327.1 313.1c-8.4-15.5-24.6-25.1-42.2-25.1H163.1zM149 328.4c2.8-5.2 8.2-8.4 14.1-8.4H284.9c5.9 0 11.3 3.2 14.1 8.4L381.1 480H66.9L149 328.4z"]
};
var faCalendarCirclePlus = {
  prefix: 'fal',
  iconName: 'calendar-circle-plus',
  icon: [576, 512, [], "e470", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192H352h64 16 16V160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faToothbrush = {
  prefix: 'fal',
  iconName: 'toothbrush',
  icon: [576, 512, [129701], "f635", "M64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32H288c24.8 0 45.1-9.9 57.7-28.9c6.6-10.1 10.1-21.2 11.9-31.6c14.8 3.6 27.9 9.7 37.9 17.8C408.3 95.7 416 109.4 416 128c0 35.3-28.7 64-64 64H64zM0 160c0 35.3 28.7 64 64 64H352c53 0 96-43 96-96c0-58.5-51.6-89.9-104-95.2c-8.8-.9-15.8 6.4-16.4 15.2c-1.5 25.3-8.4 48-39.6 48H64C28.7 96 0 124.7 0 160zM64 272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48h64 64 64 64 64H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H320V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H256V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H192V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H128V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H64V272z"]
};
var faBorderInner = {
  prefix: 'fal',
  iconName: 'border-inner',
  icon: [448, 512, [], "f84e", "M224 480c-8.8 0-16-7.2-16-16l0-192L16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0 0-192c0-8.8 7.2-16 16-16s16 7.2 16 16l0 192 192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0 0 192c0 8.8-7.2 16-16 16zM32 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM8 64a24 24 0 1 1 48 0A24 24 0 1 1 8 64zm288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPawClaws = {
  prefix: 'fal',
  iconName: 'paw-claws',
  icon: [512, 512, [], "f702", "M313.7 8.8c-4 7.9-.7 17.5 7.2 21.5c8.5 4.2 21.6 15.4 31.8 34c-30-3.5-62.2 21.7-75.2 60.5c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1h0c0-69.9-37.9-112.8-64.8-126.3c-7.9-4-17.5-.7-21.5 7.2zM307.9 135c5.2-15.5 14.2-26.8 23.3-33.1s16.3-6.6 20.8-5.1c4.4 1.5 9.9 5.8 13.4 16.1c3.5 10.3 4 24.7-1.2 40.2s-14.2 26.8-23.3 33.1s-16.3 6.6-20.8 5.1c-4.4-1.5-9.9-5.8-13.4-16.1c-3.5-10.3-4-24.7 1.2-40.2zM205.4 175.2c-3.5 10.3-9 14.6-13.4 16.1c-4.5 1.5-11.7 1.2-20.8-5.1s-18.2-17.6-23.3-33.1s-4.7-29.9-1.2-40.2c3.5-10.3 9-14.6 13.4-16.1c4.5-1.5 11.7-1.2 20.8 5.1s18.2 17.6 23.3 33.1s4.7 29.9 1.2 40.2zm-3.5 46.5c32.3-10.6 46.9-53.9 32.6-96.8c-13-38.8-45.2-64-75.2-60.5c10.2-18.6 23.3-29.8 31.8-34c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2C149.9 15.2 112 58.1 112 128h0c-.2 11.3 1.5 23.2 5.5 35.1c14.3 42.9 52.1 69.1 84.4 58.5zm-122.1 54c-.9 7.6-3.9 10.4-5.5 11.3c-1.6 .9-5.7 2.2-13-.9s-15.7-9.9-22-20.7s-8-21.4-7-29c.9-7.6 3.9-10.4 5.5-11.3c1.6-.9 5.7-2.2 13 .9s15.7 9.9 22 20.7s8 21.4 7 29zm10.4 39c24.5-14 29.1-51.7 10.2-84.1C85.9 205.6 61.7 191.1 40.2 192c10.4-28.1 28.3-44.4 39-49.7c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2C37.9 127.2 0 170.1 0 240H0c-.1 13.3 3.7 27.8 11.6 41.4c18.9 32.4 54 47.3 78.5 33.3zM256 288c25.7 0 108.2 25.4 156.8 156.3c2.1 5.7 3.2 12.2 3.2 19.4v4.4c0 6.6-5.3 11.9-11.9 11.9c-10.1 0-20.1-1.5-29.7-4.5l-80.2-25.1c-24.9-7.8-51.5-7.8-76.4 0l-80.2 25.1c-9.6 3-19.7 4.5-29.7 4.5c-6.6 0-11.9-5.3-11.9-11.9v-4.4c0-7.1 1.1-13.7 3.2-19.4C147.8 313.4 230.3 288 256 288zm0-32c-41.3 0-134.4 35.9-186.8 177.2c-3.6 9.7-5.2 20.1-5.2 30.5v4.4c0 24.2 19.7 43.9 43.9 43.9c13.3 0 26.6-2 39.3-6l80.2-25.1c18.6-5.8 38.6-5.8 57.3 0L364.8 506c12.7 4 26 6 39.3 6c24.2 0 43.9-19.7 43.9-43.9v-4.4c0-10.4-1.6-20.7-5.2-30.5C390.4 291.9 297.3 256 256 256zm183.3-9.3c6.3-10.8 14.7-17.6 22-20.7s11.4-1.8 13-.9c1.6 .9 4.6 3.7 5.5 11.3c.9 7.7-.8 18.2-7 29s-14.7 17.6-22 20.7s-11.4 1.8-13 .9c-1.6-.9-4.6-3.7-5.5-11.3c-.9-7.7 .8-18.2 7-29zm-27.7-16.1c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3c7.9-13.6 11.7-28.1 11.6-41.4h0c0-69.9-37.9-112.8-64.8-126.3c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5c10.7 5.3 28.6 21.6 39 49.7c-21.5-1-45.7 13.6-60.2 38.5z"]
};
var faKiwiFruit = {
  prefix: 'fal',
  iconName: 'kiwi-fruit',
  icon: [448, 512, [], "e30c", "M416 176c0-25.2-15.9-52.4-50.9-74.9C330.4 78.8 280.6 64 224 64s-106.4 14.8-141.1 37.1C47.9 123.6 32 150.8 32 176s15.9 52.4 50.9 74.9C117.6 273.2 167.4 288 224 288s106.4-14.8 141.1-37.1c35-22.5 50.9-49.7 50.9-74.9zm32 0v80c0 123.7-100.3 224-224 224S0 379.7 0 256V176C0 96.5 100.3 32 224 32s224 64.5 224 144zm-32 74.2C376.8 292 305.5 320 224 320s-152.8-28-192-69.8V256c0 106 86 192 192 192s192-86 192-192v-5.8zM280 176c0 13.3-25.1 24-56 24s-56-10.7-56-24s25.1-24 56-24s56 10.7 56 24zM240 88v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V88c0-8.8 7.2-16 16-16s16 7.2 16 16zm-84.7 12.7l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm160 0c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0zM96 160h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16s7.2-16 16-16zM171.3 235.3l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm128-22.6l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM240 240v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTrafficLightSlow = {
  prefix: 'fal',
  iconName: 'traffic-light-slow',
  icon: [320, 512, [], "f639", "M64 32C46.3 32 32 46.3 32 64V352c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm0-136a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z"]
};
var faRectangleCode = {
  prefix: 'fal',
  iconName: 'rectangle-code',
  icon: [512, 512, [], "e322", "M448 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM293.4 172c-6.6 5.9-7.2 16-1.3 22.6L346.6 256 292 317.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3l64-72c5.4-6.1 5.4-15.2 0-21.3l-64-72c-5.9-6.6-16-7.2-22.6-1.3zM220 194.6c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3l-64 72c-5.4 6.1-5.4 15.2 0 21.3l64 72c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L165.4 256 220 194.6z"]
};
var faHeadSideVirus = {
  prefix: 'fal',
  iconName: 'head-side-virus',
  icon: [512, 512, [], "e064", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm293.8 63.2C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM307.5 208c-17 14.5-26.3 36.8-24.5 59.1c-22.3-1.8-44.6 7.4-59.1 24.5c-14.5-17-36.8-26.3-59.1-24.5c1.8-22.3-7.4-44.6-24.5-59.1c17-14.5 26.3-36.8 24.5-59.1c22.3 1.8 44.6-7.4 59.1-24.5c6.6 7.8 14.8 13.9 24 18.1c10.9 5 23 7.3 35.1 6.3c-1.8 22.3 7.4 44.6 24.5 59.1zM208 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64 24a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faKeyboardBrightness = {
  prefix: 'fal',
  iconName: 'keyboard-brightness',
  icon: [640, 512, [], "e1c0", "M115.3 172.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l88 88c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-88-88zM304 224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16V224zm132.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l88-88c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-88 88zM0 400c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm208-16c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm320 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H528z"]
};
var faBooksMedical = {
  prefix: 'fal',
  iconName: 'books-medical',
  icon: [576, 512, [], "f7e8", "M192 464c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V416h96v48zm-16 48c12.3 0 23.5-4.6 32-12.2c8.5 7.6 19.7 12.2 32 12.2h64c26.5 0 48-21.5 48-48V416 400 384 193.8l51.4 198.1 4 15.5 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-13.9-53.7-4-15.5-63.9-246-4-15.5-18-69.2C464 9.9 438.6-5.2 413.9 1.6L354.3 18.1c-3.5 1-6.8 2.3-9.9 4C335.9 8.8 321 0 304 0H240c-12.3 0-23.5 4.6-32 12.2C199.5 4.6 188.3 0 176 0H112C85.5 0 64 21.5 64 48V96v16 16H96h80 16v48h32V128h96V384H224V336H192v48H176 96 64v16 16 48c0 26.5 21.5 48 48 48h64zM352 64.8V63.5c.3-7.2 5.1-13 10.8-14.6l59.6-16.5c6.6-1.8 14.8 2 17.2 11l14.1 54.2-87.3 24.2L352.6 68.6c-.3-1.3-.5-2.6-.6-3.8zm-32-.6v0V96H224V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V64.2zM240 480c-8.8 0-16-7.2-16-16V416h96v48c0 8.8-7.2 16-16 16H240zM192 48V96H96V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16zm269.7 80.7l59.8 230.5-87.3 24.2L374.4 152.8l87.3-24.2zm67.9 261.5l13.8 53.2c2.4 9.4-3.2 17.7-10.3 19.6l-59.6 16.5c-6.6 1.8-14.8-2-17.2-11l-14.1-54.2 87.3-24.2zM80 160c-17.7 0-32 14.3-32 32v16H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H48v16c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V304h16c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H144V192c0-17.7-14.3-32-32-32H80zm0 32h32v32c0 8.8 7.2 16 16 16h32v32H128c-8.8 0-16 7.2-16 16v32H80V288c0-8.8-7.2-16-16-16H32V240H64c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V192z"]
};
var faLightbulbSlash = {
  prefix: 'fal',
  iconName: 'lightbulb-slash',
  icon: [640, 512, [], "f673", "M438.3 258.1c-3.3 4.7-6.9 9.7-10.7 15l25.2 19.9c4-5.5 8-11 11.8-16.6c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C260.6 0 208 29.4 176.2 74.5l25.2 19.9C227.3 56.7 270.8 32 320 32c79.5 0 144 64.5 144 144c0 30.6-9.5 58.8-25.7 82.1zM226.5 114.3l25.2 19.9C265.8 111.3 291.1 96 320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-39 0-73.4 20-93.5 50.3zm-25.4 143l-52.6-41.6c5.1 22.1 14.3 42.5 26.9 60.5c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19l-.5-.7zM274.7 448h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM240 432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H250.7c-5.9 0-10.7 4.8-10.7 10.7V432zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faHouseBlank = {
  prefix: 'fal',
  iconName: 'house-blank',
  icon: [576, 512, ["home-blank"], "e487", "M277.4 4c6-5.3 15.1-5.3 21.2 0l272 240c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM96 206.7V432c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7z"]
};
var faHomeBlank = faHouseBlank;
var faSquare5 = {
  prefix: 'fal',
  iconName: 'square-5',
  icon: [448, 512, [], "e25a", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm176 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H188.5L172 225.9l80.4 8.1c38.4 3.9 67.6 36.2 67.6 74.8c0 41.5-33.7 75.2-75.2 75.2h-44c-27.4 0-53-13.7-68.3-36.4l-1.8-2.7c-4.9-7.3-3-17.3 4.4-22.2s17.3-3 22.2 4.4l1.8 2.7c9.3 13.9 25 22.3 41.8 22.3h44c23.8 0 43.2-19.3 43.2-43.2c0-22.2-16.8-40.7-38.8-42.9l-98.8-10c-4.6-.5-8.8-2.9-11.5-6.7s-3.6-8.6-2.4-13.1l24-96c1.8-7.1 8.2-12.1 15.5-12.1z"]
};
var faSquareHeart = {
  prefix: 'fal',
  iconName: 'square-heart',
  icon: [448, 512, [128159, "heart-square"], "f4c8", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm99.9 68.9c27.8-28.2 71.9-29.7 101.5-4.6c5.8 4.9 11 10.4 16.3 15.9c2.1 2.2 4.2 4.5 6.4 6.6c2.1-2.2 4.3-4.4 6.4-6.6c5.2-5.5 10.5-11 16.3-15.9c29.6-25.1 73.7-23.6 101.5 4.6c29.4 29.8 29.4 78.2 0 108L246.5 376.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 272.9c-29.4-29.8-29.4-78.2 0-108zm83.6 22.5c-16.8-17.1-44-17.1-60.8 0c-17.1 17.4-17.1 45.7 0 63.1L224 353.3 325.3 250.4c17.1-17.4 17.1-45.7 0-63.1c-16.8-17.1-44-17.1-60.8 0l-29.1 29.6c-6.3 6.4-16.5 6.4-22.8 0l-29.1-29.6z"]
};
var faHeartSquare = faSquareHeart;
var faPuzzle = {
  prefix: 'fal',
  iconName: 'puzzle',
  icon: [512, 512, [], "e443", "M320 0c-17.7 0-32 14.3-32 32V56c0 17.7 14.3 32 32 32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-17.7 0-32 14.3-32 32v24c0 17.7 14.3 32 32 32h32c0 26.5 21.5 48 48 48s48-21.5 48-48h32c17.7 0 32-14.3 32-32V64c0-35.3-28.7-64-64-64H320zm0 32H448c17.7 0 32 14.3 32 32V176H432c-8.8 0-16 7.2-16 16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8-7.2-16-16-16H320V152h16c26.5 0 48-21.5 48-48s-21.5-48-48-48H320V32zM64 64C28.7 64 0 92.7 0 128V288 448c0 35.3 28.7 64 64 64H224 384c35.3 0 64-28.7 64-64V304c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-17.7-14.3-32-32-32H240V96c0-17.7-14.3-32-32-32H64zM208 96V272H176V256c0-26.5-21.5-48-48-48s-48 21.5-48 48v16H32V128c0-17.7 14.3-32 32-32H208zM80 304c17.7 0 32-14.3 32-32V256c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 17.7 14.3 32 32 32h32v32H192c-26.5 0-48 21.5-48 48s21.5 48 48 48h16v48H64c-17.7 0-32-14.3-32-32V304H80zM240 432c0-17.7-14.3-32-32-32H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c17.7 0 32-14.3 32-32V304h32v16c0 26.5 21.5 48 48 48s48-21.5 48-48V304h48V448c0 17.7-14.3 32-32 32H240V432z"]
};
var faUserGear = {
  prefix: 'fal',
  iconName: 'user-gear',
  icon: [640, 512, ["user-cog"], "f4fe", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480H351c15.6 13.1 36.9 13.7 53 4.8v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-1.6 13.7 3.2 26.6 11.6 36.1c-14.5-4.8-30-7.4-46.2-7.4H178.3c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM373.5 394.1l17.2 30.5c15.9-6.3 33-3.7 46 3.7c12.6 7.2 23.6 20.1 26.6 36.7H497c3-16.6 13.9-29.5 26.5-36.7c12.9-7.4 30-9.9 45.9-3.6l17.2-30.5c-12.8-11.4-18.5-27.7-18.5-42.4s5.7-31 18.5-42.4l-17.2-30.5c-15.9 6.3-32.9 3.7-45.9-3.6C510.8 268 499.9 255 497 238.4H463.3c-3.1 16.6-14 29.5-26.6 36.7c-13 7.4-30 9.9-46 3.7l-17.2 30.5C386.3 320.7 392 337 392 351.7s-5.7 31-18.5 42.4zm26.1 61.7l-1.6 1c-10.7 6.3-24.4 2.6-30.5-8.2L341 401.7c-5.7-10.2-2.3-23.1 7.8-29c7.3-4.3 11.2-12.5 11.2-21s-3.9-16.7-11.2-21c-10-5.9-13.5-18.8-7.8-29l26.4-46.9c6.1-10.8 19.9-14.5 30.5-8.2l1.6 1c6.5 3.9 14.6 3.4 21.2-.3c6.6-3.8 11.3-10.6 11.3-18.2v-1.4c0-11.7 9.5-21.3 21.3-21.3h53.4c11.8 0 21.4 9.6 21.4 21.4v1.6c0 7.5 4.6 14.2 11.1 18c6.5 3.7 14.5 4.2 21 .3l1.8-1c10.7-6.3 24.4-2.6 30.5 8.2L619 301.7c5.7 10.2 2.3 23-7.8 29c-7.3 4.3-11.2 12.6-11.2 21s3.9 16.7 11.2 21c10 5.9 13.5 18.8 7.8 29l-26.4 46.9c-6.1 10.8-19.9 14.5-30.5 8.2l-1.8-1c-6.5-3.8-14.5-3.4-21 .3c-6.5 3.7-11.1 10.4-11.1 18v1.6c0 11.8-9.6 21.4-21.4 21.4H453.4c-11.7 0-21.3-9.5-21.3-21.3v-1.4c0-7.6-4.6-14.4-11.3-18.2c-6.6-3.7-14.7-4.2-21.2-.3zm80.5-160.1a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faUserCog = faUserGear;
var faPipeCircleCheck = {
  prefix: 'fal',
  iconName: 'pipe-circle-check',
  icon: [640, 512, [], "e436", "M16 96c8.8 0 16 7.2 16 16v16H256 448V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32 48.7c-11 1-21.7 3-32 5.9V160H256 32V352H320.7c-.5 5.3-.7 10.6-.7 16s.2 10.7 .7 16H32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V368 144 112c0-8.8 7.2-16 16-16zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faArrowUp19 = {
  prefix: 'fal',
  iconName: 'arrow-up-1-9',
  icon: [576, 512, ["sort-numeric-up"], "f163", "M448 48c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192H384c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V48zM171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM428 392a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm-84-52c0 46.4 37.6 84 84 84c.4 0 .9 0 1.3 0l-25.4 29.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7l62.4-72.5C504.4 385.8 512 365.2 512 344h-.1c.1-1.3 .1-2.7 .1-4c0-46.4-37.6-84-84-84s-84 37.6-84 84z"]
};
var faSortNumericUp = faArrowUp19;
var faOctagonExclamation = {
  prefix: 'fal',
  iconName: 'octagon-exclamation',
  icon: [512, 512, [], "e204", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM256 128c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faDialLow = {
  prefix: 'fal',
  iconName: 'dial-low',
  icon: [576, 512, [], "e15d", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 360c-65.3 0-119.1-48.9-127-112H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H161c7.9-63.1 61.7-112 127-112c70.7 0 128 57.3 128 128s-57.3 128-128 128zM128 288a160 160 0 1 0 320 0 160 160 0 1 0 -320 0zm440 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDoorClosed = {
  prefix: 'fal',
  iconName: 'door-closed',
  icon: [576, 512, [128682], "f52a", "M416 32c17.7 0 32 14.3 32 32V480H128V64c0-17.7 14.3-32 32-32H416zm64 448V64c0-35.3-28.7-64-64-64H160C124.7 0 96 28.7 96 64V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H96h32H448h32 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H480zM408 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faLaptopMobile = {
  prefix: 'fal',
  iconName: 'laptop-mobile',
  icon: [640, 512, ["phone-laptop"], "f87a", "M128 32H448c17.7 0 32 14.3 32 32V96h32V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H352V352H76.8c-20.3 0-37.4-13.5-42.9-32H64 96 352V288H96V64c0-17.7 14.3-32 32-32zM416 176c0-8.8 7.2-16 16-16H592c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V176zm-32 0V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48z"]
};
var faPhoneLaptop = faLaptopMobile;
var faConveyorBeltBoxes = {
  prefix: 'fal',
  iconName: 'conveyor-belt-boxes',
  icon: [640, 512, ["conveyor-belt-alt"], "f46f", "M304 32c8.8 0 16 7.2 16 16V240c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H304zM112 0C85.5 0 64 21.5 64 48V240c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H112zM528 96c8.8 0 16 7.2 16 16V240c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h96zM432 64c-26.5 0-48 21.5-48 48V240c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H432zM608 416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64H544c35.3 0 64 28.7 64 64zM96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm56 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faConveyorBeltAlt = faConveyorBeltBoxes;
var faShieldVirus = {
  prefix: 'fal',
  iconName: 'shield-virus',
  icon: [512, 512, [], "e06c", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zm76.8 311.4C334.5 295.9 351 256 384 256c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C311.9 161.5 272 145 272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C177.5 184.1 161 224 128 224c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C200.1 318.5 240 335 240 368c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM339.5 240c-17 14.5-26.3 36.8-24.5 59.1c-22.3-1.8-44.6 7.4-59.1 24.5c-14.5-17-36.8-26.3-59.1-24.5c1.8-22.3-7.4-44.6-24.5-59.1c17-14.5 26.3-36.8 24.5-59.1c22.3 1.8 44.6-7.4 59.1-24.5c6.6 7.8 14.8 13.9 24 18.1c10.9 5 23 7.3 35.1 6.3c-1.8 22.3 7.4 44.6 24.5 59.1zM240 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm48 24a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faStarfighterTwinIonEngineAdvanced = {
  prefix: 'fal',
  iconName: 'starfighter-twin-ion-engine-advanced',
  icon: [640, 512, ["starfighter-alt-advanced"], "e28e", "M132.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L36.7 145.9c-3 3-4.7 7.1-4.7 11.3v40.4l148.6-20.3C208.1 128.8 260.2 96 320 96s111.9 32.8 139.4 81.4L608 197.7V157.3c0-4.2-1.7-8.3-4.7-11.3L484.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L625.9 123.3c9 9 14.1 21.2 14.1 33.9V202v14 80 14 44.8c0 12.7-5.1 24.9-14.1 33.9L507.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L603.3 366.1c3-3 4.7-7.1 4.7-11.3V314.3L459.4 334.6C431.9 383.2 379.8 416 320 416s-111.9-32.8-139.4-81.4L32 314.3v40.4c0 4.2 1.7 8.3 4.7 11.3L155.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L14.1 388.7c-9-9-14.1-21.2-14.1-33.9V310 296 216 202 157.3c0-12.7 5.1-24.9 14.1-33.9L132.7 4.7zm341.1 207c4.1 14.1 6.2 29 6.2 44.3s-2.2 30.3-6.2 44.3L608 282V230L473.8 211.7zM32 282l134.2 18.3c-4.1-14.1-6.2-29-6.2-44.3s2.2-30.3 6.2-44.3L32 230V282zM320 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-16-66c-5.9-1.5-11.4-3.8-16.5-6.8l-24.1 24.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.1-24.1c-3-5.1-5.3-10.6-6.8-16.5H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h34c1.5-5.9 3.8-11.4 6.8-16.5l-24.1-24.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l24.1 24.1c5.1-3 10.6-5.3 16.5-6.8V160c0-8.8 7.2-16 16-16s16 7.2 16 16v34c5.9 1.5 11.4 3.8 16.5 6.8l24.1-24.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24.1 24.1c3 5.1 5.3 10.6 6.8 16.5h34c8.8 0 16 7.2 16 16s-7.2 16-16 16H382c-1.5 5.9-3.8 11.4-6.8 16.5l24.1 24.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-24.1-24.1c-5.1 3-10.6 5.3-16.5 6.8v34c0 8.8-7.2 16-16 16s-16-7.2-16-16V318zm16-30a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
var faDiceSix = {
  prefix: 'fal',
  iconName: 'dice-six',
  icon: [448, 512, [9861], "f526", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM296 160a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faStarfighterTwinIonEngine = {
  prefix: 'fal',
  iconName: 'starfighter-twin-ion-engine',
  icon: [576, 512, ["starfighter-alt"], "e038", "M16 32c8.8 0 16 7.2 16 16V197.1l116.4-19.4C175.8 128.9 228.1 96 288 96s112.2 32.9 139.6 81.7L544 197.1V48c0-8.8 7.2-16 16-16s16 7.2 16 16V202.4 216v80 13.6V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V314.9L427.6 334.3C400.2 383.1 347.9 416 288 416s-112.2-32.9-139.6-81.7L32 314.9V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V309.6 296 216 202.4 48c0-8.8 7.2-16 16-16zM448 256c0 15.1-2.1 29.6-6 43.4l102-17V229.6l-102-17c3.9 13.8 6 28.4 6 43.4zM32 282.4l102 17c-3.9-13.8-6-28.4-6-43.4s2.1-29.6 6-43.4l-102 17v52.9zM416 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM226 272H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h34c1.5-5.9 3.8-11.4 6.8-16.5l-24.1-24.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l24.1 24.1c5.1-3 10.6-5.3 16.5-6.8V160c0-8.8 7.2-16 16-16s16 7.2 16 16v34c5.9 1.5 11.4 3.8 16.5 6.8l24.1-24.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24.1 24.1c3 5.1 5.3 10.6 6.8 16.5h34c8.8 0 16 7.2 16 16s-7.2 16-16 16H350c-1.5 5.9-3.8 11.4-6.8 16.5l24.1 24.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-24.1-24.1c-5.1 3-10.6 5.3-16.5 6.8v34c0 8.8-7.2 16-16 16s-16-7.2-16-16V318c-5.9-1.5-11.4-3.8-16.5-6.8l-24.1 24.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.1-24.1c-3-5.1-5.3-10.6-6.8-16.5zm62 16a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faStarfighterAlt = faStarfighterTwinIonEngine;
var faRocketLaunch = {
  prefix: 'fal',
  iconName: 'rocket-launch',
  icon: [512, 512, [128640], "e027", "M219.3 292.7c-10-10-21.4-18.1-33.8-24.1C215.6 146.3 269 86.7 321.1 58.1c53.5-29.4 111.4-29.4 154.6-21.8c7.6 43.2 7.7 101.1-21.8 154.6C425.3 243 365.7 296.4 243.4 326.5c-6-12.4-14.1-23.9-24.1-33.8zM256 381.3c0-8.2-.8-16.3-2.4-24.3c37.8-9.5 70.4-21.3 98.4-34.7v80.1c0 12.1-6.8 23.2-17.7 28.6L256 470.1l0-88.9zm128 21.1l0-97.4C515.7 225.1 520.5 102.5 506.7 28.1c-2.2-11.6-11.2-20.7-22.8-22.8C409.5-8.5 286.9-3.7 207 128l-97.4 0c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H130.7c24.7 0 48.5 9.8 65.9 27.3s27.3 41.2 27.3 65.9V496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2zm-229-144c-7.9-1.6-16.1-2.4-24.3-2.4H41.9L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7h80.1c-13.5 28-25.2 60.5-34.7 98.4zm-11.2 189c-11 11-29.4 19.4-52.6 24.9c-20.6 4.9-42.1 6.8-59 7.4c.6-17 2.5-38.4 7.4-59c5.5-23.2 13.9-41.6 24.9-52.6c21.9-21.9 57.4-21.9 79.3 0s21.9 57.4 0 79.3zM166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C7.7 379.7 1 446 .1 483.7c-.4 16 12.2 28.6 28.2 28.2C66 511 132.3 504.3 166.5 470zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"]
};
var faMosquitoNet = {
  prefix: 'fal',
  iconName: 'mosquito-net',
  icon: [640, 512, [], "e52c", "M161.7 440.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c1.1-2.2 1.7-4.7 1.7-7.2l0-41.4 20-20v38c0 24.3 19.7 44 44 44s44-19.7 44-44v-38l30.9 30.9c3-3.7 6.6-6.9 10.6-9.5c-12.9-8.6-21.5-23.3-21.5-40c0-2.1 .1-4.2 .4-6.2L332 277.4V252.7l28.2 24.5c6.1-9.1 15.2-15.9 25.9-19.2l.2-.6-51.8-45.1 86.3 12.9c3.6-.9 7.3-1.3 11.2-1.3c8.9 0 17.2 2.4 24.3 6.6l25.8 3.8c8.2-6.5 18.6-10.5 29.9-10.5c16.7 0 31.4 8.5 40 21.5c2.1-3.1 4.5-6 7.3-8.6c-12.9-16.9-32.2-28.6-54.7-31.4L344.7 181.6l49.6-41.3c5.1-4.2 7-11.1 4.9-17.4L385.3 81.2l29-58.1c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-32 64c-1.9 3.8-2.2 8.2-.9 12.2l12.5 37.6L332 150.5V137.9c0-21.5-15.4-39.4-35.8-43.2v-31c0-4.5-3.7-8.2-8.2-8.2s-8.2 3.7-8.2 8.2v31c-20.4 3.8-35.8 21.7-35.8 43.2v12.6l-33.4-27.8 12.5-37.6c1.3-4 1-8.4-.9-12.2l-32-64c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l29 58.1-13.9 41.7c-2.1 6.2-.1 13.1 4.9 17.4l49.6 41.3L71.4 205.5C30.6 210.6 0 245.2 0 286.3c0 72.6 87.8 109 139.2 57.6L244 252.7v24.7l-47.3 47.3c-3 3-4.7 7.1-4.7 11.3l0 44.2-30.3 60.6zm-43.5-121c-.6 .5-1.1 1-1.6 1.5c-31.2 31.2-84.6 9.1-84.6-35c0-25 18.6-46 43.4-49.1l.8-.1 165.4-24.7L118.2 319.8zM528 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H448V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v48H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v48H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V480h48v16c0 8.8 7.2 16 16 16s16-7.2 16-16V480h48v16c0 8.8 7.2 16 16 16s16-7.2 16-16V480h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V400h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V320h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H528V272zm0 48h48v48H528V320zm0 80h48v48H528V400zm-80-32V320h48v48H448zm0 80V400h48v48H448zM272 360.6l0-222.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 222.7c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faVentDamper = {
  prefix: 'fal',
  iconName: 'vent-damper',
  icon: [640, 512, [], "e465", "M512 96H128c-17.7 0-32 14.3-32 32v16V368v16c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V368 144 128c0-17.7-14.3-32-32-32zM48 128l16 0c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64h16c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H576c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48zM592 352c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H576V352h16zM48 352H64V160H48c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16zM176 160H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 80H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 80H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBridgeWater = {
  prefix: 'fal',
  iconName: 'bridge-water',
  icon: [576, 512, [], "e4ce", "M544 96H32l0 80.1c53.3 1.9 96 45.7 96 99.5V361c-9.9-5.7-21-8.6-32-8.6V275.6C96 238.2 65.8 208 28.4 208C12.7 208 0 195.3 0 179.6V96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v83.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6v76.9c-11 0-22.1 2.8-32 8.6V275.6c0-53.8 42.7-97.6 96-99.5V96zM192 384.5h0V272c0-53 43-96 96-96s96 43 96 96V384.5c-10.4 0-21.3-2.2-32-6.1V272c0-35.3-28.7-64-64-64s-64 28.7-64 64V378.4c-10.3 3.8-21.1 6.1-32 6.1zm0 63.5c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z"]
};
var faBanBug = {
  prefix: 'fal',
  iconName: 'ban-bug',
  icon: [512, 512, ["debug"], "f7f9", "M256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7l316 316C363.4 459.4 312.1 480 256 480zm79.5-167.1c.3-2.9 .5-5.9 .5-8.9v-5.9l46 5.8c8.8 1.1 16.8-5.1 17.9-13.9s-5.1-16.8-13.9-17.9l-50-6.2V244.5l51.9-13c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-44.1 11V208c0-7.4-1-14.7-2.9-21.5l43.8-29.2c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4l-40.8 27.2C303.7 139.7 281.2 128 256 128c-28.6 0-53.7 15-67.8 37.6L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l-89.8-89.8zM304 281.4l-92.2-92.2C219.1 172 236.2 160 256 160c26.5 0 48 21.5 48 48v23.7 .5V280v.1 1.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 265.9l-50 6.2c-8.8 1.1-15 9.1-13.9 17.9s9.1 15 17.9 13.9l46-5.8V304c0 7.4 1 14.7 2.9 21.5l-43.8 29.2c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l40.8-27.2C208.3 372.3 230.8 384 256 384c17 0 32.8-5.3 45.8-14.4l-23.2-23.2c-6.7 3.6-14.4 5.6-22.5 5.6c-26.5 0-48-21.5-48-48V280.3c0-.2 0-.4 0-.7v-3.8l-32-32v22z"]
};
var faDebug = faBanBug;
var faPersonBooth = {
  prefix: 'fal',
  iconName: 'person-booth',
  icon: [576, 512, [], "f756", "M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM32 223.4c0 .2 0 .4 0 .6l0 55.7c.2 5.1 2.7 9.7 6.9 12.6L80 320.6V180.2c-6.2-2.7-13-4.2-20-4.2c-15.5 0-28 12.5-28 28v19.4zm0 103L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 280.2c0-.3 0-.7 0-1V204c0-33.1 26.9-60 60-60c27.9 0 53.9 14.2 69 37.6L176.7 256H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H176.7c-10.9 0-21-5.5-26.9-14.7L112 214.5V342.6L146.1 366c8.7 6 13.9 15.8 13.9 26.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V392.4l-96-66zM256 32c-8.8 0-16 7.2-16 16V224H208V48c0-26.5 21.5-48 48-48h24H528c26.5 0 48 21.5 48 48V384 496c0 8.8-7.2 16-16 16s-16-7.2-16-16V439.4c-9.4 5.4-20.3 8.6-32 8.6c-15.1 0-29.1-5.3-40-14c-10.9 8.8-24.9 14-40 14s-29.1-5.3-40-14c-10.9 8.8-24.9 14-40 14c-35.3 0-64-28.7-64-64v-2.9c0-10.8 2.2-21.6 6.5-31.5L335 255 268.1 32H256zm45.5 0l65.8 219.4c1.1 3.6 .9 7.5-.6 10.9l-42.8 99.9c-2.6 6-3.9 12.4-3.9 18.9V384c0 17.7 14.3 32 32 32c11.1 0 20.9-5.7 26.7-14.3c3-4.5 8-7.1 13.3-7.1s10.4 2.7 13.3 7.1c5.8 8.7 15.6 14.3 26.7 14.3s20.9-5.7 26.7-14.3c3-4.5 8-7.1 13.3-7.1s10.4 2.7 13.3 7.1c5.8 8.7 15.6 14.3 26.7 14.3c17.7 0 32-14.3 32-32V48c0-8.8-7.2-16-16-16H301.5zM240 320V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V320h32z"]
};
var faTextWidth = {
  prefix: 'fal',
  iconName: 'text-width',
  icon: [448, 512, [], "f035", "M32 32C14.3 32 0 46.3 0 64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64H208l0 192H160c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H240l0-192H416v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7-14.3-32-32-32H32zM4.7 372.7c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 400H393.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 368H54.6l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80z"]
};
var faGarageCar = {
  prefix: 'fal',
  iconName: 'garage-car',
  icon: [640, 512, [], "e00a", "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H128V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224zm156.9 75.1L238.4 344H401.6l-14.6-44.9c-2.1-6.6-8.3-11.1-15.2-11.1H268.2c-6.9 0-13.1 4.5-15.2 11.1zm164.6-9.9l20.6 63.6c15.6 9.9 25.9 27.4 25.9 47.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H208v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-19.8 10.3-37.3 25.9-47.2l20.6-63.6c6.4-19.8 24.9-33.2 45.7-33.2H371.8c20.8 0 39.2 13.4 45.7 33.2zM208 448H432V400c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24v48zm24-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm160-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faSquareKanban = {
  prefix: 'fal',
  iconName: 'square-kanban',
  icon: [448, 512, [], "e488", "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zM128 288c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16zm176 48c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V336zm-80-80c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16z"]
};
var faHatWizard = {
  prefix: 'fal',
  iconName: 'hat-wizard',
  icon: [512, 512, [], "f6e8", "M408.6 368L348.2 227c-9.3-21.6-10.3-45.9-2.8-68.2l37.3-112L246.5 124.6c-29.6 16.9-53 42.8-66.8 73.9L104.4 368h-35l81.1-182.5c16.6-37.4 44.7-68.4 80.2-88.7l165-94.3C398.5 .9 401.7 0 405 0c10.5 0 19 8.5 19 19v1.7c0 2.2-.4 4.4-1.1 6.5L375.7 168.9c-5 14.9-4.3 31 1.9 45.4L443.4 368H408.6zM480 456c0-13.3-10.7-24-24-24H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24zM56 400H456c30.9 0 56 25.1 56 56s-25.1 56-56 56H56c-30.9 0-56-25.1-56-56s25.1-56 56-56zM288 176v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H288v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zM240 304v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H240 208 176c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPenFancy = {
  prefix: 'fal',
  iconName: 'pen-fancy',
  icon: [512, 512, [128395, 10002], "f5ac", "M392.1 48.7C401.7 38.1 415.3 32 429.6 32C457.4 32 480 54.6 480 82.4c0 14.3-6.1 27.9-16.7 37.5L256.6 306 206 255.4 392.1 48.7zM429.6 0c-23.4 0-45.6 9.9-61.3 27.3L175.1 242 98.9 265.4c-19.8 6.1-35.4 21.3-41.9 40.9L2.9 468.6c-8.3 25 15.5 48.8 40.5 40.5L205.6 455c19.6-6.5 34.9-22.1 40.9-41.9L270 336.9 484.7 143.7c17.4-15.6 27.3-37.9 27.3-61.3C512 36.9 475.1 0 429.6 0zM237.9 332.5L216 403.7c-3 9.9-10.7 17.7-20.5 20.9L67.2 467.4 134.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3L44.6 444.8 87.4 316.5c3.3-9.8 11.1-17.4 20.9-20.5l71.2-21.9 58.4 58.4z"]
};
var faCoffeePot = {
  prefix: 'fal',
  iconName: 'coffee-pot',
  icon: [512, 512, [], "e002", "M80 64c-26.5 0-48 21.5-48 48v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V112C0 67.8 35.8 32 80 32h42.4H128 453.6C468.2 32 480 43.8 480 58.4c0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9v8c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344v-8c0-65.4 32.7-123.2 82.7-157.9L98.3 69.1c-.7-1.6-1.3-3.4-1.7-5.1H80zm365 0H131l49.8 112H395.2L445 64zM416 208H160l0 0c-26.4 19.9-46.5 47.7-56.7 80H472.7c-10.1-32.3-30.2-60.1-56.7-80l0 0zm63.2 112H96.8c-.5 5.3-.8 10.6-.8 16v8c0 42.6 27.2 78.8 46.8 98.8c2.7 2.8 7.7 5.2 15.2 5.2H418c7.5 0 12.5-2.4 15.2-5.2c19.6-20 46.8-56.2 46.8-98.8v-8c0-5.4-.3-10.7-.8-16z"]
};
var faMouseField = {
  prefix: 'fal',
  iconName: 'mouse-field',
  icon: [512, 512, [], "e5a8", "M379.4 36.6c6.2-3 13.2-4.6 20.6-4.6c26.5 0 48 21.5 48 48c0 9.6-2.8 18.6-7.7 26.1c-12.5-5.5-26-8.9-40.3-9.8V96c0-22.4-7.7-43-20.6-59.4zm88.2 86.2C475.4 110.4 480 95.7 480 80c0-44.2-35.8-80-80-80c-16.9 0-32.7 5.3-45.6 14.3C339.7 5.2 322.5 0 304 0c-53.1 0-96 43.4-96 96.3c0 25.7 10.2 49.8 27.5 67.5C155.8 180.6 96 251.3 96 336c0 18 6 34.6 16 48H64c-35.3 0-64 28.7-64 64s28.7 64 64 64H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H176 344h12.1c24.2 0 43.9-19.7 43.9-43.9c0-18.9-12.1-35.7-30-41.6l-12.8-4.3L378.8 272H464c26.5 0 48-21.5 48-48v-8c0-37.6-17.3-71.2-44.4-93.2zM176 384c-26.5 0-48-21.5-48-48c0-79.5 64.5-144 144-144h16c7.7 0 14.4-5.5 15.7-13.1s-2.9-15.1-10.1-17.8l-12.1-4.5c-24.9-9.3-41.5-33.4-41.5-60.2C240 60.9 268.7 32 304 32c35.3 0 64 28.7 64 64v16c0 8.8 7.2 16 16 16h8c48.6 0 88 39.4 88 88v8c0 8.8-7.2 16-16 16H368c-6.5 0-12.4 4-14.9 10.1l-26.4 66-33.7-11.2c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l76.9 25.6c4.9 1.6 8.1 6.2 8.1 11.3c0 6.6-5.3 11.9-11.9 11.9H344 176zM336 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V96H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16V80zm96 108a20 20 0 1 0 -40 0 20 20 0 1 0 40 0z"]
};
var faPersonDigging = {
  prefix: 'fal',
  iconName: 'person-digging',
  icon: [576, 512, ["digging"], "f85e", "M256 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32A64 64 0 1 1 192 64a64 64 0 1 1 128 0zM440.1 322.2L373.9 439.8c-2.8 5-8.2 8.2-13.9 8.2H313.9l-16 32H533.4L440.1 322.2zm-26.1-18.9c5.3-9.4 15.2-15.2 26-15.2c10.6 0 20.3 5.6 25.7 14.7L564 468.9c2.6 4.4 4 9.4 4 14.5c0 15.8-12.8 28.6-28.6 28.6H292.9c-16 0-28.9-13-28.9-28.9c0-4.5 1-8.9 3.1-12.9l18.2-36.4c5.4-10.8 16.5-17.7 28.6-17.7h36.8l13.8-24.5L24.3 206c-7.8-4.2-10.6-14-6.4-21.7s14-10.6 21.7-6.4l33.6 18.3 13.1-24c14.9-27.4 44.4-43.6 75.6-41.5l13.9 .9c45.9 3.1 85.3 33.9 99.3 77.8l36.2 113.7-3.4 1.1 72.3 39.4 34-60.4zm-142.3 1.3l-27.2-85.4c-10-31.3-38.1-53.4-70.9-55.6l-13.9-.9c-18.7-1.2-36.4 8.5-45.3 24.9l-13.1 24 170.4 92.9zM57.6 289.3c4.6-2 9.8-1.7 14.1 .7l127.5 70.9c15.2 8.5 24.7 24.5 24.7 42V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V402.8c0-5.8-3.2-11.2-8.2-14L74.5 328.1 31.5 499.9c-2.1 8.6-10.8 13.8-19.4 11.6S-1.7 500.7 .5 492.1l48-192c1.2-4.8 4.6-8.8 9.2-10.8z"]
};
var faDigging = faPersonDigging;
var faShowerDown = {
  prefix: 'fal',
  iconName: 'shower-down',
  icon: [384, 512, ["shower-alt"], "e24d", "M192 0c8.8 0 16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H336 48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32C32 109 95.1 40.8 176 32.8V16c0-8.8 7.2-16 16-16zm0 64C121.3 64 64 121.3 64 192H320c0-70.7-57.3-128-128-128zm50.7 388.9c-1.8 2.8-2.7 6.1-2.7 9.4V464c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L256 431.6l-13.3 21.3zm-27.1-17l28.2-45.1c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4V464c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4zM320 303.6l-13.3 21.3c-1.8 2.8-2.7 6.1-2.7 9.4V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L320 303.6zm-12.2-40.8c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4V336c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4l28.2-45.1zM114.7 452.9c-1.8 2.8-2.7 6.1-2.7 9.4V464c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L128 431.6l-13.3 21.3zm-27.1-17l28.2-45.1c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4V464c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4zM192 303.6l-13.3 21.3c-1.8 2.8-2.7 6.1-2.7 9.4V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L192 303.6zm-12.2-40.8c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4V336c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4l28.2-45.1zM50.7 324.9c-1.8 2.8-2.7 6.1-2.7 9.4V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L64 303.6 50.7 324.9zm-27.1-17l28.2-45.1C54.4 258.6 59 256 64 256s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4V336c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4z"]
};
var faShowerAlt = faShowerDown;
var faBoxCircleCheck = {
  prefix: 'fal',
  iconName: 'box-circle-check',
  icon: [576, 512, [], "e0c4", "M240 64H342.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128H352h64 16 16v-2.4c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H296.2c-8.1-9.8-15.2-20.6-21-32H64c-17.7 0-32-14.3-32-32V192H208h32zm-32-32H42.1L76.3 83c5.1-11.6 16.6-19 29.2-19H208v96zm224 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faBrightness = {
  prefix: 'fal',
  iconName: 'brightness',
  icon: [512, 512, [], "e0c9", "M240 104c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v88zm16 88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 160c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16zM0 256c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm408-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h88c8.8 0 16-7.2 16-16s-7.2-16-16-16H408zM75 437c6.2 6.2 16.4 6.2 22.6 0l56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L75 414.4c-6.2 6.2-6.2 16.4 0 22.6zM352.2 137.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L437 97.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-62.2 62.2zM75 75c-6.2 6.2-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L97.6 75c-6.2-6.2-16.4-6.2-22.6 0zM374.8 352.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L414.4 437c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-62.2-62.2z"]
};
var faCarSideBolt = {
  prefix: 'fal',
  iconName: 'car-side-bolt',
  icon: [640, 512, [], "e344", "M126.8 94.2L87.6 192H160v32H64c-17.7 0-32 14.3-32 32V368H65.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H385.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H608V320c0-53-43-96-96-96H448V192h30.7l-88-110c-9.1-11.4-22.9-18-37.5-18H171.3c-19.6 0-37.3 11.9-44.6 30.2zM52.8 193L97.1 82.3C109.2 51.9 138.6 32 171.3 32H353.2c24.3 0 47.3 11 62.5 30L519.9 192.2C586.9 196.3 640 252 640 320v48c0 17.7-14.3 32-32 32H574.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H254.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H32c-17.7 0-32-14.3-32-32V256c0-31.5 22.8-57.7 52.8-63zM418 368c-1.3 5.1-2 10.5-2 16s.7 10.9 2 16c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48c1.3-5.1 2-10.5 2-16s-.7-10.9-2-16c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48zM96 384c0 5.5 .7 10.9 2 16c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48c1.3-5.1 2-10.5 2-16s-.7-10.9-2-16c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48c-1.3 5.1-2 10.5-2 16zM347.3 123.3L278.6 192H368c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 224H240c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faOrnament = {
  prefix: 'fal',
  iconName: 'ornament',
  icon: [384, 512, [], "f7b8", "M192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm45.3 32c1.8-5 2.7-10.4 2.7-16c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 5.6 1 11 2.7 16H128c-17.7 0-32 14.3-32 32v48 9.7C38.6 186.9 0 248.9 0 320C0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3V144 96c0-17.7-14.3-32-32-32H237.3zm24.6 112c23 11.2 43 27.7 58.2 48H64c15.2-20.3 35.2-36.8 58.2-48H128 256h5.8zM192 96h64v48H128V96h64zM32 320c0-22.8 4.8-44.4 13.3-64H338.7c8.6 19.6 13.3 41.2 13.3 64s-4.7 44.4-13.3 64H45.3C36.8 364.4 32 342.8 32 320zM192 480c-52.3 0-98.8-25.1-128-64H320c-29.2 38.9-75.7 64-128 64z"]
};
var faPhoneArrowDownLeft = {
  prefix: 'fal',
  iconName: 'phone-arrow-down-left',
  icon: [512, 512, ["phone-arrow-down", "phone-incoming"], "e223", "M507.3 27.3L342.6 192H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v89.4L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faPhoneArrowDown = faPhoneArrowDownLeft;
var faPhoneIncoming = faPhoneArrowDownLeft;
var faCloudWord = {
  prefix: 'fal',
  iconName: 'cloud-word',
  icon: [640, 512, [], "e138", "M429.7 135.7c10.3-4.9 21.9-7.7 34.3-7.7c44.2 0 80 35.8 80 80c0 7.7-1.1 15-3 22c-4.1 14.5 2.5 30 15.8 37.1C587.3 283.2 608 315.2 608 352c0 53-43 96-96 96H144C82.1 448 32 397.9 32 336c0-48.8 31.2-90.3 74.8-105.7c12.3-4.3 20.8-15.7 21.3-28.8C131.5 125 194.6 64 272 64c48.7 0 91.7 24.1 117.8 61.2c9 12.7 25.8 17.2 39.9 10.5zM416 106.8C384.1 61.5 331.5 32 272 32c-94.6 0-171.7 74.6-175.8 168.1C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-49.1-27.7-91.8-68.3-113.2c2.8-9.8 4.3-20.1 4.3-30.8c0-61.9-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8zM512 368c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16zM240 352H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zM128 304c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm272-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H400z"]
};
var faHandFingersCrossed = {
  prefix: 'fal',
  iconName: 'hand-fingers-crossed',
  icon: [384, 512, [], "e1a3", "M189.8 4.4c-28.5-12.1-61.3 1.3-73.4 29.8L112 44.6l-4.4-10.5C95.5 5.7 62.7-7.6 34.2 4.4S-7.6 49.3 4.4 77.8L51.2 188.4 28.4 242.2 15.6 272.6C5.8 285.8 0 302.2 0 320v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V312 248v-8c0-3.2-.9-6.1-2.5-8.6C374.4 208.6 353.2 192 328 192c-12.1 0-23.3 3.8-32.5 10.4C285.6 186.5 268 176 248 176c-30.9 0-56 25.1-56 56v1.7l-19.2-45.4L219.6 77.8c12.1-28.5-1.3-61.3-29.8-73.4zm-34.4 225l4.5 10.6H151l4.5-10.6zM68.6 147.3L33.9 65.4c-5.2-12.2 .5-26.3 12.8-31.5s26.3 .5 31.5 12.8L94.6 85.7 68.6 147.3zM80 240c-5.7 0-11.3 .6-16.6 1.7L145.9 46.6c5.2-12.2 19.2-17.9 31.5-12.8s17.9 19.2 12.8 31.5L116.2 240H80zm168-32c13.3 0 24 10.7 24 24v16 48c0 13.3-10.7 24-24 24s-24-10.7-24-24v0V232c0-13.3 10.7-24 24-24zm32.5 133.6C290.4 357.5 308 368 328 368c8.4 0 16.4-1.9 23.5-5.2C346.1 428.5 291 480 224 480H160C89.3 480 32 422.7 32 352V320c0-26.5 21.5-48 48-48h88c13.2 0 24 10.7 24 24v0c0 13.3-10.7 24-24 24H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c12.1 0 23.3-3.8 32.5-10.4zM352 312c0 13.3-10.7 24-24 24s-24-10.7-24-24V296 248c0-13.3 10.7-24 24-24s24 10.7 24 24v64z"]
};
var faTrash = {
  prefix: 'fal',
  iconName: 'trash',
  icon: [448, 512, [], "f1f8", "M177.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L299.1 64H148.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0H177.7C161.2 0 145.8 8.5 137 22.6L111.1 64H64.1 32 16C7.2 64 0 71.2 0 80s7.2 16 16 16H34.3L59.8 452.6C62.1 486.1 90 512 123.6 512H324.4c33.6 0 61.4-25.9 63.8-59.4L413.7 96H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416 383.9 336.9zm44.8 32L356.3 450.3C355.1 467 341.2 480 324.4 480H123.6c-16.8 0-30.7-13-31.9-29.7L66.4 96H381.6z"]
};
var faGaugeSimple = {
  prefix: 'fal',
  iconName: 'gauge-simple',
  icon: [512, 512, ["gauge-simple-med", "tachometer-average"], "f629", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-194c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 194c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64z"]
};
var faGaugeSimpleMed = faGaugeSimple;
var faTachometerAverage = faGaugeSimple;
var faArrowDownSmallBig = {
  prefix: 'fal',
  iconName: 'arrow-down-small-big',
  icon: [576, 512, ["sort-size-down-alt"], "f88d", "M171.3 475.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V425.4L75.3 356.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM352 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80zm-32 0v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48zm32 352V304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm-32 0c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V432z"]
};
var faSortSizeDownAlt = faArrowDownSmallBig;
var faBookMedical = {
  prefix: 'fal',
  iconName: 'book-medical',
  icon: [448, 512, [], "f7e6", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM224 96h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H288v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V256H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h32V128c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7H160v32h48c8.8 0 16 7.2 16 16v48h32V240c0-8.8 7.2-16 16-16h48V192H272c-8.8 0-16-7.2-16-16V128H224z"]
};
var faFaceMelting = {
  prefix: 'fal',
  iconName: 'face-melting',
  icon: [640, 512, [129760], "e483", "M544 256c0 21.5-3 42.3-8.7 62c-6.5 22.7-2.1 46.4 9.5 64.6c.6 .9 1.2 1.9 1.9 2.8c-29 6.1-50.7 31.8-50.7 62.6c0 11.7 3.1 22.6 8.6 32H320 101.3c7.3-9.4 12.9-19.6 16.7-28.9c11.5-27.7 16.2-65.6 1.3-95.4c-15-30-23.4-63.8-23.4-99.8C96 132.3 196.3 32 320 32s224 100.3 224 224zM16 512H41.4 320 560c8.8 0 16-7.2 16-16s-7.2-16-16-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h44.1H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H604.1c-27.7 0-45.6-30.6-38-57.2c6.5-22.5 9.9-46.2 9.9-70.8C576 114.6 461.4 0 320 0S64 114.6 64 256c0 41 9.6 79.7 26.7 114c18.4 37-8 110-49.3 110H16c-8.8 0-16 7.2-16 16s7.2 16 16 16zM249.3 212.2a24 24 0 1 0 12.4-46.4 24 24 0 1 0 -12.4 46.4zm183.9 24.4a24 24 0 1 0 -46.4-12.4 24 24 0 1 0 46.4 12.4zm-220 46.7c-3.9-7.9-13.4-11.3-21.4-7.4s-11.3 13.4-7.4 21.4c14.8 30.5 45.1 67.5 98.3 81.7s97.9-2.6 126-21.7c7.3-5 9.2-14.9 4.3-22.2s-14.9-9.2-22.2-4.3c-22.7 15.4-57.9 28.5-99.8 17.2s-65.8-40.2-77.8-64.8z"]
};
var faPoo = {
  prefix: 'fal',
  iconName: 'poo',
  icon: [512, 512, [128169], "f2fe", "M224 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l5.8 5.8c8.7 8.7 13.5 20.4 13.5 32.7v8.9c0 20.6-16.7 37.3-37.3 37.3H176.9 176c-48.6 0-88 39.4-88 88c0 7.2 .9 14.3 2.5 21.1C56.4 233.2 32 265.7 32 304c0 16 4.3 31 11.7 43.9C17.6 363.2 0 391.5 0 424c0 48.6 39.4 88 88 88H424c48.6 0 88-39.4 88-88c0-32.5-17.6-60.8-43.7-76.1C475.7 335 480 320 480 304c0-38.3-24.4-70.8-58.5-82.9c1.7-6.8 2.5-13.8 2.5-21.1c0-35-20.4-65.1-49.9-79.3C363 52.2 303.6 0 232 0h-8zm40 65.8c0-10.7-2.2-21.2-6.3-30.8c46.1 10.8 81.3 50.2 85.8 98.4c.6 6.3 4.8 11.6 10.7 13.6c22 7.6 37.8 28.4 37.8 53c0 9.1-2.2 17.7-6 25.2c-2.4 4.7-2.3 10.2 .2 14.8s7.1 7.7 12.3 8.3c27.9 3.2 49.5 26.9 49.5 55.6c0 15.3-6.2 29.2-16.2 39.4c-4 4-5.5 9.9-4.1 15.4s5.7 9.8 11.2 11.3c23.7 6.5 41 28.3 41 54c0 30.9-25.1 56-56 56H88c-30.9 0-56-25.1-56-56c0-25.7 17.4-47.4 41-54c5.5-1.5 9.7-5.8 11.2-11.3s-.1-11.3-4.1-15.4C70.2 333.2 64 319.3 64 304c0-28.7 21.7-52.4 49.5-55.6c5.2-.6 9.8-3.7 12.3-8.3s2.6-10.1 .2-14.8c-3.8-7.6-6-16.1-6-25.2c0-30.9 25.1-56 56-56h.9 17.8C233 144 264 113 264 74.7V65.8zM192 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM172.3 352c-15.6 0-28.3 12.7-28.3 28.3c0 5.5 1.6 11.5 5.6 16.6C159 408.8 194.4 448 256 448s97-39.2 106.4-51.1c4-5.1 5.6-11.1 5.6-16.6c0-15.6-12.7-28.3-28.3-28.3H172.3zM256 416c-38.2 0-63.3-19.8-75.1-32H331.1c-11.8 12.2-36.9 32-75.1 32z"]
};
var faPenClipSlash = {
  prefix: 'fal',
  iconName: 'pen-clip-slash',
  icon: [640, 512, ["pen-alt-slash"], "e20f", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM556.7 149.3c25-25 25-65.5 0-90.5L517.3 19.3c-25-25-65.5-25-90.5 0L378.3 67.7 365.3 54.6c-25-25-65.5-25-90.5 0l-47 47 25.3 20 44.3-44.3c12.5-12.5 32.8-12.5 45.3 0l13.1 13.1L293 153.1l25.3 20L378.3 113 463 197.7l-50.1 50.1 25.3 20L556.7 149.3zM321.8 338.9l-50.9 50.9c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4l40.9-40.9-25.3-20-38.3 38.3c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L347 358.9l-25.3-20zm127.6-297c12.5-12.5 32.8-12.5 45.3 0l39.4 39.4c12.5 12.5 12.5 32.8 0 45.3L485.7 175 401 90.3l48.4-48.4z"]
};
var faPenAltSlash = faPenClipSlash;
var faQuoteRight = {
  prefix: 'fal',
  iconName: 'quote-right',
  icon: [448, 512, [8221, "quote-right-alt"], "f10e", "M448 304c0 61.9-50.1 112-112 112H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c44.2 0 80-35.8 80-80V279.4c-9.4 5.4-20.3 8.6-32 8.6H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 80zM416 192V160c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V192zM192 304c0 61.9-50.1 112-112 112H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H80c44.2 0 80-35.8 80-80V279.4c-9.4 5.4-20.3 8.6-32 8.6H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 80zM160 192V160c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V192z"]
};
var faQuoteRightAlt = faQuoteRight;
var faScrollOld = {
  prefix: 'fal',
  iconName: 'scroll-old',
  icon: [576, 512, [], "f70f", "M80 64c-26.5 0-48 21.5-48 48v72c0 4.4 3.6 8 8 8H96v32H40c-22.1 0-40-17.9-40-40V112C0 67.8 35.8 32 80 32H400c44.2 0 80 35.8 80 80V288H448V256H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V160H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V112c0-26.5-21.5-48-48-48H144c10 13.4 16 30 16 48V224h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H160V400c0 26.5 21.5 48 48 48s48-21.5 48-48V352c0-22.1 18-40 40-40h.6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .5 .4 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .5 .6 .6 .6 .6c22.1 0 40 17.9 40 40v56c0 39.8-32.2 72-72 72H208c-44.2 0-80-35.8-80-80V240 112c0-26.5-21.5-48-48-48zM272 448H504c22.1 0 40-17.9 40-40V352c0-4.4-3.6-8-8-8h-.6-.6-.6-.6-.5-.6-.5-.5H531h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H524h-.5H523h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H513h-.5H512h-.5H511h-.5H510h-.5H509h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H499h-.5H498h-.5H497h-.5H496h-.5H495h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H485h-.5H484h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H477h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H471h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H466h-.5-.5-.5-.5-.4-.5-.4-.4H462h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H454h-.4-.4-.4-.4-.4-.4-.4-.4H450h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H443h-.4-.4-.4-.4-.4-.4H440h-.4-.4-.4-.4-.4-.4H437h-.4-.4-.4-.4-.4-.4H434h-.4-.4-.4-.4-.4-.4H431h-.4-.4-.4-.4-.4-.4H428h-.4-.4-.4-.4-.4-.4H425h-.4-.4-.4-.4-.4-.4H422h-.4-.4-.4-.4-.4-.4H419h-.4-.4-.4-.4-.4-.4H416h-.4-.4-.4-.4-.4-.4H413h-.4-.4-.4-.4-.4-.4H410h-.4-.4-.4-.4-.4-.4H407h-.4-.4-.4-.4-.4-.4H404h-.4-.4-.4-.4-.4-.4H401h-.4-.4H400v40c0 8.8-7.2 16-16 16s-16-7.2-16-16V344h-.2-.5-.5-.5H366h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H361h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H355h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H348h-.5H347h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H337h-.5H336h-.5H335h-.5H334h-.5H333h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H323h-.5H322h-.5H321h-.5H320h-.5H319h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H309h-.5H308h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H301h-.5-.5-.5-.5-.5-.5-.6-.6H296c-4.4 0-8 3.6-8 8v48c0 18-6 34.6-16 48z"]
};
var faGuitars = {
  prefix: 'fal',
  iconName: 'guitars',
  icon: [512, 512, [], "f8bf", "M80 32V83.2c0 6.3 1.9 12.5 5.4 17.8L112 140.8v36C57.7 183 16 219.7 16 264c0 14 4.2 27.3 11.6 39.1c8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408c0 57.4 57.3 104 128 104c29.3 0 56.3-8 77.8-21.4c-5.4-9.4-9.3-19.7-11.6-30.6c-16.3 12-38.8 20.1-66.2 20.1c-59.5 0-96-38.1-96-72c0-14.1 5.6-27.9 16.5-40c20.9-23.2 21.3-58 6.2-82c-4.5-7.1-6.7-14.5-6.7-22c0-21.6 22.4-49.2 64-54.9v65.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V209.1c41.6 5.7 64 33.4 64 54.9c0 7.5-2.2 14.9-6.7 22c-15.1 23.9-14.7 58.8 6.2 82c.4 .5 .9 1 1.3 1.5c1.9-4.6 3.9-8.9 5.7-13l.3-.7c3.7-8.4 6.9-15.6 9.5-22c-3-10.1-1.5-21.8 4.1-30.7c1.1-1.7 2.1-3.5 3.1-5.3c-.9-4.9-2.7-10.7-5.7-19.2l-.5-1.4c-3.7-10.7-9.3-26.7-9.3-44.6v-23c-17.4-17.3-42.9-29.4-72-32.7v-36l26.6-39.9c3.5-5.3 5.4-11.4 5.4-17.8V32c0-17.7-14.3-32-32-32H112C94.3 0 80 14.3 80 32zm64 288a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM128 107.2l-16-24V32h32V83.2l-16 24zM344.9 50.8C347.3 39.8 357 32 368.2 32H372c10.9 0 20 9 20 20.2c0 10.9-8.9 19.8-19.6 19.8C361.2 72 352 81.2 352 92.4v57l-17.4-19.9c-3.3-3.8-4.7-8.9-3.6-13.9l13.9-64.8zm-34.4 99.8L352 198v42h-8c-43.3 0-57.3-29.2-61.8-48.2c-2.1-8.6-9.3-15.8-18.2-15.8s-16 7.2-16 16v40.6c0 12.4 4 24 8 35.5c4 11.6 8 23.3 8 35.9c0 20-9.3 40.9-19 62.5c-10.3 23.2-21 47.1-21 71.7c0 40.8 33 73.8 73.8 73.8H438.2c40.8 0 73.8-33 73.8-73.8c0-24.5-10.7-48.5-21-71.7c-9.6-21.6-19-42.5-19-62.5c0-12 4-22.9 8.1-33.8l0 0c4-10.7 7.9-21.4 7.9-33V208c0-8.8-7.2-16-16-16s-16.2 7.3-19.5 15.5c-5.7 14-20.8 32.5-60.5 32.5h-8V192 102.7c23-5.3 40-26.1 40-50.5C424 23.6 400.8 0 372 0h-3.8c-26.3 0-49.1 18.4-54.6 44.1L299.7 109c-3.2 14.8 .8 30.3 10.8 41.7zm54.3 121.1c1 .2 2.1 .3 3.2 .3s2.2-.1 3.2-.3H392c24.2 0 44-5.6 59.5-15.6c-.4 1.1-.8 2.2-1.2 3.3l-.4 1.2c-3.8 10.1-9.5 25.6-9.5 43.4c0 27 12 53.8 20.9 73.6l1.8 4.1c10.5 23.5 17.3 40.6 17.3 56.5c0 23.3-18.9 42.1-42.1 42.1H297.8c-23.3 0-42.1-18.9-42.1-42.1c0-15.9 6.8-33 17.3-56.5l1.8-4.1c8.9-19.9 20.9-46.6 20.9-73.6c0-18-5.5-34-9.3-44.8l-.4-1.3c-.7-1.9-1.3-3.7-1.8-5.3c15.1 11.9 35 19.2 59.9 19.2h20.8zM320 352c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"]
};
var faPhoneXmark = {
  prefix: 'fal',
  iconName: 'phone-xmark',
  icon: [640, 512, [], "e227", "M420.7 4.7c6.2-6.2 16.4-6.2 22.6 0L496 57.4 548.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 80l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 102.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 80 420.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zM393 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C247.5 494.5 64 300.7 64 64v0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L393 286.7zM512 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C98.6 57 96 60.2 96 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faHose = {
  prefix: 'fal',
  iconName: 'hose',
  icon: [448, 512, [], "e419", "M288 112c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.9l96.1-12c1 7.8 7.7 13.9 15.9 13.9c8.8 0 16-7.2 16-16V94.1 80 48 33.9 32c0-8.8-7.2-16-16-16c-8.1 0-14.8 6.1-15.9 13.9L320 17.9V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64v48zm32-61.9l96 12v3.8l-96 12V64 50.1zM48 448H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM12.2 432C4.6 440.5 0 451.7 0 464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32s-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32s-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32c0-26.5-21.5-48-48-48H152c-30.9 0-56-25.1-56-56s25.1-56 56-56H256V80H152c-48.6 0-88 39.4-88 88s39.4 88 88 88H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H152C85.7 288 32 234.3 32 168S85.7 48 152 48H256V16H152C68.1 16 0 84.1 0 168c0 48.8 23 92.2 58.7 120H48c-26.5 0-48 21.5-48 48c0 12.3 4.6 23.5 12.2 32C4.6 376.5 0 387.7 0 400s4.6 23.5 12.2 32zM152 320H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H152zM48 384H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faClockSix = {
  prefix: 'fal',
  iconName: 'clock-six',
  icon: [512, 512, [], "e352", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faShirt = {
  prefix: 'fal',
  iconName: 'shirt',
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M211.4 0c-27.7 0-54.5 9.6-76 27.1L56.3 91.9 12.9 127.4c-13.7 11.2-15.7 31.4-4.5 45l70.9 86.7c11.2 13.7 31.4 15.7 45 4.5L160 234.4V456c0 30.9 25.1 56 56 56H424c30.9 0 56-25.1 56-56V234.4l35.6 29.1c13.7 11.2 33.8 9.2 45-4.5l70.9-86.7c11.2-13.7 9.2-33.8-4.5-45l-10.1 12.4 10.1-12.4L583.7 91.9 504.6 27.1C483.1 9.6 456.3 0 428.6 0h-6.3c-1.3 0-2.5 .1-3.7 .2c-.8-.1-1.7-.2-2.6-.2H224c-.9 0-1.7 .1-2.6 .2c-1.2-.1-2.4-.2-3.7-.2h-6.3zm40.7 32H387.9C378 60 351.3 80 320 80s-58-20-67.9-48zM155.7 51.9C171.4 39 191.1 32 211.4 32h6.3l0 0c0 0 .2 .1 .4 .3c.5 .4 1 1.2 1.3 2.2C231.1 79.1 271.7 112 320 112s88.9-32.9 100.6-77.5c.3-1 .8-1.8 1.3-2.2c.2-.2 .4-.2 .4-.3l0 0h6.3c20.3 0 40 7 55.7 19.9l79.2 64.8 43.3 35.5-70.9 86.7-43.3-35.5-18.4-15.1c-4.8-3.9-11.4-4.7-17-2.1s-9.1 8.3-9.1 14.5V456c0 13.3-10.7 24-24 24H216c-13.3 0-24-10.7-24-24V200.7c0-6.2-3.6-11.8-9.1-14.5s-12.2-1.8-17 2.1l-18.4 15.1-43.3 35.5L33.2 152.1l43.3-35.5 79.2-64.8z"]
};
var faTShirt = faShirt;
var faTshirt = faShirt;
var faBillboard = {
  prefix: 'fal',
  iconName: 'billboard',
  icon: [640, 512, [], "e5cd", "M432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H240V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H80C53.5 32 32 53.5 32 80V352H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 64 304V488c0 8.8 7.2 16 16 16s16-7.2 16-16V384H576h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V80c0-26.5-21.5-48-48-48H432V16zM320 352H64V80c0-8.8 7.2-16 16-16H208v64H192c-8.8 0-16 7.2-16 16s7.2 16 16 16h32 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V64H400v64H384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H432V64H560c8.8 0 16 7.2 16 16V352H320z"]
};
var faSquareR = {
  prefix: 'fal',
  iconName: 'square-r',
  icon: [448, 512, [], "e27c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 32h80c44.2 0 80 35.8 80 80c0 34.8-22.2 64.4-53.2 75.4l50.5 75.7c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L231.4 288H160v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V272 160c0-17.7 14.3-32 32-32zm80 128c26.5 0 48-21.5 48-48s-21.5-48-48-48H160v96h80z"]
};
var faCubes = {
  prefix: 'fal',
  iconName: 'cubes',
  icon: [576, 512, [], "f1b3", "M293.4 32.8c-3.5-1.2-7.3-1.2-10.8 0l-104 37.1c-2.3 .8-4.4 2.2-6.1 3.9L288 118 403.4 73.8c-1.7-1.7-3.7-3-6.1-3.9l-104-37.1zM168 212.8l.1 0L272 249.9V146.2L168 106.3V212.8zm136 37.1l103.9-37.1 .1 0V106.3L304 146.2V249.9zM440 85V212.8l.1 0 104 37.1c19.1 6.8 31.9 24.9 31.9 45.2V421.4c0 19.4-11.7 36.9-29.6 44.4l-104 43c-11.8 4.9-25 4.9-36.7 0L288 460.1 170.4 508.8c-11.8 4.9-25 4.9-36.7 0l-104-43C11.7 458.3 0 440.8 0 421.4V295.2c0-20.3 12.8-38.4 31.9-45.2l104-37.1 .1 0V85c0-20.3 12.8-38.4 31.9-45.2l104-37.1c10.4-3.7 21.8-3.7 32.3 0l104 37.1C427.2 46.6 440 64.7 440 85zM272 308.2L160 348.6V478.4l112-46.3V308.2zM41.9 436.2L128 471.8V348.1L32 308.9V421.4c0 6.5 3.9 12.3 9.9 14.8zM416 478.4V348.6L304 308.2V432.1l112 46.3zm32-6.6l86.1-35.6c6-2.5 9.9-8.3 9.9-14.8V308.9l-96 39.2V471.8zM157.4 243c-3.5-1.2-7.3-1.2-10.8 0L44.6 279.4l99.8 40.8 114.1-41.1L157.4 243zm261.2 0L317.5 279.1l114.1 41.1 99.8-40.8L429.4 243c-3.5-1.2-7.3-1.2-10.8 0z"]
};
var faEnvelopeOpenDollar = {
  prefix: 'fal',
  iconName: 'envelope-open-dollar',
  icon: [512, 512, [], "f657", "M392 32H120c-13.3 0-24 10.7-24 24V222.5L77.5 207.2c-4.2-3.4-8.7-6.3-13.5-8.6V56C64 25.1 89.1 0 120 0H392c30.9 0 56 25.1 56 56V198.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5V56c0-13.3-10.7-24-24-24zM35 256c-1.6 0-3 1.3-3 3V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V259c0-1.6-1.3-3-3-3c-.7 0-1.3 .2-1.9 .7L294.5 405.1C283.7 414 270 418.9 256 418.9s-27.7-4.9-38.5-13.8L36.8 256.7c-.5-.4-1.2-.7-1.9-.7zM0 259c0-19.3 15.6-35 35-35c8.1 0 15.9 2.8 22.2 7.9L237.8 380.3c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5L454.9 231.9c6.3-5.1 14.1-7.9 22.2-7.9c19.3 0 35 15.6 35 35V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V259zM272 88v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V296c0 8.8-7.2 16-16 16s-16-7.2-16-16V278.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V88c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDivide = {
  prefix: 'fal',
  iconName: 'divide',
  icon: [448, 512, [10135, 247], "f529", "M224 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 272c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H416z"]
};
var faSunCloud = {
  prefix: 'fal',
  iconName: 'sun-cloud',
  icon: [640, 512, [127780], "f763", "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.4-50.9c-11-.4-21.6-2.6-31.4-6.5l-5 27.3-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.9l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-17.1 24.8c4-.4 8.2-.7 12.3-.7c8.6 0 17 1 25.1 2.8l20.1-29.2c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zM256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c12.4 0 24.5-1.8 35.8-5.1c-2.5-8.5-3.8-17.6-3.8-26.9c0-1.9 .1-3.7 .2-5.5c-10.1 3.6-20.9 5.5-32.2 5.5c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 1.9-.1 3.7-.2 5.5c3.2-1.1 6.4-2.1 9.7-2.9c4.9-11 11.5-21.1 19.5-29.9C368.6 171.1 317.3 128 256 128zm208 96c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64s28.7 64 64 64H568c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224zm0 32c26.5 0 48 21.5 48 48l0 .8c0 6.5 3.9 12.4 9.9 14.9s13 1.1 17.5-3.6c7.3-7.4 17.4-12 28.6-12c22.1 0 40 17.9 40 40s-17.9 40-40 40H384c-17.7 0-32-14.3-32-32s14.3-32 32-32c3.8 0 7.4 .6 10.7 1.8c5 1.8 10.6 1 14.9-2.2s6.7-8.2 6.5-13.5c0-.7 0-1.4 0-2.1c0-26.5 21.5-48 48-48z"]
};
var faLampFloor = {
  prefix: 'fal',
  iconName: 'lamp-floor',
  icon: [640, 512, [], "e015", "M224 32L160 192H480L416 32 224 32zM194.3 20.1C199.1 8 210.9 0 224 0H416c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1H160c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM208 480h96V256h32V480h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 208c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSquare7 = {
  prefix: 'fal',
  iconName: 'square-7',
  icon: [448, 512, [], "e25c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32H304c5.7 0 11 3 13.8 8s2.9 11 .1 16l-128 224c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8L276.4 160H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTengeSign = {
  prefix: 'fal',
  iconName: 'tenge-sign',
  icon: [384, 512, [8376, "tenge"], "f7d7", "M0 48c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48zM0 176c0-8.8 7.2-16 16-16H192 368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H16c-8.8 0-16-7.2-16-16z"]
};
var faTenge = faTengeSign;
var faHeadphones = {
  prefix: 'fal',
  iconName: 'headphones',
  icon: [512, 512, [127911], "f025", "M32.6 271.6C41 155.5 137.8 64 256 64s215 91.5 223.4 207.6C466.1 261.8 449.7 256 432 256c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48c44.2 0 80-35.8 80-80V368 336 288C512 146.6 397.4 32 256 32S0 146.6 0 288v48 32 32c0 44.2 35.8 80 80 80c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48c-17.7 0-34.1 5.8-47.4 15.6zM32 336c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16c-26.5 0-48-21.5-48-48V368 336zm448 0v32 32c0 26.5-21.5 48-48 48c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16c26.5 0 48 21.5 48 48z"]
};
var faHandsHolding = {
  prefix: 'fal',
  iconName: 'hands-holding',
  icon: [640, 512, [], "f4c2", "M128 128c0-35.3-28.7-64-64-64S0 92.7 0 128V344.2c0 29.7 11.8 58.2 32.8 79.2l83.9 83.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L55.4 400.8c-15-15-23.4-35.4-23.4-56.6V128c0-17.7 14.3-32 32-32s32 14.3 32 32V252.3c0 27.1 10.8 53.1 29.9 72.2l10.7 10.8s0 0 0 0l44 44s0 0 0 0l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16-44-44c-9.2-9.2-9.2-24.2 0-33.4s24.2-9.2 33.4 0L284 370.6c12.8 12.8 20 30.2 20 48.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V418.9c0-18.1 7.2-35.5 20-48.3l91.3-91.3c9.2-9.2 24.2-9.2 33.4 0s9.2 24.2 0 33.4l0 0-44 44 0 0-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16 44-44 10.8-10.8c19.2-19.2 29.9-45.1 29.9-72.2V128c0-17.7 14.3-32 32-32s32 14.3 32 32V344.2c0 21.2-8.4 41.6-23.4 56.6l-83.9 83.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l83.9-83.9c21-21 32.8-49.5 32.8-79.2V128c0-35.3-28.7-64-64-64s-64 28.7-64 64V252.3c0 4.6-.4 9.1-1.3 13.5c-2.1-3.2-4.6-6.3-7.4-9.1c-21.7-21.7-56.9-21.7-78.6 0L333.4 348c-5.1 5.1-9.6 10.6-13.4 16.6c-3.8-5.9-8.3-11.5-13.4-16.6l-91.3-91.3c-21.7-21.7-56.9-21.7-78.6 0c-2.8 2.8-5.3 5.9-7.4 9.1c-.9-4.4-1.3-8.9-1.3-13.5V128z"]
};
var faCampfire = {
  prefix: 'fal',
  iconName: 'campfire',
  icon: [512, 512, [], "f6ba", "M232.2 3.4c-2.5-2.3-5.6-3.4-8.8-3.4c-3.2 0-6.4 1.1-9 3.4c-29.9 27-55.3 57.7-73.2 87.1c-17.7 29-29.2 60.2-29.2 84.2C112 254.5 175.3 320 256 320c79.9 0 144-65.5 144-145.3c0-18.3-8.7-46.3-21.7-71.8C365 77 346.2 49.7 323.9 29.1c-5-4.7-12.9-4.7-18 0c-1.5 1.4-3.1 2.9-4.6 4.4c-6.9 7-13.4 15-19.2 22.4c-6.3-7.7-12.8-15.1-19.5-22.3C252.9 23.1 242.7 13 232.2 3.4zM282.4 85c8.8-.1 17.1-4.2 22.5-11.1c3.4-4.3 6.8-8.5 10.1-12.3c14.6 16.1 27.5 35.6 37.3 54.6c12.2 23.7 18.5 46.9 18.5 58.5c0 64.1-51.5 116.2-114.9 116.2c-64.2 0-114.9-52-114.9-116.2c0-16.4 8.4-42.1 24.9-69c14.3-23.4 34-48 57.3-70.7c12.8 12.4 24.9 25.5 36.4 39.5c5.6 6.8 14 10.7 22.8 10.6zm-57.9 .8c-4.9 0-9.5 2.2-12.5 6c-13.4 16.7-24.3 30.8-31.8 43.7c-7.6 13.3-12.3 26.3-12.3 40.8c0 26.4 9.7 48.5 26.4 63.9c16.5 15.3 38.8 23 62.5 23c19.5 0 37-5.6 53-16.4l0 0 .3-.2c34.3-24.2 42.4-71.4 23-107.7l0-.1c-1.7-3.5-4.1-8.2-7.6-13c-2.9-3.9-7.4-6.3-12.3-6.5s-9.6 1.9-12.7 5.6l-19.6 23.2-14.5-18.6c-13.5-17.3-27.5-35.4-29.3-37.7c-3-3.8-7.6-6.1-12.5-6.1zM292.5 184l16.7-19.7c6.4 21.2-.5 44.2-17.3 56.2c-10.9 7.3-22.2 10.8-35 10.8c-16.8 0-31-5.4-40.8-14.5c-9.6-8.9-16.1-22.2-16.1-40.4c0-7.2 2.1-14.7 8-24.8c4-6.9 9.4-14.5 16.4-23.8l16.7 21.5 18.3 23.6 6 7.7 1.7 2.1 .4 .6 .1 .1 0 0 0 0 0 0 12.6-9.8-12.6 9.8c3 3.8 7.5 6.1 12.3 6.2s9.4-2 12.5-5.6zM21.9 289.1c-8.2-3.3-17.5 .7-20.8 8.9s.7 17.5 8.9 20.8L212.9 400 10.1 481.1c-8.2 3.3-12.2 12.6-8.9 20.8s12.6 12.2 20.8 8.9L256 417.2l234.1 93.6c8.2 3.3 17.5-.7 20.8-8.9s-.7-17.5-8.9-20.8L299.1 400l202.9-81.1c8.2-3.3 12.2-12.6 8.9-20.8s-12.6-12.2-20.8-8.9L256 382.8 21.9 289.1z"]
};
var faCircleAmpersand = {
  prefix: 'fal',
  iconName: 'circle-ampersand',
  icon: [512, 512, [], "e0f8", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 184c0-13.3 10.7-24 24-24h16.8c12.8 0 23.2 10.4 23.2 23.2c0 10.2-5 19.8-13.5 25.6l-21.8 15-22.1-23.3c-4.3-4.5-6.6-10.4-6.6-16.6zm68.7 51.2c17.1-11.8 27.3-31.2 27.3-52c0-30.5-24.7-55.2-55.2-55.2H232c-30.9 0-56 25.1-56 56c0 14.4 5.5 28.2 15.4 38.6l18.6 19.5-38.7 26.6C154.2 280.5 144 300 144 320.8c0 34.9 28.3 63.2 63.2 63.2h36c23.3 0 45.1-11.2 58.6-30.2l6.3-8.8 32.4 34c6.1 6.4 16.2 6.6 22.6 .6s6.6-16.2 .6-22.6L327 318.5l38-53.2c5.1-7.2 3.5-17.2-3.7-22.3s-17.2-3.5-22.3 3.7l-34.5 48.2-45.4-47.7 17.5-12.1zm-87.1 59.9l42.9-29.5 53.2 55.8-9.8 13.8c-7.5 10.5-19.6 16.8-32.5 16.8h-36C190 352 176 338 176 320.8c0-10.3 5.1-19.9 13.5-25.7z"]
};
var faSnowflakes = {
  prefix: 'fal',
  iconName: 'snowflakes',
  icon: [640, 512, [], "f7cf", "M507.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L513.4 56 484.7 84.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L536 78.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L558.6 56l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L536 33.4 507.3 4.7zM240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V89.4L171.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 134.6v93.7l-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3S72 100.2 74.3 108.7l13.4 50.1L24.1 122.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7L21.6 200C13 202.3 8 211 10.3 219.6s11.1 13.6 19.6 11.3l81-21.7L192 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3S13 309.7 21.6 312l50.1 13.4L8.1 362.1C.5 366.6-2.1 376.3 2.3 384s14.2 10.3 21.9 5.9l63.5-36.7L74.3 403.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81L208 283.7v93.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 422.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V422.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 377.4V283.7l81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1 63.5 36.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-63.5-36.7L426.4 312c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L256 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81L240 228.3V134.6l59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 89.4V16zM532.7 212.7c-6.2 6.2-6.2 16.4 0 22.6L561.4 264l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L584 286.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L606.6 264l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L584 241.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faHandsClapping = {
  prefix: 'fal',
  iconName: 'hands-clapping',
  icon: [512, 512, [], "e1a8", "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V80c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM215.1 18.7c-7.4 4.9-9.3 14.8-4.4 22.2l32 48c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-32-48c-4.9-7.4-14.8-9.3-22.2-4.4zm209.8 0c-7.4-4.9-17.3-2.9-22.2 4.4l-32 48c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l32-48c4.9-7.4 2.9-17.3-4.4-22.2zM153.9 152c4.8 0 9.3 1.9 12.7 5.3L292.7 283.3c2.9 2.9 6.9 4.7 11.3 4.7c8.8 0 16-7.2 16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16V337.6C352 416.2 288.2 480 209.6 480c-37.8 0-74-15-100.7-41.7L75.3 404.7l-16-16 0 0-22-22c-3.4-3.4-5.3-7.9-5.3-12.7C32 344 40 336 49.9 336c4.8 0 9.3 1.9 12.7 5.2l0 0 38.1 38.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L85.3 318.6l0 0-48-48c-3.4-3.4-5.3-7.9-5.3-12.7C32 248 40 240 49.9 240c4.8 0 9.3 1.9 12.7 5.3l86.1 86.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L85.3 222.6l0 0-24-24c-3.4-3.4-5.3-7.9-5.3-12.7C56 176 64 168 73.9 168c4.8 0 9.3 1.9 12.7 5.3l32 32 0 0 78.1 78.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-78.1-78.1 0 0c-3.4-3.4-5.2-7.9-5.2-12.7c0-9.9 8-17.9 17.9-17.9zM31.1 211.7C12.9 219.1 0 237 0 257.9c0 13.2 5.3 25.9 14.6 35.3l15 15C12.2 316.1 0 333.6 0 353.9c0 13.2 5.3 25.9 14.6 35.3l22 22 0 0 16 16 0 0 33.6 33.6C119 493.6 163.4 512 209.6 512C305.9 512 384 433.9 384 337.6V208c0-26.5-21.5-48-48-48s-48 21.5-48 48v25.4l-98.7-98.7c-9.4-9.4-22.1-14.6-35.3-14.6c-20.4 0-37.9 12.2-45.7 29.7C99 140.9 86.7 136 73.9 136C46.4 136 24 158.4 24 185.9c0 9.1 2.5 18 7.1 25.7zM360.8 478.1c-11.7 12.6-25 23.7-39.5 33.1c5.4 .5 10.9 .8 16.4 .8C433.9 512 512 433.9 512 337.6V208c0-26.5-21.5-48-48-48s-48 21.5-48 48v25.4 45.3l4.7 4.7c2.9 2.9 6.9 4.7 11.3 4.7c8.8 0 16-7.2 16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16V337.6c0 70.7-51.6 129.4-119.2 140.5z"]
};
var faRepublican = {
  prefix: 'fal',
  iconName: 'republican',
  icon: [640, 512, [], "f75e", "M0 176C0 96.5 64.5 32 144 32H368c79.5 0 144 64.5 144 144v96 64 32c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 61.9-50.1 112-112 112c-32.2 0-61.2-13.6-81.7-35.4C440.8 465 422.1 480 400 480H336c-26.5 0-48-21.5-48-48V384H160v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272 176zM480 288H32V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V368c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16c0 44.2 35.8 80 80 80s80-35.8 80-80V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V336 288zm0-32V176c0-61.9-50.1-112-112-112H144C82.1 64 32 114.1 32 176v80H480zM160 144v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V144c0-8.8 7.2-16 16-16zm128 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faLeafMaple = {
  prefix: 'fal',
  iconName: 'leaf-maple',
  icon: [512, 512, [127809], "f6f6", "M336.9 7.4C334 2.9 329.1 .1 323.7 0s-10.4 2.4-13.5 6.8L248.6 94.5 248 60.6c-.1-4.9-2.4-9.5-6.3-12.4s-8.9-4-13.7-2.8L179.3 57.9 140.9 13.1c-2.9-3.4-7.1-5.4-11.5-5.6s-8.8 1.5-11.9 4.6L70.1 59 18 52.5c-5.3-.7-10.5 1.3-14 5.3S-.8 67.3 .5 72.4L42.9 234.8 5.7 266.2c-4.1 3.4-6.2 8.7-5.6 14s3.8 10 8.5 12.4L132 357.4 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L154.6 380l64.7 123.4c2.5 4.7 7.1 7.9 12.4 8.5s10.5-1.5 14-5.6l31.4-37.2 162.4 42.4c5.1 1.3 10.6 0 14.6-3.5s6-8.7 5.3-14l-5.6-44.4c-.6-4.9 1.1-9.8 4.5-13.2l41.4-41.9c3.1-3.2 4.8-7.5 4.6-11.9s-2.2-8.6-5.6-11.5l-44.8-38.4L466.6 284c1.2-4.7 .2-9.8-2.8-13.7s-7.5-6.2-12.4-6.3l-33.9-.6 87.7-61.6c4.7-3.3 7.3-8.9 6.7-14.7s-4.2-10.7-9.5-13.1l-41.1-18.1c-7.6-3.3-11.3-11.9-8.7-19.7L481.2 51c1.9-5.6 .5-11.9-3.6-16.2s-10.3-6-16-4.3L379.9 53.9c-6.8 1.9-14.1-.8-17.9-6.8L336.9 7.4zM178.3 356.3L316.2 218.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L155.7 333.7 44.5 275.3l19-16.1c9.4-8 13.4-20.6 10.3-32.5L37.4 87.2l36.4 4.6c4.9 .6 9.8-1.1 13.2-4.5L127.8 47l33.7 39.3c4 4.6 10.2 6.6 16.1 5.1l38.7-9.9 1.2 62.6c.1 6.9 4.7 13 11.3 15s13.8-.4 17.8-6.1l76-108.1L335 64.2c11.4 18 33.3 26.3 53.7 20.5l52.5-15-18.9 56.2c-7.9 23.5 3.4 49.2 26.1 59.2l15.2 6.7L359.1 265.4c-5.7 4-8.1 11.2-6.1 17.8s8.1 11.2 15 11.3l62.6 1.2-9.9 38.7c-1.5 5.9 .5 12.2 5.1 16.1L465 384.2l-29.3 29.6c-10.4 10.5-15.4 25.1-13.5 39.7l2.6 21L285.3 438.2c-11.9-3.1-24.6 .9-32.5 10.3l-16.1 19L178.3 356.3z"]
};
var faArrowLeft = {
  prefix: 'fal',
  iconName: 'arrow-left',
  icon: [448, 512, [8592], "f060", "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 432 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176z"]
};
var faPersonCircleXmark = {
  prefix: 'fal',
  iconName: 'person-circle-xmark',
  icon: [576, 512, [], "e543", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 368z"]
};
var faRuler = {
  prefix: 'fal',
  iconName: 'ruler',
  icon: [512, 512, [128207], "f545", "M51.9 390.6c-12.5-12.5-12.5-32.8 0-45.3l39.4-39.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L305.9 91.3l39.4-39.4c12.5-12.5 32.8-12.5 45.3 0l69.5 69.5c12.5 12.5 12.5 32.8 0 45.3L166.6 460.1c-12.5 12.5-32.8 12.5-45.3 0L51.9 390.6zm46.9 92.1c25 25 65.5 25 90.5 0L482.7 189.3c25-25 25-65.5 0-90.5L413.3 29.3c-25-25-65.5-25-90.5 0L29.3 322.7c-25 25-25 65.5 0 90.5l69.5 69.5z"]
};
var faCupStrawSwoosh = {
  prefix: 'fal',
  iconName: 'cup-straw-swoosh',
  icon: [384, 512, [], "e364", "M202.4 36.4C207.8 15 227 0 249 0h23c8.8 0 16 7.2 16 16s-7.2 16-16 16H249c-7.3 0-13.7 5-15.5 12.1l-21 83.9H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H192.4c-.2 0-.5 0-.7 0H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H179.5l22.9-91.6zM60.3 468l-23-276H69.4L83.9 365.1c29-3.7 48.3-10.6 62.3-18.6c17.1-9.8 27.6-22 39.1-36.1l2-2.5c10.8-13.4 23.2-28.6 42.5-41c19.3-12.3 44.4-21.2 80.6-24.9l4.2-50h32.1l-23 276c-2.1 24.9-22.9 44-47.8 44H108.2c-25 0-45.8-19.1-47.8-44zM307.7 274.5c-29 3.6-47.5 10.9-60.7 19.4c-14.8 9.5-24.2 21.1-35.5 35l-1.4 1.7c-11.8 14.5-25.4 30.7-48 43.7C143.4 385 119.4 392.9 86.5 397l5.7 68.3c.7 8.3 7.6 14.7 15.9 14.7H275.8c8.3 0 15.3-6.4 15.9-14.7l15.9-190.9z"]
};
var faTemperatureSun = {
  prefix: 'fal',
  iconName: 'temperature-sun',
  icon: [640, 512, ["temperature-hot"], "f76a", "M336 101.1l-18.1-3L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6L208 363.5l69 48.3c-3.2-13.7-4.9-27.9-5-42.6l-54.8-38.4c-5.5-3.9-12.8-3.9-18.4 0l-59.2 41.4-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l34.6 5.8V101.1zM208 264a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm-88-56a88 88 0 1 0 176 0 88 88 0 1 0 -176 0zM400 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM464 0c-53 0-96 43-96 96V252.7c0 4.6-2.2 9.8-6.8 14.5C335.7 293.1 320 328.8 320 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM432 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V96c0-8.8-7.2-16-16-16s-16 7.2-16 16V306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faTemperatureHot = faTemperatureSun;
var faAlignLeft = {
  prefix: 'fal',
  iconName: 'align-left',
  icon: [448, 512, [], "f036", "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 320c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faDiceD6 = {
  prefix: 'fal',
  iconName: 'dice-d6',
  icon: [448, 512, [], "f6d1", "M220.1 35.6L47.9 136.2l176 101.2L400 133l-172-97.5 11.6-20.4L228.1 35.5c-2.5-1.4-5.5-1.4-8 .1zM32 164V366.6c0 2.9 1.6 5.6 4.1 7L208 469.9V265.3L32 164zM240 469.9l171.9-96.3c2.5-1.4 4.1-4.1 4.1-7V160.8L240 265.1V469.9zM203.9 7.9c12.3-7.2 27.5-7.3 39.9-.3L427.7 112c12.5 7.1 20.3 20.4 20.3 34.8V366.6c0 14.5-7.8 27.8-20.5 34.9l-184 103c-12.1 6.8-26.9 6.8-39.1 0l-184-103C7.8 394.4 0 381.1 0 366.6V150.1c0-14.2 7.5-27.4 19.8-34.5L203.9 7.9z"]
};
var faRestroom = {
  prefix: 'fal',
  iconName: 'restroom',
  icon: [640, 512, [], "f7bd", "M144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 144 0zM112 164V320h64V164c-6-2.6-12.5-4-19.3-4H131.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L30.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L60.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l58.8 110.2c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L208 202.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H112zM496 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 496 0zM455.2 241.7c7.9 4 11.1 13.6 7.2 21.5L409.9 368H448h96 38.1L529.7 263.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l64 128c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6H560v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H464v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H384c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l64-128c4-7.9 13.6-11.1 21.5-7.2zM435 196.6l-52.9 98.9c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l52.9-98.9C424.3 148.6 458.7 128 496 128s71.7 20.6 89.3 53.5l52.9 98.9c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L557 196.6c-12-22.5-35.5-36.6-61-36.6s-49 14.1-61 36.6zM336 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHighDefinition = {
  prefix: 'fal',
  iconName: 'high-definition',
  icon: [576, 512, ["rectangle-hd"], "e1ae", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM320 176V336c0 8.8 7.2 16 16 16h48c53 0 96-43 96-96s-43-96-96-96H336c-8.8 0-16 7.2-16 16zm64 16c35.3 0 64 28.7 64 64s-28.7 64-64 64H352V192h32zM144 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v80 80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h96v64c0 8.8 7.2 16 16 16s16-7.2 16-16V256 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H144V176z"]
};
var faRectangleHd = faHighDefinition;
var faJ = {
  prefix: 'fal',
  iconName: 'j',
  icon: [320, 512, [106], "4a", "M304 32c8.8 0 16 7.2 16 16V320c0 88.4-71.6 160-160 160S0 408.4 0 320V272c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 70.7 57.3 128 128 128s128-57.3 128-128V48c0-8.8 7.2-16 16-16z"]
};
var faGalaxy = {
  prefix: 'fal',
  iconName: 'galaxy',
  icon: [512, 512, [], "e008", "M144 184c0-83.9 68.1-152 152-152h12.8C272 59.2 246.6 98.6 236.7 142.5c-1.4 6 .9 12.3 5.8 16.1s11.5 4.5 17.1 1.7C280.1 149.9 303.3 144 328 144c83.9 0 152 68.1 152 152v12.8c-27.2-36.9-66.6-62.2-110.5-72.1c-6-1.4-12.3 .9-16.2 5.8s-4.5 11.5-1.7 17.1C362.1 280.1 368 303.3 368 328c0 83.9-68.1 152-152 152H203.2c36.9-27.2 62.2-66.6 72.1-110.5c1.4-6-.9-12.3-5.8-16.2s-11.5-4.5-17.1-1.7C231.9 362.1 208.7 368 184 368c-83.9 0-152-68.1-152-152V203.2c27.2 36.9 66.6 62.2 110.5 72.1c6 1.4 12.3-.9 16.1-5.8s4.5-11.5 1.7-17.1C149.9 231.9 144 208.7 144 184zM296 0C194.4 0 112 82.4 112 184c0 17.2 2.4 33.9 6.8 49.7C94.5 222.6 73.1 205.4 57 183.2L48.1 171c-5-6.9-13-11-21.5-11C11.9 160 0 171.9 0 186.6V216C0 317.6 82.4 400 184 400c17.2 0 33.9-2.4 49.7-6.8c-11.1 24.3-28.4 45.7-50.6 61.8l9.4 12.9L183.2 455 171 463.9c-6.9 5-11 13-11 21.5c0 14.7 11.9 26.6 26.6 26.6H216c101.6 0 184-82.4 184-184c0-17.2-2.4-33.9-6.8-49.7c24.3 11.1 45.7 28.4 61.8 50.6l8.9 12.2c5 6.9 13 11 21.5 11c14.7 0 26.6-11.9 26.6-26.6V296c0-101.6-82.4-184-184-184c-17.2 0-33.9 2.4-49.7 6.8c11.1-24.3 28.4-45.7 50.6-61.8L341 48.1c6.9-5 11-13 11-21.5C352 11.9 340.1 0 325.4 0H296zM256 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faUsersViewfinder = {
  prefix: 'fal',
  iconName: 'users-viewfinder',
  icon: [640, 512, [], "e595", "M32 32h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H24C10.7 0 0 10.7 0 24V128c0 8.8 7.2 16 16 16s16-7.2 16-16V32zm576 0v96c0 8.8 7.2 16 16 16s16-7.2 16-16V24c0-13.3-10.7-24-24-24H512c-8.8 0-16 7.2-16 16s7.2 16 16 16h96zM128 480H32V384c0-8.8-7.2-16-16-16s-16 7.2-16 16V488c0 13.3 10.7 24 24 24H128c8.8 0 16-7.2 16-16s-7.2-16-16-16zm480 0H512c-8.8 0-16 7.2-16 16s7.2 16 16 16H616c13.3 0 24-10.7 24-24V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v96zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM360 320c19.4 0 35.5 13.7 39.2 32H240.8c3.7-18.3 19.8-32 39.2-32h80zm-80-32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H320 280zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H152c-30.9 0-56 25.1-56 56v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8zM464.2 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM488 288c13.3 0 24 10.7 24 24v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-30.9-25.1-56-56-56H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h56z"]
};
var faFileVideo = {
  prefix: 'fal',
  iconName: 'file-video',
  icon: [384, 512, [], "f1c8", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 288v24 48 24H96V288H208zm32 96v-.4l58.1 23.2c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2V280c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L240 288.4V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H208c17.7 0 32-14.3 32-32zm48-15.6l-48-19.2V322.8l48-19.2v64.7z"]
};
var faCherries = {
  prefix: 'fal',
  iconName: 'cherries',
  icon: [640, 512, [], "e0ec", "M288 16l8.2-13.7c-4.7-2.8-10.5-3-15.4-.6s-8.2 7.3-8.7 12.7l0 0 0 0 0 .1 0 .3-.1 1.2c-.1 1.1-.3 2.8-.6 5c-.6 4.4-1.5 10.8-2.8 18.7c-2.7 16-7.1 38.2-13.9 63c-13.8 50.2-37 109.3-74.4 150.5c-.2 .2-.3 .3-.4 .5C163.8 241.9 133.5 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-32 192-176c0-112-96-112-96-112c-21.3 0-40.2 5.8-55.6 12.9c25.7-40.5 42.3-86.8 53-125.7C292.6 85.1 297.2 61.8 300 45l.2-1.2c1 .7 2 1.5 3.1 2.3c14.5 11 33.7 27.1 53 47.8c36.2 39 71 92.5 75.3 156.9c-13.2-9.1-33.5-20.4-58.3-24.9c12.6 11.5 23.6 26.5 31.3 45.5c4.6 2.7 8.7 5.5 12.1 8c18.4 13.7 44.3 13.7 62.7 0c13.5-10 37-23.4 64.4-23.5l.1 0c.3 0 .8 0 1.6 .1c1.6 .1 4.2 .4 7.4 1.1c6.5 1.3 14.9 3.8 23 8.5C590 273.9 608 291.3 608 336c0 68-29.4 101.7-61.9 120.2c-35 20-76.5 23.8-98.1 23.8c-14.6 0-42.6-4-71.1-15.9c-7 9.2-14.8 17.4-23 24.8C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-35 0-63.7 15.6-80.3 27.3c-4.1-75.9-44.8-137.1-83.9-179.2c-20.8-22.3-41.5-39.7-57-51.5c-7.8-5.9-14.3-10.4-18.9-13.5c-2.3-1.5-4.1-2.7-5.4-3.5c-.6-.4-1.1-.7-1.5-.9l-.4-.3-.1-.1 0 0 0 0s0 0-8.2 13.7zm-.3 243.2l0 0c.2 0 .7 0 1.5 .1c1.5 .1 4 .4 7.1 1c6.3 1.2 14.3 3.6 22 8.1c13.1 7.6 30.5 24 30.5 67.6c0 57.7-27.7 91.3-61.3 112.1c-35.5 22-76.8 28.7-95.5 28.7s-60-6.8-95.5-28.7C62.9 427.3 35.2 393.7 35.2 336c0-43.6 17.5-60 30.5-67.6c7.7-4.5 15.7-6.9 22-8.1c3.1-.6 5.5-.9 7.1-1c.8-.1 1.3-.1 1.5-.1l0 0c19.6 .1 37.2 7.1 50.9 15.1c6.7 3.9 12 7.9 15.6 10.8c1.8 1.4 3 2.5 3.8 3.2c.4 .3 .6 .6 .7 .7l0 0 0 0 0 0c13.7 13.5 35.8 13.5 49.5 0l0 0 0 0c.1-.1 .3-.3 .7-.7c.8-.7 2-1.8 3.8-3.2c3.5-2.9 8.8-6.8 15.6-10.8c13.6-8 31.3-15.1 50.9-15.1z"]
};
var faUpRightFromSquare = {
  prefix: 'fal',
  iconName: 'up-right-from-square',
  icon: [512, 512, ["external-link-alt"], "f35d", "M320 33c0-18.2 14.8-33 33-33H480c17.7 0 32 14.3 32 32V159c0 18.2-14.8 33-33 33c-8.7 0-17.1-3.5-23.3-9.7L404 130.6 235.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L381.4 108 329.7 56.3C323.5 50.1 320 41.7 320 33zm33-1c-.5 0-1 .4-1 1c0 .3 .1 .5 .3 .7L478.3 159.7c.2 .2 .4 .3 .7 .3c.5 0 1-.4 1-1V32H353zM0 128C0 92.7 28.7 64 64 64H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V304c0-8.8 7.2-16 16-16s16 7.2 16 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faExternalLinkAlt = faUpRightFromSquare;
var faCircleSort = {
  prefix: 'fal',
  iconName: 'circle-sort',
  icon: [512, 512, ["sort-circle"], "e030", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM244.7 100.7c6.2-6.2 16.4-6.2 22.6 0l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96zM198.6 192l114.7 0L256 134.6 198.6 192zM148.7 315.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96zM256 377.4L313.4 320l-114.7 0L256 377.4z"]
};
var faSortCircle = faCircleSort;
var faTableCells = {
  prefix: 'fal',
  iconName: 'table-cells',
  icon: [512, 512, ["th"], "f00a", "M352 64v96H480V96c0-17.7-14.3-32-32-32H352zm-32 0H192v96H320V64zM160 64H64C46.3 64 32 78.3 32 96v64H160V64zM32 192V320H160V192H32zm0 160v64c0 17.7 14.3 32 32 32h96V352H32zm160 96H320V352H192v96zm160 0h96c17.7 0 32-14.3 32-32V352H352v96zM480 320V192H352V320H480zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM192 320H320V192H192V320z"]
};
var faTh = faTableCells;
var faFilePdf = {
  prefix: 'fal',
  iconName: 'file-pdf',
  icon: [512, 512, [], "f1c1", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
};
var faSiren = {
  prefix: 'fal',
  iconName: 'siren',
  icon: [448, 512, [], "e02d", "M363.8 320H396L375 152.1C371 120 343.8 96 311.5 96h-175C104.2 96 77 120 73 152.1L52 320H84.2l20.5-164c2-16 15.6-28 31.8-28h175c16.1 0 29.8 12 31.8 28l20.5 164zm-185.6 0l13.8-110c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9L145.9 320h32.2zM48 384H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V400c0-8.8 7.2-16 16-16zM0 400v32c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48z"]
};
var faArrowUpToDottedLine = {
  prefix: 'fal',
  iconName: 'arrow-up-to-dotted-line',
  icon: [448, 512, [], "e0a1", "M363.3 292.7l-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 214.6V320 464c0 8.8 7.2 16 16 16s16-7.2 16-16V320 214.6L340.7 315.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM32 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm384 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM152 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM344 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faImageLandscape = {
  prefix: 'fal',
  iconName: 'image-landscape',
  icon: [576, 512, ["landscape"], "e1b5", "M512 96c17.7 0 32 14.3 32 32V384c0 6.1-1.7 11.8-4.6 16.6L377 197.6c-12.8-16-37.2-16-50 0L244.4 300.9l-27.3-37.5c-12.3-17-37.4-17.7-50.6-1.4L45.3 410C37.3 404.2 32 394.7 32 384V128c0-17.7 14.3-32 32-32H512zm-1.3 320H193.3l63-78.8L352 217.6 510.7 416zM160.1 448H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64h95.9c.1 0 .2 0 .3 0zm-7.8-32H81.8L191.3 282.2l32.4 44.6L152.3 416zM144 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faLandscape = faImageLandscape;
var faTankWater = {
  prefix: 'fal',
  iconName: 'tank-water',
  icon: [448, 512, [], "e452", "M269.6 64H384c17.7 0 32 14.3 32 32V352c-20.9 0-41.7-10-58.2-21.2c-7.3-5-13.7-10.3-19.8-15.9c-10.2-9.5-25.9-9.5-36.1 0c-6.1 5.6-12.5 11-19.8 15.9C265.6 342.1 244.9 352 224 352s-41.7-9.9-58.2-21.2c-7.3-5-13.7-10.3-19.8-15.9c-10.2-9.5-25.9-9.5-36.1 0c-6.1 5.6-12.5 11-19.8 15.9C73.6 342.1 52.9 352 32 352V96c0-17.7 14.3-32 32-32H178.4l6.1-10 13.6-22H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H249.9l13.6 22 6.1 10zM32 384c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C166.4 369.9 193.7 384 224 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C358.5 369.9 385.7 384 416 384v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384zM236.4 70.7C233.7 66.5 229 64 224 64s-9.7 2.5-12.4 6.7l-47.2 70.8c-8.1 12.1-12.4 26.3-12.4 40.9V184c0 39.8 32.2 72 72 72s72-32.2 72-72v-1.7c0-14.5-4.3-28.8-12.4-40.9L236.4 70.7zm-12.4 39l33 49.5c4.6 6.8 7 14.9 7 23.1V184c0 22.1-17.9 40-40 40s-40-17.9-40-40v-1.7c0-8.2 2.4-16.3 7-23.1l33-49.5z"]
};
var faCurlingStone = {
  prefix: 'fal',
  iconName: 'curling-stone',
  icon: [576, 512, [129356, "curling"], "f44a", "M192 112c0-26.5 21.5-48 48-48H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-44.2 0-80 35.8-80 80v48c-35.3 0-64 28.7-64 64v1.1C41.7 232.9 0 279.6 0 336v32c0 61.9 50.1 112 112 112H464c61.9 0 112-50.1 112-112V336c0-56.4-41.7-103.1-96-110.9V224c0-35.3-28.7-64-64-64H192V112zM448 224H128c0-17.7 14.3-32 32-32h16H416c17.7 0 32 14.3 32 32zM112 448c-44.2 0-80-35.8-80-80H544c0 44.2-35.8 80-80 80H112zM32 336c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80H32z"]
};
var faCurling = faCurlingStone;
var faGamepadModern = {
  prefix: 'fal',
  iconName: 'gamepad-modern',
  icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M216 352H424c14.7 0 27.5 10 31 24.2l3.6 14.3c8.4 33.8 38.8 57.4 73.6 57.4c41.9 0 75.8-33.9 75.8-75.8v-2.8c0-4.5-.4-8.9-1.1-13.3L574.1 165.3c-7-40.7-32.2-71.3-66.5-79.9C464.1 74.5 401.1 64 320 64s-144.1 10.5-187.6 21.4C98 93.9 72.8 124.5 65.9 165.3L33.1 356.1c-.8 4.4-1.1 8.8-1.1 13.3v2.8c0 41.9 33.9 75.8 75.8 75.8c34.8 0 65.1-23.7 73.6-57.4l3.6-14.3c3.6-14.2 16.4-24.2 31-24.2zm211.6 46.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM208 160v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V160c0-8.8 7.2-16 16-16s16 7.2 16 16zM408 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGamepadAlt = faGamepadModern;
var faMessagesQuestion = {
  prefix: 'fal',
  iconName: 'messages-question',
  icon: [640, 512, [], "e1e7", "M202.7 288H352c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V256c0 17.7 14.3 32 32 32H96c17.7 0 32 14.3 32 32v16l55.5-41.6c5.5-4.2 12.3-6.4 19.2-6.4zM352 320H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V352 320H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64zM320 448c-35.3 0-64-28.7-64-64V352h32v32c0 17.7 14.3 32 32 32H437.3c6.9 0 13.7 2.2 19.2 6.4L512 464V448c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H448V128H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H544v32 16c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320zM184.3 70.3c-16.4 0-31 10.3-36.4 25.7l-.3 .9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4h41.3c6.5 0 11.7 5.3 11.7 11.7c0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9v9.5c0 8.8 7.2 16 16 16s16-7.2 16-16v-.3L247.4 152c13.6-7.8 22-22.3 22-37.9c0-24.2-19.6-43.7-43.7-43.7H184.3zM208 250.7a22.7 22.7 0 1 0 0-45.3 22.7 22.7 0 1 0 0 45.3z"]
};
var faBookBible = {
  prefix: 'fal',
  iconName: 'book-bible',
  icon: [448, 512, ["bible"], "f647", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM224 72h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H288v80c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V232H160c-17.7 0-32-14.3-32-32V168c0-17.7 14.3-32 32-32h32V104c0-17.7 14.3-32 32-32zm0 32v48c0 8.8-7.2 16-16 16H160v32h48c8.8 0 16 7.2 16 16v96h32V216c0-8.8 7.2-16 16-16h48V168H272c-8.8 0-16-7.2-16-16V104H224z"]
};
var faBible = faBookBible;
var faO = {
  prefix: 'fal',
  iconName: 'o',
  icon: [448, 512, [111], "4f", "M224 64a192 192 0 1 0 0 384 192 192 0 1 0 0-384zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"]
};
var faSuitcaseMedical = {
  prefix: 'fal',
  iconName: 'suitcase-medical',
  icon: [512, 512, ["medkit"], "f0fa", "M176 32H336c8.8 0 16 7.2 16 16V96H160V48c0-8.8 7.2-16 16-16zM128 48V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm256 80V448H128V128h16H368h16zM96 128V448H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H96zM416 448V128h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H416zM240 176c-17.7 0-32 14.3-32 32v32H176c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V336h32c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H304V208c0-17.7-14.3-32-32-32H240zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H288c-8.8 0-16 7.2-16 16v48H240V320c0-8.8-7.2-16-16-16H176V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208z"]
};
var faMedkit = faSuitcaseMedical;
var faBriefcaseArrowRight = {
  prefix: 'fal',
  iconName: 'briefcase-arrow-right',
  icon: [512, 512, [], "e2f2", "M176 32H336c8.8 0 16 7.2 16 16V96H160V48c0-8.8 7.2-16 16-16zM128 48V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm16 80H368h80c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h80zm155.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L329.4 272H144c-8.8 0-16 7.2-16 16s7.2 16 16 16H329.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"]
};
var faExpandWide = {
  prefix: 'fal',
  iconName: 'expand-wide',
  icon: [512, 512, [], "f320", "M144 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H32V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16H144zM0 304c0-8.8 7.2-16 16-16s16 7.2 16 16V416H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V304zM496 64c8.8 0 16 7.2 16 16V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V96H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496zM480 304c0-8.8 7.2-16 16-16s16 7.2 16 16V432c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H480V304z"]
};
var faClockElevenThirty = {
  prefix: 'fal',
  iconName: 'clock-eleven-thirty',
  icon: [512, 512, [], "e348", "M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V260.8l-61.3-92c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4l64 96c1.8 2.6 2.7 5.7 2.7 8.9V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faRv = {
  prefix: 'fal',
  iconName: 'rv',
  icon: [640, 512, [], "f7be", "M224 24c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v8H496c61.9 0 112 50.1 112 112v8c0 22.1-17.9 40-40 40H549.6L628 254.7c7.6 6.1 12 15.3 12 25V384c0 17.7-14.3 32-32 32H574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H400 254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.2L18.7 329.4C6.7 317.4 0 301.1 0 284.1V96C0 60.7 28.7 32 64 32H224V24zM64 64C46.3 64 32 78.3 32 96V284.1c0 8.5 3.4 16.6 9.4 22.6l73.6 73.6C129.6 363 151.5 352 176 352c26.2 0 49.4 12.6 64 32H384V176c0-8.8 7.2-16 16-16H568c4.4 0 8-3.6 8-8v-8c0-44.2-35.8-80-80-80H384 352V32H256V64H224 64zM176 384a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm320 0a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm-64 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h48V288H416v96h16zM416 192v64H578.4l-80-64H416zM128 224H288V160H128v64zM96 152c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24V152z"]
};
var faUserSecret = {
  prefix: 'fal',
  iconName: 'user-secret',
  icon: [448, 512, [128373], "f21b", "M169.1 37.7c-5.8 6.6-12 17.3-18.1 31.9c-6.1 14.5-11.3 31-15.5 47.2c24.4 6.4 54 11.2 88.6 11.2c33.4 0 63.3-5.2 88.3-12.1c-4.2-15.9-9.3-32-15.3-46.3c-6.1-14.6-12.4-25.3-18.1-31.9c-4-4.6-6.3-5.6-7-5.7c-4.8 0-7.3 .6-8.5 1c-1 .3-1.9 .8-3.6 1.8c-.1 .1-.4 .3-.7 .5C255.7 37.9 242.2 48 224 48s-31.7-10.1-35.1-12.7l0 0c-.3-.3-.6-.4-.7-.5c-1.6-1.1-2.5-1.5-3.6-1.8c-1.1-.4-3.6-1-8.5-1c-.6 .2-3 1.2-7 5.7zM272 0c34.2 0 57 54.9 70.8 106c.8-.3 1.6-.6 2.4-.9c14.8-5.7 26.5-11.4 34.3-15.7c3.9-2.1 6.9-3.9 8.9-5c1-.6 1.7-1 2.2-1.3l.5-.3 .1 0 0 0 0 0c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2L400 96c8.9 13.3 8.9 13.3 8.9 13.3l0 0 0 0-.1 0-.2 .1-.8 .5c-.7 .4-1.6 1-2.8 1.7c-2.4 1.4-5.8 3.5-10.3 5.8c-8.9 4.8-21.7 11.1-37.9 17.3C324.4 147.4 278.4 160 224 160c-58.3 0-104.3-12.5-135.9-25.1c-15.8-6.3-28-12.7-36.3-17.5c-4.2-2.4-7.4-4.5-9.6-6c-1.1-.7-2-1.3-2.6-1.8l-.7-.5-.2-.2-.1-.1 0 0 0 0s0 0 9.6-12.8l-9.6 12.8c-7.1-5.3-8.5-15.3-3.2-22.4c5.3-7.1 15.3-8.5 22.4-3.2l.1 0 .4 .3c.4 .3 1 .7 1.8 1.3c1.7 1.1 4.4 2.8 7.9 4.9c7.2 4.2 18 9.8 32.2 15.5c1.6 .6 3.3 1.3 5 1.9C118.7 55.7 141.5 0 176 0c18 0 25.9 5.4 32.5 9.9c4.7 3.3 8.8 6.1 15.5 6.1s10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0zm-.3 32a.1 .1 0 1 0 .1 .1 .1 .1 0 1 0 -.1-.1zm-95.6 0a.1 .1 0 1 0 .3 .1 .1 .1 0 1 0 -.3-.1zM100 224c-2.6-10.2-4-21-4-32c0-6.7 .5-13.3 1.5-19.7c9.6 3.1 19.9 6.1 31.1 8.8c-.4 3.6-.6 7.2-.6 10.9c0 53 43 96 96 96s96-43 96-96c0-4-.2-7.9-.7-11.7c11.1-2.8 21.5-5.8 31-9c1.1 6.8 1.7 13.7 1.7 20.8c0 11-1.4 21.8-4 32h71.2c7.1 0 12.8 5.7 12.8 12.8c0 2.1-.5 4.1-1.5 6l-45.7 86.8C423.6 364.8 448 415.5 448 472v8c0 17.7-14.3 32-32 32H272.4c-.2 0-.5 0-.7 0H176.4c-.2 0-.5 0-.7 0H32c-17.7 0-32-14.3-32-32v-8c0-56.5 24.4-107.2 63.2-142.4L17.5 242.8c-1-1.8-1.5-3.9-1.5-6c0-7.1 5.7-12.8 12.8-12.8H100zm234.8 32c-22.1 38.3-63.5 64-110.9 64s-88.7-25.7-110.9-64H60.6l30.9 58.7c6.8 12.9 4 28.8-6.8 38.6C52.3 382.7 32 424.9 32 472l0 8H154.8l-26.2-91.6c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l20.3 70.9L201.8 384H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-9.8l22.2 66.5 20.3-70.9c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8L293.2 480H416v-8c0-47.1-20.3-89.3-52.7-118.6c-10.8-9.8-13.6-25.7-6.8-38.6L387.4 256H334.9zM203.5 480h40.9L224 418.6 203.5 480zM144 184.4c10.1 2 20.8 3.6 32 4.9V198c0 7 5.7 12.7 12.7 12.7c5.5 0 10.3-3.5 12-8.7l3.5-10.5c6.5 .3 13.1 .5 19.8 .5c6.7 0 13.3-.2 19.8-.5l3.5 10.5c1.7 5.2 6.6 8.7 12 8.7c7 0 12.7-5.7 12.7-12.7v-9c11.2-1.4 21.8-3.2 32-5.3V198c0 24.7-20 44.7-44.7 44.7c-14.1 0-27-6.6-35.3-17.3c-8.3 10.7-21.2 17.3-35.3 17.3c-24.7 0-44.7-20-44.7-44.7V184.4z"]
};
var faOtter = {
  prefix: 'fal',
  iconName: 'otter',
  icon: [640, 512, [129446], "f700", "M145.7 211.4l-12.9 6.4c-8.1 4.1-17.1 6.2-26.2 6.2C74.2 224 48 197.8 48 165.4V144c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80v21.4c0 32.4-26.2 58.6-58.6 58.6c-9.1 0-18.1-2.1-26.2-6.2l-12.9-6.4c-9-4.5-19.6-4.5-28.6 0zM16 144v21.4c0 19.1 5.9 36.8 16 51.4V240v16.6C32 380 132 480 255.4 480H414.9C539.2 480 640 379.2 640 254.9c0-90.7-64-168.8-153-186.6l-19.9-4c-8.3-1.7-16.4 3.4-18.6 11.6s2.4 16.6 10.4 19.3l21.6 7.2c37.9 12.6 63.4 48.1 63.4 88c0 16.4-6 31.4-16 42.9V192c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80v0H359.9l.1 0h8c26.5 0 48-21.5 48-48s-21.5-48-48-48h-8c-20.9 0-40.4 6.2-56.7 16.8c.5-3.7 .7-7.6 .7-11.4V144c0-5.4-.4-10.8-1.1-16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H293.2c-18-37.8-56.5-64-101.2-64H128C83.3 32 44.8 58.2 26.8 96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h1.1c-.7 5.2-1.1 10.6-1.1 16zm96 144c-24.6 0-44.9-18.6-47.7-42.5c12.6 6.7 27 10.5 42.3 10.5c14.1 0 27.9-3.3 40.5-9.6L160 240l12.9 6.4c12.6 6.3 26.5 9.6 40.5 9.6c16.7 0 32.3-4.5 45.7-12.3c8.3 25.7 32.4 44.3 60.9 44.3h56.4c-15.2 17-24.4 39.4-24.4 64H269.3c1.8-5 2.7-10.4 2.7-16c0-26.5-21.5-48-48-48H112zm207.8-32c-11.8-.1-22.2-6.6-27.6-16.2c9.9-27.9 36.6-47.8 67.8-47.8h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8c-19.4 0-35.5 13.7-39.2 32h-1zM528 333.7V274.5c28.7-17 48-48.3 48-84.1c0-13.3-2.1-26.3-6.1-38.5c23.9 27.9 38.1 64 38.1 103C608 361.5 521.5 448 414.9 448H255.4c-87.6 0-161.4-58.9-184.2-139.2C83.1 315.9 97.1 320 112 320H224c8.8 0 16 7.2 16 16s-7.2 16-16 16H208 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 16H368c8.8 0 16-7.2 16-16V352c0-35.3 28.5-63.9 63.7-64h.3v0c8.8 0 16-7.2 16-16V256c0-20.9 13.4-38.7 32-45.3v123c0 16.1-8 31-21.4 39.9l-19.5 13c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l19.5-13c22.3-14.8 35.6-39.8 35.6-66.6zM112 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm112 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-72-16c-13.3 0-24 10.7-24 24v8c0 6.1 3.4 11.6 8.8 14.3l16 8c4.5 2.3 9.8 2.3 14.3 0l16-8c5.4-2.7 8.8-8.3 8.8-14.3v-8c0-13.3-10.7-24-24-24H152z"]
};
var faDreidel = {
  prefix: 'fal',
  iconName: 'dreidel',
  icon: [448, 512, [], "f792", "M443.3 36.7c6.2 6.2 6.2 16.4 0 22.6L321.9 180.7l73.4 73.4c18.7 18.7 18.7 49.1 0 67.9L256 461.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V269.3c0-17 6.7-33.3 18.7-45.3L158.1 84.7c18.7-18.7 49.1-18.7 67.9 0l73.4 73.4L420.7 36.7c6.2-6.2 16.4-6.2 22.6 0zm-240 70.6c-6.2-6.2-16.4-6.2-22.6 0l-57.4 57.4 192 192 57.4-57.4c6.2-6.2 6.2-16.4 0-22.6L203.3 107.3zm89.4 272l-192-192L41.4 246.6c-6 6-9.4 14.1-9.4 22.6V416c0 17.7 14.3 32 32 32H210.7c8.5 0 16.6-3.4 22.6-9.4l59.3-59.3z"]
};
var faPersonDress = {
  prefix: 'fal',
  iconName: 'person-dress',
  icon: [320, 512, ["female"], "f182", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM119.2 241.7c7.9 4 11.1 13.6 7.2 21.5L73.9 368H112h96 38.1L193.7 263.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l64 128c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6H224v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H128v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H48c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l64-128c4-7.9 13.6-11.1 21.5-7.2zM99 196.6L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l52.9-98.9C88.3 148.6 122.7 128 160 128s71.7 20.6 89.3 53.5l52.9 98.9c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L221 196.6c-12-22.5-35.5-36.6-61-36.6s-49 14.1-61 36.6z"]
};
var faFemale = faPersonDress;
var faCommentDollar = {
  prefix: 'fal',
  iconName: 'comment-dollar',
  icon: [512, 512, [], "f651", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 104c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V344c0 8.8 7.2 16 16 16s16-7.2 16-16V326.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V136z"]
};
var faBusinessTime = {
  prefix: 'fal',
  iconName: 'business-time',
  icon: [640, 512, ["briefcase-clock"], "f64a", "M160 48V96H352V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM128 96V48c0-26.5 21.5-48 48-48H336c26.5 0 48 21.5 48 48V96h64c35.3 0 64 28.7 64 64v32.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V160c0-17.7-14.3-32-32-32H368 144 64c-17.7 0-32 14.3-32 32v96H176h32H352h8.2c-8.1 9.8-15.2 20.6-21 32H208v48H322.9c-1.9 10.4-2.9 21.1-2.9 32H208c-17.7 0-32-14.3-32-32V288H32V416c0 17.7 14.3 32 32 32H339.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faBriefcaseClock = faBusinessTime;
var faFlowerTulip = {
  prefix: 'fal',
  iconName: 'flower-tulip',
  icon: [512, 512, [127799], "f801", "M268 5.4C264.9 2 260.6 0 256 0s-8.9 2-12 5.4L189.5 66.7 121.2 18.9c-4.9-3.4-11.3-3.8-16.6-1.1S96 26 96 32V160c0 70.7 57.3 128 128 128h16V396.6C200.8 331.5 129.5 288 48 288H28c-15.5 0-28 12.5-28 28C0 424.2 87.8 512 196 512h44 16 16 44c108.2 0 196-87.8 196-196c0-15.5-12.5-28-28-28H464c-81.5 0-152.8 43.5-192 108.6V288h16c70.7 0 128-57.3 128-128V32c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L322.5 66.7 268 5.4zM256 256H224c-53 0-96-43-96-96V62.7l54.8 38.4c6.7 4.7 15.7 3.6 21.1-2.5l52-58.5 52 58.5c5.4 6.1 14.5 7.1 21.1 2.5L384 62.7V160c0 53-43 96-96 96H256zM196 480c-89.2 0-161.8-71.3-164-160H48c95.1 0 174.1 69.2 189.3 160H196zm120 0H274.7c15.2-90.8 94.2-160 189.3-160h16c-2.1 88.7-74.7 160-164 160z"]
};
var faPeoplePantsSimple = {
  prefix: 'fal',
  iconName: 'people-pants-simple',
  icon: [512, 512, [], "e21a", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320h84.9c18.7 0 33.4-16 31.9-34.7L198.2 236c-2.1-24.9-22.9-44-47.8-44H105.6c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM416 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm-6.2 172l-4.1 49.3C308.1 304 322.8 320 341.6 320h84.9c18.7 0 33.4-16 31.9-34.7L454.2 236c-2.1-24.9-22.9-44-47.8-44H361.6c-25 0-45.8 19.1-47.8 44zm-31.9-2.7c3.5-41.5 38.1-73.4 79.7-73.4h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H352V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z"]
};
var faCloudDrizzle = {
  prefix: 'fal',
  iconName: 'cloud-drizzle',
  icon: [512, 512, [], "f738", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM64 376c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16V376zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16V376zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16V376zM160 448c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448z"]
};
var faTableCellsLarge = {
  prefix: 'fal',
  iconName: 'table-cells-large',
  icon: [512, 512, ["th-large"], "f009", "M272 64V240H480V96c0-17.7-14.3-32-32-32H272zm-32 0H64C46.3 64 32 78.3 32 96V240H240V64zM32 272V416c0 17.7 14.3 32 32 32H240V272H32zM272 448H448c17.7 0 32-14.3 32-32V272H272V448zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faThLarge = faTableCellsLarge;
var faBookTanakh = {
  prefix: 'fal',
  iconName: 'book-tanakh',
  icon: [448, 512, ["tanakh"], "f827", "M384 0c35.3 0 64 28.7 64 64l0 384 0 0c0 35.3-28.7 64-64 64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V413.3C13.4 406.7 0 388.9 0 368V48C0 21.5 21.5 0 48 0H384zM64 416v64H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm320-32c11.7 0 22.6 3.1 32 8.6L416 64c0-17.7-14.3-32-32-32H48c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H384zM146.7 232l-13.9 24h27.7l-13.9-24zm-13.9-24l-27.7-48c-6.2-10.7 1.5-24 13.9-24h55.4l27.7-48c6.2-10.7 21.6-10.7 27.7 0l27.7 48H313c12.3 0 20 13.3 13.9 24l-27.7 48 27.7 48c6.2 10.7-1.5 24-13.9 24H257.6l-27.7 48c-6.2 10.7-21.6 10.7-27.7 0l-27.7-48H119c-12.3 0-20-13.3-13.9-24l27.7-48zm27.7 0l27.7 48h55.4l27.7-48-27.7-48H188.3l-27.7 48zm0-48H132.9l13.9 24 13.9-24zm41.6-24h27.7L216 112l-13.9 24zm69.3 24l13.9 24 13.9-24H271.4zm13.9 72l-13.9 24h27.7l-13.9-24zm-55.4 48H202.1L216 304l13.9-24z"]
};
var faTanakh = faBookTanakh;
var faSolarSystem = {
  prefix: 'fal',
  iconName: 'solar-system',
  icon: [512, 512, [], "e02f", "M32 256c0 123.7 100.3 224 224 224c31.4 0 61.4-6.5 88.5-18.2c4.2 8.8 9.9 17.1 17.3 24.4c.7 .7 1.4 1.4 2.1 2C331.1 503.5 294.5 512 256 512C114.6 512 0 397.4 0 256c0-50.9 14.9-98.4 40.5-138.3C35.1 109.1 32 98.9 32 88c0-30.9 25.1-56 56-56c10.9 0 21.1 3.1 29.7 8.5c3.5 2.2 6.8 4.8 9.7 7.7l0 0 .2 .2L139 64.9c-2.8-6.1-6.6-11.7-11.3-16.4l0 0c4.9 4.9 8.6 10.5 11.3 16.4l0 0c3.2 7 5 14.8 5 23.1c0 30.9-25.1 56-56 56c-8.2 0-16-1.8-23.1-5C44 173.1 32 213.1 32 256zM394.3 471.5l0 0c-3.5-2.2-6.8-4.8-9.9-7.9l-.1-.1c-4.9-4.9-8.6-10.5-11.3-16.4l0 0c-3.2-7-5-14.9-5-23.1c0-30.9 25.1-56 56-56c8.2 0 16 1.8 23.1 5c20.9-34 32.9-74.1 32.9-117C480 132.3 379.7 32 256 32c-31.4 0-61.4 6.5-88.5 18.2c-4.2-8.8-10-17.1-17.3-24.4c-.7-.7-1.4-1.4-2.1-2C180.9 8.5 217.5 0 256 0C397.4 0 512 114.6 512 256c0 50.9-14.9 98.4-40.5 138.3c5.4 8.6 8.5 18.8 8.5 29.7c0 30.9-25.1 56-56 56c-10.9 0-21.1-3.1-29.7-8.5zM112 88A24 24 0 1 0 64 88a24 24 0 1 0 48 0zM365.5 189.7c-4.2 1.5-8.8 2.3-13.5 2.3c-22.1 0-40-17.9-40-40c0-3.6 .5-7.1 1.4-10.4C296.1 132.9 276.6 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128c0-24.3-6.8-47-18.5-66.3zM389 167.1c17 25.4 27 56 27 88.9c0 88.4-71.6 160-160 160s-160-71.6-160-160s71.6-160 160-160c28.3 0 54.9 7.4 78 20.3c5.4-2.7 11.5-4.3 18-4.3c22.1 0 40 17.9 40 40c0 5.3-1 10.4-3 15.1zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM424 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSealQuestion = {
  prefix: 'fal',
  iconName: 'seal-question',
  icon: [512, 512, [], "e243", "M176 96c8.5 0 16.6-3.4 22.6-9.4l46.1-46.1c6.2-6.2 16.4-6.2 22.6 0l46.1 46.1c6 6 14.1 9.4 22.6 9.4h64c8.8 0 16 7.2 16 16v64c0 8.5 3.4 16.6 9.4 22.6L471 244.2c6.2 6.2 6.2 16.4 0 22.6l-45.6 45.6c-6 6-9.4 14.1-9.4 22.6V400c0 8.8-7.2 16-16 16H335.1c-8.5 0-16.6 3.4-22.6 9.4l-45.1 45.1c-6.2 6.2-16.4 6.2-22.6 0l-45.1-45.1c-6-6-14.1-9.4-22.6-9.4H112c-8.8 0-16-7.2-16-16V335.1c0-8.5-3.4-16.6-9.4-22.6L41 266.8 18.4 289.5 41 266.8c-6.2-6.2-6.2-16.4 0-22.6l45.6-45.6c6-6 9.4-14.1 9.4-22.6V112c0-8.8 7.2-16 16-16h64zM18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1V400c0 26.5 21.5 48 48 48h64.9l45.1 45.1c18.7 18.7 49.1 18.7 67.9 0L335.1 448H400c26.5 0 48-21.5 48-48V335.1l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176V112c0-26.5-21.5-48-48-48H336L289.9 17.9c-18.7-18.7-49.1-18.7-67.9 0L176 64H112c-26.5 0-48 21.5-48 48v64L18.4 221.6zm150.3-51.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V288c0 8.8 7.2 16 16 16s16-7.2 16-16V268.3l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3H222.9c-25.5 0-47.7 17.2-54.2 41.8zM280 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faPhoneVolume = {
  prefix: 'fal',
  iconName: 'phone-volume',
  icon: [512, 512, ["volume-control-phone"], "f2a0", "M272 0C404.5 0 512 107.5 512 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-80c0-8.8 7.2-16 16-16c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112c-8.8 0-16-7.2-16-16zm73 174.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faVolumeControlPhone = faPhoneVolume;
var faDiscDrive = {
  prefix: 'fal',
  iconName: 'disc-drive',
  icon: [512, 512, [], "f8b5", "M96 64H416c17.7 0 32 14.3 32 32V448H64V96c0-17.7 14.3-32 32-32zM480 448V96c0-35.3-28.7-64-64-64H96C60.7 32 32 60.7 32 96V448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48 464h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H480zM256 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zM96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faHatCowboySide = {
  prefix: 'fal',
  iconName: 'hat-cowboy-side',
  icon: [640, 512, [], "f8c1", "M416.6 64.2L195.1 107c-7.1 1.4-12.4 7.3-12.9 14.6l-5 70.6c36.3 1.7 71.2 15.2 99.4 38.4L307.5 256H462.7L428.2 72.1c-.9-4.7-5-8.1-9.8-8.1c-.6 0-1.3 .1-1.9 .2zM145 193.7l5.3-74.4c1.5-21.7 17.4-39.6 38.8-43.7L410.5 32.8c2.6-.5 5.3-.8 8-.8c20.2 0 37.5 14.4 41.2 34.2l25 133.5c3.4 1.6 7.2 3.4 11.4 5.5c15.5 7.7 36.2 19.1 57 33.7c20.7 14.5 42.2 32.6 58.5 53.9C628.1 314 640 339.4 640 368c0 44.2-35.8 80-80 80H512.3c-.2 0-.4 0-.6 0H496 464 60.8C27.2 448 0 420.8 0 387.2V361.1c0-85.2 63-155.7 145-167.4zM525.3 416H560c26.5 0 48-21.5 48-48c0-19.4-8.1-38-21.7-55.7c-13.7-17.7-32.2-33.7-51.5-47.1c-14.9-10.5-29.9-19.2-42.7-26L525.3 416zm-34.2-8.8L468.7 288H346.3L491.1 407.2zM32 361.1v26.1C32 403.1 44.9 416 60.8 416H451.4L256.2 255.3c-24.5-20.2-55.3-31.3-87.1-31.3C93.4 224 32 285.4 32 361.1z"]
};
var faTableRows = {
  prefix: 'fal',
  iconName: 'table-rows',
  icon: [512, 512, ["rows"], "e292", "M32 96c0-17.7 14.3-32 32-32l64 0 0 176 0 32 0 176-64 0c-17.7 0-32-14.3-32-32L32 96zM160 272l320 0 0 144c0 17.7-14.3 32-32 32l-288 0 0-176zm320-32l-320 0 0-176 288 0c17.7 0 32 14.3 32 32l0 144zM0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416z"]
};
var faRows = faTableRows;
var faLocationExclamation = {
  prefix: 'fal',
  iconName: 'location-exclamation',
  icon: [384, 512, ["map-marker-exclamation"], "f608", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 96c8.8 0 16 7.2 16 16V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM168 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faMapMarkerExclamation = faLocationExclamation;
var faFaceFearful = {
  prefix: 'fal',
  iconName: 'face-fearful',
  icon: [512, 512, [], "e375", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.8 48h8.4c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2H180.2c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zm8.4 32h-8.4c-29 0-53.2 20.6-58.6 48H318.8c-5.5-27.4-29.6-48-58.6-48zM136.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM176 112c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm173 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8zM160 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48A80 80 0 1 1 80 224a80 80 0 1 1 160 0zm64 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
var faClipboardUser = {
  prefix: 'fal',
  iconName: 'clipboard-user',
  icon: [384, 512, [], "f7f3", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM192 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 64h64c26.5 0 48 21.5 48 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80H160c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 21.5-48 48-48z"]
};
var faBusSchool = {
  prefix: 'fal',
  iconName: 'bus-school',
  icon: [512, 512, [], "f5dd", "M256 32c105.1 0 146.3 31.1 158.8 47c.4 .6 1.2 2.1 1.2 5.3V128H96V84.3c0-3.3 .8-4.5 1-4.8C110.9 63.2 158.3 32 256 32zM96 245.5V160H240v80H128c-11.2 0-22 1.9-32 5.5zM272 240V160H416v85.5c-10-3.5-20.8-5.5-32-5.5H272zm176 24.4V84.3c0-7.7-1.8-17.1-8.1-25.1C419.2 32.9 366.9 0 256 0C152.4 0 94.5 33 72.6 58.8C65.8 66.9 64 76.6 64 84.3V264.4C44.4 282 32 307.6 32 336v56c0 22.3 13.1 41.6 32 50.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V448H416v48c0 8.8 7.2 16 16 16s16-7.2 16-16V442.6c18.9-9 32-28.3 32-50.6V336c0-28.4-12.4-54-32-71.6zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm256 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM64 336c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64v56c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V336zM192 80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM32 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm480 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"]
};
var faFilmSlash = {
  prefix: 'fal',
  iconName: 'film-slash',
  icon: [640, 512, [], "e179", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.4 480L448 438.6V448H192V352 256 240H160 96V176 160.7L64 135.4V416c0 35.3 28.7 64 64 64H500.4zM139.6 32L192 73.4V64H448v96 96 16h32 64v64 15.3l32 25.3V96c0-35.3-28.7-64-64-64H139.6zM160 448H128c-17.7 0-32-14.3-32-32V368h64v80zM96 272h64v64H96V272zm384-96h64v64H480V176zm0-32V64h32c17.7 0 32 14.3 32 32v48H480z"]
};
var faSquareArrowDownRight = {
  prefix: 'fal',
  iconName: 'square-arrow-down-right',
  icon: [448, 512, [], "e262", "M384 448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384zm64-32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416zM168 352c-8.8 0-16-7.2-16-16s7.2-16 16-16h97.4L132.7 187.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 297.4V192c0-8.8 7.2-16 16-16s16 7.2 16 16V336c0 8.8-7.2 16-16 16H168z"]
};
var faBookSparkles = {
  prefix: 'fal',
  iconName: 'book-sparkles',
  icon: [448, 512, ["book-spells"], "f6b8", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V413.3c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zM384 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H384zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H64zM265.9 170.9l-16.5 38.6-38.6 16.5c-19.4 8.3-19.4 35.8 0 44.1l38.6 16.5 16.5 38.6c8.3 19.4 35.8 19.4 44.1 0l16.5-38.6 38.6-16.5c19.4-8.3 19.4-35.8 0-44.1l-38.6-16.5-16.5-38.6c-8.3-19.4-35.8-19.4-44.1 0zM288 200.6l11.7 27.3c1.6 3.8 4.6 6.8 8.4 8.4L335.4 248l-27.3 11.7c-3.8 1.6-6.8 4.6-8.4 8.4L288 295.4l-11.7-27.3c-1.6-3.8-4.6-6.8-8.4-8.4L240.6 248l27.3-11.7c3.8-1.6 6.8-4.6 8.4-8.4L288 200.6zM153 121.8l7-14 7 14c1.5 3.1 4.1 5.6 7.2 7.2l14 7-14 7c-3.1 1.5-5.6 4.1-7.2 7.2l-7 14-7-14c-1.5-3.1-4.1-5.6-7.2-7.2l-14-7 14-7c3.1-1.5 5.6-4.1 7.2-7.2zm28.5-42.7c-8.8-17.7-34.1-17.7-42.9 0l-11.8 23.6-23.6 11.8c-17.7 8.8-17.7 34.1 0 42.9l23.6 11.8 11.8 23.6c8.8 17.7 34.1 17.7 42.9 0l11.8-23.6 23.6-11.8c17.7-8.8 17.7-34.1 0-42.9l-23.6-11.8L181.5 79.2z"]
};
var faBookSpells = faBookSparkles;
var faWashingMachine = {
  prefix: 'fal',
  iconName: 'washing-machine',
  icon: [448, 512, ["washer"], "f898", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM325.7 351c-7 .7-14.3 1-21.7 1c-41.8 0-72.9-20.8-95.7-36l-2.1-1.4c-25-16.7-41.3-26.6-62.2-26.6c-9.8 0-20.6 1.6-31.4 4c-.4 3.9-.6 7.9-.6 12c0 61.9 50.1 112 112 112c45.1 0 84-26.6 101.7-65zm9.5-33.4c.5-4.4 .8-8.9 .8-13.5c0-61.9-50.1-112-112-112c-45.3 0-84.4 27-102 65.7c7.4-1.1 14.8-1.7 22-1.7c32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5zM80 304a144 144 0 1 1 288 0A144 144 0 1 1 80 304z"]
};
var faWasher = faWashingMachine;
var faChild = {
  prefix: 'fal',
  iconName: 'child',
  icon: [320, 512, [], "f1ae", "M128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM73.9 240.2c1.9-3.1 3.9-6 6.1-8.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384h96V496c0 8.8 7.2 16 16 16s16-7.2 16-16V231.3c2.2 2.8 4.2 5.8 6.1 8.9l44.3 72.2c4.6 7.5 14.5 9.9 22 5.3s9.9-14.5 5.3-22l-44.3-72.2C249.2 184 206.3 160 160 160s-89.2 24-113.4 63.5L2.4 295.6c-4.6 7.5-2.3 17.4 5.3 22s17.4 2.3 22-5.3l44.3-72.2zM208 352H112V204.1c14.5-7.8 31-12.1 48-12.1s33.5 4.3 48 12.1V352z"]
};
var faLiraSign = {
  prefix: 'fal',
  iconName: 'lira-sign',
  icon: [320, 512, [8356], "f195", "M80 152c0-48.6 39.4-88 88-88h7.1c9.5 0 18.9 1.5 27.8 4.5l80 26.7c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-80-26.7c-12.2-4.1-25-6.2-37.9-6.2H168C101.7 32 48 85.7 48 152v72H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48v22.1c0 14-.8 28-2.4 41.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H40.5c-7.3 35.6-19.9 70.1-37.4 102.3l-1.1 2c-2.7 5-2.6 11 .3 15.8S10.4 480 16 480H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H42.1c14.4-30.6 24.8-62.9 31-96H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H77.8c1.5-13.9 2.2-27.9 2.2-41.9V256H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H80V152z"]
};
var faUserVisor = {
  prefix: 'fal',
  iconName: 'user-visor',
  icon: [448, 512, [], "e04c", "M224 224c41.8 0 77.4-26.7 90.5-64H133.5c13.2 37.3 48.7 64 90.5 64zm0 32c-60.6 0-111.3-42.1-124.6-98.6C88 152.5 80 141.2 80 128V96c0-17.7 14.3-32 32-32h1.1C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64H336c17.7 0 32 14.3 32 32v32c0 13.2-8 24.5-19.4 29.4C335.3 213.9 284.6 256 224 256zM152.4 64H295.6C278 44.4 252.4 32 224 32s-54 12.4-71.6 32zm25.8 272c-80 0-145 64.3-146.3 144H416c-1.2-79.7-66.2-144-146.3-144H178.3zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM336 96H112v32H336V96zm-7.1 341.4c-9.5 0-22.5 11.4-31.7 19.5c-2.6 2.2-4.8 4.2-6.6 5.6c-2.8 2-6.8 .1-6.5-3.5c3.9-36.5 15.9-66.5 35.7-89.5c1.5-1.8 4.9-1.9 6.1 .1c18.9 24.6 29 55 30.1 90.2c0 3.9-4.9 5.7-7.3 2.5c-12.2-17.3-17.6-23-19.9-25z"]
};
var faFilePlusMinus = {
  prefix: 'fal',
  iconName: 'file-plus-minus',
  icon: [384, 512, [], "e177", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V240zM128 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
};
var faChessClockFlip = {
  prefix: 'fal',
  iconName: 'chess-clock-flip',
  icon: [640, 512, ["chess-clock-alt"], "f43e", "M400 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H480V64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H464 400zM96 80c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm480 80c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H576zM464 224a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM119.4 247.4A80 80 0 1 1 232.6 360.6 80 80 0 1 1 119.4 247.4zM255.2 383.2A112 112 0 1 0 96.8 224.8 112 112 0 1 0 255.2 383.2zM464 240c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-8.8-7.2-16-16-16zM221.3 281.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9z"]
};
var faChessClockAlt = faChessClockFlip;
var faSatellite = {
  prefix: 'fal',
  iconName: 'satellite',
  icon: [512, 512, [128752], "f7bf", "M224 35.3l62.3 62.3L185.7 198.3 123.3 136 224 35.3zM309 75L241 7c-9.4-9.4-24.6-9.4-33.9 0L95 119c-9.4 9.4-9.4 24.6 0 33.9l47.6 47.6c-45.3-3.8-92 10.2-128.7 42.3c-3.8 3.3-5.9 8-5.9 13v.5c0 4.9 1.9 9.6 5.4 13L116.7 372.7l-16 16c-6.3-3-13.3-4.7-20.7-4.7c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-7.4-1.7-14.4-4.7-20.7l16-16L242.6 498.6c3.5 3.5 8.1 5.4 13 5.4h.5c5 0 9.8-2.2 13-5.9c32.1-36.7 46.1-83.3 42.3-128.7L359 417c9.4 9.4 24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9l-68-68L463 177c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L417 49c-10.9-10.9-25.6-17-41-17s-30.1 6.1-41 17L309 75zM414.3 225.7L476.7 288 376 388.7l-62.3-62.3L414.3 225.7zm26.1-71.3L292 302.8c-7.9-14.9-18.1-28.9-30.7-41.5l-10.6-10.6c-12.5-12.5-26.5-22.8-41.5-30.7L357.7 71.6c4.9-4.9 11.5-7.6 18.3-7.6s13.5 2.7 18.3 7.6l46.1 46.1c4.9 4.9 7.6 11.5 7.6 18.3s-2.7 13.5-7.6 18.3zM238.7 283.9c49 49 54.8 125.7 15.7 181.2L46.8 257.6c55.5-39.1 132.2-33.3 181.2 15.7l10.6 10.6zM80 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPlaneLock = {
  prefix: 'fal',
  iconName: 'plane-lock',
  icon: [640, 512, [], "e558", "M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2l0 0L256 480.6l105.7 30.2 0 0c2.1 .6 4.2 1 6.3 1.1V479.4L260.4 448.6c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8V290.6c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7c0 5.7 3.1 11 8.1 13.9l106.9 61.1c2.5-10.7 6.5-20.8 11.9-30.1L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zm80 376V338.9l48 13.7V352c0-11 2.8-21.4 7.7-30.4l-67.3-19.2c-4.8-1.4-10-.4-14 2.6s-6.4 7.8-6.4 12.8V384c0 5 2.4 9.8 6.4 12.8L368 440V400l-32-24zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faSteeringWheel = {
  prefix: 'fal',
  iconName: 'steering-wheel',
  icon: [512, 512, [], "f622", "M240 384v95.4C134.4 472 49.1 391.4 34.3 288H140.4c2.2 4.2 5.1 8.1 8.6 11.6l73.1 73.1c5.2 5.2 11.4 9 17.9 11.3zm32 0c6.6-2.3 12.7-6.1 17.9-11.3L363 299.6c3.5-3.5 6.3-7.4 8.6-11.6H477.7C462.9 391.4 377.6 472 272 479.4V384zM376.1 256c-.8-4-2.2-8-4.1-11.8l-12.8-25.7C351 202.3 334.4 192 316.2 192H195.8c-18.2 0-34.8 10.3-42.9 26.5L140 244.2c-1.9 3.8-3.3 7.8-4.1 11.8H32C32 132.3 132.3 32 256 32s224 100.3 224 224H376.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM181.5 232.8c2.7-5.4 8.3-8.8 14.3-8.8H316.2c6.1 0 11.6 3.4 14.3 8.8l12.8 25.7c3.1 6.2 1.9 13.6-3 18.5l-73.1 73.1c-6.2 6.2-16.4 6.2-22.6 0L171.6 277c-4.9-4.9-6.1-12.3-3-18.5l12.8-25.7z"]
};
var faTag = {
  prefix: 'fal',
  iconName: 'tag',
  icon: [448, 512, [127991], "f02b", "M32 229.5V80c0-8.8 7.2-16 16-16H197.5c8.5 0 16.6 3.4 22.6 9.4l176 176c12.5 12.5 12.5 32.8 0 45.3L262.6 428.1c-12.5 12.5-32.8 12.5-45.3 0l-176-176L18.7 274.7l22.6-22.6c-6-6-9.4-14.1-9.4-22.6zm-32 0c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80V229.5zM112 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faStretcher = {
  prefix: 'fal',
  iconName: 'stretcher',
  icon: [640, 512, [], "f825", "M27.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L145.9 232.6c15 15 35.4 23.4 56.6 23.4H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H528.2h-.4H208.2h-.4-5.3c-12.7 0-24.9-5.1-33.9-14.1L27.3 68.7zM224 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-8.8-1.8-17.3-5-24.9l53-40.6 53 40.6c-3.2 7.7-5 16.1-5 24.9c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-14.9 0-28.6 5.1-39.5 13.6l-46.2-35.3L491.6 288H438.9L368 342.2 297.1 288H244.4l97.2 74.4-46.2 35.3C284.6 389.1 270.9 384 256 384c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBookSection = {
  prefix: 'fal',
  iconName: 'book-section',
  icon: [448, 512, ["book-law"], "e0c1", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM224.7 254.1c-20.7-5.5-63.7-17-55.7-58.8c2-10.5 7.5-19.2 15.6-25.8c-11.5-8.8-19.4-21.7-15.6-41.7c5.7-29.8 37.9-45 82-38.7c7.8 1.1 16.8 3.3 28.3 6.9c7.9 2.5 12.3 10.9 9.9 18.8c-2.5 7.9-11 12.3-18.8 9.9c-9.9-3.1-17.5-4.9-23.6-5.8c-26.1-3.8-46 2.3-48.4 14.7c-1.7 8.7-.2 15.1 34 24.1l6.8 1.8 0 0c28.2 7.3 70.9 18.3 62.8 60.6c-2 10.5-7.5 19.2-15.6 25.9c11.8 8.9 19.4 21.7 15.6 41.6c-4.8 25.3-28.9 40.2-63.1 40.2c-6 0-12.3-.5-18.9-1.4c-12.1-1.7-24.9-5.8-36.1-9.5l-5.4-1.8c-7.9-2.5-12.2-11-9.7-18.8c2.5-7.9 11-12.3 18.9-9.7l5.5 1.8c10.1 3.3 21.5 7 31 8.3c26.3 3.7 46.1-2.3 48.4-14.7c2.3-11.9-5.4-16.8-40.9-26l-7-1.8zM222 185.9c-8.1 1.1-21.6 4.5-23.6 15.1c-1.7 8.7-.2 15.1 34 24.1c0 0 13.2 3.5 16.6 4.4c8.2-1.1 21.6-4.5 23.6-15c2.3-11.9-5.4-16.8-40.9-26c0 0-8.8-2.3-9.7-2.6z"]
};
var faBookLaw = faBookSection;
var faInboxes = {
  prefix: 'fal',
  iconName: 'inboxes',
  icon: [512, 512, [], "e1bb", "M34.7 192l-1.4 3.4c-.8 2-1.2 4-1.2 6.2V272c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V201.6c0-2.1-.4-4.2-1.2-6.2l-1.4-3.4H403.8c-6.1 0-11.6 3.4-14.3 8.8l-14.3 28.6C367 245.7 350.4 256 332.2 256H179.8c-18.2 0-34.8-10.3-42.9-26.5l-14.3-28.6c-2.7-5.4-8.3-8.8-14.3-8.8H34.7zM48 160h60.2c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8H332.2c6.1 0 11.6-3.4 14.3-8.8l14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5H464L414.8 41.8l29-12.1-29 12.1c-2.5-6-8.3-9.8-14.8-9.8H112c-6.5 0-12.3 3.9-14.8 9.8L48 160zM3.7 183.1l64-153.6C75.1 11.7 92.6 0 112 0H400c19.4 0 36.9 11.7 44.3 29.5l64 153.6c2.4 5.8 3.7 12.1 3.7 18.5V272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V201.6c0-6.3 1.3-12.6 3.7-18.5zM114.3 384H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H397.7c-6.1 0-11.6 3.4-14.3 8.8L369 421.5l-28.6-14.3 14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48h66.3c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8H326.1c6.1 0 11.6-3.4 14.3-8.8L369 421.5c-8.1 16.3-24.8 26.5-42.9 26.5H185.9c-18.2 0-34.8-10.3-42.9-26.5l-14.3-28.6c-2.7-5.4-8.3-8.8-14.3-8.8z"]
};
var faCoffeeBean = {
  prefix: 'fal',
  iconName: 'coffee-bean',
  icon: [448, 512, [], "e13e", "M388.3 108.6c21.2 27.9 29.6 65.9 23.5 108.9c-7 49.3-33.2 102.9-78.3 148s-98.7 71.3-148 78.3c-40.4 5.8-76.5-1.4-103.8-19.8c.1-.1 .1-.3 .2-.4c16.5-34.5 37.5-72.2 57.4-92.3c29.7-29.9 59.7-44.9 91.8-61l.5-.3 0 0c32-15.9 66.1-32.9 99.7-66.8c22.8-22.9 42.6-61.6 56.9-94.7zM363.6 84.8c-.6 1.4-1.2 2.9-1.8 4.4c-14.5 34.5-33.5 71.8-53.1 91.5c-29.7 29.9-59.7 44.9-91.8 61l-.5 .3c-32 15.9-66.1 32.9-99.7 66.8c-22.2 22.4-43.4 59.9-59.5 92.6c-22.6-28.1-31.8-67.1-25.5-111.4c7-49.3 33.2-102.9 78.3-148s98.7-71.3 148-78.3c41.4-5.9 78.1 1.7 105.7 21.1zM390 64.7C313.6 2.4 181.6 25 87.3 119.3c-98.9 98.9-119 239.2-44.9 313.5c0 0 .1 .1 .1 .1c7.5 7.5 15.8 14.1 24.5 19.7c.4 .3 .8 .5 1.2 .8c77.8 48.6 199.4 23.2 287.8-65.3c99-99 119-239.4 44.8-313.6c-3.5-3.5-7.1-6.8-10.9-9.8z"]
};
var faCircleYen = {
  prefix: 'fal',
  iconName: 'circle-yen',
  icon: [512, 512, [], "e5d0", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM165.2 148.2c6.5-5.9 16.7-5.5 22.6 1.1l68.2 75 68.2-75c5.9-6.5 16.1-7 22.6-1.1s7 16.1 1.1 22.6L271 255.2h1v.8h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v17c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V288H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-.8h1l-76.8-84.5c-5.9-6.5-5.5-16.7 1.1-22.6z"]
};
var faBracketsCurly = {
  prefix: 'fal',
  iconName: 'brackets-curly',
  icon: [576, 512, [], "f7ea", "M144 32c-44.2 0-80 35.8-80 80v53.5c0 12.7-5.1 24.9-14.1 33.9L4.7 244.7c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l45.3 45.3c9 9 14.1 21.2 14.1 33.9V400c0 44.2 35.8 80 80 80h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-26.5 0-48-21.5-48-48V346.5c0-21.2-8.4-41.6-23.4-56.6L38.6 256l33.9-33.9c15-15 23.4-35.4 23.4-56.6V112c0-26.5 21.5-48 48-48h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm288 0H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c26.5 0 48 21.5 48 48v53.5c0 21.2 8.4 41.6 23.4 56.6L537.4 256l-33.9 33.9c-15 15-23.4 35.4-23.4 56.6V400c0 26.5-21.5 48-48 48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c44.2 0 80-35.8 80-80V346.5c0-12.7 5.1-24.9 14.1-33.9l45.3-45.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-45.3-45.3c-9-9-14.1-21.2-14.1-33.9V112c0-44.2-35.8-80-80-80z"]
};
var faEllipsisStrokeVertical = {
  prefix: 'fal',
  iconName: 'ellipsis-stroke-vertical',
  icon: [192, 512, ["ellipsis-v-alt"], "f39c", "M96 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96A64 64 0 1 1 96 32a64 64 0 1 1 0 128zm32 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 256zm96 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 416z"]
};
var faEllipsisVAlt = faEllipsisStrokeVertical;
var faComment = {
  prefix: 'fal',
  iconName: 'comment',
  icon: [512, 512, [128489, 61669], "f075", "M256 64C125.8 64 32 148.6 32 240c0 37.1 15.5 70.6 40 100c5.2 6.3 8.4 14.8 7.4 23.9c-3.1 27-11.4 52.5-25.7 76.3c-.5 .9-1.1 1.8-1.6 2.6c11.1-2.9 22.2-7 32.7-11.5L91.2 446l-6.4-14.7c17-7.4 33-16.7 48.4-27.4c8.5-5.9 19.4-7.5 29.2-4.2C193 410.1 224 416 256 416c130.2 0 224-84.6 224-176s-93.8-176-224-176zM0 240C0 125.2 114.5 32 256 32s256 93.2 256 208s-114.5 208-256 208c-36 0-70.5-6.7-103.8-17.9c-.2-.1-.5 0-.7 .1c-16.9 11.7-34.7 22.1-53.9 30.5C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.8s-1.1-12.8 3.4-17.4c8.1-8.2 15.2-18.2 21.7-29c11.7-19.6 18.7-40.6 21.3-63.1c0 0-.1-.1-.1-.2C19.6 327.1 0 286.6 0 240z"]
};
var faSquare1 = {
  prefix: 'fal',
  iconName: 'square-1',
  icon: [448, 512, [], "e256", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm168 98.2c-4.9-2.9-11-2.9-16-.1l-56 32c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6L208 171.6V352H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V144c0-5.7-3-11-8-13.8z"]
};
var faCakeCandles = {
  prefix: 'fal',
  iconName: 'cake-candles',
  icon: [448, 512, [127874, "birthday-cake", "cake"], "f1fd", "M82.5 70.9c-1.6 2.6-2.5 5.7-2.5 8.8C80 88.8 87.4 96 96 96s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L96 49.7 82.5 70.9zm-27-17.1L86.2 5.4C88.3 2 92 0 96 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26zM384 256H368v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H240v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H112v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H64c-17.7 0-32 14.3-32 32l0 80c13.3 0 26.1-6 36.3-13.1c2.2-1.5 4.7-3.9 7.4-6.4C81.9 342.7 89 336 96 336s14.1 6.7 20.3 12.5c2.7 2.5 5.2 4.9 7.4 6.4c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c2.2-1.5 4.7-3.9 7.4-6.4C209.9 342.7 217 336 224 336s14.1 6.7 20.3 12.5c2.7 2.5 5.2 4.9 7.4 6.4c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c2.2-1.5 4.7-3.9 7.4-6.4c6-5.7 13-12.3 19.8-12.4c7.2-.2 15.1 6.8 21.8 12.5c2.8 2.4 5.3 4.6 7.5 6c10.3 6.7 22.7 12.4 35.2 13.3V288c0-17.7-14.3-32-32-32zM32 400l0 80H416V399.9c-21.1-.9-39.8-10.2-52.6-18.5c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C73.8 390 54.6 400 32 400zM64 224H80V176c0-8.8 7.2-16 16-16s16 7.2 16 16v48h96V176c0-8.8 7.2-16 16-16s16 7.2 16 16v48h96V176c0-8.8 7.2-16 16-16s16 7.2 16 16v48h16c35.3 0 64 28.7 64 64V480c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V288c0-35.3 28.7-64 64-64zM224 49.7L210.5 70.9c-1.6 2.6-2.5 5.7-2.5 8.8c0 9.1 7.4 16.3 16 16.3s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L224 49.7zM214.2 5.4C216.3 2 220 0 224 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26L214.2 5.4zM338.5 70.9c-1.6 2.6-2.5 5.7-2.5 8.8c0 9.1 7.4 16.3 16 16.3s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L352 49.7 338.5 70.9zm-27-17.1L342.2 5.4C344.3 2 348 0 352 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26z"]
};
var faBirthdayCake = faCakeCandles;
var faCake = faCakeCandles;
var faHeadSide = {
  prefix: 'fal',
  iconName: 'head-side',
  icon: [512, 512, [], "f6e9", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm312 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faEnvelope = {
  prefix: 'fal',
  iconName: 'envelope',
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 96c-17.7 0-32 14.3-32 32v39.9L227.6 311.3c16.9 12.4 39.9 12.4 56.8 0L480 167.9V128c0-17.7-14.3-32-32-32H64zM32 207.6V384c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V207.6L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faDollyEmpty = {
  prefix: 'fal',
  iconName: 'dolly-empty',
  icon: [576, 512, [], "f473", "M8 16C8 7.2 15.2 0 24 0H88.9c20.7 0 39 13.2 45.5 32.8L241.3 353.3c4.8-.9 9.7-1.3 14.7-1.3c34.1 0 63.2 21.3 74.7 51.4L554.5 321c8.3-3.1 17.5 1.2 20.5 9.5s-1.2 17.5-9.5 20.5L335.9 435.6C334 478.1 299 512 256 512c-44.2 0-80-35.8-80-80c0-27.8 14.1-52.2 35.6-66.6L104.1 42.9C101.9 36.4 95.8 32 88.9 32H24C15.2 32 8 24.8 8 16zM304 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faFaceTissue = {
  prefix: 'fal',
  iconName: 'face-tissue',
  icon: [512, 512, [], "e39c", "M256 32C132.3 32 32 132.3 32 256c0 8.8-7.2 16-16 16s-16-7.2-16-16C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-8.8 0-16-7.2-16-16s7.2-16 16-16c123.7 0 224-100.3 224-224S379.7 32 256 32zm39.1 306.7c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 371.2l-39.1 26.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l48-32zM136.5 190.3c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 208l-35.4-17.7zm246.2-21.5c4 7.9 .7 17.5-7.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2zM223.8 306.6l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5L51.9 479.5c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3 .8 13.9 4.5s5.3 8.8 4.5 13.9zM79.9 354.1c6.2 3.6 9.3 10.8 7.6 17.8L70 442l70.1-17.5c7-1.7 14.2 1.4 17.8 7.6l9.7 17 20.9-125.6L62.9 344.4l17 9.7z"]
};
var faAnglesUp = {
  prefix: 'fal',
  iconName: 'angles-up',
  icon: [448, 512, ["angle-double-up"], "f102", "M235.3 52.7c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 86.6 372.7 235.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-160-160zm160 352l-160-160c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 278.6 372.7 427.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"]
};
var faAngleDoubleUp = faAnglesUp;
var faBinRecycle = {
  prefix: 'fal',
  iconName: 'bin-recycle',
  icon: [576, 512, [], "e5f7", "M536 64c4.4 0 8 3.6 8 8V88c0 4.4-3.6 8-8 8H511.9 64.1 40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8H536zM0 88c0 20.3 15.1 37 34.6 39.6l0 .4L59.1 421.3c2.8 33.2 30.5 58.7 63.8 58.7H453.1c33.3 0 61-25.5 63.8-58.7L541.3 128l0-.4C560.9 125 576 108.3 576 88V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72V88zM91 418.7L66.8 128H509.2L485 418.7c-1.4 16.6-15.2 29.3-31.9 29.3H122.9c-16.6 0-30.5-12.8-31.9-29.3zM288 192c5 0 9.7 2.4 12.6 6.4l31 42.1c5 6.7 14.3 8.5 21.4 4.1c7.9-4.9 9.9-15.6 4.4-23.1l-31-42.1c-9-12.2-23.2-19.4-38.4-19.4s-29.4 7.2-38.4 19.4l-31 42.1c-5.5 7.5-3.5 18.1 4.4 23.1c7.1 4.4 16.4 2.7 21.4-4.1l31-42.1c3-4 7.6-6.4 12.6-6.4zm-86.1 77.1c-7.1-4.4-16.4-2.7-21.4 4.1L153 310.5c-5.8 7.9-9 17.5-9 27.4c0 25.5 20.6 46.1 46.1 46.1H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H190.1c-7.8 0-14.1-6.3-14.1-14.1c0-3 1-5.9 2.8-8.4l27.6-37.4c5.5-7.5 3.5-18.1-4.4-23.1zM304 368c0 8.8 7.2 16 16 16h65.9c25.5 0 46.1-20.6 46.1-46.1c0-9.8-3.1-19.4-9-27.4l-27.6-37.4c-5-6.7-14.3-8.5-21.4-4.1c-7.9 4.9-9.9 15.6-4.4 23.1l27.6 37.4c1.8 2.4 2.7 5.4 2.7 8.4c0 7.8-6.3 14.1-14.1 14.1H320c-8.8 0-16 7.2-16 16z"]
};
var faPaperclip = {
  prefix: 'fal',
  iconName: 'paperclip',
  icon: [448, 512, [128206], "f0c6", "M380.7 67.3c-29.1-29.1-76.3-29.1-105.4 0l-192 192c-46.8 46.8-46.8 122.6 0 169.4s122.6 46.8 169.4 0l152-152c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-152 152c-59.3 59.3-155.4 59.3-214.6 0S1.4 296 60.7 236.7l192-192c41.6-41.6 109-41.6 150.6 0s41.6 109 0 150.6L219.5 379.1c-28.2 28.2-74.6 25.6-99.6-5.5c-21.3-26.6-19.2-65 4.9-89.1L276.7 132.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L147.5 307.1c-12.6 12.6-13.7 32.6-2.6 46.5c13 16.2 37.2 17.6 51.9 2.9L380.7 172.7c29.1-29.1 29.1-76.3 0-105.4z"]
};
var faChartLineDown = {
  prefix: 'fal',
  iconName: 'chart-line-down',
  icon: [512, 512, [128201], "f64d", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM320 336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4L331.3 180.7c-6.2-6.2-16.4-6.2-22.6 0L224 265.4 123.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0L320 214.6 425.4 320H336c-8.8 0-16 7.2-16 16z"]
};
var faArrowRightToCity = {
  prefix: 'fal',
  iconName: 'arrow-right-to-city',
  icon: [640, 512, [], "e4b3", "M320 48c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16V208c0 8.8 7.2 16 16 16h64 32c8.8 0 16 7.2 16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-26.5-21.5-48-48-48H576V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H512V48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V496c0 8.8 7.2 16 16 16s16-7.2 16-16V48zm32 48v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H384c-17.7 0-32 14.3-32 32zm64 0v32H384V96h32zm96 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H512zm0 32h32v32H512V288zM480 416v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H512c-17.7 0-32 14.3-32 32zm64 0v32H512V416h32zM384 192c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H384zm0 32h32v32H384V224zM352 352v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H384c-17.7 0-32 14.3-32 32zm64 0v32H384V352h32zM155.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L201.4 240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H201.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"]
};
var faLockA = {
  prefix: 'fal',
  iconName: 'lock-a',
  icon: [448, 512, [], "e422", "M224 32c53 0 96 43 96 96v64H128V128c0-53 43-96 96-96zM96 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM80 224H368c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm49.7 200.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L177.9 400h92.2l19.6 39.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5L238.4 265c-.8-1.6-1.8-3-3.1-4.3c-1.4-1.4-3.1-2.6-5-3.4c-2.1-.9-4.2-1.3-6.4-1.3s-4.3 .4-6.4 1.3c-1.8 .8-3.5 1.9-5 3.4c-1.3 1.3-2.3 2.7-3 4.3L129.7 424.8zM193.9 368L224 307.8 254.1 368H193.9z"]
};
var faRibbon = {
  prefix: 'fal',
  iconName: 'ribbon',
  icon: [448, 512, [127895], "f4d6", "M228 0c-1.3 0-2.6 0-4 0V.1c-13.3 .2-29.2 .7-38.3 1.4s-17 1.7-23.5 2.6c-18.3 2.7-33.3 13.3-43.6 26.7L70.8 92.9c-14.8 19.2-22.8 42.7-22.8 67c0 27.9 10.6 54.8 29.7 75.1L332.3 506.9c5.4 5.8 14.3 6.7 20.9 2.2l80-56c3.8-2.6 6.2-6.8 6.7-11.3s-1-9.1-4.1-12.5L172.4 139.5c-2.8-3-4.3-7-4.3-11.1c0-9.1 7.4-16.5 16.5-16.5H224h16 23.5c9.1 0 16.5 7.4 16.5 16.5c0 4.1-1.5 8-4.3 11.1l-30 33 21.6 23.8 32.1-35.3c8.1-8.9 12.6-20.5 12.6-32.6c0-26.8-21.7-48.5-48.5-48.5H240 224 184.5c-26.8 0-48.5 21.7-48.5 48.5c0 12.1 4.5 23.7 12.6 32.6L399.9 437.3l-53.7 37.6L101.1 213.2c-13.5-14.4-21-33.5-21-53.2c0-17.2 5.7-33.9 16.1-47.5l47.7-62.1c6.3-8.2 14.4-13.3 23-14.6c5.8-.9 12.9-1.7 21.4-2.4c9-.7 26.1-1.3 39.7-1.4c12.1 .1 22.8 .6 31.9 1.4c8.5 .7 15.6 1.6 21.4 2.4c8.6 1.3 16.7 6.4 23 14.6l47.7 62.1c10.5 13.6 16.1 30.3 16.1 47.5c0 19.8-7.5 38.8-21 53.2L314.3 248l21.6 23.8L370.3 235c19.1-20.4 29.7-47.2 29.7-75.1c0-24.2-8-47.8-22.8-67L329.5 30.9c-10.3-13.4-25.3-24-43.6-26.7c-6.5-1-14.3-1.9-23.5-2.6C253.5 .8 243.4 .2 232 .1V0c-1.3 0-2.6 0-4 0zM112.5 319L12.2 429.2c-3.1 3.4-4.6 8-4.1 12.5s3 8.7 6.7 11.3l80 56c6.5 4.6 15.4 3.6 20.9-2.2l86.4-92.2-21.9-23.4-78.3 83.7L48.2 437.3l86.3-94.9L112.5 319z"]
};
var faLungs = {
  prefix: 'fal',
  iconName: 'lungs',
  icon: [640, 512, [129729], "f604", "M320 0c8.8 0 16 7.2 16 16V180.1c0 21.9 11.2 42.2 29.6 54L384 245.8V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V321.6L416 342v56c0 29.4 20 55 48.5 62.1l72.7 18.2c4.5 1.1 9.2 1.7 13.8 1.7c31.5 0 57-25.5 57-57v-7c-6.5-52.2-30.3-109.7-56.3-159.5s-53.9-91.9-68.9-113.3c-6.7-9.6-17.7-15.1-29.5-15.1c-20.6 0-37.3 16.7-37.3 37.3V266.1l88.6 56.4c7.5 4.7 9.7 14.6 4.9 22.1s-14.6 9.7-22.1 4.9L416 304.1l-32-20.4-35.5-22.6c-11.5-7.3-21.1-16.9-28.5-27.9c-7.3 11-16.9 20.6-28.5 27.9L256 283.7l-32 20.4-71.4 45.4c-7.5 4.7-17.3 2.5-22.1-4.9s-2.5-17.3 4.9-22.1L224 266.1V165.3c0-20.6-16.7-37.3-37.3-37.3c-11.8 0-22.8 5.5-29.5 15.1c-14.9 21.4-43 63.5-68.9 113.3S38.5 363.8 32 416v7c0 31.5 25.5 57 57 57c4.7 0 9.3-.6 13.8-1.7l72.7-18.2C204 453 224 427.4 224 398V342l32-20.4V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v80.4l18.4-11.7c18.5-11.7 29.6-32.1 29.6-54V16c0-8.8 7.2-16 16-16z"]
};
var faPersonPinball = {
  prefix: 'fal',
  iconName: 'person-pinball',
  icon: [640, 512, [], "e21d", "M104 56A24 24 0 1 0 56 56a24 24 0 1 0 48 0zM24 56a56 56 0 1 1 112 0A56 56 0 1 1 24 56zm8 168l0 55.7c.2 5.1 2.7 9.7 6.9 12.6L80 320.6V180.2c-6.2-2.7-13-4.2-20-4.2c-15.5 0-28 12.5-28 28v19.4c0 .2 0 .4 0 .6zm96 168.4l-96-66L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 280.2c0-.3 0-.7 0-1V204c0-33.1 26.9-60 60-60c27.9 0 53.9 14.2 69 37.6L176.7 256h29.7l316.4-60.8L481.6 71.5c-1.1-3.3-1.6-6.7-1.6-10.1V32c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32V192 400v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H224v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400 288H176.7c-10.9 0-21-5.5-26.9-14.7L112 214.5V342.6L146.1 366c8.7 6 13.9 15.8 13.9 26.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V392.4zM608 178.8V32H512V61.4l42.6 127.7L608 178.8zM608 384V211.4L224 285.2V384H608zM288 304a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faArrowUp91 = {
  prefix: 'fal',
  iconName: 'arrow-up-9-1',
  icon: [576, 512, ["sort-numeric-up-alt"], "f887", "M428 168a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm-84-52c0 46.4 37.6 84 84 84c.4 0 .9 0 1.3 0l-25.4 29.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7l62.4-72.5C504.4 161.8 512 141.2 512 120h-.1c.1-1.3 .1-2.7 .1-4c0-46.4-37.6-84-84-84s-84 37.6-84 84zM171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM448 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V448H384c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faSortNumericUpAlt = faArrowUp91;
var faAppleCore = {
  prefix: 'fal',
  iconName: 'apple-core',
  icon: [384, 512, [], "e08f", "M196.6 96C229.4 96 256 69.4 256 36.6V32h-4.6C218.6 32 192 58.6 192 91.4V96h4.6zm-18.3 32c-10.1 0-18.3-8.2-18.3-18.3V91.4C160 40.9 200.9 0 251.4 0h18.3C279.8 0 288 8.2 288 18.3V36.6c0 50.5-40.9 91.4-91.4 91.4H178.3zM128 480c13.2 0 32-2.7 45.3-5c12.3-2.2 25-2.2 37.3 0c13.3 2.3 32.1 5 45.3 5c19.7 0 41.8-8.8 62.6-27.3C280 415 256 362.3 256 304c0-55.6 21.8-106.1 57.3-143.4c-3-.4-6.1-.6-9.3-.6c-21 0-48.7 8.4-71.1 17.1c-26.2 10.2-55.6 10.2-81.9 0C128.7 168.4 101 160 80 160c-3.2 0-6.3 .2-9.3 .6C106.2 197.9 128 248.4 128 304c0 58.3-24 111-62.6 148.7C86.2 471.2 108.3 480 128 480zM29.9 462.4c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137c-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c19.3 0 36.1 5.4 50.3 14.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-16.2 0-37.4-3.2-50.8-5.5c-8.7-1.5-17.6-1.5-26.3 0c-13.5 2.4-34.6 5.5-50.8 5.5c-34.9 0-69.8-18.3-98.1-49.6z"]
};
var faCircleY = {
  prefix: 'fal',
  iconName: 'circle-y',
  icon: [512, 512, [], "e12f", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM156 149.5c-5.8-6.7-15.9-7.3-22.6-1.5s-7.3 15.9-1.5 22.6L240 294v90c0 8.8 7.2 16 16 16s16-7.2 16-16V294L380 170.5c5.8-6.7 5.1-16.8-1.5-22.6s-16.8-5.1-22.6 1.5L256 263.7 156 149.5z"]
};
var faH6 = {
  prefix: 'fal',
  iconName: 'h6',
  icon: [640, 512, [], "e413", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM505.4 67.1c-7.1-5.2-17.2-3.6-22.4 3.5L383.3 207.8C363 235.7 352 269.4 352 304c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-15 0-29.6 2.3-43.2 6.6l56.1-77.2c5.2-7.1 3.6-17.2-3.5-22.4zM496 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
};
var faLitecoinSign = {
  prefix: 'fal',
  iconName: 'litecoin-sign',
  icon: [384, 512, [], "e1d3", "M96 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V227.5l-51.9 13C3.5 242.6-1.7 251.3 .5 259.9s10.8 13.8 19.4 11.6l44.1-11V440c0 22.1 17.9 40 40 40H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H104c-4.4 0-8-3.6-8-8V252.5l179.9-45c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L96 219.5V48z"]
};
var faCircleSmall = {
  prefix: 'fal',
  iconName: 'circle-small',
  icon: [320, 512, [], "e122", "M288 256A128 128 0 1 0 32 256a128 128 0 1 0 256 0zM0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z"]
};
var faBorderNone = {
  prefix: 'fal',
  iconName: 'border-none',
  icon: [448, 512, [], "f850", "M32 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM128 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-240a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM320 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-432a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM416 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM224 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM416 136a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faArrowTurnDownLeft = {
  prefix: 'fal',
  iconName: 'arrow-turn-down-left',
  icon: [512, 512, [], "e2e1", "M480 48c0-8.8 7.2-16 16-16s16 7.2 16 16V224c0 44.2-35.8 80-80 80H54.6L155.3 404.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 272H432c26.5 0 48-21.5 48-48V48z"]
};
var faCircleNodes = {
  prefix: 'fal',
  iconName: 'circle-nodes',
  icon: [512, 512, [], "e4e2", "M376.2 121.7l0 0c7 4 15.2 6.3 23.8 6.3c2.6 0 5.2-.2 7.6-.6l0 0C430.5 123.7 448 103.9 448 80c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 .7 0 1.3 0 2l0 0c.5 11.4 4.9 21.7 11.9 29.7l0 0c3.5 4 7.6 7.4 12.2 10zm-5.9 32.6c-15.2-6.1-28.2-16.8-37.1-30.3L158.7 193.7c.8 4.6 1.3 9.4 1.3 14.3c0 14.4-3.8 27.9-10.5 39.6l138 120.8c13-9.9 29.2-16 46.7-16.3l36-197.7zm-4.5 203.4C395.2 369.5 416 398.3 416 432c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-14.4 3.8-27.9 10.5-39.6l-138-120.8C115 281.9 98.2 288 80 288c-44.2 0-80-35.8-80-80s35.8-80 80-80c27.9 0 52.5 14.3 66.8 36L321.3 94.3c-.8-4.6-1.3-9.4-1.3-14.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 43.6-34.9 79.1-78.3 80l-36 197.7zm-246-122.9c.7-1 1.3-2 1.9-3.1c4-7 6.3-15.1 6.3-23.8c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c8.5 0 16.6-2.2 23.5-6.2l0 0c6.5-3.7 12.1-8.8 16.3-15zM291.4 414.2c-2.2 5.5-3.4 11.5-3.4 17.8c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48c-14 0-26.6 6-35.3 15.5c-2.7 2.9-5 6.1-6.9 9.6c-.9 1.6-1.7 3.4-2.4 5.1l0 0z"]
};
var faParachuteBox = {
  prefix: 'fal',
  iconName: 'parachute-box',
  icon: [512, 512, [], "f4cd", "M256.1 0H256C86.6 0 8.7 114.4 .7 208c-.8 8.8 6.5 16 15.3 16H49.1L165 346.7c-3.2 6.4-5 13.7-5 21.3v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.7-1.8-14.9-5-21.3L462.9 224H496c8.8 0 16.1-7.2 15.3-16c-8-93.6-85.8-208-255.2-208zM418.9 224L324.1 324.4c-6.1-2.8-12.9-4.4-20.1-4.4H272V224h95.5 32 19.3zM240 224v96H208c-7.2 0-14 1.6-20.1 4.4L93.1 224h19.3 32H240zm0 128h32 32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32zM35.2 192C46.4 135.7 86.8 73.5 165.5 46.2c-29.9 35-50 87-53.1 145.8H35.2zM180.5 79.1C202.5 47.4 229.7 32 256 32s53.5 15.4 75.5 47.1c19.6 28.3 33.4 67.8 36 112.9H144.5c2.7-45.1 16.4-84.5 36-112.9zM476.8 192H399.6c-3.1-58.8-23.1-110.8-53.1-145.8C425.2 73.5 465.6 135.7 476.8 192z"]
};
var faMessageMedical = {
  prefix: 'fal',
  iconName: 'message-medical',
  icon: [512, 512, ["comment-alt-medical"], "f7f4", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM240 96c-17.7 0-32 14.3-32 32v32H176c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H304V128c0-17.7-14.3-32-32-32H240zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H288c-8.8 0-16 7.2-16 16v48H240V240c0-8.8-7.2-16-16-16H176V192h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V128z"]
};
var faCommentAltMedical = faMessageMedical;
var faRugbyBall = {
  prefix: 'fal',
  iconName: 'rugby-ball',
  icon: [512, 512, [], "e3c6", "M336 16h32c70.7 0 128 57.3 128 128v32c0 176.7-143.3 320-320 320H144C73.3 496 16 438.7 16 368V336C16 159.3 159.3 16 336 16zm27.9 32H336c-77.3 0-147.5 30.4-199.2 80c-3 2.9-5.9 5.8-8.8 8.8C78.4 188.5 48 258.7 48 336v31.9c3.5-10.8 8-22.1 13.5-33.6c23.1-48.3 64-104.5 117.2-157.6S288 82.6 336.3 59.5C345.7 55 355 51.2 363.9 48zM143.1 464c.3 0 .6 0 .9 0h32c77.3 0 147.5-30.4 199.2-80c3-2.9 5.9-5.8 8.8-8.8c49.6-51.7 80-121.9 80-199.2V147.2c-3.2 9.2-7.1 18.6-11.7 28.2c-23.1 48.3-64 104.5-117.2 157.6S225.8 427.2 177.5 450.2c-11.8 5.6-23.3 10.3-34.3 13.8zM79.2 432.5c4.6 4.6 13.1 7.9 28.2 6.6c15-1.3 34.1-7.1 56.3-17.7c44.3-21.1 97.5-59.7 148.8-110.9s89.8-104.5 110.9-148.8c10.6-22.2 16.4-41.3 17.7-56.3c1.3-15.1-2-23.6-6.6-28.2s-13.1-7.9-28.2-6.6c-15 1.3-34.1 7.1-56.3 17.7c-44.3 21.1-97.5 59.7-148.8 110.9s-89.8 104.5-110.9 148.8C79.8 370.3 74 389.4 72.7 404.4c-1.3 15.1 2 23.6 6.6 28.2z"]
};
var faCommentMusic = {
  prefix: 'fal',
  iconName: 'comment-music',
  icon: [512, 512, [], "f8b0", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm89.1 82.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V187.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V128c0-5.2-2.6-10.2-6.9-13.2zM320 276c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM192 308c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z"]
};
var faIndent = {
  prefix: 'fal',
  iconName: 'indent',
  icon: [448, 512, [], "f03c", "M0 64c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 80 0 72.8 0 64zM192 192c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 112H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM0 448c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM32 211.8v88.4L85.7 256 32 211.8zm89 31.8c7.8 6.4 7.8 18.3 0 24.7L26.2 346.4C15.7 355 0 347.6 0 334.1V177.9c0-13.5 15.7-20.9 26.2-12.4L121 243.6z"]
};
var faTreeDeciduous = {
  prefix: 'fal',
  iconName: 'tree-deciduous',
  icon: [512, 512, [127795, "tree-alt"], "f400", "M177.7 95.6c-.9 4.5-3.8 8.4-7.8 10.6s-8.8 2.7-13.1 1.2c-6.5-2.2-13.5-3.5-20.8-3.5c-35.3 0-64 28.7-64 64c0 13.2 4 25.4 10.8 35.6c2.8 4.1 3.5 9.3 1.9 14s-5.2 8.4-9.9 10C49.9 236.3 32 260.1 32 288c0 35.3 28.7 64 64 64H240V320 256 144c0-8.8 7.2-16 16-16s16 7.2 16 16V256v64 32H416c35.3 0 64-28.7 64-64c0-27.9-17.9-51.7-42.8-60.4c-4.7-1.6-8.3-5.3-9.9-10s-.9-9.9 1.9-14C436 193.4 440 181.2 440 168c0-35.3-28.7-64-64-64c-7.3 0-14.3 1.2-20.8 3.5c-4.3 1.5-9.1 1-13.1-1.2s-6.8-6.1-7.8-10.6C326.8 59.3 294.5 32 256 32s-70.8 27.3-78.3 63.6zM240 384H96c-53 0-96-43-96-96c0-35.3 19.1-66.2 47.5-82.8c-4.8-11.4-7.5-24-7.5-37.2c0-53 43-96 96-96c5.1 0 10.1 .4 14.9 1.2C166.7 30.4 207.8 0 256 0s89.3 30.4 105.1 73.2c4.9-.8 9.9-1.2 14.9-1.2c53 0 96 43 96 96c0 13.2-2.7 25.7-7.5 37.2C492.9 221.8 512 252.7 512 288c0 53-43 96-96 96H272V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384z"]
};
var faTreeAlt = faTreeDeciduous;
var faPuzzlePieceSimple = {
  prefix: 'fal',
  iconName: 'puzzle-piece-simple',
  icon: [640, 512, ["puzzle-piece-alt"], "e231", "M98 301.2l-12.8-9.6L98 301.2zM280.3 403.9l-9.1 13.2 9.1-13.2zm79.4 0l9.1 13.2-9.1-13.2zM542 301.2l-12.8 9.6 12.8-9.6zm0-90.3l-12.8-9.6 12.8 9.6zm-444 0l-12.8 9.6L98 210.8zM280.3 108.1l9.1 13.2-9.1-13.2zm79.4 0l-9.1 13.2 9.1-13.2zM271.2 94.9C252.7 107.7 240 128.2 240 152h32c0-11.8 6.3-23.1 17.4-30.8L271.2 94.9zM240 152c0 41.7 37.9 72 80 72V192c-28.6 0-48-19.8-48-40H240zm80 72c42.1 0 80-30.3 80-72H368c0 20.2-19.4 40-48 40v32zm80-72c0-23.8-12.7-44.3-31.2-57.1l-18.2 26.3c11.2 7.7 17.4 19 17.4 30.8h32zM366.6 96H464V64H366.6V96zM480 112v88.8h32V112H480zm74.8 108.4c6.4-8.6 14.1-12.4 21.2-12.4V176c-19.5 0-35.9 10.6-46.8 25.3l25.6 19.2zM576 208c7.1 0 14.7 3.8 21.1 12.3s10.9 21.1 10.9 35.7h32c0-20.8-6.3-40.2-17.3-54.9s-27.3-25.1-46.7-25.1v32zm32 48c0 14.5-4.4 27.1-10.9 35.7s-14.1 12.3-21.1 12.3v32c19.4 0 35.8-10.5 46.7-25.1s17.3-34.1 17.3-54.9H608zm-32 48c-7.1 0-14.8-3.8-21.2-12.4l-25.6 19.2c11 14.7 27.4 25.3 46.8 25.3V304zm-96 7.2V400h32V311.2H480zM464 416H366.6v32H464V416zm-95.2 1.1C387.3 404.3 400 383.8 400 360H368c0 11.8-6.3 23.1-17.4 30.8l18.2 26.3zM400 360c0-41.7-37.9-72-80-72v32c28.6 0 48 19.8 48 40h32zm-80-72c-42.1 0-80 30.3-80 72h32c0-20.2 19.4-40 48-40V288zm-80 72c0 23.8 12.7 44.3 31.2 57.1l18.2-26.3c-11.2-7.7-17.4-19-17.4-30.8H240zm33.5 56H176v32h97.5V416zM160 400V311.2H128V400h32zM85.2 291.6C78.8 300.2 71.1 304 64 304v32c19.5 0 35.9-10.6 46.8-25.3L85.2 291.6zM64 304c-7.1 0-14.7-3.8-21.1-12.3S32 270.5 32 256H0c0 20.8 6.3 40.2 17.3 54.9S44.6 336 64 336V304zM32 256c0-14.5 4.4-27.1 10.9-35.7S56.9 208 64 208V176c-19.4 0-35.8 10.5-46.7 25.1S0 235.2 0 256H32zm32-48c7.1 0 14.8 3.8 21.2 12.4l25.6-19.2C99.9 186.6 83.5 176 64 176v32zm96-7.2V112H128v88.8h32zM176 96h97.5V64H176V96zM120.8 272c-16.2 0-28.4 9.9-35.6 19.6l25.6 19.2c3.8-5.2 7.7-6.7 10-6.7V272zM272 417.4c0-.8 .6-1.4 1.5-1.4v32c16.9 0 30.5-13.7 30.5-30.6H272zm-.8-.4c.2 .2 .4 .3 .6 .5s.2 .3 .3 .3s0 0 0 0s-.1-.3-.1-.4h32c0-11.9-6.8-21.3-14.6-26.7l-18.2 26.3zm96.8 .4c0 .2 0 .3-.1 .4s0 .1 0 0s.1-.2 .3-.3s.3-.3 .6-.5l-18.2-26.3c-7.8 5.4-14.6 14.8-14.6 26.7h32zM480 400c0 8.8-7.2 16-16 16v32c26.5 0 48-21.5 48-48H480zm39.2-128c-21.7 0-39.2 17.5-39.2 39.2h32c0-4 3.2-7.2 7.2-7.2V272zm35.6 19.6c-7.2-9.7-19.4-19.6-35.6-19.6v32c2.3 0 6.1 1.6 10 6.7l25.6-19.2zM519.2 240c16.2 0 28.4-9.9 35.6-19.6l-25.6-19.2c-3.8 5.2-7.7 6.7-10 6.7v32zM160 112c0-8.8 7.2-16 16-16V64c-26.5 0-48 21.5-48 48h32zm320 88.8c0 21.6 17.5 39.2 39.2 39.2V208c-4 0-7.2-3.2-7.2-7.2H480zM120.8 240c21.6 0 39.2-17.5 39.2-39.2H128c0 4-3.2 7.2-7.2 7.2v32zM464 96c8.8 0 16 7.2 16 16h32c0-26.5-21.5-48-48-48V96zM85.2 220.4c7.2 9.7 19.4 19.6 35.6 19.6V208c-2.3 0-6.1-1.6-10-6.7L85.2 220.4zM368 94.5c0 .8-.6 1.5-1.4 1.5V64C349.7 64 336 77.7 336 94.5h32zM160 311.2c0-21.6-17.5-39.2-39.2-39.2v32c4 0 7.2 3.2 7.2 7.2h32zM272 94.5c0-.2 0-.3 .1-.4s0-.1 0 0s-.1 .2-.3 .3s-.3 .3-.6 .5l18.2 26.3c7.8-5.4 14.6-14.8 14.6-26.7H272zM366.6 416c.8 0 1.4 .6 1.4 1.4H336c0 16.9 13.7 30.6 30.6 30.6V416zm2.2-321.1c-.2-.2-.4-.3-.6-.5s-.2-.3-.3-.3s0 0 0 0s.1 .3 .1 .4H336c0 11.9 6.8 21.3 14.6 26.7l18.2-26.3zM176 416c-8.8 0-16-7.2-16-16H128c0 26.5 21.5 48 48 48V416zM304 94.5C304 77.7 290.3 64 273.5 64V96c-.8 0-1.5-.6-1.5-1.5h32z"]
};
var faPuzzlePieceAlt = faPuzzlePieceSimple;
var faTruckFieldUn = {
  prefix: 'fal',
  iconName: 'truck-field-un',
  icon: [640, 512, [], "e58e", "M96 64C78.3 64 64 78.3 64 96v32V288v64h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H352V224 192 96c0-17.7-14.3-32-32-32H96zM0 160c0-17.7 14.3-32 32-32V96c0-35.3 28.7-64 64-64H320c32.6 0 59.6 24.4 63.5 56h53.4c17.7 0 33.9 9.7 42.3 25.2L521.6 192H544c35.3 0 64 28.7 64 64v96h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608 576c0 53-43 96-96 96s-96-43-96-96H352 256c0 53-43 96-96 96s-96-43-96-96H32 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V288c-17.7 0-32-14.3-32-32V160zm384-40v72H485.2L451 128.4c-2.8-5.2-8.2-8.4-14.1-8.4H384zm0 232h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H576V256c0-17.7-14.3-32-32-32H512.3c-.2 0-.4 0-.6 0H384V352zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 240A64 64 0 1 0 96 384a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faNfcTrash = {
  prefix: 'fal',
  iconName: 'nfc-trash',
  icon: [640, 512, [], "e1fd", "M64 64H384c17.7 0 32 14.3 32 32V200.2l2.5-7.4c4.8-14.3 15.9-25.2 29.5-30.1V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H381.6l-2.3-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM384 208V128c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32v82.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V128H352v80h32zM352 384H96V128l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H352c9.7 0 18.4-4.3 24.3-11.1L369.1 304H352v80zM240 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm208.8-53.1L436.5 240H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H576h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H587.5l-12.4-37.1C573 196.4 566.9 192 560 192H464c-6.9 0-13 4.4-15.2 10.9zM470.2 240l5.3-16h72.9l5.3 16H470.2zm-69 64.1l12.7 178.2C415.1 499 429 512 445.8 512H578.2c16.8 0 30.7-13 31.9-29.7l12.7-178.2H590.8L578.2 480H445.8L433.2 304.1H401.1z"]
};
var faHourglass = {
  prefix: 'fal',
  iconName: 'hourglass',
  icon: [384, 512, [9203, 62032, "hourglass-empty"], "f254", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H32l0 44.7c0 31.6 10.4 62.4 29.6 87.5L131.9 256 61.6 347.9C42.4 373 32 403.7 32 435.3V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H352V435.3c0-31.6-10.4-62.4-29.6-87.5L252.1 256l70.2-91.9C341.6 139 352 108.3 352 76.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM320 32V76.7c0 24.6-8.1 48.5-23 68L219.3 246.3c-4.4 5.7-4.4 13.7 0 19.4L297 367.3c14.9 19.5 23 43.4 23 68V480H64l0-44.7c0-24.6 8.1-48.5 23-68l77.7-101.6c4.4-5.7 4.4-13.7 0-19.4L87 144.7c-14.9-19.5-23-43.4-23-68L64 32H320z"]
};
var faHourglassEmpty = faHourglass;
var faMountain = {
  prefix: 'fal',
  iconName: 'mountain',
  icon: [512, 512, [127956], "f6fc", "M480 424.1c0 13.2-10.7 23.9-23.9 23.9H55.9C42.7 448 32 437.3 32 424.1c0-4.5 1.3-8.9 3.7-12.7L140.2 244.8 195.5 314c3.1 3.9 7.8 6.1 12.7 6s9.6-2.4 12.6-6.4L264 256H378.9l97.5 155.4c2.4 3.8 3.7 8.2 3.7 12.7zM358.8 224H256c-5 0-9.8 2.4-12.8 6.4l-35.6 47.5-49.4-61.8L252.4 66c.8-1.3 2.2-2 3.6-2s2.9 .8 3.6 2l99.1 158zM55.9 480H456.1c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1C0 455 25 480 55.9 480z"]
};
var faFileXmark = {
  prefix: 'fal',
  iconName: 'file-xmark',
  icon: [384, 512, ["file-times"], "f317", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm52.7 260.7c-6.2 6.2-6.2 16.4 0 22.6L169.4 336l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 358.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 336l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 313.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faFileTimes = faFileXmark;
var faHouseHeart = {
  prefix: 'fal',
  iconName: 'house-heart',
  icon: [576, 512, ["home-heart"], "f4c9", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zM208 285.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L288 377.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM237.3 224c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faHomeHeart = faHouseHeart;
var faHouseChimneyBlank = {
  prefix: 'fal',
  iconName: 'house-chimney-blank',
  icon: [576, 512, [], "e3b0", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L512 192.3V56c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24V79.4L298.6 4zM416 107.6V64h64V164.1l-64-56.5zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48z"]
};
var faMeterBolt = {
  prefix: 'fal',
  iconName: 'meter-bolt',
  icon: [640, 512, [], "e1e9", "M480 256c0 5.7-.2 11.4-.6 17l32.3-30.6C504.6 107.4 392.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c69.2 0 132-27.5 178.1-72.1c-12.4-.8-23.7-5.8-32.4-13.7C362.5 459.7 311.6 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224zM176 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm95.7 232l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4H463.7zM585.6 224c-5.1 0-10.1 2-13.8 5.5L422.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6H487l-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5L633.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6H569l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"]
};
var faUserDoctor = {
  prefix: 'fal',
  iconName: 'user-doctor',
  icon: [448, 512, ["user-md"], "f0f0", "M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm48 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32-45.3V336l1.2 0h93.6c5.8 0 11.5 .3 17.2 1v33.3c-23.1 6.9-40 28.3-40 53.7v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V424c0-25.4-16.9-46.8-40-53.7V344.5c55.6 20 95.5 73 96 135.5H32c.5-68.2 48.2-125.3 112-140.2v30.9c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3zm1.2-66.7C79.3 304 0 383.3 0 481.2c0 17 13.8 30.8 30.8 30.8H417.2c17 0 30.8-13.8 30.8-30.8C448 383.3 368.7 304 270.8 304H177.2z"]
};
var faUserMd = faUserDoctor;
var faSlashBack = {
  prefix: 'fal',
  iconName: 'slash-back',
  icon: [320, 512, [], "5c", "M7.8 2.3c-7.6 4.5-10 14.4-5.5 22l288 480c4.5 7.6 14.4 10 22 5.5s10-14.4 5.5-22L29.7 7.8c-4.5-7.6-14.4-10-22-5.5z"]
};
var faCircleInfo = {
  prefix: 'fal',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V240c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v96H208zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faInfoCircle = faCircleInfo;
var faFishingRod = {
  prefix: 'fal',
  iconName: 'fishing-rod',
  icon: [448, 512, [], "e3a8", "M280.4 32c-4 0-7.9 .6-11.7 1.8L204.2 53.6C130.4 76.3 80 144.5 80 221.8V288h8c22.1 0 40 17.9 40 40V472c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V328c0-22.1 17.9-40 40-40h8V221.8C48 130.5 107.6 49.9 194.8 23L259.3 3.2C266.1 1.1 273.2 0 280.4 0C319.9 0 352 32.1 352 71.6V136c0 8.8-7.2 16-16 16s-16-7.2-16-16V71.6C320 49.7 302.3 32 280.4 32zm48.5 145.7c4.5-2.3 9.8-2.3 14.3 0c17.9 8.9 43.7 27.1 65.2 53.4C430 257.5 448 292.9 448 336c0 33.5-15.1 80.9-58.2 115.8l23.5 35.3c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H272c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l23.5-35.3C239.1 416.9 224 369.5 224 336c0-43.1 18-78.5 39.6-104.9c21.5-26.3 47.4-44.4 65.2-53.4zM256 336c0 27.3 13.9 70 56.9 98.7c7.4 4.9 9.3 14.8 4.4 22.2L301.9 480h68.2l-15.4-23.1c-4.9-7.4-2.9-17.3 4.4-22.2C402.1 406 416 363.3 416 336c0-33.7-14-62.3-32.4-84.7c-15.6-19-33.8-33-47.6-41.1c-13.8 8.1-32 22.1-47.6 41.1C270 273.7 256 302.3 256 336zM88 320H40c-4.4 0-8 3.6-8 8V472c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zm272-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHammerCrash = {
  prefix: 'fal',
  iconName: 'hammer-crash',
  icon: [640, 512, [], "e414", "M283.7 379.4l11.9-48.2c10.4 4.3 21.3 5.6 31.9 4.4l-4.4 17.7 71.3-35.9c6.9-3.5 15.2-1.6 19.9 4.5L463 385.2 479.3 307c1.6-7.5 8.3-12.9 15.9-12.7l79.8 1.4-50.9-61.5c-4.9-5.9-4.9-14.5 0-20.4l50.9-61.5-79.8 1.4c-7.7 .1-14.4-5.2-15.9-12.7L463 62.8l-30.4 39.5c-5.4-6.3-12.1-11.6-20-15.6l-6.1-3 52.3-68c3.8-5 10.2-7.2 16.2-5.8s10.8 6.2 12.1 12.3l20.8 99.3 101.4-1.8c6.2-.1 12 3.4 14.7 9.1s1.9 12.3-2.1 17.1L557.3 224 622 302.1c4 4.8 4.8 11.5 2.1 17.1s-8.5 9.2-14.7 9.1l-101.4-1.8-20.8 99.3c-1.3 6.1-6 10.9-12.1 12.3s-12.4-.9-16.2-5.8L397 351.8l-90.6 45.7c-5.6 2.8-12.3 2.1-17.2-1.8s-7.1-10.3-5.6-16.4zM72 48L32 128 320 272l64-128L192 48 72 48zM43.4 33.7C48.8 22.8 59.9 16 72 16H192c5 0 9.9 1.2 14.3 3.4l192 96c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-7.9 15.8-27.1 22.2-42.9 14.3l-97.9-48.9 0 0-28.6-14.3 0 0-28.6-14.3 0 0L122 208.8l0 0L17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80zM5.1 442.5L107.7 237.4l28.6 14.3L33.7 456.9c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L164.9 266l28.6 14.3L90.9 485.5c-11.9 23.7-40.7 33.3-64.4 21.5S-6.8 466.3 5.1 442.5z"]
};
var faMessageHeart = {
  prefix: 'fal',
  iconName: 'message-heart',
  icon: [512, 512, [], "e5c9", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 173.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L256 265.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM205.3 112c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faCloudMeatball = {
  prefix: 'fal',
  iconName: 'cloud-meatball',
  icon: [512, 512, [], "f73b", "M96 117.6c0-47.6 36.5-84.8 80-84.8c31.7 0 59.6 19.7 72.5 48.9c2.2 4.9 6.6 8.4 11.9 9.3s10.7-.9 14.4-4.8c11.7-12.4 27.7-19.9 45.2-19.9c34.6 0 64 29.7 64 68l0 .3c0 4.5 1.9 8.8 5.2 11.9s7.8 4.5 12.3 4.1c2.1-.2 4.3-.3 6.5-.3c39 0 72 33.5 72 76.4s-33 76.4-72 76.4h0l0 0H388.8c2.5 7.9 3.7 16.1 3.7 24.2c2.4 2.4 4.7 5 6.8 7.8h8.5 0l0 0c58.2 0 104-49.3 104-108.4c0-56.8-42.3-104.5-97.2-108.2c-7.2-47.2-46.3-84.2-94.8-84.2c-19.3 0-37.3 6-52.3 16.1C247.6 20.7 214.2 .8 176 .8c-62.6 0-112 53-112 116.8c0 3 .1 6 .3 9C26.3 142.9 0 181.9 0 226.8c0 59.1 45.8 108.4 104 108.4l0 0h0 8.5c2.1-2.7 4.4-5.3 6.8-7.8c0-8.2 1.2-16.4 3.7-24.2H104.1l0 0h0c-39 0-72-33.5-72-76.4c0-36.1 23.4-65.7 54-74c8.1-2.2 13.1-10.2 11.5-18.4c-1-5.4-1.6-11-1.6-16.8zM32 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0A48 48 0 1 0 0 400a48 48 0 1 0 96 0zm352 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM240 304c0-8.8 7.2-16 16-16s16 7.2 16 16c0 .5 0 1.1-.1 1.6c-.7 7 3.3 13.6 9.8 16.3s14 .8 18.5-4.6c.3-.4 .7-.8 1.1-1.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-.4 .4-.8 .7-1.2 1.1c-5.4 4.5-7.3 12-4.6 18.5s9.3 10.5 16.3 9.8c.5 0 1-.1 1.6-.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-.5 0-1.1 0-1.6-.1c-7-.7-13.6 3.3-16.3 9.8s-.8 14 4.6 18.5c.4 .3 .8 .7 1.2 1.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-.4-.4-.7-.8-1.1-1.2c-4.5-5.4-12-7.3-18.5-4.6s-10.5 9.3-9.8 16.3c0 .5 .1 1 .1 1.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.5 0-1.1 .1-1.6c.7-7-3.3-13.6-9.8-16.3s-14-.8-18.5 4.6c-.3 .4-.7 .8-1.1 1.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c.4-.4 .8-.7 1.2-1.1c5.4-4.5 7.3-12 4.6-18.5s-9.3-10.5-16.3-9.8c-.5 0-1 .1-1.6 .1c-8.8 0-16-7.2-16-16s7.2-16 16-16c.5 0 1.1 0 1.6 .1c7 .7 13.6-3.3 16.3-9.8s.8-14-4.6-18.5c-.4-.3-.8-.7-1.2-1.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l8.5-8.5-8.5 8.5c.4 .4 .7 .8 1.1 1.2c4.5 5.4 12 7.3 18.5 4.6s10.5-9.3 9.8-16.3c0-.5-.1-1-.1-1.6zm144 80c0-18.4-10.4-34.4-25.5-42.4c5-16.4 1.1-35.1-11.9-48.1s-31.6-17-48.1-11.9c-8.1-15.2-24-25.5-42.4-25.5s-34.4 10.4-42.4 25.5c-16.4-5-35.1-1.1-48.1 11.9s-17 31.6-11.9 48.1c-15.2 8.1-25.5 24-25.5 42.4s10.4 34.4 25.5 42.4c-5 16.4-1.1 35.1 11.9 48.1s31.6 17 48.1 11.9c8.1 15.2 24 25.5 42.4 25.5s34.4-10.4 42.4-25.5c16.4 5 35.1 1.1 48.1-11.9s17-31.6 11.9-48.1c15.2-8.1 25.5-24 25.5-42.4z"]
};
var faCameraPolaroid = {
  prefix: 'fal',
  iconName: 'camera-polaroid',
  icon: [576, 512, [], "f8aa", "M64 448H512c17.7 0 32-14.3 32-32V371.4c0-6.3-1.9-12.5-5.4-17.8l-1.1-1.6H38.5l-1.1 1.6c-3.5 5.3-5.4 11.4-5.4 17.8V416c0 17.7 14.3 32 32 32zM516.2 320l-28.1-42.2c-5.3-7.9-8.1-17.1-8.1-26.6V96c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V251.2c0 9.5-2.8 18.7-8.1 26.6L59.8 320H516.2zM512 480H64c-35.3 0-64-28.7-64-64V371.4c0-12.6 3.7-25 10.7-35.5L61.3 260c1.8-2.6 2.7-5.7 2.7-8.9V96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V251.2c0 3.2 .9 6.2 2.7 8.9l50.6 75.8c7 10.5 10.7 22.9 10.7 35.5V416c0 35.3-28.7 64-64 64zM416 152a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-128-8a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM112 384H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCamera = {
  prefix: 'fal',
  iconName: 'camera',
  icon: [512, 512, [62258, "camera-alt"], "f030", "M191.1 32c-20.7 0-39 13.2-45.5 32.8L135.1 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H376.9L366.5 64.8C359.9 45.2 341.6 32 320.9 32H191.1zM175.9 74.9c2.2-6.5 8.3-10.9 15.2-10.9H320.9c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h82.7c6.9 0 13-4.4 15.2-10.9l14-42.1zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 288a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faCameraAlt = faCamera;
var faSquareVirus = {
  prefix: 'fal',
  iconName: 'square-virus',
  icon: [448, 512, [], "e578", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM86.6 230.9c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24s24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24zm62.6-50.7c8.2 28.6-4.9 60.2-30.9 74.7c26 14.5 39.1 46.1 30.9 74.7c28.6-8.2 60.2 4.9 74.7 30.9c14.5-26 46.1-39.1 74.7-30.9c-8.2-28.6 4.9-60.2 30.9-74.7c-26-14.5-39.1-46.1-30.9-74.7c-16.4 4.7-33.9 2.4-48.5-5.4c-10.8-5.7-20.1-14.5-26.2-25.5c-14.5 26-46.1 39.1-74.7 30.9z"]
};
var faCartArrowUp = {
  prefix: 'fal',
  iconName: 'cart-arrow-up',
  icon: [576, 512, [], "e3ee", "M0 16C0 7.2 7.2 0 16 0H53.9c22.8 0 42.5 16 47 38.4L145.4 256H466.5c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM304 208V86.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 86.6V208c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faMeteor = {
  prefix: 'fal',
  iconName: 'meteor',
  icon: [512, 512, [9732], "f753", "M320 32c0-26.4-30.1-41.4-51.2-25.6L81.1 147.2C30 185.5 0 246.1 0 309.8C0 420.9 90 512 201.3 512c64.6 0 125.3-31 163.2-83.4L498.6 242.7c15.3-21.2 .2-50.7-25.9-50.7H446.6L509 50.3c2-4.5 3-9.5 3-14.4C512 16 496 0 476.2 0c-5 0-9.9 1-14.4 3L320 65.4V32zm154.6 .3c.5-.2 1-.3 1.5-.3c2.1 0 3.8 1.7 3.8 3.8c0 .5-.1 1.1-.3 1.5L407.4 201.6c-2.2 4.9-1.7 10.7 1.2 15.2s8 7.3 13.4 7.3h50.6L338.5 409.8C306.7 453.9 255.6 480 201.3 480C107.9 480 32 403.4 32 309.8c0-53.8 25.3-104.8 68.3-137L288 32V89.9c0 5.4 2.7 10.4 7.3 13.4s10.2 3.4 15.2 1.2L474.6 32.3zM296 312a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM200 184a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM184 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faCarOn = {
  prefix: 'fal',
  iconName: 'car-on',
  icon: [512, 512, [], "e4dd", "M272 24c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V24zM188.2 208H323.8c14.3 0 26.8 9.5 30.8 23.2L370.8 288c-.9 0-1.9 0-2.8 0H144c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L105 298.1C80.6 311.8 64 338 64 368v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H416v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H188.2c-28.6 0-53.7 18.9-61.5 46.4zM416 416v16H96V416 368c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v48zM144 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM44.7 44.7c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48c-6.2-6.2-16.4-6.2-22.6 0zm400 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faSleigh = {
  prefix: 'fal',
  iconName: 'sleigh',
  icon: [640, 512, [], "f7cc", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H32V256c0 59.6 40.8 109.8 96 124v68H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H568c39.8 0 72-32.2 72-72V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 22.1-17.9 40-40 40H448V384c70.7 0 128-57.3 128-128V128h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H576 544 488c-22.1 0-40 17.9-40 40v35.8c0 28.8-23.4 52.2-52.2 52.2c-72 0-139-37.1-177.1-98.2l-7.2-11.5C179.6 63.4 124 32.4 64 32l-1 0H56 32 16zM416 448H160V384H416v64zm72-320h56V256c0 53-43 96-96 96H160c-53 0-96-43-96-96V64c48.9 .4 94.3 25.7 120.3 67.2l7.2 11.5C235.5 213.2 312.7 256 395.8 256c46.5 0 84.2-37.7 84.2-84.2V136c0-4.4 3.6-8 8-8z"]
};
var faArrowDown19 = {
  prefix: 'fal',
  iconName: 'arrow-down-1-9',
  icon: [576, 512, ["sort-numeric-asc", "sort-numeric-down"], "f162", "M448 48V192h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432 384c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V70.2l-26.9 9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13zM171.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zM428 288a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm-84 52c0-46.4 37.6-84 84-84s84 37.6 84 84c0 1.3 0 2.7-.1 4h.1c0 21.2-7.6 41.8-21.5 57.9l-62.4 72.5c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.9-1.7-22.6L429.3 424c-.4 0-.9 0-1.3 0c-46.4 0-84-37.6-84-84z"]
};
var faSortNumericAsc = faArrowDown19;
var faSortNumericDown = faArrowDown19;
var faBuoyMooring = {
  prefix: 'fal',
  iconName: 'buoy-mooring',
  icon: [576, 512, [], "e5b6", "M272 16c0-8.8 7.2-16 16-16s16 7.2 16 16V65.1c46.7 6.7 85.5 42.3 94.6 89.9l45.8 240.3c-.4 .3-.8 .5-1.2 .8c-8.8 6.1-18.5 11.1-28.5 14.6L397.4 320H178.6l-17.3 90.7c-9.9-3.5-19.7-8.5-28.4-14.6c-.4-.3-.8-.6-1.2-.8L177.4 155c9.1-47.6 47.8-83.2 94.6-89.9V16zM208.9 161L184.7 288H391.3L367.1 161C360 123.4 326.5 96 288 96s-72 27.4-79.1 65zM192 480c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z"]
};
var faSquare4 = {
  prefix: 'fal',
  iconName: 'square-4',
  icon: [448, 512, [], "e259", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm133.9 97.1c-8.2-3.3-17.5 .7-20.8 8.9l-64 160c-2 4.9-1.4 10.5 1.6 14.9s7.9 7 13.2 7H256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H151.6l55.2-138.1c3.3-8.2-.7-17.5-8.9-20.8z"]
};
var faHandHoldingDroplet = {
  prefix: 'fal',
  iconName: 'hand-holding-droplet',
  icon: [576, 512, ["hand-holding-water"], "f4c1", "M235.6 121.1C228 132.1 224 145.1 224 158.3V160c0 35.3 28.7 64 64 64s64-28.7 64-64v-1.7c0-13.3-4-26.3-11.6-37.2L288 44.8l-52.4 76.3zM209.2 103L275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7H80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faHandHoldingWater = faHandHoldingDroplet;
var faTricycleAdult = {
  prefix: 'fal',
  iconName: 'tricycle-adult',
  icon: [640, 512, [], "e5c4", "M304 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h39c5.3 0 10.3 2.6 13.3 7L440 226.7l-53.2 70.9c-6.8 9-17.4 14.3-28.7 14.3c-2.8 0-5.6-.3-8.3-1L19.7 232.4c-8.6-2-17.2 3.3-19.3 11.9s3.3 17.2 11.9 19.3l31.9 7.6C17.6 288.2 0 318.1 0 352c0 53 43 96 96 96c18 0 34.8-4.9 49.1-13.5c-.4 .2-.8 .5-1.1 .7c14.1 8.2 30.5 12.8 48 12.8c53 0 96-43 96-96c0-8.1-1-16-2.9-23.5l57.3 13.6c5.1 1.2 10.4 1.8 15.7 1.8c21.4 0 41.5-10.1 54.3-27.1l46.6-62.1 18.8 27.8C459.4 300 448 324.7 448 352c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-14.2 0-27.7 3.1-39.8 8.6L382.8 85.1C373.8 71.9 359 64 343 64H304zM480 352c0-16.2 6.1-31.1 16-42.4L530.8 361c5 7.3 14.9 9.2 22.2 4.3s9.2-14.9 4.3-22.2l-34.7-51.3c6.7-2.4 13.9-3.7 21.5-3.7c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM247.1 319.5c5.6 9.5 8.9 20.6 8.9 32.5c0 35.3-28.7 64-64 64c-7.5 0-14.7-1.3-21.3-3.6C184 395.9 192 374.9 192 352c0-17.8-4.9-34.5-13.3-48.8l68.5 16.3zM62.9 106.1c-3.3-8.2-12.6-12.2-20.8-8.9s-12.2 12.6-8.9 20.8l23.3 58.3c7.3 18.3 22.6 32.1 41.4 37.7l89.6 26.2c8.5 2.5 17.4-2.4 19.9-10.9s-2.4-17.4-10.9-19.8l-89.6-26.2c-9.4-2.8-17.1-9.7-20.7-18.8L62.9 106.1zM94.4 416C59.8 415.1 32 386.8 32 352c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c0 0 0 0 0 0"]
};
var faWaveform = {
  prefix: 'fal',
  iconName: 'waveform',
  icon: [640, 512, [], "f8f1", "M320 0c8 0 14.8 5.9 15.9 13.9l49.3 369.5L432.2 77.6c1.2-7.9 8-13.6 16-13.6s14.6 6 15.7 13.8l34.6 254 29.8-158.8c1.4-7.3 7.6-12.7 15-13s14.1 4.5 16.1 11.6L588.1 272H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H576c-7.1 0-13.4-4.7-15.4-11.6l-13.4-46.8L511.7 434.9c-1.4 7.7-8.3 13.2-16.1 13s-14.4-6.1-15.5-13.8L447 191.4l-47.2 307c-1.2 7.9-8 13.6-16 13.6s-14.6-6-15.7-13.9L320 137.1 271.9 498.1c-1.1 7.9-7.7 13.8-15.7 13.9s-14.8-5.7-16-13.6L193 191.4 159.9 434.2c-1.1 7.8-7.6 13.6-15.5 13.8s-14.7-5.3-16.1-13L92.8 245.6 79.4 292.4c-2 6.9-8.2 11.6-15.4 11.6H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H51.9L80.6 171.6c2-7.1 8.7-11.9 16.1-11.6s13.6 5.7 15 13l29.8 158.8 34.6-254c1.1-7.9 7.8-13.8 15.7-13.8s14.7 5.7 16 13.6l47.1 305.9L304.1 13.9C305.2 5.9 312 0 320 0z"]
};
var faWater = {
  prefix: 'fal',
  iconName: 'water',
  icon: [576, 512, [], "f773", "M133.8 106.8C150.3 118 171.1 128 192 128s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 118 363.1 128 384 128s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 145.9 414.3 160 384 160s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 145.9 222.3 160 192 160s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 160.1 0 152 0 142.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zm0 288C150.3 406 171.1 416 192 416s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 406 363.1 416 384 416s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 433.9 414.3 448 384 448s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 433.9 222.3 448 192 448s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 448.1 0 440 0 430.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM192 272c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 262 363.1 272 384 272s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 289.9 414.3 304 384 304s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 289.9 222.3 304 192 304s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 304.1 0 296 0 286.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 262 171.1 272 192 272z"]
};
var faStarSharpHalfStroke = {
  prefix: 'fal',
  iconName: 'star-sharp-half-stroke',
  icon: [576, 512, ["star-sharp-half-alt"], "e28d", "M272 93.9V376.2L163.5 460.6l43.8-143.9c2-6.5-.4-13.6-5.9-17.6l-126-91H224c7 0 13.1-4.5 15.2-11.1L272 93.9zm32 282.3V93.9l32.8 102.9c2.1 6.6 8.3 11.1 15.2 11.1H500.7l-126 91c-5.5 4-7.9 11.1-5.9 17.6l43.8 143.9L304 376.2zM288 0c-11.7 0-22.1 7.6-25.7 18.8L212.3 176H58.6C43.9 176 32 187.9 32 202.6c0 8.5 4.1 16.6 11 21.6l130.3 94.1-50.8 167c-4.1 13.3 5.9 26.8 19.8 26.8c4.6 0 9.1-1.5 12.7-4.4L288 404.3 420.9 507.6c3.6 2.8 8.1 4.4 12.7 4.4c13.9 0 23.9-13.4 19.8-26.8l-50.8-167L533 224.1c6.9-5 11-13 11-21.6c0-14.7-11.9-26.6-26.6-26.6H363.7l-50-157.2C310.1 7.6 299.7 0 288 0z"]
};
var faStarSharpHalfAlt = faStarSharpHalfStroke;
var faNfcSignal = {
  prefix: 'fal',
  iconName: 'nfc-signal',
  icon: [512, 512, [], "e1fb", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H227c-1.6 10.5-2.6 21.2-2.9 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V227c-10.9 1.7-21.6 4-32 6.9V96c0-17.7-14.3-32-32-32zm0 64V245.3c-11.1 4.8-21.8 10.2-32 16.4V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32zM233.9 416H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0V384H245.3c-4.4 10.3-8.2 21-11.3 32zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm272 16c8.8 0 16 7.2 16 16s-7.2 16-16 16c-114.9 0-208 93.1-208 208c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-132.5 107.5-240 240-240zM480 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-80c0 8.8-7.2 16-16 16c-61.9 0-112 50.1-112 112c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-79.5 64.5-144 144-144c8.8 0 16 7.2 16 16z"]
};
var faPlaneProp = {
  prefix: 'fal',
  iconName: 'plane-prop',
  icon: [576, 512, [], "e22b", "M270 0c-16 0-29.6 11.9-31.7 27.8L235.6 48H224c-26.5 0-48 21.5-48 48c0 26.1 20.8 47.3 46.8 48l-4.9 37-67.1 9-3.9-27.6C144 142.6 127.1 128 107.2 128H84.8c-19.9 0-36.8 14.6-39.6 34.3l-6.1 42.9C16.3 211.2 0 231.9 0 256s16.3 44.8 39.1 50.8l6.1 42.9C48 369.4 64.9 384 84.8 384h22.4c19.9 0 36.8-14.6 39.6-34.3l3.9-27.6 67.1 9 4.9 37c-26 .6-46.8 21.9-46.8 48c0 26.5 21.5 48 48 48h11.6l2.7 20.2C240.4 500.1 254 512 270 512h36c16 0 29.6-11.9 31.7-27.8l7-52.2H368v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432c8.8 0 16-7.2 16-16s-7.2-16-16-16V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H348.9l8.5-64 108.8 0c20.6 0 46.8-8.1 67.9-20.8C554.4 303.1 576 282.9 576 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2H357.5l-8.5-64H368v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c8.8 0 16-7.2 16-16s-7.2-16-16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V80H344.7l-7-52.2C335.6 11.9 322 0 306 0H270zM224 400h3.1l4.3 32H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0-320h7.3l-4.3 32H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm101.2 96H256c-.7 0-1.4 0-2.1 .1l-3.2 .4L270 32h36l19.2 144zm0 160L306 480H270L250.7 335.4l3.2 .4c.7 .1 1.4 .1 2.1 .1h69.2zM76.9 166.9c.6-3.9 3.9-6.9 7.9-6.9h22.4c4 0 7.4 2.9 7.9 6.9l6.2 43.2c1.2 8.7 9.3 14.8 18 13.6L257.1 208H466.3c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2l-209.3 0L139.2 288.3c-8.7-1.2-16.7 4.9-18 13.6l-6.2 43.2c-.6 3.9-3.9 6.9-7.9 6.9H84.8c-4 0-7.4-2.9-7.9-6.9l-7.8-54.4c-1-7.1-6.6-12.6-13.7-13.6l-5.6-.7C39.6 275 32 266.3 32 256s7.6-19 17.8-20.4l5.6-.7c7.1-.9 12.7-6.5 13.7-13.6l7.8-54.4z"]
};
var faCalendarCheck = {
  prefix: 'fal',
  iconName: 'calendar-check',
  icon: [448, 512, [], "f274", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM331.3 283.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l112-112z"]
};
var faClockDesk = {
  prefix: 'fal',
  iconName: 'clock-desk',
  icon: [448, 512, [], "e134", "M32 224a192 192 0 1 1 384 0A192 192 0 1 1 32 224zM416 339.4V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V339.4C71.2 404.5 142.5 448 224 448s152.8-43.5 192-108.6zM0 224V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V224C448 100.3 347.7 0 224 0S0 100.3 0 224zM224 96c-8.8 0-16 7.2-16 16V224c0 4.2 1.7 8.3 4.7 11.3l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 217.4V112c0-8.8-7.2-16-16-16z"]
};
var faCalendarClock = {
  prefix: 'fal',
  iconName: 'calendar-clock',
  icon: [576, 512, ["calendar-time"], "e0d2", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32 .7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V192H32V448c0 17.7 14.3 32 32 32H296.2c10 12.1 21.7 22.9 34.6 32H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32zm48 384a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faCalendarTime = faCalendarClock;
var faBraille = {
  prefix: 'fal',
  iconName: 'braille',
  icon: [640, 512, [], "f2a1", "M64 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm160 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0zm64 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 256a64 64 0 1 0 128 0zM192 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 160 96a64 64 0 1 0 128 0zM416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM544 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 512 96a64 64 0 1 0 128 0zM576 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM240 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faPrescriptionBottleMedical = {
  prefix: 'fal',
  iconName: 'prescription-bottle-medical',
  icon: [384, 512, ["prescription-bottle-alt"], "f486", "M336 32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H336zM48 0C21.5 0 0 21.5 0 48V80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM32 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160H320V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160H32zm149.3 32c-17.7 0-32 14.3-32 32v21.3H128c-17.7 0-32 14.3-32 32v21.3c0 17.7 14.3 32 32 32h21.3V352c0 17.7 14.3 32 32 32h21.3c17.7 0 32-14.3 32-32V330.7H256c17.7 0 32-14.3 32-32V277.3c0-17.7-14.3-32-32-32H234.7V224c0-17.7-14.3-32-32-32H181.3zm0 32h21.3l0 37.3c0 8.8 7.2 16 16 16H256v21.3l-37.3 0c-8.8 0-16 7.2-16 16V352H181.3V314.7c0-8.8-7.2-16-16-16H128V277.3h37.3c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V224z"]
};
var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
var faPlateUtensils = {
  prefix: 'fal',
  iconName: 'plate-utensils',
  icon: [640, 512, [58713], "e43b", "M16 16C7.2 16 0 23.2 0 32V176c0 26.5 21.5 48 48 48H64V480c0 8.8 7.2 16 16 16s16-7.2 16-16V224h16c26.5 0 48-21.5 48-48V32c0-8.8-7.2-16-16-16s-16 7.2-16 16V176c0 8.8-7.2 16-16 16H96V32c0-8.8-7.2-16-16-16s-16 7.2-16 16V192H48c-8.8 0-16-7.2-16-16V32c0-8.8-7.2-16-16-16zM498 78.9C455.3 39.8 398.4 16 336 16c-54 0-103.9 17.9-144 48v41.9C229.4 70 280.1 48 336 48c58.9 0 112 24.5 149.9 63.8c3.1-12 7.2-22.9 12.1-32.9zm24.5 269.4C488.5 416.9 417.7 464 336 464c-73.8 0-138.6-38.4-175.5-96.4c-8.5 6.5-18.3 11.3-29 14C173.7 450.2 249.5 496 336 496c98.4 0 183-59.2 220-144H544c-7.6 0-14.8-1.3-21.5-3.7zM480 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-256 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM608 54.4V288H544V160c0-61.3 39.4-92.2 64-105.6zM640 288V36.9c0-11.5-9.3-20.9-20.9-20.9c-2.1 0-4.1 .3-6.1 1C596.2 23.2 512 59.2 512 160V288c0 17.7 14.3 32 32 32h64V480c0 8.8 7.2 16 16 16s16-7.2 16-16V320 304 288z"]
};
var faFamilyPants = {
  prefix: 'fal',
  iconName: 'family-pants',
  icon: [512, 512, [], "e302", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320h59.6c-.7 5.2-1.1 10.6-1.1 16v16H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c7 0 13.8 .9 20.2 2.6c-1.7 6.9-2.6 14-2.6 21.4c0 3.9 .3 7.8 .8 11.6c-5.7-2.4-11.9-3.6-18.4-3.6H105.6c-25 0-45.8 19.1-47.8 44zM416 352H368V336c0-5.4-.4-10.8-1.1-16h59.6c18.7 0 33.4-16 31.9-34.7L454.2 236c-2.1-24.9-22.9-44-47.8-44H361.6c-6.5 0-12.7 1.3-18.4 3.6c.5-3.8 .8-7.7 .8-11.6c0-7.4-.9-14.6-2.6-21.4c6.5-1.7 13.3-2.6 20.2-2.6h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352zm0-288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 320 64zM256 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160c-26.5 0-48 21.5-48 48v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V336c0-26.5-21.5-48-48-48zM208 413.3c-18.6-6.6-32-24.4-32-45.3V336c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 20.9-13.4 38.7-32 45.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H240v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V413.3z"]
};
var faHoseReel = {
  prefix: 'fal',
  iconName: 'hose-reel',
  icon: [640, 512, [], "e41a", "M96 256C96 132.3 196.3 32 320 32s224 100.3 224 224v96H512c-8.8 0-16 7.2-16 16s7.2 16 16 16h1.9l12 96.1c-7.8 1-13.9 7.7-13.9 15.9c0 8.8 7.2 16 16 16h1.9H544h32 14.1H592c8.8 0 16-7.2 16-16c0-8.1-6.1-14.8-13.9-15.9l12-96.1H608c8.8 0 16-7.2 16-16s-7.2-16-16-16H576V256C576 114.6 461.4 0 320 0S64 114.6 64 256s114.6 256 256 256c57.6 0 110.8-19 153.6-51.2c7.1-5.3 8.5-15.3 3.2-22.4s-15.3-8.5-22.4-3.2C417 463.3 370.4 480 320 480C196.3 480 96 379.7 96 256zM573.9 384l-12 96h-3.8l-12-96H560h13.9zM464 256a144 144 0 1 1 -288 0 144 144 0 1 1 288 0zM320 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352zm0 240a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z"]
};
var faHouseWindow = {
  prefix: 'fal',
  iconName: 'house-window',
  icon: [576, 512, [], "e3b3", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zM240 192c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H240zm0 32h96v96H240V224z"]
};
var faLandmark = {
  prefix: 'fal',
  iconName: 'landmark',
  icon: [512, 512, [127963], "f66f", "M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192H480.8c17.2 0 31.2-14 31.2-31.2c0-11.2-6-21.6-15.8-27.1L263.9 2.1zM256 34.4L477.7 160H34.3L256 34.4zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H448c8.8 0 16-7.2 16-16s-7.2-16-16-16V224H416V352H336V224H304V352H208V224H176V352H96V224H64V352zM24 432c0 8.8 7.2 16 16 16H472c8.8 0 16-7.2 16-16s-7.2-16-16-16H40c-8.8 0-16 7.2-16 16zM0 496c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16z"]
};
var faTruck = {
  prefix: 'fal',
  iconName: 'truck',
  icon: [640, 512, [128666, 9951], "f0d1", "M64 32C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H384V64c0-17.7-14.3-32-32-32H64zm0 384c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V96h65.3c14 0 27.3 6.1 36.4 16.8l78.7 91.8c7.5 8.7 11.6 19.8 11.6 31.2V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96zM416 224H570.9l-77.5-90.4c-3-3.5-7.5-5.6-12.1-5.6H416v96zm0 32v88.4c17-15.2 39.4-24.4 64-24.4c41.8 0 77.4 26.7 90.5 64H576V256H416zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faCrosshairs = {
  prefix: 'fal',
  iconName: 'crosshairs',
  icon: [512, 512, [], "f05b", "M256 0c8.8 0 16 7.2 16 16V48.6C374.1 56.4 455.6 137.9 463.4 240H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H463.4C455.6 374.1 374.1 455.6 272 463.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V463.4C137.9 455.6 56.4 374.1 48.6 272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H48.6C56.4 137.9 137.9 56.4 240 48.6V16c0-8.8 7.2-16 16-16zM80.7 272c7.6 84.4 74.8 151.7 159.3 159.3V384c0-8.8 7.2-16 16-16s16 7.2 16 16v47.3c84.4-7.6 151.7-74.8 159.3-159.3H384c-8.8 0-16-7.2-16-16s7.2-16 16-16h47.3C423.7 155.6 356.4 88.3 272 80.7V128c0 8.8-7.2 16-16 16s-16-7.2-16-16V80.7C155.6 88.3 88.3 155.6 80.7 240H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80.7zM256 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCloudRainbow = {
  prefix: 'fal',
  iconName: 'cloud-rainbow',
  icon: [576, 512, [], "f73e", "M284.8 196.9C337.4 98.8 440.9 32 560 32c8.8 0 16-7.2 16-16s-7.2-16-16-16C427.8 0 313.1 74.5 255.5 183.9c7.2 4.8 13.9 10.1 20.1 16c3-1.1 6.1-2.1 9.3-3zm155.4 78.9c6 1.5 11.8 3.3 17.5 5.5c21.1-34.4 59-57.3 102.4-57.3c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-99.6 27.1-126.8 68.2c2.7 5 5 10.3 7 15.6zm-51.2-63.7C428.4 161 490.4 128 560 128c8.8 0 16-7.2 16-16s-7.2-16-16-16c-82.5 0-155.5 40.2-200.6 102.2c10.5 3.4 20.4 8.1 29.5 13.9zM96 304c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 408c0-55.2-43-100.3-97.3-103.8C407.2 258.7 367.6 224 320 224c-19.3 0-37.3 5.7-52.4 15.5C247.3 210.8 213.9 192 176 192c-61.9 0-112 50.1-112 112c0 2.6 .1 5.3 .3 7.9C26.6 327.5 0 364.6 0 408c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104z"]
};
var faPersonCane = {
  prefix: 'fal',
  iconName: 'person-cane',
  icon: [448, 512, [], "e53c", "M248 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 168 56zM144 164V320h64V161.2c-3.4-.8-6.9-1.2-10.5-1.2H163.3c-6.8 0-13.3 1.4-19.3 4zm-32 38.1L62.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L92.7 170.3c13.9-26 41-42.3 70.6-42.3h34.2c23.5 0 45.7 10.3 60.9 28.2l89.8 105.5c5.7 6.7 4.9 16.8-1.8 22.6s-16.8 4.9-22.6-1.8L240 183.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H144V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.2zM368 352c-8.8 0-16 7.2-16 16v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-26.5 21.5-48 48-48s48 21.5 48 48V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8-7.2-16-16-16z"]
};
var faAlien = {
  prefix: 'fal',
  iconName: 'alien',
  icon: [448, 512, [128125], "f8f5", "M224 32C118 32 32 118 32 224c0 56.2 31.2 110.7 72.2 157.4c40.4 46.1 86.7 80.4 108.6 95.4c2.8 1.9 6.6 3.2 11.2 3.2s8.4-1.3 11.2-3.2c21.9-15 68.1-49.3 108.6-95.4C384.8 334.7 416 280.2 416 224c0-106-86-192-192-192zM0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 135.3-148.8 247.7-194.7 279.2c-8.6 5.9-18.9 8.8-29.3 8.8s-20.7-2.9-29.3-8.8C148.8 471.7 0 359.3 0 224zm350 16H336c-29.8 0-54.9 20.4-62 48h14c29.8 0 54.9-20.4 62-48zm-14-32h32c8.8 0 16 7.2 16 16c0 53-43 96-96 96H256c-8.8 0-16-7.2-16-16c0-53 43-96 96-96zM112 240H98c7.1 27.6 32.2 48 62 48h14c-7.1-27.6-32.2-48-62-48zm96 64c0 8.8-7.2 16-16 16H160c-53 0-96-43-96-96c0-8.8 7.2-16 16-16h32c53 0 96 43 96 96z"]
};
var faTent = {
  prefix: 'fal',
  iconName: 'tent',
  icon: [576, 512, [], "e57d", "M278.9 2.8c5.5-3.8 12.7-3.8 18.2 0L517.3 154.7c11.3 7.8 18.7 20 20.4 33.6L571.4 458c3.6 28.6-18.8 54-47.6 54H52.2C23.4 512 1 486.7 4.6 458L38.3 188.2c1.7-13.6 9.1-25.8 20.4-33.6L278.9 2.8zM76.9 181c-3.8 2.6-6.2 6.7-6.8 11.2L36.4 462c-1.2 9.5 6.3 18 15.9 18H272V46.5L76.9 181zM405.4 480L304 288.4V480H405.4zm36.2 0h82.1c9.6 0 17.1-8.4 15.9-18L505.9 192.2c-.6-4.5-3-8.6-6.8-11.2L304 46.5V220L441.6 480z"]
};
var faLaptopBinary = {
  prefix: 'fal',
  iconName: 'laptop-binary',
  icon: [640, 512, [], "e5e7", "M128 64H512c17.7 0 32 14.3 32 32V352h32V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V352H96V96c0-17.7 14.3-32 32-32zM33.9 416H606.1c-5.5 18.5-22.6 32-42.9 32H76.8c-20.3 0-37.4-13.5-42.9-32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2zM200 128c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40H200zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V168zm112-40c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16H304zm80 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40H424c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V168c0-4.4 3.6-8 8-8zM192 272c-8.8 0-16 7.2-16 16s7.2 16 16 16v48h32V288c0-8.8-7.2-16-16-16H192zm256 16c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16s7.2 16 16 16v48h32V288zm-80 24c0-22.1-17.9-40-40-40H312c-22.1 0-40 17.9-40 40v40h32V312c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v40h32V312z"]
};
var faVestPatches = {
  prefix: 'fal',
  iconName: 'vest-patches',
  icon: [448, 512, [], "e086", "M173.4 69.1l33.4 87.4-17.1 44.8L125.3 32.8c-1.7-.5-3.3-.8-4.9-.8H96c-8.8 0-16 7.2-16 16v80 58.7c0 11.6-3.2 23-9.1 32.9L36.6 276.8c-3 5-4.6 10.7-4.6 16.5V464c0 8.8 7.2 16 16 16H161.6c2.4 11.8 7.4 22.7 14.4 32H48c-26.5 0-48-21.5-48-48V293.3c0-11.6 3.2-23 9.1-32.9l34.3-57.2c3-5 4.6-10.7 4.6-16.5V128 48l0-.3C48.2 21.3 69.6 0 96 0h24.4H125c6.3 0 12.3 1.8 17.4 5.1C152.6 10 161 17.6 167.1 24.7C176 35 192.9 48 224 48s48-13 56.9-23.3C287 17.6 295.4 10 305.6 5.1C310.7 1.8 316.7 0 323 0h4.6H352c26.5 0 48 21.5 48 48v80 58.7c0 5.8 1.6 11.5 4.6 16.5l34.3 57.2c6 9.9 9.1 21.3 9.1 32.9V464c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V296.9c0-7.8 1.4-15.6 4.2-22.9L274.6 69.1C261.3 75.6 244.6 80 224 80s-37.3-4.4-50.6-10.9zM322.7 32.8L226.1 285.4c-1.4 3.6-2.1 7.5-2.1 11.4V464c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V293.3c0-5.8-1.6-11.5-4.6-16.5l-34.3-57.2c-6-9.9-9.1-21.3-9.1-32.9V128 48c0-7.7-5.5-14.2-12.8-15.7c-1-.2-2.1-.3-3.2-.3H327.6c-1.6 0-3.2 .3-4.9 .8zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-4.7-107.3L120 257.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L142.6 280l12.7 12.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L120 302.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.4 280 84.7 267.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM312 240c19.6 0 35.9 14.1 39.3 32.7c18.6 3.4 32.7 19.7 32.7 39.3c0 22.1-17.9 40-40 40h-8H288c-8.8 0-16-7.2-16-16V288v-8c0-22.1 17.9-40 40-40zm-8 40v8 32h32 8c4.4 0 8-3.6 8-8s-3.6-8-8-8h-8c-8.8 0-16-7.2-16-16v-8c0-4.4-3.6-8-8-8s-8 3.6-8 8z"]
};
var faPeopleDressSimple = {
  prefix: 'fal',
  iconName: 'people-dress-simple',
  icon: [512, 512, [], "e218", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM81.5 215.2L42.4 352H213.6L174.5 215.2C170.6 201.5 158 192 143.7 192H112.3c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4zM416 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm17.5 151.2L298.4 352H469.6L430.5 215.2C426.6 201.5 414 192 399.7 192H368.3c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H352V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H298.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"]
};
var faCheckDouble = {
  prefix: 'fal',
  iconName: 'check-double',
  icon: [448, 512, [], "f560", "M331.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 201.4 91.3 132.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l160-160zm112 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 425.4 27.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0l272-272z"]
};
var faArrowDownAZ = {
  prefix: 'fal',
  iconName: 'arrow-down-a-z',
  icon: [576, 512, ["sort-alpha-asc", "sort-alpha-down"], "f15d", "M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm163-338.5l63.9 127.7c.1 .2 .2 .4 .3 .6l15.8 31.7c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L470.1 192H361.9l-11.6 23.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l15.8-31.7c.1-.2 .2-.4 .3-.6L401.7 40.8c2.7-5.4 8.2-8.8 14.3-8.8s11.6 3.4 14.3 8.8zM416 83.8L377.9 160h76.2L416 83.8zM352 288H480c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L385.3 448H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9L446.7 320H352c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSortAlphaAsc = faArrowDownAZ;
var faSortAlphaDown = faArrowDownAZ;
var faBowlingBallPin = {
  prefix: 'fal',
  iconName: 'bowling-ball-pin',
  icon: [576, 512, [], "e0c3", "M464 32c22.1 0 40 17.9 40 40v4.4c0 6.4-.8 12.8-2.3 19l-9.4 37.4c-2.2 8.9-3.6 18-4.1 27.2H439.8c-.5-9.2-1.9-18.3-4.1-27.2l-9.4-37.4c-1.6-6.2-2.3-12.6-2.3-19V72c0-22.1 17.9-40 40-40zM432.5 219c3-8.8 5-17.8 6.2-27h50.5c1.8 13.4 5.4 26.5 10.8 38.9l30.8 70.4c8.6 19.8 13.1 41.1 13.1 62.7c0 26.2-6.6 51.9-19.1 74.9L502.5 480h-77l-20.9-38.3c-6.6 9.5-13.9 18.4-21.8 26.8l16.9 31c4.2 7.7 12.3 12.5 21.1 12.5h86.5c8.8 0 16.9-4.8 21.1-12.5L553 454.2c15.1-27.7 23-58.7 23-90.2c0-26-5.4-51.7-15.8-75.5l-30.8-70.4c-6.2-14.2-9.4-29.4-9.4-44.9v-5.5c0-9.2 1.1-18.3 3.3-27.2l9.4-37.4c2.2-8.8 3.3-17.7 3.3-26.8V72c0-39.8-32.2-72-72-72s-72 32.2-72 72v4.4c0 9 1.1 18 3.3 26.8l9.4 37.4c2.2 8.9 3.3 18 3.3 27.2v3.5c9.9 14.8 18.1 30.8 24.5 47.7zM208 128a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm-8-224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBellSchoolSlash = {
  prefix: 'fal',
  iconName: 'bell-school-slash',
  icon: [640, 512, [], "f5d6", "M480 208C480 93.1 386.9 0 272 0c-45.8 0-88.1 14.8-122.5 39.9l26.3 20.7C203.4 42.5 236.5 32 272 32c97.2 0 176 78.8 176 176c0 20.8-3.6 40.8-10.3 59.4L464 288.1c10.3-24.7 16-51.7 16-80.1zM96 208c0-14.9 1.8-29.3 5.3-43.1L74.2 143.5C67.6 163.8 64 185.5 64 208c0 59 24.6 112.2 64 150.1V448c0 35.3 28.7 64 64 64H336h16H480c15.9 0 30.4-5.8 41.6-15.3L495.4 476c-4.6 2.5-9.8 4-15.4 4H407.4c5.4-9.4 8.6-20.3 8.6-32V413.3l-32-25.3V448c0 17.7-14.3 32-32 32H336 192c-17.7 0-32-14.3-32-32V383.3C192.3 404 230.8 416 272 416c39.8 0 77-11.2 108.6-30.6L353.5 364c-24.4 12.8-52.1 20-81.5 20c-97.2 0-176-78.8-176-176zm176-80c-3.4 0-6.8 .2-10.1 .6l89.6 70.7C347.2 159.2 313.3 128 272 128zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faPlusLarge = {
  prefix: 'fal',
  iconName: 'plus-large',
  icon: [512, 512, [], "e59e", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0 0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224 224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0 0-224z"]
};
var faMoneyBillWheat = {
  prefix: 'fal',
  iconName: 'money-bill-wheat',
  icon: [512, 512, [], "e52a", "M224 80v5.3c-18.6-6.6-32-24.4-32-45.3V34.7c18.6 6.6 32 24.4 32 45.3zM160 16V40c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80v-8V104 80c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM48 16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zM16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm16 96c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM336 85.3c-18.6-6.6-32-24.4-32-45.3V34.7c18.6 6.6 32 24.4 32 45.3v5.3zM288 0c-8.8 0-16 7.2-16 16V40c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80v-8V104 80c0-44.2-35.8-80-80-80zM448 80v5.3c-18.6-6.6-32-24.4-32-45.3V34.7c18.6 6.6 32 24.4 32 45.3zM384 16V40c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80v-8V104 80c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM304 189.3V184c0-20.9 13.4-38.7 32-45.3V144c0 20.9-13.4 38.7-32 45.3zM192 184c0-20.9 13.4-38.7 32-45.3V144c0 20.9-13.4 38.7-32 45.3V184zm224 5.3V184c0-20.9 13.4-38.7 32-45.3V144c0 20.9-13.4 38.7-32 45.3zM480 304v32c-26.5 0-48-21.5-48-48h32c8.8 0 16 7.2 16 16zM32 368c44.2 0 80-35.8 80-80H400c0 44.2 35.8 80 80 80v32c-44.2 0-80 35.8-80 80H112c0-44.2-35.8-80-80-80V368zM432 480c0-26.5 21.5-48 48-48v32c0 8.8-7.2 16-16 16H432zM32 432c26.5 0 48 21.5 48 48H48c-8.8 0-16-7.2-16-16V432zM80 288c0 26.5-21.5 48-48 48V304c0-8.8 7.2-16 16-16H80zM48 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faCameraViewfinder = {
  prefix: 'fal',
  iconName: 'camera-viewfinder',
  icon: [512, 512, ["screenshot"], "e0da", "M0 48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8 7.2-16 16-16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48C21.5 0 0 21.5 0 48zM216.6 96c-16.7 0-31.6 10.3-37.5 26l-2.3 6H152c-30.9 0-56 25.1-56 56V328c0 30.9 25.1 56 56 56H360c30.9 0 56-25.1 56-56V184c0-30.9-25.1-56-56-56H335.1l-2.3-6C327 106.3 312 96 295.4 96H216.6zm-7.5 37.2c1.2-3.1 4.2-5.2 7.5-5.2h78.7c3.3 0 6.3 2.1 7.5 5.2l6.2 16.4c2.3 6.2 8.3 10.4 15 10.4h36c13.3 0 24 10.7 24 24V328c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24h36c6.7 0 12.6-4.1 15-10.4l6.2-16.4zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM464 0H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-26.5-21.5-48-48-48zM0 464c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v96zm464 48c26.5 0 48-21.5 48-48V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h96z"]
};
var faScreenshot = faCameraViewfinder;
var faMessageMusic = {
  prefix: 'fal',
  iconName: 'message-music',
  icon: [512, 512, ["comment-alt-music"], "f8af", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM345.1 82.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V155.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V96c0-5.2-2.6-10.2-6.9-13.2zM320 244c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM192 276c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z"]
};
var faCommentAltMusic = faMessageMusic;
var faCarBuilding = {
  prefix: 'fal',
  iconName: 'car-building',
  icon: [640, 512, [], "f859", "M64 32H288c17.7 0 32 14.3 32 32V165.2c9.4-7.6 20.3-13.4 32-17V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H224V448H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM264 192H216c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h41.6c3.7-3.7 7.7-7.1 11.9-10.2l18.3-64.2C286.7 201.5 276.5 192 264 192zM88 64C74.7 64 64 74.7 64 88v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24H88zm8 64V96h32v32H96zm96-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24zm32 8h32v32H224V96zM88 192c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H88zm8 64V224h32v32H96zm128-32h32v32H224V224zM88 320c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H88zm8 64V352h32v32H96zM380.2 208H515.8c14.3 0 26.8 9.5 30.8 23.2L562.8 288c-.9 0-1.9 0-2.8 0H336c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L297 298.1c-24.5 13.7-41 39.9-41 69.9v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H608v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H380.2c-28.6 0-53.7 18.9-61.5 46.4zM608 416v16H288V416 368c0-26.5 21.5-48 48-48H560c26.5 0 48 21.5 48 48v48zM336 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faBorderBottomRight = {
  prefix: 'fal',
  iconName: 'border-bottom-right',
  icon: [448, 512, ["border-style-alt"], "f854", "M448 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 17.7-14.3 32-32 32L32 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c35.3 0 64-28.7 64-64l0-352zM320 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM128 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faBorderStyleAlt = faBorderBottomRight;
var faOctagon = {
  prefix: 'fal',
  iconName: 'octagon',
  icon: [512, 512, [128721], "f306", "M163.2 43.8c7.5-7.5 17.7-11.7 28.3-11.7h129c10.6 0 20.8 4.2 28.3 11.7L468.2 163.2c7.5 7.5 11.7 17.7 11.7 28.3v129c0 10.6-4.2 20.8-11.7 28.3L348.8 468.2c-7.5 7.5-17.7 11.7-28.3 11.7h-129c-10.6 0-20.8-4.2-28.3-11.7L43.8 348.8 21.2 371.4l22.6-22.6c-7.5-7.5-11.7-17.7-11.7-28.3v-129c0-10.6 4.2-20.8 11.7-28.3L163.2 43.8zM.1 320.5c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1h129c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9v-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1h-129c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5v129z"]
};
var faCommentArrowUpRight = {
  prefix: 'fal',
  iconName: 'comment-arrow-up-right',
  icon: [512, 512, [], "e145", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM192 152c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L172.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 206.6V296c0 8.8 7.2 16 16 16s16-7.2 16-16V168c0-8.8-7.2-16-16-16H192z"]
};
var faOctagonDivide = {
  prefix: 'fal',
  iconName: 'octagon-divide',
  icon: [512, 512, [], "e203", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM256 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 240H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCookie = {
  prefix: 'fal',
  iconName: 'cookie',
  icon: [512, 512, [127850], "f563", "M242.7 48.7c-15.4-2.2-31.1 .6-44.8 7.9l-74 39.5C110.1 103.4 99.1 115 92.2 129L55.5 204.6c-6.8 14.1-9.1 30-6.4 45.4l14.5 82.8c2.7 15.4 10.2 29.6 21.4 40.4l60.3 58.4c11.2 10.9 25.5 17.9 40.9 20l83 11.7c15.4 2.2 31.1-.6 44.8-7.9l74-39.5c13.7-7.3 24.8-18.8 31.7-32.9l36.7-75.5c6.8-14.1 9.1-30 6.4-45.4l-14.6-82.8c-2.7-15.4-10.2-29.6-21.4-40.4L366.6 80.5c-11.2-10.9-25.5-17.9-40.9-20l-83-11.7zM182.8 28.4c19.7-10.5 42.3-14.5 64.4-11.4l83 11.7c22.1 3.1 42.7 13.2 58.7 28.7l60.3 58.4c16.1 15.6 26.8 35.8 30.7 57.9l14.6 82.8c3.9 22.1 .7 44.8-9.1 64.9L448.6 397c-9.8 20.1-25.7 36.6-45.4 47.2l-74 39.5c-19.7 10.5-42.3 14.5-64.4 11.4l-83-11.7c-22.1-3.1-42.7-13.2-58.7-28.7L62.8 396.2C46.8 380.6 36 360.3 32.2 338.3L17.6 255.5c-3.9-22.1-.7-44.8 9.1-64.9L63.4 115c9.8-20.1 25.7-36.6 45.4-47.2l74-39.5zM160 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm8 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm8-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faArrowRotateLeft = {
  prefix: 'fal',
  iconName: 'arrow-rotate-left',
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M48 192c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16v92.6C103.2 75.5 174.5 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-79.9 0-150-41.8-189.7-104.8C59.8 364.8 67.7 352 80 352c6 0 11.4 3.2 14.7 8.2C128.9 413 188.4 448 256 448c106 0 192-86 192-192s-86-192-192-192c-71.1 0-133.1 38.6-166.3 96H176c8.8 0 16 7.2 16 16s-7.2 16-16 16H48z"]
};
var faArrowLeftRotate = faArrowRotateLeft;
var faArrowRotateBack = faArrowRotateLeft;
var faArrowRotateBackward = faArrowRotateLeft;
var faUndo = faArrowRotateLeft;
var faTvMusic = {
  prefix: 'fal',
  iconName: 'tv-music',
  icon: [640, 512, [], "f8e6", "M576 32c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H576zM64 0C28.7 0 0 28.7 0 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 496c0 8.8 7.2 16 16 16H528c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM409.1 98.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V171.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V112c0-5.2-2.6-10.2-6.9-13.2zM384 260c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM256 292c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z"]
};
var faHardDrive = {
  prefix: 'fal',
  iconName: 'hard-drive',
  icon: [512, 512, [128436, "hdd"], "f0a0", "M64 64C46.3 64 32 78.3 32 96V264.6c9.4-5.4 20.3-8.6 32-8.6H448c11.7 0 22.6 3.1 32 8.6V96c0-17.7-14.3-32-32-32H64zM32 320v96c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zM0 320V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V320v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320zm320 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faHdd = faHardDrive;
var faReel = {
  prefix: 'fal',
  iconName: 'reel',
  icon: [448, 512, [], "e238", "M0 16C0 7.2 7.2 0 16 0H80 368h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H384V96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V32H16C7.2 32 0 24.8 0 16zM96 32V80H352V32H96zM64 160c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zM16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V416c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H368 80 16zm80-80v48H352V432H96z"]
};
var faFaceGrinSquintTears = {
  prefix: 'fal',
  iconName: 'face-grin-squint-tears',
  icon: [512, 512, [129315, "grin-squint-tears"], "f586", "M421 91.1c1.3-6.5 2.8-13.3 4.5-19.8c2.3-9.2 4.9-17.3 7.5-23.6c2.3-5.7 4-8.1 4.4-8.7c.1-.1 .1-.2 0-.1c9-9 24.7-9.5 35 .9s9.8 26 .9 35c.1-.1 0 0-.1 0c-.5 .4-3 2-8.7 4.4c-6.4 2.6-14.5 5.1-23.6 7.5c-6.6 1.7-13.3 3.2-19.8 4.5zm-36.9 26c-1 6.4 4.4 11.8 10.8 10.8c25.8-3.5 84-13.6 100.9-30.5c22-22 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9c-16.9 16.9-26.9 75.2-30.5 100.9zM32 256C32 132.3 132.3 32 256 32c31.4 0 61.2 6.4 88.3 18.1c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21C325.9 7.4 291.8 0 256 0C114.6 0 0 114.6 0 256c0 36.4 7.6 71 21.3 102.4c3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1C38.7 318.2 32 287.9 32 256zM490.7 153.6c-3.5-8.1-13-11.8-21.1-8.3s-11.8 13-8.3 21.1c12 27.4 18.6 57.7 18.6 89.6c0 123.7-100.3 224-224 224c-32.4 0-63.1-6.9-90.9-19.2c-8.1-3.6-17.5 0-21.1 8.1s0 17.5 8.1 21.1c31.8 14.1 66.9 22 103.9 22c141.4 0 256-114.6 256-256c0-36.4-7.6-71-21.3-102.4zM325.4 325.4c22.1-22 41.4-45.4 57.7-69.5c.7 32.6-11.4 65.6-36.5 90.7s-58 37.2-90.7 36.5c24-16.3 47.4-35.6 69.5-57.7zm79.3-122.7c-4.6-11.9-20.6-11.1-26.7 .2c-18.5 34.3-43.8 68.4-75.2 99.8s-65.5 56.7-99.8 75.2c-11.3 6.1-12.2 22.1-.2 26.7c55.6 21.5 121.4 9.7 166.5-35.5s57-110.9 35.5-166.5zM104.8 284c2.8 8.4 11.9 12.9 20.2 10.1l37.5-12.5L150 319.1c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1L203 261.3c1.9-5.7 .4-12.1-3.9-16.4s-10.6-5.8-16.4-3.9l-67.9 22.6c-8.4 2.8-12.9 11.9-10.1 20.2zM294.1 125c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-22.6 67.9c-1.9 5.7-.4 12.1 3.9 16.4s10.6 5.8 16.4 3.9l67.9-22.6c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-37.5 12.5L294.1 125zM71.2 425.4c6.6-1.7 13.3-3.2 19.8-4.5c-1.3 6.5-2.8 13.3-4.5 19.8c-2.3 9.2-4.9 17.3-7.5 23.6c-2.3 5.7-4 8.1-4.4 8.7c-.1 .1-.1 .1 0 .1c-9 9-24.7 9.5-35-.9s-9.8-26-.9-35c-.1 .1 0 0 .1 0c.5-.4 3-2 8.7-4.4c6.4-2.6 14.5-5.1 23.6-7.5zm45.9-41.3c-25.8 3.5-84 13.6-100.9 30.5c-22 22-21.5 57.9 .9 80.3s58.3 22.8 80.3 .9c16.9-16.9 26.9-75.2 30.5-100.9c1-6.4-4.4-11.8-10.8-10.8z"]
};
var faGrinSquintTears = faFaceGrinSquintTears;
var faDumbbell = {
  prefix: 'fal',
  iconName: 'dumbbell',
  icon: [640, 512, [], "f44b", "M208 64c8.8 0 16 7.2 16 16V256 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V368 144 80c0-8.8 7.2-16 16-16h32zM128 413.3V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V272H384V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V413.3c5 1.8 10.4 2.7 16 2.7h32c26.5 0 48-21.5 48-48V272h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V144c0-26.5-21.5-48-48-48H528c-5.6 0-11 1-16 2.7V80c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48V240H256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48V98.7C123 97 117.6 96 112 96H80c-26.5 0-48 21.5-48 48v96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v96c0 26.5 21.5 48 48 48h32c5.6 0 11-1 16-2.7zM512 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V256 368c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V144zM480 368v64c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V256 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64V368zM128 144V368c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V256 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"]
};
var faRectangleList = {
  prefix: 'fal',
  iconName: 'rectangle-list',
  icon: [576, 512, ["list-alt"], "f022", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm-64-72a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-24 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faListAlt = faRectangleList;
var faTarpDroplet = {
  prefix: 'fal',
  iconName: 'tarp-droplet',
  icon: [576, 512, [], "e57c", "M328 113.5l0 0s0 0 0 0c0-.1-.1-1.1-.6-3.1c-.6-2.3-1.7-5.3-3.2-8.9c-3.2-7.4-7.9-16-13.7-25.3c-7-11.3-15-22.6-22.4-32.6c-7.4 10-15.4 21.3-22.4 32.6c-5.8 9.3-10.5 17.9-13.7 25.3c-1.6 3.6-2.6 6.6-3.2 8.9c-.5 2-.6 3-.6 3.1c0 0 0 0 0 0l0 0c0 17.7 15.9 35.5 40 35.5s40-17.8 40-35.5zm32 0c0 37.3-32.2 67.5-72 67.5s-72-30.2-72-67.5c0-27.7 39.7-81.3 60.2-107c6.1-7.7 17.5-7.7 23.7 0c20.4 25.7 60.2 79.3 60.2 107zM64 128H193.3c1.9 11.5 5.9 22.3 11.5 32L64 160c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l320 0 0-112c0-26.5 21.5-48 48-48H544V192c0-17.7-14.3-32-32-32H371.2c5.6-9.7 9.6-20.5 11.5-32H512c35.3 0 64 28.7 64 64V348.1c0 12.7-5.1 24.9-14.1 33.9L446.1 497.9c-9 9-21.2 14.1-33.9 14.1L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM423.4 475.3L539.3 359.4c2.1-2.1 3.5-4.6 4.2-7.4H432c-8.8 0-16 7.2-16 16l0 111.5c2.8-.7 5.4-2.1 7.4-4.2zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faAlarmExclamation = {
  prefix: 'fal',
  iconName: 'alarm-exclamation',
  icon: [512, 512, [], "f843", "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 64c-8.8 0-16 7.2-16 16V320c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHouseMedicalCircleCheck = {
  prefix: 'fal',
  iconName: 'house-medical-circle-check',
  icon: [640, 512, [], "e511", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H394.8c-12.9-9.1-24.5-19.9-34.6-32H144c-26.5 0-48-21.5-48-48V206.7L288 37.3 466.1 194.5c9.7-1.7 19.7-2.5 29.9-2.5c5.6 0 11.1 .3 16.5 .8L298.6 4zM368 240H336V208c0-17.7-14.3-32-32-32H272c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c6.7 0 12.9-2 18-5.5c-1.3-8.6-2-17.5-2-26.5c0-22.6 4.3-44.2 12-64H320c-8.8 0-16 7.2-16 16v48H272V320c0-8.8-7.2-16-16-16H208V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208h32v48c0 8.8 7.2 16 16 16h28.5c7.5-11.4 16.2-22 26-31.3c-2.1-.4-4.3-.7-6.5-.7zm128 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faTrafficCone = {
  prefix: 'fal',
  iconName: 'traffic-cone',
  icon: [512, 512, [], "f636", "M248.2 32h15.5c3.3 0 6.2 2 7.4 5l49.2 123H191.6L240.8 37c1.2-3 4.2-5 7.4-5zm84.9 160l51.2 128H127.6l51.2-128H333.2zm64 160l51.2 128H63.6l51.2-128H397.2zM211.1 25.1L29.2 480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H482.8L300.9 25.1C294.8 10 280.1 0 263.8 0H248.2c-16.4 0-31.1 10-37.1 25.1z"]
};
var faGrate = {
  prefix: 'fal',
  iconName: 'grate',
  icon: [448, 512, [], "e193", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 0h56 72 72 56c17.7 0 32 14.3 32 32V256 384c0 17.7-14.3 32-32 32H296 224 152 96c-17.7 0-32-14.3-32-32V256 128c0-17.7 14.3-32 32-32zm0 32V240h40V128H96zm72 112h40V128H168V240zm72 0h40V128H240V240zm72 0h40V128H312V240zm0 32V384h40V272H312zm-32 0H240V384h40V272zm-72 0H168V384h40V272zm-72 0H96V384h40V272z"]
};
var faArrowDownRight = {
  prefix: 'fal',
  iconName: 'arrow-down-right',
  icon: [384, 512, [], "e093", "M336 416c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V361.4L59.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 384H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H336z"]
};
var faPersonSkiingNordic = {
  prefix: 'fal',
  iconName: 'person-skiing-nordic',
  icon: [576, 512, ["skiing-nordic"], "f7ca", "M320 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 288 56a56 56 0 1 0 112 0zM243.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L117.5 180c-6.7 5.8-7.3 15.9-1.5 22.6c1.5 1.7 3.3 3.1 5.3 4L64.3 476.7c-.2 1.1-.3 2.2-.3 3.3H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H143.7c.2 0 .4 0 .6 0H303.6c.2 0 .5 0 .7 0H512c35.3 0 64-28.7 64-64V432c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 17.7-14.3 32-32 32H432.2l29.5-192H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H448.2h-.5H408.1c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zM96.4 480L158 187l32.9-28.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L217.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L292.7 480H167.2l52.9-139.2c-10.2-6.4-18.6-14.9-24.8-24.7L133 480H96.4zm303.8-2.4c-.1 .8-.2 1.6-.2 2.4H326.6l36-102c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L362 253.2c5.9 20.6 24.7 34.8 46.2 34.8h21.2L400.2 477.6zM326.4 170.1L282.3 302.4 254.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7z"]
};
var faSkiingNordic = faPersonSkiingNordic;
var faCalendarPlus = {
  prefix: 'fal',
  iconName: 'calendar-plus',
  icon: [512, 512, [], "f271", "M144 0c8.8 0 16 7.2 16 16V64H352V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 160 128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zM448 192H64V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192zM416 96H96c-17.7 0-32 14.3-32 32v32H448V128c0-17.7-14.3-32-32-32zM352 336c0 8.8-7.2 16-16 16H272v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V256c0-8.8 7.2-16 16-16s16 7.2 16 16v64h64c8.8 0 16 7.2 16 16z"]
};
var faPersonFromPortal = {
  prefix: 'fal',
  iconName: 'person-from-portal',
  icon: [512, 512, ["portal-exit"], "e023", "M128 256c0 37.2-1.4 69-3.9 96h32.1c2.5-27.7 3.8-59.6 3.8-96c0-17-.3-33-.8-48c4 .2 8.1-1.1 11.4-3.9l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L249.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L320.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L394.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L394 253.2c5.9 20.6 24.7 34.8 46.2 34.8H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H440.1c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4l-44.6 39C148.1 46.7 117 0 80 0C35.8 0 0 66.6 0 256S35.8 512 80 512c23.3 0 44.3-18.6 59-64H105c-12.3 32-23.5 32-25 32h0 0c-1.6 0-13.6 0-26.4-35.8C40.9 409.1 32 349.5 32 256s8.9-153.1 21.5-188.2C66.4 32 78.4 32 80 32l0 0 0 0c1.6 0 13.6 0 26.4 35.8C119.1 102.9 128 162.5 128 256zM352 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 320 56a56 56 0 1 0 112 0zM358.4 170.1L314.3 302.4 286.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM226 314.1L197.3 384H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4z"]
};
var faPortalExit = faPersonFromPortal;
var faPlaneArrival = {
  prefix: 'fal',
  iconName: 'plane-arrival',
  icon: [640, 512, [128748], "f5af", "M253.3 32c5.8 0 11.1 3.1 13.9 8.2L388.5 255.7c2.1 3.7 5.6 6.4 9.7 7.6l91.5 25.4c15.9 4.4 30.7 12.3 43.2 23.2l26.7 23.1c11.5 9.9 6.7 28.7-8.1 32c-27.1 6-55.3 5.1-82-2.5L170.5 279.5c-1.8-.5-3.5-1.3-5-2.4L70.9 208.7c-4.2-3-6.6-7.8-6.6-12.9L64 100l34.2 7.6c5.7 1.3 10.2 5.5 11.9 11l18.6 62c1.6 5.3 5.7 9.3 11 10.8l101.8 28.3c5.6 1.6 11.6 0 15.6-4.1s5.6-10.1 4-15.7L213.2 32l40.1 0zm41.8-7.5C286.6 9.4 270.6 0 253.3 0H213.2C192 0 176.6 20.3 182.4 40.8l40.1 140.4-65.8-18.3-16.1-53.6c-5-16.6-18.6-29.3-35.6-33.1L71 68.7C51 64.3 32 79.5 32 100l.2 95.8c0 15.4 7.4 29.8 19.9 38.8L146.8 303c4.5 3.3 9.6 5.7 15 7.3l4.4-15.4-4.4 15.4 298.8 84.9c31.8 9 65.4 10 97.7 2.9c40.6-8.9 53.6-60.3 22.1-87.5l-26.7-23.1c-16.1-13.9-35.1-24.1-55.6-29.8l-85.1-23.7L295.1 24.5zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM176 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCowbellCirclePlus = {
  prefix: 'fal',
  iconName: 'cowbell-circle-plus',
  icon: [576, 512, ["cowbell-more"], "f8b4", "M176 32h96c8.8 0 16 7.2 16 16V96H160V48c0-8.8 7.2-16 16-16zM128 48V96H112c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416H262.6c-2.9-10.3-4.9-21-5.9-32H48c-5 0-9.8-2.4-12.8-6.4s-4-9.2-2.6-14l64-224c2-6.9 8.2-11.6 15.4-11.6h32H304h32c7.1 0 13.4 4.7 15.4 11.6l18.2 63.8c9.9-3.7 20.2-6.6 30.8-8.6l-18.3-64C376.3 110.2 357.4 96 336 96H320V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zM256 448c0 17.7-14.3 32-32 32s-32-14.3-32-32H160c0 35.3 28.7 64 64 64c29.2 0 53.9-19.6 61.5-46.4c-3.8-5.7-7.2-11.5-10.3-17.6H256zm64-80a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faCowbellMore = faCowbellCirclePlus;
var faCircleLeft = {
  prefix: 'fal',
  iconName: 'circle-left',
  icon: [512, 512, [61840, "arrow-alt-circle-left"], "f359", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-400 0c0 9.2 3.5 18 9.7 24.7l84 91c7.2 7.8 17.4 12.3 28.1 12.3c21.1 0 38.3-17.1 38.3-38.3l0-25.7 80 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-80 0 0-25.7c0-21.1-17.1-38.3-38.3-38.3c-10.7 0-20.9 4.5-28.1 12.3l-84 91c-6.2 6.7-9.7 15.6-9.7 24.7zm33.2 3c-.8-.8-1.2-1.9-1.2-3s.4-2.2 1.2-3l84-91c1.2-1.3 2.9-2 4.6-2c3.5 0 6.3 2.8 6.3 6.3l0 41.7c0 8.8 7.2 16 16 16l96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16 7.2-16 16l0 41.7c0 3.5-2.8 6.3-6.3 6.3c-1.7 0-3.4-.7-4.6-2l-84-91z"]
};
var faArrowAltCircleLeft = faCircleLeft;
var faDistributeSpacingVertical = {
  prefix: 'fal',
  iconName: 'distribute-spacing-vertical',
  icon: [512, 512, [], "e366", "M512 464c0-8.8-7.2-16-16-16L16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16zM144 320c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-224 0zm224 32c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l224 0zM496 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l480 0z"]
};
var faSignalBarsFair = {
  prefix: 'fal',
  iconName: 'signal-bars-fair',
  icon: [640, 512, ["signal-alt-2"], "f692", "M240 288c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V304zM96 432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z"]
};
var faSignalAlt2 = faSignalBarsFair;
var faSportsball = {
  prefix: 'fal',
  iconName: 'sportsball',
  icon: [512, 512, [], "e44b", "M436.9 52.4l-94.2 94.3c-23.7-27.4-41-60.6-49.2-97.2c41.2-5.3 88.7-4.8 143.5 2.9zM261.9 55c9.5 43.2 29.8 82.4 58.1 114.4l-64 64L138.4 115.8c22.2-19.9 49.1-36.6 81.6-48.7c13-4.8 27-8.9 41.9-12.2zM116.1 138.8L233.4 256l-64 64c-31.6-27.9-70.2-48.1-112.7-57.7c7.5-32.2 19.3-63.5 36.7-92c6.7-11 14.3-21.6 22.8-31.6zm-65.5 155c36.1 8.4 68.9 25.4 96 48.9L52.2 437.2c-6.9-42.8-8.9-93.2-1.5-143.4zM75 459.6l94.3-94.3c23.7 27.4 41 60.6 49.2 97.2c-41.2 5.3-88.7 4.8-143.5-2.9zm175-2.5c-9.5-43.2-29.8-82.4-58.1-114.4l64-64L373.6 396.2c-22.2 19.9-49.1 36.6-81.6 48.7c-13 4.8-27 8.9-41.9 12.2zm145.8-83.8L278.6 256l64-64c31.6 27.9 70.2 48.1 112.8 57.7c-7.5 32.2-19.3 63.5-36.7 92c-6.7 11-14.3 21.6-22.8 31.6zm65.5-155c-36.1-8.4-68.9-25.5-96-48.9l94.5-94.5c6.9 42.8 8.9 93.2 1.5 143.4zm.2-194.4c-103.9-17.4-187-11-252.6 13.3C142.9 61.6 96.7 103.6 66 153.6C5.8 251.8 6.9 378.3 24.4 463.1c2.7 12.9 13 22.9 26.1 25.1c103.9 17.4 187 11 252.6-13.3c66-24.5 112.2-66.5 142.9-116.5c60.2-98.2 59.1-224.7 41.6-309.5c-2.7-12.9-13-22.9-26.1-25.1z"]
};
var faGameConsoleHandheldCrank = {
  prefix: 'fal',
  iconName: 'game-console-handheld-crank',
  icon: [576, 512, [], "e5b9", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V272 96c0-17.7-14.3-32-32-32H64zM448 96V256h32V208 160c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H512v48c0 8.8-7.2 16-16 16H448V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64zM96 128V256H352V128H96zm-32 0c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V256c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zm448 64h32V160H512v32zM128 336v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H128v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTrainSubway = {
  prefix: 'fal',
  iconName: 'train-subway',
  icon: [448, 512, ["subway"], "f239", "M208 32l0 192H32V96c0-35.3 28.7-64 64-64H208zm32 0H352c35.3 0 64 28.7 64 64V224H240l0-192zM32 352V256H416v96c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zM96 0C43 0 0 43 0 96V352c0 46 32.4 84.4 75.6 93.8L36.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L118.6 448H329.4l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-38.9-38.9C415.6 436.4 448 398 448 352V96c0-53-43-96-96-96H96zm24 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm232-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSubway = faTrainSubway;
var faChartGantt = {
  prefix: 'fal',
  iconName: 'chart-gantt',
  icon: [512, 512, [], "e0e4", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM128 144c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm80 80H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm160 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFaceSmileUpsideDown = {
  prefix: 'fal',
  iconName: 'face-smile-upside-down',
  icon: [512, 512, [], "e395", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM164.1 186.5C182 165.8 212.6 144 256 144s74 21.8 91.9 42.5c5.8 6.7 15.9 7.4 22.6 1.6s7.4-15.9 1.6-22.6C349.8 139.9 311.1 112 256 112s-93.8 27.9-116.1 53.5c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6zM200.4 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faBallPile = {
  prefix: 'fal',
  iconName: 'ball-pile',
  icon: [576, 512, [], "f77e", "M352 96A64 64 0 1 0 224 96a64 64 0 1 0 128 0zm-35.4 91.7c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C277.1 205.1 288 229.3 288 256s-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C298.9 306.9 288 282.7 288 256s10.9-50.9 28.6-68.3zM384 352c-9.9 0-19.5-1.5-28.6-4.3C373.1 365.1 384 389.3 384 416c0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C181.1 365.1 192 389.3 192 416c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C106.9 306.9 96 282.7 96 256c0-53 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C202.9 146.9 192 122.7 192 96c0-53 43-96 96-96s96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3zM256 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM160 416A64 64 0 1 0 32 416a64 64 0 1 0 128 0zm224-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256-64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faBadgeDollar = {
  prefix: 'fal',
  iconName: 'badge-dollar',
  icon: [512, 512, [], "f645", "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zm16.9 140.4c0-8.8-7.2-16-16-16s-16 7.2-16 16v20.8c-9.5 1.5-19.2 4.6-27.7 9.7c-14.1 8.3-25.7 22.7-25.6 43.4c.1 19.6 11.4 32.1 24.4 39.9c11.5 6.9 26.1 11.3 38.4 15l1.7 .5c13.8 4.2 24.8 7.7 32.7 12.6c6.9 4.3 9.3 8.4 9.4 14.3c.1 8.1-3.4 13.2-9.5 17c-6.8 4.3-16.9 6.5-27.3 6.2c-13.4-.4-25.8-4.7-40.9-9.8l0 0 0 0c-2.5-.9-5.2-1.8-7.9-2.7c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2.2 .7 4.6 1.5 6.9 2.4c10.6 3.7 22.7 7.8 35.4 10.1v21.3c0 8.8 7.2 16 16 16s16-7.2 16-16V351c10-1.5 20-4.6 28.7-10.1c14.3-8.9 24.9-23.9 24.6-44.6c-.3-19.8-11.3-32.7-24.4-41c-12-7.6-27.4-12.2-40-16l-.4-.1c-13.9-4.2-25-7.6-32.8-12.3c-6.9-4.2-8.9-7.8-8.9-12.7c0-6.8 3.2-11.8 9.9-15.7c7.3-4.3 17.5-6.5 27.1-6.4c11.4 .2 23.7 2.7 36.1 6c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.7-2.3-18.3-4.5-28.1-5.8V140.4z"]
};
var faMoneyBillsSimple = {
  prefix: 'fal',
  iconName: 'money-bills-simple',
  icon: [640, 512, ["money-bills-alt"], "e1f4", "M576 64c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H576zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM368 272a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 61.9 50.1 112 112 112H528c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-44.2 0-80-35.8-80-80V112z"]
};
var faMoneyBillsAlt = faMoneyBillsSimple;
var faListTimeline = {
  prefix: 'fal',
  iconName: 'list-timeline',
  icon: [512, 512, [], "e1d1", "M213.3 128H416V64L213.3 64l-32 32 32 32zM190.6 41.4c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm181.3 32H416V384H213.3l-32 32 32 32zm-22.6-86.6c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3zM181.3 256l32 32H480V224l-266.7 0-32 32zm-33.9-11.3l43.3-43.3c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faIndianRupeeSign = {
  prefix: 'fal',
  iconName: 'indian-rupee-sign',
  icon: [320, 512, ["indian-rupee", "inr"], "e1bc", "M0 48c0-8.8 7.2-16 16-16h96H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H202.5c28.7 23.2 48.3 57.3 52.6 96H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H255.1c-8 72-69 128-143.1 128H65.9L249.3 451c7.2 5.1 8.9 15.1 3.7 22.3s-15.1 8.9-22.3 3.7L6.7 317C1 313-1.4 305.7 .8 299.1S9 288 16 288h96c56.4 0 103.1-41.7 110.9-96H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H222.9c-7.8-54.3-54.4-96-110.9-96H16C7.2 64 0 56.8 0 48z"]
};
var faIndianRupee = faIndianRupeeSign;
var faInr = faIndianRupeeSign;
var faCropSimple = {
  prefix: 'fal',
  iconName: 'crop-simple',
  icon: [512, 512, ["crop-alt"], "f565", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H96V368c0 26.5 21.5 48 48 48H352V384H144c-8.8 0-16-7.2-16-16V16zM384 496c0 8.8 7.2 16 16 16s16-7.2 16-16V416h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H416l0-240c0-26.5-21.5-48-48-48L160 96v32l208 0c8.8 0 16 7.2 16 16l0 352z"]
};
var faCropAlt = faCropSimple;
var faMoneyBill1 = {
  prefix: 'fal',
  iconName: 'money-bill-1',
  icon: [576, 512, ["money-bill-alt"], "f3d1", "M512 96c17.7 0 32 14.3 32 32v32c-35.3 0-64-28.7-64-64h32zM128 96H448c0 53 43 96 96 96V320c-53 0-96 43-96 96H128c0-53-43-96-96-96V192c53 0 96-43 96-96zM32 352c35.3 0 64 28.7 64 64H64c-17.7 0-32-14.3-32-32V352zm448 64c0-35.3 28.7-64 64-64v32c0 17.7-14.3 32-32 32H480zM96 96c0 35.3-28.7 64-64 64V128c0-17.7 14.3-32 32-32H96zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM256 208c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24 24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm-64 48a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
};
var faMoneyBillAlt = faMoneyBill1;
var faLeftLong = {
  prefix: 'fal',
  iconName: 'left-long',
  icon: [512, 512, ["long-arrow-alt-left"], "f30a", "M160 328l0 49.3c0 3.7-3 6.7-6.7 6.7c-1.9 0-3.7-.8-5-2.2L35.8 256 148.3 130.2c1.3-1.4 3.1-2.2 5-2.2c3.7 0 6.7 3 6.7 6.7l0 49.3c0 17.7 14.3 32 32 32l272 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-272 0c-17.7 0-32 14.3-32 32zM5.3 242C1.9 245.9 0 250.8 0 256s1.9 10.1 5.3 14L124.5 403.1c7.3 8.2 17.8 12.9 28.8 12.9c21.4 0 38.7-17.3 38.7-38.7l0-17.3 0-32 32 0 240 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48l-240 0-32 0 0-32 0-17.3c0-21.4-17.3-38.7-38.7-38.7c-11 0-21.5 4.7-28.8 12.9L5.3 242z"]
};
var faLongArrowAltLeft = faLeftLong;
var faKeyboardDown = {
  prefix: 'fal',
  iconName: 'keyboard-down',
  icon: [576, 512, [], "e1c2", "M64 32C46.3 32 32 46.3 32 64V224c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm184 8h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184c-8.8 0-16-7.2-16-16V88c0-8.8 7.2-16 16-16zM72 184c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V184zM88 72h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V88c0-8.8 7.2-16 16-16zM264 88c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V88zM376 72h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H376c-8.8 0-16-7.2-16-16V88c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V88zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V184c0-8.8 7.2-16 16-16zM160 192c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zM288 473.4L404.7 356.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 473.4z"]
};
var faCircleUpRight = {
  prefix: 'fal',
  iconName: 'circle-up-right',
  icon: [512, 512, [], "e129", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm80 184c0-4.4-3.6-8-8-8H214.6c-3.7 0-6.6 3-6.6 6.6c0 1.8 .7 3.4 1.9 4.7l25.4 25.4c6.2 6.2 6.2 16.4 0 22.6l-59.1 59.1c-3.6 3.6-4.9 9-3.3 13.9c.7 2 1.8 3.8 3.3 5.3l22.1 22.1c1.5 1.5 3.3 2.6 5.3 3.3c4.9 1.6 10.3 .4 13.9-3.3l59.1-59.1c6.2-6.2 16.4-6.2 22.6 0l25.4 25.4c1.2 1.2 2.9 1.9 4.7 1.9c3.7 0 6.6-3 6.6-6.6V184zm-8-40c22.1 0 40 17.9 40 40V297.4c0 21.3-17.3 38.6-38.6 38.6c-10.2 0-20.1-4.1-27.3-11.3L288 310.6l-47.7 47.7c-12.2 12.2-30.3 16.5-46.7 11c-6.7-2.2-12.8-6-17.8-11l-22.1-22.1c-5-5-8.8-11.1-11-17.8c-5.5-16.4-1.2-34.5 11-46.7L201.4 224l-14.1-14.1c-7.2-7.2-11.3-17.1-11.3-27.3c0-21.3 17.3-38.6 38.6-38.6H328z"]
};
var faCloudBoltMoon = {
  prefix: 'fal',
  iconName: 'cloud-bolt-moon',
  icon: [576, 512, ["thunderstorm-moon"], "f76d", "M387.7 101.7c7.9-27.6 28-50.1 54.2-61.6c-12.8 19-20.3 41.8-20.3 66.3c0 53.9 35.9 99.2 85.1 114.2c-8.2 2.2-16.7 3.4-25.6 3.4c-4.2 0-8.3-.3-12.4-.8c4.9 10.2 8.3 21.2 10 32.8c.8 0 1.6 0 2.4 0c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5C427.1 0 380.6 33 361.4 79.9c9.8 5.9 18.7 13.3 26.3 21.8zM112 160c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H343c5.7 8.5 9 18.7 9 29.7c0 .8 0 1.5-.1 2.3h13.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 82.6 210.9 64 176 64c-53 0-96 43-96 96l0 1.3C34.6 168.9 0 208.4 0 256c0 46.9 33.6 85.9 78 94.3c.9-1 1.8-1.9 2.7-2.8l29.1-27.6H98.9c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm31.7 216l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4H143.7zM265.6 224c-5.1 0-10.1 2-13.8 5.5L102.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6H167l-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5L313.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6H249l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"]
};
var faThunderstormMoon = faCloudBoltMoon;
var faDna = {
  prefix: 'fal',
  iconName: 'dna',
  icon: [448, 512, [129516], "f471", "M400 0c8.8 0 16 7.2 16 16c0 120.2-94.2 188.6-179.7 250.9l-2.8 2.1c-37.8 27.5-73.9 54-102.9 83.1h187c-19.8-19.8-42.8-38.4-67.5-57c3.2-2.3 6.4-4.6 9.7-6.9c5.9-4.2 11.7-8.4 17.6-12.7C349.4 330.4 416 394.9 416 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-5.5-.2-10.8-.7-16H64.7c-.4 5.2-.7 10.5-.7 16c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-113.2 83.6-180.5 164.8-240C115.6 196.5 32 129.2 32 16C32 7.2 39.2 0 48 0s16 7.2 16 16c0 5.5 .2 10.8 .7 16H383.3c.4-5.2 .7-10.5 .7-16c0-8.8 7.2-16 16-16zM377.6 64H70.4c6.5 23.4 17.6 44.5 32.2 64H345.5c14.6-19.5 25.7-40.6 32.2-64zm-60.1 96h-187c26.6 26.7 59.1 51.1 93.5 76.2c34.4-25.1 66.9-49.5 93.5-76.2zM70.4 448H377.6c-6.5-23.5-17.6-44.5-32.2-64.1c-.5 0-.9 .1-1.4 .1H104c-.5 0-.9 0-1.4-.1C88 403.5 76.8 424.5 70.4 448z"]
};
var faVirusSlash = {
  prefix: 'fal',
  iconName: 'virus-slash',
  icon: [640, 512, [], "e075", "M532.5 288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 36.4-32.2 59.6-63.3 55.7L259.9 127C293.3 115.8 320 85.2 320 43.5c0 78.4 94.8 117.7 150.2 62.2C414.8 161.2 454.1 256 532.5 256c-29.1 0-52.8 13-68.3 32.3l25.1 19.9c9.9-12 24.8-20.1 43.1-20.1zM107.5 256c29.1 0 52.8-13 68.3-32.3l-25.1-19.9c-9.9 12-24.8 20.1-43.1 20.1H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-36.4 32.2-59.6 63.3-55.7L380.1 385c-33.4 11.2-60.1 41.8-60.1 83.4c0-78.4-94.8-117.6-150.2-62.2C225.2 350.8 185.9 256 107.5 256zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faBracketRoundRight = {
  prefix: 'fal',
  iconName: 'bracket-round-right',
  icon: [192, 512, [], "29", "M33.9 40.4c-4.2 7.8-1.3 17.5 6.4 21.7C80.5 83.8 160 153.4 160 256s-79.5 172.2-119.6 193.9c-7.8 4.2-10.7 13.9-6.4 21.7s13.9 10.7 21.7 6.4C100.8 453.6 192 375.3 192 256S100.8 58.4 55.6 33.9c-7.8-4.2-17.5-1.3-21.7 6.4z"]
};
var faCircleSterling = {
  prefix: 'fal',
  iconName: 'circle-sterling',
  icon: [512, 512, [], "e5cf", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM259.6 144c-20.2 0-36.5 16.5-36.4 36.7l.3 43.3H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H223.6c-.9 22.5-7.1 44.4-18 64H328c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-5.9 0-11.4-3.3-14.2-8.5s-2.4-11.6 1-16.5l9.2-13.5c11.7-17 18.4-36.9 19.5-57.5H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h15.5l-.3-43.1c-.3-38 30.4-68.9 68.4-68.9c10.6 0 21.1 2.5 30.6 7.2l20.9 10.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-20.9-10.5c-5.1-2.5-10.6-3.8-16.3-3.8z"]
};
var faCircle5 = {
  prefix: 'fal',
  iconName: 'circle-5',
  icon: [512, 512, [], "e0f2", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128c-7.3 0-13.7 5-15.5 12.1l-24 96c-1.1 4.5-.2 9.3 2.4 13.1s6.9 6.3 11.5 6.7l98.8 10c22.1 2.2 38.8 20.8 38.8 42.9c0 23.8-19.3 43.2-43.2 43.2h-44c-16.8 0-32.4-8.3-41.8-22.3l-1.8-2.7c-4.9-7.3-14.9-9.3-22.2-4.4s-9.3 14.9-4.4 22.2l1.8 2.7c15.3 22.8 40.9 36.4 68.3 36.4h44c41.5 0 75.2-33.7 75.2-75.2c0-38.6-29.2-70.9-67.6-74.8L204 225.9 220.5 160H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]
};
var faMinus = {
  prefix: 'fal',
  iconName: 'minus',
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z"]
};
var faSubtract = faMinus;
var faFireFlame = {
  prefix: 'fal',
  iconName: 'fire-flame',
  icon: [384, 512, ["flame"], "f6df", "M341.8 265.5C310.2 178.6 258.9 100.2 192 36.4C125.1 100.2 73.8 178.6 42.2 265.5l-.7 1.9c-6.3 17.4-9.5 35.7-9.5 54.1C32 408.7 104.2 480 192 480s160-71.3 160-158.4c0-18.5-3.2-36.8-9.5-54.1l27.2-9.9-27.2 9.9-.7-1.9zm30.1-10.9l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3c72.9 68 128.7 152.4 162.7 246.1zM187.4 206v.6c0 16.1 6.3 31.6 17.5 43.3l8.2 8.5c9.9 10.3 15.5 24.1 15.5 38.4c0 30.5-24.7 55.3-55.3 55.3h-2.5c-31.9 0-57.7-25.8-57.7-57.7V272.1c-11 12.2-17.1 28.1-17.1 44.7V320c0 53 43 96 96 96h7.3c49 0 88.7-39.7 88.7-88.7c0-27.9-12.2-54.3-33.4-72.4l-44.6-38.1c-9.7-8.3-16.4-19.6-19-31.9c-2.4 6.8-3.6 13.9-3.6 21.1zm9.9-78c13.5 0 24.4 10.9 24.4 24.4v20.2c0 7.6 3.3 14.9 9.1 19.8l44.6 38.1c28.3 24.2 44.6 59.5 44.6 96.7C320 393.9 265.9 448 199.3 448H192c-70.7 0-128-57.3-128-128v-3.2c0-27.9 11.8-54.6 32.6-73.3l5.3-4.8c4.8-4.3 10.9-6.7 17.4-6.7c14.3 0 25.9 11.6 25.9 25.9v36.4c0 14.2 11.5 25.7 25.7 25.7h2.5c12.8 0 23.3-10.4 23.3-23.3c0-6-2.3-11.8-6.5-16.1l-8.2-8.5c-17-17.6-26.4-41.1-26.4-65.5V206c0-13.9 3-27.6 8.9-40.2l10.9-23.6c4-8.6 12.6-14.1 22.1-14.1z"]
};
var faFlame = faFireFlame;
var faRightToLine = {
  prefix: 'fal',
  iconName: 'right-to-line',
  icon: [448, 512, ["arrow-alt-to-right"], "f34c", "M416 80l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352c0-8.8-7.2-16-16-16s-16 7.2-16 16zM319.2 254.2c.5 .5 .8 1.1 .8 1.8s-.3 1.4-.8 1.8L187.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-8.8-7.2-16-16-16L40 304c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l120 0c8.8 0 16-7.2 16-16l0-57.3c0-3.7 3-6.7 6.7-6.7c1.7 0 3.3 .7 4.6 1.8L319.2 254.2zM352 256c0-9.5-3.9-18.6-10.8-25.1L209.2 106.5C202 99.8 192.5 96 182.7 96c-21.4 0-38.7 17.3-38.7 38.7l0 41.3L40 176c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l104 0 0 41.3c0 21.4 17.3 38.7 38.7 38.7c9.9 0 19.3-3.8 26.5-10.5L341.2 281.1c6.9-6.5 10.8-15.6 10.8-25.1z"]
};
var faArrowAltToRight = faRightToLine;
var faGif = {
  prefix: 'fal',
  iconName: 'gif',
  icon: [576, 512, [], "e190", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm48 16v80 80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM128 256c0-35.3 28.7-64 64-64c14.4 0 27.7 4.8 38.4 12.8c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4c-16-12.1-36-19.2-57.6-19.2c-53 0-96 43-96 96s43 96 96 96c21.6 0 41.6-7.1 57.6-19.2c4-3 6.4-7.8 6.4-12.8V264c0-8.8-7.2-16-16-16H184c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v31.4c-9.4 5.4-20.3 8.6-32 8.6c-35.3 0-64-28.7-64-64z"]
};
var faChess = {
  prefix: 'fal',
  iconName: 'chess',
  icon: [512, 512, [], "f439", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H52.6C41.2 96 32 105.2 32 116.6c0 2.2 .4 4.4 1.1 6.5L66.7 224H56c-8.8 0-16 7.2-16 16s7.2 16 16 16H69.8L56.7 352H89l13.1-96h51.8L167 352h32.3l-13.1-96H200c8.8 0 16-7.2 16-16s-7.2-16-16-16H189.3l33.6-100.8c.7-2.1 1.1-4.3 1.1-6.5c0-11.4-9.2-20.6-20.6-20.6H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zm11.6 208H100.4l-32-96H128h59.6l-32 96zm34.6 160H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512H216.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1zM33.1 468.7L65.8 416l124.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9zM452.5 416L479 467.2c.6 1.2 1 2.6 1 4c0 4.8-3.9 8.8-8.8 8.8H328.8c-4.8 0-8.8-3.9-8.8-8.8c0-1.4 .3-2.8 1-4L347.5 416l105 0zm-105-32c-12 0-22.9 6.7-28.4 17.3l-26.5 51.2c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8H471.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3h-105zM304 160c-8.8 0-16 7.2-16 16v80c0 3.7 1.3 7.4 3.7 10.2L328 309.8V336v16h32V336 304c0-3.7-1.3-7.4-3.7-10.2L320 250.2V192h32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V192h32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V192h32v58.2l-36.3 43.5c-2.4 2.9-3.7 6.5-3.7 10.2v32 16h32V336 309.8l36.3-43.5c2.4-2.9 3.7-6.5 3.7-10.2V176c0-8.8-7.2-16-16-16H432 368 304z"]
};
var faTrashSlash = {
  prefix: 'fal',
  iconName: 'trash-slash',
  icon: [640, 512, [], "e2b3", "M509.7 96H528c8.8 0 16-7.2 16-16s-7.2-16-16-16H512 479.9 432.9L407 22.6C398.2 8.5 382.8 0 366.3 0H273.7C257.2 0 241.8 8.5 233 22.6L207.1 64h-27l40.5 32h257L463.9 288.1l30.4 24L509.7 96zM452.9 442.5l-.6 7.8C451.1 467 437.2 480 420.4 480H219.6c-16.8 0-30.7-13-31.9-29.7L171.2 220.1l-34-26.8 18.5 259.3c2.4 33.5 30.3 59.4 63.8 59.4H420.4c29.1 0 54-19.5 61.6-46.6l-29.1-23zM273.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L395.1 64H244.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faArrowLeftLong = {
  prefix: 'fal',
  iconName: 'arrow-left-long',
  icon: [512, 512, ["long-arrow-left"], "f177", "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 496 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 171.3 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144z"]
};
var faLongArrowLeft = faArrowLeftLong;
var faPlugCircleCheck = {
  prefix: 'fal',
  iconName: 'plug-circle-check',
  icon: [576, 512, [], "e55c", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faFontCase = {
  prefix: 'fal',
  iconName: 'font-case',
  icon: [640, 512, [], "f866", "M190.9 42.3C188.6 36.1 182.6 32 176 32s-12.6 4.1-14.9 10.3l-160 416c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2L76.2 352H275.8l45.3 117.7c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7l-160-416zM263.5 320H88.5L176 92.6 263.5 320zM624 160c-8.8 0-16 7.2-16 16v34.7C585.4 179.9 549 160 508 160c-68.5 0-124 55.5-124 124v72c0 68.5 55.5 124 124 124c41 0 77.4-19.9 100-50.7V464c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zM416 284c0-50.8 41.2-92 92-92s92 41.2 92 92v72c0 50.8-41.2 92-92 92s-92-41.2-92-92V284z"]
};
var faStreetView = {
  prefix: 'fal',
  iconName: 'street-view',
  icon: [512, 512, [], "f21d", "M256 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 256 0a64 64 0 1 0 0 128zM192 280l0 0V224c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v56l0 0c-14.4 2.1-25.6 13.8-27.2 28.3l-8.9 84.5c-.4 4.1-3.9 7.2-8 7.2H236c-4.1 0-7.5-3.1-8-7.2l-8.9-84.5c-1.5-14.5-12.7-26.2-27.2-28.3zm-32-56v56c0 16.1 11.9 29.4 27.3 31.7l8.9 84.5c2.1 20.4 19.3 35.8 39.8 35.8h40c20.5 0 37.6-15.5 39.8-35.8l8.9-84.5c15.5-2.3 27.3-15.6 27.3-31.7V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64zM126.6 383.7c8.7-1.7 14.4-10.1 12.7-18.7s-10.1-14.4-18.7-12.7c-33.2 6.4-61.8 15.3-82.6 26.2C27.6 384 18.5 390.4 11.8 398C4.9 405.6 0 415.1 0 426.2c0 17.6 12.2 31 25.8 40.3c14.1 9.7 33.5 17.8 56 24.4C127.1 504.1 188.7 512 256 512s128.9-7.9 174.2-21.1c22.5-6.6 41.9-14.7 56-24.4c13.6-9.4 25.8-22.7 25.8-40.3c0-11.1-4.9-20.6-11.8-28.3c-6.7-7.5-15.9-13.9-26.2-19.4c-20.8-11-49.4-19.8-82.6-26.2c-8.7-1.7-17.1 4-18.7 12.7s4 17.1 12.7 18.7c31.6 6.1 56.8 14.2 73.6 23.1c8.4 4.5 14 8.7 17.3 12.5c3.2 3.6 3.6 5.9 3.6 6.9c0 1.6-1.3 6.6-11.9 14c-10.2 7-25.9 13.9-46.8 20C379.6 472.3 321.2 480 256 480s-123.6-7.7-165.2-19.8c-20.9-6.1-36.7-13-46.8-20c-10.7-7.3-11.9-12.3-11.9-14c0-1.1 .4-3.3 3.6-6.9c3.3-3.7 8.9-8 17.3-12.5c16.8-8.9 42-17 73.6-23.1z"]
};
var faArrowDownLeft = {
  prefix: 'fal',
  iconName: 'arrow-down-left',
  icon: [384, 512, [], "e091", "M48 416c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16V361.4L324.7 100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 384H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H48z"]
};
var faFrancSign = {
  prefix: 'fal',
  iconName: 'franc-sign',
  icon: [320, 512, [], "e18f", "M104 32C81.9 32 64 49.9 64 72V208 320H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64V464c0 8.8 7.2 16 16 16s16-7.2 16-16V352H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V224H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V72c0-4.4 3.6-8 8-8H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H104z"]
};
var faFlaskRoundPoison = {
  prefix: 'fal',
  iconName: 'flask-round-poison',
  icon: [448, 512, ["flask-poison"], "f6e0", "M160 32H288V157.7c0 18.2 10.1 33.7 24.4 42C364.9 230.3 400 287.1 400 352c0 47.4-18.7 90.4-49.2 122.1c-3.1 3.2-8.8 5.9-17 5.9H114.2c-8.2 0-13.9-2.7-17-5.9C66.7 442.4 48 399.4 48 352c0-64.9 35.1-121.7 87.6-152.2c14.3-8.3 24.4-23.9 24.4-42V32zM320 157.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304 144 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V157.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4zM128 312c0-36.4 39.2-72 96-72s96 35.6 96 72c0 20.5-11.7 40.1-32.7 54c-8.7 5.8-15.3 15.8-15.3 27.7V416H176V393.7c0-11.9-6.6-21.9-15.3-27.7c-21-13.9-32.7-33.5-32.7-54zm96-104c-66.9 0-128 43.2-128 104c0 33.6 19.3 62.3 47.1 80.7c.5 .3 .7 .6 .9 .9c.1 .1 .1 .2 .1 .2V416c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V393.7c0 0 0-.1 .1-.2c.1-.2 .4-.6 .9-.9C332.7 374.3 352 345.6 352 312c0-60.8-61.1-104-128-104zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM184 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFlaskPoison = faFlaskRoundPoison;
var faVolumeOff = {
  prefix: 'fal',
  iconName: 'volume-off',
  icon: [320, 512, [], "f026", "M288 66.7L151.6 188c-2.9 2.6-6.7 4-10.6 4H56c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h85c3.9 0 7.7 1.4 10.6 4L288 445.3V66.7zM270.4 39.5c5.5-4.8 12.5-7.5 19.8-7.5C306.7 32 320 45.3 320 61.8V450.2c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5l10.6-12-10.6 12L134.9 352H56c-30.9 0-56-25.1-56-56V216c0-30.9 25.1-56 56-56h78.9L270.4 39.5z"]
};
var faBookCircleArrowRight = {
  prefix: 'fal',
  iconName: 'book-circle-arrow-right',
  icon: [640, 512, [], "e0bc", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H394.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H326.6c-2.9-10.3-4.9-21-5.9-32H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16V211.2c10.1-5.2 20.8-9.4 32-12.6V48c0-26.5-21.5-48-48-48H64zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-3.3-211.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faChartUser = {
  prefix: 'fal',
  iconName: 'chart-user',
  icon: [640, 512, ["user-chart"], "f6a3", "M576 32H224c-17.7 0-32 14.3-32 32v36c-10.2-2.6-21-4-32-4V64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-5.3-11.4-11.8-22.2-19.5-32H576c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zM400 128c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V166.6L395.3 267.3c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L384 233.4 473.4 144H416c-8.8 0-16-7.2-16-16zM160 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 384c-54.2 0-98.4 42.5-101.2 96H287.9c-2.8-53.5-47-96-101.2-96H133.3zm0-32h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"]
};
var faUserChart = faChartUser;
var faHandsAslInterpreting = {
  prefix: 'fal',
  iconName: 'hands-asl-interpreting',
  icon: [640, 512, ["american-sign-language-interpreting", "asl-interpreting", "hands-american-sign-language-interpreting"], "f2a3", "M146.5 3.7C122-6.5 93.9 5.1 83.7 29.5L9.8 206.8C3.3 222.4 0 239.1 0 256c0 70.7 57.3 128 128 128h80c41.5 0 77.7-22.6 97-56c10.7-18.4 7.7-41-5.8-56c13.5-15 16.4-37.6 5.8-56c-5.5-9.5-12.4-18.2-20.4-25.6l31-7.8c25.7-6.4 41.4-32.5 34.9-58.2s-32.5-41.4-58.2-34.9l-16.8 4.2 10-7.8c20.9-16.3 24.6-46.5 8.2-67.4l-12.6 9.9 12.6-9.9c-16.3-20.9-46.5-24.6-67.4-8.2L176 49.7c.7-19.4-10.5-38.1-29.5-46zM263.8 256l-.3 0-.3 0c-5.5-.1-10.7-3-13.6-8c-8.3-14.4-23.9-24-41.6-24c-26.5 0-48 21.5-48 48s21.5 48 48 48c17.7 0 33.3-9.6 41.6-24c2.9-5 8.1-7.9 13.6-8l.3 0 .3 0c2.6 0 5.2 .7 7.7 2.2c7.6 4.4 10.3 14.2 5.8 21.9c-13.8 23.9-39.7 40-69.3 40H128c-53 0-96-43-96-96c0-12.7 2.5-25.2 7.4-36.9L113.2 41.8c3.4-8.2 12.8-12 20.9-8.6s12 12.8 8.6 20.9L127.9 89.9c-2.8 6.7-.7 14.5 5.1 18.9s13.8 4.4 19.6-.1l93.6-73.3c7-5.4 17-4.2 22.5 2.7s4.2 17-2.7 22.5l-69.3 54.2c-5.9 4.7-7.8 12.8-4.5 19.6s10.9 10.3 18.3 8.5l89.8-22.4c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-66.3 16.6c-6.7 1.7-11.5 7.4-12.1 14.3s3.4 13.3 9.7 16c16 6.8 29.4 18.7 38 33.7c4.4 7.6 1.8 17.4-5.8 21.9c-2.5 1.4-5.1 2.1-7.7 2.2zm-41.9 8c1.7 2.9 3.6 5.6 5.8 8c-2.1 2.4-4.1 5.1-5.8 8c-2.8 4.9-8 8-13.9 8c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.9 0 11.1 3.2 13.9 8zM493.5 508.3c24.5 10.2 52.6-1.4 62.8-25.8l73.8-177.2c6.5-15.6 9.8-32.3 9.8-49.2c0-70.7-57.3-128-128-128H432c-41.5 0-77.7 22.6-97 56c-10.7 18.4-7.7 41 5.8 56c-13.5 15-16.4 37.6-5.8 56c5.5 9.5 12.4 18.2 20.4 25.6l-31 7.8c-25.7 6.4-41.4 32.5-34.9 58.2s32.5 41.4 58.2 34.9l16.8-4.2-10 7.8c-20.9 16.3-24.6 46.5-8.2 67.4s46.5 24.6 67.4 8.2L464 462.3c-.7 19.4 10.6 38.1 29.5 46zM376.2 256l.3 0 .3 0c5.5 .1 10.7 3 13.6 8c8.3 14.4 23.9 24 41.6 24c26.5 0 48-21.5 48-48s-21.5-48-48-48c-17.7 0-33.3 9.6-41.6 24c-2.9 5-8.1 7.9-13.6 8l-.3 0-.3 0c-2.6 0-5.2-.7-7.7-2.2c-7.6-4.4-10.3-14.2-5.8-21.9c13.8-23.9 39.7-40 69.3-40h80c53 0 96 43 96 96c0 12.7-2.5 25.2-7.4 36.9L526.8 470.2c-3.4 8.2-12.8 12-20.9 8.6s-12-12.8-8.6-20.9l14.9-35.8c2.8-6.7 .7-14.5-5.1-18.9s-13.8-4.4-19.6 .1l-93.6 73.3c-7 5.4-17 4.2-22.5-2.7s-4.2-17 2.7-22.5l69.3-54.2c5.9-4.7 7.8-12.8 4.5-19.6s-10.9-10.3-18.3-8.5l-89.8 22.4c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l66.3-16.6c6.7-1.7 11.5-7.4 12.1-14.3s-3.4-13.3-9.7-16c-16-6.8-29.4-18.7-38-33.7c-4.4-7.6-1.8-17.4 5.8-21.9c2.5-1.4 5.1-2.1 7.7-2.2zm41.9-8c-1.7-2.9-3.6-5.6-5.8-8c2.1-2.4 4.1-5.1 5.8-8c2.8-4.9 8-8 13.9-8c8.8 0 16 7.2 16 16s-7.2 16-16 16c-5.9 0-11.1-3.2-13.9-8z"]
};
var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faAslInterpreting = faHandsAslInterpreting;
var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faPresentationScreen = {
  prefix: 'fal',
  iconName: 'presentation-screen',
  icon: [576, 512, ["presentation"], "f685", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM32 64V288c0 35.3 28.7 64 64 64H272v41.4l-91.3 91.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 422.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L304 393.4V352H480c35.3 0 64-28.7 64-64V64H512V288c0 17.7-14.3 32-32 32H288 96c-17.7 0-32-14.3-32-32V64H32z"]
};
var faPresentation = faPresentationScreen;
var faCircleBolt = {
  prefix: 'fal',
  iconName: 'circle-bolt',
  icon: [512, 512, [], "e0fe", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm191.7 8H240c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L320.3 248H272c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L191.7 264zM313.6 112c14.7 0 24.4 15.2 18.2 28.5L297 216h49.4c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L212.2 394.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L215 296H165.6c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L299.8 117.5c3.7-3.5 8.7-5.5 13.8-5.5z"]
};
var faFaceSmileHalo = {
  prefix: 'fal',
  iconName: 'face-smile-halo',
  icon: [512, 512, [], "e38f", "M480.3 78.1a.1 .1 0 1 0 -.2 0 .1 .1 0 1 0 .2 0zm-7.4-3.5c3.2 2.4 5 4.2 6.1 5.4c-1.1 1.2-2.9 3-6.1 5.4c-9 6.6-24 13.9-45.4 20.6C385 119.3 324.4 128 256 128s-129-8.7-171.5-22C63.1 99.3 48.1 92 39.1 85.4c-3.2-2.4-5-4.2-6.1-5.4c1.1-1.2 2.9-3 6.1-5.4c9-6.6 24-13.9 45.4-20.6C127 40.7 187.6 32 256 32s129 8.7 171.5 22c21.4 6.7 36.4 14 45.4 20.6zM31.7 78.1a.1 .1 0 1 0 .2 0 .1 .1 0 1 0 -.2 0zm0 3.8a.1 .1 0 1 0 .2 0 .1 .1 0 1 0 -.2 0zm448.5-.1a.2 .2 0 1 0 -.1 .3 .2 .2 0 1 0 .1-.3zM512 80C512 35.8 397.4 0 256 0S0 35.8 0 80s114.6 80 256 80s256-35.8 256-80zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5c-9.5 3.9-19.7 7.6-30.5 11C453.8 198.2 464 233.9 464 272c0 114.9-93.1 208-208 208S48 386.9 48 272c0-38.1 10.2-73.8 28.1-104.5c-10.9-3.4-21.1-7.1-30.5-11zm110.9 94c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 217.9 194.8 208 176 208s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm-14.9 89.4c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm162-64c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 217.9 354.8 208 336 208s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6z"]
};
var faCartCircleArrowDown = {
  prefix: 'fal',
  iconName: 'cart-circle-arrow-down',
  icon: [640, 512, [], "e3ef", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM608 368a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zm-256 0a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm211.3-3.3c-6.2-6.2-16.4-6.2-22.6 0L512 393.4V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56 56c6.2 6.2 16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faHousePersonReturn = {
  prefix: 'fal',
  iconName: 'house-person-return',
  icon: [640, 512, ["house-person-arrive", "house-return"], "e011", "M250.4 3.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L64 187.9V352c0 35.3 28.7 64 64 64H348.6l9.1-32H352 320 128c-17.7 0-32-14.3-32-32V160.5L240 37.1 367.9 146.7c5.8-9.1 12.6-17.4 20.4-24.7L250.4 3.9zM192 192h64v64H192V192zm-8-32c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H184zM464 56a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-80 0a56 56 0 1 0 112 0A56 56 0 1 0 384 56zM522.4 172.3l12.7 6.9c27.5 15 47.4 40.8 55 71.2l2.4 9.6c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4l-2.4-9.5c-9.8-39-35.4-72.2-70.7-91.5l-12.7-6.9c-19.4-10.6-41.2-16.2-63.4-16.2c-36.9 0-69.7 23.6-81.4 58.7l-17.1 51.4c-3.4 10.1-10 18.8-18.9 24.8l-29.7 19.8c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l29.7-19.8c14.8-9.9 25.9-24.4 31.5-41.3l8.8-26.4L452.7 331l-43.6 37.8c-4.7 4.1-8.1 9.4-9.8 15.4L368.6 491.6c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11L430.1 393l100.6-87.2c14.4-12.5 20.1-32.4 14.4-50.6l-26.6-85c1.3 .6 2.6 1.3 3.9 2zm-7.9 92.5c1.9 6.1 0 12.7-4.8 16.9l-30.9 26.8-45-130c10-11.5 24.7-18.4 40.6-18.4c2.5 0 5 .1 7.5 .3l32.7 104.5zm6.4 88.9c-7.9 4-11.1 13.6-7.2 21.5l30.8 61.7c1.5 3.1 3.6 5.9 6 8.3l62.2 62.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-62.2-62.2-30.8-61.7c-4-7.9-13.6-11.1-21.5-7.2z"]
};
var faHousePersonArrive = faHousePersonReturn;
var faHouseReturn = faHousePersonReturn;
var faMessageXmark = {
  prefix: 'fal',
  iconName: 'message-xmark',
  icon: [512, 512, ["comment-alt-times", "message-times"], "f4ab", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM180.7 132.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 208l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 230.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 208l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 185.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faCommentAltTimes = faMessageXmark;
var faMessageTimes = faMessageXmark;
var faFileCertificate = {
  prefix: 'fal',
  iconName: 'file-certificate',
  icon: [512, 512, ["file-award"], "f5f3", "M480 448c0 17.7-14.3 32-32 32H224v16c0 5.5-1 10.9-2.7 16H448c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64v71.1l.1-.1c1.5-.7 4-2 6.6-3c8.2-3.4 16.9-4.6 25.3-4V64c0-17.7 14.3-32 32-32H320V144c0 26.5 21.5 48 48 48H480V448zm-.5-288H368c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM69.8 358.5l-2.1 15.2 2.1-15.2L59 357l-1.5-10.8c-1.4-10.4-6.9-19.8-15.1-26.2L22.8 345.2 42.4 320l-8.6-6.7 4.1-10.1c4-9.7 4-20.6 0-30.3l-4.1-10.1 8.6-6.7L22.8 230.7 9.3 241.2c-8.5 6.6-11.6 18.1-7.5 28L8.2 285c.8 1.9 .8 4.1 0 6L1.8 306.8c-4.1 10-1 21.4 7.5 28l13.5 10.4c1.7 1.3 2.7 3.2 3 5.2l2.3 16.9c1.5 10.7 9.8 19.1 20.5 20.5L64 390V496c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L128 483.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V390l15.4-2.1c10.7-1.5 19.1-9.8 20.5-20.5l2.3-16.9-31.7-4.3L197 357l-10.8 1.5c-10.4 1.4-19.8 6.9-26.2 15.1l-6.7 8.6-10.1-4.1c-9.7-4-20.6-4-30.3 0l-10.1 4.1L96 373.6c-6.4-8.3-15.8-13.7-26.2-15.1zm-47-127.7L42.4 256c8.3-6.4 13.7-15.8 15.1-26.2L29.3 226l28.2 3.8L59 219l10.8-1.5c10.4-1.4 19.8-6.9 26.2-15.1l6.7-8.6 10.1 4.1c9.7 4 20.6 4 30.3 0l-11.3-27.6 11.3 27.6 10.1-4.1 6.7 8.6c6.4 8.3 15.8 13.7 26.2 15.1L197 219l1.5 10.8c1.4 10.4 6.9 19.8 15.1 26.2l8.6 6.7-4.1 10.1c-4 9.7-4 20.6 0 30.3l4.1 10.1-8.6 6.7c-8.3 6.4-13.7 15.8-15.1 26.2l31.7 4.3c.3-2.1 1.4-4 3-5.2l13.5-10.4c8.5-6.6 11.6-18.1 7.5-28L247.8 291c-.8-1.9-.8-4.1 0-6l6.5-15.8c4.1-10 1-21.4-7.5-28l-13.5-10.4c-1.7-1.3-2.7-3.2-3-5.2l-2.3-16.9c-1.5-10.7-9.8-19.1-20.5-20.5l-16.9-2.3c-2.1-.3-4-1.4-5.2-3l-10.4-13.5c-6.6-8.5-18.1-11.6-28-7.5L131 168.2c-1.9 .8-4.1 .8-6 0l-15.8-6.5c-10-4.1-21.4-1-28 7.5L70.7 182.8c-1.3 1.7-3.2 2.7-5.2 3l-16.9 2.3c-10.7 1.5-19.1 9.8-20.5 20.5l-2.3 16.9c-.3 2.1-1.4 4-3 5.2zM160 466.1l-23.1-15.4c-5.4-3.6-12.4-3.6-17.8 0L96 466.1V415.6c4.3 .8 8.9 .3 13.2-1.4l15.8-6.5c1.9-.8 4.1-.8 6 0l15.8 6.5c4.3 1.8 8.9 2.2 13.2 1.4v50.5z"]
};
var faFileAward = faFileCertificate;
var faUserDoctorHairLong = {
  prefix: 'fal',
  iconName: 'user-doctor-hair-long',
  icon: [448, 512, [], "e459", "M320 144c0 53-43 96-96 96s-96-43-96-96V128l34.3 0c31.7 0 61.1-14.5 80.4-38.7l6.3 6.3c10.5 10.5 24.7 16.4 39.6 16.4h30.1c.9 5.2 1.3 10.5 1.3 16v16zm32-16C352 57.3 294.7 0 224 0S96 57.3 96 128c0 35.3-16.6 68.4-44.8 89.6l-4.3 3.2C37.5 227.9 32 238.9 32 250.7C32 271.3 48.7 288 69.3 288H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H69.3c-2.9 0-5.3-2.4-5.3-5.3c0-1.7 .8-3.3 2.1-4.3l4.3-3.2c15.8-11.9 28.8-26.7 38.4-43.4C129.5 242.6 173.3 272 224 272s94.5-29.4 115.2-72.2c9.6 16.7 22.6 31.5 38.4 43.4l4.3 3.2c1.3 1 2.1 2.6 2.1 4.3c0 2.9-2.4 5.3-5.3 5.3H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h58.7c20.6 0 37.3-16.7 37.3-37.3c0-11.8-5.5-22.8-14.9-29.9l-4.3-3.2C368.6 196.4 352 163.3 352 128zM225.5 57.1C213.5 81 189.1 96 162.3 96H133.5c13.2-37.3 48.7-64 90.5-64c35.5 0 66.6 19.3 83.2 48H288.6c-6.4 0-12.5-2.5-17-7L251.3 52.7c-6.2-6.2-16.4-6.2-22.6 0c-1.3 1.3-2.4 2.8-3.1 4.5zM270.8 336c5.8 0 11.5 .3 17.2 1v33.3c-23.1 6.9-40 28.3-40 53.7v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V424c0-25.4-16.9-46.8-40-53.7V344.5c55.6 20 95.5 73 96 135.5H32c.5-68.2 48.2-125.3 112-140.2v30.9c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V336l1.2 0h93.6zM176 416a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM0 481.2c0 17 13.8 30.8 30.8 30.8H417.2c17 0 30.8-13.8 30.8-30.8C448 383.3 368.7 304 270.8 304H177.2C79.3 304 0 383.3 0 481.2z"]
};
var faCameraSecurity = {
  prefix: 'fal',
  iconName: 'camera-security',
  icon: [448, 512, ["camera-home"], "f8fe", "M384 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H324.2 123.8 64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM343.9 416H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h40.1L67.6 475.4c-4.6 7.4-4.8 16.7-.5 24.3s12.3 12.3 21 12.3H360c8.7 0 16.7-4.7 21-12.3s4-16.9-.5-24.3L343.9 416zm-202.2 0H306.3l39.4 64H102.3l39.4-64zM224 304a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM96 208a128 128 0 1 0 256 0A128 128 0 1 0 96 208z"]
};
var faCameraHome = faCameraSecurity;
var faGear = {
  prefix: 'fal',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", "M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.1-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.1-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"]
};
var faCog = faGear;
var faDropletSlash = {
  prefix: 'fal',
  iconName: 'droplet-slash',
  icon: [640, 512, ["tint-slash"], "f5c7", "M320 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c2.8-6.4 5.8-13 9.1-19.7l-25.7-20.3C141.8 252.1 128 290.3 128 320c0 106 86 192 192 192c56.1 0 106.7-24.1 141.8-62.5l-25.2-19.9C407.4 460.6 366 480 320 480zM461.7 252.5c7.6 17.6 12.8 33.1 15.7 46.2L511.9 326c.1-2 .1-4 .1-6c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7c-13.3 16.8-39 50.2-66.4 90.3l25.2 19.9c27-39.7 52.6-73 66-89.9h1.3c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8zM240 320c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTintSlash = faDropletSlash;
var faBookHeart = {
  prefix: 'fal',
  iconName: 'book-heart',
  icon: [448, 512, [], "f499", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM160 173.3c0 7.8 3.1 15.2 8.6 20.7L240 265.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6c-16.2 0-29.3 13.1-29.3 29.3zM189.3 112c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3c0-33.8 27.4-61.3 61.3-61.3z"]
};
var faMosque = {
  prefix: 'fal',
  iconName: 'mosque',
  icon: [640, 512, [128332], "f678", "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.4 54.5-29.8 73.5c34.3 1.2 61.8 29.3 61.8 64v96c0 35.3-28.7 64-64 64H544 512 464 432 368 336 288 256 224c-35.3 0-64-28.7-64-64V352c0-34.6 27.5-62.8 61.8-64c-18.5-19-29.8-44.9-29.8-73.5c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zm32 480V424c0-10.1-4.7-19.6-12.8-25.6L400 384l-19.2 14.4c-8.1 6-12.8 15.5-12.8 25.6v56h64zm32 0h48V400c0-8.8 7.2-16 16-16s16 7.2 16 16v80h32c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H502.6 400 297.4 224c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h32V400c0-8.8 7.2-16 16-16s16 7.2 16 16v80h48V424c0-20.1 9.5-39.1 25.6-51.2L400 344l38.4 28.8C454.5 384.9 464 403.9 464 424v56zM576 214.6c0-24-11.7-46.3-31.4-59.4c-5.6-3.7-11.1-7.3-16.5-10.9l0 0 0 0 0 0 0 0 0 0 0 0c-48.6-32.1-92.1-60.7-128-102.7c-35.9 41.9-79.4 70.6-128 102.7l0 0c-5.5 3.6-11 7.2-16.6 10.9c-19.7 13.1-31.4 35.4-31.4 59.4c0 40.6 32.9 73.4 73.4 73.4H400 502.6c40.6 0 73.4-32.9 73.4-73.4zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2 32V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H32v16V448c0 17.7 14.3 32 32 32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V176 126C0 83.2 20.2 42.9 54.4 17.2l16-12zM32 128h96v-2c0-32.7-15.4-63.6-41.6-83.2L80 38l-6.4 4.8C47.4 62.4 32 93.3 32 126v2z"]
};
var faDuck = {
  prefix: 'fal',
  iconName: 'duck',
  icon: [512, 512, [129414], "f6d8", "M368 259V235.4c0-17.3 7.1-31.9 15.3-42.5L402.7 208l-19.4-15.1C393.8 179.4 400 162.5 400 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.5 32.2 64.2c9.8 7.3 14.5 19.5 12.3 31.5s-11.1 21.7-22.8 25l-165 46.2c-7 2-14.5 1.5-21.2-1.4L32.2 290.9C36.5 378 108.4 448 196 448H312c53 0 96-43 96-96c0-27.5-11.5-52.2-30-69.7c-6.4-6-10-14.4-10-23.2zm32-19v19c24.6 23.3 40 56.3 40 93c0 70.7-57.3 128-128 128H196C87.8 480 0 391 0 282.7C0 268.1 11.9 256 26.6 256c3.6 0 7.2 .7 10.5 2.1L88 280l128.4-36L253 233.8c-9.8-7.3-18.3-16.1-25.2-26.2c-12.5-18.1-19.8-40-19.8-63.6c0-61.9 50.1-112 112-112c54.1 0 99.3 38.4 109.7 89.4c9.6 1.3 19.3 1.3 28.9 .1l24.2-3c15.5-1.9 29.2 10.1 29.2 25.8c0 52.9-42.9 95.7-95.7 95.7H400zm31.6-86.2c-1.7 20-8.8 38.6-19.7 54.2h4.4c32.9 0 59.9-24.9 63.3-56.8l-17 2.1c-10.3 1.3-20.7 1.5-31 .5zM312 152a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm13.2 159.7c-6.2 46.7-41.4 87-90.7 99.3c-40.4 10.1-81.2-.9-109.7-26.2c-6.6-5.9-7.2-16-1.3-22.6s16-7.2 22.6-1.3c20.7 18.3 50.6 26.6 80.7 19.1c36.8-9.2 62.3-39 66.7-72.5c1.2-8.8 9.2-14.9 18-13.7s14.9 9.2 13.7 18z"]
};
var faMosquito = {
  prefix: 'fal',
  iconName: 'mosquito',
  icon: [640, 512, [], "e52b", "M182.4 3.4c-6.9 5.5-8.2 15.7-2.8 22.7l41.9 55.7L194 136.5c-3.2 6.3-2 14.1 3 19l45.1 45.1L79.3 226.2C34 232.1 0 272.5 0 320.3c0 84.5 97.6 126.9 154.6 67.1L272 280.4v23.9L228 357c-2.5 2.9-3.8 6.7-3.8 10.6v58.3l-44.7 59.5c-5.3 7.1-4.1 17.3 2.8 22.7s16.8 4.2 22.1-2.9l48-63.9c2.1-2.8 3.3-6.3 3.3-9.9V373.5L272 354.1v45.4c0 26.5 21.5 48 48 48s48-21.5 48-48V354.1l16.2 19.4 0 57.9c0 3.6 1.2 7.1 3.3 9.9l48 63.9c5.3 7.1 15.2 8.4 22.1 2.9s8.2-15.7 2.8-22.7l-44.7-59.5V367.5c0-3.9-1.4-7.6-3.8-10.6l-44-52.7V280.4L485.4 387.4C542.4 447.2 640 404.9 640 320.3c0-47.9-34-88.2-79.4-94.2L397.9 200.7 443 155.6c5-5 6.2-12.7 3-19L418.6 81.8l41.9-55.7c5.3-7.1 4.1-17.3-2.8-22.7s-16.8-4.2-22.1 2.9l-48 63.9c-3.7 5-4.3 11.7-1.5 17.3l26.7 53.2L368 185.4v-9.5c0-23.8-17.3-43.5-40-47.3V63.8c0-4.4-3.6-8-8-8s-8 3.6-8 8v64.8c-22.7 3.8-40 23.6-40 47.3v9.5l-44.6-44.7L254 87.5c2.8-5.6 2.2-12.4-1.5-17.3l-48-63.9c-5.3-7.1-15.2-8.4-22.1-2.9zM272 237.1L133.1 363.8c-.5 .5-1.1 1-1.6 1.5C96.6 401.9 32 379.3 32 320.3c0-32.9 23.2-58.7 51.5-62.4c.3 0 .5-.1 .8-.1l185.8-29.1 1.9 1.9 0 6.4zM506.9 363.8L368 237l0-6.4 1.9-1.9 185.8 29.1c.3 0 .5 .1 .8 .1c28.3 3.7 51.5 29.5 51.5 62.4c0 58.9-64.6 81.6-99.5 45c-.5-.5-1-1-1.6-1.5zM304 399.5l0-223.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 223.6c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faStarOfDavid = {
  prefix: 'fal',
  iconName: 'star-of-david',
  icon: [512, 512, [10017], "f69a", "M418.3 286.6l-50 81.4h90.2c3 0 5.4-2.4 5.4-5.4c0-1-.3-2-.8-2.8l-44.9-73.1zM399.5 256L330.8 144H181.2L112.5 256l68.7 112H330.8l68.7-112zm37.5 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zM368.4 144l50 81.4 44.9-73.1c.5-.9 .8-1.8 .8-2.8c0-3-2.4-5.4-5.4-5.4H368.4zm-57.2-32L265.3 37.2c-2-3.2-5.5-5.2-9.3-5.2s-7.3 2-9.3 5.2L200.8 112H311.2zM143.6 144H53.4c-3 0-5.4 2.4-5.4 5.4c0 1 .3 2 .8 2.8l44.9 73.1 50-81.4zm-50 142.6L48.8 359.7c-.5 .9-.8 1.8-.8 2.8c0 3 2.4 5.4 5.4 5.4h90.2l-50-81.4zM200.8 400l45.9 74.8c2 3.2 5.5 5.2 9.3 5.2s7.3-2 9.3-5.2L311.2 400H200.8z"]
};
var faFlagSwallowtail = {
  prefix: 'fal',
  iconName: 'flag-swallowtail',
  icon: [448, 512, ["flag-alt"], "f74c", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V32 64 320v32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V352H424c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24H32V16zm0 48H408L326.4 172.8c-8.5 11.4-8.5 27 0 38.4L408 320H32V64z"]
};
var faFlagAlt = faFlagSwallowtail;
var faPersonMilitaryRifle = {
  prefix: 'fal',
  iconName: 'person-military-rifle',
  icon: [512, 512, [], "e54b", "M192 64V59.1L320 37.8V64v0H192v0zm160 8V28.3c0-14.8-13.3-26.1-27.9-23.7l-144 24C168.5 30.6 160 40.6 160 52.3V72c0 11.1 7.5 20.4 17.8 23.2c-1.2 5.4-1.8 11-1.8 16.8c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.8-.6-11.4-1.8-16.8C344.5 92.4 352 83.1 352 72zM210.7 96h90.5c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16zM192 296c0-2.3 .2-4.6 .6-6.7L301.6 480H208c-8.8 0-16-7.2-16-16V296zM320 447.8l-106.9-187c5.6-3 12.1-4.7 18.9-4.7h48c22.1 0 40 17.9 40 40V447.8zM352 464V300.2l98.1 171.7c4.4 7.7 14.2 10.3 21.8 6s10.3-14.2 6-21.8L384 291.7l46.9-81.2c8.8-15.3 3.6-34.9-11.7-43.7l16-27.7 32-55.4 8-13.9c4.4-7.7 1.8-17.4-5.9-21.9l-13.9-8c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l-16 27.7-16 27.7-16 27.7c-15.3-8.8-34.9-3.6-43.7 11.7L309.9 228c-9.5-2.6-19.5-4-29.6-4H280 232h-.3c-40.2 0-77.3 21.5-97.2 56.4L34.1 456.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6L160 300.2V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48zM339.4 240.9l36-62.3 27.7 16-38.9 67.3c-7.3-8.2-15.6-15.3-24.8-21zM288 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faCarGarage = {
  prefix: 'fal',
  iconName: 'car-garage',
  icon: [640, 512, [], "f5e2", "M328.5 2.5c-5.2-3.3-11.9-3.3-17.1 0l-304 192c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5L320 34.9 615.5 221.5c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1l-304-192zM252.2 208H387.8c14.3 0 26.8 9.5 30.8 23.2L434.8 288c-.9 0-1.9 0-2.8 0H208c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L169 298.1c-24.5 13.7-41 39.9-41 69.9v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H480v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H252.2c-28.6 0-53.7 18.9-61.5 46.4zM480 416v16H160V416 368c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48v48zM208 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCartShopping = {
  prefix: 'fal',
  iconName: 'cart-shopping',
  icon: [576, 512, [128722, "shopping-cart"], "f07a", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H53.9c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H191.2c-15.2 0-28.3-10.7-31.4-25.6L152 288H466.5c29.4 0 55-20 62.1-48.5L570.6 71.8c5-20.2-10.2-39.8-31-39.8H99.1C92.5 13 74.4 0 53.9 0H16zm90.1 64H539.5L497.6 231.8C494 246 481.2 256 466.5 256H145.4L106.1 64zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faShoppingCart = faCartShopping;
var faBookFont = {
  prefix: 'fal',
  iconName: 'book-font',
  icon: [448, 512, [], "e0bf", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM254.3 104.8l63.9 127.7c.1 .2 .2 .4 .3 .6l31.8 63.7c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L294.1 256H185.9l-27.6 55.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l31.8-63.7c.1-.2 .2-.4 .3-.6l63.9-127.7c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8zM278.1 224L240 147.8 201.9 224h76.2z"]
};
var faShieldPlus = {
  prefix: 'fal',
  iconName: 'shield-plus',
  icon: [512, 512, [], "e24a", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faVials = {
  prefix: 'fal',
  iconName: 'vials',
  icon: [512, 512, [], "f493", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H32V272 400c0 44.2 35.8 80 80 80s80-35.8 80-80V272 64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H176 48 16zM64 256V64h96V256H64zm0 32h96V400c0 26.5-21.5 48-48 48s-48-21.5-48-48V288zM304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V272 400c0 44.2 35.8 80 80 80s80-35.8 80-80V272 64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H464 336 304zm48 224V64h96V256H352zm0 32h96V400c0 26.5-21.5 48-48 48s-48-21.5-48-48V288z"]
};
var faEyeDropperFull = {
  prefix: 'fal',
  iconName: 'eye-dropper-full',
  icon: [512, 512, [], "e172", "M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l0 0-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4 0 0 0 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 39.9c-6.2-6.2-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6v41.2L3.8 469.1C1.3 473.5 0 478.4 0 483.4C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480h41.2c21.2 0 41.6-8.4 56.6-23.4L299.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-112-112zM78.1 344.6L176 246.6 265.4 336l-97.9 97.9c-9 9-21.2 14.1-33.9 14.1H88 83.8l-3.7 2.1L37.7 474.3l24.2-42.4 2.1-3.7V424 378.5c0-12.7 5.1-24.9 14.1-33.9z"]
};
var faDistributeSpacingHorizontal = {
  prefix: 'fal',
  iconName: 'distribute-spacing-horizontal',
  icon: [512, 512, [], "e365", "M464 0c-8.8 0-16 7.2-16 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16l0-480c0-8.8-7.2-16-16-16zM320 368c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 224zm32-224c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-224zM64 16C64 7.2 56.8 0 48 0S32 7.2 32 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16L64 16z"]
};
var faTabletRugged = {
  prefix: 'fal',
  iconName: 'tablet-rugged',
  icon: [448, 512, [], "f48f", "M64.5 58.4C67.1 43.4 80.2 32 96 32H352c15.8 0 28.9 11.4 31.5 26.4c.9 5 4.1 9.3 8.6 11.5L416 81.9v60.2l-23.2 11.6c-5.4 2.7-8.8 8.3-8.8 14.3v32c0 6.1 3.4 11.6 8.8 14.3L416 225.9v60.2l-23.2 11.6c-5.4 2.7-8.8 8.3-8.8 14.3v32c0 6.1 3.4 11.6 8.8 14.3L416 369.9v60.2l-23.9 11.9c-4.5 2.3-7.7 6.6-8.6 11.5c-2.6 15-15.8 26.4-31.5 26.4H96c-15.8 0-28.9-11.4-31.5-26.4c-.9-5-4.1-9.3-8.6-11.5L32 430.1V369.9l23.2-11.6c5.4-2.7 8.8-8.2 8.8-14.3V312c0-6.1-3.4-11.6-8.8-14.3L32 286.1V225.9l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3V168c0-6.1-3.4-11.6-8.8-14.3L32 142.1V81.9L55.9 69.9c4.5-2.3 7.7-6.5 8.6-11.5zM96 0C67.4 0 43.2 18.7 35 44.6L8.8 57.7C3.4 60.4 0 65.9 0 72v80c0 6.1 3.4 11.6 8.8 14.3L32 177.9v12.2L8.8 201.7C3.4 204.4 0 209.9 0 216v80c0 6.1 3.4 11.6 8.8 14.3L32 321.9v12.2L8.8 345.7C3.4 348.4 0 353.9 0 360v80c0 6.1 3.4 11.6 8.8 14.3L35 467.4C43.2 493.3 67.4 512 96 512H352c28.6 0 52.8-18.7 61-44.6l26.1-13.1c5.4-2.7 8.8-8.2 8.8-14.3V360c0-6.1-3.4-11.6-8.8-14.3L416 334.1V321.9l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3V216c0-6.1-3.4-11.6-8.8-14.3L416 190.1V177.9l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3V72c0-6.1-3.4-11.6-8.8-14.3L413 44.6C404.8 18.7 380.6 0 352 0H96zm32 96H320V416H128V96zM96 96V416c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32z"]
};
var faTemperatureSnow = {
  prefix: 'fal',
  iconName: 'temperature-snow',
  icon: [576, 512, ["temperature-frigid"], "f768", "M368 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM432 0c-53 0-96 43-96 96V252.7c0 4.6-2.2 9.8-6.8 14.5C303.7 293.1 288 328.8 288 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM400 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM284.6 142.8l7.6-28.3c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-15.9 59.2L192 196.3V134.6l43.3-43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 89.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V89.4L139.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L160 134.6v61.7l-53.4-30.8L90.7 106.3C88.5 97.8 79.7 92.7 71.2 95s-13.6 11.1-11.3 19.6l7.6 28.3L31.6 122.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l35.8 20.7-28.3 7.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l59.2-15.9L144 224 90.6 254.8 31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l28.3 7.6L15.6 298.1C7.9 302.6 5.3 312.3 9.7 320s14.2 10.3 21.9 5.9l35.8-20.7-7.6 28.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l15.9-59.2L160 251.7v61.7l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L160 358.6V400c0 8.8 7.2 16 16 16s16-7.2 16-16V358.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L192 313.4V251.7l53.4 30.8 13.8 51.7c6.5-33.3 22.4-63.3 44.8-87v-3.8l-42.6 11.4L208 224l53.4-30.8L304 204.6V171.5l-3.4-.9 3.4-2v-37l-19.4 11.2z"]
};
var faTemperatureFrigid = faTemperatureSnow;
var faMoped = {
  prefix: 'fal',
  iconName: 'moped',
  icon: [640, 512, [], "e3b9", "M336 48c0-8.8 7.2-16 16-16h40.9c20.7 0 39 13.2 45.5 32.8l5.2 15.5L500.3 52c5.2-2.6 11-4 16.9-4C532 48 544 60 544 74.9v74.3c0 14.8-12 26.9-26.9 26.9c-5.9 0-11.6-1.4-16.9-4L469 156.4 494.5 233c5.7-.7 11.6-1 17.5-1c41.5 0 79.1 16.6 106.5 43.5c6.3 6.2 6.4 16.3 .2 22.6s-16.3 6.4-22.6 .2C574.4 277.1 544.7 264 512 264c-56.5 0-104 39.1-116.7 91.8c-1.1 4.6-2 9.3-2.5 14.1c-.9 8.1-7.8 14.1-15.9 14.1H336 288 256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32V320c0-70.7 57.3-128 128-128h96c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h32 16 16 11.4c.3-1.3 .6-2.5 .9-3.8c12.2-50.8 50-91.6 98.9-108.2l-55-165.1c-2.2-6.5-8.3-10.9-15.2-10.9H352c-8.8 0-16-7.2-16-16zm118.7 65.5c.2 .1 .3 .1 .5 .2L512 142.1V81.9l-56.8 28.4c-.4 .2-.9 .4-1.3 .6l.9 2.6zM112 128H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 96H128c-53 0-96 43-96 96l0 32H69.5h35.1H215.4h17.1c-5.4-9.4-8.6-20.3-8.6-32V224zM160 448c35.3 0 64-28.7 64-64H96c0 35.3 28.7 64 64 64zm352 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faFaceSmilePlus = {
  prefix: 'fal',
  iconName: 'face-smile-plus',
  icon: [640, 512, ["smile-plus"], "f5b9", "M560 16V80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H560v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112H464c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM416 288A192 192 0 1 0 32 288a192 192 0 1 0 384 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zm144.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM126.9 330.1c4.5 11.2 15.1 29.1 31.8 44C175.1 388.7 196.8 400 224 400s48.9-11.3 65.3-25.9c16.7-14.9 27.3-32.8 31.8-44c3.3-8.2 12.6-12.2 20.8-8.9s12.2 12.6 8.9 20.8c-6.2 15.4-19.5 37.5-40.2 56C289.8 416.6 260.8 432 224 432s-65.8-15.4-86.7-34.1c-20.7-18.5-34-40.6-40.2-56c-3.3-8.2 .7-17.5 8.9-20.8s17.5 .7 20.8 8.9z"]
};
var faSmilePlus = faFaceSmilePlus;
var faRadioTuner = {
  prefix: 'fal',
  iconName: 'radio-tuner',
  icon: [512, 512, ["radio-alt"], "f8d8", "M500.1 31.5c8.5-2.3 13.6-11 11.3-19.6s-11-13.6-19.6-11.3L59.4 115.9c-31.3 8.4-54.1 34.6-58.6 66C.3 185.2 0 188.5 0 192v1.2V240 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H138.1l362-96.5zM32 193.2c0-2.2 .1-4.3 .4-6.4C34.9 171.6 48.1 160 64 160H448c17.7 0 32 14.3 32 32v32H32V193.2zM32 448V256H480V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm272 32a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"]
};
var faRadioAlt = faRadioTuner;
var faFaceSwear = {
  prefix: 'fal',
  iconName: 'face-swear',
  icon: [640, 512, [], "e399", "M534.7 192C507.2 99.5 421.5 32 320 32S132.8 99.5 105.3 192H72.1C100.5 81.6 200.7 0 320 0S539.5 81.6 567.9 192H534.7zM264.4 176c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-8.1 4-15.3 10.2-19.6l-39.6-13.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-19.7-6.6c.8 2.3 1.2 4.8 1.2 7.4zm136 24c-13.3 0-24-10.7-24-24c0-2.7 .4-5.3 1.3-7.7l-20.6 6.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-39.1 13c6.3 4.3 10.4 11.6 10.4 19.8c0 13.3-10.7 24-24 24zM32 288V448c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zM0 288c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288zm400 64H384v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H320v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V352H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V304c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32V304c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0v32h32V352H320zm250.4-52.1c6.7 5.8 7.5 15.9 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zM184 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 304v1.8c4.6 .8 8.7 1.7 12.1 2.6c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9c-4.1 .5-6.3 1.4-7.4 2.2c-.6 .4-1.2 .9-1.5 2.9c-.2 1-.1 1.6-.1 1.8c.1 .1 .5 .6 1.5 1.3c3.7 2.5 9.6 4.4 19.2 7.3l.7 .2c8 2.4 19.1 5.8 27.6 11.9c4.7 3.4 9.3 8.2 12.1 14.7c2.9 6.6 3.4 13.8 2.2 21.1c-2 11.5-7.9 20.5-17 25.9c-4.9 3-10.1 4.6-15.3 5.4v.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c-8.1-1.9-15.3-4.2-20.2-5.9c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c.5-.3 1.4-.9 2-4c.2-1.2 .2-1.9 .2-2.3c0-.4-.1-.6-.1-.6l0 0c0-.1-.3-.6-1.6-1.6c-3.5-2.5-9.3-4.6-18.7-7.4L106 382l0 0c-7.7-2.3-18.3-5.5-26.4-11c-4.7-3.2-9.4-7.7-12.4-14.1c-3.1-6.5-3.7-13.7-2.5-20.9c1.8-10.2 7-18.1 14.5-23.5c5.3-3.8 11.2-5.9 16.9-7V304c0-8.8 7.2-16 16-16s16 7.2 16 16zM96.1 343.4s0 0 0-.1l0 .1c0 0 0 0 0 0z"]
};
var faWaterArrowDown = {
  prefix: 'fal',
  iconName: 'water-arrow-down',
  icon: [576, 512, ["water-lower"], "f774", "M288 0c8.8 0 16 7.2 16 16V185.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 185.4V16c0-8.8 7.2-16 16-16zM133.8 458.8C150.3 470 171.1 480 192 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM192 352c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 342 363.1 352 384 352s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 369.9 414.3 384 384 384s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 369.9 222.3 384 192 384s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 384.1 0 376 0 366.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 342 171.1 352 192 352z"]
};
var faWaterLower = faWaterArrowDown;
var faScannerTouchscreen = {
  prefix: 'fal',
  iconName: 'scanner-touchscreen',
  icon: [512, 512, [], "f48a", "M128 16V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zm192 0V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM208 0c-8.8 0-16 7.2-16 16V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM400 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM496 0c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM288 128c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H288zM64 96C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 96H248c4.4 0 8 3.6 8 8V408c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm-40 8V408c0 22.1 17.9 40 40 40H248c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z"]
};
var faCircle7 = {
  prefix: 'fal',
  iconName: 'circle-7',
  icon: [512, 512, [], "e0f4", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H308.4L194.1 360.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l128-224c2.8-5 2.8-11-.1-16s-8.1-8-13.8-8H176z"]
};
var faPlugCirclePlus = {
  prefix: 'fal',
  iconName: 'plug-circle-plus',
  icon: [576, 512, [], "e55f", "M432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16zM112 0c8.8 0 16 7.2 16 16v96H96V16c0-8.8 7.2-16 16-16zM272 0c8.8 0 16 7.2 16 16v96H256V16c0-8.8 7.2-16 16-16zM0 160c0-8.8 7.2-16 16-16H32 64 320h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H352v35.2c-11.4 5.9-22.2 12.9-32 21V176H64v64c0 70.7 57.3 128 128 128c23.7 0 45.8-6.4 64.9-17.6c-.6 5.8-.9 11.7-.9 17.6c0 6.2 .3 12.3 .9 18.3c-15.2 6.8-31.7 11.2-48.9 12.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V399.2C95.1 391.2 32 323 32 240V176H16c-8.8 0-16-7.2-16-16z"]
};
var faPersonSkiJumping = {
  prefix: 'fal',
  iconName: 'person-ski-jumping',
  icon: [512, 512, ["ski-jump"], "f7c7", "M432 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 352 56zM112 112c0-8.8 7.2-16 16-16H288h19.2c24.8 0 44.8 20.1 44.8 44.8c0 18.1-10.8 34.3-27.5 41.3L207 231.5c-1.6 2.4-3 4.9-4.2 7.5L142.6 374.5c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l60.2-135.4c2.6-5.9 6-11.5 9.9-16.6c.5-.7 1-1.3 1.5-1.9c.3-.4 .6-.7 .9-1.1L253.2 128H128c-8.8 0-16-7.2-16-16zm183.4 16l-42.5 49.6 59.3-24.9c4.8-2 7.9-6.7 7.9-11.8c0-7.1-5.7-12.8-12.8-12.8H295.4zM496 176c8.8 0 16 7.2 16 16v7.3c0 35.9-20 68.8-51.9 85.3L23.3 510.2c-7.9 4.1-17.5 1-21.6-6.9s-1-17.5 6.9-21.6L445.4 256.1c21.3-11 34.6-32.9 34.6-56.9V192c0-8.8 7.2-16 16-16z"]
};
var faSkiJump = faPersonSkiJumping;
var faPlaceOfWorship = {
  prefix: 'fal',
  iconName: 'place-of-worship',
  icon: [640, 512, [], "f67f", "M320 0c4.2 0 8.3 1.7 11.3 4.7L406.6 80c6 6 9.4 14.1 9.4 22.6v89.3L457 217c14.3 8.7 23 24.2 23 41V480h96c17.7 0 32-14.3 32-32V378.1c0-10.9-5.5-21-14.6-26.9L512 298.6V260.5l98.8 63.9c18.2 11.8 29.2 32 29.2 53.7V448c0 35.3-28.7 64-64 64H416v0H384 352 288 256 224v0H64c-35.3 0-64-28.7-64-64V378.1c0-21.7 11-41.9 29.2-53.7L128 260.5v38.1L46.6 351.2c-9.1 5.9-14.6 16-14.6 26.9V448c0 17.7 14.3 32 32 32h96V257.9c0-16.7 8.7-32.2 23-41l41-25.1V102.6c0-8.5 3.4-16.6 9.4-22.6L308.7 4.7c3-3 7.1-4.7 11.3-4.7zM448 257.9c0-5.6-2.9-10.7-7.7-13.7l-48.7-29.8c-4.8-2.9-7.7-8.1-7.7-13.7l0-98.3-64-64-64 64v98.3c0 5.6-2.9 10.7-7.7 13.7l-48.7 29.8c-4.8 2.9-7.7 8.1-7.7 13.7V480h64V384c0-35.3 28.7-64 64-64s64 28.7 64 64v96h64V257.9zM352 480V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v96h64z"]
};
var faWaterArrowUp = {
  prefix: 'fal',
  iconName: 'water-arrow-up',
  icon: [576, 512, ["water-rise"], "f775", "M288 240c8.8 0 16-7.2 16-16V54.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272 54.6V224c0 8.8 7.2 16 16 16zM133.8 458.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480s-41.7-9.9-58.2-21.2zM192 352c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 352.1 0 358.4 0 366.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 369.9 161.7 384 192 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 369.9 353.7 384 384 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 342 404.9 352 384 352s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 342 212.9 352 192 352z"]
};
var faWaterRise = faWaterArrowUp;
var faWaveformLines = {
  prefix: 'fal',
  iconName: 'waveform-lines',
  icon: [640, 512, ["waveform-path"], "f8f2", "M320 0c8.8 0 16 7.2 16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zM512 64c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM224 96c8.8 0 16 7.2 16 16V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm192 32c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM128 192c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM32 224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm576 0c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16z"]
};
var faWaveformPath = faWaveformLines;
var faSplit = {
  prefix: 'fal',
  iconName: 'split',
  icon: [512, 512, [], "e254", "M404.7 36.7c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 144H400 339.9c-8.5 0-16.6 3.4-22.6 9.4L214.6 256 317.3 358.6c6 6 14.1 9.4 22.6 9.4H400h57.4l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 400H400 339.9c-17 0-33.3-6.7-45.3-18.7L190.1 276.7c-3-3-7.1-4.7-11.3-4.7H48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H48 178.7c4.2 0 8.3-1.7 11.3-4.7L294.6 130.7c12-12 28.3-18.7 45.3-18.7H400h57.4L404.7 59.3c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faFilmCanister = {
  prefix: 'fal',
  iconName: 'film-canister',
  icon: [576, 512, ["film-cannister"], "f8b7", "M112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H32V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48 304h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304 48 16zM64 480V96H288V480H64zM384 200v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H392c-4.4 0-8 3.6-8 8zm8 152c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8H392zm88-152v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8zM352 160H528c8.8 0 16 7.2 16 16V304c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48v32c0 8.8-7.2 16-16 16H352v32H464c26.5 0 48-21.5 48-48V368c0-8.8 7.2-16 16-16c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H352v32z"]
};
var faFilmCannister = faFilmCanister;
var faFolderXmark = {
  prefix: 'fal',
  iconName: 'folder-xmark',
  icon: [512, 512, ["folder-times"], "f65f", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM180.7 212.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 288l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 310.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 288l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 265.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faFolderTimes = faFolderXmark;
var faToiletPaperBlank = {
  prefix: 'fal',
  iconName: 'toilet-paper-blank',
  icon: [640, 512, ["toilet-paper-alt"], "f71f", "M20.5 463.6c-2.8 4.7-4.3 10-4.5 15.4c-.2 5.8 1.2 11.6 4.2 16.8C25.8 505.8 36.5 512 48 512H317.9c22.3 0 45.4-12.1 55.4-36.1c10.7-25.8 27.3-76.6 36.3-158.9c.3-2.4 .5-4.9 .8-7.4c3.4-33.9 5.6-73 5.6-117.7c0-88.4 35.8-160 80-160s80 71.6 80 160s-35.8 160-80 160c-20.6 0-39.4-15.6-53.6-41.2c-1.6 16.4-3.6 31.8-5.7 46C452.2 372.7 471.9 384 496 384c40.7 0 69-32.2 85.2-64.6C598.3 285.2 608 240.1 608 192s-9.7-93.2-26.8-127.4C565 32.2 536.7 0 496 0H464 160C107 0 64 86 64 192c0 80.2-.4 180.8-36.2 257.3c-2.3 4.9-4.7 9.6-7.3 14.3l0 .1zM432.3 32c-8.6 9.9-15.8 21.2-21.5 32.6C393.7 98.8 384 143.9 384 192c0 155.1-26.7 239-40.2 271.7c-4.3 10.3-14.5 16.3-25.9 16.3H48l0 0c.2-.3 .4-.6 .5-.9c24.4-44.1 35.9-95.4 41.6-144.8C95.9 284.6 96 234.4 96 192c0-49.1 10-92 24.7-121.5C136.4 39.2 152.1 32 160 32H432.3zm49.2 180.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM527.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16z"]
};
var faToiletPaperAlt = faToiletPaperBlank;
var faTabletScreen = {
  prefix: 'fal',
  iconName: 'tablet-screen',
  icon: [448, 512, ["tablet-android-alt"], "f3fc", "M384 32c17.7 0 32 14.3 32 32V320H32V64c0-17.7 14.3-32 32-32H384zm32 320v96c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V352H416zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 416c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"]
};
var faTabletAndroidAlt = faTabletScreen;
var faHexagonVerticalNftSlanted = {
  prefix: 'fal',
  iconName: 'hexagon-vertical-nft-slanted',
  icon: [448, 512, [], "e506", "M255.8 496.6c-19.8 11.4-44.2 11.4-64 0L32 404.3C12.2 392.9 0 371.7 0 348.9V164.3c0-22.9 12.2-44 32-55.4L191.8 16.6c19.8-11.4 44.2-11.4 64 0l159.8 92.3c19.8 11.4 32 32.6 32 55.4V348.9c0 22.9-12.2 44-32 55.4L255.8 496.6zm-48-27.7c9.9 5.7 22.1 5.7 32 0l159.8-92.3c9.9-5.7 16-16.3 16-27.7V164.3c0-11.4-6.1-22-16-27.7L239.8 44.3c-9.9-5.7-22.1-5.7-32 0L48 136.6c-9.9 5.7-16 16.3-16 27.7l0 184.6c0 11.4 6.1 22 16 27.7l159.8 92.3zM272 123.5c0 12.3-13.3 20-23.9 13.9l-24.2-13.8v117h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v128c0 8.8-7.2 16-16 16s-16-7.2-16-16v-144V96.3c0-1.6 .2-3.2 .6-4.7c.5-1.9 1.4-3.7 2.6-5.2c1.1-1.5 2.5-2.8 4-3.7c2.5-1.7 5.6-2.6 8.8-2.6l.1 0c.5 0 1 0 1.4 .1c2.5 .2 4.8 1 6.8 2.2l47.8 27.3c5 2.8 8.1 8.2 8.1 13.9zm16 27.4c0-12.3 13.3-20 23.9-13.9l72 41.1c7.7 4.4 10.3 14.2 6 21.8s-14.2 10.3-21.8 6l-16.2-9.3V352.6c0 8.8-7.2 16-16 16s-16-7.2-16-16V178.4l-23.8-13.6c-5-2.8-8.1-8.2-8.1-13.9zM143.8 128.6c8.8 0 16 7.2 16 16v224c0 7.8-5.7 14.5-13.4 15.8s-15.3-3.3-17.7-10.7L95.8 275.2v61.4c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.8 5.7-14.5 13.4-15.8s15.3 3.3 17.7 10.7L127.8 270V144.6c0-8.8 7.2-16 16-16z"]
};
var faFolderMusic = {
  prefix: 'fal',
  iconName: 'folder-music',
  icon: [512, 512, [], "e18d", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM345.1 178.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V251.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V192c0-5.2-2.6-10.2-6.9-13.2zM320 340c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM192 372c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z"]
};
var faDisplayMedical = {
  prefix: 'fal',
  iconName: 'display-medical',
  icon: [576, 512, ["desktop-medical"], "e166", "M512 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H344.3c-.2 0-.4 0-.6 0H232.3c-.2 0-.4 0-.6 0H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H512zM64 416H213.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H360h72c8.8 0 16-7.2 16-16s-7.2-16-16-16H373.6l-10.7-64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm170.9 64l10.7-64h84.9l10.7 64H234.9zM272 96c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H336V128c0-17.7-14.3-32-32-32H272zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H320c-8.8 0-16 7.2-16 16v48H272V240c0-8.8-7.2-16-16-16H208V192h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V128z"]
};
var faDesktopMedical = faDisplayMedical;
var faShareAll = {
  prefix: 'fal',
  iconName: 'share-all',
  icon: [576, 512, [], "f367", "M373.2 59.8c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1L551.2 178.4c17.5 15.9 17.5 43.3 0 59.2L394.8 379.8c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6L529.7 213.9c3.5-3.2 3.5-8.7 0-11.8L373.2 59.8zM256 160H176C96.5 160 32 224.5 32 304c0 46.1 15.9 79.7 34 103.2c-1.3-7.1-2-14.8-2-23.2c0-70.7 57.3-128 128-128h64l0 0h8c13.3 0 24 10.7 24 24v8 16l0 48L448 208 288 64v48 16 8c0 13.3-10.7 24-24 24l-8 0zm0 160V304 288H224 192c-53 0-96 43-96 96c0 30.4 12.8 47.9 22.2 56.7c5.5 5.1 9.8 12 9.8 19.5c0 10.9-8.8 19.7-19.7 19.7c-2.8 0-5.6-.6-8.1-1.9C81.5 467.9 0 417.3 0 304c0-97.2 78.8-176 176-176h48 32V112 96 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2V320z"]
};
var faPeapod = {
  prefix: 'fal',
  iconName: 'peapod',
  icon: [512, 512, [], "e31c", "M416 32C203.9 32 32 203.9 32 416v48c0 8.8 7.2 16 16 16H96c212.1 0 384-171.9 384-384V48c0-8.8-7.2-16-16-16H416zm0-32h48c26.5 0 48 21.5 48 48V96c0 229.8-186.2 416-416 416H48c-26.5 0-48-21.5-48-48V416C0 186.2 186.2 0 416 0zM368 112a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM224 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM112 368a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"]
};
var faChessClock = {
  prefix: 'fal',
  iconName: 'chess-clock',
  icon: [640, 512, [], "f43d", "M240 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H192v64H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h96V64H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 64zM544 80c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16H528c8.8 0 16 7.2 16 16zM64 160c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H64zM176 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM520.6 360.6A80 80 0 1 0 407.4 247.4 80 80 0 1 0 520.6 360.6zM384.8 224.8A112 112 0 1 1 543.2 383.2 112 112 0 1 1 384.8 224.8zM176 240c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-8.8 7.2-16 16-16zm333.3 41.4l-33.9 33.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faAxe = {
  prefix: 'fal',
  iconName: 'axe',
  icon: [640, 512, [129683], "f6b2", "M502.6 182.6L352 32l-96 96L406.6 278.6c6 6 9.4 14.1 9.4 22.6V384c106 0 192-86 192-192H525.3c-8.5 0-16.6-3.4-22.6-9.4zM473.3 108l52 52H608c17.7 0 32 14.3 32 32c0 123.7-100.3 224-224 224c-17.7 0-32-14.3-32-32V301.3L233.4 150.6c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0L404 38.7 433.4 9.4c12.5-12.5 32.8-12.5 45.3 0l24 24c12.5 12.5 12.5 32.8 0 45.3L473.3 108zM450.6 85.4L480 56 456 32 426.6 61.4l24 24zM262.7 225.3L32 456l24 24L286.7 249.3l22.6 22.6L78.6 502.6c-12.5 12.5-32.8 12.5-45.3 0l-24-24c-12.5-12.5-12.5-32.8 0-45.3L240.1 202.6l22.6 22.6z"]
};
var faSquareD = {
  prefix: 'fal',
  iconName: 'square-d',
  icon: [448, 512, [], "e268", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM160 352h64c53 0 96-43 96-96s-43-96-96-96H160V352zm-1.2-224H224c70.7 0 128 57.3 128 128s-57.3 128-128 128H158.8c-17 0-30.8-13.8-30.8-30.8V158.8c0-17 13.8-30.8 30.8-30.8z"]
};
var faGripVertical = {
  prefix: 'fal',
  iconName: 'grip-vertical',
  icon: [320, 512, [], "f58e", "M32 440l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zm184-40l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM32 232c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48zM0 280c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48zm224 0l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM32 72c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48zM0 120c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48zm224 0l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40z"]
};
var faMobileSignalOut = {
  prefix: 'fal',
  iconName: 'mobile-signal-out',
  icon: [512, 512, [], "e1f0", "M96 32H224V0H96C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V288H320V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm64 368c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zM272 0c-8.8 0-16 7.2-16 16s7.2 16 16 16c114.9 0 208 93.1 208 208c0 8.8 7.2 16 16 16s16-7.2 16-16C512 107.5 404.5 0 272 0zm16 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 112c0 8.8 7.2 16 16 16c61.9 0 112 50.1 112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-79.5-64.5-144-144-144c-8.8 0-16 7.2-16 16z"]
};
var faArrowTurnUp = {
  prefix: 'fal',
  iconName: 'arrow-turn-up',
  icon: [384, 512, ["level-up"], "f148", "M16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c44.2 0 80-35.8 80-80l0-377.4L308.7 155.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 54.6 176 432c0 26.5-21.5 48-48 48L16 480z"]
};
var faLevelUp = faArrowTurnUp;
var faU = {
  prefix: 'fal',
  iconName: 'u',
  icon: [384, 512, [117], "55", "M16 32c8.8 0 16 7.2 16 16V288c0 88.4 71.6 160 160 160s160-71.6 160-160V48c0-8.8 7.2-16 16-16s16 7.2 16 16V288c0 106-86 192-192 192S0 394 0 288V48c0-8.8 7.2-16 16-16z"]
};
var faArrowUpFromDottedLine = {
  prefix: 'fal',
  iconName: 'arrow-up-from-dotted-line',
  icon: [448, 512, [], "e09b", "M235.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 86.6V192 336c0 8.8 7.2 16 16 16s16-7.2 16-16V192 86.6L340.7 187.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM32 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm384 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM152 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSquareRootVariable = {
  prefix: 'fal',
  iconName: 'square-root-variable',
  icon: [576, 512, ["square-root-alt"], "f698", "M352.1 64c-7.1 0-13.4 4.7-15.4 11.6L223.4 468.4c-1.8 6.3-7.2 10.8-13.7 11.5s-12.7-2.6-15.8-8.4L82.9 264.4c-2.8-5.2-8.2-8.4-14.1-8.4H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H68.8c17.7 0 34 9.7 42.3 25.3l92.4 172.4L306 66.7C311.9 46.1 330.7 32 352.1 32H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H352.1zm52.6 180.7c6.2-6.2 16.4-6.2 22.6 0L480 297.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L502.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L480 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 320l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faSquareRootAlt = faSquareRootVariable;
var faLightSwitchOn = {
  prefix: 'fal',
  iconName: 'light-switch-on',
  icon: [384, 512, [], "e019", "M176 48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H176V464c0-8.8 7.2-16 16-16s16 7.2 16 16v16H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H208V48c0 8.8-7.2 16-16 16s-16-7.2-16-16zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM176 168h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48-24v96H256V144c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm0 224c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272H128v96zM96 144c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V144z"]
};
var faArrowDownArrowUp = {
  prefix: 'fal',
  iconName: 'arrow-down-arrow-up',
  icon: [576, 512, ["sort-alt"], "f883", "M203.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zm352-342.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 86.6V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96z"]
};
var faSortAlt = faArrowDownArrowUp;
var faRaindrops = {
  prefix: 'fal',
  iconName: 'raindrops',
  icon: [448, 512, [], "f75c", "M160 85.6l-27.8 53c-2.7 5.2-4.2 11-4.2 16.9V160c0 17.7 14.3 32 32 32s32-14.3 32-32v-4.5c0-5.9-1.4-11.7-4.2-16.9L160 85.6zM148.3 39.1c2.3-4.4 6.8-7.1 11.7-7.1s9.4 2.7 11.7 7.1l44.4 84.6c5.2 9.8 7.8 20.7 7.8 31.8V160c0 35.3-28.7 64-64 64s-64-28.7-64-64v-4.5c0-11.1 2.7-22 7.8-31.8l44.4-84.6zM64 277.6l-27.8 53c-2.7 5.2-4.2 11-4.2 16.9V352c0 17.7 14.3 32 32 32s32-14.3 32-32v-4.5c0-5.9-1.4-11.7-4.2-16.9L64 277.6zM52.3 231.1c2.3-4.4 6.8-7.1 11.7-7.1s9.4 2.7 11.7 7.1l44.4 84.6c5.2 9.8 7.8 20.7 7.8 31.8V352c0 35.3-28.7 64-64 64s-64-28.7-64-64v-4.5c0-11.1 2.7-22 7.8-31.8l44.4-84.6zM239 301.5c-9.8 15.3-15 33.1-15 51.3c0 52.3 43.2 95.2 96 95.2s96-42.9 96-95.2c0-18.2-5.2-36-15-51.3L320 174.9 239 301.5zm-27-17.2l95.6-149.5c2.7-4.2 7.3-6.7 12.3-6.7s9.6 2.5 12.3 6.7l95.6 149.5C441 304.7 448 328.5 448 352.8C448 423 390.3 480 320 480s-128-57-128-127.2c0-24.3 7-48.1 20.1-68.6z"]
};
var faDash = {
  prefix: 'fal',
  iconName: 'dash',
  icon: [512, 512, ["minus-large"], "e404", "M0 256c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faMinusLarge = faDash;
var faClock = {
  prefix: 'fal',
  iconName: 'clock',
  icon: [512, 512, [128339, "clock-four"], "f017", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V256c0 5.3 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faClockFour = faClock;
var faInputNumeric = {
  prefix: 'fal',
  iconName: 'input-numeric',
  icon: [640, 512, [], "e1bd", "M576 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM96 176c0 8.8 7.2 16 16 16h16V320H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V176c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm168.7 27.4c9.4-11.3 26.2-12.6 37.2-2.9c10.8 9.5 11.9 25.9 2.5 36.7l-76.6 88.3c-4.1 4.7-5.1 11.4-2.5 17.1s8.3 9.4 14.6 9.4h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H275l53.6-61.9c20.9-24.2 18.4-60.7-5.6-81.8c-24.6-21.5-62-18.5-82.9 6.5l-12.4 14.9c-5.7 6.8-4.7 16.9 2 22.5s16.9 4.7 22.5-2l12.4-14.9z"]
};
var faTruckTow = {
  prefix: 'fal',
  iconName: 'truck-tow',
  icon: [640, 512, [], "e2b8", "M96 64V176c0 26.5-21.5 48-48 48s-48-21.5-48-48V160c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V32C64 20.2 70.4 9.8 80 4.3C84.7 1.6 90.2 0 96 0h3.8 45.9c9.1 0 17.8 3.9 23.9 10.7L384 252V144c0-26.5 21.5-48 48-48h56.5c19.8 0 38.4 9.1 50.5 24.7l90.8 116.8c6.6 8.4 10.1 18.8 10.1 29.5V368c0 26.5-21.5 48-48 48H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48H192L96 64zM250.5 384H389.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H592c8.8 0 16-7.2 16-16V288H416 384 373.2 208 48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zM416 416a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm97.8-275.6c-6.1-7.8-15.4-12.4-25.3-12.4H432c-8.8 0-16 7.2-16 16V256H603.7L513.8 140.4zM145.6 32l-29.9 0 112 224h117L145.6 32zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0z"]
};
var faBackwardStep = {
  prefix: 'fal',
  iconName: 'backward-step',
  icon: [320, 512, ["step-backward"], "f048", "M64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V241.9v28.2V432c0 8.8 7.2 16 16 16s16-7.2 16-16V296.2L242.6 441.8c5 4 11.2 6.2 17.6 6.2c15.4 0 27.8-12.4 27.8-27.8V91.8C288 76.4 275.6 64 260.2 64c-6.4 0-12.6 2.2-17.6 6.2L64 215.8V80zm192 20.6V411.4L65.3 256 256 100.6z"]
};
var faStepBackward = faBackwardStep;
var faPallet = {
  prefix: 'fal',
  iconName: 'pallet',
  icon: [640, 512, [], "f482", "M16 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80 320 560h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H576V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H560 320 80 16zm80 32H304v96H96V384zm240 0H544v96H336V384z"]
};
var faCarBolt = {
  prefix: 'fal',
  iconName: 'car-bolt',
  icon: [512, 512, [], "e341", "M113.6 98.2L85.3 192.6c3.5-.4 7.1-.6 10.7-.6h32v32H96c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3-.5-.1C49.6 236.7 32 260.3 32 288v96H480V288c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H384V192h32c3.6 0 7.2 .2 10.7 .6L398.4 98.2c-6.1-20.3-24.8-34.2-46-34.2H159.6c-21.2 0-39.9 13.9-46 34.2zM48.3 204.7l.4-1.3L83 89c10.2-33.8 41.3-57 76.6-57H352.4c35.3 0 66.5 23.2 76.6 57l34.3 114.4 .4 1.3C492.6 221.2 512 252.3 512 288v96 16 16 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416 400 384 288c0-35.7 19.4-66.8 48.3-83.3zM104 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM299.3 123.3L230.6 192H320c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L281.4 224H192c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faArrowsMaximize = {
  prefix: 'fal',
  iconName: 'arrows-maximize',
  icon: [512, 512, ["expand-arrows"], "f31d", "M336 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L256 233.4 86.6 64H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16V176c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6L233.4 256 64 425.4V336c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H86.6L256 278.6 425.4 448H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H464c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4L278.6 256 448 86.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16H336z"]
};
var faExpandArrows = faArrowsMaximize;
var faFaucet = {
  prefix: 'fal',
  iconName: 'faucet',
  icon: [512, 512, [], "e005", "M240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H208v48H189.3c-12.7 0-24.9 5.1-33.9 14.1L121.4 256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H128c4.2 0 8.3-1.7 11.3-4.7l38.6-38.6c3-3 7.1-4.7 11.3-4.7h69.5c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7h48c61.9 0 112 50.1 112 112c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16c0-26.5-21.5-48-48-48H307.2c-5.7 0-11 3-13.8 8c-13.9 24-39.7 40-69.3 40s-55.5-16.1-69.3-40c-2.9-4.9-8.1-8-13.8-8H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H132.1c20.2 29 53.8 48 91.9 48s71.7-19 91.9-48H368c8.8 0 16 7.2 16 16c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48c0-79.5-64.5-144-144-144H326.6l-33.9-33.9c-9-9-21.2-14.1-33.9-14.1H240V160H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V80z"]
};
var faCloudSleet = {
  prefix: 'fal',
  iconName: 'cloud-sleet',
  icon: [512, 512, [], "f741", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM94.3 375.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm256 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zM192 368c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V368zm240-16c-8.8 0-16 7.2-16 16v32l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0V368c0-8.8-7.2-16-16-16z"]
};
var faLampStreet = {
  prefix: 'fal',
  iconName: 'lamp-street',
  icon: [512, 512, [], "e1c5", "M32 168C32 92.9 92.9 32 168 32c72.7 0 132 57 135.8 128.7c-83.1 6.9-151.1 66.7-170.3 145.6C127.3 331.8 148.3 352 171 352H469c22.7 0 43.7-20.2 37.5-45.7c-19.3-79-87.5-138.9-170.7-145.7C332 71.3 258.3 0 168 0C75.2 0 0 75.2 0 168V496c0 8.8 7.2 16 16 16s16-7.2 16-16V168zm288 24c75.2 0 138.4 51.9 155.4 121.9c.3 1.4 0 2.6-1 3.8c-1.1 1.3-3 2.3-5.5 2.3H171c-2.4 0-4.4-1-5.5-2.3c-1-1.1-1.3-2.4-1-3.8C181.6 243.9 244.8 192 320 192zM241.6 384c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64H365.3c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32H241.6z"]
};
var faListRadio = {
  prefix: 'fal',
  iconName: 'list-radio',
  icon: [512, 512, [], "e1d0", "M32 96a32 32 0 1 1 64 0A32 32 0 1 1 32 96zm96 0A64 64 0 1 0 0 96a64 64 0 1 0 128 0zm64 0c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM80 96A16 16 0 1 0 48 96a16 16 0 1 0 32 0zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z"]
};
var faPenNibSlash = {
  prefix: 'fal',
  iconName: 'pen-nib-slash',
  icon: [640, 512, [], "e4a1", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM478.3 232.3l75.1-75.1c25-25 25-65.5 0-90.5L509.3 22.6c-25-25-65.5-25-90.5 0L343.7 97.7l-80.3 21.9 31.2 24.7 52.6-14.4 98.9 98.9-7.9 28.9 27.3 21.5 12.8-46.9zM379 394.3c-.5 .2-1.1 .4-1.7 .5L129.3 469.3 239.5 359.1c9.5 5.6 20.6 8.9 32.5 8.9c18.7 0 35.6-8 47.3-20.8L294 327.2c-5.7 5.4-13.5 8.8-22 8.8c-17.7 0-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16L219.1 268c-7 10.2-11.1 22.6-11.1 36c0 11.9 3.2 23 8.9 32.5L106.7 446.7l64.8-216.1-27-21.3L67.9 464.6c-3.7 12.3-.3 25.7 8.8 34.7s22.4 12.5 34.7 8.8l275.2-82.5c7.2-2.2 14-5.3 20.2-9.3L379 394.3zM441.4 45.3c12.5-12.5 32.8-12.5 45.3 0l44.1 44.1c12.5 12.5 12.5 32.8 0 45.3L464 201.4 374.6 112l66.7-66.7z"]
};
var faBaseballBatBall = {
  prefix: 'fal',
  iconName: 'baseball-bat-ball',
  icon: [512, 512, [], "f432", "M416 0c-14.5 0-28.4 5.8-38.6 16L226.1 167.2c-9.7 9.7-18.4 20.3-26 31.7L125.2 311.3c-6.4 9.6-13.8 18.6-22 26.8L32 409.4l-4.7-4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L9.4 432l11.3 11.3 48 48L80 502.6l4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-4.7-4.7 71.2-71.2c8.2-8.2 17.2-15.6 26.8-22l112.4-74.9c11.4-7.6 22-16.3 31.7-26L496 134.6c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6L454.6 16C444.4 5.8 430.5 0 416 0zM80 457.4L54.6 432l71.2-71.2c.7-.7 1.4-1.4 2.1-2.1L153.4 384c-.7 .7-1.4 1.4-2.1 2.1L80 457.4zm98.1-93.9l-29.6-29.6c1.1-1.6 2.2-3.2 3.3-4.8l74.9-112.4c6.4-9.6 13.8-18.6 22-26.8L400 38.6c4.2-4.2 10-6.6 16-6.6s11.8 2.4 16 6.6L473.4 80c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16L322.1 263.2c-8.2 8.2-17.2 15.6-26.8 22L182.9 360.1c-1.6 1.1-3.2 2.2-4.8 3.3zM384 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faSquareUpLeft = {
  prefix: 'fal',
  iconName: 'square-up-left',
  icon: [448, 512, [], "e282", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 88V297.4c0 3.7 3 6.6 6.6 6.6c1.8 0 3.4-.7 4.7-1.9l25.4-25.4c6.2-6.2 16.4-6.2 22.6 0l59.1 59.1c3.6 3.6 9 4.9 13.9 3.3c2-.7 3.8-1.8 5.3-3.3l22.1-22.1c1.5-1.5 2.6-3.3 3.3-5.3c1.6-4.9 .4-10.3-3.3-13.9l-59.1-59.1c-6.2-6.2-6.2-16.4 0-22.6l25.4-25.4c1.2-1.2 1.9-2.9 1.9-4.7c0-3.7-3-6.6-6.6-6.6H152c-4.4 0-8 3.6-8 8zm8-40H265.4c21.3 0 38.6 17.3 38.6 38.6c0 10.2-4.1 20.1-11.3 27.3L278.6 224l47.7 47.7c12.2 12.2 16.5 30.3 11 46.7c-2.2 6.7-6 12.8-11 17.8l-22.1 22.1c-5 5-11.1 8.8-17.8 11c-16.4 5.5-34.5 1.2-46.7-11L192 310.6l-14.1 14.1c-7.2 7.2-17.1 11.3-27.3 11.3c-21.3 0-38.6-17.3-38.6-38.6V184c0-22.1 17.9-40 40-40z"]
};
var faOverline = {
  prefix: 'fal',
  iconName: 'overline',
  icon: [448, 512, [], "f876", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm208 96c-88.4 0-160 71.6-160 160v32c0 88.4 71.6 160 160 160s160-71.6 160-160V288c0-88.4-71.6-160-160-160zM96 288c0-70.7 57.3-128 128-128s128 57.3 128 128v32c0 70.7-57.3 128-128 128s-128-57.3-128-128V288z"]
};
var faS = {
  prefix: 'fal',
  iconName: 's',
  icon: [320, 512, [115], "53", "M83.4 75.8c-27.8 11.5-45.1 30.6-49.8 56.6c-3.3 18.2-1.2 31.7 3.6 42.3c4.9 10.7 13.4 19.8 25.5 27.9c25 16.7 61.4 27 101.5 38c.6 .2 1.1 .3 1.7 .5c38 10.5 79.3 21.8 109.1 41.8c15.5 10.4 28.7 23.6 36.8 41.1c8.1 17.5 10.3 37.9 6.1 61.3c-7 39-33.3 65.8-69.1 80.6c-35.3 14.5-80.2 17.7-127.9 10.5l-.1 0c-25-3.9-66.1-17.4-94.4-26.7c-5.7-1.9-10.9-3.6-15.3-5c-8.4-2.7-13-11.7-10.4-20.1s11.7-13 20.1-10.4c5 1.6 10.7 3.5 16.8 5.5c28.5 9.3 65.9 21.6 88 25.1c44 6.6 82.6 3.2 110.9-8.4c27.8-11.5 45.1-30.6 49.8-56.6c3.3-18.2 1.2-31.7-3.6-42.3c-4.9-10.7-13.4-19.8-25.5-27.9c-25-16.7-61.4-27-101.5-38l-1.7-.5c-38-10.5-79.3-21.8-109.1-41.8c-15.5-10.4-28.7-23.6-36.8-41.1C.1 170.5-2.1 150.2 2.1 126.8c7-39 33.3-65.8 69.1-80.6c35.3-14.5 80.2-17.7 127.9-10.5C213.4 37.9 256.9 46 272 49.8c8.6 2.2 13.7 10.9 11.5 19.5S272.6 83 264 80.8c-13.6-3.5-55.9-11.4-69.7-13.5l2.4-15.8-2.4 15.8c-44-6.6-82.7-3.3-111 8.4z"]
};
var faTimeline = {
  prefix: 'fal',
  iconName: 'timeline',
  icon: [640, 512, [], "e29c", "M144 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 94c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62V256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H320v82c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62V288H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V142c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62V256H160V142zM336 464a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM496 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faKeyboard = {
  prefix: 'fal',
  iconName: 'keyboard',
  icon: [576, 512, [9000], "f11c", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm88 8h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V152c0-8.8 7.2-16 16-16zM72 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V248zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V344c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184c-8.8 0-16-7.2-16-16V152zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184c-8.8 0-16-7.2-16-16V248c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V152zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V248c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H376c-8.8 0-16-7.2-16-16V152zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H376c-8.8 0-16-7.2-16-16V248c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V152zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V248c0-8.8 7.2-16 16-16zM456 344c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V344zm-280-8H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faArrowsFromDottedLine = {
  prefix: 'fal',
  iconName: 'arrows-from-dotted-line',
  icon: [448, 512, [], "e0a3", "M235.3 4.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM8 256a24 24 0 1 0 48 0A24 24 0 1 0 8 256zm384 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM200 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm96 280c4.2 0 8.3-1.7 11.3-4.7l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 457.4 240 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c3 3 7.1 4.7 11.3 4.7z"]
};
var faUsbDrive = {
  prefix: 'fal',
  iconName: 'usb-drive',
  icon: [640, 512, [], "f8e9", "M64 128c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H416V128H64zM0 160c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V160zM480 384V352H608V160H480V128H608c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H480zm96-176a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM560 320a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
};
var faBallot = {
  prefix: 'fal',
  iconName: 'ballot',
  icon: [448, 512, [], "f732", "M384 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 128c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM88 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H88zM72 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H88c-8.8 0-16 7.2-16 16zM88 360c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V376c0-8.8-7.2-16-16-16H88z"]
};
var faCaretDown = {
  prefix: 'fal',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", "M165.6 349.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 236.3c-1.4-1.3-2.2-3.2-2.2-5.2c0-3.9 3.2-7.1 7.1-7.1l241.7 0c3.9 0 7.1 3.2 7.1 7.1c0 2-.8 3.8-2.2 5.2L165.6 349.8zm22 23.3L307.7 259.6c7.8-7.4 12.3-17.7 12.3-28.4c0-21.6-17.5-39.1-39.1-39.1L39.1 192C17.5 192 0 209.5 0 231.1c0 10.8 4.4 21.1 12.3 28.4L132.4 373.1c7.4 7 17.3 10.9 27.6 10.9s20.1-3.9 27.6-10.9z"]
};
var faLocationDotSlash = {
  prefix: 'fal',
  iconName: 'location-dot-slash',
  icon: [640, 512, ["map-marker-alt-slash"], "f605", "M385.8 389.5c-24.4 35.2-48.5 66.5-65.8 88.1c-25.4-31.8-65.8-84.7-99.9-140c-17.3-28.1-32.7-56.3-43.6-82.1c-6.7-15.9-11.4-30-14-42.2L128.1 186c-.1 2-.1 4-.1 6c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0c17.3-21.6 42-53.6 67.2-89.8l-25.2-19.9zM320 0C263.8 0 213.3 24.1 178.2 62.5l25.2 19.9C232.6 51.4 274 32 320 32c88.4 0 160 71.6 160 160c0 15.6-5.4 37-16.6 63.4c-3.3 7.7-6.9 15.6-10.9 23.7l25.6 20.2C498.3 259.8 512 221.9 512 192C512 86 426 0 320 0zm80 192c0-44.2-35.8-80-80-80c-20.5 0-39.2 7.7-53.3 20.4l25.8 20.3c7.8-5.5 17.3-8.7 27.6-8.7c26.5 0 48 21.5 48 48c0 6.2-1.2 12.2-3.4 17.7L390.4 230c6.1-11.3 9.6-24.3 9.6-38zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faMapMarkerAltSlash = faLocationDotSlash;
var faCards = {
  prefix: 'fal',
  iconName: 'cards',
  icon: [640, 512, [], "e3ed", "M202.3 468.3c6.7 11 20.9 14.8 32.1 8.6c0 0 .1 0 .1-.1L427.4 365.5c0 0 .1 0 .1-.1c11.2-6.7 15-21.2 8.4-32.6L269.2 44.1c-6.6-11.5-21.3-15.4-32.8-8.8L44.1 146.4c-11.3 6.5-15.3 20.9-9 32.3c0 .1 .1 .1 .1 .2l167 289.3c0 .1 .1 .1 .1 .2zm-27.5 16.4c-.2-.3-.3-.6-.5-.9L7.6 195.2c-.2-.3-.3-.6-.5-.9c-14.9-26.5-5.7-60.2 20.7-75.5L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.3 26.5 6.3 60.3-20 75.8c-.2 .1-.5 .3-.7 .4l-192.3 111c-.2 .1-.5 .3-.7 .4c-26.4 14.9-59.8 6-75.3-20zM360 512c-13.7 0-26.2-4.9-35.9-13l33.2-19.1c.9 .1 1.8 .2 2.7 .2H584c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H373L354.7 64.2c1.7-.2 3.5-.2 5.3-.2H584c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H360zM469.4 162.8l-.1 .1 0 0c-6.7 5.7-7 16-1.1 22.2l0 0 35.9 37 35.7-37 0 0c5.9-6.1 5.6-16.4-.9-22.2c-5.1-4.2-13.4-4-19.1 1.7l-3.9 4.3c-3 3.3-7.2 5.2-11.7 5.3s-8.7-1.7-11.8-5l-4.3-4.5c-5.9-5.9-14.4-5.8-18.9-1.9zm-21-24.2c16.5-14.3 39.3-13.3 55.6-2.2c16.2-11.1 38.9-11.9 55.6 2.1l.2 .2 0 0c20.5 17.9 21.5 49.4 3 68.6l0 0L520.6 251l-.2 .2 0 0c-8.8 8.8-23.7 9.5-33-.3l-42.3-43.6 0 0c-18.5-19.2-17.6-50.8 3.2-68.7zM252.2 340.4l48.2-27.8c7.7-4.4 17.4-1.8 21.9 5.9s1.8 17.4-5.9 21.9l-48.2 27.8c-7.7 4.4-17.4 1.8-21.9-5.9s-1.8-17.4 5.9-21.9zm-27-40.1l5.9-27.4c.9-4.4 3.6-8.1 7.5-10.4s8.4-2.9 12.7-1.6l27.6 8.1c12.9 3.5 26.2-3.2 29.6-13.2l0-.1c5-14.2-3.4-30-17.5-34l0 0-90.2-25.7-22.6 90.8 0 0c-3.5 14.2 5.8 29.3 20.3 32.3c10.9 1.8 23-5.6 26.7-18.9zm31 7.9c-7.4 27.8-34.3 47.5-63.4 42.5l-.4-.1 0 0c-32.7-6.5-53.3-39.7-45.3-71.5l26.6-106.9c1-4.2 3.8-7.8 7.5-10s8.2-2.7 12.4-1.5L299.9 191l0 0c31.5 9.1 50 43.5 38.8 75.4c-10.1 29.4-42.9 40.6-68.5 33.6l-.3-.1 0 0-11.2-3.3-2.4 10.9c-.1 .2-.1 .5-.2 .7z"]
};
var faHouseChimneyMedical = {
  prefix: 'fal',
  iconName: 'house-chimney-medical',
  icon: [576, 512, ["clinic-medical"], "f7f2", "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V192.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1V64H416v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM272 176h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H336v32c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V336H208c-17.7 0-32-14.3-32-32V272c0-17.7 14.3-32 32-32h32V208c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7H208v32h48c8.8 0 16 7.2 16 16v48h32V320c0-8.8 7.2-16 16-16h48V272H320c-8.8 0-16-7.2-16-16V208H272z"]
};
var faClinicMedical = faHouseChimneyMedical;
var faBoxingGlove = {
  prefix: 'fal',
  iconName: 'boxing-glove',
  icon: [448, 512, [129354, "glove-boxing"], "f438", "M32 112c0-44.2 35.8-80 80-80H272c44.2 0 80 35.8 80 80v16H336c-38.7 0-71 27.5-78.4 64H144c-26.5 0-48-21.5-48-48v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 44.2 35.8 80 80 80H257.6c7.4 36.5 39.7 64 78.4 64c8.8 0 16-7.2 16-16s-7.2-16-16-16c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c26.5 0 48 21.5 48 48v38.9c0 17-6.7 33.3-18.7 45.3L336.4 353c-10.5 10.5-16.4 24.7-16.4 39.6V456c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V351.6c0-4.6-1.9-8.9-5.3-11.9C42.3 325 32 303.7 32 280V112zM112 0C50.1 0 0 50.1 0 112V280c0 30.5 12.2 58.2 32 78.4V456c0 30.9 25.1 56 56 56H296c30.9 0 56-25.1 56-56V392.6c0-6.4 2.5-12.5 7-17l60.9-60.9c18-18 28.1-42.4 28.1-67.9V208c0-38.7-27.5-71-64-78.4V112C384 50.1 333.9 0 272 0H112zm40.9 338.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L192 403.2l39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 364.8l-39.1-26.1z"]
};
var faGloveBoxing = faBoxingGlove;
var faTemperatureThreeQuarters = {
  prefix: 'fal',
  iconName: 'temperature-three-quarters',
  icon: [320, 512, ["temperature-3", "thermometer-3", "thermometer-three-quarters"], "f2c8", "M160 32c-35.3 0-64 28.7-64 64V252.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96V252.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V144c0-8.8 7.2-16 16-16s16 7.2 16 16V306c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z"]
};
var faTemperature3 = faTemperatureThreeQuarters;
var faThermometer3 = faTemperatureThreeQuarters;
var faThermometerThreeQuarters = faTemperatureThreeQuarters;
var faBellSchool = {
  prefix: 'fal',
  iconName: 'bell-school',
  icon: [512, 512, [], "f5d5", "M208 384a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0 32c-41.2 0-79.7-12-112-32.7V448c0 17.7 14.3 32 32 32H272h16c17.7 0 32-14.3 32-32V383.3C287.7 404 249.2 416 208 416zm64 96H128c-35.3 0-64-28.7-64-64V358.1C24.6 320.2 0 267 0 208C0 93.1 93.1 0 208 0S416 93.1 416 208c0 59-24.6 112.2-64 150.1V448c0 11.7-3.1 22.6-8.6 32H416c17.7 0 32-14.3 32-32v-2.7c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3V448c0 35.3-28.7 64-64 64H288 272zM256 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM464 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faMobileScreen = {
  prefix: 'fal',
  iconName: 'mobile-screen',
  icon: [384, 512, ["mobile-android-alt"], "f3cf", "M288 32c17.7 0 32 14.3 32 32V320H64V64c0-17.7 14.3-32 32-32H288zm32 320v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352H320zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm48 416c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16z"]
};
var faMobileAndroidAlt = faMobileScreen;
var faPlaneUp = {
  prefix: 'fal',
  iconName: 'plane-up',
  icon: [512, 512, [], "e22d", "M221.2 13.3C230.8 5.7 242.6 0 256 0c26.9 0 47.1 21.6 59.2 41.8C327.9 62.9 336 89.1 336 109.7v52.5l151.8 86.8c15 8.5 24.2 24.5 24.2 41.7v56.2c0 21.3-20.3 36.6-40.8 30.8L336 338.9V376l51.2 38.4c8.1 6 12.8 15.5 12.8 25.6v42c0 16.6-13.4 30-30 30c-2.8 0-5.6-.4-8.2-1.2l0 0L256 480.6 150.3 510.8l0 0c-2.7 .8-5.5 1.2-8.3 1.2c-16.6 0-30-13.4-30-30V440c0-10.1 4.7-19.6 12.8-25.6L176 376l0-37.1L40.8 377.6C20.3 383.4 0 368 0 346.8V290.6c0-17.2 9.2-33.1 24.2-41.7L176 162.1V109.7c0-20.7 8.4-46.9 21.2-67.9c6.5-10.7 14.5-20.8 24-28.4zm3.3 45C214.1 75.6 208 96.2 208 109.7v61.7c0 5.7-3.1 11-8.1 13.9L40.1 276.7c-5 2.8-8.1 8.2-8.1 13.9v56.2l155.6-44.5c4.8-1.4 10-.4 14 2.6s6.4 7.8 6.4 12.8l0 66.3c0 5-2.4 9.8-6.4 12.8L144 440v39.4l107.6-30.7c2.9-.8 5.9-.8 8.8 0L368 479.4V440l-57.6-43.2c-4-3-6.4-7.8-6.4-12.8V317.7c0-5 2.4-9.8 6.4-12.8s9.2-4 14-2.6L480 346.8V290.6c0-5.7-3.1-11-8.1-13.9L312.1 185.3c-5-2.8-8.1-8.2-8.1-13.9V109.7c0-13.6-5.9-34.2-16.2-51.4C276.9 40.2 265.1 32 256 32c-4.1 0-9 1.7-14.8 6.3c-5.8 4.6-11.5 11.5-16.7 20z"]
};
var faFolderHeart = {
  prefix: 'fal',
  iconName: 'folder-heart',
  icon: [512, 512, [], "e189", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM176 253.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L256 345.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM205.3 192c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faCircleLocationArrow = {
  prefix: 'fal',
  iconName: 'circle-location-arrow',
  icon: [512, 512, ["location-circle"], "f602", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm127.7 27c-11.7 0-21.9-8.3-24.2-19.8c-2.4-11.4 3.7-23.1 14.5-27.7L338.5 141c9.5-3.9 20.2-1.9 27.3 5.3c7.2 7.1 9.2 17.8 5.2 27.2L276.5 394c-3.9 9.1-12.9 15-22.8 15c-1.6 0-3.3-.1-4.9-.5C237.3 406.2 229 396 229 384.2V315 283H197 127.7zm35.3-32H229c17.7 0 32 14.3 32 32v66l73.5-171.4L163.1 251z"]
};
var faLocationCircle = faCircleLocationArrow;
var faFaceHeadBandage = {
  prefix: 'fal',
  iconName: 'face-head-bandage',
  icon: [576, 512, [], "e37a", "M288 32c2.4 0 4.9 0 7.3 .1c-29.3 9.7-57.6 21.4-84.8 35c-17.1 1.4-34.1 3.2-51 5.4C195.8 47 240.2 32 288 32zm80.1-19.2C342.9 4.5 316 0 288 0C213.6 0 146.6 31.8 99.8 82.4c-12.5 2.5-25 5.2-37.3 8.2c-8.2 2-15.3 7.1-19.7 14.3C26.9 130.6 15 158.9 7.8 189c-2.4 10.2 .3 20.9 7.2 28.7c-2.5 2.8-4.9 5.6-7.3 8.5c-4.7 5.5-7.3 12.4-7.6 19.6C.1 249.2 0 252.6 0 256c0 31.4 5 61.7 14.4 90.1c3.8 11.6 13.9 20 26 21.7s24.1-3.7 30.9-13.8c31.3-46.3 69.9-87.2 114.1-121c-.7 2.2-1.1 4.6-1.1 7.1c0 13.3 10.7 24 24 24s24-10.7 24-24c0-13.1-10.5-23.7-23.5-24c12-8.2 24.4-15.8 37.2-23c13.9-.7 27.9-1 41.9-1c83.4 0 163.9 12.3 239.8 35.1c11 3.3 22.8 .5 31.2-7.4s11.8-19.6 9.2-30.7c-7.2-30.1-19.1-58.4-34.9-84.1c-3.3-5.3-8-9.5-13.5-12.1c-.6-6-2.9-11.9-6.9-16.8c-21.2-26.5-47-49.1-76.2-66.8c-6.1-3.7-13.4-5.2-20.5-4.4c-16.2 2-32.2 4.6-48.1 7.9zM506.3 122.2c7.3 11.9 13.7 24.4 19 37.5c4.8 11.8 8.7 24.1 11.7 36.7c-11.9-3.6-23.9-6.9-36-10c-59.4-15.1-121.2-24-184.8-26c-.3 0-.5 0-.8 0c-9.1-.3-18.3-.4-27.5-.4c-17.1 0-34.1 .5-51 1.5c-48.2 2.8-95.4 9.6-141.2 20c-7 1.6-13.9 3.3-20.9 5c-12.1 3.1-24.1 6.4-36 10c.5-2 1-4 1.5-6c2.8-10.5 6.2-20.8 10.2-30.7c5.4-13.3 11.8-26 19.3-38c23.2-5.6 46.8-10.3 70.7-14.1c0 0 0 0 0 0c.8-.1 1.6-.3 2.5-.4c25-3.9 50.4-6.9 76.1-8.7c0 0 0 0 0 0s0 0 0 0C241.9 96.8 264.9 96 288 96c40 0 79.3 2.5 118 7.4c2.2 .3 4.4 .6 6.6 .9c31.7 4.3 62.9 10.1 93.5 17.5c.1 .2 .2 .3 .3 .5zM177 199.3c-40.6 29.4-77 64.4-108 103.7c-8.5 10.7-16.5 21.7-24.2 33.1c-4.4-13.3-7.7-27.1-9.9-41.3C33 282.1 32 269.2 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5c41-12.2 83.3-21.3 126.6-27.1zM300.6 64.1c38.3-13 78.3-22.2 119.5-27.4c13.7 8.3 26.6 17.9 38.5 28.5c6.1 5.5 11.9 11.2 17.5 17.2C419.3 71.1 360.6 64.9 300.6 64.1zm242.8 209c.6-8.8-6.1-16.4-14.9-17s-16.4 6.1-17 14.9C503.8 387.7 406.7 480 288 480c-73.3 0-138.3-35.2-179.2-89.6c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C129.9 471.8 204.2 512 288 512c135.7 0 246.7-105.5 255.4-238.9zM373.2 397.5c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6C373.2 354.3 340.2 336 296 336c-16.4 0-31.4 2.5-44.8 6.8c-8.4 2.7-13.1 11.6-10.5 20.1s11.6 13.1 20.1 10.5c10.4-3.3 22.1-5.3 35.2-5.3c34.8 0 60.4 14.2 77.2 29.5zM392.4 240a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSushiRoll = {
  prefix: 'fal',
  iconName: 'sushi-roll',
  icon: [448, 512, ["maki-roll", "makizushi"], "e48b", "M448 136c0-22.4-12.2-39.9-25.9-52C408.5 71.9 390.5 62.4 371 55.1C331.8 40.4 279.8 32 224 32s-107.8 8.4-147 23.1C57.5 62.4 39.5 71.9 25.9 84C12.2 96.1 0 113.6 0 136V352c0 45.2 35.8 77.4 73.9 96.5C114 468.5 167.1 480 224 480s110-11.5 150.1-31.5C412.2 429.4 448 397.2 448 352V136zm-32 0c0 14.8-11.9 28.6-32.3 40c-89.2-.1-143.5-58.9-143.7-111.8c98.6 3 176 34 176 71.8zM32 136c0-37.7 77.4-68.7 176-71.8c0 12.5 2.1 24.9 6 36.7c-17.9 4.6-39.3 11.9-60.8 22.7c-26.7 13.4-54.4 32.6-75.2 59.1C49.3 170.2 32 153.9 32 136zm78.4 58.1c16.1-17.5 36.3-31.3 57.2-41.8c22-11 43.8-18 60.5-21.8c19.3 30.3 51.4 55 92 67.8C291.8 204.5 259 208 224 208c-42.5 0-81.8-5.2-113.6-13.9zM32 193c12.7 9.7 28.3 17.6 45 23.8c39.2 14.7 91.2 23.1 147 23.1s107.8-8.4 147-23.1c16.7-6.3 32.3-14.1 45-23.8V352c0 53-86 96-192 96s-192-43-192-96V193z"]
};
var faMakiRoll = faSushiRoll;
var faMakizushi = faSushiRoll;
var faCarBump = {
  prefix: 'fal',
  iconName: 'car-bump',
  icon: [640, 512, [], "f5e0", "M131.7 88.2L304.3 41.9c20.5-5.5 42.1 3.1 53.3 21.1l48.2 78c-4.6 .5-9.3 1.4-14 2.7L106.9 220c-4.7 1.2-9.1 2.8-13.4 4.7l2.7-91.6c.6-21.2 15.1-39.5 35.6-44.9zM60.9 243.3l-.1 4.8C39.5 271.5 30.2 304.8 39 337.6l22 82.1L65.3 436l0 0 15.8 58.8c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6L98.7 442.8l1.5-.4L508.7 332.9l1.5-.4L522 376.6c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6l-11.8-44.1 0 0-8.3-30.9-22-82.1c-8.8-32.8-33.5-57-63.6-66.6l-2.5-4L384.8 46.2C366.2 16.2 330.1 1.9 296 11L123.4 57.2c-34.1 9.1-58.2 39.6-59.3 74.9L60.9 243.3zm54.3 7.6L400 174.6c34.1-9.1 69.2 11.1 78.4 45.3l22 82.1L91.9 411.5l-22-82.1c-9.1-34.1 11.1-69.2 45.3-78.4zm42.2 58a22.8 22.8 0 1 0 -44.1 11.8 22.8 22.8 0 1 0 44.1-11.8zM420.4 262a22.8 22.8 0 1 0 -11.8-44.1A22.8 22.8 0 1 0 420.4 262zm43.4 236.2c4.1-28.4 28.5-50.3 58.1-50.3s54 21.8 58.1 50.3c1.3 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1c-6.3-44-44.1-77.7-89.8-77.7s-83.5 33.8-89.8 77.7c-1.3 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6z"]
};
var faPiggyBank = {
  prefix: 'fal',
  iconName: 'piggy-bank',
  icon: [576, 512, [], "f4d3", "M272 32c34.8 0 64.5 22.2 75.5 53.3c2.9 8.3 12.1 12.7 20.4 9.8s12.7-12.1 9.8-20.4C362.3 31.2 320.8 0 272 0C216.5 0 170.4 40.4 161.5 93.4c-1.5 8.7 4.4 17 13.1 18.4s17-4.4 18.4-13.1C199.5 60.8 232.4 32 272 32zM55.2 190.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L36.2 164C14 175.1 0 197.8 0 222.6c0 35.7 28.5 64.7 64 65.4c0 0 0 0 0 0c0 52.4 25.2 98.8 64 128v48c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V448h64v16c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V434.7c25.5-11.1 47.5-28.7 64-50.7h32c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H530.7c-10.7-24.6-27.4-45.9-48.3-62.2l7.2-25C495.4 116.3 480 96 458.8 96H456c-30.5 0-58.2 12.2-78.4 32H224c-77.4 0-142 55-156.8 128H65.4C47 256 32 241 32 222.6c0-12.7 7.2-24.2 18.5-29.9l4.7-2.3zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM396.4 154.7C411 138.3 432.3 128 456 128h2.8l-10.2 35.8c-1.9 6.7 .7 13.8 6.5 17.7c22.8 15.2 40.4 37.6 49.7 63.8c2.3 6.4 8.3 10.7 15.1 10.7H544v96H503.8c-5.3 0-10.3 2.7-13.3 7.1c-15.2 22.8-37.6 40.4-63.8 49.6C420.3 411 416 417 416 423.8V464c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V432c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V407.8c0-5.3-2.7-10.3-7.1-13.3C118.6 371.5 96 332.4 96 288c0-70.7 57.3-128 128-128H384h0l.4 0c4.6 0 8.9-1.9 11.9-5.3z"]
};
var faRacquet = {
  prefix: 'fal',
  iconName: 'racquet',
  icon: [512, 512, [], "f45a", "M349 32c35.5 0 69 12.2 93.9 37.1S480 127.5 480 163c0 45.1-19.6 93.4-57.6 131.4c-68.1 68.1-168.9 76.9-225.3 20.5C172.2 290 160 256.5 160 221c0-45.1 19.6-93.4 57.6-131.4S303.9 32 349 32zm0-32c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 28.2 6.4 56 19.7 80.7c7.8 14.4 7.2 32.8-4.4 44.4l-12 12-4.7-4.7c-12.5-12.5-32.8-12.5-45.3 0l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.5-12.5 12.5-32.8 0-45.3l-4.7-4.7 11.9-11.9c11.6-11.6 30-12.2 44.4-4.3c72.5 39.4 169.9 17.5 234.7-47.4c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 376l32 32L64 480 32 448l72-72z"]
};
var faCarMirrors = {
  prefix: 'fal',
  iconName: 'car-mirrors',
  icon: [576, 512, [], "e343", "M191.6 64c-21.2 0-39.9 13.9-46 34.2l-28.3 94.4c3.5-.4 7.1-.6 10.7-.6H448c3.6 0 7.2 .2 10.7 .6L430.4 98.2c-6.1-20.3-24.8-34.2-46-34.2H191.6zM106.7 227.9l-.5-.1C81.6 236.7 64 260.3 64 288v96H512V288c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H128c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3zM56.4 224H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H84.1L115 89c10.2-33.8 41.3-57 76.6-57H384.4c35.3 0 66.5 23.2 76.6 57l30.9 103H544c8.8 0 16 7.2 16 16s-7.2 16-16 16H519.6c15.2 17 24.4 39.4 24.4 64v96 16 16 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416 400 384 288c0-24.6 9.2-47 24.4-64zM112 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faIndustryWindows = {
  prefix: 'fal',
  iconName: 'industry-windows',
  icon: [576, 512, [127981, "industry-alt"], "f3b3", "M64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V229.3c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l138.7-92.5c5.3-3.5 12.4 .3 12.4 6.7v81.9c0 6 3.4 11.5 8.7 14.2s11.8 2.3 16.6-1.3l138-99.3c5.3-3.8 12.7 0 12.7 6.5V304v16 96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352 304 80zM80 32C53.5 32 32 53.5 32 80V304v48 64c0 35.3 28.7 64 64 64H480c35.3 0 64-28.7 64-64V320 304 158.9c0-32.6-36.9-51.5-63.4-32.5L368 207.5V156.8c0-31.9-35.6-51-62.2-33.3L192 199.4V80c0-26.5-21.5-48-48-48H80zm56 272c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H136zm104 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H264c-13.3 0-24 10.7-24 24zm32 40V336h32v32H272zm120-64c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H392zm40 64H400V336h32v32zm-288 0V336h32v32H144z"]
};
var faIndustryAlt = faIndustryWindows;
var faBoltAuto = {
  prefix: 'fal',
  iconName: 'bolt-auto',
  icon: [576, 512, [], "e0b6", "M291.4 0c-6.1 0-12 2.2-16.5 6.3L8.7 242.9C3.2 247.8 0 254.8 0 262.2C0 276.4 11.6 288 25.8 288H137.3L69.2 478.7C63.4 494.9 75.4 512 92.6 512c6.1 0 11.9-2.2 16.5-6.2L374.9 271.3c5.8-5.1 9.1-12.5 9.1-20.3c0-14.9-12.1-27-27-27H246.7L314.8 33.3C320.6 17.1 308.6 0 291.4 0zM42.1 256L275.3 48.7l-66.4 186c-1.8 4.9-1 10.3 2 14.6s7.9 6.8 13.1 6.8H343.8L108.6 463.6l66.5-186.2c1.8-4.9 1-10.3-2-14.6s-7.9-6.8-13.1-6.8H42.1zM464 288c-6.1 0-11.6 3.4-14.3 8.8l-96 192c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L401.9 464H526.1l19.6 39.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-96-192c-2.7-5.4-8.2-8.8-14.3-8.8zm0 51.8L510.1 432H417.9L464 339.8z"]
};
var faBatteryHalf = {
  prefix: 'fal',
  iconName: 'battery-half',
  icon: [576, 512, ["battery-3"], "f242", "M432 128c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H432zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM112 192H240c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112z"]
};
var faBattery3 = faBatteryHalf;
var faFluxCapacitor = {
  prefix: 'fal',
  iconName: 'flux-capacitor',
  icon: [448, 512, [], "f8ba", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM292.7 255.2c3.7 .5 7.5 .8 11.3 .8c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c3.8 0 7.6-.3 11.3-.8l-45.3-45.3c-18.7-18.7-18.7-49.1 0-67.9s49.1-18.7 67.9 0L224 188.1l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9l-45.3 45.3zM173.8 273.7C155.6 288.4 144 310.8 144 336c0 44.2 35.8 80 80 80s80-35.8 80-80c0-25.2-11.6-47.6-29.8-62.3l-2.2 2.2V336c0 26.5-21.5 48-48 48s-48-21.5-48-48V275.9l-2.2-2.2zm-18.5-109c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 262.6V336c0 8.8 7.2 16 16 16s16-7.2 16-16V262.6l75.3-75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-68.7-68.7z"]
};
var faMountainCity = {
  prefix: 'fal',
  iconName: 'mountain-city',
  icon: [640, 512, [], "e52e", "M320 48c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16V208c0 8.8 7.2 16 16 16h64 32c8.8 0 16 7.2 16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-26.5-21.5-48-48-48H576V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H512V48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v92.1l32 53V48zM226 161.2L302.5 288H223c-5 0-9.8 2.4-12.8 6.4l-34.7 46.2-33-47.7L222 161.2c.5-.9 1.3-1.2 2-1.2s1.5 .3 2 1.2zM32.5 475.4l92-152.4 37.4 54.1c2.9 4.2 7.7 6.8 12.9 6.9s10-2.3 13.1-6.4L231 320h90.8l93.8 155.4c.6 1 .6 2.2 .1 3.3c-.5 1-1.4 1.3-2.1 1.3H34.5c-.7 0-1.5-.4-2.1-1.3c-.6-1-.5-2.3 .1-3.3zM253.4 144.7C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7zM352 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H384c-17.7 0-32 14.3-32 32zm64 0v32H384V96h32zm-32 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7-14.3-32-32-32H384zm96 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H512c-17.7 0-32 14.3-32 32zm64 0v32H512V288h32zm-32 96c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H512zm0 32h32v32H512V416z"]
};
var faCoins = {
  prefix: 'fal',
  iconName: 'coins',
  icon: [512, 512, [], "f51e", "M160 80c0 2.4 1.3 6.8 8.3 12.8c1.4 1.2 2.9 2.4 4.6 3.6c-15.4 .6-30.4 1.9-44.9 3.9V80c0-15.3 8.6-27.7 19.4-37c10.9-9.4 25.7-17.1 42.7-23.2C224.1 7.3 270 0 320 0s95.9 7.3 129.9 19.7c16.9 6.2 31.8 13.9 42.7 23.2C503.4 52.3 512 64.7 512 80l0 104 0 0 0 113.9c0 15.4-8.2 28.2-19.1 38s-25.7 17.9-42.7 24.4c-10.4 3.9-21.8 7.4-34.1 10.3v-33c8.2-2.2 15.8-4.6 22.8-7.2c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V231.7c-8.7 5.6-18.8 10.5-29.9 14.7c-10.4 3.9-21.8 7.4-34.1 10.3v-33c8.2-2.2 15.8-4.6 22.8-7.2c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V126.1c-8.8 5.4-19 10.1-30.1 14.1c-17.3 6.3-37.6 11.3-60 14.6c-1.9-1.9-3.8-3.8-5.7-5.5c-10.1-9.1-21.7-16.4-33.8-22.5c34.8-2.3 65.4-8.4 88.5-16.8c14.9-5.4 25.8-11.5 32.8-17.4c7-6 8.3-10.4 8.3-12.8s-1.3-6.8-8.3-12.8c-6.9-5.9-17.8-12-32.8-17.4C409.3 39 367.2 32 320 32s-89.3 7-119 17.8c-14.9 5.4-25.8 11.5-32.8 17.4c-7 6-8.3 10.4-8.3 12.8zM32 208c0 2.4 1.3 6.8 8.3 12.8c6.9 5.9 17.8 12 32.8 17.4C102.7 249 144.8 256 192 256s89.3-7 119-17.8c14.9-5.4 25.8-11.5 32.8-17.4c7-6 8.3-10.4 8.3-12.8s-1.3-6.8-8.3-12.8c-6.9-5.9-17.8-12-32.8-17.4C281.3 167 239.2 160 192 160s-89.3 7-119 17.8c-14.9 5.4-25.8 11.5-32.8 17.4c-7 6-8.3 10.4-8.3 12.8zM0 208c0-15.3 8.6-27.7 19.4-37c10.9-9.4 25.7-17.1 42.7-23.2C96.1 135.3 142 128 192 128s95.9 7.3 129.9 19.7c16.9 6.2 31.8 13.9 42.7 23.2c10.9 9.3 19.4 21.8 19.4 37l0 104 0 0 0 113.9c0 15.4-8.2 28.2-19.1 38s-25.7 17.9-42.7 24.4C288.1 501.3 242 509 192 509s-96.1-7.7-130.1-20.7c-17-6.5-31.8-14.6-42.7-24.4S0 441.3 0 425.9V312 208zm352 46.1c-8.8 5.4-19 10.1-30.1 14.1C287.9 280.7 242 288 192 288s-95.9-7.3-129.9-19.7c-11.1-4-21.3-8.7-30.1-14.1V312c0 3.1 1.6 8 8.5 14.2s17.8 12.6 32.7 18.2C102.9 355.7 144.8 363 192 363s89.1-7.3 118.8-18.6c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V254.1zM32 425.9c0 3.1 1.6 8 8.5 14.2s17.8 12.6 32.7 18.2C102.9 469.6 144.8 477 192 477s89.1-7.3 118.8-18.6c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V359.7c-8.7 5.6-18.8 10.5-29.9 14.7C288.1 387.4 242 395 192 395s-96.1-7.7-130.1-20.7c-11-4.2-21.1-9.1-29.9-14.7v66.2z"]
};
var faHoneyPot = {
  prefix: 'fal',
  iconName: 'honey-pot',
  icon: [448, 512, [127855], "e418", "M128 64h32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V64h32H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 224v32h96c53 0 96 43 96 96H32c0-53 43-96 96-96V96H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h48zM447.8 237.2c.2-4.3 .2-8.7 .2-13.2c0-42.9-21.1-80.8-53.4-104c12.9-8.6 21.4-23.3 21.4-40c0-26.5-21.5-48-48-48H176 80C53.5 32 32 53.5 32 80c0 16.7 8.5 31.4 21.4 40C21.1 143.2 0 181.1 0 224c0 4.5 .1 8.9 .2 13.2C.1 238.1 0 239 0 240c0 1.5 .2 2.9 .6 4.3c7.2 126.3 80.7 199 112.7 224.9c9.3 7.5 21.1 10.9 33.1 10.9H301.6c12 0 23.7-3.3 33.1-10.9c32-25.9 105.5-98.6 112.7-224.9c.4-1.4 .6-2.8 .6-4.3c0-1-.1-1.9-.2-2.8zM414.4 256c-2.4 23.5-7.3 44.9-13.9 64c-.2 0-.3 0-.5 0H48c-.2 0-.3 0-.5 0C41 300.9 36 279.5 33.6 256H414.4zm-27.1 96c-23.4 47.9-55.2 78.1-72.7 92.3c-2.5 2-6.7 3.7-12.9 3.7H146.4c-6.3 0-10.5-1.7-12.9-3.7c-17.5-14.1-49.4-44.4-72.7-92.3H387.3z"]
};
var faOlive = {
  prefix: 'fal',
  iconName: 'olive',
  icon: [448, 512, [], "e316", "M160 448C89.3 448 32 390.7 32 320c0-84.8 39.8-148.3 91.7-191.4C176.5 84.7 239.5 64 280 64c18.4 0 39.8 9.7 59.3 22.6c9.2 6.1 16.9 12.3 22.3 16.9c2.7 2.3 4.8 4.2 6.1 5.4c.7 .6 1.2 1.1 1.5 1.4l.3 .3 .3 .3c.3 .3 .7 .8 1.4 1.5c1.3 1.3 3.1 3.4 5.4 6.1c4.6 5.4 10.8 13.1 16.9 22.3C406.3 160.2 416 181.6 416 200c0 40.5-20.7 103.5-64.6 156.3C308.3 408.2 244.8 448 160 448zM0 320c0 88.4 71.6 160 160 160c192 0 288-181.9 288-280c0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zM260.4 132.4c3.6-3.6 11.2-6.2 24.2-3c12.6 3.2 27.6 11.5 41 24.9s21.8 28.4 24.9 41c3.2 13 .6 20.6-3 24.2s-11.2 6.2-24.2 3c-12.6-3.2-27.6-11.5-41-24.9s-21.8-28.4-24.9-41c-3.2-13-.6-20.6 3-24.2zm87.8-.7c-16.9-16.9-36.7-28.6-55.9-33.4c-18.8-4.7-39.9-3.2-54.5 11.4s-16.1 35.8-11.4 54.5c4.8 19.1 16.5 39 33.4 55.9s36.7 28.6 55.9 33.4c18.8 4.7 39.9 3.2 54.5-11.4s16.1-35.8 11.4-54.5c-4.8-19.1-16.5-39-33.4-55.9z"]
};
var faKhanda = {
  prefix: 'fal',
  iconName: 'khanda',
  icon: [512, 512, [9772], "f66d", "M266.2 3.7c-5.9-4.9-14.6-4.9-20.5 0l-48 40c-5.9 4.9-7.5 13.2-3.8 19.9l0 0 0 0 0 0 .1 .1 .3 .6c.3 .5 .7 1.3 1.2 2.3c1 2 2.6 5 4.4 8.6c.5 .9 .9 1.9 1.4 2.9C167.1 97.4 144 134 144 176s23.1 78.6 57.3 97.8c-.5 1-1 2-1.4 2.9c-1.8 3.7-3.3 6.6-4.4 8.6c-.5 1-.9 1.8-1.2 2.3l-.3 .6-.1 .1 0 0 0 0 0 0c-3.6 6.7-2 15 3.8 19.9L240 343.5v19.1l-34.6-23.8-41.1-28.2c-42.8-29.4-68.4-78-68.4-130c0-31.1 9.2-61.6 26.5-87.5l2.8-4.2c4-6 3.5-14-1.3-19.5s-12.7-7-19.2-3.7L112 80c-7.2-14.3-7.2-14.3-7.2-14.3l0 0 0 0-.1 0-.3 .2-1 .5c-.8 .4-2 1.1-3.5 1.9C97 70 93 72.5 88.1 75.7c-9.7 6.4-22.5 16.1-35.4 29C26.9 130.4 0 170.3 0 224c0 53.1 26.4 100.5 51.2 133.6c12.6 16.7 25.1 30.3 34.5 39.7c4.7 4.7 8.7 8.4 11.5 10.9c1.4 1.3 2.5 2.2 3.3 2.9l.9 .8 .3 .2 .1 .1 0 0 0 0s0 0 10.3-12.3l-10.2 12.3c5.1 4.3 12.4 4.9 18.2 1.6l75.6-43 32.7 22.5-45.8 31.5c-2.1-.6-4.2-.9-6.5-.9c-13.3 0-24 10.7-24 24s10.7 24 24 24c11.9 0 21.8-8.7 23.7-20.1L240 424.1v28.1c-9.6 5.5-16 15.9-16 27.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-11.8-6.4-22.2-16-27.7V423.4L312.2 451c1.5 11.8 11.6 21 23.8 21c13.3 0 24-10.7 24-24s-10.7-24-24-24c-2 0-3.9 .2-5.7 .7l-45.5-31.3 32.7-22.5 75.6 43c5.8 3.3 13 2.7 18.2-1.6L401.1 400c10.2 12.3 10.2 12.3 10.2 12.3l0 0 0 0 .1-.1 .3-.2 .9-.8c.8-.7 1.9-1.7 3.3-2.9c2.8-2.5 6.7-6.2 11.5-10.9c9.4-9.4 21.9-23 34.5-39.7c24.8-33.1 51.2-80.5 51.2-133.6c0-53.7-26.9-93.6-52.7-119.3c-12.9-12.9-25.8-22.6-35.4-29c-4.8-3.2-8.9-5.7-11.8-7.3c-1.5-.8-2.6-1.5-3.5-1.9l-1-.5-.3-.2-.1 0 0 0 0 0s0 0-7.2 14.3l7.2-14.3c-6.5-3.2-14.3-1.7-19.2 3.7s-5.3 13.4-1.3 19.5l2.8 4.2c17.3 25.9 26.5 56.4 26.5 87.5c0 51.9-25.6 100.6-68.4 130l-41.1 28.2L272 363.3V343.5l42.2-35.2c5.9-4.9 7.5-13.2 3.8-19.9l0 0 0 0-.1-.1-.3-.6c-.3-.5-.7-1.3-1.2-2.3c-1-2-2.6-5-4.4-8.6c-.5-.9-.9-1.9-1.4-2.9C344.9 254.6 368 218 368 176s-23.1-78.6-57.3-97.8c.5-1 1-2 1.4-2.9c1.8-3.7 3.3-6.6 4.4-8.6c.5-1 .9-1.8 1.2-2.3l.3-.6 .1-.1 0 0 0 0 0 0 0 0c3.6-6.7 2-15-3.8-19.9l-48-40zm31.3 103.9c23 14 38.4 39.4 38.4 68.4s-15.4 54.3-38.4 68.4C288.1 221 280 195 280 176s8.1-45 17.6-68.4zM214.4 244.4c-23-14-38.4-39.4-38.4-68.4s15.4-54.3 38.4-68.4C223.9 131 232 157 232 176s-8.1 45-17.6 68.4zM228.6 61.2l-.5-1.1L256 36.8l27.9 23.3-.5 1.1c-3.9 7.8-9 18.8-14.2 31.3c-4.6 11-9.3 23.7-13.2 36.8c-3.9-13.1-8.7-25.8-13.2-36.8C237.6 80 232.5 69 228.6 61.2zm14.2 198.4c4.6-11 9.3-23.7 13.2-36.8c3.9 13.1 8.7 25.8 13.2 36.8c5.2 12.5 10.3 23.5 14.2 31.3l.5 1.1L256 315.2l-27.9-23.3 .5-1.1c3.9-7.8 9-18.8 14.2-31.3zM70.2 132.7c-4.1 15.6-6.2 31.7-6.2 47.9c0 62.5 30.8 121 82.2 156.4l20 13.8-52.1 29.7c-1.7-1.6-3.7-3.5-5.8-5.7c-8.6-8.6-20.1-21-31.5-36.3C53.6 307.5 32 266.9 32 224c0-39 17.9-69.4 38.2-91.3zM481.1 224c0 42.9-21.6 83.5-44.8 114.4c-11.4 15.3-22.9 27.7-31.5 36.3c-2.1 2.1-4.1 4-5.8 5.7l-52.1-29.7 20-13.8c51.5-35.4 82.2-93.9 82.2-156.4c0-16.3-2.1-32.4-6.2-47.9c20.2 21.9 38.2 52.3 38.2 91.3z"]
};
var faFilterList = {
  prefix: 'fal',
  iconName: 'filter-list',
  icon: [512, 512, [], "e17c", "M27.6 64C12.4 64 0 76.4 0 91.6c0 6.7 2.4 13.2 6.8 18.2L112 230V360c0 10 4.7 19.5 12.7 25.5l76.2 57.5c4.2 3.2 9.4 4.9 14.7 4.9c13.5 0 24.4-10.9 24.4-24.4V230L345.2 109.8c4.4-5 6.8-11.5 6.8-18.2C352 76.4 339.6 64 324.4 64H27.6zM140 213.5L37.3 96H314.7L212 213.5c-2.6 2.9-4 6.7-4 10.5V408.3L144 360V224c0-3.9-1.4-7.6-4-10.5zM336 400c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H336zM320 256c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zM400 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H400z"]
};
var faOutlet = {
  prefix: 'fal',
  iconName: 'outlet',
  icon: [448, 512, [], "e01c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 256c0 49.2 24.6 79.3 39.5 93.1c1.2 1.1 4.3 2.9 10.9 2.9H301.6c6.6 0 9.7-1.8 10.9-2.9C327.4 335.3 352 305.2 352 256s-24.6-79.3-39.5-93.1c-1.2-1.1-4.3-2.9-10.9-2.9H146.4c-6.6 0-9.7 1.8-10.9 2.9C120.6 176.7 96 206.8 96 256zm-32 0c0-61.1 30.8-99.1 49.7-116.6c8.8-8.2 20.7-11.4 32.6-11.4H301.6c12 0 23.9 3.3 32.6 11.4C353.2 156.9 384 194.9 384 256s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4H146.4c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256zm112-64c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm-48 96c13.3 0 24 10.7 24 24v16c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8V312c0-13.3 10.7-24 24-24z"]
};
var faSliders = {
  prefix: 'fal',
  iconName: 'sliders',
  icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 8.8 7.2 16 16 16l65.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 432c8.8 0 16-7.2 16-16s-7.2-16-16-16l-257.6 0c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64L16 400c-8.8 0-16 7.2-16 16zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-80c-38.7 0-71 27.5-78.4 64L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l257.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l65.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.6 0c-7.4-36.5-39.7-64-78.4-64zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm78.4-64C263 43.5 230.7 16 192 16s-71 27.5-78.4 64L16 80C7.2 80 0 87.2 0 96s7.2 16 16 16l97.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L270.4 80z"]
};
var faSlidersH = faSliders;
var faCauldron = {
  prefix: 'fal',
  iconName: 'cauldron',
  icon: [448, 512, [], "f6bf", "M160 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96 24a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM60.1 244.9C72 223 85.2 204.3 94.9 192H224 353.1c9.7 12.3 22.9 31 34.8 52.9C404.3 275 416 307.1 416 334.4c0 45.1-21.4 80.4-56.1 105.5C324.5 465.5 275.4 480 224 480s-100.5-14.5-135.9-40.1C53.4 414.8 32 379.5 32 334.4c0-27.3 11.7-59.4 28.1-89.5zM55.2 192C30.2 228.1 0 283.9 0 334.4c0 37.4 11.9 69.4 32 95.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V461.8C106.3 494.6 164.6 512 224 512s117.7-17.4 160-50.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V429.9c20.1-26.1 32-58.1 32-95.5c0-50.5-30.2-106.3-55.2-142.4H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H368 224 80 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H55.2z"]
};
var faPeople = {
  prefix: 'fal',
  iconName: 'people',
  icon: [640, 512, [], "e216", "M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM147.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H128V164c6-2.6 12.5-4 19.3-4zM128 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L243.3 170.3c-13.9-26-41-42.3-70.6-42.3H147.3c-29.5 0-56.7 16.3-70.6 42.3L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L96 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM446.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368H528 432 393.9l52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C551.7 148.6 517.3 128 480 128s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L419 196.6c12-22.5 35.5-36.6 61-36.6z"]
};
var faFolderTree = {
  prefix: 'fal',
  iconName: 'folder-tree',
  icon: [576, 512, [], "f802", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16v96V368c0 26.5 21.5 48 48 48H256V384H48c-8.8 0-16-7.2-16-16V128H256V96H32V16zM394.7 32l21.7 21.7C423 60.3 432 64 441.3 64H544V192H320V32l74.7 0zM288 32V192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H441.3c-.8 0-1.7-.3-2.3-.9L417.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32zm32 288h74.7l21.7 21.7C423 348.3 432 352 441.3 352H544V480H320V320zm-32 0V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H441.3c-.8 0-1.7-.3-2.3-.9l-21.7-21.7c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32z"]
};
var faNetworkWired = {
  prefix: 'fal',
  iconName: 'network-wired',
  icon: [640, 512, [], "f6ff", "M400 32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H336 304 240c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H400zM336 192h64c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h64v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H144v48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H176V272H464v48H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H496V272H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V192zM496 352h64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h64 32zm-320 0h64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h64 32z"]
};
var faCroissant = {
  prefix: 'fal',
  iconName: 'croissant',
  icon: [512, 512, [129360], "f7f6", "M32 288c0-15.3 1.3-30.2 3.9-44.7l169.6 68.4-124 96.4-11.7 8.3c-.9 .2-1.7 .3-2.3 .2c-.6-.1-.9-.2-1-.3l0 0c-.1 0-.2-.2-.5-.6C44.4 378.1 32 334.6 32 288zM7.4 222.9C2.6 243.8 0 265.6 0 288c0 52.3 14 101.4 38.4 143.7c9.3 16.2 28.9 20.8 45.3 13.7c25.7 27.9 57.4 50 93.2 64.3c3.9 1.5 8 2.3 12.2 2.3h5.4c16.3 0 29.6-13.2 29.6-29.6c0-1.6-.1-3.3-.4-4.9L208 384V350.2l34.1-26.5c18.9 2 38.1-4.5 51.9-18.4L305.3 294c13.9-13.9 20.4-33 18.4-51.9L350.2 208H384l93.6 15.6c1.6 .3 3.2 .4 4.9 .4c16.3 0 29.6-13.2 29.6-29.6V189c0-4.2-.7-8.3-2.3-12.2c-14.3-35.8-36.5-67.5-64.3-93.2c7.1-16.4 2.5-36-13.7-45.3C389.4 14 340.3 0 288 0c-22.4 0-44.2 2.6-65.1 7.4C215.6 2.7 207 0 197.9 0c-5 0-10 .8-14.6 2.5C99.6 33.2 33.2 99.6 2.5 183.3C.8 188 0 193 0 197.9c0 9.1 2.7 17.7 7.4 24.9zm235.9-187C257.8 33.3 272.7 32 288 32c46.6 0 90.1 12.4 127.7 34.1c.4 .2 .5 .4 .6 .5l0 0c.1 .1 .2 .4 .3 1c.1 .6 .1 1.4-.2 2.3l-8.3 11.7-96.4 124L243.3 35.9zM188.6 480c-30-12-56.8-30.4-78.8-53.4L176 375.1V384v2.6l.4 2.6L191.6 480H189c-.1 0-.2 0-.3 0c-.1 0-.1 0-.1 0zM375.1 176l51.4-66.1c23 21.9 41.4 48.7 53.4 78.8c0 .1 0 .2 0 .4v2.5l-90.7-15.1-2.6-.4H384h-8.9zM32.5 194.3C60 119.5 119.5 60 194.3 32.5c.8-.3 2-.5 3.6-.5c5.6 0 10.6 3.4 12.7 8.6l79.1 196.2c4.8 11.9 2 25.5-7.1 34.6l-11.3 11.3c-9.1 9.1-22.7 11.8-34.6 7.1L40.6 210.7c-5.2-2.1-8.6-7.1-8.6-12.7c0-1.6 .3-2.8 .5-3.6z"]
};
var faMapPin = {
  prefix: 'fal',
  iconName: 'map-pin',
  icon: [320, 512, [128205], "f276", "M160 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM304 144c0 74.1-56 135.2-128 143.1V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V287.1c-72-8-128-69-128-143.1C16 64.5 80.5 0 160 0s144 64.5 144 144zm-192 0c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z"]
};
var faHamsa = {
  prefix: 'fal',
  iconName: 'hamsa',
  icon: [512, 512, [], "f665", "M256 32c17.7 0 32 14.3 32 32V96 208c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-17.7 14.3-32 32-32s32 14.3 32 32V272c0 8.8 7.2 16 16 16h50.7c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7l-90.2 90.2C348 461.3 303 480 256 480s-92-18.7-125.3-51.9L40.6 337.9C35.1 332.5 32 325 32 317.3C32 301.1 45.1 288 61.3 288H112c8.8 0 16-7.2 16-16V96c0-17.7 14.3-32 32-32s32 14.3 32 32V208c0 8.8 7.2 16 16 16s16-7.2 16-16V96 64c0-17.7 14.3-32 32-32zm0-32c-27.9 0-51.7 17.9-60.4 42.8C185.4 36 173.2 32 160 32c-35.3 0-64 28.7-64 64V256H61.3C27.4 256 0 283.4 0 317.3c0 16.2 6.5 31.8 17.9 43.3l90.2 90.2C147.3 490 200.5 512 256 512s108.7-22 147.9-61.3l90.2-90.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3H416V96c0-35.3-28.7-64-64-64c-13.2 0-25.4 4-35.6 10.8C307.7 17.9 283.9 0 256 0zM176.9 349.3c6.5-6.7 18.7-18.4 33.5-28.2c15.1-10.1 31.1-17 45.6-17s30.5 6.9 45.6 17c14.8 9.9 27 21.5 33.5 28.2c.4 .5 .9 1.3 .9 2.7s-.5 2.3-.9 2.7c-6.5 6.7-18.7 18.4-33.5 28.2c-15.1 10.1-31.1 17-45.6 17s-30.5-6.9-45.6-17c-14.8-9.9-27-21.5-33.5-28.2c-.4-.5-.9-1.3-.9-2.7s.5-2.3 .9-2.7zM256 272c-23.8 0-46.2 11-63.4 22.4c-17.4 11.6-31.4 25.1-38.7 32.7c-6.7 7-9.9 16.1-9.9 25s3.2 18 9.9 25c7.3 7.6 21.3 21 38.7 32.7C209.8 421 232.2 432 256 432s46.2-11 63.4-22.4c17.4-11.6 31.4-25.1 38.7-32.7c6.7-7 9.9-16.1 9.9-25s-3.2-18-9.9-25c-7.3-7.6-21.3-21-38.7-32.7C302.2 283 279.8 272 256 272zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCentSign = {
  prefix: 'fal',
  iconName: 'cent-sign',
  icon: [384, 512, [], "e3f5", "M208 0c8.8 0 16 7.2 16 16V64c1.3 0 2.7 0 4 0c44 0 84.7 14.2 117.5 38.3c7.1 5.2 8.7 15.2 3.4 22.4s-15.2 8.7-22.4 3.4C299.1 108 265 96 228 96C137.1 96 64 168 64 256s73.1 160 164 160c37 0 71.1-12 98.5-32.1c7.1-5.2 17.1-3.7 22.4 3.4s3.7 17.1-3.4 22.4C312.7 433.8 272 448 228 448c-1.3 0-2.7 0-4 0v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V444.8C101.2 428.2 32 350.3 32 256s69.2-172.2 160-188.8V16c0-8.8 7.2-16 16-16z"]
};
var faSwordsLaser = {
  prefix: 'fal',
  iconName: 'swords-laser',
  icon: [640, 512, [], "e03d", "M393.9 177.2c-4.8 2-8.2 6.1-9.4 10.9L185.1 8.2C179.3 2.9 171.6 0 163.7 0L160 0c-17.7 0-32 14.3-32 32v3.7c0 7.9 2.9 15.6 8.2 21.4L384 331.7v7.1c0 12.7 5.1 24.9 14.1 33.9L524.2 498.8c8.4 8.4 19.9 13.2 31.8 13.2s23.4-4.7 31.8-13.2l39-39c8.4-8.4 13.2-19.9 13.2-31.8s-4.7-23.4-13.2-31.8L411.3 180.7c-4.6-4.6-11.5-5.9-17.4-3.5zM160 35.7l0-3.7h3.7L384 230.8v53.1L160 35.7zM513.4 328l-28.7 28.7L456 385.4l-35.3-35.3c-3-3-4.7-7.1-4.7-11.3V230.6L513.4 328zM536 350.6l68.2 68.2c2.4 2.4 3.8 5.7 3.8 9.2s-1.4 6.7-3.8 9.2l-8.2 8.2L518.6 368 536 350.6zM573.4 468l-8.2 8.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8L478.6 408 496 390.6 573.4 468zm-375-228.3l-11-11c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l4.7 4.7-57.9 57.9c-6-3.2-13.7-2.3-18.8 2.8L16 393.4C5.8 403.6 0 417.5 0 432s5.8 28.4 16 38.6L41.4 496c10.2 10.2 24.1 16 38.6 16s28.4-5.8 38.6-16l76.7-76.7c3-3 4.7-7.1 4.7-11.3c0-2.6-.7-5.2-1.9-7.5L256 342.6l4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-11-11 26.2-29-21.6-23.9L249.6 291 221 262.4l31.6-28.5-21.4-23.8-32.8 29.6zM480 35.7L382.7 143.5l3 2.7c11.8-3.7 24.4-2.6 35.3 2.7l82.8-91.7c5.3-5.9 8.2-13.5 8.2-21.4V32c0-17.7-14.3-32-32-32h-3.7c-7.9 0-15.6 2.9-21.4 8.2l-111 100.2L367.8 130 476.3 32l3.7 0v3.7zM152 318.6L193.4 360 176 377.4 134.6 336 152 318.6zM174.6 296L192 278.6 233.4 320 216 337.4 174.6 296zM38.6 416L104 350.6 161.4 408 96 473.4c-4.2 4.2-10 6.6-16 6.6s-11.8-2.4-16-6.6L38.6 448c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16z"]
};
var faFlask = {
  prefix: 'fal',
  iconName: 'flask',
  icon: [448, 512, [], "f0c3", "M288 196.8V32H160V196.8c0 17.8-4.9 35.2-14.2 50.3L100.9 320H347.1l-44.8-72.9C292.9 232 288 214.6 288 196.8zM128 32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h48H288h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V196.8c0 11.8 3.3 23.5 9.5 33.5L437.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5V32zM37.5 423c-3.6 5.9-5.5 12.7-5.5 19.6C32 463.3 48.7 480 69.4 480H378.6c20.7 0 37.4-16.7 37.4-37.4c0-6.9-1.9-13.7-5.5-19.6l-43.7-71H81.2L37.5 423z"]
};
var faPersonPregnant = {
  prefix: 'fal',
  iconName: 'person-pregnant',
  icon: [384, 512, [], "e31e", "M192 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 192 0zm0 352h48 64 16V320c0-31.1-22.3-57.1-51.7-62.8c-12.9-2.5-23-12.6-25.4-25.5l-6.1-32.5c-4.3-22.7-24.1-39.2-47.2-39.2H176c-26.5 0-48 21.5-48 48V352h16 48zm1.9-223.9c36.6 2 67.5 28.7 74.3 65.1l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 256V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H192 160V496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c-17.7 0-32-14.3-32-32V232.1L62.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L88.2 178.8c16.7-31.3 49.2-50.8 84.7-50.8H176h13.6H192c.7 0 1.3 0 1.9 .1z"]
};
var faSquareU = {
  prefix: 'fal',
  iconName: 'square-u',
  icon: [448, 512, [], "e281", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 64V288c0 44.2 35.8 80 80 80s80-35.8 80-80V160c0-8.8 7.2-16 16-16s16 7.2 16 16V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V160c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faWandSparkles = {
  prefix: 'fal',
  iconName: 'wand-sparkles',
  icon: [512, 512, [], "f72b", "M472.8 0c-9.6 0-18.9 3.5-26 9.9L169.9 256H136c-22.1 0-40 17.9-40 40v27.1L17.7 393C6.5 403.1 0 417.5 0 432.6c0 14.1 5.6 27.6 15.6 37.6l26.2 26.2c10 10 23.5 15.6 37.6 15.6c15.1 0 29.5-6.4 39.6-17.6L391.1 192H416c17.7 0 32-14.3 32-32V133.6l55.3-69.1c5.6-7 8.7-15.8 8.7-24.8v-.5C512 17.5 494.5 0 472.8 0zM468 33.8c1.3-1.2 3-1.8 4.8-1.8c4 0 7.2 3.2 7.2 7.2v.5c0 1.7-.6 3.4-1.7 4.8L419.5 118c-2.3 2.8-3.5 6.4-3.5 10v32H384c-4.5 0-8.9 1.9-11.9 5.3L95.2 473c-4 4.5-9.8 7-15.8 7c-5.6 0-11-2.2-15-6.2L38.2 447.6c-4-4-6.2-9.3-6.2-14.9c0-6 2.6-11.7 7.1-15.8l83.6-74.6c3.4-3 5.3-7.4 5.3-11.9V296c0-4.4 3.6-8 8-8h40c3.9 0 7.7-1.4 10.6-4L468 33.8zM256 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H192c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V96h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V32zM96 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V80zM448 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faRouter = {
  prefix: 'fal',
  iconName: 'router',
  icon: [576, 512, [], "f8da", "M352 32c62.9 0 120.4 22.6 165 60.2c6.8 5.7 16.8 4.8 22.5-1.9s4.8-16.8-1.9-22.5C487.5 25.5 422.7 0 352 0S216.5 25.5 166.4 67.8c-6.8 5.7-7.6 15.8-1.9 22.5s15.8 7.6 22.5 1.9C231.6 54.6 289.1 32 352 32zm16 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H368V240zM64 352H512c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm40 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm42.2-251.4C277.9 141.7 313.3 128 352 128s74.1 13.7 101.8 36.6c6.8 5.6 16.9 4.7 22.5-2.1s4.7-16.9-2.1-22.5C441 112.5 398.4 96 352 96s-89 16.5-122.2 43.9c-6.8 5.6-7.8 15.7-2.1 22.5s15.7 7.8 22.5 2.1z"]
};
var faEllipsisVertical = {
  prefix: 'fal',
  iconName: 'ellipsis-vertical',
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0z"]
};
var faEllipsisV = faEllipsisVertical;
var faSwordLaserAlt = {
  prefix: 'fal',
  iconName: 'sword-laser-alt',
  icon: [512, 512, [], "e03c", "M353.2 224L503.8 57.1c5.3-5.9 8.2-13.5 8.2-21.4V32c0-17.7-14.3-32-32-32h-3.7c-7.9 0-15.6 2.9-21.4 8.2L215.8 224h47.8L476.3 32l3.7 0v3.7L310.1 224h43.1zM139.3 270.1L13.2 396.2C4.7 404.6 0 416.1 0 428s4.7 23.4 13.2 31.8l39 39C60.6 507.3 72.1 512 84 512s23.4-4.7 31.8-13.2L331.3 283.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H173.3c-12.7 0-24.9 5.1-33.9 14.1zM281.4 288L184 385.4l-28.7-28.7L126.6 328l35.3-35.3c3-3 7.1-4.7 11.3-4.7H281.4zM144 390.6L161.4 408 93.2 476.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8L66.6 468 144 390.6zM121.4 368L44 445.4l-8.2-8.2c-2.4-2.4-3.8-5.7-3.8-9.2s1.4-6.7 3.8-9.2L104 350.6 121.4 368z"]
};
var faTicket = {
  prefix: 'fal',
  iconName: 'ticket',
  icon: [576, 512, [127903], "f145", "M64 64C28.7 64 0 92.7 0 128v66c0 7.3 4.9 13.7 12 15.5c20.7 5.3 36 24.1 36 46.5s-15.3 41.2-36 46.5C4.9 304.3 0 310.7 0 318v66c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V318c0-7.3-4.9-13.7-12-15.5c-20.7-5.3-36-24.1-36-46.5s15.3-41.2 36-46.5c7.1-1.8 12-8.2 12-15.5V128c0-35.3-28.7-64-64-64H64zM32 128c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32v54.7c-28.2 12.3-48 40.5-48 73.3s19.8 61 48 73.3V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V329.3C60.2 317 80 288.8 80 256s-19.8-61-48-73.3V128zm128 64H416V320H160V192zm-32 0V320c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z"]
};
var faPowerOff = {
  prefix: 'fal',
  iconName: 'power-off',
  icon: [512, 512, [9211], "f011", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM164.3 78.2c7.8-4.1 10.9-13.7 6.9-21.6s-13.7-10.9-21.6-6.9C75 88.3 24 166.2 24 256c0 128.1 103.9 232 232 232s232-103.9 232-232c0-89.8-51-167.7-125.6-206.2c-7.8-4.1-17.5-1-21.6 6.9s-1 17.5 6.9 21.6C412.1 111.5 456 178.6 456 256c0 110.5-89.5 200-200 200S56 366.5 56 256c0-77.4 43.9-144.5 108.3-177.8z"]
};
var faCoin = {
  prefix: 'fal',
  iconName: 'coin',
  icon: [512, 512, [129689], "f85c", "M256 320c66.2 0 124.6-15.2 165.3-38.1C463 258.5 480 231.1 480 208s-17-50.5-58.7-73.9C380.6 111.2 322.2 96 256 96s-124.6 15.2-165.3 38.1C49 157.5 32 184.9 32 208s17 50.5 58.7 73.9C131.4 304.8 189.8 320 256 320zm-80 24.8l0 64.3c20 3.6 41.5 5.8 64 6.6l0-64c-22.2-.8-43.7-3.1-64-6.9zm-32-7.3c-17.2-4.7-33.2-10.5-48-17.1l0 64.7c14.2 6.5 30.3 12.3 48 17l0-64.6zM32 277.8L32 320c0 12.9 8.5 29.9 32 46.8l0-63.6c-12.2-7.8-23-16.3-32-25.5zm240 74l0 64c22.5-.7 44-3 64-6.6l0-64.3c-20.3 3.8-41.8 6.1-64 6.9zm208-74c-9 9.2-19.8 17.7-32 25.5l0 63.6c23.5-16.9 32-34 32-46.8l0-42.2zM368 337.5l0 64.6c17.7-4.7 33.8-10.5 48-17l0-64.7c-14.8 6.7-30.8 12.4-48 17.1zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144l0 32 0 80c0 70.7-114.6 128-256 128S0 390.7 0 320l0-80 0-32zm256-56c-47.1 0-89.1 7.4-118.7 18.8c-14.8 5.7-25.8 12.2-32.7 18.5C97.7 195.7 96 200.6 96 204s1.7 8.3 8.6 14.7c6.9 6.3 17.8 12.8 32.7 18.5C166.9 248.6 208.9 256 256 256s89.1-7.4 118.7-18.8c14.8-5.7 25.8-12.2 32.7-18.5c6.9-6.3 8.6-11.3 8.6-14.7s-1.7-8.3-8.6-14.7c-6.9-6.3-17.8-12.8-32.7-18.5C345.1 159.4 303.1 152 256 152zm192 52c0 15.4-8.2 28.3-19 38.3c-10.9 9.9-25.7 18.2-42.7 24.7c-34.1 13.2-80.2 21-130.2 21s-96.1-7.8-130.2-21c-17-6.6-31.9-14.8-42.7-24.7c-10.9-9.9-19-22.9-19-38.3s8.2-28.3 19-38.3c10.9-9.9 25.7-18.2 42.7-24.7c34.1-13.2 80.2-21 130.2-21s96.1 7.8 130.2 21c17 6.6 31.9 14.8 42.7 24.7c10.9 9.9 19 22.9 19 38.3z"]
};
var faLaptopSlash = {
  prefix: 'fal',
  iconName: 'laptop-slash',
  icon: [640, 512, [], "e1c7", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.3 480l-40.5-32H76.8c-20.3 0-37.4-13.5-42.9-32H419.2l-40.5-32H19.2C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H500.3zM544 351.5l.7 .5H576V96c0-35.3-28.7-64-64-64H139.4l40.5 32H512c17.7 0 32 14.3 32 32V351.5zM64 135.6V352H96V160.8L64 135.6z"]
};
var faRightLong = {
  prefix: 'fal',
  iconName: 'right-long',
  icon: [512, 512, ["long-arrow-alt-right"], "f30b", "M352 184l0-49.3c0-3.7 3-6.7 6.7-6.7c1.9 0 3.7 .8 5 2.2L476.2 256 363.7 381.8c-1.3 1.4-3.1 2.2-5 2.2c-3.7 0-6.7-3-6.7-6.7l0-49.3c0-17.7-14.3-32-32-32L48 296c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l272 0c17.7 0 32-14.3 32-32zm154.7 86c3.4-3.8 5.3-8.8 5.3-14s-1.9-10.1-5.3-14L387.5 108.9c-7.3-8.2-17.8-12.9-28.8-12.9c-21.4 0-38.7 17.3-38.7 38.7l0 17.3 0 32-32 0L48 184c-26.5 0-48 21.5-48 48l0 48c0 26.5 21.5 48 48 48l240 0 32 0 0 32 0 17.3c0 21.4 17.3 38.7 38.7 38.7c11 0 21.5-4.7 28.8-12.9L506.7 270z"]
};
var faLongArrowAltRight = faRightLong;
var faCircleB = {
  prefix: 'fal',
  iconName: 'circle-b',
  icon: [512, 512, [], "e0fd", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 160v96 96c0 17.7 14.3 32 32 32H296c39.8 0 72-32.2 72-72c0-26.6-14.4-49.8-35.9-62.3C344.4 236.8 352 219.3 352 200c0-39.8-32.2-72-72-72H192c-17.7 0-32 14.3-32 32zm160 40c0 22.1-17.9 40-40 40H192V160h88c22.1 0 40 17.9 40 40zM192 352V272h88 16c22.1 0 40 17.9 40 40s-17.9 40-40 40H192z"]
};
var faPersonDressSimple = {
  prefix: 'fal',
  iconName: 'person-dress-simple',
  icon: [256, 512, [], "e21c", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM81.5 215.2L42.4 352H213.6L174.5 215.2C170.6 201.5 158 192 143.7 192H112.3c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4z"]
};
var faPipeCollar = {
  prefix: 'fal',
  iconName: 'pipe-collar',
  icon: [512, 512, [], "e437", "M68.3 166.3c5.9-12.2 3.4-26.8-6.2-36.4l-16-16c-18.7-18.7-18.7-49.1 0-67.9s49.1-18.7 67.9 0l16 16c9.6 9.6 24.2 12.1 36.4 6.2C193.5 55.3 223.8 48 256 48s62.5 7.3 89.7 20.3c12.2 5.9 26.8 3.4 36.4-6.2l16-16c18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9l-16 16c-9.6 9.6-12.1 24.2-6.2 36.4c13 27.1 20.3 57.5 20.3 89.7s-7.3 62.5-20.3 89.7c-5.9 12.2-3.4 26.8 6.2 36.4l16 16c18.7 18.7 18.7 49.1 0 67.9s-49.1 18.7-67.9 0l-16-16c-9.6-9.6-24.2-12.1-36.4-6.2c-27.1 13-57.5 20.3-89.7 20.3s-62.5-7.3-89.7-20.3c-12.2-5.9-26.8-3.4-36.4 6.2l-16 16c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9l16-16c9.6-9.6 12.1-24.2 6.2-36.4C55.3 318.5 48 288.2 48 256s7.3-62.5 20.3-89.7zM136.6 23.4C105.3-7.8 54.7-7.8 23.4 23.4s-31.2 81.9 0 113.1l16 16C24.4 183.9 16 218.9 16 256s8.4 72.1 23.4 103.5l-16 16c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0l16-16c31.3 15 66.4 23.4 103.5 23.4s72.1-8.4 103.5-23.4l16 16c31.2 31.2 81.9 31.2 113.1 0s31.2-81.9 0-113.1l-16-16c15-31.3 23.4-66.4 23.4-103.5s-8.4-72.1-23.4-103.5l16-16c31.2-31.2 31.2-81.9 0-113.1s-81.9-31.2-113.1 0l-16 16C328.1 24.4 293.1 16 256 16s-72.1 8.4-103.5 23.4l-16-16zM128 256a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm288 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM448 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLightsHoliday = {
  prefix: 'fal',
  iconName: 'lights-holiday',
  icon: [640, 512, [], "f7b2", "M23.8 66C16 61.7 6.3 64.5 2 72.2S.5 89.7 8.2 94l13.5 7.5C109.7 150.4 208.7 176 309.3 176H320h10.7c100.6 0 199.6-25.6 287.5-74.5L631.8 94c7.7-4.3 10.5-14 6.2-21.8s-14-10.5-21.8-6.2l-13.5 7.5c-83.2 46.2-176.8 70.5-272 70.5H320 309.3c-95.2 0-188.8-24.3-272-70.5L23.8 66zm99.8 156.2C86.7 217 50 238.2 37 274.6C20.9 319.9 46.9 414 69.5 422.1s102.2-48.6 118.3-93.8c13-36.5-2.1-76.1-34-95.3l14.6-41.1c-10.4-2.4-20.8-5.1-31.1-8.1l-13.7 38.4zM304 257.6c-36.5 7.4-64 39.7-64 78.4c0 48 56 128 80 128s80-80 80-128c0-38.7-27.5-71-64-78.4V208c-1.8 0-3.5 0-5.3 0H320 309.3c-1.8 0-3.5 0-5.3 0v49.6zM486.3 233c-31.9 19.2-47 58.9-34 95.3c16.1 45.2 95.7 101.8 118.3 93.8s48.6-102.2 32.5-147.4c-13-36.5-49.7-57.7-86.6-52.4l-13.7-38.4c-10.3 3-20.7 5.6-31.1 8.1L486.3 233zM128.5 256.2c25 8.9 38 36.3 29.1 61.3c-4.9 13.7-22.6 34.4-45.9 52.1c-11 8.4-21.5 14.7-29.6 18.3l-.6 .3-.3-.6c-4-7.9-8.1-19.4-11.4-32.8c-6.9-28.4-7.5-55.7-2.7-69.4c8.9-25 36.3-38 61.3-29.1zM320 288c26.5 0 48 21.5 48 48c0 14.5-9.8 40-25.8 64.5c-7.6 11.6-15.3 21-21.7 27.1l-.5 .5-.5-.5c-6.4-6.1-14.2-15.6-21.7-27.1c-16-24.5-25.8-50-25.8-64.5c0-26.5 21.5-48 48-48zm-6.5 145.2c0 0 .1-.1 .2-.1l-.2 .1c-.1 0-.1 .1-.1 .1l.1 0zm12.8-.1a.4 .4 0 1 0 .8-.5 .4 .4 0 1 0 -.8 .5zM572.9 285.4c4.9 13.7 4.2 41-2.7 69.4c-3.2 13.4-7.4 24.9-11.4 32.8l-.3 .6-.6-.3c-8.1-3.6-18.6-9.9-29.6-18.3c-23.3-17.7-41-38.5-45.9-52.1c-8.9-25 4.2-52.4 29.1-61.3s52.4 4.2 61.3 29.1z"]
};
var faCitrus = {
  prefix: 'fal',
  iconName: 'citrus',
  icon: [512, 512, [], "e2f4", "M384 96c35.3 0 64-28.7 64-64H384c-35.3 0-64 28.7-64 64h64zm0 32H304c-8.8 0-16-7.2-16-16V96c0-10 1.5-19.7 4.4-28.8c-11.8-2.1-24-3.2-36.4-3.2C141.1 64 48 157.1 48 272s93.1 208 208 208s208-93.1 208-208c0-44.3-13.9-85.5-37.5-119.2c10.3-3.6 20-8.5 28.9-14.5C481 176.5 496 222.5 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272S123.5 32 256 32c17.8 0 35.1 1.9 51.8 5.6C325.3 14.7 353 0 384 0h80c8.8 0 16 7.2 16 16V32c0 53-43 96-96 96z"]
};
var faFlagUsa = {
  prefix: 'fal',
  iconName: 'flag-usa',
  icon: [448, 512, [], "f74d", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V64 367v33 96c0 8.8 7.2 16 16 16s16-7.2 16-16V392l96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L32 56V16zm0 298.6l107.1-23c33.6-7.2 68.6-4.4 100.7 8.1l25.8 10c45.2 17.6 95.1 18.8 141.2 3.5l9.2-3.1v35.6l-34.7 13c-37.9 14.2-80 12-116.2-6.1c-44.7-22.4-96-28-144.5-15.9L32 359V314.6zm0-32.7V242.6l102.2-21.9c36.4-7.8 74.3-3.9 108.4 11.3l13.8 6.2c50.6 22.5 108 23.9 159.6 3.9v34.4l-19.3 6.4c-38.9 13-81.2 11.9-119.4-2.9l-25.8-10c-37.9-14.7-79.2-18-119-9.5L32 281.9zm0-72V89L140.7 61.8c6.4-1.6 12.8-2.7 19.3-3.3V185.1c-10.9 .6-21.7 2-32.5 4.3L32 209.9zm160-24l0-47.8c17.4 2.1 34.4 6.7 50.6 13.9l13.8 6.2c50.6 22.5 108 23.9 159.6 3.9v45.7l-11.3 4.4c-43.7 17-92.4 15.8-135.3-3.2l-13.8-6.2c-20.3-9-41.8-14.7-63.6-16.9zm0-80l0-46.6c13.9 2 27.4 6.2 40.1 12.6c55.3 27.7 120.4 27.7 175.8 0l8.1-4.1v59.9l-11.3 4.4c-43.7 17-92.4 15.8-135.3-3.2l-13.8-6.2c-20.3-9-41.8-14.7-63.6-16.9zM88 120a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM88 168a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLaptopFile = {
  prefix: 'fal',
  iconName: 'laptop-file',
  icon: [640, 512, [], "e51d", "M448 32H128c-17.7 0-32 14.3-32 32V288H320v32H96 64 33.9c5.5 18.5 22.7 32 42.9 32H320v32H76.8C34.4 384 0 349.6 0 307.2C0 296.6 8.6 288 19.2 288H64V64C64 28.7 92.7 0 128 0H448c35.3 0 64 28.7 64 64V96H480V64c0-17.7-14.3-32-32-32zM384 464c0 8.8 7.2 16 16 16H592c8.8 0 16-7.2 16-16V288H528c-26.5 0-48-21.5-48-48V160H400c-8.8 0-16 7.2-16 16V464zM512 160.5V240c0 8.8 7.2 16 16 16h79.5c-.7-2.8-2.1-5.4-4.2-7.4l-83.9-83.9c-2.1-2.1-4.6-3.5-7.4-4.2zm30.1-18.4l83.9 83.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5-21.5 48-48 48H400c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H508.1c12.7 0 24.9 5.1 33.9 14.1z"]
};
var faTty = {
  prefix: 'fal',
  iconName: 'tty',
  icon: [512, 512, ["teletype"], "f1e4", "M354 164.8v29.8c0 8.1 6.1 14.9 14.1 15.9l78.7 9.4c7.3 .9 14.2-3.3 16.8-10.1L473.9 183c6.4-16.6 2.5-31.1-6.1-38.7C426.2 107.6 352.1 64 256 64s-170.2 43.6-211.9 80.3c-8.6 7.6-12.5 22.1-6.1 38.7l10.3 26.7c2.6 6.8 9.6 11 16.8 10.1l78.7-9.4c8-1 14.1-7.8 14.1-15.9V164.8c0-13 7.9-24.7 20-29.6c50-20.3 106-20.3 156.1 0c12.1 4.9 20 16.6 20 29.6zm-32 29.8V164.8c-42.3-17.2-89.7-17.2-132 0v29.8c0 24.3-18.2 44.8-42.3 47.7L69 251.6c-21.8 2.6-42.5-9.9-50.4-30.3L8.2 194.5c-10.1-26-6.2-55.8 14.8-74.2C68.7 79.9 150 32 256 32s187.3 47.9 233 88.3c20.9 18.4 24.8 48.2 14.8 74.2l-10.3 26.7c-7.9 20.4-28.7 32.9-50.4 30.3l-78.7-9.4c-24.1-2.9-42.3-23.3-42.3-47.7zM72 291.2h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H72c-15.9 0-28.8-12.9-28.8-28.8V320c0-15.9 12.9-28.8 28.8-28.8zM68.8 320v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V320c0-1.8-1.4-3.2-3.2-3.2H72c-1.8 0-3.2 1.4-3.2 3.2zM72 403.2h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H72c-15.9 0-28.8-12.9-28.8-28.8V432c0-15.9 12.9-28.8 28.8-28.8zM68.8 432v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V432c0-1.8-1.4-3.2-3.2-3.2H72c-1.8 0-3.2 1.4-3.2 3.2zM408 403.2h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H408c-15.9 0-28.8-12.9-28.8-28.8V432c0-15.9 12.9-28.8 28.8-28.8zM404.8 432v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V432c0-1.8-1.4-3.2-3.2-3.2H408c-1.8 0-3.2 1.4-3.2 3.2zm-249.6 0c0-15.9 12.9-28.8 28.8-28.8H328c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H184c-15.9 0-28.8-12.9-28.8-28.8V432zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2v32c0 1.8 1.4 3.2 3.2 3.2H328c1.8 0 3.2-1.4 3.2-3.2V432c0-1.8-1.4-3.2-3.2-3.2H184zM155.2 320c0-15.9 12.9-28.8 28.8-28.8h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H184c-15.9 0-28.8-12.9-28.8-28.8V320zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V320c0-1.8-1.4-3.2-3.2-3.2H184zm112-25.6h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H296c-15.9 0-28.8-12.9-28.8-28.8V320c0-15.9 12.9-28.8 28.8-28.8zM292.8 320v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V320c0-1.8-1.4-3.2-3.2-3.2H296c-1.8 0-3.2 1.4-3.2 3.2zm86.4 0c0-15.9 12.9-28.8 28.8-28.8h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H408c-15.9 0-28.8-12.9-28.8-28.8V320zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V320c0-1.8-1.4-3.2-3.2-3.2H408z"]
};
var faTeletype = faTty;
var faChartTreeMap = {
  prefix: 'fal',
  iconName: 'chart-tree-map',
  icon: [512, 512, [], "e0ea", "M176 64c8.8 0 16 7.2 16 16V192c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16H176zM48 32C21.5 32 0 53.5 0 80V192c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM176 304c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V320c0-8.8 7.2-16 16-16H176zM48 272c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48H48zM304 64H464c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM256 80v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zM464 224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16H464zM304 192c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H304zm0 192H464c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V400c0-8.8 7.2-16 16-16zm-48 16v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48z"]
};
var faDiagramNext = {
  prefix: 'fal',
  iconName: 'diagram-next',
  icon: [512, 512, [], "e476", "M480 160c0 17.7-14.3 32-32 32l-176 0H240L64 192c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32v64zM272 224H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H240V329.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4V224zM448 480c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64l384 0z"]
};
var faPersonRifle = {
  prefix: 'fal',
  iconName: 'person-rifle',
  icon: [576, 512, [], "e54e", "M260.7 192c28.3 0 55.1 10.7 75.3 29.1V496.2c-.1 8.7-7.2 15.8-16 15.8c-8.8 0-16-7.2-16-16V236.7c-12.7-8.2-27.7-12.7-43.3-12.7H219.3c-15.7 0-30.7 4.6-43.3 12.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V275.8L62.3 439.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l85.5-170.9c19-37.9 57.8-61.9 100.2-61.9h41.3zM288 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM480 336v14.2l3.9 17.8h7.1H528c8.8 0 16 7.2 16 16s-7.2 16-16 16h-4.2H491.1l7.1 32 9.1 41.1 4.3 19.5c1.1 4.7-.1 9.7-3.1 13.5s-7.6 6-12.5 6H476.1 416 400c-8.8 0-16-7.2-16-16V480 393.9l-2.7-1.4c-8.1-4.1-13.3-12.4-13.3-21.5v-4.9V225.9v-4.9c0-9.1 5.1-17.4 13.3-21.5l2.7-1.4V160c0-17.7 14.3-32 32-32V96 64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16V32 96v32c17.7 0 32 14.3 32 32v48 47 1 24 8l32-8V256 208c0-8.8 7.2-16 16-16s16 7.2 16 16v72 12.5c0 6.9-4.4 13-10.9 15.2l-.9 .3L480 325.3V336zm-27.3 38.9l-1.5-6.9-2.4-10.8-.4-1.7 0 0c-.3-1.1-.4-2.3-.4-3.5v-1.8V336v-7-3.7V302.3 296v-8V256 208 192 160H416v32 6.1V208c0 6-3.4 11.6-8.8 14.3l0 0-7.2 3.6V366.1l7.2 3.6 0 0c5.4 2.7 8.8 8.2 8.8 14.3v9.9V448v32h27.3H448h28.1l-7.1-32-9.1-41.1-1.5-6.9-5.6-25.1z"]
};
var faClockFiveThirty = {
  prefix: 'fal',
  iconName: 'clock-five-thirty',
  icon: [512, 512, [], "e34a", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V308.8l34.7 52c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-64-96c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faPipeValve = {
  prefix: 'fal',
  iconName: 'pipe-valve',
  icon: [512, 512, [], "e439", "M272 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V80H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v80H32V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v32V432v32c0 8.8 7.2 16 16 16s16-7.2 16-16V448H480v16c0 8.8 7.2 16 16 16s16-7.2 16-16V432 208 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H272V112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V32zM256 224H480V416H32V224H256z"]
};
var faArrowUpFromArc = {
  prefix: 'fal',
  iconName: 'arrow-up-from-arc',
  icon: [512, 512, [], "e4b4", "M256 480C132.3 480 32 379.7 32 256c0-8.8-7.2-16-16-16s-16 7.2-16 16C0 397.4 114.6 512 256 512s256-114.6 256-256c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7-100.3 224-224 224zM116 149.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3L240 58.1 240 336c0 8.8 7.2 16 16 16s16-7.2 16-16l0-277.9L372 170.6c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L268 5.4C264.9 2 260.6 0 256 0s-8.9 2-12 5.4l-128 144z"]
};
var faFaceSpiralEyes = {
  prefix: 'fal',
  iconName: 'face-spiral-eyes',
  icon: [512, 512, [], "e485", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.9 374.9l14.8-9.9c14.3-9.6 32.7-10.7 48.1-3l15.4 7.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-15.4-7.7c-5.1-2.6-11.3-2.2-16 1l-14.8 9.9c-16.1 10.7-37.1 10.7-53.3 0l-12.5-8.3c-5.4-3.6-12.4-3.6-17.8 0l-12.5 8.3c-16.1 10.7-37.1 10.7-53.3 0l-14.8-9.9c-4.8-3.2-10.9-3.6-16-1l-15.4 7.7c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l15.4-7.7c15.4-7.7 33.8-6.6 48.1 3l14.8 9.9c5.4 3.6 12.4 3.6 17.8 0l12.5-8.3c16.1-10.7 37.1-10.7 53.3 0l12.5 8.3c5.4 3.6 12.4 3.6 17.8 0zm-139-263.3c.3 6.6-4.9 12.2-11.5 12.5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-5.5-53.8 41.1-108.1 101-110.5c6.6-.3 12.2 4.9 12.5 11.5zM349.6 292c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.9-2.8-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5c-6.6 .3-12.2-4.9-12.5-11.5s4.9-12.2 11.5-12.5z"]
};
var faCompressWide = {
  prefix: 'fal',
  iconName: 'compress-wide',
  icon: [512, 512, [], "f326", "M128 80c0-8.8 7.2-16 16-16s16 7.2 16 16V208c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H128V80zm16 208c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H144zM352 80c0-8.8 7.2-16 16-16s16 7.2 16 16V192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80zM496 288c8.8 0 16 7.2 16 16s-7.2 16-16 16H384V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16H496z"]
};
var faCirclePhoneHangup = {
  prefix: 'fal',
  iconName: 'circle-phone-hangup',
  icon: [512, 512, ["phone-circle-down"], "e11d", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM112 248.6c.1-.5 .3-1.2 1.1-1.9c78.8-72.9 207-72.9 285.7 0c.8 .7 1 1.4 1.1 1.9s0 1.1-.4 1.8l-21.7 35.2c-1 1.7-4.1 3.2-7.4 1.9l-46.2-17.6c-2.4-.9-2.9-2.6-2.9-3.4l2.8-18.1c1.2-7.8-3.4-15.3-10.9-17.7c-37-11.9-77.4-11.9-114.3 0c-7.5 2.4-12.1 9.9-10.9 17.7l2.8 18.1c0 .9-.5 2.5-2.9 3.4l-46.2 17.6c-3.3 1.2-6.4-.3-7.4-1.9l-21.7-35.2c-.4-.7-.5-1.2-.4-1.8zm308.6-25.4c-91-84.3-238.2-84.3-329.2 0c-12.3 11.4-15.1 29.5-6.2 44l21.7 35.2c9.6 15.6 29.4 21.4 46 15l46.2-17.6c14.9-5.7 25.1-20.3 23.3-36.9c0-.2-.1-.5-.1-.7l-.7-4.5c22.5-5.1 46.1-5.1 68.6 0l-.7 4.5c0 .2-.1 .5-.1 .7c-1.8 16.6 8.5 31.3 23.3 36.9L359 317.5c16.6 6.3 36.4 .6 46-15l21.7-35.2c8.9-14.4 6.1-32.6-6.2-44z"]
};
var faPhoneCircleDown = faCirclePhoneHangup;
var faGearComplexCode = {
  prefix: 'fal',
  iconName: 'gear-complex-code',
  icon: [512, 512, [], "e5eb", "M215 62.8l4.9-24.3-15.7-3.1 15.7 3.1c.3-1.5 1-2.8 1.9-3.8C232.9 32.9 244.4 32 256 32s23.1 .9 34.2 2.6c1 1.1 1.6 2.4 1.9 3.8L297 62.8c2.9 14.4 13.2 25.2 25.5 30.3l0 0 1.5 .6 0 0c12.3 5.2 27.3 4.8 39.5-3.3l20.6-13.8c1.2-.8 2.6-1.3 4.1-1.3c9.1 6.7 17.7 14 25.6 21.9l.8 .8 0 0c7.9 8 15.3 16.5 21.9 25.6c-.1 1.4-.5 2.8-1.3 4.1l-13.8 20.6c-8.1 12.2-8.5 27.1-3.3 39.5l0 0 .6 1.5 0 0c5.1 12.4 15.9 22.6 30.3 25.5l24.3 4.9c1.5 .3 2.8 1 3.8 1.9c1.7 11.1 2.6 22.4 2.6 34v.4c0 11.6-.9 22.9-2.6 34c-1.1 1-2.4 1.6-3.8 1.9L449.2 297c-14.4 2.9-25.2 13.2-30.3 25.5l0 0-.6 1.5 0 0c-5.2 12.3-4.8 27.3 3.3 39.5l13.8 20.6c.8 1.2 1.3 2.6 1.3 4.1c-13.6 18.5-29.9 34.9-48.4 48.4c-1.4-.1-2.8-.5-4.1-1.3l-20.6-13.8c-12.2-8.1-27.1-8.5-39.5-3.3l0 0-1.5 .6 0 0c-12.4 5.1-22.6 15.9-25.5 30.3l-4.9 24.3c-.3 1.5-1 2.8-1.9 3.8c-11.1 1.7-22.6 2.6-34.2 2.6s-23.1-.9-34.2-2.6c-1-1.1-1.6-2.4-1.9-3.8L215 449.2c-2.9-14.4-13.2-25.2-25.5-30.3l0 0-1.5-.6 0 0c-12.3-5.2-27.3-4.8-39.5 3.3l-20.6 13.8c-1.2 .8-2.6 1.3-4.1 1.3c-18.5-13.6-34.9-29.9-48.4-48.4c.1-1.4 .5-2.8 1.3-4.1l13.8-20.6c8.1-12.2 8.5-27.1 3.3-39.5l0 0-.6-1.5 0 0c-5.1-12.4-15.9-22.6-30.3-25.5l-24.3-4.9c-1.5-.3-2.8-1-3.8-1.9C32.9 279.1 32 267.6 32 256s.9-23.1 2.6-34.2c1.1-1 2.4-1.6 3.8-1.9L62.8 215c14.4-2.9 25.2-13.2 30.3-25.5l0 0 .6-1.5 0 0c5.2-12.3 4.8-27.3-3.3-39.5L76.6 127.7c-.8-1.2-1.3-2.6-1.3-4.1c6.7-9.1 14-17.7 22-25.7l.8-.8 0 0c8-7.9 16.6-15.3 25.7-22c1.4 .1 2.8 .5 4.1 1.3l20.6 13.8c12.2 8.1 27.1 8.5 39.5 3.3l0 0 1.5-.6 0 0c12.4-5.1 22.7-15.9 25.5-30.3zM256 0c-14.8 0-29.3 1.3-43.4 3.7c-2 .3-3.9 1-5.6 2.1c-9.4 5.6-16.3 15.1-18.6 26.4l-4.9 24.3c-.5 2.6-2.6 5.4-6.3 6.9l0 0-.1 0-1.7 .7 0 0-.1 0c-3.7 1.5-7.1 1-9.4-.4L145.5 50c-9.6-6.4-21.2-8.2-31.7-5.6c-1.9 .5-3.8 1.3-5.4 2.5C96.6 55.2 85.6 64.4 75.4 74.5l0 0-.8 .8 0 0C64.4 85.6 55.2 96.6 46.9 108.3c-1.2 1.6-2 3.5-2.5 5.4c-2.6 10.6-.8 22.1 5.6 31.7l13.8 20.6c1.5 2.2 2 5.7 .4 9.4l0 .1-.7 1.7 0 0 0 .1c-1.5 3.7-4.3 5.8-6.9 6.3l-24.3 4.9c-11.4 2.3-20.8 9.2-26.4 18.6c-1 1.7-1.7 3.6-2.1 5.6C1.3 226.7 0 241.2 0 256s1.3 29.3 3.7 43.4c.3 2 1 3.9 2.1 5.6c5.6 9.4 15.1 16.3 26.4 18.6l24.3 4.9c2.6 .5 5.4 2.6 6.9 6.3l0 .1 .7 1.7 0 .1c1.5 3.7 1 7.1-.4 9.4L50 366.5c-6.4 9.6-8.2 21.2-5.6 31.7c.5 1.9 1.3 3.8 2.5 5.4c16.8 23.8 37.6 44.6 61.5 61.5c1.6 1.2 3.5 2 5.4 2.5c10.6 2.6 22.1 .8 31.7-5.6l20.6-13.8c2.2-1.5 5.7-2 9.4-.4l.1 0 1.7 .7 .1 0c3.7 1.5 5.8 4.3 6.3 6.9l4.9 24.3c2.3 11.4 9.2 20.8 18.6 26.4c1.7 1 3.6 1.7 5.6 2.1c14.1 2.4 28.6 3.7 43.4 3.7s29.3-1.3 43.4-3.7c2-.3 3.9-1 5.6-2.1c9.4-5.6 16.3-15.1 18.6-26.4l4.9-24.3c.5-2.6 2.6-5.4 6.3-6.9l.1 0 1.7-.7 .1 0c3.7-1.5 7.1-1 9.4 .4L366.5 462c9.6 6.4 21.2 8.2 31.7 5.6c1.9-.5 3.8-1.3 5.4-2.5c23.8-16.8 44.6-37.6 61.5-61.4c1.2-1.6 2-3.5 2.5-5.4c2.6-10.6 .8-22.1-5.6-31.7l-13.8-20.6c-1.5-2.2-2-5.7-.4-9.4l0-.1 .7-1.7 0-.1c1.5-3.7 4.3-5.8 6.9-6.3l24.3-4.9-3.1-15.7 3.1 15.7c11.4-2.3 20.8-9.2 26.4-18.6c1-1.7 1.7-3.6 2.1-5.6c2.4-14 3.7-28.5 3.7-43.2v0-.4 0c0-14.7-1.3-29.1-3.7-43.2c-.3-2-1-3.9-2.1-5.6c-5.6-9.4-15.1-16.3-26.4-18.6l-24.3-4.9c-2.6-.5-5.4-2.6-6.9-6.3l0-.1-.7-1.7 0-.1c-1.5-3.7-1-7.1 .4-9.4L462 145.5c6.4-9.6 8.2-21.2 5.6-31.7c-.5-1.9-1.3-3.8-2.5-5.4c-8.3-11.7-17.5-22.7-27.6-32.9l0 0-.9-.9 0 0c-10.1-10.1-21.1-19.3-32.9-27.6c-1.6-1.2-3.5-2-5.4-2.5c-10.6-2.6-22.1-.8-31.7 5.6L345.9 63.7c-2.2 1.5-5.7 2-9.4 .4l-.1 0-1.7-.7-.1 0c-3.7-1.5-5.8-4.3-6.3-6.9l-4.9-24.3c-2.3-11.4-9.2-20.8-18.6-26.4c-1.7-1-3.6-1.7-5.6-2.1C285.3 1.3 270.8 0 256 0zm31.8 162.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-32 192c-1.5 8.7 4.4 17 13.2 18.4s17-4.4 18.4-13.2l32-192zM187.3 227.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-40 40c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L158.6 256l28.7-28.7zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L353.4 256l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l40-40c6.2-6.2 6.2-16.4 0-22.6l-40-40z"]
};
var faHouseMedicalCircleExclamation = {
  prefix: 'fal',
  iconName: 'house-medical-circle-exclamation',
  icon: [640, 512, [], "e512", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H394.8c-12.9-9.1-24.5-19.9-34.6-32H144c-26.5 0-48-21.5-48-48V206.7L288 37.3 466.1 194.5c9.7-1.7 19.7-2.5 29.9-2.5c5.6 0 11.1 .3 16.5 .8L298.6 4zM368 240H336V208c0-17.7-14.3-32-32-32H272c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c6.7 0 12.9-2 18-5.5c-1.3-8.6-2-17.5-2-26.5c0-22.6 4.3-44.2 12-64H320c-8.8 0-16 7.2-16 16v48H272V320c0-8.8-7.2-16-16-16H208V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208h32v48c0 8.8 7.2 16 16 16h28.5c7.5-11.4 16.2-22 26-31.3c-2.1-.4-4.3-.7-6.5-.7zm16 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faBadminton = {
  prefix: 'fal',
  iconName: 'badminton',
  icon: [576, 512, [], "e33a", "M349 32c35.5 0 69 12.2 93.9 37.1S480 127.5 480 163c0 45.1-19.6 93.4-57.6 131.4c-68.1 68.1-168.9 76.9-225.3 20.5C172.2 290 160 256.5 160 221c0-45.1 19.6-93.4 57.6-131.4S303.9 32 349 32zm0-32c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 28.2 6.4 56 19.7 80.7c7.8 14.4 7.2 32.8-4.4 44.4l-12 12-4.7-4.7c-12.5-12.5-32.8-12.5-45.3 0l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.5-12.5 12.5-32.8 0-45.3l-4.7-4.7 11.9-11.9c11.6-11.6 30-12.2 44.4-4.3c72.5 39.4 169.9 17.5 234.7-47.4c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 376l32 32L64 480 32 448l72-72zm352.9 88l-8.2 27.4c-2.5 8.5 2.3 17.4 10.7 19.9s17.4-2.3 19.9-10.7l11-36.6H456.9zM496 496c0 8.8 7.2 16 16 16s16-7.2 16-16V464H496v32zm37.7-32l11 36.6c2.5 8.5 11.5 13.3 19.9 10.7s13.3-11.5 10.7-19.9L567.1 464H533.7zM496 400c0-8.8 7.2-16 16-16s16 7.2 16 16v16H496V400zm64 0c0-26.5-21.5-48-48-48s-48 21.5-48 48v16 32h32 32 32V416 400z"]
};
var faClosedCaptioning = {
  prefix: 'fal',
  iconName: 'closed-captioning',
  icon: [576, 512, [], "f20a", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm200 96c-35.3 0-64 28.7-64 64s28.7 64 64 64c17.4 0 33.2-7 44.8-18.3c6.3-6.2 16.4-6.1 22.6 .2s6.1 16.4-.2 22.6c-17.3 17-41 27.4-67.2 27.4c-53 0-96-43-96-96s43-96 96-96c26.2 0 49.9 10.5 67.2 27.4c6.3 6.2 6.4 16.3 .2 22.6s-16.3 6.4-22.6 .2C233.2 199 217.4 192 200 192zm192 0c-35.3 0-64 28.7-64 64s28.7 64 64 64c17.4 0 33.2-7 44.8-18.3c6.3-6.2 16.4-6.1 22.6 .2s6.1 16.4-.2 22.6c-17.3 17-41 27.4-67.2 27.4c-53 0-96-43-96-96s43-96 96-96c26.2 0 49.9 10.5 67.2 27.4c6.3 6.2 6.4 16.3 .2 22.6s-16.3 6.4-22.6 .2C425.2 199 409.4 192 392 192z"]
};
var faPersonHiking = {
  prefix: 'fal',
  iconName: 'person-hiking',
  icon: [384, 512, ["hiking"], "f6ec", "M288 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 208 56zM102.9 128.4c-19 2.5-35 16.1-40.1 35L40.2 246.3l31.9 5.3 30.8-123.2zm-1.5 138.1c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8L101.4 266.5zM368 160c8.8 0 16 7.2 16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H312.8c-10.9 0-21.1-5.6-27-14.8l-20.7-32.5L237.2 333.5l36.6 24.4c8.9 5.9 14.2 15.9 14.2 26.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384.6l-95-63.3c-16.3-10.8-24.3-30.4-20.4-49.6l19.8-96.5c6.1-29.9 35.1-49.3 65-43.7c20.6 3.9 38.7 16.1 50 33.8L312.8 224H352V176c0-8.8 7.2-16 16-16zM123.7 334.8c.5 .4 1.1 .8 1.6 1.1l26.4 17.6L111.4 500.2c-2.3 8.5-11.1 13.5-19.7 11.2s-13.5-11.2-11.2-19.7l43.2-157zm68.1-153.2L172 278.1c-1.3 6.4 1.4 12.9 6.8 16.5l29.8 19.9L240.3 173c-5.8-5.1-13-8.6-20.7-10c-12.8-2.4-25.1 5.9-27.8 18.6z"]
};
var faHiking = faPersonHiking;
var faRightFromLine = {
  prefix: 'fal',
  iconName: 'right-from-line',
  icon: [448, 512, ["arrow-alt-from-left"], "f347", "M415.2 254.2c.5 .5 .8 1.1 .8 1.8s-.3 1.4-.8 1.8L283.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-8.8-7.2-16-16-16l-120 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l120 0c8.8 0 16-7.2 16-16l0-57.3c0-3.7 3-6.7 6.7-6.7c1.7 0 3.3 .7 4.6 1.8L415.2 254.2zM448 256c0-9.5-3.9-18.6-10.8-25.1L305.2 106.5C298 99.8 288.5 96 278.7 96c-21.4 0-38.7 17.3-38.7 38.7l0 41.3-104 0c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l104 0 0 41.3c0 21.4 17.3 38.7 38.7 38.7c9.9 0 19.3-3.8 26.5-10.5L437.2 281.1c6.9-6.5 10.8-15.6 10.8-25.1zM0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80z"]
};
var faArrowAltFromLeft = faRightFromLine;
var faVenusDouble = {
  prefix: 'fal',
  iconName: 'venus-double',
  icon: [640, 512, [9890], "f226", "M192 320a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM368 176c0 91.8-70.3 167.2-160 175.3V416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.3C86.3 343.2 16 267.8 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c7.3-7.8 14-16.2 20-25c23.6 17 52.6 27 84 27c79.5 0 144-64.5 144-144s-64.5-144-144-144c-31.3 0-60.3 10-84 27c-6-8.9-12.7-17.2-20-25C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 91.8-70.3 167.2-160 175.3V416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.3c-32.7-3-62.9-14.9-88-33.3z"]
};
var faImages = {
  prefix: 'fal',
  iconName: 'images',
  icon: [576, 512, [], "f302", "M160 64H512c17.7 0 32 14.3 32 32V201.4L486.6 144c-12.5-12.5-32.8-12.5-45.3 0L304 281.4 230.6 208c-12.5-12.5-32.8-12.5-45.3 0L128 265.4V96c0-17.7 14.3-32 32-32zM576 96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64V304v16c0 35.3 28.7 64 64 64h80 0H512c35.3 0 64-28.7 64-64V240 240 96zM464 166.6l80 80V320c0 17.7-14.3 32-32 32H278.6l36.7-36.7L464 166.6zM281.4 304l-48 48H160c-17.7 0-32-14.3-32-32v-9.4l80-80L281.4 304zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112zm232 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCalculator = {
  prefix: 'fal',
  iconName: 'calculator',
  icon: [384, 512, [128425], "f1ec", "M352 160V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160H352zm0-32H32V64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v64zm32 0V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v64 16 16V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160 144 128zM72 224a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM264 416a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM80 400c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faShuttlecock = {
  prefix: 'fal',
  iconName: 'shuttlecock',
  icon: [512, 512, [], "f45b", "M241.9 0c-12.1 0-23.2 6.8-28.6 17.7L92.2 259.8 73.4 278.6 33.1 318.9C11.9 340.1 0 368.9 0 398.9C0 461.3 50.7 512 113.1 512c30 0 58.8-11.9 80-33.1l40.2-40.2 18.9-18.9 242.1-121c10.8-5.4 17.7-16.5 17.7-28.6V224c0-17.7-14.3-32-32-32H424V120c0-17.7-14.3-32-32-32H320V32c0-17.7-14.3-32-32-32H241.9zm67.2 355.6l-75.7 37.8 0 0-46.1-46.1 77.2-77.2 103-32.5-58.4 118zm47.5-23.7l53.3-107.6 .6-.2H480v46.1L356.5 331.8zM288 101.5l-.2 .6L180.2 155.5 241.9 32 288 32v69.5zm-13.6 43l-32.5 103-77.2 77.2-46.1-46.1 0 0 37.8-75.7 118-58.4zm6.1 87L315.7 120H392v76.3L280.5 231.5zM61.9 335.3L96 301.3 210.7 416l-34.1 34.1L61.9 335.3zm89.7 135c-11.7 6.3-24.9 9.7-38.5 9.7C68.3 480 32 443.7 32 398.9c0-13.6 3.4-26.8 9.7-38.5L151.6 470.3z"]
};
var faUserHair = {
  prefix: 'fal',
  iconName: 'user-hair',
  icon: [448, 512, [], "e45a", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM307.2 80C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zM32 480H416c-1.9-71-60-128-131.5-128H163.6C92.1 352 33.9 409 32 480zM0 483.6C0 393.2 73.2 320 163.6 320H284.4C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z"]
};
var faEyeEvil = {
  prefix: 'fal',
  iconName: 'eye-evil',
  icon: [640, 512, [], "f6db", "M258.1 126.1c-11.2 3.2-21.8 7.3-31.7 12.1c-8.6 4.1-18.4 4.8-27.4 2l-55.9-17.5L161.7 151c8.3 12.6 8.2 29-.2 41.5c-4.5 6.7-8.3 13.7-11.3 20.8c-4.1 9.7-12 17.2-21.9 20.7L66.5 256l61.8 22.1c9.9 3.5 17.8 11 21.9 20.7c3 7.1 6.8 14.1 11.3 20.8c8.4 12.5 8.5 28.9 .2 41.5l-18.6 28.3L199 371.8c9.1-2.8 18.9-2.1 27.4 2c9.9 4.8 20.5 8.8 31.7 12.1c8.9 2.6 16.5 8.3 21.3 16.1L320 467l40.6-64.9c4.9-7.8 12.5-13.6 21.3-16.1c11.2-3.2 21.8-7.3 31.7-12.1c8.6-4.1 18.4-4.8 27.4-2l55.9 17.5L478.3 361c-8.3-12.6-8.2-29 .2-41.5c4.5-6.7 8.3-13.7 11.3-20.8c4.1-9.7 12-17.2 21.9-20.7L573.5 256l-61.8-22.1c-9.9-3.5-17.8-11-21.9-20.7c-3-7.1-6.8-14.1-11.3-20.8c-8.4-12.5-8.5-28.9-.2-41.5l18.6-28.3L441 140.2c-9.1 2.8-18.9 2.1-27.4-2c-9.9-4.8-20.5-8.8-31.7-12.1c-8.9-2.6-16.5-8.3-21.3-16.1L320 45l-40.6 64.9c-4.9 7.8-12.5 13.6-21.3 16.1zM0 256c0-9.6 6-18.2 15.1-21.4l100.6-35.9c4-9.4 8.9-18.5 14.7-27.1L89.2 108.8c-5.3-8-4.9-18.5 .8-26.1s15.7-10.9 24.9-8l95.3 29.8c11.8-5.7 24.4-10.5 37.5-14.3l47.8-76.5C300.8 5.1 310 0 320 0s19.2 5.1 24.5 13.6l47.8 76.5c13.1 3.8 25.7 8.6 37.5 14.3l95.3-29.8c9.2-2.9 19.1 .3 24.9 8s6.1 18.1 .8 26.1l-41.3 62.7c5.8 8.6 10.7 17.7 14.7 27.1l100.6 35.9c9 3.2 15.1 11.8 15.1 21.4s-6 18.2-15.1 21.4L524.3 313.3c-4 9.4-8.9 18.5-14.7 27.1l41.3 62.7c5.3 8 4.9 18.5-.8 26.1s-15.7 10.9-24.9 8l-95.3-29.8c-11.8 5.7-24.4 10.5-37.5 14.3l-47.8 76.5C339.2 506.9 330 512 320 512s-19.2-5.1-24.5-13.6l-47.8-76.5c-13.1-3.8-25.7-8.6-37.5-14.3l-95.3 29.8c-9.2 2.9-19.1-.3-24.9-8s-6.1-18.1-.8-26.1l41.3-62.7c-5.8-8.6-10.7-17.7-14.7-27.1L15.1 277.4C6 274.2 0 265.6 0 256zm249.2-21.5c-.8 4.3-1.2 8.8-1.2 13.5c0 39.8 32.2 72 72 72s72-32.2 72-72c0-4.6-.4-9.1-1.2-13.5l-.4 .1c-13.6 5.3-27.9 9.2-42.7 11.3c.2 3-.2 6.1-1.4 9.3c-5.5 14.4-13.5 24.4-18.1 29.3c-2.1 2.3-5.1 3.4-8.2 3.4s-6.1-1.1-8.2-3.4c-4.5-4.9-12.6-14.9-18.1-29.3c-1.2-3.2-1.6-6.3-1.4-9.3c-14.8-2.1-29.1-6-42.7-11.3l-.4-.1zM220.1 219c4.9-16.8 25-20.6 41.3-14.1c18.2 7.2 37.9 11.1 58.6 11.1s40.5-3.9 58.6-11.1c16.3-6.4 36.4-2.7 41.3 14.1c2.7 9.2 4.1 18.9 4.1 29c0 57.4-46.6 104-104 104s-104-46.6-104-104c0-10 1.4-19.8 4.1-29z"]
};
var faPeoplePulling = {
  prefix: 'fal',
  iconName: 'people-pulling',
  icon: [576, 512, [], "e535", "M104 56A24 24 0 1 0 56 56a24 24 0 1 0 48 0zM24 56a56 56 0 1 1 112 0A56 56 0 1 1 24 56zm9.5 113.3c-.9 2-1.5 4.3-1.5 6.7V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-26.5 21.5-48 48-48h62.6c16.7 0 32.9 5.2 46.5 14.9l121.7 86.8c11.8-33.4 35.5-61.5 66.9-78.6l12.7-6.9c19.4-10.6 41.2-16.2 63.4-16.2c36.9 0 69.7 23.6 81.4 58.7l17.1 51.4c3.4 10.1 10 18.8 18.9 24.8l29.7 19.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-29.7-19.8c-14.8-9.9-25.9-24.4-31.5-41.3l-8.8-26.4L443.3 331l43.6 37.8c4.7 4.1 8.1 9.4 9.8 15.4l30.7 107.4c2.4 8.5-2.5 17.4-11 19.8s-17.4-2.5-19.8-11L465.9 393 365.4 305.8c-14.4-12.5-20.1-32.4-14.4-50.6l26.6-85c-1.3 .6-2.6 1.3-3.9 2l-12.7 6.9c-27.5 15-47.4 40.8-55 71.2l-2.3 9.2c-.2 1-.5 1.9-.9 2.8c-.8 2-2.1 3.7-3.5 5.1c-3.3 3.2-7.8 4.9-12.5 4.5c-1.9-.2-3.8-.6-5.5-1.5c-1-.5-1.9-1-2.7-1.6L148.2 175.9l75.3 316.4c2 8.6-3.3 17.2-11.9 19.3s-17.2-3.3-19.3-11.9L157.3 352H100.9l26.9 141c1.7 8.7-4 17.1-12.7 18.7s-17.1-4-18.7-12.7L33.5 169.3zm79-5.6c-.3-1.2-.4-2.5-.4-3.7c-.5 0-.9 0-1.4 0H64.3L94.8 320h54.9L112.4 163.7zM480 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 400 56zM381.5 264.8c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 45-130c-10-11.5-24.7-18.4-40.6-18.4c-2.5 0-5 .1-7.5 .3L381.5 264.8zm-6.4 88.9c7.9 4 11.1 13.6 7.2 21.5l-30.8 61.7c-1.5 3.1-3.6 5.9-6 8.3l-62.2 62.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l62.2-62.2 30.8-61.7c4-7.9 13.6-11.1 21.5-7.2z"]
};
var faN = {
  prefix: 'fal',
  iconName: 'n',
  icon: [384, 512, [110], "4e", "M10.5 33c6.3-2.3 13.4-.4 17.7 4.7L352 420.3V48c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 6.7-4.2 12.7-10.5 15s-13.4 .4-17.7-4.7L32 91.7V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-6.7 4.2-12.7 10.5-15z"]
};
var faGarage = {
  prefix: 'fal',
  iconName: 'garage',
  icon: [640, 512, [], "e009", "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224zm32 96H512V224H128v96zm144 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCableCar = {
  prefix: 'fal',
  iconName: 'cable-car',
  icon: [512, 512, [128673, 57551, "tram"], "f7da", "M288 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-72 8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM320 256v96H192V256h48 32 48zm32 0h64c17.7 0 32 14.3 32 32v64H352V256zm96 128v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V384H176 336 448zM64 352V288c0-17.7 14.3-32 32-32h64v96H64zM416 224H272V141.1L499.1 95.7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-240 48-240 48C4.2 162-1.4 170.5 .3 179.1s10.2 14.3 18.8 12.6L240 147.5V224H96c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64z"]
};
var faTram = faCableCar;
var faShovelSnow = {
  prefix: 'fal',
  iconName: 'shovel-snow',
  icon: [512, 512, [], "f7c3", "M419.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L358.9 42.5C344.2 57.1 336 77 336 97.8c0 15.8 4.7 30.5 12.8 42.8L272 217.4l-41.8-41.8c-16.4-16.4-42.3-18.7-61.4-5.5L20.6 273.3C7.7 282.3 0 297 0 312.7v2c0 12.7 5.1 24.9 14.1 33.9L163.3 497.9c9 9 21.2 14.1 33.9 14.1h2c15.7 0 30.4-7.7 39.4-20.6L341.8 343.1c13.3-19.1 11-44.9-5.5-61.4L294.6 240l76.8-76.8c12.3 8.1 27 12.8 42.8 12.8c20.7 0 40.6-8.2 55.3-22.9l37.8-37.8c6.2-6.2 6.2-16.4 0-22.6l-88-88zM381.5 65.1L408 38.6 473.4 104l-26.5 26.5c-8.7 8.7-20.4 13.5-32.7 13.5c-25.5 0-46.2-20.7-46.2-46.2c0-12.3 4.9-24 13.5-32.7zM187.2 196.4c6.4-4.4 15-3.7 20.5 1.8L313.8 304.4c5.5 5.5 6.2 14.1 1.8 20.4L212.4 473.1c-3 4.3-7.9 6.9-13.1 6.9h-2c-4.2 0-8.3-1.7-11.3-4.7L36.7 326.1c-3-3-4.7-7.1-4.7-11.3v-2c0-5.2 2.6-10.1 6.9-13.1L187.2 196.4zm16.2 70.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80zm64 64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80z"]
};
var faCloudRain = {
  prefix: 'fal',
  iconName: 'cloud-rain',
  icon: [512, 512, [127783, 9926], "f73d", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM82.3 451.9L96 426.7l13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1v3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c0-3.2 .8-6.3 2.3-9.1zM54.2 436.6C50.1 444.1 48 452.5 48 461v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9L102.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4 .8L54.2 436.6zm188.1 15.3L256 426.7l13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1v3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c0-3.2 .8-6.3 2.3-9.1zm-28.1-15.3c-4.1 7.5-6.2 15.8-6.2 24.3v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9L262.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4 .8-23.6 43.5zm201.8-10l13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1v3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c0-3.2 .8-6.3 2.3-9.1L416 426.7zm-18.2-33.5l-23.6 43.5c-4.1 7.5-6.2 15.8-6.2 24.3v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9L422.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4 .8z"]
};
var faFaceLying = {
  prefix: 'fal',
  iconName: 'face-lying',
  icon: [512, 512, [], "e37e", "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.8 0 149.8-41.7 189.5-104.5c4.7-7.5 14.6-9.7 22.1-5s9.7 14.6 5 22.1C427.3 464.3 347.2 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C373.8 0 472.9 79.5 502.8 187.7c2.3 8.5-2.6 17.3-11.2 19.7s-17.3-2.6-19.7-11.2C445.8 101.5 359 32 256 32zM152.4 176a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm160 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM188.8 393.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4C180.7 351.1 208.6 336 240 336c13.6 0 26.6 2.8 38.4 8c8.1 3.5 11.8 13 8.3 21.1s-13 11.8-21.1 8.3c-7.8-3.4-16.5-5.3-25.6-5.3c-20.9 0-39.5 10-51.2 25.6zM288 224H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSprinkler = {
  prefix: 'fal',
  iconName: 'sprinkler',
  icon: [512, 512, [], "e035", "M496 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 144A16 16 0 1 1 0 144a16 16 0 1 1 32 0zm128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm192 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm144-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm400 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 272A16 16 0 1 1 0 272a16 16 0 1 1 32 0zM96 80A16 16 0 1 1 64 80a16 16 0 1 1 32 0zM32 16A16 16 0 1 1 0 16a16 16 0 1 1 32 0zM256 64c8.8 0 16 7.2 16 16V256H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-89 89V472c0 22.1-17.9 40-40 40H232c-22.1 0-40-17.9-40-40V385.9l-89-89c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H240V80c0-8.8 7.2-16 16-16zM139.3 288l75.3 75.3c6 6 9.4 14.1 9.4 22.6V472c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V385.9c0-8.5 3.4-16.6 9.4-22.6L372.7 288H256 139.3z"]
};
var faBuildingCircleXmark = {
  prefix: 'fal',
  iconName: 'building-circle-xmark',
  icon: [640, 512, [], "e4d4", "M64 32H320c17.7 0 32 14.3 32 32V266.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm128 80a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-121.4 0l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"]
};
var faPersonSledding = {
  prefix: 'fal',
  iconName: 'person-sledding',
  icon: [512, 512, ["sledding"], "f7cb", "M392 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM1.7 248.8c4-7.9 13.6-11.1 21.5-7.1L419 440.6c14 7 30.3 7.9 44.9 2.4l26.5-10c8.3-3.1 17.5 1.1 20.6 9.3s-1.1 17.5-9.3 20.6l-26.5 10c-23 8.7-48.6 7.3-70.6-3.7L8.8 270.3c-7.9-4-11.1-13.6-7.1-21.5zM160 144H320c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L230.6 272 344 272c13.3 0 24 10.7 24 24v72c0 8.8-7.2 16-16 16s-16-7.2-16-16V304H230.6c-28.5 0-42.8-34.5-22.6-54.6L281.4 176H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSledding = faPersonSledding;
var faGameConsoleHandheld = {
  prefix: 'fal',
  iconName: 'game-console-handheld',
  icon: [384, 512, [], "f8bb", "M64 32C46.3 32 32 46.3 32 64V416c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V64zM96 224H288V96H96V224zM64 80c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16V224c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V80zM208 360a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 304c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H128v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H96V304z"]
};
var faShip = {
  prefix: 'fal',
  iconName: 'ship',
  icon: [576, 512, [128674], "f21a", "M240 0c-26.5 0-48 21.5-48 48V64H144c-26.5 0-48 21.5-48 48V237.3L62.7 248.1C27.9 259.3 18 303.8 44.6 328.8l88.4 82.9c6.4 6 16.6 5.7 22.6-.7s5.7-16.6-.7-22.6L66.5 305.4c-8.9-8.3-5.6-23.1 6-26.9L272 214V384c0 8.8 7.2 16 16 16s16-7.2 16-16V214l199.5 64.5c11.6 3.8 14.9 18.6 6 26.9l-88.4 82.9c-6.4 6-6.8 16.2-.7 22.6s16.2 6.8 22.6 .7l88.4-82.9c26.7-25 16.7-69.4-18.1-80.7L480 237.3V112c0-26.5-21.5-48-48-48H384V48c0-26.5-21.5-48-48-48H240zM352 64H224V48c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16V64zM192 96h16H368h16 48c8.8 0 16 7.2 16 16V226.9L302.8 180c-9.6-3.1-19.9-3.1-29.6 0L128 226.9V112c0-8.8 7.2-16 16-16h48zM133.8 458.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480s-41.7-9.9-58.2-21.2z"]
};
var faClockSixThirty = {
  prefix: 'fal',
  iconName: 'clock-six-thirty',
  icon: [512, 512, [], "e353", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V256c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faBatterySlash = {
  prefix: 'fal',
  iconName: 'battery-slash',
  icon: [640, 512, [], "f377", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM378.8 384H112c-26.5 0-48-21.5-48-48V176c0-12 4.4-22.9 11.7-31.4L50.5 124.8C39 138.7 32 156.5 32 176V336c0 44.2 35.8 80 80 80H419.4l-40.5-32zM464 96H220.6l40.5 32H464c26.5 0 48 21.5 48 48V326l30.7 24.3c.8-4.6 1.3-9.4 1.3-14.3V176c0-44.2-35.8-80-80-80zm128 96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
};
var faTugrikSign = {
  prefix: 'fal',
  iconName: 'tugrik-sign',
  icon: [384, 512, [], "e2ba", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H176V211.5l-115.9 29c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l108.1-27v63l-115.9 29c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l108.1-27V456c0 8.8 7.2 16 16 16s16-7.2 16-16V332.5l115.9-29c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L208 299.5v-63l115.9-29c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L208 203.5V64H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H192 16z"]
};
var faArrowsDownToLine = {
  prefix: 'fal',
  iconName: 'arrows-down-to-line',
  icon: [576, 512, [], "e4b8", "M560 448L16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zm11.3-164.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L464 345.4 464 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 297.4-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112zm-320-22.6c-6.2-6.2-16.4-6.2-22.6 0L144 345.4 144 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 297.4L27.3 260.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faDownload = {
  prefix: 'fal',
  iconName: 'download',
  icon: [512, 512, [], "f019", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V329.4L139.3 228.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4V16zM140.1 320H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H371.9l-32 32H448c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H172.1l-32-32zM432 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faShelves = {
  prefix: 'fal',
  iconName: 'shelves',
  icon: [640, 512, ["inventory"], "f480", "M16 0c8.8 0 16 7.2 16 16V160H608V16c0-8.8 7.2-16 16-16s16 7.2 16 16V176 432v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 176 16C0 7.2 7.2 0 16 0zM32 416H608V192H32V416zM448 32H384V96h64V32zM384 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM128 288v64h64V288H128zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V288zm192 0v64h64V288H288zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V288z"]
};
var faInventory = faShelves;
var faCloudSnow = {
  prefix: 'fal',
  iconName: 'cloud-snow',
  icon: [512, 512, [127784], "f742", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM64 352c-8.8 0-16 7.2-16 16v32l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80V368c0-8.8-7.2-16-16-16zm384 0c-8.8 0-16 7.2-16 16v32l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H464V368c0-8.8-7.2-16-16-16zM272 400c0-8.8-7.2-16-16-16s-16 7.2-16 16v32l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V400z"]
};
var faFaceGrin = {
  prefix: 'fal',
  iconName: 'face-grin',
  icon: [512, 512, [128512, "grin"], "f580", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGrin = faFaceGrin;
var faDeleteLeft = {
  prefix: 'fal',
  iconName: 'delete-left',
  icon: [576, 512, [9003, "backspace"], "f55a", "M544 128c0-17.7-14.3-32-32-32H205.3c-8.5 0-16.6 3.4-22.6 9.4L32 256 182.6 406.6c6 6 14.1 9.4 22.6 9.4H512c17.7 0 32-14.3 32-32V128zM512 64c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H205.3c-17 0-33.3-6.7-45.3-18.7L9.4 278.6c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6L160 82.7c12-12 28.3-18.7 45.3-18.7H512zM427.3 180.7c6.2 6.2 6.2 16.4 0 22.6L374.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L352 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faBackspace = faDeleteLeft;
var faOven = {
  prefix: 'fal',
  iconName: 'oven',
  icon: [448, 512, [], "e01d", "M96 32C60.7 32 32 60.7 32 96v64H416V96c0-35.3-28.7-64-64-64H96zM32 192V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192H32zM0 96C0 43 43 0 96 0H352c53 0 96 43 96 96V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM264 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 256V416H352V256H96zm-32 0c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zm64 48c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16z"]
};
var faCloudBinary = {
  prefix: 'fal',
  iconName: 'cloud-binary',
  icon: [640, 512, [], "e601", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM176 216c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40H216c-22.1 0-40-17.9-40-40V216zm40-8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V216c0-4.4-3.6-8-8-8H216zm72-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c-8.8 0-16-7.2-16-16zm120-16h16c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40H408c-22.1 0-40-17.9-40-40V216c0-22.1 17.9-40 40-40zm-8 40v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V216c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8zM192 320c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c-8.8 0-16-7.2-16-16zm80 24c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40H312c-22.1 0-40-17.9-40-40V344zm40-8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V344c0-4.4-3.6-8-8-8H312zm88-32h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faEyeDropper = {
  prefix: 'fal',
  iconName: 'eye-dropper',
  icon: [512, 512, ["eye-dropper-empty", "eyedropper"], "f1fb", "M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l0 0-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4 0 0 0 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 62.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6v41.2L3.8 469.1C1.3 473.5 0 478.4 0 483.4C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480h41.2c21.2 0 41.6-8.4 56.6-23.4L299.3 347.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L167.4 433.9c-9 9-21.2 14.1-33.9 14.1H88 83.8l-3.7 2.1L37.7 474.3l24.2-42.4 2.1-3.7V424 378.5c0-12.7 5.1-24.9 14.1-33.9L187.3 235.3z"]
};
var faEyeDropperEmpty = faEyeDropper;
var faEyedropper = faEyeDropper;
var faCommentCaptions = {
  prefix: 'fal',
  iconName: 'comment-captions',
  icon: [512, 512, [], "e146", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm288 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zM112 288c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"]
};
var faCommentsQuestion = {
  prefix: 'fal',
  iconName: 'comments-question',
  icon: [640, 512, [], "e14e", "M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6c4.8 5 5.8 12.5 2.5 18.6c-10.9 20.2-22.7 40.8-37.6 59.9c31.3-3 63.2-13.2 91.5-26c6-2.7 11.9-5.6 18-8.7c3.2-1.6 6.8-2.1 10.2-1.4c15.6 3.1 30.9 5 46.3 5c102.3 0 176-69.2 176-144s-73.7-144-176-144zM0 176C0 78.9 93.1 0 208 0S416 78.9 416 176s-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6c-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.7-2-18.9 4.4-25.8l.1-.1 0 0C22 326.6 34.3 307.1 46 286C19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110c11.7 21 24 40.6 39.5 57.5l0 0 .1 .1c6.5 7 8.2 17.1 4.4 25.8c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.9-2.2-9.6-4.5-14.3-6.8c-15.3 2.8-30.9 4.6-47 4.6c-82.1 0-153-40.2-186.8-98.5c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c15.3 0 30.6-1.9 46.3-5c3.5-.7 7.1-.2 10.2 1.4c6.1 3.1 12 6 18 8.7c28.4 12.9 60.2 23.1 91.5 26c-14.9-19-26.8-39.7-37.6-59.9c-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3zM147.9 104.1c5.5-15.4 20.1-25.7 36.4-25.7h41.3c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 173.4v.3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7H184.3c-2.8 0-5.3 1.8-6.3 4.4l-.3 .9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 236a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1 -45.3 0z"]
};
var faScribble = {
  prefix: 'fal',
  iconName: 'scribble',
  icon: [512, 512, [], "e23f", "M196.6 19.5C210.2 7 228 0 246.5 0h.9C287.5 0 320 32.5 320 72.6c0 19.2-7.6 37.7-21.3 51.3L75.9 346.7C68.3 354.4 64 364.7 64 375.4c0 22.4 18.2 40.6 40.6 40.6c10.8 0 21.1-4.3 28.7-11.9L388.1 149.3c13.6-13.6 32.1-21.3 51.3-21.3c40.1 0 72.6 32.5 72.6 72.6c0 19.2-7.6 37.7-21.3 51.3L370.5 372.1c-11.8 11.8-18.5 28-18.5 44.8c0 34.8 28.2 63.1 63 63.1c8.7 0 17.3-2 25.1-5.9l48.8-24.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48.8 24.4c-12.2 6.1-25.8 9.3-39.4 9.3c-52.5 0-95-42.7-95-95.1c0-25.2 10-49.5 27.9-67.4L468.1 229.3c7.6-7.6 11.9-17.9 11.9-28.7c0-22.4-18.2-40.6-40.6-40.6c-10.8 0-21.1 4.3-28.7 11.9L155.9 426.7c-13.6 13.6-32.1 21.3-51.3 21.3C64.5 448 32 415.5 32 375.4c0-19.2 7.6-37.7 21.3-51.3L276.1 101.3c7.6-7.6 11.9-17.9 11.9-28.7C288 50.2 269.8 32 247.4 32h-.9c-10.4 0-20.5 3.9-28.2 11L26.9 219.8c-6.5 6-16.6 5.6-22.6-.9s-5.6-16.6 .9-22.6L196.6 19.5z"]
};
var faRotateExclamation = {
  prefix: 'fal',
  iconName: 'rotate-exclamation',
  icon: [512, 512, [], "e23c", "M403.5 133.1C368.3 90.9 315.3 64 256 64C165.2 64 89.1 127 69.1 211.7c-2 8.6-10.6 13.9-19.2 11.9s-13.9-10.6-11.9-19.2C61.3 105.5 150.1 32 256 32c69.2 0 131 31.4 172.1 80.6L464 154.9V96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16s7.2-16 16-16h55.9l-36.3-42.8 0 0-.1-.1zM272 144V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zM256 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 432c-8.8 0-16-7.2-16-16V320c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H72.1l36.3 42.8 0 0 .1 .1C143.7 421.1 196.7 448 256 448c90.8 0 166.9-63 186.9-147.7c2-8.6 10.7-13.9 19.3-11.9s13.9 10.6 11.9 19.2C450.7 406.5 361.9 480 256 480c-69.2 0-131-31.4-172.1-80.6L48 357.1V416c0 8.8-7.2 16-16 16z"]
};
var faFileCircleCheck = {
  prefix: 'fal',
  iconName: 'file-circle-check',
  icon: [576, 512, [], "e5a0", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faGlass = {
  prefix: 'fal',
  iconName: 'glass',
  icon: [384, 512, [129371], "f804", "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7H343.8c4.7 0 8.4 4 8 8.7L347.1 96H36.8L32.1 40.7zM39.5 128h305L317.2 450.7C315.8 467.3 302 480 285.4 480H98.6c-16.6 0-30.5-12.7-31.9-29.3L39.5 128zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512H285.4c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1z"]
};
var faLoader = {
  prefix: 'fal',
  iconName: 'loader',
  icon: [512, 512, [], "e1d4", "M272 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 384v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-8.8 7.2-16 16-16s16 7.2 16 16zM0 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm400-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16zM437 75c6.2 6.2 6.2 16.4 0 22.6l-67.9 67.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L414.4 75c6.2-6.2 16.4-6.2 22.6 0zM165.5 369.1L97.6 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l67.9-67.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM75 75c6.2-6.2 16.4-6.2 22.6 0l67.9 67.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L75 97.6c-6.2-6.2-6.2-16.4 0-22.6zM369.1 346.5L437 414.4c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-67.9-67.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faForward = {
  prefix: 'fal',
  iconName: 'forward',
  icon: [512, 512, [9193], "f04e", "M474.4 256L256 414.1V97.9L474.4 256zM254 64c-16.6 0-30 13.5-30 30V197.4L47.7 69.7C42.5 66 36.4 64 30 64C13.5 64 0 77.5 0 94V418c0 16.6 13.5 30 30 30c6.3 0 12.5-2 17.6-5.7L224 314.6V418c0 16.6 13.5 30 30 30c6.3 0 12.5-2 17.6-5.7L502.1 275.4c6.2-4.5 9.9-11.7 9.9-19.4s-3.7-14.9-9.9-19.4L271.7 69.7C266.5 66 260.4 64 254 64zM224 275.1L32 414.1V97.9l192 139v38.2z"]
};
var faUserPilot = {
  prefix: 'fal',
  iconName: 'user-pilot',
  icon: [448, 512, [], "e2c0", "M230.9 .8c-4.6-1-9.3-1-13.9 0l-144 32C61.7 35.3 52.5 43.8 49.3 55.1s-.2 23.3 8.1 31.6L80 109.3v1.6c0 15.6 7.6 31.8 23.2 40.1c22.5 12 59.5 25 120.8 25s98.3-13.1 120.8-25c15.5-8.2 23.2-24.5 23.2-40.1v-1.6l22.6-22.6-6.2-6.2 6.2 6.2c8.3-8.3 11.4-20.4 8.1-31.6s-12.4-19.8-23.8-22.3l-144-32zM80 64L224 32 368 64 340.7 91.3c-3 3-4.7 7.1-4.7 11.3v8.2c0 5.8-2.8 10-6.2 11.8C312.2 132 280.4 144 224 144s-88.2-12-105.8-21.3c-3.4-1.8-6.2-6-6.2-11.8v-8.2c0-4.2-1.7-8.3-4.7-11.3L80 64zm41.5 320.8l70.9 62.1c18.1 15.8 45.1 15.8 63.2 0l70.9-62.1c48.4 6.1 86.2 45.9 89.3 95.2H32.2c3-49.3 40.9-89.1 89.3-95.2zm15.7-28.8c-3-2.6-6.8-4.1-10.7-3.8C55.9 356.3 0 414.8 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6c0-71.6-55.9-130.1-126.5-134.2c-3.9-.2-7.8 1.2-10.7 3.8l-76.3 66.7c-6 5.3-15 5.3-21.1 0l-76.3-66.7zM304 432c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.9-.1-5.8-.3-8.7c-9.1 4.3-19.6 8.5-31.8 12.1C318.1 246.9 275.9 288 224 288s-94.1-41.1-95.9-92.6c-12.2-3.6-22.7-7.8-31.8-12.1c-.2 2.9-.3 5.8-.3 8.7zM183.2 65.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1 183.2 65.7z"]
};
var faMobile = {
  prefix: 'fal',
  iconName: 'mobile',
  icon: [384, 512, [128241, "mobile-android", "mobile-phone"], "f3ce", "M96 32C78.3 32 64 46.3 64 64V448c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H96zM32 64C32 28.7 60.7 0 96 0H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM160 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMobileAndroid = faMobile;
var faMobilePhone = faMobile;
var faCodePullRequestClosed = {
  prefix: 'fal',
  iconName: 'code-pull-request-closed',
  icon: [512, 512, [], "e3f9", "M160 80A48 48 0 1 0 64 80a48 48 0 1 0 96 0zm32 0c0 38.7-27.5 71-64 78.4V353.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V158.4C59.5 151 32 118.7 32 80C32 35.8 67.8 0 112 0s80 35.8 80 80zM64 432a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm336 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM384 353.6V208c0-8.8 7.2-16 16-16s16 7.2 16 16V353.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4zM332.7 12.7c6.2-6.2 16.4-6.2 22.6 0L400 57.4l44.7-44.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L422.6 80l44.7 44.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L400 102.6l-44.7 44.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L377.4 80 332.7 35.3c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faFaceMeh = {
  prefix: 'fal',
  iconName: 'face-meh',
  icon: [512, 512, [128528, "meh"], "f11a", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 336c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faMeh = faFaceMeh;
var faAlignCenter = {
  prefix: 'fal',
  iconName: 'align-center',
  icon: [448, 512, [], "f037", "M112 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM96 320c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faBookSkull = {
  prefix: 'fal',
  iconName: 'book-skull',
  icon: [448, 512, ["book-dead"], "f6b7", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM240 96c-38.9 0-64 24.6-64 48c0 14.1 8.4 28 24.2 37.5c4.8 2.9 7.8 8.1 7.8 13.7V208h64V195.2c0-5.6 2.9-10.8 7.8-13.7C295.6 172 304 158.1 304 144c0-23.4-25.1-48-64-48zm-96 48c0-47.3 46.5-80 96-80s96 32.7 96 80c0 24.6-13 45.6-32 59.7V216c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V203.7c-19-14.1-32-35.1-32-59.7zm56 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM129.2 249.8c3.4-8.2 12.8-12 20.9-8.6L240 278.7l89.8-37.4c8.2-3.4 17.5 .5 20.9 8.6s-.5 17.5-8.6 20.9L281.6 296l60.6 25.2c8.2 3.4 12 12.8 8.6 20.9s-12.8 12-20.9 8.6L240 313.3l-89.8 37.4c-8.2 3.4-17.5-.5-20.9-8.6s.5-17.5 8.6-20.9L198.4 296l-60.6-25.2c-8.2-3.4-12-12.8-8.6-20.9z"]
};
var faBookDead = faBookSkull;
var faIdCard = {
  prefix: 'fal',
  iconName: 'id-card',
  icon: [576, 512, [62147, "drivers-license"], "f2c2", "M64 64C46.3 64 32 78.3 32 96l512 0c0-17.7-14.3-32-32-32H64zM0 112V96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64v16V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V112zm544 16H32V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM160 352c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48H160zM336 208c0-8.8 7.2-16 16-16H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16z"]
};
var faDriversLicense = faIdCard;
var faFaceDotted = {
  prefix: 'fal',
  iconName: 'face-dotted',
  icon: [512, 512, [129765], "e47f", "M256 0c-17.1 0-33.8 1.7-49.9 4.9c-8.7 1.7-14.3 10.1-12.6 18.8s10.1 14.3 18.8 12.6C226.4 33.5 241 32 256 32s29.6 1.5 43.7 4.3c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8C289.8 1.7 273.1 0 256 0zM398.2 43.1c-7.3-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2c24.4 16.4 45.5 37.4 61.8 61.8c4.9 7.3 14.9 9.3 22.2 4.4s9.3-14.9 4.4-22.2c-18.7-27.9-42.7-51.9-70.6-70.6zM131.6 69.7c7.3-4.9 9.3-14.9 4.4-22.2s-14.9-9.3-22.2-4.4C85.8 61.8 61.8 85.8 43.1 113.8c-4.9 7.3-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4c16.4-24.4 37.4-45.5 61.8-61.8zM36.3 212.3c1.7-8.7-3.9-17.1-12.6-18.8s-17.1 3.9-18.8 12.6C1.7 222.2 0 238.9 0 256s1.7 33.8 4.9 49.9c1.7 8.7 10.1 14.3 18.8 12.6s14.3-10.1 12.6-18.8C33.5 285.6 32 271 32 256s1.5-29.6 4.3-43.7zm470.9-6.2c-1.7-8.7-10.1-14.3-18.8-12.6s-14.3 10.1-12.6 18.8c2.8 14.1 4.3 28.8 4.3 43.7s-1.5 29.6-4.3 43.7c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6c3.2-16.2 4.9-32.9 4.9-49.9s-1.7-33.8-4.9-49.9zM69.7 380.4c-4.9-7.3-14.9-9.3-22.2-4.4s-9.3 14.9-4.4 22.2c18.7 27.9 42.7 51.9 70.6 70.6c7.3 4.9 17.3 3 22.2-4.4s2.9-17.3-4.4-22.2c-24.4-16.4-45.5-37.4-61.8-61.8zm399.2 17.8c4.9-7.3 3-17.3-4.4-22.2s-17.3-2.9-22.2 4.4c-16.4 24.4-37.4 45.5-61.8 61.8c-7.3 4.9-9.3 14.9-4.4 22.2s14.9 9.3 22.2 4.4c27.9-18.7 51.9-42.7 70.6-70.6zM212.3 475.7c-8.7-1.7-17.1 3.9-18.8 12.6s3.9 17.1 12.6 18.8c16.2 3.2 32.9 4.9 49.9 4.9s33.8-1.7 49.9-4.9c8.7-1.7 14.3-10.1 12.6-18.8s-10.1-14.3-18.8-12.6C285.6 478.5 271 480 256 480s-29.6-1.5-43.7-4.3zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM184 336c-8.8 0-16 7.2-16 16s7.2 16 16 16H328c8.8 0 16-7.2 16-16s-7.2-16-16-16H184z"]
};
var faFaceWorried = {
  prefix: 'fal',
  iconName: 'face-worried',
  icon: [512, 512, [], "e3a3", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM308.9 429.8c-16.2-6.1-34-9.4-52.9-9.4c-18.8 0-36.7 3.4-52.9 9.4c-11.2 4.2-23.6 2.3-32.4-4.5c-4.5-3.5-8.4-8.6-10-15.1c-1.6-6.7-.5-13.5 2.7-19.5C180.9 358 215.9 336 256 336c40.1 0 75.2 22.1 92.5 54.7c3.2 6 4.3 12.8 2.7 19.5c-1.6 6.5-5.5 11.6-10 15.1c-8.8 6.8-21.2 8.7-32.4 4.5zM256 368c-24.9 0-46.7 12.1-59.6 30.2c18.5-6.4 38.6-9.8 59.6-9.8c21 0 41.1 3.5 59.6 9.9C302.7 380 280.9 368 256 368zM152.4 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faOutdent = {
  prefix: 'fal',
  iconName: 'outdent',
  icon: [448, 512, ["dedent"], "f03b", "M0 64c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 48 0 55.2 0 64zM192 192c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zM0 448c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM96 211.8v88.4L42.3 256 96 211.8zM7 243.6C-.8 250-.8 262 7 268.4l94.8 78.1c10.4 8.6 26.2 1.2 26.2-12.4V177.9c0-13.5-15.7-20.9-26.2-12.4L7 243.6z"]
};
var faDedent = faOutdent;
var faHeartCircleExclamation = {
  prefix: 'fal',
  iconName: 'heart-circle-exclamation',
  icon: [576, 512, [], "e4fe", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faHouse = {
  prefix: 'fal',
  iconName: 'house',
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H368V320c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32V480H144c-26.5 0-48-21.5-48-48zm144 48V320h96V480H240z"]
};
var faHome = faHouse;
var faHomeAlt = faHouse;
var faHomeLgAlt = faHouse;
var faVectorCircle = {
  prefix: 'fal',
  iconName: 'vector-circle',
  icon: [512, 512, [], "e2c6", "M280 32c4.4 0 8 3.6 8 8l0 10.4V82.9l0 5.1c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8V40c0-4.4 3.6-8 8-8h48zm40 26V40c0-22.1-17.9-40-40-40H232c-22.1 0-40 17.9-40 40V58C128.6 78.5 78.5 128.6 58 192H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H58c20.5 63.4 70.6 113.5 134 134v18c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V454c63.4-20.5 113.5-70.6 134-134h18c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H454C433.5 128.6 383.4 78.5 320 58zm-.2 33.9c45.9 17.9 82.4 54.4 100.3 100.3c-20.2 2-36.1 19-36.1 39.8v48c0 20.8 15.8 37.8 36.1 39.8c-17.9 45.9-54.4 82.4-100.3 100.3c-2-20.2-19-36.1-39.8-36.1H232c-20.8 0-37.8 15.8-39.8 36.1c-45.9-17.9-82.4-54.4-100.3-100.3c20.2-2 36.1-19 36.1-39.8V232c0-20.8-15.8-37.8-36.1-39.8c17.9-45.9 54.4-82.4 100.3-100.3c2 20.2 19 36.1 39.8 36.1h48c20.8 0 37.8-15.8 39.8-36.1zM429.1 224s0 0 0 0h32.5s0 0 0 0H472c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8h5.1zM288 429.1v32.5l0 10.4c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8V424c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8l0 5.1zM50.4 224s0 0 0 0H82.9s0 0 0 0H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8H50.4z"]
};
var faCarCircleBolt = {
  prefix: 'fal',
  iconName: 'car-circle-bolt',
  icon: [640, 512, [], "e342", "M113.6 98.2c6.1-20.3 24.8-34.2 46-34.2H352.4c21.2 0 39.9 13.9 46 34.2l28.3 94.4c-3.5-.4-7.1-.6-10.7-.6H96c-3.6 0-7.2 .2-10.7 .6l28.3-94.4zM74.3 227.8l.5 .1 .1-.3c6.6-2.3 13.8-3.6 21.2-3.6H394.8c19.5-13.7 41.9-23.6 66.2-28.5L429 89c-10.2-33.8-41.3-57-76.6-57H159.6C124.3 32 93.1 55.2 83 89L48.7 203.4l-.4 1.3C19.4 221.2 0 252.3 0 288v96 16 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V416H326.6c-2.9-10.3-4.9-21-5.9-32H32V288c0-27.7 17.6-51.3 42.3-60.2zM104 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280 48a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-96.1-81c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H516.4l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
var faCalendarWeek = {
  prefix: 'fal',
  iconName: 'calendar-week',
  icon: [448, 512, [], "f784", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zm40 160H344c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V264c0-4.4 3.6-8 8-8zm-40 8v80c0 22.1 17.9 40 40 40H344c22.1 0 40-17.9 40-40V264c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z"]
};
var faFlyingDisc = {
  prefix: 'fal',
  iconName: 'flying-disc',
  icon: [448, 512, [], "e3a9", "M401.7 78.3c14.5 14.5 21.3 46 4.4 96.7c-16.2 48.7-52 105.9-104.6 158.5S191.8 421.9 143.1 438.1c-50.8 16.9-82.3 10-96.7-4.4c-12.1-12.1-18.9-36.1-10.9-73.4c3 5.8 7 11.5 12.3 16.8c20 20 45.9 21.8 63.4 19.8c18.1-2 36.3-8.8 52.8-17c33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8c2-17.5 .2-43.4-19.8-63.4c-5.3-5.3-11-9.3-16.8-12.3c37.2-8 61.3-1.2 73.4 10.9zM105.1 175.5C8.3 282-28.4 404.2 23.7 456.3C79 511.6 213.5 466.8 324.1 356.2S479.6 111 424.3 55.7C372.2 3.6 250 40.3 143.6 137c-6.7 6-13.3 12.3-19.8 18.8c-6.5 6.5-12.8 13.1-18.7 19.7zM128.8 197c5.7-6.2 11.5-12.4 17.6-18.5c6.1-6.1 12.3-12 18.5-17.7c26.8-24.2 54-43.2 78.1-55.2c14.8-7.3 29.2-12.4 42.2-13.9c13-1.5 27 .5 37.2 10.6s12.1 24.2 10.6 37.2c-1.5 13-6.5 27.4-13.9 42.2c-14.7 29.7-40.3 64.1-72.8 96.7s-67 58.1-96.7 72.8c-14.8 7.3-29.2 12.4-42.2 13.9c-13 1.5-27-.5-37.2-10.6s-12.1-24.2-10.6-37.2c1.5-13 6.5-27.4 13.9-42.2c12-24.1 31-51.3 55.2-78.1z"]
};
var faLaptopMedical = {
  prefix: 'fal',
  iconName: 'laptop-medical',
  icon: [640, 512, [], "f812", "M128 64H512c17.7 0 32 14.3 32 32V352h32V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V352H96V96c0-17.7 14.3-32 32-32zM33.9 416H606.1c-5.5 18.5-22.6 32-42.9 32H76.8c-20.3 0-37.4-13.5-42.9-32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2zM304 112c-17.7 0-32 14.3-32 32v32H240c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V272h32c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32H368V144c0-17.7-14.3-32-32-32H304zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H352c-8.8 0-16 7.2-16 16v48H304V256c0-8.8-7.2-16-16-16H240V208h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V144z"]
};
var faSquareDownRight = {
  prefix: 'fal',
  iconName: 'square-down-right',
  icon: [448, 512, [], "e26c", "M384 448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384zm64-32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416zM304 328V214.6c0-3.7-3-6.6-6.6-6.6c-1.8 0-3.4 .7-4.7 1.9l-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0l-59.1-59.1c-3.6-3.6-9-4.9-13.9-3.3c-2 .7-3.8 1.8-5.3 3.3l-22.1 22.1c-1.5 1.5-2.6 3.3-3.3 5.3c-1.6 4.9-.4 10.3 3.3 13.9l59.1 59.1c6.2 6.2 6.2 16.4 0 22.6l-25.4 25.4c-1.2 1.2-1.9 2.9-1.9 4.7c0 3.7 3 6.6 6.6 6.6H296c4.4 0 8-3.6 8-8zm-8 40H182.6c-21.3 0-38.6-17.3-38.6-38.6c0-10.2 4.1-20.1 11.3-27.3L169.4 288l-47.7-47.7c-12.2-12.2-16.5-30.3-11-46.7c2.2-6.7 6-12.8 11-17.8l22.1-22.1c5-5 11.1-8.8 17.8-11c16.4-5.5 34.5-1.2 46.7 11L256 201.4l14.1-14.1c7.2-7.2 17.1-11.3 27.3-11.3c21.3 0 38.6 17.3 38.6 38.6V328c0 22.1-17.9 40-40 40z"]
};
var faB = {
  prefix: 'fal',
  iconName: 'b',
  icon: [320, 512, [98], "42", "M48 32C21.5 32 0 53.5 0 80V240 432c0 26.5 21.5 48 48 48H192c70.7 0 128-57.3 128-128c0-52.8-32-98.2-77.7-117.7C270 213.9 288 181 288 144c0-61.9-50.1-112-112-112H48zM192 256c53 0 96 43 96 96s-43 96-96 96H48c-8.8 0-16-7.2-16-16V256H176h16zm-16-32H32V80c0-8.8 7.2-16 16-16H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
var faSeatAirline = {
  prefix: 'fal',
  iconName: 'seat-airline',
  icon: [448, 512, [], "e244", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V142.3c0 14 3.1 27.9 9 40.6l87.3 187C109.4 398 137.7 416 168.8 416H224v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V416H358.2c27 0 51.2-17 60.3-42.5l28.6-80.1c1.8-4.9 1-10.3-2-14.6s-7.9-6.8-13.1-6.8H85.9L63.5 224H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H48.6L38 169.3c-4-8.5-6-17.7-6-27.1V16zM240 384H168.8c-18.6 0-35.6-10.8-43.5-27.7L100.9 304H409.3l-21 58.8c-4.6 12.7-16.6 21.2-30.1 21.2H240z"]
};
var faMoonOverSun = {
  prefix: 'fal',
  iconName: 'moon-over-sun',
  icon: [512, 512, ["eclipse-alt"], "f74a", "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zM265.1 97.7l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-3.8 5.5-3.8 12.7 0 18.2l54.5 79.1-94.5 17.4c-6.5 1.2-11.6 6.3-12.8 12.8l-17.4 94.5-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0zM174.2 256c0-43.2 33.9-78.7 77-81.6c-19.3 15.2-31.7 38.7-31.7 65.1c0 46 37.6 83.2 83.9 83.2l1.2 0c-13.5 9.5-30 15.1-47.8 15.1c-45.7 0-82.6-36.6-82.6-81.8zm82.6-113.8c-63 0-114.6 50.7-114.6 113.8s51.6 113.8 114.6 113.8c31 0 59.1-12.2 79.8-32.1c8.9-8.5 11.1-21.8 5.6-32.8s-17.6-17-29.7-15c-2.9 .5-5.9 .8-9 .8c-28.9 0-51.9-23.2-51.9-51.2c0-18.9 10.5-35.6 26.3-44.5c10.7-6 16.3-18.3 13.7-30.4s-12.8-20.9-25-22c-3.2-.3-6.4-.4-9.7-.4z"]
};
var faEclipseAlt = faMoonOverSun;
var faPipe = {
  prefix: 'fal',
  iconName: 'pipe',
  icon: [64, 512, [], "7c", "M32 0c8.8 0 16 7.2 16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V16C16 7.2 23.2 0 32 0z"]
};
var faFileMedical = {
  prefix: 'fal',
  iconName: 'file-medical',
  icon: [384, 512, [], "f477", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM176 224c-17.7 0-32 14.3-32 32v32H112c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384h32c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H240V256c0-17.7-14.3-32-32-32H176zm0 80V256h32v48c0 8.8 7.2 16 16 16h48v32H224c-8.8 0-16 7.2-16 16v48H176V368c0-8.8-7.2-16-16-16H112V320h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z"]
};
var faPotato = {
  prefix: 'fal',
  iconName: 'potato',
  icon: [512, 512, [129364], "e440", "M480 144c0-61.9-50.1-112-112-112c-31 0-59 12.5-79.3 32.9c-29.6 29.7-65.7 56.7-102.4 76.8c-18.8 10.3-34.3 25.8-44.6 44.6C121.6 223 94.6 259.1 64.9 288.7C44.5 309 32 337 32 368c0 61.9 50.1 112 112 112c23.6 0 45.4-7.3 63.4-19.6c30.5-21 65.4-38.4 100.4-50.2c34.4-11.6 62.4-39.6 72.4-77.2c10.7-39.9 34.1-78.9 64.3-107.2C466.4 205.3 480 176.3 480 144zm32 0c0 41.5-17.6 78.9-45.7 105.2c-25.8 24.2-46.1 57.9-55.2 92.1c-12.9 48.3-49 84.3-93.1 99.2c-32.3 10.9-64.4 26.9-92.5 46.2C202.4 502.7 174.3 512 144 512C64.5 512 0 447.5 0 368c0-39.8 16.2-75.9 42.3-102C69.8 238.6 95 205 113.6 170.9c13.2-24.1 33.1-44 57.3-57.3C205 95 238.6 69.8 266 42.3C292.1 16.2 328.2 0 368 0c79.5 0 144 64.5 144 144zM180 264a20 20 0 1 1 0-40 20 20 0 1 1 0 40zM168 396a20 20 0 1 1 -40 0 20 20 0 1 1 40 0zM364 200a20 20 0 1 1 0-40 20 20 0 1 1 0 40z"]
};
var faDiceOne = {
  prefix: 'fal',
  iconName: 'dice-one',
  icon: [448, 512, [9856], "f525", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCircleA = {
  prefix: 'fal',
  iconName: 'circle-a',
  icon: [512, 512, [], "e0f7", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c-6.1 0-11.6 3.4-14.3 8.8l-112 224c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L185.9 304H326.1l27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-112-224c-2.7-5.4-8.3-8.8-14.3-8.8zm0 51.8L310.1 272H201.9L256 163.8z"]
};
var faHelmetBattle = {
  prefix: 'fal',
  iconName: 'helmet-battle',
  icon: [576, 512, [], "f6eb", "M84.4 .6C75.9-1.8 67 3.1 64.6 11.6l-53 185.5C3.2 226.6 25.3 256 56 256c8.8 0 16-7.2 16-16s-7.2-16-16-16c-9.4 0-16.2-9-13.6-18.1l53-185.5C97.8 11.9 92.9 3 84.4 .6zM295.7 2c-4.8-2.6-10.6-2.6-15.4 0L288 16l7.7-14zM511.5 403.9l0 0 0 0 0-.1-.1-.2-.3-1c-.2-.9-.6-2.2-1-3.9c-.9-3.4-2.1-8.3-3.6-14.5c-3-12.3-6.9-29.6-10.9-49.4c-8-39.8-15.7-88.5-15.7-126.9c0-28.6-13.1-55.9-30.6-79.6c-17.6-24-40.7-45.9-63.2-64.4c-22.6-18.6-45.2-34-62-44.8c-8.4-5.4-15.5-9.7-20.4-12.6c-2.5-1.5-4.4-2.6-5.8-3.4l-1.6-.9-.4-.2-.1-.1 0 0 0 0s0 0-7.7 14c-7.7-14-7.7-14-7.7-14l0 0 0 0-.1 .1-.4 .2-1.6 .9c-1.4 .8-3.3 1.9-5.8 3.4c-5 2.9-12 7.2-20.4 12.6c-16.8 10.8-39.4 26.2-62 44.8c-22.5 18.5-45.7 40.5-63.2 64.4C109.1 152.1 96 179.4 96 208c0 38.3-7.7 87.1-15.7 126.9c-4 19.8-7.9 37.1-10.9 49.4c-1.5 6.2-2.7 11.1-3.6 14.5c-.4 1.7-.8 3-1 3.9l-.3 1-.1 .2 0 .1 0 0 0 0 0 0c-1.9 7.2 1.4 14.8 8 18.3l166.9 87.4c2.6 1.4 5.5 2.2 8.5 2.5c13 1.1 24.1-9.1 24.1-22.1V285.1c0-15.3-10.8-28.4-25.7-31.4l-45.9-9.2c-4.9-1-8.3-5.2-8.3-10.2c0-5.7 4.6-10.4 10.4-10.4H373.6c5.7 0 10.4 4.6 10.4 10.4c0 4.9-3.5 9.2-8.3 10.2l-45.9 9.2c-15 3-25.7 16.1-25.7 31.4V489.9c0 13 11.1 23.2 24.1 22.1c3-.2 5.8-1.1 8.5-2.5l166.9-87.4c6.6-3.5 10-11.1 8-18.3l0 0zm-34.1-4.2L336 473.7V285.1l45.9-9.2c19.8-4 34.1-21.4 34.1-41.6c0-23.4-19-42.4-42.4-42.4H202.4C179 192 160 211 160 234.4c0 20.2 14.3 37.6 34.1 41.6l45.9 9.2V473.7L98.6 399.7c.6-2.4 1.2-5 1.9-8c3-12.6 7.1-30.4 11.1-50.6c8-40.2 16.3-91.5 16.3-133.1c0-19 8.9-39.5 24.4-60.7c15.4-21 36.3-41 57.8-58.6c21.4-17.5 42.8-32.2 59-42.6c7.7-5 14.2-8.9 18.9-11.6c4.6 2.7 11.1 6.7 18.9 11.6c16.2 10.3 37.6 25 59 42.6c21.4 17.6 42.3 37.7 57.8 58.6C439.1 168.5 448 189 448 208c0 41.7 8.3 92.9 16.3 133.1c4 20.2 8.1 37.9 11.1 50.6c.7 2.9 1.4 5.6 1.9 8zm34-388.1C509 3.1 500.1-1.8 491.6 .6s-13.4 11.3-11 19.8l53 185.5c2.6 9.1-4.2 18.1-13.6 18.1c-8.8 0-16 7.2-16 16s7.2 16 16 16c30.7 0 52.8-29.4 44.4-58.9l-53-185.5z"]
};
var faButter = {
  prefix: 'fal',
  iconName: 'butter',
  icon: [640, 512, [129480], "e3e4", "M480 96V288H448V96H128c-17.7 0-32 14.3-32 32V288H64V128c0-35.3 28.7-64 64-64H448h16 16 32c35.3 0 64 28.7 64 64V288H544V128c0-17.7-14.3-32-32-32H480zM0 336c0-8.8 7.2-16 16-16H32 64 576h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V352H16c-8.8 0-16-7.2-16-16zm64 16v48c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16V352H64z"]
};
var faBlanketFire = {
  prefix: 'fal',
  iconName: 'blanket-fire',
  icon: [640, 512, [], "e3da", "M32 96c0-35.3 28.7-64 64-64H352c35.3 0 64 28.7 64 64v41c9.4-6.9 20.9-9.8 32-8.8V96c0-53-43-96-96-96H96C43 0 0 43 0 96V352c0 53 43 96 96 96H314.4c-5.9-10.1-10.9-20.9-14.9-32H96c-35.3 0-64-28.7-64-64s28.7-64 64-64H301.8c4.4-10.9 9.7-21.6 15.5-32H96c-24.6 0-47 9.2-64 24.4V96zM288 350.1c0-4.6 .3-9.3 .8-14.1H96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288.8c-.5-5.9-.8-11.9-.8-17.9zm221.4-96.6c9.6-.1 18.7-4.5 24.7-12.1c3.9-4.9 7.8-9.6 11.6-14c16.4 17.8 30.9 39.4 41.8 60.5C601 314 608 339.4 608 352.2C608 422.4 551 480 480 480c-71.8 0-128-57.5-128-127.8c0-17.9 9.4-46.2 27.6-75.8c15.9-25.8 37.9-53.1 64-78.1c14.3 13.7 27.9 28.3 40.8 43.7c6.2 7.4 15.3 11.6 25 11.5zm-21.8-56.4c-10.9-11.6-22.2-22.8-34-33.4c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-1.8 1.6-3.5 3.3-5.2 5c-7.7 7.7-14.8 16.4-21.2 24.5c-7-8.4-14.1-16.5-21.5-24.4zM445.1 256c-4.8 0-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C389 324.3 384 338.3 384 354c0 28.7 10.7 52.6 28.8 69.2c18 16.5 42.3 24.8 68.2 24.8c21.3 0 40.3-6 57.9-17.7l0 0 .3-.2c37.3-26.1 46.3-77.2 25-116.5l0-.1c-1.9-3.9-4.5-9-8.3-14.1c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5c-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5C508.6 412 495.7 416 481 416c-19.1 0-35.3-6.1-46.6-16.4C423.3 389.4 416 374.3 416 354c0-8.3 2.5-16.8 9.1-28.1c4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.4 1.8 2.4 .5 .6 .1 .2 0 0 0 0 0 0L507 351l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"]
};
var faKiwiBird = {
  prefix: 'fal',
  iconName: 'kiwi-bird',
  icon: [576, 512, [], "f535", "M192 384c33.9 0 65.3-10.5 91.2-28.5c33.7-23.4 78.2-51.5 130.4-51.5H464c44.2 0 80-35.8 80-80s-35.8-80-80-80H413.6c-52.2 0-96.7-28.1-130.4-51.5C257.3 74.5 225.9 64 192 64C103.6 64 32 135.6 32 224s71.6 160 160 160zm311.3-55.1L544 402.3V302.4c-11.4 11.6-25.2 20.7-40.7 26.5zM546 471.8l-75.5-136c-2.1 .1-4.3 .2-6.5 .2H413.6c-41.2 0-78.3 22.3-112.1 45.8c-13.9 9.7-29.2 17.5-45.4 23.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V413.3c-10.4 1.7-21.1 2.7-32 2.7c-22.4 0-44-3.8-64-10.9V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V390.3C38.6 357.1 0 295.1 0 224C0 118 86 32 192 32c40.7 0 78.4 12.6 109.4 34.2c33.8 23.5 71 45.8 112.1 45.8H464c61.9 0 112 50.1 112 112V464c0 7.3-4.9 13.7-12 15.5s-14.5-1.3-18-7.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCastle = {
  prefix: 'fal',
  iconName: 'castle',
  icon: [640, 512, [], "e0de", "M128 40c0-22.1 17.9-40 40-40h24c22.1 0 40 17.9 40 40V64h32V40c0-22.1 17.9-40 40-40h32c22.1 0 40 17.9 40 40V64h32V40c0-22.1 17.9-40 40-40h24c22.1 0 40 17.9 40 40V224h32V200c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V200c0-22.1 17.9-40 40-40H56c22.1 0 40 17.9 40 40v24h32V40zm40-8c-4.4 0-8 3.6-8 8V224H480V40c0-4.4-3.6-8-8-8H448c-4.4 0-8 3.6-8 8V80c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8H304c-4.4 0-8 3.6-8 8V80c0 8.8-7.2 16-16 16H216c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8H168zM496 256H144 80c-8.8 0-16-7.2-16-16V200c0-4.4-3.6-8-8-8H40c-4.4 0-8 3.6-8 8V432c0 26.5 21.5 48 48 48H224V400c0-53 43-96 96-96s96 43 96 96v80H560c26.5 0 48-21.5 48-48V200c0-4.4-3.6-8-8-8H584c-4.4 0-8 3.6-8 8v40c0 8.8-7.2 16-16 16H496zM384 400c0-35.3-28.7-64-64-64s-64 28.7-64 64v80H384V400z"]
};
var faGolfClub = {
  prefix: 'fal',
  iconName: 'golf-club',
  icon: [512, 512, [], "f451", "M510.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L303.5 365.1l-243-65.7C30 291.2 0 314.2 0 345.8V464c0 26.5 21.5 48 48 48H226.3c24.2 0 46.4-13.7 57.2-35.4l42.7-85.5 184-368zM52.2 330.4l236.8 64-34 68c-5.4 10.8-16.5 17.7-28.6 17.7H48c-8.8 0-16-7.2-16-16V448H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V400H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V345.8c0-10.5 10-18.2 20.2-15.4z"]
};
var faArrowRightArrowLeft = {
  prefix: 'fal',
  iconName: 'arrow-right-arrow-left',
  icon: [448, 512, [8644, "exchange"], "f0ec", "M443.3 139.3c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 112 16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96zm-342.6 352c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 400 432 400c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 368l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96z"]
};
var faExchange = faArrowRightArrowLeft;
var faRotateRight = {
  prefix: 'fal',
  iconName: 'rotate-right',
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M417.3 360.2c3.2-5 8.7-8.2 14.7-8.2c12.3 0 20.3 12.8 13.7 23.2C406 438.2 335.9 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7L433.4 56c5.1-5.1 12.1-8 19.3-8C467.8 48 480 60.2 480 75.3V176c0 8.8-7.2 16-16 16H363.3c-15.1 0-27.3-12.2-27.3-27.3c0-7.2 2.9-14.2 8-19.3l36-36C346.5 81.1 303.3 64 256 64C150 64 64 150 64 256s86 192 192 192c67.6 0 127.1-35 161.3-87.8zM448 86.6L374.6 160H448V86.6z"]
};
var faRedoAlt = faRotateRight;
var faRotateForward = faRotateRight;
var faUtensils = {
  prefix: 'fal',
  iconName: 'utensils',
  icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M42.6 .2c8.7 1.5 14.6 9.7 13.2 18.4L32.7 157.4c-.4 2.6-.7 5.2-.7 7.9V176c0 26.5 21.5 48 48 48h32 32c26.5 0 48-21.5 48-48V165.3c0-2.6-.2-5.3-.7-7.9L168.2 18.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2l23.1 138.8c.7 4.3 1.1 8.7 1.1 13.2V176c0 44.2-35.8 80-80 80H128V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H80c-44.2 0-80-35.8-80-80V165.3c0-4.4 .4-8.8 1.1-13.2L24.2 13.4C25.7 4.7 33.9-1.2 42.6 .2zM88.8 0c8.8 .4 15.6 8 15.2 16.8l-8 160c-.4 8.8-8 15.6-16.8 15.2s-15.6-8-15.2-16.8l8-160C72.5 6.4 80-.4 88.8 0zm46.4 0C144-.4 151.5 6.4 152 15.2l8 160c.4 8.8-6.4 16.3-15.2 16.8s-16.3-6.4-16.8-15.2l-8-160C119.6 8 126.4 .5 135.2 0zM320 176V288c0 17.7 14.3 32 32 32h64V32.2l-.2 .1c-1.7 .4-6.7 1.5-14.3 4.6C391.4 41 379 47.8 367 58.2c-23.2 20.1-47 55.3-47 117.8zM416 0c17.7 0 32 14.3 32 32V320v16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H352c-35.3 0-64-28.7-64-64V176C288 32 400 0 416 0z"]
};
var faCutlery = faUtensils;
var faArrowUpWideShort = {
  prefix: 'fal',
  iconName: 'arrow-up-wide-short',
  icon: [576, 512, ["sort-amount-up"], "f161", "M139.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM304 464h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faSortAmountUp = faArrowUpWideShort;
var faChartPieSimpleCircleDollar = {
  prefix: 'fal',
  iconName: 'chart-pie-simple-circle-dollar',
  icon: [640, 512, [], "e605", "M288 224H394.8c-12.9 9.1-24.5 19.9-34.6 32H272c-8.8 0-16-7.2-16-16V17.7C256 8.1 263.4 0 273.1 0c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-7.1 0-14.2 .4-21.1 1.2C455.2 105.6 379.9 39.1 288 32.5V224zm-32 64h83.2c-5.2 10.1-9.4 20.8-12.6 32H224c-17.7 0-32-14.3-32-32V69.6C100.3 91.2 32 173.7 32 272c0 114.9 93.1 208 208 208c37.1 0 71.9-9.7 102-26.7c5.2 9.4 11.3 18.3 18.1 26.5C324.8 500.3 283.8 512 240 512C107.5 512 0 404.5 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V256v32h32zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8 16H480v-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L436 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288 272h32v16 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z"]
};
var faBalloons = {
  prefix: 'fal',
  iconName: 'balloons',
  icon: [640, 512, [], "e2e4", "M172.8 342.4l0 0 0 0 0 0L160 352l-12.8-9.6 0 0 0 0 0 0 0 0-.1-.1-.8-.6c-.8-.6-2-1.6-3.6-2.8c-3.1-2.6-7.8-6.4-13.3-11.4c-11.2-10-26.1-24.5-40.9-42C58 249.1 32 204.5 32 160C32 89.3 89.3 32 160 32s128 57.3 128 128c0 44.5-26 89.1-56.5 125.4c-14.8 17.6-29.7 32-40.9 42c-5.6 5-10.2 8.8-13.3 11.4c-1.6 1.3-2.8 2.2-3.6 2.8l-.8 .6-.1 .1 0 0zm-9.4 39.9L180.2 416H139.8l16.8-33.7 3.4-6.8 3.4 6.8zM192 368s128-96 128-208C320 71.6 248.4 0 160 0S0 71.6 0 160C0 272 128 368 128 368L97.4 429.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9H211.1c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L192 368zm139.2-84.9C362.3 367.8 448 432 448 432l-30.6 61.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9H531.1c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L512 432s128-96 128-208c0-88.4-71.6-160-160-160c-46.1 0-87.7 19.5-116.9 50.8c3.2 14.6 4.9 29.7 4.9 45.2c0 .7 0 1.3 0 2c21.8-39.4 63.8-66 112-66c70.7 0 128 57.3 128 128c0 44.5-26 89.1-56.5 125.4c-14.8 17.6-29.7 32-40.9 42c-5.6 5-10.2 8.8-13.3 11.4c-1.6 1.3-2.8 2.2-3.6 2.8l-.8 .6-.1 .1 0 0 0 0 0 0 0 0L480 416l-12.8-9.6 0 0 0 0 0 0 0 0-.1-.1-.8-.6c-.8-.6-2-1.6-3.6-2.8c-3.1-2.6-7.8-6.4-13.3-11.4c-11.2-10-26.1-24.5-40.9-42C381.2 317 357.6 278 352.9 238.3c-6.1 16-13.6 31-21.7 44.7zM480 439.6l3.4 6.8L500.2 480H459.8l16.8-33.7 3.4-6.8zM112 160c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zm320 64c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faMillSign = {
  prefix: 'fal',
  iconName: 'mill-sign',
  icon: [384, 512, [], "e1ed", "M287.2 21.1c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1L222.7 113.2c-12.3 8.2-22.8 18.9-30.7 31.4C173.6 115.4 141.1 96 104 96c-27.9 0-53.3 11-72 29V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H.3c-.2 2.6-.3 5.3-.3 8V432c0 8.8 7.2 16 16 16s16-7.2 16-16V200c0-39.8 32.2-72 72-72s72 32.2 72 72v53.4L96.8 490.9c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1L176 354.6V416v16c0 8.8 7.2 16 16 16s16-7.2 16-16V416 258.6l41.2-123.7c9.3-4.4 19.8-6.9 30.8-6.9c39.8 0 72 32.2 72 72V432c0 8.8 7.2 16 16 16s16-7.2 16-16V200c0-57.4-46.6-104-104-104c-6.3 0-12.4 .6-18.3 1.6l25.5-76.6z"]
};
var faBowlRice = {
  prefix: 'fal',
  iconName: 'bowl-rice',
  icon: [512, 512, [], "e2eb", "M176 80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H192zM48 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm81.3 233.1c-2.7-9-9.2-16.4-17.8-20.2C65.9 385 33.9 340.3 32.1 288H479.9c-1.8 52.3-33.9 97-79.4 116.9c-8.6 3.8-15.2 11.2-17.8 20.2C378.7 438.4 366.5 448 352 448H160c-14.5 0-26.7-9.6-30.7-22.9zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480H352c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4H27.4zM224 208c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm-96 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm224 80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm-32-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288zm128 80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16zm-32-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384zM288 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288z"]
};
var faTimelineArrow = {
  prefix: 'fal',
  iconName: 'timeline-arrow',
  icon: [640, 512, [], "e29d", "M144 80A32 32 0 1 0 80 80a32 32 0 1 0 64 0zm32 0c0 29.8-20.4 54.9-48 62V256H352V142c-27.6-7.1-48-32.2-48-62c0-35.3 28.7-64 64-64s64 28.7 64 64c0 29.8-20.4 54.9-48 62V256H579.8l-62.1-51.7c-6.8-5.7-7.7-15.7-2-22.5s15.7-7.7 22.5-2l95.9 79.9c.6 .5 1.1 1 1.6 1.5c2.6 2.8 4.2 6.7 4.2 10.8c0 .3 0 .7 0 1c-.2 3.5-1.5 6.7-3.6 9.2c-.6 .8-1.3 1.5-2.1 2.1l-.1 .1-95.9 79.9c-6.8 5.7-16.9 4.7-22.5-2s-4.7-16.9 2-22.5L579.8 288H256v82c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-29.8 20.4-54.9 48-62V288H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H96V142c-27.6-7.1-48-32.2-48-62c0-35.3 28.7-64 64-64s64 28.7 64 64zm32 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM400 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSkull = {
  prefix: 'fal',
  iconName: 'skull',
  icon: [512, 512, [128128], "f54c", "M384 399.6c-.2-10.7 4.9-20.8 13.6-26.9c51.3-36 82.4-89.8 82.4-148.7c0-102.2-96.1-192-224-192S32 121.8 32 224c0 58.8 31.1 112.7 82.4 148.7c8.8 6.1 13.9 16.2 13.6 26.9l0 .4v64c0 8.8 7.2 16 16 16h48V432c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V432c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16-7.2 16-16V400l0-.4zm32-.7c0 .4 0 .7 0 1.1v64c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V400c0-.4 0-.7 0-1.1C37.5 357.8 0 294.7 0 224C0 100.3 114.6 0 256 0S512 100.3 512 224c0 70.7-37.5 133.8-96 174.9zM160 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faGameBoardSimple = {
  prefix: 'fal',
  iconName: 'game-board-simple',
  icon: [448, 512, ["game-board-alt"], "f868", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 240H208V128H96V240zM240 120V240H360c13.3 0 24 10.7 24 24V392c0 13.3-10.7 24-24 24H232c-13.3 0-24-10.7-24-24V272H88c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24H216c13.3 0 24 10.7 24 24zm0 264H352V272H240V384z"]
};
var faGameBoardAlt = faGameBoardSimple;
var faCircleVideo = {
  prefix: 'fal',
  iconName: 'circle-video',
  icon: [512, 512, ["video-circle"], "e12b", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-320v32 64 32H160V192H288zm32 9.8V192c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32v-9.8l74.9 25c4.9 1.6 10.2 .8 14.4-2.2s6.6-7.8 6.6-13V192c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-74.9 25zm0 33.7l64-21.3v83.6l-64-21.3V235.5z"]
};
var faVideoCircle = faCircleVideo;
var faChartScatterBubble = {
  prefix: 'fal',
  iconName: 'chart-scatter-bubble',
  icon: [512, 512, [], "e0e9", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM176 323.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0-67.2a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm208 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-48-92.8a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0-67.2a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm176 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faHouseTurret = {
  prefix: 'fal',
  iconName: 'house-turret',
  icon: [640, 512, [], "e1b4", "M288 448V284.2c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zM256 284.2V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L276.8 237c-13.2 12.1-20.8 29.2-20.8 47.2zM416 288h64v64H416V288zm-32 0v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32zM32 48c0-8.8 7.2-16 16-16H96V96c0 8.8 7.2 16 16 16s16-7.2 16-16V32h96V96c0 8.8 7.2 16 16 16s16-7.2 16-16V32h48c8.8 0 16 7.2 16 16V153.9l32-29.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V203.8c0 11.8 4.3 23.1 12.1 31.9L64 294.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-3.9-1.4-7.7-4-10.6L36 214.5c-2.6-2.9-4-6.7-4-10.6V48zM192 224H160V192c0-8.8 7.2-16 16-16s16 7.2 16 16v32zm-16-80c-26.5 0-48 21.5-48 48v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V192c0-26.5-21.5-48-48-48z"]
};
var faBanana = {
  prefix: 'fal',
  iconName: 'banana',
  icon: [576, 512, [], "e2e5", "M336 144c0 41.2-8.7 80.4-24.3 115.9c-8-7.6-17-14.2-26.5-19.5C297.3 210.7 304 178.1 304 144c0-31.4-5.6-61.3-15.9-89c-9.5-25.5 8.6-55 38-55c9.8 0 19.5 3.6 27 10.4C411.4 63.1 448 139.3 448 224c0 11-.6 21.8-1.8 32.5c-11.4 1-22.6 3.6-33.3 7.5c2.1-13.1 3.1-26.4 3.1-40.1c0-75.3-32.5-143-84.3-189.9c-1.5-1.4-3.5-2.1-5.6-2.1c-3.3 0-5.5 1.4-7 3.6c-1.7 2.6-2 5.6-1.1 8.2C329.7 75 336 108.8 336 144zM253.9 296.2c-9.7-5.3-20.7-8.2-32-8.2c-11.6 0-22.9 3-32.9 8.7l-37 21.1c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l37-21.1c14.9-8.5 31.7-13 48.8-13c26.1 0 51.1 10.4 69.6 28.8l48 48 77.8-35.9c12.7-5.9 26.5-8.9 40.5-8.9c34.4 0 66.1 18.2 83.4 47.9l32.7 56c4.5 7.6 1.9 17.4-5.8 21.9s-17.4 1.9-21.9-5.8l-32.7-56c-11.6-19.8-32.8-32.1-55.8-32.1c-9.3 0-18.6 2-27.1 5.9l-1.4 .7C387.8 435 282.9 512 160 512L48 512c-26.5 0-48-21.5-48-48V448c0-26.5 21.5-48 48-48c84.4 0 159.2-40.8 205.9-103.8zm130.6 51.1l-41.7 19.3c-6.1 2.8-13.3 1.5-18-3.2l-46.4-46.4C225.8 386.8 142.2 432 48 432c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16l112 0c96.7 0 180.9-53.6 224.4-132.7z"]
};
var faHandHoldingSkull = {
  prefix: 'fal',
  iconName: 'hand-holding-skull',
  icon: [576, 512, [], "e1a4", "M176 128c0 33.3 20 63.5 51.9 81c6.4 3.5 9.6 10.9 7.8 17.9L228.5 256h119l-7.3-29.1c-1.8-7.1 1.5-14.4 7.8-17.9C380 191.5 400 161.3 400 128c0-51.1-48.1-96-112-96s-112 44.9-112 96zM288 0c77.5 0 144 55.4 144 128c0 42.6-23.3 79.6-57.9 102.6l9.4 37.5c1.2 4.8 .1 9.8-2.9 13.7s-7.7 6.2-12.6 6.2H208c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l9.4-37.5c-34.6-23-57.9-60-57.9-102.6C144 55.4 210.5 0 288 0zM248 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7H80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faPeopleDress = {
  prefix: 'fal',
  iconName: 'people-dress',
  icon: [640, 512, [], "e217", "M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM126.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H96v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L246.1 368H208 112 73.9l52.4-104.8zM160 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C231.7 148.6 197.3 128 160 128s-71.7 20.6-89.3 53.5L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L99 196.6c12-22.5 35.5-36.6 61-36.6zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM446.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368H528 432 393.9l52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C551.7 148.6 517.3 128 480 128s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L419 196.6c12-22.5 35.5-36.6 61-36.6z"]
};
var faLoveseat = {
  prefix: 'fal',
  iconName: 'loveseat',
  icon: [512, 512, ["couch-small"], "f4cc", "M320 64c53 0 96 43 96 96v37.5c10-3.5 20.8-5.5 32-5.5V160c0-70.7-57.3-128-128-128H192C121.3 32 64 89.3 64 160v32c11.2 0 22 1.9 32 5.5V160c0-53 43-96 96-96H320zM96 320v96 16c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32zM80 480c20.9 0 38.7-13.4 45.3-32H386.7c6.6 18.6 24.4 32 45.3 32h32c26.5 0 48-21.5 48-48V288c0-35.3-28.7-64-64-64s-64 28.7-64 64H128c0-35.3-28.7-64-64-64s-64 28.7-64 64V432c0 26.5 21.5 48 48 48H80zm48-64V320H384v96H128zm288 16V416 320 288c0-17.7 14.3-32 32-32s32 14.3 32 32V432c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16z"]
};
var faCouchSmall = faLoveseat;
var faTowerBroadcast = {
  prefix: 'fal',
  iconName: 'tower-broadcast',
  icon: [576, 512, ["broadcast-tower"], "f519", "M46.7 1.4c-8.1-3.6-17.5-.1-21.2 8C9.1 45.6 0 85.8 0 128s9.1 82.4 25.5 118.6c3.6 8.1 13.1 11.6 21.2 8s11.6-13.1 8-21.2C40.1 201.3 32 165.6 32 128s8.1-73.3 22.6-105.4c3.6-8.1 .1-17.5-8-21.2zm482.7 0c-8.1 3.6-11.6 13.1-8 21.2C535.9 54.7 544 90.4 544 128s-8.1 73.3-22.6 105.4c-3.6 8.1-.1 17.5 8 21.2s17.5 .1 21.2-8C566.9 210.4 576 170.2 576 128s-9.1-82.4-25.5-118.6c-3.6-8.1-13.1-11.6-21.2-8zM256 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm48 62c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62V496c0 8.8 7.2 16 16 16s16-7.2 16-16V190zM138.9 69.8c3.2-8.2-.9-17.5-9.1-20.7s-17.5 .9-20.7 9.1C100.6 79.8 96 103.4 96 128s4.6 48.2 13.1 69.8c3.2 8.2 12.5 12.3 20.7 9.1s12.3-12.5 9.1-20.7c-7-18-10.9-37.6-10.9-58.2s3.9-40.2 10.9-58.2zm328-11.6c-3.2-8.2-12.5-12.3-20.7-9.1s-12.3 12.5-9.1 20.7c7 18 10.9 37.6 10.9 58.2s-3.9 40.2-10.9 58.2c-3.2 8.2 .9 17.5 9.1 20.7s17.5-.9 20.7-9.1c8.5-21.7 13.1-45.2 13.1-69.8s-4.6-48.2-13.1-69.8z"]
};
var faBroadcastTower = faTowerBroadcast;
var faTruckPickup = {
  prefix: 'fal',
  iconName: 'truck-pickup',
  icon: [640, 512, [128763], "f63c", "M256 80V192H485.3L389 70.1c-3-3.8-7.7-6.1-12.6-6.1H272c-8.8 0-16 7.2-16 16zM524.6 190.1l1.5 1.9H552c30.9 0 56 25.1 56 56V352h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608 576 560c0 53-43 96-96 96s-96-43-96-96H272c0 53-43 96-96 96s-96-43-96-96H64 32 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V248c0-30.9 25.1-56 56-56H224V80c0-26.5 21.5-48 48-48H376.5c14.7 0 28.6 6.7 37.7 18.3L524.6 190.1zM64 352H85.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H373.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H576V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24V352zm176 32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm224 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faBlockQuote = {
  prefix: 'fal',
  iconName: 'block-quote',
  icon: [448, 512, [], "e0b5", "M16 80C7.2 80 0 87.2 0 96s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM144 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM128 416c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16s-16 7.2-16 16V432z"]
};
var faUpLong = {
  prefix: 'fal',
  iconName: 'up-long',
  icon: [320, 512, ["long-arrow-alt-up"], "f30c", "M88 160H38.7c-3.7 0-6.7-3-6.7-6.7c0-1.9 .8-3.7 2.2-5L160 35.8 285.8 148.3c1.4 1.3 2.2 3.1 2.2 5c0 3.7-3 6.7-6.7 6.7H232c-17.7 0-32 14.3-32 32V464c0 8.8-7.2 16-16 16H136c-8.8 0-16-7.2-16-16V192c0-17.7-14.3-32-32-32zM174 5.3C170.1 1.9 165.2 0 160 0s-10.1 1.9-14 5.3L12.9 124.5C4.7 131.8 0 142.3 0 153.3C0 174.7 17.3 192 38.7 192H56 88v32V464c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V224 192h32 17.3c21.4 0 38.7-17.3 38.7-38.7c0-11-4.7-21.5-12.9-28.8L174 5.3z"]
};
var faLongArrowAltUp = faUpLong;
var faStop = {
  prefix: 'fal',
  iconName: 'stop',
  icon: [384, 512, [9209], "f04d", "M320 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"]
};
var faCodeMerge = {
  prefix: 'fal',
  iconName: 'code-merge',
  icon: [448, 512, [], "f387", "M80 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM96.9 158.2C133 150.5 160 118.4 160 80c0-44.2-35.8-80-80-80S0 35.8 0 80c0 38.7 27.5 71 64 78.4V353.6C27.5 361 0 393.3 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4V234.5c26.4 32.6 66.8 53.5 112 53.5h81.6c7.4 36.5 39.7 64 78.4 64c44.2 0 80-35.8 80-80s-35.8-80-80-80c-38.7 0-71 27.5-78.4 64H208c-57 0-104.1-42.6-111.1-97.8zM416 272a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM128 432a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faMoneyCheckDollarPen = {
  prefix: 'fal',
  iconName: 'money-check-dollar-pen',
  icon: [640, 512, ["money-check-edit-alt"], "f873", "M512 96H64c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H338.2l-8 32H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64c-10.9-.3-21.8 1.5-32 5.6V128c0-17.7-14.3-32-32-32zM256 304c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm16-112H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM144 144c8.8 0 16 7.2 16 16v9.6c5.9 1 19 3.5 24.1 4.9c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-4-1.1-17.7-3.7-22.1-4.4c-12.8-2-23.6-.4-30.9 2.9c-7.2 3.3-9.9 7.5-10.5 11c-.7 4.1-.1 6.2 .5 7.4c.6 1.4 2 3.1 5 5.1c6.7 4.6 17.1 7.8 31 12l.6 .2 0 0c12.3 3.7 27.9 8.4 39.5 16.9c6.3 4.5 12 10.6 15.6 18.8c3.6 8.3 4.4 17.4 2.7 27.2c-3 17.5-14.6 29.4-29.3 35.7c-5.6 2.4-11.6 4-17.9 4.9V352c0 8.8-7.2 16-16 16s-16-7.2-16-16v-9.6c-9.4-1.7-23.5-6.6-32.4-9.6l0 0 0 0 0 0 0 0c-1.8-.6-3.3-1.1-4.6-1.6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c9.5 3.2 20.7 7 27.1 8.1c13.3 2.1 24 .8 31-2.2c6.5-2.8 9.5-6.7 10.3-11.8c.8-4.7 .2-7.3-.5-9c-.7-1.7-2.2-3.6-5.1-5.7c-6.5-4.8-16.7-8.1-30.5-12.3l-2-.6 0 0c-11.9-3.6-26.6-8-37.7-15.5c-6.2-4.2-12.2-10-15.9-17.9c-3.8-8.1-4.7-17.1-3.1-26.6c2.9-16.7 14.7-28.4 28.8-34.7c5.6-2.6 11.8-4.4 18.3-5.4V160c0-8.8 7.2-16 16-16zM582.8 264c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L600.2 304c6.2-6.2 6.2-16.4 0-22.6L582.8 264zM406.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L552.7 351.4l-40-40L406.5 417.7zM537.5 241.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L469.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L537.5 241.4z"]
};
var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
var faUpFromLine = {
  prefix: 'fal',
  iconName: 'up-from-line',
  icon: [384, 512, ["arrow-alt-from-bottom"], "f346", "M190.2 64.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L318.2 196.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7H256c-8.8 0-16 7.2-16 16V344c0 4.4-3.6 8-8 8H152c-4.4 0-8-3.6-8-8V224c0-8.8-7.2-16-16-16H70.7c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L190.2 64.8zM192 32c-9.5 0-18.6 3.9-25.1 10.8L42.5 174.8C35.8 182 32 191.5 32 201.3C32 222.7 49.3 240 70.7 240H112V344c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V240h41.3c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L217.1 42.8C210.6 35.9 201.5 32 192 32zM16 480H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faArrowAltFromBottom = faUpFromLine;
var faUpload = {
  prefix: 'fal',
  iconName: 'upload',
  icon: [512, 512, [], "f093", "M272 54.6V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6L139.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 54.6zM208 352H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H304V320H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384c0-35.3 28.7-64 64-64H208v32zm176 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faHurricane = {
  prefix: 'fal',
  iconName: 'hurricane',
  icon: [384, 512, [], "f751", "M32 208C32 118.9 98.2 45.3 184 33.6V98.8c0 16.4 12.1 29.1 26.8 32.1C291.3 147 352 218.1 352 303.4c0 89.1-66.2 162.7-152 174.4V412.6c0-16.4-12.1-29.1-26.8-32.1C92.7 364.4 32 293.3 32 208zM216 32.8c0-17.8-15.1-33.6-34.6-31.1C79.1 14.8 0 102.2 0 208C0 308.8 71.7 392.9 166.9 411.9c.5 .1 .8 .3 1 .5c.1 .1 .1 .1 .1 .1c0 0 0 0 0 0v65.9c0 17.8 15.1 33.6 34.6 31.1C304.9 496.6 384 409.3 384 303.4c0-100.8-71.7-184.9-166.9-203.9c-.5-.1-.8-.3-1-.5c-.1-.1-.1-.2-.1-.2V32.8zM240 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]
};
var faGridRound2Plus = {
  prefix: 'fal',
  iconName: 'grid-round-2-plus',
  icon: [512, 512, [], "e5dc", "M64 128a64 64 0 1 0 128 0A64 64 0 1 0 64 128zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM64 384a64 64 0 1 0 128 0A64 64 0 1 0 64 384zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM384 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c8.8 0 16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H400v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V288c0-8.8 7.2-16 16-16z"]
};
var faPeoplePants = {
  prefix: 'fal',
  iconName: 'people-pants',
  icon: [640, 512, [], "e219", "M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM147.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H128V164c6-2.6 12.5-4 19.3-4zM128 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L243.3 170.3c-13.9-26-41-42.3-70.6-42.3H147.3c-29.5 0-56.7 16.3-70.6 42.3L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L96 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM467.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H448V164c6-2.6 12.5-4 19.3-4zM448 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L563.3 170.3c-13.9-26-41-42.3-70.6-42.3H467.3c-29.5 0-56.6 16.3-70.6 42.3L337.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L416 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faMound = {
  prefix: 'fal',
  iconName: 'mound',
  icon: [576, 512, [], "e52d", "M512.7 384L63.3 384 171.9 195.2C195.8 153.6 240.1 128 288 128s92.2 25.6 116.1 67.2L512.7 384zM288 96c-59.4 0-114.2 31.7-143.9 83.2L35.6 368c-12.3 21.3 3.1 48 27.7 48H512.7c24.6 0 40-26.6 27.7-48L431.9 179.2C402.2 127.7 347.4 96 288 96z"]
};
var faWindsock = {
  prefix: 'fal',
  iconName: 'windsock',
  icon: [512, 512, [], "f777", "M16 0c8.8 0 16 7.2 16 16V128H96V86.7c0-20.1 18.3-35.2 38-31.4L486 123c15.1 2.9 26 16.1 26 31.4V261.6c0 15.3-10.9 28.5-26 31.4L134 360.7c-19.7 3.8-38-11.3-38-31.4V288H32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V272 144 16C0 7.2 7.2 0 16 0zM32 160v96H96V160H32zm96-73.3V329.3l96-18.5V105.2L128 86.7zm128 24.6V304.6L384 280V136L256 111.4zm160 30.8V273.9l64-12.3 0-107.1-64-12.3z"]
};
var faCircleHalf = {
  prefix: 'fal',
  iconName: 'circle-half',
  icon: [512, 512, [], "e110", "M224 34.3C115.5 49.8 32 143.2 32 256s83.5 206.2 192 221.7V34.3zM224.1 2C241.6-.2 256 14.3 256 32V480c0 17.7-14.4 32.2-31.9 30C97.8 494.3 0 386.6 0 256S97.8 17.7 224.1 2z"]
};
var faBrakeWarning = {
  prefix: 'fal',
  iconName: 'brake-warning',
  icon: [640, 512, [], "e0c7", "M320 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 416a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm16-336c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM320 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM77.5 100.6c4.8-7.4 2.6-17.3-4.8-22.1s-17.3-2.6-22.1 4.8C18.5 133.2 0 192.4 0 256s18.5 122.8 50.5 172.7c4.8 7.4 14.7 9.6 22.1 4.8s9.6-14.7 4.8-22.1C48.7 366.6 32 313.3 32 256s16.7-110.6 45.5-155.4zm512-17.3c-4.8-7.4-14.7-9.6-22.1-4.8s-9.6 14.7-4.8 22.1C591.3 145.4 608 198.7 608 256s-16.7 110.6-45.5 155.4c-4.8 7.4-2.6 17.3 4.8 22.1s17.3 2.6 22.1-4.8C621.4 378.8 640 319.6 640 256s-18.6-122.8-50.5-172.7z"]
};
var faToiletPortable = {
  prefix: 'fal',
  iconName: 'toilet-portable',
  icon: [320, 512, [], "e583", "M32 64V96H288V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64zm0 64V448H288V336H264c-22.1 0-40-17.9-40-40V248c0-22.1 17.9-40 40-40h24V128H32zM320 64V208v32 64 32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64zM264 240c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24V240H264z"]
};
var faCompactDisc = {
  prefix: 'fal',
  iconName: 'compact-disc',
  icon: [512, 512, [128191, 128192, 128440], "f51f", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm72 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-120 0c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-97.2 78.8-176 176-176c8.8 0 16 7.2 16 16s-7.2 16-16 16c-79.5 0-144 64.5-144 144z"]
};
var faFileArrowDown = {
  prefix: 'fal',
  iconName: 'file-arrow-down',
  icon: [384, 512, ["file-download"], "f56d", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V361.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4V240z"]
};
var faFileDownload = faFileArrowDown;
var faSaxophoneFire = {
  prefix: 'fal',
  iconName: 'saxophone-fire',
  icon: [640, 512, ["sax-hot"], "f8db", "M151.6 81.2c9.6-.1 18.7-4.5 24.7-12.1c1.5-1.9 2.9-3.6 4.3-5.4c10.7 12.6 20.2 27.2 27.6 41.5l25.2-13-25.2 13C218.9 125.8 224 145 224 153.7c0 13.6-2.8 26.5-8 38.3h34.1c3.8-12.1 5.9-25 5.9-38.3c0-16.1-7.7-40.7-19.3-63.2c-11.8-22.8-28.5-46.8-48.3-64.9c-4.3-4-11-4.1-15.5-.4c-.2 .1-.3 .3-.5 .4c-7.7 7-14.9 15.7-21.2 23.6c-7-8.4-14.2-16.4-21.6-24.2c-7.3-7.6-14.9-15-22.8-22c-2.2-2-5-3-7.8-3c-2.9 0-5.7 1-8 3C64.4 26.7 41.9 53.7 25.9 79.6C10.2 105.2 0 132.6 0 153.7C0 167 2 179.9 5.8 192H39.9c-5.1-11.7-7.9-24.7-7.9-38.3c0-12.6 6.8-34.1 21.2-57.3C64.7 77.7 80.4 58 98.9 39.5c9.7 9.5 18.9 19.6 27.7 30.1c6.2 7.4 15.3 11.6 25 11.5zM200 192c10.6-21.7 10.2-48.4-1.8-70.6l0-.1 0 0c-1.5-3.1-3.7-7.4-7-11.7c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-16.1 18.8-11.6-14.7c-12-15.2-24.4-31.1-26.1-33.2c-3-3.8-7.6-6-12.4-6s-9.4 2.2-12.5 5.9c-11.9 14.7-21.7 27.2-28.4 38.7c-6.9 11.9-11.2 23.7-11.2 37c0 13.7 2.9 26.1 8.3 36.8H97c-1.2-.9-2.3-1.8-3.3-2.7C85.5 181.8 80 170.6 80 155.2c0-5.9 1.7-12.1 6.8-20.8c3.2-5.5 7.5-11.6 13.1-18.9l13.5 17.2 16.3 20.8 5.3 6.8 1.5 1.9 .4 .5 .1 .1 0 0 0 0 0 0 12.6-9.9L137 162.7c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l12.7-14.8c3.8 16.7-2 34.1-15 43.6H200zM521.9 64c-20.8 0-40.8 8.1-55.7 22.6L221.1 324.3c-2.3 2.3-5.4 3.5-8.7 3.5c-6.7 0-12.5-5.6-12.5-12.7c0-.9 .1-1.9 .3-2.8L212.8 256H224c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0H32l-16 0c-8.8 0-16 7.2-16 16c0 7.8 5.5 14.2 12.9 15.7L2.7 311.5C.9 321.5 0 331.7 0 341.9v7.6C0 439.2 72.8 512 162.6 512c48.8 0 94.9-21.9 125.8-59.6L522.8 165.9c3-3.7 7.6-5.9 12.4-5.9h77.5c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3L606.1 87.4c-15-15-35.4-23.4-56.6-23.4H521.9zM45.4 256H180.1l-11 49.5c-.7 3.2-1.1 6.5-1.1 9.7c0 24.4 19.8 44.7 44.5 44.7c11.6 0 22.7-4.5 31-12.5L488.5 109.5c9-8.7 20.9-13.5 33.4-13.5h27.6c12.7 0 24.9 5.1 33.9 14.1L601.4 128H535.2c-14.4 0-28 6.5-37.2 17.6L263.6 432.1c-24.8 30.3-61.9 47.9-101 47.9C90.5 480 32 421.5 32 349.4v-7.6c0-8.3 .7-16.6 2.2-24.7L45.4 256zM120 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSaxHot = faSaxophoneFire;
var faCameraWebSlash = {
  prefix: 'fal',
  iconName: 'camera-web-slash',
  icon: [640, 512, ["webcam-slash"], "f833", "M544 224C544 100.3 443.7 0 320 0C262.8 0 210.5 21.5 170.9 56.8L196.5 77C229.9 48.9 273 32 320 32c106 0 192 86 192 192c0 30.9-7.3 60.1-20.3 86l25.6 20.2c17-31.6 26.7-67.8 26.7-106.2zM427.4 422.3l7.4 9.7h4.8l-12.3-9.7zm-29.1-23C374.4 410.1 347.9 416 320 416c-106 0-192-86-192-192c0-12.1 1.1-24 3.3-35.5l-27.8-22C98.6 184.9 96 204.1 96 224c0 73.7 35.6 139 90.5 179.9L133 473.4c-5.6 7.2-6.5 17-2.5 25.2s12.4 13.4 21.5 13.4H488c9.1 0 17.5-5.2 21.5-13.4c1.5-3 2.3-6.3 2.4-9.5L500.4 480H416l-247.8 0 45.3-58.9C245.2 438.3 281.5 448 320 448c38.4 0 74.5-9.7 106.1-26.7l-27.8-22zM176 224c0 79.5 64.5 144 144 144c11.6 0 22.8-1.4 33.6-3.9L318 336c-51.4-.9-94.3-36.3-106.5-84.1l-35.5-28 0 .1zm256 0c0 12.1-1.9 23.7-5.4 34.6L453 279.4c7.1-17.1 11-35.8 11-55.4c0-79.5-64.5-144-144-144c-31.7 0-61 10.2-84.7 27.6l26.4 20.8c17-10.4 37-16.4 58.4-16.4c61.9 0 112 50.1 112 112zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faWebcamSlash = faCameraWebSlash;
var faFolderMedical = {
  prefix: 'fal',
  iconName: 'folder-medical',
  icon: [512, 512, [], "e18c", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM240 176c-17.7 0-32 14.3-32 32v32H176c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V336h32c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H304V208c0-17.7-14.3-32-32-32H240zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H288c-8.8 0-16 7.2-16 16v48H240V320c0-8.8-7.2-16-16-16H176V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208z"]
};
var faFolderGear = {
  prefix: 'fal',
  iconName: 'folder-gear',
  icon: [512, 512, ["folder-cog"], "e187", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM208 192v.7c0 1-.8 3.4-4.1 5.3c-3.2 1.8-5.5 1.4-6.5 .8l-.6-.3c-15.3-8.8-34.9-3.6-43.7 11.7l-16 27.7c-8.8 15.3-3.6 34.9 11.7 43.7l.6 .3c.9 .5 2.6 2.4 2.6 6.1s-1.6 5.6-2.6 6.1l-.6 .3c-15.3 8.8-20.5 28.4-11.7 43.7l16 27.7c8.8 15.3 28.4 20.6 43.7 11.7l.6-.3c.9-.5 3.3-1 6.5 .8c3.3 1.9 4.1 4.3 4.1 5.3v.7c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-.7c0-1 .8-3.4 4.1-5.3c3.2-1.8 5.5-1.4 6.5-.8l.6 .3c15.3 8.8 34.9 3.6 43.7-11.7l16-27.7c8.8-15.3 3.6-34.9-11.7-43.7l-.6-.3c-.9-.5-2.6-2.4-2.6-6.1s1.6-5.6 2.6-6.1l.6-.3c15.3-8.8 20.6-28.4 11.7-43.7l-16-27.7c-8.8-15.3-28.4-20.5-43.7-11.7l-.6 .3c-.9 .5-3.3 1-6.5-.8c-3.3-1.9-4.1-4.3-4.1-5.3V192c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32zm64 0v.7c0 15.1 9.4 26.8 20 33c10.7 6.2 25.5 8.3 38.5 .8l.6-.3 16 27.7-.6 .3c-13 7.5-18.6 21.4-18.6 33.8s5.5 26.3 18.6 33.8l.6 .3-16 27.7-.6-.3c-13-7.5-27.8-5.4-38.5 .8c-10.6 6.2-20 17.9-20 33v.7H240v-.7c0-15.1-9.4-26.8-20-33c-10.7-6.2-25.5-8.3-38.5-.8l-.6 .3-16-27.7 .6-.3c13-7.5 18.6-21.4 18.6-33.8s-5.5-26.3-18.6-33.8l-.6-.3 16-27.7 .6 .3c13 7.5 27.8 5.4 38.5-.8c10.6-6.2 20-17.9 20-33V192h32zm8 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faFolderCog = faFolderGear;
var faHandWave = {
  prefix: 'fal',
  iconName: 'hand-wave',
  icon: [512, 512, [], "e1a7", "M354.3 95.8c8.7-1.2 14.8-9.4 13.6-18.1l-1.2-8.5c-5-35.2-32.7-62.9-67.9-67.9L290.3 .2c-8.7-1.2-16.9 4.8-18.1 13.6s4.8 16.9 13.6 18.1l8.5 1.2c21.1 3 37.7 19.6 40.7 40.7l1.2 8.5c1.3 8.7 9.4 14.8 18.1 13.6zM13.7 368.2C5 369.4-1.1 377.5 .2 386.3l1.2 8.5c5 35.2 32.7 62.9 67.9 67.9l8.5 1.2c8.7 1.2 16.9-4.8 18.1-13.6s-4.8-16.9-13.6-18.1L73.8 431c-21.1-3-37.7-19.6-40.7-40.7l-1.2-8.5c-1.2-8.7-9.4-14.8-18.1-13.6zM150.4 62.4c-21-10.8-47.5-7.3-65.1 10.3s-21 44.1-10.3 65.1c-8.7 2.6-16.8 7.3-23.7 14.1c-21.9 21.9-21.9 57.3 0 79.2l9.5 9.5c-7.6 2.7-14.8 7.1-20.9 13.2c-21.8 21.8-21.9 57.2-.2 79.1L162.9 457.1c34.8 35.1 82.2 54.9 131.7 54.9C397 512 480 429 480 326.6l0-13.8 0 0 0-.7 0 0L480 152c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 11L243.7 38.7c-21.9-21.9-57.3-21.9-79.2 0c-6.8 6.8-11.5 15-14.1 23.7zM108 95.3c9.4-9.4 24.6-9.4 33.9 0l8.8 8.8 .1 .1L288 241.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L187.1 95.3l-.1-.1c-9.3-9.4-9.3-24.5 .1-33.9c9.4-9.4 24.6-9.4 33.9 0L372.7 212.9c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-49.6c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160 0 0 0 .7 0 0 0 13.8C448 411.3 379.3 480 294.6 480c-40.9 0-80.1-16.4-109-45.4L62.6 310.3c-9.3-9.4-9.3-24.6 .1-34c9.4-9.4 24.7-9.4 34.1 0l36 36 .1 .1 42.1 42.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-42.2-42.2L105.6 240l-.1-.1L74 208.4c-9.4-9.4-9.4-24.6 0-33.9c9.3-9.3 24.4-9.4 33.8-.1L231.4 297.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-46.5-46.5-.1-.1L108 129.2c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faArrowUpArrowDown = {
  prefix: 'fal',
  iconName: 'arrow-up-arrow-down',
  icon: [576, 512, ["sort-up-down"], "e099", "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zm352 342.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V425.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96z"]
};
var faSortUpDown = faArrowUpArrowDown;
var faCaravan = {
  prefix: 'fal',
  iconName: 'caravan',
  icon: [640, 512, [], "f8ff", "M416 64c70.7 0 128 57.3 128 128V384H480V168c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40V384H282.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H80c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48H416zM80 416H96c0 53 43 96 96 96s96-43 96-96h64 96 96 32l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0V192c0-88.4-71.6-160-160-160H80C35.8 32 0 67.8 0 112V336c0 44.2 35.8 80 80 80zM448 224H416c-8.8 0-16 7.2-16 16s7.2 16 16 16h32V384H352V168c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v56zM128 160H256v64H128V160zm-32 0v64c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm96 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faShieldCat = {
  prefix: 'fal',
  iconName: 'shield-cat',
  icon: [512, 512, [], "e572", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM171.3 132.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V272c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5L281.4 192H230.6l-59.3-59.3zM176 272V182.6l36.7 36.7c3 3 7.1 4.7 11.3 4.7h64c4.2 0 8.3-1.7 11.3-4.7L336 182.6V272c0 44.2-35.8 80-80 80s-80-35.8-80-80zm56 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faMessageSlash = {
  prefix: 'fal',
  iconName: 'message-slash',
  icon: [640, 512, ["comment-alt-slash"], "f4a9", "M378.8 384h-5.5c-6.9 0-13.7 2.2-19.2 6.4L256 464V416c0-17.7-14.3-32-32-32H128c-17.7 0-32-14.3-32-32V160.7L64 135.4V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416h46l-40.5-32zM128 0c-8.3 0-16.1 1.6-23.4 4.4L139.6 32H512c17.7 0 32 14.3 32 32V351.3l28.3 22.3c2.4-6.8 3.7-14 3.7-21.6V64c0-35.3-28.7-64-64-64H128zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faCommentAltSlash = faMessageSlash;
var faBolt = {
  prefix: 'fal',
  iconName: 'bolt',
  icon: [448, 512, [9889, "zap"], "f0e7", "M306.8 6.3C311.4 2.2 317.3 0 323.4 0c17.2 0 29.2 17.1 23.4 33.3L278.7 224H389c14.9 0 27 12.1 27 27c0 7.8-3.3 15.1-9.1 20.3L141.1 505.8c-4.5 4-10.4 6.2-16.5 6.2c-17.2 0-29.2-17.1-23.5-33.3L169.3 288H57.8C43.6 288 32 276.4 32 262.2c0-7.4 3.2-14.4 8.7-19.3L306.8 6.3zm.5 42.4L74.1 256H192c5.2 0 10.1 2.5 13.1 6.8s3.7 9.7 2 14.6L140.6 463.6 375.8 256H256c-5.2 0-10.1-2.5-13.1-6.8s-3.7-9.7-2-14.6l66.4-186z"]
};
var faZap = faBolt;
var faTrashCanCheck = {
  prefix: 'fal',
  iconName: 'trash-can-check',
  icon: [448, 512, [], "e2a9", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zM331.3 235.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L192 329.4 308.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faGlassWater = {
  prefix: 'fal',
  iconName: 'glass-water',
  icon: [384, 512, [], "e4f4", "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7H343.8c4.7 0 8.4 4 8 8.7l-8.2 97.7-38 19c-19.2 9.6-42.3 7.2-59.1-6.3c-31.8-25.5-77.1-25.5-108.9 0c-16.8 13.4-39.9 15.9-59.1 6.3l-38.1-19L32.1 40.7zm11.4 135L64.1 186c30.4 15.2 66.9 11.3 93.4-9.9c20.1-16.1 48.8-16.1 68.9 0c26.5 21.2 63 25.1 93.4 9.9l20.5-10.3-23.2 275C315.8 467.3 302 480 285.4 480H98.6c-16.6 0-30.5-12.7-31.9-29.3L43.5 175.6zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512H285.4c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1z"]
};
var faOilWell = {
  prefix: 'fal',
  iconName: 'oil-well',
  icon: [576, 512, [], "e532", "M497.4 69.6c-6.9-25.6-33.2-40.8-58.8-33.9l-15.5 4.1L489.4 287l15.5-4.1c25.6-6.9 40.8-33.2 33.9-58.8L497.4 69.6zM430.4 4.7c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-15.5 4.1c-17.1 4.6-34.6-5.6-39.2-22.6L429.2 185.8 96 272.2V480h36.5L200 277.3l36.9-9.6L208.9 352H335.1L301.5 251l31-8 79 237.1H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V176c0-8.8 7.2-16 16-16s16 7.2 16 16v63.2L223.8 206l33-99.1C259 100.4 265.1 96 272 96s13 4.4 15.2 10.9L312.5 183l108.4-28.1L392.3 48c-4.6-17.1 5.6-34.6 22.6-39.2l15.5-4.1zM281.5 191.1L272 162.6l-11.3 33.9 20.8-5.4zM377.8 480l-32-96H198.2l-32 96H377.8z"]
};
var faPersonSimple = {
  prefix: 'fal',
  iconName: 'person-simple',
  icon: [256, 512, [], "e220", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320h84.9c18.7 0 33.4-16 31.9-34.7L198.2 236c-2.1-24.9-22.9-44-47.8-44H105.6c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z"]
};
var faVault = {
  prefix: 'fal',
  iconName: 'vault',
  icon: [576, 512, [], "e2c5", "M64 32C46.3 32 32 46.3 32 64V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c-35.3 0-64-28.7-64-64V64zM352 240A128 128 0 1 0 96 240a128 128 0 1 0 256 0zM64 240a160 160 0 1 1 320 0A160 160 0 1 1 64 240zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0c0 20.9-13.4 38.7-32 45.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48z"]
};
var faMars = {
  prefix: 'fal',
  iconName: 'mars',
  icon: [448, 512, [9794], "f222", "M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L288.6 168.7C258.1 143.3 218.8 128 176 128C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-42.8-15.3-82.1-40.7-112.6L416 86.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16H304zM32 304a144 144 0 1 1 288 0A144 144 0 1 1 32 304z"]
};
var faToilet = {
  prefix: 'fal',
  iconName: 'toilet',
  icon: [448, 512, [128701], "f7d8", "M0 16C0 7.2 7.2 0 16 0H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zM64 196.8c5-1.6 10.2-3.2 15.4-4.6C121 181.2 174.5 176 224 176s103 5.2 144.6 16.3c5.3 1.4 10.4 2.9 15.4 4.6V64h32V210.6c2.1 1.2 4.2 2.5 6.1 3.8c13.9 9.4 25.9 23 25.9 41.6c0 69.8-35.8 118.1-81 148.5l15.2 51c1.2 4.1 1.8 8.3 1.8 12.5c0 24.3-19.7 43.9-43.9 43.9H107.9C83.7 512 64 492.3 64 468.1c0-4.2 .6-8.5 1.8-12.5l15.2-51C35.8 374.1 0 325.8 0 256c0-18.5 12-32.2 25.9-41.6c1.9-1.3 4-2.6 6.1-3.8V64H64V196.8zM40.3 305.7c11.3 31.6 33.2 55.4 59.7 72.9C139.4 404.7 188.2 416 224 416s84.6-11.3 124.1-37.3c26.5-17.5 48.4-41.3 59.7-72.9c-11.5 5.6-24.9 10.2-39.2 14C327 330.8 273.5 336 224 336s-103-5.2-144.6-16.3c-14.3-3.8-27.6-8.4-39.2-14zM416 256c0-3.1-1.8-8.3-11.8-15c-9.8-6.6-24.7-12.7-43.9-17.8C322.2 213.1 271.7 208 224 208s-98.2 5.1-136.3 15.2c-19.2 5.1-34.1 11.2-43.9 17.8C33.8 247.7 32 252.9 32 256s1.8 8.3 11.8 15c9.8 6.6 24.7 12.7 43.9 17.8C125.8 298.9 176.3 304 224 304s98.2-5.1 136.3-15.2c19.2-5.1 34.1-11.2 43.9-17.8c9.9-6.7 11.8-11.9 11.8-15zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM351.5 464.7l-13.1-43.8C299.6 439.7 257.3 448 224 448s-75.6-8.3-114.4-27.2L96.5 464.7c-.3 1.1-.5 2.3-.5 3.4c0 6.6 5.3 11.9 11.9 11.9H340.1c6.6 0 11.9-5.3 11.9-11.9c0-1.2-.2-2.3-.5-3.4z"]
};
var faPlaneCircleXmark = {
  prefix: 'fal',
  iconName: 'plane-circle-xmark',
  icon: [640, 512, [], "e557", "M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2l0 0L256 480.6l105.7 30.2 0 0c2.7 .8 5.5 1.2 8.2 1.2c6.5 0 12.5-2 17.4-5.5c-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8V290.6c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"]
};
var faYenSign = {
  prefix: 'fal',
  iconName: 'yen-sign',
  icon: [320, 512, [165, "cny", "jpy", "rmb", "yen"], "f157", "M29 38.7C23.8 31.5 13.8 29.9 6.7 35S-2.1 50.2 3 57.4L123 224H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v64H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96V464c0 8.8 7.2 16 16 16s16-7.2 16-16V352h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V256h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H197L317 57.4c5.2-7.2 3.5-17.2-3.6-22.3s-17.2-3.5-22.3 3.6l-131 182L29 38.7z"]
};
var faCny = faYenSign;
var faJpy = faYenSign;
var faRmb = faYenSign;
var faYen = faYenSign;
var faGearCode = {
  prefix: 'fal',
  iconName: 'gear-code',
  icon: [512, 512, [], "e5e8", "M225.7 34c-1.1 1-1.9 2.3-2.4 3.8L209.6 85.5c-3.5 12.1-12.2 21.1-22.5 26.1c-7.6 3.6-14.8 7.8-21.7 12.5c-9.4 6.5-21.7 9.5-33.9 6.5l-48.2-12c-1.5-.4-3-.3-4.4 .2c-5.4 6.9-10.4 14.2-15 21.8l-4.2 7.3c-4.2 7.5-7.9 15.3-11.2 23.4c.3 1.5 1 2.9 2.1 4L85.2 211c8.7 9 12.2 21.1 11.3 32.5c-.3 4.1-.5 8.3-.5 12.5s.2 8.4 .5 12.5c.9 11.4-2.6 23.5-11.3 32.5L50.7 336.8c-1.1 1.1-1.8 2.5-2.1 4c3.3 8 7 15.8 11.2 23.4l4.2 7.3c4.6 7.6 9.6 14.8 15 21.8c1.4 .5 2.9 .5 4.4 .2l48.2-12c12.2-3 24.4 0 33.9 6.5c6.9 4.7 14.1 8.9 21.7 12.5c10.3 4.9 19.1 14 22.5 26.1l13.7 47.7c.4 1.5 1.3 2.8 2.4 3.8c9.9 1.3 20 2 30.3 2s20.4-.7 30.3-2c1.1-1 1.9-2.3 2.4-3.8l13.7-47.7c3.5-12.1 12.2-21.1 22.5-26.1c7.6-3.6 14.8-7.8 21.7-12.5c9.4-6.5 21.7-9.5 33.9-6.5l48.2 12c1.5 .4 3 .3 4.4-.2c5.4-6.9 10.4-14.2 14.9-21.8l4.2-7.3c4.2-7.5 7.9-15.3 11.2-23.4c-.3-1.5-1-2.9-2.1-4L426.8 301c-8.7-9-12.2-21.1-11.3-32.5c.3-4.1 .5-8.3 .5-12.5s-.2-8.4-.5-12.5c-.9-11.4 2.6-23.5 11.3-32.5l34.5-35.7c1.1-1.1 1.8-2.5 2.1-4c-3.3-8-7-15.8-11.2-23.3l-4.3-7.4c-4.6-7.6-9.5-14.8-14.9-21.8c-1.4-.5-2.9-.5-4.4-.2l-48.2 12c-12.2 3-24.4 0-33.9-6.5c-6.9-4.7-14.1-8.9-21.7-12.5c-10.3-4.9-19.1-14-22.5-26.1L288.7 37.8c-.4-1.5-1.3-2.8-2.4-3.8c-9.9-1.3-20-2-30.3-2s-20.4 .7-30.3 2zM217.6 2.9C230.1 1 243 0 256 0s25.9 1 38.4 2.9c1.7 .3 3.4 .8 5 1.6c9.5 4.9 16.9 13.6 20 24.5l13.7 47.7c.6 2.2 2.5 4.5 5.6 6c9.1 4.3 17.8 9.4 26 15c2.8 1.9 5.8 2.4 8 1.8l48.2-12c10.9-2.7 22.1-.7 31.1 5.1c1.5 .9 2.8 2.1 3.9 3.5c7.1 8.9 13.6 18.2 19.5 28l.1 .3L480 132l.1 .3c5.4 9.7 10.2 19.9 14.3 30.4c.6 1.6 1 3.3 1.1 5c.5 10.8-3.3 21.6-11.2 29.8l-34.5 35.7c-1.6 1.7-2.7 4.4-2.4 7.8c.4 5 .6 10 .6 15s-.2 10.1-.6 15c-.3 3.4 .8 6.2 2.4 7.8l34.5 35.7c7.9 8.2 11.7 19 11.2 29.8c-.1 1.7-.5 3.4-1.1 5c-4.1 10.5-8.9 20.6-14.3 30.4l-.1 .3-4.4 7.6-.1 .3c-5.9 9.8-12.4 19.2-19.5 28c-1.1 1.4-2.4 2.6-3.9 3.5c-9 5.7-20.2 7.8-31.1 5.1l-48.2-12c-2.2-.6-5.2-.1-8 1.8c-8.2 5.7-16.9 10.7-26 15c-3.1 1.5-4.9 3.8-5.6 6L319.4 483c-3.1 10.8-10.5 19.5-20 24.5c-1.6 .8-3.2 1.4-5 1.6C281.9 511 269 512 256 512s-25.9-1-38.4-2.9c-1.7-.3-3.4-.8-5-1.6c-9.5-4.9-16.9-13.6-20-24.5l-13.7-47.7c-.6-2.2-2.5-4.5-5.6-6c-9.1-4.3-17.8-9.4-26-15c-2.8-1.9-5.8-2.4-8-1.8l-48.2 12c-10.9 2.7-22.1 .7-31.1-5.1c-1.5-.9-2.8-2.1-3.9-3.5C49 407 42.4 397.6 36.5 387.8l-.1-.3L32 380l-.1-.3c-5.4-9.8-10.2-19.9-14.3-30.4c-.6-1.6-1-3.3-1.1-5c-.5-10.8 3.3-21.6 11.2-29.8l34.5-35.7c1.6-1.7 2.7-4.4 2.4-7.8c-.4-5-.6-10-.6-15s.2-10.1 .6-15c.3-3.4-.8-6.2-2.4-7.8L27.7 197.4c-7.9-8.2-11.7-19-11.2-29.8c.1-1.7 .5-3.4 1.1-5c4.1-10.5 8.9-20.6 14.3-30.4l.1-.3 4.4-7.6 .1-.3C42.4 114.3 49 105 56.1 96.1c1.1-1.4 2.4-2.6 3.9-3.5c9-5.7 20.2-7.8 31.1-5.1l48.2 12c2.2 .6 5.2 .1 8-1.8c8.2-5.7 16.9-10.7 26-15c3.1-1.5 4.9-3.8 5.6-6L192.6 29c3.1-10.8 10.5-19.5 20-24.5c1.6-.8 3.2-1.4 5-1.6zm70.2 159.8l-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM187.3 227.3L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm160-22.6l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 256l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faNotes = {
  prefix: 'fal',
  iconName: 'notes',
  icon: [512, 512, [], "e202", "M128 96c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32V256H368c-26.5 0-48 21.5-48 48v80H160c-17.7 0-32-14.3-32-32V96zM446.2 288c-1.6 4.5-4.2 8.7-7.6 12.1l-74.5 74.5c-3.4 3.4-7.6 6-12.1 7.6V304c0-8.8 7.2-16 16-16h78.2zM96 96V352c0 35.3 28.7 64 64 64H341.5c17 0 33.3-6.7 45.3-18.7l74.5-74.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM320 496c0-8.8-7.2-16-16-16H128c-53 0-96-43-96-96l0-240c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H304c8.8 0 16-7.2 16-16z"]
};
var faRubleSign = {
  prefix: 'fal',
  iconName: 'ruble-sign',
  icon: [384, 512, [8381, "rouble", "rub", "ruble"], "f158", "M104.7 32C82.2 32 64 50.2 64 72.7V288H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H104.7zM96 288V72.7c0-4.8 3.9-8.7 8.7-8.7H240c61.9 0 112 50.1 112 112s-50.1 112-112 112H96z"]
};
var faRouble = faRubleSign;
var faRub = faRubleSign;
var faRuble = faRubleSign;
var faTrashUndo = {
  prefix: 'fal',
  iconName: 'trash-undo',
  icon: [448, 512, ["trash-arrow-turn-left"], "f895", "M177.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L299.1 64H148.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0H177.7C161.2 0 145.8 8.5 137 22.6L111.1 64H64.1 32 16C7.2 64 0 71.2 0 80s7.2 16 16 16H34.3L59.8 452.6C62.1 486.1 90 512 123.6 512H324.4c33.6 0 61.4-25.9 63.8-59.4L413.7 96H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416 383.9 336.9zm44.8 32L356.3 450.3C355.1 467 341.2 480 324.4 480H123.6c-16.8 0-30.7-13-31.9-29.7L66.4 96H381.6zM219.9 189.3c-5.9-6.6-16-7.1-22.6-1.2l-80 72c-3.4 3-5.3 7.4-5.3 11.9s1.9 8.9 5.3 11.9l80 72c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6l-49-44.1H240c26.5 0 48 21.5 48 48v40c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-44.2-35.8-80-80-80H169.7l49-44.1c6.6-5.9 7.1-16 1.2-22.6z"]
};
var faTrashArrowTurnLeft = faTrashUndo;
var faChampagneGlass = {
  prefix: 'fal',
  iconName: 'champagne-glass',
  icon: [320, 512, ["glass-champagne"], "f79e", "M74.5 160h171l7.3 53.6C260.5 269.9 216.8 320 160 320s-100.5-50.1-92.8-106.4L74.5 160zm4.4-32L91.9 32l136.1 0 13.1 96H78.8zM60.2 27.7L35.5 209.3C25.9 279.4 75.8 342.4 144 351V480H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V351c68.2-8.6 118.1-71.6 108.5-141.7L259.8 27.7C257.6 11.8 244.1 0 228.1 0H91.9c-16 0-29.5 11.8-31.7 27.7z"]
};
var faGlassChampagne = faChampagneGlass;
var faObjectsAlignCenterHorizontal = {
  prefix: 'fal',
  iconName: 'objects-align-center-horizontal',
  icon: [512, 512, [], "e3bc", "M448 176c0 8.8-7.2 16-16 16l-176 0L80 192c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l176 0 0 0 0 0 176 0c8.8 0 16 7.2 16 16l0 64zM272 224l160 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L272 64l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L80 64c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0 0 64-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 96 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-96 0 0-64zm-16 96l112 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-112 0-112 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l112 0z"]
};
var faSun = {
  prefix: 'fal',
  iconName: 'sun',
  icon: [512, 512, [9728], "f185", "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zM265.1 97.7l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-3.8 5.5-3.8 12.7 0 18.2l54.5 79.1-94.5 17.4c-6.5 1.2-11.6 6.3-12.8 12.8l-17.4 94.5-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faTrashCanSlash = {
  prefix: 'fal',
  iconName: 'trash-can-slash',
  icon: [640, 512, ["trash-alt-slash"], "e2ad", "M512 96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H512 480 432.9L407 22.6C398.2 8.5 382.8 0 366.3 0H273.7C257.2 0 241.8 8.5 233 22.6L207.1 64h-27l40.5 32H480V300.8L512 326V96zM472.4 457.9C463.9 471.2 449 480 432 480H208c-26.5 0-48-21.5-48-48V211.2L128 186V432c0 44.2 35.8 80 80 80H432c27.2 0 51.2-13.5 65.6-34.2l-25.2-19.9zM208 400c0 8.8 7.2 16 16 16s16-7.2 16-16V274.4l-32-25.3V400zm96 0c0 8.8 7.2 16 16 16s16-7.2 16-16V350.2l-32-25.3V400zm96-162.4l32 25.3V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v61.6zM260.2 39.5c2.9-4.7 8.1-7.5 13.6-7.5h92.5c5.5 0 10.6 2.8 13.6 7.5L395.1 64H244.9l15.3-24.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTrashAltSlash = faTrashCanSlash;
var faScreenUsers = {
  prefix: 'fal',
  iconName: 'screen-users',
  icon: [640, 512, ["users-class"], "f63d", "M544 32H96C78.3 32 64 46.3 64 64V229.5c-11.9 4.2-22.8 10.7-32 19V64C32 28.7 60.7 0 96 0H544c35.3 0 64 28.7 64 64V248.4c-9.2-8.3-20.1-14.8-32-19V64c0-17.7-14.3-32-32-32zM96 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm224 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 480v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm256-32c-17.7 0-32 14.3-32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-17.7-14.3-32-32-32H288zm192 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-17.7-14.3-32-32-32H512c-17.7 0-32 14.3-32 32z"]
};
var faUsersClass = faScreenUsers;
var faGuitar = {
  prefix: 'fal',
  iconName: 'guitar',
  icon: [512, 512, [], "f7a6", "M445.7 33c.6-.6 1.5-1 2.3-1s1.7 .3 2.3 1L479 61.7c.6 .6 1 1.5 1 2.3s-.3 1.7-1 2.3l-39 39-42.9 9.5L406.6 72l39-39zM376.4 60.5l-15 67.5-35.5 35.5c-51.7-42.9-120-48-158.3-9.6c-12 12-19.7 26.8-23.4 43.2c-4.1 18.1-20.8 33.5-39.4 34.5C76.9 233 51 243.2 31.4 262.8C-17.4 311.7-8.3 400 51.8 460.2s148.5 69.3 197.4 20.4c19.6-19.6 29.8-45.5 31.2-73.4c.9-18.5 16.4-35.3 34.5-39.4c16.4-3.7 31.2-11.4 43.2-23.4c38.3-38.3 33.3-106.6-9.6-158.3L384 150.6l67.5-15c3-.7 5.7-2.2 7.8-4.3L501.7 89c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L473 10.3C466.3 3.7 457.4 0 448 0s-18.3 3.7-25 10.3L380.7 52.7c-2.2 2.2-3.6 4.9-4.3 7.8zM303.1 186.2l-74.4 74.4c-6.3-3-13.3-4.7-20.7-4.7c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-7.4-1.7-14.4-4.7-20.7l74.4-74.4c34.5 42.9 31.7 91 9.7 113c-7.3 7.3-16.6 12.3-27.6 14.8c-30.7 6.9-57.7 34.7-59.4 69c-1.1 21-8.6 39.1-21.9 52.4c-32.2 32.2-99.9 31.8-152.1-20.4S21.8 317.6 54 285.4c13.3-13.3 31.4-20.9 52.4-21.9c34.3-1.7 62.1-28.7 69-59.4c2.5-11 7.5-20.3 14.8-27.6c22-22 70.1-24.8 113 9.7zM208 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faSquareArrowLeft = {
  prefix: 'fal',
  iconName: 'square-arrow-left',
  icon: [448, 512, ["arrow-square-left"], "f33a", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm36.7-235.3l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L150.6 240 336 240c8.8 0 16 7.2 16 16s-7.2 16-16 16l-185.4 0 68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faArrowSquareLeft = faSquareArrowLeft;
var faSquare8 = {
  prefix: 'fal',
  iconName: 'square-8',
  icon: [448, 512, [], "e25d", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm172 96H212c-37.6 0-68 30.4-68 68c0 20.2 8.8 38.4 22.9 50.9C148.1 260.7 136 282.9 136 308c0 42 34 76 76 76h24c42 0 76-34 76-76c0-25.1-12.1-47.3-30.9-61.1c14-12.5 22.9-30.6 22.9-50.9c0-37.6-30.4-68-68-68zM212 232c-19.9 0-36-16.1-36-36s16.1-36 36-36h24c19.9 0 36 16.1 36 36s-16.1 36-36 36H212s0 0 0 0zm0 32s0 0 0 0h24c24.3 0 44 19.7 44 44s-19.7 44-44 44H212c-24.3 0-44-19.7-44-44s19.7-44 44-44z"]
};
var faFaceSmileHearts = {
  prefix: 'fal',
  iconName: 'face-smile-hearts',
  icon: [640, 512, [], "e390", "M422.7 21.4C391.3 7.7 356.5 0 320 0C178.6 0 64 114.6 64 256c0 11.1 .7 22 2.1 32.7c10.4 1.4 20.5 4.6 30 9.7c1.2-.6 2.4-1.3 3.6-1.8C97.3 283.4 96 269.9 96 256C96 132.3 196.3 32 320 32c34.4 0 66.9 7.7 96 21.6c.2-10.9 2.4-21.9 6.7-32.1zM534.5 191.3c6.2 20.5 9.5 42.2 9.5 64.7c0 24.2-3.8 47.6-11 69.4c3.8 1.4 7.4 3.1 11 5c7.4-4 15.3-6.8 23.4-8.5c5.6-21 8.6-43.1 8.6-65.9c0-23.6-3.2-46.4-9.1-68c-10.4 3.8-21.5 4.9-32.3 3.3zM428.5 452c-32.1 17.8-69.1 28-108.5 28c-46.7 0-90.1-14.3-126-38.7l-22.9 23c41.9 30 93.3 47.7 148.9 47.7c47.3 0 91.6-12.8 129.6-35.2l-8.3-8.3c-5-5.1-9.3-10.6-12.9-16.5zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm-69.7 90.3c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 346.2 363.4 368 320 368s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm159.3-90.3c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM486.7 38.7c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0l13.7-13.8c8.9-9 23.3-9 32.2 0c9 9 9 23.7 0 32.7l-55.4 55.8c-1 1-2.6 1-3.6 0L486.7 71.4c-9-9-9-23.7 0-32.7zm54.9-22.6c-21.4-21.6-56.2-21.6-77.6 0c-21.4 21.5-21.4 56.3 0 77.8l55.5 55.8c13.5 13.6 35.5 13.6 49 0L624 94c21.4-21.5 21.4-56.3 0-77.8c-21.4-21.6-56.2-21.6-77.6 0L544 18.6l-2.4-2.4zm-448 320c-21.4-21.6-56.2-21.6-77.6 0C-5.3 357.7-5.3 392.5 16 414l55.5 55.8c13.5 13.6 35.5 13.6 49 0L176 414c21.4-21.5 21.4-56.3 0-77.8c-21.4-21.6-56.2-21.6-77.6 0L96 338.6l-2.4-2.4zM38.7 358.7c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0l13.7-13.8c8.9-9 23.3-9 32.2 0c9 9 9 23.7 0 32.7L97.9 447.2c-1 1-2.6 1-3.6 0L38.7 391.4c-9-9-9-23.7 0-32.7zm448 32c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0l13.7-13.8c8.9-9 23.3-9 32.2 0c9 9 9 23.7 0 32.7l-55.4 55.8c-1 1-2.6 1-3.6 0l-55.5-55.8c-9-9-9-23.7 0-32.7zm54.9-22.6c-21.4-21.6-56.2-21.6-77.6 0c-21.4 21.5-21.4 56.3 0 77.8l55.5 55.8c13.5 13.6 35.5 13.6 49 0L624 446c21.4-21.5 21.4-56.3 0-77.8c-21.4-21.6-56.2-21.6-77.6 0l-2.3 2.3-2.4-2.4z"]
};
var faBracketsSquare = {
  prefix: 'fal',
  iconName: 'brackets-square',
  icon: [448, 512, ["brackets"], "f7e9", "M48 32C21.5 32 0 53.5 0 80V432c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm352 0H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
};
var faBrackets = faBracketsSquare;
var faLaptopArrowDown = {
  prefix: 'fal',
  iconName: 'laptop-arrow-down',
  icon: [640, 512, [], "e1c6", "M128 32H272V64H128c-17.7 0-32 14.3-32 32V352H64V96c0-35.3 28.7-64 64-64zM512 64H368V32H512c35.3 0 64 28.7 64 64V352H544V96c0-17.7-14.3-32-32-32zM76.8 448H563.2c20.3 0 37.4-13.5 42.9-32H33.9c5.5 18.5 22.7 32 42.9 32zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM336 48V265.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L304 265.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHockeyStickPuck = {
  prefix: 'fal',
  iconName: 'hockey-stick-puck',
  icon: [640, 512, [], "e3ae", "M503.3 1.8c7.8 4.1 10.9 13.7 6.9 21.6l-234.6 454c-11 21.3-32.9 34.6-56.9 34.6H56c-30.9 0-56-25.1-56-56V376c0-30.9 25.1-56 56-56H320.9L481.8 8.7c4.1-7.9 13.7-10.9 21.6-6.9zM304.4 352H128V480h90.8c12 0 22.9-6.7 28.4-17.3L304.4 352zM56 352c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24H96V352H56zm376 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H592c8.8 0 16-7.2 16-16V448c0-8.8-7.2-16-16-16H432zm-48 16c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48v16c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V448z"]
};
var faHouseTree = {
  prefix: 'fal',
  iconName: 'house-tree',
  icon: [640, 512, [], "e1b3", "M404.1 37.1c6.4-7.1 17.4-7.1 23.8 0L538.5 160H480c-6.2 0-11.8 3.6-14.5 9.1s-1.8 12.2 2.1 17L575.8 318.6c.1 .2 .2 .3 .2 .5c0 .5-.4 .9-.9 .9H496c-6.3 0-12.1 3.7-14.6 9.5s-1.4 12.6 2.8 17.2L606 480H414.4c-2.4 11.8-7.4 22.7-14.4 32H609.6c16.8 0 30.4-13.6 30.4-30.4c0-7.6-2.8-14.9-8-20.5L532.3 352h42.8c18.1 0 32.9-14.7 32.9-32.9c0-7.6-2.6-14.9-7.4-20.8L513.7 192h34.7c15.2 0 27.6-12.3 27.6-27.6c0-6.8-2.5-13.4-7.1-18.4L451.7 15.7c-19.1-21.2-52.3-21.2-71.4 0l-95.4 106 23.6 21.6L404.1 37.1zM32 284.2c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V284.2zM0 448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237C7.5 249.1 0 266.2 0 284.2V448zM224 288v64H160V288h64zm-64-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H160z"]
};
var faSignalFair = {
  prefix: 'fal',
  iconName: 'signal-fair',
  icon: [640, 512, ["signal-2"], "f68d", "M208 304c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM80 400c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400z"]
};
var faSignal2 = faSignalFair;
var faFaceLaughWink = {
  prefix: 'fal',
  iconName: 'face-laugh-wink',
  icon: [512, 512, ["laugh-wink"], "f59c", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288H385.5c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm25.9-96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faLaughWink = faFaceLaughWink;
var faCircleDollar = {
  prefix: 'fal',
  iconName: 'circle-dollar',
  icon: [512, 512, ["dollar-circle", "usd-circle"], "f2e8", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 120v23c13.5 1 26.6 4.6 39.6 8.3c1.5 .4 3.1 .9 4.6 1.3c8.5 2.4 13.5 11.2 11.2 19.7s-11.2 13.5-19.7 11.2c-2.4-.7-4.8-1.4-7.2-2.1c-7.5-2.2-15.2-4.4-22.9-5.5c-19.1-2.8-36.6-.4-49.3 5.1c-12.9 5.6-18.6 13.1-19.8 19.5c-1.8 9.8 2.1 16.5 10.2 21.7c10.6 6.8 26.5 11.3 45.8 16.8l.3 .1c17.7 5 38.9 11.1 54.3 21.7c19 13 27.8 33.8 23.6 56.5c-4 21.6-18.9 36-37.8 43.6c-9.9 4-21.1 6.3-33.1 6.9l0 24.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.9c-8.1-1.3-21.8-5.2-32.4-8.4c-6.9-2.1-13.8-4.3-20.7-6.5c-8.4-2.8-12.9-11.8-10.2-20.2s11.8-12.9 20.2-10.2c6.6 2.2 13.2 4.3 19.9 6.3c11.2 3.4 22.7 6.6 28.1 7.4c19.8 2.9 36.5 1.3 48-3.4c11.2-4.5 16.8-11.3 18.3-19.7c1.9-10.5-1.5-18.4-10.2-24.4c-12-8.2-26.8-12.3-40.9-16.2c-2.3-.6-4.7-1.3-6.9-1.9c-17.1-4.8-37-10.5-51.7-19.9c-8.1-5.2-15.7-12.1-20.5-21.7c-4.9-9.8-6.2-20.8-4-32.8c3.8-20.7 20-35.1 38.6-43.1c7.4-3.2 15.6-5.6 24.3-7.1V120c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDollarCircle = faCircleDollar;
var faUsdCircle = faCircleDollar;
var faHorseHead = {
  prefix: 'fal',
  iconName: 'horse-head',
  icon: [640, 512, [], "f7ab", "M404 40.2c13.7-4.8 28 5.4 28 19.9c0 7-3.5 13.6-9.4 17.5l-31.5 21c-5.3 3.5-8 9.8-6.9 16s5.7 11.3 11.9 12.8l7 1.8c32.1 8 59.4 28.9 75.6 57.8l54.4 97.2c13.9 24.9 10.6 55.9-8.4 77.2c-12.7 14.3-30.9 22.5-50.1 22.5H467c-22.2 0-43.2-10.3-56.8-27.8l-26-33.5c-7.4-9.5-21.1-11.2-30.6-3.8c-31.5 24.5-76.6 20.7-103.5-8.7l-30.3-33c-6-6.5-16.1-7-22.6-1s-7 16.1-1 22.6l30.3 33c22.3 24.3 53.2 36.3 84 35.2c.2 .6 .5 1.2 .8 1.7l35.9 66.4c3.1 5.8 4.8 12.3 4.8 18.9c0 14.3-11.6 25.9-25.9 25.9H128c-17.7 0-32-14.3-32-32V318c0-102.2 64.7-193.1 161.2-226.7L404 40.2zM375.4 420l-32-59.3c7.4-2.7 14.7-6.2 21.6-10.6l20 25.8c19.7 25.3 50 40.2 82.1 40.2h7.7c28.3 0 55.2-12.1 74-33.2c28-31.5 33-77.3 12.4-114.1l-54.4-97.2c-16-28.7-40.8-51.1-70.4-64.4l4.1-2.7C455.1 94.5 464 77.9 464 60.2C464 23.6 428-2 393.5 10L246.6 61.1C137.3 99.1 64 202.2 64 318V448c0 35.3 28.7 64 64 64H326.1c32 0 57.9-25.9 57.9-57.9c0-11.9-3-23.7-8.6-34.2zM400 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowsRepeat = {
  prefix: 'fal',
  iconName: 'arrows-repeat',
  icon: [512, 512, ["repeat-alt"], "f364", "M15.2 272C6.4 271.5-.4 264 0 255.2l.4-8C5.1 153.5 82.4 80 176.2 80H390.6L333.2 27.8c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1l88 80c3.3 3 5.2 7.3 5.2 11.8s-1.9 8.8-5.2 11.8l-88 80c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6L390.6 112H176.2c-76.7 0-140 60.2-143.8 136.8l-.4 8c-.4 8.8-8 15.6-16.8 15.2zm481.6-32c8.8 .4 15.6 8 15.2 16.8l-.4 8c-4.7 93.7-82 167.2-175.8 167.2H121.4l57.4 52.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1s5.5 16.7-1.1 22.6L121.4 400H335.8c76.7 0 140-60.2 143.8-136.8l.4-8c.4-8.8 8-15.6 16.8-15.2z"]
};
var faRepeatAlt = faArrowsRepeat;
var faBoreHole = {
  prefix: 'fal',
  iconName: 'bore-hole',
  icon: [512, 512, [], "e4c3", "M256 0c-8.8 0-16 7.2-16 16V258c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62V16c0-8.8-7.2-16-16-16zm32 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM80 160h48V320c0 70.7 57.3 128 128 128s128-57.3 128-128V160h48c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V208c0-26.5 21.5-48 48-48zm80 0c0-17.7-14.3-32-32-32H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V208c0-44.2-35.8-80-80-80H384c-17.7 0-32 14.3-32 32V320c0 53-43 96-96 96s-96-43-96-96V160z"]
};
var faIndustry = {
  prefix: 'fal',
  iconName: 'industry',
  icon: [576, 512, [], "f275", "M80 64c-8.8 0-16 7.2-16 16V304v48 64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V320 304 158.9c0-6.5-7.4-10.3-12.7-6.5l-138 99.3c-4.9 3.5-11.3 4-16.6 1.3s-8.7-8.2-8.7-14.2V156.8c0-6.4-7.1-10.2-12.4-6.7L184.9 242.6c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V80c0-8.8-7.2-16-16-16H80zM32 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V199.4l113.8-75.9c26.6-17.7 62.2 1.3 62.2 33.3v50.6l112.6-81.1c26.5-19.1 63.4-.1 63.4 32.5V304v16 96c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V352 304 80z"]
};
var faImagePolaroid = {
  prefix: 'fal',
  iconName: 'image-polaroid',
  icon: [448, 512, [], "f8c4", "M416 384v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384H416zM105.4 352H32v-9.4l96-96L169.4 288l-60.7 60.7-3.3 3.3zm45.3 0l52.7-52.7L288 214.6l128 128V352H150.6zM416 297.4L310.6 192c-12.5-12.5-32.8-12.5-45.3 0L192 265.4 150.6 224c-12.5-12.5-32.8-12.5-45.3 0L32 297.4V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V297.4zM448 336V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V336s0 0 0 0v16 16 16 32c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384 368 352 336s0 0 0 0zM128 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faWaveTriangle = {
  prefix: 'fal',
  iconName: 'wave-triangle',
  icon: [640, 512, [], "f89a", "M176.1 32c5.2 0 10.1 2.6 13 6.9l275 397.3L611 230.7c5.1-7.2 15.1-8.9 22.3-3.7s8.9 15.1 3.7 22.3l-160 224c-3 4.2-7.9 6.7-13.1 6.7s-10.1-2.6-13-6.9L175.8 75.8 29 281.3c-5.1 7.2-15.1 8.9-22.3 3.7s-8.9-15.1-3.7-22.3l160-224c3-4.2 7.9-6.7 13.1-6.7z"]
};
var faPersonRunningFast = {
  prefix: 'fal',
  iconName: 'person-running-fast',
  icon: [512, 512, [], "e5ff", "M352 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 320 56a56 56 0 1 0 112 0zM275.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L149.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L249.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L320.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L394.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L394 253.2c5.9 20.6 24.7 34.8 46.2 34.8H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H440.1c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7L314.3 302.4 286.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM226 314.1L197.3 384H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zM16 95.8c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm-16 80c0 8.8 7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faCircleDown = {
  prefix: 'fal',
  iconName: 'circle-down',
  icon: [512, 512, [61466, "arrow-alt-circle-down"], "f358", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm0-112c-9.2 0-18-3.5-24.7-9.7l-91-84c-7.8-7.2-12.3-17.4-12.3-28.1c0-21.1 17.1-38.3 38.3-38.3H192V160c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v80h25.7c21.1 0 38.3 17.1 38.3 38.3c0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7zm-3-33.2c.8 .8 1.9 1.2 3 1.2s2.2-.4 3-1.2l91-84c1.3-1.2 2-2.9 2-4.6c0-3.5-2.8-6.3-6.3-6.3H304c-8.8 0-16-7.2-16-16V160c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16H166.3c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.4 2 4.6l91 84z"]
};
var faArrowAltCircleDown = faCircleDown;
var faGrill = {
  prefix: 'fal',
  iconName: 'grill',
  icon: [448, 512, [], "e5a3", "M408 64c4.4 0 8 3.6 8 8V96c0 106-86 192-192 192S32 202 32 96V72c0-4.4 3.6-8 8-8H408zM40 32C17.9 32 0 49.9 0 72V96c0 92.5 56 171.9 136 206.1l-23.7 52c-5.2-1.4-10.7-2.1-16.4-2.1c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64H328.6l24.8 54.6c3.7 8 13.1 11.6 21.2 7.9s11.6-13.1 7.9-21.2L312 302.1C392 267.9 448 188.5 448 96V72c0-22.1-17.9-40-40-40H40zM140.4 369.9l26.1-57.3c18.4 4.9 37.7 7.5 57.6 7.5s39.2-2.6 57.6-7.5L314.1 384H151.4c-3-5.2-6.8-10-11.1-14.1zM96 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faArrowsTurnToDots = {
  prefix: 'fal',
  iconName: 'arrows-turn-to-dots',
  icon: [512, 512, [], "e4c1", "M260.7 36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L230.6 112 432 112c44.2 0 80 35.8 80 80v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-26.5-21.5-48-48-48l-201.4 0 52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6l80-80zm-9.4 256l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L281.4 400 80 400c-26.5 0-48 21.5-48 48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448c0-44.2 35.8-80 80-80l201.4 0-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM448 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM32 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0A64 64 0 1 1 0 128a64 64 0 1 1 128 0z"]
};
var faChartMixed = {
  prefix: 'fal',
  iconName: 'chart-mixed',
  icon: [512, 512, ["analytics"], "f643", "M507.8 37.2c5.9 6.5 5.5 16.7-1.1 22.6l-176 160c-6.3 5.7-16 5.5-22.1-.5L190.4 101 25.4 220.9c-7.1 5.2-17.2 3.6-22.4-3.5s-3.6-17.2 3.5-22.4l176-128c6.4-4.6 15.2-3.9 20.7 1.6L320.5 185.9 485.2 36.2c6.5-5.9 16.7-5.5 22.6 1.1zM80 432V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16zM64 320c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm144-48c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V272zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48V432c0 26.5-21.5 48-48 48s-48-21.5-48-48V272zM336 432V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16zM320 288c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48s-48-21.5-48-48V336c0-26.5 21.5-48 48-48zm144-16c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V272zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48V432c0 26.5-21.5 48-48 48s-48-21.5-48-48V272z"]
};
var faAnalytics = faChartMixed;
var faFlorinSign = {
  prefix: 'fal',
  iconName: 'florin-sign',
  icon: [384, 512, [], "e184", "M322.4 32c-32.1 0-61.2 19.2-73.7 48.8L188.2 224H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H174.6L105.8 418.7C98.3 436.5 80.9 448 61.6 448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H61.6c32.1 0 61.2-19.2 73.7-48.8L209.4 256H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H222.9L278.2 93.3C285.7 75.5 303.1 64 322.4 64H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H322.4z"]
};
var faArrowDownShortWide = {
  prefix: 'fal',
  iconName: 'arrow-down-short-wide',
  icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", "M235.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM304 48h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSortAmountDesc = faArrowDownShortWide;
var faSortAmountDownAlt = faArrowDownShortWide;
var faLessThan = {
  prefix: 'fal',
  iconName: 'less-than',
  icon: [384, 512, [62774], "3c", "M382.3 72.8c4 7.9 .7 17.5-7.2 21.5L51.8 256 375.2 417.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-352-176C3.4 267.6 0 262.1 0 256s3.4-11.6 8.8-14.3l352-176c7.9-4 17.5-.7 21.5 7.2z"]
};
var faDisplayCode = {
  prefix: 'fal',
  iconName: 'display-code',
  icon: [576, 512, ["desktop-code"], "e165", "M512 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H344.3c-.2 0-.4 0-.6 0H232.3c-.2 0-.4 0-.6 0H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H512zM64 416H213.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H360h72c8.8 0 16-7.2 16-16s-7.2-16-16-16H373.6l-10.7-64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm170.9 64l10.7-64h84.9l10.7 64H234.9zm16.4-324.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L198.6 208l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L377.4 208l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"]
};
var faDesktopCode = faDisplayCode;
var faFaceDrooling = {
  prefix: 'fal',
  iconName: 'face-drooling',
  icon: [512, 512, [], "e372", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c8.8 0 16-7.2 16-16s-7.2-16-16-16C132.3 480 32 379.7 32 256zM352 370.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V344.2c4.6-4.7 8.7-9.5 12.5-14.2c5.5-6.9 4.4-17-2.5-22.5s-17-4.4-22.5 2.5c-22.8 28.5-61.3 58-115.5 58s-92.7-29.5-115.5-58c-5.5-6.9-15.6-8-22.5-2.5s-8 15.6-2.5 22.5c26.7 33.4 73.5 70 140.5 70c11.2 0 21.9-1 32-2.9V464c0 8.8 7.2 16 16 16s16-7.2 16-16V387.8c11.7-4.7 22.3-10.4 32-16.9zM158.6 189.6c8.2-7.8 19.1-13.6 33.4-13.6c8.8 0 16-7.2 16-16s-7.2-16-16-16c-24.1 0-42.5 10.2-55.4 22.4c-12.6 12-20.4 26.3-23.8 36.5c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1c1.9-5.8 7-15.4 15.4-23.5zm210.2 23.5c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2c-3.4-10.2-11.1-24.6-23.8-36.5C362.5 154.2 344.1 144 320 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c14.3 0 25.2 5.8 33.4 13.6c8.4 8 13.5 17.7 15.4 23.5z"]
};
var faOilTemperature = {
  prefix: 'fal',
  iconName: 'oil-temperature',
  icon: [576, 512, ["oil-temp"], "f614", "M272 32c0-17.7 14.3-32 32-32h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304V96h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304v97.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V112 32zm16 320a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM133.8 314.8c13.5 9.2 29.7 17.5 46.6 20.2c3.4 11.9 8.8 23 15.7 32.9c-1.3 .1-2.7 .1-4 .1c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 368.1 0 360 0 350.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM384 368c-1.3 0-2.7 0-4-.1c6.9-9.9 12.2-21 15.7-32.9c16.8-2.8 33.1-11.1 46.5-20.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 353.9 414.3 368 384 368zM192 480c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z"]
};
var faOilTemp = faOilTemperature;
var faSquareQuestion = {
  prefix: 'fal',
  iconName: 'square-question',
  icon: [448, 512, ["question-square"], "f2fd", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm136.7 73.8c6.5-24.6 28.7-41.8 54.2-41.8H248c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L240 268.3V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V258.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H190.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM200 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faQuestionSquare = faSquareQuestion;
var faAirConditioner = {
  prefix: 'fal',
  iconName: 'air-conditioner',
  icon: [576, 512, [], "f8f4", "M64 32C46.3 32 32 46.3 32 64V192c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm112 64H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 288V432c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-29.6 16.1-55.5 40-69.3c7.6-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6c0 26.5 21.5 48 48 48s48-21.5 48-48V288h32zm64 112V288h32V400c0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.7-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8c23.9 13.8 40 39.7 40 69.3c0 44.2-35.8 80-80 80s-80-35.8-80-80z"]
};
var faAngleDown = {
  prefix: 'fal',
  iconName: 'angle-down',
  icon: [448, 512, [8964], "f107", "M212.7 331.3c6.2 6.2 16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4 75.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l160 160z"]
};
var faMountains = {
  prefix: 'fal',
  iconName: 'mountains',
  icon: [640, 512, [9968], "f6fd", "M480 424.1c0 13.2-10.7 23.9-23.9 23.9H55.9C42.7 448 32 437.3 32 424.1c0-4.5 1.3-8.9 3.7-12.7L252.4 66c.8-1.3 2.2-2 3.6-2s2.9 .8 3.6 2L476.3 411.4c2.4 3.8 3.7 8.2 3.7 12.7zm-480 0C0 455 25 480 55.9 480H456.1 578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 164.1 487.8 160 480 160s-15 4.1-19.1 10.7l-48.2 79L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1zM431.7 280L480 200.9 603.7 403.7c2.8 4.6 4.3 9.8 4.3 15.2c0 16.1-13 29.1-29.1 29.1H506.6c3.4-7.3 5.4-15.4 5.4-23.9c0-10.5-3-20.8-8.6-29.7L431.7 280z"]
};
var faOmega = {
  prefix: 'fal',
  iconName: 'omega',
  icon: [448, 512, [], "f67a", "M224 64C118 64 32 150 32 256c0 69.5 36.9 130.4 92.3 164.1c9.4 5.7 15.9 16.1 15.9 27.9c0 17.7-14.3 32-32 32H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h92.2l0 0c0 0 0 0 0-.1c-.1-.1-.2-.3-.5-.5C43.1 408.2 0 337.1 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 81.1-43.1 152.1-107.6 191.4c-.3 .2-.4 .3-.5 .5c0 0 0 .1 0 .1l0 0H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H339.8c-17.7 0-32-14.3-32-32c0-11.8 6.5-22.2 15.9-27.9C379.1 386.4 416 325.5 416 256c0-106-86-192-192-192z"]
};
var faCarTunnel = {
  prefix: 'fal',
  iconName: 'car-tunnel',
  icon: [512, 512, [], "e4de", "M256 32C132.3 32 32 132.3 32 256V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V256C0 114.6 114.6 0 256 0S512 114.6 512 256V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V256C480 132.3 379.7 32 256 32zM174.7 266.7l-19 54.3c4-.7 8.1-1 12.2-1H344c4.2 0 8.3 .4 12.2 1l-19-54.3C335 260.3 329 256 322.2 256H189.8c-6.8 0-12.9 4.3-15.1 10.7zm-61.2 78.2l31-88.7c6.7-19.3 24.9-32.2 45.3-32.2H322.2c20.4 0 38.6 12.9 45.3 32.2l31 88.7C409.4 357.5 416 374 416 392V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H128v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V392c0-18 6.6-34.5 17.5-47.1zM128 448H384V392c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40v56zm32-48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPersonDollyEmpty = {
  prefix: 'fal',
  iconName: 'person-dolly-empty',
  icon: [512, 512, [], "f4d1", "M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM0 340.3c.5 .4 1.1 .9 1.6 1.3L32 365.5 32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 340.3zM32 204v74.9c0 5.3 2.7 10.3 7.1 13.3L80 319.4V180.2c-6.2-2.7-13-4.2-20-4.2c-15.5 0-28 12.5-28 28zm117.8 69.3L112 214.5V340.8L139.4 359c7.1 4.7 12 12 13.6 20.3l22.7 113.5c1.7 8.7-3.9 17.1-12.6 18.8s-17.1-3.9-18.8-12.6L121.6 385.6 21.4 318.8C8 309.9 0 294.9 0 278.9V204c0-33.1 26.9-60 60-60c27.9 0 53.9 14.2 69 37.6L176.7 256h44l-20.3-84.2c-2.1-8.6 3.2-17.2 11.8-19.3s17.2 3.2 19.3 11.8l53.1 219.8c1.1-.1 2.2-.1 3.4-.1c25.7 0 47.9 15.1 58 37l146.1-36.5c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-148 37c-2.3 33.2-30 59.5-63.8 59.5c-35.3 0-64-28.7-64-64c0-22.9 12-42.9 30-54.3L228.5 288H176.7c-10.9 0-21-5.5-26.9-14.7zM288 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faPanFood = {
  prefix: 'fal',
  iconName: 'pan-food',
  icon: [640, 512, [129368], "e42b", "M522.4 352c4.5-9.4 8.3-19.3 11.5-29.4c.3-.9 .5-1.7 .8-2.6c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64c-3.1-10.6-7-20.8-11.6-30.7l-.6-1.3C486.5 84.3 409.4 32 320 32s-166.5 52.3-202.4 128c-4.9 10.2-9 20.9-12.3 32l0 0c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64c3.1 10.6 7 20.8 11.6 30.7l.6 1.3c36 75.7 113.1 128 202.4 128s166.5-52.3 202.4-128zm34.9 0c-38 93.8-130 160-237.4 160s-199.4-66.2-237.4-160H40c-22.1 0-40-17.9-40-40V200c0-22.1 17.9-40 40-40H82.6C120.6 66.2 212.6 0 320 0S519.4 66.2 557.4 160H600c22.1 0 40 17.9 40 40V312c0 22.1-17.9 40-40 40H557.4zm10.5-160c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H600c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H567.9zM72.1 192H40c-4.4 0-8 3.6-8 8V312c0 4.4 3.6 8 8 8H72.1c-5.3-20.5-8.1-41.9-8.1-64s2.8-43.5 8.1-64zM417.6 336c-21.5 0-42.2-8.6-57.4-23.8c-4.5-4.5-4.5-11.9 0-16.4l95.6-95.6c4.5-4.5 11.9-4.5 16.5 .1C487.4 215.4 496 236 496 257.3v2.4c0 27.4-14.7 52.6-38.4 66.2c-11.5 6.6-24.6 10-37.8 10l-2.1 0zM464 257.3c0-5.8-1.1-11.5-3.1-17l-60.5 60.5c5.5 2 11.3 3.1 17.3 3.1l2.1 0c7.7 0 15.3-2 22-5.8c13.8-7.9 22.3-22.5 22.3-38.4v-2.4zm-260.7-54l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM235.3 299.3c-2.6 2.6-2.6 6.8 0 9.4l6.6 6.6c3 3 7.1 4.7 11.3 4.7H256h32c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64V352v-2.7c0-4.2-1.7-8.3-4.7-11.3l-6.6-6.6c-2.6-2.6-6.8-2.6-9.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 16-16c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM320 384c0-17.7-14.3-32-32-32H272c-8.8 0-16 7.2-16 16v16c0 17.7 14.3 32 32 32s32-14.3 32-32zm0-288c-20.9 0-38.7 13.4-45.3 32h90.5c-6.6-18.6-24.4-32-45.3-32zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16z"]
};
var faHeadSideCough = {
  prefix: 'fal',
  iconName: 'head-side-cough',
  icon: [640, 512, [], "e061", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v8 8 10.1l-79 11.3c-18.9 2.7-33 18.9-33 38c0 20 15.3 36.6 35.2 38.2l59.9 5C396.2 448.7 387 456 376 456H304c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-8h56c30.9 0 56-25.1 56-56v-8c0-8.3-6.4-15.3-14.7-15.9l-75.5-6.3c-3.3-.3-5.8-3-5.8-6.4c0-3.2 2.3-5.9 5.5-6.3l92.8-13.3c7.9-1.1 13.7-7.9 13.7-15.8V336v0h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0 0 0 0 0 0 0 0 0 0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm312 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM512 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM552 368a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM552 464a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faGripLines = {
  prefix: 'fal',
  iconName: 'grip-lines',
  icon: [448, 512, [], "f7a4", "M448 192c0-8.8-7.2-16-16-16L16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16zm0 128c0-8.8-7.2-16-16-16L16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16z"]
};
var faThumbsDown = {
  prefix: 'fal',
  iconName: 'thumbs-down',
  icon: [512, 512, [128078, 61576], "f165", "M288.8 430.3c3.5 12.8 16.7 20.3 29.5 16.8s20.3-16.7 16.8-29.5l-4.5-16.4c-5.5-20.2-13.9-39.3-24.7-56.9c-3.1-4.9-3.2-11.1-.4-16.2s8.2-8.2 14-8.2H448c17.7 0 32-14.3 32-32c0-11.3-5.9-21.3-14.8-27c-7.2-4.6-9.5-13.9-5.3-21.3c2.6-4.6 4.1-10 4.1-15.7c0-12.4-7-23.1-17.3-28.5c-4.2-2.2-7.3-6.1-8.3-10.8s.1-9.5 3-13.2c4.2-5.4 6.7-12.2 6.7-19.5c0-14.2-9.2-26.3-22.1-30.4c-7.8-2.5-12.4-10.6-10.7-18.6c.5-2.2 .7-4.5 .7-6.9c0-17.7-14.3-32-32-32H294.5c-15.8 0-31.2 4.7-44.4 13.4l-38.5 25.7c-9 6-16.6 13.7-22.4 22.6c-4.9 7.4-14.8 9.4-22.2 4.6s-9.4-14.8-4.6-22.2c8.1-12.3 18.7-23.1 31.4-31.6l38.5-25.7c18.4-12.3 40-18.8 62.1-18.8H384c35.3 0 64 28.7 64 64l0 .6c19.1 11.1 32 31.7 32 55.4c0 8.7-1.8 17.1-4.9 24.7C487.9 188.4 496 205.2 496 224c0 6.5-1 12.8-2.8 18.7C504.8 254.3 512 270.3 512 288c0 35.3-28.7 64-64 64H346.4c6.2 13.1 11.3 26.7 15.1 40.9l4.5 16.4c8.1 29.8-9.5 60.6-39.3 68.8s-60.6-9.5-68.8-39.3l-4.5-16.4c-8.9-32.6-29.6-60.8-58.2-79l-3.1-2 8.2-12.9-8.2 12.9c-11.8-7.5-21.7-17.1-29.5-28.2c-5.1-7.2-3.3-17.2 4-22.3s17.2-3.3 22.3 4c5.4 7.7 12.2 14.4 20.4 19.5l3.1 2c35.3 22.4 60.9 57.2 71.9 97.5l4.5 16.4zM32 352H96V128H32V352zM0 352V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
};
var faUserLock = {
  prefix: 'fal',
  iconName: 'user-lock',
  icon: [640, 512, [], "f502", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480H384c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3v39c-26.8-33.5-68-55-114.3-55H178.3c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zm432 96c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H608V352H448z"]
};
var faArrowRightLong = {
  prefix: 'fal',
  iconName: 'arrow-right-long',
  icon: [512, 512, ["long-arrow-right"], "f178", "M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-144-144c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l441.4 0L340.7 388.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l144-144z"]
};
var faLongArrowRight = faArrowRightLong;
var faTicketsAirline = {
  prefix: 'fal',
  iconName: 'tickets-airline',
  icon: [640, 512, [], "e29b", "M128 96V320c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V272.5c-23.7-11.8-40-36.2-40-64.5s16.3-52.8 40-64.5V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm484.1 45.6c.1 0 .1 0 .1 0l0 0-.1 0zm.1 132.9l-.1 0c.1 0 .1 0 .1 0zM160 32H576c35.3 0 64 28.7 64 64v56c0 8.8-7.4 15.7-15.6 19.1C610.1 177.2 600 191.4 600 208s10.1 30.8 24.4 36.9c8.1 3.4 15.6 10.3 15.6 19.1v56c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zm320 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM16 96c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H112C50.1 480 0 429.9 0 368V112c0-8.8 7.2-16 16-16zm274.3 74.9c1.6 4.9 .8 10.2-2.2 14.4s-7.8 6.6-13 6.6H229.8c-4.2 0-8.3-1.7-11.3-4.7L207.1 176H196l7.3 21.9c2.2 6.6 2.2 13.7 0 20.2L196 240h11.2l11.3-11.3c3-3 7.1-4.7 11.3-4.7h45.3c5.1 0 10 2.5 13 6.6s3.8 9.5 2.2 14.4L276 288h20c2.8 0 5.5-1.5 6.9-4l30.4-52.1c2.9-4.9 8.1-7.9 13.8-7.9h41.6c11.8 0 23.1-4.7 31.5-13c1.6-1.6 1.6-4.3 0-5.9c-8.4-8.4-19.7-13-31.5-13H347.1c-5.7 0-11-3-13.8-7.9L302.9 132c-1.4-2.5-4.1-4-6.9-4H276l14.3 42.9zM264.9 96H296c14.2 0 27.4 7.6 34.6 19.8l-13.8 8.1 13.8-8.1L356.3 160h32.4c20.3 0 39.8 8.1 54.1 22.4c14.1 14.1 14.1 37 0 51.2C428.4 247.9 409 256 388.7 256H356.3l-25.8 44.2C323.4 312.4 310.2 320 296 320H264.9c-16.4 0-27.9-16-22.8-31.6L252.9 256H236.4l-6.6 6.6c-6 6-14.1 9.4-22.6 9.4H184.9c-16.4 0-27.9-16-22.8-31.6L172.9 208l-10.8-32.4c-5.2-15.5 6.4-31.6 22.8-31.6h22.3c8.5 0 16.6 3.4 22.6 9.4l6.6 6.6h16.5l-10.8-32.4C236.9 112 248.5 96 264.9 96z"]
};
var faAnchorCircleXmark = {
  prefix: 'fal',
  iconName: 'anchor-circle-xmark',
  icon: [640, 512, [], "e4ac", "M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V480H240c-79.5 0-144-64.5-144-144V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h48 48c17.2 0 33.8-2.5 49.5-7c-9.8-7.9-18.8-16.9-26.7-26.7c-7.4 1.2-15 1.8-22.8 1.8H304V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zm96 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"]
};
var faEllipsis = {
  prefix: 'fal',
  iconName: 'ellipsis',
  icon: [448, 512, ["ellipsis-h"], "f141", "M416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faEllipsisH = faEllipsis;
var faNfcSlash = {
  prefix: 'fal',
  iconName: 'nfc-slash',
  icon: [640, 512, [], "e1fc", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM544 351.3V96c0-35.3-28.7-64-64-64H160c-6 0-11.9 .8-17.4 2.4L180.1 64H192h64H480c17.7 0 32 14.3 32 32V326l32 25.3zm-64-50.5V128c0-17.7-14.3-32-32-32H336c-17.7 0-32 14.3-32 32v33.8l32 25.3V128H448V275.5l32 25.3zM378.8 384H192V236.5l-32-25.3V384c0 17.7 14.3 32 32 32H419.4l-40.5-32zM128 186L96 160.7V416c0 35.3 28.7 64 64 64H480c6 0 11.9-.8 17.4-2.4L459.9 448H160c-17.7 0-32-14.3-32-32V186z"]
};
var faChessPawn = {
  prefix: 'fal',
  iconName: 'chess-pawn',
  icon: [320, 512, [9823], "f443", "M240 144A80 80 0 1 0 80 144a80 80 0 1 0 160 0zm16 112H235.4L254 352H221.4l-18.6-96H160 117.2L98.6 352H66l18.6-96H64c-8.8 0-16-7.2-16-16s7.2-16 16-16H81.6C60.9 203.7 48 175.3 48 144C48 82.1 98.1 32 160 32s112 50.1 112 112c0 31.3-12.9 59.7-33.6 80H256c8.8 0 16 7.2 16 16s-7.2 16-16 16zM65.8 416L33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4H280.6c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L254.2 416 65.8 416zm188.4-32c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1H254.2z"]
};
var faKitMedical = {
  prefix: 'fal',
  iconName: 'kit-medical',
  icon: [576, 512, ["first-aid"], "f479", "M128 448H448V64H128V448zm-32 0V64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H96zM64 32H96h16 16H448h16 16 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H480 464 448 128 112 96 64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32zM480 448h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H480V448zM272 144h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H336v32c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V304H208c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h32V176c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7H208v32h48c8.8 0 16 7.2 16 16v48h32V288c0-8.8 7.2-16 16-16h48V240H320c-8.8 0-16-7.2-16-16V176H272z"]
};
var faFirstAid = faKitMedical;
var faGrid2Plus = {
  prefix: 'fal',
  iconName: 'grid-2-plus',
  icon: [512, 512, [], "e197", "M176 64H80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 288H80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16zM80 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM336 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H336zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c8.8 0 16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H400v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V288c0-8.8 7.2-16 16-16z"]
};
var faBells = {
  prefix: 'fal',
  iconName: 'bells',
  icon: [640, 512, [], "f77f", "M282.6 40.1C214 15.1 138 50.4 112.8 119L98.2 159C84 197.8 57.6 231 23 253.7L14.9 259C4.7 265.7-.8 277.5 .6 289.5s9.4 22.2 20.8 26.3l230.5 83.9 1.1-3.9c2.6-9.1 4.4-18.4 5.4-27.7l-226-82.3 8.2-5.4c40.3-26.5 71.1-65.2 87.7-110.4l14.7-40c18.7-51 74.5-77.7 125.7-60.9c8.4-8.6 17.7-16.3 27.9-23c-4.5-2.2-9.1-4.2-13.9-6zm8.3 183.6c-20.1-54.7 8.1-115.2 62.8-135.2s115.4 8.3 135.5 63L508 202.6c16.3 44.6 46.4 82.8 85.9 109.2l13.7 9.2 0 0L310.1 429.3l4.6-15.8c13.1-45.6 11.3-94.1-5-138.7l-18.8-51.2zM342.8 58.4c-71.4 26-108 104.8-81.9 176.2l18.8 51.2c14 38.2 15.5 79.8 4.3 118.9l-4.6 15.8c-3.3 11.6 .1 24 9 32.2s21.5 10.8 32.8 6.7L618.6 351.1c11.3-4.1 19.4-14.2 20.8-26.2s-4-23.7-14-30.4l-13.7-9.2c-33.8-22.7-59.6-55.4-73.6-93.6l-18.8-51.2C493.2 69.2 414.1 32.5 342.8 58.4zm92 379.2c-6.7 5.8-7.4 15.9-1.6 22.6C450.5 480.1 479 488 505 477.8s41.5-35.5 40.5-61.8c-.3-8.8-7.7-15.7-16.6-15.4s-15.7 7.7-15.4 16.6c.5 13.2-7.3 25.8-20.3 30.9s-27.2 1.2-35.9-8.8c-5.8-6.7-15.9-7.4-22.6-1.6zM179.9 406.7c-8.7 10-23 13.9-35.9 8.8s-20.7-17.7-20.3-30.9c.3-8.8-6.6-16.2-15.4-16.6s-16.2 6.6-16.6 15.4c-.9 26.3 14.6 51.6 40.5 61.8s54.5 2.3 71.8-17.6c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6z"]
};
var faPersonThroughWindow = {
  prefix: 'fal',
  iconName: 'person-through-window',
  icon: [640, 512, [], "e5a9", "M48 32c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16h80l0-70.4c0-70.6 41.2-134.7 105.3-164.1c52.8-24.2 86.7-77 86.7-135.1L320 32 48 32zM352 46.4c0 63.8-33.6 122.3-87.4 154.7L328.1 288l64.5 0c9.3 0 18.2 4.1 24.3 11.2l91.2 106.4 8.9 10.4H592c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16L352 32V46.4zM367 416H474.9l-82.3-96-51.3 0-54 40.5 93.5 126c5.3 7.1 3.8 17.1-3.3 22.4s-17.1 3.8-22.4-3.3L312.5 448H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0H592c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H390.5L367 416zm-98.7-81.2l35.1-26.3-67.6-92.4c-13.2 7.4-25.1 16.7-35.2 27.5l67.7 91.2zm-87.8-64.6c-13.2 22.4-20.6 48.3-20.6 75.4l0 70.4H288.7L180.6 270.2zM168 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 88 136z"]
};
var faToolbox = {
  prefix: 'fal',
  iconName: 'toolbox',
  icon: [512, 512, [129520], "f552", "M176 64H336c8.8 0 16 7.2 16 16v48H160V80c0-8.8 7.2-16 16-16zM128 80v48H106.5c-17 0-33.3 6.7-45.3 18.7L18.7 189.3C6.7 201.3 0 217.5 0 234.5V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V234.5c0-17-6.7-33.3-18.7-45.3l-42.5-42.5c-12-12-28.3-18.7-45.3-18.7H384V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm16 80H368h37.5c8.5 0 16.6 3.4 22.6 9.4l42.5 42.5c6 6 9.4 14.1 9.4 22.6V304H352V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H192V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H32V234.5c0-8.5 3.4-16.6 9.4-22.6l42.5-42.5c6-6 14.1-9.4 22.6-9.4H144zM32 336H160v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336H320v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336H480v80c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336z"]
};
var faEnvelopeDot = {
  prefix: 'fal',
  iconName: 'envelope-dot',
  icon: [576, 512, ["envelope-badge"], "e16f", "M448 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 416 80a80 80 0 1 0 160 0zM512 384V190.9c-5.2 .7-10.6 1.1-16 1.1c-13.8 0-27-2.5-39.2-7.1L284.4 311.3c-16.9 12.4-39.9 12.4-56.8 0L32 167.9V128c0-17.7 14.3-32 32-32H385.1c-.7-5.2-1.1-10.6-1.1-16s.4-10.8 1.1-16H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64zM32 207.6L208.7 337.1c28.2 20.6 66.5 20.6 94.6 0L480 207.6V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V207.6z"]
};
var faEnvelopeBadge = faEnvelopeDot;
var faHandsHoldingCircle = {
  prefix: 'fal',
  iconName: 'hands-holding-circle',
  icon: [640, 512, [], "e4fb", "M416 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-224 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM64 64c35.3 0 64 28.7 64 64V252.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64V344.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V252.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 0 0 44-44 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.9c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16 0 0-44-44 0 0-10.7-10.8C106.8 305.4 96 279.4 96 252.3V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V344.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2V128C0 92.7 28.7 64 64 64z"]
};
var faBug = {
  prefix: 'fal',
  iconName: 'bug',
  icon: [512, 512, [], "f188", "M256 32c-35.3 0-64 28.7-64 64H320c0-35.3-28.7-64-64-64zM160 96c0-53 43-96 96-96s96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96zM36.7 100.7c6.2-6.2 16.4-6.2 22.6 0L138.6 180c17.2-12.6 38.4-20 61.4-20H312c22.9 0 44.2 7.4 61.4 20l79.3-79.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L396 202.6c12.6 17.2 20 38.4 20 61.4v8h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v16c0 30.2-8.4 58.4-22.9 82.5l82.2 82.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-79-79C344.5 460.1 302.6 480 256 480s-88.5-19.9-117.7-51.6l-79 79c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l82.2-82.2C104.4 378.4 96 350.2 96 320V304H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H96v-8c0-22.9 7.4-44.2 20-61.4L36.7 123.3c-6.2-6.2-6.2-16.4 0-22.6zM128 320c0 65.3 48.9 119.1 112 127V256c0-8.8 7.2-16 16-16s16 7.2 16 16V447c63.1-7.9 112-61.7 112-127V288 264c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v24 32z"]
};
var faBowlChopsticks = {
  prefix: 'fal',
  iconName: 'bowl-chopsticks',
  icon: [512, 512, [], "e2e9", "M499.1 31.7l-480 96C10.5 129.4 2 123.8 .3 115.1S4.2 98 12.9 96.3l480-96c8.7-1.7 17.1 3.9 18.8 12.6s-3.9 17.1-12.6 18.8zM512 142.9c.6 8.8-6.1 16.4-14.9 17l-480 32c-8.8 .6-16.4-6.1-17-14.9s6.1-16.4 14.9-17l480-32c8.8-.6 16.4 6.1 17 14.9zM144.8 445.5c7.7 3.7 13.7 10.3 16.5 18.4c3.3 9.4 12.2 16.1 22.7 16.1H328c10.4 0 19.4-6.7 22.7-16.1c2.8-8.1 8.7-14.7 16.5-18.4c61.4-29.2 105-90.1 109.3-162.2l.6-10.3c.5-9.2-6.8-16.9-16-16.9H50.9c-9.2 0-16.5 7.7-16 16.9l.6 10.3c4.2 72.1 47.8 133 109.3 162.2zM3 274.8C1.4 247.3 23.3 224 50.9 224H461.1c27.6 0 49.5 23.2 47.9 50.8l-.6 10.3c-5 84.1-55.9 155.1-127.5 189.2C373.3 496.3 352.5 512 328 512H184c-24.5 0-45.3-15.7-52.9-37.6C59.5 440.3 8.5 369.3 3.6 285.2L3 274.8z"]
};
var faCreditCard = {
  prefix: 'fal',
  iconName: 'credit-card',
  icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M64 64C46.3 64 32 78.3 32 96v32H544V96c0-17.7-14.3-32-32-32H64zM32 160v64H544V160H32zm0 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V256H32zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 368c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faCreditCardAlt = faCreditCard;
var faCircleS = {
  prefix: 'fal',
  iconName: 'circle-s',
  icon: [512, 512, [], "e121", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192.7 190c2-10.7 9.2-19.1 23.1-24.4c14.3-5.5 34.5-7.2 57.9-3.8c7 1 23.4 4.5 31 6.4c8.6 2.2 17.3-3 19.4-11.6s-3-17.3-11.6-19.4c-8.2-2.1-25.7-5.8-34.1-7c-26.9-4-53.1-2.6-74.1 5.6c-21.5 8.3-38.6 24.2-43.1 48.5c-2.5 13.9-1.2 26.6 4 37.7c5.2 11 13.6 19.1 23 25.2c17.5 11.5 41.3 18.1 62 23.8l0 0 1.5 .4c22.6 6.3 41.6 11.7 54.4 20.1c6 4 9.7 8 11.7 12.3c1.9 4.1 3 9.7 1.5 18.2c-2 10.7-9.2 19.1-23.1 24.4c-14.3 5.5-34.5 7.2-57.9 3.8c-14.3-2.2-41.3-10-56.4-14.8c-8.4-2.7-17.4 2-20.1 10.5s2 17.4 10.5 20.1c15 4.7 44.2 13.3 61.2 15.9l0 0 .1 0c26.9 4 53.1 2.6 74.1-5.6c21.5-8.3 38.6-24.2 43.1-48.5c2.5-13.9 1.2-26.6-4-37.7c-5.2-11-13.6-19.1-23-25.2c-17.5-11.5-41.3-18.1-62-23.8l-1.5-.4c-22.6-6.3-41.6-11.7-54.4-20.1c-6-4-9.7-8-11.7-12.3c-1.9-4.1-3-9.7-1.5-18.2z"]
};
var faBoxBallot = {
  prefix: 'fal',
  iconName: 'box-ballot',
  icon: [576, 512, [128499], "f735", "M160 32V224H416V32H160zm-32 0c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V32zM48 160H96v32H48c-8.8 0-16 7.2-16 16V320H544V208c0-8.8-7.2-16-16-16H480V160h48c26.5 0 48 21.5 48 48V320v16 16V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352 336 320 208c0-26.5 21.5-48 48-48zM544 352H32V464c0 8.8 7.2 16 16 16H528c8.8 0 16-7.2 16-16V352z"]
};
var faCar = {
  prefix: 'fal',
  iconName: 'car',
  icon: [512, 512, [128664, "automobile"], "f1b9", "M113.6 98.2L85.3 192.6c3.5-.4 7.1-.6 10.7-.6H416c3.6 0 7.2 .2 10.7 .6L398.4 98.2c-6.1-20.3-24.8-34.2-46-34.2H159.6c-21.2 0-39.9 13.9-46 34.2zM74.3 227.8C49.6 236.7 32 260.3 32 288v96H480V288c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H96c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3-.5-.1zm-26-23.1l.4-1.3L83 89c10.2-33.8 41.3-57 76.6-57H352.4c35.3 0 66.5 23.2 76.6 57l34.3 114.4 .4 1.3C492.6 221.2 512 252.3 512 288v96 16 16 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416 400 384 288c0-35.7 19.4-66.8 48.3-83.3zM104 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faAutomobile = faCar;
var faHandHoldingHand = {
  prefix: 'fal',
  iconName: 'hand-holding-hand',
  icon: [576, 512, [], "e4f7", "M425 226.6c-13.1 8.8-28.6 13.4-44.4 13.4H232c-30.9 0-56-25.1-56-56c0-8.6 1.9-16.7 5.4-24h-5.6L81.1 216.4c-8.3 4.9-17.8 7.6-27.5 7.6H52.3C23.4 224 0 200.6 0 171.7c0-17.7 9-34.2 23.8-43.9L143.4 50.1c18.2-11.8 39.4-18.1 61-18.1H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H204.5c-15.5 0-30.6 4.5-43.6 12.9L41.2 154.7c-5.8 3.7-9.2 10.1-9.2 17c0 11.2 9.1 20.3 20.3 20.3h1.3c3.9 0 7.7-1.1 11.1-3l98.5-58.7c2.5-1.5 5.3-2.3 8.2-2.3H232h24 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H256 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H380.6c9.5 0 18.7-2.8 26.6-8.1l79.9-53.3 4-2.7H496h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H500.8L425 226.6zM151 285.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 461.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 365.3l-4 2.7H80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 285.4z"]
};
var faUserTieHair = {
  prefix: 'fal',
  iconName: 'user-tie-hair',
  icon: [448, 512, [], "e45f", "M320 128v16c0 53-43 96-96 96s-96-43-96-96V128l34.3 0c31.7 0 61.1-14.5 80.4-38.7l6.3 6.3c10.5 10.5 24.7 16.4 39.6 16.4h30.1c.9 5.2 1.3 10.5 1.3 16zM228.7 52.7c-1.3 1.3-2.4 2.8-3.1 4.5C213.5 81 189.1 96 162.3 96H133.5c13.2-37.3 48.7-64 90.5-64c35.5 0 66.6 19.3 83.2 48H288.6c-6.4 0-12.5-2.5-17-7L251.3 52.7c-6.2-6.2-16.4-6.2-22.6 0zM96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0S96 57.3 96 128zm96 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h9.8l-21.7 65-32.1-69.5c-2.9-6.3-9.5-10-16.3-8.8C56.8 336.5 0 402.3 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-79-56.8-144.7-131.8-158.6c-6.8-1.3-13.4 2.5-16.3 8.8L267.9 401l-21.7-65H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H224 192zm17.5 160.5l-9.7-21.1L224 370.6l24.3 72.8-9.7 21.1c-5.7 12.4-23.3 12.4-29.1 0zm-29.1 13.4c.3 .7 .7 1.4 1 2.1H32c.6-58.1 39.5-107.1 92.7-122.8l55.7 120.7zM416 480H266.6c.3-.7 .7-1.4 1-2.1l55.7-120.7c53.2 15.7 92.1 64.6 92.7 122.8z"]
};
var faPodiumStar = {
  prefix: 'fal',
  iconName: 'podium-star',
  icon: [448, 512, [], "f758", "M224 32h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H224c-20.9 0-38.7 13.4-45.3 32H168c-44.2 0-80 35.8-80 80v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H120V112c0-26.5 21.5-48 48-48h10.7c6.6 18.6 24.4 32 45.3 32zM47.3 224L73.5 455.2c3.7 32.3 31 56.8 63.6 56.8H310.9c32.5 0 59.9-24.4 63.6-56.8L400.7 224H368.5L342.7 451.6c-1.8 16.2-15.5 28.4-31.8 28.4H137.1c-16.3 0-30-12.2-31.8-28.4L79.5 224H47.3zm214.2 58.8l-16.2-36.8c-8.2-18.6-34.2-18.6-42.4 0l-16.2 36.8-38.2 4.7c-20.5 2.5-26.6 27.4-13.2 40.4l28.7 27.8L156.2 396c-3.4 18 15.6 35.9 34.4 24.8L224 401.3l33.4 19.6c18.8 11 37.8-6.9 34.4-24.8l-7.6-40.3 28.7-27.8c13.4-13 7.3-37.9-13.2-40.4l-38.2-4.7zm-47.5 17.4l10.1-23 10.1 23c3.2 7.3 10 12.7 18.4 13.8l25.5 3.2-19.4 18.7c-5.8 5.6-8.2 13.8-6.8 21.5l5 26.1L235.6 371c-7.2-4.2-16-4.2-23.2 0l-21.2 12.4 5-26.1c1.5-7.7-1-15.9-6.8-21.5L170 317.1l25.5-3.2c8.3-1 15.2-6.5 18.4-13.8z"]
};
var faUserHairMullet = {
  prefix: 'fal',
  iconName: 'user-hair-mullet',
  icon: [448, 512, ["business-front", "party-back", "trian-balbot"], "e45c", "M320 144c0 53-43 96-96 96s-96-43-96-96V128c0-5.5 .5-10.8 1.3-16h11.3c32.1 0 62.3-13.7 83.4-37.2c21.1 23.5 51.3 37.2 83.4 37.2h11.3c.9 5.2 1.3 10.5 1.3 16v16zM97.2 110.5c-.8 5.7-1.2 11.6-1.2 17.5v16c0 15.6 2.8 30.6 7.9 44.5c-.7 26.5-7.7 46.3-21.3 66.6c-2.5 3.8-3.3 8.5-2.2 13s4.2 8.2 8.3 10.2l16 8c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-.6-.3c4.6-8.7 8.3-17.6 11.1-26.9c5.7 6.3 12.1 12 19 17l-11.8 35.5c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l10-29.9c14.5 5.7 30.3 8.8 46.9 8.8s32.3-3.1 46.9-8.8l10 29.9c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-11.8-35.5c6.9-5 13.2-10.7 19-17c2.8 9.3 6.5 18.2 11.1 26.9l-.6 .3c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l16-8c4.1-2.1 7.1-5.8 8.3-10.2s.4-9.2-2.2-13c-13.5-20.3-20.6-40.2-21.3-66.6c5.1-13.9 7.9-28.8 7.9-44.5V128c0-5.9-.4-11.8-1.2-17.5c5.4-2.6 9.2-8.1 9.2-14.5c0-8.8-7.2-16-16-16h-1.3c-19-46.9-65-80-118.7-80s-99.7 33.1-118.7 80H104c-8.8 0-16 7.2-16 16c0 6.4 3.8 11.9 9.2 14.5zM140.8 80c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48c-26.7-.1-51.5-13.4-66.3-35.6l-3.5-5.3c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-3.5 5.3C192.4 66.6 167.5 79.9 140.8 80zm22.7 272H284.4c71.5 0 129.6 57 131.5 128H32c1.9-71 60-128 131.5-128zm0-32C73.2 320 0 393.2 0 483.6C0 499.3 12.7 512 28.4 512H419.6c15.7 0 28.4-12.7 28.4-28.4C448 393.2 374.8 320 284.4 320H163.6z"]
};
var faBusinessFront = faUserHairMullet;
var faPartyBack = faUserHairMullet;
var faTrianBalbot = faUserHairMullet;
var faMicrophoneStand = {
  prefix: 'fal',
  iconName: 'microphone-stand',
  icon: [512, 512, [127908], "f8cb", "M449.5 186.9L325.1 62.5l4.7-4.7c34.4-34.4 90.1-34.4 124.4 0s34.4 90.1 0 124.5l-4.7 4.7zm-22.6 22.6l-4.7 4.7c-17.5 17.5-40.6 26.1-63.6 25.8L272 153.4c-.4-23 8.2-46.1 25.8-63.6l4.7-4.7L426.9 209.5zM358.3 272c31.3 .4 62.7-11.3 86.5-35.1l4.7-4.7 11.3-11.3 11.3-11.3 4.7-4.7c46.9-46.9 46.9-122.8 0-169.7S354-11.7 307.1 35.1l-4.7 4.7L291.1 51.1 279.8 62.5l-4.7 4.7C251.3 91 239.6 122.4 240 153.7L15 393.7c-9.6 10.3-15 23.9-15 38c0 14.7 5.8 28.8 16.3 39.3l24.8 24.8C51.5 506.2 65.6 512 80.4 512c14.1 0 27.7-5.4 38-15L256 367.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V337.9L358.3 272zM96.5 473.6c-4.4 4.1-10.1 6.4-16.1 6.4c-6.2 0-12.2-2.5-16.6-6.9L38.9 448.3c-4.4-4.4-6.9-10.4-6.9-16.6c0-6 2.3-11.7 6.4-16.1L256.4 183 329 255.6 96.5 473.6z"]
};
var faBookOpenReader = {
  prefix: 'fal',
  iconName: 'book-open-reader',
  icon: [512, 512, ["book-reader"], "f5da", "M256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160A96 96 0 1 0 256 0a96 96 0 1 0 0 192zm0 48s-56.8-42.6-224-47.5C14.4 191.9 0 206.3 0 224V432c0 17.7 14.4 31.9 32 32.7c114.9 4.7 186.9 33.7 208.8 43.8c4.8 2.2 9.9 3.5 15.1 3.5s10.4-1.3 15.1-3.5c21.9-10.1 93.9-39.1 208.8-43.8c17.7-.7 32-15 32-32.7V224c0-17.7-14.4-32.1-32-31.5C312.8 197.4 256 240 256 240zm-18.9 25.8L240 268V473.3c-34-13.8-104.4-36.4-206.7-40.6c-.5 0-.9-.2-1.2-.5c-.1-.1-.1-.1-.1-.2l0 0 0 0 0 0 0 0 0 0 0 0V224.5c80.5 2.4 133.2 13.9 164.9 24.1c15.9 5.1 26.7 9.9 33 13.2c3.2 1.6 5.3 2.9 6.4 3.6c.4 .3 .7 .5 .9 .6zM272 268l2.9-2.2c.1-.1 .4-.3 .9-.6c1.1-.7 3.2-1.9 6.4-3.6c6.3-3.3 17-8.1 33-13.2c31.8-10.2 84.5-21.6 164.9-24.1V432v0l0 .1c0 0-.1 .1-.1 .1c-.3 .3-.7 .5-1.2 .5C376.4 436.9 306 459.5 272 473.3V268z"]
};
var faBookReader = faBookOpenReader;
var faFamilyDress = {
  prefix: 'fal',
  iconName: 'family-dress',
  icon: [512, 512, [], "e301", "M128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-15.7 64h31.4c11.5 0 21.8 6.1 27.5 15.6c-2.1-7.5-3.2-15.4-3.2-23.6c0-6.3 .7-12.5 1.9-18.4c-8.1-3.6-16.9-5.6-26.2-5.6H112.3c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384H64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384h49.6c-1-5.2-1.6-10.5-1.6-16V352H42.4L81.5 215.2C85.4 201.5 98 192 112.3 192zM366.4 384H416V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384h21.6c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H368.3c-9.3 0-18.1 2-26.2 5.6c1.3 5.9 1.9 12.1 1.9 18.4c0 8.2-1.1 16.1-3.2 23.6c5.7-9.5 16-15.6 27.5-15.6h31.4c14.3 0 26.8 9.5 30.8 23.2L469.6 352H368v16c0 5.5-.6 10.8-1.6 16zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 384 0a64 64 0 1 0 0 128zM256 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 48c26.5 0 48 21.5 48 48v32c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V336c0-26.5 21.5-48 48-48zM208 413.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V416h32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V413.3c18.6-6.6 32-24.4 32-45.3V336c0-44.2-35.8-80-80-80s-80 35.8-80 80v32c0 20.9 13.4 38.7 32 45.3z"]
};
var faCircleX = {
  prefix: 'fal',
  iconName: 'circle-x',
  icon: [512, 512, [], "e12e", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM172.1 133.6c-5.8-6.7-15.9-7.5-22.6-1.7s-7.5 15.9-1.7 22.6L234.9 256 147.9 357.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7L256 280.6l83.9 97.8c5.8 6.7 15.8 7.5 22.6 1.7s7.5-15.8 1.7-22.6L277.1 256l87.1-101.6c5.8-6.7 5-16.8-1.7-22.6s-16.8-5-22.6 1.7L256 231.4l-83.9-97.8z"]
};
var faCabin = {
  prefix: 'fal',
  iconName: 'cabin',
  icon: [512, 512, [], "e46d", "M237.1 10c11.3-8.3 26.6-8.3 37.8 0L352 66.6V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V160h-.6l13 9.6c12.3 9 19.6 23.3 19.6 38.6c0 21.4-14 39.5-33.3 45.6c.9 3.3 1.3 6.7 1.3 10.2v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V456c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V392c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V328c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V264c0-2.7 .3-5.4 .8-8H191.2c.5 2.6 .8 5.3 .8 8v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 22.1-17.9 40-40 40H72c-22.1 0-40-17.9-40-40V456c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V392c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V328c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V264c0-3.5 .5-7 1.3-10.2C14 247.6 0 229.5 0 208.1c0-15.2 7.3-29.6 19.6-38.6L237.1 10zM360 416h80c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm80 32H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8zm8-104V328c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8zM360 224h80 24.1c8.8 0 15.9-7.1 15.9-15.9c0-5.1-2.4-9.8-6.5-12.8L256 35.8 38.5 195.4c-4.1 3-6.5 7.7-6.5 12.8c0 8.8 7.1 15.9 15.9 15.9H72h80H360zm0 32c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V264c0-4.4-3.6-8-8-8H360zM72 416h80c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm80 32H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8zm8-104V328c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8zM72 256c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V264c0-4.4-3.6-8-8-8H72zM448 137V64H384V90L448 137zm-192-9a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faMountainSun = {
  prefix: 'fal',
  iconName: 'mountain-sun',
  icon: [640, 512, [], "e52f", "M608 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM480 80a80 80 0 1 1 160 0A80 80 0 1 1 480 80zM456.1 480c13.2 0 23.9-10.7 23.9-23.9c0-4.5-1.3-8.9-3.7-12.7L259.6 98c-.8-1.3-2.2-2-3.6-2s-2.9 .8-3.6 2L35.7 443.4c-2.4 3.8-3.7 8.2-3.7 12.7C32 469.3 42.7 480 55.9 480H456.1zM55.9 512C25 512 0 487 0 456.1c0-10.5 3-20.8 8.6-29.7L225.2 81c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7 48.2-79C465 196.1 472.2 192 480 192s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1H456.1 55.9zm447.5-85.6c5.6 8.9 8.6 19.2 8.6 29.7c0 8.6-1.9 16.7-5.4 23.9h72.2c16.1 0 29.1-13 29.1-29.1c0-5.3-1.5-10.6-4.3-15.2L480 232.9 431.7 312l71.7 114.3z"]
};
var faChartSimpleHorizontal = {
  prefix: 'fal',
  iconName: 'chart-simple-horizontal',
  icon: [448, 512, [], "e474", "M416 240c0-8.8-7.2-16-16-16L48 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-32zm32 32c0 26.5-21.5 48-48 48L48 320c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48l0 32zM224 400c0-8.8-7.2-16-16-16L48 384c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-32zm32 32c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32zm96-320l0-32c0-8.8-7.2-16-16-16L48 64c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16zm-16 48L48 160c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48z"]
};
var faBluetooth = {
  prefix: 'fal',
  iconName: 'bluetooth',
  icon: [384, 512, [], "f293", "M185.4 1.4c5.7-2.6 12.5-1.5 17.2 2.6l144 128c3.6 3.2 5.5 7.7 5.4 12.5s-2.4 9.2-6.2 12.1L218.1 256l127.8 99.4c3.8 2.9 6 7.4 6.2 12.1s-1.8 9.3-5.4 12.5l-144 128c-4.7 4.2-11.4 5.2-17.2 2.6s-9.4-8.3-9.4-14.6V288.7L57.8 380.6c-7 5.4-17 4.2-22.5-2.8s-4.2-17 2.8-22.5L165.9 256 38.2 156.6c-7-5.4-8.2-15.5-2.8-22.5s15.5-8.2 22.5-2.8L176 223.3V16c0-6.3 3.7-12 9.4-14.6zM208 288.7V460.4l103-91.6L208 288.7zm0-65.4l103-80.1L208 51.6V223.3z"]
};
var faArrowsLeftRightToLine = {
  prefix: 'fal',
  iconName: 'arrows-left-right-to-line',
  icon: [640, 512, [], "e4ba", "M16 64c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm203.3 84.7c6.2 6.2 6.2 16.4 0 22.6L150.6 240l338.7 0-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L489.4 272l-338.7 0 68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0zM640 80V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHandBackPointLeft = {
  prefix: 'fal',
  iconName: 'hand-back-point-left',
  icon: [512, 512, [], "e19f", "M0 168c0-30.9 25.1-56 56-56l200.6 0c2-3.2 4.2-6.4 6.5-9.5L280 80c15.1-20.1 38.8-32 64-32l19.5 0c53 0 101.7 29.1 126.8 75.7l4.5 8.3c11.3 21 17.2 44.4 17.2 68.3L512 336c0 61.9-50.1 112-112 112l-8 0-88 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-5.3 .7-10.5 1.9-15.5c-20.2-10.8-33.9-32-33.9-56.5c0-8.5 1.7-16.6 4.7-24L56 224c-30.9 0-56-25.1-56-56zm56-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l157.5 0c7.1 0 13.3 4.6 15.3 11.4s-.6 14-6.5 18c-8.7 5.8-14.3 15.6-14.3 26.7c0 15.6 11.2 28.6 25.9 31.4c5.1 1 9.5 4.4 11.6 9.2s1.8 10.3-.9 14.8c-2.9 4.8-4.6 10.5-4.6 16.6c0 14.7 10 27.2 23.6 30.9c4.4 1.2 8.1 4.2 10.1 8.3s2.2 8.8 .6 13.1c-1.4 3.6-2.2 7.6-2.2 11.8c0 17.7 14.3 32 32 32l88 0 8 0c44.2 0 80-35.8 80-80l0-135.7c0-18.5-4.6-36.8-13.4-53.1l14.1-7.6-14.1 7.6-4.5-8.3C442.6 102.6 404.7 80 363.5 80L344 80c-15.1 0-29.3 7.1-38.4 19.2L296 112l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-78.3 0-1.7 0L56 144z"]
};
var faMessageDots = {
  prefix: 'fal',
  iconName: 'message-dots',
  icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCommentAltDots = faMessageDots;
var faMessaging = faMessageDots;
var faFileHeart = {
  prefix: 'fal',
  iconName: 'file-heart',
  icon: [384, 512, [], "e176", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm61.7 306.8c0-11.9 9.6-21.5 21.5-21.5h1.5c6 0 11.7 2.3 16 6.5l16.1 15.6c6.2 6 16.1 6 22.3 0l16.1-15.6c4.3-4.2 10.1-6.5 16-6.5h1.5c11.9 0 21.5 9.6 21.5 21.5c0 5.8-2.3 11.4-6.5 15.4L192 380.4l-59.8-58.1c-4.2-4-6.5-9.6-6.5-15.4zm21.5-53.5c-29.5 0-53.5 23.9-53.5 53.5c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5z"]
};
var faBeerMug = {
  prefix: 'fal',
  iconName: 'beer-mug',
  icon: [512, 512, ["beer-foam"], "e0b3", "M208 0c-26.3 0-50.2 10.6-67.6 27.8l0 0 0 0c0 0-.1 .1-.2 .1c-.2 .1-.4 .2-.8 .2c-.7 .1-1.3-.1-1.6-.3C125.7 20.3 111.3 16 96 16C51.8 16 16 51.8 16 96s35.8 80 80 80c15.3 0 29.7-4.3 41.9-11.8c.3-.2 .8-.4 1.6-.3c.3 0 .6 .1 .8 .2c.1 0 .1 .1 .2 .1l0 0 0 0C157.8 181.4 181.7 192 208 192s50.2-10.6 67.6-27.8l0 0 0 0c0 0 0 0 .1 0c0 0 .1 0 .1 0c.2-.1 .4-.2 .8-.2c.7-.1 1.3 .1 1.6 .3c12.2 7.5 26.6 11.8 41.9 11.8c44.2 0 80-35.8 80-80s-35.8-80-80-80c-15.3 0-29.7 4.3-41.9 11.8c-.3 .2-.8 .4-1.6 .3c-.3 0-.6-.1-.8-.2c-.1 0-.1-.1-.2-.1l0 0 0 0C258.2 10.6 234.3 0 208 0zM163 50.5C174.5 39.1 190.4 32 208 32s33.5 7.1 45 18.5c11.3 11.2 29 12.4 41.8 4.5c7.3-4.5 15.9-7.1 25.1-7.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-9.2 0-17.8-2.6-25.1-7.1c-12.8-7.9-30.5-6.7-41.8 4.5c-11.6 11.5-27.5 18.5-45 18.5s-33.5-7.1-45-18.5c-11.3-11.2-29-12.4-41.8-4.5c-7.3 4.5-15.9 7.1-25.1 7.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c9.2 0 17.8 2.6 25.1 7.1c12.8 7.9 30.5 6.7 41.8-4.5zM32 187.9V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V434.5l80.1-35c29.1-12.7 47.9-41.5 47.9-73.3V272c0-44.2-35.8-80-80-80H384v-4.1c-9.7 6.7-20.4 12-32 15.4V423.7c0 .2 0 .5 0 .7V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V203.4c-11.6-3.4-22.3-8.7-32-15.4zM208 224c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zm224 0c26.5 0 48 21.5 48 48v54.1c0 19.1-11.3 36.3-28.8 44L384 399.5V224h48zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]
};
var faBeerFoam = faBeerMug;
var faDiceD20 = {
  prefix: 'fal',
  iconName: 'dice-d20',
  icon: [512, 512, [], "f6cf", "M217.5 56.4L77.9 140.2l61.4 44.7L217.5 56.4zM64 169.6V320.3l59.2-107.6L64 169.6zM104.8 388L240 469.1V398.8L104.8 388zM272 469.1L407.2 388 272 398.8v70.3zM448 320.3V169.6l-59.2 43L448 320.3zM434.1 140.2L294.5 56.4l78.2 128.4 61.4-44.7zM243.7 3.4c7.6-4.6 17.1-4.6 24.7 0l200 120c7.2 4.3 11.7 12.1 11.7 20.6V368c0 8.4-4.4 16.2-11.7 20.6l-200 120c-7.6 4.6-17.1 4.6-24.7 0l-200-120C36.4 384.2 32 376.4 32 368V144c0-8.4 4.4-16.2 11.7-20.6l200-120zM225.3 365.5L145 239.4 81.9 354l143.3 11.5zM338.9 224H173.1L256 354.2 338.9 224zM256 54.8L172.5 192H339.5L256 54.8zm30.7 310.7L430.1 354 367 239.4 286.7 365.5z"]
};
var faDrone = {
  prefix: 'fal',
  iconName: 'drone',
  icon: [512, 512, [], "f85f", "M112 32c39.6 0 72.5 28.8 78.9 66.6c1.5 8.7 9.7 14.6 18.4 13.1s14.6-9.7 13.1-18.4C213.6 40.4 167.5 0 112 0C50.1 0 0 50.1 0 112c0 55.5 40.4 101.6 93.4 110.5c8.7 1.5 17-4.4 18.4-13.1s-4.4-17-13.1-18.4C60.8 184.5 32 151.6 32 112c0-44.2 35.8-80 80-80zm286.7 0c44.2 0 80 35.8 80 80c0 39.6-28.8 72.5-66.6 78.9c-8.7 1.5-14.6 9.7-13.1 18.4s9.7 14.6 18.4 13.1c53-8.9 93.4-54.9 93.4-110.5c0-61.9-50.1-112-112-112C343.2 0 297.1 40.4 288.2 93.4c-1.5 8.7 4.4 17 13.1 18.4s17-4.4 18.4-13.1C326.1 60.8 359 32 398.7 32zM32 398.7c0-39.6 28.8-72.5 66.6-78.9c8.7-1.5 14.6-9.7 13.1-18.4s-9.7-14.6-18.4-13.1C40.4 297.1 0 343.2 0 398.7c0 61.9 50.1 112 112 112c55.5 0 101.6-40.4 110.5-93.4c1.5-8.7-4.4-17-13.1-18.4s-17 4.4-18.4 13.1c-6.3 37.8-39.3 66.6-78.9 66.6c-44.2 0-80-35.8-80-80zm366.7 80c-39.6 0-72.5-28.8-78.9-66.6c-1.5-8.7-9.7-14.6-18.4-13.1s-14.6 9.7-13.1 18.4c8.9 53 54.9 93.4 110.5 93.4c61.9 0 112-50.1 112-112c0-55.5-40.4-101.6-93.4-110.5c-8.7-1.5-17 4.4-18.4 13.1s4.4 17 13.1 18.4c37.8 6.3 66.6 39.3 66.6 78.9c0 44.2-35.8 80-80 80zM112 432c17.7 0 32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3L182.6 352H329.4l39.7 39.7c-.7 2.6-1.1 5.4-1.1 8.3c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32c-2.9 0-5.6 .4-8.3 1.1L352 329.4V182.6l39.7-39.7c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L329.4 160H182.6l-39.7-39.7c.7-2.6 1.1-5.4 1.1-8.3c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c2.9 0 5.6-.4 8.3-1.1L160 182.6V329.4l-39.7 39.7c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32zm80-112V192H320V320H192z"]
};
var faTruckDroplet = {
  prefix: 'fal',
  iconName: 'truck-droplet',
  icon: [640, 512, [], "e58c", "M352 32c17.7 0 32 14.3 32 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352zM416 128h65.3c4.7 0 9.1 2 12.1 5.6L570.9 224H416V128zm0 216.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM256 211c0 23.7-20.3 45-48 45s-48-21.3-48-45c0-1.7 .9-7.2 5-17.4c3.9-9.5 9.5-20.4 16.1-32.1c8.5-14.8 18.1-29.7 26.8-42.6c8.7 12.8 18.4 27.8 26.8 42.6c6.7 11.6 12.3 22.6 16.1 32.1c4.1 10.2 5 15.7 5 17.4zm32 0c0-32-45.2-98.9-67.6-130.2c-6.1-8.6-18.6-8.6-24.8 0C173.2 112.1 128 179 128 211c0 42.5 35.8 77 80 77s80-34.5 80-77z"]
};
var faFileCircleXmark = {
  prefix: 'fal',
  iconName: 'file-circle-xmark',
  icon: [576, 512, [], "e5a1", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faTemperatureArrowUp = {
  prefix: 'fal',
  iconName: 'temperature-arrow-up',
  icon: [576, 512, ["temperature-up"], "e040", "M112 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM176 0C123 0 80 43 80 96V252.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V96c0-8.8-7.2-16-16-16s-16 7.2-16 16V306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM420.7 36.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L416 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faTemperatureUp = faTemperatureArrowUp;
var faMedal = {
  prefix: 'fal',
  iconName: 'medal',
  icon: [512, 512, [127941], "f5a2", "M106.4 191.5c7.5-7.8 15.6-14.9 24.2-21.4L38.5 32l103.4 0 61.6 102.7c10.9-2.8 22.2-4.8 33.8-5.9l-68-113.3C163.5 5.9 153.1 0 141.9 0H24.6C11 0 0 11 0 24.6c0 4.8 1.4 9.6 4.1 13.6L106.4 191.5zm168.3-62.7c11.6 1 22.9 3 33.8 5.9L370.1 32l103.4 0L381.5 170.1c8.6 6.5 16.7 13.7 24.2 21.4L507.9 38.2c2.7-4 4.1-8.8 4.1-13.6C512 11 501 0 487.4 0H370.1c-11.2 0-21.7 5.9-27.4 15.5l-68 113.3zM256 192a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 320a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm38.8-229.5l-17.3-35.1c-8.8-17.8-34.2-17.8-43 0l-17.3 35.1-38.7 5.6c-19.7 2.9-27.5 27.1-13.3 40.9l28 27.3L186.5 395c-3.4 19.6 17.2 34.6 34.8 25.3L256 402.1l34.6 18.2c17.6 9.3 38.2-5.7 34.8-25.3l-6.6-38.6 28-27.3c14.2-13.9 6.4-38.1-13.3-40.9l-38.7-5.6zM244 300.5l12-24.3 12 24.3c3.5 7.1 10.3 12 18.1 13.1l26.8 3.9-19.4 18.9c-5.7 5.5-8.2 13.5-6.9 21.2l4.6 26.7-24-12.6c-7-3.7-15.3-3.7-22.3 0l-24 12.6 4.6-26.7c1.3-7.8-1.2-15.7-6.9-21.2l-19.4-18.9 26.8-3.9c7.8-1.1 14.6-6 18.1-13.1z"]
};
var faBed = {
  prefix: 'fal',
  iconName: 'bed',
  icon: [640, 512, [128716], "f236", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V336v64 64c0 8.8 7.2 16 16 16s16-7.2 16-16V416H608v48c0 8.8 7.2 16 16 16s16-7.2 16-16V400 336 240c0-61.9-50.1-112-112-112H304c-26.5 0-48 21.5-48 48V320H32V48zM608 384H32V352H272 608v32zm0-144v80H288V176c0-8.8 7.2-16 16-16H528c44.2 0 80 35.8 80 80zM96 208a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 64 208a80 80 0 1 0 160 0z"]
};
var faBookCopy = {
  prefix: 'fal',
  iconName: 'book-copy',
  icon: [576, 512, [], "e0be", "M224 64c0-17.7 14.3-32 32-32H528c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16H256c-11.7 0-22.6 3.1-32 8.6V64zm-32 0V352c0 35.3 28.7 64 64 64H528h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H544V317.3c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H256c-35.3 0-64 28.7-64 64zm64 320c-17.7 0-32-14.3-32-32s14.3-32 32-32H512v64H256zm96 96V448H320v32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H184.4c-8.3-9.2-14.8-20.1-19-32H64c-11.7 0-22.6 3.1-32 8.6V160c0-17.7 14.3-32 32-32h96V96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H336h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H352z"]
};
var faSquareH = {
  prefix: 'fal',
  iconName: 'square-h',
  icon: [448, 512, ["h-square"], "f0fd", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm336 48V256 368c0 8.8-7.2 16-16 16s-16-7.2-16-16V272l-160 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16v96l160 0V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHSquare = faSquareH;
var faSquareC = {
  prefix: 'fal',
  iconName: 'square-c',
  icon: [448, 512, [], "e266", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm156.1 92.1c-37.5 37.5-37.5 98.3 0 135.8s98.3 37.5 135.8 0c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-37.5-37.5-98.3-37.5-135.8 0z"]
};
var faClockTwo = {
  prefix: 'fal',
  iconName: 'clock-two',
  icon: [512, 512, [], "e35a", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V226.1l71.1-47.4c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2l-96 64c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSquareEllipsisVertical = {
  prefix: 'fal',
  iconName: 'square-ellipsis-vertical',
  icon: [448, 512, [], "e26f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCalendarUsers = {
  prefix: 'fal',
  iconName: 'calendar-users',
  icon: [640, 512, [], "e5e2", "M208 0c8.8 0 16 7.2 16 16V64H416V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32H528 512 128 112 96V160 128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm39.4 512c5.4-9.4 8.6-20.3 8.6-32H384c0 11.7 3.1 22.6 8.6 32H247.4zM480 96H160c-17.7 0-32 14.3-32 32v32H512V128c0-17.7-14.3-32-32-32zm48 256a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM480 448c-17.7 0-32 14.3-32 32H608c0-17.7-14.3-32-32-32H480zm-64 32c0-35.3 28.7-64 64-64h48 48c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32zM160 304a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 304a80 80 0 1 1 160 0A80 80 0 1 1 32 304zm0 176H192c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm32-64h48 48c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32c0-35.3 28.7-64 64-64z"]
};
var faPodcast = {
  prefix: 'fal',
  iconName: 'podcast',
  icon: [448, 512, [], "f2ce", "M416 224c0 71.3-38.8 133.5-96.5 166.6c-1.4 11.5-3.2 23.4-5 34.8l-.6 3.8C392.8 394.7 448 315.8 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 91.8 55.2 170.6 134.2 205.3l-.6-3.7c-1.9-11.5-3.7-23.5-5.1-35C70.8 357.5 32 295.3 32 224C32 118 118 32 224 32s192 86 192 192zm-48 0c0-79.5-64.5-144-144-144S80 144.5 80 224c0 42.4 18.3 80.5 47.5 106.9c1.6-7.1 4.3-13.9 8.1-20.3c2.1-3.5 4.5-6.7 7-9.7c-19-20.1-30.6-47.1-30.6-76.9c0-61.9 50.1-112 112-112s112 50.1 112 112c0 29.8-11.6 56.8-30.6 76.9c2.5 2.9 4.9 6.1 7 9.7c3.8 6.3 6.4 13.1 8.1 20.3C349.7 304.5 368 266.4 368 224zM224 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM209.5 478.2c-3.6-13.6-8.6-37.7-12.7-63c-4.3-26.4-7.3-51.3-7.3-65.7c0-4.3 .9-5.8 1.1-6.1c.2-.3 .7-1.2 2.8-2.3c5.2-2.9 15.3-5.1 30.7-5.1s25.5 2.2 30.7 5.1c2.1 1.1 2.6 2 2.8 2.3c.2 .3 1.1 1.8 1.1 6.1c0 14.3-2.9 39.2-7.3 65.6c-4.1 25.2-9.1 49.4-12.8 63.1c-1 .4-2.5 .8-4.9 1.2c-2.7 .4-5.9 .6-9.7 .6s-7-.2-9.7-.6c-2.3-.4-3.9-.8-4.9-1.2zm-30.6 9.5c5.3 19.8 25.5 24.3 45.1 24.3s39.8-4.6 45.1-24.3c8.1-29.9 21.5-103.9 21.5-138.2c0-36.5-32.4-45.5-66.6-45.5s-66.6 9-66.6 45.5c0 34.4 13.4 108.5 21.5 138.2z"]
};
var faBee = {
  prefix: 'fal',
  iconName: 'bee',
  icon: [576, 512, [], "e0b2", "M219.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l31.5 31.5C215.6 73 208 91.6 208 112c0 3 .2 6 .5 8.9C185.7 105 157 96 128 96C63 96 0 140.9 0 208c0 61.9 53.6 104.9 112.9 111.2c-.6-5.1-.9-10.2-.9-15.2c0-5.7 .3-11.4 .8-17C66.7 280.9 32 247.6 32 208c0-43.8 42.5-80 96-80c40.8 0 75.2 21.1 89.3 50.5C173.5 203.3 144 250.2 144 304c0 83.8 103.6 179.7 129.9 202.8c3.9 3.4 8.9 5.2 14.1 5.2s10.2-1.8 14.1-5.2C328.4 483.7 432 387.8 432 304c0-53.8-29.5-100.7-73.3-125.5c14-29.5 48.5-50.5 89.3-50.5c53.5 0 96 36.2 96 80c0 39.6-34.7 72.9-80.8 79c.5 5.6 .8 11.3 .8 17c0 5-.3 10.1-.9 15.2C522.4 312.9 576 269.9 576 208c0-67.1-63-112-128-112c-29 0-57.7 9-80.5 24.9c.3-2.9 .5-5.9 .5-8.9c0-20.4-7.6-39-20.2-53.2l31.5-31.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.9 39.5C311.6 34.7 300.1 32 288 32s-23.6 2.7-33.9 7.5L219.3 4.7zM288 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM177.1 288c1.6-11.3 4.9-22.1 9.6-32H389.2c4.7 9.9 8 20.7 9.6 32H177.1zm32.5-64c20.2-19.8 47.9-32 78.4-32s58.2 12.2 78.4 32H209.6zm188.7 96c-2 10.2-5.7 20.9-10.9 32H188.5c-5.2-11.1-8.9-21.8-10.9-32H398.4zm-29 64c-5.4 8.1-11.3 16.3-17.6 24.5c-2 2.6-4 5.1-6 7.5H230.3c-2-2.5-4-5-6-7.5c-6.4-8.1-12.3-16.3-17.6-24.5H369.3zm-52.1 64c-11.4 11.8-21.7 21.6-29.2 28.5c-7.6-6.9-17.9-16.6-29.2-28.5h58.5z"]
};
var faTemperatureFull = {
  prefix: 'fal',
  iconName: 'temperature-full',
  icon: [320, 512, ["temperature-4", "thermometer-4", "thermometer-full"], "f2c7", "M160 32c-35.3 0-64 28.7-64 64V252.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96V252.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V96c0-8.8 7.2-16 16-16s16 7.2 16 16V306c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z"]
};
var faTemperature4 = faTemperatureFull;
var faThermometer4 = faTemperatureFull;
var faThermometerFull = faTemperatureFull;
var faBell = {
  prefix: 'fal',
  iconName: 'bell',
  icon: [448, 512, [128276, 61602], "f0f3", "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3H44.3C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1V192c0-83 63.1-151.2 144-159.2V16zm16 48C153.3 64 96 121.3 96 192v29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3H403.7c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2V192c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8z"]
};
var faCandyBar = {
  prefix: 'fal',
  iconName: 'candy-bar',
  icon: [640, 512, [127851, "chocolate-bar"], "e3e8", "M155.5 74.7c2.3-6.4 8.3-10.7 15.1-10.7H320h16 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H352 336 320 64c-35.3 0-64-28.7-64-64V234.5c0-6.8 4.3-12.8 10.7-15.1C41.8 208.5 64 178.8 64 144c0-8.8 7.2-16 16-16c34.8 0 64.5-22.2 75.5-53.3zM192 96v96H320V96H192zm-32 30.4c-17 17.4-39.7 29.2-65 32.6c-1.6 11.7-4.9 22.8-9.8 33H160V126.4zm-96 96c-9.2 9.4-20 17.1-32 22.8V320H160V224H64v-1.6zM32 352v32c0 17.7 14.3 32 32 32h96V352H32zm160 64H320V352H192v64zm128-96V224H192v96H320zm32 96H576c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H352V416z"]
};
var faChocolateBar = faCandyBar;
var faXmarkLarge = {
  prefix: 'fal',
  iconName: 'xmark-large',
  icon: [448, 512, [], "e59b", "M420.7 36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 256 443.3 452.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 278.6 27.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 256 4.7 59.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 233.4 420.7 36.7z"]
};
var faPinata = {
  prefix: 'fal',
  iconName: 'pinata',
  icon: [512, 512, [], "e3c3", "M160 48c0-26.5 21.5-48 48-48s48 21.5 48 48V224H416c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V448c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v16c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V225.9L38.9 197.3C15.1 185.4 0 161 0 134.4C0 95.5 31.5 64 70.4 64H160V48zm96 336h96 3.7c10.2 0 20.3 1.9 29.7 5.7l23.1 9.2 36.9-12.3c7.2-2.4 15-2.2 22 .6l12.6 5V342.5c-4.7-.1-9.3-1.2-13.6-3.4l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6L128 342v50.3l12.6-5c7-2.8 14.8-3 22-.6L199.5 399l23.1-9.2c9.4-3.8 19.5-5.7 29.7-5.7H256zM128 307.6l19.4-7.8c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l17.6 8.8C474.2 279.3 447.8 256 416 256H240c-3.5 0-6.7-1.1-9.4-3l-19.3 7.7c-7 2.8-14.8 3-22 .6L152.5 249 128 258.8v48.7zM224 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V80c0 8.8-7.2 16-16 16H70.4C49.2 96 32 113.2 32 134.4c0 14.5 8.2 27.8 21.2 34.3l65.9 33c5.4 2.7 8.8 8.3 8.8 14.3v8.4l12.6-5c7-2.8 14.8-3 22-.6L199.5 231l24.5-9.8V48zM128 426.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448c0-6 .8-11.9 2.4-17.4c-1.7-.3-3.4-.7-5-1.2L152.5 417 128 426.8zm352 0L455.5 417l-36.9 12.3c-1.6 .6-3.3 1-5 1.2c1.6 5.5 2.4 11.4 2.4 17.4v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V426.8zM152 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faArrowsFromLine = {
  prefix: 'fal',
  iconName: 'arrows-from-line',
  icon: [448, 512, [], "e0a4", "M235.3 4.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM0 256c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM224 512c4.2 0 8.3-1.7 11.3-4.7l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 457.4 240 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c3 3 7.1 4.7 11.3 4.7z"]
};
var faSuperscript = {
  prefix: 'fal',
  iconName: 'superscript',
  icon: [512, 512, [], "f12b", "M464 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V160H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H464V16zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H55.2L157 256 55.2 416H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64c5.5 0 10.6-2.8 13.5-7.4L176 285.8l98.5 154.8c2.9 4.6 8 7.4 13.5 7.4h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H296.8L195 256 296.8 96H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H288c-5.5 0-10.6 2.8-13.5 7.4L176 226.2 77.5 71.4C74.6 66.8 69.5 64 64 64H16z"]
};
var faBowlSpoon = {
  prefix: 'fal',
  iconName: 'bowl-spoon',
  icon: [512, 512, [129379], "e3e0", "M112 160c-49 0-80-33.1-80-64s31-64 80-64s80 33.1 80 64s-31 64-80 64zm0 32c55.5 0 101.6-34.6 110.5-80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H222.5C213.6 34.6 167.5 0 112 0C50.1 0 0 43 0 96s50.1 96 112 96zm49.3 271.9c-2.8-8.1-8.7-14.7-16.5-18.4c-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9H461.1c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2c-7.7 3.7-13.7 10.3-16.5 18.4c-3.3 9.4-12.2 16.1-22.7 16.1H184c-10.4 0-19.4-6.7-22.7-16.1zM50.9 224C23.3 224 1.4 247.2 3 274.8l.6 10.3c4.9 84.1 55.9 155.1 127.5 189.2c7.6 21.9 28.4 37.6 52.9 37.6H328c24.5 0 45.3-15.7 52.9-37.6c71.6-34.1 122.5-105.1 127.5-189.2l.6-10.3c1.6-27.6-20.3-50.8-47.9-50.8H50.9z"]
};
var faHexagonCheck = {
  prefix: 'fal',
  iconName: 'hexagon-check',
  icon: [512, 512, [], "e416", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zm319.6-36.7l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 297.4 340.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPlugCircleXmark = {
  prefix: 'fal',
  iconName: 'plug-circle-xmark',
  icon: [576, 512, [], "e560", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faStarOfLife = {
  prefix: 'fal',
  iconName: 'star-of-life',
  icon: [512, 512, [], "f621", "M192 48c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v97.1l84.1-48.6c23-13.3 52.3-5.4 65.6 17.6l16 27.7c13.3 23 5.4 52.3-17.6 65.6L384 256l84.1 48.6c23 13.3 30.8 42.6 17.6 65.6l-16 27.7c-13.3 23-42.6 30.8-65.6 17.6L320 366.9V464c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V366.9l-84.1 48.6c-23 13.3-52.3 5.4-65.6-17.6l-16-27.7c-13.3-23-5.4-52.3 17.6-65.6L128 256 43.9 207.4 51.6 194l-7.7 13.4c-23-13.3-30.8-42.6-17.6-65.6l16-27.7c13.3-23 42.6-30.8 65.6-17.6L192 145.1V48zm48-16c-8.8 0-16 7.2-16 16V172.9c0 5.7-3 11-8 13.9s-11 2.9-16 0L91.9 124.3c-7.7-4.4-17.4-1.8-21.9 5.9L54 157.9c-4.4 7.7-1.8 17.4 5.9 21.9L168 242.1c5 2.9 8 8.1 8 13.9s-3 11-8 13.9L59.9 332.3c-7.7 4.4-10.3 14.2-5.9 21.9l16 27.7c4.4 7.7 14.2 10.3 21.9 5.9L200 325.3c5-2.9 11-2.9 16 0s8 8.1 8 13.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V339.1c0-5.7 3-11 8-13.9s11-2.9 16 0l108.1 62.4c7.7 4.4 17.4 1.8 21.9-5.9l16-27.7c4.4-7.7 1.8-17.4-5.9-21.9L344 269.9c-5-2.9-8-8.1-8-13.9s3-11 8-13.9l108.1-62.4c7.7-4.4 10.3-14.2 5.9-21.9l-16-27.7c-4.4-7.7-14.2-10.3-21.9-5.9L312 186.7c-5 2.9-11 2.9-16 0s-8-8.1-8-13.9V48c0-8.8-7.2-16-16-16H240z"]
};
var faPhoneSlash = {
  prefix: 'fal',
  iconName: 'phone-slash',
  icon: [640, 512, [], "f3dd", "M480 510.9c-95.4-6.7-182.6-43.3-252.2-100.5L253.5 390c70.9 56.3 160.6 89.9 258.1 90l.3 0c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-8.7-5-17.1-10.4-25.3-16.2L344.8 318c4.9 3.2 9.9 6.3 15 9.3L393 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.2 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8zM141.2 315.6C92.5 243.9 64 157.3 64 64v0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c1.9 3.3 3.9 6.6 6 9.8l-25.2 19.9c-2.9-4.5-5.7-9.1-8.4-13.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C98.6 57 96 60.2 96 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 85.8 26 165.5 70.4 231.7l-25.2 19.9zM614.1 3.4c6.9-5.5 17-4.3 22.5 2.6s4.3 17-2.6 22.5l-608 480c-6.9 5.5-17 4.3-22.5-2.6s-4.3-17 2.6-22.5l608-480z"]
};
var faTrafficLightStop = {
  prefix: 'fal',
  iconName: 'traffic-light-stop',
  icon: [320, 512, [], "f63a", "M64 32C46.3 32 32 46.3 32 64V352c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-136a56 56 0 1 1 0-112 56 56 0 1 1 0 112z"]
};
var faPaintRoller = {
  prefix: 'fal',
  iconName: 'paint-roller',
  icon: [512, 512, [], "f5aa", "M352 32c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352zm64 32c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V96c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V64zM240 352c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32zm-32-32c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48V288c0-17.7 14.3-32 32-32H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64V96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H272c-35.3 0-64 28.7-64 64v32z"]
};
var faAccentGrave = {
  prefix: 'fal',
  iconName: 'accent-grave',
  icon: [192, 512, [], "60", "M64 65.3C64 46.9 78.9 32 97.3 32c16.1 0 30 11.6 32.8 27.5l22.5 126.2c.6 3.3-1.9 6.3-5.3 6.3c-1.7 0-3.4-.8-4.4-2.3L70.4 86.9C66.2 81 64 74 64 66.8V65.3zm-32 0v1.5c0 13.8 4.3 27.3 12.2 38.5l72.6 102.9c7 9.9 18.4 15.8 30.5 15.8c23.3 0 40.9-21 36.8-43.9L161.6 53.8C156.1 22.7 129 0 97.3 0C61.2 0 32 29.2 32 65.3z"]
};
var faHandshakeAngle = {
  prefix: 'fal',
  iconName: 'handshake-angle',
  icon: [640, 512, ["hands-helping"], "f4c4", "M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6L452.7 81.9c-9 9-21.2 14.1-33.9 14.1H304c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V168c0-8.8 7.2-16 16-16s16 7.2 16 16v24H448c35.3 0 64 28.7 64 64c0 24.5-13.7 45.7-33.9 56.5c1.2 5 1.9 10.2 1.9 15.5c0 29.9-20.5 55-48.3 62.1C428.7 422.6 401.3 448 368 448H237.3c-4.2 0-8.3 1.7-11.3 4.7l-54.6 54.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l54.6-54.6c9-9 21.2-14.1 33.9-14.1H368c17.7 0 32-14.3 32-32c0-1.8-.2-3.6-.4-5.4c-.8-4.7 .5-9.5 3.6-13.1s7.6-5.6 12.4-5.6l.4 0c17.7 0 32-14.3 32-32c0-6.1-1.7-11.7-4.6-16.6c-2.7-4.5-3.1-10-.9-14.8s6.5-8.2 11.6-9.2c14.8-2.8 25.9-15.8 25.9-31.4c0-17.7-14.3-32-32-32H336v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V160c0-53 43-96 96-96H418.7c4.2 0 8.3-1.7 11.3-4.7L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0zM125.6 190.3c9.2-24.5 27.6-43.5 50.4-53.8v37.1c-9.1 7.1-16.3 16.7-20.5 27.9l-26.1 69.6c-2.4 6.4-6.2 12.2-11 17.1L27.3 379.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l91.1-91.1c1.6-1.6 2.9-3.6 3.7-5.7l26.1-69.6zm509.8-57.6c6.2 6.2 6.2 16.4 0 22.6L543.6 247c-1.2-12.5-4.7-24.4-10.2-35l79.3-79.3c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faHandsHelping = faHandshakeAngle;
var faCircle0 = {
  prefix: 'fal',
  iconName: 'circle-0',
  icon: [512, 512, [], "e0ed", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96v64c0 53 43 96 96 96s96-43 96-96V224c0-53-43-96-96-96zm-64 96c0-35.3 28.7-64 64-64s64 28.7 64 64v64c0 35.3-28.7 64-64 64s-64-28.7-64-64V224z"]
};
var faDialMedLow = {
  prefix: 'fal',
  iconName: 'dial-med-low',
  icon: [576, 512, [], "e160", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM197.5 378.5c-46.2-46.2-49.7-118.8-10.6-169l89.8 89.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-89.8-89.8c50.2-39.1 122.9-35.5 169 10.6c50 50 50 131 0 181s-131 50-181 0zM174.9 174.9A160 160 0 1 0 401.1 401.1 160 160 0 1 0 174.9 174.9zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faLocationDot = {
  prefix: 'fal',
  iconName: 'location-dot',
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
var faMapMarkerAlt = faLocationDot;
var faCrab = {
  prefix: 'fal',
  iconName: 'crab',
  icon: [512, 512, [129408], "e3ff", "M112 32C73.3 32 41 59.5 33.6 96h97.1c4.2 0 8.3-1.7 11.3-4.7l6.6-6.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-6.6 6.6c-9 9-21.2 14.1-33.9 14.1H32v20.1c0 11.5 6.2 22.1 16.1 27.8l78.8 45C145.1 206 167.5 196 192 193V144c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16v49c24.5 3.1 46.9 13.1 65.1 28l78.8-45c10-5.7 16.1-16.3 16.1-27.8V128H381.3c-12.7 0-24.9-5.1-33.9-14.1l-6.6-6.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l6.6 6.6c3 3 7.1 4.7 11.3 4.7h97.1C471 59.5 438.7 32 400 32H384l25.6 19.2c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-64-48c-5.5-4.1-7.8-11.3-5.6-17.9S329.1 0 336 0h64c61.9 0 112 50.1 112 112v36.1c0 23-12.3 44.2-32.2 55.6l-72.1 41.2c6 8.3 11.1 17.4 15 27.1h37.5l28.6-14.3c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-2.2 1.1-4.7 1.7-7.2 1.7H431c.7 5.2 1 10.6 1 16v8l22.2 9.2c1.9 .8 3.7 2 5.2 3.5l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-29.8-29.8-25.7-10.7-31.1 31.1L421.7 401c2.1 .8 4 2 5.6 3.6l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-29.6-29.6-49.8-19-15.1 15.1L377.3 451c4.2 3 6.7 7.9 6.7 13v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V472.2L318.1 448H193.9L160 472.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V464c0-5.2 2.5-10 6.7-13l35.2-25.1-15.1-15.1-49.8 19L75.3 459.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c1.6-1.6 3.5-2.8 5.6-3.6l39.6-15.1L98.8 354.8 73.1 365.6 43.3 395.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c1.5-1.5 3.2-2.6 5.2-3.5L80 328v-8c0-5.4 .3-10.8 1-16H48c-2.5 0-4.9-.6-7.2-1.7l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2L51.8 272H89.3c3.9-9.7 9-18.8 15-27.1L32.2 203.7C12.3 192.3 0 171.1 0 148.1V112C0 50.1 50.1 0 112 0h64c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-64 48c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4L128 32H112zM304 224H208c-53 0-96 43-96 96v2.7L205.3 416H306.7L400 322.7V320c0-53-43-96-96-96z"]
};
var faBoxOpenFull = {
  prefix: 'fal',
  iconName: 'box-open-full',
  icon: [640, 512, ["box-full"], "f49c", "M256 32c53 0 96 43 96 96c0 8.8 7.2 16 16 16s16-7.2 16-16C384 57.3 326.7 0 256 0S128 57.3 128 128c0 8.8 7.2 16 16 16s16-7.2 16-16c0-53 43-96 96-96zM80.4 161.5c-14.1-1.6-27.5 6.2-33.1 19.2l-32 74.7C5.4 278.2 18.7 304.4 43 310l159.2 36.7c18.9 4.4 38.6-3.1 49.9-18.9L320 232.9l67.9 95.1c11.3 15.8 31 23.2 49.9 18.9L597 310c24.3-5.6 37.6-31.8 27.8-54.7l-32-74.7c-5.6-13-19-20.8-33.1-19.2L320 189.2 80.4 161.5zm-3.7 31.8l214.5 24.8-65.1 91.2c-3.8 5.3-10.3 7.7-16.6 6.3L50.2 278.9c-4.9-1.1-7.5-6.4-5.6-10.9l32-74.7zM544 348.7v61.8c0 7.3-5 13.7-12.1 15.5L336 475V336c0-8.8-7.2-16-16-16s-16 7.2-16 16V475L108.1 426C101 424.3 96 417.9 96 410.5V348.7l-32-9.1v71c0 22 15 41.2 36.4 46.6l208 52c7.6 1.9 15.6 1.9 23.3 0l208-52c21.4-5.3 36.4-24.5 36.4-46.6v-71l-32 9.1zM348.8 218.1l214.5-24.8 32 74.7c2 4.6-.7 9.8-5.6 10.9L430.6 315.6c-6.3 1.5-12.9-1-16.6-6.3l-65.1-91.2zm146.4-181c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-32 96c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l32-96z"]
};
var faBoxFull = faBoxOpenFull;
var faFile = {
  prefix: 'fal',
  iconName: 'file',
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"]
};
var faGreaterThan = {
  prefix: 'fal',
  iconName: 'greater-than',
  icon: [384, 512, [62769], "3e", "M1.7 72.8c-4 7.9-.7 17.5 7.2 21.5L332.2 256 8.8 417.7c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l352-176c5.4-2.7 8.8-8.3 8.8-14.3s-3.4-11.6-8.8-14.3l-352-176c-7.9-4-17.5-.7-21.5 7.2z"]
};
var faQuotes = {
  prefix: 'fal',
  iconName: 'quotes',
  icon: [576, 512, [], "e234", "M0 88C0 39.4 39.4 0 88 0h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H88C57.1 32 32 57.1 32 88V98.7C37 97 42.4 96 48 96H80c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-8V144 88zm32 56v24 8c0 8.8 7.2 16 16 16H80c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM160 88c0-48.6 39.4-88 88-88h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8c-30.9 0-56 25.1-56 56V98.7c5-1.8 10.4-2.7 16-2.7h32c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48v-8V144 88zm32 80v8c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v24zM576 424c0 48.6-39.4 88-88 88h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8c30.9 0 56-25.1 56-56V413.3c-5 1.8-10.4 2.7-16 2.7H496c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v8 24 56zm-32-56V344v-8c0-8.8-7.2-16-16-16H496c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM416 424c0 48.6-39.4 88-88 88h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8c30.9 0 56-25.1 56-56V413.3c-5 1.8-10.4 2.7-16 2.7H336c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v8 24 56zm-32-80v-8c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V344z"]
};
var faPretzel = {
  prefix: 'fal',
  iconName: 'pretzel',
  icon: [512, 512, [129384], "e441", "M149.4 64C84.6 64 32 116.6 32 181.4c0 64.6 28 122.7 72.7 162.8l27.6-39.9C100.1 273.3 80 229.7 80 181.4c0-38.3 31.1-69.4 69.4-69.4H156c42 0 76 34 76 76v3.6c0 16.2-4.9 32-14.2 45.3l-18.2 26.3-33 47.6 0 0-45.6 65.8 0 0L92.3 418.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1l34.5-49.8c4-5.8 11.3-8.3 18-6.1c20.9 6.7 43.2 10.3 66.4 10.3H256h5.4c15.5 0 30.6-1.6 45.1-4.7l-30.4-44c-4.8 .4-9.7 .6-14.7 .6H256h-5.4c-8.4 0-16.6-.6-24.7-1.8c-5.5-.8-10.2-4.4-12.4-9.4s-1.6-10.9 1.5-15.5l27.8-40.1c3-4.3 7.9-6.9 13.2-6.9s10.2 2.6 13.2 6.9l13 18.8 14.7 21.3 48.9 70.6 34.5 49.8 0 0c7.5 10.9 22.5 13.6 33.4 6.1s13.6-22.5 6.1-33.4l-28.8-41.6c-4.9-7-3.4-16.6 3.4-21.8C446.5 315 480 252.1 480 181.4C480 116.6 427.4 64 362.6 64H356c-34.7 0-66 14.2-88.6 37.2c-3 3.1-7.1 4.8-11.4 4.8s-8.4-1.7-11.4-4.8C222 78.2 190.7 64 156 64h-6.6zM326.1 423.6c-20.6 5.5-42.3 8.4-64.7 8.4H256h-5.4c-22.3 0-44-2.9-64.7-8.4L158 463.9c-17.6 25.4-52.5 31.8-77.9 14.2S48.4 425.6 66 400.1l0 0 20.4-29.5C33.5 324.7 0 257 0 181.4C0 98.9 66.9 32 149.4 32H156c38 0 72.9 13.6 100 36.3C283.1 45.6 318 32 356 32h6.6C445.1 32 512 98.9 512 181.4c0 75.6-33.5 143.3-86.3 189.3L446 400.1c17.6 25.4 11.3 60.3-14.2 77.9s-60.3 11.3-77.9-14.2l0 0-27.9-40.3zM173.3 245l18.2-26.3c5.5-8 8.5-17.4 8.5-27.1V188c0-24.3-19.7-44-44-44h-6.6c-20.7 0-37.4 16.7-37.4 37.4c0 37.3 14.8 71.2 38.8 96.2L173.3 245zM356 144c-24.3 0-44 19.7-44 44v3.6c0 9.7 3 19.1 8.5 27.1l40.7 58.8c24-24.9 38.8-58.8 38.8-96.2c0-20.7-16.7-37.4-37.4-37.4H356zm-76 44c0-42 34-76 76-76h6.6c38.3 0 69.4 31.1 69.4 69.4c0 53.7-24.8 101.5-63.5 132.8c-3.5 2.8-7.9 4-12.3 3.4s-8.3-3.1-10.9-6.7L294.2 237c-9.2-13.3-14.2-29.1-14.2-45.3V188z"]
};
var faPersonSwimming = {
  prefix: 'fal',
  iconName: 'person-swimming',
  icon: [576, 512, [127946, "swimmer"], "f5c4", "M104 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm29.8 122.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 384.1 0 390.4 0 398.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 401.9 161.7 416 192 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 401.9 353.7 416 384 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 374 404.9 384 384 384s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 374 212.9 384 192 384s-41.7-9.9-58.2-21.2zM258.4 185L412.3 315.5c10.7-3.5 21.4-8.8 30.9-15.4l.2-.2-163-138.3C309.5 140.5 345.3 128 384 128h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-114.9 0-208 93.1-208 208v14.8c5.5 1.1 10.9 1.7 16 1.7c5.4 0 10.7-.5 16-1.6V304c0-46.8 18.3-89.4 48.1-121l2.3 2z"]
};
var faSwimmer = faPersonSwimming;
var faArrowDown = {
  prefix: 'fal',
  iconName: 'arrow-down',
  icon: [384, 512, [8595], "f063", "M180.7 475.3c6.2 6.2 16.4 6.2 22.6 0l176-176c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 425.4 208 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 377.4L27.3 276.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176z"]
};
var faUserRobotXmarks = {
  prefix: 'fal',
  iconName: 'user-robot-xmarks',
  icon: [448, 512, [], "e4a7", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H144c-44.2 0-80 35.8-80 80v96c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80H240V16zM96 144c0-26.5 21.5-48 48-48H304c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H240V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H176V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c-26.5 0-48-21.5-48-48V144zM16 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM96 384H352c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16H368V448c0-17.7-14.3-32-32-32H288 224 160 112c-17.7 0-32 14.3-32 32v32H48c-8.8 0-16-7.2-16-16V448c0-35.3 28.7-64 64-64zm16 64h32v32H112V448zm96 0v32H176V448h32zm16 64h64 48 32 32c26.5 0 48-21.5 48-48V448c0-53-43-96-96-96H96c-53 0-96 43-96 96v16c0 26.5 21.5 48 48 48H80h32 48 64zm16-64h32v32H240V448zm96 0v32H304V448h32zM137.3 118.7c-5.2-5.2-13.5-5.2-18.7 0s-5.2 13.5 0 18.7L141.3 160l-22.7 22.7c-5.2 5.2-5.2 13.5 0 18.7s13.5 5.2 18.7 0L160 178.7l22.7 22.7c5.2 5.2 13.5 5.2 18.7 0s5.2-13.5 0-18.7L178.7 160l22.7-22.7c5.2-5.2 5.2-13.5 0-18.7s-13.5-5.2-18.7 0L160 141.3l-22.7-22.7zm109.3 0c-5.2 5.2-5.2 13.5 0 18.7L269.3 160l-22.7 22.7c-5.2 5.2-5.2 13.5 0 18.7s13.5 5.2 18.7 0L288 178.7l22.7 22.7c5.2 5.2 13.5 5.2 18.7 0s5.2-13.5 0-18.7L306.7 160l22.7-22.7c5.2-5.2 5.2-13.5 0-18.7s-13.5-5.2-18.7 0L288 141.3l-22.7-22.7c-5.2-5.2-13.5-5.2-18.7 0z"]
};
var faMessageQuote = {
  prefix: 'fal',
  iconName: 'message-quote',
  icon: [512, 512, ["comment-alt-quote"], "e1e4", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM208 144v24 24H160V144h48zm-48 80h48c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C215 290.7 240 258.7 240 222V192 168 144c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm144-80h48v24 24H304V144zm48 80c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C359 290.7 384 258.7 384 222V192 168 144c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h48z"]
};
var faCommentAltQuote = faMessageQuote;
var faCandyCorn = {
  prefix: 'fal',
  iconName: 'candy-corn',
  icon: [640, 512, [], "f6bd", "M480 0c44.1 0 90.4 4.2 132.6 18.1C629 23.5 640 38.8 640 56c0 20.1-7 52-15.6 84c-9.1 33.8-21.4 73-34.7 110.4c-13.2 37.2-27.9 73.6-41.6 101.3c-13.4 27-32.9 64.3-68.1 64.3s-54.6-37.3-68.1-64.3c-13.8-27.7-28.4-64.1-41.6-101.3C357 213 344.7 173.8 335.6 140C327 108 320 76.1 320 56c0-17.2 11.4-32.6 27.8-38.1C390 4.4 436 0 480 0zM602.6 48.4C564.9 36.1 522.3 32 480 32c-42.1 0-84.4 4.2-122.2 16.3C354.2 49.6 352 53 352 56c0 13.3 4.4 36.2 11.3 63.4c1.2-.2 2.6-.3 4.1-.5c6.2-.8 15.2-1.8 26.2-2.8c22-2 52.6-4.1 86.4-4.1s64.3 2 86.4 4.1c11 1 20 2 26.2 2.8c1.6 .2 2.9 .4 4.1 .5C603.6 92.2 608 69.3 608 56c0-3.4-2.2-6.5-5.4-7.6zM371.8 150.6c8.1 28.2 18.1 59.3 28.7 89.1l1.3 3.7c21.1-1.8 48.4-3.4 78.2-3.4s57.1 1.6 78.2 3.4l1.3-3.7c10.6-29.8 20.6-60.9 28.7-89.1c-5.9-.7-14.4-1.7-24.8-2.6c-21.4-2-50.9-3.9-83.4-3.9s-62.1 2-83.4 3.9c-10.4 1-18.9 1.9-24.8 2.6zm68.8 186.9c6.9 13.8 13.5 26.4 21.5 35.7c7.6 8.8 13.1 10.9 17.9 10.9s10.4-2.1 17.9-10.9c8-9.2 14.6-21.8 21.5-35.7c8.8-17.6 18.1-39.3 27.2-62.9c-19-1.4-41.9-2.5-66.6-2.5s-47.6 1.1-66.6 2.5c9.1 23.6 18.4 45.3 27.2 62.9zM85.1 203.3c31.2-31.2 67-61 106.6-81c15.4-7.7 34-4.7 46.2 7.5c14.2 14.2 31.8 41.8 48.3 70.4c17.5 30.3 36.5 66.8 53.6 102.6c16.9 35.7 32.4 71.8 42.2 101c9.6 28.6 22.2 68.7-2.7 93.6s-65 12.2-93.6 2.7c-29.3-9.8-65.4-25.2-101-42.2c-35.9-17-72.3-36.1-102.6-53.5c-28.7-16.5-56.2-34.2-70.4-48.3c-12.2-12.2-15-31.2-7.3-46.6c20.3-39.4 49.7-75 80.8-106.2zM206 150.9c-35.4 17.9-68.4 45.2-98.3 75.1C78 255.7 51 288.6 32.9 323.9c-1.7 3.4-.8 7.4 1.4 9.5c9.4 9.4 28.8 22.5 52.8 36.8c.7-1 1.6-2.1 2.6-3.3c3.8-4.9 9.5-12 16.5-20.5c14.2-17 34.3-40 58.2-63.9s46.9-44 63.9-58.2c8.5-7.1 15.6-12.7 20.5-16.5c1.2-1 2.3-1.8 3.3-2.6c-14.3-24.1-27.4-43.4-36.8-52.8c-2.4-2.4-6.1-3-9.2-1.5zm-91 235.4c25.7 14.2 54.7 29.1 83.3 42.7l3.5 1.7c13.7-16.2 31.9-36.6 52.9-57.7s41.5-39.2 57.7-52.9l-1.7-3.5c-13.6-28.6-28.5-57.6-42.7-83.3c-4.7 3.7-11.4 9-19.4 15.7c-16.5 13.7-38.7 33.2-61.8 56.2s-42.5 45.3-56.2 61.8c-6.7 8.1-12 14.7-15.7 19.4zm180.8 83.5c14.7 4.9 28.2 9.1 40.4 10c11.6 .9 17-1.6 20.4-5s5.8-8.8 5-20.4c-.9-12.2-5.1-25.7-10-40.4c-6.3-18.6-15.1-40.6-25.3-63.7c-14.4 12.4-31.4 27.8-48.9 45.3s-32.9 34.5-45.3 48.9c23.1 10.2 45.1 19 63.7 25.3z"]
};
var faFolderMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'folder-magnifying-glass',
  icon: [512, 512, ["folder-search"], "e18b", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM240 208a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160c20.7 0 39.9-6.6 55.6-17.7l45.1 45.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-45.1-45.1C329.4 311.9 336 292.7 336 272c0-53-43-96-96-96s-96 43-96 96s43 96 96 96z"]
};
var faFolderSearch = faFolderMagnifyingGlass;
var faNotebook = {
  prefix: 'fal',
  iconName: 'notebook',
  icon: [512, 512, [], "e201", "M192 32H128c-17.7 0-32 14.3-32 32v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v48c0 17.7 14.3 32 32 32h64V32zm32 448H416c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224V480zm-16 32H128c-35.3 0-64-28.7-64-64V400H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V144H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V64C64 28.7 92.7 0 128 0h80H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H208z"]
};
var faDroplet = {
  prefix: 'fal',
  iconName: 'droplet',
  icon: [384, 512, [128167, "tint"], "f043", "M192 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c11.9-27.6 28.5-57.5 46.6-86.8c35.9-58 76.4-110.9 94.5-133.7h1.3c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8C345.9 280.8 352 303.8 352 320c0 88.4-71.6 160-160 160zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"]
};
var faTint = faDroplet;
var faBullseyePointer = {
  prefix: 'fal',
  iconName: 'bullseye-pointer',
  icon: [512, 512, [], "f649", "M256 480c123.7 0 224-100.3 224-224S379.7 32 256 32S32 132.3 32 256c0 10.4 .7 20.6 2.1 30.6l-9.6 3.5c-7.8 2.9-14.7 7.7-19.9 13.9C1.5 288.5 0 272.4 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-16.4 0-32.5-1.5-48.1-4.5c6.2-5.3 11-12.1 13.9-19.9l3.5-9.6c10 1.4 20.2 2.1 30.6 2.1zm-7.7-64.2L260 383.9c68.8-2.1 124-58.6 124-127.9c0-70.7-57.3-128-128-128c-69.3 0-125.8 55.1-127.9 124L96.2 263.7c-.1-2.6-.2-5.1-.2-7.7c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160c-2.6 0-5.2-.1-7.7-.2zM271 261.5l-79.2 215c-2.3 6.2-8.1 10.3-14.7 10.5s-12.6-3.8-15.1-9.9l-30.5-74L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L108.9 380.5 34.9 350c-6.1-2.5-10-8.5-9.9-15.1s4.3-12.4 10.5-14.7l215-79.2c5.9-2.2 12.4-.7 16.8 3.7s5.9 11 3.7 16.8zM143.3 360c3.9 1.6 7.1 4.8 8.7 8.7l24 58.2L229 283 85.1 336l58.2 24z"]
};
var faEraser = {
  prefix: 'fal',
  iconName: 'eraser',
  icon: [576, 512, [], "f12d", "M353 74.3c-9.4-9.4-24.6-9.4-33.9 0l-111 111L390.6 368l111-111c9.4-9.4 9.4-24.6 0-33.9L353 74.3zM74.3 319c-9.4 9.4-9.4 24.6 0 33.9l88 88c4.5 4.5 10.6 7 17 7H300.7c6.4 0 12.5-2.5 17-7L368 390.6 185.4 208 74.3 319zM296.4 51.7c21.9-21.9 57.3-21.9 79.2 0L524.3 200.4c21.9 21.9 21.9 57.3 0 79.2L355.9 448H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H304v-.1c-1.1 .1-2.2 .1-3.3 .1H179.3c-14.9 0-29.1-5.9-39.6-16.4l-88-88c-21.9-21.9-21.9-57.3 0-79.2L296.4 51.7z"]
};
var faHexagonImage = {
  prefix: 'fal',
  iconName: 'hexagon-image',
  icon: [512, 512, [], "e504", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32l29.6 51.3L116 280.6c15.4-15.4 40.4-15.6 56.1-.5l55.3 53.4 95.4-101.8c15.8-16.9 42.6-16.9 58.4 0l68.3 72.8L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zm92 191.3l69.8-74.4-55.6-53.8c-3.1-3-8.1-3-11.2 .1L89.9 352l45.8 79.4zm297.1-97.8l-74.9-79.9c-3.2-3.4-8.5-3.4-11.7 0L164.1 447.8H348.3c11.4 0 22-6.1 27.7-16l56.8-98.3zM208 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faEarthAmericas = {
  prefix: 'fal',
  iconName: 'earth-americas',
  icon: [512, 512, [127758, "earth", "earth-america", "globe-americas"], "f57d", "M256 480C132.3 480 32 379.7 32 256c0-11.8 .9-23.3 2.7-34.6l3 6.7c9.3 21 27.3 37 49.2 43.9l63 19.7c15.5 4.9 26.1 19.2 26.1 35.5v15c0 17 9.6 32.6 24.8 40.2c4.4 2.2 7.2 6.7 7.2 11.6v22.7c0 26.2 21.2 47.4 47.4 47.4c21.8 0 40.7-14.8 46-35.9l4.4-17.6c2.6-10.2 9.2-19 18.3-24.2l11.6-6.6c19.9-11.4 32.2-32.6 32.2-55.6v-8.3c0-17-6.7-33.3-18.7-45.3l-3.9-3.9c-12-12-28.3-18.7-45.3-18.7H251.3c-5 0-9.9-1.2-14.3-3.4l-45.9-22.9c-2.1-1-3.8-2.7-4.8-4.8l-.7-1.4c-2.3-4.6-.4-10.2 4.2-12.5c2.2-1.1 4.8-1.3 7.1-.5l24.2 8.1c15 5 31.5-.7 40.3-13.8c8.6-12.9 7.7-30-2.2-41.9l-17.9-21.5c-2.5-3-2.5-7.4 .1-10.3l20.1-23.5c13.2-15.4 15.3-37.4 5.2-55.1L259.6 32C337.1 33.2 405 73.8 444.3 134.6l-38.2 15.3c-23.6 9.4-35.7 35.6-27.7 59.7l16.9 50.7c5.2 15.6 18 27.4 33.9 31.4L475 303.2C453.3 404.3 363.5 480 256 480zM48 172.7C77.3 99.7 143.8 45.7 224 34.3l14.9 26.1c3.4 5.9 2.7 13.2-1.7 18.4l-20.1 23.5c-12.7 14.8-12.9 36.6-.4 51.6l17.9 21.5c.9 1.1 1 2.6 .2 3.7c-.8 1.2-2.2 1.7-3.6 1.2L207 172.1c-10.4-3.5-21.7-2.7-31.5 2.2c-20.4 10.2-28.7 35-18.5 55.4l.7 1.4c4.1 8.3 10.9 15 19.2 19.2l45.9 22.9c8.9 4.4 18.7 6.8 28.6 6.8h48.8c8.5 0 16.6 3.4 22.6 9.4l3.9 3.9c6 6 9.4 14.1 9.4 22.6v8.3c0 11.5-6.2 22.1-16.1 27.8l-11.6 6.6c-16.7 9.6-28.8 25.5-33.5 44.2l-4.4 17.6c-1.7 6.9-7.9 11.7-15 11.7c-8.5 0-15.4-6.9-15.4-15.4V393.9c0-17-9.6-32.6-24.8-40.2c-4.4-2.2-7.2-6.7-7.2-11.6v-15c0-30.3-19.7-57-48.6-66.1l-63-19.7c-13.2-4.1-23.9-13.7-29.5-26.3L48 172.7zM480 256c0 5.2-.2 10.3-.5 15.4l-42.6-10.6c-5.3-1.3-9.6-5.3-11.3-10.5l-16.9-50.7c-2.7-8 1.4-16.8 9.2-19.9l41.8-16.7c13 28.3 20.2 59.9 20.2 93.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faEarth = faEarthAmericas;
var faEarthAmerica = faEarthAmericas;
var faGlobeAmericas = faEarthAmericas;
var faCrateApple = {
  prefix: 'fal',
  iconName: 'crate-apple',
  icon: [512, 512, ["apple-crate"], "f6b1", "M219.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm192 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zM75 126c6.3-10.4 13.1-14 21-14c9.3 0 23.1 3.9 35.6 8.8c18.2 7.1 38.5 7.1 56.7 0c12.5-4.9 26.4-8.8 35.6-8.8c7.9 0 14.7 3.6 21 14c6.8 11.2 11 28 11 45.5c0 7.1-.5 14-1.5 20.6h32.3c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0C130.1 85.9 111.6 80 96 80c-43.6 0-64 47.8-64 91.4c0 7 .4 13.9 1.2 20.6H65.5c-1-6.6-1.5-13.4-1.5-20.6c0-17.5 4.2-34.2 11-45.5zm403.7 66c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0c-12.4-4.8-29.6-10.3-44.6-11c3.4 4 6.4 8.3 9 12.7c4.5 7.4 8.2 15.3 11.1 23.6c4.3 1.3 8.6 2.8 12.8 4.5c18.2 7.1 38.5 7.1 56.7 0c12.5-4.9 26.4-8.8 35.6-8.8c7.9 0 14.7 3.6 21 14c6.8 11.2 11 28 11 45.5c0 7.1-.5 14-1.5 20.6h32.3zM32 384H480v72c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V384zm0-32V280c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24v72H32zm480 0V280c0-30.9-25.1-56-56-56H56c-30.9 0-56 25.1-56 56v72 16 16 72c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V384 368 352zM96 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faAppleCrate = faCrateApple;
var faPersonBurst = {
  prefix: 'fal',
  iconName: 'person-burst',
  icon: [640, 512, [], "e53b", "M456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM467.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H448V164c6-2.6 12.5-4 19.3-4zM448 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L563.3 170.3c-13.9-26-41-42.3-70.6-42.3H467.3c-29.5 0-56.6 16.3-70.6 42.3L337.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L416 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16zM190.5 17.3C187.9 11.6 182.3 8 176 8s-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.8 4 11.5 4.8 17.1 2.1s9.2-8.5 9.1-14.7L260 251l75.2-15.8c6.1-1.3 10.9-6 12.3-12.1s-.9-12.4-5.8-16.2l-60.9-46.8 34.6-68.6c2.8-5.6 2.1-12.3-1.8-17.2s-10.3-7.1-16.3-5.6L222.6 87.2 190.5 17.3zm-37.6 95.2L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l53.7-13.3-24.9 49.4c-3.5 6.9-1.6 15.2 4.5 19.9l43.8 33.7-54.1 11.3c-7.5 1.6-12.9 8.3-12.7 15.9l1 55.3-42.6-35.2c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9z"]
};
var faGameBoard = {
  prefix: 'fal',
  iconName: 'game-board',
  icon: [448, 512, [], "f867", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 16v32h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H336v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H336v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H336v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H240v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V272H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V112c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 128h64V176H144v64zm96 0h64V176H240v64zm0 32v64h64V272H240zm-32 0H144v64h64V272z"]
};
var faHatChef = {
  prefix: 'fal',
  iconName: 'hat-chef',
  icon: [512, 512, [], "f86b", "M170.9 83.4C187 52.8 219.1 32 256 32s69 20.8 85 51.4c2.5 4.7 7.1 7.9 12.4 8.5s10.5-1.5 13.9-5.5C379.1 72.7 396.5 64 416 64c35.3 0 64 28.7 64 64c0 4-.4 7.8-1 11.6l-.1 .5c-3.5 22.8-14.2 58.4-26.1 93.5c-11.8 34.7-24.3 67.7-31 84.7c-.4 1-1.4 1.8-2.8 1.8H373.8l25.9-141.1c1.6-8.7-4.2-17-12.8-18.6s-17 4.2-18.6 12.8l-26.4 144c-.2 1-.3 1.9-.3 2.9H272V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V320H170.4c0-1-.1-1.9-.3-2.9l-26.4-144c-1.6-8.7-9.9-14.4-18.6-12.8s-14.4 9.9-12.8 18.6L138.2 320H93c-1.4 0-2.4-.8-2.8-1.8c-6.6-17-19.2-50-31-84.7C47.3 198.4 36.6 162.8 33.1 140l-.1-.5c-.7-3.7-1-7.6-1-11.6c0-35.3 28.7-64 64-64c19.5 0 36.9 8.7 48.6 22.4c3.5 4 8.7 6.1 13.9 5.5s9.9-3.8 12.4-8.5zM256 0c-41.9 0-79.1 20.1-102.4 51.2c-16-12-36-19.2-57.6-19.2C43 32 0 75 0 128c0 5.8 .5 11.5 1.5 17.1c4 25.9 15.6 63.8 27.4 98.7c12 35.3 24.7 68.8 31.4 86C65.6 343.4 78.7 352 93 352H419c14.3 0 27.4-8.6 32.6-22.2c6.7-17.2 19.4-50.7 31.4-86c11.8-34.9 23.4-72.8 27.4-98.7c1-5.5 1.5-11.2 1.5-17.1c0-53-43-96-96-96c-21.6 0-41.6 7.2-57.6 19.2C335.1 20.1 297.9 0 256 0zM64 384v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384H416v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64z"]
};
var faHandBackPointRight = {
  prefix: 'fal',
  iconName: 'hand-back-point-right',
  icon: [512, 512, [], "e1a1", "M512 168c0-30.9-25.1-56-56-56l-200.6 0c-2-3.2-4.2-6.4-6.5-9.5L232 80c-15.1-20.1-38.8-32-64-32l-19.5 0c-53 0-101.7 29.1-126.8 75.7L17.2 132C5.9 153 0 176.4 0 200.3L0 336c0 61.9 50.1 112 112 112l8 0 88 0c35.3 0 64-28.7 64-64c0-2.8-.2-5.6-.5-8.3c19.4-11 32.5-31.8 32.5-55.7c0-5.3-.7-10.5-1.9-15.5c20.2-10.8 33.9-32 33.9-56.5c0-8.5-1.7-16.6-4.7-24L456 224c30.9 0 56-25.1 56-56zm-56-24c13.3 0 24 10.7 24 24s-10.7 24-24 24l-157.5 0c-7.1 0-13.3 4.6-15.3 11.4s.6 14 6.5 18c8.7 5.8 14.3 15.6 14.3 26.7c0 15.6-11.2 28.6-25.9 31.4c-5.1 1-9.5 4.4-11.6 9.2s-1.8 10.3 .9 14.8c2.9 4.8 4.6 10.5 4.6 16.6c0 14.7-10 27.2-23.6 30.9c-4.4 1.2-8.1 4.2-10.1 8.3s-2.2 8.8-.6 13.1c1.4 3.6 2.2 7.6 2.2 11.8c0 17.7-14.3 32-32 32l-88 0-8 0c-44.2 0-80-35.8-80-80l0-135.7c0-18.5 4.6-36.8 13.4-53.1l-14.1-7.6 14.1 7.6 4.5-8.3C69.4 102.6 107.3 80 148.5 80L168 80c15.1 0 29.3 7.1 38.4 19.2L216 112l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l78.3 0 1.7 0 208 0z"]
};
var faDove = {
  prefix: 'fal',
  iconName: 'dove',
  icon: [512, 512, [128330], "f4ba", "M273 128.8c-.7 5-1 10.1-1 15.2l0 21.6c-5.2-1.6-10.5-3.4-15.9-5.3c-22.5-30-40.1-66.5-45.7-109.4c-9.9 15.5-21.1 37.2-30.5 65c-9.1-8.3-17.2-17.4-24-27.5C171 50.2 188.8 23.8 201.2 9.3c5.2-6 13.4-7.8 21-5.8c10.9 2.9 18 13.1 18.4 24.4c1.3 38.9 13.9 72.5 32.4 100.8zM64.7 42.2C68.8 35.5 76 32 83.2 32c10.7 0 19.3 7.6 21.5 17.2c12.8 56.5 50.9 94.7 94.7 119.9c36.2 20.8 75.4 32.1 104.7 36.8l0-61.9c0-44.2 35.8-80 80-80h99.7C499.3 64 512 76.7 512 92.3c0 5.6-1.7 11-4.7 15.7L480 148.8V288c0 88.4-71.6 160-160 160H248.6l-78.9 60.7c-2.8 2.2-6.2 3.3-9.8 3.3C77.3 512 21.7 466.2 3.2 441.6c-3-4.1-4-9.3-2.5-14.2s5.1-8.7 9.9-10.5l123-44.3C89.2 341.3 32 282.5 32 184C32 108.2 52 62.6 64.7 42.2zM80.9 81.6C72.5 103 64 136.5 64 184c0 103.8 74 156.5 113.7 178.6c5.5 3.1 8.7 9 8.2 15.3s-4.6 11.6-10.5 13.8l-130.7 47c21.4 18.2 59.2 39.8 110 41.2l78.8-60.6c2.8-2.2 6.2-3.3 9.8-3.3H320c70.7 0 128-57.3 128-128V144c0-3.2 .9-6.2 2.7-8.9L476.8 96H384c-26.5 0-48 21.5-48 48l0 80c0 4.5-1.9 8.7-5.2 11.8s-7.7 4.5-12.2 4.2c-33.6-2.8-86.6-15.1-135.3-43c-42.5-24.4-82.7-61.4-102.5-115.3zM360 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSnowflakeDroplets = {
  prefix: 'fal',
  iconName: 'snowflake-droplets',
  icon: [640, 512, [], "e5c1", "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V89.4L267.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L304 134.6v93.7l-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3s-13.6 11.1-11.3 19.6l13.4 50.1-63.5-36.7c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7L117.6 200c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l81-21.7L288 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3S109 309.7 117.6 312l50.1 13.4-45.1 26L137.2 380l46.5-26.8-13.4 50.1c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81L304 283.7v93.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 422.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V422.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L336 377.4V283.7l81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1L502.8 380l14.7-28.5-45.1-26L522.4 312c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L352 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81L336 228.3V134.6l59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L336 89.4V16zM576 377.5l28.4 55.2c2.3 4.5 3.6 9.7 3.6 14.9c0 17.9-14.5 32.3-32 32.3s-32-14.4-32-32.3c0-5.2 1.2-10.4 3.6-14.9L576 377.5zm-18-35l-38.9 75.6c-4.7 9.1-7.1 19.3-7.1 29.5c0 35.3 28.7 64.3 64 64.3s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5L594 342.5l-.1-.1-1.9-3.7-6.7-13c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7l-6.7 13-1.9 3.7-.1 .1zM35.6 432.8L64 377.5l28.4 55.2c2.3 4.5 3.6 9.7 3.6 14.9C96 465.6 81.5 480 64 480s-32-14.4-32-32.3c0-5.2 1.2-10.4 3.6-14.9zM7.1 418.1C2.4 427.2 0 437.4 0 447.7C0 483 28.7 512 64 512s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5L82 342.5l-.1-.1L80 338.7l-6.7-13c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7l-6.7 13-1.9 3.7-.1 .1L7.1 418.1z"]
};
var faBatteryEmpty = {
  prefix: 'fal',
  iconName: 'battery-empty',
  icon: [576, 512, ["battery-0"], "f244", "M80 128c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H80zM0 176c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V336c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176zm560 16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16z"]
};
var faBattery0 = faBatteryEmpty;
var faGrid4 = {
  prefix: 'fal',
  iconName: 'grid-4',
  icon: [448, 512, [], "e198", "M24 97.6V56H65.6V97.6H24zm0 119.5V175.5H65.6v41.6H24zm0 119.5V294.9H65.6v41.6H24zM24 456V414.4H65.6V456H24zM16 32C7.2 32 0 39.2 0 48v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H16zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H16zM0 286.9v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 390.4c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H16zM143.5 97.6V56h41.6V97.6H143.5zm0 119.5V175.5h41.6v41.6H143.5zm0 119.5V294.9h41.6v41.6H143.5zm0 119.5V414.4h41.6V456H143.5zm-8-424c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H135.5zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H135.5zm-16 135.5v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H135.5c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H135.5zM262.9 56h41.6V97.6H262.9V56zm0 119.5h41.6v41.6H262.9V175.5zm0 119.5h41.6v41.6H262.9V294.9zm0 119.5h41.6V456H262.9V414.4zM238.9 48v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16zm0 119.5v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H254.9zm-16 135.5V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16zM382.4 97.6V56H424V97.6H382.4zm0 119.5V175.5H424v41.6H382.4zm0 119.5V294.9H424v41.6H382.4zm0 119.5V414.4H424V456H382.4zm-8-424c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H374.4zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H374.4zm-16 135.5v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H374.4c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H374.4z"]
};
var faSocks = {
  prefix: 'fal',
  iconName: 'socks',
  icon: [512, 512, [129510], "f696", "M140.8 465.9C129 475 114.4 480 99.5 480H96c-35.3 0-64-28.7-64-64c0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C143.4 300.4 160 267.3 160 232V128H288V96H160V48c0-8.8 7.2-16 16-16H289.6C292 20.2 297 9.4 303.9 .1c-1-.1-2-.1-3-.1H176c-26.5 0-48 21.5-48 48V232c0 25.2-11.9 48.9-32 64L38.4 339.2C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96h3.5c22 0 43.4-7.3 60.8-20.8l16.1-12.4c-5.4-9.6-9.6-19.9-12.4-30.8H164l-23.2 17.9zM368 0c-26.5 0-48 21.5-48 48V232c0 25.2-11.9 48.9-32 64l-57.6 43.2C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96h3.5c22 0 43.4-7.3 60.8-20.8l116.1-89.7c27.4-21.2 43.5-53.9 43.5-88.6V48c0-26.5-21.5-48-48-48H368zM352 48c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16V96H352V48zm0 80H480V312.9c0 24.8-11.5 48.2-31.1 63.3L332.8 465.9C321 475 306.4 480 291.5 480H288c-35.3 0-64-28.7-64-64c0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C335.4 300.4 352 267.3 352 232V128z"]
};
var faFaceSunglasses = {
  prefix: 'fal',
  iconName: 'face-sunglasses',
  icon: [512, 512, [], "e398", "M256 480C132.3 480 32 379.7 32 256c0-16.4 1.8-32.5 5.1-47.9l4.4 26.4c5.1 30.9 31.8 53.5 63.1 53.5h78.7c31.3 0 58-22.6 63.1-53.5l8-48c.6-3.5 .9-7.1 .9-10.5h1.3c0 3.5 .3 7 .9 10.5l8 48c5.1 30.9 31.8 53.5 63.1 53.5h78.7c31.3 0 58-22.6 63.1-53.5l4.4-26.4c3.4 15.4 5.1 31.5 5.1 47.9c0 123.7-100.3 224-224 224zm-9.2-336c-11-19-31.5-32-55.4-32H96.7c-4.6 0-9.1 .5-13.4 1.4C124.3 63.7 186.5 32 256 32s131.7 31.7 172.8 81.4c-4.3-.9-8.8-1.4-13.4-1.4H320.7c-24 0-44.5 13-55.4 32H246.8zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM141.5 339.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM289.1 181.3c-3.3-19.5 11.8-37.3 31.6-37.3h40.7l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4L316 253.4c-9.7-4.2-17.1-13.1-18.9-24.1l-8-48zM358.6 256l52.7-52.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H374.6l32-32h8.7c19.8 0 34.8 17.8 31.6 37.3l-8 48C436.3 244.7 423 256 407.3 256H358.6zM96.7 144h40.7l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4L92 253.4c-9.7-4.2-17.1-13.1-18.9-24.1l-8-48C61.8 161.8 76.9 144 96.7 144zm90.7 59.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H150.6l32-32h8.7c19.8 0 34.8 17.8 31.6 37.3l-8 48C212.3 244.7 199 256 183.3 256H134.6l52.7-52.7z"]
};
var faInbox = {
  prefix: 'fal',
  iconName: 'inbox',
  icon: [512, 512, [], "f01c", "M32 416V327.9c0-2.6 .3-5.2 1-7.8l0-.1H134.1l23.2 46.3c5.4 10.8 16.5 17.7 28.6 17.7H326.1c12.1 0 23.2-6.8 28.6-17.7L377.9 320H479l0 .1c.6 2.5 1 5.1 1 7.8V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM471 288H377.9c-12.1 0-23.2 6.8-28.6 17.7L326.1 352H185.9l-23.2-46.3c-5.4-10.8-16.5-17.7-28.6-17.7H41L90.9 88.2C94.5 74 107.3 64 122 64H390c14.7 0 27.5 10 31 24.2L471 288zM0 327.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.9c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
};
var faSquare0 = {
  prefix: 'fal',
  iconName: 'square-0',
  icon: [448, 512, [], "e255", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-64 96v64c0 35.3 28.7 64 64 64s64-28.7 64-64V224c0-35.3-28.7-64-64-64s-64 28.7-64 64z"]
};
var faSection = {
  prefix: 'fal',
  iconName: 'section',
  icon: [256, 512, [], "e447", "M32.5 84.7c3.6-20.1 16.3-34.6 36.9-43.4c21.2-9.1 50.6-11.9 84.4-6.6c10.7 1.7 43.5 8.1 54 10.9c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-12-3.2-46-9.8-57.3-11.6C121-2.9 85.1-.3 56.7 11.9C27.8 24.3 6.5 47 .9 79.7c0 .3-.1 .6-.1 .8c-2.2 19 .4 35.7 7.6 50c7.1 14.2 18.1 25 30.7 33.6c4.6 3.1 9.6 6 14.7 8.7c-26.7 12-46.7 33-52.1 63.1c-.1 .3-.1 .6-.1 .9c-2.3 18.3 .4 34.3 7.8 48.1c7.2 13.6 18.3 23.9 30.8 32c23.3 15 54.8 24 83.1 32.1l3.3 .9c30.8 8.8 57.7 16.8 75.9 29.5c8.7 6.1 14.6 12.7 18 20.3c3.3 7.5 4.8 17.2 2.3 30.6c-3.4 18.5-15.7 32.3-36.5 40.8c-21.3 8.7-50.7 11.3-84.4 6.3c-16.9-2.6-45.6-11.9-67.8-19.1l0 0 0 0c-4.8-1.5-9.2-3-13.2-4.3c-8.4-2.7-17.4 2-20.1 10.4s2 17.4 10.4 20.1c3.4 1.1 7.4 2.4 11.8 3.8C44.9 495.5 77.2 506 97 509.1l.1 0c37.5 5.6 73.1 3.2 101.3-8.3c28.6-11.7 50.2-33.2 55.9-64.7c3.4-18.6 1.8-35-4.6-49.4c-6.3-14.3-16.8-25.1-28.9-33.6c-1.7-1.2-3.5-2.4-5.4-3.5c20-13.1 34.4-32.5 38.9-58.7c3.3-19.4 1.8-36.4-4.5-51.3c-6.2-14.8-16.6-26.2-28.8-35.2c-23.6-17.4-56.4-27.3-85.9-36.1l-.5-.1c-30.8-9.3-58.3-17.5-77.6-30.6c-9.4-6.3-16-13.4-20.1-21.4c-4-7.9-6-17.9-4.5-31.5zM178 332.3c-14.1-5.1-28.8-9.3-42.7-13.2l-.5-.1 0 0c-30.7-8.7-58.1-16.6-77.4-29c-9.3-6-15.9-12.6-19.8-20c-3.8-7.2-5.8-16.3-4.3-28.8c3.5-18.3 15.8-32 36.4-40.4c10.1-4.1 22-6.9 35.4-8.1c5.9 1.8 11.8 3.6 17.5 5.3l0 0 3.3 1c30.9 9.3 57.9 17.8 76.1 31.2c8.7 6.4 14.8 13.5 18.3 21.8c3.5 8.2 4.9 18.9 2.5 33.4c-3.8 22.2-19.1 38.5-44.8 46.8z"]
};
var faSquareThisWayUp = {
  prefix: 'fal',
  iconName: 'square-this-way-up',
  icon: [448, 512, ["box-up"], "f49f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM112 368H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-256c4.6 0 9 2 12 5.5l56 64c5.8 6.7 5.1 16.8-1.5 22.6s-16.8 5.1-22.6-1.5l-28-32V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V170.6l-28 32c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l56-64c3-3.5 7.4-5.5 12-5.5zm160 0c4.6 0 9 2 12 5.5l56 64c5.8 6.7 5.1 16.8-1.5 22.6s-16.8 5.1-22.6-1.5l-28-32V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V170.6l-28 32c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l56-64c3-3.5 7.4-5.5 12-5.5z"]
};
var faBoxUp = faSquareThisWayUp;
var faGaugeHigh = {
  prefix: 'fal',
  iconName: 'gauge-high',
  icon: [512, 512, [62461, "tachometer-alt", "tachometer-alt-fast"], "f625", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM280 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-18.6-7.9-35.3-20.5-47l82.6-153.4c4.2-7.8 1.3-17.5-6.5-21.7s-17.5-1.3-21.7 6.5L271.3 289.8c-4.9-1.2-10-1.8-15.3-1.8c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM168 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm344-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTachometerAlt = faGaugeHigh;
var faTachometerAltFast = faGaugeHigh;
var faSquareAmpersand = {
  prefix: 'fal',
  iconName: 'square-ampersand',
  icon: [448, 512, [], "e260", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm176 88c0 6.2 2.4 12.1 6.6 16.6l22.1 23.3 21.8-15C235 203 240 193.5 240 183.2c0-12.8-10.4-23.2-23.2-23.2H200c-13.3 0-24 10.7-24 24zm68.7 51.2l-17.5 12.1 45.4 47.7L307 246.7c5.1-7.2 15.1-8.9 22.3-3.7s8.9 15.1 3.7 22.3l-38 53.2L331.6 357c6.1 6.4 5.8 16.5-.6 22.6s-16.5 5.8-22.6-.6l-32.4-34-6.3 8.8c-13.5 18.9-35.3 30.2-58.6 30.2h-36c-34.9 0-63.2-28.3-63.2-63.2c0-20.8 10.2-40.3 27.4-52.1l38.7-26.6-18.6-19.5C149.5 212.2 144 198.4 144 184c0-30.9 25.1-56 56-56h16.8c30.5 0 55.2 24.7 55.2 55.2c0 20.8-10.2 40.2-27.3 52zm-87.1 59.9c-8.5 5.8-13.5 15.4-13.5 25.7c0 17.2 14 31.2 31.2 31.2h36c12.9 0 25-6.2 32.5-16.8l9.8-13.8-53.2-55.8-42.9 29.5z"]
};
var faEnvelopeOpenText = {
  prefix: 'fal',
  iconName: 'envelope-open-text',
  icon: [512, 512, [], "f658", "M392 32H120c-13.3 0-24 10.7-24 24V222.5L77.5 207.2c-4.2-3.4-8.7-6.3-13.5-8.6V56C64 25.1 89.1 0 120 0H392c30.9 0 56 25.1 56 56V198.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5V56c0-13.3-10.7-24-24-24zM35 256c-1.6 0-3 1.3-3 3V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V259c0-1.6-1.3-3-3-3c-.7 0-1.3 .2-1.9 .7L294.5 405.1C283.7 414 270 418.9 256 418.9s-27.7-4.9-38.5-13.8L36.8 256.7c-.5-.4-1.2-.7-1.9-.7zM0 259c0-19.3 15.6-35 35-35c8.1 0 15.9 2.8 22.2 7.9L237.8 380.3c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5L454.9 231.9c6.3-5.1 14.1-7.9 22.2-7.9c19.3 0 35 15.6 35 35V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V259zM176 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faLampDesk = {
  prefix: 'fal',
  iconName: 'lamp-desk',
  icon: [512, 512, [], "e014", "M381.3 96L480 96 288 288V189.3c0-8.5-3.4-16.6-9.4-22.6l-38.1-38.1C230 118 224 103.6 224 88.6C224 57.3 249.3 32 280.6 32c15 0 29.4 6 40 16.6l38.1 38.1c6 6 14.1 9.4 22.6 9.4zm0-32L343.2 25.9C326.6 9.3 304.1 0 280.6 0C231.7 0 192 39.7 192 88.6c0 21.7 7.9 42.5 22.2 58.6l-97.5 97.5c-4 4-5.6 9.9-4.1 15.4L171.2 480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H192 368c8.8 0 16-7.2 16-16s-7.2-16-16-16H204.3L145.8 260.8l90.8-90.8L256 189.3V288c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l192-192c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H381.3zm-2.6 223.9C391 298 406.8 304 424 304c39.8 0 72-32.2 72-72c0-17.2-6-33-16.1-45.4L457 209.5c4.4 6.4 7 14.2 7 22.5c0 22.1-17.9 40-40 40c-8.4 0-16.1-2.6-22.5-7l-22.8 22.8z"]
};
var faHospital = {
  prefix: 'fal',
  iconName: 'hospital',
  icon: [640, 512, [127973, 62589, "hospital-alt", "hospital-wide"], "f0f8", "M160 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V96h96c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H416v0H352 288 224v0H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h96V64zM480 336V480h96c17.7 0 32-14.3 32-32V320H528c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V224H528c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V160c0-17.7-14.3-32-32-32H480V336zM160 128H64c-17.7 0-32 14.3-32 32v32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v64h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H32V448c0 17.7 14.3 32 32 32h96V128zM448 336V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32V480h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64V336zm-96 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zM304 64h32c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H360v16c0 13.3-10.7 24-24 24H304c-13.3 0-24-10.7-24-24V184H264c-13.3 0-24-10.7-24-24V128c0-13.3 10.7-24 24-24h16V88c0-13.3 10.7-24 24-24zm8 56c0 8.8-7.2 16-16 16H272v16h24c8.8 0 16 7.2 16 16v24h16V168c0-8.8 7.2-16 16-16h24V136H344c-8.8 0-16-7.2-16-16V96H312v24z"]
};
var faHospitalAlt = faHospital;
var faHospitalWide = faHospital;
var faPollPeople = {
  prefix: 'fal',
  iconName: 'poll-people',
  icon: [640, 512, [], "f759", "M80 48a16 16 0 1 1 32 0A16 16 0 1 1 80 48zm64 0A48 48 0 1 0 48 48a48 48 0 1 0 96 0zM592 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512V64h80zM272 64H480v96H272c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H272zM592 352c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H384V352H592zm-320 0h80v96H272c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H272zM1.1 486.1L.1 494C-1 502.8 5.2 510.8 14 511.9s16.8-5.1 17.9-13.9l1-7.9c3-24 23.4-42 47.6-42h31c24.2 0 44.6 18 47.6 42l1 7.9c1.1 8.8 9.1 15 17.9 13.9s15-9.1 13.9-17.9l-1-7.9c-5-40-39-70.1-79.4-70.1h-31c-40.3 0-74.4 30-79.4 70.1zm0-288L.1 206C-1 214.8 5.2 222.8 14 223.9s16.8-5.1 17.9-13.9l1-7.9c3-24 23.4-42 47.6-42h31c24.2 0 44.6 18 47.6 42l1 7.9c1.1 8.8 9.1 15 17.9 13.9s15-9.1 13.9-17.9l-1-7.9c-5-40-39-70.1-79.4-70.1h-31c-40.3 0-74.4 30-79.4 70.1zM80 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faWhiskeyGlassIce = {
  prefix: 'fal',
  iconName: 'whiskey-glass-ice',
  icon: [512, 512, ["glass-whiskey-rocks"], "f7a1", "M480 64L430 406.9c-3.4 23.6-23.7 41.1-47.5 41.1h-253c-23.8 0-44.1-17.5-47.5-41.1L32 64H480zM32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM255.4 195.3l.6-.6c-5-1.8-10.4-2.7-16-2.7H144c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h73.8l-19-19c-4-4-7.6-8.4-10.6-13H144c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h82.7l28.7-28.7zm67.9 45.3l56.6 56.6c6.2 6.2 6.2 16.4 0 22.6l-56.6 56.6c-6.2 6.2-16.4 6.2-22.6 0l-56.6-56.6c-6.2-6.2-6.2-16.4 0-22.6l56.6-56.6c6.2-6.2 16.4-6.2 22.6 0zm-45.3-22.6l-56.6 56.6c-18.7 18.7-18.7 49.1 0 67.9L278.1 399c18.7 18.7 49.1 18.7 67.9 0l56.6-56.6c18.7-18.7 18.7-49.1 0-67.9l-56.6-56.6c-18.7-18.7-49.1-18.7-67.9 0z"]
};
var faGlassWhiskeyRocks = faWhiskeyGlassIce;
var faWineBottle = {
  prefix: 'fal',
  iconName: 'wine-bottle',
  icon: [512, 512, [], "f72f", "M404.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6c-4.4 4.4-10.6 5.7-16.1 4l-86.6 86.6c-8 8-10.9 19.6-9.6 30.9c4 36.7-8.1 74.8-36.2 103L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l22.6 22.6c-12.5 12.5-12.5 32.8 0 45.3l88 88c12.5 12.5 32.8 12.5 45.3 0l24.7-24.7L66.1 312.7 41.4 337.4 18.7 314.7 180.2 153.3c28.1-28.1 66.3-40.2 103-36.2c11.3 1.2 22.9-1.6 30.9-9.6l86.6-86.6c-1.7-5.5-.4-11.7 4-16.1zM88.7 290.1L221.9 423.3l89.4-89.4L178.1 200.7 88.7 290.1zm112-112L333.9 311.3l2.2-2.2c21-21 30-49.4 27-76.9c-2-18.3 2.3-40.5 18.8-57l13.3-13.3-45.3-45.3L336.7 130c-16.5 16.5-38.7 20.8-57 18.8c-27.5-3-55.9 6-76.9 27l-2.2 2.2zm172-84l45.3 45.3 49.4-49.4L422.1 44.7 372.7 94.1z"]
};
var faChessRook = {
  prefix: 'fal',
  iconName: 'chess-rook',
  icon: [448, 512, [9820], "f447", "M64 32C46.3 32 32 46.3 32 64V185.3c0 14 6.1 27.3 16.8 36.4L87.6 255l-5.1 97h32L120 248.8c.3-5-1.8-9.8-5.6-13L69.6 197.4c-3.5-3-5.6-7.5-5.6-12.1V64h80v40c0 8.8 7.2 16 16 16s16-7.2 16-16V64h96v40c0 8.8 7.2 16 16 16s16-7.2 16-16V64h80V185.3c0 4.7-2 9.1-5.6 12.1l-44.8 38.4c-3.8 3.2-5.8 8-5.6 13L333.5 352h32l-5.1-97 38.8-33.3c10.6-9.1 16.8-22.4 16.8-36.4V64c0-17.7-14.3-32-32-32H64zM224 160c-26.5 0-48 21.5-48 48v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V208c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v48H208V208zM97.8 416l252.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H71.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L97.8 416zm252.4-32H97.8c-11.1 0-21.4 5.7-27.2 15.1L37.9 451.8C34.1 458 32 465.2 32 472.6C32 494.3 49.7 512 71.4 512H376.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"]
};
var faUserBountyHunter = {
  prefix: 'fal',
  iconName: 'user-bounty-hunter',
  icon: [448, 512, [], "e2bf", "M80 0C71.2 0 64 7.2 64 16V264c0 1 .1 2 .3 3l-.2 3.5c-.8 12 7.5 22.7 19.2 25.1l114.6 22.9c16.2 3.2 36.1 3.2 52.3 0l114.6-22.9c11.8-2.4 20-13.1 19.2-25.1l-8.3-128.2C370.5 62.2 304.1 0 224 0C170.5 0 123.1 27.7 96 70V32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm21.1 193.1c7.3 4.5 15.8 10.5 24.4 17.9c18.8 16.4 36.3 39.1 41.2 68.5l-70.2-14 4.7-72.4zm98.5 93.1c-3.3-45.3-28.9-78.1-53.1-99.2c-13-11.4-25.9-19.7-35.6-25.2c-1.1-.6-2.1-1.2-3.1-1.7H208V287.7c-1.3-.2-2.6-.4-3.9-.7l-4.5-.9zm40.4 1.6V160H340.2c-1 .5-2 1.1-3.1 1.7c-9.7 5.5-22.6 13.9-35.6 25.2c-24.2 21.1-49.8 53.9-53.1 99.2l-4.5 .9c-1.3 .3-2.5 .5-3.9 .7zm41.3-8.2c4.9-29.5 22.4-52.1 41.2-68.5c8.5-7.4 17.1-13.4 24.4-17.9l4.7 72.4-70.2 14zM341.6 128H224 106.4C117.6 72.9 166.3 32 224 32s106.4 40.9 117.6 96zM134.4 384H313.6c54.4 0 98.9 42.4 102.2 96H310.6L241 410.3c-9.4-9.4-24.6-9.4-33.9 0L137.4 480H32.2c3.3-53.6 47.8-96 102.2-96zM224 438.6L265.4 480H182.6L224 438.6zM25.6 512H144 304 422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352H134.4C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512z"]
};
var faBarsStaggered = {
  prefix: 'fal',
  iconName: 'bars-staggered',
  icon: [512, 512, ["reorder", "stream"], "f550", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM64 240c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16z"]
};
var faReorder = faBarsStaggered;
var faStream = faBarsStaggered;
var faDiagramSankey = {
  prefix: 'fal',
  iconName: 'diagram-sankey',
  icon: [576, 512, [], "e158", "M354.1 64c-5.6 0-10.8 2.9-13.7 7.8L263 200.7c-8.7 14.5-24.3 23.3-41.2 23.3H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H221.9c5.6 0 10.8-2.9 13.7-7.8L313 55.3C321.6 40.8 337.3 32 354.1 32H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H354.1zM201.7 320l74.5 120.4c2.9 4.7 8.1 7.6 13.6 7.6H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H289.8c-16.6 0-32.1-8.6-40.8-22.7L164 320H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H180.9l.7-.4 .3 .4H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H201.7z"]
};
var faCloudHailMixed = {
  prefix: 'fal',
  iconName: 'cloud-hail-mixed',
  icon: [512, 512, [], "f73a", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM24 512a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM183.9 370.1c-7.7-4.4-17.4-1.7-21.8 6l-64 112c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l64-112c4.4-7.7 1.7-17.4-6-21.8zm192 0c-7.7-4.4-17.4-1.7-21.8 6l-64 112c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l64-112c4.4-7.7 1.7-17.4-6-21.8zm-282 21.8c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32zm192 0c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32zm192 0c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32z"]
};
var faCircleUpLeft = {
  prefix: 'fal',
  iconName: 'circle-up-left',
  icon: [512, 512, [], "e128", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 184c0-4.4 3.6-8 8-8H297.4c3.7 0 6.6 3 6.6 6.6c0 1.8-.7 3.4-1.9 4.7l-25.4 25.4c-6.2 6.2-6.2 16.4 0 22.6l59.1 59.1c3.6 3.6 4.9 9 3.3 13.9c-.7 2-1.8 3.8-3.3 5.3l-22.1 22.1c-1.5 1.5-3.3 2.6-5.3 3.3c-4.9 1.6-10.3 .4-13.9-3.3l-59.1-59.1c-6.2-6.2-16.4-6.2-22.6 0l-25.4 25.4c-1.2 1.2-2.9 1.9-4.7 1.9c-3.7 0-6.6-3-6.6-6.6V184zm8-40c-22.1 0-40 17.9-40 40V297.4c0 21.3 17.3 38.6 38.6 38.6c10.2 0 20.1-4.1 27.3-11.3L224 310.6l47.7 47.7c12.2 12.2 30.3 16.5 46.7 11c6.7-2.2 12.8-6 17.8-11l22.1-22.1c5-5 8.8-11.1 11-17.8c5.5-16.4 1.2-34.5-11-46.7L310.6 224l14.1-14.1c7.2-7.2 11.3-17.1 11.3-27.3c0-21.3-17.3-38.6-38.6-38.6H184z"]
};
var faDharmachakra = {
  prefix: 'fal',
  iconName: 'dharmachakra',
  icon: [512, 512, [9784], "f655", "M256 0c8.8 0 16 7.2 16 16V48.6c45.4 3.5 86.7 21.5 119.3 49.4L414.4 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414 120.7c27.9 32.6 46 73.9 49.4 119.3H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H463.4c-3.5 45.4-21.5 86.7-49.4 119.3L437 414.4c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L391.3 414c-32.6 27.9-73.9 46-119.3 49.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V463.4c-45.4-3.5-86.7-21.5-119.3-49.4L97.6 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L98 391.3c-27.9-32.6-46-73.9-49.4-119.3H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H48.6c3.5-45.4 21.5-86.7 49.4-119.3L75 97.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L120.7 98c32.6-27.9 73.9-46 119.3-49.4V16c0-8.8 7.2-16 16-16zM120.7 143.4c-22.2 26.7-36.7 60-40 96.6h80.6c2.4-14.4 8.1-27.9 16.4-39.6l-57-57zm79.6 34.4c11.4-8.1 24.9-13.9 39.6-16.4V80.7c-36.6 3.3-69.9 17.8-96.6 40l57 57zM210.5 211c-11.5 11.6-18.4 27.5-18.5 44.5l0 .5 0 .5c0 3.3 .3 6.7 .9 10.1c2.3 13.5 8.6 25.3 17.6 34.4c.1 .1 .2 .2 .3 .3s.2 .2 .2 .3c11.6 11.5 27.5 18.4 44.5 18.5l.5 0 .5 0c3.3 0 6.7-.3 10.1-.9c13.5-2.3 25.3-8.6 34.4-17.6c.1-.1 .2-.2 .3-.3s.2-.2 .2-.2c14-14.1 21.2-34.5 17.6-55.6c-2.3-13.5-8.6-25.3-17.6-34.4c-.1-.1-.2-.2-.3-.3s-.2-.2-.2-.2c-11.6-11.5-27.5-18.4-44.5-18.5l-.5 0-.5 0c-3.3 0-6.7 .3-10.1 .9c-13.5 2.3-25.3 8.6-34.4 17.6c-.1 .1-.2 .2-.3 .3s-.2 .2-.3 .2zM177.7 311.6c-8.1-11.4-13.9-24.9-16.4-39.6H80.7c3.3 36.6 17.8 69.9 40 96.6l57-57zm-34.4 79.6c26.7 22.2 60 36.7 96.6 40V350.7c-14.4-2.4-27.9-8.1-39.6-16.4l-57 57zm168.3-57c-11.4 8.1-24.9 13.9-39.6 16.4v80.6c36.6-3.3 69.9-17.8 96.6-40l-57-57zm79.6 34.4c22.2-26.7 36.7-60 40-96.6H350.7c-2.4 14.4-8.1 27.9-16.4 39.6l57 57zm-57-168.3c8.1 11.4 13.9 24.9 16.4 39.6h80.6c-3.3-36.6-17.8-69.9-40-96.6l-57 57zm34.4-79.6c-26.7-22.2-60-36.7-96.6-40v80.6c14.4 2.4 27.9 8.1 39.6 16.4l57-57z"]
};
var faObjectsAlignLeft = {
  prefix: 'fal',
  iconName: 'objects-align-left',
  icon: [512, 512, [], "e3be", "M0 16C0 7.2 7.2 0 16 0s16 7.2 16 16l0 480c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 16zM160 176c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L176 96c-8.8 0-16 7.2-16 16l0 64zm-32-64c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-64zm32 288c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16l0 64zm-32-64c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-64z"]
};
var faOilCanDrip = {
  prefix: 'fal',
  iconName: 'oil-can-drip',
  icon: [640, 512, [], "e205", "M352 80c0 8.8-7.2 16-16 16l-64 0v64h96.9c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48V340L31.1 315.7C12.4 308.7 0 290.7 0 270.7V208c0-26.5 21.5-48 48-48H96h32H240V96l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H336c8.8 0 16 7.2 16 16zM454.7 223.3c-7.1 1.5-14.5 .6-21-2.7l-50.5-25.2c-4.4-2.2-9.3-3.4-14.3-3.4H128V317.8 352v16c0 8.8 7.2 16 16 16H403.1c9.2 0 17.9-3.9 24-10.8L583.8 195.6 454.7 223.3zM96 192H48c-8.8 0-16 7.2-16 16v62.7c0 6.7 4.1 12.6 10.4 15L96 305.8V192zM608 400l0-.1 0-.2c0-.1 0-.3 0-.6c-.1-.5-.2-1.2-.3-2.1c-.3-1.8-.9-4.2-1.7-7c-1.7-5.7-4.2-12.5-7.4-20c-2-4.7-4.2-9.5-6.5-14.3c-2.3 4.8-4.4 9.6-6.5 14.3c-7.1 16.6-9.5 26.7-9.5 29.9c0 8.8 7.2 16 16 16c7 0 10.7-2.1 12.3-3.5c1.2-1.1 3.7-4 3.7-12.5zm32 0c0 32-21.5 48-48 48s-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8c5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400z"]
};
var faFaceSmilingHands = {
  prefix: 'fal',
  iconName: 'face-smiling-hands',
  icon: [640, 512, [], "e396", "M110.9 175.4C143.3 91.5 224.7 32 320 32s176.7 59.5 209.1 143.4c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C522 68 428.9 0 320 0S118 68 81.1 163.9c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2zM290.1 478c-8.8-1.2-16.8 5-18 13.7s5 16.8 13.7 18c11.2 1.5 22.6 2.3 34.1 2.3s22.9-.8 34.1-2.3c8.8-1.2 14.9-9.2 13.7-18s-9.2-14.9-18-13.7c-9.8 1.3-19.7 2-29.9 2s-20.1-.7-29.9-2zM384 384.8V352v-2.4V298.4c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3v11.7 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 0 0 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6l0 0-34 34L488 318.6l0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3l0 0-16 16-34 34L520 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5l0 0-5.1 5.1-26.9 26.9-2 2L552 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L584 414.6l-37.5 37.5C528.7 470 504.4 480 479.2 480c-52.6 0-95.2-42.6-95.2-95.2zM320 400c11.6 0 22.4-1.2 32.5-3.4C358.5 461.3 412.9 512 479.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L447 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V352v11.8c-9.8 2.7-20.4 4.2-32 4.2s-22.2-1.5-32-4.2V352 298.4c0-28.7-23.3-52-52-52c-17.9 0-33.6 9-43 22.7l-47.1-47.1c-18.7-18.7-49.1-18.7-67.9 0c-1 1-2 2.1-3 3.2c-15.7-3.7-32.8 .5-45 12.8s-16.5 29.4-12.8 45c-1.1 .9-2.2 1.9-3.2 3C-4.1 304.2-4.7 333.2 12.2 352c-16.9 18.8-16.3 47.8 1.8 65.9l56.8 56.8c23.9 23.9 56.2 37.3 89.9 37.3c66.3 0 120.7-50.7 126.7-115.4c10.1 2.2 21 3.4 32.5 3.4zM220.5 178.5c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C273.6 145.9 258.8 136 240 136s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm147.1 25.4c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C433.6 145.9 418.8 136 400 136s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zM100.7 267.3l0 0c-6.2-6.2-6.2-16.4 0-22.6c.7-.7 1.4-1.3 2.1-1.8c6.2-4.4 14.9-3.8 20.5 1.8L174.6 296l0 0 9.4 9.4 2.3 2.3 10.4 10.4 5.7 5.7c5 5 13.7 1.5 13.7-5.7v-8V298.4c0-1 .1-2 .2-3c.1-.9 .3-1.7 .6-2.5c2.4-8.4 10.1-14.5 19.2-14.5c11 0 20 9 20 20v51.2V352v32.8c0 52.6-42.6 95.2-95.2 95.2c-25.2 0-49.5-10-67.3-27.9L56 414.6 36.7 395.3c-5.6-5.6-6.2-14.3-1.8-20.5c.5-.7 1.1-1.4 1.8-2.1c6.2-6.2 16.4-6.2 22.6 0l2 2L78.6 392c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4L70.7 365.3l-2-2L41.8 336.4l-5.1-5.1 0 0c-5.6-5.6-6.2-14.3-1.8-20.5c.5-.7 1.1-1.4 1.8-2.1c6.2-6.2 16.4-6.2 22.6 0l0 0 0 0 34 34L110.6 360l0 0c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4l-17.3-17.3-34-34-16-16 0 0c-3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.2 4.7-11.3s7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7l16 16 34 34L142.6 328l0 0c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4l0 0-17.3-17.3-34-34z"]
};
var faBroccoli = {
  prefix: 'fal',
  iconName: 'broccoli',
  icon: [512, 512, [129382], "e3e2", "M256 0c-37.2 0-69.5 21.2-85.4 52.1C162.2 49.4 153.3 48 144 48c-48.6 0-88 39.4-88 88c0 10.7 1.9 20.9 5.4 30.4C25.5 180.3 0 215.2 0 256c0 53 43 96 96 96h8s47.7 54.5 80.2 138.3c5 12.8 17.1 21.7 30.9 21.7h81.9c13.8 0 25.9-8.9 30.9-21.7C360.3 406.5 408 352 408 352h8c53 0 96-43 96-96c0-40.8-25.5-75.7-61.4-89.6c3.5-9.5 5.4-19.7 5.4-30.4c0-48.6-39.4-88-88-88c-9.3 0-18.2 1.4-26.6 4.1C325.5 21.2 293.2 0 256 0zm19.2 352l-2 4.9L256 400l-17.2-43.1-2-4.9h38.4zm-72.9 0l24 59.9C231.1 424 242.9 432 256 432s24.9-8 29.7-20.1l24-59.9 57.7 0c-4.1 5.6-8.9 12.3-13.9 20c-16.9 25.5-38.2 62.1-55.4 106.7c-.2 .6-.6 1-.9 1.2c-.1 .1-.2 .1-.2 .1H215.1c0 0-.1 0-.2-.1c-.3-.2-.6-.6-.9-1.2c-17.3-44.6-38.5-81.2-55.4-106.7c-5.1-7.7-9.8-14.4-13.9-20h57.7zM194.6 77.8C202.5 51.3 227 32 256 32s53.5 19.3 61.4 45.8c1.4 4.7 4.8 8.5 9.3 10.3s9.6 1.5 13.9-.9C348.7 82.6 358 80 368 80c30.9 0 56 25.1 56 56c0 11.8-3.6 22.7-9.8 31.7c-3.1 4.6-3.7 10.4-1.5 15.5s6.9 8.6 12.4 9.4c31 4.4 54.9 31.1 54.9 63.4c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64c0-32.3 23.9-59 54.9-63.4c5.5-.8 10.2-4.3 12.4-9.4s1.7-10.9-1.5-15.5c-6.2-9-9.8-19.9-9.8-31.7c0-30.9 25.1-56 56-56c10 0 19.3 2.6 27.4 7.2c4.2 2.4 9.3 2.7 13.9 .9s8-5.6 9.3-10.3z"]
};
var faRouteInterstate = {
  prefix: 'fal',
  iconName: 'route-interstate',
  icon: [512, 512, [], "f61b", "M53.7 63.9C113 85.7 195.6 75.8 256 35.6c60.4 40.2 143 50.1 202.3 28.3c3.3 34.5 5.1 66.4 5.1 96.1H256 48.2c.2-29.8 2.2-61.8 5.5-96.1zM48.7 192h414c-2.3 44.8-9.9 84.2-24.8 119.4c-27.8 66-82.2 119.8-182.3 167.1C154.1 435.2 99.9 381.6 72.6 314.8c-14.8-36.1-22-76.7-23.9-122.8zM270 6.4c-8.4-5.9-19.7-5.9-28.1 0C186.2 45.5 107.2 53 57.4 30.9C43.2 24.6 24.6 33 22.8 50.6C11.9 158.8 11.7 250.5 43 326.9c31.7 77.4 94.5 136.7 203.5 182.5c6.2 2.6 13.4 2.5 19.5-.4c106.7-49.8 169.3-109 201.4-185.2c31.8-75.4 32.7-165 21.8-273.2c-1.8-17.6-20.4-26.1-34.6-19.7C404.8 53 325.8 45.5 270 6.4z"]
};
var faEarMuffs = {
  prefix: 'fal',
  iconName: 'ear-muffs',
  icon: [640, 512, [], "f795", "M320 32c-91.9 0-167.4 70.5-175.3 160.3c-11.7 1-22.7 4.2-32.6 9.2C115.5 89.7 207.3 0 320 0S524.5 89.7 527.9 201.5c-9.9-5.1-20.9-8.3-32.6-9.2C487.4 102.5 411.9 32 320 32zM496 224.6c9 1.3 17.2 4.7 24.3 9.7c5-1.5 10.3-2.2 15.7-2.2c19.9 0 37.5 10.4 47.4 26.1c23.4 6.7 40.6 28.3 40.6 53.9c0 5.1-.7 10.1-2 14.9c11.1 10.2 18 24.9 18 41.1s-6.9 30.9-18 41.1c1.3 4.7 2 9.7 2 14.9c0 25.6-17.2 47.2-40.6 53.9C573.5 493.6 555.9 504 536 504c-5.5 0-10.7-.8-15.7-2.2C511.2 508.2 500 512 488 512c-30.9 0-56-25.1-56-56c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-11.9 3.7-22.9 10-32c-6.3-9.1-10-20.1-10-32c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-30.9 25.1-56 56-56c2.7 0 5.4 .2 8 .6zM152 224c30.9 0 56 25.1 56 56c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 11.9-3.7 22.9-10 32c6.3 9.1 10 20.1 10 32c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 30.9-25.1 56-56 56c-12 0-23.2-3.8-32.3-10.2c-5 1.5-10.3 2.2-15.7 2.2c-20 0-37.5-10.4-47.4-26.1C33.2 471.2 16 449.6 16 424c0-5.1 .7-10.1 2-14.9C6.9 398.9 0 384.3 0 368s6.9-30.9 18-41.1c-1.3-4.7-2-9.7-2-14.9c0-25.6 17.2-47.2 40.6-53.9C66.5 242.4 84 232 104 232c5.5 0 10.7 .8 15.7 2.2c7.1-5 15.3-8.4 24.3-9.7c2.6-.4 5.3-.6 8-.6zm20.8 100c-5.7-9.9-5.7-22.1 0-32c2-3.5 3.2-7.6 3.2-12c0-13.3-10.7-24-24-24c-5.2 0-9.9 1.6-13.8 4.4c-8 5.6-18.1 7.3-27.4 4.6c-2.1-.6-4.4-1-6.8-1c-8.5 0-16 4.4-20.3 11.2c-4.2 6.7-10.7 11.5-18.3 13.7C55.3 291.8 48 301.1 48 312c0 2.3 .3 4.4 .9 6.4c3.2 11.5-.4 23.9-9.1 32C34.9 354.8 32 361 32 368s2.9 13.2 7.7 17.6c8.8 8.1 12.3 20.4 9.1 32c-.5 2-.9 4.1-.9 6.4c0 10.9 7.3 20.2 17.4 23.1c7.6 2.2 14.1 7 18.3 13.7C88 467.6 95.5 472 104 472c2.4 0 4.6-.3 6.8-1c9.4-2.7 19.5-1 27.4 4.6c3.9 2.8 8.6 4.4 13.8 4.4c13.3 0 24-10.7 24-24c0-4.4-1.2-8.5-3.2-12c-5.7-9.9-5.7-22.1 0-32c2-3.5 3.2-7.6 3.2-12c0-5.1-1.6-9.8-4.3-13.7c-7.7-11-7.7-25.6 0-36.6c2.7-3.9 4.3-8.6 4.3-13.7c0-4.4-1.2-8.5-3.2-12zM464 280c0 4.4 1.2 8.5 3.2 12c5.7 9.9 5.7 22.1 0 32c-2 3.5-3.2 7.6-3.2 12c0 5.1 1.6 9.8 4.3 13.7c7.7 11 7.7 25.6 0 36.6c-2.7 3.9-4.3 8.6-4.3 13.7c0 4.4 1.2 8.5 3.2 12c5.7 9.9 5.7 22.1 0 32c-2 3.5-3.2 7.6-3.2 12c0 13.3 10.7 24 24 24c5.2 0 9.9-1.6 13.8-4.4c8-5.6 18.1-7.3 27.4-4.6c2.1 .6 4.4 1 6.8 1c8.5 0 16-4.4 20.3-11.2c4.2-6.7 10.7-11.5 18.3-13.7c10.1-2.9 17.4-12.2 17.4-23.1c0-2.3-.3-4.4-.9-6.4c-3.2-11.5 .4-23.9 9.1-32c4.8-4.4 7.7-10.7 7.7-17.6s-2.9-13.2-7.7-17.6c-8.8-8.1-12.3-20.4-9.1-32c.5-2 .9-4.1 .9-6.4c0-10.9-7.3-20.2-17.4-23.1c-7.6-2.2-14.1-7-18.3-13.7C552 268.4 544.5 264 536 264c-2.4 0-4.6 .3-6.8 1c-9.4 2.7-19.5 1-27.4-4.6c-3.9-2.8-8.6-4.4-13.8-4.4c-13.3 0-24 10.7-24 24z"]
};
var faHotdog = {
  prefix: 'fal',
  iconName: 'hotdog',
  icon: [512, 512, [127789], "f80f", "M458.9 154.9l-304 304c-28.1 28.1-73.7 28.1-101.8 0S25 385.2 53.1 357.1l304-304c28.1-28.1 73.7-28.1 101.8 0s28.1 73.7 0 101.8zm22.6 22.6c40.6-40.6 40.6-106.5 0-147.1s-106.5-40.6-147.1 0l-304 304c-40.6 40.6-40.6 106.5 0 147.1s106.5 40.6 147.1 0l304-304zm-70.2-60.9c-6.2-6.2-16.4-6.2-22.6 0c-7 7-12.5 10.8-17 13.1c-4.5 2.3-8.5 3.4-13.6 4.7l-1.5 .4c-4.7 1.2-10.9 2.7-17.3 5.6c-7.4 3.4-14.8 8.4-22.7 16.3c-16.2 16.2-20.5 30.7-24 42.7l0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.5 7.8-12.4 9.1c-3 1.3-5.8 1.7-10.6 2.4l-.4 .1c-4.6 .6-10.9 1.6-18 4.5c-7.4 3.1-14.8 8.1-22.6 15.9c-16.2 16.2-20.5 30.7-24 42.7l0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.7 8.1-13.3 9.8c-3.6 1.6-6.9 2.5-12 3.7l-1.2 .3c-5.6 1.4-12.6 3.2-20.4 7.3c-7.9 4-16 9.9-25 18.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c7-7 12.5-10.8 17-13.1c4.5-2.3 8.5-3.4 13.6-4.7l1.5-.4 0 0c4.7-1.2 10.9-2.7 17.3-5.6c7.4-3.4 14.8-8.4 22.7-16.3c16.2-16.2 20.5-30.7 24-42.7l0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.5-7.8 12.4-9.1c3-1.3 5.8-1.7 10.6-2.4l.4-.1c4.6-.6 10.9-1.6 18-4.5c7.4-3.1 14.8-8.1 22.6-15.9c16.2-16.2 20.5-30.7 24-42.7l0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.7-8.1 13.3-9.8c3.6-1.6 6.9-2.5 12-3.7l1.2-.3c5.6-1.4 12.6-3.2 20.4-7.3c7.9-4 16-9.9 25-18.9c6.2-6.2 6.2-16.4 0-22.6zM264 0c-15.4 0-30.1 6.1-41 17L17 223C6.1 233.9 0 248.6 0 264c0 14.8 5.7 29.1 15.8 39.8l22.6-22.6C34.3 276.4 32 270.3 32 264c0-6.9 2.7-13.5 7.6-18.3L17.2 223.2l22.4 22.4L245.7 39.6c4.9-4.9 11.5-7.6 18.3-7.6c6.3 0 12.4 2.3 17.2 6.5l22.6-22.6C293.1 5.7 278.8 0 264 0zM208.2 496.2c10.7 10.2 25 15.8 39.8 15.8c15.4 0 30.1-6.1 41-17L495 289c10.9-10.9 17-25.6 17-41c0-14.8-5.7-29.1-15.8-39.8l-22.6 22.6c4.2 4.7 6.5 10.8 6.5 17.2c0 6.9-2.7 13.5-7.6 18.3L266.3 472.4c-4.9 4.9-11.5 7.6-18.3 7.6c-6.3 0-12.4-2.3-17.2-6.5l-22.6 22.6z"]
};
var faTransporterEmpty = {
  prefix: 'fal',
  iconName: 'transporter-empty',
  icon: [512, 512, [], "e046", "M144 480c-8.8 0-16 7.2-16 16s-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16H144z"]
};
var faPersonWalkingWithCane = {
  prefix: 'fal',
  iconName: 'person-walking-with-cane',
  icon: [512, 512, ["blind"], "f29d", "M184 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 184 0a56 56 0 1 0 0 112zm-30.4 32c-31.6 0-60.3 18.6-73.1 47.5l-47.1 106c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l47.1-106c2.5-5.6 6-10.6 10.3-14.8v96c0 17 9 32.7 23.7 41.4L256 393.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V393.2c0-11.3-6-21.8-15.8-27.6l-32.2-19V190.4c2.1 2.1 4 4.5 5.7 7l77 115.5c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-77-115.5c-14.8-22.3-39.8-35.6-66.6-35.6H153.6zM152 285.7V176c.5 0 1.1 0 1.6 0h52.2c.8 0 1.5 0 2.3 .1V327.8l-48.1-28.3c-4.9-2.9-7.9-8.1-7.9-13.8zM96.6 491.8c-2.3 8.5 2.7 17.3 11.2 19.6s17.3-2.7 19.6-11.2l34.2-125.4L133.1 358 96.6 491.8zm354.3 13.3c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L372.3 335.4c-2.8 3.2-6 6.1-9.7 8.5c-5.7 3.8-11.9 6.2-18.3 7.3L450.8 505.1z"]
};
var faBlind = faPersonWalkingWithCane;
var faAngle90 = {
  prefix: 'fal',
  iconName: 'angle-90',
  icon: [448, 512, [], "e08d", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V464c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V48zm160.8 75c-29.9-13.2-62.2-21.9-96-25.3c-9.1-.9-16.8 6.4-16.8 15.6c0 8.5 6.7 15.5 15.1 16.4c29.3 3.2 57.3 10.7 83.3 22c7.6 3.3 16.6 .8 21-6.3c4.9-8 2-18.5-6.6-22.3zM297.5 247.4c5.1 7.1 14.8 9.3 22.2 4.7c7.6-4.7 10-14.8 4.7-22.1c-20.6-28.8-45.8-54-74.6-74.6c-7.3-5.2-17.4-2.9-22.1 4.7c-4.6 7.4-2.3 17.1 4.7 22.2c24.9 18 46.9 40 64.9 64.9zm30.8 54.1c11.3 26 18.8 54 22 83.3c.9 8.5 7.9 15.1 16.4 15.1c9.2 0 16.5-7.7 15.6-16.8c-3.4-33.9-12.2-66.1-25.3-96c-3.8-8.6-14.3-11.6-22.3-6.6c-7.1 4.4-9.6 13.4-6.3 21z"]
};
var faRectangleTerminal = {
  prefix: 'fal',
  iconName: 'rectangle-terminal',
  icon: [512, 512, [], "e236", "M448 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM99.9 149.6c-5.8 6.7-5 16.8 1.7 22.6L199.4 256l-97.8 83.9c-6.7 5.8-7.5 15.8-1.7 22.6s15.9 7.5 22.6 1.7l112-96c3.5-3 5.6-7.5 5.6-12.1s-2-9.1-5.6-12.1l-112-96c-6.7-5.8-16.8-5-22.6 1.7zM224 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H224z"]
};
var faKite = {
  prefix: 'fal',
  iconName: 'kite',
  icon: [640, 512, [129665], "f6f4", "M338.2 50.8L273 344.4 457.4 160 341.1 43.7c-1.3 2.2-2.3 4.5-2.8 7.1zM258.9 407.9l-5.4 1.2-88.2 88.2c-9.4 9.4-22.1 14.6-35.3 14.6C102.4 512 80 489.6 80 462.1V316.3L24.2 349.7c-4.9 3-11.1 3-16.1 .2S0 341.8 0 336V240c0-5.8 3.1-11.1 8.1-13.9s11.2-2.8 16.1 .2L80 259.7V208c0-26.5-21.5-48-48-48H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32c44.2 0 80 35.8 80 80v51.7l55.8-33.5c4.9-3 11.1-3 16.1-.2s8.1 8.2 8.1 13.9v96c0 5.8-3.1 11.1-8.1 13.9s-11.2 2.8-16.1-.2L112 316.3V462.1c0 9.9 8 17.9 17.9 17.9c4.8 0 9.3-1.9 12.7-5.3l88.2-88.2 1.2-5.4L307 43.9C312.7 18.2 335.4 0 361.7 0H584c30.9 0 56 25.1 56 56V278.3c0 26.2-18.2 49-43.9 54.7L258.9 407.9zM480 182.6L295.6 367l293.6-65.2c2.6-.6 4.9-1.5 7.1-2.8L480 182.6zM608 56c0-.4 0-.9 0-1.3L502.6 160 608 265.4V56zM584 32H374.6L480 137.4 585.3 32c-.4 0-.9 0-1.3 0zM32 268.3v39.5L64.9 288 32 268.3zm128 39.5V268.3L127.1 288 160 307.7z"]
};
var faDrum = {
  prefix: 'fal',
  iconName: 'drum',
  icon: [512, 512, [129345], "f569", "M509.6 39.5c4.7 7.5 2.4 17.4-5.1 22l-86.3 53.9C475.4 133 512 162.8 512 208V368c0 22.6-13.6 41.6-32.3 56.2c-18.8 14.7-44.9 26.8-75.1 35.9C362.8 472.7 311.3 480 256 480s-106.8-7.3-148.6-19.9C77.1 451 51.1 439 32.3 424.2C13.6 409.6 0 390.6 0 368V208C0 128 114.6 96 256 96c42.7 0 82.9 2.9 118.3 9.2L487.5 34.4c7.5-4.7 17.4-2.4 22 5.1zM332 131.6c-23.5-2.4-49-3.6-76-3.6c-69 0-128.5 7.9-169.4 23.8C45.3 167.9 32 187.6 32 208c0 11.2 11.3 31.5 55.7 50.6C129 276.5 188.5 288 256 288s127-11.5 168.3-29.4C468.7 239.5 480 219.2 480 208c0-20.4-13.3-40.1-54.6-56.2c-13.1-5.1-28.2-9.4-44.8-12.8L248.5 221.6c-7.5 4.7-17.4 2.4-22-5.1s-2.4-17.4 5.1-22L332 131.6zM480 263.2c-16.2 12.8-38.1 24-64 32.9l0 126.4c18.3-7 33.2-15 44-23.5c14.8-11.5 20-22.2 20-31V263.2zm-96 42.3c-33.3 8.2-71.4 13.3-112 14.3v128c41.5-1.1 79.7-6.6 112-15.1l0-127.2zM240 319.8c-40.6-1.1-78.7-6.1-112-14.3V432.7c32.3 8.5 70.5 14 112 15.1v-128zM96 296.1c-25.9-8.9-47.8-20.1-64-32.9V368c0 8.8 5.3 19.5 20 31c10.8 8.5 25.6 16.5 44 23.5V296.1z"]
};
var faScrubber = {
  prefix: 'fal',
  iconName: 'scrubber',
  icon: [512, 512, [], "f2f8", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faIceCream = {
  prefix: 'fal',
  iconName: 'ice-cream',
  icon: [448, 512, [127848], "f810", "M224 0C139.7 0 70.6 65.2 64.4 147.9C36.2 157.7 16 184.5 16 216c0 39.8 32.2 72 72 72h45.5 181H360c39.8 0 72-32.2 72-72c0-31.5-20.2-58.3-48.4-68.1C377.4 65.2 308.3 0 224 0zM96 160v0C96 89.3 153.3 32 224 32s128 57.3 128 128l0 .5c0 8 5.8 14.7 13.7 15.9c19.4 2.8 34.3 19.5 34.3 39.6c0 22.1-17.9 40-40 40H314.5h-181H88c-22.1 0-40-17.9-40-40c0-20.1 14.9-36.8 34.3-39.6c7.9-1.1 13.8-7.9 13.7-15.9l0-.5zM200.1 498.1c4.9 8.6 14 13.9 23.9 13.9s19-5.3 23.9-13.9L349.7 320H312.9L224 475.5 135.1 320H98.3L200.1 498.1z"]
};
var faHeartCircleBolt = {
  prefix: 'fal',
  iconName: 'heart-circle-bolt',
  icon: [576, 512, [], "e4fc", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm191.9-81c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
var faFishBones = {
  prefix: 'fal',
  iconName: 'fish-bones',
  icon: [576, 512, [], "e304", "M42.4 141.5l27.3 22.8c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5L44.8 101.8C40.3 98.1 34.6 96 28.7 96c-17.1 0-29.3 16.7-24 33L46 256 4.7 383c-5.3 16.3 6.8 33 24 33c5.9 0 11.6-2.1 16.1-5.8L34.6 397.9l10.2 12.3 45.4-37.9c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2L42.4 370.5l32-98.5H144v80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h48V392.9c0 11.3 11.4 19 21.4 13.8c20.1-10.3 38.2-22.9 54-36.3c39.1-33 66.9-72.4 81-99.8c4.7-9.2 4.7-20.1 0-29.3c-14.1-27.4-41.9-66.8-81-99.8c-15.8-13.4-33.9-26-54-36.3c-10.1-5.1-21.4 2.5-21.4 13.8V240H368V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H176V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H74.5l-32-98.5zM447.7 259.2c.2-1 .3-2.1 .3-3.2s-.1-2.2-.3-3.2V148.1c8.2 5.6 16 11.5 23.4 17.7c35.6 30 60.9 66.1 73.2 90.1c0 .1 0 .2 0 .3c-12.4 24-37.7 60.1-73.2 90.1c-7.3 6.2-15.1 12.1-23.4 17.7V259.2z"]
};
var faDeerRudolph = {
  prefix: 'fal',
  iconName: 'deer-rudolph',
  icon: [576, 512, [], "f78f", "M240 0c8.8 0 16 7.2 16 16V40c0 13.3 10.7 24 24 24h8 8c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16V40c0 8.6-1.9 16.7-5.4 24h38.8H416c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16V40c0 22-12.7 41.1-31.2 50.2l35 35C483.1 108 500.2 96 520 96c26.5 0 48 21.5 48 48s-21.5 48-48 48c-2.9 0-5.7-.3-8.4-.7c-3.4 27.5-26.8 48.7-55.2 48.7H403.9l-18.6 61.8c-.9 3-1.4 6.1-1.4 9.2V472c0 22.1-17.9 40-40 40H312c-22.1 0-40-17.9-40-40V368H257.2c-24.1 0-47.7-5.7-69-16.6c-.9 17.8-10.1 34.4-25.3 44.6c-9.3 6.2-13.4 17.9-9.8 28.6l11.6 34.8c8.6 25.9-10.6 52.6-37.9 52.6H97.3c-17.2 0-32.5-11-37.9-27.4L37.9 420.2c-4.4-13.1-4.4-27.3 0-40.5l8.5-25.4c1.1-3.3 1.6-6.7 1.6-10.1v-4.3c0-8.5-3.4-16.6-9.4-22.6l-3.9-3.9c-.7-.7-1.5-1.5-2.2-2.3L32 321c-.6 8.8-8.1 15.5-17 15s-15.5-8.1-15-17l3.3-53c3.2-50.6 45.1-90 95.8-90H104h16H300.7l10-35.9-13.8 9.2c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l40-26.7H296h-8-8c-30.9 0-56-25.1-56-56V16c0-8.8 7.2-16 16-16zM348.3 124.2l-20 72.1c-1.9 6.9-8.2 11.7-15.4 11.7H120 104c-30.9 0-56 25.1-56 56v4.1c0 8.5 3.4 16.6 9.4 22.6l3.9 3.9c12 12 18.7 28.3 18.7 45.3v4.3c0 6.9-1.1 13.7-3.3 20.2l-8.5 25.4c-2.2 6.6-2.2 13.7 0 20.2l21.5 64.4c1.1 3.3 4.1 5.5 7.6 5.5h29.4c5.5 0 9.3-5.4 7.6-10.5l-11.6-34.8c-8.1-24.3 1.1-51.1 22.4-65.3c8.2-5.4 12.4-15.1 10.8-24.8l-3.7-21.9c-1-6.3 1.7-12.6 7.1-16.1s12.3-3.4 17.6 .1l13.7 9.2C210.3 329 233.5 336 257.2 336H288c8.8 0 16 7.2 16 16V472c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V311c0-6.2 .9-12.4 2.7-18.4l22-73.3c2-6.8 8.3-11.4 15.3-11.4h64.4c13 0 23.6-10.6 23.6-23.6c0-6.3-2.5-12.3-6.9-16.7l-60.4-60.4c-7.2-7.2-17-11.3-27.2-11.3c-17.3 0-32.5 11.5-37.1 28.2zM400 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm136 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faFax = {
  prefix: 'fal',
  iconName: 'fax',
  icon: [512, 512, [128224, 128439], "f1ac", "M160 64c0-17.7 14.3-32 32-32H388.1c8.5 0 16.6 3.4 22.6 9.4l27.9 27.9c6 6 9.4 14.1 9.4 22.6V160h32V91.9c0-17-6.7-33.3-18.7-45.3L433.4 18.7C421.4 6.7 405.1 0 388.1 0H192c-35.3 0-64 28.7-64 64v72.6c-9.4-5.4-20.3-8.6-32-8.6H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H96c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7H448c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H160V64zm0 160H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V224zm-32-32v16V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32zM296 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faParagraph = {
  prefix: 'fal',
  iconName: 'paragraph',
  icon: [448, 512, [182], "f1dd", "M32 192c0-88.4 71.6-160 160-160h64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H384l0 400c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-400H288V464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112H192c-88.4 0-160-71.6-160-160zM256 320V64H192C121.3 64 64 121.3 64 192s57.3 128 128 128h64z"]
};
var faHeadSideHeart = {
  prefix: 'fal',
  iconName: 'head-side-heart',
  icon: [512, 512, [], "e1aa", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm112-34.7c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L224 281.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM173.3 128c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faSquareE = {
  prefix: 'fal',
  iconName: 'square-e',
  icon: [448, 512, [], "e26d", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 32H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v80H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v80H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-17.7 0-32-14.3-32-32V256 160c0-17.7 14.3-32 32-32z"]
};
var faMeterFire = {
  prefix: 'fal',
  iconName: 'meter-fire',
  icon: [640, 512, [], "e1eb", "M256 32c76.2 0 143.5 38 183.9 96.1c12.4-1 25.2 3 35 11.9c5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33.6 0 65.7-6.5 95.1-18.3c-8.5-7.8-16.3-16.3-23.2-25.5C305.3 475.9 281.1 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32zM368 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 4.4 1.8 8.5 4.7 11.4c8.3-11.6 17.4-23.1 27.3-34.4V144zm-192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM509.4 253.5c9.6-.1 18.7-4.5 24.7-12.1c3.9-4.9 7.8-9.6 11.6-14c16.4 17.8 30.9 39.4 41.8 60.5C601 314 608 339.4 608 352.2C608 422.4 551 480 480 480c-71.8 0-128-57.5-128-127.8c0-17.9 9.4-46.2 27.6-75.8c15.9-25.8 37.9-53.1 64-78.1c14.3 13.7 27.9 28.3 40.8 43.7c6.2 7.4 15.3 11.6 25 11.5zm-21.8-56.4c-10.9-11.6-22.2-22.8-34-33.4c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-1.8 1.6-3.5 3.3-5.2 5c-7.7 7.7-14.8 16.4-21.2 24.5c-7-8.4-14.1-16.5-21.5-24.4zM445.1 256c-4.8 0-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C389 324.3 384 338.3 384 354c0 28.7 10.7 52.6 28.8 69.2c18 16.5 42.3 24.8 68.2 24.8c21.3 0 40.3-6 57.9-17.7l0 0 .3-.2c37.3-26.1 46.3-77.2 25-116.5l0-.1c-1.9-3.9-4.5-9-8.3-14.1c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5c-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5C508.6 412 495.7 416 481 416c-19.1 0-35.3-6.1-46.6-16.4C423.3 389.4 416 374.3 416 354c0-8.3 2.5-16.8 9.1-28.1c4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.4 1.8 2.4 .5 .6 .1 .2 0 0 0 0 0 0L507 351l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"]
};
var faCloudHail = {
  prefix: 'fal',
  iconName: 'cloud-hail',
  icon: [512, 512, [], "f739", "M176 32c-44.2 0-80 35.8-80 80c0 5.4 .5 10.6 1.5 15.7c1.7 8.3-3.5 16.5-11.7 18.6c-31 8-53.9 36.2-53.9 69.7c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72s-32.2-72-72-72c-2.2 0-4.4 .1-6.6 .3c-4.5 .4-8.9-1.1-12.2-4.1s-5.2-7.3-5.2-11.8l0-.3c0-35.3-28.7-64-64-64c-17.8 0-33.9 7.2-45.5 19c-3.7 3.7-9 5.4-14.1 4.5s-9.6-4.3-11.8-9C235.9 51 208.2 32 176 32zm238.7 80.2C469 115.7 512 160.8 512 216c0 57.4-46.6 104-104 104H104C46.6 320 0 273.4 0 216c0-43.4 26.6-80.5 64.3-96.1c-.2-2.6-.3-5.2-.3-7.9C64 50.1 114.1 0 176 0c37.9 0 71.3 18.8 91.6 47.5C282.7 37.7 300.7 32 320 32c47.6 0 87.2 34.7 94.7 80.2zM96 392a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCheckToSlot = {
  prefix: 'fal',
  iconName: 'check-to-slot',
  icon: [576, 512, ["vote-yea"], "f772", "M144 64c-8.8 0-16 7.2-16 16V384H448V80c0-8.8-7.2-16-16-16H144zM480 80V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480 448 128 96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16H96V80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48zM48 320H64v32H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H528c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H512V320h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zM379.3 174L272.6 280.6c-6.2 6.2-16.4 6.2-22.6 0l-53.3-53.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l42 42 95.4-95.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faVoteYea = faCheckToSlot;
var faMoneyFromBracket = {
  prefix: 'fal',
  iconName: 'money-from-bracket',
  icon: [640, 512, [], "e312", "M80 32C53.5 32 32 53.5 32 80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80C0 35.8 35.8 0 80 0H560c44.2 0 80 35.8 80 80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-26.5-21.5-48-48-48H80zM496 96c8.8 0 16 7.2 16 16l0 344c0 30.9-25.1 56-56 56H184c-30.9 0-56-25.1-56-56l0-344c0-8.8 7.2-16 16-16s16 7.2 16 16l0 272c53 0 96 43 96 96H384c0-53 43-96 96-96V112c0-8.8 7.2-16 16-16zM224 480c0-35.3-28.7-64-64-64l0 40c0 13.3 10.7 24 24 24h40zm232 0c13.3 0 24-10.7 24-24l0-40c-35.3 0-64 28.7-64 64h40zM320 208c-47 0-80 31.3-80 64s33 64 80 64s80-31.3 80-64s-33-64-80-64zm112 64c0 55.6-53 96-112 96s-112-40.4-112-96s53-96 112-96s112 40.4 112 96z"]
};
var faStarHalf = {
  prefix: 'fal',
  iconName: 'star-half',
  icon: [576, 512, [61731], "f089", "M226.5 168.8c-4.6 9.5-13.6 16.1-24.1 17.7L65 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L150.2 473.2l129.7-69.3V58.8l-53.4 110zM293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4V408.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9z"]
};
var faCarBus = {
  prefix: 'fal',
  iconName: 'car-bus',
  icon: [640, 512, [], "f85a", "M45.8 70.1C38.8 75.7 34.7 84.5 33 96H192 351c-1.7-11.5-5.9-20.3-12.9-25.9C316.2 52.8 271 32 192 32S67.8 52.8 45.8 70.1zM32 128v96H176V128H32zm0 128v96c0 17.7 14.3 32 32 32H224v32H64l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V407.4C12.9 396.4 0 375.7 0 352V110.2C0 88.9 4.5 62.1 26 45C54.8 22.2 107.5 0 192 0s137.2 22.2 166 45c21.5 17 26 43.9 26 65.2V144h-3.8c-9.8 0-19.2 1.5-28.2 4.2V128H208v96h76.9l-9.1 32H192 32zm72 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm276.2-80c-14.3 0-26.8 9.5-30.8 23.2L333.2 288c.9 0 1.9 0 2.8 0H560c.9 0 1.9 0 2.8 0l-16.2-56.8c-3.9-13.7-16.5-23.2-30.8-23.2H380.2zm-61.5 14.4c7.8-27.5 33-46.4 61.5-46.4H515.8c28.6 0 53.7 18.9 61.5 46.4L599 298.1c24.5 13.7 41 39.9 41 69.9v48 16 32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16V464H288v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V464 432 416 368c0-30 16.6-56.2 41-69.9l21.6-75.7zM608 416V368c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v48 16H608V416zM336 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSpeaker = {
  prefix: 'fal',
  iconName: 'speaker',
  icon: [384, 512, [], "f8df", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM272 336a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM80 336a112 112 0 1 1 224 0A112 112 0 1 1 80 336zm88 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56-208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faTimer = {
  prefix: 'fal',
  iconName: 'timer',
  icon: [512, 512, [], "e29e", "M256 0c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V32.6C388.2 40.8 480 137.7 480 256c0 123.7-100.3 224-224 224S32 379.7 32 256c0-46.6 14.2-89.9 38.6-125.8c5-7.3 3.1-17.3-4.2-22.2s-17.3-3.1-22.2 4.2C16.3 153.2 0 202.7 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM171.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96z"]
};
var faBoxesStacked = {
  prefix: 'fal',
  iconName: 'boxes-stacked',
  icon: [576, 512, [62625, "boxes", "boxes-alt"], "f468", "M384 32c17.7 0 32 14.3 32 32V192h32V64c0-35.3-28.7-64-64-64H320 256 192c-35.3 0-64 28.7-64 64V192h32V64c0-17.7 14.3-32 32-32h32V88c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V32h32zM256 32h64V88c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8V32zm71.6 480H512c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H448 384 327.6c8.3 9.2 14.8 20.1 19 32H352v31.9 .1 24c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V256h32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H346.5c-4.2 11.9-10.7 22.8-19 32zM384 256h64v56c0 4.4-3.6 8-8 8H392c-4.4 0-8-3.6-8-8V256zm-128 0c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32H96v56c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V256h32zM128 312V256h64v56c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8zm128-88H224 192 128 96 64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64z"]
};
var faBoxes = faBoxesStacked;
var faBoxesAlt = faBoxesStacked;
var faGrillHot = {
  prefix: 'fal',
  iconName: 'grill-hot',
  icon: [448, 512, [], "e5a5", "M112 0c-8.8 0-16 7.2-16 16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4c0 8.8 7.2 16 16 16s16-7.2 16-16v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2V16c0-8.8-7.2-16-16-16zM256 352H192c-88.4 0-160-71.6-160-160H416c0 88.4-71.6 160-160 160zM32 160c-17.7 0-32 14.3-32 32c0 80.5 49.5 149.4 119.7 177.9l-7.4 16.2c-5.2-1.4-10.7-2.1-16.4-2.1c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48H335.9l17.6 38.6c3.7 8 13.1 11.6 21.2 7.9s11.6-13.1 7.9-21.2L328.3 369.9C398.5 341.4 448 272.5 448 192c0-17.7-14.3-32-32-32H32zM140.4 401.9l10.2-22.4c13.4 2.9 27.2 4.5 41.5 4.5h64c14.2 0 28.1-1.5 41.5-4.5L321.3 432H158c-3-11.7-9.2-22-17.6-30.1zM64 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4c0 8.8 7.2 16 16 16s16-7.2 16-16v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2V16z"]
};
var faBallotCheck = {
  prefix: 'fal',
  iconName: 'ballot-check',
  icon: [448, 512, [], "f733", "M384 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 128c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm32 128c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM160 384c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM88 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H88zM72 376v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V376c0-8.8-7.2-16-16-16H88c-8.8 0-16 7.2-16 16zm91.3-132.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L104 257.4 91.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48z"]
};
var faLink = {
  prefix: 'fal',
  iconName: 'link',
  icon: [640, 512, [128279, "chain"], "f0c1", "M591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0c-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6l-5.3 6.1c-43.9 50.7-41.2 126.7 6.2 174.1c49.9 49.9 130.9 49.9 180.8 0L591.5 256zM48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L195.7 154.1c37.4-37.4 98.1-37.4 135.6 0c35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6l5.3-6.1c43.9-50.7 41.2-126.7-6.2-174.1C303.9 81.5 223 81.5 173 131.4L48.5 256z"]
};
var faChain = faLink;
var faEarListen = {
  prefix: 'fal',
  iconName: 'ear-listen',
  icon: [512, 512, ["assistive-listening-systems"], "f2a2", "M350 8.2c-4.3 7.7-1.5 17.5 6.2 21.8C430.1 71 480 149.7 480 240c0 8.8 7.2 16 16 16s16-7.2 16-16C512 137.6 455.4 48.4 371.8 2C364.1-2.3 354.3 .5 350 8.2zM96 240c0-79.5 64.5-144 144-144s144 64.5 144 144c0 41.9-17.9 79.7-46.5 106c-10.1 9.2-17.5 22.6-17.5 38c0 53-43 96-96 96H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c70.7 0 128-57.3 128-128c0-4.8 2.4-10 7.1-14.4C394.1 337.4 416 291.3 416 240c0-97.2-78.8-176-176-176S64 142.8 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16zm64 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM52.7 372.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM160 240c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faAssistiveListeningSystems = faEarListen;
var faFileMinus = {
  prefix: 'fal',
  iconName: 'file-minus',
  icon: [384, 512, [], "f318", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM96 320c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"]
};
var faTreeCity = {
  prefix: 'fal',
  iconName: 'tree-city',
  icon: [640, 512, [], "e587", "M336 32c-8.8 0-16 7.2-16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V192h32V112c0-8.8 7.2-16 16-16s16 7.2 16 16v80h16c26.5 0 48 21.5 48 48V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8-7.2-16-16-16H560 496c-8.8 0-16-7.2-16-16V48c0-8.8-7.2-16-16-16H336zm48 32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm0 32v32h32V96H384zm96 192c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H512c-17.7 0-32-14.3-32-32V288zm64 0H512v32h32V288zm-32 96h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H512c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm0 32v32h32V416H512zM352 224c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V224zm64 0H384v32h32V224zm-32 96h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32zm0 32v32h32V352H384zM128 224c8.8 0 16 7.2 16 16v48h32c26.5 0 48-21.5 48-48c0-16-7.8-30.2-19.9-38.9l-8-5.8c-4.9-3.5-7.4-9.5-6.4-15.5l.4-2.6c1.1-6.7 1.9-11.9 1.9-17.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.3 .8 10.5 1.9 17.2l.4 2.6c.9 6-1.5 11.9-6.4 15.5l-8 5.8C39.8 209.8 32 224 32 240c0 26.5 21.5 48 48 48h32V240c0-8.8 7.2-16 16-16zm-16 96H80c-44.2 0-80-35.8-80-80c0-26.7 13.1-50.3 33.2-64.9l0 0c-.7-4.7-1.2-9.9-1.2-15.1c0-53 43-96 96-96s96 43 96 96c0 5.2-.5 10.4-1.2 15.1l0 0C242.9 189.7 256 213.3 256 240c0 44.2-35.8 80-80 80H144V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V320z"]
};
var faPlay = {
  prefix: 'fal',
  iconName: 'play',
  icon: [384, 512, [9654], "f04b", "M56.3 66.3c-4.9-3-11.1-3.1-16.2-.3s-8.2 8.2-8.2 14V432c0 5.8 3.1 11.1 8.2 14s11.2 2.7 16.2-.3l288-176c4.8-2.9 7.7-8.1 7.7-13.7s-2.9-10.7-7.7-13.7l-288-176zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432V80C0 62.6 9.4 46.6 24.5 38.1z"]
};
var faFont = {
  prefix: 'fal',
  iconName: 'font',
  icon: [448, 512, [], "f031", "M238.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8L37.4 448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H96c8.8 0 16-7.2 16-16s-7.2-16-16-16H72.1l40.6-96H335.2l40.6 96H352c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H410.6L238.7 41.8zm83 278.2H126.3L224 89.1 321.7 320z"]
};
var faCupTogo = {
  prefix: 'fal',
  iconName: 'cup-togo',
  icon: [448, 512, ["coffee-togo"], "f6c5", "M87.9 42.9L70.2 96H377.8L360.1 42.9c-2.2-6.5-8.3-10.9-15.2-10.9H103.1c-6.9 0-13 4.4-15.2 10.9zM47.6 128H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H36.5L57.5 32.8C64.1 13.2 82.4 0 103.1 0H344.9c20.7 0 39 13.2 45.5 32.8L411.5 96H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H400.4c-.2 0-.5 0-.7 0H48.4c-.2 0-.5 0-.7 0zm27 325.9L47.4 160H79.5l5.9 64H362.5l5.9-64h32.1L373.4 453.9c-3 32.9-30.7 58.1-63.7 58.1H138.3c-33.1 0-60.7-25.2-63.7-58.1zM359.6 256H88.4l11.9 128H347.7l11.9-128zM344.8 416H103.2l3.2 35c1.5 16.5 15.3 29 31.9 29H309.7c16.5 0 30.3-12.6 31.9-29l3.2-35z"]
};
var faCoffeeTogo = faCupTogo;
var faSquareDownLeft = {
  prefix: 'fal',
  iconName: 'square-down-left',
  icon: [448, 512, [], "e26b", "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm144-88V214.6c0-3.7 3-6.6 6.6-6.6c1.8 0 3.4 .7 4.7 1.9l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0l59.1-59.1c3.6-3.6 9-4.9 13.9-3.3c2 .7 3.8 1.8 5.3 3.3l22.1 22.1c1.5 1.5 2.6 3.3 3.3 5.3c1.6 4.9 .4 10.3-3.3 13.9l-59.1 59.1c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c1.2 1.2 1.9 2.9 1.9 4.7c0 3.7-3 6.6-6.6 6.6H152c-4.4 0-8-3.6-8-8zm8 40H265.4c21.3 0 38.6-17.3 38.6-38.6c0-10.2-4.1-20.1-11.3-27.3L278.6 288l47.7-47.7c12.2-12.2 16.5-30.3 11-46.7c-2.2-6.7-6-12.8-11-17.8l-22.1-22.1c-5-5-11.1-8.8-17.8-11c-16.4-5.5-34.5-1.2-46.7 11L192 201.4l-14.1-14.1c-7.2-7.2-17.1-11.3-27.3-11.3c-21.3 0-38.6 17.3-38.6 38.6V328c0 22.1 17.9 40 40 40z"]
};
var faBurgerLettuce = {
  prefix: 'fal',
  iconName: 'burger-lettuce',
  icon: [512, 512, [], "e3e3", "M256 64c94.4 0 172.9 68.1 189 157.8l0 .1c0 .1-.1 .2-.3 .3c-.7 .8-2.4 1.7-4.7 1.7H72c-2.4 0-4-1-4.7-1.7c-.1-.1-.2-.2-.3-.3l0-.1C83.1 132.1 161.6 64 256 64zM35.5 216.2C31.6 237.9 49.9 256 72 256H440c22.1 0 40.4-18.1 36.5-39.8C457.7 111.5 366.1 32 256 32S54.3 111.5 35.5 216.2zM128 448c-35.3 0-64-28.7-64-64H448c0 35.3-28.7 64-64 64H128zM32 384c0 53 43 96 96 96H384c53 0 96-43 96-96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zM176 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 334.4c19.6 0 35.2-9.4 47.6-16.8l2.1-1.3c13.5-8.1 24.4-14 38.3-14c13.5 0 22.2 5.5 34.9 13.7c12.7 8.2 28.6 18.3 53.1 18.3c24.4 0 39.5-10.1 51.6-18.1l.4-.3c11.8-7.9 20.7-13.6 36-13.6c15.7 0 26.7 6 39.5 13.9l2.6 1.6c11.7 7.3 26.6 16.5 45.9 16.5c18.5 0 32.7-4.6 42.4-9.5c4.9-2.4 8.6-4.9 11.2-6.9c1.3-1 2.3-1.8 3.1-2.5c.4-.3 .7-.6 .9-.8l.3-.3 .1-.1 .1 0 0 0 0 0s0 0-10.2-10.2l10.2 10.2c5.6-5.6 5.6-14.7 0-20.4c-5.6-5.6-14.6-5.6-20.2-.1l-.2 .2c-.2 .2-.7 .6-1.4 1.1c-1.4 1-3.7 2.6-6.8 4.1c-6.2 3.1-16 6.5-29.6 6.5c-10.9 0-19.2-5.1-32.6-13.4l-.8-.5c-13.3-8.2-30.3-18.1-54.5-18.1c-24.4 0-39.5 10.1-51.6 18.1l-.4 .3c-11.8 7.9-20.7 13.6-36 13.6c-15.5 0-25.3-5.9-37.5-13.7l-1.4-.9c-11.9-7.7-26.9-17.4-49.1-17.4c-22.7 0-39.8 10.1-53.1 18c-14.2 8.5-23.6 14-34.9 14c-13.5 0-23.3-3.4-29.6-6.5c-3.1-1.6-5.4-3.1-6.8-4.1c-.7-.5-1.2-.9-1.4-1.1l-.2-.2c-5.6-5.5-14.7-5.4-20.2 .1c-5.6 5.6-5.6 14.7 0 20.4L32 304c-10.2 10.2-10.2 10.2-10.2 10.2l0 0 0 0 0 0 .1 .1 .3 .3c.2 .2 .6 .5 .9 .8c.8 .7 1.8 1.5 3.1 2.5c2.6 2 6.3 4.4 11.2 6.9c9.8 4.9 24 9.5 42.4 9.5z"]
};
var faRupiahSign = {
  prefix: 'fal',
  iconName: 'rupiah-sign',
  icon: [512, 512, [], "e23d", "M0 80C0 53.5 21.5 32 48 32h64c79.5 0 144 64.5 144 144c0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3L119.9 319.8c-2.6 .1-5.3 .2-7.9 .2H32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 80zM32 288h80c61.9 0 112-50.1 112-112s-50.1-112-112-112H48c-8.8 0-16 7.2-16 16V288zm288-80V352h80c44.2 0 80-35.8 80-80s-35.8-80-80-80H336c-8.8 0-16 7.2-16 16zm16-48h64c61.9 0 112 50.1 112 112s-50.1 112-112 112H320V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-26.5 21.5-48 48-48z"]
};
var faMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'magnifying-glass',
  icon: [512, 512, [128269, "search"], "f002", "M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"]
};
var faSearch = faMagnifyingGlass;
var faTableTennisPaddleBall = {
  prefix: 'fal',
  iconName: 'table-tennis-paddle-ball',
  icon: [512, 512, [127955, "ping-pong-paddle-ball", "table-tennis"], "f45d", "M423.8 88.2c56.7 56.7 70.5 139.9 41.5 209.6c10 4.2 19.4 9.6 27.9 16.1c35.9-82 20.3-181.2-46.8-248.3c-87.5-87.5-229.3-87.5-316.8 0L69.5 125.7c-24 24-37.5 56.6-37.5 90.5V219c0 33.9 13.5 66.5 37.5 90.5l9.8 9.8c13.1 13.1 12.4 34.6-1.7 46.8L11 423.8C4.3 429.6 .3 438 0 446.9s3.1 17.5 9.4 23.8l32 32c6.3 6.3 14.9 9.7 23.8 9.4s17.2-4.3 23-11l57.7-66.6c12.2-14 33.7-14.8 46.8-1.7l9.8 9.8c24 24 56.6 37.5 90.5 37.5h2.7c3.1 0 6.1-.1 9.2-.3c-5.6-9.8-10-20.4-12.9-31.7c-25.1-.3-49.1-10.3-66.9-28.1l-9.8-9.8c-26.3-26.3-69.3-24.7-93.6 3.3L64 480 32 448l66.6-57.7c28.1-24.3 29.6-67.4 3.3-93.6l-9.8-9.8C74.1 268.9 64 244.4 64 219v-2.7c0-18.2 5.2-35.8 14.6-51L293.2 379.8c3.3-11.1 8-21.6 14-31.3L99.5 140.9l52.7-52.7c75-75 196.5-75 271.5 0zM352 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faPingPongPaddleBall = faTableTennisPaddleBall;
var faTableTennis = faTableTennisPaddleBall;
var faPersonDotsFromLine = {
  prefix: 'fal',
  iconName: 'person-dots-from-line',
  icon: [576, 512, ["diagnoses"], "f470", "M344 88A56 56 0 1 0 232 88a56 56 0 1 0 112 0zM200 88a88 88 0 1 1 176 0A88 88 0 1 1 200 88zM80 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 256V256.6c-21.4 6.5-40.2 14.2-56.3 21.9c-20 9.6-35.5 19.2-45.9 26.3c-5.2 3.6-9.2 6.5-11.7 8.5c-1.3 1-2.2 1.8-2.9 2.3l-.6 .5-.1 .1 0 0 0 0c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6L48 304c-10.4-12.1-10.4-12.1-10.4-12.1l0 0 0 0 .1-.1 .3-.2 1-.8c.8-.7 2-1.6 3.5-2.8c3.1-2.4 7.5-5.7 13.3-9.6c11.6-7.9 28.5-18.3 50.1-28.7C149.1 228.8 211.5 208 288 208s138.9 20.8 182.1 41.6c21.6 10.4 38.5 20.8 50.1 28.7c5.8 3.9 10.2 7.3 13.3 9.6c1.5 1.2 2.7 2.1 3.5 2.8l1 .8 .3 .2 .1 .1 0 0 0 0s0 0-10.4 12.1l10.4-12.1c6.7 5.8 7.4 15.9 1.7 22.6s-15.9 7.4-22.5 1.7l0 0 0 0 0 0 0 0-.1-.1-.6-.5c-.6-.5-1.6-1.3-2.9-2.3c-2.6-2-6.5-4.9-11.7-8.5c-10.4-7.1-25.9-16.7-45.9-26.3c-16-7.7-34.9-15.4-56.3-21.9V448H368V248.4c-24.3-5.1-51-8.4-80-8.4s-55.7 3.2-80 8.4V448H176zM0 496c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM304 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM464 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faDiagnoses = faPersonDotsFromLine;
var faChevronsDown = {
  prefix: 'fal',
  iconName: 'chevrons-down',
  icon: [512, 512, ["chevron-double-down"], "f322", "M52.7 75.3l192 192c6.2 6.2 16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4 75.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zm0 192l192 192c6.2 6.2 16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 425.4 75.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"]
};
var faChevronDoubleDown = faChevronsDown;
var faTrashCanArrowUp = {
  prefix: 'fal',
  iconName: 'trash-can-arrow-up',
  icon: [448, 512, ["trash-restore-alt"], "f82a", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zm160 80c4.2 0 8.3 1.7 11.3 4.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 230.6V392c0 8.8-7.2 16-16 16s-16-7.2-16-16V230.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7z"]
};
var faTrashRestoreAlt = faTrashCanArrowUp;
var faSignalGood = {
  prefix: 'fal',
  iconName: 'signal-good',
  icon: [640, 512, ["signal-3"], "f68e", "M336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM192 288c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400c0-8.8-7.2-16-16-16z"]
};
var faSignal3 = faSignalGood;
var faLocationQuestion = {
  prefix: 'fal',
  iconName: 'location-question',
  icon: [384, 512, ["map-marker-question"], "f60b", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM104.7 137.8c6.5-24.6 28.7-41.8 54.2-41.8H216c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L208 236.3V256c0 8.8-7.2 16-16 16s-16-7.2-16-16V226.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H158.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM168 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faMapMarkerQuestion = faLocationQuestion;
var faFloppyDiskCircleXmark = {
  prefix: 'fal',
  iconName: 'floppy-disk-circle-xmark',
  icon: [576, 512, ["floppy-disk-times", "save-circle-xmark", "save-times"], "e181", "M32 96V416c0 17.7 14.3 32 32 32H275.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V170.5c0-8.5-3.4-16.6-9.4-22.6L332.1 73.4c-3.4-3.4-7.6-6-12.1-7.6V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64C46.3 64 32 78.3 32 96zM224 240c25.1 0 47.4 11.5 62.1 29.5c-6.9 10.2-12.8 21.2-17.4 32.8c-7-17.8-24.4-30.4-44.7-30.4c-26.5 0-48 21.5-48 48s21.5 48 48 48c12.5 0 23.9-4.8 32.4-12.6c-.3 4.2-.4 8.4-.4 12.6c0 8.3 .6 16.5 1.7 24.6C247.5 397.3 236 400 224 400c-44.2 0-80-35.8-80-80s35.8-80 80-80zM96 64v96H288V64H96zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 368z"]
};
var faFloppyDiskTimes = faFloppyDiskCircleXmark;
var faSaveCircleXmark = faFloppyDiskCircleXmark;
var faSaveTimes = faFloppyDiskCircleXmark;
var faNairaSign = {
  prefix: 'fal',
  iconName: 'naira-sign',
  icon: [448, 512, [], "e1f6", "M93.2 38.9c-4-5.8-11.2-8.3-17.9-6.2S64 41 64 48V256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64V464c0 8.8 7.2 16 16 16s16-7.2 16-16V288H226.7L354.8 473.1c4 5.8 11.2 8.3 17.9 6.2s11.2-8.3 11.2-15.3V288h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V256H243.5L93.2 38.9zM265.6 288H352V412.8L265.6 288zm-61.1-32H96V99.2L204.5 256z"]
};
var faPeach = {
  prefix: 'fal',
  iconName: 'peach',
  icon: [512, 512, [], "e20b", "M128 0C101.5 0 80 21.5 80 48c0 17 3.8 33.1 10.6 47.5c9.9-4.1 20.1-7.5 30.7-10.1C115.4 74.3 112 61.5 112 48c0-8.8 7.2-16 16-16h32c37.2 0 68.5 25.4 77.4 59.9c12.1 2.8 25 2.8 37.1 0C283.5 57.4 314.8 32 352 32h32c8.8 0 16 7.2 16 16c0 13.5-3.4 26.3-9.3 37.5c10.6 2.5 20.9 5.9 30.7 10.1C428.2 81.1 432 65 432 48c0-26.5-21.5-48-48-48H352c-40.7 0-76.4 21.8-96 54.3C236.4 21.8 200.7 0 160 0H128zm40 144c69.7 0 127.2 52.4 135.1 120c1 8.8 8.1 16 16.9 16s16.1-7.2 15.2-16c-4-42.8-24.1-80.9-54.1-108.2c6.9-1.2 13.8-2.9 20.5-5.1c13.3-4.4 27.5-6.7 42.4-6.7c75.1 0 136 60.9 136 136c0 51.7-38.2 97-91.1 134c-51.5 36.1-108.6 58.2-128.2 65.3c-1.1 .4-2.6 .7-4.7 .7s-3.5-.3-4.7-.7c-19.6-7-76.7-29.2-128.2-65.3C70.2 377 32 331.7 32 280c0-75.1 60.9-136 136-136zm123.7-23.7c-23 7.5-48.4 7.5-71.4 0c-16.5-5.4-34-8.3-52.3-8.3C75.2 112 0 187.2 0 280C0 416.2 199.3 494.6 240.6 509.4c5 1.8 10.1 2.6 15.4 2.6s10.4-.8 15.4-2.6C312.7 494.6 512 416.2 512 280c0-92.8-75.2-168-168-168c-18.3 0-35.9 2.9-52.3 8.3z"]
};
var faTaxiBus = {
  prefix: 'fal',
  iconName: 'taxi-bus',
  icon: [640, 512, [], "e298", "M192 32c79 0 124.2 20.8 146.2 38.1c7 5.5 11.1 14.4 12.9 25.9H192 33c1.7-11.5 5.9-20.3 12.9-25.9C67.8 52.8 113 32 192 32zM32 224V128H176v96H32zm0 128V256H192h83.8l9.1-32H208V128H344.6c8.4-14.5 22.3-25.4 38.9-29.8C381.8 79.5 375.6 59 358 45C329.2 22.2 276.5 0 192 0S54.8 22.2 26 45C4.5 62.1 0 88.9 0 110.2V352c0 23.7 12.9 44.4 32 55.4V464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48H224V384H64c-17.7 0-32-14.3-32-32zm96-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM488 160c4.4 0 8 3.6 8 8v8H400v-8c0-4.4 3.6-8 8-8h80zm-120 8v9.2c-23.3 4.5-42.6 21.8-49.3 45.2L297 298.1c-24.5 13.7-41 39.9-41 69.9v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H608v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-6.7-23.5-26-40.7-49.3-45.2V168c0-22.1-17.9-40-40-40H408c-22.1 0-40 17.9-40 40zm16 40H512h3.8c14.3 0 26.8 9.5 30.8 23.2L562.8 288c-.9 0-1.9 0-2.8 0H336c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2H384zM608 432H288V416 368c0-26.5 21.5-48 48-48H560c26.5 0 48 21.5 48 48v48 16zM360 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm200 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBracketCurly = {
  prefix: 'fal',
  iconName: 'bracket-curly',
  icon: [256, 512, ["bracket-curly-left"], "7b", "M64 112c0-44.2 35.8-80 80-80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-26.5 0-48 21.5-48 48v53.5c0 21.2-8.4 41.6-23.4 56.6L38.6 256l33.9 33.9c15 15 23.4 35.4 23.4 56.6V400c0 26.5 21.5 48 48 48h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-44.2 0-80-35.8-80-80V346.5c0-12.7-5.1-24.9-14.1-33.9L4.7 267.3c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l45.3-45.3c9-9 14.1-21.2 14.1-33.9V112z"]
};
var faBracketCurlyLeft = faBracketCurly;
var faLobster = {
  prefix: 'fal',
  iconName: 'lobster',
  icon: [512, 512, [129438], "e421", "M32 80c0-19.2 11.3-35.8 27.6-43.4L48.3 92.9c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6l16-80c.9-4.7-.3-9.6-3.3-13.3S84.8 0 80 0C35.8 0 0 35.8 0 80v48c0 35.3 28.7 64 64 64c6.2 0 12.2-.9 17.9-2.5l26.9 20.1c19.4 14.5 43 22.4 67.2 22.4v24H143.1c-7.5 0-14.8-1.7-21.5-5.1L87.2 233.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4H176v16H122.4c-5.2 0-10.3-.8-15.2-2.5L69.1 288.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1H176v16h-.9c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1h.9v0l18.5 51.7C169.7 444.6 152 468.2 152 496c0 8.8 7.2 16 16 16H344c8.8 0 16-7.2 16-16c0-27.8-17.7-51.4-42.5-60.3L336 384v0h.9c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4H336V336h53.6c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5H336V288h32.9c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1H336V232c24.2 0 47.8-7.9 67.2-22.4l26.9-20.1c5.7 1.7 11.7 2.5 17.9 2.5c35.3 0 64-28.7 64-64V80c0-44.2-35.8-80-80-80c-4.8 0-9.3 2.1-12.4 5.9s-4.3 8.6-3.3 13.3l16 80c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L452.4 36.6C468.7 44.2 480 60.8 480 80v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 16.7 6.4 31.9 16.9 43.3L384 184c-13.8 10.4-30.7 16-48 16c0-25.6-14.7-48.9-32-67.2V80.7c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7v25c-3.2-2.2-6.3-4.1-9-5.8c-4.3-2.6-9.7-2.6-14 0c-2.8 1.6-5.8 3.6-9 5.8v-25c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7v52.1c-17.3 18.3-32 41.6-32 67.2c-17.3 0-34.2-5.6-48-16l-16.9-12.7C121.6 159.9 128 144.7 128 128V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V80zM304 200v32 40 27.6c-1 .2-2.1 .4-3.3 .6c-9.9 1.8-24.9 3.7-44.7 3.7s-34.9-1.9-44.7-3.7c-1.2-.2-2.2-.4-3.3-.6V272 232 200v0c0-12.1 6.5-26.2 19.3-40.9c9-10.4 19.7-19.2 28.7-25.7c9.1 6.4 19.7 15.3 28.7 25.7C297.5 173.8 304 187.9 304 200v0zM208 332.2c11.6 2 27.7 3.8 48 3.8s36.4-1.8 48-3.8v15.4c-1 .2-2.1 .4-3.3 .6c-9.9 1.8-24.9 3.7-44.7 3.7s-34.9-1.9-44.7-3.7c-1.2-.2-2.2-.4-3.3-.6V332.2zM256 384c20 0 35.8-1.7 47.3-3.7l-5.5 15.5c-12.9 2.1-29.3 4.2-41.8 4.2s-28.9-2.1-41.8-4.2l-5.5-15.5c11.5 1.9 27.4 3.7 47.3 3.7zm-30.1 45.8c10 1.2 20.7 2.2 30.1 2.2s20.1-1 30.1-2.2c-2.9 15.2 5.7 30.7 20.7 36.1c7.2 2.6 13.2 7.6 17 14.2H188.3c3.8-6.5 9.7-11.6 17-14.2c15-5.4 23.6-20.8 20.7-36.1z"]
};
var faCartFlatbedEmpty = {
  prefix: 'fal',
  iconName: 'cart-flatbed-empty',
  icon: [640, 512, ["dolly-flatbed-empty"], "f476", "M0 16C0 7.2 7.2 0 16 0H80c26.5 0 48 21.5 48 48V368c0 8.8 7.2 16 16 16h80H512 624c8.8 0 16 7.2 16 16s-7.2 16-16 16H567.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H144c-26.5 0-48-21.5-48-48V48c0-8.8-7.2-16-16-16H16C7.2 32 0 24.8 0 16zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faDollyFlatbedEmpty = faCartFlatbedEmpty;
var faColon = {
  prefix: 'fal',
  iconName: 'colon',
  icon: [192, 512, [], "3a", "M128 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 128zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 384z"]
};
var faCartArrowDown = {
  prefix: 'fal',
  iconName: 'cart-arrow-down',
  icon: [576, 512, [], "f218", "M0 16C0 7.2 7.2 0 16 0H53.9c22.8 0 42.5 16 47 38.4L145.4 256H466.5c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM336 16l0 137.4 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L304 153.4 304 16c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faWand = {
  prefix: 'fal',
  iconName: 'wand',
  icon: [512, 512, [], "f72a", "M446.8 9.9C454 3.5 463.2 0 472.8 0C494.5 0 512 17.5 512 39.2v.5c0 9-3.1 17.8-8.7 24.8L448 133.6V160c0 17.7-14.3 32-32 32H391.1L119 494.4C108.9 505.6 94.5 512 79.4 512c-14.1 0-27.7-5.6-37.6-15.6L15.6 470.2C5.6 460.2 0 446.7 0 432.6c0-15.1 6.5-29.5 17.7-39.6L96 323.1V296c0-22.1 17.9-40 40-40h33.9L446.8 9.9zm26 22.1c-1.8 0-3.5 .6-4.8 1.8L186.6 284c-2.9 2.6-6.7 4-10.6 4H136c-4.4 0-8 3.6-8 8v34.3c0 4.6-1.9 8.9-5.3 11.9L39.1 416.9c-4.5 4-7.1 9.7-7.1 15.8c0 5.6 2.2 11 6.2 14.9l26.2 26.2c4 4 9.4 6.2 15 6.2c6 0 11.8-2.6 15.8-7L372.1 165.3c3-3.4 7.4-5.3 11.9-5.3h32V128c0-3.6 1.2-7.2 3.5-10l58.8-73.5c1.1-1.4 1.7-3.1 1.7-4.8v-.5c0-4-3.2-7.2-7.2-7.2z"]
};
var faWalkieTalkie = {
  prefix: 'fal',
  iconName: 'walkie-talkie',
  icon: [384, 512, [], "f8ef", "M96 16C96 7.2 88.8 0 80 0S64 7.2 64 16V96H56C25.1 96 0 121.1 0 152V302.1c0 10.6 4.2 20.8 11.7 28.3l17.9 17.9c1.5 1.5 2.3 3.5 2.3 5.7V456c0 30.9 25.1 56 56 56H296c30.9 0 56-25.1 56-56V353.9c0-2.1 .8-4.2 2.3-5.7l17.9-17.9c7.5-7.5 11.7-17.7 11.7-28.3V152c0-30.9-25.1-56-56-56H96V16zM80 128H328c13.3 0 24 10.7 24 24V302.1c0 2.1-.8 4.2-2.3 5.7l-17.9 17.9c-7.5 7.5-11.7 17.7-11.7 28.3V456c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V353.9c0-10.6-4.2-20.8-11.7-28.3L34.3 307.7c-1.5-1.5-2.3-3.5-2.3-5.7V152c0-13.3 10.7-24 24-24H80zm96-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zM96 192c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"]
};
var faFilePen = {
  prefix: 'fal',
  iconName: 'file-pen',
  icon: [576, 512, [128221, "file-edit"], "f31c", "M64 480H258.6l-1.1 4.5c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V285.7l-32 32V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zm167 104c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 39.9 39.9 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6L518.6 264zM342.4 417.5c-2.1 2.1-3.5 4.6-4.2 7.4L326 473.9l48.9-12.2c2.8-.7 5.4-2.2 7.4-4.2L488.5 351.3l-39.9-39.9L342.4 417.5zM473.3 241.4c18.7-18.7 49.1-18.7 67.9 0l17.3 17.3c18.7 18.7 18.7 49.1 0 67.9L405 480.1c-6.2 6.2-13.9 10.5-22.3 12.6l-74.8 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.8c2.1-8.4 6.5-16.2 12.6-22.3L473.3 241.4z"]
};
var faFileEdit = faFilePen;
var faReceipt = {
  prefix: 'fal',
  iconName: 'receipt',
  icon: [384, 512, [129534], "f543", "M26.5 4C21.8-.2 15.1-1.2 9.4 1.4S0 9.7 0 16V496c0 6.3 3.7 12 9.4 14.6s12.4 1.6 17.1-2.5l52.7-46.1 45.4 45.4c6.2 6.2 16.4 6.2 22.6 0L192 462.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0l45.4-45.4L357.5 508c4.7 4.1 11.4 5.1 17.1 2.5s9.4-8.3 9.4-14.6V16c0-6.3-3.7-12-9.4-14.6S362.2-.2 357.5 4L304.7 50.1 259.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L192 49.4 147.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L79.3 50.1 26.5 4zM32 460.7V51.3L69.5 84c6.3 5.5 15.9 5.2 21.8-.7L136 38.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0L248 38.6l44.7 44.7c6 6 15.5 6.3 21.8 .7L352 51.3V460.7L314.5 428c-6.3-5.5-15.9-5.2-21.8 .7L248 473.4l-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0L136 473.4 91.3 428.7c-6-6-15.5-6.3-21.8-.7L32 460.7zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"]
};
var faTablePicnic = {
  prefix: 'fal',
  iconName: 'table-picnic',
  icon: [512, 512, [], "e32d", "M191.6 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h88.2L115.8 224H16c-8.8 0-16 7.2-16 16s7.2 16 16 16l86.7 0h34.6H374.7h34.6l86.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H396.2L343.8 96H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H320.4c-.2 0-.5 0-.7 0H192.4c-.2 0-.5 0-.7 0zM309.3 96l52.4 128H150.4L202.7 96H309.3zM89.6 288L33.2 425.9c-3.3 8.2 .6 17.5 8.8 20.9s17.5-.6 20.9-8.8L124.2 288H89.6zm332.8 0H387.8l61.4 150.1c3.3 8.2 12.7 12.1 20.9 8.8s12.1-12.7 8.8-20.9L422.4 288z"]
};
var faSquarePen = {
  prefix: 'fal',
  iconName: 'square-pen',
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm299.5 67.3c-6.2-6.2-16.4-6.2-22.6 0l-21.4 21.4 40 40 21.4-21.4c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zm-149 126.4c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l82.3-82.3-40-40-82.3 82.3zm103.8-149c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L213.1 352.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L254.2 140.7z"]
};
var faPenSquare = faSquarePen;
var faPencilSquare = faSquarePen;
var faCircleMicrophoneLines = {
  prefix: 'fal',
  iconName: 'circle-microphone-lines',
  icon: [512, 512, ["microphone-circle-alt"], "e117", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-416c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64s64-28.7 64-64V240 176 160c0-35.3-28.7-64-64-64zm32 64H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 65.3 48.9 119.1 112 127v17c0 8.8 7.2 16 16 16s16-7.2 16-16V383c63.1-7.9 112-61.7 112-127V240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53-43 96-96 96s-96-43-96-96V240z"]
};
var faMicrophoneCircleAlt = faCircleMicrophoneLines;
var faDisplaySlash = {
  prefix: 'fal',
  iconName: 'display-slash',
  icon: [640, 512, ["desktop-slash"], "e2fa", "M32 110.3V352c0 35.3 28.7 64 64 64H245.1l-10.7 64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H392h72c8.8 0 16-7.2 16-16s-7.2-16-16-16H405.6l-10.7-64h24.3l-40.5-32h-2.4c-.2 0-.4 0-.6 0H264.3c-.2 0-.4 0-.6 0H96c-17.7 0-32-14.3-32-32V135.6L32 110.3zm562.5 281C603 380.5 608 366.8 608 352V64c0-35.3-28.7-64-64-64H96c-1.5 0-3 .1-4.4 .2H99L139.4 32H544c17.7 0 32 14.3 32 32V352c0 7.3-2.5 14.1-6.6 19.5l25.1 19.8zM277.6 416h84.9l10.7 64H266.9l10.7-64zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faDesktopSlash = faDisplaySlash;
var faSuitcaseRolling = {
  prefix: 'fal',
  iconName: 'suitcase-rolling',
  icon: [384, 512, [], "f5c1", "M128 48v80H256V48c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 128V48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v80h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64H96zM80 448H304h16c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H272 112 64c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H80zM96 256c0-8.8 7.2-16 16-16H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16z"]
};
var faPersonCircleExclamation = {
  prefix: 'fal',
  iconName: 'person-circle-exclamation',
  icon: [576, 512, [], "e53f", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faTransporter2 = {
  prefix: 'fal',
  iconName: 'transporter-2',
  icon: [512, 512, [], "e044", "M64 16V32H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H16C7.2 64 0 56.8 0 48s7.2-16 16-16H32V16C32 7.2 39.2 0 48 0s16 7.2 16 16zM480 336v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zM256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM144 480c-8.8 0-16 7.2-16 16s-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16H144zM383.7 224H343.5l-22-29c-.5-.7-1-1.3-1.5-1.9V224H288V176.2c-1.6-.2-3.1-.2-4.7-.2H228.7c-1.6 0-3.2 .1-4.7 .2V224H192V193.1c-.5 .6-1 1.3-1.5 1.9l-22 29H128.3L165 175.7c15.1-19.9 38.7-31.7 63.7-31.7h54.6c25 0 48.6 11.7 63.7 31.7L383.7 224zM96 272c0-8.8 7.2-16 16-16H400c8.8 0 16 7.1 16 15.9l0 .1 0 .1c0 8.8-7.2 15.9-16 15.9H112c-8.8 0-16-7.2-16-16zm64 64c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"]
};
var faHandsHoldingDiamond = {
  prefix: 'fal',
  iconName: 'hands-holding-diamond',
  icon: [640, 512, ["hand-receiving"], "f47c", "M342.6 9.4l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM224 128l96 96 96-96L320 32l-96 96zM64 64c35.3 0 64 28.7 64 64V252.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64V344.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V252.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 0 0 44-44 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.9c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16 0 0-44-44 0 0-10.7-10.8C106.8 305.4 96 279.4 96 252.3V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V344.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2V128C0 92.7 28.7 64 64 64z"]
};
var faHandReceiving = faHandsHoldingDiamond;
var faMoneyBillSimpleWave = {
  prefix: 'fal',
  iconName: 'money-bill-simple-wave',
  icon: [576, 512, [], "e1f2", "M32 422.3c0 6.8 3.7 10.4 6.2 11.3c72.8 27.2 146.7 11.3 231.1-10.2c4.3-1.1 8.6-2.2 13-3.3c77.8-19.9 165.3-42.3 253.5-18.2c2.2 .6 4.9 .2 6.9-1.2c.9-.6 1.2-1.1 1.3-1.2c0 0 0 0 0 0s0 0 0-.1V89.7c0-6.8-3.7-10.4-6.2-11.3C465 51.2 391.1 67.1 306.7 88.5c-4.3 1.1-8.6 2.2-13 3.3C215.9 111.7 128.4 134.1 40.2 110c-2.2-.6-4.9-.2-6.9 1.2c-.9 .6-1.2 1.1-1.3 1.2c0 0 0 0 0 0l0 .1V422.3zm-32 0V112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM224 256c0 47 31.3 80 64 80s64-33 64-80s-31.3-80-64-80s-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112s-96-53-96-112s40.4-112 96-112z"]
};
var faChevronDown = {
  prefix: 'fal',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", "M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z"]
};
var faBatteryFull = {
  prefix: 'fal',
  iconName: 'battery-full',
  icon: [576, 512, [128267, "battery", "battery-5"], "f240", "M432 128c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H432zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM112 192H400c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM64 208v96c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z"]
};
var faBattery = faBatteryFull;
var faBattery5 = faBatteryFull;
var faBellPlus = {
  prefix: 'fal',
  iconName: 'bell-plus',
  icon: [448, 512, [], "f849", "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3H44.3C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1V192c0-83 63.1-151.2 144-159.2V16zm16 48C153.3 64 96 121.3 96 192v29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3H403.7c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2V192c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM224 160c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V176c0-8.8 7.2-16 16-16z"]
};
var faBookArrowRight = {
  prefix: 'fal',
  iconName: 'book-arrow-right',
  icon: [640, 512, [], "e0b9", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V413.3c18.6-6.6 32-24.4 32-45.3V272H416v96c0 8.8-7.2 16-16 16H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16v96h32V48c0-26.5-21.5-48-48-48H64zM384 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H384zM539.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L585.4 192H272c-8.8 0-16 7.2-16 16s7.2 16 16 16H585.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"]
};
var faHospitals = {
  prefix: 'fal',
  iconName: 'hospitals',
  icon: [576, 512, [], "f80e", "M512 32H320c-17.7 0-32 14.3-32 32V80c-9.3-7-20.2-12-32-14.4V64c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H320c-5.1 0-10-.6-14.7-1.7c6.3-8.9 10.9-19.2 13.2-30.3c.5 0 1.1 0 1.6 0H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zM224 128H64c-17.7 0-32 14.3-32 32V352H256V160c0-17.7-14.3-32-32-32zM32 448c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V384H32v64zM64 96H224c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM320 320V288H544v32H320zm0 96V384H544v32H320zM136 176h16c4.4 0 8 3.6 8 8v40h40c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H160v40c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8V256H88c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8h40V184c0-4.4 3.6-8 8-8zM416 88c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v40h40c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H448v40c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V160H376c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h40V88z"]
};
var faClub = {
  prefix: 'fal',
  iconName: 'club',
  icon: [512, 512, [9827], "f327", "M358.3 154.9c1.1-6.1 1.7-12.4 1.7-18.9c0-57.4-46.6-104-104-104s-104 46.6-104 104c0 6.5 .6 12.8 1.7 18.9c1.6 8.8-.5 17.9-5.9 25s-13.5 11.7-22.4 12.6C73 197.8 32 242.1 32 296c0 57.4 46.6 104 104 104c39.7 0 74.2-22.2 91.8-55c5.6-10.4 16.4-16.9 28.2-16.9s22.6 6.5 28.2 16.9c17.6 32.8 52.1 55 91.8 55c57.4 0 104-46.6 104-104c0-53.9-41-98.2-93.4-103.5c-8.9-.9-17-5.5-22.4-12.6s-7.5-16.2-5.9-25zm31.5 5.8c7.4 .7 14.7 2.1 21.7 4C469.4 180.3 512 233.1 512 296c0 75.1-60.9 136-136 136c-39.4 0-74.9-16.8-99.7-43.5c-1.5-1.6-2.9-3.2-4.3-4.8V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V383.6c-1.4 1.6-2.8 3.3-4.3 4.8C210.9 415.2 175.4 432 136 432C60.9 432 0 371.1 0 296c0-62.9 42.6-115.8 100.6-131.3c7-1.9 14.3-3.2 21.7-4c-1.3-7.1-2.1-14.5-2.2-22c0-.9 0-1.8 0-2.7C120 60.9 180.9 0 256 0s136 60.9 136 136c0 .9 0 1.8 0 2.7c-.1 7.5-.9 14.8-2.2 22z"]
};
var faSkullCrossbones = {
  prefix: 'fal',
  iconName: 'skull-crossbones',
  icon: [448, 512, [128369, 9760], "f714", "M300.1 198.4c-7.6 6.1-12.1 15.3-12.1 25V240c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V223.4c0-9.8-4.4-19-12.1-25C125.1 180.2 112 155 112 128c0-49.6 46.5-96 112-96s112 46.4 112 96c0 27-13.1 52.2-35.9 70.4zM320 240V223.4c29.5-23.4 48-57.5 48-95.4C368 57.3 303.5 0 224 0S80 57.3 80 128c0 37.9 18.5 72 48 95.4V240c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48zm126.5 57.3c-3.7-8-13.2-11.5-21.2-7.8L224 382.4 22.7 289.5c-8-3.7-17.5-.2-21.2 7.8s-.2 17.5 7.8 21.2L185.8 400 9.3 481.5c-8 3.7-11.5 13.2-7.8 21.2s13.2 11.5 21.2 7.8L224 417.6l201.3 92.9c8 3.7 17.5 .2 21.2-7.8s.2-17.5-7.8-21.2L262.2 400l176.5-81.5c8-3.7 11.5-13.2 7.8-21.2zM208 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDropletDegree = {
  prefix: 'fal',
  iconName: 'droplet-degree',
  icon: [512, 512, ["dewpoint"], "f748", "M192 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c11.9-27.6 28.5-57.5 46.6-86.8c35.9-58 76.4-110.9 94.5-133.7h1.3c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8C345.9 280.8 352 303.8 352 320c0 88.4-71.6 160-160 160zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zM384 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faDewpoint = faDropletDegree;
var faCodeCompare = {
  prefix: 'fal',
  iconName: 'code-compare',
  icon: [512, 512, [], "e13a", "M322.8 484.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1s5.5 16.7-1.1 22.6L265.4 400H336c44.2 0 80-35.8 80-80V158.4c-36.5-7.4-64-39.7-64-78.4c0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4V320c0 61.9-50.1 112-112 112H265.4l57.4 52.2zM384 80a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM189.2 27.8c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1l88 80c3.3 3 5.2 7.3 5.2 11.8s-1.9 8.8-5.2 11.8l-88 80c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6L246.6 112H176c-44.2 0-80 35.8-80 80V353.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V192c0-61.9 50.1-112 112-112h70.6L189.2 27.8zM128 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faListUl = {
  prefix: 'fal',
  iconName: 'list-ul',
  icon: [512, 512, ["list-dots"], "f0ca", "M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM176 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faListDots = faListUl;
var faHandHoldingMagic = {
  prefix: 'fal',
  iconName: 'hand-holding-magic',
  icon: [576, 512, [], "f6e5", "M160 80c0 26.5 21.5 48 48 48h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-44.2 0-80-35.8-80-80s35.8-80 80-80H328c66.3 0 120 53.7 120 120s-53.7 120-120 120H272v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V237.5c0-16.3 13.2-29.5 29.5-29.5H328c48.6 0 88-39.4 88-88s-39.4-88-88-88H208c-26.5 0-48 21.5-48 48zm-9 237.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7H80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faWatermelonSlice = {
  prefix: 'fal',
  iconName: 'watermelon-slice',
  icon: [512, 512, [], "e337", "M404.7 4.7c6.2-6.2 16.4-6.2 22.6 0C481.5 58.9 512 132.5 512 209.1v4C512 378.2 378.2 512 213.2 512h-4c-76.7 0-150.2-30.5-204.5-84.7c-6.2-6.2-6.2-16.4 0-22.6l400-400zm11 34.3L391 63.7c35.5 40.8 57 94 57 152.3c0 128.1-103.9 232-232 232c-58.3 0-111.6-21.5-152.3-57L39 415.6C85.8 457 146.3 480 209.1 480h4C360.5 480 480 360.5 480 213.2v-4c0-62.8-23-123.3-64.4-170.2zM86.3 368.3C121.3 398 166.5 416 216 416c110.5 0 200-89.5 200-200c0-49.5-18-94.7-47.7-129.7L86.3 368.3zm261-203.6l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm88 8l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-168 72l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm88 8l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faCircleEllipsis = {
  prefix: 'fal',
  iconName: 'circle-ellipsis',
  icon: [512, 512, [], "e10a", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM184 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faSchoolLock = {
  prefix: 'fal',
  iconName: 'school-lock',
  icon: [640, 512, [], "e56f", "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64V272c0-30.5-12.2-58.2-32-78.4V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H256V384c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 11.7 3.1 22.6 8.6 32H384 352 288 256 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H171.2l140-93.3zM352 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v96h64V384zM128 160h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm0 32v64h32V192H128zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V352zm64 0H128v64h32V352zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm16 64v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 64c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm160 80H448V480H608V352z"]
};
var faTowerCell = {
  prefix: 'fal',
  iconName: 'tower-cell',
  icon: [576, 512, [], "e585", "M40.9 9.1c-8.2-3.2-17.5 .9-20.7 9.2C7.2 52.2 0 89.2 0 128s7.2 75.8 20.3 109.8c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C38.4 196 32 162.8 32 128s6.4-67.9 18.1-98.2c3.2-8.2-.9-17.5-9.2-20.7zm494.1 0c-8.2 3.2-12.4 12.4-9.2 20.7C537.6 60.1 544 93.2 544 128s-6.4 67.9-18.1 98.2c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2c13.1-33.9 20.3-71 20.3-109.8s-7.2-75.8-20.3-109.8c-3.2-8.2-12.4-12.4-20.7-9.2zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm47.3 75.1C345.7 159.7 352 144.6 352 128c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 16.6 6.3 31.7 16.7 43.1L97.4 489.4c-3.6 8.1 0 17.5 8 21.2s17.5 0 21.2-8l39-86.6H410.5l39 86.6c3.6 8.1 13.1 11.7 21.2 8s11.7-13.1 8-21.2L335.3 171.1zM396.1 384H179.9l28.8-64H367.3l28.8 64zM308.2 188.8L352.9 288H223.1l44.7-99.2c6.3 2.1 13.1 3.3 20.2 3.3s13.8-1.1 20.2-3.3zM140 70.4c3.5-8.1-.2-17.5-8.3-21.1s-17.5 .2-21.1 8.3C101.2 79.2 96 103 96 128s5.2 48.8 14.7 70.4c3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1c-7.7-17.6-12-37.1-12-57.6s4.3-40 12-57.6zM465.3 57.6c-3.5-8.1-13-11.8-21.1-8.3s-11.8 13-8.3 21.1c7.7 17.6 12 37.1 12 57.6s-4.3 40-12 57.6c-3.5 8.1 .2 17.5 8.3 21.1s17.5-.2 21.1-8.3C474.8 176.8 480 153 480 128s-5.2-48.8-14.7-70.4z"]
};
var faSdCards = {
  prefix: 'fal',
  iconName: 'sd-cards',
  icon: [448, 512, [], "e240", "M416 368c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V154.5c0-8.5 3.4-16.6 9.4-22.6l90.5-90.5c6-6 14.1-9.4 22.6-9.4H384c17.7 0 32 14.3 32 32V368zM448 64c0-35.3-28.7-64-64-64H234.5c-17 0-33.3 6.7-45.3 18.7L98.7 109.3c-12 12-18.7 28.3-18.7 45.3V368c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64zM240 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faJugBottle = {
  prefix: 'fal',
  iconName: 'jug-bottle',
  icon: [640, 512, [], "e5fb", "M128 64V32h64V64H128zM96 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H96h32 64 32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V24c0-13.3-10.7-24-24-24H120C106.7 0 96 10.7 96 24V64zm32 96H256c53 0 96 43 96 96v8h0v9.7V296v80 20.2V408h0v40c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256c0-53 43-96 96-96zm0-32C57.3 128 0 185.3 0 256V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm128 80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48s48-21.5 48-48V256c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V256zM404 494.6c13.2 10.9 30.1 17.4 48.4 17.4H564c42 0 76-34 76-76c0-19.5-7.4-37.3-19.5-50.8C632.6 372.3 640 355 640 336c0-18.8-7.2-35.9-19-48.8c11.8-13.2 19-30.6 19-49.7c0-28.9-16.7-55.2-42.9-67.5l-4.7-2.2c-11-5.1-23-7.8-35.1-7.8H468.8c-13.5 0-26.9 3-39.1 8.7l-9.6 4.5c-7.4 3.5-14.1 8.1-19.8 13.7c5.7 11.8 9.9 24.4 12.6 37.7c3.7-9.7 11.1-17.8 20.8-22.3l9.6-4.5c8-3.7 16.7-5.7 25.5-5.7h88.5c7.4 0 14.8 1.6 21.5 4.8l4.7 2.2c14.9 7 24.5 22 24.5 38.5c0 10.9-4.1 20.8-10.9 28.4c-11 12.3-10.9 30.9 .3 43.1C604 316.1 608 325.5 608 336c0 10.6-4.1 20.2-10.8 27.3c-11.4 12.1-11.6 30.9-.5 43.3c7 7.8 11.3 18.1 11.3 29.4c0 24.3-19.7 44-44 44H452.4c-15.5 0-29.3-8-37.1-20.4c-1.5 12.5-5.5 24.3-11.3 34.9zM480 104c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v24h32V104c0-22.1-17.9-40-40-40H488c-22.1 0-40 17.9-40 40v24h32V104z"]
};
var faDownLong = {
  prefix: 'fal',
  iconName: 'down-long',
  icon: [320, 512, ["long-arrow-alt-down"], "f309", "M88 352H38.7c-3.7 0-6.7 3-6.7 6.7c0 1.9 .8 3.7 2.2 5L160 476.2 285.8 363.7c1.4-1.3 2.2-3.1 2.2-5c0-3.7-3-6.7-6.7-6.7H232c-17.7 0-32-14.3-32-32V48c0-8.8-7.2-16-16-16H136c-8.8 0-16 7.2-16 16V320c0 17.7-14.3 32-32 32zm86 154.7c-3.8 3.4-8.8 5.3-14 5.3s-10.1-1.9-14-5.3L12.9 387.5C4.7 380.2 0 369.7 0 358.7C0 337.3 17.3 320 38.7 320H56 88V288 48c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48V288v32h32 17.3c21.4 0 38.7 17.3 38.7 38.7c0 11-4.7 21.5-12.9 28.8L174 506.7z"]
};
var faLongArrowAltDown = faDownLong;
var faEnvelopes = {
  prefix: 'fal',
  iconName: 'envelopes',
  icon: [576, 512, [], "e170", "M512 64c17.7 0 32 14.3 32 32v19.6L364.4 247.3c-16.9 12.4-39.9 12.4-56.8 0L128 115.6V96c0-17.7 14.3-32 32-32H512zM128 320V155.3L288.7 273.1c28.2 20.7 66.5 20.7 94.6 0L544 155.3V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faPhoneOffice = {
  prefix: 'fal',
  iconName: 'phone-office',
  icon: [576, 512, [], "f67d", "M176 32c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h32zM144 0C120.3 0 99.6 12.9 88.6 32H64C28.7 32 0 60.7 0 96V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480 320 231.4C220.4 12.9 199.7 0 176 0H144zM288 64v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V64c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32l16 0V368c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V64h48zm192 0v64H320V64H480zM352 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48 16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM480 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48 16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z"]
};
var faRankingStar = {
  prefix: 'fal',
  iconName: 'ranking-star',
  icon: [640, 512, [], "e561", "M300.5 77.2l-3.7 7.5-8.3 1.2L245 92.2 276.6 123l6 5.9-1.4 8.3-7.4 43.3 39-20.6 7.4-3.9 7.5 3.9 38.7 20.3-7.4-43.3-1.4-8.3 6.1-5.9 31.4-30.3-43.4-6.3-8.3-1.2-3.7-7.5L320 37.8 300.5 77.2zm-5-62c10.3-20.6 39.4-19.9 49.1 .1l19.9 40.2 44 6.3 .2 0 0 0c22.1 3.4 31.5 30.6 15.3 46.9l-.2 .2 0 0-31.9 30.8 7.5 43.7 0 .3 0 0c3.4 22-19.5 39.1-39.8 28.9l-.3-.1 0 0L320.2 192l-39.5 20.9-.3 .2 0 0c-20.3 10.2-43.2-6.9-39.8-28.9l0-.3 0 0 7.5-43.8-31.9-31.1-.2-.2 0 0c-16.2-16.2-6.7-43.5 15.3-46.9l.2 0 0 0 44-6.3 19.9-40.2 0 0zM192 368v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm224 64v32c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V368 304c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V432zM256 304V464c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM32 368v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm448 64v32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H496c-8.8 0-16 7.2-16 16zm16-48h96c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48z"]
};
var faChessKing = {
  prefix: 'fal',
  iconName: 'chess-king',
  icon: [448, 512, [9818], "f43f", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V48H168c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v48H59.6C26.7 128 0 154.7 0 187.6c0 8.2 1.7 16.3 4.9 23.8L66.1 352H101L34.3 198.6c-1.5-3.5-2.3-7.2-2.3-11C32 172.4 44.4 160 59.6 160H224 388.4c15.2 0 27.6 12.4 27.6 27.6c0 3.8-.8 7.5-2.3 11L347 352h34.9l61.1-140.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6H240V80h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V16zM382.9 468.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H71.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L97.8 416l252.4 0 32.7 52.7zM97.8 384c-11.1 0-21.4 5.7-27.2 15.1L37.9 451.8C34.1 458 32 465.2 32 472.6C32 494.3 49.7 512 71.4 512H376.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1H97.8z"]
};
var faNfcPen = {
  prefix: 'fal',
  iconName: 'nfc-pen',
  icon: [576, 512, [], "e1fa", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H266.3l-8 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V220.2l-32 32V96c0-17.7-14.3-32-32-32zm0 64V284.2l-32 32V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32zM276.2 408.3l-1.9 7.7H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0V384H286.7c-4.8 7.4-8.4 15.6-10.5 24.3zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm294.8 24c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L536.2 304c6.2-6.2 6.2-16.4 0-22.6L518.8 264zM342.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L488.7 351.4l-40-40L342.5 417.7zM473.5 241.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L473.5 241.4z"]
};
var faPersonHarassing = {
  prefix: 'fal',
  iconName: 'person-harassing',
  icon: [576, 512, [], "e549", "M216 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 136 56zM112 320h64V161.2c-3.4-.8-6.9-1.2-10.5-1.2H131.3c-6.8 0-13.3 1.4-19.3 4V320zm179.8-37.6L208 183.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H112V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.2L30.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L60.7 170.3c13.9-26 41-42.3 70.6-42.3h34.2c23.5 0 45.7 10.3 60.9 28.2l89.8 105.5c5.7 6.7 4.9 16.8-1.8 22.6s-16.8 4.9-22.6-1.8zM304 32h56c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zM432 272a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm88 96c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-25.1 0-48.8-11.5-64.4-31.3l-53.5-68.2-52.2 91.4c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l64-112c2.6-4.6 7.4-7.6 12.7-8s10.5 1.9 13.8 6.1L464 439.6V344c0-30.9 25.1-56 56-56zm0 192c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24s-24 10.7-24 24V456c0 13.3 10.7 24 24 24zM265.7 104.8c4-7.9 13.6-11.1 21.5-7.2l48 24c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-48-24c-7.9-4-11.1-13.6-7.2-21.5z"]
};
var faHatWinter = {
  prefix: 'fal',
  iconName: 'hat-winter',
  icon: [512, 512, [], "f7a8", "M256 32c7.2 11.3 20.8 16.9 33.9 14l0 0 0 0C287 59.2 292.6 72.8 304 80l0 0 0 0c-11.3 7.2-16.9 20.8-14 33.9l0 0 0 0c-13.1-2.9-26.7 2.7-33.9 14l0 0 0 0c-7.2-11.3-20.8-16.9-33.9-14l0 0 0 0c2.9-13.1-2.7-26.7-14-33.9l0 0 0 0c11.3-7.2 16.9-20.8 14-33.9l0 0 0 0c13.1 2.9 26.7-2.7 33.9-14l0 0 0 0zm56.5-8.6c-8-8-19.3-10.9-29.6-8.6C277.3 5.9 267.3 0 256 0s-21.3 5.9-27 14.8c-10.3-2.3-21.5 .6-29.6 8.6s-10.9 19.3-8.6 29.6C181.9 58.7 176 68.7 176 80s5.9 21.3 14.8 27c-2.3 10.3 .6 21.5 8.6 29.6s19.3 10.9 29.6 8.6c5.7 8.9 15.7 14.8 27 14.8s21.3-5.9 27-14.8c10.3 2.3 21.5-.6 29.6-8.6s10.9-19.3 8.6-29.6c8.9-5.7 14.8-15.7 14.8-27s-5.9-21.3-14.8-27c2.3-10.3-.6-21.5-8.6-29.6zM32 456c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM0 456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56s-25.1-56-56-56H56c-30.9 0-56 25.1-56 56zM162.5 134.6C64.3 188.2 39.4 321.8 33.6 368H65.9c.8-5.8 1.9-12.8 3.3-20.6c.5-2.9 1.1-5.9 1.8-9l8.2-4.1L127.8 310c4.8-2.4 10.4-2.2 15.1 .4l26.3 15c13.9 8 30.9 8.4 45.3 1.3l34.4-17.2c4.5-2.3 9.8-2.3 14.3 0l34.4 17.2c14.4 7.2 31.3 6.7 45.3-1.3l26.3-15c4.6-2.7 10.3-2.8 15.1-.4l48.7 24.3 8.2 4.1c.6 3.1 1.2 6.1 1.8 9c1.5 7.9 2.5 14.8 3.3 20.6h32.3c-5.8-46.2-30.7-179.8-128.8-233.4c-2.5 9-7.3 17.5-14.4 24.6c-.9 .9-1.8 1.8-2.8 2.6c40.1 21.1 66.4 58.5 84.3 99.1c5.4 12.2 9.9 24.5 13.6 36.4l-31.9-15.9c-14.4-7.2-31.3-6.7-45.3 1.3l-26.3 15c-4.6 2.7-10.3 2.8-15.1 .4l-34.4-17.2c-13.5-6.8-29.4-6.8-42.9 0L200.2 298c-4.8 2.4-10.4 2.2-15.1-.4l-26.3-15c-13.9-8-30.9-8.4-45.3-1.3L81.6 297.3c3.7-11.9 8.2-24.2 13.6-36.4c17.9-40.6 44.3-78 84.3-99.1c-1-.8-1.9-1.7-2.8-2.6c-7.1-7.1-11.9-15.6-14.4-24.6z"]
};
var faBrazilianRealSign = {
  prefix: 'fal',
  iconName: 'brazilian-real-sign',
  icon: [512, 512, [], "e46c", "M400 0c8.8 0 16 7.2 16 16V64.5c16.8 1.4 33.3 5.4 48.9 11.9L478.2 82c8.2 3.4 12 12.8 8.6 20.9s-12.8 12-20.9 8.6l-13.3-5.6C436.9 99.4 420 96 403 96H387.3c-37.2 0-67.3 30.1-67.3 67.3c0 28.6 18.1 54.1 45.1 63.6l80.3 28c39.9 13.9 66.6 51.5 66.6 93.8c0 53.7-42.7 97.5-96 99.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V447.5c-22.1-1.8-43.5-8.6-62.6-20l-25.6-15.3c-7.6-4.5-10-14.4-5.5-21.9s14.4-10.1 21.9-5.5l25.6 15.3c17.4 10.4 37.3 15.9 57.5 15.9h17.3c37.2 0 67.3-30.1 67.3-67.3c0-28.6-18.1-54.1-45.1-63.6l-80.3-28c-39.9-13.9-66.6-51.5-66.6-93.8c0-53.7 42.7-97.5 96-99.3V16c0-8.8 7.2-16 16-16zM0 80C0 53.5 21.5 32 48 32h64c79.5 0 144 64.5 144 144c0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3L119.9 319.8c-2.6 .1-5.3 .2-7.9 .2H32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 80zM32 288h80c61.9 0 112-50.1 112-112s-50.1-112-112-112H48c-8.8 0-16 7.2-16 16V288z"]
};
var faLandmarkDome = {
  prefix: 'fal',
  iconName: 'landmark-dome',
  icon: [512, 512, ["landmark-alt"], "f752", "M256 0c8.8 0 16 7.2 16 16V32.7c87.9 7.2 159 73.7 173.3 159.3H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H448 416 96 64 48c-8.8 0-16-7.2-16-16s7.2-16 16-16H66.7C81 106.3 152.1 39.9 240 32.7V16c0-8.8 7.2-16 16-16zM99.2 192H412.8C398 119 333.4 64 256 64s-142 55-156.8 128zM64 352V256H96v96h80V256h32v96h96V256h32v96h80V256h32v96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM24 432c0-8.8 7.2-16 16-16H472c8.8 0 16 7.2 16 16s-7.2 16-16 16H40c-8.8 0-16-7.2-16-16zM0 496c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faLandmarkAlt = faLandmarkDome;
var faBoneBreak = {
  prefix: 'fal',
  iconName: 'bone-break',
  icon: [640, 512, [], "f5d8", "M320 0c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM164.7 68.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm310.6 0c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zM270.7 244.3c-2.3-8.5-11.1-13.6-19.6-11.3l-73.4 19.7c-4 1.1-8.1-1.1-9.9-4.9c-17.7-38.1-60.6-59.1-102.6-47.8C18.3 212.6-9.6 260.8 3 307.8C9.7 332.6 26.3 352 47.4 363c4.9 2.6 6.7 9.1 3.7 13.8c-12.8 20.1-17.4 45.3-10.8 70.1c12.6 46.9 60.8 74.8 107.8 62.2c41.9-11.2 68.6-50.9 64.9-92.7c-.4-4.1 2.1-8.1 6.1-9.1l73.4-19.7c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-73.4 19.7c-20.6 5.5-31.3 24.9-29.7 42.9c2.4 26.6-14.7 51.8-41.3 59c-29.9 8-60.6-9.7-68.6-39.6c-4.2-15.8-1.3-31.8 6.9-44.6c13.1-20.5 5.7-48.1-15.9-59.3c-13.5-7-24-19.4-28.2-35.2c-8-29.9 9.7-60.6 39.6-68.6c26.6-7.1 54 6.2 65.3 30.4c7.6 16.3 26.6 27.8 47.2 22.3l73.4-19.7c8.5-2.3 13.6-11.1 11.3-19.6zM388.9 233c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6L454 283.6c20.6 5.5 39.6-5.9 47.2-22.3c11.2-24.2 38.6-37.5 65.3-30.4c29.9 8 47.6 38.7 39.6 68.6c-4.2 15.8-14.7 28.2-28.2 35.2c-21.6 11.2-28.9 38.8-15.9 59.3c8.2 12.8 11.1 28.8 6.9 44.6c-8 29.9-38.7 47.6-68.6 39.6c-26.6-7.1-43.7-32.4-41.3-59c1.6-18-9.1-37.4-29.7-42.9l-73.4-19.7c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l73.4 19.7c4 1.1 6.5 5 6.1 9.1c-3.7 41.8 23 81.5 64.9 92.7c46.9 12.6 95.2-15.3 107.8-62.2c6.6-24.8 2-50-10.8-70.1c-3-4.7-1.2-11.2 3.7-13.8c21.1-11 37.7-30.5 44.4-55.3c12.6-46.9-15.3-95.2-62.2-107.8c-41.9-11.2-84.9 9.8-102.6 47.8c-1.7 3.8-5.9 5.9-9.9 4.9L388.9 233z"]
};
var faArrowUp = {
  prefix: 'fal',
  iconName: 'arrow-up',
  icon: [384, 512, [8593], "f062", "M203.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-176 176c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6L356.7 235.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-176-176z"]
};
var faDownFromDottedLine = {
  prefix: 'fal',
  iconName: 'down-from-dotted-line',
  icon: [448, 512, [], "e407", "M222.2 447.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L350.2 315.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7H288c-8.8 0-16-7.2-16-16V168c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8V288c0 8.8-7.2 16-16 16H102.7c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L222.2 447.2zM224 480c-9.5 0-18.6-3.9-25.1-10.8L74.5 337.2C67.8 330 64 320.5 64 310.7c0-21.4 17.3-38.7 38.7-38.7H144V168c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40V272h41.3c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.4-10.5 26.5L249.1 469.2c-6.5 6.9-15.6 10.8-25.1 10.8zM32 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm384 0a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm72-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTv = {
  prefix: 'fal',
  iconName: 'tv',
  icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 32C46.3 32 32 46.3 32 64V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 480H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTelevision = faTv;
var faTvAlt = faTv;
var faBorderLeft = {
  prefix: 'fal',
  iconName: 'border-left',
  icon: [448, 512, [], "f84f", "M16 480c-8.8 0-16-7.2-16-16L0 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 416c0 8.8-7.2 16-16 16zm112-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-336a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM320 472a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM224 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-336a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM416 472a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM224 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm192 48a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 184a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"]
};
var faCircleDivide = {
  prefix: 'fal',
  iconName: 'circle-divide',
  icon: [512, 512, [], "e106", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-96 56c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zM280 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faShrimp = {
  prefix: 'fal',
  iconName: 'shrimp',
  icon: [512, 512, [129424], "e448", "M0 96C0 60.7 28.7 32 64 32H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H64C46.3 64 32 78.3 32 96s14.3 32 32 32H336c97.2 0 176 78.8 176 176s-78.8 176-176 176H240c-8.8 0-16-7.2-16-16c0-4.4 1.8-8.4 4.7-11.3L265.4 416l-36.7-36.7c-5-5-6.1-12.7-2.7-19s10.5-9.5 17.4-8L348.9 375c3.2 .7 6.4 1 9.7 1c14 0 25.4-11.4 25.4-25.4V348c0-15.5-12.5-28-28-28H240c-91.8 0-167.2-70.3-175.3-160H64C28.7 160 0 131.3 0 96zM336 448V404.9L289.6 395l9.7 9.7c6.2 6.2 6.2 16.4 0 22.6L278.6 448H336zm32-3.6c33-7.5 61.7-26.3 81.7-52.1l-39.8-15.9c-8.1 16.1-23.5 27.8-41.9 30.8v37.2zm98.7-79.8c8.6-18.4 13.3-39 13.3-60.6c0-9.3-.9-18.3-2.5-27.1l-67.4 45c3.3 6.9 5.4 14.4 5.9 22.4l50.8 20.3zm.8-119.5C447 199.6 403.6 166.6 352 160.9V288h4c12 0 23.3 3.6 32.7 9.7l78.8-52.5zM320 160H96.9c8 72 69 128 143.1 128h80V160zM208 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faListCheck = {
  prefix: 'fal',
  iconName: 'list-check',
  icon: [512, 512, ["tasks"], "f0ae", "M156.3 58.2c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 120.3 27.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zm0 160c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 280.3 27.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zM192 96c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM160 416c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTasks = faListCheck;
var faDiagramSubtask = {
  prefix: 'fal',
  iconName: 'diagram-subtask',
  icon: [512, 512, [], "e479", "M448 64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H144 112 64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H448zM144 224H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h48v96c0 44.2 35.8 80 80 80h32v16c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H288c-35.3 0-64 28.7-64 64v16H192c-26.5 0-48-21.5-48-48V224zm304 96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H448z"]
};
var faJugDetergent = {
  prefix: 'fal',
  iconName: 'jug-detergent',
  icon: [384, 512, [], "e519", "M128 64V32h64V64H128zM96 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H96h32 64 32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V24c0-13.3-10.7-24-24-24H120C106.7 0 96 10.7 96 24V64zm32 96H256c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256c0-53 43-96 96-96zm0-32C57.3 128 0 185.3 0 256V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm128 80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48s48-21.5 48-48V256c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V256z"]
};
var faCircleUser = {
  prefix: 'fal',
  iconName: 'circle-user',
  icon: [512, 512, [62142, "user-circle"], "f2bd", "M412.1 416.6C398.1 361.1 347.9 320 288 320H224c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.5 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1h64c50.4 0 91.6 38.8 95.7 88.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"]
};
var faUserCircle = faCircleUser;
var faSquareY = {
  prefix: 'fal',
  iconName: 'square-y',
  icon: [448, 512, [], "e287", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm124 53.5L224 263.7 324 149.5c5.8-6.7 15.9-7.3 22.6-1.5s7.3 15.9 1.5 22.6L240 294v90c0 8.8-7.2 16-16 16s-16-7.2-16-16V294L100 170.5c-5.8-6.7-5.1-16.8 1.5-22.6s16.8-5.1 22.6 1.5z"]
};
var faUserDoctorHair = {
  prefix: 'fal',
  iconName: 'user-doctor-hair',
  icon: [448, 512, [], "e458", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM228.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zm80 208v34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V339.8C80.2 354.7 32.6 411.8 32 480H416c-.5-62.4-40.4-115.4-96-135.5v25.8c23.1 6.9 40 28.3 40 53.7v24c0 8.8-7.2 16-16 16H328c-8.8 0-16-7.2-16-16s7.2-16 16-16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V424c0-25.4 16.9-46.8 40-53.7V337c-5.6-.7-11.4-1-17.2-1H177.2l-1.2 0zm-32 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM0 481.2C0 383.3 79.3 304 177.2 304h93.6C368.7 304 448 383.3 448 481.2c0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2z"]
};
var faPlanetRinged = {
  prefix: 'fal',
  iconName: 'planet-ringed',
  icon: [512, 512, [129680], "e020", "M480 32c-2.5 0-6.6 .4-12.8 1.9c-15.8 3.9-37.7 13.4-64.7 29.3l-2 1.2c-9.5-7.2-19.5-13.6-29.8-19.2c63.8-40.5 113.9-56.2 133.1-37c22.1 22.1-2.3 85.6-57.6 163.7C457.7 197.6 464 226 464 256c0 114.9-93.1 208-208 208c-30 0-58.4-6.3-84.2-17.7C93.7 501.6 30.3 526 8.1 503.9c-19.2-19.2-3.4-69.3 37-133.1c5.6 10.3 12 20.2 19.2 29.8l-1.2 2c-15.9 27-25.5 48.9-29.3 64.7C32.4 473.5 32 477.5 32 480c2.5 0 6.6-.4 12.8-1.9c15.8-3.9 37.7-13.4 64.7-29.3c9.9-5.9 20.3-12.5 31.1-19.7C84.7 391.7 48 328.2 48 256C48 141.1 141.1 48 256 48c72.2 0 135.7 36.7 173 92.5c7.3-10.8 13.9-21.1 19.7-31.1c15.9-26.9 25.5-48.9 29.3-64.7c1.5-6.3 1.9-10.3 1.9-12.8zM408.9 168.8C378.6 115.8 321.5 80 256 80C158.8 80 80 158.8 80 256c0 65.5 35.8 122.6 88.8 152.9C209 379.1 253 341.1 297.1 297.1s82-88.1 111.9-128.2zM202.3 423.7c16.9 5.4 34.9 8.3 53.7 8.3c97.2 0 176-78.8 176-176c0-18.7-2.9-36.7-8.3-53.7c-29 37.6-64.2 77.6-104 117.3s-79.8 74.9-117.3 104z"]
};
var faMushroom = {
  prefix: 'fal',
  iconName: 'mushroom',
  icon: [512, 512, [127812], "e425", "M130.8 105c17.5 23.6 45.6 39 77.2 39c46.1 0 84.6-32.5 93.9-75.9c41 8.6 77.3 30.1 104.3 60.2c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64c22.4 0 42.1-11.5 53.5-28.9c1.6 10.1 2.5 20.5 2.5 31c0 16.5-13.4 29.9-29.9 29.9H288 224 85.9C69.4 288 56 274.6 56 258.1c0-62.2 29.3-117.6 74.8-153.1zM116.1 75.9C60.3 117.1 24 183.4 24 258.1C24 292.3 51.7 320 85.9 320H191.4 224h64 32.6H426.1c34.2 0 61.9-27.7 61.9-61.9C488 133.2 386.8 32 261.9 32H250.1c-38 0-73.9 9.4-105.3 26c0 0 0 0 0 0c-10 5.3-19.6 11.3-28.6 18c0 0 0 0 0 0zm41.5 11.5c27.5-14.9 59-23.4 92.5-23.4h11.8c2.7 0 5.4 .1 8 .2C262.8 91.7 237.8 112 208 112c-20.5 0-38.7-9.6-50.4-24.6zM326.6 352H294l18 96-112 0 18-96H185.4l-16.9 90.1c-1.8 9.4 .7 19 6.8 26.3s15.1 11.6 24.6 11.6H312c9.5 0 18.5-4.2 24.6-11.6s8.6-17 6.8-26.3L326.6 352zM128 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm208-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faUserShield = {
  prefix: 'fal',
  iconName: 'user-shield',
  icon: [640, 512, [], "f505", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480H388.1c10.3 11.3 22.1 21.9 35.5 31.5c-1.7 .3-3.5 .5-5.3 .5H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c17.6 0 34.6 2.6 50.7 7.3c.6 11 1.9 22.9 4.1 35.3c-16.9-6.9-35.5-10.6-54.9-10.6H178.3c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM384.1 301.4c1.3 53 22.6 129.5 95.9 170V263l-95.9 38.4zm223.9 0L512 263V471.4c73.4-40.5 94.6-117.1 95.9-170zm-103-75.7l120 48C634 277.4 640 286.2 640 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C377.9 464.8 352 359.3 352 296c0-9.8 6-18.6 15.1-22.3l120-48c5.7-2.3 12.1-2.3 17.8 0z"]
};
var faMegaphone = {
  prefix: 'fal',
  iconName: 'megaphone',
  icon: [576, 512, [128227], "f675", "M560 32c-8.8 0-16 7.2-16 16V59.5L32 187.5V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v19.5V208v96 12.5V336c0 8.8 7.2 16 16 16s16-7.2 16-16V324.5l131.7 32.9c-2.4 8.4-3.7 17.4-3.7 26.6c0 53 43 96 96 96c46.2 0 84.7-32.6 93.9-76L544 452.5V464c0 8.8 7.2 16 16 16s16-7.2 16-16V440 72 48c0-8.8-7.2-16-16-16zM544 419.5L32 291.5v-71l512-128v327zM192 384c0-6.5 1-12.9 2.8-18.8l124 31C313.1 425.7 287.2 448 256 448c-35.3 0-64-28.7-64-64z"]
};
var faWreathLaurel = {
  prefix: 'fal',
  iconName: 'wreath-laurel',
  icon: [640, 512, [], "e5d2", "M384 32c44.2 0 80 35.8 80 80c-44.2 0-80-35.8-80-80zM494.6 94C486 40.7 439.7 0 384 0H368c-8.8 0-16 7.2-16 16V32c0 61.9 50.1 112 112 112h8.1c25.7 31.5 39.9 71 39.9 112c0 72.8-40.5 136.1-100.2 168.7c9.4 2.3 18.7 5 27.8 8.2l0 0c12.3 4.3 24.3 9.3 36 15.2l4.6 2.3c51.5 9 105.4-14.2 133-62.1L630 359c3.9-6.8 1.6-15.5-5.2-19.4c-11.4-6.6-23.6-11-35.9-13.3c31-23.4 51-60.5 51-102.3V190.2c0-7.9-6.4-14.2-14.2-14.2c-13.2 0-25.9 2.3-37.7 6.4c15.2-35.7 14-77.9-6.9-114.1L564.2 39c-3.9-6.8-12.6-9.1-19.4-5.2c-24.3 14-41.5 35.7-50.2 60.2zM319.8 480l.2 0h19.6c37.3 0 74 8.7 107.3 25.3l9.9 5c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-9.9-5C423.4 457.8 381.8 448 339.6 448H320c-106 0-192-86-192-192c0-41 14.2-80.5 39.9-112H176c61.9 0 112-50.1 112-112V16c0-8.8-7.2-16-16-16H256C200.3 0 154 40.7 145.4 94c-8.8-24.5-25.9-46.2-50.2-60.2c-6.8-3.9-15.5-1.6-19.4 5.2L58.9 68.3C38 104.5 36.8 146.7 51.9 182.4c-11.8-4.1-24.5-6.4-37.7-6.4C6.4 176 0 182.4 0 190.2V224c0 41.8 20 78.9 51 102.3c-12.3 2.3-24.4 6.7-35.9 13.3C8.4 343.5 6.1 352.2 10 359l16.9 29.3c29.8 51.7 90.2 74.7 145.1 59.4c6.9-1.9 13.7-4.4 20.3-7.6c10.2 7.1 21 13.4 32.4 18.7c-15.8 4.6-31.1 10.6-45.9 18l-9.9 5c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l9.9-5c33.3-16.7 70.1-25.3 107.3-25.3h19.3zM176 112c0-21.6 8.5-41.2 22.4-55.5C213 41.4 233.4 32 256 32c0 44.2-35.8 80-80 80zM96 289.8v24.8C58.7 301.4 32 265.8 32 224V209.9c36.6 8.1 64 40.8 64 79.8zm448 24.8V289.8c0-39.1 27.4-71.7 64-79.8V224c0 41.8-26.7 77.4-64 90.5zM142.9 397.3l12.4 21.4c-38.9 7.2-79.8-10.2-100.7-46.4l-7-12.2c35.8-11.3 75.8 3.3 95.3 37.1zM96.7 194.7C71 164.6 65.7 120.5 86.6 84.3l7-12.2c27.7 25.3 35 67.3 15.5 101.1L96.7 194.7zm434.1-21.4c-19.5-33.8-12.1-75.8 15.5-101.1l7 12.2c20.9 36.2 15.5 80.4-10.2 110.4l-12.4-21.4zm-33.8 224c19.5-33.8 59.6-48.4 95.3-37.1l-7 12.2c-20.9 36.2-61.8 53.6-100.7 46.4l12.4-21.4z"]
};
var faCircleExclamationCheck = {
  prefix: 'fal',
  iconName: 'circle-exclamation-check',
  icon: [640, 512, [], "e10d", "M32 256C32 132.3 132.3 32 256 32c95.3 0 176.7 59.5 209.1 143.4c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C458 68 364.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c75.8 0 144-33 190.8-85.3c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3c-41 45.9-100.6 74.7-167 74.7C132.3 480 32 379.7 32 256zM272 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM256 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM619.3 180.7c-6.2-6.2-16.4-6.2-22.6 0L480 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faWind = {
  prefix: 'fal',
  iconName: 'wind',
  icon: [512, 512, [], "f72e", "M288 16c0 8.8 7.2 16 16 16h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c44.2 0 80-35.8 80-80s-35.8-80-80-80H304c-8.8 0-16 7.2-16 16zm64 384c0 8.8 7.2 16 16 16h56c48.6 0 88-39.4 88-88s-39.4-88-88-88H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H424c30.9 0 56 25.1 56 56s-25.1 56-56 56H368c-8.8 0-16 7.2-16 16zM112 512h64c44.2 0 80-35.8 80-80s-35.8-80-80-80H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H176c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faBoxDollar = {
  prefix: 'fal',
  iconName: 'box-dollar',
  icon: [448, 512, ["box-usd"], "f4a0", "M240 64H342.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128H416V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H208h32zm-32-32H42.1L76.3 83c5.1-11.6 16.6-19 29.2-19H208v96zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM240 216c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V424c0 8.8 7.2 16 16 16s16-7.2 16-16V406.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V216z"]
};
var faBoxUsd = faBoxDollar;
var faCarBurst = {
  prefix: 'fal',
  iconName: 'car-burst',
  icon: [640, 512, ["car-crash"], "f5e1", "M190.5 17.3C187.9 11.6 182.2 8 176 8s-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l25.7-21.3c.3-2.9 .8-5.8 1.6-8.7l11.8-43.9-32.7 27 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l48.2-11.9 23.2-38.7L222.6 87.2 190.5 17.3zM380.9 86.9l164.4 44c13.8 3.7 23.5 16.1 23.7 30.4l1.3 75.7-264-70.7 38.9-64.9c7.3-12.3 21.9-18.2 35.7-14.5zm-63.2-2l-46.2 77c-32.6 2.9-61.4 25.6-70.3 59L175 318.8c-.3 1.3-.6 2.6-.7 3.8l-.3-.1L159.1 378c-2.7 10 3.2 20.2 13.2 22.9s20.2-3.2 22.9-13.2l9.7-36 360.5 96.6-9.7 36.1c-2.7 10 3.2 20.2 13.2 22.9s20.2-3.2 22.9-13.2l15.4-57.5-.1 0c.2-.6 .4-1.1 .5-1.7l26.2-97.8c8.9-33.4-4.6-67.5-31.4-86.3L601 160.8c-.5-28.6-19.8-53.4-47.4-60.8L389.2 56c-27.6-7.4-56.8 4.4-71.5 28.9zM569 269.8c25.6 6.9 40.8 33.2 33.9 58.8l-24.1 90.1L208 319.3l24.1-90.1c6.9-25.6 33.2-40.8 58.8-33.9l278 74.5zM278.3 294a28 28 0 1 0 14.5-54.1A28 28 0 1 0 278.3 294zm286.6 47.8a28 28 0 1 0 -54.1-14.5 28 28 0 1 0 54.1 14.5z"]
};
var faCarCrash = faCarBurst;
var faY = {
  prefix: 'fal',
  iconName: 'y',
  icon: [384, 512, [121], "59", "M28.9 38.5c-5.2-7.1-15.2-8.7-22.4-3.4S-2.1 50.3 3.1 57.5L176 293.2V464c0 8.8 7.2 16 16 16s16-7.2 16-16V293.2L380.9 57.5c5.2-7.1 3.7-17.1-3.4-22.4s-17.1-3.7-22.4 3.4L192 260.9 28.9 38.5z"]
};
var faUserHeadset = {
  prefix: 'fal',
  iconName: 'user-headset',
  icon: [448, 512, [], "f82d", "M224 32C135.6 32 64 103.6 64 192v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192C32 86 118 0 224 0S416 86 416 192v16c0 61.9-50.1 112-112 112H240 224 208c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80V192c0-88.4-71.6-160-160-160zm0 32c70.7 0 128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256h-8.4c15.2-17 24.4-39.4 24.4-64c0-53-43-96-96-96s-96 43-96 96c0 24.6 9.3 47.1 24.5 64.1c-5.4 9.4-8.5 20.3-8.5 31.9c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128zM208 352h16 16 64 9.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352H208zm105.6 32H134.4C80 384 35.5 426.4 32.2 480H415.8c-3.3-53.6-47.8-96-102.2-96z"]
};
var faArrowsRetweet = {
  prefix: 'fal',
  iconName: 'arrows-retweet',
  icon: [640, 512, ["retweet-alt"], "f361", "M116.7 68.7c6.2-6.2 16.4-6.2 22.6 0l88 88c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L144 118.6V336c0 26.5 21.5 48 48 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-44.2 0-80-35.8-80-80V118.6L51.3 179.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l88-88zM528 393.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-88 88c-6.2 6.2-16.4 6.2-22.6 0l-88-88c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 393.4V176c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c44.2 0 80 35.8 80 80V393.4z"]
};
var faRetweetAlt = faArrowsRetweet;
var faPersonSnowboarding = {
  prefix: 'fal',
  iconName: 'person-snowboarding',
  icon: [512, 512, [127938, "snowboarding"], "f7ce", "M221.3 7.1c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l40.6 61c7.1 10.6 18 17.9 30.5 20.4l37 7.4-83.3 39.2c-16.8 7.9-27.6 24.8-27.6 43.4l0 83.1-88.9 59.3c-4.2 2.8-6.6 7.2-7.1 11.8l-18.9-7.4c-7.5-3-14.2-7.8-19.4-14L28.3 293.8c-5.7-6.8-15.7-7.7-22.5-2s-7.7 15.7-2 22.5l29.5 35.4C41.8 360 52.9 368 65.5 372.9L406.9 506.5c9.3 3.6 19.2 5.5 29.2 5.5H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H436.1c-6 0-11.9-1.1-17.5-3.3l-92.9-36.4c.4-.6 .7-1.3 1-1.9l41-93.8c11.7-26.8 3.8-58.2-19.3-76.2l-38.8-30.2 96.1-54.1 80 68c6.7 5.7 16.8 4.9 22.6-1.8s4.9-16.8-1.8-22.6l-141-119.9c-3.7-3.1-7.6-6-11.6-8.6c-.8-.6-1.6-1.1-2.4-1.5c-11.2-6.9-23.6-11.7-36.6-14.3l-42.6-8.5c-4.2-.8-7.8-3.3-10.2-6.8l-40.6-61zm60.8 209.8l-46.6-36.2 106.8-50.3c.8 .6 1.5 1.2 2.2 1.8l35 29.8-97.5 54.8zM224 212.3l104.7 81.4c11.6 9 15.5 24.7 9.7 38.1l-41 93.8c-.5 1.1-.8 2.2-1 3.3L125.7 362.1l84-56c8.9-5.9 14.2-15.9 14.2-26.6l0-67.2zM424 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 424 0a56 56 0 1 0 0 112z"]
};
var faSnowboarding = faPersonSnowboarding;
var faSquareChevronRight = {
  prefix: 'fal',
  iconName: 'square-chevron-right',
  icon: [448, 512, ["chevron-square-right"], "f32b", "M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM315.3 267.3l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L281.4 256 180.7 155.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l112 112c6.2 6.2 6.2 16.4 0 22.6z"]
};
var faChevronSquareRight = faSquareChevronRight;
var faLacrosseStickBall = {
  prefix: 'fal',
  iconName: 'lacrosse-stick-ball',
  icon: [576, 512, [], "e3b6", "M344 32v0c-44.3 0-83.7 28.4-97.7 70.4l-.8 2.4c-6.2 18.8-14.3 43-31.6 64.2l-34.4 42c-12.6 15.4-19.5 34.7-19.5 54.7c0 47.7 38.7 86.3 86.3 86.3c19.9 0 39.2-6.9 54.7-19.5l42-34.4c21.1-17.3 45.2-25.3 64-31.5l1.8-.6 .8-.3 0 0c42-14 70.4-53.3 70.4-97.6l0-.1 0-.2 0-.1c0-28.8-18.4-62.8-45.6-90.1C407.2 50.4 373.2 32 344.4 32l-.2 0-.2 0zm.3-32C385.1 0 426.8 24.8 457 55s55 71.9 55 112.7l0 .3c0 58.1-37.2 109.7-92.3 128.1l-.8 .3c-19.8 6.6-39.1 13-55.6 26.5l-42 34.4c-21.1 17.3-47.6 26.7-74.9 26.7c-26.9 0-51.7-9-71.6-24.1L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L152.1 337.3C137 317.4 128 292.6 128 265.7c0-27.3 9.5-53.8 26.7-74.9l34.4-42c13.5-16.5 19.9-35.8 26.5-55.6l0 0 .3-.8C234.3 37.2 285.9 0 344 0l.3 0zM544 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faTruckFast = {
  prefix: 'fal',
  iconName: 'truck-fast',
  icon: [640, 512, ["shipping-fast"], "f48b", "M128 32H352c17.7 0 32 14.3 32 32V384H250.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4V288H64v96 32c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H416V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V64c0-17.7 14.3-32 32-32zM570.9 224H416V128h65.3c4.7 0 9.1 2 12.1 5.6L570.9 224zM416 256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4V256zM96 416a64 64 0 1 1 128 0A64 64 0 1 1 96 416zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM48 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zM16 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faShippingFast = faTruckFast;
var faUserMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'user-magnifying-glass',
  icon: [640, 512, [], "e5c5", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM32 480c1.2-79.7 66.2-144 146.3-144h91.4c6.5 0 12.9 .4 19.2 1.2c-.6-5.7-.9-11.4-.9-17.2c0-5.1 .2-10.1 .7-15c-6.2-.7-12.6-1-19-1H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-.8 0-1.5 0-2.3H416 192 32zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm224-31.9a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9l86.2 86.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-86.2-86.2C566 377 576 349.7 576 320.2c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
var faStarSharp = {
  prefix: 'fal',
  iconName: 'star-sharp',
  icon: [576, 512, [], "e28b", "M288 43.6L239.2 196.9C237.1 203.5 231 208 224 208H75.3l126 91c5.5 4 7.9 11.1 5.9 17.6L163.5 460.6l114.7-89.2c5.8-4.5 13.9-4.5 19.6 0l114.7 89.2L368.7 316.7c-2-6.5 .4-13.6 5.9-17.6l126-91H352c-7 0-13.1-4.5-15.2-11.1L288 43.6zM262.3 18.8C265.9 7.6 276.3 0 288 0s22.1 7.6 25.7 18.8l50 157.2H517.4c14.7 0 26.6 11.9 26.6 26.6c0 8.5-4.1 16.6-11 21.6L402.6 318.3l50.8 167c4.1 13.3-5.9 26.8-19.8 26.8c-4.6 0-9.1-1.5-12.7-4.4L288 404.3 155.1 507.6c-3.6 2.8-8.1 4.4-12.7 4.4c-13.9 0-23.9-13.4-19.8-26.8l50.8-167L43 224.1c-6.9-5-11-13-11-21.6C32 187.9 43.9 176 58.6 176H212.3l50-157.2z"]
};
var faCommentHeart = {
  prefix: 'fal',
  iconName: 'comment-heart',
  icon: [512, 512, [], "e5c8", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM176 221.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L256 313.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM205.3 160c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faCircle1 = {
  prefix: 'fal',
  iconName: 'circle-1',
  icon: [512, 512, [], "e0ee", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 130.2c4.9 2.9 8 8.1 8 13.8V352h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H256 192c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V171.6l-32.1 18.3c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l56-32c5-2.8 11-2.8 16 .1z"]
};
var faCircleStar = {
  prefix: 'fal',
  iconName: 'circle-star',
  icon: [512, 512, ["star-circle"], "e123", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.3-399.1c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L256 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4zm-40 95.1L256 156.2l25.6 51.9c2.3 4.7 6.8 8 12 8.8l57.3 8.3-41.5 40.4c-3.8 3.7-5.5 9-4.6 14.2l9.8 57.1-51.2-26.9c-4.7-2.5-10.2-2.5-14.9 0l-51.2 26.9 9.8-57.1c.9-5.2-.8-10.5-4.6-14.2L161 225.1l57.3-8.3c5.2-.8 9.7-4 12-8.8z"]
};
var faStarCircle = faCircleStar;
var faFish = {
  prefix: 'fal',
  iconName: 'fish',
  icon: [576, 512, [128031], "f578", "M162.4 306.8c11.1 13.4 24.1 26.8 38.7 39.2c35.5 30 81.4 54 134.8 54s99.3-24 134.8-54c35.5-30 60.8-66 73.2-90c-12.4-24-37.6-60-73.2-90c-35.5-30-81.4-54-134.8-54s-99.3 24-134.8 54c-14.6 12.4-27.6 25.8-38.7 39.2L145.1 226l-23.4-13.6L32 160l45.8 80.1L86.9 256l-9.1 15.9L32 352l89.7-52.3L145.1 286l17.3 20.8zM4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1zM416 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCloudFog = {
  prefix: 'fal',
  iconName: 'cloud-fog',
  icon: [640, 512, [127787, "fog"], "f74e", "M160 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H168c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM576 216c0-55.2-43-100.3-97.3-103.8C471.2 66.7 431.6 32 384 32c-19.3 0-37.3 5.7-52.4 15.5C311.3 18.8 277.9 0 240 0C178.1 0 128 50.1 128 112c0 2.6 .1 5.3 .3 7.9C90.6 135.5 64 172.6 64 216c0 57.4 46.6 104 104 104H472c57.4 0 104-46.6 104-104zM0 400c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm64 96c0 8.8 7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm224 0c0 8.8 7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16z"]
};
var faFog = faCloudFog;
var faWaffle = {
  prefix: 'fal',
  iconName: 'waffle',
  icon: [512, 512, [129479], "e466", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 80v64h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H368v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H368v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H368v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H272v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H176v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V272H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V176H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32l64 0V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm-96 96v64h64V176l-64 0zm0 96v64h64V272H176zm96 0v64h64V272H272zm0-32h64V176H272v64z"]
};
var faMusicNote = {
  prefix: 'fal',
  iconName: 'music-note',
  icon: [384, 512, ["music-alt"], "f8cf", "M384 23.1C384 10.3 373.7 0 360.9 0c-2 0-4 .3-5.9 .8L203.9 40.5c-7 1.8-11.9 8.2-11.9 15.5V376c-20.3-14.8-48.7-24-80-24C50.1 352 0 387.8 0 432s50.1 80 112 80s112-35.8 112-80V189.1l147.9-37.6c7.1-1.8 12.1-8.2 12.1-15.5V23.1zM192 432c0 9.1-5.1 20.3-19.4 30.5C158.3 472.7 137 480 112 480s-46.3-7.3-60.6-17.5C37.1 452.3 32 441.1 32 432s5.1-20.3 19.4-30.5C65.7 391.3 87 384 112 384s46.3 7.3 60.6 17.5C186.9 411.7 192 422.9 192 432zM352 123.6L224 156.1V68.3L352 34.6v88.9z"]
};
var faMusicAlt = faMusicNote;
var faHexagonExclamation = {
  prefix: 'fal',
  iconName: 'hexagon-exclamation',
  icon: [512, 512, [], "e417", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM256 128c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCartShoppingFast = {
  prefix: 'fal',
  iconName: 'cart-shopping-fast',
  icon: [640, 512, [], "e0dc", "M64 16C64 7.2 71.2 0 80 0h37.9c20.6 0 38.6 13 45.3 32H603.5c20.8 0 36.1 19.6 31 39.8L592.6 239.5C585.5 268 559.9 288 530.5 288H216l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H255.2c-30.4 0-56.6-21.4-62.7-51.2l-58.9-288C132 37.3 125.5 32 117.9 32H80c-8.8 0-16-7.2-16-16zM530.5 256c14.7 0 27.5-10 31-24.2L603.5 64H170.1l39.3 192H530.5zM256 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM16 128h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faObjectUnion = {
  prefix: 'fal',
  iconName: 'object-union',
  icon: [512, 512, [], "e49f", "M160 320c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H352c-17.7 0-32-14.3-32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V288c0 17.7 14.3 32 32 32h96zm-32 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64v64 32h32 64c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V384 352H128z"]
};
var faUserGraduate = {
  prefix: 'fal',
  iconName: 'user-graduate',
  icon: [448, 512, [], "f501", "M228.7 .7c-3.1-.9-6.3-.9-9.4 0l-208 64C4.6 66.8 0 73 0 80s4.6 13.2 11.3 15.3L32 101.7v71.7L.8 266.9C-.8 271.8 0 277.2 3 281.4s7.8 6.6 13 6.6H80c5.1 0 10-2.5 13-6.6s3.8-9.5 2.2-14.4L64 173.4V111.5l155.3 47.8c3.1 .9 6.3 .9 9.4 0l208-64C443.4 93.2 448 87 448 80s-4.6-13.2-11.3-15.3l-208-64zM224 127.3L70.4 80 224 32.7 377.6 80 224 127.3zM188.1 439.8c19.1 21.5 52.7 21.5 71.8 0l71.1-80c49.2 18 84.4 65 85 120.2H32c.5-55.2 35.7-102.3 85-120.2l71.1 80zM109.6 328.4C45.9 350 0 410.3 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-71-45.9-131.3-109.6-152.8c-10.9-3.7-22.7 .4-30.3 9L236 418.5c-6.4 7.2-17.6 7.2-23.9 0l-72.1-81.1c-7.6-8.6-19.4-12.7-30.3-9zM48 226.6L57.8 256H38.2L48 226.6zm48-71.8V176c0 70.7 57.3 128 128 128s128-57.3 128-128V154.8l-32 9.8V176c0 53-43 96-96 96s-96-43-96-96V164.7l-32-9.8z"]
};
var faStarfighter = {
  prefix: 'fal',
  iconName: 'starfighter',
  icon: [640, 512, [], "e037", "M269.6 35.2L240.1 278.1l-.1 1v1V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V280v-1l-.1-1L370.4 35.2C368 15.1 351 0 330.7 0H309.3C289 0 272 15.1 269.6 35.2zM309.3 32h21.5c4 0 7.5 3 7.9 7L368 281V432c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16V281L301.3 39c.5-4 3.9-7 7.9-7zM64 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32V448c0 8.8 7.2 16 16 16s16-7.2 16-16V428.7l72.1 30c8.6 12.8 23.3 21.3 39.9 21.3h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V464c0-8.8-7.2-16-16-16H176c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-26.5 0-48 21.5-48 48v16H64V160H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V96zm0 298V352h64v68.7L64 394zM608 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V320H512V304c0-26.5-21.5-48-48-48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V480h16c16.6 0 31.3-8.4 39.9-21.3l72.1-30V448c0 8.8 7.2 16 16 16s16-7.2 16-16V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V96zM512 352h64v42l-64 26.7V352zM320 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"]
};
var faCircleHalfStroke = {
  prefix: 'fal',
  iconName: 'circle-half-stroke',
  icon: [512, 512, [9680, "adjust"], "f042", "M240 479.4V32.6C123.8 40.8 32 137.7 32 256s91.8 215.2 208 223.4zM480 256c0-118.3-91.8-215.2-208-223.4V479.4C388.2 471.2 480 374.3 480 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faAdjust = faCircleHalfStroke;
var faArrowRightLongToLine = {
  prefix: 'fal',
  iconName: 'arrow-right-long-to-line',
  icon: [640, 512, [], "e3d5", "M640 80V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zM507.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 272 16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l441.4 0L340.7 123.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l144 144z"]
};
var faSquareArrowDown = {
  prefix: 'fal',
  iconName: 'square-arrow-down',
  icon: [448, 512, ["arrow-square-down"], "f339", "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm235.3-36.7l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 329.4V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V329.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0z"]
};
var faArrowSquareDown = faSquareArrowDown;
var faDiamondHalfStroke = {
  prefix: 'fal',
  iconName: 'diamond-half-stroke',
  icon: [512, 512, [], "e5b8", "M272 44.7V467.3L477.7 261.7c3.1-3.1 3.1-8.2 0-11.3L272 44.7zM240 467.3V44.7L34.3 250.3c-3.1 3.1-3.1 8.2 0 11.3L240 467.3zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216z"]
};
var faClapperboard = {
  prefix: 'fal',
  iconName: 'clapperboard',
  icon: [512, 512, [], "e131", "M32 192V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192H32zm350.6-32H480V96c0-9.2-3.9-17.5-10.1-23.3L382.6 160zm-45.3 0l96-96H326.6l-96 96H337.4zm-56-96H174.6l-96 96H185.4l96-96zm-152 0H64C46.3 64 32 78.3 32 96v64h1.4l96-96zM512 96v64 16 16V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 176 160 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64z"]
};
var faSquareChevronLeft = {
  prefix: 'fal',
  iconName: 'square-chevron-left',
  icon: [448, 512, ["chevron-square-left"], "f32a", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm68.7-235.3l112-112c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L166.6 256 267.3 356.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-112-112c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faChevronSquareLeft = faSquareChevronLeft;
var faPhoneIntercom = {
  prefix: 'fal',
  iconName: 'phone-intercom',
  icon: [512, 512, [], "e434", "M80 64c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16H80zM48 32C21.5 32 0 53.5 0 80V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM448 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H448zM224 32c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H224zm32 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32-32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM256 128H416v96H256V128zm-32 0v96c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"]
};
var faLinkHorizontal = {
  prefix: 'fal',
  iconName: 'link-horizontal',
  icon: [640, 512, ["chain-horizontal"], "e1cb", "M128 64C57.3 64 0 121.3 0 192s57.3 128 128 128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96s43-96 96-96H304.1c52.9 0 95.9 42.9 95.9 95.9c0 50.3-38.9 92-89 95.6l-8.1 .6c-8.8 .6-15.4 8.3-14.8 17.1s8.3 15.4 17.1 14.8l8.1-.6C380.2 314.6 432 258.9 432 191.9C432 121.2 374.8 64 304.1 64H128zM512 448c70.7 0 128-57.3 128-128s-57.3-128-128-128H480c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c53 0 96 43 96 96s-43 96-96 96H335.9c-52.9 0-95.9-42.9-95.9-95.9c0-50.3 38.9-92 89-95.6l8.1-.6c8.8-.6 15.4-8.3 14.8-17.1s-8.3-15.4-17.1-14.8l-8.1 .6C259.8 197.4 208 253.1 208 320.1C208 390.8 265.2 448 335.9 448H512z"]
};
var faChainHorizontal = faLinkHorizontal;
var faMango = {
  prefix: 'fal',
  iconName: 'mango',
  icon: [512, 512, [], "e30f", "M416 112c-24.6 0-47-9.2-64-24.4v42.9 32.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c-41.3 0-82.7 14.5-114 43.4l-1.2 1.1-1.3 1c-39 29.3-58.5 59.9-78 92l-2.9 4.7c-18.6 30.9-39.6 65.5-79.4 93.2c-4.7 3.4-8 7.8-9.8 12.7c-4.3 11.8 1.8 27.7 19.9 33.3l1.3 .4 1.2 .5 0 0 0 0 0 0 0 0 .1 0 .6 .2c.6 .2 1.6 .6 2.9 1.1c2.7 1 6.8 2.4 12.2 4.2c10.9 3.5 27 8.2 47.6 13C160.3 470.4 218.9 480 288 480c73.4 0 120.4-29.5 149.7-65.2c30.3-37 42.3-81.4 42.3-109.6c0-36.4-15-73.2-45.9-101.8c-14.8-13.7-31.8-24.1-50.1-31.3V140c4 1 8 1.9 12.1 2.5c21.7 8.6 42 21.1 59.7 37.4c37.5 34.6 56.2 80 56.2 125.3C512 375.9 454.5 512 288 512c-144 0-244.1-39.9-244.1-39.9C10.3 461.8-7.9 428.4 3.3 397.4c4.1-11.5 11.8-21.1 21.4-28c34.3-23.8 52.1-53.2 71.2-84.7c20.6-34 42.6-70.4 88.4-104.8C221.7 145.3 270.9 128 320 128V16c0-8.8 7.2-16 16-16h24 60.7C471.1 0 512 40.9 512 91.3c0 11.4-9.3 20.7-20.7 20.7H472 416zm16 208c0 61.9-50.1 112-112 112c-8.8 0-16-7.2-16-16s7.2-16 16-16c44.2 0 80-35.8 80-80c0-8.8 7.2-16 16-16s16 7.2 16 16zM354 32c7.1 27.6 32.2 48 62 48h56 6.9c-5.3-27.3-29.3-48-58.2-48H360h-6z"]
};
var faMusicNoteSlash = {
  prefix: 'fal',
  iconName: 'music-note-slash',
  icon: [640, 512, ["music-alt-slash"], "f8d0", "M352 189.1l147.9-37.6c7.1-1.8 12.1-8.2 12.1-15.5V23.1C512 10.3 501.7 0 488.9 0c-2 0-4 .3-5.9 .8L331.9 40.5c-7 1.8-11.9 8.2-11.9 15.5V174.5l32 25.3V189.1zM320 337.5V376c-20.3-14.8-48.7-24-80-24c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V362.8l-32-25.3zm0 94.5c0 9.1-5.1 20.3-19.4 30.5C286.3 472.7 265 480 240 480s-46.3-7.3-60.6-17.5C165.1 452.3 160 441.1 160 432s5.1-20.3 19.4-30.5C193.7 391.3 215 384 240 384s46.3 7.3 60.6 17.5C314.9 411.7 320 422.9 320 432zM480 123.6L352 156.1V68.3L480 34.6v88.9zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faMusicAltSlash = faMusicNoteSlash;
var faCircleRadiation = {
  prefix: 'fal',
  iconName: 'circle-radiation',
  icon: [512, 512, [9762, "radiation-alt"], "f7ba", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160.6 148.1c2.4-2.1 5.3-2.8 8.4-2c3.3 .8 6.9 3.2 9.1 7.1l37.2 64.4c7.4-7.8 16.9-13.5 27.7-16l-37.2-64.4c-12.7-22-43.9-32.9-66.4-13c-28.1 24.9-48.2 58.6-56 96.9c-5.9 29.4 19.1 51 44.5 51h74.3c-1.5-5.1-2.3-10.4-2.3-16s.8-10.9 2.3-16H128c-4.5 0-8.4-1.9-10.7-4.4c-2.2-2.3-3.1-5.1-2.5-8.3c6.3-31.3 22.7-58.9 45.8-79.3zm54.7 146.4l-37.2 64.4c-12.7 22-6.6 54.4 21.9 64c17.6 5.9 36.5 9.1 56 9.1s38.4-3.2 56-9.1c28.5-9.6 34.6-42 21.9-64l-37.2-64.4c-7.4 7.8-16.9 13.5-27.7 16l37.2 64.4c2.3 3.9 2.6 8.2 1.6 11.4c-.9 3.1-2.9 5.2-5.9 6.2c-14.4 4.8-29.8 7.4-45.8 7.4s-31.5-2.6-45.8-7.4c-3-1-5-3.2-5.9-6.2c-1-3.3-.7-7.5 1.6-11.4L243 310.5c-10.8-2.6-20.3-8.2-27.7-16zM309.7 272H384c25.4 0 50.5-21.5 44.5-51c-7.7-38.3-27.8-72.1-56-96.9c-22.5-19.9-53.7-9-66.4 13L269 201.5c10.8 2.6 20.3 8.2 27.7 16l37.2-64.4c2.3-3.9 5.8-6.3 9.1-7.1c3.1-.7 6-.1 8.4 2c23.1 20.4 39.5 48 45.8 79.3c.6 3.1-.3 5.9-2.5 8.3c-2.3 2.5-6.2 4.4-10.7 4.4H309.7c1.5 5.1 2.3 10.4 2.3 16s-.8 10.9-2.3 16zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faRadiationAlt = faCircleRadiation;
var faFaceTongueSweat = {
  prefix: 'fal',
  iconName: 'face-tongue-sweat',
  icon: [576, 512, [], "e39e", "M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256c0 83.8-40.2 158.1-102.4 204.8C398.8 492.9 345.6 512 288 512s-110.8-19.1-153.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2c15.6 11.8 32.9 21.5 51.3 28.9c-8.1-13.9-12.8-30.1-12.9-47.3c-10.2-7.2-16-15.7-16-24.7c0-26.5 50.1-48 112-48s112 21.5 112 48c0 9-5.8 17.5-16 24.7c-.1 17.2-4.8 33.4-12.9 47.3c18.4-7.4 35.7-17.1 51.3-28.9C476.8 394.3 512 329.3 512 256C512 132.3 411.7 32 288 32zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.5c0 .2 0 .2 0 .1C32 385.5 43.7 400 64 400s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.1-.7-.8-3.7-3.4-9.6c-3-6.7-7.4-14.5-12.8-23.1c-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0c17.6 21.7 55.5 72.2 55.5 97.2c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 38.1-75.5 55.5-97.2zM367.6 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-136 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM211.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm153.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM224 417.6c0 34.5 27.9 62.4 62.4 62.4h3.2c34.5 0 62.4-27.9 62.4-62.4V403c0-14.9-12.1-27-27-27h-2.5c-10.9 0-20.4 7.4-23 18c-3 12-20 12-23 0c-2.6-10.6-12.1-18-23-18H251c-14.9 0-27 12.1-27 27v14.6z"]
};
var faGlobeStand = {
  prefix: 'fal',
  iconName: 'globe-stand',
  icon: [448, 512, [], "f5f6", "M28.7 348.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l10-10C99 394.1 145.1 412.1 192 415.4V480H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V415.4c51.9-3.7 102.7-25.4 142.4-65c83.7-83.7 87.3-217.1 10.9-305.1l10-10c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L343.8 33.6c-6.2 6.2-6.2 16.4 0 22.6c75 75 75 196.5 0 271.5s-196.5 75-271.5 0c-6.2-6.2-16.4-6.2-22.6 0L28.7 348.7zM80 192a128 128 0 1 1 256 0A128 128 0 1 1 80 192zm288 0A160 160 0 1 0 48 192a160 160 0 1 0 320 0z"]
};
var faBaseball = {
  prefix: 'fal',
  iconName: 'baseball',
  icon: [512, 512, [129358, 9918, "baseball-ball"], "f433", "M256.6 480c-.4-5.3-.6-10.6-.6-16c0-5.8 .2-11.6 .7-17.3c.7-8.8 8.5-15.4 17.3-14.6s15.4 8.5 14.6 17.3c-.4 4.8-.6 9.7-.6 14.7c0 4.6 .2 9.1 .5 13.7c97.7-14.2 174.9-91.5 189.1-189.1c-4.5-.3-9.1-.5-13.7-.5c-4.9 0-9.8 .2-14.7 .6c-8.8 .7-16.5-5.8-17.3-14.6s5.8-16.5 14.6-17.3c5.7-.5 11.5-.7 17.3-.7c5.4 0 10.7 .2 16 .6c0-.2 0-.4 0-.6C480 132.3 379.7 32 256 32c-.2 0-.4 0-.6 0c.4 5.3 .6 10.6 .6 16c0 5.8-.2 11.6-.7 17.3c-.7 8.8-8.5 15.4-17.3 14.6s-15.4-8.5-14.6-17.3c.4-4.8 .6-9.7 .6-14.7c0-4.6-.2-9.1-.5-13.7C125.8 48.6 48.6 125.8 34.3 223.5c4.5 .3 9.1 .5 13.7 .5c4.9 0 9.8-.2 14.7-.6c8.8-.7 16.5 5.8 17.3 14.6s-5.8 16.5-14.6 17.3c-5.7 .5-11.5 .7-17.3 .7c-5.4 0-10.7-.2-16-.6c0 .2 0 .4 0 .6c0 123.7 100.3 224 224 224c.2 0 .4 0 .6 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm121.3-48c38.3-17.6 69.2-48.5 86.7-86.7c3.7-8 13.2-11.6 21.2-7.9s11.6 13.2 7.9 21.2c-20.8 45.2-57.2 81.7-102.5 102.5c-8 3.7-17.5 .2-21.2-7.9s-.2-17.5 7.9-21.2zM390.7 304c-38.3 17.6-69.2 48.5-86.7 86.7c-3.7 8-13.2 11.6-21.2 7.9s-11.6-13.2-7.9-21.2c20.8-45.2 57.2-81.7 102.5-102.5c8-3.7 17.5-.2 21.2 7.9s.2 17.5-7.9 21.2z"]
};
var faBaseballBall = faBaseball;
var faCircleP = {
  prefix: 'fal',
  iconName: 'circle-p',
  icon: [512, 512, [], "e11a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16V288v80c0 8.8 7.2 16 16 16s16-7.2 16-16V304h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H176zm88 144H192V160h72c30.9 0 56 25.1 56 56s-25.1 56-56 56z"]
};
var faAwardSimple = {
  prefix: 'fal',
  iconName: 'award-simple',
  icon: [384, 512, [], "e0ab", "M166.5 7.2c15.7-9.5 35.3-9.5 51 0l16.4 10c2.8 1.7 6 2.6 9.3 2.5l19.2-.5c18.3-.4 35.4 9.4 44.2 25.5l9.2 16.8c1.6 2.9 3.9 5.2 6.8 6.8l16.8 9.2c16.1 8.8 25.9 25.8 25.5 44.2l-.5 19.2c-.1 3.3 .8 6.5 2.5 9.3l10 16.4c9.5 15.7 9.5 35.3 0 51l-10 16.4c-1.7 2.8-2.6 6-2.5 9.3l.5 19.2c.4 18.3-9.4 35.4-25.5 44.2l-16.8 9.2c-2.9 1.6-5.2 3.9-6.8 6.8l-9.2 16.8c-8.8 16.1-25.8 25.9-44.2 25.5l-19.2-.5c-3.3-.1-6.5 .8-9.3 2.5l-16.4 10c-15.7 9.5-35.3 9.5-51 0l-16.4-10c-2.8-1.7-6-2.6-9.3-2.5l-19.2 .5c-18.3 .4-35.4-9.4-44.2-25.5l-9.2-16.8c-1.6-2.9-3.9-5.2-6.8-6.8l-16.8-9.2c-16.1-8.8-25.9-25.8-25.5-44.2l.5-19.2c.1-3.3-.8-6.5-2.5-9.3l-10-16.4c-9.5-15.7-9.5-35.3 0-51l10-16.4 13.7 8.3-13.7-8.3c1.7-2.8 2.6-6 2.5-9.3l-.5-19.2c-.4-18.3 9.4-35.4 25.5-44.2l16.8-9.2c2.9-1.6 5.2-3.9 6.8-6.8l9.2-16.8c8.8-16.1 25.8-25.9 44.2-25.5l19.2 .5c3.3 .1 6.5-.8 9.3-2.5l16.4-10zm34.4 27.3c-5.4-3.3-12.3-3.3-17.7 0l-16.4 10c-8 4.9-17.3 7.4-26.7 7.1l-19.2-.5c-6.4-.2-12.3 3.3-15.3 8.9L96.4 76.9c-4.5 8.2-11.3 15-19.5 19.5L60 105.6c-5.6 3.1-9 9-8.9 15.3l.5 19.2c.2 9.4-2.3 18.6-7.1 26.7l-10 16.4c-3.3 5.4-3.3 12.3 0 17.7l10 16.4c4.9 8 7.4 17.3 7.1 26.7l-.5 19.2c-.2 6.4 3.3 12.3 8.9 15.3l16.8 9.2c8.2 4.5 15 11.3 19.5 19.5l9.2 16.8c3.1 5.6 9 9 15.3 8.9l19.2-.5c9.4-.2 18.6 2.3 26.7 7.1l16.4 10c5.4 3.3 12.3 3.3 17.7 0l16.4-10c8-4.9 17.3-7.4 26.7-7.1l19.2 .5c6.4 .2 12.3-3.3 15.3-8.9l9.2-16.8c4.5-8.2 11.3-15 19.5-19.5l16.8-9.2c5.6-3.1 9-9 8.9-15.3l-.5-19.2c-.2-9.4 2.3-18.6 7.1-26.7l10-16.4c3.3-5.4 3.3-12.3 0-17.7l-10-16.4c-4.9-8-7.4-17.3-7.1-26.7l.5-19.2c.2-6.4-3.3-12.3-8.9-15.3l-16.8-9.2c-8.2-4.5-15-11.3-19.5-19.5L278.4 60c-3.1-5.6-9-9-15.3-8.9l-19.2 .5c-9.4 .2-18.6-2.3-26.7-7.1l-16.4-10zM192 136a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm88 56a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zM88 390c9.7 4.3 20.3 6.6 31.3 6.8l-16.6 72 83-35.6c4-1.7 8.6-1.7 12.6 0l83 35.6-16.6-72c10.9-.2 21.5-2.5 31.3-6.8l23.6 102.4c1.4 5.9-.7 12-5.3 15.9s-11 4.8-16.6 2.4L192 465.4 86.3 510.7c-5.5 2.4-11.9 1.4-16.6-2.4s-6.7-10-5.3-15.9L88 390z"]
};
var faJetFighterUp = {
  prefix: 'fal',
  iconName: 'jet-fighter-up',
  icon: [512, 512, [], "e518", "M270.6 9.5C268.1 3.7 262.3 0 256 0s-12.1 3.7-14.6 9.5L181.5 144.2c-3.6 8.2-5.5 17-5.5 26v40l-.4 .3L32 299.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v56 40 32c0 8.8 7.2 16 16 16s16-7.2 16-16V384H176v3.4l-42.2 66.8c-3.8 6-5.8 13-5.8 20.1c0 20.8 16.9 37.7 37.7 37.7H346.3c20.8 0 37.7-16.9 37.7-37.7c0-7.1-2-14.1-5.8-20.1L336 387.4V384H480v16c0 8.8 7.2 16 16 16s16-7.2 16-16V368 328 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v27.3L336.4 210.4l-.4-.3v-40c0-9-1.9-17.8-5.5-26L270.6 9.5zM480 352H336V247.8l144 89.1V352zm-304 0H32V336.9l144-89.1V352zm34.8-194.8L256 55.4l45.2 101.8c1.8 4.1 2.8 8.5 2.8 13V392c0 3 .9 6 2.5 8.5l44.6 70.7c.6 .9 .9 2 .9 3.1c0 3.2-2.6 5.7-5.7 5.7H272V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H165.7c-3.2 0-5.7-2.6-5.7-5.7c0-1.1 .3-2.1 .9-3.1l44.6-70.7c1.6-2.6 2.5-5.5 2.5-8.5V170.2c0-4.5 .9-8.9 2.8-13z"]
};
var faDiagramProject = {
  prefix: 'fal',
  iconName: 'diagram-project',
  icon: [576, 512, ["project-diagram"], "f542", "M136 64c13.3 0 24 10.7 24 24v24 32 24c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24h80zm56 104V144H384v24c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56H440c-30.9 0-56 25.1-56 56v24H192V88c0-30.9-25.1-56-56-56H56C25.1 32 0 57.1 0 88v80c0 30.9 25.1 56 56 56h80c8.6 0 16.7-1.9 24-5.4l72.2 96.3c-5.2 8.5-8.2 18.5-8.2 29.1v80c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V344c0-30.9-25.1-56-56-56H280c-8.6 0-16.7 1.9-24 5.4l-72.2-96.3c5.2-8.5 8.2-18.5 8.2-29.1zm224 0V144 112 88c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zM360 320c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H280c-13.3 0-24-10.7-24-24V344c0-13.3 10.7-24 24-24h80z"]
};
var faProjectDiagram = faDiagramProject;
var faPedestal = {
  prefix: 'fal',
  iconName: 'pedestal',
  icon: [448, 512, [], "e20d", "M352 32H96C78.3 32 64 46.3 64 64V448H32V64C32 28.7 60.7 0 96 0H352c35.3 0 64 28.7 64 64V448H384V64c0-17.7-14.3-32-32-32zM16 480H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM320 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faChartPyramid = {
  prefix: 'fal',
  iconName: 'chart-pyramid',
  icon: [512, 512, [], "e0e6", "M269.8 87.7c-6.2-10.6-21.5-10.6-27.6 0L181.3 192H330.7L269.8 87.7zM106.7 320H405.3l-56-96H162.7l-56 96zM88 352L46 423.9C39.8 434.6 47.5 448 59.9 448H452.1c12.3 0 20-13.4 13.8-24.1L424 352H88zM214.5 71.6c18.5-31.8 64.4-31.8 82.9 0L493.6 407.8c18.7 32-4.4 72.2-41.5 72.2H59.9c-37 0-60.1-40.2-41.5-72.2L214.5 71.6z"]
};
var faSidebar = {
  prefix: 'fal',
  iconName: 'sidebar',
  icon: [512, 512, [], "e24e", "M448 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H224V64H448zM64 64H192V448H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm0-32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM80 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zM64 176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faSnowmanHead = {
  prefix: 'fal',
  iconName: 'snowman-head',
  icon: [448, 512, ["frosty-head"], "f79b", "M128 32H320c17.7 0 32 14.3 32 32v96h32V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v96H96V64c0-17.7 14.3-32 32-32zM352 224h.7c29.3 31.4 47.3 73.6 47.3 120c0 52-22.5 98.8-58.5 131c-3 2.7-8.3 5-15.8 5H122.2c-7.5 0-12.7-2.2-15.8-5C70.5 442.8 48 396 48 344c0-46.4 17.9-88.6 47.3-120H96 352zM16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H54.1C30.1 257.9 16 299.3 16 344c0 61.5 26.7 116.8 69.1 154.8c10.1 9.1 23.6 13.2 37.1 13.2H325.8c13.6 0 27-4.1 37.1-13.2C405.3 460.8 432 405.5 432 344c0-44.7-14.1-86.1-38.1-120H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H384 352 96 64 16zM144 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 320c-26.5 0-48 21.5-48 48v1c0 6.9 1.4 13.6 4.2 19.9l29.2 65.6c2.6 5.8 8.3 9.5 14.6 9.5s12.1-3.7 14.6-9.5l29.2-65.6c2.8-6.3 4.2-13 4.2-19.9v-1c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v1c0 2.4-.5 4.7-1.5 6.9L224 408.6l-14.5-32.7c-1-2.2-1.5-4.5-1.5-6.9v-1z"]
};
var faFrostyHead = faSnowmanHead;
var faCopy = {
  prefix: 'fal',
  iconName: 'copy',
  icon: [512, 512, [], "f0c5", "M448 352H288c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H396.1c4.2 0 8.3 1.7 11.3 4.7l67.9 67.9c3 3 4.7 7.1 4.7 11.3V320c0 17.7-14.3 32-32 32zM497.9 81.9L430.1 14.1c-9-9-21.2-14.1-33.9-14.1H288c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V416H256v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H192V128H64z"]
};
var faBurgerGlass = {
  prefix: 'fal',
  iconName: 'burger-glass',
  icon: [640, 512, [], "e0ce", "M32.1 40.7L42.2 160H341.7L351.8 40.7c.4-4.7-3.3-8.7-8-8.7H40.1c-4.7 0-8.4 4-8 8.7zM44.9 192L66.7 450.7C68.1 467.3 81.9 480 98.6 480H260c3.7 11.9 9.7 22.7 17.6 32H98.6c-33.3 0-61-25.5-63.8-58.6L.2 43.4C-1.7 20 16.7 0 40.1 0H343.8c23.4 0 41.8 20 39.9 43.4L372.5 176.5c-12.2 4.7-23.4 10.1-33.5 16l0-.4H44.9zm286.1 87.4c-5.7 6.2-9.2 14.6-10.4 24.4h287c-1.2-9.8-4.7-18.2-10.4-24.4c-8.3-9-20.6-20.1-37.1-30.1c-.8 8.1-7.6 14.5-15.9 14.5c-8.8 0-16-7.2-16-16c0-4.6 1.9-8.7 5-11.6c-15.7-6.1-33.9-10.5-54.9-11.9c1.2 2.2 1.9 4.8 1.9 7.5c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7 .7-5.3 1.9-7.5c-21 1.4-39.2 5.9-54.9 11.9c3.1 2.9 5 7 5 11.6c0 8.8-7.2 16-16 16c-8.3 0-15.1-6.3-15.9-14.5c-16.6 10-28.8 21.1-37.1 30.1zM464 191.8c82 0 132.6 40 156.5 65.9c14.6 15.7 19.5 36.1 19.5 54.7c0 12.9-10.5 23.4-23.4 23.4H311.4c-12.9 0-23.4-10.5-23.4-23.4c0-18.7 4.9-39.1 19.5-54.7c24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3H602.7c20.6 0 37.3 16.7 37.3 37.3c0 32.4-26.3 58.7-58.7 58.7H346.7c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3c0 14.7 11.9 26.7 26.7 26.7H581.3c14.7 0 26.7-11.9 26.7-26.7c0-2.9-2.4-5.3-5.3-5.3H325.3z"]
};
var faVolumeXmark = {
  prefix: 'fal',
  iconName: 'volume-xmark',
  icon: [576, 512, ["volume-mute", "volume-times"], "f6a9", "M151.6 188L288 66.7V445.3L151.6 324c-2.9-2.6-6.7-4-10.6-4H56c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h85c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM411.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 256l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 278.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L502.6 256l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 233.4l-68.7-68.7z"]
};
var faVolumeMute = faVolumeXmark;
var faVolumeTimes = faVolumeXmark;
var faHandSparkles = {
  prefix: 'fal',
  iconName: 'hand-sparkles',
  icon: [640, 512, [], "e05d", "M328 0c-24.9 0-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8c-30.9 0-56 25.1-56 56V288.8l-32.4-32.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2L184.2 439.4C230.7 485.9 293.8 512 359.5 512H368c37.3 0 71.8-11.6 100.3-31.3c-9.6-5.5-17.4-13.7-22.3-23.6C423.5 471.6 396.7 480 368 480h-8.5c-57.3 0-112.2-22.8-152.7-63.3L103 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V80l0-.1V56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V87.9C384 74.7 394.8 64 408 64c13.3 0 24 10.7 24 24v64l0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V151.9c0-13.2 10.8-23.9 24-23.9c13.3 0 24 10.7 24 24V336c0 1.1 0 2.1 0 3.2c7.1-11.9 18.5-20.9 32-24.9V152c0-30.9-25.1-56-56-56c-8.6 0-16.7 1.9-24 5.4V88c0-30.9-25.1-56-56-56c-9.7 0-18.8 2.5-26.7 6.8C374 16.3 352.9 0 328 0zM96 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v32c0 8.8 7.2 16 16 16s16-7.2 16-16V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V80zM336 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V368h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V304zm240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H496c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H576V368z"]
};
var faBarsFilter = {
  prefix: 'fal',
  iconName: 'bars-filter',
  icon: [448, 512, [], "e0ad", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM64 240c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zM288 400c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16z"]
};
var faPaintbrushPencil = {
  prefix: 'fal',
  iconName: 'paintbrush-pencil',
  icon: [576, 512, [], "e206", "M534.5 86.6L369.9 251.3 324.6 206 489.3 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM347.3 273.9l-36.6 36.6-36.1 36.1 0 0-4.6 4.6L224.6 306l40.7-40.7 0 0L302 228.6l45.3 45.3zM176 320c6.9 0 13.5 .9 19.9 2.5l57.7 57.7c1.6 6.3 2.5 13 2.5 19.9c0 44.2-35.8 80-80 80H36.8C58 480 74.3 468.5 84 455.1c9.5-13.1 14.2-30 12.5-46.7c-.3-2.7-.4-5.5-.4-8.3c0-44.2 35.8-80 80-80zm110.3 60.2L557.2 109.3c25-25 25-65.5 0-90.5s-65.5-25-90.5 0l-271 271c-6.4-1.1-13-1.7-19.7-1.7c-61.9 0-112 50.1-112 112c0 3.9 .2 7.8 .6 11.6C66.4 429.1 54.4 448 36.8 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H176c61.9 0 112-50.1 112-112c0-6.8-.6-13.4-1.7-19.8zM170.8 17C148.9-4.9 113.5-4.9 91.6 17L49 59.6c-21.9 21.9-21.9 57.3 0 79.2L166.5 256.3c3.1-.2 6.3-.3 9.5-.3c2.7 0 5.3 .1 7.9 .2l13.9-13.9L149 193.6 225.6 117l48.8 48.8L297 143.2 170.8 17zM410.1 301.6l50.8 50.8c7.6 7.6 13.1 16.9 16.1 27.2l27.3 92.8-92.8-27.3c-10.3-3-19.6-8.6-27.2-16.1l-50.8-50.8-13.8 13.8c.1 2.7 .2 5.4 .2 8.1c0 3.2-.1 6.4-.3 9.5l42 42c11.4 11.4 25.4 19.7 40.8 24.2l121 35.6c5.6 1.7 11.7 .1 15.8-4s5.7-10.2 4-15.8l-35.6-121c-4.5-15.4-12.9-29.4-24.2-40.8l-50.8-50.8-22.6 22.6zM114.2 39.6c9.4-9.4 24.6-9.4 33.9 0L203 94.4 126.4 171 71.6 116.2c-9.4-9.4-9.4-24.6 0-33.9l42.6-42.6z"]
};
var faPartyBell = {
  prefix: 'fal',
  iconName: 'party-bell',
  icon: [512, 512, [], "e31a", "M32 224C32 118 118 32 224 32c30.3 0 59 7 84.5 19.6c7.1 3.5 11.5 11 11.5 19.1c0 6-2.4 11.7-6.6 15.9L86.6 313.4c-4.2 4.2-9.9 6.6-15.9 6.6c-8.1 0-15.6-4.3-19.1-11.5C39 283 32 254.3 32 224zM224 0C100.3 0 0 100.3 0 224c0 35.3 8.2 68.9 22.8 98.7C32.3 341.9 51.7 352 70.7 352c14.5 0 28.3-5.7 38.5-16L336 109.2c10.2-10.2 16-24.1 16-38.5c0-19-10.1-38.4-29.3-47.8C292.9 8.2 259.3 0 224 0zM480 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM352 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM40 480a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM364.7 172.7c-6.2 6.2-6.2 16.4 0 22.6l8.3 8.3c23.1 23.1 53.4 37.7 85.9 41.3l27.4 3c8.8 1 16.7-5.4 17.7-14.1s-5.4-16.7-14.1-17.7l-27.4-3c-25.3-2.8-48.8-14.1-66.8-32.1l-8.2-8.3c-6.2-6.2-16.4-6.2-22.6 0zm-169.4 192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l8.3 8.2c18 18 29.3 41.6 32.1 66.8l3 27.4c1 8.8 8.9 15.1 17.7 14.1s15.1-8.9 14.1-17.7l-3-27.4c-3.6-32.5-18.2-62.8-41.3-85.9l-8.3-8.3zm303 135.5c6.7-5.7 7.6-15.8 1.9-22.6l-8.5-10c-6.2-7.3-9.4-16.6-9.2-26.1c1-38.2-28.5-70.4-66.6-72.6l-30-1.8c-20.9-1.2-37.1-18.8-36.5-39.8c.5-17.4-5.5-34.4-16.7-47.7l-8.5-10c-5.7-6.7-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5l8.5 10c6.2 7.3 9.4 16.6 9.2 26.1c-1 38.2 28.5 70.4 66.6 72.6l30 1.8c20.9 1.2 37.1 18.8 36.5 39.8c-.5 17.4 5.5 34.4 16.7 47.7l8.5 10c5.7 6.7 15.8 7.6 22.6 1.9z"]
};
var faUserVneckHair = {
  prefix: 'fal',
  iconName: 'user-vneck-hair',
  icon: [448, 512, [], "e462", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM228.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zm89.6 290.1l-57.2-76.3C72.6 358.8 32 410.7 32 472l0 8H416v-8c0-61.3-40.6-113.2-96.4-130.2l-57.2 76.3c-19.2 25.6-57.6 25.6-76.8 0zM132.1 307.8c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.2z"]
};
var faJackOLantern = {
  prefix: 'fal',
  iconName: 'jack-o-lantern',
  icon: [576, 512, [127875], "f30e", "M272.6 96.7c-13.2 1.1-26.1 3.8-38.3 7.7l41.1-94c2.8-6.3 9-10.4 15.8-10.4h1.2c2.3 0 4.7 .5 6.8 1.4l42.3 18.1c6.4 2.7 10.5 9 10.5 15.9V108c-10.2-4-20.9-7.1-32-9.1V45.1l-20.9-9L272.6 96.7zm-94.7 38c-4 3.2-7.3 6.9-10 10.9c-5.3-1-10.6-1.5-16-1.5c-31.3 0-60.9 17.1-83.3 47.4S32 264.3 32 312s14.3 90.3 36.7 120.6s52 47.4 83.3 47.4c20.7 0 40.6-7.5 58.1-21.2c5.8-4.5 13.9-4.5 19.7 0C247.4 472.5 267.3 480 288 480s40.6-7.5 58.1-21.2c5.8-4.5 13.9-4.5 19.7 0C383.4 472.5 403.3 480 424 480c31.3 0 60.9-17.1 83.3-47.4S544 359.7 544 312s-14.3-90.3-36.7-120.6s-52-47.4-83.3-47.4c-5.4 0-10.8 .5-16 1.5c-2.7-4-6-7.7-10-10.9c-6.2-4.9-12.7-9.5-19.5-13.6c14.3-5.8 29.5-9 45.5-9c43.8 0 82.2 24.1 109 60.4s43 85.7 43 139.6s-16.1 103.3-43 139.6S467.8 512 424 512c-24.7 0-47.8-7.7-68-20.9c-20.2 13.3-43.3 20.9-68 20.9s-47.8-7.7-68-20.9c-20.2 13.3-43.3 20.9-68 20.9c-43.8 0-82.2-24.1-109-60.4S0 365.9 0 312s16.1-103.3 43-139.6S108.2 112 152 112c15.9 0 31.2 3.2 45.5 9c-6.8 4.1-13.3 8.6-19.5 13.6zm40 49.9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5c24.6-19.8 56-31.6 90-31.6s65.4 11.8 90 31.6c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5c-19.2-15.4-43.5-24.6-70-24.6s-50.8 9.2-70 24.6zm2.5 29.4l32 40c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5L208 249.6 188.5 274c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l32-40c3-3.8 7.6-6 12.5-6s9.5 2.2 12.5 6zm160 0l32 40c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5L368 249.6 348.5 274c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l32-40c3-3.8 7.6-6 12.5-6s9.5 2.2 12.5 6zm55.3 76c12.7-7.5 30.1-6.6 41.6 4.9c7.1 7.1 11.3 18.1 8 29.6c-4.3 14.8-16 44-46.1 69.4C409 419.4 361.5 440 288 440s-121-20.6-151.4-46.2c-30.1-25.4-41.9-54.6-46.1-69.4c-3.3-11.5 1-22.5 8-29.6c11.5-11.5 28.9-12.4 41.6-4.9c21.5 12.6 73.9 38 147.8 38s126.4-25.4 147.8-38zm18.1 27.2c-.6-.1-1.3 .1-1.9 .4C427.3 332.1 369.3 360 288 360c-5.4 0-10.8-.1-16-.4V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V356.7c-56.2-7.8-96.5-27.6-116.1-39.1c-.6-.3-1.3-.5-1.9-.4c-.1 0-.2 0-.3 .1c3.5 11.3 12.8 33 35.5 52.2c5.4 4.5 11.6 9 18.8 13.2c.7-8.2 7.6-14.6 15.9-14.6c8.8 0 16 7.2 16 16v12.7c21 6.8 47.3 11.3 80 11.3c17.9 0 33.8-1.3 48-3.6V384c0-8.8 7.2-16 16-16s16 7.2 16 16v12.7c22.2-7.2 38.6-17.1 50.7-27.4c22.8-19.2 32-40.9 35.5-52.2c-.1 0-.1 0-.2 0c0 0-.1 0-.1 0z"]
};
var faGrip = {
  prefix: 'fal',
  iconName: 'grip',
  icon: [448, 512, ["grip-horizontal"], "f58d", "M408 384c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM408 192c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM200 384l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8zm48 32l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-224c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM40 384l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8zm48 32l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-224c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48z"]
};
var faGripHorizontal = faGrip;
var faShareFromSquare = {
  prefix: 'fal',
  iconName: 'share-from-square',
  icon: [576, 512, [61509, "share-square"], "f14d", "M400 280V240 224c0-8.8-7.2-16-16-16H368 352 336 289.5c-53.8 0-97.5 43.6-97.5 97.5c0 5.3 .7 10.3 1.9 15C175.5 301.9 160 276 160 240c0-70.7 57.3-128 128-128h48 32 16c8.8 0 16-7.2 16-16V80 40c0-4.4 3.6-8 8-8c2.1 0 4 .8 5.5 2.2l128.8 122c1 1 1.6 2.3 1.6 3.8s-.6 2.8-1.6 3.8l-128.8 122c-1.5 1.4-3.5 2.2-5.5 2.2c-4.5 0-8-3.6-8-8zm-32-40v32 8c0 22.1 18 40 40 40c10.2 0 20.1-3.9 27.5-11L564.4 187c7.4-7 11.6-16.8 11.6-27s-4.2-20-11.6-27L435.6 11c-7.4-7-17.3-11-27.5-11C386 0 368 17.9 368 40v8V80H336 288c-88.4 0-160 71.6-160 160c0 93.4 82.8 134.8 100.6 142.6c2.2 1 4.6 1.4 7.1 1.4c11.2 0 20.3-9.1 20.3-20.3v-.9c0-6.8-3.3-13.1-8.3-17.7c-9.5-8.6-23.7-24.1-23.7-39.7c0-36.1 29.3-65.5 65.5-65.5H336h16 16zM64 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"]
};
var faShareSquare = faShareFromSquare;
var faKeynote = {
  prefix: 'fal',
  iconName: 'keynote',
  icon: [512, 512, [], "f66c", "M304 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zM240 0c-20.9 0-38.7 13.4-45.3 32H184c-44.2 0-80 35.8-80 80v48H93.7c-18.2 0-34.8 10.3-42.9 26.5L5.1 277.9c-3.3 6.7-5.1 14-5.1 21.5V304v48c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V304v-4.7c0-7.5-1.7-14.8-5.1-21.5l-45.7-91.3c-8.1-16.3-24.8-26.5-42.9-26.5H136V112c0-26.5 21.5-48 48-48h10.7c6.6 18.6 24.4 32 45.3 32h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H240zM32 352V320H480v32H32zm3.8-64l43.6-87.2c2.7-5.4 8.3-8.8 14.3-8.8H418.3c6.1 0 11.6 3.4 14.3 8.8L476.2 288H35.8zM144 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H256 368c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V416H240v64H144z"]
};
var faChildCombatant = {
  prefix: 'fal',
  iconName: 'child-combatant',
  icon: [576, 512, ["child-rifle"], "e4e0", "M144 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 112 64a64 64 0 1 0 128 0zM480 336V325.3l52.2-17.4 .9-.3c6.5-2.2 10.9-8.3 10.9-15.2V280 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48 24l-32 8v-8V256v-1V208 160c0-17.7-14.3-32-32-32V96 32 16c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16s7.2 16 16 16V64 96v32c-17.7 0-32 14.3-32 32v34.7c-18.6 6.6-32 24.4-32 45.3V352c0 19.9 12.1 36.9 29.3 44.2c.9 .4 1.8 .7 2.7 1V480v16c0 8.8 7.2 16 16 16h16 60.1H496c4.9 0 9.4-2.2 12.5-6s4.2-8.7 3.1-13.5l-4.3-19.5L498.2 432l-7.1-32h32.8H528c8.8 0 16-7.2 16-16s-7.2-16-16-16H491.1h-7.1L480 350.2V336zm-27.3 38.9l5.6 25.1 1.5 6.9 9.1 41.1 7.1 32H448h-4.7H416V448 397.3 384c0-4.2-1.6-8-4.3-10.9c-2.9-3.2-7.1-5.1-11.7-5.1c-6.4 0-12-3.8-14.5-9.3c-.7-1.6-1.2-3.3-1.4-5.1c-.1-.5-.1-1-.1-1.6V240c0-2.4 .5-4.7 1.5-6.7c2.5-5.5 8.1-9.3 14.5-9.3c4.6 0 8.8-2 11.7-5.1c2.6-2.9 4.3-6.7 4.3-10.9V194.7 192 160h32v32 16 48 32 8 6.3 23.1V329v7 14.2V352c0 1.2 .1 2.3 .4 3.5l0 0 .4 1.7 2.4 10.8 1.5 6.9zM144 199.9c7.7-5.1 16.8-7.9 26.3-7.9h11.3c9.5 0 18.6 2.8 26.3 7.9l0 .1V352H144V200l0-.1zM144 384h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V243.3l42.4 69.1c4.6 7.5 14.5 9.9 22 5.3s9.9-14.5 5.3-22l-59.8-97.5c-14.5-23.7-40.4-38.2-68.2-38.2H170.3c-27.8 0-53.7 14.5-68.2 38.2L42.4 295.6c-4.6 7.5-2.3 17.4 5.3 22s17.4 2.3 22-5.3L112 243.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384z"]
};
var faChildRifle = faChildCombatant;
var faGun = {
  prefix: 'fal',
  iconName: 'gun',
  icon: [576, 512, [], "e19b", "M496 32c8.8 0 16 7.2 16 16V64h32c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H486.6L464 230.6c-6 6-14.1 9.4-22.6 9.4H395.3l-28.6 80.1c-6.8 19.1-24.9 31.9-45.2 31.9H233L207 455.8C203.5 470 190.7 480 176 480H64c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L73.1 279.8c5-20.2-10.2-39.8-31-39.8H32c-17.7 0-32-14.3-32-32V96C0 78.3 14.3 64 32 64H480V48c0-8.8 7.2-16 16-16zM241 320h80.5c6.8 0 12.8-4.3 15.1-10.6L361.3 240H261l-20 80zM32 96l0 112H42 57.2 235h1 14.9H267 441.4L464 185.4c6-6 14.1-9.4 22.6-9.4H544V96H496 32zM228 240H97.5c8 13.7 10.9 30.5 6.7 47.5L64 448l112 0 52-208z"]
};
var faSquarePhone = {
  prefix: 'fal',
  iconName: 'square-phone',
  icon: [448, 512, ["phone-square"], "f098", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm171.2 48.1l-56 12c-1.8 .4-3.2 2-3.2 3.9c0 114.9 93.1 208 208 208c1.9 0 3.5-1.3 3.9-3.2l12-56c.4-1.9-.6-3.8-2.3-4.5l-56-24c-1.6-.7-3.5-.2-4.7 1.1l-16.6 20.3c-5 6.1-13.6 7.6-20.4 3.7c-25.4-14.7-46.6-35.9-61.4-61.4c-3.9-6.8-2.4-15.4 3.7-20.4l20.3-16.6c1.4-1.1 1.8-3 1.1-4.7l-24-56c-.8-1.8-2.6-2.7-4.5-2.3zm33.9-10.3l24 56c6.3 14.7 2.1 31.9-10.3 42l-9.2 7.5c8.6 11.9 19.1 22.4 31 31l7.5-9.2c10.2-12.4 27.3-16.6 42-10.3l56 24c15.8 6.8 24.6 23.8 21 40.6l-12 56C351.6 388.1 337 400 320 400C187.5 400 80 292.6 80 160c0-17 11.9-31.6 28.5-35.2l56-12c16.8-3.6 33.9 5.2 40.6 21z"]
};
var faPhoneSquare = faSquarePhone;
var faHatBeach = {
  prefix: 'fal',
  iconName: 'hat-beach',
  icon: [640, 512, [], "e606", "M192 224v10.8 3.9c.3 .5 1.1 1.5 2.6 2.9c4.2 4 11.9 9 24.2 13.9C243.1 265.3 278.8 272 320 272c11.5 0 22.6-.5 33.1-1.5c-.7-3.8-1.1-7.7-1.1-11.8c0-12.5 3.8-24.6 10.8-34.7c-.5-.7-1-1.4-1.4-2.2c-13.2 1.4-27.1 2.2-41.4 2.2c-44.2 0-84.2-7.2-113.1-18.7c-4.4-1.8-8.6-3.7-12.5-5.6c-1.5 7.9-2.3 16-2.3 24.4zm160-34.7c0-31.1 23.2-56.8 53.3-60.7C382.6 108.3 352.7 96 320 96c-50.9 0-94.9 29.7-115.5 72.8c3.8 2.2 8.6 4.5 14.2 6.8C243.1 185.3 278.8 192 320 192c11.1 0 21.8-.5 32-1.4c0-.4 0-.9 0-1.3zM320 64c55.7 0 104.7 28.4 133.3 71.5c8.9-4.9 19-7.5 29.4-7.5c33.8 0 61.3 27.4 61.3 61.3c0 12.5-3.8 24.6-10.8 34.7c5.2 7.6 8.7 16.2 10.1 25.3l67 26.8c17.9 7.2 29.7 24.6 29.7 43.9c0 17.7-8.9 34.5-25.1 49.8c-16.2 15.3-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7C8.9 354.5 0 337.7 0 320c0-19.3 11.8-36.7 29.7-43.9L160 224c0-88.4 71.6-160 160-160zM482.7 320c-12.5 0-24.6-3.8-34.7-10.8c-10.1 7-22.2 10.8-34.7 10.8c-17.5 0-33.2-7.3-44.4-19c-15.4 2-31.8 3-48.9 3c-44.2 0-84.2-7.2-113.1-18.7c-14.5-5.8-26.2-12.7-34.3-20.3c-2.9-2.8-5.4-5.6-7.3-8.6L41.6 305.8c-5.8 2.3-9.6 7.9-9.6 14.2c0 6.1 2.9 15 15.1 26.6c12.3 11.6 31.8 23.5 58.5 34.2C158.9 402.1 234.7 416 320 416s161.1-13.9 214.4-35.2c26.7-10.7 46.2-22.6 58.5-34.2C605.1 335 608 326.1 608 320c0-6.2-3.8-11.9-9.6-14.2l-59.1-23.6c-9.2 22.2-31.1 37.8-56.6 37.8zM413.3 160c-16.2 0-29.3 13.1-29.3 29.3c0 7.8 3.1 15.2 8.6 20.7l2.7 2.7c6.2 6.2 6.2 16.4 0 22.6l-2.7 2.7c-5.5 5.5-8.6 12.9-8.6 20.7c0 16.2 13.1 29.3 29.3 29.3c7.8 0 15.2-3.1 20.7-8.6l2.7-2.7c6.2-6.2 16.4-6.2 22.6 0l2.7 2.7c5.5 5.5 12.9 8.6 20.7 8.6c16.2 0 29.3-13.1 29.3-29.3c0-7.8-3.1-15.2-8.6-20.7l-2.7-2.7c-6.2-6.2-6.2-16.4 0-22.6l2.7-2.7c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-2.7 2.7c-6.2 6.2-16.4 6.2-22.6 0l-2.7-2.7c-5.5-5.5-12.9-8.6-20.7-8.6zM448 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPlus = {
  prefix: 'fal',
  iconName: 'plus',
  icon: [448, 512, [10133, 61543, "add"], "2b", "M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H208V448c0 8.8 7.2 16 16 16s16-7.2 16-16V272H416c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V64z"]
};
var faAdd = faPlus;
var faExpand = {
  prefix: 'fal',
  iconName: 'expand',
  icon: [448, 512, [], "f065", "M144 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H32V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16H144zM0 336c0-8.8 7.2-16 16-16s16 7.2 16 16V448H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V336zM432 32c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H432zM416 336c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H416V336z"]
};
var faComputer = {
  prefix: 'fal',
  iconName: 'computer',
  icon: [640, 512, [], "e4e5", "M384 64c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H275.5 264 184 172.5 64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 384h97.8l-21.3 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h49.8H152 296h22.2H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H307.5l-21.3-64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64zm110.2 64l21.3-64h56.9l21.3 64H174.2zM528 64h64c8.8 0 16 7.2 16 16v48H512V80c0-8.8 7.2-16 16-16zm-16 96h96v32H512V160zm0 272V224h96V432c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16zM480 80V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528c-26.5 0-48 21.5-48 48zm80 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFort = {
  prefix: 'fal',
  iconName: 'fort',
  icon: [640, 512, [], "e486", "M32 96H96h32 64v16 48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V112 96zM0 160c0 23.7 12.9 44.4 32 55.4V224 448c0 35.3 28.7 64 64 64H240h32 96 32H544c35.3 0 64-28.7 64-64V224v-8.6c19.1-11.1 32-31.7 32-55.4V112 96 64 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32 64H576 544V32 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32 64H480 448V32 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64 96v16 48c0 11.7 3.1 22.6 8.6 32H215.4c5.4-9.4 8.6-20.3 8.6-32V112 96 64 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32 64H160 128V32 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32 64H64 32V32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V64 96v16 48zM400 480V400c0-44.2-35.8-80-80-80s-80 35.8-80 80v80H192V224H448V480H400zm80-256h96V448c0 17.7-14.3 32-32 32H480V224zM64 448l0-224h96V480H96c-17.7 0-32-14.3-32-32zm304 32H272V400c0-26.5 21.5-48 48-48s48 21.5 48 48v80zM608 160c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V112 96h64 32 64v16 48z"]
};
var faCloudCheck = {
  prefix: 'fal',
  iconName: 'cloud-check',
  icon: [640, 512, [], "e35c", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM427.3 235.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 329.4 404.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faXmark = {
  prefix: 'fal',
  iconName: 'xmark',
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"]
};
var faClose = faXmark;
var faMultiply = faXmark;
var faRemove = faXmark;
var faTimes = faXmark;
var faFaceSmirking = {
  prefix: 'fal',
  iconName: 'face-smirking',
  icon: [512, 512, [], "e397", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm375.8 82.6l-.2 1.2c-5.8 34.7-35.8 60.2-71 60.2H192c-8.8 0-16-7.2-16-16s7.2-16 16-16H304.6c19.6 0 36.2-14.1 39.5-33.4l.2-1.2c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z"]
};
var faArrowsUpDownLeftRight = {
  prefix: 'fal',
  iconName: 'arrows-up-down-left-right',
  icon: [512, 512, ["arrows"], "f047", "M267.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-72 72c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6V240H54.6l44.7-44.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-72 72c-6.2 6.2-6.2 16.4 0 22.6l72 72c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272H240V457.4l-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l72 72c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 457.4V272H457.4l-44.7 44.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6l-72-72c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240H272V54.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-72-72z"]
};
var faArrows = faArrowsUpDownLeftRight;
var faChalkboardUser = {
  prefix: 'fal',
  iconName: 'chalkboard-user',
  icon: [640, 512, ["chalkboard-teacher"], "f51c", "M576 32H224c-17.7 0-32 14.3-32 32v36c-10.2-2.6-21-4-32-4V64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H560 400 384 336.8c-5.3-11.4-11.8-22.2-19.5-32H384V336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v48c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zM544 384V336c0-8.8-7.2-16-16-16H432c-8.8 0-16 7.2-16 16v48H544zM224 224A64 64 0 1 0 96 224a64 64 0 1 0 128 0zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM32.1 480H287.9c-2.8-53.5-47-96-101.2-96H133.3c-54.2 0-98.4 42.5-101.2 96zM0 485.3C0 411.7 59.7 352 133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3z"]
};
var faChalkboardTeacher = faChalkboardUser;
var faRhombus = {
  prefix: 'fal',
  iconName: 'rhombus',
  icon: [448, 512, [], "e23b", "M438.5 230.1l-184-216C246.8 5.1 235.7 0 224 0s-22.8 5.1-30.4 14.1l-184 216C-3.2 245-3.2 267 9.6 281.9l184 216c7.6 8.9 18.7 14.1 30.4 14.1s22.8-5.1 30.4-14.1l184-216c12.7-14.9 12.7-36.9 0-51.9zM230.1 34.8l184 216c2.5 3 2.5 7.4 0 10.4l-184 216c-1.5 1.8-3.7 2.8-6.1 2.8s-4.6-1-6.1-2.8l-184-216c-2.5-3-2.5-7.4 0-10.4l184-216c1.5-1.8 3.7-2.8 6.1-2.8s4.6 1 6.1 2.8z"]
};
var faClawMarks = {
  prefix: 'fal',
  iconName: 'claw-marks',
  icon: [576, 512, [], "f6c2", "M36.7 4.7c6.2-6.2 16.4-6.2 22.6 0L170.9 116.3c13.5 13.5 21.1 31.8 21.1 50.9V192h24.8c19.1 0 37.4 7.6 50.9 21.1l95.2 95.2c13.5 13.5 21.1 31.8 21.1 50.9V384h24.8c19.1 0 37.4 7.6 50.9 21.1l79.6 79.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-79.6-79.6c-7.5-7.5-17.7-11.7-28.3-11.7H368c-8.8 0-16-7.2-16-16V359.2c0-10.6-4.2-20.8-11.7-28.3l-95.2-95.2c-7.5-7.5-17.7-11.7-28.3-11.7H176c-8.8 0-16-7.2-16-16V167.2c0-10.6-4.2-20.8-11.7-28.3L36.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zm0 224c6.2-6.2 16.4-6.2 22.6 0l81.9 81.9c12 12 18.7 28.3 18.7 45.3V384h28.1c17 0 33.3 6.7 45.3 18.7l81.9 81.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-81.9-81.9c-6-6-14.1-9.4-22.6-9.4H144c-8.8 0-16-7.2-16-16V355.9c0-8.5-3.4-16.6-9.4-22.6L36.7 251.3c-6.2-6.2-6.2-16.4 0-22.6zM283.3 4.7l17.9 17.9c12 12 18.7 28.3 18.7 45.3V96h28.1c17 0 33.3 6.7 45.3 18.7l35.9 35.9c12 12 18.7 28.3 18.7 45.3V224h28.1c17 0 33.3 6.7 45.3 18.7l17.9 17.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-17.9-17.9c-6-6-14.1-9.4-22.6-9.4H432c-8.8 0-16-7.2-16-16V195.9c0-8.5-3.4-16.6-9.4-22.6l-35.9-35.9c-6-6-14.1-9.4-22.6-9.4H304c-8.8 0-16-7.2-16-16V67.9c0-8.5-3.4-16.6-9.4-22.6L260.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faPesoSign = {
  prefix: 'fal',
  iconName: 'peso-sign',
  icon: [384, 512, [], "e222", "M71.4 32C49.6 32 32 49.6 32 71.4V128H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v80V464c0 8.8 7.2 16 16 16s16-7.2 16-16V352H192c65.6 0 122-39.5 146.7-96H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H348.8c2.1-10.3 3.2-21 3.2-32s-1.1-21.7-3.2-32H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H338.7C314 71.5 257.6 32 192 32H71.4zm231.5 96H64V71.4c0-4.1 3.3-7.4 7.4-7.4H192c47.4 0 88.7 25.7 110.9 64zM64 160H316c2.6 10.2 4 21 4 32s-1.4 21.8-4 32H64V160zm238.9 96c-22.1 38.3-63.5 64-110.9 64H64V256H302.9z"]
};
var faFaceSmileTongue = {
  prefix: 'fal',
  iconName: 'face-smile-tongue',
  icon: [512, 512, [], "e394", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 8.8 7.2 16 16 16s16-7.2 16-16C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c36.4 0 71-7.6 102.4-21.3c8.1-3.5 11.8-13 8.3-21.1s-13-11.8-21.1-8.3c-27.4 12-57.7 18.6-89.6 18.6C132.3 480 32 379.7 32 256zm124.5-61.5c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 161.9 194.8 152 176 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm160 0c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 161.9 354.8 152 336 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm-224.6 78c-8.5 2.3-13.6 11.1-11.3 19.6C102 372.3 171.9 432 256 432c31 0 60.1-8.1 85.5-22.4l45.3 29.6c36.8 24 86.2 12.2 108.2-25.8l1.4-2.4c21.4-37.1 9.8-84.4-26.3-107.5l-45.2-28.8c-1.4-1-3-1.7-4.8-2.2c-8.5-2.3-17.3 2.8-19.6 11.3C382.5 351.5 324.1 400 256 400s-126.5-48.5-144.5-116.1c-2.3-8.5-11.1-13.6-19.6-11.3zm278 117.4C394 369.6 413 343 424.8 312.6l28.1 17.9c21.7 13.8 28.6 42.2 15.8 64.5l-1.4 2.4c-12.8 22.2-41.6 29-63 15l-34.4-22.5z"]
};
var faCartCircleXmark = {
  prefix: 'fal',
  iconName: 'cart-circle-xmark',
  icon: [640, 512, [], "e3f4", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"]
};
var faBuildingShield = {
  prefix: 'fal',
  iconName: 'building-shield',
  icon: [576, 512, [], "e4d8", "M320 32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c1.3 0 2.6-.1 3.9-.2c7.9 8.6 16.6 16.9 26.3 24.7c-9 4.8-19.3 7.6-30.2 7.6H256 224 160 128 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V207l-32 12.8V64c0-17.7-14.3-32-32-32zM272 240c-8.8 0-16 7.2-16 16v32 8.2V320h-8c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24h48c8.2 0 15.4 4.1 19.7 10.3L301.6 240H272zM192 384c-17.7 0-32 14.3-32 32v64h64V416c0-17.7-14.3-32-32-32zM88 96h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm8 64h32V128H96v32zm128-40c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V120zm32 8v32h32V128H256zM88 224h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm8 64h32V256H96v32zm224.1 13.4c1.3 53 22.6 129.5 95.9 170V263l-95.9 38.4zm223.9 0L448 263V471.4c73.4-40.5 94.6-117.1 95.9-170zm-103-75.7l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48c5.7-2.3 12.1-2.3 17.8 0z"]
};
var faCirclePhoneFlip = {
  prefix: 'fal',
  iconName: 'circle-phone-flip',
  icon: [512, 512, ["phone-circle-alt"], "e11c", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm52.8 144.1c-1.9-.4-3.8 .6-4.5 2.3l-24 56c-.7 1.6-.2 3.5 1.1 4.7l20.3 16.6c6.1 5 7.6 13.6 3.7 20.4c-14.7 25.4-35.9 46.6-61.4 61.4c-6.8 3.9-15.4 2.4-20.4-3.7l-16.6-20.3c-1.1-1.4-3-1.8-4.7-1.1l-56 24c-1.8 .8-2.7 2.6-2.3 4.5l12 56c.4 1.8 2 3.2 3.9 3.2c114.9 0 208-93.1 208-208c0-1.9-1.3-3.5-3.2-3.9l-56-12zm-33.9-10.3c6.8-15.8 23.8-24.6 40.6-21l56 12C388.1 128.4 400 143 400 160c0 132.5-107.4 240-240 240c-17 0-31.6-11.9-35.2-28.5l-12-56c-3.6-16.8 5.2-33.9 21-40.6l56-24c14.7-6.3 31.9-2.1 42 10.3l7.5 9.2c11.9-8.6 22.4-19.1 31-31l-9.2-7.5c-12.4-10.2-16.6-27.3-10.3-42l24-56z"]
};
var faPhoneCircleAlt = faCirclePhoneFlip;
var faBaby = {
  prefix: 'fal',
  iconName: 'baby',
  icon: [448, 512, [], "f77c", "M224 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM46.1 146.8c20.5-23.1 55.9-25.2 79.1-4.7l24.2 21.5C169.9 181.9 196.5 192 224 192s54.1-10.1 74.6-28.4l24.2-21.5c23.1-20.5 58.5-18.5 79.1 4.7s18.5 58.5-4.7 79.1L373 247.3c-16.1 14.3-33.9 26-53 35.1v32.3l49.9 56.1c16.9 19 18.9 47.1 4.7 68.3l-32 48c-17.2 25.7-51.9 32.7-77.7 15.5s-32.7-51.9-15.5-77.7l8-12L238.9 392H209.1l-18.6 20.9 8 12c17.2 25.7 10.2 60.5-15.5 77.7s-60.5 10.2-77.7-15.5l-32-48c-14.1-21.2-12.2-49.2 4.7-68.3L128 314.7V288.1c0 0 0 0 0-.1s0 0 0-.1v-5.5c-19.1-9-37-20.8-53-35.1L50.8 225.9c-23.1-20.5-25.2-55.9-4.7-79.1zM160 304v16.8c0 .2 0 .4 0 .6l38.9 38.9c1-.2 2-.3 3-.3H246c1 0 2 .1 3 .3L288 321.4c0-.2 0-.4 0-.6V304H160zm128-32c0-6.5 3.9-12.3 9.9-14.7c19.6-8.1 37.8-19.5 53.9-33.8l24.2-21.5c9.9-8.8 10.8-24 2-33.9s-24-10.8-33.9-2l-24.2 21.5C293.5 211 259.3 224 224 224s-69.5-13-95.9-36.5l-24.2-21.5c-9.9-8.8-25.1-7.9-33.9 2s-7.9 25.1 2 33.9l24.2 21.5c16.1 14.3 34.4 25.7 53.9 33.8c6 2.5 9.8 8.3 9.9 14.7H288zm18.7 75.9l-34 34 16.8 19c4.8 5.4 5.4 13.4 1.4 19.5L276 442.7c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c6.1-9.1 5.2-21.1-2-29.3l-39.2-44.1zm-131.4 34l-34-34-39.2 44.1c-7.2 8.2-8.1 20.2-2 29.3l32 48c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-14.9-22.3c-4-6.1-3.5-14.1 1.4-19.5l16.8-19z"]
};
var faUsersLine = {
  prefix: 'fal',
  iconName: 'users-line',
  icon: [640, 512, [], "e592", "M147.2 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM369.6 288h-96c-35.3 0-64 28.7-64 64h224c0-35.3-28.7-64-64-64zm-192 64c0-53 43-96 96-96h96c53 0 96 43 96 96c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32zm144-160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM64 288v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-35.3 28.7-64 64-64h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-17.7 0-32 14.3-32 32zm480-32H456c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-17.7-14.3-32-32-32zM16 448H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faQuoteLeft = {
  prefix: 'fal',
  iconName: 'quote-left',
  icon: [448, 512, [8220, "quote-left-alt"], "f10d", "M0 208C0 146.1 50.1 96 112 96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-44.2 0-80 35.8-80 80v24.6c9.4-5.4 20.3-8.6 32-8.6h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 208zm32 80v32 32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm352-32H320c-17.7 0-32 14.3-32 32v32 32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32zM256 320V288 208c0-61.9 50.1-112 112-112h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-44.2 0-80 35.8-80 80v24.6c9.4-5.4 20.3-8.6 32-8.6h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320z"]
};
var faQuoteLeftAlt = faQuoteLeft;
var faTractor = {
  prefix: 'fal',
  iconName: 'tractor',
  icon: [640, 512, [128668], "f722", "M128 48V159.2c6.9-18.3 24.5-31.2 45-31.2H211c21.7 0 40.3 14.5 46.1 34.7c12.6-7 27.6-7.8 40.7-2.7h.4 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .4L289.9 41.4c-2.6-5.7-8.3-9.4-14.6-9.4H144c-8.8 0-16 7.2-16 16zM96 157.3V48c0-26.5 21.5-48 48-48H275.3c18.9 0 36 11.1 43.8 28.3L378.3 160h.3 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6 .6 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .2V119.8c0-29.7 11.8-58.2 32.8-79.2l3.9-3.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-3.9 3.9c-15 15-23.4 35.4-23.4 56.6V160h.2 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3c22.2 0 39.9 18 39.9 40v60.5c0 12.2-5.5 23.6-15 31.2L567.1 338c-11.3 9.1-25.4 14-40 14H382.2c-4.4 15.9-16.9 28.5-32.9 33.2c10.2 18.4 7.3 41.8-8.1 57.1l-26.9 26.9c-15.3 15.4-38.7 18.3-57.1 8.1C251.3 497.5 232.7 512 211 512H173c-21.7 0-40.3-14.5-46.1-34.7c-18.4 10.2-41.8 7.3-57.1-8.1L42.8 442.3l11-11-11 11c-15.3-15.4-18.3-38.7-8.1-57.1C14.5 379.3 0 360.7 0 339V301c0-21.7 14.5-40.3 34.7-46.1c-10.2-18.4-7.3-41.8 8.1-57.1l26.9-26.9c7.4-7.4 16.6-11.9 26.3-13.4zM384 320H527.2c7.3 0 14.3-2.5 20-7L605 266.7c1.9-1.5 3-3.8 3-6.2V200c0-4.5-3.6-8-7.9-8h-.3-.3-.3-.3-.3-.3-.3-.3-.3H597h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H591h-.3-.3H590h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H586h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H580h-.4-.4-.4-.4H578h-.4-.4-.4-.4H576h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H571h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H564h-.4-.5-.5-.5-.5-.5-.5-.5-.5-.5H559h-.5H558h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H548h-.5H547h-.5H546h-.5H545h-.5H544h-.5H543h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H531h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H525h-.5-.5-.6-.6-.6-.6-.6-.6-.6-.6H519h-.6-.6-.6-.6-.6-.6H515h-.6-.6-.6-.6-.6-.6H511h-.6-.6-.6-.6-.6-.6H507h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H486h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H476h-.6-.6-.6-.6-.6-.6-.6H471h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H462h-.6-.7H460h-.6-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H432h-.7-.7H430h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H421h-.7-.7H419h-.7-.7-.7-.7-.7-.7-.7-.7-.7H412h-.7-.7-.7-.7-.7-.7-.7-.7-.7H405h-.7-.7-.7-.7-.7-.7H400h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H380h-.7-.7-.7-.7-.7-.7H375h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.1c-.2 0-.5 0-.7 0H367h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H359h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H348h-.7-.7-.7H345h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.6l5.7 5.7c15.4 15.4 18.3 38.7 8.1 57.1c20.2 5.8 34.7 24.4 34.7 46.1v19zM512 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM157 174.4l-1.3 12.9c-.6 6-4.5 11.1-10.1 13.3c-1.8 .7-3.5 1.4-5.2 2.2c-5.5 2.4-11.9 1.6-16.6-2.3l-10.1-8.2c-6.4-5.2-15.6-4.7-21.4 1.1L65.4 220.3c-5.8 5.8-6.3 15.1-1.1 21.4l8.2 10.1c3.8 4.7 4.7 11.1 2.3 16.6c-.8 1.7-1.5 3.5-2.2 5.2c-2.2 5.6-7.3 9.5-13.3 10.1L46.4 285C38.2 285.9 32 292.7 32 301V339c0 8.2 6.2 15.1 14.4 15.9l12.9 1.3c6 .6 11.1 4.5 13.3 10.1c.7 1.8 1.4 3.5 2.2 5.2c2.4 5.5 1.6 11.9-2.3 16.6l-8.2 10.1c-5.2 6.4-4.7 15.6 1.1 21.4l26.9 26.9c5.8 5.8 15.1 6.3 21.4 1.1l10.1-8.2c4.7-3.8 11.1-4.7 16.6-2.3c1.7 .8 3.5 1.5 5.2 2.2c5.6 2.2 9.5 7.3 10.1 13.3l1.3 12.9c.8 8.2 7.7 14.4 15.9 14.4H211c8.2 0 15.1-6.2 15.9-14.4l1.3-12.9c.6-6 4.5-11.1 10.1-13.3c1.8-.7 3.5-1.4 5.2-2.2c5.5-2.4 11.9-1.6 16.6 2.3l10.1 8.2c6.4 5.2 15.6 4.7 21.4-1.1l26.9-26.9c5.8-5.8 6.3-15.1 1.1-21.4l-8.2-10.1c-3.8-4.7-4.7-11.1-2.3-16.6c.8-1.7 1.5-3.4 2.2-5.2c2.2-5.6 7.3-9.5 13.3-10.1l12.9-1.3c8.2-.8 14.4-7.7 14.4-15.9V301c0-8.2-6.2-15.1-14.4-15.9l-12.9-1.3c-6-.6-11.1-4.5-13.3-10.1c-.7-1.8-1.4-3.5-2.2-5.2c-2.4-5.5-1.6-11.9 2.3-16.6l8.2-10.1c5.2-6.4 4.7-15.6-1.1-21.4l-26.9-26.9c-5.8-5.8-15.1-6.3-21.4-1.1l-10.1 8.2c-4.7 3.8-11.1 4.7-16.6 2.3c-1.7-.8-3.5-1.5-5.2-2.2c-5.6-2.2-9.5-7.3-10.1-13.3L227 174.4c-.8-8.2-7.7-14.4-15.9-14.4H173c-8.2 0-15.1 6.2-15.9 14.4zM137.6 320a54.4 54.4 0 1 0 108.8 0 54.4 54.4 0 1 0 -108.8 0zM192 406.4a86.4 86.4 0 1 1 0-172.8 86.4 86.4 0 1 1 0 172.8z"]
};
var faKeySkeleton = {
  prefix: 'fal',
  iconName: 'key-skeleton',
  icon: [448, 512, [128477], "f6f3", "M304 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 34 11.8 65.2 31.5 89.9L4.7 420.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 432 80 390.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L102.6 368 214.1 256.5C238.8 276.2 270 288 304 288z"]
};
var faTrashArrowUp = {
  prefix: 'fal',
  iconName: 'trash-arrow-up',
  icon: [448, 512, ["trash-restore"], "f829", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64h47.1H416h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H413.7L388.2 452.6C385.9 486.1 358 512 324.4 512H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64.1h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480H324.4c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zM224 176c4.2 0 8.3 1.7 11.3 4.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 230.6V392c0 8.8-7.2 16-16 16s-16-7.2-16-16V230.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7z"]
};
var faTrashRestore = faTrashArrowUp;
var faArrowDownUpLock = {
  prefix: 'fal',
  iconName: 'arrow-down-up-lock',
  icon: [640, 512, [], "e4b0", "M139.3 507.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L144 457.4V272H304h32l80 0c0-11.1 1.6-21.9 4.6-32H336V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 54.6V240H144 112 16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96V457.4L43.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM144 200V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V200h32zM336 312H304V464c0 8.8 7.2 16 16 16s16-7.2 16-16V312zm192-88c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faArrowDownToBracket = {
  prefix: 'fal',
  iconName: 'arrow-down-to-bracket',
  icon: [448, 512, [], "e094", "M363.3 219.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 297.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16V297.4L340.7 196.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM32 336v96c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V336c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V336c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faLinesLeaning = {
  prefix: 'fal',
  iconName: 'lines-leaning',
  icon: [384, 512, [], "e51e", "M190.9 53.7c3.2-8.2-.9-17.5-9.2-20.7s-17.5 .9-20.7 9.2l-160 416c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2l160-416zm84.7-21.3c-8.6-2-17.2 3.4-19.2 12l-96 416c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l96-416c2-8.6-3.4-17.2-12-19.2zM368 32c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16z"]
};
var faSquareQ = {
  prefix: 'fal',
  iconName: 'square-q',
  icon: [448, 512, [], "e27b", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256c0 53 43 96 96 96c20.7 0 39.9-6.6 55.6-17.7l-50.9-50.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l50.9 50.9C313.4 295.9 320 276.7 320 256c0-53-43-96-96-96s-96 43-96 96zm224 0c0 29.6-10 56.8-26.9 78.5l22.2 22.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.2-22.2C280.8 374 253.6 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z"]
};
var faRulerCombined = {
  prefix: 'fal',
  iconName: 'ruler-combined',
  icon: [512, 512, [], "f546", "M192 192V128l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-32c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 288 0 96c0 1.1 .1 2.2 .2 3.3C33.8 467.4 47.5 480 64 480h96l288 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32H416v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H320v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H224v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V224l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zm64 96H448c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64l-288 0H64C30.9 512 3.6 486.8 .3 454.5c-.2-2.2-.3-4.3-.3-6.5V352 64C0 28.7 28.7 0 64 0h96c35.3 0 64 28.7 64 64l0 192v32h32z"]
};
var faSymbols = {
  prefix: 'fal',
  iconName: 'symbols',
  icon: [512, 512, [128291, "icons-alt"], "f86e", "M16 0H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16S7.2 0 16 0zm0 64H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H128V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16zM473.7 4.1C493.5 .2 512 15.3 512 35.5V168h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V35.5L352 61.1V200h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V61.1c0-15.3 10.8-28.4 25.7-31.4l128-25.6zM480 172c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM320 204c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zm16 148a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm171.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0zM480 464a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM76.4 256h8.6c32.6 0 59.1 26.4 59.1 59.1c0 18.1-8.3 35.2-22.6 46.4l-20.2 15.8 49.8 45.3 47.3-35.5c7.1-5.3 17.1-3.9 22.4 3.2s3.9 17.1-3.2 22.4l-42.4 31.8 43.5 39.6c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-48.1-43.7-46.8 35.1C91.3 507.5 77.8 512 64 512c-35.5 0-64-29.1-64-64.3c0-19.7 9-38.6 24.6-50.8l27.1-21.3L35.8 361C23.2 349.6 16 333.4 16 316.4C16 283 43 256 76.4 256zm25.3 80.4c6.5-5.1 10.3-13 10.3-21.3c0-14.9-12.1-27.1-27.1-27.1H76.4C60.7 288 48 300.7 48 316.4c0 8 3.4 15.6 9.3 21l20 18.2 24.4-19.2zM44.4 422C36.6 428.2 32 437.7 32 447.7C32 465.5 46.5 480 64 480c6.9 0 13.7-2.2 19.2-6.4L125 442.2 75.8 397.4 44.4 422z"]
};
var faIconsAlt = faSymbols;
var faCopyright = {
  prefix: 'fal',
  iconName: 'copyright',
  icon: [512, 512, [169], "f1f9", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm67.9-188.1c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8s98.3-37.5 135.8 0c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faFlaskGear = {
  prefix: 'fal',
  iconName: 'flask-gear',
  icon: [640, 512, [], "e5f1", "M288 196.8V32H160V196.8c0 17.8-4.9 35.2-14.2 50.3L100.9 320H304.6c2.2 13.3 10.3 25 21.2 32H81.2L37.5 423c-3.6 5.9-5.5 12.7-5.5 19.6C32 463.3 48.7 480 69.4 480H351c15.6 13.1 36.9 13.7 53 4.8v.9c0 6.7 1.5 13.5 4.2 19.7c-9 4.3-19 6.6-29.7 6.6H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5V32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h48H288h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V196.8c0 11.8 3.3 23.5 9.5 33.5L336 241c-4.9 6.4-9.5 13.1-13.6 20.3c-1.9 3.3-3.7 6.6-5.4 10l-14.8-24.1C292.9 232 288 214.6 288 196.8zm175.3 43c-3.1 16.6-14 29.5-26.6 36.7c-13 7.4-30 9.9-46 3.7l-17.2 30.5c12.8 11.4 18.5 27.7 18.5 42.4s-5.7 31-18.5 42.4L390.7 426c15.9-6.3 33-3.7 46 3.7c12.6 7.2 23.6 20.1 26.6 36.7H497c3-16.6 13.9-29.5 26.5-36.7c12.9-7.4 30-9.9 45.9-3.6l17.2-30.5c-12.8-11.4-18.5-27.7-18.5-42.4s5.7-31 18.5-42.4l-17.2-30.5c-15.9 6.3-32.9 3.7-45.9-3.6c-12.6-7.2-23.5-20.2-26.5-36.7H463.3zm43.5-32c11.8 0 21.4 9.6 21.4 21.4v1.6c0 7.5 4.6 14.2 11.1 18c6.5 3.7 14.5 4.2 21 .3l1.8-1c10.7-6.3 24.4-2.6 30.5 8.2L619 303.1c5.7 10.2 2.3 23.1-7.8 29c-7.3 4.3-11.2 12.6-11.2 21s3.9 16.7 11.2 21c10 5.9 13.5 18.8 7.8 29L592.5 450c-6.1 10.8-19.9 14.5-30.5 8.2l-1.8-1c-6.5-3.8-14.5-3.4-21 .3c-6.5 3.7-11.1 10.4-11.1 18V477c0 11.8-9.6 21.4-21.4 21.4H453.4c-11.7 0-21.3-9.5-21.3-21.3v-1.4c0-7.6-4.6-14.4-11.3-18.2c-6.6-3.7-14.7-4.2-21.2-.3l-1.6 1c-10.7 6.3-24.4 2.6-30.5-8.2L341 403.1c-5.7-10.2-2.3-23.1 7.8-29c7.3-4.3 11.2-12.5 11.2-21s-3.9-16.7-11.2-21c-10-5.9-13.5-18.8-7.8-29l26.4-46.9c6.1-10.8 19.9-14.5 30.5-8.2l1.6 1c6.5 3.9 14.6 3.4 21.2-.3c6.6-3.8 11.3-10.6 11.3-18.2v-1.4c0-11.7 9.5-21.3 21.3-21.3h53.4zM424.1 353.1a56 56 0 1 1 112.1 0 56 56 0 1 1 -112.1 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHighlighterLine = {
  prefix: 'fal',
  iconName: 'highlighter-line',
  icon: [576, 512, [], "e1af", "M166.6 319.2L122.9 363c-3.1 3.1-3.1 8.2 0 11.3l62.8 62.8c3.1 3.1 8.2 3.1 11.3 0l43.7-43.7c6-6 14.1-9.4 22.6-9.4h48c5.2 0 10-2.5 13-6.7l19.4-27L209.6 216.3l-27 19.4c-4.2 3-6.7 7.8-6.7 13v48c0 8.5-3.4 16.6-9.4 22.6zm196 4.8L523.8 99.5c2.7-3.8 4.2-8.4 4.2-13c0-5.9-2.4-11.6-6.5-15.8L489.3 38.5c-4.2-4.2-9.9-6.5-15.8-6.5c-4.7 0-9.2 1.5-13 4.2L236 197.4 362.6 324zm-51.3 92h-48l-43.7 43.7c-11.4 11.4-27.9 14.5-42 9.3l-36 36c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17l84-84c-5.2-14.2-2.1-30.7 9.3-42L144 296.6v-48c0-15.5 7.4-30 20-39L441.8 10.2C451 3.6 462.1 0 473.5 0c14.4 0 28.2 5.7 38.4 15.9l32.2 32.2c10.2 10.2 15.9 24 15.9 38.4c0 11.4-3.6 22.5-10.2 31.7L350.4 396c-9 12.6-23.5 20-39 20zM111 407.6L38.6 480h82.7l31-31L111 407.6zM240 480H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBracketSquare = {
  prefix: 'fal',
  iconName: 'bracket-square',
  icon: [192, 512, ["bracket", "bracket-left"], "5b", "M0 80C0 53.5 21.5 32 48 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-26.5 0-48-21.5-48-48V80z"]
};
var faBracket = faBracketSquare;
var faBracketLeft = faBracketSquare;
var faIslandTropical = {
  prefix: 'fal',
  iconName: 'island-tropical',
  icon: [512, 512, [127965, "island-tree-palm"], "f811", "M150.8 96H66.9C76.3 68.3 109.1 32 176 32c45.5 0 75.1 16.8 92.3 35.9c4.4 4.9 11.2 6.6 17.4 4.3C299.5 67.2 316.2 64 336 64c66.9 0 99.7 36.3 109.1 64H260.8c-4.2 0-8.3 1.7-11.3 4.7L133.9 248.2c-13-26.2-15.4-75 31.8-122.3l.1-.1c11.4-11.4 22.8-19.8 33.9-26c7.7-4.3 10.5-14 6.3-21.7s-14-10.5-21.7-6.3C173 78.1 161.8 86 150.8 96zM176 0C91.6 0 45.8 49.5 34.7 92.2C29.1 113.6 47.7 128 64 128h58.1c-37.5 52.8-32.9 107.4-13.7 140.3c11.2 19.1 34.5 16.2 46.1 4.6l83.1-83.1c-.4 3.9-.9 7.9-1.4 12.1c-5.3 40.7-17 94.1-42.4 150.1H160C89.3 352 32 409.3 32 480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32c0-65-48.4-118.6-111.1-126.9c19.6-64.1 20.6-123.6 16.1-168.7c-.9-8.7-1.9-16.8-3.1-24.4H448c16.3 0 34.9-14.4 29.3-35.8C466.2 81.5 420.4 32 336 32c-19 0-36.1 2.5-51.4 6.9C260.8 16.5 224.7 0 176 0zM285.4 160c1.4 8.4 2.7 17.6 3.7 27.6c4.4 44 3.2 102.1-17.4 164.4h-43c23-54.6 34-106.1 39.2-145.9c2.3-18 3.5-33.6 4-46.1h13.5zM288 384c53 0 96 43 96 96H64c0-53 43-96 96-96H288z"]
};
var faIslandTreePalm = faIslandTropical;
var faArrowRightFromLine = {
  prefix: 'fal',
  iconName: 'arrow-right-from-line',
  icon: [448, 512, [8614, "arrow-from-left"], "f343", "M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 288 240l-176 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 105.4 0L292.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80z"]
};
var faArrowFromLeft = faArrowRightFromLine;
var faH2 = {
  prefix: 'fal',
  iconName: 'h2',
  icon: [640, 512, [], "f314", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zm400.1 41.5c19.2-16.5 43.7-25.5 69-25.5H507c47 0 85 38.1 85 85c0 23.1-9.4 45.2-26.1 61.2l-185 178.2c-4.7 4.5-6.2 11.5-3.7 17.5s8.3 10 14.8 10H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H431.7L588.1 265.3C611.1 243.3 624 212.8 624 181c0-64.6-52.4-117-117-117h-5.8c-33 0-64.8 11.8-89.9 33.2l-21.7 18.6c-6.7 5.8-7.5 15.9-1.7 22.6s15.8 7.5 22.6 1.7l21.7-18.6z"]
};
var faEquals = {
  prefix: 'fal',
  iconName: 'equals',
  icon: [448, 512, [62764], "3d", "M32 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H416c8.8 0 16-7.2 16-16s-7.2-16-16-16H32zm0 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H416c8.8 0 16-7.2 16-16s-7.2-16-16-16H32z"]
};
var faCakeSlice = {
  prefix: 'fal',
  iconName: 'cake-slice',
  icon: [512, 512, [127856, "shortcake"], "e3e5", "M296 64L52.3 256H480c0-64-28-112-65-144s-83-48-119-48zM0 272c0-9.8 4.5-19.1 12.2-25.1l264-208c5.6-4.4 12.6-6.9 19.8-6.9c44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256v.5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .1 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .1 .1 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2 .3 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2c0 35.4-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V368 272zm32 80H480v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V346v-.3-.3V345v-.3-.3V344v-.3-.3V343v-.3-.3V342v-.3-.3V341v-.3-.3V340v-.3-.3V339v-.3-.3V338v-.3-.3V337v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.4-.4V330v-.4-.4V329v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V325v-.4-.4V324v-.4-.4-.4-.4-.4-.4-.4V321v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V312v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V307v-.4-.4-.4-.4V305v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V297v-.4-.4-.4-.4V295v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V290v-.4-.4-.4-.4V288H32l0 64zm0 32l0 32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32v-.2-.2-.2-.2-.2V415v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V413v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V411v-.2-.2-.2-.2V410v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V406v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V401v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V398v-.2-.2-.2-.2-.2-.2-.2-.2V396v-.2-.2-.2-.2-.2-.2-.2-.2V394v-.2-.2-.2V393v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V390v-.2-.2-.2V389v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V384H32z"]
};
var faShortcake = faCakeSlice;
var faPeanut = {
  prefix: 'fal',
  iconName: 'peanut',
  icon: [512, 512, [], "e430", "M127.1 249.9l.2 0 .2 0c25.9-5.1 58.5-14.4 83.1-39s33.9-57.2 39-83.1l0-.2 0-.2c1.5-8.2 3.8-16 6.9-23.5l0 0c5.5-13.4 13.7-26 24.5-37l0 0C302.4 45.2 331.6 32 364 32h68c26.5 0 48 21.5 48 48v68c0 15.8-3.1 30.8-8.8 44.4l0 0c-5.6 13.6-14 26.4-25.2 37.6c-11.2 11.2-24 19.6-37.7 25.2l0 0c-7.5 3.1-15.3 5.4-23.5 6.9l-.2 0-.2 0c-25.9 5.1-58.5 14.4-83.1 39s-33.9 57.2-39 83.1l0 .2 0 .2c-1.5 8.2-3.8 16-6.9 23.5l0 0c-5.5 13.4-13.7 26-24.5 37l0 0C209.6 466.8 180.4 480 148 480H80c-26.5 0-48-21.5-48-48V364c0-15.8 3.1-30.8 8.8-44.4l0 0c5.6-13.6 14-26.4 25.2-37.6c11.2-11.2 24-19.6 37.7-25.2l0 0c7.5-3.1 15.3-5.4 23.5-6.9zM148 512c41.3 0 78.7-16.9 105.5-44.2c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.5-7.2 33.9-17.9 48.1-32.1c14.2-14.2 24.9-30.5 32.1-48C508 187.2 512 168.1 512 148V80c0-44.2-35.8-80-80-80H364c-41.3 0-78.7 16.9-105.5 44.2c-13.8 14-24.2 30.1-31.3 47.2c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364v68c0 44.2 35.8 80 80 80h68zM435.2 128a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm-64 64a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm-224 224a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM192 435.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM435.2 192a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM192 371.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4z"]
};
var faWrenchSimple = {
  prefix: 'fal',
  iconName: 'wrench-simple',
  icon: [384, 512, [], "e2d1", "M137 2.8c4.4 3 7 7.9 7 13.2V168l48 36 48-36V16c0-5.3 2.6-10.2 7-13.2s9.9-3.6 14.8-1.7C332.9 28.9 384 94.1 384 176c0 71.1-38.6 133.1-96 166.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V332.8c0-6 3.4-11.5 8.7-14.2C316.6 292.1 352 238.2 352 176c0-58.9-31.9-107.7-80-134.8V176c0 5-2.4 9.8-6.4 12.8l-64 48c-5.7 4.3-13.5 4.3-19.2 0l-64-48c-4-3-6.4-7.8-6.4-12.8V41.2C63.9 68.3 32 117.1 32 176c0 62.2 35.4 116.1 87.3 142.6c5.4 2.7 8.7 8.2 8.7 14.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.3C38.6 309.1 0 247.1 0 176C0 94.1 51.1 28.9 122.2 1.1C127.1-.8 132.7-.2 137 2.8z"]
};
var faBlender = {
  prefix: 'fal',
  iconName: 'blender',
  icon: [512, 512, [], "f517", "M0 72C0 32.2 32.2 0 72 0h56 24 8.1H471c20.8 0 36.1 19.6 31 39.8L423.1 355.4C456 365.3 480 395.9 480 432v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-37.8 26.2-69.5 61.5-77.9L148 240H72c-39.8 0-72-32.2-72-72V72zM128 432v32c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V432c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zM423 224H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H431l16-64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H455l16-64H162.8l26.7 320H391l32-128zM72 32C49.9 32 32 49.9 32 72v96c0 22.1 17.9 40 40 40h73.3L130.7 32H72zM288 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTeeth = {
  prefix: 'fal',
  iconName: 'teeth',
  icon: [576, 512, [], "f62e", "M96 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H480c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H96zM0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm160 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h64V224zM96 288v32c0 17.7 14.3 32 32 32s32-14.3 32-32V288H96zm75.5 79c-11.4 10.6-26.7 17-43.5 17c-35.3 0-64-28.7-64-64V272 224c0-35.3 28.7-64 64-64c14 0 27 4.5 37.6 12.2c10.9-26 36.5-44.2 66.4-44.2c22.6 0 42.8 10.4 56 26.7c13.2-16.3 33.4-26.7 56-26.7c29.9 0 55.5 18.2 66.4 44.2C421 164.5 434 160 448 160c35.3 0 64 28.7 64 64v48 48c0 35.3-28.7 64-64 64c-16.8 0-32-6.5-43.5-17c-12.8 19.9-35.1 33-60.5 33c-22.6 0-42.8-10.4-56-26.7c-13.2 16.3-33.4 26.7-56 26.7c-25.4 0-47.7-13.2-60.5-33zM232 160c-22.1 0-40 17.9-40 40v24 32h80V200c0-22.1-17.9-40-40-40zM192 320v8c0 22.1 17.9 40 40 40s40-17.9 40-40V288H192v32zm224-64h64V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v32zm0 64c0 17.7 14.3 32 32 32s32-14.3 32-32V288H416v32zm-72 48c22.1 0 40-17.9 40-40v-8V288H304v40c0 22.1 17.9 40 40 40zm40-112V224 200c0-22.1-17.9-40-40-40s-40 17.9-40 40v56h80z"]
};
var faTally2 = {
  prefix: 'fal',
  iconName: 'tally-2',
  icon: [640, 512, [], "e295", "M144 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48z"]
};
var faShekelSign = {
  prefix: 'fal',
  iconName: 'shekel-sign',
  icon: [448, 512, [8362, "ils", "shekel", "sheqel", "sheqel-sign"], "f20b", "M80 32C53.5 32 32 53.5 32 80V464c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16H192c44.2 0 80 35.8 80 80V336c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-61.9-50.1-112-112-112H80zM304 480c61.9 0 112-50.1 112-112V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 44.2-35.8 80-80 80H192c-8.8 0-16-7.2-16-16V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 26.5 21.5 48 48 48H304z"]
};
var faIls = faShekelSign;
var faShekel = faShekelSign;
var faSheqel = faShekelSign;
var faSheqelSign = faShekelSign;
var faCars = {
  prefix: 'fal',
  iconName: 'cars',
  icon: [640, 512, [], "f85b", "M124.2 32H259.8c14.3 0 26.8 9.5 30.8 23.2L306.8 112c-.9 0-1.9 0-2.8 0H80c-.9 0-1.9 0-2.8 0L93.4 55.2C97.4 41.5 109.9 32 124.2 32zM62.7 46.4L41 122.1C16.6 135.8 0 162 0 192v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V288H257.6c3.7-3.7 7.7-7.1 11.9-10.2l6.2-21.8H32V240 192c0-26.5 21.5-48 48-48H304c11.8 0 22.6 4.3 31 11.3c10.3-5.5 21.6-9.2 33.6-10.6c-6.8-9.2-15.5-17-25.6-22.6L321.3 46.4C313.5 18.9 288.4 0 259.8 0H124.2C95.6 0 70.5 18.9 62.7 46.4zM80 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm300.2-16H515.8c14.3 0 26.8 9.5 30.8 23.2L562.8 288c-.9 0-1.9 0-2.8 0H336c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L297 298.1c-24.5 13.7-41 39.9-41 69.9v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H608v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H380.2c-28.6 0-53.7 18.9-61.5 46.4zM608 416v16H288V416 368c0-26.5 21.5-48 48-48H560c26.5 0 48 21.5 48 48v48zM336 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faAxeBattle = {
  prefix: 'fal',
  iconName: 'axe-battle',
  icon: [512, 512, [], "f6b3", "M73.6 52.1C47.4 93.7 32 144.4 32 192c0 48.6 16.1 100.9 43.5 142.9c7.2-15 16.3-28.9 26.1-41c22.1-27.2 56.1-54.2 106.4-65v32.9c-38.6 9.9-64.4 31.2-81.6 52.3c-13.6 16.8-25 36.8-30.9 57.8c-1.5 5.8-6.1 10.4-11.9 11.7s-12-.7-15.8-5.3C25.5 327.7 0 257.4 0 192C0 126.4 25.6 56.5 67.7 5.7C71.8 .9 78.4-1.1 84.5 .7c6.1 1.8 10.5 7 11.3 13.3c2.9 20.2 12.8 40.3 24.9 56.4c15.9 21.3 42.5 43.5 87.2 52.9v32.6c-56.2-10.1-91.3-37.7-112.8-66.3C87 78.7 79.4 66 73.6 52.1zM304 261.8V228.9c50.3 10.8 84.4 37.8 106.5 65c9.9 12.1 18.9 26 26.1 41c20.8-32.1 35.2-70.2 40.8-108.2l-12.1-12.1c-12.5-12.5-12.5-32.8 0-45.3l12.1-12.1c-5.4-36.8-19.2-73.7-39-105.2C432.7 66 425 78.7 416.9 89.6c-21.5 28.6-56.7 56.2-112.9 66.3V123.3c44.8-9.4 71.3-31.7 87.3-52.9c12.1-16.1 22-36.2 24.9-56.4c.8-6.3 5.3-11.5 11.3-13.3c6.1-1.8 12.7 .2 16.8 5.1c37.2 44.9 61.5 104.6 66.7 163.2l-.4 .4L488 192l22.6 22.6 .4 .4c-5.2 58.5-29.4 118.6-66.7 163.2c-3.9 4.6-10 6.6-15.8 5.3s-10.5-5.9-11.9-11.7c-5.9-21-17.3-41-30.9-57.8c-17.2-21.1-43-42.4-81.7-52.3zM272 48V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faUserHairLong = {
  prefix: 'fal',
  iconName: 'user-hair-long',
  icon: [448, 512, [], "e45b", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM224 0c70.7 0 128 57.3 128 128c0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9c0 20.6-16.7 37.3-37.3 37.3H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.7c2.9 0 5.3-2.4 5.3-5.3c0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3c0 2.9 2.4 5.3 5.3 5.3H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H69.3C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128C96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM32 480H416c-1.9-71-60-128-131.5-128H163.6C92.1 352 33.9 409 32 480zM0 483.6C0 393.2 73.2 320 163.6 320H284.4C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z"]
};
var faMap = {
  prefix: 'fal',
  iconName: 'map',
  icon: [576, 512, [128506, 62072], "f279", "M170.1 33.1c3.3-1.3 6.9-1.5 10.3-.5L399.1 95.1l144-57.6c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 416.9l-144 57.6C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3l155-62zM32 122.8V440.4l128-51.2V71.6L32 122.8zm352 320V124.1L192 69.2V387.9l192 54.9zm32-2.4l128-51.2V71.6L416 122.8V440.4z"]
};
var faFileCircleInfo = {
  prefix: 'fal',
  iconName: 'file-circle-info',
  icon: [576, 512, [58604], "e493", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-32 96c0-8.8 7.2-16 16-16V384c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h0c8.8 0 16 7.2 16 16s-7.2 16-16 16H432 416c-8.8 0-16-7.2-16-16z"]
};
var faFaceDisappointed = {
  prefix: 'fal',
  iconName: 'face-disappointed',
  icon: [512, 512, [], "e36f", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 410.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faLassoSparkles = {
  prefix: 'fal',
  iconName: 'lasso-sparkles',
  icon: [576, 512, [], "e1c9", "M336 0c8.8 0 16 7.2 16 16V64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V96H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V16c0-8.8 7.2-16 16-16zM0 176C0 85.4 112 10.8 256 1.1v32C129.7 42 32 102.6 32 176c0 47.1 40.2 88.9 102.4 115.2l0 0c5.5 2.3 11.2 4.5 17 6.6l0 0C190.9 311.9 237.8 320 288 320c141.4 0 256-64.5 256-144c0-45.5-37.5-86-96-112.4V29.6C525.2 61.2 576 115 576 176c0 97.2-128.9 176-288 176c-22.9 0-45.3-1.6-66.7-4.7c11.9 17.2 18.7 38 18.7 59.7c0 58-47 105-105 105H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h87c40.3 0 73-32.7 73-73c0-27.6-15.6-52.9-40.4-65.3l-34.9-17.4C52.9 293 0 238.3 0 176zM512 368v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H512v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V368c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faClockEleven = {
  prefix: 'fal',
  iconName: 'clock-eleven',
  icon: [512, 512, [], "e347", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112v91.2l-34.7-52c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l64 96c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faRocket = {
  prefix: 'fal',
  iconName: 'rocket',
  icon: [512, 512, [], "f135", "M188.9 372l-50.4-50.4c18.6-42.6 61.7-137.7 95.1-187C304.6 30.1 409 24.6 475.7 36.3c11.7 66.7 6.2 171.1-98.4 242c-49.4 33.5-145.5 75.6-188.4 93.7zm-79.9-62.8c-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9c6.5-2.7 14.3-6 23-9.8L224 496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2V312.1c4-2.5 7.7-4.9 11.3-7.3C516.1 222.9 520.1 100.9 506.7 28.1c-2.1-11.6-11.2-20.6-22.8-22.8C411.1-8.1 289.1-4.1 207.2 116.7c-2.4 3.6-4.9 7.3-7.3 11.3l-90.2 0c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.8 .7 15.6s8.1 7.6 13.6 7.6H118.5c-3.6 8-6.8 15.2-9.4 21.2zM256 470.1l0-92.5c30.3-13.7 65.4-30.3 96-47v71.7c0 12.1-6.8 23.2-17.7 28.6L256 470.1zM109.7 160h71.5c-16.9 30.7-34 65.8-48.1 96H41.9L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"]
};
var faSirenOn = {
  prefix: 'fal',
  iconName: 'siren-on',
  icon: [640, 512, [], "e02e", "M55.2 33.7l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zm544 28.6l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 192H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H560c-8.8 0-16-7.2-16-16s7.2-16 16-16zM492 320H459.8L439.3 156c-2-16-15.6-28-31.8-28h-175c-16.1 0-29.8 12-31.8 28L180.2 320H148l21-167.9c4-32 31.2-56.1 63.5-56.1h175c32.3 0 59.5 24 63.5 56.1L492 320zm-250.1 0l14.2-114c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9L274.1 320H241.9zM496 384H144c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16zM144 352H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"]
};
var faClockTen = {
  prefix: 'fal',
  iconName: 'clock-ten',
  icon: [512, 512, [], "e354", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V226.1l-71.1-47.4c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l96 64c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faCandleHolder = {
  prefix: 'fal',
  iconName: 'candle-holder',
  icon: [448, 512, [128367], "f6bc", "M112 112c0 26.5 21.5 48 48 48s48-21.5 48-48c0-8.8-6.5-24-20.5-43.1C178.4 56.4 168 45.1 160 36.8c-8 8.3-18.4 19.6-27.5 32.1C118.5 88 112 103.2 112 112zm48 80c-44.2 0-80-35.8-80-80c0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zM0 496c0-8.8 7.2-16 16-16H64V272c0-26.5 21.5-48 48-48h32 64c26.5 0 48 21.5 48 48V480h72.6c-5.4-9.4-8.6-20.3-8.6-32c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64H256 224 96 64 16c-8.8 0-16-7.2-16-16zM128 256H112c-8.8 0-16 7.2-16 16V480H224V272c0-8.8-7.2-16-16-16H160v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256zM384 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faVideoArrowDownLeft = {
  prefix: 'fal',
  iconName: 'video-arrow-down-left',
  icon: [576, 512, [], "e2c8", "M320 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V336.8 175.2 128c0-35.3-28.7-64-64-64H64zM416 354.4l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2V377.8c0 3.4-2.8 6.2-6.2 6.2c-1 0-2.1-.3-3-.8L416 317.9v36.5zM224 352c8.8 0 16-7.2 16-16s-7.2-16-16-16H150.6L283.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L128 297.4V224c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16H224z"]
};
var faPhotoFilm = {
  prefix: 'fal',
  iconName: 'photo-film',
  icon: [640, 512, ["photo-video"], "f87c", "M576 32H256c-17.7 0-32 14.3-32 32V233.4L297.4 160c12.5-12.5 32.8-12.5 45.3 0L384 201.4 489.4 96c12.5-12.5 32.8-12.5 45.3 0L608 169.4V64c0-17.7-14.3-32-32-32zm64 176c0 0 0 0 0 .1v80c0 35.3-28.7 64-64 64H272c0 0 0 0 0 0H256c-35.3 0-64-28.7-64-64V272s0 0 0 0V64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V208zm-32 6.7l-96-96L395.3 235.3 310.6 320H576c17.7 0 32-14.3 32-32V214.6zM265.4 320l96-96L320 182.6l-96 96V288c0 17.7 14.3 32 32 32h9.4zM296 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM128 160h32v32H128v80V400v80H384V384h32v96h32c17.7 0 32-14.3 32-32V384h32v64c0 35.3-28.7 64-64 64H416 400 384 128 112 96 64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H96h16 16zM32 256H96V192H64c-17.7 0-32 14.3-32 32v32zm0 160v32c0 17.7 14.3 32 32 32H96V416H32zm64-32V288H32v96H96z"]
};
var faPhotoVideo = faPhotoFilm;
var faFloppyDiskCircleArrowRight = {
  prefix: 'fal',
  iconName: 'floppy-disk-circle-arrow-right',
  icon: [576, 512, ["save-circle-arrow-right"], "e180", "M32 96V416c0 17.7 14.3 32 32 32H275.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V170.5c0-8.5-3.4-16.6-9.4-22.6L332.1 73.4c-3.4-3.4-7.6-6-12.1-7.6V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64C46.3 64 32 78.3 32 96zM224 240c25.1 0 47.4 11.5 62.1 29.5c-6.9 10.2-12.8 21.2-17.4 32.8c-7-17.8-24.4-30.4-44.7-30.4c-26.5 0-48 21.5-48 48s21.5 48 48 48c12.5 0 23.9-4.8 32.4-12.6c-.3 4.2-.4 8.4-.4 12.6c0 8.3 .6 16.5 1.7 24.6C247.5 397.3 236 400 224 400c-44.2 0-80-35.8-80-80s35.8-80 80-80zM96 64v96H288V64H96zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-3.3 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
var faFolderMinus = {
  prefix: 'fal',
  iconName: 'folder-minus',
  icon: [512, 512, [], "f65d", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zm96 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faPlanetMoon = {
  prefix: 'fal',
  iconName: 'planet-moon',
  icon: [576, 512, [], "e01f", "M512 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 512 0a64 64 0 1 0 0 128zM224 480C118 480 32 394 32 288c0-8.1 .5-16.1 1.5-24H92.1c8.5 0 16.6 3.4 22.6 9.4L152 310.6v31.5c0 17 9.6 32.6 24.8 40.2c4.4 2.2 7.2 6.7 7.2 11.6v15.3C184 435 205 456 230.8 456c16.2 0 31.3-8.4 39.9-22.3l45.5-73.9c7.8-12.6 11.9-27.1 11.9-41.9V296c0-26.5-21.5-48-48-48H218.5c-5.2 0-10-3-12.4-7.7c-2.2-4.4-1.9-9.7 .9-13.9L249.3 163c9.8-14.7 14.4-32.1 13.3-49.7l-.9-13.6C349.6 117.2 416 194.8 416 288c0 106-86 192-192 192zM40.3 232C64.3 153.3 137.4 96 224 96c1.8 0 3.5 0 5.3 .1l1.3 19.3c.7 10.5-2.1 21-8 29.8l-42.3 63.5c-9.1 13.7-10.2 31.2-2.9 45.9c7.8 15.5 23.6 25.3 41 25.3H280c8.8 0 16 7.2 16 16v21.9c0 8.9-2.5 17.6-7.1 25.2L243.4 417c-2.7 4.4-7.5 7-12.6 7c-8.2 0-14.8-6.6-14.8-14.8V393.9c0-17-9.6-32.6-24.8-40.2c-4.4-2.2-7.2-6.7-7.2-11.6V304v-6.6l-4.7-4.7-41.9-41.9c-12-12-28.3-18.7-45.3-18.7H40.3zM227.2 64c-1.1 0-2.1 0-3.2 0C100.3 64 0 164.3 0 288S100.3 512 224 512s224-100.3 224-224c0-111.7-81.7-204.2-188.6-221.2l0 0c-10.5-1.7-21.3-2.6-32.3-2.8l0 0z"]
};
var faFaceEyesXmarks = {
  prefix: 'fal',
  iconName: 'face-eyes-xmarks',
  icon: [512, 512, [], "e374", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.8 48h8.4c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2H180.2c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zm8.4 32h-8.4c-29 0-53.2 20.6-58.6 48H318.8c-5.5-27.4-29.6-48-58.6-48zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faChartScatter = {
  prefix: 'fal',
  iconName: 'chart-scatter',
  icon: [512, 512, [], "f7ee", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM192 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56-216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDisplayArrowDown = {
  prefix: 'fal',
  iconName: 'display-arrow-down',
  icon: [576, 512, [], "e164", "M64 0H240V32H64C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H336V0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H360 216 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM245.6 416l-10.7 64H341.1l-10.7-64H245.6zM304 16V233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 233.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faStore = {
  prefix: 'fal',
  iconName: 'store',
  icon: [576, 512, [], "f54e", "M520.6 120.9l0 0c18.7 29.6 .3 66.6-29.2 70.6c-2.6 .3-5.2 .5-7.9 .5c-16.5 0-31.2-7.2-41.5-18.5c-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C254 184.8 239.3 192 222.7 192c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C123.6 184.8 109 192 92.4 192c-2.6 0-5.2-.2-7.9-.5c-29.3-4-47.7-41-29.1-70.6l0 0L111.6 32H464.4l56.2 88.9zM483.4 224c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2zM80 256c-8.8 0-16 7.2-16 16v80 16 16 64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 368 352 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H96V272c0-8.8-7.2-16-16-16zM96 384H480v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384z"]
};
var faArrowTrendUp = {
  prefix: 'fal',
  iconName: 'arrow-trend-up',
  icon: [576, 512, [], "e098", "M368 112c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V150.6L331.3 363.3c-6.2 6.2-16.4 6.2-22.6 0L192 246.6 27.3 411.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l176-176c6.2-6.2 16.4-6.2 22.6 0L320 329.4 521.4 128H384c-8.8 0-16-7.2-16-16z"]
};
var faPlugCircleMinus = {
  prefix: 'fal',
  iconName: 'plug-circle-minus',
  icon: [576, 512, [], "e55e", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-144c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]
};
var faOliveBranch = {
  prefix: 'fal',
  iconName: 'olive-branch',
  icon: [640, 512, [], "e317", "M128 96C89.1 96 59.2 78.1 41.6 64C59.2 49.9 89.1 32 128 32s68.8 17.9 86.4 32C196.8 78.1 166.9 96 128 96zm0-96C59.2 0 14.1 44.2 2.8 56.6C.9 58.6 0 61.2 0 64s.9 5.4 2.8 7.4c8.2 8.9 34 34.5 73.8 48C30.6 147.6 0 198.2 0 256v16c0 8.8 7.2 16 16 16H48c88.4 0 160-71.6 160-160V114.4L330.4 55.6C362.8 40.1 398.3 32 434.3 32H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H434.3c-40.7 0-81 9.2-117.7 26.8L253.6 57c-.1-.2-.3-.3-.4-.4C241.9 44.2 196.8 0 128 0zm47.7 128c.1 0 .2 0 .3 0c0 70.7-57.3 128-128 128H32c0-70.7 57.3-128 128-128h15.7zM412.2 436.6C390.7 465.2 363.4 480 336 480s-54.7-14.8-76.2-43.4S224 366.8 224 320s14.3-87.9 35.8-116.6C281.3 174.8 308.6 160 336 160s54.7 14.8 76.2 43.4C433.7 232.1 448 273.2 448 320s-14.3 87.9-35.8 116.6zM336 512c79.5 0 144-86 144-192s-64.5-192-144-192s-144 86-144 192s64.5 192 144 192zm129.7-40.2c52.9 16.5 105.5 8.4 139.6-27c56.2-58.3 41-168.6-33.9-246.4c-42.9-44.5-96.1-68.7-144.2-70.3c13.6 10.4 25.7 22.9 36.2 36.9c.5 .7 1 1.4 1.5 2c28.3 9 57.7 26.8 83.4 53.5c33.1 34.4 52.4 75.3 57.5 112.6c5.2 37.5-3.9 68.9-23.6 89.3c-19.5 20.2-48.9 29.2-84 24c-5-.7-10.1-1.8-15.2-3.1c-5.2 10-11 19.5-17.4 28.3z"]
};
var faAngle = {
  prefix: 'fal',
  iconName: 'angle',
  icon: [448, 512, [], "e08c", "M238.3 55.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-208 416c-2.5 5-2.2 10.8 .7 15.6s8.1 7.6 13.6 7.6H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H41.9L238.3 55.2zM295 238.9c-16.3-20.5-35-39.1-55.6-55.2c-7.7-6.1-19-3.2-23.4 5.6c-3.5 7.1-1.4 15.6 4.8 20.5c17.8 14.1 34 30.2 48.2 47.9c5.3 6.6 14.7 8.4 21.9 3.9c7.8-4.9 9.9-15.4 4.1-22.7zm14.5 84.9c9.9 22.2 17.3 45.7 21.7 70.3c1.4 8 8.2 14 16.3 14c9.6 0 17.2-8.4 15.5-17.9c-4.9-28.4-13.4-55.5-25-81c-3.9-8.6-14.5-11.4-22.5-6.4c-7 4.4-9.4 13.5-6 21z"]
};
var faVacuumRobot = {
  prefix: 'fal',
  iconName: 'vacuum-robot',
  icon: [512, 512, [], "e04e", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM356.7 155.3c-55.6-55.6-145.8-55.6-201.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c68.1-68.1 178.5-68.1 246.6 0s68.1 178.5 0 246.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c55.6-55.6 55.6-145.8 0-201.4zm-144 57.4c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z"]
};
var faSignHanging = {
  prefix: 'fal',
  iconName: 'sign-hanging',
  icon: [512, 512, ["sign"], "f4d9", "M80 0c8.8 0 16 7.2 16 16V64l400 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16l48 0V16C64 7.2 71.2 0 80 0zm80 160l0 192H448V160H160zm-32 0c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160z"]
};
var faSign = faSignHanging;
var faSquareDivide = {
  prefix: 'fal',
  iconName: 'square-divide',
  icon: [448, 512, [], "e26a", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM128 240H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSignalStreamSlash = {
  prefix: 'fal',
  iconName: 'signal-stream-slash',
  icon: [640, 512, [], "e250", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 256c0-70.7-25.5-135.5-67.8-185.6c-5.7-6.8-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5C521.4 135.6 544 193.1 544 256c0 29.5-5 57.8-14.1 84.1L556.3 361C569 328.5 576 293 576 256zm-96 0c0-46.4-16.5-89-43.9-122.2c-5.6-6.8-15.7-7.8-22.5-2.1s-7.8 15.7-2.1 22.5C434.3 181.9 448 217.3 448 256c0 6.3-.4 12.5-1.1 18.7l28.6 22.6c2.9-13.3 4.4-27.1 4.4-41.3zM139.9 195.3l-26-20.5C102.4 199.5 96 227 96 256c0 46.4 16.5 89 43.9 122.2c5.6 6.8 15.7 7.8 22.5 2.1s7.8-15.7 2.1-22.5C141.7 330.1 128 294.7 128 256c0-21.5 4.2-42 11.9-60.7zm-77.2-61L37.2 114.3C13.5 156.1 0 204.5 0 256c0 70.7 25.5 135.5 67.8 185.6c5.7 6.8 15.8 7.6 22.5 1.9s7.6-15.8 1.9-22.5C54.6 376.4 32 318.9 32 256c0-44 11.1-85.4 30.7-121.6z"]
};
var faBezierCurve = {
  prefix: 'fal',
  iconName: 'bezier-curve',
  icon: [640, 512, [], "f55b", "M352 64c8.8 0 16 7.2 16 16v21.2V112v22 10c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16V134 112 101.2 80c0-8.8 7.2-16 16-16h64zm83.4 64H514c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64s-28.7-64-64-64c-29.8 0-54.9 20.4-62 48H400V80c0-26.5-21.5-48-48-48H288c-26.5 0-48 21.5-48 48V96H126c-7.1-27.6-32.2-48-62-48C28.7 48 0 76.7 0 112s28.7 64 64 64c29.8 0 54.9-20.4 62-48h78.6C139.5 167.2 96 238.5 96 320l-16 0c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48l-16 0c0-77.5 45.9-144.3 112-174.6c.7 25.9 21.9 46.6 48 46.6h64c26 0 47.2-20.7 48-46.6c66.1 30.3 112 97.1 112 174.6l-16 0c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48l-16 0c0-81.5-43.5-152.8-108.6-192zM544 352l16 0c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16l16 0h32zm-416 0l16 0c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16l16 0h32zM32 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm512 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faEyeDropperHalf = {
  prefix: 'fal',
  iconName: 'eye-dropper-half',
  icon: [512, 512, [], "e173", "M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l0 0-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4 0 0 0 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 62.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6v41.2L3.8 469.1C1.3 473.5 0 478.4 0 483.4C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480h41.2c21.2 0 41.6-8.4 56.6-23.4L299.3 347.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H102.6l84.7-84.7zM64 378.5c0-9.5 2.8-18.7 8-26.5H249.4l-81.9 81.9c-9 9-21.2 14.1-33.9 14.1H88 83.8l-3.7 2.1L37.7 474.3l24.2-42.4 2.1-3.7V424 378.5z"]
};
var faStoreLock = {
  prefix: 'fal',
  iconName: 'store-lock',
  icon: [640, 512, [], "e4a6", "M520.6 120.9l0 0c8.1 12.7 9.2 26.8 5.6 39.1c.6 0 1.2 0 1.8 0c10.4 0 20.5 1.4 30.1 4.1c4.4-19.8 1.5-41.5-10.4-60.3L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c1.2 .9 2.5 1.8 3.8 2.7c6.1-9.1 13.5-17.2 22-24.1c-5.7-3.1-10.8-7.1-15.1-11.8c-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C254 184.8 239.3 192 222.7 192c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C123.6 184.8 109 192 92.4 192c-2.6 0-5.2-.2-7.9-.5c-29.3-4-47.7-41-29.1-70.6l0 0L111.6 32H464.4l56.2 88.9zM96 352V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v80 16 16 64c0 35.3 28.7 64 64 64H392.6c-5.4-9.4-8.6-20.3-8.6-32l-256 0c-17.7 0-32-14.3-32-32V384H384V352L96 352zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faBellSlash = {
  prefix: 'fal',
  iconName: 'bell-slash',
  icon: [640, 512, [128277, 61943], "f1f6", "M378.8 384H140.3c-6.8 0-12.3-5.5-12.3-12.3c0-3.3 1.3-6.4 3.6-8.7l2.8-2.8c33.4-33.4 53.5-77.5 57.1-124.2L160 211.2v9.9c0 43.7-17.4 85.6-48.3 116.6l-2.8 2.8c-8.3 8.3-13 19.6-13 31.3c0 24.5 19.8 44.3 44.3 44.3H419.4l-40.5-32zM304 32.8C264.5 36.7 229.2 55 203.4 82.4l25.2 19.9C251.9 78.7 284.2 64 320 64c70.7 0 128 57.3 128 128v29.1c0 21.4 3.5 42.5 10.2 62.4l75.1 59.3c-.7-.8-1.5-1.7-2.3-2.5l-2.8-2.8C497.4 306.7 480 264.8 480 221.1V192c0-83-63.1-151.2-144-159.2V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32.8zM289.8 458.7c-2.9-8.3-12.1-12.7-20.4-9.8s-12.7 12.1-9.8 20.4c8.8 24.8 32.5 42.7 60.4 42.7s51.6-17.8 60.4-42.7c2.9-8.3-1.4-17.5-9.8-20.4s-17.5 1.4-20.4 9.8C345.8 471.1 333.9 480 320 480s-25.8-8.9-30.2-21.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faCloudBoltSun = {
  prefix: 'fal',
  iconName: 'cloud-bolt-sun',
  icon: [640, 512, ["thunderstorm-sun"], "f76e", "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-7.2-7.9-13.4-16.7-18.4-26.2l-35.2 24.6-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 8.5 51c8.8-7.5 18.7-13.9 29.3-18.8L303.8 13.4zM208 120c-48.6 0-88 39.4-88 88c0 31 16 58.2 40.1 73.9c.6-12.5 2.9-24.5 6.8-35.7c-9.3-10-15-23.4-15-38.1c0-30.9 25.1-56 56-56c13.2 0 25.4 4.6 35 12.3c2.4-11 6.3-21.4 11.3-31.1C240.8 124.8 225 120 208 120zm96 72c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H543.9c-.5 11.8-4.9 23-12.4 32h25.7c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 114.6 402.9 96 368 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 42 27 77.7 64.6 90.7c1.6-10.9 6.5-21.1 14.1-29.1C243.7 342 224 317.3 224 288c0-35.3 28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm31.7 184l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4H335.7zM457.6 224c-5.1 0-10.1 2-13.8 5.5L294.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6H359l-34.9 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5L505.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6H441l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"]
};
var faThunderstormSun = faCloudBoltSun;
var faCameraSlash = {
  prefix: 'fal',
  iconName: 'camera-slash',
  icon: [640, 512, [], "e0d9", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 376.6V160c0-35.3-28.7-64-64-64H440.9L430.5 64.8C423.9 45.2 405.6 32 384.9 32H255.1c-20.7 0-39 13.2-45.5 32.8l-5.9 17.8 26.7 21.1 9.6-28.7c2.2-6.5 8.3-10.9 15.2-10.9H384.9c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9H512c17.7 0 32 14.3 32 32V351.3l32 25.3zM96 160.7L67.7 138.4c-2.4 6.8-3.7 14-3.7 21.6V416c0 35.3 28.7 64 64 64H500.4l-40.5-32H128c-17.7 0-32-14.3-32-32V160.7zM378.4 383.6l-27.6-21.8c-9.5 4-19.9 6.1-30.8 6.1c-44.2 0-80-35.8-80-80c0-4.4 .3-8.6 1-12.8l-27.6-21.8c-3.5 10.9-5.4 22.5-5.4 34.6c0 61.9 50.1 112 112 112c21.4 0 41.4-6 58.4-16.4z"]
};
var faCommentQuote = {
  prefix: 'fal',
  iconName: 'comment-quote',
  icon: [512, 512, [], "e14c", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM208 176v24 24H160V176h48zm-48 80h48c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C215 322.7 240 290.7 240 254V224 200 176c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm144-80h48v24 24H304V176zm48 80c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C359 322.7 384 290.7 384 254V224 200 176c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h48z"]
};
var faTablet = {
  prefix: 'fal',
  iconName: 'tablet',
  icon: [448, 512, ["tablet-android"], "f3fb", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTabletAndroid = faTablet;
var faSchoolFlag = {
  prefix: 'fal',
  iconName: 'school-flag',
  icon: [576, 512, [], "e56e", "M304 64h80V32H304V64zM272 16c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H315.5l89.6 64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H352 320 256 224 64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H170.9L272 87.8V64 16zm48 400c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm32 64H512c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H400c-3.3 0-6.6-1-9.3-3L288 115.7 185.3 189c-2.7 1.9-6 3-9.3 3H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H224V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64zM256 240a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM64 256c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zm64 0H96v32h32V256zm320-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v32h32V256H448zM64 384c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V384zm64 0H96v32h32V384zm320-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm0 32v32h32V384H448z"]
};
var faMessageCode = {
  prefix: 'fal',
  iconName: 'message-code',
  icon: [512, 512, [], "e1df", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM219.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 208l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L345.4 208l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"]
};
var faGlassHalf = {
  prefix: 'fal',
  iconName: 'glass-half',
  icon: [384, 512, ["glass-half-empty", "glass-half-full"], "e192", "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7H343.8c4.7 0 8.4 4 8 8.7L336 228.1V224H48v5.1L32.1 40.7zM50.3 256H333.6L317.2 450.7C315.8 467.3 302 480 285.4 480H98.6c-16.6 0-30.5-12.7-31.9-29.3L50.3 256zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512H285.4c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1z"]
};
var faGlassHalfEmpty = faGlassHalf;
var faGlassHalfFull = faGlassHalf;
var faFill = {
  prefix: 'fal',
  iconName: 'fill',
  icon: [512, 512, [], "f575", "M59.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l97.4 97.4L30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0l-64.4 64.4L59.3 4.7zm97.4 142.6l88 88c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-88-88 64.4-64.4c15.6-15.6 40.9-15.6 56.6 0L451.7 211.7c15.6 15.6 15.6 40.9 0 56.6L432 288H35c1.7-13.6 7.8-26.8 18.2-37.3L156.7 147.3zM53.3 341.3C47 335 42.3 327.7 39.2 320H400L261.3 458.7c-25 25-65.5 25-90.5 0L53.3 341.3z"]
};
var faMessageMinus = {
  prefix: 'fal',
  iconName: 'message-minus',
  icon: [512, 512, ["comment-alt-minus"], "f4a7", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faCommentAltMinus = faMessageMinus;
var faAngleUp = {
  prefix: 'fal',
  iconName: 'angle-up',
  icon: [448, 512, [8963], "f106", "M212.7 148.7c6.2-6.2 16.4-6.2 22.6 0l160 160c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160z"]
};
var faDinosaur = {
  prefix: 'fal',
  iconName: 'dinosaur',
  icon: [640, 512, [], "e5fe", "M417.6 19.2C426.7 7.1 440.9 0 456 0h13C563.5 0 640 76.5 640 170.9v50.9c0 76.5-39.4 147.6-104.3 188.2L512 424.9V464c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V453c-3.5 .9-7.5 1.8-11.7 2.6c-14.2 3-32.3 6-52.4 7.5c-.5-11.2-3.4-21.9-8.2-31.5c20.5-1.1 39.4-4.1 54-7.2c9.1-1.9 16.5-3.8 21.6-5.3c2.5-.7 4.5-1.3 5.8-1.7c.6-.2 1.1-.4 1.4-.5l.3-.1 .1 0 0 0c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V416.3c0-2.8 .6-5.6 2-8s3.4-4.5 5.8-6l31-19.4c55.5-34.7 89.2-95.6 89.2-161V170.9C608 94.2 545.8 32 469.1 32H456c-5.1 0-9.8 2.4-12.8 6.4l-6.8 9.1c-6.7 8.9-15.8 15.9-26.1 20c-11 4.4-18.2 15.1-18.2 26.9v1.8c0 17.5 14.2 31.7 31.7 31.7h74.5c34.1 0 61.8 27.7 61.8 61.8v23c0 32.7-26.5 59.1-59.1 59.1c-27.3 0-53.9-8.5-76.2-24.4l-26-18.6c-33.7-24.1-74-37-115.4-37c-49.6 0-97.3 18.5-133.9 51.9L61.1 324.4C42.6 341.4 32 365.4 32 390.5c0 49.4 40.1 89.5 89.5 89.5h121c7.5 0 13.5-6.1 13.5-13.5c0-6.4-4.4-11.9-10.7-13.2l-97.6-21.1C117.5 425.6 96 398.9 96 368c0-8.8 7.2-16 16-16s16 7.2 16 16c0 15.8 11 29.5 26.5 32.8L252.1 422C273 426.5 288 445 288 466.5c0 25.1-20.4 45.5-45.5 45.5h-121C54.4 512 0 457.6 0 390.5c0-34.1 14.4-66.7 39.6-89.7l88.2-80.5c42.5-38.8 97.9-60.3 155.5-60.3c48.1 0 94.9 15 134 43l26 18.6c16.8 12 36.9 18.4 57.6 18.4c15 0 27.1-12.1 27.1-27.1v-23c0-16.5-13.4-29.8-29.8-29.8H423.7c-35.2 0-63.7-28.5-63.7-63.7V94.5c0-24.9 15.2-47.4 38.3-56.6c4.9-2 9.2-5.3 12.4-9.5l6.8-9.1zM448 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faDrumstickBite = {
  prefix: 'fal',
  iconName: 'drumstick-bite',
  icon: [512, 512, [], "f6d7", "M192 272c0 26.5 21.5 48 48 48h88.2c-5.3-15-8.2-31.2-8.2-48c0-79.5 64.5-144 144-144c2.6 0 5.3 .1 7.9 .2C452.2 72.2 398.8 32 336 32c-79.5 0-144 64.5-144 144v96zm-32 0V176C160 78.8 238.8 0 336 0c86.5 0 158.5 62.5 173.2 144.8c2.1 11.8-10.3 20.1-22 17.6c-7.5-1.6-15.3-2.4-23.2-2.4c-61.9 0-112 50.1-112 112c0 19.2 4.8 37.2 13.3 53c5.7 10.5 1.1 24.8-10.8 26c-6.1 .6-12.3 1-18.5 1H240c-3 0-6-.2-8.9-.5L192 390.6l0 0 0 .1c0 .1-.1 .5-.1 1.2c.1 1.5 .7 3.5 2 5.2c8.9 12 14.2 26.9 14.2 42.9c0 39.8-32.2 72-72 72c-37.2 0-67.8-28.2-71.6-64.4C28.2 443.8 0 413.2 0 376c0-39.8 32.2-72 72-72c16.1 0 30.9 5.3 42.9 14.2c1.7 1.2 3.7 1.9 5.2 2c.7 0 1.1-.1 1.2-.1l.1 0 39.1-39.1c-.3-2.9-.5-5.9-.5-8.9zm12.2 42.4L144 342.7c-15 15-36.5 9.9-48.1 1.2C89.2 338.9 81 336 72 336c-22.1 0-40 17.9-40 40s17.9 40 40 40c13.1 0 24 10.9 24 24c0 22.1 17.9 40 40 40s40-17.9 40-40c0-9-2.9-17.2-7.9-23.8c-8.7-11.7-13.7-33.2 1.2-48.1l28.2-28.2c-10.3-6.4-18.9-15.1-25.4-25.4z"]
};
var faLinkHorizontalSlash = {
  prefix: 'fal',
  iconName: 'link-horizontal-slash',
  icon: [640, 512, ["chain-horizontal-slash"], "e1cc", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 320c0-70.7-57.3-128-128-128H480c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c53 0 96 43 96 96c0 24.2-8.9 46.3-23.7 63.1L609.5 403c19-22.3 30.5-51.3 30.5-83zM459.9 448l-40.5-32H335.9c-52.9 0-95.9-42.9-95.9-95.9c0-13.9 3-27.2 8.4-39.2l-25.7-20.3c-9.4 17.8-14.6 38.1-14.6 59.5C208 390.8 265.2 448 335.9 448H459.9zM400 191.9c0 13.9-3 27.2-8.4 39.2l25.7 20.3c9.4-17.8 14.6-38.1 14.6-59.5C432 121.2 374.8 64 304.1 64H180.1l40.5 32h83.5c52.9 0 95.9 42.9 95.9 95.9zm-344.3-63L30.5 109C11.5 131.4 0 160.3 0 192c0 70.7 57.3 128 128 128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96c0-24.2 8.9-46.3 23.7-63.1z"]
};
var faChainHorizontalSlash = faLinkHorizontalSlash;
var faHollyBerry = {
  prefix: 'fal',
  iconName: 'holly-berry',
  icon: [512, 512, [], "f7aa", "M288 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 0a64 64 0 1 0 0 128A64 64 0 1 0 256 0zM128 289.3V268.4l2.3 .8c24 8 49.8 8.7 74.2 2.1l5.9-1.6-1.6 5.9c-6.6 24.4-5.9 50.2 2.1 74.2l1 2.9C164.6 358 128 398.1 128 446.7l0 20.9-2.3-.8c-24-8-49.8-8.7-74.2-2.1l-5.9 1.6 1.6-5.9c6.6-24.4 5.9-50.2-2.1-74.2l-1-2.9C91.4 378 128 337.9 128 289.3zM115.6 497.2l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4c-4.9 17.9 11.6 34.4 29.5 29.5L60 495.6c18.3-5 37.6-4.5 55.6 1.5zm46-415.6c-28.4 6.5-49.6 32-49.6 62.4c0 35.3 28.7 64 64 64c30.4 0 55.8-21.2 62.4-49.6c-10.9-2-21.2-5.9-30.5-11.3C206.3 163.3 192.6 176 176 176c-17.7 0-32-14.3-32-32c0-16.6 12.7-30.3 28.9-31.9c-5.4-9.3-9.3-19.6-11.3-30.5zm112 76.8c6.5 28.4 32 49.6 62.4 49.6c35.3 0 64-28.7 64-64c0-30.4-21.2-55.8-49.6-62.4c-2 10.9-5.9 21.2-11.3 30.5c16.2 1.5 28.9 15.2 28.9 31.9c0 17.7-14.3 32-32 32c-16.6 0-30.3-12.7-31.9-28.9c-9.3 5.4-19.6 9.3-30.5 11.3zM384 289.3c0 48.6 36.6 88.7 83.8 94.1l-1 2.9c-8 24-8.7 49.8-2.1 74.2l1.6 5.9-5.9-1.6c-24.4-6.6-50.2-5.9-74.2 2.1l-2.3 .8 0-20.9c0-48.6-36.6-88.7-83.8-94.1l1-2.9c8-24 8.7-49.8 2.1-74.2l-1.6-5.9 5.9 1.6c24.4 6.6 50.2 5.9 74.2-2.1l2.3-.8v20.9zm12.4 207.9c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.7 452c-5-18.3-4.5-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-19.4-5.3c-17.9-4.9-34.4 11.6-29.5 29.5l5.3 19.4c5 18.3 4.4 37.6-1.5 55.6l-4.3 12.8c-5.2 15.5 6.4 31.6 22.8 31.6c34.6 0 62.7 28.1 62.7 62.7v32c0 16.4 16 27.9 31.6 22.8l12.8-4.3z"]
};
var faNose = {
  prefix: 'fal',
  iconName: 'nose',
  icon: [448, 512, [], "e5bd", "M190.2 8.6c-4.1-7.8-13.7-10.9-21.6-6.8s-10.9 13.7-6.8 21.6c74 142.4 171.9 248.6 223.7 299.3c19.1 18.7 30.5 43.7 30.5 69.6c0 48.5-39.3 87.7-87.7 87.7h-34l-2.3-2.6-38.7-43.5c-19.1-21.5-46.5-33.8-75.3-33.8c-27.6 0-49.9 22.3-49.9 49.9V456c0 30.9 25.1 56 56 56H328.3C394.4 512 448 458.4 448 392.3c0-35.3-15.5-68.3-40.1-92.4c-50.5-49.5-145.8-153-217.7-291.2zm39.1 446.5L251.5 480H184c-13.3 0-24-10.7-24-24v-6.1c0-9.9 8-17.9 17.9-17.9c19.7 0 38.4 8.4 51.4 23.1zm-98-151.4c8.6-1.9 14.1-10.4 12.3-19s-10.4-14.1-19-12.3l-22.8 4.9C42.4 290 0 342.4 0 403.2c0 38.2 17 74.5 46.3 98.9l7.4 6.2c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5l-7.4-6.2C44.8 459.1 32 431.9 32 403.2c0-45.6 31.9-85.1 76.5-94.6l22.8-4.9z"]
};
var faChevronLeft = {
  prefix: 'fal',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", "M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z"]
};
var faBacteria = {
  prefix: 'fal',
  iconName: 'bacteria',
  icon: [640, 512, [], "e059", "M310.4 1.3c8.1 3.5 11.8 12.9 8.3 21.1L314 33.1C329.7 41 342.7 53.8 350.9 70l10.7-4.7c8.1-3.5 17.5 .2 21.1 8.3s-.2 17.5-8.3 21.1l-14.7 6.4c1.7 20.2-4 39.8-15.3 55.6l6 3.7c7.5 4.7 9.8 14.5 5.2 22s-14.5 9.8-22 5.2l-13.3-8.2c-7.6 4.7-16.2 8.3-25.4 10.5c-6.8 1.6-13.2 3.4-19.1 5.4l3.8 17.3c1.9 8.6-3.5 17.2-12.1 19.1s-17.2-3.5-19.1-12.1L246 208.8c-19.4 11.6-31.2 25.3-38.8 37.2l7.6 3.6c8 3.8 11.4 13.3 7.6 21.3s-13.3 11.4-21.3 7.6l-7.4-3.5c-1 3.3-1.7 6.7-2.3 10.1c-1.5 14.1-6.5 27.1-14 38.1L187.6 334c6.1 6.4 5.8 16.6-.6 22.6s-16.6 5.8-22.6-.6l-9.6-10.2c-15.3 10.2-34 15.6-53.7 13.9l-6.4 14.7c-3.5 8.1-12.9 11.8-21.1 8.3s-11.8-13-8.3-21.1L70 350.9c-16-8.1-28.9-21.1-36.9-36.9l-10.7 4.7c-8.1 3.5-17.5-.2-21.1-8.3s.2-17.5 8.3-21.1L24.3 283c-.4-4.8-.4-9.6 .1-14.6c1.1-12.1 3.8-24.2 7-35.9c.2-.9 .5-1.7 .7-2.6l-15.2-7.6c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l11.6 5.8c4.8-11.7 11-24.2 18.8-37.2c1.9-3.2 3.9-6.4 6.1-9.6l-5.1-3.8c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2l5 3.7c10.9-13.1 23.5-25.8 38.1-37.8L114.4 72.4c-4.6-7.5-2.3-17.4 5.2-22s17.4-2.3 22 5.2l9 14.7c14.5-9.4 30.6-18 48.3-25.5l-3.6-8.5c-3.5-8.1 .3-17.5 8.4-21s17.5 .3 21 8.4L229 33.8c9-2.8 18.3-5.4 28.1-7.6c8.7-2 17.4-2.6 25.8-1.9l6.4-14.7c3.5-8.1 12.9-11.8 21.1-8.3zM192 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm31.7 81.6c.1-.5 .1-.9 .2-1.4c2.8-18.2 10.3-34.8 18.2-48c16-26.7 46.7-59.1 109.6-73.6c28-6.5 45.4-34.4 39-62.4s-34.4-45.4-62.4-39c-93.1 21.5-146.4 73-175.4 121.4C74.8 202.3 66.7 224.5 62.2 241c-2.9 10.6-5.1 20.8-6 30.3c-2.6 28.6 18.5 53.8 47.1 56.4c28.3 2.6 53.3-18 56.4-46.1zm161.6 208l4.7-10.7c-15.6-7.9-28.7-20.7-36.9-36.9l-10.7 4.7c-8.1 3.5-17.5-.2-21.1-8.3s.2-17.5 8.3-21.1l14.7-6.4c-1.7-20.2 4-39.8 15.3-55.6l-6-3.7c-7.5-4.6-9.8-14.5-5.2-22s14.5-9.8 22-5.2l13.3 8.2c7.6-4.7 16.2-8.3 25.4-10.5c6.8-1.6 13.2-3.4 19.1-5.4l-3.8-17.3c-1.9-8.6 3.5-17.2 12.1-19.1s17.2 3.5 19.1 12.1l2.4 10.7c19.4-11.6 31.2-25.3 38.8-37.2l-7.6-3.6c-8-3.8-11.4-13.3-7.6-21.3s13.3-11.4 21.3-7.6l7.4 3.5c1-3.3 1.7-6.7 2.3-10.1c1.5-14.1 6.5-27.1 14-38.1L452.4 178c-6.1-6.4-5.8-16.6 .6-22.6s16.6-5.8 22.6 .6l9.6 10.2c15.3-10.2 34-15.6 53.7-13.9l6.4-14.7c3.5-8.1 12.9-11.8 21.1-8.3s11.8 12.9 8.3 21.1L570 161.1c16 8.1 28.9 21.1 36.9 36.9l10.7-4.7c8.1-3.5 17.5 .2 21.1 8.3s-.2 17.5-8.3 21.1l-14.7 6.4c.4 4.8 .4 9.6-.1 14.6c-1.1 12.1-3.8 24.2-7 35.9c-.2 .9-.5 1.7-.7 2.6l15.2 7.6c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-11.6-5.8c-4.8 11.7-11 24.2-18.8 37.2c-1.9 3.2-3.9 6.4-6.1 9.6l5.1 3.8c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-5-3.7c-10.9 13.1-23.5 25.8-38.1 37.8l10.3 16.8c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2l-9-14.7c-14.5 9.4-30.6 18-48.3 25.5l3.6 8.5c3.5 8.1-.3 17.5-8.4 21s-17.5-.3-21-8.4L411 478.2c-9 2.8-18.3 5.4-28.1 7.6c-8.7 2-17.4 2.6-25.8 1.9l-6.4 14.6c-3.5 8.1-12.9 11.8-21.1 8.3s-11.8-13-8.3-21.1zM416 408a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm64.3-177.6c0 .5-.1 .9-.2 1.4c-2.8 18.2-10.3 34.8-18.2 48c-16 26.7-46.7 59.1-109.6 73.6c-28 6.5-45.4 34.4-39 62.4s34.4 45.4 62.4 39c93.1-21.5 146.4-73 175.4-121.4c14.2-23.6 22.2-45.8 26.7-62.3c2.9-10.6 5.1-20.8 6-30.3c2.6-28.6-18.5-53.8-47.1-56.4c-28.3-2.6-53.3 18-56.4 46.1z"]
};
var faClouds = {
  prefix: 'fal',
  iconName: 'clouds',
  icon: [640, 512, [], "f744", "M208 32c39.9 0 73 29.2 79 67.4c.9 5.6 4.7 10.3 9.9 12.4s11.2 1.2 15.7-2.3C323.5 101 337.1 96 352 96c35.3 0 64 28.7 64 64c0 14.7-5 28.3-13.3 39.1l.9 .8c12.2-4.5 25.3-7.2 39-7.8c3.6-10 5.5-20.8 5.5-32.1c0-53-43-96-96-96c-14 0-27.2 3-39.2 8.4C296.8 30.1 255.9 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192s43 96 96 96h64.9c1.2-11.1 3.7-21.8 7.3-32H96c-35.3 0-64-28.7-64-64s28.7-64 64-64c4.4 0 8.7 .4 12.8 1.3c4.8 1 9.7-.3 13.4-3.4s5.9-7.7 5.8-12.6c0-.4 0-.9 0-1.3c0-44.2 35.8-80 80-80zm16 272c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H232c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM640 408c0-55.2-43-100.3-97.3-103.8C535.2 258.7 495.6 224 448 224c-19.3 0-37.3 5.7-52.4 15.5C375.3 210.8 341.9 192 304 192c-61.9 0-112 50.1-112 112c0 2.6 .1 5.3 .3 7.9C154.6 327.5 128 364.6 128 408c0 57.4 46.6 104 104 104H536c57.4 0 104-46.6 104-104z"]
};
var faMoneyBillSimple = {
  prefix: 'fal',
  iconName: 'money-bill-simple',
  icon: [576, 512, [], "e1f1", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faHandLizard = {
  prefix: 'fal',
  iconName: 'hand-lizard',
  icon: [512, 512, [], "f258", "M0 120C0 89.1 25.1 64 56 64H286.6c36.2 0 70.1 17.5 91.1 46.9L491.1 269.7c13.6 19 20.9 41.8 20.9 65.1V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V334.8c0-16.7-5.2-32.9-14.9-46.5L351.7 129.5c-15-21-39.3-33.5-65.1-33.5H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H256c35.3 0 64 28.7 64 64s-28.7 64-64 64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H272c3.2 0 6.2 .9 8.9 2.7l96 64c4.4 3 7.1 8 7.1 13.3v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V408.6L267.2 352H120c-30.9 0-56-25.1-56-56s25.1-56 56-56H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H56c-30.9 0-56-25.1-56-56z"]
};
var faTablePivot = {
  prefix: 'fal',
  iconName: 'table-pivot',
  icon: [512, 512, [], "e291", "M160 64v96H480V96c0-17.7-14.3-32-32-32H160zm0 128V448H448c17.7 0 32-14.3 32-32V192H160zM128 64H64C46.3 64 32 78.3 32 96v64h96V64zM32 416c0 17.7 14.3 32 32 32h64V192H32V416zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM446.8 278.1c-2.5 6-8.3 9.9-14.8 9.9H416v48c0 26.5-21.5 48-48 48H320v16c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-32-32c-6.2-6.2-6.2-16.4 0-22.6l32-32c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8v16h48c8.8 0 16-7.2 16-16V288H368c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l32-32c6.2-6.2 16.4-6.2 22.6 0l32 32c4.6 4.6 5.9 11.5 3.5 17.4z"]
};
var faFilterSlash = {
  prefix: 'fal',
  iconName: 'filter-slash',
  icon: [640, 512, [], "e17d", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm541 93.3c5.9-7.1 9.1-16 9.1-25.2C576 49.7 558.3 32 536.5 32H139.6l40.5 32H536.5c4.2 0 7.5 3.4 7.5 7.5c0 1.8-.6 3.4-1.7 4.8l-137 165.5 25.1 19.8L566.9 96.7zM352 362.8v83.3c0 1-.8 1.9-1.9 1.9c-.4 0-.8-.1-1.1-.4l-61-47.4V312.3L256 287V400.2c0 9.9 4.6 19.2 12.4 25.3l61 47.4c5.9 4.6 13.3 7.1 20.8 7.1c18.7 0 33.9-15.2 33.9-33.9V388.1l-32-25.3z"]
};
var faTrashCanUndo = {
  prefix: 'fal',
  iconName: 'trash-can-undo',
  icon: [448, 512, ["trash-can-arrow-turn-left", "trash-undo-alt"], "f896", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zm155.9 93.3c5.9 6.6 5.4 16.7-1.2 22.6l-49 44.1H240c44.2 0 80 35.8 80 80v40c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-26.5-21.5-48-48-48H169.7l49 44.1c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2l-80-72c-3.4-3-5.3-7.4-5.3-11.9s1.9-8.9 5.3-11.9l80-72c6.6-5.9 16.7-5.4 22.6 1.2z"]
};
var faTrashCanArrowTurnLeft = faTrashCanUndo;
var faTrashUndoAlt = faTrashCanUndo;
var faNotdef = {
  prefix: 'fal',
  iconName: 'notdef',
  icon: [384, 512, [], "e1fe", "M32 452.5L172.3 256 32 59.5V452.5zM51.7 480H332.3L192 283.5 51.7 480zm160-224L352 452.5V59.5L211.7 256zM332.3 32H51.7L192 228.5 332.3 32zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"]
};
var faDisease = {
  prefix: 'fal',
  iconName: 'disease',
  icon: [512, 512, [], "f7fa", "M64.1 280.3c0-15.6-6.2-30.5-17.2-41.5L17.7 209.6C6.4 198.3 .1 183 .1 167.1c0-37.2 33.4-65.5 70.1-59.4l59.6 9.9c37.9 6.3 76-10.2 97.3-42.1l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3c0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8l0 25.2c0 32.7-26.5 59.3-59.3 59.3c-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3h-10c-7.9 0-15.8 .9-23.6 2.6L86.1 432.4c-36 8-70.1-19.4-70.1-56.2c0-15.5 6.2-30.3 17.3-41.2l13.1-12.8c11.3-11 17.7-26.2 17.7-42zM253.6 93.2c-28.3 42.4-78.9 64.3-129.2 56l-59.6-9.9c-17.2-2.9-32.8 10.4-32.8 27.8c0 7.5 3 14.6 8.3 19.9l29.2 29.2c17 17 26.6 40.1 26.6 64.1c0 24.4-9.8 47.8-27.3 64.8L55.7 357.9c-4.9 4.8-7.7 11.4-7.7 18.3c0 16.4 15.1 28.5 31.1 25l62.3-13.8c10-2.2 20.3-3.4 30.5-3.4h10c34.5 0 68 11.7 94.9 33.3L307.8 442c4.8 3.9 10.8 6 17 6c15.1 0 27.3-12.2 27.3-27.3l0-25.2c0-48.1 29.5-91.2 74.3-108.6l36.9-14.3c10.1-3.9 16.8-13.7 16.8-24.5c0-12.7-9.1-23.6-21.6-25.9l-28-5.1c-49.1-9-88.1-46.4-99-95.2l-7.1-31.5C320.9 75 307.2 64 291.3 64c-11.3 0-21.9 5.7-28.2 15.1l-9.4 14.1zM304 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM136 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPersonToDoor = {
  prefix: 'fal',
  iconName: 'person-to-door',
  icon: [576, 512, [58704], "e433", "M256 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 224 56a56 56 0 1 0 112 0zM179.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L53.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L153.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L224.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L298.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L298 253.2c5.9 20.6 24.7 34.8 46.2 34.8H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H344.1c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7L218.3 302.4 190.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM130 314.1L101.3 384H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zM528 32c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V317.3c-5 1.8-10.4 2.7-16 2.7H384V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48V224h16c5.6 0 11 1 16 2.7V48c0-8.8 7.2-16 16-16h96z"]
};
var faTurntable = {
  prefix: 'fal',
  iconName: 'turntable',
  icon: [576, 512, [], "f8e4", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zM64 256a160 160 0 1 0 320 0A160 160 0 1 0 64 256zm160 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm256 17.4V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V288.5c-16 1.4-30.9 10.8-38.6 26.2l-16 32c-11.8 23.6-2.2 52.2 21.3 64s52.2 2.2 64-21.3l16-32c10.6-21.2 3.9-46.5-14.6-59.9zM452.3 320c2.3 0 4.6 .6 6.8 1.7c7.9 4 11.1 13.6 7.2 21.5l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c2.7-5.5 8.2-8.7 14-8.8h.7z"]
};
var faBriefcaseMedical = {
  prefix: 'fal',
  iconName: 'briefcase-medical',
  icon: [512, 512, [], "f469", "M176 32H336c8.8 0 16 7.2 16 16V96H160V48c0-8.8 7.2-16 16-16zM128 48V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm16 80H368h80c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h80zm96 48c-17.7 0-32 14.3-32 32v32H176c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V336h32c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H304V208c0-17.7-14.3-32-32-32H240zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H288c-8.8 0-16 7.2-16 16v48H240V320c0-8.8-7.2-16-16-16H176V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208z"]
};
var faGenderless = {
  prefix: 'fal',
  iconName: 'genderless',
  icon: [384, 512, [], "f22d", "M192 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 320a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"]
};
var faChevronRight = {
  prefix: 'fal',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", "M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z"]
};
var faSignalWeak = {
  prefix: 'fal',
  iconName: 'signal-weak',
  icon: [640, 512, ["signal-1"], "f68c", "M64 384c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-8.8 7.2-16 16-16z"]
};
var faSignal1 = faSignalWeak;
var faClockFive = {
  prefix: 'fal',
  iconName: 'clock-five',
  icon: [512, 512, [], "e349", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V251.2l61.3 92c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-64-96c-1.8-2.6-2.7-5.7-2.7-8.9V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faRetweet = {
  prefix: 'fal',
  iconName: 'retweet',
  icon: [576, 512, [], "f079", "M96 103.9L146.5 160 45.5 160 96 103.9zm88 60.5c0-6.8-2.5-13.4-7.1-18.4l-69-76.7c-3-3.4-7.4-5.3-11.9-5.3s-8.9 1.9-11.9 5.3L15.1 146C10.5 151.1 8 157.6 8 164.4C8 179.7 20.3 192 35.6 192H80V336c0 44.2 35.8 80 80 80H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-26.5 0-48-21.5-48-48V192h44.4c15.2 0 27.6-12.3 27.6-27.6zM480 408.1L429.5 352l100.9 0L480 408.1zm-88-60.5c0 6.8 2.5 13.4 7.1 18.4l69 76.7c3 3.4 7.4 5.3 11.9 5.3s8.9-1.9 11.9-5.3l69-76.7c4.6-5.1 7.1-11.6 7.1-18.4c0-15.2-12.3-27.6-27.6-27.6H496V176c0-44.2-35.8-80-80-80H272c-8.8 0-16 7.2-16 16s7.2 16 16 16H416c26.5 0 48 21.5 48 48V320H419.6c-15.2 0-27.6 12.3-27.6 27.6z"]
};
var faCarRear = {
  prefix: 'fal',
  iconName: 'car-rear',
  icon: [512, 512, ["car-alt"], "f5de", "M159.6 64H352.4c21.2 0 39.9 13.9 46 34.2l28.3 94.4c-3.5-.4-7.1-.6-10.7-.6H96c-3.6 0-7.2 .2-10.7 .6l28.3-94.4c6.1-20.3 24.8-34.2 46-34.2zM74.7 227.9l.1-.3c6.6-2.3 13.8-3.6 21.2-3.6H416c7.4 0 14.5 1.3 21.2 3.6l.1 .3 .5-.1c24.6 8.9 42.3 32.5 42.3 60.2H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32c0 17.7-14.3 32-32 32H352V352c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v32H64c-17.7 0-32-14.3-32-32V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c0-27.7 17.6-51.3 42.3-60.2l.5 .1zM320 384H192V352H320v32zM48.7 203.4l-.4 1.3C19.4 221.2 0 252.3 0 288v64c0 23.7 12.9 44.4 32 55.4V464c0 8.8 7.2 16 16 16s16-7.2 16-16V416H448v48c0 8.8 7.2 16 16 16s16-7.2 16-16V407.4c19.1-11.1 32-31.7 32-55.4V288c0-35.7-19.4-66.8-48.3-83.3l-.4-1.3L429 89c-10.2-33.8-41.3-57-76.6-57H159.6C124.3 32 93.1 55.2 83 89L48.7 203.4z"]
};
var faCarAlt = faCarRear;
var faPumpSoap = {
  prefix: 'fal',
  iconName: 'pump-soap',
  icon: [448, 512, [], "e06b", "M128 48c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48h76.1c17 0 33.3 6.7 45.3 18.7l33.9 33.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L354.7 89.4c-6-6-14.1-9.4-22.6-9.4H256v48H224V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v80H128V48zM85.6 221.3l-18.7 224C65.3 464 80.1 480 98.8 480H285.2c18.7 0 33.4-16 31.9-34.7l-18.7-224c-1.4-16.6-15.2-29.3-31.9-29.3H117.4c-16.6 0-30.5 12.8-31.9 29.3zm-31.9-2.7c2.8-33.2 30.5-58.7 63.8-58.7H266.6c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zM156.2 345.1c-2.7 5.3-4.2 11.2-4.2 17.2c0 20.8 16.9 37.7 37.7 37.7h4.7c20.8 0 37.7-16.9 37.7-37.7c0-6-1.4-11.9-4.2-17.2L192 275.4l-35.8 69.7zM192 240c10.9 0 20.9 6.1 25.9 15.8l38.4 74.7c5.1 9.9 7.7 20.8 7.7 31.9c0 38.5-31.2 69.7-69.7 69.7h-4.7c-38.5 0-69.7-31.2-69.7-69.7c0-11.1 2.6-22 7.7-31.9l38.4-74.7c5-9.7 15-15.8 25.9-15.8z"]
};
var faComputerClassic = {
  prefix: 'fal',
  iconName: 'computer-classic',
  icon: [448, 512, [], "f8b1", "M384 32c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM64 0C28.7 0 0 28.7 0 64V368c0 23.7 12.9 44.4 32 55.4V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V423.4c19.1-11.1 32-31.7 32-55.4V64c0-35.3-28.7-64-64-64H64zm0 432H384v48H64l0-48zM352 96V224H96V96H352zM96 64C78.3 64 64 78.3 64 96V224c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96zM224 336c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zM96 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFrame = {
  prefix: 'fal',
  iconName: 'frame',
  icon: [448, 512, [], "e495", "M448 112c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L96 96l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 256-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 256 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-256 48 0c8.8 0 16-7.2 16-16zM96 384l0-256 256 0 0 256L96 384z"]
};
var faVideoSlash = {
  prefix: 'fal',
  iconName: 'video-slash',
  icon: [640, 512, [], "f4e2", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM416 175.2V128c0-35.3-28.7-64-64-64H180.1l40.5 32H352c17.7 0 32 14.3 32 32v97l32 25.3v-75zM64 384V135.4L34.1 111.8C32.7 117 32 122.4 32 128V384c0 35.3 28.7 64 64 64H352c26.4 0 49-16 58.8-38.8l-27.1-21.4C381.8 403.7 368.4 416 352 416H96c-17.7 0-32-14.3-32-32zM576 134.2V376.6l26.5 20.9c3.5-5.8 5.5-12.5 5.5-19.7V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L448 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2z"]
};
var faBatteryQuarter = {
  prefix: 'fal',
  iconName: 'battery-quarter',
  icon: [576, 512, ["battery-2"], "f243", "M432 128c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H432zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM112 192h32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM64 208v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z"]
};
var faBattery2 = faBatteryQuarter;
var faEllipsisStroke = {
  prefix: 'fal',
  iconName: 'ellipsis-stroke',
  icon: [512, 512, ["ellipsis-h-alt"], "f39b", "M416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM256 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM128 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-96 0a64 64 0 1 0 128 0A64 64 0 1 0 32 256z"]
};
var faEllipsisHAlt = faEllipsisStroke;
var faRadio = {
  prefix: 'fal',
  iconName: 'radio',
  icon: [512, 512, [128251], "f8d7", "M500.1 31.5c8.5-2.3 13.6-11 11.3-19.6s-11-13.6-19.6-11.3L59.4 115.9c-31.3 8.4-54.1 34.6-58.6 66C.3 185.2 0 188.5 0 192v1.2V240 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H138.1l362-96.5zM32 193.2c0-2.2 .1-4.3 .4-6.4C34.9 171.6 48.1 160 64 160H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V240 193.2zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 304c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm256 16a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z"]
};
var faBabyCarriage = {
  prefix: 'fal',
  iconName: 'baby-carriage',
  icon: [512, 512, ["carriage-baby"], "f77d", "M.7 224c-.2-2.9-.4-5.7-.5-8.6C0 212.9 0 210.5 0 208V192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192h8v0H416V144c0-26.5 21.5-48 48-48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16 7.2-16 16v48 16 8h-.2c-.1 2.7-.3 5.3-.5 8c-1.8 22.2-7.5 44-16.8 64.5c-11.5 25.4-28.2 48.3-49.2 67.5c-20.9 19.2-45.6 34.2-72.6 44.5S253 416 224 416s-57.9-5.2-84.8-15.5s-51.6-25.3-72.6-44.5C45.7 336.9 28.9 314 17.5 288.5C8.2 268 2.5 246.2 .7 224zm216.4-32L113.7 42.8C66.3 76.2 34.7 130.4 32.2 192H217.1zM32.8 224c1.8 17.6 6.4 34.9 13.8 51.4c9.6 21.4 23.8 40.8 41.6 57.1s39 29.3 62.3 38.2s48.3 13.4 73.5 13.4s50.2-4.6 73.5-13.4s44.5-21.8 62.3-38.2s32-35.7 41.6-57.1c7.4-16.4 12.1-33.7 13.8-51.4H256c-.1 0-.1 0-.2 0H32.8zM80 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm304 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faCarriageBaby = faBabyCarriage;
var faFaceExpressionless = {
  prefix: 'fal',
  iconName: 'face-expressionless',
  icon: [512, 512, [], "e373", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 80H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zM128 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm176-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faDownToDottedLine = {
  prefix: 'fal',
  iconName: 'down-to-dotted-line',
  icon: [448, 512, [], "e408", "M222.2 351.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L350.2 219.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7L288 208c-8.8 0-16-7.2-16-16l0-120c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 120c0 8.8-7.2 16-16 16l-57.3 0c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L222.2 351.2zM224 384c-9.5 0-18.6-3.9-25.1-10.8L74.5 241.2C67.8 234 64 224.5 64 214.7c0-21.4 17.3-38.7 38.7-38.7l41.3 0 0-104c0-22.1 17.9-40 40-40l80 0c22.1 0 40 17.9 40 40l0 104 41.3 0c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.3-10.5 26.5L249.1 373.2c-6.5 6.9-15.6 10.8-25.1 10.8zm192 44a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 428a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm312 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 428a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-72 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faCloudMusic = {
  prefix: 'fal',
  iconName: 'cloud-music',
  icon: [640, 512, [], "f8ae", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM409.1 186.8c4.3 3 6.9 7.9 6.9 13.2V328c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5V223.1l-96 36V360c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5V248c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8zM384 332c0-4.1-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12s16-7.9 16-12zM256 364c0-4.1-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12s16-7.9 16-12z"]
};
var faTrafficLight = {
  prefix: 'fal',
  iconName: 'traffic-light',
  icon: [320, 512, [128678], "f637", "M64 32C46.3 32 32 46.3 32 64V352c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z"]
};
var faCloudMinus = {
  prefix: 'fal',
  iconName: 'cloud-minus',
  icon: [640, 512, [], "e35d", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM224 272H416c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faThermometer = {
  prefix: 'fal',
  iconName: 'thermometer',
  icon: [512, 512, [], "f491", "M352.8 53.8L310.6 96l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L288 118.6 246.6 160l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 182.6 224l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 246.6l-22.6 22.6c-6 6-9.4 14.1-9.4 22.6V384h92.1c8.5 0 16.6-3.4 22.6-9.4L458.2 159.2c14-14 21.8-32.9 21.8-52.7C480 65.4 446.6 32 405.5 32c-19.8 0-38.7 7.8-52.7 21.8zM276.7 84.7l53.5-53.5c20-20 47.1-31.2 75.3-31.2C464.3 0 512 47.7 512 106.5c0 28.2-11.2 55.3-31.2 75.3L265.4 397.3c-12 12-28.3 18.7-45.3 18.7H118.6L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L96 393.4V291.9c0-17 6.7-33.3 18.7-45.3l33.9-33.9 64-64 64-64s0 0 0 0s0 0 0 0z"]
};
var faShieldMinus = {
  prefix: 'fal',
  iconName: 'shield-minus',
  icon: [512, 512, [], "e249", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM160 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faVrCardboard = {
  prefix: 'fal',
  iconName: 'vr-cardboard',
  icon: [640, 512, [], "f729", "M576 96H64c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H200.4c12.1 0 23.2-6.8 28.6-17.7L268.2 320c9.8-19.6 29.9-32 51.8-32s42 12.4 51.8 32l-21.5 10.7L371.8 320l39.2 78.3c5.4 10.8 16.5 17.7 28.6 17.7H576c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zM64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H439.6c-24.2 0-46.4-13.7-57.2-35.4l-39.2-78.3c-4.4-8.8-13.4-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-39.2 78.3c-10.8 21.7-33 35.4-57.2 35.4H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm336 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faCarTilt = {
  prefix: 'fal',
  iconName: 'car-tilt',
  icon: [640, 512, [], "f5e5", "M131.7 88.2L304.3 41.9c20.5-5.5 42.1 3.1 53.3 21.1l48.2 78c-4.6 .5-9.3 1.4-14 2.7L106.9 220c-4.7 1.2-9.1 2.8-13.4 4.7l2.7-91.6c.6-21.2 15.1-39.5 35.6-44.9zM60.9 243.3l-.1 4.8C39.5 271.5 30.2 304.8 39 337.6l22 82.1L65.3 436l0 0 11.8 44L16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l608 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-515.4 0-10-37.2 1.5-.4L508.7 332.9l1.5-.4L522 376.6c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6l-11.8-44.1-8.3-30.9-22-82.1c-8.8-32.8-33.5-57-63.6-66.6l-2.5-4L384.8 46.2C366.2 16.2 330.1 1.9 296 11L123.4 57.2c-34.1 9.1-58.2 39.6-59.3 74.9L60.9 243.3zm54.3 7.6L400 174.6c34.1-9.1 69.2 11.1 78.4 45.3l22 82.1L91.9 411.5l-22-82.1c-9.1-34.1 11.1-69.2 45.3-78.4zm42.2 58a22.8 22.8 0 1 0 -44.1 11.8 22.8 22.8 0 1 0 44.1-11.8zM420.4 262a22.8 22.8 0 1 0 -11.8-44.1A22.8 22.8 0 1 0 420.4 262z"]
};
var faGaugeCircleMinus = {
  prefix: 'fal',
  iconName: 'gauge-circle-minus',
  icon: [640, 512, [], "e497", "M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194c0-8.8 7.2-16 16-16s16 7.2 16 16l0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H560c8.8 0 16 7.2 16 16z"]
};
var faBrightnessLow = {
  prefix: 'fal',
  iconName: 'brightness-low',
  icon: [512, 512, [], "e0ca", "M280 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM432 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM56 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm96-128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM408 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm0-256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 384a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"]
};
var faHandMiddleFinger = {
  prefix: 'fal',
  iconName: 'hand-middle-finger',
  icon: [448, 512, [128405], "f806", "M224 56c0-13.3 10.7-24 24-24s24 10.7 24 24V226.7c0 5.2 2.5 10.1 6.8 13.1s9.7 3.8 14.6 2c3.3-1.2 6.9-1.8 10.7-1.8c14.7 0 27.2 10 30.9 23.6c1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1 .6c3.6-1.4 7.6-2.2 11.8-2.2c17.7 0 32 14.3 32 32v88 8c0 44.2-35.8 80-80 80H184.3c-18.5 0-36.8-4.6-53.1-13.4l-7.6 14.1 7.6-14.1-8.3-4.5C86.6 442.6 64 404.7 64 363.5V344c0-15.1 7.1-29.3 19.2-38.4l22.5-16.9c2-1.5 4.1-3 6.3-4.4V344c0 8.8 7.2 16 16 16s16-7.2 16-16V264c0-.9-.1-1.9-.2-2.8c.2-.9 .2-1.8 .2-2.8V256c0-17.7 14.3-32 32-32c8.2 0 15.7 3.1 21.3 8.1c4.7 4.2 11.4 5.3 17.2 2.7s9.5-8.3 9.5-14.6V56zM248 0c-30.9 0-56 25.1-56 56V194c-5.1-1.3-10.5-2-16-2c-32.5 0-59.3 24.2-63.4 55.6c-9.1 4.2-17.8 9.4-26 15.5L64 280c-20.1 15.1-32 38.8-32 64v19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H320c61.9 0 112-50.1 112-112v-8V304c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5V56c0-30.9-25.1-56-56-56z"]
};
var faPercent = {
  prefix: 'fal',
  iconName: 'percent',
  icon: [384, 512, [62101, 62785, "percentage"], "25", "M64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM379.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-352 352c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l352-352z"]
};
var faPercentage = faPercent;
var faTruckMoving = {
  prefix: 'fal',
  iconName: 'truck-moving',
  icon: [640, 512, [], "f4df", "M72 64c-22.1 0-40 17.9-40 40V304v32c13.4-10 30-16 48-16c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48H448V256 224 104c0-22.1-17.9-40-40-40H72zM480 336c13.4-10 30-16 48-16c32.8 0 60.9 19.7 73.3 47.9c3.8-.6 6.7-3.9 6.7-7.9V304 256H480v80zm0-176v64H592l-43.2-57.6c-3-4-7.8-6.4-12.8-6.4H480zm160 90.7V256v48 56c0 19.4-13.7 35.5-32 39.2l0 .8c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80V368 304 104C0 64.2 32.2 32 72 32H408c39.8 0 72 32.2 72 72v24h56c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faGlassWaterDroplet = {
  prefix: 'fal',
  iconName: 'glass-water-droplet',
  icon: [384, 512, [], "e4f5", "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7H343.8c4.7 0 8.4 4 8 8.7L329.5 305.4l-23.9 12c-19.2 9.6-42.3 7.2-59.1-6.3c-31.8-25.5-77.1-25.5-108.9 0c-16.8 13.4-39.9 15.9-59.1 6.3l-24-12L32.1 40.7zm25.4 302l6.6 3.3c30.4 15.2 66.9 11.3 93.4-9.9c20.1-16.1 48.8-16.1 68.9 0c26.5 21.2 63 25.1 93.4 9.9l6.5-3.2-9.1 108C315.8 467.3 302 480 285.4 480H98.6c-16.6 0-30.5-12.7-31.9-29.3l-9.1-108zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512H285.4c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1zM192 216c-19.6 0-32-14.5-32-28c0 .1 0 .1 0-.1l0 0c.1-.6 .6-3.3 2.9-8.8c2.6-6.1 6.5-13.4 11.4-21.3c5.4-8.8 11.6-17.8 17.6-26c6 8.2 12.1 17.1 17.6 26c4.9 8 8.8 15.2 11.4 21.3c2.3 5.5 2.8 8.2 2.9 8.8l0 0c0 .1 0 .2 0 .1c0 13.5-12.4 28-32 28zm0 32c35.3 0 64-26.9 64-60c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 117.9 128 164 128 188c0 33.1 28.7 60 64 60z"]
};
var faConveyorBelt = {
  prefix: 'fal',
  iconName: 'conveyor-belt',
  icon: [640, 512, [], "f46e", "M464 32c8.8 0 16 7.2 16 16V240c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h64V144c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L320 116l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.3 8.8-14.3V32h64zM272 32h96v80L329.6 83.2c-5.7-4.3-13.5-4.3-19.2 0L272 112V32zM176 0c-26.5 0-48 21.5-48 48V240c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H176zM608 416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64H544c35.3 0 64 28.7 64 64zM96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm56 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faLocationCheck = {
  prefix: 'fal',
  iconName: 'location-check',
  icon: [384, 512, ["map-marker-check"], "f606", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-84.7-52.7l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 233.4 276.7 116.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faMapMarkerCheck = faLocationCheck;
var faCoinVertical = {
  prefix: 'fal',
  iconName: 'coin-vertical',
  icon: [384, 512, [], "e3fd", "M256 256c0-66.2-15.2-124.6-38.1-165.3C194.5 49 167.1 32 144 32s-50.5 17-73.9 58.7C47.2 131.4 32 189.8 32 256s15.2 124.6 38.1 165.3C93.5 463 120.9 480 144 480s50.5-17 73.9-58.7C240.8 380.6 256 322.2 256 256zm24.8 80h64.3c3.6-20 5.8-41.5 6.6-64h-64c-.8 22.2-3.1 43.7-6.9 64zm-7.3 32c-4.7 17.2-10.5 33.2-17.1 48h64.7c6.5-14.2 12.3-30.3 17-48H273.5zM213.8 480H256c12.8 0 29.9-8.5 46.8-32H239.2c-7.8 12.2-16.3 23-25.5 32zm74-240h64c-.7-22.5-3-44-6.6-64H280.8c3.8 20.3 6.1 41.8 6.9 64zm-74-208c9.2 9 17.7 19.8 25.5 32h63.6c-16.9-23.5-34-32-46.8-32H213.8zm59.8 112h64.6c-4.7-17.7-10.5-33.8-17-48H256.4c6.7 14.8 12.4 30.8 17.1 48zM144 512C64.5 512 0 397.4 0 256S64.5 0 144 0h32 80c70.7 0 128 114.6 128 256s-57.3 256-128 256H176 144zM88 256c0 47.1 7.4 89.1 18.8 118.7c5.7 14.8 12.2 25.8 18.5 32.7c6.3 6.9 11.3 8.6 14.7 8.6s8.3-1.7 14.7-8.6c6.3-6.9 12.8-17.8 18.5-32.7C184.6 345.1 192 303.1 192 256s-7.4-89.1-18.8-118.7c-5.7-14.8-12.2-25.8-18.5-32.7C148.3 97.7 143.4 96 140 96s-8.3 1.7-14.7 8.6c-6.3 6.9-12.8 17.8-18.5 32.7C95.4 166.9 88 208.9 88 256zM140 64c15.4 0 28.3 8.2 38.3 19c9.9 10.9 18.2 25.7 24.7 42.7c13.2 34.1 21 80.2 21 130.2s-7.8 96.1-21 130.2c-6.6 17-14.8 31.9-24.7 42.7c-9.9 10.9-22.9 19-38.3 19s-28.3-8.2-38.3-19c-9.9-10.9-18.2-25.7-24.7-42.7C63.8 352.1 56 306.1 56 256s7.8-96.1 21-130.2c6.6-17 14.8-31.9 24.7-42.7c9.9-10.9 22.9-19 38.3-19z"]
};
var faDisplay = {
  prefix: 'fal',
  iconName: 'display',
  icon: [576, 512, [], "e163", "M64 32C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM213.1 416H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H360 216 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64zm32.4 0l-10.7 64H341.1l-10.7-64H245.6z"]
};
var faPersonSign = {
  prefix: 'fal',
  iconName: 'person-sign',
  icon: [512, 512, [], "f757", "M421.5 1c8.3 3.1 12.5 12.3 9.5 20.5l-7.3 19.8 70.3 25.6c12.5 4.5 18.9 18.3 14.3 30.8L470.1 202.9c-4.5 12.5-18.3 18.9-30.8 14.3l-70.9-25.8L319 325.5c-3.1 8.3-12.3 12.5-20.5 9.5s-12.5-12.3-9.5-20.5l20.5-55.8-33.9-11.3c-18.9-6.3-35.8-17.5-48.9-32.5L208 193.4V331.6l41.2 68.6c4.5 7.5 6.8 16 6.8 24.7V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V424.9c0-2.9-.8-5.7-2.3-8.2L182.9 352H112V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V336 211.8L30.3 311.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5L56 188.2C69.6 161.1 97.3 144 127.6 144H171c23.1 0 45 10 60.2 27.3l19.7 22.5c9.4 10.7 21.4 18.7 34.9 23.2l34.8 11.6 17.7-48.2-64.4-23.4c-12.5-4.5-18.9-18.3-14.3-30.8L297.9 21.1c4.5-12.5 18.3-18.9 30.8-14.3l65 23.7L401 10.5C404 2.2 413.2-2.1 421.5 1zM112 178.6V320h64V176.3c-1.7-.2-3.3-.3-5-.3H127.6c-5.4 0-10.6 .9-15.6 2.6zM144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 144 0zM325.2 39.5l-32.8 90.2 150.4 54.7 32.8-90.2L325.2 39.5z"]
};
var faFaceSmile = {
  prefix: 'fal',
  iconName: 'face-smile',
  icon: [512, 512, [128578, "smile"], "f118", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSmile = faFaceSmile;
var faPhoneHangup = {
  prefix: 'fal',
  iconName: 'phone-hangup',
  icon: [640, 512, [], "e225", "M320 128C185.6 128 85.9 196.7 38.8 245c-7.2 7.4-8.9 19.3-3.5 30.5l38.3 78.6c3.3 6.7 10.7 10.3 18 8.6l88-20.5c7.2-1.7 12.4-8.1 12.4-15.6V240c0-7.1 4.7-13.4 11.6-15.4l32.9-9.4c54.6-15.6 112.4-15.6 167 0l32.9 9.4c6.9 2 11.6 8.2 11.6 15.4v86.6c0 7.4 5.1 13.9 12.4 15.6l88 20.5c7.3 1.7 14.7-1.9 18-8.6l38.3-78.6c5.5-11.2 3.7-23.2-3.5-30.5C554.1 196.7 454.4 128 320 128zM15.9 222.6C67.2 170.1 174.6 96 320 96s252.8 74.1 304.1 126.6c18.1 18.5 19.8 45.6 9.3 66.9l-38.3 78.6c-9.8 20.1-32.2 30.8-54 25.7l-88-20.5c-21.7-5.1-37.1-24.4-37.1-46.8V252.1L394.7 246c-48.8-14-100.6-14-149.4 0L224 252.1v74.5c0 22.3-15.4 41.7-37.1 46.8l-88 20.5c-21.8 5.1-44.2-5.6-54-25.7L6.5 289.5c-10.4-21.3-8.7-48.4 9.3-66.9z"]
};
var faSignatureSlash = {
  prefix: 'fal',
  iconName: 'signature-slash',
  icon: [640, 512, [], "e3cb", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM378.8 384H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h83.4l-40.5-32zm85-96l40.5 32H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H463.8zm162 127.9c8-.9 14.2-7.7 14.2-15.9c0-8.8-7.2-16-16-16H585.4l40.4 31.9zM478.3 183.2c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3l-117 31.9L374 217.1l59.7-16.3L411 246.3l25.7 20.3 41.7-83.4zM320 131.4V128c0-53-43-96-96-96c-22.2 0-42.6 7.5-58.9 20.2l26.3 20.7c9.6-5.7 20.7-8.9 32.6-8.9c35.3 0 64 28.7 64 64v3.4c0 5.8-.1 11.7-.4 17.5L318.1 173c1.3-13.8 1.9-27.7 1.9-41.6zM155 243.7c-34.8 9.5-59 41.1-59 77.2v92.6c0 36.7 29.8 66.5 66.5 66.5c24 0 46.2-13 57.9-33.9L247.5 398c15.6-27.7 28.7-56.8 39-86.9L259.8 290c-10.2 32-23.7 63-40.2 92.3l-27.1 48.1c-6.1 10.9-17.6 17.6-30.1 17.6c-19 0-34.5-15.4-34.5-34.5V320.9c0-21.6 14.5-40.6 35.4-46.3L220.5 259l-31.2-24.7L155 243.7zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H48c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faThumbtack = {
  prefix: 'fal',
  iconName: 'thumbtack',
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M119.9 34.5L107.8 191.4c-.7 9.7-5.9 18.6-13.9 24c-27 18.3-47.3 46.2-55.6 79.6L32 320l144 0V224c0-8.8 7.2-16 16-16s16 7.2 16 16v96l144 0-6.2-25c-8.3-33.4-28.6-61.3-55.6-79.6c-8.1-5.5-13.2-14.3-13.9-24L264.1 34.5c-.1-.8-.1-1.6-.1-2.5H120c0 .8 0 1.6-.1 2.5zM176 352H32c-9.9 0-19.2-4.5-25.2-12.3S-1.4 321.8 1 312.2l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L85.5 64 88 32H64c-2.9 0-5.6-.8-7.9-2.1C51.2 27.1 48 21.9 48 16C48 7.2 55.2 0 64 0H88 296h24c8.8 0 16 7.2 16 16c0 5.9-3.2 11.1-8.1 13.9c-2.3 1.3-5 2.1-7.9 2.1H296l2.5 32 9.6 124.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3H208V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352z"]
};
var faThumbTack = faThumbtack;
var faWheatSlash = {
  prefix: 'fal',
  iconName: 'wheat-slash',
  icon: [640, 512, [], "e339", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM523.5 278.5l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-18-18-40-29.5-63.2-34.6l16.9-.8c45.1-2.3 81.2-38.4 83.5-83.5l2.7-54c.7-14.2-11-25.9-25.2-25.2L495.5 4C450.4 6.3 414.3 42.4 412 87.5l-.9 17.7c-4.9-23.5-16.5-46-34.8-64.2L353.8 18.4c-6.2-6.2-16.4-6.2-22.6 0L297.2 52.3C278.5 71 269.2 95.5 269.1 120l40.4 31.9c-13.9-24.4-10.5-56.1 10.4-76.9l22.6-22.6 11.3 11.3c35.1 35.1 37.3 90.7 6.6 128.4l26.5 20.9c37.6-28.1 91.1-25.1 125.3 9.1l11.3 11.3-22.6 22.6c-10.3 10.3-23.2 16.3-36.5 18.2l30.6 24.2c10.3-4.6 20-11.2 28.5-19.7zM286.9 311.4l-25.3-20-29 29c1.3-20.6-2.4-41.5-11-60.6l-73.7-58.2-31.6 31.6c-37.5 37.5-37.5 98.3 0 135.8L150.2 403 68.7 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l81.5-81.5 0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-27-27-63.2-39.4-98.6-37.2l31.7-31.7zM542.3 33.7L540 78.9c-1.4 28.7-24.4 51.7-53.1 53.1l-45.2 2.3L444 89.1c1.4-28.7 24.4-51.7 53.1-53.1l45.2-2.3zM172.8 380.3l-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3c37.2 37.2 37.5 97.4 .8 135l-.8 .8zm147.1 56.5c-25 25-65.5 25-90.5 0L195.5 403c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3-22.6 22.6z"]
};
var faTrophy = {
  prefix: 'fal',
  iconName: 'trophy',
  icon: [576, 512, [127942], "f091", "M176 32H400c9 0 15.4 7.3 15.1 15c-6.2 163.9-44.9 239.2-76.1 273.5c-15.5 17.1-29.9 24.8-39.3 28.3c-4.8 1.8-8.5 2.6-10.6 3c-.5 .1-.9 .1-1.2 .2c-.3 0-.7-.1-1.2-.2c-2.1-.3-5.8-1.1-10.6-3c-9.4-3.5-23.8-11.3-39.3-28.3C205.8 286.2 167.1 210.9 160.9 47c-.3-7.8 6.2-15 15.1-15zM400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H48C22 64-1.3 85.6 1.8 113.7c10.1 94 61.9 158.2 118.1 199.9c55.9 41.4 117.1 61.3 149.3 66.9l.1-.3c.9 .3 1.8 .6 2.7 .8V480H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H288 400c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V381.1c.9-.3 1.8-.5 2.7-.8l.1 .3c32.2-5.7 93.4-25.5 149.3-66.9c56.2-41.7 108-105.9 118.1-199.9C577.3 85.6 554 64 528 64H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zm44.2 96H528c9.3 0 15.2 7.3 14.4 14.3c-8.9 82.9-54.3 139.8-105.4 177.6c-19.6 14.6-40 26.2-59.2 35.3C407 281.9 434.5 212.5 444.2 96zm-246 227.2c-19.2-9.1-39.6-20.7-59.2-35.3C87.9 250.1 42.5 193.2 33.6 110.3C32.8 103.3 38.7 96 48 96h83.8c9.8 116.5 37.2 185.9 66.4 227.2z"]
};
var faCloudsSun = {
  prefix: 'fal',
  iconName: 'clouds-sun',
  icon: [640, 512, [], "f746", "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c3.2-20.2 11-38.9 22.5-54.8l-44.4 31.1-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l10.4 1.7c9.9-11.5 22.5-20.6 36.8-26.3l-30.7-5.1L303.8 13.4zM291.6 217.2c-2.1-7.9-3.3-16.3-3.3-24.9c0-5.7 .5-11.3 1.5-16.7C276.9 143 245.2 120 208 120c-48.6 0-88 39.4-88 88s39.4 88 88 88c12.8 0 24.9-2.7 35.9-7.6c7.3-28.9 24.5-53.9 47.7-71.1zM264 208a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm309.9 47.6c8.2 8 15.2 17.2 20.7 27.4c26.6-10.6 45.4-36.5 45.4-66.9c0-39.8-32.2-72-72-72c-3.2 0-6.4 .2-9.5 .6C551.4 107.9 519 80.1 480 80.1c-34.2 0-63.3 21.4-74.8 51.6c-6.6-2.3-13.8-3.6-21.2-3.6c-35.3 0-64 28.6-64 64c0 3 .2 6 .6 8.9c9.9-3.9 20.4-6.7 31.4-8l0-.5 0-.4c0-17.7 14.3-32 32-32c3.8 0 7.3 .6 10.6 1.8c16.4 5.7 34.3-2.6 40.5-18.8c6.9-18.1 24.4-30.9 44.9-30.9c23.3 0 42.8 16.7 47.1 38.7c3.2 16.6 18.8 27.8 35.6 25.6c1.7-.2 3.5-.3 5.3-.3c22.1 0 40 17.9 40 40c0 20.1-14.8 36.7-34.1 39.5zM304 320c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H290.9c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H557.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.4-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 242.6 402.9 224 368 224z"]
};
var faPersonPraying = {
  prefix: 'fal',
  iconName: 'person-praying',
  icon: [448, 512, [128720, "pray"], "f683", "M256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM200.5 176h.9c12.4 0 23.7 7.2 29 18.5l3.1 6.7c-.1 .2-.2 .5-.3 .7L157.1 384.6l-26.7-16.8c-13.1-8.2-18.4-24.6-12.7-39l53.1-132.7c4.9-12.1 16.6-20.1 29.7-20.1zm112 306.5l-128-80.6 67.3-161.5 12.4 26.5c9.2 19.7 34.9 24.7 50.8 9.9l95.9-89.1c6.5-6 6.9-16.1 .8-22.6s-16.1-6.9-22.6-.8l-95.9 89.1-33.8-72.4c-10.5-22.5-33.1-36.9-58-36.9h-.9c-26.2 0-49.7 15.9-59.4 40.2L88 316.9c-11.5 28.7-.8 61.5 25.3 77.9L248.6 480H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c7.1 0 13.4-4.7 15.4-11.6s-.8-14.2-6.8-18z"]
};
var faPray = faPersonPraying;
var faHammer = {
  prefix: 'fal',
  iconName: 'hammer',
  icon: [576, 512, [128296], "f6e3", "M398.5 206.8c8.6-.1 16.8 3.3 22.9 9.4L472 266.7 514.7 224l-48.3-48.3c-6.5-6.5-9.9-15.4-9.3-24.5c1-17-5.2-34.2-18.5-46.7L394 62.4C373.2 42.9 345.8 32 317.2 32H299.2c-15.7 0-31.2 3.3-45.5 9.7l-17.6 7.8 51.2 27.9C297.6 83 304 93.8 304 105.5v12.1c0 12.6 5 24.7 13.9 33.7l38.1 38.1c11.7 11.7 27.1 17.5 42.4 17.4zm138.8-5.4l3.3 3.3 8-8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16-3.3-3.3-50.6-50.6c-23.6 .2-47.3-8.7-65.4-26.7l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c20.5 19.3 30.1 45.9 28.5 72l48.3 48.3zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l9.7 9.7L47.9 401.7c-10.1 8.4-15.9 20.9-15.9 34C32 460.2 51.8 480 76.3 480c13.1 0 25.6-5.8 34-15.9L305.7 229.6l5.1 5.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"]
};
var faFaceVomit = {
  prefix: 'fal',
  iconName: 'face-vomit',
  icon: [576, 512, [], "e3a0", "M288 32C164.3 32 64 132.3 64 256c0 57.4 21.6 109.7 57 149.3c5.9 6.6 5.3 16.7-1.3 22.6s-16.7 5.3-22.6-1.3C56.7 381.4 32 321.6 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256c0 65.6-24.7 125.4-65.2 170.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c35.5-39.6 57-91.9 57-149.3C512 132.3 411.7 32 288 32zM161.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L203.9 208l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L372.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 488a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm520-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM288 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm92.5-47.6c8.6-1.9 17.2 3.5 19.1 12.1l6.1 27.4c5.2 23.5 20.8 43.4 42.3 54.2l39.1 19.6c6.6 3.3 10.1 10.8 8.4 18s-8.2 12.3-15.6 12.3H112c-7.4 0-13.9-5.1-15.6-12.3s1.8-14.7 8.4-18L144 462.1c21.5-10.8 37.1-30.7 42.3-54.2l6.1-27.4c1.9-8.6 10.5-14.1 19.1-12.1s14.1 10.5 12.1 19.1l-6.1 27.4c-5.8 26.2-20.8 49.2-41.9 65.1H400.4c-21.1-15.9-36.1-38.9-41.9-65.1l-6.1-27.4c-1.9-8.6 3.5-17.2 12.1-19.1zm-189.1 4c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8c5.6-19.8 24.1-38.7 48-52.1C217.3 297.6 250 288 288 288s70.7 9.6 95.4 23.5c24 13.5 42.4 32.3 48 52.1c2.4 8.5-2.5 17.3-11 19.8s-17.3-2.5-19.8-11c-2.4-8.3-12.6-21.5-32.9-33C348 328.3 320.7 320 288 320s-60 8.3-79.7 19.4c-20.4 11.5-30.6 24.7-32.9 33z"]
};
var faSpeakers = {
  prefix: 'fal',
  iconName: 'speakers',
  icon: [640, 512, [], "f8e0", "M256 257.6V336v78.4c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6zm0 78.4A80 80 0 1 0 96 336a80 80 0 1 0 160 0zm5.5 144c4.2 11.9 10.7 22.8 19 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H280.4c-8.3 9.2-14.8 20.1-19 32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H261.5zM176 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM152 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM352 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM288 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H352c-35.3 0-64-28.7-64-64V64zm176 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM440 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTtyAnswer = {
  prefix: 'fal',
  iconName: 'tty-answer',
  icon: [640, 512, ["teletype-answer"], "e2b9", "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0zM312 64h16c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H312c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm0 96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H312c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V80zM504 64h16c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H504c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H600c-8.8 0-16-7.2-16-16V80zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H600c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm-200 0H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTeletypeAnswer = faTtyAnswer;
var faMugTeaSaucer = {
  prefix: 'fal',
  iconName: 'mug-tea-saucer',
  icon: [640, 512, [], "e1f5", "M240 64H416h16 16V224v32 32c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V64h80v40.5l-36.5 30.4C164.2 141 160 150 160 159.5V224c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V159.5c0-9.5-4.2-18.5-11.5-24.6L240 104.5V64zM224 32H128c-17.7 0-32 14.3-32 32V288c0 53 43 96 96 96H384c53 0 96-43 96-96V256h48c61.9 0 112-50.1 112-112s-50.1-112-112-112H448 432 416 224zM480 224V64h48c44.2 0 80 35.8 80 80s-35.8 80-80 80H480zM0 464c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM192 224V159.5l32-26.7 32 26.7V224H192z"]
};
var faDiagramLeanCanvas = {
  prefix: 'fal',
  iconName: 'diagram-lean-canvas',
  icon: [640, 512, [], "e156", "M512 64V320h96V96c0-17.7-14.3-32-32-32H512zm-32 0H384V192h96V64zM352 64H288V320h64V64zm-96 0H160V192h96V64zM128 64H64C46.3 64 32 78.3 32 96V320h96V64zM32 352v64c0 17.7 14.3 32 32 32H304V352H32zm304 96H576c17.7 0 32-14.3 32-32V352H336v96zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM256 320V224H160v96h96zm224-96H384v96h96V224z"]
};
var faAlt = {
  prefix: 'fal',
  iconName: 'alt',
  icon: [640, 512, [], "e08a", "M462 107.7c6.1-7.4 15.2-11.7 24.8-11.7H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H486.7c-19.2 0-37.4 8.6-49.5 23.5L178 404.3c-6.1 7.4-15.2 11.7-24.8 11.7H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H153.3c19.2 0 37.4-8.6 49.5-23.5L462 107.7zM432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"]
};
var faDial = {
  prefix: 'fal',
  iconName: 'dial',
  icon: [576, 512, ["dial-med-high"], "e15b", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm11.3 243.3l89.8-89.8c39.1 50.2 35.5 122.9-10.6 169c-50 50-131 50-181 0s-50-131 0-181c46.2-46.2 118.8-49.7 169-10.6l-89.8 89.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM401.1 174.9A160 160 0 1 0 174.9 401.1 160 160 0 1 0 401.1 174.9zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDialMedHigh = faDial;
var faHandPeace = {
  prefix: 'fal',
  iconName: 'hand-peace',
  icon: [512, 512, [9996], "f25b", "M253.4 .3c-30.8-3-58.2 19.6-61.1 50.3L177.9 199 123.8 66.8c-11.7-28.6-44.4-42.3-73-30.6s-42.3 44.4-30.6 73L84.5 266.5C71.8 280.7 64 299.4 64 320v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V312.1l0-.1V248l0-.1V240c0-3.2-.9-6.1-2.5-8.6C438.4 208.6 417.2 192 392 192c-12.1 0-23.3 3.8-32.5 10.4C349.6 186.5 332 176 312 176c-6.9 0-13.6 1.3-19.7 3.6L303.7 61.4c3-30.8-19.6-58.2-50.3-61.1zM111.1 247L49.8 97.1c-5-12.3 .9-26.3 13.1-31.3s26.3 .9 31.3 13.1L160.1 240H144c-11.7 0-22.8 2.5-32.9 7zM232 240H206.1l18-186.3c1.3-13.2 13-22.9 26.2-21.6s22.9 13 21.6 26.2l-18 186.1c-6.7-2.9-14.1-4.4-21.9-4.4zm80-32c13.3 0 24 10.7 24 24l0 16 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24v0V232c0-13.3 10.7-24 24-24zm32.5 133.6C354.4 357.5 372 368 392 368c8.4 0 16.4-1.9 23.5-5.2C410.1 428.5 355 480 288 480H224c-70.7 0-128-57.3-128-128V320c0-26.5 21.5-48 48-48h88c13.2 0 24 10.7 24 24l0 0c0 13.3-10.7 24-24 24H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c12.1 0 23.3-3.8 32.5-10.4zM416 312c0 13.2-10.8 24-24 24c-13.3 0-24-10.7-24-24l0-16 0-48c0-13.3 10.7-24 24-24c13.2 0 24 10.7 24 24l0 0v64l0 0z"]
};
var faCircleTrash = {
  prefix: 'fal',
  iconName: 'circle-trash',
  icon: [512, 512, ["trash-circle"], "e126", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 144h32.1 9.3l11.3-11.3c3-3 7.1-4.7 11.3-4.7h64c4.2 0 8.3 1.7 11.3 4.7L310.6 144h9.3H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-2.1L338 354.1c-1.1 16.8-15.1 29.9-31.9 29.9H205.9c-16.8 0-30.8-13.1-31.9-29.9L162.1 176H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm157.8 32H194.2l11.7 176H306.1l11.7-176z"]
};
var faTrashCircle = faCircleTrash;
var faRotate = {
  prefix: 'fal',
  iconName: 'rotate',
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M426.1 301.2C406.2 376.5 337.6 432 256 432c-51 0-96.9-21.7-129-56.3l41-41c5.1-5.1 8-12.1 8-19.3c0-15.1-12.2-27.3-27.3-27.3H48c-8.8 0-16 7.2-16 16V404.7C32 419.8 44.2 432 59.3 432c7.2 0 14.2-2.9 19.3-8l25.7-25.7C142.3 438.7 196.2 464 256 464c97.4 0 179.2-67 201.8-157.4c2.4-9.7-5.2-18.6-15.2-18.6c-7.8 0-14.5 5.6-16.5 13.2zM385 136.3l-41 41c-5.1 5.1-8 12.1-8 19.3c0 15.1 12.2 27.3 27.3 27.3H464c8.8 0 16-7.2 16-16V107.3C480 92.2 467.8 80 452.7 80c-7.2 0-14.2 2.9-19.3 8l-25.7 25.7C369.7 73.3 315.8 48 256 48C158.6 48 76.8 115 54.2 205.4c-2.4 9.7 5.2 18.6 15.2 18.6c7.8 0 14.5-5.6 16.5-13.2C105.8 135.5 174.4 80 256 80c51 0 96.9 21.7 129.1 56.3zM448 192H374.6L448 118.6V192zM64 320h73.4L64 393.4V320z"]
};
var faSyncAlt = faRotate;
var faCircleQuarters = {
  prefix: 'fal',
  iconName: 'circle-quarters',
  icon: [512, 512, [], "e3f8", "M402.7 425.3L256 278.6 109.3 425.3C148.6 459.4 199.9 480 256 480s107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256s-20.6-107.4-54.7-146.7L278.6 256 425.3 402.7zm-22.6-316C363.4 52.6 312.1 32 256 32s-107.4 20.6-146.7 54.7L256 233.4 402.7 86.7zm-316 22.6C52.6 148.6 32 199.9 32 256s20.6 107.4 54.7 146.7L233.4 256 86.7 109.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faSpinner = {
  prefix: 'fal',
  iconName: 'spinner',
  icon: [512, 512, [], "f110", "M256 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.2 391.8A16 16 0 1 0 97.6 414.4a16 16 0 1 0 22.6-22.6zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM97.6 120.2a16 16 0 1 0 22.6-22.6A16 16 0 1 0 97.6 120.2zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM414.4 414.4a16 16 0 1 0 -22.6-22.6 16 16 0 1 0 22.6 22.6zm-45.3-45.3A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z"]
};
var faTowerControl = {
  prefix: 'fal',
  iconName: 'tower-control',
  icon: [448, 512, [], "e2a2", "M160 16c0-8.8 7.2-16 16-16h48 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H240V64h48c17.7 0 32 14.3 32 32v32h80.9c26.2 0 45.3 24.8 38.7 50.1L402.6 320.2c7.6 1.2 13.4 7.8 13.4 15.8c0 8.8-7.2 16-16 16H352V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352l-192 0V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H48c-8.8 0-16-7.2-16-16c0-8 5.8-14.6 13.4-15.8L8.4 178.1C1.8 152.8 20.9 128 47.1 128H128V96c0-17.7 14.3-32 32-32h48V32H176c-8.8 0-16-7.2-16-16zM128 160.2c0-.1 0-.1 0-.2H47.1c-5.2 0-9.1 5-7.7 10L78.5 320H128V160.2zM160 320H288V160.2c0-.1 0-.1 0-.2H160V320zM320 160V320l49.6 0 39.1-150c1.3-5.1-2.5-10-7.7-10H320zm-32-32V96H160v32H288z"]
};
var faArrowUpTriangleSquare = {
  prefix: 'fal',
  iconName: 'arrow-up-triangle-square',
  icon: [576, 512, ["sort-shapes-up"], "f88a", "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 432V336c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zM416 67.5L490.7 192H341.3L416 67.5zM307.6 186c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1H502.9c13.8 0 25.1-11.2 25.1-25.1c0-4.5-1.2-9-3.6-12.9L440.2 45.7C435.1 37.2 425.9 32 416 32s-19.1 5.2-24.2 13.7L307.6 186zM320 432c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v96z"]
};
var faSortShapesUp = faArrowUpTriangleSquare;
var faWhale = {
  prefix: 'fal',
  iconName: 'whale',
  icon: [640, 512, [128011], "f72c", "M164.9 .8c5.7 1.8 9.9 6.7 10.9 12.6l14.1 84.7 84.7 14.1c5.9 1 10.8 5.2 12.6 10.9s.3 12-3.9 16.2L242.6 180c-18.3 18.3-44.2 26.6-69.7 22.3L111 192 70.8 250.4c-9.2 13.3-10.4 30.6-3.1 45c7.5 15.1 22.9 24.6 39.7 24.6h3.2c11.3 0 22.2-3.8 31-10.9L270.9 205.7C333.8 155.4 411.8 128 492.3 128C573.9 128 640 194.1 640 275.7V384c0 53-43 96-96 96H162.4C72.7 480 0 407.3 0 317.6c0-39.5 15.7-77.3 43.6-105.2l46.5-46.5 3.4-3.4-7.9-47.4C81.4 89.6 89.7 63.7 108 45.4L148.7 4.7c4.2-4.2 10.5-5.8 16.2-3.9zM149.3 49.3L130.6 68c-11 11-16 26.5-13.4 41.8l8.7 52.2 52.2 8.7c15.3 2.5 30.9-2.4 41.8-13.4l18.7-18.7-65.3-10.9c-6.7-1.1-12-6.4-13.2-13.2L149.3 49.3zM368 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-334.1 .5c-1.3 6.9-1.9 14-1.9 21.2C32 389.6 90.4 448 162.4 448H544c35.3 0 64-28.7 64-64V275.7C608 211.8 556.2 160 492.3 160c-73.2 0-144.2 24.9-201.4 70.7L161.6 334.1c-14.5 11.6-32.4 17.9-50.9 17.9h-3.2c-28.9 0-55.4-16.4-68.4-42.2c-2.2-4.3-3.9-8.8-5.2-13.3z"]
};
var faRobot = {
  prefix: 'fal',
  iconName: 'robot',
  icon: [640, 512, [129302], "f544", "M320 0c8.8 0 16 7.2 16 16V96H448c53 0 96 43 96 96V416c0 53-43 96-96 96H192c-53 0-96-43-96-96V192c0-53 43-96 96-96H304V16c0-8.8 7.2-16 16-16zM192 128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H320 192zm16 256h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16zM224 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM48 224H64v32H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16H64v32H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zM592 384c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H576V224h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V384h16z"]
};
var faPeace = {
  prefix: 'fal',
  iconName: 'peace',
  icon: [512, 512, [9774], "f67c", "M240 479.4V289.8L93.2 409.9c37.4 39.6 89.1 65.5 146.8 69.6zM72.9 385.1L240 248.4V32.6C123.8 40.8 32 137.7 32 256c0 48.1 15.1 92.6 40.9 129.1zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm16-32.6c57.7-4.1 109.4-30 146.8-69.6L272 289.8V479.4zm167.1-94.3c25.8-36.5 40.9-81 40.9-129.1c0-118.3-91.8-215.2-208-223.4V248.4L439.1 385.1z"]
};
var faPartyHorn = {
  prefix: 'fal',
  iconName: 'party-horn',
  icon: [512, 512, [], "e31b", "M40 32a24 24 0 1 1 48 0A24 24 0 1 1 40 32zM456 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM172.7 147.3c-6.2-6.2-6.2-16.4 0-22.6l8.3-8.3c18-18 29.3-41.6 32.1-66.8l3-27.4c1-8.8 8.9-15.1 17.7-14.1s15.1 8.9 14.1 17.7l-3 27.4c-3.6 32.5-18.2 62.8-41.3 85.9l-8.3 8.3c-6.2 6.2-16.4 6.2-22.6 0zm192 169.4l8.3-8.3c23.1-23.1 53.4-37.7 85.9-41.3l27.4-3c8.8-1 16.7 5.4 17.7 14.1s-5.4 16.7-14.1 17.7l-27.4 3c-25.3 2.8-48.8 14.1-66.8 32.1l-8.2 8.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm135.5-303c5.7 6.7 4.9 16.8-1.9 22.5l-10 8.5C475 55.9 458.1 61.9 440.7 61.4c-21-.6-38.6 15.6-39.8 36.5l-1.8 30c-2.2 38.2-34.4 67.7-72.6 66.6c-9.5-.3-18.8 3-26.1 9.2l-10 8.5c-6.7 5.7-16.8 4.9-22.5-1.9s-4.9-16.8 1.9-22.5l10-8.5c13.3-11.2 30.3-17.2 47.7-16.7c21 .6 38.6-15.6 39.8-36.5l1.8-30c2.2-38.2 34.4-67.7 72.6-66.6c9.5 .3 18.8-3 26.1-9.2l10-8.5c6.7-5.7 16.8-4.9 22.6 1.9zM32.1 479.6c0 0 .1 .1 .1 .1s.1 .1 .1 .1l76.2-28.6L60.7 403.4 32.1 479.6zm169.6-63.2L95.6 310.3 73 370.7c.8 .6 1.6 1.2 2.3 1.9l64 64c.7 .7 1.4 1.5 2 2.4l60.5-22.7zM234.7 404l53.3-20c0-.1 0-.1 .1-.2s0-.1 0-.2L128.3 224c-.1 0-.1 0-.2 0l-.1 0-.1 0-20 53.3L234.7 404zM98.1 212.6c8-21.4 36.4-27.6 52.6-11.4L310.9 361.3c16.2 16.2 10 44.6-11.4 52.6L43.3 510C18 519.4-7.4 494 2 468.8L98.1 212.6z"]
};
var faGears = {
  prefix: 'fal',
  iconName: 'gears',
  icon: [640, 512, ["cogs"], "f085", "M146.2 40.7l-6.9 25.1c-1.4 5.2-5.4 9.4-10.6 11c-14.6 4.6-27.9 12.4-39 22.5c-4 3.7-9.6 5.1-14.9 3.7L49.7 96.4c-2.2 3.1-4.3 6.3-6.3 9.6l-2.4 4.2c-1.8 3.3-3.5 6.6-5 10l18.3 18.5c3.8 3.9 5.4 9.4 4.2 14.7C56.8 160.7 56 168.2 56 176s.8 15.3 2.4 22.5c1.2 5.3-.4 10.8-4.2 14.7L35.9 231.8c1.5 3.4 3.2 6.7 5 10l2.5 4.3c2 3.3 4.1 6.5 6.3 9.6L74.9 249c5.3-1.4 10.9 0 14.9 3.7c11.1 10.2 24.3 17.9 39 22.5c5.2 1.6 9.2 5.8 10.6 11l6.9 25.1c4.5 .5 9.1 .7 13.8 .7s9.2-.2 13.8-.7l6.9-25.1c1.4-5.2 5.4-9.4 10.6-11c14.6-4.6 27.9-12.4 39-22.5c4-3.7 9.6-5.1 14.9-3.7l25.2 6.6c2.2-3 4.2-6.1 6.1-9.3l2.8-4.8c1.7-3.2 3.4-6.4 4.8-9.7l-18.3-18.5c-3.8-3.9-5.4-9.4-4.2-14.7c1.6-7.2 2.4-14.8 2.4-22.6s-.8-15.3-2.4-22.6c-1.2-5.3 .4-10.8 4.2-14.7l18.3-18.5c-1.5-3.3-3.1-6.5-4.8-9.7l-2.8-4.8c-1.9-3.2-4-6.3-6.1-9.3L245.1 103c-5.3 1.4-10.9 0-14.9-3.7c-11.1-10.2-24.3-17.9-39-22.5c-5.2-1.6-9.2-5.8-10.6-11l-6.9-25.1c-4.5-.5-9.1-.7-13.8-.7s-9.2 .2-13.8 .7zM130.8 10.5C140.3 8.9 150.1 8 160 8s19.7 .9 29.1 2.5c6.1 1.1 11 5.6 12.7 11.5l7.5 27.2c13.1 5.1 25.1 12.1 35.9 20.7l27.3-7.1c6-1.6 12.3 .5 16.3 5.2c5.6 6.7 10.7 13.8 15.2 21.3l.2 .3 0 0 2.9 5.1 .2 .3 0 0c4.1 7.5 7.7 15.4 10.7 23.6c2.1 5.8 .7 12.3-3.6 16.7l-19.8 20.1c1 6.8 1.6 13.7 1.6 20.7s-.5 13.9-1.6 20.7l19.8 20.1c4.3 4.4 5.8 10.9 3.6 16.7c-3 8.2-6.6 16-10.7 23.6l-.2 .3 0 0-3 5.1-.2 .3 0 0c-4.5 7.5-9.6 14.6-15.2 21.3c-4 4.7-10.3 6.8-16.3 5.2l-27.3-7.1c-10.7 8.6-22.8 15.6-35.8 20.7L201.8 330c-1.6 6-6.6 10.5-12.7 11.5c-9.5 1.7-19.2 2.5-29.1 2.5s-19.7-.9-29.2-2.5c-6.1-1.1-11-5.6-12.7-11.5l-7.5-27.2c-13.1-5.1-25.1-12.1-35.8-20.7l-27.3 7.1c-6 1.6-12.3-.5-16.3-5.2c-5.7-6.8-10.9-14-15.4-21.6l-.1-.2 0 0-2.6-4.5-.1-.2 0 0c-4.2-7.6-7.9-15.6-10.9-23.9c-2.1-5.8-.7-12.3 3.6-16.7l19.8-20.1C24.5 189.9 24 183 24 176s.5-13.9 1.6-20.7L5.7 135.2c-4.3-4.4-5.8-10.9-3.6-16.7c3-8.3 6.7-16.3 10.9-23.9l.1-.2 0 0 2.6-4.5 .1-.2 0 0C20.4 82 25.6 74.8 31.3 68c4-4.7 10.3-6.8 16.3-5.2l27.3 7.1c10.7-8.6 22.8-15.6 35.8-20.7L118.2 22c1.6-6 6.6-10.5 12.7-11.5zM104 176a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM328.7 365.8l25.1 6.9c5.2 1.4 9.4 5.4 11 10.6c4.6 14.6 12.4 27.9 22.5 39c3.7 4 5.1 9.6 3.7 14.9l-6.6 25.2c3.1 2.2 6.3 4.3 9.6 6.3l4.2 2.4c3.3 1.8 6.6 3.5 10 5l18.5-18.3c3.9-3.8 9.4-5.4 14.7-4.2c7.2 1.6 14.8 2.4 22.5 2.4s15.3-.8 22.5-2.4c5.3-1.2 10.8 .4 14.7 4.2l18.5 18.3c3.4-1.5 6.7-3.2 10-5l4.3-2.5c3.3-2 6.5-4.1 9.6-6.3L537 437.1c-1.4-5.3 0-10.9 3.7-14.9c10.2-11.1 17.9-24.3 22.5-39c1.6-5.2 5.8-9.2 11-10.6l25.1-6.9c.5-4.5 .7-9.1 .7-13.8s-.2-9.2-.7-13.8l-25.1-6.9c-5.2-1.4-9.4-5.4-11-10.6c-4.6-14.7-12.4-27.9-22.5-39c-3.7-4-5.1-9.6-3.7-14.9l6.6-25.2c-3-2.2-6.1-4.2-9.3-6.1l-4.8-2.8c-3.2-1.7-6.4-3.4-9.7-4.8l-18.5 18.3c-3.9 3.8-9.4 5.4-14.7 4.2c-7.2-1.6-14.8-2.4-22.6-2.4s-15.3 .8-22.6 2.4c-5.3 1.2-10.8-.4-14.7-4.2l-18.5-18.3c-3.3 1.5-6.5 3.1-9.7 4.8l-4.8 2.8c-3.2 1.9-6.3 4-9.3 6.1l6.6 25.2c1.4 5.3 0 10.9-3.7 14.9c-10.2 11.1-17.9 24.3-22.5 39c-1.6 5.2-5.8 9.2-11 10.6l-25.1 6.9c-.5 4.5-.7 9.1-.7 13.8s.2 9.2 .7 13.8zm-30.2 15.4c-1.7-9.5-2.5-19.2-2.5-29.2s.9-19.7 2.5-29.1c1.1-6.1 5.6-11 11.5-12.7l27.2-7.5c5.1-13.1 12.1-25.1 20.7-35.9l-7.1-27.3c-1.6-6 .5-12.3 5.2-16.3c6.7-5.6 13.8-10.7 21.3-15.2l.3-.2 0 0 5.1-2.9 .3-.2 0 0c7.5-4.1 15.4-7.7 23.6-10.7c5.8-2.1 12.3-.7 16.7 3.6l20.1 19.8c6.8-1 13.7-1.6 20.7-1.6s13.9 .5 20.7 1.6l20.1-19.8c4.4-4.3 10.9-5.8 16.7-3.6c8.2 3 16 6.6 23.6 10.7l.3 .2 0 0 5.1 3 .3 .2 0 0c7.5 4.5 14.6 9.6 21.3 15.2c4.7 4 6.7 10.3 5.2 16.3l-7.1 27.3c8.6 10.7 15.6 22.8 20.7 35.8l27.2 7.5c6 1.6 10.5 6.6 11.5 12.7c1.7 9.5 2.5 19.2 2.5 29.1s-.9 19.7-2.5 29.2c-1.1 6.1-5.6 11-11.5 12.7l-27.2 7.5c-5.1 13.1-12.1 25.1-20.7 35.8l7.1 27.3c1.6 6-.5 12.3-5.2 16.3c-6.8 5.7-14 10.9-21.6 15.4l-.2 .1 0 0-4.5 2.6-.2 .1 0 0c-7.6 4.2-15.6 7.9-23.9 10.9c-5.8 2.1-12.3 .7-16.7-3.6l-20.1-19.8c-6.8 1-13.7 1.6-20.7 1.6s-13.9-.5-20.7-1.6l-20.1 19.8c-4.4 4.3-10.9 5.8-16.7 3.6c-8.3-3-16.3-6.7-23.9-10.9l-.2-.1 0 0-4.5-2.6-.2-.1 0 0c-7.6-4.6-14.9-9.8-21.6-15.4c-4.7-4-6.8-10.3-5.2-16.3l7.1-27.3c-8.6-10.7-15.6-22.8-20.7-35.8L310 393.8c-6-1.6-10.5-6.6-11.5-12.7zM464 408a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm24-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCogs = faGears;
var faSunBright = {
  prefix: 'fal',
  iconName: 'sun-bright',
  icon: [512, 512, ["sun-alt"], "e28f", "M256 0c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zM0 256c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm400 0c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H416c-8.8 0-16-7.2-16-16zM256 400c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V416c0-8.8 7.2-16 16-16zM75 75c6.2-6.2 16.4-6.2 22.6 0l56.6 56.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L75 97.6c-6.2-6.2-6.2-16.4 0-22.6zm0 362c-6.2-6.2-6.2-16.4 0-22.6l56.6-56.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L97.6 437c-6.2 6.2-16.4 6.2-22.6 0zM357.8 154.2c-6.2-6.2-6.2-16.4 0-22.6L414.4 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.6 56.6c-6.2 6.2-16.4 6.2-22.6 0zm0 203.6c6.2-6.2 16.4-6.2 22.6 0L437 414.4c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-56.6-56.6c-6.2-6.2-6.2-16.4 0-22.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z"]
};
var faSunAlt = faSunBright;
var faWarehouse = {
  prefix: 'fal',
  iconName: 'warehouse',
  icon: [640, 512, [], "f494", "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V496c0 8.8-7.2 16-16 16c-.1 0-.2 0-.2 0H112.2c-.1 0-.2 0-.2 0c-8.8 0-16-7.2-16-16V224zm32 256H512V416H128v64zM512 320H128v64H512V320zM128 288H512V224H128v64z"]
};
var faConveyorBeltArm = {
  prefix: 'fal',
  iconName: 'conveyor-belt-arm',
  icon: [640, 512, [], "e5f8", "M128 16c0 8.8 7.2 16 16 16h77.1l-5.5 32.7C193.1 68.7 176 88.3 176 112c0 26.5 21.5 48 48 48c18.6 0 34.8-10.6 42.8-26.2L448 158v50c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8-5.9-14.8-13.9-15.9L271 102.1c-2.9-13.8-11.8-25.5-23.8-32.1l6.3-38H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm72 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM448 288h32v32H448V288zm-32-8v40H352V280c0-13.3-10.7-24-24-24H280c-13.3 0-24 10.7-24 24v40H192V280c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24l0 40c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H512V280c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zM96 352h24 48H280h48H440h48 56c35.3 0 64 28.7 64 64s-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64zm64-64v32H128V288h32zm128 32V288h32v32H288zM128 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faLockKeyholeOpen = {
  prefix: 'fal',
  iconName: 'lock-keyhole-open',
  icon: [576, 512, ["lock-open-alt"], "f3c2", "M448 32c-53 0-96 43-96 96v64h16c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80H320V128C320 57.3 377.3 0 448 0s128 57.3 128 128v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-53-43-96-96-96zM80 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H336 80zM264 368H184c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faLockOpenAlt = faLockKeyholeOpen;
var faSquareFragile = {
  prefix: 'fal',
  iconName: 'square-fragile',
  icon: [448, 512, ["box-fragile", "square-wine-glass-crack"], "f49b", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32v80c0 44.2 35.8 80 80 80s80-35.8 80-80V128H230.6l20.7 20.7c3.4 3.4 5.1 8.1 4.6 12.9s-3.1 9.1-7 11.7l-30.2 20.1 31.5 26.3c6.8 5.7 7.7 15.7 2 22.5s-15.7 7.7-22.5 2l-48-40c-3.9-3.2-6-8.1-5.7-13.1s2.9-9.7 7.1-12.5l31.8-21.2L185.4 128H144zm-1.1-32H305.1c17.1 0 30.9 13.8 30.9 30.9V208c0 56.4-41.7 103.1-96 110.9V384h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V318.9c-54.3-7.8-96-54.4-96-110.9V126.9c0-17.1 13.8-30.9 30.9-30.9z"]
};
var faBoxFragile = faSquareFragile;
var faSquareWineGlassCrack = faSquareFragile;
var faArrowUpRightDots = {
  prefix: 'fal',
  iconName: 'arrow-up-right-dots',
  icon: [576, 512, [], "e4b7", "M144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H265.4L4.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H144zM528 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm128-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 464a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM528 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faSquareN = {
  prefix: 'fal',
  iconName: 'square-n',
  icon: [448, 512, [], "e277", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm157 38.7L288 318.1V144c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 7-4.5 13.1-11.1 15.2s-13.9-.3-17.9-5.9L160 193.9V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7 4.5-13.1 11.1-15.2s13.9 .3 17.9 5.9z"]
};
var faSplotch = {
  prefix: 'fal',
  iconName: 'splotch',
  icon: [512, 512, [], "f5bc", "M189.1 416.1L86.4 425.5C65.8 427.3 48 411.1 48 390.4c0-7.6 2.5-15 7-21.1l18.8-25c14.5-19.4 22.1-43.1 21.6-67.3c-.5-20.2-6.6-39.8-17.6-56.6L37.3 158.5c-3.4-5.2-5.3-11.4-5.3-17.6c0-20.1 18.2-35.2 37.9-31.6l42.8 7.8c47 8.5 94.9-8.8 125.4-45.5l22.3-26.8c6.7-8 16.6-12.7 27.1-12.7c15.2 0 28.7 9.7 33.5 24.1l15 45.1c14.2 42.6 46.9 76.5 88.9 92.3l32.3 12.1c13.7 5.1 22.7 18.2 22.7 32.8c0 11-5.2 21.4-14 28L404 313c-33.4 25-51 65.8-46.4 107.3l2.5 22.7c2.2 19.8-13.3 37.1-33.2 37.1c-7.6 0-14.9-2.6-20.9-7.3L269 443c-21.8-17.5-49-27-77-27c-1 0-1.9 0-2.9 .1zM51 237.8c7.8 11.9 12.1 25.7 12.4 39.8c.4 17-4.9 33.7-15.2 47.4l-18.8 25C20.7 361.7 16 375.9 16 390.4c0 39.5 33.9 70.5 73.3 66.9L192 448c20.7 0 40.8 7 57 20l37.1 29.7c11.6 9.3 26 14.3 40.8 14.3c39 0 69.3-33.9 65-72.6l-2.5-22.7c-3.4-30.2 9.5-59.9 33.8-78.1l62-46.5c16.9-12.7 26.8-32.5 26.8-53.6c0-28-17.3-53-43.5-62.8l-32.3-12.1c-33-12.4-58.7-39-69.8-72.4L351.3 46c-9.2-27.5-34.9-46-63.8-46c-20 0-38.9 8.9-51.7 24.2L213.5 51C190.3 78.8 154 92 118.4 85.5L75.6 77.7C36.2 70.6 0 100.8 0 140.9c0 12.5 3.6 24.7 10.5 35.1L51 237.8z"]
};
var faFaceGrinHearts = {
  prefix: 'fal',
  iconName: 'face-grin-hearts',
  icon: [512, 512, [128525, "grin-hearts"], "f584", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM195.1 144.6c-9.3-2.5-18.8 3-21.3 12.3l-4.3 16.1c-2.3 8.5-11.1 13.6-19.6 11.3l-16.1-4.3c-9.3-2.5-18.8 3-21.3 12.3s3 18.8 12.3 21.3L190 230.9l17.4-65c2.5-9.3-3-18.8-12.3-21.3zm-52.2 4c7.1-26.3 34.1-42 60.4-34.9s42 34.1 34.9 60.4l-17.4 65c-4.6 17.1-22.1 27.2-39.2 22.6l-65.1-17.4c-26.3-7.1-42-34.1-34.9-60.4s34.1-42 60.4-34.9l.7 .2 .2-.6zm226.1 0l.2 .6 .7-.2c26.3-7.1 53.4 8.6 60.4 34.9s-8.6 53.4-34.9 60.4l-65.1 17.4c-17.1 4.6-34.6-5.6-39.2-22.6l-17.4-65c-7.1-26.3 8.6-53.4 34.9-60.4s53.4 8.6 60.4 34.9zm-52.2-4c-9.3 2.5-14.8 12-12.3 21.3l17.4 65 65.1-17.4c9.3-2.5 14.8-12 12.3-21.3s-12-14.8-21.3-12.3L362 184.2c-8.5 2.3-17.3-2.8-19.6-11.3l-4.3-16.1c-2.5-9.3-12-14.8-21.3-12.3z"]
};
var faGrinHearts = faFaceGrinHearts;
var faMeter = {
  prefix: 'fal',
  iconName: 'meter',
  icon: [512, 512, [], "e1e8", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMandolin = {
  prefix: 'fal',
  iconName: 'mandolin',
  icon: [512, 512, [], "f6f9", "M459.3 4.7C454.3-.4 446.5-1.5 440.2 2l-72 40c-4 2.2-6.8 6-7.8 10.4l-23 99.5-38.6 38.6C227.4 187.1 0 187.6 0 336c0 97.2 78.8 176 176 176c148.4 0 148.9-227.4 145.4-298.8l38.6-38.6 99.5-23c4.4-1 8.2-3.9 10.4-7.8l40-72c3.5-6.2 2.4-14-2.7-19.1l-48-48zm-191.7 217l-43.1 43.1c-9.5-5.6-20.6-8.9-32.5-8.9c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-11.9-3.2-23-8.9-32.5l43.1-43.1c.2 28.6-1.4 65.6-7.8 102.1c-6.6 37.9-18 72.4-35.6 96.7C230.3 466.1 208.4 480 176 480C96.5 480 32 415.5 32 336c0-32.4 13.9-54.3 36.8-70.8c24.3-17.6 58.8-29 96.7-35.6c36.5-6.4 73.5-7.9 102.1-7.8zM445.5 122l-72.1 16.6L390 66.5l55.2-30.7 30.9 30.9L445.5 122zM192 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faDiceFour = {
  prefix: 'fal',
  iconName: 'dice-four',
  icon: [448, 512, [9859], "f524", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSimCard = {
  prefix: 'fal',
  iconName: 'sim-card',
  icon: [384, 512, [], "f7c4", "M32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V154.5c0-8.5-3.4-16.6-9.4-22.6L252.1 41.4c-6-6-14.1-9.4-22.6-9.4H64C46.3 32 32 46.3 32 64zM0 448V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM64 280V240c0-26.5 21.5-48 48-48h48 16 16 40 40c26.5 0 48 21.5 48 48v40 80 40c0 26.5-21.5 48-48 48H224 208 192 112c-26.5 0-48-21.5-48-48V360 280zM96 400c0 8.8 7.2 16 16 16h80V376H152 96v24zm176 16c8.8 0 16-7.2 16-16V376H224v40h48zm-64-72h80V296H232 176 96v48h56 56zm80-104c0-8.8-7.2-16-16-16H232 192v40h40 56V240zM160 224H112c-8.8 0-16 7.2-16 16v24h64V224z"]
};
var faTransgender = {
  prefix: 'fal',
  iconName: 'transgender',
  icon: [512, 512, [9895, "transgender-alt"], "f225", "M144 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H32C23.2 0 16 7.2 16 16V128c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6L89.4 96l-4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l4.7-4.7 13.2 13.2C106.8 157.9 96 189.7 96 224c0 83 63.1 151.2 144 159.2V416H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V383.2c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L464 54.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h73.4l-75.6 75.6C337.1 80.6 298.5 64 256 64s-81.1 16.6-109.8 43.6L134.6 96l4.7-4.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 73.4 70.6 32H144zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
var faTransgenderAlt = faTransgender;
var faMercury = {
  prefix: 'fal',
  iconName: 'mercury',
  icon: [384, 512, [9791], "f223", "M89.2 4.8C83-1.5 72.8-1.6 66.5 4.6s-6.4 16.3-.2 22.6C81.2 42.4 98.9 55 118.6 64C58 91.8 16 153 16 224c0 91.8 70.3 167.2 160 175.3V432H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V399.3c89.7-8.1 160-83.5 160-175.3c0-71-42-132.2-102.6-160c19.6-9 37.3-21.6 52.3-36.8c6.2-6.3 6.1-16.4-.2-22.6s-16.4-6.1-22.6 .2C268.7 31.5 232.3 48 192 48S115.3 31.5 89.2 4.8zM192 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288z"]
};
var faUpFromBracket = {
  prefix: 'fal',
  iconName: 'up-from-bracket',
  icon: [448, 512, [], "e590", "M222.2 32.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L350.2 164.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7H288c-8.8 0-16 7.2-16 16V312c0 4.4-3.6 8-8 8H184c-4.4 0-8-3.6-8-8V192c0-8.8-7.2-16-16-16H102.7c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L222.2 32.8zM224 0c-9.5 0-18.6 3.9-25.1 10.8L74.5 142.8C67.8 150 64 159.5 64 169.3c0 21.4 17.3 38.7 38.7 38.7H144V312c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V208h41.3c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L249.1 10.8C242.6 3.9 233.5 0 224 0zM32 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336z"]
};
var faKnifeKitchen = {
  prefix: 'fal',
  iconName: 'knife-kitchen',
  icon: [576, 512, [128298], "f6f5", "M485.7 33l-175 175 76.2 76.2 45-25c5.1-2.8 8.2-8.2 8.2-14V213.3c0-12.7 5.1-24.9 14.1-33.9l89-89c.6-.6 1-1.5 1-2.3s-.3-1.7-1-2.3L490.3 33c-.6-.6-1.5-1-2.3-1s-1.7 .3-2.3 1zM488 0c9.4 0 18.3 3.7 25 10.3L565.7 63c6.6 6.6 10.3 15.6 10.3 25s-3.7 18.3-10.3 25l-89 89c-3 3-4.7 7.1-4.7 11.3v31.9c0 17.4-9.4 33.5-24.7 42l-45 25c-12.5 6.9-28.1 4.8-38.2-5.3L288 230.6c-12.5-12.5-12.5-32.8 0-45.3l175-175C469.7 3.7 478.6 0 488 0zM4.7 468.7L242.7 230.6l22.6 22.6L46.6 472c21.7 5.1 43.9 8 65.4 8c99.8 0 165.6-39.9 232.5-102.4l-9-9c-12.5-12.5-12.5-32.7 0-45.2l33 33c11.5 12.6 11.3 32.2-1.3 43.9C296.6 466.3 223.2 512 112 512c-33.9 0-68.6-6.3-100.8-16.8C0 491.5-3.7 477.1 4.7 468.7zM416 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faBorderRight = {
  prefix: 'fal',
  iconName: 'border-right',
  icon: [448, 512, [], "f852", "M432 32c8.8 0 16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16zM320 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 432a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM32 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 432a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm192-48a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM32 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm192-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faArrowTurnDown = {
  prefix: 'fal',
  iconName: 'arrow-turn-down',
  icon: [384, 512, ["level-down"], "f149", "M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0L128 0c44.2 0 80 35.8 80 80l0 377.4L308.7 356.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 457.4 176 80c0-26.5-21.5-48-48-48L16 32z"]
};
var faLevelDown = faArrowTurnDown;
var faSpade = {
  prefix: 'fal',
  iconName: 'spade',
  icon: [512, 512, [9824], "f2f4", "M449.2 231.8c43.3 44.9 41 119.4-6.8 161.2c-41.5 34.7-104.2 29.3-143.7-10.6l-18.5-20.5c-6-6.6-14.4-10.4-23.3-10.5s-17.4 3.5-23.6 9.9l-19.8 20.8C173.6 422.6 110 427.4 70.7 393.2l-.2-.2 0 0c-48.7-41.8-51.1-116.3-7.8-161.2l0 0L256.4 32.1c.1 0 .2 .1 .3 .2L449.2 231.8l0 0zm23-22.2L279.4 9.7c-13-13-34-13-45.9 0L39.7 209.5c-55.9 57.9-52.9 153.8 10 207.8c53.1 46.3 134.4 38.2 184.6-10.8c.7-.7 1.5-1.5 2.2-2.2l3.5-3.7V480H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V400.6l3.4 3.8c.9 .9 1.8 1.8 2.7 2.7c50.2 48.6 130.1 56.4 185.1 10.3c61.9-53.9 64.9-149.8 9-207.8z"]
};
var faCardSpade = {
  prefix: 'fal',
  iconName: 'card-spade',
  icon: [384, 512, [], "e3ec", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm180.7 68.2c6.2-6.2 16.4-6.2 22.6 0l33.9 33.9L297 225.9c25 25 25 65.5 0 90.5c-24.5 24.5-63.9 25-89 1.5V352h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V317.8c-25.1 23.5-64.5 23-89-1.5c-25-25-25-65.5 0-90.5l59.7-59.7 33.9-33.9zm33.9 56.6L192 166.1l-22.6 22.6-59.7 59.7c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l25.8-25.8c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7l25.8 25.8c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-59.7-59.7z"]
};
var faLineColumns = {
  prefix: 'fal',
  iconName: 'line-columns',
  icon: [512, 512, [], "f870", "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 320c0 8.8 7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM288 192c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zM304 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zM288 320c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"]
};
var faArrowRightToLine = {
  prefix: 'fal',
  iconName: 'arrow-right-to-line',
  icon: [448, 512, [8677, "arrow-to-right"], "f340", "M448 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352zM347.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 240 192 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 105.4 0L196.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128z"]
};
var faArrowToRight = faArrowRightToLine;
var faPersonFallingBurst = {
  prefix: 'fal',
  iconName: 'person-falling-burst',
  icon: [640, 512, [], "e547", "M240 0c8.8 0 16 7.2 16 16l0 10.8c0 55.4-29.2 105.8-75.2 133.7l67.3 102.6 59.4-5.9c13.2-1.3 25.9 5.7 31.8 17.5l43.1 86.1c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L310.6 289l-64.4 6.4-57.5 44.7 96.6 147.1c4.9 7.4 2.8 17.3-4.6 22.2s-17.3 2.8-22.2-4.6L79.8 232.6C69.6 250.7 64 271.5 64 293.2L64 368c0 8.8-7.2 16-16 16s-16-7.2-16-16V293.2c0-67.3 43.1-127.1 106.9-148.4c3.2-1.1 6.2-2.2 9.3-3.5c.2-.1 .4-.3 .6-.4c1.6-1.1 3.4-1.8 5.2-2.2c42.4-20.6 70-63.8 70-111.9L224 16c0-8.8 7.2-16 16-16zM171.1 313.3l47.4-36.9L151.6 174.3c-.8 .3-1.7 .6-2.5 .9c-18.9 6.3-35.5 16.8-48.9 30.4c.4 .5 .9 1.1 1.3 1.7l69.7 106.1zM56 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 56 32zM464 291.5l-57 47.2-27.6-55.2L380 251l-21.4-4.5c-13.2-15-32.9-23.2-53.3-21.5l-11.8 1c-.4-.9-.7-1.9-1-2.9c-1.4-6.1 .9-12.4 5.8-16.2l60.9-46.8L324.6 91.4c-2.8-5.6-2.1-12.3 1.8-17.2s10.3-7.1 16.3-5.6l74.6 18.4 32.1-69.8C452.1 11.6 457.8 8 464 8s11.9 3.6 14.5 9.3l32.1 69.8 74.6-18.4c6.1-1.5 12.5 .7 16.3 5.6s4.6 11.6 1.8 17.2l-34.6 68.6 60.9 46.8c5 3.8 7.2 10.2 5.8 16.2s-6.2 10.8-12.3 12.1L548 251l1.4 76.8c.1 6.2-3.4 12-9.1 14.7s-12.3 1.9-17.1-2.1l-59.2-49zm0-229.2l-23.1 50.2c-3.2 7-10.9 10.7-18.4 8.9l-53.7-13.3 24.9 49.4c3.5 6.9 1.6 15.2-4.5 19.9l-43.8 33.7 54.1 11.3c7.5 1.6 12.9 8.3 12.7 15.9l-1 55.3 42.6-35.2c5.9-4.9 14.5-4.9 20.4 0l42.6 35.2-1-55.3c-.1-7.7 5.2-14.4 12.7-15.9l54.1-11.3-43.8-33.7c-6.1-4.7-8-13-4.5-19.9l24.9-49.4-53.7 13.3c-7.5 1.8-15.2-1.9-18.4-8.9L464 62.3z"]
};
var faFlagPennant = {
  prefix: 'fal',
  iconName: 'flag-pennant',
  icon: [448, 512, [128681, "pennant"], "f456", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V32 64 320v32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V350.9L432.9 213.2c9.1-3.1 15.1-11.6 15.1-21.2s-6.1-18.1-15.1-21.2L32 33.1V16zm0 50.9L396.1 192 32 317.1V66.9z"]
};
var faPennant = faFlagPennant;
var faConveyorBeltEmpty = {
  prefix: 'fal',
  iconName: 'conveyor-belt-empty',
  icon: [640, 512, [], "e150", "M96 352c-35.3 0-64 28.7-64 64s28.7 64 64 64H544c35.3 0 64-28.7 64-64s-28.7-64-64-64H96zM0 416c0-53 43-96 96-96H544c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm128-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faUserGroupSimple = {
  prefix: 'fal',
  iconName: 'user-group-simple',
  icon: [640, 512, [], "e603", "M88 136a72 72 0 1 1 144 0A72 72 0 1 1 88 136zm176 0A104 104 0 1 0 56 136a104 104 0 1 0 208 0zm144 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm176 0a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM208 320c53 0 96 43 96 96v16c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V416c0-53 43-96 96-96h80zm-80-32C57.3 288 0 345.3 0 416v16c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V416c0-32.4-12-61.9-31.8-84.4C280.7 304.9 246.3 288 208 288H128zM432 480h80c70.7 0 128-57.3 128-128V336c0-26.5-21.5-48-48-48H352c-12.7 0-24.2 4.9-32.8 13c7.7 7.4 14.7 15.7 20.8 24.5c2.9-3.4 7.2-5.5 12.1-5.5H592c8.8 0 16 7.2 16 16v16c0 53-43 96-96 96H432c-24.6 0-47-9.2-64-24.4V432c0 9.8-1.8 19.2-5 27.8c19.9 12.8 43.6 20.2 69 20.2z"]
};
var faAward = {
  prefix: 'fal',
  iconName: 'award',
  icon: [384, 512, [], "f559", "M166.5 7.2c15.7-9.5 35.3-9.5 51 0l16.4 10c2.8 1.7 6 2.6 9.3 2.5l19.2-.5c18.3-.4 35.4 9.4 44.2 25.5l9.2 16.8c1.6 2.9 3.9 5.2 6.8 6.8l16.8 9.2c16.1 8.8 25.9 25.8 25.5 44.2l-.5 19.2c-.1 3.3 .8 6.5 2.5 9.3l10 16.4c9.5 15.7 9.5 35.3 0 51l-10 16.4c-1.7 2.8-2.6 6-2.5 9.3l.5 19.2c.4 18.3-9.4 35.4-25.5 44.2l-16.8 9.2c-2.9 1.6-5.2 3.9-6.8 6.8l-9.2 16.8c-8.8 16.1-25.8 25.9-44.2 25.5l-19.2-.5c-3.3-.1-6.5 .8-9.3 2.5l-16.4 10c-15.7 9.5-35.3 9.5-51 0l-16.4-10c-2.8-1.7-6-2.6-9.3-2.5l-19.2 .5c-18.3 .4-35.4-9.4-44.2-25.5l-9.2-16.8c-1.6-2.9-3.9-5.2-6.8-6.8l-16.8-9.2c-16.1-8.8-25.9-25.8-25.5-44.2l.5-19.2c.1-3.3-.8-6.5-2.5-9.3l-10-16.4c-9.5-15.7-9.5-35.3 0-51l10-16.4 13.7 8.3-13.7-8.3c1.7-2.8 2.6-6 2.5-9.3l-.5-19.2c-.4-18.3 9.4-35.4 25.5-44.2l16.8-9.2c2.9-1.6 5.2-3.9 6.8-6.8l9.2-16.8c8.8-16.1 25.8-25.9 44.2-25.5l19.2 .5c3.3 .1 6.5-.8 9.3-2.5l16.4-10zm34.4 27.3c-5.4-3.3-12.3-3.3-17.7 0l-16.4 10c-8 4.9-17.3 7.4-26.7 7.1l-19.2-.5c-6.4-.2-12.3 3.3-15.3 8.9L96.4 76.9c-4.5 8.2-11.3 15-19.5 19.5L60 105.6c-5.6 3.1-9 9-8.9 15.3l.5 19.2c.2 9.4-2.3 18.6-7.1 26.7l-10 16.4c-3.3 5.4-3.3 12.3 0 17.7l10 16.4c4.9 8 7.4 17.3 7.1 26.7l-.5 19.2c-.2 6.4 3.3 12.3 8.9 15.3l16.8 9.2c8.2 4.5 15 11.3 19.5 19.5l9.2 16.8c3.1 5.6 9 9 15.3 8.9l19.2-.5c9.4-.2 18.6 2.3 26.7 7.1l16.4 10c5.4 3.3 12.3 3.3 17.7 0l16.4-10c8-4.9 17.3-7.4 26.7-7.1l19.2 .5c6.4 .2 12.3-3.3 15.3-8.9l9.2-16.8c4.5-8.2 11.3-15 19.5-19.5l16.8-9.2c5.6-3.1 9-9 8.9-15.3l-.5-19.2c-.2-9.4 2.3-18.6 7.1-26.7l10-16.4c3.3-5.4 3.3-12.3 0-17.7l-10-16.4c-4.9-8-7.4-17.3-7.1-26.7l.5-19.2c.2-6.4-3.3-12.3-8.9-15.3l-16.8-9.2c-8.2-4.5-15-11.3-19.5-19.5L278.4 60c-3.1-5.6-9-9-15.3-8.9l-19.2 .5c-9.4 .2-18.6-2.3-26.7-7.1l-16.4-10zM192 136a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm88 56a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zM1.3 441.8l41.2-97.9c1.5 1.8 3.6 4.8 6.9 10.8c4 7.4 9.1 14 15 19.6L41.8 428l38.1-5.7c6.2-.9 12.3 1.8 15.7 7.1L116.9 462l26-61.8c1.8 .9 4.1 2.2 6.9 3.9c7 4.3 14.5 7.4 22.2 9.3l-37.3 88.7c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4l-37.3-88.7c7.7-2 15.2-5.1 22.2-9.3c2.8-1.7 5.1-3 6.9-3.9l26 61.8 21.3-32.6c3.4-5.2 9.6-8 15.7-7.1l38.1 5.7-22.6-53.7c5.9-5.6 11-12.2 15-19.6c3.3-6 5.4-9 6.9-10.8l41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"]
};
var faTicketSimple = {
  prefix: 'fal',
  iconName: 'ticket-simple',
  icon: [576, 512, ["ticket-alt"], "f3ff", "M560 194l4 15.5c7.1-1.8 12-8.2 12-15.5H560zm0 124h16c0-7.3-4.9-13.7-12-15.5L560 318zM16 318l-4-15.5C4.9 304.3 0 310.7 0 318H16zm0-124H0c0 7.3 4.9 13.7 12 15.5L16 194zM64 64C28.7 64 0 92.7 0 128H32c0-17.7 14.3-32 32-32V64zm448 0H64V96H512V64zm64 64c0-35.3-28.7-64-64-64V96c17.7 0 32 14.3 32 32h32zm0 66V128H544v66h32zm-48 62c0-22.3 15.3-41.2 36-46.5l-8-31c-34.5 8.9-60 40.2-60 77.5h32zm36 46.5c-20.7-5.3-36-24.1-36-46.5H496c0 37.3 25.5 68.6 60 77.5l8-31zM576 384V318H544v66h32zm-64 64c35.3 0 64-28.7 64-64H544c0 17.7-14.3 32-32 32v32zM64 448H512V416H64v32zM0 384c0 35.3 28.7 64 64 64V416c-17.7 0-32-14.3-32-32H0zm0-66v66H32V318H0zm48-62c0 22.3-15.3 41.2-36 46.5l8 31c34.5-8.9 60-40.2 60-77.5H48zM12 209.5c20.7 5.3 36 24.1 36 46.5H80c0-37.3-25.5-68.6-60-77.5l-8 31zM0 128v66H32V128H0z"]
};
var faTicketAlt = faTicketSimple;
var faBuilding = {
  prefix: 'fal',
  iconName: 'building',
  icon: [384, 512, [127970, 61687], "f1ad", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM224 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm-96 96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256 224 160 128zM64 120c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V120zm32 8v32h32V128H96zM248 96h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm8 64h32V128H256v32zM64 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V248zm32 8v32h32V256H96zm152-32h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm8 64h32V256H256v32z"]
};
var faAnglesLeft = {
  prefix: 'fal',
  iconName: 'angles-left',
  icon: [512, 512, [171, "angle-double-left"], "f100", "M52.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 256 235.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160zm352-160l-160 160c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256 427.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faAngleDoubleLeft = faAnglesLeft;
var faCamcorder = {
  prefix: 'fal',
  iconName: 'camcorder',
  icon: [576, 512, [128249, "video-handheld"], "f8a8", "M96 112c0-26.5 21.5-48 48-48H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-44.2 0-80 35.8-80 80v48c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V399 241 224c0-35.3-28.7-64-64-64H96V112zM80 192H320c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H80zM520.3 460.5c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5v-209c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 226.4v35.1l117.4-52.8c1-.4 2-.7 3.1-.7c4.2 0 7.5 3.4 7.5 7.5v209c0 4.2-3.4 7.5-7.5 7.5c-1.1 0-2.1-.2-3.1-.7L416 378.5v35.1l104.3 46.9zM64 240c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z"]
};
var faVideoHandheld = faCamcorder;
var faPancakes = {
  prefix: 'fal',
  iconName: 'pancakes',
  icon: [512, 512, [129374], "e42d", "M73.8 100c8.5-6.2 21.9-12.5 39.9-18c13.7-4.2 29.6-7.9 47.2-10.7c-.5 2.8-.8 5.7-.8 8.7c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48c0-3-.3-5.9-.8-8.7c17.5 2.9 33.4 6.5 47.2 10.7c18 5.5 31.3 11.8 39.9 18c8.9 6.5 9.8 10.7 9.8 12c0 1.1-.6 4.3-6.6 9.5c-5.9 5.1-15.5 10.5-29 15.7c-26.7 10.2-65.3 18-110.4 21.2c-25.2 1.8-46.1 22.4-46.1 48.7V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.3c0-25.1-20.7-43.9-43.1-46.7c-28.5-3.5-52.9 18.5-52.9 47V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V166.1c0-19-11.4-33.8-23.4-43c-7.9-6-8.6-9.9-8.6-11.1c0-1.3 .9-5.5 9.8-12zM199.5 66.5C217.3 64.9 236.3 64 256 64s38.7 .9 56.5 2.5C317 69.3 320 74.3 320 80c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16c0-5.7 3-10.7 7.5-13.5zm-95.3-15C84.5 57.5 67.5 65 54.9 74.1C42.8 83 32 95.6 32 112c0 15.6 9.8 27.8 21.1 36.5c7.4 5.7 10.9 12.1 10.9 17.6V336c0 26.5 21.5 48 48 48s48-21.5 48-48V202.5c0-9.5 7.8-16.3 17-15.2c8.9 1.1 15 8.5 15 14.9V288c0 26.5 21.5 48 48 48s48-21.5 48-48V207.1c0-8.5 6.9-16.1 16.4-16.8c47-3.4 88.9-11.6 119.5-23.3c15.2-5.8 28.6-12.9 38.4-21.3C472 137.4 480 126.1 480 112c0-16.4-10.8-29-22.9-37.9c-12.5-9.1-29.6-16.6-49.3-22.7C368.2 39.3 314.6 32 256 32s-112.2 7.3-151.8 19.5zM426.8 210.7c-28.1 9.5-64.7 15.9-106.8 19v32.1c64.8-4.6 119.7-16.7 153.9-37.3c4.6 5.8 6.1 11.2 6.1 15.5c0 10.8-8.9 27.7-53.2 42.7c-28.4 9.6-65.4 16-108 19.1c-2.1 12.1-7 23.3-13.9 32.9c71.3-3.8 132.1-16.1 169-38.3c4.6 5.8 6.1 11.2 6.1 15.5c0 10.8-8.9 27.7-53.2 42.7C385.2 368.8 325.1 376 256 376c-25.8 0-50.3-1-73.1-3c-6.2 11.9-15.3 22-26.3 29.4c30.6 3.8 64.1 5.6 99.4 5.6c92.1 0 172.8-12.4 217.9-39.5c4.6 5.8 6.1 11.2 6.1 15.5c0 10.8-8.9 27.7-53.2 42.7C385.2 440.8 325.1 448 256 448s-129.2-7.2-170.8-21.3C40.9 411.7 32 394.8 32 384c0-4.4 1.4-9.7 6.1-15.5l1.1 .6C34.6 359 32 347.8 32 336V312 240 172.6c-8.9-7.1-18.9-17.3-25.3-30.9C2.3 149.8 0 158.5 0 168c0 13.5 4.7 25.5 13.4 36C4.7 214.5 0 226.5 0 240s4.7 25.5 13.4 36C4.7 286.5 0 298.5 0 312s4.7 25.5 13.4 36C4.7 358.5 0 370.5 0 384c0 66.7 114.6 96 256 96s256-29.3 256-96c0-13.5-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36s-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36s-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36c0-9.5-2.3-18.3-6.7-26.3c-5.8 12.1-14.3 21.6-22.2 28.3c-1.2 1-2.5 2.1-3.7 3.1c-2.7 10.6-14.7 24.8-52.6 37.6z"]
};
var faAlbumCircleUser = {
  prefix: 'fal',
  iconName: 'album-circle-user',
  icon: [576, 512, [], "e48d", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H275.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V96c0-17.7-14.3-32-32-32zM224 96c69.3 0 128.3 44 150.5 105.6c-10.2 3.5-20 8-29.3 13.2C328.1 164.3 280.3 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c11.2 0 22-1.4 32.4-4.1c.7 10.9 2.4 21.5 5 31.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm0 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM492 462.6c-7.8-9.1-19.4-14.6-31.8-14.6H403.8c-12.4 0-23.9 5.5-31.8 14.6c17.3 11 37.9 17.4 60 17.4s42.7-6.4 60-17.4zm24.3-20.8C533.5 422.1 544 396.2 544 368c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 28.2 10.5 54.1 27.7 73.8c13.8-16.1 34.2-25.8 56.1-25.8h56.4c21.8 0 42.2 9.6 56.1 25.8zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faQrcode = {
  prefix: 'fal',
  iconName: 'qrcode',
  icon: [448, 512, [], "f029", "M144 64H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80C0 53.5 21.5 32 48 32zm96 288H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16zM48 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM304 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H304zM256 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80zm0 224c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v68h64V304c0-8.8 7.2-16 16-16s16 7.2 16 16v84c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V320H288V472c0 8.8-7.2 16-16 16s-16-7.2-16-16V304zM88 104h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16zM72 376c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V376zM344 104h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H344c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16zM320 448c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V448zm96-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V448c0-8.8 7.2-16 16-16z"]
};
var faDiceD10 = {
  prefix: 'fal',
  iconName: 'dice-d10',
  icon: [512, 512, [], "f6cd", "M213.8 84.1L55.6 264.1l92.7-21.8L213.8 84.1zM48.6 298.6L240 463.6V328.6l-83.1-55.4L48.6 298.6zM272 463.6l191.4-165L355.1 273.2 272 328.6V463.6zM456.4 264.1L298.2 84.1l65.4 158.2 92.7 21.8zM256 0c6.9 0 13.5 3 18 8.2l232 264c4.2 4.8 6.4 11.1 5.9 17.5s-3.4 12.3-8.3 16.5l-232 200c-9 7.8-22.3 7.8-31.3 0l-232-200C3.5 302 .5 296 .1 289.7S1.7 277 6 272.2L238 8.2C242.5 3 249.1 0 256 0zm0 300.8L332.2 250 256 65.8 179.8 250 256 300.8z"]
};
var faFireplace = {
  prefix: 'fal',
  iconName: 'fireplace',
  icon: [640, 512, [], "f79a", "M32 0C14.3 0 0 14.3 0 32V96c0 17.7 14.3 32 32 32V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352c0-88.4 71.6-160 160-160s160 71.6 160 160V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V128c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM576 128V480H512V352c0-106-86-192-192-192s-192 86-192 192V480H64V128H576zM32 32H608V96H32V32zM341.4 332.7c9.6-.1 18.7-4.5 24.7-12.1l1.7-2.1c8.7 10.6 16.4 22.6 22.5 34.5c9.6 18.5 14 35.5 14 42.7c0 46.3-37.6 84.3-84.4 84.3c-47.3 0-84.4-37.9-84.4-84.3c0-10.7 5.9-29.6 18.8-50.6c9.9-16.1 23.3-33.1 39.1-49.2c8 8 15.6 16.4 22.9 25.2c6.2 7.4 15.3 11.6 25 11.5zm77.3 5.6c-10.7-20.7-25.9-42.5-43.9-59c-3.2-2.9-7.8-3.6-11.6-1.9c-1.1 .5-2.1 1.1-2.9 1.9c-7 6.4-13.5 14.3-19.2 21.5c-7-8.4-14.2-16.4-21.7-24.1c-6-6.2-12.3-12.1-18.6-17.9c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4zM307 353.4c-3.1-3.9-7.8-6.2-12.7-6.1s-9.6 2.4-12.6 6.3c-4.7 6.2-8.6 11.8-11.8 17.2c-5.5 9.4-8.2 17.5-8.2 26.3c0 8.8 7.2 16 16 16s16-7.2 16-16c0-1 .1-2.8 1.8-6.4l18.8 24 0 0c5.9 7.5 14.9 12 24.5 12.2s18.8-3.9 25-11.2l9.6-11.2c5.8-6.7 5-16.8-1.7-22.6s-16.8-5-22.6 1.7l-9.6 11.2 0 0-21.5-27.4 0 0L307 353.4z"]
};
var faBrowser = {
  prefix: 'fal',
  iconName: 'browser',
  icon: [512, 512, [128468], "f37e", "M160 64v64H480V96c0-17.7-14.3-32-32-32H160zm-32 0H64C46.3 64 32 78.3 32 96v32h96V64zM32 160V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V160H144 32zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faPenPaintbrush = {
  prefix: 'fal',
  iconName: 'pen-paintbrush',
  icon: [576, 512, ["pencil-paintbrush"], "f618", "M320.5 410c4.9 39.5 38.6 70 79.4 70H539.1c-21.2 0-37.5-11.5-47.2-24.9c-9.5-13.1-14.2-30-12.5-46.7c.3-2.7 .4-5.5 .4-8.3c0-40.8-30.5-74.5-70-79.4l26.5-26.5c43.9 15.1 75.5 56.8 75.5 105.9c0 3.9-.2 7.8-.6 11.6c-1.8 17.5 10.2 36.4 27.8 36.4h4.8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-144c-49.1 0-90.8-31.6-105.9-75.5L320.5 410zm-187-186L18.7 109.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0L224 133.5l-22.6 22.6L86.6 41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L156.1 201.4 133.5 224zM461.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L373 94.4 449.6 171l54.8-54.8c9.4-9.4 9.4-24.6 0-33.9L461.8 39.6zM115.1 352.4c-7.6 7.6-13.1 16.9-16.1 27.2L71.6 472.4l92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L427 193.6 350.4 117 115.1 352.4zM405.2 17c21.9-21.9 57.3-21.9 79.2 0L527 59.6c21.9 21.9 21.9 57.3 0 79.2L214.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7 .1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L405.2 17z"]
};
var faPencilPaintbrush = faPenPaintbrush;
var faFishCooked = {
  prefix: 'fal',
  iconName: 'fish-cooked',
  icon: [576, 512, [], "f7fe", "M143.4 191.2c21.4-23.6 49.6-47.6 80.7-65.6C255.3 107.5 288.4 96 320 96c51.6 0 108.2 26.5 152.4 61.5c22 17.4 40.2 36.4 52.9 54.3c13 18.4 18.7 33.7 18.7 44.2s-5.7 25.8-18.7 44.2c-12.6 17.9-30.9 36.9-52.9 54.3C428.2 389.5 371.6 416 320 416c-31.6 0-64.7-11.5-95.9-29.6c-31.1-18-59.3-42-80.7-65.6c-5.4-5.9-14.3-7-20.9-2.4L37.6 376.8 62.1 266.4c1.5-6.9 1.5-14 0-20.8L37.6 135.2l84.9 58.4c6.6 4.5 15.5 3.5 20.9-2.4zM320 64c-39.1 0-77.8 14.1-111.9 33.9c-29.8 17.2-56.8 39.3-78.7 61.6L43.7 100.6c-4.4-3-9.6-4.6-14.9-4.6C12 96-.5 111.6 3.2 128L30.8 252.5c.5 2.3 .5 4.7 0 6.9L3.2 384c-3.6 16.4 8.8 32 25.6 32c5.3 0 10.5-1.6 14.9-4.6l-9.1-13.2 9.1 13.2 85.6-58.9c21.9 22.4 49 44.4 78.7 61.6C242.2 433.9 280.9 448 320 448c61.4 0 124.8-30.9 172.3-68.5c23.9-18.9 44.4-40.1 59.2-60.9C565.8 298.2 576 276.2 576 256s-10.2-42.2-24.5-62.6c-14.7-20.8-35.2-42-59.2-60.9C444.8 94.9 381.4 64 320 64zm-4.7 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm112 16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm16 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64z"]
};
var faChairOffice = {
  prefix: 'fal',
  iconName: 'chair-office',
  icon: [448, 512, [], "f6c1", "M288 32c17.7 0 32 14.3 32 32V224h32V64c0-35.3-28.7-64-64-64H160C124.7 0 96 28.7 96 64V224h32V64c0-17.7 14.3-32 32-32H288zM64 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm352 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM352 288l32 64-160 0H64l32-64H352zM240 384H384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-32-64C375.2 262.8 364.1 256 352 256H96c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-5 9.9-4.4 21.7 1.4 31.1S52.9 384 64 384H208v48H192c-35.3 0-64 28.7-64 64c0 8.8 7.2 16 16 16s16-7.2 16-16c0-17.7 14.3-32 32-32h16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464h16c17.7 0 32 14.3 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-28.7-64-64-64H240V384z"]
};
var faNestingDolls = {
  prefix: 'fal',
  iconName: 'nesting-dolls',
  icon: [640, 512, [], "e3ba", "M192 32c53 0 96 43 96 96v80 16h32V208 128C320 57.3 262.7 0 192 0S64 57.3 64 128v80 16H96V208 128c0-53 43-96 96-96zm64.6 448H74.5c-9.2 0-14-3.5-15.9-6.4C46.9 455.7 32 424.8 32 384c0-32.6 13.6-63.3 30-96H312.2c5.4-11.4 12.1-22.2 19.9-32H51.9c-5.9 0-11.3 3.3-14 8.6C20.2 299.6 0 339.6 0 384c0 48.8 17.9 85.7 31.8 107.1C41.1 505.3 57.5 512 74.5 512H261.4c-4.8-10.1-6.4-21.3-4.8-32zM148.2 131.8c17.1-5.3 32.2-15.2 43.8-28.3c11.5 13.1 26.6 23 43.8 28.3c-2.3 5.1-5.6 9.9-9.8 14.2c-18.7 18.7-49.1 18.7-67.9 0c-4.2-4.2-7.5-9-9.8-14.2zm65.1-52.7c-5.6-7.3-14.1-10.2-21.3-10.2s-15.7 2.9-21.3 10.2c-9.2 11.9-22.4 20.4-37.5 23.5c-10.8 2.3-22.6 13.4-18.8 28.7c3.4 13.6 10.4 26.5 21.1 37.2c31.2 31.2 81.9 31.2 113.1 0c10.6-10.6 17.7-23.5 21.1-37.2c3.8-15.4-8-26.5-18.8-28.7c-15.1-3.2-28.3-11.7-37.5-23.5zM464 343.5c11.5 13.1 26.6 23 43.8 28.3c-2.3 5.1-5.6 9.9-9.8 14.2c-18.7 18.7-49.1 18.7-67.9 0c-4.2-4.2-7.5-9-9.8-14.2c17.1-5.3 32.2-15.2 43.8-28.3zm0-34.6c-7.3 0-15.7 2.9-21.3 10.2c-9.2 11.9-22.4 20.4-37.5 23.5c-10.8 2.3-22.6 13.4-18.8 28.7c3.4 13.6 10.4 26.6 21.1 37.2c31.2 31.2 81.9 31.2 113.1 0c10.6-10.6 17.7-23.5 21.1-37.2c3.8-15.4-8-26.5-18.8-28.7c-15.1-3.2-28.3-11.7-37.5-23.5c-5.6-7.3-14.1-10.2-21.3-10.2zM588.7 455.3c3.7 8.1 7.8 16.4 12.7 24.7H326.6c4.9-8.3 9-16.6 12.7-24.7C353.1 425 360 393.3 360 360c0-57.4 46.6-104 104-104s104 46.6 104 104c0 33.3 6.9 65 20.7 95.3zm46.8 18.7c-7-10-12.6-20.9-17.7-32C605.9 415.9 600 388.7 600 360c0-75.1-60.9-136-136-136s-136 60.9-136 136c0 28.7-5.9 55.9-17.8 82.1c-5 11.1-10.7 22-17.7 32l0 0c-5.2 7.3-5.9 16.9-1.8 24.9c4.1 8 12.3 13 21.3 13H616c9 0 17.2-5 21.3-13s3.4-17.6-1.8-24.9z"]
};
var faClockRotateLeft = {
  prefix: 'fal',
  iconName: 'clock-rotate-left',
  icon: [512, 512, ["history"], "f1da", "M32 132V48c0-8.8-7.2-16-16-16S0 39.2 0 48V176c0 8.8 7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H53.6C89.5 84.3 166.7 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-73.3 0-138.3-35.2-179.2-89.6c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C97.9 471.8 172.2 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C159.6 0 75.7 53.3 32 132zm224-4c-8.8 0-16 7.2-16 16V256c0 4.2 1.7 8.3 4.7 11.3l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L272 249.4V144c0-8.8-7.2-16-16-16z"]
};
var faHistory = faClockRotateLeft;
var faTrumpet = {
  prefix: 'fal',
  iconName: 'trumpet',
  icon: [640, 512, [127930], "f8e3", "M608 96.8V383.2c-10-14.3-33.6-45.3-67.1-73.1C507 282.1 461.3 256 408 256H368h-5.3H288 208 160 32V224H208h80 80 40c53.3 0 99-26.1 132.9-54.1C574.4 142.1 598 111 608 96.8zM352 288V416H304V288h48zm32 128V288h24c42.8 0 81.4 21 112.5 46.8c30.9 25.6 52.8 54.6 61.7 67.4c5.9 8.5 15.6 13.9 26.4 13.9c17.4 0 31.4-14.1 31.4-31.4V95.4C640 78.1 625.9 64 608.6 64c-10.8 0-20.5 5.4-26.4 13.9c-8.9 12.8-30.8 41.8-61.7 67.4C489.4 171 450.8 192 408 192H384V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H304V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H224V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H32c0-8.8-7.2-16-16-16s-16 7.2-16 16v16 64 16c0 8.8 7.2 16 16 16s16-7.2 16-16H88.4C73.2 305 64 327.4 64 352c0 53 43 96 96 96h48 80 80 48c47.4 0 86.7-34.3 94.6-79.4c-3.4-3.1-6.9-6.2-10.5-9.2c-6.7-5.5-13.5-10.6-20.5-15.2c.3 2.6 .5 5.2 .5 7.8c0 35.3-28.7 64-64 64H384zm-112 0H224V288h48V416zm-80 0H160c-35.3 0-64-28.7-64-64s28.7-64 64-64h32V416z"]
};
var faFaceGrinBeamSweat = {
  prefix: 'fal',
  iconName: 'face-grin-beam-sweat',
  icon: [512, 512, [128517, "grin-beam-sweat"], "f583", "M432.2 68.6c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.6c0 .2 0 .2 0 .1c0 12.2 11.7 26.7 32 26.7s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.2-.7-.8-3.7-3.4-9.5c-3-6.7-7.4-14.6-12.8-23.1c-5-7.9-10.5-15.8-15.8-23c-5.3 7.2-10.8 15.1-15.8 23zm7.3-64.5c4.3-5.5 12.8-5.5 17.1 0C473.9 25.8 512 76.3 512 101.3c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 37.9-75.5 55.5-97.2zM256 32C132.3 32 32 132.3 32 256s100.3 224 224 224s224-100.3 224-224c0-20.7-2.8-40.7-8.1-59.7c-2.4-8.5 2.6-17.3 11.2-19.7s17.3 2.6 19.7 11.2c6 21.7 9.2 44.6 9.2 68.3c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c43.1 0 83.8 10.7 119.5 29.5c7.8 4.1 10.8 13.8 6.7 21.6S368.3 62 360.5 57.8C329.3 41.3 293.8 32 256 32zm90 313.8c-28.5 5.4-58.7 8.3-89.9 8.3s-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3zm33.8-41.1c12.3-3.7 24.2 7 19.1 18.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4zM143.5 219.9c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 161.9 157.2 152 176 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4zm172.9-25.4c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 161.9 317.2 152 336 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5z"]
};
var faGrinBeamSweat = faFaceGrinBeamSweat;
var faFireSmoke = {
  prefix: 'fal',
  iconName: 'fire-smoke',
  icon: [640, 512, [], "f74b", "M349.4 93.5c9.6-.1 18.7-4.5 24.7-12.1c3.9-4.9 7.8-9.6 11.6-14c16.4 17.8 30.9 39.4 41.8 60.5C441 154 448 179.4 448 192.2c0 25.3-7.4 48.9-20.1 68.8c7.4 5.8 14.3 12.1 20.7 18.9c2.7-1.8 5.5-3.5 8.4-5.2c14.6-24.1 23-52.4 23-82.5c0-20.2-9.6-50.9-24.2-79C441.1 84.7 420.2 54.7 395.5 32c-5.6-5.1-14.4-5.2-20 0c-1.8 1.6-3.5 3.3-5.2 5c-7.7 7.7-14.8 16.4-21.2 24.5c-7-8.4-14.1-16.5-21.5-24.4c-10.9-11.6-22.2-22.8-34-33.4c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6c0 30 8.2 58.3 22.7 82.4c3 1.7 5.9 3.5 8.7 5.3c6.3-6.8 13.2-13.1 20.6-18.8c-12.7-19.9-20-43.6-20-68.9c0-17.9 9.4-46.2 27.6-75.8c15.9-25.8 37.9-53.1 64-78.1C298 51.9 311.6 66.5 324.4 82c6.2 7.4 15.3 11.6 25 11.5zM224 194c0 19.2 4.8 36.3 13.5 50.5c9.5-5.1 19.6-9.3 30.1-12.6c-7.1-9.6-11.5-22.2-11.5-38c0-8.3 2.5-16.8 9.1-28.1c4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.5 1.8 2.4 .5 .6 .1 .2 0 0 0 0 0 0L347 191l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1c6.9 19 3.9 39.8-7 54.8c10.5 3.3 20.5 7.5 30 12.6c16.2-27 17-62.2 1.3-91.1l0-.1 0 0 0 0 0 0c-1.9-3.9-4.5-9-8.3-14.1c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5c-3-3.8-7.6-6-12.4-6s-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C229 164.3 224 178.3 224 194zM213.9 364c15-44.2 56.9-76 106.1-76s91.1 31.8 106.1 76c2.1 6.2 7.7 10.5 14.2 10.8s12.6-3.2 15.4-9.1C468.6 338.7 496.1 320 528 320c44.2 0 80 35.8 80 80s-35.8 80-80 80H404.7 235.3 112c-44.2 0-80-35.8-80-80s35.8-80 80-80c31.9 0 59.4 18.7 72.3 45.7c2.8 5.9 8.9 9.5 15.4 9.1s12.1-4.7 14.2-10.8zM320 256c-52.6 0-98.6 28.2-123.7 70.3C175.8 302.8 145.6 288 112 288C50.1 288 0 338.1 0 400s50.1 112 112 112H235.3 404.7 528c61.9 0 112-50.1 112-112s-50.1-112-112-112c-33.6 0-63.8 14.8-84.3 38.3C418.6 284.2 372.6 256 320 256z"]
};
var faPhoneMissed = {
  prefix: 'fal',
  iconName: 'phone-missed',
  icon: [640, 512, [], "e226", "M112 0c-8.8 0-16 7.2-16 16V144c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l98.7 98.7C251.5 178.1 285 192 320 192s68.5-13.9 93.3-38.6L523.3 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L390.6 130.7C371.9 149.5 346.5 160 320 160s-51.9-10.5-70.6-29.3L150.6 32H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM39.1 366.5C86.8 320.1 186.2 255.1 320 255.1s233.2 65 280.9 111.3c7.6 7.4 9.5 19.8 3.7 31.3l-37.4 73.5c-3.3 6.5-10.6 10-17.7 8.4l-88.7-19.8c-7.3-1.6-12.5-8.1-12.5-15.6V362.2c0-7.2-4.8-13.5-11.8-15.4l-36.1-9.9c-52.6-14.4-108.1-14.4-160.7 0l-36.1 9.9c-7 1.9-11.8 8.2-11.8 15.4v82.1c0 7.5-5.2 14-12.5 15.6L90.6 479.7c-7.1 1.6-14.4-1.9-17.7-8.4L35.5 397.8c-5.8-11.5-3.9-23.9 3.7-31.3zM320 223.1C175.8 223.1 68.8 293 16.8 343.5c-19.3 18.7-21 46.8-9.9 68.7l37.4 73.5c9.9 19.5 31.8 29.9 53.2 25.1l88.7-19.8c21.9-4.9 37.5-24.4 37.5-46.9V374.4l24.4-6.7c47.1-12.9 96.7-12.9 143.8 0l24.4 6.7v69.8c0 22.5 15.6 42 37.5 46.9l88.7 19.8c21.4 4.8 43.3-5.6 53.2-25.1l37.4-73.5c11.1-21.9 9.4-50-9.9-68.7c-52-50.5-159-120.4-303.2-120.4z"]
};
var faFileExport = {
  prefix: 'fal',
  iconName: 'file-export',
  icon: [576, 512, ["arrow-right-from-file"], "f56e", "M352 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352v64h32V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V368H352v80zm-.5-288H240c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zm123.8 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L521.4 304H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H521.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"]
};
var faArrowRightFromFile = faFileExport;
var faShield = {
  prefix: 'fal',
  iconName: 'shield',
  icon: [512, 512, [128737, "shield-blank"], "f132", "M268.5 37.3c-8-3.4-17-3.4-25 0l-176.7 75C55.5 117 47.9 127.7 48 139.8c.5 94 39.3 259.8 195.4 334.5c7.9 3.8 17.2 3.8 25.1 0c156.1-74.7 195-240.4 195.5-334.5c.1-12.1-7.5-22.8-18.8-27.6l-176.7-75zM231 7.8c16-6.8 34-6.8 50 0l176.7 75c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L231 7.8z"]
};
var faShieldBlank = faShield;
var faArrowUpShortWide = {
  prefix: 'fal',
  iconName: 'arrow-up-short-wide',
  icon: [576, 512, ["sort-amount-up-alt"], "f885", "M139.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM304 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"]
};
var faSortAmountUpAlt = faArrowUpShortWide;
var faArrowsRepeat1 = {
  prefix: 'fal',
  iconName: 'arrows-repeat-1',
  icon: [512, 512, ["repeat-1-alt"], "f366", "M0 255.2C-.4 264 6.4 271.5 15.2 272s16.3-6.4 16.8-15.2l.4-8C36.2 172.2 99.5 112 176.2 112H390.6l-57.4 52.2c-6.5 5.9-7 16.1-1.1 22.6s16.1 7 22.6 1.1l88-80c3.3-3 5.2-7.3 5.2-11.8s-1.9-8.8-5.2-11.8l-88-80c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6L390.6 80H176.2C82.4 80 5.1 153.5 .4 247.2l-.4 8zm512 1.6c.4-8.8-6.4-16.3-15.2-16.8s-16.3 6.4-16.8 15.2l-.4 8C475.8 339.8 412.5 400 335.8 400H121.4l57.4-52.2c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80c-3.3 3-5.2 7.3-5.2 11.8s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L121.4 432H335.8c93.8 0 171.1-73.5 175.8-167.2l.4-8zM288 208c0-6.1-3.4-11.6-8.8-14.3s-11.9-2.1-16.8 1.5l-32 24c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2L256 240v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"]
};
var faRepeat1Alt = faArrowsRepeat1;
var faGunSlash = {
  prefix: 'fal',
  iconName: 'gun-slash',
  icon: [640, 512, [], "e19c", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM473.4 240c8.5 0 16.6-3.4 22.6-9.4L518.6 208H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H544V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H180.1l40.5 32H528h48v80H518.6c-8.5 0-16.6 3.4-22.6 9.4L473.4 208H362.5L403 240h70.4zM249.5 281.9L208 448 96 448l40.1-160.5c4.3-17 1.3-33.8-6.7-47.5h67l-40.5-32H89.2 74 64l0-72.6L32 110.2V208c0 17.7 14.3 32 32 32H74c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480H208c14.7 0 27.5-10 31-24.2l38-152.1-27.5-21.7z"]
};
var faAvocado = {
  prefix: 'fal',
  iconName: 'avocado',
  icon: [512, 512, [], "e0aa", "M480 144c0 34.8-15.9 66-40.9 86.6c-22.3 18.4-42.7 44.7-49.1 77.6c-9.4 47.7-31 93.8-57.5 120.3c-68.7 68.7-180.2 68.7-248.9 0s-68.7-180.2 0-248.9c26.5-26.5 72.5-48.1 120.3-57.5c32.9-6.4 59.3-26.8 77.6-49.1C302 47.9 333.2 32 368 32c61.9 0 112 50.1 112 112zM421.3 314.3c4.6-23.5 19.6-43.9 38.1-59.1C491.5 228.9 512 188.8 512 144C512 64.5 447.5 0 368 0c-44.8 0-84.9 20.5-111.3 52.6c-15.2 18.5-35.6 33.5-59.1 38.1c-51.9 10.2-104.5 34-136.7 66.3c-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c32.3-32.3 56.1-84.9 66.3-136.7zM176.1 240.1c38.2-38.2 88.1-40.4 112.1-16.4s21.8 73.9-16.4 112.1s-88.1 40.4-112.1 16.4s-21.8-73.9 16.4-112.1zm134.8-39c-41.4-41.4-112.1-28.8-157.4 16.4s-57.8 116-16.4 157.4s112.1 28.8 157.4-16.4s57.8-116 16.4-157.4z"]
};
var faBinary = {
  prefix: 'fal',
  iconName: 'binary',
  icon: [384, 512, [], "e33b", "M320 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V16zM96 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V304zM0 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80C35.8 0 0 35.8 0 80zM80 32h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zM272 288c-44.2 0-80 35.8-80 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V368c0-44.2-35.8-80-80-80H272zm-48 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V368z"]
};
var faGlassesRound = {
  prefix: 'fal',
  iconName: 'glasses-round',
  icon: [576, 512, [128083, "glasses-alt"], "f5f5", "M116.8 64c-14.4 0-26.9 9.7-30.5 23.6L46.6 241.5C70.5 220.6 101.8 208 136 208c55.1 0 102.6 32.8 124 80H316c21.3-47.2 68.8-80 124-80c34.2 0 65.5 12.6 89.4 33.5L489.7 87.6C486.1 73.7 473.6 64 459.2 64c-4.9 0-9.7 1.1-14.1 3.3l-22 11c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l22-11c8.8-4.4 18.5-6.7 28.4-6.7c29 0 54.2 19.6 61.5 47.6l48.7 188.8c4.4 17 6.6 34.4 6.6 52V344c0 75.1-60.9 136-136 136s-136-60.9-136-136c0-8.2 .7-16.2 2.1-24H269.9c1.4 7.8 2.1 15.8 2.1 24c0 75.1-60.9 136-136 136S0 419.1 0 344V320.4c0-17.5 2.2-35 6.6-52L55.3 79.6C62.5 51.6 87.8 32 116.8 32c9.9 0 19.6 2.3 28.4 6.7l22 11c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-22-11c-4.4-2.2-9.2-3.3-14.1-3.3zM544 344a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM136 448a104 104 0 1 0 0-208 104 104 0 1 0 0 208z"]
};
var faGlassesAlt = faGlassesRound;
var faPhonePlus = {
  prefix: 'fal',
  iconName: 'phone-plus',
  icon: [640, 512, [], "f4d2", "M448 208V128H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V16c0-8.8 7.2-16 16-16s16 7.2 16 16V96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm-55 78.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C247.5 494.5 64 300.7 64 64v0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L393 286.7zM512 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C98.6 57 96 60.2 96 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faDitto = {
  prefix: 'fal',
  iconName: 'ditto',
  icon: [320, 512, [], "22", "M96 98.3V96c0-17.7-14.3-32-32-32S32 78.3 32 96v2.3c0 2 .2 3.9 .5 5.9L58 251c.5 2.9 3 5 6 5s5.5-2.1 6-5L95.5 104.2l30.9 5.4-30.9-5.4c.3-1.9 .5-3.9 .5-5.9zm-96 0V96C0 60.7 28.7 32 64 32s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L101.5 256.5C98.3 274.7 82.5 288 64 288s-34.3-13.3-37.5-31.5L1 109.6c-.7-3.8-1-7.5-1-11.4zm288 0V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v2.3c0 2 .2 3.9 .5 5.9L250 251c.5 2.9 3 5 6 5s5.5-2.1 6-5l25.5-146.8 30.9 5.4-30.9-5.4c.3-1.9 .5-3.9 .5-5.9zm-96 0V96c0-35.3 28.7-64 64-64s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L293.5 256.5c-3.2 18.2-19 31.5-37.5 31.5s-34.3-13.3-37.5-31.5L193 109.6c-.7-3.8-1-7.5-1-11.4z"]
};
var faPersonSeat = {
  prefix: 'fal',
  iconName: 'person-seat',
  icon: [384, 512, [], "e21e", "M176 88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM152 32a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM32 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 61.9 50.1 112 112 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-44.2 0-80-35.8-80-80V144zm116 64c15.5 0 28 12.5 28 28v4 88H136c-8.8 0-16-7.2-16-16V236c0-15.5 12.5-28 28-28zm58.8 16c-5.6-27.4-29.8-48-58.8-48c-33.1 0-60 26.9-60 60v76c0 26.5 21.5 48 48 48h56 40.6c15.3 0 28.4 10.8 31.4 25.7l16.3 81.4c1.5 7.5 8.1 12.9 15.7 12.9h72c8.8 0 16-7.2 16-16s-7.2-16-16-16H309.1l-13.7-68.6c-6-29.9-32.2-51.4-62.8-51.4H208V256h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H206.8z"]
};
var faHouseMedical = {
  prefix: 'fal',
  iconName: 'house-medical',
  icon: [576, 512, [], "e3b2", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zM272 176c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V336h32c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H336V208c0-17.7-14.3-32-32-32H272zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H320c-8.8 0-16 7.2-16 16v48H272V320c0-8.8-7.2-16-16-16H208V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208z"]
};
var faGolfBallTee = {
  prefix: 'fal',
  iconName: 'golf-ball-tee',
  icon: [384, 512, ["golf-ball"], "f450", "M288 320c38.9-29.2 64-75.7 64-128c0-88.4-71.6-160-160-160S32 103.6 32 192c0 52.3 25.1 98.8 64 128H48.9C18.5 286 0 241.2 0 192C0 86 86 0 192 0S384 86 384 192c0 49.2-18.5 94-48.9 128H288zM80 352H192 304c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM226.1 248.6c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4c18.5 0 33.5-15 33.5-33.5zm-52.3-49.3c18.5 0 33.5-15 33.5-33.5c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4zm113.5-17.5c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4c18.5 0 33.5-15 33.5-33.5z"]
};
var faGolfBall = faGolfBallTee;
var faCircleChevronLeft = {
  prefix: 'fal',
  iconName: 'circle-chevron-left',
  icon: [512, 512, ["chevron-circle-left"], "f137", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM276.7 132.7l-112 112c-6.2 6.2-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L198.6 256 299.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faChevronCircleLeft = faCircleChevronLeft;
var faHouseChimneyWindow = {
  prefix: 'fal',
  iconName: 'house-chimney-window',
  icon: [576, 512, [], "e00d", "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V192.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1V64H416v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM240 192h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32zm0 32v96h96V224H240z"]
};
var faScythe = {
  prefix: 'fal',
  iconName: 'scythe',
  icon: [640, 512, [], "f710", "M639.7 19.1c1.7-8.7-3.9-17.1-12.6-18.8s-17.1 3.9-18.8 12.6L550.1 304H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H543.7L512.3 492.9c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6l96-480zM352 0C121.4 0 20.6 155.8 2.9 186.7c-2 3.5-2.9 7.4-2.9 11.4C0 212.4 11.6 224 25.9 224H533.4l6.4-32H37.2C64.7 149.7 158.7 32 352 32H571.8l5.1-25.4c.5-2.3 1.1-4.5 1.8-6.6H352z"]
};
var faPenNib = {
  prefix: 'fal',
  iconName: 'pen-nib',
  icon: [512, 512, [10001], "f5ad", "M377.4 45.3L310.6 112 400 201.4l66.7-66.7c12.5-12.5 12.5-32.8 0-45.3L422.6 45.3c-12.5-12.5-32.8-12.5-45.3 0zM279.7 97.7l75.1-75.1c25-25 65.5-25 90.5 0l44.1 44.1c25 25 25 65.5 0 90.5l-75.1 75.1L376.8 370c-7.3 26.6-27.7 47.6-54.2 55.6L47.4 508.1c-12.3 3.7-25.7 .3-34.7-8.8s-12.5-22.4-8.8-34.7L86.5 189.4c7.9-26.4 28.9-46.9 55.6-54.2L279.7 97.7zm3.6 32.2L150.5 166.1c-16 4.4-28.6 16.6-33.3 32.5L42.7 446.7 152.9 336.5c-5.6-9.5-8.9-20.6-8.9-32.5c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-11.9 0-23-3.2-32.5-8.9L65.3 469.3l248.1-74.4c15.9-4.8 28.2-17.4 32.5-33.3l36.2-132.8-98.9-98.9zM208 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faBanParking = {
  prefix: 'fal',
  iconName: 'ban-parking',
  icon: [512, 512, ["parking-circle-slash"], "f616", "M256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7l316 316C363.4 459.4 312.1 480 256 480zm76-170.6c30.9-16 52-48.2 52-85.4c0-53-43-96-96-96H200c-13.3 0-24 10.7-24 24v1.4L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7L332 309.4zM307.6 285L208 185.4V160h80c35.3 0 64 28.7 64 64c0 28.5-18.7 52.7-44.4 61zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 257.9V304v64c0 8.8 7.2 16 16 16s16-7.2 16-16V320h30.1L176 257.9z"]
};
var faParkingCircleSlash = faBanParking;
var faTentArrowTurnLeft = {
  prefix: 'fal',
  iconName: 'tent-arrow-turn-left',
  icon: [576, 512, [], "e580", "M114.8 27.8c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80C1.9 87.2 0 91.5 0 96s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L57.4 112 464 112c44.2 0 80 35.8 80 80v48c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-61.9-50.1-112-112-112L57.4 80l57.4-52.2zM297.5 163.1c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8C65.1 486.5 87.5 512 116.4 512H459.6c29 0 51.3-25.5 47.6-54.2L489.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM272 207.7v112c0 .2 0 .4 0 .5V480H116.4c-9.7 0-17.1-8.5-15.9-18.1l17.5-134.4c.6-4.3 2.9-8.2 6.4-10.8L272 207.7zm32 168.5L368.2 480H304V376.2zm0-60.8V207.7L451.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1H405.9l-.3-.4L304 315.4z"]
};
var faFaceDiagonalMouth = {
  prefix: 'fal',
  iconName: 'face-diagonal-mouth',
  icon: [512, 512, [129764], "e47e", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm372.4 63.4l-224 64c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8l224-64c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faDiagramCells = {
  prefix: 'fal',
  iconName: 'diagram-cells',
  icon: [512, 512, [], "e475", "M480 160c0 17.7-14.3 32-32 32L64 192c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32v64zm-32 64c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64l384 0zm64 192V352c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zm-64 32L64 448c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32z"]
};
var faCricketBatBall = {
  prefix: 'fal',
  iconName: 'cricket-bat-ball',
  icon: [512, 512, [127951, "cricket"], "f449", "M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-151 151 30.1 30.1c21.9 21.9 21.9 57.3 0 79.2L178 495.9c-10 10-24.4 16.7-40.4 15.6c-11.3-.8-28.6-2.8-46.4-8.2C73.9 498.2 54.1 489.1 39 473c-16.2-15-25.2-34.9-30.4-52.2l30.6-9.3c4.4 14.5 11.2 28.4 21.6 38c.6 .5 1.1 1.1 1.6 1.6c9.6 10.4 23.5 17.2 38 21.6c14.7 4.4 29.3 6.2 39.3 6.9c5.6 .4 11.2-1.9 15.6-6.3L308.7 320H240c-26.5 0-48-21.5-48-48V203.3L38.7 356.6c-4.4 4.4-6.7 10.1-6.3 15.6c.7 10 2.4 24.6 6.9 39.3L8.6 420.8C3.2 403 1.2 385.7 .5 374.4C-.6 358.4 6.1 344 16.1 334L224.4 125.7c21.9-21.9 57.3-21.9 79.2 0l30.1 30.1 151-151c6.2-6.2 16.4-6.2 22.6 0zM224 171.3V272c0 8.8 7.2 16 16 16H340.7l23-23c9.4-9.4 9.4-24.6 0-33.9L281 148.3c-9.4-9.4-24.6-9.4-33.9 0l-23 23zM480 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faCricket = faCricketBatBall;
var faTents = {
  prefix: 'fal',
  iconName: 'tents',
  icon: [640, 512, [], "e582", "M425.5 3.1c-5.7-4.2-13.4-4.2-19 0L236 129.1c9.5 1.8 18.7 5.8 26.8 12l5.4 4.1L416 35.9 579.5 156.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1H456.7l4.8 32h126c29 0 51.3-25.5 47.6-54.2L617.6 163.4c-1.7-12.9-8.6-24.6-19.1-32.4L425.5 3.1zm-192 160c-5.7-4.2-13.4-4.2-19 0L41.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L4.8 457.8C1.1 486.5 23.5 512 52.4 512H395.6c29 0 51.3-25.5 47.6-54.2L425.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM60.5 316.8L208 207.7V480H52.4c-9.7 0-17.1-8.5-15.9-18.1L54.1 327.6c.6-4.3 2.9-8.2 6.4-10.8zM240 309.9V207.7L387.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1H345.4l-.2-.4-104-168c-.4-.6-.7-1.1-1.2-1.6zM240 480V370.5L307.8 480H240z"]
};
var faWandMagic = {
  prefix: 'fal',
  iconName: 'wand-magic',
  icon: [512, 512, ["magic"], "f0d0", "M305.9 155.3l50.7 50.7L477.1 85.7c3.1-3.1 3.1-8.2 0-11.3L437.7 34.9c-3.1-3.1-8.2-3.1-11.3 0L305.9 155.3zm-22.6 22.6L34.9 426.3c-3.1 3.1-3.1 8.2 0 11.3l39.4 39.4c3.1 3.1 8.2 3.1 11.3 0L334.1 228.7l-50.7-50.7zM12.3 403.7L403.7 12.3c15.6-15.6 40.9-15.6 56.6 0l39.4 39.4c15.6 15.6 15.6 40.9 0 56.6L108.3 499.7c-15.6 15.6-40.9 15.6-56.6 0L12.3 460.3c-15.6-15.6-15.6-40.9 0-56.6z"]
};
var faMagic = faWandMagic;
var faDog = {
  prefix: 'fal',
  iconName: 'dog',
  icon: [576, 512, [128021], "f6d3", "M322.9 349.5c8.2 6 13.1 15.6 13.1 25.8V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V261.9l-.1 0L307.6 208c-.3 0-.7 0-1 0H160 136 96V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V375.3c0-10.2 4.9-19.8 13.1-25.8s18.9-7.8 28.6-4.6c14.5 4.6 30.1 7.2 46.3 7.2s31.7-2.5 46.3-7.2c9.7-3.1 20.4-1.4 28.6 4.6zm82.9-130.7c2.6-15.4 15.9-26.7 31.6-26.7H480c35.3 0 64-28.7 64-64V112c0-8.8-7.2-16-16-16H496c-8.5 0-16.6-3.4-22.6-9.4L455.4 68.7c-3-3-7.1-4.7-11.3-4.7H400c-10.1 0-19.6-4.7-25.6-12.8L362.5 35.4 338.2 181.3c-.4 2.3-1 4.4-1.8 6.5l67.9 39.6 1.4-8.6zM45.6 159.3C54.5 169.7 67.6 176 82 176H96h40 24H306.7L331.9 24.8C334.2 10.5 346.6 0 361.2 0c9.3 0 18.1 4.4 23.8 11.9L400 32h44.1c12.7 0 24.9 5.1 33.9 14.1L496 64h32c26.5 0 48 21.5 48 48v16c0 53-43 96-96 96H437.3L432 256V456c0 30.9-25.1 56-56 56H360c-30.9 0-56-25.1-56-56V408.7 375.3c-10.3 3.3-21 5.7-32 7.1c-7.9 1-15.9 1.6-24 1.6s-16.1-.5-24-1.6c-11-1.4-21.7-3.8-32-7.1v33.3V456c0 30.9-25.1 56-56 56H120c-30.9 0-56-25.1-56-56V208c0-.7 0-1.4 .1-2c-.7-.2-1.4-.3-2.1-.5c-27.9-7.2-50.3-29.1-57.6-58.1L.5 131.9c-2.1-8.6 3.1-17.3 11.6-19.4s17.3 3.1 19.4 11.6l3.9 15.5c.3 1.4 .8 2.7 1.2 4.1c2 5.8 5.1 11.1 9 15.6zM432 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPenLine = {
  prefix: 'fal',
  iconName: 'pen-line',
  icon: [576, 512, [], "e212", "M429.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L341 94.4 417.6 171l54.8-54.8c9.4-9.4 9.4-24.6 0-33.9L429.8 39.6zM83.1 352.4c-7.6 7.6-13.1 16.9-16.1 27.2L39.6 472.4l92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L395 193.6 318.4 117 83.1 352.4zM373.2 17c21.9-21.9 57.3-21.9 79.2 0L495 59.6c21.9 21.9 21.9 57.3 0 79.2L182.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7 .1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L373.2 17zM240 480H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faAtomSimple = {
  prefix: 'fal',
  iconName: 'atom-simple',
  icon: [512, 512, ["atom-alt"], "f5d3", "M175.1 438.1c-50.8 16.9-82.3 10.1-96.7-4.4s-21.3-46-4.4-96.7c5.4-16.2 12.9-33.3 22.5-50.9c16.8 23.8 36.7 47.4 59.4 70.1s46.3 42.6 70.1 59.4c-17.6 9.6-34.7 17.2-50.9 22.5zM55.7 55.7C16.5 94.9 27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8C173.9 27.6 94.9 16.5 55.7 55.7zM178.5 333.5c-25.3-25.3-46.6-51.6-63.8-77.5c17.2-25.9 38.6-52.3 63.8-77.5s51.6-46.6 77.5-63.8c25.9 17.2 52.3 38.6 77.5 63.8s46.6 51.6 63.8 77.5c-17.2 25.9-38.6 52.3-63.8 77.5s-51.6 46.6-77.5 63.8c-25.9-17.2-52.3-38.6-77.5-63.8zM155.8 155.8c-22.7 22.7-42.6 46.3-59.4 70.1c-9.6-17.6-17.2-34.7-22.5-50.9c-16.9-50.8-10-82.3 4.4-96.7s46-21.3 96.7-4.4c16.2 5.4 33.3 12.9 50.9 22.5c-23.8 16.8-47.4 36.7-70.1 59.4zm200.3 0c-22.7-22.7-46.3-42.6-70.1-59.4c17.6-9.6 34.7-17.2 50.9-22.5c50.8-16.9 82.3-10 96.7 4.4s21.3 46 4.4 96.7c-5.4 16.2-12.9 33.3-22.5 50.9c-16.8-23.8-36.7-47.4-59.4-70.1zm0 200.3c22.7-22.7 42.6-46.3 59.4-70.1c9.6 17.6 17.2 34.7 22.5 50.9c16.9 50.8 10.1 82.3-4.4 96.7s-46 21.3-96.7 4.4c-16.2-5.4-33.3-12.9-50.9-22.5c23.8-16.8 47.4-36.7 70.1-59.4zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faAtomAlt = faAtomSimple;
var faAmpersand = {
  prefix: 'fal',
  iconName: 'ampersand',
  icon: [448, 512, [], "26", "M175.2 64h33.9c34.7 0 62.9 28.2 62.9 62.9c0 20.5-10 39.8-26.8 51.5L181.6 223l-51.1-51.1C118.7 160 112 144 112 127.2C112 92.3 140.3 64 175.2 64zm29.4 181.9l59-41.3c25.4-17.8 40.5-46.8 40.5-77.8C304 74.5 261.5 32 209.1 32H175.2C122.6 32 80 74.6 80 127.2c0 25.2 10 49.5 27.9 67.3L155 241.6 72.9 299C47.3 317 32 346.3 32 377.7V384c0 53 43 96 96 96h80c35.3 0 68.4-16.6 89.6-44.8l21.8-29.1 69.2 69.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-72.5-72.5 74-98.6c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2l-71.2 95L204.6 245.9zm-26.6 18.6L296.6 383.2 272 416c-15.1 20.1-38.8 32-64 32H128c-35.3 0-64-28.7-64-64v-6.3c0-20.9 10.2-40.5 27.3-52.4l86.6-60.7z"]
};
var faCarrot = {
  prefix: 'fal',
  iconName: 'carrot',
  icon: [512, 512, [129365], "f787", "M320 88c0-23.9 14.5-45.4 23-55.8l.1 0c.1-.1 .4-.2 .9-.2c.4 0 .7 .1 .8 .1C352.9 42.3 368 65.6 368 96c0 14.7-1.8 22.9-3.2 26.9c-.6 1.6-1 2.6-1.2 2.9c-5.2 6.3-4.8 15.6 1.1 21.4s15.2 6.2 21.4 1.1c.4-.2 1.3-.7 2.9-1.2c4-1.3 12.2-3.2 26.9-3.2c30.4 0 53.7 15.1 63.9 23.2c0 .1 .1 .4 .1 .8c0 .5-.1 .8-.2 .9l0 .1c-10.4 8.5-32 23-55.8 23c-17.7 0-28.7-3.3-37.7-8.6c-9.8-5.7-18.3-14-31-26.7s-21.1-21.2-26.7-31c-5.3-9.1-8.6-20-8.6-37.7zm96 24c-6.3 0-11.9 .3-16.8 .8c.5-4.9 .8-10.5 .8-16.8c0-40.9-20.2-71.2-30.2-83.9C363.1 3.7 353.2 0 344 0s-19 3.7-25.7 11.8C308.7 23.6 288 52.5 288 88c0 19.5 3.3 34.8 9.9 48.2c-14.3-5.3-29.7-8.2-45.8-8.2c-50.9 0-97.2 29.3-119.1 75.2L2.3 477.7C-2 486.9-.2 497.8 7 505s18.1 9.1 27.3 4.7L308.8 379c45.9-21.9 75.2-68.2 75.2-119.1c0-16.1-2.9-31.5-8.2-45.8c13.4 6.6 28.6 9.9 48.2 9.9c35.5 0 64.4-20.7 76.2-30.3C508.3 187 512 177.2 512 168c0-9.2-3.7-19.1-12.1-25.8c-12.7-10.1-43-30.2-83.9-30.2zM252.1 160c55.2 0 99.9 44.7 99.9 99.9c0 38.5-22.2 73.6-56.9 90.2L174.2 407.6l-34.9-34.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l26.9 26.9L40.9 471.1 151.7 238.4l29 29c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-36.6-36.6c18-29.6 50.3-48.1 85.4-48.1z"]
};
var faArrowUpFromLine = {
  prefix: 'fal',
  iconName: 'arrow-up-from-line',
  icon: [384, 512, [8613, "arrow-from-bottom"], "f342", "M203.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 86.6V192 368c0 8.8 7.2 16 16 16s16-7.2 16-16V192 86.6L308.7 187.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faArrowFromBottom = faArrowUpFromLine;
var faMoon = {
  prefix: 'fal',
  iconName: 'moon',
  icon: [384, 512, [127769, 9214], "f186", "M190.6 66.8c-38.8 37.8-62.9 90.7-62.9 149.2c0 108.9 83.5 198.3 189.9 207.3C289.8 439 257.7 448 223.5 448C117.7 448 32 362.1 32 256c0-94.8 68.5-173.5 158.6-189.2zm66.1-21.5c-1.5-6.9-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3z"]
};
var faPenSlash = {
  prefix: 'fal',
  iconName: 'pen-slash',
  icon: [640, 512, [], "e213", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM559 138.8c21.9-21.9 21.9-57.3 0-79.2L516.4 17c-21.9-21.9-57.3-21.9-79.2 0L297.5 156.7l25.3 20L382.4 117 459 193.6l-50.6 50.6 25.3 20L559 138.8zM317.2 335.4l-93.6 93.6c-7.6 7.6-16.9 13.1-27.2 16.1l-92.8 27.3 27.3-92.8c3-10.3 8.6-19.6 16.1-27.2l84.6-84.6-25.3-20-81.9 81.9c-11.4 11.4-19.7 25.4-24.2 40.8l-35.6 121c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2l96.2-96.2-25.3-20zM459.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L481.6 171 405 94.4l54.8-54.8z"]
};
var faWineGlassEmpty = {
  prefix: 'fal',
  iconName: 'wine-glass-empty',
  icon: [320, 512, ["wine-glass-alt"], "f5ce", "M46.4 195.6C40.3 262.4 92.9 320 160 320s119.7-57.6 113.6-124.4L258.8 32 61.2 32 46.4 195.6zm-31.9-2.9L29.4 29.1C30.9 12.6 44.7 0 61.2 0H258.8c16.6 0 30.4 12.6 31.9 29.1l14.9 163.6c7.3 80.2-51.4 150-129.5 158.5V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160 80c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.1C65.9 342.7 7.2 272.8 14.5 192.7z"]
};
var faWineGlassAlt = faWineGlassEmpty;
var faSquareStar = {
  prefix: 'fal',
  iconName: 'square-star',
  icon: [448, 512, [], "e27f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm238.3 16.9l36.2 73.4 81.1 11.8c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4l-58.6 57.2 13.8 80.7c1 6-1.4 12.1-6.4 15.6s-11.5 4.1-16.8 1.2L224 342.1l-72.5 38.1c-5.4 2.8-11.9 2.4-16.8-1.2s-7.4-9.6-6.4-15.6l13.8-80.7L83.5 225.4c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l81-11.8 36.2-73.4c2.7-5.5 8.3-8.9 14.3-8.9s11.7 3.5 14.3 8.9zm-40 95.1c-2.3 4.7-6.8 8-12 8.8L129 225.1l41.5 40.4c3.8 3.7 5.5 9 4.6 14.2l-9.8 57.1 51.2-26.9c4.7-2.5 10.2-2.5 14.9 0l51.2 26.9-9.8-57.1c-.9-5.2 .8-10.5 4.6-14.2L319 225.1l-57.3-8.3c-5.2-.8-9.7-4-12-8.8L224 156.2l-25.6 51.9z"]
};
var faCheese = {
  prefix: 'fal',
  iconName: 'cheese',
  icon: [512, 512, [], "f7ef", "M480 240.2V256H32c0-9.3 4.6-18 12.4-23.1L292.6 67.4 274.9 40.7l17.8 26.6c3.3-2.2 7.2-3.4 11.1-3.4C401.1 64 480 142.9 480 240.2zM32 288H480V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V288zM303.8 32c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V256 240.2C512 125.2 418.8 32 303.8 32z"]
};
var faSendBackward = {
  prefix: 'fal',
  iconName: 'send-backward',
  icon: [512, 512, [], "f87f", "M64 32H288c17.7 0 32 14.3 32 32v64h32V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h64V320H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM288 96c0-17.7-14.3-32-32-32H96C78.3 64 64 78.3 64 96V256c0 17.7 14.3 32 32 32h32V256H96V96H256v32h32V96zm-64 96H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32zm-64 32V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64z"]
};
var faYinYang = {
  prefix: 'fal',
  iconName: 'yin-yang',
  icon: [512, 512, [9775], "f6ad", "M480 256c0 123.7-100.3 224-224 224c-57.4 0-104-46.6-104-104s46.6-104 104-104c75.1 0 136-60.9 136-136c0-26.5-7.6-51.2-20.6-72C436.5 103.1 480 174.5 480 256zM256 32c57.4 0 104 46.6 104 104s-46.6 104-104 104c-75.1 0-136 60.9-136 136c0 26.5 7.6 51.2 20.6 72C75.5 408.9 32 337.5 32 256C32 132.3 132.3 32 256 32zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 160a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faMusic = {
  prefix: 'fal',
  iconName: 'music',
  icon: [512, 512, [127925], "f001", "M512 23c0-12.7-10.3-23-23-23c-2.3 0-4.6 .3-6.8 1l-311 95.7C164.6 98.8 160 105 160 112V232 372.4C143 359.7 120.6 352 96 352c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80V246.3l288-88.6V308.4c-17-12.7-39.4-20.4-64-20.4c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80V136.4c0-.2 0-.5 0-.7V23zM480 368c0 21.3-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48s64 26.7 64 48zM160 432c0 21.3-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48s64 26.7 64 48zM480 124.2L192 212.8v-89L480 35.2v89z"]
};
var faCompassSlash = {
  prefix: 'fal',
  iconName: 'compass-slash',
  icon: [640, 512, [], "f5e9", "M448.8 439.3C412.4 464.9 368 480 320 480C196.3 480 96 379.7 96 256c0-29.3 5.6-57.2 15.8-82.8L85.7 152.6C71.8 184.2 64 219.2 64 256c0 141.4 114.6 256 256 256c58.2 0 111.9-19.4 154.9-52.2l-26.1-20.6zM320 0C261.8 0 208.1 19.4 165.1 52.2l26.1 20.6C227.6 47.1 272 32 320 32c123.7 0 224 100.3 224 224c0 29.3-5.6 57.2-15.8 82.8l26.1 20.6c14-31.6 21.7-66.6 21.7-103.4C576 114.6 461.4 0 320 0zM186.9 348.6c-8.3 25 15.5 48.8 40.5 40.5l111-37-30-23.7-91.1 30.4 27-80.9-26.7-21.1-30.6 91.9zM301.6 159.9l30 23.7 91.1-30.4-27 80.9 26.7 21.1 30.6-91.9c8.3-25-15.5-48.8-40.5-40.5l-111 37zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faClockOne = {
  prefix: 'fal',
  iconName: 'clock-one',
  icon: [512, 512, [], "e34e", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112v91.2l34.7-52c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2l-64 96c-3.9 5.9-11.2 8.5-17.9 6.4s-11.4-8.3-11.4-15.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFileMusic = {
  prefix: 'fal',
  iconName: 'file-music',
  icon: [384, 512, [], "f8b6", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM304 232c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V291.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V232zM256 392c-11.5 0-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12s-4.5 12-16 12zM128 424c-11.5 0-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12s-4.5 12-16 12z"]
};
var faCodeCommit = {
  prefix: 'fal',
  iconName: 'code-commit',
  icon: [640, 512, [], "f386", "M320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm127-80c-7.9 63.1-61.7 112-127 112s-119.1-48.9-127-112H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H193c7.9-63.1 61.7-112 127-112s119.1 48.9 127 112H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H447z"]
};
var faTemperatureLow = {
  prefix: 'fal',
  iconName: 'temperature-low',
  icon: [512, 512, [], "f76b", "M416 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM112 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM176 0C123 0 80 43 80 96V252.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faPersonBiking = {
  prefix: 'fal',
  iconName: 'person-biking',
  icon: [640, 512, [128692, "biking"], "f84a", "M392 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 392 0a56 56 0 1 0 0 112zM224 384A96 96 0 1 1 32 384a96 96 0 1 1 192 0zM128 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM608 384a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM512 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM309.1 166.4c6.1-5.2 15.1-5.1 21.1 .3l59.1 53.2c2.9 2.6 6.8 4.1 10.7 4.1h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H406.1l-54.5-49.1c-17.9-16.1-45-16.5-63.3-.8l-59.1 50.6c-23.9 20.5-21.9 58.1 4 76L320 328.4V416c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-5.3-2.6-10.2-6.9-13.2l-93.7-64.4c-8.7-6-9.3-18.5-1.3-25.3l59.1-50.6z"]
};
var faBiking = faPersonBiking;
var faDisplayChartUpCircleCurrency = {
  prefix: 'fal',
  iconName: 'display-chart-up-circle-currency',
  icon: [640, 512, [], "e5e5", "M64 32H512c17.7 0 32 14.3 32 32V198.6c11.2 3.2 21.9 7.4 32 12.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H213.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H360h34.8c-12.9-9.1-24.5-19.9-34.6-32H341.1 288 234.9l10.7-64H288h38.6c-2.9-10.3-4.9-21-5.9-32H232.3c-.2 0-.4 0-.6 0H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM480 192.7V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6v48c10.3-2.9 21-4.9 32-5.9zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM470.6 342.6a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l9.3 9.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-9.3-9.3c13.2-21.6 13.2-49.1 0-70.7l9.3-9.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-9.3 9.3c-21.6-13.2-49.1-13.2-70.7 0l-9.3-9.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l9.3 9.3c-13.2 21.6-13.2 49.1 0 70.7l-9.3 9.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l9.3-9.3c21.6 13.2 49.1 13.2 70.7 0z"]
};
var faSkeleton = {
  prefix: 'fal',
  iconName: 'skeleton',
  icon: [512, 512, [], "f620", "M256 0c8.8 0 16 7.2 16 16V64H416c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v64H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v64H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v75.4l86.6-24.7c6.3-1.8 12.8-2.7 19.3-2.7c38.8 0 70.2 31.4 70.2 70.2v5.2c0 18.5-6.8 36.3-19 50.1l-26.9 30.2c-11.5 12.9-28 20.3-45.3 20.3H155.2c-17.3 0-33.8-7.4-45.3-20.3L83 461.4c-12.3-13.8-19-31.6-19-50.1v-5.2c0-38.8 31.4-70.2 70.2-70.2c6.5 0 13 .9 19.3 2.7L240 363.4V288H128c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V192H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V96H96c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V16c0-8.8 7.2-16 16-16zM96 406.2v5.2c0 10.6 3.9 20.9 11 28.8l26.9 30.2c5.4 6.1 13.2 9.6 21.4 9.6H356.8c8.2 0 15.9-3.5 21.4-9.6L405 440.2c7.1-7.9 11-18.2 11-28.8v-5.2c0-21.1-17.1-38.2-38.2-38.2c-3.5 0-7.1 .5-10.5 1.5l-93.8 26.8c-11.5 3.3-23.7 3.3-35.2 0l-93.8-26.8c-3.4-1-6.9-1.5-10.5-1.5C113.1 368 96 385.1 96 406.2zM160 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCircleG = {
  prefix: 'fal',
  iconName: 'circle-g',
  icon: [512, 512, [], "e10f", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 256c0-53 43-96 96-96c24.6 0 47 9.2 64 24.4c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h62.7c-7.6 45.4-47.1 80-94.7 80c-53 0-96-43-96-96z"]
};
var faCircleArrowUpLeft = {
  prefix: 'fal',
  iconName: 'circle-arrow-up-left',
  icon: [512, 512, [], "e0fb", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-352H176c-8.8 0-16 7.2-16 16V320c0 8.8 7.2 16 16 16s16-7.2 16-16V214.6L324.7 347.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 192H312c8.8 0 16-7.2 16-16s-7.2-16-16-16z"]
};
var faCoinBlank = {
  prefix: 'fal',
  iconName: 'coin-blank',
  icon: [512, 512, [], "e3fb", "M90.7 281.9C49 258.5 32 231.1 32 208s17-50.5 58.7-73.9C131.4 111.2 189.8 96 256 96s124.6 15.2 165.3 38.1C463 157.5 480 184.9 480 208s-17 50.5-58.7 73.9C380.6 304.8 322.2 320 256 320s-124.6-15.2-165.3-38.1zM240 351.7l0 64c-22.5-.7-44-3-64-6.6l0-64.3c20.3 3.8 41.8 6.1 64 6.9zM96 320.4c14.8 6.7 30.8 12.4 48 17.1l0 64.6c-17.7-4.7-33.8-10.5-48-17l0-64.7zM64 303.2l0 63.6c-23.5-16.9-32-34-32-46.8l0-42.2c9 9.2 19.8 17.7 32 25.5zM272 415.7l0-64c22.2-.8 43.7-3.1 64-6.9l0 64.3c-20 3.6-41.5 5.8-64 6.6zM448 303.2c12.2-7.8 23-16.3 32-25.5l0 42.2c0 12.9-8.5 29.9-32 46.8l0-63.6zm-32 17.2l0 64.7c-14.2 6.5-30.3 12.3-48 17l0-64.6c17.2-4.7 33.2-10.5 48-17.1zM256 64C114.6 64 0 128.5 0 208l0 32 0 80c0 70.7 114.6 128 256 128s256-57.3 256-128l0-80 0-32c0-79.5-114.6-144-256-144z"]
};
var faBroom = {
  prefix: 'fal',
  iconName: 'broom',
  icon: [576, 512, [129529], "f51a", "M571.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-208 208-45.3-45.3c-4.8-4.8-11.2-7.4-17.9-7.4c-12.4 0-23 9-25 21.2l-9.1 54.7-9.8-1.4c-46.3-6.6-93 9-126 42L97 287c-21.1 21.1-33 49.8-33 79.7c0 1.3 .1 2.5 .4 3.7C66.1 378.2 73 384 81.3 384H96L81.3 398.7l-15 15L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512l171.9 0c39.4 0 77.2-15.6 105-43.5c33.1-33.1 48.6-79.7 42-126l-1.4-9.8 54.7-9.1c12.2-2 21.2-12.6 21.2-25c0-6.7-2.7-13.2-7.4-17.9l-45.3-45.3 208-208zM274.7 242.7l7.2-43.5 94.9 94.9-43.5 7.2-58.7-58.7zM229 266.2l24.7 3.5 52.6 52.6 3.5 24.7c5.2 36.3-7 72.9-33 98.9C255 467.7 225.4 480 194.5 480L45.3 480l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9c-4.8-11.5-15.8-19.2-28.2-19.7c2.9-16 10.7-30.8 22.3-42.4l10.5-10.5c25.9-25.9 62.6-38.1 98.9-33z"]
};
var faVacuum = {
  prefix: 'fal',
  iconName: 'vacuum',
  icon: [640, 512, [], "e04d", "M192.4 89.2C203.2 37.2 249 0 302.1 0H528c61.9 0 112 50.1 112 112c0 44.8-26.3 83.5-64.3 101.4C596.1 243.9 608 280.5 608 320V448c0 35.3-28.7 64-64 64H468.7c10.4-9.2 19.2-20 26.2-32H544c17.7 0 32-14.3 32-32V320c0-88.4-71.6-160-160-160c-17.7 0-32 14.3-32 32v96c-11 0-21.8 1.4-32 4V192c0-35.3 28.7-64 64-64c54.6 0 103.9 22.8 138.8 59.4c31-11 53.2-40.6 53.2-75.4c0-44.2-35.8-80-80-80H302.1c-37.9 0-70.6 26.6-78.3 63.7L197 224H164.3L192.4 89.2zM157.7 256h32.7L163.7 384.1C197.3 386 224 413.9 224 448c0 35.3-28.7 64-64 64H24.2C10.8 512 0 501.2 0 487.8c0-5.2 .8-10.4 2.5-15.3l7.6-22.9C23.2 410.4 59.9 384 101.2 384H131l26.7-128zM144.3 416c-.2 0-.4 0-.6 0H101.2c-27.5 0-52 17.6-60.7 43.8L33.7 480H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H144.3zM448 416a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm96-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faShieldHeart = {
  prefix: 'fal',
  iconName: 'shield-heart',
  icon: [512, 512, [], "e574", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM162.3 214.2c0-19.6 15.9-35.5 35.5-35.5c9.5 0 18.7 3.8 25.4 10.7l21.4 21.9c3 3.1 7.1 4.8 11.4 4.8s8.4-1.7 11.4-4.8l21.4-21.9c6.7-6.8 15.8-10.7 25.4-10.7c19.6 0 35.5 15.9 35.5 35.5v1.5c0 9.7-3.8 19-10.6 25.9L256 326.5l-83.1-84.9c-6.8-6.9-10.6-16.2-10.6-25.9v-1.5zm35.5-67.5c-37.3 0-67.5 30.2-67.5 67.5v1.5c0 18.1 7.1 35.4 19.7 48.3l94.6 96.5c3 3.1 7.1 4.8 11.4 4.8s8.4-1.7 11.4-4.8L362 264c12.6-12.9 19.7-30.2 19.7-48.3v-1.5c0-37.3-30.2-67.5-67.5-67.5c-18.1 0-35.5 7.3-48.2 20.3l-10 10.2-10-10.2c-12.7-13-30.1-20.3-48.2-20.3z"]
};
var faCardHeart = {
  prefix: 'fal',
  iconName: 'card-heart',
  icon: [384, 512, [], "e3eb", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 221.3c0 7.8 3.1 15.2 8.6 20.7L192 313.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6c-16.2 0-29.3 13.1-29.3 29.3zM141.3 160c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3c0-33.8 27.4-61.3 61.3-61.3z"]
};
var faLightbulbCflOn = {
  prefix: 'fal',
  iconName: 'lightbulb-cfl-on',
  icon: [640, 512, [], "e5a7", "M23.2 1.7l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32C.9 26.4-2.3 16.7 1.7 8.8S15.3-2.3 23.2 1.7zm608 28.6l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 160H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H560c-8.8 0-16-7.2-16-16s7.2-16 16-16zM87.2 318.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm480-28.6l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zM267.9 4.5C302.5-4.1 336 22 336 57.7c0 3.4-.3 6.8-.9 10l76.8-19.2C446.5 39.9 480 66 480 101.7c0 15.6-6.6 29.9-17.3 40c10.6 9.9 17.3 24 17.3 40c0 15.6-6.6 29.9-17.3 40c10.6 9.9 17.3 24 17.3 40c0 25.1-17.1 47.1-41.5 53.2L368 332.5V352h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H336v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H256c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32h16V317.5l32-8V352h32V320c0-7.3 5-13.7 12.1-15.5l82.6-20.7c10.2-2.5 17.3-11.7 17.3-22.1c0-14.8-13.9-25.7-28.3-22.1l-63.8 15.9-64 16-.1 0-63.7 15.9C193.5 296.1 160 270 160 234.3c0-15.6 6.6-29.9 17.3-40c-10.6-9.9-17.3-24-17.3-40c0-15.6 6.6-29.9 17.3-40c-10.6-9.9-17.3-24-17.3-40c0-25.1 17.1-47.1 41.5-53.2L267.9 4.5zm84 379.5H256v64H384V384H352.1l-.1 0-.1 0zM284.1 240.5l146.6-36.7c10.2-2.5 17.3-11.7 17.3-22.1c0-14.8-13.8-25.6-28.2-22.2L228.1 207.5l-.2 .1-18.6 4.6c-10.2 2.5-17.3 11.7-17.3 22.1c0 14.8 13.9 25.7 28.3 22.1l63.8-15.9zm10.4-129.6l-66.4 16.6-.1 0-18.8 4.7c-10.2 2.5-17.3 11.7-17.3 22.1c0 14.8 13.8 25.6 28.2 22.2l191.7-47.9 .2-.1 18.6-4.6c10.2-2.5 17.3-11.7 17.3-22.1c0-14.8-13.9-25.7-28.3-22.1L294.6 110.9l-.1 0zM304 57.7c0-14.8-13.9-25.7-28.3-22.1L209.3 52.2C199.1 54.7 192 63.8 192 74.3c0 14.8 13.9 25.7 28.3 22.1l0 0 66.4-16.6 0 0C296.9 77.3 304 68.2 304 57.7z"]
};
var faMelon = {
  prefix: 'fal',
  iconName: 'melon',
  icon: [512, 512, [], "e310", "M480 256c0-35.8-8.4-69.7-23.4-99.7c-8.4 56.6-47.7 127.6-110.2 190.1S212.9 448.2 156.3 456.6c30 14.9 63.9 23.4 99.7 23.4c123.7 0 224-100.3 224-224zM55.4 355.7c8.4-56.6 47.7-127.6 110.2-190.1S299.1 63.8 355.7 55.4C325.7 40.4 291.8 32 256 32C132.3 32 32 132.3 32 256c0 35.8 8.4 69.7 23.4 99.7zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM414.3 97.7c-11.8-11.8-38.7-18.4-84.2-3.2c-43.5 14.5-94.7 46.5-142 93.8s-79.3 98.5-93.8 142c-15.2 45.5-8.6 72.4 3.2 84.2s38.7 18.4 84.2 3.2c43.5-14.5 94.7-46.5 142-93.8s79.3-98.5 93.8-142c15.2-45.5 8.6-72.4-3.2-84.2z"]
};
var faGopuram = {
  prefix: 'fal',
  iconName: 'gopuram',
  icon: [512, 512, [], "f664", "M112 0c8.8 0 16 7.2 16 16V32h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V32h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V32h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V32 64 80v48 2.7c18.6 6.6 32 24.4 32 45.3v48c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3v80c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3v64c0 26.5-21.5 48-48 48H320 288 224 192 48c-26.5 0-48-21.5-48-48V400c0-20.9 13.4-38.7 32.1-45.3c-.1-.9-.1-1.8-.1-2.7V272c0-20.9 13.4-38.8 32.1-45.3c-.1-.9-.1-1.8-.1-2.7V176c0-20.9 13.4-38.7 32-45.3V128 80 64 32 16c0-8.8 7.2-16 16-16zM224 480h64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm96 0h64V384H352 304 272 240 208 160 128v96h64c0-35.3 28.7-64 64-64s64 28.7 64 64zM128 80v48H384V80 64H128V80zm-16 80c-8.8 0-16 7.2-16 16l0 48h64V160H128 112zm48 96v96h48V336c0-26.5 21.5-48 48-48s48 21.5 48 48v16h48V256H320 272 240 192 160zm112-48v16h48V160H192v64h48V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 144V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h32zM416 224V176c0-8.8-7.2-16-16-16H384 352v64h64zm0 32H384v96h64V272c0-8.8-7.2-16-16-16H416zm0 224h48c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H448 416v96zM128 256H96 80c-8.8 0-16 7.2-16 16v80h64V256zM96 384H64 48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H96V384z"]
};
var faEarthOceania = {
  prefix: 'fal',
  iconName: 'earth-oceania',
  icon: [512, 512, ["globe-oceania"], "e47b", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm16.7-303.5c-5-1.3-10.3 0-14.3 3.3l-25.2 21.5c-1.9 1.6-4.4 2.2-6.8 1.7l-.3-.1-4-5.3C211.8 216 195.8 208 178.7 208s-33.1 8-43.4 21.7l-5.3 7L94.7 253.5C66 267.1 54.4 302 69.2 330.1l3.3 6.2c12.6 24 40.6 35.5 66.5 27.3l20.4-6.5L205.2 373l27 17.4c9.6 6.2 20.9 9.5 32.3 9.5c18.4 0 35.7-8.4 47-22.9l12.1-15.4c8-10.2 12.4-22.9 12.4-35.9s-4.4-25.6-12.4-35.9l-18-22.9c-3.8-4.9-6.9-10.3-9.2-16.1l-12.8-32.7c-1.9-4.8-6-8.4-11-9.7zm-94 31.5c7 0 13.6 3.3 17.8 8.9l4 5.3c4.7 6.2 11.5 10.6 19.2 12.1l.3 .1c12.1 2.5 24.6-.8 34-8.7l8.1-6.9 4.6 11.8c3.4 8.7 8 16.8 13.8 24.2l17.9 22.9c3.6 4.6 5.6 10.3 5.6 16.1s-2 11.5-5.6 16.1l-12.1 15.4c-5.2 6.7-13.3 10.6-21.8 10.6c-5.3 0-10.5-1.5-15-4.4l-28.7-18.5c-1.1-.7-2.2-1.3-3.5-1.7l-52.7-18.2c-3.3-1.1-6.8-1.2-10.1-.1l-25.4 8.1c-11.1 3.5-23.1-1.4-28.5-11.7l-3.3-6.2c-6.3-12.1-1.4-27 10.9-32.8l35.3-16.8c4.7-2.2 8.7-5.5 11.8-9.7l5.3-7c4.2-5.6 10.8-8.9 17.8-8.9zm103-114.6c-12.4-14.4-32.1-20.2-50.2-14.7l-43.1 12.9c-19.8 5.9-23.3 32.4-5.8 43.3l39.4 24.6c9.4 5.8 20.4 8.3 31.4 6.9l37.9-4.7c19-2.4 27.7-24.9 15.2-39.4l-24.8-28.9zm-41 15.9c6.1-1.8 12.6 .1 16.7 4.9l15.1 17.6-23.2 2.9c-3.6 .5-7.3-.4-10.5-2.3l-24.4-15.2 26.2-7.9zM248 432c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H264c-8.8 0-16 7.2-16 16zM431.2 306.9c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l8 24c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-8-24zm-19.9 80.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"]
};
var faGlobeOceania = faEarthOceania;
var faContainerStorage = {
  prefix: 'fal',
  iconName: 'container-storage',
  icon: [640, 512, [], "f4b7", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H32V448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48 592h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H592 48 16zM64 448V64H576V448H64zM192 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"]
};
var faFacePouting = {
  prefix: 'fal',
  iconName: 'face-pouting',
  icon: [512, 512, [], "e387", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm85.3-102.7c4.5-3.5 8.4-8.6 10-15.1c1.6-6.7 .5-13.5-2.7-19.5C331.2 342 296.1 320 256 320c-40.1 0-75.1 22-92.5 54.7c-3.2 6-4.3 12.8-2.7 19.5c1.6 6.5 5.4 11.6 10 15.1c8.8 6.8 21.2 8.7 32.4 4.5c16.2-6.1 34-9.4 52.9-9.4c18.9 0 36.7 3.4 52.9 9.4c11.2 4.2 23.6 2.4 32.4-4.5zm-25.7-27.1c-18.5-6.4-38.6-9.9-59.6-9.9c-20.9 0-41 3.5-59.6 9.8C209.4 364 231.1 352 256 352s46.7 12.1 59.6 30.2zM176.4 264c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faSquareXmark = {
  prefix: 'fal',
  iconName: 'square-xmark',
  icon: [448, 512, [10062, "times-square", "xmark-square"], "f2d3", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm148.7 84.7c6.2-6.2 16.4-6.2 22.6 0L224 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faTimesSquare = faSquareXmark;
var faXmarkSquare = faSquareXmark;
var faFaceExplode = {
  prefix: 'fal',
  iconName: 'face-explode',
  icon: [512, 512, ["exploding-head"], "e2fe", "M296 32c-11.2 0-21.3 4.6-28.6 12c-3 3.1-7.1 4.8-11.4 4.8s-8.4-1.7-11.4-4.8c-7.3-7.4-17.4-12-28.6-12c-22.1 0-40 17.9-40 40v4.2c0 6.3-3.7 12-9.5 14.6s-12.5 1.5-17.2-2.7C143.7 83.1 136.2 80 128 80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 16 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H221.3c1.8 5 2.7 10.4 2.7 16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8-7.2-16-16-16H160 128c-35.3 0-64-28.7-64-64s28.7-64 64-64c6.7 0 13.1 1 19.1 2.9C156.2 21.4 183.6 0 216 0c14.8 0 28.6 4.5 40 12.1C267.4 4.5 281.2 0 296 0c32.4 0 59.8 21.4 68.9 50.9c6-1.9 12.5-2.9 19.1-2.9c35.3 0 64 28.7 64 64s-28.7 64-64 64H336c-8.8 0-16 7.2-16 16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-26.5 21.5-48 48-48h48c17.7 0 32-14.3 32-32s-14.3-32-32-32c-8.2 0-15.7 3.1-21.3 8.1c-4.7 4.2-11.4 5.3-17.2 2.7s-9.5-8.3-9.5-14.6V72c0-22.1-17.9-40-40-40zM32 260.3c3.1-.7 6.1-1.8 9-3.4l28.7-16.1c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0l25.5-14.4c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0l25.5-14.4c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0L411 240.8c9.7-5.5 21.6-5.5 31.4 0L471 256.9c2.8 1.6 5.8 2.7 9 3.4c5.7 1.2 11.6 .9 17.2-1l9.5-3.3 5.3-1.8 0 1.8c0 11.1-.7 22-2.1 32.7C493.9 414.7 386.3 512 256 512S18.1 414.7 2.1 288.7C.7 278 0 267.1 0 256l0-1.8L5.3 256l9.5 3.3c5.6 1.9 11.5 2.3 17.2 1zm53.3 8.4L56.7 284.8c-6.8 3.8-14.2 6.3-21.8 7.5C52.3 398.8 144.7 480 256 480s203.7-81.2 221.1-187.7c-7.6-1.2-14.9-3.7-21.8-7.5l-28.7-16.1-25.5 14.4c-19.5 11-43.3 11-62.8 0l-25.5-14.4-25.5 14.4c-19.5 11-43.3 11-62.8 0l-25.5-14.4-25.5 14.4c-19.5 11-43.3 11-62.8 0L85.3 268.7zm91 43.3a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM256 352c35.3 0 64 28.7 64 64v5.3c0 14.7-11.9 26.7-26.7 26.7H218.7c-14.7 0-26.7-11.9-26.7-26.7V416c0-35.3 28.7-64 64-64zm-32 64h64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faExplodingHead = faFaceExplode;
var faHashtag = {
  prefix: 'fal',
  iconName: 'hashtag',
  icon: [448, 512, [62098], "23", "M207.6 51.6c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h98L109.1 336H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.7L80.4 460.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6H261.7l-21.3 92.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H302l36.9-160H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H346.3l21.3-92.4c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6H186.3l21.3-92.4zM178.9 176H306L269.1 336H142l36.9-160z"]
};
var faUpRightAndDownLeftFromCenter = {
  prefix: 'fal',
  iconName: 'up-right-and-down-left-from-center',
  icon: [512, 512, ["expand-alt"], "f424", "M321 0c-18.2 0-33 14.8-33 33c0 8.7 3.5 17.1 9.7 23.3L325.4 84l-71.7 71.7c-15.6 15.6-15.6 40.9 0 56.6l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0L428 186.6l27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7c18.2 0 33-14.8 33-33V32c0-17.7-14.3-32-32-32H321zm-1 33c0-.5 .4-1 1-1H480V191c0 .5-.4 1-1 1c-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-83 83c-3.1 3.1-8.2 3.1-11.3 0l-46.1-46.1c-3.1-3.1-3.1-8.2 0-11.3l83-83c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7zM32 512H191c18.2 0 33-14.8 33-33c0-8.7-3.5-17.1-9.7-23.3L186.6 428l71.7-71.7c15.6-15.6 15.6-40.9 0-56.6l-46.1-46.1c-15.6-15.6-40.9-15.6-56.6 0L84 325.4 56.3 297.7C50.1 291.5 41.7 288 33 288c-18.2 0-33 14.8-33 33V480c0 17.7 14.3 32 32 32zm160-33c0 .5-.4 1-1 1H32V321c0-.5 .4-1 1-1c.3 0 .5 .1 .7 .3l39 39c6.2 6.2 16.4 6.2 22.6 0l83-83c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-83 83c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39c.2 .2 .3 .4 .3 .7z"]
};
var faExpandAlt = faUpRightAndDownLeftFromCenter;
var faOilCan = {
  prefix: 'fal',
  iconName: 'oil-can',
  icon: [640, 512, [], "f613", "M336 96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0v64H128 96 48c-26.5 0-48 21.5-48 48v62.7c0 20 12.4 37.9 31.1 44.9L96 340v28c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H272V96l64 0zm97.7 124.6c6.5 3.2 13.9 4.2 21 2.7l129.1-27.7L427.1 373.2c-6.1 6.9-14.8 10.8-24 10.8H144c-8.8 0-16-7.2-16-16V352 317.8 192H368.9c5 0 9.9 1.2 14.3 3.4l50.5 25.2zM96 305.8L42.4 285.7c-6.2-2.3-10.4-8.3-10.4-15V208c0-8.8 7.2-16 16-16H96V305.8z"]
};
var faT = {
  prefix: 'fal',
  iconName: 't',
  icon: [384, 512, [116], "54", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H176V464c0 8.8 7.2 16 16 16s16-7.2 16-16V64H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H192 16z"]
};
var faTransformerBolt = {
  prefix: 'fal',
  iconName: 'transformer-bolt',
  icon: [384, 512, [], "e2a4", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H128V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V16zM48 112c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H32V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48 336h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H352V192h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H336 48 16zM64 480V192H320V480H64zm78.6-144l61.9-61.9-4.4 44.3c-.4 4.5 1 9 4.1 12.3s7.3 5.3 11.9 5.3h25.4l-61.9 61.9 4.4-44.3c.4-4.5-1-9-4.1-12.3s-7.3-5.3-11.9-5.3H142.6zm75.6-112c-5.6 0-11 2.2-15 6.2L102.3 331c-4.1 4.1-6.3 9.6-6.3 15.3c0 12 9.7 21.7 21.7 21.7h32.7l-5.7 56.6c-1.3 12.5 8.6 23.4 21.2 23.4c5.6 0 11-2.2 15-6.2L281.7 341c4.1-4.1 6.3-9.6 6.3-15.3c0-12-9.7-21.7-21.7-21.7H233.7l5.7-56.6c1.3-12.5-8.6-23.4-21.2-23.4z"]
};
var faHippo = {
  prefix: 'fal',
  iconName: 'hippo',
  icon: [640, 512, [129435], "f6ed", "M427.3 44.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l12.1 12.1c-4.4 3.2-8.4 6.8-12 10.8L382 81.2C353.6 69.8 323.4 64 292.9 64H224C118 64 32 150 32 256v8 0l0 19.1c0 25.4-8.7 50.1-24.5 70L3.5 358C-2 364.9-.9 375 6 380.5s17 4.4 22.5-2.5l3.9-4.9c20.4-25.5 31.6-57.3 31.6-90L64 264v0-8c0-88.4 71.6-160 160-160h68.9c26.5 0 52.7 5 77.2 14.9l18.2 7.3c-2.8 8.1-4.3 16.8-4.3 25.9v5c0 9.5-4.5 18.4-10.8 25.6C360 190.1 352 210.1 352 232c0 45.9 35.1 83.6 80 87.6V336c0 8.8 7.2 16 16 16s16-7.2 16-16V320h88c2.7 0 5.4-.1 8-.4V336c0 8.8 7.2 16 16 16s16-7.2 16-16V310.4c28.5-14.6 48-44.2 48-78.4c0-30.8-15.8-57.8-39.7-73.6c-4.9-3.2-8.3-8.5-8.3-14.4c0-22.4-9.2-42.7-24.1-57.3l11.4-11.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L540.2 69.1C531.5 65.8 521.9 64 512 64H464c-5.4 0-10.7 .5-15.8 1.6L427.3 44.7zM448 288h-8c-30.9 0-56-25.1-56-56c0-14 5.1-26.7 13.5-36.5c9.2-10.7 18.5-26.7 18.5-46.5v-5c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48c0 13.4 5.5 24.7 13.2 33c-25.7 5.1-45.2 27.7-45.2 55c0 8.8 7.2 16 16 16s16-7.2 16-16c0-13.3 10.7-24 24-24s24 10.7 24 24c0 30.9-25.1 56-56 56H448zm-32 83.8V424c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V363.9c0-5.1-2.4-9.9-6.5-12.9s-9.4-3.9-14.3-2.4l-11.3 3.6c-31.2 9.8-64.6 9.8-95.8 0l-11.3-3.6c-4.9-1.5-10.2-.6-14.3 2.4s-6.5 7.8-6.5 12.9V424c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24V352c0-8.8-7.2-16-16-16s-16 7.2-16 16v72c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56V385.4c31.5 8.1 64.5 8.1 96 0V424c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56V384c-12.3 0-23.5-4.6-32-12.2zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-40 32c-8.8 0-16 7.2-16 16s7.2 16 16 16c13.3 0 24 10.7 24 24c0 8.8 7.2 16 16 16s16-7.2 16-16c0-30.9-25.1-56-56-56zm88-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faChartColumn = {
  prefix: 'fal',
  iconName: 'chart-column',
  icon: [512, 512, [], "e0e3", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM144 256c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8 7.2-16 16-16zM256 144V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 48c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm112-80V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCassetteVhs = {
  prefix: 'fal',
  iconName: 'cassette-vhs',
  icon: [576, 512, [128252, "vhs"], "f8ec", "M32 160V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V160H32zm0-32H544V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96v32zM576 96v32 16 16V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160 144 128 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64zM136 208h72H368h72c3.5 0 6.9 1.1 9.7 3.3L440 224c9.7-12.7 9.7-12.7 9.7-12.7l0 0 0 0 .1 0 .2 .1 .5 .4c.4 .3 1 .8 1.6 1.3c1.3 1.1 3.2 2.7 5.3 4.8c4.3 4.1 9.9 10.2 15.6 18c11.3 15.5 23 38.8 23 68s-11.8 52.5-23 68c-5.7 7.8-11.3 13.8-15.6 18c-2.1 2.1-4 3.7-5.3 4.8c-.7 .6-1.2 1-1.6 1.3l-.5 .4-.2 .1-.1 0 0 0 0 0s0 0-9.7-12.7l9.7 12.7c-2.8 2.1-6.2 3.3-9.7 3.3H368 208 136c-3.5 0-6.9-1.1-9.7-3.3L136 384c-9.7 12.7-9.7 12.7-9.7 12.7l0 0 0 0-.1 0-.2-.1-.5-.4c-.4-.3-1-.8-1.6-1.3c-1.3-1.1-3.2-2.7-5.3-4.8c-4.3-4.1-9.9-10.2-15.6-18c-11.3-15.5-23-38.8-23-68s11.8-52.5 23-68c5.7-7.8 11.3-13.8 15.6-18c2.1-2.1 4-3.7 5.3-4.8c.7-.6 1.2-1 1.6-1.3l.5-.4 .2-.1 .1 0 0 0 0 0s0 0 9.7 12.7l-9.7-12.7c2.8-2.1 6.2-3.3 9.7-3.3zm4.9 33c-3.2 3.1-7.6 7.8-11.9 13.7c-8.7 12.1-17 28.8-17 49.2s8.2 37.2 17 49.2c4.3 6 8.7 10.6 11.9 13.7c.4 .4 .7 .7 1.1 1H192V336c-17.7 0-32-14.3-32-32s14.3-32 32-32V240H141.9c-.3 .3-.7 .7-1.1 1zM352 368V240H224V368H352zm82.1 0c.3-.3 .7-.7 1.1-1c3.2-3.1 7.6-7.8 11.9-13.7c8.7-12.1 17-28.8 17-49.2s-8.2-37.2-17-49.2c-4.3-6-8.7-10.6-11.9-13.7c-.4-.4-.7-.7-1.1-1H384v32c17.7 0 32 14.3 32 32s-14.3 32-32 32v32h50.1z"]
};
var faVhs = faCassetteVhs;
var faInfinity = {
  prefix: 'fal',
  iconName: 'infinity',
  icon: [640, 512, [8734, 9854], "f534", "M0 233.5C0 157.5 61.5 96 137.5 96c39.3 0 76.7 16.8 102.7 46.1L320 231.9l79.8-89.8C425.9 112.8 463.3 96 502.5 96C578.5 96 640 157.5 640 233.5v45.1C640 354.5 578.5 416 502.5 416c-39.3 0-76.7-16.8-102.7-46.1L320 280.1l-79.8 89.8C214.1 399.2 176.7 416 137.5 416C61.5 416 0 354.5 0 278.5V233.5zM298.6 256l-82.3-92.6c-20-22.5-48.7-35.4-78.8-35.4C79.2 128 32 175.2 32 233.5v45.1C32 336.8 79.2 384 137.5 384c30.1 0 58.8-12.9 78.8-35.4L298.6 256zm42.8 0l82.3 92.6c20 22.5 48.7 35.4 78.8 35.4C560.8 384 608 336.8 608 278.5V233.5C608 175.2 560.8 128 502.5 128c-30.1 0-58.8 12.9-78.8 35.4L341.4 256z"]
};
var faVialCircleCheck = {
  prefix: 'fal',
  iconName: 'vial-circle-check',
  icon: [512, 512, [], "e596", "M0 48c0-8.8 7.2-16 16-16H32 64 192h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H224V266.8c-20.2 28.6-32 63.5-32 101.2V224H64V384c0 35.3 28.7 64 64 64s64-28.7 64-64V368c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V64H16C7.2 64 0 56.8 0 48zM64 64V192H192V64H64zM368 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L352 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faChimney = {
  prefix: 'fal',
  iconName: 'chimney',
  icon: [448, 512, [], "f78b", "M32 64H416v64H400 176 48 32V64zm0 96l0 112V400v64c0 8.8 7.2 16 16 16s16-7.2 16-16V416h96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h80H384v48c0 8.8 7.2 16 16 16s16-7.2 16-16V400 272 160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32zm352 0v96H272 192V160H384zm-224 0v96H64V160h96zm16 224H64V288H176h80v96H176zm112 0V288h96v96H288z"]
};
var faObjectIntersect = {
  prefix: 'fal',
  iconName: 'object-intersect',
  icon: [512, 512, [], "e49d", "M96 32H64C46.3 32 32 46.3 32 64V96H0V64C0 28.7 28.7 0 64 0H96V32zm32 0V0h96V32H128zM0 128H32v96H0V128zM288 32H256V0h32c35.3 0 64 28.7 64 64v64H320V64c0-17.7-14.3-32-32-32zm32 128h32v32 64 32c0 35.3-28.7 64-64 64H224 192 160V320 256 224c0-35.3 28.7-64 64-64h64 32zM160 384h32v64c0 17.7 14.3 32 32 32h32v32H224c-35.3 0-64-28.7-64-64V384zm-32-32H64c-35.3 0-64-28.7-64-64V256H32v32c0 17.7 14.3 32 32 32h64v32zM384 192V160h64c35.3 0 64 28.7 64 64v32H480V224c0-17.7-14.3-32-32-32H384zM288 512V480h96v32H288zm160 0H416V480h32c17.7 0 32-14.3 32-32V416h32v32c0 35.3-28.7 64-64 64zm64-128H480V288h32v96zM224 192c-17.7 0-32 14.3-32 32v96h96c17.7 0 32-14.3 32-32V192H224z"]
};
var faPersonArrowDownToLine = {
  prefix: 'fal',
  iconName: 'person-arrow-down-to-line',
  icon: [640, 512, [], "e538", "M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM179.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H160V164c6-2.6 12.5-4 19.3-4zM160 480V352h64V480H160zm-32 0H16c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0h96l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L275.3 170.3c-13.9-26-41-42.3-70.6-42.3H179.3c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L128 202.1V480zM480 48l0 313.4-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L512 361.4 512 48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faVoicemail = {
  prefix: 'fal',
  iconName: 'voicemail',
  icon: [640, 512, [], "f897", "M144 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM288 240c0 45.2-20.9 85.6-53.5 112h171C372.9 325.6 352 285.2 352 240c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144H144C64.5 384 0 319.5 0 240S64.5 96 144 96s144 64.5 144 144zM496 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
var faBlockBrick = {
  prefix: 'fal',
  iconName: 'block-brick',
  icon: [448, 512, ["wall-brick"], "e3db", "M136 64v64h72 32 72V64H136zm-32 0H64C46.3 64 32 78.3 32 96v32h72V64zM32 160v80h72 32 72V160H32zm0 192h72V272H32v80zm0 32v32c0 17.7 14.3 32 32 32H208V384H136 104 32zm104-32H312V272H136v80zm208 0h72V272H344v80zm72 32H344 312 240v64H384c17.7 0 32-14.3 32-32V384zm0-224H240v80h72 32 72V160zm0-32V96c0-17.7-14.3-32-32-32H344v64h72zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faWallBrick = faBlockBrick;
var faFan = {
  prefix: 'fal',
  iconName: 'fan',
  icon: [512, 512, [], "f863", "M242.5 134.2c-1.1 10.6 3.2 21 11.4 27.8s19.2 9.1 29.4 6.1c16.9-4.9 39.3-8.2 68.8-8.2l.1 0c59.5-.2 108.2 37.9 123.1 92.2l-97.5-9.7c-10.6-1.1-21 3.2-27.8 11.4s-9.1 19.2-6.2 29.4c4.9 16.9 8.2 39.3 8.2 68.8l0 .1c.2 59.5-37.9 108.2-92.2 123.1l9.7-97.5c1.1-10.6-3.2-21-11.4-27.8s-19.2-9.1-29.4-6.1c-16.9 4.9-39.3 8.2-68.8 8.2l-.1 0c-59.5 .2-108.2-37.9-123.1-92.2l97.5 9.7c10.6 1.1 21-3.2 27.8-11.4s9.1-19.2 6.1-29.4c-4.9-16.9-8.2-39.3-8.2-68.8l0-.1c-.2-59.5 37.9-108.2 92.2-123.1l-9.7 97.5zM480.1 252.7s0 0 0 0l0 0zM32 259.3l0 0c0 0 0 0 0 0zM252.7 32l0 0c0 0 0 0 0 0zm21.6 105.5l3.4-33.9 6.8-68.3c1.9-18.8-13.1-35.5-31.6-31.5C179.9 19.2 127.7 82.7 128 160c0 16.6 1 31.5 2.7 44.9c1.6 12.2 3.9 23.1 6.7 32.8l-33.9-3.4-68.3-6.8C16.4 225.6-.3 240.6 3.7 259.1C19.2 332.2 82.8 384.3 160 384c16.6 0 31.5-1 44.9-2.7c12.2-1.6 23.1-3.9 32.8-6.7l-3.4 33.9-6.8 68.3c-1.9 18.8 13.1 35.5 31.6 31.5C332.2 492.8 384.3 429.3 384 352c0-16.6-1-31.5-2.7-44.9c-1.6-12.2-3.9-23.1-6.7-32.8l33.9 3.4 68.3 6.8c18.8 1.9 35.5-13.1 31.5-31.6C492.8 179.8 429.3 127.7 352 128c-16.6 0-31.5 1-44.9 2.7c-12.2 1.6-23.1 3.9-32.8 6.7zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBagsShopping = {
  prefix: 'fal',
  iconName: 'bags-shopping',
  icon: [576, 512, [128717], "f847", "M160 96c0-35.3 28.7-64 64-64s64 28.7 64 64v64H160V96zm-32 64H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64h96V448H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32h32c0-35.3-28.7-64-64-64H320V96c0-53-43-96-96-96s-96 43-96 96v64zM512 288c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32H512zM192 320V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H256c-35.3 0-64 28.7-64 64zm128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53 43 96 96 96s96-43 96-96V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 35.3-28.7 64-64 64s-64-28.7-64-64V336z"]
};
var faParagraphLeft = {
  prefix: 'fal',
  iconName: 'paragraph-left',
  icon: [384, 512, ["paragraph-rtl"], "f878", "M320 32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H224 208 176 144C82.1 0 32 50.1 32 112s50.1 112 112 112h48v80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80V208 32h64V304c0 8.8 7.2 16 16 16s16-7.2 16-16V32zM192 32V192H144c-44.2 0-80-35.8-80-80s35.8-80 80-80h32 16zM122.2 348.3c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2l-96 80C2.1 406.7 0 411.3 0 416s2.1 9.3 5.8 12.3l96 80c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5L60.2 432H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H60.2l62.1-51.7z"]
};
var faParagraphRtl = faParagraphLeft;
var faPersonWalkingLuggage = {
  prefix: 'fal',
  iconName: 'person-walking-luggage',
  icon: [576, 512, [], "e554", "M400 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 368 56a56 56 0 1 0 112 0zM341.6 172.3c1.3-.7 2.6-1.4 3.9-2l-26.6 85c-5.7 18.2 0 38.1 14.4 50.6L433.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L464.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L411.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2l-30.8 61.7-62.2 62.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zm-94.8-63.4c-7.5-4.6-17.4-2.2-22 5.3l-25.2 41.4c-.6-.4-1.1-.7-1.7-1.1L144 304c-15.3-8.8-34.9-3.6-43.7 11.7l-64 110.9c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l36.3-62.9 70.2-115.3c4.6-7.5 2.2-17.4-5.3-22zM118 473.7L64 442.6l64-110.9 55.4 32-27.5 47.6-38 62.4z"]
};
var faCaravanSimple = {
  prefix: 'fal',
  iconName: 'caravan-simple',
  icon: [640, 512, ["caravan-alt"], "e000", "M80 64c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h21.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H544V192c0-70.7-57.3-128-128-128H80zM96 416H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V384l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0H544 288c0 53-43 96-96 96s-96-43-96-96zM256 160H128v64H256V160zM128 128H256c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm224 32v64h64V160H352zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V160zM256 416a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faCaravanAlt = faCaravanSimple;
var faTurtle = {
  prefix: 'fal',
  iconName: 'turtle',
  icon: [576, 512, [128034], "f726", "M200 64C124.9 64 64 124.9 64 200v40c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-92.8 75.2-168 168-168s168 75.2 168 168v40c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-75.1-60.9-136-136-136zM400 188.6c0-42.3 34.3-76.6 76.6-76.6c54.9 0 99.4 44.5 99.4 99.4V224c0 35.3-28.7 64-64 64H491.5c-20.3 57.4-74.7 96-135.8 96H352v48c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V384H192v48c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V384H48c-26.5 0-48-21.5-48-48s21.5-48 48-48H360c22.1 0 40-17.9 40-40V188.6zM256 416v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V416 384 352h35.7c48.2 0 91-30.8 106.3-76.6l2.8-8.5c2.2-6.5 8.3-10.9 15.2-10.9h32c17.7 0 32-14.3 32-32V211.4c0-37.2-30.2-67.4-67.4-67.4C452 144 432 164 432 188.6V248c0 39.8-32.2 72-72 72H320 256 160 96 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H96v32 32 16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V416 384 352h96v32 32zM480 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPencilMechanical = {
  prefix: 'fal',
  iconName: 'pencil-mechanical',
  icon: [512, 512, [], "e5ca", "M440 0c-9.4 0-18.3 3.7-25 10.3L376.4 48.9c-2.7-.6-5.6-.9-8.4-.9c-10.2 0-20.1 4.1-27.3 11.3L311.3 88.7 281.9 59.3c-18.7-18.7-49.1-18.7-67.9 0L108.7 164.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L236.7 81.9c6.2-6.2 16.4-6.2 22.6 0l29.4 29.4L80.4 319.7c-5.5 5.5-9.6 12.2-11.9 19.6L32 456l.7 .7-28 28c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l28-28 .7 .7 116.7-36.5c7.4-2.3 14.1-6.4 19.6-11.9L452.7 171.3c7.2-7.2 11.3-17.1 11.3-27.3c0-2.9-.3-5.7-.9-8.4L501.7 97c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L465 10.3C458.3 3.7 449.4 0 440 0zm4.7 108.7L403.3 67.3 437.7 33c.6-.6 1.5-1 2.3-1s1.7 .3 2.3 1L479 69.7c.6 .6 1 1.5 1 2.3s-.3 1.7-1 2.3l-34.3 34.3zm-14.6 30.6c1.2 1.2 1.9 2.9 1.9 4.7s-.7 3.4-1.9 4.7L188.7 390.1l-66.7-66.7L363.3 81.9c1.2-1.2 2.9-1.9 4.7-1.9s3.4 .7 4.7 1.9l57.4 57.4zM99 348.8c.2-.8 .5-1.5 .9-2.3l65.5 65.5c-.7 .4-1.5 .7-2.3 .9L69.9 442.1 99 348.8z"]
};
var faUpDown = {
  prefix: 'fal',
  iconName: 'up-down',
  icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M103.3 9.7C110 3.5 118.8 0 128 0s18 3.5 24.7 9.7l91 84c7.8 7.2 12.3 17.4 12.3 28.1c0 21.1-17.1 38.3-38.3 38.3H192V352h25.7c21.1 0 38.3 17.1 38.3 38.3c0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7s-18-3.5-24.7-9.7l-91-84C4.5 411.1 0 400.9 0 390.3C0 369.1 17.1 352 38.3 352H64V160H38.3C17.1 160 0 142.9 0 121.7c0-10.7 4.5-20.9 12.3-28.1l91-84zM128 32c-1.1 0-2.2 .4-3 1.2l-91 84c-1.3 1.2-2 2.9-2 4.6c0 3.5 2.8 6.3 6.3 6.3H80c8.8 0 16 7.2 16 16V368v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 8.8-7.2 16-16 16H38.3c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.4 2 4.6l91 84c.8 .8 1.9 1.2 3 1.2s2.2-.4 3-1.2l91-84c1.3-1.2 2-2.8 2-4.6c0-3.5-2.8-6.3-6.3-6.3H176c-8.8 0-16-7.2-16-16v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0V144c0-8.8 7.2-16 16-16h41.7c3.5 0 6.3-2.8 6.3-6.3c0-1.7-.7-3.4-2-4.6l-91-84c-.8-.8-1.9-1.2-3-1.2z"]
};
var faArrowsAltV = faUpDown;
var faCloudMoonRain = {
  prefix: 'fal',
  iconName: 'cloud-moon-rain',
  icon: [576, 512, [], "f73c", "M357.5 109.6c10.8-32.9 36.5-59.3 69.4-71c-17.1 22.5-27.3 50.4-27.3 80.8c0 63.2 44.1 116.1 103.2 130.4c-10.6 3.7-21.9 5.8-33.7 6.2c4.6 9.8 7.9 20.4 9.5 31.5c34-3.1 64.7-17.8 87.8-40.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-5.8 1-11.7 1.5-17.8 1.5c-57.2 0-103.4-45.9-103.4-102.2c0-38.1 21.1-71.4 52.5-89c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-4.1-.3-8.2-.5-12.3-.5C401.2 0 346.7 41.2 327.4 98.5c10.7 2.3 20.7 6.1 30 11.1zM88.6 418.5c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zM112 192c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H98.9c-.1 0-.3 0-.4 0c-.1 0-.1 0-.2 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3C34.6 200.9 0 240.4 0 288c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H365.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 114.6 210.9 96 176 96z"]
};
var faBoothCurtain = {
  prefix: 'fal',
  iconName: 'booth-curtain',
  icon: [512, 512, [], "f734", "M0 32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V32l32 0V0H32C14.3 0 0 14.3 0 32zm288 0V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64zM256 448c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7c11.7 0 22.6-3.1 32-8.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384 48 32c0-17.7-14.3-32-32-32H208 128C110.3 0 96 14.3 96 32V384c0 35.3 28.7 64 64 64c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7zM480 48V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64V48zM384 32V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64zM192 384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64V384z"]
};
var faCalendar = {
  prefix: 'fal',
  iconName: 'calendar',
  icon: [448, 512, [128197, 128198], "f133", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H32V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32z"]
};
var faBoxHeart = {
  prefix: 'fal',
  iconName: 'box-heart',
  icon: [448, 512, [], "f49d", "M240 64H342.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128H416V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H208h32zm-32-32H42.1L76.3 83c5.1-11.6 16.6-19 29.2-19H208v96zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM146.7 264.5c14.3-14.3 37.4-14.3 51.7 0l14.3 14.3c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7l14.3-14.3c14.3-14.3 37.4-14.3 51.7 0s14.3 37.4 0 51.7L224 393.4l-77.3-77.3c-14.3-14.3-14.3-37.4 0-51.7zM221 241.8c-26.8-26.8-70.2-26.8-96.9 0s-26.8 70.2 0 96.9L201.4 416c12.5 12.5 32.8 12.5 45.3 0l77.3-77.3c26.8-26.8 26.8-70.2 0-96.9s-70.2-26.8-96.9 0l-3 3-3-3z"]
};
var faTrailer = {
  prefix: 'fal',
  iconName: 'trailer',
  icon: [640, 512, [], "e041", "M56 64H456c13.3 0 24 10.7 24 24V352H282.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H56c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM288 384H616c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V88c0-30.9-25.1-56-56-56H56C25.1 32 0 57.1 0 88V328c0 30.9 25.1 56 56 56H96c0 53 43 96 96 96s96-43 96-96zm-32 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM112 96c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16z"]
};
var faUserDoctorMessage = {
  prefix: 'fal',
  iconName: 'user-doctor-message',
  icon: [640, 512, ["user-md-chat"], "f82e", "M128 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 128A128 128 0 1 1 224 0a128 128 0 1 1 0 256zM160 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-96v34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V339.8C80.2 354.7 32.6 411.8 32 480H416c-.5-62.4-40.4-115.4-96-135.5v25.8c23.1 6.9 40 28.3 40 53.7v24c0 8.8-7.2 16-16 16H328c-8.8 0-16-7.2-16-16s7.2-16 16-16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V424c0-25.4 16.9-46.8 40-53.7V337c-5.6-.7-11.4-1-17.2-1H177.2l-1.2 0zM0 481.2C0 383.3 79.3 304 177.2 304h93.6C368.7 304 448 383.3 448 481.2c0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2zM544 192h48c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H432c-8.8 0-16 7.2-16 16V176c0 8.8 7.2 16 16 16h16c17.7 0 32 14.3 32 32v8l44.8-33.6c5.5-4.2 12.3-6.4 19.2-6.4zm-65.1 80.8l-9.6 7.2-8.5 6.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2V269.3v-12V256 224H432c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H544l-64 48-1.1 .8z"]
};
var faUserMdChat = faUserDoctorMessage;
var faBahai = {
  prefix: 'fal',
  iconName: 'bahai',
  icon: [576, 512, ["haykal"], "f666", "M287.7 0c7.2 0 13.6 4.9 15.5 11.9l32.2 120.7L437.8 60.8c5.9-4.2 13.9-3.8 19.5 .8s7.3 12.5 4.2 19l-53 113.1 124.6 10.7c7.2 .6 13.1 6 14.4 13.2s-2.4 14.2-9 17.3L425 287.7l88.5 88.2c5.1 5.1 6.2 13 2.6 19.3s-11 9.3-18 7.5L377.3 370.2l11 124.4c.6 7.2-3.7 14-10.5 16.4s-14.4 .1-18.6-5.9L287.7 402.7 216.1 505.2c-4.2 5.9-11.8 8.3-18.6 5.9s-11.1-9.2-10.5-16.4l11-124.4L77.3 402.6c-7 1.9-14.4-1.2-18-7.5s-2.6-14.2 2.6-19.3l88.5-88.2L37 235c-6.6-3.1-10.3-10.1-9-17.3s7.2-12.5 14.4-13.2l124.6-10.7L114 80.7c-3.1-6.6-1.4-14.4 4.2-19s13.5-5 19.5-.8L240 132.6 272.2 11.9c1.9-7 8.2-11.9 15.5-11.9zm0 78L265 162.9c-1.3 5-5.1 9.1-10 10.9s-10.4 1.1-14.7-1.9l-72-50.5L205.6 201c2.2 4.7 2 10.3-.6 14.8s-7.3 7.5-12.5 7.9l-87.6 7.5 79.7 37c4.7 2.2 8.1 6.6 9 11.7s-.8 10.4-4.5 14.1l-62.2 62 84.9-22.8c5-1.4 10.4-.2 14.4 3.2s6.1 8.5 5.7 13.7l-7.8 87.5 50.4-72.1c3-4.3 7.9-6.8 13.1-6.8s10.1 2.6 13.1 6.8l50.4 72.1-7.8-87.5c-.5-5.2 1.6-10.3 5.7-13.7s9.4-4.6 14.4-3.2l84.9 22.8-62.2-62c-3.7-3.7-5.4-9-4.5-14.1s4.3-9.5 9-11.7l79.7-37-87.6-7.5c-5.2-.4-9.9-3.4-12.5-7.9s-2.9-10-.6-14.8L407 121.4l-72 50.5c-4.3 3-9.8 3.7-14.7 1.9s-8.6-5.9-10-10.9L287.7 78z"]
};
var faHaykal = faBahai;
var faAmpGuitar = {
  prefix: 'fal',
  iconName: 'amp-guitar',
  icon: [512, 512, [], "f8a1", "M139.6 51.9C168.3 27.2 210.1 0 256 0s87.7 27.2 116.4 51.9c4.8 4.1 9.3 8.2 13.4 12.1H448c35.3 0 64 28.7 64 64V256v16 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288 272 256 128C0 92.7 28.7 64 64 64h62.2c4.2-4 8.7-8.1 13.4-12.1zm36 12.1H336.4C312.1 46 284 32 256 32s-56.1 14-80.4 32zM480 288H32V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V288zm0-32V128c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32V256H480zM80 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM208 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSdCard = {
  prefix: 'fal',
  iconName: 'sd-card',
  icon: [384, 512, [], "f7c2", "M352 64V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V154.5c0-8.5 3.4-16.6 9.4-22.6l90.5-90.5c6-6 14.1-9.4 22.6-9.4H320c17.7 0 32 14.3 32 32zm32 384V64c0-35.3-28.7-64-64-64H154.5c-17 0-33.3 6.7-45.3 18.7L18.7 109.3C6.7 121.3 0 137.5 0 154.5V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64zM192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80z"]
};
var faVolumeSlash = {
  prefix: 'fal',
  iconName: 'volume-slash',
  icon: [640, 512, [128263], "f2e2", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 256c0-59.6-27.2-112.9-69.8-148.1c-6.8-5.6-16.9-4.7-22.5 2.1s-4.7 16.9 2.1 22.5C521.4 161.9 544 206.3 544 256c0 28.7-7.5 55.6-20.8 78.9l25.4 20C566 326 576 292.2 576 256zM472 294.4c5.2-11.8 8-24.8 8-38.4c0-31.4-15.1-59.3-38.4-76.8c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C438 216.5 448 235.1 448 256c0 6.1-.9 12-2.4 17.6L472 294.4zM352 61.8C352 45.3 338.7 32 322.2 32c-7.3 0-14.3 2.7-19.8 7.5l-72.1 64.1 25.5 20.1L320 66.7V174.5l32 25.3V61.8zM88 192h47.6L95.1 160H88c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L302.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V362.8l-32-25.3V445.3L183.6 324c-2.9-2.6-6.7-4-10.6-4H88c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24z"]
};
var faBorderBottom = {
  prefix: 'fal',
  iconName: 'border-bottom',
  icon: [448, 512, [], "f84d", "M448 464c0 8.8-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0c8.8 0 16 7.2 16 16zM392 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 352A24 24 0 1 1 8 352a24 24 0 1 1 48 0zm144 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM440 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 160a24 24 0 1 1 48 0A24 24 0 1 1 8 160zm240 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm144 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 256A24 24 0 1 1 8 256a24 24 0 1 1 48 0zm144 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM440 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 64a24 24 0 1 1 48 0A24 24 0 1 1 8 64zm240 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm48 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm48 192a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faWifiWeak = {
  prefix: 'fal',
  iconName: 'wifi-weak',
  icon: [640, 512, ["wifi-1"], "f6aa", "M320 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faWifi1 = faWifiWeak;
var faDragon = {
  prefix: 'fal',
  iconName: 'dragon',
  icon: [640, 512, [128009], "f6d5", "M288.8 10.9C291 4.4 297.1 0 304 0H432h16 35.8c32.7 0 63.8 14.3 85 39.1l56 65.4c9.7 11.4 15.1 25.8 15.1 40.8c0 34.6-28.1 62.7-62.7 62.7H554.5c-21.2 0-41.6-8.4-56.6-23.4l-8.6-8.6H480v12c0 17.6 8.3 34.2 22.4 44.8l90.7 68C622.6 323 640 357.7 640 394.7c0 62-48 112.7-108.9 117c-1 .2-2 .3-3.1 .3h-5.3H440 48.4c-24.7 .2-45.9-18.5-48.2-43.6c-2.4-26.4 17-49.8 43.4-52.2l378.3-35-29-34.9C366.4 314.7 352 274.8 352 233.7V188.3v0l0-.3v0V153.9l-55.2-27.6c-5-2.5-8.3-7.4-8.8-12.9s1.9-10.9 6.3-14.2L341.3 64 294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9zM525.9 480c.4-.1 .8-.1 1.3-.1c45-2.3 80.8-39.6 80.8-85.2c0-26.9-12.6-52.2-34.1-68.3l-90.7-68C461 241.8 448 215.7 448 188V160c0-8.8 7.2-16 16-16h32c4.2 0 8.3 1.7 11.3 4.7l13.3 13.3c9 9 21.2 14.1 33.9 14.1h22.8c17 0 30.7-13.8 30.7-30.7c0-7.3-2.6-14.4-7.4-20l-56-65.4C529.4 42.2 507.2 32 483.8 32H448 432 352l25.6 19.2c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-43.3 32.5 40.8 20.4c5.4 2.7 8.8 8.3 8.8 14.3v44 0l0 .3v0 45.4c0 33.7 11.8 66.3 33.4 92.2L459 375.8c3.2 3.9 5 8.8 5 13.9c0 11.2-8.5 20.6-19.7 21.6L46.5 448.1c-8.8 .8-15.3 8.6-14.5 17.4c.8 8.4 7.8 14.6 16.1 14.5l.2 0v0H440h82.7 3.2zM320 199.4v34.2c0 1.4 0 2.8 0 4.3L171.7 139c-6.1-4-14.1-3.5-19.5 1.4L63 219.7l127.6-11.6c6.7-.6 13.1 3 15.9 9.1s1.6 13.3-3.2 18.1L150.6 288H327.2c3 11 6.8 21.7 11.5 32H112c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l48.8-48.8-132 12c-6.9 .6-13.4-3.2-16.1-9.6S.2 232.6 5.4 228L130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87zM495.2 57.7l32 16c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2z"]
};
var faShoePrints = {
  prefix: 'fal',
  iconName: 'shoe-prints',
  icon: [640, 512, [], "f54b", "M319.9 47c31.6-7.9 68.4-15 96.1-15c43.5 0 94.5 11 133.7 30.6c41 20.5 58.3 44.3 58.3 65.4c0 19.6-13.4 35.6-46.2 48.1C529.9 188.2 490.2 192 464 192c-39.2 0-61-12.3-88.1-27.8l-.5-.3c-22.9-13.1-49.1-28.1-87.4-33.7V55.7c8.8-2.6 19.8-5.6 31.9-8.6zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0C352.3 0 256 32 256 32v96 32h0zm-64-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V32H192c-35.3 0-64 28.7-64 64s28.7 64 64 64h32V128H192zm-.1 337c-12.1-3-23-6-31.9-8.6V381.7c38.2-5.6 64.5-20.6 87.4-33.7l.5-.3C275 332.3 296.8 320 336 320c26.2 0 65.9 3.8 97.8 15.9C466.6 348.4 480 364.4 480 384c0 21.1-17.4 44.9-58.3 65.4C382.5 469 331.5 480 288 480c-27.7 0-64.5-7.2-96.1-15zM128 352h0v32 96s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zM64 384H96V352H64c-35.3 0-64 28.7-64 64s28.7 64 64 64H96V448H64c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faCirclePlus = {
  prefix: 'fal',
  iconName: 'circle-plus',
  icon: [512, 512, ["plus-circle"], "f055", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faPlusCircle = faCirclePlus;
var faFaceGrinTongueWink = {
  prefix: 'fal',
  iconName: 'face-grin-tongue-wink',
  icon: [512, 512, [128540, "grin-tongue-wink"], "f58b", "M256 32C132.3 32 32 132.3 32 256c0 79.8 41.7 149.8 104.5 189.5c7.5 4.7 9.7 14.6 5 22.1s-14.6 9.7-22.1 5C47.7 427.3 0 347.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 91.2-47.7 171.3-119.5 216.6c-7.5 4.7-17.4 2.5-22.1-5s-2.5-17.4 5-22.1C438.3 405.8 480 335.8 480 256C480 132.3 379.7 32 256 32zm96 351.4V416c0 53-43 96-96 96s-96-43-96-96V383.3c-20.2-15.7-36.3-36.2-46.8-59.8c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7c-10.4 23.6-26.6 44.2-46.9 59.9zm-32-4.7c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64V378.6zM336 256a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM124.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zM336.4 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGrinTongueWink = faFaceGrinTongueWink;
var faHandHolding = {
  prefix: 'fal',
  iconName: 'hand-holding',
  icon: [576, 512, [], "f4bd", "M195.4 304c-15.8 0-31.2 4.7-44.4 13.4L75.2 368H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c3.2 0 6.2-.9 8.9-2.7l79.9-53.3c7.9-5.3 17.1-8.1 26.6-8.1H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H320 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 24 60.6c2.9 0 5.7-.8 8.2-2.3L511.3 355c3.4-2 7.2-3 11.1-3h1.3c11.2 0 20.3 9.1 20.3 20.3c0 6.9-3.5 13.3-9.2 17L415.1 467.1c-13 8.4-28.1 12.9-43.6 12.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H371.5c21.7 0 42.9-6.3 61-18.1l119.6-77.8C567 406.5 576 390 576 372.3c0-28.9-23.4-52.3-52.3-52.3h-1.3c-9.7 0-19.1 2.6-27.5 7.6L400.2 384h-5.6c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56H195.4z"]
};
var faPlugCircleExclamation = {
  prefix: 'fal',
  iconName: 'plug-circle-exclamation',
  icon: [576, 512, [], "e55d", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faLinkSlash = {
  prefix: 'fal',
  iconName: 'link-slash',
  icon: [640, 512, ["chain-broken", "chain-slash", "unlink"], "f127", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L492 310.3l25.3 20L591.5 256zM414.6 412.2l-33.4-26.3c-26.1 1.3-52.5-8.1-72.5-28c-14.2-14.2-23-31.7-26.4-50.1L249 281.5c-2.4 35.7 10.1 72 37.2 99.1c34.8 34.8 84.6 45.3 128.5 31.7zM331.2 154.1c14.2 14.2 23 31.7 26.4 50.1L391 230.5c2.4-35.7-10.1-72-37.2-99.1c-34.8-34.8-84.6-45.3-128.5-31.7l33.4 26.3c26.1-1.3 52.5 8.1 72.5 28zM148 201.7l-25.3-20L48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L148 201.7z"]
};
var faChainBroken = faLinkSlash;
var faChainSlash = faLinkSlash;
var faUnlink = faLinkSlash;
var faClone = {
  prefix: 'fal',
  iconName: 'clone',
  icon: [512, 512, [], "f24d", "M64 480H288c17.7 0 32-14.3 32-32V384h32v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v32H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32zM224 320H448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32zm-64-32V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"]
};
var faPersonWalkingArrowLoopLeft = {
  prefix: 'fal',
  iconName: 'person-walking-arrow-loop-left',
  icon: [640, 512, [], "e551", "M176 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 144 56a56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L240.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2L66.9 422.5 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zm334.6 90.6c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5L412.2 368l75.8 0c83.9 0 152-68.1 152-152s-68.1-152-152-152L336 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l152 0c66.3 0 120 53.7 120 120s-53.7 120-120 120l-75.8 0 62.1-51.7c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2l-96 80c-3.6 3-5.8 7.5-5.8 12.3s2.1 9.3 5.8 12.3l96 80z"]
};
var faArrowUpZA = {
  prefix: 'fal',
  iconName: 'arrow-up-z-a',
  icon: [576, 512, ["sort-alpha-up-alt"], "f882", "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h94.7L339.5 198c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H385.3L492.5 58c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1H352zm64 256c-6.1 0-11.6 3.4-14.3 8.8L337.8 424.6c-.1 .2-.2 .4-.3 .6l-15.8 31.7c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L361.9 448H470.1l11.6 23.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-15.8-31.7c-.1-.2-.2-.4-.3-.6L430.3 296.8c-2.7-5.4-8.2-8.8-14.3-8.8zM377.9 416L416 339.8 454.1 416H377.9z"]
};
var faSortAlphaUpAlt = faArrowUpZA;
var faFireFlameCurved = {
  prefix: 'fal',
  iconName: 'fire-flame-curved',
  icon: [384, 512, ["fire-alt"], "f7e4", "M53.9 186.1C19.4 220.6 0 267.4 0 316.2v11.5C0 429.5 82.5 512 184.3 512h15.1C301.4 512 384 429.4 384 327.4c0-66.1-27.1-129.2-74.9-174.8L230.9 78.2C221.4 69.1 216 56.6 216 43.4V21.3C216 9.6 206.4 0 194.7 0c-6.7 0-13 3.2-17.1 8.5l-19.5 26c-14.4 19.3-23.2 42.2-25.2 66.2l-.9 10.8c-.9 11.3-.4 22.5 1.6 33.5c2.8 15.3 8.3 29.9 16.4 43.3c.6 1.1 1.3 2.1 2 3.2c1.6 2.5 3.4 5 5.2 7.5l32 42.7c7 9.3 10.8 20.7 10.8 32.4v14c0 22.1-17.9 40-40 40s-40-17.9-40-40V200.3v-12c0-10.8-6.1-20.2-15-25c-4-2.1-8.5-3.3-13.3-3.3c-7.5 0-14.7 3-20 8.3L53.9 186.1zM184.5 52.6c2.1 18.5 10.7 35.8 24.3 48.7L287 175.8c41.5 39.5 65 94.3 65 151.6C352 411.7 283.7 480 199.4 480H184.3C100.2 480 32 411.8 32 327.7V316.2c0-40.3 16-79 44.5-107.5L88 197.3V288c0 39.8 32.2 72 72 72s72-32.2 72-72V274c0-18.6-6-36.7-17.2-51.6l-32-42.7c-14.1-18.8-20.8-42.1-18.9-65.6l.9-10.8c1.5-18 8-35.2 18.9-49.6l.8-1.1zm18.7-24.9l0 0-8.5-6.4 8.5 6.4s0 0 0 0z"]
};
var faFireAlt = faFireFlameCurved;
var faTornado = {
  prefix: 'fal',
  iconName: 'tornado',
  icon: [448, 512, [127786], "f76f", "M352 122.6c0 13.9 4.5 27.4 12.8 38.5L418 232c19.4 25.9 30 57.5 30 89.9c0 39.7-15.8 77.8-43.9 105.9l-78.2 78.2c-3.8 3.8-8.9 5.9-14.2 5.9c-12.4 0-21.8-11.1-19.8-23.4l5.9-35.7c4-24 .3-48.7-10.6-70.5c-10-19.9-25.5-36.5-44.6-47.8L126.2 266.2C48 220.2 0 136.3 0 45.6V32C0 14.3 14.3 0 32 0H393.4C405.9 0 416 10.1 416 22.6c0 6-2.4 11.8-6.6 16L370.8 77.2c-12 12-18.8 28.4-18.8 45.4zM32 45.6c0 28.7 5.5 56.6 15.7 82.4H320.2c-.1-1.8-.2-3.6-.2-5.4c0-25.5 10.1-50 28.2-68L370.7 32H32V45.6zM142.4 238.7L200 272.5V272H404.9c-3.4-7.3-7.6-14.2-12.5-20.8l-53.2-70.9c-4.7-6.3-8.6-13.1-11.7-20.3H63.4c19 31.9 45.9 59.2 79 78.7zM253.5 304l5.3 3.1c24.5 14.4 44.3 35.6 57 61c13.8 27.5 18.5 58.6 13.7 89l51.9-51.9c22.1-22.1 34.5-52.1 34.5-83.3c0-6-.5-12-1.4-17.9H253.5z"]
};
var faFileCirclePlus = {
  prefix: 'fal',
  iconName: 'file-circle-plus',
  icon: [576, 512, [58606], "e494", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDeleteRight = {
  prefix: 'fal',
  iconName: 'delete-right',
  icon: [576, 512, [], "e154", "M32 128c0-17.7 14.3-32 32-32H370.7c8.5 0 16.6 3.4 22.6 9.4L544 256 393.4 406.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V128zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H370.7c17 0 33.3-6.7 45.3-18.7L566.6 278.6c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6L416 82.7C404 70.7 387.7 64 370.7 64H64zm84.7 116.7c-6.2 6.2-6.2 16.4 0 22.6L201.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L246.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faBookQuran = {
  prefix: 'fal',
  iconName: 'book-quran',
  icon: [448, 512, ["quran"], "f687", "M384 0c35.3 0 64 28.7 64 64l0 384 0 0c0 35.3-28.7 64-64 64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V413.3C13.4 406.7 0 388.9 0 368V48C0 21.5 21.5 0 48 0H384zM64 416v64H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm320-32c11.7 0 22.6 3.1 32 8.6L416 64c0-17.7-14.3-32-32-32H48c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H384zM298.1 166.2c2.2-5.3 9.6-5.3 11.8 0l8.9 21.4 23.1 1.9c5.7 .5 8 7.5 3.7 11.2L328 215.8l5.4 22.6c1.3 5.5-4.7 9.9-9.6 6.9L304 233.2l-19.8 12.1c-4.9 3-10.9-1.4-9.6-6.9l5.4-22.6-17.6-15.1c-4.3-3.7-2-10.8 3.7-11.2l23.1-1.9 8.9-21.4zM126.4 208c0 62.7 50.9 113.6 113.6 113.6c11.7 0 23-1.8 33.6-5c-53.3-5.9-98.3-51.6-98.3-108.6s45-102.6 98.3-108.6c-10.6-3.3-21.9-5-33.6-5c-62.7 0-113.6 50.9-113.6 113.6zM240 65.6c28.5 0 55 8.4 77.3 22.8c10.5 6.8 11.8 18.8 8.4 27.2s-12.8 16-25 13.6c-48.6-9.9-96.6 28.8-96.6 78.8s48 88.7 96.6 78.8c12.3-2.5 21.6 5.2 25 13.6s2.1 20.4-8.4 27.2C295 342 268.5 350.4 240 350.4c-78.6 0-142.4-63.8-142.4-142.4s63.8-142.4 142.4-142.4z"]
};
var faQuran = faBookQuran;
var faCircleQuarter = {
  prefix: 'fal',
  iconName: 'circle-quarter',
  icon: [512, 512, [], "e11f", "M224 34.3V224L34.3 224C48.3 125.9 125.9 48.3 224 34.3zM2 224.1C-.2 241.6 14.3 256 32 256l192 0c17.7 0 32-14.3 32-32V32c0-17.7-14.4-32.2-31.9-30C108.2 16.4 16.4 108.2 2 224.1z"]
};
var faAnchor = {
  prefix: 'fal',
  iconName: 'anchor',
  icon: [576, 512, [9875], "f13d", "M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V480H240c-79.5 0-144-64.5-144-144V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h48 48c97.2 0 176-78.8 176-176V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V336c0 79.5-64.5 144-144 144H304V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80z"]
};
var faBorderAll = {
  prefix: 'fal',
  iconName: 'border-all',
  icon: [448, 512, [], "f84c", "M384 64c17.7 0 32 14.3 32 32V240H240V64H384zm32 208V416c0 17.7-14.3 32-32 32H240V272H416zM208 240H32V96c0-17.7 14.3-32 32-32H208V240zM32 272H208V448H64c-17.7 0-32-14.3-32-32V272zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faFunction = {
  prefix: 'fal',
  iconName: 'function',
  icon: [640, 512, [], "f661", "M80 80c0-44.2 35.8-80 80-80h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-26.5 0-48 21.5-48 48V192h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112V398.1c0 41.1-31.1 75.5-72 79.6l-22.4 2.2C8.8 480.8 1 474.4 .1 465.6s5.5-16.6 14.3-17.5l22.4-2.2C61.3 443.4 80 422.7 80 398.1V224H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H80V80zm221.5 80.5C272.8 206.1 256 260.9 256 320s16.8 113.9 45.5 159.5c4.7 7.5 2.5 17.4-5 22.1s-17.4 2.5-22.1-5C242.5 445.9 224 385.2 224 320s18.5-125.9 50.5-176.5c4.7-7.5 14.6-9.7 22.1-5s9.7 14.6 5 22.1zm260.9 0c-4.7-7.5-2.5-17.4 5-22.1s17.4-2.5 22.1 5C621.5 194.1 640 254.8 640 320s-18.5 125.9-50.5 176.5c-4.7 7.5-14.6 9.7-22.1 5s-9.7-14.6-5-22.1C591.2 433.9 608 379.1 608 320s-16.8-113.9-45.5-159.5zM379.3 244.7L432 297.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 320l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faFaceAngry = {
  prefix: 'fal',
  iconName: 'face-angry',
  icon: [512, 512, [128544, "angry"], "f556", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm82.7-116.1c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 264c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faAngry = faFaceAngry;
var faPeopleSimple = {
  prefix: 'fal',
  iconName: 'people-simple',
  icon: [512, 512, [], "e21b", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320h84.9c18.7 0 33.4-16 31.9-34.7L198.2 236c-2.1-24.9-22.9-44-47.8-44H105.6c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM416 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm17.5 151.2L298.4 352H469.6L430.5 215.2C426.6 201.5 414 192 399.7 192H368.3c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H352V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H298.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"]
};
var faCookieBite = {
  prefix: 'fal',
  iconName: 'cookie-bite',
  icon: [512, 512, [], "f564", "M182.8 28.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4zm46.3 19.7c15 58.3 62 103.6 121.2 116.4c15.6 54.1 59 96.4 113.7 110.5c0 11.2-2.5 22.3-7.5 32.5L419.8 383c-6.8 14.1-17.9 25.6-31.7 32.9l-74 39.5c-13.7 7.3-29.4 10.1-44.8 7.9l-83-11.7c-15.4-2.2-29.7-9.2-40.9-20L85.1 373.2c-11.2-10.9-18.7-25-21.4-40.4L49.1 250c-2.7-15.4-.5-31.3 6.4-45.4L92.2 129c6.8-14.1 17.9-25.6 31.7-32.9l74-39.5c9.7-5.2 20.4-8.1 31.2-8.6zM184 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowTrendDown = {
  prefix: 'fal',
  iconName: 'arrow-trend-down',
  icon: [576, 512, [], "e097", "M368 400c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16s-16 7.2-16 16V361.4L331.3 148.7c-6.2-6.2-16.4-6.2-22.6 0L192 265.4 27.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0L320 182.6 521.4 384H384c-8.8 0-16 7.2-16 16z"]
};
var faRss = {
  prefix: 'fal',
  iconName: 'rss',
  icon: [448, 512, ["feed"], "f09e", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16c220.9 0 400 179.1 400 400c0 8.8 7.2 16 16 16s16-7.2 16-16C448 225.4 254.6 32 16 32zm0 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c141.4 0 256 114.6 256 256c0 8.8 7.2 16 16 16s16-7.2 16-16c0-159.1-128.9-288-288-288zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z"]
};
var faFeed = faRss;
var faFaceMonocle = {
  prefix: 'fal',
  iconName: 'face-monocle',
  icon: [512, 512, [], "e380", "M448 371.4V224c0-8.8-7.2-16-16-16c-.9 0-1.8 .1-2.7 .2c-10.7-46-52-80.2-101.3-80.2c-57.4 0-104 46.6-104 104s46.6 104 104 104c37.1 0 69.6-19.4 88-48.5V393.9c0 5.9 .4 11.8 1.2 17.6C376.5 453.7 319.3 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 42.2-11.7 81.7-32 115.4zm3.9 49.4C489.4 376.3 512 318.8 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c65.8 0 125.9-24.8 171.2-65.7c10.2 22.8 27.1 42.5 48.9 56.1l11.4 7.1c7.5 4.7 17.4 2.4 22-5.1s2.4-17.4-5.1-22l-11.4-7.1c-20.2-12.6-34.7-32.2-41.3-54.5zM176.4 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM328 160a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM160 352c0 8.8 7.2 16 16 16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59C221.3 339.5 193.7 336 176 336c-8.8 0-16 7.2-16 16zM305.2 105.9c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L376.3 77c-12.7-8.5-27.6-13-42.8-13c-17.5 0-34.5 6-48.2 16.9L262 99.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6z"]
};
var faDrawPolygon = {
  prefix: 'fal',
  iconName: 'draw-polygon',
  icon: [448, 512, [], "f5ee", "M96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0zM80 158V354c22.5 5.8 40.2 23.5 46 46H322c2.9-11.1 8.6-21 16.4-28.9l-32.2-53.7c-5.8 1.7-11.9 2.6-18.2 2.6c-35.3 0-64-28.7-64-64s28.7-64 64-64c6.3 0 12.4 .9 18.2 2.6l32.2-53.7c-7.8-7.9-13.5-17.8-16.4-28.9H126c-5.8 22.5-23.5 40.2-46 46zM365.8 354.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64s-28.7 64-64 64c-29.8 0-54.9-20.4-62-48H126c-7.1 27.6-32.2 48-62 48c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V158C20.4 150.9 0 125.8 0 96C0 60.7 28.7 32 64 32c29.8 0 54.9 20.4 62 48H322c7.1-27.6 32.2-48 62-48c35.3 0 64 28.7 64 64s-28.7 64-64 64c-6.3 0-12.4-.9-18.2-2.6l-32.2 53.7C345 222.6 352 238.5 352 256s-7 33.4-18.4 44.9l32.2 53.7zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM352 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faScaleBalanced = {
  prefix: 'fal',
  iconName: 'scale-balanced',
  icon: [640, 512, [9878, "balance-scale"], "f24e", "M384 64c0 29.8-20.4 54.9-48 62V480H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 112c-8.8 0-16-7.2-16-16s7.2-16 16-16H304V126c-27.6-7.1-48-32.2-48-62H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H264.6C275.6 12.9 296.3 0 320 0s44.4 12.9 55.4 32H512c8.8 0 16 7.2 16 16s-7.2 16-16 16H384zm56.7 298.3C457.8 375.1 482.9 384 512 384s54.2-8.9 71.3-21.7C600.4 349.5 608 334.2 608 320H416v-1.6l0 .1V320c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 288H597.7L512 147.3zM384 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96s-128-43-128-96zM32 320c0 14.2 7.6 29.5 24.7 42.3C73.8 375.1 98.9 384 128 384s54.2-8.9 71.3-21.7C216.4 349.5 224 334.2 224 320H32v-1.6l0 .1V320zm10.3-32H213.7L128 147.3 42.3 288zM128 416C57.3 416 0 373 0 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBalanceScale = faScaleBalanced;
var faCalendarLines = {
  prefix: 'fal',
  iconName: 'calendar-lines',
  icon: [448, 512, ["calendar-note"], "e0d5", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H32V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32zM96 368c0-8.8 7.2-16 16-16H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm16-112H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCalendarNote = faCalendarLines;
var faArrowDownBigSmall = {
  prefix: 'fal',
  iconName: 'arrow-down-big-small',
  icon: [576, 512, ["sort-size-down"], "f88c", "M171.3 475.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V425.4L75.3 356.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM352 432V368c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm-32 0c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v64zM352 80c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16V208c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80zm-32 0V208c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
};
var faSortSizeDown = faArrowDownBigSmall;
var faGaugeSimpleHigh = {
  prefix: 'fal',
  iconName: 'gauge-simple-high',
  icon: [512, 512, [61668, "tachometer", "tachometer-fast"], "f62a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-18.6-7.9-35.3-20.5-47l82.6-153.4c4.2-7.8 1.3-17.5-6.5-21.7s-17.5-1.3-21.7 6.5L271.3 289.8c-4.9-1.2-10-1.8-15.3-1.8c-35.3 0-64 28.7-64 64s28.7 64 64 64z"]
};
var faTachometer = faGaugeSimpleHigh;
var faTachometerFast = faGaugeSimpleHigh;
var faDoNotEnter = {
  prefix: 'fal',
  iconName: 'do-not-enter',
  icon: [512, 512, [], "f5ec", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm112-16v32c0 4.4 3.6 8 8 8H392c4.4 0 8-3.6 8-8V240c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8zm-32 0c0-22.1 17.9-40 40-40H392c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40H120c-22.1 0-40-17.9-40-40V240z"]
};
var faShower = {
  prefix: 'fal',
  iconName: 'shower',
  icon: [512, 512, [128703], "f2cc", "M32 115.9C32 87.2 55.2 64 83.9 64c13.8 0 27 5.5 36.7 15.2l28.1 28.1c.5 .5 1.1 1 1.7 1.5c-33 43.9-29.5 106.5 10.4 146.4l4.7 4.7-16.8 16.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16.8 16.8-4.7-4.7C279.3 56.9 216.7 53.4 172.8 86.4c-.4-.6-.9-1.2-1.5-1.7L143.2 56.6C127.5 40.8 106.1 32 83.9 32C37.6 32 0 69.6 0 115.9V464c0 8.8 7.2 16 16 16s16-7.2 16-16V115.9zm151.4 3.5c31.2-31.2 81.9-31.2 113.1 0l4.7 4.7L188.1 237.3l-4.7-4.7c-31.2-31.2-31.2-81.9 0-113.1zM416 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM424 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faDiceD8 = {
  prefix: 'fal',
  iconName: 'dice-d8',
  icon: [512, 512, [], "f6d2", "M240 51.3L44.3 247.1l195.7 81V51.3zM72.8 293.5L240 460.7v-98L72.8 293.5zM272 460.7L439.2 293.5 272 362.7v98zM467.8 247.1L272 51.3V328.1l195.8-81zM239 7c9.4-9.4 24.6-9.4 33.9 0L505 239c9.4 9.4 9.4 24.6 0 33.9L273 505c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L239 7z"]
};
var faDesktop = {
  prefix: 'fal',
  iconName: 'desktop',
  icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 32H64C46.3 32 32 46.3 32 64V256H544V64c0-17.7-14.3-32-32-32zm64 224v32 64c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H360 216 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64H64c-35.3 0-64-28.7-64-64V288 256 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V256zM32 288v64c0 17.7 14.3 32 32 32H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H512c17.7 0 32-14.3 32-32V288H32zM234.9 480H341.1l-10.7-64H245.6l-10.7 64z"]
};
var faDesktopAlt = faDesktop;
var faM = {
  prefix: 'fal',
  iconName: 'm',
  icon: [448, 512, [109], "4d", "M11.3 32.7c6.7-2.1 14 .5 17.9 6.3L224 323.7 418.8 39c4-5.8 11.2-8.3 17.9-6.3S448 41 448 48V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V99.7L237.2 361c-3 4.4-7.9 7-13.2 7s-10.2-2.6-13.2-7L32 99.7V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-7 4.6-13.2 11.3-15.3z"]
};
var faGripDotsVertical = {
  prefix: 'fal',
  iconName: 'grip-dots-vertical',
  icon: [256, 512, [], "e411", "M64 96A16 16 0 1 0 32 96a16 16 0 1 0 32 0zM0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zM48 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faFaceViewfinder = {
  prefix: 'fal',
  iconName: 'face-viewfinder',
  icon: [512, 512, [], "e2ff", "M48 0C21.5 0 0 21.5 0 48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8 7.2-16 16-16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zM464 0H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-26.5-21.5-48-48-48zM0 464c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v96zm464 48c26.5 0 48-21.5 48-48V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h96zM240 216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM214.4 280c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c13.8 23.9 39.7 40 69.3 40s55.5-16.1 69.3-40c4.4-7.6 1.8-17.4-5.8-21.9s-17.4-1.8-21.9 5.8c-8.3 14.4-23.8 24-41.6 24s-33.3-9.6-41.6-24z"]
};
var faSoftServe = {
  prefix: 'fal',
  iconName: 'soft-serve',
  icon: [384, 512, [127846, "creemee"], "e400", "M192 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7H116c-37.6 0-68 30.4-68 68c0 11.5 2.8 22.2 7.8 31.7C23.5 174 0 204.2 0 240c0 32.8 19.7 61 48 73.3V352c0 22.2 15.1 41 35.7 46.4L92.6 470c3 24 23.4 42 47.6 42H243.8c24.2 0 44.6-18 47.6-42l8.9-71.6C320.9 393 336 374.2 336 352V313.3c28.3-12.3 48-40.5 48-73.3c0-37.2-25.4-68.5-59.8-77.4c7.5-12.1 11.8-26.3 11.8-41.6C336 54.2 281.8 0 215 0H192zM304 288H80c-26.5 0-48-21.5-48-48s21.5-48 48-48h8.3H112c8.8 0 16-7.2 16-16s-7.2-16-16-16H93.4C85.2 153.4 80 143.3 80 132c0-19.9 16.1-36 36-36h61.3C203.1 96 224 75.1 224 49.3c0-5.9-1.1-11.7-3.2-17.1c46.5 3 83.2 41.6 83.2 88.8c0 16.2-8.2 30.5-20.8 39H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h47.7 .3 16c26.5 0 48 21.5 48 48s-21.5 48-48 48zM80 320H304v32c0 8.8-7.2 16-16 16h-2c-8.1 0-14.9 6-15.9 14l-10.5 84c-1 8-7.8 14-15.9 14H140.2c-8.1 0-14.9-6-15.9-14l-10.5-84c-1-8-7.8-14-15.9-14H96c-8.8 0-16-7.2-16-16V320z"]
};
var faCreemee = faSoftServe;
var faH5 = {
  prefix: 'fal',
  iconName: 'h5',
  icon: [640, 512, [], "e412", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM432 64c-7.6 0-14.2 5.4-15.7 12.9l-32 160c-.9 4.7 .3 9.6 3.3 13.3s7.6 5.9 12.4 5.9H528c44.2 0 80 35.8 80 80s-35.8 80-80 80H456.4c-17.2 0-32.5-11-37.9-27.4l-3.2-9.7c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l3.2 9.7c9.8 29.4 37.3 49.2 68.3 49.2H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H419.5L445.1 96H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"]
};
var faHandBackPointDown = {
  prefix: 'fal',
  iconName: 'hand-back-point-down',
  icon: [448, 512, [], "e19e", "M136 512c-30.9 0-56-25.1-56-56V255.4c-3.2-2-6.4-4.2-9.5-6.5L48 232c-20.1-15.1-32-38.8-32-64V148.5c0-53 29.1-101.7 75.7-126.8l8.3-4.5C121 5.9 144.4 0 168.3 0H304c61.9 0 112 50.1 112 112v8 88c0 35.3-28.7 64-64 64c-2.8 0-5.6-.2-8.3-.5c-11 19.4-31.8 32.5-55.7 32.5c-5.3 0-10.5-.7-15.5-1.9c-10.8 20.2-32 33.9-56.5 33.9c-8.5 0-16.6-1.7-24-4.7V456c0 30.9-25.1 56-56 56zm-24-56c0 13.3 10.7 24 24 24s24-10.7 24-24V298.5c0-7.1 4.6-13.3 11.4-15.3s14 .6 18 6.5c5.8 8.7 15.6 14.3 26.7 14.3c15.6 0 28.6-11.2 31.4-25.9c1-5.1 4.4-9.5 9.2-11.6s10.3-1.8 14.8 .9c4.8 2.9 10.5 4.6 16.6 4.6c14.7 0 27.2-10 30.9-23.6c1.2-4.4 4.2-8.1 8.3-10.1s8.8-2.2 13.1-.6c3.6 1.4 7.6 2.2 11.8 2.2c17.7 0 32-14.3 32-32V120v-8c0-44.2-35.8-80-80-80H168.3c-18.5 0-36.8 4.6-53.1 13.4l-7.6-14.1 7.6 14.1-8.3 4.5C70.6 69.4 48 107.3 48 148.5V168c0 15.1 7.1 29.3 19.2 38.4L80 216V168c0-8.8 7.2-16 16-16s16 7.2 16 16v78.3V248 456z"]
};
var faTableList = {
  prefix: 'fal',
  iconName: 'table-list',
  icon: [512, 512, ["th-list"], "f00b", "M192 64v96H480V96c0-17.7-14.3-32-32-32H192zm-32 0H64C46.3 64 32 78.3 32 96v64H160V64zM32 192V320H160V192H32zm0 160v64c0 17.7 14.3 32 32 32h96V352H32zm160 96H448c17.7 0 32-14.3 32-32V352H192v96zM480 320V192H192V320H480zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faThList = faTableList;
var faCommentSms = {
  prefix: 'fal',
  iconName: 'comment-sms',
  icon: [512, 512, ["sms"], "f7cd", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM202.9 176.8C196.4 179 192 185.1 192 192v96c0 8.8 7.2 16 16 16s16-7.2 16-16V240l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 240v48c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 229.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6zm-90.9 38c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.6 .1 16.7 1.6 23.3 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4c-9.3-.1-20.4 1.9-29.7 7.4C88.6 189.3 80 199.8 80 215c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7.2-.2-14.2-2.6-23.7-5.8l0 0 0 0 0 0c-1.3-.4-2.7-.9-4.1-1.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1 .4 2.4 .8 3.6 1.2l0 0 0 0c9 3.1 20.9 7.2 33.2 7.6c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4zm256 0c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.1 .1 12.9 1.4 20.1 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4c-9.3-.1-20.3 1.9-29.7 7.4c-9.9 5.9-18.6 16.4-18.5 31.6c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7-.2-13.5-2.4-22.6-5.5l0 0 0 0 0 0c-1.5-.5-3.2-1.1-4.9-1.6c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.2 .4 2.6 .9 4 1.4l0 0c8.8 3 20.4 7 32.6 7.4c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4z"]
};
var faSms = faCommentSms;
var faRectangle = {
  prefix: 'fal',
  iconName: 'rectangle',
  icon: [512, 512, [9644, "rectangle-landscape"], "f2fa", "M448 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H448zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"]
};
var faRectangleLandscape = faRectangle;
var faClipboardListCheck = {
  prefix: 'fal',
  iconName: 'clipboard-list-check',
  icon: [384, 512, [], "f737", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM171.3 235.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 249.4 99.3 236.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48zM192 272c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm-32 96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-48 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faTurkey = {
  prefix: 'fal',
  iconName: 'turkey',
  icon: [640, 512, [], "f725", "M496 64c0-17.7 14.3-32 32-32s32 14.3 32 32c0 2.7-.3 5.4-1 7.9c-1.3 5.2-.5 11.1 2.9 16c3.7 5.2 9.4 8 15.2 8.2c17.1 .6 30.9 14.7 30.9 32c0 17.7-14.3 32-32 32c-6 0-12.6-.6-20.3-1.5l-3.9-.5c-6.3-.7-13.2-1.5-19.9-2c-15.9-1-35.4-.4-51.5 11l-41.6 29.3c-18.8 13.2-30.5 32-39.1 50.6c-5.3 11.3-10 24.3-14.4 36.2c-2.5 6.7-4.8 13.1-7.1 18.8c-4.9 12.2-12.9 23.3-23.9 32.2C320 362 269.6 356.7 241.8 322.3S219.3 237.6 253.7 209.8c17.2-13.9 38.3-19.5 58.7-17.4c14.5 1.5 31.2 3.1 47.6 2c16.5-1.2 33.7-5.3 48.9-16l63.6-44.9c12.8-9 18.4-22.7 20.9-34.8C495.9 86.7 496 73.8 496 64zM528 0c-35.3 0-64 28.7-64 64c0 10.1-.2 19.7-1.9 28.1c-1.8 8.3-4.6 12.9-8.1 15.3l-40.3 28.4C370.6 110.5 325.7 96 288 96C176 96 0 224 0 384C0 512 160 512 288 512s288 0 288-128c0-60.3-25-116.1-62.2-162.2l-26.2 18.5C522 282.3 544 332 544 384c0 24.6-7.4 40.5-18.3 52c-11.6 12.3-29.6 22.1-54.5 29.2C420.4 479.7 353.4 480 288 480s-132.4-.3-183.2-14.8c-24.9-7.1-42.9-16.9-54.5-29.2C39.4 424.5 32 408.6 32 384c0-68 37.6-132 91.4-180.2C177.6 155.2 242.3 128 288 128c27.3 0 61.5 9.7 96.1 28c-7.6 3.8-16.4 5.8-26.5 6.5c-13.1 .9-27.2-.3-41.9-1.9c-28.5-3-58.2 4.9-82.2 24.3c-48.1 38.9-55.5 109.4-16.6 157.5s109.4 55.5 157.5 16.6c15.3-12.4 26.5-28 33.4-45.1c3.1-7.7 5.7-14.9 8.3-21.9l0 0c4-10.8 7.7-21.1 12.6-31.6c7.6-16.4 16.3-29.3 28.5-37.9l41.6-29.3c6.7-4.7 16.5-6.2 31-5.2c5.8 .4 11.7 1.1 18 1.8l4.3 .5c7.6 .9 15.9 1.7 23.9 1.7c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62c0-.7 0-1.3 0-2c0-35.3-28.7-64-64-64z"]
};
var faBook = {
  prefix: 'fal',
  iconName: 'book',
  icon: [448, 512, [128212], "f02d", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V413.3c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zM384 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H384zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H96V384H64zm64 0V32H400c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H128zm48-240c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"]
};
var faUserPlus = {
  prefix: 'fal',
  iconName: 'user-plus',
  icon: [640, 512, [], "f234", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zM512 304c0 8.8 7.2 16 16 16s16-7.2 16-16V224h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H544V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faIceSkate = {
  prefix: 'fal',
  iconName: 'ice-skate',
  icon: [576, 512, [9976], "f7ac", "M320 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v7.4l-4.1 1.1L67.6 82.2C46.6 87.8 32 106.8 32 128.6V336c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V306c0-36.7-25-68.7-60.6-77.6L320 195.5V144 16zM75.9 113.1L288 56.6V128H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h62l141.6 35.4C465 264.7 480 283.9 480 306v30c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V128.6c0-7.2 4.9-13.6 11.9-15.5zM128 432V416H96v16 48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96H400h96c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 26.5-21.5 48-48 48H416V432 416H384v16 48H128V432z"]
};
var faCheck = {
  prefix: 'fal',
  iconName: 'check',
  icon: [448, 512, [10003, 10004], "f00c", "M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faBatteryThreeQuarters = {
  prefix: 'fal',
  iconName: 'battery-three-quarters',
  icon: [576, 512, ["battery-4"], "f241", "M432 128c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H432zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM112 192H304c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM64 208v96c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z"]
};
var faBattery4 = faBatteryThreeQuarters;
var faTomato = {
  prefix: 'fal',
  iconName: 'tomato',
  icon: [512, 512, [], "e330", "M235.3 4.7L224 16C235.3 4.7 235.3 4.7 235.3 4.7l0 0 0 0 .1 .1 .2 .2 .4 .5c.4 .4 .8 .9 1.4 1.5c1.1 1.3 2.6 3.1 4.4 5.4c3.5 4.7 8 11.5 12.5 20.4c6 12 11.9 27.8 15.1 47.4c52.9 1.7 102.9 13.6 145.6 35.3c13.2 6.7 20.1 21.6 16.6 36s-16.3 24.5-31.1 24.5h-4.8c6.7 11.5 5.5 26.1-3.1 36.5c-9.1 10.9-24.2 14.5-37.2 8.9L256 178.8l-99.4 42.6c-13 5.6-28.2 1.9-37.2-8.9c-8.7-10.5-9.8-25.2-2.9-36.8l-.2 0c-13.3 2-26.9-4.5-33.4-17.1c-8-15.8-1.7-35 14-43l0 0 .8-.4 0 0c41-20.6 88.6-32.3 139.1-34.6c-2.8-13.8-7.1-24.9-11.3-33.3c-3.5-7-7-12.2-9.5-15.6c-1.2-1.7-2.2-2.8-2.9-3.6c-.3-.4-.5-.6-.6-.7l-.1-.1c-6.2-6.3-6.1-16.3 .1-22.5c6.2-6.2 16.4-6.2 22.6 0zM240 112.3c-47.2 2-90.9 12.7-127.7 31.3l0 0-.8 .4 0 0 0 0c1.2-.3 2.4-.4 3.6-.4l31.3 .2c5.9 0 11.3 3.3 14 8.5s2.4 11.5-.8 16.4L144 192l105.7-45.3c4-1.7 8.6-1.7 12.6 0L368 192l-15.4-23.1c-3.3-4.9-3.6-11.2-.8-16.4s8.2-8.5 14.1-8.5h34.6c-37-18.8-81-29.7-128.5-31.7c-.2 8.7-7.3 15.7-16 15.7s-15.8-7-16-15.7zM73.4 195.4C47.3 223.5 32 259.8 32 304c0 55 23.6 97.8 62.5 127.7C134.1 462.2 190.8 480 256 480s121.9-17.8 161.5-48.3C456.4 401.8 480 359 480 304c0-44.2-15.3-80.5-41.4-108.6c8.7-6.4 15.7-15 20.3-25.1C492.2 204.5 512 249.6 512 304c0 130.9-114.6 208-256 208S0 434.9 0 304c0-54.4 19.8-99.6 53.1-133.7c.4 .9 .8 1.8 1.3 2.7c4.7 9.2 11.2 16.7 18.9 22.4z"]
};
var faSwordLaser = {
  prefix: 'fal',
  iconName: 'sword-laser',
  icon: [512, 512, [], "e03b", "M503.8 57.1l-210 232.7-22.7-22.7L480 35.7V32l-3.7 0L244.8 240.9l-22.7-22.7L454.9 8.2C460.7 2.9 468.4 0 476.3 0H480c17.7 0 32 14.3 32 32v3.7c0 7.9-2.9 15.6-8.2 21.4zM187.3 228.7l16 16 64 64 0 0 0 0 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7-57.9 57.9c1.2 2.3 1.9 4.9 1.9 7.5c0 4.2-1.7 8.3-4.7 11.3L118.6 496c-10.2 10.2-24.1 16-38.6 16s-28.4-5.8-38.6-16L16 470.6C5.8 460.4 0 446.5 0 432s5.8-28.4 16-38.6l76.7-76.7c5.1-5.1 12.8-6 18.8-2.8L169.4 256l-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM152 318.6L134.6 336 176 377.4 193.4 360 152 318.6zM174.6 296L216 337.4 233.4 320 192 278.6 174.6 296zM38.6 416c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16L64 473.4c4.2 4.2 10 6.6 16 6.6s11.8-2.4 16-6.6L161.4 408 104 350.6 38.6 416z"]
};
var faHouseCircleCheck = {
  prefix: 'fal',
  iconName: 'house-circle-check',
  icon: [640, 512, [], "e509", "M277.4 4c6-5.3 15.1-5.3 21.2 0L512.5 192.8c-5.4-.5-10.9-.8-16.5-.8c-10.2 0-20.2 .9-29.9 2.5L288 37.3 96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c1 0 2.1 .1 3.1 .1c-5.1 10.1-9.3 20.7-12.5 31.9H240V480h16 80 24.2c10 12.1 21.7 22.9 34.6 32H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faBuildings = {
  prefix: 'fal',
  iconName: 'buildings',
  icon: [512, 512, [], "e0cc", "M448 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448zM288 0c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H288zM192 128H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H216.4c-8.3-9.2-14.8-20.1-19-32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H192V128zM88 320c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H88zm8 64V352h32v32H96zm224 8c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24v48zm32-8V352h32v32H352zM88 192c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H88zm8 64V224h32v32H96zM320 88v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24zm32 8h32v32H352V96zm-8 192h48c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24zm8-64h32v32H352V224z"]
};
var faAngleLeft = {
  prefix: 'fal',
  iconName: 'angle-left',
  icon: [320, 512, [8249], "f104", "M52.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 256 235.3 404.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-160-160z"]
};
var faCartFlatbedBoxes = {
  prefix: 'fal',
  iconName: 'cart-flatbed-boxes',
  icon: [640, 512, ["dolly-flatbed-alt"], "f475", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H80c8.8 0 16 7.2 16 16V368c0 26.5 21.5 48 48 48h24.6c-5.4 9.4-8.6 20.3-8.6 32c0 35.3 28.7 64 64 64s64-28.7 64-64c0-11.7-3.1-22.6-8.6-32H456.6c-5.4 9.4-8.6 20.3-8.6 32c0 35.3 28.7 64 64 64s64-28.7 64-64c0-11.7-3.1-22.6-8.6-32H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H512 224 144c-8.8 0-16-7.2-16-16V48c0-26.5-21.5-48-48-48H16zM544 448a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-416H352V288H224l0-224zm-32 0V288c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zm320 0v64H448V64h64zM448 32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H448zm0 192H576v64H448V224zm-32 0v64c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32z"]
};
var faDollyFlatbedAlt = faCartFlatbedBoxes;
var faDiagramSuccessor = {
  prefix: 'fal',
  iconName: 'diagram-successor',
  icon: [512, 512, [], "e47a", "M480 352c0-17.7-14.3-32-32-32L64 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64zm32 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64zM256 96c0-17.7-14.3-32-32-32l-32 0L64 64C46.3 64 32 78.3 32 96l0 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-64zm23.4-32c5.4 9.4 8.6 20.3 8.6 32l0 64c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0 32 0 144 0c35.3 0 64 28.7 64 64l0 89.4 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L400 185.4 400 96c0-17.7-14.3-32-32-32l-88.6 0zM96 368l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 400c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTruckArrowRight = {
  prefix: 'fal',
  iconName: 'truck-arrow-right',
  icon: [640, 512, [], "e58b", "M352 32c17.7 0 32 14.3 32 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352zM481.3 128c4.7 0 9.1 2 12.1 5.6L570.9 224H416V128h65.3zM416 344.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM235.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265.4 160H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H265.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"]
};
var faSquareW = {
  prefix: 'fal',
  iconName: 'square-w',
  icon: [448, 512, [], "e285", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm103.1 58.8l56.3 162.6 49.4-154.2c2.1-6.6 8.3-11.1 15.2-11.1s13.1 4.5 15.2 11.1l49.4 154.2 56.3-162.6c2.9-8.4 12-12.8 20.4-9.9s12.8 12 9.9 20.4l-72 208c-2.3 6.5-8.4 10.8-15.3 10.8s-13-4.6-15.1-11.1L224 220.5 175.2 372.9c-2.1 6.6-8.2 11-15.1 11.1s-13.1-4.3-15.3-10.8l-72-208c-2.9-8.4 1.5-17.5 9.9-20.4s17.5 1.5 20.4 9.9z"]
};
var faArrowsSplitUpAndLeft = {
  prefix: 'fal',
  iconName: 'arrows-split-up-and-left',
  icon: [512, 512, [], "e4bc", "M235.3 123.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 54.6V384v16c0 44.2 35.8 80 80 80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H416c-61.9 0-112-50.1-112-112V384c0-44.2-35.8-80-80-80H54.6l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 272H224c31.3 0 59.7 12.9 80 33.6V54.6l-68.7 68.7z"]
};
var faLamp = {
  prefix: 'fal',
  iconName: 'lamp',
  icon: [448, 512, [], "f4ca", "M112 32L32 224H416L336 32 112 32zM82.5 19.7C87.4 7.8 99.1 0 112 0H336c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1s-15.9 14.2-26.6 14.2H32c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1l80-192zM160 312.2V288h32v24.2c0 14.8-6.7 27.8-16.5 36.6c-6.8 6.1-19.3 18.4-29.8 34.1C135 398.9 128 415.8 128 432c0 17.1 5.8 31.8 12.1 42.6c1 1.7 4.8 5.4 14.4 5.4h139c9.7 0 13.5-3.7 14.4-5.4c6.3-10.8 12.1-25.5 12.1-42.6c0-16.2-7-33.1-17.7-49.1c-10.5-15.7-23-28-29.8-34.1c-9.8-8.8-16.5-21.8-16.5-36.6V288h32v24.2c0 4.9 2.2 9.5 5.9 12.8C309.7 339.3 352 382 352 432c0 24.4-8.3 44.6-16.4 58.7c-8.5 14.7-25.2 21.3-42.1 21.3h-139c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-50 42.3-92.7 58.1-107c3.6-3.3 5.9-7.9 5.9-12.8z"]
};
var faAirplay = {
  prefix: 'fal',
  iconName: 'airplay',
  icon: [576, 512, [], "e089", "M480 64H96c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64h37.5l-18.7 18.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128C0 75 43 32 96 32H480c53 0 96 43 96 96V320c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3L442.5 384H480c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM162.2 435.7c-1.4 1.3-2.2 3.2-2.2 5.2c0 3.9 3.2 7.1 7.1 7.1H408.9c3.9 0 7.1-3.2 7.1-7.1c0-2-.8-3.8-2.2-5.2L293.6 322.2c-1.4-1.3-3.5-2.2-5.6-2.2s-4.2 .8-5.6 2.2L162.2 435.7zm-22-23.3L260.4 298.9c7.4-7 17.4-10.9 27.6-10.9s20.1 3.9 27.6 10.9L435.7 412.4c7.8 7.4 12.3 17.7 12.3 28.5c0 21.6-17.5 39.1-39.1 39.1H167.1c-21.6 0-39.1-17.5-39.1-39.1c0-10.8 4.4-21.1 12.3-28.5z"]
};
var faHandFist = {
  prefix: 'fal',
  iconName: 'hand-fist',
  icon: [448, 512, [9994, "fist-raised"], "f6de", "M254.2 233.7c7.7 4 16.5 6.3 25.8 6.3c12.1 0 23.3-3.8 32.5-10.4C322.4 245.5 340 256 360 256c8.6 0 16.7-1.9 24-5.4V256c0 38.6-19.5 72.6-49.2 92.7c-8.6 5.8-14.8 15.7-14.8 27.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V376.1l0-.1 .1-.1c.1-.2 .3-.5 .7-.7C390.9 349.3 416 305.6 416 256V200v-8V152c0-30.9-25.1-56-56-56c-8.6 0-16.7 1.9-24 5.4V88c0-30.9-25.1-56-56-56c-9.7 0-18.8 2.5-26.7 6.8C246 16.3 224.9 0 200 0s-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8C89.1 32 64 57.1 64 88V200c0 2.6 .2 5.1 .5 7.6C44.8 222.2 32 245.6 32 272c0 59 39.9 108.7 94.2 123.5c.8 .2 1.3 .6 1.6 1c.1 .2 .2 .3 .2 .3l0 0V496c0 8.8 7.2 16 16 16s16-7.2 16-16V396.7c0-16.3-11.9-28.4-25.4-32.1C93.9 353.5 64 316.2 64 272c0-26.5 21.5-48 48-48h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c30.9 0 56-25.1 56-56c0-4.9-.6-9.7-1.8-14.3zM224 197.4c-7.3-3.5-15.4-5.4-24-5.4H176V88 56c0-13.3 10.7-24 24-24s24 10.7 24 24V88v96 13.4zM144 192H112c-5.5 0-10.8 .6-16 1.6V88c0-13.3 10.7-24 24-24s24 10.7 24 24V192zm240 0v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V184 152c0-13.3 10.7-24 24-24s24 10.7 24 24v40zM256 88c0-13.3 10.7-24 24-24s24 10.7 24 24v64 32c0 13.3-10.7 24-24 24s-24-10.7-24-24V88z"]
};
var faFistRaised = faHandFist;
var faShieldQuartered = {
  prefix: 'fal',
  iconName: 'shield-quartered',
  icon: [512, 512, [], "e575", "M66.8 112.3C55.5 117 47.9 127.7 48 139.8c.1 20 1.9 43.2 6.3 68.2H240V38.8L66.8 112.3zM61.1 240C82.3 324.6 133.3 420.1 240 472.6V240H61.1zM272 240V472.6c106.7-52.5 157.7-148 179-232.6H272zm185.8-32c4.3-24.9 6.2-48.2 6.3-68.2c.1-12.1-7.5-22.8-18.8-27.6L272 38.8V208H457.8zM231 7.8c16-6.8 34-6.8 50 0l176.7 75c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L231 7.8z"]
};
var faSlashForward = {
  prefix: 'fal',
  iconName: 'slash-forward',
  icon: [320, 512, [], "2f", "M312.2 2.3c7.6 4.5 10 14.4 5.5 22l-288 480c-4.5 7.6-14.4 10-22 5.5s-10-14.4-5.5-22l288-480c4.5-7.6 14.4-10 22-5.5z"]
};
var faLocationPen = {
  prefix: 'fal',
  iconName: 'location-pen',
  icon: [384, 512, ["map-marker-edit"], "f607", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM252.3 131.7c-4.9-4.9-12.9-4.9-17.8 0l-8.1 8.1 17.8 17.8 8.1-8.1c4.9-4.9 4.9-12.9 0-17.8zM143.1 223.1c-2 2.1-3.5 4.6-4.2 7.4L134 250l19.4-4.9c2.8-.7 5.4-2.2 7.4-4.2l60.7-60.7-17.8-17.8-60.7 60.7zM211.8 109c17.4-17.4 45.7-17.4 63.1 0c17.4 17.4 17.4 45.6 0 63l-91.4 91.5c-6.2 6.2-13.9 10.5-22.3 12.6l-45.3 11.3c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l11.3-45.3c2.1-8.4 6.5-16.1 12.6-22.3L211.8 109z"]
};
var faMapMarkerEdit = faLocationPen;
var faCloudMoon = {
  prefix: 'fal',
  iconName: 'cloud-moon',
  icon: [640, 512, [], "f6c3", "M460.6 35.9c-30 32-48.4 75-48.4 122.4c0 90.8 67.6 165.8 155.1 177.2c-21.5 10.8-45.8 16.9-71.5 16.9c-24.6 0-47.9-5.6-68.7-15.5c17.7 11 32.1 26.8 41.3 45.6c8.9 1.3 18.1 1.9 27.4 1.9c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.1-25.1 2.1c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3S519 1.3 512 .7c-5.4-.5-10.8-.7-16.3-.7C389.8 0 304 86.1 304 192.2c0 10.8 .9 21.5 2.6 31.8c11.8 .3 23.2 2.4 33.9 6.1c-2.9-12.2-4.5-24.8-4.5-37.9C336 115.8 389.3 52 460.6 35.9zM112 320c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H98.9c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3C34.6 328.9 0 368.4 0 416c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H365.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.4-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 242.6 210.9 224 176 224z"]
};
var faPotFood = {
  prefix: 'fal',
  iconName: 'pot-food',
  icon: [640, 512, [127858], "e43f", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 25.8 4.3 44.4 11.7 59.2c7.2 14.3 16.7 23.9 24.6 31.7l.4 .4c8.1 8.1 14.3 14.4 19 23.8c4.6 9.2 8.3 22.7 8.3 44.8c0 8.8 7.2 16 16 16s16-7.2 16-16c0-25.8-4.3-44.4-11.7-59.2c-7.2-14.3-16.7-23.9-24.6-31.7l-.4-.4c-8.1-8.1-14.3-14.4-19-23.8C131.7 51.6 128 38.2 128 16zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 25.8 4.3 44.4 11.7 59.2c7.2 14.3 16.7 23.9 24.6 31.7l0 0 0 0 0 0 .4 .4c8.1 8.1 14.3 14.4 19 23.8c4.6 9.2 8.3 22.7 8.3 44.8c0 8.8 7.2 16 16 16s16-7.2 16-16c0-25.8-4.3-44.4-11.7-59.2c-7.2-14.3-16.7-23.9-24.6-31.7l-.4-.4c-8.1-8.1-14.3-14.4-19-23.8C227.7 51.6 224 38.2 224 16zM32 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H67.8c5.9 82.9 56.5 152.7 127.3 186.4c7.6 21.9 28.4 37.6 52.9 37.6H392c24.5 0 45.3-15.7 52.9-37.6C515.7 440.7 566.3 370.9 572.2 288H608c8.8 0 16-7.2 16-16s-7.2-16-16-16H570.4c-6.6-18.6-24.3-32-45.3-32H114.9c-21 0-38.7 13.4-45.3 32H32zm507.4-64c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80h34c12.3-28.3 40.5-48 73.3-48s61 19.7 73.3 48h34zM225.3 463.9c-2.8-8.1-8.7-14.7-16.5-18.4c-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9H525.1c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2c-7.7 3.7-13.7 10.3-16.5 18.4c-3.3 9.4-12.2 16.1-22.7 16.1H248c-10.4 0-19.4-6.7-22.7-16.1z"]
};
var faBriefcase = {
  prefix: 'fal',
  iconName: 'briefcase',
  icon: [512, 512, [128188], "f0b1", "M160 48V96H352V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM128 96V48c0-26.5 21.5-48 48-48H336c26.5 0 48 21.5 48 48V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm240 32H144 64c-17.7 0-32 14.3-32 32v96H176h32 96 32H480V160c0-17.7-14.3-32-32-32H368zM480 288H336v48c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V288H32V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V288zm-272 0v48h96V288H208z"]
};
var faPersonFalling = {
  prefix: 'fal',
  iconName: 'person-falling',
  icon: [512, 512, [], "e546", "M320 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 10.8c0 48.1-27.6 91.3-70 111.9c-1.8 .4-3.6 1.1-5.2 2.2c-.2 .1-.4 .3-.6 .4c-3 1.3-6.1 2.4-9.3 3.5C139.1 166.1 96 225.9 96 293.2V368c0 8.8 7.2 16 16 16s16-7.2 16-16l0-74.8c0-21.7 5.6-42.5 15.8-60.6L322.6 504.8c4.9 7.4 14.8 9.4 22.2 4.6s9.4-14.8 4.6-22.2L252.7 340.1l57.5-44.7 67-6.7 74.6 89.5c5.7 6.8 15.7 7.7 22.5 2s7.7-15.7 2-22.5l-74.6-89.5c-6.8-8.2-17.2-12.4-27.8-11.4l-61.9 6.2L244.8 160.5c46-27.9 75.2-78.2 75.2-133.7L320 16zM282.5 276.4l-47.4 36.9L165.4 207.2c-.4-.6-.8-1.1-1.3-1.7c13.4-13.5 30-24.1 48.9-30.4c.8-.3 1.7-.6 2.5-.9l66.9 102.1zM96 88a24 24 0 1 1 48 0A24 24 0 1 1 96 88zm80 0A56 56 0 1 0 64 88a56 56 0 1 0 112 0z"]
};
var faImagePortrait = {
  prefix: 'fal',
  iconName: 'image-portrait',
  icon: [384, 512, ["portrait"], "f3e0", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM235.4 320H148.6c-18.6 0-34 14-36.3 32H271.7c-2.2-18-17.6-32-36.3-32zm-86.9-32H192h43.4c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6c0-37.9 30.7-68.6 68.6-68.6z"]
};
var faPortrait = faImagePortrait;
var faUserTag = {
  prefix: 'fal',
  iconName: 'user-tag',
  icon: [640, 512, [], "f507", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM416 480c0-2.4-.1-4.8-.3-7.2l26.8 26.8c-5.4 7.5-14.2 12.5-24.2 12.5H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c17.5 0 34.3 2.5 50.3 7.2v33l0 .7c-15.7-5.7-32.6-8.9-50.3-8.9H178.3c-80 0-145 64.3-146.3 144H416zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM545.9 491.3c-18.7 18.7-49.1 18.7-67.9 0L370.7 384c-12-12-18.7-28.3-18.7-45.3V256c0-17.7 14.3-32 32-32h82.7c17 0 33.3 6.7 45.3 18.7L619.3 350.1c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.4zM384 256v82.7c0 8.5 3.4 16.6 9.4 22.6L500.7 468.7c6.2 6.2 16.4 6.2 22.6 0l73.4-73.4c6.2-6.2 6.2-16.4 0-22.6L489.4 265.4c-6-6-14.1-9.4-22.6-9.4H384zm24 40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faRug = {
  prefix: 'fal',
  iconName: 'rug',
  icon: [640, 512, [], "e569", "M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H32v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 48 64 576h16 16 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V352h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V272h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V192h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608 592 576 64 48 32 16zM64 96h64V416H64V336 256 176 96zm448 0h64v80 80 80 80H512V96zm-32 0V416H160V96H480z"]
};
var faPrintSlash = {
  prefix: 'fal',
  iconName: 'print-slash',
  icon: [640, 512, [], "f686", "M480 463.9V480H160V352H338.3l-40.5-32H160c-17.7 0-32 14.3-32 32v32H96V256c0-17.7 14.3-32 32-32h48.2l-40.5-32H128c-35.3 0-64 28.7-64 64V384c0 17.7 14.3 32 32 32h32v64c0 17.7 14.3 32 32 32H480c14.8 0 27.3-10.1 30.9-23.7L480 463.9zM137.5 30.4L163 50.5C168.1 39.6 179.2 32 192 32H421.5c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c6 6 9.4 14.1 9.4 22.6V160h32V90.5c0-17-6.7-33.3-18.7-45.3L466.7 18.7C454.7 6.7 438.5 0 421.5 0H192c-23 0-43.2 12.2-54.5 30.4zM512 192H342.2l40.5 32H512c17.7 0 32 14.3 32 32v95.3l32 25.3V256c0-35.3-28.7-64-64-64zM496 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faEarthEurope = {
  prefix: 'fal',
  iconName: 'earth-europe',
  icon: [512, 512, ["globe-europe"], "f7a2", "M477.7 288H439.4c-6.2 0-12.3-2.2-17.1-6.2l-15.9-13.2c-4.6-3.8-5.2-10.5-1.5-15.2c14.6-18.3 1.6-45.4-21.8-45.4h-3.7c-6.3 0-11.4-5.1-11.4-11.4v-9.4c0-18.4-22.2-27.6-35.2-14.6l-32.1 32.1c-2.6 2.6-6.8 2.6-9.4 0l-2.8-2.8c-6.3-6.3-14.8-9.8-23.7-9.8c-10.5 0-20.5 5-26.8 13.4l-10.7 14.3c-2 2.7-5.2 4.3-8.5 4.3c-5.9 0-10.7-4.8-10.7-10.7v-1.6c0-3.3 1.3-6.4 3.6-8.7l18.7-18.7c6.2-6.2 9.7-14.7 9.7-23.5c0-4.3 2.4-8.2 6.2-10.1l59.2-29.6c20.2-10.1 26.9-35.6 14.2-54.3c-8.9-13.2-25.1-19.1-40-15.3l4.5-17.8C394.5 47.5 480 141.8 480 256c0 10.9-.8 21.5-2.3 32zm-7 32c-3.3 11-7.4 21.7-12.3 32H438.6c-10.2 0-20.1-4.1-27.3-11.3l-4-4C396.6 326 382.2 320 367.1 320c-5.9 0-11.7-2.1-16.1-6l-26.6-22.8c-14.5-12.4-33-19.3-52.1-19.3H251.4c-15.8 0-31.2 4.7-44.4 13.4l-27.4 18.3c-22.3 14.8-35.6 39.8-35.6 66.6v3.2c0 21.2 8.4 41.6 23.4 56.6l16 16c11.5 11.5 27.1 17.9 43.3 17.9c11.4 0 21.2 6.5 26.1 16C130.6 478.3 32 378.6 32 256C32 133.8 129.9 34.4 251.5 32l-6.9 27.6c-4.9 19.7 15.4 36.2 33.7 27.3l8.1-3.9c2.4-1.2 5.3-.4 6.8 1.8c1.8 2.7 .8 6.3-2 7.8l-59.2 29.6c-14.7 7.3-23.9 22.3-23.9 38.7c0 .3-.1 .6-.4 .9L189 180.4c-8.3 8.3-13 19.6-13 31.3v1.6c0 23.6 19.1 42.7 42.7 42.7c13.4 0 26.1-6.3 34.1-17.1l10.7-14.3c.3-.4 .7-.6 1.2-.6c.4 0 .8 .2 1.1 .4l2.8 2.8c15.1 15.1 39.6 15.1 54.7 0l15.4-15.4c5.8 15.3 20 26.5 36.9 28c-9.5 17.6-5.6 40 10.3 53.3l15.9 13.2c10.5 8.8 23.8 13.6 37.5 13.6h31.3zm-30.9 64c-35.1 50.3-90.2 85.5-153.8 94c-6.8-26.4-30.8-46-59.3-46c-7.8 0-15.2-3.1-20.7-8.6l-16-16c-9-9-14.1-21.2-14.1-33.9v-3.2c0-16.1 8-31 21.4-39.9l27.4-18.3c7.9-5.3 17.1-8.1 26.6-8.1h20.9c11.5 0 22.5 4.1 31.2 11.6l26.6 22.8c10.3 8.8 23.4 13.7 37 13.7c6.6 0 12.9 2.6 17.5 7.3l4 4c13.2 13.2 31.2 20.7 49.9 20.7h1.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faGlobeEurope = faEarthEurope;
var faCartFlatbedSuitcase = {
  prefix: 'fal',
  iconName: 'cart-flatbed-suitcase',
  icon: [640, 512, ["luggage-cart"], "f59d", "M0 16C0 7.2 7.2 0 16 0H80c26.5 0 48 21.5 48 48V368c0 8.8 7.2 16 16 16h80H512 624c8.8 0 16 7.2 16 16s-7.2 16-16 16H567.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H144c-26.5 0-48-21.5-48-48V48c0-8.8-7.2-16-16-16H16C7.2 32 0 24.8 0 16zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM336 32c-8.8 0-16 7.2-16 16V80H448V48c0-8.8-7.2-16-16-16H336zM480 80h32c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V144c0-35.3 28.7-64 64-64h32V48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V80zM272 112H256c-17.7 0-32 14.3-32 32V256c0 17.7 14.3 32 32 32h16V112zm32 176H464V112H304V288zm192 0h16c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32H496V288z"]
};
var faLuggageCart = faCartFlatbedSuitcase;
var faHandBackPointRibbon = {
  prefix: 'fal',
  iconName: 'hand-back-point-ribbon',
  icon: [448, 512, [], "e1a0", "M152 0C121.1 0 96 25.1 96 56v8H16C9.8 64 4.2 67.5 1.6 73.1S-.3 85.2 3.5 90l24 30-24 30c-3.8 4.8-4.6 11.4-1.9 16.9S9.8 176 16 176H96v80.6c-3.2 2-6.4 4.2-9.5 6.5L64 280c-20.1 15.1-32 38.8-32 64v19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H320c61.9 0 112-50.1 112-112v-8V304c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-8.5 0-16.6 1.7-24 4.7V56c0-30.9-25.1-56-56-56zM128 176h48v37.5c0 7.1 4.6 13.3 11.4 15.3s14-.6 18-6.5c5.8-8.7 15.6-14.3 26.7-14.3c15.6 0 28.6 11.2 31.4 25.9c1 5.1 4.4 9.5 9.2 11.6s10.3 1.8 14.8-.9c4.8-2.9 10.5-4.6 16.6-4.6c14.7 0 27.2 10 30.9 23.6c1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1 .6c3.6-1.4 7.6-2.2 11.8-2.2c17.7 0 32 14.3 32 32v88 8c0 44.2-35.8 80-80 80H184.3c-18.5 0-36.8-4.6-53.1-13.4l-8.3-4.5C86.6 442.6 64 404.7 64 363.5V344c0-15.1 7.1-29.3 19.2-38.4L96 296v48c0 8.8 7.2 16 16 16s16-7.2 16-16V265.7 264 176zm48-32H49.3l11.2-14c4.7-5.8 4.7-14.1 0-20L49.3 96H176v48zm0-80H128V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8z"]
};
var faRectangleXmark = {
  prefix: 'fal',
  iconName: 'rectangle-xmark',
  icon: [512, 512, [62164, "rectangle-times", "times-rectangle", "window-close"], "f410", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm180.7 84.7c6.2-6.2 16.4-6.2 22.6 0L256 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faRectangleTimes = faRectangleXmark;
var faTimesRectangle = faRectangleXmark;
var faWindowClose = faRectangleXmark;
var faTireRugged = {
  prefix: 'fal',
  iconName: 'tire-rugged',
  icon: [512, 512, [], "f634", "M229.8 32c-8.2 0-15.1 6.3-15.9 14.5l-.3 3.1c-.6 6.6-5.2 12.1-11.6 13.9c-15.5 4.3-30.2 10.5-43.9 18.2c-5.8 3.2-12.9 2.6-18-1.6l-2.4-2c-6.4-5.2-15.7-4.8-21.5 1L79.1 116.1c-5.8 5.8-6.3 15.1-1 21.5l2 2.4c4.2 5.1 4.8 12.3 1.6 18c-7.7 13.7-13.9 28.4-18.2 43.9c-1.8 6.4-7.3 11-13.9 11.6l-3.1 .3c-8.2 .8-14.5 7.7-14.5 15.9v52.4c0 8.2 6.3 15.1 14.5 15.9l3.1 .3c6.6 .6 12.1 5.2 13.9 11.6c4.3 15.5 10.5 30.2 18.2 43.9c3.2 5.8 2.6 12.9-1.6 18l-2 2.4c-5.2 6.4-4.8 15.7 1 21.5l37.1 37.1c5.8 5.8 15.1 6.3 21.5 1l2.4-2c5.1-4.2 12.3-4.8 18-1.6c13.7 7.7 28.4 13.9 43.9 18.2c6.4 1.8 11 7.3 11.6 13.9l.3 3.1c.8 8.2 7.7 14.5 15.9 14.5h52.4c8.2 0 15.1-6.3 15.9-14.5l.3-3.1c.6-6.6 5.2-12.1 11.6-13.9c15.5-4.3 30.2-10.5 43.9-18.2c5.8-3.2 12.9-2.6 18 1.6l2.4 2c6.4 5.2 15.7 4.8 21.5-1l37.1-37.1c5.8-5.8 6.3-15.1 1-21.5l-2-2.4c-4.2-5.1-4.8-12.3-1.6-18c7.7-13.7 13.9-28.4 18.2-43.9c1.8-6.4 7.3-11 13.9-11.6l3.1-.3c8.2-.8 14.5-7.7 14.5-15.9V229.8c0-8.2-6.3-15.1-14.5-15.9l-3.1-.3c-6.6-.6-12.1-5.2-13.9-11.6c-4.3-15.5-10.5-30.2-18.2-43.9c-3.2-5.8-2.6-12.9 1.6-18l2-2.4c5.2-6.4 4.8-15.7-1-21.5L395.8 79.1c-5.8-5.8-15.1-6.3-21.5-1L372 80c-5.1 4.2-12.3 4.8-18 1.6c-13.7-7.7-28.4-13.9-43.9-18.2c-6.4-1.8-11-7.3-11.6-13.9l-.3-3.1c-.8-8.2-7.7-14.5-15.9-14.5H229.8zm-46.4 3.6C188.9 14.9 207.7 0 229.8 0h52.4c22 0 40.9 14.9 46.4 35.6c11 3.6 21.7 8.1 31.9 13.2c18.5-10.7 42.4-8 58 7.6l37.1 37.1c15.6 15.6 18.3 39.4 7.6 58c5.2 10.2 9.6 20.9 13.2 31.9c20.7 5.5 35.6 24.3 35.6 46.4v52.4c0 22-14.9 40.9-35.6 46.4c-3.6 11-8.1 21.7-13.2 31.9c10.7 18.5 8 42.4-7.6 58l-37.1 37.1c-15.6 15.6-39.4 18.3-58 7.6c-10.2 5.2-20.9 9.6-31.9 13.2c-5.5 20.7-24.3 35.6-46.4 35.6H229.8c-22 0-40.9-14.9-46.4-35.6c-11-3.6-21.7-8.1-31.9-13.2c-18.5 10.7-42.4 8-58-7.6L56.4 418.5c-15.6-15.6-18.3-39.5-7.6-58c-5.2-10.2-9.6-20.9-13.2-31.9C14.9 323.1 0 304.3 0 282.2V229.8c0-22 14.9-40.9 35.6-46.4c3.6-11 8.1-21.7 13.2-31.9c-10.7-18.5-8-42.4 7.6-58L93.5 56.4c15.6-15.6 39.5-18.3 58-7.6c10.2-5.2 20.9-9.6 31.9-13.2zM96 256a160 160 0 1 1 320 0A160 160 0 1 1 96 256zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-224a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-75.9 96.6a24 24 0 1 1 14.8-45.7 24 24 0 1 1 -14.8 45.7zm167.2-30.2a24 24 0 1 1 -45.7 14.8 24 24 0 1 1 45.7-14.8zm-29.6 73.8a24 24 0 1 1 -38.8 28.2 24 24 0 1 1 38.8-28.2zM199.6 333.7a24 24 0 1 1 28.2-38.8 24 24 0 1 1 -28.2 38.8z"]
};
var faLightbulbDollar = {
  prefix: 'fal',
  iconName: 'lightbulb-dollar',
  icon: [384, 512, [], "f670", "M336 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.8 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32s144 64.5 144 144zM146.7 448h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM112 432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H122.7c-5.9 0-10.7 4.8-10.7 10.7V432zM208 88c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V296c0 8.8 7.2 16 16 16s16-7.2 16-16V278.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V88z"]
};
var faCowbell = {
  prefix: 'fal',
  iconName: 'cowbell',
  icon: [448, 512, [], "f8b3", "M176 32h96c8.8 0 16 7.2 16 16V96H160V48c0-8.8 7.2-16 16-16zM128 48V96H112c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416H400c15.1 0 29.3-7.1 38.3-19.1s12-27.6 7.8-42.1l-64-224C376.3 110.2 357.4 96 336 96H320V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm16 80H304h32c7.1 0 13.4 4.7 15.4 11.6l64 224c1.4 4.8 .4 10-2.6 14s-7.8 6.4-12.8 6.4H48c-5 0-9.8-2.4-12.8-6.4s-4-9.2-2.6-14l64-224c2-6.9 8.2-11.6 15.4-11.6h32zm80 384c35.3 0 64-28.7 64-64H256c0 17.7-14.3 32-32 32s-32-14.3-32-32H160c0 35.3 28.7 64 64 64z"]
};
var faBahtSign = {
  prefix: 'fal',
  iconName: 'baht-sign',
  icon: [320, 512, [], "e0ac", "M144 0c-8.8 0-16 7.2-16 16V64H37.6C16.8 64 0 80.8 0 101.6V240v32V406.3c0 23 18.7 41.7 41.7 41.7H128v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h56c57.4 0 104-46.6 104-104c0-44.7-28.2-82.8-67.8-97.5C274.1 227.4 288 199.3 288 168c0-57.4-46.6-104-104-104H160V16c0-8.8-7.2-16-16-16zM128 96V240H32V101.6c0-3.1 2.5-5.6 5.6-5.6H128zm32 144V96h24c39.8 0 72 32.2 72 72s-32.2 72-72 72H160zm-32 32V416H41.7c-5.4 0-9.7-4.4-9.7-9.7V272h96zm32 144V272h24 32c39.8 0 72 32.2 72 72s-32.2 72-72 72H160z"]
};
var faCorner = {
  prefix: 'fal',
  iconName: 'corner',
  icon: [448, 512, [], "e3fe", "M0 176c0-8.8 7.2-16 16-16H400c26.5 0 48 21.5 48 48V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8-7.2-16-16-16H16c-8.8 0-16-7.2-16-16z"]
};
var faChevronsRight = {
  prefix: 'fal',
  iconName: 'chevrons-right',
  icon: [512, 512, ["chevron-double-right"], "f324", "M75.3 459.3l192-192c6.2-6.2 6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256 52.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm192 0l192-192c6.2-6.2 6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256 244.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"]
};
var faChevronDoubleRight = faChevronsRight;
var faBookOpen = {
  prefix: 'fal',
  iconName: 'book-open',
  icon: [576, 512, [128214, 128366], "f518", "M156 32c44.6 0 89.7 8.6 132 22.6C330.3 40.6 375.4 32 420 32c55.4 0 107.2 14.6 128.9 21.6C565.7 59 576 74.5 576 91.1V402.5c0 26.9-25.1 44.8-49 40.6c-18.5-3.2-51.3-7.2-99-7.2c-58.9 0-97.8 24.3-111.2 34.1c-7.5 5.5-17.2 9.6-28.2 9.9c-.2 0-.5 0-.7 0c-.1 0-.1 0-.2 0c-.1 0-.2 0-.3 0c-10.2 0-19.6-3.4-27-8.4C245.5 461.5 202 436 148 436c-45.2 0-80.1 4.4-100 7.7c-24 4-48-14.1-48-40.2V91.1C0 74.5 10.3 59 27.1 53.6C48.8 46.6 100.6 32 156 32zM304 440c20.3-13.5 63.1-36 124-36c49.5 0 84.1 4.2 104.4 7.6c2.5 .4 5.7-.3 8.2-2.3c2.2-1.8 3.4-4 3.4-6.8V91.1c0-3.5-2.1-6.1-4.9-7C518.6 77.5 470.5 64 420 64c-38.6 0-78.1 7.1-116 19V440zM272 83c-37.9-12-77.4-19-116-19C105.5 64 57.4 77.5 36.9 84c-2.8 .9-4.9 3.6-4.9 7V403.5c0 2.7 1.1 4.9 3.1 6.5c2.2 1.8 5.1 2.5 7.6 2.1c21.3-3.6 58-8.2 105.3-8.2c56.8 0 102.8 23.7 124 36.9V83z"]
};
var faBookJournalWhills = {
  prefix: 'fal',
  iconName: 'book-journal-whills',
  icon: [448, 512, ["journal-whills"], "f66a", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V413.3c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zM384 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H384zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H64zM190.5 86.3c-3.6-4.2-9.7-5.4-14.6-2.8C130.8 106.8 100 153.8 100 208c0 77.3 62.7 140 140 140s140-62.7 140-140c0-54.2-30.8-101.2-75.9-124.5c-4.9-2.5-11-1.4-14.6 2.8s-3.9 10.3-.7 14.8C295.9 111 300 123 300 136c0 17.8-7.7 33.7-20 44.7c-4.9 4.4-5.4 11.9-1 16.9c8.1 9.2 13 21.2 13 34.4c0 23.2-15.2 42.9-36.3 49.6l-.9-23.4 2.2 2.2c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-9-9H272c4.4 0 8-3.6 8-8s-3.6-8-8-8H259.3l9-9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-4.2 4.2L248 87.7c-.2-4.3-3.7-7.7-8-7.7s-7.8 3.4-8 7.7l-4.8 120.2-4.2-4.2c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l9 9H208c-4.4 0-8 3.6-8 8s3.6 8 8 8h12.7l-9 9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l2.2-2.2-.9 23.4c-21-6.7-36.3-26.3-36.3-49.6c0-13.2 4.9-25.2 13-34.4c4.4-4.9 3.9-12.5-1-16.9c-12.3-11-20-27-20-44.7c0-13 4.1-25 11.1-34.8c3.2-4.5 2.9-10.6-.7-14.8zm133.1 41.2c11 11.4 19.7 25.1 25.3 40.3l-18.5 18.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l12.2-12.2c1.4 7.3 2.2 14.8 2.2 22.5l0 .7-25.7 25.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L353 234.3C341.1 285.7 295 324 240 324s-101.1-38.3-113-89.7l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L124 208.7l0-.7c0-7.7 .8-15.2 2.2-22.5l12.2 12.2c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-18.5-18.5c5.6-15.2 14.3-28.8 25.3-40.3c-.3 2.8-.4 5.6-.4 8.4c0 20.9 7.6 40 20.2 54.7C168.5 202.6 164 216.8 164 232c0 42 34 76 76 76s76-34 76-76c0-15.2-4.5-29.4-12.2-41.3C316.4 176 324 156.9 324 136c0-2.8-.1-5.7-.4-8.4z"]
};
var faJournalWhills = faBookJournalWhills;
var faInhaler = {
  prefix: 'fal',
  iconName: 'inhaler',
  icon: [576, 512, [], "f5f9", "M542.5 93.5L429.5 65.3l-16.7 62.2-25.8-25.8 14-51.8c3.4-12.6 16.3-20.2 29-17l128 32c6.3 1.6 11.6 5.6 14.9 11.2s4.1 12.2 2.4 18.4L533.2 248l-25.8-25.8L542.5 93.5zM380.7 186l-9.3 34.5c-5.6 21-24.6 35.5-46.4 35.5H232c-4.4 0-8 3.6-8 8V440c0 4.4 3.6 8 8 8H456c3.6 0 6.8-2.4 7.7-5.9l37.1-136L380.7 186zM530 290c4.1 4.1 5.6 10 4.1 15.5l-39.5 145C489.8 467.9 474 480 456 480H232c-22.1 0-40-17.9-40-40V264c0-22.1 17.9-40 40-40h93.1c7.2 0 13.6-4.9 15.4-11.8L357 150.9c3.2-11.9 18.1-15.9 26.8-7.2L530 290zM8 256a24 24 0 1 1 48 0A24 24 0 1 1 8 256zm96 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHandcuffs = {
  prefix: 'fal',
  iconName: 'handcuffs',
  icon: [640, 512, [], "e4f8", "M248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM192 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-32 72c13.3 0 24 10.7 24 24c22.1 0 40 17.9 40 40v21.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.6 39.5-122 96-146.7V184c0-22.1 17.9-40 40-40c0-13.3 10.7-24 24-24zm32 75.2V184c0-4.4-3.6-8-8-8H136c-4.4 0-8 3.6-8 8v11.2c10.3-2.1 21-3.2 32-3.2s21.7 1.1 32 3.2zM288 352A128 128 0 1 0 32 352a128 128 0 1 0 256 0zm-64 0A64 64 0 1 0 96 352a64 64 0 1 0 128 0zM64 352a96 96 0 1 1 192 0A96 96 0 1 1 64 352zm416 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm-64-72c0-22.1 17.9-40 40-40c0-13.3 10.7-24 24-24s24 10.7 24 24c22.1 0 40 17.9 40 40v21.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160c-47.4 0-90-20.6-119.3-53.3c-5.9-6.6-5.3-16.7 1.3-22.6s16.7-5.3 22.6 1.3C408 463.5 442.1 480 480 480c70.7 0 128-57.3 128-128s-57.3-128-128-128c-37.9 0-72 16.5-95.4 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c15.2-17 34-30.7 55.3-40V184zm32 11.2c10.3-2.1 21-3.2 32-3.2s21.7 1.1 32 3.2V184c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v11.2zM368 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm80 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSnake = {
  prefix: 'fal',
  iconName: 'snake',
  icon: [512, 512, [128013], "f716", "M293.9 88H277 180C115.9 88 64 139.9 64 204s51.9 116 116 116H344c30.9 0 56 25.1 56 56s-25.1 56-56 56H256.1h0l-.1 0 0 0-140.8 0c-8.4 0-16.8 1.7-24.6 4.9L44.8 456l45.8 19.1c7.8 3.3 16.2 4.9 24.6 4.9h60.7 0l.1 0 0 0 168 0c57.4 0 104-46.6 104-104s-46.6-104-104-104H180c-37.6 0-68-30.4-68-68s30.4-68 68-68h92 17.1l9.5 14.2c14.1 21.1 37.7 33.8 63.1 33.8h4.5c12.3 0 24.5-2.7 35.6-7.9L455 151.3c15.3-7.1 25-22.5 25-39.3s-9.8-32.2-25-39.3L400.5 47.3C390.2 42.5 379 40 367.7 40c-25.8 0-49.9 12.8-64.2 34l-9.5 14zM176 512l-.1 0H115.2c-12.7 0-25.2-2.5-36.9-7.4L14.8 478.2C5.8 474.4 0 465.7 0 456s5.8-18.4 14.8-22.2l63.5-26.5c11.7-4.9 24.2-7.4 36.9-7.4H256l.1 0H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H180C98.3 352 32 285.7 32 204S98.3 56 180 56h97c20.3-29.9 54.2-48 90.7-48c16 0 31.9 3.5 46.4 10.3l54.4 25.4C495 56.1 512 82.7 512 112s-17 55.9-43.5 68.3l-53.1 24.8c-8.7 4-17.8 7-27.1 8.8c-7.2 1.4-14.6 2.1-22 2.1h-4.5c-6 0-11.9-.5-17.7-1.5c-8-1.3-15.7-3.5-23.1-6.5c-19.7-8-36.8-21.8-48.9-40H180c-19.9 0-36 16.1-36 36s16.1 36 36 36H315.1 344c6 0 11.9 .4 17.7 1.1c1.5 .2 3 .4 4.5 .7c6.8 1.1 13.5 2.8 19.9 4.8C440.6 264.4 480 315.6 480 376c0 75.1-60.9 136-136 136H176zM352 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTriangleExclamation = {
  prefix: 'fal',
  iconName: 'triangle-exclamation',
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M34.5 420.4c-1.6 2.8-2.5 6-2.5 9.3c0 10.2 8.2 18.4 18.4 18.4H461.6c10.2 0 18.4-8.2 18.4-18.4c0-3.3-.9-6.4-2.5-9.3L276.5 75.8C272.2 68.5 264.4 64 256 64s-16.2 4.5-20.5 11.8L34.5 420.4zM6.9 404.2l201-344.6C217.9 42.5 236.2 32 256 32s38.1 10.5 48.1 27.6l201 344.6c4.5 7.7 6.9 16.5 6.9 25.4c0 27.8-22.6 50.4-50.4 50.4H50.4C22.6 480 0 457.4 0 429.6c0-8.9 2.4-17.7 6.9-25.4zM256 160c8.8 0 16 7.2 16 16V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM232 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faExclamationTriangle = faTriangleExclamation;
var faWarning = faTriangleExclamation;
var faNoteMedical = {
  prefix: 'fal',
  iconName: 'note-medical',
  icon: [448, 512, [], "e200", "M384 64c17.7 0 32 14.3 32 32V309.5c0 3.6-.6 7.2-1.8 10.5H336c-26.5 0-48 21.5-48 48v78.2c-3.3 1.2-6.9 1.8-10.5 1.8H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm2.7 288L320 418.7V368c0-8.8 7.2-16 16-16h50.7zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H277.5c17 0 33.3-6.7 45.3-18.7L429.3 354.7c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H64zM176 144v32H144c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V272h32c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32H272V144c0-17.7-14.3-32-32-32H208c-17.7 0-32 14.3-32 32zm64 0v48c0 8.8 7.2 16 16 16h48v32H256c-8.8 0-16 7.2-16 16v48H208V256c0-8.8-7.2-16-16-16H144V208h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V144h32z"]
};
var faDatabase = {
  prefix: 'fal',
  iconName: 'database',
  icon: [448, 512, [], "f1c0", "M416 80.4V182.1c-14.5 10.6-37.9 20.6-68.9 28.3C312.5 218.9 270 224 224 224s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3V80.4c.3-.8 1.6-3.2 6.2-7.1c7.3-6.2 19.9-13.2 38.1-19.7C112.6 40.6 164.8 32 224 32s111.4 8.6 147.6 21.6c18.3 6.5 30.8 13.5 38.1 19.7c4.7 4 6 6.4 6.2 7.1zm0 139.1v90.6c-14.5 10.6-37.9 20.6-68.9 28.3C312.5 346.9 270 352 224 352s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3V219.5c17.2 8.9 38.1 16.3 61.2 21.9C130.7 250.7 175.8 256 224 256s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9zM32 431.6v-84c17.2 8.9 38.1 16.3 61.2 21.9C130.7 378.7 175.8 384 224 384s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9v84c-.3 .8-1.6 3.2-6.2 7.1c-7.3 6.2-19.9 13.2-38.1 19.7C335.4 471.4 283.2 480 224 480s-111.4-8.6-147.6-21.6c-18.3-6.5-30.8-13.5-38.1-19.7c-4.7-4-6-6.4-6.2-7.1zm384.1-.3a.1 .1 0 1 0 -.2 0 .1 .1 0 1 0 .2 0zm-384.2 0a.1 .1 0 1 0 .1 0 .1 .1 0 1 0 -.1 0zm0-350.6a.1 .1 0 1 0 .1-.1 .1 .1 0 1 0 -.1 .1zM416 80.6a.1 .1 0 1 0 -.1 .3 .1 .1 0 1 0 .1-.3zM448 432V80C448 35.8 347.7 0 224 0S0 35.8 0 80V432c0 44.2 100.3 80 224 80s224-35.8 224-80z"]
};
var faDownLeft = {
  prefix: 'fal',
  iconName: 'down-left',
  icon: [384, 512, [], "e16a", "M72 384c-4.4 0-8-3.6-8-8V174.6c0-3.7 3-6.6 6.6-6.6c1.8 0 3.4 .7 4.7 1.9l61.4 61.4c6.2 6.2 16.4 6.2 22.6 0L272 118.6c4.2-4.2 10-6.6 16-6.6s11.8 2.4 16 6.6L329.4 144c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16L216.7 288.7c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l61.4 61.4c1.2 1.2 1.9 2.9 1.9 4.7c0 3.7-3 6.6-6.6 6.6H72zm-40-8c0 22.1 17.9 40 40 40H273.4c21.3 0 38.6-17.3 38.6-38.6c0-10.2-4.1-20.1-11.3-27.3L250.6 300 352 198.6c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6L326.6 96C316.4 85.8 302.5 80 288 80s-28.4 5.8-38.6 16L148 197.4 97.9 147.3C90.7 140.1 80.9 136 70.6 136C49.3 136 32 153.3 32 174.6V376z"]
};
var faShare = {
  prefix: 'fal',
  iconName: 'share',
  icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M296 160c13.3 0 24-10.7 24-24v-8V112 64L480 208 320 352l0-48V288v-8c0-13.3-10.7-24-24-24h-8H192c-70.7 0-128 57.3-128 128c0 8.3 .7 16.1 2 23.2C47.9 383.7 32 350.1 32 304c0-79.5 64.5-144 144-144H288h8zm-8 144v16 32c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2V96v16 16H256 176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h64 32v16z"]
};
var faArrowTurnRight = faShare;
var faMailForward = faShare;
var faFaceThinking = {
  prefix: 'fal',
  iconName: 'face-thinking',
  icon: [512, 512, [], "e39b", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 108.4-76.9 198.8-179.2 219.5c-8.7 1.8-14.3 10.2-12.5 18.9s10.2 14.3 18.9 12.5C424 483.2 512 379.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 23.6 3.2 46.5 9.2 68.3c2.4 8.5 11.2 13.5 19.7 11.2s13.5-11.2 11.2-19.7c-5.2-19-8.1-39-8.1-59.7zm165.1 .8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l70.5 23.5L160 348.8V320c0-26.5-21.5-48-48-48s-48 21.5-48 48V440c0 39.8 32.2 72 72 72h47.8c29.4 0 55.9-17.9 66.9-45.3l23.9-59.6 47-18.4c20.9-8.2 32.8-29.4 30.1-50.7c-2.3-18.7-15.1-34.7-33.3-40.8L197.1 256.8zM320 342.7c0 .4 0 .9 0 1.3h0c0 6.4-3.9 12.4-10.2 14.9l-53.5 20.9c-4.3 1.7-7.7 5.2-9.2 9.5c-.1 .2-.1 .4-.2 .6l-26 64.9C214.8 470 200.1 480 183.8 480H136c-22.1 0-40-17.9-40-40V320c0-8.8 7.2-16 16-16s16 7.2 16 16v52.2c0 5.3 2.6 10.2 7 13.2s9.9 3.6 14.9 1.7l148.3-58c8.2-3.2 17.5 .8 20.7 9.1c.6 1.5 .9 3 1.1 4.5zM200.4 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-120-87.2l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 94.1 162.3 90 127.1 110.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4c23.5-13.4 52.9-10.6 73.4 7z"]
};
var faTurnDownRight = {
  prefix: 'fal',
  iconName: 'turn-down-right',
  icon: [512, 512, [], "e455", "M352 208l0-57.3c0-3.7 3-6.7 6.7-6.7c1.9 0 3.7 .8 5 2.2L476.2 272 363.7 397.8c-1.3 1.4-3.1 2.2-5 2.2c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-17.7-14.3-32-32-32l-176 0C82.1 304 32 253.9 32 192L32 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 112c0 26.5 21.5 48 48 48l176 0c17.7 0 32-14.3 32-32zm154.7 78c3.4-3.8 5.3-8.8 5.3-14s-1.9-10.1-5.3-14L387.5 124.9c-7.3-8.2-17.8-12.9-28.8-12.9c-21.4 0-38.7 17.3-38.7 38.7l0 25.3 0 32-32 0-144 0c-8.8 0-16-7.2-16-16l0-112c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80L0 192c0 79.5 64.5 144 144 144l144 0 32 0 0 32 0 25.3c0 21.4 17.3 38.7 38.7 38.7c11 0 21.5-4.7 28.8-12.9L506.7 286z"]
};
var faBottleDroplet = {
  prefix: 'fal',
  iconName: 'bottle-droplet',
  icon: [320, 512, [], "e4c4", "M72 16C72 7.2 79.2 0 88 0l8 0V0h32 64 32 8c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0V145.1c38.3 22.1 64 63.5 64 110.9V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V256c0-47.4 25.7-88.7 64-110.9V32l-8 0c-8.8 0-16-7.2-16-16zM192 32l-64 0V145.1c0 11.4-6.1 22-16 27.7C83.2 189.5 64 220.5 64 256V448c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-35.5-19.2-66.5-48-83.2c-9.9-5.7-16-16.3-16-27.7V32zm0 305c0-5.6-4-17.2-14.6-33.5c-5.4-8.3-11.5-16.5-17.4-23.6c-5.9 7.2-12 15.3-17.4 23.6C132 319.8 128 331.4 128 337c0 16.6 13.8 31 32 31c11.5 0 19.3-3.4 23.8-7.5c4-3.6 8.2-10.3 8.2-23.5zm32 0c0 42-28.7 63-64 63s-64-28.2-64-63c0-31 34.9-73.5 53.2-93.6c5.9-6.5 15.8-6.5 21.6 0C189.1 263.5 224 306 224 337z"]
};
var faMaskFace = {
  prefix: 'fal',
  iconName: 'mask-face',
  icon: [640, 512, [], "e1d7", "M320 96c20.9 0 41.3 6.2 58.6 17.8l37.1 24.8c21 14 45.7 21.5 71 21.5H504h8v64c0 106-86 192-192 192s-192-86-192-192V160h8 16 1.2c25.3 0 50-7.5 71-21.5l37.1-24.8C278.7 102.2 299.1 96 320 96zM153.2 128H152 136h-8H48c-26.5 0-48 21.5-48 48v85c0 51.4 35 96.2 84.8 108.7l71.3 17.8 14.9 3.7c39.6 35.3 91.8 56.8 149 56.8s109.4-21.5 149-56.8l14.9-3.7 71.3-17.8C605 357.2 640 312.4 640 261V176c0-26.5-21.5-48-48-48H512h-8H486.8c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64s-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1zM48 160H96v64c0 46.3 14 89.3 38.1 125L92.6 338.7C57 329.8 32 297.8 32 261V176c0-8.8 7.2-16 16-16zM547.4 338.7L505.9 349c24.1-35.7 38.1-78.7 38.1-125V160h48c8.8 0 16 7.2 16 16v85c0 36.7-25 68.7-60.6 77.6zM208 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm-16 80c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm48 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"]
};
var faHillRockslide = {
  prefix: 'fal',
  iconName: 'hill-rockslide',
  icon: [576, 512, [], "e508", "M238.5 127.7c-5.5-9.7-5.5-21.6 0-31.4l27-48C271.1 38.2 281.8 32 293.4 32h53.3c11.6 0 22.2 6.2 27.9 16.3l27 48c5.5 9.7 5.5 21.6 0 31.4l-27 48c-5.7 10.1-16.3 16.3-27.9 16.3H293.4c-11.6 0-22.2-6.2-27.9-16.3l-27-48zM293.4 64l-27 48 27 48 53.3 0 27-48-27-48-53.3 0zM32 118.6L32 448c0 17.7 14.3 32 32 32H393.4L32 118.6zm-32 0C0 90.1 34.5 75.8 54.6 96L416 457.4c20.2 20.2 5.9 54.6-22.6 54.6H64c-35.3 0-64-28.7-64-64V118.6zM432.3 406.5c-10.1-5.7-16.3-16.3-16.3-27.9V325.4c0-11.6 6.2-22.2 16.3-27.9l48-27c9.7-5.5 21.6-5.5 31.4 0l48 27c10.1 5.7 16.3 16.3 16.3 27.9v53.3c0 11.6-6.2 22.2-16.3 27.9l-48 27c-9.7 5.5-21.6 5.5-31.4 0l-48-27zm63.7-.9l48-27V325.4l-48-27-48 27v53.3l48 27zM128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faScannerKeyboard = {
  prefix: 'fal',
  iconName: 'scanner-keyboard',
  icon: [512, 512, [], "f489", "M128 16V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zm192 0V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM208 0c-8.8 0-16 7.2-16 16V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM400 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM496 0c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM288 128c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H288zM64 96C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 96H248c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40H248c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40zM80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zM64 400c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm-16 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z"]
};
var faCircleO = {
  prefix: 'fal',
  iconName: 'circle-o',
  icon: [512, 512, [], "e119", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-256a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z"]
};
var faGridHorizontal = {
  prefix: 'fal',
  iconName: 'grid-horizontal',
  icon: [448, 512, [], "e307", "M40 160c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H40zM0 168c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V168zM40 320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8H40zM0 328c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V328zM248 160H200c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm-48-32h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40zm0 192c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8H200zm-40 8c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V328zM408 160H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm-48-32h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40zm0 192c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8H360zm-40 8c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V328z"]
};
var faMessageDollar = {
  prefix: 'fal',
  iconName: 'message-dollar',
  icon: [512, 512, ["comment-alt-dollar"], "f650", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM272 104c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V312c0 8.8 7.2 16 16 16s16-7.2 16-16V294.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V104z"]
};
var faCommentAltDollar = faMessageDollar;
var faRightLeft = {
  prefix: 'fal',
  iconName: 'right-left',
  icon: [512, 512, ["exchange-alt"], "f362", "M352 222.7c0 18.4 14.9 33.3 33.3 33.3c8.4 0 16.4-3.1 22.6-8.8l99-91.4c3.3-3 5.1-7.3 5.1-11.8s-1.9-8.7-5.1-11.8l-99-91.4c-6.1-5.7-14.2-8.8-22.6-8.8C366.9 32 352 46.9 352 65.3V128H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H352v62.7zm33.3 1.3c-.7 0-1.3-.6-1.3-1.3V65.3c0-.7 .6-1.3 1.3-1.3c.3 0 .6 .1 .9 .3L472.4 144l-86.3 79.7c-.2 .2-.5 .3-.9 .3zM126.7 480c18.4 0 33.3-14.9 33.3-33.3V384H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V289.3c0-18.4-14.9-33.3-33.3-33.3c-8.4 0-16.4 3.1-22.6 8.8l-99 91.4C1.9 359.3 0 363.5 0 368s1.9 8.7 5.1 11.8l99 91.4c6.1 5.7 14.2 8.8 22.6 8.8zm1.3-33.3c0 .7-.6 1.3-1.3 1.3c-.3 0-.6-.1-.9-.3L39.6 368l86.3-79.7c.2-.2 .5-.3 .9-.3c.7 0 1.3 .6 1.3 1.3V446.7z"]
};
var faExchangeAlt = faRightLeft;
var faColumns3 = {
  prefix: 'fal',
  iconName: 'columns-3',
  icon: [640, 512, [], "e361", "M448 64V448H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H448zm-32 0H224V448H416V64zM192 448V64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H192zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faPaperPlane = {
  prefix: 'fal',
  iconName: 'paper-plane',
  icon: [512, 512, [61913], "f1d8", "M511.6 36.9c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256C5.5 266.3-.7 277.8 .1 290s8.4 22.9 19.6 27.6L160 376v93c0 23.8 19.3 43 43 43c13.1 0 25.4-5.9 33.6-16.1l52.8-66 .1 0 114.2 47.6c9.1 3.8 19.4 3.2 28-1.6s14.5-13.3 16-23l64-416zm-253 380.2l-47 58.8c-2.1 2.6-5.3 4.1-8.6 4.1c-6.1 0-11-4.9-11-11V389.3l66.6 27.8zm43.1-16.7l-96.6-40.3L474.1 70.5 416 448 301.8 400.4zM450.5 48.8L173.6 347 32 288 450.5 48.8z"]
};
var faRoadCircleExclamation = {
  prefix: 'fal',
  iconName: 'road-circle-exclamation',
  icon: [640, 512, [], "e565", "M157.5 74c9.2-25.2 33.2-42 60.1-42H422.4c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7c-1.5 0-2.9 0-4.4 .1L452.5 85c-4.6-12.6-16.6-21-30.1-21H336v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H217.6c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43H339.2c5.9 11.4 12.9 22.2 21 32H100.6c-44.5 0-75.4-44.2-60.1-86L157.5 74zM336 208v86.6c-3.5 7.6-6.5 15.6-8.9 23.8c-2.1 1.1-4.6 1.7-7.1 1.7c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faDungeon = {
  prefix: 'fal',
  iconName: 'dungeon',
  icon: [512, 512, [], "f6d9", "M319.3 163.6c6.2 4.2 11.9 9.1 17.1 14.4c6.1 6.3 14 11 22.7 13.5c-1.6 8.9-.8 18 2.2 26.2c3 8.2 5 16.9 6 25.9c1.1 10.4 5.7 20.5 12.9 28.5c-7.6 8.5-12.2 19.7-12.2 32v48c0 12.3 4.6 23.5 12.2 32c-7.6 8.5-12.2 19.7-12.2 32v48c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V416c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32V304c0-12.3-4.6-23.5-12.2-32c7.9-8.8 12.6-20.7 11.6-34.2c-2.1-30.4-9.6-59.3-21.4-85.8c-6.1-13.8-17.3-22.4-29.8-25.8c2.1-12.8-1-26.6-10.8-37.9c-17.9-20.6-39-38.3-62.5-52.3c-13-7.7-27.1-8.3-39.3-3.9c-5.7-11.7-16.2-21.1-30.8-24.7C297.2 2.5 276.9 0 256 0s-41.2 2.5-60.7 7.2c-14.6 3.6-25.1 13-30.8 24.7c-12.2-4.4-26.3-3.8-39.3 3.9c-23.6 14-44.7 31.7-62.5 52.3c-9.8 11.3-13 25.1-10.8 37.9c-12.5 3.5-23.7 12.1-29.8 25.8C10.2 178.5 2.8 207.4 .6 237.8c-1 13.5 3.7 25.4 11.6 34.2C4.6 280.5 0 291.7 0 304v48c0 12.3 4.6 23.5 12.2 32C4.6 392.5 0 403.7 0 416v48c0 26.5 21.5 48 48 48H96c26.5 0 48-21.5 48-48V416c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32V304c0-12.3-4.6-23.5-12.2-32c7.2-8 11.7-18.1 12.9-28.5c1-9 3.1-17.7 6-25.9c3-8.2 3.8-17.4 2.2-26.2c8.7-2.4 16.6-7.2 22.7-13.5c5.2-5.3 10.9-10.2 17.1-14.4c7.2-4.9 13.2-11.9 17.1-20c8.5 3 17.6 3.8 26.2 2.2c6.5-1.2 13.2-1.8 20-1.8s13.5 .6 20 1.8c8.6 1.5 17.7 .8 26.2-2.2c3.9 8.1 9.9 15.1 17.1 20zm62-5l0 0c-6.9 4.6-16.2 3.1-22-2.9c-6.7-6.9-14-13.1-21.9-18.5c-6.7-4.6-9.8-13.1-6.8-20.6l.2-.6 0 0 17.9-44.8c3.5-8.7 13.6-12.6 21.6-7.8c20.6 12.3 39.1 27.8 54.8 45.8c6 6.9 4.2 17.4-3.5 22.5l-1 .7 0 0-39.4 26.2zm16.2 27.6l1.5-1 0 0L438.4 159l0 0c7.8-5.2 18.5-2.6 22.3 6c10.3 23.2 16.8 48.5 18.7 75.1c.6 8.8-6.6 16-15.4 16H416c-8.8 0-15.9-7.2-16.9-16c-1.3-11.6-3.9-22.7-7.8-33.3c-2.7-7.5-.5-16.1 6.2-20.5zM416 400h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V416c0-8.8 7.2-16 16-16zM193 59.3l0 0-.2-.4c-3.4-8.6 1.1-18.3 10.1-20.5c17-4.1 34.8-6.3 53.1-6.3s36.1 2.2 53.1 6.3c9 2.2 13.5 11.9 10.1 20.5l-.2 .4 0 .1-17.9 44.8 0 0c-3.1 7.6-11.4 11.6-19.4 10.1c-8.3-1.5-16.9-2.3-25.7-2.3s-17.3 .8-25.7 2.3c-8.1 1.5-16.4-2.5-19.4-10.1l0 0L193 59.3zm-51.3 4.1c8-4.8 18.2-.9 21.6 7.8l0 0L181.2 116l0 0 .2 .6c3 7.5-.1 16-6.8 20.6c-7.9 5.4-15.3 11.6-21.9 18.5c-5.8 6-15.1 7.5-22 2.9L91.4 132.3l0 0-1-.7c-7.6-5.1-9.5-15.6-3.5-22.5c15.7-18 34.1-33.5 54.8-45.8zM51.3 165c3.8-8.6 14.5-11.2 22.3-6L113 185.2l0 0 1.5 1c6.6 4.4 8.9 13 6.2 20.5c-3.9 10.6-6.5 21.7-7.8 33.3c-1 8.8-8 16-16.9 16H48c-8.8 0-16.1-7.2-15.4-16c1.9-26.6 8.4-51.9 18.7-75.1zM112 304v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16zm288 0c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V304zM32 416c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V416zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"]
};
var faHandHoldingBox = {
  prefix: 'fal',
  iconName: 'hand-holding-box',
  icon: [576, 512, [], "f47b", "M208 32v96c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7L288 113.9l56.8 28.4c5 2.5 10.9 2.2 15.6-.7s7.6-8.1 7.6-13.6V32h64c8.8 0 16 7.2 16 16V208c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h64zM224 0H144C117.5 0 96 21.5 96 48V208c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H352 224zm16 32h96v70.1L295.2 81.7c-4.5-2.3-9.8-2.3-14.3 0L240 102.1V32zM195.4 304c-15.8 0-31.2 4.7-44.4 13.4L75.2 368H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80h4.8l4-2.7 79.9-53.3c7.9-5.3 17.1-8.1 26.6-8.1H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H320 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 24 60.6c2.9 0 5.7-.8 8.2-2.3L511.3 355c3.4-2 7.2-3 11.1-3h1.3c11.2 0 20.3 9.1 20.3 20.3c0 6.9-3.5 13.3-9.2 17L415.1 467.1c-13 8.4-28.1 12.9-43.6 12.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H371.5c21.7 0 42.9-6.3 61-18.1l119.6-77.8C567 406.5 576 390 576 372.3c0-28.9-23.4-52.3-52.3-52.3h-1.3c-9.7 0-19.1 2.6-27.5 7.6L400.2 384h-5.6c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56H195.4z"]
};
var faInputText = {
  prefix: 'fal',
  iconName: 'input-text',
  icon: [640, 512, [], "e1bf", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm176 32c6.5 0 12.4 4 14.9 10.1l64 160c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9L216.4 320l-.4 0H136l-.4 0-8.8 21.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l64-160c2.4-6.1 8.3-10.1 14.9-10.1zm0 59.1L148.4 288h55.1L176 219.1zM288 176c0-8.8 7.2-16 16-16h56c30.9 0 56 25.1 56 56c0 12.1-3.8 23.3-10.4 32.5C421.5 258.4 432 276 432 296c0 30.9-25.1 56-56 56H304c-8.8 0-16-7.2-16-16V320 256 192 176zm72 96H320v48h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H360zm0-32c13.3 0 24-10.7 24-24s-10.7-24-24-24H320v48h40z"]
};
var faWindowFlip = {
  prefix: 'fal',
  iconName: 'window-flip',
  icon: [512, 512, ["window-alt"], "f40f", "M448 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H448zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96zm-96 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM296 128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faWindowAlt = faWindowFlip;
var faAlignRight = {
  prefix: 'fal',
  iconName: 'align-right',
  icon: [448, 512, [], "f038", "M432 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16H432zm0 128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432zm16 144c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16zM432 432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432z"]
};
var faScannerGun = {
  prefix: 'fal',
  iconName: 'scanner-gun',
  icon: [576, 512, ["scanner"], "f488", "M112 64c-44.2 0-80 35.8-80 80s35.8 80 80 80H242.9 280h24c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112zM80 251.4C33.8 237.6 0 194.7 0 144C0 82.1 50.1 32 112 32H304c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H261.2L144.3 454.6c-13.4 22.8-42.9 30.5-65.7 17L25.2 440.2C2.4 426.8-5.2 397.5 8.1 374.7L80 251.4zm34.3 4.6L35.7 390.8c-4.4 7.6-1.9 17.4 5.7 21.9l53.4 31.4c7.6 4.5 17.4 1.9 21.9-5.7L224.1 256H114.4zM432 32H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16zm16 80H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16zm16 48H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16zM416 464c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16z"]
};
var faScanner = faScannerGun;
var faTire = {
  prefix: 'fal',
  iconName: 'tire',
  icon: [512, 512, [], "f631", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm319.9 4l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4zm-9.9 30.4c-8.6 13.5-22.1 23.5-38 27.6l0 65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1zM240 383l0-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4zM130.3 280.2L192.1 260c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 186.1 128 219.2 128 256c0 8.3 .8 16.3 2.3 24.2zm102.1-83.7c7.3-2.9 15.3-4.5 23.6-4.5s16.3 1.6 23.6 4.5l38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z"]
};
var faEngine = {
  prefix: 'fal',
  iconName: 'engine',
  icon: [640, 512, [], "e16e", "M416 80c0 8.8-7.2 16-16 16l-80 0v32h16 60.6c12.6 0 25 3.7 35.5 10.7L483.5 173c17.8 11.9 28.5 31.9 28.5 53.3V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H144c-26.5 0-48-21.5-48-48V272H88 32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80H88h8V176c0-26.5 21.5-48 48-48h16H288V96l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H400c8.8 0 16 7.2 16 16zM304 160H160 144c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16h28.8c9.7 0 18.9 4.4 25 12l32 40c6.1 7.6 15.3 12 25 12H448c17.7 0 32-14.3 32-32V226.3c0-10.7-5.3-20.7-14.2-26.6l-51.4-34.3c-5.3-3.5-11.4-5.4-17.8-5.4H336 304l0 0 0 0zM168 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-32V416h32V224H576zm-32 0c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224z"]
};
var faMoneyBill1Wave = {
  prefix: 'fal',
  iconName: 'money-bill-1-wave',
  icon: [576, 512, ["money-bill-wave-alt"], "f53b", "M32 112.5l0-.1s0 0 0 0l0 0 0 0 0 0c.1-.1 .4-.6 1.3-1.2c2-1.3 4.7-1.8 6.9-1.2c18.7 5.1 37.3 8.1 55.8 9.5v.5c0 35.3-28.7 64-64 64V112.5zm0 309.9V376c35.3 0 64 28.7 64 64v6.8c-19.5-1.9-38.7-6-57.8-13.2c-2.5-.9-6.2-4.5-6.2-11.3zM128 440c0-53-43-96-96-96V216c52.9 0 95.8-42.8 96-95.6c57.8-1 113.9-15.3 165.7-28.6c4.4-1.1 8.7-2.2 13-3.3C356.9 75.8 403.3 65 448 64v8c0 53 43 96 96 96V296c-52.9 0-95.8 42.8-96 95.6c-57.8 1-113.9 15.3-165.7 28.6c-4.4 1.1-8.7 2.2-13 3.3C219.1 436.2 172.7 447 128 448v-8zm352-47.5V392c0-35.3 28.7-64 64-64v71.5c0 .1 0 .1 0 .1s0 0 0 0c-.1 .1-.4 .6-1.3 1.2c-2 1.3-4.7 1.8-6.9 1.2c-18.6-5.1-37.3-8.1-55.8-9.5zm0-327.3c19.5 1.9 38.7 6 57.8 13.2c2.5 .9 6.2 4.5 6.2 11.3V136c-35.3 0-64-28.7-64-64V65.2zM0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM400 256c0-65-44.9-128-112-128s-112 63-112 128s44.9 128 112 128s112-63 112-128zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM272 192c-8.8 0-16 7.2-16 16s7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24 24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V208c0-8.8-7.2-16-16-16H272z"]
};
var faMoneyBillWaveAlt = faMoneyBill1Wave;
var faLifeRing = {
  prefix: 'fal',
  iconName: 'life-ring',
  icon: [512, 512, [], "f1cd", "M402.7 425.3C363.4 459.4 312.1 480 256 480s-107.4-20.6-146.7-54.7l91.1-91C216.1 345.4 235.3 352 256 352s39.9-6.6 55.6-17.7l91.1 91zm22.6-22.6l-91-91.1C345.4 295.9 352 276.7 352 256s-6.6-39.9-17.7-55.6l91-91.1C459.4 148.6 480 199.9 480 256s-20.6 107.4-54.7 146.7zM448 425.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L425.4 64C380.2 24.2 320.9 0 256 0S131.8 24.2 86.6 64L75.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L64 86.6C24.2 131.8 0 191.1 0 256s24.2 124.2 64 169.4L52.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448c45.1 39.8 104.4 64 169.4 64s124.2-24.2 169.4-64l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L448 425.4zM402.7 86.7l-91.1 91.1C295.9 166.6 276.7 160 256 160s-39.9 6.6-55.6 17.7L109.3 86.7C148.6 52.6 199.9 32 256 32s107.4 20.6 146.7 54.7zM177.7 311.6L86.7 402.7C52.6 363.4 32 312.1 32 256s20.6-107.4 54.7-146.7l91.1 91.1C166.6 216.1 160 235.3 160 256s6.6 39.9 17.7 55.6zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faHands = {
  prefix: 'fal',
  iconName: 'hands',
  icon: [608, 512, ["sign-language", "signing"], "f2a7", "M439.9 395.4c11.5-2.6 22.9-6.3 34-11.4c62.7-28.4 102.7-91 102.2-159.8l-.5-75.6c-.2-26.5-21.8-47.8-48.3-47.7c-19.5 .1-36.2 11.9-43.6 28.6L439 31C428.1 6.8 399.7-3.9 375.5 7c-5.7 2.6-10.6 6.1-14.7 10.4C347.3 1.1 324.2-4.8 304 4.3s-31 30.5-27.6 51.3c-5.9 .3-11.8 1.7-17.5 4.2c-19.3 8.8-30 28.7-27.9 48.7l40.4 17.5-7.2-15.9c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8L315.1 145l10.2 4.4 .4 .2 0 0c12.8 5.7 24.8 12.6 35.9 20.5L322.4 83.8 309.2 54.6c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8l13.2 29.1L391.2 158c3.6 8 13.1 11.6 21.2 8s11.6-13.1 8-21.2L380.7 57.4c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8l71.5 157.8c3.1 6.9 10.6 10.6 18 9s12.6-8.2 12.6-15.7l-.3-46.2c-.1-8.8 7.1-16 15.9-16.1s16.1 7.1 16.1 15.9l.5 75.7c.4 56.1-32.3 107.3-83.5 130.4c-4.6 2.1-9.2 3.9-13.9 5.4c-1.3 12-3.6 23.8-6.9 35.1zm-209.4-218l69.1 30.7c51.3 22.8 84.4 73.7 84.4 129.8C384 416.4 320.4 480 241.9 480H112c-8.8 0-16-7.2-16-16c0-8.8 7.1-16 16-16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64.1 0L96 416l0 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l0 0h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64l0 0H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H80l0 0h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16-7.2-16-16c0-8.8 7.2-16 16-16H253.2c7.6 0 14.1-5.3 15.7-12.7s-2.2-14.9-9.2-17.9l-42.2-18.8c-8.1-3.6-11.7-13-8.1-21.1s13-11.7 21.1-8.1zM67.4 446.3C65.2 451.8 64 457.8 64 464c0 26.5 21.5 48 48 48H241.9C338.1 512 416 434.1 416 337.9c0-68.8-40.5-131.1-103.4-159.1l-69.1-30.7c-24.2-10.8-52.6 .1-63.4 24.4c-7.9 17.8-4.1 37.8 8.1 51.5H80c-26.5 0-48 21.5-48 48c0 6.2 1.2 12.2 3.4 17.7C15 295.2 0 313.9 0 336s15 40.8 35.4 46.3C33.2 387.8 32 393.8 32 400c0 22.1 15 40.8 35.4 46.3z"]
};
var faSignLanguage = faHands;
var faSigning = faHands;
var faCircleCaretRight = {
  prefix: 'fal',
  iconName: 'circle-caret-right',
  icon: [512, 512, ["caret-circle-right"], "f330", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm352 0c0-9.6-4-18.7-11-25.2L238.2 135.3c-5.1-4.7-11.8-7.3-18.7-7.3c-15.2 0-27.5 12.3-27.5 27.5l0 201c0 15.2 12.3 27.5 27.5 27.5c6.9 0 13.6-2.6 18.7-7.3L341 281.2c7-6.5 11-15.6 11-25.2zm-32.7-1.7c.5 .4 .7 1.1 .7 1.7s-.3 1.3-.7 1.7L224 346.2l0-180.3 95.3 88.4z"]
};
var faCaretCircleRight = faCircleCaretRight;
var faWheat = {
  prefix: 'fal',
  iconName: 'wheat',
  icon: [512, 512, [], "f72d", "M433.1 36c-28.7 1.4-51.7 24.4-53.1 53.1l-2.3 45.2 45.2-2.3c28.7-1.4 51.7-24.4 53.1-53.1l2.3-45.2L433.1 36zM348 87.5C350.3 42.4 386.4 6.3 431.5 4l54-2.7c14.2-.7 25.9 11 25.2 25.2l-2.7 54c-2.3 45.1-38.3 81.2-83.5 83.5l-16.9 .8c23.1 5 45.2 16.6 63.2 34.6L493.4 222c6.2 6.2 6.2 16.4 0 22.6l-33.9 33.9c-17.4 17.4-39.8 26.7-62.6 28l6 6c6.2 6.2 6.2 16.4 0 22.6L369 369c-17.4 17.4-39.8 26.7-62.5 28l6 6c6.2 6.2 6.2 16.4 0 22.6l-33.9 33.9c-37.5 37.5-98.3 37.5-135.8 0l-33.9-33.9 0 0L27.3 507.1c-6.2 6.2-16.4 6.3-22.6 0s-6.2-16.4 0-22.6L86.2 403 52.3 369.1c-37.5-37.5-37.5-98.3 0-135.8l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0l6 6c1.3-22.8 10.6-45.2 28-62.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0l6 6c1.3-22.8 10.6-45.2 28-62.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0L312.4 41c18.3 18.3 29.9 40.7 34.8 64.2l.9-17.7zm88.8 168.4l22.6-22.6L448.1 222c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0zm-181-90.5l33.9 33.9 1.5-1.5c36-37.6 35.5-97.3-1.5-134.3L278.5 52.3 255.9 74.9c-25 25-25 65.5 0 90.5zm-56.6-11.3L188 142.8l-22.6 22.6c-25 25-25 65.5 0 90.5l33.9 33.9 1.3-1.3c36.2-37.6 35.8-97.4-1.3-134.5zM108.8 380.3l.8-.8c36.7-37.6 36.4-97.7-.8-135L97.5 233.3 74.9 255.9c-25 25-25 65.5 0 90.5l33.9 33.9zm147.1 56.5l22.6-22.6L267.2 403c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0zm90.5-90.5l22.6-22.6-11.3-11.3c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0z"]
};
var faFileSpreadsheet = {
  prefix: 'fal',
  iconName: 'file-spreadsheet',
  icon: [384, 512, [], "f65b", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM96 384h80v32H96V384zm0-32V320h80v32H96zm112 64V384h80v32H208zm0-64V320h80v32H208zm112 16V352 320 304 288 256c0-17.7-14.3-32-32-32H192 96c-17.7 0-32 14.3-32 32v32 16 16 32 16 16 32c0 17.7 14.3 32 32 32h80 16 16 80c17.7 0 32-14.3 32-32V384 368zM288 256v32H192 96V256h96 96z"]
};
var faAudioDescriptionSlash = {
  prefix: 'fal',
  iconName: 'audio-description-slash',
  icon: [640, 512, [], "e0a8", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM459.9 448H96c-17.7 0-32-14.3-32-32V135.4L32 110.2V416c0 35.3 28.7 64 64 64H500.4l-40.5-32zM544 32H139.6l40.5 32H544c17.7 0 32 14.3 32 32V376.6l32 25.3V96c0-35.3-28.7-64-64-64zM512 256c0-53-43-96-96-96H352c-8.8 0-16 7.2-16 16v11.1l32 25.3V192h48c35.3 0 64 28.7 64 64c0 13.4-4.1 25.8-11.1 36l25.2 19.9c11.3-15.7 17.9-35 17.9-55.9zM129.7 328.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L177.9 304h92.2l19.6 39.2c4 7.9 13.6 11.1 21.5 7.2c5.1-2.6 8.3-7.5 8.8-12.8L237 272H193.9l12.2-24.4-25.7-20.3L129.7 328.8z"]
};
var faCalendarDay = {
  prefix: 'fal',
  iconName: 'calendar-day',
  icon: [448, 512, [], "f783", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zm40 160h80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V264c0-4.4 3.6-8 8-8zm-40 8v80c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V264c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z"]
};
var faWaterLadder = {
  prefix: 'fal',
  iconName: 'water-ladder',
  icon: [576, 512, ["ladder-water", "swimming-pool"], "f5c5", "M128 112c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-26.5-21.5-48-48-48s-48 21.5-48 48V224.2H384V112c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-26.5-21.5-48-48-48s-48 21.5-48 48V240.2 378.2c-10.8 4-21.8 6.2-32 6.2h0V256.2H160V378.2c-9.5-3.5-18.8-8.3-27.1-14.1c-1.6-1.1-3.2-2.2-4.9-3.1V240.2 112zm64 336c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z"]
};
var faLadderWater = faWaterLadder;
var faSwimmingPool = faWaterLadder;
var faArrowsUpDown = {
  prefix: 'fal',
  iconName: 'arrows-up-down',
  icon: [320, 512, ["arrows-v"], "f07d", "M171.3 4.7c-6.1-6.1-15.9-6.3-22.2-.4l-104 96c-6.5 6-6.9 16.1-.9 22.6s16.1 6.9 22.6 .9L144 52.5V457.4L75.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 457.4V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96z"]
};
var faArrowsV = faArrowsUpDown;
var faChessPawnPiece = {
  prefix: 'fal',
  iconName: 'chess-pawn-piece',
  icon: [256, 512, ["chess-pawn-alt"], "f444", "M176 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm16 80h-6.1l10.7 96H164.3l-10.7-96H128 102.3L91.6 352H59.5l10.7-96H64c-8.8 0-16-7.2-16-16s7.2-16 16-16c-10-13.4-16-30-16-48c0-44.2 35.8-80 80-80s80 35.8 80 80c0 18-6 34.6-16 48c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-1.8 128c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1H190.2zM33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4H216.6c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L190.2 416 65.8 416 33.1 468.7z"]
};
var faChessPawnAlt = faChessPawnPiece;
var faFaceGrimace = {
  prefix: 'fal',
  iconName: 'face-grimace',
  icon: [512, 512, [128556, "grimace"], "f57f", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V320h-8zm40 48h32V320H208v48zm96 0V320H272v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zM168 288H344c30.9 0 56 25.1 56 56s-25.1 56-56 56H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-15.6-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGrimace = faFaceGrimace;
var faWheelchairMove = {
  prefix: 'fal',
  iconName: 'wheelchair-move',
  icon: [448, 512, ["wheelchair-alt"], "e2ce", "M368 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 368 0zM199.5 106.9c-11.9-4.9-25.6-2.1-34.7 7l-41.4 41.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l41.4-41.4c18.2-18.2 45.6-23.7 69.5-14L313.5 119c31.7 13 40 54.1 15.8 78.4l-49.1 49.1c6.9 7.9 13.1 16.4 18.4 25.6H412.1c20.5 0 35.7 19 31.2 38.9L415.6 435.5c-1.9 8.6-10.5 14.1-19.1 12.1s-14.1-10.5-12.1-19.1L412.1 304H312.7c4.8 15.2 7.3 31.3 7.3 48c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c5.6 0 11.1 .3 16.5 .8l67.7-67.7-44.7-18.3zm107.2 67.8c8.1-8.1 5.3-21.8-5.3-26.1l-25.1-10.3-62.8 62.8c15.7 5.6 30.3 13.5 43.3 23.4l49.9-49.9zM160 480a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]
};
var faWheelchairAlt = faWheelchairMove;
var faTurnDown = {
  prefix: 'fal',
  iconName: 'turn-down',
  icon: [384, 512, [10549, "level-down-alt"], "f3be", "M128 352H70.7c-3.7 0-6.7 3-6.7 6.7c0 1.9 .8 3.7 2.2 5L192 476.2 317.8 363.7c1.4-1.3 2.2-3.1 2.2-5c0-3.7-3-6.7-6.7-6.7H256c-17.7 0-32-14.3-32-32V144c0-61.9-50.1-112-112-112H48c-8.8 0-16 7.2-16 16V80c0 8.8 7.2 16 16 16l64 0c26.5 0 48 21.5 48 48V320c0 17.7-14.3 32-32 32zm78 154.7c-3.8 3.4-8.8 5.3-14 5.3s-10.1-1.9-14-5.3L44.9 387.5C36.7 380.2 32 369.7 32 358.7C32 337.3 49.3 320 70.7 320H96h32V288 144c0-8.8-7.2-16-16-16l-64 0C21.5 128 0 106.5 0 80V48C0 21.5 21.5 0 48 0h64c79.5 0 144 64.5 144 144V288v32h32 25.3c21.4 0 38.7 17.3 38.7 38.7c0 11-4.7 21.5-12.9 28.8L206 506.7z"]
};
var faLevelDownAlt = faTurnDown;
var faSquareS = {
  prefix: 'fal',
  iconName: 'square-s',
  icon: [448, 512, [], "e27d", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160.7 94c-1.5 8.5-.5 14.1 1.5 18.2c2 4.2 5.7 8.3 11.7 12.3c12.8 8.4 31.8 13.9 54.4 20.1l1.5 .4c20.7 5.7 44.5 12.3 62 23.8c9.3 6.1 17.7 14.3 23 25.2c5.3 11.1 6.6 23.8 4 37.7c-4.5 24.3-21.6 40.2-43.1 48.5c-21.1 8.1-47.2 9.5-74.1 5.6l-.1 0 0 0c-17-2.6-46.2-11.2-61.2-15.9c-8.4-2.6-13.1-11.6-10.5-20.1s11.6-13.1 20.1-10.5c15.2 4.8 42.2 12.6 56.4 14.8c23.4 3.4 43.6 1.8 57.9-3.8c13.9-5.4 21.2-13.8 23.1-24.4c1.5-8.5 .5-14.1-1.5-18.2c-2-4.2-5.7-8.3-11.7-12.3c-12.8-8.4-31.8-13.9-54.4-20.1l-1.5-.4 0 0c-20.7-5.7-44.5-12.3-62-23.8c-9.3-6.1-17.7-14.3-23-25.2c-5.3-11.1-6.6-23.8-4-37.7c4.5-24.3 21.6-40.2 43.1-48.5c21.1-8.1 47.2-9.5 74.1-5.6c8.4 1.2 25.9 5 34.1 7c8.6 2.2 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6c-7.6-1.9-24-5.4-31-6.4c-23.4-3.5-43.6-1.8-57.9 3.8c-13.9 5.4-21.2 13.8-23.1 24.4z"]
};
var faRectangleBarcode = {
  prefix: 'fal',
  iconName: 'rectangle-barcode',
  icon: [576, 512, ["barcode-alt"], "f463", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 48c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm288 0c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm80-16c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM160 144c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm80-16c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144z"]
};
var faBarcodeAlt = faRectangleBarcode;
var faPersonWalkingArrowRight = {
  prefix: 'fal',
  iconName: 'person-walking-arrow-right',
  icon: [640, 512, [], "e552", "M176 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 144 56a56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L240.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2L66.9 422.5 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zm419.1-190c-6.8-5.7-16.9-4.7-22.5 2s-4.7 16.9 2 22.5L579.8 240H384c-8.8 0-16 7.2-16 16s7.2 16 16 16H579.8l-62.1 51.7c-6.8 5.7-7.7 15.7-2 22.5s15.7 7.7 22.5 2l96-80c3.6-3 5.8-7.5 5.8-12.3s-2.1-9.3-5.8-12.3l-96-80z"]
};
var faSquareEnvelope = {
  prefix: 'fal',
  iconName: 'square-envelope',
  icon: [448, 512, ["envelope-square"], "f199", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM352 160v29.2L231.3 255.6c-2.2 1.2-4.7 1.9-7.3 1.9s-5.1-.6-7.3-1.9L96 189.2V160H352zm0 65.7V352H96V225.7l105.3 57.9c7 3.8 14.8 5.8 22.7 5.8s15.8-2 22.7-5.8L352 225.7zM96 128c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96z"]
};
var faEnvelopeSquare = faSquareEnvelope;
var faDice = {
  prefix: 'fal',
  iconName: 'dice',
  icon: [640, 512, [127922], "f522", "M252.3 57c-15.6-15.6-40.9-15.6-56.6 0L57 195.7c-15.6 15.6-15.6 40.9 0 56.6L195.7 391c15.6 15.6 40.9 15.6 56.6 0L391 252.3c15.6-15.6 15.6-40.9 0-56.6L252.3 57zM173.1 34.3c28.1-28.1 73.7-28.1 101.8 0L413.7 173.1c28.1 28.1 28.1 73.7 0 101.8L274.9 413.7c-28.1 28.1-73.7 28.1-101.8 0L34.3 274.9c-28.1-28.1-28.1-73.7 0-101.8L173.1 34.3zM320 448V413.8l32-32V448c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H466.7c0-10.8-1.7-21.6-5-32H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H384c-35.3 0-64-28.7-64-64zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM120 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 152a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faUnicorn = {
  prefix: 'fal',
  iconName: 'unicorn',
  icon: [640, 512, [129412], "f727", "M448 32h24 8 5.8c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7c-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1H432c-8.8 0-16 7.2-16 16v52.8c-.3 1.5-.4 3-.3 4.5c.2 2.2 .3 4.4 .3 6.7c0 24-10.4 45.1-26.7 59.6c-3.4 3-5.3 7.4-5.3 11.9V472c0 4.4-3.6 8-8 8H344c-4.4 0-8-3.6-8-8V334.7c0-7.8-5.6-14.5-13.3-15.8c-1.4-.2-2.8-.5-4.3-.8L202.2 291.9c-5.2-1.2-10.6 .3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7c0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1H141.6c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9c0-4.6-.9-9.3-2.7-13.5L99.9 230.2C97.3 224 96 217.4 96 210.7c0-28 22.7-50.7 50.7-50.7H192h40 88c8.8 0 16-7.2 16-16c0-61.9 50.1-112 112-112zM564.2 64c-2.5-12.2-7.7-23.4-15-32.9C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16H485.8 480h-8H448C373.9 0 312.8 56 304.9 128H232 192 146.7c-33.5 0-62.3 19.9-75.3 48.5C31.3 180.8 0 214.7 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-20.9 13.4-38.7 32-45.3c0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2 .4 .2 .8 .2 1.2c0 .4-.1 .9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3h33.2c26.5 0 45.6-25.2 38.5-50.7l-15.9-57.2c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4L304 347.6V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V318.4c19.6-20 32-47.5 32-78.4c0-1.9-.1-3.9-.1-5.8c.1-.7 .1-1.4 .1-2.2V192h7.4l1.7 2.5c19 28.6 57.4 36.8 86.5 18.6c20.4-12.7 31.8-35.9 29.6-59.9l-4.7-49.4 65.2-21.7c3.8-1.3 6.4-4.8 6.4-8.8c0-5.1-4.2-9.3-9.3-9.3H564.2zM480 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faBowlingBall = {
  prefix: 'fal',
  iconName: 'bowling-ball',
  icon: [512, 512, [], "f436", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm240-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-120-8a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM240 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPompebled = {
  prefix: 'fal',
  iconName: 'pompebled',
  icon: [512, 512, [], "e43d", "M257.2 22.7c53.3 36.8 58 117.1 21.4 183.5l-.4 .7-.5 .7c-.6 .9-.4 2 .3 2.5c.2 .2 .4 .2 .4 .2s.2 0 .2 0s.2 0 .3-.1s.3-.2 .4-.5l.4-.6 .4-.5c47.8-58 123.3-82.4 176.4-44.3c64 45.3 72.1 140.1 25.2 209.7l0 0c-83.4 123.2-257.1 185-380.5 96.5l9.3-13-9.3 13c0 0 0 0 0 0C-21.9 382.3-27.4 196.3 56.1 73.1c0 0 0 0 0 0L69.3 82 56.1 73c0 0 0 0 0 0C103.1 2.9 192.9-22.8 257.2 22.7zM238.8 48.8C192.6 16.1 122.2 31.9 82.6 90.9l0 .1C5.7 204.5 15 369.3 120.1 444.4l0 0C224.2 519 378.6 469.5 455.5 356c39.6-58.7 29.4-132.7-17.2-165.7l-.1-.1c-33.4-24-90.3-12.8-132.7 38.3c-10.7 14.7-31 18.3-46 7.5c-14.7-10.6-18.2-30.8-8.5-45.8C283.1 131.4 273.1 72.4 239 49l-.2-.1 0 0z"]
};
var faBrain = {
  prefix: 'fal',
  iconName: 'brain',
  icon: [512, 512, [129504], "f5dc", "M144.2 75.4c-.6 6.7-5.4 12.4-12 14C111.4 94.7 96 113.6 96 136c0 3.1 .3 6.2 .9 9.2c1.5 7.6-2.7 15.2-10 18C68.8 170 56 187.6 56 208c0 5.2 .8 10.3 2.4 15c2 6.1 .2 12.8-4.6 17C40.4 251.7 32 268.9 32 288c0 22.9 12 43 30.2 54.3c6.7 4.2 9.3 12.6 6.3 19.8C65.6 368.8 64 376.2 64 384c0 30.9 25.1 56 56 56c3.3 0 6.5-.3 9.5-.8c7.5-1.3 14.9 2.9 17.6 10c6.9 18 24.4 30.8 44.8 30.8c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48c-25 0-45.5 19.1-47.8 43.4zM256 480c-14.6 19.4-37.8 32-64 32c-29.6 0-55.5-16.1-69.3-40c-.9 0-1.8 0-2.7 0c-48.6 0-88-39.4-88-88c0-7.6 1-15 2.8-22C13.6 344.4 0 317.8 0 288c0-25.1 9.6-48 25.4-65c-.9-4.9-1.4-9.9-1.4-15c0-29.6 16.1-55.5 40-69.3c0-.9 0-1.8 0-2.7c0-33.6 20.7-62.4 50.1-74.2C122.3 26.4 154.1 0 192 0c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c37.9 0 69.7 26.4 77.9 61.8C427.3 73.6 448 102.4 448 136c0 .9 0 1.8 0 2.7c23.9 13.8 40 39.7 40 69.3c0 5.1-.5 10.1-1.4 15c15.8 17.1 25.4 40 25.4 65c0 29.8-13.6 56.4-34.8 74c1.8 7.1 2.8 14.4 2.8 22c0 48.6-39.4 88-88 88c-.9 0-1.8 0-2.7 0c-13.8 23.9-39.7 40-69.3 40c-26.2 0-49.4-12.6-64-32zm16-48c0 26.5 21.5 48 48 48c20.4 0 37.9-12.8 44.8-30.8c2.7-7.1 10.1-11.3 17.6-10c3.1 .5 6.3 .8 9.5 .8c30.9 0 56-25.1 56-56c0-7.8-1.6-15.2-4.4-21.8c-3.1-7.2-.4-15.7 6.3-19.8C468 331 480 310.9 480 288c0-19.1-8.4-36.3-21.7-48.1c-4.8-4.2-6.6-10.9-4.6-17c1.5-4.7 2.4-9.7 2.4-15c0-20.4-12.8-38-30.9-44.9c-7.3-2.8-11.5-10.4-10-18c.6-3 .9-6 .9-9.2c0-22.4-15.4-41.3-36.2-46.5c-6.6-1.7-11.4-7.3-12-14C365.5 51.1 345 32 320 32c-26.5 0-48 21.5-48 48V432z"]
};
var faWatchSmart = {
  prefix: 'fal',
  iconName: 'watch-smart',
  icon: [384, 512, [], "e2cc", "M96 48V64H288V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48C64 21.5 85.5 0 112 0H272c26.5 0 48 21.5 48 48V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16V448H96v16zM80 96c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zm128 80v71.4l40.9 27.2c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-48-32c-4.5-3-7.1-8-7.1-13.3V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faBookUser = {
  prefix: 'fal',
  iconName: 'book-user',
  icon: [448, 512, [], "f7e7", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM240 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM208 272c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48H208z"]
};
var faSensorCloud = {
  prefix: 'fal',
  iconName: 'sensor-cloud',
  icon: [640, 512, ["sensor-smoke"], "e02c", "M64 64H384c17.7 0 32 14.3 32 32V225c11.2 1.4 21.9 4.2 32 8.3V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H237.8c-5.2-9.9-9.1-20.7-11.4-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM336 352c0-35.3 28.7-64 64-64c24.4 0 45.7 13.7 56.5 33.9c2.5 4.6 7 7.7 12.1 8.3s10.3-1.3 13.8-5.1C489.8 317 500.3 312 512 312c22.1 0 40 17.9 40 40c0 .4 0 .9 0 1.3c-.2 7.7 5 14.4 12.5 16.1c24.9 5.7 43.6 28 43.6 54.6c0 30.9-25.1 56-56 56H344c-30.9 0-56-25.1-56-56c0-24.4 15.6-45.2 37.4-52.8c6.7-2.4 11-8.8 10.7-15.9c-.1-1.1-.1-2.2-.1-3.3zm64-96c-50.8 0-92.4 39.5-95.8 89.5C275.6 360 256 389.7 256 424c0 48.6 39.4 88 88 88H552c48.6 0 88-39.4 88-88c0-37.6-23.6-69.7-56.7-82.3c-5-34.9-35-61.7-71.3-61.7c-13.9 0-27 4-38 10.8c-17.6-21.3-44.2-34.8-74-34.8z"]
};
var faSensorSmoke = faSensorCloud;
var faClapperboardPlay = {
  prefix: 'fal',
  iconName: 'clapperboard-play',
  icon: [512, 512, [], "e132", "M480 192V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H480zm0-32H382.6l87.3-87.3C476.1 78.5 480 86.8 480 96v64zm-249.4 0l96-96H433.4l-96 96H230.6zm-45.3 0H78.6l96-96H281.4l-96 96zM64 64h65.4l-96 96H32V96c0-17.7 14.3-32 32-32zm448 96V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64 16 16V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192 176 160zM216.1 226.2c-4.9-2.9-11.1-2.9-16.1-.1s-8.1 8.1-8.1 13.9V400c0 5.7 3.1 11 8.1 13.9s11.1 2.8 16.1-.1l136-80c4.9-2.9 7.9-8.1 7.9-13.8s-3-10.9-7.9-13.8l-136-80zM312.4 320L224 372V268l88.4 52z"]
};
var faBandage = {
  prefix: 'fal',
  iconName: 'bandage',
  icon: [640, 512, [129657, "band-aid"], "f462", "M480 128V384h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H480zm-32 0H192V384H448V128zM160 384V128H80c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h80zm0-288h32H448h32 80c44.2 0 80 35.8 80 80V336c0 44.2-35.8 80-80 80H480 448 192 160 80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80h80zm112 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faBandAid = faBandage;
var faCalendarMinus = {
  prefix: 'fal',
  iconName: 'calendar-minus',
  icon: [512, 512, [], "f272", "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H96c-35.3 0-64 28.7-64 64v32 32V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H384V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H160V16zM64 192H448V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V192zM96 96H416c17.7 0 32 14.3 32 32v32H64V128c0-17.7 14.3-32 32-32zM336 352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336z"]
};
var faCircleXmark = {
  prefix: 'fal',
  iconName: 'circle-xmark',
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faTimesCircle = faCircleXmark;
var faXmarkCircle = faCircleXmark;
var faCircle4 = {
  prefix: 'fal',
  iconName: 'circle-4',
  icon: [512, 512, [], "e0f1", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM229.9 129.1c8.2 3.3 12.2 12.6 8.9 20.8L183.6 288H288V208c0-8.8 7.2-16 16-16s16 7.2 16 16v80h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H160c-5.3 0-10.3-2.6-13.2-7s-3.6-10-1.6-14.9l64-160c3.3-8.2 12.6-12.2 20.8-8.9z"]
};
var faGifts = {
  prefix: 'fal',
  iconName: 'gifts',
  icon: [640, 512, [], "f79c", "M193.1 21.3c3-8.3-1.4-17.5-9.7-20.4s-17.5 1.4-20.4 9.7L144.5 62.8 127.2 10.9C124.4 2.6 115.3-2 106.9 .8S94 12.7 96.8 21.1L113 69.7 65.4 35.1c-7.1-5.2-17.2-3.6-22.4 3.5s-3.6 17.2 3.5 22.4L94.8 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H200.6c-5.4-9.4-8.6-20.3-8.6-32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H224c13.5 0 25.1 8.4 29.8 20.3c5.7-10 13.1-18.9 21.6-26.4C263.8 106.2 245.1 96 224 96H193.2l48.2-35.1c7.1-5.2 8.7-15.2 3.5-22.4s-15.2-8.7-22.4-3.5L176.3 68.7l16.8-47.4zM361.8 172.6L401.4 224H392 336c-17.7 0-32-14.3-32-32c0-17.6 14.4-32 32.2-32c10 0 19.6 4.7 25.6 12.6zM272 192c0 11.7 3.1 22.6 8.6 32H272c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-8.6c5.4-9.4 8.6-20.3 8.6-32c0-35.4-28.9-64-64.2-64c-19.9 0-38.8 9.2-51 25.1L432 211.4l-44.8-58.3c-12.2-15.8-31.1-25.1-51-25.1c-35.3 0-64.2 28.6-64.2 64zm-16 80c0-8.8 7.2-16 16-16h64 56 24v96H256V272zm0 192V384H416v96H272c-8.8 0-16-7.2-16-16zm352 0c0 8.8-7.2 16-16 16H448V384H608v80zm0-192v80H448V256h24 56 64c8.8 0 16 7.2 16 16zM472 224h-9.4l39.6-51.4c6.1-7.9 15.6-12.6 25.6-12.6c17.7 0 32.2 14.4 32.2 32c0 17.7-14.3 32-32 32H472z"]
};
var faAlbumCollection = {
  prefix: 'fal',
  iconName: 'album-collection',
  icon: [512, 512, [], "f8a0", "M32 16c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H48C39.2 0 32 7.2 32 16zM16 80c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272C31.4 489.9 55.6 512 84.5 512H427.5c29 0 53.1-22.1 55.8-50.9l24.7-272c3-32.8-22.8-61.1-55.8-61.1H59.8zM35.9 186.2C34.6 172.1 45.7 160 59.8 160H452.2c14.1 0 25.2 12.1 23.9 26.2l-24.7 272c-1.1 12.4-11.5 21.8-23.9 21.8H84.5c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272zM256 416c-77.7 0-128-49.3-128-96s50.3-96 128-96s128 49.3 128 96s-50.3 96-128 96zm0 32c88.4 0 160-57.3 160-128s-71.6-128-160-128s-160 57.3-160 128s71.6 128 160 128zm0-104c13.3 0 24-9 24-20s-10.7-20-24-20s-24 9-24 20s10.7 20 24 20z"]
};
var faHotel = {
  prefix: 'fal',
  iconName: 'hotel',
  icon: [512, 512, [127976], "f594", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H32V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H240h32H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM272 432v48H240V432c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H64V32H448V480H304V432zM320 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm64 0v32H352V96h32zM240 64c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H240zm0 32h32v32H240V96zM208 224v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32zm64 0v32H240V224h32zm80-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H352zm0 32h32v32H352V224zM96 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm64 0v32H128V96h32zm-32 96c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H128zm0 32h32v32H128V224zm68.4 154.7C211 362.3 232.3 352 256 352s45 10.3 59.6 26.7c5.9 6.6 16 7.1 22.6 1.3s7.1-16 1.3-22.6C319 334.4 289.2 320 256 320s-63 14.4-83.5 37.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3z"]
};
var faEarthAsia = {
  prefix: 'fal',
  iconName: 'earth-asia',
  icon: [512, 512, [127759, "globe-asia"], "f57e", "M480 256c0-91.8-55.2-170.7-134.2-205.3l-22.3 55.8c-4.8 11.9-15 20.8-27.4 24l-17 4.3c-5.6 1.4-7.9 8-4.5 12.6l16.1 21.5c10.2 13.6 10.7 32.1 1.3 46.2l-10.7 16.1c-10.4 15.6-27.9 24.9-46.6 24.9h-2.3c-5.4 0-9.2 5.2-7.7 10.3l6 19.9c7.4 24.8-11.1 49.8-37 49.8c-16.8 0-32.2-9.5-39.7-24.5l-9.3-18.5c-2.4-4.9-9-5.9-12.8-2.1l-15.4 15.4c-9.5 9.5-23 13.6-36.1 10.9l-42-8.4C62 407 150.5 480 256 480c47.4 0 91.4-14.7 127.6-39.9l-8.5-6.1-10.6 3.9c-27.7 10.3-58.6-2.7-70.6-29.6L288.4 396c-11.9-26.5-1.5-57.7 23.8-71.8L348.4 304l6.1-9.5c9-14 24.4-22.5 41.1-22.5s32.1 8.5 41.1 22.5l1.9 2.9 15.7-4.4c7.5-2.1 15.4-1.9 22.8 .4c2-12.2 3.1-24.7 3.1-37.4zm-11.6 68.4c-1.8-.9-3.8-1-5.6-.5l-15.8 4.4c-13.4 3.8-27.8-1.7-35.3-13.5l-2-3.1c-3.1-4.8-8.4-7.7-14.1-7.7s-11 2.9-14.1 7.7l-6.1 9.5c-2.8 4.4-6.7 8.1-11.4 10.7l-36.2 20.2c-10.9 6.1-15.3 19.4-10.2 30.8l5.5 12.4c5.2 11.5 18.4 17.1 30.3 12.7L372 401c5-1.9 10.6-1.1 15 2l22.4 16.2c27.3-25.6 48.1-58 59.9-94.5l-.9-.4zM315.6 40c-19-5.2-38.9-8-59.6-8C132.3 32 32 132.3 32 256c0 6.4 .3 12.8 .8 19l53.7 10.7c2.6 .5 5.3-.3 7.2-2.2l15.4-15.4c19.3-19.3 51.9-14 64.1 10.4l9.3 18.5c2.1 4.2 6.4 6.8 11 6.8c4.5 0 7.7-4.3 6.4-8.6l-6-19.9c-7.7-25.7 11.5-51.5 38.3-51.5h2.3c8 0 15.5-4 20-10.7l10.7-16.1c1.9-2.8 1.8-6.5-.3-9.2l-16.1-21.5c-17.2-22.9-5.5-55.9 22.3-62.8l17-4.3c2.5-.6 4.5-2.4 5.5-4.8L315.6 40zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm163.9 88.5l32 8c8.6 2.1 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6l-32-8c-8.6-2.1-13.8-10.8-11.6-19.4s10.8-13.8 19.4-11.6zm84.2 3c-8.6-2.1-13.8-10.8-11.6-19.4l8-32c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-8 32c-2.1 8.6-10.8 13.8-19.4 11.6zM366.3 143.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z"]
};
var faGlobeAsia = faEarthAsia;
var faIdCardClip = {
  prefix: 'fal',
  iconName: 'id-card-clip',
  icon: [576, 512, ["id-card-alt"], "f47f", "M320 32H256V96h64V32zM256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zm64 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM208 432c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48zM64 64H192V96H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H384V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64z"]
};
var faIdCardAlt = faIdCardClip;
var faMagnifyingGlassPlus = {
  prefix: 'fal',
  iconName: 'magnifying-glass-plus',
  icon: [512, 512, ["search-plus"], "f00e", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM192 304c0 8.8 7.2 16 16 16s16-7.2 16-16V224h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faSearchPlus = faMagnifyingGlassPlus;
var faThumbsUp = {
  prefix: 'fal',
  iconName: 'thumbs-up',
  icon: [512, 512, [128077, 61575], "f164", "M288.8 81.7c3.5-12.8 16.7-20.3 29.5-16.8s20.3 16.7 16.8 29.5l-4.5 16.4c-5.5 20.2-13.9 39.3-24.7 56.9c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2H448c17.7 0 32 14.3 32 32c0 11.3-5.9 21.3-14.8 27c-7.2 4.6-9.5 13.9-5.3 21.3c2.6 4.6 4.1 10 4.1 15.7c0 12.4-7 23.1-17.3 28.5c-4.2 2.2-7.3 6.1-8.3 10.8s.1 9.5 3 13.2c4.2 5.4 6.7 12.2 6.7 19.5c0 14.2-9.2 26.3-22.1 30.4c-7.8 2.6-12.4 10.6-10.7 18.6c.5 2.2 .7 4.5 .7 6.9c0 17.7-14.3 32-32 32H294.5c-15.8 0-31.2-4.7-44.4-13.4l-38.5-25.7c-9-6-16.6-13.7-22.4-22.6c-4.9-7.4-14.8-9.4-22.2-4.6s-9.4 14.8-4.6 22.2c8.1 12.3 18.7 23.1 31.4 31.6l38.5 25.7c18.4 12.3 40 18.8 62.1 18.8H384c35.3 0 64-28.7 64-64l0-.6c19.1-11.1 32-31.7 32-55.4c0-8.7-1.8-17.1-4.9-24.7C487.9 323.6 496 306.8 496 288c0-6.5-1-12.8-2.8-18.7C504.8 257.7 512 241.7 512 224c0-35.3-28.7-64-64-64H346.4c6.2-13.1 11.3-26.7 15.1-40.9l4.5-16.4c8.1-29.8-9.5-60.6-39.3-68.8s-60.6 9.5-68.8 39.3l-4.5 16.4c-8.9 32.6-29.6 60.8-58.2 79l-3.1 2c-11.8 7.5-21.7 17.1-29.5 28.2c-5.1 7.2-3.3 17.2 4 22.3s17.2 3.3 22.3-4c5.4-7.7 12.2-14.4 20.4-19.5l3.1-2c35.3-22.4 60.9-57.2 71.9-97.5l4.5-16.4zM32 224H96V448H32V224zM0 224V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]
};
var faCloudShowers = {
  prefix: 'fal',
  iconName: 'cloud-showers',
  icon: [512, 512, [], "f73f", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM128 384c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V384zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V384zm-96 32c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V416zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V416z"]
};
var faUserClock = {
  prefix: 'fal',
  iconName: 'user-clock',
  icon: [640, 512, [], "f4fd", "M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM32 480c1.2-79.7 66.2-144 146.3-144h91.4c18.2 0 35.6 3.3 51.7 9.4c1.4-10.8 3.8-21.4 7-31.5c-18.4-6.4-38.2-9.9-58.8-9.9H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H394.8c-12.9-9.1-24.5-19.9-34.6-32H32zM352 128A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"]
};
var faOnion = {
  prefix: 'fal',
  iconName: 'onion',
  icon: [448, 512, [129477], "e427", "M195.8 0c2.7 0 5.3 .5 7.7 1.5l.1 0c3.2 1.4 6 3.5 8.1 6.3l0 0c.7 .9 1.3 1.9 1.9 3l3.4 6.8c2.9 5.9 11.4 5.9 14.3 0l3.4-6.8c.5-1.1 1.2-2.1 1.9-3l0 0c2.1-2.8 4.9-5 8.1-6.3l.1 0c2.4-1 5-1.5 7.7-1.5c10.9 0 19.6 9 21.3 19.8c2.1 13.6 6.5 25.6 12.4 36.6l.1 0 0 0 0 0 .1 .1 .2 .4 .7 1.4 1.2 2.2c15.3 25.7 39.5 45.4 64.5 65.7C399 163.7 448 203.5 448 288c0 83.4-62.5 139.3-140.4 163.1l-.1 .1-.6 .6-.2 .2-.1 .1 0 0 0 0s0 0-.1-.1c-.1-.1-.2-.2-.3-.4l-.1 0 13.1 39.4c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-14-42c-11.5 2.1-23.1 3.5-34.8 4.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V463.4c-11.7-.8-23.3-2.2-34.8-4.3l-14 42c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2L142 451.5C63.4 428 0 372 0 288c0-84.5 49-124.3 95.3-162C120.5 105.6 144.8 85.8 160 60l1-1.8 .7-1.3 .2-.3 .1-.1 0 0 0 0 .1 0c6-11 10.3-23 12.5-36.6C176.2 9 184.9 0 195.8 0zM119.2 147.9l-4.8 3.9 0 0c-4.5 3.7-8.9 7.3-13.1 10.7C62 195.3 32 227 32 288c0 43.8 21.5 78.3 56.8 103.3c6 4.3 12.5 8.3 19.2 11.9C93.2 378.7 80 345.3 80 304c0-48.4 19.7-108.4 39.2-156.1zm48 277.2c14.6 3.4 29.6 5.5 44.9 6.4c-2.2-4.5-4.5-9.4-6.8-14.9C194.6 391.3 184 355.2 184 312c0-61.9 6.1-128.6 12.1-179.6c3-25.6 6-47.3 8.3-62.6c1.1-7.7 2.1-13.8 2.7-17.9l.2-1.3c-2.3-1-4.4-2.3-6.5-3.7c-3.4 10.4-7.7 19.9-12.9 28.7l-1.2 2.4c-2.1 4.1-5.2 10.1-8.9 17.6c-7.4 15-17.2 35.9-27.1 59.7C130.8 203.4 112 260.8 112 304c0 39.4 14.5 70.3 29.2 91.5c7.3 10.6 14.7 18.7 20.1 24.1c2.4 2.4 4.4 4.2 5.9 5.5zm80.7 5.5c14.7-1.5 29.2-4.2 43.1-8c.8-.8 1.6-1.7 2.6-2.7c5.1-5.6 12-13.8 18.9-24.3c13.8-21 27-49.9 27-83.6c0-44.9-19.7-104.3-40.5-154.1c-10.3-24.6-20.5-46.2-28.2-61.6c-3.8-7.7-7-13.9-9.3-18.1l-1.2-2.2c-5.2-8.9-9.7-18.6-13.1-29.1c-2.3 1.7-4.8 3-7.4 4.1l0 .1-.2 1.2c-.2 1-.4 2.6-.7 4.6c-.6 4.1-1.6 10-2.7 17.6c-2.2 15.1-5.2 36.5-8.2 61.7C221.9 186.6 216 251.9 216 312c0 37.9 9.4 69.8 18.8 92.2c4.7 11.2 9.4 19.9 12.8 25.8l.3 .5zm81.9-282c20.5 49.6 41.7 112.6 41.7 163.4c0 34.3-10.9 63.9-23.6 86.7c3.9-2.4 7.7-4.9 11.4-7.4c35.3-25 56.8-59.5 56.8-103.3c0-61-30-92.7-69.3-125.5c-4.1-3.5-8.5-7-13.1-10.7l-3.9-3.2z"]
};
var faClockTwelveThirty = {
  prefix: 'fal',
  iconName: 'clock-twelve-thirty',
  icon: [512, 512, [], "e359", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 144V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faArrowDownToDottedLine = {
  prefix: 'fal',
  iconName: 'arrow-down-to-dotted-line',
  icon: [448, 512, [], "e095", "M363.3 219.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 297.4V192 48c0-8.8 7.2-16 16-16s16 7.2 16 16V192 297.4L340.7 196.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM32 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM104 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faHandDots = {
  prefix: 'fal',
  iconName: 'hand-dots',
  icon: [512, 512, ["allergies"], "f461", "M210.7 38.8C218 16.3 239.1 0 264 0s46 16.3 53.3 38.8c7.9-4.3 17-6.8 26.7-6.8c30.9 0 56 25.1 56 56v13.4c7.3-3.5 15.4-5.4 24-5.4c30.9 0 56 25.1 56 56V336c0 97.2-78.8 176-176 176h-8.5c-65.8 0-128.9-26.1-175.4-72.6L16.4 335.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0L128 288.8V88c0-30.9 25.1-56 56-56c9.7 0 18.8 2.5 26.7 6.8zM208 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V327.4c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L73 279c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L142.8 416.7c40.5 40.5 95.4 63.3 152.7 63.3H304c79.5 0 144-64.5 144-144V152c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V152.1l0-.1V88c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V88.1l0-.1 0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24V79.9l0 .1V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V88.1l0-.1zm32 232a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM320 416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faAllergies = faHandDots;
var faFileInvoice = {
  prefix: 'fal',
  iconName: 'file-invoice',
  icon: [384, 512, [], "f570", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm0 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM224 432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm64-96H96V272H288v64zM96 240c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H96z"]
};
var faWindowMinimize = {
  prefix: 'fal',
  iconName: 'window-minimize',
  icon: [512, 512, [128469], "f2d1", "M16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faRectangleWide = {
  prefix: 'fal',
  iconName: 'rectangle-wide',
  icon: [640, 512, [], "f2fc", "M576 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"]
};
var faCommentArrowUp = {
  prefix: 'fal',
  iconName: 'comment-arrow-up',
  icon: [512, 512, [], "e144", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 150.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 182.6V320c0 8.8 7.2 16 16 16s16-7.2 16-16V182.6z"]
};
var faGarlic = {
  prefix: 'fal',
  iconName: 'garlic',
  icon: [512, 512, [129476], "e40e", "M192 48c0-8.8 7.2-16 16-16h32V70.2c0 51.4 18.4 101.1 51.9 140.2l17.1 19.9c17.5 20.4 27.1 46.5 27.1 73.3C336 365.6 285.8 416 224 416c-61.9 0-112-50.1-112-112v-5.3c0-24.4 7.6-48.3 21.8-68.2L149 209.3c24.6-34.5 39.2-75 42.3-117.1c.4-3.6 .6-7.3 .6-11V75.2 56 48zm-32 0v8V75.2c0 4.7-.2 9.3-.5 14c-2.1 16.4-10.4 31.6-23.5 42L52.7 197.8C19.4 224.5 0 264.8 0 307.5C0 385.1 62.9 448 140.5 448H144v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h3.5C449.1 448 512 385.1 512 307.5c0-42.7-19.4-83-52.7-109.7L376 131.2c-15.2-12.1-24-30.5-24-50V48c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48zM72.7 222.8l61-48.8c-3.3 5.7-6.8 11.3-10.7 16.7l-15.2 21.2C89.7 237.3 80 267.6 80 298.7V304c0 45.1 20.7 85.4 53.2 111.8C76.7 412 32 365 32 307.5c0-33 15-64.1 40.7-84.7zM371.5 416H314.3c32.7-26.5 53.7-67.1 53.7-112.3c0-34.5-12.3-68-34.8-94.2l-17.1-19.9C287.7 156.4 272 114 272 70.2V32h32c8.8 0 16 7.2 16 16V81.2c0 29.2 13.3 56.7 36 75l83.3 66.6C465 243.4 480 274.6 480 307.5C480 367.4 431.4 416 371.5 416z"]
};
var faMugSaucer = {
  prefix: 'fal',
  iconName: 'mug-saucer',
  icon: [640, 512, ["coffee"], "f0f4", "M416 64h16 16V224v32 32c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V64H416zm64 224V256h48c61.9 0 112-50.1 112-112s-50.1-112-112-112H448 432 416 128c-17.7 0-32 14.3-32 32V288c0 53 43 96 96 96H384c53 0 96-43 96-96zm48-64H480V64h48c44.2 0 80 35.8 80 80s-35.8 80-80 80zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faCoffee = faMugSaucer;
var faBrush = {
  prefix: 'fal',
  iconName: 'brush',
  icon: [384, 512, [], "f55d", "M256 352c-17.7 0-32 14.3-32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7-14.3-32-32-32H80c-26.5 0-48-21.5-48-48V288H352v16c0 26.5-21.5 48-48 48H256zm96-96H32V64c0-17.7 14.3-32 32-32H96V144c0 8.8 7.2 16 16 16s16-7.2 16-16V32h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16V32h96c17.7 0 32 14.3 32 32V256zM80 384H96h32v32 32c0 35.3 28.7 64 64 64s64-28.7 64-64V416 384h32 16c44.2 0 80-35.8 80-80V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V304c0 44.2 35.8 80 80 80z"]
};
var faTreeDecorated = {
  prefix: 'fal',
  iconName: 'tree-decorated',
  icon: [448, 512, [], "f7dc", "M236.4 5.9C233.3 2.2 228.8 0 224 0s-9.3 2.2-12.4 5.9L70.3 178.6c-4.1 5-6.3 11.2-6.3 17.6C64 211.6 76.4 224 91.8 224h18.9L38.1 314.8c-3.9 4.9-6.1 11.1-6.1 17.4C32 347.5 44.5 360 59.8 360H81.1L5.2 467.6C1.8 472.4 0 478 0 483.9C0 499.4 12.6 512 28.1 512H160 288 419.9c15.5 0 28.1-12.6 28.1-28.1c0-5.8-1.8-11.5-5.2-16.2L366.9 360h21.3c15.4 0 27.8-12.5 27.8-27.8c0-6.3-2.2-12.5-6.1-17.4L337.3 224h18.9c15.4 0 27.8-12.4 27.8-27.8c0-6.4-2.2-12.6-6.3-17.6L236.4 5.9zM412.4 480H288 160 35.6l89.5-126.8c3.4-4.9 3.9-11.3 1.1-16.6s-8.2-8.6-14.2-8.6H68.5l88-110c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1H100.7L224 41.3 347.3 192H304c-6.2 0-11.8 3.5-14.4 9.1s-1.9 12.1 1.9 16.9l88 110H336c-6 0-11.5 3.3-14.2 8.6s-2.3 11.7 1.1 16.6L412.4 480zM184 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faMask = {
  prefix: 'fal',
  iconName: 'mask',
  icon: [576, 512, [], "f6fa", "M80.9 150.2C46 180.3 32 222.2 32 272c0 47.9 16.9 83.2 41.9 106.7C99.2 402.4 135 416 176 416h8.4c12.1 0 23.2-6.8 28.6-17.7L236.2 352l28.6 14.3-23.2 46.3c-10.8 21.7-33 35.4-57.2 35.4H176C80 448 0 384 0 272S64 64 288 64s288 96 288 208s-80 176-176 176h-8.4c-24.2 0-46.4-13.7-57.2-35.4l-23.2-46.3c-4.4-8.8-13.3-14.3-23.2-14.3s-18.8 5.5-23.2 14.3L236.2 352c9.8-19.6 29.9-32 51.8-32s42 12.4 51.8 32l23.2 46.3c5.4 10.8 16.5 17.7 28.6 17.7H400c41 0 76.8-13.6 102.1-37.3c25-23.4 41.9-58.7 41.9-106.7c0-49.8-14-91.7-48.9-121.8C459.3 119.3 396.2 96 288 96s-171.3 23.3-207.1 54.2zM160 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm288 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faCalendarHeart = {
  prefix: 'fal',
  iconName: 'calendar-heart',
  icon: [448, 512, [], "e0d3", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zm80 205.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L224 393.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM173.3 240c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faMagnifyingGlassMinus = {
  prefix: 'fal',
  iconName: 'magnifying-glass-minus',
  icon: [512, 512, ["search-minus"], "f010", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM112 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faSearchMinus = faMagnifyingGlassMinus;
var faFlower = {
  prefix: 'fal',
  iconName: 'flower',
  icon: [448, 512, [127804, 10047], "f7ff", "M448 168c0 33.6-12.2 64.3-32.3 88c20.1 23.7 32.3 54.4 32.3 88c0 75.1-60.9 136-136 136c-33.6 0-64.3-12.2-88-32.3c-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168C0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM203.3 88.7C185.1 73.3 161.7 64 136 64C78.6 64 32 110.6 32 168c0 25.7 9.3 49.1 24.7 67.3c10.1 11.9 10.1 29.5 0 41.4C41.3 294.9 32 318.3 32 344c0 57.4 46.6 104 104 104c25.7 0 49.1-9.3 67.3-24.7c11.9-10.1 29.5-10.1 41.4 0C262.9 438.7 286.3 448 312 448c57.4 0 104-46.6 104-104c0-25.7-9.3-49.1-24.7-67.3c-10.1-11.9-10.1-29.5 0-41.4C406.7 217.1 416 193.7 416 168c0-57.4-46.6-104-104-104c-25.7 0-49.1 9.3-67.3 24.7c-11.9 10.1-29.5 10.1-41.4 0zM272 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faRightLeftLarge = {
  prefix: 'fal',
  iconName: 'right-left-large',
  icon: [640, 512, [], "e5e1", "M205.2 496c-12.4 0-24.4-4.6-33.7-12.8L49.3 374.6C38.3 364.8 32 350.7 32 336s6.3-28.8 17.3-38.6L171.5 188.8c9.3-8.3 21.3-12.8 33.7-12.8c28 0 50.8 22.7 50.8 50.8V240h32 64l32 0h16c8.8 0 16 7.2 16 16l0 16v13.2c0 10.4 8.4 18.8 18.8 18.8c4.6 0 9-1.7 12.5-4.7L569.4 190.7c4.2-3.7 6.6-9.1 6.6-14.7s-2.4-10.9-6.6-14.7L447.3 52.7c-3.4-3.1-7.9-4.7-12.5-4.7C424.4 48 416 56.4 416 66.8V80 96c0 8.8-7.2 16-16 16H384 288c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V66.8c0-28 22.7-50.8 50.8-50.8c12.4 0 24.4 4.6 33.7 12.8L590.7 137.4c11 9.8 17.3 23.8 17.3 38.6s-6.3 28.8-17.3 38.6L468.5 323.2c-9.3 8.3-21.3 12.8-33.7 12.8c-28 0-50.8-22.7-50.8-50.8V272l-32 0H288 256 240c-8.8 0-16-7.2-16-16V240 226.8c0-10.4-8.4-18.8-18.8-18.8c-4.6 0-9 1.7-12.5 4.7L70.6 321.3c-4.2 3.7-6.6 9.1-6.6 14.7s2.4 10.9 6.6 14.7L192.7 459.3c3.4 3.1 7.9 4.7 12.5 4.7c10.4 0 18.8-8.4 18.8-18.8V432 416c0-8.8 7.2-16 16-16h16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0v13.2c0 28-22.7 50.8-50.8 50.8z"]
};
var faRulerVertical = {
  prefix: 'fal',
  iconName: 'ruler-vertical',
  icon: [256, 512, [], "f548", "M192 32c17.7 0 32 14.3 32 32V96H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"]
};
var faCirclesOverlap = {
  prefix: 'fal',
  iconName: 'circles-overlap',
  icon: [640, 512, [], "e600", "M232 415.8c-25.2-36.2-40-80.3-40-127.8c0-99.1 64.3-183.1 153.5-212.7C312.4 48.2 270.1 32 224 32C118 32 32 118 32 224s86 192 192 192c2.7 0 5.4-.1 8-.2zm36.4-5C353 390.8 416 314.7 416 224c0-46.7-16.7-89.5-44.4-122.8C287 121.2 224 197.3 224 288c0 46.7 16.7 89.5 44.4 122.8zm-11.6 34.8c-10.7 1.6-21.7 2.4-32.8 2.4C100.3 448 0 347.7 0 224S100.3 0 224 0c62.3 0 118.6 25.4 159.2 66.4C393.9 64.8 404.8 64 416 64c123.7 0 224 100.3 224 224s-100.3 224-224 224c-62.3 0-118.6-25.4-159.2-66.4zM408 96.2c25.2 36.3 40 80.3 40 127.8c0 99.1-64.3 183.1-153.5 212.7C327.6 463.8 369.9 480 416 480c106 0 192-86 192-192s-86-192-192-192c-2.7 0-5.4 .1-8 .2z"]
};
var faUserLarge = {
  prefix: 'fal',
  iconName: 'user-large',
  icon: [512, 512, ["user-alt"], "f406", "M368 144a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM32 480H480c-.7-70.8-58.3-128-129.3-128H161.3C90.3 352 32.7 409.2 32 480zM0 481.3C0 392.2 72.2 320 161.3 320H350.7C439.8 320 512 392.2 512 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3z"]
};
var faUserAlt = faUserLarge;
var faStarshipFreighter = {
  prefix: 'fal',
  iconName: 'starship-freighter',
  icon: [576, 512, [], "e03a", "M377.1 371.9L315.5 285c2.9-9.2 4.5-18.9 4.5-29c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c.6 0 1.1 0 1.7 0l60.7 85.7C266.8 444.4 245.8 448 224 448C118 448 32 362 32 256S118 64 224 64c104.4 0 189.3 83.3 191.9 187c0 1.6 .1 3.3 .1 5c0 1.7 0 3.5-.1 5.2c-1.1 41.5-15.4 79.8-38.9 110.7zM405.4 400H397l-.6-.9c22.5-27.1 38.7-59.5 46.5-95.1h4.6H544v42.1L405.4 400zM460 413.1l95.6-37.2c12.3-4.8 20.4-16.6 20.4-29.8V304c0-17.7-14.3-32-32-32H479.5 447.4c.4-5.3 .6-10.6 .6-16c0-5.3-.2-10.6-.6-15.8l0-.2h32.1H544c17.7 0 32-14.3 32-32V165.9c0-13.2-8.1-25-20.4-29.8L347.6 55.2C308.2 39.9 266.3 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480c28.7 0 57.1-3.6 84.8-10.7l13.5 19.1C332.8 503.2 349.8 512 368 512h56c30.9 0 56-25.1 56-56c0-17.2-7.8-32.6-20-42.9zM447.4 208h-4.6c-8.4-38.6-26.8-73.5-52.3-101.8L544 165.9l0 42.1H447.4zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM348.2 469.6L262.3 344.1c15-6.5 28-16.8 37.9-29.6L380.7 432H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H368c-7.9 0-15.3-3.9-19.8-10.4z"]
};
var faTrainTram = {
  prefix: 'fal',
  iconName: 'train-tram',
  icon: [448, 512, [128650], "e5b4", "M41.3 50c9.1-11.4 22.9-18 37.5-18H208V96H160c-53 0-96 43-96 96V352c0 28.9 12.8 54.8 33 72.4L36.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l65.8-65.8c10.8 4.2 22.6 6.5 34.9 6.5H288c12.3 0 24-2.3 34.9-6.5l65.8 65.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L351 424.4c20.2-17.6 33-43.5 33-72.4V192c0-53-43-96-96-96H240V32H369.2c14.6 0 28.4 6.6 37.5 18l12.8 16c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5L431.7 30C416.5 11 393.5 0 369.2 0H78.8C54.5 0 31.5 11 16.3 30L3.5 46C-2 52.9-.9 63 6 68.5S23 72.9 28.5 66L41.3 50zM160 128h48 32 48c35.3 0 64 28.7 64 64v64H96V192c0-35.3 28.7-64 64-64zM96 288H352v64c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V288zm96 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBridgeSuspension = {
  prefix: 'fal',
  iconName: 'bridge-suspension',
  icon: [640, 512, [], "e4cd", "M128 0c6.4 0 11.9 3.7 14.5 9.2l6.6 13.2C181.4 87.1 247.6 128 320 128s138.6-40.9 170.9-105.6l6.6-13.2C500.1 3.7 505.6 0 512 0c7.2 0 13.3 4.7 15.3 11.3c14.5 43 58.7 87.5 102.6 104.9c8.2 3.3 12.2 12.6 9 20.8s-12.6 12.2-20.8 9c-33-13.1-66-38.6-90.1-69.1V256h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V76.8c-24.1 30.5-57.1 56-90.1 69.1c-8.2 3.3-17.5-.8-20.8-9s.8-17.5 9-20.8C54 98.7 98.2 54.3 112.7 11.3C114.7 4.7 120.8 0 128 0zm16 256h64V129.9c-24.5-14.2-46.3-33.1-64-55.8V256zm96 0h64V159.4c-22.2-1.6-43.7-6.5-64-14.3V256zm96 0h64V145.2c-20.3 7.8-41.8 12.7-64 14.3V256zm96 0h64V74c-17.7 22.7-39.5 41.6-64 55.8V256zM16 320H32c53 0 96 43 96 96v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448c0-70.7 57.3-128 128-128s128 57.3 128 128v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V416c0-53 43-96 96-96h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608c-35.3 0-64 28.7-64 64v48c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V448c0-53-43-96-96-96s-96 43-96 96v16c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V416c0-35.3-28.7-64-64-64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTrashCheck = {
  prefix: 'fal',
  iconName: 'trash-check',
  icon: [448, 512, [], "e2af", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64h47.1H416h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H413.7L388.2 452.6C385.9 486.1 358 512 324.4 512H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64.1h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480H324.4c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zM331.3 235.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L192 329.4 308.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faUserNurse = {
  prefix: 'fal',
  iconName: 'user-nurse',
  icon: [448, 512, [], "f82f", "M128 128v16H320V128 70.2l-96-36-96 36V128zM96 160V128 70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128v32 16c0 70.7-57.3 128-128 128s-128-57.3-128-128V160zm224 16H128c0 53 43 96 96 96s96-43 96-96zM119 359.1C68.7 376.5 32.5 424 32 480H416c-.5-56-36.7-103.5-86.9-120.9L259 433.6c-19 20.1-51 20.1-69.9 0L119 359.1zm22.4-22.9l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6c10.5-3.4 21.8 .4 29.4 8.5zM216 48h16c4.4 0 8 3.6 8 8V72h16c4.4 0 8 3.6 8 8V96c0 4.4-3.6 8-8 8H240v16c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8V104H192c-4.4 0-8-3.6-8-8V80c0-4.4 3.6-8 8-8h16V56c0-4.4 3.6-8 8-8z"]
};
var faBoombox = {
  prefix: 'fal',
  iconName: 'boombox',
  icon: [640, 512, [128254], "f8a5", "M144 32H496c26.5 0 48 21.5 48 48v80H96V80c0-26.5 21.5-48 48-48zM64 80v80c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64V80c0-44.2-35.8-80-80-80H144C99.8 0 64 35.8 64 80zM80 192H560h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H80zM96 336a80 80 0 1 1 160 0A80 80 0 1 1 96 336zm192 0A112 112 0 1 0 64 336a112 112 0 1 0 224 0zm176-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM208 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400z"]
};
var faSyringe = {
  prefix: 'fal',
  iconName: 'syringe',
  icon: [512, 512, [128137], "f48e", "M404.7 4.7c-6.2 6.2-6.2 16.4 0 22.6L433.4 56 384 105.4 315.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80 80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L406.6 128 456 78.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-40-40-40-40c-6.2-6.2-16.4-6.2-22.6 0zm-272 224L82.7 278.6c-12 12-18.7 28.3-18.7 45.3V425.4L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448H188.1c17 0 33.3-6.7 45.3-18.7l192-192-22.6-22.6-192 192c-6 6-14.1 9.4-22.6 9.4H96V323.9c0-8.5 3.4-16.6 9.4-22.6L144 262.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 240 208 198.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L230.6 176l66.7-66.7L274.7 86.6l-78.1 78.1s0 0 0 0s0 0 0 0l-64 64s0 0 0 0s0 0 0 0z"]
};
var faCloudSun = {
  prefix: 'fal',
  iconName: 'cloud-sun',
  icon: [640, 512, [9925], "f6c4", "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c3.2-20.2 11-38.9 22.5-54.8l-44.4 31.1-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l71 11.8-40.2 57.5c11.4-3.3 23.4-5.1 35.8-5.1c2.2 0 4.5 .1 6.7 .2l38.5-55c3.1-4.5 3.8-10.3 1.6-15.4s-6.7-8.7-12.1-9.6L317.9 98.1 303.8 13.4zm-59.9 275c7.8-30.6 26.5-56.8 51.9-74.1c.1-2.1 .2-4.2 .2-6.3c0-48.6-39.4-88-88-88s-88 39.4-88 88s39.4 88 88 88c12.8 0 24.9-2.7 35.9-7.6zM264 208a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm40 112c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H290.9c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H557.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.4-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 242.6 402.9 224 368 224z"]
};
var faShieldExclamation = {
  prefix: 'fal',
  iconName: 'shield-exclamation',
  icon: [512, 512, [], "e247", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM256 128c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faStopwatch20 = {
  prefix: 'fal',
  iconName: 'stopwatch-20',
  icon: [448, 512, [], "e06f", "M144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V96.6C100.6 104.8 16 194.5 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-47.6-16-91.4-42.9-126.5l38.2-38.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-37 37c-33.7-32.3-78.3-53.3-127.7-57V32h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm80 480a176 176 0 1 1 0-352 176 176 0 1 1 0 352zm16-240V368c0 26.5 21.5 48 48 48s48-21.5 48-48V240c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48-16c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM151.8 235.3c2.3-6.8 8.6-11.3 15.7-11.3c9.1 0 16.5 7.4 16.5 16.5v14.8c0 7.1-2.4 14-6.9 19.6l-32.6 40.7c-15.9 19.9-24.5 44.5-24.5 70V400c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H152c.4-17.6 6.5-34.6 17.5-48.3L202.1 295c9-11.2 13.9-25.2 13.9-39.6V240.5c0-26.8-21.7-48.5-48.5-48.5c-20.9 0-39.4 13.4-46.1 33.2l-.6 1.7c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l.6-1.7z"]
};
var faSquareFull = {
  prefix: 'fal',
  iconName: 'square-full',
  icon: [512, 512, [128997, 128998, 128999, 129000, 129001, 129002, 129003, 11035, 11036], "f45c", "M480 32V480H32V32H480zM32 0H0V32 480v32H32 480h32V480 32 0H480 32z"]
};
var faGripDots = {
  prefix: 'fal',
  iconName: 'grip-dots',
  icon: [448, 512, [], "e410", "M384 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM48 176a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM384 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM208 336a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCommentExclamation = {
  prefix: 'fal',
  iconName: 'comment-exclamation',
  icon: [512, 512, [], "f4af", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm0 80c-8.8 0-16 7.2-16 16V256c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faPenSwirl = {
  prefix: 'fal',
  iconName: 'pen-swirl',
  icon: [512, 512, [], "e214", "M454.8 45.5c-12.6-12.6-32.9-12.5-45.4 .1L383 72.4l57 57 26.7-26.8c12.5-12.5 12.5-32.8 0-45.2L454.8 45.5zM218.2 239.2c-4.3 4.4-7.3 9.9-8.6 15.9l-12.9 61.7 61.5-12.9c6.1-1.3 11.7-4.3 16.1-8.7L417.4 152 360.5 95.1 218.2 239.2zM386.7 23.1c24.9-25.3 65.7-25.4 90.8-.3l11.9 11.9c25 25 25 65.5 0 90.5L296.9 317.8c-8.8 8.8-20 14.8-32.1 17.4l-85.5 17.9c-5.3 1.1-10.8-.5-14.6-4.3s-5.5-9.3-4.3-14.6l18-85.7c2.5-12 8.5-23.1 17.1-31.8L386.7 23.1zM301.1 52.9C286.5 49.7 271.5 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c8.8 0 16 7.2 16 16s-7.2 16-16 16C123.5 496 16 388.5 16 256S123.5 16 256 16c24.7 0 48.5 3.7 71 10.7L301.1 52.9zM485.5 185.7c6.8 22.2 10.5 45.8 10.5 70.3c0 79.5-64.5 144-144 144c-12.4 0-24.5-1.6-36-4.5c-8.6-2.2-13.7-10.9-11.5-19.5s10.9-13.7 19.5-11.5c8.9 2.3 18.3 3.5 28 3.5c61.9 0 112-50.1 112-112c0-15.1-1.6-29.9-4.7-44.1l26.2-26.2z"]
};
var faFalafel = {
  prefix: 'fal',
  iconName: 'falafel',
  icon: [576, 512, [129478], "e40a", "M160.4 177.7c-11.7-15.9-11.2-38 1.5-53.4c2.3-2.7 3.1-6.5 2.2-10.1c-5.1-20.1 4.7-41.3 23.7-50c3.1-1.4 5.4-4.3 6.1-7.9C198 35.9 216 21 237 21.6c3.3 .1 6.5-1.4 8.6-4.3C258 .5 280.7-4.9 299.3 4.9c3 1.6 6.5 1.6 9.4 0C327.3-4.9 350 .5 362.4 17.3c2.1 2.9 5.3 4.4 8.6 4.3c21-.6 39 14.3 42.9 34.7c.7 3.6 3.1 6.5 6.1 7.9c19 8.7 28.8 29.9 23.7 50c-.9 3.6 0 7.4 2.2 10.1c13.2 16 13.2 39.3 0 55.3c-2.3 2.7-3.1 6.5-2.2 10.1c.2 1 .5 2 .6 3c-4.2 .6-8.4 1.6-12.5 3c-6.6-2.2-13.4-3.4-20.2-3.7c-1.4-11.7 2-23.6 9.6-32.8c3.5-4.2 3.5-10.4 0-14.5c-8.8-10.7-12-25-8.6-38.4c1.4-5.5-1.4-10.9-6-13c-12.6-5.8-21.6-17.4-24.2-30.9c-1.1-5.5-5.7-9-10.6-8.9c-13.9 .4-27-6.1-35.3-17.3c-3.1-4.3-8.6-5.4-13-3.1c-12.3 6.5-27 6.5-39.3 0c-4.4-2.3-9.9-1.2-13 3.1C263.1 47.5 250 54 236 53.6c-4.9-.1-9.5 3.4-10.6 8.9c-2.6 13.6-11.6 25.2-24.2 30.9c-4.6 2.1-7.4 7.5-6 13c3.4 13.4 .2 27.7-8.6 38.4c-3.5 4.2-3.5 10.4 0 14.5c4.7 5.6 7.8 12.3 9.1 19.3c-11.4-3.1-23.5-3.5-35.3-.9zM240 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm27.2 182.2c-.5-3.7-2.8-7.1-6.5-8.8c-12.8-5.7-22-17.2-24.7-30.9c-1.1-5.3-5.8-9.1-11.3-8.9c-14 .4-27.3-6-35.7-17.1c-3.3-4.3-9.2-5.7-14.1-3.2c-12.4 6.4-27.2 6.4-39.6 0c-4.9-2.5-10.8-1.1-14.1 3.2c-8.4 11.2-21.7 17.5-35.7 17.1c-5.5-.2-10.2 3.7-11.3 8.9c-2.7 13.7-12 25.2-24.7 30.9c-5 2.2-7.6 7.7-6.2 12.9c3.5 13.5 .2 27.9-8.8 38.6c-3.5 4.1-3.5 10.1 0 14.3c9 10.7 12.3 25 8.8 38.6c-1.3 5.2 1.3 10.6 6.2 12.9c12.8 5.7 22 17.2 24.7 30.9c1.1 5.3 5.8 9.1 11.3 8.9c14-.4 27.3 6 35.7 17.1c3.3 4.3 9.2 5.7 14.1 3.2c12.4-6.4 27.2-6.4 39.6 0c4.9 2.5 10.8 1.1 14.1-3.2c8.4-11.1 21.7-17.5 35.7-17.1c5.5 .2 10.2-3.7 11.3-8.9c2.7-13.7 12-25.2 24.7-30.9c2.5-1.1 4.4-3 5.5-5.3c-.1 12 2.8 23.7 8.2 34.2l-.7 .3c-3.3 1.5-5.7 4.4-6.4 8c-4.1 20.6-22.5 35.2-43.5 34.6c-3.6-.1-7.1 1.6-9.2 4.4c-12.7 16.8-35.6 22-54.3 12.4c-3.2-1.7-7.1-1.7-10.3 0c-18.7 9.6-41.6 4.4-54.3-12.4c-2.2-2.9-5.6-4.5-9.2-4.4c-21 .6-39.4-14-43.5-34.6c-.7-3.5-3.1-6.5-6.4-8c-19.2-8.6-29.4-29.7-24.2-50.1c.9-3.5 .1-7.1-2.3-9.9c-13.6-16.1-13.6-39.6 0-55.6c2.3-2.7 3.2-6.4 2.3-9.9c-5.3-20.4 5-41.5 24.2-50.1c3.3-1.5 5.7-4.4 6.4-8c4.1-20.6 22.5-35.2 43.5-34.6c3.6 .1 7.1-1.6 9.2-4.4c12.7-16.8 35.6-22 54.3-12.4c3.2 1.7 7.1 1.7 10.3 0c18.7-9.6 41.6-4.4 54.3 12.4c2.2 2.9 5.6 4.5 9.2 4.4c21-.6 39.4 14 43.5 34.6c.7 3.5 3.1 6.5 6.4 8c2.9 1.3 5.6 2.9 8.1 4.7c-7.6 9.7-12.6 21.2-14.6 33.3zM64 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm224 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm13.1-159c-3.7-2-8.4-1-11.1 2.7c-7.9 10.8-20.6 17-34 16.6c-4.1-.1-8.1 2.8-9 7.6c-2.5 13.1-11.2 24.2-23.3 29.8c-3.9 1.8-6.3 6.4-5.1 11.2c3.3 12.9 .2 26.7-8.3 36.9c-3 3.6-3 8.9 0 12.5c8.5 10.3 11.5 24 8.3 36.9c-1.2 4.7 1.2 9.4 5.1 11.2c12.2 5.6 20.8 16.7 23.3 29.8c.9 4.7 4.9 7.7 9 7.6c13.4-.4 26.1 5.9 34 16.6c2.7 3.6 7.4 4.6 11.1 2.7c11.9-6.3 26-6.3 37.8 0c3.7 2 8.4 1 11.1-2.7c7.9-10.8 20.6-17 34-16.6c4.1 .1 8.1-2.8 9-7.6c2.5-13.1 11.2-24.2 23.3-29.8c3.9-1.8 6.3-6.4 5.1-11.2c-2.5-9.7-1.3-19.9 3-28.8c-25.6-4.9-53-20.9-75.5-43.4c-24.1-24.1-40.5-53.5-44.2-80.3c-1.3-.5-2.5-1.1-3.7-1.7zM428 228.7c1.3 .7 2.6 1 4 1c4.3 0 8.5 1.7 11.5 4.8s4.6 7.3 4.5 11.6c-.5 18.2 11 45.6 35.6 70.2c26.8 26.8 56.4 37.7 74.2 35.3c4.5-.6 9.1 .7 12.6 3.7s5.5 7.3 5.6 11.9c.2 9.7-3 19.5-9.6 27.4c-1.9 2.3-2.7 5.6-1.9 8.7c4.9 19.4-4.5 39.7-22.8 48.1c-2.6 1.2-4.6 3.7-5.2 6.8c-3.8 19.6-21.1 34-41.4 33.4c-2.8-.1-5.5 1.2-7.3 3.7c-12 16.2-33.8 21.4-51.8 12c-2.5-1.3-5.5-1.3-8 0c-17.9 9.4-39.8 4.2-51.8-12c-1.8-2.4-4.6-3.7-7.3-3.7c-20.2 .6-37.5-13.8-41.4-33.4c-.6-3.1-2.6-5.6-5.2-6.8c-18.3-8.4-27.7-28.8-22.8-48.1c.8-3.1 0-6.3-1.9-8.7c-12.8-15.4-12.8-37.9 0-53.3c1.9-2.3 2.7-5.6 1.9-8.7c-4.9-19.4 4.5-39.7 22.8-48.1c2.6-1.2 4.6-3.7 5.2-6.8c3.8-19.6 21.1-34 41.4-33.4c2.8 .1 5.5-1.2 7.3-3.7c12-16.2 33.8-21.4 51.8-12z"]
};
var faCircle2 = {
  prefix: 'fal',
  iconName: 'circle-2',
  icon: [512, 512, [], "e0ef", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM217 174.4c9.8-9.2 22.7-14.2 36.1-14c28.2 .4 50.9 23.4 50.9 51.6c0 13.7-5.4 26.8-15.1 36.5L180.7 356.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H230.6l80.9-80.9c15.7-15.7 24.5-37 24.5-59.1c0-45.7-36.7-83-82.4-83.6c-21.7-.3-42.7 7.8-58.5 22.7L181 164.3c-6.4 6.1-6.7 16.2-.7 22.6s16.2 6.7 22.6 .7L217 174.4z"]
};
var faMagnet = {
  prefix: 'fal',
  iconName: 'magnet',
  icon: [448, 512, [129522], "f076", "M48 64c-8.8 0-16 7.2-16 16v48h80V80c0-8.8-7.2-16-16-16H48zM32 256c0 106 86 192 192 192s192-86 192-192V160H336v96c0 61.9-50.1 112-112 112s-112-50.1-112-112V160H32v96zM416 128V80c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16v48h80zM0 80C0 53.5 21.5 32 48 32H96c26.5 0 48 21.5 48 48V256c0 44.2 35.8 80 80 80s80-35.8 80-80V80c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48V256c0 123.7-100.3 224-224 224S0 379.7 0 256V80z"]
};
var faJar = {
  prefix: 'fal',
  iconName: 'jar',
  icon: [320, 512, [], "e516", "M64 0H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16S55.2 0 64 0zm0 96c-17.7 0-32 14.3-32 32v64H288V128c0-17.7-14.3-32-32-32H64zM32 224V352H288V224H32zm0 160v64c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32V384H32zM0 128C0 92.7 28.7 64 64 64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faGramophone = {
  prefix: 'fal',
  iconName: 'gramophone',
  icon: [384, 512, [], "f8bd", "M67.2 278c-.5 1.8 .2 3.7 1.8 4.7c1.5 1 3.6 1.1 5.4-.2c80.8-56.9 145.7-73.7 193.6-73.9C183.4 144.5 145 62.6 133.2 32.8c-.1-.3-.3-.6-.5-.7c-.2-.1-.3-.1-.3-.1L67.2 278zm300.8-.3c0 1.1 0 2.1-.1 3.2c0 1.1 .1 2.3 .1 3.4c0 37.4-30.3 67.7-67.7 67.7l-6.4 0-.2 0H176c-8.8 0-16-7.2-16-16s7.2-16 16-16H293.7l.2 0c22.3-.1 40.5-17.4 42-39.3c-1-17.2-9.2-29.6-21.1-33.4C279.3 236 205 229.7 92.8 308.7c-12.2 8.6-28.8 9.2-41.6 .7c-12.9-8.6-19-24.5-15-39.5l65.1-246C105.1 9.8 117.8 0 132.3 0c13.9 0 25.7 8.8 30.6 21c12.5 31.4 58 127.5 163.5 188c24.1 13.8 41.6 39.2 41.6 68.7zM304 416H80c-8.8 0-16 7.2-16 16v48H320V432c0-8.8-7.2-16-16-16zM80 384H304c26.5 0 48 21.5 48 48v48 0h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32v0V432c0-26.5 21.5-48 48-48z"]
};
var faDiceD12 = {
  prefix: 'fal',
  iconName: 'dice-d12',
  icon: [512, 512, [], "f6ce", "M200.3 32c-2.8 0-5.6 .7-8 2.1L128.7 70.9 256 111.2 383.3 70.9 319.7 34.1c-2.4-1.4-5.2-2.1-8-2.1L200.3 32zM92 92.8c-.8 .9-1.6 1.9-2.2 2.9L34.2 192.2c.6 .5 1.2 1 1.7 1.6l95.8 106.4L240 246.1V139.7L92 92.8zM32 237.3l0 74.4c0 2.8 .7 5.6 2.1 8l55.7 96.5c1.4 2.4 3.4 4.5 5.9 5.9l62.7 36.2-44.5-130L32 237.3zM199.7 480c.2 0 .4 0 .6 0H311.7c.7 0 1.4 0 2.1-.1l50.6-151.8L256 273.9 147.7 328.1l52 151.9zM355 457.5l61.2-35.4c2.4-1.4 4.5-3.4 5.9-5.9l55.7-96.5c1.4-2.4 2.1-5.2 2.1-8V237.3l-81.9 90.9L355 457.5zM477.8 192.2L422.1 95.7c-.6-1.1-1.3-2-2.2-2.9L272 139.7V246.1l108.3 54.1 95.8-106.4c.5-.6 1.1-1.1 1.7-1.6zM176.3 6.4c7.3-4.2 15.6-6.4 24-6.4H311.7c8.4 0 16.7 2.2 24 6.4l96.5 55.7c7.3 4.2 13.4 10.3 17.6 17.6l55.7 96.5c4.2 7.3 6.4 15.6 6.4 24V311.7c0 8.4-2.2 16.7-6.4 24l-55.7 96.5c-4.2 7.3-10.3 13.4-17.6 17.6l-96.5 55.7c-7.3 4.2-15.6 6.4-24 6.4H200.3c-8.4 0-16.7-2.2-24-6.4L79.7 449.8c-7.3-4.2-13.4-10.3-17.6-17.6L6.4 335.7c-4.2-7.3-6.4-15.6-6.4-24V200.3c0-8.4 2.2-16.7 6.4-24L62.2 79.7c4.2-7.3 10.3-13.4 17.6-17.6L176.3 6.4z"]
};
var faNoteSticky = {
  prefix: 'fal',
  iconName: 'note-sticky',
  icon: [448, 512, [62026, "sticky-note"], "f249", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H272V352c0-26.5 21.5-48 48-48h96V96c0-17.7-14.3-32-32-32H64zM304 434.7L402.7 336H320c-8.8 0-16 7.2-16 16v82.7zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V309.5c0 17-6.7 33.3-18.7 45.3L322.7 461.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V96z"]
};
var faStickyNote = faNoteSticky;
var faDown = {
  prefix: 'fal',
  iconName: 'down',
  icon: [384, 512, ["arrow-alt-down"], "f354", "M189.7 448h4.6c4.4 0 8.6-1.8 11.6-5L348.5 293.2c2.2-2.3 3.5-5.4 3.5-8.7c0-6.9-5.6-12.6-12.6-12.6H256c-8.8 0-16-7.2-16-16V80c0-8.8-7.2-16-16-16H160c-8.8 0-16 7.2-16 16V256c0 8.8-7.2 16-16 16H44.6c-6.9 0-12.6 5.6-12.6 12.6c0 3.2 1.2 6.3 3.5 8.7L178.1 443c3 3.2 7.2 5 11.6 5zM384 284.6c0 11.4-4.4 22.5-12.3 30.7L229 465.1c-9.1 9.5-21.6 14.9-34.8 14.9h-4.6c-13.1 0-25.7-5.4-34.8-14.9L12.3 315.3C4.4 307 0 296 0 284.6C0 260 20 240 44.6 240H112V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V240h67.4c24.6 0 44.6 20 44.6 44.6z"]
};
var faArrowAltDown = faDown;
var faHundredPoints = {
  prefix: 'fal',
  iconName: 'hundred-points',
  icon: [512, 512, [128175, "100"], "e41c", "M177.4 93.3c5-35.2 35.2-61.3 70.7-61.3c43.5 0 76.9 38.5 70.7 81.5L302.6 226.7c-5 35.2-35.2 61.3-70.7 61.3c-43.5 0-76.9-38.5-70.7-81.5L177.4 93.3zM248.1 64c-19.6 0-36.3 14.4-39 33.9L192.9 211c-3.4 23.8 15 45 39 45c19.6 0 36.3-14.4 39-33.9L287.1 109c3.4-23.8-15-45-39-45zM129.8 35.2c4.6 3.5 6.9 9.2 6 15l-40 256c-1.4 8.8-9.6 14.9-18.3 13.6s-14.7-9.3-13.3-18.1L99.7 74.4 54.3 94.6c-8.1 3.6-17.5 0-21-8.1s.3-17.5 8.4-21.1l72-32c5.4-2.4 11.5-1.7 16.1 1.8zM425.6 32c42.8 0 76.1 37.3 71.2 79.8l-11.2 96.7c-4.2 36.1-34.8 63.4-71.2 63.4c-42.8 0-76.1-37.3-71.2-79.8l11.2-96.7C358.6 59.3 389.2 32 425.6 32zM386.2 99.1L375 195.8c-2.7 23.5 15.7 44.2 39.4 44.2c20.1 0 37.1-15.1 39.4-35.1L465 108.2C467.7 84.6 449.3 64 425.6 64c-20.1 0-37.1 15.1-39.4 35.1zM511.9 333.9c1.2 8.8-5 16.8-13.7 18l-480 64c-8.8 1.2-16.8-5-18-13.7s5-16.8 13.7-18l480-64c8.8-1.2 16.8 5 18 13.7zM466 447.9l-256 32c-8.8 1.1-16.8-5.1-17.9-13.9s5.1-16.8 13.9-17.9l256-32c8.8-1.1 16.8 5.1 17.9 13.9s-5.1 16.8-13.9 17.9z"]
};
var fa100 = faHundredPoints;
var faPaperclipVertical = {
  prefix: 'fal',
  iconName: 'paperclip-vertical',
  icon: [384, 512, [], "e3c2", "M64 96c0-53 43-96 96-96s96 43 96 96V352c0 35.3-28.7 64-64 64s-64-28.7-64-64V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-35.3-28.7-64-64-64s-64 28.7-64 64V384c0 53 43 96 96 96s96-43 96-96V144c0-8.8 7.2-16 16-16s16 7.2 16 16V384c0 70.7-57.3 128-128 128s-128-57.3-128-128V96z"]
};
var faWindWarning = {
  prefix: 'fal',
  iconName: 'wind-warning',
  icon: [640, 512, ["wind-circle-exclamation"], "f776", "M390.3 352c-33.2 57.4-95.2 96-166.3 96C118 448 32 362 32 256S118 64 224 64s192 86 192 192h32C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480c89.4 0 166.5-52.3 202.4-128H390.3zM224 128c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM496 480h48c53 0 96-43 96-96s-43-96-96-96H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H544c35.3 0 64 28.7 64 64s-28.7 64-64 64H496c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48-256c53 0 96-43 96-96s-43-96-96-96H496c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c35.3 0 64 28.7 64 64s-28.7 64-64 64H471.9c2.7 10.4 4.7 21.1 6.1 32h66z"]
};
var faWindCircleExclamation = faWindWarning;
var faLocationPinSlash = {
  prefix: 'fal',
  iconName: 'location-pin-slash',
  icon: [640, 512, ["map-marker-slash"], "f60c", "M512 192C512 86 426 0 320 0C263.8 0 213.3 24.1 178.2 62.5l25.2 19.9C232.6 51.4 274 32 320 32c88.4 0 160 71.6 160 160c0 15.6-5.4 37-16.6 63.4c-3.3 7.7-6.9 15.6-10.9 23.7l25.6 20.2C498.3 259.8 512 221.9 512 192zM176.6 255.4c-6.7-15.9-11.4-30-14-42.2L128.1 186c-.1 2-.1 4-.1 6c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0c17.3-21.6 42-53.6 67.2-89.8l-25.2-19.9c-24.4 35.2-48.5 66.5-65.8 88.1c-25.4-31.8-65.8-84.7-99.9-140c-17.3-28.1-32.7-56.3-43.6-82.1zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faMapMarkerSlash = faLocationPinSlash;
var faFaceSadSweat = {
  prefix: 'fal',
  iconName: 'face-sad-sweat',
  icon: [576, 512, [], "e38a", "M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-57.6 0-110.8-19.1-153.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2C191 463.3 237.5 480 288 480c123.7 0 224-100.3 224-224S411.7 32 288 32zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.5c0 .2 0 .2 0 .1C32 385.5 43.7 400 64 400s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.1-.7-.8-3.7-3.4-9.6c-3-6.7-7.4-14.5-12.8-23.1c-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0c17.6 21.7 55.5 72.2 55.5 97.2c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 38.1-75.5 55.5-97.2zM348.1 410.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C220.2 371.4 248.3 352 288 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM391.6 272a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm3.7-99.3c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm153.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faBugSlash = {
  prefix: 'fal',
  iconName: 'bug-slash',
  icon: [640, 512, [], "e490", "M560 304c8.8 0 16-7.2 16-16s-7.2-16-16-16H480v-8c0-22.9-7.4-44.2-20-61.4l79.3-79.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L437.4 180c-17.2-12.6-38.4-20-61.4-20H301.7l40.5 32H376c39.8 0 72 32.2 72 72v11.5L484.1 304H560zM411.4 409.7c-19.7 20.1-46 33.7-75.4 37.4V350.2l-32-25.3V447c-63.1-7.9-112-61.7-112-127V288 264c0-8.5 1.5-16.6 4.2-24.2l-26.1-20.6C163.6 232.8 160 248 160 264v8H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v16c0 30.2 8.4 58.4 22.9 82.5l-82.2 82.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l79-79C231.5 460.1 273.4 480 320 480c46 0 87.4-19.4 116.6-50.4l-25.2-19.9zM224 98.7L261.2 128H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96s-96 43-96 96v2.7zM320 32c35.3 0 64 28.7 64 64H256c0-35.3 28.7-64 64-64zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faCupcake = {
  prefix: 'fal',
  iconName: 'cupcake',
  icon: [448, 512, [129473], "e402", "M208 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7H148c-36.2 0-65.8 28.3-67.9 64H80c-44.2 0-80 35.8-80 80s35.8 80 80 80H368c44.2 0 80-35.8 80-80s-35.8-80-80-80C368 57.3 310.7 0 240 0H208zm32 49.3c0-6-1.1-11.8-3.3-17.3H240c53 0 96 43 96 96c0 4-.6 7.8-1.7 11.4c-1.4 4.8-.5 10.1 2.5 14.1s7.8 6.4 12.8 6.4H368c26.5 0 48 21.5 48 48s-21.5 48-48 48H80c-26.5 0-48-21.5-48-48s21.5-48 48-48H97.4c4.9 0 9.5-2.2 12.5-6.1s4.1-8.8 3-13.6c-.6-2.7-1-5.4-1-8.3c0-19.9 16.1-36 36-36h45.3C219.1 96 240 75.1 240 49.3zM89.7 471.4c3.7 23.4 23.8 40.6 47.4 40.6h46.7 .3 79.7 .3 46.7c23.6 0 43.8-17.2 47.4-40.6L382 320H349.6L326.7 466.5c-1.2 7.8-7.9 13.5-15.8 13.5H281.4l13.3-160H262.6L249.3 480H198.7L185.4 320H153.3l13.3 160H137.1c-7.9 0-14.6-5.7-15.8-13.5L98.4 320H66L89.7 471.4z"]
};
var faLightSwitchOff = {
  prefix: 'fal',
  iconName: 'light-switch-off',
  icon: [384, 512, [], "e018", "M176 464v16H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H176V48c0 8.8 7.2 16 16 16s16-7.2 16-16V32H320c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H208V464c0-8.8-7.2-16-16-16s-16 7.2-16 16zM0 448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM176 344h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16zm-48 24V272H256v96c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm0-224c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96H128V144zM96 368c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48V368z"]
};
var faToggleLargeOff = {
  prefix: 'fal',
  iconName: 'toggle-large-off',
  icon: [576, 512, [], "e5b0", "M160 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm0 32H416c88.4 0 160-71.6 160-160s-71.6-160-160-160H160C71.6 96 0 167.6 0 256s71.6 160 160 160zm96-32c38.9-29.2 64-75.7 64-128s-25.1-98.8-64-128H416c70.7 0 128 57.3 128 128s-57.3 128-128 128H256z"]
};
var faPenFancySlash = {
  prefix: 'fal',
  iconName: 'pen-fancy-slash',
  icon: [640, 512, [], "e210", "M548.7 143.7c17.4-15.6 27.3-37.9 27.3-61.3C576 36.9 539.1 0 493.6 0c-23.4 0-45.6 9.9-61.3 27.3L308.2 165.2 333.4 185 456.1 48.7C465.7 38.1 479.3 32 493.6 32C521.4 32 544 54.6 544 82.4c0 14.3-6.1 27.9-16.7 37.5L398.1 236.1l25.5 20.1L548.7 143.7zM304.2 325L280 403.7c-3 9.9-10.7 17.7-20.5 20.9L131.2 467.4 198.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3l-67.4 67.4 42.8-128.3c3.3-9.8 11.1-17.4 20.9-20.5L240.7 275l-30.5-24.1-47.3 14.6c-19.8 6.1-35.4 21.3-41.9 40.9L66.9 468.6c-8.3 25 15.5 48.8 40.5 40.5L269.6 455c19.6-6.5 34.9-22.1 40.9-41.9l20.6-66.8L304.2 325zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTruckContainer = {
  prefix: 'fal',
  iconName: 'truck-container',
  icon: [640, 512, [], "f4dc", "M64 32H352c35.3 0 64 28.7 64 64V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V96C0 60.7 28.7 32 64 32zM448 160c0-17.7 14.3-32 32-32h56c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8V256v48 56c0 19.4-13.7 35.5-32 39.2l0 .8c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48H448V256 240 224 160zm144 64l-43.2-57.6c-3-4-7.8-6.4-12.8-6.4H480v64H592zm16 32H480v80c13.4-10 30-16 48-16c32.8 0 60.9 19.7 73.3 47.9c3.8-.6 6.7-3.9 6.7-7.9V304 256zM112 96c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faBoot = {
  prefix: 'fal',
  iconName: 'boot',
  icon: [512, 512, [129406], "f782", "M32 32H352V96H32V32zM0 32V96v32H32 352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM240 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v32H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h90.8c3.4 3 7.4 5.3 12 6.7l91.6 27.5c27.1 8.1 45.6 33 45.6 61.3V384H32V160H0V384v31.7 .3 41.4c0 14.5 5.8 28.4 16 38.6s24.1 16 38.6 16H69.5c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h11c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h11c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h14.9c14.5 0 28.4-5.8 38.6-16s16-24.1 16-38.6V416v-.3V384 351.4c0-42.4-27.8-79.8-68.4-92L352 232V176c0-8.8-7.2-16-16-16H240zM480.3 416v41.4c0 6.1-2.4 11.9-6.7 16.2s-10.1 6.7-16.2 6.7H442.5c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6c-15.5-15.5-40.6-15.5-56.1 0l22.4 22.4-22.4-22.4-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5h-11c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6c-15.5-15.5-40.6-15.5-56.1 0l-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5h-11c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6L134.3 485l21.8-21.8c-15.5-15.5-40.6-15.5-56.1 0l-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5H54.6c-6.1 0-11.9-2.4-16.2-6.7s-6.7-10.1-6.7-16.2V416H32 480h.3z"]
};
var faArrowUpFromWaterPump = {
  prefix: 'fal',
  iconName: 'arrow-up-from-water-pump',
  icon: [576, 512, [], "e4b6", "M112 32c-8.8 0-16 7.2-16 16V256H256V48c0-8.8-7.2-16-16-16H112zM288 48V256H432V54.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 54.6V256h48c35.3 0 64 28.7 64 64V425c-5.3-3.1-11.2-5.4-17.5-6.9c-4.8-1.1-9.7-2.8-14.5-4.8V320c0-17.7-14.3-32-32-32H448 288 256 96 64c-17.7 0-32 14.3-32 32v93.3c-4.8 2.1-9.7 3.7-14.5 4.8C11.2 419.6 5.3 421.9 0 425V320c0-35.3 28.7-64 64-64V48C64 21.5 85.5 0 112 0H240c26.5 0 48 21.5 48 48zM192 480c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z"]
};
var faFileCheck = {
  prefix: 'fal',
  iconName: 'file-check',
  icon: [384, 512, [], "f316", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM283.3 294c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-95.4 95.4-42-42c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L154 400.6c6.2 6.2 16.4 6.2 22.6 0L283.3 294z"]
};
var faBone = {
  prefix: 'fal',
  iconName: 'bone',
  icon: [576, 512, [129460], "f5d7", "M143.2 174.3C138.6 148 115.6 128 88 128c-30.9 0-56 25.1-56 56c0 16.3 7 31 18.2 41.3c17.9 16.4 17.9 45 0 61.4C39 297 32 311.7 32 328c0 30.9 25.1 56 56 56c27.6 0 50.6-20 55.2-46.3C146.3 320 161.7 304 183 304H393c21.3 0 36.7 16 39.8 33.7C437.4 364 460.4 384 488 384c30.9 0 56-25.1 56-56c0-16.3-7-31-18.2-41.3c-17.9-16.4-17.9-45 0-61.4C537 215 544 200.3 544 184c0-30.9-25.1-56-56-56c-27.6 0-50.6 20-55.2 46.3C429.7 192 414.3 208 393 208H183c-21.3 0-36.7-16-39.8-33.7zm31.5-5.5c.7 4.1 4.1 7.3 8.3 7.3H393c4.1 0 7.6-3.2 8.3-7.3C408.5 127.4 444.6 96 488 96c48.6 0 88 39.4 88 88c0 25.7-11 48.8-28.5 64.9c-4.1 3.7-4.1 10.5 0 14.2C565 279.2 576 302.3 576 328c0 48.6-39.4 88-88 88c-43.4 0-79.5-31.4-86.7-72.7c-.7-4.1-4.1-7.3-8.3-7.3H183c-4.1 0-7.6 3.2-8.3 7.3C167.5 384.6 131.4 416 88 416c-48.6 0-88-39.4-88-88c0-25.7 11-48.8 28.5-64.9c4.1-3.7 4.1-10.5 0-14.2C11 232.8 0 209.7 0 184c0-48.6 39.4-88 88-88c43.4 0 79.5 31.4 86.7 72.7z"]
};
var faCardsBlank = {
  prefix: 'fal',
  iconName: 'cards-blank',
  icon: [640, 512, [], "e4df", "M202.3 468.3c6.7 11 20.9 14.8 32.1 8.6c0 0 .1 0 .1-.1L427.4 365.5c0 0 .1 0 .1-.1c11.2-6.7 15-21.2 8.4-32.6L269.2 44.1c-6.6-11.5-21.3-15.4-32.8-8.8L44.1 146.4c-11.3 6.5-15.3 20.9-9 32.3c0 .1 .1 .1 .1 .2l167 289.3c0 .1 .1 .1 .1 .2zm-27.5 16.4c-.2-.3-.3-.6-.5-.9L7.6 195.2c-.2-.3-.3-.6-.5-.9c-14.9-26.5-5.7-60.2 20.7-75.5L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.3 26.5 6.3 60.3-20 75.8c-.2 .1-.5 .3-.7 .4l-192.3 111c-.2 .1-.5 .3-.7 .4c-26.4 14.9-59.8 6-75.3-20zM324.1 499l33.2-19.1c.9 .1 1.8 .2 2.7 .2H584c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H373L354.7 64.2c1.7-.2 3.5-.2 5.3-.2H584c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H360c-13.7 0-26.2-4.9-35.9-13z"]
};
var faCircle3 = {
  prefix: 'fal',
  iconName: 'circle-3',
  icon: [512, 512, [], "e0f0", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H276.7l-79.2 67.9c-5.1 4.4-6.9 11.5-4.6 17.7s8.4 10.4 15.1 10.4l63.5-.3c26.7-.1 48.4 21.5 48.4 48.2c0 26.6-21.6 48.2-48.2 48.2h-36c-17.5 0-34-8.2-44.5-22.2l-2.5-3.4c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4l2.5 3.4c16.5 22.1 42.5 35 70.1 35h36c44.3 0 80.2-35.9 80.2-80.2c0-44.4-36.1-80.4-80.6-80.2l-19.9 .1 78.9-67.6c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4H176z"]
};
var faBenchTree = {
  prefix: 'fal',
  iconName: 'bench-tree',
  icon: [640, 512, [], "e2e7", "M575.2 106.1c-1.9 11.9 3.1 23.9 12.9 30.9C600.2 145.8 608 160 608 176c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48c0-16 7.8-30.2 19.9-38.9c9.8-7.1 14.7-19 12.9-30.9c-.5-3.3-.8-6.7-.8-10.1c0-35.3 28.7-64 64-64s64 28.7 64 64c0 3.5-.3 6.8-.8 10.1zm31.6 5c.8-4.9 1.2-10 1.2-15.1c0-53-43-96-96-96s-96 43-96 96c0 5.1 .4 10.2 1.2 15.1C397.1 125.7 384 149.3 384 176c0 44.2 35.8 80 80 80h32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c44.2 0 80-35.8 80-80c0-26.7-13.1-50.3-33.2-64.9zM64 224H320v64H304 80 64V224zm0 96l0 48H48 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400H80 304h16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H336 320V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32zm224 0v48H96V320H288z"]
};
var faKeyboardBrightnessLow = {
  prefix: 'fal',
  iconName: 'keyboard-brightness-low',
  icon: [640, 512, [], "e1c1", "M320 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zM184 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm296 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSkiBootSki = {
  prefix: 'fal',
  iconName: 'ski-boot-ski',
  icon: [640, 512, [], "e3cd", "M415.6 19.4c1.9-8.6-3.7-17.1-12.3-19s-17.1 3.7-19 12.3L380.2 32H168c-7.6 0-14.2 5.3-15.7 12.8L88.2 358.4c-6.1 29.8 16.7 57.6 47 57.6H432c26.5 0 48-21.5 48-48V315.8c0-18.2-10.3-34.8-26.5-42.9l-83.2-41.6L415.6 19.4zM279.2 64h94.2l-20.6 96c-.3 0-.5 0-.8 0H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h41.9l-6.9 32H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h60.2l90.9 45.5c5.4 2.7 8.8 8.3 8.8 14.3V368c0 8.8-7.2 16-16 16H135.2c-10.1 0-17.7-9.3-15.7-19.2l25.2-123.3c43.6-20 107.6-67.2 134.4-177.5zm-33 0c-20.3 76-60 115.7-93 136.6L181.1 64h65.1zM640 416c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3-28.7 64-64 64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H544c53 0 96-43 96-96z"]
};
var faBrainCircuit = {
  prefix: 'fal',
  iconName: 'brain-circuit',
  icon: [512, 512, [], "e0c6", "M192 32c26.5 0 48 21.5 48 48v48H212.7c-6.2-14.1-20.3-24-36.7-24c-22.1 0-40 17.9-40 40s17.9 40 40 40c16.4 0 30.5-9.9 36.7-24H240V272H192c-24.9 0-45.4 19-47.8 43.2C130 321.3 120 335.5 120 352c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.2-9.6-30.1-23.4-36.4c1.9-6.7 8.1-11.6 15.4-11.6h48V432c0 26.5-21.5 48-48 48c-20.4 0-37.9-12.8-44.8-30.8c-2.7-7.1-10.1-11.3-17.6-10c-3.1 .5-6.3 .8-9.5 .8c-30.9 0-56-25.1-56-56c0-7.8 1.6-15.2 4.4-21.8c3.1-7.2 .4-15.7-6.3-19.8C44 331 32 310.9 32 288c0-19.1 8.4-36.3 21.7-48.1c4.8-4.2 6.6-10.9 4.6-17c-1.5-4.7-2.4-9.7-2.4-15c0-20.4 12.8-38 30.9-44.9c7.3-2.8 11.5-10.4 10-18c-.6-3-.9-6-.9-9.2c0-22.4 15.4-41.3 36.2-46.5c6.6-1.7 11.4-7.3 12-14C146.5 51.1 167 32 192 32zm80 128h48c8.8 0 16 7.2 16 16v11.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7V176c0-26.5-21.5-48-48-48H272V80c0-26.5 21.5-48 48-48c25 0 45.5 19.1 47.8 43.4c.6 6.7 5.4 12.4 12 14C400.6 94.7 416 113.6 416 136c0 3.1-.3 6.2-.9 9.2c-1.5 7.6 2.7 15.2 10 18C443.2 170 456 187.6 456 208c0 5.2-.8 10.3-2.4 15c-2 6.1-.2 12.8 4.6 17C471.6 251.7 480 268.9 480 288c0 22.9-12 43-30.2 54.3c-6.7 4.2-9.3 12.6-6.3 19.8c2.8 6.7 4.4 14.1 4.4 21.8c0 30.9-25.1 56-56 56c-3.3 0-6.5-.3-9.5-.8c-7.5-1.3-14.9 2.9-17.6 10c-6.9 18-24.4 30.8-44.8 30.8c-26.5 0-48-21.5-48-48V384h59.3c6.2 14.1 20.3 24 36.7 24c22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24H272V160zM192 512c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c29.6 0 55.5-16.1 69.3-40c.9 0 1.8 0 2.7 0c48.6 0 88-39.4 88-88c0-7.6-1-15-2.8-22c21.2-17.6 34.8-44.2 34.8-74c0-25.1-9.6-48-25.4-65c.9-4.9 1.4-9.9 1.4-15c0-29.6-16.1-55.5-40-69.3c0-.9 0-1.8 0-2.7c0-33.6-20.7-62.4-50.1-74.2C389.7 26.4 357.9 0 320 0c-26.2 0-49.4 12.6-64 32C241.4 12.6 218.2 0 192 0c-37.9 0-69.7 26.4-77.9 61.8C84.7 73.6 64 102.4 64 136c0 .9 0 1.8 0 2.7C40.1 152.5 24 178.4 24 208c0 5.1 .5 10.1 1.4 15C9.6 240 0 262.9 0 288c0 29.8 13.6 56.4 34.8 74C33 369 32 376.4 32 384c0 48.6 39.4 88 88 88c.9 0 1.8 0 2.7 0c13.8 23.9 39.7 40 69.3 40zM176 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faUserInjured = {
  prefix: 'fal',
  iconName: 'user-injured',
  icon: [448, 512, [], "f728", "M320 128c0 53-43 96-96 96s-96-43-96-96c0-5.5 .5-10.8 1.3-16H192 318.7c.9 5.2 1.3 10.5 1.3 16zM307.2 80H237.6l39.8-31.8c12.2 8.2 22.4 19.1 29.8 31.8zM243.8 34L186.4 80H140.8c16.6-28.7 47.6-48 83.2-48c6.8 0 13.4 .7 19.8 2zM352 128A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM32 480c.5-33.7 12.4-64.6 32-89v89H32zm64 0V361.3c12.9-8.8 27.3-15.6 42.7-19.9L226.9 480H96zm224-32c0 17.7-14.3 32-32 32H264.8l-40.7-64H288c17.7 0 32 14.3 32 32zM80 512h80 16H288 418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H80zm336-32H343.4c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64H203.7l-30.5-47.9c1.7-.1 3.4-.1 5.1-.1h91.4c80 0 145 64.3 146.3 144z"]
};
var faBlockBrickFire = {
  prefix: 'fal',
  iconName: 'block-brick-fire',
  icon: [640, 512, ["firewall"], "e3dc", "M168 64v64h72 32 72V64H168zm-32 0H96C78.3 64 64 78.3 64 96v32h72V64zM64 160v80h72 32 72V160H64zm0 192h72V272H64v80zm0 32v32c0 17.7 14.3 32 32 32H240V384H168 136 64zm104-32H288c.1 10.9 1.1 21.6 3 32H272v64h42.4c6.6 11.4 14.4 22.2 23.2 32H96c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64v48.6c-1.7-1.5-3.3-3.1-5-4.6c-7.7-7-17.2-10.9-27-11.8V96c0-17.7-14.3-32-32-32H376v64 32H272v80h54.9c-.6 .9-1.1 1.8-1.7 2.7c-5.8 9.5-11.3 19.3-16.2 29.3H168v80zm341.4-98.5c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1c-18.3 29.6-27.6 57.9-27.6 75.8C352 422.5 408.2 480 480 480c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zm-21.8-56.4c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zM445.1 256c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0C521.3 442 502.3 448 481 448c-25.9 0-50.2-8.4-68.2-24.8C394.7 406.6 384 382.7 384 354c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L507 351l-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.4-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6C445.7 409.9 461.9 416 481 416c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5z"]
};
var faFirewall = faBlockBrickFire;
var faFaceSadTear = {
  prefix: 'fal',
  iconName: 'face-sad-tear',
  icon: [512, 512, [128546, "sad-tear"], "f5b4", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM160 300.4c-5.5 6.9-11 14.3-16.2 22c-11.4 17.1-15.8 29-15.8 34.9c0 12.2 11.7 26.7 32 26.7s32-14.5 32-26.7c0-5.9-4.4-17.8-15.8-34.9c-5.1-7.7-10.7-15.1-16.2-22zm-8.6-40.3c4.3-5.5 12.8-5.5 17.1 0c1.6 2 3.3 4.1 5.2 6.3c18.9 23 50.3 61.2 50.3 90.8c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-29.2 30.8-66.9 49.6-90l0 0 0 0c2.1-2.6 4.1-5 5.8-7.2zM256 320c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16s7.2-16 16-16zM359.6 208a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSadTear = faFaceSadTear;
var faPlane = {
  prefix: 'fal',
  iconName: 'plane',
  icon: [576, 512, [], "f072", "M562.7 221.2c7.6 9.5 13.3 21.3 13.3 34.8c0 26.9-21.6 47.1-41.8 59.2c-21.1 12.7-47.3 20.8-67.9 20.8H365.9L279.1 487.8c-8.5 15-24.5 24.2-41.7 24.2H181.2c-21.3 0-36.6-20.3-30.8-40.8L189.1 336H136L97.6 387.2C91.6 395.3 82.1 400 72 400H30c-16.6 0-30-13.4-30-30c0-2.8 .4-5.6 1.2-8.2L31.4 256 1.2 150.3C.4 147.6 0 144.8 0 142c0-16.6 13.4-30 30-30H72c10.1 0 19.6 4.7 25.6 12.8L136 176l53.1 0L150.4 40.8C144.6 20.3 160 0 181.2 0l56.2 0c17.2 0 33.1 9.2 41.7 24.2L365.9 176H466.3c20.7 0 46.9 8.4 68 21.2c10.7 6.5 20.8 14.5 28.4 24zm-45 3.3c-17.3-10.5-37.9-16.6-51.3-16.6H356.6c-5.7 0-11-3.1-13.9-8.1L251.3 40.1l13.9-7.9-13.9 7.9c-2.8-5-8.2-8.1-13.9-8.1l-56.2 0 44.5 155.6c1.4 4.8 .4 10-2.6 14s-7.8 6.4-12.8 6.4L128 208c-5 0-9.8-2.4-12.8-6.4L72 144H32.6L63.4 251.6c.8 2.9 .8 5.9 0 8.8L32.6 368H72l43.2-57.6c3-4 7.8-6.4 12.8-6.4h82.3c5 0 9.8 2.4 12.8 6.4s4 9.2 2.6 14L181.2 480h56.2c5.7 0 11-3.1 13.9-8.1l91.4-159.9c2.9-5 8.2-8.1 13.9-8.1H466.3c13.6 0 34.2-5.9 51.4-16.2C535.8 276.9 544 265.1 544 256c0-4.1-1.7-9-6.3-14.8c-4.6-5.8-11.5-11.5-20-16.7z"]
};
var faTentArrowsDown = {
  prefix: 'fal',
  iconName: 'tent-arrows-down',
  icon: [576, 512, [], "e581", "M203.9 117.3c-5.9-6.6-16-7.1-22.6-1.2l-53.3 48L128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 148.1-53.3-48c-6.6-5.9-16.7-5.4-22.6 1.2s-5.4 16.7 1.2 22.6l80 72c6.1 5.5 15.3 5.5 21.4 0l80-72c6.6-5.9 7.1-16 1.2-22.6zm352 0c-5.9-6.6-16-7.1-22.6-1.2l-53.3 48V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V164.1l-53.3-48c-6.6-5.9-16.7-5.4-22.6 1.2s-5.4 16.7 1.2 22.6l80 72c6.1 5.5 15.3 5.5 21.4 0l80-72c6.6-5.9 7.1-16 1.2-22.6zM297.5 163.1c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8C65.1 486.5 87.5 512 116.4 512H459.6c29 0 51.3-25.5 47.6-54.2L489.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM124.5 316.8L272 207.7v112 .5V480H116.4c-9.7 0-17.1-8.5-15.9-18.1l17.5-134.4c.6-4.3 2.9-8.2 6.4-10.8zM304 315.4V207.7L451.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1H405.9l-.3-.4L304 315.4zM304 480V376.2L368.2 480H304z"]
};
var faExclamation = {
  prefix: 'fal',
  iconName: 'exclamation',
  icon: [64, 512, [10069, 10071, 61738], "21", "M48 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 8.8 7.2 16 16 16s16-7.2 16-16V48zM32 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowsSpin = {
  prefix: 'fal',
  iconName: 'arrows-spin',
  icon: [512, 512, [], "e4bb", "M257.1 79.5c-11.3 0-22.4 1.1-33.1 3.1V50.2c10.8-1.7 21.9-2.6 33.1-2.6c53.8 0 102.8 20.4 139.7 53.9l27.1-27.1c15.1-15.1 41-4.4 41 17l0 86.1c0 8.8-7.2 16-16 16l-86.1 0c-21.4 0-32.1-25.9-17-41l28.3-28.3c-31.1-27.7-72.1-44.6-117-44.6zM124.2 140.2c-26.8 30.9-43.1 71.2-43.1 115.3c0 11.1 1 21.9 3 32.5H51.7c-1.7-10.6-2.5-21.4-2.5-32.5c0-53 19.8-101.3 52.4-138L74.3 90.3c-15.1-15.1-4.4-41 17-41l86.1 0c8.8 0 16 7.2 16 16v86.1c0 21.4-25.9 32.1-41 17l-28.2-28.2zM433.1 255.5c0-10.8-1-21.3-2.8-31.5h32.4c1.6 10.3 2.4 20.8 2.4 31.5c0 53.8-20.4 102.8-53.9 139.7l28.7 28.7c15.1 15.1 4.4 41-17 41H336.9c-8.8 0-16-7.2-16-16V362.8c0-21.4 25.8-32.1 41-17l26.7 26.7c27.7-31.1 44.6-72.1 44.6-117zM288 428.8v32.4c-10.1 1.5-20.4 2.3-30.9 2.3c-53 0-101.3-19.8-138-52.4L90.3 439.9c-15.1 15.1-41 4.4-41-17l0-86.1c0-8.8 7.2-16 16-16l86.1 0c21.4 0 32.1 25.9 17 41l-26.6 26.6c30.9 26.8 71.2 43.1 115.3 43.1c10.5 0 20.8-.9 30.9-2.7zm115.6 4.1l-50.7-50.7v50.7h50.7zM161.4 132.1V81.4l-50.7 0 50.7 50.7zm-80 271.5l50.7-50.7H81.4l0 50.7zM382.2 161.4l50.7 0V110.6l-50.7 50.7z"]
};
var faFaceSmileRelaxed = {
  prefix: 'fal',
  iconName: 'face-smile-relaxed',
  icon: [512, 512, [], "e392", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faCommentXmark = {
  prefix: 'fal',
  iconName: 'comment-xmark',
  icon: [512, 512, ["comment-times"], "f4b5", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM180.7 164.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 240l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 262.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 240l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 217.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faCommentTimes = faCommentXmark;
var faPrint = {
  prefix: 'fal',
  iconName: 'print',
  icon: [512, 512, [128424, 128438, 9113], "f02f", "M96 160H64V64C64 28.7 92.7 0 128 0H357.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V160H416V90.5c0-8.5-3.4-16.6-9.4-22.6L380.1 41.4c-6-6-14.1-9.4-22.6-9.4H128c-17.7 0-32 14.3-32 32v96zm352 64H64c-17.7 0-32 14.3-32 32V384H64V352c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32h32V256c0-17.7-14.3-32-32-32zm0 192v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V384c0 17.7-14.3 32-32 32H448zM96 352l0 128H416V352H96zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTurkishLiraSign = {
  prefix: 'fal',
  iconName: 'turkish-lira-sign',
  icon: [384, 512, ["try", "turkish-lira"], "e2bb", "M80 32c8.8 0 16 7.2 16 16v77.1L251.6 80.6c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8L96 158.4v62.7l155.6-44.5c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8L96 254.4V448h95.2C277 448 347.5 380.4 351 294.7l1-23.3c.4-8.8 7.8-15.7 16.7-15.3s15.7 7.8 15.3 16.7L383 296c-4.3 102.8-88.9 184-191.8 184H80c-8.8 0-16-7.2-16-16V263.5l-27.6 7.9c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8L64 230.2V167.5l-27.6 7.9c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8L64 134.2V48c0-8.8 7.2-16 16-16z"]
};
var faTry = faTurkishLiraSign;
var faTurkishLira = faTurkishLiraSign;
var faFaceNoseSteam = {
  prefix: 'fal',
  iconName: 'face-nose-steam',
  icon: [512, 512, [], "e382", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 10.1-.7 20.1-2 29.9c-1.2 8.8 5 16.8 13.7 18s16.8-5 18-13.7c1.5-11.2 2.3-22.6 2.3-34.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 11.6 .8 22.9 2.3 34.1c1.2 8.8 9.2 14.9 18 13.7s14.9-9.2 13.7-18c-1.3-9.8-2-19.7-2-29.9zM211.2 475.5c-8.7-1.8-17.1 3.8-18.9 12.5s3.8 17.1 12.5 18.9c16.6 3.4 33.7 5.1 51.2 5.1s34.6-1.8 51.2-5.1c8.7-1.8 14.3-10.2 12.5-18.9s-10.2-14.3-18.9-12.5c-14.5 2.9-29.5 4.5-44.8 4.5s-30.3-1.5-44.8-4.5zm-7.2-163.3c3.8-6.3 2.8-14.4-2.4-19.5s-13.2-6.2-19.5-2.4l-67.1 40.3c-1.1-1.4-2.3-2.8-3.7-4.1c-18.7-18.7-49.1-18.7-67.9 0c-2.7 2.7-5 5.6-6.9 8.8C22.7 334 8.6 338.6-1.9 349.1c-17.9 17.9-18.7 46.4-2.5 65.2c-10.3 23.4-5.8 51.8 13.4 70.9s47.5 23.6 70.9 13.4c18.9 16.2 47.3 15.4 65.2-2.5c10.5-10.5 15.1-24.6 13.9-38.3c3.1-1.9 6.1-4.2 8.8-6.9c18.7-18.7 18.7-49.1 0-67.9c-1.3-1.3-2.7-2.5-4.1-3.7l40.3-67.1zm124.3-21.1c-6.3-3.8-14.4-2.8-19.5 2.4s-6.2 13.3-2.4 19.5l40.3 67.1c-1.4 1.1-2.8 2.4-4.1 3.7c-18.7 18.7-18.7 49.1 0 67.9c2.7 2.7 5.6 5 8.8 6.9c-1.2 13.7 3.4 27.8 13.9 38.3c17.9 17.9 46.4 18.7 65.2 2.5c23.4 10.3 51.8 5.8 70.9-13.4s23.6-47.5 13.4-70.9c16.2-18.9 15.4-47.3-2.5-65.2c-10.5-10.5-24.6-15.1-38.3-13.9c-1.9-3.1-4.2-6.1-6.9-8.8c-18.7-18.7-49.1-18.7-67.9 0c-1.3 1.3-2.5 2.7-3.7 4.1l-67.1-40.3zM116.6 366.8l26.9-16.2-16.2 26.9c-2.6 4.4-3 9.8-1 14.5s6.1 8.2 11.1 9.3c2.8 .7 5.4 2.1 7.6 4.3c6.2 6.2 6.2 16.4 0 22.6c-2.3 2.3-5.2 3.8-8.2 4.4c-4.9 1-9 4.1-11.2 8.5s-2.3 9.6-.1 14.1c2.9 6 1.8 13.3-3.1 18.2c-6.2 6.2-16.4 6.2-22.6 0c-1-1-1.9-2.2-2.6-3.4c-2.3-4-6.2-6.8-10.7-7.7s-9.2 .2-12.9 3c-12.5 9.6-30.6 8.7-42.1-2.8s-12.4-29.5-2.8-42.1c2.8-3.7 3.9-8.4 3-12.9s-3.7-8.4-7.7-10.7c-1.2-.7-2.3-1.5-3.4-2.6c-6.2-6.2-6.2-16.4 0-22.6c4.9-4.9 12.3-6 18.2-3.1c4.5 2.1 9.7 2.1 14.1-.1s7.6-6.4 8.5-11.2c.6-3 2-5.8 4.4-8.2c6.2-6.2 16.4-6.2 22.6 0c2.2 2.2 3.6 4.8 4.3 7.6c1.2 5 4.6 9.1 9.3 11.1s10.1 1.6 14.5-1zm266.2 11.7l-16.2-26.9 26.9 16.2c4.4 2.6 9.8 3 14.5 1s8.2-6.1 9.3-11.1c.7-2.8 2.1-5.4 4.3-7.6c6.2-6.2 16.4-6.2 22.6 0c2.3 2.3 3.8 5.2 4.4 8.2c1 4.9 4.1 9 8.5 11.2s9.6 2.3 14.1 .1c6-2.9 13.3-1.8 18.2 3.1c6.2 6.2 6.2 16.4 0 22.6c-1 1-2.2 1.9-3.4 2.6c-4 2.3-6.8 6.2-7.7 10.7s.2 9.2 3 12.9c9.6 12.5 8.7 30.6-2.8 42.1s-29.5 12.4-42.1 2.8c-3.7-2.8-8.4-3.9-12.9-3s-8.4 3.7-10.7 7.7c-.7 1.2-1.5 2.3-2.6 3.4c-6.2 6.2-16.4 6.2-22.6 0c-4.9-4.9-6-12.3-3.1-18.2c2.1-4.5 2.1-9.7-.1-14.1s-6.4-7.6-11.2-8.5c-3-.6-5.8-2-8.2-4.4c-6.2-6.2-6.2-16.4 0-22.6c2.2-2.2 4.9-3.6 7.6-4.3c5-1.2 9.1-4.6 11.1-9.3s1.6-10.1-1-14.5zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm192 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm101.1-96.8c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1c-41.3 13.8-74.2 39.9-86.3 51.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c9.3-9.3 38.2-32.3 73.7-44.1zm-266.1 0c35.5 11.8 64.4 34.8 73.7 44.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-12-12-45-38.1-86.3-51.9c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2z"]
};
var faCircleWaveformLines = {
  prefix: 'fal',
  iconName: 'circle-waveform-lines',
  icon: [512, 512, ["waveform-circle"], "e12d", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 144V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zM160 176V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24V312c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-8.8 7.2-16 16-16s16 7.2 16 16zM224 216v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V216c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faWaveformCircle = faCircleWaveformLines;
var faDollarSign = {
  prefix: 'fal',
  iconName: 'dollar-sign',
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", "M176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V63.5c-6.3 .1-12.6 .3-18.8 .9c-24 2-47.9 7.8-67.4 20.6C37.7 98.1 23.2 118 17.9 146c-3.8 20.3-1.9 38.2 5.7 53.7C31 215 43.1 226.5 57.1 235.4c26.7 17 63.6 26.7 97.2 35.5l1.7 .4c35.7 9.4 67.8 17.9 89.8 31.9c10.6 6.8 17.8 14.2 21.9 22.6c4 8.3 5.8 19 3 33.8c-3.9 20.7-18.4 36.4-42.9 46c-24.9 9.8-59.1 12.6-98 7c-24.4-3.6-61-12.1-91.3-25.2c-8.1-3.5-17.5 .2-21 8.4s.2 17.5 8.4 21c33.6 14.5 73.1 23.5 99.3 27.4l.1 0c6.4 .9 12.7 1.6 18.9 2.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V447.4c23.2-.7 44.8-4.7 63.4-11.9c32-12.5 56.2-35.7 62.7-69.9c3.8-20.3 1.9-38.2-5.7-53.7c-7.4-15.3-19.6-26.8-33.5-35.6c-26.7-17-63.6-26.7-97.2-35.5l-1.7-.4c-35.7-9.4-67.8-17.9-89.8-31.9c-10.6-6.8-17.8-14.2-21.9-22.6c-4-8.3-5.8-19-3-33.8c3.6-19.3 13.1-31.8 26-40.2c13.4-8.8 31.5-13.7 52.6-15.5c42.3-3.5 91.3 6 124.3 14c8.6 2.1 17.2-3.2 19.3-11.8s-3.2-17.2-11.8-19.3c-21.9-5.3-52.1-11.7-83.8-14.4V16z"]
};
var faDollar = faDollarSign;
var faUsd = faDollarSign;
var faFerrisWheel = {
  prefix: 'fal',
  iconName: 'ferris-wheel',
  icon: [512, 512, [], "e174", "M272 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM211.8 66.7c-20.4 4.8-39.6 12.9-56.9 23.7c3.3 6.5 5.2 13.9 5.2 21.7c0 7.4-1.7 14.4-4.7 20.7l68.2 68.2c5.1-3 10.6-5.3 16.5-6.8V93.3c-12.7-4.5-23-14.2-28.2-26.6zM272 194c5.9 1.5 11.4 3.8 16.5 6.8l68.2-68.2c-3-6.3-4.7-13.3-4.7-20.7c0-7.8 1.9-15.2 5.2-21.7c-17.3-10.8-36.5-18.8-56.9-23.7C295 79 284.7 88.8 272 93.3V194zm39.1 29.5c3 5.1 5.3 10.6 6.8 16.5H418.7c4.3-12.1 13.3-22 24.9-27.5c-4.5-20.5-12.2-39.8-22.7-57.3c-6.3 3.1-13.4 4.8-20.9 4.8c-7.4 0-14.4-1.7-20.7-4.7l-68.2 68.2zM418.7 272H318c-4.6 17.9-16.7 32.7-32.8 41l81.4 176.3c2.3 5 1.9 10.7-1 15.3s-8 7.4-13.5 7.4H160c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3L226.8 313c-16.1-8.2-28.2-23.1-32.8-41H93.3c-4.2 11.8-12.8 21.5-23.9 27c4.9 20.4 13.1 39.5 24 56.8c5.7-2.4 12-3.7 18.6-3.7c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48c0-8.1 2-15.7 5.5-22.3c-14.9-22.4-26-47.7-32.1-74.8C16 298 0 278.9 0 256c0-22.5 15.5-41.4 36.3-46.6C42 181.2 53 154.8 68.1 131.5c-2.7-6-4.1-12.6-4.1-19.5c0-26.5 21.5-48 48-48c6.7 0 13 1.4 18.8 3.8c23.6-15.9 50.4-27.5 79.2-33.5C215.9 14.5 234.3 0 256 0s40.1 14.5 46 34.3c28.8 6 55.6 17.6 79.2 33.5C387 65.4 393.3 64 400 64c26.5 0 48 21.5 48 48c0 6.9-1.5 13.6-4.1 19.5c15.2 23.3 26.1 49.7 31.8 77.9c20.9 5.2 36.3 24.1 36.3 46.6c0 22.9-16 42-37.4 46.8c-6.1 27.1-17.1 52.4-32.1 74.8c3.5 6.7 5.5 14.3 5.5 22.3c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c6.6 0 12.9 1.3 18.6 3.7c10.9-17.3 19.1-36.4 24-56.8c-11.1-5.5-19.7-15.2-23.9-27zM194 240c1.5-5.9 3.8-11.4 6.8-16.5l-68.2-68.2c-6.3 3-13.3 4.7-20.7 4.7c-7.5 0-14.6-1.7-20.9-4.8C80.6 172.7 72.9 192 68.4 212.5C79.9 218 89 227.9 93.3 240H194zm254 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64-144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm272 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144-89.8L185 480H327L256 326.2zm0-38.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faComputerSpeaker = {
  prefix: 'fal',
  iconName: 'computer-speaker',
  icon: [640, 512, [], "f8b2", "M64 384c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H293.5c4.2-11.9 10.7-22.8 19-32H64C28.7 32 0 60.7 0 96V352c0 35.3 28.7 64 64 64H288V384H64zm48 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H312.4c-8.3-9.2-14.8-20.1-19-32H112zM576 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H576zM384 32c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H384zm96 352a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM496 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM480 96a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSkullCow = {
  prefix: 'fal',
  iconName: 'skull-cow',
  icon: [640, 512, [], "f8de", "M55.6 1.9c6.8 3.7 10 11.8 7.5 19.1L52 54.5c-2.5 7.5-3.4 15.4-2.6 23.2C52.3 106.3 76.3 128 105 128h79.4C202 108.4 227.6 96 256 96H384c28.4 0 54 12.4 71.6 32H535c28.7 0 52.7-21.7 55.6-50.3c.8-7.8-.1-15.8-2.6-23.2L576.8 21.1c-2.5-7.4 .7-15.4 7.5-19.1s15.3-2 20.1 4.1l7.5 9.3c18.2 22.7 28 50.9 28 80V112c0 70.7-57.3 128-128 128H480v48c0 41.8-26.7 77.3-64 90.5l-26.4 87.9c-8.1 27.1-33 45.6-61.3 45.6H311.6c-28.3 0-53.2-18.5-61.3-45.6L224 378.5c-37.3-13.2-64-48.7-64-90.5V240H128C57.3 240 0 182.7 0 112V95.3C0 66.2 9.9 38 28 15.3L35.5 6C40.3 0 48.8-1.8 55.6 1.9zM480 208h32c49.7 0 90.6-37.8 95.5-86.3C591.6 145 564.9 160 535 160H474.5c3.5 10 5.5 20.8 5.5 32v16zM105 160c-29.9 0-56.6-15-72.5-38.3C37.4 170.2 78.3 208 128 208h32V192c0-11.2 1.9-22 5.5-32H105zM234.6 348.4c9.6 3.4 17 11.2 20 21L281 457.2c4.1 13.5 16.5 22.8 30.7 22.8h16.8c14.1 0 26.6-9.3 30.7-22.8l26.4-87.9c2.9-9.8 10.4-17.6 20-21c24.9-8.8 42.6-32.6 42.6-60.4V192c0-35.3-28.7-64-64-64H256c-35.3 0-64 28.7-64 64v96c0 27.8 17.7 51.5 42.6 60.4zM232 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faX = {
  prefix: 'fal',
  iconName: 'x',
  icon: [384, 512, [120], "58", "M380.2 58.3c5.7-6.7 4.9-16.8-1.9-22.5s-16.8-4.9-22.6 1.9L192 231.2 28.2 37.7c-5.7-6.7-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5L171 256 3.8 453.7c-5.7 6.7-4.9 16.8 1.9 22.6s16.8 4.9 22.5-1.9L192 280.8 355.8 474.3c5.7 6.7 15.8 7.6 22.6 1.9s7.6-15.8 1.9-22.6L213 256 380.2 58.3z"]
};
var faMagnifyingGlassDollar = {
  prefix: 'fal',
  iconName: 'magnifying-glass-dollar',
  icon: [512, 512, ["search-dollar"], "f688", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm16-312c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V312c0 8.8 7.2 16 16 16s16-7.2 16-16V294.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V104z"]
};
var faSearchDollar = faMagnifyingGlassDollar;
var faUsersGear = {
  prefix: 'fal',
  iconName: 'users-gear',
  icon: [640, 512, ["users-cog"], "f509", "M144 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm112 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm119.2 78.5c12-8.4 21.9-19.5 29-32.5c7.5-13.7 11.8-29.4 11.8-46.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c20.6 0 39.6-6.5 55.2-17.5zM360.1 352H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H445.6c-1.1-2-2.1-4-3-6c-19.6 2.1-40.8-4.6-55.4-23.1c-.7-.9-1.5-1.9-2.2-2.8H160.1c2.8-53.5 47-96 101.2-96H372.1l0 0c-6.7-9.1-11.1-20.1-12-32zm278.2-67.4C629.1 232 583.2 192 528 192H444c2.6 10.2 4 21 4 32h65 15c28.7 0 53.9 15.2 68 37.9c15.5 1.4 30.9 8.5 42.3 22.7zM464 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM196 192H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80c0-11 1.4-21.8 4-32zM501 289.3v-.6c3.9-.5 7.9-.7 12-.7s8.1 .3 12 .7v.6c0 16.5 10.6 29.2 22 35.8c11.5 6.7 27.7 9.4 41.9 1.2l.5-.3c2.1 2.7 4 5.6 5.8 8.5l1.9 3.2c1.6 2.9 3.1 5.9 4.4 9l-.5 .3c-14.3 8.2-20 23.7-20 36.9s5.7 28.7 20 36.9l.5 .3c-1.3 3.1-2.7 6.1-4.3 9l-1.9 3.4c-1.8 2.9-3.7 5.7-5.7 8.4l-.5-.3c-14.2-8.2-30.4-5.5-41.9 1.2c-11.4 6.6-22 19.2-22 35.8v.6c-3.9 .5-7.9 .7-12 .7s-8.1-.3-12-.7v-.6c0-16.5-10.6-29.2-22-35.8c-11.5-6.7-27.7-9.4-41.9-1.2l-.5 .3c-2.1-2.7-4-5.5-5.7-8.4l-1.9-3.3c-1.6-2.9-3.1-5.9-4.4-9l.5-.3c14.3-8.2 20-23.7 20-36.9s-5.7-28.7-20-36.9l-.5-.3c1.3-3.1 2.8-6.1 4.4-9.1l1.8-3.2c1.8-2.9 3.7-5.8 5.8-8.5l.5 .3c14.2 8.2 30.4 5.5 41.9-1.2c11.4-6.6 22-19.2 22-35.8zM513 256c-6.1 0-12.2 .4-18.1 1.3c-16.2 2.3-25.9 16.5-25.9 30.7v1.4c0 2-1.5 5.4-6.1 8.1c-4.5 2.6-8.1 2.2-9.9 1.1l-1.2-.7c-12.2-7.1-29.4-5.8-39.5 7.1c-3.3 4.2-6.3 8.6-9.1 13.2l0 0-.1 .2-2 3.4 0 0-.1 .2c-2.5 4.6-4.8 9.4-6.8 14.3c-6.1 15.2 1.4 30.7 13.6 37.7l1.2 .7c1.8 1 4 4 4 9.2s-2.2 8.2-4 9.2l-1.2 .7c-12.2 7.1-19.7 22.6-13.6 37.7c2 4.9 4.2 9.6 6.7 14.2l0 0 .1 .3 2.1 3.6 0 0 .2 .3c2.7 4.6 5.8 8.9 9 13.1c10.1 12.8 27.3 14.1 39.5 7.1l1.2-.7c1.8-1 5.4-1.5 9.9 1.1c4.6 2.7 6.1 6.1 6.1 8.1v1.4c0 14.1 9.7 28.4 25.9 30.7c5.9 .8 12 1.3 18.1 1.3s12.2-.4 18.1-1.3c16.2-2.3 25.9-16.5 25.9-30.7v-1.4c0-2 1.5-5.4 6.1-8.1c4.5-2.6 8.1-2.2 9.9-1.1l1.2 .7c12.2 7.1 29.4 5.8 39.5-7.1c3.3-4.2 6.3-8.5 9-13.1l0 0 .2-.3 2.1-3.6 0 0 .1-.3c2.5-4.6 4.8-9.3 6.7-14.1c6.1-15.2-1.4-30.7-13.6-37.7l-1.2-.7c-1.8-1-4-4-4-9.2s2.2-8.2 4-9.2l1.2-.7c12.2-7.1 19.7-22.6 13.6-37.7c-2-4.9-4.2-9.7-6.8-14.2l0 0-.1-.2-2-3.5 0 0-.1-.2c-2.8-4.6-5.8-9-9.1-13.2c-10.1-12.8-27.3-14.1-39.5-7.1l-1.2 .7c-1.8 1-5.4 1.5-9.9-1.1c-4.6-2.7-6.1-6.1-6.1-8.1v-1.4c0-14.1-9.7-28.4-25.9-30.7c-5.9-.8-12-1.3-18.1-1.3zm15 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faUsersCog = faUsersGear;
var faPersonMilitaryPointing = {
  prefix: 'fal',
  iconName: 'person-military-pointing',
  icon: [576, 512, [], "e54a", "M256 59.1V64v0H384v0V37.8L256 59.1zM398.2 95.2c1.2 5.4 1.8 11 1.8 16.8c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.8 .6-11.4 1.8-16.8C231.5 92.4 224 83.1 224 72V52.3c0-11.7 8.5-21.7 20.1-23.7l144-24C402.7 2.2 416 13.5 416 28.3V72c0 11.1-7.5 20.4-17.8 23.2zm-33 .8H274.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16zM32 240c0-8.8 7.2-16 16-16H240h16 88 .3c40.2 0 77.3 21.5 97.2 56.4L541.9 456.1c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6L416 300.2V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V432.4c0-.2 0-.5 0-.7V256H48c-8.8 0-16-7.2-16-16zM256 464c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V448H256v16zM384 296c0-4.3-.7-8.5-1.9-12.4L273.8 416H384V296zm-40-40H256V387.2L360.4 259.5c-5-2.3-10.6-3.5-16.4-3.5z"]
};
var faBuildingColumns = {
  prefix: 'fal',
  iconName: 'building-columns',
  icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192H256 480.8c17.2 0 31.2-14 31.2-31.2c0-11.2-6-21.6-15.8-27.1L263.9 2.1zM306.6 160c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 8.6 1.9 16.7 5.4 24H34.3L256 34.4 477.7 160H306.6zM256 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H448c8.8 0 16-7.2 16-16s-7.2-16-16-16V224H416V352H336V224H304V352H208V224H176V352H96V224H64V352zM40 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H472c8.8 0 16-7.2 16-16s-7.2-16-16-16H40zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faBank = faBuildingColumns;
var faInstitution = faBuildingColumns;
var faMuseum = faBuildingColumns;
var faUniversity = faBuildingColumns;
var faCircleT = {
  prefix: 'fal',
  iconName: 'circle-t',
  icon: [512, 512, [], "e124", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96V368c0 8.8 7.2 16 16 16s16-7.2 16-16V176h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 144z"]
};
var faSack = {
  prefix: 'fal',
  iconName: 'sack',
  icon: [512, 512, [], "f81c", "M310.5 144h-109l-5.3 3.4C141.4 182.5 32 268.3 32 416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64c0-147.7-109.4-233.5-164.3-268.6l-5.3-3.4zm-3.8-41.8L355.1 32H156.9l48.4 70.2 6.7 9.8h87.8l6.7-9.8zM0 416C0 273.4 91.2 183.7 152.6 138.5c9.7-7.1 18.6-13.2 26.4-18.1L160.8 94 121.9 37.6C111 21.7 122.4 0 141.7 0H370.3c19.3 0 30.7 21.7 19.8 37.6L351.2 94 333 120.4c7.7 4.9 16.7 11 26.4 18.1C420.8 183.7 512 273.4 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96z"]
};
var faGrid2 = {
  prefix: 'fal',
  iconName: 'grid-2',
  icon: [512, 512, [], "e196", "M80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H80zM32 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zM80 320c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H80zM32 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336zM432 64H336c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM336 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 288c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H336zm-48 16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V336z"]
};
var faCameraCctv = {
  prefix: 'fal',
  iconName: 'camera-cctv',
  icon: [576, 512, ["cctv"], "f8ac", "M128 32L32 200 320 320 512 192 128 32zM100.2 16.1c8-14 25.2-19.9 40.1-13.7l384 160c10.9 4.5 18.4 14.7 19.5 26.5s-4.3 23.2-14.1 29.7l-192 128c-8.9 5.9-20.2 7-30.1 2.9l-85.6-35.7L175 437.7c-2.4 6.2-8.3 10.3-15 10.3H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368c0-8.8 7.2-16 16-16s16 7.2 16 16v48H149l43.6-114.4-172.9-72c-8.5-3.5-15-10.5-18-19.2s-2-18.2 2.5-26.2l96-168zM396.9 345.6l31.4-20.9 83.3 37.9 27.6-66.3-41-18.2 31.5-21 36.7 16.3c7.9 3.5 11.6 12.8 8.3 20.8l-40 96c-3.3 8-13.5 12-21.4 8.4L396.9 345.6z"]
};
var faCctv = faCameraCctv;
var faUmbrella = {
  prefix: 'fal',
  iconName: 'umbrella',
  icon: [576, 512, [], "f0e9", "M304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V48.4C132.8 55.6 18.9 156 2.1 285.9c-2 15.6 17.3 24.4 27.8 12.7C43.9 283 71.2 272 96 272c38.7 0 71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C217 299.5 249.3 272 288 272s71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C409 299.5 441.3 272 480 272c24.8 0 52.1 11 66.1 26.7c10.5 11.7 29.8 2.9 27.8-12.7C557.1 156 443.2 55.6 304 48.4V16zm80 278.3c-19.6-32.5-55.2-54.3-96-54.3s-76.4 21.8-96 54.3C172.4 261.8 136.8 240 96 240c-17.6 0-36.7 4.1-53.7 11.8C73.3 153 171 80 288 80s214.7 73 245.7 171.8C516.7 244.1 497.6 240 480 240c-40.8 0-76.4 21.8-96 54.3zM272 306.7V446.6c0 18.5-15 33.4-33.4 33.4c-12.7 0-24.2-7.2-29.9-18.5l-2.3-4.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l2.3 4.7C191.1 498 213.8 512 238.6 512c36.1 0 65.4-29.3 65.4-65.4V306.7c-5-1.8-10.4-2.7-16-2.7s-11 1-16 2.7z"]
};
var faTrowel = {
  prefix: 'fal',
  iconName: 'trowel',
  icon: [512, 512, [], "e589", "M491.8 20.2c26.9 26.9 26.9 70.5 0 97.5l-95.4 95.4c-14.6 14.6-38.2 14.6-52.8 0l-11-11-102 102 75.5 75.5c12.6 12.6 7.5 34.1-9.4 39.7L36.2 506.1C17.5 512.4-.4 494.5 5.9 475.8L92.7 215.2c5.6-16.9 27.1-22 39.7-9.4L208 281.4l102-102-11-11c-14.6-14.6-14.6-38.2 0-52.8l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0zM321.6 138.2c-2.1 2.1-2.1 5.5 0 7.5l44.7 44.7c2.1 2.1 5.5 2.1 7.5 0L469.2 95c14.4-14.4 14.4-37.8 0-52.2s-37.8-14.4-52.2 0l-95.4 95.4zM41.3 470.7L274.4 393 119 237.6 41.3 470.7z"]
};
var faHorizontalRule = {
  prefix: 'fal',
  iconName: 'horizontal-rule',
  icon: [640, 512, [8213], "f86c", "M0 256c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faBedFront = {
  prefix: 'fal',
  iconName: 'bed-front',
  icon: [512, 512, ["bed-alt"], "f8f7", "M64 96v40.6c9.4-5.4 20.3-8.6 32-8.6H208c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7H416c11.7 0 22.6 3.1 32 8.6V96c0-17.7-14.3-32-32-32H96C78.3 64 64 78.3 64 96zm416 96v48c19.4 14.6 32 37.8 32 64v96 64c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V400 304c0-26.2 12.6-49.4 32-64V192 96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64v96zm-32 33.6V192c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v32H432c5.5 0 10.8 .6 16 1.6zM240 224V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v33.6c5.2-1 10.5-1.6 16-1.6H240zm240 80c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v80H480V304z"]
};
var faBedAlt = faBedFront;
var faD = {
  prefix: 'fal',
  iconName: 'd',
  icon: [384, 512, [100], "44", "M48 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H160c106 0 192-86 192-192s-86-192-192-192H48zM0 80C0 53.5 21.5 32 48 32H160c123.7 0 224 100.3 224 224s-100.3 224-224 224H48c-26.5 0-48-21.5-48-48V80z"]
};
var faStapler = {
  prefix: 'fal',
  iconName: 'stapler',
  icon: [640, 512, [], "e5af", "M448 352v32H80c-26.5 0-48 21.5-48 48s21.5 48 48 48H592c26.5 0 48-21.5 48-48V416 384 336 304v-4.7c0-36.4-20.5-69.6-53.1-85.9L260.7 50.4C236.6 38.3 209.9 32 182.9 32C128.2 32 76.7 57.8 43.8 101.6L11.5 144.7C4 154.6 0 166.7 0 179.1c0 26.4 17.9 49.3 43.5 55.7L72 242v78c0 17.7 14.3 32 32 32H448zm-64-32H104V250l280 70zm224 64H480V336c0-14.7-10-27.5-24.2-31L51.3 203.8C39.9 201 32 190.8 32 179.1c0-5.5 1.8-10.9 5.1-15.3l32.3-43.1C96.2 85 138.3 64 182.9 64c22 0 43.8 5.1 63.5 15L572.6 242.1c21.7 10.8 35.4 33 35.4 57.2V304v32 48zM480 416H608v16c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448h32z"]
};
var faMasksTheater = {
  prefix: 'fal',
  iconName: 'masks-theater',
  icon: [640, 512, [127917, "theater-masks"], "f630", "M371.6 28c1.7 1.2 3.2 2.5 4.5 4c-23 .4-42.7 2.7-59.5 6.3c-26.4-6.7-68.1-10.5-131.4-.1C76.9 56.1 41.9 92.8 32.6 105.7l0 .1c-.1 .8-.2 2.4 .3 5L60.8 274.5c5.4 31.5 19.5 58.8 41.8 76.9c20.8 16.8 46.9 35.3 74 48.2c16.9 8.1 32.9 13.4 47.4 15.5c6.8 10.4 14.5 21.4 23 32.5c-58 4.9-123.3-37.8-165-71.7c-29.7-24-46.8-59-53.2-96.2L.8 116.1c-1.7-9.8-1-19.9 4.7-28C20.5 67 63.6 25.9 179.8 6.9S350.5 12.8 371.6 28zM159 286.9c9.4-7.6 22-15.8 37.8-21.8l-1.7 10.2c-1.5 9-2.5 18.2-2.9 27.5c-4.7 2.8-8.9 5.8-12.4 8.7c-5.7 4.7-11.3 9.9-15.7 15.9c-5 7.2-15.1 9.1-22.5 4.2c-7.4-4.9-9.4-14.8-4.4-22.1c5.9-8.6 13.8-16 21.8-22.6zm-3.9-122.6c3.1-8.2 12.5-12.4 20.9-9.3s12.7 12.3 9.5 20.5c-5.9 15.4-19.8 27.5-37.6 30.4s-35-4-45.7-16.7c-5.7-6.8-4.7-16.8 2.2-22.4s17.2-4.6 22.9 2.1c7.8 9.3 23.5 6.7 27.8-4.6zm230 346.3c-60-9.8-110.5-74.6-140.1-122c-20.1-32.2-24.7-70.7-18.3-107.9L254.6 117c1.7-9.8 5.6-19.1 13.8-24.9C289.5 76.8 344 51.8 460.2 70.9S619.5 131 634.5 152.1c5.8 8.1 6.4 18.2 4.7 28L611.3 343.8c-6.4 37.2-23.5 72.2-53.2 96.2c-43.7 35.4-113.1 80.5-173 70.7zm-58.5-69.5c21.7 21.3 43.5 34.7 63.8 38s45.4-2.4 73-15.6c27.1-13 53.2-31.4 74-48.2c22.3-18.1 36.4-45.4 41.8-76.9l27.9-163.7c.4-2.5 .4-4.2 .3-5l0-.1c-9.4-12.9-44.3-49.7-152.6-67.5s-153.6 5.9-166.7 15.1l0 .1c-.4 .7-1 2.2-1.4 4.8L258.7 285.9c-5.4 31.5-1.1 61.9 14 86.1c14.1 22.6 32.6 48.3 53.9 69.2zm24.7-202.5c-5.7 6.8-16 7.7-22.9 2.1s-7.9-15.6-2.2-22.4c10.7-12.7 27.8-19.6 45.7-16.7s31.7 15 37.6 30.4c3.1 8.2-1.1 17.4-9.5 20.5s-17.8-1.1-20.9-9.3c-2-5.2-6.6-9.2-12.5-10.1s-11.6 1.3-15.2 5.6zm147.8 85.7l.6-.2c3.1-1 6.1-2 9.1-3.1c3.7-1.4 7.3-2.9 10.9-4.5c6.2-2.8 13.5 1.6 12.4 8.3c-.7 4.2-1.7 8.3-2.8 12.3c-1 3.5-2.2 7-3.6 10.4c-.2 .5-.4 1-.6 1.5c-19.7 47-70.6 76.1-123.9 67.4s-91.7-52.5-94.8-103.3c0-.5-.1-1.1-.1-1.6c-.2-3.6-.1-7.3 .1-11c.2-4.1 .7-8.3 1.4-12.5c1.1-6.6 9.5-8.5 14.5-3.9c2.8 2.6 5.8 5.2 8.8 7.7c2.5 2 5 4 7.6 5.9l.5 .4c22 15.9 48 27.2 76.8 31.9s57.1 2.4 83.2-5.6zm-20.7 37.4c-21.9 3.4-44.8 3.4-67.8-.4s-44.6-11.1-64.2-21.3c10.9 22.9 32.8 40.4 60.2 44.9s53.9-5 71.8-23.2zm1.2-102c-5.7 6.8-16 7.7-22.9 2.1s-7.9-15.6-2.2-22.4c10.7-12.7 27.8-19.6 45.7-16.7s31.7 15 37.6 30.4c3.1 8.2-1.1 17.4-9.5 20.5s-17.8-1.1-20.9-9.3c-2-5.2-6.6-9.2-12.6-10.1s-11.6 1.3-15.2 5.6z"]
};
var faTheaterMasks = faMasksTheater;
var faKipSign = {
  prefix: 'fal',
  iconName: 'kip-sign',
  icon: [384, 512, [], "e1c4", "M80 32c8.8 0 16 7.2 16 16V222.4L325.9 35.6c6.9-5.6 16.9-4.5 22.5 2.3s4.5 16.9-2.3 22.5L125.1 240H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H125.1l221 179.6c6.9 5.6 7.9 15.6 2.3 22.5s-15.7 7.9-22.5 2.3L96 289.6V465c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V48c0-8.8 7.2-16 16-16z"]
};
var faFaceWoozy = {
  prefix: 'fal',
  iconName: 'face-woozy',
  icon: [512, 512, [], "e3a2", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM205.3 120.9c-28 42-69.6 64.1-88.3 70.3c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2c13.4-4.5 48.5-22.9 71.7-57.7c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2zm6.6 118.6l-64 16c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l64-16c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4zM411.3 347.3L372 386.6c-13.7 13.7-32.3 21.4-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1L267.4 388c-18.2-11.4-40.8-13.4-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4l11.5 7.7c18.5 12.3 41.8 14.7 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2c10.9 0 21.3-4.3 29-12l39.3-39.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM327.7 169.9c-4.5 8.9-7.7 22.4-7.7 38.1s3.2 29.2 7.7 38.1c2.2 4.5 4.5 7.2 6.2 8.7c.8 .7 1.4 1 1.7 1.1c.2 .1 .3 .1 .3 .1s.1 0 .1 0s0 0 0 0s0 0 .1 0c0 0 .1 0 .3-.1c.3-.1 .9-.4 1.7-1.1c1.7-1.5 4-4.2 6.2-8.7c4.5-8.9 7.7-22.4 7.7-38.1s-3.2-29.2-7.7-38.1c-2.2-4.5-4.5-7.2-6.2-8.7c-.8-.7-1.4-1-1.7-1.1c-.2-.1-.3-.1-.3-.1l0 0 0 0s0 0 0 0s0 0 0 0c0 0-.1 0-.3 .1c-.3 .1-.9 .4-1.7 1.1c-1.7 1.5-4 4.2-6.2 8.7zm-28.6-14.3c6.6-13.3 18.8-27.6 36.9-27.6s30.3 14.3 36.9 27.6c7.1 14.2 11.1 32.8 11.1 52.4s-3.9 38.2-11.1 52.4C366.3 273.7 354.2 288 336 288s-30.3-14.3-36.9-27.6C291.9 246.2 288 227.6 288 208s3.9-38.2 11.1-52.4z"]
};
var faCloudQuestion = {
  prefix: 'fal',
  iconName: 'cloud-question',
  icon: [640, 512, [], "e492", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM232.7 201.8c6.5-24.6 28.7-41.8 54.2-41.8H344c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L336 300.3V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V290.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H286.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM296 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faPineapple = {
  prefix: 'fal',
  iconName: 'pineapple',
  icon: [512, 512, [], "e31f", "M387.4 2.6c-12 5.2-21.8 13-29.1 22.5c-12.5-12.2-32.5-12-44.9 .3c-17.1 17.1-26.7 38.9-28.8 61.2c11 3.3 21.7 7.9 31.7 13.6C315.1 81.4 321.7 62.3 336 48l14.7 14.7c3.9 3.9 9.6 5.5 15 4.3s9.7-5.2 11.5-10.4C380.8 46 388.5 36.9 400 32l3.6 14.3c1.2 4.8 4.6 8.9 9.2 10.8s9.8 1.7 14.2-.8c9.5-5.4 20.4-8.3 31.5-8.3H464v5.5c0 11.2-2.9 22-8.3 31.5c-2.5 4.3-2.8 9.6-.8 14.2s6 8 10.8 9.2L480 112c-4.9 11.5-14 19.2-24.6 22.8c-5.2 1.8-9.2 6.1-10.4 11.5s.4 11 4.3 15L464 176c-14.3 14.3-33.4 20.9-52.1 19.8c5.7 10 10.2 20.7 13.6 31.7c22.3-2.1 44.1-11.7 61.2-28.8c12.4-12.4 12.5-32.4 .3-44.9c9.4-7.3 17.3-17.1 22.5-29.1c3.7-8.6 3.4-18.4-.7-26.8c-3.6-7.2-9.7-12.7-17.1-15.6c2.9-9.2 4.4-18.9 4.4-28.7V48c0-17.7-14.3-32-32-32h-5.5c-9.8 0-19.5 1.5-28.7 4.4c-2.9-7.4-8.4-13.5-15.6-17.1c-8.4-4.2-18.2-4.4-26.8-.7zM67.9 406.6C44.9 383.7 32 352.5 32 320s12.9-63.7 35.9-86.6l85.5-85.5c23-23 54.1-35.9 86.6-35.9s63.7 12.9 86.6 35.9l37.5 37.5c23 23 35.9 54.1 35.9 86.6s-12.9 63.7-35.9 86.6l-85.5 85.5c-23 23-54.1 35.9-86.6 35.9s-63.7-12.9-86.6-35.9L67.9 406.6zM45.3 429.3l37.5 37.5c29 29 68.3 45.3 109.3 45.3s80.3-16.3 109.3-45.3l85.5-85.5c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-37.5-37.5C320.3 96.3 281 80 240 80s-80.3 16.3-109.3 45.3L45.3 210.7C16.3 239.7 0 279 0 320s16.3 80.3 45.3 109.3zM148.7 212.7c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm-64 88c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L128 321.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm128 0c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 321.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm-64 88c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 409.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faHandPointLeft = {
  prefix: 'fal',
  iconName: 'hand-point-left',
  icon: [512, 512, [], "f0a5", "M56 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0 40 0 0-32c0-5.5 .6-10.8 1.6-16L56 128zm216 48l0 0 0 32 0 0 0 24c0 13.2 10.7 24 24 24l0 0c13.3 0 24-10.7 24-24l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 15.7-6.4 29.8-16.8 40c10.4 10.2 16.8 24.3 16.8 40c0 13.8-5 26.4-13.2 36.1C351.7 358.4 360 374.2 360 392c0 8.6-1.9 16.7-5.4 24C424.1 414.6 480 357.8 480 288l0-64c0-70.7-57.3-128-128-128l-32 0c-26.5 0-48 21.5-48 48l0 32zm-32 32l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l31.9 0c0 0 0 0 .1 0l13.4 0c-3.5-7.3-5.4-15.4-5.4-24l0-24zm-90.6 0L56 208c-30.9 0-56-25.1-56-56s25.1-56 56-56l200 0c14.6-19.4 37.8-32 64-32l32 0c88.4 0 160 71.6 160 160l0 64c0 88.4-71.6 160-160 160l-48 0-32 0-24 0c-30.9 0-56-25.1-56-56c0-12.1 3.8-23.3 10.4-32.5C186.5 349.6 176 332 176 312c0-9.7 2.5-18.8 6.8-26.7C160.3 278 144 256.9 144 232c0-8.6 1.9-16.7 5.4-24zM272 288l-40 0c-13.2 0-24 10.8-24 24c0 13.3 10.7 24 24 24l16 0 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l0 0-24 0zm0 128l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0z"]
};
var faGalleryThumbnails = {
  prefix: 'fal',
  iconName: 'gallery-thumbnails',
  icon: [576, 512, [], "e3aa", "M512 32c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H512zM64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 448v32H32l0-32H64zM32 416c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H32zm160 32h32v32H192V448zm-32 0v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm224 0v32H352V448h32zm-32-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H352zm160 32h32v32H512V448zm-32 0v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H512c-17.7 0-32 14.3-32 32z"]
};
var faCircleJ = {
  prefix: 'fal',
  iconName: 'circle-j',
  icon: [512, 512, [], "e112", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-368c0-8.8-7.2-16-16-16s-16 7.2-16 16V288c0 35.3-28.7 64-64 64s-64-28.7-64-64V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53 43 96 96 96s96-43 96-96V144z"]
};
var faEyes = {
  prefix: 'fal',
  iconName: 'eyes',
  icon: [640, 512, [], "e367", "M304 256c0 55.6-16.9 104.7-42.8 139.2C235.3 429.7 202.1 448 168 448s-67.3-18.3-93.2-52.8c-7-9.3-13.3-19.6-18.8-30.8c7.6 2.4 15.6 3.7 24 3.7c44.2 0 80-35.8 80-80s-35.8-80-80-80c-17.1 0-32.9 5.4-45.9 14.5c5.3-41.7 20.2-78.3 40.7-105.7C100.7 82.3 133.9 64 168 64s67.3 18.3 93.2 52.8C287.1 151.3 304 200.4 304 256zm16-95.5C293.1 84.5 235.2 32 168 32C75.2 32 0 132.3 0 256S75.2 480 168 480c67.2 0 125.1-52.5 152-128.5C346.9 427.5 404.8 480 472 480c92.8 0 168-100.3 168-224s-75.2-224-168-224c-67.2 0-125.1 52.5-152 128.5zm58.8 234.7c-7-9.3-13.3-19.6-18.8-30.8c7.6 2.4 15.6 3.7 24 3.7c44.2 0 80-35.8 80-80s-35.8-80-80-80c-17.1 0-32.9 5.4-45.9 14.5c5.3-41.7 20.2-78.3 40.7-105.7C404.7 82.3 437.9 64 472 64s67.3 18.3 93.2 52.8C591.1 151.3 608 200.4 608 256s-16.9 104.7-42.8 139.2S506.1 448 472 448s-67.3-18.3-93.2-52.8zM32 288a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm352-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faHandshakeSimple = {
  prefix: 'fal',
  iconName: 'handshake-simple',
  icon: [640, 512, [129309, "handshake-alt"], "f4c6", "M263.9 64h8.7L237.4 99.2c-16.6 4.1-32.2 11.9-45.5 23.1l-40.5 34c-2.9 2.4-6.5 3.8-10.3 3.8H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h87.3l36-30.3C197.2 76 230 64 263.9 64zm28.4 35c23.8-22.5 55.3-35 88.1-35c30.2 0 59.4 10.6 82.5 30.1L503.3 128H592c8.8 0 16 7.2 16 16s-7.2 16-16 16H497.5c-3.8 0-7.4-1.3-10.3-3.8l-44.8-37.7C425 104 403.1 96 380.4 96c-24.6 0-48.2 9.4-66.1 26.3l-79.4 75c-14.9 14.1-14.6 38 .8 51.6c13.5 12 33.8 11.8 47-.4l76.1-70.2c6.5-6 16.6-5.6 22.6 .9s5.6 16.6-.9 22.6l-8.1 7.5L458 294.8c7 7 12.1 15.2 15.1 24H592c8.8 0 16 7.2 16 16s-7.2 16-16 16H475.8c-2.3 13.8-9.2 27-20.6 37c-15.7 14-36.5 18.8-55.7 14.8c-2.7 8.1-7 15.8-13 22.5c-23 25.9-62 28.6-88.4 7.3c-.8 .7-1.5 1.5-2.3 2.2c-26.4 23.6-66.7 22.5-91.8-2.6l-24.3-24.3c0 0-.1-.1-.1-.1l-15.4-15.4-28.6-28.6c-7.5-7.5-17.7-11.7-28.3-11.7H48c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.4 0c19.1 0 37.4 7.6 50.9 21.1l28.6 28.6 39.9 39.8c13.1 13.1 34 13.6 47.8 1.3c3.2-2.9 5.8-6.2 7.6-9.8c2.4-4.5 6.7-7.6 11.8-8.4s10.1 .9 13.7 4.5l8.1 8.1c13.1 13.1 34.6 12.5 46.9-1.4c5.8-6.5 8.5-14.7 8.1-22.9c-.3-6 2.8-11.6 8-14.6s11.6-2.8 16.6 .5c11.8 7.6 27.6 6.7 38.6-3c13.7-12.2 14.4-33.5 1.4-46.5L348.9 231l-44.5 41c-25.3 23.4-64.2 23.7-90 .8C185 246.7 184.3 201 212.9 174l79.4-75z"]
};
var faHandshakeAlt = faHandshakeSimple;
var faPageCaretUp = {
  prefix: 'fal',
  iconName: 'page-caret-up',
  icon: [384, 512, ["file-caret-up"], "e42a", "M352 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H245.5c8.5 0 16.6 3.4 22.6 9.4l74.5 74.5c6 6 9.4 14.1 9.4 22.6V448zM64 512H320c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64zM203.8 197.2c-3-3.3-7.3-5.2-11.8-5.2s-8.8 1.9-11.8 5.2l-75.7 82.6c-14.1 15.4-3.2 40.2 17.7 40.2H261.8c20.9 0 31.8-24.8 17.7-40.2l-75.7-82.6zM192 231.7L243.6 288H140.4L192 231.7z"]
};
var faFileCaretUp = faPageCaretUp;
var faJetFighter = {
  prefix: 'fal',
  iconName: 'jet-fighter',
  icon: [640, 512, ["fighter-jet"], "f0fb", "M224 32h23.9L352.6 176H224V32zM384.2 208h106c1.9 0 3.8 .3 5.6 1l107.6 40.3c2.8 1 4.6 3.7 4.6 6.6s-1.8 5.6-4.6 6.6L495.8 303c-1.8 .7-3.7 1-5.6 1h-106-.4H208 160c-4.2 0-8.3 1.7-11.3 4.7l-38.6 38.6c-3 3-7.1 4.7-11.3 4.7H80c-8.8 0-16-7.2-16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V176c0-8.8 7.2-16 16-16H98.7c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7h48H383.8h.4zM32 272v64c0 26.5 21.5 48 48 48H98.7c12.7 0 24.9-5.1 33.9-14.1L166.6 336H192V480c-8.8 0-16 7.2-16 16s7.2 16 16 16h16 47.8 .4H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H287.4L392.1 336h98.1c5.8 0 11.5-1 16.9-3.1l107.6-40.3c15.3-5.7 25.4-20.3 25.4-36.6s-10.1-30.9-25.4-36.6L507.1 179.1c-5.4-2-11.1-3.1-16.9-3.1H392.1L287.4 32H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H256.2h-.4H208 192c-8.8 0-16 7.2-16 16s7.2 16 16 16V176H166.6l-33.9-33.9c-9-9-21.2-14.1-33.9-14.1H80c-26.5 0-48 21.5-48 48v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32zM224 480V336H352.6L247.9 480H224z"]
};
var faFighterJet = faJetFighter;
var faComet = {
  prefix: 'fal',
  iconName: 'comet',
  icon: [512, 512, [], "e003", "M320 32c0-26.4-30.1-41.4-51.2-25.6L81.1 147.2C30 185.5 0 246.1 0 309.8C0 420.9 90 512 201.3 512c64.6 0 125.3-31 163.2-83.4L498.6 242.7c15.3-21.2 .2-50.7-25.9-50.7H446.6L509 50.3c2-4.5 3-9.5 3-14.4C512 16 496 0 476.2 0c-5 0-9.9 1-14.4 3L320 65.4V32zm154.6 .3c.5-.2 1-.3 1.5-.3c2.1 0 3.8 1.7 3.8 3.8c0 .5-.1 1.1-.3 1.5L407.4 201.6c-2.2 4.9-1.7 10.7 1.2 15.2s8 7.3 13.4 7.3h50.6L338.5 409.8C306.7 453.9 255.6 480 201.3 480C107.9 480 32 403.4 32 309.8c0-53.8 25.3-104.8 68.3-137L288 32V89.9c0 5.4 2.7 10.4 7.3 13.4s10.2 3.4 15.2 1.2L474.6 32.3zM169.1 283.7c10.4-1.5 19.4-8.1 24.1-17.5L208 236.2l14.8 30.1c4.7 9.4 13.7 16 24.1 17.5l33.2 4.8-24 23.4c-7.5 7.4-11 17.9-9.2 28.3l5.7 33.1-29.7-15.6c-9.3-4.9-20.5-4.9-29.8 0l-29.7 15.6 5.7-33.1c1.8-10.4-1.7-21-9.2-28.3l-24-23.4 33.2-4.8zm53.3-90.8c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2L208 386.1l58.4 30.7c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2z"]
};
var faSquareShareNodes = {
  prefix: 'fal',
  iconName: 'square-share-nodes',
  icon: [448, 512, ["share-alt-square"], "f1e1", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-18.4 0-35.1-7.8-46.7-20.3l-81.7 44.6c.3 2.5 .5 5.1 .5 7.7s-.2 5.2-.5 7.7l81.7 44.6C284.9 295.8 301.6 288 320 288c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-5.4 .7-10.6 1.9-15.6l-78.2-42.7C168.1 309.6 149.2 320 128 320c-35.3 0-64-28.7-64-64s28.7-64 64-64c21.2 0 40.1 10.4 51.7 26.3l78.2-42.7c-1.3-5-1.9-10.2-1.9-15.6c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faShareAltSquare = faSquareShareNodes;
var faShieldKeyhole = {
  prefix: 'fal',
  iconName: 'shield-keyhole',
  icon: [512, 512, [], "e248", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM256 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 25.4 16.9 46.8 40 53.7V336c0 8.8 7.2 16 16 16s16-7.2 16-16V261.7c23.1-6.9 40-28.3 40-53.7z"]
};
var faBarcode = {
  prefix: 'fal',
  iconName: 'barcode',
  icon: [512, 512, [], "f02a", "M0 48c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zm64 0c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zm80-16c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zm80-16c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zM496 32c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16z"]
};
var faPlusMinus = {
  prefix: 'fal',
  iconName: 'plus-minus',
  icon: [384, 512, [], "e43c", "M176 208V352c0 8.8 7.2 16 16 16s16-7.2 16-16V208H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V32c0-8.8-7.2-16-16-16s-16 7.2-16 16V176H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H176zM16 464c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16z"]
};
var faSquareSlidersVertical = {
  prefix: 'fal',
  iconName: 'square-sliders-vertical',
  icon: [448, 512, ["sliders-v-square"], "f3f2", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 96c-8.8 0-16 7.2-16 16v48H104c-8.8 0-16 7.2-16 16s7.2 16 16 16h40 40c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V144c0-8.8-7.2-16-16-16zm0 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V272c0-8.8-7.2-16-16-16zM304 128c-8.8 0-16 7.2-16 16V256H264c-8.8 0-16 7.2-16 16s7.2 16 16 16h40 40c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16zm0 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16z"]
};
var faSlidersVSquare = faSquareSlidersVertical;
var faVideo = {
  prefix: 'fal',
  iconName: 'video',
  icon: [576, 512, ["video-camera"], "f03d", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64v47.2V336.8 384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM519.4 411.3L416 354.4V317.9l118.8 65.4c.9 .5 1.9 .8 3 .8c3.4 0 6.2-2.8 6.2-6.2V134.2c0-3.4-2.8-6.2-6.2-6.2c-1 0-2.1 .3-3 .8L416 194.1V157.6l103.4-56.9c5.6-3.1 12-4.7 18.4-4.7c21.1 0 38.2 17.1 38.2 38.2V377.8c0 21.1-17.1 38.2-38.2 38.2c-6.4 0-12.8-1.6-18.4-4.7z"]
};
var faVideoCamera = faVideo;
var faMessageMiddle = {
  prefix: 'fal',
  iconName: 'message-middle',
  icon: [512, 512, ["comment-middle-alt"], "e1e1", "M343.5 384H448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32H168.5c9.5 0 18.5 4.2 24.6 11.5L256 471l62.9-75.5C325 388.2 334 384 343.5 384zM268.3 485.7s0 0 0 0L256 496l12.3-10.2 0 0zM168.5 416H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H343.5l-75.2 90.2c-3 3.6-7.5 5.8-12.3 5.8s-9.3-2.1-12.3-5.8L168.5 416z"]
};
var faCommentMiddleAlt = faMessageMiddle;
var faGraduationCap = {
  prefix: 'fal',
  iconName: 'graduation-cap',
  icon: [640, 512, [127891, "mortar-board"], "f19d", "M307.2 66.2L47.6 160l74 26.7c10.3-6.9 21.5-12.6 33.4-17.1l159.4-59.8c8.3-3.1 17.5 1.1 20.6 9.4s-1.1 17.5-9.4 20.6L166.2 199.6c-1.5 .5-2.9 1.1-4.3 1.7l145.3 52.5c4.1 1.5 8.4 2.2 12.8 2.2s8.7-.8 12.8-2.2L592.4 160 332.8 66.2c-4.1-1.5-8.4-2.2-12.8-2.2s-8.7 .8-12.8 2.2zM296.3 283.9L126.9 222.7C99.4 246 82.1 279.9 80.2 316.9c5.9 13.2 10.2 27.5 13.4 41.5c6.4 27.6 10.7 65.9 2.1 108.7c-.9 4.3-3.4 8-7.1 10.4s-8.2 3.1-12.4 2l-64-16c-5.2-1.3-9.4-5.1-11.2-10.2s-.9-10.7 2.3-14.9c8.6-11.7 16-24.6 22.5-37.6C37.2 377.8 48 348.4 48 320c0-.6 0-1.2 .1-1.8c1.4-41 18-79.1 45.1-107.7L15.8 182.6C6.3 179.1 0 170.1 0 160s6.3-19.1 15.8-22.6L296.3 36.1c7.6-2.7 15.6-4.1 23.7-4.1s16.1 1.4 23.7 4.1L624.2 137.4c9.5 3.4 15.8 12.5 15.8 22.6s-6.3 19.1-15.8 22.6L343.7 283.9c-7.6 2.7-15.6 4.1-23.7 4.1s-16.1-1.4-23.7-4.1zm-122-10L160.4 406.3c.7 .8 1.8 2.1 3.7 3.7c6 5.2 16.5 11.5 31.9 17.5C226.4 439.4 270.3 448 320 448s93.6-8.6 124.1-20.6c15.4-6 25.8-12.3 31.9-17.5c1.9-1.6 3-2.8 3.7-3.7L465.7 273.8l31-11.2L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.3-145.4 31 11.2zM480.5 405a.2 .2 0 1 0 -.3-.1 .2 .2 0 1 0 .3 .1zm-321 0a.1 .1 0 1 0 .2 0 .1 .1 0 1 0 -.2 0zM67 444.2c2.5-20.7 1.7-40-.5-56.7c-3.8 10-8 19.3-12.1 27.6c-3.8 7.6-7.9 15.2-12.5 22.8L67 444.2z"]
};
var faMortarBoard = faGraduationCap;
var faHandHoldingMedical = {
  prefix: 'fal',
  iconName: 'hand-holding-medical',
  icon: [576, 512, [], "e05c", "M266.7 0h42.7c17.7 0 32 14.3 32 32V74.7H384c17.7 0 32 14.3 32 32v42.7c0 17.7-14.3 32-32 32H341.3V224c0 17.7-14.3 32-32 32H266.7c-17.7 0-32-14.3-32-32V181.3H192c-17.7 0-32-14.3-32-32V106.7c0-17.7 14.3-32 32-32h42.7V32c0-17.7 14.3-32 32-32zm0 32V90.7c0 8.8-7.2 16-16 16l-58.7 0v42.7h58.7c8.8 0 16 7.2 16 16V224h42.7V165.3c0-8.8 7.2-16 16-16l58.7 0V106.7H325.3c-8.8 0-16-7.2-16-16l0-58.7-42.7 0zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7H80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faPersonCircleCheck = {
  prefix: 'fal',
  iconName: 'person-circle-check',
  icon: [576, 512, [], "e53e", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faSquareZ = {
  prefix: 'fal',
  iconName: 'square-z',
  icon: [448, 512, [], "e288", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32H304c6 0 11.5 3.3 14.2 8.7s2.3 11.7-1.2 16.6L175.1 352H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-6 0-11.5-3.4-14.2-8.7s-2.3-11.7 1.2-16.6L272.9 160H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMessageText = {
  prefix: 'fal',
  iconName: 'message-text',
  icon: [512, 512, ["comment-alt-text"], "e1e6", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM192 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h48V272c0 8.8 7.2 16 16 16s16-7.2 16-16V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 192z"]
};
var faCommentAltText = faMessageText;
var faTurnUp = {
  prefix: 'fal',
  iconName: 'turn-up',
  icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M128 160H70.7c-3.7 0-6.7-3-6.7-6.7c0-1.9 .8-3.7 2.2-5L192 35.8 317.8 148.3c1.4 1.3 2.2 3.1 2.2 5c0 3.7-3 6.7-6.7 6.7H256c-17.7 0-32 14.3-32 32V368c0 61.9-50.1 112-112 112H48c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16l64 0c26.5 0 48-21.5 48-48V192c0-17.7-14.3-32-32-32zM206 5.3C202.1 1.9 197.2 0 192 0s-10.1 1.9-14 5.3L44.9 124.5C36.7 131.8 32 142.3 32 153.3C32 174.7 49.3 192 70.7 192H96h32v32V368c0 8.8-7.2 16-16 16l-64 0c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h64c79.5 0 144-64.5 144-144V224 192h32 25.3c21.4 0 38.7-17.3 38.7-38.7c0-11-4.7-21.5-12.9-28.8L206 5.3z"]
};
var faLevelUpAlt = faTurnUp;
var icons = {
  fa0: fa0,
  fa1: fa1,
  fa2: fa2,
  fa3: fa3,
  fa4: fa4,
  fa5: fa5,
  fa6: fa6,
  fa7: fa7,
  fa8: fa8,
  fa9: fa9,
  faFillDrip: faFillDrip,
  faArrowsToCircle: faArrowsToCircle,
  faCircleChevronRight: faCircleChevronRight,
  faChevronCircleRight: faChevronCircleRight,
  faWagonCovered: faWagonCovered,
  faLineHeight: faLineHeight,
  faBagel: faBagel,
  faTransporter7: faTransporter7,
  faAt: faAt,
  faRectanglesMixed: faRectanglesMixed,
  faPhoneArrowUpRight: faPhoneArrowUpRight,
  faPhoneArrowUp: faPhoneArrowUp,
  faPhoneOutgoing: faPhoneOutgoing,
  faTrashCan: faTrashCan,
  faTrashAlt: faTrashAlt,
  faCircleL: faCircleL,
  faHeadSideGoggles: faHeadSideGoggles,
  faHeadVr: faHeadVr,
  faTextHeight: faTextHeight,
  faUserXmark: faUserXmark,
  faUserTimes: faUserTimes,
  faFaceHandYawn: faFaceHandYawn,
  faGaugeSimpleMin: faGaugeSimpleMin,
  faTachometerSlowest: faTachometerSlowest,
  faStethoscope: faStethoscope,
  faCoffin: faCoffin,
  faMessage: faMessage,
  faCommentAlt: faCommentAlt,
  faSalad: faSalad,
  faBowlSalad: faBowlSalad,
  faInfo: faInfo,
  faRobotAstromech: faRobotAstromech,
  faRingDiamond: faRingDiamond,
  faFonduePot: faFonduePot,
  faTheta: faTheta,
  faFaceHandPeeking: faFaceHandPeeking,
  faSquareUser: faSquareUser,
  faDownLeftAndUpRightToCenter: faDownLeftAndUpRightToCenter,
  faCompressAlt: faCompressAlt,
  faExplosion: faExplosion,
  faFileLines: faFileLines,
  faFileAlt: faFileAlt,
  faFileText: faFileText,
  faWaveSquare: faWaveSquare,
  faRing: faRing,
  faBuildingUn: faBuildingUn,
  faDiceThree: faDiceThree,
  faTirePressureWarning: faTirePressureWarning,
  faWifiFair: faWifiFair,
  faWifi2: faWifi2,
  faCalendarDays: faCalendarDays,
  faCalendarAlt: faCalendarAlt,
  faMp3Player: faMp3Player,
  faAnchorCircleCheck: faAnchorCircleCheck,
  faTally4: faTally4,
  faRectangleHistory: faRectangleHistory,
  faBuildingCircleArrowRight: faBuildingCircleArrowRight,
  faVolleyball: faVolleyball,
  faVolleyballBall: faVolleyballBall,
  faSunHaze: faSunHaze,
  faTextSize: faTextSize,
  faUfo: faUfo,
  faFork: faFork,
  faUtensilFork: faUtensilFork,
  faArrowsUpToLine: faArrowsUpToLine,
  faMobileSignal: faMobileSignal,
  faBarcodeScan: faBarcodeScan,
  faSortDown: faSortDown,
  faSortDesc: faSortDesc,
  faFolderArrowDown: faFolderArrowDown,
  faFolderDownload: faFolderDownload,
  faCircleMinus: faCircleMinus,
  faMinusCircle: faMinusCircle,
  faFaceIcicles: faFaceIcicles,
  faShovel: faShovel,
  faDoorOpen: faDoorOpen,
  faFilms: faFilms,
  faRightFromBracket: faRightFromBracket,
  faSignOutAlt: faSignOutAlt,
  faFaceGlasses: faFaceGlasses,
  faNfc: faNfc,
  faAtom: faAtom,
  faSoap: faSoap,
  faIcons: faIcons,
  faHeartMusicCameraBolt: faHeartMusicCameraBolt,
  faMicrophoneLinesSlash: faMicrophoneLinesSlash,
  faMicrophoneAltSlash: faMicrophoneAltSlash,
  faClosedCaptioningSlash: faClosedCaptioningSlash,
  faCalculatorSimple: faCalculatorSimple,
  faCalculatorAlt: faCalculatorAlt,
  faBridgeCircleCheck: faBridgeCircleCheck,
  faSlidersUp: faSlidersUp,
  faSlidersV: faSlidersV,
  faLocationMinus: faLocationMinus,
  faMapMarkerMinus: faMapMarkerMinus,
  faPumpMedical: faPumpMedical,
  faFingerprint: faFingerprint,
  faSkiBoot: faSkiBoot,
  faStandardDefinition: faStandardDefinition,
  faRectangleSd: faRectangleSd,
  faH1: faH1,
  faHandPointRight: faHandPointRight,
  faMagnifyingGlassLocation: faMagnifyingGlassLocation,
  faSearchLocation: faSearchLocation,
  faMessageBot: faMessageBot,
  faForwardStep: faForwardStep,
  faStepForward: faStepForward,
  faFaceSmileBeam: faFaceSmileBeam,
  faSmileBeam: faSmileBeam,
  faLightCeiling: faLightCeiling,
  faMessageExclamation: faMessageExclamation,
  faCommentAltExclamation: faCommentAltExclamation,
  faBowlScoop: faBowlScoop,
  faBowlShavedIce: faBowlShavedIce,
  faSquareX: faSquareX,
  faUtilityPoleDouble: faUtilityPoleDouble,
  faFlagCheckered: faFlagCheckered,
  faChevronsUp: faChevronsUp,
  faChevronDoubleUp: faChevronDoubleUp,
  faFootball: faFootball,
  faFootballBall: faFootballBall,
  faUserVneck: faUserVneck,
  faSchoolCircleExclamation: faSchoolCircleExclamation,
  faCrop: faCrop,
  faAnglesDown: faAnglesDown,
  faAngleDoubleDown: faAngleDoubleDown,
  faUsersRectangle: faUsersRectangle,
  faPeopleRoof: faPeopleRoof,
  faSquareArrowRight: faSquareArrowRight,
  faArrowSquareRight: faArrowSquareRight,
  faLocationPlus: faLocationPlus,
  faMapMarkerPlus: faMapMarkerPlus,
  faLightbulbExclamationOn: faLightbulbExclamationOn,
  faPeopleLine: faPeopleLine,
  faBeerMugEmpty: faBeerMugEmpty,
  faBeer: faBeer,
  faCrateEmpty: faCrateEmpty,
  faDiagramPredecessor: faDiagramPredecessor,
  faTransporter: faTransporter,
  faCalendarCircleUser: faCalendarCircleUser,
  faArrowUpLong: faArrowUpLong,
  faLongArrowUp: faLongArrowUp,
  faPersonCarryBox: faPersonCarryBox,
  faPersonCarry: faPersonCarry,
  faFireFlameSimple: faFireFlameSimple,
  faBurn: faBurn,
  faPerson: faPerson,
  faMale: faMale,
  faLaptop: faLaptop,
  faFileCsv: faFileCsv,
  faMenorah: faMenorah,
  faUnion: faUnion,
  faChevronsLeft: faChevronsLeft,
  faChevronDoubleLeft: faChevronDoubleLeft,
  faCircleHeart: faCircleHeart,
  faHeartCircle: faHeartCircle,
  faTruckPlane: faTruckPlane,
  faRecordVinyl: faRecordVinyl,
  faBringForward: faBringForward,
  faSquareP: faSquareP,
  faFaceGrinStars: faFaceGrinStars,
  faGrinStars: faGrinStars,
  faSigma: faSigma,
  faCameraMovie: faCameraMovie,
  faBong: faBong,
  faClarinet: faClarinet,
  faTruckFlatbed: faTruckFlatbed,
  faSpaghettiMonsterFlying: faSpaghettiMonsterFlying,
  faPastafarianism: faPastafarianism,
  faArrowDownUpAcrossLine: faArrowDownUpAcrossLine,
  faLeafHeart: faLeafHeart,
  faHouseBuilding: faHouseBuilding,
  faCheeseSwiss: faCheeseSwiss,
  faSpoon: faSpoon,
  faUtensilSpoon: faUtensilSpoon,
  faJarWheat: faJarWheat,
  faEnvelopesBulk: faEnvelopesBulk,
  faMailBulk: faMailBulk,
  faFileCircleExclamation: faFileCircleExclamation,
  faBowArrow: faBowArrow,
  faCartXmark: faCartXmark,
  faHexagonXmark: faHexagonXmark,
  faTimesHexagon: faTimesHexagon,
  faXmarkHexagon: faXmarkHexagon,
  faCircleH: faCircleH,
  faHospitalSymbol: faHospitalSymbol,
  faMerge: faMerge,
  faPager: faPager,
  faCartMinus: faCartMinus,
  faAddressBook: faAddressBook,
  faContactBook: faContactBook,
  faPanFrying: faPanFrying,
  faGrid: faGrid,
  faGrid3: faGrid3,
  faFootballHelmet: faFootballHelmet,
  faHandLove: faHandLove,
  faTrees: faTrees,
  faStrikethrough: faStrikethrough,
  faPage: faPage,
  faK: faK,
  faDiagramPrevious: faDiagramPrevious,
  faGaugeMin: faGaugeMin,
  faTachometerAltSlowest: faTachometerAltSlowest,
  faFolderGrid: faFolderGrid,
  faEggplant: faEggplant,
  faRam: faRam,
  faLandmarkFlag: faLandmarkFlag,
  faLips: faLips,
  faPencil: faPencil,
  faPencilAlt: faPencilAlt,
  faBackward: faBackward,
  faCaretRight: faCaretRight,
  faComments: faComments,
  faPaste: faPaste,
  faFileClipboard: faFileClipboard,
  faDesktopArrowDown: faDesktopArrowDown,
  faCodePullRequest: faCodePullRequest,
  faPumpkin: faPumpkin,
  faClipboardList: faClipboardList,
  faPenField: faPenField,
  faBlueberries: faBlueberries,
  faTruckRampBox: faTruckRampBox,
  faTruckLoading: faTruckLoading,
  faNote: faNote,
  faArrowDownToSquare: faArrowDownToSquare,
  faUserCheck: faUserCheck,
  faCloudXmark: faCloudXmark,
  faVialVirus: faVialVirus,
  faBookBlank: faBookBlank,
  faBookAlt: faBookAlt,
  faGolfFlagHole: faGolfFlagHole,
  faMessageArrowDown: faMessageArrowDown,
  faCommentAltArrowDown: faCommentAltArrowDown,
  faFaceUnamused: faFaceUnamused,
  faSheetPlastic: faSheetPlastic,
  faCircle9: faCircle9,
  faBlog: faBlog,
  faUserNinja: faUserNinja,
  faPencilSlash: faPencilSlash,
  faBowlingPins: faBowlingPins,
  faPersonArrowUpFromLine: faPersonArrowUpFromLine,
  faDownRight: faDownRight,
  faScrollTorah: faScrollTorah,
  faTorah: faTorah,
  faWebhook: faWebhook,
  faBlindsOpen: faBlindsOpen,
  faFence: faFence,
  faUp: faUp,
  faArrowAltUp: faArrowAltUp,
  faBroomBall: faBroomBall,
  faQuidditch: faQuidditch,
  faQuidditchBroomBall: faQuidditchBroomBall,
  faDrumstick: faDrumstick,
  faSquareV: faSquareV,
  faFaceAwesome: faFaceAwesome,
  faGaveDandy: faGaveDandy,
  faDialOff: faDialOff,
  faToggleOff: faToggleOff,
  faFaceSmileHorns: faFaceSmileHorns,
  faBoxArchive: faBoxArchive,
  faArchive: faArchive,
  faGrapes: faGrapes,
  faPersonDrowning: faPersonDrowning,
  faDialMax: faDialMax,
  faCircleM: faCircleM,
  faCalendarImage: faCalendarImage,
  faCircleCaretDown: faCircleCaretDown,
  faCaretCircleDown: faCaretCircleDown,
  faArrowDown91: faArrowDown91,
  faSortNumericDesc: faSortNumericDesc,
  faSortNumericDownAlt: faSortNumericDownAlt,
  faFaceGrinTongueSquint: faFaceGrinTongueSquint,
  faGrinTongueSquint: faGrinTongueSquint,
  faShishKebab: faShishKebab,
  faSprayCan: faSprayCan,
  faAlarmSnooze: faAlarmSnooze,
  faScarecrow: faScarecrow,
  faTruckMonster: faTruckMonster,
  faGiftCard: faGiftCard,
  faW: faW,
  faCodePullRequestDraft: faCodePullRequestDraft,
  faSquareB: faSquareB,
  faElephant: faElephant,
  faEarthAfrica: faEarthAfrica,
  faGlobeAfrica: faGlobeAfrica,
  faRainbow: faRainbow,
  faCircleNotch: faCircleNotch,
  faTabletScreenButton: faTabletScreenButton,
  faTabletAlt: faTabletAlt,
  faPaw: faPaw,
  faMessageQuestion: faMessageQuestion,
  faCloud: faCloud,
  faTrowelBricks: faTrowelBricks,
  faSquare3: faSquare3,
  faFaceFlushed: faFaceFlushed,
  faFlushed: faFlushed,
  faHospitalUser: faHospitalUser,
  faMicrowave: faMicrowave,
  faChfSign: faChfSign,
  faTentArrowLeftRight: faTentArrowLeftRight,
  faCartCircleArrowUp: faCartCircleArrowUp,
  faTrashClock: faTrashClock,
  faGavel: faGavel,
  faLegal: faLegal,
  faSprinklerCeiling: faSprinklerCeiling,
  faBrowsers: faBrowsers,
  faTrillium: faTrillium,
  faMusicSlash: faMusicSlash,
  faTruckRamp: faTruckRamp,
  faBinoculars: faBinoculars,
  faMicrophoneSlash: faMicrophoneSlash,
  faBoxTissue: faBoxTissue,
  faCircleC: faCircleC,
  faStarChristmas: faStarChristmas,
  faChartBullet: faChartBullet,
  faMotorcycle: faMotorcycle,
  faTreeChristmas: faTreeChristmas,
  faTireFlat: faTireFlat,
  faSunglasses: faSunglasses,
  faBadge: faBadge,
  faMessagePen: faMessagePen,
  faCommentAltEdit: faCommentAltEdit,
  faMessageEdit: faMessageEdit,
  faBellConcierge: faBellConcierge,
  faConciergeBell: faConciergeBell,
  faPenRuler: faPenRuler,
  faPencilRuler: faPencilRuler,
  faArrowProgress: faArrowProgress,
  faChessRookPiece: faChessRookPiece,
  faChessRookAlt: faChessRookAlt,
  faSquareRoot: faSquareRoot,
  faAlbumCollectionCirclePlus: faAlbumCollectionCirclePlus,
  faPeopleArrows: faPeopleArrows,
  faPeopleArrowsLeftRight: faPeopleArrowsLeftRight,
  faFaceAngryHorns: faFaceAngryHorns,
  faMarsAndVenusBurst: faMarsAndVenusBurst,
  faTombstone: faTombstone,
  faSquareCaretRight: faSquareCaretRight,
  faCaretSquareRight: faCaretSquareRight,
  faScissors: faScissors,
  faCut: faCut,
  faListMusic: faListMusic,
  faSunPlantWilt: faSunPlantWilt,
  faToiletsPortable: faToiletsPortable,
  faHockeyPuck: faHockeyPuck,
  faMustache: faMustache,
  faHyphen: faHyphen,
  faTable: faTable,
  faUserChef: faUserChef,
  faMessageImage: faMessageImage,
  faCommentAltImage: faCommentAltImage,
  faUsersMedical: faUsersMedical,
  faSensorTriangleExclamation: faSensorTriangleExclamation,
  faSensorAlert: faSensorAlert,
  faMagnifyingGlassArrowRight: faMagnifyingGlassArrowRight,
  faTachographDigital: faTachographDigital,
  faDigitalTachograph: faDigitalTachograph,
  faFaceMask: faFaceMask,
  faPickleball: faPickleball,
  faStarSharpHalf: faStarSharpHalf,
  faUsersSlash: faUsersSlash,
  faClover: faClover,
  faMeat: faMeat,
  faReply: faReply,
  faMailReply: faMailReply,
  faStarAndCrescent: faStarAndCrescent,
  faEmptySet: faEmptySet,
  faHouseFire: faHouseFire,
  faSquareMinus: faSquareMinus,
  faMinusSquare: faMinusSquare,
  faHelicopter: faHelicopter,
  faBird: faBird,
  faCompass: faCompass,
  faSquareCaretDown: faSquareCaretDown,
  faCaretSquareDown: faCaretSquareDown,
  faHeartHalfStroke: faHeartHalfStroke,
  faHeartHalfAlt: faHeartHalfAlt,
  faFileCircleQuestion: faFileCircleQuestion,
  faLaptopCode: faLaptopCode,
  faJoystick: faJoystick,
  faGrillFire: faGrillFire,
  faRectangleVerticalHistory: faRectangleVerticalHistory,
  faSwatchbook: faSwatchbook,
  faPrescriptionBottle: faPrescriptionBottle,
  faBars: faBars,
  faNavicon: faNavicon,
  faKeyboardLeft: faKeyboardLeft,
  faPeopleGroup: faPeopleGroup,
  faHourglassEnd: faHourglassEnd,
  faHourglass3: faHourglass3,
  faHeartCrack: faHeartCrack,
  faHeartBroken: faHeartBroken,
  faFaceBeamHandOverMouth: faFaceBeamHandOverMouth,
  faDropletPercent: faDropletPercent,
  faHumidity: faHumidity,
  faSquareUpRight: faSquareUpRight,
  faExternalLinkSquareAlt: faExternalLinkSquareAlt,
  faFaceKissBeam: faFaceKissBeam,
  faKissBeam: faKissBeam,
  faCorn: faCorn,
  faRollerCoaster: faRollerCoaster,
  faPhotoFilmMusic: faPhotoFilmMusic,
  faRadar: faRadar,
  faSickle: faSickle,
  faFilm: faFilm,
  faCoconut: faCoconut,
  faRulerHorizontal: faRulerHorizontal,
  faShieldCross: faShieldCross,
  faCassetteTape: faCassetteTape,
  faSquareTerminal: faSquareTerminal,
  faPeopleRobbery: faPeopleRobbery,
  faLightbulb: faLightbulb,
  faCaretLeft: faCaretLeft,
  faCommentMiddle: faCommentMiddle,
  faTrashCanList: faTrashCanList,
  faBlock: faBlock,
  faCircleExclamation: faCircleExclamation,
  faExclamationCircle: faExclamationCircle,
  faSchoolCircleXmark: faSchoolCircleXmark,
  faArrowRightFromBracket: faArrowRightFromBracket,
  faSignOut: faSignOut,
  faFaceFrownSlight: faFaceFrownSlight,
  faCircleChevronDown: faCircleChevronDown,
  faChevronCircleDown: faChevronCircleDown,
  faSidebarFlip: faSidebarFlip,
  faUnlockKeyhole: faUnlockKeyhole,
  faUnlockAlt: faUnlockAlt,
  faTemperatureList: faTemperatureList,
  faCloudShowersHeavy: faCloudShowersHeavy,
  faHeadphonesSimple: faHeadphonesSimple,
  faHeadphonesAlt: faHeadphonesAlt,
  faSitemap: faSitemap,
  faPipeSection: faPipeSection,
  faSpaceStationMoonConstruction: faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt: faSpaceStationMoonAlt,
  faCircleDollarToSlot: faCircleDollarToSlot,
  faDonate: faDonate,
  faMemory: faMemory,
  faFaceSleeping: faFaceSleeping,
  faRoadSpikes: faRoadSpikes,
  faFireBurner: faFireBurner,
  faSquirrel: faSquirrel,
  faArrowUpToLine: faArrowUpToLine,
  faArrowToTop: faArrowToTop,
  faFlag: faFlag,
  faFaceCowboyHat: faFaceCowboyHat,
  faHanukiah: faHanukiah,
  faChartScatter3d: faChartScatter3d,
  faDisplayChartUp: faDisplayChartUp,
  faSquareCode: faSquareCode,
  faFeather: faFeather,
  faVolumeLow: faVolumeLow,
  faVolumeDown: faVolumeDown,
  faXmarkToSlot: faXmarkToSlot,
  faTimesToSlot: faTimesToSlot,
  faVoteNay: faVoteNay,
  faBoxTaped: faBoxTaped,
  faBoxAlt: faBoxAlt,
  faCommentSlash: faCommentSlash,
  faSwords: faSwords,
  faCloudSunRain: faCloudSunRain,
  faAlbum: faAlbum,
  faCircleN: faCircleN,
  faCompress: faCompress,
  faWheatAwn: faWheatAwn,
  faWheatAlt: faWheatAlt,
  faAnkh: faAnkh,
  faHandsHoldingChild: faHandsHoldingChild,
  faAsterisk: faAsterisk,
  faKeySkeletonLeftRight: faKeySkeletonLeftRight,
  faCommentLines: faCommentLines,
  faLuchadorMask: faLuchadorMask,
  faLuchador: faLuchador,
  faMaskLuchador: faMaskLuchador,
  faSquareCheck: faSquareCheck,
  faCheckSquare: faCheckSquare,
  faShredder: faShredder,
  faBookOpenCover: faBookOpenCover,
  faBookOpenAlt: faBookOpenAlt,
  faSandwich: faSandwich,
  faPesetaSign: faPesetaSign,
  faSquareParkingSlash: faSquareParkingSlash,
  faParkingSlash: faParkingSlash,
  faTrainTunnel: faTrainTunnel,
  faHeading: faHeading,
  faHeader: faHeader,
  faGhost: faGhost,
  faFaceAnguished: faFaceAnguished,
  faHockeySticks: faHockeySticks,
  faAbacus: faAbacus,
  faFilmSimple: faFilmSimple,
  faFilmAlt: faFilmAlt,
  faList: faList,
  faListSquares: faListSquares,
  faTreePalm: faTreePalm,
  faSquarePhoneFlip: faSquarePhoneFlip,
  faPhoneSquareAlt: faPhoneSquareAlt,
  faCartPlus: faCartPlus,
  faGamepad: faGamepad,
  faBorderCenterV: faBorderCenterV,
  faCircleDot: faCircleDot,
  faDotCircle: faDotCircle,
  faClipboardMedical: faClipboardMedical,
  faFaceDizzy: faFaceDizzy,
  faDizzy: faDizzy,
  faEgg: faEgg,
  faUpToLine: faUpToLine,
  faArrowAltToTop: faArrowAltToTop,
  faHouseMedicalCircleXmark: faHouseMedicalCircleXmark,
  faWatchFitness: faWatchFitness,
  faClockNineThirty: faClockNineThirty,
  faCampground: faCampground,
  faFolderPlus: faFolderPlus,
  faJug: faJug,
  faFutbol: faFutbol,
  faFutbolBall: faFutbolBall,
  faSoccerBall: faSoccerBall,
  faSnowBlowing: faSnowBlowing,
  faPaintbrush: faPaintbrush,
  faPaintBrush: faPaintBrush,
  faLock: faLock,
  faArrowDownFromLine: faArrowDownFromLine,
  faArrowFromTop: faArrowFromTop,
  faGasPump: faGasPump,
  faSignalBarsSlash: faSignalBarsSlash,
  faSignalAltSlash: faSignalAltSlash,
  faMonkey: faMonkey,
  faRectanglePro: faRectanglePro,
  faPro: faPro,
  faHouseNight: faHouseNight,
  faHotTubPerson: faHotTubPerson,
  faHotTub: faHotTub,
  faBlanket: faBlanket,
  faMapLocation: faMapLocation,
  faMapMarked: faMapMarked,
  faHouseFloodWater: faHouseFloodWater,
  faCommentsQuestionCheck: faCommentsQuestionCheck,
  faTree: faTree,
  faArrowsCross: faArrowsCross,
  faBackpack: faBackpack,
  faSquareSmall: faSquareSmall,
  faFolderArrowUp: faFolderArrowUp,
  faFolderUpload: faFolderUpload,
  faBridgeLock: faBridgeLock,
  faCrosshairsSimple: faCrosshairsSimple,
  faSackDollar: faSackDollar,
  faPenToSquare: faPenToSquare,
  faEdit: faEdit,
  faSquareSliders: faSquareSliders,
  faSlidersHSquare: faSlidersHSquare,
  faCarSide: faCarSide,
  faMessageMiddleTop: faMessageMiddleTop,
  faCommentMiddleTopAlt: faCommentMiddleTopAlt,
  faLightbulbOn: faLightbulbOn,
  faKnife: faKnife,
  faUtensilKnife: faUtensilKnife,
  faShareNodes: faShareNodes,
  faShareAlt: faShareAlt,
  faDisplayChartUpCircleDollar: faDisplayChartUpCircleDollar,
  faWaveSine: faWaveSine,
  faHeartCircleMinus: faHeartCircleMinus,
  faCircleW: faCircleW,
  faCircleCalendar: faCircleCalendar,
  faCalendarCircle: faCalendarCircle,
  faHourglassHalf: faHourglassHalf,
  faHourglass2: faHourglass2,
  faMicroscope: faMicroscope,
  faSunset: faSunset,
  faSink: faSink,
  faCalendarExclamation: faCalendarExclamation,
  faTruckContainerEmpty: faTruckContainerEmpty,
  faHandHeart: faHandHeart,
  faBagShopping: faBagShopping,
  faShoppingBag: faShoppingBag,
  faArrowDownZA: faArrowDownZA,
  faSortAlphaDesc: faSortAlphaDesc,
  faSortAlphaDownAlt: faSortAlphaDownAlt,
  faMitten: faMitten,
  faReplyClock: faReplyClock,
  faReplyTime: faReplyTime,
  faPersonRays: faPersonRays,
  faRight: faRight,
  faArrowAltRight: faArrowAltRight,
  faCircleF: faCircleF,
  faUsers: faUsers,
  faFacePleading: faFacePleading,
  faEyeSlash: faEyeSlash,
  faFlaskVial: faFlaskVial,
  faPoliceBox: faPoliceBox,
  faCucumber: faCucumber,
  faHeadSideBrain: faHeadSideBrain,
  faHand: faHand,
  faHandPaper: faHandPaper,
  faPersonBikingMountain: faPersonBikingMountain,
  faBikingMountain: faBikingMountain,
  faUtensilsSlash: faUtensilsSlash,
  faPrintMagnifyingGlass: faPrintMagnifyingGlass,
  faPrintSearch: faPrintSearch,
  faFolderBookmark: faFolderBookmark,
  faOm: faOm,
  faPi: faPi,
  faFlaskRoundPotion: faFlaskRoundPotion,
  faFlaskPotion: faFlaskPotion,
  faFaceShush: faFaceShush,
  faWorm: faWorm,
  faHouseCircleXmark: faHouseCircleXmark,
  faPlug: faPlug,
  faCalendarCircleExclamation: faCalendarCircleExclamation,
  faSquareI: faSquareI,
  faChevronUp: faChevronUp,
  faFaceSaluting: faFaceSaluting,
  faGaugeSimpleLow: faGaugeSimpleLow,
  faTachometerSlow: faTachometerSlow,
  faFacePersevering: faFacePersevering,
  faCircleCamera: faCircleCamera,
  faCameraCircle: faCameraCircle,
  faHandSpock: faHandSpock,
  faSpiderWeb: faSpiderWeb,
  faCircleMicrophone: faCircleMicrophone,
  faMicrophoneCircle: faMicrophoneCircle,
  faBookArrowUp: faBookArrowUp,
  faPopsicle: faPopsicle,
  faCommand: faCommand,
  faBlinds: faBlinds,
  faStopwatch: faStopwatch,
  faSaxophone: faSaxophone,
  faSquare2: faSquare2,
  faFieldHockeyStickBall: faFieldHockeyStickBall,
  faFieldHockey: faFieldHockey,
  faArrowUpSquareTriangle: faArrowUpSquareTriangle,
  faSortShapesUpAlt: faSortShapesUpAlt,
  faFaceScream: faFaceScream,
  faSquareM: faSquareM,
  faCameraWeb: faCameraWeb,
  faWebcam: faWebcam,
  faCommentArrowDown: faCommentArrowDown,
  faLightbulbCfl: faLightbulbCfl,
  faWindowFrameOpen: faWindowFrameOpen,
  faFaceKiss: faFaceKiss,
  faKiss: faKiss,
  faBridgeCircleXmark: faBridgeCircleXmark,
  faPeriod: faPeriod,
  faFaceGrinTongue: faFaceGrinTongue,
  faGrinTongue: faGrinTongue,
  faUpToDottedLine: faUpToDottedLine,
  faThoughtBubble: faThoughtBubble,
  faSkeletonRibs: faSkeletonRibs,
  faRaygun: faRaygun,
  faFlute: faFlute,
  faAcorn: faAcorn,
  faVideoArrowUpRight: faVideoArrowUpRight,
  faGrateDroplet: faGrateDroplet,
  faSealExclamation: faSealExclamation,
  faChessBishop: faChessBishop,
  faMessageSms: faMessageSms,
  faCoffeeBeans: faCoffeeBeans,
  faHatWitch: faHatWitch,
  faFaceGrinWink: faFaceGrinWink,
  faGrinWink: faGrinWink,
  faClockThreeThirty: faClockThreeThirty,
  faEarDeaf: faEarDeaf,
  faDeaf: faDeaf,
  faDeafness: faDeafness,
  faHardOfHearing: faHardOfHearing,
  faAlarmClock: faAlarmClock,
  faEclipse: faEclipse,
  faFaceRelieved: faFaceRelieved,
  faRoadCircleCheck: faRoadCircleCheck,
  faDiceFive: faDiceFive,
  faOctagonMinus: faOctagonMinus,
  faMinusOctagon: faMinusOctagon,
  faSquareRss: faSquareRss,
  faRssSquare: faRssSquare,
  faFaceZany: faFaceZany,
  faTricycle: faTricycle,
  faLandMineOn: faLandMineOn,
  faSquareArrowUpLeft: faSquareArrowUpLeft,
  faICursor: faICursor,
  faChartMixedUpCircleDollar: faChartMixedUpCircleDollar,
  faSaltShaker: faSaltShaker,
  faStamp: faStamp,
  faFilePlus: faFilePlus,
  faDrawSquare: faDrawSquare,
  faToiletPaperUnderSlash: faToiletPaperUnderSlash,
  faToiletPaperReverseSlash: faToiletPaperReverseSlash,
  faStairs: faStairs,
  faDroneFront: faDroneFront,
  faDroneAlt: faDroneAlt,
  faGlassEmpty: faGlassEmpty,
  faDialHigh: faDialHigh,
  faUserHelmetSafety: faUserHelmetSafety,
  faUserConstruction: faUserConstruction,
  faUserHardHat: faUserHardHat,
  faI: faI,
  faHryvniaSign: faHryvniaSign,
  faHryvnia: faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter: faArrowDownLeftAndArrowUpRightToCenter,
  faPills: faPills,
  faFaceGrinWide: faFaceGrinWide,
  faGrinAlt: faGrinAlt,
  faTooth: faTooth,
  faBasketballHoop: faBasketballHoop,
  faObjectsAlignBottom: faObjectsAlignBottom,
  faV: faV,
  faSparkles: faSparkles,
  faSquid: faSquid,
  faLeafyGreen: faLeafyGreen,
  faCircleArrowUpRight: faCircleArrowUpRight,
  faCalendars: faCalendars,
  faBangladeshiTakaSign: faBangladeshiTakaSign,
  faBicycle: faBicycle,
  faHammerWar: faHammerWar,
  faCircleD: faCircleD,
  faSpiderBlackWidow: faSpiderBlackWidow,
  faStaffSnake: faStaffSnake,
  faRodAsclepius: faRodAsclepius,
  faRodSnake: faRodSnake,
  faStaffAesculapius: faStaffAesculapius,
  faPear: faPear,
  faHeadSideCoughSlash: faHeadSideCoughSlash,
  faTriangle: faTriangle,
  faApartment: faApartment,
  faTruckMedical: faTruckMedical,
  faAmbulance: faAmbulance,
  faPepper: faPepper,
  faPiano: faPiano,
  faGunSquirt: faGunSquirt,
  faWheatAwnCircleExclamation: faWheatAwnCircleExclamation,
  faSnowman: faSnowman,
  faUserAlien: faUserAlien,
  faShieldCheck: faShieldCheck,
  faMortarPestle: faMortarPestle,
  faRoadBarrier: faRoadBarrier,
  faChartCandlestick: faChartCandlestick,
  faBriefcaseBlank: faBriefcaseBlank,
  faSchool: faSchool,
  faIgloo: faIgloo,
  faBracketRound: faBracketRound,
  faParenthesis: faParenthesis,
  faJoint: faJoint,
  faHorseSaddle: faHorseSaddle,
  faMugMarshmallows: faMugMarshmallows,
  faFilters: faFilters,
  faBellOn: faBellOn,
  faAngleRight: faAngleRight,
  faDialMed: faDialMed,
  faHorse: faHorse,
  faQ: faQ,
  faMonitorWaveform: faMonitorWaveform,
  faMonitorHeartRate: faMonitorHeartRate,
  faLinkSimple: faLinkSimple,
  faWhistle: faWhistle,
  faG: faG,
  faWineGlassCrack: faWineGlassCrack,
  faFragile: faFragile,
  faSlotMachine: faSlotMachine,
  faNotesMedical: faNotesMedical,
  faCarWash: faCarWash,
  faEscalator: faEscalator,
  faCommentImage: faCommentImage,
  faTemperatureHalf: faTemperatureHalf,
  faTemperature2: faTemperature2,
  faThermometer2: faThermometer2,
  faThermometerHalf: faThermometerHalf,
  faDongSign: faDongSign,
  faDonut: faDonut,
  faDoughnut: faDoughnut,
  faCapsules: faCapsules,
  faPooStorm: faPooStorm,
  faPooBolt: faPooBolt,
  faTally1: faTally1,
  faFaceFrownOpen: faFaceFrownOpen,
  faFrownOpen: faFrownOpen,
  faSquareDashed: faSquareDashed,
  faSquareJ: faSquareJ,
  faHandPointUp: faHandPointUp,
  faMoneyBill: faMoneyBill,
  faArrowUpBigSmall: faArrowUpBigSmall,
  faSortSizeUp: faSortSizeUp,
  faBarcodeRead: faBarcodeRead,
  faBaguette: faBaguette,
  faBowlSoftServe: faBowlSoftServe,
  faFaceHoldingBackTears: faFaceHoldingBackTears,
  faSquareUp: faSquareUp,
  faArrowAltSquareUp: faArrowAltSquareUp,
  faTrainSubwayTunnel: faTrainSubwayTunnel,
  faSubwayTunnel: faSubwayTunnel,
  faSquareExclamation: faSquareExclamation,
  faExclamationSquare: faExclamationSquare,
  faSemicolon: faSemicolon,
  faBookmark: faBookmark,
  faFanTable: faFanTable,
  faAlignJustify: faAlignJustify,
  faBatteryLow: faBatteryLow,
  faBattery1: faBattery1,
  faCreditCardFront: faCreditCardFront,
  faBrainArrowCurvedRight: faBrainArrowCurvedRight,
  faMindShare: faMindShare,
  faUmbrellaBeach: faUmbrellaBeach,
  faHelmetUn: faHelmetUn,
  faLocationSmile: faLocationSmile,
  faMapMarkerSmile: faMapMarkerSmile,
  faArrowLeftToLine: faArrowLeftToLine,
  faArrowToLeft: faArrowToLeft,
  faBullseye: faBullseye,
  faSushi: faSushi,
  faNigiri: faNigiri,
  faMessageCaptions: faMessageCaptions,
  faCommentAltCaptions: faCommentAltCaptions,
  faTrashList: faTrashList,
  faBacon: faBacon,
  faOption: faOption,
  faHandPointDown: faHandPointDown,
  faArrowUpFromBracket: faArrowUpFromBracket,
  faTrashPlus: faTrashPlus,
  faObjectsAlignTop: faObjectsAlignTop,
  faFolder: faFolder,
  faFolderBlank: faFolderBlank,
  faFaceAnxiousSweat: faFaceAnxiousSweat,
  faCreditCardBlank: faCreditCardBlank,
  faFileWaveform: faFileWaveform,
  faFileMedicalAlt: faFileMedicalAlt,
  faMicrochipAi: faMicrochipAi,
  faMug: faMug,
  faPlaneUpSlash: faPlaneUpSlash,
  faRadiation: faRadiation,
  faPenCircle: faPenCircle,
  faBagSeedling: faBagSeedling,
  faChartSimple: faChartSimple,
  faCrutches: faCrutches,
  faCircleParking: faCircleParking,
  faParkingCircle: faParkingCircle,
  faMarsStroke: faMarsStroke,
  faLeafOak: faLeafOak,
  faSquareBolt: faSquareBolt,
  faVial: faVial,
  faGauge: faGauge,
  faDashboard: faDashboard,
  faGaugeMed: faGaugeMed,
  faTachometerAltAverage: faTachometerAltAverage,
  faWandMagicSparkles: faWandMagicSparkles,
  faMagicWandSparkles: faMagicWandSparkles,
  faLambda: faLambda,
  faE: faE,
  faPizza: faPizza,
  faBowlChopsticksNoodles: faBowlChopsticksNoodles,
  faH3: faH3,
  faPenClip: faPenClip,
  faPenAlt: faPenAlt,
  faBridgeCircleExclamation: faBridgeCircleExclamation,
  faBadgePercent: faBadgePercent,
  faUser: faUser,
  faSensor: faSensor,
  faComma: faComma,
  faSchoolCircleCheck: faSchoolCircleCheck,
  faToiletPaperUnder: faToiletPaperUnder,
  faToiletPaperReverse: faToiletPaperReverse,
  faLightEmergency: faLightEmergency,
  faArrowDownToArc: faArrowDownToArc,
  faDumpster: faDumpster,
  faVanShuttle: faVanShuttle,
  faShuttleVan: faShuttleVan,
  faBuildingUser: faBuildingUser,
  faLightSwitch: faLightSwitch,
  faSquareCaretLeft: faSquareCaretLeft,
  faCaretSquareLeft: faCaretSquareLeft,
  faHighlighter: faHighlighter,
  faWavePulse: faWavePulse,
  faHeartRate: faHeartRate,
  faKey: faKey,
  faHatSanta: faHatSanta,
  faTamale: faTamale,
  faBoxCheck: faBoxCheck,
  faBullhorn: faBullhorn,
  faSteak: faSteak,
  faLocationCrosshairsSlash: faLocationCrosshairsSlash,
  faLocationSlash: faLocationSlash,
  faPersonDolly: faPersonDolly,
  faGlobe: faGlobe,
  faSynagogue: faSynagogue,
  faFileChartColumn: faFileChartColumn,
  faFileChartLine: faFileChartLine,
  faPersonHalfDress: faPersonHalfDress,
  faFolderImage: faFolderImage,
  faCalendarPen: faCalendarPen,
  faCalendarEdit: faCalendarEdit,
  faRoadBridge: faRoadBridge,
  faFaceSmileTear: faFaceSmileTear,
  faMessagePlus: faMessagePlus,
  faCommentAltPlus: faCommentAltPlus,
  faLocationArrow: faLocationArrow,
  faC: faC,
  faTabletButton: faTabletButton,
  faRectangleHistoryCircleUser: faRectangleHistoryCircleUser,
  faBuildingLock: faBuildingLock,
  faChartLineUp: faChartLineUp,
  faMailbox: faMailbox,
  faTruckBolt: faTruckBolt,
  faPizzaSlice: faPizzaSlice,
  faMoneyBillWave: faMoneyBillWave,
  faChartArea: faChartArea,
  faAreaChart: faAreaChart,
  faHouseFlag: faHouseFlag,
  faCircleThreeQuartersStroke: faCircleThreeQuartersStroke,
  faPersonCircleMinus: faPersonCircleMinus,
  faScalpel: faScalpel,
  faBan: faBan,
  faCancel: faCancel,
  faBellExclamation: faBellExclamation,
  faCircleBookmark: faCircleBookmark,
  faBookmarkCircle: faBookmarkCircle,
  faEggFried: faEggFried,
  faFaceWeary: faFaceWeary,
  faUniformMartialArts: faUniformMartialArts,
  faCameraRotate: faCameraRotate,
  faSunDust: faSunDust,
  faCommentText: faCommentText,
  faSprayCanSparkles: faSprayCanSparkles,
  faAirFreshener: faAirFreshener,
  faSignalBars: faSignalBars,
  faSignalAlt: faSignalAlt,
  faSignalAlt4: faSignalAlt4,
  faSignalBarsStrong: faSignalBarsStrong,
  faDiamondExclamation: faDiamondExclamation,
  faStar: faStar,
  faDialMin: faDialMin,
  faRepeat: faRepeat,
  faCross: faCross,
  faPageCaretDown: faPageCaretDown,
  faFileCaretDown: faFileCaretDown,
  faBox: faBox,
  faVenusMars: faVenusMars,
  faClockSevenThirty: faClockSevenThirty,
  faArrowPointer: faArrowPointer,
  faMousePointer: faMousePointer,
  faClockFourThirty: faClockFourThirty,
  faSignalBarsGood: faSignalBarsGood,
  faSignalAlt3: faSignalAlt3,
  faCactus: faCactus,
  faLightbulbGear: faLightbulbGear,
  faMaximize: faMaximize,
  faExpandArrowsAlt: faExpandArrowsAlt,
  faChargingStation: faChargingStation,
  faShapes: faShapes,
  faTriangleCircleSquare: faTriangleCircleSquare,
  faPlaneTail: faPlaneTail,
  faGaugeSimpleMax: faGaugeSimpleMax,
  faTachometerFastest: faTachometerFastest,
  faCircleU: faCircleU,
  faShieldSlash: faShieldSlash,
  faSquarePhoneHangup: faSquarePhoneHangup,
  faPhoneSquareDown: faPhoneSquareDown,
  faArrowUpLeft: faArrowUpLeft,
  faTransporter1: faTransporter1,
  faPeanuts: faPeanuts,
  faShuffle: faShuffle,
  faRandom: faRandom,
  faPersonRunning: faPersonRunning,
  faRunning: faRunning,
  faMobileRetro: faMobileRetro,
  faGripLinesVertical: faGripLinesVertical,
  faBinBottlesRecycle: faBinBottlesRecycle,
  faArrowUpFromSquare: faArrowUpFromSquare,
  faFileDashedLine: faFileDashedLine,
  faPageBreak: faPageBreak,
  faBracketCurlyRight: faBracketCurlyRight,
  faSpider: faSpider,
  faClockThree: faClockThree,
  faHandsBound: faHandsBound,
  faScalpelLineDashed: faScalpelLineDashed,
  faScalpelPath: faScalpelPath,
  faFileInvoiceDollar: faFileInvoiceDollar,
  faPipeSmoking: faPipeSmoking,
  faFaceAstonished: faFaceAstonished,
  faWindow: faWindow,
  faPlaneCircleExclamation: faPlaneCircleExclamation,
  faEar: faEar,
  faFileLock: faFileLock,
  faDiagramVenn: faDiagramVenn,
  faXRay: faXRay,
  faGoalNet: faGoalNet,
  faCoffinCross: faCoffinCross,
  faSpellCheck: faSpellCheck,
  faLocationXmark: faLocationXmark,
  faMapMarkerTimes: faMapMarkerTimes,
  faMapMarkerXmark: faMapMarkerXmark,
  faCircleQuarterStroke: faCircleQuarterStroke,
  faLasso: faLasso,
  faSlash: faSlash,
  faPersonToPortal: faPersonToPortal,
  faPortalEnter: faPortalEnter,
  faCalendarStar: faCalendarStar,
  faComputerMouse: faComputerMouse,
  faMouse: faMouse,
  faArrowRightToBracket: faArrowRightToBracket,
  faSignIn: faSignIn,
  faPegasus: faPegasus,
  faFilesMedical: faFilesMedical,
  faNfcLock: faNfcLock,
  faPersonSkiLift: faPersonSkiLift,
  faSkiLift: faSkiLift,
  faSquare6: faSquare6,
  faShopSlash: faShopSlash,
  faStoreAltSlash: faStoreAltSlash,
  faWindTurbine: faWindTurbine,
  faSlidersSimple: faSlidersSimple,
  faGridRound: faGridRound,
  faBadgeSheriff: faBadgeSheriff,
  faServer: faServer,
  faVirusCovidSlash: faVirusCovidSlash,
  faIntersection: faIntersection,
  faShopLock: faShopLock,
  faFamily: faFamily,
  faHourglassStart: faHourglassStart,
  faHourglass1: faHourglass1,
  faUserHairBuns: faUserHairBuns,
  faBlenderPhone: faBlenderPhone,
  faHourglassClock: faHourglassClock,
  faPersonSeatReclined: faPersonSeatReclined,
  faPaperPlaneTop: faPaperPlaneTop,
  faPaperPlaneAlt: faPaperPlaneAlt,
  faSend: faSend,
  faMessageArrowUp: faMessageArrowUp,
  faCommentAltArrowUp: faCommentAltArrowUp,
  faLightbulbExclamation: faLightbulbExclamation,
  faLayerMinus: faLayerMinus,
  faLayerGroupMinus: faLayerGroupMinus,
  faChartPieSimpleCircleCurrency: faChartPieSimpleCircleCurrency,
  faCircleE: faCircleE,
  faBuildingWheat: faBuildingWheat,
  faGaugeMax: faGaugeMax,
  faTachometerAltFastest: faTachometerAltFastest,
  faPersonBreastfeeding: faPersonBreastfeeding,
  faApostrophe: faApostrophe,
  faFireHydrant: faFireHydrant,
  faRightToBracket: faRightToBracket,
  faSignInAlt: faSignInAlt,
  faVideoPlus: faVideoPlus,
  faSquareRight: faSquareRight,
  faArrowAltSquareRight: faArrowAltSquareRight,
  faCommentSmile: faCommentSmile,
  faVenus: faVenus,
  faPassport: faPassport,
  faInboxIn: faInboxIn,
  faInboxArrowDown: faInboxArrowDown,
  faHeartPulse: faHeartPulse,
  faHeartbeat: faHeartbeat,
  faCircle8: faCircle8,
  faCloudsMoon: faCloudsMoon,
  faClockTenThirty: faClockTenThirty,
  faPeopleCarryBox: faPeopleCarryBox,
  faPeopleCarry: faPeopleCarry,
  faFolderUser: faFolderUser,
  faTrashCanXmark: faTrashCanXmark,
  faTemperatureHigh: faTemperatureHigh,
  faMicrochip: faMicrochip,
  faLeftLongToLine: faLeftLongToLine,
  faCrown: faCrown,
  faWeightHanging: faWeightHanging,
  faXmarksLines: faXmarksLines,
  faFilePrescription: faFilePrescription,
  faCalendarRange: faCalendarRange,
  faFlowerDaffodil: faFlowerDaffodil,
  faHandBackPointUp: faHandBackPointUp,
  faWeightScale: faWeightScale,
  faWeight: faWeight,
  faStarExclamation: faStarExclamation,
  faBooks: faBooks,
  faUserGroup: faUserGroup,
  faUserFriends: faUserFriends,
  faArrowUpAZ: faArrowUpAZ,
  faSortAlphaUp: faSortAlphaUp,
  faLayerPlus: faLayerPlus,
  faLayerGroupPlus: faLayerGroupPlus,
  faPlayPause: faPlayPause,
  faBlockQuestion: faBlockQuestion,
  faSnooze: faSnooze,
  faZzz: faZzz,
  faScannerImage: faScannerImage,
  faTvRetro: faTvRetro,
  faSquareT: faSquareT,
  faFarm: faFarm,
  faBarnSilo: faBarnSilo,
  faChessKnight: faChessKnight,
  faBarsSort: faBarsSort,
  faPalletBoxes: faPalletBoxes,
  faPaletteBoxes: faPaletteBoxes,
  faPalletAlt: faPalletAlt,
  faFaceLaughSquint: faFaceLaughSquint,
  faLaughSquint: faLaughSquint,
  faCodeSimple: faCodeSimple,
  faBoltSlash: faBoltSlash,
  faPanelFire: faPanelFire,
  faBinaryCircleCheck: faBinaryCircleCheck,
  faCommentMinus: faCommentMinus,
  faBurrito: faBurrito,
  faViolin: faViolin,
  faObjectsColumn: faObjectsColumn,
  faSquareChevronDown: faSquareChevronDown,
  faChevronSquareDown: faChevronSquareDown,
  faCommentPlus: faCommentPlus,
  faTriangleInstrument: faTriangleInstrument,
  faTriangleMusic: faTriangleMusic,
  faWheelchair: faWheelchair,
  faUserPilotTie: faUserPilotTie,
  faPianoKeyboard: faPianoKeyboard,
  faBedEmpty: faBedEmpty,
  faCircleArrowUp: faCircleArrowUp,
  faArrowCircleUp: faArrowCircleUp,
  faToggleOn: faToggleOn,
  faRectangleVertical: faRectangleVertical,
  faRectanglePortrait: faRectanglePortrait,
  faPersonWalking: faPersonWalking,
  faWalking: faWalking,
  faL: faL,
  faSignalStream: faSignalStream,
  faDownToBracket: faDownToBracket,
  faCircleZ: faCircleZ,
  faStars: faStars,
  faFire: faFire,
  faBedPulse: faBedPulse,
  faProcedures: faProcedures,
  faHouseDay: faHouseDay,
  faShuttleSpace: faShuttleSpace,
  faSpaceShuttle: faSpaceShuttle,
  faShirtLongSleeve: faShirtLongSleeve,
  faChartPieSimple: faChartPieSimple,
  faChartPieAlt: faChartPieAlt,
  faFaceLaugh: faFaceLaugh,
  faLaugh: faLaugh,
  faFolderOpen: faFolderOpen,
  faAlbumCollectionCircleUser: faAlbumCollectionCircleUser,
  faCandy: faCandy,
  faBowlHot: faBowlHot,
  faSoup: faSoup,
  faFlatbread: faFlatbread,
  faHeartCirclePlus: faHeartCirclePlus,
  faCodeFork: faCodeFork,
  faCity: faCity,
  faSignalBarsWeak: faSignalBarsWeak,
  faSignalAlt1: faSignalAlt1,
  faMicrophoneLines: faMicrophoneLines,
  faMicrophoneAlt: faMicrophoneAlt,
  faClockTwelve: faClockTwelve,
  faPepperHot: faPepperHot,
  faCitrusSlice: faCitrusSlice,
  faSheep: faSheep,
  faUnlock: faUnlock,
  faColonSign: faColonSign,
  faHeadset: faHeadset,
  faBadgerHoney: faBadgerHoney,
  faH4: faH4,
  faStoreSlash: faStoreSlash,
  faRoadCircleXmark: faRoadCircleXmark,
  faSignalSlash: faSignalSlash,
  faUserMinus: faUserMinus,
  faMarsStrokeUp: faMarsStrokeUp,
  faMarsStrokeV: faMarsStrokeV,
  faChampagneGlasses: faChampagneGlasses,
  faGlassCheers: faGlassCheers,
  faTaco: faTaco,
  faHexagonPlus: faHexagonPlus,
  faPlusHexagon: faPlusHexagon,
  faClipboard: faClipboard,
  faHouseCircleExclamation: faHouseCircleExclamation,
  faFileArrowUp: faFileArrowUp,
  faFileUpload: faFileUpload,
  faWifi: faWifi,
  faWifi3: faWifi3,
  faWifiStrong: faWifiStrong,
  faMessages: faMessages,
  faCommentsAlt: faCommentsAlt,
  faBath: faBath,
  faBathtub: faBathtub,
  faUmbrellaSimple: faUmbrellaSimple,
  faUmbrellaAlt: faUmbrellaAlt,
  faRectangleHistoryCirclePlus: faRectangleHistoryCirclePlus,
  faUnderline: faUnderline,
  faPrescriptionBottlePill: faPrescriptionBottlePill,
  faUserPen: faUserPen,
  faUserEdit: faUserEdit,
  faBinarySlash: faBinarySlash,
  faSquareO: faSquareO,
  faSignature: faSignature,
  faStroopwafel: faStroopwafel,
  faBold: faBold,
  faAnchorLock: faAnchorLock,
  faBuildingNgo: faBuildingNgo,
  faTransporter3: faTransporter3,
  faEngineWarning: faEngineWarning,
  faEngineExclamation: faEngineExclamation,
  faCircleDownRight: faCircleDownRight,
  faSquareK: faSquareK,
  faManatSign: faManatSign,
  faMoneyCheckPen: faMoneyCheckPen,
  faMoneyCheckEdit: faMoneyCheckEdit,
  faNotEqual: faNotEqual,
  faBorderTopLeft: faBorderTopLeft,
  faBorderStyle: faBorderStyle,
  faMapLocationDot: faMapLocationDot,
  faMapMarkedAlt: faMapMarkedAlt,
  faTilde: faTilde,
  faJedi: faJedi,
  faSquarePollVertical: faSquarePollVertical,
  faPoll: faPoll,
  faArrowDownSquareTriangle: faArrowDownSquareTriangle,
  faSortShapesDownAlt: faSortShapesDownAlt,
  faMugHot: faMugHot,
  faDogLeashed: faDogLeashed,
  faCarBattery: faCarBattery,
  faBatteryCar: faBatteryCar,
  faFaceDowncastSweat: faFaceDowncastSweat,
  faMailboxFlagUp: faMailboxFlagUp,
  faMemoCircleInfo: faMemoCircleInfo,
  faGift: faGift,
  faDiceTwo: faDiceTwo,
  faVolume: faVolume,
  faVolumeMedium: faVolumeMedium,
  faTransporter5: faTransporter5,
  faGaugeCircleBolt: faGaugeCircleBolt,
  faCoinFront: faCoinFront,
  faFileSlash: faFileSlash,
  faMessageArrowUpRight: faMessageArrowUpRight,
  faTreasureChest: faTreasureChest,
  faChessQueen: faChessQueen,
  faPaintbrushFine: faPaintbrushFine,
  faPaintBrushAlt: faPaintBrushAlt,
  faPaintBrushFine: faPaintBrushFine,
  faPaintbrushAlt: faPaintbrushAlt,
  faGlasses: faGlasses,
  faHoodCloak: faHoodCloak,
  faSquareQuote: faSquareQuote,
  faUpLeft: faUpLeft,
  faBringFront: faBringFront,
  faChessBoard: faChessBoard,
  faBurgerCheese: faBurgerCheese,
  faCheeseburger: faCheeseburger,
  faBuildingCircleCheck: faBuildingCircleCheck,
  faRepeat1: faRepeat1,
  faArrowDownToLine: faArrowDownToLine,
  faArrowToBottom: faArrowToBottom,
  faGrid5: faGrid5,
  faRightLongToLine: faRightLongToLine,
  faPersonChalkboard: faPersonChalkboard,
  faMarsStrokeRight: faMarsStrokeRight,
  faMarsStrokeH: faMarsStrokeH,
  faHandBackFist: faHandBackFist,
  faHandRock: faHandRock,
  faGridRound5: faGridRound5,
  faTally: faTally,
  faTally5: faTally5,
  faSquareCaretUp: faSquareCaretUp,
  faCaretSquareUp: faCaretSquareUp,
  faCloudShowersWater: faCloudShowersWater,
  faChartBar: faChartBar,
  faBarChart: faBarChart,
  faHandsBubbles: faHandsBubbles,
  faHandsWash: faHandsWash,
  faLessThanEqual: faLessThanEqual,
  faTrain: faTrain,
  faUpFromDottedLine: faUpFromDottedLine,
  faEyeLowVision: faEyeLowVision,
  faLowVision: faLowVision,
  faTrafficLightGo: faTrafficLightGo,
  faFaceExhaling: faFaceExhaling,
  faSensorFire: faSensorFire,
  faUserUnlock: faUserUnlock,
  faHexagonDivide: faHexagonDivide,
  fa00: fa00,
  faCrow: faCrow,
  faCassetteBetamax: faCassetteBetamax,
  faBetamax: faBetamax,
  faSailboat: faSailboat,
  faWindowRestore: faWindowRestore,
  faNfcMagnifyingGlass: faNfcMagnifyingGlass,
  faFileBinary: faFileBinary,
  faCircleV: faCircleV,
  faSquarePlus: faSquarePlus,
  faPlusSquare: faPlusSquare,
  faBowlScoops: faBowlScoops,
  faMistletoe: faMistletoe,
  faCustard: faCustard,
  faLacrosseStick: faLacrosseStick,
  faHockeyMask: faHockeyMask,
  faSunrise: faSunrise,
  faPanelEws: faPanelEws,
  faToriiGate: faToriiGate,
  faCloudExclamation: faCloudExclamation,
  faMessageLines: faMessageLines,
  faCommentAltLines: faCommentAltLines,
  faFrog: faFrog,
  faBucket: faBucket,
  faFloppyDiskPen: faFloppyDiskPen,
  faImage: faImage,
  faWindowFrame: faWindowFrame,
  faMicrophone: faMicrophone,
  faCow: faCow,
  faFileZip: faFileZip,
  faSquareRing: faSquareRing,
  faDownFromLine: faDownFromLine,
  faArrowAltFromTop: faArrowAltFromTop,
  faCaretUp: faCaretUp,
  faShieldXmark: faShieldXmark,
  faShieldTimes: faShieldTimes,
  faScrewdriver: faScrewdriver,
  faCircleSortDown: faCircleSortDown,
  faSortCircleDown: faSortCircleDown,
  faFolderClosed: faFolderClosed,
  faHouseTsunami: faHouseTsunami,
  faSquareNfi: faSquareNfi,
  faForklift: faForklift,
  faArrowUpFromGroundWater: faArrowUpFromGroundWater,
  faBracketSquareRight: faBracketSquareRight,
  faMartiniGlass: faMartiniGlass,
  faGlassMartiniAlt: faGlassMartiniAlt,
  faRotateLeft: faRotateLeft,
  faRotateBack: faRotateBack,
  faRotateBackward: faRotateBackward,
  faUndoAlt: faUndoAlt,
  faTableColumns: faTableColumns,
  faColumns: faColumns,
  faSquareA: faSquareA,
  faTick: faTick,
  faLemon: faLemon,
  faHeadSideMask: faHeadSideMask,
  faHandshake: faHandshake,
  faGem: faGem,
  faDolly: faDolly,
  faDollyBox: faDollyBox,
  faSmoking: faSmoking,
  faMinimize: faMinimize,
  faCompressArrowsAlt: faCompressArrowsAlt,
  faRefrigerator: faRefrigerator,
  faMonument: faMonument,
  faOctagonXmark: faOctagonXmark,
  faTimesOctagon: faTimesOctagon,
  faXmarkOctagon: faXmarkOctagon,
  faAlignSlash: faAlignSlash,
  faSnowplow: faSnowplow,
  faAnglesRight: faAnglesRight,
  faAngleDoubleRight: faAngleDoubleRight,
  faTruckRampCouch: faTruckRampCouch,
  faTruckCouch: faTruckCouch,
  faCannabis: faCannabis,
  faCirclePlay: faCirclePlay,
  faPlayCircle: faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter: faArrowUpRightAndArrowDownLeftFromCenter,
  faTablets: faTablets,
  fa360Degrees: fa360Degrees,
  faEthernet: faEthernet,
  faEuroSign: faEuroSign,
  faEur: faEur,
  faEuro: faEuro,
  faChair: faChair,
  faCircleCheck: faCircleCheck,
  faCheckCircle: faCheckCircle,
  faSquareDashedCirclePlus: faSquareDashedCirclePlus,
  faMoneySimpleFromBracket: faMoneySimpleFromBracket,
  faBat: faBat,
  faCircleStop: faCircleStop,
  faStopCircle: faStopCircle,
  faHeadSideHeadphones: faHeadSideHeadphones,
  faPhoneRotary: faPhoneRotary,
  faCompassDrafting: faCompassDrafting,
  faDraftingCompass: faDraftingCompass,
  faPlateWheat: faPlateWheat,
  faCalendarCircleMinus: faCalendarCircleMinus,
  faChopsticks: faChopsticks,
  faCarWrench: faCarWrench,
  faCarMechanic: faCarMechanic,
  faIcicles: faIcicles,
  faPersonShelter: faPersonShelter,
  faNeuter: faNeuter,
  faIdBadge: faIdBadge,
  faKazoo: faKazoo,
  faMarker: faMarker,
  faBinBottles: faBinBottles,
  faFaceLaughBeam: faFaceLaughBeam,
  faLaughBeam: faLaughBeam,
  faSquareArrowDownLeft: faSquareArrowDownLeft,
  faBatteryBolt: faBatteryBolt,
  faTreeLarge: faTreeLarge,
  faHelicopterSymbol: faHelicopterSymbol,
  faAperture: faAperture,
  faUniversalAccess: faUniversalAccess,
  faGearComplex: faGearComplex,
  faFileMagnifyingGlass: faFileMagnifyingGlass,
  faFileSearch: faFileSearch,
  faUpRight: faUpRight,
  faCircleChevronUp: faCircleChevronUp,
  faChevronCircleUp: faChevronCircleUp,
  faUserPolice: faUserPolice,
  faLariSign: faLariSign,
  faVolcano: faVolcano,
  faTeddyBear: faTeddyBear,
  faStocking: faStocking,
  faPersonWalkingDashedLineArrowRight: faPersonWalkingDashedLineArrowRight,
  faImageSlash: faImageSlash,
  faMaskSnorkel: faMaskSnorkel,
  faSmoke: faSmoke,
  faSterlingSign: faSterlingSign,
  faGbp: faGbp,
  faPoundSign: faPoundSign,
  faBatteryExclamation: faBatteryExclamation,
  faViruses: faViruses,
  faSquarePersonConfined: faSquarePersonConfined,
  faUserTie: faUserTie,
  faArrowDownLong: faArrowDownLong,
  faLongArrowDown: faLongArrowDown,
  faTentArrowDownToLine: faTentArrowDownToLine,
  faCertificate: faCertificate,
  faCrystalBall: faCrystalBall,
  faReplyAll: faReplyAll,
  faMailReplyAll: faMailReplyAll,
  faSuitcase: faSuitcase,
  faPersonSkating: faPersonSkating,
  faSkating: faSkating,
  faStarShooting: faStarShooting,
  faBinaryLock: faBinaryLock,
  faFilterCircleDollar: faFilterCircleDollar,
  faFunnelDollar: faFunnelDollar,
  faCameraRetro: faCameraRetro,
  faCircleArrowDown: faCircleArrowDown,
  faArrowCircleDown: faArrowCircleDown,
  faCommentPen: faCommentPen,
  faCommentEdit: faCommentEdit,
  faFileImport: faFileImport,
  faArrowRightToFile: faArrowRightToFile,
  faBanjo: faBanjo,
  faSquareArrowUpRight: faSquareArrowUpRight,
  faExternalLinkSquare: faExternalLinkSquare,
  faLightEmergencyOn: faLightEmergencyOn,
  faKerning: faKerning,
  faBoxOpen: faBoxOpen,
  faSquareF: faSquareF,
  faScroll: faScroll,
  faSpa: faSpa,
  faArrowLeftFromLine: faArrowLeftFromLine,
  faArrowFromRight: faArrowFromRight,
  faStrawberry: faStrawberry,
  faLocationPinLock: faLocationPinLock,
  faPause: faPause,
  faClockEightThirty: faClockEightThirty,
  faPlaneEngines: faPlaneEngines,
  faPlaneAlt: faPlaneAlt,
  faHillAvalanche: faHillAvalanche,
  faTemperatureEmpty: faTemperatureEmpty,
  faTemperature0: faTemperature0,
  faThermometer0: faThermometer0,
  faThermometerEmpty: faThermometerEmpty,
  faBomb: faBomb,
  faGaugeLow: faGaugeLow,
  faTachometerAltSlow: faTachometerAltSlow,
  faRegistered: faRegistered,
  faTrashCanPlus: faTrashCanPlus,
  faAddressCard: faAddressCard,
  faContactCard: faContactCard,
  faVcard: faVcard,
  faScaleUnbalancedFlip: faScaleUnbalancedFlip,
  faBalanceScaleRight: faBalanceScaleRight,
  faGlobeSnow: faGlobeSnow,
  faSubscript: faSubscript,
  faDiamondTurnRight: faDiamondTurnRight,
  faDirections: faDirections,
  faIntegral: faIntegral,
  faBurst: faBurst,
  faHouseLaptop: faHouseLaptop,
  faLaptopHouse: faLaptopHouse,
  faFaceTired: faFaceTired,
  faTired: faTired,
  faMoneyBills: faMoneyBills,
  faBlindsRaised: faBlindsRaised,
  faSmog: faSmog,
  faUfoBeam: faUfoBeam,
  faCircleCaretUp: faCircleCaretUp,
  faCaretCircleUp: faCaretCircleUp,
  faUserVneckHairLong: faUserVneckHairLong,
  faSquareALock: faSquareALock,
  faCrutch: faCrutch,
  faGasPumpSlash: faGasPumpSlash,
  faFontAwesome: faFontAwesome,
  faFontAwesomeFlag: faFontAwesomeFlag,
  faFontAwesomeLogoFull: faFontAwesomeLogoFull,
  faCloudArrowUp: faCloudArrowUp,
  faCloudUpload: faCloudUpload,
  faCloudUploadAlt: faCloudUploadAlt,
  faPalette: faPalette,
  faTransporter4: faTransporter4,
  faChartMixedUpCircleCurrency: faChartMixedUpCircleCurrency,
  faObjectsAlignRight: faObjectsAlignRight,
  faArrowsTurnRight: faArrowsTurnRight,
  faVest: faVest,
  faPig: faPig,
  faInboxFull: faInboxFull,
  faCircleEnvelope: faCircleEnvelope,
  faEnvelopeCircle: faEnvelopeCircle,
  faTrianglePersonDigging: faTrianglePersonDigging,
  faConstruction: faConstruction,
  faFerry: faFerry,
  faBullseyeArrow: faBullseyeArrow,
  faArrowsDownToPeople: faArrowsDownToPeople,
  faSeedling: faSeedling,
  faSprout: faSprout,
  faClockSeven: faClockSeven,
  faLeftRight: faLeftRight,
  faArrowsAltH: faArrowsAltH,
  faBoxesPacking: faBoxesPacking,
  faCircleArrowLeft: faCircleArrowLeft,
  faArrowCircleLeft: faArrowCircleLeft,
  faFlashlight: faFlashlight,
  faGroupArrowsRotate: faGroupArrowsRotate,
  faBowlFood: faBowlFood,
  faSquare9: faSquare9,
  faCandyCane: faCandyCane,
  faArrowDownWideShort: faArrowDownWideShort,
  faSortAmountAsc: faSortAmountAsc,
  faSortAmountDown: faSortAmountDown,
  faSquareDollar: faSquareDollar,
  faDollarSquare: faDollarSquare,
  faUsdSquare: faUsdSquare,
  faPhoneArrowRight: faPhoneArrowRight,
  faHandHoldingSeedling: faHandHoldingSeedling,
  faMessageCheck: faMessageCheck,
  faCommentAltCheck: faCommentAltCheck,
  faCloudBolt: faCloudBolt,
  faThunderstorm: faThunderstorm,
  faChartLineUpDown: faChartLineUpDown,
  faTextSlash: faTextSlash,
  faRemoveFormat: faRemoveFormat,
  faWatch: faWatch,
  faCircleDownLeft: faCircleDownLeft,
  faText: faText,
  faProjector: faProjector,
  faFaceSmileWink: faFaceSmileWink,
  faSmileWink: faSmileWink,
  faTombstoneBlank: faTombstoneBlank,
  faTombstoneAlt: faTombstoneAlt,
  faChessKingPiece: faChessKingPiece,
  faChessKingAlt: faChessKingAlt,
  faCircle6: faCircle6,
  faLeft: faLeft,
  faArrowAltLeft: faArrowAltLeft,
  faFileWord: faFileWord,
  faFilePowerpoint: faFilePowerpoint,
  faSquareDown: faSquareDown,
  faArrowAltSquareDown: faArrowAltSquareDown,
  faObjectsAlignCenterVertical: faObjectsAlignCenterVertical,
  faArrowsLeftRight: faArrowsLeftRight,
  faArrowsH: faArrowsH,
  faHouseLock: faHouseLock,
  faCloudArrowDown: faCloudArrowDown,
  faCloudDownload: faCloudDownload,
  faCloudDownloadAlt: faCloudDownloadAlt,
  faWreath: faWreath,
  faChildren: faChildren,
  faMeterDroplet: faMeterDroplet,
  faChalkboard: faChalkboard,
  faBlackboard: faBlackboard,
  faUserLargeSlash: faUserLargeSlash,
  faUserAltSlash: faUserAltSlash,
  faSignalStrong: faSignalStrong,
  faSignal4: faSignal4,
  faLollipop: faLollipop,
  faLollypop: faLollypop,
  faListTree: faListTree,
  faEnvelopeOpen: faEnvelopeOpen,
  faDrawCircle: faDrawCircle,
  faCatSpace: faCatSpace,
  faHandshakeSimpleSlash: faHandshakeSimpleSlash,
  faHandshakeAltSlash: faHandshakeAltSlash,
  faRabbitRunning: faRabbitRunning,
  faRabbitFast: faRabbitFast,
  faMemoPad: faMemoPad,
  faMattressPillow: faMattressPillow,
  faAlarmPlus: faAlarmPlus,
  faAlicorn: faAlicorn,
  faCommentQuestion: faCommentQuestion,
  faGingerbreadMan: faGingerbreadMan,
  faGuaraniSign: faGuaraniSign,
  faBurgerFries: faBurgerFries,
  faMugTea: faMugTea,
  faBorderTop: faBorderTop,
  faArrowsRotate: faArrowsRotate,
  faRefresh: faRefresh,
  faSync: faSync,
  faCircleBookOpen: faCircleBookOpen,
  faBookCircle: faBookCircle,
  faArrowsToDottedLine: faArrowsToDottedLine,
  faFireExtinguisher: faFireExtinguisher,
  faGarageOpen: faGarageOpen,
  faShelvesEmpty: faShelvesEmpty,
  faCruzeiroSign: faCruzeiroSign,
  faWatchApple: faWatchApple,
  faWatchCalculator: faWatchCalculator,
  faListDropdown: faListDropdown,
  faCabinetFiling: faCabinetFiling,
  faBurgerSoda: faBurgerSoda,
  faSquareArrowUp: faSquareArrowUp,
  faArrowSquareUp: faArrowSquareUp,
  faGreaterThanEqual: faGreaterThanEqual,
  faPalletBox: faPalletBox,
  faFaceConfounded: faFaceConfounded,
  faShieldHalved: faShieldHalved,
  faShieldAlt: faShieldAlt,
  faTruckPlow: faTruckPlow,
  faBookAtlas: faBookAtlas,
  faAtlas: faAtlas,
  faVirus: faVirus,
  faGridRound2: faGridRound2,
  faCommentMiddleTop: faCommentMiddleTop,
  faEnvelopeCircleCheck: faEnvelopeCircleCheck,
  faLayerGroup: faLayerGroup,
  faRestroomSimple: faRestroomSimple,
  faArrowsToDot: faArrowsToDot,
  faBorderOuter: faBorderOuter,
  faHashtagLock: faHashtagLock,
  faClockTwoThirty: faClockTwoThirty,
  faArchway: faArchway,
  faHeartCircleCheck: faHeartCircleCheck,
  faHouseChimneyCrack: faHouseChimneyCrack,
  faHouseDamage: faHouseDamage,
  faFileZipper: faFileZipper,
  faFileArchive: faFileArchive,
  faHeartHalf: faHeartHalf,
  faCommentCheck: faCommentCheck,
  faSquare: faSquare,
  faMemo: faMemo,
  faMartiniGlassEmpty: faMartiniGlassEmpty,
  faGlassMartini: faGlassMartini,
  faCouch: faCouch,
  faCediSign: faCediSign,
  faItalic: faItalic,
  faGlassCitrus: faGlassCitrus,
  faCalendarLinesPen: faCalendarLinesPen,
  faChurch: faChurch,
  faPersonSnowmobiling: faPersonSnowmobiling,
  faSnowmobile: faSnowmobile,
  faFaceHushed: faFaceHushed,
  faCommentsDollar: faCommentsDollar,
  faPickaxe: faPickaxe,
  faLinkSimpleSlash: faLinkSimpleSlash,
  faDemocrat: faDemocrat,
  faFaceConfused: faFaceConfused,
  faPinball: faPinball,
  faZ: faZ,
  faPersonSkiing: faPersonSkiing,
  faSkiing: faSkiing,
  faDeer: faDeer,
  faInputPipe: faInputPipe,
  faRoadLock: faRoadLock,
  faA: faA,
  faBookmarkSlash: faBookmarkSlash,
  faTemperatureArrowDown: faTemperatureArrowDown,
  faTemperatureDown: faTemperatureDown,
  faMace: faMace,
  faFeatherPointed: faFeatherPointed,
  faFeatherAlt: faFeatherAlt,
  faSausage: faSausage,
  faTrashCanClock: faTrashCanClock,
  faP: faP,
  faBroomWide: faBroomWide,
  faSnowflake: faSnowflake,
  faStomach: faStomach,
  faNewspaper: faNewspaper,
  faRectangleAd: faRectangleAd,
  faAd: faAd,
  faGuitarElectric: faGuitarElectric,
  faArrowTurnDownRight: faArrowTurnDownRight,
  faMoonCloud: faMoonCloud,
  faBreadSliceButter: faBreadSliceButter,
  faCircleArrowRight: faCircleArrowRight,
  faArrowCircleRight: faArrowCircleRight,
  faUserGroupCrown: faUserGroupCrown,
  faUsersCrown: faUsersCrown,
  faCircleI: faCircleI,
  faToiletPaperCheck: faToiletPaperCheck,
  faFilterCircleXmark: faFilterCircleXmark,
  faLocust: faLocust,
  faSort: faSort,
  faUnsorted: faUnsorted,
  faListOl: faListOl,
  faList12: faList12,
  faListNumeric: faListNumeric,
  faChartWaterfall: faChartWaterfall,
  faSparkle: faSparkle,
  faFaceParty: faFaceParty,
  faKidneys: faKidneys,
  faWifiExclamation: faWifiExclamation,
  faChartNetwork: faChartNetwork,
  faPersonDressBurst: faPersonDressBurst,
  faDiceD4: faDiceD4,
  faMoneyCheckDollar: faMoneyCheckDollar,
  faMoneyCheckAlt: faMoneyCheckAlt,
  faVectorSquare: faVectorSquare,
  faBreadSlice: faBreadSlice,
  faLanguage: faLanguage,
  faWheatAwnSlash: faWheatAwnSlash,
  faFaceKissWinkHeart: faFaceKissWinkHeart,
  faKissWinkHeart: faKissWinkHeart,
  faDagger: faDagger,
  faPodium: faPodium,
  faMemoCircleCheck: faMemoCircleCheck,
  faRouteHighway: faRouteHighway,
  faDownToLine: faDownToLine,
  faArrowAltToBottom: faArrowAltToBottom,
  faFilter: faFilter,
  faSquareG: faSquareG,
  faCirclePhone: faCirclePhone,
  faPhoneCircle: faPhoneCircle,
  faClipboardPrescription: faClipboardPrescription,
  faUserNurseHair: faUserNurseHair,
  faQuestion: faQuestion,
  faFileSignature: faFileSignature,
  faToggleLargeOn: faToggleLargeOn,
  faUpDownLeftRight: faUpDownLeftRight,
  faArrowsAlt: faArrowsAlt,
  faDryerHeat: faDryerHeat,
  faDryerAlt: faDryerAlt,
  faHouseChimneyUser: faHouseChimneyUser,
  faHandHoldingHeart: faHandHoldingHeart,
  faArrowUpSmallBig: faArrowUpSmallBig,
  faSortSizeUpAlt: faSortSizeUpAlt,
  faTrainTrack: faTrainTrack,
  faPuzzlePiece: faPuzzlePiece,
  faMoneyCheck: faMoneyCheck,
  faStarHalfStroke: faStarHalfStroke,
  faStarHalfAlt: faStarHalfAlt,
  faFileExclamation: faFileExclamation,
  faCode: faCode,
  faWhiskeyGlass: faWhiskeyGlass,
  faGlassWhiskey: faGlassWhiskey,
  faMoonStars: faMoonStars,
  faBuildingCircleExclamation: faBuildingCircleExclamation,
  faClothesHanger: faClothesHanger,
  faMobileNotch: faMobileNotch,
  faMobileIphone: faMobileIphone,
  faMagnifyingGlassChart: faMagnifyingGlassChart,
  faArrowUpRightFromSquare: faArrowUpRightFromSquare,
  faExternalLink: faExternalLink,
  faCubesStacked: faCubesStacked,
  faImagesUser: faImagesUser,
  faWonSign: faWonSign,
  faKrw: faKrw,
  faWon: faWon,
  faImagePolaroidUser: faImagePolaroidUser,
  faVirusCovid: faVirusCovid,
  faSquareEllipsis: faSquareEllipsis,
  faPie: faPie,
  faChessKnightPiece: faChessKnightPiece,
  faChessKnightAlt: faChessKnightAlt,
  faAustralSign: faAustralSign,
  faCloudPlus: faCloudPlus,
  faF: faF,
  faLeaf: faLeaf,
  faBedBunk: faBedBunk,
  faRoad: faRoad,
  faTaxi: faTaxi,
  faCab: faCab,
  faPersonCirclePlus: faPersonCirclePlus,
  faChartPie: faChartPie,
  faPieChart: faPieChart,
  faBoltLightning: faBoltLightning,
  faClockEight: faClockEight,
  faSackXmark: faSackXmark,
  faFileExcel: faFileExcel,
  faFileContract: faFileContract,
  faFishFins: faFishFins,
  faCircleQ: faCircleQ,
  faBuildingFlag: faBuildingFlag,
  faFaceGrinBeam: faFaceGrinBeam,
  faGrinBeam: faGrinBeam,
  faObjectUngroup: faObjectUngroup,
  faFaceDisguise: faFaceDisguise,
  faCircleArrowDownRight: faCircleArrowDownRight,
  faAlien8bit: faAlien8bit,
  faAlienMonster: faAlienMonster,
  faHandPointRibbon: faHandPointRibbon,
  faPoop: faPoop,
  faObjectExclude: faObjectExclude,
  faTelescope: faTelescope,
  faLocationPin: faLocationPin,
  faMapMarker: faMapMarker,
  faSquareList: faSquareList,
  faKaaba: faKaaba,
  faToiletPaper: faToiletPaper,
  faHelmetSafety: faHelmetSafety,
  faHardHat: faHardHat,
  faHatHard: faHatHard,
  faCommentCode: faCommentCode,
  faSimCards: faSimCards,
  faStarship: faStarship,
  faEject: faEject,
  faCircleRight: faCircleRight,
  faArrowAltCircleRight: faArrowAltCircleRight,
  faPlaneCircleCheck: faPlaneCircleCheck,
  faSeal: faSeal,
  faUserCowboy: faUserCowboy,
  faHexagonVerticalNft: faHexagonVerticalNft,
  faFaceRollingEyes: faFaceRollingEyes,
  faMehRollingEyes: faMehRollingEyes,
  faBreadLoaf: faBreadLoaf,
  faRingsWedding: faRingsWedding,
  faObjectGroup: faObjectGroup,
  faFrenchFries: faFrenchFries,
  faChartLine: faChartLine,
  faLineChart: faLineChart,
  faCalendarArrowDown: faCalendarArrowDown,
  faCalendarDownload: faCalendarDownload,
  faSendBack: faSendBack,
  faMaskVentilator: faMaskVentilator,
  faSignatureLock: faSignatureLock,
  faArrowRight: faArrowRight,
  faSignsPost: faSignsPost,
  faMapSigns: faMapSigns,
  faOctagonPlus: faOctagonPlus,
  faPlusOctagon: faPlusOctagon,
  faCashRegister: faCashRegister,
  faPersonCircleQuestion: faPersonCircleQuestion,
  faMelonSlice: faMelonSlice,
  faSpaceStationMoon: faSpaceStationMoon,
  faMessageSmile: faMessageSmile,
  faCommentAltSmile: faCommentAltSmile,
  faCupStraw: faCupStraw,
  faLeftFromLine: faLeftFromLine,
  faArrowAltFromRight: faArrowAltFromRight,
  faH: faH,
  faBasketShoppingSimple: faBasketShoppingSimple,
  faShoppingBasketAlt: faShoppingBasketAlt,
  faHandsHoldingHeart: faHandsHoldingHeart,
  faHandsHeart: faHandsHeart,
  faClockNine: faClockNine,
  faTarp: faTarp,
  faFaceSleepy: faFaceSleepy,
  faHandHorns: faHandHorns,
  faScrewdriverWrench: faScrewdriverWrench,
  faTools: faTools,
  faArrowsToEye: faArrowsToEye,
  faCircleThreeQuarters: faCircleThreeQuarters,
  faTrophyStar: faTrophyStar,
  faTrophyAlt: faTrophyAlt,
  faPlugCircleBolt: faPlugCircleBolt,
  faFaceThermometer: faFaceThermometer,
  faGridRound4: faGridRound4,
  faShirtRunning: faShirtRunning,
  faBookCircleArrowUp: faBookCircleArrowUp,
  faFaceNauseated: faFaceNauseated,
  faHeart: faHeart,
  faFileChartPie: faFileChartPie,
  faMarsAndVenus: faMarsAndVenus,
  faHouseUser: faHouseUser,
  faHomeUser: faHomeUser,
  faCircleArrowDownLeft: faCircleArrowDownLeft,
  faDumpsterFire: faDumpsterFire,
  faHexagonMinus: faHexagonMinus,
  faMinusHexagon: faMinusHexagon,
  faLeftToLine: faLeftToLine,
  faArrowAltToLeft: faArrowAltToLeft,
  faHouseCrack: faHouseCrack,
  faPawSimple: faPawSimple,
  faPawAlt: faPawAlt,
  faArrowLeftLongToLine: faArrowLeftLongToLine,
  faBracketsRound: faBracketsRound,
  faParentheses: faParentheses,
  faMartiniGlassCitrus: faMartiniGlassCitrus,
  faCocktail: faCocktail,
  faUserShakespeare: faUserShakespeare,
  faArrowRightToArc: faArrowRightToArc,
  faFaceSurprise: faFaceSurprise,
  faSurprise: faSurprise,
  faBottleWater: faBottleWater,
  faCirclePause: faCirclePause,
  faPauseCircle: faPauseCircle,
  faGaugeCirclePlus: faGaugeCirclePlus,
  faFolders: faFolders,
  faAngel: faAngel,
  faValueAbsolute: faValueAbsolute,
  faRabbit: faRabbit,
  faToiletPaperSlash: faToiletPaperSlash,
  faCircleEuro: faCircleEuro,
  faAppleWhole: faAppleWhole,
  faAppleAlt: faAppleAlt,
  faKitchenSet: faKitchenSet,
  faDiamondHalf: faDiamondHalf,
  faLockKeyhole: faLockKeyhole,
  faLockAlt: faLockAlt,
  faR: faR,
  faTemperatureQuarter: faTemperatureQuarter,
  faTemperature1: faTemperature1,
  faThermometer1: faThermometer1,
  faThermometerQuarter: faThermometerQuarter,
  faSquareInfo: faSquareInfo,
  faInfoSquare: faInfoSquare,
  faWifiSlash: faWifiSlash,
  faToiletPaperXmark: faToiletPaperXmark,
  faHandsHoldingDollar: faHandsHoldingDollar,
  faHandsUsd: faHandsUsd,
  faCube: faCube,
  faArrowDownTriangleSquare: faArrowDownTriangleSquare,
  faSortShapesDown: faSortShapesDown,
  faBitcoinSign: faBitcoinSign,
  faShutters: faShutters,
  faShieldDog: faShieldDog,
  faSolarPanel: faSolarPanel,
  faLockOpen: faLockOpen,
  faTableTree: faTableTree,
  faHouseChimneyHeart: faHouseChimneyHeart,
  faTally3: faTally3,
  faElevator: faElevator,
  faMoneyBillTransfer: faMoneyBillTransfer,
  faMoneyBillTrendUp: faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight: faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal: faSquarePollHorizontal,
  faPollH: faPollH,
  faCircle: faCircle,
  faCartCircleExclamation: faCartCircleExclamation,
  faSword: faSword,
  faBackwardFast: faBackwardFast,
  faFastBackward: faFastBackward,
  faRecycle: faRecycle,
  faUserAstronaut: faUserAstronaut,
  faInterrobang: faInterrobang,
  faPlaneSlash: faPlaneSlash,
  faCircleDashed: faCircleDashed,
  faTrademark: faTrademark,
  faBasketball: faBasketball,
  faBasketballBall: faBasketballBall,
  faForkKnife: faForkKnife,
  faUtensilsAlt: faUtensilsAlt,
  faSatelliteDish: faSatelliteDish,
  faBadgeCheck: faBadgeCheck,
  faCircleUp: faCircleUp,
  faArrowAltCircleUp: faArrowAltCircleUp,
  faSlider: faSlider,
  faMobileScreenButton: faMobileScreenButton,
  faMobileAlt: faMobileAlt,
  faClockOneThirty: faClockOneThirty,
  faInboxOut: faInboxOut,
  faInboxArrowUp: faInboxArrowUp,
  faCloudSlash: faCloudSlash,
  faVolumeHigh: faVolumeHigh,
  faVolumeUp: faVolumeUp,
  faUsersRays: faUsersRays,
  faWallet: faWallet,
  faOctagonCheck: faOctagonCheck,
  faFlatbreadStuffed: faFlatbreadStuffed,
  faClipboardCheck: faClipboardCheck,
  faCartCirclePlus: faCartCirclePlus,
  faTruckClock: faTruckClock,
  faShippingTimed: faShippingTimed,
  faPool8Ball: faPool8Ball,
  faFileAudio: faFileAudio,
  faTurnDownLeft: faTurnDownLeft,
  faLockHashtag: faLockHashtag,
  faChartRadar: faChartRadar,
  faStaff: faStaff,
  faBurger: faBurger,
  faHamburger: faHamburger,
  faUtilityPole: faUtilityPole,
  faTransporter6: faTransporter6,
  faWrench: faWrench,
  faBugs: faBugs,
  faVectorPolygon: faVectorPolygon,
  faDiagramNested: faDiagramNested,
  faRupeeSign: faRupeeSign,
  faRupee: faRupee,
  faFileImage: faFileImage,
  faCircleQuestion: faCircleQuestion,
  faQuestionCircle: faQuestionCircle,
  faImageUser: faImageUser,
  faBuoy: faBuoy,
  faPlaneDeparture: faPlaneDeparture,
  faHandshakeSlash: faHandshakeSlash,
  faBookBookmark: faBookBookmark,
  faBorderCenterH: faBorderCenterH,
  faCanFood: faCanFood,
  faTypewriter: faTypewriter,
  faArrowRightFromArc: faArrowRightFromArc,
  faCircleK: faCircleK,
  faFaceHandOverMouth: faFaceHandOverMouth,
  faPopcorn: faPopcorn,
  faHouseWater: faHouseWater,
  faHouseFlood: faHouseFlood,
  faObjectSubtract: faObjectSubtract,
  faCodeBranch: faCodeBranch,
  faWarehouseFull: faWarehouseFull,
  faWarehouseAlt: faWarehouseAlt,
  faHatCowboy: faHatCowboy,
  faBridge: faBridge,
  faPhoneFlip: faPhoneFlip,
  faPhoneAlt: faPhoneAlt,
  faArrowDownFromDottedLine: faArrowDownFromDottedLine,
  faFileDoc: faFileDoc,
  faSquareQuarters: faSquareQuarters,
  faTruckFront: faTruckFront,
  faCat: faCat,
  faTrashXmark: faTrashXmark,
  faCircleCaretLeft: faCircleCaretLeft,
  faCaretCircleLeft: faCaretCircleLeft,
  faFiles: faFiles,
  faAnchorCircleExclamation: faAnchorCircleExclamation,
  faFaceClouds: faFaceClouds,
  faUserCrown: faUserCrown,
  faTruckField: faTruckField,
  faRoute: faRoute,
  faCartCircleCheck: faCartCircleCheck,
  faClipboardQuestion: faClipboardQuestion,
  faPanorama: faPanorama,
  faCommentMedical: faCommentMedical,
  faTeethOpen: faTeethOpen,
  faUserTieHairLong: faUserTieHairLong,
  faFileCircleMinus: faFileCircleMinus,
  faHeadSideMedical: faHeadSideMedical,
  faTags: faTags,
  faWineGlass: faWineGlass,
  faForwardFast: faForwardFast,
  faFastForward: faFastForward,
  faFaceMehBlank: faFaceMehBlank,
  faMehBlank: faMehBlank,
  faUserRobot: faUserRobot,
  faSquareParking: faSquareParking,
  faParking: faParking,
  faCardDiamond: faCardDiamond,
  faFaceZipper: faFaceZipper,
  faFaceRaisedEyebrow: faFaceRaisedEyebrow,
  faHouseSignal: faHouseSignal,
  faSquareChevronUp: faSquareChevronUp,
  faChevronSquareUp: faChevronSquareUp,
  faNfcSymbol: faNfcSymbol,
  faBarsProgress: faBarsProgress,
  faTasksAlt: faTasksAlt,
  faFaucetDrip: faFaucetDrip,
  faArrowsToLine: faArrowsToLine,
  faDolphin: faDolphin,
  faArrowUpRight: faArrowUpRight,
  faCircleR: faCircleR,
  faCartFlatbed: faCartFlatbed,
  faDollyFlatbed: faDollyFlatbed,
  faBanSmoking: faBanSmoking,
  faSmokingBan: faSmokingBan,
  faCircleSortUp: faCircleSortUp,
  faSortCircleUp: faSortCircleUp,
  faTerminal: faTerminal,
  faMobileButton: faMobileButton,
  faHouseMedicalFlag: faHouseMedicalFlag,
  faBasketShopping: faBasketShopping,
  faShoppingBasket: faShoppingBasket,
  faTape: faTape,
  faChestnut: faChestnut,
  faBusSimple: faBusSimple,
  faBusAlt: faBusAlt,
  faEye: faEye,
  faFaceSadCry: faFaceSadCry,
  faSadCry: faSadCry,
  faHeat: faHeat,
  faTicketAirline: faTicketAirline,
  faBootHeeled: faBootHeeled,
  faArrowsMinimize: faArrowsMinimize,
  faCompressArrows: faCompressArrows,
  faAudioDescription: faAudioDescription,
  faPersonMilitaryToPerson: faPersonMilitaryToPerson,
  faFileShield: faFileShield,
  faHexagon: faHexagon,
  faManhole: faManhole,
  faUserSlash: faUserSlash,
  faPen: faPen,
  faTowerObservation: faTowerObservation,
  faFloppyDisks: faFloppyDisks,
  faToiletPaperBlankUnder: faToiletPaperBlankUnder,
  faToiletPaperReverseAlt: faToiletPaperReverseAlt,
  faFileCode: faFileCode,
  faSignal: faSignal,
  faSignal5: faSignal5,
  faSignalPerfect: faSignalPerfect,
  faPump: faPump,
  faBus: faBus,
  faHeartCircleXmark: faHeartCircleXmark,
  faArrowUpLeftFromCircle: faArrowUpLeftFromCircle,
  faHouseChimney: faHouseChimney,
  faHomeLg: faHomeLg,
  faWindowMaximize: faWindowMaximize,
  faDryer: faDryer,
  faFaceFrown: faFaceFrown,
  faFrown: faFrown,
  faChessBishopPiece: faChessBishopPiece,
  faChessBishopAlt: faChessBishopAlt,
  faShirtTankTop: faShirtTankTop,
  faDiploma: faDiploma,
  faScrollRibbon: faScrollRibbon,
  faScreencast: faScreencast,
  faWalker: faWalker,
  faPrescription: faPrescription,
  faShop: faShop,
  faStoreAlt: faStoreAlt,
  faFloppyDisk: faFloppyDisk,
  faSave: faSave,
  faVihara: faVihara,
  faFaceKissClosedEyes: faFaceKissClosedEyes,
  faScaleUnbalanced: faScaleUnbalanced,
  faBalanceScaleLeft: faBalanceScaleLeft,
  faFileUser: faFileUser,
  faUserPoliceTie: faUserPoliceTie,
  faFaceTongueMoney: faFaceTongueMoney,
  faTennisBall: faTennisBall,
  faSquareL: faSquareL,
  faSortUp: faSortUp,
  faSortAsc: faSortAsc,
  faCalendarArrowUp: faCalendarArrowUp,
  faCalendarUpload: faCalendarUpload,
  faCommentDots: faCommentDots,
  faCommenting: faCommenting,
  faPlantWilt: faPlantWilt,
  faScarf: faScarf,
  faAlbumCirclePlus: faAlbumCirclePlus,
  faUserNurseHairLong: faUserNurseHairLong,
  faDiamond: faDiamond,
  faSquareLeft: faSquareLeft,
  faArrowAltSquareLeft: faArrowAltSquareLeft,
  faFaceGrinSquint: faFaceGrinSquint,
  faGrinSquint: faGrinSquint,
  faCircleEllipsisVertical: faCircleEllipsisVertical,
  faHandHoldingDollar: faHandHoldingDollar,
  faHandHoldingUsd: faHandHoldingUsd,
  faGridDividers: faGridDividers,
  faBacterium: faBacterium,
  faHandPointer: faHandPointer,
  faDrumSteelpan: faDrumSteelpan,
  faHandScissors: faHandScissors,
  faHandsPraying: faHandsPraying,
  faPrayingHands: faPrayingHands,
  faFacePensive: faFacePensive,
  faUserMusic: faUserMusic,
  faArrowRotateRight: faArrowRotateRight,
  faArrowRightRotate: faArrowRightRotate,
  faArrowRotateForward: faArrowRotateForward,
  faRedo: faRedo,
  faMessagesDollar: faMessagesDollar,
  faCommentsAltDollar: faCommentsAltDollar,
  faSensorOn: faSensorOn,
  faBalloon: faBalloon,
  faBiohazard: faBiohazard,
  faChessQueenPiece: faChessQueenPiece,
  faChessQueenAlt: faChessQueenAlt,
  faLocationCrosshairs: faLocationCrosshairs,
  faLocation: faLocation,
  faMarsDouble: faMarsDouble,
  faHousePersonLeave: faHousePersonLeave,
  faHouseLeave: faHouseLeave,
  faHousePersonDepart: faHousePersonDepart,
  faRulerTriangle: faRulerTriangle,
  faCardClub: faCardClub,
  faChildDress: faChildDress,
  faUsersBetweenLines: faUsersBetweenLines,
  faLungsVirus: faLungsVirus,
  faSpinnerThird: faSpinnerThird,
  faFaceGrinTears: faFaceGrinTears,
  faGrinTears: faGrinTears,
  faPhone: faPhone,
  faComputerMouseScrollwheel: faComputerMouseScrollwheel,
  faMouseAlt: faMouseAlt,
  faCalendarXmark: faCalendarXmark,
  faCalendarTimes: faCalendarTimes,
  faChildReaching: faChildReaching,
  faTableLayout: faTableLayout,
  faNarwhal: faNarwhal,
  faRampLoading: faRampLoading,
  faCalendarCirclePlus: faCalendarCirclePlus,
  faToothbrush: faToothbrush,
  faBorderInner: faBorderInner,
  faPawClaws: faPawClaws,
  faKiwiFruit: faKiwiFruit,
  faTrafficLightSlow: faTrafficLightSlow,
  faRectangleCode: faRectangleCode,
  faHeadSideVirus: faHeadSideVirus,
  faKeyboardBrightness: faKeyboardBrightness,
  faBooksMedical: faBooksMedical,
  faLightbulbSlash: faLightbulbSlash,
  faHouseBlank: faHouseBlank,
  faHomeBlank: faHomeBlank,
  faSquare5: faSquare5,
  faSquareHeart: faSquareHeart,
  faHeartSquare: faHeartSquare,
  faPuzzle: faPuzzle,
  faUserGear: faUserGear,
  faUserCog: faUserCog,
  faPipeCircleCheck: faPipeCircleCheck,
  faArrowUp19: faArrowUp19,
  faSortNumericUp: faSortNumericUp,
  faOctagonExclamation: faOctagonExclamation,
  faDialLow: faDialLow,
  faDoorClosed: faDoorClosed,
  faLaptopMobile: faLaptopMobile,
  faPhoneLaptop: faPhoneLaptop,
  faConveyorBeltBoxes: faConveyorBeltBoxes,
  faConveyorBeltAlt: faConveyorBeltAlt,
  faShieldVirus: faShieldVirus,
  faStarfighterTwinIonEngineAdvanced: faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced: faStarfighterAltAdvanced,
  faDiceSix: faDiceSix,
  faStarfighterTwinIonEngine: faStarfighterTwinIonEngine,
  faStarfighterAlt: faStarfighterAlt,
  faRocketLaunch: faRocketLaunch,
  faMosquitoNet: faMosquitoNet,
  faVentDamper: faVentDamper,
  faBridgeWater: faBridgeWater,
  faBanBug: faBanBug,
  faDebug: faDebug,
  faPersonBooth: faPersonBooth,
  faTextWidth: faTextWidth,
  faGarageCar: faGarageCar,
  faSquareKanban: faSquareKanban,
  faHatWizard: faHatWizard,
  faPenFancy: faPenFancy,
  faCoffeePot: faCoffeePot,
  faMouseField: faMouseField,
  faPersonDigging: faPersonDigging,
  faDigging: faDigging,
  faShowerDown: faShowerDown,
  faShowerAlt: faShowerAlt,
  faBoxCircleCheck: faBoxCircleCheck,
  faBrightness: faBrightness,
  faCarSideBolt: faCarSideBolt,
  faOrnament: faOrnament,
  faPhoneArrowDownLeft: faPhoneArrowDownLeft,
  faPhoneArrowDown: faPhoneArrowDown,
  faPhoneIncoming: faPhoneIncoming,
  faCloudWord: faCloudWord,
  faHandFingersCrossed: faHandFingersCrossed,
  faTrash: faTrash,
  faGaugeSimple: faGaugeSimple,
  faGaugeSimpleMed: faGaugeSimpleMed,
  faTachometerAverage: faTachometerAverage,
  faArrowDownSmallBig: faArrowDownSmallBig,
  faSortSizeDownAlt: faSortSizeDownAlt,
  faBookMedical: faBookMedical,
  faFaceMelting: faFaceMelting,
  faPoo: faPoo,
  faPenClipSlash: faPenClipSlash,
  faPenAltSlash: faPenAltSlash,
  faQuoteRight: faQuoteRight,
  faQuoteRightAlt: faQuoteRightAlt,
  faScrollOld: faScrollOld,
  faGuitars: faGuitars,
  faPhoneXmark: faPhoneXmark,
  faHose: faHose,
  faClockSix: faClockSix,
  faShirt: faShirt,
  faTShirt: faTShirt,
  faTshirt: faTshirt,
  faBillboard: faBillboard,
  faSquareR: faSquareR,
  faCubes: faCubes,
  faEnvelopeOpenDollar: faEnvelopeOpenDollar,
  faDivide: faDivide,
  faSunCloud: faSunCloud,
  faLampFloor: faLampFloor,
  faSquare7: faSquare7,
  faTengeSign: faTengeSign,
  faTenge: faTenge,
  faHeadphones: faHeadphones,
  faHandsHolding: faHandsHolding,
  faCampfire: faCampfire,
  faCircleAmpersand: faCircleAmpersand,
  faSnowflakes: faSnowflakes,
  faHandsClapping: faHandsClapping,
  faRepublican: faRepublican,
  faLeafMaple: faLeafMaple,
  faArrowLeft: faArrowLeft,
  faPersonCircleXmark: faPersonCircleXmark,
  faRuler: faRuler,
  faCupStrawSwoosh: faCupStrawSwoosh,
  faTemperatureSun: faTemperatureSun,
  faTemperatureHot: faTemperatureHot,
  faAlignLeft: faAlignLeft,
  faDiceD6: faDiceD6,
  faRestroom: faRestroom,
  faHighDefinition: faHighDefinition,
  faRectangleHd: faRectangleHd,
  faJ: faJ,
  faGalaxy: faGalaxy,
  faUsersViewfinder: faUsersViewfinder,
  faFileVideo: faFileVideo,
  faCherries: faCherries,
  faUpRightFromSquare: faUpRightFromSquare,
  faExternalLinkAlt: faExternalLinkAlt,
  faCircleSort: faCircleSort,
  faSortCircle: faSortCircle,
  faTableCells: faTableCells,
  faTh: faTh,
  faFilePdf: faFilePdf,
  faSiren: faSiren,
  faArrowUpToDottedLine: faArrowUpToDottedLine,
  faImageLandscape: faImageLandscape,
  faLandscape: faLandscape,
  faTankWater: faTankWater,
  faCurlingStone: faCurlingStone,
  faCurling: faCurling,
  faGamepadModern: faGamepadModern,
  faGamepadAlt: faGamepadAlt,
  faMessagesQuestion: faMessagesQuestion,
  faBookBible: faBookBible,
  faBible: faBible,
  faO: faO,
  faSuitcaseMedical: faSuitcaseMedical,
  faMedkit: faMedkit,
  faBriefcaseArrowRight: faBriefcaseArrowRight,
  faExpandWide: faExpandWide,
  faClockElevenThirty: faClockElevenThirty,
  faRv: faRv,
  faUserSecret: faUserSecret,
  faOtter: faOtter,
  faDreidel: faDreidel,
  faPersonDress: faPersonDress,
  faFemale: faFemale,
  faCommentDollar: faCommentDollar,
  faBusinessTime: faBusinessTime,
  faBriefcaseClock: faBriefcaseClock,
  faFlowerTulip: faFlowerTulip,
  faPeoplePantsSimple: faPeoplePantsSimple,
  faCloudDrizzle: faCloudDrizzle,
  faTableCellsLarge: faTableCellsLarge,
  faThLarge: faThLarge,
  faBookTanakh: faBookTanakh,
  faTanakh: faTanakh,
  faSolarSystem: faSolarSystem,
  faSealQuestion: faSealQuestion,
  faPhoneVolume: faPhoneVolume,
  faVolumeControlPhone: faVolumeControlPhone,
  faDiscDrive: faDiscDrive,
  faHatCowboySide: faHatCowboySide,
  faTableRows: faTableRows,
  faRows: faRows,
  faLocationExclamation: faLocationExclamation,
  faMapMarkerExclamation: faMapMarkerExclamation,
  faFaceFearful: faFaceFearful,
  faClipboardUser: faClipboardUser,
  faBusSchool: faBusSchool,
  faFilmSlash: faFilmSlash,
  faSquareArrowDownRight: faSquareArrowDownRight,
  faBookSparkles: faBookSparkles,
  faBookSpells: faBookSpells,
  faWashingMachine: faWashingMachine,
  faWasher: faWasher,
  faChild: faChild,
  faLiraSign: faLiraSign,
  faUserVisor: faUserVisor,
  faFilePlusMinus: faFilePlusMinus,
  faChessClockFlip: faChessClockFlip,
  faChessClockAlt: faChessClockAlt,
  faSatellite: faSatellite,
  faPlaneLock: faPlaneLock,
  faSteeringWheel: faSteeringWheel,
  faTag: faTag,
  faStretcher: faStretcher,
  faBookSection: faBookSection,
  faBookLaw: faBookLaw,
  faInboxes: faInboxes,
  faCoffeeBean: faCoffeeBean,
  faCircleYen: faCircleYen,
  faBracketsCurly: faBracketsCurly,
  faEllipsisStrokeVertical: faEllipsisStrokeVertical,
  faEllipsisVAlt: faEllipsisVAlt,
  faComment: faComment,
  faSquare1: faSquare1,
  faCakeCandles: faCakeCandles,
  faBirthdayCake: faBirthdayCake,
  faCake: faCake,
  faHeadSide: faHeadSide,
  faEnvelope: faEnvelope,
  faDollyEmpty: faDollyEmpty,
  faFaceTissue: faFaceTissue,
  faAnglesUp: faAnglesUp,
  faAngleDoubleUp: faAngleDoubleUp,
  faBinRecycle: faBinRecycle,
  faPaperclip: faPaperclip,
  faChartLineDown: faChartLineDown,
  faArrowRightToCity: faArrowRightToCity,
  faLockA: faLockA,
  faRibbon: faRibbon,
  faLungs: faLungs,
  faPersonPinball: faPersonPinball,
  faArrowUp91: faArrowUp91,
  faSortNumericUpAlt: faSortNumericUpAlt,
  faAppleCore: faAppleCore,
  faCircleY: faCircleY,
  faH6: faH6,
  faLitecoinSign: faLitecoinSign,
  faCircleSmall: faCircleSmall,
  faBorderNone: faBorderNone,
  faArrowTurnDownLeft: faArrowTurnDownLeft,
  faCircleNodes: faCircleNodes,
  faParachuteBox: faParachuteBox,
  faMessageMedical: faMessageMedical,
  faCommentAltMedical: faCommentAltMedical,
  faRugbyBall: faRugbyBall,
  faCommentMusic: faCommentMusic,
  faIndent: faIndent,
  faTreeDeciduous: faTreeDeciduous,
  faTreeAlt: faTreeAlt,
  faPuzzlePieceSimple: faPuzzlePieceSimple,
  faPuzzlePieceAlt: faPuzzlePieceAlt,
  faTruckFieldUn: faTruckFieldUn,
  faNfcTrash: faNfcTrash,
  faHourglass: faHourglass,
  faHourglassEmpty: faHourglassEmpty,
  faMountain: faMountain,
  faFileXmark: faFileXmark,
  faFileTimes: faFileTimes,
  faHouseHeart: faHouseHeart,
  faHomeHeart: faHomeHeart,
  faHouseChimneyBlank: faHouseChimneyBlank,
  faMeterBolt: faMeterBolt,
  faUserDoctor: faUserDoctor,
  faUserMd: faUserMd,
  faSlashBack: faSlashBack,
  faCircleInfo: faCircleInfo,
  faInfoCircle: faInfoCircle,
  faFishingRod: faFishingRod,
  faHammerCrash: faHammerCrash,
  faMessageHeart: faMessageHeart,
  faCloudMeatball: faCloudMeatball,
  faCameraPolaroid: faCameraPolaroid,
  faCamera: faCamera,
  faCameraAlt: faCameraAlt,
  faSquareVirus: faSquareVirus,
  faCartArrowUp: faCartArrowUp,
  faMeteor: faMeteor,
  faCarOn: faCarOn,
  faSleigh: faSleigh,
  faArrowDown19: faArrowDown19,
  faSortNumericAsc: faSortNumericAsc,
  faSortNumericDown: faSortNumericDown,
  faBuoyMooring: faBuoyMooring,
  faSquare4: faSquare4,
  faHandHoldingDroplet: faHandHoldingDroplet,
  faHandHoldingWater: faHandHoldingWater,
  faTricycleAdult: faTricycleAdult,
  faWaveform: faWaveform,
  faWater: faWater,
  faStarSharpHalfStroke: faStarSharpHalfStroke,
  faStarSharpHalfAlt: faStarSharpHalfAlt,
  faNfcSignal: faNfcSignal,
  faPlaneProp: faPlaneProp,
  faCalendarCheck: faCalendarCheck,
  faClockDesk: faClockDesk,
  faCalendarClock: faCalendarClock,
  faCalendarTime: faCalendarTime,
  faBraille: faBraille,
  faPrescriptionBottleMedical: faPrescriptionBottleMedical,
  faPrescriptionBottleAlt: faPrescriptionBottleAlt,
  faPlateUtensils: faPlateUtensils,
  faFamilyPants: faFamilyPants,
  faHoseReel: faHoseReel,
  faHouseWindow: faHouseWindow,
  faLandmark: faLandmark,
  faTruck: faTruck,
  faCrosshairs: faCrosshairs,
  faCloudRainbow: faCloudRainbow,
  faPersonCane: faPersonCane,
  faAlien: faAlien,
  faTent: faTent,
  faLaptopBinary: faLaptopBinary,
  faVestPatches: faVestPatches,
  faPeopleDressSimple: faPeopleDressSimple,
  faCheckDouble: faCheckDouble,
  faArrowDownAZ: faArrowDownAZ,
  faSortAlphaAsc: faSortAlphaAsc,
  faSortAlphaDown: faSortAlphaDown,
  faBowlingBallPin: faBowlingBallPin,
  faBellSchoolSlash: faBellSchoolSlash,
  faPlusLarge: faPlusLarge,
  faMoneyBillWheat: faMoneyBillWheat,
  faCameraViewfinder: faCameraViewfinder,
  faScreenshot: faScreenshot,
  faMessageMusic: faMessageMusic,
  faCommentAltMusic: faCommentAltMusic,
  faCarBuilding: faCarBuilding,
  faBorderBottomRight: faBorderBottomRight,
  faBorderStyleAlt: faBorderStyleAlt,
  faOctagon: faOctagon,
  faCommentArrowUpRight: faCommentArrowUpRight,
  faOctagonDivide: faOctagonDivide,
  faCookie: faCookie,
  faArrowRotateLeft: faArrowRotateLeft,
  faArrowLeftRotate: faArrowLeftRotate,
  faArrowRotateBack: faArrowRotateBack,
  faArrowRotateBackward: faArrowRotateBackward,
  faUndo: faUndo,
  faTvMusic: faTvMusic,
  faHardDrive: faHardDrive,
  faHdd: faHdd,
  faReel: faReel,
  faFaceGrinSquintTears: faFaceGrinSquintTears,
  faGrinSquintTears: faGrinSquintTears,
  faDumbbell: faDumbbell,
  faRectangleList: faRectangleList,
  faListAlt: faListAlt,
  faTarpDroplet: faTarpDroplet,
  faAlarmExclamation: faAlarmExclamation,
  faHouseMedicalCircleCheck: faHouseMedicalCircleCheck,
  faTrafficCone: faTrafficCone,
  faGrate: faGrate,
  faArrowDownRight: faArrowDownRight,
  faPersonSkiingNordic: faPersonSkiingNordic,
  faSkiingNordic: faSkiingNordic,
  faCalendarPlus: faCalendarPlus,
  faPersonFromPortal: faPersonFromPortal,
  faPortalExit: faPortalExit,
  faPlaneArrival: faPlaneArrival,
  faCowbellCirclePlus: faCowbellCirclePlus,
  faCowbellMore: faCowbellMore,
  faCircleLeft: faCircleLeft,
  faArrowAltCircleLeft: faArrowAltCircleLeft,
  faDistributeSpacingVertical: faDistributeSpacingVertical,
  faSignalBarsFair: faSignalBarsFair,
  faSignalAlt2: faSignalAlt2,
  faSportsball: faSportsball,
  faGameConsoleHandheldCrank: faGameConsoleHandheldCrank,
  faTrainSubway: faTrainSubway,
  faSubway: faSubway,
  faChartGantt: faChartGantt,
  faFaceSmileUpsideDown: faFaceSmileUpsideDown,
  faBallPile: faBallPile,
  faBadgeDollar: faBadgeDollar,
  faMoneyBillsSimple: faMoneyBillsSimple,
  faMoneyBillsAlt: faMoneyBillsAlt,
  faListTimeline: faListTimeline,
  faIndianRupeeSign: faIndianRupeeSign,
  faIndianRupee: faIndianRupee,
  faInr: faInr,
  faCropSimple: faCropSimple,
  faCropAlt: faCropAlt,
  faMoneyBill1: faMoneyBill1,
  faMoneyBillAlt: faMoneyBillAlt,
  faLeftLong: faLeftLong,
  faLongArrowAltLeft: faLongArrowAltLeft,
  faKeyboardDown: faKeyboardDown,
  faCircleUpRight: faCircleUpRight,
  faCloudBoltMoon: faCloudBoltMoon,
  faThunderstormMoon: faThunderstormMoon,
  faDna: faDna,
  faVirusSlash: faVirusSlash,
  faBracketRoundRight: faBracketRoundRight,
  faCircleSterling: faCircleSterling,
  faCircle5: faCircle5,
  faMinus: faMinus,
  faSubtract: faSubtract,
  faFireFlame: faFireFlame,
  faFlame: faFlame,
  faRightToLine: faRightToLine,
  faArrowAltToRight: faArrowAltToRight,
  faGif: faGif,
  faChess: faChess,
  faTrashSlash: faTrashSlash,
  faArrowLeftLong: faArrowLeftLong,
  faLongArrowLeft: faLongArrowLeft,
  faPlugCircleCheck: faPlugCircleCheck,
  faFontCase: faFontCase,
  faStreetView: faStreetView,
  faArrowDownLeft: faArrowDownLeft,
  faFrancSign: faFrancSign,
  faFlaskRoundPoison: faFlaskRoundPoison,
  faFlaskPoison: faFlaskPoison,
  faVolumeOff: faVolumeOff,
  faBookCircleArrowRight: faBookCircleArrowRight,
  faChartUser: faChartUser,
  faUserChart: faUserChart,
  faHandsAslInterpreting: faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
  faAslInterpreting: faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting: faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen: faPresentationScreen,
  faPresentation: faPresentation,
  faCircleBolt: faCircleBolt,
  faFaceSmileHalo: faFaceSmileHalo,
  faCartCircleArrowDown: faCartCircleArrowDown,
  faHousePersonReturn: faHousePersonReturn,
  faHousePersonArrive: faHousePersonArrive,
  faHouseReturn: faHouseReturn,
  faMessageXmark: faMessageXmark,
  faCommentAltTimes: faCommentAltTimes,
  faMessageTimes: faMessageTimes,
  faFileCertificate: faFileCertificate,
  faFileAward: faFileAward,
  faUserDoctorHairLong: faUserDoctorHairLong,
  faCameraSecurity: faCameraSecurity,
  faCameraHome: faCameraHome,
  faGear: faGear,
  faCog: faCog,
  faDropletSlash: faDropletSlash,
  faTintSlash: faTintSlash,
  faBookHeart: faBookHeart,
  faMosque: faMosque,
  faDuck: faDuck,
  faMosquito: faMosquito,
  faStarOfDavid: faStarOfDavid,
  faFlagSwallowtail: faFlagSwallowtail,
  faFlagAlt: faFlagAlt,
  faPersonMilitaryRifle: faPersonMilitaryRifle,
  faCarGarage: faCarGarage,
  faCartShopping: faCartShopping,
  faShoppingCart: faShoppingCart,
  faBookFont: faBookFont,
  faShieldPlus: faShieldPlus,
  faVials: faVials,
  faEyeDropperFull: faEyeDropperFull,
  faDistributeSpacingHorizontal: faDistributeSpacingHorizontal,
  faTabletRugged: faTabletRugged,
  faTemperatureSnow: faTemperatureSnow,
  faTemperatureFrigid: faTemperatureFrigid,
  faMoped: faMoped,
  faFaceSmilePlus: faFaceSmilePlus,
  faSmilePlus: faSmilePlus,
  faRadioTuner: faRadioTuner,
  faRadioAlt: faRadioAlt,
  faFaceSwear: faFaceSwear,
  faWaterArrowDown: faWaterArrowDown,
  faWaterLower: faWaterLower,
  faScannerTouchscreen: faScannerTouchscreen,
  faCircle7: faCircle7,
  faPlugCirclePlus: faPlugCirclePlus,
  faPersonSkiJumping: faPersonSkiJumping,
  faSkiJump: faSkiJump,
  faPlaceOfWorship: faPlaceOfWorship,
  faWaterArrowUp: faWaterArrowUp,
  faWaterRise: faWaterRise,
  faWaveformLines: faWaveformLines,
  faWaveformPath: faWaveformPath,
  faSplit: faSplit,
  faFilmCanister: faFilmCanister,
  faFilmCannister: faFilmCannister,
  faFolderXmark: faFolderXmark,
  faFolderTimes: faFolderTimes,
  faToiletPaperBlank: faToiletPaperBlank,
  faToiletPaperAlt: faToiletPaperAlt,
  faTabletScreen: faTabletScreen,
  faTabletAndroidAlt: faTabletAndroidAlt,
  faHexagonVerticalNftSlanted: faHexagonVerticalNftSlanted,
  faFolderMusic: faFolderMusic,
  faDisplayMedical: faDisplayMedical,
  faDesktopMedical: faDesktopMedical,
  faShareAll: faShareAll,
  faPeapod: faPeapod,
  faChessClock: faChessClock,
  faAxe: faAxe,
  faSquareD: faSquareD,
  faGripVertical: faGripVertical,
  faMobileSignalOut: faMobileSignalOut,
  faArrowTurnUp: faArrowTurnUp,
  faLevelUp: faLevelUp,
  faU: faU,
  faArrowUpFromDottedLine: faArrowUpFromDottedLine,
  faSquareRootVariable: faSquareRootVariable,
  faSquareRootAlt: faSquareRootAlt,
  faLightSwitchOn: faLightSwitchOn,
  faArrowDownArrowUp: faArrowDownArrowUp,
  faSortAlt: faSortAlt,
  faRaindrops: faRaindrops,
  faDash: faDash,
  faMinusLarge: faMinusLarge,
  faClock: faClock,
  faClockFour: faClockFour,
  faInputNumeric: faInputNumeric,
  faTruckTow: faTruckTow,
  faBackwardStep: faBackwardStep,
  faStepBackward: faStepBackward,
  faPallet: faPallet,
  faCarBolt: faCarBolt,
  faArrowsMaximize: faArrowsMaximize,
  faExpandArrows: faExpandArrows,
  faFaucet: faFaucet,
  faCloudSleet: faCloudSleet,
  faLampStreet: faLampStreet,
  faListRadio: faListRadio,
  faPenNibSlash: faPenNibSlash,
  faBaseballBatBall: faBaseballBatBall,
  faSquareUpLeft: faSquareUpLeft,
  faOverline: faOverline,
  faS: faS,
  faTimeline: faTimeline,
  faKeyboard: faKeyboard,
  faArrowsFromDottedLine: faArrowsFromDottedLine,
  faUsbDrive: faUsbDrive,
  faBallot: faBallot,
  faCaretDown: faCaretDown,
  faLocationDotSlash: faLocationDotSlash,
  faMapMarkerAltSlash: faMapMarkerAltSlash,
  faCards: faCards,
  faHouseChimneyMedical: faHouseChimneyMedical,
  faClinicMedical: faClinicMedical,
  faBoxingGlove: faBoxingGlove,
  faGloveBoxing: faGloveBoxing,
  faTemperatureThreeQuarters: faTemperatureThreeQuarters,
  faTemperature3: faTemperature3,
  faThermometer3: faThermometer3,
  faThermometerThreeQuarters: faThermometerThreeQuarters,
  faBellSchool: faBellSchool,
  faMobileScreen: faMobileScreen,
  faMobileAndroidAlt: faMobileAndroidAlt,
  faPlaneUp: faPlaneUp,
  faFolderHeart: faFolderHeart,
  faCircleLocationArrow: faCircleLocationArrow,
  faLocationCircle: faLocationCircle,
  faFaceHeadBandage: faFaceHeadBandage,
  faSushiRoll: faSushiRoll,
  faMakiRoll: faMakiRoll,
  faMakizushi: faMakizushi,
  faCarBump: faCarBump,
  faPiggyBank: faPiggyBank,
  faRacquet: faRacquet,
  faCarMirrors: faCarMirrors,
  faIndustryWindows: faIndustryWindows,
  faIndustryAlt: faIndustryAlt,
  faBoltAuto: faBoltAuto,
  faBatteryHalf: faBatteryHalf,
  faBattery3: faBattery3,
  faFluxCapacitor: faFluxCapacitor,
  faMountainCity: faMountainCity,
  faCoins: faCoins,
  faHoneyPot: faHoneyPot,
  faOlive: faOlive,
  faKhanda: faKhanda,
  faFilterList: faFilterList,
  faOutlet: faOutlet,
  faSliders: faSliders,
  faSlidersH: faSlidersH,
  faCauldron: faCauldron,
  faPeople: faPeople,
  faFolderTree: faFolderTree,
  faNetworkWired: faNetworkWired,
  faCroissant: faCroissant,
  faMapPin: faMapPin,
  faHamsa: faHamsa,
  faCentSign: faCentSign,
  faSwordsLaser: faSwordsLaser,
  faFlask: faFlask,
  faPersonPregnant: faPersonPregnant,
  faSquareU: faSquareU,
  faWandSparkles: faWandSparkles,
  faRouter: faRouter,
  faEllipsisVertical: faEllipsisVertical,
  faEllipsisV: faEllipsisV,
  faSwordLaserAlt: faSwordLaserAlt,
  faTicket: faTicket,
  faPowerOff: faPowerOff,
  faCoin: faCoin,
  faLaptopSlash: faLaptopSlash,
  faRightLong: faRightLong,
  faLongArrowAltRight: faLongArrowAltRight,
  faCircleB: faCircleB,
  faPersonDressSimple: faPersonDressSimple,
  faPipeCollar: faPipeCollar,
  faLightsHoliday: faLightsHoliday,
  faCitrus: faCitrus,
  faFlagUsa: faFlagUsa,
  faLaptopFile: faLaptopFile,
  faTty: faTty,
  faTeletype: faTeletype,
  faChartTreeMap: faChartTreeMap,
  faDiagramNext: faDiagramNext,
  faPersonRifle: faPersonRifle,
  faClockFiveThirty: faClockFiveThirty,
  faPipeValve: faPipeValve,
  faArrowUpFromArc: faArrowUpFromArc,
  faFaceSpiralEyes: faFaceSpiralEyes,
  faCompressWide: faCompressWide,
  faCirclePhoneHangup: faCirclePhoneHangup,
  faPhoneCircleDown: faPhoneCircleDown,
  faGearComplexCode: faGearComplexCode,
  faHouseMedicalCircleExclamation: faHouseMedicalCircleExclamation,
  faBadminton: faBadminton,
  faClosedCaptioning: faClosedCaptioning,
  faPersonHiking: faPersonHiking,
  faHiking: faHiking,
  faRightFromLine: faRightFromLine,
  faArrowAltFromLeft: faArrowAltFromLeft,
  faVenusDouble: faVenusDouble,
  faImages: faImages,
  faCalculator: faCalculator,
  faShuttlecock: faShuttlecock,
  faUserHair: faUserHair,
  faEyeEvil: faEyeEvil,
  faPeoplePulling: faPeoplePulling,
  faN: faN,
  faGarage: faGarage,
  faCableCar: faCableCar,
  faTram: faTram,
  faShovelSnow: faShovelSnow,
  faCloudRain: faCloudRain,
  faFaceLying: faFaceLying,
  faSprinkler: faSprinkler,
  faBuildingCircleXmark: faBuildingCircleXmark,
  faPersonSledding: faPersonSledding,
  faSledding: faSledding,
  faGameConsoleHandheld: faGameConsoleHandheld,
  faShip: faShip,
  faClockSixThirty: faClockSixThirty,
  faBatterySlash: faBatterySlash,
  faTugrikSign: faTugrikSign,
  faArrowsDownToLine: faArrowsDownToLine,
  faDownload: faDownload,
  faShelves: faShelves,
  faInventory: faInventory,
  faCloudSnow: faCloudSnow,
  faFaceGrin: faFaceGrin,
  faGrin: faGrin,
  faDeleteLeft: faDeleteLeft,
  faBackspace: faBackspace,
  faOven: faOven,
  faCloudBinary: faCloudBinary,
  faEyeDropper: faEyeDropper,
  faEyeDropperEmpty: faEyeDropperEmpty,
  faEyedropper: faEyedropper,
  faCommentCaptions: faCommentCaptions,
  faCommentsQuestion: faCommentsQuestion,
  faScribble: faScribble,
  faRotateExclamation: faRotateExclamation,
  faFileCircleCheck: faFileCircleCheck,
  faGlass: faGlass,
  faLoader: faLoader,
  faForward: faForward,
  faUserPilot: faUserPilot,
  faMobile: faMobile,
  faMobileAndroid: faMobileAndroid,
  faMobilePhone: faMobilePhone,
  faCodePullRequestClosed: faCodePullRequestClosed,
  faFaceMeh: faFaceMeh,
  faMeh: faMeh,
  faAlignCenter: faAlignCenter,
  faBookSkull: faBookSkull,
  faBookDead: faBookDead,
  faIdCard: faIdCard,
  faDriversLicense: faDriversLicense,
  faFaceDotted: faFaceDotted,
  faFaceWorried: faFaceWorried,
  faOutdent: faOutdent,
  faDedent: faDedent,
  faHeartCircleExclamation: faHeartCircleExclamation,
  faHouse: faHouse,
  faHome: faHome,
  faHomeAlt: faHomeAlt,
  faHomeLgAlt: faHomeLgAlt,
  faVectorCircle: faVectorCircle,
  faCarCircleBolt: faCarCircleBolt,
  faCalendarWeek: faCalendarWeek,
  faFlyingDisc: faFlyingDisc,
  faLaptopMedical: faLaptopMedical,
  faSquareDownRight: faSquareDownRight,
  faB: faB,
  faSeatAirline: faSeatAirline,
  faMoonOverSun: faMoonOverSun,
  faEclipseAlt: faEclipseAlt,
  faPipe: faPipe,
  faFileMedical: faFileMedical,
  faPotato: faPotato,
  faDiceOne: faDiceOne,
  faCircleA: faCircleA,
  faHelmetBattle: faHelmetBattle,
  faButter: faButter,
  faBlanketFire: faBlanketFire,
  faKiwiBird: faKiwiBird,
  faCastle: faCastle,
  faGolfClub: faGolfClub,
  faArrowRightArrowLeft: faArrowRightArrowLeft,
  faExchange: faExchange,
  faRotateRight: faRotateRight,
  faRedoAlt: faRedoAlt,
  faRotateForward: faRotateForward,
  faUtensils: faUtensils,
  faCutlery: faCutlery,
  faArrowUpWideShort: faArrowUpWideShort,
  faSortAmountUp: faSortAmountUp,
  faChartPieSimpleCircleDollar: faChartPieSimpleCircleDollar,
  faBalloons: faBalloons,
  faMillSign: faMillSign,
  faBowlRice: faBowlRice,
  faTimelineArrow: faTimelineArrow,
  faSkull: faSkull,
  faGameBoardSimple: faGameBoardSimple,
  faGameBoardAlt: faGameBoardAlt,
  faCircleVideo: faCircleVideo,
  faVideoCircle: faVideoCircle,
  faChartScatterBubble: faChartScatterBubble,
  faHouseTurret: faHouseTurret,
  faBanana: faBanana,
  faHandHoldingSkull: faHandHoldingSkull,
  faPeopleDress: faPeopleDress,
  faLoveseat: faLoveseat,
  faCouchSmall: faCouchSmall,
  faTowerBroadcast: faTowerBroadcast,
  faBroadcastTower: faBroadcastTower,
  faTruckPickup: faTruckPickup,
  faBlockQuote: faBlockQuote,
  faUpLong: faUpLong,
  faLongArrowAltUp: faLongArrowAltUp,
  faStop: faStop,
  faCodeMerge: faCodeMerge,
  faMoneyCheckDollarPen: faMoneyCheckDollarPen,
  faMoneyCheckEditAlt: faMoneyCheckEditAlt,
  faUpFromLine: faUpFromLine,
  faArrowAltFromBottom: faArrowAltFromBottom,
  faUpload: faUpload,
  faHurricane: faHurricane,
  faGridRound2Plus: faGridRound2Plus,
  faPeoplePants: faPeoplePants,
  faMound: faMound,
  faWindsock: faWindsock,
  faCircleHalf: faCircleHalf,
  faBrakeWarning: faBrakeWarning,
  faToiletPortable: faToiletPortable,
  faCompactDisc: faCompactDisc,
  faFileArrowDown: faFileArrowDown,
  faFileDownload: faFileDownload,
  faSaxophoneFire: faSaxophoneFire,
  faSaxHot: faSaxHot,
  faCameraWebSlash: faCameraWebSlash,
  faWebcamSlash: faWebcamSlash,
  faFolderMedical: faFolderMedical,
  faFolderGear: faFolderGear,
  faFolderCog: faFolderCog,
  faHandWave: faHandWave,
  faArrowUpArrowDown: faArrowUpArrowDown,
  faSortUpDown: faSortUpDown,
  faCaravan: faCaravan,
  faShieldCat: faShieldCat,
  faMessageSlash: faMessageSlash,
  faCommentAltSlash: faCommentAltSlash,
  faBolt: faBolt,
  faZap: faZap,
  faTrashCanCheck: faTrashCanCheck,
  faGlassWater: faGlassWater,
  faOilWell: faOilWell,
  faPersonSimple: faPersonSimple,
  faVault: faVault,
  faMars: faMars,
  faToilet: faToilet,
  faPlaneCircleXmark: faPlaneCircleXmark,
  faYenSign: faYenSign,
  faCny: faCny,
  faJpy: faJpy,
  faRmb: faRmb,
  faYen: faYen,
  faGearCode: faGearCode,
  faNotes: faNotes,
  faRubleSign: faRubleSign,
  faRouble: faRouble,
  faRub: faRub,
  faRuble: faRuble,
  faTrashUndo: faTrashUndo,
  faTrashArrowTurnLeft: faTrashArrowTurnLeft,
  faChampagneGlass: faChampagneGlass,
  faGlassChampagne: faGlassChampagne,
  faObjectsAlignCenterHorizontal: faObjectsAlignCenterHorizontal,
  faSun: faSun,
  faTrashCanSlash: faTrashCanSlash,
  faTrashAltSlash: faTrashAltSlash,
  faScreenUsers: faScreenUsers,
  faUsersClass: faUsersClass,
  faGuitar: faGuitar,
  faSquareArrowLeft: faSquareArrowLeft,
  faArrowSquareLeft: faArrowSquareLeft,
  faSquare8: faSquare8,
  faFaceSmileHearts: faFaceSmileHearts,
  faBracketsSquare: faBracketsSquare,
  faBrackets: faBrackets,
  faLaptopArrowDown: faLaptopArrowDown,
  faHockeyStickPuck: faHockeyStickPuck,
  faHouseTree: faHouseTree,
  faSignalFair: faSignalFair,
  faSignal2: faSignal2,
  faFaceLaughWink: faFaceLaughWink,
  faLaughWink: faLaughWink,
  faCircleDollar: faCircleDollar,
  faDollarCircle: faDollarCircle,
  faUsdCircle: faUsdCircle,
  faHorseHead: faHorseHead,
  faArrowsRepeat: faArrowsRepeat,
  faRepeatAlt: faRepeatAlt,
  faBoreHole: faBoreHole,
  faIndustry: faIndustry,
  faImagePolaroid: faImagePolaroid,
  faWaveTriangle: faWaveTriangle,
  faPersonRunningFast: faPersonRunningFast,
  faCircleDown: faCircleDown,
  faArrowAltCircleDown: faArrowAltCircleDown,
  faGrill: faGrill,
  faArrowsTurnToDots: faArrowsTurnToDots,
  faChartMixed: faChartMixed,
  faAnalytics: faAnalytics,
  faFlorinSign: faFlorinSign,
  faArrowDownShortWide: faArrowDownShortWide,
  faSortAmountDesc: faSortAmountDesc,
  faSortAmountDownAlt: faSortAmountDownAlt,
  faLessThan: faLessThan,
  faDisplayCode: faDisplayCode,
  faDesktopCode: faDesktopCode,
  faFaceDrooling: faFaceDrooling,
  faOilTemperature: faOilTemperature,
  faOilTemp: faOilTemp,
  faSquareQuestion: faSquareQuestion,
  faQuestionSquare: faQuestionSquare,
  faAirConditioner: faAirConditioner,
  faAngleDown: faAngleDown,
  faMountains: faMountains,
  faOmega: faOmega,
  faCarTunnel: faCarTunnel,
  faPersonDollyEmpty: faPersonDollyEmpty,
  faPanFood: faPanFood,
  faHeadSideCough: faHeadSideCough,
  faGripLines: faGripLines,
  faThumbsDown: faThumbsDown,
  faUserLock: faUserLock,
  faArrowRightLong: faArrowRightLong,
  faLongArrowRight: faLongArrowRight,
  faTicketsAirline: faTicketsAirline,
  faAnchorCircleXmark: faAnchorCircleXmark,
  faEllipsis: faEllipsis,
  faEllipsisH: faEllipsisH,
  faNfcSlash: faNfcSlash,
  faChessPawn: faChessPawn,
  faKitMedical: faKitMedical,
  faFirstAid: faFirstAid,
  faGrid2Plus: faGrid2Plus,
  faBells: faBells,
  faPersonThroughWindow: faPersonThroughWindow,
  faToolbox: faToolbox,
  faEnvelopeDot: faEnvelopeDot,
  faEnvelopeBadge: faEnvelopeBadge,
  faHandsHoldingCircle: faHandsHoldingCircle,
  faBug: faBug,
  faBowlChopsticks: faBowlChopsticks,
  faCreditCard: faCreditCard,
  faCreditCardAlt: faCreditCardAlt,
  faCircleS: faCircleS,
  faBoxBallot: faBoxBallot,
  faCar: faCar,
  faAutomobile: faAutomobile,
  faHandHoldingHand: faHandHoldingHand,
  faUserTieHair: faUserTieHair,
  faPodiumStar: faPodiumStar,
  faUserHairMullet: faUserHairMullet,
  faBusinessFront: faBusinessFront,
  faPartyBack: faPartyBack,
  faTrianBalbot: faTrianBalbot,
  faMicrophoneStand: faMicrophoneStand,
  faBookOpenReader: faBookOpenReader,
  faBookReader: faBookReader,
  faFamilyDress: faFamilyDress,
  faCircleX: faCircleX,
  faCabin: faCabin,
  faMountainSun: faMountainSun,
  faChartSimpleHorizontal: faChartSimpleHorizontal,
  faBluetooth: faBluetooth,
  faArrowsLeftRightToLine: faArrowsLeftRightToLine,
  faHandBackPointLeft: faHandBackPointLeft,
  faMessageDots: faMessageDots,
  faCommentAltDots: faCommentAltDots,
  faMessaging: faMessaging,
  faFileHeart: faFileHeart,
  faBeerMug: faBeerMug,
  faBeerFoam: faBeerFoam,
  faDiceD20: faDiceD20,
  faDrone: faDrone,
  faTruckDroplet: faTruckDroplet,
  faFileCircleXmark: faFileCircleXmark,
  faTemperatureArrowUp: faTemperatureArrowUp,
  faTemperatureUp: faTemperatureUp,
  faMedal: faMedal,
  faBed: faBed,
  faBookCopy: faBookCopy,
  faSquareH: faSquareH,
  faHSquare: faHSquare,
  faSquareC: faSquareC,
  faClockTwo: faClockTwo,
  faSquareEllipsisVertical: faSquareEllipsisVertical,
  faCalendarUsers: faCalendarUsers,
  faPodcast: faPodcast,
  faBee: faBee,
  faTemperatureFull: faTemperatureFull,
  faTemperature4: faTemperature4,
  faThermometer4: faThermometer4,
  faThermometerFull: faThermometerFull,
  faBell: faBell,
  faCandyBar: faCandyBar,
  faChocolateBar: faChocolateBar,
  faXmarkLarge: faXmarkLarge,
  faPinata: faPinata,
  faArrowsFromLine: faArrowsFromLine,
  faSuperscript: faSuperscript,
  faBowlSpoon: faBowlSpoon,
  faHexagonCheck: faHexagonCheck,
  faPlugCircleXmark: faPlugCircleXmark,
  faStarOfLife: faStarOfLife,
  faPhoneSlash: faPhoneSlash,
  faTrafficLightStop: faTrafficLightStop,
  faPaintRoller: faPaintRoller,
  faAccentGrave: faAccentGrave,
  faHandshakeAngle: faHandshakeAngle,
  faHandsHelping: faHandsHelping,
  faCircle0: faCircle0,
  faDialMedLow: faDialMedLow,
  faLocationDot: faLocationDot,
  faMapMarkerAlt: faMapMarkerAlt,
  faCrab: faCrab,
  faBoxOpenFull: faBoxOpenFull,
  faBoxFull: faBoxFull,
  faFile: faFile,
  faGreaterThan: faGreaterThan,
  faQuotes: faQuotes,
  faPretzel: faPretzel,
  faPersonSwimming: faPersonSwimming,
  faSwimmer: faSwimmer,
  faArrowDown: faArrowDown,
  faUserRobotXmarks: faUserRobotXmarks,
  faMessageQuote: faMessageQuote,
  faCommentAltQuote: faCommentAltQuote,
  faCandyCorn: faCandyCorn,
  faFolderMagnifyingGlass: faFolderMagnifyingGlass,
  faFolderSearch: faFolderSearch,
  faNotebook: faNotebook,
  faDroplet: faDroplet,
  faTint: faTint,
  faBullseyePointer: faBullseyePointer,
  faEraser: faEraser,
  faHexagonImage: faHexagonImage,
  faEarthAmericas: faEarthAmericas,
  faEarth: faEarth,
  faEarthAmerica: faEarthAmerica,
  faGlobeAmericas: faGlobeAmericas,
  faCrateApple: faCrateApple,
  faAppleCrate: faAppleCrate,
  faPersonBurst: faPersonBurst,
  faGameBoard: faGameBoard,
  faHatChef: faHatChef,
  faHandBackPointRight: faHandBackPointRight,
  faDove: faDove,
  faSnowflakeDroplets: faSnowflakeDroplets,
  faBatteryEmpty: faBatteryEmpty,
  faBattery0: faBattery0,
  faGrid4: faGrid4,
  faSocks: faSocks,
  faFaceSunglasses: faFaceSunglasses,
  faInbox: faInbox,
  faSquare0: faSquare0,
  faSection: faSection,
  faSquareThisWayUp: faSquareThisWayUp,
  faBoxUp: faBoxUp,
  faGaugeHigh: faGaugeHigh,
  faTachometerAlt: faTachometerAlt,
  faTachometerAltFast: faTachometerAltFast,
  faSquareAmpersand: faSquareAmpersand,
  faEnvelopeOpenText: faEnvelopeOpenText,
  faLampDesk: faLampDesk,
  faHospital: faHospital,
  faHospitalAlt: faHospitalAlt,
  faHospitalWide: faHospitalWide,
  faPollPeople: faPollPeople,
  faWhiskeyGlassIce: faWhiskeyGlassIce,
  faGlassWhiskeyRocks: faGlassWhiskeyRocks,
  faWineBottle: faWineBottle,
  faChessRook: faChessRook,
  faUserBountyHunter: faUserBountyHunter,
  faBarsStaggered: faBarsStaggered,
  faReorder: faReorder,
  faStream: faStream,
  faDiagramSankey: faDiagramSankey,
  faCloudHailMixed: faCloudHailMixed,
  faCircleUpLeft: faCircleUpLeft,
  faDharmachakra: faDharmachakra,
  faObjectsAlignLeft: faObjectsAlignLeft,
  faOilCanDrip: faOilCanDrip,
  faFaceSmilingHands: faFaceSmilingHands,
  faBroccoli: faBroccoli,
  faRouteInterstate: faRouteInterstate,
  faEarMuffs: faEarMuffs,
  faHotdog: faHotdog,
  faTransporterEmpty: faTransporterEmpty,
  faPersonWalkingWithCane: faPersonWalkingWithCane,
  faBlind: faBlind,
  faAngle90: faAngle90,
  faRectangleTerminal: faRectangleTerminal,
  faKite: faKite,
  faDrum: faDrum,
  faScrubber: faScrubber,
  faIceCream: faIceCream,
  faHeartCircleBolt: faHeartCircleBolt,
  faFishBones: faFishBones,
  faDeerRudolph: faDeerRudolph,
  faFax: faFax,
  faParagraph: faParagraph,
  faHeadSideHeart: faHeadSideHeart,
  faSquareE: faSquareE,
  faMeterFire: faMeterFire,
  faCloudHail: faCloudHail,
  faCheckToSlot: faCheckToSlot,
  faVoteYea: faVoteYea,
  faMoneyFromBracket: faMoneyFromBracket,
  faStarHalf: faStarHalf,
  faCarBus: faCarBus,
  faSpeaker: faSpeaker,
  faTimer: faTimer,
  faBoxesStacked: faBoxesStacked,
  faBoxes: faBoxes,
  faBoxesAlt: faBoxesAlt,
  faGrillHot: faGrillHot,
  faBallotCheck: faBallotCheck,
  faLink: faLink,
  faChain: faChain,
  faEarListen: faEarListen,
  faAssistiveListeningSystems: faAssistiveListeningSystems,
  faFileMinus: faFileMinus,
  faTreeCity: faTreeCity,
  faPlay: faPlay,
  faFont: faFont,
  faCupTogo: faCupTogo,
  faCoffeeTogo: faCoffeeTogo,
  faSquareDownLeft: faSquareDownLeft,
  faBurgerLettuce: faBurgerLettuce,
  faRupiahSign: faRupiahSign,
  faMagnifyingGlass: faMagnifyingGlass,
  faSearch: faSearch,
  faTableTennisPaddleBall: faTableTennisPaddleBall,
  faPingPongPaddleBall: faPingPongPaddleBall,
  faTableTennis: faTableTennis,
  faPersonDotsFromLine: faPersonDotsFromLine,
  faDiagnoses: faDiagnoses,
  faChevronsDown: faChevronsDown,
  faChevronDoubleDown: faChevronDoubleDown,
  faTrashCanArrowUp: faTrashCanArrowUp,
  faTrashRestoreAlt: faTrashRestoreAlt,
  faSignalGood: faSignalGood,
  faSignal3: faSignal3,
  faLocationQuestion: faLocationQuestion,
  faMapMarkerQuestion: faMapMarkerQuestion,
  faFloppyDiskCircleXmark: faFloppyDiskCircleXmark,
  faFloppyDiskTimes: faFloppyDiskTimes,
  faSaveCircleXmark: faSaveCircleXmark,
  faSaveTimes: faSaveTimes,
  faNairaSign: faNairaSign,
  faPeach: faPeach,
  faTaxiBus: faTaxiBus,
  faBracketCurly: faBracketCurly,
  faBracketCurlyLeft: faBracketCurlyLeft,
  faLobster: faLobster,
  faCartFlatbedEmpty: faCartFlatbedEmpty,
  faDollyFlatbedEmpty: faDollyFlatbedEmpty,
  faColon: faColon,
  faCartArrowDown: faCartArrowDown,
  faWand: faWand,
  faWalkieTalkie: faWalkieTalkie,
  faFilePen: faFilePen,
  faFileEdit: faFileEdit,
  faReceipt: faReceipt,
  faTablePicnic: faTablePicnic,
  faSquarePen: faSquarePen,
  faPenSquare: faPenSquare,
  faPencilSquare: faPencilSquare,
  faCircleMicrophoneLines: faCircleMicrophoneLines,
  faMicrophoneCircleAlt: faMicrophoneCircleAlt,
  faDisplaySlash: faDisplaySlash,
  faDesktopSlash: faDesktopSlash,
  faSuitcaseRolling: faSuitcaseRolling,
  faPersonCircleExclamation: faPersonCircleExclamation,
  faTransporter2: faTransporter2,
  faHandsHoldingDiamond: faHandsHoldingDiamond,
  faHandReceiving: faHandReceiving,
  faMoneyBillSimpleWave: faMoneyBillSimpleWave,
  faChevronDown: faChevronDown,
  faBatteryFull: faBatteryFull,
  faBattery: faBattery,
  faBattery5: faBattery5,
  faBellPlus: faBellPlus,
  faBookArrowRight: faBookArrowRight,
  faHospitals: faHospitals,
  faClub: faClub,
  faSkullCrossbones: faSkullCrossbones,
  faDropletDegree: faDropletDegree,
  faDewpoint: faDewpoint,
  faCodeCompare: faCodeCompare,
  faListUl: faListUl,
  faListDots: faListDots,
  faHandHoldingMagic: faHandHoldingMagic,
  faWatermelonSlice: faWatermelonSlice,
  faCircleEllipsis: faCircleEllipsis,
  faSchoolLock: faSchoolLock,
  faTowerCell: faTowerCell,
  faSdCards: faSdCards,
  faJugBottle: faJugBottle,
  faDownLong: faDownLong,
  faLongArrowAltDown: faLongArrowAltDown,
  faEnvelopes: faEnvelopes,
  faPhoneOffice: faPhoneOffice,
  faRankingStar: faRankingStar,
  faChessKing: faChessKing,
  faNfcPen: faNfcPen,
  faPersonHarassing: faPersonHarassing,
  faHatWinter: faHatWinter,
  faBrazilianRealSign: faBrazilianRealSign,
  faLandmarkDome: faLandmarkDome,
  faLandmarkAlt: faLandmarkAlt,
  faBoneBreak: faBoneBreak,
  faArrowUp: faArrowUp,
  faDownFromDottedLine: faDownFromDottedLine,
  faTv: faTv,
  faTelevision: faTelevision,
  faTvAlt: faTvAlt,
  faBorderLeft: faBorderLeft,
  faCircleDivide: faCircleDivide,
  faShrimp: faShrimp,
  faListCheck: faListCheck,
  faTasks: faTasks,
  faDiagramSubtask: faDiagramSubtask,
  faJugDetergent: faJugDetergent,
  faCircleUser: faCircleUser,
  faUserCircle: faUserCircle,
  faSquareY: faSquareY,
  faUserDoctorHair: faUserDoctorHair,
  faPlanetRinged: faPlanetRinged,
  faMushroom: faMushroom,
  faUserShield: faUserShield,
  faMegaphone: faMegaphone,
  faWreathLaurel: faWreathLaurel,
  faCircleExclamationCheck: faCircleExclamationCheck,
  faWind: faWind,
  faBoxDollar: faBoxDollar,
  faBoxUsd: faBoxUsd,
  faCarBurst: faCarBurst,
  faCarCrash: faCarCrash,
  faY: faY,
  faUserHeadset: faUserHeadset,
  faArrowsRetweet: faArrowsRetweet,
  faRetweetAlt: faRetweetAlt,
  faPersonSnowboarding: faPersonSnowboarding,
  faSnowboarding: faSnowboarding,
  faSquareChevronRight: faSquareChevronRight,
  faChevronSquareRight: faChevronSquareRight,
  faLacrosseStickBall: faLacrosseStickBall,
  faTruckFast: faTruckFast,
  faShippingFast: faShippingFast,
  faUserMagnifyingGlass: faUserMagnifyingGlass,
  faStarSharp: faStarSharp,
  faCommentHeart: faCommentHeart,
  faCircle1: faCircle1,
  faCircleStar: faCircleStar,
  faStarCircle: faStarCircle,
  faFish: faFish,
  faCloudFog: faCloudFog,
  faFog: faFog,
  faWaffle: faWaffle,
  faMusicNote: faMusicNote,
  faMusicAlt: faMusicAlt,
  faHexagonExclamation: faHexagonExclamation,
  faCartShoppingFast: faCartShoppingFast,
  faObjectUnion: faObjectUnion,
  faUserGraduate: faUserGraduate,
  faStarfighter: faStarfighter,
  faCircleHalfStroke: faCircleHalfStroke,
  faAdjust: faAdjust,
  faArrowRightLongToLine: faArrowRightLongToLine,
  faSquareArrowDown: faSquareArrowDown,
  faArrowSquareDown: faArrowSquareDown,
  faDiamondHalfStroke: faDiamondHalfStroke,
  faClapperboard: faClapperboard,
  faSquareChevronLeft: faSquareChevronLeft,
  faChevronSquareLeft: faChevronSquareLeft,
  faPhoneIntercom: faPhoneIntercom,
  faLinkHorizontal: faLinkHorizontal,
  faChainHorizontal: faChainHorizontal,
  faMango: faMango,
  faMusicNoteSlash: faMusicNoteSlash,
  faMusicAltSlash: faMusicAltSlash,
  faCircleRadiation: faCircleRadiation,
  faRadiationAlt: faRadiationAlt,
  faFaceTongueSweat: faFaceTongueSweat,
  faGlobeStand: faGlobeStand,
  faBaseball: faBaseball,
  faBaseballBall: faBaseballBall,
  faCircleP: faCircleP,
  faAwardSimple: faAwardSimple,
  faJetFighterUp: faJetFighterUp,
  faDiagramProject: faDiagramProject,
  faProjectDiagram: faProjectDiagram,
  faPedestal: faPedestal,
  faChartPyramid: faChartPyramid,
  faSidebar: faSidebar,
  faSnowmanHead: faSnowmanHead,
  faFrostyHead: faFrostyHead,
  faCopy: faCopy,
  faBurgerGlass: faBurgerGlass,
  faVolumeXmark: faVolumeXmark,
  faVolumeMute: faVolumeMute,
  faVolumeTimes: faVolumeTimes,
  faHandSparkles: faHandSparkles,
  faBarsFilter: faBarsFilter,
  faPaintbrushPencil: faPaintbrushPencil,
  faPartyBell: faPartyBell,
  faUserVneckHair: faUserVneckHair,
  faJackOLantern: faJackOLantern,
  faGrip: faGrip,
  faGripHorizontal: faGripHorizontal,
  faShareFromSquare: faShareFromSquare,
  faShareSquare: faShareSquare,
  faKeynote: faKeynote,
  faChildCombatant: faChildCombatant,
  faChildRifle: faChildRifle,
  faGun: faGun,
  faSquarePhone: faSquarePhone,
  faPhoneSquare: faPhoneSquare,
  faHatBeach: faHatBeach,
  faPlus: faPlus,
  faAdd: faAdd,
  faExpand: faExpand,
  faComputer: faComputer,
  faFort: faFort,
  faCloudCheck: faCloudCheck,
  faXmark: faXmark,
  faClose: faClose,
  faMultiply: faMultiply,
  faRemove: faRemove,
  faTimes: faTimes,
  faFaceSmirking: faFaceSmirking,
  faArrowsUpDownLeftRight: faArrowsUpDownLeftRight,
  faArrows: faArrows,
  faChalkboardUser: faChalkboardUser,
  faChalkboardTeacher: faChalkboardTeacher,
  faRhombus: faRhombus,
  faClawMarks: faClawMarks,
  faPesoSign: faPesoSign,
  faFaceSmileTongue: faFaceSmileTongue,
  faCartCircleXmark: faCartCircleXmark,
  faBuildingShield: faBuildingShield,
  faCirclePhoneFlip: faCirclePhoneFlip,
  faPhoneCircleAlt: faPhoneCircleAlt,
  faBaby: faBaby,
  faUsersLine: faUsersLine,
  faQuoteLeft: faQuoteLeft,
  faQuoteLeftAlt: faQuoteLeftAlt,
  faTractor: faTractor,
  faKeySkeleton: faKeySkeleton,
  faTrashArrowUp: faTrashArrowUp,
  faTrashRestore: faTrashRestore,
  faArrowDownUpLock: faArrowDownUpLock,
  faArrowDownToBracket: faArrowDownToBracket,
  faLinesLeaning: faLinesLeaning,
  faSquareQ: faSquareQ,
  faRulerCombined: faRulerCombined,
  faSymbols: faSymbols,
  faIconsAlt: faIconsAlt,
  faCopyright: faCopyright,
  faFlaskGear: faFlaskGear,
  faHighlighterLine: faHighlighterLine,
  faBracketSquare: faBracketSquare,
  faBracket: faBracket,
  faBracketLeft: faBracketLeft,
  faIslandTropical: faIslandTropical,
  faIslandTreePalm: faIslandTreePalm,
  faArrowRightFromLine: faArrowRightFromLine,
  faArrowFromLeft: faArrowFromLeft,
  faH2: faH2,
  faEquals: faEquals,
  faCakeSlice: faCakeSlice,
  faShortcake: faShortcake,
  faPeanut: faPeanut,
  faWrenchSimple: faWrenchSimple,
  faBlender: faBlender,
  faTeeth: faTeeth,
  faTally2: faTally2,
  faShekelSign: faShekelSign,
  faIls: faIls,
  faShekel: faShekel,
  faSheqel: faSheqel,
  faSheqelSign: faSheqelSign,
  faCars: faCars,
  faAxeBattle: faAxeBattle,
  faUserHairLong: faUserHairLong,
  faMap: faMap,
  faFileCircleInfo: faFileCircleInfo,
  faFaceDisappointed: faFaceDisappointed,
  faLassoSparkles: faLassoSparkles,
  faClockEleven: faClockEleven,
  faRocket: faRocket,
  faSirenOn: faSirenOn,
  faClockTen: faClockTen,
  faCandleHolder: faCandleHolder,
  faVideoArrowDownLeft: faVideoArrowDownLeft,
  faPhotoFilm: faPhotoFilm,
  faPhotoVideo: faPhotoVideo,
  faFloppyDiskCircleArrowRight: faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight: faSaveCircleArrowRight,
  faFolderMinus: faFolderMinus,
  faPlanetMoon: faPlanetMoon,
  faFaceEyesXmarks: faFaceEyesXmarks,
  faChartScatter: faChartScatter,
  faDisplayArrowDown: faDisplayArrowDown,
  faStore: faStore,
  faArrowTrendUp: faArrowTrendUp,
  faPlugCircleMinus: faPlugCircleMinus,
  faOliveBranch: faOliveBranch,
  faAngle: faAngle,
  faVacuumRobot: faVacuumRobot,
  faSignHanging: faSignHanging,
  faSign: faSign,
  faSquareDivide: faSquareDivide,
  faSignalStreamSlash: faSignalStreamSlash,
  faBezierCurve: faBezierCurve,
  faEyeDropperHalf: faEyeDropperHalf,
  faStoreLock: faStoreLock,
  faBellSlash: faBellSlash,
  faCloudBoltSun: faCloudBoltSun,
  faThunderstormSun: faThunderstormSun,
  faCameraSlash: faCameraSlash,
  faCommentQuote: faCommentQuote,
  faTablet: faTablet,
  faTabletAndroid: faTabletAndroid,
  faSchoolFlag: faSchoolFlag,
  faMessageCode: faMessageCode,
  faGlassHalf: faGlassHalf,
  faGlassHalfEmpty: faGlassHalfEmpty,
  faGlassHalfFull: faGlassHalfFull,
  faFill: faFill,
  faMessageMinus: faMessageMinus,
  faCommentAltMinus: faCommentAltMinus,
  faAngleUp: faAngleUp,
  faDinosaur: faDinosaur,
  faDrumstickBite: faDrumstickBite,
  faLinkHorizontalSlash: faLinkHorizontalSlash,
  faChainHorizontalSlash: faChainHorizontalSlash,
  faHollyBerry: faHollyBerry,
  faNose: faNose,
  faChevronLeft: faChevronLeft,
  faBacteria: faBacteria,
  faClouds: faClouds,
  faMoneyBillSimple: faMoneyBillSimple,
  faHandLizard: faHandLizard,
  faTablePivot: faTablePivot,
  faFilterSlash: faFilterSlash,
  faTrashCanUndo: faTrashCanUndo,
  faTrashCanArrowTurnLeft: faTrashCanArrowTurnLeft,
  faTrashUndoAlt: faTrashUndoAlt,
  faNotdef: faNotdef,
  faDisease: faDisease,
  faPersonToDoor: faPersonToDoor,
  faTurntable: faTurntable,
  faBriefcaseMedical: faBriefcaseMedical,
  faGenderless: faGenderless,
  faChevronRight: faChevronRight,
  faSignalWeak: faSignalWeak,
  faSignal1: faSignal1,
  faClockFive: faClockFive,
  faRetweet: faRetweet,
  faCarRear: faCarRear,
  faCarAlt: faCarAlt,
  faPumpSoap: faPumpSoap,
  faComputerClassic: faComputerClassic,
  faFrame: faFrame,
  faVideoSlash: faVideoSlash,
  faBatteryQuarter: faBatteryQuarter,
  faBattery2: faBattery2,
  faEllipsisStroke: faEllipsisStroke,
  faEllipsisHAlt: faEllipsisHAlt,
  faRadio: faRadio,
  faBabyCarriage: faBabyCarriage,
  faCarriageBaby: faCarriageBaby,
  faFaceExpressionless: faFaceExpressionless,
  faDownToDottedLine: faDownToDottedLine,
  faCloudMusic: faCloudMusic,
  faTrafficLight: faTrafficLight,
  faCloudMinus: faCloudMinus,
  faThermometer: faThermometer,
  faShieldMinus: faShieldMinus,
  faVrCardboard: faVrCardboard,
  faCarTilt: faCarTilt,
  faGaugeCircleMinus: faGaugeCircleMinus,
  faBrightnessLow: faBrightnessLow,
  faHandMiddleFinger: faHandMiddleFinger,
  faPercent: faPercent,
  faPercentage: faPercentage,
  faTruckMoving: faTruckMoving,
  faGlassWaterDroplet: faGlassWaterDroplet,
  faConveyorBelt: faConveyorBelt,
  faLocationCheck: faLocationCheck,
  faMapMarkerCheck: faMapMarkerCheck,
  faCoinVertical: faCoinVertical,
  faDisplay: faDisplay,
  faPersonSign: faPersonSign,
  faFaceSmile: faFaceSmile,
  faSmile: faSmile,
  faPhoneHangup: faPhoneHangup,
  faSignatureSlash: faSignatureSlash,
  faThumbtack: faThumbtack,
  faThumbTack: faThumbTack,
  faWheatSlash: faWheatSlash,
  faTrophy: faTrophy,
  faCloudsSun: faCloudsSun,
  faPersonPraying: faPersonPraying,
  faPray: faPray,
  faHammer: faHammer,
  faFaceVomit: faFaceVomit,
  faSpeakers: faSpeakers,
  faTtyAnswer: faTtyAnswer,
  faTeletypeAnswer: faTeletypeAnswer,
  faMugTeaSaucer: faMugTeaSaucer,
  faDiagramLeanCanvas: faDiagramLeanCanvas,
  faAlt: faAlt,
  faDial: faDial,
  faDialMedHigh: faDialMedHigh,
  faHandPeace: faHandPeace,
  faCircleTrash: faCircleTrash,
  faTrashCircle: faTrashCircle,
  faRotate: faRotate,
  faSyncAlt: faSyncAlt,
  faCircleQuarters: faCircleQuarters,
  faSpinner: faSpinner,
  faTowerControl: faTowerControl,
  faArrowUpTriangleSquare: faArrowUpTriangleSquare,
  faSortShapesUp: faSortShapesUp,
  faWhale: faWhale,
  faRobot: faRobot,
  faPeace: faPeace,
  faPartyHorn: faPartyHorn,
  faGears: faGears,
  faCogs: faCogs,
  faSunBright: faSunBright,
  faSunAlt: faSunAlt,
  faWarehouse: faWarehouse,
  faConveyorBeltArm: faConveyorBeltArm,
  faLockKeyholeOpen: faLockKeyholeOpen,
  faLockOpenAlt: faLockOpenAlt,
  faSquareFragile: faSquareFragile,
  faBoxFragile: faBoxFragile,
  faSquareWineGlassCrack: faSquareWineGlassCrack,
  faArrowUpRightDots: faArrowUpRightDots,
  faSquareN: faSquareN,
  faSplotch: faSplotch,
  faFaceGrinHearts: faFaceGrinHearts,
  faGrinHearts: faGrinHearts,
  faMeter: faMeter,
  faMandolin: faMandolin,
  faDiceFour: faDiceFour,
  faSimCard: faSimCard,
  faTransgender: faTransgender,
  faTransgenderAlt: faTransgenderAlt,
  faMercury: faMercury,
  faUpFromBracket: faUpFromBracket,
  faKnifeKitchen: faKnifeKitchen,
  faBorderRight: faBorderRight,
  faArrowTurnDown: faArrowTurnDown,
  faLevelDown: faLevelDown,
  faSpade: faSpade,
  faCardSpade: faCardSpade,
  faLineColumns: faLineColumns,
  faArrowRightToLine: faArrowRightToLine,
  faArrowToRight: faArrowToRight,
  faPersonFallingBurst: faPersonFallingBurst,
  faFlagPennant: faFlagPennant,
  faPennant: faPennant,
  faConveyorBeltEmpty: faConveyorBeltEmpty,
  faUserGroupSimple: faUserGroupSimple,
  faAward: faAward,
  faTicketSimple: faTicketSimple,
  faTicketAlt: faTicketAlt,
  faBuilding: faBuilding,
  faAnglesLeft: faAnglesLeft,
  faAngleDoubleLeft: faAngleDoubleLeft,
  faCamcorder: faCamcorder,
  faVideoHandheld: faVideoHandheld,
  faPancakes: faPancakes,
  faAlbumCircleUser: faAlbumCircleUser,
  faQrcode: faQrcode,
  faDiceD10: faDiceD10,
  faFireplace: faFireplace,
  faBrowser: faBrowser,
  faPenPaintbrush: faPenPaintbrush,
  faPencilPaintbrush: faPencilPaintbrush,
  faFishCooked: faFishCooked,
  faChairOffice: faChairOffice,
  faNestingDolls: faNestingDolls,
  faClockRotateLeft: faClockRotateLeft,
  faHistory: faHistory,
  faTrumpet: faTrumpet,
  faFaceGrinBeamSweat: faFaceGrinBeamSweat,
  faGrinBeamSweat: faGrinBeamSweat,
  faFireSmoke: faFireSmoke,
  faPhoneMissed: faPhoneMissed,
  faFileExport: faFileExport,
  faArrowRightFromFile: faArrowRightFromFile,
  faShield: faShield,
  faShieldBlank: faShieldBlank,
  faArrowUpShortWide: faArrowUpShortWide,
  faSortAmountUpAlt: faSortAmountUpAlt,
  faArrowsRepeat1: faArrowsRepeat1,
  faRepeat1Alt: faRepeat1Alt,
  faGunSlash: faGunSlash,
  faAvocado: faAvocado,
  faBinary: faBinary,
  faGlassesRound: faGlassesRound,
  faGlassesAlt: faGlassesAlt,
  faPhonePlus: faPhonePlus,
  faDitto: faDitto,
  faPersonSeat: faPersonSeat,
  faHouseMedical: faHouseMedical,
  faGolfBallTee: faGolfBallTee,
  faGolfBall: faGolfBall,
  faCircleChevronLeft: faCircleChevronLeft,
  faChevronCircleLeft: faChevronCircleLeft,
  faHouseChimneyWindow: faHouseChimneyWindow,
  faScythe: faScythe,
  faPenNib: faPenNib,
  faBanParking: faBanParking,
  faParkingCircleSlash: faParkingCircleSlash,
  faTentArrowTurnLeft: faTentArrowTurnLeft,
  faFaceDiagonalMouth: faFaceDiagonalMouth,
  faDiagramCells: faDiagramCells,
  faCricketBatBall: faCricketBatBall,
  faCricket: faCricket,
  faTents: faTents,
  faWandMagic: faWandMagic,
  faMagic: faMagic,
  faDog: faDog,
  faPenLine: faPenLine,
  faAtomSimple: faAtomSimple,
  faAtomAlt: faAtomAlt,
  faAmpersand: faAmpersand,
  faCarrot: faCarrot,
  faArrowUpFromLine: faArrowUpFromLine,
  faArrowFromBottom: faArrowFromBottom,
  faMoon: faMoon,
  faPenSlash: faPenSlash,
  faWineGlassEmpty: faWineGlassEmpty,
  faWineGlassAlt: faWineGlassAlt,
  faSquareStar: faSquareStar,
  faCheese: faCheese,
  faSendBackward: faSendBackward,
  faYinYang: faYinYang,
  faMusic: faMusic,
  faCompassSlash: faCompassSlash,
  faClockOne: faClockOne,
  faFileMusic: faFileMusic,
  faCodeCommit: faCodeCommit,
  faTemperatureLow: faTemperatureLow,
  faPersonBiking: faPersonBiking,
  faBiking: faBiking,
  faDisplayChartUpCircleCurrency: faDisplayChartUpCircleCurrency,
  faSkeleton: faSkeleton,
  faCircleG: faCircleG,
  faCircleArrowUpLeft: faCircleArrowUpLeft,
  faCoinBlank: faCoinBlank,
  faBroom: faBroom,
  faVacuum: faVacuum,
  faShieldHeart: faShieldHeart,
  faCardHeart: faCardHeart,
  faLightbulbCflOn: faLightbulbCflOn,
  faMelon: faMelon,
  faGopuram: faGopuram,
  faEarthOceania: faEarthOceania,
  faGlobeOceania: faGlobeOceania,
  faContainerStorage: faContainerStorage,
  faFacePouting: faFacePouting,
  faSquareXmark: faSquareXmark,
  faTimesSquare: faTimesSquare,
  faXmarkSquare: faXmarkSquare,
  faFaceExplode: faFaceExplode,
  faExplodingHead: faExplodingHead,
  faHashtag: faHashtag,
  faUpRightAndDownLeftFromCenter: faUpRightAndDownLeftFromCenter,
  faExpandAlt: faExpandAlt,
  faOilCan: faOilCan,
  faT: faT,
  faTransformerBolt: faTransformerBolt,
  faHippo: faHippo,
  faChartColumn: faChartColumn,
  faCassetteVhs: faCassetteVhs,
  faVhs: faVhs,
  faInfinity: faInfinity,
  faVialCircleCheck: faVialCircleCheck,
  faChimney: faChimney,
  faObjectIntersect: faObjectIntersect,
  faPersonArrowDownToLine: faPersonArrowDownToLine,
  faVoicemail: faVoicemail,
  faBlockBrick: faBlockBrick,
  faWallBrick: faWallBrick,
  faFan: faFan,
  faBagsShopping: faBagsShopping,
  faParagraphLeft: faParagraphLeft,
  faParagraphRtl: faParagraphRtl,
  faPersonWalkingLuggage: faPersonWalkingLuggage,
  faCaravanSimple: faCaravanSimple,
  faCaravanAlt: faCaravanAlt,
  faTurtle: faTurtle,
  faPencilMechanical: faPencilMechanical,
  faUpDown: faUpDown,
  faArrowsAltV: faArrowsAltV,
  faCloudMoonRain: faCloudMoonRain,
  faBoothCurtain: faBoothCurtain,
  faCalendar: faCalendar,
  faBoxHeart: faBoxHeart,
  faTrailer: faTrailer,
  faUserDoctorMessage: faUserDoctorMessage,
  faUserMdChat: faUserMdChat,
  faBahai: faBahai,
  faHaykal: faHaykal,
  faAmpGuitar: faAmpGuitar,
  faSdCard: faSdCard,
  faVolumeSlash: faVolumeSlash,
  faBorderBottom: faBorderBottom,
  faWifiWeak: faWifiWeak,
  faWifi1: faWifi1,
  faDragon: faDragon,
  faShoePrints: faShoePrints,
  faCirclePlus: faCirclePlus,
  faPlusCircle: faPlusCircle,
  faFaceGrinTongueWink: faFaceGrinTongueWink,
  faGrinTongueWink: faGrinTongueWink,
  faHandHolding: faHandHolding,
  faPlugCircleExclamation: faPlugCircleExclamation,
  faLinkSlash: faLinkSlash,
  faChainBroken: faChainBroken,
  faChainSlash: faChainSlash,
  faUnlink: faUnlink,
  faClone: faClone,
  faPersonWalkingArrowLoopLeft: faPersonWalkingArrowLoopLeft,
  faArrowUpZA: faArrowUpZA,
  faSortAlphaUpAlt: faSortAlphaUpAlt,
  faFireFlameCurved: faFireFlameCurved,
  faFireAlt: faFireAlt,
  faTornado: faTornado,
  faFileCirclePlus: faFileCirclePlus,
  faDeleteRight: faDeleteRight,
  faBookQuran: faBookQuran,
  faQuran: faQuran,
  faCircleQuarter: faCircleQuarter,
  faAnchor: faAnchor,
  faBorderAll: faBorderAll,
  faFunction: faFunction,
  faFaceAngry: faFaceAngry,
  faAngry: faAngry,
  faPeopleSimple: faPeopleSimple,
  faCookieBite: faCookieBite,
  faArrowTrendDown: faArrowTrendDown,
  faRss: faRss,
  faFeed: faFeed,
  faFaceMonocle: faFaceMonocle,
  faDrawPolygon: faDrawPolygon,
  faScaleBalanced: faScaleBalanced,
  faBalanceScale: faBalanceScale,
  faCalendarLines: faCalendarLines,
  faCalendarNote: faCalendarNote,
  faArrowDownBigSmall: faArrowDownBigSmall,
  faSortSizeDown: faSortSizeDown,
  faGaugeSimpleHigh: faGaugeSimpleHigh,
  faTachometer: faTachometer,
  faTachometerFast: faTachometerFast,
  faDoNotEnter: faDoNotEnter,
  faShower: faShower,
  faDiceD8: faDiceD8,
  faDesktop: faDesktop,
  faDesktopAlt: faDesktopAlt,
  faM: faM,
  faGripDotsVertical: faGripDotsVertical,
  faFaceViewfinder: faFaceViewfinder,
  faSoftServe: faSoftServe,
  faCreemee: faCreemee,
  faH5: faH5,
  faHandBackPointDown: faHandBackPointDown,
  faTableList: faTableList,
  faThList: faThList,
  faCommentSms: faCommentSms,
  faSms: faSms,
  faRectangle: faRectangle,
  faRectangleLandscape: faRectangleLandscape,
  faClipboardListCheck: faClipboardListCheck,
  faTurkey: faTurkey,
  faBook: faBook,
  faUserPlus: faUserPlus,
  faIceSkate: faIceSkate,
  faCheck: faCheck,
  faBatteryThreeQuarters: faBatteryThreeQuarters,
  faBattery4: faBattery4,
  faTomato: faTomato,
  faSwordLaser: faSwordLaser,
  faHouseCircleCheck: faHouseCircleCheck,
  faBuildings: faBuildings,
  faAngleLeft: faAngleLeft,
  faCartFlatbedBoxes: faCartFlatbedBoxes,
  faDollyFlatbedAlt: faDollyFlatbedAlt,
  faDiagramSuccessor: faDiagramSuccessor,
  faTruckArrowRight: faTruckArrowRight,
  faSquareW: faSquareW,
  faArrowsSplitUpAndLeft: faArrowsSplitUpAndLeft,
  faLamp: faLamp,
  faAirplay: faAirplay,
  faHandFist: faHandFist,
  faFistRaised: faFistRaised,
  faShieldQuartered: faShieldQuartered,
  faSlashForward: faSlashForward,
  faLocationPen: faLocationPen,
  faMapMarkerEdit: faMapMarkerEdit,
  faCloudMoon: faCloudMoon,
  faPotFood: faPotFood,
  faBriefcase: faBriefcase,
  faPersonFalling: faPersonFalling,
  faImagePortrait: faImagePortrait,
  faPortrait: faPortrait,
  faUserTag: faUserTag,
  faRug: faRug,
  faPrintSlash: faPrintSlash,
  faEarthEurope: faEarthEurope,
  faGlobeEurope: faGlobeEurope,
  faCartFlatbedSuitcase: faCartFlatbedSuitcase,
  faLuggageCart: faLuggageCart,
  faHandBackPointRibbon: faHandBackPointRibbon,
  faRectangleXmark: faRectangleXmark,
  faRectangleTimes: faRectangleTimes,
  faTimesRectangle: faTimesRectangle,
  faWindowClose: faWindowClose,
  faTireRugged: faTireRugged,
  faLightbulbDollar: faLightbulbDollar,
  faCowbell: faCowbell,
  faBahtSign: faBahtSign,
  faCorner: faCorner,
  faChevronsRight: faChevronsRight,
  faChevronDoubleRight: faChevronDoubleRight,
  faBookOpen: faBookOpen,
  faBookJournalWhills: faBookJournalWhills,
  faJournalWhills: faJournalWhills,
  faInhaler: faInhaler,
  faHandcuffs: faHandcuffs,
  faSnake: faSnake,
  faTriangleExclamation: faTriangleExclamation,
  faExclamationTriangle: faExclamationTriangle,
  faWarning: faWarning,
  faNoteMedical: faNoteMedical,
  faDatabase: faDatabase,
  faDownLeft: faDownLeft,
  faShare: faShare,
  faArrowTurnRight: faArrowTurnRight,
  faMailForward: faMailForward,
  faFaceThinking: faFaceThinking,
  faTurnDownRight: faTurnDownRight,
  faBottleDroplet: faBottleDroplet,
  faMaskFace: faMaskFace,
  faHillRockslide: faHillRockslide,
  faScannerKeyboard: faScannerKeyboard,
  faCircleO: faCircleO,
  faGridHorizontal: faGridHorizontal,
  faMessageDollar: faMessageDollar,
  faCommentAltDollar: faCommentAltDollar,
  faRightLeft: faRightLeft,
  faExchangeAlt: faExchangeAlt,
  faColumns3: faColumns3,
  faPaperPlane: faPaperPlane,
  faRoadCircleExclamation: faRoadCircleExclamation,
  faDungeon: faDungeon,
  faHandHoldingBox: faHandHoldingBox,
  faInputText: faInputText,
  faWindowFlip: faWindowFlip,
  faWindowAlt: faWindowAlt,
  faAlignRight: faAlignRight,
  faScannerGun: faScannerGun,
  faScanner: faScanner,
  faTire: faTire,
  faEngine: faEngine,
  faMoneyBill1Wave: faMoneyBill1Wave,
  faMoneyBillWaveAlt: faMoneyBillWaveAlt,
  faLifeRing: faLifeRing,
  faHands: faHands,
  faSignLanguage: faSignLanguage,
  faSigning: faSigning,
  faCircleCaretRight: faCircleCaretRight,
  faCaretCircleRight: faCaretCircleRight,
  faWheat: faWheat,
  faFileSpreadsheet: faFileSpreadsheet,
  faAudioDescriptionSlash: faAudioDescriptionSlash,
  faCalendarDay: faCalendarDay,
  faWaterLadder: faWaterLadder,
  faLadderWater: faLadderWater,
  faSwimmingPool: faSwimmingPool,
  faArrowsUpDown: faArrowsUpDown,
  faArrowsV: faArrowsV,
  faChessPawnPiece: faChessPawnPiece,
  faChessPawnAlt: faChessPawnAlt,
  faFaceGrimace: faFaceGrimace,
  faGrimace: faGrimace,
  faWheelchairMove: faWheelchairMove,
  faWheelchairAlt: faWheelchairAlt,
  faTurnDown: faTurnDown,
  faLevelDownAlt: faLevelDownAlt,
  faSquareS: faSquareS,
  faRectangleBarcode: faRectangleBarcode,
  faBarcodeAlt: faBarcodeAlt,
  faPersonWalkingArrowRight: faPersonWalkingArrowRight,
  faSquareEnvelope: faSquareEnvelope,
  faEnvelopeSquare: faEnvelopeSquare,
  faDice: faDice,
  faUnicorn: faUnicorn,
  faBowlingBall: faBowlingBall,
  faPompebled: faPompebled,
  faBrain: faBrain,
  faWatchSmart: faWatchSmart,
  faBookUser: faBookUser,
  faSensorCloud: faSensorCloud,
  faSensorSmoke: faSensorSmoke,
  faClapperboardPlay: faClapperboardPlay,
  faBandage: faBandage,
  faBandAid: faBandAid,
  faCalendarMinus: faCalendarMinus,
  faCircleXmark: faCircleXmark,
  faTimesCircle: faTimesCircle,
  faXmarkCircle: faXmarkCircle,
  faCircle4: faCircle4,
  faGifts: faGifts,
  faAlbumCollection: faAlbumCollection,
  faHotel: faHotel,
  faEarthAsia: faEarthAsia,
  faGlobeAsia: faGlobeAsia,
  faIdCardClip: faIdCardClip,
  faIdCardAlt: faIdCardAlt,
  faMagnifyingGlassPlus: faMagnifyingGlassPlus,
  faSearchPlus: faSearchPlus,
  faThumbsUp: faThumbsUp,
  faCloudShowers: faCloudShowers,
  faUserClock: faUserClock,
  faOnion: faOnion,
  faClockTwelveThirty: faClockTwelveThirty,
  faArrowDownToDottedLine: faArrowDownToDottedLine,
  faHandDots: faHandDots,
  faAllergies: faAllergies,
  faFileInvoice: faFileInvoice,
  faWindowMinimize: faWindowMinimize,
  faRectangleWide: faRectangleWide,
  faCommentArrowUp: faCommentArrowUp,
  faGarlic: faGarlic,
  faMugSaucer: faMugSaucer,
  faCoffee: faCoffee,
  faBrush: faBrush,
  faTreeDecorated: faTreeDecorated,
  faMask: faMask,
  faCalendarHeart: faCalendarHeart,
  faMagnifyingGlassMinus: faMagnifyingGlassMinus,
  faSearchMinus: faSearchMinus,
  faFlower: faFlower,
  faRightLeftLarge: faRightLeftLarge,
  faRulerVertical: faRulerVertical,
  faCirclesOverlap: faCirclesOverlap,
  faUserLarge: faUserLarge,
  faUserAlt: faUserAlt,
  faStarshipFreighter: faStarshipFreighter,
  faTrainTram: faTrainTram,
  faBridgeSuspension: faBridgeSuspension,
  faTrashCheck: faTrashCheck,
  faUserNurse: faUserNurse,
  faBoombox: faBoombox,
  faSyringe: faSyringe,
  faCloudSun: faCloudSun,
  faShieldExclamation: faShieldExclamation,
  faStopwatch20: faStopwatch20,
  faSquareFull: faSquareFull,
  faGripDots: faGripDots,
  faCommentExclamation: faCommentExclamation,
  faPenSwirl: faPenSwirl,
  faFalafel: faFalafel,
  faCircle2: faCircle2,
  faMagnet: faMagnet,
  faJar: faJar,
  faGramophone: faGramophone,
  faDiceD12: faDiceD12,
  faNoteSticky: faNoteSticky,
  faStickyNote: faStickyNote,
  faDown: faDown,
  faArrowAltDown: faArrowAltDown,
  faHundredPoints: faHundredPoints,
  fa100: fa100,
  faPaperclipVertical: faPaperclipVertical,
  faWindWarning: faWindWarning,
  faWindCircleExclamation: faWindCircleExclamation,
  faLocationPinSlash: faLocationPinSlash,
  faMapMarkerSlash: faMapMarkerSlash,
  faFaceSadSweat: faFaceSadSweat,
  faBugSlash: faBugSlash,
  faCupcake: faCupcake,
  faLightSwitchOff: faLightSwitchOff,
  faToggleLargeOff: faToggleLargeOff,
  faPenFancySlash: faPenFancySlash,
  faTruckContainer: faTruckContainer,
  faBoot: faBoot,
  faArrowUpFromWaterPump: faArrowUpFromWaterPump,
  faFileCheck: faFileCheck,
  faBone: faBone,
  faCardsBlank: faCardsBlank,
  faCircle3: faCircle3,
  faBenchTree: faBenchTree,
  faKeyboardBrightnessLow: faKeyboardBrightnessLow,
  faSkiBootSki: faSkiBootSki,
  faBrainCircuit: faBrainCircuit,
  faUserInjured: faUserInjured,
  faBlockBrickFire: faBlockBrickFire,
  faFirewall: faFirewall,
  faFaceSadTear: faFaceSadTear,
  faSadTear: faSadTear,
  faPlane: faPlane,
  faTentArrowsDown: faTentArrowsDown,
  faExclamation: faExclamation,
  faArrowsSpin: faArrowsSpin,
  faFaceSmileRelaxed: faFaceSmileRelaxed,
  faCommentXmark: faCommentXmark,
  faCommentTimes: faCommentTimes,
  faPrint: faPrint,
  faTurkishLiraSign: faTurkishLiraSign,
  faTry: faTry,
  faTurkishLira: faTurkishLira,
  faFaceNoseSteam: faFaceNoseSteam,
  faCircleWaveformLines: faCircleWaveformLines,
  faWaveformCircle: faWaveformCircle,
  faDollarSign: faDollarSign,
  faDollar: faDollar,
  faUsd: faUsd,
  faFerrisWheel: faFerrisWheel,
  faComputerSpeaker: faComputerSpeaker,
  faSkullCow: faSkullCow,
  faX: faX,
  faMagnifyingGlassDollar: faMagnifyingGlassDollar,
  faSearchDollar: faSearchDollar,
  faUsersGear: faUsersGear,
  faUsersCog: faUsersCog,
  faPersonMilitaryPointing: faPersonMilitaryPointing,
  faBuildingColumns: faBuildingColumns,
  faBank: faBank,
  faInstitution: faInstitution,
  faMuseum: faMuseum,
  faUniversity: faUniversity,
  faCircleT: faCircleT,
  faSack: faSack,
  faGrid2: faGrid2,
  faCameraCctv: faCameraCctv,
  faCctv: faCctv,
  faUmbrella: faUmbrella,
  faTrowel: faTrowel,
  faHorizontalRule: faHorizontalRule,
  faBedFront: faBedFront,
  faBedAlt: faBedAlt,
  faD: faD,
  faStapler: faStapler,
  faMasksTheater: faMasksTheater,
  faTheaterMasks: faTheaterMasks,
  faKipSign: faKipSign,
  faFaceWoozy: faFaceWoozy,
  faCloudQuestion: faCloudQuestion,
  faPineapple: faPineapple,
  faHandPointLeft: faHandPointLeft,
  faGalleryThumbnails: faGalleryThumbnails,
  faCircleJ: faCircleJ,
  faEyes: faEyes,
  faHandshakeSimple: faHandshakeSimple,
  faHandshakeAlt: faHandshakeAlt,
  faPageCaretUp: faPageCaretUp,
  faFileCaretUp: faFileCaretUp,
  faJetFighter: faJetFighter,
  faFighterJet: faFighterJet,
  faComet: faComet,
  faSquareShareNodes: faSquareShareNodes,
  faShareAltSquare: faShareAltSquare,
  faShieldKeyhole: faShieldKeyhole,
  faBarcode: faBarcode,
  faPlusMinus: faPlusMinus,
  faSquareSlidersVertical: faSquareSlidersVertical,
  faSlidersVSquare: faSlidersVSquare,
  faVideo: faVideo,
  faVideoCamera: faVideoCamera,
  faMessageMiddle: faMessageMiddle,
  faCommentMiddleAlt: faCommentMiddleAlt,
  faGraduationCap: faGraduationCap,
  faMortarBoard: faMortarBoard,
  faHandHoldingMedical: faHandHoldingMedical,
  faPersonCircleCheck: faPersonCircleCheck,
  faSquareZ: faSquareZ,
  faMessageText: faMessageText,
  faCommentAltText: faCommentAltText,
  faTurnUp: faTurnUp,
  faLevelUpAlt: faLevelUpAlt
};




/***/ }),

/***/ 54933:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$X1": function() { return /* binding */ faAsterisk; },
/* harmony export */   "A8": function() { return /* binding */ faTasks; },
/* harmony export */   "AX7": function() { return /* binding */ faSpinnerThird; },
/* harmony export */   "Aq": function() { return /* binding */ faEyeSlash; },
/* harmony export */   "CGe": function() { return /* binding */ faFileCertificate; },
/* harmony export */   "CmM": function() { return /* binding */ faSort; },
/* harmony export */   "E8Q": function() { return /* binding */ faPenLine; },
/* harmony export */   "FDd": function() { return /* binding */ faCircleQuestion; },
/* harmony export */   "FGq": function() { return /* binding */ faMapMarkerAlt; },
/* harmony export */   "FL8": function() { return /* binding */ faBook; },
/* harmony export */   "FU$": function() { return /* binding */ faEnvelope; },
/* harmony export */   "FVb": function() { return /* binding */ faUsers; },
/* harmony export */   "Fuz": function() { return /* binding */ faQuestionCircle; },
/* harmony export */   "HEx": function() { return /* binding */ faSignOut; },
/* harmony export */   "ILF": function() { return /* binding */ faUser; },
/* harmony export */   "ImE": function() { return /* binding */ faEmptySet; },
/* harmony export */   "IwR": function() { return /* binding */ faPen; },
/* harmony export */   "KCX": function() { return /* binding */ faUserAstronaut; },
/* harmony export */   "KtF": function() { return /* binding */ faPlusCircle; },
/* harmony export */   "L4e": function() { return /* binding */ faStickyNote; },
/* harmony export */   "LEp": function() { return /* binding */ faCheck; },
/* harmony export */   "Mdf": function() { return /* binding */ faEye; },
/* harmony export */   "Mzg": function() { return /* binding */ faComment; },
/* harmony export */   "NBC": function() { return /* binding */ faTimes; },
/* harmony export */   "NdV": function() { return /* binding */ faUserGroup; },
/* harmony export */   "OH3": function() { return /* binding */ faSend; },
/* harmony export */   "P88": function() { return /* binding */ faBuilding; },
/* harmony export */   "QU_": function() { return /* binding */ faEuroSign; },
/* harmony export */   "SZw": function() { return /* binding */ faClock; },
/* harmony export */   "TzT": function() { return /* binding */ faPencil; },
/* harmony export */   "UL8": function() { return /* binding */ faCirclePause; },
/* harmony export */   "Uwo": function() { return /* binding */ faEllipsisVertical; },
/* harmony export */   "VE0": function() { return /* binding */ faRobot; },
/* harmony export */   "Vui": function() { return /* binding */ faTrashCan; },
/* harmony export */   "WA2": function() { return /* binding */ faCircleXmark; },
/* harmony export */   "XAH": function() { return /* binding */ faTrash; },
/* harmony export */   "XH": function() { return /* binding */ faKeynote; },
/* harmony export */   "Xf_": function() { return /* binding */ faGraduationCap; },
/* harmony export */   "Xgz": function() { return /* binding */ faNewspaper; },
/* harmony export */   "Y$T": function() { return /* binding */ faMagnifyingGlass; },
/* harmony export */   "YIN": function() { return /* binding */ faClose; },
/* harmony export */   "ZJ7": function() { return /* binding */ faDiploma; },
/* harmony export */   "Zrf": function() { return /* binding */ faList; },
/* harmony export */   "_3l": function() { return /* binding */ faFilePen; },
/* harmony export */   "_su": function() { return /* binding */ faMedal; },
/* harmony export */   "a3n": function() { return /* binding */ faCheckSquare; },
/* harmony export */   "acZ": function() { return /* binding */ faArrowLeft; },
/* harmony export */   "aj4": function() { return /* binding */ faMoneyBillWave; },
/* harmony export */   "blG": function() { return /* binding */ faColumns3; },
/* harmony export */   "byT": function() { return /* binding */ faLock; },
/* harmony export */   "cAo": function() { return /* binding */ faHeadSideHeadphones; },
/* harmony export */   "eFW": function() { return /* binding */ faArrowRight; },
/* harmony export */   "eHv": function() { return /* binding */ faExclamationTriangle; },
/* harmony export */   "eW2": function() { return /* binding */ faCaretDown; },
/* harmony export */   "f8k": function() { return /* binding */ faCheckCircle; },
/* harmony export */   "fix": function() { return /* binding */ faBadgeCheck; },
/* harmony export */   "gJF": function() { return /* binding */ faExternalLink; },
/* harmony export */   "j1w": function() { return /* binding */ faPhone; },
/* harmony export */   "jGC": function() { return /* binding */ faPercent; },
/* harmony export */   "l1h": function() { return /* binding */ faCaretUp; },
/* harmony export */   "lH_": function() { return /* binding */ faBallotCheck; },
/* harmony export */   "lXL": function() { return /* binding */ faComments; },
/* harmony export */   "m5q": function() { return /* binding */ faTrophyStar; },
/* harmony export */   "m6E": function() { return /* binding */ faBrowser; },
/* harmony export */   "m6i": function() { return /* binding */ faHeart; },
/* harmony export */   "mMr": function() { return /* binding */ faBoxHeart; },
/* harmony export */   "nYk": function() { return /* binding */ faTimesCircle; },
/* harmony export */   "pw6": function() { return /* binding */ faBookSparkles; },
/* harmony export */   "q7m": function() { return /* binding */ faDownload; },
/* harmony export */   "qQ1": function() { return /* binding */ faComputer; },
/* harmony export */   "qbi": function() { return /* binding */ faSuitcase; },
/* harmony export */   "sqG": function() { return /* binding */ faInfoCircle; },
/* harmony export */   "tMT": function() { return /* binding */ faRocket; },
/* harmony export */   "tb9": function() { return /* binding */ faPodcast; },
/* harmony export */   "u8Q": function() { return /* binding */ faThumbsUp; },
/* harmony export */   "uVn": function() { return /* binding */ faMoneyBills; },
/* harmony export */   "uzA": function() { return /* binding */ faFilmSimple; },
/* harmony export */   "w49": function() { return /* binding */ faFileCode; },
/* harmony export */   "wn1": function() { return /* binding */ faSearch; },
/* harmony export */   "yOe": function() { return /* binding */ faHandshake; },
/* harmony export */   "zBy": function() { return /* binding */ faShare; }
/* harmony export */ });
/* unused harmony exports fas, prefix, fa0, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, faFillDrip, faArrowsToCircle, faCircleChevronRight, faChevronCircleRight, faWagonCovered, faLineHeight, faBagel, faTransporter7, faAt, faRectanglesMixed, faPhoneArrowUpRight, faPhoneArrowUp, faPhoneOutgoing, faTrashAlt, faCircleL, faHeadSideGoggles, faHeadVr, faTextHeight, faUserXmark, faUserTimes, faFaceHandYawn, faGaugeSimpleMin, faTachometerSlowest, faStethoscope, faCoffin, faMessage, faCommentAlt, faSalad, faBowlSalad, faInfo, faRobotAstromech, faRingDiamond, faFonduePot, faTheta, faFaceHandPeeking, faSquareUser, faDownLeftAndUpRightToCenter, faCompressAlt, faExplosion, faFileLines, faFileAlt, faFileText, faWaveSquare, faRing, faBuildingUn, faDiceThree, faTirePressureWarning, faWifiFair, faWifi2, faCalendarDays, faCalendarAlt, faMp3Player, faAnchorCircleCheck, faTally4, faRectangleHistory, faBuildingCircleArrowRight, faVolleyball, faVolleyballBall, faSunHaze, faTextSize, faUfo, faFork, faUtensilFork, faArrowsUpToLine, faMobileSignal, faBarcodeScan, faSortDown, faSortDesc, faFolderArrowDown, faFolderDownload, faCircleMinus, faMinusCircle, faFaceIcicles, faShovel, faDoorOpen, faFilms, faRightFromBracket, faSignOutAlt, faFaceGlasses, faNfc, faAtom, faSoap, faIcons, faHeartMusicCameraBolt, faMicrophoneLinesSlash, faMicrophoneAltSlash, faClosedCaptioningSlash, faCalculatorSimple, faCalculatorAlt, faBridgeCircleCheck, faSlidersUp, faSlidersV, faLocationMinus, faMapMarkerMinus, faPumpMedical, faFingerprint, faSkiBoot, faStandardDefinition, faRectangleSd, faH1, faHandPointRight, faMagnifyingGlassLocation, faSearchLocation, faMessageBot, faForwardStep, faStepForward, faFaceSmileBeam, faSmileBeam, faLightCeiling, faMessageExclamation, faCommentAltExclamation, faBowlScoop, faBowlShavedIce, faSquareX, faUtilityPoleDouble, faFlagCheckered, faChevronsUp, faChevronDoubleUp, faFootball, faFootballBall, faUserVneck, faSchoolCircleExclamation, faCrop, faAnglesDown, faAngleDoubleDown, faUsersRectangle, faPeopleRoof, faSquareArrowRight, faArrowSquareRight, faLocationPlus, faMapMarkerPlus, faLightbulbExclamationOn, faPeopleLine, faBeerMugEmpty, faBeer, faCrateEmpty, faDiagramPredecessor, faTransporter, faCalendarCircleUser, faArrowUpLong, faLongArrowUp, faPersonCarryBox, faPersonCarry, faFireFlameSimple, faBurn, faPerson, faMale, faLaptop, faFileCsv, faMenorah, faUnion, faChevronsLeft, faChevronDoubleLeft, faCircleHeart, faHeartCircle, faTruckPlane, faRecordVinyl, faBringForward, faSquareP, faFaceGrinStars, faGrinStars, faSigma, faCameraMovie, faBong, faClarinet, faTruckFlatbed, faSpaghettiMonsterFlying, faPastafarianism, faArrowDownUpAcrossLine, faLeafHeart, faHouseBuilding, faCheeseSwiss, faSpoon, faUtensilSpoon, faJarWheat, faEnvelopesBulk, faMailBulk, faFileCircleExclamation, faBowArrow, faCartXmark, faHexagonXmark, faTimesHexagon, faXmarkHexagon, faCircleH, faHospitalSymbol, faMerge, faPager, faCartMinus, faAddressBook, faContactBook, faPanFrying, faGrid, faGrid3, faFootballHelmet, faHandLove, faTrees, faStrikethrough, faPage, faK, faDiagramPrevious, faGaugeMin, faTachometerAltSlowest, faFolderGrid, faEggplant, faRam, faLandmarkFlag, faLips, faPencilAlt, faBackward, faCaretRight, faPaste, faFileClipboard, faDesktopArrowDown, faCodePullRequest, faPumpkin, faClipboardList, faPenField, faBlueberries, faTruckRampBox, faTruckLoading, faNote, faArrowDownToSquare, faUserCheck, faCloudXmark, faVialVirus, faBookBlank, faBookAlt, faGolfFlagHole, faMessageArrowDown, faCommentAltArrowDown, faFaceUnamused, faSheetPlastic, faCircle9, faBlog, faUserNinja, faPencilSlash, faBowlingPins, faPersonArrowUpFromLine, faDownRight, faScrollTorah, faTorah, faWebhook, faBlindsOpen, faFence, faUp, faArrowAltUp, faBroomBall, faQuidditch, faQuidditchBroomBall, faDrumstick, faSquareV, faFaceAwesome, faGaveDandy, faDialOff, faToggleOff, faFaceSmileHorns, faBoxArchive, faArchive, faGrapes, faPersonDrowning, faDialMax, faCircleM, faCalendarImage, faCircleCaretDown, faCaretCircleDown, faArrowDown91, faSortNumericDesc, faSortNumericDownAlt, faFaceGrinTongueSquint, faGrinTongueSquint, faShishKebab, faSprayCan, faAlarmSnooze, faScarecrow, faTruckMonster, faGiftCard, faW, faCodePullRequestDraft, faSquareB, faElephant, faEarthAfrica, faGlobeAfrica, faRainbow, faCircleNotch, faTabletScreenButton, faTabletAlt, faPaw, faMessageQuestion, faCloud, faTrowelBricks, faSquare3, faFaceFlushed, faFlushed, faHospitalUser, faMicrowave, faChfSign, faTentArrowLeftRight, faCartCircleArrowUp, faTrashClock, faGavel, faLegal, faSprinklerCeiling, faBrowsers, faTrillium, faMusicSlash, faTruckRamp, faBinoculars, faMicrophoneSlash, faBoxTissue, faCircleC, faStarChristmas, faChartBullet, faMotorcycle, faTreeChristmas, faTireFlat, faSunglasses, faBadge, faMessagePen, faCommentAltEdit, faMessageEdit, faBellConcierge, faConciergeBell, faPenRuler, faPencilRuler, faArrowProgress, faChessRookPiece, faChessRookAlt, faSquareRoot, faAlbumCollectionCirclePlus, faPeopleArrows, faPeopleArrowsLeftRight, faFaceAngryHorns, faMarsAndVenusBurst, faTombstone, faSquareCaretRight, faCaretSquareRight, faScissors, faCut, faListMusic, faSunPlantWilt, faToiletsPortable, faHockeyPuck, faMustache, faHyphen, faTable, faUserChef, faMessageImage, faCommentAltImage, faUsersMedical, faSensorTriangleExclamation, faSensorAlert, faMagnifyingGlassArrowRight, faTachographDigital, faDigitalTachograph, faFaceMask, faPickleball, faStarSharpHalf, faUsersSlash, faClover, faMeat, faReply, faMailReply, faStarAndCrescent, faHouseFire, faSquareMinus, faMinusSquare, faHelicopter, faBird, faCompass, faSquareCaretDown, faCaretSquareDown, faHeartHalfStroke, faHeartHalfAlt, faFileCircleQuestion, faLaptopCode, faJoystick, faGrillFire, faRectangleVerticalHistory, faSwatchbook, faPrescriptionBottle, faBars, faNavicon, faKeyboardLeft, faPeopleGroup, faHourglassEnd, faHourglass3, faHeartCrack, faHeartBroken, faFaceBeamHandOverMouth, faDropletPercent, faHumidity, faSquareUpRight, faExternalLinkSquareAlt, faFaceKissBeam, faKissBeam, faCorn, faRollerCoaster, faPhotoFilmMusic, faRadar, faSickle, faFilm, faCoconut, faRulerHorizontal, faShieldCross, faCassetteTape, faSquareTerminal, faPeopleRobbery, faLightbulb, faCaretLeft, faCommentMiddle, faTrashCanList, faBlock, faCircleExclamation, faExclamationCircle, faSchoolCircleXmark, faArrowRightFromBracket, faFaceFrownSlight, faCircleChevronDown, faChevronCircleDown, faSidebarFlip, faUnlockKeyhole, faUnlockAlt, faTemperatureList, faCloudShowersHeavy, faHeadphonesSimple, faHeadphonesAlt, faSitemap, faPipeSection, faSpaceStationMoonConstruction, faSpaceStationMoonAlt, faCircleDollarToSlot, faDonate, faMemory, faFaceSleeping, faRoadSpikes, faFireBurner, faSquirrel, faArrowUpToLine, faArrowToTop, faFlag, faFaceCowboyHat, faHanukiah, faChartScatter3d, faDisplayChartUp, faSquareCode, faFeather, faVolumeLow, faVolumeDown, faXmarkToSlot, faTimesToSlot, faVoteNay, faBoxTaped, faBoxAlt, faCommentSlash, faSwords, faCloudSunRain, faAlbum, faCircleN, faCompress, faWheatAwn, faWheatAlt, faAnkh, faHandsHoldingChild, faKeySkeletonLeftRight, faCommentLines, faLuchadorMask, faLuchador, faMaskLuchador, faSquareCheck, faShredder, faBookOpenCover, faBookOpenAlt, faSandwich, faPesetaSign, faSquareParkingSlash, faParkingSlash, faTrainTunnel, faHeading, faHeader, faGhost, faFaceAnguished, faHockeySticks, faAbacus, faFilmAlt, faListSquares, faTreePalm, faSquarePhoneFlip, faPhoneSquareAlt, faCartPlus, faGamepad, faBorderCenterV, faCircleDot, faDotCircle, faClipboardMedical, faFaceDizzy, faDizzy, faEgg, faUpToLine, faArrowAltToTop, faHouseMedicalCircleXmark, faWatchFitness, faClockNineThirty, faCampground, faFolderPlus, faJug, faFutbol, faFutbolBall, faSoccerBall, faSnowBlowing, faPaintbrush, faPaintBrush, faArrowDownFromLine, faArrowFromTop, faGasPump, faSignalBarsSlash, faSignalAltSlash, faMonkey, faRectanglePro, faPro, faHouseNight, faHotTubPerson, faHotTub, faBlanket, faMapLocation, faMapMarked, faHouseFloodWater, faCommentsQuestionCheck, faTree, faArrowsCross, faBackpack, faSquareSmall, faFolderArrowUp, faFolderUpload, faBridgeLock, faCrosshairsSimple, faSackDollar, faPenToSquare, faEdit, faSquareSliders, faSlidersHSquare, faCarSide, faMessageMiddleTop, faCommentMiddleTopAlt, faLightbulbOn, faKnife, faUtensilKnife, faShareNodes, faShareAlt, faDisplayChartUpCircleDollar, faWaveSine, faHeartCircleMinus, faCircleW, faCircleCalendar, faCalendarCircle, faHourglassHalf, faHourglass2, faMicroscope, faSunset, faSink, faCalendarExclamation, faTruckContainerEmpty, faHandHeart, faBagShopping, faShoppingBag, faArrowDownZA, faSortAlphaDesc, faSortAlphaDownAlt, faMitten, faReplyClock, faReplyTime, faPersonRays, faRight, faArrowAltRight, faCircleF, faFacePleading, faFlaskVial, faPoliceBox, faCucumber, faHeadSideBrain, faHand, faHandPaper, faPersonBikingMountain, faBikingMountain, faUtensilsSlash, faPrintMagnifyingGlass, faPrintSearch, faFolderBookmark, faOm, faPi, faFlaskRoundPotion, faFlaskPotion, faFaceShush, faWorm, faHouseCircleXmark, faPlug, faCalendarCircleExclamation, faSquareI, faChevronUp, faFaceSaluting, faGaugeSimpleLow, faTachometerSlow, faFacePersevering, faCircleCamera, faCameraCircle, faHandSpock, faSpiderWeb, faCircleMicrophone, faMicrophoneCircle, faBookArrowUp, faPopsicle, faCommand, faBlinds, faStopwatch, faSaxophone, faSquare2, faFieldHockeyStickBall, faFieldHockey, faArrowUpSquareTriangle, faSortShapesUpAlt, faFaceScream, faSquareM, faCameraWeb, faWebcam, faCommentArrowDown, faLightbulbCfl, faWindowFrameOpen, faFaceKiss, faKiss, faBridgeCircleXmark, faPeriod, faFaceGrinTongue, faGrinTongue, faUpToDottedLine, faThoughtBubble, faSkeletonRibs, faRaygun, faFlute, faAcorn, faVideoArrowUpRight, faGrateDroplet, faSealExclamation, faChessBishop, faMessageSms, faCoffeeBeans, faHatWitch, faFaceGrinWink, faGrinWink, faClockThreeThirty, faEarDeaf, faDeaf, faDeafness, faHardOfHearing, faAlarmClock, faEclipse, faFaceRelieved, faRoadCircleCheck, faDiceFive, faOctagonMinus, faMinusOctagon, faSquareRss, faRssSquare, faFaceZany, faTricycle, faLandMineOn, faSquareArrowUpLeft, faICursor, faChartMixedUpCircleDollar, faSaltShaker, faStamp, faFilePlus, faDrawSquare, faToiletPaperUnderSlash, faToiletPaperReverseSlash, faStairs, faDroneFront, faDroneAlt, faGlassEmpty, faDialHigh, faUserHelmetSafety, faUserConstruction, faUserHardHat, faI, faHryvniaSign, faHryvnia, faArrowDownLeftAndArrowUpRightToCenter, faPills, faFaceGrinWide, faGrinAlt, faTooth, faBasketballHoop, faObjectsAlignBottom, faV, faSparkles, faSquid, faLeafyGreen, faCircleArrowUpRight, faCalendars, faBangladeshiTakaSign, faBicycle, faHammerWar, faCircleD, faSpiderBlackWidow, faStaffSnake, faRodAsclepius, faRodSnake, faStaffAesculapius, faPear, faHeadSideCoughSlash, faTriangle, faApartment, faTruckMedical, faAmbulance, faPepper, faPiano, faGunSquirt, faWheatAwnCircleExclamation, faSnowman, faUserAlien, faShieldCheck, faMortarPestle, faRoadBarrier, faChartCandlestick, faBriefcaseBlank, faSchool, faIgloo, faBracketRound, faParenthesis, faJoint, faHorseSaddle, faMugMarshmallows, faFilters, faBellOn, faAngleRight, faDialMed, faHorse, faQ, faMonitorWaveform, faMonitorHeartRate, faLinkSimple, faWhistle, faG, faWineGlassCrack, faFragile, faSlotMachine, faNotesMedical, faCarWash, faEscalator, faCommentImage, faTemperatureHalf, faTemperature2, faThermometer2, faThermometerHalf, faDongSign, faDonut, faDoughnut, faCapsules, faPooStorm, faPooBolt, faTally1, faFaceFrownOpen, faFrownOpen, faSquareDashed, faSquareJ, faHandPointUp, faMoneyBill, faArrowUpBigSmall, faSortSizeUp, faBarcodeRead, faBaguette, faBowlSoftServe, faFaceHoldingBackTears, faSquareUp, faArrowAltSquareUp, faTrainSubwayTunnel, faSubwayTunnel, faSquareExclamation, faExclamationSquare, faSemicolon, faBookmark, faFanTable, faAlignJustify, faBatteryLow, faBattery1, faCreditCardFront, faBrainArrowCurvedRight, faMindShare, faUmbrellaBeach, faHelmetUn, faLocationSmile, faMapMarkerSmile, faArrowLeftToLine, faArrowToLeft, faBullseye, faSushi, faNigiri, faMessageCaptions, faCommentAltCaptions, faTrashList, faBacon, faOption, faHandPointDown, faArrowUpFromBracket, faTrashPlus, faObjectsAlignTop, faFolder, faFolderBlank, faFaceAnxiousSweat, faCreditCardBlank, faFileWaveform, faFileMedicalAlt, faMicrochipAi, faMug, faPlaneUpSlash, faRadiation, faPenCircle, faBagSeedling, faChartSimple, faCrutches, faCircleParking, faParkingCircle, faMarsStroke, faLeafOak, faSquareBolt, faVial, faGauge, faDashboard, faGaugeMed, faTachometerAltAverage, faWandMagicSparkles, faMagicWandSparkles, faLambda, faE, faPizza, faBowlChopsticksNoodles, faH3, faPenClip, faPenAlt, faBridgeCircleExclamation, faBadgePercent, faSensor, faComma, faSchoolCircleCheck, faToiletPaperUnder, faToiletPaperReverse, faLightEmergency, faArrowDownToArc, faDumpster, faVanShuttle, faShuttleVan, faBuildingUser, faLightSwitch, faSquareCaretLeft, faCaretSquareLeft, faHighlighter, faWavePulse, faHeartRate, faKey, faHatSanta, faTamale, faBoxCheck, faBullhorn, faSteak, faLocationCrosshairsSlash, faLocationSlash, faPersonDolly, faGlobe, faSynagogue, faFileChartColumn, faFileChartLine, faPersonHalfDress, faFolderImage, faCalendarPen, faCalendarEdit, faRoadBridge, faFaceSmileTear, faMessagePlus, faCommentAltPlus, faLocationArrow, faC, faTabletButton, faRectangleHistoryCircleUser, faBuildingLock, faChartLineUp, faMailbox, faTruckBolt, faPizzaSlice, faChartArea, faAreaChart, faHouseFlag, faCircleThreeQuartersStroke, faPersonCircleMinus, faScalpel, faBan, faCancel, faBellExclamation, faCircleBookmark, faBookmarkCircle, faEggFried, faFaceWeary, faUniformMartialArts, faCameraRotate, faSunDust, faCommentText, faSprayCanSparkles, faAirFreshener, faSignalBars, faSignalAlt, faSignalAlt4, faSignalBarsStrong, faDiamondExclamation, faStar, faDialMin, faRepeat, faCross, faPageCaretDown, faFileCaretDown, faBox, faVenusMars, faClockSevenThirty, faArrowPointer, faMousePointer, faClockFourThirty, faSignalBarsGood, faSignalAlt3, faCactus, faLightbulbGear, faMaximize, faExpandArrowsAlt, faChargingStation, faShapes, faTriangleCircleSquare, faPlaneTail, faGaugeSimpleMax, faTachometerFastest, faCircleU, faShieldSlash, faSquarePhoneHangup, faPhoneSquareDown, faArrowUpLeft, faTransporter1, faPeanuts, faShuffle, faRandom, faPersonRunning, faRunning, faMobileRetro, faGripLinesVertical, faBinBottlesRecycle, faArrowUpFromSquare, faFileDashedLine, faPageBreak, faBracketCurlyRight, faSpider, faClockThree, faHandsBound, faScalpelLineDashed, faScalpelPath, faFileInvoiceDollar, faPipeSmoking, faFaceAstonished, faWindow, faPlaneCircleExclamation, faEar, faFileLock, faDiagramVenn, faXRay, faGoalNet, faCoffinCross, faSpellCheck, faLocationXmark, faMapMarkerTimes, faMapMarkerXmark, faCircleQuarterStroke, faLasso, faSlash, faPersonToPortal, faPortalEnter, faCalendarStar, faComputerMouse, faMouse, faArrowRightToBracket, faSignIn, faPegasus, faFilesMedical, faNfcLock, faPersonSkiLift, faSkiLift, faSquare6, faShopSlash, faStoreAltSlash, faWindTurbine, faSlidersSimple, faGridRound, faBadgeSheriff, faServer, faVirusCovidSlash, faIntersection, faShopLock, faFamily, faHourglassStart, faHourglass1, faUserHairBuns, faBlenderPhone, faHourglassClock, faPersonSeatReclined, faPaperPlaneTop, faPaperPlaneAlt, faMessageArrowUp, faCommentAltArrowUp, faLightbulbExclamation, faLayerMinus, faLayerGroupMinus, faChartPieSimpleCircleCurrency, faCircleE, faBuildingWheat, faGaugeMax, faTachometerAltFastest, faPersonBreastfeeding, faApostrophe, faFireHydrant, faRightToBracket, faSignInAlt, faVideoPlus, faSquareRight, faArrowAltSquareRight, faCommentSmile, faVenus, faPassport, faInboxIn, faInboxArrowDown, faHeartPulse, faHeartbeat, faCircle8, faCloudsMoon, faClockTenThirty, faPeopleCarryBox, faPeopleCarry, faFolderUser, faTrashCanXmark, faTemperatureHigh, faMicrochip, faLeftLongToLine, faCrown, faWeightHanging, faXmarksLines, faFilePrescription, faCalendarRange, faFlowerDaffodil, faHandBackPointUp, faWeightScale, faWeight, faStarExclamation, faBooks, faUserFriends, faArrowUpAZ, faSortAlphaUp, faLayerPlus, faLayerGroupPlus, faPlayPause, faBlockQuestion, faSnooze, faZzz, faScannerImage, faTvRetro, faSquareT, faFarm, faBarnSilo, faChessKnight, faBarsSort, faPalletBoxes, faPaletteBoxes, faPalletAlt, faFaceLaughSquint, faLaughSquint, faCodeSimple, faBoltSlash, faPanelFire, faBinaryCircleCheck, faCommentMinus, faBurrito, faViolin, faObjectsColumn, faSquareChevronDown, faChevronSquareDown, faCommentPlus, faTriangleInstrument, faTriangleMusic, faWheelchair, faUserPilotTie, faPianoKeyboard, faBedEmpty, faCircleArrowUp, faArrowCircleUp, faToggleOn, faRectangleVertical, faRectanglePortrait, faPersonWalking, faWalking, faL, faSignalStream, faDownToBracket, faCircleZ, faStars, faFire, faBedPulse, faProcedures, faHouseDay, faShuttleSpace, faSpaceShuttle, faShirtLongSleeve, faChartPieSimple, faChartPieAlt, faFaceLaugh, faLaugh, faFolderOpen, faAlbumCollectionCircleUser, faCandy, faBowlHot, faSoup, faFlatbread, faHeartCirclePlus, faCodeFork, faCity, faSignalBarsWeak, faSignalAlt1, faMicrophoneLines, faMicrophoneAlt, faClockTwelve, faPepperHot, faCitrusSlice, faSheep, faUnlock, faColonSign, faHeadset, faBadgerHoney, faH4, faStoreSlash, faRoadCircleXmark, faSignalSlash, faUserMinus, faMarsStrokeUp, faMarsStrokeV, faChampagneGlasses, faGlassCheers, faTaco, faHexagonPlus, faPlusHexagon, faClipboard, faHouseCircleExclamation, faFileArrowUp, faFileUpload, faWifi, faWifi3, faWifiStrong, faMessages, faCommentsAlt, faBath, faBathtub, faUmbrellaSimple, faUmbrellaAlt, faRectangleHistoryCirclePlus, faUnderline, faPrescriptionBottlePill, faUserPen, faUserEdit, faBinarySlash, faSquareO, faSignature, faStroopwafel, faBold, faAnchorLock, faBuildingNgo, faTransporter3, faEngineWarning, faEngineExclamation, faCircleDownRight, faSquareK, faManatSign, faMoneyCheckPen, faMoneyCheckEdit, faNotEqual, faBorderTopLeft, faBorderStyle, faMapLocationDot, faMapMarkedAlt, faTilde, faJedi, faSquarePollVertical, faPoll, faArrowDownSquareTriangle, faSortShapesDownAlt, faMugHot, faDogLeashed, faCarBattery, faBatteryCar, faFaceDowncastSweat, faMailboxFlagUp, faMemoCircleInfo, faGift, faDiceTwo, faVolume, faVolumeMedium, faTransporter5, faGaugeCircleBolt, faCoinFront, faFileSlash, faMessageArrowUpRight, faTreasureChest, faChessQueen, faPaintbrushFine, faPaintBrushAlt, faPaintBrushFine, faPaintbrushAlt, faGlasses, faHoodCloak, faSquareQuote, faUpLeft, faBringFront, faChessBoard, faBurgerCheese, faCheeseburger, faBuildingCircleCheck, faRepeat1, faArrowDownToLine, faArrowToBottom, faGrid5, faRightLongToLine, faPersonChalkboard, faMarsStrokeRight, faMarsStrokeH, faHandBackFist, faHandRock, faGridRound5, faTally, faTally5, faSquareCaretUp, faCaretSquareUp, faCloudShowersWater, faChartBar, faBarChart, faHandsBubbles, faHandsWash, faLessThanEqual, faTrain, faUpFromDottedLine, faEyeLowVision, faLowVision, faTrafficLightGo, faFaceExhaling, faSensorFire, faUserUnlock, faHexagonDivide, fa00, faCrow, faCassetteBetamax, faBetamax, faSailboat, faWindowRestore, faNfcMagnifyingGlass, faFileBinary, faCircleV, faSquarePlus, faPlusSquare, faBowlScoops, faMistletoe, faCustard, faLacrosseStick, faHockeyMask, faSunrise, faPanelEws, faToriiGate, faCloudExclamation, faMessageLines, faCommentAltLines, faFrog, faBucket, faFloppyDiskPen, faImage, faWindowFrame, faMicrophone, faCow, faFileZip, faSquareRing, faDownFromLine, faArrowAltFromTop, faShieldXmark, faShieldTimes, faScrewdriver, faCircleSortDown, faSortCircleDown, faFolderClosed, faHouseTsunami, faSquareNfi, faForklift, faArrowUpFromGroundWater, faBracketSquareRight, faMartiniGlass, faGlassMartiniAlt, faRotateLeft, faRotateBack, faRotateBackward, faUndoAlt, faTableColumns, faColumns, faSquareA, faTick, faLemon, faHeadSideMask, faGem, faDolly, faDollyBox, faSmoking, faMinimize, faCompressArrowsAlt, faRefrigerator, faMonument, faOctagonXmark, faTimesOctagon, faXmarkOctagon, faAlignSlash, faSnowplow, faAnglesRight, faAngleDoubleRight, faTruckRampCouch, faTruckCouch, faCannabis, faCirclePlay, faPlayCircle, faArrowUpRightAndArrowDownLeftFromCenter, faTablets, fa360Degrees, faEthernet, faEur, faEuro, faChair, faCircleCheck, faSquareDashedCirclePlus, faMoneySimpleFromBracket, faBat, faCircleStop, faStopCircle, faPhoneRotary, faCompassDrafting, faDraftingCompass, faPlateWheat, faCalendarCircleMinus, faChopsticks, faCarWrench, faCarMechanic, faIcicles, faPersonShelter, faNeuter, faIdBadge, faKazoo, faMarker, faBinBottles, faFaceLaughBeam, faLaughBeam, faSquareArrowDownLeft, faBatteryBolt, faTreeLarge, faHelicopterSymbol, faAperture, faUniversalAccess, faGearComplex, faFileMagnifyingGlass, faFileSearch, faUpRight, faCircleChevronUp, faChevronCircleUp, faUserPolice, faLariSign, faVolcano, faTeddyBear, faStocking, faPersonWalkingDashedLineArrowRight, faImageSlash, faMaskSnorkel, faSmoke, faSterlingSign, faGbp, faPoundSign, faBatteryExclamation, faViruses, faSquarePersonConfined, faUserTie, faArrowDownLong, faLongArrowDown, faTentArrowDownToLine, faCertificate, faCrystalBall, faReplyAll, faMailReplyAll, faPersonSkating, faSkating, faStarShooting, faBinaryLock, faFilterCircleDollar, faFunnelDollar, faCameraRetro, faCircleArrowDown, faArrowCircleDown, faCommentPen, faCommentEdit, faFileImport, faArrowRightToFile, faBanjo, faSquareArrowUpRight, faExternalLinkSquare, faLightEmergencyOn, faKerning, faBoxOpen, faSquareF, faScroll, faSpa, faArrowLeftFromLine, faArrowFromRight, faStrawberry, faLocationPinLock, faPause, faClockEightThirty, faPlaneEngines, faPlaneAlt, faHillAvalanche, faTemperatureEmpty, faTemperature0, faThermometer0, faThermometerEmpty, faBomb, faGaugeLow, faTachometerAltSlow, faRegistered, faTrashCanPlus, faAddressCard, faContactCard, faVcard, faScaleUnbalancedFlip, faBalanceScaleRight, faGlobeSnow, faSubscript, faDiamondTurnRight, faDirections, faIntegral, faBurst, faHouseLaptop, faLaptopHouse, faFaceTired, faTired, faBlindsRaised, faSmog, faUfoBeam, faCircleCaretUp, faCaretCircleUp, faUserVneckHairLong, faSquareALock, faCrutch, faGasPumpSlash, faFontAwesome, faFontAwesomeFlag, faFontAwesomeLogoFull, faCloudArrowUp, faCloudUpload, faCloudUploadAlt, faPalette, faTransporter4, faChartMixedUpCircleCurrency, faObjectsAlignRight, faArrowsTurnRight, faVest, faPig, faInboxFull, faCircleEnvelope, faEnvelopeCircle, faTrianglePersonDigging, faConstruction, faFerry, faBullseyeArrow, faArrowsDownToPeople, faSeedling, faSprout, faClockSeven, faLeftRight, faArrowsAltH, faBoxesPacking, faCircleArrowLeft, faArrowCircleLeft, faFlashlight, faGroupArrowsRotate, faBowlFood, faSquare9, faCandyCane, faArrowDownWideShort, faSortAmountAsc, faSortAmountDown, faSquareDollar, faDollarSquare, faUsdSquare, faPhoneArrowRight, faHandHoldingSeedling, faMessageCheck, faCommentAltCheck, faCloudBolt, faThunderstorm, faChartLineUpDown, faTextSlash, faRemoveFormat, faWatch, faCircleDownLeft, faText, faProjector, faFaceSmileWink, faSmileWink, faTombstoneBlank, faTombstoneAlt, faChessKingPiece, faChessKingAlt, faCircle6, faLeft, faArrowAltLeft, faFileWord, faFilePowerpoint, faSquareDown, faArrowAltSquareDown, faObjectsAlignCenterVertical, faArrowsLeftRight, faArrowsH, faHouseLock, faCloudArrowDown, faCloudDownload, faCloudDownloadAlt, faWreath, faChildren, faMeterDroplet, faChalkboard, faBlackboard, faUserLargeSlash, faUserAltSlash, faSignalStrong, faSignal4, faLollipop, faLollypop, faListTree, faEnvelopeOpen, faDrawCircle, faCatSpace, faHandshakeSimpleSlash, faHandshakeAltSlash, faRabbitRunning, faRabbitFast, faMemoPad, faMattressPillow, faAlarmPlus, faAlicorn, faCommentQuestion, faGingerbreadMan, faGuaraniSign, faBurgerFries, faMugTea, faBorderTop, faArrowsRotate, faRefresh, faSync, faCircleBookOpen, faBookCircle, faArrowsToDottedLine, faFireExtinguisher, faGarageOpen, faShelvesEmpty, faCruzeiroSign, faWatchApple, faWatchCalculator, faListDropdown, faCabinetFiling, faBurgerSoda, faSquareArrowUp, faArrowSquareUp, faGreaterThanEqual, faPalletBox, faFaceConfounded, faShieldHalved, faShieldAlt, faTruckPlow, faBookAtlas, faAtlas, faVirus, faGridRound2, faCommentMiddleTop, faEnvelopeCircleCheck, faLayerGroup, faRestroomSimple, faArrowsToDot, faBorderOuter, faHashtagLock, faClockTwoThirty, faArchway, faHeartCircleCheck, faHouseChimneyCrack, faHouseDamage, faFileZipper, faFileArchive, faHeartHalf, faCommentCheck, faSquare, faMemo, faMartiniGlassEmpty, faGlassMartini, faCouch, faCediSign, faItalic, faGlassCitrus, faCalendarLinesPen, faChurch, faPersonSnowmobiling, faSnowmobile, faFaceHushed, faCommentsDollar, faPickaxe, faLinkSimpleSlash, faDemocrat, faFaceConfused, faPinball, faZ, faPersonSkiing, faSkiing, faDeer, faInputPipe, faRoadLock, faA, faBookmarkSlash, faTemperatureArrowDown, faTemperatureDown, faMace, faFeatherPointed, faFeatherAlt, faSausage, faTrashCanClock, faP, faBroomWide, faSnowflake, faStomach, faRectangleAd, faAd, faGuitarElectric, faArrowTurnDownRight, faMoonCloud, faBreadSliceButter, faCircleArrowRight, faArrowCircleRight, faUserGroupCrown, faUsersCrown, faCircleI, faToiletPaperCheck, faFilterCircleXmark, faLocust, faUnsorted, faListOl, faList12, faListNumeric, faChartWaterfall, faSparkle, faFaceParty, faKidneys, faWifiExclamation, faChartNetwork, faPersonDressBurst, faDiceD4, faMoneyCheckDollar, faMoneyCheckAlt, faVectorSquare, faBreadSlice, faLanguage, faWheatAwnSlash, faFaceKissWinkHeart, faKissWinkHeart, faDagger, faPodium, faMemoCircleCheck, faRouteHighway, faDownToLine, faArrowAltToBottom, faFilter, faSquareG, faCirclePhone, faPhoneCircle, faClipboardPrescription, faUserNurseHair, faQuestion, faFileSignature, faToggleLargeOn, faUpDownLeftRight, faArrowsAlt, faDryerHeat, faDryerAlt, faHouseChimneyUser, faHandHoldingHeart, faArrowUpSmallBig, faSortSizeUpAlt, faTrainTrack, faPuzzlePiece, faMoneyCheck, faStarHalfStroke, faStarHalfAlt, faFileExclamation, faCode, faWhiskeyGlass, faGlassWhiskey, faMoonStars, faBuildingCircleExclamation, faClothesHanger, faMobileNotch, faMobileIphone, faMagnifyingGlassChart, faArrowUpRightFromSquare, faCubesStacked, faImagesUser, faWonSign, faKrw, faWon, faImagePolaroidUser, faVirusCovid, faSquareEllipsis, faPie, faChessKnightPiece, faChessKnightAlt, faAustralSign, faCloudPlus, faF, faLeaf, faBedBunk, faRoad, faTaxi, faCab, faPersonCirclePlus, faChartPie, faPieChart, faBoltLightning, faClockEight, faSackXmark, faFileExcel, faFileContract, faFishFins, faCircleQ, faBuildingFlag, faFaceGrinBeam, faGrinBeam, faObjectUngroup, faFaceDisguise, faCircleArrowDownRight, faAlien8bit, faAlienMonster, faHandPointRibbon, faPoop, faObjectExclude, faTelescope, faLocationPin, faMapMarker, faSquareList, faKaaba, faToiletPaper, faHelmetSafety, faHardHat, faHatHard, faCommentCode, faSimCards, faStarship, faEject, faCircleRight, faArrowAltCircleRight, faPlaneCircleCheck, faSeal, faUserCowboy, faHexagonVerticalNft, faFaceRollingEyes, faMehRollingEyes, faBreadLoaf, faRingsWedding, faObjectGroup, faFrenchFries, faChartLine, faLineChart, faCalendarArrowDown, faCalendarDownload, faSendBack, faMaskVentilator, faSignatureLock, faSignsPost, faMapSigns, faOctagonPlus, faPlusOctagon, faCashRegister, faPersonCircleQuestion, faMelonSlice, faSpaceStationMoon, faMessageSmile, faCommentAltSmile, faCupStraw, faLeftFromLine, faArrowAltFromRight, faH, faBasketShoppingSimple, faShoppingBasketAlt, faHandsHoldingHeart, faHandsHeart, faClockNine, faTarp, faFaceSleepy, faHandHorns, faScrewdriverWrench, faTools, faArrowsToEye, faCircleThreeQuarters, faTrophyAlt, faPlugCircleBolt, faFaceThermometer, faGridRound4, faShirtRunning, faBookCircleArrowUp, faFaceNauseated, faFileChartPie, faMarsAndVenus, faHouseUser, faHomeUser, faCircleArrowDownLeft, faDumpsterFire, faHexagonMinus, faMinusHexagon, faLeftToLine, faArrowAltToLeft, faHouseCrack, faPawSimple, faPawAlt, faArrowLeftLongToLine, faBracketsRound, faParentheses, faMartiniGlassCitrus, faCocktail, faUserShakespeare, faArrowRightToArc, faFaceSurprise, faSurprise, faBottleWater, faPauseCircle, faGaugeCirclePlus, faFolders, faAngel, faValueAbsolute, faRabbit, faToiletPaperSlash, faCircleEuro, faAppleWhole, faAppleAlt, faKitchenSet, faDiamondHalf, faLockKeyhole, faLockAlt, faR, faTemperatureQuarter, faTemperature1, faThermometer1, faThermometerQuarter, faSquareInfo, faInfoSquare, faWifiSlash, faToiletPaperXmark, faHandsHoldingDollar, faHandsUsd, faCube, faArrowDownTriangleSquare, faSortShapesDown, faBitcoinSign, faShutters, faShieldDog, faSolarPanel, faLockOpen, faTableTree, faHouseChimneyHeart, faTally3, faElevator, faMoneyBillTransfer, faMoneyBillTrendUp, faHouseFloodWaterCircleArrowRight, faSquarePollHorizontal, faPollH, faCircle, faCartCircleExclamation, faSword, faBackwardFast, faFastBackward, faRecycle, faInterrobang, faPlaneSlash, faCircleDashed, faTrademark, faBasketball, faBasketballBall, faForkKnife, faUtensilsAlt, faSatelliteDish, faCircleUp, faArrowAltCircleUp, faSlider, faMobileScreenButton, faMobileAlt, faClockOneThirty, faInboxOut, faInboxArrowUp, faCloudSlash, faVolumeHigh, faVolumeUp, faUsersRays, faWallet, faOctagonCheck, faFlatbreadStuffed, faClipboardCheck, faCartCirclePlus, faTruckClock, faShippingTimed, faPool8Ball, faFileAudio, faTurnDownLeft, faLockHashtag, faChartRadar, faStaff, faBurger, faHamburger, faUtilityPole, faTransporter6, faWrench, faBugs, faVectorPolygon, faDiagramNested, faRupeeSign, faRupee, faFileImage, faImageUser, faBuoy, faPlaneDeparture, faHandshakeSlash, faBookBookmark, faBorderCenterH, faCanFood, faTypewriter, faArrowRightFromArc, faCircleK, faFaceHandOverMouth, faPopcorn, faHouseWater, faHouseFlood, faObjectSubtract, faCodeBranch, faWarehouseFull, faWarehouseAlt, faHatCowboy, faBridge, faPhoneFlip, faPhoneAlt, faArrowDownFromDottedLine, faFileDoc, faSquareQuarters, faTruckFront, faCat, faTrashXmark, faCircleCaretLeft, faCaretCircleLeft, faFiles, faAnchorCircleExclamation, faFaceClouds, faUserCrown, faTruckField, faRoute, faCartCircleCheck, faClipboardQuestion, faPanorama, faCommentMedical, faTeethOpen, faUserTieHairLong, faFileCircleMinus, faHeadSideMedical, faTags, faWineGlass, faForwardFast, faFastForward, faFaceMehBlank, faMehBlank, faUserRobot, faSquareParking, faParking, faCardDiamond, faFaceZipper, faFaceRaisedEyebrow, faHouseSignal, faSquareChevronUp, faChevronSquareUp, faNfcSymbol, faBarsProgress, faTasksAlt, faFaucetDrip, faArrowsToLine, faDolphin, faArrowUpRight, faCircleR, faCartFlatbed, faDollyFlatbed, faBanSmoking, faSmokingBan, faCircleSortUp, faSortCircleUp, faTerminal, faMobileButton, faHouseMedicalFlag, faBasketShopping, faShoppingBasket, faTape, faChestnut, faBusSimple, faBusAlt, faFaceSadCry, faSadCry, faHeat, faTicketAirline, faBootHeeled, faArrowsMinimize, faCompressArrows, faAudioDescription, faPersonMilitaryToPerson, faFileShield, faHexagon, faManhole, faUserSlash, faTowerObservation, faFloppyDisks, faToiletPaperBlankUnder, faToiletPaperReverseAlt, faSignal, faSignal5, faSignalPerfect, faPump, faBus, faHeartCircleXmark, faArrowUpLeftFromCircle, faHouseChimney, faHomeLg, faWindowMaximize, faDryer, faFaceFrown, faFrown, faChessBishopPiece, faChessBishopAlt, faShirtTankTop, faScrollRibbon, faScreencast, faWalker, faPrescription, faShop, faStoreAlt, faFloppyDisk, faSave, faVihara, faFaceKissClosedEyes, faScaleUnbalanced, faBalanceScaleLeft, faFileUser, faUserPoliceTie, faFaceTongueMoney, faTennisBall, faSquareL, faSortUp, faSortAsc, faCalendarArrowUp, faCalendarUpload, faCommentDots, faCommenting, faPlantWilt, faScarf, faAlbumCirclePlus, faUserNurseHairLong, faDiamond, faSquareLeft, faArrowAltSquareLeft, faFaceGrinSquint, faGrinSquint, faCircleEllipsisVertical, faHandHoldingDollar, faHandHoldingUsd, faGridDividers, faBacterium, faHandPointer, faDrumSteelpan, faHandScissors, faHandsPraying, faPrayingHands, faFacePensive, faUserMusic, faArrowRotateRight, faArrowRightRotate, faArrowRotateForward, faRedo, faMessagesDollar, faCommentsAltDollar, faSensorOn, faBalloon, faBiohazard, faChessQueenPiece, faChessQueenAlt, faLocationCrosshairs, faLocation, faMarsDouble, faHousePersonLeave, faHouseLeave, faHousePersonDepart, faRulerTriangle, faCardClub, faChildDress, faUsersBetweenLines, faLungsVirus, faFaceGrinTears, faGrinTears, faComputerMouseScrollwheel, faMouseAlt, faCalendarXmark, faCalendarTimes, faChildReaching, faTableLayout, faNarwhal, faRampLoading, faCalendarCirclePlus, faToothbrush, faBorderInner, faPawClaws, faKiwiFruit, faTrafficLightSlow, faRectangleCode, faHeadSideVirus, faKeyboardBrightness, faBooksMedical, faLightbulbSlash, faHouseBlank, faHomeBlank, faSquare5, faSquareHeart, faHeartSquare, faPuzzle, faUserGear, faUserCog, faPipeCircleCheck, faArrowUp19, faSortNumericUp, faOctagonExclamation, faDialLow, faDoorClosed, faLaptopMobile, faPhoneLaptop, faConveyorBeltBoxes, faConveyorBeltAlt, faShieldVirus, faStarfighterTwinIonEngineAdvanced, faStarfighterAltAdvanced, faDiceSix, faStarfighterTwinIonEngine, faStarfighterAlt, faRocketLaunch, faMosquitoNet, faVentDamper, faBridgeWater, faBanBug, faDebug, faPersonBooth, faTextWidth, faGarageCar, faSquareKanban, faHatWizard, faPenFancy, faCoffeePot, faMouseField, faPersonDigging, faDigging, faShowerDown, faShowerAlt, faBoxCircleCheck, faBrightness, faCarSideBolt, faOrnament, faPhoneArrowDownLeft, faPhoneArrowDown, faPhoneIncoming, faCloudWord, faHandFingersCrossed, faGaugeSimple, faGaugeSimpleMed, faTachometerAverage, faArrowDownSmallBig, faSortSizeDownAlt, faBookMedical, faFaceMelting, faPoo, faPenClipSlash, faPenAltSlash, faQuoteRight, faQuoteRightAlt, faScrollOld, faGuitars, faPhoneXmark, faHose, faClockSix, faShirt, faTShirt, faTshirt, faBillboard, faSquareR, faCubes, faEnvelopeOpenDollar, faDivide, faSunCloud, faLampFloor, faSquare7, faTengeSign, faTenge, faHeadphones, faHandsHolding, faCampfire, faCircleAmpersand, faSnowflakes, faHandsClapping, faRepublican, faLeafMaple, faPersonCircleXmark, faRuler, faCupStrawSwoosh, faTemperatureSun, faTemperatureHot, faAlignLeft, faDiceD6, faRestroom, faHighDefinition, faRectangleHd, faJ, faGalaxy, faUsersViewfinder, faFileVideo, faCherries, faUpRightFromSquare, faExternalLinkAlt, faCircleSort, faSortCircle, faTableCells, faTh, faFilePdf, faSiren, faArrowUpToDottedLine, faImageLandscape, faLandscape, faTankWater, faCurlingStone, faCurling, faGamepadModern, faGamepadAlt, faMessagesQuestion, faBookBible, faBible, faO, faSuitcaseMedical, faMedkit, faBriefcaseArrowRight, faExpandWide, faClockElevenThirty, faRv, faUserSecret, faOtter, faDreidel, faPersonDress, faFemale, faCommentDollar, faBusinessTime, faBriefcaseClock, faFlowerTulip, faPeoplePantsSimple, faCloudDrizzle, faTableCellsLarge, faThLarge, faBookTanakh, faTanakh, faSolarSystem, faSealQuestion, faPhoneVolume, faVolumeControlPhone, faDiscDrive, faHatCowboySide, faTableRows, faRows, faLocationExclamation, faMapMarkerExclamation, faFaceFearful, faClipboardUser, faBusSchool, faFilmSlash, faSquareArrowDownRight, faBookSpells, faWashingMachine, faWasher, faChild, faLiraSign, faUserVisor, faFilePlusMinus, faChessClockFlip, faChessClockAlt, faSatellite, faPlaneLock, faSteeringWheel, faTag, faStretcher, faBookSection, faBookLaw, faInboxes, faCoffeeBean, faCircleYen, faBracketsCurly, faEllipsisStrokeVertical, faEllipsisVAlt, faSquare1, faCakeCandles, faBirthdayCake, faCake, faHeadSide, faDollyEmpty, faFaceTissue, faAnglesUp, faAngleDoubleUp, faBinRecycle, faPaperclip, faChartLineDown, faArrowRightToCity, faLockA, faRibbon, faLungs, faPersonPinball, faArrowUp91, faSortNumericUpAlt, faAppleCore, faCircleY, faH6, faLitecoinSign, faCircleSmall, faBorderNone, faArrowTurnDownLeft, faCircleNodes, faParachuteBox, faMessageMedical, faCommentAltMedical, faRugbyBall, faCommentMusic, faIndent, faTreeDeciduous, faTreeAlt, faPuzzlePieceSimple, faPuzzlePieceAlt, faTruckFieldUn, faNfcTrash, faHourglass, faHourglassEmpty, faMountain, faFileXmark, faFileTimes, faHouseHeart, faHomeHeart, faHouseChimneyBlank, faMeterBolt, faUserDoctor, faUserMd, faSlashBack, faCircleInfo, faFishingRod, faHammerCrash, faMessageHeart, faCloudMeatball, faCameraPolaroid, faCamera, faCameraAlt, faSquareVirus, faCartArrowUp, faMeteor, faCarOn, faSleigh, faArrowDown19, faSortNumericAsc, faSortNumericDown, faBuoyMooring, faSquare4, faHandHoldingDroplet, faHandHoldingWater, faTricycleAdult, faWaveform, faWater, faStarSharpHalfStroke, faStarSharpHalfAlt, faNfcSignal, faPlaneProp, faCalendarCheck, faClockDesk, faCalendarClock, faCalendarTime, faBraille, faPrescriptionBottleMedical, faPrescriptionBottleAlt, faPlateUtensils, faFamilyPants, faHoseReel, faHouseWindow, faLandmark, faTruck, faCrosshairs, faCloudRainbow, faPersonCane, faAlien, faTent, faLaptopBinary, faVestPatches, faPeopleDressSimple, faCheckDouble, faArrowDownAZ, faSortAlphaAsc, faSortAlphaDown, faBowlingBallPin, faBellSchoolSlash, faPlusLarge, faMoneyBillWheat, faCameraViewfinder, faScreenshot, faMessageMusic, faCommentAltMusic, faCarBuilding, faBorderBottomRight, faBorderStyleAlt, faOctagon, faCommentArrowUpRight, faOctagonDivide, faCookie, faArrowRotateLeft, faArrowLeftRotate, faArrowRotateBack, faArrowRotateBackward, faUndo, faTvMusic, faHardDrive, faHdd, faReel, faFaceGrinSquintTears, faGrinSquintTears, faDumbbell, faRectangleList, faListAlt, faTarpDroplet, faAlarmExclamation, faHouseMedicalCircleCheck, faTrafficCone, faGrate, faArrowDownRight, faPersonSkiingNordic, faSkiingNordic, faCalendarPlus, faPersonFromPortal, faPortalExit, faPlaneArrival, faCowbellCirclePlus, faCowbellMore, faCircleLeft, faArrowAltCircleLeft, faDistributeSpacingVertical, faSignalBarsFair, faSignalAlt2, faSportsball, faGameConsoleHandheldCrank, faTrainSubway, faSubway, faChartGantt, faFaceSmileUpsideDown, faBallPile, faBadgeDollar, faMoneyBillsSimple, faMoneyBillsAlt, faListTimeline, faIndianRupeeSign, faIndianRupee, faInr, faCropSimple, faCropAlt, faMoneyBill1, faMoneyBillAlt, faLeftLong, faLongArrowAltLeft, faKeyboardDown, faCircleUpRight, faCloudBoltMoon, faThunderstormMoon, faDna, faVirusSlash, faBracketRoundRight, faCircleSterling, faCircle5, faMinus, faSubtract, faFireFlame, faFlame, faRightToLine, faArrowAltToRight, faGif, faChess, faTrashSlash, faArrowLeftLong, faLongArrowLeft, faPlugCircleCheck, faFontCase, faStreetView, faArrowDownLeft, faFrancSign, faFlaskRoundPoison, faFlaskPoison, faVolumeOff, faBookCircleArrowRight, faChartUser, faUserChart, faHandsAslInterpreting, faAmericanSignLanguageInterpreting, faAslInterpreting, faHandsAmericanSignLanguageInterpreting, faPresentationScreen, faPresentation, faCircleBolt, faFaceSmileHalo, faCartCircleArrowDown, faHousePersonReturn, faHousePersonArrive, faHouseReturn, faMessageXmark, faCommentAltTimes, faMessageTimes, faFileAward, faUserDoctorHairLong, faCameraSecurity, faCameraHome, faGear, faCog, faDropletSlash, faTintSlash, faBookHeart, faMosque, faDuck, faMosquito, faStarOfDavid, faFlagSwallowtail, faFlagAlt, faPersonMilitaryRifle, faCarGarage, faCartShopping, faShoppingCart, faBookFont, faShieldPlus, faVials, faEyeDropperFull, faDistributeSpacingHorizontal, faTabletRugged, faTemperatureSnow, faTemperatureFrigid, faMoped, faFaceSmilePlus, faSmilePlus, faRadioTuner, faRadioAlt, faFaceSwear, faWaterArrowDown, faWaterLower, faScannerTouchscreen, faCircle7, faPlugCirclePlus, faPersonSkiJumping, faSkiJump, faPlaceOfWorship, faWaterArrowUp, faWaterRise, faWaveformLines, faWaveformPath, faSplit, faFilmCanister, faFilmCannister, faFolderXmark, faFolderTimes, faToiletPaperBlank, faToiletPaperAlt, faTabletScreen, faTabletAndroidAlt, faHexagonVerticalNftSlanted, faFolderMusic, faDisplayMedical, faDesktopMedical, faShareAll, faPeapod, faChessClock, faAxe, faSquareD, faGripVertical, faMobileSignalOut, faArrowTurnUp, faLevelUp, faU, faArrowUpFromDottedLine, faSquareRootVariable, faSquareRootAlt, faLightSwitchOn, faArrowDownArrowUp, faSortAlt, faRaindrops, faDash, faMinusLarge, faClockFour, faInputNumeric, faTruckTow, faBackwardStep, faStepBackward, faPallet, faCarBolt, faArrowsMaximize, faExpandArrows, faFaucet, faCloudSleet, faLampStreet, faListRadio, faPenNibSlash, faBaseballBatBall, faSquareUpLeft, faOverline, faS, faTimeline, faKeyboard, faArrowsFromDottedLine, faUsbDrive, faBallot, faLocationDotSlash, faMapMarkerAltSlash, faCards, faHouseChimneyMedical, faClinicMedical, faBoxingGlove, faGloveBoxing, faTemperatureThreeQuarters, faTemperature3, faThermometer3, faThermometerThreeQuarters, faBellSchool, faMobileScreen, faMobileAndroidAlt, faPlaneUp, faFolderHeart, faCircleLocationArrow, faLocationCircle, faFaceHeadBandage, faSushiRoll, faMakiRoll, faMakizushi, faCarBump, faPiggyBank, faRacquet, faCarMirrors, faIndustryWindows, faIndustryAlt, faBoltAuto, faBatteryHalf, faBattery3, faFluxCapacitor, faMountainCity, faCoins, faHoneyPot, faOlive, faKhanda, faFilterList, faOutlet, faSliders, faSlidersH, faCauldron, faPeople, faFolderTree, faNetworkWired, faCroissant, faMapPin, faHamsa, faCentSign, faSwordsLaser, faFlask, faPersonPregnant, faSquareU, faWandSparkles, faRouter, faEllipsisV, faSwordLaserAlt, faTicket, faPowerOff, faCoin, faLaptopSlash, faRightLong, faLongArrowAltRight, faCircleB, faPersonDressSimple, faPipeCollar, faLightsHoliday, faCitrus, faFlagUsa, faLaptopFile, faTty, faTeletype, faChartTreeMap, faDiagramNext, faPersonRifle, faClockFiveThirty, faPipeValve, faArrowUpFromArc, faFaceSpiralEyes, faCompressWide, faCirclePhoneHangup, faPhoneCircleDown, faGearComplexCode, faHouseMedicalCircleExclamation, faBadminton, faClosedCaptioning, faPersonHiking, faHiking, faRightFromLine, faArrowAltFromLeft, faVenusDouble, faImages, faCalculator, faShuttlecock, faUserHair, faEyeEvil, faPeoplePulling, faN, faGarage, faCableCar, faTram, faShovelSnow, faCloudRain, faFaceLying, faSprinkler, faBuildingCircleXmark, faPersonSledding, faSledding, faGameConsoleHandheld, faShip, faClockSixThirty, faBatterySlash, faTugrikSign, faArrowsDownToLine, faShelves, faInventory, faCloudSnow, faFaceGrin, faGrin, faDeleteLeft, faBackspace, faOven, faCloudBinary, faEyeDropper, faEyeDropperEmpty, faEyedropper, faCommentCaptions, faCommentsQuestion, faScribble, faRotateExclamation, faFileCircleCheck, faGlass, faLoader, faForward, faUserPilot, faMobile, faMobileAndroid, faMobilePhone, faCodePullRequestClosed, faFaceMeh, faMeh, faAlignCenter, faBookSkull, faBookDead, faIdCard, faDriversLicense, faFaceDotted, faFaceWorried, faOutdent, faDedent, faHeartCircleExclamation, faHouse, faHome, faHomeAlt, faHomeLgAlt, faVectorCircle, faCarCircleBolt, faCalendarWeek, faFlyingDisc, faLaptopMedical, faSquareDownRight, faB, faSeatAirline, faMoonOverSun, faEclipseAlt, faPipe, faFileMedical, faPotato, faDiceOne, faCircleA, faHelmetBattle, faButter, faBlanketFire, faKiwiBird, faCastle, faGolfClub, faArrowRightArrowLeft, faExchange, faRotateRight, faRedoAlt, faRotateForward, faUtensils, faCutlery, faArrowUpWideShort, faSortAmountUp, faChartPieSimpleCircleDollar, faBalloons, faMillSign, faBowlRice, faTimelineArrow, faSkull, faGameBoardSimple, faGameBoardAlt, faCircleVideo, faVideoCircle, faChartScatterBubble, faHouseTurret, faBanana, faHandHoldingSkull, faPeopleDress, faLoveseat, faCouchSmall, faTowerBroadcast, faBroadcastTower, faTruckPickup, faBlockQuote, faUpLong, faLongArrowAltUp, faStop, faCodeMerge, faMoneyCheckDollarPen, faMoneyCheckEditAlt, faUpFromLine, faArrowAltFromBottom, faUpload, faHurricane, faGridRound2Plus, faPeoplePants, faMound, faWindsock, faCircleHalf, faBrakeWarning, faToiletPortable, faCompactDisc, faFileArrowDown, faFileDownload, faSaxophoneFire, faSaxHot, faCameraWebSlash, faWebcamSlash, faFolderMedical, faFolderGear, faFolderCog, faHandWave, faArrowUpArrowDown, faSortUpDown, faCaravan, faShieldCat, faMessageSlash, faCommentAltSlash, faBolt, faZap, faTrashCanCheck, faGlassWater, faOilWell, faPersonSimple, faVault, faMars, faToilet, faPlaneCircleXmark, faYenSign, faCny, faJpy, faRmb, faYen, faGearCode, faNotes, faRubleSign, faRouble, faRub, faRuble, faTrashUndo, faTrashArrowTurnLeft, faChampagneGlass, faGlassChampagne, faObjectsAlignCenterHorizontal, faSun, faTrashCanSlash, faTrashAltSlash, faScreenUsers, faUsersClass, faGuitar, faSquareArrowLeft, faArrowSquareLeft, faSquare8, faFaceSmileHearts, faBracketsSquare, faBrackets, faLaptopArrowDown, faHockeyStickPuck, faHouseTree, faSignalFair, faSignal2, faFaceLaughWink, faLaughWink, faCircleDollar, faDollarCircle, faUsdCircle, faHorseHead, faArrowsRepeat, faRepeatAlt, faBoreHole, faIndustry, faImagePolaroid, faWaveTriangle, faPersonRunningFast, faCircleDown, faArrowAltCircleDown, faGrill, faArrowsTurnToDots, faChartMixed, faAnalytics, faFlorinSign, faArrowDownShortWide, faSortAmountDesc, faSortAmountDownAlt, faLessThan, faDisplayCode, faDesktopCode, faFaceDrooling, faOilTemperature, faOilTemp, faSquareQuestion, faQuestionSquare, faAirConditioner, faAngleDown, faMountains, faOmega, faCarTunnel, faPersonDollyEmpty, faPanFood, faHeadSideCough, faGripLines, faThumbsDown, faUserLock, faArrowRightLong, faLongArrowRight, faTicketsAirline, faAnchorCircleXmark, faEllipsis, faEllipsisH, faNfcSlash, faChessPawn, faKitMedical, faFirstAid, faGrid2Plus, faBells, faPersonThroughWindow, faToolbox, faEnvelopeDot, faEnvelopeBadge, faHandsHoldingCircle, faBug, faBowlChopsticks, faCreditCard, faCreditCardAlt, faCircleS, faBoxBallot, faCar, faAutomobile, faHandHoldingHand, faUserTieHair, faPodiumStar, faUserHairMullet, faBusinessFront, faPartyBack, faTrianBalbot, faMicrophoneStand, faBookOpenReader, faBookReader, faFamilyDress, faCircleX, faCabin, faMountainSun, faChartSimpleHorizontal, faBluetooth, faArrowsLeftRightToLine, faHandBackPointLeft, faMessageDots, faCommentAltDots, faMessaging, faFileHeart, faBeerMug, faBeerFoam, faDiceD20, faDrone, faTruckDroplet, faFileCircleXmark, faTemperatureArrowUp, faTemperatureUp, faBed, faBookCopy, faSquareH, faHSquare, faSquareC, faClockTwo, faSquareEllipsisVertical, faCalendarUsers, faBee, faTemperatureFull, faTemperature4, faThermometer4, faThermometerFull, faBell, faCandyBar, faChocolateBar, faXmarkLarge, faPinata, faArrowsFromLine, faSuperscript, faBowlSpoon, faHexagonCheck, faPlugCircleXmark, faStarOfLife, faPhoneSlash, faTrafficLightStop, faPaintRoller, faAccentGrave, faHandshakeAngle, faHandsHelping, faCircle0, faDialMedLow, faLocationDot, faCrab, faBoxOpenFull, faBoxFull, faFile, faGreaterThan, faQuotes, faPretzel, faPersonSwimming, faSwimmer, faArrowDown, faUserRobotXmarks, faMessageQuote, faCommentAltQuote, faCandyCorn, faFolderMagnifyingGlass, faFolderSearch, faNotebook, faDroplet, faTint, faBullseyePointer, faEraser, faHexagonImage, faEarthAmericas, faEarth, faEarthAmerica, faGlobeAmericas, faCrateApple, faAppleCrate, faPersonBurst, faGameBoard, faHatChef, faHandBackPointRight, faDove, faSnowflakeDroplets, faBatteryEmpty, faBattery0, faGrid4, faSocks, faFaceSunglasses, faInbox, faSquare0, faSection, faSquareThisWayUp, faBoxUp, faGaugeHigh, faTachometerAlt, faTachometerAltFast, faSquareAmpersand, faEnvelopeOpenText, faLampDesk, faHospital, faHospitalAlt, faHospitalWide, faPollPeople, faWhiskeyGlassIce, faGlassWhiskeyRocks, faWineBottle, faChessRook, faUserBountyHunter, faBarsStaggered, faReorder, faStream, faDiagramSankey, faCloudHailMixed, faCircleUpLeft, faDharmachakra, faObjectsAlignLeft, faOilCanDrip, faFaceSmilingHands, faBroccoli, faRouteInterstate, faEarMuffs, faHotdog, faTransporterEmpty, faPersonWalkingWithCane, faBlind, faAngle90, faRectangleTerminal, faKite, faDrum, faScrubber, faIceCream, faHeartCircleBolt, faFishBones, faDeerRudolph, faFax, faParagraph, faHeadSideHeart, faSquareE, faMeterFire, faCloudHail, faCheckToSlot, faVoteYea, faMoneyFromBracket, faStarHalf, faCarBus, faSpeaker, faTimer, faBoxesStacked, faBoxes, faBoxesAlt, faGrillHot, faLink, faChain, faEarListen, faAssistiveListeningSystems, faFileMinus, faTreeCity, faPlay, faFont, faCupTogo, faCoffeeTogo, faSquareDownLeft, faBurgerLettuce, faRupiahSign, faTableTennisPaddleBall, faPingPongPaddleBall, faTableTennis, faPersonDotsFromLine, faDiagnoses, faChevronsDown, faChevronDoubleDown, faTrashCanArrowUp, faTrashRestoreAlt, faSignalGood, faSignal3, faLocationQuestion, faMapMarkerQuestion, faFloppyDiskCircleXmark, faFloppyDiskTimes, faSaveCircleXmark, faSaveTimes, faNairaSign, faPeach, faTaxiBus, faBracketCurly, faBracketCurlyLeft, faLobster, faCartFlatbedEmpty, faDollyFlatbedEmpty, faColon, faCartArrowDown, faWand, faWalkieTalkie, faFileEdit, faReceipt, faTablePicnic, faSquarePen, faPenSquare, faPencilSquare, faCircleMicrophoneLines, faMicrophoneCircleAlt, faDisplaySlash, faDesktopSlash, faSuitcaseRolling, faPersonCircleExclamation, faTransporter2, faHandsHoldingDiamond, faHandReceiving, faMoneyBillSimpleWave, faChevronDown, faBatteryFull, faBattery, faBattery5, faBellPlus, faBookArrowRight, faHospitals, faClub, faSkullCrossbones, faDropletDegree, faDewpoint, faCodeCompare, faListUl, faListDots, faHandHoldingMagic, faWatermelonSlice, faCircleEllipsis, faSchoolLock, faTowerCell, faSdCards, faJugBottle, faDownLong, faLongArrowAltDown, faEnvelopes, faPhoneOffice, faRankingStar, faChessKing, faNfcPen, faPersonHarassing, faHatWinter, faBrazilianRealSign, faLandmarkDome, faLandmarkAlt, faBoneBreak, faArrowUp, faDownFromDottedLine, faTv, faTelevision, faTvAlt, faBorderLeft, faCircleDivide, faShrimp, faListCheck, faDiagramSubtask, faJugDetergent, faCircleUser, faUserCircle, faSquareY, faUserDoctorHair, faPlanetRinged, faMushroom, faUserShield, faMegaphone, faWreathLaurel, faCircleExclamationCheck, faWind, faBoxDollar, faBoxUsd, faCarBurst, faCarCrash, faY, faUserHeadset, faArrowsRetweet, faRetweetAlt, faPersonSnowboarding, faSnowboarding, faSquareChevronRight, faChevronSquareRight, faLacrosseStickBall, faTruckFast, faShippingFast, faUserMagnifyingGlass, faStarSharp, faCommentHeart, faCircle1, faCircleStar, faStarCircle, faFish, faCloudFog, faFog, faWaffle, faMusicNote, faMusicAlt, faHexagonExclamation, faCartShoppingFast, faObjectUnion, faUserGraduate, faStarfighter, faCircleHalfStroke, faAdjust, faArrowRightLongToLine, faSquareArrowDown, faArrowSquareDown, faDiamondHalfStroke, faClapperboard, faSquareChevronLeft, faChevronSquareLeft, faPhoneIntercom, faLinkHorizontal, faChainHorizontal, faMango, faMusicNoteSlash, faMusicAltSlash, faCircleRadiation, faRadiationAlt, faFaceTongueSweat, faGlobeStand, faBaseball, faBaseballBall, faCircleP, faAwardSimple, faJetFighterUp, faDiagramProject, faProjectDiagram, faPedestal, faChartPyramid, faSidebar, faSnowmanHead, faFrostyHead, faCopy, faBurgerGlass, faVolumeXmark, faVolumeMute, faVolumeTimes, faHandSparkles, faBarsFilter, faPaintbrushPencil, faPartyBell, faUserVneckHair, faJackOLantern, faGrip, faGripHorizontal, faShareFromSquare, faShareSquare, faChildCombatant, faChildRifle, faGun, faSquarePhone, faPhoneSquare, faHatBeach, faPlus, faAdd, faExpand, faFort, faCloudCheck, faXmark, faMultiply, faRemove, faFaceSmirking, faArrowsUpDownLeftRight, faArrows, faChalkboardUser, faChalkboardTeacher, faRhombus, faClawMarks, faPesoSign, faFaceSmileTongue, faCartCircleXmark, faBuildingShield, faCirclePhoneFlip, faPhoneCircleAlt, faBaby, faUsersLine, faQuoteLeft, faQuoteLeftAlt, faTractor, faKeySkeleton, faTrashArrowUp, faTrashRestore, faArrowDownUpLock, faArrowDownToBracket, faLinesLeaning, faSquareQ, faRulerCombined, faSymbols, faIconsAlt, faCopyright, faFlaskGear, faHighlighterLine, faBracketSquare, faBracket, faBracketLeft, faIslandTropical, faIslandTreePalm, faArrowRightFromLine, faArrowFromLeft, faH2, faEquals, faCakeSlice, faShortcake, faPeanut, faWrenchSimple, faBlender, faTeeth, faTally2, faShekelSign, faIls, faShekel, faSheqel, faSheqelSign, faCars, faAxeBattle, faUserHairLong, faMap, faFileCircleInfo, faFaceDisappointed, faLassoSparkles, faClockEleven, faSirenOn, faClockTen, faCandleHolder, faVideoArrowDownLeft, faPhotoFilm, faPhotoVideo, faFloppyDiskCircleArrowRight, faSaveCircleArrowRight, faFolderMinus, faPlanetMoon, faFaceEyesXmarks, faChartScatter, faDisplayArrowDown, faStore, faArrowTrendUp, faPlugCircleMinus, faOliveBranch, faAngle, faVacuumRobot, faSignHanging, faSign, faSquareDivide, faSignalStreamSlash, faBezierCurve, faEyeDropperHalf, faStoreLock, faBellSlash, faCloudBoltSun, faThunderstormSun, faCameraSlash, faCommentQuote, faTablet, faTabletAndroid, faSchoolFlag, faMessageCode, faGlassHalf, faGlassHalfEmpty, faGlassHalfFull, faFill, faMessageMinus, faCommentAltMinus, faAngleUp, faDinosaur, faDrumstickBite, faLinkHorizontalSlash, faChainHorizontalSlash, faHollyBerry, faNose, faChevronLeft, faBacteria, faClouds, faMoneyBillSimple, faHandLizard, faTablePivot, faFilterSlash, faTrashCanUndo, faTrashCanArrowTurnLeft, faTrashUndoAlt, faNotdef, faDisease, faPersonToDoor, faTurntable, faBriefcaseMedical, faGenderless, faChevronRight, faSignalWeak, faSignal1, faClockFive, faRetweet, faCarRear, faCarAlt, faPumpSoap, faComputerClassic, faFrame, faVideoSlash, faBatteryQuarter, faBattery2, faEllipsisStroke, faEllipsisHAlt, faRadio, faBabyCarriage, faCarriageBaby, faFaceExpressionless, faDownToDottedLine, faCloudMusic, faTrafficLight, faCloudMinus, faThermometer, faShieldMinus, faVrCardboard, faCarTilt, faGaugeCircleMinus, faBrightnessLow, faHandMiddleFinger, faPercentage, faTruckMoving, faGlassWaterDroplet, faConveyorBelt, faLocationCheck, faMapMarkerCheck, faCoinVertical, faDisplay, faPersonSign, faFaceSmile, faSmile, faPhoneHangup, faSignatureSlash, faThumbtack, faThumbTack, faWheatSlash, faTrophy, faCloudsSun, faPersonPraying, faPray, faHammer, faFaceVomit, faSpeakers, faTtyAnswer, faTeletypeAnswer, faMugTeaSaucer, faDiagramLeanCanvas, faAlt, faDial, faDialMedHigh, faHandPeace, faCircleTrash, faTrashCircle, faRotate, faSyncAlt, faCircleQuarters, faSpinner, faTowerControl, faArrowUpTriangleSquare, faSortShapesUp, faWhale, faPeace, faPartyHorn, faGears, faCogs, faSunBright, faSunAlt, faWarehouse, faConveyorBeltArm, faLockKeyholeOpen, faLockOpenAlt, faSquareFragile, faBoxFragile, faSquareWineGlassCrack, faArrowUpRightDots, faSquareN, faSplotch, faFaceGrinHearts, faGrinHearts, faMeter, faMandolin, faDiceFour, faSimCard, faTransgender, faTransgenderAlt, faMercury, faUpFromBracket, faKnifeKitchen, faBorderRight, faArrowTurnDown, faLevelDown, faSpade, faCardSpade, faLineColumns, faArrowRightToLine, faArrowToRight, faPersonFallingBurst, faFlagPennant, faPennant, faConveyorBeltEmpty, faUserGroupSimple, faAward, faTicketSimple, faTicketAlt, faAnglesLeft, faAngleDoubleLeft, faCamcorder, faVideoHandheld, faPancakes, faAlbumCircleUser, faQrcode, faDiceD10, faFireplace, faPenPaintbrush, faPencilPaintbrush, faFishCooked, faChairOffice, faNestingDolls, faClockRotateLeft, faHistory, faTrumpet, faFaceGrinBeamSweat, faGrinBeamSweat, faFireSmoke, faPhoneMissed, faFileExport, faArrowRightFromFile, faShield, faShieldBlank, faArrowUpShortWide, faSortAmountUpAlt, faArrowsRepeat1, faRepeat1Alt, faGunSlash, faAvocado, faBinary, faGlassesRound, faGlassesAlt, faPhonePlus, faDitto, faPersonSeat, faHouseMedical, faGolfBallTee, faGolfBall, faCircleChevronLeft, faChevronCircleLeft, faHouseChimneyWindow, faScythe, faPenNib, faBanParking, faParkingCircleSlash, faTentArrowTurnLeft, faFaceDiagonalMouth, faDiagramCells, faCricketBatBall, faCricket, faTents, faWandMagic, faMagic, faDog, faAtomSimple, faAtomAlt, faAmpersand, faCarrot, faArrowUpFromLine, faArrowFromBottom, faMoon, faPenSlash, faWineGlassEmpty, faWineGlassAlt, faSquareStar, faCheese, faSendBackward, faYinYang, faMusic, faCompassSlash, faClockOne, faFileMusic, faCodeCommit, faTemperatureLow, faPersonBiking, faBiking, faDisplayChartUpCircleCurrency, faSkeleton, faCircleG, faCircleArrowUpLeft, faCoinBlank, faBroom, faVacuum, faShieldHeart, faCardHeart, faLightbulbCflOn, faMelon, faGopuram, faEarthOceania, faGlobeOceania, faContainerStorage, faFacePouting, faSquareXmark, faTimesSquare, faXmarkSquare, faFaceExplode, faExplodingHead, faHashtag, faUpRightAndDownLeftFromCenter, faExpandAlt, faOilCan, faT, faTransformerBolt, faHippo, faChartColumn, faCassetteVhs, faVhs, faInfinity, faVialCircleCheck, faChimney, faObjectIntersect, faPersonArrowDownToLine, faVoicemail, faBlockBrick, faWallBrick, faFan, faBagsShopping, faParagraphLeft, faParagraphRtl, faPersonWalkingLuggage, faCaravanSimple, faCaravanAlt, faTurtle, faPencilMechanical, faUpDown, faArrowsAltV, faCloudMoonRain, faBoothCurtain, faCalendar, faTrailer, faUserDoctorMessage, faUserMdChat, faBahai, faHaykal, faAmpGuitar, faSdCard, faVolumeSlash, faBorderBottom, faWifiWeak, faWifi1, faDragon, faShoePrints, faCirclePlus, faFaceGrinTongueWink, faGrinTongueWink, faHandHolding, faPlugCircleExclamation, faLinkSlash, faChainBroken, faChainSlash, faUnlink, faClone, faPersonWalkingArrowLoopLeft, faArrowUpZA, faSortAlphaUpAlt, faFireFlameCurved, faFireAlt, faTornado, faFileCirclePlus, faDeleteRight, faBookQuran, faQuran, faCircleQuarter, faAnchor, faBorderAll, faFunction, faFaceAngry, faAngry, faPeopleSimple, faCookieBite, faArrowTrendDown, faRss, faFeed, faFaceMonocle, faDrawPolygon, faScaleBalanced, faBalanceScale, faCalendarLines, faCalendarNote, faArrowDownBigSmall, faSortSizeDown, faGaugeSimpleHigh, faTachometer, faTachometerFast, faDoNotEnter, faShower, faDiceD8, faDesktop, faDesktopAlt, faM, faGripDotsVertical, faFaceViewfinder, faSoftServe, faCreemee, faH5, faHandBackPointDown, faTableList, faThList, faCommentSms, faSms, faRectangle, faRectangleLandscape, faClipboardListCheck, faTurkey, faUserPlus, faIceSkate, faBatteryThreeQuarters, faBattery4, faTomato, faSwordLaser, faHouseCircleCheck, faBuildings, faAngleLeft, faCartFlatbedBoxes, faDollyFlatbedAlt, faDiagramSuccessor, faTruckArrowRight, faSquareW, faArrowsSplitUpAndLeft, faLamp, faAirplay, faHandFist, faFistRaised, faShieldQuartered, faSlashForward, faLocationPen, faMapMarkerEdit, faCloudMoon, faPotFood, faBriefcase, faPersonFalling, faImagePortrait, faPortrait, faUserTag, faRug, faPrintSlash, faEarthEurope, faGlobeEurope, faCartFlatbedSuitcase, faLuggageCart, faHandBackPointRibbon, faRectangleXmark, faRectangleTimes, faTimesRectangle, faWindowClose, faTireRugged, faLightbulbDollar, faCowbell, faBahtSign, faCorner, faChevronsRight, faChevronDoubleRight, faBookOpen, faBookJournalWhills, faJournalWhills, faInhaler, faHandcuffs, faSnake, faTriangleExclamation, faWarning, faNoteMedical, faDatabase, faDownLeft, faArrowTurnRight, faMailForward, faFaceThinking, faTurnDownRight, faBottleDroplet, faMaskFace, faHillRockslide, faScannerKeyboard, faCircleO, faGridHorizontal, faMessageDollar, faCommentAltDollar, faRightLeft, faExchangeAlt, faPaperPlane, faRoadCircleExclamation, faDungeon, faHandHoldingBox, faInputText, faWindowFlip, faWindowAlt, faAlignRight, faScannerGun, faScanner, faTire, faEngine, faMoneyBill1Wave, faMoneyBillWaveAlt, faLifeRing, faHands, faSignLanguage, faSigning, faCircleCaretRight, faCaretCircleRight, faWheat, faFileSpreadsheet, faAudioDescriptionSlash, faCalendarDay, faWaterLadder, faLadderWater, faSwimmingPool, faArrowsUpDown, faArrowsV, faChessPawnPiece, faChessPawnAlt, faFaceGrimace, faGrimace, faWheelchairMove, faWheelchairAlt, faTurnDown, faLevelDownAlt, faSquareS, faRectangleBarcode, faBarcodeAlt, faPersonWalkingArrowRight, faSquareEnvelope, faEnvelopeSquare, faDice, faUnicorn, faBowlingBall, faPompebled, faBrain, faWatchSmart, faBookUser, faSensorCloud, faSensorSmoke, faClapperboardPlay, faBandage, faBandAid, faCalendarMinus, faXmarkCircle, faCircle4, faGifts, faAlbumCollection, faHotel, faEarthAsia, faGlobeAsia, faIdCardClip, faIdCardAlt, faMagnifyingGlassPlus, faSearchPlus, faCloudShowers, faUserClock, faOnion, faClockTwelveThirty, faArrowDownToDottedLine, faHandDots, faAllergies, faFileInvoice, faWindowMinimize, faRectangleWide, faCommentArrowUp, faGarlic, faMugSaucer, faCoffee, faBrush, faTreeDecorated, faMask, faCalendarHeart, faMagnifyingGlassMinus, faSearchMinus, faFlower, faRightLeftLarge, faRulerVertical, faCirclesOverlap, faUserLarge, faUserAlt, faStarshipFreighter, faTrainTram, faBridgeSuspension, faTrashCheck, faUserNurse, faBoombox, faSyringe, faCloudSun, faShieldExclamation, faStopwatch20, faSquareFull, faGripDots, faCommentExclamation, faPenSwirl, faFalafel, faCircle2, faMagnet, faJar, faGramophone, faDiceD12, faNoteSticky, faDown, faArrowAltDown, faHundredPoints, fa100, faPaperclipVertical, faWindWarning, faWindCircleExclamation, faLocationPinSlash, faMapMarkerSlash, faFaceSadSweat, faBugSlash, faCupcake, faLightSwitchOff, faToggleLargeOff, faPenFancySlash, faTruckContainer, faBoot, faArrowUpFromWaterPump, faFileCheck, faBone, faCardsBlank, faCircle3, faBenchTree, faKeyboardBrightnessLow, faSkiBootSki, faBrainCircuit, faUserInjured, faBlockBrickFire, faFirewall, faFaceSadTear, faSadTear, faPlane, faTentArrowsDown, faExclamation, faArrowsSpin, faFaceSmileRelaxed, faCommentXmark, faCommentTimes, faPrint, faTurkishLiraSign, faTry, faTurkishLira, faFaceNoseSteam, faCircleWaveformLines, faWaveformCircle, faDollarSign, faDollar, faUsd, faFerrisWheel, faComputerSpeaker, faSkullCow, faX, faMagnifyingGlassDollar, faSearchDollar, faUsersGear, faUsersCog, faPersonMilitaryPointing, faBuildingColumns, faBank, faInstitution, faMuseum, faUniversity, faCircleT, faSack, faGrid2, faCameraCctv, faCctv, faUmbrella, faTrowel, faHorizontalRule, faBedFront, faBedAlt, faD, faStapler, faMasksTheater, faTheaterMasks, faKipSign, faFaceWoozy, faCloudQuestion, faPineapple, faHandPointLeft, faGalleryThumbnails, faCircleJ, faEyes, faHandshakeSimple, faHandshakeAlt, faPageCaretUp, faFileCaretUp, faJetFighter, faFighterJet, faComet, faSquareShareNodes, faShareAltSquare, faShieldKeyhole, faBarcode, faPlusMinus, faSquareSlidersVertical, faSlidersVSquare, faVideo, faVideoCamera, faMessageMiddle, faCommentMiddleAlt, faMortarBoard, faHandHoldingMedical, faPersonCircleCheck, faSquareZ, faMessageText, faCommentAltText, faTurnUp, faLevelUpAlt */
var prefix = "fas";
var fa0 = {
  prefix: 'fas',
  iconName: '0',
  icon: [320, 512, [], "30", "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 96c-53 0-96 43-96 96V320c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z"]
};
var fa1 = {
  prefix: 'fas',
  iconName: '1',
  icon: [256, 512, [], "31", "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z"]
};
var fa2 = {
  prefix: 'fas',
  iconName: '2',
  icon: [320, 512, [], "32", "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"]
};
var fa3 = {
  prefix: 'fas',
  iconName: '3',
  icon: [320, 512, [], "33", "M0 64C0 46.3 14.3 32 32 32H272c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H105.4C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H80c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96H32C14.3 96 0 81.7 0 64z"]
};
var fa4 = {
  prefix: 'fas',
  iconName: '4',
  icon: [384, 512, [], "34", "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368H256v80c0 17.7 14.3 32 32 32s32-14.3 32-32V368h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V304H82.4L189 77.6z"]
};
var fa5 = {
  prefix: 'fas',
  iconName: '5',
  icon: [320, 512, [], "35", "M32.5 58.3C35.3 43.1 48.5 32 64 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H100.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"]
};
var fa6 = {
  prefix: 'fas',
  iconName: '6',
  icon: [320, 512, [], "36", "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3c0 .2 0 .3 0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z"]
};
var fa7 = {
  prefix: 'fas',
  iconName: '7',
  icon: [320, 512, [], "37", "M0 64C0 46.3 14.3 32 32 32H288c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z"]
};
var fa8 = {
  prefix: 'fas',
  iconName: '8',
  icon: [320, 512, [], "38", "M304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h15.9c0 0 .1 0 .1 0h32c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0H144c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"]
};
var fa9 = {
  prefix: 'fas',
  iconName: '9',
  icon: [320, 512, [], "39", "M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"]
};
var faFillDrip = {
  prefix: 'fas',
  iconName: 'fill-drip',
  icon: [576, 512, [], "f576", "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6H386.7l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"]
};
var faArrowsToCircle = {
  prefix: 'fas',
  iconName: 'arrows-to-circle',
  icon: [640, 512, [], "e4bd", "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"]
};
var faCircleChevronRight = {
  prefix: 'fas',
  iconName: 'circle-chevron-right',
  icon: [512, 512, ["chevron-circle-right"], "f138", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"]
};
var faChevronCircleRight = faCircleChevronRight;
var faWagonCovered = {
  prefix: 'fas',
  iconName: 'wagon-covered',
  icon: [640, 512, [], "f8ee", "M4.5 57.4C-5.2 30.3 16.1 2.1 44.8 4.1L194.1 14C210.9 15.1 224 29.1 224 45.9V224H64L4.5 57.4zM288 16h64c17.7 0 32 14.3 32 32V224H256V48c0-17.7 14.3-32 32-32zM64 288c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32h-1.6c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96H286.9c-7.8 54.3-54.4 96-110.9 96c-61.9 0-112-50.1-112-112c0-31.3 12.9-59.7 33.6-80H96c-17.7 0-32-14.3-32-32zm96 128H114c5.8 22.5 23.5 40.2 46 46V416zm0-32V338c-22.5 5.8-40.2 23.5-46 46h46zm32 78c22.5-5.8 40.2-23.5 46-46H192v46zm0-124v46h46c-5.8-22.5-23.5-40.2-46-46zM448 462V416H402c5.8 22.5 23.5 40.2 46 46zm-46-78h46V338c-22.5 5.8-40.2 23.5-46 46zm124 32H480v46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46v46h46zM595.2 4.1c28.7-1.9 50 26.2 40.3 53.4L576 224H416V45.9c0-16.8 13.1-30.8 29.9-31.9l149.3-10z"]
};
var faLineHeight = {
  prefix: 'fas',
  iconName: 'line-height',
  icon: [576, 512, [], "f871", "M118.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V370.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V141.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM256 416c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-17.7 0-32 14.3-32 32z"]
};
var faBagel = {
  prefix: 'fas',
  iconName: 'bagel',
  icon: [640, 512, [129391], "e3d7", "M640 208c0 114.9-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c6.5-12.3 12-25.3 16.3-38.8c4.7-.7 9.3-2.5 13.3-5.3L471 357.3c5.1-3.5 11-5.4 17.2-5.6l25.3-.7c13.2-.4 24.8-8.8 29.3-21.3l8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6L582 275.8c10.5-8.1 14.9-21.7 11.2-34.4L586 217c-1.7-5.9-1.7-12.2 0-18.1l7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4l-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6l-8.5-23.9c-4.4-12.5-16.1-20.9-29.3-21.3l-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6L450.1 44.4c-10.9-7.5-25.3-7.5-36.2 0L393 58.7c-5.1 3.5-11 5.4-17.2 5.6L350.5 65c-13.2 .4-24.8 8.8-29.3 21.3l-1.8 5.1c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208zM396.1 155c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64c0 30.6-21.5 56.3-50.3 62.5c-6-43.3-23.6-82.9-49.5-115.6zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm256 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM144 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faTransporter7 = {
  prefix: 'fas',
  iconName: 'transporter-7',
  icon: [512, 512, [], "e2a8", "M472.7 38.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 64l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 96l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 96l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 64l-7.3-25.4zM64 288l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 288 6.6 295.3C2.7 296.4 0 299.9 0 304s2.7 7.6 6.6 8.7L32 320l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 320l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 288zM296 512h88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h88 80z"]
};
var faAt = {
  prefix: 'fas',
  iconName: 'at',
  icon: [512, 512, [61946], "40", "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faRectanglesMixed = {
  prefix: 'fas',
  iconName: 'rectangles-mixed',
  icon: [576, 512, [], "e323", "M0 80C0 53.5 21.5 32 48 32H272c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zm384 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V80zM112 304H288c26.5 0 48 21.5 48 48v80c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48z"]
};
var faPhoneArrowUpRight = {
  prefix: 'fas',
  iconName: 'phone-arrow-up-right',
  icon: [512, 512, ["phone-arrow-up", "phone-outgoing"], "e224", "M295 183l135-135H384c-13.3 0-24-10.7-24-24s10.7-24 24-24H488c13.3 0 24 10.7 24 24V128c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9L329 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"]
};
var faPhoneArrowUp = faPhoneArrowUpRight;
var faPhoneOutgoing = faPhoneArrowUpRight;
var faTrashCan = {
  prefix: 'fas',
  iconName: 'trash-can',
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
};
var faTrashAlt = faTrashCan;
var faCircleL = {
  prefix: 'fas',
  iconName: 'circle-l',
  icon: [512, 512, [], "e114", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 152V336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHeadSideGoggles = {
  prefix: 'fas',
  iconName: 'head-side-goggles',
  icon: [512, 512, ["head-vr"], "f6ea", "M45.9 128C75.3 53.1 148.3 0 233.7 0H256c39.3 0 75.8 11.8 106.2 32H304c-61.9 0-112 50.1-112 112c0 17.2 3.9 33.5 10.8 48H32.2 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H45.9zM304 256H507.1c3.2 6.2 4.9 13.1 4.9 20.2c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V375.8c0-17-7.1-33-17.5-46.4C55 299.1 38.3 261.6 33.5 224H225.6c20.2 19.8 47.9 32 78.4 32zm0-192H416V224H304c-44.2 0-80-35.8-80-80s35.8-80 80-80zM480 224H448V64h32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32z"]
};
var faHeadVr = faHeadSideGoggles;
var faTextHeight = {
  prefix: 'fas',
  iconName: 'text-height',
  icon: [576, 512, [], "f034", "M64 128V96h64l0 320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192l0-320h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H160 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM502.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"]
};
var faUserXmark = {
  prefix: 'fas',
  iconName: 'user-xmark',
  icon: [640, 512, ["user-times"], "f235", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faUserTimes = faUserXmark;
var faFaceHandYawn = {
  prefix: 'fas',
  iconName: 'face-hand-yawn',
  icon: [512, 512, [], "e379", "M336.9 498.9C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5V384 330.4c0-28.7 23.3-52 52-52c1.8 0 3.6 .1 5.3 .3C184.8 246.3 217.8 224 256 224c28.7 0 54.5 12.6 72.1 32.6c14.8-2.4 30.4 2 41.8 13.4c12.2 12.2 16.5 29.4 12.8 45c1.1 .9 2.2 1.9 3.2 3c18.1 18.1 18.7 47.1 1.8 65.9c16.9 18.8 16.3 47.8-1.8 65.9l-49 49zM204.5 102c5.5 6.9 4.4 17-2.5 22.5l-80 64c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l80-64c6.9-5.5 17-4.4 22.5 2.5zM310 124.5c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5l80 64c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5l-80-64zM299.3 276.7c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7V330.4c0-11-9-20-20-20s-20 9-20 20V384v32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faGaugeSimpleMin = {
  prefix: 'fas',
  iconName: 'gauge-simple-min',
  icon: [512, 512, ["tachometer-slowest"], "f62d", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-35.3-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faTachometerSlowest = faGaugeSimpleMin;
var faStethoscope = {
  prefix: 'fas',
  iconName: 'stethoscope',
  icon: [576, 512, [129658], "f0f1", "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112V265.3c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCoffin = {
  prefix: 'fas',
  iconName: 'coffin',
  icon: [384, 512, [9904], "f6c6", "M11.5 114.9l91-104C108.5 4 117.3 0 126.5 0h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6z"]
};
var faMessage = {
  prefix: 'fas',
  iconName: 'message',
  icon: [512, 512, ["comment-alt"], "f27a", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"]
};
var faCommentAlt = faMessage;
var faSalad = {
  prefix: 'fas',
  iconName: 'salad',
  icon: [512, 512, [129367, "bowl-salad"], "f81e", "M416 96c2.6 0 5.2 .1 7.8 .2C406.2 76.5 380.5 64 352 64c-8.7 0-17.2 1.2-25.3 3.4C309.5 27.7 270 0 224 0s-85.5 27.7-102.7 67.4c-8-2.2-16.5-3.4-25.3-3.4C43 64 0 107 0 160s43 96 96 96h73.4L84.7 171.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 249.4V112c0-8.8 7.2-16 16-16s16 7.2 16 16V256h52c-2.6-10.2-4-21-4-32c0-70.7 57.3-128 128-128zM27.4 288C12.3 288 0 300.3 0 315.4c0 70.5 44.4 130.7 106.7 154.1l1.8 14.4c2 16 15.6 28 31.8 28H371.8c16.1 0 29.8-12 31.8-28l1.8-14.4C467.6 446.1 512 385.9 512 315.4c0-15.1-12.3-27.4-27.4-27.4H27.4zM512 224c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H506.5c3.5-10 5.5-20.8 5.5-32z"]
};
var faBowlSalad = faSalad;
var faInfo = {
  prefix: 'fas',
  iconName: 'info',
  icon: [192, 512, [], "f129", "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V256H32c-17.7 0-32-14.3-32-32z"]
};
var faRobotAstromech = {
  prefix: 'fas',
  iconName: 'robot-astromech',
  icon: [512, 512, [], "e2d2", "M256 0c70.7 0 128 57.3 128 128v32H128V128C128 57.3 185.3 0 256 0zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM48 240c0-26.5 21.5-48 48-48H416c26.5 0 48 21.5 48 48V398.3c0 8.7 2.4 17.2 6.8 24.7l38.9 64.8c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1H400c-8.8 0-16-7.2-16-16V384l-45.3 45.3c-12 12-28.3 18.7-45.3 18.7h-75c-17 0-33.3-6.7-45.3-18.7L128 384V496c0 8.8-7.2 16-16 16H16c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1L41.2 423c4.5-7.5 6.8-16 6.8-24.7V240zm160 16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]
};
var faRingDiamond = {
  prefix: 'fas',
  iconName: 'ring-diamond',
  icon: [384, 512, [], "e5ab", "M122.5 13.3C126.6 5.1 134.9 0 144 0h96c9.1 0 17.4 5.1 21.5 13.3l24 48c3.5 7.1 3.4 15.5-.5 22.4l-30.4 54.8C329.9 164.4 384 235.9 384 320c0 106-86 192-192 192S0 426 0 320c0-84.1 54.1-155.6 129.4-181.6L99 83.7c-3.8-6.9-4-15.3-.5-22.4l24-48zM192 192a128 128 0 1 0 0 256 128 128 0 1 0 0-256z"]
};
var faFonduePot = {
  prefix: 'fas',
  iconName: 'fondue-pot',
  icon: [512, 512, [129749], "e40d", "M319 39.8l-24 96c-2.9 11.5-11.6 20-22.2 23L264.5 192h-33l10.2-41c-7.9-7.7-11.7-19.3-8.8-30.8l24-96C261.2 7.1 278.6-3.3 295.8 1s27.6 21.7 23.3 38.8zm62.9 120.2L360.6 192H322.1l33.2-49.8c-4.9-9.9-4.5-22.1 2.1-31.9l64-96C431.2-.5 451-4.4 465.8 5.4s18.7 29.7 8.9 44.4l-64 96c-6.6 9.9-17.7 14.9-28.7 14.2zM32 224H64v16 64c0 8.8 7.2 16 16 16s16-7.2 16-16V272c0-8.8 7.2-16 16-16s16 7.2 16 16s7.2 16 16 16s16-7.2 16-16V240 224H384h64 32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 52.3-25.1 98.8-64 128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-3.2c-10.3 2.1-21 3.2-32 3.2H160c-11 0-21.7-1.1-32-3.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448C25.1 418.8 0 372.3 0 320V256c0-17.7 14.3-32 32-32z"]
};
var faTheta = {
  prefix: 'fas',
  iconName: 'theta',
  icon: [384, 512, [], "f69e", "M64 256c0-51 15.9-96 40.2-127.6C128.5 96.9 159.8 80 192 80s63.5 16.9 87.8 48.4C304.1 160 320 205 320 256s-15.9 96-40.2 127.6C255.5 415.1 224.2 432 192 432s-63.5-16.9-87.8-48.4C79.9 352 64 307 64 256zM192 16C135.8 16 87.1 45.7 53.5 89.4C19.9 133.1 0 192.1 0 256s19.9 122.9 53.5 166.6C87.1 466.3 135.8 496 192 496s104.9-29.7 138.5-73.4C364.1 378.9 384 319.9 384 256s-19.9-122.9-53.5-166.6C296.9 45.7 248.2 16 192 16zM128 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z"]
};
var faFaceHandPeeking = {
  prefix: 'fas',
  iconName: 'face-hand-peeking',
  icon: [640, 512, [129763], "e481", "M497.8 144.3c12.9-12.9 31.8-16.1 47.7-9.6C502.2 54.5 417.5 0 320 0C248.5 0 183.8 29.3 137.3 76.6c7.7 1.8 14.9 5.7 20.9 11.7c17.2 17.2 17.2 45 0 62.2l-1.5 1.5H232c22.1 0 40 17.9 40 40c0 2.6-.2 5.1-.7 7.5c10.1 7.3 16.7 19.1 16.7 32.5s-6.6 25.3-16.7 32.5c.5 2.4 .7 4.9 .7 7.5c0 22.1-17.9 40-40 40h-8c0 .3 0 .6 0 .9c0 22.1-17.9 40-40 40l-64.8 0c-13.3 0-26.4-2.2-38.8-6.5C117 443.2 210.4 512 320 512c91.5 0 171.8-48 217.1-120.2c-5.4 .7-10.8 1.1-16.3 1.1H456c-22.1 0-40-17.9-40-40c0-.1 0-.2 0-.3c0-.2 0-.4 0-.6h-8c-22.1 0-40-17.9-40-40c0-1.1 0-2.2 .1-3.3c-37-10.4-64.1-44.4-64.1-84.7c0-48.6 39.4-88 88-88c6.6 0 13 .7 19.2 2.1c11.8-4 25.2-2.4 36.1 5.4l37.9 27.1c1.1-9.6 5.3-18.9 12.6-26.2zM320 448c-35.3 0-64-21.5-64-48s28.7-48 64-48s64 21.5 64 48s-28.7 48-64 48zm90.3-208c3.8-4.2 6.1-9.9 6.1-16c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 6.1 2.3 11.8 6.1 16h35.8zM248 192c0-8.8-7.2-16-16-16H118.2c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L51.9 166.4l-.8 .8C14.7 204.4 15 264.1 51.9 301c17.9 17.9 42.1 27.9 67.3 27.9H184c8.8 0 16-7.2 16-16s-7.2-16-16-16H170c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5h62c8.8 0 16-7.2 16-16s-7.2-16-16-16H169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4l78.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4l62.4 0c8.8 0 16-7.2 16-16zm163-25.3c-5.1 7.2-3.5 17.2 3.7 22.3l59.7 42.6c3.5 2.5 5.6 6.6 5.6 10.9c0 7.4-6 13.4-13.4 13.4L392 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h84c2.2 0 4 1.8 4 4s-1.8 4-4 4H408c-8.8 0-16 7.2-16 16s7.2 16 16 16l67.5 0c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5H456c-8.8 0-16 7.2-16 16s7.2 16 16 16h64.8c25.2 0 49.5-10 67.3-27.9c36.9-36.9 37.2-96.6 .8-133.8l-.8-.8L543 161.3c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l14.8 14.8c6.6 6.6 2.7 18-6.6 19c-2.8 .3-5.6-.4-7.8-2L433.3 163c-7.2-5.1-17.2-3.5-22.3 3.7z"]
};
var faSquareUser = {
  prefix: 'fas',
  iconName: 'square-user',
  icon: [448, 512, [], "e283", "M81.1 416H366.9c-7.8-54.3-54.4-96-110.9-96H192c-56.4 0-103.1 41.7-110.9 96zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
};
var faDownLeftAndUpRightToCenter = {
  prefix: 'fas',
  iconName: 'down-left-and-up-right-to-center',
  icon: [512, 512, ["compress-alt"], "f422", "M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"]
};
var faCompressAlt = faDownLeftAndUpRightToCenter;
var faExplosion = {
  prefix: 'fas',
  iconName: 'explosion',
  icon: [576, 512, [], "e4e9", "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H117.8L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448v0H512v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64zM288 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"]
};
var faFileLines = {
  prefix: 'fas',
  iconName: 'file-lines',
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFileAlt = faFileLines;
var faFileText = faFileLines;
var faWaveSquare = {
  prefix: 'fas',
  iconName: 'wave-square',
  icon: [640, 512, [], "f83e", "M128 64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V416h96V256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96H192V256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z"]
};
var faRing = {
  prefix: 'fas',
  iconName: 'ring',
  icon: [512, 512, [], "f70b", "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304V208z"]
};
var faBuildingUn = {
  prefix: 'fas',
  iconName: 'building-un',
  icon: [384, 512, [], "e4d9", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDiceThree = {
  prefix: 'fas',
  iconName: 'dice-three',
  icon: [448, 512, [9858], "f527", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faTirePressureWarning = {
  prefix: 'fas',
  iconName: 'tire-pressure-warning',
  icon: [512, 512, [], "f633", "M384 32c0-17.7 14.3-32 32-32s32 14.3 32 32V54.5c0 24.1 3.9 48 11.5 70.8l2.5 7.4c4.8 14.4 11.5 28.6 19.3 44.4c17.5 35.6 33.4 82.6 27.5 136.2c-5.3 48.6-28.1 99-76.8 148.7v34c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16v-8H336v8c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16v-8H240v8c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16v-8H144v8c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V462C31.3 412.3 8.6 361.9 3.2 313.3c-5.9-53.6 9.9-100.6 27.5-136.2c7.8-15.8 14.5-30 19.3-44.4l2.5-7.4C60.1 102.5 64 78.5 64 54.5V32C64 14.3 78.3 0 96 0s32 14.3 32 32V54.5c0 31-5 61.7-14.8 91.1l-2.5 7.4c-6.3 19-14.8 36.6-22.6 52.5c-14.7 29.7-25.3 64-21.3 100.9c3.7 34 20.4 74.1 65.7 117.7H379.4c45.3-43.6 62-83.7 65.7-117.7c4.1-36.9-6.6-71.1-21.3-100.9c-7.8-15.8-16.3-33.5-22.6-52.5l-2.5-7.4C389 116.2 384 85.4 384 54.5V32zM280 120V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zM256 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faWifiFair = {
  prefix: 'fas',
  iconName: 'wifi-fair',
  icon: [640, 512, ["wifi-2"], "f6ab", "M320 352a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0-160c-70.2 0-137.9 25.6-190.5 72c-13.2 11.7-14.5 31.9-2.8 45.2c11.8 13.3 32 14.5 45.2 2.8c40.9-36.1 93.5-56 148.1-56s107.3 19.9 148.1 56c6.1 5.4 13.7 8 21.2 8c8.8 0 17.7-3.7 24-10.8c11.7-13.2 10.4-33.5-2.8-45.2c-52.6-46.4-120.2-72-190.5-72zM171.8 312c39.5-34.9 91.3-56 148.2-56s108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8zM320 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faWifi2 = faWifiFair;
var faCalendarDays = {
  prefix: 'fas',
  iconName: 'calendar-days',
  icon: [448, 512, ["calendar-alt"], "f073", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"]
};
var faCalendarAlt = faCalendarDays;
var faMp3Player = {
  prefix: 'fas',
  iconName: 'mp3-player',
  icon: [384, 512, [], "f8ce", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM96 64C78.3 64 64 78.3 64 96v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96z"]
};
var faAnchorCircleCheck = {
  prefix: 'fas',
  iconName: 'anchor-circle-check',
  icon: [640, 512, [], "e4aa", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faTally4 = {
  prefix: 'fas',
  iconName: 'tally-4',
  icon: [640, 512, [], "e297", "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm96-32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32zM544 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"]
};
var faRectangleHistory = {
  prefix: 'fas',
  iconName: 'rectangle-history',
  icon: [512, 512, [], "e4a2", "M512 224c0-35.3-28.7-64-64-64L64 160c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224zM440 80L72 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zM392 0L120 0C106.7 0 96 10.7 96 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
var faBuildingCircleArrowRight = {
  prefix: 'fas',
  iconName: 'building-circle-arrow-right',
  icon: [640, 512, [], "e4d1", "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faVolleyball = {
  prefix: 'fas',
  iconName: 'volleyball',
  icon: [512, 512, [127952, "volleyball-ball"], "f45f", "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"]
};
var faVolleyballBall = faVolleyball;
var faSunHaze = {
  prefix: 'fas',
  iconName: 'sun-haze',
  icon: [640, 512, [], "f765", "M425.5 1.2c5 2.1 8.6 6.6 9.6 11.9L455 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L510.9 256 448 256c0-70.7-57.3-128-128-128s-128 57.3-128 128l-62.9 0L66.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L185 121 204.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L320 65.1 410.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM320 160c53 0 96 43 96 96H224c0-53 43-96 96-96zM616 288c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24s10.7-24 24-24H616zm-208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H408zm144 88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H552zM64 488c0-13.3 10.7-24 24-24H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm208 0c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24z"]
};
var faTextSize = {
  prefix: 'fas',
  iconName: 'text-size',
  icon: [640, 512, [], "f894", "M64 128V96h96l0 320H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H224l0-320h96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H192 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM384 304V288h64l0 128H432c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H512l0-128h64v16c0 17.7 14.3 32 32 32s32-14.3 32-32V272c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v32c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faUfo = {
  prefix: 'fas',
  iconName: 'ufo',
  icon: [640, 512, [128760], "e047", "M320 112c59.2 0 109.6 37.9 128.3 90.7c5 14.2 7.7 29.4 7.7 45.3c0 0-40 40-136 40s-136-40-136-40c0-15.9 2.7-31.1 7.7-45.3c18.7-52.8 69-90.7 128.3-90.7zm0-48c-90.1 0-165.2 64.8-180.9 150.4C55.1 237.5 0 276.2 0 320c0 70.7 143.3 128 320 128s320-57.3 320-128c0-43.8-55.1-82.5-139.1-105.6C485.2 128.8 410.2 64 320 64zm0 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM104 328a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm408-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faFork = {
  prefix: 'fas',
  iconName: 'fork',
  icon: [512, 512, ["utensil-fork"], "f2e3", "M412.4 5.9c5.2 6.4 4.8 15.6-1.1 21.5L320 118.6c-5.2 5.2-5.2 13.6 0 18.8c4.9 4.9 12.8 5.2 18.1 .6l99.4-86.1c6.3-5.5 15.9-5.2 21.8 .8s6.3 15.4 .8 21.8L374 173.9c-4.6 5.3-4.3 13.2 .6 18.1c5.2 5.2 13.6 5.2 18.8 0l91.3-91.3c5.8-5.8 15.1-6.3 21.5-1.1s7.7 14.4 3.2 21.2l-71 106.5c-18.6 27.9-49.9 44.6-83.4 44.6c-19.3 0-37.9-5.5-53.9-15.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L255.7 211c-10.2-16-15.7-34.7-15.7-53.9c0-33.5 16.8-64.8 44.6-83.4l106.5-71c6.8-4.6 16-3.2 21.2 3.2z"]
};
var faUtensilFork = faFork;
var faArrowsUpToLine = {
  prefix: 'fas',
  iconName: 'arrows-up-to-line',
  icon: [576, 512, [], "e4c2", "M32 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L416 237.3 416 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"]
};
var faMobileSignal = {
  prefix: 'fas',
  iconName: 'mobile-signal',
  icon: [512, 512, [], "e1ef", "M64 64H288V315.7c18.3-21.2 39.9-39.5 64-54V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H224V488c0-13.6 1-27 3-40H64V64zm80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM488 256c-128.1 0-232 103.9-232 232c0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-136c0-13.3-10.7-24-24-24c-75.1 0-136 60.9-136 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88c13.3 0 24-10.7 24-24z"]
};
var faBarcodeScan = {
  prefix: 'fas',
  iconName: 'barcode-scan',
  icon: [640, 512, [], "f465", "M88 32C74.7 32 64 42.7 64 56V192h64V56c0-13.3-10.7-24-24-24H88zM64 456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320H64V456zm96 8c0 8.8 7.2 16 16 16s16-7.2 16-16V320H160V464zm64-8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320H224V456zm0-264h64V56c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24V192zm96 264c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320H320V456zm0-264h64V56c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24V192zM448 464c0 8.8 7.2 16 16 16s16-7.2 16-16V320H448V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 408c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320H512V456zm0-264h64V56c0-13.3-10.7-24-24-24H536c-13.3 0-24 10.7-24 24V192zm-352 0h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V192zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faSortDown = {
  prefix: 'fas',
  iconName: 'sort-down',
  icon: [320, 512, ["sort-desc"], "f0dd", "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]
};
var faSortDesc = faSortDown;
var faFolderArrowDown = {
  prefix: 'fas',
  iconName: 'folder-arrow-down',
  icon: [512, 512, ["folder-download"], "e053", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24V302.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V200z"]
};
var faFolderDownload = faFolderArrowDown;
var faCircleMinus = {
  prefix: 'fas',
  iconName: 'circle-minus',
  icon: [512, 512, ["minus-circle"], "f056", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMinusCircle = faCircleMinus;
var faFaceIcicles = {
  prefix: 'fas',
  iconName: 'face-icicles',
  icon: [512, 512, [], "e37c", "M512 256c0 8.3-.4 16.6-1.2 24.7c0 .5-.1 1.1-.1 1.6l-14.8 200C494.7 499.1 480.8 512 464 512s-30.7-12.9-31.9-29.6l-2.8-37.9c-5 4.6-10.2 9-15.6 13.2l-11.5 32.9C397.7 503.4 385.6 512 372 512c-11.5 0-21.9-6.1-27.5-15.7C316.9 506.5 287.1 512 256 512c-69.4 0-132.3-27.6-178.4-72.4C71.9 444.9 64.3 448 56 448c-15.6 0-29-11.3-31.6-26.7L6.5 313.4C2.2 294.9 0 275.7 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM56 415.8l0 .2 0-.2 20-120.2C78.1 283.3 68.6 272 56 272s-22.1 11.3-20.1 23.7L56 415.8zM344 400l28 80 28-80V360l-56 0v40zm55.3-56c-3.8-22.7-23.6-40-47.3-40h-8v40l55.3 0zM328 344V304H264v40h64zm0 56V360H264v40l32 48 32-48zm-80-96H184v40l64 0V304zm0 56l-64 0v40h64V360zm-80-16V304h-8c-23.8 0-43.5 17.3-47.3 40H168zm0 56V360H112.7c3.8 22.7 23.6 40 47.3 40h8zm40.4-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 480l21.8-232.1C487 235.1 476.9 224 464 224s-23 11.1-21.8 23.9L464 480z"]
};
var faShovel = {
  prefix: 'fas',
  iconName: 'shovel',
  icon: [512, 512, [], "f713", "M361.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-44.1 44.1c-18.7 18.7-44.1 29.3-70.6 29.3c-15.9 0-30.9-3.7-44.3-10.3l-97 97 50.7 50.7c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32V386.3c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0l50.7 50.7 97-97C291.7 155.1 288 140 288 124.1c0-26.5 10.5-51.9 29.3-70.6L361.4 9.4zM384 77.3L362.5 98.7c-6.7 6.7-10.5 15.9-10.5 25.4c0 19.8 16.1 35.9 35.9 35.9c9.5 0 18.6-3.8 25.4-10.5L434.7 128 384 77.3z"]
};
var faDoorOpen = {
  prefix: 'fas',
  iconName: 'door-open',
  icon: [576, 512, [], "f52b", "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"]
};
var faFilms = {
  prefix: 'fas',
  iconName: 'films',
  icon: [576, 512, [], "e17a", "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm8 48h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H168c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM472 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H488c-8.8 0-16-7.2-16-16V96zM168 184h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H168c-8.8 0-16-7.2-16-16V200c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H488c-8.8 0-16-7.2-16-16V200zM168 288h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H168c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H488c-8.8 0-16-7.2-16-16V304zM288 80h96c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V112c0-17.7 14.3-32 32-32zM256 256c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V256zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faRightFromBracket = {
  prefix: 'fas',
  iconName: 'right-from-bracket',
  icon: [512, 512, ["sign-out-alt"], "f2f5", "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"]
};
var faSignOutAlt = faRightFromBracket;
var faFaceGlasses = {
  prefix: 'fas',
  iconName: 'face-glasses',
  icon: [512, 512, [], "e377", "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256c0-22.1 2.8-43.5 8.1-64H48v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V192h32v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V192h39.9c5.3 20.5 8.1 41.9 8.1 64zM256 0C363.4 0 455.4 66.2 493.4 160H458.6c-9-18.9-28.3-32-50.6-32H328c-22.3 0-41.6 13.1-50.6 32H234.6c-9-18.9-28.3-32-50.6-32H104c-22.3 0-41.6 13.1-50.6 32H18.6C56.6 66.2 148.6 0 256 0zM80 192v-8c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V192zm61.5 147.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM304 184c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v8 56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V184zM184.4 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faNfc = {
  prefix: 'fas',
  iconName: 'nfc',
  icon: [448, 512, [], "e1f7", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 48V368c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48z"]
};
var faAtom = {
  prefix: 'fas',
  iconName: 'atom',
  icon: [512, 512, [9883], "f5d2", "M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSoap = {
  prefix: 'fas',
  iconName: 'soap',
  icon: [512, 512, [129532], "e06e", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96V416c0 53 43 96 96 96H416c53 0 96-43 96-96V288c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H352c35.3 0 64-28.7 64-64s-28.7-64-64-64H320 160z"]
};
var faIcons = {
  prefix: 'fas',
  iconName: 'icons',
  icon: [512, 512, ["heart-music-camera-bolt"], "f86d", "M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L213.3 304H240c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H74.7zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM478.7 278.3L440.3 368H496c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L391.7 400H336c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L19.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"]
};
var faHeartMusicCameraBolt = faIcons;
var faMicrophoneLinesSlash = {
  prefix: 'fas',
  iconName: 'microphone-lines-slash',
  icon: [640, 512, ["microphone-alt-slash"], "f539", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256H358.9l-34.5-27c2.9-3.1 7-5 11.6-5h80V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"]
};
var faMicrophoneAltSlash = faMicrophoneLinesSlash;
var faClosedCaptioningSlash = {
  prefix: 'fas',
  iconName: 'closed-captioning-slash',
  icon: [640, 512, [], "e135", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zm197.8 155c26.6 1.2 50.4 13.3 67 31.9c6.1 6.8 7.6 16.2 4.7 24.3l-71.6-56.2zm94 73.7c10-42.3 48-73.8 93.4-73.8c28.4 0 54 12.4 71.5 32c8.8 9.9 8 25-1.9 33.9s-25 8-33.9-1.9c-8.8-9.9-21.6-16-35.8-16c-26.5 0-48 21.5-48 48c0 5.4 .9 10.5 2.5 15.4l-47.9-37.6zm89.4 70c1.3 .1 2.7 .2 4.1 .2c14.2 0 27-6.1 35.8-16c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9c-7.8 8.7-17.2 16-27.7 21.4l-47.9-37.6zM32 121.2V416c0 35.3 28.7 64 64 64H487.4L295 328.4c-16.8 14.7-38.9 23.6-63 23.6c-53 0-96-43-96-96c0-16 3.9-31.1 10.8-44.3L32 121.2zM232 304c8.7 0 16.9-2.3 23.9-6.4l-70-55.1c-1.3 4.3-1.9 8.8-1.9 13.5c0 26.5 21.5 48 48 48z"]
};
var faCalculatorSimple = {
  prefix: 'fas',
  iconName: 'calculator-simple',
  icon: [512, 512, ["calculator-alt"], "f64c", "M0 48C0 21.5 21.5 0 48 0H176c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48zm288 0c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V48zm48 240H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM0 336c0-26.5 21.5-48 48-48H176c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zM416 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V96H352c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V64zM64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM83.3 348.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L89.4 400 60.7 428.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 422.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L134.6 400l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 377.4 83.3 348.7zM352 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H352zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H352z"]
};
var faCalculatorAlt = faCalculatorSimple;
var faBridgeCircleCheck = {
  prefix: 'fas',
  iconName: 'bridge-circle-check',
  icon: [640, 512, [], "e4c9", "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faSlidersUp = {
  prefix: 'fas',
  iconName: 'sliders-up',
  icon: [512, 512, ["sliders-v"], "f3f1", "M96 0c17.7 0 32 14.3 32 32V86.7c28.3 12.3 48 40.5 48 73.3s-19.7 61-48 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V233.3C35.7 221 16 192.8 16 160s19.7-61 48-73.3V32C64 14.3 78.3 0 96 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 32.8-19.7 61-48 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V425.3c-28.3-12.3-48-40.5-48-73.3s19.7-61 48-73.3V32c0-17.7 14.3-32 32-32s32 14.3 32 32V278.7c28.3 12.3 48 40.5 48 73.3zM448 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V265.3c-28.3-12.3-48-40.5-48-73.3s19.7-61 48-73.3V32c0-17.7 14.3-32 32-32s32 14.3 32 32v86.7c28.3 12.3 48 40.5 48 73.3s-19.7 61-48 73.3z"]
};
var faSlidersV = faSlidersUp;
var faLocationMinus = {
  prefix: 'fas',
  iconName: 'location-minus',
  icon: [384, 512, ["map-marker-minus"], "f609", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM120 168H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMapMarkerMinus = faLocationMinus;
var faPumpMedical = {
  prefix: 'fas',
  iconName: 'pump-medical',
  icon: [448, 512, [], "e06a", "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFingerprint = {
  prefix: 'fas',
  iconName: 'fingerprint',
  icon: [512, 512, [], "f577", "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7V256c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1V256c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9V256z"]
};
var faSkiBoot = {
  prefix: 'fas',
  iconName: 'ski-boot',
  icon: [512, 512, [], "e3cc", "M383.4 38c3.3-17.4-8-34.1-25.4-37.5s-34.1 8-37.5 25.4l-1.2 6H245.7c-22.1 130.8-76 201.3-127.2 238.9c-26.2 19.3-51.2 29.5-69.9 35c-6.3 1.8-11.8 3.1-16.5 4L.6 474c-1.8 9.4 .7 19.1 6.8 26.4S22.5 512 32 512H448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V376c0-12.3-7-23.4-18-28.8L340 288H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h69.5l12.3-64H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h72l17.3-90 6.2-32zM38.8 275.4c.3-.1 .6-.2 .9-.3c15.6-4.6 37.1-13.3 59.9-30c43-31.6 92.3-92.9 113.7-213.1H112C96.7 32 83.5 42.9 80.6 58L38.8 275.4z"]
};
var faStandardDefinition = {
  prefix: 'fas',
  iconName: 'standard-definition',
  icon: [576, 512, ["rectangle-sd"], "e28a", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 88V328c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96H328c-13.3 0-24 10.7-24 24zm48 24h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H352V208zm-184.9 .1c7.4-2.4 19.5-2.9 36.2-.7l3-22.2-3 22.2c5.1 .7 21.1 3.4 25.7 4.4c12.1 2.8 24.1-4.8 26.8-16.9s-4.8-24.1-16.9-26.8c-6.5-1.5-23.9-4.4-29.7-5.1c-18.9-2.5-38.9-3.1-56 2.5c-18.8 6.1-33.9 19.7-38.5 42.3c-.1 .4-.1 .8-.2 1.2c-1.7 11.4-.2 22.4 5 32.3c5.1 9.6 12.9 16.1 20.5 20.7c13.7 8.2 31.5 12.3 45.1 15.5l0 0 1.7 .4c16 3.7 27.1 6.5 34.1 10.7c3 1.8 3.8 3 3.9 3.3l0 0c.1 .1 .7 1.2 .2 4.7c-.4 2.7-1.2 3.8-1.7 4.3c-.7 .7-2.3 2-5.8 3.1c-7.7 2.4-20.1 2.9-36.9 .6c-7.4-1-20.3-4.8-31.4-8c-2.5-.7-5-1.4-7.2-2.1c-11.9-3.4-24.3 3.5-27.7 15.4s3.5 24.3 15.4 27.7c1.5 .4 3.3 .9 5.3 1.5l0 0c10.8 3.2 28.4 8.3 39.4 9.9l.1 0c18.9 2.5 39.2 3.1 56.4-2.3c8.9-2.8 17.8-7.5 24.9-15.2c7.3-7.8 11.8-17.6 13.4-28.5c1.7-11.4 .2-22.4-5-32.3c-5.1-9.6-12.9-16.1-20.5-20.7c-13.7-8.2-31.5-12.3-45.1-15.5l0 0-1.7-.4c-16-3.7-27.1-6.5-34.1-10.7c-3-1.8-3.8-3-3.9-3.3l0 0c-.1-.1-.6-1.1-.3-4.1c.9-4 2.8-6.2 8.3-8z"]
};
var faRectangleSd = faStandardDefinition;
var faH1 = {
  prefix: 'fas',
  iconName: 'h1',
  icon: [576, 512, [], "f313", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zm448 0c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-64 32c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l17.7-8.8V384H416c-17.7 0-32 14.3-32 32s14.3 32 32 32h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V96z"]
};
var faHandPointRight = {
  prefix: 'fas',
  iconName: 'hand-point-right',
  icon: [512, 512, [], "f0a4", "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zm64-64c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h48c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32H160C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64v88c0 22.1-17.9 40-40 40s-40-17.9-40-40V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v56c0 39.8 32.2 72 72 72z"]
};
var faMagnifyingGlassLocation = {
  prefix: 'fas',
  iconName: 'magnifying-glass-location',
  icon: [512, 512, ["search-location"], "f689", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSearchLocation = faMagnifyingGlassLocation;
var faMessageBot = {
  prefix: 'fas',
  iconName: 'message-bot',
  icon: [640, 512, [], "e3b8", "M160 0C124.7 0 96 28.7 96 64V176H59.7c-5.5-9.6-15.9-16-27.7-16c-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16H96V352c0 35.3 28.7 64 64 64h64v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416H480c35.3 0 64-28.7 64-64V208h36.3c5.5 9.6 15.9 16 27.7 16c17.7 0 32-14.3 32-32s-14.3-32-32-32c-11.8 0-22.2 6.4-27.7 16H544V64c0-35.3-28.7-64-64-64H160zm0 128c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V128zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faForwardStep = {
  prefix: 'fas',
  iconName: 'forward-step',
  icon: [320, 512, ["step-forward"], "f051", "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"]
};
var faStepForward = faForwardStep;
var faFaceSmileBeam = {
  prefix: 'fas',
  iconName: 'face-smile-beam',
  icon: [512, 512, [128522, "smile-beam"], "f5b8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faSmileBeam = faFaceSmileBeam;
var faLightCeiling = {
  prefix: 'fas',
  iconName: 'light-ceiling',
  icon: [512, 512, [], "e016", "M256 0c17.7 0 32 14.3 32 32V162c115.8 14.4 207.6 106.3 222 222.1c2.2 17.5-12.4 31.9-30 31.9H32C14.3 416-.2 401.6 2 384.1C16.4 268.2 108.2 176.4 224 162V32c0-17.7 14.3-32 32-32zm0 512c-35.3 0-64-28.7-64-64H320c0 35.3-28.7 64-64 64z"]
};
var faMessageExclamation = {
  prefix: 'fas',
  iconName: 'message-exclamation',
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM256 80c-13.3 0-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCommentAltExclamation = faMessageExclamation;
var faBowlScoop = {
  prefix: 'fas',
  iconName: 'bowl-scoop',
  icon: [448, 512, [127847, "bowl-shaved-ice"], "e3de", "M32 224H416c0-106-86-192-192-192S32 118 32 224zM16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9C11.1 361.9 72.4 416 145 416h40.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H320c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 416H303c72.6 0 133.9-54.1 142.9-126.1l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16z"]
};
var faBowlShavedIce = faBowlScoop;
var faSquareX = {
  prefix: 'fas',
  iconName: 'square-x',
  icon: [448, 512, [], "e286", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.3 104.5L224 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L192.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z"]
};
var faUtilityPoleDouble = {
  prefix: 'fas',
  iconName: 'utility-pole-double',
  icon: [512, 512, [], "e2c4", "M256 0c17.7 0 32 14.3 32 32V64h96V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32V56c0-13.3 10.7-24 24-24s24 10.7 24 24V96c0 17.7-14.3 32-32 32H428.8L288 221.9V256h96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 17.7-14.3 32-32 32H428.8L288 413.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V413.9L83.2 320H32c-17.7 0-32-14.3-32-32V248c0-13.3 10.7-24 24-24s24 10.7 24 24v8H80v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96V221.9L83.2 128H32C14.3 128 0 113.7 0 96V56C0 42.7 10.7 32 24 32s24 10.7 24 24v8H80V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96V32c0-17.7 14.3-32 32-32zM140.8 128L224 183.4V128H140.8zM288 183.4L371.2 128H288v55.4zM140.8 320L224 375.4V320H140.8zM288 375.4L371.2 320H288v55.4z"]
};
var faFlagCheckered = {
  prefix: 'fas',
  iconName: 'flag-checkered',
  icon: [448, 512, [127937], "f11e", "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1V345.8c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V400 334 64 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9v65.5L64 252.6V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3V238.7l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4V244.2l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6L128 173.2V98L64 114v73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2V251.9l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4V115.4c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"]
};
var faChevronsUp = {
  prefix: 'fas',
  iconName: 'chevrons-up',
  icon: [512, 512, ["chevron-double-up"], "f325", "M278.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3 425.4 278.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-192-192zm192 384l-192-192c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 301.3 425.4 470.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"]
};
var faChevronDoubleUp = faChevronsUp;
var faFootball = {
  prefix: 'fas',
  iconName: 'football',
  icon: [512, 512, [127944, "football-ball"], "f44e", "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faFootballBall = faFootball;
var faUserVneck = {
  prefix: 'fas',
  iconName: 'user-vneck',
  icon: [448, 512, [], "e461", "M224 0a128 128 0 1 0 0 256A128 128 0 1 0 224 0zM157.3 327.1c-3.2-4.3-8.4-6.7-13.7-6.2C62.9 329.7 0 398.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-83.1-62.9-151.5-143.7-160.3c-5.3-.6-10.5 1.9-13.7 6.2l-53.9 71.8c-6.4 8.5-19.2 8.5-25.6 0l-53.9-71.8z"]
};
var faSchoolCircleExclamation = {
  prefix: 'fas',
  iconName: 'school-circle-exclamation',
  icon: [640, 512, [], "e56c", "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faCrop = {
  prefix: 'fas',
  iconName: 'crop',
  icon: [512, 512, [], "f125", "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64v64l178.7 0L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H173.3L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-274.7z"]
};
var faAnglesDown = {
  prefix: 'fas',
  iconName: 'angles-down',
  icon: [448, 512, ["angle-double-down"], "f103", "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"]
};
var faAngleDoubleDown = faAnglesDown;
var faUsersRectangle = {
  prefix: 'fas',
  iconName: 'users-rectangle',
  icon: [640, 512, [], "e594", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H544c53 0 96-43 96-96V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm159.8 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3C119.9 256 96 279.9 96 309.3zM461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faPeopleRoof = {
  prefix: 'fas',
  iconName: 'people-roof',
  icon: [640, 512, [], "e537", "M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm312 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM226.9 491.4L200 441.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V441.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V441.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V345.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"]
};
var faSquareArrowRight = {
  prefix: 'fas',
  iconName: 'square-arrow-right',
  icon: [448, 512, ["arrow-square-right"], "f33b", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM361 273L249 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L361 239c9.4 9.4 9.4 24.6 0 33.9z"]
};
var faArrowSquareRight = faSquareArrowRight;
var faLocationPlus = {
  prefix: 'fas',
  iconName: 'location-plus',
  icon: [384, 512, ["map-marker-plus"], "f60a", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM168 280V216H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V104c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faMapMarkerPlus = faLocationPlus;
var faLightbulbExclamationOn = {
  prefix: 'fas',
  iconName: 'lightbulb-exclamation-on',
  icon: [640, 512, [], "e1ca", "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80V416H400v16zM344 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V200c0 13.3 10.7 24 24 24s24-10.7 24-24V88zM320 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faPeopleLine = {
  prefix: 'fas',
  iconName: 'people-line',
  icon: [640, 512, [], "e534", "M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V217.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5z"]
};
var faBeerMugEmpty = {
  prefix: 'fas',
  iconName: 'beer-mug-empty',
  icon: [512, 512, ["beer"], "f0fc", "M32 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h51.2c42.4 0 76.8 34.4 76.8 76.8V274.9c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V172.8c0-7.1-5.7-12.8-12.8-12.8H384V311.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"]
};
var faBeer = faBeerMugEmpty;
var faCrateEmpty = {
  prefix: 'fas',
  iconName: 'crate-empty',
  icon: [512, 512, [], "e151", "M48 224c-26.5 0-48 21.5-48 48v80H512V272c0-26.5-21.5-48-48-48H48zM512 384H0v80c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V384zM64 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM48 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faDiagramPredecessor = {
  prefix: 'fas',
  iconName: 'diagram-predecessor',
  icon: [512, 512, [], "e477", "M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"]
};
var faTransporter = {
  prefix: 'fas',
  iconName: 'transporter',
  icon: [512, 512, [], "e042", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 272v96H184V237.3L153 276c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36L409 236c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-31-38.7V416H264V320H248zM216 512H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H296 216zM64 96l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 128l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 128 6.6 120.7C2.7 119.6 0 116.1 0 112s2.7-7.6 6.6-8.7L32 96l7.3-25.4C40.4 66.7 43.9 64 48 64s7.6 2.7 8.7 6.6L64 96zM472.7 6.6L480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4C456.4 2.7 459.9 0 464 0s7.6 2.7 8.7 6.6z"]
};
var faCalendarCircleUser = {
  prefix: 'fas',
  iconName: 'calendar-circle-user',
  icon: [576, 512, [], "e471", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3V192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-66.3 80.7C489.5 468.1 462.2 480 432 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7zM384 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faArrowUpLong = {
  prefix: 'fas',
  iconName: 'arrow-up-long',
  icon: [384, 512, ["long-arrow-up"], "f176", "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"]
};
var faLongArrowUp = faArrowUpLong;
var faPersonCarryBox = {
  prefix: 'fas',
  iconName: 'person-carry-box',
  icon: [384, 512, ["person-carry"], "f4cf", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM96 306.7V241.7l16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4H224 352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32v96H161.1l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32v0V410.5l-64-64z"]
};
var faPersonCarry = faPersonCarryBox;
var faFireFlameSimple = {
  prefix: 'fas',
  iconName: 'fire-flame-simple',
  icon: [384, 512, ["burn"], "f46a", "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"]
};
var faBurn = faFireFlameSimple;
var faPerson = {
  prefix: 'fas',
  iconName: 'person',
  icon: [320, 512, [129485, "male"], "f183", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z"]
};
var faMale = faPerson;
var faLaptop = {
  prefix: 'fas',
  iconName: 'laptop',
  icon: [640, 512, [128187], "f109", "M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"]
};
var faFileCsv = {
  prefix: 'fas',
  iconName: 'file-csv',
  icon: [512, 512, [], "f6dd", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"]
};
var faMenorah = {
  prefix: 'fas',
  iconName: 'menorah',
  icon: [640, 512, [], "f676", "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32V288c0 17.7 14.3 32 32 32H288V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320H544c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 53-43 96-96 96H352v64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V384H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H96V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H192V256 160c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32v96 32H384V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H480V256 160c0-17.7 14.3-32 32-32z"]
};
var faUnion = {
  prefix: 'fas',
  iconName: 'union',
  icon: [384, 512, [8899], "f6a2", "M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"]
};
var faChevronsLeft = {
  prefix: 'fas',
  iconName: 'chevrons-left',
  icon: [512, 512, ["chevron-double-left"], "f323", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192zm384-192l-192 192c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 470.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"]
};
var faChevronDoubleLeft = faChevronsLeft;
var faCircleHeart = {
  prefix: 'fas',
  iconName: 'circle-heart',
  icon: [512, 512, ["heart-circle"], "f4c7", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM131.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L278.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L131.9 280.9z"]
};
var faHeartCircle = faCircleHeart;
var faTruckPlane = {
  prefix: 'fas',
  iconName: 'truck-plane',
  icon: [640, 512, [], "e58f", "M200 0c-30.6 0-56 54.7-56 86.1V192.5L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15V463.4c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V408 325.5 184l0-1.1 0 0V86.1C256 54.7 231.5 0 200 0zm88 176V400c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V448H544v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V445.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7H539.7c9.2 0 17.2 6 20.5 14.7L576 304H352l15.8-49.3zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM336 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faRecordVinyl = {
  prefix: 'fas',
  iconName: 'record-vinyl',
  icon: [512, 512, [], "f8d9", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBringForward = {
  prefix: 'fas',
  iconName: 'bring-forward',
  icon: [512, 512, [], "f856", "M224 448H448V224H384V160h64c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V384h64v64zm64-96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64z"]
};
var faSquareP = {
  prefix: 'fas',
  iconName: 'square-p',
  icon: [448, 512, [], "e279", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h92c50.8 0 92 41.2 92 92s-41.2 92-92 92H176v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V288 152c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44H176v88h68z"]
};
var faFaceGrinStars = {
  prefix: 'fas',
  iconName: 'face-grin-stars',
  icon: [512, 512, [129321, "grin-stars"], "f587", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm407.4 75.5c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"]
};
var faGrinStars = faFaceGrinStars;
var faSigma = {
  prefix: 'fas',
  iconName: 'sigma',
  icon: [384, 512, [8721], "f68b", "M2.4 51.8C7.4 39.8 19.1 32 32 32H320c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H109.3L246.6 233.4c12.5 12.5 12.5 32.8 0 45.3L109.3 416H320V384c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 35.3-28.7 64-64 64H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L178.7 256 9.4 86.6C.2 77.5-2.5 63.7 2.4 51.8z"]
};
var faCameraMovie = {
  prefix: 'fas',
  iconName: 'camera-movie',
  icon: [576, 512, [127909, 127910], "f8a9", "M128 64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM352 256H128C57.3 256 0 198.7 0 128S57.3 0 128 0c48.2 0 90.2 26.6 112 66C261.8 26.6 303.8 0 352 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zm0-192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM558.3 259.4c10.8 5.4 17.7 16.5 17.7 28.6V480c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48L448 448V432 336 320l12.8-9.6 64-48c9.7-7.3 22.7-8.4 33.5-3zM64 288h64H352c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V352H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64z"]
};
var faBong = {
  prefix: 'fas',
  iconName: 'bong',
  icon: [448, 512, [], "f55c", "M160 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7H302.9c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8V64H160V208.5zM288 64V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V64C78.3 64 64 49.7 64 32S78.3 0 96 0h16H272h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z"]
};
var faClarinet = {
  prefix: 'fas',
  iconName: 'clarinet',
  icon: [640, 512, [], "f8ad", "M224 144c0-8.8 7.2-16 16-16h32 96 96 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v32h76.6c9.5 0 18.7-2.8 26.6-8.1l31.9-21.3c4.9-3.3 11.2-3.6 16.4-.8s8.5 8.2 8.5 14.1V368c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8l-31.9-21.3c-7.9-5.3-17.1-8.1-26.6-8.1H108.3c-10.2 0-20.3-1.9-29.7-5.7L10.1 318.9C4 316.4 0 310.5 0 304V240c0-6.5 4-12.4 10.1-14.9l68.6-27.4c9.4-3.8 19.5-5.7 29.7-5.7H256V160H240c-8.8 0-16-7.2-16-16zm224 16H384v32h64V160zm-96 0H288v32h64V160zM272 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faTruckFlatbed = {
  prefix: 'fas',
  iconName: 'truck-flatbed',
  icon: [640, 512, [], "e2b6", "M608 416H576c0 53-43 96-96 96s-96-43-96-96H352 256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H88.4c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32H352V128c0-17.7 14.3-32 32-32h16 16 50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32zM416 160v96H544V237.3L466.7 160H416zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faSpaghettiMonsterFlying = {
  prefix: 'fas',
  iconName: 'spaghetti-monster-flying',
  icon: [640, 512, ["pastafarianism"], "f67b", "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faPastafarianism = faSpaghettiMonsterFlying;
var faArrowDownUpAcrossLine = {
  prefix: 'fas',
  iconName: 'arrow-down-up-across-line',
  icon: [576, 512, [], "e4af", "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H448V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3V224H192 128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192zM448 320H384V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"]
};
var faLeafHeart = {
  prefix: 'fas',
  iconName: 'leaf-heart',
  icon: [512, 512, [], "f4cb", "M272 96l0 0H376c42.7 0 79.9-23.9 98.8-59.1c3.5-6.5 13.6-6.8 16.2 .1c13.5 36.5 21.1 77 21.1 119.6C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.4 48 440v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440c0-75.1 38.3-141.2 96.4-179.9C102.5 168.5 178.8 96 272 96l0 0zM189.7 242.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5c-29.5 0-53.5 23.9-53.5 53.5z"]
};
var faHouseBuilding = {
  prefix: 'fas',
  iconName: 'house-building',
  icon: [640, 512, [], "e1b1", "M368 0c-26.5 0-48 21.5-48 48V153.9l64 58.7V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H413.2c1.9 6.8 2.8 13.9 2.8 21.1V288h16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H416V464c0 18-6 34.6-16 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368zM512 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V208zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zM400 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V112zM0 277.1V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V277.1c0-13.5-5.6-26.3-15.6-35.4l-144-132c-18.4-16.8-46.5-16.8-64.9 0l-144 132C5.6 250.8 0 263.7 0 277.1zM144 296c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H168c-13.3 0-24-10.7-24-24V296z"]
};
var faCheeseSwiss = {
  prefix: 'fas',
  iconName: 'cheese-swiss',
  icon: [512, 512, [129472], "f7f0", "M451 93c37.7 37.7 61 89.7 61 147.2V256H496.2 448 96 16 0c0-5.4 .7-10.7 2.1-15.8c3.8-13.7 12.4-25.8 24.5-33.9L96 160l23.2-15.4c7.8-5.2 18.4-2.3 25.5 3.8C153.1 155.6 164 160 176 160c26.5 0 48-21.5 48-48c0-5.2-.8-10.2-2.3-14.9c-2.9-9-1.6-19.9 6.3-25.1l47-31.3c8.6-5.7 18.6-8.7 28.9-8.7c56 0 106.8 22.1 144.2 58c1 1 2 2 3 2.9zM432 288h16 48 16v16V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V304 288H16 96 304c8.8 0 15.7 7.4 18.6 15.7C329.1 322.5 347 336 368 336s38.9-13.5 45.4-32.3c2.9-8.4 9.8-15.7 18.6-15.7zM224 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faSpoon = {
  prefix: 'fas',
  iconName: 'spoon',
  icon: [512, 512, [129348, 61873, "utensil-spoon"], "f2e5", "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"]
};
var faUtensilSpoon = faSpoon;
var faJarWheat = {
  prefix: 'fas',
  iconName: 'jar-wheat',
  icon: [320, 512, [], "e517", "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7zM112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"]
};
var faEnvelopesBulk = {
  prefix: 'fas',
  iconName: 'envelopes-bulk',
  icon: [640, 512, ["mail-bulk"], "f674", "M128 0C110.3 0 96 14.3 96 32V224h96V192c0-35.3 28.7-64 64-64H480V32c0-17.7-14.3-32-32-32H128zM256 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64V416H576c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM64 256c-17.7 0-32 14.3-32 32v13L187.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301V288c0-17.7-14.3-32-32-32H64zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8V480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V340.8z"]
};
var faMailBulk = faEnvelopesBulk;
var faFileCircleExclamation = {
  prefix: 'fas',
  iconName: 'file-circle-exclamation',
  icon: [576, 512, [], "e4eb", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faBowArrow = {
  prefix: 'fas',
  iconName: 'bow-arrow',
  icon: [512, 512, [127993], "f6b9", "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1 .3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16l35 35L144.6 333.4 93.8 320.7c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-12.7-50.8L425.7 120.3l35 35c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zm-458 85.5c-12.6-11.6-32.1-11.3-44.3 .9c-12.5 12.5-12.5 32.8 0 45.3L145.8 287 191 241.8l-90.6-90.6c56.5-30.7 125.2-30.9 181.9-.7l46.8-46.8c-83.8-53.2-191.8-53-275.4 .8zM361.5 229.7c30.2 56.7 30 125.4-.7 181.9L270.2 321 225 366.2 361.4 502.6c12.5 12.5 32.8 12.5 45.3 0c12.2-12.2 12.5-31.8 .9-44.3c53.7-83.6 54-191.6 .8-275.4l-46.8 46.8z"]
};
var faCartXmark = {
  prefix: 'fas',
  iconName: 'cart-xmark',
  icon: [576, 512, [], "e0dd", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM395.4 128.9L364.3 160l31.1 31.1c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L336 188.3l-31.1 31.1c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L307.7 160l-31.1-31.1c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0L336 131.7l31.1-31.1c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"]
};
var faHexagonXmark = {
  prefix: 'fas',
  iconName: 'hexagon-xmark',
  icon: [512, 512, ["times-hexagon", "xmark-hexagon"], "f2ee", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faTimesHexagon = faHexagonXmark;
var faXmarkHexagon = faHexagonXmark;
var faCircleH = {
  prefix: 'fas',
  iconName: 'circle-h',
  icon: [512, 512, [9405, "hospital-symbol"], "f47e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H320V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHospitalSymbol = faCircleH;
var faMerge = {
  prefix: 'fas',
  iconName: 'merge',
  icon: [512, 512, [], "e526", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h97.2c9.7 0 18.9 4.4 25 12L247 256 154.2 372c-6.1 7.6-15.3 12-25 12H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h97.2c29.2 0 56.7-13.3 75-36l99.2-124H384v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H303.4L204.2 100c-18.2-22.8-45.8-36-75-36H32z"]
};
var faPager = {
  prefix: 'fas',
  iconName: 'pager',
  icon: [512, 512, [128223], "f815", "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"]
};
var faCartMinus = {
  prefix: 'fas',
  iconName: 'cart-minus',
  icon: [576, 512, [], "e0db", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM280 132H392c11 0 20 9 20 20s-9 20-20 20H280c-11 0-20-9-20-20s9-20 20-20z"]
};
var faAddressBook = {
  prefix: 'fas',
  iconName: 'address-book',
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"]
};
var faContactBook = faAddressBook;
var faPanFrying = {
  prefix: 'fas',
  iconName: 'pan-frying',
  icon: [576, 512, [127859], "e42c", "M448 224c0 33.4-7.3 65.1-20.4 93.6l123.7 79.9C566.7 409.2 576 427.1 576 448c0 35.3-28.7 64-64 64c-15.2 0-28.3-4.6-39.3-13.5L364.8 398.3C326.3 429.4 277.3 448 224 448C100.3 448 0 347.7 0 224S100.3 0 224 0S448 100.3 448 224zM319.9 154c-21.2-5.4-50.6-22.6-65.8-38.4c-24.5-25.5-65-26.3-90.5-1.8c-11.6 11.2-18.1 25.6-19.4 40.5c-2.2 24.7-9.2 56.2-21.5 77.6c-22.1 38.3-9 87.2 29.3 109.3s87.2 9 109.3-29.3c9.4-16.3 33-30 51.6-32.6c10.2-1.4 20.3-5.4 29.2-12c28.4-21.1 34.3-61.1 13.3-89.5c-9.1-12.3-21.8-20.4-35.5-23.9zM528 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faGrid = {
  prefix: 'fas',
  iconName: 'grid',
  icon: [448, 512, ["grid-3"], "e195", "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 232c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V232zM128 392v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40zM160 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V72zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392zM448 72v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V232zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z"]
};
var faGrid3 = faGrid;
var faFootballHelmet = {
  prefix: 'fas',
  iconName: 'football-helmet',
  icon: [512, 512, [], "f44f", "M488.1 194.9c4.5 17.1-8.2 33.1-25.7 35.3L340.3 245.5l14 74.5H464c26.5 0 48 21.5 48 48v32 50.4c0 25.2-20.4 45.6-45.6 45.6h-17c-54.9 0-102-39.1-112.1-93.1L327.7 352H288l9.2 18.3c4.5 9 6.8 18.9 6.8 28.9c0 35.7-29 64.7-64.7 64.7h-1.7c-9 0-17.9-1.8-26.1-5.4l-93.4-40c-4-1.7-8.3-2.6-12.6-2.6h-14c-9.1 0-17.9-3.8-23.5-10.9C35.4 364.1 16 312.3 16 256C16 123.5 123.5 16 256 16c111.4 0 205.1 75.9 232.1 178.9zm-207.1 58c-14.3 1.8-25.1 14-25.1 28.4c0 4.4 1 8.8 3 12.8l13 26h49.7l-13.2-70.6-27.4 3.4zM360.3 352l6 32H480V368c0-8.8-7.2-16-16-16H360.3zM480 416H374.7c13.1 28.7 42 48 74.7 48h17c7.5 0 13.6-6.1 13.6-13.6V416zM176 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHandLove = {
  prefix: 'fas',
  iconName: 'hand-love',
  icon: [512, 512, [], "e1a5", "M160 0c17.7 0 32 14.3 32 32V191.9l0 .1v96c0 35.3 28.7 64 64 64c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7c35.3 0 64-28.7 64-64V224.1l0-.1V96c0-17.7 14.3-32 32-32s32 14.3 32 32V336c0 97.2-78.8 176-176 176H284.8c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V32c0-17.7 14.3-32 32-32zm64 192c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm128 0c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]
};
var faTrees = {
  prefix: 'fas',
  iconName: 'trees',
  icon: [640, 512, [], "f724", "M70.2 121.4L178.5 5.8C182 2.1 186.9 0 192 0s10 2.1 13.5 5.8L313.8 121.4c4 4.3 6.2 9.9 6.2 15.7c0 12.7-10.3 22.9-22.9 22.9H272l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5H304l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5H224v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H23.5C10.5 416 0 405.5 0 392.5c0-5.5 1.9-10.8 5.4-15L80 288H55.5c-13 0-23.5-10.5-23.5-23.5c0-5.5 1.9-10.8 5.4-15L112 160H86.9C74.3 160 64 149.7 64 137.1c0-5.8 2.2-11.4 6.2-15.7zm271.4-16.4L434.5 5.8C438 2.1 442.9 0 448 0s10 2.1 13.5 5.8L569.8 121.4c4 4.3 6.2 9.9 6.2 15.7c0 12.7-10.3 22.9-22.9 22.9H528l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5H560l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5H480v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416l0-23.4 0-.1 0-.1V392h0c-.1-12.8-4.7-25.2-12.9-35l-40.6-48.7c13-10.2 21.4-26 21.4-43.8c0-13-4.6-25.6-12.9-35.5l-40.4-48.5c12.9-10 21.3-25.8 21.3-43.4c0-11.6-3.7-22.8-10.4-32.1z"]
};
var faStrikethrough = {
  prefix: 'fas',
  iconName: 'strikethrough',
  icon: [512, 512, [], "f0cc", "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"]
};
var faPage = {
  prefix: 'fas',
  iconName: 'page',
  icon: [384, 512, [], "e428", "M64 512H320c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64z"]
};
var faK = {
  prefix: 'fas',
  iconName: 'k',
  icon: [320, 512, [107], "4b", "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64V328 448c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"]
};
var faDiagramPrevious = {
  prefix: 'fas',
  iconName: 'diagram-previous',
  icon: [512, 512, [], "e478", "M448 352L64 352v64l384 0V352zm0-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64H232V224l-46.1 0c-21.4 0-32.1-25.9-17-41L239 113c9.4-9.4 24.6-9.4 33.9 0L343 183c15.1 15.1 4.4 41-17 41L280 224v64H448zM365.7 160.4L295.6 90.3c-21.9-21.9-57.3-21.9-79.2 0l-70.1 70.1c-18.4 18.4-20.4 43.7-11 63.6L64 224c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H376.7c9.4-19.9 7.4-45.2-11-63.6z"]
};
var faGaugeMin = {
  prefix: 'fas',
  iconName: 'gauge-min',
  icon: [512, 512, ["tachometer-alt-slowest"], "f628", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAltSlowest = faGaugeMin;
var faFolderGrid = {
  prefix: 'fas',
  iconName: 'folder-grid',
  icon: [512, 512, [], "e188", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM104 240c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H104zm128 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H232zm104 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H360c-13.3 0-24 10.7-24 24z"]
};
var faEggplant = {
  prefix: 'fas',
  iconName: 'eggplant',
  icon: [512, 512, [], "e16c", "M505 7c9.4 9.4 9.4 24.6 0 33.9l-9 9V192c0 8.8-7.2 16-16 16c-26.5 0-48-21.5-48-48c0-5.8-4-10.7-9.4-12.6c-13.3-4.8-25.4-13-35.1-22.8s-18-21.9-22.8-35.1c-2-5.4-6.9-9.4-12.6-9.4c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16H462.1l9-9c9.4-9.4 24.6-9.4 33.9 0zM169.9 139.3c40.3-19.6 81-39.3 113.4-66.6c11.8 20 32.1 34.4 55.9 38.3c6.7 14 15.8 26.3 25.8 36.2s22.2 19.1 36.2 25.8c5 30.4 27.1 55.1 56.2 63.8C410.6 362.7 311.1 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3z"]
};
var faRam = {
  prefix: 'fas',
  iconName: 'ram',
  icon: [640, 512, [128015], "f70a", "M336 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-8.8 7.2-16 16-16s16 7.2 16 16V88.4c-6.8 6.1-12.8 13.2-17.6 21l-47.8 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2V240c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V167.8l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5c-4.9-7.8-10.8-14.9-17.6-21V64c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-35.3-28.7-64-64-64s-64 28.7-64 64v1.3c-5.2-.9-10.5-1.3-16-1.3s-10.8 .5-16 1.3V64c0-35.3-28.7-64-64-64s-64 28.7-64 64zM308.5 174.1c-8.9-20.8-4.3-44 10-59.7C312.3 85.6 286.7 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32V426.3c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c26.9 0 49.9-16.5 59.3-40H464c-61.9 0-112-50.1-112-112V207.4c-18.7-2.7-35.5-14.8-43.5-33.4zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faLandmarkFlag = {
  prefix: 'fas',
  iconName: 'landmark-flag',
  icon: [512, 512, [], "e51c", "M272 0h80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H272v32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H240V16c0-8.8 7.2-16 16-16h16zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"]
};
var faLips = {
  prefix: 'fas',
  iconName: 'lips',
  icon: [576, 512, [128068, 128482], "f600", "M288 101.3c3-2.4 6.2-4.8 9.7-7.3c17.8-12.7 46.8-30 78.3-30c20.3 0 42.8 9.3 61.4 19.2c20 10.6 41.1 24.7 60.2 39.5c19.1 14.8 37.1 31.2 50.8 46.5c6.8 7.6 13.1 15.7 17.9 23.7c4.3 7.2 9.7 18.3 9.7 31c0 9.2-2.6 19.1-5.3 27.5c-3 9.1-7.4 19.4-12.8 30.3c-10.8 21.7-26.8 46.9-47.7 71.1C468.8 400.9 404.7 448 320 448H256c-84.7 0-148.8-47.1-190.2-95.1C44.9 328.8 29 303.5 18.1 281.8C12.7 271 8.4 260.7 5.3 251.5C2.6 243.1 0 233.2 0 224c0-12.8 5.5-23.8 9.7-31c4.8-8.1 11.1-16.1 17.9-23.7c13.6-15.3 31.7-31.7 50.8-46.5c19.1-14.9 40.2-29 60.2-39.5C157.2 73.3 179.7 64 200 64c31.5 0 60.6 17.2 78.3 30c3.4 2.5 6.7 4.9 9.7 7.3zM64 224c0 7.9 80 96 224 96s224-88.1 224-96c0-7.7-46.3-31.1-138.8-32c-3.4 0-6.9 .5-10.1 1.5C350 197.6 313.7 208 288 208s-62-10.4-75.1-14.4c-3.3-1-6.7-1.6-10.1-1.5C110.3 192.9 64 216.3 64 224z"]
};
var faPencil = {
  prefix: 'fas',
  iconName: 'pencil',
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPencilAlt = faPencil;
var faBackward = {
  prefix: 'fas',
  iconName: 'backward',
  icon: [512, 512, [9194], "f04a", "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V256v41.7L459.5 440.6zM256 352V256 128 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V352z"]
};
var faCaretRight = {
  prefix: 'fas',
  iconName: 'caret-right',
  icon: [256, 512, [], "f0da", "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"]
};
var faComments = {
  prefix: 'fas',
  iconName: 'comments',
  icon: [640, 512, [128490, 61670], "f086", "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"]
};
var faPaste = {
  prefix: 'fas',
  iconName: 'paste',
  icon: [512, 512, ["file-clipboard"], "f0ea", "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faFileClipboard = faPaste;
var faDesktopArrowDown = {
  prefix: 'fas',
  iconName: 'desktop-arrow-down',
  icon: [576, 512, [], "e155", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352V64H512V288H64V64H224V0H64zM312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V174.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V24z"]
};
var faCodePullRequest = {
  prefix: 'fas',
  iconName: 'code-pull-request',
  icon: [512, 512, [], "e13c", "M305.8 2.1C314.4 5.9 320 14.5 320 24V64h16c70.7 0 128 57.3 128 128V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64H320v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80A24 24 0 1 0 56 80a24 24 0 1 0 48 0zm8 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPumpkin = {
  prefix: 'fas',
  iconName: 'pumpkin',
  icon: [576, 512, [], "f707", "M234.6 103.9C251.5 98.8 269.4 96 288 96c22.8 0 44.7 4.2 64.8 11.7c-.6-2-.8-4.1-.8-6.3V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4l-40.9 93.5zm161.6 27.3c12.1 8.8 23.1 19.1 32.7 30.5c5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1c9.6-11.4 20.6-21.7 32.7-30.5c-.6-.1-1.2-.2-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320S68.1 512 152 512c19.3 0 37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8c83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8c-.6 .1-1.2 .2-1.8 .3z"]
};
var faClipboardList = {
  prefix: 'fas',
  iconName: 'clipboard-list',
  icon: [384, 512, [], "f46d", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"]
};
var faPenField = {
  prefix: 'fas',
  iconName: 'pen-field',
  icon: [640, 512, [], "e211", "M601.9 16c-18.8-18.8-49.2-18.7-67.9 0L494.4 55.7l89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4 .4-68.2L601.9 16zM328.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15L560.8 167.5 471.7 78.4 328.5 221.8zM80 128c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H496c44.2 0 80-35.8 80-80V304c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16H272c17.7 0 32-14.3 32-32s-14.3-32-32-32H80zm80 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBlueberries = {
  prefix: 'fas',
  iconName: 'blueberries',
  icon: [512, 512, [], "e2e8", "M512 176C512 78.8 433.2 0 336 0C255.4 0 187.4 54.2 166.6 128.2c3.1-.1 6.3-.2 9.4-.2c114.9 0 208 93.1 208 208c0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176zM176 512a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0-304c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V224c0-8.8 7.2-16 16-16zM384 64V96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTruckRampBox = {
  prefix: 'fas',
  iconName: 'truck-ramp-box',
  icon: [640, 512, ["truck-loading"], "f4de", "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"]
};
var faTruckLoading = faTruckRampBox;
var faNote = {
  prefix: 'fas',
  iconName: 'note',
  icon: [448, 512, [], "e1ff", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320H336c-26.5 0-48 21.5-48 48V480H64c-35.3 0-64-28.7-64-64V96zM402.7 352H448l-32 32-64 64-32 32V434.7 368c0-8.8 7.2-16 16-16h66.7zM112 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM88 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faArrowDownToSquare = {
  prefix: 'fas',
  iconName: 'arrow-down-to-square',
  icon: [512, 512, [], "e096", "M374.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 242.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V242.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V112c0-44.2-35.8-80-80-80H400c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
};
var faUserCheck = {
  prefix: 'fas',
  iconName: 'user-check',
  icon: [640, 512, [], "f4fc", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faCloudXmark = {
  prefix: 'fas',
  iconName: 'cloud-xmark',
  icon: [640, 512, [], "e35f", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm95-273c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faVialVirus = {
  prefix: 'fas',
  iconName: 'vial-virus',
  icon: [512, 512, [], "e597", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V384c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32zM96 192V96h64v96H96zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faBookBlank = {
  prefix: 'fas',
  iconName: 'book-blank',
  icon: [448, 512, [128213, 128215, 128216, 128217, "book-alt"], "f5d9", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faBookAlt = faBookBlank;
var faGolfFlagHole = {
  prefix: 'fas',
  iconName: 'golf-flag-hole',
  icon: [512, 512, [], "e3ac", "M162.7 2.5c-7.4-3.7-16.3-3.3-23.4 1.1S128 15.7 128 24V232c0 1.3 .1 2.7 .3 4c-.2 1.3-.3 2.6-.3 4v92.8C51.5 349.4 0 380.5 0 416c0 53 114.6 96 256 96s256-43 256-96s-114.6-96-256-96c-27.9 0-54.8 1.7-80 4.8V246.8l194.7-97.4c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-208-104zM288 416c0 17.7-28.7 32-64 32s-64-14.3-64-32s28.7-32 64-32s64 14.3 64 32z"]
};
var faMessageArrowDown = {
  prefix: 'fas',
  iconName: 'message-arrow-down',
  icon: [512, 512, ["comment-alt-arrow-down"], "e1db", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V238.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V120z"]
};
var faCommentAltArrowDown = faMessageArrowDown;
var faFaceUnamused = {
  prefix: 'fas',
  iconName: 'face-unamused',
  icon: [512, 512, [], "e39f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-117.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z"]
};
var faSheetPlastic = {
  prefix: 'fas',
  iconName: 'sheet-plastic',
  icon: [384, 512, [], "e571", "M0 448c0 35.3 28.7 64 64 64H224V384c0-17.7 14.3-32 32-32H384V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384H256V512L384 384z"]
};
var faCircle9 = {
  prefix: 'fas',
  iconName: 'circle-9',
  icon: [512, 512, [], "e0f6", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C337.8 287.2 352 256.4 352 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z"]
};
var faBlog = {
  prefix: 'fas',
  iconName: 'blog',
  icon: [512, 512, [], "f781", "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z"]
};
var faUserNinja = {
  prefix: 'fas',
  iconName: 'user-ninja',
  icon: [448, 512, [129399], "f504", "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faPencilSlash = {
  prefix: 'fas',
  iconName: 'pencil-slash',
  icon: [640, 512, [], "e215", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.6 295.8l42.1-42.1L474.3 231l11.3-11.3-33.9-33.9-62.1-62.1L355.7 89.8l-11.3 11.3-22.6 22.6-57.8 57.8L38.8 5.1zM306.2 214.7l50.5-50.5c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-47.8 47.8-25.4-19.9zM195.5 250l-72.9 72.9c-10.4 10.4-18 23.3-22.2 37.4L65 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2l88.3-88.3-77.9-61.4-27.6 27.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.9-24.9L195.5 250zM224 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9l-78.1 23 23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM426.7 18.7L412.3 33.2 389.7 55.8 378.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L517.3 18.7c-25-25-65.5-25-90.5 0z"]
};
var faBowlingPins = {
  prefix: 'fas',
  iconName: 'bowling-pins',
  icon: [512, 512, [], "f437", "M128 0c35.3 0 64 28.7 64 64v1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1H86.5c-.5-2.7-1.1-5.4-1.8-8.1L66.9 87.1c-2-7.2-2.9-14.6-2.9-22V64C64 28.7 92.7 0 128 0zM82.1 210.4c2.2-6 3.8-12.1 4.8-18.4h82.3c1 6.3 2.6 12.4 4.8 18.4l38.6 104.7c7.6 20.6 11.5 42.5 11.5 64.4c0 28.9-6.7 57.5-19.7 83.4l-15.7 31.4C183.2 505.2 172.1 512 160 512H96c-12.1 0-23.2-6.8-28.6-17.7L51.7 462.9C38.7 437 32 408.5 32 379.5c0-22 3.9-43.8 11.5-64.4L82.1 210.4zM384 0c35.3 0 64 28.7 64 64v1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1H342.5c-.5-2.7-1.1-5.4-1.8-8.1L322.9 87.1c-2-7.2-2.9-14.6-2.9-22V64c0-35.3 28.7-64 64-64zM338.1 210.4c2.2-6 3.8-12.1 4.8-18.4h82.3c1 6.3 2.6 12.4 4.8 18.4L470 319.3c6.6 17.9 10 36.8 10 55.8c0 20.5-3.9 40.9-11.5 59.9l-22.7 56.9C440.9 504 429.1 512 416 512H352c-13.1 0-24.9-8-29.7-20.1L299.5 435C291.9 416 288 395.6 288 375.1c0-19 3.4-37.9 10-55.8l40.1-108.9z"]
};
var faPersonArrowUpFromLine = {
  prefix: 'fas',
  iconName: 'person-arrow-up-from-line',
  icon: [640, 512, [], "e539", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"]
};
var faDownRight = {
  prefix: 'fas',
  iconName: 'down-right',
  icon: [384, 512, [], "e16b", "M336 432H96c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l72-72L11.3 171.3C4.1 164.1 0 154.2 0 144s4.1-20.1 11.3-27.3L52.7 75.3C59.9 68.1 69.8 64 80 64s20.1 4.1 27.3 11.3L241.4 209.4l72-72c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6V400c0 17.7-14.3 32-32 32z"]
};
var faScrollTorah = {
  prefix: 'fas',
  iconName: 'scroll-torah',
  icon: [640, 512, ["torah"], "f6a0", "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128V480H512V32zM592 0c-26.5 0-48 14.3-48 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z"]
};
var faTorah = faScrollTorah;
var faWebhook = {
  prefix: 'fas',
  iconName: 'webhook',
  icon: [576, 512, [], "e5d5", "M306 50c-43.1-9.9-86 16.9-95.9 60c-7.9 34.1 7.4 68.2 35.5 85.9c5.4 3.4 9.2 8.8 10.7 15s.3 12.7-3 18.1L170.4 361.5c3.6 6.7 5.6 14.4 5.6 22.5c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c.6 0 1.1 0 1.7 0L201 221.9c-32.5-30.2-48.4-76.4-37.7-122.7C179.2 30.3 247.9-12.6 316.8 3.3c65.9 15.2 108 78.7 97.7 144.4c-2.1 13.1-14.3 22-27.4 20s-22-14.3-20-27.4C373.5 99.2 347.1 59.5 306 50zM289.7 176c-.6 0-1.1 0-1.7 0c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48c0 8.1-2 15.8-5.6 22.5l71.3 114.1c45.8-17.7 99.8-8.2 136.8 28.9c50 50 50 131 0 181c-43 43-109 49-158.4 18c-11.2-7-14.6-21.8-7.6-33.1s21.8-14.6 33.1-7.6c30.9 19.3 72.1 15.5 99-11.3c31.2-31.2 31.2-81.9 0-113.1c-26.8-26.8-68.1-30.6-99-11.3c-5.4 3.4-11.9 4.5-18.1 3s-11.6-5.3-15-10.7L289.7 176zM448 432c-17.8 0-33.3-9.7-41.6-24H253.8c-9.2 48.3-46 88.9-97 100.7c-68.9 15.9-137.6-27-153.5-95.9C-11 351 22.1 289.4 78.7 265.8c12.2-5.1 26.3 .7 31.4 12.9s-.7 26.3-12.9 31.4c-35.4 14.7-56 53.3-47.1 91.8c9.9 43.1 52.9 69.9 95.9 60c37-8.5 62.1-41.5 62-77.9c0-6.4 2.5-12.5 7-17s10.6-7 17-7H406.4c8.3-14.3 23.8-24 41.6-24c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
};
var faBlindsOpen = {
  prefix: 'fas',
  iconName: 'blinds-open',
  icon: [512, 512, [], "f8fc", "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64 64 66.7c13.6 4.8 24.4 15.6 29.3 29.3c.1 .3 .2 .7 .4 1c1.5 4.7 2.4 9.7 2.4 15c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16c4.8-13.6 15.6-24.4 29.3-29.3V192 128 64H32C14.3 64 0 49.7 0 32zm47.4 96H96v64H17.8C8 192 0 184 0 174.2c0-4 1.4-7.9 3.9-11.1L22.4 140c6.1-7.6 15.3-12 25-12zm0 160H65.6c-1 5.2-1.6 10.5-1.6 16c0 18 6 34.6 16 48H17.8C8 352 0 344 0 334.2c0-4 1.4-7.9 3.9-11.1L22.4 300c6.1-7.6 15.3-12 25-12zm446.9 64H208c10-13.4 16-30 16-48c0-5.5-.6-10.8-1.6-16H464.6c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1c0 9.8-8 17.8-17.8 17.8zm0-160H192V128H464.6c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1c0 9.8-8 17.8-17.8 17.8zM17.8 512C8 512 0 504 0 494.2c0-4 1.4-7.9 3.9-11.1L22.4 460c6.1-7.6 15.3-12 25-12H464.6c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1c0 9.8-8 17.8-17.8 17.8H17.8z"]
};
var faFence = {
  prefix: 'fas',
  iconName: 'fence',
  icon: [512, 512, [], "e303", "M76.8 38.4C73.8 34.4 69 32 64 32s-9.8 2.4-12.8 6.4L6.4 98.1C2.2 103.7 0 110.4 0 117.3V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V416h32V352H128V224h32V160H128V117.3c0-6.9-2.2-13.7-6.4-19.2L76.8 38.4zm192 0c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4L198.4 98.1c-4.2 5.5-6.4 12.3-6.4 19.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V416h32V352H320V224h32V160H320V117.3c0-6.9-2.2-13.7-6.4-19.2L268.8 38.4zM448 32c-5 0-9.8 2.4-12.8 6.4L390.4 98.1c-4.2 5.5-6.4 12.3-6.4 19.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V117.3c0-6.9-2.2-13.7-6.4-19.2L460.8 38.4c-3-4-7.8-6.4-12.8-6.4z"]
};
var faUp = {
  prefix: 'fas',
  iconName: 'up',
  icon: [384, 512, ["arrow-alt-up"], "f357", "M169.4 41.4c12.5-12.5 32.8-12.5 45.3 0l160 160c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H256V440c0 22.1-17.9 40-40 40H168c-22.1 0-40-17.9-40-40V256H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l160-160z"]
};
var faArrowAltUp = faUp;
var faBroomBall = {
  prefix: 'fas',
  iconName: 'broom-ball',
  icon: [576, 512, ["quidditch", "quidditch-broom-ball"], "f458", "M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H364.3L256 211.7V182.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5L341.1 353.4c3.7 42.7-11.7 85.2-42.3 115.8C271.4 496.6 234.2 512 195.5 512L22.1 512C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5L133.7 359.7c4.2-3.7-.4-10.4-5.4-7.9L77.2 377.4c-6.1 3-13.2-1.4-13.2-8.2c0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faQuidditch = faBroomBall;
var faQuidditchBroomBall = faBroomBall;
var faDrumstick = {
  prefix: 'fas',
  iconName: 'drumstick',
  icon: [512, 512, [127831], "f6d6", "M150.6 287.8c6-6 9.4-14.1 9.4-22.6V176C160 78.8 238.8 0 336 0s176 78.8 176 176s-78.8 176-176 176H246.8c-8.5 0-16.6 3.4-22.6 9.4l-26.8 26.8c-12.3 12.3-11.4 32.5-7.2 49.4c1.1 4.6 1.8 9.5 1.8 14.5c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c5 0 9.8 .6 14.5 1.8c16.9 4.2 37.1 5.2 49.4-7.2l26.8-26.8z"]
};
var faSquareV = {
  prefix: 'fas',
  iconName: 'square-v',
  icon: [448, 512, [], "e284", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm77.5 125.3L224 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z"]
};
var faFaceAwesome = {
  prefix: 'fas',
  iconName: 'face-awesome',
  icon: [512, 512, ["gave-dandy"], "e409", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm203.5-95.6c-5.6 9.4-15.8 15.6-27.5 15.6c-17.7 0-32-14.3-32-32c0-9.1 3.8-17.4 10-23.2c-3.3-.5-6.6-.8-10-.8c-35.3 0-64 28.7-64 64v10.3c0 16.4 13.3 29.7 29.7 29.7h68.6c16.4 0 29.7-13.3 29.7-29.7V184c0-8.3-1.6-16.3-4.5-23.6zM384 176c-17.7 0-32-14.3-32-32c0-8.5 3.3-16.3 8.8-22c-5.4-1.3-11-2-16.8-2c-39.8 0-72 32.2-72 72v7.5c0 13.5 11 24.5 24.5 24.5h95.1c13.5 0 24.5-11 24.5-24.5V192c0-10.4-2.2-20.2-6.1-29.1c-5.8 8-15.2 13.1-25.9 13.1zM245.5 447.8c2.7 .1 5.4 .2 8.1 .2h4.9c55.1 0 105.1-26.1 137-67.5c0 0 0 0 0 0c15.7-20.5 27-44.6 32.4-71.3c2.2-11-6.2-21.2-17.4-21.2h0H101.6h0c-11.2 0-19.6 10.2-17.4 21.2c15.6 78.1 82.4 135 161.2 138.6zm-5.4-32.5c1.5-44.1 37.8-79.4 82.2-79.4c19.9 0 38.1 7 52.3 18.7C349 392.1 306.1 416 258.4 416h-4.9c-4.6 0-9.1-.2-13.5-.6z"]
};
var faGaveDandy = faFaceAwesome;
var faDialOff = {
  prefix: 'fas',
  iconName: 'dial-off',
  icon: [576, 512, [], "e162", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 288c0 80.2-59 146.6-136 158.2V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V446.2c-77-11.6-136-78-136-158.2c0-88.4 71.6-160 160-160s160 71.6 160 160zm64 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faToggleOff = {
  prefix: 'fas',
  iconName: 'toggle-off',
  icon: [576, 512, [], "f204", "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faFaceSmileHorns = {
  prefix: 'fas',
  iconName: 'face-smile-horns',
  icon: [640, 512, [], "e391", "M320 512c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM228.1 349.5C246 370.2 276.6 392 320 392s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C413.8 396.1 375.1 424 320 424s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM272.4 272c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-10.9-3.6c.2 1.5 .3 2.9 .3 4.4zm128 32c-17.7 0-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8c0 17.7-14.3 32-32 32z"]
};
var faBoxArchive = {
  prefix: 'fas',
  iconName: 'box-archive',
  icon: [512, 512, ["archive"], "f187", "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
};
var faArchive = faBoxArchive;
var faGrapes = {
  prefix: 'fas',
  iconName: 'grapes',
  icon: [512, 512, [], "e306", "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM304 152a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM112 232a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm32 80A56 56 0 1 0 32 312a56 56 0 1 0 112 0zM112 456A56 56 0 1 0 0 456a56 56 0 1 0 112 0zm144-32a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM280 288a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faPersonDrowning = {
  prefix: 'fas',
  iconName: 'person-drowning',
  icon: [576, 512, [], "e545", "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3V64zM320 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"]
};
var faDialMax = {
  prefix: 'fas',
  iconName: 'dial-max',
  icon: [576, 512, [], "e15e", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM401.4 174.7c56.7 56.7 61.9 145.4 15.7 208L305.2 270.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L383.2 416.7c-62.6 46.2-151.3 41-208-15.7c-62.5-62.5-62.5-163.8 0-226.3s163.8-62.5 226.3 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleM = {
  prefix: 'fas',
  iconName: 'circle-m',
  icon: [512, 512, [], "e115", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.5 137.9L256 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2l-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L176 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7 .3 26.8 8.8z"]
};
var faCalendarImage = {
  prefix: 'fas',
  iconName: 'calendar-image',
  icon: [448, 512, [], "e0d4", "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM147.2 360.7c6.5-8.4 19.1-8.3 25.5 .2L184 376l58.3-84.2c6.5-9.4 20.5-9.1 26.7 .5l83.4 131.1c6.8 10.6-.9 24.6-13.5 24.6H112.5c-13.3 0-20.8-15.2-12.7-25.8l47.3-61.5zM128 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleCaretDown = {
  prefix: 'fas',
  iconName: 'circle-caret-down',
  icon: [512, 512, ["caret-circle-down"], "f32d", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm0 368c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"]
};
var faCaretCircleDown = faCircleCaretDown;
var faArrowDown91 = {
  prefix: 'fas',
  iconName: 'arrow-down-9-1',
  icon: [576, 512, ["sort-numeric-desc", "sort-numeric-down-alt"], "f886", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM450.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V416H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V320c0-10.3-4.9-19.9-13.3-26zM418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91zM405.1 203.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"]
};
var faSortNumericDesc = faArrowDown91;
var faSortNumericDownAlt = faArrowDown91;
var faFaceGrinTongueSquint = {
  prefix: 'fas',
  iconName: 'face-grin-tongue-squint',
  icon: [512, 512, [128541, "grin-tongue-squint"], "f58a", "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faGrinTongueSquint = faFaceGrinTongueSquint;
var faShishKebab = {
  prefix: 'fas',
  iconName: 'shish-kebab',
  icon: [512, 512, [], "f821", "M438.6 73.4c-12.5-12.5-32.8-12.5-45.3 0c-8.5 8.5-11.3 20.7-8.1 31.7c3.2 10.9 5.6 24.2 4.5 38c-1.1 14-5.9 30.3-19.1 43.4L346.2 211 301 165.8l24.4-24.4c.2-.3 .5-1.3 .6-3.2c.3-3.8-.3-9.1-2.1-15.2c-9.5-32.5-1.5-69.2 24.3-94.9c37.5-37.5 98.3-37.5 135.8 0c31.4 31.4 36.5 79.2 15.3 115.9c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c7.1-12.2 5.3-28.2-5.1-38.6zM61.8 405L107 450.2 54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L61.8 405zM325.3 141.5a.1 .1 0 1 0 -.1-.2 .1 .1 0 1 0 .1 .2zM233 143L369 279c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0L151 225c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zM87 255c9.4-9.4 24.6-9.4 33.9 0L257 391c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0L39 337c-9.4-9.4-9.4-24.6 0-33.9l48-48z"]
};
var faSprayCan = {
  prefix: 'fas',
  iconName: 'spray-can',
  icon: [512, 512, [], "f5bd", "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0zM256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faAlarmSnooze = {
  prefix: 'fas',
  iconName: 'alarm-snooze',
  icon: [512, 512, [], "f845", "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM200 192H312c9.2 0 17.5 5.2 21.6 13.5s3 18-2.6 25.3L249.1 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-9.2 0-17.5-5.2-21.6-13.5s-3-18 2.6-25.3L262.9 240H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faScarecrow = {
  prefix: 'fas',
  iconName: 'scarecrow',
  icon: [448, 512, [], "f70d", "M320 96c0 11.2-1.9 22-5.5 32H416c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4l-7.6 11.4 19.9 14.9c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-19.9 14.9 7.6 11.4c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H343c-10.1 0-17.7 9.2-15.7 19.1l24.3 121.7c1.2 6.2-1.2 12.5-6.3 16.1s-11.8 4-17.3 .9L287.9 391c-4.9-2.8-11-2.8-15.9 0l-40.1 22.9c-4.9 2.8-11 2.8-15.9 0L175.9 391c-4.9-2.8-11-2.8-15.9 0l-40.1 22.9c-5.4 3.1-12.2 2.8-17.3-.9s-7.6-10-6.3-16.1l24.3-121.7c2-9.9-5.6-19.1-15.7-19.1H32c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l7.6-11.4L6.4 204.8C2.4 201.8 0 197 0 192s2.4-9.8 6.4-12.8l19.9-14.9-7.6-11.4c-3.3-4.9-3.6-11.2-.8-16.4s8.2-8.5 14.1-8.5H133.5c-3.5-10-5.5-20.8-5.5-32c0-53 43-96 96-96s96 43 96 96zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 480V427.8l12.2 6.9c12.3 7 27.4 7 39.7 0l12.2-6.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]
};
var faTruckMonster = {
  prefix: 'fas',
  iconName: 'truck-monster',
  icon: [640, 512, [], "f63b", "M288 64v64H416L368 64H288zM419.2 25.6L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64H288c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H224V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6zM152 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512H152c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512H472c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faGiftCard = {
  prefix: 'fas',
  iconName: 'gift-card',
  icon: [576, 512, [], "f663", "M353.5 68.8C361.1 55.9 374.9 48 389.8 48H392c22.1 0 40 17.9 40 40s-17.9 40-40 40H320h-1.3l34.8-59.2zm-131 0L257.3 128H256 184c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zm89.6-24.3L288 85.5l-24.1-41C247.7 16.9 218.1 0 186.2 0H184C135.4 0 96 39.4 96 88c0 14.4 3.5 28 9.6 40H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H470.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4zM512 384v64H64V384H512zm0-64H64V192H230.1l-40.5 48.6c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1L288 197.5l61.6 73.9c8.5 10.2 23.6 11.6 33.8 3.1s11.6-23.6 3.1-33.8L345.9 192H512V320z"]
};
var faW = {
  prefix: 'fas',
  iconName: 'w',
  icon: [576, 512, [119], "57", "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"]
};
var faCodePullRequestDraft = {
  prefix: 'fas',
  iconName: 'code-pull-request-draft',
  icon: [448, 512, [], "e3fa", "M56 80a24 24 0 1 1 48 0A24 24 0 1 1 56 80zm56 73.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V153.3zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm312-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM416 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faSquareB = {
  prefix: 'fas',
  iconName: 'square-b',
  icon: [448, 512, [], "e264", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 120c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76H152c-13.3 0-24-10.7-24-24V256 152zm144 52c0-15.5-12.5-28-28-28H176v56h68c15.5 0 28-12.5 28-28zM176 336h84c15.5 0 28-12.5 28-28s-12.5-28-28-28H244 176v56z"]
};
var faElephant = {
  prefix: 'fas',
  iconName: 'elephant',
  icon: [640, 512, [128024], "f6da", "M304 0C242.1 0 192 50.1 192 112s50.1 112 112 112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-79.5 0-144-64.5-144-144c0-25.3 6.5-49.1 18-69.8c-20.5 7-39.4 17.3-56.1 30.4C67.4 111.9 32 175.8 32 248v19c0 12.4-1.2 24.7-3.7 36.9c-1.9 9.3-5.8 18-11.4 25.6L4.8 345.6c-8 10.6-5.8 25.6 4.8 33.6s25.6 5.8 33.6-4.8l12.1-16.2c3.2-4.3 6.1-8.8 8.7-13.5V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V410c15.3 3.9 31.4 6 48 6s32.7-2.1 48-6v70c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V340.7c16.7 18.9 38.8 32.8 64 39.3v18.6c0 45 36.5 81.4 81.4 81.4c30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6c-9.6 0-17.4-7.8-17.4-17.4V380c22.9-5.9 43.4-18 59.4-34.4c6.2-6.3 6.1-16.4-.2-22.6c-6.3-6.2-16.3-6.1-22.5 .1c-1.3 1.3-2.6 2.6-4 3.9c-1.5 1.4-3.1 2.7-4.6 4c-8.3 6.7-17.8 12-28 15.6v0c-10 3.5-20.8 5.5-32 5.5s-22-1.9-32-5.5v0c-7.5-2.6-14.6-6.2-21.1-10.5h0c-9.1-6.1-17.2-13.7-23.7-22.4c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2C472.5 310 491.1 320 512 320c11.7 0 22.6-3.1 32-8.6V192c0-88.4-71.6-160-160-160h-1.6C362.2 12.2 334.5 0 304 0zM464 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faEarthAfrica = {
  prefix: 'fas',
  iconName: 'earth-africa',
  icon: [512, 512, [127757, "globe-africa"], "f57c", "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faGlobeAfrica = faEarthAfrica;
var faRainbow = {
  prefix: 'fas',
  iconName: 'rainbow',
  icon: [640, 512, [127752], "f75b", "M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-35.3-28.7-64-64-64zM160 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-88.4-71.6-160-160-160s-160 71.6-160 160z"]
};
var faCircleNotch = {
  prefix: 'fas',
  iconName: 'circle-notch',
  icon: [512, 512, [], "f1ce", "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"]
};
var faTabletScreenButton = {
  prefix: 'fas',
  iconName: 'tablet-screen-button',
  icon: [448, 512, ["tablet-alt"], "f3fa", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64H64V384H384V64z"]
};
var faTabletAlt = faTabletScreenButton;
var faPaw = {
  prefix: 'fas',
  iconName: 'paw',
  icon: [512, 512, [], "f1b0", "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"]
};
var faMessageQuestion = {
  prefix: 'fas',
  iconName: 'message-question',
  icon: [512, 512, [], "e1e3", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm169.8 53.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCloud = {
  prefix: 'fas',
  iconName: 'cloud',
  icon: [640, 512, [9729], "f0c2", "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"]
};
var faTrowelBricks = {
  prefix: 'fas',
  iconName: 'trowel-bricks',
  icon: [512, 512, [], "e58a", "M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48H376c-14.9 0-27.4-10.2-31-24H256v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm192 0H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"]
};
var faSquare3 = {
  prefix: 'fas',
  iconName: 'square-3',
  icon: [448, 512, [], "e258", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H280c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2H208c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L218.3 176H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faFaceFlushed = {
  prefix: 'fas',
  iconName: 'face-flushed',
  icon: [512, 512, [128563, "flushed"], "f579", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faFlushed = faFaceFlushed;
var faHospitalUser = {
  prefix: 'fas',
  iconName: 'hospital-user',
  icon: [576, 512, [], "f80d", "M48 0C21.5 0 0 21.5 0 48V256H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48H265.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM152 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V152H112c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"]
};
var faMicrowave = {
  prefix: 'fas',
  iconName: 'microwave',
  icon: [576, 512, [], "e01b", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32H128c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64V96zm96 56V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm400-40c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16z"]
};
var faChfSign = {
  prefix: 'fas',
  iconName: 'chf-sign',
  icon: [640, 512, [], "e602", "M0 113.4C0 68.5 36.5 32 81.4 32c30.8 0 59 17.4 72.8 45l2.3 4.7c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L97 105.6c-3-5.9-9-9.6-15.6-9.6C71.8 96 64 103.8 64 113.4V398.6c0 9.6 7.8 17.4 17.4 17.4c6.6 0 12.6-3.7 15.6-9.6l2.3-4.7c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.3 4.7c-13.8 27.6-42 45-72.8 45C36.5 480 0 443.5 0 398.6V113.4zM224 32c17.7 0 32 14.3 32 32V224h96V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H256V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM448 64c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V224h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64z"]
};
var faTentArrowLeftRight = {
  prefix: 'fas',
  iconName: 'tent-arrow-left-right',
  icon: [576, 512, [], "e57f", "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"]
};
var faCartCircleArrowUp = {
  prefix: 'fas',
  iconName: 'cart-circle-arrow-up',
  icon: [640, 512, [], "e3f0", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM428.7 371.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.6l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"]
};
var faTrashClock = {
  prefix: 'fas',
  iconName: 'trash-clock',
  icon: [576, 512, [], "e2b0", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H330.8C285.6 480.1 256 427.5 256 368c0-90.4 68.2-164.9 155.9-174.9L416 128zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faGavel = {
  prefix: 'fas',
  iconName: 'gavel',
  icon: [512, 512, ["legal"], "f0e3", "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"]
};
var faLegal = faGavel;
var faSprinklerCeiling = {
  prefix: 'fas',
  iconName: 'sprinkler-ceiling',
  icon: [384, 512, [], "e44c", "M0 0V96c0 15.3 10.8 28.4 25.7 31.4L128 147.8V82.6L64 69.8V0H0zM256 82.6v65.3l102.3-20.5c15-3 25.7-16.1 25.7-31.4V0H320V69.8L256 82.6zM160 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-48 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM24 496a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM272 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V64z"]
};
var faBrowsers = {
  prefix: 'fas',
  iconName: 'browsers',
  icon: [576, 512, [], "e0cb", "M160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zM280 72H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24zM224 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faTrillium = {
  prefix: 'fas',
  iconName: 'trillium',
  icon: [448, 512, [], "e588", "M128 160c0-64.1 61.6-128.2 86.1-151.1c5.6-5.3 14.1-5.3 19.8 0c24.5 23 86.1 87 86.1 151.1c0 15.7-3.7 30.4-10.4 43.5c16.2 0 32.6 4.2 47.7 12.9c55.5 32 80.2 117.4 87.8 150.2c1.8 7.5-2.5 14.9-9.9 17.1c-32.1 9.7-118.4 31.1-173.9-1c-16.6-9.6-29.2-23.3-37.4-39.2c-8.1 15.9-20.8 29.6-37.4 39.2c-55.5 32-141.8 10.7-173.9 1c-7.4-2.2-11.6-9.6-9.9-17.1c7.6-32.7 32.3-118.1 87.8-150.2c15.1-8.7 31.6-12.9 47.8-12.9C131.7 190.4 128 175.7 128 160zm136 80a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm88-80v0c0-12.5-1.8-24.8-4.8-36.6c38.6-12.8 68.2-11.9 83-10c14.9 1.9 23.7 17.1 17.9 31c-5.6 13.3-19 38.4-47.7 64.6c-8.1-7.7-17.1-14.6-27-20.3l0 0c-7.3-4.2-14.9-7.6-22.6-10.3c.9-6 1.3-12.1 1.3-18.4zM100.8 123.4c-3 11.8-4.8 24.1-4.8 36.6c0 6.2 .4 12.3 1.3 18.3c-7.8 2.7-15.4 6.1-22.7 10.3l0 0c-9.9 5.7-18.8 12.6-26.9 20.2C19 182.7 5.6 157.6 0 144.3c-5.8-13.8 3-29.1 17.9-31c14.7-1.9 44.4-2.8 83 10zm73.3 299.4c9.8-3.1 19.4-7.2 28.5-12.5c7.8-4.5 14.9-9.7 21.4-15.4c6.5 5.8 13.6 11 21.4 15.4c9.2 5.3 18.8 9.4 28.6 12.5c-8.2 36.1-22.6 61.6-31 74.2c-9.1 13.7-28.8 13.7-37.9 0c-8.3-12.6-22.8-38.2-31-74.3z"]
};
var faMusicSlash = {
  prefix: 'fas',
  iconName: 'music-slash',
  icon: [640, 512, [], "f8d1", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-71.5-56C569.8 400.2 576 384.7 576 368V104 32c0-10.1-4.8-19.6-12.9-25.7s-18.6-7.9-28.3-5l-320 96c-12.7 3.8-21.6 14.9-22.7 27.9L38.8 5.1zM300.7 210.4L512 147V292.6c-10-2.9-20.8-4.6-32-4.6c-22.2 0-42.6 6.3-58.8 16.8L300.7 210.4zM192 247.3V356.6c-10-3-20.8-4.6-32-4.6c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80V297.7l-64-50.4z"]
};
var faTruckRamp = {
  prefix: 'fas',
  iconName: 'truck-ramp',
  icon: [640, 512, [], "f4e0", "M640 400V0H416c-35.3 0-64 28.7-64 64V353.8L31.6 441.1c-17.1 4.6-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5L416 402.7C417.5 463.3 467 512 528 512c61.9 0 112-50.1 112-112zM528 352a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faBinoculars = {
  prefix: 'fas',
  iconName: 'binoculars',
  icon: [512, 512, [], "f1e5", "M128 32h32c17.7 0 32 14.3 32 32V96H96V64c0-17.7 14.3-32 32-32zm64 96V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V388.9c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28H192zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128h99.8zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96H320V64zm-32 64V288H224V128h64z"]
};
var faMicrophoneSlash = {
  prefix: 'fas',
  iconName: 'microphone-slash',
  icon: [640, 512, [], "f131", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM344 430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4z"]
};
var faBoxTissue = {
  prefix: 'fas',
  iconName: 'box-tissue',
  icon: [512, 512, [], "e05b", "M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H418.5l25.6-64H464c26.5 0 48 21.5 48 48V384H0V272c0-26.5 21.5-48 48-48H79zM0 416H512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416z"]
};
var faCircleC = {
  prefix: 'fas',
  iconName: 'circle-c',
  icon: [512, 512, [], "e101", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"]
};
var faStarChristmas = {
  prefix: 'fas',
  iconName: 'star-christmas',
  icon: [512, 512, [], "f7d4", "M15.5 275.9L192 320l44.1 176.5c2.3 9.1 10.5 15.5 19.9 15.5s17.6-6.4 19.9-15.5L320 320l176.5-44.1c9.1-2.3 15.5-10.5 15.5-19.9s-6.4-17.6-15.5-19.9L320 192 275.9 15.5C273.6 6.4 265.4 0 256 0s-17.6 6.4-19.9 15.5L192 192 15.5 236.1C6.4 238.4 0 246.6 0 256s6.4 17.6 15.5 19.9zM71 71c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L105 71c-9.4-9.4-24.6-9.4-33.9 0zM441 71c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9zm0 336l-48-48c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM71 441c9.4 9.4 24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 407c-9.4 9.4-9.4 24.6 0 33.9z"]
};
var faChartBullet = {
  prefix: 'fas',
  iconName: 'chart-bullet',
  icon: [512, 512, [], "e0e1", "M264 32c13.3 0 24 10.7 24 24v8H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48c-26.5 0-48-21.5-48-48V112C0 85.5 21.5 64 48 64H240V56c0-13.3 10.7-24 24-24zM160 128v32h80V128H160zm128 0v32H448V128H288zm48 256V352H256v32h80zm0 64H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H336v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h80c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H384v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8zm48-96v32h64V352H384z"]
};
var faMotorcycle = {
  prefix: 'fas',
  iconName: 'motorcycle',
  icon: [640, 512, [127949], "f21c", "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H187.3zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faTreeChristmas = {
  prefix: 'fas',
  iconName: 'tree-christmas',
  icon: [448, 512, [127876], "f7db", "M150.2 71l47.1-17.7L215 6.2c1.4-3.8 5-6.2 9-6.2s7.6 2.5 9 6.2l17.7 47.1L297.8 71c3.8 1.4 6.2 5 6.2 9s-2.5 7.6-6.2 9l-47.1 17.7L233 153.8c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2l-17.7-47.1L150.2 89c-3.8-1.4-6.2-5-6.2-9s2.5-7.6 6.2-9zM263 165l11.8-31.5 144 180c3.4 4.2 5.2 9.4 5.2 14.8c0 13.1-10.6 23.7-23.7 23.7H368l76.2 122c2.5 4 3.8 8.5 3.8 13.2c0 13.7-11.1 24.9-24.9 24.9H24.9C11.1 512 0 500.9 0 487.1c0-4.7 1.3-9.2 3.8-13.2L80 352H47.7C34.6 352 24 341.4 24 328.3c0-5.4 1.8-10.6 5.2-14.8l144-180L185 165c6.1 16.2 21.6 27 39 27s32.9-10.8 39-27zM184 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM288 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faTireFlat = {
  prefix: 'fas',
  iconName: 'tire-flat',
  icon: [512, 512, [], "f632", "M256 32C114.6 32 0 146.6 0 288c0 47.3 12.8 91.7 35.2 129.7C14.9 423.3 0 441.9 0 464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48c0-22.1-14.9-40.7-35.2-46.3c22.4-38 35.2-82.4 35.2-129.7C512 146.6 397.4 32 256 32zm96 384c-2.1 1.6-4.3 3.2-6.6 4.7C319.9 437.9 289.1 448 256 448c-36 0-69.3-11.9-96-32c-38.9-29.2-64-75.7-64-128c0-88.4 71.6-160 160-160s160 71.6 160 160c0 52.3-25.1 98.8-64 128zm-96-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm16 95c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6l0 65zM381.7 312.2c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4l61.8 20.1zM256 224c8.3 0 16.3 1.6 23.6 4.5l38.2-52.6C299.5 165.8 278.4 160 256 160s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5zM128 288c0 8.3 .8 16.3 2.3 24.2L192.1 292c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 218.1 128 251.2 128 288zm12.2 54.6c18.3 38.8 55.5 66.9 99.8 72.4l0-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1z"]
};
var faSunglasses = {
  prefix: 'fas',
  iconName: 'sunglasses',
  icon: [576, 512, [128374], "f892", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368l105.6-52.8c-10.7-1.9-22.2-3.2-33.9-3.2c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zm409.8-10.3c-10.5-1.9-21.9-3.1-33.4-3.1c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.3 41.2 102.3-51.1z"]
};
var faBadge = {
  prefix: 'fas',
  iconName: 'badge',
  icon: [512, 512, [], "f335", "M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9z"]
};
var faMessagePen = {
  prefix: 'fas',
  iconName: 'message-pen',
  icon: [512, 512, ["comment-alt-edit", "message-edit"], "f4a4", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm340.8 59c-14.7-14.7-38.6-14.7-53.3 0L272.6 138l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 232.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 284c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 160.6l-71.9 71.9z"]
};
var faCommentAltEdit = faMessagePen;
var faMessageEdit = faMessagePen;
var faBellConcierge = {
  prefix: 'fas',
  iconName: 'bell-concierge',
  icon: [512, 512, [128718, "concierge-bell"], "f562", "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faConciergeBell = faBellConcierge;
var faPenRuler = {
  prefix: 'fas',
  iconName: 'pen-ruler',
  icon: [512, 512, ["pencil-ruler"], "f5ae", "M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"]
};
var faPencilRuler = faPenRuler;
var faArrowProgress = {
  prefix: 'fas',
  iconName: 'arrow-progress',
  icon: [512, 512, [], "e5df", "M448 128A64 64 0 1 0 448 0a64 64 0 1 0 0 128zM128 32C57.3 32 0 89.3 0 160s57.3 128 128 128H384c35.3 0 64 28.7 64 64c0 27.9-17.9 51.7-42.8 60.4c-11.5-17.1-31-28.4-53.2-28.4c-35.3 0-64 28.7-64 64s28.7 64 64 64c24.7 0 46.1-14 56.8-34.4C467.6 466.1 512 414.2 512 352c0-70.7-57.3-128-128-128H128c-35.3 0-64-28.7-64-64s28.7-64 64-64H256v14.1c0 9.9 8 17.9 17.9 17.9c4 0 7.8-1.3 11-3.8l60.8-47.3c4-3.1 6.3-7.9 6.3-12.9s-2.3-9.8-6.3-12.9L284.8 3.8c-3.1-2.4-7-3.8-11-3.8C264 0 256 8 256 17.9V32H128zm-8.6 384c-11.1-19.1-31.7-32-55.4-32c-35.3 0-64 28.7-64 64s28.7 64 64 64c23.7 0 44.4-12.9 55.4-32H160v14.1c0 9.9 8 17.9 17.9 17.9c4 0 7.8-1.3 11-3.8l60.8-47.3c4-3.1 6.3-7.9 6.3-12.9s-2.3-9.8-6.3-12.9l-60.8-47.3c-3.1-2.4-7-3.8-11-3.8c-9.9 0-17.9 8-17.9 17.9V416H119.4z"]
};
var faChessRookPiece = {
  prefix: 'fas',
  iconName: 'chess-rook-piece',
  icon: [320, 512, ["chess-rook-alt"], "f448", "M67.4 384L80 264 49.4 233.4c-6-6-9.4-14.1-9.4-22.6V112c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V112c0-8.8 7.2-16 16-16h24c8.8 0 16 7.2 16 16v98.7c0 8.5-3.4 16.6-9.4 22.6L240 264l12.6 120H67.4zM136 280.9c0 3.9 3.2 7.1 7.1 7.1h33.8c3.9 0 7.1-3.2 7.1-7.1V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v32.9zM20.8 473.6L64 416H256l43.2 57.6c3.1 4.2 4.8 9.2 4.8 14.4c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24c0-5.2 1.7-10.2 4.8-14.4z"]
};
var faChessRookAlt = faChessRookPiece;
var faSquareRoot = {
  prefix: 'fas',
  iconName: 'square-root',
  icon: [576, 512, [8730], "f697", "M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1z"]
};
var faAlbumCollectionCirclePlus = {
  prefix: 'fas',
  iconName: 'album-collection-circle-plus',
  icon: [640, 512, [], "e48e", "M32 24c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C42.7 0 32 10.7 32 24zM48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214l32 256c3 24 23.4 42 47.6 42H394.8c-18.9-13.3-35.1-30.3-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9C154.4 480 72 419.1 72 344s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2c31.5-29.9 74.2-48.2 121-48.2c4.5 0 9 .2 13.4 .5c-2-5.9-5.2-11.5-9.4-16.3c-9.1-10.3-22.2-16.2-36-16.2H48zM256 376c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H472c13.3 0 24-10.7 24-24s-10.7-24-24-24H40zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H512v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPeopleArrows = {
  prefix: 'fas',
  iconName: 'people-arrows',
  icon: [640, 512, ["people-arrows-left-right"], "e068", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V391.2l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96V240c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V336H272v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"]
};
var faPeopleArrowsLeftRight = faPeopleArrows;
var faFaceAngryHorns = {
  prefix: 'fas',
  iconName: 'face-angry-horns',
  icon: [640, 512, [], "e368", "M576 256c0 141.4-114.6 256-256 256S64 397.4 64 256c0-24.6 3.5-48.4 9.9-70.9C29.6 125.8 6.5 50.1 .3 19.1C-1 12.8 1.7 6.3 7.1 2.7s12.4-3.6 17.8 0c19.3 12.9 48.5 24.2 78.4 33.1c23.3 7 46 12.2 63 15.5C209.1 19.1 262.3 0 320 0s110.9 19.1 153.8 51.3c17-3.3 39.7-8.6 63-15.5c29.8-8.9 59.1-20.2 78.4-33.1c5.4-3.6 12.4-3.6 17.8 0s8.1 10.1 6.8 16.4c-6.2 31-29.3 106.6-73.6 166c6.5 22.5 9.9 46.3 9.9 70.9zM402.7 411.9c6.6-5.9 7.1-16 1.2-22.6C387.8 371.4 359.7 352 320 352s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM240.4 296c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faMarsAndVenusBurst = {
  prefix: 'fas',
  iconName: 'mars-and-venus-burst',
  icon: [640, 512, [], "e523", "M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59.1 146.7 136.1 158.2c0 .6-.1 1.2-.1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3H352c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l24 0H376c0 13.3 10.7 24 24 24s24-10.7 24-24H400l24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H424v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2-.1-1.8c77-11.6 136.1-78 136.1-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"]
};
var faTombstone = {
  prefix: 'fas',
  iconName: 'tombstone',
  icon: [448, 512, [], "f720", "M32 192C32 86 118 0 224 0S416 86 416 192V416H32V192zM0 480c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM248 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h48V328c0 13.3 10.7 24 24 24s24-10.7 24-24V208h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V120z"]
};
var faSquareCaretRight = {
  prefix: 'fas',
  iconName: 'square-caret-right',
  icon: [448, 512, ["caret-square-right"], "f152", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"]
};
var faCaretSquareRight = faSquareCaretRight;
var faScissors = {
  prefix: 'fas',
  iconName: 'scissors',
  icon: [512, 512, [9984, 9986, 9988, "cut"], "f0c4", "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCut = faScissors;
var faListMusic = {
  prefix: 'fas',
  iconName: 'list-music',
  icon: [512, 512, [], "f8c9", "M498.7 6c8.3 6 13.3 15.7 13.3 26V96c0 13.8-8.8 26-21.9 30.4L416 151.1V432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c17.2 0 33.5 2.8 48 7.7V128 64c0-13.8 8.8-26 21.9-30.4l96-32C479.6-1.6 490.4 0 498.7 6zM32 64H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96S14.3 64 32 64zm0 128H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faSunPlantWilt = {
  prefix: 'fas',
  iconName: 'sun-plant-wilt',
  icon: [640, 512, [], "e57a", "M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v8V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V280v-8V176z"]
};
var faToiletsPortable = {
  prefix: 'fas',
  iconName: 'toilets-portable',
  icon: [576, 512, [], "e584", "M32 0H224c17.7 0 32 14.3 32 32V64H0V32C0 14.3 14.3 0 32 0zM0 96H24 232h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM192 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM352 0H544c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32zM320 96h24H552h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM512 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"]
};
var faHockeyPuck = {
  prefix: 'fas',
  iconName: 'hockey-puck',
  icon: [512, 512, [], "f453", "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"]
};
var faMustache = {
  prefix: 'fas',
  iconName: 'mustache',
  icon: [640, 512, [], "e5bc", "M147.9 148.4C169.3 125.2 199.4 112 231 112c33 0 64.4 14.4 85.9 39.5l3.1 3.6 3.1-3.6C344.6 126.4 376 112 409 112c31.6 0 61.7 13.2 83.1 36.4l2 2.1c27.6 29.9 74.6 30.9 103.4 2.1L599 151c2.5-2.5 5.5-4.4 8.6-5.5c2.6-1 5.4-1.5 8.4-1.5c5.7 0 10.9 2 15 5.2c1.3 1.1 2.6 2.3 3.6 3.6c.4 .5 .7 1 1.1 1.4c.3 .4 .5 .8 .7 1.1c.3 .5 .6 .9 .8 1.4c1.8 3.3 2.7 7.1 2.7 11.2v39.4C640 313.8 553.8 400 447.4 400c-46.7 0-91.7-16.9-126.9-47.7l-.5-.4-.5 .4C284.4 383.1 239.3 400 192.6 400C86.2 400 0 313.8 0 207.4V168c0-4.2 1.1-8.1 2.9-11.5c.6-1 1.2-2.1 2-3c1.2-1.6 2.6-3 4.1-4.2c1.5-1.2 3.1-2.2 4.8-3c3.1-1.5 6.5-2.3 10.2-2.3c2.9 0 5.8 .5 8.4 1.5c3.1 1.2 6.1 3 8.6 5.5l1.6 1.6c28.8 28.8 75.8 27.9 103.4-2.1l2-2.1z"]
};
var faHyphen = {
  prefix: 'fas',
  iconName: 'hyphen',
  icon: [320, 512, [], "2d", "M0 256c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
};
var faTable = {
  prefix: 'fas',
  iconName: 'table',
  icon: [512, 512, [], "f0ce", "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faUserChef = {
  prefix: 'fas',
  iconName: 'user-chef',
  icon: [448, 512, [], "e3d2", "M384 48c0 20.9-13.4 38.7-32 45.3V112v64c0 70.7-57.3 128-128 128s-128-57.3-128-128V112 93.3C77.4 86.7 64 68.9 64 48C64 21.5 85.5 0 112 0c14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zM304 176V160H144v16c0 44.2 35.8 80 80 80s80-35.8 80-80zM178.4 340.6c7.5 1.9 8.2 12.3 1 15.2l-43.2 17.3C111.9 382.8 96 406.3 96 432.5V480v24 8H88 64 25.6C11.5 512 0 500.5 0 486.4c0-58.8 37.7-108.8 90.3-127c3.3-1.2 5.7-4.3 5.7-7.8V330.2c0-5.2 4.9-9 9.9-7.8l72.5 18.1zM352 512H160 136h-8v-8V480 432.5c0-13.1 8-24.9 20.1-29.7L341 325.6c5.3-2.1 11 1.8 11 7.4v18.6c0 3.5 2.3 6.6 5.7 7.8c52.6 18.2 90.3 68.2 90.3 127c0 14.1-11.5 25.6-25.6 25.6H352zM224 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faMessageImage = {
  prefix: 'fas',
  iconName: 'message-image',
  icon: [512, 512, ["comment-alt-image"], "e1e0", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm176 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm120 0c-8 0-15.5 4-20 10.7l-56 84L202.7 201c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H392c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C311.5 132 304 128 296 128z"]
};
var faCommentAltImage = faMessageImage;
var faUsersMedical = {
  prefix: 'fas',
  iconName: 'users-medical',
  icon: [640, 512, [], "f830", "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM405.3 320h77.4c6.6-18.6 24.4-32 45.3-32h32c20.9 0 38.7 13.4 45.3 32h13.4c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM416 400c0-14.6 6.5-27.7 16.9-36.5C416.3 356.1 398 352 378.7 352H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H482.7c-1.8-5-2.7-10.4-2.7-16V480H464c-26.5 0-48-21.5-48-48V400zm0-176a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm96 112v48H464c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448h48c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H576V336c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16z"]
};
var faSensorTriangleExclamation = {
  prefix: 'fas',
  iconName: 'sensor-triangle-exclamation',
  icon: [640, 512, ["sensor-alert"], "e029", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H225c-.6-4-1-8.1-1-12.3c0-13.2 3.4-26.2 9.9-37.7l150.4-265c13-22.9 37.3-37.1 63.7-37.1V96c0-35.3-28.7-64-64-64H64zm48 88V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm53.8 325.8c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3H595.7c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9l-150.4 265zM464 272v88c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8 7.2-16 16-16s16 7.2 16 16zM448 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSensorAlert = faSensorTriangleExclamation;
var faMagnifyingGlassArrowRight = {
  prefix: 'fas',
  iconName: 'magnifying-glass-arrow-right',
  icon: [512, 512, [], "e521", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H238.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"]
};
var faTachographDigital = {
  prefix: 'fas',
  iconName: 'tachograph-digital',
  icon: [640, 512, ["digital-tachograph"], "f566", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faDigitalTachograph = faTachographDigital;
var faFaceMask = {
  prefix: 'fas',
  iconName: 'face-mask',
  icon: [576, 512, [], "e37f", "M410.5 281.7L541.8 222C525.1 96.7 417.9 0 288 0S50.9 96.7 34.2 222l131.3 59.7c8-15.3 24.1-25.7 42.5-25.7H368c18.4 0 34.5 10.4 42.5 25.7zm5.5 32.6V384h93.8c21.8-37.6 34.2-81.3 34.2-127.9L416 314.3zM413.3 416c-6.6 18.6-24.4 32-45.3 32H208c-20.9 0-38.7-13.4-45.3-32H88.1c46.9 58.5 119 96 199.9 96s152.9-37.5 199.9-96H413.3zM160 384V314.3L32 256.1c0 46.6 12.5 90.3 34.2 127.9H160zm-4.7-180.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C146.4 167 184.6 144 240 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-47 0-77.1 19.7-84.7 27.3zM336 176c-8.8 0-16-7.2-16-16s7.2-16 16-16c55.4 0 93.6 23 107.3 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C413.1 195.7 383 176 336 176zM208 304c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]
};
var faPickleball = {
  prefix: 'fas',
  iconName: 'pickleball',
  icon: [576, 512, [], "e435", "M250.4 28c37.5-37.4 98.4-37.4 136 0L499.9 141.3c29.2 29.2 35.7 72.4 19.4 107.8c-24.9-15.8-54.4-25-86.1-25c-72 0-133 47.3-153.3 112.5L155.7 212.8c-6.3-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L273 374.9c-.2 3-.3 6.1-.3 9.1c0 27.8 7.1 53.8 19.6 76.6c-9.3 .5-18.7-1-27.6-4.7l-56.7-23.2c-23.9-9.8-51.4-4.3-69.6 13.9L84.4 500.3c-15.6 15.6-41 15.6-56.7 0s-15.6-40.9 0-56.5l53.5-53.4c18.4-18.3 23.8-45.8 13.9-69.8L71.1 262.8c-10-23.9-4.5-51.4 13.9-69.7L250.4 28zM304 384a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm32-16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-80-80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z"]
};
var faStarSharpHalf = {
  prefix: 'fas',
  iconName: 'star-sharp-half',
  icon: [576, 512, [], "e28c", "M254.4 50.4L214.5 176H90.3 88 74.7 56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L56 230.4l10.5 8.2 1.8 1.4 103.7 80.7L132 446.7l-1.1 3.5L126.1 465l-5 15.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7l13-10.1 12.3-9.5 2.9-2.3L288 406.4V325.3 155.9 0c-10.5 0-19.7 6.8-22.9 16.7L260 32.9l0 0-4.6 14.3-1 3.2z"]
};
var faUsersSlash = {
  prefix: 'fas',
  iconName: 'users-slash',
  icon: [640, 512, [], "e073", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192H106.7zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.5-6 23.9-14.8L324.9 352H261.3zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"]
};
var faClover = {
  prefix: 'fas',
  iconName: 'clover',
  icon: [448, 512, [], "e139", "M173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4H61.3C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3h-4.9c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34V93.3C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2C205.1 38.5 189.5 32 173.3 32z"]
};
var faMeat = {
  prefix: 'fas',
  iconName: 'meat',
  icon: [512, 512, [127830], "f814", "M243.6 19.6C283.7-20.4 371.9 2.8 440.5 71.5s91.9 156.8 51.8 196.9l-40.5 40.5C403.9 357 338.7 384 270.8 384H212.6c-7.1 0-13.9 2.8-18.9 7.8c-10.3 10.3-9.7 26.9-5 40.7c2.1 6.1 3.2 12.7 3.2 19.5c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c6.8 0 13.4 1.1 19.5 3.2c13.8 4.7 30.4 5.3 40.7-5c5-5 7.8-11.8 7.8-18.9V241.3c0-67.9 27-133 75-181l40.7-40.7zm64 184.8c49.6 49.6 113.3 66.4 142.2 37.4s12.2-92.6-37.4-142.2S299.1 33.2 270.2 62.2s-12.2 92.6 37.4 142.2zm36.3-36.3c-15.3-15.3-20.4-34.9-11.5-43.8s28.5-3.7 43.8 11.5s20.4 34.9 11.5 43.8s-28.5 3.7-43.8-11.5z"]
};
var faReply = {
  prefix: 'fas',
  iconName: 'reply',
  icon: [512, 512, [61714, "mail-reply"], "f3e5", "M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"]
};
var faMailReply = faReply;
var faStarAndCrescent = {
  prefix: 'fas',
  iconName: 'star-and-crescent',
  icon: [512, 512, [9770], "f699", "M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256zM375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"]
};
var faEmptySet = {
  prefix: 'fas',
  iconName: 'empty-set',
  icon: [512, 512, [8709, 216], "f656", "M435.4 121.9l67.2-67.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L390.2 76.6C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l67.2-67.2c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1zm-91.2 .7L122.5 344.2C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5zm-176.5 267L389.5 167.8C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5z"]
};
var faHouseFire = {
  prefix: 'fas',
  iconName: 'house-fire',
  icon: [640, 512, [], "e50c", "M288 350.1l0 1.9H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM453.5 163.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM530 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"]
};
var faSquareMinus = {
  prefix: 'fas',
  iconName: 'square-minus',
  icon: [448, 512, [61767, "minus-square"], "f146", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMinusSquare = faSquareMinus;
var faHelicopter = {
  prefix: 'fas',
  iconName: 'helicopter',
  icon: [640, 512, [128641], "f533", "M128 32c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H384 320c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128H320V64H160c-17.7 0-32-14.3-32-32zM384 320H512V288c0-53-43-96-96-96H384V320zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H536.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"]
};
var faBird = {
  prefix: 'fas',
  iconName: 'bird',
  icon: [512, 512, [], "e469", "M0 192v-3.6C0 172.7 12.7 160 28.4 160H224c17.7 0 32-14.3 32-32V96c0-53 43-96 96-96c47.5 0 86.9 34.5 94.6 79.7l57.6 34.6c4.8 2.9 7.8 8.1 7.8 13.7s-2.9 10.8-7.8 13.7L448 175.5V192c0 93.9-57.7 174.3-139.7 207.6l40.9 77.2c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-45.7-86.3C249 415 236.6 416 224 416c-1 0-2 0-3 0l32.2 60.8c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-48.6-91.9C68.5 380.5 0 294.3 0 192zm376-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCompass = {
  prefix: 'fas',
  iconName: 'compass',
  icon: [512, 512, [129517], "f14e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSquareCaretDown = {
  prefix: 'fas',
  iconName: 'square-caret-down',
  icon: [448, 512, ["caret-square-down"], "f150", "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"]
};
var faCaretSquareDown = faSquareCaretDown;
var faHeartHalfStroke = {
  prefix: 'fas',
  iconName: 'heart-half-stroke',
  icon: [512, 512, ["heart-half-alt"], "e1ac", "M256 186.5V407.4L420.7 253.6c17.4-16.2 27.3-38.9 27.3-62.7v-5.8c0-38.6-27.9-71.5-66-77.9c-25.1-4.2-50.8 4-68.8 22l-12 12L256 186.5zM119.4 44.1C165 36.5 211.3 51.4 244 84l0 0 12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"]
};
var faHeartHalfAlt = faHeartHalfStroke;
var faFileCircleQuestion = {
  prefix: 'fas',
  iconName: 'file-circle-question',
  icon: [576, 512, [], "e4ef", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"]
};
var faLaptopCode = {
  prefix: 'fas',
  iconName: 'laptop-code',
  icon: [640, 512, [], "f5fc", "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faJoystick = {
  prefix: 'fas',
  iconName: 'joystick',
  icon: [448, 512, [128377], "f8c5", "M336 112c0 50.7-33.7 93.6-80 107.4V320H192V219.4c-46.3-13.8-80-56.6-80-107.4C112 50.1 162.1 0 224 0s112 50.1 112 112zM200 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM64 352c0-17.7 14.3-32 32-32s32 14.3 32 32H384c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64z"]
};
var faGrillFire = {
  prefix: 'fas',
  iconName: 'grill-fire',
  icon: [576, 512, [], "e5a4", "M0 72C0 49.9 17.9 32 40 32H408c22.1 0 40 17.9 40 40V96c0 24.1-3.8 47.3-10.9 69.1c-8.5-8.6-17.2-17-26.2-25.1c-17.7-16-44.7-16-62.5-.1c-35.4 31.6-65.6 67.7-87.3 102.8c-15 24.3-27.7 51-33.6 77.3c-1.2 0-2.4 0-3.6 0c-16.9 0-33.4-1.9-49.3-5.4L151.8 368h73c1.5 16.6 5.2 32.7 10.7 48H160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96V72zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM389.5 163.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 56.7 24.2 76.9C576 437.9 504.7 512 416 512c-89.7 0-160-74.2-160-161.9c0-26.4 12.7-58.6 32.4-90.6c20-32.4 48.1-66.1 81.4-95.8c5.6-5 14.2-5 19.8 0zM466 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"]
};
var faRectangleVerticalHistory = {
  prefix: 'fas',
  iconName: 'rectangle-vertical-history',
  icon: [576, 512, [], "e237", "M256 0c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H256zM96 72V440c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-13.3-10.7-24-24-24s-24 10.7-24 24zM0 120V392c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24S0 106.7 0 120z"]
};
var faSwatchbook = {
  prefix: 'fas',
  iconName: 'swatchbook',
  icon: [512, 512, [], "f5c3", "M0 32C0 14.3 14.3 0 32 0H160c17.7 0 32 14.3 32 32V416c0 53-43 96-96 96s-96-43-96-96V32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192H480c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H182.8zM128 64H64v64h64V64zM64 192v64h64V192H64zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPrescriptionBottle = {
  prefix: 'fas',
  iconName: 'prescription-bottle',
  icon: [384, 512, [], "f485", "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128z"]
};
var faBars = {
  prefix: 'fas',
  iconName: 'bars',
  icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
};
var faNavicon = faBars;
var faKeyboardLeft = {
  prefix: 'fas',
  iconName: 'keyboard-left',
  icon: [640, 512, [], "e1c3", "M224 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H224zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM224 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM320 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336zM432 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM416 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V240zM528 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM512 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM113.2 153.8c-9-3.7-19.3-1.7-26.2 5.2L7 239c-9.4 9.4-9.4 24.6 0 33.9l80 80c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V176c0-9.7-5.8-18.5-14.8-22.2z"]
};
var faPeopleGroup = {
  prefix: 'fas',
  iconName: 'people-group',
  icon: [640, 512, [], "e533", "M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"]
};
var faHourglassEnd = {
  prefix: 'fas',
  iconName: 'hourglass-end',
  icon: [384, 512, [8987, "hourglass-3"], "f253", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"]
};
var faHourglass3 = faHourglassEnd;
var faHeartCrack = {
  prefix: 'fas',
  iconName: 'heart-crack',
  icon: [512, 512, [128148, "heart-broken"], "f7a9", "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"]
};
var faHeartBroken = faHeartCrack;
var faFaceBeamHandOverMouth = {
  prefix: 'fas',
  iconName: 'face-beam-hand-over-mouth',
  icon: [512, 512, [129325], "e47c", "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L207 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V384v32.8c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM217.6 212.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 172.4 120 190.1 120 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 172.4 280 190.1 280 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm-78.3 63.9c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2V384 330.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faDropletPercent = {
  prefix: 'fas',
  iconName: 'droplet-percent',
  icon: [384, 512, ["humidity"], "f750", "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zm75.3-267.3c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6zM136 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHumidity = faDropletPercent;
var faSquareUpRight = {
  prefix: 'fas',
  iconName: 'square-up-right',
  icon: [448, 512, [8599, "external-link-square-alt"], "f360", "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM320 313.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"]
};
var faExternalLinkSquareAlt = faSquareUpRight;
var faFaceKissBeam = {
  prefix: 'fas',
  iconName: 'face-kiss-beam',
  icon: [512, 512, [128537, "kiss-beam"], "f597", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faKissBeam = faFaceKissBeam;
var faCorn = {
  prefix: 'fas',
  iconName: 'corn',
  icon: [512, 512, [127805], "f6c7", "M512 40c0 15-8.3 28.1-20.5 34.9C499.2 82.2 504 92.6 504 104c0 18-11.8 33.2-28.2 38.2c2.7 5.4 4.2 11.4 4.2 17.8c0 18-11.8 33.2-28.2 38.2c2.7 5.4 4.2 11.4 4.2 17.8c0 22.1-17.9 40-40 40c-1.1 0-2.3 0-3.4-.1c2.2 4.9 3.4 10.4 3.4 16.1c0 13.6-6.8 25.7-17.3 32.9c-47.7-29.7-103.6-41.1-157.5-34.2c6.9-53.9-4.5-109.8-34.2-157.5C214.3 102.8 226.4 96 240 96c5.7 0 11.2 1.2 16.1 3.4c-.1-1.1-.1-2.2-.1-3.4c0-22.1 17.9-40 40-40c6.4 0 12.4 1.5 17.8 4.2C318.8 43.8 334 32 352 32c6.4 0 12.4 1.5 17.8 4.2C374.8 19.8 390 8 408 8c11.4 0 21.8 4.8 29.1 12.5C443.9 8.3 457 0 472 0c22.1 0 40 17.9 40 40zM137.7 98c1.2-6.3 8.9-8.7 13.2-3.9c45.4 50.5 69.5 114 56.9 183.4c-38.7 10.7-75.2 31.2-105.5 61.6L24.9 416.5c-34.2-37.7-33.1-96 3.2-132.4l64-64c18.3-18.3 30.6-41.7 35.3-67.1L137.7 98zM92.1 483.9L47.4 439.2l77.5-77.5c28.6-28.6 63.5-47.1 100.1-55.6c72.2-16.6 139.8 7.4 192.8 55c4.8 4.3 2.4 12.1-3.9 13.2l-54.9 10.2c-25.4 4.7-48.8 17-67.1 35.3l-64 64c-37.5 37.5-98.3 37.5-135.8 0z"]
};
var faRollerCoaster = {
  prefix: 'fas',
  iconName: 'roller-coaster',
  icon: [640, 512, [], "e324", "M64 190.1c0-31.8 15.8-60 40-77V456c0 13.3 10.7 24 24 24s24-10.7 24-24V96.2c2-.1 4-.2 6.1-.2c14.8 0 29.1 3.5 41.9 9.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V154.7l48 69.1V456c0 13.3 10.7 24 24 24s24-10.7 24-24V292.9l20.3 29.2c7.9 11.3 17.2 21.3 27.7 29.8V456c0 13.3 10.7 24 24 24s24-10.7 24-24V377.6c13.6 4.2 28 6.4 42.6 6.4H488v72c0 13.3 10.7 24 24 24s24-10.7 24-24V378.4c14.4-4.2 27.8-10.5 40-18.6V448c0 17.7 14.3 32 32 32s32-14.3 32-32V248h-.2c.1-2.6 .2-5.3 .2-8c0-79.5-64.5-144-144-144h-4c-28.9 0-57.3 7.1-82.8 20.7l-51.6 27.5L432 251.3V177.1l7.3-3.9c12.7-6.8 26.5-11 40.7-12.5V264c0 13.3 10.7 24 24 24s24-10.7 24-24V166.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80H482.6c-26.2 0-50.8-12.8-65.7-34.4L287.9 99.9C258.4 57.4 209.9 32 158.1 32C70.8 32 0 102.8 0 190.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V190.1z"]
};
var faPhotoFilmMusic = {
  prefix: 'fas',
  iconName: 'photo-film-music',
  icon: [640, 512, [], "e228", "M192 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64v69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-98.9 33-37.8-60.5c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5L388 177.9l-15.3-19.7c-3-3.9-7.7-6.2-12.6-6.2s-9.6 2.3-12.6 6.2l-56 72c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9h64l0 64H256c-35.3 0-64-28.7-64-64V64zM319.5 404.6c-13.8 10.3-25.2 25.2-29.6 43.4H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h96V360c0 17.7 14.3 32 32 32H342.2c-8.2 3.3-15.8 7.5-22.6 12.6zM320 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM56 168v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H72c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V264c0-8.8-7.2-16-16-16H72zM56 360v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V360c0-8.8-7.2-16-16-16H72c-8.8 0-16 7.2-16 16zM630 164.5c6.3 4.5 10 11.8 10 19.5v48V392c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V265.3l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V296 248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"]
};
var faRadar = {
  prefix: 'fas',
  iconName: 'radar',
  icon: [512, 512, [], "e024", "M304.8 173.3c-14.3-8.4-31-13.3-48.8-13.3c-53 0-96 43-96 96s43 96 96 96s96-43 96-96h64c0 73.5-49.6 135.5-117.2 154.2C290.8 394.7 274.7 384 256 384s-34.8 10.7-42.8 26.2c-51.7-14.3-92.8-53.9-109.4-104.6c14.4-8.3 24.1-23.8 24.1-41.7c0-19.4-11.5-36.1-28-43.7C116.2 149.1 179.9 96 256 96c35.5 0 68.3 11.6 94.9 31.2l22.8-22.8C341.2 79 300.4 64 256 64C163.1 64 85.7 129.9 67.9 217.6C47.2 222.9 32 241.7 32 264c0 23.8 17.3 43.6 40.1 47.4c19.3 64.3 71.5 114.4 137 130.9C213.8 463.8 233 480 256 480s42.2-16.2 46.9-37.8C386.3 421.3 448 345.9 448 256h64c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L463 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-182 182c3.3 7.7 5.1 16.1 5.1 25c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l23.8-23.8z"]
};
var faSickle = {
  prefix: 'fas',
  iconName: 'sickle',
  icon: [512, 512, [], "f822", "M212.7 340.7L181 309c-33.9-33.9-53-80-53-128C128 81 209 0 309 0h11c90.1 0 165.8 62.1 186.4 145.8c1.8 7.3-4 14.2-11.5 14.2c-3.9 0-7.5-1.9-9.9-4.9C458.9 122.9 419.5 104 377.8 104C301.7 104 240 165.7 240 241.8v9.8c0 20.7 5.2 39.7 12.2 58.6c2.2 6 .9 12.8-3.7 17.3l-13.2 13.2c-6.2 6.2-16.4 6.2-22.6 0zM121 311l24 24 32 32 24 24c9.4 9.4 9.4 24.6 0 33.9l-16 16c-9.4 9.4-24.6 9.4-33.9 0l-7-7L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l71-71-7-7c-9.4-9.4-9.4-24.6 0-33.9l16-16c9.4-9.4 24.6-9.4 33.9 0z"]
};
var faFilm = {
  prefix: 'fas',
  iconName: 'film',
  icon: [512, 512, [127902], "f008", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"]
};
var faCoconut = {
  prefix: 'fas',
  iconName: 'coconut',
  icon: [512, 512, [], "e2f6", "M141.2 141.2c-43.7 43.7-73 91.8-85.8 133.3c-13.2 42.7-7.4 71.9 7.5 86.7s44 20.6 86.7 7.5c41.5-12.8 89.6-42.1 133.3-85.8s73-91.8 85.8-133.3c13.2-42.7 7.4-71.9-7.5-86.7s-44-20.6-86.7-7.5C233 68.1 184.9 97.5 141.2 141.2zM260.4 9.5C309.6-5.7 361.5-4.8 395.2 28.8l40.9 40.9C484.7 118.4 512 184.3 512 252.9C512 396 396 512 253 512c-68.7 0-134.6-27.3-183.2-75.9l-41-41C-4.8 361.5-5.7 309.6 9.5 260.3c15.6-50.4 49.7-105 97.8-153.1S210 25 260.4 9.5zm63.5 88.1c25 25-5.4 95.9-67.9 158.4s-133.4 92.9-158.4 67.9s5.4-95.9 67.9-158.4S298.9 72.6 323.9 97.6zm95.4 107.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-56 136c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-136 56c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32z"]
};
var faRulerHorizontal = {
  prefix: 'fas',
  iconName: 'ruler-horizontal',
  icon: [640, 512, [], "f547", "M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"]
};
var faShieldCross = {
  prefix: 'fas',
  iconName: 'shield-cross',
  icon: [512, 512, [9960], "f712", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 66.8l32 13.6V128c0 17.7 14.3 32 32 32H431.3c-1.2 19.6-4.2 41.4-9.4 64H320c-17.7 0-32 14.3-32 32V426.8c-10 6.5-20.7 12.5-32 18c-11.3-5.5-22-11.5-32-18V256c0-17.7-14.3-32-32-32H90.1c-5.2-22.6-8.1-44.4-9.4-64H192c17.7 0 32-14.3 32-32V80.3l32-13.6z"]
};
var faCassetteTape = {
  prefix: 'fas',
  iconName: 'cassette-tape',
  icon: [576, 512, [128429], "f8ab", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H483.1l-36.3-96.9c-7-18.7-24.9-31.1-44.9-31.1H174.2c-20 0-37.9 12.4-44.9 31.1L92.9 480H64c-35.3 0-64-28.7-64-64V96zM416.8 394.4L448.9 480H127.1l32.1-85.6c2.3-6.2 8.3-10.4 15-10.4H401.8c6.7 0 12.6 4.1 15 10.4zM341.5 192H234.5c3.5 10 5.5 20.8 5.5 32s-1.9 22-5.5 32H341.5c-3.5-10-5.5-20.8-5.5-32s1.9-22 5.5-32zm90.5 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM112 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faSquareTerminal = {
  prefix: 'fas',
  iconName: 'square-terminal',
  icon: [448, 512, [], "e32a", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm70.3 55.8c-9 9.8-8.3 25 1.5 33.9L148.5 256 71.8 326.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"]
};
var faPeopleRobbery = {
  prefix: 'fas',
  iconName: 'people-robbery',
  icon: [576, 512, [], "e536", "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64v96l0 .6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H88V480c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H209.6l-37.4-58.9C157.6 142 132.1 128 104.7 128H72z"]
};
var faLightbulb = {
  prefix: 'fas',
  iconName: 'lightbulb',
  icon: [384, 512, [128161], "f0eb", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"]
};
var faCaretLeft = {
  prefix: 'fas',
  iconName: 'caret-left',
  icon: [256, 512, [], "f0d9", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"]
};
var faCommentMiddle = {
  prefix: 'fas',
  iconName: 'comment-middle',
  icon: [512, 512, [], "e149", "M188.3 408.7l44.5 89c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3l44.5-89C432.2 384.5 512 303.8 512 208C512 93.1 397.4 0 256 0S0 93.1 0 208c0 95.8 79.8 176.5 188.3 200.7z"]
};
var faTrashCanList = {
  prefix: 'fas',
  iconName: 'trash-can-list',
  icon: [640, 512, [], "e2ab", "M147.8 0c-12.1 0-23.2 6.8-28.6 17.7L112 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H304l-7.2-14.3C291.4 6.8 280.3 0 268.2 0H147.8zM384 128H32V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V128zM160 208V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm128 0V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm192-80c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H480zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H480zM448 416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"]
};
var faBlock = {
  prefix: 'fas',
  iconName: 'block',
  icon: [640, 512, [], "e46a", "M96 96c0-35.3 28.7-64 64-64H480c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96zm96 8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM192 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleExclamation = {
  prefix: 'fas',
  iconName: 'circle-exclamation',
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faExclamationCircle = faCircleExclamation;
var faSchoolCircleXmark = {
  prefix: 'fas',
  iconName: 'school-circle-xmark',
  icon: [640, 512, [], "e56d", "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
var faArrowRightFromBracket = {
  prefix: 'fas',
  iconName: 'arrow-right-from-bracket',
  icon: [512, 512, ["sign-out"], "f08b", "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"]
};
var faSignOut = faArrowRightFromBracket;
var faFaceFrownSlight = {
  prefix: 'fas',
  iconName: 'face-frown-slight',
  icon: [512, 512, [], "e376", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm91.9-117.5C330 373.8 299.4 352 256 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleChevronDown = {
  prefix: 'fas',
  iconName: 'circle-chevron-down',
  icon: [512, 512, ["chevron-circle-down"], "f13a", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"]
};
var faChevronCircleDown = faCircleChevronDown;
var faSidebarFlip = {
  prefix: 'fas',
  iconName: 'sidebar-flip',
  icon: [512, 512, [], "e24f", "M512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96zM288 96V416H64V96H288zm136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48zm24 120c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24zm-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48z"]
};
var faUnlockKeyhole = {
  prefix: 'fas',
  iconName: 'unlock-keyhole',
  icon: [448, 512, ["unlock-alt"], "f13e", "M224 64c-44.2 0-80 35.8-80 80v48H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"]
};
var faUnlockAlt = faUnlockKeyhole;
var faTemperatureList = {
  prefix: 'fas',
  iconName: 'temperature-list',
  icon: [512, 512, [], "e299", "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM352 32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352zM320 192c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H384z"]
};
var faCloudShowersHeavy = {
  prefix: 'fas',
  iconName: 'cloud-showers-heavy',
  icon: [512, 512, [], "f740", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM313.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"]
};
var faHeadphonesSimple = {
  prefix: 'fas',
  iconName: 'headphones-simple',
  icon: [512, 512, ["headphones-alt"], "f58f", "M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V352zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h16z"]
};
var faHeadphonesAlt = faHeadphonesSimple;
var faSitemap = {
  prefix: 'fas',
  iconName: 'sitemap',
  icon: [576, 512, [], "f0e8", "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"]
};
var faPipeSection = {
  prefix: 'fas',
  iconName: 'pipe-section',
  icon: [640, 512, [], "e438", "M32 96C14.3 96 0 110.3 0 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32zm576 0c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32zm-64 32H96V384H544V128z"]
};
var faSpaceStationMoonConstruction = {
  prefix: 'fas',
  iconName: 'space-station-moon-construction',
  icon: [512, 512, ["space-station-moon-alt"], "e034", "M512 256c0 7.8-.3 15.5-1 23.1C438.8 304.7 351.2 320 256 320s-182.8-15.3-255-40.9c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0c57.8 0 111.1 19.1 153.9 51.4c3.9 2.9 6.1 7.5 6.1 12.4V80c0 8.8-7.2 16-16 16H368c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48 16c8.8 0 16 7.2 16 16v32c0 8.8 7.2 16 16 16h31.9c8.1 0 14.9 6 15.5 14.1c.4 5.9 .6 11.9 .6 17.9zM256 512C134.9 512 33.4 427.9 6.8 314.8C79.4 338.4 164.7 352 256 352c44.3 0 87.3-3.2 128-9.2V368c0 8.8 7.2 16 16 16h32c8.8 0 16 7.2 16 16v19.3c0 3.9-1.4 7.7-4.1 10.5C397.2 480.4 330.3 512 256 512zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
var faCircleDollarToSlot = {
  prefix: 'fas',
  iconName: 'circle-dollar-to-slot',
  icon: [512, 512, ["donate"], "f4b9", "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V304c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V112c0-11.1-9-20.1-20.1-20.1zM48 352H64c19.5 25.9 44 47.7 72.2 64H64v32H256 448V416H375.8c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"]
};
var faDonate = faCircleDollarToSlot;
var faMemory = {
  prefix: 'fas',
  iconName: 'memory',
  icon: [576, 512, [], "f538", "M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320H576V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zM576 352H0v64c0 17.7 14.3 32 32 32H80V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32V352zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faFaceSleeping = {
  prefix: 'fas',
  iconName: 'face-sleeping',
  icon: [512, 512, [], "e38d", "M512 256c0-46.6-12.5-90.3-34.2-128H432c-19.4 0-36.9-11.7-44.3-29.6c-7.1-17.1-3.7-36.7 8.6-50.4c-2.9-3.2-5.4-6.9-7.3-10.8C350.2 13.6 304.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256zM272 96c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L310.6 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L297.4 96H272zM216 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM416 16c0 8.8 7.2 16 16 16h25.4L420.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H470.6l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0H432c-8.8 0-16 7.2-16 16z"]
};
var faRoadSpikes = {
  prefix: 'fas',
  iconName: 'road-spikes',
  icon: [640, 512, [], "e568", "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 448 384 320 256 192 64V116.8zM32 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faFireBurner = {
  prefix: 'fas',
  iconName: 'fire-burner',
  icon: [640, 512, [], "e4f1", "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 288c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32v64H544V320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V288zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSquirrel = {
  prefix: 'fas',
  iconName: 'squirrel',
  icon: [512, 512, [], "f71a", "M160 296.2c0 2-.7 3.9-2 5.4c-18.7 22.3-30 51-30 82.3c0 70.7 57.3 128 128 128h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H432c10-13.4 16-30 16-48c0-26.2-12.6-49.4-32-64c-13.4-10-30-16-48-16c-9.4 0-18.3 1.6-26.7 4.5c-8.3 2.9-17.5-1.4-20.4-9.8s1.4-17.5 9.8-20.4c11.7-4.1 24.3-6.4 37.3-6.4c17.2 0 33.5 3.9 48 10.8V240h21.2c26.7 0 51.7-13.4 66.6-35.6L512 192c0-53-43-96-96-96V75.2C416 69 411 64 404.8 64c-15.2 0-28.7 7.6-36.8 19.2C359.9 71.6 346.4 64 331.2 64C325 64 320 69 320 75.2V96c0 54.4-10.5 108.1-30.7 158c-.9-2-1.3-4.2-1.3-6.4V144C288 64.5 223.5 0 144 0S0 64.5 0 144s64.5 144 144 144c2.3 0 4.6-.1 6.9-.2c4.9-.2 9.1 3.5 9.1 8.4zM416 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faArrowUpToLine = {
  prefix: 'fas',
  iconName: 'arrow-up-to-line',
  icon: [384, 512, ["arrow-to-top"], "f341", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM214.6 169.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 269.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V269.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"]
};
var faArrowToTop = faArrowUpToLine;
var faFlag = {
  prefix: 'fas',
  iconName: 'flag',
  icon: [448, 512, [127988, 61725], "f024", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z"]
};
var faFaceCowboyHat = {
  prefix: 'fas',
  iconName: 'face-cowboy-hat',
  icon: [512, 512, [], "e36e", "M216 0c9.1 0 17.9 4 26.1 10.7c7.9 6.5 19.8 6.5 27.7 0C278.1 4 286.9 0 296 0c36.8 0 67.4 64.9 82.4 109.8C412 99.3 442 84.6 466.9 66.8c2.5-1.8 5.4-2.8 8.4-2.8c8.9 0 15.6 8.3 12.9 16.7C461.2 163.2 367.5 224 256 224S50.8 163.2 23.8 80.7C21 72.3 27.7 64 36.7 64c3 0 6 1 8.4 2.8C70 84.6 100 99.3 133.6 109.8C148.6 64.9 179.2 0 216 0zM48 304c0-37.9 10.1-73.4 27.8-104c48.8 35.3 112.5 56 180.2 56s131.4-20.6 180.2-56c17.7 30.6 27.8 66.1 27.8 104c0 114.9-93.1 208-208 208S48 418.9 48 304zm299.8 60.7c-27.9 7.8-59 12.1-91.6 12.1s-63.7-4.3-91.6-12.1c-12.4-3.5-24.3 7.3-18.6 18.8C166.2 424.1 208 452 256.2 452s90-27.9 110.2-68.6c5.7-11.5-6.2-22.2-18.6-18.8zM216 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHanukiah = {
  prefix: 'fas',
  iconName: 'hanukiah',
  icon: [640, 512, [128334], "f6e6", "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144z"]
};
var faChartScatter3d = {
  prefix: 'fas',
  iconName: 'chart-scatter-3d',
  icon: [512, 512, [], "e0e8", "M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V273L43.5 423.4c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1L256 329.7 427.5 472.6c13.6 11.3 33.8 9.5 45.1-4.1s9.5-33.8-4.1-45.1L288 273V64zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDisplayChartUp = {
  prefix: 'fas',
  iconName: 'display-chart-up',
  icon: [576, 512, [], "e5e3", "M0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416H64c-35.3 0-64-28.7-64-64V64zm64 0V352H512V64H64zM376 96h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V177.9L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 144H376c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSquareCode = {
  prefix: 'fas',
  iconName: 'square-code',
  icon: [448, 512, [], "e267", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm262.2 71.9c-8.9 9.9-8.1 25 1.8 33.9L324.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L123.9 256l60.2-54.2z"]
};
var faFeather = {
  prefix: 'fas',
  iconName: 'feather',
  icon: [512, 512, [129718], "f52d", "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330v55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"]
};
var faVolumeLow = {
  prefix: 'fas',
  iconName: 'volume-low',
  icon: [448, 512, [128264, "volume-down"], "f027", "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"]
};
var faVolumeDown = faVolumeLow;
var faXmarkToSlot = {
  prefix: 'fas',
  iconName: 'xmark-to-slot',
  icon: [576, 512, ["times-to-slot", "vote-nay"], "f771", "M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm145 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"]
};
var faTimesToSlot = faXmarkToSlot;
var faVoteNay = faXmarkToSlot;
var faBoxTaped = {
  prefix: 'fas',
  iconName: 'box-taped',
  icon: [448, 512, ["box-alt"], "f49a", "M50.7 58.5L0 160H160L192 32H93.7C75.5 32 58.9 42.3 50.7 58.5zM288 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H256l32 128zM160 192H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192H288v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192z"]
};
var faBoxAlt = faBoxTaped;
var faCommentSlash = {
  prefix: 'fas',
  iconName: 'comment-slash',
  icon: [640, 512, [], "f4b3", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104-17.9L82.9 161.3C70.7 185.6 64 212.2 64 240z"]
};
var faSwords = {
  prefix: 'fas',
  iconName: 'swords',
  icon: [512, 512, [9876], "f71d", "M4.7 4.7C8.5 .9 13.9-.7 19.1 .3L89.6 14.4c9.3 1.9 17.8 6.4 24.5 13.1L393.4 306.7l-86.6 86.6L27.5 114.2c-6.7-6.7-11.3-15.2-13.1-24.5L.3 19.1C-.7 13.9 .9 8.5 4.7 4.7zm454.6 304l16 16c4.7 4.7 6 11.8 3.3 17.8l-27.5 62 56.2 56.2c6.2 6.2 6.2 16.4 0 22.6l-24 24c-6.2 6.2-16.4 6.2-22.6 0l-56.2-56.2-62 27.5c-6.1 2.7-13.1 1.4-17.8-3.3l-16-16c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zM96 329.4l50.7-50.7 86.6 86.6L182.6 416l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6l-16 16c-4.7 4.7-11.8 6-17.8 3.3l-62-27.5L51.3 507.3c-6.2 6.2-16.4 6.2-22.6 0l-24-24c-6.2-6.2-6.2-16.4 0-22.6l56.2-56.2-27.5-62c-2.7-6.1-1.4-13.1 3.3-17.8l16-16c6.2-6.2 16.4-6.2 22.6 0L96 329.4zM484.5 114.2L365.3 233.4l-86.6-86.6L397.8 27.5c6.7-6.7 15.2-11.3 24.5-13.1L492.9 .3c5.2-1 10.7 .6 14.5 4.4s5.4 9.2 4.4 14.5L497.6 89.6c-1.9 9.3-6.4 17.8-13.1 24.5z"]
};
var faCloudSunRain = {
  prefix: 'fas',
  iconName: 'cloud-sun-rain',
  icon: [640, 512, [127782], "f743", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm74.5-116.1c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"]
};
var faAlbum = {
  prefix: 'fas',
  iconName: 'album',
  icon: [448, 512, [128189], "f89f", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM384 256A160 160 0 1 0 64 256a160 160 0 1 0 320 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleN = {
  prefix: 'fas',
  iconName: 'circle-n',
  icon: [512, 512, [], "e118", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM203.7 138.3L304 283.2V152c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 10.5-6.8 19.8-16.8 22.9s-20.9-.6-26.9-9.2L208 228.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.5 6.8-19.8 16.8-22.9s20.9 .6 26.9 9.2z"]
};
var faCompress = {
  prefix: 'fas',
  iconName: 'compress',
  icon: [448, 512, [], "f066", "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"]
};
var faWheatAwn = {
  prefix: 'fas',
  iconName: 'wheat-awn',
  icon: [512, 512, ["wheat-alt"], "e2cd", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"]
};
var faWheatAlt = faWheatAwn;
var faAnkh = {
  prefix: 'fas',
  iconName: 'ankh',
  icon: [320, 512, [9765], "f644", "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H241.2c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"]
};
var faHandsHoldingChild = {
  prefix: 'fas',
  iconName: 'hands-holding-child',
  icon: [640, 512, [], "e4fa", "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm44.7 164.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"]
};
var faAsterisk = {
  prefix: 'fas',
  iconName: 'asterisk',
  icon: [384, 512, [10033, 61545], "2a", "M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z"]
};
var faKeySkeletonLeftRight = {
  prefix: 'fas',
  iconName: 'key-skeleton-left-right',
  icon: [640, 512, [], "e3b4", "M576 128a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm64 0c0 70.7-57.3 128-128 128c-59.6 0-109.8-40.8-124-96H320v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160H224l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l196 0C402.2 40.8 452.4 0 512 0c70.7 0 128 57.3 128 128zM64 384a64 64 0 1 0 128 0A64 64 0 1 0 64 384zM0 384c0-70.7 57.3-128 128-128c59.6 0 109.8 40.8 124 96l68 0V320c0-17.7 14.3-32 32-32s32 14.3 32 32v32h32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-196 0c-14.2 55.2-64.3 96-124 96C57.3 512 0 454.7 0 384z"]
};
var faCommentLines = {
  prefix: 'fas',
  iconName: 'comment-lines',
  icon: [512, 512, [], "f4b0", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM152 176H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faLuchadorMask = {
  prefix: 'fas',
  iconName: 'luchador-mask',
  icon: [448, 512, ["luchador", "mask-luchador"], "f455", "M224 0C100.3 0 0 100.3 0 224v96C0 426 86 512 192 512h64c106 0 192-86 192-192V224C448 100.3 347.7 0 224 0zM128 384c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H252.7 195.3 160c-17.7 0-32 14.3-32 32zm-32 0c0-33.2 25.2-60.5 57.6-63.7c-1-3.7-1.6-7.6-1.6-11.6c0-7.3 1.8-14.4 5.3-20.7H144c-44.2 0-80-35.8-80-80c0-26.5 21.5-48 48-48h32c44.2 0 80 35.8 80 80c0-44.2 35.8-80 80-80h32c26.5 0 48 21.5 48 48c0 44.2-35.8 80-80 80H290.7c3.4 6.3 5.3 13.4 5.3 20.7c0 4-.6 7.9-1.6 11.6c32.3 3.2 57.6 30.5 57.6 63.7c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64zm156.7-64h.2c6.1 0 11.1-5 11.1-11.1c0 0 0-.1 0-.1s0-.1 0-.1c0-3-1.2-5.9-3.3-8l-8-8-4.2-4.2-.4-.4-10.3-10.3C234 274 229.1 272 224 272s-10 2-13.7 5.7L200 288l-.4 .4-4.2 4.2-8 8c-2.1 2.1-3.3 5-3.3 8c0 0 0 .1 0 .1s0 .1 0 .1c0 6.1 5 11.1 11.1 11.1h.2 11.3 6 .6 21.5 .6 6 11.3zM112 192c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16-7.2 16-16c0-26.5-21.5-48-48-48H112zm240 16c0-8.8-7.2-16-16-16H304c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48z"]
};
var faLuchador = faLuchadorMask;
var faMaskLuchador = faLuchadorMask;
var faSquareCheck = {
  prefix: 'fas',
  iconName: 'square-check',
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faCheckSquare = faSquareCheck;
var faShredder = {
  prefix: 'fas',
  iconName: 'shredder',
  icon: [512, 512, [], "f68a", "M64 64C64 28.7 92.7 0 128 0H354.7c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3V192c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64V64zM384 93.3L354.7 64H128V192H384V93.3zM432 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM40 416H88v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V416zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V416zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V416zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V416zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V416z"]
};
var faBookOpenCover = {
  prefix: 'fas',
  iconName: 'book-open-cover',
  icon: [640, 512, ["book-open-alt"], "e0c0", "M304 32V408L96 368V34.7C96 14.9 113.8-.2 133.3 3.1L304 32zM89.7 405.1L320 451.2l230.3-46.1c15-3 25.7-16.1 25.7-31.4V28.8l25.7-5.1C621.5 19.7 640 34.8 640 55V421.8c0 15.3-10.8 28.4-25.7 31.4L320 512 25.7 453.1C10.8 450.2 0 437 0 421.8V55C0 34.8 18.5 19.7 38.3 23.7L64 28.8v345c0 15.3 10.8 28.4 25.7 31.4zM336 408V32L506.7 3.1C526.2-.2 544 14.9 544 34.7V368L336 408z"]
};
var faBookOpenAlt = faBookOpenCover;
var faSandwich = {
  prefix: 'fas',
  iconName: 'sandwich',
  icon: [512, 512, [129386], "f81f", "M0 96C0 78.3 14.3 64 32 64H480c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V96zM303.9 382.6c10 5.8 22.3 5.8 32.2 0l70.2-40.9c6.4-3.7 13.6-5.7 20.9-5.7H432h48c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32H208h4.8c7.4 0 14.6 2 20.9 5.7l70.2 40.9zM32 304c-17.7 0-32-14.3-32-32s14.3-32 32-32c7.2 0 15.8-3.7 35.4-13c16.6-7.8 40.6-19 68.6-19c30.6 0 53 10.2 70.1 18l1.9 .9c17.2 7.8 29.7 13.1 48.1 13.1s30.9-5.3 48.1-13.1l1.9-.9c17-7.8 39.4-18 70.1-18c28 0 52.1 11.3 68.6 19c19.6 9.2 28.2 13 35.4 13c17.7 0 32 14.3 32 32s-14.3 32-32 32c-22.7 0-44.3-10.3-58.8-17.2l0 0c-1.3-.6-2.6-1.2-3.8-1.8c-17.4-8.2-29.4-13-41.4-13c-16.2 0-27.5 5-45.4 13.1l-.1 0c-18 8.2-41.4 18.9-74.5 18.9s-56.6-10.7-74.5-18.9l-.1 0C163.5 277 152.2 272 136 272c-12 0-23.9 4.7-41.4 13c-1.2 .6-2.5 1.2-3.8 1.8C76.3 293.7 54.7 304 32 304z"]
};
var faPesetaSign = {
  prefix: 'fas',
  iconName: 'peseta-sign',
  icon: [384, 512, [], "e221", "M64 32C46.3 32 32 46.3 32 64v96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96V448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h96c77.4 0 142-55 156.8-128H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32H64zM282.5 160H96V96h96c41.8 0 77.4 26.7 90.5 64zM96 224H282.5c-13.2 37.3-48.7 64-90.5 64H96V224z"]
};
var faSquareParkingSlash = {
  prefix: 'fas',
  iconName: 'square-parking-slash',
  icon: [640, 512, ["parking-slash"], "f617", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM227 152.7c6-14.5 20.3-24.7 37-24.7h72c53 0 96 43 96 96c0 26.3-10.6 50.2-27.8 67.5l-51.4-40.3c9.1-5.6 15.2-15.7 15.2-27.2c0-17.7-14.3-32-32-32H288v8.4l-61-47.8zM224 288V272.5L96 171.6V416c0 35.3 28.7 64 64 64H480c2.3 0 4.6-.1 6.9-.4L288 322.9V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V288z"]
};
var faParkingSlash = faSquareParkingSlash;
var faTrainTunnel = {
  prefix: 'fas',
  iconName: 'train-tunnel',
  icon: [512, 512, [], "e454", "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h41.4l64.3-64.3C137.3 444.5 112 417.2 112 384V192c0-35.3 28.7-64 64-64H336c35.3 0 64 28.7 64 64V384c0 33.2-25.3 60.5-57.7 63.7L406.6 512H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM361.4 512l-64-64H214.6l-64 64H361.4zM184 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H184zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faHeading = {
  prefix: 'fas',
  iconName: 'heading',
  icon: [448, 512, ["header"], "f1dc", "M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z"]
};
var faHeader = faHeading;
var faGhost = {
  prefix: 'fas',
  iconName: 'ghost',
  icon: [384, 512, [128123], "f6e2", "M40.1 467.1l-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2V192C0 86 86 0 192 0S384 86 384 192V462.2c0 9.8-8 17.8-17.8 17.8c-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faFaceAnguished = {
  prefix: 'fas',
  iconName: 'face-anguished',
  icon: [512, 512, [], "e369", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faHockeySticks = {
  prefix: 'fas',
  iconName: 'hockey-sticks',
  icon: [640, 512, [], "f454", "M220.6 17.7l82.3 164.6-35.8 71.6L163.4 46.3c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3zM372.8 322.1L387.8 352H544V480v32H480v0H435.8c-24.2 0-46.4-13.7-57.2-35.4l-41.5-83 35.8-71.6zM576 352h32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H576V352zM462.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9L261.5 476.6c-10.8 21.7-33 35.4-57.2 35.4H160 128 96V480 352H252.2L419.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3zM0 384c0-17.7 14.3-32 32-32H64V512H32c-17.7 0-32-14.3-32-32V384z"]
};
var faAbacus = {
  prefix: 'fas',
  iconName: 'abacus',
  icon: [576, 512, [129518], "f640", "M512 96V208H448V176h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96h64zm-96 32h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H288V176h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96H416v32zm-160 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H160V176h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96h96v32zm-128 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H64V96h64v32zM64 416l0-176h64v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H64zm96-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V312h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V240h96v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H160V384zm128-72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V240H416v96h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H288V384h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V312zm160 72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V240h64V416H448V384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faFilmSimple = {
  prefix: 'fas',
  iconName: 'film-simple',
  icon: [512, 512, ["film-alt"], "f3a0", "M384 32H128V80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64V432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48H384V432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64V80c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V32zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176zm336-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V304zm336-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faFilmAlt = faFilmSimple;
var faList = {
  prefix: 'fas',
  iconName: 'list',
  icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"]
};
var faListSquares = faList;
var faTreePalm = {
  prefix: 'fas',
  iconName: 'tree-palm',
  icon: [576, 512, [127796], "f82b", "M102.9 91.4l30.3 50.5c-4 3.5-8 7.2-12 11.2c-71 71-60.2 151-32.7 191.3c5 7.3 15.2 7.3 21.4 1L248.4 206.9c4 10.8 7.8 26.2 9.7 47.2c4.2 46.5-1.6 116.8-32.7 216.4c-3 9.7-1.3 20.3 4.8 28.5s15.6 13 25.8 13h64c16.1 0 29.8-12 31.8-28c12.4-99-2.3-207.2-31.7-292H446.7c2.8 0 5.4-1.5 6.9-3.9l19.6-32.7c3.1-5.2 10.6-5.2 13.7 0l19.6 32.7c1.4 2.4 4.1 3.9 6.9 3.9H560c8.8 0 16.1-7.2 14.4-15.9C565.3 128.2 516.4 64 416 64c-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0C59.6 0 10.7 64.2 1.6 112.1C-.1 120.8 7.2 128 16 128H62.7c2.8 0 5.4-1.5 6.9-3.9L89.1 91.4c3.1-5.2 10.6-5.2 13.7 0z"]
};
var faSquarePhoneFlip = {
  prefix: 'fas',
  iconName: 'square-phone-flip',
  icon: [448, 512, ["phone-square-alt"], "f87b", "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"]
};
var faPhoneSquareAlt = faSquarePhoneFlip;
var faCartPlus = {
  prefix: 'fas',
  iconName: 'cart-plus',
  icon: [576, 512, [], "f217", "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z"]
};
var faGamepad = {
  prefix: 'fas',
  iconName: 'gamepad',
  icon: [640, 512, [], "f11b", "M192 64C86 64 0 150 0 256S86 448 192 448H448c106 0 192-86 192-192s-86-192-192-192H192zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200z"]
};
var faBorderCenterV = {
  prefix: 'fas',
  iconName: 'border-center-v',
  icon: [448, 512, [], "f89d", "M448 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 352A32 32 0 1 0 0 352a32 32 0 1 0 64 0zM384 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 160A32 32 0 1 0 0 160a32 32 0 1 0 64 0zm320 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zM64 448A32 32 0 1 0 0 448a32 32 0 1 0 64 0zM288 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM96 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384z"]
};
var faCircleDot = {
  prefix: 'fas',
  iconName: 'circle-dot',
  icon: [512, 512, [128280, "dot-circle"], "f192", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faDotCircle = faCircleDot;
var faClipboardMedical = {
  prefix: 'fas',
  iconName: 'clipboard-medical',
  icon: [384, 512, [], "e133", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"]
};
var faFaceDizzy = {
  prefix: 'fas',
  iconName: 'face-dizzy',
  icon: [512, 512, ["dizzy"], "f567", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faDizzy = faFaceDizzy;
var faEgg = {
  prefix: 'fas',
  iconName: 'egg',
  icon: [384, 512, [129370], "f7fb", "M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"]
};
var faUpToLine = {
  prefix: 'fas',
  iconName: 'up-to-line',
  icon: [384, 512, ["arrow-alt-to-top"], "f34d", "M342.1 262.1L219.3 139.3c-7.2-7.2-17.1-11.3-27.3-11.3s-20.1 4.1-27.3 11.3L41.9 262.1c-6.4 6.4-9.9 15-9.9 24C32 304.8 47.2 320 65.9 320l62.1 0 0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V320l62.1 0c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24zM32 96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96z"]
};
var faArrowAltToTop = faUpToLine;
var faHouseMedicalCircleXmark = {
  prefix: 'fas',
  iconName: 'house-medical-circle-xmark',
  icon: [640, 512, [], "e513", "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"]
};
var faWatchFitness = {
  prefix: 'fas',
  iconName: 'watch-fitness',
  icon: [384, 512, [], "f63e", "M64 48C64 21.5 85.5 0 112 0H272c26.5 0 48 21.5 48 48H64zm0 416H320c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48zM0 160c0-44.2 35.8-80 80-80H304c44.2 0 80 35.8 80 80V352c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V160zm141.3 0C107.4 160 80 187.4 80 221.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faClockNineThirty = {
  prefix: 'fas',
  iconName: 'clock-nine-thirty',
  icon: [512, 512, [], "e34d", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V256c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h80V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faCampground = {
  prefix: 'fas',
  iconName: 'campground',
  icon: [576, 512, [9978], "f6bb", "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4V464c0 26.5 21.5 48 48 48H288 528c26.5 0 48-21.5 48-48V440.4c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448H168.5L288 291.7 407.5 448H288z"]
};
var faFolderPlus = {
  prefix: 'fas',
  iconName: 'folder-plus',
  icon: [512, 512, [], "f65e", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faJug = {
  prefix: 'fas',
  iconName: 'jug',
  icon: [448, 512, [], "f8c6", "M160 0H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM400 168c0-13.3-10.7-24-24-24c-10.3 0-19.1 6.5-22.5 15.6l25.1 32.2c12.1-1.3 21.4-11.5 21.4-23.9zm-89.3-63.3l11.8 15.1C335.7 105.2 354.8 96 376 96c39.8 0 72 32.2 72 72c0 29.2-17.4 54.3-42.3 65.6c6.8 15.8 10.3 32.9 10.3 50.3V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V283.9c0-28.5 9.5-56.1 27-78.6l78.3-100.7c2.1-2.6 3.7-5.6 4.8-8.7H305.9c1.1 3.1 2.7 6 4.8 8.7zM128 288c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H128z"]
};
var faFutbol = {
  prefix: 'fas',
  iconName: 'futbol',
  icon: [512, 512, [9917, "futbol-ball", "soccer-ball"], "f1e3", "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"]
};
var faFutbolBall = faFutbol;
var faSoccerBall = faFutbol;
var faSnowBlowing = {
  prefix: 'fas',
  iconName: 'snow-blowing',
  icon: [640, 512, [], "f761", "M512 48h32c53 0 96 43 96 96s-43 96-96 96H416c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H512c-17.7 0-32-14.3-32-32s14.3-32 32-32zM176 64c13.3 0 24 10.7 24 24v25.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L200 158.6v55.8l48.3-27.9 12.9-48.2c2.3-8.5 11.1-13.6 19.6-11.3s13.6 11.1 11.3 19.6l-4.6 17.3 22-12.7c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8l-22 12.7 17.3 4.6c8.5 2.3 13.6 11.1 11.3 19.6s-11.1 13.6-19.6 11.3l-48.2-12.9L224 256l48.3 27.9L320.6 271c8.5-2.3 17.3 2.8 19.6 11.3s-2.8 17.3-11.3 19.6l-17.3 4.6 22 12.7c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8l-22-12.7 4.6 17.3c2.3 8.5-2.8 17.3-11.3 19.6s-17.3-2.8-19.6-11.3l-12.9-48.2L200 297.6v55.8l35.3 35.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L200 398.6V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V398.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L152 353.4V297.6l-48.3 27.9L90.7 373.7c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l4.6-17.3-22 12.7C31 367.4 16.4 363.5 9.7 352s-2.7-26.2 8.8-32.8l22-12.7-17.3-4.6c-8.5-2.3-13.6-11.1-11.3-19.6s11.1-13.6 19.6-11.3l48.2 12.9L128 256 79.7 228.1 31.4 241c-8.5 2.3-17.3-2.8-19.6-11.3s2.8-17.3 11.3-19.6l17.3-4.6-22-12.7C7 186.2 3.1 171.5 9.7 160s21.3-15.4 32.8-8.8l22 12.7-4.6-17.3c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3l12.9 48.2L152 214.4V158.6l-35.3-35.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L152 113.4V88c0-13.3 10.7-24 24-24zM480 432c0-17.7 14.3-32 32-32h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H416c-17.7 0-32-14.3-32-32s14.3-32 32-32H536c53 0 96 43 96 96s-43 96-96 96H512c-17.7 0-32-14.3-32-32z"]
};
var faPaintbrush = {
  prefix: 'fas',
  iconName: 'paintbrush',
  icon: [576, 512, [128396, "paint-brush"], "f1fc", "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"]
};
var faPaintBrush = faPaintbrush;
var faLock = {
  prefix: 'fas',
  iconName: 'lock',
  icon: [448, 512, [128274], "f023", "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"]
};
var faArrowDownFromLine = {
  prefix: 'fas',
  iconName: 'arrow-down-from-line',
  icon: [384, 512, [8615, "arrow-from-top"], "f345", "M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 370.7V192c0-17.7 14.3-32 32-32s32 14.3 32 32V370.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128zM32 96C14.3 96 0 81.7 0 64S14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"]
};
var faArrowFromTop = faArrowDownFromLine;
var faGasPump = {
  prefix: 'fas',
  iconName: 'gas-pump',
  icon: [512, 512, [9981], "f52f", "M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V168v24 32V376c0 39.8-32.2 72-72 72s-72-32.2-72-72V344c0-22.1-17.9-40-40-40h-8V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zM96 80v96c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"]
};
var faSignalBarsSlash = {
  prefix: 'fas',
  iconName: 'signal-bars-slash',
  icon: [640, 512, ["signal-alt-slash"], "f694", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L608 451.2V48c0-26.5-21.5-48-48-48s-48 21.5-48 48V376l-64-50.2V176c0-26.5-21.5-48-48-48s-48 21.5-48 48v74.6L38.8 5.1zM288 322.9l-74.7-58.8C200.5 272.7 192 287.4 192 304V464c0 26.5 21.5 48 48 48s48-21.5 48-48V322.9zM448 464V449l-96-75.6V464c0 26.5 21.5 48 48 48s48-21.5 48-48zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z"]
};
var faSignalAltSlash = faSignalBarsSlash;
var faMonkey = {
  prefix: 'fas',
  iconName: 'monkey',
  icon: [576, 512, [128018], "f6fb", "M160 416c0-89.7 61.4-165 144.5-186.1C329.1 265 369.9 288 416 288c9.8 0 19.4-1 28.7-3L526.5 363c31.6 30.2 49.5 72 49.5 115.7V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-26.2-10.7-51.3-29.7-69.4L416 346.1V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H416 160C71.6 512 0 440.4 0 352V110.1C0 49.3 49.3 0 110.1 0h10.4c57.2 0 102.8 47.8 100.1 104.9c-2.3 48.2-38.6 88-86.4 94.6l-1.9 .3c-17.5 2.4-33.7-9.8-36.1-27.3s9.8-33.7 27.3-36.1l1.9-.3c17.3-2.4 30.4-16.7 31.2-34.2c1-20.6-15.5-37.9-36.2-37.9H110.1C84.7 64 64 84.7 64 110.1V352c0 53 43 96 96 96V416zM416 256c-29.3 0-55.9-12.2-74.8-31.7c-9-9.3-16.2-20.2-21.3-32.3c-35.3 0-64-28.7-64-64s28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64s-28.6 64-64 64c-15.7 37.6-52.8 64-96 64zM384 64c-26.5 0-48 21.5-48 48c0 20.8 13.2 38.4 31.6 45.1c4.7 1.7 8.4 5.9 8.4 10.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9c18.5-6.7 31.6-24.4 31.6-45.1c0-26.5-21.5-48-48-48H384zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faRectanglePro = {
  prefix: 'fas',
  iconName: 'rectangle-pro',
  icon: [640, 512, ["pro"], "e235", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm40 128h56c35.3 0 64 28.7 64 64s-28.7 64-64 64H128v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 184c0-13.3 10.7-24 24-24zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H128v32h32zm80-56c0-13.3 10.7-24 24-24h56c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.7 52.7l24.1 38.5c7 11.2 3.6 26-7.6 33.1s-26 3.6-33.1-7.6l-33-52.7H288v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 184zm48 56h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288v32zm200-80c48.6 0 88 39.4 88 88v16c0 48.6-39.4 88-88 88s-88-39.4-88-88V248c0-48.6 39.4-88 88-88zm-40 88v16c0 22.1 17.9 40 40 40s40-17.9 40-40V248c0-22.1-17.9-40-40-40s-40 17.9-40 40z"]
};
var faPro = faRectanglePro;
var faHouseNight = {
  prefix: 'fas',
  iconName: 'house-night',
  icon: [640, 512, [], "e010", "M125.2 16.1c6.2-4.4 5.4-14.8-2.2-15.6c-3.6-.4-7.3-.5-11-.5C50.1 0 0 50.1 0 112s50.1 112 112 112c32.1 0 61.1-13.5 81.5-35.2c5.2-5.6-1-14-8.6-13.2c-2.9 .3-5.9 .4-9 .4c-48.6 0-88-39.4-88-88c0-29.7 14.7-55.9 37.2-71.9zm138.3-3.8c-2.6-7-12.4-7-15 0L236.6 44.6 204.3 56.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15L275.4 44.6 263.5 12.3zm158.2 92.2c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S178.8 352 192 352h32V464c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48V352h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM352 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V304zM88.5 332.3L76.6 364.6 44.3 376.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3c-2.6-7-12.4-7-15 0z"]
};
var faHotTubPerson = {
  prefix: 'fas',
  iconName: 'hot-tub-person',
  icon: [512, 512, ["hot-tub"], "f593", "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"]
};
var faHotTub = faHotTubPerson;
var faBlanket = {
  prefix: 'fas',
  iconName: 'blanket',
  icon: [448, 512, [], "f498", "M0 128V352c0 70.7 57.3 128 128 128H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-35.3 0-64-28.7-64-64s28.7-64 64-64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H368c44.2 0 80-35.8 80-80V128c0-53-43-96-96-96H96C43 32 0 75 0 128z"]
};
var faMapLocation = {
  prefix: 'fas',
  iconName: 'map-location',
  icon: [576, 512, ["map-marked"], "f59f", "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6V503zM15.1 187.3C6 191 0 199.8 0 209.6V480.4c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77V449.4l192 54.9V255z"]
};
var faMapMarked = faMapLocation;
var faHouseFloodWater = {
  prefix: 'fas',
  iconName: 'house-flood-water',
  icon: [576, 512, [], "e50e", "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"]
};
var faCommentsQuestionCheck = {
  prefix: 'fas',
  iconName: 'comments-question-check',
  icon: [640, 512, [], "e14f", "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5zM180.2 77.3h48.5c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20V179.5c0-7.2 3.8-13.8 10-17.3L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6H180.2c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1c6.6-18.6 24.2-31.1 44-31.1zm27.8 160a26.7 26.7 0 1 1 0 53.3 26.7 26.7 0 1 1 0-53.3zm358.1 88.8l-80 80c-7.8 7.8-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0L472 363.7l65.9-65.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"]
};
var faTree = {
  prefix: 'fas',
  iconName: 'tree',
  icon: [448, 512, [127794], "f1bb", "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320H80L5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H424.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"]
};
var faArrowsCross = {
  prefix: 'fas',
  iconName: 'arrows-cross',
  icon: [448, 512, [], "e0a2", "M54.6 41.4c-12.5-12.5-32.8-12.5-45.3 0S-3.1 74.1 9.4 86.6L156.1 233.4l45.3-45.3L54.6 41.4zM338.7 416H288c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v50.7l-92.1-92.1-45.3 45.3L338.7 416zM288 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 141.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H288z"]
};
var faBackpack = {
  prefix: 'fas',
  iconName: 'backpack',
  icon: [448, 512, [127890], "f5d4", "M192 48h64c4.4 0 8 3.6 8 8V96H184V56c0-4.4 3.6-8 8-8zm-56 8V96h-8C57.3 96 0 153.3 0 224V448c0 35.3 28.7 64 64 64l0-112V352c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64v48V512c35.3 0 64-28.7 64-64V224c0-70.7-57.3-128-128-128h-8V56c0-30.9-25.1-56-56-56H192c-30.9 0-56 25.1-56 56zM352 512V416H96v96H352zM144 176H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352 384V352c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v32H352z"]
};
var faSquareSmall = {
  prefix: 'fas',
  iconName: 'square-small',
  icon: [320, 512, [], "e27e", "M0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160z"]
};
var faFolderArrowUp = {
  prefix: 'fas',
  iconName: 'folder-arrow-up',
  icon: [512, 512, ["folder-upload"], "e054", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM280 376V273.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V376c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faFolderUpload = faFolderArrowUp;
var faBridgeLock = {
  prefix: 'fas',
  iconName: 'bridge-lock',
  icon: [640, 512, [], "e4cc", "M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faCrosshairsSimple = {
  prefix: 'fas',
  iconName: 'crosshairs-simple',
  icon: [512, 512, [], "e59f", "M445.3 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h61.3C431.9 368.4 368.4 431.9 288 445.3V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v61.3C143.6 431.9 80.1 368.4 66.7 288H128c17.7 0 32-14.3 32-32s-14.3-32-32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V128c0 17.7 14.3 32 32 32s32-14.3 32-32V66.7C368.4 80.1 431.9 143.6 445.3 224zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z"]
};
var faSackDollar = {
  prefix: 'fas',
  iconName: 'sack-dollar',
  icon: [512, 512, [128176], "f81d", "M320 96H192L144.6 24.9C137.5 14.2 145.1 0 157.9 0H354.1c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128H320c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4l0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"]
};
var faPenToSquare = {
  prefix: 'fas',
  iconName: 'pen-to-square',
  icon: [512, 512, ["edit"], "f044", "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"]
};
var faEdit = faPenToSquare;
var faSquareSliders = {
  prefix: 'fas',
  iconName: 'square-sliders',
  icon: [448, 512, ["sliders-h-square"], "f3f0", "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zm0-144c0 17.7-14.3 32-32 32l-32 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16L96 368c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 32 0c17.7 0 32 14.3 32 32zM352 144c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 160 0z"]
};
var faSlidersHSquare = faSquareSliders;
var faCarSide = {
  prefix: 'fas',
  iconName: 'car-side',
  icon: [640, 512, [128663], "f5e4", "M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faMessageMiddleTop = {
  prefix: 'fas',
  iconName: 'message-middle-top',
  icon: [512, 512, ["comment-middle-top-alt"], "e1e2", "M343.5 96H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H168.5L243.7 5.8c3-3.6 7.5-5.8 12.3-5.8s9.3 2.1 12.3 5.8L343.5 96z"]
};
var faCommentMiddleTopAlt = faMessageMiddleTop;
var faLightbulbOn = {
  prefix: 'fas',
  iconName: 'lightbulb-on',
  icon: [640, 512, [], "f672", "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80V416H400v16zM320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80z"]
};
var faKnife = {
  prefix: 'fas',
  iconName: 'knife',
  icon: [512, 512, ["utensil-knife"], "f2e4", "M217.5 249.3l242-242c4.7-4.7 11-7.3 17.6-7.3c11.2 0 21 7.5 23.5 18.4C505.3 38.6 512 71.5 512 96c0 83.3-48.2 130.5-128.9 209.4c-6.5 6.4-13.3 13-20.3 19.9c-12.1 11.9-28.4 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-14.6-14.6-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192 16-16c0 0 .1-.1 .1-.1z"]
};
var faUtensilKnife = faKnife;
var faShareNodes = {
  prefix: 'fas',
  iconName: 'share-nodes',
  icon: [448, 512, ["share-alt"], "f1e0", "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"]
};
var faShareAlt = faShareNodes;
var faDisplayChartUpCircleDollar = {
  prefix: 'fas',
  iconName: 'display-chart-up-circle-dollar',
  icon: [640, 512, [], "e5e6", "M0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V211.2c-19.5-10-41.1-16.4-64-18.5V64H64V352H320.7c-.5 5.3-.7 10.6-.7 16c0 59.5 29.5 112.1 74.8 144H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416H64c-35.3 0-64-28.7-64-64V64zm480 56v72.7c-16.7 1.5-32.7 5.3-47.7 11.2c-.2-1.3-.3-2.6-.3-3.9V177.9L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 144H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
var faWaveSine = {
  prefix: 'fas',
  iconName: 'wave-sine',
  icon: [640, 512, [8767], "f899", "M63.4 230.3l0-.1 .2-1c.2-.9 .5-2.4 1-4.3c1-3.8 2.5-9.4 4.6-16.2C73.6 195 80.3 177 90 159.4C110.2 122.8 137.8 96 176 96c29 0 49.1 14.4 67 44.4c19 31.8 31.9 75.4 46.3 124.5c.2 .8 .5 1.6 .7 2.4c13.5 46.2 28.4 97.5 52 137c25.1 42 63 75.6 122 75.6c73.8 0 118.2-53.2 142-96.6c12.3-22.4 20.6-44.5 25.7-60.8c2.6-8.2 4.5-15.1 5.7-20c.6-2.5 1.1-4.4 1.4-5.9c.2-.7 .3-1.3 .4-1.7l.1-.5 0-.2 0-.1 0 0c0 0 0 0-31.4-6.3l31.4 6.3c3.5-17.3-7.8-34.2-25.1-37.7s-34.2 7.8-37.7 25.1l0 0 0 .1-.2 1c-.2 .9-.5 2.4-1 4.3c-1 3.8-2.5 9.4-4.6 16.2c-4.3 13.7-11.1 31.6-20.8 49.2c-20.1 36.6-47.8 63.4-86 63.4c-29 0-49.1-14.4-67-44.4c-19-31.8-31.9-75.4-46.3-124.5c-.2-.8-.5-1.6-.7-2.4c-13.5-46.2-28.4-97.5-52-137C272.9 65.6 235 32 176 32C102.2 32 57.8 85.2 34 128.6C21.7 151 13.4 173 8.2 189.3c-2.6 8.2-4.5 15.1-5.7 20c-.6 2.5-1.1 4.4-1.4 5.9c-.2 .7-.3 1.3-.4 1.7l-.1 .5 0 .2 0 .1 0 0c0 0 0 0 31.4 6.3L.6 217.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1"]
};
var faHeartCircleMinus = {
  prefix: 'fas',
  iconName: 'heart-circle-minus',
  icon: [576, 512, [], "e4ff", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faCircleW = {
  prefix: 'fas',
  iconName: 'circle-w',
  icon: [512, 512, [], "e12c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM150.9 168.7L192 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L320 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L256 254.7 214.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z"]
};
var faCircleCalendar = {
  prefix: 'fas',
  iconName: 'circle-calendar',
  icon: [512, 512, ["calendar-circle"], "e102", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 96c8.8 0 16 7.2 16 16v16h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32c17.7 0 32 14.3 32 32v32H128V160c0-17.7 14.3-32 32-32h32V112c0-8.8 7.2-16 16-16zM128 352V224H384V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32z"]
};
var faCalendarCircle = faCircleCalendar;
var faHourglassHalf = {
  prefix: 'fas',
  iconName: 'hourglass-half',
  icon: [384, 512, ["hourglass-2"], "f252", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9H112z"]
};
var faHourglass2 = faHourglassHalf;
var faMicroscope = {
  prefix: 'fas',
  iconName: 'microscope',
  icon: [512, 512, [128300], "f610", "M160 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM32 448H320c70.7 0 128-57.3 128-128s-57.3-128-128-128V128c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSunset = {
  prefix: 'fas',
  iconName: 'sunset',
  icon: [576, 512, [127751], "f767", "M354.5 104.3L320 135.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V135.7l-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zm48.7 132.8c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L288 289.1l-90.3-62.3c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L153 345 45.1 364.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L64 432H169.3c19-46.9 65-80 118.7-80s99.7 33.1 118.7 80H512l29.2-42.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L423 345 403.1 237.1zM0 488c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"]
};
var faSink = {
  prefix: 'fas',
  iconName: 'sink',
  icon: [512, 512, [], "e06d", "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96V288H160V264c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H400V264c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24H288V96zM480 416V384H32v32c0 53 43 96 96 96H384c53 0 96-43 96-96z"]
};
var faCalendarExclamation = {
  prefix: 'fas',
  iconName: 'calendar-exclamation',
  icon: [448, 512, [], "f334", "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM192 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-176v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faTruckContainerEmpty = {
  prefix: 'fas',
  iconName: 'truck-container-empty',
  icon: [640, 512, [], "e2b5", "M456 144c-13.3 0-24 10.7-24 24v88 32 32H208 80 32c-17.7 0-32 14.3-32 32v32 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16L432 384l17.6 0c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H456zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHandHeart = {
  prefix: 'fas',
  iconName: 'hand-heart',
  icon: [512, 512, [], "f4bc", "M256 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V336c0 97.2-78.8 176-176 176H284.8c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zM208 362.6c0 12.1 5.1 23.6 14.1 31.6l55.2 49.7c6.1 5.5 15.3 5.5 21.4 0l55.2-49.7c9-8.1 14.1-19.6 14.1-31.6c0-23.5-19.1-42.6-42.6-42.6h-1.1c-14.6 0-28.3 7.3-36.4 19.5c-8.1-12.2-21.7-19.5-36.4-19.5h-1.1c-23.5 0-42.6 19.1-42.6 42.6z"]
};
var faBagShopping = {
  prefix: 'fas',
  iconName: 'bag-shopping',
  icon: [448, 512, ["shopping-bag"], "f290", "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faShoppingBag = faBagShopping;
var faArrowDownZA = {
  prefix: 'fas',
  iconName: 'arrow-down-z-a',
  icon: [576, 512, ["sort-alpha-desc", "sort-alpha-down-alt"], "f881", "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z"]
};
var faSortAlphaDesc = faArrowDownZA;
var faSortAlphaDownAlt = faArrowDownZA;
var faMitten = {
  prefix: 'fas',
  iconName: 'mitten',
  icon: [448, 512, [], "f7b5", "M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192h2.8c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448z"]
};
var faReplyClock = {
  prefix: 'fas',
  iconName: 'reply-clock',
  icon: [640, 512, ["reply-time"], "e239", "M352 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM496 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V80c0-8.8-7.2-16-16-16zm0 256c5.1 0 10.2-.2 15.2-.6c.5 5.5 .8 11 .8 16.6c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 257.7 0 249.1 0 240s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2v64h96.7c8.1 89.7 83.5 160 175.3 160z"]
};
var faReplyTime = faReplyClock;
var faPersonRays = {
  prefix: 'fas',
  iconName: 'person-rays',
  icon: [512, 512, [], "e54d", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H248zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"]
};
var faRight = {
  prefix: 'fas',
  iconName: 'right',
  icon: [448, 512, [11157, "arrow-alt-right"], "f356", "M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-96L40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l184 0 0-96c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l160 160z"]
};
var faArrowAltRight = faRight;
var faCircleF = {
  prefix: 'fas',
  iconName: 'circle-f',
  icon: [512, 512, [], "e10e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24z"]
};
var faUsers = {
  prefix: 'fas',
  iconName: 'users',
  icon: [640, 512, [], "f0c0", "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"]
};
var faFacePleading = {
  prefix: 'fas',
  iconName: 'face-pleading',
  icon: [512, 512, [], "e386", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM302.7 427.9c6.6-5.9 7.1-16 1.2-22.6C294.7 395.1 278.7 384 256 384s-38.7 11.1-47.9 21.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c4.7-5.3 12.7-10.7 24.1-10.7s19.4 5.4 24.1 10.7c5.9 6.6 16 7.1 22.6 1.2zM240 240c0-41.5-31.5-75.6-72-79.6c10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9c1 8.1 7.9 14 15.9 14c-10 13.4-16 30-16 48c0 44.2 35.8 80 80 80s80-35.8 80-80zm192 0c0-18-6-34.6-16-48c8 0 14.9-5.9 15.9-14c1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8c-40.4 4-72 38.1-72 79.6c0 44.2 35.8 80 80 80s80-35.8 80-80zm-304-8c17.7 0 32-14.3 32-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4c17.7 0 32-14.3 32-32z"]
};
var faEyeSlash = {
  prefix: 'fas',
  iconName: 'eye-slash',
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"]
};
var faFlaskVial = {
  prefix: 'fas',
  iconName: 'flask-vial',
  icon: [640, 512, [], "e4f3", "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V309.9l-49 79.6zM96 64v96h64V64H96zM352 0H480h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V214.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V224c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64H384z"]
};
var faPoliceBox = {
  prefix: 'fas',
  iconName: 'police-box',
  icon: [384, 512, [], "e021", "M192 0c8.8 0 16 7.2 16 16V32h80c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V96c0-17.7 14.3-32 32-32c0-17.7 14.3-32 32-32h80V16c0-8.8 7.2-16 16-16zM96 136v24h32V128H104c-4.4 0-8 3.6-8 8zm0 40v24c0 4.4 3.6 8 8 8h24V176H96zm72-48H144v32h32V136c0-4.4-3.6-8-8-8zm-24 48v32h24c4.4 0 8-3.6 8-8V176H144zm72-48c-4.4 0-8 3.6-8 8v24h32V128H216zm24 48H208v24c0 4.4 3.6 8 8 8h24V176zm16-48v32h32V136c0-4.4-3.6-8-8-8H256zm32 48H256v32h24c4.4 0 8-3.6 8-8V176zM96 256v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"]
};
var faCucumber = {
  prefix: 'fas',
  iconName: 'cucumber',
  icon: [512, 512, [129362], "e401", "M37.5 474.5c47.8 47.8 124 49.9 174.3 6.3c12.6 10.3 31.1 9.6 42.9-2.2c11.6-11.6 12.4-30 2.4-42.6L436 257c12.6 10.1 31 9.3 42.6-2.4c11.7-11.7 12.5-30.3 2.2-42.9c43.6-50.3 41.5-126.5-6.3-174.3c-50-50-131-50-181 0L172 159c-12.6-10.1-31-9.3-42.6 2.4s-12.4 30-2.4 42.6L37.5 293.5c-50 50-50 131 0 181zM400 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM304 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faHeadSideBrain = {
  prefix: 'fas',
  iconName: 'head-side-brain',
  icon: [512, 512, [], "f808", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM285.3 208H336c26.5 0 48-21.5 48-48s-21.5-48-48-48c-.9 0-1.8 0-2.7 .1C326.7 93.4 308.9 80 288 80c-8.6 0-16.6 2.2-23.5 6.2C255.9 72.8 241 64 224 64s-31.9 8.8-40.5 22.2c-7-3.9-15-6.2-23.5-6.2c-26.5 0-48 21.5-48 48c-26.5 0-48 21.5-48 48c0 20.9 13.4 38.7 32.1 45.3c0 .9-.1 1.8-.1 2.7c0 26.5 21.5 48 48 48c5.6 0 11-1 16-2.7V288c0 17.7 14.3 32 32 32s32-14.3 32-32V269.3c5 1.8 10.4 2.7 16 2.7c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16zM160 176v2.7l-.1 0c0-.9 .1-1.8 .1-2.7z"]
};
var faHand = {
  prefix: 'fas',
  iconName: 'hand',
  icon: [512, 512, [129306, 9995, "hand-paper"], "f256", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z"]
};
var faHandPaper = faHand;
var faPersonBikingMountain = {
  prefix: 'fas',
  iconName: 'person-biking-mountain',
  icon: [640, 512, [128693, "biking-mountain"], "f84b", "M448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM427.2 160l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zm-238.8 6.7L290.8 89.9c7.2-5.4 8.5-15.7 2.9-22.8L278.8 48.4c-21.6-27-60.7-32-88.4-11.2L125.2 86.1c-7.2 5.4-8.5 15.7-2.9 22.8l44 55c5.4 6.7 15.2 8 22.1 2.8zM120 256c-12.1 0-22.1 8.9-23.8 20.6c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3L31.8 299.1c-8.6 8.6-9.3 21.9-2.3 31.3c-3.7 6.9-6.8 14.1-9 21.8C8.9 353.9 0 363.9 0 376v16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.3 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9C97.9 503.1 107.9 512 120 512h16c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.7-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.3-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.3-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.8-3.7-14.1-6.8-21.7-9C158.1 264.9 148.1 256 136 256H120zm8 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352.2-43.4c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3l-11.3 11.3c-8.6 8.6-9.3 21.9-2.2 31.3c-3.7 6.9-6.8 14.1-9 21.8C392.9 353.9 384 363.9 384 376v16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.2 31.3l11.3 11.3c8.5 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9c1.7 11.6 11.7 20.6 23.8 20.6h16c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.8-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.2-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.2-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.9-3.7-14.1-6.8-21.8-9C542.1 264.9 532.1 256 520 256H504c-12.1 0-22.1 8.9-23.8 20.6zM448 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faBikingMountain = faPersonBikingMountain;
var faUtensilsSlash = {
  prefix: 'fas',
  iconName: 'utensils-slash',
  icon: [640, 512, [], "e464", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V352 240 32c0-17.7-14.3-32-32-32C496 0 384 32 384 176v99.7l-77.6-60.8c8.6-13.6 13.6-29.7 13.6-47c0-6.4-.7-12.8-2.1-19.1L287.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S256 7.8 256 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L223.9 14.6C223.2 6.3 216.3 0 208 0s-15.2 6.3-15.9 14.6l-9.4 103.3L160 100.1V16c0-8.2-6.1-15-14.3-15.9s-15.6 4.5-17.4 12.4L116.5 66 38.8 5.1zM176 255.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V285.1L96.1 171.7c1.9 44.2 36.3 80 79.9 83.9z"]
};
var faPrintMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'print-magnifying-glass',
  icon: [640, 512, ["print-search"], "f81a", "M192 0H418.7c17 0 33.3 6.7 45.3 18.7L493.3 48c12 12 18.7 28.3 18.7 45.3V160H448V93.3L418.7 64H192v96H128V64c0-35.3 28.7-64 64-64zM128 192H352c-38.9 29.2-64 75.7-64 128c0 11 1.1 21.7 3.2 32H192v16 16 64H352c26.7 20.1 60 32 96 32c17.5 0 34.4-2.8 50.2-8l6.3 6.3c-10.8 20.1-32 33.8-56.4 33.8H192c-35.3 0-64-28.7-64-64V384H96c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64zM448 400.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"]
};
var faPrintSearch = faPrintMagnifyingGlass;
var faFolderBookmark = {
  prefix: 'fas',
  iconName: 'folder-bookmark',
  icon: [512, 512, [], "e186", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM288 176V336c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L368 308l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V176c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16z"]
};
var faOm = {
  prefix: 'fas',
  iconName: 'om',
  icon: [512, 512, [128329], "f679", "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48H109.8c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H144h16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5 0-.1c-2.6-7.8-10.7-12.3-18.7-10.5C4.4 354.2-.9 361.8 .1 370L16 368C.1 370 .1 370 .1 370l0 0 0 0 0 .1 .1 .4c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.3 0 0c0 0 0 0 0 0c-1.9-7.3-8.6-12.4-16.2-12.1c-7.6 .3-13.9 5.9-15.1 13.4L336 368c-15.8-2.6-15.8-2.6-15.8-2.6l0 0 0 0 0 .1-.1 .3c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96V288c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4H245.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4zM280.9 66.7c-6-4-14-3.5-19.5 1.3s-7 12.7-3.7 19.2L272 80c-14.3 7.2-14.3 7.2-14.3 7.2l0 0 0 0 0 .1 .1 .2 .4 .7c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-22.6-22.6l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3c-12.4-12.4-32.6-12.5-45.1-.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2 0 0 0 0 0 0z"]
};
var faPi = {
  prefix: 'fas',
  iconName: 'pi',
  icon: [448, 512, [], "f67e", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H96V284c0 39.7-9.3 78.9-27 114.5l-1.6 3.2c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l1.6-3.2C148.4 382.7 160 333.7 160 284V128H288V366.6c0 45 36.5 81.4 81.4 81.4c30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6c-9.6 0-17.4-7.8-17.4-17.4V128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faFlaskRoundPotion = {
  prefix: 'fas',
  iconName: 'flask-round-potion',
  icon: [448, 512, ["flask-potion"], "f6e1", "M192 64h64v93.7c0 30.4 16.9 56.1 40.3 69.7c43 25 71.6 71.4 71.7 124.4c-58.6-1.7-85.4-12.6-109.9-22.6c-22-9-42.2-17.2-82.1-17.2c-42.3 0-73.4 9.2-94.5 18.8c6.5-44.1 33-81.7 70.2-103.4c23.4-13.6 40.3-39.3 40.3-69.7V64zm128 93.7V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H304 144 128C110.3 0 96 14.3 96 32s14.3 32 32 32v93.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4z"]
};
var faFlaskPotion = faFlaskRoundPotion;
var faFaceShush = {
  prefix: 'fas',
  iconName: 'face-shush',
  icon: [512, 512, [], "e38c", "M0 256C0 359.8 61.8 449.1 150.5 489.3c-4.2-10.3-6.5-21.5-6.5-33.3V432 408c0-37.3 23.2-69.2 56-82V275.9c-14.8-6.9-26.6-15.9-35.3-24.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c3.7 3.7 8.1 7.4 13.3 10.9c4-27 27.3-47.6 55.4-47.6s51.3 20.7 55.4 47.6c5.2-3.5 9.6-7.3 13.3-10.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-8.7 8.7-20.5 17.7-35.3 24.6v58.3c17.9 11.7 31.3 29.7 37 50.9c16-3.2 33.3 .6 46.9 11.9c18.4 15.3 24.5 39.9 17.1 61.3c60.3-46.8 99-120 99-202.3C512 114.6 397.4 0 256 0S0 114.6 0 256zM176.4 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM280 248c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h48V248zM224 408c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-30.9-25.1-56-56-56H232c-30.9 0-56 25.1-56 56v24 24c0 30.9 25.1 56 56 56h48 17.5c21.4 0 41.6-9.5 55.3-25.9l25.6-30.7c8.5-10.2 7.1-25.3-3.1-33.8s-25.3-7.1-33.8 3.1L316 455.4c-4.6 5.5-11.3 8.6-18.4 8.6h-10L224 419.5V408z"]
};
var faWorm = {
  prefix: 'fas',
  iconName: 'worm',
  icon: [512, 512, [], "e599", "M256 96c0-53 43-96 96-96h38.4C439.9 0 480 40.1 480 89.6V176v16V376c0 75.1-60.9 136-136 136s-136-60.9-136-136V296c0-22.1-17.9-40-40-40s-40 17.9-40 40V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192H352c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHouseCircleXmark = {
  prefix: 'fas',
  iconName: 'house-circle-xmark',
  icon: [640, 512, [], "e50b", "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPlug = {
  prefix: 'fas',
  iconName: 'plug',
  icon: [384, 512, [128268], "f1e6", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8C297 398 352 333.4 352 256V224c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faCalendarCircleExclamation = {
  prefix: 'fas',
  iconName: 'calendar-circle-exclamation',
  icon: [576, 512, [], "e46e", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3V192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faSquareI = {
  prefix: 'fas',
  iconName: 'square-i',
  icon: [448, 512, [], "e272", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V336h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faChevronUp = {
  prefix: 'fas',
  iconName: 'chevron-up',
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
};
var faFaceSaluting = {
  prefix: 'fas',
  iconName: 'face-saluting',
  icon: [640, 512, [129761], "e484", "M258.1 58.5h0c14.5-9.8 18.4-29.4 8.8-44c0 0 0 0 0 0c-.1-.1-.2-.3-.3-.4C256.7-.6 236.8-4.4 222.2 5.5L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c18.9 15.4 43.2 20.9 66 16.5c4.4-.9 8.8-2.1 13.1-3.8c.3-.1 .7-.3 1-.4c.5-.2 1-.4 1.5-.6c5.6-2.3 10.9-5.4 16-9l82.3-59.9h0c14.3-10.4 17.5-30.4 7.1-44.7c-4.8-6.7-11.8-10.9-19.3-12.5c-3.5-.7-7.2-.9-10.8-.4c-5.1 .7-10.1 2.6-14.6 5.8L128 185.8V146.8l27.3-18.5 13.1-8.9 89.7-60.9zM352 0c-18.4 0-36.3 1.9-53.5 5.6c12.6 27.9 3.8 61.6-22.4 79.4l-54.6 37c8.6 4.4 16.3 10.9 22.3 19.2c8.6 11.9 12.6 25.7 12.2 39.3c4.8-2.8 10.4-4.5 16.3-4.5c17.7 0 32 14.3 32 32s-14.3 32-32 32c-13.9 0-25.8-8.9-30.2-21.4c-3.5 4.4-7.7 8.5-12.5 12l-82.3 59.9c-13.9 10.1-29.5 16.6-45.6 19.6C126.5 425.5 229.1 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0zM257.4 341c17.5 12.6 48.9 27 94.6 27s77.2-14.4 94.6-27c7.2-5.2 17.2-3.5 22.3 3.6s3.5 17.2-3.6 22.3c-22.7 16.4-60.7 33-113.4 33s-90.6-16.6-113.4-33c-7.2-5.2-8.8-15.2-3.6-22.3s15.2-8.8 22.3-3.6zm175-165a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGaugeSimpleLow = {
  prefix: 'fas',
  iconName: 'gauge-simple-low',
  icon: [512, 512, ["tachometer-slow"], "f62c", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.1 .3L173.3 140.9c-6.1-11.8-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4l76.6 147.4C197.8 321.6 192 336.1 192 352c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faTachometerSlow = faGaugeSimpleLow;
var faFacePersevering = {
  prefix: 'fas',
  iconName: 'face-persevering',
  icon: [512, 512, [], "e385", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zm-104.8-310c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM133.5 210.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 221.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faCircleCamera = {
  prefix: 'fas',
  iconName: 'circle-camera',
  icon: [512, 512, ["camera-circle"], "e103", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM196 160l6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6h62.7c10 0 19 6.2 22.5 15.6L316 160h36c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h36zm108 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faCameraCircle = faCircleCamera;
var faHandSpock = {
  prefix: 'fas',
  iconName: 'hand-spock',
  icon: [576, 512, [128406], "f259", "M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64h10.9 8.2c.1 0 .1-.1 .1-.1s.1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"]
};
var faSpiderWeb = {
  prefix: 'fas',
  iconName: 'spider-web',
  icon: [576, 512, [128376], "f719", "M133.8 22.2c4.8-12.7 18-20.2 31.4-17.7l69 12.9c35.6 6.7 72.1 6.7 107.6 0l69-12.9c13.4-2.5 26.6 5 31.4 17.7l28.9 77.2c11.5 30.7 28.1 59.2 49.1 84.4l45.3 54.3c8.7 10.4 8.7 25.5 0 35.9l-45.3 54.3c-21 25.2-37.6 53.7-49.1 84.4l-28.9 77.2c-4.8 12.7-18 20.2-31.4 17.7l-69-12.9c-35.6-6.7-72.1-6.7-107.6 0l-69 12.9c-13.4 2.5-26.6-5-31.4-17.7l-28.9-77.2C93.3 382 76.7 353.4 55.7 328.2L10.5 273.9c-8.7-10.4-8.7-25.5 0-35.9l45.3-54.3c21-25.2 37.6-53.7 49.1-84.4l28.9-77.2zm33.3 70.6L157.3 119c-13.7 36.6-33.5 70.6-58.5 100.6L88.4 232h44.6c23.5-27.6 41.7-59.2 53.7-93.4l2.5-7L167.1 92.8zm42.1-23.1l21.4 37.4c37.7 9.5 77.2 9.5 114.9 0l21.4-37.4-14.7 2.8c-42.4 7.9-85.9 7.9-128.3 0l-14.7-2.8zM408.9 92.8l-22.2 38.8 2.5 7c12.1 34.2 30.3 65.8 53.8 93.4h44.6l-10.3-12.4c-25-30-44.8-64-58.5-100.6l-9.8-26.2zM487.6 280H443c-23.6 28.1-41.8 60.4-53.6 95.3l-2.1 6.1 21.6 37.9 9.8-26.2c13.7-36.6 33.5-70.6 58.5-100.6L487.6 280zM366.8 442.3l-19.5-34.2c-37.9-11.7-78.3-12.8-116.7-3.2l-21.3 37.4 14.7-2.8c42.4-7.9 85.9-7.9 128.3 0l14.7 2.8zM167.1 419.2l22.2-38.8-2.5-7c-12.1-34.2-30.3-65.8-53.7-93.4H88.4l10.3 12.4c25 30 44.8 64 58.5 100.6l9.8 26.2zM193.2 280c10.1 15 18.9 30.7 26.5 47.1L246.6 280H193.2zm67.9 71.4c18.1-1.5 36.3-1.2 54.3 1L288 304.4l-26.9 47zm95.5-23.7c7.6-16.6 16.4-32.5 26.5-47.7H329.4l27.3 47.7zM382.8 232c-10.1-15-18.9-30.7-26.5-47.1L329.4 232h53.4zm-68.1-71c-17.7 1.7-35.6 1.7-53.3 0L288 207.6 314.7 161zm-94.9 23.9c-7.6 16.4-16.5 32.1-26.5 47.1h53.4l-26.9-47.1z"]
};
var faCircleMicrophone = {
  prefix: 'fas',
  iconName: 'circle-microphone',
  icon: [512, 512, ["microphone-circle"], "e116", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256c0 26.5-21.5 48-48 48s-48-21.5-48-48V144zm-64 80c8.8 0 16 7.2 16 16v16c0 53 43 96 96 96s96-43 96-96V240c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 65.3-48.9 119.1-112 127v17c0 8.8-7.2 16-16 16s-16-7.2-16-16V383c-63.1-7.9-112-61.7-112-127V240c0-8.8 7.2-16 16-16z"]
};
var faMicrophoneCircle = faCircleMicrophone;
var faBookArrowUp = {
  prefix: 'fas',
  iconName: 'book-arrow-up',
  icon: [448, 512, [], "e0ba", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H264V209.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V384H96c-17.7 0-32 14.3-32 32z"]
};
var faPopsicle = {
  prefix: 'fas',
  iconName: 'popsicle',
  icon: [320, 512, [], "e43e", "M160 0C71.6 0 0 71.6 0 160V336c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V160C320 71.6 248.4 0 160 0zm32 480V416H128v64c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faCommand = {
  prefix: 'fas',
  iconName: 'command',
  icon: [512, 512, [], "e142", "M0 96C0 43 43 0 96 0s96 43 96 96v32H320V96c0-53 43-96 96-96s96 43 96 96s-43 96-96 96H384V320h32c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96V384H192v32c0 53-43 96-96 96s-96-43-96-96s43-96 96-96h32V192H96C43 192 0 149 0 96zm128 32V96c0-17.7-14.3-32-32-32S64 78.3 64 96s14.3 32 32 32h32zm64 192H320V192H192V320zm-64 64H96c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32V384zm256 0v32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32H384zm0-256h32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32v32z"]
};
var faBlinds = {
  prefix: 'fas',
  iconName: 'blinds',
  icon: [512, 512, [], "f8fb", "M32 0C14.3 0 0 14.3 0 32C0 43.4 6 53.4 15 59.1L1.1 100.8c-.7 2.1-1.1 4.3-1.1 6.5C0 118.8 9.2 128 20.6 128H128V64h32v64H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L497 59.1c9-5.7 15-15.7 15-27.1c0-17.7-14.3-32-32-32H32zM24 160L1.1 228.8c-.7 2.1-1.1 4.3-1.1 6.5C0 246.8 9.2 256 20.6 256H98.7c4.8-13.6 15.6-24.4 29.3-29.3V160H24zM144 320c-20.9 0-38.7-13.4-45.3-32H24L1.1 356.8c-.7 2.1-1.1 4.3-1.1 6.5C0 374.8 9.2 384 20.6 384H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 288H189.3c-6.6 18.6-24.4 32-45.3 32zm16-93.3c13.6 4.8 24.4 15.6 29.3 29.3H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 160H160v66.7zM20.6 512H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 416H24L1.1 484.8c-.7 2.1-1.1 4.3-1.1 6.5C0 502.8 9.2 512 20.6 512z"]
};
var faStopwatch = {
  prefix: 'fas',
  iconName: 'stopwatch',
  icon: [448, 512, [9201], "f2f2", "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H224 176zm72 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSaxophone = {
  prefix: 'fas',
  iconName: 'saxophone',
  icon: [640, 512, [127927], "f8dc", "M246.7 176L171.4 306.1c-2.2 3.8-3.4 8.2-3.4 12.6v2.6c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L319 225l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L367 177l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L415 129l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8 44.3-44.3c12-12 28.3-18.7 45.3-18.7h30.3c15 0 29.5 5.2 41 14.8l24.3 20.3c3.7 3.1 5.9 7.7 5.9 12.6c0 9-7.3 16.3-16.3 16.3H559.5c-9.8 0-19 4.5-25.1 12.1L288.6 418.6C257.9 457.4 211.2 480 161.8 480C72.4 480 0 407.6 0 318.2v-3.1c0-12.7 1.5-25.4 4.4-37.8L28.2 176H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H246.7zM120 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSquare2 = {
  prefix: 'fas',
  iconName: 'square-2',
  icon: [448, 512, [], "e257", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM190.7 184.7l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L212.7 336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L244.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z"]
};
var faFieldHockeyStickBall = {
  prefix: 'fas',
  iconName: 'field-hockey-stick-ball',
  icon: [512, 512, [127953, "field-hockey"], "f44c", "M491.2 8.5c21.8 15.1 27.3 45 12.2 66.8l-52.2 75.5L371.3 97.5l53.1-76.8c15.1-21.8 45-27.3 66.8-12.2zM353.1 123.9L433 177.2 241 454.9c-24.6 35.5-64.9 56.8-108.1 56.9C59.5 512 .1 452.3 .6 378.9l0-2.2c.2-25.7 7.8-50.8 21.8-72.4l17.3-26.5c14.5-22.2 44.2-28.4 66.4-13.9s28.4 44.2 13.9 66.4l-17.3 26.5c-4 6.1-6.2 13.3-6.2 20.6l0 2.2c-.1 20 16 36.2 36 36.1c11.7 0 22.7-5.8 29.4-15.5L353.1 123.9zM432 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faFieldHockey = faFieldHockeyStickBall;
var faArrowUpSquareTriangle = {
  prefix: 'fas',
  iconName: 'arrow-up-square-triangle',
  icon: [576, 512, ["sort-shapes-up-alt"], "f88b", "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48zM443.1 303c-5.8-9.4-16.1-15-27.1-15s-21.3 5.7-27.1 15l-80 128c-6.2 9.9-6.5 22.3-.9 32.5s16.4 16.5 28 16.5H496c11.6 0 22.3-6.3 28-16.5s5.3-22.6-.9-32.5l-80-128z"]
};
var faSortShapesUpAlt = faArrowUpSquareTriangle;
var faFaceScream = {
  prefix: 'fas',
  iconName: 'face-scream',
  icon: [640, 512, [], "e38b", "M573.9 288.5c1.4-10.7 2.1-21.5 2.1-32.5C576 114.6 461.4 0 320 0S64 114.6 64 256c0 11 .7 21.9 2.1 32.6c20.6-2.5 41.7 3.5 57.8 16.9l0 0c57.5 48 87.8 118 98 187C252.1 505.1 285.2 512 320 512c34.8 0 68-6.9 98.2-19.5c10.2-69 40.4-139 98-187l0 0c16.1-13.4 37.2-19.4 57.8-17zM320 320c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm-46.6-77c-22.5 36.9-62.8 54.7-90.1 39.8s-31.1-56.9-8.7-93.7s62.8-54.7 90.1-39.8s31.1 56.9 8.7 93.7zm183.3 39.8c-27.3 14.9-67.6-2.9-90.1-39.8s-18.6-78.8 8.7-93.7s67.6 2.9 90.1 39.8s18.6 78.8-8.7 93.7zM103.4 330.1C89.1 318.2 68 316.4 51.6 327c-20 13-25.6 39.5-12.4 59.3c26.4 40 43.6 75.3 43.2 125.7L192 512c-7-68.4-34.8-137-88.7-181.9zM588.5 327c-16.4-10.6-37.6-8.8-51.8 3.1C482.8 375 455 443.6 448 512l109.8 0c-.4-50.5 16.7-85.7 43.2-125.7c13.1-19.8 7.6-46.3-12.4-59.3z"]
};
var faSquareM = {
  prefix: 'fas',
  iconName: 'square-m',
  icon: [448, 512, [], "e276", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm75.5 105.9L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2l-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7 .3 26.8 8.8z"]
};
var faCameraWeb = {
  prefix: 'fas',
  iconName: 'camera-web',
  icon: [448, 512, ["webcam"], "f832", "M344.2 413.1C406.6 373.3 448 303.5 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 79.5 41.4 149.3 103.8 189.1L45.6 453.8c-11.4 8-16.4 22.5-12.2 35.8S50 512 64 512H384c14 0 26.3-9.1 30.5-22.4s-.7-27.8-12.2-35.8l-58.2-40.7zM224 352a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-288a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM176 224c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z"]
};
var faWebcam = faCameraWeb;
var faCommentArrowDown = {
  prefix: 'fas',
  iconName: 'comment-arrow-down',
  icon: [512, 512, [], "e143", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm24-296V270.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faLightbulbCfl = {
  prefix: 'fas',
  iconName: 'lightbulb-cfl',
  icon: [320, 512, [], "e5a6", "M167.8 63c17.1-4.3 27.6-21.7 23.3-38.8S169.4-3.3 152.2 1L24.2 33C7.1 37.2-3.3 54.6 1 71.8S22.6 99.3 39.8 95l128-32zM319 88.2c-4.3-17.1-21.7-27.6-38.8-23.3l-256 64C7.1 133.2-3.3 150.6 1 167.8s21.7 27.6 38.8 23.3l256-64c17.1-4.3 27.6-21.7 23.3-38.8zM295.8 223c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3l-256 64C7.1 229.2-3.3 246.6 1 263.8s21.7 27.6 38.8 23.3l256-64zM64 416v32c0 17.7 14.3 32 32 32h32c0 17.7 14.3 32 32 32s32-14.3 32-32h32c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H144V294L96 306v78c-17.7 0-32 14.3-32 32zM319 280.2c-4.3-17.1-21.7-27.6-38.8-23.3l-64 16-16 4c-13.2 3.3-22.4 14.3-24 27l-.2 0v3.3c0 .5 0 .9 0 1.4V384h48V337l7.8-1.9 64-16c17.1-4.3 27.6-21.7 23.3-38.8z"]
};
var faWindowFrameOpen = {
  prefix: 'fas',
  iconName: 'window-frame-open',
  icon: [512, 512, [], "e050", "M480 224V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V224v64H96 416h64V224zm-64 0H280V64H416V224zm-184 0H96V64H232V224zM96 448V320H32V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320H416V448H96z"]
};
var faFaceKiss = {
  prefix: 'fas',
  iconName: 'face-kiss',
  icon: [512, 512, [128535, "kiss"], "f596", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faKiss = faFaceKiss;
var faBridgeCircleXmark = {
  prefix: 'fas',
  iconName: 'bridge-circle-xmark',
  icon: [640, 512, [], "e4cb", "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPeriod = {
  prefix: 'fas',
  iconName: 'period',
  icon: [128, 512, [], "2e", "M0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416z"]
};
var faFaceGrinTongue = {
  prefix: 'fas',
  iconName: 'face-grin-tongue',
  icon: [512, 512, [128539, "grin-tongue"], "f589", "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faGrinTongue = faFaceGrinTongue;
var faUpToDottedLine = {
  prefix: 'fas',
  iconName: 'up-to-dotted-line',
  icon: [448, 512, [], "e457", "M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM73.9 262.1L196.7 139.3c7.2-7.2 17.1-11.3 27.3-11.3s20.1 4.1 27.3 11.3L374.1 262.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9H288V448c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V320H97.9C79.2 320 64 304.8 64 286.1c0-9 3.6-17.6 9.9-24z"]
};
var faThoughtBubble = {
  prefix: 'fas',
  iconName: 'thought-bubble',
  icon: [512, 512, [], "e32e", "M374.8 80.3C355.9 33.2 309.8 0 256 0s-99.9 33.2-118.8 80.3c-3-.2-6.1-.3-9.2-.3C57.3 80 0 137.3 0 208s57.3 128 128 128c14.4 0 28.3-2.4 41.3-6.8C184.7 361.6 217.7 384 256 384s71.3-22.4 86.7-54.8c12.9 4.4 26.8 6.8 41.3 6.8c70.7 0 128-57.3 128-128s-57.3-128-128-128c-3.1 0-6.1 .1-9.2 .3zM144 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSkeletonRibs = {
  prefix: 'fas',
  iconName: 'skeleton-ribs',
  icon: [640, 512, [], "e5cb", "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H260.2c-33.5 0-65.7 17.6-82.1 48.9C150.5 165.8 96 282.2 96 384v17c0 43.6 35.4 79 79 79c15.1 0 30.1-2.7 44.2-8l67.1-25.2c.6-.2 1.1-.4 1.7-.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V446.2c.6 .2 1.1 .4 1.7 .6L420.8 472c14.1 5.3 29.1 8 44.2 8c43.6 0 79-35.4 79-79V384c0-101.8-54.5-218.2-82.2-271.1C445.5 81.6 413.3 64 379.8 64H352V32zm-64 96v38.3l-72.7 16.2c7-15.2 13.8-28.7 19.6-40c4.5-8.6 13.9-14.5 25.3-14.5H288zM186 254.6l102-22.7v39.7L171.2 303.4c4.1-16.5 9.2-32.9 14.7-48.8zM160.3 372.7L288 337.9v42c-8.2 1.7-16.3 4-24.2 7l-67.1 25.2c-7 2.6-14.3 3.9-21.7 3.9c-8.3 0-15-6.7-15-15V384c0-3.7 .1-7.5 .3-11.3zM352 379.9V339l118.8 35.6c3 .9 6.1 1.3 9.1 1.4c.1 2.7 .1 5.3 .1 8v17c0 8.3-6.7 15-15 15c-7.4 0-14.8-1.3-21.7-3.9l-67.1-25.2c-7.9-3-16-5.3-24.2-7zm117.8-72.4L352 272.2V231.9l102 22.7c6 17.2 11.4 35.1 15.7 53zm-45-125L352 166.3V128h27.8c11.4 0 20.8 5.9 25.3 14.5c5.9 11.3 12.6 24.8 19.6 40zM0 144v96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V240c0-10.1 4.7-19.6 12.8-25.6l25.6-19.2C118.5 183.1 128 164.1 128 144c0-35.3-28.7-64-64-64S0 108.7 0 144zM576 80c-35.3 0-64 28.7-64 64c0 20.1 9.5 39.1 25.6 51.2l25.6 19.2c8.1 6 12.8 15.5 12.8 25.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V240 144c0-35.3-28.7-64-64-64z"]
};
var faRaygun = {
  prefix: 'fas',
  iconName: 'raygun',
  icon: [576, 512, [], "e025", "M192 64h96V56c0-13.3 10.7-24 24-24s24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24v-.4L188.6 494.3c-7.9 15.8-27.1 22.2-42.9 14.3l-80-40c-15.8-7.9-22.2-27.1-14.3-42.9L120.2 288H112C50.1 288 0 237.9 0 176C0 131.3 26.2 92.8 64 74.8V24.6C64 11 75 0 88.6 0c4.8 0 9.6 1.4 13.6 4.1L192 64zm200 0c13.3 0 24 10.7 24 24v56h60.9l77.1-30.9c4.9-2 10.5-1.4 14.9 1.6s7 7.9 7 13.2v96c0 5.3-2.6 10.3-7 13.2s-10 3.6-14.9 1.6L476.9 208H416v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM136 176a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFlute = {
  prefix: 'fas',
  iconName: 'flute',
  icon: [640, 512, [], "f8b9", "M48 160H96V352H48c-26.5 0-48-21.5-48-48V208c0-26.5 21.5-48 48-48zM592 352H128V160H592c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48zM320 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faAcorn = {
  prefix: 'fas',
  iconName: 'acorn',
  icon: [448, 512, [], "f6ae", "M262.4 4.8c10.6 8 12.8 23 4.8 33.6l-4.8 6.4c-4.4 5.9-7.9 12.4-10.3 19.2H352c53 0 96 43 96 96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32c0-53 43-96 96-96H202.4C206 46.7 213.3 30.3 224 16l4.8-6.4c8-10.6 23-12.8 33.6-4.8zM213.9 476.4C78.5 425.9 48 302.1 48 224H224 400c0 78.1-30.5 201.9-165.9 252.4c-6.5 2.4-13.7 2.4-20.2 0z"]
};
var faVideoArrowUpRight = {
  prefix: 'fas',
  iconName: 'video-arrow-up-right',
  icon: [576, 512, [], "e2c9", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L416 174.9V192 320v17.1l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128zM152 160H264c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V241.9L137 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l103-103H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faGrateDroplet = {
  prefix: 'fas',
  iconName: 'grate-droplet',
  icon: [576, 512, [], "e194", "M0 96C0 60.7 28.7 32 64 32h64 96 96 64c35.3 0 64 28.7 64 64v66.2c-15.1 4.3-28.2 14.6-35.8 28.8L336.9 332.2C325.8 353.1 320 376.4 320 400c0 29.6 8.9 57.1 24.2 80H320 224 128 64c-35.3 0-64-28.7-64-64V256 96zm96 0H64V224H96V96zM64 416H96V288H64V416zm128 0V288H160V416h32zm96 0V288H256V416h32zM384 96H352V224h32V96zM256 96V224h32V96H256zm-96 0V224h32V96H160zM440.5 206.1c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z"]
};
var faSealExclamation = {
  prefix: 'fas',
  iconName: 'seal-exclamation',
  icon: [512, 512, [], "e242", "M222.1 17.9c18.7-18.7 49.1-18.7 67.9 0L336 64h64c26.5 0 48 21.5 48 48v64l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.1V400c0 26.5-21.5 48-48 48H335.1l-45.1 45.1c-18.7 18.7-49.1 18.7-67.9 0L176.9 448H112c-26.5 0-48-21.5-48-48V335.1L18.4 289.5c-18.7-18.7-18.7-49.1 0-67.9L64 176V112c0-26.5 21.5-48 48-48h64l46.1-46.1zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faChessBishop = {
  prefix: 'fas',
  iconName: 'chess-bishop',
  icon: [320, 512, [9821], "f43a", "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V400H256V372.7c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32H128zM48 432L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512H297.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L272 432H48z"]
};
var faMessageSms = {
  prefix: 'fas',
  iconName: 'message-sms',
  icon: [512, 512, [], "e1e5", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm202.9 80.8C196.4 147 192 153.1 192 160v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208v48c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6zm173.1 38c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.1 .1 12.9 1.4 20.1 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4c-9.3-.1-20.4 1.9-29.7 7.4c-9.9 5.9-18.6 16.4-18.5 31.6c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7-.2-13.5-2.4-22.6-5.5l0 0 0 0c-1.5-.5-3.2-1.1-4.9-1.6c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.2 .4 2.6 .9 4 1.4l0 0 0 0c8.8 3 20.4 7 32.6 7.4c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.2-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4zm-272 0c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.6 .1 16.7 1.6 23.3 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4c-9.3-.1-20.4 1.9-29.7 7.4C80.6 157.3 72 167.8 72 183c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7.2-.2-14.2-2.6-23.7-5.8l0 0 0 0c-1.3-.4-2.7-.9-4.1-1.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1 .4 2.4 .8 3.6 1.2l0 0 0 0c9 3.1 20.9 7.2 33.2 7.6c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4z"]
};
var faCoffeeBeans = {
  prefix: 'fas',
  iconName: 'coffee-beans',
  icon: [512, 512, [], "e13f", "M507.5 209.7c-3.4 12.3-19.1 11.8-25.4 .7c-5.4-9.5-11.3-18.5-17.6-26c-27.6-32.6-60.8-44.5-90.1-55l-1-.3c-30-10.7-55.8-20.2-77.5-45.9c-10.8-12.8-21.3-33.4-29.3-52c-1.7-4-.6-8.7 3-11.2C320.9-16 401.3-2.6 458 54c45.7 45.7 63.2 106.7 49.5 155.6zM228.5 78.3c3.4-12.3 19.1-11.8 25.4-.7c5.3 9.5 11.3 18.5 17.6 26c27.6 32.6 60.8 44.5 90.1 55l1 .3c30 10.7 55.8 20.2 77.5 45.9c10.8 12.8 21.3 33.4 29.3 52c1.7 4 .6 8.7-3 11.2C415.1 304 334.7 290.6 278 234c-45.7-45.7-63.2-106.7-49.5-155.6zM75.5 206c11.2-6.3 22 5.2 18.5 17.6c-2.9 10.5-5.2 21.2-6 31c-3.6 42.8 11.6 74.9 25 103.2l.4 .9c13.7 28.9 25.3 54.1 22.5 87.8c-1.4 16.7-8.6 38.9-16.1 57.9c-1.6 4.1-5.8 6.6-10.1 5.8C47.7 499.3 0 432.6 0 352c0-65 31-120.9 75.5-146zM180.5 498c-11.2 6.3-22-5.2-18.5-17.6c2.9-10.5 5.2-21.2 6-31c3.6-42.8-11.6-74.9-25-103.2l-.4-.9c-13.7-28.9-25.3-54.1-22.5-87.8c1.4-16.7 8.6-38.9 16.1-57.9c1.6-4.1 5.8-6.6 10.1-5.8C208.3 204.7 256 271.4 256 352c0 65-31 120.9-75.5 146z"]
};
var faHatWitch = {
  prefix: 'fas',
  iconName: 'hat-witch',
  icon: [576, 512, [], "f6e7", "M200.7 181.4L112 384H224V336c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v48H464L386.7 206.1c-1.8-4-2.7-8.4-2.7-12.8v-.8c0-5.6 1.5-11 4.2-15.9l18.6-32.5c5.7-10 16.3-16.1 27.8-16.1H455c14.7 0 27.5 10 31 24.2l6.2 24.6c2.2 8.9 10.2 15.1 19.4 15.1c9.5 0 17.7-6.7 19.6-16.1l12.2-60.8c.4-2.1 .6-4.2 .6-6.3v-6.8c0-9-3.8-17.5-10.4-23.6L457.2 8.4C451.3 3 443.6 0 435.6 0h-2.2c-6.1 0-12.1 1.8-17.3 5L273.1 96.6c-32 20.5-57.2 50-72.4 84.8zM320 384V336c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48h64zM22.6 416C10.1 416 0 426.1 0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512H416c77.4 0 134.1-41.7 153.1-57.8c4.6-3.9 6.9-9.6 6.9-15.6c0-12.5-10.1-22.6-22.6-22.6H22.6z"]
};
var faFaceGrinWink = {
  prefix: 'fas',
  iconName: 'face-grin-wink',
  icon: [512, 512, ["grin-wink"], "f58c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGrinWink = faFaceGrinWink;
var faClockThreeThirty = {
  prefix: 'fas',
  iconName: 'clock-three-thirty',
  icon: [512, 512, [], "e357", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V256c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faEarDeaf = {
  prefix: 'fas',
  iconName: 'ear-deaf',
  icon: [512, 512, ["deaf", "deafness", "hard-of-hearing"], "f2a4", "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7V400c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"]
};
var faDeaf = faEarDeaf;
var faDeafness = faEarDeaf;
var faHardOfHearing = faEarDeaf;
var faAlarmClock = {
  prefix: 'fas',
  iconName: 'alarm-clock',
  icon: [512, 512, [9200], "f34e", "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM280 184v94.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faEclipse = {
  prefix: 'fas',
  iconName: 'eclipse',
  icon: [640, 512, [], "f749", "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9l9.6 52.2c-34.2 15-63.7 38.9-85.4 68.8c-12.4-4-25.6-6.2-39.4-6.2c-70.7 0-128 57.3-128 128s57.3 128 128 128c13.7 0 27-2.2 39.4-6.2c21.7 29.9 51.1 53.9 85.4 68.8l-9.6 52.2c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM256 160c7.6 0 15 .9 22.1 2.6C264 190.7 256 222.4 256 256s8 65.3 22.1 93.4c-7.1 1.7-14.5 2.6-22.1 2.6c-53 0-96-43-96-96s43-96 96-96zM464 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352z"]
};
var faFaceRelieved = {
  prefix: 'fas',
  iconName: 'face-relieved',
  icon: [512, 512, [], "e389", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM187.3 356.7c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C329.4 397.2 298.9 416 256 416s-73.4-18.8-91.3-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM207.2 74.9c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zM314.9 95.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 141.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z"]
};
var faRoadCircleCheck = {
  prefix: 'fas',
  iconName: 'road-circle-check',
  icon: [640, 512, [], "e564", "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faDiceFive = {
  prefix: 'fas',
  iconName: 'dice-five',
  icon: [448, 512, [9860], "f523", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faOctagonMinus = {
  prefix: 'fas',
  iconName: 'octagon-minus',
  icon: [512, 512, ["minus-octagon"], "f308", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faMinusOctagon = faOctagonMinus;
var faSquareRss = {
  prefix: 'fas',
  iconName: 'square-rss',
  icon: [448, 512, ["rss-square"], "f143", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faRssSquare = faSquareRss;
var faFaceZany = {
  prefix: 'fas',
  iconName: 'face-zany',
  icon: [512, 512, [], "e3a4", "M384.1 477.7C506.5 407 548.5 250.4 477.8 128S250.5-36.4 128.1 34.3S-36.3 261.6 34.4 384c36.2 62.7 94.9 104.3 160.1 120.5c-11.5-15.8-18.4-35.4-18.4-56.5V408.2c-10.4-6.2-20.1-13.7-28.9-22.2c-10.2-9.9-6.6-26.3 5.7-33.4L391.2 214.9c12.3-7.1 28.3-2 31.8 11.8c15.2 59.4-5.9 124.1-55 165V448c0 15.4-3.6 30-10.1 42.9c8.8-3.8 17.5-8.2 26.1-13.2zM128 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm112-8a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm96.1 296V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0C257.8 383.9 248 376 236.7 376h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64zM152 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm144-56a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faTricycle = {
  prefix: 'fas',
  iconName: 'tricycle',
  icon: [512, 512, [], "e5c3", "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h73.6c7.9 0 14.4 6.4 14.4 14.4c0 4.2-1.8 8.2-5 10.9l-42.6 36.5c-.8 .7-1.6 1.4-2.3 2.2H307.2c-58.8 0-114 23.9-154.1 64.6L133.6 176H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H77.6l44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7c-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4c30.7-48.1 84-77.6 141.6-77.6h12.1l11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-2.4 0-4.8 .1-7.2 .2l-13.9-55.6 31.3-26.9C408 129.9 416 112.6 416 94.4C416 59.9 388.1 32 353.6 32H280zm64.2 260l16.5 65.9c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1l-16.5-65.9c36.6 3.4 65.2 34.2 65.2 71.7c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-25.1 12.8-47.1 32.2-60zM112 312a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faLandMineOn = {
  prefix: 'fas',
  iconName: 'land-mine-on',
  icon: [640, 512, [], "e51b", "M344 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32H192V320zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5H482.3c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"]
};
var faSquareArrowUpLeft = {
  prefix: 'fas',
  iconName: 'square-arrow-up-left',
  icon: [448, 512, [], "e263", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM288 144c13.3 0 24 10.7 24 24s-10.7 24-24 24H193.9L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24H288z"]
};
var faICursor = {
  prefix: 'fas',
  iconName: 'i-cursor',
  icon: [256, 512, [], "f246", "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V128.3c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"]
};
var faChartMixedUpCircleDollar = {
  prefix: 'fas',
  iconName: 'chart-mixed-up-circle-dollar',
  icon: [576, 512, [], "e5d9", "M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.8L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L480 105v39c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H400zM192 224c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32zM64 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z"]
};
var faSaltShaker = {
  prefix: 'fas',
  iconName: 'salt-shaker',
  icon: [384, 512, [129474], "e446", "M319.4 448H64.6l36.6-256H282.8l36.6 256zM59.8 512H324.2c33 0 59.8-26.8 59.8-59.8c0-2.8-.2-5.7-.6-8.5L338.1 126.7C327.7 54 265.4 0 192 0S56.3 54 45.9 126.7L.6 443.8c-.4 2.8-.6 5.6-.6 8.5c0 33 26.8 59.8 59.8 59.8zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM240 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faStamp = {
  prefix: 'fas',
  iconName: 'stamp',
  icon: [512, 512, [], "f5bf", "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V413.3c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112H366.2c-29.9 0-54.2-24.3-54.2-54.2zM416 416v32H96V416H416z"]
};
var faFilePlus = {
  prefix: 'fas',
  iconName: 'file-plus',
  icon: [384, 512, [], "f319", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM192 240c13.3 0 24 10.7 24 24v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V264c0-13.3 10.7-24 24-24z"]
};
var faDrawSquare = {
  prefix: 'fas',
  iconName: 'draw-square',
  icon: [448, 512, [], "f5ef", "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V151.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM119.4 448c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V360.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4z"]
};
var faToiletPaperUnderSlash = {
  prefix: 'fas',
  iconName: 'toilet-paper-under-slash',
  icon: [640, 512, ["toilet-paper-reverse-slash"], "e2a1", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V343.1c-9.9 19.5-23.2 38.2-39.9 51.8L510 374.4c22.6-14.8 41.4-46 53.1-86.4c8.2-28.2 12.8-61 12.8-96C576 86 533 0 480 0c-11.2 0-22 3.8-32 10.9c-37.3 26.4-64 97.5-64 181.1c0 33.8 4.4 65.5 12 93.1l-39.3-30.8c-3.1-19.9-4.7-40.8-4.7-62.3c0-56.9 11.5-110 31.5-150.1c7.5-15 17.1-29.7 28.7-41.9H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM528 512L406.2 416H224v48c0 26.5 21.5 48 48 48H528l.3 0H528zM64 192c0 106 43 192 96 192H365.5L66.5 148.4C64.9 162.4 64 177 64 192zm416 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"]
};
var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
var faStairs = {
  prefix: 'fas',
  iconName: 'stairs',
  icon: [576, 512, [], "e289", "M384 64c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v96c0 17.7-14.3 32-32 32H320v96c0 17.7-14.3 32-32 32H192v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V320c0-17.7 14.3-32 32-32h96V192c0-17.7 14.3-32 32-32h96V64z"]
};
var faDroneFront = {
  prefix: 'fas',
  iconName: 'drone-front',
  icon: [640, 512, ["drone-alt"], "f860", "M155.7 112c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H155.7zM376 112c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H539.7c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16H376zM96 192v64c0 12.6 7.4 24.1 19 29.2l56.5 25.1c-17.8 21.5-27.5 48.5-27.5 76.4V392c0 13.3 10.7 24 24 24s24-10.7 24-24v-5.2c0-16.8 5.9-33.2 16.7-46.1l8.4-10.1L259 349.2c4.1 1.8 8.5 2.8 13 2.8h96c4.5 0 8.9-.9 13-2.8l41.9-18.6 8.4 10.1c10.8 12.9 16.7 29.3 16.7 46.1V392c0 13.3 10.7 24 24 24s24-10.7 24-24v-5.2c0-27.9-9.7-54.9-27.5-76.4L525 285.2c11.6-5.1 19-16.6 19-29.2V192H480v43.2l-17.8 7.9-40.6-23.7C390.7 201.5 355.7 192 320 192s-70.7 9.5-101.6 27.5l-40.6 23.7L160 235.2V192H96z"]
};
var faDroneAlt = faDroneFront;
var faGlassEmpty = {
  prefix: 'fas',
  iconName: 'glass-empty',
  icon: [384, 512, [], "e191", "M8.6 10.2C14.6 3.7 23.1 0 32 0H352c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1L355.1 437.7c-3 41.9-37.8 74.3-79.8 74.3H108.7c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64L92.7 433.1c.6 8.4 7.6 14.9 16 14.9H275.3c8.4 0 15.4-6.5 16-14.9L317.6 64H66.4z"]
};
var faDialHigh = {
  prefix: 'fas',
  iconName: 'dial-high',
  icon: [576, 512, [], "e15c", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm.4 127.6c80.2 0 146.6 59 158.2 136H288.4c-13.3 0-24 10.7-24 24s10.7 24 24 24H446.6c-11.6 77-78 136-158.2 136c-88.4 0-160-71.6-160-160s71.6-160 160-160zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faUserHelmetSafety = {
  prefix: 'fas',
  iconName: 'user-helmet-safety',
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", "M216 0c-13.3 0-24 10.7-24 24V80L163.6 23.1C125.6 43.5 99 82.6 96.2 128H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24h-.2C349 82.6 322.4 43.5 284.4 23.1L256 80V24c0-13.3-10.7-24-24-24H216zm8 320c65.3 0 119.1-48.9 127-112H97c7.9 63.1 61.7 112 127 112zm-89.6 32C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352H134.4z"]
};
var faUserConstruction = faUserHelmetSafety;
var faUserHardHat = faUserHelmetSafety;
var faI = {
  prefix: 'fas',
  iconName: 'i',
  icon: [320, 512, [105], "49", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96h96V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 32z"]
};
var faHryvniaSign = {
  prefix: 'fas',
  iconName: 'hryvnia-sign',
  icon: [384, 512, [8372, "hryvnia"], "f6f2", "M121.9 116.2C138.3 103.1 158.7 96 179.6 96H223c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H155.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H52.3c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H331.7c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113H179.6c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"]
};
var faHryvnia = faHryvniaSign;
var faArrowDownLeftAndArrowUpRightToCenter = {
  prefix: 'fas',
  iconName: 'arrow-down-left-and-arrow-up-right-to-center',
  icon: [512, 512, [], "e092", "M502.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L336 130.7V80c0-17.7-14.3-32-32-32s-32 14.3-32 32V208c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32s-14.3-32-32-32H381.3L502.6 54.6zM80 272c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L176 381.3V432c0 17.7 14.3 32 32 32s32-14.3 32-32V304c0-17.7-14.3-32-32-32H80z"]
};
var faPills = {
  prefix: 'fas',
  iconName: 'pills',
  icon: [576, 512, [], "f484", "M112 96c-26.5 0-48 21.5-48 48V256h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"]
};
var faFaceGrinWide = {
  prefix: 'fas',
  iconName: 'face-grin-wide',
  icon: [512, 512, [128515, "grin-alt"], "f581", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"]
};
var faGrinAlt = faFaceGrinWide;
var faTooth = {
  prefix: 'fas',
  iconName: 'tooth',
  icon: [448, 512, [129463], "f5c9", "M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"]
};
var faBasketballHoop = {
  prefix: 'fas',
  iconName: 'basketball-hoop',
  icon: [640, 512, [], "f435", "M6.8 187C24.7 153.1 116.7 0 320 0S615.3 153.1 633.2 187c4.9 9.4 6.8 19.1 6.8 28V331.2c0 25.3-14.9 48.2-38 58.5l-96.4 42.9L526.2 288H493.9l-7.2 50.3-22.9 160c-.9 6.1-5.2 11.2-11.1 13s-12.3 .1-16.5-4.4L384.4 451l-52.8 56c-3 3.2-7.2 5-11.6 5s-8.6-1.8-11.6-5l-52.8-56-51.9 55.9c-4.2 4.5-10.6 6.2-16.5 4.4s-10.2-6.9-11.1-13l-22.9-160L146.1 288H113.8l20.7 144.6L38 389.7C14.9 379.4 0 356.5 0 331.2V214.9c0-8.9 1.8-18.6 6.8-28zM178.4 288l5.2 36.6 44-36.6H178.4zm99.3 0l-.6 .5L320 334.6l42.8-46.1-.6-.5H277.8zm134.5 0l44 36.6 5.2-36.6H412.3zM192 128c-17.7 0-32 14.3-32 32v48H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64H464h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V160c0-17.7-14.3-32-32-32H192zm256 32v48H192V160H448zM387.5 309l-45.7 49.2 42.7 46 51.6-54.7L387.5 309zm49.4 151.6l11-76.8-41.5 44 30.5 32.9zM320 381.7l-42.6 45.9L320 472.7l42.6-45.2L320 381.7zm-21.8-23.5L252.5 309l-48.7 40.5 51.6 54.7 42.7-46zm-64.6 69.5l-41.5-44 11 76.8 30.5-32.9z"]
};
var faObjectsAlignBottom = {
  prefix: 'fas',
  iconName: 'objects-align-bottom',
  icon: [512, 512, [], "e3bb", "M24 512l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24zM64 336c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48l0 288zm224 0c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48l0 160z"]
};
var faV = {
  prefix: 'fas',
  iconName: 'v',
  icon: [384, 512, [118], "56", "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z"]
};
var faSparkles = {
  prefix: 'fas',
  iconName: 'sparkles',
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
};
var faSquid = {
  prefix: 'fas',
  iconName: 'squid',
  icon: [512, 512, [129425], "e450", "M276 .3c-5.3-1.1-10.8 .6-14.6 4.5s-5.4 9.4-4.2 14.7l13.1 58.9c-71.9 46.2-103.4 101.8-110.6 148.4L146 213l-2.3-2.3-22.6-22.6c-6.2-6.2-6.2-16.4 0-22.6l56.4-56.4c18.9-18.9 18.7-49.5-.3-68.2L140.1 4.6c-6.3-6.1-16.3-6.1-22.5 .1l-2.8 2.8c-34 34-33.3 87.7-1.9 121L98.5 142.9c-18.7 18.7-18.7 49.1 0 67.9l22.6 22.6 0 0 5.7 5.7 0 0c9.3 9.4 9.3 24.5 0 33.9c-9.3 9.3-24.4 9.4-33.8 .2L76.5 256.6c-19.1-19.1-50.2-18.7-68.7 .9L4.4 261c-6.1 6.4-5.8 16.5 .6 22.6s16.5 5.8 22.6-.6l3.3-3.5c6.2-6.5 16.6-6.7 22.9-.3l10.6 10.6 .1 .2 22.6 22.6c10.1 10.2 9 26.9-2.4 35.8l-20 15.6c-3.5 2.7-7.7 4.2-12.1 4.2c-10.9 0-19.7-8.8-19.7-19.7V336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 12.3C.9 376.8 24.1 400 52.6 400c11.5 0 22.7-3.8 31.8-10.9l28.2-21.9c9.4-7.3 22.8-6.5 31.2 1.9s9.3 21.8 1.9 31.2l-21.9 28.2c-7.1 9.1-10.9 20.3-10.9 31.8c0 28.6 23.2 51.7 51.7 51.7h12.3c8.8 0 16-7.2 16-16s-7.2-16-16-16H164.6c-10.9 0-19.7-8.8-19.7-19.7c0-4.4 1.5-8.7 4.2-12.1l15.6-20c8.8-11.4 25.6-12.4 35.8-2.3l.1 .1L223 448.3l.1 .1 9.9 9.8c6.5 6.5 6.2 17.2-.7 23.3l-2.8 2.5c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l2.8-2.5c20.7-18.3 21.6-50.3 2.1-69.8l-9.9-9.9-5.7-5.7-.1-.1c-9.3-9.3-9.3-24.4 0-33.8l.1-.1 .1-.1c9.3-9.2 24.4-9.2 33.7 0l28.4 28.4c18.7 18.7 49.1 18.7 67.9 0L384.4 400c33.3 31.4 87 32.1 121-1.9l2.8-2.8c6.2-6.2 6.3-16.3 .1-22.5L472 335.7c-18.7-19-49.3-19.2-68.2-.3l-56.4 56.3c-6.2 6.2-16.4 6.2-22.6 0l-22.5-22.5-.1-.1-16-16c46.6-7.2 102.2-38.7 148.4-110.6l58.9 13.1c5.3 1.2 10.8-.4 14.7-4.2s5.6-9.3 4.5-14.6L489.3 120.2c9.2-30.2 17.2-64 23.4-101.5c.9-5.1-.8-10.3-4.5-13.9S499.4-.6 494.3 .2C456.7 6.5 423 14.4 392.7 23.6L276 .3zM168.9 280a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faLeafyGreen = {
  prefix: 'fas',
  iconName: 'leafy-green',
  icon: [576, 512, [129388], "e41d", "M97.9 28.4C92 34.4 87 40.8 83 47.7C70 69.6 50.6 89.9 30.9 105.9c-2.3 1.8-4.4 3.8-6.5 5.9C-1.4 137.6-6.8 176.2 8.5 207.2c5.7 11.7 11 24.1 11 37.1v35.7c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2l0 12.9c0 2.9 .2 5.8 .7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6V330.5c0-25.5 10.1-49.9 28.1-67.9l10.5-10.5c6-6 9.4-14.1 9.4-22.6v-43c0-25.5 10.1-49.9 28.1-67.9l29.1-29.1c5-5 8.8-12.9 13.7-27c4.4-12.9 10.8-24.8 18.9-35.5c-38-36.5-98.4-36-135.8 1.5zM567.5 229.9c-3.1-29.1-2.3-61.5 5-89.9c2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5c-28.4 7.3-60.8 8.1-89.9 5c-3.3-.3-6.7-.5-10.1-.5c-42.1 0-77.9 27.1-90.8 64.9c-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3v43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3v45.7c0 17-6.7 33.3-18.7 45.3L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.9-35.9c12-12 28.3-18.7 45.3-18.7h45.7c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7h43c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3C540.9 317.9 568 282.1 568 240c0-3.4-.2-6.8-.5-10.1zM475.3 100.7c6.2 6.2 6.2 16.4 0 22.6L390.6 208H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H358.6l-59.3 59.3-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L272 281.4V192c0-8.8 7.2-16 16-16s16 7.2 16 16v57.4l36.7-36.7 112-112c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faCircleArrowUpRight = {
  prefix: 'fas',
  iconName: 'circle-arrow-up-right',
  icon: [512, 512, [], "e0fc", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm368 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-94.1L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135L184 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l160 0c13.3 0 24 10.7 24 24l0 152z"]
};
var faCalendars = {
  prefix: 'fas',
  iconName: 'calendars',
  icon: [512, 512, [], "e0d7", "M224 0c-17.7 0-32 14.3-32 32V64H144c-26.5 0-48 21.5-48 48v48H512V112c0-26.5-21.5-48-48-48H416V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H256V32c0-17.7-14.3-32-32-32zM96 192V368c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V192H96zm-48-8c0-13.3-10.7-24-24-24s-24 10.7-24 24V392c0 66.3 53.7 120 120 120H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V184z"]
};
var faBangladeshiTakaSign = {
  prefix: 'fas',
  iconName: 'bangladeshi-taka-sign',
  icon: [384, 512, [], "e2e6", "M36 32.2C18.4 30.1 2.4 42.5 .2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8V160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V384c0 53 43 96 96 96h32c106 0 192-86 192-192V256c0-53-43-96-96-96H272c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c17.7 0 32 14.3 32 32v32c0 70.7-57.3 128-128 128H160c-17.7 0-32-14.3-32-32V224h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V128.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"]
};
var faBicycle = {
  prefix: 'fas',
  iconName: 'bicycle',
  icon: [640, 512, [128690], "f206", "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"]
};
var faHammerWar = {
  prefix: 'fas',
  iconName: 'hammer-war',
  icon: [384, 512, [], "f6e4", "M192 0c17.7 0 32 14.3 32 32V50.8L347.3 32.4c9.2-1.4 18.6 1.3 25.6 7.4S384 54.7 384 64V256c0 9.3-4.1 18.2-11.1 24.2s-16.4 8.8-25.6 7.4L196.7 265.1c-3.1-.5-6.3-.5-9.5 0L36.7 287.6c-9.2 1.4-18.6-1.3-25.6-7.4S0 265.3 0 256V64c0-9.3 4.1-18.2 11.1-24.2s16.4-8.8 25.6-7.4L160 50.8V32c0-17.7 14.3-32 32-32zm0 296.7l32 4.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V301.5l32-4.8z"]
};
var faCircleD = {
  prefix: 'fas',
  iconName: 'circle-d',
  icon: [512, 512, [], "e104", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128h72c70.7 0 128 57.3 128 128s-57.3 128-128 128H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm72 208c44.2 0 80-35.8 80-80s-35.8-80-80-80H208V336h48z"]
};
var faSpiderBlackWidow = {
  prefix: 'fas',
  iconName: 'spider-black-widow',
  icon: [512, 512, [], "f718", "M144.6 1.6c12.4 4.8 18.5 18.6 13.8 31l-32.5 84.6c-1.1 3-.4 6.3 1.8 8.5L176 174.1V160c0-31.8 18.6-59.3 45.5-72.2c9.1-4.4 18.5 3.3 18.5 13.4V112c0 8.8 7.2 16 16 16s16-7.2 16-16V101.2c0-10.1 9.4-17.7 18.5-13.4C317.4 100.7 336 128.2 336 160v14.1l48.3-48.3c2.2-2.2 2.9-5.6 1.8-8.5L353.6 32.6c-4.8-12.4 1.4-26.3 13.8-31s26.3 1.4 31 13.8L430.9 100c7.9 20.7 3 44.1-12.7 59.7l-57.4 57.4 80.4-26.8c2.4-.8 4.3-2.7 5.1-5.1l18.9-56.8c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4l-18.9 56.8c-5.6 16.7-18.7 29.8-35.4 35.4L395.9 256l60.5 20.2c16.7 5.6 29.8 18.7 35.4 35.4l18.9 56.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-18.9-56.8c-.8-2.4-2.7-4.3-5.1-5.1l-80.4-26.8 57.4 57.4c15.6 15.6 20.6 39 12.7 59.7l-32.5 84.6c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l32.5-84.6c1.1-3 .4-6.3-1.8-8.5L352 353.9c-1 52.1-43.6 94.1-96 94.1s-95-41.9-96-94.1l-32.3 32.3c-2.2 2.2-2.9 5.6-1.8 8.5l32.5 84.6c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8L81.1 412c-7.9-20.7-3-44.1 12.7-59.7l57.4-57.4L70.8 321.7c-2.4 .8-4.3 2.7-5.1 5.1L46.8 383.6C42.6 396.2 29 403 16.4 398.8S-3 381 1.2 368.4l18.9-56.8c5.6-16.7 18.7-29.8 35.4-35.4L116.1 256 55.6 235.8c-16.7-5.6-29.8-18.7-35.4-35.4L1.2 143.6C-3 131 3.8 117.4 16.4 113.2s26.2 2.6 30.4 15.2l18.9 56.8c.8 2.4 2.7 4.3 5.1 5.1l80.4 26.8L93.7 159.7C78.1 144 73.1 120.6 81.1 100l32.5-84.6c4.8-12.4 18.6-18.5 31-13.8zm73.8 305.6L240 336l-21.6 28.8c-1.6 2.1-2.4 4.6-2.4 7.2c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12c0-2.6-.8-5.1-2.4-7.2L272 336l21.6-28.8c1.6-2.1 2.4-4.6 2.4-7.2c0-6.6-5.4-12-12-12H228c-6.6 0-12 5.4-12 12c0 2.6 .8 5.1 2.4 7.2z"]
};
var faStaffSnake = {
  prefix: 'fas',
  iconName: 'staff-snake',
  icon: [384, 512, ["rod-asclepius", "rod-snake", "staff-aesculapius"], "e579", "M222.6 43.2l-.1 4.8H288c53 0 96 43 96 96s-43 96-96 96H248V160h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H248 220l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96H240V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H213l-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32H152c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128H136 122.6c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56S25.1 48 56 48h8 8 89.5l-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faRodAsclepius = faStaffSnake;
var faRodSnake = faStaffSnake;
var faStaffAesculapius = faStaffSnake;
var faPear = {
  prefix: 'fas',
  iconName: 'pear',
  icon: [512, 512, [], "e20c", "M505 7c9.4 9.4 9.4 24.6 0 33.9L457.9 88.1c14 20.5 22.1 45.3 22.1 71.9c0 30.7-10.8 58.9-28.9 81c-29.9 36.5-61.4 81.8-73.3 127.4c-8.3 32-25 62.3-50.1 87.3c-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1c45.7-11.8 90.9-43.4 127.4-73.3c22.1-18 50.3-28.9 81-28.9c26.7 0 51.4 8.2 71.9 22.1L471 7c9.4-9.4 24.6-9.4 33.9 0zM320 320c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 53-43 96-96 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c70.7 0 128-57.3 128-128z"]
};
var faHeadSideCoughSlash = {
  prefix: 'fas',
  iconName: 'head-side-cough-slash',
  icon: [640, 512, [], "e062", "M448 325.8l44 34.5c8.1 1.4 14.8 6.8 18 14.1L552.9 408c10.6 .4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1c11.1 0 20.4 7.5 23.2 17.8h-3.9c6.2 8.5 6.4 20.4-.4 29c-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L89.6 44.9C127 16.7 173.5 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 5.8zM0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTriangle = {
  prefix: 'fas',
  iconName: 'triangle',
  icon: [512, 512, [9650], "f2ec", "M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480H472c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z"]
};
var faApartment = {
  prefix: 'fas',
  iconName: 'apartment',
  icon: [576, 512, [], "e468", "M176 0c-26.5 0-48 21.5-48 48V96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48h80 32 96V416c0-17.7 14.3-32 32-32s32 14.3 32 32v96h96 32 80c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H448V48c0-26.5-21.5-48-48-48H176zM368 320H336c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm144 80c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm16 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm112-80H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM384 80v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zM384 208c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM496 320H464c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 208c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm112 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16z"]
};
var faTruckMedical = {
  prefix: 'fas',
  iconName: 'truck-medical',
  icon: [640, 512, [128657, "ambulance"], "f0f9", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H240V80c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"]
};
var faAmbulance = faTruckMedical;
var faPepper = {
  prefix: 'fas',
  iconName: 'pepper',
  icon: [512, 512, [129745], "e432", "M252.6 11.7C245.8 .3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c6.7 11.2 10.3 24 10.3 37v10.9c-5.6-2-11.5-3.5-17.4-4.4l-1.1-.2c-8.1-1.2-16.4-1.3-24.9-.3c-4 .5-7.9 1.2-11.9 2.2c-51.4 12.9-74.7 65-61.9 116.4l37.1 148.3c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6L83.8 223c-11.8-47 .4-94.4 31.3-125.2c-13.6-2.8-28-2.6-42.4 1C21.3 111.7-10 163.8 2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.8c7-1.7 13.6-4.2 19.8-7.3c5.6-2.8 12.3-2.8 17.9 0c3 1.5 6 2.8 9.2 4c10.7 4 22.2 6.2 34 6.2c11.6 0 22.9-2.1 33.5-6.1c3.2-1.2 6.4-2.6 9.4-4.1c5.6-2.8 12.3-2.8 17.9 0c6.2 3.1 12.8 5.6 19.8 7.3c51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.8-116.4c-23.2-5.8-46.5-2.6-66.3 7.3c-5.6 2.8-12.3 2.8-17.9 0c-6.2-3.1-12.8-5.6-19.8-7.3c-19-4.8-38.1-3.5-55.3 2.6V90.6c0-21.7-5.9-43.1-17.1-61.7L252.6 11.7z"]
};
var faPiano = {
  prefix: 'fas',
  iconName: 'piano',
  icon: [512, 512, [], "f8d4", "M0 192V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.6c0-24.2-13.7-46.4-35.4-57.2l-58.4-29.2c-21-10.5-34.2-31.9-34.2-55.4C384 83.2 300.8 0 198.3 0H192C86 0 0 86 0 192zM416 352h32v96H64V352H96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352z"]
};
var faGunSquirt = {
  prefix: 'fas',
  iconName: 'gun-squirt',
  icon: [576, 512, [], "e19d", "M128 56c0-13.3-10.7-24-24-24S80 42.7 80 56v9.3C34.6 72.9 0 112.4 0 160c0 47.3 34.3 86.7 79.4 94.6L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480H168c14.7 0 27.5-10 31-24.2L219 376h53v16c0 13.3 10.7 24 24 24s24-10.7 24-24V352 312c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H231l18-72H448c41.8 0 77.4-26.7 90.5-64H552c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H538.5C525.4 90.7 489.8 64 448 64H128V56zM96 128H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faWheatAwnCircleExclamation = {
  prefix: 'fas',
  iconName: 'wheat-awn-circle-exclamation',
  icon: [640, 512, [], "e598", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faSnowman = {
  prefix: 'fas',
  iconName: 'snowman',
  icon: [512, 512, [9731, 9924], "f7d0", "M341.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L408 160.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9H181.3c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3L70.5 198.1l-56-24C2.4 168.8-3.3 154.7 1.9 142.5s19.3-17.8 31.5-12.6L56 139.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2L152.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C164 127.2 160 112.1 160 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24v3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faUserAlien = {
  prefix: 'fas',
  iconName: 'user-alien',
  icon: [448, 512, [], "e04a", "M64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 101-106.6 185-139.2 208.3c-6.1 4.3-13.4 6.5-20.8 6.5s-14.7-2.1-20.8-6.5C170.6 352 64 268.1 64 167zm244.6 9c-37.9 0-68.6 30.7-68.6 68.6c0 6.3 5.1 11.4 11.4 11.4h16c37.9 0 68.6-30.7 68.6-68.6c0-6.3-5.1-11.4-11.4-11.4h-16zM208 244.6c0-37.9-30.7-68.6-68.6-68.6h-16c-6.3 0-11.4 5.1-11.4 11.4c0 37.9 30.7 68.6 68.6 68.6h16c6.3 0 11.4-5.1 11.4-11.4zM0 486.4C0 415 55.7 356.6 126.1 352.3c23.8 23.2 46.1 40.2 58.5 49.1c12 8.6 25.9 12.4 39.4 12.4s27.4-3.8 39.4-12.4c12.4-8.8 34.7-25.8 58.5-49.1C392.3 356.6 448 415 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4z"]
};
var faShieldCheck = {
  prefix: 'fas',
  iconName: 'shield-check',
  icon: [512, 512, [], "f2f7", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faMortarPestle = {
  prefix: 'fas',
  iconName: 'mortar-pestle',
  icon: [512, 512, [], "f5a7", "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160H397.3L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512H352c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faRoadBarrier = {
  prefix: 'fas',
  iconName: 'road-barrier',
  icon: [640, 512, [], "e562", "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32zM405.2 96H330.8l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zM362.8 288h74.3l5.4-10.7L533.2 96H458.8l-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96H202.8zm288 192H576V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7L490.8 288z"]
};
var faChartCandlestick = {
  prefix: 'fas',
  iconName: 'chart-candlestick',
  icon: [512, 512, [], "e0e2", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zM320 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32V48zm64 176v64c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c-17.7 0-32 14.3-32 32zM160 128c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48z"]
};
var faBriefcaseBlank = {
  prefix: 'fas',
  iconName: 'briefcase-blank',
  icon: [512, 512, [], "e0c8", "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64z"]
};
var faSchool = {
  prefix: 'fas',
  iconName: 'school',
  icon: [640, 512, [127979], "f549", "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM256 416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H256V416zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z"]
};
var faIgloo = {
  prefix: 'fas',
  iconName: 'igloo',
  icon: [576, 512, [], "f7ae", "M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160V39.1C424.9 55.7 487.2 99.8 527.5 160H352zM29.9 192H96V320H0c0-46 10.8-89.4 29.9-128zM192 320H128V192H448V320H384v32H576v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64V480H48c-26.5 0-48-21.5-48-48V352H192V320zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128H480z"]
};
var faBracketRound = {
  prefix: 'fas',
  iconName: 'bracket-round',
  icon: [192, 512, ["parenthesis"], "28", "M154.6 46.2c9.8 14.7 5.8 34.6-8.9 44.4C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4c14.7 9.8 18.7 29.7 8.9 44.4s-29.7 18.7-44.4 8.9C71.9 449 0 371.8 0 256S71.9 62.9 110.2 37.4c14.7-9.8 34.6-5.8 44.4 8.9z"]
};
var faParenthesis = faBracketRound;
var faJoint = {
  prefix: 'fas',
  iconName: 'joint',
  icon: [640, 512, [], "f595", "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h19 51.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352H336 288c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9V392c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"]
};
var faHorseSaddle = {
  prefix: 'fas',
  iconName: 'horse-saddle',
  icon: [576, 512, [], "f8c3", "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128v32c0 41.8-26.7 77.4-64 90.5v78.6l51.7 14.8c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM224 320V256c-53 0-96-43-96-96V130.6c-21.8 5.5-40.3 19.5-51.7 38.2C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l.3 .1zm64-160V128H224 203.2 160v32c0 35.3 28.7 64 64 64s64-28.7 64-64zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faMugMarshmallows = {
  prefix: 'fas',
  iconName: 'mug-marshmallows',
  icon: [512, 512, [], "f7b7", "M192 32c7.5 0 14.4 2.6 19.8 6.9L175 75.7c-9.6 9.6-15 22.7-15 36.3c0 5.5 .9 10.9 2.6 16H32V64c0-17.7 14.3-32 32-32H192zm5.7 93.7C194 122 192 117.1 192 112s2-10 5.7-13.7l60.7-60.7C262 34 266.9 32 272 32s10 2 13.7 5.7l60.7 60.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L344 128H200l-2.3-2.3zM0 192c0-17.7 14.3-32 32-32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160H352h48c61.9 0 112 50.1 112 112s-50.1 112-112 112H384c0 53-43 96-96 96H96c-53 0-96-43-96-96V192zm384 32v96h16c26.5 0 48-21.5 48-48s-21.5-48-48-48H384z"]
};
var faFilters = {
  prefix: 'fas',
  iconName: 'filters',
  icon: [640, 512, [], "e17e", "M232 32c-15.9 0-30.2 9.4-36.6 23.9s-3.6 31.5 7.2 43.2L352 261.5V368c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6V261.5L629.4 99.1c10.7-11.7 13.6-28.6 7.2-43.2S615.9 32 600 32H232zM40 96c-15.9 0-30.2 9.4-36.6 23.9s-3.6 31.5 7.2 43.2L160 325.5V400c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6V325.5l32-34.8V274L179 120.7c-6.7-7.3-11.7-15.7-14.9-24.7H40z"]
};
var faBellOn = {
  prefix: 'fas',
  iconName: 'bell-on',
  icon: [640, 512, [128365], "f8fa", "M320 0c-17.7 0-32 14.3-32 32V51.2C215 66 160 130.6 160 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416H512c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C497.3 319.2 480 273.9 480 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7zM0 200c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm536-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H536zM597.5 21.3c-5.9-11.9-20.3-16.7-32.2-10.7l-64 32c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l64-32c11.9-5.9 16.7-20.3 10.7-32.2zM53.3 53.5l64 32c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-64-32C62.9 4.6 48.5 9.4 42.5 21.3s-1.1 26.3 10.7 32.2z"]
};
var faAngleRight = {
  prefix: 'fas',
  iconName: 'angle-right',
  icon: [320, 512, [8250], "f105", "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"]
};
var faDialMed = {
  prefix: 'fas',
  iconName: 'dial-med',
  icon: [576, 512, [], "e15f", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 287.2C128 207 187 140.6 264 129l0 158.2c0 13.3 10.7 24 24 24s24-10.7 24-24L312 129c77 11.6 136 78 136 158.2c0 88.4-71.6 160-160 160s-160-71.6-160-160zm384 .8a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHorse = {
  prefix: 'fas',
  iconName: 'horse',
  icon: [576, 512, [128014], "f6f0", "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128H224 203.2 148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faQ = {
  prefix: 'fas',
  iconName: 'q',
  icon: [448, 512, [113], "51", "M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"]
};
var faMonitorWaveform = {
  prefix: 'fas',
  iconName: 'monitor-waveform',
  icon: [576, 512, ["monitor-heart-rate"], "f611", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM80 96H496c8.8 0 16 7.2 16 16V400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V272 112c0-8.8 7.2-16 16-16zM96 256h96c6.1 0 11.6 3.4 14.3 8.8L224 300.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L329.9 256H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-6.1 0-11.6-3.4-14.3-8.8L288 243.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L182.1 288H96v96H480V128H96V256z"]
};
var faMonitorHeartRate = faMonitorWaveform;
var faLinkSimple = {
  prefix: 'fas',
  iconName: 'link-simple',
  icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-53 0-96 43-96 96s43 96 96 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c53 0 96-43 96-96s-43-96-96-96H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c88.4 0 160 71.6 160 160zM192 224H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faWhistle = {
  prefix: 'fas',
  iconName: 'whistle',
  icon: [640, 512, [], "f460", "M44.1 188.8C18.5 180.5 0 156.4 0 128C0 92.7 28.7 64 64 64c23.4 0 43.8 12.5 55 31.2C149.2 75.5 185.2 64 224 64c51 0 97.4 19.9 131.8 52.4c1.1 .5 2.2 1.2 3.2 2l62.4 48.3c5.1 4 7.3 10.6 5.6 16.9l-5.7 21.1c-3.2 11.7 1.1 24.2 10.8 31.5c9.6 7.2 22.7 7.9 33 1.7l17.7-10.6c5.7-3.4 12.8-3 18 1.1l128.6 99.6C636.1 333 640 341 640 349.4c0 6.8-2.5 13.4-7.1 18.4l-63.4 69.7c-6.1 6.7-14.7 10.5-23.7 10.5h-2c-5.2 0-10.2-1.2-14.8-3.6L380.7 367c-34.8 49-92 81-156.7 81C118 448 32 362 32 256c0-23.6 4.3-46.3 12.1-67.2zM288 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faG = {
  prefix: 'fas',
  iconName: 'g',
  icon: [448, 512, [103], "47", "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H400c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"]
};
var faWineGlassCrack = {
  prefix: 'fas',
  iconName: 'wine-glass-crack',
  icon: [320, 512, ["fragile"], "f4bb", "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H233.9C222 0 214.3 12.5 219.6 23.2l14.2 28.5c3.5 7.1 1.4 15.7-5.1 20.3l-58.4 40.9c-6 4.2-8.4 12-5.8 18.9l31.1 81c2.1 5.5-1.9 11.4-7.8 11.4c-2.4 0-4.7-1.1-6.3-2.9L92.1 118c-6.4-7.4-4.7-18.7 3.5-24l58.6-37.3c7.6-4.8 9.7-14.9 4.7-22.4L140.7 7.1c-3-4.5-8-7.1-13.3-7.1H64z"]
};
var faFragile = faWineGlassCrack;
var faSlotMachine = {
  prefix: 'fas',
  iconName: 'slot-machine',
  icon: [640, 512, [], "e3ce", "M128 0C92.7 0 64 28.7 64 64H448c0-35.3-28.7-64-64-64H128zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64v32c0 35.3 28.7 64 64 64H416h32 80c53 0 96-43 96-96V211.8c9.8-8.8 16-21.6 16-35.8c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 14.2 6.2 27 16 35.8V416c0 17.7-14.3 32-32 32H448V416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zM56 200c0-13.3 10.7-24 24-24h59.9c23 0 38.5 23.5 29.4 44.6L126.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L115.6 224H80c-13.3 0-24-10.7-24-24zm168-24h59.9c23 0 38.5 23.5 29.4 44.6L270.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L259.6 224H224c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 24c0-13.3 10.7-24 24-24h59.9c23 0 38.5 23.5 29.4 44.6L414.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L403.6 224H368c-13.3 0-24-10.7-24-24z"]
};
var faNotesMedical = {
  prefix: 'fas',
  iconName: 'notes-medical',
  icon: [512, 512, [], "f481", "M96 352V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V293.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16H272zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296z"]
};
var faCarWash = {
  prefix: 'fas',
  iconName: 'car-wash',
  icon: [448, 512, [], "f5e6", "M64 128c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2C69 5.1 59 5.1 53.2 11.8C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48zm160 0c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48zM432 80c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48s48-16 48-48zM153.8 224H294.2c6.8 0 12.8 4.3 15.1 10.6L328.3 288H119.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zM78.5 213.1L50.2 292.4C30.1 300.9 16 320.8 16 344v40 64 32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V448H352v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C358.1 181.3 328 160 294.2 160H153.8c-33.8 0-64 21.3-75.3 53.1zM96 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faEscalator = {
  prefix: 'fas',
  iconName: 'escalator',
  icon: [640, 512, [], "e171", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM405.9 175.8C417.5 165.6 432.5 160 448 160h96c35.3 0 64 28.7 64 64s-28.7 64-64 64H472L234.1 496.2C222.5 506.4 207.5 512 192 512H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h72L405.9 175.8zM320 192v16.4l-128 112V192c0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
var faCommentImage = {
  prefix: 'fas',
  iconName: 'comment-image',
  icon: [512, 512, [], "e148", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm168-16c7.6 0 14.7 3.6 19.2 9.6l96 128c5.5 7.3 6.3 17 2.3 25.1s-12.4 13.3-21.5 13.3H200 120c-9.3 0-17.8-5.4-21.7-13.8s-2.7-18.4 3.3-25.5l40-48c4.6-5.5 11.3-8.6 18.4-8.6s13.9 3.2 18.4 8.6L199 257.3l77.8-103.7c4.5-6 11.6-9.6 19.2-9.6z"]
};
var faTemperatureHalf = {
  prefix: 'fas',
  iconName: 'temperature-half',
  icon: [320, 512, [127777, "temperature-2", "thermometer-2", "thermometer-half"], "f2c9", "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V208c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature2 = faTemperatureHalf;
var faThermometer2 = faTemperatureHalf;
var faThermometerHalf = faTemperatureHalf;
var faDongSign = {
  prefix: 'fas',
  iconName: 'dong-sign',
  icon: [384, 512, [], "e169", "M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V288 128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faDonut = {
  prefix: 'fas',
  iconName: 'donut',
  icon: [512, 512, [127849, "doughnut"], "e406", "M0 208C0 119.6 114.6 48 256 48s256 71.6 256 160v31c-.7 10-4.3 19.5-10.5 27.4c-6.2 8-14.7 14-24.4 17.1l-.3 .1-.3 .1c-13.1 4.9-24.4 13.8-32 25.5c-9.4 13-22 23.3-36.5 30.1c-14.7 6.8-30.8 9.6-46.9 8.3l-.6 0-.6 0c-17.7-.2-35.3 3.3-51.7 10.1l0 0-.1 0c-16.4 7-34.1 10.5-51.9 10.3l0 0-.3 0c-17.8 .2-35.5-3.3-51.9-10.3l-.1 0c-16.4-6.8-34-10.2-51.7-10.1l-.6 0-.6 0c-16.1 1.3-32.3-1.6-46.9-8.4c-14.6-6.8-27.1-17.1-36.5-30.2c-7.7-11.7-18.9-20.6-32-25.5l-.4-.1-.4-.1c-9.7-3.1-18.2-9.1-24.4-17.1C4.3 258.4 .7 248.9 0 238.9V208zm0 92.7c7.4 5.7 15.7 10.1 24.6 13c6.7 2.6 12.4 7.2 16.3 13.2l.2 .3 .2 .3c12.6 17.6 29.6 31.7 49.3 40.8c19.5 9 41 12.9 62.4 11.3c13.2-.1 26.3 2.5 38.5 7.6c20.4 8.6 42.4 13 64.5 12.8c22.1 .2 44.1-4.2 64.5-12.8c12.2-5.1 25.3-7.6 38.5-7.6c21.4 1.7 42.9-2.2 62.3-11.2c19.7-9.1 36.7-23.1 49.3-40.7l.2-.3 .2-.3c3.9-6 9.6-10.6 16.3-13.2c8.9-2.9 17.3-7.4 24.6-13V304c0 88.4-114.6 160-256 160S0 392.4 0 304v-3.3zM320 192c0-17.7-28.7-32-64-32s-64 14.3-64 32s28.7 32 64 32s64-14.3 64-32zM283.3 84.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-112 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm224 9.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zM64 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm331.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-240 16c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm176 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"]
};
var faDoughnut = faDonut;
var faCapsules = {
  prefix: 'fas',
  iconName: 'capsules',
  icon: [576, 512, [], "f46b", "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256H64V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"]
};
var faPooStorm = {
  prefix: 'fas',
  iconName: 'poo-storm',
  icon: [448, 512, ["poo-bolt"], "f75a", "M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 21.7-8.5 37.2-21.9 47.6c-13.8 10.8-34 17-57.8 17H128c-35.3 0-64 28.7-64 64c0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 41 28 75.4 65.8 85.2c-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L285.7 320H304c20.4 0 38.5 12.9 45.3 32.1c3.7 10.6 3.5 21.8 0 31.9H360c48.6 0 88-39.4 88-88c0-43.6-31.7-79.8-73.3-86.8c5.9-9.7 9.3-21.1 9.3-33.2c0-35.3-28.7-64-64-64h-1.4c.9-5.4 1.4-10.9 1.4-16.6c0-48.7-36.1-88.9-83.1-95.2zm45.1 227.4c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H233.9l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"]
};
var faPooBolt = faPooStorm;
var faTally1 = {
  prefix: 'fas',
  iconName: 'tally-1',
  icon: [640, 512, [], "e294", "M128 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"]
};
var faFaceFrownOpen = {
  prefix: 'fas',
  iconName: 'face-frown-open',
  icon: [512, 512, [128550, "frown-open"], "f57a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"]
};
var faFrownOpen = faFaceFrownOpen;
var faSquareDashed = {
  prefix: 'fas',
  iconName: 'square-dashed',
  icon: [448, 512, [], "e269", "M96 32h32V96H96c-17.7 0-32 14.3-32 32v32H0V128C0 75 43 32 96 32zM0 192H64V320H0V192zm384 0h64V320H384V192zm64-32H384V128c0-17.7-14.3-32-32-32H320V32h32c53 0 96 43 96 96v32zm0 192v32c0 53-43 96-96 96H320V416h32c17.7 0 32-14.3 32-32V352h64zM64 352v32c0 17.7 14.3 32 32 32h32v64H96c-53 0-96-43-96-96V352H64zm96 128V416H288v64H160zm0-384V32H288V96H160z"]
};
var faSquareJ = {
  prefix: 'fas',
  iconName: 'square-j',
  icon: [448, 512, [], "e273", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 152V288c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHandPointUp = {
  prefix: 'fas',
  iconName: 'hand-point-up',
  icon: [384, 512, [9757], "f0a6", "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"]
};
var faMoneyBill = {
  prefix: 'fas',
  iconName: 'money-bill',
  icon: [576, 512, [], "f0d6", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faArrowUpBigSmall = {
  prefix: 'fas',
  iconName: 'arrow-up-big-small',
  icon: [576, 512, ["sort-size-up"], "f88e", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM320 368c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V368zM368 32H496c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48z"]
};
var faSortSizeUp = faArrowUpBigSmall;
var faBarcodeRead = {
  prefix: 'fas',
  iconName: 'barcode-read',
  icon: [576, 512, [], "f464", "M56 48c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 25.1 25.1 0 56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56zm96 80h16c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm160 0h16c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm72 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24H408c-13.3 0-24-10.7-24-24V152zM240 128c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM528 56c0-4.4-3.6-8-8-8H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56zM56 464h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56V376c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 4.4 3.6 8 8 8zm472-8V376c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 30.9-25.1 56-56 56H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8z"]
};
var faBaguette = {
  prefix: 'fas',
  iconName: 'baguette',
  icon: [640, 512, [129366], "e3d8", "M583 234.5c58.8-39.2 74.7-118.7 35.5-177.5S499.8-17.7 441 21.5L356.5 77.8l70.8 70.8c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L329.3 96l-88 58.7 74 74c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-78.6-78.6-88 58.7 77.2 77.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L98.9 249.6 57 277.5C-1.8 316.7-17.7 396.2 21.5 455s118.7 74.7 177.5 35.5l384-256z"]
};
var faBowlSoftServe = {
  prefix: 'fas',
  iconName: 'bowl-soft-serve',
  icon: [512, 512, [], "e46b", "M257.2 9.9c2.5-6 8.3-9.9 14.8-9.9h36.6C367.9 0 416 48.1 416 107.4c0 19.9-6.9 38.1-18.3 52.6H416c35.3 0 64 28.7 64 64s-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h8.6c-5.4-9.4-8.6-20.3-8.6-32c0-35.3 28.7-64 64-64h94.1C264 64 272 56 272 46.1c0-4.8-1.9-9.3-5.3-12.7l-6.1-6.1c-4.6-4.6-5.9-11.5-3.5-17.4zM64 320H448c8.8 0 16 7.2 16 16v8c0 57.4-46.6 104-104 104H329.9l20.4 40.8c1.1 2.3 1.7 4.7 1.7 7.2c0 2.9-.8 5.8-2.4 8.4c-2.9 4.7-8.1 7.6-13.6 7.6H176c-5.5 0-10.7-2.9-13.6-7.6c-1.6-2.6-2.4-5.5-2.4-8.4c0-2.4 .6-4.9 1.7-7.2L182.1 448H152C94.6 448 48 401.4 48 344v-8c0-8.8 7.2-16 16-16z"]
};
var faFaceHoldingBackTears = {
  prefix: 'fas',
  iconName: 'face-holding-back-tears',
  icon: [512, 512, [129401], "e482", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM344.5 367.9c-6.7-5.8-16.8-5.1-22.6 1.6C309 384.4 287.1 400 256 400s-53-15.6-65.9-30.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6C183.1 410.3 213.2 432 256 432s72.9-21.7 90.1-41.5c5.8-6.7 5.1-16.8-1.6-22.6zM240 272V240c0-41.5-31.5-75.6-72-79.6c10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9c1 8.1 7.9 14 15.9 14c-10 13.4-16 30-16 48s6 34.6 16 48v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.7c9.8 4.3 20.6 6.7 32 6.7c18 0 34.6-6 48-16c0 8.8 7.2 16 16 16s16-7.2 16-16V288 272zm144 41.3V320c0 8.8 7.2 16 16 16s16-7.2 16-16V288c10-13.4 16-30 16-48s-6-34.6-16-48c8 0 14.9-5.9 15.9-14c1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8c-40.4 4-72 38.1-72 79.6c0 44.2 35.8 80 80 80c11.4 0 22.2-2.4 32-6.7zM128 232c17.7 0 32-14.3 32-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4c17.7 0 32-14.3 32-32z"]
};
var faSquareUp = {
  prefix: 'fas',
  iconName: 'square-up',
  icon: [448, 512, [11014, "arrow-alt-square-up"], "f353", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm39.1 185.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H272v96c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V256H118.3C106 256 96 246 96 233.7c0-6.2 2.6-12.1 7.1-16.3z"]
};
var faArrowAltSquareUp = faSquareUp;
var faTrainSubwayTunnel = {
  prefix: 'fas',
  iconName: 'train-subway-tunnel',
  icon: [512, 512, ["subway-tunnel"], "e2a3", "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h41.4l64.3-64.3C137.3 444.5 112 417.2 112 384V192c0-35.3 28.7-64 64-64H336c35.3 0 64 28.7 64 64V384c0 33.2-25.3 60.5-57.7 63.7L406.6 512H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM361.4 512l-64-64H214.6l-64 64H361.4zM184 192c-13.3 0-24 10.7-24 24v8 64 8c0 13.3 10.7 24 24 24h8 16 8c13.3 0 24-10.7 24-24v-8V224v-8c0-13.3-10.7-24-24-24h-8H192h-8zm88 24v8 64 8c0 13.3 10.7 24 24 24h8 16 8c13.3 0 24-10.7 24-24v-8V224v-8c0-13.3-10.7-24-24-24h-8H304h-8c-13.3 0-24 10.7-24 24zM184 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSubwayTunnel = faTrainSubwayTunnel;
var faSquareExclamation = {
  prefix: 'fas',
  iconName: 'square-exclamation',
  icon: [448, 512, ["exclamation-square"], "f321", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faExclamationSquare = faSquareExclamation;
var faSemicolon = {
  prefix: 'fas',
  iconName: 'semicolon',
  icon: [192, 512, [], "3b", "M96 64a64 64 0 1 1 0 128A64 64 0 1 1 96 64zm54.8 319L83.7 492.8C76.4 504.7 63.5 512 49.5 512C24 512 5 488.5 10.4 463.6L37.5 337c6.1-28.6 31.4-49 60.6-49c34.2 0 61.9 28.1 61.9 62.3c0 11.5-3.2 22.9-9.2 32.7z"]
};
var faBookmark = {
  prefix: 'fas',
  iconName: 'bookmark',
  icon: [384, 512, [128278, 61591], "f02e", "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"]
};
var faFanTable = {
  prefix: 'fas',
  iconName: 'fan-table',
  icon: [448, 512, [], "e004", "M256 413.6C355.7 398.2 432 312 432 208C432 93.1 338.9 0 224 0S16 93.1 16 208c0 104 76.3 190.2 176 205.6V448H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224 352c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V413.6zM184.9 68.5L224.3 166c18.5-25.3 50-39.8 83.3-35.1c48.1 6.8 81.7 51.3 74.9 99.4c-1.2 8.8-9.3 14.8-18.1 13.6L260.2 229.2c12.6 28.7 9.5 63.2-11.2 89.7c-29.9 38.3-85.2 45.1-123.5 15.2c-7-5.4-8.2-15.5-2.8-22.5l64.8-82.9c-31.2-3.4-59.5-23.4-72.1-54.5C97.2 129.1 119 77.9 164.1 59.7c8.2-3.3 17.5 .6 20.8 8.8zM224 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faAlignJustify = {
  prefix: 'fas',
  iconName: 'align-justify',
  icon: [448, 512, [], "f039", "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"]
};
var faBatteryLow = {
  prefix: 'fas',
  iconName: 'battery-low',
  icon: [576, 512, ["battery-1"], "e0b1", "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm80 96H96V320h64V192z"]
};
var faBattery1 = faBatteryLow;
var faCreditCardFront = {
  prefix: 'fas',
  iconName: 'credit-card-front',
  icon: [576, 512, [], "f38a", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM112 288c-8.8 0-16 7.2-16 16s7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM96 368c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zM408 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H408z"]
};
var faBrainArrowCurvedRight = {
  prefix: 'fas',
  iconName: 'brain-arrow-curved-right',
  icon: [640, 512, ["mind-share"], "f677", "M240 56c0-30.9-25.1-56-56-56c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1c30.9 0 56-25.1 56-56V56zm32 0V456c0 30.9 25.1 56 56 56c3.2 0 6.4-.3 9.5-.8C321.3 491 304 459.3 304 416c0-79.5 64.5-144 144-144h32V256c0-4.9 .8-9.8 2.2-14.3c-4.9-3.9-10.2-7.3-16-10C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56zM539.3 244.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v48H448c-61.9 0-112 50.1-112 112c0 54.3 34.6 85.6 45 93.8c1.9 1.5 4.3 2.2 6.7 2.2c6.8 0 12.3-5.5 12.3-12.3V464c0-35.3 28.7-64 64-64h48v48c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"]
};
var faMindShare = faBrainArrowCurvedRight;
var faUmbrellaBeach = {
  prefix: 'fas',
  iconName: 'umbrella-beach',
  icon: [576, 512, [127958], "f5ca", "M346.3 271.8l-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"]
};
var faHelmetUn = {
  prefix: 'fas',
  iconName: 'helmet-un',
  icon: [512, 512, [], "e503", "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384H200h14.9L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.5l-1.5-1.5V288h80 32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM320 417.2l-78-73.7L274.4 288H320V417.2zM285.3 103.1l34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faLocationSmile = {
  prefix: 'fas',
  iconName: 'location-smile',
  icon: [384, 512, ["map-marker-smile"], "f60d", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-95.4 84.9c6.2 9.4 29.1 31.1 63.4 31.1s57.1-21.7 63.4-31.1c6.1-9.2 18.5-11.7 27.7-5.5s11.7 18.5 5.5 27.7C277.1 284.4 243.1 316 192 316s-85.1-31.6-96.6-48.9c-6.1-9.2-3.6-21.6 5.5-27.7s21.6-3.6 27.7 5.5z"]
};
var faMapMarkerSmile = faLocationSmile;
var faArrowLeftToLine = {
  prefix: 'fas',
  iconName: 'arrow-left-to-line',
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", "M0 96C0 78.3 14.3 64 32 64s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96zM137.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L237.3 224 416 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-178.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"]
};
var faArrowToLeft = faArrowLeftToLine;
var faBullseye = {
  prefix: 'fas',
  iconName: 'bullseye',
  icon: [512, 512, [], "f140", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSushi = {
  prefix: 'fas',
  iconName: 'sushi',
  icon: [576, 512, [127843, "nigiri"], "e48a", "M479.7 320l-73.8-24.5L506.3 125.6c24.8 26.7 42.1 60.7 48.5 98.8l12.5 75.2c4 23.8-18.8 43.2-41.7 35.6l-7-2.3L479.7 320h0zM393.5 66.1c32.9 4.8 63.2 18 88.7 37.5L374.8 285.2 323.1 268c-14.6-4.9-30-7-45.2-6.4L393.5 66.1zm-36-2.1L235.6 270.4 96.1 318.7 246.6 64H357.5zM21.3 224.4C36.6 132.2 116.1 64.6 209.5 64L49.4 334.8c-22.4 6.6-44.5-12.5-40.6-36l12.4-74.4zM32 384V369c8.5 .7 17.5-.3 26.4-3.4l193-66.9c20-6.9 41.6-7.1 61.7-.4l205.5 68.2c8.6 2.9 17.2 3.8 25.5 3.1V384c0 35.3-28.7 64-64 64c-19.1 0-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7C132.3 439.6 115.1 448 96 448c-35.3 0-64-28.7-64-64z"]
};
var faNigiri = faSushi;
var faMessageCaptions = {
  prefix: 'fas',
  iconName: 'message-captions',
  icon: [512, 512, ["comment-alt-captions"], "e1de", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zM120 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faCommentAltCaptions = faMessageCaptions;
var faTrashList = {
  prefix: 'fas',
  iconName: 'trash-list',
  icon: [640, 512, [], "e2b1", "M147.8 0H268.2c12.1 0 23.2 6.8 28.6 17.7L304 32h80c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h80l7.2-14.3C124.6 6.8 135.7 0 147.8 0zM32 128H384L362.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm448 0H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-17.7 0-32-14.3-32-32s14.3-32 32-32zM448 416c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-17.7 0-32-14.3-32-32z"]
};
var faBacon = {
  prefix: 'fas',
  iconName: 'bacon',
  icon: [576, 512, [129363], "f7e5", "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"]
};
var faOption = {
  prefix: 'fas',
  iconName: 'option',
  icon: [640, 512, [], "e318", "M448 448c-9.7 0-18.9-4.4-25-12L176.6 128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H192c9.7 0 18.9 4.4 25 12L463.4 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H448zm0-320c-17.7 0-32-14.3-32-32s14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H448z"]
};
var faHandPointDown = {
  prefix: 'fas',
  iconName: 'hand-point-down',
  icon: [384, 512, [], "f0a7", "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32V480zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-64 64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0H162.3C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z"]
};
var faArrowUpFromBracket = {
  prefix: 'fas',
  iconName: 'arrow-up-from-bracket',
  icon: [448, 512, [], "e09a", "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 53 43 96 96 96H352c53 0 96-43 96-96V352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352z"]
};
var faTrashPlus = {
  prefix: 'fas',
  iconName: 'trash-plus',
  icon: [448, 512, [], "e2b2", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zM200 408c0 13.3 10.7 24 24 24s24-10.7 24-24V344h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V232c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faObjectsAlignTop = {
  prefix: 'fas',
  iconName: 'objects-align-top',
  icon: [512, 512, [], "e3c0", "M24 0H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24S10.7 0 24 0zM64 176c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V176zm224 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V176z"]
};
var faFolder = {
  prefix: 'fas',
  iconName: 'folder',
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"]
};
var faFolderBlank = faFolder;
var faFaceAnxiousSweat = {
  prefix: 'fas',
  iconName: 'face-anxious-sweat',
  icon: [576, 512, [], "e36a", "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512zM79.5 404.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5zM208 400c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16zM367.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faCreditCardBlank = {
  prefix: 'fas',
  iconName: 'credit-card-blank',
  icon: [576, 512, [], "f389", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 368c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faFileWaveform = {
  prefix: 'fas',
  iconName: 'file-waveform',
  icon: [448, 512, ["file-medical-alt"], "f478", "M96 0C60.7 0 32 28.7 32 64V288H144c6.1 0 11.6 3.4 14.3 8.8L176 332.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L281.9 288H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V160H288c-17.7 0-32-14.3-32-32V0H96zM288 0V128H416L288 0z"]
};
var faFileMedicalAlt = faFileWaveform;
var faMicrochipAi = {
  prefix: 'fas',
  iconName: 'microchip-ai',
  icon: [512, 512, [], "e1ec", "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zm32 152c6.4 0 12.1 3.8 14.7 9.6l42 96 14 32c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2L239.5 304H176.5l-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l14-32 42-96c2.5-5.8 8.3-9.6 14.7-9.6zm17.5 96L208 231.9 190.5 272h35.1zM336 176c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16z"]
};
var faMug = {
  prefix: 'fas',
  iconName: 'mug',
  icon: [576, 512, [], "f874", "M64 64C46.3 64 32 78.3 32 96V352c0 53 43 96 96 96H320c53 0 96-43 96-96V320h32c70.7 0 128-57.3 128-128s-57.3-128-128-128H384 64zm352 64h32c35.3 0 64 28.7 64 64s-28.7 64-64 64H416V128z"]
};
var faPlaneUpSlash = {
  prefix: 'fas',
  iconName: 'plane-up-slash',
  icon: [640, 512, [], "e22e", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L482.4 352.8 554.9 377c10.4 3.5 21.1-4.3 21.1-15.2V305.1c0-10.7-5.3-20.7-14.2-26.6L384 160l0-66.3C384 59.5 356 0 320 0c-35 0-64 59.5-64 93.7V160l-10.6 7.1L38.8 5.1zm122.5 218L78.2 278.5C69.3 284.4 64 294.4 64 305.1v56.7c0 10.9 10.7 18.6 21.1 15.2L256 320v80l-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L320 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c7.8 0 14-6.3 14-14V455.3c0-2.8-.7-5.6-2.1-8L161.3 223.1z"]
};
var faRadiation = {
  prefix: 'fas',
  iconName: 'radiation',
  icon: [512, 512, [], "f7b9", "M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faPenCircle = {
  prefix: 'fas',
  iconName: 'pen-circle',
  icon: [512, 512, [], "e20e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM357.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM151.9 289L257.1 183.8l71 71L222.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faBagSeedling = {
  prefix: 'fas',
  iconName: 'bag-seedling',
  icon: [512, 512, [], "e5f2", "M64 64L38.6 38.6c-4.2-4.2-6.6-10-6.6-16C32 10.1 42.1 0 54.6 0H457.4C469.9 0 480 10.1 480 22.6c0 6-2.4 11.8-6.6 16L448 64H64zM56 96H456l10.6 42.5c8.9 35.5 13.4 72 13.4 108.7v17.7c0 36.6-4.5 73.1-13.4 108.7L456 416H56L45.4 373.5C36.5 338 32 301.5 32 264.8V247.2c0-36.6 4.5-73.1 13.4-108.7L56 96zm8 352H448l25.4 25.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16L64 448zm80-288c-8.8 0-16 7.2-16 16c0 59.2 45.9 107.6 104 111.7V328c0 13.3 10.7 24 24 24s24-10.7 24-24V287.7c58.1-4.1 104-52.6 104-111.7c0-8.8-7.2-16-16-16h-2c-47.3 0-88.4 26-110 64.5C234.4 186 193.3 160 146 160h-2z"]
};
var faChartSimple = {
  prefix: 'fas',
  iconName: 'chart-simple',
  icon: [448, 512, [], "e473", "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"]
};
var faCrutches = {
  prefix: 'fas',
  iconName: 'crutches',
  icon: [640, 512, [], "f7f8", "M470.6 9.4l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM294.6 188.2L404.1 78.6l45.3 45.3L397.3 176 464 242.7l52.1-52.1 45.3 45.3-74.6 74.6-.1 .1-.1 .1-34.7 34.7c-12.9 12.9-29.2 21.9-47.1 25.8L297.1 395.2c-5.9 1.3-11.4 4.3-15.7 8.6l-98.8 98.8c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l98.8-98.8c4.3-4.3 7.3-9.7 8.6-15.7l23.9-107.6c4-17.8 12.9-34.1 25.8-47.1zm45.3 45.3c-4.3 4.3-7.3 9.7-8.6 15.7l-17 76.7 76.7-17c5.9-1.3 11.4-4.3 15.7-8.6L418.7 288 352 221.3l-12.2 12.2zM169.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L213.3 56l84.1 84.1-25.4 25.4c-6.7 6.7-12.6 14.1-17.6 22L168 101.3 101.3 168 223.7 290.4l-10.1 45.5-17 17c-2.9-2.3-5.7-4.8-8.4-7.5L56 213.3l-1.4 1.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160zM411.7 402.5c9.3-2.1 18.3-5.2 26.9-9.2l64.1 64.1c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-90.2-90.2 44.5-9.9z"]
};
var faCircleParking = {
  prefix: 'fas',
  iconName: 'circle-parking',
  icon: [512, 512, ["parking-circle"], "f615", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm232 0h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H232v64zm48 64H232v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"]
};
var faParkingCircle = faCircleParking;
var faMarsStroke = {
  prefix: 'fas',
  iconName: 'mars-stroke',
  icon: [512, 512, [9894], "f229", "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H376zm88 48h0v0l0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"]
};
var faLeafOak = {
  prefix: 'fas',
  iconName: 'leaf-oak',
  icon: [512, 512, [], "f6f7", "M429.7 268.6l40.9-10.2c24.4-6.1 41.4-28 41.4-53.1c0-18.3-9.1-35.4-24.4-45.5l-14.3-9.5c-5.6-3.8-8.3-10.6-6.6-17.2l5-20.1c5.1-20.4-.9-42-15.8-56.9s-36.5-20.9-56.9-15.8l-20.1 5c-6.6 1.6-13.4-1-17.2-6.6l-9.5-14.3C342.1 9.1 325 0 306.7 0c-25.1 0-47 17.1-53.1 41.4L243.4 82.3c-1.5 6-9 8.1-13.4 3.7L208 64c-17.7-17.7-46.3-17.7-64 0c-10.1 10.1-14.8 24.3-12.8 38.4l10.7 75.1c.8 5.6-5.4 9.5-10.1 6.4C111 170 83.3 172.7 65.6 190.4l-3.6 3.6c-17.9 17.9-22.3 45.2-11 67.8L66.5 293C75.4 310.7 80 330.3 80 350.2v35.2L229.6 235.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l73-73h15.8c19.9 0 39.5 4.6 57.2 13.5l31.1 15.5c22.6 11.3 49.9 6.9 67.8-11l3.6-3.6c17.7-17.7 20.4-45.4 6.6-66.2c-3.1-4.7 .8-10.9 6.4-10.1l75.1 10.7c14.1 2 28.3-2.7 38.4-12.8c17.7-17.7 17.7-46.3 0-64l-22-22c-4.4-4.4-2.3-11.9 3.7-13.4z"]
};
var faSquareBolt = {
  prefix: 'fas',
  iconName: 'square-bolt',
  icon: [448, 512, [], "e265", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm234.1 83.6c5.8 4.7 7.6 12.9 4.3 19.6L249.9 240H320c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L198.1 272H128c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faVial = {
  prefix: 'fas',
  iconName: 'vial',
  icon: [512, 512, [129514], "f492", "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5V416c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96H205.3z"]
};
var faGauge = {
  prefix: 'fas',
  iconName: 'gauge',
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faDashboard = faGauge;
var faGaugeMed = faGauge;
var faTachometerAltAverage = faGauge;
var faWandMagicSparkles = {
  prefix: 'fas',
  iconName: 'wand-magic-sparkles',
  icon: [576, 512, ["magic-wand-sparkles"], "e2ca", "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"]
};
var faMagicWandSparkles = faWandMagicSparkles;
var faLambda = {
  prefix: 'fas',
  iconName: 'lambda',
  icon: [448, 512, [], "f66e", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H140.2l16.4 32.7L18.8 434.9c-7.3 16.1-.1 35.1 16 42.3s35.1 .1 42.3-16L193.5 202.6l121 242c10.8 21.7 33 35.4 57.2 35.4H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H371.8L197.5 67.4C186.6 45.7 164.5 32 140.2 32H32z"]
};
var faE = {
  prefix: 'fas',
  iconName: 'e',
  icon: [320, 512, [101], "45", "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"]
};
var faPizza = {
  prefix: 'fas',
  iconName: 'pizza',
  icon: [576, 512, [127829], "f817", "M385.2 419c10.4-8.2 25.5-8.4 34.9 1s9.4 24.7-.8 33.1C375 489.9 318.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0c62.1 0 119 22.1 163.3 58.8c10.2 8.5 10.1 23.8 .8 33.1s-24.5 9.2-34.9 1C349.7 64.8 304.8 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c48.8 0 93.7-16.8 129.2-45zm-16-49.9c6.2 6.2 6.3 16.5-.5 22.1c-69.1 57.7-172.2 54.1-237.1-10.8c-68.7-68.7-68.7-180.2 0-248.9C196.5 66.6 299.5 63 368.6 120.8c6.8 5.7 6.7 15.9 .5 22.1L267.3 244.7c-6.2 6.2-6.2 16.4 0 22.6L369.1 369.1zM192 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM443.4 156.6c6.7-6.7 17.7-6.2 23 1.7c39.5 59 39.5 136.5 0 195.5c-5.2 7.8-16.3 8.3-23 1.7l-88.1-88.1c-6.2-6.2-6.2-16.4 0-22.6l24.2-24.2c3.6 2.2 7.9 3.5 12.5 3.5c13.3 0 24-10.7 24-24c0-4.6-1.3-8.9-3.5-12.5l30.9-30.9zM472 280a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm22.4 126.4c-8.9-8.9-9.4-23.1-2.3-33.5C514.8 339.6 528 299.3 528 256s-13.2-83.6-35.9-116.9c-7.1-10.4-6.6-24.6 2.3-33.5c9.9-9.9 26.2-9.4 34.3 2C558.5 149.5 576 200.7 576 256s-17.5 106.5-47.4 148.4c-8.1 11.4-24.4 11.9-34.3 2z"]
};
var faBowlChopsticksNoodles = {
  prefix: 'fas',
  iconName: 'bowl-chopsticks-noodles',
  icon: [512, 512, [], "e2ea", "M13.1 93.6L128 72V56c0-13.3 10.7-24 24-24s24 10.7 24 24v7 37.5 38V176v48h32V176 137.5v-42V57 40c0-13.3 10.7-24 24-24s24 10.7 24 24v8V88v48 40 48h32H478.4c18.2 0 32.7 15.3 31.6 33.5c-5.4 91.7-59.7 169.7-136.4 209.7l-1.2 9.7c-2.5 20-19.5 35-39.7 35H179.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C61.6 427.2 7.4 349.3 2 257.5C.9 239.3 15.4 224 33.6 224H128V176H16.2C7.3 176 0 168.7 0 159.7c0-8.8 7-16 15.7-16.2L128 140V108L18.5 125.1C8.8 126.6 0 119.1 0 109.3C0 101.6 5.5 95 13.1 93.6zM488.4 176H288V135l199.6-6.2C501 128.3 512 139 512 152.4c0 13-10.6 23.6-23.6 23.6zm3.9-124.9L288 83V42L484.4 5.2C498.7 2.5 512 13.5 512 28.1c0 11.5-8.4 21.2-19.7 23z"]
};
var faH3 = {
  prefix: 'fas',
  iconName: 'h3',
  icon: [640, 512, [], "f315", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zM400 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H514.7l-89.4 89.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h72c30.9 0 56 25.1 56 56s-25.1 56-56 56H455.4c-11.7 0-21.7-8.5-23.7-20.1l-.2-1.2c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.2 1.2c7.1 42.4 43.8 73.5 86.8 73.5H520c66.3 0 120-53.7 120-120c0-64.6-51-117.2-114.9-119.9l89.5-89.5c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H400z"]
};
var faPenClip = {
  prefix: 'fas',
  iconName: 'pen-clip',
  icon: [512, 512, ["pen-alt"], "f305", "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1 0 0-1-1 0 0-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"]
};
var faPenAlt = faPenClip;
var faBridgeCircleExclamation = {
  prefix: 'fas',
  iconName: 'bridge-circle-exclamation',
  icon: [640, 512, [], "e4ca", "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faBadgePercent = {
  prefix: 'fas',
  iconName: 'badge-percent',
  icon: [512, 512, [], "f646", "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z"]
};
var faUser = {
  prefix: 'fas',
  iconName: 'user',
  icon: [448, 512, [128100, 62144], "f007", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"]
};
var faSensor = {
  prefix: 'fas',
  iconName: 'sensor',
  icon: [448, 512, [], "e028", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 88V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faComma = {
  prefix: 'fas',
  iconName: 'comma',
  icon: [192, 512, [], "2c", "M160 350.4V349c0-33.7-27.3-61-61-61c-29.5 0-54.8 21.1-60.1 50.1l-22.2 122c-.5 2.6-.7 5.2-.7 7.9v8.2C16 495.9 32.1 512 51.9 512c12.5 0 24.1-6.5 30.6-17.2L150.8 383c6-9.8 9.2-21.1 9.2-32.6z"]
};
var faSchoolCircleCheck = {
  prefix: 'fas',
  iconName: 'school-circle-check',
  icon: [640, 512, [], "e56b", "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"]
};
var faToiletPaperUnder = {
  prefix: 'fas',
  iconName: 'toilet-paper-under',
  icon: [512, 512, ["toilet-paper-reverse"], "e2a0", "M96 0H348.2C336.6 12.2 327 26.9 319.5 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9H96C43 384 0 298 0 192S43 0 96 0zM320 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192c0 35-4.7 67.8-12.8 96c-16.6 57.4-47.6 96-83.2 96c-11.2 0-22-3.8-32-10.9c-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64zM160 416H416c44.8 0 76.9-35.2 96-72.9V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V416zM64 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faToiletPaperReverse = faToiletPaperUnder;
var faLightEmergency = {
  prefix: 'fas',
  iconName: 'light-emergency',
  icon: [448, 512, [], "e41f", "M64 192c0-88.4 71.6-160 160-160s160 71.6 160 160V352H64V192zm160-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80zM32 384H416c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"]
};
var faArrowDownToArc = {
  prefix: 'fas',
  iconName: 'arrow-down-to-arc',
  icon: [512, 512, [], "e4ae", "M256 448c106 0 192-86 192-192c0-17.7 14.3-32 32-32s32 14.3 32 32c0 141.4-114.6 256-256 256S0 397.4 0 256c0-17.7 14.3-32 32-32s32 14.3 32 32c0 106 86 192 192 192zM390.6 230.6l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-112-112c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 242.7 224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 57.4-57.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"]
};
var faDumpster = {
  prefix: 'fas',
  iconName: 'dumpster',
  icon: [576, 512, [], "f793", "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l25.6 128zM32 192l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H448c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z"]
};
var faVanShuttle = {
  prefix: 'fas',
  iconName: 'van-shuttle',
  icon: [640, 512, [128656, "shuttle-van"], "f5b6", "M64 104v88h96V96H72c-4.4 0-8 3.6-8 8zm482 88L465.1 96H384v96H546zm-226 0V96H224v96h96zM592 384H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104C0 64.2 32.2 32 72 32H192 352 465.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faShuttleVan = faVanShuttle;
var faBuildingUser = {
  prefix: 'fas',
  iconName: 'building-user',
  icon: [640, 512, [], "e4da", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"]
};
var faLightSwitch = {
  prefix: 'fas',
  iconName: 'light-switch',
  icon: [384, 512, [], "e017", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 96h64c35.3 0 64 28.7 64 64v80H96V160c0-35.3 28.7-64 64-64zM288 272v80c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V272H288zM192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faSquareCaretLeft = {
  prefix: 'fas',
  iconName: 'square-caret-left',
  icon: [448, 512, ["caret-square-left"], "f191", "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"]
};
var faCaretSquareLeft = faSquareCaretLeft;
var faHighlighter = {
  prefix: 'fas',
  iconName: 'highlighter',
  icon: [576, 512, [], "f591", "M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5H224l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"]
};
var faWavePulse = {
  prefix: 'fas',
  iconName: 'wave-pulse',
  icon: [640, 512, ["heart-rate"], "f5f8", "M319.1 0c14.8-.4 27.9 9.3 31.8 23.6l74 271.2 17.7-35.4c10.8-21.7 33-35.4 57.2-35.4H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H499.8L444.6 398.3c-5.9 11.9-18.6 18.8-31.8 17.5s-24.2-10.6-27.7-23.4L323.7 167.3 255.3 486.7c-3.1 14.4-15.5 24.8-30.2 25.3s-27.8-9.1-31.8-23.2L135.9 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H135.9c28.6 0 53.7 18.9 61.5 46.4L219.6 348 288.7 25.3C291.8 10.9 304.4 .4 319.1 0z"]
};
var faHeartRate = faWavePulse;
var faKey = {
  prefix: 'fas',
  iconName: 'key',
  icon: [512, 512, [128273], "f084", "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faHatSanta = {
  prefix: 'fas',
  iconName: 'hat-santa',
  icon: [640, 512, [], "f7a7", "M149.7 137.8L64 352H448L385.1 210.6c-.8-1.7-1.1-3.5-1.1-5.4c0-7.3 5.9-13.2 13.2-13.2h.8c1.4 0 2.7 .2 4 .6l55.3 16.6c2.1-3.2 4.5-6.1 7.2-8.8c0-14.3 5.5-28.7 16.4-39.6c2.2-2.2 4.6-4.2 7.1-6L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8zm434.3 44.4C583 169.8 572.7 160 560 160s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C489.8 217 480 227.3 480 240s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C537 310.2 547.3 320 560 320s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C630.2 263 640 252.7 640 240s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 432c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48s-21.5-48-48-48H48c-26.5 0-48 21.5-48 48z"]
};
var faTamale = {
  prefix: 'fas',
  iconName: 'tamale',
  icon: [320, 512, [129748], "e451", "M48.1 18.3C72.3 8.6 108.4 0 160 0s87.7 8.6 111.9 18.3c12.1 4.8 21 9.9 27.4 14.1c12.7 8.5 23.1 20.4 20.3 36.9L296.4 208l-.4 0H236.2L248 72.7c.4-4.4-2.9-8.3-7.3-8.7s-8.3 2.9-8.7 7.3L220.1 208H168V64c0-4.4-3.6-8-8-8s-8 3.6-8 8V208H99.9L88 71.3c-.4-4.4-4.3-7.7-8.7-7.3s-7.7 4.3-7.3 8.7L83.8 208H24l-.4 0L.4 69.3C-2.3 52.8 8.1 40.8 20.8 32.4c6.3-4.2 15.3-9.3 27.4-14.1zM24 240H296c8.8 0 16 7.2 16 16s-7.2 16-16 16H192l28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272H24c-8.8 0-16-7.2-16-16s7.2-16 16-16zM152 448c0 4.4 3.6 8 8 8s8-3.6 8-8V346.7c13.4 17.9 35.9 26.5 57.4 18.1l6.6 76c.4 4.4 4.3 7.7 8.7 7.3s7.7-4.3 7.3-8.7l-7.3-84.1c14.2-13.2 18.9-33.4 12.6-51.2H296l.4 0 23.1 138.7c1.7 10.2-1.6 20.6-8.9 27.9l0 0c-10.6 10.5-25.1 17.6-38.7 23C247.7 503.4 211.6 512 160 512s-87.7-8.6-111.9-18.3c-13.7-5.5-28.1-12.5-38.7-23l0 0c-7.3-7.3-10.6-17.7-8.9-27.9L23.6 304l.4 0H66.7c-6.3 17.7-1.6 38 12.6 51.2L72 439.3c-.4 4.4 2.9 8.3 7.3 8.7s8.3-2.9 8.7-7.3l6.6-76c21.5 8.4 44-.2 57.4-18.1V448z"]
};
var faBoxCheck = {
  prefix: 'fas',
  iconName: 'box-check',
  icon: [448, 512, [], "f467", "M93.7 32H208V160H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32H354.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240V32zM0 192H448V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm337 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 281z"]
};
var faBullhorn = {
  prefix: 'fas',
  iconName: 'bullhorn',
  icon: [512, 512, [128226, 128363], "f0a1", "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7V240 371.3C357.2 317.8 280.5 288 200.7 288H192V192h8.7c79.8 0 156.5-29.8 215.3-83.3z"]
};
var faSteak = {
  prefix: 'fas',
  iconName: 'steak',
  icon: [576, 512, [129385], "f824", "M268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512c-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5zm36.8 122l0 0c2.5-6 4.8-11.8 7.1-17c6.9-15.7 13.3-27.1 21.5-34.7c7.5-7 17.5-11.7 33.9-11.7c25.4 0 53.3 16.2 75.5 44c22 27.5 36.5 64.1 36.5 100c0 40.8-28.3 84.6-74.7 119.2C359.4 393.4 298.6 416 240 416c-31 0-69.1-3.9-98.8-14.1C110.1 391.2 96 376.7 96 360c0-9 2.6-13.2 6.9-16.9c5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8c28.6-28.6 42.9-63.7 54.3-91.9zm6.8-75.2c-13.3 12.4-21.9 29-29 45.3c-2.9 6.6-5.6 13.2-8.3 19.8c-11.4 27.8-22.8 55.7-46.4 79.3c-41.4 41.4-78.6 57.1-107 69l-1.1 .5-.7 .3 0 0c-13.5 5.7-27.5 11.6-37.7 20.3C70.4 328.8 64 342.1 64 360c0 39.3 33.9 60.8 66.8 72.1C165.1 443.9 207 448 240 448c66.3 0 133.6-25.4 184.4-63.2C474.8 347.4 512 295.2 512 240c0-44.1-17.5-87.5-43.5-120C442.7 87.8 406.6 64 368 64c-23.7 0-41.7 7.3-55.6 20.3zM384 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLocationCrosshairsSlash = {
  prefix: 'fas',
  iconName: 'location-crosshairs-slash',
  icon: [640, 512, ["location-slash"], "f603", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-146-114.5c12.1-20.1 20.6-42.6 24.6-66.6H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H509.3C495.9 143.6 432.4 80.1 352 66.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7c-39.9 6.7-75.6 25.7-103.1 52.9L38.8 5.1zm197 154.4C258.3 139.9 287.8 128 320 128c70.7 0 128 57.3 128 128c0 21.2-5.1 41.1-14.2 58.7l-38.9-30.5c3.3-8.8 5.1-18.3 5.1-28.2c0-44.2-35.8-80-80-80c-16.8 0-32.4 5.2-45.3 14l-38.9-30.5zM414.9 422.9l-56.8-44.7C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128c0-2.9 .1-5.7 .3-8.5l-56.8-44.7c-2 6.9-3.6 14-4.8 21.3H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h34.7c13.5 80.4 76.9 143.9 157.3 157.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c22.6-3.8 43.8-11.5 62.9-22.4z"]
};
var faLocationSlash = faLocationCrosshairsSlash;
var faPersonDolly = {
  prefix: 'fas',
  iconName: 'person-dolly',
  icon: [512, 512, [], "f4d0", "M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM96 241.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3L98.1 399.4 18.7 320C6.7 308 0 291.7 0 274.7V186.6C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64h46.1l-6.5-26.2c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l49.6 198.4c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1L351.4 456.9C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64c0-21.3 10.4-40.1 26.3-51.7L223.3 288H152.6c-16 0-31-8-39.9-21.4L96 241.7zM0 480L0 346.5l64 64V480v0c0 17.7-14.3 32-32 32s-32-14.3-32-32zm288-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm69.4-87.8c-17.1 4.3-34.5-6.1-38.8-23.3l-22.9-91.5c-4.3-17.1 6.1-34.5 23.3-38.8l91.5-22.9c17.1-4.3 34.5 6.1 38.8 23.3l22.9 91.5c4.3 17.1-6.1 34.5-23.3 38.8l-91.5 22.9z"]
};
var faGlobe = {
  prefix: 'fas',
  iconName: 'globe',
  icon: [512, 512, [127760], "f0ac", "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"]
};
var faSynagogue = {
  prefix: 'fas',
  iconName: 'synagogue',
  icon: [640, 512, [128333], "f69b", "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166V280.1 512H464 352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H176 160V280.1 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64H512zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"]
};
var faFileChartColumn = {
  prefix: 'fas',
  iconName: 'file-chart-column',
  icon: [384, 512, ["file-chart-line"], "f659", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 248V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 64V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24s24 10.7 24 24zM128 376v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFileChartLine = faFileChartColumn;
var faPersonHalfDress = {
  prefix: 'fas',
  iconName: 'person-half-dress',
  icon: [320, 512, [], "e548", "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 352V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3V384h0v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"]
};
var faFolderImage = {
  prefix: 'fas',
  iconName: 'folder-image',
  icon: [512, 512, [], "e18a", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM176 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm120 0c-8 0-15.5 4-20 10.7l-56 84L202.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H392c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C311.5 228 304 224 296 224z"]
};
var faCalendarPen = {
  prefix: 'fas',
  iconName: 'calendar-pen',
  icon: [512, 512, ["calendar-edit"], "f333", "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zm308.8 75c-14.7-14.7-38.6-14.7-53.3 0L272.6 282l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 376.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 428c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 304.6l-71.9 71.9z"]
};
var faCalendarEdit = faCalendarPen;
var faRoadBridge = {
  prefix: 'fas',
  iconName: 'road-bridge',
  icon: [640, 512, [], "e563", "M352 0H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V384zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM32 96H288v64H248v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-53-43-96-96-96V224H72V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64H120v64h80V160z"]
};
var faFaceSmileTear = {
  prefix: 'fas',
  iconName: 'face-smile-tear',
  icon: [512, 512, [], "e393", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm141.5 67.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5c8.8 0 16-7.2 16-16s-7.2-16-16-16c-43.4 0-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM352 416c26.5 0 48-21 48-47c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C332.4 308.6 304 349 304 369c0 26 21.5 47 48 47zM208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faMessagePlus = {
  prefix: 'fas',
  iconName: 'message-plus',
  icon: [512, 512, ["comment-alt-plus"], "f4a8", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM232 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faCommentAltPlus = faMessagePlus;
var faLocationArrow = {
  prefix: 'fas',
  iconName: 'location-arrow',
  icon: [448, 512, [], "f124", "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"]
};
var faC = {
  prefix: 'fas',
  iconName: 'c',
  icon: [384, 512, [99], "43", "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"]
};
var faTabletButton = {
  prefix: 'fas',
  iconName: 'tablet-button',
  icon: [448, 512, [], "f10a", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faRectangleHistoryCircleUser = {
  prefix: 'fas',
  iconName: 'rectangle-history-circle-user',
  icon: [640, 512, [], "e4a4", "M320 368c0 59.5 29.5 112.1 74.8 144L64 512c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-97.2 0-176 78.8-176 176zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24H392zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7H463.4c-21 0-38.9 13.7-45.1 32.7C438.5 468.1 465.8 480 496 480s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faBuildingLock = {
  prefix: 'fas',
  iconName: 'building-lock',
  icon: [576, 512, [], "e4d6", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faChartLineUp = {
  prefix: 'fas',
  iconName: 'chart-line-up',
  icon: [512, 512, [], "e0e5", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zM439 279c15.1 15.1 41 4.4 41-17V152c0-13.3-10.7-24-24-24H345.9c-21.4 0-32.1 25.9-17 41l32.4 32.4L304 258.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 253.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0l80-80L439 279z"]
};
var faMailbox = {
  prefix: 'fas',
  iconName: 'mailbox',
  icon: [576, 512, [128234], "f813", "M0 208V384c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144S0 128.5 0 208zm64 0c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm256 0V384c0 24.6-9.2 47-24.4 64H512c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144H245.2C290.4 95.9 320 148.5 320 208zm64 0c0-8.8 7.2-16 16-16h64 32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V224H400c-8.8 0-16-7.2-16-16z"]
};
var faTruckBolt = {
  prefix: 'fas',
  iconName: 'truck-bolt',
  icon: [640, 512, [], "e3d0", "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM270.3 87.2L233.9 160H288c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4L182.1 192H128c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9 .5s7.4 12.8 4.1 19.4z"]
};
var faPizzaSlice = {
  prefix: 'fas',
  iconName: 'pizza-slice',
  icon: [512, 512, [], "f818", "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMoneyBillWave = {
  prefix: 'fas',
  iconName: 'money-bill-wave',
  icon: [576, 512, [], "f53a", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"]
};
var faChartArea = {
  prefix: 'fas',
  iconName: 'chart-area',
  icon: [512, 512, ["area-chart"], "f1fe", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288H448c17.7 0 32-14.3 32-32V251.8c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"]
};
var faAreaChart = faChartArea;
var faHouseFlag = {
  prefix: 'fas',
  iconName: 'house-flag',
  icon: [640, 512, [], "e50d", "M480 0c-17.7 0-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288H64V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.7l.2 0h-1V159z"]
};
var faCircleThreeQuartersStroke = {
  prefix: 'fas',
  iconName: 'circle-three-quarters-stroke',
  icon: [512, 512, [], "e5d4", "M256 64V224c0 17.7 14.3 32 32 32H448c0-106-86-192-192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faPersonCircleMinus = {
  prefix: 'fas',
  iconName: 'person-circle-minus',
  icon: [576, 512, [], "e540", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]
};
var faScalpel = {
  prefix: 'fas',
  iconName: 'scalpel',
  icon: [512, 512, [], "f61d", "M387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17H200c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1zM169.4 320H176h96 16v16c0 74.9-65.5 118.6-126.1 142.9C100.1 503.6 34.1 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l160-160 4.7-4.7z"]
};
var faBan = {
  prefix: 'fas',
  iconName: 'ban',
  icon: [512, 512, [128683, "cancel"], "f05e", "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faCancel = faBan;
var faBellExclamation = {
  prefix: 'fas',
  iconName: 'bell-exclamation',
  icon: [448, 512, [], "f848", "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7zM192 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-184v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faCircleBookmark = {
  prefix: 'fas',
  iconName: 'circle-bookmark',
  icon: [512, 512, ["bookmark-circle"], "e100", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 176c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 6.2-3.5 11.8-9.1 14.4s-12.1 1.9-16.9-1.9l-70-56-70 56c-4.8 3.8-11.4 4.6-16.9 1.9s-9.1-8.3-9.1-14.4V176z"]
};
var faBookmarkCircle = faCircleBookmark;
var faEggFried = {
  prefix: 'fas',
  iconName: 'egg-fried',
  icon: [512, 512, [], "f7fc", "M284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7c27.5 7 52.8 23.2 71 47.8c42.1 56.8 30.2 137-26.6 179.1c-17.8 13.2-37.9 21.1-58.4 24c-37.2 5.2-84.5 32.7-103.3 65.2c-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM336 240a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-160-8c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-39.8 32.2-72 72-72c8.8 0 16 7.2 16 16s-7.2 16-16 16c-22.1 0-40 17.9-40 40z"]
};
var faFaceWeary = {
  prefix: 'fas',
  iconName: 'face-weary',
  icon: [512, 512, [], "e3a1", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm46.6-164c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faUniformMartialArts = {
  prefix: 'fas',
  iconName: 'uniform-martial-arts',
  icon: [640, 512, [], "e3d1", "M180 0h28 9.6c12.3 0 23.5 7 28.8 18.1l61.1 126.7L253 288H144V133.1L98 216.7c-1.3 2.4-2 5-2 7.7V384c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224.4c0-18.9 4.8-37.4 13.9-54L80.3 49.7C95.9 21.2 124.9 2.8 157 .3c1-.2 2-.3 3-.3h4.4H180zM389.1 20.6C393.8 8.2 405.7 0 419 0h13 28 15.6H480c1 0 2 .1 3 .3c32.1 2.5 61 20.9 76.7 49.5l66.4 120.7c9.1 16.5 13.9 35.1 13.9 54V384c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224.4c0-2.7-.7-5.3-2-7.7l-46-83.7V288H287.2l52.7-138.3L389.1 20.6zM320 320H496v32H388.4 349.9l47.4 71.1c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-50.7-76-50.7 76c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2L290.1 352H251.6 144V320H264h56zM216.1 405.4c-14.7 22.1-8.7 51.9 13.3 66.6s51.9 8.7 66.6-13.3L320 422.5l24.1 36.1c14.7 22.1 44.5 28 66.6 13.3s28-44.5 13.3-66.6L409.7 384H496v64c0 35.3-28.7 64-64 64H208c-35.3 0-64-28.7-64-64V384h86.3l-14.2 21.4z"]
};
var faCameraRotate = {
  prefix: 'fas',
  iconName: 'camera-rotate',
  icon: [640, 512, [], "e0d8", "M213.1 64.8L202.7 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM192 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z"]
};
var faSunDust = {
  prefix: 'fas',
  iconName: 'sun-dust',
  icon: [512, 512, [], "f764", "M371.1 13.1L391 121l-44.5 44.5C323.3 142.3 291.3 128 256 128c-70.7 0-128 57.3-128 128c0 35.3 14.3 67.3 37.5 90.5L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6s8.6 6.6 9.6 11.9zM256 160c26.5 0 50.5 10.7 67.9 28.1L188.1 323.9C170.7 306.5 160 282.5 160 256c0-53 43-96 96-96zm192 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM240 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM368 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCommentText = {
  prefix: 'fas',
  iconName: 'comment-text',
  icon: [512, 512, [], "e14d", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM184 160h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V312c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSprayCanSparkles = {
  prefix: 'fas',
  iconName: 'spray-can-sparkles',
  icon: [512, 512, ["air-freshener"], "f5d0", "M96 32v96H224V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"]
};
var faAirFreshener = faSprayCanSparkles;
var faSignalBars = {
  prefix: 'fas',
  iconName: 'signal-bars',
  icon: [640, 512, ["signal-alt", "signal-alt-4", "signal-bars-strong"], "f690", "M560 0c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V48c0-26.5-21.5-48-48-48zM352 176V464c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zM240 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z"]
};
var faSignalAlt = faSignalBars;
var faSignalAlt4 = faSignalBars;
var faSignalBarsStrong = faSignalBars;
var faDiamondExclamation = {
  prefix: 'fas',
  iconName: 'diamond-exclamation',
  icon: [512, 512, [], "e405", "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faStar = {
  prefix: 'fas',
  iconName: 'star',
  icon: [576, 512, [11088, 61446], "f005", "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"]
};
var faDialMin = {
  prefix: 'fas',
  iconName: 'dial-min',
  icon: [576, 512, [], "e161", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM400.9 401c-56.7 56.7-145.4 62-208 15.7L304.7 304.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L158.9 382.8c-46.2-62.6-41-151.3 15.7-208c62.5-62.5 163.8-62.5 226.3 0s62.5 163.8 0 226.3zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faRepeat = {
  prefix: 'fas',
  iconName: 'repeat',
  icon: [512, 512, [128257], "f363", "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z"]
};
var faCross = {
  prefix: 'fas',
  iconName: 'cross',
  icon: [384, 512, [128327, 10013], "f654", "M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H256V48c0-26.5-21.5-48-48-48H176z"]
};
var faPageCaretDown = {
  prefix: 'fas',
  iconName: 'page-caret-down',
  icon: [384, 512, ["file-caret-down"], "e429", "M320 512c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320zM192 352c-4.5 0-8.8-1.9-11.8-5.2l-75.7-82.6c-14.1-15.4-3.2-40.2 17.7-40.2l139.6 0c20.9 0 31.8 24.8 17.7 40.2l-75.7 82.6c-3 3.3-7.3 5.2-11.8 5.2z"]
};
var faFileCaretDown = faPageCaretDown;
var faBox = {
  prefix: 'fas',
  iconName: 'box',
  icon: [448, 512, [128230], "f466", "M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z"]
};
var faVenusMars = {
  prefix: 'fas',
  iconName: 'venus-mars',
  icon: [640, 512, [9892], "f228", "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H208v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"]
};
var faClockSevenThirty = {
  prefix: 'fas',
  iconName: 'clock-seven-thirty',
  icon: [512, 512, [], "e351", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V335.3l-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faArrowPointer = {
  prefix: 'fas',
  iconName: 'arrow-pointer',
  icon: [320, 512, ["mouse-pointer"], "f245", "M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"]
};
var faMousePointer = faArrowPointer;
var faClockFourThirty = {
  prefix: 'fas',
  iconName: 'clock-four-thirty',
  icon: [512, 512, [], "e34b", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V300.8L338.7 340c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faSignalBarsGood = {
  prefix: 'fas',
  iconName: 'signal-bars-good',
  icon: [640, 512, ["signal-alt-3"], "f693", "M400 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 304V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48s-48 21.5-48 48zM32 432v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faSignalAlt3 = faSignalBarsGood;
var faCactus = {
  prefix: 'fas',
  iconName: 'cactus',
  icon: [512, 512, [127797], "f8a7", "M160 96c0-53 43-96 96-96s96 43 96 96V352h48c8.8 0 16-7.2 16-16V272c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 61.9-50.1 112-112 112H352v16c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V320H112C50.1 320 0 269.9 0 208V144c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 8.8 7.2 16 16 16h48V96zm80 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLightbulbGear = {
  prefix: 'fas',
  iconName: 'lightbulb-gear',
  icon: [576, 512, [], "e5fd", "M262.1 352.2c-11 7-19.1 18.6-21.4 31.8H112c-9.6-31.9-29.5-59.1-49.2-86.2l0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0c97 0 175.6 78.4 176 175.3c-17.8 7.7-28 25.6-28 43.3v.9c-17.6-9.7-41.5-8.2-57.2 8.7c-9.2 9.9-17.4 20.9-24.4 33s-12.4 24.7-16.4 37.6c-6.7 21.6 3.4 42.7 20 53.3zM112 416H245.6c3.5 9.2 7.7 18.3 12.8 27c2.9 5 6 9.9 9.4 14.6C257.1 489.2 227.2 512 192 512c-44.2 0-80-35.8-80-80V416zm0-240c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C130.1 64 80 114.1 80 176c0 8.8 7.2 16 16 16s16-7.2 16-16zm260 42.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v17.7c0 7.8 4.8 14.8 11.6 18.7c6.8 3.9 15.1 4.5 21.8 .6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8 .6c-6.8 3.9-11.6 10.9-11.6 18.7l0 17.7c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V467.8c0-7.9-4.9-14.9-11.7-18.9c-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6c6.9-3.9 11.7-11 11.7-18.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
};
var faMaximize = {
  prefix: 'fas',
  iconName: 'maximize',
  icon: [512, 512, ["expand-arrows-alt"], "f31e", "M200 32H56C42.7 32 32 42.7 32 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312V456c0 13.3 10.7 24 24 24H200c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H456c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"]
};
var faExpandArrowsAlt = faMaximize;
var faChargingStation = {
  prefix: 'fas',
  iconName: 'charging-station',
  icon: [576, 512, [], "f5e7", "M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"]
};
var faShapes = {
  prefix: 'fas',
  iconName: 'shapes',
  icon: [512, 512, ["triangle-circle-square"], "f61f", "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2H384c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312V456c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]
};
var faTriangleCircleSquare = faShapes;
var faPlaneTail = {
  prefix: 'fas',
  iconName: 'plane-tail',
  icon: [512, 512, [], "e22c", "M61.5 308.8L.8 39C-3.7 19 11.5 0 32 0h76.9c17.3 0 33.9 7 46 19.5L384 256H488h24v24 24V464v24 24H488 267.7c-10.7 0-21.2-1.9-31.2-5.7L40.4 431.9C16.1 422.7 0 399.4 0 373.4c0-28.2 18.8-52.8 45.9-60.3l15.5-4.3zM216 352c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"]
};
var faGaugeSimpleMax = {
  prefix: 'fas',
  iconName: 'gauge-simple-max',
  icon: [512, 512, ["tachometer-fastest"], "f62b", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-3.7-.3-7.3-.9-10.8l117.5-72.8c11.3-7 14.7-21.8 7.8-33s-21.8-14.8-33-7.8L293.8 300.4C283.2 292.6 270.1 288 256 288c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"]
};
var faTachometerFastest = faGaugeSimpleMax;
var faCircleU = {
  prefix: 'fas',
  iconName: 'circle-u',
  icon: [512, 512, [], "e127", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 168V288c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faShieldSlash = {
  prefix: 'fas',
  iconName: 'shield-slash',
  icon: [640, 512, [], "e24b", "M320 0c4.6 0 9.2 1 13.4 2.9L521.7 82.8c22 9.3 38.4 31 38.3 57.2c-.3 58.7-14.7 146.2-62.1 225L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L131 77.4 306.7 2.9C310.8 1 315.4 0 320 0zM80.6 159.5L437.5 440.7c-25.2 24-55.3 45.4-91.1 62.5c-16.7 8-36.1 8-52.8 0C132 425.8 86.1 261.5 80.6 159.5z"]
};
var faSquarePhoneHangup = {
  prefix: 'fas',
  iconName: 'square-phone-hangup',
  icon: [448, 512, ["phone-square-down"], "e27a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM359.4 310c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4 .2-26.7-8.5L66.8 274.8C62 267 63.4 257.3 70.3 251c84.9-78.6 222.6-78.6 307.5 0c6.8 6.3 8.2 16.1 3.4 23.8L359.4 310z"]
};
var faPhoneSquareDown = faSquarePhoneHangup;
var faArrowUpLeft = {
  prefix: 'fas',
  iconName: 'arrow-up-left',
  icon: [384, 512, [], "e09d", "M64 96c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V205.3L297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 160H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"]
};
var faTransporter1 = {
  prefix: 'fas',
  iconName: 'transporter-1',
  icon: [512, 512, [], "e043", "M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 512c-17.7 0-32-14.3-32-32s14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H296 216 128zM383.7 288c-9.3-.1-18.5-4.2-24.7-12l-31-38.7V288H184V237.3L153 276c-6.3 7.8-15.4 11.9-24.7 12H128v0c-7 0-14.1-2.3-20-7c-13.8-11.1-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36L409 236c11 13.8 8.8 33.9-5 45c-5.9 4.7-13 7-20 7v0h-.3zm-327 38.6L64 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 384 6.6 376.7C2.7 375.6 0 372.1 0 368s2.7-7.6 6.6-8.7L32 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 160zM176 320H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPeanuts = {
  prefix: 'fas',
  iconName: 'peanuts',
  icon: [640, 512, [129372], "e431", "M299.2 38.9l22.6 50.7c-3.6 10.8-6.5 22.2-8.8 31.5l0 0 0 0 0 0c-1.2 4.6-2.2 8.8-3.1 12.1c-4.2 14.8-8.7 24.6-16.3 32.2s-17.4 12.1-32.2 16.3c-3.4 1-7.5 2-12.1 3.1l0 0c-12.5 3.1-28.5 7.1-42 12.7c-21.3 8.8-41.2 21.9-58.4 39.1C114.3 271.1 96 315.4 96 364v68c0 27.8 10.2 53.3 27 72.9l-3.2 1.4c-33.1 14.7-71.8-.2-86.6-33.2L10.5 422.2C3.8 407.2 .4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6C14 314 22.7 300.5 33.4 289.3c5.8-6.1 12.3-11.7 19.5-16.6c16.7-11.8 32.5-25.8 39.8-44.9s5-40.1 .4-60c-2.1-8.4-3.2-17-3.4-25.4c-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9c10.7-11.2 23.6-20.6 38.7-27.3L212.6 5.7c33.1-14.7 71.8 .1 86.6 33.2zM492 0h68c44.2 0 80 35.8 80 80v68c0 40.6-16.4 77.4-42.9 104.2l-.9 .9c-14.1 14-30.3 24.6-47.6 31.7c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2c-.6 .6-1.1 1.1-1.7 1.7C353.1 495.8 316.5 512 276 512H208c-44.2 0-80-35.8-80-80V364c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30C362.4 74 373 57.8 387.1 43.6l.4-.4c14.2-14.1 30.5-24.8 47.8-32C452.8 4 471.9 0 492 0zm52 147.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 0a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-224 224a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM339.2 416a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm0-64a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z"]
};
var faShuffle = {
  prefix: 'fas',
  iconName: 'shuffle',
  icon: [512, 512, [128256, "random"], "f074", "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"]
};
var faRandom = faShuffle;
var faPersonRunning = {
  prefix: 'fas',
  iconName: 'person-running',
  icon: [448, 512, [127939, "running"], "f70c", "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"]
};
var faRunning = faPersonRunning;
var faMobileRetro = {
  prefix: 'fas',
  iconName: 'mobile-retro',
  icon: [320, 512, [], "e527", "M0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
};
var faGripLinesVertical = {
  prefix: 'fas',
  iconName: 'grip-lines-vertical',
  icon: [192, 512, [], "f7a5", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"]
};
var faBinBottlesRecycle = {
  prefix: 'fas',
  iconName: 'bin-bottles-recycle',
  icon: [640, 512, [], "e5f6", "M152 0c-13.3 0-24 10.7-24 24v8c-8.8 0-16 7.2-16 16s7.2 16 16 16H256c8.8 0 16-7.2 16-16s-7.2-16-16-16V24c0-13.3-10.7-24-24-24H152zM32 192H352c0-26.5-10.7-50.5-28.1-67.9c-1.1-1.1-2.1-2.1-3.2-3.1c-17.1-15.5-39.7-25-64.6-25H128c-53 0-96 43-96 96zm352 0H575.1c-1.2-9.7-4.6-18.7-9.6-26.5c6.4-9.5 10.1-21 10.1-33.3c0-23.2-13.4-44.3-34.4-54.2L528 71.8c-5.3-2.5-10.8-4.4-16.4-5.7V24c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24V66.1c-5.6 1.3-11.1 3.2-16.4 5.7L354.1 78c-7.2 3.4-13.5 8-18.6 13.6C365 115.1 384 151.3 384 192zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32L56.2 457c4.5 31.5 31.5 55 63.4 55h401c31.8 0 58.9-23.4 63.4-55L608 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM308.5 326.1l-7.6 11.4c-4.8 7.2-14.5 9.3-21.8 4.7c-7.6-4.8-9.8-14.9-4.8-22.4l7.6-11.4c8.5-12.7 22.8-20.4 38.1-20.4c15.4 0 29.8 7.7 38.2 20.6l8.5 12.9c4.9 7.5 2.7 17.6-4.9 22.4c-7.4 4.6-17.1 2.5-21.8-4.8l-8.5-12.9c-2.6-3.9-6.9-6.2-11.5-6.2c-4.6 0-8.9 2.3-11.5 6.1zm-43.1 64.7l-7.9 11.9c-.9 1.4-1.4 3.1-1.4 4.7c0 4.7 3.8 8.6 8.6 8.6h25.2c8.8 0 16 7.2 16 16s-7.2 16-16 16H264.6c-22.4 0-40.6-18.2-40.6-40.6c0-8 2.4-15.8 6.8-22.5l7.9-11.9c4.8-7.2 14.5-9.3 21.8-4.7c7.6 4.8 9.8 14.9 4.8 22.4zM353.7 416h20.9c4.8 0 8.6-3.9 8.6-8.6c0-1.7-.5-3.3-1.4-4.7l-6.6-10.1c-4.9-7.5-2.7-17.6 4.9-22.4c7.4-4.6 17.1-2.5 21.8 4.8l6.6 10.1c4.4 6.6 6.7 14.4 6.7 22.4c0 22.4-18.2 40.6-40.6 40.6H353.7c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faArrowUpFromSquare = {
  prefix: 'fas',
  iconName: 'arrow-up-from-square',
  icon: [512, 512, [], "e09c", "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM64 112c0-8.8 7.2-16 16-16h8c17.7 0 32-14.3 32-32s-14.3-32-32-32H80C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V112c0-44.2-35.8-80-80-80h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112z"]
};
var faFileDashedLine = {
  prefix: 'fas',
  iconName: 'file-dashed-line',
  icon: [640, 512, ["page-break"], "f877", "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512v96H128V64zm0 304H512v80c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V368zM512 128H384V0L512 128zM56 288H168c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zm224 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24zm192 0H584c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faPageBreak = faFileDashedLine;
var faBracketCurlyRight = {
  prefix: 'fas',
  iconName: 'bracket-curly-right',
  icon: [256, 512, [], "7d", "M192 128c0-53-43-96-96-96H64C46.3 32 32 46.3 32 64s14.3 32 32 32H96c17.7 0 32 14.3 32 32v37.5c0 25.5 10.1 49.9 28.1 67.9L178.7 256l-22.6 22.6c-18 18-28.1 42.4-28.1 67.9V384c0 17.7-14.3 32-32 32H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96c53 0 96-43 96-96V346.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3l-45.3-45.3c-6-6-9.4-14.1-9.4-22.6V128z"]
};
var faSpider = {
  prefix: 'fas',
  iconName: 'spider',
  icon: [512, 512, [128375], "f717", "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1V160c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16V101.2c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"]
};
var faClockThree = {
  prefix: 'fas',
  iconName: 'clock-three',
  icon: [512, 512, [], "e356", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faHandsBound = {
  prefix: 'fas',
  iconName: 'hands-bound',
  icon: [640, 512, [], "e4f9", "M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32V96v59.1 .7V192v21.9c0 14.2 5.1 27.9 14.3 38.7L131.6 352H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32H288h64H480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V192 155.8v-.7V96 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96v48.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1V320v32H288V320 258.1c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8V96 32zm64 448v32H288V480h64v32H480V480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H480 352 288 160 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32z"]
};
var faScalpelLineDashed = {
  prefix: 'fas',
  iconName: 'scalpel-line-dashed',
  icon: [576, 512, ["scalpel-path"], "f61e", "M441.4 0c-20.8 0-40.6 9.2-54 25.1L187.8 261.7c-4 4.8-4.9 11.4-2.3 17.1s8.3 9.3 14.5 9.3H332.6c14.1 0 27.6-6.2 36.7-17L494.4 122.7C505.8 109.2 512 92.2 512 74.6v-4C512 31.6 480.4 0 441.4 0zM164.7 324.7l-160 160c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336V320H272 176h-6.6l-4.7 4.7zM304 480H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H496z"]
};
var faScalpelPath = faScalpelLineDashed;
var faFileInvoiceDollar = {
  prefix: 'fas',
  iconName: 'file-invoice-dollar',
  icon: [384, 512, [], "f571", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"]
};
var faPipeSmoking = {
  prefix: 'fas',
  iconName: 'pipe-smoking',
  icon: [640, 512, [], "e3c4", "M575.2 64c-32.1 0-62.1 16-79.9 42.7l-61.8 92.7c-3.9-4.8-8.6-9.1-14-12.7l-24-16c-4.7-3.2-9.7-5.6-14.9-7.4L442 71.2C471.7 26.7 521.7 0 575.2 0H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H575.2zM333.4 206.2c9.8-14.7 29.7-18.7 44.4-8.9l24 16c14.7 9.8 18.7 29.7 8.9 44.4L287.8 442.1C258.6 485.8 209.6 512 157.1 512C70.3 512 0 441.7 0 354.9V272c0-26.5 21.5-48 48-48H208c26.5 0 48 21.5 48 48v50.3l77.4-116.1z"]
};
var faFaceAstonished = {
  prefix: 'fas',
  iconName: 'face-astonished',
  icon: [512, 512, [], "e36b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V352c0-26.5 21.5-48 48-48zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faWindow = {
  prefix: 'fas',
  iconName: 'window',
  icon: [512, 512, [], "f40e", "M512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96zM96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPlaneCircleExclamation = {
  prefix: 'fas',
  iconName: 'plane-circle-exclamation',
  icon: [640, 512, [], "e556", "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faEar = {
  prefix: 'fas',
  iconName: 'ear',
  icon: [384, 512, [128066], "f5f0", "M319.9 335.2c-18.2 16.3-30 39.1-35.1 62.9c-5.6 26.3-18.6 51.3-39 71.7c-56.2 56.2-147.4 56.2-203.6 0C14.1 441.7 0 404.9 0 368V192C0 86 86 0 192 0S384 86 384 192c0 56.9-24.8 108-64.1 143.2zM128 192c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-61.9-50.1-112-112-112S80 130.1 80 192v20.2c0 21.2 12 40.6 31 50.1l14 7c1.8 .9 3 2.8 3 4.9c0 1.6-.7 3.2-2 4.2L88.6 309.6c-10.2 8.5-11.6 23.6-3.1 33.8s23.6 11.6 33.8 3.1l37.4-31.2C169 305.1 176 290.1 176 274.2c0-20.2-11.4-38.8-29.5-47.8l-14-7c-2.7-1.4-4.4-4.1-4.4-7.2V192z"]
};
var faFileLock = {
  prefix: 'fas',
  iconName: 'file-lock',
  icon: [576, 512, [], "e3a6", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v33.6c-19.8 20.2-32 47.9-32 78.4v24.6c-19.1 11.1-32 31.7-32 55.4V480c0 11.4 3 22.2 8.3 31.5c-2.7 .3-5.5 .5-8.3 .5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm80 112c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faDiagramVenn = {
  prefix: 'fas',
  iconName: 'diagram-venn',
  icon: [640, 512, [], "e15a", "M256 412.8C216.4 372.4 192 317 192 256s24.4-116.4 64-156.8C245.7 97.1 235 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c11 0 21.7-1.1 32-3.2zm64 45.7c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-34.4 0-66.9-7.7-96-21.6zM370.7 192H269.3c-6.5 14.9-10.8 31.1-12.5 48H383.2c-1.7-16.9-6-33.1-12.5-48zM269.3 320H370.7c6.5-14.9 10.8-31.1 12.5-48H256.8c1.7 16.9 6 33.1 12.5 48zM288 352c9.1 12.1 19.9 22.9 32 32c12.1-9.1 22.9-19.9 32-32H288zm64-192c-9.1-12.1-19.9-22.9-32-32c-12.1 9.1-22.9 19.9-32 32h64z"]
};
var faXRay = {
  prefix: 'fas',
  iconName: 'x-ray',
  icon: [512, 512, [], "f497", "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16v32H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16H240v70.6L189.1 307c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6H316.4c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 326.6V256H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V176h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faGoalNet = {
  prefix: 'fas',
  iconName: 'goal-net',
  icon: [640, 512, [], "e3ab", "M64 128c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-53-43-96-96-96H96C43 32 0 75 0 128V448c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm112 0c-8.8 0-16 7.2-16 16v48H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V320h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V224h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H384V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H288V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H192V144c0-8.8-7.2-16-16-16zm80 256H192V320h64v64zm96 0H288V320h64v64zm96 0H384V320h64v64zm0-96H384V224h64v64zm-96 0H288V224h64v64zm-96 0H192V224h64v64z"]
};
var faCoffinCross = {
  prefix: 'fas',
  iconName: 'coffin-cross',
  icon: [384, 512, [], "e051", "M102.4 10.9l-91 104C4.1 123.3 0 134.2 0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1H255.9c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0h-131c-9.2 0-18 4-24.1 10.9zM216 120v40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSpellCheck = {
  prefix: 'fas',
  iconName: 'spell-check',
  icon: [576, 512, [], "f891", "M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160H93.3L112 115.2 130.7 160zM256 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H288c-17.7 0-32 14.3-32 32zm96 64H320V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V160zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"]
};
var faLocationXmark = {
  prefix: 'fas',
  iconName: 'location-xmark',
  icon: [384, 512, ["map-marker-times", "map-marker-xmark"], "f60e", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM111 111c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faMapMarkerTimes = faLocationXmark;
var faMapMarkerXmark = faLocationXmark;
var faCircleQuarterStroke = {
  prefix: 'fas',
  iconName: 'circle-quarter-stroke',
  icon: [512, 512, [], "e5d3", "M64 256l160 0c17.7 0 32-14.3 32-32l0-160c106 0 192 86 192 192s-86 192-192 192S64 362 64 256zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z"]
};
var faLasso = {
  prefix: 'fas',
  iconName: 'lasso',
  icon: [576, 512, [], "f8c8", "M576 176c0 97.2-128.9 176-288 176c-13.2 0-26.3-.5-39-1.6c4.6 12.8 7 26.5 7 40.6c0 66.8-54.2 121-121 121H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h71c31.5 0 57-25.5 57-57c0-21.6-12.2-41.3-31.5-51l-46.8-23.4 .2-.4C44.7 284.1 0 233.2 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 288c123.7 0 224-50.1 224-112s-100.3-112-224-112S64 114.1 64 176s100.3 112 224 112z"]
};
var faSlash = {
  prefix: 'fas',
  iconName: 'slash',
  icon: [640, 512, [], "f715", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]
};
var faPersonToPortal = {
  prefix: 'fas',
  iconName: 'person-to-portal',
  icon: [512, 512, ["portal-enter"], "e022", "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C102.4 108.3 132.2 96 163.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c3.6 8.7 10.9 15.2 19.6 18.1C357.8 96.9 391.4 0 432 0c44.2 0 80 114.6 80 256s-35.8 256-80 256c-40.9 0-74.6-98-79.4-224.5c-34.6-3.6-64.9-25.9-78.5-58.5l-5.1-12.3L238 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L286.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zM109.5 310.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H91.2l18.3-41.3z"]
};
var faPortalEnter = faPersonToPortal;
var faCalendarStar = {
  prefix: 'fas',
  iconName: 'calendar-star',
  icon: [512, 512, [], "f736", "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zm233.3 58.9c-3.8-7.7-14.8-7.7-18.7 0l-23.6 47.8-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L256 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8z"]
};
var faComputerMouse = {
  prefix: 'fas',
  iconName: 'computer-mouse',
  icon: [384, 512, [128433, "mouse"], "f8cc", "M0 192H176V0H160C71.6 0 0 71.6 0 160v32zm0 32V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192 0zm384-32V160C384 71.6 312.4 0 224 0H208V192H384z"]
};
var faMouse = faComputerMouse;
var faArrowRightToBracket = {
  prefix: 'fas',
  iconName: 'arrow-right-to-bracket',
  icon: [512, 512, ["sign-in"], "f090", "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
};
var faSignIn = faArrowRightToBracket;
var faPegasus = {
  prefix: 'fas',
  iconName: 'pegasus',
  icon: [576, 512, [], "f703", "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C378.4 0 321.7 55.6 320 124.8L184.9 34.7c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1c0 48.1 3.8 99.9 26 139.8c9.2 16.6 21.7 31.3 38.2 42.7c-7.2-2.5-14-5.4-20.3-8.8c-22.5-12.1-38.6-29.4-49.9-49.8c-7.3-13.2-12.7-27.8-16.5-43c-25.9 3.5-48.1 18.6-61.1 40C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faFilesMedical = {
  prefix: 'fas',
  iconName: 'files-medical',
  icon: [448, 512, [], "f7fd", "M160 0H320V96c0 17.7 14.3 32 32 32h96V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM416 64l32 32H402.7 384 352V64 45.3 0l32 32 32 32zM24 96c13.3 0 24 10.7 24 24V376c0 48.6 39.4 88 88 88H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24zm216 80v48H192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V288h48c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H304V176c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16z"]
};
var faNfcLock = {
  prefix: 'fas',
  iconName: 'nfc-lock',
  icon: [576, 512, [], "e1f8", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v65.1c-24.9 3.6-47.2 15.3-64 32.5V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16V272v24.6c-19.1 11.1-32 31.7-32 55.4v32H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H320v64H64c-35.3 0-64-28.7-64-64V96zM464 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faPersonSkiLift = {
  prefix: 'fas',
  iconName: 'person-ski-lift',
  icon: [512, 512, ["ski-lift"], "f7c8", "M240 0c8.8 0 16 7.2 16 16V198.3l-32 8.5V16c0-8.8 7.2-16 16-16zM64 80a48 48 0 1 1 96 0A48 48 0 1 1 64 80zm36.4 138c-14.2-30.8 8.3-66 42.2-66c18.2 0 34.8 10.7 42.3 27.3l28.8 63.4 55.9-14.9c25.4-6.8 50.3 12.4 50.3 38.6V388.5L443.1 343c12.6-4.6 20.9-16.6 20.9-30v-1c0-13.3 10.7-24 24-24s24 10.7 24 24v1c0 33.5-20.9 63.4-52.3 75L128.3 510.5c-12.4 4.6-26.2-1.8-30.8-14.2s1.8-26.2 14.2-30.8L256 412.2V297.7l-66.7 17.8c-22.6 6-46.2-5.1-56-26.3L100.4 218zM45.7 189.6l65 135.8c8.3 17.4 28 26.4 46.6 21.3l36.5-9.9c12.8-3.5 26 4.1 29.5 16.8s-4.1 26-16.8 29.5l-36.5 9.9c-41 11.2-84.2-8.6-102.5-46.9L2.3 210.4c-5.7-12-.7-26.3 11.3-32s26.3-.7 32 11.3z"]
};
var faSkiLift = faPersonSkiLift;
var faSquare6 = {
  prefix: 'fas',
  iconName: 'square-6',
  icon: [448, 512, [], "e25b", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C142.2 224.8 128 255.6 128 288z"]
};
var faShopSlash = {
  prefix: 'fas',
  iconName: 'shop-slash',
  icon: [640, 512, ["store-alt-slash"], "e070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224H512V376L384 275.7V224H320v1.5L277.2 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.5l-64-50.4V384z"]
};
var faStoreAltSlash = faShopSlash;
var faWindTurbine = {
  prefix: 'fas',
  iconName: 'wind-turbine',
  icon: [512, 512, [], "f89b", "M315.7 414.8c9.1 14.8 32 6.5 29.5-10.7L316.8 212c-.5-3.4 .1-6.9 1.8-9.9L411 31.2c8.3-15.3-10.4-31-24-20.1L234.7 131.7c-2.7 2.1-6 3.4-9.5 3.5L31.1 140.6C13.7 141 9.5 165 25.7 171.4l180.6 71.5c3.2 1.3 5.9 3.5 7.7 6.5L315.7 414.8zM224 326.8V464H152c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H288V430.8l-64-104zM256 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSlidersSimple = {
  prefix: 'fas',
  iconName: 'sliders-simple',
  icon: [512, 512, [], "e253", "M96 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm90.5 0L480 320c17.7 0 32 14.3 32 32s-14.3 32-32 32l-293.5 0c-13.2 37.3-48.7 64-90.5 64c-53 0-96-43-96-96s43-96 96-96c41.8 0 77.4 26.7 90.5 64zM384 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-58.5-32c13.2-37.3 48.7-64 90.5-64c53 0 96 43 96 96s-43 96-96 96c-41.8 0-77.4-26.7-90.5-64L32 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l293.5 0z"]
};
var faGridRound = {
  prefix: 'fas',
  iconName: 'grid-round',
  icon: [448, 512, [], "e5da", "M128 96A64 64 0 1 1 0 96a64 64 0 1 1 128 0zm0 160A64 64 0 1 1 0 256a64 64 0 1 1 128 0zM64 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM288 96A64 64 0 1 1 160 96a64 64 0 1 1 128 0zM224 320a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96-256a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM384 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"]
};
var faBadgeSheriff = {
  prefix: 'fas',
  iconName: 'badge-sheriff',
  icon: [448, 512, [], "f8a2", "M272 48c0 14.8-6.7 28-17.2 36.8l25 42.8c5.7 9.8 16.2 15.8 27.5 15.9l47.6 .2c6.7-18.5 24.4-31.7 45.2-31.7c26.5 0 48 21.5 48 48s-21.5 48-48 48c-5.9 0-11.6-1.1-16.9-3.1L363 240.1c-5.6 9.8-5.6 21.9 0 31.8l20.1 35.2c5.3-2 10.9-3.1 16.9-3.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.8 0-38.5-13.2-45.2-31.7l-47.6 .2c-11.3 0-21.8 6.1-27.5 15.9l-25 42.8c10.5 8.8 17.2 22 17.2 36.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-14.8 6.7-28 17.2-36.8l-25-42.8c-5.7-9.8-16.2-15.8-27.5-15.9l-47.6-.2C86.5 386.8 68.8 400 48 400c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.6 1.1 16.9 3.1L85 271.9c5.6-9.8 5.6-21.9 0-31.8L64.9 204.9c-5.3 2-10.9 3.1-16.9 3.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.8 0 38.5 13.2 45.2 31.7l47.6-.2c11.3 0 21.8-6.1 27.5-15.9l25-42.8C182.7 76 176 62.8 176 48c0-26.5 21.5-48 48-48s48 21.5 48 48zM224 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faServer = {
  prefix: 'fas',
  iconName: 'server',
  icon: [512, 512, [], "f233", "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faVirusCovidSlash = {
  prefix: 'fas',
  iconName: 'virus-covid-slash',
  icon: [640, 512, [], "e4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zM149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2L149.2 213.5z"]
};
var faIntersection = {
  prefix: 'fas',
  iconName: 'intersection',
  icon: [384, 512, [8898], "f668", "M32 480c17.7 0 32-14.3 32-32V224c0-70.7 57.3-128 128-128s128 57.3 128 128V448c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-106-86-192-192-192S0 118 0 224V448c0 17.7 14.3 32 32 32z"]
};
var faShopLock = {
  prefix: 'fas',
  iconName: 'shop-lock',
  icon: [640, 512, [], "e4a5", "M36.8 192H449.6c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224H320V384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 352 224zm144 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faFamily = {
  prefix: 'fas',
  iconName: 'family',
  icon: [512, 512, [], "e300", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 160h44.8c9.2 0 18.1 1.6 26.4 4.5c-.5 3.8-.8 7.6-.8 11.5c0 24.3 10.9 46.1 28 60.8c-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1 .8 11.9 2.4 17.5c-8.7 9-20.9 14.5-34.4 14.5H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160zM368 512c-13.5 0-25.7-5.6-34.4-14.5c1.6-5.6 2.4-11.4 2.4-17.5V423.6c19.6-17.6 32-43.1 32-71.6V336c0-43.1-24.3-80.5-60-99.2c17.1-14.7 28-36.5 28-60.8c0-2.4-.1-4.7-.3-7.1c9.6-5.7 20.8-8.9 32.6-8.9h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48H368zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V407.4c-19.1-11.1-32-31.7-32-55.4V336c0-44.2 35.8-80 80-80z"]
};
var faHourglassStart = {
  prefix: 'fas',
  iconName: 'hourglass-start',
  icon: [384, 512, ["hourglass-1"], "f251", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM288 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"]
};
var faHourglass1 = faHourglassStart;
var faUserHairBuns = {
  prefix: 'fas',
  iconName: 'user-hair-buns',
  icon: [448, 512, [], "e3d3", "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H160c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32h14.4c1 5.2 1.6 10.5 1.6 16zM84 192c7 0 13.7-1.6 19.6-4.6c17.8 49.3 65 84.6 120.4 84.6s102.7-35.3 120.4-84.6c5.9 2.9 12.5 4.6 19.6 4.6c24.3 0 44-19.7 44-44V108c0-24.3-19.7-44-44-44c-9.3 0-17.9 2.9-25 7.8C318.2 29.3 274.5 0 224 0s-94.2 29.3-115 71.8C101.9 66.9 93.3 64 84 64c-24.3 0-44 19.7-44 44v40c0 24.3 19.7 44 44 44zm77.3 128C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320H161.3z"]
};
var faBlenderPhone = {
  prefix: 'fas',
  iconName: 'blender-phone',
  icon: [576, 512, [], "f6b6", "M224 352L196.8 52.3C194.2 24.2 216.3 0 244.6 0H534.1c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H549.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H523.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352H224zm-16 32H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"]
};
var faHourglassClock = {
  prefix: 'fas',
  iconName: 'hourglass-clock',
  icon: [576, 512, [], "e41b", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h10.8C285.6 480.1 256 427.5 256 368c0-27.2 6.2-53 17.2-76l-36-36 67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faPersonSeatReclined = {
  prefix: 'fas',
  iconName: 'person-seat-reclined',
  icon: [512, 512, [], "e21f", "M176 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm89 160l-8-32h63c17.7 0 32-14.3 32-32s-14.3-32-32-32H240.8c-6.6-19-24.5-32-44.9-32c-30.9 0-53.6 29.1-46.1 59l21.1 84.5C178 332 203.6 352 233 352h6.3c.5 0 .9 0 1.4 0h78.1c6.7 0 12.6 4.1 15 10.4L370 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H265zM95.5 154.1c-3.3-17.4-20-28.8-37.3-25.6s-28.8 20-25.6 37.3L65.9 343.6C77.2 404.1 130.1 448 191.7 448H272c17.7 0 32-14.3 32-32s-14.3-32-32-32H191.7c-30.8 0-57.2-21.9-62.9-52.2L95.5 154.1z"]
};
var faPaperPlaneTop = {
  prefix: 'fas',
  iconName: 'paper-plane-top',
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M49.9 27.8C15.1 12.7-19.2 50.1-1.2 83.5L68.1 212.2c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L-1.2 428.5c-18 33.4 16.3 70.8 51.1 55.7L491.8 292.7c32.1-13.9 32.1-59.5 0-73.4L49.9 27.8z"]
};
var faPaperPlaneAlt = faPaperPlaneTop;
var faSend = faPaperPlaneTop;
var faMessageArrowUp = {
  prefix: 'fas',
  iconName: 'message-arrow-up',
  icon: [512, 512, ["comment-alt-arrow-up"], "e1dc", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM280 296V177.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V296c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faCommentAltArrowUp = faMessageArrowUp;
var faLightbulbExclamation = {
  prefix: 'fas',
  iconName: 'lightbulb-exclamation',
  icon: [384, 512, [], "f671", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zm0-448c13.3 0 24 10.7 24 24V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM160 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faLayerMinus = {
  prefix: 'fas',
  iconName: 'layer-minus',
  icon: [576, 512, ["layer-group-minus"], "f5fe", "M408 56c-13.3 0-24 10.7-24 24s10.7 24 24 24H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H408zm-96.5 77.2c-14.9-6.9-32.1-6.9-47 0L45.9 234.2C37.4 238.1 32 246.6 32 256s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-218.6-101zm13.4 274.7c-23.4 10.8-50.4 10.8-73.8 0l-152-70.2L45.9 362.2C37.4 366.1 32 374.6 32 384s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2z"]
};
var faLayerGroupMinus = faLayerMinus;
var faChartPieSimpleCircleCurrency = {
  prefix: 'fas',
  iconName: 'chart-pie-simple-circle-currency',
  icon: [640, 512, [], "e604", "M496 192c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6V240H375.2c31.5-29.8 74-48 120.8-48zM320 368c0-28.8 6.9-56 19.2-80H224V66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM521.4 393.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L460.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426z"]
};
var faCircleE = {
  prefix: 'fas',
  iconName: 'circle-e',
  icon: [512, 512, [], "e109", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v56H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V256 152c0-13.3 10.7-24 24-24z"]
};
var faBuildingWheat = {
  prefix: 'fas',
  iconName: 'building-wheat',
  icon: [640, 512, [], "e4db", "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm384 80v16c0 44.2-35.8 80-80 80H544V272c0-44.2 35.8-80 80-80h16zm0 128c0 44.2-35.8 80-80 80H544V384c0-44.2 35.8-80 80-80h16v16zm0 112c0 44.2-35.8 80-80 80H544V496c0-44.2 35.8-80 80-80h16v16zM512 496v16H496c-44.2 0-80-35.8-80-80V416h16c44.2 0 80 35.8 80 80zm0-96H496c-44.2 0-80-35.8-80-80V304h16c44.2 0 80 35.8 80 80v16zm0-128v16H496c-44.2 0-80-35.8-80-80V192h16c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24V160c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24z"]
};
var faGaugeMax = {
  prefix: 'fas',
  iconName: 'gauge-max',
  icon: [512, 512, ["tachometer-alt-fastest"], "f626", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-3.7-.3-7.3-.9-10.8l117.5-72.8c11.3-7 14.7-21.8 7.8-33s-21.8-14.8-33-7.8L293.8 300.4C283.2 292.6 270.1 288 256 288c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAltFastest = faGaugeMax;
var faPersonBreastfeeding = {
  prefix: 'fas',
  iconName: 'person-breastfeeding',
  icon: [448, 512, [], "e53a", "M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"]
};
var faApostrophe = {
  prefix: 'fas',
  iconName: 'apostrophe',
  icon: [192, 512, [], "27", "M72 352c66.3 0 120-53.7 120-120V160 128 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h64v8c0 30.9-25.1 56-56 56H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h8z"]
};
var faFireHydrant = {
  prefix: 'fas',
  iconName: 'fire-hydrant',
  icon: [384, 512, [], "e17f", "M224 32v4c45 11.6 80.4 47 92 92h12c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H68c11.6-45 47-80.4 92-92V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM32 488c0-13.3 10.7-24 24-24h8V400H48c-17.7 0-32-14.3-32-32V304c0-17.7 14.3-32 32-32H64V208H320v64h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320v64h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H64 56c-13.3 0-24-10.7-24-24zm160-88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faRightToBracket = {
  prefix: 'fas',
  iconName: 'right-to-bracket',
  icon: [512, 512, ["sign-in-alt"], "f2f6", "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faSignInAlt = faRightToBracket;
var faVideoPlus = {
  prefix: 'fas',
  iconName: 'video-plus',
  icon: [576, 512, [], "f4e1", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L416 174.9V192 320v17.1l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128zM216 184v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSquareRight = {
  prefix: 'fas',
  iconName: 'square-right',
  icon: [448, 512, [10145, "arrow-alt-square-right"], "f352", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM262.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L262.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C234 384 224 374 224 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z"]
};
var faArrowAltSquareRight = faSquareRight;
var faCommentSmile = {
  prefix: 'fas',
  iconName: 'comment-smile',
  icon: [512, 512, [], "f4b4", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM192 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM150.5 270.1c9.9-8.8 25-8 33.9 1.9c17.6 19.7 43.1 32 71.6 32s53.9-12.3 71.6-32c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9C337 333.4 298.6 352 256 352s-81-18.6-107.3-48c-8.8-9.9-8-25 1.9-33.9z"]
};
var faVenus = {
  prefix: 'fas',
  iconName: 'venus',
  icon: [384, 512, [9792], "f221", "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"]
};
var faPassport = {
  prefix: 'fas',
  iconName: 'passport',
  icon: [448, 512, [], "f5ab", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8H279.6zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8H129.3c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faInboxIn = {
  prefix: 'fas',
  iconName: 'inbox-in',
  icon: [512, 512, [128229, "inbox-arrow-down"], "f310", "M288 32V210.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM48 320h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48z"]
};
var faInboxArrowDown = faInboxIn;
var faHeartPulse = {
  prefix: 'fas',
  iconName: 'heart-pulse',
  icon: [512, 512, ["heartbeat"], "f21e", "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 16.9-2.8 33.5-8.3 49.1z"]
};
var faHeartbeat = faHeartPulse;
var faCircle8 = {
  prefix: 'fas',
  iconName: 'circle-8',
  icon: [512, 512, [], "e0f5", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 128H248c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0H248s0 0 0 0zm16 48h8c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-17.7 0-32-14.3-32-32s14.3-32 32-32h8 16z"]
};
var faCloudsMoon = {
  prefix: 'fas',
  iconName: 'clouds-moon',
  icon: [640, 512, [], "f745", "M352 160c0 11.5 1.2 22.7 3.5 33.4c53.7 8.2 96.5 49.8 106.4 103c14.2 5.5 27.2 13.4 38.5 23.2c3.7 .3 7.4 .4 11.2 .4c43.2 0 82.5-17.3 111.2-45.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7c-64.3 0-116.5-52.3-116.5-116.9c0-43.7 23.9-81.8 59.3-101.9c6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1 .6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160zM114.8 273.9c20.1-30.1 54.3-49.9 93.2-49.9c12.9 0 25.3 2.2 36.8 6.2c19.6-19.9 45.8-33.5 75-37.2l0-.9c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72c16.1 0 30.9-5.3 42.9-14.1zM64 431.9c0 44.2 35.8 80 80 80H415.9c53 0 96-43 96-96c0-47.6-34.6-87-80-94.6l0-1.3c0-53-43-96-96-96c-34.9 0-65.4 18.6-82.2 46.4C240.8 261.3 225 256 208 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 431.9z"]
};
var faClockTenThirty = {
  prefix: 'fas',
  iconName: 'clock-ten-thirty',
  icon: [512, 512, [], "e355", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V256c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3L232 268.8V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faPeopleCarryBox = {
  prefix: 'fas',
  iconName: 'people-carry-box',
  icon: [640, 512, ["people-carry"], "f4ce", "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7V186.6c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51V241.7l-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8H256.7c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm77.9 348.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"]
};
var faPeopleCarry = faPeopleCarryBox;
var faFolderUser = {
  prefix: 'fas',
  iconName: 'folder-user',
  icon: [512, 512, [], "e18e", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM144 405.3c0 5.9 4.8 10.7 10.7 10.7H357.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H197.3c-29.5 0-53.3 23.9-53.3 53.3z"]
};
var faTrashCanXmark = {
  prefix: 'fas',
  iconName: 'trash-can-xmark',
  icon: [448, 512, [], "e2ae", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM143 239c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faTemperatureHigh = {
  prefix: 'fas',
  iconName: 'temperature-high',
  icon: [512, 512, [], "f769", "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
var faMicrochip = {
  prefix: 'fas',
  iconName: 'microchip',
  icon: [512, 512, [], "f2db", "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160 128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160V352H352V160z"]
};
var faLeftLongToLine = {
  prefix: 'fas',
  iconName: 'left-long-to-line',
  icon: [640, 512, [], "e41e", "M0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32S0 78.3 0 96zM279.5 409.4c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22V320l288 0c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32l-288 0V120c0-9.6-5.7-18.2-14.5-22s-19-2-26 4.6l-144 136c-4.8 4.5-7.5 10.8-7.5 17.4s2.7 12.9 7.5 17.4l144 136z"]
};
var faCrown = {
  prefix: 'fas',
  iconName: 'crown',
  icon: [576, 512, [128081], "f521", "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"]
};
var faWeightHanging = {
  prefix: 'fas',
  iconName: 'weight-hanging',
  icon: [512, 512, [], "f5cd", "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H346.5z"]
};
var faXmarksLines = {
  prefix: 'fas',
  iconName: 'xmarks-lines',
  icon: [640, 512, [], "e59a", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faFilePrescription = {
  prefix: 'fas',
  iconName: 'file-prescription',
  icon: [384, 512, [], "f572", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"]
};
var faCalendarRange = {
  prefix: 'fas',
  iconName: 'calendar-range',
  icon: [512, 512, [], "e0d6", "M128 32V64H80c-26.5 0-48 21.5-48 48v48H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM160 288a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM384 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 288c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm40 104c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24H264z"]
};
var faFlowerDaffodil = {
  prefix: 'fas',
  iconName: 'flower-daffodil',
  icon: [512, 512, [9880], "f800", "M288 281.3c9.8 4.3 20.6 6.7 32 6.7c44.2 0 80-35.8 80-80c0-26.2-12.6-49.4-32-64c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80c-26.2 0-49.4 12.6-64 32C241.4 12.6 218.2 0 192 0c-44.2 0-80 35.8-80 80c0 26.2 12.6 49.4 32 64c-19.4 14.6-32 37.8-32 64c0 44.2 35.8 80 80 80c11.4 0 22.2-2.4 32-6.7V394.8C192.1 349.5 139.5 320 80 320H29.5C13.2 320 0 333.2 0 349.5C0 439.3 72.7 512 162.5 512H224h32 32 61.5C439.3 512 512 439.3 512 349.5c0-16.3-13.2-29.5-29.5-29.5H432c-59.5 0-112.1 29.5-144 74.8V281.3zM208 144a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faHandBackPointUp = {
  prefix: 'fas',
  iconName: 'hand-back-point-up',
  icon: [448, 512, [], "e1a2", "M136 0C113.9 0 96 17.9 96 40V240v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L39 284.8C24.4 297 16 315 16 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H288c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C334 227.5 313.3 208 288 208c-12.4 0-23.6 4.7-32.1 12.3C254 195.5 233.3 176 208 176c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"]
};
var faWeightScale = {
  prefix: 'fas',
  iconName: 'weight-scale',
  icon: [512, 512, ["weight"], "f496", "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"]
};
var faWeight = faWeightScale;
var faStarExclamation = {
  prefix: 'fas',
  iconName: 'star-exclamation',
  icon: [576, 512, [], "f2f3", "M288.1 0c12.2 0 23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18zM288 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faBooks = {
  prefix: 'fas',
  iconName: 'books',
  icon: [512, 512, [128218], "f5db", "M0 32C0 14.3 14.3 0 32 0H96c17.7 0 32 14.3 32 32V96H0V32zm0 96H128V384H0V128zM0 416H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416zM160 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96H160V32zm0 96H288V384H160V128zm0 288H288v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416zm203.6-19.9L320 232.6V142.8l100.4-26.9 66 247.4L363.6 396.1zM412.2 85L320 109.6V11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L412.2 85zM371.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L371.8 427z"]
};
var faUserGroup = {
  prefix: 'fas',
  iconName: 'user-group',
  icon: [640, 512, [128101, "user-friends"], "f500", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"]
};
var faUserFriends = faUserGroup;
var faArrowUpAZ = {
  prefix: 'fas',
  iconName: 'arrow-up-a-z',
  icon: [576, 512, ["sort-alpha-up"], "f15e", "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176H395.8z"]
};
var faSortAlphaUp = faArrowUpAZ;
var faLayerPlus = {
  prefix: 'fas',
  iconName: 'layer-plus',
  icon: [576, 512, ["layer-group-plus"], "f5ff", "M464 0c-13.3 0-24 10.7-24 24V56H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v32c0 13.3 10.7 24 24 24s24-10.7 24-24V104h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H488V24c0-13.3-10.7-24-24-24zM311.5 133.2c-14.9-6.9-32.1-6.9-47 0L45.9 234.2C37.4 238.1 32 246.6 32 256s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-218.6-101zm13.4 274.7c-23.4 10.8-50.4 10.8-73.8 0l-152-70.2L45.9 362.2C37.4 366.1 32 374.6 32 384s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2z"]
};
var faLayerGroupPlus = faLayerPlus;
var faPlayPause = {
  prefix: 'fas',
  iconName: 'play-pause',
  icon: [640, 512, [], "e22f", "M116.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160zM448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96z"]
};
var faBlockQuestion = {
  prefix: 'fas',
  iconName: 'block-question',
  icon: [640, 512, [], "e3dd", "M160 32c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm73.8 149.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L344 280.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V266.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H286.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM288 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM144 104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM472 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM144 408a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSnooze = {
  prefix: 'fas',
  iconName: 'snooze',
  icon: [448, 512, [128164, "zzz"], "f880", "M192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32l-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5s16.5 17.7 28.6 17.7h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l57.6-76.8c7.3-9.7 8.4-22.7 3-33.5S300.1 0 288 0H192zM320 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32l-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5s16.5 17.7 28.6 17.7h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H384l57.6-76.8c7.3-9.7 8.4-22.7 3-33.5S428.1 224 416 224H320zM32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32h91.7L7.4 459.5c-7.9 9.5-9.7 22.8-4.4 34.1S19.6 512 32 512H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H100.3L216.6 308.5c7.9-9.5 9.7-22.8 4.4-34.1s-16.6-18.4-29-18.4H32z"]
};
var faZzz = faSnooze;
var faScannerImage = {
  prefix: 'fas',
  iconName: 'scanner-image',
  icon: [576, 512, [], "f8f3", "M79.1 35.8c-15.6-8.3-35-2.4-43.3 13.2s-2.4 35 13.2 43.3L416 288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V339.2c0-23.6-13-45.3-33.9-56.5L79.1 35.8zM64 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faTvRetro = {
  prefix: 'fas',
  iconName: 'tv-retro',
  icon: [512, 512, [128250], "f401", "M169 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55H80C35.8 96 0 131.8 0 176V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H321.9l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87L169 7zM424 232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 224c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V224z"]
};
var faSquareT = {
  prefix: 'fas',
  iconName: 'square-t',
  icon: [448, 512, [], "e280", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 112H224 328c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faFarm = {
  prefix: 'fas',
  iconName: 'farm',
  icon: [576, 512, ["barn-silo"], "f864", "M0 96C0 43 43 0 96 0s96 43 96 96H0zm181.4 32L132.8 246c-3.2 7.7-4.8 16-4.8 24.4V480c0 11.7 3.1 22.6 8.6 32H48c-26.5 0-48-21.5-48-48V128H181.4zM160 480V270.3c0-4.2 .8-8.3 2.4-12.2l48.9-118.7c3-7.4 8.7-13.3 15.9-16.7L354.3 62.5c8.7-4.1 18.7-4.1 27.4 0l127.1 60.2c7.2 3.4 12.9 9.4 15.9 16.7l48.9 118.7c1.6 3.9 2.4 8 2.4 12.2V480c0 17.7-14.3 32-32 32H432V448c0-26.5-21.5-48-48-48H352c-26.5 0-48 21.5-48 48v64H192c-17.7 0-32-14.3-32-32zM320 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24z"]
};
var faBarnSilo = faFarm;
var faChessKnight = {
  prefix: 'fas',
  iconName: 'chess-knight',
  icon: [448, 512, [9822], "f441", "M96 48L82.7 61.3C70.7 73.3 64 89.5 64 106.5V238.9c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0c10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400H384l28.9-159c2.1-11.3 3.1-22.8 3.1-34.3V192C416 86 330 0 224 0H83.8C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H409.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432H64L22.6 473.4z"]
};
var faBarsSort = {
  prefix: 'fas',
  iconName: 'bars-sort',
  icon: [448, 512, [], "e0ae", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM192 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H160c17.7 0 32 14.3 32 32z"]
};
var faPalletBoxes = {
  prefix: 'fas',
  iconName: 'pallet-boxes',
  icon: [640, 512, [57863, "palette-boxes", "pallet-alt"], "f483", "M64 32C64 14.3 78.3 0 96 0H288c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V32zM384 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V96zM0 352c0-17.7 14.3-32 32-32H96 320 544h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H544 320 96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V384H32c-17.7 0-32-14.3-32-32zm128 96H288V384H128v64zm224 0H512V384H352v64z"]
};
var faPaletteBoxes = faPalletBoxes;
var faPalletAlt = faPalletBoxes;
var faFaceLaughSquint = {
  prefix: 'fas',
  iconName: 'face-laugh-squint',
  icon: [512, 512, ["laugh-squint"], "f59b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faLaughSquint = faFaceLaughSquint;
var faCodeSimple = {
  prefix: 'fas',
  iconName: 'code-simple',
  icon: [576, 512, [], "e13d", "M214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 214.6 118.6zm146.7 0L498.7 256 361.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3z"]
};
var faBoltSlash = {
  prefix: 'fas',
  iconName: 'bolt-slash',
  icon: [640, 512, [], "e0b8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-182.4-143 52.7-46.1c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H368.5L445.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8L228.4 153.7 38.8 5.1zM138.9 231.9c-10 8.8-13.6 22.9-8.9 35.3s16.6 20.7 30 20.7h83.7l-88.9-70-15.9 13.9zm55.7 235.5c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8L374.4 391 264.5 304.4l-69.9 163z"]
};
var faPanelFire = {
  prefix: 'fas',
  iconName: 'panel-fire',
  icon: [640, 512, [], "e42f", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v32.2c-12.6-1.2-25.5 2.7-35.5 11.7c-9.9 8.9-19.4 18.1-28.5 27.5V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H337.5c-4.4 6.2-8.5 12.5-12.3 18.7c-10.9 17.6-20.5 36.4-27.2 55.4c-3-1.4-6.4-2.1-9.9-2.1c-13.3 0-24 10.7-24 24s10.7 24 24 24l.2 0c-.1 2-.2 4.1-.2 6.1c0 49.3 18.6 95.2 49.6 129.9H64c-35.3 0-64-28.7-64-64V96zM120 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM453.5 163.6c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79c0 87.8-71.3 159.8-160 159.8c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM530 432.9c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"]
};
var faBinaryCircleCheck = {
  prefix: 'fas',
  iconName: 'binary-circle-check',
  icon: [640, 512, [], "e33c", "M322.7 6c8.3 6 13.3 15.7 13.3 26V160h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H304 256c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V76.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16C303.6-1.6 314.4 0 322.7 6zM98.7 294c8.3 6 13.3 15.7 13.3 26V448h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM64 0h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zm0 64v96h64V64H64zM192 352c0-35.3 28.7-64 64-64h64c6.2 0 12.2 .9 17.9 2.5c-11.2 22.9-17.6 48.6-17.9 75.7V352H256v96h64v0h19.2c7.8 15.3 17.8 29.3 29.5 41.5C357 503.3 339.5 512 320 512H256c-35.3 0-64-28.7-64-64V352zm128.7 32H320V369.8c0 4.8 .3 9.5 .7 14.2zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faCommentMinus = {
  prefix: 'fas',
  iconName: 'comment-minus',
  icon: [512, 512, [], "f4b1", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM184 216H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faBurrito = {
  prefix: 'fas',
  iconName: 'burrito',
  icon: [512, 512, [127791], "f7ed", "M251.4 52.6L33.9 270.1c-9.9 9.9-17.8 21.3-23.4 33.7C39.2 324.1 74.2 336 112 336c79.2 0 146.2-52.3 168.3-124.3c5-16.3 7.7-33.7 7.7-51.7c0-40.4-13.6-77.7-36.6-107.4zm15-32C299.7 57.5 320 106.4 320 160c0 11.9-1 23.6-2.9 34.9c11.4-1.9 23-2.9 34.9-2.9c53.6 0 102.5 20.3 139.4 53.6c12.8-14.2 20.6-33 20.6-53.6c0-11.4-2.4-22.2-6.7-32c4.3-9.8 6.7-20.6 6.7-32c0-34.6-22-64.1-52.8-75.2C448.1 22 418.6 0 384 0c-11.4 0-22.2 2.4-32 6.7C342.2 2.4 331.4 0 320 0c-20.6 0-39.4 7.8-53.6 20.6zm193 240C429.7 237.6 392.4 224 352 224c-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-40.8 0-78.8-11.7-110.9-32C.4 341.3 0 346.6 0 352c0 30.7 12.2 60.2 33.9 81.9l44.1 44.1C99.8 499.8 129.3 512 160 512s60.2-12.2 81.9-33.9L459.4 260.6z"]
};
var faViolin = {
  prefix: 'fas',
  iconName: 'violin',
  icon: [640, 512, [127931], "f8ed", "M630.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L417 177.7C398 166.5 375.7 160 352 160c-20.8 0-40.4 5-57.8 13.8c-6.7 3.4-9.1 11.4-7.7 18.8c1 5 1.5 10.2 1.5 15.4c0 44.2-35.8 80-80 80c-11.6 0-22.7-2.5-32.7-7c-7.4-3.3-16.6-2.4-21.3 4.3C137.6 308.7 128 337.2 128 368c0 15 2.3 29.5 6.6 43.1l44.6-33.5c19.1-14.3 45.9-12.4 62.7 4.5l16 16c16.9 16.9 18.8 43.6 4.5 62.7l-33.5 44.6c13.6 4.3 28.1 6.6 43.1 6.6c30.8 0 59.3-9.6 82.6-26.1c6.7-4.7 7.6-13.8 4.3-21.3c-4.5-10-7-21-7-32.7c0-44.2 35.8-80 80-80c5.3 0 10.5 .5 15.4 1.5c7.4 1.4 15.4-1 18.8-7.7c8.8-17.4 13.8-37 13.8-57.8c0-23.7-6.5-46-17.7-65L630.6 54.6zM520 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM345 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 41zM472 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm48-48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM198.4 403.2l-64 48c-3.7 2.8-6 7-6.4 11.7s1.4 9.2 4.6 12.4l32 32c3.3 3.3 7.8 5 12.4 4.6s8.9-2.6 11.7-6.4l48-64c4.8-6.4 4.1-15.3-1.5-20.9l-16-16c-5.6-5.6-14.5-6.3-20.9-1.5z"]
};
var faObjectsColumn = {
  prefix: 'fas',
  iconName: 'objects-column',
  icon: [448, 512, [], "e3c1", "M48 32C21.5 32 0 53.5 0 80V240c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM304 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H304zM0 400v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48zM304 32c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304z"]
};
var faSquareChevronDown = {
  prefix: 'fas',
  iconName: 'square-chevron-down',
  icon: [448, 512, ["chevron-square-down"], "f329", "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM207 345L103 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 345c-9.4 9.4-24.6 9.4-33.9 0z"]
};
var faChevronSquareDown = faSquareChevronDown;
var faCommentPlus = {
  prefix: 'fas',
  iconName: 'comment-plus',
  icon: [512, 512, [], "f4b2", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM232 328V264H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V152c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faTriangleInstrument = {
  prefix: 'fas',
  iconName: 'triangle-instrument',
  icon: [576, 512, ["triangle-music"], "f8e2", "M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V69.9c-18 6.8-33.6 19.4-44.1 36.1L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94H450c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L448.2 239l-46.4 46.4 73.6 116.5c3 4.8 4.6 10.4 4.6 16c0 16.6-13.5 30-30 30H126c-16.6 0-30-13.5-30-30c0-5.7 1.6-11.2 4.6-16L266 140.1c4.8-7.6 13.1-12.1 22-12.1s17.3 4.6 22 12.1l48 75.9-51.2 51.2c-5.9-2.1-12.2-3.2-18.8-3.2c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l43.5-43.5 46.4-46.4L537 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-98.6 98.6L364.1 106C353.6 89.2 338 76.7 320 69.9V32z"]
};
var faTriangleMusic = faTriangleInstrument;
var faWheelchair = {
  prefix: 'fas',
  iconName: 'wheelchair',
  icon: [512, 512, [], "f193", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM120.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464C98.1 464 48 413.9 48 352c0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H282.2l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H259.8z"]
};
var faUserPilotTie = {
  prefix: 'fas',
  iconName: 'user-pilot-tie',
  icon: [448, 512, [], "e2c1", "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM161.7 72.8c4-7.9 13.6-11.1 21.5-7.2L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5zm-63.6 96C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zm89.5 206.3L208 416l-12.2 48.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512H192v0h64v0H422.4c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.2 464.9 240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2H201.9c-11.9 0-19.6 12.5-14.3 23.2zM320 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16z"]
};
var faPianoKeyboard = {
  prefix: 'fas',
  iconName: 'piano-keyboard',
  icon: [576, 512, [127929], "f8d5", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM512 224V384H432V315.7c9.6-5.5 16-15.9 16-27.7V224h64zM400 384H304V315.7c9.6-5.5 16-15.9 16-27.7V224h64v64c0 11.8 6.4 22.2 16 27.7V384zm-128 0H176V315.7c9.6-5.5 16-15.9 16-27.7V224h64v64c0 11.8 6.4 22.2 16 27.7V384zm-128 0H64V224h64v64c0 11.8 6.4 22.2 16 27.7V384z"]
};
var faBedEmpty = {
  prefix: 'fas',
  iconName: 'bed-empty',
  icon: [640, 512, [128719], "f8f9", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V256v96 96c0 17.7 14.3 32 32 32s32-14.3 32-32V416H352 576v32c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-53-43-96-96-96H64V64z"]
};
var faCircleArrowUp = {
  prefix: 'fas',
  iconName: 'circle-arrow-up',
  icon: [512, 512, ["arrow-circle-up"], "f0aa", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119c9.4-9.4 24.6-9.4 33.9 0L385 231z"]
};
var faArrowCircleUp = faCircleArrowUp;
var faToggleOn = {
  prefix: 'fas',
  iconName: 'toggle-on',
  icon: [576, 512, [], "f205", "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faRectangleVertical = {
  prefix: 'fas',
  iconName: 'rectangle-vertical',
  icon: [384, 512, ["rectangle-portrait"], "f2fb", "M320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0z"]
};
var faRectanglePortrait = faRectangleVertical;
var faPersonWalking = {
  prefix: 'fas',
  iconName: 'person-walking',
  icon: [320, 512, [128694, "walking"], "f554", "M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"]
};
var faWalking = faPersonWalking;
var faL = {
  prefix: 'fas',
  iconName: 'l',
  icon: [320, 512, [108], "4c", "M64 32c17.7 0 32 14.3 32 32V416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"]
};
var faSignalStream = {
  prefix: 'fas',
  iconName: 'signal-stream',
  icon: [576, 512, [], "f8dd", "M108.2 71c13.8 11.1 16 31.2 5 45C82.4 154.4 64 203 64 256s18.4 101.6 49.1 140c11.1 13.8 8.8 33.9-5 45s-33.9 8.8-45-5C23.7 386.7 0 324.1 0 256S23.7 125.3 63.2 76c11.1-13.8 31.2-16 45-5zm359.7 0c13.8-11.1 33.9-8.8 45 5C552.3 125.3 576 187.9 576 256s-23.7 130.7-63.2 180c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45c30.7-38.4 49.1-87 49.1-140s-18.4-101.6-49.1-140c-11.1-13.8-8.8-33.9 5-45zM232 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-27.5-74.7c-17.8 19.8-28.5 46-28.5 74.7s10.8 54.8 28.5 74.7c11.8 13.2 10.7 33.4-2.5 45.2s-33.4 10.7-45.2-2.5C129 342.2 112 301.1 112 256s17-86.2 44.8-117.3c11.8-13.2 32-14.3 45.2-2.5s14.3 32 2.5 45.2zm214.7-42.7C447 169.8 464 210.9 464 256s-17 86.2-44.8 117.3c-11.8 13.2-32 14.3-45.2 2.5s-14.3-32-2.5-45.2c17.8-19.8 28.5-46 28.5-74.7s-10.8-54.8-28.5-74.7c-11.8-13.2-10.7-33.4 2.5-45.2s33.4-10.7 45.2 2.5z"]
};
var faDownToBracket = {
  prefix: 'fas',
  iconName: 'down-to-bracket',
  icon: [448, 512, [], "e4e7", "M374.1 217.9L251.3 340.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L73.9 217.9c-6.4-6.4-9.9-15-9.9-24C64 175.2 79.2 160 97.9 160l62.1 0 0-128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l0 128 62.1 0c18.7 0 33.9 15.2 33.9 33.9c0 9-3.6 17.6-9.9 24zM64 352v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96V352c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faCircleZ = {
  prefix: 'fas',
  iconName: 'circle-z',
  icon: [512, 512, [], "e130", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c8.9 0 17.1 5 21.3 12.9s3.6 17.5-1.5 24.8L229.8 336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.9 0-17.1-5-21.3-12.9s-3.6-17.5 1.5-24.8L282.2 176H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faStars = {
  prefix: 'fas',
  iconName: 'stars',
  icon: [512, 512, [], "f762", "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zm-112.4 5.1c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94zm215.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z"]
};
var faFire = {
  prefix: 'fas',
  iconName: 'fire',
  icon: [448, 512, [128293], "f06d", "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"]
};
var faBedPulse = {
  prefix: 'fas',
  iconName: 'bed-pulse',
  icon: [640, 512, ["procedures"], "f487", "M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160H544c53 0 96 43 96 96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V352H288V192c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faProcedures = faBedPulse;
var faHouseDay = {
  prefix: 'fas',
  iconName: 'house-day',
  icon: [640, 512, [], "e00e", "M174.2 8.3C171.4 3.2 166-.1 160.1-.1s-11.3 3.2-14.1 8.4L118.4 59.5 62.8 42.9c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.7 55.7L8.3 146.1c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51.2 27.6L42.8 257.6c-1.7 5.6-.1 11.7 4 15.9s10.3 5.7 15.9 4l55.7-16.7L133.1 288l57.4-53c-9.4 3.9-19.7 6-30.5 6c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 13.1-3.1 25.4-8.7 36.3L296 137.5l-35.3-19 16.7-55.7c1.7-5.6 .1-11.7-4-15.9s-10.3-5.7-15.9-4L201.8 59.5 174.2 8.3zM112 160a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm309.7-55.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S178.8 352 192 352h32V464c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48V352h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM352 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V304z"]
};
var faShuttleSpace = {
  prefix: 'fas',
  iconName: 'shuttle-space',
  icon: [640, 512, ["space-shuttle"], "f197", "M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96h2zM352 128L245.2 63.9C210.4 43 170.6 32 130 32h-2v96l224 0zM96 128l0-96H80C53.5 32 32 53.5 32 80v48h8c-22.1 0-40 17.9-40 40v16V328v16c0 22.1 17.9 40 40 40H32v48c0 26.5 21.5 48 48 48H96l0-96h8c26.2 0 49.4-12.6 64-32H456c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6v24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4V212.4c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"]
};
var faSpaceShuttle = faShuttleSpace;
var faShirtLongSleeve = {
  prefix: 'fas',
  iconName: 'shirt-long-sleeve',
  icon: [640, 512, [], "e3c7", "M157 .3c-32.1 2.5-61 20.9-76.7 49.5L13.9 170.5C4.8 187 0 205.6 0 224.4V384c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V224.4c0-2.7 .7-5.3 2-7.7l46-83.7V448c0 35.3 28.7 64 64 64H432c35.3 0 64-28.7 64-64V133.1l46 83.7c1.3 2.4 2 5 2 7.7V384c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224.4c0-18.9-4.8-37.4-13.9-54L559.7 49.7C544.1 21.2 515.1 2.8 483 .3c-1-.2-2-.3-3-.3h-4.4H460 432c-8.8 0-15.9 7.2-17.3 15.9C407.1 61.4 367.6 96 320 96s-87.1-34.6-94.7-80.1C223.9 7.2 216.8 0 208 0H180 164.4 160c-1 0-2 .1-3 .3z"]
};
var faChartPieSimple = {
  prefix: 'fas',
  iconName: 'chart-pie-simple',
  icon: [512, 512, ["chart-pie-alt"], "f64e", "M495.4 240H272V16.6c0-9 7-16.6 16-16.6C411.7 0 512 100.3 512 224c0 9-7.6 16-16.6 16zM190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V288H445.3c18.5 0 33.3 15.7 29.5 33.8C451.9 430.5 355.5 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.5 60.1 190.2 37.2z"]
};
var faChartPieAlt = faChartPieSimple;
var faFaceLaugh = {
  prefix: 'fas',
  iconName: 'face-laugh',
  icon: [512, 512, ["laugh"], "f599", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faLaugh = faFaceLaugh;
var faFolderOpen = {
  prefix: 'fas',
  iconName: 'folder-open',
  icon: [576, 512, [128194, 128449, 61717], "f07c", "M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"]
};
var faAlbumCollectionCircleUser = {
  prefix: 'fas',
  iconName: 'album-collection-circle-user',
  icon: [640, 512, [], "e48f", "M32 24c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C42.7 0 32 10.7 32 24zM48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214l32 256c3 24 23.4 42 47.6 42H394.8c-18.9-13.3-35.1-30.3-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9C154.4 480 72 419.1 72 344s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2c31.5-29.9 74.2-48.2 121-48.2c4.5 0 9 .2 13.4 .5c-2-5.9-5.2-11.5-9.4-16.3c-9.1-10.3-22.2-16.2-36-16.2H48zM256 376c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H472c13.3 0 24-10.7 24-24s-10.7-24-24-24H40zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-66.3 80.7C553.5 468.1 526.2 480 496 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7zM448 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faCandy = {
  prefix: 'fas',
  iconName: 'candy',
  icon: [640, 512, [127852], "e3e7", "M318.1 64c-24.5 .2-47.9 5.1-69.4 13.7L419.9 420c20.3-12.4 38.2-28.5 52.6-47.3L318.1 64zM492.3 340.8c4.7-9.6 8.7-19.6 11.8-30l93.2 46.6c10.5 5.3 23.3 2.1 30.2-7.4s5.8-22.7-2.5-31l-29.6-29.6 29.1-10.9C633.8 275 640 266 640 256s-6.2-19-15.6-22.5l-29.1-10.9L625 193c8.3-8.3 9.4-21.5 2.5-31s-19.7-12.7-30.2-7.4L504 201.1C483.7 132.9 426.5 80.6 355.5 67.3L492.3 340.8zm-101 93.5L220.1 92c-20.3 12.4-38.2 28.5-52.6 47.3L321.9 448c24.5-.2 47.9-5.1 69.4-13.7zM284.5 444.7L147.7 171.2c-4.7 9.6-8.7 19.6-11.8 30L42.7 154.5c-10.5-5.3-23.3-2.1-30.2 7.4s-5.8 22.7 2.5 31l29.6 29.6L15.6 233.5C6.2 237 0 246 0 256s6.2 19 15.6 22.5l29.1 10.9L15 319c-8.3 8.3-9.4 21.5-2.5 31s19.7 12.7 30.2 7.4L136 310.9c20.3 68.2 77.5 120.6 148.5 133.9z"]
};
var faBowlHot = {
  prefix: 'fas',
  iconName: 'bowl-hot',
  icon: [512, 512, ["soup"], "f823", "M152 0c-13.3 0-24 10.7-24 24v8c0 32.7 15.4 63.6 41.6 83.2C183.7 125.8 192 142.4 192 160v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-32.7-15.4-63.6-41.6-83.2C184.3 66.2 176 49.6 176 32V24c0-13.3-10.7-24-24-24zM33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35H332.7c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5H33.6zM304 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 32.7 15.4 63.6 41.6 83.2C311.7 125.8 320 142.4 320 160v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-32.7-15.4-63.6-41.6-83.2C312.3 66.2 304 49.6 304 32V24z"]
};
var faSoup = faBowlHot;
var faFlatbread = {
  prefix: 'fas',
  iconName: 'flatbread',
  icon: [512, 512, [129747], "e40b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 171.3l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-112-70.6c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zm160 182.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faHeartCirclePlus = {
  prefix: 'fas',
  iconName: 'heart-circle-plus',
  icon: [576, 512, [], "e500", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCodeFork = {
  prefix: 'fas',
  iconName: 'code-fork',
  icon: [448, 512, [], "e13b", "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCity = {
  prefix: 'fas',
  iconName: 'city',
  icon: [640, 512, [127961], "f64f", "M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"]
};
var faSignalBarsWeak = {
  prefix: 'fas',
  iconName: 'signal-bars-weak',
  icon: [640, 512, ["signal-alt-1"], "f691", "M32 432c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z"]
};
var faSignalAlt1 = faSignalBarsWeak;
var faMicrophoneLines = {
  prefix: 'fas',
  iconName: 'microphone-lines',
  icon: [384, 512, [127897, "microphone-alt"], "f3c9", "M96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zM320 240v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"]
};
var faMicrophoneAlt = faMicrophoneLines;
var faClockTwelve = {
  prefix: 'fas',
  iconName: 'clock-twelve',
  icon: [512, 512, [], "e358", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V256c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faPepperHot = {
  prefix: 'fas',
  iconName: 'pepper-hot',
  icon: [512, 512, [127798], "f816", "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24V152c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"]
};
var faCitrusSlice = {
  prefix: 'fas',
  iconName: 'citrus-slice',
  icon: [512, 512, [], "e2f5", "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391zm116.3 32.9c9.6 2.7 18.8-4.9 18.8-14.9V264.5c0-6.2-4.3-11.5-10-14c-5.9-2.6-13-2.1-17.6 2.5L59.3 342.2c-6.2 6.2-6.2 16.4 0 22.6l4 4c27.1 27.1 59.6 45.5 94 55.2zM250.5 166c2.5 5.7 7.8 10 14 10H409c10 0 17.6-9.1 14.9-18.8C414.2 123 396 90.6 369.1 63.6l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L253 148.4c-4.6 4.6-5.2 11.7-2.5 17.6zm.6 50.5c-2 4.9-1.4 10.6 2.4 14.3l114 114c6.6 6.6 17.4 6.2 22.9-1.3c26.2-35.8 40.1-77.8 41.5-120.1c.3-8.6-6.8-15.4-15.4-15.4H263c-5.3 0-9.8 3.7-11.8 8.5zm-34.6 34.6c-4.9 2-8.5 6.5-8.5 11.8V416.4c0 8.6 6.8 15.7 15.4 15.4c42.4-1.4 84.4-15.3 120.1-41.5c7.5-5.5 7.9-16.3 1.3-22.9l-114-114c-3.7-3.7-9.4-4.4-14.3-2.4z"]
};
var faSheep = {
  prefix: 'fas',
  iconName: 'sheep',
  icon: [640, 512, [128017], "f711", "M384 135.8V208c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V135.8l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5L561.6 77.4C544.7 50.2 514.5 32 480 32s-64.7 18.2-81.6 45.4L350.5 97.9c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2zm80-7.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM352 175.4c-18.7-2.7-35.5-14.8-43.5-33.4c-6.9-16.1-5.7-33.5 1.8-47.9C299 76 278.9 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32V426.3c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c35.3 0 64-28.7 64-64c0-2.7-.2-5.4-.5-8H464c-61.9 0-112-50.1-112-112V175.4z"]
};
var faUnlock = {
  prefix: 'fas',
  iconName: 'unlock',
  icon: [448, 512, [128275], "f09c", "M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z"]
};
var faColonSign = {
  prefix: 'fas',
  iconName: 'colon-sign',
  icon: [384, 512, [], "e140", "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.2 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"]
};
var faHeadset = {
  prefix: 'fas',
  iconName: 'headset',
  icon: [512, 512, [], "f590", "M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z"]
};
var faBadgerHoney = {
  prefix: 'fas',
  iconName: 'badger-honey',
  icon: [640, 512, [129441], "f6b4", "M164.6 389.3l16-37.3H298.7l16.9 101.3c2.6 15.4 15.9 26.7 31.6 26.7h31.1c19.8 0 34.8-17.8 31.6-37.3L393 342.1c27.9-29 80.6-70.8 144.1-90.8l16.1 25.8c3.1 5 10.4 5 13.6 0l22.8-36.5c12.9-2.1 25.2-7.4 34.4-16.6c10.2-10.2 16-24.1 16-38.6v-3.8c0-23.2-12.6-44.5-32.8-55.8L525.3 80.3C506.1 69.6 484.5 64 462.5 64c-20.1 0-39.9 4.7-57.8 13.6L400 80c-21 10.5-44.2 16-67.8 16H160 128C57.3 96 0 153.3 0 224v32c0 17.7 14.3 32 32 32c5.4 0 10.6-1.4 15-3.7c9.1 17.1 22.1 31.9 37.7 43.3l-16.8 59c-2.5 8.8-2.5 18.2 .2 27l13.1 43.7c4.1 13.5 16.5 22.8 30.7 22.8H141c21.4 0 36.8-20.7 30.7-41.2l-8.3-27.7c-2.2-7.2-1.7-14.9 1.2-21.8zM570 160H518.6c.9 2.5 1.4 5.2 1.4 8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-2.8 .5-5.5 1.4-8h-5.9c-23.2 0-46 6.3-65.9 18.2L294.8 242.3c-14.9 9-32 13.7-49.4 13.7H192c-46.4 0-86.2-28.2-103.2-68.5C102 161.7 129 144 160 144H332.2c31 0 61.5-7.2 89.2-21.1l4.7-2.4c11.3-5.6 23.7-8.6 36.3-8.6c13.8 0 27.4 3.5 39.5 10.2L570 160z"]
};
var faH4 = {
  prefix: 'fas',
  iconName: 'h4',
  icon: [640, 512, [], "f86a", "M479 103.8L441 256H576V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320H400c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l48-192c4.3-17.1 21.7-27.6 38.8-23.3s27.6 21.7 23.3 38.8zM32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z"]
};
var faStoreSlash = {
  prefix: 'fas',
  iconName: 'store-slash',
  icon: [640, 512, [], "e071", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V384 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V350.9L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm73.4 218.1c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3L365.5 384H160z"]
};
var faRoadCircleXmark = {
  prefix: 'fas',
  iconName: 'road-circle-xmark',
  icon: [640, 512, [], "e566", "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"]
};
var faSignalSlash = {
  prefix: 'fas',
  iconName: 'signal-slash',
  icon: [640, 512, [], "f695", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L608 451.2V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V401.1l-64-50.2V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V300.8l-64-50.2V224c0-17.7-14.3-32-32-32c-10.7 0-20.1 5.2-25.9 13.2L38.8 5.1zM576 512l-.3 0h.6l-.3 0zm-96-32v-5.8l-64-50.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM352 373.3l-64-50.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V373.3zM192 288c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416z"]
};
var faUserMinus = {
  prefix: 'fas',
  iconName: 'user-minus',
  icon: [640, 512, [], "f503", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMarsStrokeUp = {
  prefix: 'fas',
  iconName: 'mars-stroke-up',
  icon: [320, 512, [9896, "mars-stroke-v"], "f22a", "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H184v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8V168H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z"]
};
var faMarsStrokeV = faMarsStrokeUp;
var faChampagneGlasses = {
  prefix: 'fas',
  iconName: 'champagne-glasses',
  icon: [640, 512, [129346, "glass-cheers"], "f79f", "M155.6 17.3C163 3 179.9-3.6 195 1.9L320 47.5l125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6L556.1 413l41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41l-71.1 25.9L476.8 510c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1L92.2 484.1 21.1 458.2c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8L261.6 157l13.1-57.9L199.6 71.7zm240.9 0L365.4 99.1 378.5 157l89.2-32.5L440.5 71.7z"]
};
var faGlassCheers = faChampagneGlasses;
var faTaco = {
  prefix: 'fas',
  iconName: 'taco',
  icon: [512, 512, [127790], "f826", "M274.8 38.4l44.1 34.2c5.6 4.4 12.6 6.6 19.7 6.4l55.8-1.7c14-.4 26.5 8.6 30.4 22.1l15.6 53.6c2 6.8 6.3 12.8 12.2 16.8L498.6 201c11.6 7.9 16.3 22.5 11.6 35.7l-17.1 47.7C441.1 209.2 354.3 160 256 160s-185.1 49.2-237.1 124.4L1.8 236.7c-4.7-13.1 0-27.8 11.6-35.7l46.1-31.4c5.9-4 10.2-9.9 12.2-16.8L87.3 99.3c3.9-13.4 16.4-22.5 30.4-22.1L173.4 79c7.1 .2 14.1-2 19.7-6.4l44.1-34.2c11-8.6 26.5-8.6 37.5 0zM512 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32C0 306.6 114.6 192 256 192s256 114.6 256 256zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faHexagonPlus = {
  prefix: 'fas',
  iconName: 'hexagon-plus',
  icon: [512, 512, ["plus-hexagon"], "f300", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faPlusHexagon = faHexagonPlus;
var faClipboard = {
  prefix: 'fas',
  iconName: 'clipboard',
  icon: [384, 512, [128203], "f328", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faHouseCircleExclamation = {
  prefix: 'fas',
  iconName: 'house-circle-exclamation',
  icon: [640, 512, [], "e50a", "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faFileArrowUp = {
  prefix: 'fas',
  iconName: 'file-arrow-up',
  icon: [384, 512, ["file-upload"], "f574", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"]
};
var faFileUpload = faFileArrowUp;
var faWifi = {
  prefix: 'fas',
  iconName: 'wifi',
  icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faWifi3 = faWifi;
var faWifiStrong = faWifi;
var faMessages = {
  prefix: 'fas',
  iconName: 'messages',
  icon: [640, 512, ["comments-alt"], "f4b6", "M64 0C28.7 0 0 28.7 0 64V256c0 35.3 28.7 64 64 64H96v48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM352 352H256v32c0 35.3 28.7 64 64 64H437.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V448h32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448V256c0 53-43 96-96 96z"]
};
var faCommentsAlt = faMessages;
var faBath = {
  prefix: 'fas',
  iconName: 'bath',
  icon: [512, 512, [128705, "bathtub"], "f2cd", "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"]
};
var faBathtub = faBath;
var faUmbrellaSimple = {
  prefix: 'fas',
  iconName: 'umbrella-simple',
  icon: [512, 512, ["umbrella-alt"], "e2bc", "M256 0c17.7 0 32 14.3 32 32v2C403.8 48.4 495.6 140.2 510 256.1c2.2 17.5-12.4 31.9-30 31.9H32C14.3 288-.2 273.6 2 256.1C16.4 140.2 108.2 48.4 224 34V32c0-17.7 14.3-32 32-32zm32 430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V320h64V430.6z"]
};
var faUmbrellaAlt = faUmbrellaSimple;
var faRectangleHistoryCirclePlus = {
  prefix: 'fas',
  iconName: 'rectangle-history-circle-plus',
  icon: [640, 512, [], "e4a3", "M320 368c0 59.5 29.5 112.1 74.8 144L64 512c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-97.2 0-176 78.8-176 176zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24H392zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"]
};
var faUnderline = {
  prefix: 'fas',
  iconName: 'underline',
  icon: [448, 512, [], "f0cd", "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
};
var faPrescriptionBottlePill = {
  prefix: 'fas',
  iconName: 'prescription-bottle-pill',
  icon: [576, 512, [], "e5c0", "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352v83.2c-57 29.1-96 88.4-96 156.8c0 54.5 24.8 103.3 63.8 135.6c-9.4 5.4-20.2 8.4-31.8 8.4H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128zM304.8 300.5c6.7-12.6 23.6-13.5 33.7-3.4L502.9 461.5c10.1 10.1 9.2 27-3.4 33.7C479.4 505.9 456.4 512 432 512c-79.5 0-144-64.5-144-144c0-24.4 6.1-47.4 16.8-67.5zm254.5 135c-6.7 12.6-23.6 13.5-33.7 3.4L361.1 274.5c-10.1-10.1-9.2-27 3.4-33.7C384.6 230.1 407.6 224 432 224c79.5 0 144 64.5 144 144c0 24.4-6.1 47.4-16.8 67.5z"]
};
var faUserPen = {
  prefix: 'fas',
  iconName: 'user-pen',
  icon: [640, 512, ["user-edit"], "f4ff", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"]
};
var faUserEdit = faUserPen;
var faBinarySlash = {
  prefix: 'fas',
  iconName: 'binary-slash',
  icon: [640, 512, [], "e33e", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V352c0-35.3-28.7-64-64-64H399.7L298 208.3c13.5-11.7 22-29 22-48.3V64c0-35.3-28.7-64-64-64H192c-35.3 0-64 28.7-64 64V75L38.8 5.1zM192 125.2V64h64v96H236.4L192 125.2zM464 32c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V32zM240 320c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H240V320zm80 32v96c0 35.3 28.7 64 64 64h64c20.1 0 38.1-9.3 49.8-23.8l-51-40.2H384V398.5l-63.9-50.3c-.1 1.3-.1 2.5-.1 3.8z"]
};
var faSquareO = {
  prefix: 'fas',
  iconName: 'square-o',
  icon: [448, 512, [], "e278", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
var faSignature = {
  prefix: 'fas',
  iconName: 'signature',
  icon: [640, 512, [], "f5b7", "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48H616z"]
};
var faStroopwafel = {
  prefix: 'fas',
  iconName: 'stroopwafel',
  icon: [512, 512, [], "f551", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3L233.4 256l-45.3 45.3L142.9 256zm67.9 67.9L256 278.6l45.3 45.3L256 369.1l-45.3-45.3zM278.6 256l45.3-45.3L369.1 256l-45.3 45.3L278.6 256zm22.6-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z"]
};
var faBold = {
  prefix: 'fas',
  iconName: 'bold',
  icon: [384, 512, [], "f032", "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"]
};
var faAnchorLock = {
  prefix: 'fas',
  iconName: 'anchor-lock',
  icon: [640, 512, [], "e4ad", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3V446.7c-5.2 .9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faBuildingNgo = {
  prefix: 'fas',
  iconName: 'building-ngo',
  icon: [384, 512, [], "e4d7", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"]
};
var faTransporter3 = {
  prefix: 'fas',
  iconName: 'transporter-3',
  icon: [512, 512, [], "e045", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 512h88 80 88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32zM56.7 102.6C55.6 98.7 52.1 96 48 96s-7.6 2.7-8.7 6.6L32 128 6.6 135.3C2.7 136.4 0 139.9 0 144s2.7 7.6 6.6 8.7L32 160l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 160l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 128l-7.3-25.4zM480 32L472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faEngineWarning = {
  prefix: 'fas',
  iconName: 'engine-warning',
  icon: [640, 512, ["engine-exclamation"], "f5f2", "M424 88c0 13.3-10.7 24-24 24l-72 0v32h81.5c14.5 0 28.6 4.9 40 14L488 188.8c15.2 12.1 24 30.5 24 50V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H128c-17.7 0-32-14.3-32-32V280H48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V160c0-13.3 10.7-24 24-24s24 10.7 24 24v72H96V176c0-17.7 14.3-32 32-32l32 0 48 0 72 0V112l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24H400c13.3 0 24 10.7 24 24zM324 208c0-11-9-20-20-20s-20 9-20 20v88c0 11 9 20 20 20s20-9 20-20V208zM304 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM576 192h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]
};
var faEngineExclamation = faEngineWarning;
var faCircleDownRight = {
  prefix: 'fas',
  iconName: 'circle-down-right',
  icon: [512, 512, [], "e108", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm96 198.6V336c0 8.8-7.2 16-16 16H198.6c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L216 280l-66.3-66.3C146 210 144 205.1 144 200s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L280 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6z"]
};
var faSquareK = {
  prefix: 'fas',
  iconName: 'square-k',
  icon: [448, 512, [], "e274", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM313.1 168.8l-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V298.5 152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8L278.9 135.2c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5 .3 33.9z"]
};
var faManatSign = {
  prefix: 'fas',
  iconName: 'manat-sign',
  icon: [384, 512, [], "e1d5", "M192 32c-17.7 0-32 14.3-32 32V98.7C69.2 113.9 0 192.9 0 288V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32z"]
};
var faMoneyCheckPen = {
  prefix: 'fas',
  iconName: 'money-check-pen',
  icon: [640, 512, ["money-check-edit"], "f872", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H330.5l6-23.9c2.8-11.3 8.6-21.5 16.8-29.7L534.6 213.1c11.6-11.6 26.3-18.5 41.4-20.5V128c0-35.3-28.7-64-64-64H64zm48 224H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm517.8 27.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"]
};
var faMoneyCheckEdit = faMoneyCheckPen;
var faNotEqual = {
  prefix: 'fas',
  iconName: 'not-equal',
  icon: [448, 512, [], "f53e", "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H153.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H260.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"]
};
var faBorderTopLeft = {
  prefix: 'fas',
  iconName: 'border-top-left',
  icon: [448, 512, ["border-style"], "f853", "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBorderStyle = faBorderTopLeft;
var faMapLocationDot = {
  prefix: 'fas',
  iconName: 'map-location-dot',
  icon: [576, 512, ["map-marked-alt"], "f5a0", "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faMapMarkedAlt = faMapLocationDot;
var faTilde = {
  prefix: 'fas',
  iconName: 'tilde',
  icon: [448, 512, [63135], "7e", "M99.9 192C80.1 192 64 208.1 64 227.9V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V227.9C0 172.7 44.7 128 99.9 128c26.5 0 51.9 10.5 70.6 29.3L322.7 309.5c6.7 6.7 15.9 10.5 25.4 10.5c19.8 0 35.9-16.1 35.9-35.9V192c0-17.7 14.3-32 32-32s32 14.3 32 32v92.1c0 55.2-44.7 99.9-99.9 99.9c-26.5 0-51.9-10.5-70.6-29.3L125.3 202.5c-6.7-6.7-15.9-10.5-25.4-10.5z"]
};
var faJedi = {
  prefix: 'fas',
  iconName: 'jedi',
  icon: [576, 512, [], "f669", "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9H64.5c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"]
};
var faSquarePollVertical = {
  prefix: 'fas',
  iconName: 'square-poll-vertical',
  icon: [448, 512, ["poll"], "f681", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM320 288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z"]
};
var faPoll = faSquarePollVertical;
var faArrowDownSquareTriangle = {
  prefix: 'fas',
  iconName: 'arrow-down-square-triangle',
  icon: [576, 512, ["sort-shapes-down-alt"], "f889", "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 72c0-22.1 17.9-40 40-40H472c22.1 0 40 17.9 40 40V184c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72zM443.1 303l80 128c6.2 9.9 6.5 22.3 .9 32.5s-16.4 16.5-28 16.5H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6 .9-32.5l80-128c5.8-9.4 16.1-15 27.1-15s21.3 5.7 27.1 15z"]
};
var faSortShapesDownAlt = faArrowDownSquareTriangle;
var faMugHot = {
  prefix: 'fas',
  iconName: 'mug-hot',
  icon: [512, 512, [9749], "f7b6", "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"]
};
var faDogLeashed = {
  prefix: 'fas',
  iconName: 'dog-leashed',
  icon: [576, 512, [129454], "f6d4", "M122.7 4.1l160 144c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2l-160-144c-6.6-5.9-7.1-16-1.2-22.6s16-7.1 22.6-1.2zM144 192H256V383.3c-5.3 .5-10.6 .7-16 .7c-28.8 0-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16zM320 364.8c-10.1 5.2-20.8 9.4-32 12.6V208.1L416 262l0 218c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8zM426.7 192l-6.2 37.2L305.9 180.9l26.8-161C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7zM448 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faCarBattery = {
  prefix: 'fas',
  iconName: 'car-battery',
  icon: [512, 512, ["battery-car"], "f5df", "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"]
};
var faBatteryCar = faCarBattery;
var faFaceDowncastSweat = {
  prefix: 'fas',
  iconName: 'face-downcast-sweat',
  icon: [512, 512, [], "e371", "M35.2 126.3c4.1 1.1 8.4 1.7 12.8 1.7c26.5 0 48-21 48-47c0-5-1.8-11.3-4.6-18.1c-.3-.7-.6-1.4-.9-2.1c-8.9-20.2-26.5-44.9-36-57.5c-3.2-4.4-9.6-4.4-12.8 0C28.6 20.6 0 61 0 81c0 21.7 14.9 39.8 35.2 45.3zM256 0c-51.4 0-99.3 15.2-139.4 41.2c1.5 3.1 3 6.2 4.3 9.3c3.4 8 7.1 19 7.1 30.5c0 44.3-36.6 79-80 79c-9.6 0-18.8-1.7-27.4-4.8C7.3 186.2 0 220.2 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM195.9 410.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7zM96 272c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm208-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMailboxFlagUp = {
  prefix: 'fas',
  iconName: 'mailbox-flag-up',
  icon: [576, 512, [], "e5bb", "M400 16c-29.8 0-54.9 20.4-62 48H245.2C290.4 95.9 320 148.5 320 208V384c0 24.6-9.2 47-24.4 64H512c35.3 0 64-28.7 64-64V208c0-42.6-18.5-81-48-107.3V80c0-35.3-28.7-64-64-64H400zm0 208c-8.8 0-16-7.2-16-16V112 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H416v80c0 8.8-7.2 16-16 16zM0 208V384c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144S0 128.5 0 208zm64 0c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16z"]
};
var faMemoCircleInfo = {
  prefix: 'fas',
  iconName: 'memo-circle-info',
  icon: [576, 512, [], "e49a", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm64 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm352-96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16h0v48h0c-8.8 0-16 7.2-16 16s7.2 16 16 16h16 16c8.8 0 16-7.2 16-16s-7.2-16-16-16V368c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16z"]
};
var faGift = {
  prefix: 'fas',
  iconName: 'gift',
  icon: [512, 512, [127873], "f06b", "M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"]
};
var faDiceTwo = {
  prefix: 'fas',
  iconName: 'dice-two',
  icon: [448, 512, [9857], "f528", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faVolume = {
  prefix: 'fas',
  iconName: 'volume',
  icon: [576, 512, [128265, "volume-medium"], "f6a8", "M333.1 34.8C344.6 40 352 51.4 352 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L163.8 352H96c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L298.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zm172 72.2c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C466.1 199.1 480 225.9 480 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"]
};
var faVolumeMedium = faVolume;
var faTransporter5 = {
  prefix: 'fas',
  iconName: 'transporter-5',
  icon: [512, 512, [], "e2a6", "M480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4C456.4 2.7 459.9 0 464 0s7.6 2.7 8.7 6.6L480 32zM56.7 134.6L64 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 192 6.6 184.7C2.7 183.6 0 180.1 0 176s2.7-7.6 6.6-8.7L32 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM384 512H296 216 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32zM224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zM176 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 256H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faGaugeCircleBolt = {
  prefix: 'fas',
  iconName: 'gauge-circle-bolt',
  icon: [640, 512, [], "e496", "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24V292.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L516.4 356H552c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L475.6 380H440c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
var faCoinFront = {
  prefix: 'fas',
  iconName: 'coin-front',
  icon: [512, 512, [], "e3fc", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm24-264c0-13.3-10.7-24-24-24s-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
};
var faFileSlash = {
  prefix: 'fas',
  iconName: 'file-slash',
  icon: [640, 512, [], "e3a7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V160H384c-17.7 0-32-14.3-32-32V0H192c-35.3 0-64 28.7-64 64V75L38.8 5.1zM128 196.9V448c0 35.3 28.7 64 64 64H448c20.1 0 38.1-9.3 49.8-23.8L128 196.9zM512 128L384 0V128H512z"]
};
var faMessageArrowUpRight = {
  prefix: 'fas',
  iconName: 'message-arrow-up-right',
  icon: [512, 512, [], "e1dd", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm200 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24H200z"]
};
var faTreasureChest = {
  prefix: 'fas',
  iconName: 'treasure-chest',
  icon: [576, 512, [], "f723", "M0 160v96H128V32C57.3 32 0 89.3 0 160zM0 432c0 26.5 21.5 48 48 48h80V288H0V432zM416 288H352v32c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V288H160V480H416V288zM528 480c26.5 0 48-21.5 48-48V288H448V480h80zm48-320c0-70.7-57.3-128-128-128V256H576V160zM416 256V32H160V256h64V224c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64zM304 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]
};
var faChessQueen = {
  prefix: 'fas',
  iconName: 'chess-queen',
  icon: [512, 512, [9819], "f445", "M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM134.1 143.8c3.3-13 15-23.8 30.2-23.8c12.3 0 22.6 7.2 27.7 17c12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17c15.3 0 27 10.8 30.2 23.8c7 27.8 32.2 48.3 62.1 48.3c10.8 0 21-2.7 29.8-7.4c8.4-4.4 18.9-4.5 27.6 .9c13 8 17.1 25 9.2 38L399.7 400H384 343.6 168.4 128 112.3L5.4 223.6c-7.9-13-3.8-30 9.2-38c8.7-5.3 19.2-5.3 27.6-.9c8.9 4.7 19 7.4 29.8 7.4c29.9 0 55.1-20.5 62.1-48.3zM256 224l0 0 0 0h0zM112 432H400l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H86.6C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z"]
};
var faPaintbrushFine = {
  prefix: 'fas',
  iconName: 'paintbrush-fine',
  icon: [576, 512, ["paint-brush-alt", "paint-brush-fine", "paintbrush-alt"], "f5a9", "M559.6 16.4c21.9 21.9 21.9 57.3 0 79.2L306.9 348.3l-79.2-79.2L480.4 16.4c21.9-21.9 57.3-21.9 79.2 0zM205.1 291.7l79.2 79.2-.1 .1c2.5 9.3 3.8 19 3.8 29c0 61.9-50.1 112-112 112H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h4.8c17.6 0 29.6-18.9 27.8-36.4c-.4-3.8-.6-7.7-.6-11.6c0-61.9 50.1-112 112-112c10 0 19.8 1.3 29 3.8l.1-.1z"]
};
var faPaintBrushAlt = faPaintbrushFine;
var faPaintBrushFine = faPaintbrushFine;
var faPaintbrushAlt = faPaintbrushFine;
var faGlasses = {
  prefix: 'fas',
  iconName: 'glasses',
  icon: [576, 512, [], "f530", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368V325.4c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z"]
};
var faHoodCloak = {
  prefix: 'fas',
  iconName: 'hood-cloak',
  icon: [576, 512, [], "f6ef", "M432 0H288h0c-9.8 0-66 0-120.2 37.7C111.4 76.9 64 151.8 64 288c0 58.5-14.6 101.6-28.6 129.7c-7 14.1-14 24.5-19 31.1c-2.5 3.3-4.5 5.7-5.7 7.1c-.6 .7-1.1 1.2-1.3 1.4l-.2 .2c-9 9.1-11.7 22.8-6.8 34.7c5 12 16.6 19.8 29.6 19.8h96V320c0-88.4 71.6-160 160-160s160 71.6 160 160V512h96c12.9 0 24.6-7.8 29.6-19.8c4.9-11.9 2.2-25.6-6.8-34.7l0 0 0 0 0 0-.1-.1c-.2-.2-.7-.7-1.3-1.4c-1.3-1.4-3.2-3.8-5.7-7.1c-5-6.6-11.9-17-19-31.1C526.6 389.6 512 346.5 512 288c0-103.1-46.5-172.8-95.8-217.2l32-29c7.3-6.7 9.8-17.2 6.2-26.4S441.9 0 432 0zM416 512V320c0-70.7-57.3-128-128-128s-128 57.3-128 128V512H416z"]
};
var faSquareQuote = {
  prefix: 'fas',
  iconName: 'square-quote',
  icon: [448, 512, [], "e329", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 128h48c17.7 0 32 14.3 32 32v24 24 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272H128c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm224 80v39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272H272c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24z"]
};
var faUpLeft = {
  prefix: 'fas',
  iconName: 'up-left',
  icon: [384, 512, [], "e2bd", "M48 80H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-72 72L372.7 340.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3l-41.4 41.4c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L142.6 302.6l-72 72c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V112c0-17.7 14.3-32 32-32z"]
};
var faBringFront = {
  prefix: 'fas',
  iconName: 'bring-front',
  icon: [640, 512, [], "f857", "M64 64h64 32 32 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64h64V192H64V64zM480 448H448 384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H512v64h64V448H512 480zM224 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H224z"]
};
var faChessBoard = {
  prefix: 'fas',
  iconName: 'chess-board',
  icon: [448, 512, [], "f43c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 64v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z"]
};
var faBurgerCheese = {
  prefix: 'fas',
  iconName: 'burger-cheese',
  icon: [512, 512, [127828, "cheeseburger"], "f7f1", "M32 194.9C32 211 45 224 61.1 224H450.9c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zM128 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm240 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 400v16c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V400c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM234 262.7c-6.5-4.4-14.2-6.7-22.1-6.7H208l-.1 0H64c-26.5 0-48 21.5-48 48s21.5 48 48 48H448c26.5 0 48-21.5 48-48s-21.5-48-48-48H432.1l-.1 0h-3.9c-7.9 0-15.6 2.3-22.1 6.7l-68.2 45.5c-10.7 7.2-24.8 7.2-35.5 0L234 262.7z"]
};
var faCheeseburger = faBurgerCheese;
var faBuildingCircleCheck = {
  prefix: 'fas',
  iconName: 'building-circle-check',
  icon: [640, 512, [], "e4d2", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faRepeat1 = {
  prefix: 'fas',
  iconName: 'repeat-1',
  icon: [512, 512, [128258], "f365", "M32 256c-17.7 0-32-14.3-32-32C0 135.6 71.6 64 160 64H320V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V128H160c-53 0-96 43-96 96c0 17.7-14.3 32-32 32zm448 0c17.7 0 32 14.3 32 32c0 88.4-71.6 160-160 160H192v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32H352c53 0 96-43 96-96c0-17.7 14.3-32 32-32zM288 216v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"]
};
var faArrowDownToLine = {
  prefix: 'fas',
  iconName: 'arrow-down-to-line',
  icon: [384, 512, ["arrow-to-bottom"], "f33d", "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zM214.6 342.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 242.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V242.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128z"]
};
var faArrowToBottom = faArrowDownToLine;
var faGrid5 = {
  prefix: 'fas',
  iconName: 'grid-5',
  icon: [448, 512, [], "e199", "M0 48c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H16C7.2 96 0 88.8 0 80V48zm0 96c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V144zm16 80H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM0 336c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V336zm16 80H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V48zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM96 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V432zM208 32h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM192 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM192 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM288 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V48zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM288 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM288 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V432zM400 32h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM384 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM384 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16z"]
};
var faRightLongToLine = {
  prefix: 'fas',
  iconName: 'right-long-to-line',
  icon: [640, 512, [], "e444", "M640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32zM360.5 409.4c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V320L32 320c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32l288 0V120c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136z"]
};
var faPersonChalkboard = {
  prefix: 'fas',
  iconName: 'person-chalkboard',
  icon: [640, 512, [], "e53d", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V192h56 64 16c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64H576V256H384V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faMarsStrokeRight = {
  prefix: 'fas',
  iconName: 'mars-stroke-right',
  icon: [640, 512, [9897, "mars-stroke-h"], "f22b", "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152H416V176c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32V176c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V280H464v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H382.4z"]
};
var faMarsStrokeH = faMarsStrokeRight;
var faHandBackFist = {
  prefix: 'fas',
  iconName: 'hand-back-fist',
  icon: [448, 512, ["hand-rock"], "f255", "M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"]
};
var faHandRock = faHandBackFist;
var faGridRound5 = {
  prefix: 'fas',
  iconName: 'grid-round-5',
  icon: [448, 512, [], "e5de", "M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm0 96A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 64A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM128 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faTally = {
  prefix: 'fas',
  iconName: 'tally',
  icon: [640, 512, ["tally-5"], "f69c", "M128 32c17.7 0 32 14.3 32 32V275.6l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32V232.9l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32V190.3l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v83.6l53.9-18c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L544 215.1V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V236.4l-64 21.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V279.1l-64 21.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V321.7l-64 21.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V364.4l-53.9 18c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5L96 296.9V64c0-17.7 14.3-32 32-32z"]
};
var faTally5 = faTally;
var faSquareCaretUp = {
  prefix: 'fas',
  iconName: 'square-caret-up',
  icon: [448, 512, ["caret-square-up"], "f151", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"]
};
var faCaretSquareUp = faSquareCaretUp;
var faCloudShowersWater = {
  prefix: 'fas',
  iconName: 'cloud-showers-water',
  icon: [576, 512, [], "e4e4", "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faChartBar = {
  prefix: 'fas',
  iconName: 'chart-bar',
  icon: [512, 512, ["bar-chart"], "f080", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faBarChart = faChartBar;
var faHandsBubbles = {
  prefix: 'fas',
  iconName: 'hands-bubbles',
  icon: [576, 512, ["hands-wash"], "e05e", "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 160l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7v-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8 0 0 0 0-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zM332.1 88.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27c.9 1.5 1.7 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4H352h13.3l0 0H397l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352v8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H352l0 0 0 0H258.8L305 219.1c15-9.4 19.5-29.1 10.2-44.1z"]
};
var faHandsWash = faHandsBubbles;
var faLessThanEqual = {
  prefix: 'fas',
  iconName: 'less-than-equal',
  icon: [448, 512, [], "f537", "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faTrain = {
  prefix: 'fas',
  iconName: 'train',
  icon: [448, 512, [128646], "f238", "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM224 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faUpFromDottedLine = {
  prefix: 'fas',
  iconName: 'up-from-dotted-line',
  icon: [448, 512, [], "e456", "M73.9 166.1L196.7 43.3C203.9 36.1 213.8 32 224 32s20.1 4.1 27.3 11.3L374.1 166.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9H288V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V224H97.9C79.2 224 64 208.8 64 190.1c0-9 3.6-17.6 9.9-24zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faEyeLowVision = {
  prefix: 'fas',
  iconName: 'eye-low-vision',
  icon: [640, 512, ["low-vision"], "f2a8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7c60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3L223 149.5zm223.1 298L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z"]
};
var faLowVision = faEyeLowVision;
var faTrafficLightGo = {
  prefix: 'fas',
  iconName: 'traffic-light-go',
  icon: [320, 512, [], "f638", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-200a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM136 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faFaceExhaling = {
  prefix: 'fas',
  iconName: 'face-exhaling',
  icon: [576, 512, [], "e480", "M256 512c55.8 0 107.4-17.9 149.5-48.2c-10.5-9.3-17.9-22.1-20.5-36.5l-42.2-12.7C329.3 410.6 320 398.1 320 384s9.3-26.6 22.8-30.6L385 340.7c5.3-30 31.5-52.7 63-52.7c.7 0 1.4 0 2.1 0c13.2-14.7 32.3-24 53.7-24c2.7 0 5.4 .2 8.1 .5c.1-2.8 .1-5.6 .1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM195.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm121.6 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM256 344a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm287.4-5.5c.1-.8 .1-1.7 .1-2.5c0-22.1-17.9-40-39.9-40c-16.9 0-31.4 10.5-37.2 25.4c-3.3-.9-6.9-1.4-10.5-1.4c-22.1 0-39.9 17.9-39.9 40l-56.1 14.1c-4.6 1.1-7.8 5.2-7.8 9.9s3.2 8.8 7.8 9.9l56.9 14.2c-.5 2.5-.8 5.1-.8 7.8c0 22.1 17.9 40 39.9 40c4.9 0 9.6-.9 14-2.5c7.1 11.1 19.5 18.5 33.7 18.5c22.1 0 39.9-17.9 39.9-40c0-.8 0-1.7-.1-2.5c19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z"]
};
var faSensorFire = {
  prefix: 'fas',
  iconName: 'sensor-fire',
  icon: [640, 512, [], "e02a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4c21.7-35.2 51.9-71.2 87.3-102.8c10-8.9 23-12.8 35.5-11.7V96c0-35.3-28.7-64-64-64H64zm48 88V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm245.5 43.6c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8C332.7 291.3 320 325.6 320 352c0 87.8 70.3 159.8 160 159.8c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faUserUnlock = {
  prefix: 'fas',
  iconName: 'user-unlock',
  icon: [640, 512, [], "e058", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3V480c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3zM496 272v48h16 48 48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272c0-44.2 35.8-80 80-80s80 35.8 80 80H560c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faHexagonDivide = {
  prefix: 'fas',
  iconName: 'hexagon-divide',
  icon: [512, 512, [], "e1ad", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H168zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var fa00 = {
  prefix: 'fas',
  iconName: '00',
  icon: [640, 512, [], "e467", "M144 32C64.5 32 0 96.5 0 176V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM64 176c0-44.2 35.8-80 80-80s80 35.8 80 80V336c0 44.2-35.8 80-80 80s-80-35.8-80-80V176zM496 32c-79.5 0-144 64.5-144 144V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM416 176c0-44.2 35.8-80 80-80s80 35.8 80 80V336c0 44.2-35.8 80-80 80s-80-35.8-80-80V176z"]
};
var faCrow = {
  prefix: 'fas',
  iconName: 'crow',
  icon: [640, 512, [], "f520", "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384H259.2l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384H352c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192V128v-8l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32H523.9C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCassetteBetamax = {
  prefix: 'fas',
  iconName: 'cassette-betamax',
  icon: [576, 512, ["betamax"], "f8a4", "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 160H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160zM192 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 320a96 96 0 1 1 192 0A96 96 0 1 1 64 320zm256-64c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V256z"]
};
var faBetamax = faCassetteBetamax;
var faSailboat = {
  prefix: 'fas',
  iconName: 'sailboat',
  icon: [576, 512, [], "e445", "M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6H272c-8.8 0-16-7.2-16-16V16zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5V336c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"]
};
var faWindowRestore = {
  prefix: 'fas',
  iconName: 'window-restore',
  icon: [512, 512, [], "f2d2", "M432 64H208c-8.8 0-16 7.2-16 16V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V320h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"]
};
var faNfcMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'nfc-magnifying-glass',
  icon: [640, 512, [], "e1f9", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v64c-22.8 0-44.4 4.8-64 13.3V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v48c-38.9 29.2-64 75.7-64 128c0 22.8 4.8 44.4 13.3 64H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H320c21.6 28.8 52.7 50 88.6 59.1c-7.6 3.2-15.9 4.9-24.6 4.9H64c-35.3 0-64-28.7-64-64V96zM448 400.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"]
};
var faFileBinary = {
  prefix: 'fas',
  iconName: 'file-binary',
  icon: [384, 512, [], "e175", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48zM96 304v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm144-48h32c8.8 0 16 7.2 16 16V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H272 240c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V288H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleV = {
  prefix: 'fas',
  iconName: 'circle-v',
  icon: [512, 512, [], "e12a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM173.5 157.3L256 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z"]
};
var faSquarePlus = {
  prefix: 'fas',
  iconName: 'square-plus',
  icon: [448, 512, [61846, "plus-square"], "f0fe", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faPlusSquare = faSquarePlus;
var faBowlScoops = {
  prefix: 'fas',
  iconName: 'bowl-scoops',
  icon: [448, 512, [127813], "e3df", "M224 208c0 5.4 .4 10.8 1.1 16H446.9c.7-5.2 1.1-10.6 1.1-16c0-61.9-50.1-112-112-112l-1.1 0c-38.7 .4-72.7 20.4-92.6 50.6C230.7 164.2 224 185.3 224 208zM0 208c0 5.4 .4 10.8 1.1 16H192.9c-.6-5.3-.9-10.6-.9-16c0-22 4.9-42.8 13.7-61.4c-13.9-21.2-34.9-37.4-59.6-45.3C135.4 97.9 123.9 96 112 96C50.1 96 0 146.1 0 208zM325.4 64.4C307.5 26.3 268.8 0 224 0s-83.5 26.3-101.4 64.4c40.9 3 77.1 23 101.4 53.1c24.3-30.1 60.5-50.1 101.4-53.1zM16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9C11.1 361.9 72.4 416 145 416h40.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H320c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 416H303c72.6 0 133.9-54.1 142.9-126.1l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16z"]
};
var faMistletoe = {
  prefix: 'fas',
  iconName: 'mistletoe',
  icon: [576, 512, [], "f7b4", "M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v94.1l-98 98L91.3 230.4C38.3 240.6 0 287 0 341c0 41.4 33.6 75 75 75c50.5 0 94.3-33.5 108.1-81.2c7.2 10.4 19.3 17.2 32.9 17.2c22.1 0 40-17.9 40-40s-17.9-40-40-40c-7.9 0-15.3 2.3-21.5 6.3l5.4-28.2L264 185.9v72.4c14.7 13.2 24 32.3 24 53.7c0 39.8-32.2 72-72 72c-7.2 0-14.2-1.1-20.8-3c-2.1 8.4-3.2 17.1-3.2 25.9V416c0 53 43 96 96 96s96-43 96-96v-9.1c0-25.1-9-49.4-25.3-68.4L312 284V185.9L376.1 250l14.4 74.7C400.6 377.7 447 416 501 416c41.4 0 75-33.6 75-75c0-54-38.3-100.3-91.3-110.5L410 216.1l-98-98V24zm64 88a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faCustard = {
  prefix: 'fas',
  iconName: 'custard',
  icon: [576, 512, [127854], "e403", "M396.7 64c30 0 56 20.8 62.5 50.1l13.5 60.8C450.9 167.4 423.5 160 400 160c-26.4 0-45.8 9.4-62.2 17.2l-.7 .3c-16.7 8-30.4 14.4-49.1 14.4s-32.3-6.4-49.1-14.4l-.7-.3C221.8 169.4 202.4 160 176 160c-23.5 0-50.9 7.4-72.6 14.9l13.5-60.8C123.4 84.8 149.3 64 179.3 64H396.7zM64.3 350.9L95.1 212.1c4.1-1.6 8.5-3.3 13.2-5c22-7.9 47.8-15.1 67.7-15.1c18.7 0 32.3 6.4 49.1 14.4l.7 .3c16.4 7.9 35.8 17.2 62.2 17.2s45.8-9.4 62.2-17.2l.7-.3c16.7-8 30.4-14.4 49.1-14.4c19.8 0 45.6 7.2 67.7 15.1c4.7 1.7 9.2 3.4 13.2 5L512 352 64.3 350.9zM32 384H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faLacrosseStick = {
  prefix: 'fas',
  iconName: 'lacrosse-stick',
  icon: [512, 512, [], "e3b5", "M336 64v0c.1 0 .2 0 .3 0c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1c0 .1 0 .2 0 .3h0c0 33.1-21.9 62.1-53.7 71.2l-11.5 3.3c-19.6 5.6-37.9 15.1-53.9 27.8L294 306.2c-11.1 8.9-25 13.8-39.2 13.8c-34.7 0-62.8-28.1-62.8-62.8c0-14.3 4.9-28.1 13.8-39.2l27.9-34.9c12.8-15.9 22.2-34.3 27.8-53.9l3.3-11.5C273.9 85.9 302.9 64 336 64zm0-64V0C274.4 0 220.2 40.9 203.3 100.1L200 111.7c-3.3 11.5-8.8 22.2-16.2 31.5l-27.9 34.9c-18 22.5-27.8 50.4-27.8 79.2c0 23.4 6.3 45.3 17.4 64.1l-136 136c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l136-136c18.8 11.1 40.7 17.4 64.1 17.4c28.8 0 56.7-9.8 79.2-27.8l34.9-27.9c9.3-7.4 20-13 31.5-16.2l11.5-3.3C471.1 291.8 512 237.6 512 176h0c0-.1 0-.2 0-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0c-.1 0-.2 0-.3 0z"]
};
var faHockeyMask = {
  prefix: 'fas',
  iconName: 'hockey-mask',
  icon: [448, 512, [], "f6ee", "M0 240C0 111 64 0 224 0S448 111 448 240c0 192-48 272-224 272S0 432 0 240zM160 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 272c35.3 0 64-28.7 64-64c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64zm256-64c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faSunrise = {
  prefix: 'fas',
  iconName: 'sunrise',
  icon: [576, 512, [127749], "f766", "M354.5 135.7L320 104.3V208c0 17.7-14.3 32-32 32s-32-14.3-32-32V104.3l-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zm39.1 89.5c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L512 432H406.7c-19-46.9-65-80-118.7-80s-99.7 33.1-118.7 80H64L34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM0 488c0-13.3 10.7-24 24-24H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"]
};
var faPanelEws = {
  prefix: 'fas',
  iconName: 'panel-ews',
  icon: [512, 512, [], "e42e", "M64 0C28.7 0 0 28.7 0 64V288H16c44.2 0 80 35.8 80 80v16c0 17.7 14.3 32 32 32s32-14.3 32-32V352c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V368c0-26.5-21.5-48-48-48H0V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm48 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 128h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 128h64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32z"]
};
var faToriiGate = {
  prefix: 'fas',
  iconName: 'torii-gate',
  icon: [512, 512, [9961], "f6a1", "M0 80c0 26.5 21.5 48 48 48H64v64h64V128h96v64h64V128h96v64h64V128h16c26.5 0 48-21.5 48-48V13.4C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32H126.8c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4V80zM64 288V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64z"]
};
var faCloudExclamation = {
  prefix: 'fas',
  iconName: 'cloud-exclamation',
  icon: [640, 512, [], "e491", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM320 160c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faMessageLines = {
  prefix: 'fas',
  iconName: 'message-lines',
  icon: [512, 512, ["comment-alt-lines"], "f4a6", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm152 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"]
};
var faCommentAltLines = faMessageLines;
var faFrog = {
  prefix: 'fas',
  iconName: 'frog',
  icon: [576, 512, [], "f52e", "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBucket = {
  prefix: 'fas',
  iconName: 'bucket',
  icon: [448, 512, [], "e4cf", "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8H352v-8c0-57.4-46.6-104-104-104H200C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1L388.5 469c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32z"]
};
var faFloppyDiskPen = {
  prefix: 'fas',
  iconName: 'floppy-disk-pen',
  icon: [576, 512, [], "e182", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H258.5l14-55.9c2.8-11.3 8.6-21.5 16.8-29.7L448 235.6V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm325.8-52.2c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 417.1c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 358.8l-71-71L311.9 417.1z"]
};
var faImage = {
  prefix: 'fas',
  iconName: 'image',
  icon: [512, 512, [], "f03e", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faWindowFrame = {
  prefix: 'fas',
  iconName: 'window-frame',
  icon: [512, 512, [129695], "e04f", "M32 256V64C32 28.7 60.7 0 96 0H416c35.3 0 64 28.7 64 64V256 448c17.7 0 32 14.3 32 32s-14.3 32-32 32H416 96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V256zm384 32H280V448H416V288zm-184 0H96V448H232V288zm48-64H416V64H280V224zM232 64H96V224H232V64z"]
};
var faMicrophone = {
  prefix: 'fas',
  iconName: 'microphone',
  icon: [384, 512, [], "f130", "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"]
};
var faCow = {
  prefix: 'fas',
  iconName: 'cow',
  icon: [640, 512, [128004], "f6c8", "M96 224v32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V327.8c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16V351.1c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V343.8c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H272 256 192 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4V256 224 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160v64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H361.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"]
};
var faFileZip = {
  prefix: 'fas',
  iconName: 'file-zip',
  icon: [512, 512, [], "e5ee", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H240c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM240 352h64c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384H240c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368zm32 64h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48z"]
};
var faSquareRing = {
  prefix: 'fas',
  iconName: 'square-ring',
  icon: [448, 512, [], "e44f", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 224a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320z"]
};
var faDownFromLine = {
  prefix: 'fas',
  iconName: 'down-from-line',
  icon: [384, 512, ["arrow-alt-from-top"], "f349", "M41.9 345.9L164.7 468.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L342.1 345.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9H256V160c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32V288H65.9C47.2 288 32 303.2 32 321.9c0 9 3.6 17.6 9.9 24zM32 96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96z"]
};
var faArrowAltFromTop = faDownFromLine;
var faCaretUp = {
  prefix: 'fas',
  iconName: 'caret-up',
  icon: [320, 512, [], "f0d8", "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
};
var faShieldXmark = {
  prefix: 'fas',
  iconName: 'shield-xmark',
  icon: [512, 512, ["shield-times"], "e24c", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faShieldTimes = faShieldXmark;
var faScrewdriver = {
  prefix: 'fas',
  iconName: 'screwdriver',
  icon: [512, 512, [129691], "f54a", "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v54.1l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"]
};
var faCircleSortDown = {
  prefix: 'fas',
  iconName: 'circle-sort-down',
  icon: [512, 512, ["sort-circle-down"], "e031", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM267.3 411.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9H352c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96zm0-310.6l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zM313.4 192L256 134.6 198.6 192H313.4z"]
};
var faSortCircleDown = faCircleSortDown;
var faFolderClosed = {
  prefix: 'fas',
  iconName: 'folder-closed',
  icon: [512, 512, [], "e185", "M448 480H64c-35.3 0-64-28.7-64-64V192H512V416c0 35.3-28.7 64-64 64zm64-320H0V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64z"]
};
var faHouseTsunami = {
  prefix: 'fas',
  iconName: 'house-tsunami',
  icon: [576, 512, [], "e515", "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1l0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"]
};
var faSquareNfi = {
  prefix: 'fas',
  iconName: 'square-nfi',
  icon: [448, 512, [], "e576", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"]
};
var faForklift = {
  prefix: 'fas',
  iconName: 'forklift',
  icon: [640, 512, [], "f47a", "M48 160H96V48c0-26.5 21.5-48 48-48H292.7c20.3 0 38.4 12.8 45.2 31.9l75.3 210.8c1.8 5.2 2.8 10.6 2.8 16.1v85.7c19.6 17.6 32 43.1 32 71.6c0 53-43 96-96 96s-96-43-96-96H192c0 53-43 96-96 96s-96-43-96-96V208c0-26.5 21.5-48 48-48zm208 96h94L281.4 64H160v96l96 96zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm256 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM544 32V384h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H512c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faArrowUpFromGroundWater = {
  prefix: 'fas',
  iconName: 'arrow-up-from-ground-water',
  icon: [576, 512, [], "e4b5", "M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"]
};
var faBracketSquareRight = {
  prefix: 'fas',
  iconName: 'bracket-square-right',
  icon: [192, 512, [], "5d", "M192 96c0-35.3-28.7-64-64-64H64C46.3 32 32 46.3 32 64s14.3 32 32 32h64V416H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c35.3 0 64-28.7 64-64V96z"]
};
var faMartiniGlass = {
  prefix: 'fas',
  iconName: 'martini-glass',
  icon: [512, 512, [127864, "glass-martini-alt"], "f57b", "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM173.3 128l-64-64H402.7l-64 64H173.3z"]
};
var faGlassMartiniAlt = faMartiniGlass;
var faRotateLeft = {
  prefix: 'fas',
  iconName: 'rotate-left',
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"]
};
var faRotateBack = faRotateLeft;
var faRotateBackward = faRotateLeft;
var faUndoAlt = faRotateLeft;
var faTableColumns = {
  prefix: 'fas',
  iconName: 'table-columns',
  icon: [512, 512, ["columns"], "f0db", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64V416H224V160H64zm384 0H288V416H448V160z"]
};
var faColumns = faTableColumns;
var faSquareA = {
  prefix: 'fas',
  iconName: 'square-a',
  icon: [448, 512, [], "e25f", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 336H158.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L182.8 288h82.3L224 205.7z"]
};
var faTick = {
  prefix: 'fas',
  iconName: 'tick',
  icon: [128, 512, [], "e32f", "M0 98.3V96C0 60.7 28.7 32 64 32s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L101.5 256.5C98.3 274.7 82.5 288 64 288s-34.3-13.3-37.5-31.5L1 109.6c-.7-3.8-1-7.5-1-11.4z"]
};
var faLemon = {
  prefix: 'fas',
  iconName: 'lemon',
  icon: [448, 512, [127819], "f094", "M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"]
};
var faHeadSideMask = {
  prefix: 'fas',
  iconName: 'head-side-mask',
  icon: [576, 512, [], "e063", "M32 224.2c0-22.2 3.2-43.6 9.2-63.9L262.2 321c-4 9.5-6.2 20-6.2 31V512H128c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zm248.3 70.4L53 129.3C88.7 53 166.2 0 256 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2H336c-21.7 0-41.3 8.6-55.7 22.6zM336 304H534l0 0h10l-19.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H514.5l-9.8 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H494.8l-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2H288V352c0-14 6-26.7 15.6-35.4c0 0 0 0 0 0c8.5-7.8 19.9-12.6 32.4-12.6zm48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faHandshake = {
  prefix: 'fas',
  iconName: 'handshake',
  icon: [640, 512, [], "f2b5", "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V128H16zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faGem = {
  prefix: 'fas',
  iconName: 'gem',
  icon: [512, 512, [128142], "f3a5", "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"]
};
var faDolly = {
  prefix: 'fas',
  iconName: 'dolly',
  icon: [576, 512, ["dolly-box"], "f472", "M0 32C0 14.3 14.3 0 32 0h72.9c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L104.9 64H32C14.3 64 0 49.7 0 32zM244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5z"]
};
var faDollyBox = faDolly;
var faSmoking = {
  prefix: 'fas',
  iconName: 'smoking',
  icon: [640, 512, [128684], "f48d", "M448 32V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32V245c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V416zm224 0v32H384V416H224zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32z"]
};
var faMinimize = {
  prefix: 'fas',
  iconName: 'minimize',
  icon: [512, 512, ["compress-arrows-alt"], "f78c", "M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V312c0-13.3 10.7-24 24-24H456zm-256 0c13.3 0 24 10.7 24 24V456c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H200zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V200c0 13.3-10.7 24-24 24H56z"]
};
var faCompressArrowsAlt = faMinimize;
var faRefrigerator = {
  prefix: 'fas',
  iconName: 'refrigerator',
  icon: [384, 512, [], "e026", "M96 0C43 0 0 43 0 96v64H288V112c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V96c0-53-43-96-96-96H96zM384 192H320V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H0V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V192z"]
};
var faMonument = {
  prefix: 'fas',
  iconName: 'monument',
  icon: [384, 512, [], "f5a6", "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faOctagonXmark = {
  prefix: 'fas',
  iconName: 'octagon-xmark',
  icon: [512, 512, ["times-octagon", "xmark-octagon"], "f2f0", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faTimesOctagon = faOctagonXmark;
var faXmarkOctagon = faOctagonXmark;
var faAlignSlash = {
  prefix: 'fas',
  iconName: 'align-slash',
  icon: [640, 512, [], "f846", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L481.4 352H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H399.7l-81.7-64H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H236.4L154.8 96H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM324.9 352l-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H324.9zM162.5 224l-61.8-48.7c-3 4.9-4.7 10.6-4.7 16.7c0 17.7 14.3 32 32 32h34.5zM487.4 480l-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H487.4z"]
};
var faSnowplow = {
  prefix: 'fas',
  iconName: 'snowplow',
  icon: [640, 512, [], "f7d2", "M298.9 64l68.6 160H256l-64-64V64H298.9zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48V160H96c-17.7 0-32 14.3-32 32V298.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V320 235.2L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288H448V256.7c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H368zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faAnglesRight = {
  prefix: 'fas',
  iconName: 'angles-right',
  icon: [512, 512, [187, "angle-double-right"], "f101", "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"]
};
var faAngleDoubleRight = faAnglesRight;
var faTruckRampCouch = {
  prefix: 'fas',
  iconName: 'truck-ramp-couch',
  icon: [640, 512, ["truck-couch"], "f4dd", "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM294.5 209.2c8.7-2.3 17.4-2.1 25.5 .2V334.8l-38.7 10.4L126.7 386.6 64.9 403.2c-17.1 4.6-34.6-5.6-39.2-22.6L13.3 334.2c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9c-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5c-11 2.9-20.8 8-29.2 14.7L8 252.8z"]
};
var faTruckCouch = faTruckRampCouch;
var faCannabis = {
  prefix: 'fas',
  iconName: 'cannabis',
  icon: [512, 512, [], "f55f", "M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V417.2l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"]
};
var faCirclePlay = {
  prefix: 'fas',
  iconName: 'circle-play',
  icon: [512, 512, [61469, "play-circle"], "f144", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"]
};
var faPlayCircle = faCirclePlay;
var faArrowUpRightAndArrowDownLeftFromCenter = {
  prefix: 'fas',
  iconName: 'arrow-up-right-and-arrow-down-left-from-center',
  icon: [512, 512, [], "e0a0", "M352 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L297.4 169.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H352zM214.6 297.4c-12.5-12.5-32.8-12.5-45.3 0L64 402.7V352c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3L214.6 342.6c12.5-12.5 12.5-32.8 0-45.3z"]
};
var faTablets = {
  prefix: 'fas',
  iconName: 'tablets',
  icon: [640, 512, [], "f490", "M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7c-7.9 5.2-8.5 16.2-1.8 22.9L591.4 248.8c6.7 6.7 17.8 6.2 22.9-1.8zM567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8c-16.3 25-25.7 54.9-25.7 87c0 88.4 71.6 160 160 160c32.1 0 61.9-9.4 87-25.7zM301.5 368H18.5c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5zm0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5H301.5z"]
};
var fa360Degrees = {
  prefix: 'fas',
  iconName: '360-degrees',
  icon: [640, 512, [], "e2dc", "M640 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H96L38.4 204.8c-7.3 9.7-8.4 22.7-3 33.5S51.9 256 64 256H80c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32H90.5c-8.5 0-16.6-3.4-22.6-9.4L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l13.3 13.3c18 18 42.4 28.1 67.9 28.1H96c53 0 96-43 96-96V304c0-47-29-87.3-70.1-103.9l63.7-84.9c7.3-9.7 8.4-22.7 3-33.5S172.1 64 160 64H32zm448 80c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm96 224V144c0-44.2-35.8-80-80-80s-80 35.8-80 80V368c0 44.2 35.8 80 80 80s80-35.8 80-80zM288 160c0-17.7 14.3-32 32-32s32-14.3 32-32s-14.3-32-32-32c-53 0-96 43-96 96V288c0 .1 0 .2 0 .2V368c0 44.2 35.8 80 80 80s80-35.8 80-80V272c0-44.2-35.8-80-80-80c-5.5 0-10.8 .6-16 1.6V160zm0 112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V272z"]
};
var faEthernet = {
  prefix: 'fas',
  iconName: 'ethernet',
  icon: [512, 512, [], "f796", "M0 224V416c0 17.7 14.3 32 32 32H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448V160c0-17.7-14.3-32-32-32H384V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z"]
};
var faEuroSign = {
  prefix: 'fas',
  iconName: 'euro-sign',
  icon: [320, 512, [8364, "eur", "euro"], "f153", "M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3 .1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H60.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8V248c0-2.7 .1-5.4 .2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48.1z"]
};
var faEur = faEuroSign;
var faEuro = faEuroSign;
var faChair = {
  prefix: 'fas',
  iconName: 'chair',
  icon: [448, 512, [129681], "f6c0", "M248 48V256h48V58.7c23.9 13.8 40 39.7 40 69.3V256h48V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288H48z"]
};
var faCircleCheck = {
  prefix: 'fas',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faCheckCircle = faCircleCheck;
var faSquareDashedCirclePlus = {
  prefix: 'fas',
  iconName: 'square-dashed-circle-plus',
  icon: [576, 512, [], "e5c2", "M96 32C43 32 0 75 0 128v32H64V128c0-17.7 14.3-32 32-32h32V32H96zM0 192V320H64V192H0zM64 352H0v32c0 53 43 96 96 96h32V416H96c-17.7 0-32-14.3-32-32V352zM384 128v70.6c15.3-4.3 31.4-6.6 48-6.6c5.4 0 10.7 .2 16 .7V128c0-53-43-96-96-96H320V96h32c17.7 0 32 14.3 32 32zM160 480H296.2c-15.3-18.5-26.9-40.2-33.6-64H160v64zm0-384H288V32H160V96zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMoneySimpleFromBracket = {
  prefix: 'fas',
  iconName: 'money-simple-from-bracket',
  icon: [640, 512, [], "e313", "M64 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 43 43 0 96 0H544c53 0 96 43 96 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7-14.3-32-32-32H96C78.3 64 64 78.3 64 96zm64 0l384 0 0 352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64l0-352zM320 352c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80z"]
};
var faBat = {
  prefix: 'fas',
  iconName: 'bat',
  icon: [576, 512, [], "f6b5", "M235.6 52.8l10.8 14.4c6 8.1 15.5 12.8 25.6 12.8h32c10.1 0 19.6-4.7 25.6-12.8l10.8-14.4c2.3-3 5.8-4.8 9.6-4.8c5.8 0 10.8 4.1 11.8 9.8l19 101.4L452.6 125c16.2-7.7 35.5-3.6 47.1 10C548.9 192.4 576 265.6 576 341.2v37.6c0 9.7-10.2 16-18.9 11.7l-63.8-31.9c-7.5-3.7-16.6-1.1-20.9 6.1l-29.8 49.7c-5.4 8.9-17.7 10.4-25 3.1l-36.6-36.6c-6.8-6.8-18.1-6.1-24 1.6l-56.2 73.1c-6.4 8.3-19 8.3-25.4 0l-56.2-73.1c-5.9-7.7-17.2-8.4-24-1.6l-36.6 36.6c-7.4 7.4-19.7 5.8-25-3.1l-29.8-49.7c-4.3-7.2-13.4-9.8-20.9-6.1L18.9 390.5c-8.7 4.3-18.9-2-18.9-11.7V341.2C0 265.6 27.1 192.4 76.3 135c11.6-13.6 30.9-17.7 47.1-10l71.8 34.2 19-101.4c1.1-5.7 6-9.8 11.8-9.8c3.8 0 7.4 1.8 9.6 4.8z"]
};
var faCircleStop = {
  prefix: 'fas',
  iconName: 'circle-stop',
  icon: [512, 512, [62094, "stop-circle"], "f28d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"]
};
var faStopCircle = faCircleStop;
var faHeadSideHeadphones = {
  prefix: 'fas',
  iconName: 'head-side-headphones',
  icon: [512, 512, [], "f8c2", "M256 0V0c95.2 0 174.2 69.3 189.4 160.1c2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2C0 122.8 67.4 36.9 160 9.3V86.6c0 12.4-7.4 23.3-17.4 30.5C114.4 137.4 96 170.6 96 208c0 61.9 50.1 112 112 112s112-50.1 112-112c0-37.4-18.4-70.6-46.6-90.9c-10-7.2-17.4-18.2-17.4-30.5V0zM240 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faPhoneRotary = {
  prefix: 'fas',
  iconName: 'phone-rotary',
  icon: [512, 512, [9742], "f8d3", "M0 141.3c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1V176c0 17.7-14.3 32-32 32H437.7c-13.1 0-24.9-8-29.7-20.1l-19.4-48.6c-2.9-7.3-8.4-13.2-15.7-16c-18.6-7-59.5-19.3-116.8-19.3s-98.2 12.3-116.8 19.3c-7.3 2.8-12.8 8.7-15.7 16L104 187.9C99.2 200 87.4 208 74.3 208H32c-17.7 0-32-14.3-32-32V141.3zM32 432V401c0-11.1 2.9-22.1 8.4-31.8l101.1-177C153 172.3 174.2 160 197.1 160H314.9c23 0 44.2 12.3 55.6 32.2l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8v31c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48zM328 312a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"]
};
var faCompassDrafting = {
  prefix: 'fas',
  iconName: 'compass-drafting',
  icon: [512, 512, ["drafting-compass"], "f568", "M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192h0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496V440.6c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDraftingCompass = faCompassDrafting;
var faPlateWheat = {
  prefix: 'fas',
  iconName: 'plate-wheat',
  icon: [512, 512, [], "e55a", "M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zM400 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm80 160v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320H484.2c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4z"]
};
var faCalendarCircleMinus = {
  prefix: 'fas',
  iconName: 'calendar-circle-minus',
  icon: [576, 512, [], "e46f", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3V192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faChopsticks = {
  prefix: 'fas',
  iconName: 'chopsticks',
  icon: [640, 512, [], "e3f7", "M368 0c-15.3 0-29 7.2-37.7 18.3L3.4 486.1c-5.5 6.9-4.3 17 2.7 22.5s17 4.2 22.5-2.7L405.7 77.7C412.2 69.5 416 59.2 416 48c0-26.5-21.5-48-48-48zM131.9 506.4c5.8 6.7 15.9 7.5 22.6 1.7L623.2 148.4c10.3-8.8 16.8-21.9 16.8-36.4c0-26.5-21.5-48-48-48c-11.9 0-22.8 4.4-31.2 11.6L133.6 483.9c-6.7 5.8-7.5 15.8-1.7 22.6z"]
};
var faCarWrench = {
  prefix: 'fas',
  iconName: 'car-wrench',
  icon: [512, 512, ["car-mechanic"], "f5e3", "M468.9 104H456l-.5 0c-.7 0-1.4-.1-2.1-.1C441.3 102.5 432 92.4 432 80s9.3-22.5 21.3-23.9c.7-.1 1.4-.1 2.1-.1l.5 0h12.9 17.6c10.8 0 18.4-10.6 12.5-19.6c-3.6-5.5-7.8-10.5-12.5-14.9c-4.2-3.9-8.8-7.4-13.8-10.3C470.8 10 468.9 9 466.9 8C456.4 2.9 444.5 0 432 0c-29.1 0-54.5 15.5-68.5 38.7c-3.3 5.4-8.9 9.3-15.3 9.3H163.8c-6.4 0-12-3.8-15.3-9.3C134.5 15.5 109.1 0 80 0C67.5 0 55.6 2.9 45.1 8c-2 1-3.9 2-5.8 3.1c-5 2.9-9.6 6.4-13.8 10.3c-4.7 4.4-9 9.4-12.5 14.9C7 45.4 14.7 56 25.5 56H43.1 56l.5 0c.7 0 1.4 .1 2.1 .1C70.7 57.5 80 67.6 80 80s-9.3 22.5-21.3 23.9c-.7 .1-1.4 .1-2.1 .1l-.5 0H43.1 25.5C14.7 104 7 114.6 12.9 123.6c3.6 5.5 7.8 10.5 12.5 14.9c4.2 3.9 8.8 7.4 13.8 10.3c1.9 1.1 3.8 2.2 5.8 3.1c10.6 5.1 22.4 8 34.9 8c29.1 0 54.5-15.5 68.5-38.7c3.3-5.4 8.9-9.3 15.3-9.3H348.2c6.4 0 12 3.8 15.3 9.3c14 23.2 39.5 38.7 68.5 38.7c12.5 0 24.4-2.9 34.9-8c2-1 3.9-2 5.8-3.1c5-2.9 9.6-6.4 13.8-10.3c4.7-4.4 9-9.4 12.5-14.9c5.9-9-1.7-19.6-12.5-19.6H468.9zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCarMechanic = faCarWrench;
var faIcicles = {
  prefix: 'fas',
  iconName: 'icicles',
  icon: [512, 512, [], "f7ad", "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"]
};
var faPersonShelter = {
  prefix: 'fas',
  iconName: 'person-shelter',
  icon: [512, 512, [], "e54f", "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faNeuter = {
  prefix: 'fas',
  iconName: 'neuter',
  icon: [384, 512, [9906], "f22c", "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"]
};
var faIdBadge = {
  prefix: 'fas',
  iconName: 'id-badge',
  icon: [384, 512, [], "f2c1", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faKazoo = {
  prefix: 'fas',
  iconName: 'kazoo',
  icon: [640, 512, [], "f8c7", "M514 128h94c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H514c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16H224c-3 0-6-.4-9-1.3l-192-56C9.4 322.7 0 310.2 0 296V216c0-14.2 9.4-26.7 23-30.7l192-56c2.9-.8 5.9-1.3 9-1.3H382c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16zm30 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM427.3 212.7L448 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L470.6 256l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L448 278.6l-20.7 20.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L425.4 256l-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faMarker = {
  prefix: 'fas',
  iconName: 'marker',
  icon: [512, 512, [], "f5a1", "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"]
};
var faBinBottles = {
  prefix: 'fas',
  iconName: 'bin-bottles',
  icon: [640, 512, [], "e5f5", "M152 0h80c13.3 0 24 10.7 24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16V24c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96H256c24.9 0 47.6 9.5 64.6 25c1.1 1 2.2 2 3.2 3.1C341.3 141.5 352 165.5 352 192H32zm352 0c0-40.7-19-76.9-48.6-100.4c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7V24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V66.1c5.6 1.3 11.1 3.2 16.4 5.7L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5H384zM0 256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32L583.8 457c-4.5 31.5-31.5 55-63.4 55h-401c-31.8 0-58.9-23.4-63.4-55L32 288c-17.7 0-32-14.3-32-32z"]
};
var faFaceLaughBeam = {
  prefix: 'fas',
  iconName: 'face-laugh-beam',
  icon: [512, 512, [128513, "laugh-beam"], "f59a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM217.6 212.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faLaughBeam = faFaceLaughBeam;
var faSquareArrowDownLeft = {
  prefix: 'fas',
  iconName: 'square-arrow-down-left',
  icon: [448, 512, [], "e261", "M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zM288 368c13.3 0 24-10.7 24-24s-10.7-24-24-24H193.9L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V344c0 13.3 10.7 24 24 24H288z"]
};
var faBatteryBolt = {
  prefix: 'fas',
  iconName: 'battery-bolt',
  icon: [576, 512, [], "f376", "M80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80h92.2c-12.9-14.5-16.1-35.6-7.2-53.5l5.3-10.5H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H219.2l80-64H80zM464 352H324.8l-80 64H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H371.8c13 14.5 16.1 35.6 7.2 53.5L373.7 160H464c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16zM346.1 115.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L193.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H297.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"]
};
var faTreeLarge = {
  prefix: 'fas',
  iconName: 'tree-large',
  icon: [448, 512, [], "f7dd", "M62 169.4L210.6 5.9C214 2.1 218.9 0 224 0s10 2.1 13.4 5.9L386 169.4c3.9 4.2 6 9.8 6 15.5c0 12.7-10.3 23.1-23.1 23.1H344l75.5 105.7c2.9 4.1 4.5 9 4.5 14.1c0 13.4-10.9 24.2-24.2 24.2H368l76.2 122c2.5 4 3.8 8.5 3.8 13.2c0 13.7-11.1 24.9-24.9 24.9H24.9C11.1 512 0 500.9 0 487.1c0-4.7 1.3-9.2 3.8-13.2L80 352H48.2C34.8 352 24 341.1 24 327.8c0-5 1.6-10 4.5-14.1L104 208H79.1C66.3 208 56 197.7 56 184.9c0-5.7 2.1-11.3 6-15.5z"]
};
var faHelicopterSymbol = {
  prefix: 'fas',
  iconName: 'helicopter-symbol',
  icon: [512, 512, [], "e502", "M445.3 224H510C495.6 108.2 403.8 16.4 288 2V66.7C368.4 80.1 431.9 143.6 445.3 224zM510 288H445.3C431.9 368.4 368.4 431.9 288 445.4V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V445.4C143.6 431.9 80.1 368.4 66.7 288H2zm0-64H66.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H208V160z"]
};
var faAperture = {
  prefix: 'fas',
  iconName: 'aperture',
  icon: [512, 512, [], "e2df", "M256 0c4 0 7.9 .1 11.9 .3c11.3 .5 17.5 12.9 11.8 22.8L177.5 200c-6.2 10.7-21.6 10.7-27.7 0L82.8 84.1c-3.6-6.3-2.6-14.3 2.9-19.2C130.9 24.5 190.6 0 256 0zM0 256c0-50.9 14.9-98.3 40.5-138.2c6.1-9.5 19.9-8.6 25.6 1.2L168.2 296c6.2 10.7-1.5 24-13.9 24H20.5c-7.3 0-13.7-4.9-15.2-12.1C1.8 291.2 0 273.8 0 256zM193.7 492c-3.6 6.3-11.1 9.4-18 7.1C111.8 478 59 432.5 28.5 373.6C23.3 363.5 31 352 42.3 352H246.8c12.3 0 20 13.3 13.9 24l-67 116zM256 512c-4 0-7.9-.1-11.9-.3c-11.3-.5-17.5-12.9-11.8-22.8L334.5 312c6.2-10.7 21.6-10.7 27.7 0l66.9 115.9c3.6 6.3 2.6 14.3-2.9 19.2C381.1 487.5 321.4 512 256 512zM512 256c0 50.9-14.9 98.3-40.5 138.2c-6.1 9.5-19.9 8.6-25.6-1.2L343.8 216c-6.2-10.7 1.5-24 13.9-24H491.5c7.3 0 13.7 4.9 15.2 12.1c3.5 16.8 5.3 34.1 5.3 51.9zM318.3 20c3.6-6.3 11.1-9.4 18-7.1C400.2 34 453 79.5 483.5 138.4c5.2 10.1-2.5 21.6-13.8 21.6H265.2c-12.3 0-20-13.3-13.9-24l67-116z"]
};
var faUniversalAccess = {
  prefix: 'fas',
  iconName: 'universal-access',
  icon: [512, 512, [], "f29a", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6V235.5c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faGearComplex = {
  prefix: 'fas',
  iconName: 'gear-complex',
  icon: [512, 512, [], "e5e9", "M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1 .6 266.1 0 256 0c-11.1 0-22.1 .7-32.8 2.1c-10.3 1.3-18 9.7-19.3 20l-2.9 23.1c-.8 6.4-5.4 11.6-11.5 13.7c-9.6 3.2-19 7.2-27.9 11.7c-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4c-16.6 13-31.5 28-44.4 44.7c-6.3 8.2-5.9 19.6 .5 27.8l14.2 18.3c4 5.1 4.4 12 1.5 17.8c-4.4 8.8-8.2 17.9-11.3 27.4c-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6 .6 21.1 1.9 31.4c1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4 .8 11.7 5.4 13.7 11.6c3.1 9.5 6.9 18.7 11.3 27.5c2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8c12.9 16.7 27.8 31.7 44.4 44.7c8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5c9 4.6 18.3 8.5 27.9 11.7c6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20c10.7 1.4 21.7 2.1 32.8 2.1c10.1 0 20.1-.6 29.9-1.7c10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8c10-3.2 19.7-7.2 29-11.8c5.8-2.9 12.7-2.4 17.8 1.5L385 457.9c8.2 6.4 19.6 6.8 27.8 .5c2.8-2.2 5.5-4.4 8.2-6.7L451.7 421c1.8-2.2 3.6-4.4 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18c4.8-9.4 9-19.3 12.3-29.5c2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4c.2-1.7 .4-3.5 .6-5.2V230.1c-.2-1.7-.4-3.5-.6-5.2c-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6c-3.4-10.2-7.5-20.1-12.3-29.5c-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7 .4-27.9c-1.8-2.2-3.6-4.4-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7c-8.2-6.4-19.6-5.9-27.8 .5L366.7 68.3c-5.1 4-12.1 4.4-17.8 1.5c-9.3-4.6-19-8.6-29-11.8c-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zM256 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faFileMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'file-magnifying-glass',
  icon: [384, 512, ["file-search"], "f865", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm16 304c0 17.8-4.9 34.5-13.3 48.9L297 391.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-38.4-38.4C210.4 395.2 193.8 400 176 400c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm-96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faFileSearch = faFileMagnifyingGlass;
var faUpRight = {
  prefix: 'fas',
  iconName: 'up-right',
  icon: [384, 512, [], "e2be", "M336 80H96c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l72 72L11.3 340.7C4.1 347.9 0 357.8 0 368s4.1 20.1 11.3 27.3l41.4 41.4C59.9 443.9 69.8 448 80 448s20.1-4.1 27.3-11.3L241.4 302.6l72 72c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V112c0-17.7-14.3-32-32-32z"]
};
var faCircleChevronUp = {
  prefix: 'fas',
  iconName: 'circle-chevron-up',
  icon: [512, 512, ["chevron-circle-up"], "f139", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"]
};
var faChevronCircleUp = faCircleChevronUp;
var faUserPolice = {
  prefix: 'fas',
  iconName: 'user-police',
  icon: [448, 512, [], "e333", "M230.1 .8l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6L368 102.5v8.4c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 131.7 80 121.6 80 110.9v-8.4L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40c4-1.1 8.2-1.1 12.2 0zM227 48.6c-1.9-.8-4-.8-5.9 0L189 61.4c-3 1.2-5 4.2-5 7.4c0 17.2 7 46.1 36.9 58.6c2 .8 4.2 .8 6.2 0C257 114.9 264 86 264 68.8c0-3.3-2-6.2-5-7.4L227 48.6zM98.1 168.8c39.1 15 81.5 23.2 125.9 23.2s86.8-8.2 125.9-23.2c1.4 7.5 2.1 15.3 2.1 23.2c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-7.9 .7-15.7 2.1-23.2zM134.4 352c2.8 0 5.5 .9 7.7 2.6l72.3 54.2c5.7 4.3 13.5 4.3 19.2 0l72.3-54.2c2.2-1.7 4.9-2.6 7.7-2.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352zM352 408c-3.5 0-6.5 2.2-7.6 5.5L339 430.2l-17.4 0c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9L331 454.8l-5.4 16.6c-1.1 3.3 .1 6.9 2.9 9s6.6 2 9.4 0L352 470.1l14.1 10.3c2.8 2 6.6 2.1 9.4 0s4-5.7 2.9-9L373 454.8l14.1-10.2c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5l-17.4 0-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5z"]
};
var faLariSign = {
  prefix: 'fas',
  iconName: 'lari-sign',
  icon: [384, 512, [], "e1c8", "M144 32c17.7 0 32 14.3 32 32V96.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V161c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32V188.1C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"]
};
var faVolcano = {
  prefix: 'fas',
  iconName: 'volcano',
  icon: [512, 512, [127755], "f770", "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1H235.1c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"]
};
var faTeddyBear = {
  prefix: 'fas',
  iconName: 'teddy-bear',
  icon: [576, 512, [], "e3cf", "M154.7 103.7C138.7 93.9 128 76.2 128 56c0-30.9 25.1-56 56-56c24.2 0 44.7 15.3 52.6 36.7C252.5 33.5 269.8 32 288 32s35.5 1.5 51.4 4.7C347.3 15.3 367.8 0 392 0c30.9 0 56 25.1 56 56c0 20.2-10.7 37.9-26.7 47.7c1.8 7.4 2.7 15.5 2.7 24.3c0 70.7-60.9 128-136 128s-136-57.3-136-128c0-8.8 .9-16.8 2.7-24.3zM240 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64c0-26.5-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48zm-32-8c0 13.3-14.3 24-32 24s-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24zM50.3 178.3c20.8-16.4 51-12.8 67.4 8L143.5 219c73.7 93.5 215.4 93.5 289.1 0l25.8-32.7c16.4-20.8 46.6-24.4 67.4-8s24.4 46.6 8 67.4l-25.8 32.7c-17.7 22.4-37.9 41.3-59.9 56.7V400h16.6c3.9-27.1 27.2-48 55.4-48c30.9 0 56 25.1 56 56c0 2.7-.2 5.4-.6 8l-13 53.3c-5.8 23.8-26.3 40.9-50.4 42.6v.1h-4H480 96 68 64v-.1c-24.1-1.7-44.6-18.8-50.4-42.6L.6 416c-.4-2.6-.6-5.3-.6-8c0-30.9 25.1-56 56-56c28.2 0 51.6 20.9 55.4 48H128V335.1c-22-15.4-42.3-34.3-59.9-56.7L42.3 245.7c-16.4-20.8-12.8-51 8-67.4zM256 352c-35.3 0-64 28.7-64 64H384c0-35.3-28.7-64-64-64H256z"]
};
var faStocking = {
  prefix: 'fas',
  iconName: 'stocking',
  icon: [384, 512, [], "f7d5", "M96 0C78.3 0 64 14.3 64 32V64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zm0 128V238.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9v2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5V128H96z"]
};
var faPersonWalkingDashedLineArrowRight = {
  prefix: 'fas',
  iconName: 'person-walking-dashed-line-arrow-right',
  icon: [640, 512, [], "e553", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM392 320c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440z"]
};
var faImageSlash = {
  prefix: 'fas',
  iconName: 'image-slash',
  icon: [640, 512, [], "e1b7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zm120 94.1c5.3-2 11.1-3.2 17.2-3.2c26.5 0 48 21.5 48 48c0 2-.1 4-.4 6L158.8 99.2zM328.1 231.9l20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5L499.4 366.1 328.1 231.9zM221.7 272.5c.3-.4 .6-.7 1-1.1L64 146.4V416c0 35.3 28.7 64 64 64H487.4l-81.2-64H320 248 152c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l88-104z"]
};
var faMaskSnorkel = {
  prefix: 'fas',
  iconName: 'mask-snorkel',
  icon: [576, 512, [], "e3b7", "M544 32c-17.7 0-32 14.3-32 32v96h64V64c0-17.7-14.3-32-32-32zM512 367.4c0 44.5-36.1 80.6-80.6 80.6c-39.4 0-73-28.5-79.5-67.4l-.3-1.9c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.3 1.9C300.4 460.9 360.7 512 431.4 512C511.3 512 576 447.3 576 367.4V192H512V367.4zM64 64C28.7 64 0 92.7 0 128v96c0 35.3 28.7 64 64 64h79.7c28.6 0 53.7-18.9 61.5-46.4l3.4-11.7c4.4-15.5 26.3-15.5 30.8 0l3.4 11.7c7.8 27.5 33 46.4 61.5 46.4H384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"]
};
var faSmoke = {
  prefix: 'fas',
  iconName: 'smoke',
  icon: [640, 512, [], "f760", "M172.3 194.3c-9.2-1.5-18.7-2.3-28.3-2.3c-29.2 0-56.7 7.1-80.9 19.6C43.7 189.2 32 160 32 128C32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298 32 320 32c44.3 0 83.4 22.5 106.4 56.8c-11.5 7.3-22 16-31.2 25.9C372.7 102.8 347.2 96 320 96c-66.5 0-123.5 40.6-147.7 98.3zm276.3 62.5C419.5 217.5 372.7 192 320 192c-31.5 0-60.9 9.1-85.7 24.9c-9.6-5.8-19.8-10.6-30.5-14.5C224 158.5 268.4 128 320 128c31.3 0 60.1 11.3 82.3 30c22.4-37.1 63.1-62 109.7-62c70.7 0 128 57.3 128 128c0 42.2-20.4 79.6-51.9 102.9C563.1 284.5 516.9 256 464 256c-5.2 0-10.3 .3-15.4 .8zM144 512C64.5 512 0 447.5 0 368s64.5-144 144-144c34.5 0 66.1 12.1 90.9 32.3C257.6 236.2 287.4 224 320 224c49.1 0 91.8 27.7 113.2 68.3c9.8-2.8 20.1-4.3 30.8-4.3c61.9 0 112 50.1 112 112s-50.1 112-112 112H144z"]
};
var faSterlingSign = {
  prefix: 'fas',
  iconName: 'sterling-sign',
  icon: [320, 512, [163, "gbp", "pound-sign"], "f154", "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1C104.1 390 112 361.5 112 332.5V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"]
};
var faGbp = faSterlingSign;
var faPoundSign = faSterlingSign;
var faBatteryExclamation = {
  prefix: 'fas',
  iconName: 'battery-exclamation',
  icon: [576, 512, [], "e0b0", "M208 96v64H80c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H198.7c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80H208zM464 416H345.3c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H336V96H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80zM272 96c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zM240 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faViruses = {
  prefix: 'fas',
  iconName: 'viruses',
  icon: [640, 512, [], "e076", "M192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSquarePersonConfined = {
  prefix: 'fas',
  iconName: 'square-person-confined',
  icon: [448, 512, [], "e577", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7V248z"]
};
var faUserTie = {
  prefix: 'fas',
  iconName: 'user-tie',
  icon: [448, 512, [], "f508", "M224 256A128 128 0 1 1 224 0a128 128 0 1 1 0 256zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3c70.1 17.6 121.9 81 121.9 156.4c0 17-13.8 30.7-30.7 30.7H285.5c-2.1 0-4-.4-5.8-1.1l.3 1.1H168l.3-1.1c-1.8 .7-3.8 1.1-5.8 1.1H30.7C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4c8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9z"]
};
var faArrowDownLong = {
  prefix: 'fas',
  iconName: 'arrow-down-long',
  icon: [384, 512, ["long-arrow-down"], "f175", "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"]
};
var faLongArrowDown = faArrowDownLong;
var faTentArrowDownToLine = {
  prefix: 'fas',
  iconName: 'tent-arrow-down-to-line',
  icon: [640, 512, [], "e57e", "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H159.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448h76.8L384 320V448z"]
};
var faCertificate = {
  prefix: 'fas',
  iconName: 'certificate',
  icon: [512, 512, [], "f0a3", "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.3-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"]
};
var faCrystalBall = {
  prefix: 'fas',
  iconName: 'crystal-ball',
  icon: [448, 512, [], "e362", "M448 224c0 62.7-25.7 119.3-67.2 160H67.2C25.7 343.3 0 286.7 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM152.5 84.3l-9.8 26.4-26.4 9.8c-7 2.6-7 12.4 0 15l26.4 9.8 9.8 26.4c2.6 7 12.4 7 15 0l9.8-26.4 26.4-9.8c7-2.6 7-12.4 0-15l-26.4-9.8-9.8-26.4c-2.6-7-12.4-7-15 0zm159 48c-2.6-7-12.4-7-15 0l-18.4 49.8-49.8 18.4c-7 2.6-7 12.4 0 15l49.8 18.4 18.4 49.8c2.6 7 12.4 7 15 0l18.4-49.8 49.8-18.4c7-2.6 7-12.4 0-15l-49.8-18.4-18.4-49.8zm98.9 331.8c3.7 5.1 5.6 11.3 5.6 17.6c0 16.7-13.6 30.3-30.3 30.3H62.3C45.6 512 32 498.4 32 481.7c0-6.3 2-12.5 5.6-17.6L72 416H376l34.4 48.1z"]
};
var faReplyAll = {
  prefix: 'fas',
  iconName: 'reply-all',
  icon: [576, 512, ["mail-reply-all"], "f122", "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3 .9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V288h32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352V64z"]
};
var faMailReplyAll = faReplyAll;
var faSuitcase = {
  prefix: 'fas',
  iconName: 'suitcase',
  icon: [512, 512, [129523], "f0f2", "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z"]
};
var faPersonSkating = {
  prefix: 'fas',
  iconName: 'person-skating',
  icon: [448, 512, ["skating"], "f7c5", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H319.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V349.3l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
var faSkating = faPersonSkating;
var faStarShooting = {
  prefix: 'fas',
  iconName: 'star-shooting',
  icon: [512, 512, [127776], "e036", "M313 41L265 89c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L279 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM170.4 157.4c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94zM505 199c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zM505 41L361 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faBinaryLock = {
  prefix: 'fas',
  iconName: 'binary-lock',
  icon: [640, 512, [], "e33d", "M322.7 6c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H256c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H336V32c0-10.3-4.9-19.9-13.3-26zM98.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16C5.1 311.2-3.9 329.4 1.7 346.1s23.7 25.8 40.5 20.2l5.9-2V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H80h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V320c0-10.3-4.9-19.9-13.3-26zM64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 64h64v96H64V64zM192 352v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H256c-35.3 0-64 28.7-64 64zm128 0v96H256V352h64zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faFilterCircleDollar = {
  prefix: 'fas',
  iconName: 'filter-circle-dollar',
  icon: [576, 512, ["funnel-dollar"], "f662", "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
var faFunnelDollar = faFilterCircleDollar;
var faCameraRetro = {
  prefix: 'fas',
  iconName: 'camera-retro',
  icon: [512, 512, [128247], "f083", "M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"]
};
var faCircleArrowDown = {
  prefix: 'fas',
  iconName: 'circle-arrow-down',
  icon: [512, 512, ["arrow-circle-down"], "f0ab", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM127 281c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 393c-9.4 9.4-24.6 9.4-33.9 0L127 281z"]
};
var faArrowCircleDown = faCircleArrowDown;
var faCommentPen = {
  prefix: 'fas',
  iconName: 'comment-pen',
  icon: [512, 512, ["comment-edit"], "f4ae", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm84.8-293c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L272.6 170 287.5 155c14.7-14.7 38.6-14.7 53.3 0zM178.1 264.5L250 192.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faCommentEdit = faCommentPen;
var faFileImport = {
  prefix: 'fas',
  iconName: 'file-import',
  icon: [512, 512, ["arrow-right-to-file"], "f56f", "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z"]
};
var faArrowRightToFile = faFileImport;
var faBanjo = {
  prefix: 'fas',
  iconName: 'banjo',
  icon: [512, 512, [129685], "f8a3", "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41L286 180.7c-20.6-13.9-44.3-23.4-70-27V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.7c-28.5 4.1-54.6 15.3-76.6 31.7l-1.2-1.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l1.2 1.2C41 241.4 29.8 267.5 25.7 296H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h1.7c4.1 28.5 15.3 54.6 31.7 76.6l-1.2 1.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l1.2-1.2c22 16.5 48.2 27.7 76.6 31.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-1.7c28.5-4.1 54.6-15.3 76.6-31.7l1.2 1.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-1.2-1.2c16.5-22 27.7-48.2 31.7-76.6H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.7c-3.7-25.7-13.1-49.5-27-70l76.1-76.1 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM192 208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM155.3 308.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48z"]
};
var faSquareArrowUpRight = {
  prefix: 'fas',
  iconName: 'square-arrow-up-right',
  icon: [448, 512, ["external-link-square"], "f14c", "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"]
};
var faExternalLinkSquare = faSquareArrowUpRight;
var faLightEmergencyOn = {
  prefix: 'fas',
  iconName: 'light-emergency-on',
  icon: [640, 512, [], "e420", "M69.3 36c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM597.3 76c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24H88c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H552zM320 32c-88.4 0-160 71.6-160 160V352H480V192c0-88.4-71.6-160-160-160zM240 192c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80zM96 416v32c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32z"]
};
var faKerning = {
  prefix: 'fas',
  iconName: 'kerning',
  icon: [640, 512, [], "f86f", "M454.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-240 480c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l240-480zM60.6 113.7C52.7 97.9 33.5 91.5 17.7 99.4S-4.5 126.5 3.4 142.3l128 256c5.4 10.8 16.5 17.7 28.6 17.7s23.2-6.8 28.6-17.7l128-256c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L160 312.4 60.6 113.7zm320 284.6L403.8 352H556.2l23.2 46.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-128-256C503.2 102.8 492.1 96 480 96s-23.2 6.8-28.6 17.7l-128 256c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3zM480 199.6L524.2 288H435.8L480 199.6z"]
};
var faBoxOpen = {
  prefix: 'fas',
  iconName: 'box-open',
  icon: [640, 512, [], "f49e", "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128h2.2z"]
};
var faSquareF = {
  prefix: 'fas',
  iconName: 'square-f',
  icon: [448, 512, [], "e270", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24z"]
};
var faScroll = {
  prefix: 'fas',
  iconName: 'scroll',
  icon: [576, 512, [128220], "f70e", "M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z"]
};
var faSpa = {
  prefix: 'fas',
  iconName: 'spa',
  icon: [576, 512, [], "f5bb", "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480H288 267.9C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"]
};
var faArrowLeftFromLine = {
  prefix: 'fas',
  iconName: 'arrow-left-from-line',
  icon: [448, 512, [8612, "arrow-from-right"], "f344", "M384 96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96zM9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224 288 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-178.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"]
};
var faArrowFromRight = faArrowLeftFromLine;
var faStrawberry = {
  prefix: 'fas',
  iconName: 'strawberry',
  icon: [512, 512, [], "e32b", "M481.5 1.9c12.2 5.2 17.8 19.3 12.6 31.5c-13.4 31.2-36.9 59-56.3 78.7c32.8 1.8 57.4 18 68.2 26.6c4 3.2 6 8.1 6 13.2s-2 10-6 13.3C495 174.4 469.7 192 440 192c-40 0-55.3-15.3-80-40s-40-40-40-80c0-29.7 17.6-55 26.7-66c3.3-4 8.2-6 13.3-6s10 2 13.2 6C382.3 17.4 400 44.3 400 80c0 .7 0 1.4 0 2.1c.7-.7 1.4-1.3 2-2c18.2-18.2 37.7-41.7 47.9-65.5c5.2-12.2 19.3-17.8 31.5-12.6zM0 336C0 160 96.2 64 192.2 64c32.7 .1 65.3 12.6 90.3 37.5l128 128c25 25 37.5 57.8 37.5 90.5c0 96-96 192-272 192C48 512 0 464 0 336zM172.8 172.8c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm87.3 2.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm32-96c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm-224-96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zM108.8 364.8c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7z"]
};
var faLocationPinLock = {
  prefix: 'fas',
  iconName: 'location-pin-lock',
  icon: [512, 512, [], "e51f", "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c17.7 0 32 14.3 32 32v48H368V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faPause = {
  prefix: 'fas',
  iconName: 'pause',
  icon: [320, 512, [9208], "f04c", "M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"]
};
var faClockEightThirty = {
  prefix: 'fas',
  iconName: 'clock-eight-thirty',
  icon: [512, 512, [], "e346", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V300.8L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faPlaneEngines = {
  prefix: 'fas',
  iconName: 'plane-engines',
  icon: [576, 512, [9992, "plane-alt"], "f3de", "M576 256c0-35-59.5-64-93.7-64l-116.6 0-37.2-65.1C342 123.1 352 110.7 352 96c0-17.7-14.3-32-32-32l-27.4 0L265.2 16.1C259.5 6.2 248.9 0 237.4 0L181.2 0c-10.6 0-18.3 10.2-15.4 20.4l49 171.6L112 192 68.8 134.4c-3-4-7.8-6.4-12.8-6.4l-42 0c-7.8 0-14 6.3-14 14c0 1.3 .2 2.6 .5 3.9l22.7 79.3C9.8 229 0 241.4 0 256s9.8 27 23.2 30.8L.5 366.1c-.4 1.3-.5 2.6-.5 3.9c0 7.8 6.3 14 14 14l42 0c5 0 9.8-2.4 12.8-6.4L112 320l102.9 0-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4l56.2 0c11.5 0 22.1-6.2 27.8-16.1L292.6 448l27.4 0c17.7 0 32-14.3 32-32c0-14.7-10-27.1-23.5-30.9L365.7 320l116.6 0c34.2 0 93.7-28 93.7-64z"]
};
var faPlaneAlt = faPlaneEngines;
var faHillAvalanche = {
  prefix: 'fas',
  iconName: 'hill-avalanche',
  icon: [576, 512, [], "e507", "M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9zM480 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87z"]
};
var faTemperatureEmpty = {
  prefix: 'fas',
  iconName: 'temperature-empty',
  icon: [320, 512, ["temperature-0", "thermometer-0", "thermometer-empty"], "f2cb", "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM160 0C98.1 0 48 50.2 48 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faTemperature0 = faTemperatureEmpty;
var faThermometer0 = faTemperatureEmpty;
var faThermometerEmpty = faTemperatureEmpty;
var faBomb = {
  prefix: 'fas',
  iconName: 'bomb',
  icon: [512, 512, [128163], "f1e2", "M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"]
};
var faGaugeLow = {
  prefix: 'fas',
  iconName: 'gauge-low',
  icon: [512, 512, ["tachometer-alt-slow"], "f627", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-.6 0-1.3 0-1.9 0L190 142.3c-5.3-12.1-19.5-17.6-31.6-12.3s-17.6 19.5-12.3 31.6l64.1 145.7C198.9 318.9 192 334.6 192 352c0 35.3 28.7 64 64 64zM128 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAltSlow = faGaugeLow;
var faRegistered = {
  prefix: 'fas',
  iconName: 'registered',
  icon: [512, 512, [174], "f25d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z"]
};
var faTrashCanPlus = {
  prefix: 'fas',
  iconName: 'trash-can-plus',
  icon: [448, 512, [], "e2ac", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM200 408c0 13.3 10.7 24 24 24s24-10.7 24-24V344h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V232c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faAddressCard = {
  prefix: 'fas',
  iconName: 'address-card',
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faContactCard = faAddressCard;
var faVcard = faAddressCard;
var faScaleUnbalancedFlip = {
  prefix: 'fas',
  iconName: 'scale-unbalanced-flip',
  icon: [640, 512, ["balance-scale-right"], "f516", "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288L128 163.8 55.6 288H200.4zM128 384C65.1 384 12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384zm382.8-92.2L438.4 416H583.3L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"]
};
var faBalanceScaleRight = faScaleUnbalancedFlip;
var faGlobeSnow = {
  prefix: 'fas',
  iconName: 'globe-snow',
  icon: [448, 512, [], "f7a3", "M448 224c0 62.7-25.7 119.3-67.2 160H256V352h64c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 256H288c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64v32H67.2C25.7 343.3 0 286.7 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM256 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM20.3 474.2L61.1 416H386.9l40.8 58.2c5.1 7.3 5.8 16.9 1.6 24.8S416.9 512 408 512H40c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8z"]
};
var faSubscript = {
  prefix: 'fas',
  iconName: 'subscript',
  icon: [512, 512, [], "f12c", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320z"]
};
var faDiamondTurnRight = {
  prefix: 'fas',
  iconName: 'diamond-turn-right',
  icon: [512, 512, ["directions"], "f5eb", "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"]
};
var faDirections = faDiamondTurnRight;
var faIntegral = {
  prefix: 'fas',
  iconName: 'integral',
  icon: [320, 512, [], "f667", "M216 64c-13.3 0-24 10.7-24 24V424c0 48.6-39.4 88-88 88s-88-39.4-88-88v-8c0-17.7 14.3-32 32-32s32 14.3 32 32v8c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-48.6 39.4-88 88-88s88 39.4 88 88v8c0 17.7-14.3 32-32 32s-32-14.3-32-32V88c0-13.3-10.7-24-24-24z"]
};
var faBurst = {
  prefix: 'fas',
  iconName: 'burst',
  icon: [512, 512, [], "e4dc", "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"]
};
var faHouseLaptop = {
  prefix: 'fas',
  iconName: 'house-laptop',
  icon: [640, 512, ["laptop-house"], "e066", "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64V416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304V448H544V304H352zm-48-16c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H544 352 304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32V288z"]
};
var faLaptopHouse = faHouseLaptop;
var faFaceTired = {
  prefix: 'fas',
  iconName: 'face-tired',
  icon: [512, 512, [128555, "tired"], "f5c8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faTired = faFaceTired;
var faMoneyBills = {
  prefix: 'fas',
  iconName: 'money-bills',
  icon: [640, 512, [], "e1f3", "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64H160V256zM224 96c0 35.3-28.7 64-64 64V96h64zM576 256v64H512c0-35.3 28.7-64 64-64zM512 96h64v64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"]
};
var faBlindsRaised = {
  prefix: 'fas',
  iconName: 'blinds-raised',
  icon: [512, 512, [], "f8fd", "M32 0C14.3 0 0 14.3 0 32C0 43.9 6.5 54.2 16.1 59.8L1.2 100.6c-.8 2.2-1.2 4.6-1.2 7C0 118.9 9.1 128 20.4 128H128V64h32v64H491.6c11.3 0 20.4-9.1 20.4-20.4c0-2.4-.4-4.7-1.2-7L495.9 59.8C505.5 54.2 512 43.9 512 32c0-17.7-14.3-32-32-32H32zM144 512c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V224H491.9c11.1 0 20.1-9 20.1-20.1c0-2.6-.5-5.1-1.4-7.5L496 160H160v64H128V160H16L1.4 196.4c-1 2.4-1.4 4.9-1.4 7.5C0 215 9 224 20.1 224H128V418.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
var faSmog = {
  prefix: 'fas',
  iconName: 'smog',
  icon: [640, 512, [], "f75f", "M32 144c0 79.5 64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24z"]
};
var faUfoBeam = {
  prefix: 'fas',
  iconName: 'ufo-beam',
  icon: [576, 512, [], "e048", "M184 152s24 40 104 40s104-40 104-40c0-48-33.3-104-104-104s-104 56-104 104zm-42.6-40.4C159.1 47.2 218.1 0 288 0s128.9 47.2 146.6 111.6C519.2 131.1 576 167 576 208c0 61.9-128.9 112-288 112S0 269.9 0 208c0-41 56.8-76.9 141.4-96.4zM120 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM74.3 325.7l4.2-8.9c14.3 5.6 29.7 10.6 46 15l-6.8 14.5-72 152c-5.7 12-20 17.1-32 11.4s-17.1-20-11.4-32l72-152zm384 20.6l-6.8-14.5c16.3-4.4 31.7-9.4 46-15l4.2 8.9 72 152c5.7 12 .6 26.3-11.4 32s-26.3 .6-32-11.4l-72-152z"]
};
var faCircleCaretUp = {
  prefix: 'fas',
  iconName: 'circle-caret-up',
  icon: [512, 512, ["caret-circle-up"], "f331", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-368c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H152c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"]
};
var faCaretCircleUp = faCircleCaretUp;
var faUserVneckHairLong = {
  prefix: 'fas',
  iconName: 'user-vneck-hair-long',
  icon: [448, 512, [], "e463", "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224 70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128zm61.3 199.1l53.9 71.8c6.4 8.5 19.2 8.5 25.6 0l53.9-71.8c3.2-4.3 8.4-6.7 13.7-6.2C385.1 329.7 448 398.2 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3C0 398.2 62.9 329.7 143.7 321c5.3-.6 10.5 1.9 13.7 6.2z"]
};
var faSquareALock = {
  prefix: 'fas',
  iconName: 'square-a-lock',
  icon: [576, 512, [], "e44d", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H320V384c-9.1 0-17.7-5.2-21.8-13.9l-12-26.1H161.8l-12 26.1c-5.6 12-19.8 17.3-31.8 11.7s-17.3-19.8-11.7-31.8l96-208c3.9-8.5 12.4-13.9 21.8-13.9s17.9 5.4 21.8 13.9l82.4 178.6c5.6-10 13.9-18.3 23.8-24V272c0-56.4 41.7-103.1 96-110.9V96c0-35.3-28.7-64-64-64H64zM224 209.3L184 296h80l-40-86.7zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faCrutch = {
  prefix: 'fas',
  iconName: 'crutch',
  icon: [512, 512, [], "f7f7", "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"]
};
var faGasPumpSlash = {
  prefix: 'fas',
  iconName: 'gas-pump-slash',
  icon: [640, 512, [], "f5f4", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-72.2-56.6C569.5 397.9 576 379.7 576 360V224 192 168 154.5c0-17-6.7-33.3-18.7-45.3L480 32c-8.8-8.8-23.2-8.8-32 0s-8.8 23.2 0 32l32 32v64c0 29.8 20.4 54.9 48 62V360c0 8.5-2.7 16.4-7.2 22.9L384 275.7V64c0-35.3-28.7-64-64-64H160c-30.9 0-56.7 21.9-62.7 51L38.8 5.1zM96 171.6V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32V398.5L96 171.6z"]
};
var faFontAwesome = {
  prefix: 'fas',
  iconName: 'font-awesome',
  icon: [448, 512, [62501, 62694, "font-awesome-flag", "font-awesome-logo-full"], "f2b4", "M448 48V384c-63.1 22.5-82.3 32-119.5 32c-62.8 0-86.6-32-149.3-32c-20.6 0-36.6 3.6-51.2 8.2v-64c14.6-4.6 30.6-8.2 51.2-8.2c62.7 0 86.5 32 149.3 32c20.4 0 35.6-3 55.5-9.3v-208c-19.9 6.3-35.1 9.3-55.5 9.3c-62.8 0-86.6-32-149.3-32c-50.8 0-74.9 20.6-115.2 28.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32s32 14.3 32 32V76.7c40.3-8 64.4-28.7 115.2-28.7c62.7 0 86.5 32 149.3 32c37.1 0 56.4-9.5 119.5-32z"]
};
var faFontAwesomeFlag = faFontAwesome;
var faFontAwesomeLogoFull = faFontAwesome;
var faCloudArrowUp = {
  prefix: 'fas',
  iconName: 'cloud-arrow-up',
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"]
};
var faCloudUpload = faCloudArrowUp;
var faCloudUploadAlt = faCloudArrowUp;
var faPalette = {
  prefix: 'fas',
  iconName: 'palette',
  icon: [512, 512, [127912], "f53f", "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faTransporter4 = {
  prefix: 'fas',
  iconName: 'transporter-4',
  icon: [512, 512, [], "e2a5", "M224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 160zM56.7 358.6L64 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 416 6.6 408.7C2.7 407.6 0 404.1 0 400s2.7-7.6 6.6-8.7L32 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 480c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H296 216 128c-17.7 0-32-14.3-32-32z"]
};
var faChartMixedUpCircleCurrency = {
  prefix: 'fas',
  iconName: 'chart-mixed-up-circle-currency',
  icon: [576, 512, [], "e5d8", "M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.8L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L480 105v39c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H400zM192 224c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32zM64 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L374 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L396.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z"]
};
var faObjectsAlignRight = {
  prefix: 'fas',
  iconName: 'objects-align-right',
  icon: [512, 512, [], "e3bf", "M512 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM336 64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48L48 224c-26.5 0-48-21.5-48-48V112C0 85.5 21.5 64 48 64l288 0zm0 224c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H336z"]
};
var faArrowsTurnRight = {
  prefix: 'fas',
  iconName: 'arrows-turn-right',
  icon: [448, 512, [], "e4c0", "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160H128c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V224C0 153.3 57.3 96 128 96H338.7L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96H242.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"]
};
var faVest = {
  prefix: 'fas',
  iconName: 'vest',
  icon: [448, 512, [], "e085", "M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6V128 54.3 48c0-26.5-21.5-48-48-48h-4.5c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0H112C85.5 0 64 21.5 64 48v6.3V128v17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48H176c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"]
};
var faPig = {
  prefix: 'fas',
  iconName: 'pig',
  icon: [640, 512, [128022], "f706", "M513.5 32c8 0 14.5 6.5 14.5 14.5V78c0 19.7-9 37.8-23.6 49.7c6.4 4.9 12.7 10.1 18.6 15.7c17.6-15.9 28.5-38.6 29-63.3h40c8.8 0 16 7.2 16 16v16c0 32.8-24.6 59.8-56.3 63.5l6.8 9C570 200 585 212.5 602.2 221.1L608 224h8c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24H572.5c-22.2 21.2-49.7 36.2-79.8 43.3l-13 45.5C475.8 470.5 463.3 480 449 480H416c-17.7 0-32-14.3-32-32V416H320 272v32c0 17.7-14.3 32-32 32H207c-14.3 0-26.8-9.5-30.8-23.2L155 382.4C110.3 358 80 310.5 80 256V240H47.4C21.2 240 0 218.8 0 192.6c0-21.8 14.8-40.7 35.9-46l8.2-2c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-8.2 2c-6.9 1.7-11.7 7.9-11.7 15c0 8.5 6.9 15.4 15.4 15.4H83.2C98 135 162.6 80 240 80H362.4c14.5 0 28.8 1.3 42.7 3.9c8.1-19.5 25.4-34.4 47-39.1l58.4-12.5c1-.2 2-.3 3-.3zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
var faInboxFull = {
  prefix: 'fas',
  iconName: 'inbox-full',
  icon: [512, 512, [], "e1ba", "M58.9 80.5C66 52 91.6 32 121 32H391c29.4 0 55 20 62.1 48.5l57 227.9c1.3 5.1 1.9 10.3 1.9 15.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V323.9c0-5.2 .6-10.4 1.9-15.5l57-227.9zM391 96H121L73 288h51.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H439L391 96zM176 144H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 80H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleEnvelope = {
  prefix: 'fas',
  iconName: 'circle-envelope',
  icon: [512, 512, ["envelope-circle"], "e10c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v9.3L264.7 255.6c-2.7 1.2-5.7 1.9-8.7 1.9s-5.9-.6-8.7-1.9L128 201.3V192zm149.9 92.7L384 236.5V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V236.5l106.1 48.3c6.9 3.1 14.3 4.8 21.9 4.8s15-1.6 21.9-4.8z"]
};
var faEnvelopeCircle = faCircleEnvelope;
var faTrianglePersonDigging = {
  prefix: 'fas',
  iconName: 'triangle-person-digging',
  icon: [640, 512, ["construction"], "f85d", "M354.5 51.8C347.3 39.5 334.2 32 320 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S89.7 480 104 480H536c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368zM216.9 304.7l15.6 9.8 64 40c4.7 2.9 7.5 8.1 7.5 13.6v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V376.9l-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8zm112-45.7l19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1H384c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8c22.7 0 43.2 13.8 51.6 34.9zM288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faConstruction = faTrianglePersonDigging;
var faFerry = {
  prefix: 'fas',
  iconName: 'ferry',
  icon: [576, 512, [], "e4ea", "M224 0H352c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32zM96 128H480c17.7 0 32 14.3 32 32V283.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9H375.6c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9H183.9c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32zm32 64v96H448V192H128zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faBullseyeArrow = {
  prefix: 'fas',
  iconName: 'bullseye-arrow',
  icon: [512, 512, [127919], "f648", "M335.2 244.7c.5 3.7 .8 7.5 .8 11.3c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80c3.8 0 7.6 .3 11.3 .8l31.2-31.2L293.7 117c-12-3.3-24.7-5-37.7-5c-79.5 0-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144c0-13.1-1.7-25.7-5-37.7l-28.6-4.8-31.2 31.2zm110.1-20.8c1.8 10.4 2.7 21.1 2.7 32.1c0 106-86 192-192 192S64 362 64 256S150 64 256 64c10.9 0 21.6 .9 32.1 2.7l9.3-9.3 43.1-43.1C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5l-43.1 43.1-9.3 9.3zm-80.2-43.1l50.7 8.4c10.2 1.7 20.6-1.6 27.9-8.9l51.2-51.2c8.1-8.1 5.3-21.9-5.4-26.2L432 80 409 22.5c-4.3-10.7-18-13.5-26.2-5.4L331.6 68.4c-7.3 7.3-10.6 17.7-8.9 27.9l8.4 50.7L239 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l92.1-92.1z"]
};
var faArrowsDownToPeople = {
  prefix: 'fas',
  iconName: 'arrows-down-to-people',
  icon: [640, 512, [], "e4b9", "M144 0c-13.3 0-24 10.7-24 24V142.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zM360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"]
};
var faSeedling = {
  prefix: 'fas',
  iconName: 'seedling',
  icon: [512, 512, [127793, "sprout"], "f4d8", "M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64H64c123.7 0 224 100.3 224 224v32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96z"]
};
var faSprout = faSeedling;
var faClockSeven = {
  prefix: 'fas',
  iconName: 'clock-seven',
  icon: [512, 512, [], "e350", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V248.7l-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faLeftRight = {
  prefix: 'fas',
  iconName: 'left-right',
  icon: [512, 512, [8596, "arrows-alt-h"], "f337", "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"]
};
var faArrowsAltH = faLeftRight;
var faBoxesPacking = {
  prefix: 'fas',
  iconName: 'boxes-packing',
  icon: [640, 512, [], "e4c7", "M256 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H256V48zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176zm352 80V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256H352zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
};
var faCircleArrowLeft = {
  prefix: 'fas',
  iconName: 'circle-arrow-left',
  icon: [512, 512, ["arrow-circle-left"], "f0a8", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z"]
};
var faArrowCircleLeft = faCircleArrowLeft;
var faFlashlight = {
  prefix: 'fas',
  iconName: 'flashlight',
  icon: [640, 512, [128294], "f8b8", "M576 416h32c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H576V416zM544 97.7C449.1 107.9 384 160 384 160H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H384s65.1 52.1 160 62.3V97.7zM224 256c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32z"]
};
var faGroupArrowsRotate = {
  prefix: 'fas',
  iconName: 'group-arrows-rotate',
  icon: [512, 512, [], "e4f6", "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4V163.2c0-5.7-4.7-10.4-10.4-10.4H169.9c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"]
};
var faBowlFood = {
  prefix: 'fas',
  iconName: 'bowl-food',
  icon: [512, 512, [], "e4c6", "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"]
};
var faSquare9 = {
  prefix: 'fas',
  iconName: 'square-9',
  icon: [448, 512, [], "e25e", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 272a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C305.8 287.2 320 256.4 320 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z"]
};
var faCandyCane = {
  prefix: 'fas',
  iconName: 'candy-cane',
  icon: [512, 512, [], "f786", "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"]
};
var faArrowDownWideShort = {
  prefix: 'fas',
  iconName: 'arrow-down-wide-short',
  icon: [576, 512, ["sort-amount-asc", "sort-amount-down"], "f160", "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"]
};
var faSortAmountAsc = faArrowDownWideShort;
var faSortAmountDown = faArrowDownWideShort;
var faSquareDollar = {
  prefix: 'fas',
  iconName: 'square-dollar',
  icon: [448, 512, ["dollar-square", "usd-square"], "f2e9", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM244.8 133.6v14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7V133.6c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"]
};
var faDollarSquare = faSquareDollar;
var faUsdSquare = faSquareDollar;
var faPhoneArrowRight = {
  prefix: 'fas',
  iconName: 'phone-arrow-right',
  icon: [512, 512, [], "e5be", "M117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24zM425 7l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H312c-13.3 0-24-10.7-24-24s10.7-24 24-24H430.1L391 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faHandHoldingSeedling = {
  prefix: 'fas',
  iconName: 'hand-holding-seedling',
  icon: [576, 512, [], "f4bf", "M96 14.5C96 6.5 102.5 0 110.5 0H160c88.4 0 160 71.6 160 160v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V160H241.5C161.1 160 96 94.9 96 14.5zm384 0C480 89 424.1 150.3 352 159c-.2-44.9-15.9-86.2-42-118.8C338.2 15.2 375.3 0 416 0h49.5c8 0 14.5 6.5 14.5 14.5zm88.2 321.7c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faMessageCheck = {
  prefix: 'fas',
  iconName: 'message-check',
  icon: [512, 512, ["comment-alt-check"], "f4a2", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm369 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 153z"]
};
var faCommentAltCheck = faMessageCheck;
var faCloudBolt = {
  prefix: 'fas',
  iconName: 'cloud-bolt',
  icon: [512, 512, [127785, "thunderstorm"], "f76c", "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320H352h64c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"]
};
var faThunderstorm = faCloudBolt;
var faChartLineUpDown = {
  prefix: 'fas',
  iconName: 'chart-line-up-down',
  icon: [512, 512, [], "e5d7", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm313.4 57.4L288 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l112-112 18.7 18.7c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6V96.2v-.3V80c0-8.8-7.2-16-16-16H374.6C362.1 64 352 74.1 352 86.6c0 6 2.4 11.8 6.6 16l18.7 18.7zm64 141.3l-18.7 18.7-34.7-34.7-45.3 45.3 34.7 34.7-18.7 18.7c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6l89.4 0c8.8 0 16-7.2 16-16V278.6c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6z"]
};
var faTextSlash = {
  prefix: 'fas',
  iconName: 'text-slash',
  icon: [640, 512, ["remove-format"], "f87d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1L272.9 311 243.3 416z"]
};
var faRemoveFormat = faTextSlash;
var faWatch = {
  prefix: 'fas',
  iconName: 'watch',
  icon: [384, 512, [8986], "f2e1", "M112 0H272c26.5 0 48 21.5 48 48V72.2C283.7 46.8 239.6 32 192 32s-91.7 14.8-128 40.2V48C64 21.5 85.5 0 112 0zM64 464V439.8c36.3 25.3 80.4 40.2 128 40.2s91.7-14.8 128-40.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48zM0 256a192 192 0 1 1 384 0A192 192 0 1 1 0 256zM192 152c-13.3 0-24 10.7-24 24v80c0 8 4 15.5 10.7 20l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L216 243.2V176c0-13.3-10.7-24-24-24z"]
};
var faCircleDownLeft = {
  prefix: 'fas',
  iconName: 'circle-down-left',
  icon: [512, 512, [], "e107", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM160 198.6V336c0 8.8 7.2 16 16 16H313.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L296 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7C322 146 317.1 144 312 144s-10 2-13.7 5.7L232 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6z"]
};
var faText = {
  prefix: 'fas',
  iconName: 'text',
  icon: [448, 512, [], "f893", "M64 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V80C0 53.5 21.5 32 48 32H224 400c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H256l0 320h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H144c-17.7 0-32-14.3-32-32s14.3-32 32-32h48l0-320H64z"]
};
var faProjector = {
  prefix: 'fas',
  iconName: 'projector',
  icon: [640, 512, [], "f8d6", "M440 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM281 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L281 39zM585 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L495 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56-56zm-9 119H512c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64l9.9 39.8C77.5 502 90.3 512 105 512h14c14.7 0 27.5-10 31-24.2L160 448H320c26.7 20.1 60 32 96 32c24.4 0 47.5-5.5 68.2-15.2l5.7 23c3.6 14.2 16.4 24.2 31 24.2h14c14.7 0 27.5-10 31-24.2L576 448c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64zM416 224a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM64 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faFaceSmileWink = {
  prefix: 'fas',
  iconName: 'face-smile-wink',
  icon: [512, 512, [128521, "smile-wink"], "f4da", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faSmileWink = faFaceSmileWink;
var faTombstoneBlank = {
  prefix: 'fas',
  iconName: 'tombstone-blank',
  icon: [448, 512, [129702, "tombstone-alt"], "f721", "M224 0C118 0 32 86 32 192V416H416V192C416 86 330 0 224 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faTombstoneAlt = faTombstoneBlank;
var faChessKingPiece = {
  prefix: 'fas',
  iconName: 'chess-king-piece',
  icon: [256, 512, ["chess-king-alt"], "f440", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H60.2C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384H196L180 256h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48z"]
};
var faChessKingAlt = faChessKingPiece;
var faCircle6 = {
  prefix: 'fas',
  iconName: 'circle-6',
  icon: [512, 512, [], "e0f3", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C174.2 224.8 160 255.6 160 288z"]
};
var faLeft = {
  prefix: 'fas',
  iconName: 'left',
  icon: [448, 512, ["arrow-alt-left"], "f355", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 96 184 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-184 0 0 96c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-160-160z"]
};
var faArrowAltLeft = faLeft;
var faFileWord = {
  prefix: 'fas',
  iconName: 'file-word',
  icon: [384, 512, [], "f1c2", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"]
};
var faFilePowerpoint = {
  prefix: 'fas',
  iconName: 'file-powerpoint',
  icon: [384, 512, [], "f1c4", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76H160v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V368 264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28H160v56h44z"]
};
var faSquareDown = {
  prefix: 'fas',
  iconName: 'square-down',
  icon: [448, 512, [11015, "arrow-alt-square-down"], "f350", "M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zm39.1-185.4l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3H272V160c0-17.7-14.3-32-32-32H208c-17.7 0-32 14.3-32 32v96H118.3C106 256 96 266 96 278.3c0 6.2 2.6 12.1 7.1 16.3z"]
};
var faArrowAltSquareDown = faSquareDown;
var faObjectsAlignCenterVertical = {
  prefix: 'fas',
  iconName: 'objects-align-center-vertical',
  icon: [512, 512, [], "e3bd", "M64 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V232h64V144c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v88h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H448v88c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V280H224V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64V80z"]
};
var faArrowsLeftRight = {
  prefix: 'fas',
  iconName: 'arrows-left-right',
  icon: [512, 512, ["arrows-h"], "f07e", "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"]
};
var faArrowsH = faArrowsLeftRight;
var faHouseLock = {
  prefix: 'fas',
  iconName: 'house-lock',
  icon: [640, 512, [], "e510", "M384 480c0 11.7 3.1 22.6 8.6 32H392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4V480zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faCloudArrowDown = {
  prefix: 'fas',
  iconName: 'cloud-arrow-down',
  icon: [640, 512, [62337, "cloud-download", "cloud-download-alt"], "f0ed", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"]
};
var faCloudDownload = faCloudArrowDown;
var faCloudDownloadAlt = faCloudArrowDown;
var faWreath = {
  prefix: 'fas',
  iconName: 'wreath',
  icon: [448, 512, [], "f7e2", "M122.2 42.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 32.6-24.4 59.6-56 63.5v-3.7c0-28.6-23.2-51.8-51.8-51.8c-7.2 0-14.4 1.5-21 4.5L224 381l-55.2-24.5c-6.6-2.9-13.8-4.5-21-4.5C119.2 352 96 375.2 96 403.8v3.7c-31.6-3.9-56-30.9-56-63.5c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6zM203 142.4c-5.7 6-13.6 9.4-21.9 9.1c-16.6-.6-30.2 13-29.6 29.6c.3 8.3-3 16.3-9.1 21.9c-12.1 11.3-12.1 30.6 0 41.9c6 5.7 9.4 13.6 9.1 21.9c-.6 16.6 13 30.2 29.6 29.6c8.3-.3 16.3 3 21.9 9.1c11.3 12.1 30.6 12.1 41.9 0c5.7-6 13.6-9.4 21.9-9.1c16.6 .6 30.2-13 29.6-29.6c-.3-8.3 3-16.3 9.1-21.9c12.1-11.3 12.1-30.6 0-41.9c-6-5.7-9.4-13.6-9.1-21.9c.6-16.6-13-30.2-29.6-29.6c-8.3 .3-16.3-3-21.9-9.1c-11.3-12.1-30.6-12.1-41.9 0zM128 403.8c0-10.9 8.9-19.8 19.8-19.8c2.8 0 5.5 .6 8 1.7L224 416l68.2-30.3c2.5-1.1 5.3-1.7 8-1.7c10.9 0 19.8 8.9 19.8 19.8v88.4c0 10.9-8.9 19.8-19.8 19.8c-2.8 0-5.5-.6-8-1.7L224 480l-68.2 30.3c-2.5 1.1-5.3 1.7-8 1.7c-10.9 0-19.8-8.9-19.8-19.8V403.8z"]
};
var faChildren = {
  prefix: 'fas',
  iconName: 'children',
  icon: [640, 512, [], "e4e1", "M160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM88 480V400H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H152v80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 0a64 64 0 1 1 0 128A64 64 0 1 1 480 0zm-8 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H472z"]
};
var faMeterDroplet = {
  prefix: 'fas',
  iconName: 'meter-droplet',
  icon: [640, 512, [], "e1ea", "M256 512c53.7 0 103.5-16.5 144.6-44.7C390 447.2 384 424.3 384 400c0-23.6 5.8-46.9 16.9-67.8l75.3-141.2c4.9-9.2 12.1-16.7 20.6-22.1C461.2 70.4 366.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm120.5 46.1L429.2 347.3C420.5 363.5 416 381.6 416 400c0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.4-4.5-36.5-13.2-52.7L551.5 206.1c-4.6-8.7-13.7-14.1-23.5-14.1s-18.9 5.4-23.5 14.1z"]
};
var faChalkboard = {
  prefix: 'fas',
  iconName: 'chalkboard',
  icon: [576, 512, ["blackboard"], "f51b", "M96 32C60.7 32 32 60.7 32 96V384H96V96l384 0V384h64V96c0-35.3-28.7-64-64-64H96zM224 384v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"]
};
var faBlackboard = faChalkboard;
var faUserLargeSlash = {
  prefix: 'fas',
  iconName: 'user-large-slash',
  icon: [640, 512, ["user-alt-slash"], "f4fa", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM545.5 512H528L284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H545.3l.3 0z"]
};
var faUserAltSlash = faUserLargeSlash;
var faSignalStrong = {
  prefix: 'fas',
  iconName: 'signal-strong',
  icon: [640, 512, ["signal-4"], "f68f", "M480 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V128zM352 224c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224zM192 288c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416z"]
};
var faSignal4 = faSignalStrong;
var faLollipop = {
  prefix: 'fas',
  iconName: 'lollipop',
  icon: [512, 512, [127853, "lollypop"], "e424", "M210.8 334.8C265.3 314.2 304 261.6 304 200v-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 53-43 96-96 96h-8C94.6 296 48 249.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8zM0 192C0 298 86 384 192 384c41.5 0 79.9-13.1 111.2-35.5L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L348.5 303.2C370.9 271.9 384 233.5 384 192C384 86 298 0 192 0S0 86 0 192z"]
};
var faLollypop = faLollipop;
var faListTree = {
  prefix: 'fas',
  iconName: 'list-tree',
  icon: [512, 512, [], "e1d2", "M24 48C10.7 48 0 58.7 0 72v48c0 13.3 10.7 24 24 24V256 384c0 30.9 25.1 56 56 56h48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24H80c-4.4 0-8-3.6-8-8V280h56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24H72V144c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H24zM160 96c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM288 256c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0 160c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32z"]
};
var faEnvelopeOpen = {
  prefix: 'fas',
  iconName: 'envelope-open',
  icon: [512, 512, [62135], "f2b6", "M64 208.1L256 65.9 448 208.1v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5V208.1zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"]
};
var faDrawCircle = {
  prefix: 'fas',
  iconName: 'draw-circle',
  icon: [512, 512, [], "f5ed", "M472.1 196.7c-20.8-76-80.7-135.9-156.7-156.7C305.8 16.5 282.8 0 256 0s-49.8 16.5-59.3 39.9c-76 20.8-135.9 80.7-156.7 156.7C16.5 206.2 0 229.2 0 256s16.5 49.8 39.9 59.3c20.8 76 80.7 135.9 156.7 156.7c9.5 23.4 32.5 39.9 59.3 39.9s49.8-16.5 59.3-39.9c76-20.8 135.9-80.7 156.7-156.7c23.4-9.5 39.9-32.5 39.9-59.3s-16.5-49.8-39.9-59.3zM408 206c-14.7 11.7-24 29.8-24 50s9.4 38.3 24 50c-15.8 48.2-53.9 86.2-102 102c-11.7-14.7-29.8-24-50-24s-38.3 9.4-50 24c-48.2-15.8-86.2-53.9-102-102c14.7-11.7 24-29.8 24-50s-9.4-38.3-24-50c15.8-48.2 53.9-86.2 102-102c11.7 14.7 29.8 24 50 24s38.3-9.4 50-24c48.2 15.8 86.2 53.9 102 102z"]
};
var faCatSpace = {
  prefix: 'fas',
  iconName: 'cat-space',
  icon: [640, 512, [], "e001", "M576 160c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-32.5 12.1-62.1 32-84.7V160c0 53 43 96 96 96s96-43 96-96V75.3c19.9 22.6 32 52.2 32 84.7zM411.2 89.6L381.8 50.4C401.1 38.7 423.8 32 448 32s46.9 6.7 66.2 18.4L484.8 89.6c-3 4-7.8 6.4-12.8 6.4H424c-5 0-9.8-2.4-12.8-6.4zM480 316.8C553 302 608 237.4 608 160C608 71.6 536.4 0 448 0S288 71.6 288 160c0 11.7 1.3 23.1 3.6 34.1c-54.9 8.1-102.2 39.5-131.6 83.8V192.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1C50.4 94.1 34.4 106.5 32.2 124s10.2 33.5 27.8 35.7l7.9 1c16 2 28 15.6 28 31.8V416c0 53 43 96 96 96H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H280L416 339.2V480c0 17.7 14.3 32 32 32s32-14.3 32-32V316.8zM400 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM231.5 12.3c-2.6-7-12.4-7-15 0L205.8 41.1c-.8 2.2-2.5 3.9-4.7 4.7L172.3 56.5c-7 2.6-7 12.4 0 15l28.8 10.7c2.2 .8 3.9 2.5 4.7 4.7l10.7 28.8c2.6 7 12.4 7 15 0l10.7-28.8c.8-2.2 2.5-3.9 4.7-4.7l28.8-10.7c7-2.6 7-12.4 0-15L246.9 45.8c-2.2-.8-3.9-2.5-4.7-4.7L231.5 12.3z"]
};
var faHandshakeSimpleSlash = {
  prefix: 'fas',
  iconName: 'handshake-simple-slash',
  icon: [640, 512, ["handshake-alt-slash"], "e05f", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM0 176V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6L41.2 128.5C17.9 131.8 0 151.8 0 176z"]
};
var faHandshakeAltSlash = faHandshakeSimpleSlash;
var faRabbitRunning = {
  prefix: 'fas',
  iconName: 'rabbit-running',
  icon: [576, 512, ["rabbit-fast"], "f709", "M460.7 39.3l-2.2-2.1c-4.7-4.6-11.5-6.4-17.9-4.7s-11.4 6.6-13.1 13l-.8 2.9c-3.3 11.8-5.1 23.7-5.5 35.6c24.3 20.6 42.9 47.8 53.3 78.8c-8.2-1.9-16.5-2.9-25-2.9c-.6 0-1.1 0-1.7 0c-18.4-44-56.5-77.4-103.6-89.3l-3.4-.9c-6.2-1.6-12.9-.6-18.5 2.6c-10.8 6.2-15.6 19.5-11.2 31.1c14.9 39.5 44.3 71.4 81.4 89.7c-3.7 6.6-6.4 14-7.6 21.8L279.7 154.9C248.8 137.3 213.8 128 178.2 128c-32.3 0-62.2 16.8-78.9 44.4C89 159.9 73.4 152 56 152c-30.9 0-56 25.1-56 56s25.1 56 56 56c11.3 0 21.8-3.3 30.6-9.1c4.9 17.2 14.5 33.1 28.4 45.9L257.2 431.2C269 442 284.4 448 300.4 448H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 335.2 320V340.5c0-42.9-28.4-80.5-69.6-92.3l-30.8-8.8c-8.5-2.4-13.4-11.3-11-19.8s11.3-13.4 19.8-11l30.8 8.8c55 15.7 92.8 65.9 92.8 123.1v15.7l56-32.4 6.4-3.7H515.7c33.3 0 60.3-27 60.3-60.3c0-18.1-8.2-35.3-22.2-46.7l-34.6-28.2c-4.6-3.7-9.4-7.1-14.5-10c8.4-49.3-7.8-100-43.9-135.5zm-318.5 382c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9l46-30.7-48.6-44.5-32.9 22zM480 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faRabbitFast = faRabbitRunning;
var faMemoPad = {
  prefix: 'fas',
  iconName: 'memo-pad',
  icon: [448, 512, [], "e1da", "M0 64V96H448V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64zm0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V128H0zm96 96c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16z"]
};
var faMattressPillow = {
  prefix: 'fas',
  iconName: 'mattress-pillow',
  icon: [640, 512, [], "e525", "M256 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H256V64zm32 384H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288V448zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"]
};
var faAlarmPlus = {
  prefix: 'fas',
  iconName: 'alarm-plus',
  icon: [512, 512, [], "f844", "M14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4L14.9 146.4zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM352 25.4C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM256 176c-13.3 0-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24z"]
};
var faAlicorn = {
  prefix: 'fas',
  iconName: 'alicorn',
  icon: [640, 512, [], "f6b0", "M448 160v78.1V240h0c-.5 30-12.8 56.4-32 75.7V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V346.7c-4.1-.7-8.2-1.6-12.3-2.8l-84-24c.2 2.3 .3 4.6 .3 6.9c0 18.6-7.4 36.5-20.6 49.7l-12.7 12.7c-4.8 4.8-6.4 11.8-4.3 18.2l20.8 62.5c6.9 20.7-8.5 42.1-30.4 42.1H143.1c-13.8 0-26-8.8-30.4-21.9L95.3 437.7c-10.6-31.7-6.5-65.9 10-93.9c7.6-12.9 9.5-29.1 1.2-41.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4C54.6 230.8 48 242.6 48 256v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-44.6 33.2-81.5 76.3-87.2c13-21.4 35.2-36.5 61.1-40c3.8 15.3 9.2 29.8 16.5 43c11.3 20.4 27.4 37.7 49.9 49.8c6.3 3.4 13.1 6.4 20.3 8.8c-16.5-11.4-28.9-26-38.2-42.7C163.8 147.9 160 96.1 160 48c0-5.9 3.2-11.3 8.5-14.1s11.5-2.5 16.4 .8L320 124.8C321.7 55.6 378.4 0 448 0h16 16 64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-5.7c5.2 4.6 9.6 10 13.1 16h79.3c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8L560 90.7v64.8c0 22.1-13.4 41.9-33.9 50.1c-26.1 10.4-55.7-.9-68.3-26L448 160zm64-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faCommentQuestion = {
  prefix: 'fas',
  iconName: 'comment-question',
  icon: [512, 512, [], "e14b", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM169.8 149.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 248.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V234.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faGingerbreadMan = {
  prefix: 'fas',
  iconName: 'gingerbread-man',
  icon: [448, 512, [], "f79d", "M296.9 158.5c-5.2 6-1.2 17.5 6.7 17.5H368c35.3 0 64 28.7 64 64s-28.7 64-64 64H347.1c-19 0-29.4 22.2-17.2 36.7L385.2 407c22.6 27.2 19 67.5-8.2 90.1s-67.5 19-90.1-8.2l-45.6-54.8c-9-10.7-25.5-10.7-34.4 0L161.2 489c-22.6 27.2-63 30.8-90.1 8.2s-30.8-63-8.2-90.1l55.2-66.3c12.2-14.6 1.8-36.7-17.2-36.7H80c-35.3 0-64-28.7-64-64s28.7-64 64-64h64.4c7.9 0 11.9-11.5 6.7-17.5C136.7 141.7 128 119.9 128 96c0-53 43-96 96-96s96 43 96 96c0 23.9-8.7 45.7-23.1 62.5zM192 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faGuaraniSign = {
  prefix: 'fas',
  iconName: 'guarani-sign',
  icon: [384, 512, [], "e19a", "M192 0c-17.7 0-32 14.3-32 32V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32H224V132c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32zM160 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380V288h92c-11.6 45-47 80.4-92 92z"]
};
var faBurgerFries = {
  prefix: 'fas',
  iconName: 'burger-fries',
  icon: [640, 512, [], "e0cd", "M183.2 1.7c-5-2.5-10.8-2.2-15.6 .7S160 10.5 160 16V206.7l0 0v63.2c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2V31.8c-.1-6-3.5-11.4-8.8-14.1l-32-16zM128 14.7l-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6V14.7zM40.3 85.6L19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2H48c3.6 0 7 .4 10.2 1L40.3 85.6zM383.8 98.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8L346.2 85l-19 107.8c2-.3 4-.6 6.1-.7c11-6.5 23.3-12.3 37.1-17.2l13.4-76.1zM276.3 337.2c-11.8-10.4-19.5-25.3-20.2-42.1c-16.6 5.4-37.6 8.8-64.1 8.8c-91.7 0-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224H21.4C9.6 224 0 233.6 0 245.4c0 1.7 .2 3.4 .6 5.1l57.5 237C61.5 501.9 74.4 512 89.2 512H272c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8zm-8.5-82.9c.8-.6 1.6-1.1 2.4-1.7c4.1-6.6 9.4-14 16.1-21.6c.1-.3 .2-.6 .3-.9c.7-2.3 1.7-4.7 2.8-7L319.8 50.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2l-.2 1.4V261c4.8-2.1 8.7-4.4 11.8-6.6zm372.2 38c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5H612.5c15.2 0 27.5-12.3 27.5-27.5zM384 239.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm-16 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16H304z"]
};
var faMugTea = {
  prefix: 'fas',
  iconName: 'mug-tea',
  icon: [576, 512, [], "f875", "M144 64v50.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6V256c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V189.3c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6V64H384h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H416v32c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32h80zM416 256h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H416V256z"]
};
var faBorderTop = {
  prefix: 'fas',
  iconName: 'border-top',
  icon: [448, 512, [], "f855", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm64 96A32 32 0 1 1 0 160a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 352a32 32 0 1 1 64 0A32 32 0 1 1 0 352zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faArrowsRotate = {
  prefix: 'fas',
  iconName: 'arrows-rotate',
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"]
};
var faRefresh = faArrowsRotate;
var faSync = faArrowsRotate;
var faCircleBookOpen = {
  prefix: 'fas',
  iconName: 'circle-book-open',
  icon: [512, 512, ["book-circle"], "e0ff", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 336c-23.1 0-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5V346.1c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2C225 347.1 207.1 336 184 336zm144 0c-23.1 0-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5V346.1c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2C369 347.1 351.1 336 328 336z"]
};
var faBookCircle = faCircleBookOpen;
var faArrowsToDottedLine = {
  prefix: 'fas',
  iconName: 'arrows-to-dotted-line',
  icon: [448, 512, [], "e0a6", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H256V32zM201.4 329.4l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faFireExtinguisher = {
  prefix: 'fas',
  iconName: 'fire-extinguisher',
  icon: [512, 512, [129519], "f134", "M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104H224v34.8c37.8 18 64 56.5 64 101.2V384H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V56h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V416H288zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faGarageOpen = {
  prefix: 'fas',
  iconName: 'garage-open',
  icon: [640, 512, [], "e00b", "M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3zM194.1 320l-5.2 15c-17.2 9.5-28.9 27.9-28.9 49v96c0 17.7 14.3 32 32 32s32-14.3 32-32V464H416v16c0 17.7 14.3 32 32 32s32-14.3 32-32V384c0-21.1-11.7-39.5-28.9-49l-5.2-15H395l2.8 8H242.2l2.8-8H194.1zM240 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM512 224H128v64H512V224z"]
};
var faShelvesEmpty = {
  prefix: 'fas',
  iconName: 'shelves-empty',
  icon: [640, 512, [], "e246", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V192 448v32c0 17.7 14.3 32 32 32s32-14.3 32-32H576c0 17.7 14.3 32 32 32s32-14.3 32-32V448 192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V160H64V32zm0 192H576V416H64V224z"]
};
var faCruzeiroSign = {
  prefix: 'fas',
  iconName: 'cruzeiro-sign',
  icon: [448, 512, [], "e152", "M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V320v-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32v55.3V320v82.7C135.5 378 96 321.6 96 256z"]
};
var faWatchApple = {
  prefix: 'fas',
  iconName: 'watch-apple',
  icon: [384, 512, [], "e2cb", "M64 48H320c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48zM80 80C35.8 80 0 115.8 0 160V352c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80H80zM192 213.3a42.7 42.7 0 1 1 0 85.3 42.7 42.7 0 1 1 0-85.3zM213.3 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm74.7-160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 512H272c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48z"]
};
var faWatchCalculator = {
  prefix: 'fas',
  iconName: 'watch-calculator',
  icon: [384, 512, [], "f8f0", "M64 48H320c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48zM80 80C35.8 80 0 115.8 0 160V352c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80H80zm0 64H304c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16zm32 128a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM88 384a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM112 512H272c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48z"]
};
var faListDropdown = {
  prefix: 'fas',
  iconName: 'list-dropdown',
  icon: [512, 512, [], "e1cf", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 192V416H64V192H448zM436.7 96c7.1 0 10.7 8.6 5.7 13.7l-36.7 36.7c-3.1 3.1-8.2 3.1-11.3 0l-36.7-36.7c-5-5-1.5-13.7 5.7-13.7h73.4zM128 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H384c13.3 0 24-10.7 24-24s-10.7-24-24-24H128zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H384c13.3 0 24-10.7 24-24s-10.7-24-24-24H128z"]
};
var faCabinetFiling = {
  prefix: 'fas',
  iconName: 'cabinet-filing',
  icon: [448, 512, [128452], "f64b", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V240H0V64zM0 272H448V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V272zM128 128v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm0 256v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z"]
};
var faBurgerSoda = {
  prefix: 'fas',
  iconName: 'burger-soda',
  icon: [640, 512, [], "f858", "M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H333.4c14-8.2 30.1-15.4 48.6-20.9c1.3-3.5 2-7.2 2-11.1c0-17.7-14.3-32-32-32H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H249.3zM40 224L60.3 468c2.1 24.9 22.9 44 47.8 44H272c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8c-12.4-10.9-20.3-26.9-20.3-44.8c0-6.3 1-13.8 4.4-21.5c4.2-9.5 13.8-27.8 32.2-47H40zm600 68.3c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5H612.5c15.2 0 27.5-12.3 27.5-27.5zM384 239.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm-16 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16H304z"]
};
var faSquareArrowUp = {
  prefix: 'fas',
  iconName: 'square-arrow-up',
  icon: [448, 512, ["arrow-square-up"], "f33c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm177 87L353 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 119c9.4-9.4 24.6-9.4 33.9 0z"]
};
var faArrowSquareUp = faSquareArrowUp;
var faGreaterThanEqual = {
  prefix: 'fas',
  iconName: 'greater-than-equal',
  icon: [448, 512, [], "f532", "M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416z"]
};
var faPalletBox = {
  prefix: 'fas',
  iconName: 'pallet-box',
  icon: [640, 512, [], "e208", "M176 0h80V112c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V0h80c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM0 352c0-17.7 14.3-32 32-32H96 320 544h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H544 320 96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V384H32c-17.7 0-32-14.3-32-32zm128 96H288V384H128v64zm224 0H512V384H352v64z"]
};
var faFaceConfounded = {
  prefix: 'fas',
  iconName: 'face-confounded',
  icon: [512, 512, [], "e36c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM116 205.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zm-161.6 160L256 380.8l39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 387.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0L208 387.2l-39.1 26.1c-4.8 3.2-10.9 3.6-16 1l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l23.7 11.8 40.3-26.8c5.4-3.6 12.4-3.6 17.8 0z"]
};
var faShieldHalved = {
  prefix: 'fas',
  iconName: 'shield-halved',
  icon: [512, 512, ["shield-alt"], "f3ed", "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"]
};
var faShieldAlt = faShieldHalved;
var faTruckPlow = {
  prefix: 'fas',
  iconName: 'truck-plow',
  icon: [640, 512, [], "f7de", "M192 96v96H327.5L269.9 96H192zm-64 96V80c0-26.5 21.5-48 48-48h93.9c22.5 0 43.3 11.8 54.9 31.1L402.1 192H448c17.7 0 32 14.3 32 32v64h32V176c0-7.3 2.5-14.3 7-20l64-80c11-13.8 31.2-16 45-5s16 31.2 5 45l-57 71.2V320v36.8L633 428c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-64-80c-4.5-5.7-7-12.7-7-20V352H474.5c3.5 10 5.5 20.8 5.5 32c0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32H224c-1.9 0-3.8-.2-5.6-.5c3.7 10.2 5.6 21.1 5.6 32.5c0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h96zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faBookAtlas = {
  prefix: 'fas',
  iconName: 'book-atlas',
  icon: [448, 512, ["atlas"], "f558", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9H303.5c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208h31.1c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32H145.3c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"]
};
var faAtlas = faBookAtlas;
var faVirus = {
  prefix: 'fas',
  iconName: 'virus',
  icon: [512, 512, [], "e074", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGridRound2 = {
  prefix: 'fas',
  iconName: 'grid-round-2',
  icon: [512, 512, [], "e5db", "M128 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm0 256a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM288 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z"]
};
var faCommentMiddleTop = {
  prefix: 'fas',
  iconName: 'comment-middle-top',
  icon: [512, 512, [], "e14a", "M188.3 103.3l44.5-89C237.2 5.5 246.2 0 256 0s18.8 5.5 23.2 14.3l44.5 89C432.2 127.5 512 208.2 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-95.8 79.8-176.5 188.3-200.7z"]
};
var faEnvelopeCircleCheck = {
  prefix: 'fas',
  iconName: 'envelope-circle-check',
  icon: [640, 512, [], "e4e8", "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176V384c0 35.3 28.7 64 64 64H360.2C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faLayerGroup = {
  prefix: 'fas',
  iconName: 'layer-group',
  icon: [576, 512, [], "f5fd", "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"]
};
var faRestroomSimple = {
  prefix: 'fas',
  iconName: 'restroom-simple',
  icon: [640, 512, [], "e23a", "M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM25.9 233.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6c-41.6 0-76.3 31.9-79.7 73.4zM320 0c-13.3 0-24 10.7-24 24V488c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zM512 128A64 64 0 1 0 512 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H448v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V384h21.6c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H496.3z"]
};
var faArrowsToDot = {
  prefix: 'fas',
  iconName: 'arrows-to-dot',
  icon: [512, 512, [], "e4be", "M256 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H288v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H192c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224H64V192c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBorderOuter = {
  prefix: 'fas',
  iconName: 'border-outer',
  icon: [448, 512, [], "f851", "M64 96l0 320H384V96H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faHashtagLock = {
  prefix: 'fas',
  iconName: 'hashtag-lock',
  icon: [576, 512, [], "e415", "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32c0 .4 0 .8 0 1.1c-24.1 3.5-45.8 14.6-62.4 30.9H347.1L325.8 320h2.8c-5.4 9.4-8.6 20.3-8.6 32v32h-4.9l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1zM464 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faClockTwoThirty = {
  prefix: 'fas',
  iconName: 'clock-two-thirty',
  icon: [512, 512, [], "e35b", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V256c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faArchway = {
  prefix: 'fas',
  iconName: 'archway',
  icon: [512, 512, [], "f557", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H96h64V352c0-53 43-96 96-96s96 43 96 96V480h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32V416z"]
};
var faHeartCircleCheck = {
  prefix: 'fas',
  iconName: 'heart-circle-check',
  icon: [576, 512, [], "e4fd", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faHouseChimneyCrack = {
  prefix: 'fas',
  iconName: 'house-chimney-crack',
  icon: [576, 512, ["house-damage"], "f6f1", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24z"]
};
var faHouseDamage = faHouseChimneyCrack;
var faFileZipper = {
  prefix: 'fas',
  iconName: 'file-zipper',
  icon: [384, 512, ["file-archive"], "f1c6", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faFileArchive = faFileZipper;
var faHeartHalf = {
  prefix: 'fas',
  iconName: 'heart-half',
  icon: [512, 512, [], "e1ab", "M256 96L244 84l0 0c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9l0-50.7 0-265.4V96z"]
};
var faCommentCheck = {
  prefix: 'fas',
  iconName: 'comment-check',
  icon: [512, 512, [], "f4ac", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM369 193L241 321c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 159c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faSquare = {
  prefix: 'fas',
  iconName: 'square',
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faMemo = {
  prefix: 'fas',
  iconName: 'memo',
  icon: [384, 512, [], "e1d8", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faMartiniGlassEmpty = {
  prefix: 'fas',
  iconName: 'martini-glass-empty',
  icon: [512, 512, ["glass-martini"], "f000", "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM256 210.7L109.3 64H402.7L256 210.7z"]
};
var faGlassMartini = faMartiniGlassEmpty;
var faCouch = {
  prefix: 'fas',
  iconName: 'couch',
  icon: [640, 512, [], "f4b8", "M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z"]
};
var faCediSign = {
  prefix: 'fas',
  iconName: 'cedi-sign',
  icon: [384, 512, [], "e0df", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8V32zM192 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"]
};
var faItalic = {
  prefix: 'fas',
  iconName: 'italic',
  icon: [384, 512, [], "f033", "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"]
};
var faGlassCitrus = {
  prefix: 'fas',
  iconName: 'glass-citrus',
  icon: [512, 512, [], "f869", "M448 144c0-44.2-35.8-80-80-80c-26.2 0-49.4 12.6-64 32H232.2C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144c0 78.4-62.6 142.1-140.5 144l6.5-64.6c39.5-4.9 70-38.6 70-79.4zM249.3 224l-.1 1.3-.9-1.3h1zM8.3 138.5C14.3 131.8 23 128 32 128H320c9 0 17.7 3.8 23.7 10.5s9 15.7 8.1 24.7L322.7 454.4C319.5 487.1 291.9 512 259 512H93c-32.9 0-60.4-24.9-63.7-57.6L.2 163.2c-.9-9 2-18 8.1-24.7zM67.4 192l6.4 64H278.2l6.4-64H67.4z"]
};
var faCalendarLinesPen = {
  prefix: 'fas',
  iconName: 'calendar-lines-pen',
  icon: [576, 512, [], "e472", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448v43.6L289.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H48c-26.5 0-48-21.5-48-48V192zm120 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM96 392c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faChurch = {
  prefix: 'fas',
  iconName: 'church',
  icon: [640, 512, [9962], "f51d", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"]
};
var faPersonSnowmobiling = {
  prefix: 'fas',
  iconName: 'person-snowmobiling',
  icon: [640, 512, ["snowmobile"], "f7d1", "M240 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM373.5 85.3c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l37.4 74.7L360 192H304l-61.7-55.6c-11.8-10.6-27-16.4-42.8-16.4h-.9c-23.7 0-45.5 13.1-56.6 34.1l-35.3 66.6c-11.4 21.6-9.4 47.8 5.3 67.4H99.8c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-2.5 5-3.6 10.2-3.4 15.2c4-.6 8.1-.9 12.3-.9H272c26.2 0 49.4 12.6 64 32H450l36 48H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H576c6.4 0 12.5-2.5 17-7l40-40c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-33 33H546l-46-61.3 68.9-45.9c4.5-3 7.1-8 7.1-13.3V265.9c0-6.1-3.4-11.6-8.8-14.3L419.8 177.9 373.5 85.3zM298.5 256H312l-24 32H264l-72-32 32-48 29.3 29.3c12 12 28.3 18.7 45.3 18.7zM48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48H272c26.5 0 48-21.5 48-48s-21.5-48-48-48H48z"]
};
var faSnowmobile = faPersonSnowmobiling;
var faFaceHushed = {
  prefix: 'fas',
  iconName: 'face-hushed',
  icon: [512, 512, [], "e37b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM256 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCommentsDollar = {
  prefix: 'fas',
  iconName: 'comments-dollar',
  icon: [640, 512, [], "f653", "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"]
};
var faPickaxe = {
  prefix: 'fas',
  iconName: 'pickaxe',
  icon: [512, 512, [], "e5bf", "M462.4 373.5l0 0-.1-.2-.3-.8c-.3-.7-.7-1.8-1.3-3.3c-1.2-2.9-3-7.2-5.5-12.7c-5-11-12.6-26.7-23.1-45.3c-21-37.3-53.6-86-99.5-132s-94.7-78.5-132-99.5c-18.6-10.5-34.3-18.1-45.3-23.1c-5.5-2.5-9.8-4.3-12.7-5.5c-1.4-.6-2.5-1-3.3-1.3l-.8-.3-.2-.1 0 0 0 0c-6.2-2.3-10.4-8.2-10.5-14.8s3.9-12.6 10-15.1C169.5 7 204 0 240 0c59.6 0 114.7 19.2 159.5 51.6l9.4-9.8c6-6.2 14.2-9.7 22.8-9.8s16.9 3.3 22.9 9.4l16 16c6.1 6.1 9.5 14.3 9.4 22.9s-3.6 16.8-9.8 22.8l-9.8 9.4C492.8 157.3 512 212.4 512 272c0 36-7 70.5-19.8 102c-2.5 6.1-8.5 10.1-15.1 10s-12.5-4.3-14.8-10.5l0 0zM9.4 502.6C-3 490.3-3.1 470.4 8.9 457.8l272-282.9c9.7 8.4 19.5 17.4 29.1 27s18.6 19.4 27 29.1L54.2 503.1c-12.6 12.1-32.5 11.9-44.8-.4z"]
};
var faLinkSimpleSlash = {
  prefix: 'fas',
  iconName: 'link-simple-slash',
  icon: [640, 512, [], "e1ce", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L532.4 392c45.4-28.2 75.6-78.6 75.6-136c0-88.4-71.6-160-160-160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96 43 96 96c0 43.3-28.6 79.8-67.9 91.8L399.7 288H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H318.1l-81.7-64H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-11.3 0-22.3 1.2-32.9 3.4L38.8 5.1zM121 191.4L70.7 151.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-53 0-96-43-96-96c0-24.9 9.5-47.6 25-64.6z"]
};
var faDemocrat = {
  prefix: 'fas',
  iconName: 'democrat',
  icon: [640, 512, [], "f747", "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H480l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352h96v64 64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416H288v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416 352h96H448zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"]
};
var faFaceConfused = {
  prefix: 'fas',
  iconName: 'face-confused',
  icon: [512, 512, [], "e36d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.1 395.6l-1.1 .9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l1.1-.9C205 327.5 272 304 341 304h11c8.8 0 16 7.2 16 16s-7.2 16-16 16H341c-61.8 0-121.7 21-169.9 59.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPinball = {
  prefix: 'fas',
  iconName: 'pinball',
  icon: [448, 512, [], "e229", "M352 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm22.1 254.4c14.9 4.8 30.7-1.8 37.9-15c7.4-13.5 4.2-30.8-8.4-40.6l-246-208.3c-40.6-34.1-101.2-28.8-135.2 11.8S-6.3 327.5 34.3 361.6c9.2 7.7 19.9 13.8 32 17.7l307.8 99.1zM64 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faZ = {
  prefix: 'fas',
  iconName: 'z',
  icon: [384, 512, [122], "5a", "M0 64C0 46.3 14.3 32 32 32H352c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z"]
};
var faPersonSkiing = {
  prefix: 'fas',
  iconName: 'person-skiing',
  icon: [512, 512, [9975, "skiing"], "f7c9", "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L232.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L151.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"]
};
var faSkiing = faPersonSkiing;
var faDeer = {
  prefix: 'fas',
  iconName: 'deer',
  icon: [512, 512, [129420], "f78e", "M240 0c8.8 0 16 7.2 16 16V40c0 13.3 10.7 24 24 24h8 8c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16V40c0 8.6-1.9 16.7-5.4 24h30.6H416c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16V40c0 21.7-12.3 40.4-30.3 49.8c.6 .5 1.1 1.1 1.7 1.6l55.3 55.3c8.5 8.5 13.3 20 13.3 32c0 25-20.3 45.3-45.3 45.3H416h-5.3L384 304v64V480c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V368H251.7c-28.8 0-55.3-9.8-76.3-26.4c-2.1 16.9-9.8 32.6-21.9 44.8L142.9 397c-4.6 4.6-6.2 11.5-4 17.7l19.3 54.7c7.3 20.8-8.1 42.6-30.2 42.6H94.1c-13.6 0-25.7-8.6-30.2-21.4l-15.5-44c-11.4-32.4-7.4-67.8 10-96.3C65 339.4 65 324.9 56 315.9c-3-3-5.7-6.1-8.1-9.5c-1.3 12.9-12.7 22.5-25.7 21.5C8.9 326.9-.9 315.4 .1 302.2L2.4 272c4.2-54.2 49.3-96 103.7-96h7.9H128h64c.6 0 1.2 0 1.7 0c.8 0 1.7 0 2.5 0H302.4l9.6-32H274c-9.9 0-18-8-18-18c0-8.2 5.6-15.4 13.6-17.4L320 96H296h-8-8c-30.9 0-56-25.1-56-56V16c0-8.8 7.2-16 16-16zM400 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faInputPipe = {
  prefix: 'fas',
  iconName: 'input-pipe',
  icon: [640, 512, [], "e1be", "M64 128V384H576V128H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm144 56V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faRoadLock = {
  prefix: 'fas',
  iconName: 'road-lock',
  icon: [640, 512, [], "e567", "M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faA = {
  prefix: 'fas',
  iconName: 'a',
  icon: [384, 512, [97], "41", "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384H290.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320H120l72-172.8L264 320z"]
};
var faBookmarkSlash = {
  prefix: 'fas',
  iconName: 'bookmark-slash',
  icon: [640, 512, [], "e0c2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48V75L38.8 5.1zM128 487.7c0 13.4 10.9 24.3 24.3 24.3c5 0 9.9-1.5 14-4.4L320 400 473.7 507.6c4.1 2.9 9 4.4 14 4.4c9.9 0 18.4-5.9 22.2-14.3L128 196.9V487.7z"]
};
var faTemperatureArrowDown = {
  prefix: 'fas',
  iconName: 'temperature-arrow-down',
  icon: [576, 512, ["temperature-down"], "e03f", "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64H480V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352H384c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"]
};
var faTemperatureDown = faTemperatureArrowDown;
var faMace = {
  prefix: 'fas',
  iconName: 'mace',
  icon: [512, 512, [], "f6f8", "M244.8 95l28-84.1C275 4.4 281.1 0 288 0s13 4.4 15.2 10.9l28 84.1c40.4 13.5 72.3 45.4 85.8 85.8l84.1 28c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-84.1 28c-13.5 40.4-45.4 72.3-85.8 85.8l-28 84.1C301 443.6 294.9 448 288 448s-13-4.4-15.2-10.9l-28-84.1c-9.8-3.3-19-7.6-27.7-12.9L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L171.9 294.9c-5.3-8.6-9.6-17.9-12.9-27.7l-84.1-28C68.4 237 64 230.9 64 224s4.4-13 10.9-15.2l84.1-28c13.5-40.4 45.4-72.3 85.8-85.8zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faFeatherPointed = {
  prefix: 'fas',
  iconName: 'feather-pointed',
  icon: [512, 512, ["feather-alt"], "f56b", "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"]
};
var faFeatherAlt = faFeatherPointed;
var faSausage = {
  prefix: 'fas',
  iconName: 'sausage',
  icon: [512, 512, [], "f820", "M320 160c0-42 26.9-77.7 64.5-90.7L369.2 27.4c-.8-2.2-1.2-4.6-1.2-7C368 9.1 377.1 0 388.4 0h55.2C454.9 0 464 9.1 464 20.4c0 2.4-.4 4.7-1.2 7L447.5 69.3C485.1 82.3 512 118 512 160c0 194.4-157.6 352-352 352c-42 0-77.7-26.9-90.7-64.5L27.4 462.8c-2.2 .8-4.6 1.2-7 1.2C9.1 464 0 454.9 0 443.6V388.4C0 377.1 9.1 368 20.4 368c2.4 0 4.7 .4 7 1.2l41.9 15.2C82.3 346.9 118 320 160 320c88.4 0 160-71.6 160-160zm80 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 114.9-93.1 208-208 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240-107.5 240-240z"]
};
var faTrashCanClock = {
  prefix: 'fas',
  iconName: 'trash-can-clock',
  icon: [576, 512, [], "e2aa", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416v64.7c-29.3 2.6-56.6 12.5-80 27.7V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v39.2c-29.8 31.5-48 74-48 120.8c0 59.5 29.6 112.1 74.8 144H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm64 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]
};
var faP = {
  prefix: 'fas',
  iconName: 'p',
  icon: [320, 512, [112], "50", "M0 96C0 60.7 28.7 32 64 32h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V320 96zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z"]
};
var faBroomWide = {
  prefix: 'fas',
  iconName: 'broom-wide',
  icon: [512, 512, [], "e5d1", "M502.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128-15.8-15.8c-15.2-15.2-38.5-18.4-57.3-8l-32.5 18L380.4 288.1l18-32.5c10.4-18.7 7.1-42.1-8-57.3l-15.8-15.8 128-128c12.5-12.5 12.5-32.8 0-45.3zM187.5 151.8L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l43.2 43.2c2.1 2.1 5.3 2.9 8.2 1.9l52.1-17.4c6.3-2.1 12.2 3.9 10.1 10.1l-17.4 52.1c-1 2.9-.2 6 1.9 8.2L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4l95.1-171.1L187.5 151.8z"]
};
var faSnowflake = {
  prefix: 'fas',
  iconName: 'snowflake',
  icon: [448, 512, [10052, 10054], "f2dc", "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"]
};
var faStomach = {
  prefix: 'fas',
  iconName: 'stomach',
  icon: [512, 512, [], "f623", "M192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96c0 70.7 57.3 128 128 128v64c0 35.3-28.7 64-64 64H128C57.3 352 0 409.3 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32c0-26.5 21.5-48 48-48c24.6 0 36 9.5 58.2 28.2l0 0c1.7 1.4 3.4 2.9 5.3 4.4c12.6 10.5 28.4 22.9 49.6 32.2C246.5 506.2 272 512 304 512c114.9 0 208-93.1 208-208V224c0-70.7-57.3-128-128-128c-47.4 0-88.7 25.7-110.9 64H256c-35.3 0-64-28.7-64-64V32zM445.1 332.7c-7.2 1.9-14.6 3.3-21.1 3.3c-16.8 .2-28.4-7.9-40-16s-23.2-16.3-40-16c-7.9 .1-17.1 2.1-25.6 4.6c1.1-6.7 1.6-13.6 1.6-20.6V224c0-35.3 28.7-64 64-64s64 28.7 64 64v80c0 9.8-1 19.4-2.9 28.7z"]
};
var faNewspaper = {
  prefix: 'fas',
  iconName: 'newspaper',
  icon: [512, 512, [128240], "f1ea", "M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
};
var faRectangleAd = {
  prefix: 'fas',
  iconName: 'rectangle-ad',
  icon: [576, 512, ["ad"], "f641", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"]
};
var faAd = faRectangleAd;
var faGuitarElectric = {
  prefix: 'fas',
  iconName: 'guitar-electric',
  icon: [512, 512, [127928], "f8be", "M352 81.1v33.6L243.8 223c-14.6-26.1-5.5-50.4 3.2-64.7c4.8-7.9 4.8-18.7-1.7-25.3s-17.1-6.6-23.6 0l-29.9 30.2c-9.1 9.2-14.7 21.5-20.2 33.5l0 0 0 0c-1.2 2.6-2.3 5.1-3.5 7.6c-3.5 7.3-8.9 15.7-17.1 24c-24.7 25-64.7 40.2-89.6 47.7c-14.5 4.4-28.1 11.7-38.7 22.4c-30 30.4-30 79.6 0 110l79.9 80.8c30 30.4 78.7 30.4 108.8 0c10.7-10.8 17.9-24.5 22.2-39.2c7.5-25.2 22.5-65.6 47.2-90.6c10-10.1 20-16 28.3-19.3l1.1-.5 0 0c11.3-4.6 23-9.4 31.6-18l21.6-21.8c6.5-6.6 6.5-17.3 0-23.8s-17.3-6.6-25.8-3c-11.1 4.7-28 7.3-48.3-4.7L461.3 96H464c26.5 0 48-21.5 48-48s-21.5-48-48-48h-1.1c-9.7 0-19.2 2.9-27.3 8.3L366.2 54.5C357.3 60.4 352 70.4 352 81.1zM195.3 268.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-64 64l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faArrowTurnDownRight = {
  prefix: 'fas',
  iconName: 'arrow-turn-down-right',
  icon: [512, 512, [], "e3d6", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V224c0 53 43 96 96 96H402.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256H96c-17.7 0-32-14.3-32-32V64z"]
};
var faMoonCloud = {
  prefix: 'fas',
  iconName: 'moon-cloud',
  icon: [640, 512, [], "f754", "M479.5 32c-118.2 0-214.9 92-223 208.3C310 244.7 352 289.4 352 344c0 27.9-11 53.3-29 72c40.3 39.6 95.5 64 156.4 64c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.2-.5-12.6-.8-19-.8zM64 416H248c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C208.8 246.5 179 224 144 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64s28.7 64 64 64z"]
};
var faBreadSliceButter = {
  prefix: 'fas',
  iconName: 'bread-slice-butter',
  icon: [512, 512, [], "e3e1", "M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64zm182.6 73.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0l50.7-50.7c12.5-12.5 12.5-32.8 0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-50.7 50.7z"]
};
var faCircleArrowRight = {
  prefix: 'fas',
  iconName: 'circle-arrow-right',
  icon: [512, 512, ["arrow-circle-right"], "f0a9", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"]
};
var faArrowCircleRight = faCircleArrowRight;
var faUserGroupCrown = {
  prefix: 'fas',
  iconName: 'user-group-crown',
  icon: [640, 512, ["users-crown"], "f6a5", "M144 144V128H304v16c0 44.2-35.8 80-80 80s-80-35.8-80-80zm-.1-124.9c-.3-.2-.6-.4-.8-.6L140 16 124.4 3.5C121.5 1.2 118 0 114.4 0H112c-8.8 0-16 7.2-16 16V39v3.2 .1V144c0 70.7 57.3 128 128 128s128-57.3 128-128V42.3v-.1V39 16c0-8.8-7.2-16-16-16h-2.4c-3.6 0-7.2 1.2-10 3.5L308 16l-3 2.4c-.3 .2-.6 .4-.8 .6l-.1 .1c-10.2 7.5-23.8 8.3-34.9 2L238.9 4c-4.6-2.6-9.7-4-14.9-4s-10.4 1.4-14.9 4L178.9 21.2c-11 6.3-24.7 5.5-34.9-2l-.1-.1zM168 304C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168zm264-48c61.9 0 112-50.1 112-112s-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8V144c0 5.4-.3 10.7-.8 16c-2.4 24.3-10.3 47.1-22.4 67c-.5 .8-1 1.6-1.4 2.3C379 245.9 404.3 256 432 256zm39.4 256H609.3c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320H417.3c-2.4 0-4.8 .1-7.1 .2C452.9 356.8 480 411.3 480 472v8c0 11.7-3.1 22.6-8.6 32z"]
};
var faUsersCrown = faUserGroupCrown;
var faCircleI = {
  prefix: 'fas',
  iconName: 'circle-i',
  icon: [512, 512, [], "e111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V336h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faToiletPaperCheck = {
  prefix: 'fas',
  iconName: 'toilet-paper-check',
  icon: [640, 512, [], "e5b2", "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM291.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 225.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72z"]
};
var faFilterCircleXmark = {
  prefix: 'fas',
  iconName: 'filter-circle-xmark',
  icon: [576, 512, [], "e17b", "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faLocust = {
  prefix: 'fas',
  iconName: 'locust',
  icon: [576, 512, [], "e520", "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4H431.8l-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400H496c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3V280C576 143 465 32 328 32H312zm50.5 168l17.1 40H333l29.5-40zm-87.7 38.1l-1.4 1.9H225.1l32.7-41.5 16.9 39.5zM88.8 240C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240H88.8zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faSort = {
  prefix: 'fas',
  iconName: 'sort',
  icon: [320, 512, ["unsorted"], "f0dc", "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"]
};
var faUnsorted = faSort;
var faListOl = {
  prefix: 'fas',
  iconName: 'list-ol',
  icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faList12 = faListOl;
var faListNumeric = faListOl;
var faChartWaterfall = {
  prefix: 'fas',
  iconName: 'chart-waterfall',
  icon: [512, 512, [], "e0eb", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64-96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faSparkle = {
  prefix: 'fas',
  iconName: 'sparkle',
  icon: [448, 512, [], "e5d6", "M245.8 45.9C241.9 37.4 233.4 32 224 32s-17.9 5.4-21.8 13.9L142.7 174.7 13.9 234.2C5.4 238.1 0 246.6 0 256s5.4 17.9 13.9 21.8l128.8 59.5 59.5 128.8c3.9 8.5 12.4 13.9 21.8 13.9s17.9-5.4 21.8-13.9l59.5-128.8 128.8-59.5c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8L305.3 174.7 245.8 45.9z"]
};
var faFaceParty = {
  prefix: 'fas',
  iconName: 'face-party',
  icon: [640, 512, [], "e383", "M531.7 400C485.6 467.6 408 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0C433.4 0 529.7 73.8 563.3 176H560c-44.2 0-80 35.8-80 80c0 18 6 34.6 16 48H416c-1 0-2 0-3 .1c-1.2-2.3-2.7-4.4-4.3-6.4c-4.3-5.2-10.1-9.7-16.7-13.4C378.7 276.9 361.4 272 344 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c1.6-2 3.1-4.1 4.3-6.4c1 .1 2 .1 3 .1H531.7zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm89.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM512 256c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H400c-8.8 0-16-7.2-16-16s7.2-16 16-16H592c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H560c-26.5 0-48-21.5-48-48zM51.3 152.2l-20-52C46.6 71.8 66 46 88.8 23.4L132 37.8C96.5 68.5 68.5 107.7 51.3 152.2zM55.1 12.2C40.9 27.6 28 44.4 16.6 62.1L1.1 21.7C-1.2 16 .2 9.4 4.4 4.9S15.2-1.1 21.1 .8L55.1 12.2z"]
};
var faKidneys = {
  prefix: 'fas',
  iconName: 'kidneys',
  icon: [640, 512, [], "f5fb", "M152 0c-21.5 0-45.5 6.3-64.3 23.8C56.4 52.8 0 119.6 0 224c0 24.9 3.5 54.7 7.1 79.1c7.1 48 48.8 80.9 95.3 80.9c58.4 0 104-50.4 98.2-108.5l-4.1-41.2c-2-20.1 4.5-40.1 17.9-55.1l18.2-20.5c15.2-17.1 23.5-39.1 23.5-61.9c0-31.2-15.6-60.2-41.5-77.5l-3.4-2.3C194.5 5.9 175.1 0 155.2 0H152zM488 0h-3.2c-19.9 0-39.4 5.9-55.9 16.9l-3.4 2.3C399.6 36.5 384 65.6 384 96.7c0 22.8 8.4 44.8 23.5 61.9l18.2 20.5c13.4 15.1 19.9 35.1 17.9 55.1l-4.1 41.2C433.7 333.6 479.3 384 537.7 384c46.5 0 88.2-32.9 95.3-80.9c3.6-24.4 7.1-54.2 7.1-79.1c0-104.4-56.4-171.2-87.7-200.2C533.5 6.3 509.5 0 488 0zM228.2 231.1l1.9 18.8 21.5 10.7c2.7 1.4 4.4 4.1 4.4 7.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-21.2-12-40.6-31-50.1l-34.8-17.4-.1 .1c-7.5 8.4-11.1 19.5-10 30.7zm173.6-30.7l-.1-.1L367 217.7c-19 9.5-31 28.9-31 50.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-3 1.7-5.8 4.4-7.2l21.5-10.7 1.9-18.8c1.1-11.2-2.5-22.3-10-30.7z"]
};
var faWifiExclamation = {
  prefix: 'fas',
  iconName: 'wifi-exclamation',
  icon: [640, 512, [], "e2cf", "M320 32c-27.2 0-48.7 23.1-46.8 50.2l14.9 208C289.3 307 303.2 320 320 320s30.7-13 31.9-29.7l14.9-208C368.7 55.1 347.2 32 320 32zM241.3 84.5c-1.2-17.4 3.3-33.9 11.9-47.6C159.4 51 75.1 94.1 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9c51.3-49.2 116.2-84.3 188.5-99.1l-1.4-19.3zm157.4 0l-1.4 19.3c72.3 14.8 137.2 49.9 188.5 99.1c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C564.9 94.1 480.6 51 386.8 37c8.6 13.7 13.1 30.1 11.9 47.6zM129.5 264c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c23.6-20.8 51.6-36.7 82.4-46.2l-4.7-65.1C204.4 212 163.4 234.1 129.5 264zm260.9-63.3l-4.6 65.1c30.8 9.4 58.8 25.4 82.4 46.2c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2c-33.9-29.9-74.9-52-120.1-63.3zM384 416a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faChartNetwork = {
  prefix: 'fas',
  iconName: 'chart-network',
  icon: [640, 512, [], "f78a", "M288 64c0 13.7-4.3 26.3-11.6 36.7l29.2 62.5c9.8-2.1 20-3.2 30.4-3.2c36.1 0 69 13.3 94.3 35.2L512.4 135c-.2-2.3-.4-4.6-.4-7c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.2 0-17.9-1.9-25.8-5.4l-82 60.2c7.6 17.5 11.8 36.9 11.8 57.2c0 15.6-2.5 30.7-7.1 44.8l72 43.2c9.2-5.1 19.8-8 31.1-8c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64l0-1.1-72.1-43.3C413.7 431 376.8 448 336 448c-68.5 0-125.9-47.9-140.4-112H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64s28.7-64 64-64c23.7 0 44.4 12.9 55.4 32h76.1c7.5-33 26.3-61.6 52.1-81.7l-29.2-62.5C185.7 124.9 160 97.5 160 64c0-35.3 28.7-64 64-64s64 28.7 64 64zm48 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faPersonDressBurst = {
  prefix: 'fas',
  iconName: 'person-dress-burst',
  icon: [640, 512, [], "e544", "M528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"]
};
var faDiceD4 = {
  prefix: 'fas',
  iconName: 'dice-d4',
  icon: [512, 512, [], "f6d0", "M228.8 .7C235.5 2.8 240 9 240 16V496c0 6.3-3.7 12-9.4 14.6s-12.5 1.6-17.2-2.6L5.4 324c-6.1-5.4-7.2-14.5-2.5-21.2l208-296c4-5.7 11.3-8.2 17.9-6.1zm54.4 0c6.7-2.1 13.9 .3 17.9 6.1l208 296c4.7 6.7 3.6 15.8-2.5 21.2l-208 184c-4.7 4.2-11.4 5.2-17.2 2.6s-9.4-8.3-9.4-14.6V16c0-7 4.5-13.2 11.2-15.3z"]
};
var faMoneyCheckDollar = {
  prefix: 'fas',
  iconName: 'money-check-dollar',
  icon: [576, 512, ["money-check-alt"], "f53d", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164 152v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"]
};
var faMoneyCheckAlt = faMoneyCheckDollar;
var faVectorSquare = {
  prefix: 'fas',
  iconName: 'vector-square',
  icon: [448, 512, [], "f5cb", "M368 80h32v32H368V80zM352 32c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM96 160c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32V160zM48 400H80v32H48V400zm320 32V400h32v32H368zM48 112V80H80v32H48z"]
};
var faBreadSlice = {
  prefix: 'fas',
  iconName: 'bread-slice',
  icon: [512, 512, [], "f7ec", "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"]
};
var faLanguage = {
  prefix: 'fas',
  iconName: 'language',
  icon: [640, 512, [], "f1ab", "M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"]
};
var faWheatAwnSlash = {
  prefix: 'fas',
  iconName: 'wheat-awn-slash',
  icon: [640, 512, [], "e338", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L550.5 231c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L569 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L473 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L393.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L369.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L335.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4L38.8 5.1zm255 322.4l-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM569 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L447 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88z"]
};
var faFaceKissWinkHeart = {
  prefix: 'fas',
  iconName: 'face-kiss-wink-heart',
  icon: [512, 512, [128536, "kiss-wink-heart"], "f598", "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"]
};
var faKissWinkHeart = faFaceKissWinkHeart;
var faDagger = {
  prefix: 'fas',
  iconName: 'dagger',
  icon: [384, 512, [], "f6cb", "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H48c-26.5 0-48 21.5-48 48s21.5 48 48 48c20.9 0 38.7-13.4 45.3-32H192h98.7c6.6 18.6 24.4 32 45.3 32c26.5 0 48-21.5 48-48s-21.5-48-48-48H224V32zM128 224v24V414.8c0 10.5 2.9 20.8 8.5 29.7l35.1 56.2c4.4 7 12.1 11.3 20.4 11.3s16-4.3 20.4-11.3l35.1-56.2c5.6-8.9 8.5-19.2 8.5-29.7V248 224H232 152 128z"]
};
var faPodium = {
  prefix: 'fas',
  iconName: 'podium',
  icon: [448, 512, [], "f680", "M182.4 72c8.3 14.3 23.8 24 41.6 24h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H224c-17.8 0-33.3 9.7-41.6 24H168c-48.6 0-88 39.4-88 88v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H128V112c0-22.1 17.9-40 40-40h14.4zM48 224L73.7 455.1c3.6 32.4 31 56.9 63.6 56.9H310.7c32.6 0 60-24.5 63.6-56.9L400 224H48z"]
};
var faMemoCircleCheck = {
  prefix: 'fas',
  iconName: 'memo-circle-check',
  icon: [576, 512, [], "e1d9", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm64 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm208 48a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm188.7-43.3L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faRouteHighway = {
  prefix: 'fas',
  iconName: 'route-highway',
  icon: [448, 512, [], "f61a", "M240.5 4.6c-10.1-6.1-22.8-6.1-32.9 0l-4.7 2.8c-37.5 22.5-84 24.3-123.1 4.7l-1.4-.7c-15.2-7.6-33.7-2-42.1 12.7l-32 56c-5.3 9.3-5.6 20.6-.8 30.2l16.2 32.5C27.8 159.1 32 177 32 195.2c0 14.9-2.8 29.7-8.4 43.6L9.3 274.5C3.2 289.9 0 306.4 0 323c0 49.5 28 94.8 72.2 116.9l137.4 68.7c9 4.5 19.6 4.5 28.6 0l137.4-68.7C420 417.8 448 372.5 448 323c0-16.6-3.2-33.1-9.3-48.5l-14.3-35.7c-5.5-13.9-8.4-28.6-8.4-43.6c0-18.2 4.2-36.2 12.4-52.5l16.2-32.5c4.8-9.6 4.5-20.9-.8-30.2l-32-56c-8.4-14.7-26.9-20.3-42.1-12.7l-1.4 .7c-39.1 19.6-85.6 17.8-123.1-4.7l-4.7-2.8zM96 192H352c0 1.1 0 2.2 0 3.2c0 23.1 4.4 45.9 13 67.3l14.3 35.7c3.2 7.9 4.8 16.3 4.8 24.8c0 25.3-14.3 48.4-36.9 59.7L224 444.2 100.9 382.7C78.3 371.4 64 348.3 64 323c0-8.5 1.6-16.9 4.8-24.8L83 262.6c8.6-21.4 13-44.3 13-67.3c0-1.1 0-2.2 0-3.2z"]
};
var faDownToLine = {
  prefix: 'fas',
  iconName: 'down-to-line',
  icon: [384, 512, ["arrow-alt-to-bottom"], "f34a", "M342.1 249.9L219.3 372.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L41.9 249.9c-6.4-6.4-9.9-15-9.9-24C32 207.2 47.2 192 65.9 192l62.1 0 0-128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V192l62.1 0c18.7 0 33.9 15.2 33.9 33.9c0 9-3.6 17.6-9.9 24zM32 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faArrowAltToBottom = faDownToLine;
var faFilter = {
  prefix: 'fas',
  iconName: 'filter',
  icon: [512, 512, [], "f0b0", "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"]
};
var faSquareG = {
  prefix: 'fas',
  iconName: 'square-g',
  icon: [448, 512, [], "e271", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80z"]
};
var faCirclePhone = {
  prefix: 'fas',
  iconName: 'circle-phone',
  icon: [512, 512, ["phone-circle"], "e11b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.7 128.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L200 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C368.9 378 361 384 352 384c-123.7 0-224-100.3-224-224c0-9 6-16.9 14.7-19.3l44-12z"]
};
var faPhoneCircle = faCirclePhone;
var faClipboardPrescription = {
  prefix: 'fas',
  iconName: 'clipboard-prescription',
  icon: [384, 512, [], "f5e8", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"]
};
var faUserNurseHair = {
  prefix: 'fas',
  iconName: 'user-nurse-hair',
  icon: [448, 512, [], "e45d", "M96 70.2V128h.3c-.2 2.6-.3 5.3-.3 8v40c0 70.7 57.3 128 128 128s128-57.3 128-128V136c0-2.7-.1-5.4-.3-8h.3V70.2c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80l32 0c29.8 0 55.9-16.3 69.6-40.5C257.3 150.4 275.5 160 296 160h8zM141.3 336.2c-7.6-8.1-18.9-11.9-29.4-8.5C47 348.5 0 409.4 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-71.8-47-132.7-111.9-153.6c-10.5-3.4-21.8 .4-29.4 8.5l-71 75.5c-6.3 6.7-17 6.7-23.3 0l-71-75.5zM208 48c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8V64h16c4.4 0 8 3.6 8 8V88c0 4.4-3.6 8-8 8H240v16c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8V96H192c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h16V48z"]
};
var faQuestion = {
  prefix: 'fas',
  iconName: 'question',
  icon: [320, 512, [10067, 10068, 61736], "3f", "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faFileSignature = {
  prefix: 'fas',
  iconName: 'file-signature',
  icon: [576, 512, [], "f573", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V428.7c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"]
};
var faToggleLargeOn = {
  prefix: 'fas',
  iconName: 'toggle-large-on',
  icon: [576, 512, [], "e5b1", "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 64a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
var faUpDownLeftRight = {
  prefix: 'fas',
  iconName: 'up-down-left-right',
  icon: [512, 512, ["arrows-alt"], "f0b2", "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"]
};
var faArrowsAlt = faUpDownLeftRight;
var faDryerHeat = {
  prefix: 'fas',
  iconName: 'dryer-heat',
  icon: [448, 512, ["dryer-alt"], "f862", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM156.7 212.7c-6.2 6.2-6.2 16.4 0 22.6L177.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm102.6 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L257.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L270.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7z"]
};
var faDryerAlt = faDryerHeat;
var faHouseChimneyUser = {
  prefix: 'fas',
  iconName: 'house-chimney-user',
  icon: [576, 512, [], "e065", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"]
};
var faHandHoldingHeart = {
  prefix: 'fas',
  iconName: 'hand-holding-heart',
  icon: [576, 512, [], "f4be", "M148 76.6C148 34.3 182.3 0 224.6 0c20.3 0 39.8 8.1 54.1 22.4l9.3 9.3 9.3-9.3C311.6 8.1 331.1 0 351.4 0C393.7 0 428 34.3 428 76.6c0 20.3-8.1 39.8-22.4 54.1L302.1 234.1c-7.8 7.8-20.5 7.8-28.3 0L170.4 130.7C156.1 116.4 148 96.9 148 76.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faArrowUpSmallBig = {
  prefix: 'fas',
  iconName: 'arrow-up-small-big',
  icon: [576, 512, ["sort-size-up-alt"], "f88f", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM320 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80zm48 176H496c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48z"]
};
var faSortSizeUpAlt = faArrowUpSmallBig;
var faTrainTrack = {
  prefix: 'fas',
  iconName: 'train-track',
  icon: [576, 512, [], "e453", "M222.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L147.6 96H112c-17.7 0-32 14.3-32 32s14.3 32 32 32h14.3l-21.3 64H72c-17.7 0-32 14.3-32 32s14.3 32 32 32H83.6L62.3 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h8.9l-7.3 21.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l14-42.1H467.6l14 42.1c5.6 16.8 23.7 25.8 40.5 20.2s25.8-23.7 20.2-40.5L535.1 416H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H513.7l-21.3-64H504c17.7 0 32-14.3 32-32s-14.3-32-32-32H471.1l-21.3-64H464c17.7 0 32-14.3 32-32s-14.3-32-32-32H428.4l-14-42.1c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5L360.9 96H215.1l7.3-21.9zM193.7 160H382.3l21.3 64H172.4l21.3-64zM446.3 352H129.7l21.3-64H424.9l21.3 64z"]
};
var faPuzzlePiece = {
  prefix: 'fas',
  iconName: 'puzzle-piece',
  icon: [512, 512, [129513], "f12e", "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8v0c0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2v0c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2v0c-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48H279.2c-12.8 0-23.2-10.4-23.2-23.2v0c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8v0c0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320v0c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256v0C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48H168.8c12.8 0 23.2-10.4 23.2-23.2v0z"]
};
var faMoneyCheck = {
  prefix: 'fas',
  iconName: 'money-check',
  icon: [576, 512, [], "f53c", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"]
};
var faStarHalfStroke = {
  prefix: 'fas',
  iconName: 'star-half-stroke',
  icon: [640, 512, ["star-half-alt"], "f5c0", "M320 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L320.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L320.1 439.8 191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L470.5 329l24.6 145.7z"]
};
var faStarHalfAlt = faStarHalfStroke;
var faFileExclamation = {
  prefix: 'fas',
  iconName: 'file-exclamation',
  icon: [384, 512, [], "f31a", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM192 192c13.3 0 24 10.7 24 24V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCode = {
  prefix: 'fas',
  iconName: 'code',
  icon: [640, 512, [], "f121", "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"]
};
var faWhiskeyGlass = {
  prefix: 'fas',
  iconName: 'whiskey-glass',
  icon: [512, 512, [129347, "glass-whiskey"], "f7a0", "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM87.7 224L69 96H443L424.3 224H87.7z"]
};
var faGlassWhiskey = faWhiskeyGlass;
var faMoonStars = {
  prefix: 'fas',
  iconName: 'moon-stars',
  icon: [512, 512, [], "f755", "M284.8 99.2l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11zm119 211.6c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2s3.8 10.7 9.2 12.2l58 16.6 16.6 58zM191.8 128C85.8 128 0 214.1 0 320.2S85.8 512.4 191.8 512.4c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.2-25.1 2.2c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-5.4-.5-10.8-.7-16.3-.7z"]
};
var faBuildingCircleExclamation = {
  prefix: 'fas',
  iconName: 'building-circle-exclamation',
  icon: [640, 512, [], "e4d3", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faClothesHanger = {
  prefix: 'fas',
  iconName: 'clothes-hanger',
  icon: [640, 512, [], "e136", "M209.8 84.8C222.3 35 267.1 0 318.5 0H320c61.9 0 112 50.1 112 112v6.3c0 36.5-17.8 70.8-47.8 91.8l-8.3 5.8L608.2 377.2C628.1 391 640 413.7 640 438c0 40.9-33.1 74-74 74H74c-40.9 0-74-33.1-74-74c0-24.2 11.9-47 31.8-60.8L301.6 189.8l.1-.1 45.8-32c12.8-9 20.5-23.7 20.5-39.3V112c0-26.5-21.5-48-48-48h-1.5c-22 0-41.2 15-46.6 36.4l-.9 3.4c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l.9-3.4zM320 255L68.3 429.7c-2.7 1.9-4.3 4.9-4.3 8.2c0 5.5 4.5 10 10 10H566c5.5 0 10-4.5 10-10c0-3.3-1.6-6.4-4.3-8.2L320 255z"]
};
var faMobileNotch = {
  prefix: 'fas',
  iconName: 'mobile-notch',
  icon: [384, 512, ["mobile-iphone"], "e1ee", "M128 64V80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V64h32c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zM96 0C51.8 0 16 35.8 16 80V432c0 44.2 35.8 80 80 80H288c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H96zm32 400c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16z"]
};
var faMobileIphone = faMobileNotch;
var faMagnifyingGlassChart = {
  prefix: 'fas',
  iconName: 'magnifying-glass-chart',
  icon: [512, 512, [], "e522", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faArrowUpRightFromSquare = {
  prefix: 'fas',
  iconName: 'arrow-up-right-from-square',
  icon: [512, 512, ["external-link"], "f08e", "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
};
var faExternalLink = faArrowUpRightFromSquare;
var faCubesStacked = {
  prefix: 'fas',
  iconName: 'cubes-stacked',
  icon: [448, 512, [], "e4e6", "M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H288zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352zM160 384v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"]
};
var faImagesUser = {
  prefix: 'fas',
  iconName: 'images-user',
  icon: [576, 512, [], "e1b9", "M96 96V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm240 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM269.7 256H402.3c25.2 0 45.7 20.5 45.7 45.7c0 10.1-8.2 18.3-18.3 18.3H242.3c-10.1 0-18.3-8.2-18.3-18.3c0-25.2 20.5-45.7 45.7-45.7zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faWonSign = {
  prefix: 'fas',
  iconName: 'won-sign',
  icon: [512, 512, [8361, "krw", "won"], "f159", "M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H72.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1H249zm96 64h26.6l-15.2 45.6L345 288z"]
};
var faKrw = faWonSign;
var faWon = faWonSign;
var faImagePolaroidUser = {
  prefix: 'fas',
  iconName: 'image-polaroid-user',
  icon: [448, 512, [], "e1b6", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 32V320c0 17.7 14.3 32 32 32h16c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64h16c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm96 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faVirusCovid = {
  prefix: 'fas',
  iconName: 'virus-covid',
  icon: [512, 512, [], "e4a8", "M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V81.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464V216c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H430.4c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V430.4c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280H48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v16H81.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48H216c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSquareEllipsis = {
  prefix: 'fas',
  iconName: 'square-ellipsis',
  icon: [448, 512, [], "e26e", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faPie = {
  prefix: 'fas',
  iconName: 'pie',
  icon: [576, 512, [129383], "f705", "M544 240c-7.6 0-14.3-4.9-17-12C490 132.1 397 64 288 64S86 132.1 49 228c-2.7 7.1-9.4 12-17 12c-17.7 0-32 14.3-32 32c0 17.2 13.6 31.3 30.7 32c17.7-.5 35-7 48.7-14.2c7-3.6 12.7-7.3 16.7-10c2-1.4 3.5-2.5 4.5-3.2c.5-.4 .9-.7 1.1-.8l.2-.2 0 0 20.7 .4 0 0 .2 .1c.2 .2 .5 .4 .9 .8c.9 .7 2.2 1.8 4.1 3.1c3.7 2.6 9.1 6.2 16.1 9.8c14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8c1.8-1.3 3.2-2.4 4.1-3.1c.4-.4 .7-.6 .9-.8l.1-.1c6.1-5.4 15.2-5.4 21.2 0l0 0 .1 .1c.2 .2 .5 .4 .9 .8c.9 .7 2.2 1.8 4.1 3.1c3.7 2.6 9.1 6.2 16.1 9.8c14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8c1.8-1.3 3.2-2.4 4.1-3.1c.4-.4 .7-.6 .9-.8l.1-.1c5.9-5.2 14.6-5.4 20.7-.4l0 0 0 0 0 0 0 0 0 0 0 0 .2 .2c.2 .2 .6 .5 1.1 .8c1 .7 2.5 1.9 4.5 3.2c4 2.7 9.7 6.4 16.7 10c13.7 7.2 31.1 13.7 48.7 14.2c17.1-.7 30.7-14.7 30.7-32c0-17.7-14.3-32-32-32zM122.6 276c-5.9-5.2-14.6-5.4-20.7-.4l0 0 20.7 .4s0 0 0 0zM81.4 404.2c8.7 26.1 33.2 43.8 60.7 43.8H433.9c27.5 0 52-17.6 60.7-43.8l24-71.9c-14.2-3.5-26.8-9-36.8-14.2c-7-3.7-12.9-7.3-17.5-10.3c-4.5 3.1-10.3 6.7-17.4 10.4C429.8 327 405.2 336 376 336s-53.8-9-70.8-17.8c-6.9-3.6-12.7-7.2-17.2-10.2c-4.5 3-10.2 6.6-17.2 10.2C253.8 327 229.2 336 200 336s-53.8-9-70.8-17.8c-7.1-3.6-12.9-7.3-17.4-10.4c-4.6 3-10.5 6.7-17.5 10.3c-10 5.2-22.7 10.7-36.8 14.2l24 71.9zM206.3 151.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5zm192-14.3l16 32c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2zM304 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChessKnightPiece = {
  prefix: 'fas',
  iconName: 'chess-knight-piece',
  icon: [320, 512, ["chess-knight-alt"], "f442", "M57.6 102.4l-6.9 6.9c-12 12-18.7 28.3-18.7 45.3v81.2c0 10.7 5.3 20.7 14.2 26.6l3.5 2.4c12.7 8.5 29.1 9.5 42.8 2.7c2.3-1.1 4.5-2.5 6.5-4l38.8-29.1c5.5-4.1 13.1-4.1 18.6 0c8.2 6.1 8.3 18.4 .2 24.7L81 317c-20.8 16-33 40.7-33 67H272l26.9-107.6c3.4-13.6 5.1-27.5 5.1-41.5c0-94.4-76.5-171-171-171H47.8C39.1 64 32 71.1 32 79.8c0 6 3.4 11.5 8.7 14.2l16.9 8.4zm19.2 54.4a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L272 416H48z"]
};
var faChessKnightAlt = faChessKnightPiece;
var faAustralSign = {
  prefix: 'fas',
  iconName: 'austral-sign',
  icon: [448, 512, [], "e0a9", "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96L82.7 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H56L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H365.3L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H325.3L253.5 51.7zM256 224H192l32-76.8L256 224zm-90.7 64H282.7L296 320H152l13.3-32z"]
};
var faCloudPlus = {
  prefix: 'fas',
  iconName: 'cloud-plus',
  icon: [640, 512, [], "e35e", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM296 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H232c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faF = {
  prefix: 'fas',
  iconName: 'f',
  icon: [320, 512, [102], "46", "M64 32C28.7 32 0 60.7 0 96V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"]
};
var faLeaf = {
  prefix: 'fas',
  iconName: 'leaf',
  icon: [512, 512, [], "f06c", "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.2 5.4c-25.9 5.9-50 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"]
};
var faBedBunk = {
  prefix: 'fas',
  iconName: 'bed-bunk',
  icon: [576, 512, [], "f8f8", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V448H256 512v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448 416 288 256 192 160 112C576 50.1 525.9 0 464 0H256c-17.7 0-32 14.3-32 32v96H64V32zM512 256H256c-17.7 0-32 14.3-32 32v96H64V192H256 512v64zM192 304a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faRoad = {
  prefix: 'fas',
  iconName: 'road',
  icon: [576, 512, [128739], "f018", "M256 32H181.2c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480H256V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64H521.4c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faTaxi = {
  prefix: 'fas',
  iconName: 'taxi',
  icon: [512, 512, [128662, "cab"], "f1ba", "M192 0c-17.7 0-32 14.3-32 32V64c0 .1 0 .1 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288V432v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V432H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V432 288c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1c0-.1 0-.1 0-.2V32c0-17.7-14.3-32-32-32H192zM165.4 128H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 224H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCab = faTaxi;
var faPersonCirclePlus = {
  prefix: 'fas',
  iconName: 'person-circle-plus',
  icon: [576, 512, [], "e541", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faChartPie = {
  prefix: 'fas',
  iconName: 'chart-pie',
  icon: [576, 512, ["pie-chart"], "f200", "M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"]
};
var faPieChart = faChartPie;
var faBoltLightning = {
  prefix: 'fas',
  iconName: 'bolt-lightning',
  icon: [384, 512, [], "e0b7", "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"]
};
var faClockEight = {
  prefix: 'fas',
  iconName: 'clock-eight',
  icon: [512, 512, [], "e345", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V256c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3L232 243.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSackXmark = {
  prefix: 'fas',
  iconName: 'sack-xmark',
  icon: [512, 512, [], "e56a", "M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"]
};
var faFileExcel = {
  prefix: 'fas',
  iconName: 'file-excel',
  icon: [384, 512, [], "f1c3", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"]
};
var faFileContract = {
  prefix: 'fas',
  iconName: 'file-contract',
  icon: [384, 512, [], "f56c", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"]
};
var faFishFins = {
  prefix: 'fas',
  iconName: 'fish-fins',
  icon: [576, 512, [], "e4f2", "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM384 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCircleQ = {
  prefix: 'fas',
  iconName: 'circle-q',
  icon: [512, 512, [], "e11e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L377 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z"]
};
var faBuildingFlag = {
  prefix: 'fas',
  iconName: 'building-flag',
  icon: [640, 512, [], "e4d5", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32V512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32z"]
};
var faFaceGrinBeam = {
  prefix: 'fas',
  iconName: 'face-grin-beam',
  icon: [512, 512, [128516, "grin-beam"], "f582", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faGrinBeam = faFaceGrinBeam;
var faObjectUngroup = {
  prefix: 'fas',
  iconName: 'object-ungroup',
  icon: [640, 512, [], "f248", "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H328.6C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V232.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4V232.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4H520.6c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H311.4z"]
};
var faFaceDisguise = {
  prefix: 'fas',
  iconName: 'face-disguise',
  icon: [512, 512, [], "e370", "M256 512c141.4 0 256-114.6 256-256c0-16.4-1.5-32.5-4.5-48H440c0 50.1-38.4 91.2-87.3 95.6c9.6 7.9 15.3 19.7 15.3 32.4c0 15.9-9 30.4-23.1 37.5L364.5 398c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5l-23.9-29.9-7.3 3.6 10.5 26.3c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9l-10-24.9c-2.4 .7-4.8 1.3-7.2 1.8V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V406.8c-2.4-.5-4.8-1.1-7.2-1.8l-10 24.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l10.5-26.3-7.3-3.6L172.5 418c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l19.6-24.5C153 366.4 144 351.9 144 336c0-12.7 5.7-24.5 15.3-32.4C110.4 299.2 72 258.1 72 208H4.5C1.5 223.5 0 239.6 0 256C0 397.4 114.6 512 256 512zm61.9-245.5c7.9 3.5 16.8 5.5 26.1 5.5c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 2.5 .1 4.9 .4 7.3c5.4 3.6 10.1 8.4 13.5 14.1l21.4 35.7c1.1 .6 1.9 1 2.6 1.3zM232 208c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c9.3 0 18.1-2 26.1-5.5c.6-.3 1.5-.7 2.6-1.3L218 229.5c3.5-5.8 8.1-10.6 13.5-14.1c.3-2.4 .4-4.9 .4-7.3zM12.7 176H77.5c5.3-14.9 14.1-28 25.4-38.5l-5.2-10.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l3.5 7c4.6-2 9.3-3.6 14.2-4.9V96c0-8.8 7.2-16 16-16s16 7.2 16 16v16.3c4.4 .4 8.7 1 13 2l4.7-9.5c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-3.6 7.3c16.4 10.2 29.5 25.3 37.3 43.1c7.8-17.9 20.9-32.9 37.3-43.1l-3.6-7.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.7 9.5c4.2-.9 8.6-1.6 13-2V96c0-8.8 7.2-16 16-16s16 7.2 16 16v19c4.9 1.3 9.6 2.9 14.2 4.9l3.5-7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-5.2 10.3c11.3 10.5 20.1 23.7 25.4 38.5h64.7C465.7 73.8 369.4 0 256 0S46.3 73.8 12.7 176zM256 240c-4.3 0-8.3 2.3-10.5 6l-39.8 66.3-2.4 4-4.2 2.1-17.7 8.8c-3.4 1.7-5.5 5.1-5.5 8.8s2.1 7.2 5.5 8.8l53.1 26.5c13.5 6.8 29.4 6.8 42.9 0l53.1-26.5c3.4-1.7 5.5-5.1 5.5-8.8s-2.1-7.2-5.5-8.8l-17.7-8.8-4.2-2.1-2.4-4L266.5 246c-2.2-3.7-6.2-6-10.5-6zM144 216a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCircleArrowDownRight = {
  prefix: 'fas',
  iconName: 'circle-arrow-down-right',
  icon: [512, 512, [], "e0fa", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM192 368c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L151 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24V344c0 13.3-10.7 24-24 24H192z"]
};
var faAlien8bit = {
  prefix: 'fas',
  iconName: 'alien-8bit',
  icon: [640, 512, [128126, "alien-monster"], "f8f6", "M128 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h48c8.8 0 16 7.2 16 16v48H384V80c0-8.8 7.2-16 16-16h48V48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H448v32 32h48c8.8 0 16 7.2 16 16v48h32V144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16H544v80c0 8.8-7.2 16-16 16H480v80c0 8.8-7.2 16-16 16H416 368c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16h48V384H224v32h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224 176c-8.8 0-16-7.2-16-16V384H112c-8.8 0-16-7.2-16-16V288H48c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v80h32V176c0-8.8 7.2-16 16-16h48V128 96H144c-8.8 0-16-7.2-16-16V48zm64 192v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm192 0v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16z"]
};
var faAlienMonster = faAlien8bit;
var faHandPointRibbon = {
  prefix: 'fas',
  iconName: 'hand-point-ribbon',
  icon: [448, 512, [], "e1a6", "M64 32C64 14.3 78.3 0 96 0s32 14.3 32 32h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H11.8C5.3 128 0 122.7 0 116.2c0-3.9 1.9-7.5 5.1-9.7L43.6 80 5.1 53.5C1.9 51.3 0 47.7 0 43.8C0 37.3 5.3 32 11.8 32L64 32zm0 208V160h64v80H64zm192-48c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H194.3c-42.4 0-83.1-16.9-113.1-46.9L69.5 453.5C45.5 429.5 32 396.9 32 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"]
};
var faPoop = {
  prefix: 'fas',
  iconName: 'poop',
  icon: [512, 512, [], "f619", "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32H352c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"]
};
var faObjectExclude = {
  prefix: 'fas',
  iconName: 'object-exclude',
  icon: [512, 512, [], "e49c", "M0 64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64v96h96c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V352H64c-35.3 0-64-28.7-64-64V64zM320 192H192V320H320V192z"]
};
var faTelescope = {
  prefix: 'fas',
  iconName: 'telescope',
  icon: [576, 512, [128301], "e03e", "M375.7 40c-15.3 8.8-20.6 28.4-11.7 43.7L460 250c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-96-166.3C466 4.4 446.4-.8 431.1 8L375.7 40zM11.8 343.6C.4 350.3-3.6 364.9 3.1 376.4l25.9 44.9c6.6 11.5 21.3 15.4 32.8 8.8l44.1-25.5 .8 1.4c8.6 15 27.6 20.4 42.8 12.2l88.4-47.4L193.8 478.9c-5 12.3 .9 26.3 13.2 31.3s26.3-.9 31.3-13.2L304 335.6l65.8 161.4c5 12.3 19 18.2 31.3 13.2s18.2-19 13.2-31.3L346.4 312.5l86.1-46.2-.2-.3-96-166.3c-1-1.8-2-3.6-2.8-5.4L62.4 268.4c-14.4 9.2-19 28.1-10.4 42.9l4 6.9L11.8 343.6z"]
};
var faLocationPin = {
  prefix: 'fas',
  iconName: 'location-pin',
  icon: [384, 512, ["map-marker"], "f041", "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"]
};
var faMapMarker = faLocationPin;
var faSquareList = {
  prefix: 'fas',
  iconName: 'square-list',
  icon: [448, 512, [], "e489", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H192z"]
};
var faKaaba = {
  prefix: 'fas',
  iconName: 'kaaba',
  icon: [576, 512, [128331], "f66b", "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v16 0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2V128 112C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2V182.8l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"]
};
var faToiletPaper = {
  prefix: 'fas',
  iconName: 'toilet-paper',
  icon: [640, 512, [129531], "f71e", "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faHelmetSafety = {
  prefix: 'fas',
  iconName: 'helmet-safety',
  icon: [576, 512, ["hard-hat", "hat-hard"], "f807", "M256 32c-17.7 0-32 14.3-32 32v2.3 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288v64H544l0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1V66.3 64c0-17.7-14.3-32-32-32H256zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6H16.6z"]
};
var faHardHat = faHelmetSafety;
var faHatHard = faHelmetSafety;
var faCommentCode = {
  prefix: 'fas',
  iconName: 'comment-code',
  icon: [512, 512, [], "e147", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM217 193l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM329 159l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faSimCards = {
  prefix: 'fas',
  iconName: 'sim-cards',
  icon: [448, 512, [], "e251", "M160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V141.3c0-17-6.7-33.3-18.7-45.3L352 18.7C340 6.7 323.7 0 306.7 0H160zm48 144v48H160V176c0-17.7 14.3-32 32-32h16zm-48 80h64 96 64v48H320 224 160V224zm224-32H336V144h16c17.7 0 32 14.3 32 32v16zm-80-48v48H240V144h64zm80 160v16c0 17.7-14.3 32-32 32H336V304h48zm-80 48H240V304h64v48zm-96 0H192c-17.7 0-32-14.3-32-32V304h48v48zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faStarship = {
  prefix: 'fas',
  iconName: 'starship',
  icon: [640, 512, [], "e039", "M448 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 256a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm32-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM188.9 205.4L137 160h71c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128s14.3 32 32 32H64.1l65.5 57.3-2.2 .4C109.1 221.4 96 237.4 96 256s13.1 34.6 31.4 38.3l2.2 .4L64.1 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c17.7 0 32-14.3 32-32s-14.3-32-32-32H137l51.9-45.4 43 8.6c-5.2-18.9-7.9-38.7-7.9-59.2s2.7-40.3 7.9-59.2l-43 8.6z"]
};
var faEject = {
  prefix: 'fas',
  iconName: 'eject',
  icon: [448, 512, [9167], "f052", "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"]
};
var faCircleRight = {
  prefix: 'fas',
  iconName: 'circle-right',
  icon: [512, 512, [61838, "arrow-alt-circle-right"], "f35a", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L294.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C266 384 256 374 256 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z"]
};
var faArrowAltCircleRight = faCircleRight;
var faPlaneCircleCheck = {
  prefix: 'fas',
  iconName: 'plane-circle-check',
  icon: [640, 512, [], "e555", "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faSeal = {
  prefix: 'fas',
  iconName: 'seal',
  icon: [512, 512, [], "e241", "M289.9 18.4c-18.7-18.7-49.1-18.7-67.9 0L176.5 64H112c-26.5 0-48 21.5-48 48v64.5L18.4 222.1c-18.7 18.7-18.7 49.1 0 67.9L64 335.5V400c0 26.5 21.5 48 48 48h64.5l45.6 45.6c18.7 18.7 49.1 18.7 67.9 0L335.5 448H400c26.5 0 48-21.5 48-48V335.5l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176.5V112c0-26.5-21.5-48-48-48H335.5L289.9 18.4z"]
};
var faUserCowboy = {
  prefix: 'fas',
  iconName: 'user-cowboy',
  icon: [448, 512, [], "f8ea", "M224 16c6.7 0 10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0c35.2 0 58.3 58.1 72 110.4C316.4 120 277 128 224 128s-92.4-8-120-17.6C117.7 58.1 140.8 0 176 0c18 0 25.9 5.4 32.5 9.9c4.8 3.3 8.8 6.1 15.5 6.1zM8.6 97.8c7-3.6 15.5-1.7 20.2 4.6c5.6 7.5 22.7 22 55 34.7C115.8 149.6 161.8 160 224 160s108.2-10.4 140.2-22.9c32.4-12.7 49.4-27.2 55-34.7c4.7-6.3 13.3-8.2 20.2-4.6s10.2 11.8 7.8 19.2c-9.3 27.9-35 62.4-72.5 89.9c-7.1 5.2-14.7 10.1-22.7 14.8c0 .8 0 1.5 0 2.3c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-.8 0-1.5 0-2.3c-8-4.6-15.6-9.6-22.7-14.8C35.8 179.5 10.1 145 .8 117.1c-2.5-7.4 .8-15.6 7.8-19.2zM100.7 384H347.3c48.4 0 89.3 36.1 95.3 84.1l1 7.9c2.4 19.1-12.5 36-31.8 36H36.2C17 512 2.1 495.1 4.5 476l1-7.9c6-48 46.8-84.1 95.3-84.1z"]
};
var faHexagonVerticalNft = {
  prefix: 'fas',
  iconName: 'hexagon-vertical-nft',
  icon: [448, 512, [], "e505", "M260.9 495.5c-22.3 12.9-49.7 12.9-72 0L36 407.2C13.7 394.4 0 370.6 0 344.9V168.3c0-25.7 13.7-49.5 36-62.4L188.9 17.7c22.3-12.9 49.7-12.9 72 0l152.9 88.3c22.3 12.9 36 36.6 36 62.4V344.9c0 25.7-13.7 49.5-36 62.4L260.9 495.5zM95.8 170.6c-2.8-7.1-10.3-11.2-17.9-9.8s-13 8-13 15.7v160c0 8.8 7.2 16 16 16s16-7.2 16-16V259.7l33.1 82.9c2.8 7.1 10.3 11.2 17.9 9.8s13-8 13-15.7v-160c0-8.8-7.2-16-16-16s-16 7.2-16 16v76.9L95.8 170.6zm97.1 5.9v80 80c0 8.8 7.2 16 16 16s16-7.2 16-16v-64h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-144h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64z"]
};
var faFaceRollingEyes = {
  prefix: 'fas',
  iconName: 'face-rolling-eyes',
  icon: [512, 512, [128580, "meh-rolling-eyes"], "f5a5", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"]
};
var faMehRollingEyes = faFaceRollingEyes;
var faBreadLoaf = {
  prefix: 'fas',
  iconName: 'bread-loaf',
  icon: [640, 512, [127838], "f7eb", "M0 192C0 64 176 32 240 32s240 32 240 160c0 35.3-28.7 64-64 64V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64zM397.4 34.9c-2-.9-4.1-1.9-6.2-2.8c3.1-.1 6-.2 8.8-.2c64 0 240 32 240 160c0 35.3-28.7 64-64 64V432c0 26.5-21.5 48-48 48H432c10-13.4 16-30 16-48V282.5c37.3-13.2 64-48.7 64-90.5c0-82.2-57.6-130.7-114.6-157.1z"]
};
var faRingsWedding = {
  prefix: 'fas',
  iconName: 'rings-wedding',
  icon: [512, 512, [], "f81b", "M113.7 8.8C116.4 3.4 121.9 0 128 0h96c6.1 0 11.6 3.4 14.3 8.8l16 32c2.3 4.5 2.3 9.8 0 14.3l-24.6 49.2C300.6 127.1 352 193.5 352 272c0 52.3-22.8 99.2-59 131.5c-18.7-11.9-32.1-31.5-35.9-54.2C276.2 329.2 288 302 288 272c0-12-1.9-23.6-5.4-34.5c-34.9 19-58.6 56-58.6 98.5c0 61.9 50.1 112 112 112s112-50.1 112-112c0-46.1-27.8-85.7-67.6-102.9c-5-26.2-14.8-50.7-28.6-72.4C441.6 168.7 512 244.1 512 336c0 97.2-78.8 176-176 176c-55.3 0-104.7-25.5-137-65.5c-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272c0-78.5 51.4-144.9 122.3-167.7L97.7 55.2c-2.3-4.5-2.3-9.8 0-14.3l16-32zM176 160c-61.9 0-112 50.1-112 112c0 58.7 45.1 106.8 102.5 111.6c-4.2-15.1-6.5-31.1-6.5-47.6c0-64.4 34.5-120.7 86.1-151.3C226.9 169.2 202.5 160 176 160z"]
};
var faObjectGroup = {
  prefix: 'fas',
  iconName: 'object-group',
  icon: [576, 512, [], "f247", "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"]
};
var faFrenchFries = {
  prefix: 'fas',
  iconName: 'french-fries',
  icon: [384, 512, [127839], "f803", "M183.2 1.7c-5-2.5-10.8-2.2-15.6 .7S160 10.5 160 16V206.7l0 0v63.2c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2V31.8c-.1-6-3.5-11.4-8.8-14.1l-32-16zM128 14.7l-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6V14.7zM40.3 85.6L19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2H48c3.6 0 7 .4 10.2 1L40.3 85.6zM383.8 98.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8L346.2 85l-19 107.8c2.8-.5 5.7-.8 8.8-.8h26.6c1.6 0 3.2 .1 4.7 .2l16.5-93.4zm-64-48c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2l-.2 1.4V261c4.8-2.1 8.7-4.4 11.8-6.6c12-8.4 16.7-18 18.7-24.3c.7-2.3 1.7-4.7 2.8-7L319.8 50.8zM.6 250.5l57.5 237C61.5 501.9 74.4 512 89.2 512H294.8c14.8 0 27.6-10.1 31.1-24.5l57.5-237c.4-1.7 .6-3.3 .6-5.1c0-11.8-9.6-21.4-21.4-21.4H336c-8.8 0-16.3 7.2-18.9 15.7C309.7 263 283.7 304 192 304s-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224H21.4C9.6 224 0 233.6 0 245.4c0 1.7 .2 3.4 .6 5.1z"]
};
var faChartLine = {
  prefix: 'fas',
  iconName: 'chart-line',
  icon: [512, 512, ["line-chart"], "f201", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"]
};
var faLineChart = faChartLine;
var faCalendarArrowDown = {
  prefix: 'fas',
  iconName: 'calendar-arrow-down',
  icon: [448, 512, ["calendar-download"], "e0d0", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V366.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V264z"]
};
var faCalendarDownload = faCalendarArrowDown;
var faSendBack = {
  prefix: 'fas',
  iconName: 'send-back',
  icon: [640, 512, [], "f87e", "M192 64V192H64V64H192zM64 0C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM576 320V448H448V320H576zM448 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H448zM160 288v64c0 35.3 28.7 64 64 64H352V320c0-53 43-96 96-96h32V160c0-35.3-28.7-64-64-64H288v96c0 53-43 96-96 96H160z"]
};
var faMaskVentilator = {
  prefix: 'fas',
  iconName: 'mask-ventilator',
  icon: [640, 512, [], "e524", "M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H159.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6V393.3c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320V512h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faSignatureLock = {
  prefix: 'fas',
  iconName: 'signature-lock',
  icon: [640, 512, [], "e3ca", "M96 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5L68.4 243.7C27.8 255.8 0 293.2 0 335.6v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3h72.6c5.6-9.7 13.7-17.8 23.4-23.4V272c0-5.4 .4-10.8 1.1-16H364.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L220.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zM209.9 368c-6.7 16.3-14.2 32.3-22.3 48H384V368H209.9zM86.8 305l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2L79.9 411.7c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faArrowRight = {
  prefix: 'fas',
  iconName: 'arrow-right',
  icon: [448, 512, [8594], "f061", "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"]
};
var faSignsPost = {
  prefix: 'fas',
  iconName: 'signs-post',
  icon: [512, 512, ["map-signs"], "f277", "M224 32H64C46.3 32 32 46.3 32 64v64c0 17.7 14.3 32 32 32H441.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32H288V192H224v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32V256zM288 480V384H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faMapSigns = faSignsPost;
var faOctagonPlus = {
  prefix: 'fas',
  iconName: 'octagon-plus',
  icon: [512, 512, ["plus-octagon"], "f301", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faPlusOctagon = faOctagonPlus;
var faCashRegister = {
  prefix: 'fas',
  iconName: 'cash-register',
  icon: [512, 512, [], "f788", "M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V378.4c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"]
};
var faPersonCircleQuestion = {
  prefix: 'fas',
  iconName: 'person-circle-question',
  icon: [576, 512, [], "e542", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"]
};
var faMelonSlice = {
  prefix: 'fas',
  iconName: 'melon-slice',
  icon: [512, 512, [], "e311", "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391zM320 128c0 106-86 192-192 192c-11.4 0-22.5-1-33.3-2.9c-5.4-.9-11 .6-14.8 4.5L59.3 342.2c-6.2 6.2-6.2 16.4 0 22.6l4 4c84.4 84.4 221.1 84.4 305.5 0c84.2-84.2 84.4-220.7 .3-305.1l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L321.6 79.8c-3.9 3.9-5.4 9.4-4.5 14.8c1.9 10.8 2.9 22 2.9 33.3z"]
};
var faSpaceStationMoon = {
  prefix: 'fas',
  iconName: 'space-station-moon',
  icon: [512, 512, [], "e033", "M512 256c0 7.8-.3 15.5-1 23.1C438.8 304.7 351.2 320 256 320s-182.8-15.3-255-40.9c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0S512 114.6 512 256zM256 512C134.9 512 33.4 427.9 6.8 314.8C79.4 338.4 164.7 352 256 352s176.6-13.6 249.2-37.2C478.6 427.9 377.1 512 256 512zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faMessageSmile = {
  prefix: 'fas',
  iconName: 'message-smile',
  icon: [512, 512, ["comment-alt-smile"], "f4aa", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"]
};
var faCommentAltSmile = faMessageSmile;
var faCupStraw = {
  prefix: 'fas',
  iconName: 'cup-straw',
  icon: [384, 512, [129380], "e363", "M249.3 0H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H249.3c-3.7 0-6.9 2.6-7.8 6.2L224.2 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H174.9l20-84.8C200.8 17.9 223.4 0 249.3 0zM60.3 468L40 224H344L323.7 468c-2.1 24.9-22.9 44-47.8 44H108.2c-25 0-45.8-19.1-47.8-44z"]
};
var faLeftFromLine = {
  prefix: 'fas',
  iconName: 'left-from-line',
  icon: [448, 512, ["arrow-alt-from-right"], "f348", "M134.1 406.1L11.3 283.3C4.1 276.1 0 266.2 0 256s4.1-20.1 11.3-27.3L134.1 105.9c6.4-6.4 15-9.9 24-9.9c18.7 0 33.9 15.2 33.9 33.9l0 62.1 128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0 0 62.1c0 18.7-15.2 33.9-33.9 33.9c-9 0-17.6-3.6-24-9.9zM384 416l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]
};
var faArrowAltFromRight = faLeftFromLine;
var faH = {
  prefix: 'fas',
  iconName: 'h',
  icon: [384, 512, [104], "48", "M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"]
};
var faBasketShoppingSimple = {
  prefix: 'fas',
  iconName: 'basket-shopping-simple',
  icon: [576, 512, ["shopping-basket-alt"], "e0af", "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192H404.3L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192H544c17.7 0 32 14.3 32 32s-14.3 32-32 32L492.1 463.5C485 492 459.4 512 430 512H146c-29.4 0-55-20-62.1-48.5L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32h85.6L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM144 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm312-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faShoppingBasketAlt = faBasketShoppingSimple;
var faHandsHoldingHeart = {
  prefix: 'fas',
  iconName: 'hands-holding-heart',
  icon: [640, 512, ["hands-heart"], "f4c3", "M180 76.6C180 34.3 214.3 0 256.6 0c20.3 0 39.8 8.1 54.1 22.4l9.3 9.3 9.3-9.3C343.6 8.1 363.1 0 383.4 0C425.7 0 460 34.3 460 76.6c0 20.3-8.1 39.8-22.4 54.1L334.1 234.1c-7.8 7.8-20.5 7.8-28.3 0L202.4 130.7C188.1 116.4 180 96.9 180 76.6zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"]
};
var faHandsHeart = faHandsHoldingHeart;
var faClockNine = {
  prefix: 'fas',
  iconName: 'clock-nine',
  icon: [512, 512, [], "e34c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V256c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faTarp = {
  prefix: 'fas',
  iconName: 'tarp',
  icon: [576, 512, [], "e57b", "M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32H576V128zM448 448L576 320H448l0 128zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faFaceSleepy = {
  prefix: 'fas',
  iconName: 'face-sleepy',
  icon: [512, 512, [], "e38e", "M385.1 477.1C347.2 499.3 303.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 37-7.8 72.1-22 103.9c-7.4-6.2-15.1-11.8-22.7-16.7C429.6 318.7 383.6 304 352 304c-15.3 0-28.5 10.9-31.4 25.9s5.3 30.1 19.5 35.8c21 8.4 31.6 23.5 37.4 41.7c6.3 19.4 6.5 40.3 6.5 56.6c0 4.5 .4 8.9 1.1 13.1zM176 389.5c-6.8 11.1 6 20.7 18.3 16.4c18.9-6.5 39.8-10.1 61.8-10.1s42.9 3.6 61.8 10.1c12.3 4.2 25.1-5.3 18.3-16.4C321 364.8 290.8 348 256 348s-64.9 16.8-80.1 41.5zM316.8 246.4c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0zm-121.6 0c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zM512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-32 0-102.4-64-128c48 0 160 48 160 128z"]
};
var faHandHorns = {
  prefix: 'fas',
  iconName: 'hand-horns',
  icon: [384, 512, [], "e1a9", "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM320 96c0-17.7 14.3-32 32-32s32 14.3 32 32v96 96 64c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c35.3 0 64-28.7 64-64V192 96z"]
};
var faScrewdriverWrench = {
  prefix: 'fas',
  iconName: 'screwdriver-wrench',
  icon: [512, 512, ["tools"], "f7d9", "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTools = faScrewdriverWrench;
var faArrowsToEye = {
  prefix: 'fas',
  iconName: 'arrows-to-eye',
  icon: [640, 512, [], "e4bf", "M15 15C24.4 5.7 39.6 5.7 49 15l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H78.1L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24V78.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V433.9L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H561.9l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"]
};
var faCircleThreeQuarters = {
  prefix: 'fas',
  iconName: 'circle-three-quarters',
  icon: [512, 512, [], "e125", "M256 32c0-17.7-14.4-32.2-31.9-30C97.8 17.7 0 125.4 0 256C0 397.4 114.6 512 256 512c130.6 0 238.3-97.8 254-224.1c2.2-17.5-12.4-31.9-30-31.9H256V32z"]
};
var faTrophyStar = {
  prefix: 'fas',
  iconName: 'trophy-star',
  icon: [576, 512, ["trophy-alt"], "f2eb", "M176 0H400c26.5 0 48.1 21.8 47.1 48.2c-.2 5.3-.4 10.6-.7 15.8H552c13.3 0 24 10.7 24 24c0 92.6-33.5 157-78.5 200.7c-44.3 43.1-98.3 64.8-138.2 75.8c-23.4 6.5-39.4 26-39.4 45.6c0 20.9 17 37.9 37.9 37.9H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h26.1c20.9 0 37.9-17 37.9-37.9c0-19.6-15.9-39.2-39.4-45.6c-39.9-11-93.9-32.7-138.1-75.8C33.5 245 0 180.6 0 88C0 74.7 10.7 64 24 64H129.6c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zM133.2 112H48.9c5.1 66.3 31.1 111.2 63 142.3c22.4 21.8 48.3 37.3 73.2 48.3c-22.7-40.3-42.8-100.5-51.9-190.6zM390.8 302.6c24.9-11 50.8-26.5 73.2-48.3c32-31.1 58-76 63-142.3H442.7c-9.1 90.1-29.2 150.3-51.9 190.6zM295.2 86.5c-2.9-5.9-11.4-5.9-14.3 0l-19.2 38.9c-1.2 2.4-3.4 4-6 4.4L212.7 136c-6.6 1-9.2 9-4.4 13.6l31 30.2c1.9 1.8 2.7 4.5 2.3 7.1l-7.3 42.7c-1.1 6.5 5.7 11.5 11.6 8.4L284.3 218c2.3-1.2 5.1-1.2 7.4 0l38.4 20.2c5.9 3.1 12.7-1.9 11.6-8.4L334.4 187c-.4-2.6 .4-5.2 2.3-7.1l31-30.2c4.7-4.6 2.1-12.7-4.4-13.6l-42.9-6.2c-2.6-.4-4.9-2-6-4.4L295.2 86.5z"]
};
var faTrophyAlt = faTrophyStar;
var faPlugCircleBolt = {
  prefix: 'fas',
  iconName: 'plug-circle-bolt',
  icon: [576, 512, [], "e55b", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
var faFaceThermometer = {
  prefix: 'fas',
  iconName: 'face-thermometer',
  icon: [576, 512, [], "e39a", "M544 256c0 141.4-114.6 256-256 256S32 397.4 32 256S146.6 0 288 0C400 0 495.2 72 530 172.2c-14-4.1-29.8-.7-41 10.2l-150.8 146c-14.9-5.2-31.6-8.4-50.2-8.4c-55.1 0-93.8 27.9-116.1 53.5c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6C214 373.8 244.6 352 288 352s74 21.8 91.9 42.5c5.8 6.7 15.9 7.4 22.6 1.6c5.2-4.5 6.8-11.6 4.5-17.7l9.4-9-24.8-24.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.1 25.1 15.3-14.8-25.4-25.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.7 25.7 15.3-14.8-26-26c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.3 26.3L514.1 275l-26.6-26.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.9 26.9 12.5-12c.1 3.2 .2 6.4 .2 9.6zM240.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faGridRound4 = {
  prefix: 'fas',
  iconName: 'grid-round-4',
  icon: [448, 512, [], "e5dd", "M44.8 121.6a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm0 119.5a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7A44.8 44.8 0 1 1 0 315.7a44.8 44.8 0 1 1 89.6 0zM44.8 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM209.1 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM164.3 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM164.3 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM328.5 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM283.7 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM283.7 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM448 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM403.2 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM448 315.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM403.2 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6z"]
};
var faShirtRunning = {
  prefix: 'fas',
  iconName: 'shirt-running',
  icon: [384, 512, [], "e3c8", "M80 0c17.7 0 32 14.3 32 32V80c0 44.2 35.8 80 80 80s80-35.8 80-80V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 33.3 2.6 61.5 6.5 85.2L0 393.8V282.5c0-17 6.7-33.5 14.7-48.4C28.8 207.6 48 155 48 64V32C48 14.3 62.3 0 80 0zM3.8 469.8L360.4 215c3 7.5 6 13.8 8.9 19c8 15 14.7 31.5 14.7 48.4V448c0 35.3-28.7 64-64 64H64c-27.7 0-51.3-17.6-60.2-42.2z"]
};
var faBookCircleArrowUp = {
  prefix: 'fas',
  iconName: 'book-circle-arrow-up',
  icon: [640, 512, [], "e0bd", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h10.8c-23.3-16.4-42.5-38.4-55.6-64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32H320.7c-.5-5.3-.7-10.6-.7-16c0-80.6 54.1-148.5 128-169.4V32c0-17.7-14.3-32-32-32H384 96zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM428.7 371.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.6l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"]
};
var faFaceNauseated = {
  prefix: 'fas',
  iconName: 'face-nauseated',
  icon: [512, 512, [], "e381", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-12.3-84.7l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM168 282.7c19.5 11.3 33.8 30.5 38.4 53.3h99.2c4.6-22.8 18.9-42 38.4-53.3c7.7-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6c7.6 4.4 10.3 14.2 5.8 21.9s-14.2 10.3-21.9 5.8c-19.5-11.3-33.8-30.5-38.4-53.3H206.4c-4.6 22.8-18.9 42-38.4 53.3c-7.6 4.4-17.4 1.8-21.9-5.8s-1.8-17.4 5.8-21.9c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8z"]
};
var faHeart = {
  prefix: 'fas',
  iconName: 'heart',
  icon: [512, 512, [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578], "f004", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"]
};
var faFileChartPie = {
  prefix: 'fas',
  iconName: 'file-chart-pie',
  icon: [384, 512, [], "f65a", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm40 320H208c-8.8 0-16-7.2-16-16V216c0-8.8 7.2-16.1 16-14.9c53.5 7.1 95.9 49.5 103 103c1.2 8.8-6.1 16-14.9 16zM160 230V336c0 8.8 7.2 16 16 16H282c10.1 0 17.7 9.3 14.1 18.8C278.9 415.9 235.2 448 184 448c-66.3 0-120-53.7-120-120c0-51.2 32.1-94.9 77.2-112.2c9.5-3.6 18.8 4 18.8 14.1z"]
};
var faMarsAndVenus = {
  prefix: 'fas',
  iconName: 'mars-and-venus',
  icon: [512, 512, [9893], "f224", "M337.8 14.8C341.5 5.8 350.3 0 360 0H472c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59.1 146.7-136.1 158.2c0 .6 .1 1.2 .1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-24 0-24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456H208c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2 .1-1.8C155.1 370.7 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48l0 0h0v0zM256 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24h24zm96-264a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faHouseUser = {
  prefix: 'fas',
  iconName: 'house-user',
  icon: [576, 512, ["home-user"], "e1b0", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"]
};
var faHomeUser = faHouseUser;
var faCircleArrowDownLeft = {
  prefix: 'fas',
  iconName: 'circle-arrow-down-left',
  icon: [512, 512, [], "e0f9", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm64-144c13.3 0 24-10.7 24-24s-10.7-24-24-24H225.9L361 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V344c0 13.3 10.7 24 24 24H320z"]
};
var faDumpsterFire = {
  prefix: 'fas',
  iconName: 'dumpster-fire',
  icon: [640, 512, [], "f794", "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304V160zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.6-1.6 3.3-3.2 5-4.8zM325.2 210.7c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4zm128.4-78.9c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 407.9 390.3 480 480 480c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faHexagonMinus = {
  prefix: 'fas',
  iconName: 'hexagon-minus',
  icon: [512, 512, ["minus-hexagon"], "f307", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faMinusHexagon = faHexagonMinus;
var faLeftToLine = {
  prefix: 'fas',
  iconName: 'left-to-line',
  icon: [448, 512, ["arrow-alt-to-left"], "f34b", "M230.1 406.1L107.3 283.3C100.1 276.1 96 266.2 96 256s4.1-20.1 11.3-27.3L230.1 105.9c6.4-6.4 15-9.9 24-9.9c18.7 0 33.9 15.2 33.9 33.9l0 62.1 128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0 0 62.1c0 18.7-15.2 33.9-33.9 33.9c-9 0-17.6-3.6-24-9.9zM64 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32z"]
};
var faArrowAltToLeft = faLeftToLine;
var faHouseCrack = {
  prefix: 'fas',
  iconName: 'house-crack',
  icon: [576, 512, [], "e3b1", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H230.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"]
};
var faPawSimple = {
  prefix: 'fas',
  iconName: 'paw-simple',
  icon: [448, 512, ["paw-alt"], "f701", "M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm1.7 206c6.2-2.3 11.8-6.3 15-12.2l40-71.9c14.4-25.9 41.7-42 71.3-42s56.9 16.1 71.3 42l40 71.9c3.2 5.8 8.8 9.9 15 12.2c38.3 14 65.7 50.8 65.7 94c0 55.2-44.8 100-100 100c-21.2 0-40.8-6.6-56.9-17.8c-17.4-12-52.8-12-70.1 0C172.8 473.4 153.2 480 132 480C76.8 480 32 435.2 32 380c0-43.2 27.4-80 65.7-94zM304 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm48 160a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM48 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faPawAlt = faPawSimple;
var faArrowLeftLongToLine = {
  prefix: 'fas',
  iconName: 'arrow-left-long-to-line',
  icon: [640, 512, [], "e3d4", "M0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32S0 78.3 0 96zM137.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 288 608 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"]
};
var faBracketsRound = {
  prefix: 'fas',
  iconName: 'brackets-round',
  icon: [512, 512, ["parentheses"], "e0c5", "M145.8 90.6c14.7-9.8 18.7-29.7 8.9-44.4s-29.7-18.7-44.4-8.9C71.9 62.9 0 140.2 0 256S71.9 449 110.2 474.6c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4C120.1 404.3 64 345 64 256s56.1-148.3 81.8-165.4zm220.5 0C391.9 107.7 448 167 448 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C440.1 449.1 512 371.8 512 256s-71.9-193.1-110.2-218.6c-14.7-9.8-34.6-5.8-44.4 8.9s-5.8 34.6 8.9 44.4z"]
};
var faParentheses = faBracketsRound;
var faMartiniGlassCitrus = {
  prefix: 'fas',
  iconName: 'martini-glass-citrus',
  icon: [576, 512, ["cocktail"], "f561", "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177V464h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H208 120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"]
};
var faCocktail = faMartiniGlassCitrus;
var faUserShakespeare = {
  prefix: 'fas',
  iconName: 'user-shakespeare',
  icon: [448, 512, [], "e2c2", "M224 48c-44.2 0-80 35.8-80 80v32c0 40.1 29.5 73.3 68 79.1V224c0-6.6 5.4-12 12-12s12 5.4 12 12v15.1c38.5-5.8 68-39 68-79.1V128c0-44.2-35.8-80-80-80zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v23.2c0 10.9 3.7 21.5 10.5 30L373.6 195c6.7 8.4 10.4 18.8 10.4 29.6c0 26.2-21.2 47.4-47.4 47.4H286c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16H111.4C85.2 272 64 250.8 64 224.6c0-10.8 3.7-21.2 10.4-29.6l11.1-13.9c6.8-8.5 10.5-19.1 10.5-30V128zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5c4.7-4.7 12.3-4.7 17 0zM272 304c23.9 0 45.8 8.8 62.6 23.2c65.7 20.4 113.4 81.7 113.4 154c0 17-13.8 30.7-30.7 30.7H240c0-8.8-7.2-16-16-16s-16 7.2-16 16H30.7C13.8 512 0 498.2 0 481.3c0-72.4 47.7-133.6 113.4-154C130.2 312.8 152.1 304 176 304h96zM208 448a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm-80-48c26.4-10.6 54.6-16 83.1-16h25.8c28.5 0 56.7 5.4 83.1 16c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48z"]
};
var faArrowRightToArc = {
  prefix: 'fas',
  iconName: 'arrow-right-to-arc',
  icon: [512, 512, [], "e4b2", "M448 256c0-106-86-192-192-192c-17.7 0-32-14.3-32-32s14.3-32 32-32C397.4 0 512 114.6 512 256s-114.6 256-256 256c-17.7 0-32-14.3-32-32s14.3-32 32-32c106 0 192-86 192-192zM230.6 121.4l112 112c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H242.7l-57.4-57.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"]
};
var faFaceSurprise = {
  prefix: 'fas',
  iconName: 'face-surprise',
  icon: [512, 512, [128558, "surprise"], "f5c2", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSurprise = faFaceSurprise;
var faBottleWater = {
  prefix: 'fas',
  iconName: 'bottle-water',
  icon: [320, 512, [], "e4c5", "M120 0h80c13.3 0 24 10.7 24 24V64H96V24c0-13.3 10.7-24 24-24zM32 151.7c0-15.6 9-29.8 23.2-36.5l24.4-11.4c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l24.4 11.4c14.1 6.6 23.2 20.8 23.2 36.5c0 14.4-7.5 27-18.9 34.1c11.5 8.8 18.9 22.6 18.9 38.2c0 16.7-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48c0-16.7 8.5-31.4 21.5-40C40.5 415.4 32 400.7 32 384s8.5-31.4 21.5-40C40.5 335.4 32 320.7 32 304s8.5-31.4 21.5-40C40.5 255.4 32 240.7 32 224c0-15.6 7.4-29.4 18.9-38.2C39.5 178.7 32 166.1 32 151.7zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faCirclePause = {
  prefix: 'fas',
  iconName: 'circle-pause',
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faPauseCircle = faCirclePause;
var faGaugeCirclePlus = {
  prefix: 'fas',
  iconName: 'gauge-circle-plus',
  icon: [640, 512, [], "e498", "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24V292.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H512v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFolders = {
  prefix: 'fas',
  iconName: 'folders',
  icon: [576, 512, [], "f660", "M512 384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7L322.7 50.7c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faAngel = {
  prefix: 'fas',
  iconName: 'angel',
  icon: [576, 512, [], "f779", "M384 64c0 0 0 .1 0 .2s-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6s0-.1 0-.2s0-.1 0-.2s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6s0 .1 0 .2zm-16 80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM120 464H49.7l37.9-75.8c5.6-11.1 8.4-23.4 8.4-35.8v-.9c0-12.4-2.9-24.7-8.4-35.8L69.2 279c-3.4-6.7-5.2-14.4-5.2-22.1c0-27.1 22-48.9 48.2-48.9c12.8 0 25 5.1 34.1 14.1l66.4 66.4c-6.8 7.2-12.7 15.5-17.3 24.7L120 464zM253.8 261.8l-73.6-73.6c-18-18-42.5-28.2-68-28.2C59.1 160 16 203.8 16 256.9c0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3H96h96H384h96 50.7c25 0 45.3-20.3 45.3-45.3c0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3v-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9c-25.5 0-50 10.1-68 28.2l-73.6 73.6C311.4 258 299.8 256 288 256s-23.4 2-34.2 5.8zm126.8 51.4c-4.6-9.2-10.4-17.5-17.3-24.7l66.4-66.4c9-9 21.3-14.1 34.1-14.1c26.1 0 48.2 21.8 48.2 48.9c0 7.7-1.8 15.4-5.2 22.1l-18.4 36.7c-5.6 11.1-8.4 23.4-8.4 35.8v.9c0 12.4 2.9 24.7 8.4 35.8L526.3 464H456L380.6 313.2z"]
};
var faValueAbsolute = {
  prefix: 'fas',
  iconName: 'value-absolute',
  icon: [512, 512, [], "f6a6", "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32zM182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 301.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 210.7l-73.4-73.4zM512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"]
};
var faRabbit = {
  prefix: 'fas',
  iconName: 'rabbit',
  icon: [512, 512, [128007], "f708", "M321.4 128c4.8 0 9.6 .3 14.3 .9c1.1-24-2.6-47.9-10.9-70.1c7.6-17.8 18.6-34.2 32.7-48.3l4.6-4.6c3.7-3.7 8.8-5.8 14-5.8c9.2 0 17.2 6.4 19.3 15.4l1 4.4c9.8 42.4 1.8 86.5-21 122.4c5.5 3.1 10.7 6.6 15.6 10.6L425.8 181c14 11.4 22.2 28.6 22.2 46.7c0 33.3-27 60.3-60.3 60.3H352v25.8l61.7 154.3c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-39.4-98.6L265.6 448H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H208 160c-28.5 0-52.6-18.6-60.9-44.2C88.8 480.1 73.3 488 56 488c-30.9 0-56-25.1-56-56s25.1-56 56-56c17.4 0 33 8 43.3 20.5C114 317.7 176.8 255.9 256 242.7V193.4c0-10.9 2.7-21.2 7.4-30.2c-34.3-36.5-50.3-86.8-43.2-136.8l.7-4.9C222.7 9.2 233.2 0 245.7 0c6.6 0 12.9 2.6 17.6 7.3l3.1 3.1c31.8 31.5 47.9 74.8 45.4 118.4c3.1-.5 6.3-.7 9.6-.7zM368 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faToiletPaperSlash = {
  prefix: 'fas',
  iconName: 'toilet-paper-slash',
  icon: [640, 512, [], "e072", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM367.3 385.4L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"]
};
var faCircleEuro = {
  prefix: 'fas',
  iconName: 'circle-euro',
  icon: [512, 512, [], "e5ce", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 272h16c-.6-5-.9-10.1-.9-15.2c0-5.7 .4-11.3 1.1-16.8H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h24.7c19.2-46.9 65.4-80 119.2-80H313c13.3 0 24 10.7 24 24s-10.7 24-24 24H271.9c-26.3 0-49.6 12.6-64.4 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H192.9c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H206.4c14.7 20.3 38.5 33.5 65.5 33.5H313c13.3 0 24 10.7 24 24s-10.7 24-24 24H271.9c-54.4 0-101-33.8-119.8-81.5H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faAppleWhole = {
  prefix: 'fas',
  iconName: 'apple-whole',
  icon: [448, 512, [127822, 127823, "apple-alt"], "f5d1", "M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H224zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"]
};
var faAppleAlt = faAppleWhole;
var faKitchenSet = {
  prefix: 'fas',
  iconName: 'kitchen-set',
  icon: [576, 512, [], "e51a", "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faDiamondHalf = {
  prefix: 'fas',
  iconName: 'diamond-half',
  icon: [512, 512, [], "e5b7", "M256 0c-10.2 0-20.5 3.9-28.3 11.7l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c7.8 7.8 18 11.7 28.3 11.7V0z"]
};
var faLockKeyhole = {
  prefix: 'fas',
  iconName: 'lock-keyhole',
  icon: [448, 512, ["lock-alt"], "f30d", "M224 64c44.2 0 80 35.8 80 80v48H144V144c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H368V144C368 64.5 303.5 0 224 0S80 64.5 80 144zM256 320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faLockAlt = faLockKeyhole;
var faR = {
  prefix: 'fas',
  iconName: 'r',
  icon: [320, 512, [114], "52", "M64 32C28.7 32 0 60.7 0 96V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H64zM176 256H64V96H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
var faTemperatureQuarter = {
  prefix: 'fas',
  iconName: 'temperature-quarter',
  icon: [320, 512, ["temperature-1", "thermometer-1", "thermometer-quarter"], "f2ca", "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature1 = faTemperatureQuarter;
var faThermometer1 = faTemperatureQuarter;
var faThermometerQuarter = faTemperatureQuarter;
var faSquareInfo = {
  prefix: 'fas',
  iconName: 'square-info',
  icon: [448, 512, [8505, "info-square"], "f30f", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM184 336h24V272H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faInfoSquare = faSquareInfo;
var faWifiSlash = {
  prefix: 'fas',
  iconName: 'wifi-slash',
  icon: [640, 512, [], "f6ac", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L364.6 260.4c39.2 7.9 74.7 26.1 103.6 51.6c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192c-13.3 0-26.5 .9-39.3 2.7l-95.1-74.5C227.4 104.5 272.7 96 320 96c103.2 0 196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32c-68.7 0-133.7 15.5-191.9 43.1L38.8 5.1zM93.6 169.8L41.7 128.9C30.7 137.7 20 147 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9c12.4-11.9 25.6-23 39.5-33.1zM228 275.7L173 232.3c-15.5 9.2-30.1 19.8-43.5 31.7c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c16.7-14.8 35.6-27 56.2-36.3zM320 352c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-7-1.1-13.7-3.2-20l-55.6-43.8c-1.7-.1-3.4-.2-5.2-.2z"]
};
var faToiletPaperXmark = {
  prefix: 'fas',
  iconName: 'toilet-paper-xmark',
  icon: [512, 512, [], "e5b3", "M96 0H348.2C336.6 12.2 327 26.9 319.5 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9H96C43 384 0 298 0 192S43 0 96 0zM320 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192c0 35-4.7 67.8-12.8 96c-16.6 57.4-47.6 96-83.2 96c-11.2 0-22-3.8-32-10.9c-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64zM160 416H416c44.8 0 76.9-35.2 96-72.9V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V416zm51.3-283.3c-6.2-6.2-16.4-6.2-22.6 0L152 169.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L129.4 192 92.7 228.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L152 214.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L174.6 192l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faHandsHoldingDollar = {
  prefix: 'fas',
  iconName: 'hands-holding-dollar',
  icon: [640, 512, ["hands-usd"], "f4c5", "M344 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8l0 0c-2.1-.7-4.1-1.4-5.9-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"]
};
var faHandsUsd = faHandsHoldingDollar;
var faCube = {
  prefix: 'fas',
  iconName: 'cube',
  icon: [512, 512, [], "f1b2", "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z"]
};
var faArrowDownTriangleSquare = {
  prefix: 'fas',
  iconName: 'arrow-down-triangle-square',
  icon: [576, 512, ["sort-shapes-down"], "f888", "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM443.1 47l80 128c6.2 9.9 6.5 22.3 .9 32.5s-16.4 16.5-28 16.5H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6 .9-32.5l80-128c5.8-9.4 16.1-15 27.1-15s21.3 5.7 27.1 15zM320 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V336z"]
};
var faSortShapesDown = faArrowDownTriangleSquare;
var faBitcoinSign = {
  prefix: 'fas',
  iconName: 'bitcoin-sign',
  icon: [320, 512, [], "e0b4", "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32V64h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H41.7C18.7 448 0 429.3 0 406.3V288 265.7 224 101.6C0 80.8 16.8 64 37.6 64H48V32zM64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zm112 64H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"]
};
var faShutters = {
  prefix: 'fas',
  iconName: 'shutters',
  icon: [512, 512, [], "e449", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM20.6 224H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 128H24L1.1 196.8c-.7 2.1-1.1 4.3-1.1 6.5C0 214.8 9.2 224 20.6 224zM491.4 352c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 256H24L1.1 324.8c-.7 2.1-1.1 4.3-1.1 6.5C0 342.8 9.2 352 20.6 352H491.4zM20.6 480H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 384H24L1.1 452.8c-.7 2.1-1.1 4.3-1.1 6.5C0 470.8 9.2 480 20.6 480z"]
};
var faShieldDog = {
  prefix: 'fas',
  iconName: 'shield-dog',
  icon: [512, 512, [], "e573", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64V160h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160h40 8v32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSolarPanel = {
  prefix: 'fas',
  iconName: 'solar-panel',
  icon: [640, 512, [], "f5ba", "M122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C.4 347 30.6 384 71 384H288v64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H569c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0H122.2zM260.9 64H379.1l10.4 104h-139L260.9 64zM202.3 168H101.4L122.2 64h90.4L202.3 168zM91.8 216H197.5L187.1 320H71L91.8 216zm153.9 0H394.3l10.4 104-169.4 0 10.4-104zm196.8 0H548.2L569 320h-116L442.5 216zm96-48H437.7L427.3 64h90.4l31.4-6.3L517.8 64l20.8 104z"]
};
var faLockOpen = {
  prefix: 'fas',
  iconName: 'lock-open',
  icon: [576, 512, [], "f3c1", "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"]
};
var faTableTree = {
  prefix: 'fas',
  iconName: 'table-tree',
  icon: [512, 512, [], "e293", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 160V416H64V160H96v64 96c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16-7.2-16-16V269.3c5 1.8 10.4 2.7 16 2.7h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16-7.2-16-16V160H448zM224 240v32c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm80 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H304z"]
};
var faHouseChimneyHeart = {
  prefix: 'fas',
  iconName: 'house-chimney-heart',
  icon: [576, 512, [], "e1b2", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM237.3 208c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faTally3 = {
  prefix: 'fas',
  iconName: 'tally-3',
  icon: [640, 512, [], "e296", "M128 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm128 0c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM416 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faElevator = {
  prefix: 'fas',
  iconName: 'elevator',
  icon: [512, 512, [], "e16d", "M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H208c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"]
};
var faMoneyBillTransfer = {
  prefix: 'fas',
  iconName: 'money-bill-transfer',
  icon: [640, 512, [], "e528", "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64H337.9c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64h64V320zM320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faMoneyBillTrendUp = {
  prefix: 'fas',
  iconName: 'money-bill-trend-up',
  icon: [512, 512, [], "e529", "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2l0 .1v0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faHouseFloodWaterCircleArrowRight = {
  prefix: 'fas',
  iconName: 'house-flood-water-circle-arrow-right',
  icon: [640, 512, [], "e50f", "M288 144A144 144 0 1 0 0 144a144 144 0 1 0 288 0zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"]
};
var faSquarePollHorizontal = {
  prefix: 'fas',
  iconName: 'square-poll-horizontal',
  icon: [448, 512, ["poll-h"], "f682", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"]
};
var faPollH = faSquarePollHorizontal;
var faCircle = {
  prefix: 'fas',
  iconName: 'circle',
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faCartCircleExclamation = {
  prefix: 'fas',
  iconName: 'cart-circle-exclamation',
  icon: [640, 512, [], "e3f2", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faSword = {
  prefix: 'fas',
  iconName: 'sword',
  icon: [512, 512, [128481], "f71c", "M511.8 18.6c.8-5.1-.8-10.3-4.5-13.9S498.5-.6 493.4 .2L417.6 12.8c-16.4 2.7-31.6 10.6-43.4 22.3L166.6 242.7 269.3 345.4 476.8 137.8c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8zM84.7 228.7l-16 16c-5.4 5.4-6.2 13.8-2 20.2l53.1 79.6c2.1 3.2 1.7 7.4-1 10.1L79.2 394.2c-2.1 2.1-5.3 2.9-8.2 1.9L37.1 384.8c-5.7-1.9-12.1-.4-16.4 3.9l-16 16c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l16-16c4.3-4.3 5.8-10.6 3.9-16.4L115.9 441c-1-2.9-.2-6 1.9-8.2l39.6-39.6c2.7-2.7 6.9-3.1 10.1-1l79.6 53.1c6.3 4.2 14.8 3.4 20.2-2l16-16c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faBackwardFast = {
  prefix: 'fas',
  iconName: 'backward-fast',
  icon: [512, 512, [9198, "fast-backward"], "f049", "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V214.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96V214.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96V416c0 12.4-7.2 23.7-18.4 29z"]
};
var faFastBackward = faBackwardFast;
var faRecycle = {
  prefix: 'fas',
  iconName: 'recycle',
  icon: [512, 512, [9842, 9850, 9851], "f1b8", "M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM429.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L320 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32l96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L182 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3L68.8 335.3c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"]
};
var faUserAstronaut = {
  prefix: 'fas',
  iconName: 'user-astronaut',
  icon: [448, 512, [], "f4fb", "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9V128c0-16.8-12.9-30.5-29.3-31.9zM336 144v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512H128V448c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64l98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faInterrobang = {
  prefix: 'fas',
  iconName: 'interrobang',
  icon: [320, 512, [8253], "e5ba", "M144 96c-35.3 0-64 28.7-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128v3.6c0 43.6-22.1 84.1-58.8 107.7L203 298.4c-6.9 4.4-11 12-11 20.2V320c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.4V176c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4l18.6-12c18.3-11.8 29.4-32.1 29.4-53.8V160c0-35.3-28.7-64-64-64H144zM120 440a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faPlaneSlash = {
  prefix: 'fas',
  iconName: 'plane-slash',
  icon: [640, 512, [], "e069", "M514.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64H440.6L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L238.1 161.3 197.8 20.4C194.9 10.2 202.6 0 213.2 0h56.2c11.5 0 22.1 6.2 27.8 16.1L397.7 192l116.6 0zM41.5 128.7l321 252.9L297.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6H144l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4H46c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L64 256 32.5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-6.2 4-11.4 9.5-13.3z"]
};
var faCircleDashed = {
  prefix: 'fas',
  iconName: 'circle-dashed',
  icon: [512, 512, [], "e105", "M1.1 232C6 179.3 26.9 131.3 58.8 92.7l45.5 45.5C83.7 164.8 69.9 196.9 65.5 232H1.1zM138.3 104.3L92.7 58.8C131.3 26.9 179.3 6 232 1.1V65.5c-35.1 4.4-67.2 18.2-93.7 38.8zM280 446.5c35.1-4.4 67.2-18.2 93.7-38.8l45.5 45.5C380.7 485.1 332.7 506 280 510.9V446.5zm127.7-72.8c20.6-26.6 34.5-58.7 38.8-93.7h64.4c-4.9 52.7-25.8 100.7-57.7 139.3l-45.5-45.5zM92.7 453.2l45.5-45.5c26.6 20.6 58.7 34.5 93.7 38.8v64.4c-52.7-4.9-100.7-25.8-139.3-57.7zM58.8 419.3C26.9 380.7 6 332.7 1.1 280H65.5c4.4 35.1 18.2 67.2 38.8 93.7L58.8 419.3zM419.3 58.8l-45.5 45.5C347.2 83.7 315.1 69.9 280 65.5V1.1C332.7 6 380.7 26.9 419.3 58.8zm-11.6 79.5l45.5-45.5c31.9 38.5 52.8 86.6 57.7 139.3H446.5c-4.4-35.1-18.2-67.2-38.8-93.7z"]
};
var faTrademark = {
  prefix: 'fas',
  iconName: 'trademark',
  icon: [640, 512, [8482], "f25c", "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32H96V384c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128z"]
};
var faBasketball = {
  prefix: 'fas',
  iconName: 'basketball',
  icon: [512, 512, [127936, "basketball-ball"], "f434", "M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"]
};
var faBasketballBall = faBasketball;
var faForkKnife = {
  prefix: 'fas',
  iconName: 'fork-knife',
  icon: [576, 512, ["utensils-alt"], "f2e6", "M475.3 27.3c5.8-5.8 6.3-15.1 1.1-21.5S462-1.9 455.1 2.7l-106.5 71C320.8 92.3 304 123.6 304 157.1c0 19.3 5.5 37.9 15.7 53.9L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L365 256.3c16 10.2 34.7 15.7 53.9 15.7c33.5 0 64.8-16.8 83.4-44.6l71-106.5c4.6-6.8 3.2-16-3.2-21.2s-15.6-4.8-21.5 1.1L457.4 192c-5.2 5.2-13.6 5.2-18.8 0c-4.9-4.9-5.2-12.8-.6-18.1l86.1-99.4c5.5-6.3 5.2-15.9-.8-21.8s-15.4-6.3-21.8-.8L402.1 138c-5.3 4.6-13.2 4.3-18.1-.6c-5.2-5.2-5.2-13.6 0-18.8l91.3-91.3zM52.5 7.3C47.9 2.6 41.5 0 34.9 0c-11.2 0-21 7.5-23.5 18.4C6.7 38.6 0 71.5 0 96c0 83.3 48.2 130.5 128.9 209.4c6.5 6.4 13.3 13 20.3 19.9c1.9 1.8 3.8 3.5 5.9 5.1L265.4 220.1 52.5 7.3zM457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L355.9 310.6l-45.3 45.3L457.4 502.6z"]
};
var faUtensilsAlt = faForkKnife;
var faSatelliteDish = {
  prefix: 'fas',
  iconName: 'satellite-dish',
  icon: [512, 512, [128225], "f7c0", "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faBadgeCheck = {
  prefix: 'fas',
  iconName: 'badge-check',
  icon: [512, 512, [], "f336", "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
var faCircleUp = {
  prefix: 'fas',
  iconName: 'circle-up',
  icon: [512, 512, [61467, "arrow-alt-circle-up"], "f35b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H304v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V256H150.3C138 256 128 246 128 233.7c0-6.2 2.6-12.1 7.1-16.3z"]
};
var faArrowAltCircleUp = faCircleUp;
var faSlider = {
  prefix: 'fas',
  iconName: 'slider',
  icon: [512, 512, [], "e252", "M352 160V352H320V160h32zM320 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V160c0-35.3-28.7-64-64-64H320zM0 256c0 17.7 14.3 32 32 32H224V224H32c-17.7 0-32 14.3-32 32z"]
};
var faMobileScreenButton = {
  prefix: 'fas',
  iconName: 'mobile-screen-button',
  icon: [384, 512, ["mobile-alt"], "f3cd", "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64H80V384H304V64z"]
};
var faMobileAlt = faMobileScreenButton;
var faClockOneThirty = {
  prefix: 'fas',
  iconName: 'clock-one-thirty',
  icon: [512, 512, [], "e34f", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V263.3l60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faInboxOut = {
  prefix: 'fas',
  iconName: 'inbox-out',
  icon: [512, 512, [128228, "inbox-arrow-up"], "f311", "M288 109.3V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM48 320h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48z"]
};
var faInboxArrowUp = faInboxOut;
var faCloudSlash = {
  prefix: 'fas',
  iconName: 'cloud-slash',
  icon: [640, 512, [], "e137", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L600 445c24.6-23.3 40-56.3 40-93c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-46.4 0-88.2 19.8-117.4 51.3L38.8 5.1zM97.2 172.6c-.8 6.4-1.2 12.9-1.2 19.4c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144H487.4L97.2 172.6z"]
};
var faVolumeHigh = {
  prefix: 'fas',
  iconName: 'volume-high',
  icon: [640, 512, [128266, "volume-up"], "f028", "M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"]
};
var faVolumeUp = faVolumeHigh;
var faUsersRays = {
  prefix: 'fas',
  iconName: 'users-rays',
  icon: [640, 512, [], "e593", "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faWallet = {
  prefix: 'fas',
  iconName: 'wallet',
  icon: [512, 512, [], "f555", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faOctagonCheck = {
  prefix: 'fas',
  iconName: 'octagon-check',
  icon: [512, 512, [], "e426", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
var faFlatbreadStuffed = {
  prefix: 'fas',
  iconName: 'flatbread-stuffed',
  icon: [576, 512, [129369], "e40c", "M272.2 4c-12.8-7-28.7-4.5-38.7 6.1L186.6 59.9c-4.6 4.9-10.5 8.2-17.1 9.5L102.4 82.7c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2L23.1 252.1c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3l55.9-55.9C121.1 316.3 112 291.2 112 264c0-66.3 53.7-120 120-120c27.2 0 52.3 9.1 72.5 24.3L424.4 48.4c4.6-4.6 10-8.3 15.8-11.1c-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6 .8-13.3-.5-19.2-3.7L272.2 4zM159.3 313.5L281.5 191.3C267.4 181.6 250.4 176 232 176c-48.6 0-88 39.4-88 88c0 18.4 5.6 35.4 15.3 49.5zM482.8 73.1c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272c0-64.7-24.9-121.2-61.2-166.9zM256 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faClipboardCheck = {
  prefix: 'fas',
  iconName: 'clipboard-check',
  icon: [384, 512, [], "f46c", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faCartCirclePlus = {
  prefix: 'fas',
  iconName: 'cart-circle-plus',
  icon: [640, 512, [], "e3f3", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM352 368a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm208 16H512v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faTruckClock = {
  prefix: 'fas',
  iconName: 'truck-clock',
  icon: [640, 512, ["shipping-timed"], "f48c", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 176A112 112 0 1 0 96 176a112 112 0 1 0 224 0zM208 96c8.8 0 16 7.2 16 16v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"]
};
var faShippingTimed = faTruckClock;
var faPool8Ball = {
  prefix: 'fas',
  iconName: 'pool-8-ball',
  icon: [512, 512, [], "e3c5", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm384-64a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-80-48c0 11.5-4 22-10.7 30.2C304.8 184.5 312 199.4 312 216c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.6 7.2-31.5 18.7-41.8C212 166 208 155.5 208 144c0-26.5 21.5-48 48-48s48 21.5 48 48zm-48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faFileAudio = {
  prefix: 'fas',
  iconName: 'file-audio',
  icon: [384, 512, [], "f1c7", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"]
};
var faTurnDownLeft = {
  prefix: 'fas',
  iconName: 'turn-down-left',
  icon: [512, 512, [], "e331", "M177.5 446c-8.8 3.8-19 2-26-4.6l-144-136C2.7 300.9 0 294.6 0 288s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 88 192 0c17.7 0 32-14.3 32-32l0-144c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 144c0 70.7-57.3 128-128 128l-192 0 0 88c0 9.6-5.7 18.2-14.5 22z"]
};
var faLockHashtag = {
  prefix: 'fas',
  iconName: 'lock-hashtag',
  icon: [448, 512, [], "e423", "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80zm96 48c-8.8 0-16 7.2-16 16v32H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v64H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V320h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H192V256c0-8.8-7.2-16-16-16zm16 144V320h64v64H192z"]
};
var faChartRadar = {
  prefix: 'fas',
  iconName: 'chart-radar',
  icon: [512, 512, [], "e0e7", "M72.5 252c-1.4 2.5-1.4 5.5 0 8l88.3 152.9c1.4 2.5 4.1 4 6.9 4H344.3c2.9 0 5.5-1.5 6.9-4L439.5 260l48.7 28.1L439.5 260c1.4-2.5 1.4-5.5 0-8L351.2 99.1c-1.4-2.5-4.1-4-6.9-4H167.7c-2.9 0-5.5 1.5-6.9 4L72.5 252zM17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM290.2 180.8l40.2 100.6c17.1 4.6 29.6 20.1 29.6 38.6c0 22.1-17.9 40-40 40c-15.9 0-29.7-9.3-36.1-22.7l-97.2-19.4c-7.1 6.3-16.4 10.2-26.7 10.2c-22.1 0-40-17.9-40-40s17.9-40 40-40l57.6-76.8c-1-3.6-1.6-7.3-1.6-11.2c0-22.1 17.9-40 40-40s40 17.9 40 40c0 7.6-2.1 14.7-5.8 20.8zM202 271.9l79.2 15.8-31.7-79.2L202 271.9z"]
};
var faStaff = {
  prefix: 'fas',
  iconName: 'staff',
  icon: [512, 512, [], "f71b", "M284.2 44.2C297.8 17.1 325.5 0 355.8 0H432c44.2 0 80 35.8 80 80V183.9c0 35.7-23.7 67.1-58 76.9l-3.9 1.1c-4 1.2-7.5 3.9-9.5 7.5l-19 33.6c-4.3 7.7-14.1 10.4-21.8 6.1l-32.8-18.5c-3.7-2.1-8.1-2.6-12.3-1.5l-85.5 24.4c-2.6 .7-5 2.1-6.9 4.1L81.9 497.9c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9l77.3-77.3c3-3 4.7-7.1 4.7-11.3V304c0-8.8 7.2-16 16-16h37.5c4.2 0 8.3-1.7 11.3-4.7l39.4-39.4c9.6-9.6 21.5-16.6 34.6-20.4l169.6-48.5c6.9-2 11.6-8.2 11.6-15.4V112c0-8.8-7.2-16-16-16H371.8c-3.7 0-7.2 2.1-8.8 5.5v0c-11.9 23.7-40.7 33.3-64.4 21.5s-33.3-40.7-21.5-64.4l7.2-14.3z"]
};
var faBurger = {
  prefix: 'fas',
  iconName: 'burger',
  icon: [512, 512, ["hamburger"], "f805", "M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400z"]
};
var faHamburger = faBurger;
var faUtilityPole = {
  prefix: 'fas',
  iconName: 'utility-pole',
  icon: [512, 512, [], "e2c3", "M256 0c17.7 0 32 14.3 32 32V64h96V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32V56c0-13.3 10.7-24 24-24s24 10.7 24 24V96c0 17.7-14.3 32-32 32H428.8L288 221.9V288 480c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 221.9L83.2 128H32C14.3 128 0 113.7 0 96V56C0 42.7 10.7 32 24 32s24 10.7 24 24v8H80V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96V32c0-17.7 14.3-32 32-32zM140.8 128L224 183.4V128H140.8zM288 183.4L371.2 128H288v55.4z"]
};
var faTransporter6 = {
  prefix: 'fas',
  iconName: 'transporter-6',
  icon: [512, 512, [], "e2a7", "M56.7 6.6L64 32l25.4 7.3C93.3 40.4 96 43.9 96 48s-2.7 7.6-6.6 8.7L64 64 56.7 89.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32 39.3 6.6C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6zM384 512H296 216 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32zm96-128l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 416l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 384zM224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 256H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faWrench = {
  prefix: 'fas',
  iconName: 'wrench',
  icon: [512, 512, [128295], "f0ad", "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faBugs = {
  prefix: 'fas',
  iconName: 'bugs',
  icon: [576, 512, [], "e4d0", "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184H64v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"]
};
var faVectorPolygon = {
  prefix: 'fas',
  iconName: 'vector-polygon',
  icon: [448, 512, [], "e2c7", "M0 64C0 46.3 14.3 32 32 32H96c17.7 0 32 14.3 32 32H320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384.3l-4.5 7.9-28.4 49.7c.4 2.1 .6 4.2 .6 6.4v64c0 2.2-.2 4.3-.6 6.4l28.4 49.7 4.5 7.9H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32H128c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V160c-17.7 0-32-14.3-32-32V64zM322.2 372.3L292.3 320H256c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h36.3l29.9-52.3c-1.4-3.6-2.2-7.5-2.2-11.7H128c0 17.7-14.3 32-32 32V352c17.7 0 32 14.3 32 32H320c0-4.1 .8-8.1 2.2-11.7zM48 80v32H80V80H48zm320 0v32h32V80H368zM80 400H48v32H80V400zm288 0v32h32V400H368zM304 240H272v32h32V240z"]
};
var faDiagramNested = {
  prefix: 'fas',
  iconName: 'diagram-nested',
  icon: [448, 512, [], "e157", "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H128v96c0 17.7 14.3 32 32 32h96V336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V416H160c-53 0-96-43-96-96V224H48c-26.5 0-48-21.5-48-48V80z"]
};
var faRupeeSign = {
  prefix: 'fas',
  iconName: 'rupee-sign',
  icon: [448, 512, [8360, "rupee"], "f156", "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9l0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1l0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"]
};
var faRupee = faRupeeSign;
var faFileImage = {
  prefix: 'fas',
  iconName: 'file-image',
  icon: [384, 512, [128443], "f1c5", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H216 176 128 80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"]
};
var faCircleQuestion = {
  prefix: 'fas',
  iconName: 'circle-question',
  icon: [512, 512, [62108, "question-circle"], "f059", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faQuestionCircle = faCircleQuestion;
var faImageUser = {
  prefix: 'fas',
  iconName: 'image-user',
  icon: [512, 512, [], "e1b8", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4z"]
};
var faBuoy = {
  prefix: 'fas',
  iconName: 'buoy',
  icon: [576, 512, [], "e5b5", "M192 0c-17.7 0-32 14.3-32 32c0 15.3 10.8 28.1 25.1 31.3L133.8 320H96c-17.7 0-32 14.3-32 32v16c0 8.2 .7 16.1 2 23.9c21-11.1 46.9-9.9 66.9 4.2c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c20-14.1 45.9-15.3 66.9-4.2c1.3-7.8 2-15.8 2-23.9V352c0-17.7-14.3-32-32-32H442.2L390.9 63.3C405.2 60.1 416 47.3 416 32c0-17.7-14.3-32-32-32H192zM325.8 64l9.8 49L288 168.5 240.4 113l9.8-49h75.5zm21.8 108.8l17 84.9-44.9-52.4 27.9-32.6zm-91.1 32.6l-44.9 52.4 17-84.9 27.9 32.6zM221.3 320L288 242.2 354.7 320H221.3zm85.2 101.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"]
};
var faPlaneDeparture = {
  prefix: 'fas',
  iconName: 'plane-departure',
  icon: [640, 512, [128747], "f5b0", "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]
};
var faHandshakeSlash = {
  prefix: 'fas',
  iconName: 'handshake-slash',
  icon: [640, 512, [], "e060", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM96 171.6L40.6 128H0V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V171.6zM413.6 421.9L128 196.9V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V128H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faBookBookmark = {
  prefix: 'fas',
  iconName: 'book-bookmark',
  icon: [448, 512, [], "e0bb", "M0 96C0 43 43 0 96 0h96V190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5V0h32 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32z"]
};
var faBorderCenterH = {
  prefix: 'fas',
  iconName: 'border-center-h',
  icon: [448, 512, [], "f89c", "M32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224z"]
};
var faCanFood = {
  prefix: 'fas',
  iconName: 'can-food',
  icon: [384, 512, [129387], "e3e6", "M270.3 304.5c12.1-2.5 23.4-5.5 33.7-9V426c-2.8 1.6-6.6 3.6-11.8 5.7C269.8 440.9 234.4 448 192 448s-77.8-7.1-100.2-16.3c-5.2-2.1-9-4.1-11.8-5.7V295.5c10.3 3.5 21.6 6.5 33.7 9c7.6 36.3 39.8 63.5 78.3 63.5s70.7-27.2 78.3-63.5zm-100.1-40a32 32 0 1 1 43.5 46.9 32 32 0 1 1 -43.5-46.9zM16 72V240 440c0 39.8 78.8 72 176 72s176-32.2 176-72V240 72c0-39.8-78.8-72-176-72S16 32.2 16 72zm288 0c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24s112 10.7 112 24z"]
};
var faTypewriter = {
  prefix: 'fas',
  iconName: 'typewriter',
  icon: [512, 512, [], "f8e7", "M64 64C64 28.7 92.7 0 128 0H354.7c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3V192h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H64V64zm320 64H352c-17.7 0-32-14.3-32-32V64H128V192h18.7c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3c6 6 14.1 9.4 22.6 9.4H306.7c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 14.1-9.4 22.6-9.4H384V128zM160 288a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 288a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zm-32-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faArrowRightFromArc = {
  prefix: 'fas',
  iconName: 'arrow-right-from-arc',
  icon: [512, 512, [], "e4b1", "M64 256C64 150 150 64 256 64c17.7 0 32-14.3 32-32s-14.3-32-32-32C114.6 0 0 114.6 0 256S114.6 512 256 512c17.7 0 32-14.3 32-32s-14.3-32-32-32C150 448 64 362 64 256zM390.6 121.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H402.7l-57.4 57.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112z"]
};
var faCircleK = {
  prefix: 'fas',
  iconName: 'circle-k',
  icon: [512, 512, [], "e113", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm89.1-343.2l-73.1 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L238 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V298.5 152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8L310.9 135.2c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5 .3 33.9z"]
};
var faFaceHandOverMouth = {
  prefix: 'fas',
  iconName: 'face-hand-over-mouth',
  icon: [512, 512, [129762], "e378", "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L207 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V384v32.8c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-37.1 52.7c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2V384 330.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faPopcorn = {
  prefix: 'fas',
  iconName: 'popcorn',
  icon: [448, 512, [127871], "f819", "M32.2 160c-.1-1.3-.2-2.7-.2-4c0-20.9 14.5-38.3 34-42.9c-1.3-4.2-2-8.6-2-13.1c0-24.3 19.7-44 44-44c1.9 0 3.7 .1 5.6 .3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6c20.3 0 37.3 13.7 42.4 32.3c1.8-.2 3.7-.3 5.6-.3c24.3 0 44 19.7 44 44c0 4.6-.7 9-2 13.1c19.5 4.5 34 22 34 42.9c0 1.3-.1 2.7-.2 4H328.2 119.8 32.2zm-4 32H97.8l30.3 257.9c1 8.8 9 15.1 17.8 14s15.1-9 14-17.8L130 192h78V448c0 8.8 7.2 16 16 16s16-7.2 16-16V192h78L288.1 446.1c-1 8.8 5.2 16.7 14 17.8s16.7-5.2 17.8-14L350.2 192h69.6c15.6 0 28.2 12.6 28.2 28.2c0 2.5-.3 5.1-1 7.5L377.8 476.8C372 497.6 353.1 512 331.5 512h-215c-21.6 0-40.5-14.4-46.2-35.2L1 227.7c-.7-2.5-1-5-1-7.5C0 204.6 12.6 192 28.2 192z"]
};
var faHouseWater = {
  prefix: 'fas',
  iconName: 'house-water',
  icon: [576, 512, ["house-flood"], "f74f", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V393c21.3-12.2 48.1-11.4 68.8 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c20.7-14.6 47.7-15.4 69.1-3l-.5-105.6h32zM224 216c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V216zm82.5 205.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"]
};
var faHouseFlood = faHouseWater;
var faObjectSubtract = {
  prefix: 'fas',
  iconName: 'object-subtract',
  icon: [512, 512, [], "e49e", "M512 448c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-96-96 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 96 96 0c35.3 0 64 28.7 64 64l0 224zM288 288l0-224L64 64l0 224 224 0z"]
};
var faCodeBranch = {
  prefix: 'fas',
  iconName: 'code-branch',
  icon: [448, 512, [], "f126", "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V160c0 70.7-57.3 128-128 128H176c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V352 153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faWarehouseFull = {
  prefix: 'fas',
  iconName: 'warehouse-full',
  icon: [640, 512, ["warehouse-alt"], "f495", "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM376 384H488c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V408c0-13.3 10.7-24 24-24zM128 248c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V248zm24 136H296c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V408c0-13.3 10.7-24 24-24z"]
};
var faWarehouseAlt = faWarehouseFull;
var faHatCowboy = {
  prefix: 'fas',
  iconName: 'hat-cowboy',
  icon: [640, 512, [], "f8c0", "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"]
};
var faBridge = {
  prefix: 'fas',
  iconName: 'bridge',
  icon: [576, 512, [], "e4c8", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H72v64H0V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96V160H504V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM456 96v64H376V96h80zM328 96v64H248V96h80zM200 96v64H120V96h80z"]
};
var faPhoneFlip = {
  prefix: 'fas',
  iconName: 'phone-flip',
  icon: [512, 512, [128381, "phone-alt"], "f879", "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"]
};
var faPhoneAlt = faPhoneFlip;
var faArrowDownFromDottedLine = {
  prefix: 'fas',
  iconName: 'arrow-down-from-dotted-line',
  icon: [448, 512, [], "e090", "M32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM374.6 342.6l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 370.7V304 192c0-17.7 14.3-32 32-32s32 14.3 32 32V304v66.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"]
};
var faFileDoc = {
  prefix: 'fas',
  iconName: 'file-doc',
  icon: [512, 512, [], "e5ed", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z"]
};
var faSquareQuarters = {
  prefix: 'fas',
  iconName: 'square-quarters',
  icon: [448, 512, [], "e44e", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0L224 256 384 96H64zm0 320H384L224 256 64 416z"]
};
var faTruckFront = {
  prefix: 'fas',
  iconName: 'truck-front',
  icon: [512, 512, [], "e2b7", "M0 80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V368c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432C12.6 417.4 0 394.2 0 368V80zm129.9 72.2L112 224H400l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCat = {
  prefix: 'fas',
  iconName: 'cat',
  icon: [576, 512, [128008], "f6be", "M320 192h17.1c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4v4 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L280 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5v0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32h0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128v0V32 12 10.7C352 4.8 356.7 .1 362.6 0h.2c3.3 0 6.4 1.6 8.4 4.2l0 .1L384 21.3l27.2 36.3L416 64h64l4.8-6.4L512 21.3 524.8 4.3l0-.1c2-2.6 5.1-4.2 8.4-4.2h.2C539.3 .1 544 4.8 544 10.7V12 32v96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faTrashXmark = {
  prefix: 'fas',
  iconName: 'trash-xmark',
  icon: [448, 512, [], "e2b4", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zM143 239c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faCircleCaretLeft = {
  prefix: 'fas',
  iconName: 'circle-caret-left',
  icon: [512, 512, ["caret-circle-left"], "f32e", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-368 0c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"]
};
var faCaretCircleLeft = faCircleCaretLeft;
var faFiles = {
  prefix: 'fas',
  iconName: 'files',
  icon: [448, 512, [], "e178", "M320 0H160C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V128H352c-17.7 0-32-14.3-32-32V0zM448 96L416 64 384 32 352 0V45.3 64 96h32 18.7H448zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faAnchorCircleExclamation = {
  prefix: 'fas',
  iconName: 'anchor-circle-exclamation',
  icon: [640, 512, [], "e4ab", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faFaceClouds = {
  prefix: 'fas',
  iconName: 'face-clouds',
  icon: [640, 512, [], "e47d", "M128 0C104.3 0 83.6 12.9 72.6 32H64C28.7 32 0 60.7 0 96s28.7 64 64 64H224c35.3 0 64-28.7 64-64s-28.7-64-64-64c-13.2 0-25.4 4-35.6 10.8C179.7 17.9 155.9 0 128 0zM72.1 192c-5.3 20.5-8.1 41.9-8.1 64c0 114.6 75.4 211.7 179.3 244.3c-12.1-17-19.3-37.8-19.3-60.3c0-50.6 36.2-92.8 84.1-102.1C321.2 290.7 364.6 256 416 256c29.1 0 55.6 11.1 75.5 29.2c8.9-3.4 18.5-5.2 28.5-5.2c20 0 38.3 7.3 52.3 19.5c2.4-14.1 3.7-28.7 3.7-43.5C576 114.6 461.4 0 320 0c-20.6 0-40.7 2.4-59.9 7C295.2 21.3 320 55.8 320 96c0 39.6-24 73.6-58.2 88.3c6.5 5.9 10.5 14.3 10.5 23.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H72.1zm328.3-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 368h-8c-39.8 0-72 32.2-72 72s32.2 72 72 72H568c39.8 0 72-32.2 72-72s-32.2-72-72-72h-.7c.4-2.6 .7-5.3 .7-8c0-26.5-21.5-48-48-48c-13.9 0-26.4 5.9-35.1 15.3C470.9 303.8 445.3 288 416 288c-44.2 0-80 35.8-80 80z"]
};
var faUserCrown = {
  prefix: 'fas',
  iconName: 'user-crown',
  icon: [448, 512, [], "f6a4", "M144 128v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128H144zm0-108.8c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2 .6-.4 .8-.6l3-2.4L323.6 3.5c2.8-2.3 6.4-3.5 10-3.5H336c8.8 0 16 7.2 16 16V39v3.2 .1V144c0 70.7-57.3 128-128 128s-128-57.3-128-128V42.3v-.1V39 16c0-8.8 7.2-16 16-16h2.4c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3 .2 .6 .4 .8 .6l.1 .1zM0 472c0-92.8 75.2-168 168-168H280c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8z"]
};
var faTruckField = {
  prefix: 'fas',
  iconName: 'truck-field',
  icon: [640, 512, [], "e58d", "M32 96c0-35.3 28.7-64 64-64H320c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2H544c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96zM384 224h85.9l-42.7-96H384v96zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faRoute = {
  prefix: 'fas',
  iconName: 'route',
  icon: [512, 512, [], "f4d7", "M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCartCircleCheck = {
  prefix: 'fas',
  iconName: 'cart-circle-check',
  icon: [640, 512, [], "e3f1", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"]
};
var faClipboardQuestion = {
  prefix: 'fas',
  iconName: 'clipboard-question',
  icon: [384, 512, [], "e4e3", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V314.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faPanorama = {
  prefix: 'fas',
  iconName: 'panorama',
  icon: [640, 512, [], "e209", "M45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"]
};
var faCommentMedical = {
  prefix: 'fas',
  iconName: 'comment-medical',
  icon: [512, 512, [], "f7f5", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272H176c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"]
};
var faTeethOpen = {
  prefix: 'fas',
  iconName: 'teeth-open',
  icon: [576, 512, [], "f62f", "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96zM224 96c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V144c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V144zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V176c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V176zM96 480H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"]
};
var faUserTieHairLong = {
  prefix: 'fas',
  iconName: 'user-tie-hair-long',
  icon: [448, 512, [], "e460", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 261.9 58.1 272 70.6 272H224 377.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5V128C352 57.3 294.7 0 224 0zm55.7 510.9c1.8 .7 3.8 1.1 5.8 1.1H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c2.1 0 4-.4 5.8-1.1L168 512H280l-.3-1.1z"]
};
var faFileCircleMinus = {
  prefix: 'fas',
  iconName: 'file-circle-minus',
  icon: [576, 512, [], "e4ed", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]
};
var faHeadSideMedical = {
  prefix: 'fas',
  iconName: 'head-side-medical',
  icon: [512, 512, [], "f809", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM192 112v48H144c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H256V112c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z"]
};
var faTags = {
  prefix: 'fas',
  iconName: 'tags',
  icon: [512, 512, [], "f02c", "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faWineGlass = {
  prefix: 'fas',
  iconName: 'wine-glass',
  icon: [320, 512, [127863], "f4e3", "M32.1 29.3C33.5 12.8 47.4 0 64 0H256c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6V448h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H160 80c-17.7 0-32-14.3-32-32s14.3-32 32-32h48V348.4C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7H231.9l-5.3-64H93.4l-5.3 64z"]
};
var faForwardFast = {
  prefix: 'fas',
  iconName: 'forward-fast',
  icon: [512, 512, [9197, "fast-forward"], "f050", "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V214.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96V214.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z"]
};
var faFastForward = faForwardFast;
var faFaceMehBlank = {
  prefix: 'fas',
  iconName: 'face-meh-blank',
  icon: [512, 512, [128566, "meh-blank"], "f5a4", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faMehBlank = faFaceMehBlank;
var faUserRobot = {
  prefix: 'fas',
  iconName: 'user-robot',
  icon: [448, 512, [], "e04b", "M224 0c8.8 0 16 7.2 16 16V64h64c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h64V16c0-8.8 7.2-16 16-16zM16 144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm400-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 352H352c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32H352V448c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32-14.3-32-32V448c0-53 43-96 96-96zm80 112v48H144V464c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v48H208V464c0-8.8 7.2-16 16-16zm80 16v48H272V464c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSquareParking = {
  prefix: 'fas',
  iconName: 'square-parking',
  icon: [448, 512, [127359, "parking"], "f540", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 256h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64zm48 64H192v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"]
};
var faParking = faSquareParking;
var faCardDiamond = {
  prefix: 'fas',
  iconName: 'card-diamond',
  icon: [384, 512, [], "e3ea", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm180.7 84.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faFaceZipper = {
  prefix: 'fas',
  iconName: 'face-zipper',
  icon: [512, 512, [], "e3a5", "M492.4 354.4C505 324.1 512 290.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c50.3 0 97.2-14.5 136.7-39.5c-1.1-1.8-2.2-3.7-3.1-5.7l-29.1-58.1c-9.2-18.5-5.6-40.8 9-55.4l15.7-15.7c14.6-14.6 36.9-18.2 55.4-9l51.8 25.9zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM144 336v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm98.2 132.4c14.7 29.3 53.7 35.6 76.9 12.5l1.8-1.8c23.2-23.2 16.8-62.2-12.5-76.9l-58.1-29.1c-6.2-3.1-13.6-1.9-18.5 3l-15.7 15.7c-4.9 4.9-6.1 12.3-3 18.5l29.1 58.1zm62.3-36.9c4.7 4.7 4.7 12.3 0 17l-16 16c-4.7 4.7-12.3 4.7-17 0s-4.7-12.3 0-17l16-16c4.7-4.7 12.3-4.7 17 0z"]
};
var faFaceRaisedEyebrow = {
  prefix: 'fas',
  iconName: 'face-raised-eyebrow',
  icon: [512, 512, [], "e388", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM328.8 141.8c10.7-10.7 28.5-8.9 36.9 3.7l4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5zM128 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
};
var faHouseSignal = {
  prefix: 'fas',
  iconName: 'house-signal',
  icon: [576, 512, [], "e012", "M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34c87.1 25.3 155.6 94.2 180.3 181.6H464c26.5 0 48-21.5 48-48V256h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V208zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 376c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"]
};
var faSquareChevronUp = {
  prefix: 'fas',
  iconName: 'square-chevron-up',
  icon: [448, 512, ["chevron-square-up"], "f32c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM241 167L345 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167c9.4-9.4 24.6-9.4 33.9 0z"]
};
var faChevronSquareUp = faSquareChevronUp;
var faNfcSymbol = {
  prefix: 'fas',
  iconName: 'nfc-symbol',
  icon: [512, 512, [], "e531", "M348.9 471.8c10.3 9.3 25.4 10.8 37.4 3.9C461.6 432.1 512 348.8 512 256s-50.3-176.1-125.7-219.7C371 27.5 351.4 32.7 342.6 48s-3.6 34.9 11.7 43.7C410.1 124 448 186.4 448 256c0 61.4-29.5 117.2-74.8 151.7L213.4 264.2c-13.2-11.8-33.4-10.7-45.2 2.4s-10.7 33.4 2.4 45.2l178.3 160zM163.1 40.2c-10.3-9.3-25.4-10.8-37.4-3.9C50.3 79.9 0 163.2 0 256s50.3 176.1 125.7 219.7c15.3 8.8 34.9 3.6 43.7-11.7s3.6-34.9-11.7-43.7C101.9 388 64 325.7 64 256c0-61.4 29.5-117.2 74.8-151.7L298.6 247.8c13.2 11.8 33.4 10.7 45.2-2.4s10.7-33.4-2.4-45.2L163.1 40.2z"]
};
var faBarsProgress = {
  prefix: 'fas',
  iconName: 'bars-progress',
  icon: [512, 512, ["tasks-alt"], "f828", "M448 160H320V128H448v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM448 352v32H192V352H448zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"]
};
var faTasksAlt = faBarsProgress;
var faFaucetDrip = {
  prefix: 'fas',
  iconName: 'faucet-drip',
  icon: [512, 512, [128688], "e006", "M224 0c17.7 0 32 14.3 32 32V44l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192V116.2l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s-14.3-32-32-32H315.9c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32V224zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"]
};
var faArrowsToLine = {
  prefix: 'fas',
  iconName: 'arrows-to-line',
  icon: [448, 512, [], "e0a7", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H256V32zM201.4 329.4l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faDolphin = {
  prefix: 'fas',
  iconName: 'dolphin',
  icon: [512, 512, [], "e168", "M477.3 24.9c3.5-5.3 3.6-12.2 .1-17.6S467.7-.8 461.4 .2c-16.7 2.8-43.1 8.6-68.8 17C378 22 362.5 28 349 35.3C306.5 12.8 258 0 206.5 0H176C96.5 0 32 64.5 32 144c0 18.6 3.5 36.4 10 52.7L20.5 209.6C7.8 217.2 0 231 0 245.8C0 269.1 18.9 288 42.2 288H176h16 11.2l92 61.3c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V288h6.6c31.7 0 57.4 25.7 57.4 57.4c0 30.6-24 55.8-54.5 57.3l-53.4 2.7c-20.2-33-56.3-53.4-95.4-53.4H176c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6L190.1 432l-28.4 56.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h4.7c35.9 0 69.2-17.1 90.1-45.4l68 3.8c94.1 5.2 173.3-70 173.3-164.3c0-80.8-31.4-154.5-82.7-209.3l48-72zM176 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faArrowUpRight = {
  prefix: 'fas',
  iconName: 'arrow-up-right',
  icon: [384, 512, [], "e09f", "M352 128c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l146.7 0L41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 205.3 288 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224z"]
};
var faCircleR = {
  prefix: 'fas',
  iconName: 'circle-r',
  icon: [512, 512, [], "e120", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H288c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L252 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24zm80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64h56z"]
};
var faCartFlatbed = {
  prefix: 'fas',
  iconName: 'cart-flatbed',
  icon: [640, 512, ["dolly-flatbed"], "f474", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM192 80V272c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H464V176c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V32H240c-26.5 0-48 21.5-48 48z"]
};
var faDollyFlatbed = faCartFlatbed;
var faBanSmoking = {
  prefix: 'fas',
  iconName: 'ban-smoking',
  icon: [512, 512, [128685, "smoking-ban"], "f54d", "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32H384v32H333.3zm32 32H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H229.5z"]
};
var faSmokingBan = faBanSmoking;
var faCircleSortUp = {
  prefix: 'fas',
  iconName: 'circle-sort-up',
  icon: [512, 512, ["sort-circle-up"], "e032", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H352c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zm0 310.6l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96c6.2 6.2 16.4 6.2 22.6 0zM313.4 320L256 377.4 198.6 320H313.4z"]
};
var faSortCircleUp = faCircleSortUp;
var faTerminal = {
  prefix: 'fas',
  iconName: 'terminal',
  icon: [576, 512, [], "f120", "M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faMobileButton = {
  prefix: 'fas',
  iconName: 'mobile-button',
  icon: [384, 512, [], "f10b", "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM192 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHouseMedicalFlag = {
  prefix: 'fas',
  iconName: 'house-medical-flag',
  icon: [640, 512, [], "e514", "M480 0c17.7 0 32 14.3 32 32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H512V512H448V192 32c0-17.7 14.3-32 32-32zM276.8 39.7L416 159V512h1l-.2 0H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"]
};
var faBasketShopping = {
  prefix: 'fas',
  iconName: 'basket-shopping',
  icon: [576, 512, ["shopping-basket"], "f291", "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512H430c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.4L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192H171.7L253.3 35.1zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faShoppingBasket = faBasketShopping;
var faTape = {
  prefix: 'fas',
  iconName: 'tape',
  icon: [576, 512, [], "f4db", "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faChestnut = {
  prefix: 'fas',
  iconName: 'chestnut',
  icon: [448, 512, [127792], "e3f6", "M224 32c5.3 0 10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c7.5 6.8 16.7 14.3 27.2 22.8l3.1 2.5 0 0c20.3 16.4 44.7 36.1 68.2 59.6C400.8 190.2 448 258 448 352H0c0-94 47.2-161.8 96.7-211.3c23.5-23.5 47.9-43.2 68.2-59.6l3.1-2.5c10.6-8.5 19.7-16 27.2-22.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1zM4 384H444c-14.2 55.2-64.3 96-124 96H128C68.4 480 18.2 439.2 4 384z"]
};
var faBusSimple = {
  prefix: 'fas',
  iconName: 'bus-simple',
  icon: [448, 512, ["bus-alt"], "f55e", "M224 0C348.8 0 448 35.2 448 80V96 416c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32V96 80C0 35.2 99.2 0 224 0zM64 128V256c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBusAlt = faBusSimple;
var faEye = {
  prefix: 'fas',
  iconName: 'eye',
  icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
};
var faFaceSadCry = {
  prefix: 'fas',
  iconName: 'face-sad-cry',
  icon: [512, 512, [128557, "sad-cry"], "f5b3", "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V477.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V493.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faSadCry = faFaceSadCry;
var faHeat = {
  prefix: 'fas',
  iconName: 'heat',
  icon: [448, 512, [], "e00c", "M176 32c17.7 0 32 14.3 32 32v80c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V400c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144V64c0-17.7 14.3-32 32-32zM32 96c17.7 0 32 14.3 32 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C144.3 320.4 160 367.5 160 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-34.6-11.2-68.3-32-96L44.8 294.4C15.7 255.6 0 208.5 0 160V128c0-17.7 14.3-32 32-32zm320 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C432.3 320.4 448 367.5 448 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-34.6-11.2-68.3-32-96l-19.2-25.6C303.7 255.6 288 208.5 288 160V128c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faTicketAirline = {
  prefix: 'fas',
  iconName: 'ticket-airline',
  icon: [640, 512, [], "e29a", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V336c0-8.8-7.3-15.8-15.8-18c-27.7-7-48.2-32.1-48.2-62s20.5-55 48.2-62c8.6-2.2 15.8-9.1 15.8-18V128c0-35.3-28.7-64-64-64H64zm352 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM176 224l-28.5-85.5c-1.7-5.2 2.1-10.5 7.6-10.5h31.1c8.5 0 16.4 4.5 20.7 11.9L256 224h46.9c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5C334.4 281.6 319 288 302.9 288H256l-49.1 84.1c-4.3 7.4-12.2 11.9-20.7 11.9H155.1c-5.5 0-9.3-5.4-7.6-10.5L176 288H120l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H74.2c-5.2 0-9-4.9-7.8-9.9L79 259.9c.6-2.5 .6-5.2 0-7.8L66.5 201.9c-1.3-5 2.6-9.9 7.8-9.9H88c5 0 9.8 2.4 12.8 6.4L120 224h56z"]
};
var faBootHeeled = {
  prefix: 'fas',
  iconName: 'boot-heeled',
  icon: [512, 512, [], "e33f", "M128 0H63.3C46 0 32 14 32 31.3c0 1.8 .1 3.9 .6 6.2C34.6 47.1 56 154.3 56 232c0 33.2-12.8 93.5-19.7 123.2C33.6 367 32 379.3 32 391.8V488c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V472.9l125 34.7c10.5 2.9 21.3 4.4 32.1 4.4H456h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V429.7c0-27.3-15.4-52.2-39.8-64.4L327.8 309.1c-24.4-12.2-39.8-37.1-39.8-64.4V24c0-13.3-10.7-24-24-24H160V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V0z"]
};
var faArrowsMinimize = {
  prefix: 'fas',
  iconName: 'arrows-minimize',
  icon: [512, 512, ["compress-arrows"], "e0a5", "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h50.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zm448 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L397.3 160H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v50.7L457.4 9.4zM32 320c0-17.7 14.3-32 32-32H192c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352H64c-17.7 0-32-14.3-32-32zm256 0c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H397.3L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 397.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V320z"]
};
var faCompressArrows = faArrowsMinimize;
var faAudioDescription = {
  prefix: 'fas',
  iconName: 'audio-description',
  icon: [576, 512, [], "f29e", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"]
};
var faPersonMilitaryToPerson = {
  prefix: 'fas',
  iconName: 'person-military-to-person',
  icon: [512, 512, [], "e54c", "M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9H184.1c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1H66.5C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256v32c0 17.7 14.3 32 32 32H192c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5V256c0-35.3-28.7-64-64-64H96c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H352zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32l-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"]
};
var faFileShield = {
  prefix: 'fas',
  iconName: 'file-shield',
  icon: [576, 512, [], "e4f0", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"]
};
var faHexagon = {
  prefix: 'fas',
  iconName: 'hexagon',
  icon: [512, 512, [11043], "f312", "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220z"]
};
var faManhole = {
  prefix: 'fas',
  iconName: 'manhole',
  icon: [512, 512, [], "e1d6", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM281.4 115.4c5.8-7.5 14.5-14.7 23.6-11.8c64.4 20.7 111 81.1 111 152.4s-46.6 131.7-111 152.4c-9 2.9-17.8-4.3-23.6-11.8c-5.8-7.6-15.1-12.6-25.4-12.6s-19.6 4.9-25.4 12.6c-5.8 7.5-14.5 14.7-23.6 11.8C142.6 387.7 96 327.3 96 256s46.6-131.7 111-152.4c9-2.9 17.8 4.3 23.6 11.8c5.8 7.6 15.1 12.6 25.4 12.6s19.6-4.9 25.4-12.6zM192 176a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm80-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-32 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]
};
var faUserSlash = {
  prefix: 'fas',
  iconName: 'user-slash',
  icon: [640, 512, [], "f506", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z"]
};
var faPen = {
  prefix: 'fas',
  iconName: 'pen',
  icon: [512, 512, [128394], "f304", "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"]
};
var faTowerObservation = {
  prefix: 'fas',
  iconName: 'tower-observation',
  icon: [512, 512, [], "e586", "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H384.5c-.4 0-.8 0-1.1 0H128.6c-.4 0-.8 0-1.1 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32V144c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448h117zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256H197.8zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faFloppyDisks = {
  prefix: 'fas',
  iconName: 'floppy-disks',
  icon: [512, 512, [], "e183", "M96 56c0-30.9 25.1-56 56-56H370.7c14.9 0 29.1 5.9 39.6 16.4l85.3 85.3c10.5 10.5 16.4 24.7 16.4 39.6V360c0 30.9-25.1 56-56 56H152c-30.9 0-56-25.1-56-56V56zm96 8c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H192zM368 288a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM48 120V376c0 48.6 39.4 88 88 88H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faToiletPaperBlankUnder = {
  prefix: 'fas',
  iconName: 'toilet-paper-blank-under',
  icon: [512, 512, ["toilet-paper-reverse-alt"], "e29f", "M348.2 0H96C43 0 0 86 0 192S43 384 96 384H348.2c-11.6-12.2-21.1-26.9-28.7-41.9C299.5 302 288 248.9 288 192s11.5-110 31.5-150.1c7.5-15 17.1-29.7 28.7-41.9zM384 10.9c-37.3 26.4-64 97.5-64 181.1s26.7 154.7 64 181.1c10 7.1 20.8 10.9 32 10.9c35.5 0 66.6-38.6 83.2-96c8.2-28.2 12.8-61 12.8-96C512 86 469 0 416 0c-11.2 0-22 3.8-32 10.9zM416 256c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64zM160 464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V343.1c-19.1 37.8-51.2 72.9-96 72.9H160v48z"]
};
var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
var faFileCode = {
  prefix: 'fas',
  iconName: 'file-code',
  icon: [384, 512, [], "f1c9", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faSignal = {
  prefix: 'fas',
  iconName: 'signal',
  icon: [640, 512, [128246, "signal-5", "signal-perfect"], "f012", "M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM352 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faSignal5 = faSignal;
var faSignalPerfect = faSignal;
var faPump = {
  prefix: 'fas',
  iconName: 'pump',
  icon: [640, 512, [], "e442", "M128 32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM32 176c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-17.7-14.3-32-32-32zm128 48H96V384H320V96H160V224zM431.9 106.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3V413.7c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3c10.5 7 22.9 10.7 35.5 10.7H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H467.4c-12.6 0-25 3.7-35.5 10.7zM448 208c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16z"]
};
var faBus = {
  prefix: 'fas',
  iconName: 'bus',
  icon: [576, 512, [128653], "f207", "M288 0C422.4 0 512 35.2 512 80V96l0 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H192v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h0V96h0V80C64 35.2 153.6 0 288 0zM128 160v96c0 17.7 14.3 32 32 32H272V128H160c-17.7 0-32 14.3-32 32zM304 288H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H304V288zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16z"]
};
var faHeartCircleXmark = {
  prefix: 'fas',
  iconName: 'heart-circle-xmark',
  icon: [576, 512, [], "e501", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faArrowUpLeftFromCircle = {
  prefix: 'fas',
  iconName: 'arrow-up-left-from-circle',
  icon: [512, 512, [], "e09e", "M192 0H32C14.3 0 0 14.3 0 32V192c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3L297.4 342.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 64H192c17.7 0 32-14.3 32-32s-14.3-32-32-32zM325.3 67.1c-17.4-2.9-33.9 8.8-36.9 26.3s8.8 33.9 26.3 36.9C390.4 142.9 448 208.8 448 288c0 88.4-71.6 160-160 160c-79.2 0-145.1-57.6-157.8-133.3c-2.9-17.4-19.4-29.2-36.9-26.3s-29.2 19.4-26.3 36.9C84.9 431.3 177 512 288 512c123.7 0 224-100.3 224-224c0-111-80.7-203.1-186.7-220.9z"]
};
var faHouseChimney = {
  prefix: 'fas',
  iconName: 'house-chimney',
  icon: [576, 512, [63499, "home-lg"], "e3af", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64 24c0 22.1 17.9 40 40 40h24 32.5c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1h16c22.1 0 40-17.9 40-40V455.8c.3-2.6 .5-5.3 .5-8.1l-.7-160.2h32z"]
};
var faHomeLg = faHouseChimney;
var faWindowMaximize = {
  prefix: 'fas',
  iconName: 'window-maximize',
  icon: [512, 512, [128470], "f2d0", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faDryer = {
  prefix: 'fas',
  iconName: 'dryer',
  icon: [448, 512, [], "f861", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM368 304A144 144 0 1 0 80 304a144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM336 304c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H113.1c7.8-54.3 54.4-96 110.9-96c61.9 0 112 50.1 112 112z"]
};
var faFaceFrown = {
  prefix: 'fas',
  iconName: 'face-frown',
  icon: [512, 512, [9785, "frown"], "f119", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faFrown = faFaceFrown;
var faChessBishopPiece = {
  prefix: 'fas',
  iconName: 'chess-bishop-piece',
  icon: [256, 512, ["chess-bishop-alt"], "f43b", "M104 32C90.7 32 80 42.7 80 56c0 12.2 9.1 22.3 20.9 23.8C79.6 100.1 48 139 48 192c0 26.3 13.6 40.5 26.3 48H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h5.7L64 384H192l-13.7-96H184c13.3 0 24-10.7 24-24s-10.7-24-24-24h-2.3c12.7-7.5 26.3-21.7 26.3-48c0-22.5-5.7-42.4-13.9-59.5l-38.8 38.8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L177 104.4c-7.4-10-15.2-18.2-21.9-24.6C166.9 78.3 176 68.2 176 56c0-13.3-10.7-24-24-24H104zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48z"]
};
var faChessBishopAlt = faChessBishopPiece;
var faShirtTankTop = {
  prefix: 'fas',
  iconName: 'shirt-tank-top',
  icon: [384, 512, [], "e3c9", "M112 32C112 14.3 97.7 0 80 0S48 14.3 48 32V64c0 91-19.2 143.6-33.3 170.1C6.7 249.1 0 265.5 0 282.5V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V282.5c0-17-6.7-33.5-14.7-48.4C355.2 207.6 336 155 336 64V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V80c0 44.2-35.8 80-80 80s-80-35.8-80-80V32z"]
};
var faDiploma = {
  prefix: 'fas',
  iconName: 'diploma',
  icon: [640, 512, ["scroll-ribbon"], "f5ea", "M302 59.7l18 20.6 18-20.6C353.4 42.1 375.6 32 399 32h1c44.2 0 80 35.8 80 80c0 11.4-2.4 22.2-6.7 32H544v32c0-32 0-32 0-32l0 0 .1 0 .2 0 .5 0c.4 0 .8 0 1.4 .1c1 .1 2.3 .1 3.8 .3c3 .3 7 .9 11.6 2.1c9.2 2.3 21.3 6.9 33.4 15.9C620.9 181.7 640 216.2 640 272c0 47.5-13.7 81.1-32 104.1c-18 22.6-38.5 32.6-49 36.6c-7.3 2.8-14 3.3-19 3.3h-.5c-4.7 0-9.3-.5-13.9-1.5L384 383v81c0 6.2-3.6 11.9-9.2 14.5s-12.3 1.8-17-2.2L320 444.8l-37.8 31.5c-4.8 4-11.4 4.8-17 2.2s-9.2-8.3-9.2-14.5V383L114.4 414.5c-4.6 1-9.2 1.5-13.9 1.5h-.5c-4.9 0-11.7-.5-19-3.3c-10.5-4-31-14-49-36.6C13.7 353.1 0 319.5 0 272c0-55.8 19.1-90.3 44.8-109.6c12.1-9.1 24.3-13.6 33.4-15.9c4.6-1.2 8.6-1.8 11.6-2.1c1.5-.2 2.8-.3 3.8-.3c.5 0 1 0 1.4-.1l.5 0 .2 0 .1 0 0 0c0 0 0 0 0 32V144h70.7c-4.3-9.8-6.7-20.6-6.7-32c0-44.2 35.8-80 80-80h1c23.4 0 45.6 10.1 61 27.7zM240 144h54.4c6.9 0 10.5-8.1 6-13.3L265.9 91.3C259.6 84.1 250.5 80 241 80h-1c-17.7 0-32 14.3-32 32s14.3 32 32 32zm105.6 0H392h8c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1c-1.2 0-2.3 .1-3.5 .2c-8.2 .9-15.8 4.8-21.3 11.1l-34.5 39.5c-4.5 5.2-.9 13.3 6 13.3zM256 208H96.7l-.1 0c-.5 .1-1.5 .2-2.9 .5c-2.8 .7-6.7 2.1-10.6 5.1C76.9 218.3 64 231.8 64 272c0 34.5 9.6 53.7 18.1 64.3c7.2 9 14.9 13.5 19.2 15.6L256 317.4V208zM384 317.4l154.8 34.4c4.3-2 12-6.6 19.2-15.6c8.4-10.6 18.1-29.8 18.1-64.3c0-40.2-12.9-53.7-19.2-58.4c-3.9-2.9-7.7-4.4-10.6-5.1c-1.4-.3-2.4-.5-2.9-.5l-.1 0H384V317.4zM540.1 352c0 0 0 0 0 0l0 0h0zM99.9 352c0 0 0 0 0 0h0z"]
};
var faScrollRibbon = faDiploma;
var faScreencast = {
  prefix: 'fas',
  iconName: 'screencast',
  icon: [576, 512, [], "e23e", "M512 96H64v99c-13-2-26.4-3-40-3H0V96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H288V456c0-13.6-1-27-3-40H512V96zM24 224c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 344c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24z"]
};
var faWalker = {
  prefix: 'fas',
  iconName: 'walker',
  icon: [448, 512, [], "f831", "M194 64H320c17.7 0 32 14.3 32 32v64H145l17.9-71.8C166.5 74 179.3 64 194 64zM352 224V392.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V96c0-53-43-96-96-96H194c-44.1 0-82.4 30-93.1 72.7L1 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3L129 224H352zm32 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPrescription = {
  prefix: 'fas',
  iconName: 'prescription',
  icon: [448, 512, [], "f5b1", "M32 0C14.3 0 0 14.3 0 32V192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224h50.7l128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0H32zM176 160H64V64H176c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
};
var faShop = {
  prefix: 'fas',
  iconName: 'shop',
  icon: [640, 512, ["store-alt"], "f54f", "M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z"]
};
var faStoreAlt = faShop;
var faFloppyDisk = {
  prefix: 'fas',
  iconName: 'floppy-disk',
  icon: [448, 512, [128190, 128426, "save"], "f0c7", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSave = faFloppyDisk;
var faVihara = {
  prefix: 'fas',
  iconName: 'vihara',
  icon: [640, 512, [], "f6a7", "M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24H576v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H24c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V176 128h-7.5c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128H320 224v64h72 48 72V128zM160 288v64H296h24 24H480V288H344 320h0H296 160z"]
};
var faFaceKissClosedEyes = {
  prefix: 'fas',
  iconName: 'face-kiss-closed-eyes',
  icon: [512, 512, [], "e37d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-93.5-80.1c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faScaleUnbalanced = {
  prefix: 'fas',
  iconName: 'scale-unbalanced',
  icon: [640, 512, ["balance-scale-left"], "f515", "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288L512 163.8 584.4 288H439.6zM512 384c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 273.1c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zM129.2 291.8L201.6 416H56.7l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L153.2 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"]
};
var faBalanceScaleLeft = faScaleUnbalanced;
var faFileUser = {
  prefix: 'fas',
  iconName: 'file-user',
  icon: [384, 512, [], "f65c", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"]
};
var faUserPoliceTie = {
  prefix: 'fas',
  iconName: 'user-police-tie',
  icon: [448, 512, [], "e334", "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM227 48.6l32 12.8c3 1.2 5 4.2 5 7.4c0 17.2-7 46.1-36.9 58.6c-2 .8-4.2 .8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8c1.9-.8 4-.8 5.9 0zM98.1 168.8C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zm89.5 206.3L208 416l-12.2 48.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512H192v0h64v0H422.4c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.2 464.9 240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2H201.9c-11.9 0-19.6 12.5-14.3 23.2zm172 38.4l5.4 16.6 17.4 0c3.5 0 6.6 2.2 7.6 5.5s-.1 6.9-2.9 9L373 454.8l5.4 16.6c1.1 3.3-.1 6.9-2.9 9s-6.6 2-9.4 0L352 470.1l-14.1 10.3c-2.8 2-6.6 2.1-9.4 0s-4-5.7-2.9-9l5.4-16.6-14.1-10.2c-2.8-2-4-5.7-2.9-9s4.2-5.5 7.6-5.5l17.4 0 5.4-16.6c1.1-3.3 4.1-5.5 7.6-5.5s6.5 2.2 7.6 5.5z"]
};
var faFaceTongueMoney = {
  prefix: 'fas',
  iconName: 'face-tongue-money',
  icon: [512, 512, [], "e39d", "M0 256C0 364.6 67.7 457.5 163.1 494.6C151.1 476.8 144 455.2 144 432V421.5c-22.4-20.1-39-46.1-47.2-75.4c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1c-8.2 29.4-24.9 55.4-47.2 75.4V432c0 23.2-7.1 44.8-19.1 62.6C444.3 457.5 512 364.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM192 104v9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c3 6.6 3.5 13.9 2.2 21.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2V248c0 8.8-7.2 16-16 16s-16-7.2-16-16V237.2c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1V104c0-8.8 7.2-16 16-16s16 7.2 16 16zM336 88c8.8 0 16 7.2 16 16v9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c3 6.6 3.5 13.9 2.2 21.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2V248c0 8.8-7.2 16-16 16s-16-7.2-16-16V237.2c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1V104c0-8.8 7.2-16 16-16zm0 264H176v80c0 44.2 35.8 80 80 80s80-35.8 80-80V352zm-80 16c5.9 0 10.7 4.9 10.7 10.9v6.7c3 .6 5.8 1.2 8.1 1.8c5.7 1.6 9.1 7.5 7.6 13.3s-7.4 9.3-13 7.7c-5.5-1.5-12.6-2.8-18-2.2c-2.7 .3-4.1 .9-4.7 1.4c-1.7 1.3-1.7 3.8-.2 4.9c4.6 3.3 10 4.7 15.5 6.2c5.6 1.5 11.2 3 15.9 6.4c3.2 2.3 6.3 5.5 8.3 9.9c2 4.5 2.3 9.4 1.5 14.4c-1.3 7.8-5.3 13.9-11.3 17.7c-3.1 1.9-6.4 3-9.6 3.6v6.1c0 6-4.8 10.9-10.7 10.9s-10.7-4.9-10.7-10.9v-7.3c-5.6-1.3-10.7-3-14-4.1c-5.6-1.9-8.6-8.1-6.8-13.8s7.9-8.8 13.5-6.9c6.3 2.1 14.6 4.7 21.3 4.8c3.3 .1 5.1-.5 5.9-1c1.8-1.1 2.1-4.3 .4-5.5c-2.3-1.7-6.2-2.9-12.6-4.8l-.8-.2c-5.2-1.5-12.6-3.7-18.1-7.6c-3.2-2.3-6.3-5.5-8.3-9.9c-2-4.5-2.3-9.4-1.5-14.4c1.2-6.9 4.6-12.4 9.6-16.1c3.6-2.6 7.5-4.1 11.3-4.9v-6.4c0-6 4.8-10.9 10.7-10.9z"]
};
var faTennisBall = {
  prefix: 'fas',
  iconName: 'tennis-ball',
  icon: [512, 512, [127934], "f45e", "M.2 245.1C.1 248.7 0 252.3 0 256C0 397.4 114.6 512 256 512c3.7 0 7.3-.1 10.9-.2c-3.8-10.7-6.6-21.8-8.4-33.1c-4.4-27.2-2.9-55 4.4-81.6s20.2-51.2 37.9-72.4s39.7-38.2 64.5-50.1s52-18.2 79.5-18.7c22.8-.4 45.5 3.3 67 10.9c.2-3.6 .2-7.2 .2-10.9C512 114.6 397.4 0 256 0c-3.7 0-7.3 .1-10.9 .2c10.7 30.5 13.7 63.4 8.2 95.6c-7.1 42.4-28.3 81.2-60 110.1s-72.4 46.4-115.2 49.6c-26.6 2-53.1-1.7-77.9-10.4zM206.8 4.7C104.9 24.6 24.6 104.9 4.7 206.8C26.9 216 51.1 220 75.3 218.2c34.5-2.5 67.2-16.6 92.8-39.9s42.6-54.5 48.4-88.7c4.8-28.7 1.4-58.2-9.7-84.9zM445.4 293.4c-22.2 .4-44 5.5-64 15.1s-37.7 23.3-52 40.3s-24.6 36.9-30.5 58.3s-7.1 43.8-3.5 65.7c1.9 11.9 5.2 23.5 9.8 34.6c101.9-19.8 182.2-100.2 202.1-202.1c-19.6-8.1-40.6-12.1-61.9-11.8z"]
};
var faSquareL = {
  prefix: 'fas',
  iconName: 'square-l',
  icon: [448, 512, [], "e275", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM176 152V336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSortUp = {
  prefix: 'fas',
  iconName: 'sort-up',
  icon: [320, 512, ["sort-asc"], "f0de", "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
};
var faSortAsc = faSortUp;
var faCalendarArrowUp = {
  prefix: 'fas',
  iconName: 'calendar-arrow-up',
  icon: [448, 512, ["calendar-upload"], "e0d1", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM248 424V321.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V424c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faCalendarUpload = faCalendarArrowUp;
var faCommentDots = {
  prefix: 'fas',
  iconName: 'comment-dots',
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCommenting = faCommentDots;
var faPlantWilt = {
  prefix: 'fas',
  iconName: 'plant-wilt',
  icon: [512, 512, [], "e5aa", "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V120C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V248c0-30.9 25.1-56 56-56s56 25.1 56 56v32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V280 248 120z"]
};
var faScarf = {
  prefix: 'fas',
  iconName: 'scarf',
  icon: [512, 512, [129507], "f7c1", "M416 168.8c0 22.8-7 44.9-19.9 63.4L278.6 114.7l15.1-15.1C283.1 97.5 270.3 96 256 96s-27.1 1.5-37.8 3.6L256 137.4 374.6 256l9.4 9.4 11.3 11.3 112 112c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L384 310.6 358.6 336 459.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 358.6 310.6 384 411.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-112-112L128.4 247C107.7 226.3 96 198.1 96 168.8c0-19 4.9-37.7 14.2-54.2l41.5-73.8C165.9 15.6 192.5 0 221.4 0h69.1c28.9 0 55.6 15.6 69.7 40.8l41.5 73.8c9.3 16.6 14.2 35.2 14.2 54.2zM4.7 388.7l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"]
};
var faAlbumCirclePlus = {
  prefix: 'fas',
  iconName: 'album-circle-plus',
  icon: [576, 512, [], "e48c", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7c-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4c6.5 25.5 18.5 48.7 34.8 68.4H64c-35.3 0-64-28.7-64-64V96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208 0a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faUserNurseHairLong = {
  prefix: 'fas',
  iconName: 'user-nurse-hair-long',
  icon: [448, 512, [], "e45e", "M96 70.2V128h.3c-.2 2.6-.3 5.3-.3 8v24 11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 293.9 58.1 304 70.6 304H224 377.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5V160 136c0-2.7-.1-5.4-.3-8h.3V70.2c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80l32 0c29.8 0 55.9-16.3 69.6-40.5C257.3 150.4 275.5 160 296 160h8zM151.4 346.8c-6.4-6.8-15.4-10.6-24.6-9.3C55.1 347.7 0 409.4 0 483.8C0 499.4 12.6 512 28.2 512H419.8c15.6 0 28.2-12.6 28.2-28.2c0-74.5-55.1-136.1-126.7-146.3c-9.2-1.3-18.3 2.5-24.6 9.3l-61 64.8c-6.3 6.7-17 6.7-23.3 0l-61-64.8zM208 48c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8V64h16c4.4 0 8 3.6 8 8V88c0 4.4-3.6 8-8 8H240v16c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8V96H192c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h16V48z"]
};
var faDiamond = {
  prefix: 'fas',
  iconName: 'diamond',
  icon: [512, 512, [9830], "f219", "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"]
};
var faSquareLeft = {
  prefix: 'fas',
  iconName: 'square-left',
  icon: [448, 512, [11013, "arrow-alt-square-left"], "f351", "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm185.4 39.1L85.5 242.2C82 245.9 80 250.9 80 256s2 10.1 5.5 13.8l99.9 107.1c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1z"]
};
var faArrowAltSquareLeft = faSquareLeft;
var faFaceGrinSquint = {
  prefix: 'fas',
  iconName: 'face-grin-squint',
  icon: [512, 512, [128518, "grin-squint"], "f585", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faGrinSquint = faFaceGrinSquint;
var faCircleEllipsisVertical = {
  prefix: 'fas',
  iconName: 'circle-ellipsis-vertical',
  icon: [512, 512, [], "e10b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHandHoldingDollar = {
  prefix: 'fas',
  iconName: 'hand-holding-dollar',
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faHandHoldingUsd = faHandHoldingDollar;
var faGridDividers = {
  prefix: 'fas',
  iconName: 'grid-dividers',
  icon: [512, 512, [], "e3ad", "M0 24C0 10.7 10.7 0 24 0H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM64 96h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm0 288h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zM192 128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V128zm32 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zM352 128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V128zm32 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zM24 288H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faBacterium = {
  prefix: 'fas',
  iconName: 'bacterium',
  icon: [512, 512, [], "e05a", "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7l0 0-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM92.1 363.3l0 0L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHandPointer = {
  prefix: 'fas',
  iconName: 'hand-pointer',
  icon: [448, 512, [], "f25a", "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v48 16 48c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"]
};
var faDrumSteelpan = {
  prefix: 'fas',
  iconName: 'drum-steelpan',
  icon: [576, 512, [], "f56a", "M288 32c159.1 0 288 48 288 128V352c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"]
};
var faHandScissors = {
  prefix: 'fas',
  iconName: 'hand-scissors',
  icon: [512, 512, [], "f257", "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9l0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"]
};
var faHandsPraying = {
  prefix: 'fas',
  iconName: 'hands-praying',
  icon: [640, 512, ["praying-hands"], "f684", "M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V219.1c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32V342.3c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480V384c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2V238.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"]
};
var faPrayingHands = faHandsPraying;
var faFacePensive = {
  prefix: 'fas',
  iconName: 'face-pensive',
  icon: [512, 512, [], "e384", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 384h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM387.2 270.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM65.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8L87.2 222.3c-7.9 4-17.5 .7-21.5-7.2zm373.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L402 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z"]
};
var faUserMusic = {
  prefix: 'fas',
  iconName: 'user-music',
  icon: [640, 512, [], "f8eb", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c36.3 0 70.1 10.9 98.3 29.5v51.6c-18 2.5-34.8 9.1-48.5 19.4c-17.6 13.2-31.5 34-31.5 59.5c0 19.1 7.7 35.4 18.9 48H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM630 164.5c6.3 4.5 10 11.8 10 19.5v48V392c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V265.3l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V296 248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"]
};
var faArrowRotateRight = {
  prefix: 'fas',
  iconName: 'arrow-rotate-right',
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"]
};
var faArrowRightRotate = faArrowRotateRight;
var faArrowRotateForward = faArrowRotateRight;
var faRedo = faArrowRotateRight;
var faMessagesDollar = {
  prefix: 'fas',
  iconName: 'messages-dollar',
  icon: [640, 512, ["comments-alt-dollar"], "f652", "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V320H64c-35.3 0-64-28.7-64-64V64zM256 352h96c53 0 96-43 96-96V128H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H544v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320c-35.3 0-64-28.7-64-64V352zM228 56c0-11-9-20-20-20s-20 9-20 20V70c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V264c0 11 9 20 20 20s20-9 20-20V250.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V56z"]
};
var faCommentsAltDollar = faMessagesDollar;
var faSensorOn = {
  prefix: 'fas',
  iconName: 'sensor-on',
  icon: [640, 512, [], "e02b", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm88 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24zm413.3 12l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM536 232h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H536c-13.3 0-24-10.7-24-24s10.7-24 24-24zm13.3 140l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7z"]
};
var faBalloon = {
  prefix: 'fas',
  iconName: 'balloon',
  icon: [384, 512, [], "e2e3", "M0 192C0 86 86 0 192 0S384 86 384 192c0 102.6-102.8 194.9-143.6 227.5c-9.3 7.4-12.5 20.4-7.1 31l21.4 42.7c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9H140.9c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8l21.4-42.7c5.3-10.6 2.1-23.6-7.1-31C102.8 386.9 0 294.6 0 192zm96-16c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.1 64 64 114.1 64 176c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faBiohazard = {
  prefix: 'fas',
  iconName: 'biohazard',
  icon: [576, 512, [9763], "f780", "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"]
};
var faChessQueenPiece = {
  prefix: 'fas',
  iconName: 'chess-queen-piece',
  icon: [256, 512, ["chess-queen-alt"], "f446", "M104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM229.9 124.9l-41.5 67.5c11.2 2.1 19.6 11.8 19.6 23.6c0 13.3-10.7 24-24 24h-8l19.6 144H60.4L80 240H72c-13.3 0-24-10.7-24-24c0-11.8 8.5-21.5 19.6-23.6L26.1 124.9c-3.7-6-3-13.6 1.6-18.9s12.1-6.9 18.6-4.1c3 1.3 6.3 2.1 9.8 2.1c11.8 0 21.6-8.5 23.6-19.7c1.1-6.3 6-11.4 12.3-12.8s12.8 1.1 16.5 6.4C112.8 84 119.9 88 128 88s15.2-4 19.6-10.1c3.7-5.3 10.2-7.8 16.5-6.4s11.1 6.4 12.3 12.8c2 11.2 11.8 19.7 23.6 19.7c3.5 0 6.8-.7 9.8-2.1c6.4-2.9 13.9-1.2 18.6 4.1s5.3 13 1.6 18.9zM208 416l43.2 57.6c3.1 4.2 4.8 9.2 4.8 14.4c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24c0-5.2 1.7-10.2 4.8-14.4L48 416H208z"]
};
var faChessQueenAlt = faChessQueenPiece;
var faLocationCrosshairs = {
  prefix: 'fas',
  iconName: 'location-crosshairs',
  icon: [512, 512, ["location"], "f601", "M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faLocation = faLocationCrosshairs;
var faMarsDouble = {
  prefix: 'fas',
  iconName: 'mars-double',
  icon: [640, 512, [9891], "f227", "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312zm88 48h0v0l0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zM368 480c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2v.2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7V168c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"]
};
var faHousePersonLeave = {
  prefix: 'fas',
  iconName: 'house-person-leave',
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0L379.5 117.2c-32.6 19.5-57.5 50.2-69.6 86.7l-2.6 7.8c-11.2 33.5 6.9 69.8 40.5 81c15.8 5.3 32.2 4 46.3-2.3L361.5 372l-44 44H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM128 208v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM528 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM443.7 200.5l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L601 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L567 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5c-1 .4-1.9 .8-2.9 1.2zm-30 135.1c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L388.7 398l25-62.4z"]
};
var faHouseLeave = faHousePersonLeave;
var faHousePersonDepart = faHousePersonLeave;
var faRulerTriangle = {
  prefix: 'fas',
  iconName: 'ruler-triangle',
  icon: [512, 512, [128208], "f61c", "M0 32V448c0 35.3 28.7 64 64 64H480c17.7 0 32-14.3 32-32v-2.7c0-8.5-3.4-16.6-9.4-22.6l-51.3-51.3-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24L131.3 83.3l-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24L57.4 9.4C51.4 3.4 43.2 0 34.7 0H32C14.3 0 0 14.3 0 32zM128 256L256 384H128V256z"]
};
var faCardClub = {
  prefix: 'fas',
  iconName: 'card-club',
  icon: [384, 512, [], "e3e9", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM130.1 208.3C101.9 211.3 80 235.1 80 264c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8V336H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V303.2c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56c0-28.9-21.9-52.7-50.1-55.7c1.4-5.2 2.1-10.7 2.1-16.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6 .7 11.1 2.1 16.3z"]
};
var faChildDress = {
  prefix: 'fas',
  iconName: 'child-dress',
  icon: [320, 512, [], "e59c", "M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400H88z"]
};
var faUsersBetweenLines = {
  prefix: 'fas',
  iconName: 'users-between-lines',
  icon: [640, 512, [], "e591", "M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faLungsVirus = {
  prefix: 'fas',
  iconName: 'lungs-virus',
  icon: [640, 512, [], "e067", "M320 0c17.7 0 32 14.3 32 32V156.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSpinnerThird = {
  prefix: 'fas',
  iconName: 'spinner-third',
  icon: [512, 512, [], "f3f4", "M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z"]
};
var faFaceGrinTears = {
  prefix: 'fas',
  iconName: 'face-grin-tears',
  icon: [640, 512, [128514, "grin-tears"], "f588", "M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.4 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"]
};
var faGrinTears = faFaceGrinTears;
var faPhone = {
  prefix: 'fas',
  iconName: 'phone',
  icon: [512, 512, [128222, 128379], "f095", "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"]
};
var faComputerMouseScrollwheel = {
  prefix: 'fas',
  iconName: 'computer-mouse-scrollwheel',
  icon: [384, 512, ["mouse-alt"], "f8cd", "M160 0C71.6 0 0 71.6 0 160V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V160C384 71.6 312.4 0 224 0H160zm64 128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faMouseAlt = faComputerMouseScrollwheel;
var faCalendarXmark = {
  prefix: 'fas',
  iconName: 'calendar-xmark',
  icon: [512, 512, ["calendar-times"], "f273", "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zM337 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"]
};
var faCalendarTimes = faCalendarXmark;
var faChildReaching = {
  prefix: 'fas',
  iconName: 'child-reaching',
  icon: [384, 512, [], "e59d", "M256 64A64 64 0 1 0 128 64a64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"]
};
var faTableLayout = {
  prefix: 'fas',
  iconName: 'table-layout',
  icon: [512, 512, [], "e290", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 96v64H64V96H448zM64 224h64V416H64V224zm384 0V416H192V224H448z"]
};
var faNarwhal = {
  prefix: 'fas',
  iconName: 'narwhal',
  icon: [640, 512, [], "f6fe", "M639.3 20.7c2.4-7.8-1.4-16.1-8.9-19.4s-16.2-.4-20.2 6.6L516.7 168.3c-16.9-5.4-34.9-8.3-53.6-8.3c-50.9 0-100.7 17.5-140.2 49.6L154.1 346.8c-10.5 8.5-26.1 1.1-26.1-12.4V253.1l29.9-20.9c21.4-15 34.1-39.4 34.1-65.5l0-54.7c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112l0 54.7c0 26.1 12.7 50.6 34.1 65.5L64 253.1V352c0 88.4 71.6 160 160 160H464c97.2 0 176-78.8 176-176c0-51.4-22.3-97.7-57.8-129.9l57-185.4zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faRampLoading = {
  prefix: 'fas',
  iconName: 'ramp-loading',
  icon: [448, 512, [], "f4d4", "M32 48C32 21.5 53.5 0 80 0H368c26.5 0 48 21.5 48 48V440.4l-64-128V64H96V312.4l-64 128V48zM404.4 488.8c.8 1.5 1.2 3 1.5 4.6c1.5 9.3-5.6 18.6-15.8 18.6H368 80 57.9c-10.2 0-17.4-9.2-15.8-18.6c.3-1.5 .7-3.1 1.5-4.6L96 384l32-64H320l32 64 52.4 104.8z"]
};
var faCalendarCirclePlus = {
  prefix: 'fas',
  iconName: 'calendar-circle-plus',
  icon: [576, 512, [], "e470", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3V192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faToothbrush = {
  prefix: 'fas',
  iconName: 'toothbrush',
  icon: [576, 512, [129701], "f635", "M64 224c-35.3 0-64-28.7-64-64s28.7-64 64-64H288c31.2 0 38.2-22.7 39.6-48c.5-8.8 7.6-16.1 16.4-15.2c52.4 5.3 104 36.7 104 95.2c0 53-43 96-96 96H64zm-8 32c13.3 0 24 10.7 24 24V416h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24V416h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24V416h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24V416h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24V416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V280c0-13.3 10.7-24 24-24z"]
};
var faBorderInner = {
  prefix: 'fas',
  iconName: 'border-inner',
  icon: [448, 512, [], "f84e", "M64 448A32 32 0 1 1 0 448a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0-384A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zM416 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 352A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM416 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 160A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM0 256c0-17.7 14.3-32 32-32l160 0 0-160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160L32 288c-17.7 0-32-14.3-32-32z"]
};
var faPawClaws = {
  prefix: 'fas',
  iconName: 'paw-claws',
  icon: [512, 512, [], "f702", "M178.1 15.3C183 9.9 192 13.4 192 20.7V71.2c18.3 9.8 34.3 28.9 42.5 53.6c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5c-4-11.9-5.7-23.9-5.5-35.2h0c0-25.7 9.6-50.6 26.9-69.6l39.2-43.1zm132 206.3c-32.3-10.6-46.9-53.9-32.6-96.8c8.2-24.7 24.2-43.8 42.5-53.6V20.7c0-7.3 9-10.8 13.9-5.4l39.2 43.1c17.3 19 26.9 43.9 26.9 69.6h0c.2 11.3-1.5 23.2-5.5 35.1c-14.3 42.9-52.1 69.1-84.4 58.5zm-209.7 8.9c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3C3.7 267.8-.1 253.3 0 240H0v-3.2c0-13.5 4.3-26.7 12.2-37.6l37.3-51.3c4.6-6.3 14.5-3 14.5 4.7v44.2c13.9 6.1 27.1 17.8 36.4 33.7zM69.2 433.2C121.6 291.9 214.7 256 256 256s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 512 64 491.1 64 465.3v-1.6c0-10.4 1.6-20.7 5.2-30.5zM421.8 314.7c-24.5-14-29.1-51.7-10.2-84.1c9.3-15.9 22.4-27.6 36.4-33.7V152.6c0-7.7 9.9-11 14.5-4.7l37.3 51.3c8 10.9 12.2 24.1 12.2 37.6V240h0c.1 13.3-3.7 27.8-11.6 41.4c-18.9 32.4-54 47.3-78.5 33.3z"]
};
var faKiwiFruit = {
  prefix: 'fas',
  iconName: 'kiwi-fruit',
  icon: [448, 512, [], "e30c", "M448 176c0 79.5-100.3 144-224 144S0 255.5 0 176S100.3 32 224 32s224 64.5 224 144zM224 64c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zM64 176c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm256 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm-96 56c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-8.8-7.2-16-16-16zM139.3 92.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm192 0c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-176 150.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24s25.1 24 56 24s56-10.7 56-24zM224 480C102.4 480 3.4 383.1 .1 262.2c13.2 16.4 29.8 30.7 48.2 42.5C94.7 334.6 156.9 352 224 352s129.3-17.4 175.7-47.3c18.5-11.9 35-26.2 48.2-42.5C444.6 383.1 345.6 480 224 480z"]
};
var faTrafficLightSlow = {
  prefix: 'fas',
  iconName: 'traffic-light-slow',
  icon: [320, 512, [], "f639", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm72 368a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm0-128a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM136 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faRectangleCode = {
  prefix: 'fas',
  iconName: 'rectangle-code',
  icon: [512, 512, [], "e322", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm294.2 71.9c-8.9 9.9-8.1 25 1.8 33.9L356.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L155.9 256l60.2-54.2z"]
};
var faHeadSideVirus = {
  prefix: 'fas',
  iconName: 'head-side-virus',
  icon: [512, 512, [], "e064", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faKeyboardBrightness = {
  prefix: 'fas',
  iconName: 'keyboard-brightness',
  icon: [640, 512, [], "e1c0", "M134.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 192c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96zm153.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64zM0 384c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm224-32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H544z"]
};
var faBooksMedical = {
  prefix: 'fas',
  iconName: 'books-medical',
  icon: [576, 512, [], "f7e8", "M64 32C64 14.3 78.3 0 96 0h64c17.7 0 32 14.3 32 32V96H64V32zm0 384H192v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416zM224 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96H224V32zm0 96H352V384H224V128zm0 288H352v64c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V416zm203.6-19.9L384 232.6V142.8l100.4-26.9 66 247.4L427.6 396.1zM476.2 85L384 109.6V11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L476.2 85zM435.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L435.8 427zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H128v48c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V288H16c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16H64V176z"]
};
var faLightbulbSlash = {
  prefix: 'fas',
  iconName: 'lightbulb-slash',
  icon: [640, 512, [], "f673", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-195-152.8c4.4-6.2 8.9-12.4 13.4-18.6l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C249.7 0 189.1 41.2 160.8 100.8L38.8 5.1zM213.3 141.9C227.7 96.7 270 64 320 64c8.8 0 16 7.2 16 16s-7.2 16-16 16c-40 0-73.1 29.3-79 67.6l-27.7-21.7zm-60.9 87.9c5.4 16.8 13.2 32.4 23 46.6c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H348.1L152.4 229.8zM240 416v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-7.1L388.7 416H240z"]
};
var faHouseBlank = {
  prefix: 'fas',
  iconName: 'house-blank',
  icon: [576, 512, ["home-blank"], "e487", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
};
var faHomeBlank = faHouseBlank;
var faSquare5 = {
  prefix: 'fas',
  iconName: 'square-5',
  icon: [448, 512, [], "e25a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm112 96H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H196l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z"]
};
var faSquareHeart = {
  prefix: 'fas',
  iconName: 'square-heart',
  icon: [448, 512, [128159, "heart-square"], "f4c8", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM99.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L246.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 280.9z"]
};
var faHeartSquare = faSquareHeart;
var faPuzzle = {
  prefix: 'fas',
  iconName: 'puzzle',
  icon: [512, 512, [], "e443", "M320 0H448c35.3 0 64 28.7 64 64V192c0 8.8-7.2 16-16 16H444c-6.6 0-12 5.4-12 12v4c0 17.7-14.3 32-32 32s-32-14.3-32-32v-4c0-6.6-5.4-12-12-12l-36 0c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-8.8 0-16-7.2-16-16V16c0-8.8 7.2-16 16-16zM0 256V128C0 92.7 28.7 64 64 64H192c8.8 0 16 7.2 16 16v36c0 6.6 5.4 12 12 12h4c17.7 0 32 14.3 32 32s-14.3 32-32 32h-4c-6.6 0-12 5.4-12 12v52c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V240c0-17.7-14.3-32-32-32s-32 14.3-32 32v16c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM0 448V320c0-8.8 7.2-16 16-16H192c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H64c-35.3 0-64-28.7-64-64zM240 320c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v16c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16V448c0 35.3-28.7 64-64 64H256c-8.8 0-16-7.2-16-16V320z"]
};
var faUserGear = {
  prefix: 'fas',
  iconName: 'user-gear',
  icon: [640, 512, ["user-cog"], "f4fe", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V454.8c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
};
var faUserCog = faUserGear;
var faPipeCircleCheck = {
  prefix: 'fas',
  iconName: 'pipe-circle-check',
  icon: [640, 512, [], "e436", "M32 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm448 0c17.7 0 32 14.3 32 32v64.7c-5.3-.5-10.6-.7-16-.7c-16.6 0-32.7 2.3-48 6.6V128c0-17.7 14.3-32 32-32zM320 368c0 5.4 .2 10.7 .7 16H96V128H416v83.2c-57 29.1-96 88.4-96 156.8zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faArrowUp19 = {
  prefix: 'fas',
  iconName: 'arrow-up-1-9',
  icon: [576, 512, ["sort-numeric-up"], "f163", "M450.7 38c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V108.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"]
};
var faSortNumericUp = faArrowUp19;
var faOctagonExclamation = {
  prefix: 'fas',
  iconName: 'octagon-exclamation',
  icon: [512, 512, [], "e204", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faDialLow = {
  prefix: 'fas',
  iconName: 'dial-low',
  icon: [576, 512, [], "e15d", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-.4 447.6c-80.2 0-146.6-59-158.2-136l158.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-158.2 0c11.6-77 78-136 158.2-136c88.4 0 160 71.6 160 160s-71.6 160-160 160zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faDoorClosed = {
  prefix: 'fas',
  iconName: 'door-closed',
  icon: [576, 512, [128682], "f52a", "M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLaptopMobile = {
  prefix: 'fas',
  iconName: 'laptop-mobile',
  icon: [640, 512, ["phone-laptop"], "f87a", "M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H352V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM448 448V192H576V448H448zM384 176V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48z"]
};
var faPhoneLaptop = faLaptopMobile;
var faConveyorBeltBoxes = {
  prefix: 'fas',
  iconName: 'conveyor-belt-boxes',
  icon: [640, 512, ["conveyor-belt-alt"], "f46f", "M64 32C64 14.3 78.3 0 96 0H288c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V32zM384 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V96zM0 416c0-53 43-96 96-96H544c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faConveyorBeltAlt = faConveyorBeltBoxes;
var faShieldVirus = {
  prefix: 'fas',
  iconName: 'shield-virus',
  icon: [512, 512, [], "e06c", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faStarfighterTwinIonEngineAdvanced = {
  prefix: 'fas',
  iconName: 'starfighter-twin-ion-engine-advanced',
  icon: [640, 512, ["starfighter-alt-advanced"], "e28e", "M148.8 7.7c13.4 11.5 15 31.7 3.5 45.1L64 155.8v61.8l107.6-21.5C195.3 137.4 252.8 96 320 96s124.7 41.4 148.4 100.1L576 217.6V148.5L488.5 53.7c-12-13-11.2-33.2 1.8-45.2s33.2-11.2 45.2 1.8L623 105.1c10.9 11.8 17 27.3 17 43.4V348.8c0 14.5-4.9 28.6-14 40L537 500c-11 13.8-31.2 16-45 5s-16-31.2-5-45l89-111.2V294.4L468.4 315.9C444.7 374.6 387.2 416 320 416s-124.7-41.4-148.4-100.1L64 294.4v61.8l88.3 103c11.5 13.4 9.9 33.6-3.5 45.1s-33.6 9.9-45.1-3.5l-88.3-103C5.5 386.2 0 371.4 0 356.2V155.8c0-15.3 5.5-30.1 15.4-41.7l88.3-103c11.5-13.4 31.7-15 45.1-3.5zM304 350.7V318c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39l23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5H225.3c2.4 14.6 8.2 28.1 16.4 39.6zM225.3 240H258c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3l23.1 23.1c5.1-3 10.6-5.3 16.5-6.8V161.3c-14.6 2.4-28.1 8.2-39.6 16.4zM375.6 334.3l-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8v32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6H382c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM382 240h32.7c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4V194c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zM342.8 278.5c5.7-5.8 9.2-13.7 9.2-22.5c0-17.7-14.3-32-32-32l0 0 0 0c-17.7 0-32 14.3-32 32c0 17.7 14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z"]
};
var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
var faDiceSix = {
  prefix: 'fas',
  iconName: 'dice-six',
  icon: [448, 512, [9861], "f526", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faStarfighterTwinIonEngine = {
  prefix: 'fas',
  iconName: 'starfighter-twin-ion-engine',
  icon: [576, 512, ["starfighter-alt"], "e038", "M32 32c17.7 0 32 14.3 32 32V211.2l75.6-15.1C163.3 137.4 220.8 96 288 96s124.7 41.4 148.4 100.1L512 211.2V64c0-17.7 14.3-32 32-32s32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.8l-75.6 15.1C412.7 374.6 355.2 416 288 416s-124.7-41.4-148.4-100.1L64 300.8V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 224 64C0 46.3 14.3 32 32 32zM272 350.7V318c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39l23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5H193.3c2.4 14.6 8.2 28.1 16.4 39.6zM193.3 240H226c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3l23.1 23.1c5.1-3 10.6-5.3 16.5-6.8V161.3c-14.6 2.4-28.1 8.2-39.6 16.4zM343.6 334.3l-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8v32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6H350c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM350 240h32.7c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4V194c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zM310.8 278.5c5.7-5.8 9.2-13.7 9.2-22.5c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z"]
};
var faStarfighterAlt = faStarfighterTwinIonEngine;
var faRocketLaunch = {
  prefix: 'fas',
  iconName: 'rocket-launch',
  icon: [512, 512, [128640], "e027", "M117.8 128H207C286.9-3.7 409.5-8.5 483.9 5.3c11.6 2.2 20.7 11.2 22.8 22.8c13.8 74.4 9 197-122.7 276.9v89.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-114.7c0-22.6-9-44.3-25-60.3s-37.7-25-60.3-25H24c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3zM424 128a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM166.5 470C132.3 504.3 66 511 28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5zm-46.7-36.4c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3c-.5 8 5.9 14.3 13.9 13.9c12.8-.7 31.2-3.7 41.3-13.7z"]
};
var faMosquitoNet = {
  prefix: 'fas',
  iconName: 'mosquito-net',
  icon: [640, 512, [], "e52c", "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4V242.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H528v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H448v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V400H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V320H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16zm16 112h48V320H528v48zm0 80h48V400H528v48zM448 320v48h48V320H448zm0 80v48h48V400H448z"]
};
var faVentDamper = {
  prefix: 'fas',
  iconName: 'vent-damper',
  icon: [640, 512, [], "e465", "M64 128c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64v32h32c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H576v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V352H32c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H64V128zm120 16c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faBridgeWater = {
  prefix: 'fas',
  iconName: 'bridge-water',
  icon: [576, 512, [], "e4ce", "M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6V352.5c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3h0l0-.5V256c0-53-43-96-96-96s-96 43-96 96V384l0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7V227.6C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6V96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faBanBug = {
  prefix: 'fas',
  iconName: 'ban-bug',
  icon: [512, 512, ["debug"], "f7f9", "M256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2L367.2 412.5C335.9 434.9 297.5 448 256 448zm89-148.3l19.9 4c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7V246.7l35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-22-5.5L307.8 163c-14-11.9-32.1-19-51.8-19c-18.7 0-35.9 6.4-49.6 17.2L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L345 299.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM140.9 272.3c-8.7 1.7-14.3 10.2-12.6 18.8s10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5L204.2 349c14 11.9 32.1 19 51.8 19c6.6 0 13-.8 19.2-2.3L175 265.5l-34.1 6.8z"]
};
var faDebug = faBanBug;
var faPersonBooth = {
  prefix: 'fas',
  iconName: 'person-booth',
  icon: [576, 512, [], "f756", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64V32zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM224 512c17.7 0 32-14.3 32-32V320H192V480c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3V269.3l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H157.3l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6v55.7l0 .9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V421.3c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"]
};
var faTextWidth = {
  prefix: 'fas',
  iconName: 'text-width',
  icon: [448, 512, [], "f035", "M64 128V96H192l0 128H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l0-128H384v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H224 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V416H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"]
};
var faGarageCar = {
  prefix: 'fas',
  iconName: 'garage-car',
  icon: [640, 512, [], "e00a", "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM254.3 293.4L242.2 328H397.8l-12.1-34.6c-1.1-3.2-4.2-5.4-7.6-5.4H261.8c-3.4 0-6.4 2.2-7.6 5.4zM188.9 335L209 277.5c7.9-22.5 29.1-37.5 52.9-37.5H378.2c23.8 0 45 15.1 52.9 37.5L451.1 335c17.2 9.5 28.9 27.9 28.9 49v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V464H224v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-21.1 11.7-39.5 28.9-49zM240 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSquareKanban = {
  prefix: 'fas',
  iconName: 'square-kanban',
  icon: [448, 512, [], "e488", "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zm-64-96c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192c0 17.7-14.3 32-32 32zM256 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64zM128 320c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 17.7-14.3 32-32 32z"]
};
var faHatWizard = {
  prefix: 'fas',
  iconName: 'hat-wizard',
  icon: [512, 512, [], "f6e8", "M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416H64zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faPenFancy = {
  prefix: 'fas',
  iconName: 'pen-fancy',
  icon: [512, 512, [128395, 10002], "f5ac", "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"]
};
var faCoffeePot = {
  prefix: 'fas',
  iconName: 'coffee-pot',
  icon: [512, 512, [], "e002", "M64 128c0-17.7 14.3-32 32-32h12.8l34 84.9C95 215.9 64 272.3 64 336v8c0 55.5 34.6 99.4 55.9 121.2c9.9 10.2 23.9 14.8 38.1 14.8H418c14.2 0 28.1-4.7 38.1-14.8C477.4 443.4 512 399.5 512 344v-8c0-63.7-31-120.1-78.8-155.1L478.1 68.8c1.3-3.2 1.9-6.6 1.9-10C480 44 468 32 453.2 32H192 122.8 96C43 32 0 75 0 128v64c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm65 192c5.2-41.4 30.1-76.6 65-96H382c34.9 19.4 59.8 54.6 65 96H129z"]
};
var faMouseField = {
  prefix: 'fas',
  iconName: 'mouse-field',
  icon: [512, 512, [], "e5a8", "M396.4 112.9C398.8 105 400 96.6 400 88c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 29.9 14.9 56.3 37.6 72.2C169.5 164.3 96 240.4 96 333.6c0 12.3 2.7 24 7.5 34.4H72c-39.8 0-72 32.2-72 72s32.2 72 72 72H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24H178.4 232h8 19H382.6c18.5 0 33.4-15 33.4-33.4c0-14.1-8.8-26.6-22-31.4l-43.7-15.9 23.8-63.5c2 .1 4 .2 6 .2H482.9c16.1 0 29.1-13 29.1-29.1c0-41.5-19.3-78.4-49.4-102.4C473.5 125.8 480 107.7 480 88c0-46.4-35.9-84.4-81.4-87.8C419.2 20.6 432 48.8 432 80c0 13.9-2.5 27.2-7.2 39.5c-9.1-3.2-18.6-5.5-28.4-6.6zM400 196a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM312 48c22.1 0 40 17.9 40 40v24c0 8.8-7.2 16-16 16H312c-22.1 0-40-17.9-40-40s17.9-40 40-40z"]
};
var faPersonDigging = {
  prefix: 'fas',
  iconName: 'person-digging',
  icon: [576, 512, ["digging"], "f85e", "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"]
};
var faDigging = faPersonDigging;
var faShowerDown = {
  prefix: 'fas',
  iconName: 'shower-down',
  icon: [384, 512, ["shower-alt"], "e24d", "M192 0c17.7 0 32 14.3 32 32v3.2C297 50 352 114.6 352 192c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32C32 114.6 87 50 160 35.2V32c0-17.7 14.3-32 32-32zm52.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zm-82.2-85.6l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1zm146.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zM98.7 465.7l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1zM52.8 295.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"]
};
var faShowerAlt = faShowerDown;
var faBoxCircleCheck = {
  prefix: 'fas',
  iconName: 'box-circle-check',
  icon: [576, 512, [], "e0c4", "M93.7 32H208V160H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32H354.3c18.2 0 34.8 10.3 42.9 26.5L448 160H416 240V32zM0 416V192H416v.7c-89.7 8.1-160 83.5-160 175.3c0 42.5 15.1 81.6 40.2 112H64c-35.3 0-64-28.7-64-64zm288-48a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faBrightness = {
  prefix: 'fas',
  iconName: 'brightness',
  icon: [512, 512, [], "e0c9", "M224 80V32c0-17.7 14.3-32 32-32s32 14.3 32 32V80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM0 256c0-17.7 14.3-32 32-32H80c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm432-32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H432c-17.7 0-32-14.3-32-32s14.3-32 32-32zM256 512c-17.7 0-32-14.3-32-32V432c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 17.7-14.3 32-32 32zM73.4 438.6c-12.5-12.5-12.5-32.8 0-45.3l32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32c-12.5 12.5-32.8 12.5-45.3 0zm288-333.3l32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm77.3 333.3c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32c12.5 12.5 12.5 32.8 0 45.3zm-333.3-288l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"]
};
var faCarSideBolt = {
  prefix: 'fas',
  iconName: 'car-side-bolt',
  icon: [640, 512, [], "e344", "M82.2 92.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3zM480 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM114.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM331.2 100.6c5.3 5.2 6.3 13.3 2.5 19.6L300.3 176H352c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L243.7 208H192c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z"]
};
var faOrnament = {
  prefix: 'fas',
  iconName: 'ornament',
  icon: [384, 512, [], "f7b8", "M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 11.7 3.1 22.6 8.6 32H128c-17.7 0-32 14.3-32 32v25.7C66.9 170.5 42.5 194.9 25.7 224H358.3c-16.9-29.1-41.2-53.5-70.3-70.3V128c0-17.7-14.3-32-32-32h-8.6zM0 320c0 22.4 3.8 44 10.9 64H373.1c7.1-20 10.9-41.6 10.9-64s-3.8-44-10.9-64H10.9C3.8 276 0 297.6 0 320zm25.7 96c33.2 57.4 95.2 96 166.3 96s133.1-38.6 166.3-96H25.7z"]
};
var faPhoneArrowDownLeft = {
  prefix: 'fas',
  iconName: 'phone-arrow-down-left',
  icon: [512, 512, ["phone-arrow-down", "phone-incoming"], "e223", "M505 41l-135 135H416c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24v46.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"]
};
var faPhoneArrowDown = faPhoneArrowDownLeft;
var faPhoneIncoming = faPhoneArrowDownLeft;
var faCloudWord = {
  prefix: 'fas',
  iconName: 'cloud-word',
  icon: [640, 512, [], "e138", "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm512 32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16zM240 352c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96zM128 304c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm272-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faHandFingersCrossed = {
  prefix: 'fas',
  iconName: 'hand-fingers-crossed',
  icon: [384, 512, [], "e1a3", "M93 18.5l17.3 37.2L75 131.3 35 45.5c-7.5-16-.5-35.1 15.5-42.5s35.1-.5 42.5 15.5zM150.6 272l0 0H152c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64H80l0 0h35.3l0 0h35.3zM192 252.1c-8-5.4-17.2-9.2-27-11L181 207l11 23.7v21.5zM130.2 240H59.6L163 18.5c7.5-16 26.5-22.9 42.5-15.5s22.9 26.5 15.5 42.5L130.2 240zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224z"]
};
var faTrash = {
  prefix: 'fas',
  iconName: 'trash',
  icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"]
};
var faGaugeSimple = {
  prefix: 'fas',
  iconName: 'gauge-simple',
  icon: [512, 512, ["gauge-simple-med", "tachometer-average"], "f629", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faGaugeSimpleMed = faGaugeSimple;
var faTachometerAverage = faGaugeSimple;
var faArrowDownSmallBig = {
  prefix: 'fas',
  iconName: 'arrow-down-small-big',
  icon: [576, 512, ["sort-size-down-alt"], "f88d", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM320 80v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48zm48 176c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H368z"]
};
var faSortSizeDownAlt = faArrowDownSmallBig;
var faBookMedical = {
  prefix: 'fas',
  iconName: 'book-medical',
  icon: [448, 512, [], "f7e6", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM208 112v48H160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16z"]
};
var faFaceMelting = {
  prefix: 'fas',
  iconName: 'face-melting',
  icon: [640, 512, [129760], "e483", "M571.4 304.8c-4.5 23.2 11.8 47.2 35.4 47.2H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H44.9c36.8 0 58.4-50.7 42.9-84.1C72.5 331.1 64 294.5 64 256C64 114.6 178.6 0 320 0S576 114.6 576 256c0 16.7-1.6 33-4.6 48.8zM247.2 219.9a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8zM441 238.7a32 32 0 1 0 -61.8-16.6A32 32 0 1 0 441 238.7zM213.2 299.4c-3.9-7.9-13.4-11.3-21.4-7.4s-11.3 13.4-7.4 21.4c14.8 30.5 45.1 67.5 98.3 81.7s97.9-2.6 126-21.7c7.3-5 9.2-14.9 4.3-22.2s-14.9-9.2-22.2-4.3c-22.7 15.4-57.9 28.5-99.8 17.2s-65.8-40.2-77.8-64.8z"]
};
var faPoo = {
  prefix: 'fas',
  iconName: 'poo',
  icon: [512, 512, [128169], "f2fe", "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72H394.3c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3H339.7c6.8 0 12.3 5.5 12.3 12.3z"]
};
var faPenClipSlash = {
  prefix: 'fas',
  iconName: 'pen-clip-slash',
  icon: [640, 512, ["pen-alt-slash"], "e20f", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l55-55 17-17-1-1-16-16-96-96-17-17L338.9 81c-28.1-28.1-73.7-28.1-101.8 0l-44.6 44.6L38.8 5.1zM230.5 155.4L271 114.9c9.4-9.4 24.6-9.4 33.9 0L318.1 128l-53.8 53.8-33.7-26.4zm-67 127.1c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l47.7-47.7L195.8 250.3l-32.3 32.3zM517.3 19.3c-25-25-65.5-25-90.5 0L374.6 71.4l17 17 96 96 16 16 0 0 1 1 0 0 52.1-52.1c25-25 25-65.5 0-90.5L517.3 19.3z"]
};
var faPenAltSlash = faPenClipSlash;
var faQuoteRight = {
  prefix: 'fas',
  iconName: 'quote-right',
  icon: [448, 512, [8221, "quote-right-alt"], "f10e", "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"]
};
var faQuoteRightAlt = faQuoteRight;
var faScrollOld = {
  prefix: 'fas',
  iconName: 'scroll-old',
  icon: [576, 512, [], "f70f", "M48 32c26.5 0 48 21.5 48 48v80H48 32c-17.7 0-32-14.3-32-32V80C0 53.5 21.5 32 48 32zm80 48c0-18-6-34.6-16-48H384c51.4 0 93.4 40.5 95.9 91.3c-.4 3.5-2 6.9-4.6 9.4l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3V200v16 1.4c0 4.2-1.7 8.3-4.7 11.3l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3V296v24H314.7c-32.4 0-58.7 26.3-58.7 58.7V384c0 35.3-28.7 64-64 64s-64-28.7-64-64V264v-1.4c0-4.2 1.7-8.3 4.7-11.3l21.7-21.7c3.1-3.1 3.1-8.2 0-11.3l-21.7-21.7c-3-3-4.7-7.1-4.7-11.3V184 80zM576 368c0 61.9-50.1 112-112 112H368 192c53 0 96-43 96-96v-5.3c0-14.7 11.9-26.7 26.7-26.7H344h1.4c4.2 0 8.3 1.7 11.3 4.7l21.7 21.7c3.1 3.1 8.2 3.1 11.3 0l21.7-21.7c3-3 7.1-4.7 11.3-4.7H424 560c8.8 0 16 7.2 16 16z"]
};
var faGuitars = {
  prefix: 'fas',
  iconName: 'guitars',
  icon: [512, 512, [], "f8bf", "M104 0h48c13.3 0 24 10.7 24 24V76.2c0 6.2-1.4 12.3-4.2 17.9L152 133.7V178c50.3 8.6 88 43.8 88 86c0 14-4.2 27.3-11.6 39.1c-8.2 13-7.5 32 2.9 43.4c5.9 6.5 10.9 13.7 14.8 21.3c-2.3 4.9-4.7 9.6-7 13.9c-8.8 16.3-15 35.6-15 56.5c0 11.6 1.9 22.8 5.4 33.3C205.9 496.1 169.3 512 128 512C57.3 512 0 465.4 0 408c0-23 9.2-44.3 24.8-61.5c10.3-11.4 11.1-30.4 2.9-43.4C20.2 291.3 16 278 16 264c0-42.1 37.7-77.3 88-86V133.7L84.2 94.1C81.4 88.6 80 82.4 80 76.2V24C80 10.7 90.7 0 104 0zm24 344a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM360 148.6l-21.4-24.5c-6.6-7.6-9.3-17.9-7.2-27.8l13.9-64.8C349.2 13.1 365.4 0 384.2 0c22 0 39.8 17.8 39.8 39.8v4.6c0 12.4-6.4 23.3-16 29.7V238.9c27.9-4.2 39.6-19.4 44.5-31.3c3.3-8.2 10.7-15.5 19.5-15.5s16 7.2 16 16v29.3c0 11.6-4.8 22.8-9.3 33.5l-.5 1.1c-3.3 7.8-6.2 18.5-6.2 32.1c0 33.5 17 70.9 28.8 92.9c6.9 12.7 11.2 26.9 11.2 41.3c0 40.8-33 73.8-73.8 73.8H329.8C289 512 256 479 256 438.2c0-14.5 4.3-28.6 11.2-41.3C279 374.9 296 337.5 296 304c0-11.2-2-20.5-4.5-27.8c-.9-2.5-1.8-5-2.7-7.5l0 0 0 0c-4.3-11.8-8.8-23.8-8.8-36.2V192c0-8.8 7.2-16 16-16s16.1 7.2 18.2 15.8c3.9 16.4 14.9 40.5 45.8 46.7V148.6zM336 320c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16z"]
};
var faPhoneXmark = {
  prefix: 'fas',
  iconName: 'phone-xmark',
  icon: [640, 512, [], "e227", "M181.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c33.3 70.4 90.3 127.4 160.7 160.7L409 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512C264.6 512 64 311.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24zM399 15c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L399 49c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faHose = {
  prefix: 'fas',
  iconName: 'hose',
  icon: [448, 512, [], "e419", "M288 104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.3l80.2-11.5C417.3 98 423.9 104 432 104c8.8 0 16-7.2 16-16V40c0-8.8-7.2-16-16-16c-8.1 0-14.7 6-15.8 13.7L336 26.3V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80zM64 176c0-44.2 35.8-80 80-80H256V32H144C64.5 32 0 96.5 0 176s64.5 144 144 144H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-44.2 0-80-35.8-80-80zM32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faClockSix = {
  prefix: 'fas',
  iconName: 'clock-six',
  icon: [512, 512, [], "e352", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faShirt = {
  prefix: 'fas',
  iconName: 'shirt',
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z"]
};
var faTShirt = faShirt;
var faTshirt = faShirt;
var faBillboard = {
  prefix: 'fas',
  iconName: 'billboard',
  icon: [640, 512, [], "e5cd", "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32H256c0-17.7-14.3-32-32-32s-32 14.3-32 32H80C53.5 32 32 53.5 32 80V352c-17.7 0-32 14.3-32 32s14.3 32 32 32H80 288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416H560h48c17.7 0 32-14.3 32-32s-14.3-32-32-32V80c0-26.5-21.5-48-48-48H448zM320 352H96V96h96v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V96H384v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V96h96V352H320z"]
};
var faSquareR = {
  prefix: 'fas',
  iconName: 'square-r',
  icon: [448, 512, [], "e27c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H256c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288H176v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24zm80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H176v64h56z"]
};
var faCubes = {
  prefix: 'fas',
  iconName: 'cubes',
  icon: [576, 512, [], "f1b3", "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5V204.7c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7V413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2V152.6L392 121v89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8L256 323.2v95.9l-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1V354.8L528 323.2v90.7c0 3.2-1.9 6-4.8 7.3z"]
};
var faEnvelopeOpenDollar = {
  prefix: 'fas',
  iconName: 'envelope-open-dollar',
  icon: [512, 512, [], "f657", "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM276 136v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4l0 0c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"]
};
var faDivide = {
  prefix: 'fas',
  iconName: 'divide',
  icon: [448, 512, [10135, 247], "f529", "M272 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H400z"]
};
var faSunCloud = {
  prefix: 'fas',
  iconName: 'sun-cloud',
  icon: [640, 512, [127780], "f763", "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2l-20.1 29.1C481 193 472.6 192 464 192c-32.9 0-62.4 14.2-82.9 36.7C368.6 171.1 317.3 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c12.4 0 24.5-1.8 35.8-5.1c11.3 38.8 46.5 67.5 88.7 69l-9.4 51c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM352 256c0 1.9-.1 3.7-.2 5.5c-35.6 12.6-61.5 45.6-63.7 85c-10.1 3.6-20.9 5.5-32.2 5.5c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm32 160c-35.3 0-64-28.7-64-64s28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72H384z"]
};
var faLampFloor = {
  prefix: 'fas',
  iconName: 'lamp-floor',
  icon: [640, 512, [], "e015", "M194.3 20.1C199.1 8 210.9 0 224 0H416c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1H160c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM288 256h64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64V256z"]
};
var faSquare7 = {
  prefix: 'fas',
  iconName: 'square-7',
  icon: [448, 512, [], "e25c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H296c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faTengeSign = {
  prefix: 'fas',
  iconName: 'tenge-sign',
  icon: [384, 512, [8376, "tenge"], "f7d7", "M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32H192 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"]
};
var faTenge = faTengeSign;
var faHeadphones = {
  prefix: 'fas',
  iconName: 'headphones',
  icon: [512, 512, [127911], "f025", "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80V384 336 288C0 146.6 114.6 32 256 32s256 114.6 256 256v48 48 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"]
};
var faHandsHolding = {
  prefix: 'fas',
  iconName: 'hands-holding',
  icon: [640, 512, [], "f4c2", "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"]
};
var faCampfire = {
  prefix: 'fas',
  iconName: 'campfire',
  icon: [512, 512, [], "f6ba", "M232.2 3.4c-2.5-2.3-5.6-3.4-8.8-3.4c-3.2 0-6.4 1.1-9 3.4c-29.9 27-55.3 57.7-73.2 87.1c-17.7 29-29.2 60.2-29.2 84.2C112 254.5 175.3 320 256 320c79.9 0 144-65.5 144-145.3c0-18.3-8.7-46.3-21.7-71.8C365 77 346.2 49.7 323.9 29.1c-5-4.7-12.9-4.7-18 0c-8.7 8-16.7 17.8-23.8 26.8C266.6 37 250 19.6 232.2 3.4zM301 248.2c-13.5 9.1-27.9 13.6-44.1 13.6c-40.5 0-72.9-26.4-72.9-70.9c0-21.8 13.5-40.9 40.5-74.5c3.6 4.5 55.8 71.8 55.8 71.8L312.7 150c2.7 3.6 4.5 7.3 6.3 10.9c16.2 30 9 68.2-18 87.3zM42.8 289.9c-16.6-5.9-35 2.7-40.9 19.4s2.7 35 19.4 40.9L160.9 400 21.2 449.9C4.6 455.8-4.1 474.1 1.9 490.8s24.3 25.3 40.9 19.4L256 434l213.2 76.2c16.6 5.9 35-2.7 40.9-19.4s-2.7-35-19.4-40.9L351.1 400l139.6-49.9c16.6-5.9 25.3-24.3 19.4-40.9s-24.3-25.3-40.9-19.4L256 366 42.8 289.9z"]
};
var faCircleAmpersand = {
  prefix: 'fas',
  iconName: 'circle-ampersand',
  icon: [512, 512, [], "e0f8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 191.6c0 4.1 1.6 8.1 4.6 11L235 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2H231.6c-8.6 0-15.6 7-15.6 15.6zm71 46.9l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L361 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4H210.5c-36.7 0-66.5-29.8-66.5-66.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9c0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z"]
};
var faSnowflakes = {
  prefix: 'fas',
  iconName: 'snowflakes',
  icon: [640, 512, [], "f7cf", "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32zM487 7c9.4-9.4 24.6-9.4 33.9 0l23 23L567 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L487 41c-9.4-9.4-9.4-24.6 0-33.9zm32 192c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faHandsClapping = {
  prefix: 'fas',
  iconName: 'hands-clapping',
  icon: [512, 512, [], "e1a8", "M336 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4zM424.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"]
};
var faRepublican = {
  prefix: 'fas',
  iconName: 'republican',
  icon: [640, 512, [], "f75e", "M0 192C0 103.6 71.6 32 160 32H384c88.4 0 160 71.6 160 160v64H0V192zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160H320h96 32 64 32v32 80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V352H448v32 64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384 288H128z"]
};
var faLeafMaple = {
  prefix: 'fas',
  iconName: 'leaf-maple',
  icon: [512, 512, [127809], "f6f6", "M339.8 7.5l15.8 31.6c7.1 14.2 23.6 21.1 38.7 16l67.6-22.5c1.4-.5 2.9-.7 4.4-.7c7.6 0 13.8 6.2 13.8 13.8c0 1.5-.2 2.9-.7 4.4l-22.5 67.6c-5 15.1 1.8 31.6 16 38.7l31.6 15.8c4.6 2.3 7.5 7 7.5 12.2c0 4.7-2.4 9.1-6.4 11.6l-97.9 61.2c-6.8 4.3-3.8 14.8 4.2 14.8h38.3c7.6 0 13.8 6.2 13.8 13.8c0 1.5-.2 2.9-.7 4.4l-8.5 25.5c-4.1 12.3-.3 25.9 9.5 34.4l34.3 29.4c3.4 2.9 5.4 7.2 5.4 11.7c0 5.5-3 10.6-7.8 13.4l-28.9 16.5c-11.6 6.6-17.9 19.8-15.7 33l4.2 25.1c.1 .6 .2 1.3 .2 1.9c0 7.6-7.2 13.2-14.6 11.2l-155-40.4c-8.2-2.1-16.6 2.4-19.2 10.4l-8.5 25.4c-1.7 5-6.3 8.4-11.6 8.4c-4.4 0-8.5-2.4-10.7-6.3l-53-95.3L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239.3 270.8c3.6-6.1 2.7-14.1-2.5-19.4c-6.2-6.2-16.4-6.2-22.6 0l-84 84L22.3 275.5c-3.9-2.2-6.3-6.2-6.3-10.7c0-5.3 3.4-9.9 8.4-11.6l25.4-8.5c8-2.7 12.5-11.1 10.4-19.2L19.8 70.6C17.9 63.2 23.4 56 31 56c.6 0 1.3 .1 1.9 .2L58 60.3c13.2 2.2 26.4-4.1 33-15.7l16.5-28.9C110.3 11 115.4 8 120.9 8c4.5 0 8.8 2 11.7 5.4L162 47.7c8.5 9.9 22.1 13.6 34.4 9.5l25.5-8.5c1.4-.5 2.9-.7 4.4-.7c7.6 0 13.8 6.2 13.8 13.8v38.3c0 8 10.5 11.1 14.8 4.2L316 6.4c2.5-4 6.9-6.4 11.6-6.4c5.2 0 9.9 2.9 12.2 7.5z"]
};
var faArrowLeft = {
  prefix: 'fas',
  iconName: 'arrow-left',
  icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
};
var faPersonCircleXmark = {
  prefix: 'fas',
  iconName: 'person-circle-xmark',
  icon: [576, 512, [], "e543", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faRuler = {
  prefix: 'fas',
  iconName: 'ruler',
  icon: [512, 512, [128207], "f545", "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"]
};
var faCupStrawSwoosh = {
  prefix: 'fas',
  iconName: 'cup-straw-swoosh',
  icon: [384, 512, [], "e364", "M194.8 43.2l-20 84.8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H249.3c-26 0-48.6 17.9-54.5 43.2zM40 224L60.3 468c2.1 24.9 22.9 44 47.8 44H275.8c25 0 45.8-19.1 47.8-44L344 224H40zm194.4 78.9c18.8-10.1 42-17.2 72.7-20.6L303 331.2c-20.8 3.1-35.2 8.2-45.8 13.9c-17.2 9.3-26.9 21.2-39.9 37.2l-.7 .8c-13.3 16.4-29.5 35.9-58.7 50.4c-17.7 8.8-39.3 15.2-66.7 18.9l-4-47.9c22.1-3.2 37.7-8.3 49.4-14.1c19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7z"]
};
var faTemperatureSun = {
  prefix: 'fas',
  iconName: 'temperature-sun',
  icon: [640, 512, ["temperature-hot"], "f76a", "M320.6 98.5l-2.7-.5L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6L208 363.5l70.8 49.6c4.5 3.1 10.3 3.8 15.4 1.6c.7-.3 1.5-.7 2.1-1.1c-5.4-16.9-8.3-34.9-8.3-53.7c0-37.7 11.8-72.6 32-101.2V112c0-4.5 .2-9 .6-13.5zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm208 0c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C537.8 332.6 544 349.5 544 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM464 0C402.1 0 352 50.2 352 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8c-18.9 24.4-30.1 55-30.1 88.1c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C576 50.2 525.9 0 464 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
var faTemperatureHot = faTemperatureSun;
var faAlignLeft = {
  prefix: 'fas',
  iconName: 'align-left',
  icon: [448, 512, [], "f036", "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
};
var faDiceD6 = {
  prefix: 'fas',
  iconName: 'dice-d6',
  icon: [448, 512, [], "f6d1", "M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14V496c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8V381c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96z"]
};
var faRestroom = {
  prefix: 'fas',
  iconName: 'restroom',
  icon: [640, 512, [], "f7bd", "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120zM320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480V384H422.2c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H504v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]
};
var faHighDefinition = {
  prefix: 'fas',
  iconName: 'high-definition',
  icon: [576, 512, ["rectangle-hd"], "e1ae", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 88V328c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96H328c-13.3 0-24 10.7-24 24zm80 24c26.5 0 48 21.5 48 48s-21.5 48-48 48H352V208h32zM160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v72 72c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V256 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v48H160V184z"]
};
var faRectangleHd = faHighDefinition;
var faJ = {
  prefix: 'fas',
  iconName: 'j',
  icon: [320, 512, [106], "4a", "M288 32c17.7 0 32 14.3 32 32V320c0 88.4-71.6 160-160 160S0 408.4 0 320V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z"]
};
var faGalaxy = {
  prefix: 'fas',
  iconName: 'galaxy',
  icon: [512, 512, [], "e008", "M320 0h11.5C342.8 0 352 9.2 352 20.5c0 7.1-3.7 13.7-9.8 17.5l-12.5 7.7c-35.2 21.7-60.9 54.9-73.3 93.1c19.9-7 41.3-10.8 63.5-10.8c106 0 192 86 192 192v11.5c0 11.3-9.2 20.5-20.5 20.5c-7.1 0-13.7-3.7-17.5-9.8l-7.7-12.5c-21.7-35.2-54.9-60.9-93.1-73.3c7 19.9 10.8 41.3 10.8 63.5c0 106-86 192-192 192H180.5c-11.3 0-20.5-9.2-20.5-20.5c0-7.1 3.7-13.7 9.8-17.5l12.5-7.7c35.2-21.7 60.9-54.9 73.3-93.1c-19.9 7-41.3 10.8-63.5 10.8C86 384 0 298 0 192V180.5C0 169.2 9.2 160 20.5 160c7.1 0 13.7 3.7 17.5 9.8l7.7 12.5c21.7 35.2 54.9 60.9 93.1 73.3c-7-19.9-10.8-41.3-10.8-63.5C128 86 214 0 320 0zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faUsersViewfinder = {
  prefix: 'fas',
  iconName: 'users-viewfinder',
  icon: [640, 512, [], "e595", "M48 48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H32C14.3 0 0 14.3 0 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 17.7 14.3 32 32 32H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H608c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H504z"]
};
var faFileVideo = {
  prefix: 'fas',
  iconName: 'file-video',
  icon: [384, 512, [], "f1c8", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"]
};
var faCherries = {
  prefix: 'fas',
  iconName: 'cherries',
  icon: [640, 512, [], "e0ec", "M288 24L302.1 4.5c-6.9-5-15.9-5.9-23.7-2.5s-13.2 10.7-14.2 19.1c0 0 0 0 0 0s0 0 0 0l0 0 0 .2-.1 .9c-.1 .9-.3 2.2-.6 4c-.6 3.6-1.5 9-2.9 15.8c-2.8 13.7-7.6 33.3-15.3 56.3c-14 42-37.4 94.7-75.8 143.7C152.3 233.5 126.5 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-20.5 0-38.9 4.3-54 9.7c27.1-42.6 45-85.1 56.7-120.2c5.7-17 9.9-32.3 13-45.1c11.7 10.8 25.8 24.7 40.1 41.2c29.6 34.3 59.1 78.4 73.1 128.5c-12-5.3-27-10.3-44.2-12.7C397.3 247.7 416 282.9 416 336c0 71.9-26.1 120.9-62.1 152.9C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-32.3 0-59.2 10.6-76.3 19.6C453.5 176 415.2 118.9 380.2 78.3c-19.9-23-39.2-41.3-53.6-53.9c-7.2-6.3-13.2-11.2-17.5-14.5c-2.1-1.7-3.8-3-5-3.9c-.6-.4-1.1-.8-1.4-1l-.4-.3-.1-.1 0 0 0 0s0 0-14.1 19.4z"]
};
var faUpRightFromSquare = {
  prefix: 'fas',
  iconName: 'up-right-from-square',
  icon: [512, 512, ["external-link-alt"], "f35d", "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
};
var faExternalLinkAlt = faUpRightFromSquare;
var faCircleSort = {
  prefix: 'fas',
  iconName: 'circle-sort',
  icon: [512, 512, ["sort-circle"], "e030", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H352c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zM244.7 411.3c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96z"]
};
var faSortCircle = faCircleSort;
var faTableCells = {
  prefix: 'fas',
  iconName: 'table-cells',
  icon: [512, 512, ["th"], "f00a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64H208V96zm240 0v64H360V96h88zM64 224h88v64H64V224zm232 0v64H208V224h88zm64 0h88v64H360V224zM152 352v64H64V352h88zm56 0h88v64H208V352zm240 0v64H360V352h88z"]
};
var faTh = faTableCells;
var faFilePdf = {
  prefix: 'fas',
  iconName: 'file-pdf',
  icon: [512, 512, [], "f1c1", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
};
var faSiren = {
  prefix: 'fas',
  iconName: 'siren',
  icon: [448, 512, [], "e02d", "M73 152.1L48 352h57.9l22.2-178c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9L138.1 352H400L375 152.1C371 120 343.8 96 311.5 96h-175C104.2 96 77 120 73 152.1zM32 384c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H32z"]
};
var faArrowUpToDottedLine = {
  prefix: 'fas',
  iconName: 'arrow-up-to-dotted-line',
  icon: [448, 512, [], "e0a1", "M32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM320 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-9.4 233.4l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 269.3V336 448c0 17.7 14.3 32 32 32s32-14.3 32-32V336 269.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"]
};
var faImageLandscape = {
  prefix: 'fas',
  iconName: 'image-landscape',
  icon: [576, 512, ["landscape"], "e1b5", "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm328 64c-8 0-15.5 4-20 10.7l-56 84L234.7 265c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H424c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C343.5 196 336 192 328 192zM160 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLandscape = faImageLandscape;
var faTankWater = {
  prefix: 'fas',
  iconName: 'tank-water',
  icon: [448, 512, [], "e452", "M285.9 96l-22-40.3L251 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H197L184.1 55.7 162.1 96H64V297.9c8.3-3 16.2-6.8 23.3-10.8c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 18.9 12.7c15.8 9 35.5 16.8 55.2 16.9h.4c19.6 0 39.3-7.9 55.2-16.9c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 19 12.8c7.1 4 15 7.9 23.4 10.8V96H285.9zM175 139.2L212.2 71c2.4-4.3 6.9-7 11.8-7s9.5 2.7 11.8 7L273 139.2c4.6 8.4 7 17.9 7 27.5V168c0 30.9-25.1 56-56 56s-56-25.1-56-56v-1.4c0-9.6 2.4-19 7-27.5z"]
};
var faCurlingStone = {
  prefix: 'fas',
  iconName: 'curling-stone',
  icon: [576, 512, [129356, "curling"], "f44a", "M224 128c0-17.7 14.3-32 32-32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-53 0-96 43-96 96v32c-35.3 0-64 28.7-64 64c-53 0-96 43-96 96v16H576V320c0-53-43-96-96-96c0-35.3-28.7-64-64-64H224V128zM576 368H0v16c0 53 43 96 96 96H480c53 0 96-43 96-96V368z"]
};
var faCurling = faCurlingStone;
var faGamepadModern = {
  prefix: 'fas',
  iconName: 'gamepad-modern',
  icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M0 369.4v2.8C0 431.7 48.3 480 107.8 480c49.5 0 92.6-33.7 104.6-81.7L216 384H424l3.6 14.3c12 48 55.1 81.7 104.6 81.7C591.7 480 640 431.7 640 372.2v-2.8c0-6.3-.5-12.5-1.6-18.7L605.7 159.8c-8.6-50.2-40.9-93.2-90.3-105.5C469.5 42.9 403.8 32 320 32s-149.5 10.9-195.3 22.3C75.2 66.6 42.9 109.6 34.3 159.8L1.6 350.7C.5 356.9 0 363.1 0 369.4zM432 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24-56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-240-8v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faGamepadAlt = faGamepadModern;
var faMessagesQuestion = {
  prefix: 'fas',
  iconName: 'messages-question',
  icon: [640, 512, [], "e1e7", "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V320H64c-35.3 0-64-28.7-64-64V64zM256 352h96c53 0 96-43 96-96V128H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H544v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320c-35.3 0-64-28.7-64-64V352zM136.2 92.4l-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4h48.5c7 0 12.6 5.7 12.6 12.6c0 4.5-2.4 8.7-6.3 10.9L198 146.1c-6.2 3.6-10 10.2-10 17.3v11.2c0 11 9 20 20 20c10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6c0-29.1-23.6-52.6-52.6-52.6H180.2c-19.8 0-37.4 12.4-44 31.1zM234.7 248a26.7 26.7 0 1 0 -53.3 0 26.7 26.7 0 1 0 53.3 0z"]
};
var faBookBible = {
  prefix: 'fas',
  iconName: 'book-bible',
  icon: [448, 512, ["bible"], "f647", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272V304c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V192H160c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h48V80z"]
};
var faBible = faBookBible;
var faO = {
  prefix: 'fas',
  iconName: 'o',
  icon: [448, 512, [111], "4f", "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"]
};
var faSuitcaseMedical = {
  prefix: 'fas',
  iconName: 'suitcase-medical',
  icon: [512, 512, ["medkit"], "f0fa", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96v32V480H384V128 96 56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H96V96zM416 480h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H416V480zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"]
};
var faMedkit = faSuitcaseMedical;
var faBriefcaseArrowRight = {
  prefix: 'fas',
  iconName: 'briefcase-arrow-right',
  icon: [512, 512, [], "e2f2", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM297 191l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H152c-13.3 0-24-10.7-24-24s10.7-24 24-24H302.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faExpandWide = {
  prefix: 'fas',
  iconName: 'expand-wide',
  icon: [512, 512, [], "f320", "M32 64C14.3 64 0 78.3 0 96v96c0 17.7 14.3 32 32 32s32-14.3 32-32V128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V320zM384 64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32H384zM512 320c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V320z"]
};
var faClockElevenThirty = {
  prefix: 'fas',
  iconName: 'clock-eleven-thirty',
  icon: [512, 512, [], "e348", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V263.3l-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faRv = {
  prefix: 'fas',
  iconName: 'rv',
  icon: [640, 512, [], "f7be", "M224 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16V32H512c53 0 96 43 96 96c0 17.7-14.3 32-32 32H384V416H254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H96L18.7 338.7C6.7 326.7 0 310.5 0 293.5V96C0 60.7 28.7 32 64 32H224V16zM112 128c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H112zm96 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80-48V400 320 288 216 192h24 76.6c12.9 0 25.5 4.5 35.5 12.7l67.4 55.2c13 10.6 20.5 26.5 20.5 43.3V320v64c0 17.7-14.3 32-32 32H574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80V416zM578.1 288l-56.5-46.2c-1.4-1.2-3.2-1.8-5.1-1.8H464v48H578.1z"]
};
var faUserSecret = {
  prefix: 'fas',
  iconName: 'user-secret',
  icon: [448, 512, [128373], "f21b", "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4H342.7c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm56 208H267.6c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40V169.6c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"]
};
var faOtter = {
  prefix: 'fas',
  iconName: 'otter',
  icon: [640, 512, [129446], "f700", "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V336 320c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6V240c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16v32 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V204.3c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1h0c0 123.7-100.3 224-224 224h-1.1H256h-.6C132 480 32 380 32 256.6V256 216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64H320c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faDreidel = {
  prefix: 'fas',
  iconName: 'dreidel',
  icon: [448, 512, [], "f792", "M438.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 146.7 225.9 84.7c-18.7-18.7-49.1-18.7-67.9 0l-57.4 57.4L337.9 379.3l57.4-57.4c18.7-18.7 18.7-49.1 0-67.9L333.3 192 438.6 86.6zM315.3 401.9L78.1 164.7 18.7 224C6.7 236 0 252.3 0 269.3V416c0 35.3 28.7 64 64 64H210.7c17 0 33.3-6.7 45.3-18.7l59.3-59.3z"]
};
var faPersonDress = {
  prefix: 'fas',
  iconName: 'person-dress',
  icon: [320, 512, ["female"], "f182", "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"]
};
var faFemale = faPersonDress;
var faCommentDollar = {
  prefix: 'fas',
  iconName: 'comment-dollar',
  icon: [512, 512, [], "f651", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"]
};
var faBusinessTime = {
  prefix: 'fas',
  iconName: 'business-time',
  icon: [640, 512, ["briefcase-clock"], "f64a", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 352h8.2c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM320 352H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H360.2C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faBriefcaseClock = faBusinessTime;
var faFlowerTulip = {
  prefix: 'fas',
  iconName: 'flower-tulip',
  icon: [512, 512, [127799], "f801", "M96 44v84c0 70.7 57.3 128 128 128V394.8C192.1 349.5 139.5 320 80 320H29.5C13.2 320 0 333.2 0 349.5C0 439.3 72.7 512 162.5 512H224h32 32 61.5C439.3 512 512 439.3 512 349.5c0-16.3-13.2-29.5-29.5-29.5H432c-59.5 0-112.1 29.5-144 74.8V256c70.7 0 128-57.3 128-128V44c0-6.6-5.4-12-12-12c-2.6 0-5.1 .8-7.2 2.4L336 80 268.8 5.3c-3-3.4-7.4-5.3-11.9-5.3h-1.7c-4.5 0-8.9 1.9-11.9 5.3L176 80 115.2 34.4c-2.1-1.6-4.6-2.4-7.2-2.4c-6.6 0-12 5.4-12 12z"]
};
var faPeoplePantsSimple = {
  prefix: 'fas',
  iconName: 'people-pants-simple',
  icon: [512, 512, [], "e21a", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C482.7 191.9 448 160 406.4 160H361.6z"]
};
var faCloudDrizzle = {
  prefix: 'fas',
  iconName: 'cloud-drizzle',
  icon: [512, 512, [], "f738", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-8 56v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 64v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V440c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V440c0-13.3 10.7-24 24-24zm-72-40v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24z"]
};
var faTableCellsLarge = {
  prefix: 'fas',
  iconName: 'table-cells-large',
  icon: [512, 512, ["th-large"], "f009", "M448 96V224H288V96H448zm0 192V416H288V288H448zM224 224H64V96H224V224zM64 288H224V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faThLarge = faTableCellsLarge;
var faBookTanakh = {
  prefix: 'fas',
  iconName: 'book-tanakh',
  icon: [448, 512, ["tanakh"], "f827", "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24H124.9l13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24H249.6L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48h55.4l27.7 48-27.7 48H180.3l-27.7-48zm0-48l-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24H194.1zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72l13.9 24H263.4l13.9-24zm-55.4 48L208 280l-13.9-24h27.7z"]
};
var faTanakh = faBookTanakh;
var faSolarSystem = {
  prefix: 'fas',
  iconName: 'solar-system',
  icon: [512, 512, [], "e02f", "M448 256c0 41.9-13.4 80.6-36.2 112.2C387.3 370.3 368 390.9 368 416c0 26.5 21.5 48 48 48s48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256C512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4c18.6 11.8 32 31.1 36 53.6C199.4 70.4 227 64 256 64c106 0 192 86 192 192zM256 448C150 448 64 362 64 256c0-41.9 13.4-80.6 36.2-112.2C124.7 141.7 144 121.1 144 96c0-26.5-21.5-48-48-48S48 69.5 48 96c0 3.2 .3 6.4 .9 9.4C18.2 147.7 0 199.7 0 256C0 397.4 114.6 512 256 512c42.1 0 81.7-10.1 116.8-28.1c-18.5-11.9-31.8-31.3-35.6-53.8C312.5 441.6 285 448 256 448zM389.2 182.7c1.8-4.6 2.8-9.5 2.8-14.7c0-22.1-17.9-40-40-40c-4 0-7.8 .6-11.5 1.7C316.4 113.5 287.3 104 256 104c-83.9 0-152 68.1-152 152s68.1 152 152 152s152-68.1 152-152c0-26.6-6.8-51.5-18.8-73.3zM312 168.4c.2 20.6 16 37.6 36.2 39.5c7.5 14.4 11.8 30.8 11.8 48.2c0 57.4-46.6 104-104 104s-104-46.6-104-104s46.6-104 104-104c20.6 0 39.8 6 56 16.4zm8 87.6a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faSealQuestion = {
  prefix: 'fas',
  iconName: 'seal-question',
  icon: [512, 512, [], "e243", "M222.1 17.9c18.7-18.7 49.1-18.7 67.9 0L336 64h64c26.5 0 48 21.5 48 48v64l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.1V400c0 26.5-21.5 48-48 48H335.1l-45.1 45.1c-18.7 18.7-49.1 18.7-67.9 0L176.9 448H112c-26.5 0-48-21.5-48-48V335.1L18.4 289.5c-18.7-18.7-18.7-49.1 0-67.9L64 176V112c0-26.5 21.5-48 48-48h64l46.1-46.1zM169.8 165.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faPhoneVolume = {
  prefix: 'fas',
  iconName: 'phone-volume',
  icon: [512, 512, ["volume-control-phone"], "f2a0", "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"]
};
var faVolumeControlPhone = faPhoneVolume;
var faDiscDrive = {
  prefix: 'fas',
  iconName: 'disc-drive',
  icon: [512, 512, [], "f8b5", "M32 96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H416 96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0z"]
};
var faHatCowboySide = {
  prefix: 'fas',
  iconName: 'hat-cowboy-side',
  icon: [640, 512, [], "f8c1", "M152.7 135.9l-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1h10.7c39.4 0 77.8 12.1 110.1 34.7L562.4 421.8l35.1 24.6c24.4-6 42.5-28.1 42.5-54.4c0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32h-2.7c-5.6 0-11.1 .7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4zM0 384c0 35.3 28.7 64 64 64H544L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9H162.9c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2V384z"]
};
var faTableRows = {
  prefix: 'fas',
  iconName: 'table-rows',
  icon: [512, 512, ["rows"], "e292", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 0V224H448V96H128zM448 288H128V416H448V288z"]
};
var faRows = faTableRows;
var faLocationExclamation = {
  prefix: 'fas',
  iconName: 'location-exclamation',
  icon: [384, 512, ["map-marker-exclamation"], "f608", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 96c13.3 0 24 10.7 24 24V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMapMarkerExclamation = faLocationExclamation;
var faFaceFearful = {
  prefix: 'fas',
  iconName: 'face-fearful',
  icon: [512, 512, [], "e375", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM96 224a64 64 0 1 1 128 0A64 64 0 1 1 96 224zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 112c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm173 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8zM192.4 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faClipboardUser = {
  prefix: 'fas',
  iconName: 'clipboard-user',
  icon: [384, 512, [], "f7f3", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"]
};
var faBusSchool = {
  prefix: 'fas',
  iconName: 'bus-school',
  icon: [512, 512, [], "f5dd", "M256 0C380.8 0 464 35.2 464 80V96v16h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H464v28.2c9.8 8.8 16 21.6 16 35.8v96c0 20.9-13.4 38.7-32 45.3V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V448H160v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V445.3c-18.6-6.6-32-24.4-32-45.3V304c0-14.2 6.2-27 16-35.8V240H32c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32H48V96 80C48 35.2 131.2 0 256 0zM112 160v64c0 17.7 14.3 32 32 32h96V128H144c-17.7 0-32 14.3-32 32zm160 96h96c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H272V256zM112 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 80c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16z"]
};
var faFilmSlash = {
  prefix: 'fas',
  iconName: 'film-slash',
  icon: [640, 512, [], "e179", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM224 150.3V128c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H318.1L224 150.3zM487.4 480l-87-68.5c-4.8 2.9-10.4 4.5-16.4 4.5H256c-17.7 0-32-14.3-32-32V320c0-14.1 9.1-26.1 21.8-30.3l-71.1-56c.8 2 1.3 4.1 1.3 6.4v32c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h32c.9 0 1.9 .1 2.8 .2L64 146.4V416c0 35.3 28.7 64 64 64H487.4zM112 368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V368zM464 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H480c-8.8 0-16-7.2-16-16V240zM480 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H480c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"]
};
var faSquareArrowDownRight = {
  prefix: 'fas',
  iconName: 'square-arrow-down-right',
  icon: [448, 512, [], "e262", "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384zM160 368c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24V344c0 13.3-10.7 24-24 24H160z"]
};
var faBookSparkles = {
  prefix: 'fas',
  iconName: 'book-sparkles',
  icon: [448, 512, ["book-spells"], "f6b8", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM264 200l16.6-38.8c2.8-6.5 11.9-6.5 14.7 0L312 200l38.8 16.6c6.5 2.8 6.5 11.9 0 14.7L312 248l-16.6 38.8c-2.8 6.5-11.9 6.5-14.7 0L264 248l-38.8-16.6c-6.5-2.8-6.5-11.9 0-14.7L264 200zM168.8 78.3c2.9-5.9 11.4-5.9 14.3 0L192 96l17.7 8.8c5.9 2.9 5.9 11.4 0 14.3L192 128l-8.8 17.7c-2.9 5.9-11.4 5.9-14.3 0L160 128l-17.7-8.8c-5.9-2.9-5.9-11.4 0-14.3L160 96l8.8-17.7z"]
};
var faBookSpells = faBookSparkles;
var faWashingMachine = {
  prefix: 'fas',
  iconName: 'washing-machine',
  icon: [448, 512, ["washer"], "f898", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM368 304A144 144 0 1 0 80 304a144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm16 328c-61.9 0-112-50.1-112-112c0-16.5 3.6-32.2 10-46.3c7.4-1.1 14.8-1.7 22-1.7c32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5C328.5 373 281.3 416 224 416z"]
};
var faWasher = faWashingMachine;
var faChild = {
  prefix: 'fas',
  iconName: 'child',
  icon: [320, 512, [], "f1ae", "M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm48 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H144z"]
};
var faLiraSign = {
  prefix: 'fas',
  iconName: 'lira-sign',
  icon: [320, 512, [8356], "f195", "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H46c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"]
};
var faUserVisor = {
  prefix: 'fas',
  iconName: 'user-visor',
  icon: [448, 512, [], "e04c", "M343 175.2C324.2 222.5 278 256 224 256s-100.2-33.5-119-80.8c-14.3-3.2-25-16-25-31.2V80c0-17.7 14.3-32 32-32h12.1C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48H336c17.7 0 32 14.3 32 32v64c0 15.3-10.7 28-25 31.2zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zm348.7-19.9c2.4 3.2 7.3 1.4 7.3-2.5c-1.1-35.3-11.3-65.6-30.1-90.2c-1.2-2-4.6-1.9-6.1-.1c-19.9 23-31.9 53-35.8 89.5c-.3 3.5 3.7 5.5 6.5 3.5c1.8-1.4 4.1-3.4 6.6-5.6c9.2-8.1 22.3-19.5 31.7-19.5c2.3 2 7.6 7.8 19.9 25zM144 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
};
var faFilePlusMinus = {
  prefix: 'fas',
  iconName: 'file-plus-minus',
  icon: [384, 512, [], "e177", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM208 208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V208c0-8.8 7.2-16 16-16s16 7.2 16 16zM128 384H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faChessClockFlip = {
  prefix: 'fas',
  iconName: 'chess-clock-flip',
  icon: [640, 512, ["chess-clock-alt"], "f43e", "M384 56c0-13.3 10.7-24 24-24H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H488v48h88c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64H96V112c0-8.8 7.2-16 16-16H240c8.8 0 16 7.2 16 16v16H440V80H408c-13.3 0-24-10.7-24-24zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zm-52.7-59.3c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l48-48c6.2-6.2 16.4-6.2 22.6 0zM464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm16-176v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChessClockAlt = faChessClockFlip;
var faSatellite = {
  prefix: 'fas',
  iconName: 'satellite',
  icon: [512, 512, [128752], "f7bf", "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"]
};
var faPlaneLock = {
  prefix: 'fas',
  iconName: 'plane-lock',
  icon: [640, 512, [], "e558", "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2C418 247.6 416 259.6 416 272v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v24 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faSteeringWheel = {
  prefix: 'fas',
  iconName: 'steering-wheel',
  icon: [512, 512, [], "f622", "M224 358.9v86.5C143.6 431.9 80.1 368.4 66.7 288H168.9L224 358.9zm64 0L343.1 288H445.3C431.9 368.4 368.4 431.9 288 445.3V358.9zM352 224l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7H195.8c-12.1 0-23.2 6.8-28.6 17.7L160 224H66.7C81.9 133.2 160.9 64 256 64s174.1 69.2 189.3 160H352zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faTag = {
  prefix: 'fas',
  iconName: 'tag',
  icon: [448, 512, [127991], "f02b", "M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faStretcher = {
  prefix: 'fas',
  iconName: 'stretcher',
  icon: [640, 512, [], "f825", "M83 79.2C64.9 59.8 34.5 58.9 15.2 77S-5.1 125.5 13 144.8L123.5 262.7c15.1 16.1 36.3 25.3 58.4 25.3H592c26.5 0 48-21.5 48-48s-21.5-48-48-48H188.8L83 79.2zM240 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0c0-5.3-.7-10.5-1.9-15.5L368 396.2l49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-12.4 0-24 3.5-33.9 9.7l-37.3-27.1 64-46.5H391.2L368 336.9 344.8 320H263.2l64 46.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm160-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faBookSection = {
  prefix: 'fas',
  iconName: 'book-section',
  icon: [448, 512, ["book-law"], "e0c1", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM228.5 241.3l7.5 2c37.9 9.8 46.1 15 43.6 27.7c-2.5 13.2-23.7 19.6-51.7 15.7c-10.2-1.4-22.4-5.4-33.1-8.9l-5.9-1.9c-8.4-2.7-17.4 1.9-20.1 10.4c-2.7 8.4 2 17.4 10.4 20.1l5.8 1.9c12 3.9 25.7 8.3 38.6 10.1c7 1 13.8 1.5 20.2 1.5c36.5 0 62.2-15.8 67.3-42.8c4.1-21.2-4-34.9-16.7-44.4c8.7-7.1 14.5-16.4 16.7-27.6c8.6-45.1-36.9-56.9-67-64.7l0 0-7.3-1.9c-36.5-9.7-38-16.5-36.2-25.8c2.5-13.2 23.8-19.7 51.6-15.7c6.6 .9 14.6 2.9 25.2 6.2c8.3 2.6 17.4-2.1 20-10.5c2.6-8.4-2.1-17.4-10.5-20c-12.2-3.8-21.9-6.2-30.2-7.3c-47.1-6.7-81.5 9.6-87.5 41.3c-4.1 21.3 4.4 35.1 16.7 44.5c-8.7 7.1-14.5 16.4-16.7 27.5c-8.5 44.6 37.4 56.8 59.5 62.7zm-2.9-72.8c.9 .2 10.3 2.7 10.3 2.7c37.9 9.8 46.1 15 43.6 27.7c-2.2 11.3-16.5 14.9-25.2 16.1c-3.6-1-17.7-4.7-17.7-4.7c-36.5-9.7-38-16.5-36.2-25.8c2.2-11.3 16.5-14.9 25.2-16.1z"]
};
var faBookLaw = faBookSection;
var faInboxes = {
  prefix: 'fas',
  iconName: 'inboxes',
  icon: [512, 512, [], "e1bb", "M117.7 64L79.3 160h45c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7h45L394.3 64H117.7zM60.3 35.2C68.8 13.9 89.4 0 112.2 0H399.8c22.9 0 43.5 13.9 52 35.2L508 175.8c2.6 6.6 4 13.7 4 20.8V264c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V196.6c0-7.1 1.4-14.2 4-20.8L60.3 35.2zM48 352h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"]
};
var faCoffeeBean = {
  prefix: 'fas',
  iconName: 'coffee-bean',
  icon: [448, 512, [], "e13e", "M331.4 203.3c24.4-24.6 45.4-67.3 59.9-101.7c5.1-12.2 20.9-15.3 28.2-4.3c51.2 77.7 26.2 201.2-63.4 290.8c-79.6 79.6-186 108.1-263.2 77.7c-14.8-5.8-20-23.2-13.2-37.5c.7-1.6 1.5-3.1 2.2-4.7c16.5-34.5 37.5-72.2 57.4-92.3c29.7-29.9 59.7-44.9 91.8-61l.5-.3 0 0c32-15.9 66.1-32.9 99.7-66.8zM53.1 409.7c-5.3 11-19.9 13.6-26.9 3.6c-54-77.4-29.6-203.2 61.2-294C167.6 39.1 275.1 10.7 352.5 42.4c14 5.7 19.4 22 13.7 36c-1.4 3.5-2.9 7.1-4.4 10.8c-14.5 34.5-33.5 71.8-53.1 91.5c-29.7 29.9-59.7 44.9-91.8 61l-.5 .3c-32 15.9-66.1 32.9-99.7 66.8c-24.1 24.3-47.1 66.6-63.6 101z"]
};
var faCircleYen = {
  prefix: 'fas',
  iconName: 'circle-yen',
  icon: [512, 512, [], "e5d0", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.9 150.2c9.8-8.9 25-8.2 33.9 1.6L256 220.3l62.2-68.5c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9L288.4 256H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H280v32h40c8.8 0 16 7.2 16 16s-7.2 16-16 16H280v25c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h40V288H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h31.6l-65.3-71.9c-8.9-9.8-8.2-25 1.6-33.9z"]
};
var faBracketsCurly = {
  prefix: 'fas',
  iconName: 'brackets-curly',
  icon: [576, 512, [], "f7ea", "M416 32H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32 14.3 32 32v37.5c0 25.5 10.1 49.9 28.1 67.9L498.7 256l-22.6 22.6c-18 18-28.1 42.4-28.1 67.9V384c0 17.7-14.3 32-32 32H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c53 0 96-43 96-96V346.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3l-45.3-45.3c-6-6-9.4-14.1-9.4-22.6V128c0-53-43-96-96-96zM160 32c-53 0-96 43-96 96v37.5c0 8.5-3.4 16.6-9.4 22.6L9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l45.3 45.3c6 6 9.4 14.1 9.4 22.6V384c0 53 43 96 96 96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V346.5c0-25.5-10.1-49.9-28.1-67.9L77.3 256l22.6-22.6c18-18 28.1-42.4 28.1-67.9V128c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160z"]
};
var faEllipsisStrokeVertical = {
  prefix: 'fas',
  iconName: 'ellipsis-stroke-vertical',
  icon: [192, 512, ["ellipsis-v-alt"], "f39c", "M96 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 96A72 72 0 1 1 96 24a72 72 0 1 1 0 144zm24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 256zm96 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 416z"]
};
var faEllipsisVAlt = faEllipsisStrokeVertical;
var faComment = {
  prefix: 'fas',
  iconName: 'comment',
  icon: [512, 512, [128489, 61669], "f075", "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"]
};
var faSquare1 = {
  prefix: 'fas',
  iconName: 'square-1',
  icon: [448, 512, [], "e256", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm236 35.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L200 193.4V336H160c-13.3 0-24 10.7-24 24s10.7 24 24 24h64 64c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V152c0-8.6-4.6-16.5-12-20.8z"]
};
var faCakeCandles = {
  prefix: 'fas',
  iconName: 'cake-candles',
  icon: [448, 512, [127874, "birthday-cake", "cake"], "f1fd", "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1 0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l0 0 0 0 .1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l0 0 0 0 0 0 .1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9V288c0-35.3-28.7-64-64-64V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H128V176zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V394.6z"]
};
var faBirthdayCake = faCakeCandles;
var faCake = faCakeCandles;
var faHeadSide = {
  prefix: 'fas',
  iconName: 'head-side',
  icon: [512, 512, [], "f6e9", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faEnvelope = {
  prefix: 'fas',
  iconName: 'envelope',
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"]
};
var faDollyEmpty = {
  prefix: 'fas',
  iconName: 'dolly-empty',
  icon: [576, 512, [], "f473", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64h72.9L197 340.2c-22.5 17.6-37 45-37 75.8c0 53 43 96 96 96c52.4 0 95.1-42 96-94.3l202.1-67.4c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2L331.8 357c-17.2-22.1-43.9-36.5-74-37L165.7 43.8C156.9 17.6 132.5 0 104.9 0H32z"]
};
var faFaceTissue = {
  prefix: 'fas',
  iconName: 'face-tissue',
  icon: [512, 512, [], "e39c", "M512 256c0 141.4-114.6 256-256 256c-11.5 0-22.9-.8-34-2.2c.6-1.9 1-3.9 1.4-5.9l18.4-110.2 5.4 3.6c5.4 3.6 12.4 3.6 17.8 0L304 371.2l39.1 26.1c4.8 3.2 10.9 3.6 16 1l32-16c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-23.7 11.8-40.3-26.8c-5.4-3.6-12.4-3.6-17.8 0L256 364.8l-8.5-5.7 7.9-47.2c2.5-15.3-2.4-30.9-13.4-41.8s-26.5-16-41.8-13.4l-192 32c-2 .3-4 .8-5.9 1.4C.8 278.9 0 267.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM133.5 130.7c-7.9-4.2-17.5 1.5-17.5 10.5c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9zM396 141.1c0-9-9.6-14.7-17.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6zM219.3 292.7c3.7 3.7 5.3 8.8 4.5 13.9l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5L51.9 479.5c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3 .8 13.9 4.5z"]
};
var faAnglesUp = {
  prefix: 'fas',
  iconName: 'angles-up',
  icon: [448, 512, ["angle-double-up"], "f102", "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"]
};
var faAngleDoubleUp = faAnglesUp;
var faBinRecycle = {
  prefix: 'fas',
  iconName: 'bin-recycle',
  icon: [576, 512, [], "e5f7", "M0 64C0 46.3 14.3 32 32 32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm32 64H544L517.3 421.8c-3 33-30.6 58.2-63.7 58.2H122.4c-33.1 0-60.7-25.2-63.7-58.2L32 128zm256 88c2.2 0 4.3 1.1 5.5 2.9l20.7 29.6c7.3 10.5 21.6 13.4 32.4 6.6c11.7-7.3 14.8-22.9 6.9-34.1l-20.7-29.6c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3l-20.7 29.6c-7.9 11.3-4.7 26.8 6.9 34.1c10.8 6.8 25.1 3.9 32.4-6.6l20.7-29.6c1.3-1.8 3.3-2.9 5.5-2.9zm-88.3 77.1c-10.8-6.8-25.1-3.9-32.4 6.6l-21.5 30.7c-6.4 9.1-9.8 20-9.8 31.2c0 30.1 24.4 54.4 54.4 54.4H240c13.3 0 24-10.7 24-24s-10.7-24-24-24H190.4c-3.5 0-6.4-2.9-6.4-6.4c0-1.3 .4-2.6 1.2-3.7l21.5-30.7c7.9-11.3 4.7-26.8-6.9-34.1zM312 392c0 13.3 10.7 24 24 24h49.6c30.1 0 54.4-24.4 54.4-54.4c0-11.2-3.4-22.1-9.8-31.2l-21.5-30.7c-7.3-10.5-21.6-13.4-32.4-6.6c-11.7 7.3-14.8 22.9-6.9 34.1l21.5 30.7c.8 1.1 1.2 2.4 1.2 3.7c0 3.5-2.9 6.4-6.4 6.4H336c-13.3 0-24 10.7-24 24z"]
};
var faPaperclip = {
  prefix: 'fas',
  iconName: 'paperclip',
  icon: [448, 512, [128206], "f0c6", "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"]
};
var faChartLineDown = {
  prefix: 'fas',
  iconName: 'chart-line-down',
  icon: [512, 512, [128201], "f64d", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm217.4 57.4L208 194.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0L304 189.3l57.4 57.4L329 279c-15.1 15.1-4.4 41 17 41H456c13.3 0 24-10.7 24-24V185.9c0-21.4-25.9-32.1-41-17l-32.4 32.4-80-80c-12.5-12.5-32.8-12.5-45.3 0z"]
};
var faArrowRightToCity = {
  prefix: 'fas',
  iconName: 'arrow-right-to-city',
  icon: [640, 512, [], "e4b3", "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"]
};
var faLockA = {
  prefix: 'fas',
  iconName: 'lock-a',
  icon: [448, 512, [], "e422", "M224 64c44.2 0 80 35.8 80 80v48H144V144c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H368V144C368 64.5 303.5 0 224 0S80 64.5 80 144zm49.7 280.8L209.6 265c.8-1.6 1.8-3 3-4.3c1.4-1.5 3.1-2.6 5-3.4c2.1-.9 4.2-1.3 6.4-1.3s4.3 .4 6.4 1.3c1.8 .8 3.5 1.9 5 3.4c1.3 1.3 2.3 2.7 3.1 4.3l79.9 159.9c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L270.1 400H177.9l-19.6 39.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5zM193.9 368h60.2L224 307.8 193.9 368z"]
};
var faRibbon = {
  prefix: 'fas',
  iconName: 'ribbon',
  icon: [448, 512, [127895], "f4d6", "M333.2 322.8l0 0-133.9-146 0 0L146 118.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65V149.1c0-19-5.6-37.5-16.1-53.3L327.8 35.6C312.9 13.4 287.9 0 261.2 0h-76c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8V164c0 23.2 8.4 45.6 23.6 63.1l56 64.2 0 0 83.3 95.6 0 0 91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4l-87.7-95.7zM205.2 410.6l-83.3-95.6L27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z"]
};
var faLungs = {
  prefix: 'fas',
  iconName: 'lungs',
  icon: [640, 512, [129729], "f604", "M320 0c17.7 0 32 14.3 32 32V164.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V325l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32z"]
};
var faPersonPinball = {
  prefix: 'fas',
  iconName: 'person-pinball',
  icon: [640, 512, [], "e21d", "M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM96 241.7v65.1l49.9 49.9c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L18.7 320C6.7 308 0 291.7 0 274.7V186.6C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64H224c12.9 0 24.1 7.7 29.1 18.7l295-49.2L515.3 95c-2.2-6.5-3.3-13.4-3.3-20.2V32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V178.2 216v8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H256v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H152.6c-16 0-31-8-39.9-21.4L96 241.7zM0 480L0 346.5l64 64V480v0c0 17.7-14.3 32-32 32s-32-14.3-32-32zM280 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowUp91 = {
  prefix: 'fas',
  iconName: 'arrow-up-9-1',
  icon: [576, 512, ["sort-numeric-up-alt"], "f887", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM450.7 294c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"]
};
var faSortNumericUpAlt = faArrowUp91;
var faAppleCore = {
  prefix: 'fas',
  iconName: 'apple-core',
  icon: [384, 512, [], "e08f", "M192 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H192zM30.5 167c-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c19.3 0 36.1 5.4 50.3 14.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3c-34.9 0-69.8-18.3-98.1-49.6c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137z"]
};
var faCircleY = {
  prefix: 'fas',
  iconName: 'circle-y',
  icon: [512, 512, [], "e12f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM170.1 152.3L256 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L280 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24V297L133.9 183.7c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z"]
};
var faH6 = {
  prefix: 'fas',
  iconName: 'h6',
  icon: [640, 512, [], "e413", "M537 116l-35.3 44.1C578.6 163.1 640 226.4 640 304c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.3 13-75.5 37-105.5L487 76c11-13.8 31.2-16 45-5s16 31.2 5 45zM416 304a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z"]
};
var faLitecoinSign = {
  prefix: 'fas',
  iconName: 'litecoin-sign',
  icon: [384, 512, [], "e1d3", "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64V213.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L64 280.1V448c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3V64z"]
};
var faCircleSmall = {
  prefix: 'fas',
  iconName: 'circle-small',
  icon: [320, 512, [], "e122", "M0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z"]
};
var faBorderNone = {
  prefix: 'fas',
  iconName: 'border-none',
  icon: [448, 512, [], "f850", "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faArrowTurnDownLeft = {
  prefix: 'fas',
  iconName: 'arrow-turn-down-left',
  icon: [512, 512, [], "e2e1", "M448 64c0-17.7 14.3-32 32-32s32 14.3 32 32V224c0 53-43 96-96 96H109.3l73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H416c17.7 0 32-14.3 32-32V64z"]
};
var faCircleNodes = {
  prefix: 'fas',
  iconName: 'circle-nodes',
  icon: [512, 512, [], "e4e2", "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"]
};
var faParachuteBox = {
  prefix: 'fas',
  iconName: 'parachute-box',
  icon: [512, 512, [], "f4cd", "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H240V320H208c-7 0-13.7 1.5-19.7 4.2L68.2 192H96.5c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192h6L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2H272V192H383.5z"]
};
var faMessageMedical = {
  prefix: 'fas',
  iconName: 'message-medical',
  icon: [512, 512, ["comment-alt-medical"], "f7f4", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm224 64v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240h48c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H288V128c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"]
};
var faCommentAltMedical = faMessageMedical;
var faRugbyBall = {
  prefix: 'fas',
  iconName: 'rugby-ball',
  icon: [512, 512, [], "e3c6", "M368 16c13.4 0 26.4 2.1 38.5 5.9c-21.1 1.8-44.5 8.7-69 19.5c-53.4 23.5-114.8 66.9-172.1 124.1S64.9 284.1 41.4 337.6c-10.8 24.5-17.7 47.9-19.5 69C18.1 394.4 16 381.4 16 368l0-32C16 159.3 159.3 16 336 16l32 0zm122.1 89.5c3.8 12.2 5.9 25.1 5.9 38.5v32c0 176.7-143.3 320-320 320H144c-13.4 0-26.4-2.1-38.5-5.9c21.1-1.8 44.5-8.7 69-19.5c53.4-23.5 114.8-66.9 172.1-124.1s100.6-118.6 124.1-172.1c10.8-24.5 17.7-47.9 19.5-69zM63.7 448.3c-6.7-6.7-10.9-17.8-10.2-34.8c.7-17.1 6.3-38.5 17.1-63c21.5-49 62.3-107.1 117.5-162.3s113.4-95.9 162.3-117.5c24.5-10.8 45.9-16.4 63-17.1c17.1-.7 28.1 3.5 34.8 10.2s10.9 17.8 10.2 34.8c-.7 17.1-6.3 38.5-17.1 63c-21.5 49-62.3 107.1-117.5 162.3s-113.4 95.9-162.3 117.5c-24.5 10.8-45.9 16.4-63 17.1c-17.1 .7-28.1-3.4-34.8-10.2z"]
};
var faCommentMusic = {
  prefix: 'fas',
  iconName: 'comment-music',
  icon: [512, 512, [], "f8b0", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm96-320v32V288c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V183.1l-96 36V320c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V208 176c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z"]
};
var faIndent = {
  prefix: 'fas',
  iconName: 'indent',
  icon: [448, 512, [], "f03c", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"]
};
var faTreeDeciduous = {
  prefix: 'fas',
  iconName: 'tree-deciduous',
  icon: [512, 512, [127795, "tree-alt"], "f400", "M384 80c-11.5 0-22.5 2.4-32.4 6.8C347 38.1 305.9 0 256 0s-91 38.1-95.6 86.8C150.5 82.4 139.5 80 128 80c-44.2 0-80 35.8-80 80c0 14.4 3.8 27.9 10.5 39.6C24.1 214.2 0 248.3 0 288c0 53 43 96 96 96H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H416c53 0 96-43 96-96c0-39.7-24.1-73.8-58.5-88.4c6.7-11.7 10.5-25.2 10.5-39.6c0-44.2-35.8-80-80-80z"]
};
var faTreeAlt = faTreeDeciduous;
var faPuzzlePieceSimple = {
  prefix: 'fas',
  iconName: 'puzzle-piece-simple',
  icon: [640, 512, ["puzzle-piece-alt"], "e231", "M264.8 64C277.6 64 288 74.4 288 87.2v0c0 9.2-5.8 17.3-13.2 22.8c-11.6 8.7-18.8 20.7-18.8 34c0 26.5 28.7 48 64 48s64-21.5 64-48c0-13.3-7.2-25.3-18.8-34c-7.4-5.5-13.2-13.6-13.2-22.8v0C352 74.4 362.4 64 375.2 64H464c26.5 0 48 21.5 48 48v88.8c0 12.8 10.4 23.2 23.2 23.2v0c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2v0c-12.8 0-23.2 10.4-23.2 23.2V400c0 26.5-21.5 48-48 48H375.2c-12.8 0-23.2-10.4-23.2-23.2v0c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8v0c0 12.8-10.4 23.2-23.2 23.2H176c-26.5 0-48-21.5-48-48V311.2c0-12.8-10.4-23.2-23.2-23.2v0c-9.2 0-17.3 5.8-22.8 13.2C73.3 312.8 61.3 320 48 320c-26.5 0-48-28.7-48-64s21.5-64 48-64c13.3 0 25.3 7.2 34 18.8c5.5 7.4 13.6 13.2 22.8 13.2v0c12.8 0 23.2-10.4 23.2-23.2V112c0-26.5 21.5-48 48-48h88.8z"]
};
var faPuzzlePieceAlt = faPuzzlePieceSimple;
var faTruckFieldUn = {
  prefix: 'fas',
  iconName: 'truck-field-un',
  icon: [640, 512, [], "e58e", "M96 32C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38H375.4C364.4 44.9 343.7 32 320 32H96zm288 96h43.2l42.7 96H384V128zM112 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faNfcTrash = {
  prefix: 'fas',
  iconName: 'nfc-trash',
  icon: [640, 512, [], "e1fd", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v66.7c-11.5 4.1-21.3 12.5-26.9 23.8l-2.7 5.5H400c-5.6 0-11 1-16 2.7V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v96V368c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H336c16.4 0 30.9-8.2 39.6-20.8l6.1 84.8H64c-35.3 0-64-28.7-64-64V96zM449.7 200.8c2.7-5.4 8.2-8.8 14.3-8.8h96c6.1 0 11.6 3.4 14.3 8.8L585.9 224H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H576 448 400c-8.8 0-16-7.2-16-16s7.2-16 16-16h38.1l11.6-23.2zM413.9 482.3L400 288H624L610.1 482.3C608.9 499 595 512 578.2 512H445.8c-16.8 0-30.7-13-31.9-29.7z"]
};
var faHourglass = {
  prefix: 'fas',
  iconName: 'hourglass',
  icon: [384, 512, [9203, 62032, "hourglass-empty"], "f254", "M0 32C0 14.3 14.3 0 32 0H64 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zM96 64V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64H96zm0 384H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z"]
};
var faHourglassEmpty = faHourglass;
var faMountain = {
  prefix: 'fas',
  iconName: 'mountain',
  icon: [512, 512, [127956], "f6fc", "M256 32c12.5 0 24.1 6.4 30.8 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5l18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8h49z"]
};
var faFileXmark = {
  prefix: 'fas',
  iconName: 'file-xmark',
  icon: [384, 512, ["file-times"], "f317", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 239c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faFileTimes = faFileXmark;
var faHouseHeart = {
  prefix: 'fas',
  iconName: 'house-heart',
  icon: [576, 512, ["home-heart"], "f4c9", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM176 269.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
var faHomeHeart = faHouseHeart;
var faHouseChimneyBlank = {
  prefix: 'fas',
  iconName: 'house-chimney-blank',
  icon: [576, 512, [], "e3b0", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"]
};
var faMeterBolt = {
  prefix: 'fas',
  iconName: 'meter-bolt',
  icon: [640, 512, [], "e1e9", "M256 512c73.7 0 140.1-31.1 186.8-81l7.5-15H432c-20.4 0-38.5-12.9-45.3-32.1s-.6-40.6 15.3-53.4l109.6-87.7C504.8 107.5 393 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm218.1 67.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L449.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H553.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"]
};
var faUserDoctor = {
  prefix: 'fas',
  iconName: 'user-doctor',
  icon: [448, 512, ["user-md"], "f0f0", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faUserMd = faUserDoctor;
var faSlashBack = {
  prefix: 'fas',
  iconName: 'slash-back',
  icon: [320, 512, [], "5c", "M16.1 4.2C.8 13-4.6 32.5 4.2 47.9l256 448c8.8 15.3 28.3 20.7 43.7 11.9s20.7-28.3 11.9-43.7l-256-448C51 .8 31.5-4.6 16.1 4.2z"]
};
var faCircleInfo = {
  prefix: 'fas',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faInfoCircle = faCircleInfo;
var faFishingRod = {
  prefix: 'fas',
  iconName: 'fishing-rod',
  icon: [448, 512, [], "e3a8", "M295.9 48c-3 0-6 .4-8.8 1.2L209.8 71.3C137.7 91.9 88 157.8 88 232.8V288h8c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8V232.8c0-96.4 63.9-181.2 156.7-207.7L273.8 3.1C281 1 288.4 0 295.9 0C340.1 0 376 35.9 376 80.1V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V80.1C328 62.4 313.6 48 295.9 48zM256 344c0-71.6 55.6-127.8 89-148.1c4.3-2.6 9.6-2.6 14 0c33.5 20.3 89 76.6 89 148.1c0 32-16 80-64 112l27.3 27.3c3 3 4.7 7.1 4.7 11.3V496c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16v-1.4c0-4.2 1.7-8.3 4.7-11.3L320 456c-48-32-64-80-64-112zm128-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHammerCrash = {
  prefix: 'fas',
  iconName: 'hammer-crash',
  icon: [640, 512, [], "e414", "M283.9 378.6l18.3-60.1c18-4.1 34.2-16 43.1-33.8l64-128c10.5-21.1 8.4-45.2-3.7-63.6l52.7-76.6c3.7-5.4 10.4-8 16.7-6.5s11.2 6.7 12.3 13.1l16.2 104.1 105.1-7.4c6.5-.5 12.7 3.1 15.5 9s1.8 12.9-2.6 17.8L550.1 224l71.3 77.5c4.4 4.8 5.5 11.9 2.6 17.8s-9 9.5-15.5 9l-105.1-7.4L487.3 425c-1 6.5-5.9 11.7-12.3 13.1s-13-1.1-16.7-6.5l-59.7-86.7-91.4 52.2c-5.7 3.3-12.8 2.7-17.9-1.4s-7.2-10.9-5.3-17.2zm28.3-101.7c-9.3 10.9-25.2 14.4-38.6 7.7l-65.9-32.9 0 0L122 208.8l0 0L17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80C48.8 22.8 59.9 16 72 16H192c5 0 9.9 1.2 14.3 3.4l78.2 39.1 81.8 40.9c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-1.2 2.4-2.7 4.6-4.4 6.6zM107.6 237.4l85.9 42.9L90.9 485.5c-11.9 23.7-40.7 33.3-64.4 21.5S-6.8 466.2 5.1 442.5L107.6 237.4z"]
};
var faMessageHeart = {
  prefix: 'fas',
  iconName: 'message-heart',
  icon: [512, 512, [], "e5c9", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM144 173.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faCloudMeatball = {
  prefix: 'fas',
  iconName: 'cloud-meatball',
  icon: [512, 512, [], "f73b", "M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faCameraPolaroid = {
  prefix: 'fas',
  iconName: 'camera-polaroid',
  icon: [576, 512, [], "f8aa", "M64 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V246.3l53.3 79.9c7 10.5 10.7 22.9 10.7 35.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V361.7c0-12.6 3.7-25 10.7-35.5L64 246.3V96zM288 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM448 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faCamera = {
  prefix: 'fas',
  iconName: 'camera',
  icon: [512, 512, [62258, "camera-alt"], "f030", "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faCameraAlt = faCamera;
var faSquareVirus = {
  prefix: 'fas',
  iconName: 'square-virus',
  icon: [448, 512, [], "e578", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCartArrowUp = {
  prefix: 'fas',
  iconName: 'cart-arrow-up',
  icon: [576, 512, [], "e3ee", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H312V177.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V288h99.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faMeteor = {
  prefix: 'fas',
  iconName: 'meteor',
  icon: [512, 512, [9732], "f753", "M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faCarOn = {
  prefix: 'fas',
  iconName: 'car-on',
  icon: [512, 512, [], "e4dd", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
var faSleigh = {
  prefix: 'fas',
  iconName: 'sleigh',
  icon: [640, 512, [], "f7cc", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V256c0 53 43 96 96 96v32h64V352H384v32h64V352c53 0 96-43 96-96V160c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 480c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7H55 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H552c48.6 0 88-39.4 88-88v-8z"]
};
var faArrowDown19 = {
  prefix: 'fas',
  iconName: 'arrow-down-1-9',
  icon: [576, 512, ["sort-numeric-asc", "sort-numeric-down"], "f162", "M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V64c0-10.3-4.9-19.9-13.3-26zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM418.3 307a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 307zM405.1 419.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"]
};
var faSortNumericAsc = faArrowDown19;
var faSortNumericDown = faArrowDown19;
var faBuoyMooring = {
  prefix: 'fas',
  iconName: 'buoy-mooring',
  icon: [576, 512, [], "e5b6", "M256 32c0-17.7 14.3-32 32-32s32 14.3 32 32V68.7c38 11.5 67.8 43.2 75.9 83.7l48.5 242.7c-.4 .3-.9 .6-1.3 .9c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-19 0-41.2-7.9-59.2-20.3c-.4-.3-.9-.6-1.3-.9l48.5-242.7c8.1-40.6 37.9-72.2 75.9-83.7V32zm32 96c-22 0-40.9 15.5-45.2 37L218.2 288H357.8L333.2 165c-4.3-21.5-23.2-37-45.2-37zm18.5 293.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faSquare4 = {
  prefix: 'fas',
  iconName: 'square-4',
  icon: [448, 512, [], "e259", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm191.6 33.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10H240v40c0 13.3 10.7 24 24 24s24-10.7 24-24V320h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H169.3l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z"]
};
var faHandHoldingDroplet = {
  prefix: 'fas',
  iconName: 'hand-holding-droplet',
  icon: [576, 512, ["hand-holding-water"], "f4c1", "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faHandHoldingWater = faHandHoldingDroplet;
var faTricycleAdult = {
  prefix: 'fas',
  iconName: 'tricycle-adult',
  icon: [640, 512, [], "e5c4", "M312 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h31.4c2.6 0 5 1.3 6.5 3.4l79.2 112.5-48.2 64.3c-5.6 7.5-14.4 11.9-23.7 11.9c-1.9 0-3.8-.2-5.7-.5l-322.9-63c-13-2.5-25.6 6-28.2 19s6 25.6 19 28.2l4.6 .9C9.1 305.4 0 327.6 0 352c0 53 43 96 96 96c18.2 0 35.3-5.1 49.8-13.9c-.6 .4-1.2 .7-1.8 1.1c14.1 8.2 30.5 12.8 48 12.8c53 0 96-43 96-96c0-4.1-.3-8.2-.8-12.2l55.1 10.7c4.9 1 9.9 1.4 14.9 1.4c24.4 0 47.4-11.5 62.1-31.1l38.8-51.8 13.7 19.5C457 305.6 448 327.7 448 352c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-11.4 0-22.3 2-32.5 5.6L389.2 87.8C378.7 72.9 361.6 64 343.4 64H312zM223.5 327.4c5.3 6.8 8.5 15.3 8.5 24.6c0 22.1-17.9 40-40 40c-2.9 0-5.6-.3-8.3-.9c5.3-12 8.3-25.2 8.3-39.1c0-11.2-1.9-21.9-5.4-31.8l36.9 7.2zM96 312a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm448 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM94.1 117.2c-6-16.6-24.3-25.3-40.9-19.3s-25.3 24.3-19.3 40.9l14.9 41.7c9.4 26.2 31.7 45.6 58.9 51.3l77.7 16.3c17.3 3.6 34.3-7.4 37.9-24.7s-7.4-34.3-24.7-37.9l-77.7-16.3c-5.4-1.1-9.9-5-11.8-10.3L94.1 117.2z"]
};
var faWaveform = {
  prefix: 'fas',
  iconName: 'waveform',
  icon: [640, 512, [], "f8f1", "M320 0c12 0 22.1 8.8 23.8 20.7l42 304.4L424.3 84.2c1.9-11.7 12-20.3 23.9-20.2s21.9 8.9 23.6 20.6l28.2 197.3 20.5-102.6c2.2-10.8 11.3-18.7 22.3-19.3s20.9 6.4 24.2 16.9L593.7 264H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H576c-10.5 0-19.8-6.9-22.9-16.9l-4.1-13.4-29.4 147c-2.3 11.5-12.5 19.6-24.2 19.3s-21.4-9-23.1-20.6L446.7 248.3l-39 243.5c-1.9 11.7-12.1 20.3-24 20.2s-21.9-8.9-23.5-20.7L320 199.6 279.8 491.3c-1.6 11.8-11.6 20.6-23.5 20.7s-22.1-8.5-24-20.2l-39-243.5L167.8 427.4c-1.7 11.6-11.4 20.3-23.1 20.6s-21.9-7.8-24.2-19.3l-29.4-147-4.1 13.4C83.8 305.1 74.5 312 64 312H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H46.3l26.8-87.1c3.2-10.5 13.2-17.5 24.2-16.9s20.2 8.5 22.3 19.3l20.5 102.6L168.2 84.6c1.7-11.7 11.7-20.5 23.6-20.6s22 8.5 23.9 20.2l38.5 240.9 42-304.4C297.9 8.8 308 0 320 0z"]
};
var faWater = {
  prefix: 'fas',
  iconName: 'water',
  icon: [576, 512, [], "f773", "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faStarSharpHalfStroke = {
  prefix: 'fas',
  iconName: 'star-sharp-half-stroke',
  icon: [576, 512, ["star-sharp-half-alt"], "e28d", "M56 230.4L41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176H74.7h2.5 .1H214.5L258.6 37.2l.1-.3 1.3-4 0 0 5.2-16.2C268.3 6.8 277.6 0 288 0s19.7 6.8 22.9 16.7L316 32.9l1.3 4 .1 .3L361.6 176H498.7h.1 2.5H520c10.3 0 19.4 6.5 22.7 16.2s.1 20.4-8 26.7L520 230.4l-2 1.5-.1 .1-114 88.7 44.4 139.5 .1 .4 1.4 4.5 5 15.7c3.2 10-.5 21-9.1 27s-20.2 5.7-28.5-.7l-13-10.1-3.7-2.9-.3-.3L288 406.4 175.8 493.7l-.3 .3-3.7 2.9-13 10.1c-8.3 6.5-19.8 6.8-28.5 .7s-12.3-16.9-9.1-27l5-15.7 1.4-4.5 .1-.4 44.4-139.5L58.1 232l-.1-.1-2-1.5zM288 335.5l0 0 34.4 26.7 47.9 37.2-19.7-61.8-11.8-37.2 30.8-24L426.7 232H361.6h-41l-12.4-39L288 129.5l0 0V335.5z"]
};
var faStarSharpHalfAlt = faStarSharpHalfStroke;
var faNfcSignal = {
  prefix: 'fas',
  iconName: 'nfc-signal',
  icon: [512, 512, [], "e1fb", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V227c-22.4 3.4-43.8 9.6-64 18.3V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16V261.7c-47.2 28.4-84.8 71.2-106.7 122.3H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H233.9c-5.8 20.4-9.2 41.9-9.8 64H64c-35.3 0-64-28.7-64-64V96zM488 256c13.3 0 24 10.7 24 24s-10.7 24-24 24c-101.6 0-184 82.4-184 184c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1 103.9-232 232-232zm-8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-72c0 13.3-10.7 24-24 24c-48.6 0-88 39.4-88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-75.1 60.9-136 136-136c13.3 0 24 10.7 24 24z"]
};
var faPlaneProp = {
  prefix: 'fas',
  iconName: 'plane-prop',
  icon: [576, 512, [], "e22b", "M240 384l-8.3-66.4-110-11L113.8 370c-1 8-7.8 14-15.9 14H62.1c-8.1 0-14.9-6-15.9-14L36 287.8c-1.3 .2-2.6 .2-4 .2c-17.7 0-32-14.3-32-32s14.3-32 32-32c1.3 0 2.7 .1 4 .2L46.2 142c1-8 7.8-14 15.9-14H97.9c8.1 0 14.9 6 15.9 14l7.9 63.4 110-11L240 128H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h24l6.2-50c1-8 7.8-14 15.9-14h35.8c8.1 0 14.9 6 15.9 14L328 64h40V48c0-8.8 7.2-16 16-16s16 7.2 16 16V80c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H336l8 64H482.3c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64H344l-8 64h32V368c0-8.8 7.2-16 16-16s16 7.2 16 16v32c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H328l-6.2 50c-1 8-7.8 14-15.9 14H270.1c-8.1 0-14.9-6-15.9-14L248 448H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h16z"]
};
var faCalendarCheck = {
  prefix: 'fas',
  iconName: 'calendar-check',
  icon: [448, 512, [], "f274", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"]
};
var faClockDesk = {
  prefix: 'fas',
  iconName: 'clock-desk',
  icon: [448, 512, [], "e134", "M0 224a224 224 0 1 1 448 0A224 224 0 1 1 0 224zM224 96c-13.3 0-24 10.7-24 24V224c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41V120c0-13.3-10.7-24-24-24zm0 384c96.4 0 180.3-53.3 224-132V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V348c43.7 78.7 127.6 132 224 132z"]
};
var faCalendarClock = {
  prefix: 'fas',
  iconName: 'calendar-clock',
  icon: [576, 512, ["calendar-time"], "e0d2", "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H432 0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368c0-97.2 78.8-176 176-176c5.4 0 10.7 .2 16 .7V192zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faCalendarTime = faCalendarClock;
var faBraille = {
  prefix: 'fas',
  iconName: 'braille',
  icon: [640, 512, [], "f2a1", "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faPrescriptionBottleMedical = {
  prefix: 'fas',
  iconName: 'prescription-bottle-medical',
  icon: [384, 512, ["prescription-bottle-alt"], "f486", "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM160 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
};
var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
var faPlateUtensils = {
  prefix: 'fas',
  iconName: 'plate-utensils',
  icon: [640, 512, [58713], "e43b", "M40.7 16c4 .3 7.1 3.5 7.3 7.5L55.5 152H72.9L88.1 23.1c.5-4 3.9-7.1 7.9-7.1s7.5 3 7.9 7.1L119.1 152h17.3L144 23.5c.2-4 3.3-7.2 7.3-7.5s7.6 2.3 8.5 6.1l30.3 128.7c1.3 5.4 1.9 11 1.9 16.6c0 39.9-32.2 72.2-72 72.5V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V240c-39.8-.3-72-32.6-72-72.5c0-5.6 .6-11.2 1.9-16.6L32.2 22.2c.9-3.9 4.5-6.5 8.5-6.1zm572.4 1c2-.7 4-1 6.1-1c11.5 0 20.9 9.3 20.9 20.9V216 320 472c0 13.3-10.7 24-24 24s-24-10.7-24-24V320H544c-17.7 0-32-14.3-32-32V160C512 59.2 596.2 23.2 613.1 17zM221.2 143.6L204.9 74.3C241.8 47.7 287.1 32 336 32c60.3 0 115 23.8 155.3 62.5C484.3 113.3 480 135 480 160v26.2C454.1 132.8 399.3 96 336 96c-44.9 0-85.5 18.5-114.6 48.3l-.2-.8zM336 480c-76.2 0-143.5-38.1-184-96.2V266.8c8.5-2.8 16.6-6.7 24-11.4l0 .6c0 88.4 71.6 160 160 160c68.1 0 126.2-42.5 149.3-102.4c9.2 21 29.3 36.2 53.2 38.2C502.6 427.6 425.4 480 336 480zM208 256a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z"]
};
var faFamilyPants = {
  prefix: 'fas',
  iconName: 'family-pants',
  icon: [512, 512, [], "e302", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 160h44.8c9.2 0 18.1 1.6 26.4 4.5c-.5 3.8-.8 7.6-.8 11.5c0 24.3 10.9 46.1 28 60.8c-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1 .8 11.9 2.4 17.5c-8.7 9-20.9 14.5-34.4 14.5H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160zM368 512c-13.5 0-25.7-5.6-34.4-14.5c1.6-5.5 2.4-11.4 2.4-17.5V423.6c19.6-17.6 32-43.1 32-71.6V336c0-43.1-24.3-80.5-60-99.2c17.1-14.7 28-36.5 28-60.8c0-3.9-.3-7.8-.8-11.5c8.3-2.9 17.2-4.5 26.4-4.5h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H368zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V407.4c-19.1-11.1-32-31.7-32-55.4V336c0-44.2 35.8-80 80-80z"]
};
var faHoseReel = {
  prefix: 'fas',
  iconName: 'hose-reel',
  icon: [640, 512, [], "e41a", "M320 64c-106 0-192 86-192 192s86 192 192 192c40.8 0 78.6-12.7 109.7-34.4c14.5-10.1 34.4-6.6 44.6 7.9s6.6 34.4-7.9 44.6C424.8 495 374.3 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0S576 114.6 576 256v96h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-2.3l-11.5 80.2c7.8 1.1 13.7 7.8 13.7 15.8c0 8.8-7.2 16-16 16H520c-8.8 0-16-7.2-16-16c0-8.1 6-14.7 13.7-15.8L506.3 400H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V256c0-106-86-192-192-192zM224 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faHouseWindow = {
  prefix: 'fas',
  iconName: 'house-window',
  icon: [576, 512, [], "e3b3", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM248 192h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24z"]
};
var faLandmark = {
  prefix: 'fas',
  iconName: 'landmark',
  icon: [512, 512, [127963], "f66f", "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9V104l4.4-1.6L240.1 4.2zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"]
};
var faTruck = {
  prefix: 'fas',
  iconName: 'truck',
  icon: [640, 512, [128666, 9951], "f0d1", "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCrosshairs = {
  prefix: 'fas',
  iconName: 'crosshairs',
  icon: [512, 512, [], "f05b", "M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCloudRainbow = {
  prefix: 'fas',
  iconName: 'cloud-rainbow',
  icon: [576, 512, [], "f73e", "M560 64.4C466.8 69.5 385.4 119 336.5 192l-.5 0c-19.7 0-38.3 5.1-54.4 14.1c-5.5-6-11.5-11.4-18-16.4C319.9 81.4 430.9 6.1 560 .4c8.8-.4 16 6.8 16 15.6V48c0 8.8-7.2 16-16 16.4zM424 234.7c-13.3-16.9-31.5-29.9-52.3-36.9C415.4 139.9 483.1 101.2 560 96.5c8.8-.5 16 6.7 16 15.5v32c0 8.8-7.2 15.9-16 16.7c-55.3 4.6-104 32.6-136 74zm23.4 57.2c-1-9.1-3-17.9-6.1-26.2c25.7-40.1 68.9-67.9 118.8-72.9c8.8-.9 16 6.4 16 15.2v32c0 8.8-7.2 15.9-15.9 17.3c-31.4 5.2-57.7 25.8-70.9 53.7c-12.5-8.7-26.6-15.3-41.8-19.1zM96 512c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 318.1 64 311.1 64 304c0-61.9 50.1-112 112-112c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96z"]
};
var faPersonCane = {
  prefix: 'fas',
  iconName: 'person-cane',
  icon: [448, 512, [], "e53c", "M272 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"]
};
var faAlien = {
  prefix: 'fas',
  iconName: 'alien',
  icon: [448, 512, [128125], "f8f5", "M224 0C100.3 0 0 100.3 0 224C0 359.3 148.8 471.7 194.7 503.2c8.6 5.9 18.9 8.8 29.3 8.8s20.7-2.9 29.3-8.8C299.2 471.7 448 359.3 448 224C448 100.3 347.7 0 224 0zm32 306.3c0-45.4 36.8-82.3 82.3-82.3h32c7.6 0 13.7 6.1 13.7 13.7c0 45.4-36.8 82.3-82.3 82.3h-32c-7.6 0-13.7-6.1-13.7-13.7zM109.7 224c45.4 0 82.3 36.8 82.3 82.3c0 7.6-6.1 13.7-13.7 13.7h-32C100.8 320 64 283.2 64 237.7c0-7.6 6.1-13.7 13.7-13.7h32z"]
};
var faTent = {
  prefix: 'fas',
  iconName: 'tent',
  icon: [576, 512, [], "e57d", "M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H416L288 288V512H32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"]
};
var faLaptopBinary = {
  prefix: 'fas',
  iconName: 'laptop-binary',
  icon: [640, 512, [], "e5e7", "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM200 128h16c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40zm-8 40v32c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm112-40h16c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm80 40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40H424c-22.1 0-40-17.9-40-40V168zm40-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H424zM192 272h16c8.8 0 16 7.2 16 16v64H192V304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm256 16v64H416V304c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16zm-80 24v40l-32 0V312c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v40l-32 0V312c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40z"]
};
var faVestPatches = {
  prefix: 'fas',
  iconName: 'vest-patches',
  icon: [448, 512, [], "e086", "M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6V128 54.3 48C64 21.5 85.5 0 112 0h4.5c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0H336c26.5 0 48 21.5 48 48v6.3V128v17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280v8 32c0 8.8 7.2 16 16 16h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faPeopleDressSimple = {
  prefix: 'fas',
  iconName: 'people-dress-simple',
  icon: [512, 512, [], "e218", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384H64v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V384h21.6c21.3 0 36.6-20.3 30.8-40.8L205.3 206.4c-7.9-27.5-33-46.4-61.5-46.4H112.3zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L267.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H320v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V384h21.6c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H368.3z"]
};
var faCheckDouble = {
  prefix: 'fas',
  iconName: 'check-double',
  icon: [448, 512, [], "f560", "M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"]
};
var faArrowDownAZ = {
  prefix: 'fas',
  iconName: 'arrow-down-a-z',
  icon: [576, 512, ["sort-alpha-asc", "sort-alpha-down"], "f15d", "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176z"]
};
var faSortAlphaAsc = faArrowDownAZ;
var faSortAlphaDown = faArrowDownAZ;
var faBowlingBallPin = {
  prefix: 'fas',
  iconName: 'bowling-ball-pin',
  icon: [576, 512, [], "e0c3", "M416 64c0-35.3 28.7-64 64-64s64 28.7 64 64v1.1c0 7.4-1 14.8-3 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1H438.5c-.5-2.7-1.1-5.4-1.8-8.1L418.9 87.1c-2-7.2-2.9-14.6-2.9-22V64zm22.8 128h82.3c1 6.3 2.6 12.4 4.8 18.4L566 319.3c6.6 17.9 10 36.8 10 55.8c0 20.5-3.9 40.9-11.5 59.9l-22.7 56.9C536.9 504 525.1 512 512 512H448c-13.1 0-24.9-8-29.7-20.1l-17.8-44.5c29.8-40 47.5-89.6 47.5-143.4c0-30.7-5.8-60.1-16.3-87.1l2.4-6.5c2.2-6 3.8-12.1 4.8-18.4zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zM224 172a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zM196 288a28 28 0 1 0 0-56 28 28 0 1 0 0 56zm-44-68a28 28 0 1 0 -56 0 28 28 0 1 0 56 0z"]
};
var faBellSchoolSlash = {
  prefix: 'fas',
  iconName: 'bell-school-slash',
  icon: [640, 512, [], "f5d6", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L570.7 422c3.4-6.6 5.3-14.1 5.3-22c0-26.5-21.5-48-48-48c-12.1 0-23.1 4.5-31.5 11.8L445 323.5c22.1-33 35-72.8 35-115.5C480 93.1 386.9 0 272 0C211.2 0 156.6 26.1 118.5 67.6L38.8 5.1zM220 147.2c14-11.9 32.1-19.2 52-19.2c44.2 0 80 35.8 80 80c0 12.9-3.1 25.1-8.5 35.9l-26.1-20.4c1.7-4.9 2.6-10.1 2.6-15.5c0-26.5-21.5-48-48-48c-9.5 0-18.4 2.8-25.9 7.6L220 147.2zM508.3 496.5L465.8 463c-3.2 .7-6.4 1-9.8 1H416V423.8l-16.1-12.7C362.9 434.5 319 448 272 448c-54 0-103.9-17.9-144-48v64c0 26.5 21.5 48 48 48H384h32 40c19.3 0 37.3-5.7 52.3-15.5zM373 389.9L71.5 152.4C66.6 170.1 64 188.7 64 208c0 114.9 93.1 208 208 208c36.7 0 71.1-9.5 101-26.1z"]
};
var faPlusLarge = {
  prefix: 'fas',
  iconName: 'plus-large',
  icon: [512, 512, [], "e59e", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H224V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0 0-192z"]
};
var faMoneyBillWheat = {
  prefix: 'fas',
  iconName: 'money-bill-wheat',
  icon: [512, 512, [], "e52a", "M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faCameraViewfinder = {
  prefix: 'fas',
  iconName: 'camera-viewfinder',
  icon: [512, 512, ["screenshot"], "e0da", "M56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 25.1 25.1 0 56 0zM376 0h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-4.4-3.6-8-8-8H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376v80c0 4.4 3.6 8 8 8h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0v80c0 30.9-25.1 56-56 56H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8V376c0-13.3 10.7-24 24-24s24 10.7 24 24zM180 128l6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6h94.7c10 0 19 6.2 22.5 15.6L332 128h36c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h36zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faScreenshot = faCameraViewfinder;
var faMessageMusic = {
  prefix: 'fas',
  iconName: 'message-music',
  icon: [512, 512, ["comment-alt-music"], "f8af", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM352 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V128 96z"]
};
var faCommentAltMusic = faMessageMusic;
var faCarBuilding = {
  prefix: 'fas',
  iconName: 'car-building',
  icon: [640, 512, [], "f859", "M48 0C21.5 0 0 21.5 0 48V432c0 26.5 21.5 48 48 48H192V448 352c0-32.8 16.5-61.8 41.6-79.1l5.6-16.9H208c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16h32c8.2 0 14.9 6.1 15.9 14l.5-1.4c10.5-31.6 34.2-56 63.7-68.2V48c0-26.5-21.5-48-48-48H48zM80 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0-96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V112zM80 288h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm282.6-64H501.4c6.9 0 13 4.4 15.2 10.9L534.3 288H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3l-26.6 79.7C238.8 304.7 224 326.6 224 352v96h0v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H560v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32l0-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faBorderBottomRight = {
  prefix: 'fas',
  iconName: 'border-bottom-right',
  icon: [448, 512, ["border-style-alt"], "f854", "M448 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 336c0 8.8-7.2 16-16 16L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l336 0c44.2 0 80-35.8 80-80l0-336zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faBorderStyleAlt = faBorderBottomRight;
var faOctagon = {
  prefix: 'fas',
  iconName: 'octagon',
  icon: [512, 512, [128721], "f306", "M191.5 .1c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5v129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1h129c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9v-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1h-129z"]
};
var faCommentArrowUpRight = {
  prefix: 'fas',
  iconName: 'comment-arrow-up-right',
  icon: [512, 512, [], "e145", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM200 160H312c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V241.9l-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faOctagonDivide = {
  prefix: 'fas',
  iconName: 'octagon-divide',
  icon: [512, 512, [], "e203", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H168zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCookie = {
  prefix: 'fas',
  iconName: 'cookie',
  icon: [512, 512, [127850], "f563", "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faArrowRotateLeft = {
  prefix: 'fas',
  iconName: 'arrow-rotate-left',
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"]
};
var faArrowLeftRotate = faArrowRotateLeft;
var faArrowRotateBack = faArrowRotateLeft;
var faArrowRotateBackward = faArrowRotateLeft;
var faUndo = faArrowRotateLeft;
var faTvMusic = {
  prefix: 'fas',
  iconName: 'tv-music',
  icon: [640, 512, [], "f8e6", "M576 64V352H64V64H576zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zM416 112c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v48 49.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V219.1l96-36v42.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V160 112z"]
};
var faHardDrive = {
  prefix: 'fas',
  iconName: 'hard-drive',
  icon: [512, 512, [128436, "hdd"], "f0a0", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V280.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4V96zM64 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faHdd = faHardDrive;
var faReel = {
  prefix: 'fas',
  iconName: 'reel',
  icon: [448, 512, [], "e238", "M0 32C0 14.3 14.3 0 32 0H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V88c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V64H32C14.3 64 0 49.7 0 32zM0 480c0-17.7 14.3-32 32-32H64V424c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v24h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM80 144H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFaceGrinSquintTears = {
  prefix: 'fas',
  iconName: 'face-grin-squint-tears',
  icon: [512, 512, [129315, "grin-squint-tears"], "f586", "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-16.3 4.4-34.1 7.5-46.3 9.3c-1.6 .2-3.1 .5-4.6 .6c-4.9 .8-9.1-2.8-9.5-7.4c-.1-.7 0-1.4 .1-2.1c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c.4-.1 .7-.1 1-.1c5.1-.2 9.2 4.3 8.4 9.6c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.9 209c-4.7-11.9-20.8-11-26.8 .3c-19 35.5-45 70.8-77.5 103.3S244.8 371.1 209.3 390c-11.3 6-12.2 22.1-.3 26.8c57.6 22.9 125.8 11 172.3-35.5s58.4-114.8 35.5-172.3zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"]
};
var faGrinSquintTears = faFaceGrinSquintTears;
var faDumbbell = {
  prefix: 'fas',
  iconName: 'dumbbell',
  icon: [640, 512, [], "f44b", "M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H96V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H544v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"]
};
var faRectangleList = {
  prefix: 'fas',
  iconName: 'rectangle-list',
  icon: [576, 512, ["list-alt"], "f022", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"]
};
var faListAlt = faRectangleList;
var faTarpDroplet = {
  prefix: 'fas',
  iconName: 'tarp-droplet',
  icon: [576, 512, [], "e57c", "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128H197.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64V352H448c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM448 512l0-128H576L448 512zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faAlarmExclamation = {
  prefix: 'fas',
  iconName: 'alarm-exclamation',
  icon: [512, 512, [], "f843", "M14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4L14.9 146.4zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM352 25.4C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-200c0-13.3-10.7-24-24-24s-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
};
var faHouseMedicalCircleCheck = {
  prefix: 'fas',
  iconName: 'house-medical-circle-check',
  icon: [640, 512, [], "e511", "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faTrafficCone = {
  prefix: 'fas',
  iconName: 'traffic-cone',
  icon: [512, 512, [], "f636", "M173.7 128L216 20.3C220.8 8.1 232.7 0 245.8 0h20.4c13.2 0 25 8.1 29.8 20.3L338.3 128H173.7zm-25.1 64H363.4l37.7 96H110.9l37.7-96zM48 448l37.7-96H426.3L464 448h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48z"]
};
var faGrate = {
  prefix: 'fas',
  iconName: 'grate',
  icon: [448, 512, [], "e193", "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64h64 96 96 64c35.3 0 64-28.7 64-64V256 96c0-35.3-28.7-64-64-64H320 224 128 64zm0 64H96V224H64V96zm0 192H96V416H64V288zm96 128V288h32V416H160zm96 0V288h32V416H256zm96 0V288h32V416H352zm32-192H352V96h32V224zM288 96V224H256V96h32zm-96 0V224H160V96h32z"]
};
var faArrowDownRight = {
  prefix: 'fas',
  iconName: 'arrow-down-right',
  icon: [384, 512, [], "e093", "M320 416c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 146.7L86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 352 96 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0z"]
};
var faPersonSkiingNordic = {
  prefix: 'fas',
  iconName: 'person-skiing-nordic',
  icon: [576, 512, ["skiing-nordic"], "f7ca", "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464H202.8l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H159.3c.4 0 .9 0 1.3 0H319.3c.5 0 1 0 1.4 0H504c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24H434.6l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32H426.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464H357.8l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288h2.7z"]
};
var faSkiingNordic = faPersonSkiingNordic;
var faCalendarPlus = {
  prefix: 'fas',
  iconName: 'calendar-plus',
  icon: [512, 512, [], "f271", "M128 32V64H80c-26.5 0-48 21.5-48 48v48H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM256 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H176c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"]
};
var faPersonFromPortal = {
  prefix: 'fas',
  iconName: 'person-from-portal',
  icon: [512, 512, ["portal-exit"], "e023", "M154.2 352c3.8-29.6 5.8-62.1 5.8-96c0-18.3-.6-36.1-1.7-53.4c12.4 8.3 29.4 7 40.4-4l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L233.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L334 299l30.9-82.4 5.1 12.3C385 264.7 419.9 288 458.7 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c0 0 0 0-.1 .1C141 63.1 112.8 0 80 0C35.8 0 0 114.6 0 256S35.8 512 80 512c25.3 0 47.8-37.5 62.5-96h55.1c19 0 36.2-11.2 43.9-28.5L253 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L187.2 352h-33zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faPortalExit = faPersonFromPortal;
var faPlaneArrival = {
  prefix: 'fas',
  iconName: 'plane-arrival',
  icon: [640, 512, [128748], "f5af", "M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14-9.3-22.5zM32 448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCowbellCirclePlus = {
  prefix: 'fas',
  iconName: 'cowbell-circle-plus',
  icon: [576, 512, ["cowbell-more"], "f8b4", "M112 96h16V40c0-22.1 17.9-40 40-40H280c22.1 0 40 17.9 40 40V96h16c21.4 0 40.3 14.2 46.2 34.8l18.3 64C318.3 209.7 256 281.6 256 368c0 16.6 2.3 32.7 6.6 48H48c-15.1 0-29.3-7.1-38.3-19.1s-12-27.6-7.8-42.1l64-224C71.7 110.2 90.6 96 112 96zM285.5 465.6C277.9 492.4 253.2 512 224 512c-35.3 0-64-28.7-64-64H275.2c3.1 6.1 6.6 12 10.3 17.6zM272 96V48H176V96h96zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faCowbellMore = faCowbellCirclePlus;
var faCircleLeft = {
  prefix: 'fas',
  iconName: 'circle-left',
  icon: [512, 512, [61840, "arrow-alt-circle-left"], "f359", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9L117.5 269.8c-3.5-3.8-5.5-8.7-5.5-13.8s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1z"]
};
var faArrowAltCircleLeft = faCircleLeft;
var faDistributeSpacingVertical = {
  prefix: 'fas',
  iconName: 'distribute-spacing-vertical',
  icon: [512, 512, [], "e366", "M0 56C0 42.7 10.7 32 24 32H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 80 0 69.3 0 56zM96 208c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V208zM24 432H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSignalBarsFair = {
  prefix: 'fas',
  iconName: 'signal-bars-fair',
  icon: [640, 512, ["signal-alt-2"], "f692", "M240 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z"]
};
var faSignalAlt2 = faSignalBarsFair;
var faSportsball = {
  prefix: 'fas',
  iconName: 'sportsball',
  icon: [512, 512, [], "e44b", "M487.6 48.9c-.1-.5-.2-1-.3-1.5L365.3 169.3c34.8 30.2 79 49.8 127.6 53.9c9.3-63 4.7-125.5-5.4-174.3zM464.8 24.6c-1.1-.3-2.2-.5-3.3-.7c-65.6-11-122.9-12.5-172.8-6c3.9 49.1 23.6 93.7 54 128.8L464.8 24.6zM446 358.4c19.8-32.3 33-67.7 41.1-103.6c-55.1-5.3-105.1-28.1-144.4-62.8l-64 64L418.5 395.9c10.3-11.8 19.4-24.4 27.4-37.5zM320 169.4C285 129.7 262.1 79 257 23.3c-17 3.6-33 8.3-48.1 13.9c-37 13.7-67.8 33-93.1 56L256 233.4l64-64zM233.4 256L93.4 116.1C83.2 127.9 74.1 140.5 66 153.6c-19.8 32.3-33 67.7-41.1 103.6c55.1 5.3 105.1 28.1 144.4 62.8l64-64zM192 342.6c35 39.7 58 90.3 63 146.1c17-3.6 33-8.3 48.1-13.9c37-13.7 67.8-33 93.1-56L256 278.6l-64 64zm-45.3 .1c-34.8-30.2-79-49.8-127.6-53.9c-9.3 63-4.7 125.5 5.4 174.3c.1 .5 .2 1 .3 1.5L146.7 342.7zm22.6 22.6L47.2 487.4c1.1 .3 2.2 .5 3.3 .7c65.6 11 123 12.5 172.8 6c-3.9-49.1-23.6-93.7-54-128.8z"]
};
var faGameConsoleHandheldCrank = {
  prefix: 'fas',
  iconName: 'game-console-handheld-crank',
  icon: [640, 512, [], "e5b9", "M32 96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V96zm96 0c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H128zm32 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V336zm144 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM512 168c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H560v72c0 13.3-10.7 24-24 24H512V272 256 200 168z"]
};
var faTrainSubway = {
  prefix: 'fas',
  iconName: 'train-subway',
  icon: [448, 512, ["subway"], "f239", "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM272 96h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM64 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSubway = faTrainSubway;
var faChartGantt = {
  prefix: 'fas',
  iconName: 'chart-gantt',
  icon: [512, 512, [], "e0e4", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faFaceSmileUpsideDown = {
  prefix: 'fas',
  iconName: 'face-smile-upside-down',
  icon: [512, 512, [], "e395", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm91.9 186.5C330 165.8 299.4 144 256 144s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM367.6 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faBallPile = {
  prefix: 'fas',
  iconName: 'ball-pile',
  icon: [640, 512, [], "f77e", "M320 160A80 80 0 1 0 320 0a80 80 0 1 0 0 160zM208 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM192 432A80 80 0 1 0 32 432a80 80 0 1 0 160 0zm128 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm288-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM432 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faBadgeDollar = {
  prefix: 'fas',
  iconName: 'badge-dollar',
  icon: [512, 512, [], "f645", "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zm20.9 140.4c0-11-9-20-20-20s-20 9-20 20v17.4c-8.8 1.8-17.7 4.8-25.7 9.6c-15 8.9-27.7 24.4-27.6 46.9c.1 21.5 12.6 35.1 26.3 43.4c11.9 7.2 27 11.7 39.1 15.4l1.9 .6c13.9 4.2 24.4 7.6 31.7 12.2c6.1 3.8 7.5 6.8 7.6 11c.1 6.5-2.5 10.4-7.6 13.6c-6 3.7-15.2 5.9-25.1 5.6c-12.7-.4-24.6-4.4-39.7-9.6l0 0 0 0 0 0 0 0c-2.6-.9-5.2-1.8-8-2.7c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c2.2 .7 4.5 1.5 6.8 2.3c9.7 3.3 20.9 7.2 32.8 9.6v18c0 11 9 20 20 20s20-9 20-20V354.4c9.3-1.7 18.6-4.9 26.8-10.1c15.3-9.5 26.8-25.7 26.5-48.1c-.3-21.6-12.4-35.6-26.3-44.3c-12.5-7.9-28.3-12.6-40.8-16.4l-.6-.2c-14.1-4.3-24.6-7.5-31.9-11.9c-6.2-3.7-7-6.3-7-9.3c0-5.1 2.1-8.8 7.9-12.3c6.5-3.8 16-6 25-5.8c10.9 .2 22.9 2.6 35.2 5.8c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-7.8-2.1-16.3-4.1-25.1-5.4V140.4z"]
};
var faMoneyBillsSimple = {
  prefix: 'fas',
  iconName: 'money-bills-simple',
  icon: [640, 512, ["money-bills-alt"], "e1f4", "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"]
};
var faMoneyBillsAlt = faMoneyBillsSimple;
var faListTimeline = {
  prefix: 'fas',
  iconName: 'list-timeline',
  icon: [512, 512, [], "e1d1", "M16 96a48 48 0 1 1 96 0A48 48 0 1 1 16 96zM64 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM191.5 54.4c5.5-4.2 12.3-6.4 19.2-6.4H424c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6l38.4-28.8zM153.1 243.2l38.4-28.8c5.5-4.2 12.3-6.4 19.2-6.4H488c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6zm0 160l38.4-28.8c5.5-4.2 12.3-6.4 19.2-6.4H424c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6z"]
};
var faIndianRupeeSign = {
  prefix: 'fas',
  iconName: 'indian-rupee-sign',
  icon: [320, 512, ["indian-rupee", "inr"], "e1bc", "M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"]
};
var faIndianRupee = faIndianRupeeSign;
var faInr = faIndianRupeeSign;
var faCropSimple = {
  prefix: 'fas',
  iconName: 'crop-simple',
  icon: [512, 512, ["crop-alt"], "f565", "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"]
};
var faCropAlt = faCropSimple;
var faMoneyBill1 = {
  prefix: 'fas',
  iconName: 'money-bill-1',
  icon: [576, 512, ["money-bill-alt"], "f3d1", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm76-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"]
};
var faMoneyBillAlt = faMoneyBill1;
var faLeftLong = {
  prefix: 'fas',
  iconName: 'left-long',
  icon: [512, 512, ["long-arrow-alt-left"], "f30a", "M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z"]
};
var faLongArrowAltLeft = faLeftLong;
var faKeyboardDown = {
  prefix: 'fas',
  iconName: 'keyboard-down',
  icon: [576, 512, [], "e1c2", "M64 0C28.7 0 0 28.7 0 64V224c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176zm112-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm272 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V176zM176 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V80zM368 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V80zM153.8 366.8c-3.7 9-1.7 19.3 5.2 26.2L271 505c9.4 9.4 24.6 9.4 33.9 0L417 393c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H176c-9.7 0-18.5 5.8-22.2 14.8z"]
};
var faCircleUpRight = {
  prefix: 'fas',
  iconName: 'circle-up-right',
  icon: [512, 512, [], "e129", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm96 313.4V176c0-8.8-7.2-16-16-16H198.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L216 232l-66.3 66.3C146 302 144 306.9 144 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L280 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"]
};
var faCloudBoltMoon = {
  prefix: 'fas',
  iconName: 'cloud-bolt-moon',
  icon: [576, 512, ["thunderstorm-moon"], "f76d", "M361.4 79.9C380.6 33 427.1 0 481.2 0c3.7 0 7.3 .2 10.9 .5c7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-26.9 15.1-44.9 43.6-44.9 76.1c0 48.1 39.4 87.4 88.4 87.4c5.2 0 10.3-.4 15.2-1.3c6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-23.3 22.4-55 36.1-89.9 36.1c-.8 0-1.6 0-2.4 0c-5.4-37.8-29.7-69.5-63-85.3c-1.8-38.6-23.1-72.1-54.3-90.8zm86.4 192.1c0 44.2-35.8 80-80 80H349.2C342.4 332.8 324.3 320 304 320H285.7l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2L82 330.5c-6 4.8-10.5 10.7-13.6 17.4C28.8 336 0 299.4 0 255.9c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7zM282.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L233.9 352H304c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L182.1 384H112c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faThunderstormMoon = faCloudBoltMoon;
var faDna = {
  prefix: 'fas',
  iconName: 'dna',
  icon: [448, 512, [129516], "f471", "M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l0 0 0 0 0 0-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5H283.3c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32H384c0-17.7 14.3-32 32-32zM338.6 384H109.4c-10.1 10.6-18.6 21.3-25.5 32H364.1c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128H338.6c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5H164.7z"]
};
var faVirusSlash = {
  prefix: 'fas',
  iconName: 'virus-slash',
  icon: [640, 512, [], "e075", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7z"]
};
var faBracketRoundRight = {
  prefix: 'fas',
  iconName: 'bracket-round-right',
  icon: [192, 512, [], "29", "M37.4 46.2C27.6 61 31.5 80.8 46.3 90.6C71.9 107.7 128 167 128 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C120.1 449 192 371.8 192 256S120.1 62.9 81.8 37.4C67 27.6 47.2 31.5 37.4 46.2z"]
};
var faCircleSterling = {
  prefix: 'fas',
  iconName: 'circle-sterling',
  icon: [512, 512, [], "e5cf", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm5.5-352c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H231.7l.1 9.7c.1 18.6-3.1 37-9.6 54.3H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c7.7-14.9 11.6-31.5 11.5-48.3l-.1-10.1H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h7.5l-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9c10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z"]
};
var faCircle5 = {
  prefix: 'fas',
  iconName: 'circle-5',
  icon: [512, 512, [], "e0f2", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H228l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z"]
};
var faMinus = {
  prefix: 'fas',
  iconName: 'minus',
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"]
};
var faSubtract = faMinus;
var faFireFlame = {
  prefix: 'fas',
  iconName: 'fire-flame',
  icon: [384, 512, ["flame"], "f6df", "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zM188.8 148.3c2-2.7 5.2-4.3 8.5-4.3c5.9 0 10.7 4.8 10.7 10.7v11.4c0 8.9 3.6 17.4 9.9 23.6l51.5 50.7C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109h-3c-61.9 0-112-50.1-112-112v-8.2c0-21.2 7.8-41.6 21.8-57.4l6.9-7.8c2.1-2.4 5.1-3.7 8.3-3.7c6.1 0 11 4.9 11 11v44c0 24.3 19.8 44 44.1 44c24.2 0 43.9-19.6 43.9-43.8c0-11.6-4.6-22.8-12.8-31l-13.2-13.2c-14-14-21.9-33.1-21.9-53c0-16.2 5.3-32 15-44.9l5.8-7.8z"]
};
var faFlame = faFireFlame;
var faRightToLine = {
  prefix: 'fas',
  iconName: 'right-to-line',
  icon: [448, 512, ["arrow-alt-to-right"], "f34c", "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM384 416l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]
};
var faArrowAltToRight = faRightToLine;
var faGif = {
  prefix: 'fas',
  iconName: 'gif',
  icon: [576, 512, [], "e190", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 64c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm48 16v80 80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM128 256c0-35.3 28.7-64 64-64c14.4 0 27.7 4.8 38.4 12.8c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4c-16-12.1-36-19.2-57.6-19.2c-53 0-96 43-96 96s43 96 96 96c21.6 0 41.6-7.1 57.6-19.2c4-3 6.4-7.8 6.4-12.8V264c0-8.8-7.2-16-16-16H184c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v31.4c-9.4 5.4-20.3 8.6-32 8.6c-35.3 0-64-28.7-64-64z"]
};
var faChess = {
  prefix: 'fas',
  iconName: 'chess',
  icon: [512, 512, [], "f439", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H60.2C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384H196L180 256h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48zm288 0l-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L464 416H336zM304 208v51.9c0 7.8 2.8 15.3 8 21.1L339.2 312 337 384H462.5l-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7V208c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v16H424V208c0-8.8-7.2-16-16-16H392c-8.8 0-16 7.2-16 16v16H352V208c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16v32H384V304z"]
};
var faTrashSlash = {
  prefix: 'fas',
  iconName: 'trash-slash',
  icon: [640, 512, [], "e2b3", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L497.2 364.4 512 128H195.6L154.8 96H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H416l-7.2-14.3C403.4 6.8 392.3 0 380.2 0H259.8c-12.1 0-23.2 6.8-28.6 17.7L224 32H128c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM149.2 467c1.6 25.3 22.6 45 47.9 45H442.9c20.6 0 38.3-13 45.1-31.5L132.5 200.4 149.2 467z"]
};
var faArrowLeftLong = {
  prefix: 'fas',
  iconName: 'arrow-left-long',
  icon: [512, 512, ["long-arrow-left"], "f177", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"]
};
var faLongArrowLeft = faArrowLeftLong;
var faPlugCircleCheck = {
  prefix: 'fas',
  iconName: 'plug-circle-check',
  icon: [576, 512, [], "e55c", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faFontCase = {
  prefix: 'fas',
  iconName: 'font-case',
  icon: [640, 512, [], "f866", "M206 52.8C201.3 40.3 189.3 32 176 32s-25.3 8.3-30 20.8L2 436.8c-6.2 16.5 2.2 35 18.7 41.2s35-2.2 41.2-18.7L96.2 368H255.8L290 459.2c6.2 16.5 24.7 24.9 41.2 18.7s24.9-24.6 18.7-41.2L206 52.8zM231.8 304H120.2L176 155.1 231.8 304zM608 160c-13 0-24.1 7.7-29.2 18.8C559.4 166.9 536.5 160 512 160c-70.7 0-128 57.3-128 128v64c0 70.7 57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V352 288 192c0-17.7-14.3-32-32-32zM576 288v64c0 35.3-28.7 64-64 64s-64-28.7-64-64V288c0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
var faStreetView = {
  prefix: 'fas',
  iconName: 'street-view',
  icon: [512, 512, [], "f21d", "M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"]
};
var faArrowDownLeft = {
  prefix: 'fas',
  iconName: 'arrow-down-left',
  icon: [384, 512, [], "e091", "M32 384c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-146.7 0L342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L96 306.7 96 160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 224z"]
};
var faFrancSign = {
  prefix: 'fas',
  iconName: 'franc-sign',
  icon: [320, 512, [], "e18f", "M80 32C62.3 32 48 46.3 48 64V224v96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
};
var faFlaskRoundPoison = {
  prefix: 'fas',
  iconName: 'flask-round-poison',
  icon: [448, 512, ["flask-poison"], "f6e0", "M328.5 172.1c-5.2-3-8.5-8.4-8.5-14.4V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H304 256 192 144 128C110.3 0 96 14.3 96 32s14.3 32 32 32v93.7c0 6-3.3 11.4-8.5 14.4l0 0c-5.3 3.1-10.4 6.4-15.4 9.9C50.8 219.7 16 281.8 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9zM300 376.6c-7.1 5.2-12 13-12 21.8V408c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24v-9.6c0-8.8-4.9-16.7-12-21.8c-22.1-16.1-36-39.1-36-64.6c0-48.6 50.1-88 112-88s112 39.4 112 88c0 25.5-13.9 48.6-36 64.6zM184 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faFlaskPoison = faFlaskRoundPoison;
var faVolumeOff = {
  prefix: 'fas',
  iconName: 'volume-off',
  icon: [320, 512, [], "f026", "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"]
};
var faBookCircleArrowRight = {
  prefix: 'fas',
  iconName: 'book-circle-arrow-right',
  icon: [640, 512, [], "e0bc", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h10.8c-23.3-16.4-42.5-38.4-55.6-64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32H320.7c-.5-5.3-.7-10.6-.7-16c0-80.6 54.1-148.5 128-169.4V32c0-17.7-14.3-32-32-32H384 96zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM492.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faChartUser = {
  prefix: 'fas',
  iconName: 'chart-user',
  icon: [640, 512, ["user-chart"], "f6a3", "M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H576V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm252.7 75.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h88c8.8 0 16 7.2 16 16v88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 55.7-55.7-27-27zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM0 485.3C0 411.7 59.7 352 133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3z"]
};
var faUserChart = faChartUser;
var faHandsAslInterpreting = {
  prefix: 'fas',
  iconName: 'hands-asl-interpreting',
  icon: [640, 512, ["american-sign-language-interpreting", "asl-interpreting", "hands-american-sign-language-interpreting"], "f2a3", "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7V256c0 70.7 57.3 128 128 128h72 8v-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128H440h-8v.3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"]
};
var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faAslInterpreting = faHandsAslInterpreting;
var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faPresentationScreen = {
  prefix: 'fas',
  iconName: 'presentation-screen',
  icon: [576, 512, ["presentation"], "f685", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V288c0 35.3 28.7 64 64 64H256v34.7l-70.6 70.6c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 445.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L320 386.7V352H480c35.3 0 64-28.7 64-64V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 64 32zM96 64H480V288H288 96V64z"]
};
var faPresentation = faPresentationScreen;
var faCircleBolt = {
  prefix: 'fas',
  iconName: 'circle-bolt',
  icon: [512, 512, [], "e0fe", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm74.1-396.4c5.8 4.7 7.6 12.9 4.2 19.6L281.9 240H352c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 272H160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faFaceSmileHalo = {
  prefix: 'fas',
  iconName: 'face-smile-halo',
  icon: [512, 512, [], "e38f", "M512 80c0 44.2-114.6 80-256 80S0 124.2 0 80S114.6 0 256 0S512 35.8 512 80zm-64 0c0-17.7-86-32-192-32S64 62.3 64 80s86 32 192 32s192-14.3 192-32zM16 272c0-41.9 10.7-81.3 29.6-115.5C98.1 178.3 173 192 256 192s157.9-13.7 210.4-35.5C485.3 190.7 496 230.1 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272zm148.1 85.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 378.2 299.4 400 256 400s-74-21.8-91.9-42.5zm53.5-56.7l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 260.4 120 278.1 120 296c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 260.4 280 278.1 280 296c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]
};
var faCartCircleArrowDown = {
  prefix: 'fas',
  iconName: 'cart-circle-arrow-down',
  icon: [640, 512, [], "e3ef", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-147.3c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0l-56-56c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 393.4V304c0-8.8 7.2-16 16-16s16 7.2 16 16v89.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faHousePersonReturn = {
  prefix: 'fas',
  iconName: 'house-person-return',
  icon: [640, 512, ["house-person-arrive", "house-return"], "e011", "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0L388.9 125.9c-19 14.8-34.4 34.5-44.1 57.7l-10.7 25.8-10.7 5.4c-31.6 15.8-44.4 54.3-28.6 85.9c15.4 30.9 52.5 43.8 83.6 29.7l-6.8 7.5c-9 9.8-15.4 21.7-18.6 34.7L342 416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM128 208v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm84.3 200.5c-1-.4-1.9-.8-2.9-1.2l16.9 63.5c5.6 21.1 .1 43.6-14.7 59.7l-70.7 77.1-22 88.1c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l23-92.1c1.9-7.8 5.8-14.9 11.2-20.8l49.5-54-19.3-65.5-9.6 23c-4.4 10.6-12.5 19.3-22.8 24.5l-26.7 13.3c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L359 232.7l15.3-36.8c17.1-41.1 57.3-67.9 101.9-67.9c22.8 0 45.3 4.8 66.1 14l8 3.5c32.9 14.6 58.1 42.4 69.4 76.5l2.6 7.8c5.6 16.8-3.5 34.9-20.2 40.5s-34.9-3.5-40.5-20.2l-2.6-7.8c-5.7-17.1-18.3-30.9-34.7-38.2l-8-3.5zm30 135.1l25 62.4 59.4 59.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L523.7 441c-4.6-4.6-8.2-10.1-10.6-16.1l-14.5-36.2 40.7-44.4c2.5-2.7 4.8-5.6 7-8.6z"]
};
var faHousePersonArrive = faHousePersonReturn;
var faHouseReturn = faHousePersonReturn;
var faMessageXmark = {
  prefix: 'fas',
  iconName: 'message-xmark',
  icon: [512, 512, ["comment-alt-times", "message-times"], "f4ab", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm175 63c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faCommentAltTimes = faMessageXmark;
var faMessageTimes = faMessageXmark;
var faFileCertificate = {
  prefix: 'fas',
  iconName: 'file-certificate',
  icon: [512, 512, ["file-award"], "f5f3", "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H221.3c1.8-5.1 2.7-10.5 2.7-16V416c1.3-.5 2.5-1 3.8-1.5c6.8-3 14.3-7.8 20.6-15.5c6.4-7.9 10.1-17.2 11.4-27.1c.5-3.6 .8-5.7 1.1-7.1c1.1-.9 2.8-2.3 5.6-4.5c19.9-15.4 27.1-42.2 17.5-65.5c-1.4-3.3-2.1-5.4-2.6-6.7c.5-1.4 1.2-3.4 2.6-6.7c9.5-23.3 2.4-50.1-17.5-65.5c-2.8-2.2-4.5-3.6-5.6-4.5c-.3-1.4-.6-3.6-1.1-7.1c-3.4-24.9-23-44.6-47.9-47.9c-3.6-.5-5.7-.8-7.1-1.1c-.9-1.1-2.3-2.8-4.5-5.6c-15.4-19.9-42.2-27.1-65.5-17.5c-2.6 1.1-5.1 2.3-6.6 3l-.1 .1V64zm384 64H384V0L512 128zM109.2 161.6L125 168c1.9 .8 4.1 .8 6.1 0l15.8-6.5c10-4.1 21.5-1 28.1 7.5l10.5 13.5c1.3 1.7 3.2 2.7 5.2 3l16.9 2.3c10.7 1.5 19.1 9.9 20.5 20.5l2.3 16.9c.3 2.1 1.4 4 3 5.2l13.5 10.5c8.5 6.6 11.6 18.1 7.5 28.1L248 285c-.8 1.9-.8 4.1 0 6.1l6.5 15.8c4.1 10 1 21.5-7.5 28.1l-13.5 10.5c-1.7 1.3-2.7 3.2-3 5.2l-2.3 16.9c-1.5 10.7-9.9 19.1-20.5 20.6L192 390.2V496c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L128 483.2 88.9 509.3c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V390.2l-15.5-2.1c-10.7-1.5-19.1-9.9-20.5-20.6l-2.3-16.9c-.3-2.1-1.4-4-3-5.2L9.1 334.9c-8.5-6.6-11.6-18.1-7.5-28.1L8 291c.8-1.9 .8-4.1 0-6.1L1.6 269.2c-4.1-10-1-21.5 7.5-28.1l13.5-10.5c1.7-1.3 2.7-3.2 3-5.2l2.3-16.9c1.5-10.7 9.9-19.1 20.5-20.5l16.9-2.3c2.1-.3 4-1.4 5.2-3l10.5-13.5c6.6-8.5 18.1-11.6 28.1-7.5zM192 288A64 64 0 1 0 64 288a64 64 0 1 0 128 0z"]
};
var faFileAward = faFileCertificate;
var faUserDoctorHairLong = {
  prefix: 'fas',
  iconName: 'user-doctor-hair-long',
  icon: [448, 512, [], "e459", "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224 70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128zM288 320v42c-27.6 7.1-48 32.2-48 62v40c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16V424c0-17.7 14.3-32 32-32s32 14.3 32 32v24c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V424c0-29.8-20.4-54.9-48-62V323.4c73.1 15.3 128 80.2 128 157.8c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-77.7 54.9-142.5 128-157.8v46.9c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V320l1.3 0H286.7l1.3 0zM120 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCameraSecurity = {
  prefix: 'fas',
  iconName: 'camera-security',
  icon: [448, 512, ["camera-home"], "f8fe", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H310l59 36.9c12.1 7.6 17.7 22.2 13.8 36S366.3 512 352 512H96c-14.3 0-26.8-9.5-30.8-23.2s1.7-28.4 13.8-36L138 416H64c-35.3 0-64-28.7-64-64V64zM128 208a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 208a128 128 0 1 0 256 0z"]
};
var faCameraHome = faCameraSecurity;
var faGear = {
  prefix: 'fas',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faCog = faGear;
var faDropletSlash = {
  prefix: 'fas',
  iconName: 'droplet-slash',
  icon: [640, 512, ["tint-slash"], "f5c7", "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.1 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTintSlash = faDropletSlash;
var faBookHeart = {
  prefix: 'fas',
  iconName: 'book-heart',
  icon: [448, 512, [], "f499", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm64-258.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4C221.1 102.5 205.5 96 189.3 96c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faMosque = {
  prefix: 'fas',
  iconName: 'mosque',
  icon: [640, 512, [128332], "f678", "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H560V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H448V454c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58H288zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160H160V296.6c-19.1 11.1-32 31.7-32 55.4V480c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176 160z"]
};
var faDuck = {
  prefix: 'fas',
  iconName: 'duck',
  icon: [512, 512, [129414], "f6d8", "M400.7 224c-.4 0-.7 .3-.7 .7v0 24c0 6.6 2.8 12.8 7.2 17.7C427.6 289.1 440 319.1 440 352c0 70.7-57.3 128-128 128H196C87.8 480 0 392.2 0 284v-5.4C0 266.1 10.1 256 22.6 256c6 0 11.8 2.4 16 6.6L54 278c6.2 6.2 15.2 8.5 23.6 6.1l172.8-49.4c10.4-3 15.7-14.5 7.8-21.7v0c-21-19-34.1-46.5-34.1-77c0-57.4 46.6-104 104-104c53.8 0 98.1 40.9 103.5 93.3c0 .4 .3 .6 .7 .7v0c10.5 1.3 21.2 1.3 31.8 0l35.3-4.4c6.8-.8 12.8 4.4 12.8 11.3c0 50.3-40.8 91.1-91.1 91.1H400.7zM368 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM340.6 296.9c.5-8.8-6.2-16.4-15-16.9s-16.4 6.2-16.9 15c-2.4 41.2-32.6 79-77.3 90.1c-40.3 10.1-80.5-4.6-103.7-33.5c-5.5-6.9-15.6-8-22.5-2.5s-8 15.6-2.5 22.5c31.1 38.7 84 57.6 136.4 44.5c58-14.5 98.3-63.8 101.5-119.3z"]
};
var faMosquito = {
  prefix: 'fas',
  iconName: 'mosquito',
  icon: [640, 512, [], "e52b", "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"]
};
var faStarOfDavid = {
  prefix: 'fas',
  iconName: 'star-of-david',
  icon: [512, 512, [10017], "f69a", "M404.2 309.5L383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88H317.4l54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168H383.1zM283 112L256 68l-27 44h54zM128.9 168H86.6l21.1 34.5L128.9 168zM107.8 309.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44H229z"]
};
var faFlagSwallowtail = {
  prefix: 'fas',
  iconName: 'flag-swallowtail',
  icon: [448, 512, ["flag-alt"], "f74c", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H424c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24H64z"]
};
var faFlagAlt = faFlagSwallowtail;
var faPersonMilitaryRifle = {
  prefix: 'fas',
  iconName: 'person-military-rifle',
  icon: [512, 512, [], "e54b", "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25zm17.6 57H334.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCarGarage = {
  prefix: 'fas',
  iconName: 'car-garage',
  icon: [640, 512, [], "f5e2", "M343.8 8.8c-14.8-8.4-32.9-8.4-47.6 0L24.1 164.2C8.8 173 3.5 192.5 12.2 207.9s28.3 20.7 43.7 11.9L320 68.9 584.1 219.8c15.3 8.8 34.9 3.4 43.7-11.9s3.4-34.9-11.9-43.7L343.8 8.8zM249.8 224H390.2c6.8 0 12.8 4.3 15.1 10.6L424.3 288H215.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9l-28.3 79.3C126.1 300.9 112 320.8 112 344v40 64 32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H448v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C454.1 181.3 424 160 390.2 160H249.8c-33.8 0-64 21.3-75.3 53.1zM192 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCartShopping = {
  prefix: 'fas',
  iconName: 'cart-shopping',
  icon: [576, 512, [128722, "shopping-cart"], "f07a", "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faShoppingCart = faCartShopping;
var faBookFont = {
  prefix: 'fas',
  iconName: 'book-font',
  icon: [448, 512, [], "e0bf", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM254.3 72.8c-2.7-5.4-8.3-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-64 128-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L185.9 224H294.1l27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-32-64-64-128zM240 115.8L278.1 192H201.9L240 115.8z"]
};
var faShieldPlus = {
  prefix: 'fas',
  iconName: 'shield-plus',
  icon: [512, 512, [], "e24a", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faVials = {
  prefix: 'fas',
  iconName: 'vials',
  icon: [512, 512, [], "f493", "M0 64C0 46.3 14.3 32 32 32H88h48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64zM136 96H88V256h48V96zM288 64c0-17.7 14.3-32 32-32h56 48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zM424 96H376V256h48V96z"]
};
var faEyeDropperFull = {
  prefix: 'fas',
  iconName: 'eye-dropper-full',
  icon: [512, 512, [], "e172", "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9 176.1 202.6 55.4 323.3z"]
};
var faDistributeSpacingHorizontal = {
  prefix: 'fas',
  iconName: 'distribute-spacing-horizontal',
  icon: [512, 512, [], "e365", "M32 24C32 10.7 42.7 0 56 0S80 10.7 80 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24zM160 144c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V144zM456 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"]
};
var faTabletRugged = {
  prefix: 'fas',
  iconName: 'tablet-rugged',
  icon: [448, 512, [], "f48f", "M32 176L8.8 164.4C3.4 161.7 0 156.2 0 150.1V73.9c0-6.1 3.4-11.6 8.8-14.3L34.3 46.8C41.8 19.8 66.6 0 96 0H352c29.4 0 54.2 19.8 61.7 46.8l25.5 12.7c5.4 2.7 8.8 8.3 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3L416 176v16l23.2 11.6c5.4 2.7 8.8 8.3 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3L416 320v16l23.2 11.6c5.4 2.7 8.8 8.2 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3l-25.5 12.7c-7.5 27-32.3 46.8-61.7 46.8H96c-29.4 0-54.2-19.8-61.7-46.8L8.8 452.4C3.4 449.7 0 444.2 0 438.1V361.9c0-6.1 3.4-11.6 8.8-14.3L32 336V320L8.8 308.4C3.4 305.7 0 300.2 0 294.1V217.9c0-6.1 3.4-11.6 8.8-14.3L32 192V176zM112 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112z"]
};
var faTemperatureSnow = {
  prefix: 'fas',
  iconName: 'temperature-snow',
  icon: [576, 512, ["temperature-frigid"], "f768", "M384 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C505.8 332.6 512 349.5 512 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM432 0C370.1 0 320 50.1 320 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8c-18.9 24.4-30.1 55-30.1 88.1c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C544 50.1 493.9 0 432 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM288 131.6l-88 50.8V126.6l35.3-35.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L200 81.4V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V81.4L139.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L152 126.6v55.8l-48.3-27.9L90.7 106.3C88.5 97.7 79.7 92.7 71.2 95s-13.6 11.1-11.3 19.6l4.6 17.3-22-12.7C31 112.6 16.3 116.5 9.7 128s-2.7 26.2 8.8 32.8l22 12.7-17.3 4.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l48.2-12.9L128 224 79.7 251.9 31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l17.3 4.6-22 12.7C7 293.8 3.1 308.5 9.7 320s21.3 15.4 32.8 8.8l22-12.7-4.6 17.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l12.9-48.2L152 265.6v55.8l-35.3 35.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L152 366.6V392c0 13.3 10.7 24 24 24s24-10.7 24-24V366.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L200 321.4V265.6l67.7 39.1c5.2-13.5 12-26.2 20.3-37.9v-5.8l-64-37 64-37V131.6z"]
};
var faTemperatureFrigid = faTemperatureSnow;
var faMoped = {
  prefix: 'fas',
  iconName: 'moped',
  icon: [640, 512, [], "e3b9", "M328 56c0-13.3 10.7-24 24-24h41.3c23.8 0 45.1 15.1 52.9 37.6l8.1 23.3 51-25.5c4.4-2.2 9.3-3.4 14.3-3.4H528c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-8.4c-5 0-9.9-1.2-14.3-3.4l-34.9-17.5L500 224.4c4-.3 8-.4 12-.4c43.7 0 83.3 17.5 112.1 45.8c9.5 9.3 9.6 24.5 .3 33.9s-24.5 9.6-33.9 .3C570.2 284.2 542.6 272 512 272c-55.1 0-101 39.8-110.3 92.3c-2 11.5-12 19.8-23.6 19.8H336c-.9 0-1.7 0-2.6-.1H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32V320c0-70.7 57.3-128 128-128h96c17.7 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32h77.3c16.8-38.5 48.4-69.2 87.6-84.7L400.8 85.4c-1.1-3.2-4.2-5.4-7.6-5.4H352c-13.3 0-24-10.7-24-24zM128 96h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32 336c26.5 0 48-21.5 48-48H112c0 26.5 21.5 48 48 48zm352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faFaceSmilePlus = {
  prefix: 'fas',
  iconName: 'face-smile-plus',
  icon: [640, 512, ["smile-plus"], "f5b9", "M544 0c-13.3 0-24 10.7-24 24V72H472c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V120h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H568V24c0-13.3-10.7-24-24-24zM224 512a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM144.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM140 346.1c20.5 23.3 50.6 37.9 84 37.9s63.5-14.6 84-37.9c5.8-6.6 16-7.3 22.6-1.4s7.3 16 1.4 22.6C305.6 397.1 267 416 224 416s-81.6-18.9-108-48.7c-5.8-6.6-5.2-16.7 1.4-22.6s16.7-5.2 22.6 1.4z"]
};
var faSmilePlus = faFaceSmilePlus;
var faRadioTuner = {
  prefix: 'fas',
  iconName: 'radio-tuner',
  icon: [512, 512, ["radio-alt"], "f8d8", "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM320 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 336H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32z"]
};
var faRadioAlt = faRadioTuner;
var faFaceSwear = {
  prefix: 'fas',
  iconName: 'face-swear',
  icon: [640, 512, [], "e399", "M320 0C178.6 0 64 114.6 64 256H576C576 114.6 461.4 0 320 0zM240.4 224c-17.7 0-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8zM48 288c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48zm352 96H384v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H320v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V384H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V336c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32V336c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0v32h32V384H320zm250.4-52.1c6.7 5.8 7.5 15.8 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM184 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 336v1.8c4.6 .8 8.7 1.7 12.1 2.6c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9c-4.1 .5-6.3 1.4-7.4 2.2c-.6 .4-1.2 .9-1.5 2.9c-.2 1-.1 1.6-.1 1.8c.1 .1 .5 .6 1.5 1.3c3.7 2.5 9.6 4.4 19.2 7.3l.7 .2c8 2.4 19.1 5.8 27.6 11.9c4.7 3.4 9.3 8.2 12.1 14.7c2.9 6.6 3.4 13.8 2.2 21.1c-2 11.5-7.9 20.5-17 25.9c-4.9 3-10.1 4.6-15.3 5.4v.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c-8.1-1.9-15.3-4.2-20.2-5.9c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c.5-.3 1.4-.9 2-4c.2-1.2 .2-1.9 .2-2.3c0-.4-.1-.6-.1-.6l0 0c0-.1-.3-.6-1.6-1.6c-3.5-2.5-9.3-4.6-18.7-7.4L106 414c-7.7-2.3-18.3-5.5-26.4-11c-4.7-3.2-9.4-7.7-12.4-14.1c-3.1-6.5-3.7-13.7-2.5-20.9c1.8-10.2 7-18.1 14.5-23.5c5.3-3.8 11.2-5.9 16.9-7V336c0-8.8 7.2-16 16-16s16 7.2 16 16zM96.1 375.4a.1 .1 0 1 0 .1-.1 .1 .1 0 1 0 -.1 .1z"]
};
var faWaterArrowDown = {
  prefix: 'fas',
  iconName: 'water-arrow-down',
  icon: [576, 512, ["water-lower"], "f774", "M354.5 104.3L320 135.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V135.7l-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zm-85 189.6C247 309.4 219.5 320 192 320c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 373.7 159 384 192 384c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 309.2 410.9 320 384 320c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zm37 128c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"]
};
var faWaterLower = faWaterArrowDown;
var faScannerTouchscreen = {
  prefix: 'fas',
  iconName: 'scanner-touchscreen',
  icon: [512, 512, [], "f48a", "M152 0h16c13.3 0 24 10.7 24 24V64H128V24c0-13.3 10.7-24 24-24zM0 160c0-35.3 28.7-64 64-64H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm64 16V432c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM288 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V64H288V24zM240 0c8.8 0 16 7.2 16 16V64H224V16c0-8.8 7.2-16 16-16zM384 16c0-8.8 7.2-16 16-16s16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V16zM472 0h16c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24H472c-13.3 0-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"]
};
var faCircle7 = {
  prefix: 'fas',
  iconName: 'circle-7',
  icon: [512, 512, [], "e0f4", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faPlugCirclePlus = {
  prefix: 'fas',
  iconName: 'plug-circle-plus',
  icon: [576, 512, [], "e55f", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPersonSkiJumping = {
  prefix: 'fas',
  iconName: 'person-ski-jumping',
  icon: [512, 512, ["ski-jump"], "f7c7", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H304.5c46 0 65.7 58.4 29 86.2L230.1 260.8l-6.4 7.5c-2.4 2.8-4.4 6.1-5.7 9.6L179.5 380.6 433.7 249.1c18.6-9.6 30.3-28.8 30.3-49.7V192c0-13.3 10.7-24 24-24s24 10.7 24 24v7.3c0 38.9-21.7 74.5-56.2 92.4L35 509.3C23.3 515.4 8.8 510.8 2.7 499s-1.5-26.3 10.3-32.3l111.2-57.5c-10.7-8.4-15.2-23-10.2-36.4l44-117.4c3.9-10.5 9.7-20.2 17-28.8L232.1 160H160c-17.7 0-32-14.3-32-32z"]
};
var faSkiJump = faPersonSkiJumping;
var faPlaceOfWorship = {
  prefix: 'fas',
  iconName: 'place-of-worship',
  icon: [640, 512, [], "f67f", "M224 109.3V217.6L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"]
};
var faWaterArrowUp = {
  prefix: 'fas',
  iconName: 'water-arrow-up',
  icon: [576, 512, ["water-rise"], "f775", "M354.5 135.7L320 104.3V208c0 17.7-14.3 32-32 32s-32-14.3-32-32V104.3l-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zm-85 158.2c11.1-7.9 25.9-7.9 37 0C329 309.4 356.5 320 384 320c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 373.7 417 384 384 384c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 309.2 165.1 320 192 320c27.5 0 55-10.6 77.5-26.1zm37 128C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faWaterRise = faWaterArrowUp;
var faWaveformLines = {
  prefix: 'fas',
  iconName: 'waveform-lines',
  icon: [640, 512, ["waveform-path"], "f8f2", "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM544 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM256 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V160zM160 224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm576 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faWaveformPath = faWaveformLines;
var faSplit = {
  prefix: 'fas',
  iconName: 'split',
  icon: [512, 512, [], "e254", "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H346.5c-8.5 0-16.6 3.4-22.6 9.4L237.3 256l86.6 86.6c6 6 14.1 9.4 22.6 9.4H384V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H346.5c-25.5 0-49.9-10.1-67.9-28.1L178.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H178.7l99.9-99.9c18-18 42.4-28.1 67.9-28.1H384V64c0-12.9 7.8-24.6 19.8-29.6z"]
};
var faFilmCanister = {
  prefix: 'fas',
  iconName: 'film-canister',
  icon: [576, 512, ["film-cannister"], "f8b7", "M128 0C110.3 0 96 14.3 96 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c0-17.7-14.3-32-32-32H128zM352 128V416H480c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32-14.3 32-32V160c0-17.7-14.3-32-32-32H352zm56 40h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V184c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H504c-8.8 0-16-7.2-16-16V184zM408 328h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V344c0-8.8 7.2-16 16-16z"]
};
var faFilmCannister = faFilmCanister;
var faFolderXmark = {
  prefix: 'fas',
  iconName: 'folder-xmark',
  icon: [512, 512, ["folder-times"], "f65f", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM175 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faFolderTimes = faFolderXmark;
var faToiletPaperBlank = {
  prefix: 'fas',
  iconName: 'toilet-paper-blank',
  icon: [640, 512, ["toilet-paper-alt"], "f71f", "M384 192c0-65.5 13.2-142.4 60.2-192H160C107 0 64 86 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1C356.7 439 384 350.8 384 192zm224 0C608 86 565 0 512 0s-96 86-96 192s43 192 96 192s96-86 96-192zm-64 0c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"]
};
var faToiletPaperAlt = faToiletPaperBlank;
var faTabletScreen = {
  prefix: 'fas',
  iconName: 'tablet-screen',
  icon: [448, 512, ["tablet-android-alt"], "f3fc", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 448c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM384 64H64V384H384V64z"]
};
var faTabletAndroidAlt = faTabletScreen;
var faHexagonVerticalNftSlanted = {
  prefix: 'fas',
  iconName: 'hexagon-vertical-nft-slanted',
  icon: [448, 512, [], "e506", "M260.9 495.5c-22.3 12.9-49.7 12.9-72 0L36 407.2C13.7 394.4 0 370.6 0 344.9V168.3c0-25.7 13.7-49.5 36-62.4L188.9 17.7c22.3-12.9 49.7-12.9 72 0l152.9 88.3c22.3 12.9 36 36.6 36 62.4V344.9c0 25.7-13.7 49.5-36 62.4L260.9 495.5zm11.1-372c0-5.7-3.1-11-8.1-13.9L216.1 82.3c-2-1.2-4.3-2-6.8-2.2c-.5 0-1-.1-1.4-.1l-.1 0c-3.3 0-6.3 1-8.8 2.6c-1.5 1-2.9 2.2-4 3.7c-1.2 1.5-2.1 3.3-2.6 5.2c-.4 1.6-.6 3.1-.6 4.7V256.6v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-117l24.2 13.8c10.7 6.1 23.9-1.6 23.9-13.9zm16 27.4c0 5.7 3.1 11 8.1 13.9l23.8 13.6V352.6c0 8.8 7.2 16 16 16s16-7.2 16-16V196.6l16.2 9.3c7.7 4.4 17.4 1.7 21.8-6s1.7-17.4-6-21.8l-72-41.1c-10.7-6.1-23.9 1.6-23.9 13.9zM143.8 128.6c-8.8 0-16 7.2-16 16V270L95 171.5c-2.5-7.4-10-12-17.7-10.7s-13.4 7.9-13.4 15.8v160c0 8.8 7.2 16 16 16s16-7.2 16-16V275.2l32.8 98.5c2.5 7.4 10 12 17.7 10.7s13.4-7.9 13.4-15.8v-224c0-8.8-7.2-16-16-16z"]
};
var faFolderMusic = {
  prefix: 'fas',
  iconName: 'folder-music',
  icon: [512, 512, [], "e18d", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM352 192c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V283.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V224 192z"]
};
var faDisplayMedical = {
  prefix: 'fas',
  iconName: 'display-medical',
  icon: [576, 512, ["desktop-medical"], "e166", "M0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416H64c-35.3 0-64-28.7-64-64V64zm64 0V352H512V64H64zm192 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240H208c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16h48V128z"]
};
var faDesktopMedical = faDisplayMedical;
var faShareAll = {
  prefix: 'fas',
  iconName: 'share-all',
  icon: [576, 512, [], "f367", "M366.6 39.5c9.1-9.6 24.3-10 33.9-.9L542.2 173.2c19.9 18.9 19.9 50.7 0 69.6L400.5 377.4c-9.6 9.1-24.8 8.7-33.9-.9s-8.7-24.8 .9-33.9L509.2 208 367.5 73.4c-9.6-9.1-10-24.3-.9-33.9zM224 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2V288H192c-53 0-96 43-96 96c0 30.4 12.8 47.9 22.2 56.7c5.5 5.1 9.8 12 9.8 19.5c0 10.9-8.8 19.7-19.7 19.7c-2.8 0-5.6-.6-8.1-1.9C81.5 467.9 0 417.3 0 304c0-97.2 78.8-176 176-176h48V64z"]
};
var faPeapod = {
  prefix: 'fas',
  iconName: 'peapod',
  icon: [512, 512, [], "e31c", "M464 0H416C186.2 0 0 186.2 0 416v48c0 26.5 21.5 48 48 48H96c229.8 0 416-186.2 416-416V48c0-26.5-21.5-48-48-48zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0A56 56 0 1 1 88 368zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faChessClock = {
  prefix: 'fas',
  iconName: 'chess-clock',
  icon: [640, 512, [], "f43d", "M256 56c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v48H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H544V112c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16v16H200V80h32c13.3 0 24-10.7 24-24zM576 304a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zm-52.7-59.3c-6.2-6.2-16.4-6.2-22.6 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6zM176 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm-16 48v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faAxe = {
  prefix: 'fas',
  iconName: 'axe',
  icon: [640, 512, [129683], "f6b2", "M374.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3L384 301.3V384c0 17.7 14.3 32 32 32c123.7 0 224-100.3 224-224c0-17.7-14.3-32-32-32H525.3l-56-56 33.4-33.4c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0L408 42.7 374.6 9.4zM448 316c45-11.6 80.4-47 92-92h32.8C560.1 286.7 510.7 336.1 448 348.8V316zM244.1 206.6L9.4 441.4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0L305.4 267.9l-61.3-61.3z"]
};
var faSquareD = {
  prefix: 'fas',
  iconName: 'square-d',
  icon: [448, 512, [], "e268", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h72c70.7 0 128 57.3 128 128s-57.3 128-128 128H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm24 208h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H176V336z"]
};
var faGripVertical = {
  prefix: 'fas',
  iconName: 'grip-vertical',
  icon: [320, 512, [], "f58e", "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"]
};
var faMobileSignalOut = {
  prefix: 'fas',
  iconName: 'mobile-signal-out',
  icon: [512, 512, [], "e1f0", "M64 64H224V0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V288H288V448H64V64zm80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24C512 103.9 408.1 0 280 0zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 120c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"]
};
var faArrowTurnUp = {
  prefix: 'fas',
  iconName: 'arrow-turn-up',
  icon: [384, 512, ["level-up"], "f148", "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"]
};
var faLevelUp = faArrowTurnUp;
var faU = {
  prefix: 'fas',
  iconName: 'u',
  icon: [384, 512, [117], "55", "M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"]
};
var faArrowUpFromDottedLine = {
  prefix: 'fas',
  iconName: 'arrow-up-from-dotted-line',
  icon: [448, 512, [], "e09b", "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 141.3V208 320c0 17.7 14.3 32 32 32s32-14.3 32-32V208 141.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM32 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm128 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faSquareRootVariable = {
  prefix: 'fas',
  iconName: 'square-root-variable',
  icon: [576, 512, ["square-root-alt"], "f698", "M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"]
};
var faSquareRootAlt = faSquareRootVariable;
var faLightSwitchOn = {
  prefix: 'fas',
  iconName: 'light-switch-on',
  icon: [384, 512, [], "e019", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 96h64c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zm32-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 128c-17.7 0-32 14.3-32 32v96H256V160c0-17.7-14.3-32-32-32H160z"]
};
var faArrowDownArrowUp = {
  prefix: 'fas',
  iconName: 'arrow-down-arrow-up',
  icon: [576, 512, ["sort-alt"], "f883", "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L128 370.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V370.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96zm352-333.3c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L448 141.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V141.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96z"]
};
var faSortAlt = faArrowDownArrowUp;
var faRaindrops = {
  prefix: 'fas',
  iconName: 'raindrops',
  icon: [448, 512, [], "f75c", "M102.4 133.6c-4.2 8.6-6.4 18-6.4 27.6c0 34.7 28.1 62.8 62.8 62.8h2.4c34.7 0 62.8-28.1 62.8-62.8c0-9.6-2.2-19-6.4-27.6L171.5 39.2c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2l-46.1 94.4zm-96 192c-4.2 8.6-6.4 18-6.4 27.6C0 387.9 28.1 416 62.8 416h2.4c34.7 0 62.8-28.1 62.8-62.8c0-9.6-2.2-19-6.4-27.6L75.5 231.2c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2L6.4 325.6zM307.8 134.8L210 294.2c-11.8 19.2-18 41.3-18 63.8c0 67.4 54.6 122 122 122h12c67.4 0 122-54.6 122-122c0-22.5-6.2-44.6-18-63.8L332.2 134.8c-2.6-4.2-7.2-6.8-12.2-6.8s-9.6 2.6-12.2 6.8z"]
};
var faDash = {
  prefix: 'fas',
  iconName: 'dash',
  icon: [512, 512, ["minus-large"], "e404", "M0 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
};
var faMinusLarge = faDash;
var faClock = {
  prefix: 'fas',
  iconName: 'clock',
  icon: [512, 512, [128339, "clock-four"], "f017", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faClockFour = faClock;
var faInputNumeric = {
  prefix: 'fas',
  iconName: 'input-numeric',
  icon: [640, 512, [], "e1bd", "M576 128V384H64V128H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm40 120c0 13.3 10.7 24 24 24h8v96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H184V184c0-13.3-10.7-24-24-24H128c-13.3 0-24 10.7-24 24zm190.6 30.4c5.7-8 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H318.8l34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z"]
};
var faTruckTow = {
  prefix: 'fas',
  iconName: 'truck-tow',
  icon: [640, 512, [], "e2b8", "M96 0h49.6c9.1 0 17.8 3.9 23.9 10.7L384 252V128c0-17.7 14.3-32 32-32h82.7c17 0 33.3 6.7 45.3 18.7L621.3 192c12 12 18.7 28.3 18.7 45.3V256v32 88c0 22.1-17.9 40-40 40H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48H192L96 64V176c0 26.5-21.5 48-48 48s-48-21.5-48-48V160c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V32C64 14.3 78.3 0 96 0zM576 256V237.3L498.7 160H448v96H576zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faBackwardStep = {
  prefix: 'fas',
  iconName: 'backward-step',
  icon: [320, 512, ["step-backward"], "f048", "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"]
};
var faStepBackward = faBackwardStep;
var faPallet = {
  prefix: 'fas',
  iconName: 'pallet',
  icon: [640, 512, [], "f482", "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z"]
};
var faCarBolt = {
  prefix: 'fas',
  iconName: 'car-bolt',
  icon: [512, 512, [], "e341", "M74.8 96.3L39.6 196.8C16.4 206.4 0 229.3 0 256V400v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V400H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V400 256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM96 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM318.3 119.2L281.9 192H336c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4L230.1 224H176c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9 .5s7.4 12.8 4.1 19.4z"]
};
var faArrowsMaximize = {
  prefix: 'fas',
  iconName: 'arrows-maximize',
  icon: [512, 512, ["expand-arrows"], "f31d", "M320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L256 210.7 141.3 96H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H64C46.3 32 32 46.3 32 64V192c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3L210.7 256 96 370.7V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H141.3L256 301.3 370.7 416H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H448c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v50.7L301.3 256 416 141.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320z"]
};
var faExpandArrows = faArrowsMaximize;
var faFaucet = {
  prefix: 'fas',
  iconName: 'faucet',
  icon: [512, 512, [], "e005", "M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V180.2l-32-4-32 4V224H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 256H32z"]
};
var faCloudSleet = {
  prefix: 'fas',
  iconName: 'cloud-sleet',
  icon: [512, 512, [], "f741", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm272 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zM216 376v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm256 0v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H472v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440H408c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V376c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faLampStreet = {
  prefix: 'fas',
  iconName: 'lamp-street',
  icon: [512, 512, [], "e1c5", "M64 176c0-61.9 50.1-112 112-112c57.4 0 104.7 43.2 111.2 98.8C207.1 176.6 144 239.9 130.6 320.1C127.7 337.6 142.3 352 160 352H480c17.7 0 32.3-14.4 29.4-31.9c-13.5-80.6-77.2-144.2-157.9-157.6C344.6 71.6 268.7 0 176 0C78.8 0 0 78.8 0 176V480c0 17.7 14.3 32 32 32s32-14.3 32-32V176zM320 448c35.3 0 64-28.7 64-64H256c0 35.3 28.7 64 64 64z"]
};
var faListRadio = {
  prefix: 'fas',
  iconName: 'list-radio',
  icon: [512, 512, [], "e1d0", "M64 160A64 64 0 1 0 64 32a64 64 0 1 0 0 128zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM40 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0zM64 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faPenNibSlash = {
  prefix: 'fas',
  iconName: 'pen-nib-slash',
  icon: [640, 512, [], "e4a1", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L450.3 327.6l28.3-94.4 2.8-9.2L352 94.6l-9.2 2.8L208.1 137.8 38.8 5.1zm29 440.7c-3.8 11.3-1 23.9 7.3 32.4L228.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-9.4 2.7-18.2 7.4-25.7l-85-67L67.8 445.8zM272 352c-7.4 0-14.4-1.7-20.7-4.7L97.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c3.6-1.2 7.1-2.8 10.5-4.6l-98.5-77.6c-8.7 9-20.9 14.6-34.4 14.6zM432.4 18.3L376.7 74.1 501.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L511.6 18.3c-21.9-21.9-57.3-21.9-79.2 0z"]
};
var faBaseballBatBall = {
  prefix: 'fas',
  iconName: 'baseball-bat-ball',
  icon: [512, 512, [], "f432", "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faSquareUpLeft = {
  prefix: 'fas',
  iconName: 'square-up-left',
  icon: [448, 512, [], "e282", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 281.4V176c0-8.8 7.2-16 16-16H281.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L264 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C290 366 285.1 368 280 368s-10-2-13.7-5.7L200 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6z"]
};
var faOverline = {
  prefix: 'fas',
  iconName: 'overline',
  icon: [448, 512, [], "f876", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm192 96a176 176 0 1 0 0 352 176 176 0 1 0 0-352zM336 304a112 112 0 1 1 -224 0 112 112 0 1 1 224 0z"]
};
var faS = {
  prefix: 'fas',
  iconName: 's',
  icon: [320, 512, [115], "53", "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"]
};
var faTimeline = {
  prefix: 'fas',
  iconName: 'timeline',
  icon: [640, 512, [], "e29c", "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM488 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faKeyboard = {
  prefix: 'fas',
  iconName: 'keyboard',
  icon: [576, 512, [9000], "f11c", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336zM272 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM368 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240zM464 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z"]
};
var faArrowsFromDottedLine = {
  prefix: 'fas',
  iconName: 'arrows-from-dotted-line',
  icon: [448, 512, [], "e0a3", "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM192 352v32H160c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H256V352c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faUsbDrive = {
  prefix: 'fas',
  iconName: 'usb-drive',
  icon: [640, 512, [], "f8e9", "M64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64H416c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zm544 32H480V384H608c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32zM560 232a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm24 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faBallot = {
  prefix: 'fas',
  iconName: 'ballot',
  icon: [448, 512, [], "f732", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112zm0 128c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zM80 352h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm112 32c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16-272H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM192 256c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16z"]
};
var faCaretDown = {
  prefix: 'fas',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
};
var faLocationDotSlash = {
  prefix: 'fas',
  iconName: 'location-dot-slash',
  icon: [640, 512, ["map-marker-alt-slash"], "f605", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zm219 171.7c6.8-28 32.1-48.8 62.2-48.8c35.3 0 64 28.7 64 64c0 24.7-13.9 46-34.4 56.7l-91.8-72zm85.9 322.4c16.2-20.2 39-49.6 62.5-83.1L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0z"]
};
var faMapMarkerAltSlash = faLocationDotSlash;
var faCards = {
  prefix: 'fas',
  iconName: 'cards',
  icon: [640, 512, [], "e3ed", "M7.5 194.9c-15.4-26.6-6.3-60.7 20.4-76.1L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.4 26.6 6.2 60.7-20.4 76.1L250.5 504.5c-26.6 15.4-60.7 6.2-76.1-20.4L7.5 194.9zM197 159.6c-11.1-3-22.6 3.6-25.6 14.8l-7.2 26.9-20.4 76.1c-7 26 8.5 52.7 34.4 59.7s52.7-8.5 59.7-34.4l2.4-8.8c.1-.4 .2-.8 .3-1.1l17.7 30.7-12.1 7c-6.7 3.8-8.9 12.4-5.1 19s12.4 8.9 19 5.1l48.2-27.8c6.7-3.8 8.9-12.4 5.1-19s-12.4-8.9-19-5.1l-12.1 7-17.7-30.7c.4 .1 .8 .2 1.1 .3l8.8 2.4c26 7 52.7-8.5 59.7-34.4s-8.5-52.7-34.4-59.7l-76.1-20.4L197 159.6zM459.4 420.9c41.9-24.2 56.3-77.8 32.1-119.8L354.7 64.2c1.7-.2 3.5-.2 5.3-.2H584c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H360c-13.7 0-26.2-4.9-35.9-13l135.3-78.1zm74.5-183.3L582 187.6c14-14.5 13.2-38.5-2.2-51.9c-14-11.7-34.5-9.5-46.9 3.2l-4.7 5.2-5-5.2c-12.5-12.7-33.2-15-46.7-3.2c-15.7 13.5-16.5 37.5-2.5 51.9l48.4 49.9c3 3.2 8.2 3.2 11.5 0z"]
};
var faHouseChimneyMedical = {
  prefix: 'fas',
  iconName: 'house-chimney-medical',
  icon: [576, 512, ["clinic-medical"], "f7f2", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H320V208c0-8.8-7.2-16-16-16H272z"]
};
var faClinicMedical = faHouseChimneyMedical;
var faBoxingGlove = {
  prefix: 'fas',
  iconName: 'boxing-glove',
  icon: [448, 512, [129354, "glove-boxing"], "f438", "M0 96C0 43 43 0 96 0H288c53 0 96 43 96 96v32H352c-26.2 0-49.4 12.6-64 32H144c-21.2 0-34.3-5.3-41.8-9.7c-3.8-2.3-6.3-4.4-7.7-5.8c-.7-.7-1.1-1.2-1.3-1.5l-.1-.1 0 0c-5-7.1-14.7-9-22-4.2c-7.4 4.9-9.3 14.8-4.4 22.2L80 152c-13.3 8.9-13.3 8.9-13.3 8.9l0 0 0 0 .1 .1 .1 .2 .4 .5c.3 .4 .6 .8 1.1 1.4c.9 1.1 2 2.4 3.6 4c3.1 3.1 7.6 6.9 13.8 10.7C98.3 185.3 117.2 192 144 192H273.6c-1 5.2-1.6 10.5-1.6 16c0 37.3 25.5 68.6 60 77.5c8.6 2.2 17.3-2.9 19.5-11.5s-2.9-17.3-11.5-19.5c-20.7-5.3-36-24.1-36-46.5c0-26.5 21.5-48 48-48h32c35.3 0 64 28.7 64 64v24.2c0 25.5-10.1 49.9-28.1 67.9l-49.1 49.1c-12 12-18.7 28.3-18.7 45.3V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V359.6C12.4 342 0 316.4 0 288V96zM152.9 354.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L192 419.2l39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 380.8l-39.1-26.1z"]
};
var faGloveBoxing = faBoxingGlove;
var faTemperatureThreeQuarters = {
  prefix: 'fas',
  iconName: 'temperature-three-quarters',
  icon: [320, 512, ["temperature-3", "thermometer-3", "thermometer-three-quarters"], "f2c8", "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature3 = faTemperatureThreeQuarters;
var faThermometer3 = faTemperatureThreeQuarters;
var faThermometerThreeQuarters = faTemperatureThreeQuarters;
var faBellSchool = {
  prefix: 'fas',
  iconName: 'bell-school',
  icon: [512, 512, [], "f5d5", "M208 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 288A208 208 0 1 0 208 0a208 208 0 1 0 0 416zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 448c-54 0-103.9-17.9-144-48v64c0 26.5 21.5 48 48 48H320h32 40c43.4 0 80.1-28.8 92-68.3c16.6-7.6 28-24.3 28-43.7c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15.5 7.3 29.2 18.7 38c-8 15.4-24.1 26-42.7 26H352V400c-40.1 30.1-90 48-144 48z"]
};
var faMobileScreen = {
  prefix: 'fas',
  iconName: 'mobile-screen',
  icon: [384, 512, ["mobile-android-alt"], "f3cf", "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"]
};
var faMobileAndroidAlt = faMobileScreen;
var faPlaneUp = {
  prefix: 'fas',
  iconName: 'plane-up',
  icon: [512, 512, [], "e22d", "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400V320L21.1 377C10.7 380.4 0 372.7 0 361.8V305.1c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"]
};
var faFolderHeart = {
  prefix: 'fas',
  iconName: 'folder-heart',
  icon: [512, 512, [], "e189", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM144 253.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faCircleLocationArrow = {
  prefix: 'fas',
  iconName: 'circle-location-arrow',
  icon: [512, 512, ["location-circle"], "f602", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM358.2 182.7l-84 196c-3.5 8.1-11.4 13.3-20.2 13.3c-1.4 0-2.9-.1-4.4-.4C239.4 389.5 232 380.4 232 370V280H142c-10.4 0-19.5-7.4-21.5-17.6c-2.1-10.2 3.3-20.5 12.9-24.6l196-84c8.5-3.5 18-1.7 24.2 4.7c6.4 6.3 8.2 15.9 4.7 24.2z"]
};
var faLocationCircle = faCircleLocationArrow;
var faFaceHeadBandage = {
  prefix: 'fas',
  iconName: 'face-head-bandage',
  icon: [576, 512, [], "e37a", "M288 0C213.6 0 146.6 31.8 99.8 82.4c-12.5 2.5-25 5.2-37.3 8.2c-8.2 2-15.3 7.1-19.7 14.3C26.9 130.6 15 158.9 7.8 189c-2.4 10.2 .3 20.9 7.2 28.7c-2.5 2.8-4.9 5.6-7.3 8.5c-4.7 5.5-7.3 12.4-7.6 19.6C.1 249.2 0 252.6 0 256c0 31.4 5 61.7 14.4 90.1c3.8 11.6 13.9 20 26 21.7c5.6 .8 11.2 0 16.3-2C97.8 452.2 185.9 512 288 512c141.4 0 256-114.6 256-256c0-9.5-.5-18.8-1.5-28c6.1-1.1 11.9-3.9 16.5-8.3c8.3-7.9 11.8-19.6 9.2-30.7c-7.2-30.1-19.1-58.4-34.9-84.1c-3.3-5.3-8-9.5-13.5-12.1c-.6-6-2.9-11.9-6.9-16.8c-21.2-26.5-47-49.1-76.2-66.8c-6.1-3.7-13.4-5.2-20.5-4.4c-16.2 2-32.2 4.6-48.1 7.9C342.9 4.5 316 0 288 0zM219.2 98.5s0 0 0 0s0 0 0 0C241.9 96.8 264.9 96 288 96c40 0 79.3 2.5 118 7.4c2.2 .3 4.4 .6 6.6 .9c31.7 4.3 62.9 10.1 93.5 17.5c.1 .2 .2 .3 .3 .5c7.3 11.9 13.7 24.4 19 37.5c4.8 11.8 8.7 24.1 11.7 36.7c-11.9-3.6-23.9-6.9-36-10c-59.4-15.1-121.2-24-184.8-26c-.3 0-.5 0-.8 0c-9.1-.3-18.3-.4-27.5-.4c-17.1 0-34.1 .5-51 1.5c-48.2 2.8-95.4 9.6-141.2 20c-7 1.6-13.9 3.3-20.9 5c-12.1 3.1-24.1 6.4-36 10c.5-2 1-4 1.5-6c2.8-10.5 6.2-20.8 10.2-30.7c5.4-13.3 11.8-26 19.3-38c23.2-5.6 46.8-10.3 70.7-14.1c0 0 0 0 0 0c.8-.1 1.6-.3 2.5-.4c25-3.9 50.4-6.9 76.1-8.7zM50.3 226.4c41-12.2 83.3-21.3 126.6-27.1c-40.6 29.4-77 64.4-108 103.7c-8.5 10.7-16.5 21.7-24.2 33.1c-4.4-13.3-7.7-27.1-9.9-41.3C33 282.1 32 269.2 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5zm126 13.6c13.5-10.8 27.6-20.9 42.1-30.4c12.7 4.2 21.9 16.2 21.9 30.4c0 17.7-14.3 32-32 32s-32-14.3-32-32zM476.2 82.4C419.3 71.1 360.6 64.9 300.6 64.1c38.3-13 78.3-22.2 119.5-27.4c13.7 8.3 26.6 17.9 38.5 28.5c6.1 5.5 11.9 11.2 17.5 17.2zm-103 315.1C356.4 382.2 330.8 368 296 368c-13.1 0-24.8 2-35.2 5.3c-8.4 2.7-17.4-2-20.1-10.5s2-17.4 10.5-20.1c13.4-4.2 28.4-6.8 44.8-6.8c44.2 0 77.2 18.3 98.8 37.9c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1zM368.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSushiRoll = {
  prefix: 'fas',
  iconName: 'sushi-roll',
  icon: [448, 512, ["maki-roll", "makizushi"], "e48b", "M448 368V144C448 82.1 347.7 32 224 32S0 82.1 0 144V368c0 61.9 100.3 112 224 112s224-50.1 224-112zM308.2 198.4c-24.5 6.1-53.3 9.6-84.2 9.6c-40.7 0-77.8-6.1-106-16.1c14.8-14.8 32.8-26.7 51.4-36.1c20.5-10.3 40.9-17 56.9-20.8c18.2 27.3 46.6 49.9 82 63.4zM205.1 80.4c.8 6 2.1 11.9 3.8 17.7c-17.3 4.7-37.4 11.8-57.5 21.9c-24.5 12.3-49.9 29.4-70.3 52.7C70.2 164.1 64 154.4 64 144c0-32.8 61.7-59.8 141.1-63.6zm40.7 .2c78 4.3 138.2 31 138.2 63.4c0 9.8-5.5 19.1-15.4 27.4c-69.5-5.5-113.5-48.4-122.8-90.8z"]
};
var faMakiRoll = faSushiRoll;
var faMakizushi = faSushiRoll;
var faCarBump = {
  prefix: 'fas',
  iconName: 'car-bump',
  icon: [640, 512, [], "f5e0", "M145.1 120.6L292.4 81.2c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6L114.6 211.6l7-63.6c1.4-13.1 10.8-24 23.5-27.4zM58 141.1L47.8 234.2C27.4 249.4 17.2 276 24.2 302.1L57.3 425.8l12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5 487.8 177.9c-7-26.1-29.1-44.1-54.4-47L378.1 55.3c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1zm58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1 -16.6-61.8zm255.6-35.3a32 32 0 1 1 61.8-16.6 32 32 0 1 1 -61.8 16.6zM584.8 512c19.5 0 34.7-17.7 25.8-35c-18.6-36.2-56.3-61-99.7-61s-81.2 24.8-99.7 61c-8.9 17.3 6.3 35 25.8 35H584.8z"]
};
var faPiggyBank = {
  prefix: 'fas',
  iconName: 'piggy-bank',
  icon: [576, 512, [], "f4d3", "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96h11.5c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H256v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24H68c-11 0-20 9-20 20s9 20 20 20H99.2c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2H384zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faRacquet = {
  prefix: 'fas',
  iconName: 'racquet',
  icon: [512, 512, [], "f45a", "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3c40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-54.4 54.4-131.9 78.7-198.2 61.7c-29.4-7.5-62.9-5.5-84.3 16L148.3 409c6.4 12.1 4.5 27.4-5.6 37.6l-56 56c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l56-56c10.2-10.2 25.5-12.1 37.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84C129.8 250.9 128 236 128 221c0-54.2 23.4-110.5 66.9-154z"]
};
var faCarMirrors = {
  prefix: 'fas',
  iconName: 'car-mirrors',
  icon: [576, 512, [], "e343", "M167.2 117.4c4.5-12.8 16.6-21.4 30.2-21.4H378.6c13.6 0 25.7 8.6 30.2 21.4L434.9 192H141.1l26.1-74.6zM32 224h8.6c-5.4 9.4-8.6 20.3-8.6 32V400v48c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H448v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V400 256c0-11.7-3.1-22.6-8.6-32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H491.5L469.2 96.3C455.7 57.8 419.4 32 378.6 32H197.4c-40.8 0-77.1 25.8-90.6 64.3L84.5 160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32zm64 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faIndustryWindows = {
  prefix: 'fas',
  iconName: 'industry-windows',
  icon: [576, 512, [127981, "industry-alt"], "f3b3", "M32 64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V215.4L316.6 131c16-8.6 35.4 3 35.4 21.1v63.2L508.6 131c16-8.6 35.4 3 35.4 21.1V304 432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V352 304 64zM264 312c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H264zM120 328v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H136c-8.8 0-16 7.2-16 16zm272-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H392z"]
};
var faIndustryAlt = faIndustryWindows;
var faBoltAuto = {
  prefix: 'fas',
  iconName: 'bolt-auto',
  icon: [576, 512, [], "e0b6", "M317.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224C.9 240.7-2.6 254.8 2 267.3S18.7 288 32 288H143.5L66.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H240.5L317.4 44.6zM464 288c-12.1 0-23.2 6.8-28.6 17.7l-80 160c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-80-160C487.2 294.8 476.1 288 464 288zM447.8 424L464 391.6 480.2 424H447.8z"]
};
var faBatteryHalf = {
  prefix: 'fas',
  iconName: 'battery-half',
  icon: [576, 512, ["battery-3"], "f242", "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm208 96H96V320H288V192z"]
};
var faBattery3 = faBatteryHalf;
var faFluxCapacitor = {
  prefix: 'fas',
  iconName: 'flux-capacitor',
  icon: [448, 512, [], "f8ba", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM148.7 237.3l-49-49c-15.6-15.6-15.6-40.9 0-56.6s40.9-15.6 56.6 0l49 49c1.8-6.6 2.7-13.6 2.7-20.7c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7zM184 282.7c-23.9 13.8-40 39.7-40 69.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-29.6-16.1-55.5-40-69.3V352c0 22.1-17.9 40-40 40s-40-17.9-40-40V282.7zm115.3-45.4c6.6 1.8 13.6 2.7 20.7 2.7c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0 7.2 .9 14.1 2.7 20.7l49-49c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6l-49 49zm-160-88.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 262.6V352c0 8.8 7.2 16 16 16s16-7.2 16-16V262.6l91.3-91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-84.7-84.7z"]
};
var faMountainCity = {
  prefix: 'fas',
  iconName: 'mountain-city',
  icon: [640, 512, [], "e52e", "M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zM224 188.9L283.8 288H223l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"]
};
var faCoins = {
  prefix: 'fas',
  iconName: 'coins',
  icon: [512, 512, [], "f51e", "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"]
};
var faHoneyPot = {
  prefix: 'fas',
  iconName: 'honey-pot',
  icon: [448, 512, [127855], "e418", "M128 32H64C46.3 32 32 46.3 32 64s14.3 32 32 32C25.1 125.2 0 171.7 0 224C0 362.8 79.6 441.9 113.3 469.1c9.3 7.5 21.1 10.9 33.1 10.9H301.6c12 0 23.7-3.3 33.1-10.9C368.4 441.9 448 362.8 448 224c0-52.3-25.1-98.8-64-128c17.7 0 32-14.3 32-32s-14.3-32-32-32H176V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V32zM64 224H384c0 53.7-14.7 96.1-32.9 128H96.9C78.7 320.1 64 277.7 64 224z"]
};
var faOlive = {
  prefix: 'fas',
  iconName: 'olive',
  icon: [448, 512, [], "e316", "M160 480C71.6 480 0 408.4 0 320C0 128 181.9 32 280 32c56 0 112 56 112 56s56 56 56 112c0 98.1-96 280-288 280zM287.1 192.9c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8s-69.6-40.1-87.8-21.9s-8.4 57.5 21.9 87.8z"]
};
var faKhanda = {
  prefix: 'fas',
  iconName: 'khanda',
  icon: [512, 512, [9772], "f66d", "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l0 0 0 0 0 0 0 0-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1 0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3l0 0 0 0 .1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1 0 0 0 0s0 0-10.2-12.3l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V424.1l-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3l0 0 0 0-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0 0 0 0 0s0 0 7.2 14.3l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L240 362.6V343.5l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1 0 0 0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z"]
};
var faFilterList = {
  prefix: 'fas',
  iconName: 'filter-list',
  icon: [512, 512, [], "e17c", "M40 64C24.2 64 9.9 73.3 3.5 87.7s-3.8 31.3 6.8 43L112 243.8V368c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6V243.8l101.7-113c10.6-11.7 13.2-28.6 6.8-43S327.8 64 312 64H40zM352 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352zM320 256c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zM416 64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H416z"]
};
var faOutlet = {
  prefix: 'fas',
  iconName: 'outlet',
  icon: [448, 512, [], "e01c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm0 224c0-61.1 30.8-99.1 49.7-116.6c8.8-8.2 20.7-11.4 32.6-11.4H301.6c12 0 23.9 3.3 32.6 11.4C353.2 156.9 384 194.9 384 256s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4H146.4c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256zm96-64c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm128 0c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm-64 96c-13.3 0-24 10.7-24 24v16c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V312c0-13.3-10.7-24-24-24z"]
};
var faSliders = {
  prefix: 'fas',
  iconName: 'sliders',
  icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"]
};
var faSlidersH = faSliders;
var faCauldron = {
  prefix: 'fas',
  iconName: 'cauldron',
  icon: [448, 512, [], "f6bf", "M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM35.1 224C16.5 257 0 297.1 0 334.4c0 37.4 11.9 69.4 32 95.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24V473c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39v15c0 13.3 10.7 24 24 24s24-10.7 24-24V429.9c20.1-26.1 32-58.1 32-95.5c0-37.3-16.5-77.4-35.1-110.4H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H368 224 80 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h3.1z"]
};
var faPeople = {
  prefix: 'fas',
  iconName: 'people',
  icon: [640, 512, [], "e216", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faFolderTree = {
  prefix: 'fas',
  iconName: 'folder-tree',
  icon: [576, 512, [], "f802", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96V384c0 35.3 28.7 64 64 64H256V384H64V160H256V96H64V32zM288 192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V192zm0 288c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V480z"]
};
var faNetworkWired = {
  prefix: 'fas',
  iconName: 'network-wired',
  icon: [640, 512, [], "f6ff", "M256 64H384v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H192V288H448v32H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V192h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 448V384H224v64H96zm320-64H544v64H416V384z"]
};
var faCroissant = {
  prefix: 'fas',
  iconName: 'croissant',
  icon: [512, 512, [129360], "f7f6", "M259.4 1.4c3.9 5.9 7 12.5 9.1 19.5l59.9 199.7c1.2 4.1 2 8.2 2.4 12.4L440.3 92.2c13.6-17.4 10.5-42.8-8.6-53.9C389.4 14 340.3 0 288 0c-9.7 0-19.2 .5-28.6 1.4zM233 330.8c-4.1-.4-8.3-1.2-12.4-2.4L20.9 268.5c-7-2.1-13.6-5.2-19.5-9.1C.5 268.8 0 278.3 0 288c0 52.3 14 101.4 38.4 143.7c11 19.1 36.4 22.2 53.9 8.6L233 330.8zM232.7 19l0 0c2 3 3.6 6.4 4.8 10c-1.2-3.6-2.8-6.9-4.8-10l0 0zm232.9 92.8L390 209l87.6 14.6c1.6 .3 3.2 .4 4.9 .4c16.3 0 29.6-13.2 29.6-29.6V189c0-4.2-.7-8.3-2.3-12.2c-10.1-25.2-24.1-48.5-41.3-69c-.9 1.4-1.9 2.7-2.9 4zM209 390l-97.1 75.6c-1.3 1-2.6 2-4 2.9c20.5 17.2 43.8 31.2 69 41.3c3.9 1.5 8 2.3 12.2 2.3h5.4c16.3 0 29.6-13.2 29.6-29.6c0-1.6-.1-3.3-.4-4.9L209 390zM19 232.7l0 0c2.3 1.5 4.7 2.8 7.3 3.8c1.2 .5 2.5 1 3.8 1.3l199.7 59.9c11.3 3.4 23.5 .3 31.8-8l28.1-28.1c8.3-8.3 11.4-20.5 8-31.8L237.8 30.1C232.5 12.2 216 0 197.4 0c-4.6 0-9.2 .7-13.5 2.3C99.7 33 33 99.7 2.3 183.9C.7 188.2 0 192.8 0 197.4c0 14.5 7.4 27.6 19 35.3l0 0z"]
};
var faMapPin = {
  prefix: 'fas',
  iconName: 'map-pin',
  icon: [320, 512, [128205], "f276", "M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM128 480V317.1c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]
};
var faHamsa = {
  prefix: 'fas',
  iconName: 'hamsa',
  icon: [512, 512, [], "f665", "M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40V272c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCentSign = {
  prefix: 'fas',
  iconName: 'cent-sign',
  icon: [384, 512, [], "e3f5", "M224 0c17.7 0 32 14.3 32 32V66.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3V32c0-17.7 14.3-32 32-32z"]
};
var faSwordsLaser = {
  prefix: 'fas',
  iconName: 'swords-laser',
  icon: [640, 512, [], "e03d", "M135 7c-9.1 9.1-9.4 23.7-.7 33.2L360 286.9V181.8L168.2 6.3C158.7-2.4 144.1-2.1 135 7zm263 349.7l49 49 27.3-27.3 32-32L533.7 319 411.3 196.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V322.7c0 12.7 5.1 24.9 14.1 33.9zM523.3 352L629 457.7l3.5-3.5c4.8-4.8 7.5-11.3 7.5-18.1s-2.7-13.3-7.5-18.1L545 330.3 523.3 352zM512 363.3L491.3 384 597 489.7 617.7 469 512 363.3zm-32 32L458.3 417l87.5 87.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5l3.5-3.5L480 395.3zM247.6 211.4l-24.7 22.6c-1.6-3.9-4.7-7.2-8.7-8.8c-6-2.5-12.9-1.1-17.4 3.5l-25.4 25.4-4.9-4.9c-12.5-12.3-32.6-12.2-45 .2c-12.5 12.5-12.5 32.8 0 45.3l4.7 4.7L7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l50.3 50.3c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5L209.9 388.7c9-9 14.1-21.2 14.1-33.9v-6.6l74.3-81.2-50.7-55.5zm142.8-45.2l115.3-126c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L343.7 123.5l46.7 42.7zM152 344a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faFlask = {
  prefix: 'fas',
  iconName: 'flask',
  icon: [448, 512, [], "f0c3", "M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM192 196.8V64h64V196.8c0 23.7 6.6 46.9 19 67.1L309.5 320h-171L173 263.9c12.4-20.2 19-43.4 19-67.1z"]
};
var faPersonPregnant = {
  prefix: 'fas',
  iconName: 'person-pregnant',
  icon: [384, 512, [], "e31e", "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 383c-13.8-3.6-24-16.1-24-31V296.9l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1h1.1 12.5H192c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 264v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h-8-8v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V383z"]
};
var faSquareU = {
  prefix: 'fas',
  iconName: 'square-u',
  icon: [448, 512, [], "e281", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 136V288c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faWandSparkles = {
  prefix: 'fas',
  iconName: 'wand-sparkles',
  icon: [512, 512, [], "f72b", "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16H384.2c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"]
};
var faRouter = {
  prefix: 'fas',
  iconName: 'router',
  icon: [576, 512, [], "f8da", "M352 48c58.8 0 112.5 21.8 153.4 57.9c9.9 8.8 25.1 7.8 33.9-2.1s7.8-25.1-2.1-33.9C487.8 26.4 422.9 0 352 0S216.2 26.4 166.9 69.9c-9.9 8.8-10.9 23.9-2.1 33.9s23.9 10.9 33.9 2.1C239.5 69.8 293.2 48 352 48zm24 200c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H376V248zM96 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM276.5 186.7C297.1 170 323.4 160 352 160s54.9 10 75.5 26.7c10.3 8.3 25.4 6.8 33.8-3.5s6.8-25.4-3.5-33.8C428.8 126 392 112 352 112s-76.8 14-105.7 37.4c-10.3 8.3-11.9 23.5-3.5 33.8s23.5 11.9 33.8 3.5z"]
};
var faEllipsisVertical = {
  prefix: 'fas',
  iconName: 'ellipsis-vertical',
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"]
};
var faEllipsisV = faEllipsisVertical;
var faSwordLaserAlt = {
  prefix: 'fas',
  iconName: 'sword-laser-alt',
  icon: [512, 512, [], "e03c", "M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L225.1 232H330.2L505.7 40.2zM189.3 256c-12.7 0-24.9 5.1-33.9 14.1l-49 49 27.3 27.3 32 32L193 405.7 315.3 283.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H189.3zm-7.6 161L160 395.3 54.3 501l3.5 3.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5L181.7 417zM43 489.7L148.7 384 128 363.3 22.3 469 43 489.7zm-32-32L116.7 352 95 330.3 7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l3.5 3.5z"]
};
var faTicket = {
  prefix: 'fas',
  iconName: 'ticket',
  icon: [576, 512, [127903], "f145", "M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 112l0 160c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"]
};
var faPowerOff = {
  prefix: 'fas',
  iconName: 'power-off',
  icon: [512, 512, [9211], "f011", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"]
};
var faCoin = {
  prefix: 'fas',
  iconName: 'coin',
  icon: [512, 512, [129689], "f85c", "M256 352C114.6 352 0 287.5 0 208S114.6 64 256 64s256 64.5 256 144s-114.6 144-256 144zM86.6 248.2c12 11.4 27.7 20.1 44.4 26.8c33.6 13.4 77.8 21 125 21s91.4-7.6 125-21c16.7-6.7 32.4-15.4 44.4-26.8C437.5 236.7 448 220.5 448 200s-10.5-36.7-22.6-48.2c-12-11.4-27.7-20.1-44.4-26.8c-33.6-13.4-77.8-21-125-21s-91.4 7.6-125 21c-16.7 6.7-32.4 15.4-44.4 26.8C74.5 163.3 64 179.5 64 200s10.5 36.7 22.6 48.2zM96 200c0-35.3 71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64s-160-28.7-160-64zM0 290.1c13.2 15.6 29.7 29.3 48 40.9l0 63.7C17.8 373.6 0 347.9 0 320l0-29.9zM80 413l0-64.7c28.4 13.2 60.9 23 96 29l0 64.3c-36.2-6-68.9-15.9-96-28.7zm128 32.8l0-64.1c15.7 1.6 31.7 2.4 48 2.4s32.3-.8 48-2.4l0 64.1c-15.5 1.5-31.6 2.2-48 2.2s-32.5-.8-48-2.2zm128-4.1l0-64.3c35.1-6 67.6-15.9 96-29l0 64.7c-27.1 12.8-59.8 22.7-96 28.7zm128-47l0-63.7c18.3-11.5 34.8-25.2 48-40.9l0 29.9c0 27.9-17.8 53.6-48 74.6z"]
};
var faLaptopSlash = {
  prefix: 'fas',
  iconName: 'laptop-slash',
  icon: [640, 512, [], "e1c7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-14-10.9c14.3-13.9 23.2-33.4 23.2-55c0-10.6-8.6-19.2-19.2-19.2H522.2L154.8 96H512V352h64V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM128 197L64 146.6V352h64V197zM487.2 480L365.3 384H19.2C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H487.2z"]
};
var faRightLong = {
  prefix: 'fas',
  iconName: 'right-long',
  icon: [512, 512, ["long-arrow-alt-right"], "f30b", "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z"]
};
var faLongArrowAltRight = faRightLong;
var faCircleB = {
  prefix: 'fas',
  iconName: 'circle-b',
  icon: [512, 512, [], "e0fd", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C356.3 261.6 368 283.4 368 308c0 42-34 76-76 76H184c-13.3 0-24-10.7-24-24V256 152zm144 52c0-15.5-12.5-28-28-28H208v56h68c15.5 0 28-12.5 28-28zM208 336h84c15.5 0 28-12.5 28-28s-12.5-28-28-28H276 208v56z"]
};
var faPersonDressSimple = {
  prefix: 'fas',
  iconName: 'person-dress-simple',
  icon: [256, 512, [], "e21c", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM50.7 206.4c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192v80c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4z"]
};
var faPipeCollar = {
  prefix: 'fas',
  iconName: 'pipe-collar',
  icon: [512, 512, [], "e437", "M18.7 18.7c25-25 65.5-25 90.5 0L126 35.4C164.1 12.9 208.5 0 256 0s91.9 12.9 130 35.4l16.7-16.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L476.6 126c22.5 38.1 35.4 82.6 35.4 130s-12.9 91.9-35.4 130l16.7 16.7c25 25 25 65.5 0 90.5s-65.5 25-90.5 0L386 476.6C347.9 499.1 303.5 512 256 512s-91.9-12.9-130-35.4l-16.7 16.7c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5L35.4 386C12.9 347.9 0 303.5 0 256s12.9-91.9 35.4-130L18.7 109.3c-25-25-25-65.5 0-90.5zM64 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM80 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faLightsHoliday = {
  prefix: 'fas',
  iconName: 'lights-holiday',
  icon: [640, 512, [], "f7b2", "M5.4 78.2c9.8-14.7 29.6-18.7 44.3-9l0 0 .4 .3c.5 .3 1.3 .8 2.5 1.5c2.4 1.4 6.3 3.6 11.7 6.3C75 82.7 91.6 90.1 114.1 97.6C159 112.6 227.6 128 320 128s161-15.4 205.9-30.4c22.5-7.5 39.1-14.9 49.8-20.3c5.4-2.7 9.3-4.9 11.7-6.3c1.2-.7 2.1-1.2 2.5-1.5l.4-.2 0 0c0 0 0 0 .1 0c14.7-9.7 34.5-5.8 44.3 8.9c9.8 14.7 5.8 34.6-8.9 44.4L608 96c17.8 26.6 17.7 26.6 17.7 26.6l0 0-.1 0-.2 .1-.4 .3c-.3 .2-.7 .5-1.2 .8c-1 .6-2.4 1.5-4.2 2.5c-3.6 2.1-8.7 4.9-15.3 8.2c-13.3 6.6-32.7 15.2-58.2 23.7C495 175.4 419.6 192 320 192s-175-16.6-226.1-33.6c-25.5-8.5-44.9-17.1-58.2-23.7c-6.6-3.3-11.7-6.1-15.3-8.2c-1.8-1-3.2-1.9-4.2-2.5c-.5-.3-.9-.6-1.2-.8l-.4-.3-.1-.1-.1 0 0 0c0 0 0 0 17.7-26.6L14.2 122.6C-.5 112.8-4.4 93 5.4 78.2zM523.2 198.7l9.4 25.8c30.8 1.9 59 21.7 70.2 52.5c16.4 45.1-8.8 139.4-31.4 147.6s-102.5-47.8-119-92.9c-11.2-30.8-2.3-64.1 20-85.3l-12.3-33.8c23.2-4 44.2-8.7 63.1-13.8zM320 224c10.9 0 21.6-.2 32-.6v39.2c28.3 12.3 48 40.5 48 73.3c0 48-56 128-80 128s-80-80-80-128c0-32.8 19.7-61 48-73.3V223.4c10.4 .4 21.1 .6 32 .6zM179.9 212.5l-12.3 33.8c22.3 21.3 31.2 54.5 20 85.3c-16.4 45.1-96.4 101.1-119 92.9S20.8 322.1 37.3 277c11.2-30.8 39.4-50.6 70.2-52.5l9.4-25.8c18.8 5.1 39.9 9.9 63.1 13.8z"]
};
var faCitrus = {
  prefix: 'fas',
  iconName: 'citrus',
  icon: [512, 512, [], "e2f4", "M304 128h80c53 0 96-43 96-96V16c0-8.8-7.2-16-16-16H384c-53 0-96 43-96 96v16c0 8.8 7.2 16 16 16zM256 96c0-23.1 6.1-44.7 16.8-63.4c-5.5-.4-11.1-.6-16.8-.6C123.5 32 16 139.5 16 272s107.5 240 240 240s240-107.5 240-240c0-49.5-15-95.5-40.7-133.7C435 152 410.4 160 384 160H304c-26.5 0-48-21.5-48-48V96z"]
};
var faFlagUsa = {
  prefix: 'fas',
  iconName: 'flag-usa',
  icon: [448, 512, [], "f74d", "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9v32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V416 345.5 312.8 249.5 216.8 153.5 120.8 64 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLaptopFile = {
  prefix: 'fas',
  iconName: 'laptop-file',
  icon: [640, 512, [], "e51d", "M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H320V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM512 128H400c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V256H544c-17.7 0-32-14.3-32-32V128zm32 0v96h96l-96-96z"]
};
var faTty = {
  prefix: 'fas',
  iconName: 'tty',
  icon: [512, 512, ["teletype"], "f1e4", "M38.3 241.3L15.1 200.6c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4V144c-49.6-18.1-104-18.1-153.6 0v54.8c0 13.8-8.9 26.1-22 30.4L76.1 255.8c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V336zm0 96c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V432zM144 320h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V432z"]
};
var faTeletype = faTty;
var faChartTreeMap = {
  prefix: 'fas',
  iconName: 'chart-tree-map',
  icon: [512, 512, [], "e0ea", "M0 80C0 53.5 21.5 32 48 32H176c26.5 0 48 21.5 48 48V192c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM0 320c0-26.5 21.5-48 48-48H176c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V320zM304 32H464c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zM256 240c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V240zm48 112H464c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"]
};
var faDiagramNext = {
  prefix: 'fas',
  iconName: 'diagram-next',
  icon: [512, 512, [], "e476", "M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41H232V224H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H365.3l.4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4H64v64H210.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7H448z"]
};
var faPersonRifle = {
  prefix: 'fas',
  iconName: 'person-rifle',
  icon: [576, 512, [], "e54e", "M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM448 0c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 16z"]
};
var faClockFiveThirty = {
  prefix: 'fas',
  iconName: 'clock-five-thirty',
  icon: [512, 512, [], "e34a", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V335.3l20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faPipeValve = {
  prefix: 'fas',
  iconName: 'pipe-valve',
  icon: [512, 512, [], "e439", "M288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V76L128 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128-16 128 16c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 76V64zm0 84.2l-32-4-32 4V192H96V448H416V192H288V148.2zM32 160c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32zm480 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V192z"]
};
var faArrowUpFromArc = {
  prefix: 'fas',
  iconName: 'arrow-up-from-arc',
  icon: [512, 512, [], "e4b4", "M256 448C150 448 64 362 64 256c0-17.7-14.3-32-32-32s-32 14.3-32 32C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 106-86 192-192 192zM121.4 121.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 224 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0l-112 112z"]
};
var faFaceSpiralEyes = {
  prefix: 'fas',
  iconName: 'face-spiral-eyes',
  icon: [512, 512, [], "e485", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56.9-137.1l14.8-9.9c14.3-9.6 32.7-10.7 48.1-3l15.4 7.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-15.4-7.7c-5.1-2.6-11.3-2.2-16 1l-14.8 9.9c-16.1 10.7-37.1 10.7-53.3 0l-12.5-8.3c-5.4-3.6-12.4-3.6-17.8 0l-12.5 8.3c-16.1 10.7-37.1 10.7-53.3 0l-14.8-9.9c-4.8-3.2-10.9-3.6-16-1l-15.4 7.7c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l15.4-7.7c15.4-7.7 33.8-6.6 48.1 3l14.8 9.9c5.4 3.6 12.4 3.6 17.8 0l12.5-8.3c16.1-10.7 37.1-10.7 53.3 0l12.5 8.3c5.4 3.6 12.4 3.6 17.8 0zm-147-263.3c.3 6.6-4.9 12.2-11.5 12.5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-5.5-53.8 41.1-108.1 101-110.5c6.6-.3 12.2 4.9 12.5 11.5zM357.6 292c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.9-2.8-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5c-6.6 .3-12.2-4.9-12.5-11.5s4.9-12.2 11.5-12.5z"]
};
var faCompressWide = {
  prefix: 'fas',
  iconName: 'compress-wide',
  icon: [512, 512, [], "f326", "M160 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V96zM32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32H32zM416 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V96zM384 288c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H384z"]
};
var faCirclePhoneHangup = {
  prefix: 'fas',
  iconName: 'circle-phone-hangup',
  icon: [512, 512, ["phone-circle-down"], "e11d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM391.4 310c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4 .2-26.7-8.5L98.8 274.8c-4.8-7.8-3.4-17.5 3.4-23.8c84.9-78.6 222.6-78.6 307.5 0c6.8 6.3 8.2 16.1 3.4 23.8L391.4 310z"]
};
var faPhoneCircleDown = faCirclePhoneHangup;
var faGearComplexCode = {
  prefix: 'fas',
  iconName: 'gear-complex-code',
  icon: [512, 512, [], "e5eb", "M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1 .6 266.1 0 256 0c-11.1 0-22.1 .7-32.8 2.1c-10.3 1.3-18 9.7-19.3 20l-2.9 23.1c-.8 6.4-5.4 11.6-11.5 13.7c-9.6 3.2-19 7.2-27.9 11.7c-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4c-16.6 13-31.5 28-44.4 44.7c-6.3 8.2-5.9 19.6 .5 27.8l14.2 18.3c4 5.1 4.4 12 1.5 17.8c-4.4 8.8-8.2 17.9-11.3 27.4c-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6 .6 21.1 1.9 31.4c1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4 .8 11.7 5.4 13.7 11.6c3.1 9.5 6.9 18.7 11.3 27.5c2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8c12.9 16.7 27.8 31.7 44.4 44.7c8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5c9 4.6 18.3 8.5 27.9 11.7c6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20c10.7 1.4 21.7 2.1 32.8 2.1c10.1 0 20.1-.6 29.9-1.7c10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8c10-3.2 19.7-7.2 29-11.8c5.8-2.9 12.7-2.4 17.8 1.5L385 457.9c8.2 6.4 19.6 6.8 27.8 .5c2.8-2.2 5.5-4.4 8.2-6.7L451.7 421c1.8-2.2 3.6-4.4 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18c4.8-9.4 9-19.3 12.3-29.5c2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4c.2-1.7 .4-3.5 .6-5.2V230.1c-.2-1.7-.4-3.5-.6-5.2c-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6c-3.4-10.2-7.5-20.1-12.3-29.5c-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7 .4-27.9c-1.8-2.2-3.6-4.4-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7c-8.2-6.4-19.6-5.9-27.8 .5L366.7 68.3c-5.1 4-12.1 4.4-17.8 1.5c-9.3-4.6-19-8.6-29-11.8c-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zM287.8 162.6l-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM187.3 227.3L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm160-22.6l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 256l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faHouseMedicalCircleExclamation = {
  prefix: 'fas',
  iconName: 'house-medical-circle-exclamation',
  icon: [640, 512, [], "e512", "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faBadminton = {
  prefix: 'fas',
  iconName: 'badminton',
  icon: [576, 512, [], "e33a", "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3c40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-54.4 54.4-131.9 78.7-198.2 61.7c-29.4-7.5-62.9-5.5-84.3 16L148.3 409c6.4 12.1 4.5 27.4-5.6 37.6l-56 56c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l56-56c10.2-10.2 25.5-12.1 37.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84C129.8 250.9 128 236 128 221c0-54.2 23.4-110.5 66.9-154zM464 400c0-26.5 21.5-48 48-48s48 21.5 48 48v32H464V400zm-15.3 91.4l13-43.4h33.4l-15.8 52.6c-2.5 8.5-11.5 13.3-19.9 10.7s-13.3-11.5-10.7-19.9zM496 496V448h32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16zm48.7 4.6L528.9 448h33.4l13 43.4c2.5 8.5-2.3 17.4-10.7 19.9s-17.4-2.3-19.9-10.7z"]
};
var faClosedCaptioning = {
  prefix: 'fas',
  iconName: 'closed-captioning',
  icon: [576, 512, [], "f20a", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"]
};
var faPersonHiking = {
  prefix: 'fas',
  iconName: 'person-hiking',
  icon: [384, 512, ["hiking"], "f6ec", "M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H336V184c0-13.3 10.7-24 24-24s24 10.7 24 24v55.8c0 .1 0 .2 0 .2s0 .2 0 .2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H296.6c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z"]
};
var faHiking = faPersonHiking;
var faRightFromLine = {
  prefix: 'fas',
  iconName: 'right-from-line',
  icon: [448, 512, ["arrow-alt-from-left"], "f347", "M313.9 105.9L436.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L313.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM64 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32z"]
};
var faArrowAltFromLeft = faRightFromLine;
var faVenusDouble = {
  prefix: 'fas',
  iconName: 'venus-double',
  icon: [640, 512, [9890], "f226", "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1c-26.6-4.9-51.1-15.7-72-31.1z"]
};
var faImages = {
  prefix: 'fas',
  iconName: 'images',
  icon: [576, 512, [], "f302", "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faCalculator = {
  prefix: 'fas',
  iconName: 'calculator',
  icon: [384, 512, [128425], "f1ec", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faShuttlecock = {
  prefix: 'fas',
  iconName: 'shuttlecock',
  icon: [512, 512, [], "f45b", "M320 32c0 8.8-7.2 16-16 16c-24.4 0-46 15.8-53.4 39.1l-29.3 92.8c-1.3 4.1-4.2 7.6-8.1 9.5l-32.4 16.2c-3.1 1.5-5.6 4.1-7.2 7.2l-32.5 64.9c-3.1 6.2-1.9 13.6 3 18.5L163 315l71.9-71.9L281.1 96.8C284.3 86.8 293.5 80 304 80H408c13.3 0 24 10.7 24 24V208c0 10.5-6.8 19.7-16.8 22.9L268.8 277.1 197 349l18.9 18.9c4.9 4.9 12.3 6.1 18.5 3l64.9-32.5c3.1-1.5 5.6-4.1 7.2-7.2l16.2-32.4c1.9-3.9 5.4-6.8 9.5-8.1l92.8-29.3c23.3-7.4 39.1-29 39.1-53.4c0-8.8 7.2-16 16-16h8c13.3 0 24 10.7 24 24v51.7c0 12.4-7.2 23.7-18.4 29L250.1 411.2c-6.7 3.1-12.8 7.4-18 12.7l-28.8 28.8-144-144 28.8-28.8c5.2-5.2 9.5-11.3 12.7-18L215.4 18.4C220.6 7.2 231.9 0 244.3 0H296c13.3 0 24 10.7 24 24v8zM36.7 331.3l144 144-6.9 6.9c-19.1 19.1-45 29.8-72 29.8C45.6 512 0 466.4 0 410.2c0-27 10.7-52.9 29.8-72l6.9-6.9z"]
};
var faUserHair = {
  prefix: 'fas',
  iconName: 'user-hair',
  icon: [448, 512, [], "e45a", "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32zM96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0S96 57.3 96 128zm65.3 192C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320H161.3z"]
};
var faEyeEvil = {
  prefix: 'fas',
  iconName: 'eye-evil',
  icon: [640, 512, [], "f6db", "M254.9 112.2c-10.7 2.8-21.1 6.3-30.9 10.4L114.4 76.1c-8.7-3.7-18.7-1-24.4 6.5s-5.5 17.9 .4 25.2l57.3 70.8c-7 9-12.8 18.6-17.3 28.6L15.5 236.1C6.4 238.4 0 246.6 0 256s6.4 17.6 15.5 19.9l114.9 28.7c4.5 10.1 10.3 19.7 17.3 28.6L90.4 404.1c-5.9 7.3-6.1 17.7-.4 25.2s15.7 10.2 24.4 6.5L224 389.4c9.8 4.1 20.1 7.6 30.9 10.4l42.7 97.6c3.9 8.9 12.7 14.7 22.4 14.7s18.5-5.8 22.4-14.7l42.7-97.6c10.7-2.8 21.1-6.3 30.9-10.4l109.7 46.5c8.7 3.7 18.7 1 24.4-6.5s5.5-17.9-.4-25.2l-57.3-70.8c7-9 12.8-18.6 17.3-28.6l114.9-28.7c9.1-2.3 15.5-10.5 15.5-19.9s-6.4-17.6-15.5-19.9L509.6 207.4c-4.5-10.1-10.3-19.7-17.3-28.6l57.3-70.8c5.9-7.3 6.1-17.7 .4-25.2s-15.7-10.2-24.4-6.5L416 122.6c-9.8-4.1-20.1-7.6-30.9-10.4L342.4 14.7C338.5 5.8 329.7 0 320 0s-18.5 5.8-22.4 14.7l-42.7 97.6zM320 352c-53 0-96-43-96-96c0-19.7 6-38.1 16.2-53.3c16.6 9.6 35 16.2 54.7 19.3c-3.9 9.4-6.8 20.8-6.8 34c0 31.5 16.5 52.7 23.8 60.6c2.1 2.3 5.1 3.4 8.2 3.4s6.1-1.1 8.2-3.4c7.3-7.9 23.8-29.2 23.8-60.6c0-13.2-2.9-24.6-6.8-34c19.6-3.1 38.1-9.8 54.7-19.3C410 217.9 416 236.3 416 256c0 53-43 96-96 96z"]
};
var faPeoplePulling = {
  prefix: 'fas',
  iconName: 'people-pulling',
  icon: [576, 512, [], "e535", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128H64zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"]
};
var faN = {
  prefix: 'fas',
  iconName: 'n',
  icon: [384, 512, [110], "4e", "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 50.5 8.4 38.5 21.1 33.9z"]
};
var faGarage = {
  prefix: 'fas',
  iconName: 'garage',
  icon: [640, 512, [], "e009", "M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3zM128 224v96H512V224H128zm0 128V512H512V352H128zm128 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16z"]
};
var faCableCar = {
  prefix: 'fas',
  iconName: 'cable-car',
  icon: [512, 512, [128673, 57551, "tram"], "f7da", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 56a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 288c0-35.3 28.7-64 64-64H232V157.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5V224H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352z"]
};
var faTram = faCableCar;
var faShovelSnow = {
  prefix: 'fas',
  iconName: 'shovel-snow',
  icon: [512, 512, [], "f7c3", "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-31.4 31.4c-15.1 15.1-35.6 23.6-57 23.6c-13.5 0-26.2-3.3-37.4-9.2l-83.5 83.5 47 47c11.3 11.3 12.5 29.1 3 41.8l-120 160c-5.6 7.4-14.1 12.1-23.3 12.7s-18.3-2.7-24.9-9.3l-168-168C2.8 328.1-.6 319 .1 309.7s5.3-17.8 12.7-23.3l160-120c12.7-9.6 30.6-8.3 41.8 3l47 47 83.5-83.5c-5.9-11.2-9.2-23.9-9.2-37.4c0-21.4 8.5-41.9 23.6-57L391 7zm17 50.9L393.5 72.4c-6.1 6.1-9.5 14.4-9.5 23c0 18 14.6 32.6 32.6 32.6c8.6 0 16.9-3.4 23-9.5L454.1 104 408 57.9zM203.3 267.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80zm64 64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80z"]
};
var faCloudRain = {
  prefix: 'fas',
  iconName: 'cloud-rain',
  icon: [512, 512, [127783, 9926], "f73d", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z"]
};
var faFaceLying = {
  prefix: 'fas',
  iconName: 'face-lying',
  icon: [512, 512, [], "e37e", "M494 350.5c-4.5 1-9.2 1.5-14 1.5H352c-8.8 0-16-7.2-16-16s7.2-16 16-16H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-8.8 0-16-7.2-16-16s7.2-16 16-16H480c11.2 0 21.7 2.9 30.9 7.9C498.8 101.8 389.3 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c108 0 200.4-66.9 238-161.5zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM188.8 393.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4C180.7 351.1 208.6 336 240 336c13.6 0 26.6 2.8 38.4 8c8.1 3.5 11.8 13 8.3 21.1s-13 11.8-21.1 8.3c-7.8-3.4-16.5-5.3-25.6-5.3c-20.9 0-39.5 10-51.2 25.6z"]
};
var faSprinkler = {
  prefix: 'fas',
  iconName: 'sprinkler',
  icon: [512, 512, [], "e035", "M24 0a24 24 0 1 1 0 48A24 24 0 1 1 24 0zM0 128a24 24 0 1 1 48 0A24 24 0 1 1 0 128zM0 232a24 24 0 1 1 48 0A24 24 0 1 1 0 232zM64 72a24 24 0 1 1 48 0A24 24 0 1 1 64 72zm24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm360 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM488 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM448 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-40-32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 64c17.7 0 32 14.3 32 32V256H388.2c15.3 0 27.8 12.4 27.8 27.8c0 7.8-3.3 15.2-9 20.5L320 384v96c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V384l-87-79.7c-5.7-5.3-9-12.7-9-20.5c0-15.3 12.4-27.8 27.8-27.8H224V96c0-17.7 14.3-32 32-32z"]
};
var faBuildingCircleXmark = {
  prefix: 'fas',
  iconName: 'building-circle-xmark',
  icon: [640, 512, [], "e4d4", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPersonSledding = {
  prefix: 'fas',
  iconName: 'person-sledding',
  icon: [512, 512, ["sledding"], "f7cb", "M400 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM35.1 226.7c-11.8-6.1-26.3-1.5-32.4 10.2s-1.5 26.3 10.2 32.4L396.4 468.4c27.3 14.2 59.7 14.4 87.2 .7l15.2-7.6c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-15.2 7.6c-13.7 6.9-29.9 6.7-43.6-.3l-41.7-21.6c4.5-5.5 7.2-12.5 7.2-20.2V304c0-26.5-21.5-48-48-48H301.3L361 196.3c25.2-25.2 7.4-68.3-28.3-68.3H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h84l-59.2 40.3c-23.6 16.1-26 44.8-13.8 64.9L35.1 226.7zM320 320v54.6L214.7 320H320z"]
};
var faSledding = faPersonSledding;
var faGameConsoleHandheld = {
  prefix: 'fas',
  iconName: 'game-console-handheld',
  icon: [384, 512, [], "f8bb", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V64zM96 80V192c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM232 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 304v16H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H96v16c0 8.8 7.2 16 16 16s16-7.2 16-16V352h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H128V304c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faShip = {
  prefix: 'fas',
  iconName: 'ship',
  icon: [576, 512, [128674], "f21a", "M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faClockSixThirty = {
  prefix: 'fas',
  iconName: 'clock-six-thirty',
  icon: [512, 512, [], "e353", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V256c0-13.3-10.7-24-24-24s-24 10.7-24 24V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faBatterySlash = {
  prefix: 'fas',
  iconName: 'battery-slash',
  icon: [640, 512, [], "f377", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6C563.1 386 576 362.5 576 336V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H154.8L38.8 5.1zM236.4 160H496c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H481.4l-245-192zm88.5 192H112c-8.8 0-16-7.2-16-16V176c0-1.4 .2-2.7 .5-4L45.4 131.7C36.9 144.4 32 159.6 32 176V336c0 44.2 35.8 80 80 80H406.2l-81.2-64z"]
};
var faTugrikSign = {
  prefix: 'fas',
  iconName: 'tugrik-sign',
  icon: [384, 512, [], "e2ba", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V199L56.2 225c-17.1 4.3-27.6 21.7-23.3 38.8s21.7 27.6 38.8 23.3L160 265v30L56.2 321c-17.1 4.3-27.6 21.7-23.3 38.8s21.7 27.6 38.8 23.3L160 361v87c0 17.7 14.3 32 32 32s32-14.3 32-32V345L327.8 319c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3L224 279V249L327.8 223c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3L224 183V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"]
};
var faArrowsDownToLine = {
  prefix: 'fas',
  iconName: 'arrows-down-to-line',
  icon: [576, 512, [], "e4b8", "M544 416L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7 480 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L54.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"]
};
var faDownload = {
  prefix: 'fas',
  iconName: 'download',
  icon: [512, 512, [], "f019", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faShelves = {
  prefix: 'fas',
  iconName: 'shelves',
  icon: [640, 512, ["inventory"], "f480", "M32 0C49.7 0 64 14.3 64 32V160H576V32c0-17.7 14.3-32 32-32s32 14.3 32 32V192 448v32c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32V448 192 32C0 14.3 14.3 0 32 0zM64 416H576V224H64V416zM352 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V32zM128 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32zm160 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32z"]
};
var faInventory = faShelves;
var faCloudSnow = {
  prefix: 'fas',
  iconName: 'cloud-snow',
  icon: [512, 512, [127784], "f742", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM64 352c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H88v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H40V376c0-13.3 10.7-24 24-24zm192 32c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V408c0-13.3 10.7-24 24-24zm216-8v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H472v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440H408c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V376c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFaceGrin = {
  prefix: 'fas',
  iconName: 'face-grin',
  icon: [512, 512, [128512, "grin"], "f580", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGrin = faFaceGrin;
var faDeleteLeft = {
  prefix: 'fas',
  iconName: 'delete-left',
  icon: [576, 512, [9003, "backspace"], "f55a", "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faBackspace = faDeleteLeft;
var faOven = {
  prefix: 'fas',
  iconName: 'oven',
  icon: [448, 512, [], "e01d", "M0 96v64H448V96c0-53-43-96-96-96H96C43 0 0 43 0 96zM56 80a24 24 0 1 1 48 0A24 24 0 1 1 56 80zM176 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm16 200V448H64l0-192H384zM64 192H0v64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256 192H384 64zm48 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faCloudBinary = {
  prefix: 'fas',
  iconName: 'cloud-binary',
  icon: [640, 512, [], "e601", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm16-280v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm88-16c0 8.8 7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm136-16c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H424zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V200zM176 320c0 8.8 7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm96 24v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V344c0-22.1-17.9-40-40-40H312c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8zm104-32c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16H416z"]
};
var faEyeDropper = {
  prefix: 'fas',
  iconName: 'eye-dropper',
  icon: [512, 512, ["eye-dropper-empty", "eyedropper"], "f1fb", "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"]
};
var faEyeDropperEmpty = faEyeDropper;
var faEyedropper = faEyeDropper;
var faCommentCaptions = {
  prefix: 'fas',
  iconName: 'comment-captions',
  icon: [512, 512, [], "e146", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM120 208H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm224 0h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24s10.7-24 24-24zM120 288h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm128 0H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCommentsQuestion = {
  prefix: 'fas',
  iconName: 'comments-question',
  icon: [640, 512, [], "e14e", "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM136.2 108.4l-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4h48.5c7 0 12.6 5.7 12.6 12.6c0 4.5-2.4 8.7-6.3 10.9L198 162.1c-6.2 3.6-10 10.2-10 17.3v11.2c0 11 9 20 20 20c10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6c0-29.1-23.6-52.6-52.6-52.6H180.2c-19.8 0-37.4 12.4-44 31.1zM234.7 264a26.7 26.7 0 1 0 -53.3 0 26.7 26.7 0 1 0 53.3 0z"]
};
var faScribble = {
  prefix: 'fas',
  iconName: 'scribble',
  icon: [512, 512, [], "e23f", "M170 23.3C186.5 8.3 208 0 230.3 0h1.1C280.3 0 320 39.7 320 88.6c0 23.5-9.3 46-25.9 62.6L103.2 342.1c-4.6 4.6-7.2 10.9-7.2 17.4C96 373 107 384 120.6 384c6.5 0 12.8-2.6 17.4-7.2L360.8 153.9c16.6-16.6 39.1-25.9 62.6-25.9c48.9 0 88.6 39.7 88.6 88.6c0 23.5-9.3 46-25.9 62.6l-88.2 88.2c-8.8 8.8-13.8 20.9-13.8 33.4c0 26 21.1 47.1 47 47.1c6.2 0 12.4-1.5 18-4.2l16.7-8.4c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L477.6 501c-14.5 7.2-30.4 11-46.6 11c-61.4 0-111-49.9-111-111.1c0-29.5 11.7-57.8 32.6-78.7l88.2-88.2c4.6-4.6 7.2-10.9 7.2-17.4c0-13.6-11-24.6-24.6-24.6c-6.5 0-12.8 2.6-17.4 7.2L183.2 422.1c-16.6 16.6-39.1 25.9-62.6 25.9C71.7 448 32 408.3 32 359.4c0-23.5 9.3-46 25.9-62.6L248.8 105.9c4.6-4.6 7.2-10.9 7.2-17.4C256 75 245 64 231.4 64h-1.1c-6.4 0-12.6 2.4-17.3 6.7L53.5 215.7c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2L170 23.3z"]
};
var faRotateExclamation = {
  prefix: 'fas',
  iconName: 'rotate-exclamation',
  icon: [512, 512, [], "e23c", "M74.9 192L46.1 178.2c-7.6 15.9-.9 35 15 42.7s35 .9 42.7-15l0 0 0 0 0-.1 .2-.3 .7-1.5c.6-1.3 1.6-3.2 2.8-5.6c2.5-4.8 5.9-11.4 10-18.5c8.7-15.3 18.2-29.8 25.3-36.9c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0c-13.8 13.8-27 35.2-35.7 50.6c-4.6 8.2-8.6 15.6-11.3 21c-1.4 2.7-2.5 4.9-3.3 6.5l-.9 1.8-.2 .5-.1 .2 0 0 0 0 0 0s0 0 28.9 13.8zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM48 464c17.7 0 32-14.3 32-32V396.8l17.6 17.6c87.5 87.5 229.3 87.5 316.8 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0L125.7 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32V432c0 17.7 14.3 32 32 32z"]
};
var faFileCircleCheck = {
  prefix: 'fas',
  iconName: 'file-circle-check',
  icon: [576, 512, [], "e5a0", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faGlass = {
  prefix: 'fas',
  iconName: 'glass',
  icon: [384, 512, [129371], "f804", "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM70.9 128L66.4 64H317.6l-4.6 64H70.9z"]
};
var faLoader = {
  prefix: 'fas',
  iconName: 'loader',
  icon: [512, 512, [], "e1d4", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32zm0 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416zM0 256c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm416-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H416zM75 75c-12.5 12.5-12.5 32.8 0 45.3l45.3 45.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L120.2 75C107.7 62.5 87.5 62.5 75 75zM391.8 346.5c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L391.8 437c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-45.3-45.3zM75 437c12.5 12.5 32.8 12.5 45.3 0l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L75 391.8c-12.5 12.5-12.5 32.8 0 45.3zM346.5 120.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L437 120.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-45.3 45.3z"]
};
var faForward = {
  prefix: 'fas',
  iconName: 'forward',
  icon: [512, 512, [9193], "f04e", "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V256v41.7L52.5 440.6zM256 352V256 128 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V352z"]
};
var faUserPilot = {
  prefix: 'fas',
  iconName: 'user-pilot',
  icon: [448, 512, [], "e2c0", "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM161.7 72.8c4-7.9 13.6-11.1 21.5-7.2L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5zm-63.6 96C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zm116.3 240l-72.3-54.2c-2.2-1.7-4.9-2.6-7.7-2.6C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352c-2.8 0-5.5 .9-7.7 2.6l-72.3 54.2c-5.7 4.3-13.5 4.3-19.2 0zM336 416h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMobile = {
  prefix: 'fas',
  iconName: 'mobile',
  icon: [384, 512, [128241, "mobile-android", "mobile-phone"], "f3ce", "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMobileAndroid = faMobile;
var faMobilePhone = faMobile;
var faCodePullRequestClosed = {
  prefix: 'fas',
  iconName: 'code-pull-request-closed',
  icon: [512, 512, [], "e3f9", "M329.4 9.4c12.5-12.5 32.8-12.5 45.3 0L400 34.7 425.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L445.3 80l25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L400 125.3l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L354.7 80 329.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zM136 80A24 24 0 1 0 88 80a24 24 0 1 0 48 0zm56 0c0 32.8-19.7 61-48 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C51.7 141 32 112.8 32 80C32 35.8 67.8 0 112 0s80 35.8 80 80zM112 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm288 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 56c-44.2 0-80-35.8-80-80c0-32.8 19.7-61 48-73.3V224c0-17.7 14.3-32 32-32s32 14.3 32 32V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80z"]
};
var faFaceMeh = {
  prefix: 'fas',
  iconName: 'face-meh',
  icon: [512, 512, [128528, "meh"], "f11a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMeh = faFaceMeh;
var faAlignCenter = {
  prefix: 'fas',
  iconName: 'align-center',
  icon: [448, 512, [], "f037", "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"]
};
var faBookSkull = {
  prefix: 'fas',
  iconName: 'book-skull',
  icon: [448, 512, ["book-dead"], "f6b7", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V163.2c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"]
};
var faBookDead = faBookSkull;
var faIdCard = {
  prefix: 'fas',
  iconName: 'id-card',
  icon: [576, 512, [62147, "drivers-license"], "f2c2", "M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"]
};
var faDriversLicense = faIdCard;
var faFaceDotted = {
  prefix: 'fas',
  iconName: 'face-dotted',
  icon: [512, 512, [129765], "e47f", "M216 3.1C229 1.1 242.4 0 256 0s27 1.1 40 3.1c17.5 2.7 29.4 19.1 26.6 36.6s-19.1 29.4-36.6 26.6C276.3 64.8 266.3 64 256 64s-20.3 .8-30.1 2.3c-17.5 2.7-33.8-9.2-36.6-26.6S198.5 5.9 216 3.1zM150.2 55.9c10.4 14.3 7.2 34.3-7 44.7c-16.3 11.9-30.7 26.2-42.5 42.5c-10.4 14.3-30.4 17.4-44.7 7s-17.4-30.4-7-44.7c15.8-21.7 34.9-40.8 56.6-56.6c14.3-10.4 34.3-7.2 44.7 7zm211.6 0c10.4-14.3 30.4-17.4 44.7-7c21.7 15.8 40.8 34.9 56.6 56.6c10.4 14.3 7.2 34.3-7 44.7s-34.3 7.2-44.7-7c-11.9-16.3-26.2-30.7-42.5-42.5c-14.3-10.4-17.4-30.4-7-44.7zM472.3 189.3c17.5-2.7 33.8 9.2 36.6 26.6c2.1 13.1 3.1 26.4 3.1 40s-1.1 27-3.1 40c-2.7 17.5-19.1 29.4-36.6 26.6s-29.4-19.1-26.6-36.6c1.5-9.8 2.3-19.8 2.3-30.1s-.8-20.3-2.3-30.1c-2.7-17.5 9.2-33.8 26.6-36.6zm-432.6 0c17.5 2.7 29.4 19.1 26.6 36.6C64.8 235.7 64 245.7 64 256s.8 20.3 2.3 30.1c2.7 17.5-9.2 33.8-26.6 36.6S5.9 313.5 3.1 296C1.1 283 0 269.6 0 256s1.1-27 3.1-40c2.7-17.5 19.1-29.4 36.6-26.6zM55.9 361.8c14.3-10.4 34.3-7.2 44.7 7c11.9 16.3 26.2 30.7 42.5 42.5c14.3 10.4 17.4 30.4 7 44.7s-30.4 17.4-44.7 7c-21.7-15.8-40.8-34.9-56.6-56.6c-10.4-14.3-7.2-34.3 7-44.7zm400.1 0c14.3 10.4 17.4 30.4 7 44.7c-15.8 21.7-34.9 40.8-56.6 56.6c-14.3 10.4-34.3 7.2-44.7-7s-7.2-34.3 7-44.7c16.3-11.9 30.7-26.2 42.5-42.5c10.4-14.3 30.4-17.4 44.7-7zM189.3 472.3c2.7-17.5 19.1-29.4 36.6-26.6c9.8 1.5 19.8 2.3 30.1 2.3s20.3-.8 30.1-2.3c17.5-2.7 33.8 9.2 36.6 26.6s-9.2 33.8-26.6 36.6c-13.1 2.1-26.4 3.1-40 3.1s-27-1.1-40-3.1c-17.5-2.7-29.4-19.1-26.6-36.6zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM184 328H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faFaceWorried = {
  prefix: 'fas',
  iconName: 'face-worried',
  icon: [512, 512, [], "e3a3", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-73.6-97.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faOutdent = {
  prefix: 'fas',
  iconName: 'outdent',
  icon: [448, 512, ["dedent"], "f03b", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6V335.3c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"]
};
var faDedent = faOutdent;
var faHeartCircleExclamation = {
  prefix: 'fas',
  iconName: 'heart-circle-exclamation',
  icon: [576, 512, [], "e4fe", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faHouse = {
  prefix: 'fas',
  iconName: 'house',
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
};
var faHome = faHouse;
var faHomeAlt = faHouse;
var faHomeLgAlt = faHouse;
var faVectorCircle = {
  prefix: 'fas',
  iconName: 'vector-circle',
  icon: [512, 512, [], "e2c6", "M192 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v9.3C392.2 62.8 449.2 119.8 470.7 192H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-9.3C449.2 392.2 392.2 449.2 320 470.7V480c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32v-9.3C119.8 449.2 62.8 392.2 41.3 320H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h9.3C62.8 119.8 119.8 62.8 192 41.3V32zM403.7 194.4c-16.2-38.9-47.3-70-86.2-86.2C312.7 119.9 301.3 128 288 128H224c-13.3 0-24.7-8.1-29.6-19.7c-38.9 16.2-70 47.3-86.2 86.2c11.6 4.8 19.7 16.2 19.7 29.6v64c0 13.3-8.1 24.7-19.7 29.6c16.2 38.9 47.3 70 86.2 86.2c4.8-11.6 16.2-19.7 29.6-19.7h64c13.3 0 24.7 8.1 29.6 19.7c38.9-16.2 70-47.3 86.2-86.2C392.1 312.7 384 301.3 384 288V224c0-13.3 8.1-24.7 19.7-29.6zM240 48V80h32V48H240zm32 384H240v32h32V432zM432 240v32h32V240H432zM80 240H48v32H80V240z"]
};
var faCarCircleBolt = {
  prefix: 'fas',
  iconName: 'car-circle-bolt',
  icon: [640, 512, [], "e342", "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l34.1 97.4C385.8 205.7 320 279.2 320 368c0 10.9 1 21.6 2.9 32H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm368-64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H516.4l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
var faCalendarWeek = {
  prefix: 'fas',
  iconName: 'calendar-week',
  icon: [448, 512, [], "f784", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"]
};
var faFlyingDisc = {
  prefix: 'fas',
  iconName: 'flying-disc',
  icon: [640, 512, [], "e3a9", "M119.7 456.3c-25.2-25.2-29.6-66.7-16.5-114.9c3.2 9.5 8.4 18.5 16.2 26.3c15.6 15.6 36 20.7 55 20.5c18.9-.1 38.8-5.3 58.2-13.3c39-16.1 82-46 121.2-85.1s69-82.2 85.1-121.2c8-19.4 13.2-39.4 13.3-58.2c.1-19-5-39.5-20.5-55c-7.8-7.8-16.8-13-26.3-16.2c48.2-13 89.8-8.6 114.9 16.6c55.3 55.3 10.5 189.8-100.2 300.5S175 511.6 119.7 456.3zM331.1 267.1C257.4 340.9 172.7 375.8 141.9 345s4.1-115.4 77.9-189.2S378.3 47.2 409 77.9s-4.1 115.4-77.9 189.2z"]
};
var faLaptopMedical = {
  prefix: 'fas',
  iconName: 'laptop-medical',
  icon: [640, 512, [], "f812", "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V272H240c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"]
};
var faSquareDownRight = {
  prefix: 'fas',
  iconName: 'square-down-right',
  icon: [448, 512, [], "e26c", "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384zM320 198.6V336c0 8.8-7.2 16-16 16H166.6c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L184 280l-66.3-66.3C114 210 112 205.1 112 200s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6z"]
};
var faB = {
  prefix: 'fas',
  iconName: 'b',
  icon: [320, 512, [98], "42", "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H192c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128H64zm96 192H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288h96 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z"]
};
var faSeatAirline = {
  prefix: 'fas',
  iconName: 'seat-airline',
  icon: [448, 512, [], "e244", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V143.6c0 15.2 3.1 30.2 9.1 44.1L82 357.8c15.1 35.3 49.8 58.2 88.2 58.2H216v48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H264V416h96c15.1 0 29.3-7.1 38.4-19.2l43.2-57.6c7.3-9.7 8.4-22.7 3-33.5S428.1 288 416 288H121.7L108 256H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H80.5L67.9 162.5c-2.6-6-3.9-12.4-3.9-18.9V32z"]
};
var faMoonOverSun = {
  prefix: 'fas',
  iconName: 'moon-over-sun',
  icon: [512, 512, ["eclipse-alt"], "f74a", "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM400 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-258 0c0-63.1 51.6-114 115-114c3.3 0 6.5 .1 9.7 .4c7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-22.9 12.8-38.3 37.1-38.3 64.8c0 41 33.6 74.5 75.4 74.5c4.4 0 8.8-.4 13-1.1c6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-20.7 19.9-49 32.2-80.1 32.2c-63.4 0-115-50.9-115-114z"]
};
var faEclipseAlt = faMoonOverSun;
var faPipe = {
  prefix: 'fas',
  iconName: 'pipe',
  icon: [64, 512, [], "7c", "M32 0C49.7 0 64 14.3 64 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32C0 14.3 14.3 0 32 0z"]
};
var faFileMedical = {
  prefix: 'fas',
  iconName: 'file-medical',
  icon: [384, 512, [], "f477", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"]
};
var faPotato = {
  prefix: 'fas',
  iconName: 'potato',
  icon: [512, 512, [129364], "e440", "M466.3 249.2C494.4 222.9 512 185.5 512 144C512 64.5 447.5 0 368 0c-39.8 0-75.9 16.2-102 42.3C238.6 69.8 205 95 170.9 113.6c-24.1 13.2-44 33.1-57.3 57.3C95 205 69.8 238.6 42.3 266C16.2 292.1 0 328.2 0 368c0 79.5 64.5 144 144 144c30.3 0 58.4-9.3 81.5-25.3c28.1-19.3 60.2-35.3 92.5-46.2c44.1-14.9 80.1-50.9 93.1-99.2c9.2-34.2 29.4-67.9 55.2-92.1zM384 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM136 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faDiceOne = {
  prefix: 'fas',
  iconName: 'dice-one',
  icon: [448, 512, [9856], "f525", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleA = {
  prefix: 'fas',
  iconName: 'circle-a',
  icon: [512, 512, [], "e0f7", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L321.2 320H190.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L214.8 272h82.3L256 189.7z"]
};
var faHelmetBattle = {
  prefix: 'fas',
  iconName: 'helmet-battle',
  icon: [576, 512, [], "f6eb", "M80 17.1c.6-8.3-5.3-15.7-13.6-17s-16.1 4.1-18 12.2L.8 218.8c-.5 2.2-.8 4.5-.8 6.8C0 242.4 13.6 256 30.4 256h2.2c17.1 0 31.3-13.2 32.5-30.2L80 17.1zM320 352V488c0 18.4 20.8 30.1 36.5 20.5l144-88c9.2-5.6 13.5-16.7 10.6-27.1C494.1 333.6 480 270.2 480 208c0-85-89.1-149.2-153.1-189c-1.9-1.2-4-2.6-6.3-4.1l0 0C311.2 8.4 298.7 0 288 0s-23.2 8.4-32.7 14.9c-2.3 1.5-4.4 3-6.3 4.1C185.1 58.8 96 123 96 208c0 62.2-14.1 125.6-31.1 185.4c-3 10.4 1.4 21.4 10.6 27.1l144 88c15.7 9.6 36.5-2.1 36.5-20.5V296h0V267.5c0-6.9-4.4-13-10.9-15.2l-72.3-24.1c-7.6-2.5-12.7-9.6-12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H397.4c10.3 0 18.6 8.3 18.6 18.6c0 8-5.1 15.1-12.7 17.6l-72.3 24.1c-6.5 2.2-10.9 8.3-10.9 15.2V352h0zM509.6 .2c-8.3 1.2-14.2 8.6-13.6 17l14.9 208.6c1.2 17 15.4 30.2 32.5 30.2h2.2c16.8 0 30.4-13.6 30.4-30.4c0-2.3-.3-4.6-.8-6.8L527.6 12.4c-1.9-8.1-9.7-13.5-18-12.2z"]
};
var faButter = {
  prefix: 'fas',
  iconName: 'butter',
  icon: [640, 512, [129480], "e3e4", "M64 128c0-35.3 28.7-64 64-64H448V288H64V128zM32 320H608c17.7 0 32 14.3 32 32s-14.3 32-32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384c-17.7 0-32-14.3-32-32s14.3-32 32-32zM512 64c35.3 0 64 28.7 64 64V288H480V64h32z"]
};
var faBlanketFire = {
  prefix: 'fas',
  iconName: 'blanket-fire',
  icon: [640, 512, [], "e3da", "M0 128V352c0 70.7 57.3 128 128 128H337.6c-16.5-18.6-29.6-40.3-38.1-64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64H301.8c6.3-15.5 14.4-30.8 23.3-45.3c21.7-35.2 51.9-71.2 87.3-102.8c10-8.9 23-12.8 35.5-11.7V128c0-53-43-96-96-96H96C43 32 0 75 0 128zM288 350.1c0-9.8 1.3-19.9 3.6-30.1H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H291c-2-11.1-3-22.4-3-33.9zM453.5 163.8c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 433c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faKiwiBird = {
  prefix: 'fas',
  iconName: 'kiwi-bird',
  icon: [576, 512, [], "f535", "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3V224c0-70.7-57.3-128-128-128H392.3c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V410c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24V405.1c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCastle = {
  prefix: 'fas',
  iconName: 'castle',
  icon: [640, 512, [], "e0de", "M128 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h48V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h48V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v96V224h64V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v96V464c0 26.5-21.5 48-48 48H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64V512H48c-26.5 0-48-21.5-48-48V272 176c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16v48h64V112 16z"]
};
var faGolfClub = {
  prefix: 'fas',
  iconName: 'golf-club',
  icon: [512, 512, [], "f451", "M508.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L264 392.5l0-.5L42.1 318C21.4 311.1 0 326.6 0 348.4V376H48c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v32H48c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v8c0 17.7 14.3 32 32 32H255.3c12 .3 23.6-6.3 29.3-17.7l224-448z"]
};
var faArrowRightArrowLeft = {
  prefix: 'fas',
  iconName: 'arrow-right-arrow-left',
  icon: [448, 512, [8644, "exchange"], "f0ec", "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"]
};
var faExchange = faArrowRightArrowLeft;
var faRotateRight = {
  prefix: 'fas',
  iconName: 'rotate-right',
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"]
};
var faRedoAlt = faRotateRight;
var faRotateForward = faRotateRight;
var faUtensils = {
  prefix: 'fas',
  iconName: 'utensils',
  icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"]
};
var faCutlery = faUtensils;
var faArrowUpWideShort = {
  prefix: 'fas',
  iconName: 'arrow-up-wide-short',
  icon: [576, 512, ["sort-amount-up"], "f161", "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z"]
};
var faSortAmountUp = faArrowUpWideShort;
var faChartPieSimpleCircleDollar = {
  prefix: 'fas',
  iconName: 'chart-pie-simple-circle-dollar',
  icon: [640, 512, [], "e605", "M496 192c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6V240H375.2c31.5-29.8 74-48 120.8-48zM320 368c0-28.8 6.9-56 19.2-80H224V66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z"]
};
var faBalloons = {
  prefix: 'fas',
  iconName: 'balloons',
  icon: [640, 512, [], "e2e4", "M320 160C320 71.6 248.4 0 160 0S0 71.6 0 160c0 92.5 87.2 174 117.7 199.7c5.9 5 7.8 13.4 4.4 20.3L97.4 429.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9H211.1c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L198 379.9c-3.5-6.9-1.6-15.3 4.4-20.3C232.8 334 320 252.5 320 160zM144 96c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zM437.7 423.7c5.9 5 7.8 13.4 4.4 20.3l-24.7 49.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9H531.1c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L518 443.9c-3.5-6.9-1.6-15.3 4.4-20.3C552.8 398 640 316.5 640 224c0-88.4-71.6-160-160-160c-53.7 0-101.2 26.4-130.2 67c1.4 9.5 2.2 19.2 2.2 29c0 37.2-11.5 71.8-27.3 101.9c18.5 76.2 86.8 139.7 113 161.8zM416 208c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z"]
};
var faMillSign = {
  prefix: 'fas',
  iconName: 'mill-sign',
  icon: [384, 512, [], "e1ed", "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128v80V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"]
};
var faBowlRice = {
  prefix: 'fas',
  iconName: 'bowl-rice',
  icon: [512, 512, [], "e2eb", "M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176H72c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faTimelineArrow = {
  prefix: 'fas',
  iconName: 'timeline-arrow',
  icon: [640, 512, [], "e29d", "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H530.7l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM328 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSkull = {
  prefix: 'fas',
  iconName: 'skull',
  icon: [512, 512, [128128], "f54c", "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1v64c0 26.5 21.5 48 48 48h48V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48V400c0-.4 0-.7 0-1.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faGameBoardSimple = {
  prefix: 'fas',
  iconName: 'game-board-simple',
  icon: [448, 512, ["game-board-alt"], "f868", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 0V256H384V96H224zm0 160H64V416H224V256z"]
};
var faGameBoardAlt = faGameBoardSimple;
var faCircleVideo = {
  prefix: 'fas',
  iconName: 'circle-video',
  icon: [512, 512, ["video-circle"], "e12b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 192c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192zM396.9 317.9L352 288V224l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V307.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"]
};
var faVideoCircle = faCircleVideo;
var faChartScatterBubble = {
  prefix: 'fas',
  iconName: 'chart-scatter-bubble',
  icon: [512, 512, [], "e0e9", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM192 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM384 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faHouseTurret = {
  prefix: 'fas',
  iconName: 'house-turret',
  icon: [640, 512, [], "e1b4", "M256 464V277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4V464c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48zM424 272c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V296c0-13.3-10.7-24-24-24H424zM24 0C10.7 0 0 10.7 0 24V96v8 93.5c0 17 6.7 33.3 18.7 45.3L64 288V464c0 26.5 21.5 48 48 48H240c-10-13.4-16-30-16-48V277.1c0-22.4 9.4-43.8 25.9-59L352 124.6V104 96 24c0-13.3-10.7-24-24-24H280c-13.3 0-24 10.7-24 24V96H224V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24V96H96V24C96 10.7 85.3 0 72 0H24zM176 160c22.1 0 40 17.9 40 40v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V200c0-22.1 17.9-40 40-40z"]
};
var faBanana = {
  prefix: 'fas',
  iconName: 'banana',
  icon: [576, 512, [], "e2e5", "M304 144c0 35.7-7.3 69.6-20.5 100.5c4.8 3 9.4 6.2 13.9 9.8l35.5 28.4L413.9 261c10.6-2.8 21.4-4.4 32.3-4.9c1.2-10.5 1.8-21.3 1.8-32.1c0-84.7-36.6-160.9-94.8-213.6C345.6 3.6 335.9 0 326.1 0c-29.4 0-47.5 29.4-38 55c10.3 27.7 15.9 57.7 15.9 89zM277.4 279.2c-18.8-15-42.1-23.2-66.1-23.2c-22.9 0-45.2 7.4-63.5 21.2l-42.2 31.6c-10.6 8-12.8 23-4.8 33.6s23 12.8 33.6 4.8l42.2-31.6c10-7.5 22.2-11.6 34.7-11.6c10.5 0 20.8 2.9 29.7 8.2C194.1 366 125 400 48 400c-26.5 0-48 21.5-48 48v16c0 26.5 21.5 48 48 48l112 0c117.3 0 218.2-70.1 263.1-170.6l11.5-3.1c5.7-1.5 11.6-2.3 17.5-2.3c23.8 0 45.9 12.5 58.1 32.9l21.3 35.4c6.8 11.4 21.6 15 32.9 8.2s15-21.6 8.2-32.9l-21.3-35.4C530.4 309.3 492.7 288 452 288c-3.8 0-7.5 .2-11.3 .6c-5.5 .5-10.9 1.5-16.3 2.8c-.8 .2-1.5 .4-2.3 .6l-96.7 25.8h0l-48.1-38.5z"]
};
var faHandHoldingSkull = {
  prefix: 'fas',
  iconName: 'hand-holding-skull',
  icon: [576, 512, [], "e1a4", "M371.6 232.2c-6 3.8-9.4 10.8-8 17.7l4.1 20.6c.2 .9 .3 1.9 .3 2.9c0 8-6.5 14.6-14.6 14.6H222.6c-8 0-14.6-6.5-14.6-14.6c0-1 .1-1.9 .3-2.9l4.1-20.6c1.4-7-2-13.9-8-17.7C167.8 209 144 171 144 128C144 57.3 208.5 0 288 0s144 57.3 144 128c0 43-23.8 81-60.4 104.2zM240 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faPeopleDress = {
  prefix: 'fas',
  iconName: 'people-dress',
  icon: [640, 512, [], "e217", "M208 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM70.2 384H88v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L226.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-53.6-89.2c-20.3-33.7-56.7-54.3-96-54.3H154.2c-39.3 0-75.7 20.6-96 54.3L4.6 271.5c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L55 362.9C51.6 373.3 59.3 384 70.2 384zM528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faLoveseat = {
  prefix: 'fas',
  iconName: 'loveseat',
  icon: [512, 512, ["couch-small"], "f4cc", "M64 160C64 89.3 121.3 32 192 32H320c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM416 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H384h32V320 272z"]
};
var faCouchSmall = faLoveseat;
var faTowerBroadcast = {
  prefix: 'fas',
  iconName: 'tower-broadcast',
  icon: [576, 512, ["broadcast-tower"], "f519", "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"]
};
var faBroadcastTower = faTowerBroadcast;
var faTruckPickup = {
  prefix: 'fas',
  iconName: 'truck-pickup',
  icon: [640, 512, [128763], "f63c", "M368.6 96l76.8 96H288V96h80.6zM224 80V192H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32H65.1c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V224c0-17.7-14.3-32-32-32H527.4L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48zm0 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faBlockQuote = {
  prefix: 'fas',
  iconName: 'block-quote',
  icon: [448, 512, [], "e0b5", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM160 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zM128 416c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM32 224c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32z"]
};
var faUpLong = {
  prefix: 'fas',
  iconName: 'up-long',
  icon: [320, 512, ["long-arrow-alt-up"], "f30c", "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192H96l0 288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32l0-288h72c9.6 0 18.2-5.7 22-14.5z"]
};
var faLongArrowAltUp = faUpLong;
var faStop = {
  prefix: 'fas',
  iconName: 'stop',
  icon: [384, 512, [9209], "f04d", "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faCodeMerge = {
  prefix: 'fas',
  iconName: 'code-merge',
  icon: [448, 512, [], "f387", "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faMoneyCheckDollarPen = {
  prefix: 'fas',
  iconName: 'money-check-dollar-pen',
  icon: [640, 512, ["money-check-edit-alt"], "f873", "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64.6c-15.2 2-29.8 8.8-41.4 20.5L353.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-6 23.9H64c-35.3 0-64-28.7-64-64V128zM256 304c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm16-112c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zM144 139.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V352c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V160c0-11.1-9-20.1-20.1-20.1zm469.8 95.8l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417L505.1 287.8l71 71L446.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
var faUpFromLine = {
  prefix: 'fas',
  iconName: 'up-from-line',
  icon: [384, 512, ["arrow-alt-from-bottom"], "f346", "M41.9 166.1L164.7 43.3C171.9 36.1 181.8 32 192 32s20.1 4.1 27.3 11.3L342.1 166.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9H256V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V224H65.9C47.2 224 32 208.8 32 190.1c0-9 3.6-17.6 9.9-24zM32 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faArrowAltFromBottom = faUpFromLine;
var faUpload = {
  prefix: 'fas',
  iconName: 'upload',
  icon: [512, 512, [], "f093", "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHurricane = {
  prefix: 'fas',
  iconName: 'hurricane',
  icon: [384, 512, [], "f751", "M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9V81.2c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2V430.2c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGridRound2Plus = {
  prefix: 'fas',
  iconName: 'grid-round-2-plus',
  icon: [512, 512, [], "e5dc", "M128 224a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 256a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM480 128a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z"]
};
var faPeoplePants = {
  prefix: 'fas',
  iconName: 'people-pants',
  icon: [640, 512, [], "e219", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faMound = {
  prefix: 'fas',
  iconName: 'mound',
  icon: [576, 512, [], "e52d", "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"]
};
var faWindsock = {
  prefix: 'fas',
  iconName: 'windsock',
  icon: [512, 512, [], "f777", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h64v8.6c0 20.3 18.7 35.5 38.5 31.3l41.5-8.6V64.7L166.5 56c-19.9-4.1-38.5 11-38.5 31.3V96H64V32zm64 112V272H64V144h64zM272 78V338l96-20V98L272 78zM486.5 293.3c14.8-3.1 25.5-16.2 25.5-31.3V154c0-15.2-10.6-28.2-25.5-31.3L432 111.3V304.7l54.5-11.4z"]
};
var faCircleHalf = {
  prefix: 'fas',
  iconName: 'circle-half',
  icon: [512, 512, [], "e110", "M256 32c0-17.7-14.4-32.2-31.9-30C97.8 17.7 0 125.4 0 256S97.8 494.3 224.1 510c17.5 2.2 31.9-12.4 31.9-30V32z"]
};
var faBrakeWarning = {
  prefix: 'fas',
  iconName: 'brake-warning',
  icon: [640, 512, [], "e0c7", "M96 256a224 224 0 1 1 448 0A224 224 0 1 1 96 256zM344 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM91.1 109C63.8 151.4 48 201.8 48 256s15.8 104.6 43.1 147c7.2 11.1 4 26-7.2 33.2s-26 4-33.2-7.2C18.6 379.1 0 319.7 0 256S18.6 132.9 50.7 83c7.2-11.1 22-14.4 33.2-7.2s14.4 22 7.2 33.2zM589.3 83C621.4 132.9 640 192.3 640 256s-18.6 123.1-50.7 173c-7.2 11.1-22 14.4-33.2 7.2s-14.4-22-7.2-33.2c27.3-42.4 43.1-92.8 43.1-147s-15.8-104.6-43.1-147c-7.2-11.1-4-26 7.2-33.2s26-4 33.2 7.2z"]
};
var faToiletPortable = {
  prefix: 'fas',
  iconName: 'toilet-portable',
  icon: [320, 512, [], "e583", "M0 32V64H320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM24 96H0v24V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H272v8c0 13.3 10.7 24 24 24s24-10.7 24-24V120 96H296 24zM256 240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCompactDisc = {
  prefix: 'fas',
  iconName: 'compact-disc',
  icon: [512, 512, [128191, 128192, 128440], "f51f", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faFileArrowDown = {
  prefix: 'fas',
  iconName: 'file-arrow-down',
  icon: [384, 512, ["file-download"], "f56d", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFileDownload = faFileArrowDown;
var faSaxophoneFire = {
  prefix: 'fas',
  iconName: 'saxophone-fire',
  icon: [640, 512, ["sax-hot"], "f8db", "M102.6 0c-2.5 0-5 .9-7 2.6c-23.3 20.8-43 44.4-57 67.1C24.9 92 16 116 16 134.5c0 14.6 2.8 28.6 7.9 41.5H79.5c-4.8-8-7.5-17.8-7.5-29c0-16.8 10.5-31.5 31.5-57.4c2.8 3.5 43.4 55.3 43.4 55.3l25.2-29.4c2.1 2.8 3.5 5.6 4.9 8.4c9.1 16.7 8.7 36.7-.2 52.1H232c5.1-12.9 8-26.9 8-41.5c0-14.1-6.7-35.7-16.9-55.3c-10.3-19.9-25-40.9-42.3-56.8c-3.9-3.6-10.1-3.6-14 0c-6.7 6.1-13 13.7-18.5 20.7c-12.1-14.5-25-28-38.8-40.4C107.5 .9 105.1 0 102.6 0zm68.8 338.1L218.9 256H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H16.9L4.4 309.4C1.5 321.8 0 334.4 0 347.1v3.1C0 439.6 72.4 512 161.8 512c49.4 0 96.1-22.6 126.8-61.4L534.4 140.1c6.1-7.7 15.3-12.1 25.1-12.1h64.2c9 0 16.3-7.3 16.3-16.3c0-4.9-2.2-9.5-5.9-12.6L609.8 78.8c-11.5-9.6-26-14.8-41-14.8H538.5c-17 0-33.3 6.7-45.3 18.7L449 127l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L401 175l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L353 223l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L206.6 369.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6v-2.6c0-4.4 1.2-8.8 3.4-12.6zM144 280a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM88 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSaxHot = faSaxophoneFire;
var faCameraWebSlash = {
  prefix: 'fas',
  iconName: 'camera-web-slash',
  icon: [640, 512, ["webcam-slash"], "f833", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135.2-106C525.9 324.9 544 276.6 544 224C544 100.3 443.7 0 320 0C248 0 183.9 34 143 86.7L38.8 5.1zM193.3 126.2C222.6 88.4 268.5 64 320 64c88.4 0 160 71.6 160 160c0 37.7-13 72.3-34.8 99.6L420 303.9c17.5-21.9 28-49.7 28-79.9c0-70.7-57.3-128-128-128c-41.3 0-78.1 19.6-101.5 50l-25.2-19.7zm88.2 69.1l-25.2-19.7C270.9 156.4 294 144 320 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-15.8 0-29.8 7.6-38.5 19.3zM507.7 496L359.4 379.1c-12.6 3.2-25.8 4.9-39.4 4.9c-88.4 0-160-71.6-160-160c0-.6 0-1.3 0-1.9l-58.8-46.3C97.8 191.3 96 207.4 96 224c0 79.5 41.4 149.3 103.8 189.1l-58.2 40.7c-11.4 8-16.4 22.5-12.2 35.8S146 512 160 512H480c11.6 0 22.1-6.2 27.7-16zM324.8 351.9L194.5 249.2C206.2 307.8 257.9 352 320 352c1.6 0 3.2 0 4.8-.1z"]
};
var faWebcamSlash = faCameraWebSlash;
var faFolderMedical = {
  prefix: 'fas',
  iconName: 'folder-medical',
  icon: [512, 512, [], "e18c", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"]
};
var faFolderGear = {
  prefix: 'fas',
  iconName: 'folder-gear',
  icon: [512, 512, ["folder-cog"], "e187", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM368.6 259.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM216 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faFolderCog = faFolderGear;
var faHandWave = {
  prefix: 'fas',
  iconName: 'hand-wave',
  icon: [512, 512, [], "e1a7", "M352.2 82.3L351 73.8c-3-21.1-19.6-37.7-40.7-40.7l-8.5-1.2c-8.7-1.2-14.8-9.4-13.6-18.1S297.5-1.1 306.3 .2l8.5 1.2c35.2 5 62.9 32.7 67.9 67.9l1.2 8.5c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6zM185.4 70.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192c3.3 3.3 9.4 1.1 9.4-3.7l0-77.7c0-22.1 17.9-40 40-40s40 17.9 40 40V312.3c0 60.2-27.9 116.9-75.5 153.7C385.7 505.3 321 515.7 263 498.7c-28.4-7.1-55.3-21.8-77.6-44.1l-4.9-4.9L73.4 342.6l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l31.9 31.9 .1 .1L165.3 344c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L57.4 198.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L229.3 280c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L105.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L293.3 216c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L185.4 70.6zM13.7 352.2c8.7-1.2 16.9 4.8 18.1 13.6l1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2c8.7 1.3 14.8 9.4 13.6 18.1s-9.4 14.8-18.1 13.6l-8.5-1.2c-35.2-5-62.9-32.7-67.9-67.9L.2 370.3c-1.2-8.7 4.8-16.9 13.6-18.1z"]
};
var faArrowUpArrowDown = {
  prefix: 'fas',
  iconName: 'arrow-up-arrow-down',
  icon: [576, 512, ["sort-up-down"], "e099", "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 141.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zm352 333.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L448 370.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V370.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96z"]
};
var faSortUpDown = faArrowUpArrowDown;
var faCaravan = {
  prefix: 'fas',
  iconName: 'caravan',
  icon: [640, 512, [], "f8ff", "M0 112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80V112zM320 352H448V256H416c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V352zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faShieldCat = {
  prefix: 'fas',
  iconName: 'shield-cat',
  icon: [512, 512, [], "e572", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faMessageSlash = {
  prefix: 'fas',
  iconName: 'message-slash',
  icon: [640, 512, ["comment-alt-slash"], "f4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352V64c0-35.3-28.7-64-64-64H128C104.4 0 83.8 12.7 72.7 31.7L38.8 5.1zM64 352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416h32.8L64 146.4V352z"]
};
var faCommentAltSlash = faMessageSlash;
var faBolt = {
  prefix: 'fas',
  iconName: 'bolt',
  icon: [448, 512, [9889, "zap"], "f0e7", "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"]
};
var faZap = faBolt;
var faTrashCanCheck = {
  prefix: 'fas',
  iconName: 'trash-can-check',
  icon: [448, 512, [], "e2a9", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM337 265c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 265z"]
};
var faGlassWater = {
  prefix: 'fas',
  iconName: 'glass-water',
  icon: [384, 512, [], "e4f4", "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM73 156.5L66.4 64H317.6L311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"]
};
var faOilWell = {
  prefix: 'fas',
  iconName: 'oil-well',
  icon: [576, 512, [], "e532", "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1L305.3 352H238.7L265 277l-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32H327.7l11.2 32H205.1z"]
};
var faPersonSimple = {
  prefix: 'fas',
  iconName: 'person-simple',
  icon: [256, 512, [], "e220", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z"]
};
var faVault = {
  prefix: 'fas',
  iconName: 'vault',
  icon: [576, 512, [], "e2c5", "M64 0C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H80l16 32h64l16-32H400l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM480 221.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"]
};
var faMars = {
  prefix: 'fas',
  iconName: 'mars',
  icon: [448, 512, [9794], "f222", "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
var faToilet = {
  prefix: 'fas',
  iconName: 'toilet',
  icon: [448, 512, [128701], "f7d8", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPlaneCircleXmark = {
  prefix: 'fas',
  iconName: 'plane-circle-xmark',
  icon: [640, 512, [], "e557", "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faYenSign = {
  prefix: 'fas',
  iconName: 'yen-sign',
  icon: [320, 512, [165, "cny", "jpy", "rmb", "yen"], "f157", "M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V288h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H219.8L314.6 81.7c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"]
};
var faCny = faYenSign;
var faJpy = faYenSign;
var faRmb = faYenSign;
var faYen = faYenSign;
var faGearCode = {
  prefix: 'fas',
  iconName: 'gear-code',
  icon: [512, 512, [], "e5e8", "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zm-208.2-3.9c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-32 192c-1.5 8.7 4.4 17 13.2 18.4s17-4.4 18.4-13.2l32-192zM187.3 227.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-40 40c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L158.6 256l28.7-28.7zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L353.4 256l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l40-40c6.2-6.2 6.2-16.4 0-22.6l-40-40z"]
};
var faNotes = {
  prefix: 'fas',
  iconName: 'notes',
  icon: [512, 512, [], "e202", "M160 32c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64H339.2c4.3 0 8.6-.4 12.8-1.3V320c0-17.7 14.3-32 32-32h94.7c.9-4.2 1.3-8.5 1.3-12.8V96c0-35.3-28.7-64-64-64H160zM384 352v45.7V416l96-96H461.7 416 384v32zM296 464H136c-48.6 0-88-39.4-88-88l0-224c0-13.3-10.7-24-24-24s-24 10.7-24 24V376c0 75.1 60.9 136 136 136H296c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
var faRubleSign = {
  prefix: 'fas',
  iconName: 'ruble-sign',
  icon: [384, 512, [8381, "rouble", "rub", "ruble"], "f158", "M96 32C78.3 32 64 46.3 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H96zM240 256H128V96H240c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
var faRouble = faRubleSign;
var faRub = faRubleSign;
var faRuble = faRubleSign;
var faTrashUndo = {
  prefix: 'fas',
  iconName: 'trash-undo',
  icon: [448, 512, ["trash-arrow-turn-left"], "f895", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128zM217.8 199.9c8.9 9.9 8.1 25-1.8 33.9L182.5 264H240c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V352c0-22.1-17.9-40-40-40H182.5l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z"]
};
var faTrashArrowTurnLeft = faTrashUndo;
var faChampagneGlass = {
  prefix: 'fas',
  iconName: 'champagne-glass',
  icon: [320, 512, ["glass-champagne"], "f79e", "M88 0C71.9 0 58.3 12 56.3 27.9L33.2 208C24.9 273.4 67.3 332.4 128 348V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348c60.7-15.6 103.1-74.6 94.8-140l-23-180.1C261.7 12 248.1 0 232 0H88zm20 128l8.2-64h87.7l8.2 64H108z"]
};
var faGlassChampagne = faChampagneGlass;
var faObjectsAlignCenterHorizontal = {
  prefix: 'fas',
  iconName: 'objects-align-center-horizontal',
  icon: [512, 512, [], "e3bc", "M256 0c-13.3 0-24 10.7-24 24V64H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H232v64H144c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h88v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h88c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H280V224H432c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H280V24c0-13.3-10.7-24-24-24z"]
};
var faSun = {
  prefix: 'fas',
  iconName: 'sun',
  icon: [512, 512, [9728], "f185", "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
};
var faTrashCanSlash = {
  prefix: 'fas',
  iconName: 'trash-can-slash',
  icon: [640, 512, ["trash-alt-slash"], "e2ad", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V128H195.6L154.8 96H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H416l-7.2-14.3C403.4 6.8 392.3 0 380.2 0H259.8c-12.1 0-23.2 6.8-28.6 17.7L224 32H128c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM304 213v-5c0-8.8 7.2-16 16-16s16 7.2 16 16v30L304 213zm96 75.2V208c0-8.8 7.2-16 16-16s16 7.2 16 16V313.3l-32-25.1zM128 448c0 35.3 28.7 64 64 64H448c20.1 0 38.1-9.3 49.8-23.8L431.5 436c-1.8 6.9-8 12-15.5 12c-8.8 0-16-7.2-16-16V411.2l-64-50.4V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V335.5l-64-50.4V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V259.9l-80-63V448z"]
};
var faTrashAltSlash = faTrashCanSlash;
var faScreenUsers = {
  prefix: 'fas',
  iconName: 'screen-users',
  icon: [640, 512, ["users-class"], "f63d", "M96 0C60.7 0 32 28.7 32 64V248.4C49 233.2 71.4 224 96 224V64l448 0V224c24.6 0 47 9.2 64 24.4V64c0-35.3-28.7-64-64-64H96zm64 320A64 64 0 1 0 32 320a64 64 0 1 0 128 0zM0 480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64zM384 320a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM224 480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H288c-35.3 0-64 28.7-64 64zm320-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H512z"]
};
var faUsersClass = faScreenUsers;
var faGuitar = {
  prefix: 'fas',
  iconName: 'guitar',
  icon: [512, 512, [], "f7a6", "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faSquareArrowLeft = {
  prefix: 'fas',
  iconName: 'square-arrow-left',
  icon: [448, 512, ["arrow-square-left"], "f33a", "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM87 239L199 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L344 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L87 273c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faArrowSquareLeft = faSquareArrowLeft;
var faSquare8 = {
  prefix: 'fas',
  iconName: 'square-8',
  icon: [448, 512, [], "e25d", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm232 32H216c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0H216s0 0 0 0zm16 48h8c17.7 0 32 14.3 32 32s-14.3 32-32 32H208c-17.7 0-32-14.3-32-32s14.3-32 32-32h8 16z"]
};
var faFaceSmileHearts = {
  prefix: 'fas',
  iconName: 'face-smile-hearts',
  icon: [640, 512, [], "e390", "M448.2 34.3c-1.3 19.7 5.5 39.8 20.5 54.9l55.5 55.8c9.2 9.3 21.1 14.2 33.2 14.9C569.4 189.6 576 222 576 256c0 37.4-8 73-22.5 105.1c-27-15.2-61.9-11.3-84.8 11.8c-25.8 26-27.5 67.1-4.9 94.9C422.8 495.7 373.3 512 320 512c-61.3 0-117.6-21.6-161.7-57.6l13.1-13.1c27.6-27.7 27.6-72.6 0-100.4c-24.8-25-63.6-27.6-91.3-7.7c-1.7-1.2-3.5-2.4-5.2-3.4C67.8 306.5 64 281.7 64 256C64 114.6 178.6 0 320 0c46.7 0 90.5 12.5 128.2 34.3zM205.5 323.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 346.2 363.4 368 320 368s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm-.7-90.3c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zm230.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM573.7 11.5c15.2-15.3 39.8-15.3 54.9 0s15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0L491.4 66.7c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L560 25.3l13.7-13.8zm54.9 384c15.2 15.3 15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0l-55.5-55.8c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L560 409.3l13.7-13.8c15.2-15.3 39.8-15.3 54.9 0zm-534.9-32c15.2-15.3 39.8-15.3 54.9 0s15.2 40 0 55.2L93.2 474.5c-7.3 7.3-19.1 7.3-26.3 0L11.4 418.7c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L80 377.3l13.7-13.8z"]
};
var faBracketsSquare = {
  prefix: 'fas',
  iconName: 'brackets-square',
  icon: [448, 512, ["brackets"], "f7e9", "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h64V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zM64 32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64V416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32z"]
};
var faBrackets = faBracketsSquare;
var faLaptopArrowDown = {
  prefix: 'fas',
  iconName: 'laptop-arrow-down',
  icon: [640, 512, [], "e1c6", "M128 32C92.7 32 64 60.7 64 96V352h64V96H256V32H128zM512 96V352h64V96c0-35.3-28.7-64-64-64H384V96H512zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2zM344 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V238.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V56z"]
};
var faHockeyStickPuck = {
  prefix: 'fas',
  iconName: 'hockey-stick-puck',
  icon: [640, 512, [], "e3ae", "M462.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9L261.5 476.6c-10.8 21.7-33 35.4-57.2 35.4H160 128 96V480 352H252.2L419.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3zM0 384c0-17.7 14.3-32 32-32H64V512H32c-17.7 0-32-14.3-32-32V384zm416 32H608c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448c0-17.7 14.3-32 32-32z"]
};
var faHouseTree = {
  prefix: 'fas',
  iconName: 'house-tree',
  icon: [640, 512, [], "e1b3", "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H514.6L601 300c7.7 9.6 9.2 22.8 3.9 33.9S588.3 352 576 352H546.6L633 460c7.7 9.6 9.2 22.8 3.9 33.9S620.3 512 608 512H400c10-13.4 16-30 16-48V277.1c0-22.4-9.4-43.8-25.9-59L282.9 119.9 393.4 9.4zM0 277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V277.1zM144 296v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V296c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24z"]
};
var faSignalFair = {
  prefix: 'fas',
  iconName: 'signal-fair',
  icon: [640, 512, ["signal-2"], "f68d", "M224 320c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416z"]
};
var faSignal2 = faSignalFair;
var faFaceLaughWink = {
  prefix: 'fas',
  iconName: 'face-laugh-wink',
  icon: [512, 512, ["laugh-wink"], "f59c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faLaughWink = faFaceLaughWink;
var faCircleDollar = {
  prefix: 'fas',
  iconName: 'circle-dollar',
  icon: [512, 512, ["dollar-circle", "usd-circle"], "f2e8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm20.8-378.4v14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7V133.6c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"]
};
var faDollarCircle = faCircleDollar;
var faUsdCircle = faCircleDollar;
var faHorseHead = {
  prefix: 'fas',
  iconName: 'horse-head',
  icon: [640, 512, [], "f7ab", "M64 464V316.9c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H112c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowsRepeat = {
  prefix: 'fas',
  iconName: 'arrows-repeat',
  icon: [512, 512, ["repeat-alt"], "f364", "M1.6 213.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2C77.1 189.9 118.5 160 165.2 160H338.7l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96H165.2C91 96 25.1 143.5 1.6 213.9zm508.7 84.2c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2C434.9 322.1 393.5 352 346.8 352H173.3l41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L173.3 416H346.8c74.2 0 140.1-47.5 163.6-117.9z"]
};
var faRepeatAlt = faArrowsRepeat;
var faBoreHole = {
  prefix: 'fas',
  iconName: 'bore-hole',
  icon: [512, 512, [], "e4c3", "M256 0c-17.7 0-32 14.3-32 32V296.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H384c-17.7 0-32 14.3-32 32V352c0 53-43 96-96 96s-96-43-96-96V160c0-17.7-14.3-32-32-32H48z"]
};
var faIndustry = {
  prefix: 'fas',
  iconName: 'industry',
  icon: [576, 512, [], "f275", "M64 32C46.3 32 32 46.3 32 64V304v48 80c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304 152.2c0-18.2-19.4-29.7-35.4-21.1L352 215.4V152.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4V64c0-17.7-14.3-32-32-32H64z"]
};
var faImagePolaroid = {
  prefix: 'fas',
  iconName: 'image-polaroid',
  icon: [448, 512, [], "f8c4", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H352c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm152 64c-5.3 0-10.2 2.6-13.2 6.9l-52.4 76.3-9.6-12.8c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4l-48 64c-3.6 4.8-4.2 11.3-1.5 16.8s8.3 8.8 14.3 8.8h48 48 40 88c5.9 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-88-128c-3-4.3-7.9-6.9-13.2-6.9zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faWaveTriangle = {
  prefix: 'fas',
  iconName: 'wave-triangle',
  icon: [640, 512, [], "f89a", "M176 32c10.1 0 19.6 4.7 25.6 12.8L464 394.7 582.4 236.8c10.6-14.1 30.7-17 44.8-6.4s17 30.7 6.4 44.8l-144 192c-6 8.1-15.5 12.8-25.6 12.8s-19.6-4.7-25.6-12.8L176 117.3 57.6 275.2c-10.6 14.1-30.7 17-44.8 6.4s-17-30.7-6.4-44.8l144-192c6-8.1 15.5-12.8 25.6-12.8z"]
};
var faPersonRunningFast = {
  prefix: 'fas',
  iconName: 'person-running-fast',
  icon: [512, 512, [], "e5ff", "M368 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM259.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C198.4 108.3 228.2 96 259.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H458.7c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L334 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L382.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zM205.5 310.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h59.2l18.3-41.3zM16 95.8H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm16 48H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleDown = {
  prefix: 'fas',
  iconName: 'circle-down',
  icon: [512, 512, [61466, "arrow-alt-circle-down"], "f358", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z"]
};
var faArrowAltCircleDown = faCircleDown;
var faGrill = {
  prefix: 'fas',
  iconName: 'grill',
  icon: [448, 512, [], "e5a3", "M0 72C0 49.9 17.9 32 40 32H408c22.1 0 40 17.9 40 40V96c0 89.8-52.9 167.3-129.2 203l63.2 147.5c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L316.7 416H160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96V72zM151.8 368H296.2l-22.9-53.4c-15.9 3.6-32.3 5.4-49.3 5.4s-33.4-1.9-49.3-5.4L151.8 368zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowsTurnToDots = {
  prefix: 'fas',
  iconName: 'arrows-turn-to-dots',
  icon: [512, 512, [], "e4c1", "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"]
};
var faChartMixed = {
  prefix: 'fas',
  iconName: 'chart-mixed',
  icon: [512, 512, ["analytics"], "f643", "M500 89c13.8-11 16-31.2 5-45s-31.2-16-45-5L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L500 89zM160 256V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32s-32 14.3-32 32zm288-64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zm96-32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faAnalytics = faChartMixed;
var faFlorinSign = {
  prefix: 'fas',
  iconName: 'florin-sign',
  icon: [384, 512, [], "e184", "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H69.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H240l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H314.7z"]
};
var faArrowDownShortWide = {
  prefix: 'fas',
  iconName: 'arrow-down-short-wide',
  icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faSortAmountDesc = faArrowDownShortWide;
var faSortAmountDownAlt = faArrowDownShortWide;
var faLessThan = {
  prefix: 'fas',
  iconName: 'less-than',
  icon: [384, 512, [62774], "3c", "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"]
};
var faDisplayCode = {
  prefix: 'fas',
  iconName: 'display-code',
  icon: [576, 512, ["desktop-code"], "e165", "M0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416H64c-35.3 0-64-28.7-64-64V64zm64 0V352H512V64H64zM249 177l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM361 143l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faDesktopCode = faDisplayCode;
var faFaceDrooling = {
  prefix: 'fas',
  iconName: 'face-drooling',
  icon: [512, 512, [], "e372", "M384 477.8c76.5-44.3 128-127 128-221.8C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c33.9 0 66.4-6.6 96-18.6V370.9c-9.7 6.4-20.3 12.2-32 16.9V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V397.1c-10.1 1.9-20.8 2.9-32 2.9c-67 0-113.8-36.7-140.5-70c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5c22.8 28.5 61.3 58 115.5 58s92.7-29.5 115.5-58c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5c-3.8 4.7-7.9 9.5-12.5 14.2V477.8zM158.6 189.6c-8.4 8-13.5 17.7-15.4 23.5c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2c3.4-10.2 11.1-24.6 23.8-36.5C149.5 154.2 167.9 144 192 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-14.3 0-25.2 5.8-33.4 13.6zm210.2 23.5c-1.9-5.8-7-15.4-15.4-23.5c-8.2-7.8-19-13.6-33.4-13.6c-8.8 0-16-7.2-16-16s7.2-16 16-16c24.1 0 42.5 10.2 55.4 22.4c12.6 12 20.4 26.3 23.8 36.5c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1z"]
};
var faOilTemperature = {
  prefix: 'fas',
  iconName: 'oil-temperature',
  icon: [576, 512, ["oil-temp"], "f614", "M256 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H320V96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V128 32zM400 304l0-1.2c21.9-3.2 43.7-12.6 61.5-24.9l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 357.7 417 368 384 368c-1.4 0-2.7 0-4-.1c12.6-18.1 20-40.2 20-63.9zM192 368c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0c17.8 12.3 39.6 21.7 61.4 24.9l0 1.2c0 23.8 7.4 45.8 20 63.9c-1.3 0-2.7 .1-4 .1zm192 80c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0C329 437.4 356.5 448 384 448z"]
};
var faOilTemp = faOilTemperature;
var faSquareQuestion = {
  prefix: 'fas',
  iconName: 'square-question',
  icon: [448, 512, ["question-square"], "f2fd", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm73.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H190.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faQuestionSquare = faSquareQuestion;
var faAirConditioner = {
  prefix: 'fas',
  iconName: 'air-conditioner',
  icon: [576, 512, [], "f8f4", "M64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 256H192V416c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7c15.3-8.9 20.5-28.4 11.7-43.7s-28.4-20.5-43.7-11.7C83.4 349.4 64 380.4 64 416c0 53 43 96 96 96s96-43 96-96V256zm64 128c0 53 43 96 96 96s96-43 96-96c0-35.6-19.4-66.6-48-83.1c-15.3-8.8-34.9-3.6-43.7 11.7s-3.6 34.9 11.7 43.7c9.6 5.6 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32V256H320V384z"]
};
var faAngleDown = {
  prefix: 'fas',
  iconName: 'angle-down',
  icon: [448, 512, [8964], "f107", "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
};
var faMountains = {
  prefix: 'fas',
  iconName: 'mountains',
  icon: [640, 512, [9968], "f6fd", "M381.1 480H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7 48.2-79C465 164.1 472.2 160 480 160s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1H456.1h-75z"]
};
var faOmega = {
  prefix: 'fas',
  iconName: 'omega',
  icon: [448, 512, [], "f67a", "M224 96C135.6 96 64 167.6 64 256c0 56.4 29.1 106 73.3 134.5c13.3 8.6 22.7 23.7 22.7 41.2c0 26.7-21.6 48.3-48.3 48.3H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H67.2C25.8 375.4 0 318.7 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 62.7-25.8 119.4-67.2 160H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H336.3c-26.7 0-48.3-21.6-48.3-48.3c0-17.5 9.4-32.6 22.7-41.2C354.9 362 384 312.4 384 256c0-88.4-71.6-160-160-160z"]
};
var faCarTunnel = {
  prefix: 'fas',
  iconName: 'car-tunnel',
  icon: [512, 512, [], "e4de", "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h42.8c-6.6-5.9-10.8-14.4-10.8-24V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6V488c0 9.6-4.2 18.1-10.8 24H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24V448H160v40c0 9.6-4.2 18.1-10.8 24H362.8zM190.8 277.5L177 320H335l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faPersonDollyEmpty = {
  prefix: 'fas',
  iconName: 'person-dolly-empty',
  icon: [512, 512, [], "f4d1", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM96 306.7V241.7l16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4h70.7l27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L339.7 410.3c-10-13.7-25.3-23.3-42.8-25.7L247.3 186.2c-3.2-12.9-16.2-20.7-29.1-17.5s-20.7 16.2-17.5 29.1l6.5 26.2H161.1l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32v0V410.5l-64-64zM272 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faPanFood = {
  prefix: 'fas',
  iconName: 'pan-food',
  icon: [640, 512, [129368], "e42b", "M320 512A256 256 0 1 0 320 0a256 256 0 1 0 0 512zm0-448c37.2 0 69.3 26.3 76.6 62.8l.6 3.2c1.4 7.3-4.1 14-11.5 14H254.3c-7.4 0-12.9-6.8-11.5-14l.6-3.2C250.7 90.3 282.8 64 320 64zM230.1 185.9c7.8 7.8 7.8 20.5 0 28.3l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM227.3 284.7c2.1 2.1 3.5 4.6 4.2 7.3c.4 1.7 .8 3.4 1.1 5.1c1.1 5.4 2.1 11 5.9 14.7l3.4 3.4c3 3 7.1 4.7 11.3 4.7H280c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56V349.3c0-4.2-1.7-8.3-4.7-11.3l-3.4-3.4c-3.8-3.8-9.3-4.8-14.7-5.9c-1.7-.3-3.5-.7-5.1-1.1c-2.7-.7-5.2-2.1-7.3-4.2c-6.2-6.2-6.2-16.4 0-22.6l8-8 8-8c6.2-6.2 16.4-6.2 22.6 0zM455.8 184.2c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6v4.8c0 18.7-8.5 36.4-23.1 48.1C462 299.2 448.4 304 434.4 304l-4.1 0c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4l79.6-79.6zM24 160c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm616 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
};
var faHeadSideCough = {
  prefix: 'fas',
  iconName: 'head-side-cough',
  icon: [640, 512, [], "e061", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416v16c0 26.5-21.5 48-48 48H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGripLines = {
  prefix: 'fas',
  iconName: 'grip-lines',
  icon: [448, 512, [], "f7a4", "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"]
};
var faThumbsDown = {
  prefix: 'fas',
  iconName: 'thumbs-down',
  icon: [512, 512, [128078, 61576], "f165", "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"]
};
var faUserLock = {
  prefix: 'fas',
  iconName: 'user-lock',
  icon: [640, 512, [], "f502", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H392.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7H178.3zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faArrowRightLong = {
  prefix: 'fas',
  iconName: 'arrow-right-long',
  icon: [512, 512, ["long-arrow-right"], "f178", "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
};
var faLongArrowRight = faArrowRightLong;
var faTicketsAirline = {
  prefix: 'fas',
  iconName: 'tickets-airline',
  icon: [640, 512, [], "e29b", "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V272c0-8.8-7.4-15.7-15.7-18.6C605.5 246.9 592 229 592 208s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm416 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM265.3 106.5c-1.7-5.2 2.1-10.5 7.6-10.5H304c8.5 0 16.4 4.5 20.7 11.9L364.4 176h40.3c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5c-11.4 11.4-26.8 17.7-42.8 17.7H364.4l-39.7 68.1c-4.3 7.4-12.2 11.9-20.7 11.9H272.9c-5.5 0-9.3-5.3-7.6-10.5L288.4 240H245.8l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H200c-5.2 0-9-4.9-7.8-9.9l12.5-50.2c.6-2.5 .6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9h13.8c5 0 9.8 2.4 12.8 6.4L245.8 176h42.7l-23.2-69.5zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"]
};
var faAnchorCircleXmark = {
  prefix: 'fas',
  iconName: 'anchor-circle-xmark',
  icon: [640, 512, [], "e4ac", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faEllipsis = {
  prefix: 'fas',
  iconName: 'ellipsis',
  icon: [448, 512, ["ellipsis-h"], "f141", "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faEllipsisH = faEllipsis;
var faNfcSlash = {
  prefix: 'fas',
  iconName: 'nfc-slash',
  icon: [640, 512, [], "e1fc", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM173.5 110.7c8.7-9 21-14.7 34.5-14.7h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-3.3 0-6.4 1-8.9 2.7l-25.6-20.1zM302.1 211.5c.6-.3 1.3-.5 1.9-.7V144c0-26.5 21.5-48 48-48h80c26.5 0 48 21.5 48 48V350.9l-32-25.1V144c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16v66.7c18.6 6.6 32 24.4 32 45.3c0 2.3-.2 4.6-.5 6.8l-65.5-51.3zM486.9 479.6L406.2 416H208c-26.5 0-48-21.5-48-48V222.1L96 171.6V416c0 35.3 28.7 64 64 64H480c2.3 0 4.6-.1 6.9-.4zM208 384H365.5L192 247.3V368c0 8.8 7.2 16 16 16z"]
};
var faChessPawn = {
  prefix: 'fas',
  iconName: 'chess-pawn',
  icon: [320, 512, [9823], "f443", "M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88H96c-17.7 0-32 14.3-32 32c0 16.5 12.5 30 28.5 31.8L80 400H240L227.5 287.8c16-1.8 28.5-15.3 28.5-31.8c0-17.7-14.3-32-32-32h-8.5zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432H64L22.6 473.4z"]
};
var faKitMedical = {
  prefix: 'fas',
  iconName: 'kit-medical',
  icon: [576, 512, ["first-aid"], "f479", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H96V32H64zm64 0V480H448V32H128zM512 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480V480h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"]
};
var faFirstAid = faKitMedical;
var faGrid2Plus = {
  prefix: 'fas',
  iconName: 'grid-2-plus',
  icon: [512, 512, [], "e197", "M80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 256h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z"]
};
var faBells = {
  prefix: 'fas',
  iconName: 'bells',
  icon: [640, 512, [], "f77f", "M230.8 245.5l18.7 51.2c11.7 31.8 12.9 66.5 3.5 99.1l-1.1 3.9L21.4 315.8C10 311.7 2 301.5 .6 289.5s4.1-23.8 14.3-30.4l8.2-5.4C57.6 231 84 197.8 98.2 159l14.7-40C138 50.4 214 15.1 282.6 40.1c4.8 1.7 9.4 3.7 13.9 6c-64.1 42.2-93.3 124.2-65.7 199.5zm30.1-10.9c-26.1-71.3 10.5-150.2 81.9-176.2s150.4 10.8 176.5 82.1L538 191.7c14 38.2 39.8 71 73.6 93.6l13.7 9.2c10 6.7 15.4 18.5 14 30.4s-9.5 22.1-20.8 26.2L321.1 459.4c-11.3 4.1-24 1.5-32.8-6.7s-12.3-20.7-9-32.2l4.6-15.8c11.2-39 9.7-80.7-4.3-118.9l-18.8-51.2zM480.8 480c-21.2 0-40-10.2-51.7-25.9l116.1-42.3c.1 1.3 .1 2.6 .1 3.9c0 35.5-28.9 64.3-64.5 64.3zM94.3 376.1l117.6 43.4c-11.6 17.1-31.2 28.4-53.5 28.4c-35.6 0-64.5-28.8-64.5-64.3c0-2.5 .1-5.1 .4-7.5z"]
};
var faPersonThroughWindow = {
  prefix: 'fas',
  iconName: 'person-through-window',
  icon: [640, 512, [], "e5a9", "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0H64V64zm288 0l224 0V384H508.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320H379.2l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H308.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0H192s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faToolbox = {
  prefix: 'fas',
  iconName: 'toolbox',
  icon: [512, 512, [129520], "f552", "M176 88v40H336V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V88c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56v40h28.1c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9V304H384V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H192V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H0V227.9c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1H128zM0 416V336H128v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H320v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H512v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z"]
};
var faEnvelopeDot = {
  prefix: 'fas',
  iconName: 'envelope-dot',
  icon: [576, 512, ["envelope-badge"], "e16f", "M496 0a80 80 0 1 1 0 160A80 80 0 1 1 496 0zM48 64H385.1c-.7 5.2-1.1 10.6-1.1 16c0 45.6 27.2 84.8 66.3 102.3L275.2 313.6c-11.4 8.5-27 8.5-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112C0 85.5 21.5 64 48 64zM294.4 339.2L490.8 191.9c1.7 .1 3.4 .1 5.2 .1c5.4 0 10.8-.4 16-1.1V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V176L217.6 339.2c22.8 17.1 54 17.1 76.8 0z"]
};
var faEnvelopeBadge = faEnvelopeDot;
var faHandsHoldingCircle = {
  prefix: 'fas',
  iconName: 'hands-holding-circle',
  icon: [640, 512, [], "e4fb", "M320 0a128 128 0 1 1 0 256A128 128 0 1 1 320 0zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"]
};
var faBug = {
  prefix: 'fas',
  iconName: 'bug',
  icon: [512, 512, [], "f188", "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"]
};
var faBowlChopsticks = {
  prefix: 'fas',
  iconName: 'bowl-chopsticks',
  icon: [512, 512, [], "e2e9", "M18.5 125.1l473.8-74c11.3-1.8 19.7-11.5 19.7-23c0-14.6-13.3-25.6-27.6-22.9L13.1 93.6C5.5 95 0 101.6 0 109.3c0 9.8 8.8 17.3 18.5 15.8zM0 159.7c0 9 7.3 16.2 16.2 16.2H488.4c13 0 23.6-10.6 23.6-23.6c0-13.3-11-24-24.4-23.6L15.7 143.5C7 143.8 0 151 0 159.7zM33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35H332.7c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5H33.6z"]
};
var faCreditCard = {
  prefix: 'fas',
  iconName: 'credit-card',
  icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faCreditCardAlt = faCreditCard;
var faCircleS = {
  prefix: 'fas',
  iconName: 'circle-s',
  icon: [512, 512, [], "e121", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM207.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z"]
};
var faBoxBallot = {
  prefix: 'fas',
  iconName: 'box-ballot',
  icon: [576, 512, [128499], "f735", "M128 32c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32V224H128V32zM0 352H576V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352zM48 160H96v96H480V160h48c26.5 0 48 21.5 48 48V320H0V208c0-26.5 21.5-48 48-48z"]
};
var faCar = {
  prefix: 'fas',
  iconName: 'car',
  icon: [512, 512, [128664, "automobile"], "f1b9", "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faAutomobile = faCar;
var faHandHoldingHand = {
  prefix: 'fas',
  iconName: 'hand-holding-hand',
  icon: [576, 512, [], "e4f7", "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32H384 544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H507.2l-44.9 36c-22.7 18.2-50.9 28-80 28H304 288 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160l0 0 .9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faUserTieHair = {
  prefix: 'fas',
  iconName: 'user-tie-hair',
  icon: [448, 512, [], "e45f", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0zm55.7 510.9c1.8 .7 3.8 1.1 5.8 1.1H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c2.1 0 4-.4 5.8-1.1L168 512H280l-.3-1.1z"]
};
var faPodiumStar = {
  prefix: 'fas',
  iconName: 'podium-star',
  icon: [448, 512, [], "f758", "M168 72c-22.1 0-40 17.9-40 40v32H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H80V112c0-48.6 39.4-88 88-88h14.4C190.7 9.7 206.2 0 224 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H224c-17.8 0-33.3-9.7-41.6-24H168zM73.7 455.1L48 224H400L374.3 455.1c-3.6 32.4-31 56.9-63.6 56.9H137.3c-32.6 0-60-24.5-63.6-56.9zM231.3 276.8c-2.9-6.4-11.7-6.4-14.5 0l-20.2 45.5c-1.2 2.6-3.6 4.4-6.3 4.8l-47.9 5.9c-6.8 .8-9.5 9.5-4.5 14.3l35.4 34c2 2 3 4.9 2.4 7.7l-9.4 49.1c-1.3 6.9 5.8 12.3 11.8 8.9l42.1-24.4c2.4-1.4 5.4-1.4 7.8 0L270 446.9c6 3.5 13.1-1.9 11.8-8.9L272.3 389c-.5-2.8 .4-5.8 2.4-7.7l35.4-34c5-4.8 2.3-13.5-4.5-14.3L257.8 327c-2.8-.3-5.2-2.1-6.3-4.8l-20.2-45.5z"]
};
var faUserHairMullet = {
  prefix: 'fas',
  iconName: 'user-hair-mullet',
  icon: [448, 512, ["business-front", "party-back", "trian-balbot"], "e45c", "M304 128v16c0 18-6 34.6-16 48h0v0c-14.6 19.4-37.8 32-64 32s-49.4-12.6-64-32v0h0c-10-13.4-16-30-16-48V128c0-5.7 .6-11.3 1.7-16.6c30.6-3.1 58.5-17.9 78.3-40.6c19.8 22.7 47.6 37.5 78.3 40.6c1.1 5.4 1.7 10.9 1.7 16.6zM237.4 271.3L255 289c5.5 5.5 13.2 8 20.8 6.7s14.2-6.1 17.6-13l6.1-12.2 19.5 7.8c9.3 3.7 19.8 1.3 26.6-6s8.3-18.1 3.8-27c-8.5-17-11-22.3-12.2-27.1c-.7-2.9-1.1-5.9-1.2-12.3C346.2 187.5 352 166.4 352 144V128c0-7.1-.6-14-1.7-20.7c5.9-4.4 9.7-11.4 9.7-19.3c0-13.3-10.7-24-24-24h-1.1C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64H112C98.7 64 88 74.7 88 88c0 7.9 3.8 14.9 9.7 19.3C96.6 114 96 120.9 96 128v16c0 22.4 5.8 43.5 15.9 61.8c-.1 6.4-.5 9.4-1.2 12.3c-1.2 4.8-3.7 10.1-12.2 27.1c-4.5 8.9-2.9 19.7 3.8 27s17.3 9.7 26.6 6l19.5-7.8 6.1 12.2c3.5 6.9 10 11.7 17.6 13s15.4-1.3 20.8-6.7l17.7-17.7c4.4 .5 8.9 .7 13.4 .7s9-.2 13.4-.7zM161.3 320C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320H161.3z"]
};
var faBusinessFront = faUserHairMullet;
var faPartyBack = faUserHairMullet;
var faTrianBalbot = faUserHairMullet;
var faMicrophoneStand = {
  prefix: 'fas',
  iconName: 'microphone-stand',
  icon: [512, 512, [127908], "f8cb", "M479.2 32.8c-43.7-43.7-114.7-43.7-158.4 0l-4.7 4.7L474.5 195.9l4.7-4.7c43.7-43.7 43.7-114.7 0-158.4zM293.5 60.1l-4.7 4.7c-24.4 24.4-35.2 57.2-32.4 89L358.2 255.6c31.8 2.8 64.6-8 89-32.4l4.7-4.7L293.5 60.1zM229.1 171.7L215.8 187 7.8 427c-11 12.7-10.3 31.7 1.6 43.6l32 32c11.9 11.9 30.9 12.6 43.6 1.6L224 383.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V328.2l37-32 15.3-13.3L229.1 171.7z"]
};
var faBookOpenReader = {
  prefix: 'fas',
  iconName: 'book-open-reader',
  icon: [512, 512, ["book-reader"], "f5da", "M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"]
};
var faBookReader = faBookOpenReader;
var faFamilyDress = {
  prefix: 'fas',
  iconName: 'family-dress',
  icon: [512, 512, [], "e301", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM112.3 160h31.4c11.8 0 23 3.2 32.6 8.9c-.2 2.3-.3 4.7-.3 7.1c0 24.3 10.9 46.1 28 60.8c-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1 .8 11.9 2.4 17.5c-8.7 9-20.9 14.5-34.4 14.5H112c-26.5 0-48-21.5-48-48V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4c7.8-27.5 33-46.4 61.5-46.4zM368 512c-13.5 0-25.7-5.6-34.4-14.5c1.6-5.5 2.4-11.4 2.4-17.5V423.6c19.6-17.6 32-43.1 32-71.6V336c0-43.1-24.3-80.5-60-99.2c17.1-14.7 28-36.5 28-60.8c0-2.4-.1-4.8-.3-7.1c9.6-5.7 20.8-8.9 32.6-8.9h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48H368zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V407.4c-19.1-11.1-32-31.7-32-55.4V336c0-44.2 35.8-80 80-80z"]
};
var faCircleX = {
  prefix: 'fas',
  iconName: 'circle-x',
  icon: [512, 512, [], "e12e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.3 136.5L256 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L287.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L256 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L224.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z"]
};
var faCabin = {
  prefix: 'fas',
  iconName: 'cabin',
  icon: [512, 512, [], "e46d", "M237.4 6C248.5-2 263.5-2 274.6 6L384 84.1V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v88.7L498.6 166c11.3 8.1 16.1 22.6 11.9 35.8S493.9 224 480 224H448 416 32c-13.9 0-26.2-9-30.5-22.2S2.1 174 13.4 166L237.4 6zM32 280c0-13.3 10.7-24 24-24H168c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V280zm24 72H168c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24zm0 96H168c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V472c0-13.3 10.7-24 24-24zM320 280c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V280zm24 168H456c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V472c0-13.3 10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V376zM256 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faMountainSun = {
  prefix: 'fas',
  iconName: 'mountain-sun',
  icon: [640, 512, [], "e52f", "M560 160A80 80 0 1 0 560 0a80 80 0 1 0 0 160zM55.9 512H381.1h75H578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"]
};
var faChartSimpleHorizontal = {
  prefix: 'fas',
  iconName: 'chart-simple-horizontal',
  icon: [448, 512, [], "e474", "M400 320c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 192c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l352 0zM208 480c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 352c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l160 0zM384 112l0-32c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80l0 32c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48z"]
};
var faBluetooth = {
  prefix: 'fas',
  iconName: 'bluetooth',
  icon: [384, 512, [], "f293", "M178.8 2.9c11.4-5.2 24.8-3.2 34.3 5.1l128 112C348 126 352 134.8 352 144s-4 18-10.9 24.1L240.6 256l100.5 87.9C348 350 352 358.8 352 368s-4 18-10.9 24.1l-128 112c-9.4 8.3-22.9 10.2-34.3 5.1S160 492.6 160 480V326.5L85.1 392.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2L143.4 256 42.9 168.1c-13.3-11.6-14.6-31.9-3-45.2s31.9-14.6 45.2-3L160 185.5V32c0-12.6 7.3-24 18.8-29.1zM224 326.5v83L271.4 368 224 326.5zm0-141L271.4 144 224 102.5v83z"]
};
var faArrowsLeftRightToLine = {
  prefix: 'fas',
  iconName: 'arrows-left-right-to-line',
  icon: [640, 512, [], "e4ba", "M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faHandBackPointLeft = {
  prefix: 'fas',
  iconName: 'hand-back-point-left',
  icon: [512, 512, [], "e19f", "M0 184c0-22.1 17.9-40 40-40l200 0h7l73 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-55.7 0c1.4-2 3-3.9 4.5-5.8l16-19.2C297 72.4 315 64 334 64L372 64c38 0 74 16.9 98.3 46.1l4.5 5.4c24 28.8 37.1 65 37.1 102.4V336c0 70.7-57.3 128-128 128l-64 0H288c-26.5 0-48-21.5-48-48c0-12.4 4.7-23.6 12.3-32.1C227.5 382 208 361.3 208 336c0-12.4 4.7-23.6 12.3-32.1C195.5 302 176 281.3 176 256c0-12.3 4.6-23.5 12.2-32L40 224c-22.1 0-40-17.9-40-40z"]
};
var faMessageDots = {
  prefix: 'fas',
  iconName: 'message-dots',
  icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM128 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCommentAltDots = faMessageDots;
var faMessaging = faMessageDots;
var faFileHeart = {
  prefix: 'fas',
  iconName: 'file-heart',
  icon: [384, 512, [], "e176", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 301.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 344.6C86.5 333.1 80 317.5 80 301.3z"]
};
var faBeerMug = {
  prefix: 'fas',
  iconName: 'beer-mug',
  icon: [512, 512, ["beer-foam"], "e0b3", "M267.7 133.3C253 149.7 231.7 160 208 160s-45-10.3-59.7-26.7c-6.9-7.7-21.4-8.6-29.6-2.3C108 139.1 94.6 144 80 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c14.6 0 28 4.9 38.7 13c8.2 6.3 22.7 5.4 29.6-2.3C163 10.3 184.3 0 208 0s45 10.3 59.7 26.7c6.9 7.7 21.4 8.6 29.6 2.3C308 20.9 321.4 16 336 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.6 0-28-4.9-38.7-13c-8.2-6.3-22.7-5.4-29.6 2.3zM32 448V163.2C46.1 171.3 62.5 176 80 176c18.7 0 36.2-5.4 51-14.7c20 19 47.2 30.7 77 30.7s57-11.7 77-30.7c14.8 9.3 32.3 14.7 51 14.7c19.6 0 37.9-5.9 53.1-16h46.1c42.4 0 76.8 34.4 76.8 76.8V338.9c0 30.3-17.9 57.9-45.6 70.2L384 445.7V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm352-72.4l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V236.8c0-7.1-5.7-12.8-12.8-12.8H384V375.6zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]
};
var faBeerFoam = faBeerMug;
var faDiceD20 = {
  prefix: 'fas',
  iconName: 'dice-d20',
  icon: [512, 512, [], "f6cf", "M48.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L201.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L47.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM16 171.7V295.3c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158C29.6 151.6 16 159.3 16 171.7zM310.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7zm-49.3 246L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8V452.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM41.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H183.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM174.4 176H337.6c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"]
};
var faDrone = {
  prefix: 'fas',
  iconName: 'drone',
  icon: [512, 512, [], "f85f", "M223 127.2L171.6 88.7C162.3 64.9 139.1 48 112 48c-35.3 0-64 28.7-64 64c0 27.1 16.9 50.3 40.7 59.6L127.2 223c-5 .7-10.1 1-15.2 1C50.1 224 0 173.9 0 112S50.1 0 112 0s112 50.1 112 112c0 5.2-.3 10.2-1 15.2zm-49.6 2.8l39.8 29.9 .1 .1h85.3l.1-.1 39.8-29.9 29.7-22.3C370.3 92.1 383.8 80 400 80c17.7 0 32 14.3 32 32c0 16.2-12.1 29.7-27.8 31.7l-22.3 29.7-29.9 39.8-.1 .1v85.3l.1 .1 29.9 39.8 22.3 29.7c15.7 2.1 27.8 15.5 27.8 31.7c0 17.7-14.3 32-32 32c-16.2 0-29.7-12.1-31.7-27.8l-29.7-22.3-39.8-29.9-.1-.1H213.3l-.1 .1-39.8 29.9-29.7 22.3C141.7 419.9 128.2 432 112 432c-17.7 0-32-14.3-32-32c0-16.2 12.1-29.7 27.8-31.7l22.3-29.7 29.9-39.8 .1-.1V213.3l-.1-.1-29.9-39.8-22.3-29.7C92.1 141.7 80 128.2 80 112c0-17.7 14.3-32 32-32c16.2 0 29.7 12.1 31.7 27.8l29.7 22.3zM224 400c0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c5.2 0 10.2 .3 15.2 1L88.7 340.4C64.9 349.7 48 372.9 48 400c0 35.3 28.7 64 64 64c27.1 0 50.3-16.9 59.6-40.7L223 384.8c.7 5 1 10.1 1 15.2zm65-272.8c-.7-5-1-10.1-1-15.2C288 50.1 338.1 0 400 0s112 50.1 112 112s-50.1 112-112 112c-5.2 0-10.2-.3-15.2-1l38.5-51.3c23.8-9.3 40.7-32.5 40.7-59.6c0-35.3-28.7-64-64-64c-27.1 0-50.3 16.9-59.6 40.7L289 127.2zM288 400c0-5.2 .3-10.2 1-15.2l51.3 38.5c9.3 23.8 32.5 40.7 59.6 40.7c35.3 0 64-28.7 64-64c0-27.1-16.9-50.3-40.7-59.6L384.8 289c5-.7 10.1-1 15.2-1c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112z"]
};
var faTruckDroplet = {
  prefix: 'fas',
  iconName: 'truck-droplet',
  icon: [640, 512, [], "e58c", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"]
};
var faFileCircleXmark = {
  prefix: 'fas',
  iconName: 'file-circle-xmark',
  icon: [576, 512, [], "e5a1", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faTemperatureArrowUp = {
  prefix: 'fas',
  iconName: 'temperature-arrow-up',
  icon: [576, 512, ["temperature-up"], "e040", "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM480 160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V160z"]
};
var faTemperatureUp = faTemperatureArrowUp;
var faMedal = {
  prefix: 'fas',
  iconName: 'medal',
  icon: [512, 512, [127941], "f5a2", "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0H133.9c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0H487.4C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"]
};
var faBed = {
  prefix: 'fas',
  iconName: 'bed',
  icon: [640, 512, [128716], "f236", "M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faBookCopy = {
  prefix: 'fas',
  iconName: 'book-copy',
  icon: [576, 512, [], "e0be", "M160 96L96 96C43 96 0 139 0 192V416c0 53 43 96 96 96H320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 288 96c-17.7 0-32-14.3-32-32s14.3-32 32-32h81.1c-10.9-18.8-17.1-40.7-17.1-64V96zM320 416h32H512h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H512 288c-53 0-96 43-96 96V320c0 24.6 9.2 47 24.4 64c17.6 19.6 43.1 32 71.6 32h32zm-64-96c0-17.7 14.3-32 32-32h96 96v64H384 288c-17.7 0-32-14.3-32-32z"]
};
var faSquareH = {
  prefix: 'fas',
  iconName: 'square-h',
  icon: [448, 512, ["h-square"], "f0fd", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM336 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHSquare = faSquareH;
var faSquareC = {
  prefix: 'fas',
  iconName: 'square-c',
  icon: [448, 512, [], "e266", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM167.4 199.4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0z"]
};
var faClockTwo = {
  prefix: 'fas',
  iconName: 'clock-two',
  icon: [512, 512, [], "e35a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392v91.2L338.7 172c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSquareEllipsisVertical = {
  prefix: 'fas',
  iconName: 'square-ellipsis-vertical',
  icon: [448, 512, [], "e26f", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCalendarUsers = {
  prefix: 'fas',
  iconName: 'calendar-users',
  icon: [640, 512, [], "e5e2", "M192 32V64H144c-26.5 0-48 21.5-48 48v48h32H512h32V112c0-26.5-21.5-48-48-48H448V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H256V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm55.4 480H392.6c-5.4-9.4-8.6-20.3-8.6-32c0-43.8 29.4-80.8 69.6-92.3c-23-20.5-37.6-50.4-37.6-83.7c0-56.4 41.7-103.1 96-110.9V192H128v1.1c54.3 7.8 96 54.4 96 110.9c0 33.3-14.5 63.2-37.6 83.7C226.6 399.2 256 436.2 256 480c0 11.7-3.1 22.6-8.6 32zM528 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-48 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H480zM192 304A80 80 0 1 0 32 304a80 80 0 1 0 160 0zM0 480c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64z"]
};
var faPodcast = {
  prefix: 'fas',
  iconName: 'podcast',
  icon: [448, 512, [], "f2ce", "M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faBee = {
  prefix: 'fas',
  iconName: 'bee',
  icon: [576, 512, [], "e0b2", "M196.7 4.7c6.2-6.2 16.4-6.2 22.6 0l34.8 34.8C264.4 34.7 275.9 32 288 32s23.6 2.7 33.9 7.5L356.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L347.8 58.8C360.4 73 368 91.6 368 112c0 3-.2 6-.5 8.9C390.3 105 419 96 448 96c65 0 128 44.9 128 112c0 61.9-53.6 104.9-112.9 111.2c.6-5.1 .9-10.2 .9-15.2c0-16.8-2.4-33.1-6.8-48.5c35.2-3.6 54.8-27.9 54.8-47.5c0-21.3-22.9-48-64-48c-34.8 0-56.6 19.2-62.4 38.1c28.6 26.3 46.4 64 46.4 105.9c0 83.8-103.6 179.7-129.9 202.8c-3.9 3.4-8.9 5.2-14.1 5.2s-10.2-1.8-14.1-5.2C247.6 483.7 144 387.8 144 304c0-41.9 17.9-79.6 46.4-105.9C184.6 179.2 162.8 160 128 160c-41.1 0-64 26.7-64 48c0 19.6 19.5 43.9 54.8 47.5c-4.4 15.4-6.8 31.7-6.8 48.5c0 5 .3 10.1 .9 15.2C53.6 312.9 0 269.9 0 208C0 140.9 63 96 128 96c29 0 57.7 9 80.5 24.9c-.3-2.9-.5-5.9-.5-8.9c0-20.4 7.6-39 20.2-53.2L196.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zm52.8 384.1c12.8 16.4 26.5 31.3 38.5 43.4c12-12.1 25.7-27 38.5-43.4c1.2-1.6 2.5-3.2 3.7-4.8H245.8c1.2 1.6 2.4 3.2 3.7 4.8zM359.6 336c5.6-12.6 8.4-23.4 8.4-32H208c0 8.6 2.8 19.4 8.4 32H359.6zM352 256c-14.6-19.4-37.8-32-64-32s-49.4 12.6-64 32H352z"]
};
var faTemperatureFull = {
  prefix: 'fas',
  iconName: 'temperature-full',
  icon: [320, 512, ["temperature-4", "thermometer-4", "thermometer-full"], "f2c7", "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature4 = faTemperatureFull;
var faThermometer4 = faTemperatureFull;
var faThermometerFull = faTemperatureFull;
var faBell = {
  prefix: 'fas',
  iconName: 'bell',
  icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"]
};
var faCandyBar = {
  prefix: 'fas',
  iconName: 'candy-bar',
  icon: [640, 512, [127851, "chocolate-bar"], "e3e8", "M0 320H128V224H0v96zm0 64c0 35.3 28.7 64 64 64h64V352H0v32zm288 64V352H160v96H288zm0-224H160v96H288V224zm0-160H160V192H288V64zm288 0H320V448H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM44.2 192H120s0 0 0 0h8V160h0V108.2c0-7.1-9-11.1-15-7.4C101 107.9 87 112 72 112c-4 0-7.9-.3-11.7-.9c-7-1-14.2 6.2-13.1 13.1c.6 3.8 .9 7.7 .9 11.7c0 15-4.1 29-11.3 41c-3.6 6.1 .4 15 7.4 15z"]
};
var faChocolateBar = faCandyBar;
var faXmarkLarge = {
  prefix: 'fas',
  iconName: 'xmark-large',
  icon: [448, 512, [], "e59b", "M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256 438.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0L224 210.7 393.4 41.4z"]
};
var faPinata = {
  prefix: 'fas',
  iconName: 'pinata',
  icon: [512, 512, [], "e3c3", "M112 318.1V254.7l25.8 9.9c14.7 5.6 31.1 4.9 45.1-2.2L259.8 224H288 432c44.2 0 80 35.8 80 80v13.2l-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7L112 318.1zm0 35.8l2.4 1.2c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l11.4-4.6v50.5l-24 12-17.7-8.8c-9-4.5-19.6-4.5-28.6 0l-16.5 8.3-16.3-10.8c-2.6-1.8-5.7-2.7-8.9-2.7H224c-3.2 0-6.2 .9-8.9 2.7l-16.3 10.8-16.5-8.3c-9-4.5-19.6-4.5-28.6 0L136 414.1l-24-12V353.9zm37.3-119.2L34.4 190.6C13.4 179.6 0 157.8 0 133.8V128C0 92.7 28.7 64 64 64H176V32c0-17.7 14.3-32 32-32s32 14.3 32 32V198.1l-71.4 35.7c-6 3-13.1 3.4-19.3 .9zM112 437.9l9.7 4.8c9 4.5 19.6 4.5 28.6 0l17.7-8.8 16.5 8.3c10.3 5.1 22.5 4.4 32.1-2l7.4-4.9V480c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V437.9zm288-2.7l7.4 4.9c9.6 6.4 21.8 7.1 32.1 2l16.5-8.3 17.7 8.8c9 4.5 19.6 4.5 28.6 0l9.7-4.8V480c0 17.7-14.3 32-32 32H432c-17.7 0-32-14.3-32-32V435.2zM200 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faArrowsFromLine = {
  prefix: 'fas',
  iconName: 'arrows-from-line',
  icon: [448, 512, [], "e0a4", "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM192 352v32H160c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H256V352c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faSuperscript = {
  prefix: 'fas',
  iconName: 'superscript',
  icon: [512, 512, [], "f12b", "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32z"]
};
var faBowlSpoon = {
  prefix: 'fas',
  iconName: 'bowl-spoon',
  icon: [512, 512, [129379], "e3e0", "M112 192C50.1 192 0 149 0 96S50.1 0 112 0c48.8 0 90.3 26.7 105.6 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H217.6c-15.4 37.3-56.9 64-105.6 64zM2 257.5C.9 239.3 15.4 224 33.6 224H478.4c18.2 0 32.7 15.3 31.6 33.5c-5.4 91.7-59.7 169.7-136.4 209.7l-1.2 9.7c-2.5 20-19.5 35-39.7 35H179.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C61.6 427.2 7.4 349.3 2 257.5z"]
};
var faHexagonCheck = {
  prefix: 'fas',
  iconName: 'hexagon-check',
  icon: [512, 512, [], "e416", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
var faPlugCircleXmark = {
  prefix: 'fas',
  iconName: 'plug-circle-xmark',
  icon: [576, 512, [], "e560", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faStarOfLife = {
  prefix: 'fas',
  iconName: 'star-of-life',
  icon: [512, 512, [], "f621", "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z"]
};
var faPhoneSlash = {
  prefix: 'fas',
  iconName: 'phone-slash',
  icon: [640, 512, [], "f3dd", "M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 107.4 37.8 206 100.8 283.1L9.2 469.1c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7s-23.3-12.3-33.7-4.1L253 278c-17.8-21.5-32.9-45.2-45-70.7L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96zm96.8 319l-91.3 72C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3z"]
};
var faTrafficLightStop = {
  prefix: 'fas',
  iconName: 'traffic-light-stop',
  icon: [320, 512, [], "f63a", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm72 368a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM160 216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-128a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
var faPaintRoller = {
  prefix: 'fas',
  iconName: 'paint-roller',
  icon: [512, 512, [], "f5aa", "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 352c0-17.7 14.3-32 32-32V304c0-44.2 35.8-80 80-80H416c17.7 0 32-14.3 32-32V160 69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352z"]
};
var faAccentGrave = {
  prefix: 'fas',
  iconName: 'accent-grave',
  icon: [192, 512, [], "60", "M108.3 204.8L41.2 95c-6-9.8-9.2-21.2-9.2-32.7C32 28.1 59.7 0 93.9 0c29.2 0 54.4 20.4 60.6 49l27.1 126.6C187 200.5 168 224 142.5 224c-14 0-26.9-7.3-34.2-19.2z"]
};
var faHandshakeAngle = {
  prefix: 'fas',
  iconName: 'handshake-angle',
  icon: [640, 512, ["hands-helping"], "f4c4", "M544 248v3.3l69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5H296c-37.1 0-67.6 28-71.6 64H224V248c0 22.1 17.9 40 40 40s40-17.9 40-40V176c0 0 0-.1 0-.1V160l16 0 136 0c0 0 0 0 .1 0H464c44.2 0 80 35.8 80 80v8zM336 192v56c0 39.8-32.2 72-72 72s-72-32.2-72-72V129.4c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1H384c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16H432c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8v-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"]
};
var faHandsHelping = faHandshakeAngle;
var faCircle0 = {
  prefix: 'fas',
  iconName: 'circle-0',
  icon: [512, 512, [], "e0ed", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48V224c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faDialMedLow = {
  prefix: 'fas',
  iconName: 'dial-med-low',
  icon: [576, 512, [], "e160", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM174.6 400.5c-56.7-56.7-62-145.4-15.7-208L270.8 304.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L192.8 158.5c62.6-46.2 151.3-41 208 15.7c62.5 62.5 62.5 163.8 0 226.3s-163.8 62.5-226.3 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faLocationDot = {
  prefix: 'fas',
  iconName: 'location-dot',
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faMapMarkerAlt = faLocationDot;
var faCrab = {
  prefix: 'fas',
  iconName: 'crab',
  icon: [512, 512, [129408], "e3ff", "M128 0C60 0 4.4 53 .2 120c0 .2 0 .3 0 .5L0 128H7.9l.1 0H0v33.3c0 28.1 16.3 53.6 41.8 65.4L98.9 253c-3.7 6-6.9 12.4-9.6 19H51.8L23.2 257.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l32 16c2.2 1.1 4.7 1.7 7.2 1.7H81c-.7 5.2-1 10.6-1 16v9.8l-21.1 7c-2.4 .8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L72.6 366l28-9.3 30.7 30.7L90.9 400.8c-2.4 .8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L104.6 430l52-17.3 15.7 15.7-36.6 21.9c-4.8 2.9-7.8 8.1-7.8 13.7v32c0 8.8 7.2 16 16 16s16-7.2 16-16V473.1L201.8 448H310.2L352 473.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V464c0-5.6-3-10.8-7.8-13.7l-36.6-21.9 15.7-15.7 52 17.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-40.4-13.5 30.7-30.7 28 9.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-21.1-7V320c0-5.4-.3-10.8-1-16h33c2.5 0 4.9-.6 7.2-1.7l32-16c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L460.2 272H422.7c-2.7-6.6-5.9-13-9.6-19l57.1-26.3c25.5-11.8 41.8-37.3 41.8-65.4V128h-8c0 0 .1 0 .1 0H512l-.2-7.5c0-.1 0-.3 0-.4l0 0 0 0C507.6 53 452 0 384 0H339.3c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c5 5 1.5 13.7-5.7 13.7H328c-4.4 0-8.1 3.6-7.5 8c3.9 31.6 30.9 56 63.5 56h80v33.3c0 9.4-5.4 17.9-13.9 21.8L378.7 216c-16.9-12.2-37-20.3-58.7-23V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H224V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v49c-21.7 2.7-41.7 10.9-58.7 23L61.9 183.1C53.4 179.2 48 170.6 48 161.3V128h80c32.6 0 59.6-24.4 63.5-56c.5-4.4-3.1-8-7.5-8H147.3c-7.1 0-10.7-8.6-5.7-13.7l36.7-36.7c5-5 1.5-13.7-5.7-13.7H128z"]
};
var faBoxOpenFull = {
  prefix: 'fas',
  iconName: 'box-open-full',
  icon: [640, 512, ["box-full"], "f49c", "M508.9 64.9l-27.5 73.4L320 158.5l-7.2-.9c4.6-8.8 7.2-18.9 7.2-29.6c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.1 .6 10 1.7 14.7l-65.5-8.2c-.1-2.2-.2-4.3-.2-6.5C128 57.3 185.3 0 256 0c69.6 0 126.2 55.6 128 124.7l35.1-93.6c9.3-24.8 37-37.4 61.8-28.1s37.4 37 28.1 61.8zM576 338.3v83.4c0 14.7-10 27.5-24.2 31L335.5 506.8c-10.2 2.6-20.9 2.6-31 0L88.2 452.8C74 449.2 64 436.4 64 421.7V338.3l127.6 36.5c27.8 8 57.6-3.8 72.5-28.6L320 252.9l55.9 93.2c14.9 24.8 44.6 36.6 72.5 28.6L576 338.3zM58.9 168.8c3-6.1 9.6-9.6 16.3-8.7L320 190.7l244.8-30.6c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 344c-13.9 4-28.8-1.9-36.2-14.3L320 190.7l-83.4 139c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 297.3c-19.3-5.5-28.8-27.2-19.8-45.1l41.7-83.4z"]
};
var faBoxFull = faBoxOpenFull;
var faFile = {
  prefix: 'fas',
  iconName: 'file',
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"]
};
var faGreaterThan = {
  prefix: 'fas',
  iconName: 'greater-than',
  icon: [384, 512, [62769], "3e", "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"]
};
var faQuotes = {
  prefix: 'fas',
  iconName: 'quotes',
  icon: [576, 512, [], "e234", "M88 0C39.4 0 0 39.4 0 88v56 24 24c0 26.5 21.5 48 48 48H96c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H64V88c0-13.3 10.7-24 24-24h8c17.7 0 32-14.3 32-32s-14.3-32-32-32H88zM264 0c-48.6 0-88 39.4-88 88v56 24 24c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H240V88c0-13.3 10.7-24 24-24h8c17.7 0 32-14.3 32-32s-14.3-32-32-32h-8zM576 424V368 344 320c0-26.5-21.5-48-48-48H480c-26.5 0-48 21.5-48 48v48c0 26.5 21.5 48 48 48h32v8c0 13.3-10.7 24-24 24h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8c48.6 0 88-39.4 88-88zM312 512c48.6 0 88-39.4 88-88V368 344 320c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v48c0 26.5 21.5 48 48 48h32v8c0 13.3-10.7 24-24 24h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8z"]
};
var faPretzel = {
  prefix: 'fas',
  iconName: 'pretzel',
  icon: [512, 512, [129384], "e441", "M138.6 32C62.1 32 0 94.1 0 170.6C0 253.3 40.9 326.5 103.7 371L71.3 417C58.6 435 62.9 460 81 472.7s43 8.4 55.7-9.7l40-56.8c21.8 6.4 44.9 9.8 68.7 9.8H256h10.6c23.9 0 46.9-3.4 68.7-9.8l40 56.8c12.7 18.1 37.7 22.4 55.7 9.7s22.4-37.7 9.7-55.7l-32.4-46C471.1 326.5 512 253.3 512 170.6C512 94.1 449.9 32 373.4 32H364c-42.6 0-81 18-108 46.8C229 50 190.6 32 148 32h-9.4zM216 180v7.4c0 15.5-4.8 30.7-13.7 43.4l-52.5 74.7C107.5 275.6 80 226.3 80 170.6c0-32.4 26.2-58.6 58.6-58.6H148c37.6 0 68 30.4 68 68zm40 113.5L285.2 335c-6.1 .7-12.3 1-18.6 1H256 245.4c-6.3 0-12.5-.3-18.6-1L256 293.5zm53.7-62.6C300.8 218.2 296 203 296 187.4V180c0-37.6 30.4-68 68-68h9.4c32.4 0 58.6 26.2 58.6 58.6c0 55.7-27.5 105-69.7 134.9l-52.5-74.7z"]
};
var faPersonSwimming = {
  prefix: 'fas',
  iconName: 'person-swimming',
  icon: [576, 512, [127946, "swimmer"], "f5c4", "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faSwimmer = faPersonSwimming;
var faArrowDown = {
  prefix: 'fas',
  iconName: 'arrow-down',
  icon: [384, 512, [8595], "f063", "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
};
var faUserRobotXmarks = {
  prefix: 'fas',
  iconName: 'user-robot-xmarks',
  icon: [448, 512, [], "e4a7", "M224 0c8.8 0 16 7.2 16 16V64h64c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h64V16c0-8.8 7.2-16 16-16zM16 144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm400-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 352H352c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32H352V448c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32-14.3-32-32V448c0-53 43-96 96-96zm80 112v48H144V464c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v48H208V464c0-8.8 7.2-16 16-16zm80 16v48H272V464c0-8.8 7.2-16 16-16s16 7.2 16 16zM119.5 119.5c-4.7 4.7-4.7 12.3 0 17L143 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L160 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L177 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L160 143l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0zm145 0c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17L271 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L288 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L305 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L288 143l-23.5-23.5z"]
};
var faMessageQuote = {
  prefix: 'fas',
  iconName: 'message-quote',
  icon: [512, 512, ["comment-alt-quote"], "e1e4", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm160 48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V192 168 144c0-17.7-14.3-32-32-32H160zm224 80V168 144c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V192z"]
};
var faCommentAltQuote = faMessageQuote;
var faCandyCorn = {
  prefix: 'fas',
  iconName: 'candy-corn',
  icon: [640, 512, [], "f6bd", "M440.6 256c9.8 25.6 19.6 49 28.7 67.2c3.3 6.7 6.2 12.4 9.3 17.7c.5 .8 1 1.7 1.4 2.4c.5-.8 1-1.6 1.4-2.4c3.1-5.3 6-11 9.3-17.7c9-18.2 18.9-41.5 28.7-67.2H440.6zM480 0c44.1 0 90.4 4.2 132.6 18.1C629 23.5 640 38.8 640 56c0 17.4-5.3 43.8-12.3 71.4c-4.4-1-9.3-2.1-14.5-3.1c-30.9-6.2-76-12.3-133.1-12.3s-102.2 6.1-133.1 12.3c-5.3 1.1-10.1 2.1-14.5 3.1c-7-27.6-12.3-54-12.3-71.4c0-17.2 11.4-32.6 27.8-38.1C390 4.4 436 0 480 0zM370.3 250.4c-11-30.8-21.3-62.9-29.6-92.1c3.8-.9 8-1.8 12.4-2.7c29.1-5.8 72-11.7 126.9-11.7s97.8 5.9 126.9 11.7c4.5 .9 8.6 1.8 12.4 2.7c-8.3 29.2-18.6 61.3-29.6 92.1c-13.2 37.2-27.9 73.6-41.6 101.3c-13.4 27-32.9 64.3-68.1 64.3s-54.6-37.3-68.1-64.3c-13.8-27.7-28.4-64.1-41.6-101.3zM83 211.1c30.4-30.4 65.3-59.4 103.9-79c15-7.5 33.1-4.6 45 7.3c12 12 26.6 33.9 40.7 57.7c-3.8 2.3-7.8 5-12.2 7.9c-25.6 17.1-60.9 43.9-100.3 83.3S94 363 76.9 388.6c-2.9 4.3-5.5 8.4-7.9 12.2C45.2 386.6 23.3 372 11.3 360C-.6 348.1-3.3 329.6 4.2 314.6C23.9 276.2 52.6 241.5 83 211.1zm97 248.2c-28.8-13.7-58-28.7-83.9-43c2-3.2 4.3-6.7 6.7-10.4c16-24 41.6-57.7 79.4-95.5S253.7 247 277.7 231c3.7-2.5 7.2-4.7 10.4-6.7c14.4 25.9 29.4 55.1 43.1 83.9c16.5 34.8 31.5 70 41.1 98.5c9.3 27.9 21.7 67-2.6 91.2s-63.4 11.9-91.2 2.6c-28.5-9.6-63.7-24.6-98.5-41.1zm52.3-44.6c24.4 11 47.3 20.2 66.1 26.5c6.9 2.3 12.8 4.2 18.6 5.8c.9 .2 1.8 .5 2.7 .7c-.2-.9-.4-1.7-.7-2.7c-1.5-5.8-3.4-11.7-5.8-18.6c-6.3-18.8-15.6-41.7-26.5-66.1l-54.4 54.4z"]
};
var faFolderMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'folder-magnifying-glass',
  icon: [512, 512, ["folder-search"], "e18b", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM336 272c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L327 393.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faFolderSearch = faFolderMagnifyingGlass;
var faNotebook = {
  prefix: 'fas',
  iconName: 'notebook',
  icon: [512, 512, [], "e201", "M64 48v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v80H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v80H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56c0 26.5 21.5 48 48 48h80V0H112C85.5 0 64 21.5 64 48zM432 0H224V512H432c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48z"]
};
var faDroplet = {
  prefix: 'fas',
  iconName: 'droplet',
  icon: [384, 512, [128167, "tint"], "f043", "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"]
};
var faTint = faDroplet;
var faBullseyePointer = {
  prefix: 'fas',
  iconName: 'bullseye-pointer',
  icon: [512, 512, [], "f649", "M256 448c106 0 192-86 192-192s-86-192-192-192S64 150 64 256c0 3.9 .1 7.8 .4 11.7L1.8 286.1C.6 276.2 0 266.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l18.4-62.6c3.9 .2 7.8 .4 11.7 .4zm2.3-48l19.7-67c33.5-9.6 58-40.4 58-76.9c0-44.2-35.8-80-80-80c-36.5 0-67.4 24.5-76.9 58L112 253.7C113.2 175.2 177.2 112 256 112c79.5 0 144 64.5 144 144c0 78.8-63.2 142.8-141.7 144zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5L36.4 338.2c-13-6.5-11.3-25.6 2.6-29.7z"]
};
var faEraser = {
  prefix: 'fas',
  iconName: 'eraser',
  icon: [576, 512, [], "f12d", "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"]
};
var faHexagonImage = {
  prefix: 'fas',
  iconName: 'hexagon-image',
  icon: [512, 512, [], "e504", "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36H344.3c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.7c-25.7 0-49.5 13.7-62.4 36L17.1 220zm141.2 59.8c4.5-4.9 10.8-7.7 17.4-7.8s13 2.6 17.6 7.4L232.2 320l71.6-86.2c4.6-5.5 11.3-8.7 18.5-8.7s13.9 3.2 18.5 8.7l72.6 87.4-55.2 95.7c-2.9 5-8.1 8-13.9 8l-176.6 0c-5.7 0-11-3-13.9-8l-46.8-81 51.2-56.1zM192 120a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faEarthAmericas = {
  prefix: 'fas',
  iconName: 'earth-americas',
  icon: [512, 512, [127758, "earth", "earth-america", "globe-americas"], "f57d", "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faEarth = faEarthAmericas;
var faEarthAmerica = faEarthAmericas;
var faGlobeAmericas = faEarthAmericas;
var faCrateApple = {
  prefix: 'fas',
  iconName: 'crate-apple',
  icon: [512, 512, ["apple-crate"], "f6b1", "M160 54.9C160 24.6 184.6 0 214.9 0c5 0 9.1 4.1 9.1 9.1C224 39.4 199.4 64 169.1 64c-5 0-9.1-4.1-9.1-9.1zM32 171.4C32 127.8 52.4 80 96 80c15.6 0 34.1 5.9 47.2 11c10.7 4.2 22.8 4.2 33.5 0c13.1-5.1 31.6-11 47.2-11c43.6 0 64 47.8 64 91.4c0 7-.4 13.9-1.2 20.6H33.2c-.8-6.7-1.2-13.5-1.2-20.6zM319 192c.7-6.7 1-13.6 1-20.6c0-26.1-6-55.1-20.3-78.6c-2.7-4.4-5.7-8.7-9-12.7c15 .6 32.2 6.1 44.6 11c10.7 4.2 22.8 4.2 33.5 0c13.1-5.1 31.6-11 47.2-11c43.6 0 64 47.8 64 91.4c0 7-.4 13.9-1.2 20.6H319zM406.9 0c5 0 9.1 4.1 9.1 9.1C416 39.4 391.4 64 361.1 64c-5 0-9.1-4.1-9.1-9.1C352 24.6 376.6 0 406.9 0zM0 272c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48v80H0V272zM0 384H512v80c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V384zm80-96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM464 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faAppleCrate = faCrateApple;
var faPersonBurst = {
  prefix: 'fas',
  iconName: 'person-burst',
  icon: [640, 512, [], "e53b", "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"]
};
var faGameBoard = {
  prefix: 'fas',
  iconName: 'game-board',
  icon: [448, 512, [], "f867", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 0v80h80V96H144zm0 160V176H64v80h80zm80 0H144v80H64v80h80V336h80v80h80V336h80V256H304V176h80V96H304v80H224v80zm0 0h80v80H224V256z"]
};
var faHatChef = {
  prefix: 'fas',
  iconName: 'hat-chef',
  icon: [512, 512, [], "f86b", "M153.6 51.2C177 20.1 214.1 0 256 0s79 20.1 102.4 51.2c16-12.1 36-19.2 57.6-19.2c7.1 0 14.4 .8 21.6 2.5C482 44.7 512 84.3 512 128c0 7.1-.8 14.4-2.5 21.6C496 224 448 320 448 320H373.6l26.2-157.4c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2L341.1 320H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16V320H170.9L143.8 157.4c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4L138.4 320H64s-48-96-61.5-170.4C.8 142.4 0 135.1 0 128c0-43.7 30-83.3 74.4-93.5C81.6 32.8 88.9 32 96 32c21.6 0 41.6 7.1 57.6 19.2zM448 448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V352H448v96z"]
};
var faHandBackPointRight = {
  prefix: 'fas',
  iconName: 'hand-back-point-right',
  icon: [512, 512, [], "e1a1", "M512 168c0-22.1-17.9-40-40-40l-200 0-7 0-73 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l55.7 0c-1.4-2-3-3.9-4.5-5.8L227.2 71C215 56.4 197 48 178 48L140 48c-38 0-74 16.9-98.3 46.1l-4.5 5.4C13.1 128.3 0 164.5 0 201.9L0 320c0 70.7 57.3 128 128 128l64 0 32 0c26.5 0 48-21.5 48-48c0-12.4-4.7-23.6-12.3-32.1C284.5 366 304 345.3 304 320c0-12.4-4.7-23.6-12.3-32.1C316.5 286 336 265.3 336 240c0-12.3-4.6-23.5-12.2-32L472 208c22.1 0 40-17.9 40-40z"]
};
var faDove = {
  prefix: 'fas',
  iconName: 'dove',
  icon: [512, 512, [128330], "f4ba", "M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6V138.8C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v30.6l0 0v1.3l0 0 0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faSnowflakeDroplets = {
  prefix: 'fas',
  iconName: 'snowflake-droplets',
  icon: [640, 512, [], "e5c1", "M320 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.7 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L383.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 21.5 12.6-29.3 57-22.7-13.2 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L352 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L145 395.1l-29.3-57 21.5-12.6-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L256.5 256l-60.9-35.5-67.7 18.1c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8-25.3-14.8c-15.3-8.9-20.4-28.5-11.5-43.8s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L288 200.3V129.9L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32zM519.1 418.1l47.5-92.4c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5c0 35.3-28.7 64.3-64 64.3s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5zM54.7 325.7c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5C128 483 99.3 512 64 512s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5l47.5-92.4z"]
};
var faBatteryEmpty = {
  prefix: 'fas',
  iconName: 'battery-empty',
  icon: [576, 512, ["battery-0"], "f244", "M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z"]
};
var faBattery0 = faBatteryEmpty;
var faGrid4 = {
  prefix: 'fas',
  iconName: 'grid-4',
  icon: [448, 512, [], "e198", "M0 48c0-8.8 7.2-16 16-16H73.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V48zM0 167.5c0-8.8 7.2-16 16-16H73.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V167.5zM16 270.9H73.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V286.9c0-8.8 7.2-16 16-16zM0 406.4c0-8.8 7.2-16 16-16H73.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V406.4zM119.5 48c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H135.5c-8.8 0-16-7.2-16-16V48zm0 119.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H135.5c-8.8 0-16-7.2-16-16V167.5zm16 103.5h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H135.5c-8.8 0-16-7.2-16-16V286.9c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H135.5c-8.8 0-16-7.2-16-16V406.4zM254.9 32h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H254.9c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm0 119.5h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H254.9c-8.8 0-16-7.2-16-16V167.5c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H254.9c-8.8 0-16-7.2-16-16V286.9zm16 103.5h57.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H254.9c-8.8 0-16-7.2-16-16V406.4c0-8.8 7.2-16 16-16zM358.4 48c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H374.4c-8.8 0-16-7.2-16-16V48zm0 119.5c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H374.4c-8.8 0-16-7.2-16-16V167.5zm16 103.5H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H374.4c-8.8 0-16-7.2-16-16V286.9c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H374.4c-8.8 0-16-7.2-16-16V406.4z"]
};
var faSocks = {
  prefix: 'fas',
  iconName: 'socks',
  icon: [512, 512, [129510], "f696", "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64H288V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0H176c-26.5 0-48 21.5-48 48V64zM320 96V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96H320zM512 64V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V64H512z"]
};
var faFaceSunglasses = {
  prefix: 'fas',
  iconName: 'face-sunglasses',
  icon: [512, 512, [], "e398", "M256 512c141.4 0 256-114.6 256-256c0-16.6-1.6-32.8-4.6-48.5l2.6-15.7c7.9-47.6-20.5-91.8-63.3-106.6C399.8 32.9 331.8 0 256 0S112.2 32.9 65.3 85.2C22.4 100-6 144.2 2 191.8l2.6 15.7C1.6 223.2 0 239.4 0 256C0 397.4 114.6 512 256 512zM183.3 272H104.7c-23.5 0-43.5-17-47.3-40.1l-8-48C44.4 154.6 67 128 96.7 128h94.7c14.4 0 27.1 6.2 35.8 16h57.8c8.7-9.8 21.4-16 35.8-16h94.7c29.7 0 52.2 26.6 47.3 55.9l-8 48C450.8 255 430.8 272 407.3 272H328.7c-23.5 0-43.5-17-47.3-40.1l-8-48c-.4-2.7-.7-5.3-.7-7.9H239.3c0 2.6-.2 5.2-.7 7.9l-8 48C226.8 255 206.8 272 183.3 272zm-19.2 69.5C182 362.2 212.6 384 256 384s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 388.1 311.1 416 256 416s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6z"]
};
var faInbox = {
  prefix: 'fas',
  iconName: 'inbox',
  icon: [512, 512, [], "f01c", "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"]
};
var faSquare0 = {
  prefix: 'fas',
  iconName: 'square-0',
  icon: [448, 512, [], "e255", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48V224c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faSection = {
  prefix: 'fas',
  iconName: 'section',
  icon: [256, 512, [], "e447", "M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C22.3 194.2 6.5 215.1 1.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31l0 0 3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2l0 0c-4.3-1.5-8.5-2.9-12.3-4.2C25.3 420 7.2 429.1 1.6 445.8s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6l0 0 .2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"]
};
var faSquareThisWayUp = {
  prefix: 'fas',
  iconName: 'square-this-way-up',
  icon: [448, 512, ["box-up"], "f49f", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM80 384H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM265.4 192c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L306.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4H352V304c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V192H265.4zm-192 0c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L114.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4H160V304c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V192H73.4z"]
};
var faBoxUp = faSquareThisWayUp;
var faGaugeHigh = {
  prefix: 'fas',
  iconName: 'gauge-high',
  icon: [512, 512, [62461, "tachometer-alt", "tachometer-alt-fast"], "f625", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAlt = faGaugeHigh;
var faTachometerAltFast = faGaugeHigh;
var faSquareAmpersand = {
  prefix: 'fas',
  iconName: 'square-ampersand',
  icon: [448, 512, [], "e260", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM184 191.6c0 4.1 1.6 8.1 4.6 11L203 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2H199.6c-8.6 0-15.6 7-15.6 15.6zm71 46.9l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L329 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4H178.5c-36.7 0-66.5-29.8-66.5-66.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9c0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z"]
};
var faEnvelopeOpenText = {
  prefix: 'fas',
  iconName: 'envelope-open-text',
  icon: [512, 512, [], "f658", "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faLampDesk = {
  prefix: 'fas',
  iconName: 'lamp-desk',
  icon: [512, 512, [], "e014", "M192 65.9C192 29.5 221.5 0 257.9 0c17.5 0 34.3 6.9 46.6 19.3L349.3 64H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-73.5 73.5-45.1 45.1-73.5 73.5c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V173.3l-92.6 92.6L209 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H184.7c-.5 0-.9 0-1.4 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H143L97 263.8c-2.7-10.9 .5-22.4 8.4-30.4L218.7 120l-7.4-7.4C198.9 100.2 192 83.4 192 65.9zM432 288c-14.7 0-27.8-6.6-36.6-16.9l67.7-67.7c10.3 8.8 16.9 21.9 16.9 36.6c0 26.5-21.5 48-48 48z"]
};
var faHospital = {
  prefix: 'fas',
  iconName: 'hospital',
  icon: [640, 512, [127973, 62589, "hospital-alt", "hospital-wide"], "f0f8", "M192 48c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48V512H368V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H192V48zM48 96H160V512H48c-26.5 0-48-21.5-48-48V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V144c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v48H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V464c0 26.5-21.5 48-48 48H480V96H592zM312 64c-8.8 0-16 7.2-16 16v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152h24c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H344V80c0-8.8-7.2-16-16-16H312z"]
};
var faHospitalAlt = faHospital;
var faHospitalWide = faHospital;
var faPollPeople = {
  prefix: 'fas',
  iconName: 'poll-people',
  icon: [640, 512, [], "f759", "M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zm448 80H480V96h96v32zM272 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H272zM576 416H352V384H576v32zM272 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H272zM64 128c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64zm64 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64z"]
};
var faWhiskeyGlassIce = {
  prefix: 'fas',
  iconName: 'whiskey-glass-ice',
  icon: [512, 512, ["glass-whiskey-rocks"], "f7a1", "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM417 283.7c9.6 9.6 15 22.7 15 36.3s-5.4 26.7-15 36.3L356.3 417c-9.6 9.6-22.7 15-36.3 15s-26.7-5.4-36.3-15l-49-49H160c-35.3 0-64-28.7-64-64V281.1L69 96H443L415.8 282.5l1.2 1.2zM160 208c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h50.6c-1.7-5.1-2.6-10.5-2.6-16c0-13.6 5.4-26.7 15-36.3l33-33V240c0-17.7-14.3-32-32-32H160zm85.7 98.3C242 310 240 314.9 240 320s2 10 5.7 13.7l60.7 60.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l60.7-60.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-60.7-60.7C330 242 325.1 240 320 240s-10 2-13.7 5.7l-60.7 60.7z"]
};
var faGlassWhiskeyRocks = faWhiskeyGlassIce;
var faWineBottle = {
  prefix: 'fas',
  iconName: 'wine-bottle',
  icon: [512, 512, [], "f72f", "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"]
};
var faChessRook = {
  prefix: 'fas',
  iconName: 'chess-rook',
  icon: [448, 512, [9820], "f447", "M32 192V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V192c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144H80L96 256 44.8 217.6C36.7 211.6 32 202.1 32 192zm176 96h32c8.8 0 16-7.2 16-16V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM22.6 473.4L64 432H384l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H38.6C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z"]
};
var faUserBountyHunter = {
  prefix: 'fas',
  iconName: 'user-bounty-hunter',
  icon: [448, 512, [], "e2bf", "M323 120C309.4 78 270 48 224 48s-85.4 30-99 72H323zm5.5 36.4L248 171.5v98.4l9.5-1.9c7.6-49.7 42.9-81.5 71.9-97.8l-.9-13.8zm-209 0l-.9 13.8c29 16.3 64.2 48.1 71.9 97.8l9.5 1.9V171.5l-80.5-15.1zM96 70C123.1 27.7 170.5 0 224 0c80.1 0 146.5 62.2 151.7 142.2L383 256.5c1.3 20-12.4 37.9-32.1 41.8L250.1 318.4c-5.2 1-10.4 1.6-15.7 1.6H213.5c-5.3 0-10.5-.5-15.7-1.6L97 298.3c-16.2-3.2-28.4-16-31.4-31.6c-1-3.4-1.6-7-1.6-10.7V16C64 7.2 71.2 0 80 0H96c8.8 0 16 7.2 16 16s-7.2 16-16 16V70zm38.4 282H313.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352zm37.1 103.4c-3.7 2.8-1.7 8.6 2.9 8.6h99.2c4.6 0 6.6-5.9 2.9-8.6l-47.7-35.8c-2.8-2.1-6.8-2.1-9.6 0l-47.7 35.8z"]
};
var faBarsStaggered = {
  prefix: 'fas',
  iconName: 'bars-staggered',
  icon: [512, 512, ["reorder", "stream"], "f550", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
};
var faReorder = faBarsStaggered;
var faStream = faBarsStaggered;
var faDiagramSankey = {
  prefix: 'fas',
  iconName: 'diagram-sankey',
  icon: [576, 512, [], "e158", "M294.4 44.8c6-8.1 15.5-12.8 25.6-12.8H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H336L249.6 211.2c-6 8.1-15.5 12.8-25.6 12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H208L294.4 44.8zM141.9 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H216.5l57.6 96H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-11.2 0-21.7-5.9-27.4-15.5L141.9 320z"]
};
var faCloudHailMixed = {
  prefix: 'fas',
  iconName: 'cloud-hail-mixed',
  icon: [512, 512, [], "f73a", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-10.3 24c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l10.3-24c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm232 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zM326.1 385.5l-10.3 24c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l10.3-24c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCircleUpLeft = {
  prefix: 'fas',
  iconName: 'circle-up-left',
  icon: [512, 512, [], "e128", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 313.4V176c0-8.8 7.2-16 16-16H313.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L296 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C322 366 317.1 368 312 368s-10-2-13.7-5.7L232 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6z"]
};
var faDharmachakra = {
  prefix: 'fas',
  iconName: 'dharmachakra',
  icon: [512, 512, [9784], "f655", "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faObjectsAlignLeft = {
  prefix: 'fas',
  iconName: 'objects-align-left',
  icon: [512, 512, [], "e3be", "M0 24L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24L48 24C48 10.7 37.3 0 24 0S0 10.7 0 24zM176 64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48L176 64zm0 224c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H176z"]
};
var faOilCanDrip = {
  prefix: 'fas',
  iconName: 'oil-can-drip',
  icon: [640, 512, [], "e205", "M352 96c0 17.7-14.3 32-32 32H288v32h80.9c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48V346.7l-67.5-30C11.2 309 0 291.8 0 272.8V208c0-26.5 21.5-48 48-48H96h48 80V128H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H320c17.7 0 32 14.3 32 32zM48 208v64.8l48 21.3V208H48zM592 448c-26.5 0-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8c5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400c0 32-21.5 48-48 48z"]
};
var faFaceSmilingHands = {
  prefix: 'fas',
  iconName: 'face-smiling-hands',
  icon: [640, 512, [], "e396", "M411.1 495.3c-17-21.6-27.1-48.9-27.1-78.5V386c-18.1 8.4-39.4 14-64 14s-45.9-5.6-64-14v30.8c0 29.6-10.1 56.9-27.1 78.5c28.3 10.8 59 16.7 91.1 16.7s62.8-5.9 91.1-16.7zM320 0C183.1 0 71.3 107.5 64.3 242.6c16.8-5.8 36.2-2 49.6 11.4L161 301.1c9.4-13.7 25.1-22.7 43-22.7c28.7 0 52 23.3 52 52v19.2c16.8 10.6 38.1 18.4 64 18.4s47.2-7.7 64-18.4V330.4c0-28.7 23.3-52 52-52c17.9 0 33.6 9 43 22.7l47.1-47.1c13.4-13.4 32.8-17.2 49.6-11.4C568.7 107.5 456.9 0 320 0zM281.6 228.8l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zm160 0l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zM68.7 299.3L120 350.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L43.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L88 382.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L56 414.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 404.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.8 56.8C79.3 502 103.6 512 128.8 512c52.6 0 95.2-42.6 95.2-95.2V384 330.4c0-11-9-20-20-20s-20 9-20 20v19.7c0 7.1-8.6 10.7-13.7 5.7l-79-79c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zm502.6 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7V330.4c0-11-9-20-20-20s-20 9-20 20V384v32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L593.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L561.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L529.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3z"]
};
var faBroccoli = {
  prefix: 'fas',
  iconName: 'broccoli',
  icon: [512, 512, [129382], "e3e2", "M0 256c0 53 43 96 96 96H416c53 0 96-43 96-96c0-45.5-31.6-83.6-74.1-93.5c6.4-10 10.1-21.8 10.1-34.5c0-35.3-28.7-64-64-64c-12.7 0-24.6 3.7-34.5 10.1C339.6 31.6 301.5 0 256 0s-83.6 31.6-93.5 74.1C152.6 67.7 140.7 64 128 64c-35.3 0-64 28.7-64 64c0 12.7 3.7 24.6 10.1 34.5C31.6 172.4 0 210.5 0 256zM192.2 490.3c5 12.8 17.1 21.7 30.9 21.7h65.9c13.8 0 25.9-8.9 30.9-21.7c17.6-45.3 39.6-82.1 56.1-106.3H280l-16.8 33.7c-2.9 5.9-11.4 5.9-14.3 0L232 384H136.1c16.5 24.2 38.5 60.9 56.1 106.3z"]
};
var faRouteInterstate = {
  prefix: 'fas',
  iconName: 'route-interstate',
  icon: [512, 512, [], "f61b", "M85.3 192h341c-.8 44.3-7.9 81.8-21.9 114.4c-23.4 54.1-68.5 99.1-149 138.5c-81.5-36.2-126.1-80.9-149-135.4c-14-33.3-20.6-72-21-117.4zM276.9 7.3c-12.8-7.8-29-7.8-41.8 0c-27.5 16.8-50.2 26-73.4 30c-23.3 4-49.2 3.2-83.7-3.2C55.9 30 34.4 45 31.1 67.7C16 170.4 15.9 259.5 47.3 334.2c32.1 76.4 94.6 132.5 193 173.9c10.4 4.4 22.3 4.1 32.5-.6c95.7-44.8 157.8-100.7 190.3-175.7c32-73.9 32.9-161.2 17.8-264.1C477.6 45.1 456.1 30 434 34.1c-34.4 6.3-60.3 7.2-83.7 3.2c-23.2-4-45.9-13.2-73.4-30z"]
};
var faEarMuffs = {
  prefix: 'fas',
  iconName: 'ear-muffs',
  icon: [640, 512, [], "f795", "M320 64c-78.2 0-143.3 56.1-157.2 130.2c-6-1.4-12.3-2.2-18.8-2.2c-17.7 0-34.1 5.8-47.4 15.6C105 91.5 201.8 0 320 0S535 91.5 543.4 207.6C530.1 197.8 513.7 192 496 192c-6.5 0-12.7 .8-18.8 2.2C463.3 120.1 398.2 64 320 64zM179.8 304c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48c-22.1 0-40.8-15-46.3-35.4C92.2 478.8 86.2 480 80 480c-26.5 0-48-21.5-48-48c0-6.2 1.2-12.2 3.4-17.7C15 408.8 0 390.1 0 368s15-40.8 35.4-46.3C33.2 316.2 32 310.2 32 304c0-26.5 21.5-48 48-48c6.2 0 12.2 1.2 17.7 3.4C103.2 239 121.9 224 144 224c26.5 0 48 21.5 48 48c0 12.3-4.6 23.5-12.2 32zm280.4 0c-7.6-8.5-12.2-19.7-12.2-32c0-26.5 21.5-48 48-48c22.1 0 40.8 15 46.3 35.4c5.5-2.2 11.4-3.4 17.7-3.4c26.5 0 48 21.5 48 48c0 6.2-1.2 12.2-3.4 17.7C625 327.2 640 345.9 640 368s-15 40.8-35.4 46.3c2.2 5.5 3.4 11.4 3.4 17.7c0 26.5-21.5 48-48 48c-6.2 0-12.2-1.2-17.7-3.4C536.8 497 518.1 512 496 512c-26.5 0-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32z"]
};
var faHotdog = {
  prefix: 'fas',
  iconName: 'hotdog',
  icon: [512, 512, [127789], "f80f", "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l0 0v0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l0 0-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"]
};
var faTransporterEmpty = {
  prefix: 'fas',
  iconName: 'transporter-empty',
  icon: [512, 512, [], "e046", "M296 512h88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h88 80z"]
};
var faPersonWalkingWithCane = {
  prefix: 'fas',
  iconName: 'person-walking-with-cane',
  icon: [512, 512, ["blind"], "f29d", "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6v43.2c0 17 6.7 33.3 18.7 45.3L224 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L224 306.7V213.3l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128H167.6zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"]
};
var faBlind = faPersonWalkingWithCane;
var faAngle90 = {
  prefix: 'fas',
  iconName: 'angle-90',
  icon: [448, 512, [], "e08d", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V64zM96 97.6v48.3c31 3.6 60.4 12.5 87.4 25.7l25.3-41.1C174.2 113 136.2 101.6 96 97.6zm115.2 89.7c32.6 21 60.5 48.9 81.5 81.5l40.9-25.2c-25-39-58.2-72.2-97.2-97.2l-25.2 40.9zM334.1 384h48.3c-4-40.2-15.4-78.2-32.9-112.6l-41.1 25.3c13.2 26.9 22 56.3 25.7 87.4z"]
};
var faRectangleTerminal = {
  prefix: 'fas',
  iconName: 'rectangle-terminal',
  icon: [512, 512, [], "e236", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm102.3 55.8c-9 9.8-8.3 25 1.5 33.9L180.5 256l-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM248 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faKite = {
  prefix: 'fas',
  iconName: 'kite',
  icon: [640, 512, [129665], "f6f4", "M344 0c-14.9 0-27.8 10.3-31.2 24.8l-80 344c-.4 1.7-.7 3.5-.8 5.2l-85.4 85.4c-2.9 2.9-6.9 4.6-11 4.6c-8.6 0-15.6-7-15.6-15.6V359.8l-24-12-24 12v88.6c0 35.1 28.5 63.6 63.6 63.6c16.9 0 33-6.7 45-18.6L266 407.9c1.8-.1 3.5-.4 5.2-.8l344-80c14.5-3.4 24.8-16.3 24.8-31.2V32c0-17.7-14.3-32-32-32H344zM24 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h8c22.1 0 40 17.9 40 40v68L18.7 257.4c-1.8-.9-3.8-1.4-5.8-1.4C5.8 256 0 261.8 0 268.9v70.1C0 346.2 5.8 352 12.9 352c2 0 4-.5 5.8-1.4L72 324v0l9.7-4.8c4.5-2.3 9.4-3.4 14.3-3.4l.5 0c3.5 .1 7 .7 10.4 1.9c1.2 .4 2.3 .9 3.4 1.5l0 0L120 324l53.3 26.6c1.8 .9 3.8 1.4 5.8 1.4c7.1 0 12.9-5.8 12.9-12.9V268.9c0-7.1-5.8-12.9-12.9-12.9c-2 0-4 .5-5.8 1.4L120 284V216c0-48.6-39.4-88-88-88H24zM427.3 84.7L480 137.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L502.6 160l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L480 182.6 363.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 160l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faDrum = {
  prefix: 'fas',
  iconName: 'drum',
  icon: [512, 512, [129345], "f569", "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208V368c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24V463.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24V479.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24V446.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6z"]
};
var faScrubber = {
  prefix: 'fas',
  iconName: 'scrubber',
  icon: [512, 512, [], "f2f8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faIceCream = {
  prefix: 'fas',
  iconName: 'ice-cream',
  icon: [448, 512, [127848], "f810", "M367.1 160c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h53.5 181H368c26.5 0 48-21.5 48-48s-21.5-48-48-48h-.9zM96 288L200.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288H96z"]
};
var faHeartCircleBolt = {
  prefix: 'fas',
  iconName: 'heart-circle-bolt',
  icon: [576, 512, [], "e4fc", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
var faFishBones = {
  prefix: 'fas',
  iconName: 'fish-bones',
  icon: [576, 512, [], "e304", "M87.1 148.2c5.6 4.6 8.9 11.4 8.9 18.7V208h0v24h40V160c0-13.3 10.7-24 24-24s24 10.7 24 24v72h48V160c0-13.3 10.7-24 24-24s24 10.7 24 24v72h48V160c0-13.3 10.7-24 24-24s24 10.7 24 24v72h40V130.9c0-16.9 17.1-28.4 31.8-20c16 9.1 30.6 19.7 43.7 30.7c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8c-13.1 11-27.7 21.6-43.7 30.7c-14.7 8.4-31.8-3.1-31.8-20V280H376v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H280v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H184v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H96v24h0v41.1c0 7.2-3.3 14.1-8.9 18.7l-48 38.9c-8.8 7.1-21.3 7.1-30.1 .1s-11.5-19.2-6.6-29.3L54.9 266.6c3.3-6.7 3.3-14.5 0-21.2L2.5 138.6c-5-10.1-2.2-22.3 6.6-29.3s21.3-7 30.1 .1l48 38.9z"]
};
var faDeerRudolph = {
  prefix: 'fas',
  iconName: 'deer-rudolph',
  icon: [576, 512, [], "f78f", "M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 30.9 25.1 56 56 56h8 8 24l-50.4 12.6c-8 2-13.6 9.2-13.6 17.4c0 9.9 8 18 18 18h38l-9.6 32H196.3c-.8 0-1.7 0-2.5 0c-.6 0-1.2 0-1.7 0H128 113.9h-7.9C51.7 176 6.6 217.8 2.4 272L.1 302.2c-1 13.2 8.9 24.8 22.1 25.8c13 1 24.4-8.6 25.7-21.5c2.4 3.3 5.2 6.5 8.1 9.5c9 9 9 23.5 2.4 34.4c-17.4 28.6-21.5 63.9-10 96.3l15.5 44C68.4 503.4 80.5 512 94.1 512H128c22.1 0 37.5-21.8 30.2-42.6l-19.3-54.7c-2.2-6.2-.6-13 4-17.7l10.6-10.6c12.1-12.1 19.8-27.9 21.9-44.8c21 16.5 47.5 26.4 76.3 26.4H288V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V368 304l26.7-80H416h50.7c25 0 45.3-20.3 45.3-45.3c0-1.2 0-2.4-.1-3.6c2.6 .5 5.4 .8 8.1 .8c22.1 0 40-17.9 40-40s-17.9-40-40-40c-19.6 0-35.9 14.1-39.3 32.7L443.4 91.4c-.6-.6-1.1-1.1-1.7-1.6C459.7 80.4 472 61.7 472 40V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24H377.3 346.6c3.5-7.3 5.4-15.4 5.4-24V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24h-8-8c-13.3 0-24-10.7-24-24V16zM384 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faFax = {
  prefix: 'fas',
  iconName: 'fax',
  icon: [512, 512, [128224, 128439], "f1ac", "M128 64v96h64V64H386.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64zM0 160V480c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm480 32H128V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faParagraph = {
  prefix: 'fas',
  iconName: 'paragraph',
  icon: [448, 512, [182], "f1dd", "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"]
};
var faHeadSideHeart = {
  prefix: 'fas',
  iconName: 'head-side-heart',
  icon: [512, 512, [], "e1aa", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm112-35c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faSquareE = {
  prefix: 'fas',
  iconName: 'square-e',
  icon: [448, 512, [], "e26d", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V256 152c0-13.3 10.7-24 24-24z"]
};
var faMeterFire = {
  prefix: 'fas',
  iconName: 'meter-fire',
  icon: [640, 512, [], "e1eb", "M256 512c33.6 0 65.7-6.5 95.1-18.3c-39-35.9-63.1-87.5-63.1-143.7c0-35.2 16.3-73.6 37.2-107.4c4.4-7.1 9.1-14.2 14.1-21.3C327.9 216.5 320 205.2 320 192V160c0-17.7 14.3-32 32-32s32 14.3 32 32v7.4c9-9.4 18.5-18.6 28.5-27.5C430.2 124 457.3 124 475 140c5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm165.5 3.6c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8C332.7 291.3 320 325.6 320 352c0 87.8 70.3 159.8 160 159.8c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faCloudHail = {
  prefix: 'fas',
  iconName: 'cloud-hail',
  icon: [512, 512, [], "f739", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm0 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCheckToSlot = {
  prefix: 'fas',
  iconName: 'check-to-slot',
  icon: [576, 512, ["vote-yea"], "f772", "M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"]
};
var faVoteYea = faCheckToSlot;
var faMoneyFromBracket = {
  prefix: 'fas',
  iconName: 'money-from-bracket',
  icon: [640, 512, [], "e312", "M64 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 43 43 0 96 0H544c53 0 96 43 96 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7-14.3-32-32-32H96C78.3 64 64 78.3 64 96zm64 0l384 0 0 352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64l0-352zM256 448c0-35.3-28.7-64-64-64v64h64zm192-64c-35.3 0-64 28.7-64 64h64l0-64zM320 352c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80z"]
};
var faStarHalf = {
  prefix: 'fas',
  iconName: 'star-half',
  icon: [576, 512, [61731], "f089", "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zM429.9 512c1.1 .1 2.1 .1 3.2 0h-3.2z"]
};
var faCarBus = {
  prefix: 'fas',
  iconName: 'car-bus',
  icon: [640, 512, [], "f85a", "M32 416H48v32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V416h64V352c0-32.8 16.5-61.8 41.6-79.1L249.9 224H208V96h88c13.3 0 24 10.7 24 24v16.4c13.2-5.4 27.7-8.4 42.6-8.4H384V74.5c0-16.2-9.2-31-23.7-38.3C312.8 12.4 260.3 0 207.1 0H176.9C123.7 0 71.2 12.4 23.7 36.2C9.2 43.4 0 58.2 0 74.5V384c0 17.7 14.3 32 32 32zM88 96h88V224H88c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm8 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm266.6-72H501.4c6.9 0 13 4.4 15.2 10.9L534.3 288H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3l-26.6 79.7C238.8 304.7 224 326.6 224 352v96h0v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H560v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32l0-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSpeaker = {
  prefix: 'fas',
  iconName: 'speaker',
  icon: [384, 512, [], "f8df", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM304 336A112 112 0 1 0 80 336a112 112 0 1 0 224 0zM192 272a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faTimer = {
  prefix: 'fas',
  iconName: 'timer',
  icon: [512, 512, [], "e29e", "M256 0c-17.7 0-32 14.3-32 32V96c0 17.7 14.3 32 32 32s32-14.3 32-32V66.7C378.8 81.9 448 160.9 448 256c0 106-86 192-192 192S64 362 64 256c0-53.7 22-102.3 57.6-137.1c12.6-12.4 12.8-32.6 .5-45.3S89.5 60.8 76.8 73.1C29.5 119.6 0 184.4 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM193 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80z"]
};
var faBoxesStacked = {
  prefix: 'fas',
  iconName: 'boxes-stacked',
  icon: [576, 512, [62625, "boxes", "boxes-alt"], "f468", "M248 0H208c-26.5 0-48 21.5-48 48V160c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48H328V80c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V0zM64 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H184v80c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V256H64zM352 512H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H472v80c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V256H352c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2V464c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"]
};
var faBoxes = faBoxesStacked;
var faBoxesAlt = faBoxesStacked;
var faGrillHot = {
  prefix: 'fas',
  iconName: 'grill-hot',
  icon: [448, 512, [], "e5a5", "M120 0c13.3 0 24 10.7 24 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C181.3 60 192 80 192 101.4V104c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C106.7 68 96 48 96 26.6V24c0-13.3 10.7-24 24-24zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 78.1-46.6 145.3-113.6 175.3l47.7 111.2c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L327 472H155.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l7.5-17.5C46.6 337.3 0 270.1 0 192zM155.3 424H306.5l-18.3-42.7C277.7 383.1 267 384 256 384H192c-11 0-21.7-.9-32.2-2.7L147.5 410c3.2 4.3 5.8 9 7.8 14zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C293.3 60 304 80 304 101.4V104c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C218.7 68 208 48 208 26.6V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faBallotCheck = {
  prefix: 'fas',
  iconName: 'ballot-check',
  icon: [448, 512, [], "f733", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112zm0 256c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368zm144 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM192 128c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 112H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-52.7-27.3c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0l-24-24c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L96 249.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faLink = {
  prefix: 'fas',
  iconName: 'link',
  icon: [640, 512, [128279, "chain"], "f0c1", "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"]
};
var faChain = faLink;
var faEarListen = {
  prefix: 'fas',
  iconName: 'ear-listen',
  icon: [512, 512, ["assistive-listening-systems"], "f2a2", "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1-.1 0 0 0c0 0 0 0-14.3 28.6L398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faAssistiveListeningSystems = faEarListen;
var faFileMinus = {
  prefix: 'fas',
  iconName: 'file-minus',
  icon: [384, 512, [], "f318", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM120 304H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faTreeCity = {
  prefix: 'fas',
  iconName: 'tree-city',
  icon: [640, 512, [], "e587", "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80H160V480c0 18-15 32-32 32c-18 0-32-14-32-32V320H80c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"]
};
var faPlay = {
  prefix: 'fas',
  iconName: 'play',
  icon: [384, 512, [9654], "f04b", "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"]
};
var faFont = {
  prefix: 'fas',
  iconName: 'font',
  icon: [448, 512, [], "f031", "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"]
};
var faCupTogo = {
  prefix: 'fas',
  iconName: 'cup-togo',
  icon: [448, 512, ["coffee-togo"], "f6c5", "M55.2 17.7C60.6 6.8 71.7 0 83.8 0H364.2c12.1 0 23.2 6.8 28.6 17.7L416 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96S14.3 64 32 64L55.2 17.7zM74.7 453.8L48 160H400L373.3 453.8c-3 33-30.6 58.2-63.7 58.2H138.4c-33.1 0-60.7-25.2-63.7-58.2zM323.8 290.9c1.7-18.7-13.1-34.9-31.9-34.9H156c-18.8 0-33.6 16.2-31.9 34.9l8.7 96c1.5 16.5 15.3 29.1 31.9 29.1H283.2c16.6 0 30.4-12.6 31.9-29.1l8.7-96z"]
};
var faCoffeeTogo = faCupTogo;
var faSquareDownLeft = {
  prefix: 'fas',
  iconName: 'square-down-left',
  icon: [448, 512, [], "e26b", "M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zm64-281.4V336c0 8.8 7.2 16 16 16H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L264 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7C290 146 285.1 144 280 144s-10 2-13.7 5.7L200 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6z"]
};
var faBurgerLettuce = {
  prefix: 'fas',
  iconName: 'burger-lettuce',
  icon: [512, 512, [], "e3e3", "M32 194.9C32 211 45 224 61.1 224H450.9c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zM128 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm240 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 400v16c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V400c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm48-48c24.6 0 44.2-11.8 56.2-19c.9-.5 1.7-1 2.5-1.5c13.7-8.1 20.8-11.5 29.3-11.5c7.7 0 12.3 2.5 25.4 10.9l.2 .1c13 8.3 32.6 21 62.4 21c29.7 0 48.6-12.6 61-20.9l.8-.5c11.6-7.7 16.6-10.6 26.2-10.6c10.5 0 17.9 3.7 30.2 11.3c.9 .5 1.8 1.1 2.8 1.7c11.4 7.1 30.3 19 55 19c21.5 0 38.4-5.4 50.3-11.4c5.9-3 10.5-6 13.9-8.5c1.7-1.3 3.1-2.4 4.1-3.3c.5-.5 1-.9 1.4-1.2l.5-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-22.6-22.6l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3c-12.3-12.3-32-12.5-44.5-.7l-.3 .2c-.6 .5-2 1.4-4.1 2.5c-4.1 2-11.2 4.6-21.7 4.6c-5.2 0-9.2-2-24.2-11.3C394.1 268.3 373.5 256 344 256c-29.7 0-48.6 12.6-61 20.9l-.8 .5C270.6 285.1 265.7 288 256 288c-10 0-16.1-3.2-28-10.9l-1.8-1.1c-11.9-7.7-30.8-20-58.3-20c-27.7 0-48.4 12.3-61.6 20.2l-.5 .3C90.7 285.6 85.6 288 80 288c-10.5 0-17.6-2.6-21.7-4.6c-2.1-1-3.5-2-4.1-2.5l-.3-.2c-12.5-11.8-32.3-11.6-44.5 .7c-12.5 12.5-12.5 32.8 0 45.3l22.4-22.4C9.4 326.6 9.4 326.6 9.4 326.6l0 0 0 0 .1 .1 .2 .2 .5 .5c.4 .4 .8 .8 1.4 1.2c1.1 .9 2.4 2.1 4.1 3.3c3.4 2.5 8 5.6 13.9 8.5C41.6 346.6 58.5 352 80 352z"]
};
var faRupiahSign = {
  prefix: 'fas',
  iconName: 'rupiah-sign',
  icon: [512, 512, [], "e23d", "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112H352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 192c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96h48z"]
};
var faMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'magnifying-glass',
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
var faSearch = faMagnifyingGlass;
var faTableTennisPaddleBall = {
  prefix: 'fas',
  iconName: 'table-tennis-paddle-ball',
  icon: [640, 512, [127955, "ping-pong-paddle-ball", "table-tennis"], "f45d", "M480 288c-50.1 0-93.6 28.8-114.6 70.8L132.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C535.8 297.6 509 288 480 288zM113.3 151.9L354.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3H357c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L152.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32c-6.3-6.3-9.7-14.9-9.4-23.8s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8c-24-24-37.5-56.6-37.5-90.5v-2.7c0-22.8 6.1-44.9 17.3-64.3zM480 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faPingPongPaddleBall = faTableTennisPaddleBall;
var faTableTennis = faTableTennisPaddleBall;
var faPersonDotsFromLine = {
  prefix: 'fas',
  iconName: 'person-dots-from-line',
  icon: [576, 512, ["diagnoses"], "f470", "M288 176A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM78.7 372.9c15-12.5 50-34.4 97.3-50.1V432H400V322.7c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM224 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faDiagnoses = faPersonDotsFromLine;
var faChevronsDown = {
  prefix: 'fas',
  iconName: 'chevrons-down',
  icon: [512, 512, ["chevron-double-down"], "f322", "M278.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 402.7 425.4 233.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192zm192-384l-192 192c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 210.7 425.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"]
};
var faChevronDoubleDown = faChevronsDown;
var faTrashCanArrowUp = {
  prefix: 'fas',
  iconName: 'trash-can-arrow-up',
  icon: [448, 512, ["trash-restore-alt"], "f82a", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"]
};
var faTrashRestoreAlt = faTrashCanArrowUp;
var faSignalGood = {
  prefix: 'fas',
  iconName: 'signal-good',
  icon: [640, 512, ["signal-3"], "f68e", "M320 192c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faSignal3 = faSignalGood;
var faLocationQuestion = {
  prefix: 'fas',
  iconName: 'location-question',
  icon: [384, 512, ["map-marker-question"], "f60b", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM105.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 232.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V218.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMapMarkerQuestion = faLocationQuestion;
var faFloppyDiskCircleXmark = {
  prefix: 'fas',
  iconName: 'floppy-disk-circle-xmark',
  icon: [576, 512, ["floppy-disk-times", "save-circle-xmark", "save-times"], "e181", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H296.2c-17.6-21.4-30.3-46.9-36.3-75c-10.2 6.9-22.6 11-35.9 11c-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7 .2 16 .7V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faFloppyDiskTimes = faFloppyDiskCircleXmark;
var faSaveCircleXmark = faFloppyDiskCircleXmark;
var faSaveTimes = faFloppyDiskCircleXmark;
var faNairaSign = {
  prefix: 'fas',
  iconName: 'naira-sign',
  icon: [448, 512, [], "e1f6", "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H228.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H262.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zM185.5 256H128V169.7L185.5 256z"]
};
var faPeach = {
  prefix: 'fas',
  iconName: 'peach',
  icon: [512, 512, [], "e20b", "M344 80c-31.5 0-61.4 7.3-88 20.4C229.4 87.3 199.5 80 168 80c-11.4 0-22.6 1-33.5 2.8C120.5 67.2 112 46.6 112 24c0-13.3 10.7-24 24-24h24c53 0 96 43 96 96c0-53 43-96 96-96h24c13.3 0 24 10.7 24 24c0 22.6-8.5 43.2-22.5 58.8C366.6 81 355.4 80 344 80zM168 112c17.8 0 34.9 2.8 50.9 7.9c63 20 109.9 76.2 116.3 144.2c.8 8.8 7.9 16 16.8 16s16.1-7.2 15.4-16c-4.6-58.2-34.2-109.5-78-143c.8-.2 1.5-.5 2.3-.7c16.5-5.4 34-8.3 52.3-8.3c92.8 0 168 75.2 168 168c0 136.2-199.3 214.6-240.6 229.4c-5 1.8-10.1 2.6-15.4 2.6s-10.4-.8-15.4-2.6C199.3 494.6 0 416.2 0 280c0-92.8 75.2-168 168-168z"]
};
var faTaxiBus = {
  prefix: 'fas',
  iconName: 'taxi-bus',
  icon: [640, 512, [], "e298", "M48 416H32c-17.7 0-32-14.3-32-32V74.5c0-16.2 9.2-31 23.7-38.3C71.2 12.4 123.7 0 176.9 0h30.3c53.2 0 105.6 12.4 153.2 36.2C374.8 43.4 384 58.2 384 74.5V96c-21.9 0-40.4 14.7-46.2 34.8c-6.1 1.4-12.1 3.3-17.8 5.6V120c0-13.3-10.7-24-24-24H208V224h41.9l-16.3 48.9C208.5 290.2 192 319.2 192 352v64H128v32c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V416zM64 120v80c0 13.3 10.7 24 24 24h88V96H88c-13.3 0-24 10.7-24 24zm56 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM368 152c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v8h5.4c34.4 0 65 22 75.9 54.7l26.6 79.7C625.2 304.7 640 326.6 640 352l0 96v32c0 17.7-14.3 32-32 32H592c-17.7 0-32-14.3-32-32V448H304v32c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V448h0V352c0-25.4 14.8-47.3 36.1-57.6l26.6-79.7C297.6 182 328.2 160 362.6 160H368v-8zm-20.6 82.9L329.7 288H534.3l-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9H362.6c-6.9 0-13 4.4-15.2 10.9zM328 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBracketCurly = {
  prefix: 'fas',
  iconName: 'bracket-curly',
  icon: [256, 512, ["bracket-curly-left"], "7b", "M64 128c0-53 43-96 96-96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32 14.3-32 32v37.5c0 25.5-10.1 49.9-28.1 67.9L77.3 256l22.6 22.6c18 18 28.1 42.4 28.1 67.9V384c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-53 0-96-43-96-96V346.5c0-8.5-3.4-16.6-9.4-22.6L9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l45.3-45.3c6-6 9.4-14.1 9.4-22.6V128z"]
};
var faBracketCurlyLeft = faBracketCurly;
var faLobster = {
  prefix: 'fas',
  iconName: 'lobster',
  icon: [512, 512, [129438], "e421", "M80 8.2c0-3.7-2.5-6.9-6.1-7.5C70.7 .3 67.4 0 64 0C28.7 0 0 28.7 0 64v64c0 35.3 28.7 64 64 64l.7 0 41.8 27.9C126.2 233 149.4 240 173.1 240H192v16H143.1c-7.5 0-14.8-1.7-21.5-5.1L87.2 233.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4H192v16H122.4c-5.2 0-10.3-.8-15.2-2.5L69.1 288.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1H192v16H175.1c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1H192l21.4 64.1c-29.8 1.8-53.4 26.5-53.4 56.8c0 3.9 3.2 7.1 7.1 7.1H344.9c3.9 0 7.1-3.2 7.1-7.1c0-30.2-23.6-55-53.4-56.8L320 384h16.9c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4H320V336h69.6c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5H320V288h48.9c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1H320V240h18.9c23.7 0 46.9-7 66.6-20.2L447.3 192l.7 0c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64c-3.4 0-6.7 .3-9.9 .8c-3.6 .6-6.1 3.8-6.1 7.5V72c0 7.7-9.8 11-14.4 4.8L397.4 49.9c-3.7-4.9-11.2-3.9-12.3 2.1c-.7 3.9-1.1 7.9-1.1 11.9v64c0 14.9 5.1 28.6 13.6 39.4l-18.7 12.5C367 187.8 353.1 192 338.9 192H314.2c-2.7-7.3-6.2-14-10.2-20.2V80.7c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7V138c-3.1-2.3-6.2-4.4-9-6.1c-4.3-2.6-9.7-2.6-13.9 0c-2.8 1.7-5.9 3.8-9 6.1V80.7c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7v91.1c-4 6.2-7.5 13-10.2 20.2H173.1c-14.2 0-28.1-4.2-39.9-12.1l-18.7-12.5c8.5-10.9 13.6-24.6 13.6-39.4V64c0-4.1-.4-8.1-1.1-11.9c-1.1-6-8.6-7.1-12.3-2.1L94.4 76.8C89.8 83 80 79.7 80 72V8.2z"]
};
var faCartFlatbedEmpty = {
  prefix: 'fas',
  iconName: 'cart-flatbed-empty',
  icon: [640, 512, ["dolly-flatbed-empty"], "f476", "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32z"]
};
var faDollyFlatbedEmpty = faCartFlatbedEmpty;
var faColon = {
  prefix: 'fas',
  iconName: 'colon',
  icon: [192, 512, [], "3a", "M96 192A64 64 0 1 0 96 64a64 64 0 1 0 0 128zm0 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faCartArrowDown = {
  prefix: 'fas',
  iconName: 'cart-arrow-down',
  icon: [576, 512, [], "f218", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360V134.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faWand = {
  prefix: 'fas',
  iconName: 'wand',
  icon: [512, 512, [], "f72a", "M497 7c-9-9-23.5-9.4-33-.9L189.3 251.9c-2.9 2.6-6.7 4.1-10.7 4.1H144c-8.8 0-16 7.2-16 16v27.6c0 4.6-1.9 8.9-5.3 11.9L11.1 411.3C4 417.7 0 426.7 0 436.2c0 8.8 3.5 17.3 9.7 23.5l42.6 42.6c6.2 6.2 14.7 9.8 23.5 9.8c9.5 0 18.5-4 24.8-11.1L372.3 197.3c3-3.4 7.4-5.3 11.9-5.3H400c8.8 0 16-7.2 16-16V154.6c0-3.9 1.5-7.7 4.1-10.7L505.9 48c8.5-9.5 8.1-24-.9-33l-8-8z"]
};
var faWalkieTalkie = {
  prefix: 'fas',
  iconName: 'walkie-talkie',
  icon: [384, 512, [], "f8ef", "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144V300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V371.9c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32H224c0-17.7-14.3-32-32-32s-32 14.3-32 32H112V24zm0 136H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFilePen = {
  prefix: 'fas',
  iconName: 'file-pen',
  icon: [576, 512, [128221, "file-edit"], "f31c", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V285.7l-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faFileEdit = faFilePen;
var faReceipt = {
  prefix: 'fas',
  iconName: 'receipt',
  icon: [384, 512, [129534], "f543", "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"]
};
var faTablePicnic = {
  prefix: 'fas',
  iconName: 'table-picnic',
  icon: [512, 512, [], "e32d", "M319.3 64H192.7c-.5 0-1 0-1.5 0H96C78.3 64 64 78.3 64 96s14.3 32 32 32h48.7l-38.4 96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H80.7h68.9H362.3h68.9H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H405.7l-38.4-96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320.7c-.5 0-1 0-1.5 0zM444.1 320H375.1l43.2 107.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6L444.1 320zm-307.2 0H67.9L34.3 404.1c-6.6 16.4 1.4 35 17.8 41.6s35-1.4 41.6-17.8L136.9 320zm38.4-96l38.4-96h84.7l38.4 96H175.3z"]
};
var faSquarePen = {
  prefix: 'fas',
  iconName: 'square-pen',
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faPenSquare = faSquarePen;
var faPencilSquare = faSquarePen;
var faCircleMicrophoneLines = {
  prefix: 'fas',
  iconName: 'circle-microphone-lines',
  icon: [512, 512, ["microphone-circle-alt"], "e117", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 96c-26.5 0-48 21.5-48 48V256c0 26.5 21.5 48 48 48s48-21.5 48-48V240H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c0-26.5-21.5-48-48-48zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 65.3 48.9 119.1 112 127v17c0 8.8 7.2 16 16 16s16-7.2 16-16V383c63.1-7.9 112-61.7 112-127V240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53-43 96-96 96s-96-43-96-96V240z"]
};
var faMicrophoneCircleAlt = faCircleMicrophoneLines;
var faDisplaySlash = {
  prefix: 'fas',
  iconName: 'display-slash',
  icon: [640, 512, ["desktop-slash"], "e2fa", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-70.5-55.2c27.4-7.2 47.6-32.2 47.6-61.9V64c0-35.3-28.7-64-64-64H96C79.6 0 64.6 6.2 53.2 16.4L38.8 5.1zM113.9 64H544V352H481.4L113.9 64zM32 352c0 35.3 28.7 64 64 64H272l-10.7 32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H448c17.7 0 32-14.3 32-32c0-2.1-.2-4.1-.6-6.1L446.6 448H378.7L368 416h38l-81.2-64H96V171.8L32 121.4V352z"]
};
var faDesktopSlash = faDisplaySlash;
var faSuitcaseRolling = {
  prefix: 'fas',
  iconName: 'suitcase-rolling',
  icon: [384, 512, [], "f5c1", "M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72H144V56zm176 72H288V56c0-30.9-25.1-56-56-56H152C121.1 0 96 25.1 96 56v72H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32H256c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zM112 224H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPersonCircleExclamation = {
  prefix: 'fas',
  iconName: 'person-circle-exclamation',
  icon: [576, 512, [], "e53f", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faTransporter2 = {
  prefix: 'fas',
  iconName: 'transporter-2',
  icon: [512, 512, [], "e044", "M56.7 6.6C55.6 2.7 52.1 0 48 0s-7.6 2.7-8.7 6.6L32 32 6.6 39.3C2.7 40.4 0 43.9 0 48s2.7 7.6 6.6 8.7L32 64l7.3 25.4C40.4 93.3 43.9 96 48 96s7.6-2.7 8.7-6.6L64 64l25.4-7.3C93.3 55.6 96 52.1 96 48s-2.7-7.6-6.6-8.7L64 32 56.7 6.6zM256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 512h88 80 88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32zM399.4 224l-48.1-60c-18.2-22.7-45.8-36-74.9-36H235.7c-29.1 0-56.7 13.2-74.9 36l-48.1 60H399.4zM480 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 352zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faHandsHoldingDiamond = {
  prefix: 'fas',
  iconName: 'hands-holding-diamond',
  icon: [640, 512, ["hand-receiving"], "f47c", "M297.4 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0zM80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"]
};
var faHandReceiving = faHandsHoldingDiamond;
var faMoneyBillSimpleWave = {
  prefix: 'fas',
  iconName: 'money-bill-simple-wave',
  icon: [576, 512, [], "e1f2", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]
};
var faChevronDown = {
  prefix: 'fas',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
};
var faBatteryFull = {
  prefix: 'fas',
  iconName: 'battery-full',
  icon: [576, 512, [128267, "battery", "battery-5"], "f240", "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm368 96H96V320H448V192z"]
};
var faBattery = faBatteryFull;
var faBattery5 = faBatteryFull;
var faBellPlus = {
  prefix: 'fas',
  iconName: 'bell-plus',
  icon: [448, 512, [], "f849", "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7zM224 152c13.3 0 24 10.7 24 24v40h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264H160c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V176c0-13.3 10.7-24 24-24z"]
};
var faBookArrowRight = {
  prefix: 'fas',
  iconName: 'book-arrow-right',
  icon: [640, 512, [], "e0b9", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V232H558.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H448V32c0-17.7-14.3-32-32-32H384 96zM448 184v48H248c-13.3 0-24-10.7-24-24s10.7-24 24-24H448zM96 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faHospitals = {
  prefix: 'fas',
  iconName: 'hospitals',
  icon: [576, 512, [], "f80e", "M304 0c-26.5 0-48 21.5-48 48V64c35.3 0 64 28.7 64 64V480c0 11.7-3.1 22.6-8.6 32H528c26.5 0 48-21.5 48-48V384H464c-8.8 0-16-7.2-16-16s7.2-16 16-16H576V288H464c-8.8 0-16-7.2-16-16s7.2-16 16-16H576V48c0-26.5-21.5-48-48-48H304zM408 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H456v24c0 8.8-7.2 16-16 16H424c-8.8 0-16-7.2-16-16V168H384c-8.8 0-16-7.2-16-16V136c0-8.8 7.2-16 16-16h24V96zM0 144V384H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v48c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H48C21.5 96 0 117.5 0 144zm120 48c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H168v24c0 8.8-7.2 16-16 16H136c-8.8 0-16-7.2-16-16V264H96c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16h24V192z"]
};
var faClub = {
  prefix: 'fas',
  iconName: 'club',
  icon: [512, 512, [9827], "f327", "M380 160.1c2.6-10.2 4-21 4-32.1C384 57.3 326.7 0 256 0S128 57.3 128 128c0 11.1 1.4 21.8 4 32.1c-1.3 0-2.7-.1-4-.1C57.3 160 0 217.3 0 288s57.3 128 128 128c38.2 0 72.5-16.8 96-43.3V448H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V372.7c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128s-57.3-128-128-128c-1.4 0-2.7 0-4 .1z"]
};
var faSkullCrossbones = {
  prefix: 'fas',
  iconName: 'skull-crossbones',
  icon: [448, 512, [128369, 9760], "f714", "M368 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V234.4c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM168 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6C1.9 308.7-4.5 289.5 3.4 273.7z"]
};
var faDropletDegree = {
  prefix: 'fas',
  iconName: 'droplet-degree',
  icon: [512, 512, ["dewpoint"], "f748", "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM464 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faDewpoint = faDropletDegree;
var faCodeCompare = {
  prefix: 'fas',
  iconName: 'code-compare',
  icon: [512, 512, [], "e13a", "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v40h16c35.3 0 64-28.7 64-64V153.3C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128H320v40zM456 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V128H176c-35.3 0-64 28.7-64 64V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16V24zM56 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"]
};
var faListUl = {
  prefix: 'fas',
  iconName: 'list-ul',
  icon: [512, 512, ["list-dots"], "f0ca", "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faListDots = faListUl;
var faHandHoldingMagic = {
  prefix: 'fas',
  iconName: 'hand-holding-magic',
  icon: [576, 512, [], "f6e5", "M192 80c0 8.8 7.2 16 16 16h80c17.7 0 32 14.3 32 32s-14.3 32-32 32H208c-44.2 0-80-35.8-80-80s35.8-80 80-80H320c70.7 0 128 57.3 128 128s-57.3 128-128 128H288c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32h64c35.3 0 64-28.7 64-64s-28.7-64-64-64H208c-8.8 0-16 7.2-16 16zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faWatermelonSlice = {
  prefix: 'fas',
  iconName: 'watermelon-slice',
  icon: [512, 512, [], "e337", "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391zm22.3-22.3c84.4 84.4 221.1 84.4 305.5 0c84.2-84.2 84.4-220.7 .3-305.1l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L59.3 342.2c-6.2 6.2-6.2 16.4 0 22.6l4 4zm245.4-220c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm-80 80c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm88 8c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm-168 72c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm88 8c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faCircleEllipsis = {
  prefix: 'fas',
  iconName: 'circle-ellipsis',
  icon: [512, 512, [], "e10a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSchoolLock = {
  prefix: 'fas',
  iconName: 'school-lock',
  icon: [640, 512, [], "e56f", "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V272c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4H320.3l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faTowerCell = {
  prefix: 'fas',
  iconName: 'tower-cell',
  icon: [576, 512, [], "e585", "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448H398.3l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32H354.7l14.5 32zM288 205.3L325.6 288H250.4L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"]
};
var faSdCards = {
  prefix: 'fas',
  iconName: 'sd-cards',
  icon: [448, 512, [], "e240", "M384 0H237.3C220.3 0 204 6.7 192 18.7L114.7 96c-12 12-18.7 28.3-18.7 45.3V352c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM280 64c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm80 0c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faJugBottle = {
  prefix: 'fas',
  iconName: 'jug-bottle',
  icon: [640, 512, [], "e5fb", "M120 0C106.7 0 96 10.7 96 24V48H88C74.7 48 64 58.7 64 72s10.7 24 24 24H232c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V24c0-13.3-10.7-24-24-24H120zm8 128C57.3 128 0 185.3 0 256V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm160 96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zM472 64c-13.3 0-24 10.7-24 24v40H576V88c0-13.3-10.7-24-24-24H472zM416.4 392.4c-.1 .1-.2 .1-.4 .2V448c0 16.9-4.3 32.7-12 46.5c11.5 10.9 27 17.5 44 17.5H576c35.3 0 64-28.7 64-64c0-24.1-13.3-45.1-33-56c19.7-10.9 33-31.9 33-56c0-23.5-12.6-44-31.5-55.1c18.7-10.1 31.5-29.9 31.5-52.7c0-23.2-13.4-44.3-34.4-54.2l-13.2-6.2c-11-5.1-23-7.8-35.1-7.8H466.7c-12.1 0-24.1 2.7-35.1 7.8L418.4 174c-6.9 3.2-13 7.7-18 13c10 20.9 15.6 44.3 15.6 69V391.4c.3 .2 .7 .4 1 .6c-.2 .1-.4 .2-.6 .4z"]
};
var faDownLong = {
  prefix: 'fas',
  iconName: 'down-long',
  icon: [320, 512, ["long-arrow-alt-down"], "f309", "M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0 0-288c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 288-72 0c-9.6 0-18.2 5.7-22 14.5z"]
};
var faLongArrowAltDown = faDownLong;
var faEnvelopes = {
  prefix: 'fas',
  iconName: 'envelopes',
  icon: [576, 512, [], "e170", "M316.7 249.6c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4l220-163C570.8 55.7 544.2 32 512 32H160c-32.2 0-58.8 23.7-63.3 54.7l220 163zm57.7 25.7C363.3 283.6 349.8 288 336 288s-27.3-4.4-38.4-12.7L96 126V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V126L374.4 275.3zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faPhoneOffice = {
  prefix: 'fas',
  iconName: 'phone-office',
  icon: [576, 512, [], "f67d", "M128 0C110.3 0 96 14.3 96 32V384c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H128zM64 32C28.7 32 0 60.7 0 96V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H256V384c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V32zm256 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128zm32 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm160-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM480 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faRankingStar = {
  prefix: 'fas',
  iconName: 'ranking-star',
  icon: [640, 512, [], "e561", "M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"]
};
var faChessKing = {
  prefix: 'fas',
  iconName: 'chess-king',
  icon: [448, 512, [9818], "f43f", "M224 0c17.7 0 32 14.3 32 32V48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v48H408c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400H80L3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40H192V112H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM38.6 473.4L80 432H368l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"]
};
var faNfcPen = {
  prefix: 'fas',
  iconName: 'nfc-pen',
  icon: [576, 512, [], "e1fa", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V235.6l-64 64V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16V331.6L299.6 384H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H275.1c-1 2.6-1.9 5.3-2.6 8.1l-14 55.9H64c-35.3 0-64-28.7-64-64V96zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faPersonHarassing = {
  prefix: 'fas',
  iconName: 'person-harassing',
  icon: [576, 512, [], "e549", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 344v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"]
};
var faHatWinter = {
  prefix: 'fas',
  iconName: 'hat-winter',
  icon: [512, 512, [], "f7a8", "M279.9 22.2C279 9.8 268.7 0 256 0s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C185.8 57 176 67.3 176 80s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C233 150.2 243.3 160 256 160s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C326.2 103 336 92.7 336 80s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM216.4 175.6c-14.2 0-28.4-5.4-39.3-16.1c-62.7 27.1-98.6 85.4-118.9 139.6c4.2 1.6 8.9 1.4 13-.6l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.5 2.3 9.8 2.3 14.3 0l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.5 2.3 9.8 2.3 14.3 0l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.1 2 8.8 2.2 13 .6c-20.3-54.2-56.2-112.5-118.9-139.6c-10.9 10.7-25.1 16.1-39.3 16.1C285.5 185.7 271.5 192 256 192s-29.5-6.3-39.6-16.4zM48.1 329.5C34.3 377.5 32 416 32 416H480s-2.3-38.5-16.1-86.5c-12.2 4.3-25.6 3.5-37.3-2.4l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.7c-13.5 6.8-29.4 6.8-42.9 0l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.7c-13.5 6.8-29.4 6.8-42.9 0l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0L85.5 327.2c-11.7 5.8-25.2 6.6-37.3 2.4z"]
};
var faBrazilianRealSign = {
  prefix: 'fas',
  iconName: 'brazilian-real-sign',
  icon: [512, 512, [], "e46c", "M400 0c17.7 0 32 14.3 32 32V50.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V460.6c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2V32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256z"]
};
var faLandmarkDome = {
  prefix: 'fas',
  iconName: 'landmark-dome',
  icon: [512, 512, ["landmark-alt"], "f752", "M248 0h16c13.3 0 24 10.7 24 24V34.7C368.4 48.1 431.9 111.6 445.3 192H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24zM64 288h64V416h40V288h64V416h48V288h64V416h40V288h64V420.3c.6 .3 1.2 .7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z"]
};
var faLandmarkAlt = faLandmarkDome;
var faBoneBreak = {
  prefix: 'fas',
  iconName: 'bone-break',
  icon: [640, 512, [], "f5d8", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM201 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L201 71zM473 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48zM143.9 223.8C129.3 204.5 106.1 192 80 192c-44.2 0-80 35.8-80 80c0 35.8 23.5 66.1 55.9 76.3c4.6 1.5 8.3 5.1 9.3 9.8s-1.1 9.5-4.8 12.6C43.1 385.5 32 407.5 32 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-11.9 7-23.8 18.6-26.1L320 384l109.4 21.9C441 408.2 448 420.1 448 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-24.5-11.1-46.5-28.5-61.2c-3.7-3.1-5.7-7.9-4.8-12.6s4.7-8.4 9.3-9.8C616.5 338.1 640 307.8 640 272c0-44.2-35.8-80-80-80c-26.1 0-49.3 12.5-63.9 31.8c-10.1 13.3-25.7 23.8-42.1 20.5l-70.6-14.1c-17.3-3.5-34.2 7.8-37.7 25.1L320 384 294.3 255.4c-3.5-17.3-20.3-28.6-37.7-25.1L186 244.4c-16.4 3.3-32.1-7.2-42.1-20.5z"]
};
var faArrowUp = {
  prefix: 'fas',
  iconName: 'arrow-up',
  icon: [384, 512, [8593], "f062", "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"]
};
var faDownFromDottedLine = {
  prefix: 'fas',
  iconName: 'down-from-dotted-line',
  icon: [448, 512, [], "e407", "M73.9 345.9L196.7 468.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L374.1 345.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9H288V160c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32V288H97.9C79.2 288 64 303.2 64 321.9c0 9 3.6 17.6 9.9 24zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM256 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM448 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTv = {
  prefix: 'fas',
  iconName: 'tv',
  icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faTelevision = faTv;
var faTvAlt = faTv;
var faBorderLeft = {
  prefix: 'fas',
  iconName: 'border-left',
  icon: [448, 512, [], "f84f", "M32 480c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32s32 14.3 32 32l0 384c0 17.7-14.3 32-32 32zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faCircleDivide = {
  prefix: 'fas',
  iconName: 'circle-divide',
  icon: [512, 512, [], "e106", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM168 232H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faShrimp = {
  prefix: 'fas',
  iconName: 'shrimp',
  icon: [512, 512, [129424], "e448", "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H264 88.8 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM224 456c0 13.3 10.7 24 24 24h72V407.8l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128H320V320h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faListCheck = {
  prefix: 'fas',
  iconName: 'list-check',
  icon: [512, 512, ["tasks"], "f0ae", "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faTasks = faListCheck;
var faDiagramSubtask = {
  prefix: 'fas',
  iconName: 'diagram-subtask',
  icon: [512, 512, [], "e479", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H160v96c0 17.7 14.3 32 32 32h32c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H288c-35.3 0-64-28.7-64-64H192c-53 0-96-43-96-96V224H64c-35.3 0-64-28.7-64-64V96zM448 352H288v64H448V352z"]
};
var faJugDetergent = {
  prefix: 'fas',
  iconName: 'jug-detergent',
  icon: [384, 512, [], "e519", "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faCircleUser = {
  prefix: 'fas',
  iconName: 'circle-user',
  icon: [512, 512, [62142, "user-circle"], "f2bd", "M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
};
var faUserCircle = faCircleUser;
var faSquareY = {
  prefix: 'fas',
  iconName: 'square-y',
  icon: [448, 512, [], "e287", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm74.1 120.3L224 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24V297L101.9 183.7c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z"]
};
var faUserDoctorHair = {
  prefix: 'fas',
  iconName: 'user-doctor-hair',
  icon: [448, 512, [], "e458", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16h31.8c28.9 0 55.8-15.2 70.6-40l5.3 5.3C265 89 280.8 95.7 297.3 96c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0zm64 320l-1.3 0H161.3l-1.3 0v50.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V323.4C54.9 338.8 0 403.6 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-77.7-54.9-142.5-128-157.8V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V320zM168 424a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faPlanetRinged = {
  prefix: 'fas',
  iconName: 'planet-ringed',
  icon: [512, 512, [129680], "e020", "M319.7 319.7C456.6 182.8 539.1 43.3 503.9 8.1C481.7-14 418.3 10.4 340.2 65.7C314.4 54.3 286 48 256 48C141.1 48 48 141.1 48 256c0 30 6.3 58.4 17.7 84.2C10.4 418.3-14 481.7 8.1 503.9c35.2 35.2 174.7-47.3 311.6-184.2zM256 464c114.9 0 208-93.1 208-208c0-16.1-1.8-31.8-5.3-46.9c-31.8 42.6-71.4 88.2-116.4 133.2s-90.6 84.6-133.2 116.4c15.1 3.5 30.7 5.3 46.9 5.3z"]
};
var faMushroom = {
  prefix: 'fas',
  iconName: 'mushroom',
  icon: [512, 512, [127812], "e425", "M24 258.1C24 133.2 125.2 32 250.1 32h11.8C386.8 32 488 133.2 488 258.1c0 34.2-27.7 61.9-61.9 61.9H313 199 85.9C51.7 320 24 292.3 24 258.1zm387.5-96.7c-3.7-.9-7.5-1.4-11.5-1.4c-26.5 0-48 21.5-48 48s21.5 48 48 48c15.9 0 30-7.7 38.7-19.6c-3.3-27.4-12.9-52.9-27.2-75zM145.9 113.6c8 35.7 39.9 62.4 78.1 62.4c44.2 0 80-35.8 80-80c0-3.8-.3-7.5-.8-11.2C290 81.7 276.1 80 261.9 80H250.1c-38.9 0-74.9 12.5-104.2 33.6zM191 352H321L343 440.2c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3H200c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L191 352zM160 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faUserShield = {
  prefix: 'fas',
  iconName: 'user-shield',
  icon: [640, 512, [], "f505", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3H178.3zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8L591.4 312z"]
};
var faMegaphone = {
  prefix: 'fas',
  iconName: 'megaphone',
  icon: [576, 512, [128227], "f675", "M544 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM64 190.3L480 64V448L348.9 408.2C338.2 449.5 300.7 480 256 480c-53 0-96-43-96-96c0-11 1.9-21.7 5.3-31.5L64 321.7C63.1 338.6 49.1 352 32 352c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32c17.1 0 31.1 13.4 32 30.3zm239 203.9l-91.6-27.8c-2.1 5.4-3.3 11.4-3.3 17.6c0 26.5 21.5 48 48 48c23 0 42.2-16.2 46.9-37.8z"]
};
var faWreathLaurel = {
  prefix: 'fas',
  iconName: 'wreath-laurel',
  icon: [640, 512, [], "e5d2", "M144 112C144 50.1 194.1 0 256 0h16c8.8 0 16 7.2 16 16V32c0 60.2-47.5 109.3-107 111.9c-23.9 32.2-37 71.5-37 112.1c0 97.2 78.8 176 176 176h11.6c43.5 0 86.3 10.1 125.2 29.6l9.9 5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-9.9-5C403.1 488.4 367.6 480 331.6 480H320 308.4c-36 0-71.5 8.4-103.8 24.5l-9.9 5c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l9.9-5c8.3-4.2 16.8-7.9 25.4-11.2c-5.6-3.2-11-6.7-16.3-10.3c-59.6 28.2-131.9 6.3-165.4-51.8l-8-13.9c-4.4-7.7-1.8-17.4 5.9-21.9c13.8-8 28.4-13.1 43.3-15.5C27.5 315.6 0 273 0 224V208c0-8.8 7.2-16 16-16c15.9 0 31.1 2.9 45.2 8.2c-24.3-38.8-26.8-89.5-2.3-131.9l8-13.9c4.4-7.7 14.2-10.3 21.9-5.9C115 63.7 133.8 86.8 144 113v-1zm315 31.9C399.5 141.3 352 92.2 352 32V16c0-8.8 7.2-16 16-16h16c61.9 0 112 50.1 112 112v1c10.2-26.2 29-49.2 55.3-64.4c7.7-4.4 17.4-1.8 21.9 5.9l8 13.9c24.5 42.4 21.9 93.1-2.3 131.9c14.1-5.3 29.3-8.2 45.2-8.2c8.8 0 16 7.2 16 16v16c0 49-27.5 91.6-68 113.1c14.8 2.4 29.5 7.5 43.3 15.5c7.7 4.4 10.3 14.2 5.9 21.9l-8 13.9c-24.2 42-68.7 65.1-114 64c-4.8-5.8-10.9-10.8-18.1-14.4l-9.9-5c-2.8-1.4-5.7-2.8-8.6-4.1c-10.4-4.8-21-9-31.8-12.6c-7.9-2.7-15.9-5-24-7C460 378.9 496 321.7 496 256c0-40.6-13.1-79.9-37-112.1z"]
};
var faCircleExclamationCheck = {
  prefix: 'fas',
  iconName: 'circle-exclamation-check',
  icon: [640, 512, [], "e10d", "M506.5 203L480 229.5l-18.7-18.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5l64 64c11.9 11.9 27.4 18.2 43 18.7c-44.3 76.5-127 128-221.8 128C114.6 512 0 397.4 0 256S114.6 0 256 0C379.2 0 482.1 87 506.5 203zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM625 209L497 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faWind = {
  prefix: 'fas',
  iconName: 'wind',
  icon: [512, 512, [], "f72e", "M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"]
};
var faBoxDollar = {
  prefix: 'fas',
  iconName: 'box-dollar',
  icon: [448, 512, ["box-usd"], "f4a0", "M93.7 32H208V160H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32H354.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240V32zM0 192H448V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm244 40c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5l0 0c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V440c0 11 9 20 20 20s20-9 20-20V426.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V232z"]
};
var faBoxUsd = faBoxDollar;
var faCarBurst = {
  prefix: 'fas',
  iconName: 'car-burst',
  icon: [640, 512, ["car-crash"], "f5e1", "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"]
};
var faCarCrash = faCarBurst;
var faY = {
  prefix: 'fas',
  iconName: 'y',
  icon: [384, 512, [121], "59", "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"]
};
var faUserHeadset = {
  prefix: 'fas',
  iconName: 'user-headset',
  icon: [448, 512, [], "f82d", "M224 32C135.6 32 64 103.6 64 192v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192C32 86 118 0 224 0S416 86 416 192v16c0 61.9-50.1 112-112 112H240 224 208c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80V192c0-88.4-71.6-160-160-160zM96 192c0-70.7 57.3-128 128-128s128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256h-8.6c-11.1-19.1-31.7-32-55.4-32H208c-35.3 0-64 28.7-64 64c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192zM224 352h16 64 9.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352H208h16z"]
};
var faArrowsRetweet = {
  prefix: 'fas',
  iconName: 'arrows-retweet',
  icon: [640, 512, ["retweet-alt"], "f361", "M150.6 73.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 173.3V320c0 53 43 96 96 96H304c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32-14.3-32-32V173.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM336 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H448c17.7 0 32 14.3 32 32V338.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L544 338.7V192c0-53-43-96-96-96H336z"]
};
var faRetweetAlt = faArrowsRetweet;
var faPersonSnowboarding = {
  prefix: 'fas',
  iconName: 'person-snowboarding',
  icon: [512, 512, [127938, "snowboarding"], "f7ce", "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H443.8c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faSnowboarding = faPersonSnowboarding;
var faSquareChevronRight = {
  prefix: 'fas',
  iconName: 'square-chevron-right',
  icon: [448, 512, ["chevron-square-right"], "f32b", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM313 273L209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239c9.4 9.4 9.4 24.6 0 33.9z"]
};
var faChevronSquareRight = faSquareChevronRight;
var faLacrosseStickBall = {
  prefix: 'fas',
  iconName: 'lacrosse-stick-ball',
  icon: [576, 512, [], "e3b6", "M336 64v0c.1 0 .2 0 .3 0c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1c0 .1 0 .2 0 .3h0c0 33.1-21.9 62.1-53.7 71.2l-11.5 3.3c-19.6 5.6-37.9 15.1-53.9 27.8L294 306.2c-11.1 8.9-25 13.8-39.2 13.8c-34.7 0-62.8-28.1-62.8-62.8c0-14.3 4.9-28.1 13.8-39.2l27.9-34.9c12.8-15.9 22.2-34.3 27.8-53.9l3.3-11.5C273.9 85.9 302.9 64 336 64zm0-64V0C274.4 0 220.2 40.9 203.3 100.1L200 111.7c-3.3 11.5-8.8 22.2-16.2 31.5l-27.9 34.9c-18 22.5-27.8 50.4-27.8 79.2c0 23.4 6.3 45.3 17.4 64.1l-136 136c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l136-136c18.8 11.1 40.7 17.4 64.1 17.4c28.8 0 56.7-9.8 79.2-27.8l34.9-27.9c9.3-7.4 20-13 31.5-16.2l11.5-3.3C471.1 291.8 512 237.6 512 176h0c0-.1 0-.2 0-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0c-.1 0-.2 0-.3 0zM496 512a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faTruckFast = {
  prefix: 'fas',
  iconName: 'truck-fast',
  icon: [640, 512, ["shipping-fast"], "f48b", "M112 0C85.5 0 64 21.5 64 48V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 272c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 240c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V416c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zM544 237.3V256H416V160h50.7L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faShippingFast = faTruckFast;
var faUserMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'user-magnifying-glass',
  icon: [640, 512, [], "e5c5", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-.8 0-1.5 0-2.3c-88.4 0-160-71.6-160-160c0-5.1 .2-10.1 .7-15c-6.2-.7-12.6-1-19-1H178.3zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 505.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
var faStarSharp = {
  prefix: 'fas',
  iconName: 'star-sharp',
  icon: [576, 512, [], "e28b", "M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176H56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L172.1 320.7 121.1 480.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4 417.3 506.9c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27L403.9 320.7 534.7 218.9c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2H361.5L310.9 16.7z"]
};
var faCommentHeart = {
  prefix: 'fas',
  iconName: 'comment-heart',
  icon: [512, 512, [], "e5c8", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM144 205.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
var faCircle1 = {
  prefix: 'fas',
  iconName: 'circle-1',
  icon: [512, 512, [], "e0ee", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 131.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L232 193.4V336H192c-13.3 0-24 10.7-24 24s10.7 24 24 24h64 64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V152c0-8.6-4.6-16.5-12-20.8z"]
};
var faCircleStar = {
  prefix: 'fas',
  iconName: 'circle-star',
  icon: [512, 512, ["star-circle"], "e123", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 104c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L256 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z"]
};
var faStarCircle = faCircleStar;
var faFish = {
  prefix: 'fas',
  iconName: 'fish',
  icon: [576, 512, [128031], "f578", "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCloudFog = {
  prefix: 'fas',
  iconName: 'cloud-fog',
  icon: [640, 512, [127787, "fog"], "f74e", "M160 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2c-1.3-6.7-1.9-13.7-1.9-20.8C128 50.1 178.1 0 240 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H160zM0 392c0-13.3 10.7-24 24-24H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm64 96c0-13.3 10.7-24 24-24H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm208 0c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24z"]
};
var faFog = faCloudFog;
var faWaffle = {
  prefix: 'fas',
  iconName: 'waffle',
  icon: [512, 512, [129479], "e466", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 80c-8.8 0-16 7.2-16 16v48H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V368h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16V368h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V368h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V176h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H272V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H176V96c0-8.8-7.2-16-16-16zm16 256V272h64v64H176zm96 0V272h64v64H272zm64-160v64H272V176h64zm-96 0v64H176V176h64z"]
};
var faMusicNote = {
  prefix: 'fas',
  iconName: 'music-note',
  icon: [384, 512, ["music-alt"], "f8cf", "M384 32c0-9.9-4.5-19.2-12.3-25.2S353.8-1.4 344.2 1l-128 32C202 36.5 192 49.3 192 64v64V359.7c-14.5-4.9-30.8-7.7-48-7.7c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V153L359.8 127C374 123.5 384 110.7 384 96V32z"]
};
var faMusicAlt = faMusicNote;
var faHexagonExclamation = {
  prefix: 'fas',
  iconName: 'hexagon-exclamation',
  icon: [512, 512, [], "e417", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCartShoppingFast = {
  prefix: 'fas',
  iconName: 'cart-shopping-fast',
  icon: [640, 512, [], "e0dc", "M88 0C74.7 0 64 10.7 64 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H263.7c-11.5 0-21.4-8.2-23.6-19.5L234.7 288H523.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C640.6 57 621.4 32 595.1 32h-411C175 12.8 155.6 0 133.5 0H88zM240 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM24 96C10.7 96 0 106.7 0 120s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faObjectUnion = {
  prefix: 'fas',
  iconName: 'object-union',
  icon: [512, 512, [], "e49f", "M64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h96v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H352V64c0-35.3-28.7-64-64-64H64z"]
};
var faUserGraduate = {
  prefix: 'fas',
  iconName: 'user-graduate',
  icon: [448, 512, [], "f501", "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"]
};
var faStarfighter = {
  prefix: 'fas',
  iconName: 'starfighter',
  icon: [640, 512, [], "e037", "M353.8 14L384 256V464c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V256L286.2 14c1-8 7.8-14 15.9-14h35.8c8.1 0 14.9 6 15.9 14zM288 256v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256c0-17.7-14.3-32-32-32s-32 14.3-32 32zM48 72c13.3 0 24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24V352h56V320c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32 64 32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-9.6L72 444v4c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24zm544 0c13.3 0 24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24V448c0 13.3-10.7 24-24 24s-24-10.7-24-24v-4l-88 26.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448 416 352 320c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32h56V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24z"]
};
var faCircleHalfStroke = {
  prefix: 'fas',
  iconName: 'circle-half-stroke',
  icon: [512, 512, [9680, "adjust"], "f042", "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faAdjust = faCircleHalfStroke;
var faArrowRightLongToLine = {
  prefix: 'fas',
  iconName: 'arrow-right-long-to-line',
  icon: [640, 512, [], "e3d5", "M640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32zM502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l370.7 0-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z"]
};
var faSquareArrowDown = {
  prefix: 'fas',
  iconName: 'square-arrow-down',
  icon: [448, 512, ["arrow-square-down"], "f339", "M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zm177-87L353 281c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71V136c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L207 393c9.4 9.4 24.6 9.4 33.9 0z"]
};
var faArrowSquareDown = faSquareArrowDown;
var faDiamondHalfStroke = {
  prefix: 'fas',
  iconName: 'diamond-half-stroke',
  icon: [512, 512, [], "e5b8", "M256 78.5L433.5 256 256 433.5V78.5zm28.3-66.8c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"]
};
var faClapperboard = {
  prefix: 'fas',
  iconName: 'clapperboard',
  icon: [512, 512, [], "e131", "M448 32H361.9l-1 1-127 127h92.1l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40l-104 104H512zM294.1 32H201.9l-1 1L73.9 160h92.1l1-1 127-127zM64 32C28.7 32 0 60.7 0 96v64H6.1l1-1 127-127H64zM512 192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192z"]
};
var faSquareChevronLeft = {
  prefix: 'fas',
  iconName: 'square-chevron-left',
  icon: [448, 512, ["chevron-square-left"], "f32a", "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM135 239L239 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faChevronSquareLeft = faSquareChevronLeft;
var faPhoneIntercom = {
  prefix: 'fas',
  iconName: 'phone-intercom',
  icon: [512, 512, [], "e434", "M48 32H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80C0 53.5 21.5 32 48 32zM160 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V96zM320 368a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zM224 128v96c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"]
};
var faLinkHorizontal = {
  prefix: 'fas',
  iconName: 'link-horizontal',
  icon: [640, 512, ["chain-horizontal"], "e1cb", "M144.6 64C64.7 64 0 128.7 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9 .3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-44.5 36.1-80.6 80.6-80.6H303.4c44.5 0 80.6 36.1 80.6 80.6c0 39.4-28.5 73-67.4 79.5l-1.9 .3c-17.4 2.9-29.2 19.4-26.3 36.8s19.4 29.2 36.8 26.3l1.9-.3c69.7-11.6 120.8-72 120.8-142.6C448 128.7 383.3 64 303.4 64H144.6zM495.4 448C575.3 448 640 383.3 640 303.4c0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9 .3c38.9 6.5 67.4 40.1 67.4 79.5c0 44.5-36.1 80.6-80.6 80.6H336.6c-44.5 0-80.6-36.1-80.6-80.6c0-39.4 28.5-73 67.4-79.5l1.9-.3c17.4-2.9 29.2-19.4 26.3-36.8s-19.4-29.2-36.8-26.3l-1.9 .3C243.1 172.4 192 232.7 192 303.4C192 383.3 256.7 448 336.6 448H495.4z"]
};
var faChainHorizontal = faLinkHorizontal;
var faMango = {
  prefix: 'fas',
  iconName: 'mango',
  icon: [512, 512, [], "e30f", "M344 0h8 24 8 56c39.8 0 72 32.2 72 72c0 13.3-10.7 24-24 24H448c-33.4 0-62.8-17-80-42.9v49c32.2 8.3 62.6 25 87.8 50.2C493.3 189.7 512 238.9 512 288c0 76.6-57.5 224-224 224c-144 0-244.1-43.3-244.1-43.3C10.3 457.6-7.9 421.4 3.3 387.9C7.4 375.4 15 365 24.7 357.5c34.3-25.7 52.1-57.6 71.2-91.8c20.6-36.8 42.6-76.3 88.4-113.5C221.7 114.7 270.9 96 320 96V24c0-13.3 10.7-24 24-24zm88 304c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 53-43 96-96 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c70.7 0 128-57.3 128-128z"]
};
var faMusicNoteSlash = {
  prefix: 'fas',
  iconName: 'music-note-slash',
  icon: [640, 512, ["music-alt-slash"], "f8d0", "M512 32c0-9.9-4.5-19.2-12.3-25.2S481.8-1.4 472.2 1l-128 32C330 36.5 320 49.3 320 64v64 97.5L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L384 275.7V153L487.8 127C502 123.5 512 110.7 512 96V32zM272 352c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V411.2L317.8 359c-14-4.5-29.5-7-45.8-7z"]
};
var faMusicAltSlash = faMusicNoteSlash;
var faCircleRadiation = {
  prefix: 'fas',
  iconName: 'circle-radiation',
  icon: [512, 512, [9762, "radiation-alt"], "f7ba", "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faRadiationAlt = faCircleRadiation;
var faFaceTongueSweat = {
  prefix: 'fas',
  iconName: 'face-tongue-sweat',
  icon: [576, 512, [], "e39e", "M544 256c0 112.9-73.1 208.7-174.5 242.8C378.7 484 384 466.6 384 448V416.7c10.2-7.2 16-15.7 16-24.7c0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7V448c0 18.6 5.3 36 14.5 50.8c-41.3-13.9-78-38-106.9-69.4C116.9 415 128 393.5 128 369c0-11.4-3.8-22.4-7.1-30.5c-3.7-8.7-8.4-17.6-13.2-25.7C98.1 296.7 87 281.3 80 272.1c-11.6-15.6-31.7-19.9-48-12.8c0-1.1 0-2.2 0-3.3C32 114.6 146.6 0 288 0S544 114.6 544 256zM96 369c0 14.2-6.4 26.9-16.5 35.5C71 411.7 60 416 48 416c-26.5 0-48-21-48-47c0-17.3 21.4-50 35.7-69.7c2.2-3 4.2-5.8 5.9-8.1c3.2-4.4 9.6-4.4 12.8 0C67.6 308.6 96 349 96 369zm239.6-97a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM352 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6z"]
};
var faGlobeStand = {
  prefix: 'fas',
  iconName: 'globe-stand',
  icon: [448, 512, [], "f5f6", "M15 367c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l18.5-18.5c34.3 27.7 74.9 43.8 116.5 48.3V464H88c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V430.7c49.1-5.3 96.8-26.7 134.4-64.3c81.7-81.7 87.1-211 16.1-298.9L401 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L332.5 49.6c-9.4 9.4-9.4 24.6 0 33.9c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0c-9.4-9.4-24.6-9.4-33.9 0L15 367zm193-15a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
var faBaseball = {
  prefix: 'fas',
  iconName: 'baseball',
  icon: [512, 512, [129358, 9918, "baseball-ball"], "f433", "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"]
};
var faBaseballBall = faBaseball;
var faCircleP = {
  prefix: 'fas',
  iconName: 'circle-p',
  icon: [512, 512, [], "e11a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128h92c50.8 0 92 41.2 92 92s-41.2 92-92 92H208v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V288 152c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44H208v88h68z"]
};
var faAwardSimple = {
  prefix: 'fas',
  iconName: 'award-simple',
  icon: [384, 512, [], "e0ab", "M173.3 5.3c11.5-7 26-7 37.5 0l17.9 10.9c5.9 3.6 12.7 5.4 19.6 5.2l20.9-.5c13.5-.3 26 6.9 32.5 18.7l10 18.4c3.3 6.1 8.3 11 14.3 14.3l18.4 10c11.8 6.5 19.1 19 18.7 32.5l-.5 20.9c-.2 6.9 1.7 13.7 5.2 19.6l10.9 17.9c7 11.5 7 26 0 37.5l-10.9 17.9c-3.6 5.9-5.4 12.7-5.2 19.6l.5 20.9c.3 13.5-6.9 26-18.7 32.5l-18.4 10c-6.1 3.3-11 8.3-14.3 14.3l-10 18.4c-6.5 11.8-19 19.1-32.5 18.7l-20.9-.5c-6.9-.2-13.7 1.7-19.6 5.2l-17.9 10.9c-11.5 7-26 7-37.5 0l-17.9-10.9c-5.9-3.6-12.7-5.4-19.6-5.2l-20.9 .5c-13.5 .3-26-6.9-32.5-18.7L72.4 326c-3.3-6.1-8.3-11-14.3-14.3l-18.4-10c-11.8-6.5-19.1-19-18.7-32.5l.5-20.9c.2-6.9-1.7-13.7-5.2-19.6L5.3 210.7c-7-11.5-7-26 0-37.5l10.9-17.9c3.6-5.9 5.4-12.7 5.2-19.6l-.5-20.9c-.3-13.5 6.9-26 18.7-32.5L58 72.4c6.1-3.3 11-8.3 14.3-14.3l10-18.4c6.5-11.8 19-19.1 32.5-18.7l20.9 .5c6.9 .2 13.7-1.7 19.6-5.2L173.3 5.3zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM64.4 492.4L88 390c8.9 3.7 18.6 5.6 28.6 5.4l20.7-.5c.2 0 .4 .1 .6 .2l17.6 10.7c22.4 13.6 50.5 13.6 72.9 0L246.1 395c.2-.1 .4-.2 .6-.2l20.7 .5c10 .2 19.7-1.7 28.6-5.4l23.6 102.4c1.3 5.5-.5 11.3-4.6 15.2s-10 5.3-15.4 3.8L192 480.6 84.4 511.4c-5.4 1.6-11.3 .1-15.4-3.8s-5.8-9.7-4.6-15.2z"]
};
var faJetFighterUp = {
  prefix: 'fas',
  iconName: 'jet-fighter-up',
  icon: [512, 512, [], "e518", "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v56 32 24c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H192v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96V448c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16V480c0-4.6-2-9-5.5-12L320 416.7V384H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V368 336 280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"]
};
var faDiagramProject = {
  prefix: 'fas',
  iconName: 'diagram-project',
  icon: [576, 512, ["project-diagram"], "f542", "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"]
};
var faProjectDiagram = faDiagramProject;
var faPedestal = {
  prefix: 'fas',
  iconName: 'pedestal',
  icon: [448, 512, [], "e20d", "M96 0C60.7 0 32 28.7 32 64V416H416V64c0-35.3-28.7-64-64-64H96zm24 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM304 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faChartPyramid = {
  prefix: 'fas',
  iconName: 'chart-pyramid',
  icon: [512, 512, [], "e0e6", "M290.6 59.7c-15.4-26.5-53.7-26.5-69.1 0L163 160H349L290.6 59.7zM69.6 320H442.4L367.7 192H144.3L69.6 320zM51 352L11.4 419.8C-4.2 446.5 15.1 480 45.9 480H466.1c30.9 0 50.1-33.5 34.6-60.2L461 352H51z"]
};
var faSidebar = {
  prefix: 'fas',
  iconName: 'sidebar',
  icon: [512, 512, [], "e24e", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 0V416H448V96H224zM88 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zM64 216c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"]
};
var faSnowmanHead = {
  prefix: 'fas',
  iconName: 'snowman-head',
  icon: [448, 512, ["frosty-head"], "f79b", "M64 64C64 28.7 92.7 0 128 0H320c35.3 0 64 28.7 64 64v96H224 64V64zM330.2 192H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H390.3c16.3 28.2 25.7 61 25.7 96c0 59.8-27.4 113.3-70.3 148.5c-9.7 8-22.3 11.5-34.9 11.5H137.2c-12.6 0-25.1-3.5-34.9-11.5C59.4 465.3 32 411.8 32 352c0-35 9.3-67.8 25.7-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h85.8H330.2zM152 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM219.3 445.2c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l23.8-46.3c2.3-4.5 3.5-9.6 3.5-14.7c0-17.7-14.3-32.2-32-32.2s-32 14.5-32 32.2c0 5.1 1.2 10.2 3.5 14.7l23.8 46.3z"]
};
var faFrostyHead = faSnowmanHead;
var faCopy = {
  prefix: 'fas',
  iconName: 'copy',
  icon: [512, 512, [], "f0c5", "M272 0H396.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128H192v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"]
};
var faBurgerGlass = {
  prefix: 'fas',
  iconName: 'burger-glass',
  icon: [640, 512, [], "e0ce", "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H272c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8c-12.4-10.9-20.3-26.9-20.3-44.8c0-6.3 1-13.8 4.4-21.5c5.5-12.5 20.5-40.4 52.7-65.3c16.2-12.5 36.3-23.8 60.9-32l10-139.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM73.2 160L66.4 64H317.6l-6.9 96H73.2zM640 292.3c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5H612.5c15.2 0 27.5-12.3 27.5-27.5zM384 239.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm-16 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16H304z"]
};
var faVolumeXmark = {
  prefix: 'fas',
  iconName: 'volume-xmark',
  icon: [576, 512, ["volume-mute", "volume-times"], "f6a9", "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faVolumeMute = faVolumeXmark;
var faVolumeTimes = faVolumeXmark;
var faHandSparkles = {
  prefix: 'fas',
  iconName: 'hand-sparkles',
  icon: [640, 512, [], "e05d", "M320 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V323.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512H348.8c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"]
};
var faBarsFilter = {
  prefix: 'fas',
  iconName: 'bars-filter',
  icon: [448, 512, [], "e0ad", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM288 416c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32z"]
};
var faPaintbrushPencil = {
  prefix: 'fas',
  iconName: 'paintbrush-pencil',
  icon: [576, 512, [], "e206", "M559.6 95.6c21.9-21.9 21.9-57.3 0-79.2s-57.3-21.9-79.2 0L227.7 269.1l79.2 79.2L559.6 95.6zM205 291.8c-9.3-2.5-19-3.8-29-3.8c-61.9 0-112 50.1-112 112c0 3.9 .2 7.8 .6 11.6C66.4 429.1 54.4 448 36.8 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H176c61.9 0 112-50.1 112-112c0-10-1.3-19.8-3.8-29l.1-.1-79.2-79.2-.1 .1zm93.4-138.7L164.7 19.3c-25-25-65.5-25-90.5 0L50.7 42.7c-25 25-25 65.5 0 90.5L173.5 256c.8 0 1.7 0 2.5 0c6.2 0 12.4 .4 18.4 1.2L298.5 153.1zM320 402.5l64.6 64.6c6.7 6.7 15.1 11.6 24.2 14.2l104 29.7c8.4 2.4 17.4 .1 23.6-6.1s8.5-15.2 6.1-23.6l-29.7-104c-2.6-9.2-7.5-17.5-14.2-24.2l-75.6-75.6L318.8 381.6c.8 6 1.2 12.2 1.2 18.4c0 .8 0 1.7 0 2.5z"]
};
var faPartyBell = {
  prefix: 'fas',
  iconName: 'party-bell',
  icon: [512, 512, [], "e31a", "M0 224C0 100.3 100.3 0 224 0c35.3 0 68.9 8.2 98.7 22.8C341.9 32.3 352 51.7 352 70.7c0 14.5-5.7 28.3-16 38.5L109.2 336C99 346.3 85.1 352 70.7 352c-19 0-38.4-10.1-47.8-29.3C8.2 292.9 0 259.3 0 224zM480 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 480a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM359 167c9.4-9.4 24.6-9.4 33.9 0l8.3 8.3c16.7 16.7 38.6 27.2 62.1 29.8l27.4 3c13.2 1.5 22.7 13.3 21.2 26.5s-13.3 22.7-26.5 21.2l-27.4-3c-34.3-3.8-66.3-19.2-90.7-43.6L359 201c-9.4-9.4-9.4-24.6 0-33.9zM201 359l8.3 8.2c24.4 24.4 39.8 56.4 43.6 90.7l3 27.4c1.5 13.2-8 25-21.2 26.5s-25-8-26.5-21.2l-3-27.4c-2.6-23.5-13.1-45.4-29.8-62.1L167 393c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM503.5 506.3c-10.1 8.6-25.3 7.3-33.8-2.8l-8.5-10c-12.5-14.8-19.1-33.7-18.6-53c.5-16.6-12.4-30.6-29-31.6l-30-1.8c-42.5-2.5-75.3-38.3-74.2-80.8c.2-7.6-2.4-15-7.3-20.7l-8.5-10c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8l8.5 10c12.5 14.8 19.1 33.7 18.6 53c-.5 16.6 12.4 30.6 29 31.6l30 1.8c42.5 2.5 75.3 38.3 74.2 80.8c-.2 7.6 2.4 15 7.3 20.7l8.5 10c8.6 10.1 7.3 25.3-2.8 33.8z"]
};
var faUserVneckHair = {
  prefix: 'fas',
  iconName: 'user-vneck-hair',
  icon: [448, 512, [], "e462", "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32zM96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0S96 57.3 96 128zm61.3 199.1c-3.2-4.3-8.4-6.7-13.7-6.2C62.9 329.7 0 398.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-83.1-62.9-151.5-143.7-160.3c-5.3-.6-10.5 1.9-13.7 6.2l-53.9 71.8c-6.4 8.5-19.2 8.5-25.6 0l-53.9-71.8z"]
};
var faJackOLantern = {
  prefix: 'fas',
  iconName: 'jack-o-lantern',
  icon: [576, 512, [127875], "f30e", "M234.6 103.9C251.5 98.8 269.4 96 288 96c22.8 0 44.7 4.2 64.8 11.7c-.6-2-.8-4.1-.8-6.3V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4l-40.9 93.5zm161.6 27.3c12.1 8.8 23.1 19.1 32.7 30.5c5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1c9.6-11.4 20.6-21.7 32.7-30.5c-.6-.1-1.2-.2-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320S68.1 512 152 512c19.3 0 37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8c83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8c-.6 .1-1.2 .2-1.8 .3zM208 208c5.3 0 10.3 2.7 13.3 7.1l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H176c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1zm173.3 7.1l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H336c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1zM368 437.5C346.2 444 319.8 448 288 448s-58.2-4-80-10.5V416c0-8.8-7.2-16-16-16H176c-8.6 0-15.7 6.9-16 15.4c-36.9-24.7-49.9-56.7-54.1-71.4c-1.4-5 .3-10.2 4-13.8c5.8-5.8 15.1-6.6 22.2-2.4c18 10.6 55.5 29.1 107.9 36.8V384c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V368c77.6 0 132.8-26.6 155.9-40.2c7.1-4.2 16.4-3.4 22.2 2.4c3.7 3.7 5.4 8.8 4 13.8c-4.2 14.7-17.3 46.8-54.1 71.4c-.3-8.6-7.3-15.4-16-15.4H384c-8.8 0-16 7.2-16 16v21.5z"]
};
var faGrip = {
  prefix: 'fas',
  iconName: 'grip',
  icon: [448, 512, ["grip-horizontal"], "f58d", "M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"]
};
var faGripHorizontal = faGrip;
var faShareFromSquare = {
  prefix: 'fas',
  iconName: 'share-from-square',
  icon: [576, 512, [61509, "share-square"], "f14d", "M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"]
};
var faShareSquare = faShareFromSquare;
var faKeynote = {
  prefix: 'fas',
  iconName: 'keynote',
  icon: [512, 512, [], "f66c", "M184 72h14.4c8.3 14.3 23.8 24 41.6 24h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H240c-17.8 0-33.3 9.7-41.6 24H184c-48.6 0-88 39.4-88 88v48H80c-12.1 0-23.2 6.8-28.6 17.7l-48 96C1.2 278.1 0 283 0 288v32c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V288c0-5-1.2-9.9-3.4-14.3l-48-96C455.2 166.8 444.1 160 432 160H144V112c0-22.1 17.9-40 40-40zM160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V384H224v64H160z"]
};
var faChildCombatant = {
  prefix: 'fas',
  iconName: 'child-combatant',
  icon: [576, 512, ["child-rifle"], "e4e0", "M176 128A64 64 0 1 0 176 0a64 64 0 1 0 0 128zm-8 352V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9H169.8c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0H432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16z"]
};
var faChildRifle = faChildCombatant;
var faGun = {
  prefix: 'fas',
  iconName: 'gun',
  icon: [576, 512, [], "e19b", "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96V208c0 17.7 14.3 32 32 32H42c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352H321.4c23.7 0 44.8-14.9 52.7-37.2L400.9 240H432c8.5 0 16.6-3.4 22.6-9.4L477.3 208H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H528V56zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSquarePhone = {
  prefix: 'fas',
  iconName: 'square-phone',
  icon: [448, 512, ["phone-square"], "f098", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"]
};
var faPhoneSquare = faSquarePhone;
var faHatBeach = {
  prefix: 'fas',
  iconName: 'hat-beach',
  icon: [640, 512, [], "e606", "M320 448c176.7 0 320-57.3 320-128c0-19.3-11.8-36.7-29.7-43.9L574.9 262c.7 4.2 1.1 8.5 1.1 12.8c0 42.7-34.6 77.3-77.3 77.3c-12.2 0-24.1-2.9-34.7-8.3c-10.7 5.4-22.6 8.3-34.7 8.3c-38.6 0-70.6-28.3-76.3-65.4c-10.6 .9-21.6 1.4-32.9 1.4c-88.4 0-160-28.7-160-64v0L29.7 276.1C11.8 283.3 0 300.7 0 320c0 70.7 143.3 128 320 128zm32-242.7c0-42.7 34.6-77.3 77.3-77.3c7.1 0 14.1 1 20.9 2.9C421.1 90.4 373.6 64 320 64c-70.4 0-130.2 45.5-151.6 108.7l.1-.2C174.7 201.3 240.1 224 320 224c11.7 0 23-.5 34-1.4c-1.3-5.6-2-11.5-2-17.3zM473.1 168c-5.5 3.8-12.7 3.8-18.2 0c-7.5-5.2-16.4-8-25.7-8c-25 0-45.3 20.3-45.3 45.3c0 9.2 2.8 18.2 8 25.7c3.8 5.5 3.8 12.7 0 18.2c-5.2 7.5-8 16.4-8 25.7c0 25 20.3 45.3 45.3 45.3c9.2 0 18.2-2.8 25.7-8c5.5-3.8 12.7-3.8 18.2 0c7.5 5.2 16.4 8 25.7 8c25 0 45.3-20.3 45.3-45.3c0-9.2-2.8-18.2-8-25.7c-3.8-5.5-3.8-12.7 0-18.2c5.2-7.5 8-16.4 8-25.7c0-25-20.3-45.3-45.3-45.3c-9.2 0-18.2 2.8-25.7 8zM464 216a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPlus = {
  prefix: 'fas',
  iconName: 'plus',
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"]
};
var faAdd = faPlus;
var faExpand = {
  prefix: 'fas',
  iconName: 'expand',
  icon: [448, 512, [], "f065", "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"]
};
var faComputer = {
  prefix: 'fas',
  iconName: 'computer',
  icon: [640, 512, [], "e4e5", "M384 96V320H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H181.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H277.3l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm464 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faFort = {
  prefix: 'fas',
  iconName: 'fort',
  icon: [640, 512, [], "e486", "M0 16C0 7.2 7.2 0 16 0H48c8.8 0 16 7.2 16 16V64H96V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V96v16 48H384V112 96 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V96v16 64c0 20.9-13.4 38.7-32 45.3V464c0 26.5-21.5 48-48 48H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64V512H80c-26.5 0-48-21.5-48-48V221.3C13.4 214.7 0 196.9 0 176V112 96 16z"]
};
var faCloudCheck = {
  prefix: 'fas',
  iconName: 'cloud-check',
  icon: [640, 512, [], "e35c", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM433 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z"]
};
var faXmark = {
  prefix: 'fas',
  iconName: 'xmark',
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
};
var faClose = faXmark;
var faMultiply = faXmark;
var faRemove = faXmark;
var faTimes = faXmark;
var faFaceSmirking = {
  prefix: 'fas',
  iconName: 'face-smirking',
  icon: [512, 512, [], "e397", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm96-48c0 8.8 7.2 16 16 16h32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32H112c-8.8 0-16 7.2-16 16zM375.8 338.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-.2 1.2c-3.2 19.3-19.9 33.4-39.5 33.4H192c-8.8 0-16 7.2-16 16s7.2 16 16 16H304.6c35.2 0 65.2-25.4 71-60.2l.2-1.2zM288 208c0 8.8 7.2 16 16 16h32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32H304c-8.8 0-16 7.2-16 16z"]
};
var faArrowsUpDownLeftRight = {
  prefix: 'fas',
  iconName: 'arrows-up-down-left-right',
  icon: [512, 512, ["arrows"], "f047", "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224V402.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288H402.7l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"]
};
var faArrows = faArrowsUpDownLeftRight;
var faChalkboardUser = {
  prefix: 'fas',
  iconName: 'chalkboard-user',
  icon: [640, 512, ["chalkboard-teacher"], "f51c", "M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"]
};
var faChalkboardTeacher = faChalkboardUser;
var faRhombus = {
  prefix: 'fas',
  iconName: 'rhombus',
  icon: [448, 512, [], "e23b", "M254.4 14.1C246.8 5.1 235.7 0 224 0s-22.8 5.1-30.4 14.1l-184 216C-3.2 245-3.2 267 9.6 281.9l184 216c7.6 8.9 18.7 14.1 30.4 14.1s22.8-5.1 30.4-14.1l184-216c12.7-14.9 12.7-36.9 0-51.9l-184-216z"]
};
var faClawMarks = {
  prefix: 'fas',
  iconName: 'claw-marks',
  icon: [576, 512, [], "f6c2", "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4l96 96 64 64 160 160 64 64 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L434.7 448H384c-17.7 0-32-14.3-32-32V365.3L210.7 224H160c-17.7 0-32-14.3-32-32V141.3L41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm0 224c12.5-12.5 32.8-12.5 45.3 0l64 64 96 96 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L210.7 448H128c-17.7 0-32-14.3-32-32V333.3L41.4 278.6c-12.5-12.5-12.5-32.8 0-45.3zM310.6 9.4l32 32 64 64 64 64 64 64 32 32c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L498.7 288H448c-17.7 0-32-14.3-32-32V205.3L370.7 160H320c-17.7 0-32-14.3-32-32V77.3L265.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"]
};
var faPesoSign = {
  prefix: 'fas',
  iconName: 'peso-sign',
  icon: [384, 512, [], "e222", "M64 32C46.3 32 32 46.3 32 64v64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.8C303.7 71 244.4 32 176 32H64zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32zM96 192H286.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96V192zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96V288H254.4z"]
};
var faFaceSmileTongue = {
  prefix: 'fas',
  iconName: 'face-smile-tongue',
  icon: [512, 512, [], "e394", "M503.4 322c5.6-21.1 8.6-43.2 8.6-66C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c61.5 0 118-21.7 162.1-57.9c-2.8-1.2-5.5-2.7-8.2-4.2l-68.1-40.4C316.3 423.8 287.1 432 256 432c-84.1 0-154-59.7-175.5-139.9c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3C129.5 351.5 187.9 400 256 400s126.5-48.5 144.5-116.1c2.3-8.5 11.1-13.6 19.6-11.3c1.5 .4 2.9 1 4.2 1.8l65.4 37.8c5 2.9 9.6 6.2 13.7 10zM370.6 389.3l55.7 33.1c22.6 13.4 51.8 5.8 65-17c13.3-23 5.4-52.3-17.6-65.6l-48.6-28.1c-11.7 30.4-30.5 57.1-54.5 77.6zm-153-160.5l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faCartCircleXmark = {
  prefix: 'fas',
  iconName: 'cart-circle-xmark',
  icon: [640, 512, [], "e3f4", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faBuildingShield = {
  prefix: 'fas',
  iconName: 'building-shield',
  icon: [576, 512, [], "e4d8", "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V207l-42.4 17H304 272c-8.8 0-16 7.2-16 16v32 24.2V304c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"]
};
var faCirclePhoneFlip = {
  prefix: 'fas',
  iconName: 'circle-phone-flip',
  icon: [512, 512, ["phone-circle-alt"], "e11c", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm69.3 128.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L312 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C143.1 378 151 384 160 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"]
};
var faPhoneCircleAlt = faCirclePhoneFlip;
var faBaby = {
  prefix: 'fas',
  iconName: 'baby',
  icon: [448, 512, [], "f77c", "M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"]
};
var faUsersLine = {
  prefix: 'fas',
  iconName: 'users-line',
  icon: [640, 512, [], "e592", "M211.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64zm461.6 32H576c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faQuoteLeft = {
  prefix: 'fas',
  iconName: 'quote-left',
  icon: [448, 512, [8220, "quote-left-alt"], "f10d", "M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z"]
};
var faQuoteLeftAlt = faQuoteLeft;
var faTractor = {
  prefix: 'fas',
  iconName: 'tractor',
  icon: [640, 512, [128668], "f722", "M96 64c0-35.3 28.7-64 64-64H266.3c26.2 0 49.7 15.9 59.4 40.2L373.7 160H480V126.2c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48H352c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V192 160 64zm170.3 0H160v96h32H304.7L266.3 64zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM528 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"]
};
var faKeySkeleton = {
  prefix: 'fas',
  iconName: 'key-skeleton',
  icon: [448, 512, [128477], "f6f3", "M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 28.2 8.1 54.5 22.1 76.7L9.4 393.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 416 96 397.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 352l86.1-86.1c22.2 14 48.5 22.1 76.7 22.1z"]
};
var faTrashArrowUp = {
  prefix: 'fas',
  iconName: 'trash-arrow-up',
  icon: [448, 512, ["trash-restore"], "f829", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"]
};
var faTrashRestore = faTrashArrowUp;
var faArrowDownUpLock = {
  prefix: 'fas',
  iconName: 'arrow-down-up-lock',
  icon: [640, 512, [], "e4b0", "M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288H416V272c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3V224l-128 0H96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H96V402.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64zM288 320V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H288zm240-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faArrowDownToBracket = {
  prefix: 'fas',
  iconName: 'arrow-down-to-bracket',
  icon: [448, 512, [], "e094", "M374.6 214.6l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 242.7V32c0-17.7 14.3-32 32-32s32 14.3 32 32V242.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM64 352v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96V352c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faLinesLeaning = {
  prefix: 'fas',
  iconName: 'lines-leaning',
  icon: [384, 512, [], "e51e", "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z"]
};
var faSquareQ = {
  prefix: 'fas',
  iconName: 'square-q',
  icon: [448, 512, [], "e27b", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L345 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z"]
};
var faRulerCombined = {
  prefix: 'fas',
  iconName: 'ruler-combined',
  icon: [512, 512, [], "f546", "M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"]
};
var faSymbols = {
  prefix: 'fas',
  iconName: 'symbols',
  icon: [512, 512, [128291, "icons-alt"], "f86e", "M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM32 0H192c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 64 0 49.7 0 32S14.3 0 32 0zM502.6 342.6l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM0 128c0-17.7 14.3-32 32-32h80 80c17.7 0 32 14.3 32 32s-14.3 32-32 32H144v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160H32c-17.7 0-32-14.3-32-32zM288 328a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM472 432a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM135.6 374l10.3 10.8 23.5-23.5c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-24.7 24.7L215.2 458c12.2 12.8 11.6 33.1-1.2 45.2s-33.1 11.6-45.2-1.2l-24.1-25.4-12.8 12.8C117.4 503.9 97.7 512 77.3 512C34.6 512 0 477.4 0 434.7v-.9c0-19.4 7.2-38.2 20.3-52.6l13.1-14.4C22.5 354.3 16 337.9 16 320c0-39.8 32.2-72 72-72s72 32.2 72 72c0 21.5-9.4 40.8-24.4 54zm-68 50.3c-2.4 2.6-3.7 6-3.7 9.5v.9c0 7.3 5.9 13.3 13.3 13.3c3.5 0 6.9-1.4 9.4-3.9l14-14L81.1 409.5 67.7 424.3zM104 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faIconsAlt = faSymbols;
var faCopyright = {
  prefix: 'fas',
  iconName: 'copyright',
  icon: [512, 512, [169], "f1f9", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"]
};
var faFlaskGear = {
  prefix: 'fas',
  iconName: 'flask-gear',
  icon: [640, 512, [], "e5f1", "M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c10.6 0 20.7-2.4 29.7-6.6c-2.8-6.2-4.2-12.9-4.2-19.7v-.9c-17.6 9.7-41.5 8.1-57.2-8.7c-9.2-9.9-17.4-20.9-24.4-33s-12.5-24.7-16.4-37.6c-6.7-21.6 3.4-42.7 20-53.3l-.2-.2h-207L173 263.9c12.4-20.2 19-43.4 19-67.1V64h64V196.8c0 23.7 6.6 46.9 19 67.1L304 311c.1-4 .8-8.1 2-12.2c4-12.9 9.4-25.5 16.4-37.6c4.1-7.1 8.7-13.9 13.6-20.3l-6.5-10.6c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM436 218.2v17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9v17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8V467.5c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7V218.2c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7c-6.8 1.5-11.3 7.8-11.3 14.8zm-4.1 133.5a48.1 48.1 0 1 1 96.1 0 48.1 48.1 0 1 1 -96.1 0z"]
};
var faHighlighterLine = {
  prefix: 'fas',
  iconName: 'highlighter-line',
  icon: [576, 512, [], "e1af", "M229 229l215-158.4 29.3 29.3L315 315 229 229zM128 320l0 0-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0L224 416h71.7c15.3 0 29.6-7.2 38.6-19.5L535.6 123.4c5.5-7.4 8.4-16.4 8.4-25.6c0-11.4-4.5-22.4-12.6-30.5L476.6 12.6C468.5 4.5 457.6 0 446.2 0C437 0 428 2.9 420.6 8.4L147.5 209.6c-12.3 9-19.5 23.4-19.5 38.6V320zM70.1 403.3l-63 63c-4.5 4.5-7 10.6-7 17V488c0 13.3 10.7 24 24 24H92.7c6.4 0 12.5-2.5 17-7l31-31L70.1 403.3zM224 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"]
};
var faBracketSquare = {
  prefix: 'fas',
  iconName: 'bracket-square',
  icon: [192, 512, ["bracket", "bracket-left"], "5b", "M0 96C0 60.7 28.7 32 64 32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64V416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V96z"]
};
var faBracket = faBracketSquare;
var faBracketLeft = faBracketSquare;
var faIslandTropical = {
  prefix: 'fas',
  iconName: 'island-tropical',
  icon: [512, 512, [127965, "island-tree-palm"], "f811", "M114.3 93.7c-1.5 1.5-3.5 2.3-5.7 2.3H78.2c-8.8 0-16.1-7.2-13.8-15.8C73.6 44.8 112.8 0 190.2 0c58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c77.4 0 116.6 44.8 125.8 80.2c2.2 8.6-5 15.8-13.8 15.8H451.3c-2.1 0-4.2-.8-5.7-2.3l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24c-1.5 1.5-3.5 2.3-5.7 2.3H301.5c28 79.9 21.2 170.2 9.9 226.1C370.9 365.1 416 417.3 416 480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32c0-70.7 57.3-128 128-128h64c29.7-79.3 29.4-150.9 22.8-194l-87.6 87.6c-6.2 6.2-16.5 6.2-21-1.4c-18.5-31.6-22.5-90.9 32.3-145.7c1.4-1.4 2.8-2.7 4.1-4c-.3-.3-.7-.5-1-.8l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24z"]
};
var faIslandTreePalm = faIslandTropical;
var faArrowRightFromLine = {
  prefix: 'fas',
  iconName: 'arrow-right-from-line',
  icon: [448, 512, [8614, "arrow-from-left"], "f343", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 224 160 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l178.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
};
var faArrowFromLeft = faArrowRightFromLine;
var faH2 = {
  prefix: 'fas',
  iconName: 'h2',
  icon: [640, 512, [], "f314", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zm385.9 47.4c11.6-9.9 26.4-15.4 41.7-15.4H496c35.3 0 64 28.7 64 64v5.8c0 17.9-7.5 35.1-20.8 47.2L378.4 392.4c-9.7 8.9-13 22.9-8.2 35.2S386.8 448 400 448H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H482.3l100.2-91.9c26.4-24.2 41.5-58.5 41.5-94.4V192c0-70.7-57.3-128-128-128h-4.5c-30.6 0-60.1 10.9-83.3 30.8l-29 24.9c-13.4 11.5-15 31.7-3.5 45.1s31.7 15 45.1 3.5l29-24.9z"]
};
var faEquals = {
  prefix: 'fas',
  iconName: 'equals',
  icon: [448, 512, [62764], "3d", "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z"]
};
var faCakeSlice = {
  prefix: 'fas',
  iconName: 'cake-slice',
  icon: [512, 512, [127856, "shortcake"], "e3e5", "M276.2 38.9c5.6-4.4 12.6-6.9 19.8-6.9c44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256v.5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2 .3 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2c0 35.4-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V272c0-9.8 4.5-19.1 12.2-25.1l264-208zM448 288H64v48H448v-.1-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.4-.4V330v-.4-.4V329v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V325v-.4-.4V324v-.4-.4-.4-.4-.4-.4-.4V321v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V312v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V307v-.4-.4-.4-.4V305v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V297v-.4-.4-.4-.4V295v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V290v-.4-.4-.4-.4V288zM64 416H448v-.2-.2-.2-.2-.2V415v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V413v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V411v-.2-.2-.2-.2V410v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V406v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V401v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V398v-.2-.2-.2-.2-.2-.2-.2-.2V396v-.2-.2-.2-.2-.2-.2-.2-.2V394v-.2-.2-.2V393v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V390v-.2-.2-.2V389v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.3-.2-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V379v-.3-.3-.3V378v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V374v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V371v-.3-.3-.3-.3-.3-.3V369v-.3-.3-.3V368H64v48z"]
};
var faShortcake = faCakeSlice;
var faPeanut = {
  prefix: 'fas',
  iconName: 'peanut',
  icon: [512, 512, [], "e430", "M432 0H364c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C245 57.8 234.4 74 227.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364v68c0 44.2 35.8 80 80 80h68c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C495.6 225.4 512 188.6 512 148V80c0-44.2-35.8-80-80-80zM396.8 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm0 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 0a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM192 396.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm0-64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z"]
};
var faWrenchSimple = {
  prefix: 'fas',
  iconName: 'wrench-simple',
  icon: [384, 512, [], "e2d1", "M132.7 164.7l48 48c6.2 6.2 16.4 6.2 22.6 0l48-48c3-3 4.7-7.1 4.7-11.3V17.6c0-11 10.9-18.7 20.8-13.8C340.3 35 384 100.4 384 176c0 71.1-38.6 133.1-96 166.3V464c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V342.3C38.6 309.1 0 247.1 0 176C0 100.4 43.7 35 107.2 3.7C117.1-1.2 128 6.5 128 17.6V153.4c0 4.2 1.7 8.3 4.7 11.3z"]
};
var faBlender = {
  prefix: 'fas',
  iconName: 'blender',
  icon: [512, 512, [], "f517", "M0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faTeeth = {
  prefix: 'fas',
  iconName: 'teeth',
  icon: [576, 512, [], "f62e", "M0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"]
};
var faTally2 = {
  prefix: 'fas',
  iconName: 'tally-2',
  icon: [640, 512, [], "e295", "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"]
};
var faShekelSign = {
  prefix: 'fas',
  iconName: 'shekel-sign',
  icon: [448, 512, [8362, "ils", "shekel", "sheqel", "sheqel-sign"], "f20b", "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192c35.3 0 64 28.7 64 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128H32zM320 480c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320z"]
};
var faIls = faShekelSign;
var faShekel = faShekelSign;
var faSheqel = faShekelSign;
var faSheqelSign = faShekelSign;
var faCars = {
  prefix: 'fas',
  iconName: 'cars',
  icon: [640, 512, [], "f85b", "M123.4 74.9c2.2-6.5 8.3-10.9 15.2-10.9H277.4c6.9 0 13 4.4 15.2 10.9L310.3 128H105.7l17.7-53.1zM36.1 134.4C14.8 144.7 0 166.6 0 192v96H0v32c0 17.7 14.3 32 32 32H48c17.7 0 32-14.3 32-32V288H216.5c5.1-5.7 10.8-10.7 17.1-15.1l22.8-68.3c15.2-45.7 58-76.6 106.3-76.6h15.1L353.3 54.7C342.4 22 311.8 0 277.4 0H138.6c-34.4 0-65 22-75.9 54.7L36.1 134.4zM56 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm306.6 16H501.4c6.9 0 13 4.4 15.2 10.9L534.3 288H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3l-26.6 79.7C238.8 304.7 224 326.6 224 352v96h0v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H560v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32l0-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faAxeBattle = {
  prefix: 'fas',
  iconName: 'axe-battle',
  icon: [512, 512, [], "f6b3", "M95.9 14l0 .1c0 .1 .1 .4 .1 .7c.1 .7 .3 1.8 .6 3.3c.6 3 1.7 7.4 3.5 12.8c3.6 10.8 9.9 25.1 20.6 39.5c13.9 18.6 36 37.9 71.2 48.8V266.8c-29.9 11.1-50.9 29.3-65.6 47.3c-11.9 14.6-19.7 29.3-24.5 40.3c-2.4 5.5-4 10-5.1 13.1c-.5 1.5-.9 2.7-1.1 3.5l-.2 .8 0 .1 0 0c-1.5 5.8-6.1 10.3-11.9 11.7s-12-.7-15.8-5.3L80 368c-12.2 10.3-12.2 10.3-12.2 10.3l0 0 0 0-.1-.1-.2-.2-.6-.8c-.5-.7-1.3-1.6-2.3-2.9c-1.9-2.5-4.6-6.1-7.7-10.6c-6.3-9.2-14.7-22.4-23.1-38.9C17 291.9 0 245.3 0 192S17 92.1 33.7 59.3c8.4-16.5 16.8-29.7 23.1-38.9c3.2-4.6 5.8-8.2 7.7-10.6c1-1.2 1.7-2.2 2.3-2.9l.6-.8 .2-.2 .1-.1 0 0 0 0s0 0 12.2 10.3L67.8 5.7c4.1-4.9 10.7-6.8 16.8-5c6.1 1.8 10.5 7 11.3 13.3l0 0zM320 266.8V119.2c35.2-10.9 57.3-30.2 71.2-48.8C403.3 54.3 412.8 34 416.1 14c.8-6.3 5.3-11.5 11.3-13.3c6.1-1.8 12.8 .3 16.9 5.2c13.3 16.3 24.4 34.8 33.9 53.4c12.4 24.5 25.1 56.6 30.7 93.4c.5 3.5-1.4 7-4.7 8.4l-55.1 23.6c-6.5 2.8-6.5 11.9 0 14.7L504.3 223c3.3 1.4 5.3 4.8 4.7 8.4c-8 53-31.3 105.5-64.5 146.6c-3.9 4.6-10.3 7-16.1 5.6s-10.5-6-11.9-11.8c-5.9-21-17.2-40.9-30.9-57.7c-14.7-18-35.7-36.2-65.6-47.3zM288 64V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faUserHairLong = {
  prefix: 'fas',
  iconName: 'user-hair-long',
  icon: [448, 512, [], "e45b", "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224 70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128zm65.3 192H286.7C375.8 320 448 392.2 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3C0 392.2 72.2 320 161.3 320z"]
};
var faMap = {
  prefix: 'fas',
  iconName: 'map',
  icon: [576, 512, [128506, 62072], "f279", "M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"]
};
var faFileCircleInfo = {
  prefix: 'fas',
  iconName: 'file-circle-info',
  icon: [576, 512, [58604], "e493", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16h0v48h0c-8.8 0-16 7.2-16 16s7.2 16 16 16h16 16c8.8 0 16-7.2 16-16s-7.2-16-16-16V368c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16z"]
};
var faFaceDisappointed = {
  prefix: 'fas',
  iconName: 'face-disappointed',
  icon: [512, 512, [], "e36f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faLassoSparkles = {
  prefix: 'fas',
  iconName: 'lasso-sparkles',
  icon: [576, 512, [], "e1c9", "M290.7 0L288 0C128.9 0 0 78.8 0 176c0 57.2 44.7 108.1 113.9 140.2l-.2 .4L160.5 340c19.3 9.7 31.5 29.4 31.5 51c0 31.5-25.5 57-57 57H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h71c66.8 0 121-54.2 121-121c0-14.1-2.4-27.8-7-40.6c12.8 1.1 25.8 1.6 39 1.6c159.1 0 288-78.8 288-176c0-76.4-79.6-141.4-191-165.8l5.6 15.1 26 9.6C435.5 42 448 59.9 448 80c0 5.6-1 11.1-2.8 16.2C486.4 116.5 512 144.8 512 176c0 61.9-100.3 112-224 112S64 237.9 64 176c0-51 68.2-94 161.4-107.6c3.8-15.2 14.8-27.9 29.9-33.4l26-9.6L290.7 0zM351 10.4C348.7 4.2 342.7 0 336 0s-12.7 4.2-15 10.4L306.3 50.3 266.4 65c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L321 149.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L405.6 95c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15L365.7 50.3 351 10.4zM496 352c-6.7 0-12.7 4.2-15 10.4l-14.7 39.8L426.4 417c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L481 501.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L565.6 447c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.8-14.7L511 362.4c-2.3-6.3-8.3-10.4-15-10.4z"]
};
var faClockEleven = {
  prefix: 'fas',
  iconName: 'clock-eleven',
  icon: [512, 512, [], "e347", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120v56.7l-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faRocket = {
  prefix: 'fas',
  iconName: 'rocket',
  icon: [512, 512, [], "f135", "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faSirenOn = {
  prefix: 'fas',
  iconName: 'siren-on',
  icon: [640, 512, [], "e02e", "M69.3 36l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM597.3 76l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 192H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM144 352l25-199.9c4-32 31.2-56.1 63.5-56.1h175c32.3 0 59.5 24 63.5 56.1L496 352H234.1l21.8-174c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9L201.9 352H144zM96 416c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416z"]
};
var faClockTen = {
  prefix: 'fas',
  iconName: 'clock-ten',
  icon: [512, 512, [], "e354", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120v91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faCandleHolder = {
  prefix: 'fas',
  iconName: 'candle-holder',
  icon: [448, 512, [128367], "f6bc", "M160 192c-44.2 0-80-35.8-80-80c0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zm-32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V224h64c17.7 0 32 14.3 32 32V464h52.1c-2.7-7.5-4.1-15.6-4.1-24c0-39.8 32.2-72 72-72s72 32.2 72 72s-32.2 72-72 72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64V256c0-17.7 14.3-32 32-32h32zM400 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faVideoArrowDownLeft = {
  prefix: 'fas',
  iconName: 'video-arrow-down-left',
  icon: [576, 512, [], "e2c8", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L416 174.9V192 320v17.1l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128zM232 352H120c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v54.1L247 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-103 103H232c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faPhotoFilm = {
  prefix: 'fas',
  iconName: 'photo-film',
  icon: [640, 512, ["photo-video"], "f87c", "M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"]
};
var faPhotoVideo = faPhotoFilm;
var faFloppyDiskCircleArrowRight = {
  prefix: 'fas',
  iconName: 'floppy-disk-circle-arrow-right',
  icon: [576, 512, ["save-circle-arrow-right"], "e180", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H296.2c-17.6-21.4-30.3-46.9-36.3-75c-10.2 6.9-22.6 11-35.9 11c-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7 .2 16 .7V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM428.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
var faFolderMinus = {
  prefix: 'fas',
  iconName: 'folder-minus',
  icon: [512, 512, [], "f65d", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faPlanetMoon = {
  prefix: 'fas',
  iconName: 'planet-moon',
  icon: [576, 512, [], "e01f", "M512 0a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zM236.2 112.4c-4-.3-8.1-.4-12.2-.4c-76.2 0-141.1 48.4-165.6 116.2C53.3 242.3 64.7 256 79.7 256h28.4c12.7 0 24.9 5.1 33.9 14.1L185 313c4.5 4.5 7 10.6 7 17V352c0 9.2 3.9 17.6 10.2 23.4l1.9 1.8c9.3 8.6 19.9 18.4 19.9 30.8v23c0 13.8 11.2 25 25 25c9.2 0 17.7-5.1 22-13.2l41.3-76.6c5-9.3 7.6-19.8 7.6-30.3V320c0-17.7-14.3-32-32-32H222.1c-9 0-17.7-3.6-24.1-10c-12.5-12.5-13.4-32.4-2.1-45.9l52.7-63.2c4.8-5.8 7.4-13 7.4-20.5V134.9c0-11.6-8.3-21.7-19.8-22.5z"]
};
var faFaceEyesXmarks = {
  prefix: 'fas',
  iconName: 'face-eyes-xmarks',
  icon: [512, 512, [], "e374", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM123.3 132.7L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm192 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM256 304c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z"]
};
var faChartScatter = {
  prefix: 'fas',
  iconName: 'chart-scatter',
  icon: [512, 512, [], "f7ee", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDisplayArrowDown = {
  prefix: 'fas',
  iconName: 'display-arrow-down',
  icon: [576, 512, [], "e164", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352V64H512V352H64V64H224V0H64zM312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V206.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V24z"]
};
var faStore = {
  prefix: 'fas',
  iconName: 'store',
  icon: [576, 512, [], "f54e", "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"]
};
var faArrowTrendUp = {
  prefix: 'fas',
  iconName: 'arrow-trend-up',
  icon: [576, 512, [], "e098", "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"]
};
var faPlugCircleMinus = {
  prefix: 'fas',
  iconName: 'plug-circle-minus',
  icon: [576, 512, [], "e55e", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faOliveBranch = {
  prefix: 'fas',
  iconName: 'olive-branch',
  icon: [640, 512, [], "e317", "M2.7 53.1C13.8 41.6 59 0 128 0c66.9 0 111.4 39.1 124.2 52L306 26.7C343.3 9.1 384 0 425.2 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H425.2c-34.2 0-67.9 7.5-98.8 22.1L191.9 133.4C189.1 219.3 118.6 288 32 288H16c-8.8 0-16-7.2-16-16V256c0-61.4 34.5-114.6 85.2-141.5C40.4 102.8 11.3 75.8 2.7 66.9C.9 65 0 62.6 0 60s.9-5 2.7-6.9zM480 320c0 106-64.5 192-144 192s-144-86-144-192s64.5-192 144-192s144 86 144 192zM465.7 471.8c29.2-40.5 46.3-94 46.3-151.8c0-59.3-18-114.2-48.6-155c-10.5-14-22.7-26.5-36.2-36.9c48.2 1.6 101.3 25.8 144.2 70.3c75 77.8 90.2 188.1 33.9 246.4c-34.1 35.4-86.8 43.5-139.6 27z"]
};
var faAngle = {
  prefix: 'fas',
  iconName: 'angle',
  icon: [448, 512, [], "e08c", "M252.6 78.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-192 384c-5 9.9-4.4 21.7 1.4 31.1S20.9 480 32 480H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H83.8L252.6 78.3zm-12.2 96l-21.9 43.8c21.4 17.4 40.4 37.7 56.2 60.4l40.8-25.3c-20.7-30.1-46.1-56.7-75.1-78.9zM321.1 384h49c-7-37-19.8-71.9-37.6-103.7l-40.8 25.3c13.3 24.2 23.3 50.5 29.5 78.3z"]
};
var faVacuumRobot = {
  prefix: 'fas',
  iconName: 'vacuum-robot',
  icon: [512, 512, [], "e04e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM356.7 356.7c55.6-55.6 55.6-145.8 0-201.4s-145.8-55.6-201.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c68.1-68.1 178.5-68.1 246.6 0s68.1 178.5 0 246.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm-144-144c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z"]
};
var faSignHanging = {
  prefix: 'fas',
  iconName: 'sign-hanging',
  icon: [512, 512, ["sign"], "f4d9", "M96 0c17.7 0 32 14.3 32 32V64l352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H64V32C64 14.3 78.3 0 96 0zm96 160H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"]
};
var faSign = faSignHanging;
var faSquareDivide = {
  prefix: 'fas',
  iconName: 'square-divide',
  icon: [448, 512, [], "e26a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM136 232H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSignalStreamSlash = {
  prefix: 'fas',
  iconName: 'signal-stream-slash',
  icon: [640, 512, [], "e250", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-91.7-71.9C562.6 355.5 576 307.3 576 256c0-68.1-23.7-130.7-63.2-180c-11.1-13.8-31.2-16-45-5s-16 31.2-5 45c30.7 38.4 49.1 87 49.1 140c0 36.4-8.7 70.8-24.1 101.1l-38.7-30.4c9.5-21.7 14.8-45.6 14.8-70.8c0-45.1-17-86.2-44.8-117.3c-11.8-13.2-32-14.3-45.2-2.5s-14.3 32-2.5 45.2c17.8 19.8 28.5 46 28.5 74.7c0 10.1-1.3 19.9-3.8 29.2l-53.6-42c-5.8-24.7-28-43.2-54.5-43.2c-.2 0-.4 0-.5 0L38.8 5.1zm84.7 188.2C116.1 212.8 112 233.9 112 256c0 45.1 17 86.2 44.8 117.3c11.8 13.2 32 14.3 45.2 2.5s14.3-32 2.5-45.2c-17.8-19.8-28.5-46-28.5-74.7c0-6.8 .6-13.5 1.8-19.9l-54.3-42.8zM33 122C11.9 162 0 207.6 0 256c0 68.1 23.7 130.7 63.2 180c11.1 13.8 31.2 16 45 5s16-31.2 5-45C82.4 357.6 64 309 64 256c0-33.4 7.3-65.1 20.4-93.5L33 122z"]
};
var faBezierCurve = {
  prefix: 'fas',
  iconName: 'bezier-curve',
  icon: [640, 512, [], "f55b", "M296 136V88h48v48H296zM288 32c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400V80c0-26.5-21.5-48-48-48H288zM88 376h48v48H88V376zm416 48V376h48v48H504z"]
};
var faEyeDropperHalf = {
  prefix: 'fas',
  iconName: 'eye-dropper-half',
  icon: [512, 512, [], "e173", "M240.1 130.8L341.6 29.2c39-39 102.2-39 141.1 0s39 102.2 0 141.1L381.2 271.9l9.4 9.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l9.4 9.4zm-63.9 71.8l45.3 45.3L149.3 320h85.5l29.4-29.4 45.3 45.3L188.7 456.6c-15 15-35.4 23.4-56.6 23.4H89.7L49.7 506.6c-12.7 8.5-29.6 6.8-40.4-4s-12.5-27.7-4-40.4L32 422.3V379.9c0-21.2 8.4-41.6 23.4-56.6L176.1 202.6z"]
};
var faStoreLock = {
  prefix: 'fas',
  iconName: 'store-lock',
  icon: [640, 512, [], "e4a6", "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c5 5.5 10.6 10.3 16.8 14.4C455.2 179.6 489.3 160 528 160c10.4 0 20.5 1.4 30.1 4.1c4.4-19.8 1.5-41.5-10.4-60.3zM128 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H392.6c-5.4-9.4-8.6-20.3-8.6-32V384H128zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faBellSlash = {
  prefix: 'fas',
  iconName: 'bell-slash',
  icon: [640, 512, [128277, 61943], "f1f6", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c.5-1.7 .7-3.5 .7-5.4c0-27.6-11-54.1-30.5-73.7L512 320c-20.5-20.5-32-48.3-32-77.3V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM160 242.7c0 29-11.5 56.8-32 77.3l-1.5 1.5C107 341 96 367.5 96 395.2c0 11.5 9.3 20.8 20.8 20.8H406.2L160 222.1v20.7zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
};
var faCloudBoltSun = {
  prefix: 'fas',
  iconName: 'cloud-bolt-sun',
  icon: [640, 512, ["thunderstorm-sun"], "f76e", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zM639.9 303.9c0 44.2-35.8 80-80 80H541.3c3.5-10.1 3.7-21.3 0-31.8C534.5 332.9 516.4 320 496 320H477.7l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2l-160 128c-14.5 11.6-20.9 30.5-16.8 48.4c-37.9-12.8-65.2-48.7-65.2-90.9c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7zM474.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L425.9 352H496c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L374.1 384H304c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faThunderstormSun = faCloudBoltSun;
var faCameraSlash = {
  prefix: 'fas',
  iconName: 'camera-slash',
  icon: [640, 512, [], "e0d9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8L202.7 96H154.8L38.8 5.1zM285.4 198.4c10.7-4.1 22.4-6.4 34.6-6.4c53 0 96 43 96 96c0 4.1-.3 8.2-.8 12.2L285.4 198.4zM224 288c0-5 .4-9.9 1.1-14.6L65.2 147.4c-.8 4.1-1.2 8.3-1.2 12.6V416c0 35.3 28.7 64 64 64H487.4L356.4 376.8c-11.2 4.6-23.5 7.2-36.4 7.2c-53 0-96-43-96-96z"]
};
var faCommentQuote = {
  prefix: 'fas',
  iconName: 'comment-quote',
  icon: [512, 512, [], "e14c", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM160 144h48c17.7 0 32 14.3 32 32v24 24 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256H160c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32zm224 80v39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256H304c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24z"]
};
var faTablet = {
  prefix: 'fas',
  iconName: 'tablet',
  icon: [448, 512, ["tablet-android"], "f3fb", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTabletAndroid = faTablet;
var faSchoolFlag = {
  prefix: 'fas',
  iconName: 'school-flag',
  icon: [576, 512, [], "e56e", "M288 0H400c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H320.7l89.6 64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48V512H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H165.7L256 95.5V32c0-17.7 14.3-32 32-32zm48 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H464z"]
};
var faMessageCode = {
  prefix: 'fas',
  iconName: 'message-code',
  icon: [512, 512, [], "e1df", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm217 97c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM329 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"]
};
var faGlassHalf = {
  prefix: 'fas',
  iconName: 'glass-half',
  icon: [384, 512, ["glass-half-empty", "glass-half-full"], "e192", "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM77.8 224L66.4 64H317.6L306.2 224H77.8z"]
};
var faGlassHalfEmpty = faGlassHalf;
var faGlassHalfFull = faGlassHalf;
var faFill = {
  prefix: 'fas',
  iconName: 'fill',
  icon: [512, 512, [], "f575", "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L386.7 288H67.5c1.4-5.4 4.2-10.4 8.4-14.6L168 181.3z"]
};
var faMessageMinus = {
  prefix: 'fas',
  iconName: 'message-minus',
  icon: [512, 512, ["comment-alt-minus"], "f4a7", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM184 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faCommentAltMinus = faMessageMinus;
var faAngleUp = {
  prefix: 'fas',
  iconName: 'angle-up',
  icon: [448, 512, [8963], "f106", "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"]
};
var faDinosaur = {
  prefix: 'fas',
  iconName: 'dinosaur',
  icon: [640, 512, [], "e5fe", "M446.2 0H448C554 0 640 86 640 192v30.6c0 88-51.5 165.6-128 201.5V480c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V458c-15.3 3.9-31.4 6-48 6c-6.8 0-13.5-.4-20.1-1c-7.5-18.9-24.4-33.3-45.4-36.8L162 408.1c-19.6-3.3-34-20.2-34-40.1c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.5 25.7 65.8 60.7 71.7l108.5 18.1c13.2 2.2 22.8 13.6 22.8 26.9c0 15.1-12.2 27.3-27.3 27.3H256 224 192 120.7C54.1 512 0 457.9 0 391.3c0-34 14.4-66.5 39.5-89.3l89.7-81.6C172 181.5 227.6 160 285.3 160c50.2 0 99 16.3 139.2 46.4L480 248c6.9 5.2 15.3 8 24 8c22.1 0 40-17.9 40-40V192c0-35.3-28.7-64-64-64H448 415.7c-26.3 0-47.7-21.4-47.7-47.7V75.6c0-16.7 10.1-31.6 25.6-37.8l1.7-.7c8.2-3.3 14.8-9.4 18.7-17.2C420.2 7.7 432.6 0 446.2 0zM464 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faDrumstickBite = {
  prefix: 'fas',
  iconName: 'drumstick-bite',
  icon: [512, 512, [], "f6d7", "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176v89.2z"]
};
var faLinkHorizontalSlash = {
  prefix: 'fas',
  iconName: 'link-horizontal-slash',
  icon: [640, 512, ["chain-horizontal-slash"], "e1cc", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-56.7-44.4c39.6-25.8 65.9-70.5 65.9-121.3c0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9 .3c38.9 6.5 67.4 40.1 67.4 79.5c0 36.6-24.4 67.6-57.9 77.4L415.3 300.2c20.5-25.1 32.7-57.1 32.7-91.6C448 128.7 383.3 64 303.4 64H144.6c-9.4 0-18.5 .9-27.4 2.6L38.8 5.1zM195.6 128H303.4c44.5 0 80.6 36.1 80.6 80.6c0 19.7-7.1 38-19.1 52.1L195.6 128zM446.8 448l-81.2-64H336.6c-44.5 0-80.6-36.1-80.6-80.6c0-1.9 .1-3.7 .2-5.5l-55.5-43.8c-5.6 15.4-8.6 32.1-8.6 49.3C192 383.3 256.7 448 336.6 448H446.8zM30.4 119.9C11.3 144.4 0 175.2 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9 .3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-18.5 6.2-35.5 16.6-49.1L30.4 119.9z"]
};
var faChainHorizontalSlash = faLinkHorizontalSlash;
var faHollyBerry = {
  prefix: 'fas',
  iconName: 'holly-berry',
  icon: [512, 512, [], "f7aa", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faNose = {
  prefix: 'fas',
  iconName: 'nose',
  icon: [448, 512, [], "e5bd", "M324.2 231.9L421 338.3c17.4 19.1 27 44 27 69.9C448 465.5 401.5 512 344.1 512h-9.4c-32.3 0-63.6-11.3-88.4-32l-6.4-5.3c-20.7-17.2-46.7-26.7-73.6-26.7c-21.2 0-38.3 17.2-38.3 38.3V492c0 1.7 .1 3.4 .3 5.1c.8 7.1-4 14.9-11.2 14.9H112C50.8 512 1.1 462.9 0 401.9C1 345.3 44.3 298 100.9 292.4l44.7-4.5c8.8-.9 15.2-8.7 14.3-17.5s-8.7-15.2-17.5-14.3l-44.7 4.5c-7.1 .7-14 1.9-20.7 3.6c-6.4 1.6-13-3-13-9.7V32C64 14.3 78.3 0 96 0h61.6c11.4 0 21.9 6 27.6 15.9l75.6 129.6c18.1 30.9 39.3 59.9 63.4 86.4z"]
};
var faChevronLeft = {
  prefix: 'fas',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
};
var faBacteria = {
  prefix: 'fas',
  iconName: 'bacteria',
  icon: [640, 512, [], "e059", "M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9c-7.3 1.7-14.3 3.5-21.1 5.5l-5.5-12.7c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L65.9 155c-1.8 2.8-3.5 5.7-5.1 8.5c-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2 .8-.4 1.5-.5 2.3c-2.2 9.3-3.4 17.3-4.1 23.4c-.4 3.1-.6 5.7-.8 7.8c-.1 1.1-.1 2-.2 2.8l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.1 1l-.1 0L28 269.3c-.1 3.1 0 6.1 .2 9.1l-15.2 4.3C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2 .1 2.4 .2 3.6 .2c15.6 .5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1c11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5 0 0c11.7 .4 27.3 .9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1l.1 0 29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5l0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faClouds = {
  prefix: 'fas',
  iconName: 'clouds',
  icon: [640, 512, [], "f744", "M304 160c-74.1 0-135.2 56-143.1 128H96c-53 0-96-43-96-96s43-96 96-96l1.1 0C104.9 41.7 151.6 0 208 0c47.9 0 88.8 30.1 104.8 72.4C324.8 67 338 64 352 64c53 0 96 43 96 96c0 12.1-2.2 23.6-6.3 34.2c-11.4 2.3-22.2 6.4-32.1 11.9C383.3 177.7 345.7 160 304 160zM224 512c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2c-1.3-6.7-1.9-13.7-1.9-20.8c0-61.9 50.1-112 112-112c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H224z"]
};
var faMoneyBillSimple = {
  prefix: 'fas',
  iconName: 'money-bill-simple',
  icon: [576, 512, [], "e1f1", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm224 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faHandLizard = {
  prefix: 'fas',
  iconName: 'hand-lizard',
  icon: [512, 512, [], "f258", "M0 112C0 85.5 21.5 64 48 64H160h80 46.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v12 16 48c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V402.2L273.9 352H240 160 112c-26.5 0-48-21.5-48-48s21.5-48 48-48h48 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160 48c-26.5 0-48-21.5-48-48z"]
};
var faTablePivot = {
  prefix: 'fas',
  iconName: 'table-pivot',
  icon: [512, 512, [], "e291", "M0 96C0 60.7 28.7 32 64 32h64V160H0V96zm448 64H160V32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192H128V416H448V160zm-33.2 86.1c-2.5 6-8.3 9.9-14.8 9.9H384v48c0 26.5-21.5 48-48 48H288v16c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-32-32c-6.2-6.2-6.2-16.4 0-22.6l32-32c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8v16h48c8.8 0 16-7.2 16-16V256H336c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l32-32c6.2-6.2 16.4-6.2 22.6 0l32 32c4.6 4.6 5.9 11.5 3.5 17.4z"]
};
var faFilterSlash = {
  prefix: 'fas',
  iconName: 'filter-slash',
  icon: [640, 512, [], "e17d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L406.6 293.4 567 97.3c9.8-12 11.8-28.5 5.2-42.5S551.5 32 536 32H104c-8.1 0-15.8 2.5-22.3 6.8L38.8 5.1zM256 400c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6V398.5L256 297.7V400z"]
};
var faTrashCanUndo = {
  prefix: 'fas',
  iconName: 'trash-can-undo',
  icon: [448, 512, ["trash-can-arrow-turn-left", "trash-undo-alt"], "f896", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V128zM217.8 199.9c8.9 9.9 8.1 25-1.8 33.9L182.5 264H240c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V352c0-22.1-17.9-40-40-40H182.5l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z"]
};
var faTrashCanArrowTurnLeft = faTrashCanUndo;
var faTrashUndoAlt = faTrashCanUndo;
var faNotdef = {
  prefix: 'fas',
  iconName: 'notdef',
  icon: [384, 512, [], "e1fe", "M64 390.3L153.5 256 64 121.7V390.3zM102.5 448H281.5L192 313.7 102.5 448zm128-192L320 390.3V121.7L230.5 256zM281.5 64H102.5L192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"]
};
var faDisease = {
  prefix: 'fas',
  iconName: 'disease',
  icon: [512, 512, [], "f7fa", "M236.4 61.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6h10c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPersonToDoor = {
  prefix: 'fas',
  iconName: 'person-to-door',
  icon: [576, 512, [58704], "e433", "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C102.4 108.3 132.2 96 163.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H362.7c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L238 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L286.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zM109.5 310.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H91.2l18.3-41.3zM384 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V320h0c35.3 0 64-28.7 64-64s-28.7-64-64-64h0V48z"]
};
var faTurntable = {
  prefix: 'fas',
  iconName: 'turntable',
  icon: [576, 512, [], "f8e4", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM384 256A160 160 0 1 0 64 256a160 160 0 1 0 320 0zM512 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V272.4c0 2.5-.6 4.9-1.7 7.2l-16.2 32.5c-11 .7-21.4 7-26.7 17.6l-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l16-32c5.3-10.6 4.2-22.7-1.9-31.9l16.2-32.4c3.3-6.7 5.1-14 5.1-21.5V112zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBriefcaseMedical = {
  prefix: 'fas',
  iconName: 'briefcase-medical',
  icon: [512, 512, [], "f469", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"]
};
var faGenderless = {
  prefix: 'fas',
  iconName: 'genderless',
  icon: [384, 512, [], "f22d", "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"]
};
var faChevronRight = {
  prefix: 'fas',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
};
var faSignalWeak = {
  prefix: 'fas',
  iconName: 'signal-weak',
  icon: [640, 512, ["signal-1"], "f68c", "M64 384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"]
};
var faSignal1 = faSignalWeak;
var faClockFive = {
  prefix: 'fas',
  iconName: 'clock-five',
  icon: [512, 512, [], "e349", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V248.7l60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faRetweet = {
  prefix: 'fas',
  iconName: 'retweet',
  icon: [576, 512, [], "f079", "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"]
};
var faCarRear = {
  prefix: 'fas',
  iconName: 'car-rear',
  icon: [512, 512, ["car-alt"], "f5de", "M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H384v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V391.4c19.1-11.1 32-31.7 32-55.4V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCarAlt = faCarRear;
var faPumpSoap = {
  prefix: 'fas',
  iconName: 'pump-soap',
  icon: [448, 512, [], "e06b", "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"]
};
var faComputerClassic = {
  prefix: 'fas',
  iconName: 'computer-classic',
  icon: [448, 512, [], "f8b1", "M0 48C0 21.5 21.5 0 48 0H400c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48zM32 480V448H416v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM96 64C78.3 64 64 78.3 64 96V224c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96zM80 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm144-24c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"]
};
var faFrame = {
  prefix: 'fas',
  iconName: 'frame',
  icon: [448, 512, [], "e495", "M448 128c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L128 96l0-32c0-17.7-14.3-32-32-32S64 46.3 64 64l0 32L32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l32 0 0 192-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 192 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-192 32 0c17.7 0 32-14.3 32-32zM128 352l0-192 192 0 0 192-192 0z"]
};
var faVideoSlash = {
  prefix: 'fas',
  iconName: 'video-slash',
  icon: [640, 512, [], "f4e2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9V192 320v5.8l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5V384c0 35.3 28.7 64 64 64H352c23.4 0 43.9-12.6 55-31.3z"]
};
var faBatteryQuarter = {
  prefix: 'fas',
  iconName: 'battery-quarter',
  icon: [576, 512, ["battery-2"], "f243", "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm112 96H96V320h96V192z"]
};
var faBattery2 = faBatteryQuarter;
var faEllipsisStroke = {
  prefix: 'fas',
  iconName: 'ellipsis-stroke',
  icon: [512, 512, ["ellipsis-h-alt"], "f39b", "M416 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-96a72 72 0 1 0 0 144 72 72 0 1 0 0-144zM256 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-96a72 72 0 1 0 0 144 72 72 0 1 0 0-144zM120 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-96 0a72 72 0 1 0 144 0A72 72 0 1 0 24 256z"]
};
var faEllipsisHAlt = faEllipsisStroke;
var faRadio = {
  prefix: 'fas',
  iconName: 'radio',
  icon: [512, 512, [128251], "f8d7", "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"]
};
var faBabyCarriage = {
  prefix: 'fas',
  iconName: 'baby-carriage',
  icon: [512, 512, ["carriage-baby"], "f77d", "M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0V160zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faCarriageBaby = faBabyCarriage;
var faFaceExpressionless = {
  prefix: 'fas',
  iconName: 'face-expressionless',
  icon: [512, 512, [], "e373", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zM128 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm176-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faDownToDottedLine = {
  prefix: 'fas',
  iconName: 'down-to-dotted-line',
  icon: [448, 512, [], "e408", "M0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM73.9 249.9L196.7 372.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L374.1 249.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9H288V64c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32V192H97.9C79.2 192 64 207.2 64 225.9c0 9 3.6 17.6 9.9 24z"]
};
var faCloudMusic = {
  prefix: 'fas',
  iconName: 'cloud-music',
  icon: [640, 512, [], "f8ae", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM416 184c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V275.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V216 184z"]
};
var faTrafficLight = {
  prefix: 'fas',
  iconName: 'traffic-light',
  icon: [320, 512, [128678], "f637", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
var faCloudMinus = {
  prefix: 'fas',
  iconName: 'cloud-minus',
  icon: [640, 512, [], "e35d", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM248 264c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faThermometer = {
  prefix: 'fas',
  iconName: 'thermometer',
  icon: [512, 512, [], "f491", "M96 382.1V293.3c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4H129.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"]
};
var faShieldMinus = {
  prefix: 'fas',
  iconName: 'shield-minus',
  icon: [512, 512, [], "e249", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faVrCardboard = {
  prefix: 'fas',
  iconName: 'vr-cardboard',
  icon: [640, 512, [], "f729", "M576 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H184.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faCarTilt = {
  prefix: 'fas',
  iconName: 'car-tilt',
  icon: [640, 512, [], "f5e5", "M145.1 120.6L292.4 81.2c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6L114.6 211.6l7-63.6c1.4-13.1 10.8-24 23.5-27.4zM58 141.1L47.8 234.2C27.4 249.4 17.2 276 24.2 302.1L57.3 425.8l6 22.2H48c-26.5 0-48 21.5-48 48v16H640V496c0-26.5-21.5-48-48-48H162.6c-.1-.2-.1-.5-.2-.7L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5 487.8 177.9c-7-26.1-29.1-44.1-54.4-47L378.1 55.3c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1zm58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1 -16.6-61.8zm255.6-35.3a32 32 0 1 1 61.8-16.6 32 32 0 1 1 -61.8 16.6z"]
};
var faGaugeCircleMinus = {
  prefix: 'fas',
  iconName: 'gauge-circle-minus',
  icon: [640, 512, [], "e497", "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24V292.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16H560c8.8 0 16 7.2 16 16z"]
};
var faBrightnessLow = {
  prefix: 'fas',
  iconName: 'brightness-low',
  icon: [512, 512, [], "e0ca", "M224 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm96 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM432 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0-256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faHandMiddleFinger = {
  prefix: 'fas',
  iconName: 'hand-middle-finger',
  icon: [448, 512, [128405], "f806", "M232 0c-22.1 0-40 17.9-40 40V204.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"]
};
var faPercent = {
  prefix: 'fas',
  iconName: 'percent',
  icon: [384, 512, [62101, 62785, "percentage"], "25", "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faPercentage = faPercent;
var faTruckMoving = {
  prefix: 'fas',
  iconName: 'truck-moving',
  icon: [640, 512, [], "f4df", "M64 32C28.7 32 0 60.7 0 96V304v80 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16H416h33.6c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGlassWaterDroplet = {
  prefix: 'fas',
  iconName: 'glass-water-droplet',
  icon: [384, 512, [], "e4f5", "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM83 297.5L66.4 64H317.6L301 297.5 288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"]
};
var faConveyorBelt = {
  prefix: 'fas',
  iconName: 'conveyor-belt',
  icon: [640, 512, [], "f46e", "M176 0h80V112c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V0h80c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM0 416c0-53 43-96 96-96H544c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faLocationCheck = {
  prefix: 'fas',
  iconName: 'location-check',
  icon: [384, 512, ["map-marker-check"], "f606", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM305 145L177 273c-9.4 9.4-24.6 9.4-33.9 0L79 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 111c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faMapMarkerCheck = faLocationCheck;
var faCoinVertical = {
  prefix: 'fas',
  iconName: 'coin-vertical',
  icon: [384, 512, [], "e3fd", "M288 256c0 141.4-64.5 256-144 256S0 397.4 0 256S64.5 0 144 0s144 114.6 144 256zM184.2 425.4c11.4-12 20.1-27.7 26.8-44.4c13.4-33.6 21-77.8 21-125s-7.6-91.4-21-125c-6.7-16.7-15.4-32.4-26.8-44.4C172.7 74.5 156.5 64 136 64s-36.7 10.5-48.2 22.6C76.5 98.6 67.7 114.3 61 131c-13.4 33.6-21 77.8-21 125s7.6 91.4 21 125c6.7 16.7 15.4 32.4 26.8 44.4C99.3 437.5 115.5 448 136 448s36.7-10.5 48.2-22.6zM136 416c-35.3 0-64-71.6-64-160s28.7-160 64-160s64 71.6 64 160s-28.7 160-64 160zm90.1 96c15.6-13.2 29.3-29.7 40.9-48h63.7c-21 30.2-46.8 48-74.6 48H226.1zM349 432H284.3c13.2-28.4 23-60.9 29-96h64.3c-6 36.2-15.9 68.9-28.7 96zm32.8-128H317.6c1.6-15.7 2.4-31.7 2.4-48s-.8-32.3-2.4-48h64.1c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48zm-4.1-128H313.3c-6-35.1-15.9-67.6-29-96H349c12.8 27.1 22.7 59.8 28.7 96zm-47-128H267c-11.5-18.3-25.2-34.8-40.9-48H256c27.9 0 53.6 17.8 74.6 48z"]
};
var faDisplay = {
  prefix: 'fas',
  iconName: 'display',
  icon: [576, 512, [], "e163", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z"]
};
var faPersonSign = {
  prefix: 'fas',
  iconName: 'person-sign',
  icon: [512, 512, [], "f757", "M438.1 32.2c4.5-12.5-1.9-26.2-14.3-30.8S397.5 3.3 393 15.8l-4.6 12.7L328.7 6.7c-12.5-4.5-26.2 1.9-30.8 14.3L259.6 126.3c-4.5 12.5 1.9 26.2 14.3 30.8l59.7 21.7-15.4 42.4-28.8-10.8c-9.7-3.7-18.4-9.6-25.4-17.4L235 160.2c-18.2-20.5-44.3-32.2-71.8-32.2H135.6c-36.4 0-69.6 20.5-85.9 53.1L3.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L80 263.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h20.2L192 407.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V407.6c0-9.9-2.3-19.7-6.8-28.6L216 312.4V235.2l.3 .3c13.8 15.6 31.2 27.5 50.7 34.8l29.3 11L289 301.5c-4.5 12.5 1.9 26.2 14.3 30.8s26.2-1.9 30.8-14.3l44.6-122.6 60.6 22c12.5 4.5 26.2-1.9 30.8-14.3L508.4 97.7c4.5-12.5-1.9-26.2-14.3-30.8l-60.6-22 4.6-12.7zM192 48A48 48 0 1 0 96 48a48 48 0 1 0 96 0z"]
};
var faFaceSmile = {
  prefix: 'fas',
  iconName: 'face-smile',
  icon: [512, 512, [128578, "smile"], "f118", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSmile = faFaceSmile;
var faPhoneHangup = {
  prefix: 'fas',
  iconName: 'phone-hangup',
  icon: [640, 512, [], "e225", "M11.7 266.3l41.9 94.3c6.1 13.7 20.8 21.3 35.5 18.4l109.2-21.8c15-3 25.7-16.1 25.7-31.4V240c62.3-20.8 129.7-20.8 192 0v85.8c0 15.3 10.8 28.4 25.7 31.4L550.9 379c14.7 2.9 29.4-4.7 35.5-18.4l41.9-94.3c7.2-16.2 5.1-35.1-7.4-47.7C570.8 168.1 464.2 96 320 96S69.2 168.1 19.1 218.6c-12.5 12.6-14.6 31.5-7.4 47.7z"]
};
var faSignatureSlash = {
  prefix: 'fas',
  iconName: 'signature-slash',
  icon: [640, 512, [], "e3cb", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L563 416h53c13.3 0 24-10.7 24-24s-10.7-24-24-24H501.8l-61.2-48H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96c-37 0-69.1 20.9-85.1 51.6L38.8 5.1zM192.1 125.3C193.5 108.9 207.2 96 224 96c17.7 0 32 14.3 32 32v7.8c0 12.8-.5 25.6-1.5 38.3l-62.4-48.9zM355.3 253.2l42.8-12.8-12.3 36.8-30.5-23.9zm-190.9-9.5c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c17.5-30.5 31.9-62.7 43.1-95.9L181.1 238.7l-16.7 5zm67.4 46.6c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7l49-14.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24z"]
};
var faThumbtack = {
  prefix: 'fas',
  iconName: 'thumbtack',
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"]
};
var faThumbTack = faThumbtack;
var faWheatSlash = {
  prefix: 'fas',
  iconName: 'wheat-slash',
  icon: [640, 512, [], "e339", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L550.5 231c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9L369.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L335.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4L38.8 5.1zm255 322.4l-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM536 0c-48.6 0-88 39.4-88 88v24c0 8.8 7.2 16 16 16h24c48.6 0 88-39.4 88-88V16c0-8.8-7.2-16-16-16H536z"]
};
var faTrophy = {
  prefix: 'fas',
  iconName: 'trophy',
  icon: [576, 512, [127942], "f091", "M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"]
};
var faCloudsSun = {
  prefix: 'fas',
  iconName: 'clouds-sun',
  icon: [640, 512, [], "f746", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 30.7 5.1c-26.4 10.6-47 32.6-55.7 59.9C276.8 132.7 244.8 112 208 112c-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17.1c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm450.6 75c-18.9-35.1-56-59-98.7-59c-12.9 0-25.3 2.2-36.8 6.2C435.9 206.6 403.7 192 368 192c-16.7 0-32.6 3.2-47.3 9c-.4-2.9-.6-5.9-.6-8.9c0-35.3 28.6-64 64-64c7.4 0 14.6 1.3 21.2 3.6c11.5-30.1 40.6-51.6 74.8-51.6c38.9 0 71.3 27.8 78.5 64.6c3.1-.4 6.3-.6 9.5-.6c39.8 0 72 32.2 72 72c0 30.4-18.8 56.3-45.4 66.9zm45.3 148.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"]
};
var faPersonPraying = {
  prefix: 'fas',
  iconName: 'person-praying',
  icon: [448, 512, [128720, "pray"], "f683", "M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432H72c-22.1 0-40 17.9-40 40s17.9 40 40 40H280c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"]
};
var faPray = faPersonPraying;
var faHammer = {
  prefix: 'fas',
  iconName: 'hammer',
  icon: [576, 512, [128296], "f6e3", "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"]
};
var faFaceVomit = {
  prefix: 'fas',
  iconName: 'face-vomit',
  icon: [576, 512, [], "e3a0", "M544 256c0 72.5-30.1 137.9-78.5 184.5l-16.7-5.6c-11.9-4-21.5-12.3-27.2-22.9c16.7-12.6 26.4-27.7 26.4-44c0-44.2-71.6-80-160-80s-160 35.8-160 80c0 16.3 9.7 31.4 26.4 44c-5.7 10.6-15.2 19-27.2 22.9l-16.7 5.6C62.1 393.9 32 328.5 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256zM148 141.1c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9c-7.9-4.2-17.5 1.5-17.5 10.5zm262.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6c0-9-9.6-14.7-17.5-10.5zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm480 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 396.1V338.7c23.6-11.1 57.3-18.7 96-18.7s72.4 7.6 96 18.7v57.4c0 31 19.8 58.5 49.2 68.3l34.1 11.4c7.6 2.5 12.7 9.6 12.7 17.6c0 10.3-8.3 18.6-18.6 18.6H114.6c-10.3 0-18.6-8.3-18.6-18.6c0-8 5.1-15.1 12.7-17.6l34.1-11.4c29.4-9.8 49.2-37.3 49.2-68.3zM304 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSpeakers = {
  prefix: 'fas',
  iconName: 'speakers',
  icon: [640, 512, [], "f8e0", "M64 0H280.4C265.2 17 256 39.4 256 64V257.6c-20.3-20.7-48.7-33.6-80-33.6c-61.9 0-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6V448c0 24.6 9.2 47 24.4 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM320 503.4c-19.1-11.1-32-31.7-32-55.4V336 64c0-23.7 12.9-44.4 32-55.4C329.4 3.1 340.3 0 352 0H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H352c-11.7 0-22.6-3.1-32-8.6zM352 336a112 112 0 1 0 224 0 112 112 0 1 0 -224 0zM176 272a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 336a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faTtyAnswer = {
  prefix: 'fas',
  iconName: 'tty-answer',
  icon: [640, 512, ["teletype-answer"], "e2b9", "M117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24zM304 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm0 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V80zM496 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H592c-8.8 0-16-7.2-16-16V80zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H592c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM384 176c0-8.8 7.2-16 16-16H528c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V176z"]
};
var faTeletypeAnswer = faTtyAnswer;
var faMugTeaSaucer = {
  prefix: 'fas',
  iconName: 'mug-tea-saucer',
  icon: [640, 512, [], "e1f5", "M208 82.7V32H128c-17.7 0-32 14.3-32 32V288c0 53 43 96 96 96H384c53 0 96-43 96-96h32c70.7 0 128-57.3 128-128s-57.3-128-128-128H448 240V82.7c0 8.5 3.4 16.6 9.4 22.6l29.3 29.3c6 6 9.4 14.1 9.4 22.6V224c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V157.3c0-8.5 3.4-16.6 9.4-22.6l29.3-29.3c6-6 9.4-14.1 9.4-22.6zM480 96h32c35.3 0 64 28.7 64 64s-28.7 64-64 64H480V96zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faDiagramLeanCanvas = {
  prefix: 'fas',
  iconName: 'diagram-lean-canvas',
  icon: [640, 512, [], "e156", "M512 96V304h64V96H512zm-48 0H400v80h64V96zM352 96H288V304h64V96zM240 96H176v80h64V96zM128 96H64V304h64V96zM64 352v64H296V352H64zm280 64H576V352H344v64zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM240 304V224H176v80h64zm224-80H400v80h64V224z"]
};
var faAlt = {
  prefix: 'fas',
  iconName: 'alt',
  icon: [640, 512, [], "e08a", "M448 64c-9.7 0-18.9 4.4-25 12L176.6 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192c9.7 0 18.9-4.4 25-12L463.4 128H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H448zm0 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H448z"]
};
var faDial = {
  prefix: 'fas',
  iconName: 'dial',
  icon: [576, 512, ["dial-med-high"], "e15b", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM175.1 174.2c56.7-56.7 145.4-62 208-15.7L271.3 270.4c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L417.1 192.4c46.2 62.6 41 151.3-15.7 208c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faDialMedHigh = faDial;
var faHandPeace = {
  prefix: 'fas',
  iconName: 'hand-peace',
  icon: [512, 512, [9996], "f25b", "M224 0c17.7 0 32 14.3 32 32V240H192V32c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zM93.3 51.2L175.9 240H106.1L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5h69.9H216c22.1 0 40 17.9 40 40s-17.9 40-40 40H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H226.3c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363V336c0-32.7 24.6-59.7 56.3-63.5z"]
};
var faCircleTrash = {
  prefix: 'fas',
  iconName: 'circle-trash',
  icon: [512, 512, ["trash-circle"], "e126", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128h41.4l11.3-11.3c3-3 7.1-4.7 11.3-4.7h64c4.2 0 8.3 1.7 11.3 4.7L310.6 128H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H352L338.4 354.7c-1.4 16.6-15.2 29.3-31.9 29.3H205.4c-16.6 0-30.5-12.8-31.9-29.3L160 192z"]
};
var faTrashCircle = faCircleTrash;
var faRotate = {
  prefix: 'fas',
  iconName: 'rotate',
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"]
};
var faSyncAlt = faRotate;
var faCircleQuarters = {
  prefix: 'fas',
  iconName: 'circle-quarters',
  icon: [512, 512, [], "e3f8", "M120.2 391.8L256 256 391.8 391.8C426.5 357 448 309 448 256s-21.5-101-56.2-135.8L256 256 120.2 120.2C85.5 155 64 203 64 256s21.5 101 56.2 135.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faSpinner = {
  prefix: 'fas',
  iconName: 'spinner',
  icon: [512, 512, [], "f110", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"]
};
var faTowerControl = {
  prefix: 'fas',
  iconName: 'tower-control',
  icon: [448, 512, [], "e2a2", "M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V96H160c-17.7 0-32 14.3-32 32H42.6C16 128-3.2 153.4 4.1 179L44.5 320.2C28.5 321.9 16 335.5 16 352c0 17.7 14.3 32 32 32H80v96c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V384l32 0c17.7 0 32-14.3 32-32c0-16.5-12.5-30.1-28.5-31.8L443.9 179c7.3-25.6-11.9-51-38.5-51H320c0-17.7-14.3-32-32-32H248V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H224 184zM128 192V320H111c-.1-.3-.1-.5-.2-.8L74.4 192H128zm48 128V192h96V320l-96 0zM320 192h53.6L337.2 319.2l-.1 .3-.1 .5H320V192z"]
};
var faArrowUpTriangleSquare = {
  prefix: 'fas',
  iconName: 'arrow-up-triangle-square',
  icon: [576, 512, ["sort-shapes-up"], "f88a", "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM443.1 47C437.3 37.7 427 32 416 32s-21.3 5.7-27.1 15l-80 128c-6.2 9.9-6.5 22.3-.9 32.5s16.4 16.5 28 16.5H496c11.6 0 22.3-6.3 28-16.5s5.3-22.6-.9-32.5l-80-128zM320 336v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
};
var faSortShapesUp = faArrowUpTriangleSquare;
var faWhale = {
  prefix: 'fas',
  iconName: 'whale',
  icon: [640, 512, [128011], "f72c", "M175.8 13.4c-1-5.9-5.2-10.8-10.9-12.6s-12-.3-16.2 3.9L108 45.4C89.7 63.7 81.4 89.6 85.6 115.1l7.9 47.4L43.6 212.4C15.7 240.3 0 278.2 0 317.6C0 407.3 72.7 480 162.4 480H544c53 0 96-43 96-96V272.1C640 192.5 575.5 128 495.9 128c-82.5 0-162.4 29.5-225 83.2L156.4 309.4c-8 6.8-18.1 10.6-28.6 10.6h-1.1c-18.3 0-34.5-11.7-40.3-29c-4-12-2.4-25.2 4.3-35.9l37.6-60.1 44.7 7.5c25.5 4.2 51.5-4.1 69.7-22.3l40.7-40.7c4.2-4.2 5.8-10.5 3.9-16.2s-6.7-9.9-12.6-10.9L189.9 98.1 175.8 13.4zM400 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faRobot = {
  prefix: 'fas',
  iconName: 'robot',
  icon: [640, 512, [129302], "f544", "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z"]
};
var faPeace = {
  prefix: 'fas',
  iconName: 'peace',
  icon: [512, 512, [9774], "f67c", "M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5V445.3c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3V240.8L422.8 351.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faPartyHorn = {
  prefix: 'fas',
  iconName: 'party-horn',
  icon: [512, 512, [], "e31b", "M32 32a32 32 0 1 1 64 0A32 32 0 1 1 32 32zM448 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM167 153c-9.4-9.4-9.4-24.6 0-33.9l8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4C209.6 8.2 221.5-1.3 234.7 .1s22.7 13.3 21.2 26.5l-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153c-9.4 9.4-24.6 9.4-33.9 0zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3c13.2-1.5 25 8 26.5 21.2s-8 25-21.2 26.5l-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM506.3 8.5c8.6 10.1 7.3 25.3-2.8 33.8l-10 8.5c-14.8 12.5-33.7 19.1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2c-7.6-.2-15 2.4-20.7 7.3l-10 8.5c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l10-8.5c14.8-12.5 33.7-19.1 53-18.6c16.6 .4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2c7.6 .2 15-2.4 20.7-7.3l10-8.5c10.1-8.6 25.3-7.3 33.8 2.8zM150.6 201.4l160 160c7.7 7.7 11 18.8 8.6 29.4s-9.9 19.4-20 23.2l-39.7 14.9L83.1 252.5 98 212.8c3.8-10.2 12.6-17.7 23.2-20s21.7 1 29.4 8.6zM48.2 345.6l22.6-60.2L226.6 441.2l-60.2 22.6L48.2 345.6zM35.9 378.5l97.6 97.6L43.2 510c-11.7 4.4-25 1.5-33.9-7.3S-2.4 480.5 2 468.8l33.8-90.3z"]
};
var faGears = {
  prefix: 'fas',
  iconName: 'gears',
  icon: [640, 512, ["cogs"], "f085", "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8h-.7c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCogs = faGears;
var faSunBright = {
  prefix: 'fas',
  iconName: 'sun-bright',
  icon: [512, 512, ["sun-alt"], "e28f", "M256 0c-13.3 0-24 10.7-24 24V88c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm0 400c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V424c0-13.3-10.7-24-24-24zM488 280c13.3 0 24-10.7 24-24s-10.7-24-24-24H424c-13.3 0-24 10.7-24 24s10.7 24 24 24h64zM112 256c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H88c13.3 0 24-10.7 24-24zM437 108.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-45.3 45.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9zM154.2 357.8c-9.4-9.4-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l45.3-45.3c9.4-9.4 9.4-24.6 0-33.9zM403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-45.3-45.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L403.1 437zM154.2 154.2c9.4-9.4 9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l45.3 45.3c9.4 9.4 24.6 9.4 33.9 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
var faSunAlt = faSunBright;
var faWarehouse = {
  prefix: 'fas',
  iconName: 'warehouse',
  icon: [640, 512, [], "f494", "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24V432H512l0 56c0 13.3-10.7 24-24 24zM128 400V336H512v64H128zm0-96V224H512l0 80H128z"]
};
var faConveyorBeltArm = {
  prefix: 'fas',
  iconName: 'conveyor-belt-arm',
  icon: [640, 512, [], "e5f8", "M240.9 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H267.1l-5.7 34c.8 1 1.5 2 2.3 3l204.5 27.3c17.5 2.3 29.8 18.4 27.5 35.9c-1.4 10.2-7.4 18.7-15.7 23.5V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V190.1L255.2 164.5c-8.4 7.2-19.3 11.6-31.2 11.6c-26.5 0-48-21.5-48-48c0-17.1 8.9-32 22.3-40.6L202.2 64H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h79c.6 0 1.2 0 1.9 0zM240 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h32c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96s43-96 96-96l0-40c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h64V280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h64V280zM128 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLockKeyholeOpen = {
  prefix: 'fas',
  iconName: 'lock-keyhole-open',
  icon: [576, 512, ["lock-open-alt"], "f3c2", "M432 64c-44.2 0-80 35.8-80 80v48h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H288V144C288 64.5 352.5 0 432 0s144 64.5 144 144v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V144c0-44.2-35.8-80-80-80zM256 384c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"]
};
var faLockOpenAlt = faLockKeyholeOpen;
var faSquareFragile = {
  prefix: 'fas',
  iconName: 'square-fragile',
  icon: [448, 512, ["box-fragile", "square-wine-glass-crack"], "f49b", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 86.3C128 106 138 96 150.3 96H176l32 64-32 32 80 64-32-64 48-32L240 96h57.7C310 96 320 106 320 118.3V208c0 47.6-34.6 87.1-80 94.7V384h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V302.7c-45.4-7.6-80-47.1-80-94.7V118.3z"]
};
var faBoxFragile = faSquareFragile;
var faSquareWineGlassCrack = faSquareFragile;
var faArrowUpRightDots = {
  prefix: 'fas',
  iconName: 'arrow-up-right-dots',
  icon: [576, 512, [], "e4b7", "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H160zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faSquareN = {
  prefix: 'fas',
  iconName: 'square-n',
  icon: [448, 512, [], "e277", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.3 104.5L288 294.5V152c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 10.1-6.3 19.1-15.7 22.5s-20.1 .7-26.6-7L160 217.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.1 6.3-19.1 15.7-22.5s20.1-.7 26.6 7z"]
};
var faSplotch = {
  prefix: 'fas',
  iconName: 'splotch',
  icon: [512, 512, [], "f5bc", "M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"]
};
var faFaceGrinHearts = {
  prefix: 'fas',
  iconName: 'face-grin-hearts',
  icon: [512, 512, [128525, "grin-hearts"], "f584", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"]
};
var faGrinHearts = faFaceGrinHearts;
var faMeter = {
  prefix: 'fas',
  iconName: 'meter',
  icon: [512, 512, [], "e1e8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faMandolin = {
  prefix: 'fas',
  iconName: 'mandolin',
  icon: [512, 512, [], "f6f9", "M435.3 3.6C444.8-2.3 457.1-.9 465 7l40 40c7.9 7.9 9.3 20.2 3.4 29.7l-40 64c-3.2 5.1-8.2 8.8-14 10.4L388 169.2l-65.9 65.9C323.7 322.4 311.5 512 176 512C78.8 512 0 433.2 0 336C0 200.5 189.6 188.3 276.9 189.8L342.8 124l18.1-66.3c1.6-5.8 5.3-10.8 10.4-14l64-40zM208 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faDiceFour = {
  prefix: 'fas',
  iconName: 'dice-four',
  icon: [448, 512, [9859], "f524", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSimCard = {
  prefix: 'fas',
  iconName: 'sim-card',
  icon: [384, 512, [], "f7c4", "M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32v32h64V192H96zM64 352h80 96 80V288H240 144 64v64zM320 224c0-17.7-14.3-32-32-32H256v64h64V224zM160 192v64h64V192H160zM288 448c17.7 0 32-14.3 32-32V384H256v64h32zM160 384v64h64V384H160zM64 416c0 17.7 14.3 32 32 32h32V384H64v32z"]
};
var faTransgender = {
  prefix: 'fas',
  iconName: 'transgender',
  icon: [512, 512, [9895, "transgender-alt"], "f225", "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V414.2C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faTransgenderAlt = faTransgender;
var faMercury = {
  prefix: 'fas',
  iconName: 'mercury',
  icon: [384, 512, [9791], "f223", "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z"]
};
var faUpFromBracket = {
  prefix: 'fas',
  iconName: 'up-from-bracket',
  icon: [448, 512, [], "e590", "M73.9 134.1L196.7 11.3C203.9 4.1 213.8 0 224 0s20.1 4.1 27.3 11.3L374.1 134.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9H288V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192H97.9C79.2 192 64 176.8 64 158.1c0-9 3.6-17.6 9.9-24zM64 352v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96V352c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faKnifeKitchen = {
  prefix: 'fas',
  iconName: 'knife-kitchen',
  icon: [576, 512, [128298], "f6f5", "M488 0c9.4 0 18.3 3.7 25 10.3L557.7 55c6.6 6.6 10.3 15.6 10.3 25s-3.7 18.3-10.3 25l-97 97c-3 3-4.7 7.1-4.7 11.3v31.9c0 17.4-9.4 33.5-24.7 42l-31 17.2L295.9 200.1l-11.3-11.3L463 10.3C469.7 3.7 478.6 0 488 0zM432 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM262 211.4l11.3 11.3 126 126c6.2 6.2 6.2 16.4 0 22.6C321.4 449.2 235.3 512 112 512c-25.6 0-50.9-4.2-69.5-8.4c-9.4-2.1-17.2-4.2-22.7-5.7c-2.8-.8-4.9-1.4-6.5-1.9c-.8-.2-1.4-.4-1.8-.6l-.5-.2-.1 0 0 0 0 0 0 0s0 0 5.1-15.2l-5.1 15.2c-5.3-1.8-9.2-6.1-10.5-11.5s.3-11.1 4.3-15l246-246L262 211.4z"]
};
var faBorderRight = {
  prefix: 'fas',
  iconName: 'border-right',
  icon: [448, 512, [], "f852", "M416 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32zM320 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192-32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faArrowTurnDown = {
  prefix: 'fas',
  iconName: 'arrow-turn-down',
  icon: [384, 512, ["level-down"], "f149", "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"]
};
var faLevelDown = faArrowTurnDown;
var faSpade = {
  prefix: 'fas',
  iconName: 'spade',
  icon: [512, 512, [9824], "f2f4", "M278 12.5c-12.3-11.7-31.7-11.7-44 0L168 75.1 40 196.3c-51.3 48.6-53.5 129.6-4.9 181s129.6 53.5 181 4.9l8-7.6V448H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V374.6l8 7.6c51.3 48.6 132.3 46.4 181-4.9s46.4-132.3-4.9-181L344 75.1 278 12.5z"]
};
var faCardSpade = {
  prefix: 'fas',
  iconName: 'card-spade',
  icon: [384, 512, [], "e3ec", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM175 137.8c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6 64 64c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-7.4-7.4c-.3-.3-.6-.6-1-.9V336h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V295.2c-.3 .3-.7 .6-1 .9l-7.4 7.4c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l64-64L175 137.8z"]
};
var faLineColumns = {
  prefix: 'fas',
  iconName: 'line-columns',
  icon: [512, 512, [], "f870", "M224 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H192c17.7 0 32-14.3 32-32zm0 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192c17.7 0 32-14.3 32-32zM0 320c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM224 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192c17.7 0 32-14.3 32-32zM288 64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zM512 192c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32zM288 320c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zM512 448c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32z"]
};
var faArrowRightToLine = {
  prefix: 'fas',
  iconName: 'arrow-right-to-line',
  icon: [448, 512, [8677, "arrow-to-right"], "f340", "M448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM310.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l178.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
};
var faArrowToRight = faArrowRightToLine;
var faPersonFallingBurst = {
  prefix: 'fas',
  iconName: 'person-falling-burst',
  icon: [640, 512, [], "e547", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H224l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"]
};
var faFlagPennant = {
  prefix: 'fas',
  iconName: 'flag-pennant',
  icon: [448, 512, [128681, "pennant"], "f456", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352L433 213.6c9-3.4 15-12 15-21.6s-6-18.2-15-21.6L64 32z"]
};
var faPennant = faFlagPennant;
var faConveyorBeltEmpty = {
  prefix: 'fas',
  iconName: 'conveyor-belt-empty',
  icon: [640, 512, [], "e150", "M96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faUserGroupSimple = {
  prefix: 'fas',
  iconName: 'user-group-simple',
  icon: [640, 512, [], "e603", "M160 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm320 0a104 104 0 1 1 0 208 104 104 0 1 1 0-208zM0 416c0-70.7 57.3-128 128-128h64c70.7 0 128 57.3 128 128v16c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416zm448 64c-38.3 0-72.7-16.8-96.1-43.5c.1-1.5 .1-3 .1-4.5V416c0-34.9-11.2-67.1-30.1-93.4c5.8-20 24.2-34.6 46.1-34.6H592c26.5 0 48 21.5 48 48v16c0 70.7-57.3 128-128 128H448z"]
};
var faAward = {
  prefix: 'fas',
  iconName: 'award',
  icon: [384, 512, [], "f559", "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"]
};
var faTicketSimple = {
  prefix: 'fas',
  iconName: 'ticket-simple',
  icon: [576, 512, ["ticket-alt"], "f3ff", "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192V128z"]
};
var faTicketAlt = faTicketSimple;
var faBuilding = {
  prefix: 'fas',
  iconName: 'building',
  icon: [384, 512, [127970, 61687], "f1ad", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"]
};
var faAnglesLeft = {
  prefix: 'fas',
  iconName: 'angles-left',
  icon: [512, 512, [171, "angle-double-left"], "f100", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"]
};
var faAngleDoubleLeft = faAnglesLeft;
var faCamcorder = {
  prefix: 'fas',
  iconName: 'camcorder',
  icon: [576, 512, [128249, "video-handheld"], "f8a8", "M128 96c-17.7 0-32 14.3-32 32v32H320c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-23.7 12.9-44.4 32-55.4V128c0-53 43-96 96-96H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H128zm431.1 67.8c10.4 5.6 16.9 16.4 16.9 28.2V448c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 401.1V384 256 238.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faVideoHandheld = faCamcorder;
var faPancakes = {
  prefix: 'fas',
  iconName: 'pancakes',
  icon: [512, 512, [129374], "e42d", "M256 192c0-17.7 14.3-31.9 32-32.6c108.6-4.4 192-31.1 192-63.4c0-35.3-100.3-64-224-64S32 60.7 32 96c0 13.8 15.3 26.6 41.3 37C86.5 138.3 96 150.6 96 164.8V272c0 17.7 14.3 32 32 32s32-14.3 32-32V171.7c0-9.5 8.1-16.8 17.5-15.7c8.1 .9 14.5 7.6 14.5 15.7V224c0 17.7 14.3 32 32 32s32-14.3 32-32V192zM192 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zM14.9 133C5.3 141.4 0 150.5 0 160c0 20.3 24.2 38.8 64 52.9V164.8c0-.1-.1-.2-.2-.4c-.4-.5-1.2-1.3-2.4-1.8c-14.7-5.9-28.7-13.4-39.6-22.9c-2.3-2-4.6-4.3-6.8-6.8zM286.1 239.5C413.3 234.8 512 201 512 160c0-9.5-5.3-18.6-14.9-27c-4 4.5-8.5 8.4-12.7 11.5c-13.4 10-30.9 17.8-49.8 24C396.6 181 345.5 189 289.3 191.3c-.5 0-.9 .2-1.2 .5c-.1 .1-.1 .2-.1 .2l0 32c0 5.3-.7 10.5-1.9 15.5zM7.2 221.1C2.5 227.2 0 233.5 0 240c0 21 25.8 40 68 54.3c-2.6-6.9-4-14.5-4-22.3V246.7c-21.5-6.8-41.1-15.2-56.8-25.6zM256 320c141.4 0 256-35.8 256-80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26c-47.8 14.9-111.2 24-180.2 24.8c-11.3 10-26.1 16.1-42.4 16.1c-11.8 0-22.9-3.2-32.4-8.8c-1.6 14.1-7.8 26.9-17 36.7c25.6 2.7 52.9 4.1 81.4 4.1zm256 0c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 342.8 329 352 256 352s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 307.2 0 313.5 0 320c0 44.2 114.6 80 256 80s256-35.8 256-80zm0 80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 422.8 329 432 256 432s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 387.2 0 393.5 0 400c0 44.2 114.6 80 256 80s256-35.8 256-80z"]
};
var faAlbumCircleUser = {
  prefix: 'fas',
  iconName: 'album-circle-user',
  icon: [576, 512, [], "e48d", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7c-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4c6.5 25.5 18.5 48.7 34.8 68.4H64c-35.3 0-64-28.7-64-64V96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7H399.4c-21 0-38.9 13.7-45.1 32.7C374.5 468.1 401.8 480 432 480s57.5-11.9 77.7-31.3zM480 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faQrcode = {
  prefix: 'fas',
  iconName: 'qrcode',
  icon: [448, 512, [], "f029", "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm64 16v64h64V352H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64H320v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V304zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
};
var faDiceD10 = {
  prefix: 'fas',
  iconName: 'dice-d10',
  icon: [512, 512, [], "f6cd", "M209.7 16.3C212.4 8.3 206.4 0 198 0V0c-3.8 0-7.3 1.7-9.7 4.6L2.4 237C.8 238.9 0 241.3 0 243.8v0c0 7 6.4 12.1 13.2 10.6l117.6-26.1c5.5-1.2 9.9-5.2 11.7-10.6L209.7 16.3zM8.7 288.2C3.6 289.4 0 293.9 0 299.1v0c0 3.1 1.3 6.1 3.6 8.2L220.7 508.9c2.1 2 4.9 3.1 7.8 3.1v0c6.3 0 11.5-5.1 11.5-11.5V328.8c0-5.3-2.6-10.2-6.9-13.2l-78.7-54.5c-3.7-2.5-8.2-3.4-12.6-2.5L8.7 288.2zM272 500.5c0 6.3 5.1 11.5 11.5 11.5v0c2.9 0 5.7-1.1 7.8-3.1L508.4 307.3c2.3-2.1 3.6-5.1 3.6-8.2v0c0-5.2-3.6-9.8-8.7-10.9L370.2 258.7c-4.4-1-8.9-.1-12.6 2.5l-78.7 54.5c-4.3 3-6.9 7.9-6.9 13.2V500.5zM498.8 254.4c6.8 1.5 13.2-3.7 13.2-10.6v0c0-2.5-.8-4.9-2.4-6.8L323.7 4.6C321.4 1.7 317.8 0 314 0V0c-8.5 0-14.4 8.3-11.7 16.3l67.2 201.5c1.8 5.3 6.2 9.3 11.7 10.6l117.6 26.1zM246.6 6.8L174.8 222.3c-2.2 6.7 .2 14.2 6.1 18.2l66.1 45.7c5.5 3.8 12.7 3.8 18.2 0l66.1-45.7c5.8-4 8.3-11.5 6.1-18.2L265.4 6.8C264 2.7 260.3 0 256 0V0c-4.3 0-8 2.7-9.4 6.8z"]
};
var faFireplace = {
  prefix: 'fas',
  iconName: 'fireplace',
  icon: [640, 512, [], "f79a", "M0 32V64C0 81.7 14.3 96 32 96H608c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zm608 96H32V480c0 17.7 14.3 32 32 32h96V352c0-88.4 71.6-160 160-160s160 71.6 160 160V512h96c17.7 0 32-14.3 32-32V128zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4c-10.7-20.7-25.9-42.5-43.9-59c-4.1-3.7-10.4-3.8-14.5 0c-7 6.4-13.5 14.3-19.2 21.5c-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8z"]
};
var faBrowser = {
  prefix: 'fas',
  iconName: 'browser',
  icon: [512, 512, [128468], "f37e", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm384 0c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24z"]
};
var faPenPaintbrush = {
  prefix: 'fas',
  iconName: 'pen-paintbrush',
  icon: [576, 512, ["pencil-paintbrush"], "f618", "M95.6 16.4L226.3 147.1l-79.2 79.2L16.4 95.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0zM400 512c-53.6 0-98.5-37.7-109.4-88.1L423.9 290.6c50.3 11 88.1 55.8 88.1 109.4c0 3.9-.2 7.8-.6 11.6c-1.8 17.5 10.2 36.4 27.8 36.4H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H400zM501.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L354.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM76.9 353.2L331.7 98.3 445.7 212.3 190.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2z"]
};
var faPencilPaintbrush = faPenPaintbrush;
var faFishCooked = {
  prefix: 'fas',
  iconName: 'fish-cooked',
  icon: [576, 512, [], "f7fe", "M320 64c120 0 256 128 256 192s-136 192-256 192c-74.8 0-155.9-49.8-206.3-102.8c-6-6.3-15.8-7.2-22.5-1.7L26.1 396.4c-5.3 4.3-12.9 4.8-18.7 1.1s-8.6-10.7-6.9-17.4L30.5 259.9c.6-2.5 .6-5.2 0-7.8L.5 131.9c-1.6-6.5 .9-13.2 6.4-17s12.7-3.8 18.2 0l72 49.5c6.6 4.5 15.5 3.5 21.1-2.2C168.9 110.9 247.4 64 320 64zm-4.7 84.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zm112 16c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6zm16 112c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faChairOffice = {
  prefix: 'fas',
  iconName: 'chair-office',
  icon: [448, 512, [], "f6c1", "M160 0H288c35.3 0 64 28.7 64 64V256H96V64c0-35.3 28.7-64 64-64zM64 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm384 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zM51.4 305.7C56.8 294.8 67.9 288 80 288H368c12.1 0 23.2 6.8 28.6 17.7l16 32c5 9.9 4.4 21.7-1.4 31.1s-16.1 15.2-27.2 15.2H256v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224 160c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V384H64c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32z"]
};
var faNestingDolls = {
  prefix: 'fas',
  iconName: 'nesting-dolls',
  icon: [640, 512, [], "e3ba", "M192 0c61.9 0 112 50.1 112 112V224H80V112C80 50.1 130.1 0 192 0zm-8.7 64.9c-11.7 15.1-28.7 26-48.2 29.7c-4 .8-7.2 4.2-6.8 8.2c1.5 14 7.6 27.7 18.4 38.5c25 25 65.5 25 90.5 0c10.8-10.8 16.9-24.4 18.4-38.5c.4-4.1-2.7-7.5-6.8-8.2c-19.5-3.7-36.5-14.6-48.2-29.7c-4.1-5.3-13.2-5.3-17.3 0zM635.5 474.1c5.2 7.3 5.9 16.9 1.8 24.9s-12.4 13-21.3 13H312c-9 0-17.2-5-21.3-13c-4.1-8-3.4-17.6 1.8-24.9l0 0 .2-.3c.2-.3 .6-.8 1-1.5c.9-1.4 2.3-3.5 4-6.3c3.4-5.6 7.9-13.8 12.5-23.8c9.2-20.3 17.8-46.8 17.8-74.1v-8c0-75.1 60.9-136 136-136s136 60.9 136 136v8c0 27.3 8.6 53.7 17.8 74.1c4.6 10 9.1 18.2 12.5 23.8c1.7 2.8 3.1 5 4 6.3c.5 .7 .8 1.2 1 1.5l.2 .3 0 0 0 0zM455.3 320.9C440.7 339.8 417.8 352 392 352c-4.3 0-8 3.3-7.6 7.6c1.7 17.9 9.4 35.3 23.1 49c31.2 31.2 81.9 31.2 113.1 0c13.7-13.7 21.4-31.1 23.1-49c.4-4.3-3.3-7.6-7.6-7.6c-25.8 0-48.7-12.2-63.3-31.1c-4.1-5.3-13.2-5.3-17.3 0zM296 360v8c0 21-6.8 42.7-15 60.8c-4 8.7-7.9 15.8-10.8 20.6c-1.4 2.4-2.6 4.1-3.2 5.2c-.3 .5-.6 .9-.7 1l0 0 0 .1 0 0 0 0c-11.7 16.6-13.5 38.1-4.9 56.3H74.5c-17 0-33.4-6.7-42.7-20.9C17.9 469.7 0 432.8 0 384c0-44.4 20.2-84.4 37.9-119.4c2.7-5.3 8.1-8.6 14-8.6H332.1C309.5 284.6 296 320.7 296 360z"]
};
var faClockRotateLeft = {
  prefix: 'fas',
  iconName: 'clock-rotate-left',
  icon: [512, 512, ["history"], "f1da", "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"]
};
var faHistory = faClockRotateLeft;
var faTrumpet = {
  prefix: 'fas',
  iconName: 'trumpet',
  icon: [640, 512, [127930], "f8e3", "M628.7 64.7C635.4 66.8 640 73 640 80V368c0 7-4.6 13.2-11.3 15.3s-14-.4-17.9-6.2l0 0 0 0-.1-.2-.7-.9c-.6-.8-1.5-2.1-2.8-3.8c-2.5-3.3-6.2-8.1-11-13.9c-9.6-11.6-23.6-26.9-40.8-42.3c-35-31.1-81.3-60-131.4-60H400V382c27.6-7.1 48-32.2 48-62V290.8c22 5 43.7 16.4 64 31.2c-1.1 69.8-58 126-128 126H288.1c0 0 0 0-.1 0H192c-70.7 0-128-57.3-128-128c0-23.3 6.2-45.2 17.1-64H46.6c-3.3 9.3-12.2 16-22.6 16c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24c10.4 0 19.3 6.7 22.6 16H176V160c0-13.3 10.7-24 24-24s24 10.7 24 24v32h40V160c0-13.3 10.7-24 24-24s24 10.7 24 24v32h40V160c0-13.3 10.7-24 24-24s24 10.7 24 24v32h24c50.1 0 96.4-28.8 131.4-60c17.3-15.3 31.2-30.7 40.8-42.3c4.8-5.8 8.5-10.6 11-13.9c1.2-1.7 2.2-2.9 2.8-3.8l.7-.9 .1-.2 0 0 0 0c4-5.8 11.2-8.3 17.9-6.2zM312 384h40V256H312V384zM224 256V384h40V256H224zm-96 64c0 29.8 20.4 54.9 48 62V258c-27.6 7.1-48 32.2-48 62z"]
};
var faFaceGrinBeamSweat = {
  prefix: 'fas',
  iconName: 'face-grin-beam-sweat',
  icon: [512, 512, [128517, "grin-beam-sweat"], "f583", "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM383.8 317.8C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7c24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7c5.1-11.8-6.9-22.4-19.2-18.7zm-166.2-89l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]
};
var faGrinBeamSweat = faFaceGrinBeamSweat;
var faFireSmoke = {
  prefix: 'fas',
  iconName: 'fire-smoke',
  icon: [640, 512, [], "f74b", "M283.7 0c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6c0 30 8.2 58.3 22.7 82.4c4.6 2.6 9 5.4 13.3 8.5c13.7-16.8 30.7-30.8 50.1-40.9c-3.9-9.4-6-20.2-6-32.1c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c11.3 20.7 12.3 44.9 4.2 65.2c19.3 10.1 36.2 24 49.9 40.8c4.2-3 8.5-5.8 12.9-8.3c14.6-24.1 23-52.4 23-82.5c0-20.2-9.6-50.9-24.2-79C441.1 84.7 420.2 54.7 395.5 32c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7c-2.8-2.5-6.3-3.7-9.8-3.8zM0 400c0 61.9 50.1 112 112 112H320 528c61.9 0 112-50.1 112-112s-50.1-112-112-112c-37 0-69.9 18-90.3 45.7C418.2 288 372.8 256 320 256s-98.2 32-117.7 77.7C181.9 306 149 288 112 288C50.1 288 0 338.1 0 400z"]
};
var faPhoneMissed = {
  prefix: 'fas',
  iconName: 'phone-missed',
  icon: [640, 512, [], "e226", "M232 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-39 39 58.7 58.7C282.3 152.4 300.8 160 320 160s37.7-7.6 51.3-21.3L503 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L405.3 172.7C382.6 195.3 352 208 320 208s-62.6-12.7-85.3-35.3L176 113.9l-39 39c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V24c0-13.3 10.7-24 24-24H232zM51.4 489.9l-35.4-62c-9.7-16.9-8.3-38.1 5.5-51.7C72.6 325.9 178.1 256 320 256s247.4 69.9 298.5 120.2c13.9 13.6 15.2 34.8 5.5 51.7l-35.4 62c-7.4 12.9-22.7 19.1-37 14.8L438.8 470.8c-13.5-4.1-22.8-16.5-22.8-30.6V384c-62.3-20.8-129.7-20.8-192 0v56.2c0 14.1-9.3 26.6-22.8 30.6L88.4 504.7c-14.3 4.3-29.6-1.8-37-14.8z"]
};
var faFileExport = {
  prefix: 'fas',
  iconName: 'file-export',
  icon: [576, 512, ["arrow-right-from-file"], "f56e", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"]
};
var faArrowRightFromFile = faFileExport;
var faShield = {
  prefix: 'fas',
  iconName: 'shield',
  icon: [512, 512, [128737, "shield-blank"], "f132", "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"]
};
var faShieldBlank = faShield;
var faArrowUpShortWide = {
  prefix: 'fas',
  iconName: 'arrow-up-short-wide',
  icon: [576, 512, ["sort-amount-up-alt"], "f885", "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"]
};
var faSortAmountUpAlt = faArrowUpShortWide;
var faArrowsRepeat1 = {
  prefix: 'fas',
  iconName: 'arrows-repeat-1',
  icon: [512, 512, ["repeat-1-alt"], "f366", "M21.9 254.4C5.1 248.8-3.9 230.6 1.6 213.9C25.1 143.5 91 96 165.2 96H338.7L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H165.2c-46.7 0-88.1 29.9-102.8 74.1c-5.6 16.8-23.7 25.8-40.5 20.2zm468.2 3.3c16.8 5.6 25.8 23.7 20.2 40.5C486.9 368.5 421 416 346.8 416H173.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H346.8c46.7 0 88.1-29.9 102.8-74.1c5.6-16.8 23.7-25.8 40.5-20.2zM288 216v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"]
};
var faRepeat1Alt = faArrowsRepeat1;
var faGunSlash = {
  prefix: 'fas',
  iconName: 'gun-slash',
  icon: [640, 512, [], "e19c", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L412.3 297.8 432.9 240H464c8.5 0 16.6-3.4 22.6-9.4L509.3 208H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H560V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H113.9L38.8 5.1zM195.6 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H236.4l-40.8-32zM338.5 240h43.4l-9.5 26.6L338.5 240zM324.9 352L264 304h-3l.5-2L32 121.2V208c0 17.7 14.3 32 32 32H74c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480h96c14.7 0 27.5-10 31-24.2L249 352h75.9z"]
};
var faAvocado = {
  prefix: 'fas',
  iconName: 'avocado',
  icon: [512, 512, [], "e0aa", "M459.4 255.3c-18.5 15.2-33.5 35.6-38.1 59.1c-10.2 51.9-34 104.5-66.3 136.7c-81.2 81.2-212.9 81.2-294.2 0s-81.2-212.9 0-294.2c32.3-32.3 84.9-56.1 136.7-66.3c23.5-4.6 43.9-19.6 59.1-38.1C283.1 20.5 323.2 0 368 0c79.5 0 144 64.5 144 144c0 44.8-20.5 84.9-52.6 111.3zM283.2 347.2c41.7-41.7 49.1-102.1 16.4-134.8s-93-25.3-134.8 16.4s-49.1 102.1-16.4 134.8s93 25.3 134.8-16.4z"]
};
var faBinary = {
  prefix: 'fas',
  iconName: 'binary',
  icon: [384, 512, [], "e33b", "M336 32V160h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H304 256c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V76.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16C303.6-1.6 314.4 0 322.7 6s13.3 15.7 13.3 26zM112 320V448h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4s13.3 15.7 13.3 26zM0 64C0 28.7 28.7 0 64 0h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm128 0H64v96h64V64zM256 288h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zm0 64v96h64V352H256z"]
};
var faGlassesRound = {
  prefix: 'fas',
  iconName: 'glasses-round',
  icon: [576, 512, [128083, "glasses-alt"], "f5f5", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L64.4 228.3C85.2 215.4 109.7 208 136 208c55.1 0 102.6 32.8 124 80H316c21.3-47.2 68.8-80 124-80c26.3 0 50.8 7.4 71.6 20.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l40.5 173.7c4.9 20.9 7.3 42.2 7.3 63.6V336c0 .8 0 1.6-.1 2.4c.1 1.9 .1 3.8 .1 5.6c0 75.1-60.9 136-136 136c-72.4 0-131.6-56.6-135.8-128H271.8c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0-1.9 0-3.8 .1-5.6c-.1-.8-.1-1.6-.1-2.4V325.5c0-21.4 2.5-42.8 7.3-63.6L47.9 88.2C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM136 416a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm376-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"]
};
var faGlassesAlt = faGlassesRound;
var faPhonePlus = {
  prefix: 'fas',
  iconName: 'phone-plus',
  icon: [640, 512, [], "f4d2", "M456 200V136H392c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V24c0-13.3 10.7-24 24-24s24 10.7 24 24V88h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H504v64c0 13.3-10.7 24-24 24s-24-10.7-24-24zM181.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c33.3 70.4 90.3 127.4 160.7 160.7L409 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512C264.6 512 64 311.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24z"]
};
var faDitto = {
  prefix: 'fas',
  iconName: 'ditto',
  icon: [320, 512, [], "22", "M0 96v2.3c0 3.8 .3 7.6 1 11.4L26.5 256.5C29.7 274.7 45.5 288 64 288s34.3-13.3 37.5-31.5L127 109.6c.7-3.8 1-7.5 1-11.4V96c0-35.3-28.7-64-64-64S0 60.7 0 96zm192 0v2.3c0 3.8 .3 7.6 1 11.4l25.5 146.8c3.2 18.2 19 31.5 37.5 31.5s34.3-13.3 37.5-31.5L319 109.6c.7-3.8 1-7.5 1-11.4V96c0-35.3-28.7-64-64-64s-64 28.7-64 64z"]
};
var faPersonSeat = {
  prefix: 'fas',
  iconName: 'person-seat',
  icon: [384, 512, [], "e21e", "M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 160V256h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H189.3c-6.6-18.6-24.4-32-45.3-32c-26.5 0-48 21.5-48 48v80c0 35.3 28.7 64 64 64h85.6c8.1 0 14.9 6 15.9 14l10.7 86c2 16 15.6 28 31.8 28h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.2L325 358.1c-5-40-39-70.1-79.4-70.1H192zM64 160c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 70.7 57.3 128 128 128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-35.3 0-64-28.7-64-64V160z"]
};
var faHouseMedical = {
  prefix: 'fas',
  iconName: 'house-medical',
  icon: [576, 512, [], "e3b2", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"]
};
var faGolfBallTee = {
  prefix: 'fas',
  iconName: 'golf-ball-tee',
  icon: [384, 512, ["golf-ball"], "f450", "M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V464c0-8.8-7.2-16-16-16H128c-17.7 0-32-14.3-32-32z"]
};
var faGolfBall = faGolfBallTee;
var faCircleChevronLeft = {
  prefix: 'fas',
  iconName: 'circle-chevron-left',
  icon: [512, 512, ["chevron-circle-left"], "f137", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"]
};
var faChevronCircleLeft = faCircleChevronLeft;
var faHouseChimneyWindow = {
  prefix: 'fas',
  iconName: 'house-chimney-window',
  icon: [576, 512, [], "e00d", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H248z"]
};
var faScythe = {
  prefix: 'fas',
  iconName: 'scythe',
  icon: [640, 512, [], "f710", "M614.7 .7c5.6 1.2 10.5 3.8 14.5 7.3c8.4 7.4 12.6 19 10.1 30.7l-4.8 22.6L577.6 326.7l-34.3 160c-3.7 17.3-20.7 28.3-38 24.6s-28.3-20.7-24.6-38l26-121.3H416c-17.7 0-32-14.3-32-32s14.3-32 32-32H520.4L569 61.3l7.7-36 0 0L582.1 0H608c2.2 0 4.5 .2 6.7 .7zM352 0H549.4l-4 18.6L508.3 192H12.7C5.7 192 0 186.3 0 179.3c0-2.1 .5-4.1 1.6-6C15 151.1 114.8 0 352 0z"]
};
var faPenNib = {
  prefix: 'fas',
  iconName: 'pen-nib',
  icon: [512, 512, [10001], "f5ad", "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"]
};
var faBanParking = {
  prefix: 'fas',
  iconName: 'ban-parking',
  icon: [512, 512, ["parking-circle-slash"], "f616", "M412.5 367.2L342.3 297c20.6-17.6 33.7-43.8 33.7-73c0-53-43-96-96-96H208c-9.7 0-18.6 3.5-25.5 9.2L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2zm-45.3 45.3C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2L367.2 412.5zM296.6 251.4L237.3 192H280c17.7 0 32 14.3 32 32c0 11.6-6.2 21.7-15.4 27.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 261.3V288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V325.3l-64-64z"]
};
var faParkingCircleSlash = faBanParking;
var faTentArrowTurnLeft = {
  prefix: 'fas',
  iconName: 'tent-arrow-turn-left',
  icon: [576, 512, [], "e580", "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"]
};
var faFaceDiagonalMouth = {
  prefix: 'fas',
  iconName: 'face-diagonal-mouth',
  icon: [512, 512, [129764], "e47e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM372.4 319.4l-224 64c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8l224-64c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faDiagramCells = {
  prefix: 'fas',
  iconName: 'diagram-cells',
  icon: [512, 512, [], "e475", "M512 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H64v64l384 0zm0 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64z"]
};
var faCricketBatBall = {
  prefix: 'fas',
  iconName: 'cricket-bat-ball',
  icon: [512, 512, [127951, "cricket"], "f449", "M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-135 135L409 231c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-23 23H240c-8.8 0-16-7.2-16-16V126.1l23-23c9.4-9.4 24.6-9.4 33.9 0l41.4 41.4 135-135c12.5-12.5 32.8-12.5 45.3 0zM352 432a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM16.1 334L192 158.1V272c0 26.5 21.5 48 48 48H353.9L178 495.9c-10 10-24.4 16.7-40.4 15.6c-11.3-.8-28.6-2.8-46.4-8.2C73.9 498.2 54.1 489.1 39 473c-16.2-15-25.2-34.9-30.4-52.2C3.2 403 1.2 385.7 .5 374.4C-.6 358.4 6.1 344 16.1 334z"]
};
var faCricket = faCricketBatBall;
var faTents = {
  prefix: 'fas',
  iconName: 'tents',
  icon: [640, 512, [], "e582", "M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512H224V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"]
};
var faWandMagic = {
  prefix: 'fas',
  iconName: 'wand-magic',
  icon: [512, 512, ["magic"], "f0d0", "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"]
};
var faMagic = faWandMagic;
var faDog = {
  prefix: 'fas',
  iconName: 'dog',
  icon: [576, 512, [128021], "f6d3", "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7l-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16H303.8L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faPenLine = {
  prefix: 'fas',
  iconName: 'pen-line',
  icon: [576, 512, [], "e212", "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-48.4 48.4L314.3 67.7l48.4-48.4c25-25 65.5-25 90.5 0zM58.6 323.5L291.7 90.3 421.7 220.3 188.5 453.4c-10.4 10.4-23.3 18-37.4 22.2L30.8 511c-8.4 2.5-17.5 .2-23.7-6.1S-1.5 489.7 1 481.2L36.4 360.9c4.2-14.1 11.8-27 22.2-37.4zM248 464H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faAtomSimple = {
  prefix: 'fas',
  iconName: 'atom-simple',
  icon: [512, 512, ["atom-alt"], "f5d3", "M100.9 411.1c-1.3-1.3-12.4-16.8 3.3-64c3.5-10.4 8-21.4 13.6-32.9c11.6 14.2 24.3 28.3 38 41.9s27.7 26.4 41.9 38c-11.4 5.6-22.4 10.2-32.8 13.6c-47.2 15.7-62.7 4.6-64 3.3zM153.7 256c13.5-18.3 29.3-36.8 47.4-54.9s36.6-33.9 54.9-47.4c18.3 13.5 36.8 29.3 54.9 47.4s33.9 36.6 47.4 54.9c-13.5 18.3-29.3 36.8-47.4 54.9s-36.6 33.9-54.9 47.4c-18.3-13.5-36.8-29.3-54.9-47.4s-33.9-36.6-47.4-54.9zm44.1-138.1c-14.2 11.6-28.3 24.3-41.9 38s-26.4 27.7-38 41.9c-5.6-11.4-10.2-22.4-13.6-32.8c-15.7-47.2-4.6-62.7-3.3-64s16.8-12.4 64 3.3c10.4 3.5 21.4 8 32.8 13.6zM256 76.8C173.9 27.6 94.9 16.5 55.7 55.7S27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8zm58.2 41.1c11.4-5.6 22.4-10.2 32.9-13.6c47.2-15.7 62.7-4.6 64-3.3s12.4 16.8-3.3 64c-3.5 10.4-8 21.4-13.6 32.8c-11.6-14.2-24.3-28.3-38-41.9s-27.7-26.4-41.9-38zm79.9 196.3c5.6 11.4 10.2 22.4 13.6 32.9c15.7 47.2 4.6 62.7 3.3 64s-16.8 12.4-64-3.3c-10.4-3.5-21.4-8-32.9-13.6c14.2-11.6 28.3-24.3 41.9-38s26.4-27.7 38-41.9zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faAtomAlt = faAtomSimple;
var faAmpersand = {
  prefix: 'fas',
  iconName: 'ampersand',
  icon: [448, 512, [], "26", "M180.7 96h38c20.6 0 37.3 16.7 37.3 37.3c0 11.8-5.5 22.8-14.9 29.9l-48 36-39-41.3c-6.4-6.8-10-15.8-10-25.2c0-20.3 16.4-36.7 36.7-36.7zm56.6 150l42.2-31.6C305 195.3 320 165.2 320 133.3C320 77.4 274.6 32 218.7 32h-38C125.1 32 80 77.1 80 132.7c0 25.7 9.8 50.4 27.5 69.1l34 36L74.7 288C47.8 308.1 32 339.8 32 373.3C32 432.2 79.8 480 138.7 480h74.5c37.4 0 72.4-18.7 93.2-49.9l6.9-10.4L360.7 470c12.1 12.8 32.4 13.4 45.2 1.3s13.4-32.4 1.3-45.2l-57.5-60.9 60.9-91.4c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9l-52.7 79.1L237.3 246zm-51.5 38.6L268.2 372l-15.1 22.6C244.2 408 229.2 416 213.2 416H138.7C115.1 416 96 396.9 96 373.3c0-13.4 6.3-26.1 17.1-34.1l72.7-54.5z"]
};
var faCarrot = {
  prefix: 'fas',
  iconName: 'carrot',
  icon: [512, 512, [129365], "f787", "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"]
};
var faArrowUpFromLine = {
  prefix: 'fas',
  iconName: 'arrow-up-from-line',
  icon: [384, 512, [8613, "arrow-from-bottom"], "f342", "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.3V208 320c0 17.7 14.3 32 32 32s32-14.3 32-32V208 141.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faArrowFromBottom = faArrowUpFromLine;
var faMoon = {
  prefix: 'fas',
  iconName: 'moon',
  icon: [384, 512, [127769, 9214], "f186", "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"]
};
var faPenSlash = {
  prefix: 'fas',
  iconName: 'pen-slash',
  icon: [640, 512, [], "e213", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l75.7-75.7L355.7 90.3l-91.5 91.5L38.8 5.1zm78 324.1c-6.6 6.6-11.5 14.8-14.1 23.8L65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l128.2-37.7c9-2.6 17.2-7.5 23.8-14.1l94.4-94.4L195.8 250.3l-79 79zM426.7 19.3L378.3 67.7 508.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L517.3 19.3c-25-25-65.5-25-90.5 0z"]
};
var faWineGlassEmpty = {
  prefix: 'fas',
  iconName: 'wine-glass-empty',
  icon: [320, 512, ["wine-glass-alt"], "f5ce", "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"]
};
var faWineGlassAlt = faWineGlassEmpty;
var faSquareStar = {
  prefix: 'fas',
  iconName: 'square-star',
  icon: [448, 512, [], "e27f", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 8c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L224 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z"]
};
var faCheese = {
  prefix: 'fas',
  iconName: 'cheese',
  icon: [512, 512, [], "f7ef", "M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288H512z"]
};
var faSendBackward = {
  prefix: 'fas',
  iconName: 'send-backward',
  icon: [512, 512, [], "f87f", "M64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h64V224c0-53 43-96 96-96H352V64c0-35.3-28.7-64-64-64H64zM224 224H448V448H224V224zm-64 0V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64z"]
};
var faYinYang = {
  prefix: 'fas',
  iconName: 'yin-yang',
  icon: [512, 512, [9775], "f6ad", "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMusic = {
  prefix: 'fas',
  iconName: 'music',
  icon: [512, 512, [127925], "f001", "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V147L192 223.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"]
};
var faCompassSlash = {
  prefix: 'fas',
  iconName: 'compass-slash',
  icon: [640, 512, [], "f5e9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-95.4-74.8C561.1 354.5 576 307 576 256C576 114.6 461.4 0 320 0C246.8 0 180.9 30.7 134.2 79.9L38.8 5.1zM270.3 186.5l143.3-55.1c19.4-7.5 38.5 11.6 31 31L397.1 285.9 270.3 186.5zM320 512c55.2 0 106.3-17.5 148.1-47.2L317 345.8l-90.6 34.8c-19.4 7.5-38.5-11.6-31-31l29.4-76.5L82.3 160.8C70.5 190.2 64 222.4 64 256c0 141.4 114.6 256 256 256z"]
};
var faClockOne = {
  prefix: 'fas',
  iconName: 'clock-one',
  icon: [512, 512, [], "e34e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392v56.7l20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFileMusic = {
  prefix: 'fas',
  iconName: 'file-music',
  icon: [384, 512, [], "f8b6", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm32 224v32V384c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V279.1l-96 36V416c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V304 272c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z"]
};
var faCodeCommit = {
  prefix: 'fas',
  iconName: 'code-commit',
  icon: [640, 512, [], "f386", "M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z"]
};
var faTemperatureLow = {
  prefix: 'fas',
  iconName: 'temperature-low',
  icon: [512, 512, [], "f76b", "M448 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 96a96 96 0 1 1 192 0A96 96 0 1 1 320 96zM144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faPersonBiking = {
  prefix: 'fas',
  iconName: 'person-biking',
  icon: [640, 512, [128692, "biking"], "f84a", "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
};
var faBiking = faPersonBiking;
var faDisplayChartUpCircleCurrency = {
  prefix: 'fas',
  iconName: 'display-chart-up-circle-currency',
  icon: [640, 512, [], "e5e5", "M0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V211.2c-19.5-10-41.1-16.4-64-18.5V64H64V352H320.7c-.5 5.3-.7 10.6-.7 16c0 59.5 29.5 112.1 74.8 144H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416H64c-35.3 0-64-28.7-64-64V64zm480 56v72.7c-16.7 1.5-32.7 5.3-47.7 11.2c-.2-1.3-.3-2.6-.3-3.9V177.9L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 144H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l17.3 17.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L438 332.7c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L460.7 426c21.6 13.2 49.1 13.2 70.7 0z"]
};
var faSkeleton = {
  prefix: 'fas',
  iconName: 'skeleton',
  icon: [512, 512, [], "f620", "M256 0c17.7 0 32 14.3 32 32V64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H288v32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H288v32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H288v64c0 .8 0 1.6-.1 2.3l67.6-29c8.3-3.5 17.2-5.4 26.1-5.4c36.7 0 66.4 29.7 66.4 66.4v1.5c0 18-7.2 35.3-19.9 48l-25.8 25.8c-11.7 11.7-27.6 18.3-44.1 18.3H153.9c-16.6 0-32.4-6.6-44.1-18.3L83.9 467.9c-12.7-12.7-19.9-30-19.9-48v-1.5c0-36.7 29.7-66.4 66.4-66.4c9 0 17.9 1.8 26.1 5.4l67.6 29c-.1-.8-.1-1.5-.1-2.3V320H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V224H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H224V128H96c-17.7 0-32-14.3-32-32s14.3-32 32-32H224V32c0-17.7 14.3-32 32-32zM184 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCircleG = {
  prefix: 'fas',
  iconName: 'circle-g',
  icon: [512, 512, [], "e10f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C295.2 183.7 276.5 176 256 176c-44.2 0-80 35.8-80 80z"]
};
var faCircleArrowUpLeft = {
  prefix: 'fas',
  iconName: 'circle-arrow-up-left',
  icon: [512, 512, [], "e0fb", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm64-368c13.3 0 24 10.7 24 24s-10.7 24-24 24H225.9L361 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24H320z"]
};
var faCoinBlank = {
  prefix: 'fas',
  iconName: 'coin-blank',
  icon: [512, 512, [], "e3fb", "M0 208c0 79.5 114.6 144 256 144s256-64.5 256-144s-114.6-144-256-144S0 128.5 0 208zm0 82.1L0 320c0 27.9 17.8 53.6 48 74.6L48 331c-18.3-11.5-34.8-25.2-48-40.9zM80 413c27.1 12.8 59.8 22.7 96 28.7l0-64.3c-35.1-6-67.6-15.9-96-29L80 413zm128 32.8c15.5 1.5 31.6 2.2 48 2.2s32.5-.8 48-2.2l0-64.1c-15.7 1.6-31.7 2.4-48 2.4s-32.3-.8-48-2.4l0 64.1zm128-4.1c36.2-6 68.9-15.9 96-28.7l0-64.7c-28.4 13.2-60.9 23-96 29l0 64.3zm128-47c30.2-21 48-46.8 48-74.6l0-29.9c-13.2 15.6-29.7 29.3-48 40.9l0 63.7z"]
};
var faBroom = {
  prefix: 'fas',
  iconName: 'broom',
  icon: [576, 512, [129529], "f51a", "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"]
};
var faVacuum = {
  prefix: 'fas',
  iconName: 'vacuum',
  icon: [640, 512, [], "e04d", "M301.6 64H512c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.8 52.8C513.8 148.1 467.2 128 416 128c-35.3 0-64 28.7-64 64V292c10.2-2.6 21-4 32-4c70.7 0 128 57.3 128 128c0 38.2-16.8 72.5-43.3 96H544c35.3 0 64-28.7 64-64V320c0-31.7-7.7-61.7-21.3-88C619 208.7 640 170.8 640 128C640 57.3 582.7 0 512 0H301.6C241.3 0 189.1 42.2 176.4 101.2L150.1 224h65.5L239 114.6C245.4 85.1 271.4 64 301.6 64zM208.7 256H143.3L109 416H83.8c-33.8 0-64.7 18.9-80 49C1.4 469.5 0 474.6 0 480c0 17.7 14.3 32 32 32h95.4c.4 0 .9 0 1.3 0H176c26.5 0 48-21.5 48-48s-21.5-48-48-48h-1.6l34.3-160zM480 416a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faShieldHeart = {
  prefix: 'fas',
  iconName: 'shield-heart',
  icon: [512, 512, [], "e574", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
var faCardHeart = {
  prefix: 'fas',
  iconName: 'card-heart',
  icon: [384, 512, [], "e3eb", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3z"]
};
var faLightbulbCflOn = {
  prefix: 'fas',
  iconName: 'lightbulb-cfl-on',
  icon: [640, 512, [], "e5a7", "M351 24.2c4.3 17.1-6.1 34.5-23.3 38.8l-128 32c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l128-32c17.1-4.3 34.5 6.1 38.8 23.3zM455.8 127l-256 64c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zM479 184.2c4.3 17.1-6.1 34.5-23.3 38.8l-256 64c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3zM256 384V306l48-12v90h80c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H352c0 17.7-14.3 32-32 32s-32-14.3-32-32H256c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm199.8-65l-64 16L384 337v47H336V308.7c0-.5 0-.9 0-1.4V304l.2 0c1.6-12.7 10.8-23.7 24-27l16-4 64-16c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zM53.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S42.3-3.3 53.3 4zM613.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM101.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm464-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7z"]
};
var faMelon = {
  prefix: 'fas',
  iconName: 'melon',
  icon: [512, 512, [], "e310", "M256 512c-38.5 0-75-8.5-107.7-23.7c67.1-5.8 149.8-48.2 220.8-119.2s113.4-153.8 119.2-220.8C503.5 181 512 217.5 512 256c0 141.4-114.6 256-256 256zM74.7 436.8c-19.1-19.4-26.8-55.8-11.9-108c14.6-51.2 49.6-110.2 102.7-163.3s112.1-88.1 163.3-102.7c52.4-15 88.9-7.1 108.2 12.2s27.2 55.9 12.2 108.2c-14.6 51.2-49.6 110.2-102.7 163.3s-112.1 88.1-163.3 102.7c-52.1 14.9-88.6 7.2-108-11.9c-.2-.2-.4-.4-.5-.5zm-51-73.1C8.5 331 0 294.5 0 256C0 114.6 114.6 0 256 0c38.5 0 75 8.5 107.7 23.7c-67.1 5.8-149.8 48.2-220.8 119.2s-113.4 153.8-119.2 220.8z"]
};
var faGopuram = {
  prefix: 'fas',
  iconName: 'gopuram',
  icon: [512, 512, [], "f664", "M120 0c13.3 0 24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64v64c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H416V352H384V224H352V128H320v96h32V352h32V512H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H128V352h32V224h32V128H160v96H128V352H96V512H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V256c0-17.7 14.3-32 32-32V160c0-17.7 14.3-32 32-32V64 32 24c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32v48h64V304c0-17.7-14.3-32-32-32zm-32-80v32h64V192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faEarthOceania = {
  prefix: 'fas',
  iconName: 'earth-oceania',
  icon: [512, 512, ["globe-oceania"], "e47b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faGlobeOceania = faEarthOceania;
var faContainerStorage = {
  prefix: 'fas',
  iconName: 'container-storage',
  icon: [640, 512, [], "f4b7", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM176 152V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFacePouting = {
  prefix: 'fas',
  iconName: 'face-pouting',
  icon: [512, 512, [], "e387", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM161.3 382.1c-5.4 12.3 8.7 21.6 21.1 16.4c22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4c-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faSquareXmark = {
  prefix: 'fas',
  iconName: 'square-xmark',
  icon: [448, 512, [10062, "times-square", "xmark-square"], "f2d3", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faTimesSquare = faSquareXmark;
var faXmarkSquare = faSquareXmark;
var faFaceExplode = {
  prefix: 'fas',
  iconName: 'face-explode',
  icon: [512, 512, ["exploding-head"], "e2fe", "M320 196.5c0 7.9 2.5 15.4 7 21.6c-14.5-6.6-31.5-5.6-45.3 3l-17.3 10.8c-5.2 3.2-11.8 3.2-17 0L230.2 221c-13.8-8.6-30.8-9.6-45.3-3c4.5-6.2 7-13.7 7-21.6V192c0-17.7-14.3-32-32-32H120c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8c7.5-3.7 15.9-5.8 24.8-5.8c30.9 0 56 25.1 56 56s-25.1 56-56 56H352c-17.7 0-32 14.3-32 32v4.5zM299 248c5.1-3 11.4-3 16.4 0h0c.1 .1 .2 .1 .3 .2L333 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c5.2-3.2 11.8-3.2 17 0l20.7 12.9c12.8 8 28.6 9.5 42.7 4.1L512 253.5c0 .8 0 1.7 0 2.5c0 141.4-114.6 256-256 256S0 397.4 0 256c0-.8 0-1.7 0-2.5l30.5 11.7c14.1 5.4 29.9 3.9 42.7-4.1l20.7-12.9c5.2-3.2 11.8-3.2 17 0L128.2 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c.1-.1 .2-.1 .3-.2h0c5.1-3 11.4-3 16.4 0h0c.1 .1 .2 .1 .3 .2L230.6 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c.1-.1 .2-.1 .3-.2h0zm-90.6 88a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 437.3c0 5.9 4.8 10.7 10.7 10.7H309.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H245.3c-29.5 0-53.3 23.9-53.3 53.3z"]
};
var faExplodingHead = faFaceExplode;
var faHashtag = {
  prefix: 'fas',
  iconName: 'hashtag',
  icon: [448, 512, [62098], "23", "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"]
};
var faUpRightAndDownLeftFromCenter = {
  prefix: 'fas',
  iconName: 'up-right-and-down-left-from-center',
  icon: [512, 512, ["expand-alt"], "f424", "M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"]
};
var faExpandAlt = faUpRightAndDownLeftFromCenter;
var faOilCan = {
  prefix: 'fas',
  iconName: 'oil-can',
  icon: [640, 512, [], "f613", "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H144 96 48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288V128h32zM96 208v86.1L48 272.8V208H96z"]
};
var faT = {
  prefix: 'fas',
  iconName: 't',
  icon: [384, 512, [116], "54", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"]
};
var faTransformerBolt = {
  prefix: 'fas',
  iconName: 'transformer-bolt',
  icon: [384, 512, [], "e2a4", "M136 24v8h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H112 64c-8.8 0-16-7.2-16-16s7.2-16 16-16H88V24C88 10.7 98.7 0 112 0s24 10.7 24 24zm160 0v8h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H272 224c-8.8 0-16-7.2-16-16s7.2-16 16-16h24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM48 112c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zm160 0c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16zM0 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V224c-17.7 0-32-14.3-32-32zm232.9 34.7c-6-4-13.9-3.6-19.3 1.1l-112 96c-5.1 4.4-6.9 11.4-4.6 17.7s8.3 10.4 15 10.4h57.8l-25 74.9c-2.3 6.8 .3 14.3 6.3 18.3s13.9 3.6 19.3-1.1l112-96c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4H214.2l25-74.9c2.3-6.8-.3-14.3-6.3-18.3z"]
};
var faHippo = {
  prefix: 'fas',
  iconName: 'hippo',
  icon: [640, 512, [129435], "f6ed", "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V320H480v16c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V318.4c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V372c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h7.2H256h32c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faChartColumn = {
  prefix: 'fas',
  iconName: 'chart-column',
  icon: [512, 512, [], "e0e3", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faCassetteVhs = {
  prefix: 'fas',
  iconName: 'cassette-vhs',
  icon: [576, 512, [128252, "vhs"], "f8ec", "M0 96v32H576V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160H0zM467.9 384H416V349.3c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3V224h51.9c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80zM160 349.3V384H108.1C90.5 362.1 80 334.3 80 304s10.5-58.1 28.1-80H160v34.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3zM256 224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32z"]
};
var faVhs = faCassetteVhs;
var faInfinity = {
  prefix: 'fas',
  iconName: 'infinity',
  icon: [640, 512, [8734, 9854], "f534", "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"]
};
var faVialCircleCheck = {
  prefix: 'fas',
  iconName: 'vial-circle-check',
  icon: [512, 512, [], "e596", "M0 64C0 46.3 14.3 32 32 32H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zM96 96v96h64V96H96zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faChimney = {
  prefix: 'fas',
  iconName: 'chimney',
  icon: [448, 512, [], "f78b", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64zM32 192h96V320H32V192zm384 0V320H160V192H416zM288 352V480H32V352H288zm128 0V480H320V352h96z"]
};
var faObjectIntersect = {
  prefix: 'fas',
  iconName: 'object-intersect',
  icon: [512, 512, [], "e49d", "M288 64v96H224c-35.3 0-64 28.7-64 64v64H64V64H288zM64 352h96v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H352V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64zM448 224V448H224V352h64c35.3 0 64-28.7 64-64V224h96z"]
};
var faPersonArrowDownToLine = {
  prefix: 'fas',
  iconName: 'person-arrow-down-to-line',
  icon: [640, 512, [], "e538", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM464 64V306.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faVoicemail = {
  prefix: 'fas',
  iconName: 'voicemail',
  icon: [640, 512, [], "f897", "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faBlockBrick = {
  prefix: 'fas',
  iconName: 'block-brick',
  icon: [448, 512, ["wall-brick"], "e3db", "M96 32v80H352V32H96zM64 112V32C28.7 32 0 60.7 0 96v16H64zM0 144v96H208V144H0zM0 368H64V272H0v96zm0 32v16c0 35.3 28.7 64 64 64H208V400H0zm240 0v80H384c35.3 0 64-28.7 64-64V400H240zm208-32V272H384v96h64zm-96 0V272H96v96H352zm96-224H240v96H448V144zm0-32V96c0-35.3-28.7-64-64-64v80h64z"]
};
var faWallBrick = faBlockBrick;
var faFan = {
  prefix: 'fas',
  iconName: 'fan',
  icon: [512, 512, [], "f863", "M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBagsShopping = {
  prefix: 'fas',
  iconName: 'bags-shopping',
  icon: [576, 512, [128717], "f847", "M176 96v64h96V96c0-26.5-21.5-48-48-48s-48 21.5-48 48zm-48 64V96c0-53 43-96 96-96s96 43 96 96v64h64c35.3 0 64 28.7 64 64H240c-44.2 0-80 35.8-80 80V464c0 5.5 .6 10.8 1.6 16H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64zm128 96H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V320c0-35.3 28.7-64 64-64zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53 43 96 96 96s96-43 96-96V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 35.3-28.7 64-64 64s-64-28.7-64-64V336z"]
};
var faParagraphLeft = {
  prefix: 'fas',
  iconName: 'paragraph-left',
  icon: [384, 512, ["paragraph-rtl"], "f878", "M320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 144C82.1 0 32 50.1 32 112s50.1 112 112 112h16l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224h32l0 224c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM128 384V337.6c0-9.7-7.9-17.6-17.6-17.6c-4.2 0-8.2 1.5-11.3 4.2l-93 78.7C2.2 406.1 0 410.9 0 416s2.2 9.9 6.1 13.2l93 78.7c3.2 2.7 7.2 4.2 11.3 4.2c9.7 0 17.6-7.9 17.6-17.6V448H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z"]
};
var faParagraphRtl = faParagraphLeft;
var faPersonWalkingLuggage = {
  prefix: 'fas',
  iconName: 'person-walking-luggage',
  icon: [576, 512, [], "e554", "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"]
};
var faCaravanSimple = {
  prefix: 'fas',
  iconName: 'caravan-simple',
  icon: [640, 512, ["caravan-alt"], "e000", "M80 32C35.8 32 0 67.8 0 112V336c0 44.2 35.8 80 80 80H96c0 53 43 96 96 96s96-43 96-96H576l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V192c0-88.4-71.6-160-160-160H80zM64 160c0-17.7 14.3-32 32-32H224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160zm288-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM144 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faCaravanAlt = faCaravanSimple;
var faTurtle = {
  prefix: 'fas',
  iconName: 'turtle',
  icon: [576, 512, [128034], "f726", "M384 249.2c0 21.4-17.4 38.8-38.8 38.8H70.8C49.4 288 32 270.6 32 249.2V208c0-97.2 78.8-176 176-176s176 78.8 176 176v41.2zM480 288c-2 0-4-.1-5.9-.3c-16.3 53.3-64.3 92.7-122.1 96V440c0 22.1-17.9 40-40 40H264c-22.1 0-40-17.9-40-40V384H192v56c0 22.1-17.9 40-40 40H104c-22.1 0-40-17.9-40-40V384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h72 48H264h48 32c39.8 0 72-32.2 72-72V224 192 176c0-35.3 28.7-64 64-64c53 0 96 43 96 96v16c0 35.3-28.7 64-64 64H480zm16-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faPencilMechanical = {
  prefix: 'fas',
  iconName: 'pencil-mechanical',
  icon: [512, 512, [], "e5ca", "M475.3 11.3C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3L390.6 41.4l80 80 30.1-30.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3L475.3 11.3zm-233 76.3c3.1-3.1 8.2-3.1 11.3 0L283 117 72.8 327.2C67 333 62.8 340.1 60.6 348L32.8 445.3 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l25.7-25.7L164 451.4c7.8-2.2 15-6.4 20.8-12.2L436.7 187.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L379.3 75.3C372.1 68.1 362.2 64 352 64s-20.1 4.1-27.3 11.3L317 83 287.6 53.7c-21.9-21.9-57.3-21.9-79.2 0L103 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L242.3 87.6zM89.1 422.9l17.3-60.5 43.2 43.2L89.1 422.9z"]
};
var faUpDown = {
  prefix: 'fas',
  iconName: 'up-down',
  icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"]
};
var faArrowsAltV = faUpDown;
var faCloudMoonRain = {
  prefix: 'fas',
  iconName: 'cloud-moon-rain',
  icon: [576, 512, [], "f73c", "M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H367.9zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"]
};
var faBoothCurtain = {
  prefix: 'fas',
  iconName: 'booth-curtain',
  icon: [512, 512, [], "f734", "M64 0C28.7 0 0 28.7 0 64V480c0 17.7 14.3 32 32 32s32-14.3 32-32V64l64 0V0H64zM512 64c0-35.3-28.7-64-64-64H352 256 192c-17.7 0-32 14.3-32 32V400c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48v80c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"]
};
var faCalendar = {
  prefix: 'fas',
  iconName: 'calendar',
  icon: [448, 512, [128197, 128198], "f133", "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"]
};
var faBoxHeart = {
  prefix: 'fas',
  iconName: 'box-heart',
  icon: [448, 512, [], "f49d", "M93.7 32H208V160H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32H354.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240V32zM0 192H448V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zM212.7 420.7c6.2 6.2 16.4 6.2 22.6 0l77.3-77.3c20.5-20.5 20.5-53.8 0-74.3s-53.8-20.5-74.3 0L224 283.4l-14.3-14.3c-20.5-20.5-53.8-20.5-74.3 0s-20.5 53.8 0 74.3l77.3 77.3z"]
};
var faTrailer = {
  prefix: 'fas',
  iconName: 'trailer',
  icon: [640, 512, [], "e041", "M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faUserDoctorMessage = {
  prefix: 'fas',
  iconName: 'user-doctor-message',
  icon: [640, 512, ["user-md-chat"], "f82e", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3c0-81 54-149.4 128-171.1v59.1c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V304.9c6-.6 12.1-.9 18.3-.9h91.4c6.2 0 12.3 .3 18.3 .9V362c-27.6 7.1-48 32.2-48 62v40c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16V424c0-17.7 14.3-32 32-32s32 14.3 32 32v24c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V424c0-29.8-20.4-54.9-48-62V311.2c74 21.7 128 90.1 128 171.1c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM120 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM432 0H592c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H544l-83.2 62.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2V224H432c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48z"]
};
var faUserMdChat = faUserDoctorMessage;
var faBahai = {
  prefix: 'fas',
  iconName: 'bahai',
  icon: [576, 512, ["haykal"], "f666", "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"]
};
var faHaykal = faBahai;
var faAmpGuitar = {
  prefix: 'fas',
  iconName: 'amp-guitar',
  icon: [512, 512, [], "f8a1", "M256 0c-48.9 0-92.5 28.8-121.6 53.8c-15 12.9-27.3 25.7-35.8 35.3c-2.3 2.6-4.3 4.9-6 6.9H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H419.5c-1.7-2.1-3.8-4.4-6-6.9c-8.5-9.6-20.8-22.4-35.8-35.3C348.5 28.8 304.9 0 256 0zm96.9 96H159.1c2.1-1.9 4.3-3.8 6.5-5.8C192.5 67.2 224.9 48 256 48s63.5 19.2 90.4 42.2c2.2 1.9 4.4 3.9 6.5 5.8zM96 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 448V256H448V448H64zm64-128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM256 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM384 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faSdCard = {
  prefix: 'fas',
  iconName: 'sd-card',
  icon: [384, 512, [], "f7c2", "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faVolumeSlash = {
  prefix: 'fas',
  iconName: 'volume-slash',
  icon: [640, 512, [128263], "f2e2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.1 386.2C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5L449 326.6c19-17.5 31-42.7 31-70.6c0-30.1-13.9-56.9-35.4-74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4L352 250.6V64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L197.8 129.8 38.8 5.1zM352 373.3L82.9 161.3C53.8 167.4 32 193.1 32 224v64c0 35.3 28.7 64 64 64h67.8L298.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S352 460.6 352 448V373.3z"]
};
var faBorderBottom = {
  prefix: 'fas',
  iconName: 'border-bottom',
  icon: [448, 512, [], "f84d", "M448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32zm-64-96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 352A32 32 0 1 1 0 352a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 160a32 32 0 1 1 64 0A32 32 0 1 1 0 160zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 64a32 32 0 1 1 64 0A32 32 0 1 1 0 64zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm64 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faWifiWeak = {
  prefix: 'fas',
  iconName: 'wifi-weak',
  icon: [640, 512, ["wifi-1"], "f6aa", "M256 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faWifi1 = faWifiWeak;
var faDragon = {
  prefix: 'fas',
  iconName: 'dragon',
  icon: [640, 512, [128009], "f6d5", "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0H416h32 16c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48H538.5c-17 0-33.3-6.7-45.3-18.7L480 160H448v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512H496 432 32.3c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V181.5v-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3v.6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"]
};
var faShoePrints = {
  prefix: 'fas',
  iconName: 'shoe-prints',
  icon: [640, 512, [], "f54b", "M416 0C352.3 0 256 32 256 32V160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32V480s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"]
};
var faCirclePlus = {
  prefix: 'fas',
  iconName: 'circle-plus',
  icon: [512, 512, ["plus-circle"], "f055", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faPlusCircle = faCirclePlus;
var faFaceGrinTongueWink = {
  prefix: 'fas',
  iconName: 'face-grin-tongue-wink',
  icon: [512, 512, [128540, "grin-tongue-wink"], "f58b", "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGrinTongueWink = faFaceGrinTongueWink;
var faHandHolding = {
  prefix: 'fas',
  iconName: 'hand-holding',
  icon: [576, 512, [], "f4bd", "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .1 .5 .5 0 1 1 .9-.1z"]
};
var faPlugCircleExclamation = {
  prefix: 'fas',
  iconName: 'plug-circle-exclamation',
  icon: [576, 512, [], "e55d", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faLinkSlash = {
  prefix: 'fas',
  iconName: 'link-slash',
  icon: [640, 512, ["chain-broken", "chain-slash", "unlink"], "f127", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"]
};
var faChainBroken = faLinkSlash;
var faChainSlash = faLinkSlash;
var faUnlink = faLinkSlash;
var faClone = {
  prefix: 'fas',
  iconName: 'clone',
  icon: [512, 512, [], "f24d", "M288 448H64V224h64V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64zm-64-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"]
};
var faPersonWalkingArrowLoopLeft = {
  prefix: 'fas',
  iconName: 'person-walking-arrow-loop-left',
  icon: [640, 512, [], "e551", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96H461.3l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"]
};
var faArrowUpZA = {
  prefix: 'fas',
  iconName: 'arrow-up-z-a',
  icon: [576, 512, ["sort-alpha-up-alt"], "f882", "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400H395.8z"]
};
var faSortAlphaUpAlt = faArrowUpZA;
var faFireFlameCurved = {
  prefix: 'fas',
  iconName: 'fire-flame-curved',
  icon: [384, 512, ["fire-alt"], "f7e4", "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"]
};
var faFireAlt = faFireFlameCurved;
var faTornado = {
  prefix: 'fas',
  iconName: 'tornado',
  icon: [448, 512, [127786], "f76f", "M0 32V45.6C0 62.7 1.7 79.6 5 96H357.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z"]
};
var faFileCirclePlus = {
  prefix: 'fas',
  iconName: 'file-circle-plus',
  icon: [576, 512, [58606], "e494", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faDeleteRight = {
  prefix: 'fas',
  iconName: 'delete-right',
  icon: [576, 512, [], "e154", "M0 128C0 92.7 28.7 64 64 64H370.7c17 0 33.3 6.7 45.3 18.7L566.6 233.4c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6L416 429.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V128zm143 47c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faBookQuran = {
  prefix: 'fas',
  iconName: 'book-quran',
  icon: [448, 512, ["quran"], "f687", "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"]
};
var faQuran = faBookQuran;
var faCircleQuarter = {
  prefix: 'fas',
  iconName: 'circle-quarter',
  icon: [512, 512, [], "e11f", "M32 256C14.3 256-.2 241.6 2 224.1C16.4 108.2 108.2 16.4 224.1 2C241.6-.2 256 14.3 256 32V224c0 17.7-14.3 32-32 32L32 256z"]
};
var faAnchor = {
  prefix: 'fas',
  iconName: 'anchor',
  icon: [576, 512, [9875], "f13d", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1z"]
};
var faBorderAll = {
  prefix: 'fas',
  iconName: 'border-all',
  icon: [448, 512, [], "f84c", "M384 96V224H256V96H384zm0 192V416H256V288H384zM192 224H64V96H192V224zM64 288H192V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faFunction = {
  prefix: 'fas',
  iconName: 'function',
  icon: [640, 512, [], "f661", "M64 96c0-53 43-96 96-96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32 14.3-32 32v96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V383.5c0 48.4-36.1 89.3-84.1 95.3l-7.9 1C18.4 481.9 2.4 469.5 .2 452s10.2-33.5 27.8-35.7l7.9-1c16-2 28-15.6 28-31.8V256H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V96zm266.7 81.7C303.7 218.4 288 267.3 288 320s15.7 101.6 42.7 142.3c9.8 14.7 5.7 34.6-9 44.3s-34.6 5.7-44.3-9C243.6 446.7 224 385.6 224 320s19.6-126.7 53.3-177.7c9.8-14.7 29.6-18.8 44.3-9s18.8 29.6 9 44.3zm202.6 0c-9.8-14.7-5.7-34.6 9-44.3s34.6-5.7 44.3 9C620.4 193.3 640 254.4 640 320s-19.6 126.7-53.3 177.7c-9.8 14.7-29.6 18.8-44.3 9s-18.8-29.6-9-44.3c27-40.7 42.7-89.6 42.7-142.3s-15.7-101.6-42.7-142.3zM398.6 241.4L432 274.7l33.4-33.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L477.3 320l33.4 33.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L432 365.3l-33.4 33.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L386.7 320l-33.4-33.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"]
};
var faFaceAngry = {
  prefix: 'fas',
  iconName: 'face-angry',
  icon: [512, 512, [128544, "angry"], "f556", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM338.7 395.9c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faAngry = faFaceAngry;
var faPeopleSimple = {
  prefix: 'fas',
  iconName: 'people-simple',
  icon: [512, 512, [], "e21b", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L267.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H320v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V384h21.6c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.9-27.5-33-46.4-61.5-46.4H368.3z"]
};
var faCookieBite = {
  prefix: 'fas',
  iconName: 'cookie-bite',
  icon: [512, 512, [], "f564", "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faArrowTrendDown = {
  prefix: 'fas',
  iconName: 'arrow-trend-down',
  icon: [576, 512, [], "e097", "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z"]
};
var faRss = {
  prefix: 'fas',
  iconName: 'rss',
  icon: [448, 512, ["feed"], "f09e", "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faFeed = faRss;
var faFaceMonocle = {
  prefix: 'fas',
  iconName: 'face-monocle',
  icon: [512, 512, [], "e380", "M427.2 446.3C381.9 487.2 321.8 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 62.8-22.6 120.3-60.1 164.9c-2.5-8.6-3.9-17.7-3.9-26.9V224c0-61.9-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6v91.5c0 18.4 3.9 36.2 11.2 52.4zM256 224a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm-79.6-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59C205.3 339.5 177.7 336 160 336c-8.8 0-16 7.2-16 16zM305.2 89.9c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L376.3 61c-12.7-8.5-27.6-13-42.8-13c-17.5 0-34.5 6-48.2 16.9L262 83.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6z"]
};
var faDrawPolygon = {
  prefix: 'fas',
  iconName: 'draw-polygon',
  icon: [448, 512, [], "f5ee", "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"]
};
var faScaleBalanced = {
  prefix: 'fas',
  iconName: 'scale-balanced',
  icon: [640, 512, [9878, "balance-scale"], "f24e", "M384 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288H584.4L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320H199.3L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z"]
};
var faBalanceScale = faScaleBalanced;
var faCalendarLines = {
  prefix: 'fas',
  iconName: 'calendar-lines',
  icon: [448, 512, ["calendar-note"], "e0d5", "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM96 296c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm24 72H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCalendarNote = faCalendarLines;
var faArrowDownBigSmall = {
  prefix: 'fas',
  iconName: 'arrow-down-big-small',
  icon: [576, 512, ["sort-size-down"], "f88c", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM320 368v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48zM368 32c-26.5 0-48 21.5-48 48V208c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368z"]
};
var faSortSizeDown = faArrowDownBigSmall;
var faGaugeSimpleHigh = {
  prefix: 'fas',
  iconName: 'gauge-simple-high',
  icon: [512, 512, [61668, "tachometer", "tachometer-fast"], "f62a", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"]
};
var faTachometer = faGaugeSimpleHigh;
var faTachometerFast = faGaugeSimpleHigh;
var faDoNotEnter = {
  prefix: 'fas',
  iconName: 'do-not-enter',
  icon: [512, 512, [], "f5ec", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96 208H416c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16z"]
};
var faShower = {
  prefix: 'fas',
  iconName: 'shower',
  icon: [512, 512, [128703], "f2cc", "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDiceD8 = {
  prefix: 'fas',
  iconName: 'dice-d8',
  icon: [512, 512, [], "f6d2", "M240 16c0-6.5-4-12.4-10-14.8s-13-1-17.5 3.7l-208 216c-3.7 3.9-5.3 9.3-4.1 14.6s4.9 9.5 9.9 11.5l208 80c4.9 1.9 10.5 1.2 14.8-1.7s6.9-7.9 6.9-13.2V16zM34.6 307.5c-4.1 6.3-3.3 14.6 1.9 20l176 179.7c4.5 4.6 11.5 6.1 17.5 3.6s10-8.3 10-14.8V384c0-6.6-4.1-12.6-10.3-14.9l-176-67.7c-7-2.7-15-.1-19.1 6.1zm442.7 0c-4.1-6.3-12.1-8.8-19.1-6.1l-176 67.7c-6.2 2.4-10.3 8.3-10.3 14.9V496c0 6.5 3.9 12.4 10 14.8s12.9 1 17.5-3.6l176-179.7c5.3-5.4 6.1-13.7 1.9-20zM282 1.2C276 3.6 272 9.5 272 16V312c0 5.3 2.6 10.2 6.9 13.2s9.9 3.6 14.8 1.7l208-80c5-1.9 8.7-6.2 9.9-11.5s-.4-10.7-4.1-14.6l-208-216C295 .2 288.1-1.3 282 1.2z"]
};
var faDesktop = {
  prefix: 'fas',
  iconName: 'desktop',
  icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"]
};
var faDesktopAlt = faDesktop;
var faM = {
  prefix: 'fas',
  iconName: 'm',
  icon: [448, 512, [109], "4d", "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.2c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 49.9 9.2 37.5 22.7 33.4z"]
};
var faGripDotsVertical = {
  prefix: 'fas',
  iconName: 'grip-dots-vertical',
  icon: [256, 512, [], "e411", "M48 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM96 416A48 48 0 1 0 0 416a48 48 0 1 0 96 0zM208 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faFaceViewfinder = {
  prefix: 'fas',
  iconName: 'face-viewfinder',
  icon: [512, 512, [], "e2ff", "M56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 25.1 25.1 0 56 0zM376 0h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-4.4-3.6-8-8-8H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376v80c0 4.4 3.6 8 8 8h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0v80c0 30.9-25.1 56-56 56H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8V376c0-13.3 10.7-24 24-24s24 10.7 24 24zM96 256a160 160 0 1 1 320 0A160 160 0 1 1 96 256zm128-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM169.9 292.5c-6.4 6.1-6.6 16.2-.5 22.6C191.2 337.8 222 352 256 352s64.8-14.2 86.6-36.9c6.1-6.4 5.9-16.5-.5-22.6s-16.5-5.9-22.6 .5C303.5 309.6 281 320 256 320s-47.5-10.4-63.5-27.1c-6.1-6.4-16.2-6.6-22.6-.5z"]
};
var faSoftServe = {
  prefix: 'fas',
  iconName: 'soft-serve',
  icon: [384, 512, [127846, "creemee"], "e400", "M208 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l6.1 6.1c3.4 3.4 5.3 7.9 5.3 12.7C208 56 200 64 190.1 64H128c-35.3 0-64 28.7-64 64c0 11.8 3.2 22.9 8.8 32.4C40.8 164 16 191.1 16 224c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64s-28.7-64-64-64h-2.3c11.5-14.4 18.3-32.7 18.3-52.6C320 48.1 271.9 0 212.6 0H208zM48 320v32c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5H259.4c16.3 0 30-12.3 31.8-28.5L302.2 384H304c17.7 0 32-14.3 32-32V320H48z"]
};
var faCreemee = faSoftServe;
var faH5 = {
  prefix: 'fas',
  iconName: 'h5',
  icon: [640, 512, [], "e412", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zM432 64c-15.1 0-28.2 10.6-31.3 25.4l-32 152c-2 9.4 .4 19.3 6.5 26.8s15.2 11.8 24.8 11.8H524c28.7 0 52 23.3 52 52s-23.3 52-52 52H456.4c-10.3 0-19.5-6.6-22.8-16.4l-3.2-9.7c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5l3.2 9.7c12 35.9 45.6 60.2 83.5 60.2H524c64.1 0 116-51.9 116-116s-51.9-116-116-116H439.4L458 128H576c17.7 0 32-14.3 32-32s-14.3-32-32-32H432z"]
};
var faHandBackPointDown = {
  prefix: 'fas',
  iconName: 'hand-back-point-down',
  icon: [448, 512, [], "e19e", "M136 512c-22.1 0-40-17.9-40-40V272v-7V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v55.7c-2-1.4-3.9-3-5.8-4.5L39 227.2C24.4 215 16 197 16 178V140c0-38 16.9-74 46.1-98.3l5.4-4.5C96.3 13.1 132.5 0 169.9 0H288c70.7 0 128 57.3 128 128v64 32c0 26.5-21.5 48-48 48c-12.4 0-23.6-4.7-32.1-12.3C334 284.5 313.3 304 288 304c-12.4 0-23.6-4.7-32.1-12.3C254 316.5 233.3 336 208 336c-12.3 0-23.5-4.6-32-12.2V472c0 22.1-17.9 40-40 40z"]
};
var faTableList = {
  prefix: 'fas',
  iconName: 'table-list',
  icon: [512, 512, ["th-list"], "f00b", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"]
};
var faThList = faTableList;
var faCommentSms = {
  prefix: 'fas',
  iconName: 'comment-sms',
  icon: [512, 512, ["sms"], "f7cd", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM202.9 176.8c6.5-2.2 13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2zm173.1 38c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.2-.4-23.7-4.4-32.6-7.4l0 0 0 0c-1.4-.5-2.7-.9-4-1.4c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7 .6 3.3 1.1 4.9 1.6l0 0 0 0c9.1 3.1 15.6 5.3 22.6 5.5c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6c-9-5.4-17.7-14.7-17.7-29.4c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c10 .2 19.7 2.3 27.9 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9zm-272 0c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.3-.4-24.2-4.5-33.2-7.6l0 0 0 0c-1.3-.4-2.5-.8-3.6-1.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4 .5 2.8 .9 4.1 1.4l0 0 0 0c9.5 3.2 16.5 5.6 23.7 5.8c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4 0 0c-7.2-2.2-16.7-5-24.3-9.6C80.8 239 72.1 229.7 72 215c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c9.5 .1 22.2 2.1 31.1 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9z"]
};
var faSms = faCommentSms;
var faRectangle = {
  prefix: 'fas',
  iconName: 'rectangle',
  icon: [512, 512, [9644, "rectangle-landscape"], "f2fa", "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faRectangleLandscape = faRectangle;
var faClipboardListCheck = {
  prefix: 'fas',
  iconName: 'clipboard-list-check',
  icon: [384, 512, [], "f737", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-4.7 132.7c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 249.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0zM192 272c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm-16 80H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTurkey = {
  prefix: 'fas',
  iconName: 'turkey',
  icon: [640, 512, [], "f725", "M472 56c0 22.1-1.2 49.3-19.3 62l-31.6 22.3C375.9 112.2 327.9 96 288 96C176 96 0 224 0 384C0 512 160 512 288 512s288 0 288-128c0-63-27.3-121.1-67.3-168.3c-.4 .2-.7 .4-1 .6l-28.3 20c-8.3 5.9-15.1 15-21.2 28.3c-6.1 13.4-10.5 28.6-15.4 46l-.3 1c-7.9 27.5-24 53-47.9 72.3c-61.8 50-152.5 40.5-202.5-21.4c-13.9-17.2-23.2-36.6-28.1-56.7c-2.3-9.4 5.3-17.9 15-17.9c8 0 14.6 5.8 16.9 13.5c4 14.5 10.9 28.5 21 41c21.3 26.3 52.1 40.5 83.5 41.5c25.9 .8 52.2-7.3 74-24.9c18.6-15 31.1-34.8 37.2-56.2l.6-2c9.6-33.7 20.1-70.5 48.7-90.6L486.7 192s0 0 0 0l2.5-1.8c18.3-12.9 43.3-10.4 67.4-8c9.4 .9 18.6 1.8 27.3 1.8c30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.1 0-2-1.1-1.7-2.2c1.1-4.4 1.7-9 1.7-13.8c0-30.9-25.1-56-56-56s-56 25.1-56 56z"]
};
var faBook = {
  prefix: 'fas',
  iconName: 'book',
  icon: [448, 512, [128212], "f02d", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faUserPlus = {
  prefix: 'fas',
  iconName: 'user-plus',
  icon: [640, 512, [], "f234", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faIceSkate = {
  prefix: 'fas',
  iconName: 'ice-skate',
  icon: [576, 512, [9976], "f7ac", "M512 336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V132.2c0-21.4 14.2-40.3 34.8-46.2L256 32c0-17.7 14.3-32 32-32s32 14.3 32 32V96H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h48l119.3 29.8C482 232.5 512 270.9 512 315v21zm40 72c13.3 0 24 10.7 24 24v8c0 39.8-32.2 72-72 72H408 120 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H96V416h48v48H384V416h48v48h72c13.3 0 24-10.7 24-24v-8c0-13.3 10.7-24 24-24z"]
};
var faCheck = {
  prefix: 'fas',
  iconName: 'check',
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
};
var faBatteryThreeQuarters = {
  prefix: 'fas',
  iconName: 'battery-three-quarters',
  icon: [576, 512, ["battery-4"], "f241", "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm272 96H96V320H352V192z"]
};
var faBattery4 = faBatteryThreeQuarters;
var faTomato = {
  prefix: 'fas',
  iconName: 'tomato',
  icon: [512, 512, [], "e330", "M241 7L224 24C241 7 241 7 241 7l0 0 0 0 .1 .1 .2 .2 .5 .5c.4 .4 1 1 1.7 1.8c1.4 1.5 3.2 3.6 5.4 6.3c4.4 5.4 10.1 13.1 15.8 22.8c6.6 11.2 13.4 25.5 18 42.1c45.7 3.1 88.5 14.2 125.1 32.8c6.6 3.4 10 10.8 8.3 18s-8.2 12.3-15.6 12.3H365.9l15.4 23.1c3.9 5.9 3.5 13.7-1 19.1s-12.1 7.3-18.6 4.5L256 145.4 150.3 190.7c-6.5 2.8-14.1 1-18.6-4.5s-4.9-13.2-1-19.1l15.5-23.3-31.3-.2c-7 1.5-14.3-1.7-17.7-8.4c-4-7.9-.9-17.5 7-21.5l.8-.4C142.2 94.6 185.6 83.5 232 80.7c-2.6-6.4-5.6-12.3-8.7-17.6c-4.3-7.3-8.6-13-11.7-16.9c-1.6-1.9-2.8-3.4-3.6-4.3c-.4-.4-.7-.8-.9-.9l-.1-.1c-9.3-9.4-9.3-24.5 .1-33.9c9.4-9.4 24.6-9.4 33.9 0zM71.1 154c6 9.4 14.9 16.1 25 19.5c-.6 11.8 3.1 23.7 11 33.2c13.6 16.3 36.3 21.8 55.8 13.4L256 180.2l93.1 39.9c19.5 8.4 42.2 2.9 55.8-13.4c7.9-9.5 11.7-21.5 11-33.2c10.3-3.5 19.1-10.4 25-19.5c44 35.5 71.1 86.4 71.1 150c0 130.9-114.6 208-256 208S0 434.9 0 304c0-63.6 27.1-114.5 71.1-150z"]
};
var faSwordLaser = {
  prefix: 'fas',
  iconName: 'sword-laser',
  icon: [512, 512, [], "e03b", "M505 7c9.1 9.1 9.4 23.7 .7 33.2L285.2 281.3l-54.4-54.4L471.8 6.3c9.5-8.7 24.1-8.3 33.2 .7zM195.3 236.7l80 80c6.2 6.2 6.2 16.4 0 22.6c-6.1 6.1-15.8 6.2-22.1 .5l-81-81c-5.8-6.3-5.6-16 .5-22.1c6.2-6.2 16.4-6.2 22.6 0zm-57.7 57.7l23.7-23.7 80 80-23.7 23.7-80-80zm-11.3 11.3l80 80-20.7 20.7-80-80 20.7-20.7zM87 330.3L181.7 425l-2.3 2.3L105 501.7C98.3 508.3 89.4 512 80 512s-18.3-3.7-25-10.3L10.3 457C3.7 450.3 0 441.4 0 432s3.7-18.3 10.3-25l74.3-74.3 2.3-2.3z"]
};
var faHouseCircleCheck = {
  prefix: 'fas',
  iconName: 'house-circle-check',
  icon: [640, 512, [], "e509", "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faBuildings = {
  prefix: 'fas',
  iconName: 'buildings',
  icon: [512, 512, [], "e0cc", "M256 0c-35.3 0-64 28.7-64 64v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256 448c35.3 0 64-28.7 64-64V192 64c0-35.3-28.7-64-64-64H256zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V304zm208 16c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272zm112-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM256 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V80zM400 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM256 208V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400z"]
};
var faAngleLeft = {
  prefix: 'fas',
  iconName: 'angle-left',
  icon: [320, 512, [8249], "f104", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
};
var faCartFlatbedBoxes = {
  prefix: 'fas',
  iconName: 'cart-flatbed-boxes',
  icon: [640, 512, ["dolly-flatbed-alt"], "f475", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM224 32c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224zM416 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32zm32 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448z"]
};
var faDollyFlatbedAlt = faCartFlatbedBoxes;
var faDiagramSuccessor = {
  prefix: 'fas',
  iconName: 'diagram-successor',
  icon: [512, 512, [], "e47a", "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"]
};
var faTruckArrowRight = {
  prefix: 'fas',
  iconName: 'truck-arrow-right',
  icon: [640, 512, [], "e58b", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"]
};
var faSquareW = {
  prefix: 'fas',
  iconName: 'square-w',
  icon: [448, 512, [], "e285", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm54.9 136.7L160 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L224 254.7 182.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z"]
};
var faArrowsSplitUpAndLeft = {
  prefix: 'fas',
  iconName: 'arrows-split-up-and-left',
  icon: [512, 512, [], "e4bc", "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z"]
};
var faLamp = {
  prefix: 'fas',
  iconName: 'lamp',
  icon: [448, 512, [], "f4ca", "M82.5 19.7C87.4 7.8 99.1 0 112 0H336c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1s-15.9 14.2-26.6 14.2H32c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1l80-192zM160 288H288v32s64 50.5 64 112c0 24.4-8.3 44.6-16.4 58.7c-8.5 14.7-25.2 21.3-42.1 21.3h-139c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-61.5 64-112 64-112V288z"]
};
var faAirplay = {
  prefix: 'fas',
  iconName: 'airplay',
  icon: [576, 512, [], "e089", "M480 96H96c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32h69.5l-50.7 50.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128C0 75 43 32 96 32H480c53 0 96 43 96 96V320c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3L410.5 352H480c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zM265.4 297.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"]
};
var faHandFist = {
  prefix: 'fas',
  iconName: 'hand-fist',
  icon: [448, 512, [9994, "fist-raised"], "f6de", "M192 0c17.7 0 32 14.3 32 32V144H160V32c0-17.7 14.3-32 32-32zM64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H64V64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V256c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V401.6c-17.3-7.9-33.2-18.8-46.9-32.5L69.5 357.5C45.5 333.5 32 300.9 32 267V240c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"]
};
var faFistRaised = faHandFist;
var faShieldQuartered = {
  prefix: 'fas',
  iconName: 'shield-quartered',
  icon: [512, 512, [], "e575", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM80 141.4L256 66.8V224H90.1c-6.9-30-9.8-58.5-10.1-82.6zM256 444.8V224H422c-18.5 80.5-65.5 172.2-166 220.8z"]
};
var faSlashForward = {
  prefix: 'fas',
  iconName: 'slash-forward',
  icon: [320, 512, [], "2f", "M303.9 4.2c15.3 8.8 20.7 28.3 11.9 43.7l-256 448c-8.8 15.3-28.3 20.7-43.7 11.9S-4.6 479.5 4.2 464.1l256-448C269 .8 288.5-4.6 303.9 4.2z"]
};
var faLocationPen = {
  prefix: 'fas',
  iconName: 'location-pen',
  icon: [384, 512, ["map-marker-edit"], "f607", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM276.8 107c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L208.6 122 223.5 107c14.7-14.7 38.6-14.7 53.3 0zM114.1 216.5L186 144.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faMapMarkerEdit = faLocationPen;
var faCloudMoon = {
  prefix: 'fas',
  iconName: 'cloud-moon',
  icon: [640, 512, [], "f6c3", "M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"]
};
var faPotFood = {
  prefix: 'fas',
  iconName: 'pot-food',
  icon: [640, 512, [127858], "e43f", "M112 24c0 26.5 10.5 38.7 25.9 56.1l.4 .4C154.8 99 176 122.9 176 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C85.2 93 64 69.1 64 24C64 10.7 74.7 0 88 0s24 10.7 24 24zm112 0c0 26.5 10.5 38.7 25.9 56.1l.4 .4C266.8 99 288 122.9 288 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C197.2 93 176 69.1 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24zm208 88c50.7 0 93.6 33.7 107.4 80H324.6c13.8-46.3 56.6-80 107.4-80zM77.7 320H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H65.9c-.2-17.5 14-32 31.7-32H542.4c17.7 0 31.9 14.5 31.7 32H592c17.7 0 32 14.3 32 32s-14.3 32-32 32H562.3c-20.6 64-66.1 116.7-124.7 147.2l-1.2 9.7c-2.5 20-19.5 35-39.7 35H243.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C143.8 436.7 98.3 384 77.7 320z"]
};
var faBriefcase = {
  prefix: 'fas',
  iconName: 'briefcase',
  icon: [512, 512, [128188], "f0b1", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"]
};
var faPersonFalling = {
  prefix: 'fas',
  iconName: 'person-falling',
  icon: [512, 512, [], "e546", "M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0h-1.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faImagePortrait = {
  prefix: 'fas',
  iconName: 'image-portrait',
  icon: [384, 512, ["portrait"], "f3e0", "M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"]
};
var faPortrait = faImagePortrait;
var faUserTag = {
  prefix: 'fas',
  iconName: 'user-tag',
  icon: [640, 512, [], "f507", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2H178.3zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384zm24 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faRug = {
  prefix: 'fas',
  iconName: 'rug',
  icon: [640, 512, [], "e569", "M24 64H56 80V88v88 80 80 88 24H56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V360H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V200H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0H528V448H112V64zM640 88c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H584 560V424 336 256 176 88 64h24 32c13.3 0 24 10.7 24 24z"]
};
var faPrintSlash = {
  prefix: 'fas',
  iconName: 'print-slash',
  icon: [640, 512, [], "f686", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L522.2 384H544c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H277.2L192 125.2V64H418.7L448 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L464 18.7C452 6.7 435.7 0 418.7 0H192c-35.3 0-64 28.7-64 64V75L38.8 5.1zm459 483.1l-51-40.2H192V384 368 352H324.9L122.2 192.3C89.6 195.2 64 222.6 64 256v96c0 17.7 14.3 32 32 32h32v64c0 35.3 28.7 64 64 64H448c20.1 0 38.1-9.3 49.8-23.8zM496 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faEarthEurope = {
  prefix: 'fas',
  iconName: 'earth-europe',
  icon: [512, 512, ["globe-europe"], "f7a2", "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faGlobeEurope = faEarthEurope;
var faCartFlatbedSuitcase = {
  prefix: 'fas',
  iconName: 'cart-flatbed-suitcase',
  icon: [640, 512, ["luggage-cart"], "f59d", "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32zM432 96V56c0-4.4-3.6-8-8-8H344c-4.4 0-8 3.6-8 8V96h96zM288 96V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56V96 320H288V96zM512 320V96h16c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H512zM240 96h16V320H240c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"]
};
var faLuggageCart = faCartFlatbedSuitcase;
var faHandBackPointRibbon = {
  prefix: 'fas',
  iconName: 'hand-back-point-ribbon',
  icon: [448, 512, [], "e1a0", "M112 128H43.8c-6.5 0-11.8-5.3-11.8-11.8c0-3.9 1.9-7.5 5.1-9.7L75.6 80 37.1 53.5c-3.2-2.2-5.1-5.8-5.1-9.7C32 37.3 37.3 32 43.8 32h69C116.5 13.7 132.6 0 152 0c22.1 0 40 17.9 40 40v8 64 16H176 112zm0 112V160h80v28.2c8.5-7.6 19.7-12.2 32-12.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v32 64c0 70.7-57.3 128-128 128H185.9c-37.4 0-73.7-13.1-102.4-37.1l-5.4-4.5C48.9 446.1 32 410 32 372V334c0-19 8.4-37 23-49.2l19.2-16c1.9-1.6 3.8-3.1 5.8-4.5V320c0 8.8 7.2 16 16 16s16-7.2 16-16V247v-7z"]
};
var faRectangleXmark = {
  prefix: 'fas',
  iconName: 'rectangle-xmark',
  icon: [512, 512, [62164, "rectangle-times", "times-rectangle", "window-close"], "f410", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faRectangleTimes = faRectangleXmark;
var faTimesRectangle = faRectangleXmark;
var faWindowClose = faRectangleXmark;
var faTireRugged = {
  prefix: 'fas',
  iconName: 'tire-rugged',
  icon: [512, 512, [], "f634", "M320 24c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24V40c0 .4 0 .8 0 1.3c-14.9 4.4-29.2 10.4-42.6 17.7c-.3-.3-.6-.6-.9-.9L137.2 46.7c-9.4-9.4-24.6-9.4-33.9 0L46.7 103.3c-9.4 9.4-9.4 24.6 0 33.9L58 148.5c.3 .3 .6 .6 .9 .9c-7.3 13.4-13.2 27.7-17.7 42.6c-.4 0-.8 0-1.3 0H24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24H40c.4 0 .8 0 1.3 0c4.4 14.9 10.4 29.2 17.7 42.6c-.3 .3-.6 .6-.9 .9L46.7 374.8c-9.4 9.4-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0L148.5 454c.3-.3 .6-.6 .9-.9c13.4 7.3 27.7 13.2 42.6 17.7c0 .4 0 .8 0 1.3v16c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V472c0-.4 0-.8 0-1.3c14.9-4.4 29.2-10.4 42.6-17.7c.3 .3 .6 .6 .9 .9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0l56.6-56.6c9.4-9.4 9.4-24.6 0-33.9L454 363.5c-.3-.3-.6-.6-.9-.9c7.3-13.4 13.2-27.7 17.7-42.6c.4 0 .8 0 1.3 0h16c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H472c-.4 0-.8 0-1.3 0c-4.4-14.9-10.4-29.2-17.7-42.6c.3-.3 .6-.6 .9-.9l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9L408.7 46.7c-9.4-9.4-24.6-9.4-33.9 0L363.5 58c-.3 .3-.6 .6-.9 .9c-13.4-7.3-27.7-13.2-42.6-17.7c0-.4 0-.8 0-1.3V24zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-61.1 2.9a24 24 0 1 0 -14.8 45.7 24 24 0 1 0 14.8-45.7zm106.7 30.2a24 24 0 1 0 45.7-14.8 24 24 0 1 0 -45.7 14.8zm-22.7 87.2a24 24 0 1 0 38.8-28.2 24 24 0 1 0 -38.8 28.2zm-51.1-33.5a24 24 0 1 0 -28.2 38.8 24 24 0 1 0 28.2-38.8z"]
};
var faLightbulbDollar = {
  prefix: 'fas',
  iconName: 'lightbulb-dollar',
  icon: [384, 512, [], "f670", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM212 88v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V296c0 11-9 20-20 20s-20-9-20-20V281.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V88c0-11 9-20 20-20s20 9 20 20z"]
};
var faCowbell = {
  prefix: 'fas',
  iconName: 'cowbell',
  icon: [448, 512, [], "f8b3", "M112 96h16V40c0-22.1 17.9-40 40-40H280c22.1 0 40 17.9 40 40V96h16c21.4 0 40.3 14.2 46.2 34.8l64 224c4.1 14.5 1.2 30.1-7.8 42.1s-23.3 19.1-38.3 19.1H48c-15.1 0-29.3-7.1-38.3-19.1s-12-27.6-7.8-42.1l64-224C71.7 110.2 90.6 96 112 96zm160 0V48H176V96h96zm16 352c0 35.3-28.7 64-64 64s-64-28.7-64-64H288z"]
};
var faBahtSign = {
  prefix: 'fas',
  iconName: 'baht-sign',
  icon: [320, 512, [], "e0ac", "M144 0c-17.7 0-32 14.3-32 32V64H37.6C16.8 64 0 80.8 0 101.6V224v41.7V288 406.3c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32zM112 128v96H64V128h48zm64 96V128c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64v96H64V288h48zm64 96V288h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H176z"]
};
var faCorner = {
  prefix: 'fas',
  iconName: 'corner',
  icon: [448, 512, [], "e3fe", "M0 192c0-17.7 14.3-32 32-32H384c35.3 0 64 28.7 64 64V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"]
};
var faChevronsRight = {
  prefix: 'fas',
  iconName: 'chevrons-right',
  icon: [512, 512, ["chevron-double-right"], "f324", "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 233.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192zm-384 192l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"]
};
var faChevronDoubleRight = faChevronsRight;
var faBookOpen = {
  prefix: 'fas',
  iconName: 'book-open',
  icon: [576, 512, [128214, 128366], "f518", "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"]
};
var faBookJournalWhills = {
  prefix: 'fas',
  iconName: 'book-journal-whills',
  icon: [448, 512, ["journal-whills"], "f66a", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.2-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6c-2.7-1.9-6.2 1.4-5 4.5c8.5 22.4 3.6 48-13 65.6c-3.2 3.4-3.6 8.9-.9 12.7c9.8 14 12.7 31.9 7.5 48.5c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-5.1-16.6-2.2-34.4 7.6-48.5c2.7-3.9 2.3-9.3-.9-12.7c-16.6-17.5-21.6-43.1-13.1-65.5c1.2-3.1-2.3-6.4-5-4.5c-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"]
};
var faJournalWhills = faBookJournalWhills;
var faInhaler = {
  prefix: 'fas',
  iconName: 'inhaler',
  icon: [576, 512, [], "f5f9", "M429.8 32.7c-12.7-3.2-25.6 4.4-29 17l-14 51.8L533.2 248 575.2 94.3c1.7-6.2 .8-12.9-2.4-18.4s-8.6-9.6-14.9-11.2l-128-32zM534.1 305.5c1.5-5.5-.1-11.5-4.1-15.5L383.8 143.8c-8.7-8.7-23.6-4.7-26.8 7.2l-16.5 61.2c-1.9 7-8.2 11.8-15.4 11.8H232c-22.1 0-40 17.9-40 40V440c0 22.1 17.9 40 40 40H456c18 0 33.8-12.1 38.6-29.5l39.5-145zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zm0 96A32 32 0 1 0 0 352a32 32 0 1 0 64 0zm64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM64 448A32 32 0 1 0 0 448a32 32 0 1 0 64 0zm64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faHandcuffs = {
  prefix: 'fas',
  iconName: 'handcuffs',
  icon: [640, 512, [], "e4f8", "M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSnake = {
  prefix: 'fas',
  iconName: 'snake',
  icon: [512, 512, [128013], "f716", "M483.4 65.7L403.6 25.8c-30.8-15.4-68-9.4-92.3 15L288 64H176C96.5 64 32 128.5 32 208s64.5 144 144 144H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H256.1l-.1 0H111.6c-10.3 0-20.6 1.7-30.4 4.9l-66 22C6.1 446 0 454.4 0 464s6.1 18 15.2 21.1l66 22c9.8 3.3 20 4.9 30.4 4.9h64.3l.1 0H320c70.7 0 128-57.3 128-128s-57.3-128-128-128H176c-26.5 0-48-21.5-48-48s21.5-48 48-48H288l23.2 23.2c24.3 24.3 61.5 30.4 92.3 15l79.8-39.9c17.5-8.8 28.6-26.7 28.6-46.3s-11.1-37.5-28.6-46.3zM352 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTriangleExclamation = {
  prefix: 'fas',
  iconName: 'triangle-exclamation',
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faExclamationTriangle = faTriangleExclamation;
var faWarning = faTriangleExclamation;
var faNoteMedical = {
  prefix: 'fas',
  iconName: 'note-medical',
  icon: [448, 512, [], "e200", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320H336c-26.5 0-48 21.5-48 48V480H64c-35.3 0-64-28.7-64-64V96zM402.7 352H448l-32 32-64 64-32 32V434.7 368c0-8.8 7.2-16 16-16h66.7zM192 144v48H144c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H256V144c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z"]
};
var faDatabase = {
  prefix: 'fas',
  iconName: 'database',
  icon: [448, 512, [], "f1c0", "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"]
};
var faDownLeft = {
  prefix: 'fas',
  iconName: 'down-left',
  icon: [384, 512, [], "e16a", "M48 432H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-72-72L372.7 171.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L331.3 75.3C324.1 68.1 314.2 64 304 64s-20.1 4.1-27.3 11.3L142.6 209.4l-72-72c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6V400c0 17.7 14.3 32 32 32z"]
};
var faShare = {
  prefix: 'fas',
  iconName: 'share',
  icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"]
};
var faArrowTurnRight = faShare;
var faMailForward = faShare;
var faFaceThinking = {
  prefix: 'fas',
  iconName: 'face-thinking',
  icon: [512, 512, [], "e39b", "M512 256c0 141.4-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9c4-5.7 7.3-12 9.8-18.8l21-57.7 35.8-13c23.9-8.7 38.3-32 36.8-56.1c-1.3-24.4-16.5-46.1-39.2-55.6L166.2 257.3c-8.1-3.4-17.5 .4-21 8.5s.4 17.5 8.5 21l82.4 34.7L144 355v-3c0-30.9-25.1-56-56-56s-56 25.1-56 56v28C11.6 343.3 0 301 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4zM112 352v48.6l151.8-55.2c12.5-4.5 26.2 1.9 30.8 14.4s-1.9 26.2-14.4 30.8l-49.8 18.1-26.1 71.7c-6.9 19-24.9 31.6-45.1 31.6H112c-26.5 0-48-21.5-48-48V352c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faTurnDownRight = {
  prefix: 'fas',
  iconName: 'turn-down-right',
  icon: [512, 512, [], "e455", "M334.5 446c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 88-192 0c-17.7 0-32-14.3-32-32L96 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64L0 208c0 70.7 57.3 128 128 128l192 0 0 88c0 9.6 5.7 18.2 14.5 22z"]
};
var faBottleDroplet = {
  prefix: 'fas',
  iconName: 'bottle-droplet',
  icon: [320, 512, [], "e4c4", "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 0 0 0H104l0 0 0 0L96 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C185.9 288.9 208 320.2 208 337c0 24.9-21.5 45-48 45z"]
};
var faMaskFace = {
  prefix: 'fas',
  iconName: 'mask-face',
  icon: [640, 512, [], "e1d7", "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H144 128 56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512 496h-9.2c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3V176h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faHillRockslide = {
  prefix: 'fas',
  iconName: 'hill-rockslide',
  icon: [576, 512, [], "e508", "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2H293.4c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9V309.4c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faScannerKeyboard = {
  prefix: 'fas',
  iconName: 'scanner-keyboard',
  icon: [512, 512, [], "f489", "M152 0h16c13.3 0 24 10.7 24 24V64H128V24c0-13.3 10.7-24 24-24zM312 0h16c13.3 0 24 10.7 24 24V64H288V24c0-13.3 10.7-24 24-24zM224 16c0-8.8 7.2-16 16-16s16 7.2 16 16V64H224V16zM400 0c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zm48 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24H472c-13.3 0-24-10.7-24-24V24zM0 160c0-35.3 28.7-64 64-64H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm64 24v16c0 13.3 10.7 24 24 24H264c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm0 120v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80zm112-80v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208z"]
};
var faCircleO = {
  prefix: 'fas',
  iconName: 'circle-o',
  icon: [512, 512, [], "e119", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
var faGridHorizontal = {
  prefix: 'fas',
  iconName: 'grid-horizontal',
  icon: [448, 512, [], "e307", "M128 168c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V168zm0 160c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-160v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-160v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"]
};
var faMessageDollar = {
  prefix: 'fas',
  iconName: 'message-dollar',
  icon: [512, 512, ["comment-alt-dollar"], "f650", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm276 40c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"]
};
var faCommentAltDollar = faMessageDollar;
var faRightLeft = {
  prefix: 'fas',
  iconName: 'right-left',
  icon: [512, 512, ["exchange-alt"], "f362", "M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64H480z"]
};
var faExchangeAlt = faRightLeft;
var faColumns3 = {
  prefix: 'fas',
  iconName: 'columns-3',
  icon: [640, 512, [], "e361", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 96V416H64V96H192zm64 0H384V416H256V96zm320 0V416H448V96H576z"]
};
var faPaperPlane = {
  prefix: 'fas',
  iconName: 'paper-plane',
  icon: [512, 512, [61913], "f1d8", "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"]
};
var faRoadCircleExclamation = {
  prefix: 'fas',
  iconName: 'road-circle-exclamation',
  icon: [640, 512, [], "e565", "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faDungeon = {
  prefix: 'fas',
  iconName: 'dungeon',
  icon: [512, 512, [], "f6d9", "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H408zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H408zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"]
};
var faHandHoldingBox = {
  prefix: 'fas',
  iconName: 'hand-holding-box',
  icon: [576, 512, [], "f47b", "M224 121.7c0 3.5 2.8 6.3 6.3 6.3c1.1 0 2.2-.3 3.1-.8l46.6-26.6c4.9-2.8 11-2.8 15.9 0l46.6 26.6c1 .5 2 .8 3.1 .8c3.5 0 6.3-2.8 6.3-6.3V0h80c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48h80V121.7zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faInputText = {
  prefix: 'fas',
  iconName: 'input-text',
  icon: [640, 512, [], "e1bf", "M64 128V384H576V128H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7H146.3l-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3zm0 83.1L167.6 280h32.8L184 243.1zM304 184c0-13.3 10.7-24 24-24h52c33.1 0 60 26.9 60 60c0 9.2-2.1 17.9-5.8 25.7c13.3 11 21.8 27.6 21.8 46.3c0 33.1-26.9 60-60 60H328c-13.3 0-24-10.7-24-24v-8V256 192v-8zm48 24v24h28c6.6 0 12-5.4 12-12s-5.4-12-12-12H352zm0 96h44c6.6 0 12-5.4 12-12s-5.4-12-12-12H380 352v24z"]
};
var faWindowFlip = {
  prefix: 'fas',
  iconName: 'window-flip',
  icon: [512, 512, ["window-alt"], "f40f", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faWindowAlt = faWindowFlip;
var faAlignRight = {
  prefix: 'fas',
  iconName: 'align-right',
  icon: [448, 512, [], "f038", "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
};
var faScannerGun = {
  prefix: 'fas',
  iconName: 'scanner-gun',
  icon: [576, 512, ["scanner"], "f488", "M112 32C50.1 32 0 82.1 0 144c0 50.7 33.8 93.6 80 107.4L8.1 374.7c-13.3 22.8-5.7 52.2 17.1 65.6l53.4 31.4c22.8 13.4 52.3 5.8 65.7-17L261.2 256H304c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H112zm328 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H440zM416 216v16c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zm24 200c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H440zM416 144c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16zm16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432zm-16 80c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16z"]
};
var faScanner = faScannerGun;
var faTire = {
  prefix: 'fas',
  iconName: 'tire',
  icon: [512, 512, [], "f631", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-16.1 62l0 65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6zm47.9-58l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4zm-40.2-63.5l38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5s16.3 1.6 23.6 4.5zM168.3 162.7C143.5 186.1 128 219.2 128 256c0 8.3 .8 16.3 2.3 24.2L192.1 260c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7zm33.7 127.7l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4l0-65c-15.8-4.1-29.3-14.1-37.9-27.5zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z"]
};
var faEngine = {
  prefix: 'fas',
  iconName: 'engine',
  icon: [640, 512, [], "e16e", "M400 112c13.3 0 24-10.7 24-24s-10.7-24-24-24H208c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0v32H208 160 128c-17.7 0-32 14.3-32 32v56H48V160c0-13.3-10.7-24-24-24s-24 10.7-24 24V352c0 13.3 10.7 24 24 24s24-10.7 24-24V280H96v72c0 17.7 14.3 32 32 32h44.8l32 40c12.1 15.2 30.5 24 50 24H448c35.3 0 64-28.7 64-64V238.8c0-19.4-8.8-37.8-24-50L449.5 158c-11.3-9.1-25.4-14-40-14H328V112l72 0zM288 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192-32c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H576z"]
};
var faMoneyBill1Wave = {
  prefix: 'fas',
  iconName: 'money-bill-1-wave',
  icon: [576, 512, ["money-bill-wave-alt"], "f53b", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416H64V352c35.3 0 64 28.7 64 64zM64 224V160h64c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"]
};
var faMoneyBillWaveAlt = faMoneyBill1Wave;
var faLifeRing = {
  prefix: 'fas',
  iconName: 'life-ring',
  icon: [512, 512, [], "f1cd", "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faHands = {
  prefix: 'fas',
  iconName: 'hands',
  icon: [576, 512, ["sign-language", "signing"], "f2a7", "M544 160l-.1 72.6c-.1 52.2-24 101-64 133.1c.1-1.9 .1-3.8 .1-5.7v-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4L248.7 48.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8 0 0 0 0 43.3 75L480 160c0-17.7 14.4-32 32-32s32 14.4 32 32zM243.9 88.5L268.5 131c-13.9 4.5-26.4 13.7-34.7 27c-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7l26.8 46.4c.6 6 2.1 11.8 4.3 17.4H224 210.7l0 0H179l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zM260.9 175c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352v8c0 83.9-68.1 152-152 152H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h92c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H224l0 0 0 0h93.2L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z"]
};
var faSignLanguage = faHands;
var faSigning = faHands;
var faCircleCaretRight = {
  prefix: 'fas',
  iconName: 'circle-caret-right',
  icon: [512, 512, ["caret-circle-right"], "f330", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm368 0c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"]
};
var faCaretCircleRight = faCircleCaretRight;
var faWheat = {
  prefix: 'fas',
  iconName: 'wheat',
  icon: [512, 512, [], "f72d", "M472 0c-48.6 0-88 39.4-88 88v24c0 8.8 7.2 16 16 16h24c48.6 0 88-39.4 88-88V16c0-8.8-7.2-16-16-16H472zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9L305.5 27.3z"]
};
var faFileSpreadsheet = {
  prefix: 'fas',
  iconName: 'file-spreadsheet',
  icon: [384, 512, [], "f65b", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM88 224H296c17.7 0 32 14.3 32 32v16 80 64c0 17.7-14.3 32-32 32H232 152 88c-17.7 0-32-14.3-32-32V352 272 256c0-17.7 14.3-32 32-32zm0 112h48V288H88v48zm80 0h48V288H168v48zm80 0h48V288H248v48zm0 32v48h48V368H248zm-32 0H168v48h48V368zm-80 0H88v48h48V368z"]
};
var faAudioDescriptionSlash = {
  prefix: 'fas',
  iconName: 'audio-description-slash',
  icon: [640, 512, [], "e0a8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM336 238V184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96c0 35.3-19 66.1-47.4 82.8l-44.6-35c24.7-2 44.1-22.7 44.1-47.8c0-26.5-21.5-48-48-48H384v67.7L336 238zM487.4 480L314.3 343.6c-2 2.4-4.6 4.4-7.5 5.9c-11.9 5.9-26.3 1.1-32.2-10.7l-9.4-18.9H182.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l42.5-85L32 121.2V416c0 35.3 28.7 64 64 64H487.4zm-254-200.2l-21.8-17.2-8.6 17.2h30.4z"]
};
var faCalendarDay = {
  prefix: 'fas',
  iconName: 'calendar-day',
  icon: [448, 512, [], "f783", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"]
};
var faWaterLadder = {
  prefix: 'fas',
  iconName: 'water-ladder',
  icon: [576, 512, ["ladder-water", "swimming-pool"], "f5c5", "M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V224H384V127.7C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3h0V288H192v96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1V127.7zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faLadderWater = faWaterLadder;
var faSwimmingPool = faWaterLadder;
var faArrowsUpDown = {
  prefix: 'fas',
  iconName: 'arrows-up-down',
  icon: [320, 512, ["arrows-v"], "f07d", "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"]
};
var faArrowsV = faArrowsUpDown;
var faChessPawnPiece = {
  prefix: 'fas',
  iconName: 'chess-pawn-piece',
  icon: [256, 512, ["chess-pawn-alt"], "f444", "M176 240c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h5.7L64 384H192l-13.7-96H184c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8zM4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48L4.8 473.6z"]
};
var faChessPawnAlt = faChessPawnPiece;
var faFaceGrimace = {
  prefix: 'fas',
  iconName: 'face-grimace',
  icon: [512, 512, [128556, "grimace"], "f57f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-112h-8V360l55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344V304h8c23.8 0 43.5 17.3 47.3 40zM328 344H264V304h64v40zm0 56H264V360h64v40zm-80-96v40l-64 0V304h64zm0 56v40H184V360l64 0zm-80-16H112.7c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGrimace = faFaceGrimace;
var faWheelchairMove = {
  prefix: 'fas',
  iconName: 'wheelchair-move',
  icon: [448, 512, ["wheelchair-alt"], "e2ce", "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faWheelchairAlt = faWheelchairMove;
var faTurnDown = {
  prefix: 'fas',
  iconName: 'turn-down',
  icon: [384, 512, [10549, "level-down-alt"], "f3be", "M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26s12.5-14.5 22-14.5h88l0-192c0-17.7-14.3-32-32-32H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0l80 0c70.7 0 128 57.3 128 128l0 192h88c9.6 0 18.2 5.7 22 14.5z"]
};
var faLevelDownAlt = faTurnDown;
var faSquareS = {
  prefix: 'fas',
  iconName: 'square-s',
  icon: [448, 512, [], "e27d", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6 0 0c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z"]
};
var faRectangleBarcode = {
  prefix: 'fas',
  iconName: 'rectangle-barcode',
  icon: [576, 512, ["barcode-alt"], "f463", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 96c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm56 16c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm88-16c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm88 24c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm112-24c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z"]
};
var faBarcodeAlt = faRectangleBarcode;
var faPersonWalkingArrowRight = {
  prefix: 'fas',
  iconName: 'person-walking-arrow-right',
  icon: [640, 512, [], "e552", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"]
};
var faSquareEnvelope = {
  prefix: 'fas',
  iconName: 'square-envelope',
  icon: [448, 512, ["envelope-square"], "f199", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"]
};
var faEnvelopeSquare = faSquareEnvelope;
var faDice = {
  prefix: 'fas',
  iconName: 'dice',
  icon: [640, 512, [127922], "f522", "M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H461.7c11.6 36 3.1 77-25.4 105.5L320 413.8V448zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faUnicorn = {
  prefix: 'fas',
  iconName: 'unicorn',
  icon: [640, 512, [129412], "f727", "M448 160v78.1V240h0c-.5 30-12.8 56.4-32 75.7V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V346.7c-4.1-.7-8.2-1.6-12.3-2.8l-84-24c.2 2.3 .3 4.6 .3 6.9c0 18.6-7.4 36.5-20.6 49.7l-12.7 12.7c-4.8 4.8-6.4 11.8-4.3 18.2l20.8 62.5c6.9 20.7-8.5 42.1-30.4 42.1H143.1c-13.8 0-26-8.8-30.4-21.9L95.3 437.7c-10.6-31.7-6.5-65.9 10-93.9c7.6-12.9 9.5-29.1 1.2-41.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4C54.6 230.8 48 242.6 48 256v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-44.6 33.2-81.5 76.3-87.2c14.9-24.4 41.8-40.8 72.5-40.8h54.4H224h96C320 57.3 377.3 0 448 0h16 16 64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-5.7c5.2 4.6 9.6 10 13.1 16h79.3c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8L560 90.7v64.8c0 22.1-13.4 41.9-33.9 50.1c-26.1 10.4-55.7-.9-68.3-26L448 160zm64-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faBowlingBall = {
  prefix: 'fas',
  iconName: 'bowling-ball',
  icon: [512, 512, [], "f436", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPompebled = {
  prefix: 'fas',
  iconName: 'pompebled',
  icon: [512, 512, [], "e43d", "M460.3 172c-46.2-33.2-117-14.1-165.1 44.3c-5.9 8.6-17.2 10.6-25.6 4.5s-10.3-17.6-4.4-26.2c36.9-66.9 29-141.3-17.7-173.5C188.6-20.6 103.1 1.5 56.9 70.4c-85.5 126.3-77.6 313.4 44.2 400.4c121.4 87 296.3 27.7 381.8-98.6c46.2-68.4 36.4-158.5-22.6-200.2z"]
};
var faBrain = {
  prefix: 'fas',
  iconName: 'brain',
  icon: [512, 512, [129504], "f5dc", "M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"]
};
var faWatchSmart = {
  prefix: 'fas',
  iconName: 'watch-smart',
  icon: [384, 512, [], "e2cc", "M64 48H320c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48zM80 80C35.8 80 0 115.8 0 160V352c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80H80zm136 80v86.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17V160c0-13.3 10.7-24 24-24s24 10.7 24 24zM112 512H272c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48z"]
};
var faBookUser = {
  prefix: 'fas',
  iconName: 'book-user',
  icon: [448, 512, [], "f7e7", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM304 128a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM128 304c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H208c-44.2 0-80 35.8-80 80z"]
};
var faSensorCloud = {
  prefix: 'fas',
  iconName: 'sensor-cloud',
  icon: [640, 512, ["sensor-smoke"], "e02c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H234.8c-6.9-14.5-10.8-30.8-10.8-48c0-44.7 26.2-83.3 64.1-101.3C290.9 271.3 339.9 224 400 224c17.2 0 33.5 3.9 48 10.8V96c0-35.3-28.7-64-64-64H64zm48 88V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zM336 512H560c44.2 0 80-35.8 80-80c0-39-27.9-71.5-64.8-78.6c.5-3.1 .8-6.2 .8-9.4c0-30.9-25.1-56-56-56c-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C284.4 359.9 256 392.6 256 432c0 44.2 35.8 80 80 80z"]
};
var faSensorSmoke = faSensorCloud;
var faClapperboardPlay = {
  prefix: 'fas',
  iconName: 'clapperboard-play',
  icon: [512, 512, [], "e132", "M453.8 32.3L327 159l-1 1H233.9L361 33l1-1H448c2 0 3.9 .1 5.8 .3zM393.9 160L498 56c8.8 11 14 24.9 14 40v64H393.9zM201.9 32h92.1L167 159l-1 1H73.9L201 33l1-1zm-67.9 0L7 159l-1 1H0V96C0 60.7 28.7 32 64 32h70.1zM0 192H512V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm216.5 65.9c-5.2 2.8-8.5 8.2-8.5 14.1V400c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l96-64c4.4-3 7.1-8 7.1-13.3s-2.7-10.3-7.1-13.3l-96-64c-4.9-3.3-11.2-3.6-16.4-.8z"]
};
var faBandage = {
  prefix: 'fas',
  iconName: 'bandage',
  icon: [640, 512, [129657, "band-aid"], "f462", "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faBandAid = faBandage;
var faCalendarMinus = {
  prefix: 'fas',
  iconName: 'calendar-minus',
  icon: [512, 512, [], "f272", "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zM344 376c13.3 0 24-10.7 24-24s-10.7-24-24-24H168c-13.3 0-24 10.7-24 24s10.7 24 24 24H344z"]
};
var faCircleXmark = {
  prefix: 'fas',
  iconName: 'circle-xmark',
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faTimesCircle = faCircleXmark;
var faXmarkCircle = faCircleXmark;
var faCircle4 = {
  prefix: 'fas',
  iconName: 'circle-4',
  icon: [512, 512, [], "e0f1", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM223.6 129.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10H272v40c0 13.3 10.7 24 24 24s24-10.7 24-24V320h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H201.3l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z"]
};
var faGifts = {
  prefix: 'fas',
  iconName: 'gifts',
  icon: [640, 512, [], "f79c", "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H200.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96H217.8l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80H416V256h32v96H640V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48H416V384H224v80zm224 48H592c26.5 0 48-21.5 48-48V384H448V512zm96-312c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"]
};
var faAlbumCollection = {
  prefix: 'fas',
  iconName: 'album-collection',
  icon: [512, 512, [], "f8a0", "M32 24c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C42.7 0 32 10.7 32 24zM48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214l32 256c3 24 23.4 42 47.6 42H432c24.2 0 44.6-18 47.6-42l32-256c1.7-13.7-2.5-27.4-11.6-37.7s-22.2-16.2-36-16.2H48zM440 344c0 75.1-82.4 136-184 136S72 419.1 72 344s82.4-136 184-136s184 60.9 184 136zM256 376c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H472c13.3 0 24-10.7 24-24s-10.7-24-24-24H40z"]
};
var faHotel = {
  prefix: 'fas',
  iconName: 'hotel',
  icon: [512, 512, [127976], "f594", "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64C14.3 64 0 49.7 0 32zm96 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM240 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H240zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H368zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8H328z"]
};
var faEarthAsia = {
  prefix: 'fas',
  iconName: 'earth-asia',
  icon: [512, 512, [127759, "globe-asia"], "f57e", "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"]
};
var faGlobeAsia = faEarthAsia;
var faIdCardClip = {
  prefix: 'fas',
  iconName: 'id-card-clip',
  icon: [576, 512, ["id-card-alt"], "f47f", "M256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64H192v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faIdCardAlt = faIdCardClip;
var faMagnifyingGlassPlus = {
  prefix: 'fas',
  iconName: 'magnifying-glass-plus',
  icon: [512, 512, ["search-plus"], "f00e", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faSearchPlus = faMagnifyingGlassPlus;
var faThumbsUp = {
  prefix: 'fas',
  iconName: 'thumbs-up',
  icon: [512, 512, [128077, 61575], "f164", "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]
};
var faCloudShowers = {
  prefix: 'fas',
  iconName: 'cloud-showers',
  icon: [512, 512, [], "f73f", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm16 32c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24zm192 0c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24zm-72 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V408c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V408c0-13.3 10.7-24 24-24z"]
};
var faUserClock = {
  prefix: 'fas',
  iconName: 'user-clock',
  icon: [640, 512, [], "f4fd", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"]
};
var faOnion = {
  prefix: 'fas',
  iconName: 'onion',
  icon: [448, 512, [129477], "e427", "M216.8 17.7l-3.4-6.8C210.1 4.2 203.3 0 195.8 0c-10.9 0-19.6 9-21.3 19.8C167 67.8 132 96.2 95.3 126C49 163.7 0 203.5 0 288c0 80.4 58 135.2 131.9 160.3l-10.7 32.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2L178.6 460c7.1 1.2 14.2 2.1 21.4 2.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24V462.7c7.2-.7 14.3-1.6 21.4-2.7l11.9 35.6c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-10.7-32.1C390 423.2 448 368.4 448 288c0-84.5-49-124.3-95.3-162C316 96.2 281 67.8 273.5 19.8C271.8 9 263.1 0 252.2 0c-7.5 0-14.3 4.2-17.7 10.9l-3.4 6.8c-2.9 5.9-11.4 5.9-14.3 0zM97 186.2l.4-.9c.4-.8 .8-1.5 1.2-2.2c2.5-3.8 6.6-6.4 11.3-6.9c1.9-.2 3.8-.1 5.6 .3s3.6 1.2 5.2 2.2c3.9 2.6 6.4 6.8 7 11.2c.3 1.9 .2 3.9-.3 5.9c-.3 1.3-.8 2.5-1.3 3.6l-.3 .7c-.3 .6-.8 1.6-1.4 2.9c-1.2 2.6-2.9 6.4-4.9 11.2c-4 9.6-9 23-13.3 38.2c-8.8 31.3-13.5 67.1-3.4 94c3.1 8.3-1.1 17.5-9.4 20.6s-17.5-1.1-20.6-9.4c-13.9-37-6.6-81.3 2.6-114c4.7-16.7 10.2-31.4 14.5-41.8c2.2-5.2 4-9.4 5.4-12.3c.7-1.5 1.2-2.6 1.6-3.4zM209 122.5c.3-.9 .8-1.8 1.3-2.7c1.2-2.1 2.9-3.8 4.8-5c3.4-2.3 7.7-3.3 11.9-2.5c1.9 .4 3.7 1 5.2 2c2 1.2 3.7 2.9 5 4.8s2.2 4.1 2.6 6.4c.3 1.8 .3 3.7-.1 5.5c-.2 1.1-.5 2.2-1 3.3l0 .1-.5 1.3c-.4 1.1-1.1 2.8-1.9 5c-1.6 4.4-4 10.9-6.6 18.9c-5.4 16.2-12.2 38.7-18.1 64c-11.9 51.7-18.9 111.9-4.4 155.3c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1c-17.5-52.5-8.5-120.3 3.6-172.7c6.1-26.6 13.3-50.1 18.9-67c2.8-8.4 5.2-15.2 7-19.9c.9-2.4 1.6-4.2 2.1-5.4l.6-1.5 .1-.1zM288 160c0-8.8 7.2-16 16-16c.1 0 .2 0 .2 0c.1 0 .2 0 .4 0c5.8-.2 11.6 2.7 14.6 8.2l-1 .6 0 0c1-.5 1-.5 1-.5l0 0 0 0 0 .1 .2 .3 .6 1.1c.5 .9 1.2 2.2 2.1 3.9c1.8 3.4 4.2 8.3 7.1 14.3c5.7 12.1 13.1 29.2 19.8 48.9c13.1 38.7 24.5 90.6 11.7 135.5c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8c10-35.1 1.4-79.2-11.2-116.5c-6.2-18.3-13.1-34.2-18.4-45.6c-2.7-5.7-4.9-10.2-6.5-13.2l-.1-.1c-3.5-2.9-5.7-7.3-5.7-12.2z"]
};
var faClockTwelveThirty = {
  prefix: 'fas',
  iconName: 'clock-twelve-thirty',
  icon: [512, 512, [], "e359", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-360V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faArrowDownToDottedLine = {
  prefix: 'fas',
  iconName: 'arrow-down-to-dotted-line',
  icon: [448, 512, [], "e095", "M374.6 214.6l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 242.7V176 64c0-17.7 14.3-32 32-32s32 14.3 32 32V176v66.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faHandDots = {
  prefix: 'fas',
  iconName: 'hand-dots',
  icon: [512, 512, ["allergies"], "f461", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faAllergies = faHandDots;
var faFileInvoice = {
  prefix: 'fas',
  iconName: 'file-invoice',
  icon: [384, 512, [], "f570", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faWindowMinimize = {
  prefix: 'fas',
  iconName: 'window-minimize',
  icon: [512, 512, [128469], "f2d1", "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faRectangleWide = {
  prefix: 'fas',
  iconName: 'rectangle-wide',
  icon: [640, 512, [], "f2fc", "M0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faCommentArrowUp = {
  prefix: 'fas',
  iconName: 'comment-arrow-up',
  icon: [512, 512, [], "e144", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm24-120c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V328z"]
};
var faGarlic = {
  prefix: 'fas',
  iconName: 'garlic',
  icon: [512, 512, [129476], "e40e", "M83.4 169.1C42.3 200.5 0 232.7 0 288C0 392.6 85.5 411.7 116.7 415.2C85 390.5 64 352.6 64 304c0-27.8 4.3-48.7 11-66.5c5.9-15.6 13.6-28.6 20.7-40.5c.8-1.4 1.7-2.8 2.5-4.2c7.8-13.2 15.1-26.2 20.5-43.3c1.2-3.7 2.3-7.7 3.3-11.9c-11.7 10.9-25.1 21.1-38.7 31.5zM384 416s128 0 128-128c0-55.3-42.3-87.5-83.4-118.9C389.8 139.5 352 110.6 352 64V48c0-26.5-21.5-48-48-48H288V80c0 30.2 4.7 51.9 11.4 69c6.7 17.1 15.7 30.3 25.5 43.8c1.2 1.6 2.4 3.3 3.6 4.9l0 0 0 0c19 25.8 39.4 53.5 39.4 106.3c0 49.2-21.5 87.3-53.7 112H384zM256 80V0H208c-26.5 0-48 21.5-48 48V64 80c0 33.4-4.2 58.5-10.8 79.2c-6.6 20.7-15.3 36.2-23.5 49.9l-2.5 4.2c-7.2 12.1-13.5 22.6-18.3 35.5c-5.3 13.9-9 31-9 55.2c0 69.3 54.9 112 120 112s120-42.7 120-112c0-42.1-15-62.5-33.5-87.7l0 0 0-.1c-1.1-1.5-2.2-3.1-3.4-4.6c-10.2-13.9-21.2-29.8-29.5-50.9C261.3 139.5 256 113.8 256 80zM136 448v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H136zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H200zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H264zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H328z"]
};
var faMugSaucer = {
  prefix: 'fas',
  iconName: 'mug-saucer',
  icon: [640, 512, ["coffee"], "f0f4", "M96 64c0-17.7 14.3-32 32-32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zM480 224h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H480V224zM32 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faCoffee = faMugSaucer;
var faBrush = {
  prefix: 'fas',
  iconName: 'brush',
  icon: [384, 512, [], "f55d", "M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48V224v22.4V256H9.6 374.4 384v-9.6V224 48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTreeDecorated = {
  prefix: 'fas',
  iconName: 'tree-decorated',
  icon: [448, 512, [], "f7dc", "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L28.5 313.7c-2.9 4.1-4.5 9-4.5 14.1C24 341.1 34.8 352 48.2 352H80L3.8 474c-2.5 4-3.8 8.5-3.8 13.2C0 500.9 11.1 512 24.9 512H423.1c13.7 0 24.9-11.1 24.9-24.9c0-4.7-1.3-9.2-3.8-13.2L368 352h31.8c13.4 0 24.2-10.9 24.2-24.2c0-5-1.6-10-4.5-14.1L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9zM160 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faMask = {
  prefix: 'fas',
  iconName: 'mask',
  icon: [576, 512, [], "f6fa", "M288 64C64 64 0 160 0 272S80 448 176 448h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4H400c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faCalendarHeart = {
  prefix: 'fas',
  iconName: 'calendar-heart',
  icon: [448, 512, [], "e0d3", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM112 317.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faMagnifyingGlassMinus = {
  prefix: 'fas',
  iconName: 'magnifying-glass-minus',
  icon: [512, 512, ["search-minus"], "f010", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"]
};
var faSearchMinus = faMagnifyingGlassMinus;
var faFlower = {
  prefix: 'fas',
  iconName: 'flower',
  icon: [448, 512, [127804, 10047], "f7ff", "M128 480c38.2 0 72.5-16.8 96-43.3c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128c0-38.2-16.8-72.5-43.3-96c26.6-23.5 43.3-57.8 43.3-96c0-70.7-57.3-128-128-128c-38.2 0-72.5 16.8-96 43.3C200.5 48.8 166.2 32 128 32C57.3 32 0 89.3 0 160c0 38.2 16.8 72.5 43.3 96C16.8 279.5 0 313.8 0 352c0 70.7 57.3 128 128 128zm96-304a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faRightLeftLarge = {
  prefix: 'fas',
  iconName: 'right-left-large',
  icon: [640, 512, [], "e5e1", "M184.4 512c-19 0-37.2-7.5-50.6-21L15 372.3C5.4 362.7 0 349.6 0 336s5.4-26.7 15-36.3L133.8 181c13.4-13.4 31.6-21 50.6-21c37 0 67.4 28 71.2 64H320h96 16c8.8 0 16 7.2 16 16v16 24.4c0 4.2 3.4 7.6 7.6 7.6c2 0 3.9-.8 5.4-2.2L570.7 176 461 66.2c-1.4-1.4-3.4-2.2-5.4-2.2c-4.2 0-7.6 3.4-7.6 7.6V96v16c0 8.8-7.2 16-16 16H416 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h64.4c3.8-36 34.2-64 71.2-64c19 0 37.2 7.5 50.6 21L625 139.7c9.6 9.6 15 22.7 15 36.3s-5.4 26.7-15 36.3L506.2 331c-13.4 13.4-31.6 21-50.6 21c-37 0-67.4-28-71.2-64H320 224 208c-8.8 0-16-7.2-16-16V256 231.6c0-4.2-3.4-7.6-7.6-7.6c-2 0-3.9 .8-5.4 2.2L69.3 336 179 445.8c1.4 1.4 3.4 2.2 5.4 2.2c4.2 0 7.6-3.4 7.6-7.6V416 400c0-8.8 7.2-16 16-16h16 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H255.6c-3.8 36-34.2 64-71.2 64z"]
};
var faRulerVertical = {
  prefix: 'fas',
  iconName: 'ruler-vertical',
  icon: [256, 512, [], "f548", "M0 48C0 21.5 21.5 0 48 0H208c26.5 0 48 21.5 48 48V96H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"]
};
var faCirclesOverlap = {
  prefix: 'fas',
  iconName: 'circles-overlap',
  icon: [640, 512, [], "e600", "M192 288c0 34.2 7.7 66.6 21.4 95.7C130 378.2 64 308.8 64 224c0-88.4 71.6-160 160-160c32.2 0 62.2 9.5 87.3 25.9C240.4 127.5 192 202.1 192 288zm32 160c11.2 0 22.1-.8 32.8-2.4c40.6 41 96.9 66.4 159.2 66.4c123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1 .8-32.8 2.4C342.6 25.4 286.3 0 224 0C100.3 0 0 100.3 0 224S100.3 448 224 448zm192 0c-32.2 0-62.2-9.5-87.3-25.9C399.6 384.5 448 309.9 448 224c0-34.2-7.7-66.6-21.4-95.7C510 133.8 576 203.2 576 288c0 88.4-71.6 160-160 160z"]
};
var faUserLarge = {
  prefix: 'fas',
  iconName: 'user-large',
  icon: [512, 512, ["user-alt"], "f406", "M256 288A144 144 0 1 0 256 0a144 144 0 1 0 0 288zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H481.3c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320H161.3z"]
};
var faUserAlt = faUserLarge;
var faStarshipFreighter = {
  prefix: 'fas',
  iconName: 'starship-freighter',
  icon: [576, 512, [], "e03a", "M224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l207.9 80.9c12.3 4.8 20.4 16.6 20.4 29.8V208c0 8.8-7.2 16-16 16H445.7 432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h13.7H560c8.8 0 16 7.2 16 16v42.1c0 13.2-8.1 25-20.4 29.8l-82.1 31.9c4.1 7.1 6.5 15.3 6.5 24.1c0 26.5-21.5 48-48 48H352c-11.5 0-21.6-6.1-27.3-15.2C292.2 474.9 258.2 480 224 480zm0-272a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faTrainTram = {
  prefix: 'fas',
  iconName: 'train-tram',
  icon: [448, 512, [128650], "e5b4", "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0H361.2c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15H248V96h40c53 0 96 43 96 96V352c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1H365.3c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48H86.8zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBridgeSuspension = {
  prefix: 'fas',
  iconName: 'bridge-suspension',
  icon: [640, 512, [], "e4cd", "M128 8c9.1 0 17 5 21.1 12.5C184.2 81.6 249.7 120 320 120s135.8-38.4 170.9-99.5C495 13 502.9 8 512 8c8.8 0 16.5 4.7 20.7 11.8c13.1 21.2 26.6 42.2 42 59.8c15.5 17.7 31.7 30.6 49.4 36.9c12.5 4.5 18.9 18.2 14.4 30.7s-18.2 18.9-30.7 14.4c-25.5-9.2-46.4-25.8-63.9-44.5V256h64c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32c-35.3 0-64 28.7-64 64v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V448c0-53-43-96-96-96H288c-53 0-96 43-96 96v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-35.3-28.7-64-64-64c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32H96V117.1c-17.4 18.7-38.4 35.3-63.9 44.5c-12.5 4.5-26.2-2-30.7-14.4s2-26.2 14.4-30.7c17.7-6.4 33.9-19.3 49.4-36.9c15.4-17.6 29-38.6 42-59.8C111.5 12.7 119.2 8 128 8zM480 108.1c-12.4 10.7-25.8 20.1-40 28.2V256h40V108.1zm-88 49c-15.5 4.8-31.6 8.1-48 9.8V256h48V157zm-96 9.8c-16.4-1.6-32.5-4.9-48-9.8v99h48V166.8zm-96-30.5c-14.2-8-27.6-17.5-40-28.2V256h40V136.3z"]
};
var faTrashCheck = {
  prefix: 'fas',
  iconName: 'trash-check',
  icon: [448, 512, [], "e2af", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zM337 249c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 249z"]
};
var faUserNurse = {
  prefix: 'fas',
  iconName: 'user-nurse',
  icon: [448, 512, [], "f82f", "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"]
};
var faBoombox = {
  prefix: 'fas',
  iconName: 'boombox',
  icon: [640, 512, [128254], "f8a5", "M120 48H520c22.1 0 40 17.9 40 40v72H448c0-17.7-14.3-32-32-32s-32 14.3-32 32H352c0-17.7-14.3-32-32-32s-32 14.3-32 32H256c0-17.7-14.3-32-32-32s-32 14.3-32 32H80V88c0-22.1 17.9-40 40-40zM608 168.6V88c0-48.6-39.4-88-88-88H120C71.4 0 32 39.4 32 88v80.6C12.9 179.6 0 200.3 0 224V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V224c0-23.7-12.9-44.4-32-55.4zM256 336A80 80 0 1 0 96 336a80 80 0 1 0 160 0zM64 336a112 112 0 1 1 224 0A112 112 0 1 1 64 336zm400 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
};
var faSyringe = {
  prefix: 'fas',
  iconName: 'syringe',
  icon: [512, 512, [128137], "f48e", "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V325.3c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"]
};
var faCloudSun = {
  prefix: 'fas',
  iconName: 'cloud-sun',
  icon: [640, 512, [9925], "f6c4", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM639.9 431.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"]
};
var faShieldExclamation = {
  prefix: 'fas',
  iconName: 'shield-exclamation',
  icon: [512, 512, [], "e247", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 128c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faStopwatch20 = {
  prefix: 'fas',
  iconName: 'stopwatch-20',
  icon: [448, 512, [], "e06f", "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176zM288 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52V256c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12V256c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20H128c-11 0-20-9-20-20V368.3c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z"]
};
var faSquareFull = {
  prefix: 'fas',
  iconName: 'square-full',
  icon: [512, 512, [128997, 128998, 128999, 129000, 129001, 129002, 129003, 11035, 11036], "f45c", "M0 0H512V512H0V0z"]
};
var faGripDots = {
  prefix: 'fas',
  iconName: 'grip-dots',
  icon: [448, 512, [], "e410", "M336 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-160 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM64 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM336 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM224 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM16 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z"]
};
var faCommentExclamation = {
  prefix: 'fas',
  iconName: 'comment-exclamation',
  icon: [512, 512, [], "f4af", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm0-336c13.3 0 24 10.7 24 24V248c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24zM224 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faPenSwirl = {
  prefix: 'fas',
  iconName: 'pen-swirl',
  icon: [512, 512, [], "e214", "M347.8 17C319.3 6 288.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c17.7 0 32-14.3 32-32s-14.3-32-32-32C150 448 64 362 64 256S150 64 256 64c14.1 0 27.8 1.5 41 4.4L347.8 17zM310.6 349.4c-5.4 5.3-11.4 9.8-17.8 13.6c-1.7 2.7-3 5.7-3.8 9c-4.4 17.1 5.9 34.6 23 39c12.8 3.3 26.2 5 40 5c88.4 0 160-71.6 160-160c0-32.2-5.9-63-16.8-91.3l-51.4 51.4c2.7 12.9 4.2 26.2 4.2 39.9c0 53-43 96-96 96c-8.3 0-16.4-1.1-24-3c-5.9-1.5-11.9-1.3-17.4 .4zM473.9 16c-18.8-18.8-49.2-18.7-67.9 0L366.4 55.7l89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4 .4-68.2L473.9 16zM200.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15L432.8 167.5 343.7 78.4 200.5 221.8z"]
};
var faFalafel = {
  prefix: 'fas',
  iconName: 'falafel',
  icon: [576, 512, [129478], "e40a", "M166.6 162.5c5.9 7.1 8 16.7 5.7 25.7c-.3 1.3-.6 2.6-.7 3.9c17.2 .6 33.9 8.6 45.1 22.8c28.3 .2 52.1 20.3 58.1 47.4c4.8 2.4 9.2 5.4 13.1 8.8c3.9-3.4 8.3-6.4 13.1-8.8c6-27.1 29.8-47.1 58.1-47.4c17.3-21.9 47.4-29.2 72.8-17c1.5-.7 3-1.4 4.5-1.9c.1-2.6-.2-5.2-.9-7.8c-2.3-9-.1-18.6 5.7-25.7c8.8-10.7 8.8-26.3 0-37c-5.9-7.1-8-16.7-5.7-25.7c3.4-13.5-3.2-27.6-15.7-33.3c-8.3-3.8-14.3-11.5-16.1-20.6c-2.7-13.7-14.6-23.5-28.3-23.1c-9.1 .3-17.8-4-23.2-11.4C344 .3 329.1-3.2 316.9 3.2c-8.1 4.3-17.7 4.3-25.8 0C278.9-3.2 264 .3 255.8 11.4c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37zm48.8 84.4c-3.6 .1-7.2-.5-10.5-1.8c-5-1.9-9.4-5.2-12.7-9.6c-8.2-11.2-23.2-14.6-35.3-8.2c-8.1 4.3-17.7 4.3-25.8 0c-12.2-6.4-27.1-2.9-35.3 8.2c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-3.4 13.5 3.2 27.6 15.7 33.3c8.3 3.8 14.3 11.5 16.1 20.6c2.7 13.7 14.6 23.5 28.3 23.1c9.1-.3 17.8 4 23.2 11.4c8.2 11.2 23.2 14.6 35.3 8.2c8.1-4.3 17.7-4.3 25.8 0c12.2 6.4 27.1 2.9 35.3-8.2c5.5-7.4 14.1-11.7 23.2-11.4c13.7 .4 25.7-9.4 28.3-23.1c1.8-9.1 7.8-16.8 16.1-20.6c4.1-1.9 7.6-4.7 10.3-8.1c-3.1-10.1-3.7-21-1.2-31.7c-17.3-22.1-17.3-53.3 0-75.4c-2.4-10.7-1.9-21.7 1.2-31.7c-2.7-3.4-6.2-6.2-10.3-8.1c-8.3-3.8-14.3-11.5-16.1-20.6c-.2-1-.5-2-.8-3c-3.7-12.1-14.9-20.4-27.6-20.1zM224 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm453.4-42.6c4.1-4.1 7-9.2 8.7-14.9c0-.2 .1-.3 .1-.5c7-25-7.6-62.8-38.6-93.7c-23.3-23.3-50.5-37.4-73.1-39.9c0 0 0 0 0 0c-2-.2-3.9-.4-5.8-.4c0 0 0 0 0 0c-9.6-.2-18.3 1.8-25.1 6.4c0 0 0 0 0 0c0 0-.1 0-.1 .1c-1.6 1.1-3.1 2.3-4.5 3.6c-.2 .2-.3 .3-.5 .5c-19.2 19.2-11.4 59 16.6 94.3c4 5 8.4 10 13.2 14.8c38.4 38.4 87.2 51.7 109.1 29.8zM508.6 412c-26-7.1-52.6-23.3-74.9-45.7s-38.6-48.9-45.7-74.9c-5.3-19.6-6.4-43.3 4.2-63.6c-3.2 1.9-6.1 4.4-8.4 7.6c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-3.4 13.5 3.2 27.6 15.7 33.3c8.3 3.8 14.3 11.5 16.1 20.6c2.7 13.7 14.6 23.5 28.3 23.1c9.1-.3 17.8 4 23.2 11.4c8.2 11.2 23.2 14.6 35.3 8.2c8.1-4.3 17.7-4.3 25.8 0c12.2 6.4 27.1 2.9 35.3-8.2c5.5-7.4 14.1-11.7 23.2-11.4c13.7 .4 25.7-9.4 28.3-23.1c1.8-9.1 7.8-16.8 16.1-20.6c12.5-5.7 19.2-19.8 15.7-33.3l-.1-.6c-18.1 6.4-38 5-54.9 .4zM368 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faCircle2 = {
  prefix: 'fas',
  iconName: 'circle-2',
  icon: [512, 512, [], "e0ef", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM222.7 184.7l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L244.7 336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L276.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z"]
};
var faMagnet = {
  prefix: 'fas',
  iconName: 'magnet',
  icon: [448, 512, [129522], "f076", "M0 160v96C0 379.7 100.3 480 224 480s224-100.3 224-224V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H0zm0-32H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64zm320 0H448V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v64z"]
};
var faJar = {
  prefix: 'fas',
  iconName: 'jar',
  icon: [320, 512, [], "e516", "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"]
};
var faGramophone = {
  prefix: 'fas',
  iconName: 'gramophone',
  icon: [384, 512, [], "f8bd", "M127 0c10.5-.4 20 6 23.6 15.9l0 .1 .3 .7c.3 .7 .7 1.7 1.3 3.2c1.2 2.9 3.2 7.3 6 12.8c5.7 11.1 14.8 27 28.2 45.1c26.9 36.2 71.4 81.5 141.3 116.8c17.3 8.7 31.6 22.9 40.1 40.4c5.4 10.9 8.2 23 8.2 35l0 .3 0 .3c0 45-36.5 81.4-81.4 81.4H184c-13.3 0-24-10.7-24-24s10.7-24 24-24l110 0c18.7 0 33.9-15.1 34-33.7c-.1-5.4-1.5-10.7-4.1-15.6c-3.1-4.9-7.7-7.8-12.4-8.6c-44.1-7.3-133.1-7.9-241.4 69.4c-.3 .2-.7 .5-1 .7c-2.7 1.8-5.6 2.9-8.7 3.5c-3.2 .6-6.6 .6-10-.2c-1.2-.3-2.4-.7-3.6-1.1c-.5-.2-1-.5-1.5-.7c-.9-.4-1.7-.9-2.5-1.5c-1.2-.8-2.2-1.6-3.2-2.6c-1.4-1.3-2.5-2.7-3.6-4.2c-1.8-2.8-3-5.8-3.6-8.9c-.6-3.1-.5-6.4 .2-9.6c.1-.3 .2-.7 .3-1L104.8 17.9C107.5 7.7 116.5 .4 127 0zM32 416c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V416z"]
};
var faDiceD12 = {
  prefix: 'fas',
  iconName: 'dice-d12',
  icon: [512, 512, [], "f6ce", "M318.2 0c4.2 0 8.4 1.1 12 3.2l72 41.6c5.9 3.4 5.1 12.2-1.3 14.5L264.1 108.1c-5.2 1.9-10.9 1.9-16.1 0L111.1 59.3c-6.4-2.3-7.2-11.1-1.3-14.5l72-41.6c3.6-2.1 7.8-3.2 12-3.2H318.2zM149.9 490.4L74.2 446.6c-3.6-2.1-6.7-5.1-8.8-8.8L3.2 330.2c-2.1-3.6-3.2-7.8-3.2-12V233.9c0-7.1 8.6-10.7 13.7-5.7l96.1 96.1c2.7 2.7 4.8 6.1 5.9 9.8L161.6 481c2.2 7-5.3 13-11.6 9.3zM512 233.9v84.2c0 4.2-1.1 8.4-3.2 12L446.6 437.8c-2.1 3.6-5.1 6.7-8.8 8.8l-75.8 43.7c-6.3 3.6-13.8-2.4-11.6-9.3l45.9-146.9c1.2-3.7 3.2-7.1 5.9-9.8l96.1-96.1c5-5 13.7-1.5 13.7 5.7zM15.3 184.7c-5.1-5.1-6.2-13-2.5-19.3L57.4 88c3.9-6.7 12-9.7 19.2-7.1l152.8 54.6c6.4 2.3 10.6 8.3 10.6 15.1v85.7c0 6.1-3.4 11.6-8.8 14.3l-89.7 44.8c-6.2 3.1-13.6 1.9-18.5-3L15.3 184.7zM454.6 88l44.7 77.3c3.6 6.3 2.6 14.2-2.5 19.3L389 292.4c-4.9 4.9-12.3 6.1-18.5 3l-89.7-44.8c-5.4-2.7-8.8-8.3-8.8-14.3V150.6c0-6.8 4.3-12.8 10.6-15.1L435.4 80.9c7.3-2.6 15.4 .4 19.2 7.1zM295.5 512H216.5c-7 0-13.2-4.5-15.3-11.2L151.4 341.2c-2.3-7.5 1.1-15.6 8.1-19.1l89.3-44.7c4.5-2.3 9.8-2.3 14.3 0l89.3 44.7c7 3.5 10.5 11.6 8.1 19.1L310.7 500.8c-2.1 6.7-8.3 11.2-15.3 11.2z"]
};
var faNoteSticky = {
  prefix: 'fas',
  iconName: 'note-sticky',
  icon: [448, 512, [62026, "sticky-note"], "f249", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H288V368c0-26.5 21.5-48 48-48H448V96c0-35.3-28.7-64-64-64H64zM448 352H402.7 336c-8.8 0-16 7.2-16 16v66.7V480l32-32 64-64 32-32z"]
};
var faStickyNote = faNoteSticky;
var faDown = {
  prefix: 'fas',
  iconName: 'down',
  icon: [384, 512, ["arrow-alt-down"], "f354", "M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l96 0 0-184c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 184 96 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-160 160z"]
};
var faArrowAltDown = faDown;
var faHundredPoints = {
  prefix: 'fas',
  iconName: 'hundred-points',
  icon: [512, 512, [128175, "100"], "e41c", "M163 101.8C168 61.9 201.9 32 242 32c47.9 0 85 42 79 89.5L309 218.2c-5 39.8-38.9 69.8-79 69.8c-47.9 0-85-42-79-89.5L163 101.8zM242 96c-7.9 0-14.5 5.9-15.5 13.7l-12.1 96.7c-1.2 9.3 6.1 17.6 15.5 17.6c7.9 0 14.5-5.9 15.5-13.7l12.1-96.7c1.2-9.3-6.1-17.6-15.5-17.6zM135.7 68l-32 224c-2.5 17.5-18.7 30-36.2 27.7S37.8 301.5 40.3 284L64.3 116.5l-19.7 8.7c-16.2 7.2-35.1 0-42-16.1s.6-35.1 16.8-42.3l72-32c10.6-4.7 22.9-3.4 32.1 3.5s13.8 18.2 12.2 29.7zm376 247.5c2.5 17.5-9.7 33.7-27.2 36.2l-448 64C19 418.2 2.8 406 .3 388.5S10 354.8 27.5 352.3l448-64c17.5-2.5 33.7 9.7 36.2 27.2zm0 96c2.5 17.5-9.7 33.7-27.2 36.2l-224 32c-17.5 2.5-33.7-9.7-36.2-27.2s9.7-33.7 27.2-36.2l224-32c17.5-2.5 33.7 9.7 36.2 27.2zM427.7 32c46.9 0 83.7 40.3 79.5 87l-7.3 80.4c-3.7 41.1-38.2 72.6-79.5 72.6c-46.9 0-83.7-40.3-79.5-87l7.3-80.4C351.9 63.5 386.4 32 427.7 32zm-15.7 78.4l-7.3 80.4c-.8 9.3 6.4 17.2 15.7 17.2c8.2 0 15-6.2 15.7-14.4l7.3-80.4c.8-9.3-6.4-17.2-15.7-17.2c-8.2 0-15 6.2-15.7 14.4z"]
};
var fa100 = faHundredPoints;
var faPaperclipVertical = {
  prefix: 'fas',
  iconName: 'paperclip-vertical',
  icon: [384, 512, [], "e3c2", "M32 128C32 57.3 89.3 0 160 0s128 57.3 128 128V320c0 44.2-35.8 80-80 80s-80-35.8-80-80V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-35.3-28.7-64-64-64s-64 28.7-64 64V336c0 61.9 50.1 112 112 112s112-50.1 112-112V160c0-17.7 14.3-32 32-32s32 14.3 32 32V336c0 97.2-78.8 176-176 176s-176-78.8-176-176V128z"]
};
var faWindWarning = {
  prefix: 'fas',
  iconName: 'wind-warning',
  icon: [640, 512, ["wind-circle-exclamation"], "f776", "M418 368c-38.7 67-111.1 112-194 112C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208H384c-35.3 0-64 28.7-64 64s28.7 64 64 64h34zM248 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm248 48c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32H536c53 0 96 43 96 96s-43 96-96 96H504c-17.7 0-32-14.3-32-32zm72-192H479.5c-1.4-22.2-5.6-43.7-12.3-64H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H512c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c53 0 96 43 96 96s-43 96-96 96z"]
};
var faWindCircleExclamation = faWindWarning;
var faLocationPinSlash = {
  prefix: 'fas',
  iconName: 'location-pin-slash',
  icon: [640, 512, ["map-marker-slash"], "f60c", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zM343.7 499.2c16.2-20.2 39-49.6 62.5-83.1L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0z"]
};
var faMapMarkerSlash = faLocationPinSlash;
var faFaceSadSweat = {
  prefix: 'fas',
  iconName: 'face-sad-sweat',
  icon: [576, 512, [], "e38a", "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512zM79.5 404.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5zm291.3 7.4c-6.6 5.9-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C220.2 371.4 248.3 352 288 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6zM367.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faBugSlash = {
  prefix: 'fas',
  iconName: 'bug-slash',
  icon: [640, 512, [], "e490", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H479.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96zM160.3 256H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7zM336 479.2c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7V479.2z"]
};
var faCupcake = {
  prefix: 'fas',
  iconName: 'cupcake',
  icon: [448, 512, [129473], "e402", "M240 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l6.1 6.1c3.4 3.4 5.3 7.9 5.3 12.7C240 56 232 64 222.1 64H160c-35.3 0-64 28.7-64 64l0 .8c-3.3 .5-6.6 1.4-9.9 2.4L50.9 143C20.5 153.2 0 181.6 0 213.6C0 254.7 33.3 288 74.4 288H373.6c41.1 0 74.4-33.3 74.4-74.4c0-32-20.5-60.4-50.9-70.6l-35.3-11.8c-4.1-1.4-8.2-2.3-12.5-2.8c1.7-6.7 2.6-13.8 2.6-21C352 48.1 303.9 0 244.6 0H240zm27.9 512l24-192H156.1l24 192h87.8zM64 320L89.3 471.9C93.2 495 113.2 512 136.7 512h11.2l-24-192H64zM300.1 512h11.2c23.5 0 43.5-17 47.3-40.1L384 320H324.1l-24 192z"]
};
var faLightSwitchOff = {
  prefix: 'fas',
  iconName: 'light-switch-off',
  icon: [384, 512, [], "e018", "M64 512c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64zm96-96h64c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64zm32 32a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-416a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM160 384c-17.7 0-32-14.3-32-32V256H256v96c0 17.7-14.3 32-32 32H160z"]
};
var faToggleLargeOff = {
  prefix: 'fas',
  iconName: 'toggle-large-off',
  icon: [576, 512, [], "e5b0", "M192 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm0 64H384c106 0 192-86 192-192s-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448zm143.1-64c30.4-34 48.9-78.8 48.9-128s-18.5-94-48.9-128H384c70.7 0 128 57.3 128 128s-57.3 128-128 128H335.1z"]
};
var faPenFancySlash = {
  prefix: 'fas',
  iconName: 'pen-fancy-slash',
  icon: [640, 512, [], "e210", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L387.9 278.7l161-140.2c17.2-15 27.1-36.7 27.1-59.6c0-43.6-35.4-79-79-79c-22.8 0-44.6 9.9-59.6 27.1L287.1 199.7 38.8 5.1zM318 346.5L211 262.3l-60.1 13.9c-17.1 3.9-30.7 16.9-35.4 33.8L65.7 487.6l95.4-95.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1L88.4 510.3 266 460.5c16.9-4.7 29.9-18.3 33.8-35.4L318 346.5z"]
};
var faTruckContainer = {
  prefix: 'fas',
  iconName: 'truck-container',
  icon: [640, 512, [], "f4dc", "M48 32H352c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80C0 53.5 21.5 32 48 32zM80 80c-8.8 0-16 7.2-16 16V224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zM224 96V224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16zM160 80c-8.8 0-16 7.2-16 16V224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zM304 96V224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16zm128 72c0-13.3 10.7-24 24-24h72.8c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3V272v16 64c0 17.7-14.3 32-32 32h-1.6c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H432 286.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80V384 352c0-17.7 14.3-32 32-32H80 208 432V288 256 168zm48 88H585l-50-61.1c-1.5-1.9-3.8-2.9-6.2-2.9H480v64zm80 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM208 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faBoot = {
  prefix: 'fas',
  iconName: 'boot',
  icon: [512, 512, [129406], "f782", "M0 32C0 14.3 14.3 0 32 0H320c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H0V32zM0 457.4V448H512v9.4c0 14.5-5.8 28.4-16 38.6s-24.1 16-38.6 16H442.5c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7H54.6c-14.5 0-28.4-5.8-38.6-16S0 471.9 0 457.4zM0 416V128H320v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h48l119.3 29.8C482 296.5 512 334.9 512 379v37H0z"]
};
var faArrowUpFromWaterPump = {
  prefix: 'fas',
  iconName: 'arrow-up-from-water-pump',
  icon: [576, 512, [], "e4b6", "M112 0C85.5 0 64 21.5 64 48V256H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400V304c0-26.5-21.5-48-48-48H480l0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256H288V48c0-26.5-21.5-48-48-48H112zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"]
};
var faFileCheck = {
  prefix: 'fas',
  iconName: 'file-check',
  icon: [384, 512, [], "f316", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm49 281L177 409c-9.4 9.4-24.6 9.4-33.9 0L79 345c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 247c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faBone = {
  prefix: 'fas',
  iconName: 'bone',
  icon: [576, 512, [129460], "f5d7", "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"]
};
var faCardsBlank = {
  prefix: 'fas',
  iconName: 'cards-blank',
  icon: [640, 512, [], "e4df", "M27.8 118.8C1.2 134.2-7.9 168.2 7.5 194.9l167 289.3c15.4 26.6 49.4 35.8 76.1 20.4L443.4 393.2c26.6-15.4 35.8-49.4 20.4-76.1L296.8 27.8C281.4 1.2 247.3-7.9 220.7 7.5L27.8 118.8zM459.4 420.9L324.1 499c9.7 8.1 22.2 13 35.9 13H584c30.9 0 56-25.1 56-56V120c0-30.9-25.1-56-56-56H360c-1.8 0-3.5 .1-5.3 .2L491.5 301.1c24.2 41.9 9.8 95.6-32.1 119.8z"]
};
var faCircle3 = {
  prefix: 'fas',
  iconName: 'circle-3',
  icon: [512, 512, [], "e0f0", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H312c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2H240c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L250.3 176H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faBenchTree = {
  prefix: 'fas',
  iconName: 'bench-tree',
  icon: [640, 512, [], "e2e7", "M608 96c0 5.1-.4 10.2-1.2 15.1C626.9 125.7 640 149.3 640 176c0 44.2-35.8 80-80 80H544V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256H464c-44.2 0-80-35.8-80-80c0-26.7 13.1-50.3 33.2-64.9c-.8-4.9-1.2-10-1.2-15.1c0-53 43-96 96-96s96 43 96 96zM32 224c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224zm0 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faKeyboardBrightnessLow = {
  prefix: 'fas',
  iconName: 'keyboard-brightness-low',
  icon: [640, 512, [], "e1c1", "M320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96-32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H224z"]
};
var faSkiBootSki = {
  prefix: 'fas',
  iconName: 'ski-boot-ski',
  icon: [640, 512, [], "e3cd", "M390.3 .6c17.3 3.5 28.6 20.3 25.1 37.7l-6.4 32L397.4 128H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h55l-9.6 48H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h62.2l78.7 34.7c11.6 5.1 19.1 16.6 19.1 29.3v80c0 17.7-14.3 32-32 32H120c-9.6 0-18.7-4.3-24.7-11.7s-8.5-17.2-6.6-26.6l24.7-123.6c2.9-.5 6.1-1.2 9.5-2.1c15.6-3.9 36.4-11.6 58.3-26.9c42.4-29.7 86.4-86.4 104.5-193.1h65.7l1.3-6.3C356.1 8.4 372.9-2.8 390.3 .6zM162.8 198.9c-15.8 11-30.8 17.2-42.6 20.7L152.6 57.7c3-15 16.1-25.7 31.4-25.7h69.2c-17.4 96-56.7 143.3-90.4 166.9zM640 416c0 53-43 96-96 96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32-14.3 32-32s14.3-32 32-32s32 14.3 32 32z"]
};
var faBrainCircuit = {
  prefix: 'fas',
  iconName: 'brain-circuit',
  icon: [512, 512, [], "e0c6", "M240 56c0-30.9-25.1-56-56-56c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1c30.9 0 56-25.1 56-56V272H192c-8.8 0-16 7.2-16 16v34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V288c0-26.5 21.5-48 48-48h48V160H205.3c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.9 0 38.7 13.4 45.3 32H240V56zm32 104V352h34.7c6.6-18.6 24.4-32 45.3-32c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32H272v72c0 30.9 25.1 56 56 56c28.9 0 52.7-21.9 55.7-50.1c5.2 1.4 10.7 2.1 16.3 2.1c35.3 0 64-28.7 64-64c0-7.4-1.3-14.6-3.6-21.2C490.6 367.4 512 338.2 512 304c0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56v72h48c26.5 0 48 21.5 48 48v2.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V176c0-8.8-7.2-16-16-16H272zM144 144a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm208 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM144 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm192 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z"]
};
var faUserInjured = {
  prefix: 'fas',
  iconName: 'user-injured',
  icon: [448, 512, [], "f728", "M240 80H342.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7V512H243.7L181.5 408.2 124 312.4zm33-7.2L204.3 384H272c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48H223.5l57.1 95.2C303 507.2 320 487.6 320 464z"]
};
var faBlockBrickFire = {
  prefix: 'fas',
  iconName: 'block-brick-fire',
  icon: [640, 512, ["firewall"], "e3dc", "M128 32v80H384V32H128zM96 112V32C60.7 32 32 60.7 32 96v16H96zM32 144v96H240V144H32zm0 224H96V272H32v96zm0 32v16c0 35.3 28.7 64 64 64H240V400H32zm240 0v80h65.6c-20.2-22.6-35.1-50-43.1-80H272zM480 144h-.6l.6 .6V144zm-208 0v96h54.9c20.6-32.8 48.5-66.2 81-96H272zM128 272v96H288.8c-.5-5.9-.8-11.9-.8-17.9c0-25.4 8.5-52.4 21-78.1H128zM480 112V96c0-35.3-28.7-64-64-64v80h64zm-26.5 51.8c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 433c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faFirewall = faBlockBrickFire;
var faFaceSadTear = {
  prefix: 'fas',
  iconName: 'face-sad-tear',
  icon: [512, 512, [128546, "sad-tear"], "f5b4", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSadTear = faFaceSadTear;
var faPlane = {
  prefix: 'fas',
  iconName: 'plane',
  icon: [576, 512, [], "f072", "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"]
};
var faTentArrowsDown = {
  prefix: 'fas',
  iconName: 'tent-arrows-down',
  icon: [576, 512, [], "e581", "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"]
};
var faExclamation = {
  prefix: 'fas',
  iconName: 'exclamation',
  icon: [64, 512, [10069, 10071, 61738], "21", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faArrowsSpin = {
  prefix: 'fas',
  iconName: 'arrows-spin',
  icon: [512, 512, [], "e4bb", "M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H448c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5 .8-32 2.3V99.2c10.3-2.1 21-3.2 32-3.2zM132.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H64c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9 .8 21.5 2.3 32H99.2c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM477.7 224H412.8c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V448c0 8.8 7.2 16 16 16H448c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H64c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3V412.8c-10.3 2.1-21 3.2-32 3.2z"]
};
var faFaceSmileRelaxed = {
  prefix: 'fas',
  iconName: 'face-smile-relaxed',
  icon: [512, 512, [], "e392", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faCommentXmark = {
  prefix: 'fas',
  iconName: 'comment-xmark',
  icon: [512, 512, ["comment-times"], "f4b5", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM175 159c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faCommentTimes = faCommentXmark;
var faPrint = {
  prefix: 'fas',
  iconName: 'print',
  icon: [512, 512, [128424, 128438, 9113], "f02f", "M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTurkishLiraSign = {
  prefix: 'fas',
  iconName: 'turkish-lira-sign',
  icon: [384, 512, ["try", "turkish-lira"], "e2bb", "M96 32c17.7 0 32 14.3 32 32V99.3L247.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480H96c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6V184.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6V64c0-17.7 14.3-32 32-32z"]
};
var faTry = faTurkishLiraSign;
var faTurkishLira = faTurkishLiraSign;
var faFaceNoseSteam = {
  prefix: 'fas',
  iconName: 'face-nose-steam',
  icon: [512, 512, [], "e382", "M498.2 339.1c8.9-26.1 13.8-54 13.8-83.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 28.6 4.7 56.1 13.3 81.8c4.9-1.5 9.9-2.4 15-2.7c1.2-1.4 2.4-2.7 3.7-4l4 4-4-4c23.3-23.3 60.1-24.9 85.3-4.7l51-30.6c30-18 64.1 16.1 46.1 46.1l-30.6 51c20.2 25.1 18.6 62-4.7 85.3c-1.3 1.3-2.6 2.5-4 3.7c-.3 5.4-1.3 10.8-3 16C198.4 507 226.6 512 256 512c28.7 0 56.3-4.7 82-13.4c-1.6-5.1-2.6-10.5-2.9-15.8c-1.4-1.2-2.7-2.4-4-3.7c-23.3-23.3-24.9-60.1-4.7-85.3l-30.6-51c-18-30 16.1-64.1 46.1-46.1l51 30.6c25.1-20.2 62-18.6 85.3 4.7c1.3 1.3 2.5 2.6 3.7 4c5.5 .3 11 1.3 16.3 3.1zm-12.4 29.7c-1.9-.5-3.8-.8-5.8-.9c-5.4-.3-10.8 .7-15.7 3.1c-1-5.2-3.3-10.1-6.9-14.4c-.6-.7-1.2-1.4-1.8-2c-12-12-31.2-12.5-43.8-1.4c-.5 .5-1 .9-1.5 1.4c-3.7 3.7-6.3 8.1-7.8 12.8L332.8 323c-2.8-1.8-6.5-1.4-8.8 1l-.2 .2c-.3 .2-.6 .5-.7 .8c-1.6 2.3-1.7 5.3-.1 7.7l44.2 70.4c-4.9 1.5-9.6 4.1-13.4 8c-4.7 4.7-7.6 10.4-8.8 16.4c-.5 2.4-.7 4.8-.6 7.2c.2 7.9 3.4 15.7 9.4 21.7c.7 .7 1.3 1.3 2 1.9c4.2 3.6 9.2 5.9 14.4 6.9c-1.5 3.2-2.5 6.7-2.9 10.1c-.2 1.8-.3 3.7-.2 5.6c0 .7 .1 1.4 .2 2c.8 6.9 3.9 13.5 9.1 18.8c12.5 12.5 32.8 12.5 45.3 0c2.1-2.1 3.8-4.3 5.2-6.7c18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2c12.5-12.5 12.5-32.8 0-45.3c-4.3-4.3-9.5-7.1-15-8.5l0 0zM142.4 485.5c.4-1.8 .7-3.6 .8-5.4c.3-5.4-.7-10.8-3.1-15.7c5.2-1 10.1-3.3 14.4-6.9c.7-.6 1.4-1.2 2-1.8c1.5-1.5 2.8-3.1 4-4.8c8-11.9 7.1-27.9-2.5-38.9c-.5-.5-.9-1-1.4-1.5c-3.6-3.6-7.9-6.2-12.5-7.7l44.9-69.8c1.8-2.8 1.4-6.5-.9-8.8c-2.3-2.3-5.9-2.7-8.7-1L108 367.5c0-.2-.1-.3-.1-.5c-1.5-4.8-4.1-9.4-8-13.2c-.2-.2-.4-.4-.7-.6c-.3-.3-.6-.5-.8-.8c-12.6-11.1-31.7-10.6-43.8 1.4c-.7 .7-1.3 1.3-1.9 2c-3.6 4.3-5.9 9.2-6.9 14.4c-4.9-2.4-10.3-3.4-15.7-3.1c-1.5 .1-3.1 .3-4.6 .6c-5.9 1.2-11.6 4.1-16.2 8.7c-12.5 12.5-12.5 32.8 0 45.3c2.1 2.1 4.3 3.8 6.7 5.2C1.7 445.6 3 472.7 20.3 489.9s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7c12.5 12.5 32.8 12.5 45.3 0c4.4-4.4 7.2-9.8 8.5-15.4zM112 224h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 32c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm95.2-133.1c2.8 8.4-1.7 17.4-10.1 20.2c-35.5 11.8-64.4 34.8-73.7 44.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c12-12 45-38.1 86.3-51.9c8.4-2.8 17.4 1.7 20.2 10.1zm-286.4 0c2.8-8.4 11.9-12.9 20.2-10.1c41.3 13.8 74.2 39.9 86.3 51.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-9.3-9.3-38.2-32.3-73.7-44.1c-8.4-2.8-12.9-11.9-10.1-20.2z"]
};
var faCircleWaveformLines = {
  prefix: 'fas',
  iconName: 'circle-waveform-lines',
  icon: [512, 512, ["waveform-circle"], "e12d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-368V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zM160 176V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24V312c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-8.8 7.2-16 16-16s16 7.2 16 16zM224 216v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V216c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faWaveformCircle = faCircleWaveformLines;
var faDollarSign = {
  prefix: 'fas',
  iconName: 'dollar-sign',
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", "M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z"]
};
var faDollar = faDollarSign;
var faUsd = faDollarSign;
var faFerrisWheel = {
  prefix: 'fas',
  iconName: 'ferris-wheel',
  icon: [512, 512, [], "e174", "M302.7 36.9c27.7 5.9 53.5 16.9 76.4 31.9c6.3-3.1 13.4-4.8 20.9-4.8c26.5 0 48 21.5 48 48c0 7.5-1.7 14.6-4.8 20.9c15.1 22.9 26 48.7 31.9 76.4c21.1 5 36.9 24 36.9 46.7s-15.7 41.7-36.9 46.7c-5.9 27.7-16.9 53.5-31.9 76.4c3.1 6.3 4.8 13.4 4.8 20.9c0 25.6-20 46.4-45.1 47.9l-38.5-80c4.6-5.1 10.3-9.2 16.6-12c17.2-21.5 29-47.5 33.2-75.9H332.3c2.4-7.6 3.7-15.6 3.7-24s-1.3-16.4-3.7-24h81.9c-3.9-26.3-14.3-50.4-29.4-70.9L326.9 219c-7.6-14.5-19.5-26.4-33.9-33.9l57.9-57.9c-20.5-15.1-44.6-25.4-70.9-29.4v81.9c-7.6-2.4-15.6-3.7-24-3.7s-16.4 1.3-24 3.7V97.8c-26.3 4-50.4 14.3-70.9 29.4L219 185.1c-14.5 7.6-26.4 19.5-33.9 33.9l-57.9-57.9c-15.1 20.5-25.4 44.6-29.4 70.9h81.9c-2.4 7.6-3.7 15.6-3.7 24s1.3 16.4 3.7 24H97.8c4.3 28.5 16.1 54.4 33.2 75.9c6.4 2.8 12.1 6.9 16.7 12l-38.5 80C84 446.4 64 425.6 64 400c0-7.5 1.7-14.6 4.8-20.9c-15.1-22.9-26.1-48.7-31.9-76.4C15.7 297.7 0 278.7 0 256s15.7-41.7 36.9-46.7c5.9-27.7 16.9-53.5 31.9-76.4C65.7 126.6 64 119.5 64 112c0-26.5 21.5-48 48-48c7.5 0 14.6 1.7 20.9 4.8c22.9-15.1 48.7-26.1 76.4-31.9C214.3 15.7 233.3 0 256 0s41.7 15.7 46.7 36.9zM304 256c0 11.6-4.1 22.3-11 30.6l88.8 191.3c3.4 7.4 2.9 16.1-1.5 23s-12 11.1-20.2 11.1H152c-8.2 0-15.8-4.2-20.2-11.1s-5-15.6-1.5-23L219 286.6c-6.9-8.3-11-19-11-30.6c0-26.5 21.5-48 48-48s48 21.5 48 48z"]
};
var faComputerSpeaker = {
  prefix: 'fas',
  iconName: 'computer-speaker',
  icon: [640, 512, [], "f8b2", "M288 432V416H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H304c-10-13.4-16-30-16-48zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H288V320H64V96H288V80c0-18 6-34.6 16-48H64zm304 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368zM544 320a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm64-192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSkullCow = {
  prefix: 'fas',
  iconName: 'skull-cow',
  icon: [640, 512, [], "f8de", "M63.2 21.1c2.5-7.4-.7-15.4-7.5-19.1S40.3 0 35.5 6L28 15.3C9.9 38 0 66.4 0 95.5C0 166.1 57.2 224 128 224V208 192 160 144 128H105c-28.7 0-52.7-21.7-55.6-50.3c-.8-7.8 .1-15.8 2.6-23.2L63.2 21.1zM240 96c-44.2 0-80 35.8-80 80V288c0 37 25.2 68.2 59.3 77.3l27.6 110.3c5.3 21.4 24.5 36.4 46.6 36.4h53c22 0 41.2-15 46.6-36.4l27.6-110.3C454.8 356.2 480 325 480 288V176c0-44.2-35.8-80-80-80H240zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM584.4 1.9c-6.8 3.7-10 11.8-7.5 19.1L588 54.5c2.5 7.5 3.4 15.4 2.6 23.2C587.7 106.3 563.7 128 535 128H512v16 16 32 16 16c70.8 0 128-57.9 128-128.5c0-29-9.9-57.4-28-80.1L604.5 6c-4.8-6.1-13.3-7.8-20.1-4.1z"]
};
var faX = {
  prefix: 'fas',
  iconName: 'x',
  icon: [384, 512, [120], "58", "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"]
};
var faMagnifyingGlassDollar = {
  prefix: 'fas',
  iconName: 'magnifying-glass-dollar',
  icon: [512, 512, ["search-dollar"], "f688", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"]
};
var faSearchDollar = faMagnifyingGlassDollar;
var faUsersGear = {
  prefix: 'fas',
  iconName: 'users-gear',
  icon: [640, 512, ["users-cog"], "f509", "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6v-21c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6v21c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faUsersCog = faUsersGear;
var faPersonMilitaryPointing = {
  prefix: 'fas',
  iconName: 'person-military-pointing',
  icon: [576, 512, [], "e54a", "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25H400c8.8 0 16-7.2 16-16V17.4C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40H224v89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5H240 72zm345.7 20.9L246.6 416H416V369.7l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V448H224z"]
};
var faBuildingColumns = {
  prefix: 'fas',
  iconName: 'building-columns',
  icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBank = faBuildingColumns;
var faInstitution = faBuildingColumns;
var faMuseum = faBuildingColumns;
var faUniversity = faBuildingColumns;
var faCircleT = {
  prefix: 'fas',
  iconName: 'circle-t',
  icon: [512, 512, [], "e124", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152 144H256 360c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSack = {
  prefix: 'fas',
  iconName: 'sack',
  icon: [512, 512, [], "f81c", "M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4z"]
};
var faGrid2 = {
  prefix: 'fas',
  iconName: 'grid-2',
  icon: [512, 512, [], "e196", "M224 80c0-26.5-21.5-48-48-48H80C53.5 32 32 53.5 32 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM288 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zM480 336c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z"]
};
var faCameraCctv = {
  prefix: 'fas',
  iconName: 'camera-cctv',
  icon: [576, 512, ["cctv"], "f8ac", "M140.3 2.5c-14.9-6.2-32.1-.3-40.1 13.7l-96 168c-4.6 8-5.5 17.5-2.5 26.2s9.5 15.7 18 19.2l158.1 65.9L137.9 400H64V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v48 48c0 17.7 14.3 32 32 32s32-14.3 32-32V464h96c13.3 0 25.2-8.2 29.9-20.6l47-123.4 70.8 29.5c9.9 4.1 21.2 3 30.1-2.9l192-128c9.8-6.5 15.2-18 14.1-29.7s-8.6-21.9-19.5-26.5l-384-160zM513.4 398.6c3.9 1.8 8.4 1.9 12.5 .3s7.2-4.7 8.9-8.7l40-96c3.3-8-.3-17.2-8.3-20.8l-36.7-16.3L396.9 345.6l116.5 52.9z"]
};
var faCctv = faCameraCctv;
var faUmbrella = {
  prefix: 'fas',
  iconName: 'umbrella',
  icon: [576, 512, [], "f0e9", "M288 0c17.7 0 32 14.3 32 32V49.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"]
};
var faTrowel = {
  prefix: 'fas',
  iconName: 'trowel',
  icon: [512, 512, [], "e589", "M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"]
};
var faHorizontalRule = {
  prefix: 'fas',
  iconName: 'horizontal-rule',
  icon: [640, 512, [8213], "f86c", "M0 256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
};
var faBedFront = {
  prefix: 'fas',
  iconName: 'bed-front',
  icon: [512, 512, ["bed-alt"], "f8f7", "M32 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V209.1c-14.5-8.4-30.7-14-48-16.1c0-.3 0-.7 0-1V160c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v32H240V160c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32v32c0 .3 0 .7 0 1c-17.3 2.2-33.6 7.8-48 16.1V80zM0 320c0-53 43-96 96-96H416c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320z"]
};
var faBedAlt = faBedFront;
var faD = {
  prefix: 'fas',
  iconName: 'd',
  icon: [384, 512, [100], "44", "M0 96C0 60.7 28.7 32 64 32h96c123.7 0 224 100.3 224 224s-100.3 224-224 224H64c-35.3 0-64-28.7-64-64V96zm160 0H64V416h96c88.4 0 160-71.6 160-160s-71.6-160-160-160z"]
};
var faStapler = {
  prefix: 'fas',
  iconName: 'stapler',
  icon: [640, 512, [], "e5af", "M640 299.3V304 432c0 26.5-21.5 48-48 48H512 448 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448V368H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304V288L128 230.9V304H448z"]
};
var faMasksTheater = {
  prefix: 'fas',
  iconName: 'masks-theater',
  icon: [640, 512, [127917, "theater-masks"], "f630", "M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7c6.1-.9 12.1-2.5 18-4.5c-9.2-12.3-17.3-24.4-24.2-35.4c-21.9-35-28.8-75.2-25.9-113.6c-20.6 4.1-39.2 13-54.7 25.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9C278.2 53.2 310.5 37 363.2 32.2c-.8-.7-1.6-1.4-2.4-2.1C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8 .6-19.9-5.1-27.9c-14.8-20.9-57.3-61.2-170-78.3S299.4 77.2 279.2 92.8c-7.8 6-11.5 15.4-12.9 25.2L242.1 282.3c-5.5 37.3-.4 75.8 19.6 107.7zM404.5 235.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6c-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7c23.9 20.8 53.6 35.3 87 40.3s66.1 .1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"]
};
var faTheaterMasks = faMasksTheater;
var faKipSign = {
  prefix: 'fas',
  iconName: 'kip-sign',
  icon: [384, 512, [], "e1c4", "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z"]
};
var faFaceWoozy = {
  prefix: 'fas',
  iconName: 'face-woozy',
  icon: [512, 512, [], "e3a2", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM411.3 347.3L372 386.6c-13.7 13.7-32.3 21.4-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1L267.4 388c-18.2-11.4-40.8-13.4-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4l11.5 7.7c18.5 12.3 41.8 14.7 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2c10.9 0 21.3-4.3 29-12l39.3-39.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM200.9 98.7c7.4 4.9 9.3 14.8 4.4 22.2c-28 42-69.6 64.1-88.3 70.3c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2c13.4-4.5 48.5-22.9 71.7-57.7c4.9-7.4 14.8-9.3 22.2-4.4zm22.6 121.4c2.1 8.6-3.1 17.3-11.6 19.4l-64 16c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l64-16c8.6-2.1 17.3 3.1 19.4 11.6zM336 272c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"]
};
var faCloudQuestion = {
  prefix: 'fas',
  iconName: 'cloud-question',
  icon: [640, 512, [], "e492", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm89.8-282.7l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V296c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H286.6c-23.7 0-44.8 14.9-52.8 37.3zM352 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faPineapple = {
  prefix: 'fas',
  iconName: 'pineapple',
  icon: [512, 512, [], "e31f", "M431.5 12.1c-1.1-4.5-4.2-8.4-8.4-10.5s-9.1-2.2-13.4-.4C393.8 8.1 383 20.8 378.1 35.4L363.3 20.7c-6.2-6.2-16.4-6.2-22.6 0C325.3 36.1 317.1 56 316.2 76.2C297.3 68.2 276.9 64 256 64c-41 0-80.3 16.3-109.3 45.3L45.3 210.7C16.3 239.7 0 279 0 320s16.3 80.3 45.3 109.3l37.5 37.5c29 29 68.3 45.3 109.3 45.3s80.3-16.3 109.3-45.3L402.7 365.3c29-29 45.3-68.3 45.3-109.3c0-20.9-4.2-41.3-12.2-60.2c20.2-.9 40.1-9.1 55.5-24.5c6.2-6.2 6.2-16.4 0-22.6l-14.7-14.7c14.6-4.9 27.3-15.8 34.1-31.6c1.8-4.3 1.7-9.2-.4-13.4s-5.9-7.3-10.5-8.4l-14.3-3.6C492.4 65 496 51.4 496 37.5V32c0-8.8-7.2-16-16-16h-5.5c-13.9 0-27.5 3.6-39.4 10.4l-3.6-14.3zM164.7 212.7c6.2-6.2 16.4-6.2 22.6 0L208 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6zm-80 80c6.2-6.2 16.4-6.2 22.6 0L128 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6zm182.6 0L288 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM164.7 395.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 393.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32z"]
};
var faHandPointLeft = {
  prefix: 'fas',
  iconName: 'hand-point-left',
  icon: [512, 512, [], "f0a5", "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0V96L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm-64-64c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32H352c88.4 0 160-71.6 160-160V226.3c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64v88c0 22.1 17.9 40 40 40s40-17.9 40-40V160c0-8.8 7.2-16 16-16s16 7.2 16 16v56c0 39.8-32.2 72-72 72z"]
};
var faGalleryThumbnails = {
  prefix: 'fas',
  iconName: 'gallery-thumbnails',
  icon: [576, 512, [], "e3aa", "M512 64V288H64L64 64H512zM64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM0 448v32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H192zm128 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H512z"]
};
var faCircleJ = {
  prefix: 'fas',
  iconName: 'circle-j',
  icon: [512, 512, [], "e112", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-360V288c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faEyes = {
  prefix: 'fas',
  iconName: 'eyes',
  icon: [640, 512, [], "e367", "M96 224c-11.1 0-21.6 2.8-30.7 7.8c4-36.7 16.8-68.8 34.5-92.4C121.3 110.8 148.6 96 176 96s54.7 14.8 76.2 43.4C273.7 168.1 288 209.2 288 256s-14.3 87.9-35.8 116.6S203.4 416 176 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3c3.1 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64zm224-97.3c-5-9.1-10.5-17.6-16.6-25.7C272.8 60.2 228.1 32 176 32s-96.8 28.2-127.4 69C18 141.8 0 196.7 0 256s18 114.2 48.6 155c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69c6-8 11.6-16.6 16.6-25.7c5 9.1 10.5 17.6 16.6 25.7c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69C622 370.2 640 315.3 640 256s-18-114.2-48.6-155C560.8 60.2 516.1 32 464 32s-96.8 28.2-127.4 69c-6 8-11.6 16.6-16.6 25.7zm54.4 224.6c3.1 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8c4-36.7 16.8-68.8 34.5-92.4C409.3 110.8 436.6 96 464 96s54.7 14.8 76.2 43.4C561.7 168.1 576 209.2 576 256s-14.3 87.9-35.8 116.6S491.4 416 464 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3z"]
};
var faHandshakeSimple = {
  prefix: 'fas',
  iconName: 'handshake-simple',
  icon: [640, 512, [129309, "handshake-alt"], "f4c6", "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"]
};
var faHandshakeAlt = faHandshakeSimple;
var faPageCaretUp = {
  prefix: 'fas',
  iconName: 'page-caret-up',
  icon: [384, 512, ["file-caret-up"], "e42a", "M320 512c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320zM192 192c4.5 0 8.8 1.9 11.8 5.2l75.7 82.6c14.1 15.4 3.2 40.2-17.7 40.2H122.2c-20.9 0-31.8-24.8-17.7-40.2l75.7-82.6c3-3.3 7.3-5.2 11.8-5.2z"]
};
var faFileCaretUp = faPageCaretUp;
var faJetFighter = {
  prefix: 'fas',
  iconName: 'jet-fighter',
  icon: [640, 512, ["fighter-jet"], "f0fb", "M160 24c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H280L384 192H500.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H82.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faFighterJet = faJetFighter;
var faComet = {
  prefix: 'fas',
  iconName: 'comet',
  icon: [512, 512, [], "e003", "M299.4 75.6L493.7 .9c1.5-.6 3.2-.9 4.8-.9C506 0 512 6 512 13.5c0 1.7-.3 3.3-.9 4.8L436.4 212.6l29.3-2.3c12.8-1 21.5 12.8 15.1 24L378.6 410.7C342.3 473.4 275.4 512 203 512C90.9 512 0 421.1 0 309c0-72.4 38.6-139.4 101.3-175.7L277.7 31.2c11.1-6.5 25 2.2 24 15.1l-2.3 29.3zM192 200c-6.1 0-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2L192 402.1l58.4 30.7c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2c-2.7-5.5-8.3-8.9-14.3-8.9z"]
};
var faSquareShareNodes = {
  prefix: 'fas',
  iconName: 'square-share-nodes',
  icon: [448, 512, ["share-alt-square"], "f1e1", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
var faShareAltSquare = faSquareShareNodes;
var faShieldKeyhole = {
  prefix: 'fas',
  iconName: 'shield-keyhole',
  icon: [512, 512, [], "e248", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM312 208c0 22.3-13.1 41.6-32 50.6V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V258.6c-18.9-9-32-28.3-32-50.6c0-30.9 25.1-56 56-56s56 25.1 56 56z"]
};
var faBarcode = {
  prefix: 'fas',
  iconName: 'barcode',
  icon: [512, 512, [], "f02a", "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faPlusMinus = {
  prefix: 'fas',
  iconName: 'plus-minus',
  icon: [384, 512, [], "e43c", "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V320c0 17.7 14.3 32 32 32s32-14.3 32-32V208H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32zM0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]
};
var faSquareSlidersVertical = {
  prefix: 'fas',
  iconName: 'square-sliders-vertical',
  icon: [448, 512, ["sliders-v-square"], "f3f2", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 0c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176V128c0-17.7-14.3-32-32-32zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V288H256c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v32c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H336V128z"]
};
var faSlidersVSquare = faSquareSlidersVertical;
var faVideo = {
  prefix: 'fas',
  iconName: 'video',
  icon: [576, 512, ["video-camera"], "f03d", "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"]
};
var faVideoCamera = faVideo;
var faMessageMiddle = {
  prefix: 'fas',
  iconName: 'message-middle',
  icon: [512, 512, ["comment-middle-alt"], "e1e1", "M343.5 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H168.5l75.2 90.2c3 3.6 7.5 5.8 12.3 5.8s9.3-2.1 12.3-5.8L343.5 416z"]
};
var faCommentMiddleAlt = faMessageMiddle;
var faGraduationCap = {
  prefix: 'fas',
  iconName: 'graduation-cap',
  icon: [640, 512, [127891, "mortar-board"], "f19d", "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"]
};
var faMortarBoard = faGraduationCap;
var faHandHoldingMedical = {
  prefix: 'fas',
  iconName: 'hand-holding-medical',
  icon: [576, 512, [], "e05c", "M224 24V80H168c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176h56c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H320V24c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0 0 0c-.3 0-.6 0-.9 0z"]
};
var faPersonCircleCheck = {
  prefix: 'fas',
  iconName: 'person-circle-check',
  icon: [576, 512, [], "e53e", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faSquareZ = {
  prefix: 'fas',
  iconName: 'square-z',
  icon: [448, 512, [], "e288", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm72 96H312c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176H136c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMessageText = {
  prefix: 'fas',
  iconName: 'message-text',
  icon: [512, 512, ["comment-alt-text"], "e1e6", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm168 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h64V296c0 13.3 10.7 24 24 24s24-10.7 24-24V160h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 168z"]
};
var faCommentAltText = faMessageText;
var faTurnUp = {
  prefix: 'fas',
  iconName: 'turn-up',
  icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5h88l0 192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192h88c9.6 0 18.2-5.7 22-14.5z"]
};
var faLevelUpAlt = faTurnUp;
var icons = {
  fa0: fa0,
  fa1: fa1,
  fa2: fa2,
  fa3: fa3,
  fa4: fa4,
  fa5: fa5,
  fa6: fa6,
  fa7: fa7,
  fa8: fa8,
  fa9: fa9,
  faFillDrip: faFillDrip,
  faArrowsToCircle: faArrowsToCircle,
  faCircleChevronRight: faCircleChevronRight,
  faChevronCircleRight: faChevronCircleRight,
  faWagonCovered: faWagonCovered,
  faLineHeight: faLineHeight,
  faBagel: faBagel,
  faTransporter7: faTransporter7,
  faAt: faAt,
  faRectanglesMixed: faRectanglesMixed,
  faPhoneArrowUpRight: faPhoneArrowUpRight,
  faPhoneArrowUp: faPhoneArrowUp,
  faPhoneOutgoing: faPhoneOutgoing,
  faTrashCan: faTrashCan,
  faTrashAlt: faTrashAlt,
  faCircleL: faCircleL,
  faHeadSideGoggles: faHeadSideGoggles,
  faHeadVr: faHeadVr,
  faTextHeight: faTextHeight,
  faUserXmark: faUserXmark,
  faUserTimes: faUserTimes,
  faFaceHandYawn: faFaceHandYawn,
  faGaugeSimpleMin: faGaugeSimpleMin,
  faTachometerSlowest: faTachometerSlowest,
  faStethoscope: faStethoscope,
  faCoffin: faCoffin,
  faMessage: faMessage,
  faCommentAlt: faCommentAlt,
  faSalad: faSalad,
  faBowlSalad: faBowlSalad,
  faInfo: faInfo,
  faRobotAstromech: faRobotAstromech,
  faRingDiamond: faRingDiamond,
  faFonduePot: faFonduePot,
  faTheta: faTheta,
  faFaceHandPeeking: faFaceHandPeeking,
  faSquareUser: faSquareUser,
  faDownLeftAndUpRightToCenter: faDownLeftAndUpRightToCenter,
  faCompressAlt: faCompressAlt,
  faExplosion: faExplosion,
  faFileLines: faFileLines,
  faFileAlt: faFileAlt,
  faFileText: faFileText,
  faWaveSquare: faWaveSquare,
  faRing: faRing,
  faBuildingUn: faBuildingUn,
  faDiceThree: faDiceThree,
  faTirePressureWarning: faTirePressureWarning,
  faWifiFair: faWifiFair,
  faWifi2: faWifi2,
  faCalendarDays: faCalendarDays,
  faCalendarAlt: faCalendarAlt,
  faMp3Player: faMp3Player,
  faAnchorCircleCheck: faAnchorCircleCheck,
  faTally4: faTally4,
  faRectangleHistory: faRectangleHistory,
  faBuildingCircleArrowRight: faBuildingCircleArrowRight,
  faVolleyball: faVolleyball,
  faVolleyballBall: faVolleyballBall,
  faSunHaze: faSunHaze,
  faTextSize: faTextSize,
  faUfo: faUfo,
  faFork: faFork,
  faUtensilFork: faUtensilFork,
  faArrowsUpToLine: faArrowsUpToLine,
  faMobileSignal: faMobileSignal,
  faBarcodeScan: faBarcodeScan,
  faSortDown: faSortDown,
  faSortDesc: faSortDesc,
  faFolderArrowDown: faFolderArrowDown,
  faFolderDownload: faFolderDownload,
  faCircleMinus: faCircleMinus,
  faMinusCircle: faMinusCircle,
  faFaceIcicles: faFaceIcicles,
  faShovel: faShovel,
  faDoorOpen: faDoorOpen,
  faFilms: faFilms,
  faRightFromBracket: faRightFromBracket,
  faSignOutAlt: faSignOutAlt,
  faFaceGlasses: faFaceGlasses,
  faNfc: faNfc,
  faAtom: faAtom,
  faSoap: faSoap,
  faIcons: faIcons,
  faHeartMusicCameraBolt: faHeartMusicCameraBolt,
  faMicrophoneLinesSlash: faMicrophoneLinesSlash,
  faMicrophoneAltSlash: faMicrophoneAltSlash,
  faClosedCaptioningSlash: faClosedCaptioningSlash,
  faCalculatorSimple: faCalculatorSimple,
  faCalculatorAlt: faCalculatorAlt,
  faBridgeCircleCheck: faBridgeCircleCheck,
  faSlidersUp: faSlidersUp,
  faSlidersV: faSlidersV,
  faLocationMinus: faLocationMinus,
  faMapMarkerMinus: faMapMarkerMinus,
  faPumpMedical: faPumpMedical,
  faFingerprint: faFingerprint,
  faSkiBoot: faSkiBoot,
  faStandardDefinition: faStandardDefinition,
  faRectangleSd: faRectangleSd,
  faH1: faH1,
  faHandPointRight: faHandPointRight,
  faMagnifyingGlassLocation: faMagnifyingGlassLocation,
  faSearchLocation: faSearchLocation,
  faMessageBot: faMessageBot,
  faForwardStep: faForwardStep,
  faStepForward: faStepForward,
  faFaceSmileBeam: faFaceSmileBeam,
  faSmileBeam: faSmileBeam,
  faLightCeiling: faLightCeiling,
  faMessageExclamation: faMessageExclamation,
  faCommentAltExclamation: faCommentAltExclamation,
  faBowlScoop: faBowlScoop,
  faBowlShavedIce: faBowlShavedIce,
  faSquareX: faSquareX,
  faUtilityPoleDouble: faUtilityPoleDouble,
  faFlagCheckered: faFlagCheckered,
  faChevronsUp: faChevronsUp,
  faChevronDoubleUp: faChevronDoubleUp,
  faFootball: faFootball,
  faFootballBall: faFootballBall,
  faUserVneck: faUserVneck,
  faSchoolCircleExclamation: faSchoolCircleExclamation,
  faCrop: faCrop,
  faAnglesDown: faAnglesDown,
  faAngleDoubleDown: faAngleDoubleDown,
  faUsersRectangle: faUsersRectangle,
  faPeopleRoof: faPeopleRoof,
  faSquareArrowRight: faSquareArrowRight,
  faArrowSquareRight: faArrowSquareRight,
  faLocationPlus: faLocationPlus,
  faMapMarkerPlus: faMapMarkerPlus,
  faLightbulbExclamationOn: faLightbulbExclamationOn,
  faPeopleLine: faPeopleLine,
  faBeerMugEmpty: faBeerMugEmpty,
  faBeer: faBeer,
  faCrateEmpty: faCrateEmpty,
  faDiagramPredecessor: faDiagramPredecessor,
  faTransporter: faTransporter,
  faCalendarCircleUser: faCalendarCircleUser,
  faArrowUpLong: faArrowUpLong,
  faLongArrowUp: faLongArrowUp,
  faPersonCarryBox: faPersonCarryBox,
  faPersonCarry: faPersonCarry,
  faFireFlameSimple: faFireFlameSimple,
  faBurn: faBurn,
  faPerson: faPerson,
  faMale: faMale,
  faLaptop: faLaptop,
  faFileCsv: faFileCsv,
  faMenorah: faMenorah,
  faUnion: faUnion,
  faChevronsLeft: faChevronsLeft,
  faChevronDoubleLeft: faChevronDoubleLeft,
  faCircleHeart: faCircleHeart,
  faHeartCircle: faHeartCircle,
  faTruckPlane: faTruckPlane,
  faRecordVinyl: faRecordVinyl,
  faBringForward: faBringForward,
  faSquareP: faSquareP,
  faFaceGrinStars: faFaceGrinStars,
  faGrinStars: faGrinStars,
  faSigma: faSigma,
  faCameraMovie: faCameraMovie,
  faBong: faBong,
  faClarinet: faClarinet,
  faTruckFlatbed: faTruckFlatbed,
  faSpaghettiMonsterFlying: faSpaghettiMonsterFlying,
  faPastafarianism: faPastafarianism,
  faArrowDownUpAcrossLine: faArrowDownUpAcrossLine,
  faLeafHeart: faLeafHeart,
  faHouseBuilding: faHouseBuilding,
  faCheeseSwiss: faCheeseSwiss,
  faSpoon: faSpoon,
  faUtensilSpoon: faUtensilSpoon,
  faJarWheat: faJarWheat,
  faEnvelopesBulk: faEnvelopesBulk,
  faMailBulk: faMailBulk,
  faFileCircleExclamation: faFileCircleExclamation,
  faBowArrow: faBowArrow,
  faCartXmark: faCartXmark,
  faHexagonXmark: faHexagonXmark,
  faTimesHexagon: faTimesHexagon,
  faXmarkHexagon: faXmarkHexagon,
  faCircleH: faCircleH,
  faHospitalSymbol: faHospitalSymbol,
  faMerge: faMerge,
  faPager: faPager,
  faCartMinus: faCartMinus,
  faAddressBook: faAddressBook,
  faContactBook: faContactBook,
  faPanFrying: faPanFrying,
  faGrid: faGrid,
  faGrid3: faGrid3,
  faFootballHelmet: faFootballHelmet,
  faHandLove: faHandLove,
  faTrees: faTrees,
  faStrikethrough: faStrikethrough,
  faPage: faPage,
  faK: faK,
  faDiagramPrevious: faDiagramPrevious,
  faGaugeMin: faGaugeMin,
  faTachometerAltSlowest: faTachometerAltSlowest,
  faFolderGrid: faFolderGrid,
  faEggplant: faEggplant,
  faRam: faRam,
  faLandmarkFlag: faLandmarkFlag,
  faLips: faLips,
  faPencil: faPencil,
  faPencilAlt: faPencilAlt,
  faBackward: faBackward,
  faCaretRight: faCaretRight,
  faComments: faComments,
  faPaste: faPaste,
  faFileClipboard: faFileClipboard,
  faDesktopArrowDown: faDesktopArrowDown,
  faCodePullRequest: faCodePullRequest,
  faPumpkin: faPumpkin,
  faClipboardList: faClipboardList,
  faPenField: faPenField,
  faBlueberries: faBlueberries,
  faTruckRampBox: faTruckRampBox,
  faTruckLoading: faTruckLoading,
  faNote: faNote,
  faArrowDownToSquare: faArrowDownToSquare,
  faUserCheck: faUserCheck,
  faCloudXmark: faCloudXmark,
  faVialVirus: faVialVirus,
  faBookBlank: faBookBlank,
  faBookAlt: faBookAlt,
  faGolfFlagHole: faGolfFlagHole,
  faMessageArrowDown: faMessageArrowDown,
  faCommentAltArrowDown: faCommentAltArrowDown,
  faFaceUnamused: faFaceUnamused,
  faSheetPlastic: faSheetPlastic,
  faCircle9: faCircle9,
  faBlog: faBlog,
  faUserNinja: faUserNinja,
  faPencilSlash: faPencilSlash,
  faBowlingPins: faBowlingPins,
  faPersonArrowUpFromLine: faPersonArrowUpFromLine,
  faDownRight: faDownRight,
  faScrollTorah: faScrollTorah,
  faTorah: faTorah,
  faWebhook: faWebhook,
  faBlindsOpen: faBlindsOpen,
  faFence: faFence,
  faUp: faUp,
  faArrowAltUp: faArrowAltUp,
  faBroomBall: faBroomBall,
  faQuidditch: faQuidditch,
  faQuidditchBroomBall: faQuidditchBroomBall,
  faDrumstick: faDrumstick,
  faSquareV: faSquareV,
  faFaceAwesome: faFaceAwesome,
  faGaveDandy: faGaveDandy,
  faDialOff: faDialOff,
  faToggleOff: faToggleOff,
  faFaceSmileHorns: faFaceSmileHorns,
  faBoxArchive: faBoxArchive,
  faArchive: faArchive,
  faGrapes: faGrapes,
  faPersonDrowning: faPersonDrowning,
  faDialMax: faDialMax,
  faCircleM: faCircleM,
  faCalendarImage: faCalendarImage,
  faCircleCaretDown: faCircleCaretDown,
  faCaretCircleDown: faCaretCircleDown,
  faArrowDown91: faArrowDown91,
  faSortNumericDesc: faSortNumericDesc,
  faSortNumericDownAlt: faSortNumericDownAlt,
  faFaceGrinTongueSquint: faFaceGrinTongueSquint,
  faGrinTongueSquint: faGrinTongueSquint,
  faShishKebab: faShishKebab,
  faSprayCan: faSprayCan,
  faAlarmSnooze: faAlarmSnooze,
  faScarecrow: faScarecrow,
  faTruckMonster: faTruckMonster,
  faGiftCard: faGiftCard,
  faW: faW,
  faCodePullRequestDraft: faCodePullRequestDraft,
  faSquareB: faSquareB,
  faElephant: faElephant,
  faEarthAfrica: faEarthAfrica,
  faGlobeAfrica: faGlobeAfrica,
  faRainbow: faRainbow,
  faCircleNotch: faCircleNotch,
  faTabletScreenButton: faTabletScreenButton,
  faTabletAlt: faTabletAlt,
  faPaw: faPaw,
  faMessageQuestion: faMessageQuestion,
  faCloud: faCloud,
  faTrowelBricks: faTrowelBricks,
  faSquare3: faSquare3,
  faFaceFlushed: faFaceFlushed,
  faFlushed: faFlushed,
  faHospitalUser: faHospitalUser,
  faMicrowave: faMicrowave,
  faChfSign: faChfSign,
  faTentArrowLeftRight: faTentArrowLeftRight,
  faCartCircleArrowUp: faCartCircleArrowUp,
  faTrashClock: faTrashClock,
  faGavel: faGavel,
  faLegal: faLegal,
  faSprinklerCeiling: faSprinklerCeiling,
  faBrowsers: faBrowsers,
  faTrillium: faTrillium,
  faMusicSlash: faMusicSlash,
  faTruckRamp: faTruckRamp,
  faBinoculars: faBinoculars,
  faMicrophoneSlash: faMicrophoneSlash,
  faBoxTissue: faBoxTissue,
  faCircleC: faCircleC,
  faStarChristmas: faStarChristmas,
  faChartBullet: faChartBullet,
  faMotorcycle: faMotorcycle,
  faTreeChristmas: faTreeChristmas,
  faTireFlat: faTireFlat,
  faSunglasses: faSunglasses,
  faBadge: faBadge,
  faMessagePen: faMessagePen,
  faCommentAltEdit: faCommentAltEdit,
  faMessageEdit: faMessageEdit,
  faBellConcierge: faBellConcierge,
  faConciergeBell: faConciergeBell,
  faPenRuler: faPenRuler,
  faPencilRuler: faPencilRuler,
  faArrowProgress: faArrowProgress,
  faChessRookPiece: faChessRookPiece,
  faChessRookAlt: faChessRookAlt,
  faSquareRoot: faSquareRoot,
  faAlbumCollectionCirclePlus: faAlbumCollectionCirclePlus,
  faPeopleArrows: faPeopleArrows,
  faPeopleArrowsLeftRight: faPeopleArrowsLeftRight,
  faFaceAngryHorns: faFaceAngryHorns,
  faMarsAndVenusBurst: faMarsAndVenusBurst,
  faTombstone: faTombstone,
  faSquareCaretRight: faSquareCaretRight,
  faCaretSquareRight: faCaretSquareRight,
  faScissors: faScissors,
  faCut: faCut,
  faListMusic: faListMusic,
  faSunPlantWilt: faSunPlantWilt,
  faToiletsPortable: faToiletsPortable,
  faHockeyPuck: faHockeyPuck,
  faMustache: faMustache,
  faHyphen: faHyphen,
  faTable: faTable,
  faUserChef: faUserChef,
  faMessageImage: faMessageImage,
  faCommentAltImage: faCommentAltImage,
  faUsersMedical: faUsersMedical,
  faSensorTriangleExclamation: faSensorTriangleExclamation,
  faSensorAlert: faSensorAlert,
  faMagnifyingGlassArrowRight: faMagnifyingGlassArrowRight,
  faTachographDigital: faTachographDigital,
  faDigitalTachograph: faDigitalTachograph,
  faFaceMask: faFaceMask,
  faPickleball: faPickleball,
  faStarSharpHalf: faStarSharpHalf,
  faUsersSlash: faUsersSlash,
  faClover: faClover,
  faMeat: faMeat,
  faReply: faReply,
  faMailReply: faMailReply,
  faStarAndCrescent: faStarAndCrescent,
  faEmptySet: faEmptySet,
  faHouseFire: faHouseFire,
  faSquareMinus: faSquareMinus,
  faMinusSquare: faMinusSquare,
  faHelicopter: faHelicopter,
  faBird: faBird,
  faCompass: faCompass,
  faSquareCaretDown: faSquareCaretDown,
  faCaretSquareDown: faCaretSquareDown,
  faHeartHalfStroke: faHeartHalfStroke,
  faHeartHalfAlt: faHeartHalfAlt,
  faFileCircleQuestion: faFileCircleQuestion,
  faLaptopCode: faLaptopCode,
  faJoystick: faJoystick,
  faGrillFire: faGrillFire,
  faRectangleVerticalHistory: faRectangleVerticalHistory,
  faSwatchbook: faSwatchbook,
  faPrescriptionBottle: faPrescriptionBottle,
  faBars: faBars,
  faNavicon: faNavicon,
  faKeyboardLeft: faKeyboardLeft,
  faPeopleGroup: faPeopleGroup,
  faHourglassEnd: faHourglassEnd,
  faHourglass3: faHourglass3,
  faHeartCrack: faHeartCrack,
  faHeartBroken: faHeartBroken,
  faFaceBeamHandOverMouth: faFaceBeamHandOverMouth,
  faDropletPercent: faDropletPercent,
  faHumidity: faHumidity,
  faSquareUpRight: faSquareUpRight,
  faExternalLinkSquareAlt: faExternalLinkSquareAlt,
  faFaceKissBeam: faFaceKissBeam,
  faKissBeam: faKissBeam,
  faCorn: faCorn,
  faRollerCoaster: faRollerCoaster,
  faPhotoFilmMusic: faPhotoFilmMusic,
  faRadar: faRadar,
  faSickle: faSickle,
  faFilm: faFilm,
  faCoconut: faCoconut,
  faRulerHorizontal: faRulerHorizontal,
  faShieldCross: faShieldCross,
  faCassetteTape: faCassetteTape,
  faSquareTerminal: faSquareTerminal,
  faPeopleRobbery: faPeopleRobbery,
  faLightbulb: faLightbulb,
  faCaretLeft: faCaretLeft,
  faCommentMiddle: faCommentMiddle,
  faTrashCanList: faTrashCanList,
  faBlock: faBlock,
  faCircleExclamation: faCircleExclamation,
  faExclamationCircle: faExclamationCircle,
  faSchoolCircleXmark: faSchoolCircleXmark,
  faArrowRightFromBracket: faArrowRightFromBracket,
  faSignOut: faSignOut,
  faFaceFrownSlight: faFaceFrownSlight,
  faCircleChevronDown: faCircleChevronDown,
  faChevronCircleDown: faChevronCircleDown,
  faSidebarFlip: faSidebarFlip,
  faUnlockKeyhole: faUnlockKeyhole,
  faUnlockAlt: faUnlockAlt,
  faTemperatureList: faTemperatureList,
  faCloudShowersHeavy: faCloudShowersHeavy,
  faHeadphonesSimple: faHeadphonesSimple,
  faHeadphonesAlt: faHeadphonesAlt,
  faSitemap: faSitemap,
  faPipeSection: faPipeSection,
  faSpaceStationMoonConstruction: faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt: faSpaceStationMoonAlt,
  faCircleDollarToSlot: faCircleDollarToSlot,
  faDonate: faDonate,
  faMemory: faMemory,
  faFaceSleeping: faFaceSleeping,
  faRoadSpikes: faRoadSpikes,
  faFireBurner: faFireBurner,
  faSquirrel: faSquirrel,
  faArrowUpToLine: faArrowUpToLine,
  faArrowToTop: faArrowToTop,
  faFlag: faFlag,
  faFaceCowboyHat: faFaceCowboyHat,
  faHanukiah: faHanukiah,
  faChartScatter3d: faChartScatter3d,
  faDisplayChartUp: faDisplayChartUp,
  faSquareCode: faSquareCode,
  faFeather: faFeather,
  faVolumeLow: faVolumeLow,
  faVolumeDown: faVolumeDown,
  faXmarkToSlot: faXmarkToSlot,
  faTimesToSlot: faTimesToSlot,
  faVoteNay: faVoteNay,
  faBoxTaped: faBoxTaped,
  faBoxAlt: faBoxAlt,
  faCommentSlash: faCommentSlash,
  faSwords: faSwords,
  faCloudSunRain: faCloudSunRain,
  faAlbum: faAlbum,
  faCircleN: faCircleN,
  faCompress: faCompress,
  faWheatAwn: faWheatAwn,
  faWheatAlt: faWheatAlt,
  faAnkh: faAnkh,
  faHandsHoldingChild: faHandsHoldingChild,
  faAsterisk: faAsterisk,
  faKeySkeletonLeftRight: faKeySkeletonLeftRight,
  faCommentLines: faCommentLines,
  faLuchadorMask: faLuchadorMask,
  faLuchador: faLuchador,
  faMaskLuchador: faMaskLuchador,
  faSquareCheck: faSquareCheck,
  faCheckSquare: faCheckSquare,
  faShredder: faShredder,
  faBookOpenCover: faBookOpenCover,
  faBookOpenAlt: faBookOpenAlt,
  faSandwich: faSandwich,
  faPesetaSign: faPesetaSign,
  faSquareParkingSlash: faSquareParkingSlash,
  faParkingSlash: faParkingSlash,
  faTrainTunnel: faTrainTunnel,
  faHeading: faHeading,
  faHeader: faHeader,
  faGhost: faGhost,
  faFaceAnguished: faFaceAnguished,
  faHockeySticks: faHockeySticks,
  faAbacus: faAbacus,
  faFilmSimple: faFilmSimple,
  faFilmAlt: faFilmAlt,
  faList: faList,
  faListSquares: faListSquares,
  faTreePalm: faTreePalm,
  faSquarePhoneFlip: faSquarePhoneFlip,
  faPhoneSquareAlt: faPhoneSquareAlt,
  faCartPlus: faCartPlus,
  faGamepad: faGamepad,
  faBorderCenterV: faBorderCenterV,
  faCircleDot: faCircleDot,
  faDotCircle: faDotCircle,
  faClipboardMedical: faClipboardMedical,
  faFaceDizzy: faFaceDizzy,
  faDizzy: faDizzy,
  faEgg: faEgg,
  faUpToLine: faUpToLine,
  faArrowAltToTop: faArrowAltToTop,
  faHouseMedicalCircleXmark: faHouseMedicalCircleXmark,
  faWatchFitness: faWatchFitness,
  faClockNineThirty: faClockNineThirty,
  faCampground: faCampground,
  faFolderPlus: faFolderPlus,
  faJug: faJug,
  faFutbol: faFutbol,
  faFutbolBall: faFutbolBall,
  faSoccerBall: faSoccerBall,
  faSnowBlowing: faSnowBlowing,
  faPaintbrush: faPaintbrush,
  faPaintBrush: faPaintBrush,
  faLock: faLock,
  faArrowDownFromLine: faArrowDownFromLine,
  faArrowFromTop: faArrowFromTop,
  faGasPump: faGasPump,
  faSignalBarsSlash: faSignalBarsSlash,
  faSignalAltSlash: faSignalAltSlash,
  faMonkey: faMonkey,
  faRectanglePro: faRectanglePro,
  faPro: faPro,
  faHouseNight: faHouseNight,
  faHotTubPerson: faHotTubPerson,
  faHotTub: faHotTub,
  faBlanket: faBlanket,
  faMapLocation: faMapLocation,
  faMapMarked: faMapMarked,
  faHouseFloodWater: faHouseFloodWater,
  faCommentsQuestionCheck: faCommentsQuestionCheck,
  faTree: faTree,
  faArrowsCross: faArrowsCross,
  faBackpack: faBackpack,
  faSquareSmall: faSquareSmall,
  faFolderArrowUp: faFolderArrowUp,
  faFolderUpload: faFolderUpload,
  faBridgeLock: faBridgeLock,
  faCrosshairsSimple: faCrosshairsSimple,
  faSackDollar: faSackDollar,
  faPenToSquare: faPenToSquare,
  faEdit: faEdit,
  faSquareSliders: faSquareSliders,
  faSlidersHSquare: faSlidersHSquare,
  faCarSide: faCarSide,
  faMessageMiddleTop: faMessageMiddleTop,
  faCommentMiddleTopAlt: faCommentMiddleTopAlt,
  faLightbulbOn: faLightbulbOn,
  faKnife: faKnife,
  faUtensilKnife: faUtensilKnife,
  faShareNodes: faShareNodes,
  faShareAlt: faShareAlt,
  faDisplayChartUpCircleDollar: faDisplayChartUpCircleDollar,
  faWaveSine: faWaveSine,
  faHeartCircleMinus: faHeartCircleMinus,
  faCircleW: faCircleW,
  faCircleCalendar: faCircleCalendar,
  faCalendarCircle: faCalendarCircle,
  faHourglassHalf: faHourglassHalf,
  faHourglass2: faHourglass2,
  faMicroscope: faMicroscope,
  faSunset: faSunset,
  faSink: faSink,
  faCalendarExclamation: faCalendarExclamation,
  faTruckContainerEmpty: faTruckContainerEmpty,
  faHandHeart: faHandHeart,
  faBagShopping: faBagShopping,
  faShoppingBag: faShoppingBag,
  faArrowDownZA: faArrowDownZA,
  faSortAlphaDesc: faSortAlphaDesc,
  faSortAlphaDownAlt: faSortAlphaDownAlt,
  faMitten: faMitten,
  faReplyClock: faReplyClock,
  faReplyTime: faReplyTime,
  faPersonRays: faPersonRays,
  faRight: faRight,
  faArrowAltRight: faArrowAltRight,
  faCircleF: faCircleF,
  faUsers: faUsers,
  faFacePleading: faFacePleading,
  faEyeSlash: faEyeSlash,
  faFlaskVial: faFlaskVial,
  faPoliceBox: faPoliceBox,
  faCucumber: faCucumber,
  faHeadSideBrain: faHeadSideBrain,
  faHand: faHand,
  faHandPaper: faHandPaper,
  faPersonBikingMountain: faPersonBikingMountain,
  faBikingMountain: faBikingMountain,
  faUtensilsSlash: faUtensilsSlash,
  faPrintMagnifyingGlass: faPrintMagnifyingGlass,
  faPrintSearch: faPrintSearch,
  faFolderBookmark: faFolderBookmark,
  faOm: faOm,
  faPi: faPi,
  faFlaskRoundPotion: faFlaskRoundPotion,
  faFlaskPotion: faFlaskPotion,
  faFaceShush: faFaceShush,
  faWorm: faWorm,
  faHouseCircleXmark: faHouseCircleXmark,
  faPlug: faPlug,
  faCalendarCircleExclamation: faCalendarCircleExclamation,
  faSquareI: faSquareI,
  faChevronUp: faChevronUp,
  faFaceSaluting: faFaceSaluting,
  faGaugeSimpleLow: faGaugeSimpleLow,
  faTachometerSlow: faTachometerSlow,
  faFacePersevering: faFacePersevering,
  faCircleCamera: faCircleCamera,
  faCameraCircle: faCameraCircle,
  faHandSpock: faHandSpock,
  faSpiderWeb: faSpiderWeb,
  faCircleMicrophone: faCircleMicrophone,
  faMicrophoneCircle: faMicrophoneCircle,
  faBookArrowUp: faBookArrowUp,
  faPopsicle: faPopsicle,
  faCommand: faCommand,
  faBlinds: faBlinds,
  faStopwatch: faStopwatch,
  faSaxophone: faSaxophone,
  faSquare2: faSquare2,
  faFieldHockeyStickBall: faFieldHockeyStickBall,
  faFieldHockey: faFieldHockey,
  faArrowUpSquareTriangle: faArrowUpSquareTriangle,
  faSortShapesUpAlt: faSortShapesUpAlt,
  faFaceScream: faFaceScream,
  faSquareM: faSquareM,
  faCameraWeb: faCameraWeb,
  faWebcam: faWebcam,
  faCommentArrowDown: faCommentArrowDown,
  faLightbulbCfl: faLightbulbCfl,
  faWindowFrameOpen: faWindowFrameOpen,
  faFaceKiss: faFaceKiss,
  faKiss: faKiss,
  faBridgeCircleXmark: faBridgeCircleXmark,
  faPeriod: faPeriod,
  faFaceGrinTongue: faFaceGrinTongue,
  faGrinTongue: faGrinTongue,
  faUpToDottedLine: faUpToDottedLine,
  faThoughtBubble: faThoughtBubble,
  faSkeletonRibs: faSkeletonRibs,
  faRaygun: faRaygun,
  faFlute: faFlute,
  faAcorn: faAcorn,
  faVideoArrowUpRight: faVideoArrowUpRight,
  faGrateDroplet: faGrateDroplet,
  faSealExclamation: faSealExclamation,
  faChessBishop: faChessBishop,
  faMessageSms: faMessageSms,
  faCoffeeBeans: faCoffeeBeans,
  faHatWitch: faHatWitch,
  faFaceGrinWink: faFaceGrinWink,
  faGrinWink: faGrinWink,
  faClockThreeThirty: faClockThreeThirty,
  faEarDeaf: faEarDeaf,
  faDeaf: faDeaf,
  faDeafness: faDeafness,
  faHardOfHearing: faHardOfHearing,
  faAlarmClock: faAlarmClock,
  faEclipse: faEclipse,
  faFaceRelieved: faFaceRelieved,
  faRoadCircleCheck: faRoadCircleCheck,
  faDiceFive: faDiceFive,
  faOctagonMinus: faOctagonMinus,
  faMinusOctagon: faMinusOctagon,
  faSquareRss: faSquareRss,
  faRssSquare: faRssSquare,
  faFaceZany: faFaceZany,
  faTricycle: faTricycle,
  faLandMineOn: faLandMineOn,
  faSquareArrowUpLeft: faSquareArrowUpLeft,
  faICursor: faICursor,
  faChartMixedUpCircleDollar: faChartMixedUpCircleDollar,
  faSaltShaker: faSaltShaker,
  faStamp: faStamp,
  faFilePlus: faFilePlus,
  faDrawSquare: faDrawSquare,
  faToiletPaperUnderSlash: faToiletPaperUnderSlash,
  faToiletPaperReverseSlash: faToiletPaperReverseSlash,
  faStairs: faStairs,
  faDroneFront: faDroneFront,
  faDroneAlt: faDroneAlt,
  faGlassEmpty: faGlassEmpty,
  faDialHigh: faDialHigh,
  faUserHelmetSafety: faUserHelmetSafety,
  faUserConstruction: faUserConstruction,
  faUserHardHat: faUserHardHat,
  faI: faI,
  faHryvniaSign: faHryvniaSign,
  faHryvnia: faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter: faArrowDownLeftAndArrowUpRightToCenter,
  faPills: faPills,
  faFaceGrinWide: faFaceGrinWide,
  faGrinAlt: faGrinAlt,
  faTooth: faTooth,
  faBasketballHoop: faBasketballHoop,
  faObjectsAlignBottom: faObjectsAlignBottom,
  faV: faV,
  faSparkles: faSparkles,
  faSquid: faSquid,
  faLeafyGreen: faLeafyGreen,
  faCircleArrowUpRight: faCircleArrowUpRight,
  faCalendars: faCalendars,
  faBangladeshiTakaSign: faBangladeshiTakaSign,
  faBicycle: faBicycle,
  faHammerWar: faHammerWar,
  faCircleD: faCircleD,
  faSpiderBlackWidow: faSpiderBlackWidow,
  faStaffSnake: faStaffSnake,
  faRodAsclepius: faRodAsclepius,
  faRodSnake: faRodSnake,
  faStaffAesculapius: faStaffAesculapius,
  faPear: faPear,
  faHeadSideCoughSlash: faHeadSideCoughSlash,
  faTriangle: faTriangle,
  faApartment: faApartment,
  faTruckMedical: faTruckMedical,
  faAmbulance: faAmbulance,
  faPepper: faPepper,
  faPiano: faPiano,
  faGunSquirt: faGunSquirt,
  faWheatAwnCircleExclamation: faWheatAwnCircleExclamation,
  faSnowman: faSnowman,
  faUserAlien: faUserAlien,
  faShieldCheck: faShieldCheck,
  faMortarPestle: faMortarPestle,
  faRoadBarrier: faRoadBarrier,
  faChartCandlestick: faChartCandlestick,
  faBriefcaseBlank: faBriefcaseBlank,
  faSchool: faSchool,
  faIgloo: faIgloo,
  faBracketRound: faBracketRound,
  faParenthesis: faParenthesis,
  faJoint: faJoint,
  faHorseSaddle: faHorseSaddle,
  faMugMarshmallows: faMugMarshmallows,
  faFilters: faFilters,
  faBellOn: faBellOn,
  faAngleRight: faAngleRight,
  faDialMed: faDialMed,
  faHorse: faHorse,
  faQ: faQ,
  faMonitorWaveform: faMonitorWaveform,
  faMonitorHeartRate: faMonitorHeartRate,
  faLinkSimple: faLinkSimple,
  faWhistle: faWhistle,
  faG: faG,
  faWineGlassCrack: faWineGlassCrack,
  faFragile: faFragile,
  faSlotMachine: faSlotMachine,
  faNotesMedical: faNotesMedical,
  faCarWash: faCarWash,
  faEscalator: faEscalator,
  faCommentImage: faCommentImage,
  faTemperatureHalf: faTemperatureHalf,
  faTemperature2: faTemperature2,
  faThermometer2: faThermometer2,
  faThermometerHalf: faThermometerHalf,
  faDongSign: faDongSign,
  faDonut: faDonut,
  faDoughnut: faDoughnut,
  faCapsules: faCapsules,
  faPooStorm: faPooStorm,
  faPooBolt: faPooBolt,
  faTally1: faTally1,
  faFaceFrownOpen: faFaceFrownOpen,
  faFrownOpen: faFrownOpen,
  faSquareDashed: faSquareDashed,
  faSquareJ: faSquareJ,
  faHandPointUp: faHandPointUp,
  faMoneyBill: faMoneyBill,
  faArrowUpBigSmall: faArrowUpBigSmall,
  faSortSizeUp: faSortSizeUp,
  faBarcodeRead: faBarcodeRead,
  faBaguette: faBaguette,
  faBowlSoftServe: faBowlSoftServe,
  faFaceHoldingBackTears: faFaceHoldingBackTears,
  faSquareUp: faSquareUp,
  faArrowAltSquareUp: faArrowAltSquareUp,
  faTrainSubwayTunnel: faTrainSubwayTunnel,
  faSubwayTunnel: faSubwayTunnel,
  faSquareExclamation: faSquareExclamation,
  faExclamationSquare: faExclamationSquare,
  faSemicolon: faSemicolon,
  faBookmark: faBookmark,
  faFanTable: faFanTable,
  faAlignJustify: faAlignJustify,
  faBatteryLow: faBatteryLow,
  faBattery1: faBattery1,
  faCreditCardFront: faCreditCardFront,
  faBrainArrowCurvedRight: faBrainArrowCurvedRight,
  faMindShare: faMindShare,
  faUmbrellaBeach: faUmbrellaBeach,
  faHelmetUn: faHelmetUn,
  faLocationSmile: faLocationSmile,
  faMapMarkerSmile: faMapMarkerSmile,
  faArrowLeftToLine: faArrowLeftToLine,
  faArrowToLeft: faArrowToLeft,
  faBullseye: faBullseye,
  faSushi: faSushi,
  faNigiri: faNigiri,
  faMessageCaptions: faMessageCaptions,
  faCommentAltCaptions: faCommentAltCaptions,
  faTrashList: faTrashList,
  faBacon: faBacon,
  faOption: faOption,
  faHandPointDown: faHandPointDown,
  faArrowUpFromBracket: faArrowUpFromBracket,
  faTrashPlus: faTrashPlus,
  faObjectsAlignTop: faObjectsAlignTop,
  faFolder: faFolder,
  faFolderBlank: faFolderBlank,
  faFaceAnxiousSweat: faFaceAnxiousSweat,
  faCreditCardBlank: faCreditCardBlank,
  faFileWaveform: faFileWaveform,
  faFileMedicalAlt: faFileMedicalAlt,
  faMicrochipAi: faMicrochipAi,
  faMug: faMug,
  faPlaneUpSlash: faPlaneUpSlash,
  faRadiation: faRadiation,
  faPenCircle: faPenCircle,
  faBagSeedling: faBagSeedling,
  faChartSimple: faChartSimple,
  faCrutches: faCrutches,
  faCircleParking: faCircleParking,
  faParkingCircle: faParkingCircle,
  faMarsStroke: faMarsStroke,
  faLeafOak: faLeafOak,
  faSquareBolt: faSquareBolt,
  faVial: faVial,
  faGauge: faGauge,
  faDashboard: faDashboard,
  faGaugeMed: faGaugeMed,
  faTachometerAltAverage: faTachometerAltAverage,
  faWandMagicSparkles: faWandMagicSparkles,
  faMagicWandSparkles: faMagicWandSparkles,
  faLambda: faLambda,
  faE: faE,
  faPizza: faPizza,
  faBowlChopsticksNoodles: faBowlChopsticksNoodles,
  faH3: faH3,
  faPenClip: faPenClip,
  faPenAlt: faPenAlt,
  faBridgeCircleExclamation: faBridgeCircleExclamation,
  faBadgePercent: faBadgePercent,
  faUser: faUser,
  faSensor: faSensor,
  faComma: faComma,
  faSchoolCircleCheck: faSchoolCircleCheck,
  faToiletPaperUnder: faToiletPaperUnder,
  faToiletPaperReverse: faToiletPaperReverse,
  faLightEmergency: faLightEmergency,
  faArrowDownToArc: faArrowDownToArc,
  faDumpster: faDumpster,
  faVanShuttle: faVanShuttle,
  faShuttleVan: faShuttleVan,
  faBuildingUser: faBuildingUser,
  faLightSwitch: faLightSwitch,
  faSquareCaretLeft: faSquareCaretLeft,
  faCaretSquareLeft: faCaretSquareLeft,
  faHighlighter: faHighlighter,
  faWavePulse: faWavePulse,
  faHeartRate: faHeartRate,
  faKey: faKey,
  faHatSanta: faHatSanta,
  faTamale: faTamale,
  faBoxCheck: faBoxCheck,
  faBullhorn: faBullhorn,
  faSteak: faSteak,
  faLocationCrosshairsSlash: faLocationCrosshairsSlash,
  faLocationSlash: faLocationSlash,
  faPersonDolly: faPersonDolly,
  faGlobe: faGlobe,
  faSynagogue: faSynagogue,
  faFileChartColumn: faFileChartColumn,
  faFileChartLine: faFileChartLine,
  faPersonHalfDress: faPersonHalfDress,
  faFolderImage: faFolderImage,
  faCalendarPen: faCalendarPen,
  faCalendarEdit: faCalendarEdit,
  faRoadBridge: faRoadBridge,
  faFaceSmileTear: faFaceSmileTear,
  faMessagePlus: faMessagePlus,
  faCommentAltPlus: faCommentAltPlus,
  faLocationArrow: faLocationArrow,
  faC: faC,
  faTabletButton: faTabletButton,
  faRectangleHistoryCircleUser: faRectangleHistoryCircleUser,
  faBuildingLock: faBuildingLock,
  faChartLineUp: faChartLineUp,
  faMailbox: faMailbox,
  faTruckBolt: faTruckBolt,
  faPizzaSlice: faPizzaSlice,
  faMoneyBillWave: faMoneyBillWave,
  faChartArea: faChartArea,
  faAreaChart: faAreaChart,
  faHouseFlag: faHouseFlag,
  faCircleThreeQuartersStroke: faCircleThreeQuartersStroke,
  faPersonCircleMinus: faPersonCircleMinus,
  faScalpel: faScalpel,
  faBan: faBan,
  faCancel: faCancel,
  faBellExclamation: faBellExclamation,
  faCircleBookmark: faCircleBookmark,
  faBookmarkCircle: faBookmarkCircle,
  faEggFried: faEggFried,
  faFaceWeary: faFaceWeary,
  faUniformMartialArts: faUniformMartialArts,
  faCameraRotate: faCameraRotate,
  faSunDust: faSunDust,
  faCommentText: faCommentText,
  faSprayCanSparkles: faSprayCanSparkles,
  faAirFreshener: faAirFreshener,
  faSignalBars: faSignalBars,
  faSignalAlt: faSignalAlt,
  faSignalAlt4: faSignalAlt4,
  faSignalBarsStrong: faSignalBarsStrong,
  faDiamondExclamation: faDiamondExclamation,
  faStar: faStar,
  faDialMin: faDialMin,
  faRepeat: faRepeat,
  faCross: faCross,
  faPageCaretDown: faPageCaretDown,
  faFileCaretDown: faFileCaretDown,
  faBox: faBox,
  faVenusMars: faVenusMars,
  faClockSevenThirty: faClockSevenThirty,
  faArrowPointer: faArrowPointer,
  faMousePointer: faMousePointer,
  faClockFourThirty: faClockFourThirty,
  faSignalBarsGood: faSignalBarsGood,
  faSignalAlt3: faSignalAlt3,
  faCactus: faCactus,
  faLightbulbGear: faLightbulbGear,
  faMaximize: faMaximize,
  faExpandArrowsAlt: faExpandArrowsAlt,
  faChargingStation: faChargingStation,
  faShapes: faShapes,
  faTriangleCircleSquare: faTriangleCircleSquare,
  faPlaneTail: faPlaneTail,
  faGaugeSimpleMax: faGaugeSimpleMax,
  faTachometerFastest: faTachometerFastest,
  faCircleU: faCircleU,
  faShieldSlash: faShieldSlash,
  faSquarePhoneHangup: faSquarePhoneHangup,
  faPhoneSquareDown: faPhoneSquareDown,
  faArrowUpLeft: faArrowUpLeft,
  faTransporter1: faTransporter1,
  faPeanuts: faPeanuts,
  faShuffle: faShuffle,
  faRandom: faRandom,
  faPersonRunning: faPersonRunning,
  faRunning: faRunning,
  faMobileRetro: faMobileRetro,
  faGripLinesVertical: faGripLinesVertical,
  faBinBottlesRecycle: faBinBottlesRecycle,
  faArrowUpFromSquare: faArrowUpFromSquare,
  faFileDashedLine: faFileDashedLine,
  faPageBreak: faPageBreak,
  faBracketCurlyRight: faBracketCurlyRight,
  faSpider: faSpider,
  faClockThree: faClockThree,
  faHandsBound: faHandsBound,
  faScalpelLineDashed: faScalpelLineDashed,
  faScalpelPath: faScalpelPath,
  faFileInvoiceDollar: faFileInvoiceDollar,
  faPipeSmoking: faPipeSmoking,
  faFaceAstonished: faFaceAstonished,
  faWindow: faWindow,
  faPlaneCircleExclamation: faPlaneCircleExclamation,
  faEar: faEar,
  faFileLock: faFileLock,
  faDiagramVenn: faDiagramVenn,
  faXRay: faXRay,
  faGoalNet: faGoalNet,
  faCoffinCross: faCoffinCross,
  faSpellCheck: faSpellCheck,
  faLocationXmark: faLocationXmark,
  faMapMarkerTimes: faMapMarkerTimes,
  faMapMarkerXmark: faMapMarkerXmark,
  faCircleQuarterStroke: faCircleQuarterStroke,
  faLasso: faLasso,
  faSlash: faSlash,
  faPersonToPortal: faPersonToPortal,
  faPortalEnter: faPortalEnter,
  faCalendarStar: faCalendarStar,
  faComputerMouse: faComputerMouse,
  faMouse: faMouse,
  faArrowRightToBracket: faArrowRightToBracket,
  faSignIn: faSignIn,
  faPegasus: faPegasus,
  faFilesMedical: faFilesMedical,
  faNfcLock: faNfcLock,
  faPersonSkiLift: faPersonSkiLift,
  faSkiLift: faSkiLift,
  faSquare6: faSquare6,
  faShopSlash: faShopSlash,
  faStoreAltSlash: faStoreAltSlash,
  faWindTurbine: faWindTurbine,
  faSlidersSimple: faSlidersSimple,
  faGridRound: faGridRound,
  faBadgeSheriff: faBadgeSheriff,
  faServer: faServer,
  faVirusCovidSlash: faVirusCovidSlash,
  faIntersection: faIntersection,
  faShopLock: faShopLock,
  faFamily: faFamily,
  faHourglassStart: faHourglassStart,
  faHourglass1: faHourglass1,
  faUserHairBuns: faUserHairBuns,
  faBlenderPhone: faBlenderPhone,
  faHourglassClock: faHourglassClock,
  faPersonSeatReclined: faPersonSeatReclined,
  faPaperPlaneTop: faPaperPlaneTop,
  faPaperPlaneAlt: faPaperPlaneAlt,
  faSend: faSend,
  faMessageArrowUp: faMessageArrowUp,
  faCommentAltArrowUp: faCommentAltArrowUp,
  faLightbulbExclamation: faLightbulbExclamation,
  faLayerMinus: faLayerMinus,
  faLayerGroupMinus: faLayerGroupMinus,
  faChartPieSimpleCircleCurrency: faChartPieSimpleCircleCurrency,
  faCircleE: faCircleE,
  faBuildingWheat: faBuildingWheat,
  faGaugeMax: faGaugeMax,
  faTachometerAltFastest: faTachometerAltFastest,
  faPersonBreastfeeding: faPersonBreastfeeding,
  faApostrophe: faApostrophe,
  faFireHydrant: faFireHydrant,
  faRightToBracket: faRightToBracket,
  faSignInAlt: faSignInAlt,
  faVideoPlus: faVideoPlus,
  faSquareRight: faSquareRight,
  faArrowAltSquareRight: faArrowAltSquareRight,
  faCommentSmile: faCommentSmile,
  faVenus: faVenus,
  faPassport: faPassport,
  faInboxIn: faInboxIn,
  faInboxArrowDown: faInboxArrowDown,
  faHeartPulse: faHeartPulse,
  faHeartbeat: faHeartbeat,
  faCircle8: faCircle8,
  faCloudsMoon: faCloudsMoon,
  faClockTenThirty: faClockTenThirty,
  faPeopleCarryBox: faPeopleCarryBox,
  faPeopleCarry: faPeopleCarry,
  faFolderUser: faFolderUser,
  faTrashCanXmark: faTrashCanXmark,
  faTemperatureHigh: faTemperatureHigh,
  faMicrochip: faMicrochip,
  faLeftLongToLine: faLeftLongToLine,
  faCrown: faCrown,
  faWeightHanging: faWeightHanging,
  faXmarksLines: faXmarksLines,
  faFilePrescription: faFilePrescription,
  faCalendarRange: faCalendarRange,
  faFlowerDaffodil: faFlowerDaffodil,
  faHandBackPointUp: faHandBackPointUp,
  faWeightScale: faWeightScale,
  faWeight: faWeight,
  faStarExclamation: faStarExclamation,
  faBooks: faBooks,
  faUserGroup: faUserGroup,
  faUserFriends: faUserFriends,
  faArrowUpAZ: faArrowUpAZ,
  faSortAlphaUp: faSortAlphaUp,
  faLayerPlus: faLayerPlus,
  faLayerGroupPlus: faLayerGroupPlus,
  faPlayPause: faPlayPause,
  faBlockQuestion: faBlockQuestion,
  faSnooze: faSnooze,
  faZzz: faZzz,
  faScannerImage: faScannerImage,
  faTvRetro: faTvRetro,
  faSquareT: faSquareT,
  faFarm: faFarm,
  faBarnSilo: faBarnSilo,
  faChessKnight: faChessKnight,
  faBarsSort: faBarsSort,
  faPalletBoxes: faPalletBoxes,
  faPaletteBoxes: faPaletteBoxes,
  faPalletAlt: faPalletAlt,
  faFaceLaughSquint: faFaceLaughSquint,
  faLaughSquint: faLaughSquint,
  faCodeSimple: faCodeSimple,
  faBoltSlash: faBoltSlash,
  faPanelFire: faPanelFire,
  faBinaryCircleCheck: faBinaryCircleCheck,
  faCommentMinus: faCommentMinus,
  faBurrito: faBurrito,
  faViolin: faViolin,
  faObjectsColumn: faObjectsColumn,
  faSquareChevronDown: faSquareChevronDown,
  faChevronSquareDown: faChevronSquareDown,
  faCommentPlus: faCommentPlus,
  faTriangleInstrument: faTriangleInstrument,
  faTriangleMusic: faTriangleMusic,
  faWheelchair: faWheelchair,
  faUserPilotTie: faUserPilotTie,
  faPianoKeyboard: faPianoKeyboard,
  faBedEmpty: faBedEmpty,
  faCircleArrowUp: faCircleArrowUp,
  faArrowCircleUp: faArrowCircleUp,
  faToggleOn: faToggleOn,
  faRectangleVertical: faRectangleVertical,
  faRectanglePortrait: faRectanglePortrait,
  faPersonWalking: faPersonWalking,
  faWalking: faWalking,
  faL: faL,
  faSignalStream: faSignalStream,
  faDownToBracket: faDownToBracket,
  faCircleZ: faCircleZ,
  faStars: faStars,
  faFire: faFire,
  faBedPulse: faBedPulse,
  faProcedures: faProcedures,
  faHouseDay: faHouseDay,
  faShuttleSpace: faShuttleSpace,
  faSpaceShuttle: faSpaceShuttle,
  faShirtLongSleeve: faShirtLongSleeve,
  faChartPieSimple: faChartPieSimple,
  faChartPieAlt: faChartPieAlt,
  faFaceLaugh: faFaceLaugh,
  faLaugh: faLaugh,
  faFolderOpen: faFolderOpen,
  faAlbumCollectionCircleUser: faAlbumCollectionCircleUser,
  faCandy: faCandy,
  faBowlHot: faBowlHot,
  faSoup: faSoup,
  faFlatbread: faFlatbread,
  faHeartCirclePlus: faHeartCirclePlus,
  faCodeFork: faCodeFork,
  faCity: faCity,
  faSignalBarsWeak: faSignalBarsWeak,
  faSignalAlt1: faSignalAlt1,
  faMicrophoneLines: faMicrophoneLines,
  faMicrophoneAlt: faMicrophoneAlt,
  faClockTwelve: faClockTwelve,
  faPepperHot: faPepperHot,
  faCitrusSlice: faCitrusSlice,
  faSheep: faSheep,
  faUnlock: faUnlock,
  faColonSign: faColonSign,
  faHeadset: faHeadset,
  faBadgerHoney: faBadgerHoney,
  faH4: faH4,
  faStoreSlash: faStoreSlash,
  faRoadCircleXmark: faRoadCircleXmark,
  faSignalSlash: faSignalSlash,
  faUserMinus: faUserMinus,
  faMarsStrokeUp: faMarsStrokeUp,
  faMarsStrokeV: faMarsStrokeV,
  faChampagneGlasses: faChampagneGlasses,
  faGlassCheers: faGlassCheers,
  faTaco: faTaco,
  faHexagonPlus: faHexagonPlus,
  faPlusHexagon: faPlusHexagon,
  faClipboard: faClipboard,
  faHouseCircleExclamation: faHouseCircleExclamation,
  faFileArrowUp: faFileArrowUp,
  faFileUpload: faFileUpload,
  faWifi: faWifi,
  faWifi3: faWifi3,
  faWifiStrong: faWifiStrong,
  faMessages: faMessages,
  faCommentsAlt: faCommentsAlt,
  faBath: faBath,
  faBathtub: faBathtub,
  faUmbrellaSimple: faUmbrellaSimple,
  faUmbrellaAlt: faUmbrellaAlt,
  faRectangleHistoryCirclePlus: faRectangleHistoryCirclePlus,
  faUnderline: faUnderline,
  faPrescriptionBottlePill: faPrescriptionBottlePill,
  faUserPen: faUserPen,
  faUserEdit: faUserEdit,
  faBinarySlash: faBinarySlash,
  faSquareO: faSquareO,
  faSignature: faSignature,
  faStroopwafel: faStroopwafel,
  faBold: faBold,
  faAnchorLock: faAnchorLock,
  faBuildingNgo: faBuildingNgo,
  faTransporter3: faTransporter3,
  faEngineWarning: faEngineWarning,
  faEngineExclamation: faEngineExclamation,
  faCircleDownRight: faCircleDownRight,
  faSquareK: faSquareK,
  faManatSign: faManatSign,
  faMoneyCheckPen: faMoneyCheckPen,
  faMoneyCheckEdit: faMoneyCheckEdit,
  faNotEqual: faNotEqual,
  faBorderTopLeft: faBorderTopLeft,
  faBorderStyle: faBorderStyle,
  faMapLocationDot: faMapLocationDot,
  faMapMarkedAlt: faMapMarkedAlt,
  faTilde: faTilde,
  faJedi: faJedi,
  faSquarePollVertical: faSquarePollVertical,
  faPoll: faPoll,
  faArrowDownSquareTriangle: faArrowDownSquareTriangle,
  faSortShapesDownAlt: faSortShapesDownAlt,
  faMugHot: faMugHot,
  faDogLeashed: faDogLeashed,
  faCarBattery: faCarBattery,
  faBatteryCar: faBatteryCar,
  faFaceDowncastSweat: faFaceDowncastSweat,
  faMailboxFlagUp: faMailboxFlagUp,
  faMemoCircleInfo: faMemoCircleInfo,
  faGift: faGift,
  faDiceTwo: faDiceTwo,
  faVolume: faVolume,
  faVolumeMedium: faVolumeMedium,
  faTransporter5: faTransporter5,
  faGaugeCircleBolt: faGaugeCircleBolt,
  faCoinFront: faCoinFront,
  faFileSlash: faFileSlash,
  faMessageArrowUpRight: faMessageArrowUpRight,
  faTreasureChest: faTreasureChest,
  faChessQueen: faChessQueen,
  faPaintbrushFine: faPaintbrushFine,
  faPaintBrushAlt: faPaintBrushAlt,
  faPaintBrushFine: faPaintBrushFine,
  faPaintbrushAlt: faPaintbrushAlt,
  faGlasses: faGlasses,
  faHoodCloak: faHoodCloak,
  faSquareQuote: faSquareQuote,
  faUpLeft: faUpLeft,
  faBringFront: faBringFront,
  faChessBoard: faChessBoard,
  faBurgerCheese: faBurgerCheese,
  faCheeseburger: faCheeseburger,
  faBuildingCircleCheck: faBuildingCircleCheck,
  faRepeat1: faRepeat1,
  faArrowDownToLine: faArrowDownToLine,
  faArrowToBottom: faArrowToBottom,
  faGrid5: faGrid5,
  faRightLongToLine: faRightLongToLine,
  faPersonChalkboard: faPersonChalkboard,
  faMarsStrokeRight: faMarsStrokeRight,
  faMarsStrokeH: faMarsStrokeH,
  faHandBackFist: faHandBackFist,
  faHandRock: faHandRock,
  faGridRound5: faGridRound5,
  faTally: faTally,
  faTally5: faTally5,
  faSquareCaretUp: faSquareCaretUp,
  faCaretSquareUp: faCaretSquareUp,
  faCloudShowersWater: faCloudShowersWater,
  faChartBar: faChartBar,
  faBarChart: faBarChart,
  faHandsBubbles: faHandsBubbles,
  faHandsWash: faHandsWash,
  faLessThanEqual: faLessThanEqual,
  faTrain: faTrain,
  faUpFromDottedLine: faUpFromDottedLine,
  faEyeLowVision: faEyeLowVision,
  faLowVision: faLowVision,
  faTrafficLightGo: faTrafficLightGo,
  faFaceExhaling: faFaceExhaling,
  faSensorFire: faSensorFire,
  faUserUnlock: faUserUnlock,
  faHexagonDivide: faHexagonDivide,
  fa00: fa00,
  faCrow: faCrow,
  faCassetteBetamax: faCassetteBetamax,
  faBetamax: faBetamax,
  faSailboat: faSailboat,
  faWindowRestore: faWindowRestore,
  faNfcMagnifyingGlass: faNfcMagnifyingGlass,
  faFileBinary: faFileBinary,
  faCircleV: faCircleV,
  faSquarePlus: faSquarePlus,
  faPlusSquare: faPlusSquare,
  faBowlScoops: faBowlScoops,
  faMistletoe: faMistletoe,
  faCustard: faCustard,
  faLacrosseStick: faLacrosseStick,
  faHockeyMask: faHockeyMask,
  faSunrise: faSunrise,
  faPanelEws: faPanelEws,
  faToriiGate: faToriiGate,
  faCloudExclamation: faCloudExclamation,
  faMessageLines: faMessageLines,
  faCommentAltLines: faCommentAltLines,
  faFrog: faFrog,
  faBucket: faBucket,
  faFloppyDiskPen: faFloppyDiskPen,
  faImage: faImage,
  faWindowFrame: faWindowFrame,
  faMicrophone: faMicrophone,
  faCow: faCow,
  faFileZip: faFileZip,
  faSquareRing: faSquareRing,
  faDownFromLine: faDownFromLine,
  faArrowAltFromTop: faArrowAltFromTop,
  faCaretUp: faCaretUp,
  faShieldXmark: faShieldXmark,
  faShieldTimes: faShieldTimes,
  faScrewdriver: faScrewdriver,
  faCircleSortDown: faCircleSortDown,
  faSortCircleDown: faSortCircleDown,
  faFolderClosed: faFolderClosed,
  faHouseTsunami: faHouseTsunami,
  faSquareNfi: faSquareNfi,
  faForklift: faForklift,
  faArrowUpFromGroundWater: faArrowUpFromGroundWater,
  faBracketSquareRight: faBracketSquareRight,
  faMartiniGlass: faMartiniGlass,
  faGlassMartiniAlt: faGlassMartiniAlt,
  faRotateLeft: faRotateLeft,
  faRotateBack: faRotateBack,
  faRotateBackward: faRotateBackward,
  faUndoAlt: faUndoAlt,
  faTableColumns: faTableColumns,
  faColumns: faColumns,
  faSquareA: faSquareA,
  faTick: faTick,
  faLemon: faLemon,
  faHeadSideMask: faHeadSideMask,
  faHandshake: faHandshake,
  faGem: faGem,
  faDolly: faDolly,
  faDollyBox: faDollyBox,
  faSmoking: faSmoking,
  faMinimize: faMinimize,
  faCompressArrowsAlt: faCompressArrowsAlt,
  faRefrigerator: faRefrigerator,
  faMonument: faMonument,
  faOctagonXmark: faOctagonXmark,
  faTimesOctagon: faTimesOctagon,
  faXmarkOctagon: faXmarkOctagon,
  faAlignSlash: faAlignSlash,
  faSnowplow: faSnowplow,
  faAnglesRight: faAnglesRight,
  faAngleDoubleRight: faAngleDoubleRight,
  faTruckRampCouch: faTruckRampCouch,
  faTruckCouch: faTruckCouch,
  faCannabis: faCannabis,
  faCirclePlay: faCirclePlay,
  faPlayCircle: faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter: faArrowUpRightAndArrowDownLeftFromCenter,
  faTablets: faTablets,
  fa360Degrees: fa360Degrees,
  faEthernet: faEthernet,
  faEuroSign: faEuroSign,
  faEur: faEur,
  faEuro: faEuro,
  faChair: faChair,
  faCircleCheck: faCircleCheck,
  faCheckCircle: faCheckCircle,
  faSquareDashedCirclePlus: faSquareDashedCirclePlus,
  faMoneySimpleFromBracket: faMoneySimpleFromBracket,
  faBat: faBat,
  faCircleStop: faCircleStop,
  faStopCircle: faStopCircle,
  faHeadSideHeadphones: faHeadSideHeadphones,
  faPhoneRotary: faPhoneRotary,
  faCompassDrafting: faCompassDrafting,
  faDraftingCompass: faDraftingCompass,
  faPlateWheat: faPlateWheat,
  faCalendarCircleMinus: faCalendarCircleMinus,
  faChopsticks: faChopsticks,
  faCarWrench: faCarWrench,
  faCarMechanic: faCarMechanic,
  faIcicles: faIcicles,
  faPersonShelter: faPersonShelter,
  faNeuter: faNeuter,
  faIdBadge: faIdBadge,
  faKazoo: faKazoo,
  faMarker: faMarker,
  faBinBottles: faBinBottles,
  faFaceLaughBeam: faFaceLaughBeam,
  faLaughBeam: faLaughBeam,
  faSquareArrowDownLeft: faSquareArrowDownLeft,
  faBatteryBolt: faBatteryBolt,
  faTreeLarge: faTreeLarge,
  faHelicopterSymbol: faHelicopterSymbol,
  faAperture: faAperture,
  faUniversalAccess: faUniversalAccess,
  faGearComplex: faGearComplex,
  faFileMagnifyingGlass: faFileMagnifyingGlass,
  faFileSearch: faFileSearch,
  faUpRight: faUpRight,
  faCircleChevronUp: faCircleChevronUp,
  faChevronCircleUp: faChevronCircleUp,
  faUserPolice: faUserPolice,
  faLariSign: faLariSign,
  faVolcano: faVolcano,
  faTeddyBear: faTeddyBear,
  faStocking: faStocking,
  faPersonWalkingDashedLineArrowRight: faPersonWalkingDashedLineArrowRight,
  faImageSlash: faImageSlash,
  faMaskSnorkel: faMaskSnorkel,
  faSmoke: faSmoke,
  faSterlingSign: faSterlingSign,
  faGbp: faGbp,
  faPoundSign: faPoundSign,
  faBatteryExclamation: faBatteryExclamation,
  faViruses: faViruses,
  faSquarePersonConfined: faSquarePersonConfined,
  faUserTie: faUserTie,
  faArrowDownLong: faArrowDownLong,
  faLongArrowDown: faLongArrowDown,
  faTentArrowDownToLine: faTentArrowDownToLine,
  faCertificate: faCertificate,
  faCrystalBall: faCrystalBall,
  faReplyAll: faReplyAll,
  faMailReplyAll: faMailReplyAll,
  faSuitcase: faSuitcase,
  faPersonSkating: faPersonSkating,
  faSkating: faSkating,
  faStarShooting: faStarShooting,
  faBinaryLock: faBinaryLock,
  faFilterCircleDollar: faFilterCircleDollar,
  faFunnelDollar: faFunnelDollar,
  faCameraRetro: faCameraRetro,
  faCircleArrowDown: faCircleArrowDown,
  faArrowCircleDown: faArrowCircleDown,
  faCommentPen: faCommentPen,
  faCommentEdit: faCommentEdit,
  faFileImport: faFileImport,
  faArrowRightToFile: faArrowRightToFile,
  faBanjo: faBanjo,
  faSquareArrowUpRight: faSquareArrowUpRight,
  faExternalLinkSquare: faExternalLinkSquare,
  faLightEmergencyOn: faLightEmergencyOn,
  faKerning: faKerning,
  faBoxOpen: faBoxOpen,
  faSquareF: faSquareF,
  faScroll: faScroll,
  faSpa: faSpa,
  faArrowLeftFromLine: faArrowLeftFromLine,
  faArrowFromRight: faArrowFromRight,
  faStrawberry: faStrawberry,
  faLocationPinLock: faLocationPinLock,
  faPause: faPause,
  faClockEightThirty: faClockEightThirty,
  faPlaneEngines: faPlaneEngines,
  faPlaneAlt: faPlaneAlt,
  faHillAvalanche: faHillAvalanche,
  faTemperatureEmpty: faTemperatureEmpty,
  faTemperature0: faTemperature0,
  faThermometer0: faThermometer0,
  faThermometerEmpty: faThermometerEmpty,
  faBomb: faBomb,
  faGaugeLow: faGaugeLow,
  faTachometerAltSlow: faTachometerAltSlow,
  faRegistered: faRegistered,
  faTrashCanPlus: faTrashCanPlus,
  faAddressCard: faAddressCard,
  faContactCard: faContactCard,
  faVcard: faVcard,
  faScaleUnbalancedFlip: faScaleUnbalancedFlip,
  faBalanceScaleRight: faBalanceScaleRight,
  faGlobeSnow: faGlobeSnow,
  faSubscript: faSubscript,
  faDiamondTurnRight: faDiamondTurnRight,
  faDirections: faDirections,
  faIntegral: faIntegral,
  faBurst: faBurst,
  faHouseLaptop: faHouseLaptop,
  faLaptopHouse: faLaptopHouse,
  faFaceTired: faFaceTired,
  faTired: faTired,
  faMoneyBills: faMoneyBills,
  faBlindsRaised: faBlindsRaised,
  faSmog: faSmog,
  faUfoBeam: faUfoBeam,
  faCircleCaretUp: faCircleCaretUp,
  faCaretCircleUp: faCaretCircleUp,
  faUserVneckHairLong: faUserVneckHairLong,
  faSquareALock: faSquareALock,
  faCrutch: faCrutch,
  faGasPumpSlash: faGasPumpSlash,
  faFontAwesome: faFontAwesome,
  faFontAwesomeFlag: faFontAwesomeFlag,
  faFontAwesomeLogoFull: faFontAwesomeLogoFull,
  faCloudArrowUp: faCloudArrowUp,
  faCloudUpload: faCloudUpload,
  faCloudUploadAlt: faCloudUploadAlt,
  faPalette: faPalette,
  faTransporter4: faTransporter4,
  faChartMixedUpCircleCurrency: faChartMixedUpCircleCurrency,
  faObjectsAlignRight: faObjectsAlignRight,
  faArrowsTurnRight: faArrowsTurnRight,
  faVest: faVest,
  faPig: faPig,
  faInboxFull: faInboxFull,
  faCircleEnvelope: faCircleEnvelope,
  faEnvelopeCircle: faEnvelopeCircle,
  faTrianglePersonDigging: faTrianglePersonDigging,
  faConstruction: faConstruction,
  faFerry: faFerry,
  faBullseyeArrow: faBullseyeArrow,
  faArrowsDownToPeople: faArrowsDownToPeople,
  faSeedling: faSeedling,
  faSprout: faSprout,
  faClockSeven: faClockSeven,
  faLeftRight: faLeftRight,
  faArrowsAltH: faArrowsAltH,
  faBoxesPacking: faBoxesPacking,
  faCircleArrowLeft: faCircleArrowLeft,
  faArrowCircleLeft: faArrowCircleLeft,
  faFlashlight: faFlashlight,
  faGroupArrowsRotate: faGroupArrowsRotate,
  faBowlFood: faBowlFood,
  faSquare9: faSquare9,
  faCandyCane: faCandyCane,
  faArrowDownWideShort: faArrowDownWideShort,
  faSortAmountAsc: faSortAmountAsc,
  faSortAmountDown: faSortAmountDown,
  faSquareDollar: faSquareDollar,
  faDollarSquare: faDollarSquare,
  faUsdSquare: faUsdSquare,
  faPhoneArrowRight: faPhoneArrowRight,
  faHandHoldingSeedling: faHandHoldingSeedling,
  faMessageCheck: faMessageCheck,
  faCommentAltCheck: faCommentAltCheck,
  faCloudBolt: faCloudBolt,
  faThunderstorm: faThunderstorm,
  faChartLineUpDown: faChartLineUpDown,
  faTextSlash: faTextSlash,
  faRemoveFormat: faRemoveFormat,
  faWatch: faWatch,
  faCircleDownLeft: faCircleDownLeft,
  faText: faText,
  faProjector: faProjector,
  faFaceSmileWink: faFaceSmileWink,
  faSmileWink: faSmileWink,
  faTombstoneBlank: faTombstoneBlank,
  faTombstoneAlt: faTombstoneAlt,
  faChessKingPiece: faChessKingPiece,
  faChessKingAlt: faChessKingAlt,
  faCircle6: faCircle6,
  faLeft: faLeft,
  faArrowAltLeft: faArrowAltLeft,
  faFileWord: faFileWord,
  faFilePowerpoint: faFilePowerpoint,
  faSquareDown: faSquareDown,
  faArrowAltSquareDown: faArrowAltSquareDown,
  faObjectsAlignCenterVertical: faObjectsAlignCenterVertical,
  faArrowsLeftRight: faArrowsLeftRight,
  faArrowsH: faArrowsH,
  faHouseLock: faHouseLock,
  faCloudArrowDown: faCloudArrowDown,
  faCloudDownload: faCloudDownload,
  faCloudDownloadAlt: faCloudDownloadAlt,
  faWreath: faWreath,
  faChildren: faChildren,
  faMeterDroplet: faMeterDroplet,
  faChalkboard: faChalkboard,
  faBlackboard: faBlackboard,
  faUserLargeSlash: faUserLargeSlash,
  faUserAltSlash: faUserAltSlash,
  faSignalStrong: faSignalStrong,
  faSignal4: faSignal4,
  faLollipop: faLollipop,
  faLollypop: faLollypop,
  faListTree: faListTree,
  faEnvelopeOpen: faEnvelopeOpen,
  faDrawCircle: faDrawCircle,
  faCatSpace: faCatSpace,
  faHandshakeSimpleSlash: faHandshakeSimpleSlash,
  faHandshakeAltSlash: faHandshakeAltSlash,
  faRabbitRunning: faRabbitRunning,
  faRabbitFast: faRabbitFast,
  faMemoPad: faMemoPad,
  faMattressPillow: faMattressPillow,
  faAlarmPlus: faAlarmPlus,
  faAlicorn: faAlicorn,
  faCommentQuestion: faCommentQuestion,
  faGingerbreadMan: faGingerbreadMan,
  faGuaraniSign: faGuaraniSign,
  faBurgerFries: faBurgerFries,
  faMugTea: faMugTea,
  faBorderTop: faBorderTop,
  faArrowsRotate: faArrowsRotate,
  faRefresh: faRefresh,
  faSync: faSync,
  faCircleBookOpen: faCircleBookOpen,
  faBookCircle: faBookCircle,
  faArrowsToDottedLine: faArrowsToDottedLine,
  faFireExtinguisher: faFireExtinguisher,
  faGarageOpen: faGarageOpen,
  faShelvesEmpty: faShelvesEmpty,
  faCruzeiroSign: faCruzeiroSign,
  faWatchApple: faWatchApple,
  faWatchCalculator: faWatchCalculator,
  faListDropdown: faListDropdown,
  faCabinetFiling: faCabinetFiling,
  faBurgerSoda: faBurgerSoda,
  faSquareArrowUp: faSquareArrowUp,
  faArrowSquareUp: faArrowSquareUp,
  faGreaterThanEqual: faGreaterThanEqual,
  faPalletBox: faPalletBox,
  faFaceConfounded: faFaceConfounded,
  faShieldHalved: faShieldHalved,
  faShieldAlt: faShieldAlt,
  faTruckPlow: faTruckPlow,
  faBookAtlas: faBookAtlas,
  faAtlas: faAtlas,
  faVirus: faVirus,
  faGridRound2: faGridRound2,
  faCommentMiddleTop: faCommentMiddleTop,
  faEnvelopeCircleCheck: faEnvelopeCircleCheck,
  faLayerGroup: faLayerGroup,
  faRestroomSimple: faRestroomSimple,
  faArrowsToDot: faArrowsToDot,
  faBorderOuter: faBorderOuter,
  faHashtagLock: faHashtagLock,
  faClockTwoThirty: faClockTwoThirty,
  faArchway: faArchway,
  faHeartCircleCheck: faHeartCircleCheck,
  faHouseChimneyCrack: faHouseChimneyCrack,
  faHouseDamage: faHouseDamage,
  faFileZipper: faFileZipper,
  faFileArchive: faFileArchive,
  faHeartHalf: faHeartHalf,
  faCommentCheck: faCommentCheck,
  faSquare: faSquare,
  faMemo: faMemo,
  faMartiniGlassEmpty: faMartiniGlassEmpty,
  faGlassMartini: faGlassMartini,
  faCouch: faCouch,
  faCediSign: faCediSign,
  faItalic: faItalic,
  faGlassCitrus: faGlassCitrus,
  faCalendarLinesPen: faCalendarLinesPen,
  faChurch: faChurch,
  faPersonSnowmobiling: faPersonSnowmobiling,
  faSnowmobile: faSnowmobile,
  faFaceHushed: faFaceHushed,
  faCommentsDollar: faCommentsDollar,
  faPickaxe: faPickaxe,
  faLinkSimpleSlash: faLinkSimpleSlash,
  faDemocrat: faDemocrat,
  faFaceConfused: faFaceConfused,
  faPinball: faPinball,
  faZ: faZ,
  faPersonSkiing: faPersonSkiing,
  faSkiing: faSkiing,
  faDeer: faDeer,
  faInputPipe: faInputPipe,
  faRoadLock: faRoadLock,
  faA: faA,
  faBookmarkSlash: faBookmarkSlash,
  faTemperatureArrowDown: faTemperatureArrowDown,
  faTemperatureDown: faTemperatureDown,
  faMace: faMace,
  faFeatherPointed: faFeatherPointed,
  faFeatherAlt: faFeatherAlt,
  faSausage: faSausage,
  faTrashCanClock: faTrashCanClock,
  faP: faP,
  faBroomWide: faBroomWide,
  faSnowflake: faSnowflake,
  faStomach: faStomach,
  faNewspaper: faNewspaper,
  faRectangleAd: faRectangleAd,
  faAd: faAd,
  faGuitarElectric: faGuitarElectric,
  faArrowTurnDownRight: faArrowTurnDownRight,
  faMoonCloud: faMoonCloud,
  faBreadSliceButter: faBreadSliceButter,
  faCircleArrowRight: faCircleArrowRight,
  faArrowCircleRight: faArrowCircleRight,
  faUserGroupCrown: faUserGroupCrown,
  faUsersCrown: faUsersCrown,
  faCircleI: faCircleI,
  faToiletPaperCheck: faToiletPaperCheck,
  faFilterCircleXmark: faFilterCircleXmark,
  faLocust: faLocust,
  faSort: faSort,
  faUnsorted: faUnsorted,
  faListOl: faListOl,
  faList12: faList12,
  faListNumeric: faListNumeric,
  faChartWaterfall: faChartWaterfall,
  faSparkle: faSparkle,
  faFaceParty: faFaceParty,
  faKidneys: faKidneys,
  faWifiExclamation: faWifiExclamation,
  faChartNetwork: faChartNetwork,
  faPersonDressBurst: faPersonDressBurst,
  faDiceD4: faDiceD4,
  faMoneyCheckDollar: faMoneyCheckDollar,
  faMoneyCheckAlt: faMoneyCheckAlt,
  faVectorSquare: faVectorSquare,
  faBreadSlice: faBreadSlice,
  faLanguage: faLanguage,
  faWheatAwnSlash: faWheatAwnSlash,
  faFaceKissWinkHeart: faFaceKissWinkHeart,
  faKissWinkHeart: faKissWinkHeart,
  faDagger: faDagger,
  faPodium: faPodium,
  faMemoCircleCheck: faMemoCircleCheck,
  faRouteHighway: faRouteHighway,
  faDownToLine: faDownToLine,
  faArrowAltToBottom: faArrowAltToBottom,
  faFilter: faFilter,
  faSquareG: faSquareG,
  faCirclePhone: faCirclePhone,
  faPhoneCircle: faPhoneCircle,
  faClipboardPrescription: faClipboardPrescription,
  faUserNurseHair: faUserNurseHair,
  faQuestion: faQuestion,
  faFileSignature: faFileSignature,
  faToggleLargeOn: faToggleLargeOn,
  faUpDownLeftRight: faUpDownLeftRight,
  faArrowsAlt: faArrowsAlt,
  faDryerHeat: faDryerHeat,
  faDryerAlt: faDryerAlt,
  faHouseChimneyUser: faHouseChimneyUser,
  faHandHoldingHeart: faHandHoldingHeart,
  faArrowUpSmallBig: faArrowUpSmallBig,
  faSortSizeUpAlt: faSortSizeUpAlt,
  faTrainTrack: faTrainTrack,
  faPuzzlePiece: faPuzzlePiece,
  faMoneyCheck: faMoneyCheck,
  faStarHalfStroke: faStarHalfStroke,
  faStarHalfAlt: faStarHalfAlt,
  faFileExclamation: faFileExclamation,
  faCode: faCode,
  faWhiskeyGlass: faWhiskeyGlass,
  faGlassWhiskey: faGlassWhiskey,
  faMoonStars: faMoonStars,
  faBuildingCircleExclamation: faBuildingCircleExclamation,
  faClothesHanger: faClothesHanger,
  faMobileNotch: faMobileNotch,
  faMobileIphone: faMobileIphone,
  faMagnifyingGlassChart: faMagnifyingGlassChart,
  faArrowUpRightFromSquare: faArrowUpRightFromSquare,
  faExternalLink: faExternalLink,
  faCubesStacked: faCubesStacked,
  faImagesUser: faImagesUser,
  faWonSign: faWonSign,
  faKrw: faKrw,
  faWon: faWon,
  faImagePolaroidUser: faImagePolaroidUser,
  faVirusCovid: faVirusCovid,
  faSquareEllipsis: faSquareEllipsis,
  faPie: faPie,
  faChessKnightPiece: faChessKnightPiece,
  faChessKnightAlt: faChessKnightAlt,
  faAustralSign: faAustralSign,
  faCloudPlus: faCloudPlus,
  faF: faF,
  faLeaf: faLeaf,
  faBedBunk: faBedBunk,
  faRoad: faRoad,
  faTaxi: faTaxi,
  faCab: faCab,
  faPersonCirclePlus: faPersonCirclePlus,
  faChartPie: faChartPie,
  faPieChart: faPieChart,
  faBoltLightning: faBoltLightning,
  faClockEight: faClockEight,
  faSackXmark: faSackXmark,
  faFileExcel: faFileExcel,
  faFileContract: faFileContract,
  faFishFins: faFishFins,
  faCircleQ: faCircleQ,
  faBuildingFlag: faBuildingFlag,
  faFaceGrinBeam: faFaceGrinBeam,
  faGrinBeam: faGrinBeam,
  faObjectUngroup: faObjectUngroup,
  faFaceDisguise: faFaceDisguise,
  faCircleArrowDownRight: faCircleArrowDownRight,
  faAlien8bit: faAlien8bit,
  faAlienMonster: faAlienMonster,
  faHandPointRibbon: faHandPointRibbon,
  faPoop: faPoop,
  faObjectExclude: faObjectExclude,
  faTelescope: faTelescope,
  faLocationPin: faLocationPin,
  faMapMarker: faMapMarker,
  faSquareList: faSquareList,
  faKaaba: faKaaba,
  faToiletPaper: faToiletPaper,
  faHelmetSafety: faHelmetSafety,
  faHardHat: faHardHat,
  faHatHard: faHatHard,
  faCommentCode: faCommentCode,
  faSimCards: faSimCards,
  faStarship: faStarship,
  faEject: faEject,
  faCircleRight: faCircleRight,
  faArrowAltCircleRight: faArrowAltCircleRight,
  faPlaneCircleCheck: faPlaneCircleCheck,
  faSeal: faSeal,
  faUserCowboy: faUserCowboy,
  faHexagonVerticalNft: faHexagonVerticalNft,
  faFaceRollingEyes: faFaceRollingEyes,
  faMehRollingEyes: faMehRollingEyes,
  faBreadLoaf: faBreadLoaf,
  faRingsWedding: faRingsWedding,
  faObjectGroup: faObjectGroup,
  faFrenchFries: faFrenchFries,
  faChartLine: faChartLine,
  faLineChart: faLineChart,
  faCalendarArrowDown: faCalendarArrowDown,
  faCalendarDownload: faCalendarDownload,
  faSendBack: faSendBack,
  faMaskVentilator: faMaskVentilator,
  faSignatureLock: faSignatureLock,
  faArrowRight: faArrowRight,
  faSignsPost: faSignsPost,
  faMapSigns: faMapSigns,
  faOctagonPlus: faOctagonPlus,
  faPlusOctagon: faPlusOctagon,
  faCashRegister: faCashRegister,
  faPersonCircleQuestion: faPersonCircleQuestion,
  faMelonSlice: faMelonSlice,
  faSpaceStationMoon: faSpaceStationMoon,
  faMessageSmile: faMessageSmile,
  faCommentAltSmile: faCommentAltSmile,
  faCupStraw: faCupStraw,
  faLeftFromLine: faLeftFromLine,
  faArrowAltFromRight: faArrowAltFromRight,
  faH: faH,
  faBasketShoppingSimple: faBasketShoppingSimple,
  faShoppingBasketAlt: faShoppingBasketAlt,
  faHandsHoldingHeart: faHandsHoldingHeart,
  faHandsHeart: faHandsHeart,
  faClockNine: faClockNine,
  faTarp: faTarp,
  faFaceSleepy: faFaceSleepy,
  faHandHorns: faHandHorns,
  faScrewdriverWrench: faScrewdriverWrench,
  faTools: faTools,
  faArrowsToEye: faArrowsToEye,
  faCircleThreeQuarters: faCircleThreeQuarters,
  faTrophyStar: faTrophyStar,
  faTrophyAlt: faTrophyAlt,
  faPlugCircleBolt: faPlugCircleBolt,
  faFaceThermometer: faFaceThermometer,
  faGridRound4: faGridRound4,
  faShirtRunning: faShirtRunning,
  faBookCircleArrowUp: faBookCircleArrowUp,
  faFaceNauseated: faFaceNauseated,
  faHeart: faHeart,
  faFileChartPie: faFileChartPie,
  faMarsAndVenus: faMarsAndVenus,
  faHouseUser: faHouseUser,
  faHomeUser: faHomeUser,
  faCircleArrowDownLeft: faCircleArrowDownLeft,
  faDumpsterFire: faDumpsterFire,
  faHexagonMinus: faHexagonMinus,
  faMinusHexagon: faMinusHexagon,
  faLeftToLine: faLeftToLine,
  faArrowAltToLeft: faArrowAltToLeft,
  faHouseCrack: faHouseCrack,
  faPawSimple: faPawSimple,
  faPawAlt: faPawAlt,
  faArrowLeftLongToLine: faArrowLeftLongToLine,
  faBracketsRound: faBracketsRound,
  faParentheses: faParentheses,
  faMartiniGlassCitrus: faMartiniGlassCitrus,
  faCocktail: faCocktail,
  faUserShakespeare: faUserShakespeare,
  faArrowRightToArc: faArrowRightToArc,
  faFaceSurprise: faFaceSurprise,
  faSurprise: faSurprise,
  faBottleWater: faBottleWater,
  faCirclePause: faCirclePause,
  faPauseCircle: faPauseCircle,
  faGaugeCirclePlus: faGaugeCirclePlus,
  faFolders: faFolders,
  faAngel: faAngel,
  faValueAbsolute: faValueAbsolute,
  faRabbit: faRabbit,
  faToiletPaperSlash: faToiletPaperSlash,
  faCircleEuro: faCircleEuro,
  faAppleWhole: faAppleWhole,
  faAppleAlt: faAppleAlt,
  faKitchenSet: faKitchenSet,
  faDiamondHalf: faDiamondHalf,
  faLockKeyhole: faLockKeyhole,
  faLockAlt: faLockAlt,
  faR: faR,
  faTemperatureQuarter: faTemperatureQuarter,
  faTemperature1: faTemperature1,
  faThermometer1: faThermometer1,
  faThermometerQuarter: faThermometerQuarter,
  faSquareInfo: faSquareInfo,
  faInfoSquare: faInfoSquare,
  faWifiSlash: faWifiSlash,
  faToiletPaperXmark: faToiletPaperXmark,
  faHandsHoldingDollar: faHandsHoldingDollar,
  faHandsUsd: faHandsUsd,
  faCube: faCube,
  faArrowDownTriangleSquare: faArrowDownTriangleSquare,
  faSortShapesDown: faSortShapesDown,
  faBitcoinSign: faBitcoinSign,
  faShutters: faShutters,
  faShieldDog: faShieldDog,
  faSolarPanel: faSolarPanel,
  faLockOpen: faLockOpen,
  faTableTree: faTableTree,
  faHouseChimneyHeart: faHouseChimneyHeart,
  faTally3: faTally3,
  faElevator: faElevator,
  faMoneyBillTransfer: faMoneyBillTransfer,
  faMoneyBillTrendUp: faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight: faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal: faSquarePollHorizontal,
  faPollH: faPollH,
  faCircle: faCircle,
  faCartCircleExclamation: faCartCircleExclamation,
  faSword: faSword,
  faBackwardFast: faBackwardFast,
  faFastBackward: faFastBackward,
  faRecycle: faRecycle,
  faUserAstronaut: faUserAstronaut,
  faInterrobang: faInterrobang,
  faPlaneSlash: faPlaneSlash,
  faCircleDashed: faCircleDashed,
  faTrademark: faTrademark,
  faBasketball: faBasketball,
  faBasketballBall: faBasketballBall,
  faForkKnife: faForkKnife,
  faUtensilsAlt: faUtensilsAlt,
  faSatelliteDish: faSatelliteDish,
  faBadgeCheck: faBadgeCheck,
  faCircleUp: faCircleUp,
  faArrowAltCircleUp: faArrowAltCircleUp,
  faSlider: faSlider,
  faMobileScreenButton: faMobileScreenButton,
  faMobileAlt: faMobileAlt,
  faClockOneThirty: faClockOneThirty,
  faInboxOut: faInboxOut,
  faInboxArrowUp: faInboxArrowUp,
  faCloudSlash: faCloudSlash,
  faVolumeHigh: faVolumeHigh,
  faVolumeUp: faVolumeUp,
  faUsersRays: faUsersRays,
  faWallet: faWallet,
  faOctagonCheck: faOctagonCheck,
  faFlatbreadStuffed: faFlatbreadStuffed,
  faClipboardCheck: faClipboardCheck,
  faCartCirclePlus: faCartCirclePlus,
  faTruckClock: faTruckClock,
  faShippingTimed: faShippingTimed,
  faPool8Ball: faPool8Ball,
  faFileAudio: faFileAudio,
  faTurnDownLeft: faTurnDownLeft,
  faLockHashtag: faLockHashtag,
  faChartRadar: faChartRadar,
  faStaff: faStaff,
  faBurger: faBurger,
  faHamburger: faHamburger,
  faUtilityPole: faUtilityPole,
  faTransporter6: faTransporter6,
  faWrench: faWrench,
  faBugs: faBugs,
  faVectorPolygon: faVectorPolygon,
  faDiagramNested: faDiagramNested,
  faRupeeSign: faRupeeSign,
  faRupee: faRupee,
  faFileImage: faFileImage,
  faCircleQuestion: faCircleQuestion,
  faQuestionCircle: faQuestionCircle,
  faImageUser: faImageUser,
  faBuoy: faBuoy,
  faPlaneDeparture: faPlaneDeparture,
  faHandshakeSlash: faHandshakeSlash,
  faBookBookmark: faBookBookmark,
  faBorderCenterH: faBorderCenterH,
  faCanFood: faCanFood,
  faTypewriter: faTypewriter,
  faArrowRightFromArc: faArrowRightFromArc,
  faCircleK: faCircleK,
  faFaceHandOverMouth: faFaceHandOverMouth,
  faPopcorn: faPopcorn,
  faHouseWater: faHouseWater,
  faHouseFlood: faHouseFlood,
  faObjectSubtract: faObjectSubtract,
  faCodeBranch: faCodeBranch,
  faWarehouseFull: faWarehouseFull,
  faWarehouseAlt: faWarehouseAlt,
  faHatCowboy: faHatCowboy,
  faBridge: faBridge,
  faPhoneFlip: faPhoneFlip,
  faPhoneAlt: faPhoneAlt,
  faArrowDownFromDottedLine: faArrowDownFromDottedLine,
  faFileDoc: faFileDoc,
  faSquareQuarters: faSquareQuarters,
  faTruckFront: faTruckFront,
  faCat: faCat,
  faTrashXmark: faTrashXmark,
  faCircleCaretLeft: faCircleCaretLeft,
  faCaretCircleLeft: faCaretCircleLeft,
  faFiles: faFiles,
  faAnchorCircleExclamation: faAnchorCircleExclamation,
  faFaceClouds: faFaceClouds,
  faUserCrown: faUserCrown,
  faTruckField: faTruckField,
  faRoute: faRoute,
  faCartCircleCheck: faCartCircleCheck,
  faClipboardQuestion: faClipboardQuestion,
  faPanorama: faPanorama,
  faCommentMedical: faCommentMedical,
  faTeethOpen: faTeethOpen,
  faUserTieHairLong: faUserTieHairLong,
  faFileCircleMinus: faFileCircleMinus,
  faHeadSideMedical: faHeadSideMedical,
  faTags: faTags,
  faWineGlass: faWineGlass,
  faForwardFast: faForwardFast,
  faFastForward: faFastForward,
  faFaceMehBlank: faFaceMehBlank,
  faMehBlank: faMehBlank,
  faUserRobot: faUserRobot,
  faSquareParking: faSquareParking,
  faParking: faParking,
  faCardDiamond: faCardDiamond,
  faFaceZipper: faFaceZipper,
  faFaceRaisedEyebrow: faFaceRaisedEyebrow,
  faHouseSignal: faHouseSignal,
  faSquareChevronUp: faSquareChevronUp,
  faChevronSquareUp: faChevronSquareUp,
  faNfcSymbol: faNfcSymbol,
  faBarsProgress: faBarsProgress,
  faTasksAlt: faTasksAlt,
  faFaucetDrip: faFaucetDrip,
  faArrowsToLine: faArrowsToLine,
  faDolphin: faDolphin,
  faArrowUpRight: faArrowUpRight,
  faCircleR: faCircleR,
  faCartFlatbed: faCartFlatbed,
  faDollyFlatbed: faDollyFlatbed,
  faBanSmoking: faBanSmoking,
  faSmokingBan: faSmokingBan,
  faCircleSortUp: faCircleSortUp,
  faSortCircleUp: faSortCircleUp,
  faTerminal: faTerminal,
  faMobileButton: faMobileButton,
  faHouseMedicalFlag: faHouseMedicalFlag,
  faBasketShopping: faBasketShopping,
  faShoppingBasket: faShoppingBasket,
  faTape: faTape,
  faChestnut: faChestnut,
  faBusSimple: faBusSimple,
  faBusAlt: faBusAlt,
  faEye: faEye,
  faFaceSadCry: faFaceSadCry,
  faSadCry: faSadCry,
  faHeat: faHeat,
  faTicketAirline: faTicketAirline,
  faBootHeeled: faBootHeeled,
  faArrowsMinimize: faArrowsMinimize,
  faCompressArrows: faCompressArrows,
  faAudioDescription: faAudioDescription,
  faPersonMilitaryToPerson: faPersonMilitaryToPerson,
  faFileShield: faFileShield,
  faHexagon: faHexagon,
  faManhole: faManhole,
  faUserSlash: faUserSlash,
  faPen: faPen,
  faTowerObservation: faTowerObservation,
  faFloppyDisks: faFloppyDisks,
  faToiletPaperBlankUnder: faToiletPaperBlankUnder,
  faToiletPaperReverseAlt: faToiletPaperReverseAlt,
  faFileCode: faFileCode,
  faSignal: faSignal,
  faSignal5: faSignal5,
  faSignalPerfect: faSignalPerfect,
  faPump: faPump,
  faBus: faBus,
  faHeartCircleXmark: faHeartCircleXmark,
  faArrowUpLeftFromCircle: faArrowUpLeftFromCircle,
  faHouseChimney: faHouseChimney,
  faHomeLg: faHomeLg,
  faWindowMaximize: faWindowMaximize,
  faDryer: faDryer,
  faFaceFrown: faFaceFrown,
  faFrown: faFrown,
  faChessBishopPiece: faChessBishopPiece,
  faChessBishopAlt: faChessBishopAlt,
  faShirtTankTop: faShirtTankTop,
  faDiploma: faDiploma,
  faScrollRibbon: faScrollRibbon,
  faScreencast: faScreencast,
  faWalker: faWalker,
  faPrescription: faPrescription,
  faShop: faShop,
  faStoreAlt: faStoreAlt,
  faFloppyDisk: faFloppyDisk,
  faSave: faSave,
  faVihara: faVihara,
  faFaceKissClosedEyes: faFaceKissClosedEyes,
  faScaleUnbalanced: faScaleUnbalanced,
  faBalanceScaleLeft: faBalanceScaleLeft,
  faFileUser: faFileUser,
  faUserPoliceTie: faUserPoliceTie,
  faFaceTongueMoney: faFaceTongueMoney,
  faTennisBall: faTennisBall,
  faSquareL: faSquareL,
  faSortUp: faSortUp,
  faSortAsc: faSortAsc,
  faCalendarArrowUp: faCalendarArrowUp,
  faCalendarUpload: faCalendarUpload,
  faCommentDots: faCommentDots,
  faCommenting: faCommenting,
  faPlantWilt: faPlantWilt,
  faScarf: faScarf,
  faAlbumCirclePlus: faAlbumCirclePlus,
  faUserNurseHairLong: faUserNurseHairLong,
  faDiamond: faDiamond,
  faSquareLeft: faSquareLeft,
  faArrowAltSquareLeft: faArrowAltSquareLeft,
  faFaceGrinSquint: faFaceGrinSquint,
  faGrinSquint: faGrinSquint,
  faCircleEllipsisVertical: faCircleEllipsisVertical,
  faHandHoldingDollar: faHandHoldingDollar,
  faHandHoldingUsd: faHandHoldingUsd,
  faGridDividers: faGridDividers,
  faBacterium: faBacterium,
  faHandPointer: faHandPointer,
  faDrumSteelpan: faDrumSteelpan,
  faHandScissors: faHandScissors,
  faHandsPraying: faHandsPraying,
  faPrayingHands: faPrayingHands,
  faFacePensive: faFacePensive,
  faUserMusic: faUserMusic,
  faArrowRotateRight: faArrowRotateRight,
  faArrowRightRotate: faArrowRightRotate,
  faArrowRotateForward: faArrowRotateForward,
  faRedo: faRedo,
  faMessagesDollar: faMessagesDollar,
  faCommentsAltDollar: faCommentsAltDollar,
  faSensorOn: faSensorOn,
  faBalloon: faBalloon,
  faBiohazard: faBiohazard,
  faChessQueenPiece: faChessQueenPiece,
  faChessQueenAlt: faChessQueenAlt,
  faLocationCrosshairs: faLocationCrosshairs,
  faLocation: faLocation,
  faMarsDouble: faMarsDouble,
  faHousePersonLeave: faHousePersonLeave,
  faHouseLeave: faHouseLeave,
  faHousePersonDepart: faHousePersonDepart,
  faRulerTriangle: faRulerTriangle,
  faCardClub: faCardClub,
  faChildDress: faChildDress,
  faUsersBetweenLines: faUsersBetweenLines,
  faLungsVirus: faLungsVirus,
  faSpinnerThird: faSpinnerThird,
  faFaceGrinTears: faFaceGrinTears,
  faGrinTears: faGrinTears,
  faPhone: faPhone,
  faComputerMouseScrollwheel: faComputerMouseScrollwheel,
  faMouseAlt: faMouseAlt,
  faCalendarXmark: faCalendarXmark,
  faCalendarTimes: faCalendarTimes,
  faChildReaching: faChildReaching,
  faTableLayout: faTableLayout,
  faNarwhal: faNarwhal,
  faRampLoading: faRampLoading,
  faCalendarCirclePlus: faCalendarCirclePlus,
  faToothbrush: faToothbrush,
  faBorderInner: faBorderInner,
  faPawClaws: faPawClaws,
  faKiwiFruit: faKiwiFruit,
  faTrafficLightSlow: faTrafficLightSlow,
  faRectangleCode: faRectangleCode,
  faHeadSideVirus: faHeadSideVirus,
  faKeyboardBrightness: faKeyboardBrightness,
  faBooksMedical: faBooksMedical,
  faLightbulbSlash: faLightbulbSlash,
  faHouseBlank: faHouseBlank,
  faHomeBlank: faHomeBlank,
  faSquare5: faSquare5,
  faSquareHeart: faSquareHeart,
  faHeartSquare: faHeartSquare,
  faPuzzle: faPuzzle,
  faUserGear: faUserGear,
  faUserCog: faUserCog,
  faPipeCircleCheck: faPipeCircleCheck,
  faArrowUp19: faArrowUp19,
  faSortNumericUp: faSortNumericUp,
  faOctagonExclamation: faOctagonExclamation,
  faDialLow: faDialLow,
  faDoorClosed: faDoorClosed,
  faLaptopMobile: faLaptopMobile,
  faPhoneLaptop: faPhoneLaptop,
  faConveyorBeltBoxes: faConveyorBeltBoxes,
  faConveyorBeltAlt: faConveyorBeltAlt,
  faShieldVirus: faShieldVirus,
  faStarfighterTwinIonEngineAdvanced: faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced: faStarfighterAltAdvanced,
  faDiceSix: faDiceSix,
  faStarfighterTwinIonEngine: faStarfighterTwinIonEngine,
  faStarfighterAlt: faStarfighterAlt,
  faRocketLaunch: faRocketLaunch,
  faMosquitoNet: faMosquitoNet,
  faVentDamper: faVentDamper,
  faBridgeWater: faBridgeWater,
  faBanBug: faBanBug,
  faDebug: faDebug,
  faPersonBooth: faPersonBooth,
  faTextWidth: faTextWidth,
  faGarageCar: faGarageCar,
  faSquareKanban: faSquareKanban,
  faHatWizard: faHatWizard,
  faPenFancy: faPenFancy,
  faCoffeePot: faCoffeePot,
  faMouseField: faMouseField,
  faPersonDigging: faPersonDigging,
  faDigging: faDigging,
  faShowerDown: faShowerDown,
  faShowerAlt: faShowerAlt,
  faBoxCircleCheck: faBoxCircleCheck,
  faBrightness: faBrightness,
  faCarSideBolt: faCarSideBolt,
  faOrnament: faOrnament,
  faPhoneArrowDownLeft: faPhoneArrowDownLeft,
  faPhoneArrowDown: faPhoneArrowDown,
  faPhoneIncoming: faPhoneIncoming,
  faCloudWord: faCloudWord,
  faHandFingersCrossed: faHandFingersCrossed,
  faTrash: faTrash,
  faGaugeSimple: faGaugeSimple,
  faGaugeSimpleMed: faGaugeSimpleMed,
  faTachometerAverage: faTachometerAverage,
  faArrowDownSmallBig: faArrowDownSmallBig,
  faSortSizeDownAlt: faSortSizeDownAlt,
  faBookMedical: faBookMedical,
  faFaceMelting: faFaceMelting,
  faPoo: faPoo,
  faPenClipSlash: faPenClipSlash,
  faPenAltSlash: faPenAltSlash,
  faQuoteRight: faQuoteRight,
  faQuoteRightAlt: faQuoteRightAlt,
  faScrollOld: faScrollOld,
  faGuitars: faGuitars,
  faPhoneXmark: faPhoneXmark,
  faHose: faHose,
  faClockSix: faClockSix,
  faShirt: faShirt,
  faTShirt: faTShirt,
  faTshirt: faTshirt,
  faBillboard: faBillboard,
  faSquareR: faSquareR,
  faCubes: faCubes,
  faEnvelopeOpenDollar: faEnvelopeOpenDollar,
  faDivide: faDivide,
  faSunCloud: faSunCloud,
  faLampFloor: faLampFloor,
  faSquare7: faSquare7,
  faTengeSign: faTengeSign,
  faTenge: faTenge,
  faHeadphones: faHeadphones,
  faHandsHolding: faHandsHolding,
  faCampfire: faCampfire,
  faCircleAmpersand: faCircleAmpersand,
  faSnowflakes: faSnowflakes,
  faHandsClapping: faHandsClapping,
  faRepublican: faRepublican,
  faLeafMaple: faLeafMaple,
  faArrowLeft: faArrowLeft,
  faPersonCircleXmark: faPersonCircleXmark,
  faRuler: faRuler,
  faCupStrawSwoosh: faCupStrawSwoosh,
  faTemperatureSun: faTemperatureSun,
  faTemperatureHot: faTemperatureHot,
  faAlignLeft: faAlignLeft,
  faDiceD6: faDiceD6,
  faRestroom: faRestroom,
  faHighDefinition: faHighDefinition,
  faRectangleHd: faRectangleHd,
  faJ: faJ,
  faGalaxy: faGalaxy,
  faUsersViewfinder: faUsersViewfinder,
  faFileVideo: faFileVideo,
  faCherries: faCherries,
  faUpRightFromSquare: faUpRightFromSquare,
  faExternalLinkAlt: faExternalLinkAlt,
  faCircleSort: faCircleSort,
  faSortCircle: faSortCircle,
  faTableCells: faTableCells,
  faTh: faTh,
  faFilePdf: faFilePdf,
  faSiren: faSiren,
  faArrowUpToDottedLine: faArrowUpToDottedLine,
  faImageLandscape: faImageLandscape,
  faLandscape: faLandscape,
  faTankWater: faTankWater,
  faCurlingStone: faCurlingStone,
  faCurling: faCurling,
  faGamepadModern: faGamepadModern,
  faGamepadAlt: faGamepadAlt,
  faMessagesQuestion: faMessagesQuestion,
  faBookBible: faBookBible,
  faBible: faBible,
  faO: faO,
  faSuitcaseMedical: faSuitcaseMedical,
  faMedkit: faMedkit,
  faBriefcaseArrowRight: faBriefcaseArrowRight,
  faExpandWide: faExpandWide,
  faClockElevenThirty: faClockElevenThirty,
  faRv: faRv,
  faUserSecret: faUserSecret,
  faOtter: faOtter,
  faDreidel: faDreidel,
  faPersonDress: faPersonDress,
  faFemale: faFemale,
  faCommentDollar: faCommentDollar,
  faBusinessTime: faBusinessTime,
  faBriefcaseClock: faBriefcaseClock,
  faFlowerTulip: faFlowerTulip,
  faPeoplePantsSimple: faPeoplePantsSimple,
  faCloudDrizzle: faCloudDrizzle,
  faTableCellsLarge: faTableCellsLarge,
  faThLarge: faThLarge,
  faBookTanakh: faBookTanakh,
  faTanakh: faTanakh,
  faSolarSystem: faSolarSystem,
  faSealQuestion: faSealQuestion,
  faPhoneVolume: faPhoneVolume,
  faVolumeControlPhone: faVolumeControlPhone,
  faDiscDrive: faDiscDrive,
  faHatCowboySide: faHatCowboySide,
  faTableRows: faTableRows,
  faRows: faRows,
  faLocationExclamation: faLocationExclamation,
  faMapMarkerExclamation: faMapMarkerExclamation,
  faFaceFearful: faFaceFearful,
  faClipboardUser: faClipboardUser,
  faBusSchool: faBusSchool,
  faFilmSlash: faFilmSlash,
  faSquareArrowDownRight: faSquareArrowDownRight,
  faBookSparkles: faBookSparkles,
  faBookSpells: faBookSpells,
  faWashingMachine: faWashingMachine,
  faWasher: faWasher,
  faChild: faChild,
  faLiraSign: faLiraSign,
  faUserVisor: faUserVisor,
  faFilePlusMinus: faFilePlusMinus,
  faChessClockFlip: faChessClockFlip,
  faChessClockAlt: faChessClockAlt,
  faSatellite: faSatellite,
  faPlaneLock: faPlaneLock,
  faSteeringWheel: faSteeringWheel,
  faTag: faTag,
  faStretcher: faStretcher,
  faBookSection: faBookSection,
  faBookLaw: faBookLaw,
  faInboxes: faInboxes,
  faCoffeeBean: faCoffeeBean,
  faCircleYen: faCircleYen,
  faBracketsCurly: faBracketsCurly,
  faEllipsisStrokeVertical: faEllipsisStrokeVertical,
  faEllipsisVAlt: faEllipsisVAlt,
  faComment: faComment,
  faSquare1: faSquare1,
  faCakeCandles: faCakeCandles,
  faBirthdayCake: faBirthdayCake,
  faCake: faCake,
  faHeadSide: faHeadSide,
  faEnvelope: faEnvelope,
  faDollyEmpty: faDollyEmpty,
  faFaceTissue: faFaceTissue,
  faAnglesUp: faAnglesUp,
  faAngleDoubleUp: faAngleDoubleUp,
  faBinRecycle: faBinRecycle,
  faPaperclip: faPaperclip,
  faChartLineDown: faChartLineDown,
  faArrowRightToCity: faArrowRightToCity,
  faLockA: faLockA,
  faRibbon: faRibbon,
  faLungs: faLungs,
  faPersonPinball: faPersonPinball,
  faArrowUp91: faArrowUp91,
  faSortNumericUpAlt: faSortNumericUpAlt,
  faAppleCore: faAppleCore,
  faCircleY: faCircleY,
  faH6: faH6,
  faLitecoinSign: faLitecoinSign,
  faCircleSmall: faCircleSmall,
  faBorderNone: faBorderNone,
  faArrowTurnDownLeft: faArrowTurnDownLeft,
  faCircleNodes: faCircleNodes,
  faParachuteBox: faParachuteBox,
  faMessageMedical: faMessageMedical,
  faCommentAltMedical: faCommentAltMedical,
  faRugbyBall: faRugbyBall,
  faCommentMusic: faCommentMusic,
  faIndent: faIndent,
  faTreeDeciduous: faTreeDeciduous,
  faTreeAlt: faTreeAlt,
  faPuzzlePieceSimple: faPuzzlePieceSimple,
  faPuzzlePieceAlt: faPuzzlePieceAlt,
  faTruckFieldUn: faTruckFieldUn,
  faNfcTrash: faNfcTrash,
  faHourglass: faHourglass,
  faHourglassEmpty: faHourglassEmpty,
  faMountain: faMountain,
  faFileXmark: faFileXmark,
  faFileTimes: faFileTimes,
  faHouseHeart: faHouseHeart,
  faHomeHeart: faHomeHeart,
  faHouseChimneyBlank: faHouseChimneyBlank,
  faMeterBolt: faMeterBolt,
  faUserDoctor: faUserDoctor,
  faUserMd: faUserMd,
  faSlashBack: faSlashBack,
  faCircleInfo: faCircleInfo,
  faInfoCircle: faInfoCircle,
  faFishingRod: faFishingRod,
  faHammerCrash: faHammerCrash,
  faMessageHeart: faMessageHeart,
  faCloudMeatball: faCloudMeatball,
  faCameraPolaroid: faCameraPolaroid,
  faCamera: faCamera,
  faCameraAlt: faCameraAlt,
  faSquareVirus: faSquareVirus,
  faCartArrowUp: faCartArrowUp,
  faMeteor: faMeteor,
  faCarOn: faCarOn,
  faSleigh: faSleigh,
  faArrowDown19: faArrowDown19,
  faSortNumericAsc: faSortNumericAsc,
  faSortNumericDown: faSortNumericDown,
  faBuoyMooring: faBuoyMooring,
  faSquare4: faSquare4,
  faHandHoldingDroplet: faHandHoldingDroplet,
  faHandHoldingWater: faHandHoldingWater,
  faTricycleAdult: faTricycleAdult,
  faWaveform: faWaveform,
  faWater: faWater,
  faStarSharpHalfStroke: faStarSharpHalfStroke,
  faStarSharpHalfAlt: faStarSharpHalfAlt,
  faNfcSignal: faNfcSignal,
  faPlaneProp: faPlaneProp,
  faCalendarCheck: faCalendarCheck,
  faClockDesk: faClockDesk,
  faCalendarClock: faCalendarClock,
  faCalendarTime: faCalendarTime,
  faBraille: faBraille,
  faPrescriptionBottleMedical: faPrescriptionBottleMedical,
  faPrescriptionBottleAlt: faPrescriptionBottleAlt,
  faPlateUtensils: faPlateUtensils,
  faFamilyPants: faFamilyPants,
  faHoseReel: faHoseReel,
  faHouseWindow: faHouseWindow,
  faLandmark: faLandmark,
  faTruck: faTruck,
  faCrosshairs: faCrosshairs,
  faCloudRainbow: faCloudRainbow,
  faPersonCane: faPersonCane,
  faAlien: faAlien,
  faTent: faTent,
  faLaptopBinary: faLaptopBinary,
  faVestPatches: faVestPatches,
  faPeopleDressSimple: faPeopleDressSimple,
  faCheckDouble: faCheckDouble,
  faArrowDownAZ: faArrowDownAZ,
  faSortAlphaAsc: faSortAlphaAsc,
  faSortAlphaDown: faSortAlphaDown,
  faBowlingBallPin: faBowlingBallPin,
  faBellSchoolSlash: faBellSchoolSlash,
  faPlusLarge: faPlusLarge,
  faMoneyBillWheat: faMoneyBillWheat,
  faCameraViewfinder: faCameraViewfinder,
  faScreenshot: faScreenshot,
  faMessageMusic: faMessageMusic,
  faCommentAltMusic: faCommentAltMusic,
  faCarBuilding: faCarBuilding,
  faBorderBottomRight: faBorderBottomRight,
  faBorderStyleAlt: faBorderStyleAlt,
  faOctagon: faOctagon,
  faCommentArrowUpRight: faCommentArrowUpRight,
  faOctagonDivide: faOctagonDivide,
  faCookie: faCookie,
  faArrowRotateLeft: faArrowRotateLeft,
  faArrowLeftRotate: faArrowLeftRotate,
  faArrowRotateBack: faArrowRotateBack,
  faArrowRotateBackward: faArrowRotateBackward,
  faUndo: faUndo,
  faTvMusic: faTvMusic,
  faHardDrive: faHardDrive,
  faHdd: faHdd,
  faReel: faReel,
  faFaceGrinSquintTears: faFaceGrinSquintTears,
  faGrinSquintTears: faGrinSquintTears,
  faDumbbell: faDumbbell,
  faRectangleList: faRectangleList,
  faListAlt: faListAlt,
  faTarpDroplet: faTarpDroplet,
  faAlarmExclamation: faAlarmExclamation,
  faHouseMedicalCircleCheck: faHouseMedicalCircleCheck,
  faTrafficCone: faTrafficCone,
  faGrate: faGrate,
  faArrowDownRight: faArrowDownRight,
  faPersonSkiingNordic: faPersonSkiingNordic,
  faSkiingNordic: faSkiingNordic,
  faCalendarPlus: faCalendarPlus,
  faPersonFromPortal: faPersonFromPortal,
  faPortalExit: faPortalExit,
  faPlaneArrival: faPlaneArrival,
  faCowbellCirclePlus: faCowbellCirclePlus,
  faCowbellMore: faCowbellMore,
  faCircleLeft: faCircleLeft,
  faArrowAltCircleLeft: faArrowAltCircleLeft,
  faDistributeSpacingVertical: faDistributeSpacingVertical,
  faSignalBarsFair: faSignalBarsFair,
  faSignalAlt2: faSignalAlt2,
  faSportsball: faSportsball,
  faGameConsoleHandheldCrank: faGameConsoleHandheldCrank,
  faTrainSubway: faTrainSubway,
  faSubway: faSubway,
  faChartGantt: faChartGantt,
  faFaceSmileUpsideDown: faFaceSmileUpsideDown,
  faBallPile: faBallPile,
  faBadgeDollar: faBadgeDollar,
  faMoneyBillsSimple: faMoneyBillsSimple,
  faMoneyBillsAlt: faMoneyBillsAlt,
  faListTimeline: faListTimeline,
  faIndianRupeeSign: faIndianRupeeSign,
  faIndianRupee: faIndianRupee,
  faInr: faInr,
  faCropSimple: faCropSimple,
  faCropAlt: faCropAlt,
  faMoneyBill1: faMoneyBill1,
  faMoneyBillAlt: faMoneyBillAlt,
  faLeftLong: faLeftLong,
  faLongArrowAltLeft: faLongArrowAltLeft,
  faKeyboardDown: faKeyboardDown,
  faCircleUpRight: faCircleUpRight,
  faCloudBoltMoon: faCloudBoltMoon,
  faThunderstormMoon: faThunderstormMoon,
  faDna: faDna,
  faVirusSlash: faVirusSlash,
  faBracketRoundRight: faBracketRoundRight,
  faCircleSterling: faCircleSterling,
  faCircle5: faCircle5,
  faMinus: faMinus,
  faSubtract: faSubtract,
  faFireFlame: faFireFlame,
  faFlame: faFlame,
  faRightToLine: faRightToLine,
  faArrowAltToRight: faArrowAltToRight,
  faGif: faGif,
  faChess: faChess,
  faTrashSlash: faTrashSlash,
  faArrowLeftLong: faArrowLeftLong,
  faLongArrowLeft: faLongArrowLeft,
  faPlugCircleCheck: faPlugCircleCheck,
  faFontCase: faFontCase,
  faStreetView: faStreetView,
  faArrowDownLeft: faArrowDownLeft,
  faFrancSign: faFrancSign,
  faFlaskRoundPoison: faFlaskRoundPoison,
  faFlaskPoison: faFlaskPoison,
  faVolumeOff: faVolumeOff,
  faBookCircleArrowRight: faBookCircleArrowRight,
  faChartUser: faChartUser,
  faUserChart: faUserChart,
  faHandsAslInterpreting: faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
  faAslInterpreting: faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting: faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen: faPresentationScreen,
  faPresentation: faPresentation,
  faCircleBolt: faCircleBolt,
  faFaceSmileHalo: faFaceSmileHalo,
  faCartCircleArrowDown: faCartCircleArrowDown,
  faHousePersonReturn: faHousePersonReturn,
  faHousePersonArrive: faHousePersonArrive,
  faHouseReturn: faHouseReturn,
  faMessageXmark: faMessageXmark,
  faCommentAltTimes: faCommentAltTimes,
  faMessageTimes: faMessageTimes,
  faFileCertificate: faFileCertificate,
  faFileAward: faFileAward,
  faUserDoctorHairLong: faUserDoctorHairLong,
  faCameraSecurity: faCameraSecurity,
  faCameraHome: faCameraHome,
  faGear: faGear,
  faCog: faCog,
  faDropletSlash: faDropletSlash,
  faTintSlash: faTintSlash,
  faBookHeart: faBookHeart,
  faMosque: faMosque,
  faDuck: faDuck,
  faMosquito: faMosquito,
  faStarOfDavid: faStarOfDavid,
  faFlagSwallowtail: faFlagSwallowtail,
  faFlagAlt: faFlagAlt,
  faPersonMilitaryRifle: faPersonMilitaryRifle,
  faCarGarage: faCarGarage,
  faCartShopping: faCartShopping,
  faShoppingCart: faShoppingCart,
  faBookFont: faBookFont,
  faShieldPlus: faShieldPlus,
  faVials: faVials,
  faEyeDropperFull: faEyeDropperFull,
  faDistributeSpacingHorizontal: faDistributeSpacingHorizontal,
  faTabletRugged: faTabletRugged,
  faTemperatureSnow: faTemperatureSnow,
  faTemperatureFrigid: faTemperatureFrigid,
  faMoped: faMoped,
  faFaceSmilePlus: faFaceSmilePlus,
  faSmilePlus: faSmilePlus,
  faRadioTuner: faRadioTuner,
  faRadioAlt: faRadioAlt,
  faFaceSwear: faFaceSwear,
  faWaterArrowDown: faWaterArrowDown,
  faWaterLower: faWaterLower,
  faScannerTouchscreen: faScannerTouchscreen,
  faCircle7: faCircle7,
  faPlugCirclePlus: faPlugCirclePlus,
  faPersonSkiJumping: faPersonSkiJumping,
  faSkiJump: faSkiJump,
  faPlaceOfWorship: faPlaceOfWorship,
  faWaterArrowUp: faWaterArrowUp,
  faWaterRise: faWaterRise,
  faWaveformLines: faWaveformLines,
  faWaveformPath: faWaveformPath,
  faSplit: faSplit,
  faFilmCanister: faFilmCanister,
  faFilmCannister: faFilmCannister,
  faFolderXmark: faFolderXmark,
  faFolderTimes: faFolderTimes,
  faToiletPaperBlank: faToiletPaperBlank,
  faToiletPaperAlt: faToiletPaperAlt,
  faTabletScreen: faTabletScreen,
  faTabletAndroidAlt: faTabletAndroidAlt,
  faHexagonVerticalNftSlanted: faHexagonVerticalNftSlanted,
  faFolderMusic: faFolderMusic,
  faDisplayMedical: faDisplayMedical,
  faDesktopMedical: faDesktopMedical,
  faShareAll: faShareAll,
  faPeapod: faPeapod,
  faChessClock: faChessClock,
  faAxe: faAxe,
  faSquareD: faSquareD,
  faGripVertical: faGripVertical,
  faMobileSignalOut: faMobileSignalOut,
  faArrowTurnUp: faArrowTurnUp,
  faLevelUp: faLevelUp,
  faU: faU,
  faArrowUpFromDottedLine: faArrowUpFromDottedLine,
  faSquareRootVariable: faSquareRootVariable,
  faSquareRootAlt: faSquareRootAlt,
  faLightSwitchOn: faLightSwitchOn,
  faArrowDownArrowUp: faArrowDownArrowUp,
  faSortAlt: faSortAlt,
  faRaindrops: faRaindrops,
  faDash: faDash,
  faMinusLarge: faMinusLarge,
  faClock: faClock,
  faClockFour: faClockFour,
  faInputNumeric: faInputNumeric,
  faTruckTow: faTruckTow,
  faBackwardStep: faBackwardStep,
  faStepBackward: faStepBackward,
  faPallet: faPallet,
  faCarBolt: faCarBolt,
  faArrowsMaximize: faArrowsMaximize,
  faExpandArrows: faExpandArrows,
  faFaucet: faFaucet,
  faCloudSleet: faCloudSleet,
  faLampStreet: faLampStreet,
  faListRadio: faListRadio,
  faPenNibSlash: faPenNibSlash,
  faBaseballBatBall: faBaseballBatBall,
  faSquareUpLeft: faSquareUpLeft,
  faOverline: faOverline,
  faS: faS,
  faTimeline: faTimeline,
  faKeyboard: faKeyboard,
  faArrowsFromDottedLine: faArrowsFromDottedLine,
  faUsbDrive: faUsbDrive,
  faBallot: faBallot,
  faCaretDown: faCaretDown,
  faLocationDotSlash: faLocationDotSlash,
  faMapMarkerAltSlash: faMapMarkerAltSlash,
  faCards: faCards,
  faHouseChimneyMedical: faHouseChimneyMedical,
  faClinicMedical: faClinicMedical,
  faBoxingGlove: faBoxingGlove,
  faGloveBoxing: faGloveBoxing,
  faTemperatureThreeQuarters: faTemperatureThreeQuarters,
  faTemperature3: faTemperature3,
  faThermometer3: faThermometer3,
  faThermometerThreeQuarters: faThermometerThreeQuarters,
  faBellSchool: faBellSchool,
  faMobileScreen: faMobileScreen,
  faMobileAndroidAlt: faMobileAndroidAlt,
  faPlaneUp: faPlaneUp,
  faFolderHeart: faFolderHeart,
  faCircleLocationArrow: faCircleLocationArrow,
  faLocationCircle: faLocationCircle,
  faFaceHeadBandage: faFaceHeadBandage,
  faSushiRoll: faSushiRoll,
  faMakiRoll: faMakiRoll,
  faMakizushi: faMakizushi,
  faCarBump: faCarBump,
  faPiggyBank: faPiggyBank,
  faRacquet: faRacquet,
  faCarMirrors: faCarMirrors,
  faIndustryWindows: faIndustryWindows,
  faIndustryAlt: faIndustryAlt,
  faBoltAuto: faBoltAuto,
  faBatteryHalf: faBatteryHalf,
  faBattery3: faBattery3,
  faFluxCapacitor: faFluxCapacitor,
  faMountainCity: faMountainCity,
  faCoins: faCoins,
  faHoneyPot: faHoneyPot,
  faOlive: faOlive,
  faKhanda: faKhanda,
  faFilterList: faFilterList,
  faOutlet: faOutlet,
  faSliders: faSliders,
  faSlidersH: faSlidersH,
  faCauldron: faCauldron,
  faPeople: faPeople,
  faFolderTree: faFolderTree,
  faNetworkWired: faNetworkWired,
  faCroissant: faCroissant,
  faMapPin: faMapPin,
  faHamsa: faHamsa,
  faCentSign: faCentSign,
  faSwordsLaser: faSwordsLaser,
  faFlask: faFlask,
  faPersonPregnant: faPersonPregnant,
  faSquareU: faSquareU,
  faWandSparkles: faWandSparkles,
  faRouter: faRouter,
  faEllipsisVertical: faEllipsisVertical,
  faEllipsisV: faEllipsisV,
  faSwordLaserAlt: faSwordLaserAlt,
  faTicket: faTicket,
  faPowerOff: faPowerOff,
  faCoin: faCoin,
  faLaptopSlash: faLaptopSlash,
  faRightLong: faRightLong,
  faLongArrowAltRight: faLongArrowAltRight,
  faCircleB: faCircleB,
  faPersonDressSimple: faPersonDressSimple,
  faPipeCollar: faPipeCollar,
  faLightsHoliday: faLightsHoliday,
  faCitrus: faCitrus,
  faFlagUsa: faFlagUsa,
  faLaptopFile: faLaptopFile,
  faTty: faTty,
  faTeletype: faTeletype,
  faChartTreeMap: faChartTreeMap,
  faDiagramNext: faDiagramNext,
  faPersonRifle: faPersonRifle,
  faClockFiveThirty: faClockFiveThirty,
  faPipeValve: faPipeValve,
  faArrowUpFromArc: faArrowUpFromArc,
  faFaceSpiralEyes: faFaceSpiralEyes,
  faCompressWide: faCompressWide,
  faCirclePhoneHangup: faCirclePhoneHangup,
  faPhoneCircleDown: faPhoneCircleDown,
  faGearComplexCode: faGearComplexCode,
  faHouseMedicalCircleExclamation: faHouseMedicalCircleExclamation,
  faBadminton: faBadminton,
  faClosedCaptioning: faClosedCaptioning,
  faPersonHiking: faPersonHiking,
  faHiking: faHiking,
  faRightFromLine: faRightFromLine,
  faArrowAltFromLeft: faArrowAltFromLeft,
  faVenusDouble: faVenusDouble,
  faImages: faImages,
  faCalculator: faCalculator,
  faShuttlecock: faShuttlecock,
  faUserHair: faUserHair,
  faEyeEvil: faEyeEvil,
  faPeoplePulling: faPeoplePulling,
  faN: faN,
  faGarage: faGarage,
  faCableCar: faCableCar,
  faTram: faTram,
  faShovelSnow: faShovelSnow,
  faCloudRain: faCloudRain,
  faFaceLying: faFaceLying,
  faSprinkler: faSprinkler,
  faBuildingCircleXmark: faBuildingCircleXmark,
  faPersonSledding: faPersonSledding,
  faSledding: faSledding,
  faGameConsoleHandheld: faGameConsoleHandheld,
  faShip: faShip,
  faClockSixThirty: faClockSixThirty,
  faBatterySlash: faBatterySlash,
  faTugrikSign: faTugrikSign,
  faArrowsDownToLine: faArrowsDownToLine,
  faDownload: faDownload,
  faShelves: faShelves,
  faInventory: faInventory,
  faCloudSnow: faCloudSnow,
  faFaceGrin: faFaceGrin,
  faGrin: faGrin,
  faDeleteLeft: faDeleteLeft,
  faBackspace: faBackspace,
  faOven: faOven,
  faCloudBinary: faCloudBinary,
  faEyeDropper: faEyeDropper,
  faEyeDropperEmpty: faEyeDropperEmpty,
  faEyedropper: faEyedropper,
  faCommentCaptions: faCommentCaptions,
  faCommentsQuestion: faCommentsQuestion,
  faScribble: faScribble,
  faRotateExclamation: faRotateExclamation,
  faFileCircleCheck: faFileCircleCheck,
  faGlass: faGlass,
  faLoader: faLoader,
  faForward: faForward,
  faUserPilot: faUserPilot,
  faMobile: faMobile,
  faMobileAndroid: faMobileAndroid,
  faMobilePhone: faMobilePhone,
  faCodePullRequestClosed: faCodePullRequestClosed,
  faFaceMeh: faFaceMeh,
  faMeh: faMeh,
  faAlignCenter: faAlignCenter,
  faBookSkull: faBookSkull,
  faBookDead: faBookDead,
  faIdCard: faIdCard,
  faDriversLicense: faDriversLicense,
  faFaceDotted: faFaceDotted,
  faFaceWorried: faFaceWorried,
  faOutdent: faOutdent,
  faDedent: faDedent,
  faHeartCircleExclamation: faHeartCircleExclamation,
  faHouse: faHouse,
  faHome: faHome,
  faHomeAlt: faHomeAlt,
  faHomeLgAlt: faHomeLgAlt,
  faVectorCircle: faVectorCircle,
  faCarCircleBolt: faCarCircleBolt,
  faCalendarWeek: faCalendarWeek,
  faFlyingDisc: faFlyingDisc,
  faLaptopMedical: faLaptopMedical,
  faSquareDownRight: faSquareDownRight,
  faB: faB,
  faSeatAirline: faSeatAirline,
  faMoonOverSun: faMoonOverSun,
  faEclipseAlt: faEclipseAlt,
  faPipe: faPipe,
  faFileMedical: faFileMedical,
  faPotato: faPotato,
  faDiceOne: faDiceOne,
  faCircleA: faCircleA,
  faHelmetBattle: faHelmetBattle,
  faButter: faButter,
  faBlanketFire: faBlanketFire,
  faKiwiBird: faKiwiBird,
  faCastle: faCastle,
  faGolfClub: faGolfClub,
  faArrowRightArrowLeft: faArrowRightArrowLeft,
  faExchange: faExchange,
  faRotateRight: faRotateRight,
  faRedoAlt: faRedoAlt,
  faRotateForward: faRotateForward,
  faUtensils: faUtensils,
  faCutlery: faCutlery,
  faArrowUpWideShort: faArrowUpWideShort,
  faSortAmountUp: faSortAmountUp,
  faChartPieSimpleCircleDollar: faChartPieSimpleCircleDollar,
  faBalloons: faBalloons,
  faMillSign: faMillSign,
  faBowlRice: faBowlRice,
  faTimelineArrow: faTimelineArrow,
  faSkull: faSkull,
  faGameBoardSimple: faGameBoardSimple,
  faGameBoardAlt: faGameBoardAlt,
  faCircleVideo: faCircleVideo,
  faVideoCircle: faVideoCircle,
  faChartScatterBubble: faChartScatterBubble,
  faHouseTurret: faHouseTurret,
  faBanana: faBanana,
  faHandHoldingSkull: faHandHoldingSkull,
  faPeopleDress: faPeopleDress,
  faLoveseat: faLoveseat,
  faCouchSmall: faCouchSmall,
  faTowerBroadcast: faTowerBroadcast,
  faBroadcastTower: faBroadcastTower,
  faTruckPickup: faTruckPickup,
  faBlockQuote: faBlockQuote,
  faUpLong: faUpLong,
  faLongArrowAltUp: faLongArrowAltUp,
  faStop: faStop,
  faCodeMerge: faCodeMerge,
  faMoneyCheckDollarPen: faMoneyCheckDollarPen,
  faMoneyCheckEditAlt: faMoneyCheckEditAlt,
  faUpFromLine: faUpFromLine,
  faArrowAltFromBottom: faArrowAltFromBottom,
  faUpload: faUpload,
  faHurricane: faHurricane,
  faGridRound2Plus: faGridRound2Plus,
  faPeoplePants: faPeoplePants,
  faMound: faMound,
  faWindsock: faWindsock,
  faCircleHalf: faCircleHalf,
  faBrakeWarning: faBrakeWarning,
  faToiletPortable: faToiletPortable,
  faCompactDisc: faCompactDisc,
  faFileArrowDown: faFileArrowDown,
  faFileDownload: faFileDownload,
  faSaxophoneFire: faSaxophoneFire,
  faSaxHot: faSaxHot,
  faCameraWebSlash: faCameraWebSlash,
  faWebcamSlash: faWebcamSlash,
  faFolderMedical: faFolderMedical,
  faFolderGear: faFolderGear,
  faFolderCog: faFolderCog,
  faHandWave: faHandWave,
  faArrowUpArrowDown: faArrowUpArrowDown,
  faSortUpDown: faSortUpDown,
  faCaravan: faCaravan,
  faShieldCat: faShieldCat,
  faMessageSlash: faMessageSlash,
  faCommentAltSlash: faCommentAltSlash,
  faBolt: faBolt,
  faZap: faZap,
  faTrashCanCheck: faTrashCanCheck,
  faGlassWater: faGlassWater,
  faOilWell: faOilWell,
  faPersonSimple: faPersonSimple,
  faVault: faVault,
  faMars: faMars,
  faToilet: faToilet,
  faPlaneCircleXmark: faPlaneCircleXmark,
  faYenSign: faYenSign,
  faCny: faCny,
  faJpy: faJpy,
  faRmb: faRmb,
  faYen: faYen,
  faGearCode: faGearCode,
  faNotes: faNotes,
  faRubleSign: faRubleSign,
  faRouble: faRouble,
  faRub: faRub,
  faRuble: faRuble,
  faTrashUndo: faTrashUndo,
  faTrashArrowTurnLeft: faTrashArrowTurnLeft,
  faChampagneGlass: faChampagneGlass,
  faGlassChampagne: faGlassChampagne,
  faObjectsAlignCenterHorizontal: faObjectsAlignCenterHorizontal,
  faSun: faSun,
  faTrashCanSlash: faTrashCanSlash,
  faTrashAltSlash: faTrashAltSlash,
  faScreenUsers: faScreenUsers,
  faUsersClass: faUsersClass,
  faGuitar: faGuitar,
  faSquareArrowLeft: faSquareArrowLeft,
  faArrowSquareLeft: faArrowSquareLeft,
  faSquare8: faSquare8,
  faFaceSmileHearts: faFaceSmileHearts,
  faBracketsSquare: faBracketsSquare,
  faBrackets: faBrackets,
  faLaptopArrowDown: faLaptopArrowDown,
  faHockeyStickPuck: faHockeyStickPuck,
  faHouseTree: faHouseTree,
  faSignalFair: faSignalFair,
  faSignal2: faSignal2,
  faFaceLaughWink: faFaceLaughWink,
  faLaughWink: faLaughWink,
  faCircleDollar: faCircleDollar,
  faDollarCircle: faDollarCircle,
  faUsdCircle: faUsdCircle,
  faHorseHead: faHorseHead,
  faArrowsRepeat: faArrowsRepeat,
  faRepeatAlt: faRepeatAlt,
  faBoreHole: faBoreHole,
  faIndustry: faIndustry,
  faImagePolaroid: faImagePolaroid,
  faWaveTriangle: faWaveTriangle,
  faPersonRunningFast: faPersonRunningFast,
  faCircleDown: faCircleDown,
  faArrowAltCircleDown: faArrowAltCircleDown,
  faGrill: faGrill,
  faArrowsTurnToDots: faArrowsTurnToDots,
  faChartMixed: faChartMixed,
  faAnalytics: faAnalytics,
  faFlorinSign: faFlorinSign,
  faArrowDownShortWide: faArrowDownShortWide,
  faSortAmountDesc: faSortAmountDesc,
  faSortAmountDownAlt: faSortAmountDownAlt,
  faLessThan: faLessThan,
  faDisplayCode: faDisplayCode,
  faDesktopCode: faDesktopCode,
  faFaceDrooling: faFaceDrooling,
  faOilTemperature: faOilTemperature,
  faOilTemp: faOilTemp,
  faSquareQuestion: faSquareQuestion,
  faQuestionSquare: faQuestionSquare,
  faAirConditioner: faAirConditioner,
  faAngleDown: faAngleDown,
  faMountains: faMountains,
  faOmega: faOmega,
  faCarTunnel: faCarTunnel,
  faPersonDollyEmpty: faPersonDollyEmpty,
  faPanFood: faPanFood,
  faHeadSideCough: faHeadSideCough,
  faGripLines: faGripLines,
  faThumbsDown: faThumbsDown,
  faUserLock: faUserLock,
  faArrowRightLong: faArrowRightLong,
  faLongArrowRight: faLongArrowRight,
  faTicketsAirline: faTicketsAirline,
  faAnchorCircleXmark: faAnchorCircleXmark,
  faEllipsis: faEllipsis,
  faEllipsisH: faEllipsisH,
  faNfcSlash: faNfcSlash,
  faChessPawn: faChessPawn,
  faKitMedical: faKitMedical,
  faFirstAid: faFirstAid,
  faGrid2Plus: faGrid2Plus,
  faBells: faBells,
  faPersonThroughWindow: faPersonThroughWindow,
  faToolbox: faToolbox,
  faEnvelopeDot: faEnvelopeDot,
  faEnvelopeBadge: faEnvelopeBadge,
  faHandsHoldingCircle: faHandsHoldingCircle,
  faBug: faBug,
  faBowlChopsticks: faBowlChopsticks,
  faCreditCard: faCreditCard,
  faCreditCardAlt: faCreditCardAlt,
  faCircleS: faCircleS,
  faBoxBallot: faBoxBallot,
  faCar: faCar,
  faAutomobile: faAutomobile,
  faHandHoldingHand: faHandHoldingHand,
  faUserTieHair: faUserTieHair,
  faPodiumStar: faPodiumStar,
  faUserHairMullet: faUserHairMullet,
  faBusinessFront: faBusinessFront,
  faPartyBack: faPartyBack,
  faTrianBalbot: faTrianBalbot,
  faMicrophoneStand: faMicrophoneStand,
  faBookOpenReader: faBookOpenReader,
  faBookReader: faBookReader,
  faFamilyDress: faFamilyDress,
  faCircleX: faCircleX,
  faCabin: faCabin,
  faMountainSun: faMountainSun,
  faChartSimpleHorizontal: faChartSimpleHorizontal,
  faBluetooth: faBluetooth,
  faArrowsLeftRightToLine: faArrowsLeftRightToLine,
  faHandBackPointLeft: faHandBackPointLeft,
  faMessageDots: faMessageDots,
  faCommentAltDots: faCommentAltDots,
  faMessaging: faMessaging,
  faFileHeart: faFileHeart,
  faBeerMug: faBeerMug,
  faBeerFoam: faBeerFoam,
  faDiceD20: faDiceD20,
  faDrone: faDrone,
  faTruckDroplet: faTruckDroplet,
  faFileCircleXmark: faFileCircleXmark,
  faTemperatureArrowUp: faTemperatureArrowUp,
  faTemperatureUp: faTemperatureUp,
  faMedal: faMedal,
  faBed: faBed,
  faBookCopy: faBookCopy,
  faSquareH: faSquareH,
  faHSquare: faHSquare,
  faSquareC: faSquareC,
  faClockTwo: faClockTwo,
  faSquareEllipsisVertical: faSquareEllipsisVertical,
  faCalendarUsers: faCalendarUsers,
  faPodcast: faPodcast,
  faBee: faBee,
  faTemperatureFull: faTemperatureFull,
  faTemperature4: faTemperature4,
  faThermometer4: faThermometer4,
  faThermometerFull: faThermometerFull,
  faBell: faBell,
  faCandyBar: faCandyBar,
  faChocolateBar: faChocolateBar,
  faXmarkLarge: faXmarkLarge,
  faPinata: faPinata,
  faArrowsFromLine: faArrowsFromLine,
  faSuperscript: faSuperscript,
  faBowlSpoon: faBowlSpoon,
  faHexagonCheck: faHexagonCheck,
  faPlugCircleXmark: faPlugCircleXmark,
  faStarOfLife: faStarOfLife,
  faPhoneSlash: faPhoneSlash,
  faTrafficLightStop: faTrafficLightStop,
  faPaintRoller: faPaintRoller,
  faAccentGrave: faAccentGrave,
  faHandshakeAngle: faHandshakeAngle,
  faHandsHelping: faHandsHelping,
  faCircle0: faCircle0,
  faDialMedLow: faDialMedLow,
  faLocationDot: faLocationDot,
  faMapMarkerAlt: faMapMarkerAlt,
  faCrab: faCrab,
  faBoxOpenFull: faBoxOpenFull,
  faBoxFull: faBoxFull,
  faFile: faFile,
  faGreaterThan: faGreaterThan,
  faQuotes: faQuotes,
  faPretzel: faPretzel,
  faPersonSwimming: faPersonSwimming,
  faSwimmer: faSwimmer,
  faArrowDown: faArrowDown,
  faUserRobotXmarks: faUserRobotXmarks,
  faMessageQuote: faMessageQuote,
  faCommentAltQuote: faCommentAltQuote,
  faCandyCorn: faCandyCorn,
  faFolderMagnifyingGlass: faFolderMagnifyingGlass,
  faFolderSearch: faFolderSearch,
  faNotebook: faNotebook,
  faDroplet: faDroplet,
  faTint: faTint,
  faBullseyePointer: faBullseyePointer,
  faEraser: faEraser,
  faHexagonImage: faHexagonImage,
  faEarthAmericas: faEarthAmericas,
  faEarth: faEarth,
  faEarthAmerica: faEarthAmerica,
  faGlobeAmericas: faGlobeAmericas,
  faCrateApple: faCrateApple,
  faAppleCrate: faAppleCrate,
  faPersonBurst: faPersonBurst,
  faGameBoard: faGameBoard,
  faHatChef: faHatChef,
  faHandBackPointRight: faHandBackPointRight,
  faDove: faDove,
  faSnowflakeDroplets: faSnowflakeDroplets,
  faBatteryEmpty: faBatteryEmpty,
  faBattery0: faBattery0,
  faGrid4: faGrid4,
  faSocks: faSocks,
  faFaceSunglasses: faFaceSunglasses,
  faInbox: faInbox,
  faSquare0: faSquare0,
  faSection: faSection,
  faSquareThisWayUp: faSquareThisWayUp,
  faBoxUp: faBoxUp,
  faGaugeHigh: faGaugeHigh,
  faTachometerAlt: faTachometerAlt,
  faTachometerAltFast: faTachometerAltFast,
  faSquareAmpersand: faSquareAmpersand,
  faEnvelopeOpenText: faEnvelopeOpenText,
  faLampDesk: faLampDesk,
  faHospital: faHospital,
  faHospitalAlt: faHospitalAlt,
  faHospitalWide: faHospitalWide,
  faPollPeople: faPollPeople,
  faWhiskeyGlassIce: faWhiskeyGlassIce,
  faGlassWhiskeyRocks: faGlassWhiskeyRocks,
  faWineBottle: faWineBottle,
  faChessRook: faChessRook,
  faUserBountyHunter: faUserBountyHunter,
  faBarsStaggered: faBarsStaggered,
  faReorder: faReorder,
  faStream: faStream,
  faDiagramSankey: faDiagramSankey,
  faCloudHailMixed: faCloudHailMixed,
  faCircleUpLeft: faCircleUpLeft,
  faDharmachakra: faDharmachakra,
  faObjectsAlignLeft: faObjectsAlignLeft,
  faOilCanDrip: faOilCanDrip,
  faFaceSmilingHands: faFaceSmilingHands,
  faBroccoli: faBroccoli,
  faRouteInterstate: faRouteInterstate,
  faEarMuffs: faEarMuffs,
  faHotdog: faHotdog,
  faTransporterEmpty: faTransporterEmpty,
  faPersonWalkingWithCane: faPersonWalkingWithCane,
  faBlind: faBlind,
  faAngle90: faAngle90,
  faRectangleTerminal: faRectangleTerminal,
  faKite: faKite,
  faDrum: faDrum,
  faScrubber: faScrubber,
  faIceCream: faIceCream,
  faHeartCircleBolt: faHeartCircleBolt,
  faFishBones: faFishBones,
  faDeerRudolph: faDeerRudolph,
  faFax: faFax,
  faParagraph: faParagraph,
  faHeadSideHeart: faHeadSideHeart,
  faSquareE: faSquareE,
  faMeterFire: faMeterFire,
  faCloudHail: faCloudHail,
  faCheckToSlot: faCheckToSlot,
  faVoteYea: faVoteYea,
  faMoneyFromBracket: faMoneyFromBracket,
  faStarHalf: faStarHalf,
  faCarBus: faCarBus,
  faSpeaker: faSpeaker,
  faTimer: faTimer,
  faBoxesStacked: faBoxesStacked,
  faBoxes: faBoxes,
  faBoxesAlt: faBoxesAlt,
  faGrillHot: faGrillHot,
  faBallotCheck: faBallotCheck,
  faLink: faLink,
  faChain: faChain,
  faEarListen: faEarListen,
  faAssistiveListeningSystems: faAssistiveListeningSystems,
  faFileMinus: faFileMinus,
  faTreeCity: faTreeCity,
  faPlay: faPlay,
  faFont: faFont,
  faCupTogo: faCupTogo,
  faCoffeeTogo: faCoffeeTogo,
  faSquareDownLeft: faSquareDownLeft,
  faBurgerLettuce: faBurgerLettuce,
  faRupiahSign: faRupiahSign,
  faMagnifyingGlass: faMagnifyingGlass,
  faSearch: faSearch,
  faTableTennisPaddleBall: faTableTennisPaddleBall,
  faPingPongPaddleBall: faPingPongPaddleBall,
  faTableTennis: faTableTennis,
  faPersonDotsFromLine: faPersonDotsFromLine,
  faDiagnoses: faDiagnoses,
  faChevronsDown: faChevronsDown,
  faChevronDoubleDown: faChevronDoubleDown,
  faTrashCanArrowUp: faTrashCanArrowUp,
  faTrashRestoreAlt: faTrashRestoreAlt,
  faSignalGood: faSignalGood,
  faSignal3: faSignal3,
  faLocationQuestion: faLocationQuestion,
  faMapMarkerQuestion: faMapMarkerQuestion,
  faFloppyDiskCircleXmark: faFloppyDiskCircleXmark,
  faFloppyDiskTimes: faFloppyDiskTimes,
  faSaveCircleXmark: faSaveCircleXmark,
  faSaveTimes: faSaveTimes,
  faNairaSign: faNairaSign,
  faPeach: faPeach,
  faTaxiBus: faTaxiBus,
  faBracketCurly: faBracketCurly,
  faBracketCurlyLeft: faBracketCurlyLeft,
  faLobster: faLobster,
  faCartFlatbedEmpty: faCartFlatbedEmpty,
  faDollyFlatbedEmpty: faDollyFlatbedEmpty,
  faColon: faColon,
  faCartArrowDown: faCartArrowDown,
  faWand: faWand,
  faWalkieTalkie: faWalkieTalkie,
  faFilePen: faFilePen,
  faFileEdit: faFileEdit,
  faReceipt: faReceipt,
  faTablePicnic: faTablePicnic,
  faSquarePen: faSquarePen,
  faPenSquare: faPenSquare,
  faPencilSquare: faPencilSquare,
  faCircleMicrophoneLines: faCircleMicrophoneLines,
  faMicrophoneCircleAlt: faMicrophoneCircleAlt,
  faDisplaySlash: faDisplaySlash,
  faDesktopSlash: faDesktopSlash,
  faSuitcaseRolling: faSuitcaseRolling,
  faPersonCircleExclamation: faPersonCircleExclamation,
  faTransporter2: faTransporter2,
  faHandsHoldingDiamond: faHandsHoldingDiamond,
  faHandReceiving: faHandReceiving,
  faMoneyBillSimpleWave: faMoneyBillSimpleWave,
  faChevronDown: faChevronDown,
  faBatteryFull: faBatteryFull,
  faBattery: faBattery,
  faBattery5: faBattery5,
  faBellPlus: faBellPlus,
  faBookArrowRight: faBookArrowRight,
  faHospitals: faHospitals,
  faClub: faClub,
  faSkullCrossbones: faSkullCrossbones,
  faDropletDegree: faDropletDegree,
  faDewpoint: faDewpoint,
  faCodeCompare: faCodeCompare,
  faListUl: faListUl,
  faListDots: faListDots,
  faHandHoldingMagic: faHandHoldingMagic,
  faWatermelonSlice: faWatermelonSlice,
  faCircleEllipsis: faCircleEllipsis,
  faSchoolLock: faSchoolLock,
  faTowerCell: faTowerCell,
  faSdCards: faSdCards,
  faJugBottle: faJugBottle,
  faDownLong: faDownLong,
  faLongArrowAltDown: faLongArrowAltDown,
  faEnvelopes: faEnvelopes,
  faPhoneOffice: faPhoneOffice,
  faRankingStar: faRankingStar,
  faChessKing: faChessKing,
  faNfcPen: faNfcPen,
  faPersonHarassing: faPersonHarassing,
  faHatWinter: faHatWinter,
  faBrazilianRealSign: faBrazilianRealSign,
  faLandmarkDome: faLandmarkDome,
  faLandmarkAlt: faLandmarkAlt,
  faBoneBreak: faBoneBreak,
  faArrowUp: faArrowUp,
  faDownFromDottedLine: faDownFromDottedLine,
  faTv: faTv,
  faTelevision: faTelevision,
  faTvAlt: faTvAlt,
  faBorderLeft: faBorderLeft,
  faCircleDivide: faCircleDivide,
  faShrimp: faShrimp,
  faListCheck: faListCheck,
  faTasks: faTasks,
  faDiagramSubtask: faDiagramSubtask,
  faJugDetergent: faJugDetergent,
  faCircleUser: faCircleUser,
  faUserCircle: faUserCircle,
  faSquareY: faSquareY,
  faUserDoctorHair: faUserDoctorHair,
  faPlanetRinged: faPlanetRinged,
  faMushroom: faMushroom,
  faUserShield: faUserShield,
  faMegaphone: faMegaphone,
  faWreathLaurel: faWreathLaurel,
  faCircleExclamationCheck: faCircleExclamationCheck,
  faWind: faWind,
  faBoxDollar: faBoxDollar,
  faBoxUsd: faBoxUsd,
  faCarBurst: faCarBurst,
  faCarCrash: faCarCrash,
  faY: faY,
  faUserHeadset: faUserHeadset,
  faArrowsRetweet: faArrowsRetweet,
  faRetweetAlt: faRetweetAlt,
  faPersonSnowboarding: faPersonSnowboarding,
  faSnowboarding: faSnowboarding,
  faSquareChevronRight: faSquareChevronRight,
  faChevronSquareRight: faChevronSquareRight,
  faLacrosseStickBall: faLacrosseStickBall,
  faTruckFast: faTruckFast,
  faShippingFast: faShippingFast,
  faUserMagnifyingGlass: faUserMagnifyingGlass,
  faStarSharp: faStarSharp,
  faCommentHeart: faCommentHeart,
  faCircle1: faCircle1,
  faCircleStar: faCircleStar,
  faStarCircle: faStarCircle,
  faFish: faFish,
  faCloudFog: faCloudFog,
  faFog: faFog,
  faWaffle: faWaffle,
  faMusicNote: faMusicNote,
  faMusicAlt: faMusicAlt,
  faHexagonExclamation: faHexagonExclamation,
  faCartShoppingFast: faCartShoppingFast,
  faObjectUnion: faObjectUnion,
  faUserGraduate: faUserGraduate,
  faStarfighter: faStarfighter,
  faCircleHalfStroke: faCircleHalfStroke,
  faAdjust: faAdjust,
  faArrowRightLongToLine: faArrowRightLongToLine,
  faSquareArrowDown: faSquareArrowDown,
  faArrowSquareDown: faArrowSquareDown,
  faDiamondHalfStroke: faDiamondHalfStroke,
  faClapperboard: faClapperboard,
  faSquareChevronLeft: faSquareChevronLeft,
  faChevronSquareLeft: faChevronSquareLeft,
  faPhoneIntercom: faPhoneIntercom,
  faLinkHorizontal: faLinkHorizontal,
  faChainHorizontal: faChainHorizontal,
  faMango: faMango,
  faMusicNoteSlash: faMusicNoteSlash,
  faMusicAltSlash: faMusicAltSlash,
  faCircleRadiation: faCircleRadiation,
  faRadiationAlt: faRadiationAlt,
  faFaceTongueSweat: faFaceTongueSweat,
  faGlobeStand: faGlobeStand,
  faBaseball: faBaseball,
  faBaseballBall: faBaseballBall,
  faCircleP: faCircleP,
  faAwardSimple: faAwardSimple,
  faJetFighterUp: faJetFighterUp,
  faDiagramProject: faDiagramProject,
  faProjectDiagram: faProjectDiagram,
  faPedestal: faPedestal,
  faChartPyramid: faChartPyramid,
  faSidebar: faSidebar,
  faSnowmanHead: faSnowmanHead,
  faFrostyHead: faFrostyHead,
  faCopy: faCopy,
  faBurgerGlass: faBurgerGlass,
  faVolumeXmark: faVolumeXmark,
  faVolumeMute: faVolumeMute,
  faVolumeTimes: faVolumeTimes,
  faHandSparkles: faHandSparkles,
  faBarsFilter: faBarsFilter,
  faPaintbrushPencil: faPaintbrushPencil,
  faPartyBell: faPartyBell,
  faUserVneckHair: faUserVneckHair,
  faJackOLantern: faJackOLantern,
  faGrip: faGrip,
  faGripHorizontal: faGripHorizontal,
  faShareFromSquare: faShareFromSquare,
  faShareSquare: faShareSquare,
  faKeynote: faKeynote,
  faChildCombatant: faChildCombatant,
  faChildRifle: faChildRifle,
  faGun: faGun,
  faSquarePhone: faSquarePhone,
  faPhoneSquare: faPhoneSquare,
  faHatBeach: faHatBeach,
  faPlus: faPlus,
  faAdd: faAdd,
  faExpand: faExpand,
  faComputer: faComputer,
  faFort: faFort,
  faCloudCheck: faCloudCheck,
  faXmark: faXmark,
  faClose: faClose,
  faMultiply: faMultiply,
  faRemove: faRemove,
  faTimes: faTimes,
  faFaceSmirking: faFaceSmirking,
  faArrowsUpDownLeftRight: faArrowsUpDownLeftRight,
  faArrows: faArrows,
  faChalkboardUser: faChalkboardUser,
  faChalkboardTeacher: faChalkboardTeacher,
  faRhombus: faRhombus,
  faClawMarks: faClawMarks,
  faPesoSign: faPesoSign,
  faFaceSmileTongue: faFaceSmileTongue,
  faCartCircleXmark: faCartCircleXmark,
  faBuildingShield: faBuildingShield,
  faCirclePhoneFlip: faCirclePhoneFlip,
  faPhoneCircleAlt: faPhoneCircleAlt,
  faBaby: faBaby,
  faUsersLine: faUsersLine,
  faQuoteLeft: faQuoteLeft,
  faQuoteLeftAlt: faQuoteLeftAlt,
  faTractor: faTractor,
  faKeySkeleton: faKeySkeleton,
  faTrashArrowUp: faTrashArrowUp,
  faTrashRestore: faTrashRestore,
  faArrowDownUpLock: faArrowDownUpLock,
  faArrowDownToBracket: faArrowDownToBracket,
  faLinesLeaning: faLinesLeaning,
  faSquareQ: faSquareQ,
  faRulerCombined: faRulerCombined,
  faSymbols: faSymbols,
  faIconsAlt: faIconsAlt,
  faCopyright: faCopyright,
  faFlaskGear: faFlaskGear,
  faHighlighterLine: faHighlighterLine,
  faBracketSquare: faBracketSquare,
  faBracket: faBracket,
  faBracketLeft: faBracketLeft,
  faIslandTropical: faIslandTropical,
  faIslandTreePalm: faIslandTreePalm,
  faArrowRightFromLine: faArrowRightFromLine,
  faArrowFromLeft: faArrowFromLeft,
  faH2: faH2,
  faEquals: faEquals,
  faCakeSlice: faCakeSlice,
  faShortcake: faShortcake,
  faPeanut: faPeanut,
  faWrenchSimple: faWrenchSimple,
  faBlender: faBlender,
  faTeeth: faTeeth,
  faTally2: faTally2,
  faShekelSign: faShekelSign,
  faIls: faIls,
  faShekel: faShekel,
  faSheqel: faSheqel,
  faSheqelSign: faSheqelSign,
  faCars: faCars,
  faAxeBattle: faAxeBattle,
  faUserHairLong: faUserHairLong,
  faMap: faMap,
  faFileCircleInfo: faFileCircleInfo,
  faFaceDisappointed: faFaceDisappointed,
  faLassoSparkles: faLassoSparkles,
  faClockEleven: faClockEleven,
  faRocket: faRocket,
  faSirenOn: faSirenOn,
  faClockTen: faClockTen,
  faCandleHolder: faCandleHolder,
  faVideoArrowDownLeft: faVideoArrowDownLeft,
  faPhotoFilm: faPhotoFilm,
  faPhotoVideo: faPhotoVideo,
  faFloppyDiskCircleArrowRight: faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight: faSaveCircleArrowRight,
  faFolderMinus: faFolderMinus,
  faPlanetMoon: faPlanetMoon,
  faFaceEyesXmarks: faFaceEyesXmarks,
  faChartScatter: faChartScatter,
  faDisplayArrowDown: faDisplayArrowDown,
  faStore: faStore,
  faArrowTrendUp: faArrowTrendUp,
  faPlugCircleMinus: faPlugCircleMinus,
  faOliveBranch: faOliveBranch,
  faAngle: faAngle,
  faVacuumRobot: faVacuumRobot,
  faSignHanging: faSignHanging,
  faSign: faSign,
  faSquareDivide: faSquareDivide,
  faSignalStreamSlash: faSignalStreamSlash,
  faBezierCurve: faBezierCurve,
  faEyeDropperHalf: faEyeDropperHalf,
  faStoreLock: faStoreLock,
  faBellSlash: faBellSlash,
  faCloudBoltSun: faCloudBoltSun,
  faThunderstormSun: faThunderstormSun,
  faCameraSlash: faCameraSlash,
  faCommentQuote: faCommentQuote,
  faTablet: faTablet,
  faTabletAndroid: faTabletAndroid,
  faSchoolFlag: faSchoolFlag,
  faMessageCode: faMessageCode,
  faGlassHalf: faGlassHalf,
  faGlassHalfEmpty: faGlassHalfEmpty,
  faGlassHalfFull: faGlassHalfFull,
  faFill: faFill,
  faMessageMinus: faMessageMinus,
  faCommentAltMinus: faCommentAltMinus,
  faAngleUp: faAngleUp,
  faDinosaur: faDinosaur,
  faDrumstickBite: faDrumstickBite,
  faLinkHorizontalSlash: faLinkHorizontalSlash,
  faChainHorizontalSlash: faChainHorizontalSlash,
  faHollyBerry: faHollyBerry,
  faNose: faNose,
  faChevronLeft: faChevronLeft,
  faBacteria: faBacteria,
  faClouds: faClouds,
  faMoneyBillSimple: faMoneyBillSimple,
  faHandLizard: faHandLizard,
  faTablePivot: faTablePivot,
  faFilterSlash: faFilterSlash,
  faTrashCanUndo: faTrashCanUndo,
  faTrashCanArrowTurnLeft: faTrashCanArrowTurnLeft,
  faTrashUndoAlt: faTrashUndoAlt,
  faNotdef: faNotdef,
  faDisease: faDisease,
  faPersonToDoor: faPersonToDoor,
  faTurntable: faTurntable,
  faBriefcaseMedical: faBriefcaseMedical,
  faGenderless: faGenderless,
  faChevronRight: faChevronRight,
  faSignalWeak: faSignalWeak,
  faSignal1: faSignal1,
  faClockFive: faClockFive,
  faRetweet: faRetweet,
  faCarRear: faCarRear,
  faCarAlt: faCarAlt,
  faPumpSoap: faPumpSoap,
  faComputerClassic: faComputerClassic,
  faFrame: faFrame,
  faVideoSlash: faVideoSlash,
  faBatteryQuarter: faBatteryQuarter,
  faBattery2: faBattery2,
  faEllipsisStroke: faEllipsisStroke,
  faEllipsisHAlt: faEllipsisHAlt,
  faRadio: faRadio,
  faBabyCarriage: faBabyCarriage,
  faCarriageBaby: faCarriageBaby,
  faFaceExpressionless: faFaceExpressionless,
  faDownToDottedLine: faDownToDottedLine,
  faCloudMusic: faCloudMusic,
  faTrafficLight: faTrafficLight,
  faCloudMinus: faCloudMinus,
  faThermometer: faThermometer,
  faShieldMinus: faShieldMinus,
  faVrCardboard: faVrCardboard,
  faCarTilt: faCarTilt,
  faGaugeCircleMinus: faGaugeCircleMinus,
  faBrightnessLow: faBrightnessLow,
  faHandMiddleFinger: faHandMiddleFinger,
  faPercent: faPercent,
  faPercentage: faPercentage,
  faTruckMoving: faTruckMoving,
  faGlassWaterDroplet: faGlassWaterDroplet,
  faConveyorBelt: faConveyorBelt,
  faLocationCheck: faLocationCheck,
  faMapMarkerCheck: faMapMarkerCheck,
  faCoinVertical: faCoinVertical,
  faDisplay: faDisplay,
  faPersonSign: faPersonSign,
  faFaceSmile: faFaceSmile,
  faSmile: faSmile,
  faPhoneHangup: faPhoneHangup,
  faSignatureSlash: faSignatureSlash,
  faThumbtack: faThumbtack,
  faThumbTack: faThumbTack,
  faWheatSlash: faWheatSlash,
  faTrophy: faTrophy,
  faCloudsSun: faCloudsSun,
  faPersonPraying: faPersonPraying,
  faPray: faPray,
  faHammer: faHammer,
  faFaceVomit: faFaceVomit,
  faSpeakers: faSpeakers,
  faTtyAnswer: faTtyAnswer,
  faTeletypeAnswer: faTeletypeAnswer,
  faMugTeaSaucer: faMugTeaSaucer,
  faDiagramLeanCanvas: faDiagramLeanCanvas,
  faAlt: faAlt,
  faDial: faDial,
  faDialMedHigh: faDialMedHigh,
  faHandPeace: faHandPeace,
  faCircleTrash: faCircleTrash,
  faTrashCircle: faTrashCircle,
  faRotate: faRotate,
  faSyncAlt: faSyncAlt,
  faCircleQuarters: faCircleQuarters,
  faSpinner: faSpinner,
  faTowerControl: faTowerControl,
  faArrowUpTriangleSquare: faArrowUpTriangleSquare,
  faSortShapesUp: faSortShapesUp,
  faWhale: faWhale,
  faRobot: faRobot,
  faPeace: faPeace,
  faPartyHorn: faPartyHorn,
  faGears: faGears,
  faCogs: faCogs,
  faSunBright: faSunBright,
  faSunAlt: faSunAlt,
  faWarehouse: faWarehouse,
  faConveyorBeltArm: faConveyorBeltArm,
  faLockKeyholeOpen: faLockKeyholeOpen,
  faLockOpenAlt: faLockOpenAlt,
  faSquareFragile: faSquareFragile,
  faBoxFragile: faBoxFragile,
  faSquareWineGlassCrack: faSquareWineGlassCrack,
  faArrowUpRightDots: faArrowUpRightDots,
  faSquareN: faSquareN,
  faSplotch: faSplotch,
  faFaceGrinHearts: faFaceGrinHearts,
  faGrinHearts: faGrinHearts,
  faMeter: faMeter,
  faMandolin: faMandolin,
  faDiceFour: faDiceFour,
  faSimCard: faSimCard,
  faTransgender: faTransgender,
  faTransgenderAlt: faTransgenderAlt,
  faMercury: faMercury,
  faUpFromBracket: faUpFromBracket,
  faKnifeKitchen: faKnifeKitchen,
  faBorderRight: faBorderRight,
  faArrowTurnDown: faArrowTurnDown,
  faLevelDown: faLevelDown,
  faSpade: faSpade,
  faCardSpade: faCardSpade,
  faLineColumns: faLineColumns,
  faArrowRightToLine: faArrowRightToLine,
  faArrowToRight: faArrowToRight,
  faPersonFallingBurst: faPersonFallingBurst,
  faFlagPennant: faFlagPennant,
  faPennant: faPennant,
  faConveyorBeltEmpty: faConveyorBeltEmpty,
  faUserGroupSimple: faUserGroupSimple,
  faAward: faAward,
  faTicketSimple: faTicketSimple,
  faTicketAlt: faTicketAlt,
  faBuilding: faBuilding,
  faAnglesLeft: faAnglesLeft,
  faAngleDoubleLeft: faAngleDoubleLeft,
  faCamcorder: faCamcorder,
  faVideoHandheld: faVideoHandheld,
  faPancakes: faPancakes,
  faAlbumCircleUser: faAlbumCircleUser,
  faQrcode: faQrcode,
  faDiceD10: faDiceD10,
  faFireplace: faFireplace,
  faBrowser: faBrowser,
  faPenPaintbrush: faPenPaintbrush,
  faPencilPaintbrush: faPencilPaintbrush,
  faFishCooked: faFishCooked,
  faChairOffice: faChairOffice,
  faNestingDolls: faNestingDolls,
  faClockRotateLeft: faClockRotateLeft,
  faHistory: faHistory,
  faTrumpet: faTrumpet,
  faFaceGrinBeamSweat: faFaceGrinBeamSweat,
  faGrinBeamSweat: faGrinBeamSweat,
  faFireSmoke: faFireSmoke,
  faPhoneMissed: faPhoneMissed,
  faFileExport: faFileExport,
  faArrowRightFromFile: faArrowRightFromFile,
  faShield: faShield,
  faShieldBlank: faShieldBlank,
  faArrowUpShortWide: faArrowUpShortWide,
  faSortAmountUpAlt: faSortAmountUpAlt,
  faArrowsRepeat1: faArrowsRepeat1,
  faRepeat1Alt: faRepeat1Alt,
  faGunSlash: faGunSlash,
  faAvocado: faAvocado,
  faBinary: faBinary,
  faGlassesRound: faGlassesRound,
  faGlassesAlt: faGlassesAlt,
  faPhonePlus: faPhonePlus,
  faDitto: faDitto,
  faPersonSeat: faPersonSeat,
  faHouseMedical: faHouseMedical,
  faGolfBallTee: faGolfBallTee,
  faGolfBall: faGolfBall,
  faCircleChevronLeft: faCircleChevronLeft,
  faChevronCircleLeft: faChevronCircleLeft,
  faHouseChimneyWindow: faHouseChimneyWindow,
  faScythe: faScythe,
  faPenNib: faPenNib,
  faBanParking: faBanParking,
  faParkingCircleSlash: faParkingCircleSlash,
  faTentArrowTurnLeft: faTentArrowTurnLeft,
  faFaceDiagonalMouth: faFaceDiagonalMouth,
  faDiagramCells: faDiagramCells,
  faCricketBatBall: faCricketBatBall,
  faCricket: faCricket,
  faTents: faTents,
  faWandMagic: faWandMagic,
  faMagic: faMagic,
  faDog: faDog,
  faPenLine: faPenLine,
  faAtomSimple: faAtomSimple,
  faAtomAlt: faAtomAlt,
  faAmpersand: faAmpersand,
  faCarrot: faCarrot,
  faArrowUpFromLine: faArrowUpFromLine,
  faArrowFromBottom: faArrowFromBottom,
  faMoon: faMoon,
  faPenSlash: faPenSlash,
  faWineGlassEmpty: faWineGlassEmpty,
  faWineGlassAlt: faWineGlassAlt,
  faSquareStar: faSquareStar,
  faCheese: faCheese,
  faSendBackward: faSendBackward,
  faYinYang: faYinYang,
  faMusic: faMusic,
  faCompassSlash: faCompassSlash,
  faClockOne: faClockOne,
  faFileMusic: faFileMusic,
  faCodeCommit: faCodeCommit,
  faTemperatureLow: faTemperatureLow,
  faPersonBiking: faPersonBiking,
  faBiking: faBiking,
  faDisplayChartUpCircleCurrency: faDisplayChartUpCircleCurrency,
  faSkeleton: faSkeleton,
  faCircleG: faCircleG,
  faCircleArrowUpLeft: faCircleArrowUpLeft,
  faCoinBlank: faCoinBlank,
  faBroom: faBroom,
  faVacuum: faVacuum,
  faShieldHeart: faShieldHeart,
  faCardHeart: faCardHeart,
  faLightbulbCflOn: faLightbulbCflOn,
  faMelon: faMelon,
  faGopuram: faGopuram,
  faEarthOceania: faEarthOceania,
  faGlobeOceania: faGlobeOceania,
  faContainerStorage: faContainerStorage,
  faFacePouting: faFacePouting,
  faSquareXmark: faSquareXmark,
  faTimesSquare: faTimesSquare,
  faXmarkSquare: faXmarkSquare,
  faFaceExplode: faFaceExplode,
  faExplodingHead: faExplodingHead,
  faHashtag: faHashtag,
  faUpRightAndDownLeftFromCenter: faUpRightAndDownLeftFromCenter,
  faExpandAlt: faExpandAlt,
  faOilCan: faOilCan,
  faT: faT,
  faTransformerBolt: faTransformerBolt,
  faHippo: faHippo,
  faChartColumn: faChartColumn,
  faCassetteVhs: faCassetteVhs,
  faVhs: faVhs,
  faInfinity: faInfinity,
  faVialCircleCheck: faVialCircleCheck,
  faChimney: faChimney,
  faObjectIntersect: faObjectIntersect,
  faPersonArrowDownToLine: faPersonArrowDownToLine,
  faVoicemail: faVoicemail,
  faBlockBrick: faBlockBrick,
  faWallBrick: faWallBrick,
  faFan: faFan,
  faBagsShopping: faBagsShopping,
  faParagraphLeft: faParagraphLeft,
  faParagraphRtl: faParagraphRtl,
  faPersonWalkingLuggage: faPersonWalkingLuggage,
  faCaravanSimple: faCaravanSimple,
  faCaravanAlt: faCaravanAlt,
  faTurtle: faTurtle,
  faPencilMechanical: faPencilMechanical,
  faUpDown: faUpDown,
  faArrowsAltV: faArrowsAltV,
  faCloudMoonRain: faCloudMoonRain,
  faBoothCurtain: faBoothCurtain,
  faCalendar: faCalendar,
  faBoxHeart: faBoxHeart,
  faTrailer: faTrailer,
  faUserDoctorMessage: faUserDoctorMessage,
  faUserMdChat: faUserMdChat,
  faBahai: faBahai,
  faHaykal: faHaykal,
  faAmpGuitar: faAmpGuitar,
  faSdCard: faSdCard,
  faVolumeSlash: faVolumeSlash,
  faBorderBottom: faBorderBottom,
  faWifiWeak: faWifiWeak,
  faWifi1: faWifi1,
  faDragon: faDragon,
  faShoePrints: faShoePrints,
  faCirclePlus: faCirclePlus,
  faPlusCircle: faPlusCircle,
  faFaceGrinTongueWink: faFaceGrinTongueWink,
  faGrinTongueWink: faGrinTongueWink,
  faHandHolding: faHandHolding,
  faPlugCircleExclamation: faPlugCircleExclamation,
  faLinkSlash: faLinkSlash,
  faChainBroken: faChainBroken,
  faChainSlash: faChainSlash,
  faUnlink: faUnlink,
  faClone: faClone,
  faPersonWalkingArrowLoopLeft: faPersonWalkingArrowLoopLeft,
  faArrowUpZA: faArrowUpZA,
  faSortAlphaUpAlt: faSortAlphaUpAlt,
  faFireFlameCurved: faFireFlameCurved,
  faFireAlt: faFireAlt,
  faTornado: faTornado,
  faFileCirclePlus: faFileCirclePlus,
  faDeleteRight: faDeleteRight,
  faBookQuran: faBookQuran,
  faQuran: faQuran,
  faCircleQuarter: faCircleQuarter,
  faAnchor: faAnchor,
  faBorderAll: faBorderAll,
  faFunction: faFunction,
  faFaceAngry: faFaceAngry,
  faAngry: faAngry,
  faPeopleSimple: faPeopleSimple,
  faCookieBite: faCookieBite,
  faArrowTrendDown: faArrowTrendDown,
  faRss: faRss,
  faFeed: faFeed,
  faFaceMonocle: faFaceMonocle,
  faDrawPolygon: faDrawPolygon,
  faScaleBalanced: faScaleBalanced,
  faBalanceScale: faBalanceScale,
  faCalendarLines: faCalendarLines,
  faCalendarNote: faCalendarNote,
  faArrowDownBigSmall: faArrowDownBigSmall,
  faSortSizeDown: faSortSizeDown,
  faGaugeSimpleHigh: faGaugeSimpleHigh,
  faTachometer: faTachometer,
  faTachometerFast: faTachometerFast,
  faDoNotEnter: faDoNotEnter,
  faShower: faShower,
  faDiceD8: faDiceD8,
  faDesktop: faDesktop,
  faDesktopAlt: faDesktopAlt,
  faM: faM,
  faGripDotsVertical: faGripDotsVertical,
  faFaceViewfinder: faFaceViewfinder,
  faSoftServe: faSoftServe,
  faCreemee: faCreemee,
  faH5: faH5,
  faHandBackPointDown: faHandBackPointDown,
  faTableList: faTableList,
  faThList: faThList,
  faCommentSms: faCommentSms,
  faSms: faSms,
  faRectangle: faRectangle,
  faRectangleLandscape: faRectangleLandscape,
  faClipboardListCheck: faClipboardListCheck,
  faTurkey: faTurkey,
  faBook: faBook,
  faUserPlus: faUserPlus,
  faIceSkate: faIceSkate,
  faCheck: faCheck,
  faBatteryThreeQuarters: faBatteryThreeQuarters,
  faBattery4: faBattery4,
  faTomato: faTomato,
  faSwordLaser: faSwordLaser,
  faHouseCircleCheck: faHouseCircleCheck,
  faBuildings: faBuildings,
  faAngleLeft: faAngleLeft,
  faCartFlatbedBoxes: faCartFlatbedBoxes,
  faDollyFlatbedAlt: faDollyFlatbedAlt,
  faDiagramSuccessor: faDiagramSuccessor,
  faTruckArrowRight: faTruckArrowRight,
  faSquareW: faSquareW,
  faArrowsSplitUpAndLeft: faArrowsSplitUpAndLeft,
  faLamp: faLamp,
  faAirplay: faAirplay,
  faHandFist: faHandFist,
  faFistRaised: faFistRaised,
  faShieldQuartered: faShieldQuartered,
  faSlashForward: faSlashForward,
  faLocationPen: faLocationPen,
  faMapMarkerEdit: faMapMarkerEdit,
  faCloudMoon: faCloudMoon,
  faPotFood: faPotFood,
  faBriefcase: faBriefcase,
  faPersonFalling: faPersonFalling,
  faImagePortrait: faImagePortrait,
  faPortrait: faPortrait,
  faUserTag: faUserTag,
  faRug: faRug,
  faPrintSlash: faPrintSlash,
  faEarthEurope: faEarthEurope,
  faGlobeEurope: faGlobeEurope,
  faCartFlatbedSuitcase: faCartFlatbedSuitcase,
  faLuggageCart: faLuggageCart,
  faHandBackPointRibbon: faHandBackPointRibbon,
  faRectangleXmark: faRectangleXmark,
  faRectangleTimes: faRectangleTimes,
  faTimesRectangle: faTimesRectangle,
  faWindowClose: faWindowClose,
  faTireRugged: faTireRugged,
  faLightbulbDollar: faLightbulbDollar,
  faCowbell: faCowbell,
  faBahtSign: faBahtSign,
  faCorner: faCorner,
  faChevronsRight: faChevronsRight,
  faChevronDoubleRight: faChevronDoubleRight,
  faBookOpen: faBookOpen,
  faBookJournalWhills: faBookJournalWhills,
  faJournalWhills: faJournalWhills,
  faInhaler: faInhaler,
  faHandcuffs: faHandcuffs,
  faSnake: faSnake,
  faTriangleExclamation: faTriangleExclamation,
  faExclamationTriangle: faExclamationTriangle,
  faWarning: faWarning,
  faNoteMedical: faNoteMedical,
  faDatabase: faDatabase,
  faDownLeft: faDownLeft,
  faShare: faShare,
  faArrowTurnRight: faArrowTurnRight,
  faMailForward: faMailForward,
  faFaceThinking: faFaceThinking,
  faTurnDownRight: faTurnDownRight,
  faBottleDroplet: faBottleDroplet,
  faMaskFace: faMaskFace,
  faHillRockslide: faHillRockslide,
  faScannerKeyboard: faScannerKeyboard,
  faCircleO: faCircleO,
  faGridHorizontal: faGridHorizontal,
  faMessageDollar: faMessageDollar,
  faCommentAltDollar: faCommentAltDollar,
  faRightLeft: faRightLeft,
  faExchangeAlt: faExchangeAlt,
  faColumns3: faColumns3,
  faPaperPlane: faPaperPlane,
  faRoadCircleExclamation: faRoadCircleExclamation,
  faDungeon: faDungeon,
  faHandHoldingBox: faHandHoldingBox,
  faInputText: faInputText,
  faWindowFlip: faWindowFlip,
  faWindowAlt: faWindowAlt,
  faAlignRight: faAlignRight,
  faScannerGun: faScannerGun,
  faScanner: faScanner,
  faTire: faTire,
  faEngine: faEngine,
  faMoneyBill1Wave: faMoneyBill1Wave,
  faMoneyBillWaveAlt: faMoneyBillWaveAlt,
  faLifeRing: faLifeRing,
  faHands: faHands,
  faSignLanguage: faSignLanguage,
  faSigning: faSigning,
  faCircleCaretRight: faCircleCaretRight,
  faCaretCircleRight: faCaretCircleRight,
  faWheat: faWheat,
  faFileSpreadsheet: faFileSpreadsheet,
  faAudioDescriptionSlash: faAudioDescriptionSlash,
  faCalendarDay: faCalendarDay,
  faWaterLadder: faWaterLadder,
  faLadderWater: faLadderWater,
  faSwimmingPool: faSwimmingPool,
  faArrowsUpDown: faArrowsUpDown,
  faArrowsV: faArrowsV,
  faChessPawnPiece: faChessPawnPiece,
  faChessPawnAlt: faChessPawnAlt,
  faFaceGrimace: faFaceGrimace,
  faGrimace: faGrimace,
  faWheelchairMove: faWheelchairMove,
  faWheelchairAlt: faWheelchairAlt,
  faTurnDown: faTurnDown,
  faLevelDownAlt: faLevelDownAlt,
  faSquareS: faSquareS,
  faRectangleBarcode: faRectangleBarcode,
  faBarcodeAlt: faBarcodeAlt,
  faPersonWalkingArrowRight: faPersonWalkingArrowRight,
  faSquareEnvelope: faSquareEnvelope,
  faEnvelopeSquare: faEnvelopeSquare,
  faDice: faDice,
  faUnicorn: faUnicorn,
  faBowlingBall: faBowlingBall,
  faPompebled: faPompebled,
  faBrain: faBrain,
  faWatchSmart: faWatchSmart,
  faBookUser: faBookUser,
  faSensorCloud: faSensorCloud,
  faSensorSmoke: faSensorSmoke,
  faClapperboardPlay: faClapperboardPlay,
  faBandage: faBandage,
  faBandAid: faBandAid,
  faCalendarMinus: faCalendarMinus,
  faCircleXmark: faCircleXmark,
  faTimesCircle: faTimesCircle,
  faXmarkCircle: faXmarkCircle,
  faCircle4: faCircle4,
  faGifts: faGifts,
  faAlbumCollection: faAlbumCollection,
  faHotel: faHotel,
  faEarthAsia: faEarthAsia,
  faGlobeAsia: faGlobeAsia,
  faIdCardClip: faIdCardClip,
  faIdCardAlt: faIdCardAlt,
  faMagnifyingGlassPlus: faMagnifyingGlassPlus,
  faSearchPlus: faSearchPlus,
  faThumbsUp: faThumbsUp,
  faCloudShowers: faCloudShowers,
  faUserClock: faUserClock,
  faOnion: faOnion,
  faClockTwelveThirty: faClockTwelveThirty,
  faArrowDownToDottedLine: faArrowDownToDottedLine,
  faHandDots: faHandDots,
  faAllergies: faAllergies,
  faFileInvoice: faFileInvoice,
  faWindowMinimize: faWindowMinimize,
  faRectangleWide: faRectangleWide,
  faCommentArrowUp: faCommentArrowUp,
  faGarlic: faGarlic,
  faMugSaucer: faMugSaucer,
  faCoffee: faCoffee,
  faBrush: faBrush,
  faTreeDecorated: faTreeDecorated,
  faMask: faMask,
  faCalendarHeart: faCalendarHeart,
  faMagnifyingGlassMinus: faMagnifyingGlassMinus,
  faSearchMinus: faSearchMinus,
  faFlower: faFlower,
  faRightLeftLarge: faRightLeftLarge,
  faRulerVertical: faRulerVertical,
  faCirclesOverlap: faCirclesOverlap,
  faUserLarge: faUserLarge,
  faUserAlt: faUserAlt,
  faStarshipFreighter: faStarshipFreighter,
  faTrainTram: faTrainTram,
  faBridgeSuspension: faBridgeSuspension,
  faTrashCheck: faTrashCheck,
  faUserNurse: faUserNurse,
  faBoombox: faBoombox,
  faSyringe: faSyringe,
  faCloudSun: faCloudSun,
  faShieldExclamation: faShieldExclamation,
  faStopwatch20: faStopwatch20,
  faSquareFull: faSquareFull,
  faGripDots: faGripDots,
  faCommentExclamation: faCommentExclamation,
  faPenSwirl: faPenSwirl,
  faFalafel: faFalafel,
  faCircle2: faCircle2,
  faMagnet: faMagnet,
  faJar: faJar,
  faGramophone: faGramophone,
  faDiceD12: faDiceD12,
  faNoteSticky: faNoteSticky,
  faStickyNote: faStickyNote,
  faDown: faDown,
  faArrowAltDown: faArrowAltDown,
  faHundredPoints: faHundredPoints,
  fa100: fa100,
  faPaperclipVertical: faPaperclipVertical,
  faWindWarning: faWindWarning,
  faWindCircleExclamation: faWindCircleExclamation,
  faLocationPinSlash: faLocationPinSlash,
  faMapMarkerSlash: faMapMarkerSlash,
  faFaceSadSweat: faFaceSadSweat,
  faBugSlash: faBugSlash,
  faCupcake: faCupcake,
  faLightSwitchOff: faLightSwitchOff,
  faToggleLargeOff: faToggleLargeOff,
  faPenFancySlash: faPenFancySlash,
  faTruckContainer: faTruckContainer,
  faBoot: faBoot,
  faArrowUpFromWaterPump: faArrowUpFromWaterPump,
  faFileCheck: faFileCheck,
  faBone: faBone,
  faCardsBlank: faCardsBlank,
  faCircle3: faCircle3,
  faBenchTree: faBenchTree,
  faKeyboardBrightnessLow: faKeyboardBrightnessLow,
  faSkiBootSki: faSkiBootSki,
  faBrainCircuit: faBrainCircuit,
  faUserInjured: faUserInjured,
  faBlockBrickFire: faBlockBrickFire,
  faFirewall: faFirewall,
  faFaceSadTear: faFaceSadTear,
  faSadTear: faSadTear,
  faPlane: faPlane,
  faTentArrowsDown: faTentArrowsDown,
  faExclamation: faExclamation,
  faArrowsSpin: faArrowsSpin,
  faFaceSmileRelaxed: faFaceSmileRelaxed,
  faCommentXmark: faCommentXmark,
  faCommentTimes: faCommentTimes,
  faPrint: faPrint,
  faTurkishLiraSign: faTurkishLiraSign,
  faTry: faTry,
  faTurkishLira: faTurkishLira,
  faFaceNoseSteam: faFaceNoseSteam,
  faCircleWaveformLines: faCircleWaveformLines,
  faWaveformCircle: faWaveformCircle,
  faDollarSign: faDollarSign,
  faDollar: faDollar,
  faUsd: faUsd,
  faFerrisWheel: faFerrisWheel,
  faComputerSpeaker: faComputerSpeaker,
  faSkullCow: faSkullCow,
  faX: faX,
  faMagnifyingGlassDollar: faMagnifyingGlassDollar,
  faSearchDollar: faSearchDollar,
  faUsersGear: faUsersGear,
  faUsersCog: faUsersCog,
  faPersonMilitaryPointing: faPersonMilitaryPointing,
  faBuildingColumns: faBuildingColumns,
  faBank: faBank,
  faInstitution: faInstitution,
  faMuseum: faMuseum,
  faUniversity: faUniversity,
  faCircleT: faCircleT,
  faSack: faSack,
  faGrid2: faGrid2,
  faCameraCctv: faCameraCctv,
  faCctv: faCctv,
  faUmbrella: faUmbrella,
  faTrowel: faTrowel,
  faHorizontalRule: faHorizontalRule,
  faBedFront: faBedFront,
  faBedAlt: faBedAlt,
  faD: faD,
  faStapler: faStapler,
  faMasksTheater: faMasksTheater,
  faTheaterMasks: faTheaterMasks,
  faKipSign: faKipSign,
  faFaceWoozy: faFaceWoozy,
  faCloudQuestion: faCloudQuestion,
  faPineapple: faPineapple,
  faHandPointLeft: faHandPointLeft,
  faGalleryThumbnails: faGalleryThumbnails,
  faCircleJ: faCircleJ,
  faEyes: faEyes,
  faHandshakeSimple: faHandshakeSimple,
  faHandshakeAlt: faHandshakeAlt,
  faPageCaretUp: faPageCaretUp,
  faFileCaretUp: faFileCaretUp,
  faJetFighter: faJetFighter,
  faFighterJet: faFighterJet,
  faComet: faComet,
  faSquareShareNodes: faSquareShareNodes,
  faShareAltSquare: faShareAltSquare,
  faShieldKeyhole: faShieldKeyhole,
  faBarcode: faBarcode,
  faPlusMinus: faPlusMinus,
  faSquareSlidersVertical: faSquareSlidersVertical,
  faSlidersVSquare: faSlidersVSquare,
  faVideo: faVideo,
  faVideoCamera: faVideoCamera,
  faMessageMiddle: faMessageMiddle,
  faCommentMiddleAlt: faCommentMiddleAlt,
  faGraduationCap: faGraduationCap,
  faMortarBoard: faMortarBoard,
  faHandHoldingMedical: faHandHoldingMedical,
  faPersonCircleCheck: faPersonCircleCheck,
  faSquareZ: faSquareZ,
  faMessageText: faMessageText,
  faCommentAltText: faCommentAltText,
  faTurnUp: faTurnUp,
  faLevelUpAlt: faLevelUpAlt
};




/***/ }),

/***/ 30630:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 33579:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 37328:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectSpread; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 96670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 26297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 66383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 92228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 15459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30630);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 98614:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I18nContext": function() { return /* reexport */ I18nContext; },
  "I18nextProvider": function() { return /* reexport */ I18nextProvider; },
  "Trans": function() { return /* reexport */ Trans_Trans; },
  "TransWithoutContext": function() { return /* reexport */ Trans; },
  "Translation": function() { return /* reexport */ Translation; },
  "composeInitialProps": function() { return /* reexport */ composeInitialProps; },
  "date": function() { return /* binding */ date; },
  "getDefaults": function() { return /* reexport */ getDefaults; },
  "getI18n": function() { return /* reexport */ getI18n; },
  "getInitialProps": function() { return /* reexport */ getInitialProps; },
  "initReactI18next": function() { return /* reexport */ initReactI18next; },
  "number": function() { return /* binding */ number; },
  "plural": function() { return /* binding */ plural; },
  "select": function() { return /* binding */ es_select; },
  "selectOrdinal": function() { return /* binding */ selectOrdinal; },
  "setDefaults": function() { return /* reexport */ setDefaults; },
  "setI18n": function() { return /* reexport */ setI18n; },
  "time": function() { return /* binding */ time; },
  "useSSR": function() { return /* reexport */ useSSR; },
  "useTranslation": function() { return /* reexport */ useTranslation; },
  "withSSR": function() { return /* reexport */ withSSR; },
  "withTranslation": function() { return /* reexport */ withTranslation; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/void-elements/index.js
var void_elements = __webpack_require__(64896);
var void_elements_default = /*#__PURE__*/__webpack_require__.n(void_elements);
;// CONCATENATED MODULE: ../../node_modules/html-parse-stringify/dist/html-parse-stringify.module.js
var t=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],((void_elements_default())[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(t),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var o=c[1].trim(),l=[o,""];o.indexOf("=")>-1&&(l=o.split("=")),r.attrs[l[0]]=l[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}var c={parse:function(e,t){t||(t={}),t.components||(t.components=s);var a,c=[],o=[],l=-1,m=!1;if(0!==e.indexOf("<")){var u=e.indexOf("<");c.push({type:"text",content:-1===u?e:e.substring(0,u)})}return e.replace(r,function(r,s){if(m){if(r!=="</"+a.name+">")return;m=!1}var u,f="/"!==r.charAt(1),h=r.startsWith("\x3c!--"),p=s+r.length,d=e.charAt(p);if(h){var v=n(r);return l<0?(c.push(v),c):((u=o[l]).children.push(v),c)}if(f&&(l++,"tag"===(a=n(r)).type&&t.components[a.name]&&(a.type="component",m=!0),a.voidElement||m||!d||"<"===d||a.children.push({type:"text",content:e.slice(p,e.indexOf("<",p))}),0===l&&c.push(a),(u=o[l-1])&&u.children.push(a),o[l]=a),(!f||a.voidElement)&&(l>-1&&(a.voidElement||a.name===r.slice(2,-1))&&(l--,a=-1===l?c:o[l]),!m&&"<"!==d&&d)){u=-1===l?c:o[l].children;var x=e.indexOf("<",p),g=e.slice(p,-1===x?void 0:x);i.test(g)&&(g=" "),(x>-1&&l+u.length>=0||" "!==g)&&u.push({type:"text",content:g})}}),c},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};/* harmony default export */ var html_parse_stringify_module = (c);
//# sourceMappingURL=html-parse-stringify.module.js.map

;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (typeof args[0] === 'string') args[0] = `react-i18next:: ${args[0]}`;
    console.warn(...args);
  }
}
const alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn(...args);
}
const loadedClb = (i18n, cb) => () => {
  if (i18n.isInitialized) {
    cb();
  } else {
    const initialized = () => {
      setTimeout(() => {
        i18n.off('initialized', initialized);
      }, 0);
      cb();
    };
    i18n.on('initialized', initialized);
  }
};
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function loadLanguages(i18n, lng, ns, cb) {
  if (typeof ns === 'string') ns = [ns];
  ns.forEach(n => {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const lng = i18n.languages[0];
  const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  const lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;
  const loadNotPending = (l, n) => {
    const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}
function hasLoadedNamespace(ns, i18n) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }
  const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }
  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: (i18nInstance, loadNotPending) => {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/unescape.js
const matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};
const unescapeHtmlEntity = m => htmlEntities[m];
const unescape_unescape = text => text.replace(matchHtmlEntity, unescapeHtmlEntity);
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/defaults.js

let defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
function setDefaults() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = {
    ...defaultOptions,
    ...options
  };
}
function getDefaults() {
  return defaultOptions;
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/i18nInstance.js
let i18nInstance;
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/TransWithoutContext.js





function hasChildren(node, checkLength) {
  if (!node) return false;
  const base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}
function getChildren(node) {
  if (!node) return [];
  return node.props ? node.props.children : node.children;
}
function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(child => (0,react.isValidElement)(child));
}
function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}
function mergeProps(source, target) {
  const newTarget = {
    ...target
  };
  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}
function nodesToString(children, i18nOptions) {
  if (!children) return '';
  let stringNode = '';
  const childrenArray = getAsArray(children);
  const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach((child, childIndex) => {
    if (typeof child === 'string') {
      stringNode += `${child}`;
    } else if ((0,react.isValidElement)(child)) {
      const childPropsCount = Object.keys(child.props).length;
      const shouldKeepChild = keepArray.indexOf(child.type) > -1;
      const childChildren = child.props.children;
      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += `<${child.type}/>`;
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += `<${childIndex}></${childIndex}>`;
      } else if (child.props.i18nIsDynamicList) {
        stringNode += `<${childIndex}></${childIndex}>`;
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += `<${child.type}>${childChildren}</${child.type}>`;
      } else {
        const content = nodesToString(childChildren, i18nOptions);
        stringNode += `<${childIndex}>${content}</${childIndex}>`;
      }
    } else if (child === null) {
      warn(`Trans: the passed in value is invalid - seems you passed in a null child.`);
    } else if (typeof child === 'object') {
      const {
        format,
        ...clone
      } = child;
      const keys = Object.keys(clone);
      if (keys.length === 1) {
        const value = format ? `${keys[0]}, ${format}` : keys[0];
        stringNode += `{{${value}}}`;
      } else {
        warn(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
      }
    } else {
      warn(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    }
  });
  return stringNode;
}
function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  const data = {};
  function getData(childs) {
    const childrenArray = getAsArray(childs);
    childrenArray.forEach(child => {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (typeof child === 'object' && !(0,react.isValidElement)(child)) Object.assign(data, child);
    });
  }
  getData(children);
  const ast = html_parse_stringify_module.parse(`<0>${targetString}</0>`);
  const opts = {
    ...data,
    ...combinedTOpts
  };
  function renderInner(child, node, rootReactNode) {
    const childs = getChildren(child);
    const mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }
  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push((0,react.cloneElement)(child, {
      ...child.props,
      key: i
    }, isVoid ? undefined : inner));
  }
  function mapAST(reactNode, astNode, rootReactNode) {
    const reactNodes = getAsArray(reactNode);
    const astNodes = getAsArray(astNode);
    return astNodes.reduce((mem, node, i) => {
      const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
      if (node.type === 'tag') {
        let tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        const child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        const isElement = (0,react.isValidElement)(child);
        const isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === 'object' && child.dummy && !isElement;
        const isKnownComponent = typeof children === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
        if (typeof child === 'string') {
          const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
          const inner = renderInner(child, node, rootReactNode);
          pushTranslatedJSX(child, inner, mem, i);
        } else if (isEmptyTransWithHTML) {
          const inner = mapAST(reactNodes, node.children, rootReactNode);
          mem.push((0,react.cloneElement)(child, {
            ...child.props,
            key: i
          }, inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            const inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push((0,react.createElement)(node.name, {
                key: `${node.name}-${i}`
              }));
            } else {
              const inner = mapAST(reactNodes, node.children, rootReactNode);
              mem.push((0,react.createElement)(node.name, {
                key: `${node.name}-${i}`
              }, inner));
            }
          } else if (node.voidElement) {
            mem.push(`<${node.name} />`);
          } else {
            const inner = mapAST(reactNodes, node.children, rootReactNode);
            mem.push(`<${node.name}>${inner}</${node.name}>`);
          }
        } else if (typeof child === 'object' && !isElement) {
          const content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push((0,react.cloneElement)(child, {
            ...child.props,
            key: i
          }, translationContent));
        } else {
          mem.push((0,react.cloneElement)(child, {
            ...child.props,
            key: i
          }));
        }
      } else if (node.type === 'text') {
        const wrapTextNodes = i18nOptions.transWrapTextNodes;
        const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
        if (wrapTextNodes) {
          mem.push((0,react.createElement)(wrapTextNodes, {
            key: `${node.name}-${i}`
          }, content));
        } else {
          mem.push(content);
        }
      }
      return mem;
    }, []);
  }
  const result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}
function Trans(_ref) {
  let {
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions = {},
    values,
    defaults,
    components,
    ns,
    i18n: i18nFromProps,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  } = _ref;
  const i18n = i18nFromProps || getI18n();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }
  const t = tFromProps || i18n.t.bind(i18n) || (k => k);
  if (context) tOptions.context = context;
  const reactI18nextOptions = {
    ...getDefaults(),
    ...(i18n.options && i18n.options.react)
  };
  let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  const defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  const {
    hashTransKey
  } = reactI18nextOptions;
  const key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  const interpolationOverride = values ? tOptions.interpolation : {
    interpolation: {
      ...tOptions.interpolation,
      prefix: '#$?',
      suffix: '?$#'
    }
  };
  const combinedTOpts = {
    ...tOptions,
    count,
    ...values,
    ...interpolationOverride,
    defaultValue,
    ns: namespaces
  };
  const translation = key ? t(key, combinedTOpts) : defaultValue;
  const content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? (0,react.createElement)(useAsParent, additionalProps, content) : content;
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/initReactI18next.js


const initReactI18next = {
  type: '3rdParty',
  init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/context.js





const I18nContext = (0,react.createContext)();
class ReportNamespaces {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(namespaces) {
    namespaces.forEach(ns => {
      if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
function composeInitialProps(ForComponent) {
  return ctx => new Promise(resolve => {
    const i18nInitialProps = getInitialProps();
    if (ForComponent.getInitialProps) {
      ForComponent.getInitialProps(ctx).then(componentsInitialProps => {
        resolve({
          ...componentsInitialProps,
          ...i18nInitialProps
        });
      });
    } else {
      resolve(i18nInitialProps);
    }
  });
}
function getInitialProps() {
  const i18n = getI18n();
  const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  const ret = {};
  const initialI18nStore = {};
  i18n.languages.forEach(l => {
    initialI18nStore[l] = {};
    namespaces.forEach(ns => {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/Trans.js




function Trans_Trans(_ref) {
  let {
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions = {},
    values,
    defaults,
    components,
    ns,
    i18n: i18nFromProps,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  } = _ref;
  const {
    i18n: i18nFromContext,
    defaultNS: defaultNSFromContext
  } = (0,react.useContext)(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  const t = tFromProps || i18n && i18n.t.bind(i18n);
  return Trans({
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions,
    values,
    defaults,
    components,
    ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
    i18n,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  });
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/useTranslation.js



const usePrevious = (value, ignore) => {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};
function useTranslation(ns) {
  let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    i18n: i18nFromProps
  } = props;
  const {
    i18n: i18nFromContext,
    defaultNS: defaultNSFromContext
  } = (0,react.useContext)(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');
    const notReadyT = (k, optsOrDefaultValue) => {
      if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
      if (optsOrDefaultValue && typeof optsOrDefaultValue === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };
    const retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
  const i18nOptions = {
    ...getDefaults(),
    ...i18n.options.react,
    ...props
  };
  const {
    useSuspense,
    keyPrefix
  } = i18nOptions;
  let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(n => hasLoadedNamespace(n, i18n, i18nOptions));
  function getT() {
    return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }
  const [t, setT] = (0,react.useState)(getT);
  let joinedNS = namespaces.join();
  if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
  const previousJoinedNS = usePrevious(joinedNS);
  const isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(() => {
    const {
      bindI18n,
      bindI18nStore
    } = i18nOptions;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, () => {
          if (isMounted.current) setT(getT);
        });
      } else {
        loadNamespaces(i18n, namespaces, () => {
          if (isMounted.current) setT(getT);
        });
      }
    }
    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }
    function boundReset() {
      if (isMounted.current) setT(getT);
    }
    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return () => {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(e => i18n.off(e, boundReset));
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(e => i18n.store.off(e, boundReset));
    };
  }, [i18n, joinedNS]);
  const isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(() => {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }
    isInitial.current = false;
  }, [i18n, keyPrefix]);
  const ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(resolve => {
    if (props.lng) {
      loadLanguages(i18n, props.lng, namespaces, () => resolve());
    } else {
      loadNamespaces(i18n, namespaces, () => resolve());
    }
  });
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/withTranslation.js



function withTranslation(ns) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      let {
        forwardedRef,
        ...rest
      } = _ref;
      const [t, i18n, ready] = useTranslation(ns, {
        ...rest,
        keyPrefix: options.keyPrefix
      });
      const passDownProps = {
        ...rest,
        t,
        i18n,
        tReady: ready
      };
      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }
      return (0,react.createElement)(WrappedComponent, passDownProps);
    }
    I18nextWithTranslation.displayName = `withI18nextTranslation(${getDisplayName(WrappedComponent)})`;
    I18nextWithTranslation.WrappedComponent = WrappedComponent;
    const forwardRef = (props, ref) => (0,react.createElement)(I18nextWithTranslation, Object.assign({}, props, {
      forwardedRef: ref
    }));
    return options.withRef ? (0,react.forwardRef)(forwardRef) : I18nextWithTranslation;
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/Translation.js

function Translation(props) {
  const {
    ns,
    children,
    ...options
  } = props;
  const [t, i18n, ready] = useTranslation(ns, options);
  return children(t, {
    i18n,
    lng: i18n.language
  }, ready);
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  let {
    i18n,
    defaultNS,
    children
  } = _ref;
  const value = (0,react.useMemo)(() => ({
    i18n,
    defaultNS
  }), [i18n, defaultNS]);
  return (0,react.createElement)(I18nContext.Provider, {
    value
  }, children);
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/useSSR.js


function useSSR(initialI18nStore, initialLanguage) {
  let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    i18n: i18nFromProps
  } = props;
  const {
    i18n: i18nFromContext
  } = (0,react.useContext)(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n.options && i18n.options.isClone) return;
  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore;
    i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources) => {
      Object.keys(lngResources).forEach(ns => {
        if (mem.indexOf(ns) < 0) mem.push(ns);
      });
      return mem;
    }, i18n.options.ns);
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }
  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/withSSR.js




function withSSR() {
  return function Extend(WrappedComponent) {
    function I18nextWithSSR(_ref) {
      let {
        initialI18nStore,
        initialLanguage,
        ...rest
      } = _ref;
      useSSR(initialI18nStore, initialLanguage);
      return (0,react.createElement)(WrappedComponent, {
        ...rest
      });
    }
    I18nextWithSSR.getInitialProps = composeInitialProps(WrappedComponent);
    I18nextWithSSR.displayName = `withI18nextSSR(${getDisplayName(WrappedComponent)})`;
    I18nextWithSSR.WrappedComponent = WrappedComponent;
    return I18nextWithSSR;
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/index.js












const date = () => '';
const time = () => '';
const number = () => '';
const es_select = () => '';
const plural = () => '';
const selectOrdinal = () => '';

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(86570), __webpack_exec__(93642); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);